"use strict";

(function () {
  'use strict';

  angular.module('external', []);
})();

(function () {
  'use strict';

  angular.module('external').factory("Bim", bimFactory);

  function bimFactory() {
    return {
      mainViewer: function mainViewer(element, identifier, data) {
        return new BimMainViewer(element, identifier, data);
      },
      simpleViewer: function simpleViewer(element, quality) {
        return new BimSimpleViewer(element, quality);
      },
      markingViewer: function markingViewer(element) {
        return new BimMarkingViewer(element);
      },
      navigationController: function navigationController(viewer3d, planViewer) {
        return new BimNavigationController(viewer3d, planViewer);
      },
      planViewer: function planViewer(element) {
        return new BimPlanViewer(element);
      },
      vpViewer: function vpViewer(element) {
        return new BimVPViewer(element);
      },
      planGenerator: function planGenerator() {
        return new BimPlanGenerator();
      },
      levelList: function levelList(modelData) {
        return BimUtils.getLevelListFromStructureTree(modelData.tree);
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('external').factory('VP', VPFactory);

  function VPFactory() {
    return {
      mainViewer: function mainViewer(element) {
        return new VPMainViewer(element);
      },
      simpleViewer: function simpleViewer(element) {
        return new VPSimpleViewer(element);
      },
      markingViewer: function markingViewer(element) {
        return new VPMarkingViewer(element);
      },
      board: function board() {
        return new VPBoard();
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('external').factory('pdfFactory', pdfFactory);

  function pdfFactory() {
    return {
      getImage: function getImage(buffer, pageNum, maxSize) {
        return new Promise(function (resolve, reject) {
          var reader = new FileReader();

          reader.onload = function () {
            var typedarray = new Uint8Array(this.result);
            pdfjsLib.getDocument(typedarray).promise.then(function (pdf) {
              pdf.getPage(pageNum).then(function (page) {
                var viewport = page.getViewport({
                  scale: 1
                });

                if (maxSize !== undefined) {
                  var scale = viewport.height > viewport.width ? maxSize / viewport.height : maxSize / viewport.width;
                  viewport = page.getViewport({
                    scale: scale
                  });
                }

                var canvas = document.createElement("canvas");
                var context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width; //Draw it on the canvas

                page.render({
                  canvasContext: context,
                  viewport: viewport
                }).promise.then(function () {
                  resolve({
                    image: canvas.toDataURL("image/png"),
                    size: {
                      width: canvas.width,
                      height: canvas.height
                    }
                  });
                });
              })["catch"](function (err) {
                reject(err);
                console.error(err);
              });
            });
          };

          reader.readAsArrayBuffer(buffer);
        });
      },
      getImageByUrl: function getImageByUrl(url, pageNum, maxSize) {
        return new Promise(function (resolve, reject) {
          pdfjsLib.getDocument({
            url: url
          }).promise.then(function (pdf) {
            // you can now use *pdf* here
            pdf.getPage(pageNum).then(function (page) {
              var viewport = page.getViewport({
                scale: 1
              });

              if (maxSize !== undefined) {
                var scale = viewport.height > viewport.width ? maxSize / viewport.height : maxSize / viewport.width;
                viewport = page.getViewport({
                  scale: scale
                });
              }

              var canvas = document.createElement("canvas");
              var context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width; //Draw it on the canvas

              page.render({
                canvasContext: context,
                viewport: viewport
              }).promise.then(function () {
                resolve({
                  image: canvas.toDataURL("image/png"),
                  size: {
                    width: canvas.width,
                    height: canvas.height
                  }
                });
              })["catch"](function (err) {
                reject(err);
              });
            })["catch"](function (err) {
              reject(err);
            });
          })["catch"](function (err) {
            reject(err);
          });
        });
      },
      getPageFromURL: function getPageFromURL(url) {
        var pageNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        return new Promise(function (resolve, reject) {
          pdfjsLib.getDocument(url).promise.then(function (doc) {
            doc.getPage(pageNum).then(function (page) {
              return resolve(page);
            })["catch"](function (e) {
              return reject(e);
            });
          })["catch"](function (e) {
            reject(e);
          });
        });
      },
      numPagesFromURL: function numPagesFromURL(url) {
        return new Promise(function (resolve, reject) {
          pdfjsLib.getDocument(url).promise.then(function (doc) {
            resolve(doc.numPages);
          })["catch"](function (e) {
            reject(e);
          });
        });
      },
      getPageFromFile: function getPageFromFile(file) {
        var pageNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        return new Promise(function (resolve, reject) {
          var reader = new FileReader();

          reader.onload = function () {
            pdfjsLib.getDocument(reader.result).promise.then(function (doc) {
              doc.getPage(pageNum).then(function (page) {
                return resolve(page);
              })["catch"](function (e) {
                return reject(e);
              });
            })["catch"](function (e) {
              reject(e);
            });
          };

          reader.onerror = function (ev) {
            reject(ev);
          };

          reader.readAsDataURL(file);
        });
      },
      numPagesFromFile: function numPagesFromFile(file) {
        return new Promise(function (resolve, reject) {
          var reader = new FileReader();

          reader.onload = function () {
            pdfjsLib.getDocument(reader.result).promise.then(function (doc) {
              resolve(doc.numPages);
            })["catch"](function (e) {
              reject(e);
            });
          };

          reader.onerror = function (ev) {
            reject(ev);
          };

          reader.readAsDataURL(file);
        });
      },
      exportSemiPlan: function exportSemiPlan(fileName, pageSize, data) {
        new PdfSemiPlan(data)["export"](fileName, pageSize);
      },
      exportPlan: function exportPlan(fileName, data) {
        new PdfBimPlan(data.imageData, data.materials)["export"](fileName, {
          label: 'A4',
          size: {
            width: 1753,
            height: 1240
          }
        });
      },
      exportGantt: function exportGantt(fileName, gantt, styles, options) {
        new DWGanttPdf()["export"](fileName, gantt, styles, options);
      },
      exportCalendar: function exportCalendar(fileName, element) {
        PdfCalendar(fileName, element);
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('external').factory('GMap', GMapFactory);

  function GMapFactory() {
    return {
      drawingViewer: function drawingViewer(mapElement, gmapConfig, data) {
        return new GMapDrawingViewer(mapElement, gmapConfig, data);
      },
      earthViewer: function earthViewer(containerId) {
        return new EarthViewer(containerId);
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('external').factory('GIS', GisFactory);

  function GisFactory() {
    return {
      mainViewer: function mainViewer() {
        return new GisViewer();
      }
    };
  }
})();


"use strict";

function BimMainViewer(container) {
  'use strict';

  if (!Detector.webgl) Detector.addGetWebGLMessage();
  var self = this; // data management

  this.data = new BimData(); // signal manager

  this.signaler = new BimSignaler(this); // viewer

  this.viewer = new BimViewer(container, this.signaler).create();
  this.bimModel = undefined; // object picking

  this.objectPicker = new BimObjectPicker(this.viewer, this.data); // drawing command

  this.curCmd = undefined;
  this.planTransformer = undefined; //drawing

  this.currentUnit = 'm';
  this.fillColor = 'red';
  this.inputMethod = 'en';
  this.theme = 0;
  this.colorMode = 'normal';
  this.currentTexture = undefined;
  this.textBrush = {
    fontSize: 24,
    fontFamily: "Arial",
    fillColor: 'rgba(0,0,0,1)',
    strokeColor: 'rgba(0,0,0,1)'
  };
  this.drawer2d = new BimDrawer2d(this.viewer);
  this.drawer2dText = new BimDrawer2dText(this.viewer);
  this.overlay = {
    scene: new THREE.Scene(),
    render: function render(renderer, camera) {
      this.scene.updateMatrixWorld();
      renderer.render(this.scene, camera);
    }
  }; //clipping

  this.clippingManager = new BimClippingManager();
  this.crossSection = new CrossSection(this.viewer, this.clippingManager);
  this.planSection = new CrossSection(this.viewer, this.clippingManager);
  this.clippingManager.add(this.crossSection);
  this.clippingManager.add(this.planSection);
  this.cutter3d = new BimCutter3d(this.viewer, this.crossSection, this.objectPicker);
  this.planControl3d = new BimPlan3d(this.viewer, this.planSection, this.objectPicker);
  this.markers = [];
  this.mouseStatus = undefined;
  this.defaultHotspotUrl = '/assets/images/cgviewer/vp-issue-hold.svg';
  this.hotspotUrls = {
    'Open': '/assets/images/cgviewer/vp-issue-hold.svg',
    'Open-Message': '/assets/images/cgviewer/vp-issue-open.svg',
    'On Hold': '/assets/images/cgviewer/vp-issue-hold.svg',
    'Resolved': '/assets/images/cgviewer/vp-issue-completed.svg',
    'Completed': '/assets/images/cgviewer/vp-issue-completed.svg'
  };
  self.viewer.canvas.addEventListener("pointerdown", mousedown, false);
  this.viewer.addOverlay(this.overlay);
  this.viewer.addOverlay(this.cutter3d);
  this.viewer.addOverlay(this.planControl3d); // register signals

  this.signaler.cameraControlChanged.add(function () {
    if (self.curCmd && self.curCmd.cameraControlChanged) self.curCmd.cameraControlChanged();
  });
  this.signaler.releaseCmd.add(function () {
    self.activateCmd(undefined);
    self.viewer.setDragAction('picker');
  });
  this.signaler.planTransformReady.add(function (plan) {
    if (self.planTransformer !== plan.transformer) {
      if (self.planTransformer !== undefined) {
        self.planTransformer.detach();
      }

      self.planTransformer = plan.transformer;
      self.planTransformer.attach();
    }
  });
  this.signaler.objectSelected.add(function () {
    if (self.planTransformer !== undefined) {
      self.planTransformer.detach();
      self.planTransformer = undefined;
    }
  });
  this.signaler.objectDblClicked.add(function () {
    if (self.planTransformer !== undefined) {
      self.planTransformer.detach();
      self.planTransformer = undefined;
    }
  });
  this.signaler.requestShowPlan.add(function (bimPlan) {
    self.toggleShowBimPlan(bimPlan);
  });

  var resizeEvent = function resizeEvent() {
    self.setSize(container.clientWidth, container.clientHeight);
  };

  this.create = function () {
    this.setSize(container.clientWidth, container.clientHeight);
    window.addEventListener('resize', resizeEvent, false);
    this.signaler.start();
  };

  this.destroy = function () {
    window.removeEventListener('resize', resizeEvent, false);
    this.viewer.destroy();
    this.signaler.stop();
  };

  this.on = function (type, callback) {
    if (this.signaler[type] !== undefined) {
      this.signaler[type].add(callback);
    } else {
      console.warn('there is no event type: ', type);
    }
  };

  this.off = function (type, callback) {
    if (this.signaler[type]) {
      this.signaler[type].remove(callback);
    }
  };

  this.loadBim = function (model) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var bimLoader = new BimLoader();
      bimLoader.load(model).then(function (bimModel) {
        if (model.viewer && model.viewer.position) {
          var pos = model.viewer.position;
          bimModel.mesh.position.set(pos.x, pos.y, pos.z);
        }

        self.data.addModel(bimModel);
        self.viewer.addBimModel(bimModel);
        _this.bimModel = bimModel;

        if (self.isModelFull()) {
          var models = self.data.getModels();
          models[0].makeTransparent(0.5);
          self.viewer.setDirty(true);
          self.objectPicker.stop();
          self.objectMover = new BimObjectMover(self.viewer, self.data);
          self.viewer.fitScreen(false);
        } else {
          if (model.plans !== undefined) {
            new BimPlanLoader(self.planSection, self.planControl3d).load(self.viewer, model.plans, self.data);
          } // if (model.viewer) {
          //   self.viewer.fitInBimModel(bimModel, false);
          //   self.viewer.setCameraData(bimModel, model.viewer.camera);
          // } else {


          self.viewer.fitInBimModel(bimModel, false); // }
        }

        resolve(bimModel);
      })["catch"](function (err) {
        reject(err);
      });
    });
  };

  this.loadBimModel = function (bimModel) {
    self.data.addModel(bimModel);
    self.viewer.addBimModel(bimModel);

    if (self.isModelFull()) {
      var models = self.data.getModels();
      models[0].makeTransparent(0.5);
      self.viewer.setDirty(true);
      self.objectPicker.stop();
      self.objectMover = new BimObjectMover(self.viewer, self.data);
      self.viewer.fitScreen(false);
    } else {
      self.viewer.fitInBimModel(bimModel, false);
    }
  };

  this.getBimData = function () {
    return this.data;
  };

  this.getBimModel = function () {
    return this.data.models[0];
  };

  this.exportCalculationData = function (sections) {
    return this.data.getCalculationData(sections);
  };

  this.isModelFull = function () {
    return this.data.isModelFull();
  };

  this.activateCmd = function (drawer) {
    if (this.curCmd) {
      this.curCmd.setActive(false);
    }

    this.curCmd = drawer;

    if (drawer) {
      this.objectPicker.stop();
      drawer.drawer2d = this.drawer2d;
      drawer.setActive(true);
      drawer.drawer2d.clear();
      this.signaler.toolActivated.dispatch(drawer.type);
    } else {
      this.objectPicker.start();
      this.signaler.toolActivated.dispatch(undefined);
    }

    return drawer;
  };

  this.newDimensions = function (cmd) {
    switch (cmd) {
      case 'commonlength':
        this.activateCmd(new BimMeasureDistanceCmd(this.viewer, this.overlay.scene).setCurrentUnit(this.currentUnit).setInputMethod(this.inputMethod));
        break;

      case 'angle':
        this.activateCmd(new BimMeasureAngleCmd(this.viewer, this.overlay.scene).setCurrentUnit(this.currentUnit).setInputMethod(this.inputMethod));
        break;

      case 'vertexlength':
        this.activateCmd(new BimMeasureVertexCmd(this.viewer, this.overlay.scene).setCurrentUnit(this.currentUnit).setInputMethod(this.inputMethod));
        break;

      case 'circumference':
      case 'diameter':
      case 'sameplane':
      case 'volume':
      case 'totalarea':
        this.activateCmd(new BimMeasureValueCmd(this.viewer, this.overlay.scene, cmd).setCurrentUnit(this.currentUnit).setInputMethod(this.inputMethod));
        break;
    }
  };

  this.onAddCrossSection = function () {
    this.activateCmd(new BimCrossSectionCmd(this.viewer, this.overlay.scene, this.crossSection, this.cutter3d));
  };

  this.onVisibleCrossSection = function () {
    this.cutter3d.enableCutter();
  };

  this.onApplyCrossSection = function () {
    if (this.crossSection.applyCrossSection()) {
      this.cutter3d.enableCutter();
    } else {
      this.cutter3d.disableCutter();
    }
  };

  this.takeScreenshot = function () {
    var imageData = this.viewer.getImage();
    var image = imageData.data;
    var linkElement = document.createElement('a');
    linkElement.setAttribute('href', image.replace("image/png", "image/octet-stream"));
    linkElement.setAttribute('download', "screenshot.png");
    linkElement.click();
  };

  this.takeImage = function () {
    var image3D = this.viewer.canvas.toDataURL({
      format: 'jpeg',
      quality: 1.0
    });
    return image3D;
  };

  this.newPaint = function () {
    if (this.colorMode === 'inventory') return;
    this.activateCmd(new BimPaintCmd(this.viewer, this.data, this.overlay.scene, this.fillColor, this.currentTexture));
  };

  this.newText = function () {
    this.activateCmd(new BimText2dCmd(this.viewer, this.overlay.scene, this.drawer2dText, this.textBrush));
  };

  this.setDragAction = function (action) {
    this.activateCmd(undefined);
    this.viewer.setDragAction(action);
  };

  this.setSize = function (width, height) {
    this.viewer.setSize(width, height);
    this.drawer2d.reset();
  };

  this.newBimPlan = function (pdf) {
    this.activateCmd(new BimPlanMatchCmd(this.viewer, this.overlay.scene, pdf, addBimPlan));
  };
  /**
   * complete bim plan
   * @param bimPlan {BimPlan}
   */


  this.completeBimPlan = function (bimPlan) {
    this.planTransformer = undefined;
    bimPlan.setCompleted();
  };
  /**
   * remove bim plan
   * @param bimPlan {BimPlan}
   */


  this.removeBimPlan = function (bimPlan) {
    this.planTransformer = undefined;
    bimPlan.destroy();
    this.data.removePlan(bimPlan);
    this.signaler.planRemoved.dispatch(bimPlan);
  };
  /**
   * show bim plan
   * @param bimPlan {BimPlan}
   */


  this.showBimPlan = function (bimPlan) {
    bimPlan.setVisible(true);
    this.viewer.setCameraViews(bimPlan.cameraViewType());
  };

  this.toggleShowBimPlan = function (bimPlan) {
    if (!bimPlan.isVisible()) {
      bimPlan.setVisible(true);
      this.viewer.setCameraViews(bimPlan.cameraViewType());
    } else {
      bimPlan.setVisible(false);
    }
  };

  this.invalidate = function () {
    this.viewer.setDirty(true);
  };

  this.updateVisibility = function (ids) {
    this.viewer.updateVisibility(ids);
  };

  this.setFillColor = function (color) {
    if (this.colorMode === 'inventory') return;
    this.fillColor = color;
    this.currentTexture = undefined;
    this.newPaint();
  };

  this.setCurrentTexture = function (texture) {
    if (this.colorMode === 'inventory') return;
    this.currentTexture = texture;
    this.newPaint();
  };

  this.flipTexture = function () {
    var object = this.data.getSelectedObject();

    if (object) {
      var mesh = object.mesh;

      if (mesh.geometry.isBufferGeometry && mesh.geometry.attributes.uv) {
        var texture = mesh.material.map;
        var uvs = mesh.geometry.attributes.uv.array;

        for (var i = 0; i < uvs.length; i += 2) {
          var temp = uvs[i];
          uvs[i] = uvs[i + 1];
          uvs[i + 1] = temp;
        }

        mesh.material = undefined;
        mesh.material = new THREE.MeshLambertMaterial({
          map: texture
        });
        mesh.material.map.needsUpdate = true;
        mesh.material.needsUpdate = true;
        mesh.geometry.uvsNeedUpdate = true;
      }
    }
  };

  this.updateCurrentUnit = function (unit) {
    this.currentUnit = unit;

    if (this.curCmd && this.curCmd.setCurrentUnit) {
      this.curCmd.setCurrentUnit(unit);
    }
  };

  this.selectBimObject = function (bimObject) {
    this.data.clearSelection();
    this.data.setObjectSelected(bimObject, true);
    this.signaler.objectSelected.dispatch(bimObject, [bimObject]);
    this.viewer.setDirty(true);
  };

  this.selectBimObjects = function (bimObjects) {
    this.data.setObjectsSelected(bimObjects, true);
    this.signaler.objectSelected.dispatch(bimObjects[0], this.data.getSelectedObjects());
    this.viewer.setDirty(true);
  };

  this.toggleModelItemSelected = function (bimModel, item) {
    bimModel.toggleItemSelected(item);
    var bimObjects = bimModel.getBimObjectsFrom(item);
    this.signaler.objectSelected.dispatch(bimObjects[0], this.data.getSelectedObjects());
    this.viewer.setDirty(true);
  };

  this.setCursor = function (cursor, isUrl, isUp) {
    this.viewer.setCursor(cursor, isUrl, isUp);
  };

  this.setTheme = function (theme) {
    this.theme = theme.id;
    this.viewer.setTheme(theme);
    this.viewer.setDirty(true);
  };

  this.getTheme = function () {
    return this.theme;
  };

  this.setQuality = function (quality) {
    if (this.viewer.setQuality(quality)) {
      this.data.setQuality(quality);
      this.clippingManager.setQuality(this.viewer);
    }

    this.viewer.setDirty(true);
  };

  this.setColorMode = function (colorMode) {
    if (this.colorMode === colorMode) return;
    this.colorMode = colorMode;
    this.data.setColorMode(colorMode);
    this.viewer.setDirty(true);
  };

  this.setSelectMode = function (faceMode) {
    if (this.faceMode === faceMode) return;
    this.faceMode = faceMode;
    this.data.setSelectMode(faceMode);
    this.viewer.setDirty(true);
  };

  this.setCameraMode = function (mode) {
    this.viewer.setCameraMode(mode);
    this.data.setPlansVisible(mode === 'default');
  };

  this.changeWalkCameraControl = function (dir) {
    this.viewer.changeWalkCameraControl(dir);
  };

  this.setInputMethod = function (method) {
    this.inputMethod = method;
  };

  this.changeTextInfo = function (prop, value) {
    if (prop === 'stroke') {
      this.textBrush.strokeColor = value;
    } else if (prop === 'fill') {
      this.textBrush.fillColor = value;
    } else if (prop === 'fontFamily') {
      this.textBrush.fontFamily = value;
    } else if (prop === 'fontSize') {
      this.textBrush.fontSize = value;
    } else if (prop === 'fontStyle') {
      this.textBrush.fontStyle = value;
    }

    if (this.curCmd && this.curCmd instanceof BimText2dCmd) {
      this.curCmd.changeTextInfo(prop, value);
    }
  };

  this.getCameraData = function () {
    return this.viewer.getCameraData();
  };

  this.getModelsPosition = function () {
    return this.data.getModelsPosition();
  };

  this.removeCollision = function () {
    var model = this.data.removeLastModel();

    if (model) {
      this.viewer.removeBimModel(model);
      this.viewer.fitScreen(false);
    }

    var models = this.data.getModels();
    models[0].makeTransparent();
    this.viewer.setDirty(true);
    this.objectPicker.start();

    if (this.objectMover) {
      this.objectMover.destroy();
      this.objectMover = undefined;
    }
  };

  this.detectCollision = function () {
    var models = self.data.getModels();
    self.viewer.scene.updateMatrixWorld();
    var collisionList = [];

    for (var i = 0; i < models.length - 1; i++) {
      var modelA = models[i];
      var aBimObjects = modelA.getBimObjects();

      for (var k = i + 1; k < models.length; k++) {
        var modelB = models[k];
        var bBimObjects = modelB.getBimObjects();

        for (var j = 0; j < aBimObjects.length; j++) {
          for (var l = 0; l < bBimObjects.length; l++) {
            if (aBimObjects[j].isIntersect(bBimObjects[l])) {
              collisionList.push({
                object1: aBimObjects[j],
                object2: bBimObjects[l]
              });
            }
          }
        }
      }
    }

    return collisionList;
  };

  this.showCollision = function (collision) {
    this.data.clearSelection();
    collision.object1.setSelected(true);
    collision.object2.setSelected(true);
    this.viewer.fitInBimObject(collision.object2, true);
  };

  function addBimPlan(pdf, params) {
    var bimPlan = new BimPlan(self.viewer, self.planSection, self.planControl3d);
    bimPlan.name = pdf.name;
    bimPlan.pdfImage = pdf.data;
    bimPlan.image = pdf.data;
    bimPlan.pdf = pdf.pdfData;
    bimPlan.setNormal(params.normal);
    var maxSize = params.rw * 3.5;

    if (pdf.size.width > pdf.size.height) {
      bimPlan.size = {
        width: maxSize * pdf.size.width / pdf.size.height,
        height: maxSize
      };
    } else {
      bimPlan.size = {
        width: maxSize,
        height: maxSize * pdf.size.height / pdf.size.width
      };
    }

    new THREE.TextureLoader().load(pdf.data, function (texture) {
      texture.flipY = false;
      var mesh = new THREE.Mesh(new THREE.PlaneGeometry(bimPlan.size.width, bimPlan.size.height), new THREE.MeshBasicMaterial({
        map: texture,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.6
      }));
      mesh.name = 'plan';
      mesh.matrix.identity();
      var kind = bimPlan.kindOf();

      switch (kind.axis) {
        case 'yz':
          params.matrix.elements[12] += kind.dir ? 0.05 : -0.05;
          break;

        case 'xz':
          params.matrix.elements[13] += kind.dir ? 0.05 : -0.05;
          break;

        default:
          params.matrix.elements[14] += kind.dir ? 0.05 : -0.05;
          break;
      }

      mesh.applyMatrix4(params.matrix);
      mesh.geometry.computeBoundingBox();
      mesh.userData.type = 'plan';
      mesh.userData.unSnapable = true;
      mesh.userData.unClippable = true;
      self.viewer.addObject(mesh);
      bimPlan.mesh = mesh;
      new THREE.TextureLoader().load('assets/images/cgviewer/marker-2d.png', function (markerTexture) {
        var marker = new THREE.Sprite(new THREE.SpriteMaterial({
          map: markerTexture,
          depthTest: false,
          depthWrite: false
        }));
        marker.matrix.identity();
        marker.userData.type = 'plan-marker';
        marker.userData.unSnapable = true;
        marker.userData.unClippable = true;
        marker.userData.fixedSize = true;
        marker.renderOrder = 1000;
        marker.applyMatrix4(params.matrix);
        marker.visible = false;
        self.viewer.addObject(marker);
        bimPlan.marker = marker;
        bimPlan.transformer = new BimPlanTransformer(self.viewer, bimPlan, self.drawer2d);
        bimPlan.setup();
        self.data.addPlan(bimPlan);
        self.signaler.planAdded.dispatch(bimPlan);
        self.signaler.planTransformReady.dispatch(bimPlan, {
          x: params.x,
          y: params.y
        });
      }, undefined, function (err) {
        console.error(err);
      });
    }, undefined, function (err) {
      console.error(err);
    });
  }
  /**
   * @param markers {[{x: Number, y: Number, z: Number}]}
   */


  this.loadMarkers = function (markers) {
    for (var i = 0; i < markers.length; i++) {
      addMarkingIcon(markers[i]);
    }
  };

  this.getMarkers = function () {
    var data = [];

    for (var i = 0; i < this.markers.length; i++) {
      var position = this.markers[i].position;
      data.push({
        x: position.x,
        y: position.y,
        z: position.z
      });
    }

    return data;
  };

  this.addMarker = function () {
    this.mouseStatus = 'marking';
    this.setCursor('hotspot', true, true);
  };

  this.removeMarker = function () {
    this.mouseStatus = 'removing';
    this.setCursor('eraser', true, true);
  };

  this.removeAllMarkers = function () {
    for (var i = 0; i < this.markers.length; i++) {
      var marker = this.markers[i];
      self.viewer.removeObject(marker);
    }

    self.markers = [];
    self.viewer.setDirty(true);
  };

  this.placeMarker = function (pos2d, levelId) {
    var floor = this.bimModel.floors.find(function (x) {
      return x.guid === levelId;
    });
    var box = this.bimModel.getFloorBoundingBox(floor);
    var size = new THREE.Vector3(0, 0, 0);
    var center = new THREE.Vector3(0, 0, 0);
    size = box.getSize(size);
    center = box.getCenter(center);
    var x = (0.5 - pos2d.x) * size.x + center.x;
    var y = (0.5 - pos2d.y) * size.y + center.y;
    var position = new THREE.Vector3(x, y, center.z);
    addMarkingIcon(position);
  };

  this.get2dPos = function (markerPos, levelId) {
    var floor = this.bimModel.floors.find(function (x) {
      return x.guid === levelId;
    });
    var box = this.bimModel.getFloorBoundingBox(floor);
    var size = new THREE.Vector3(0, 0, 0);
    size = box.getSize(size);
    var x = markerPos.x - box.min.x;
    var y = markerPos.y - box.min.y;
    return {
      x: size.x === 0 ? 0 : x / size.x,
      y: size.y === 0 ? 0 : y / size.y
    };
  };

  function mousedown(event) {
    if (self.mouseStatus !== "marking" && self.mouseStatus !== 'removing') {
      return;
    }

    if (event.which !== 1) {
      //check if left button clicked
      return;
    }

    event.preventDefault();
    var canvas = self.viewer.canvas;
    var rayCaster = new THREE.Raycaster();
    var mousePosition = new THREE.Vector2();
    var rect = canvas.getBoundingClientRect();
    mousePosition.x = (event.clientX - rect.left) / self.viewer.width * 2 - 1;
    mousePosition.y = -((event.clientY - rect.top) / self.viewer.height) * 2 + 1;
    rayCaster.setFromCamera(mousePosition, self.viewer.camera);

    if (self.mouseStatus === 'marking') {
      var intersects = rayCaster.intersectObject(self.viewer.scene, true);

      if (intersects.length > 0) {
        var point = intersects[0].point;
        addMarkingIcon(point);
        self.setCursor('default');
        self.mouseStatus = undefined;
        self.signaler.markerPlaced.dispatch(true, {
          x: point.x,
          y: point.y,
          z: point.z
        });
      }
    } else {
      var _intersects = rayCaster.intersectObjects(self.markers, true);

      if (_intersects.length > 0) {
        removeMarkingIcon(_intersects[0].object);
        self.setCursor('default');
        self.mouseStatus = undefined;
        self.signaler.markerRemoved.dispatch(true);
      }
    }
  }

  function addMarkingIcon(pos) {
    if (pos.status === 'Open' && pos.hasMessages) {
      pos.status = 'Open-Message';
    }

    var hotspotUrl = self.hotspotUrls[pos.status];

    if (!hotspotUrl) {
      hotspotUrl = self.defaultHotspotUrl;
    }

    new THREE.TextureLoader().load(hotspotUrl, function (texture) {
      texture.minFilter = THREE.LinearFilter;
      texture.needsUpdate = true;
      var marker = new THREE.Sprite(new THREE.SpriteMaterial({
        map: texture,
        depthTest: false
      }));
      marker.scale.set(1.5, 1.5, 1.5);
      marker.position.set(pos.x, pos.y, pos.z);
      marker.renderOrder = 1000;
      marker.userData.fixedSize = true;
      marker.userData.unClippable = true;
      self.viewer.addObject(marker);
      self.viewer.setDirty(true);
      self.markers.push(marker);
    });
  }

  function removeMarkingIcon(marker) {
    self.viewer.removeObject(marker);
    self.viewer.setDirty(true);
    var index = self.markers.indexOf(marker);

    if (index !== -1) {
      self.markers.splice(index, 1);
    }
  }
  /**
   * show all objects
   */


  this.showAllObject = function () {
    if (!this.bimModel) return;
    this.bimModel.setAllItemVisible(true);
    this.viewer.fitScreen(true);
    this.viewer.setDirty(true);
  };
  /**
   * show only object by GUID
   * @param guid {String}
   */


  this.showObject = function (guid) {
    if (!this.bimModel) return;
    var item = this.bimModel.getItemByGuid(guid);

    if (item !== undefined) {
      this.bimModel.setItemVisibleOnly(item);
      this.viewer.fitScreen(true);
      this.viewer.setDirty(true);
    }
  };
}


"use strict";

function BimMarkingViewer(container) {
  'use strict';

  BimSimpleViewer.call(this, container, 'high');
  var self = this;
  this.drawingTool = undefined;
  this.clipping = undefined;
  this.overlay = {
    scene: new THREE.Scene(),
    render: function render(renderer, camera) {
      this.scene.updateMatrixWorld();
      renderer.render(this.scene, camera);
    }
  };
  this.clippingManager = new BimClippingManager();
  this.crossSection = new CrossSection(this.viewer, this.clippingManager);
  this.clippingManager.add(this.crossSection);
  this.cutter3d = new BimCutter3d(this.viewer, this.crossSection, undefined);
  this.cutter3d.stopDisable = true;
  this.viewer.addOverlay(this.overlay);
  this.viewer.addOverlay(this.cutter3d);
  this.markers = [];
  this.mouseStatus = undefined;
  this.defaultHotspotUrl = '/assets/images/cgviewer/vp-issue-hold.svg';
  this.hotspotUrls = {
    'Open': '/assets/images/cgviewer/vp-issue-hold.svg',
    'Open-Message': '/assets/images/cgviewer/vp-issue-open.svg',
    'On Hold': '/assets/images/cgviewer/vp-issue-hold.svg',
    'Resolved': '/assets/images/cgviewer/vp-issue-completed.svg',
    'Completed': '/assets/images/cgviewer/vp-issue-completed.svg'
  };
  self.viewer.canvas.addEventListener("pointerdown", mousedown, false);
  this.signaler.clippingAdded.add(clippingAdded);

  this.clear = function () {
    this.bimModel = undefined;
    this.viewer.clear();
    this.removeCrossSection();
  };
  /**
   * @param markers {[{x: Number, y: Number, z: Number}]}
   */


  this.loadMarkers = function (markers) {
    for (var i = 0; i < markers.length; i++) {
      addMarkingIcon(markers[i]);
    }
  };

  this.getMarkers = function () {
    var data = [];

    for (var i = 0; i < this.markers.length; i++) {
      var position = this.markers[i].position;
      data.push({
        x: position.x,
        y: position.y,
        z: position.z
      });
    }

    return data;
  };

  this.addMarker = function () {
    this.mouseStatus = 'marking';
    this.setCursor('hotspot', true, true);
  };

  this.removeMarker = function () {
    this.mouseStatus = 'removing';
    this.setCursor('eraser', true, true);
  };

  this.removeAllMarkers = function () {
    for (var i = 0; i < this.markers.length; i++) {
      var marker = this.markers[i];
      self.viewer.removeObject(marker);
    }

    self.markers = [];
    self.viewer.setDirty(true);
  };

  this.placeMarker = function (pos2d, levelId) {
    var floor = this.bimModel.floors.find(function (x) {
      return x.guid === levelId;
    });
    var box = this.bimModel.getFloorBoundingBox(floor);
    var size = new THREE.Vector3(0, 0, 0);
    var center = new THREE.Vector3(0, 0, 0);
    size = box.getSize(size);
    center = box.getCenter(center);
    var x = (0.5 - pos2d.x) * size.x + center.x;
    var y = (0.5 - pos2d.y) * size.y + center.y;
    var position = new THREE.Vector3(x, y, center.z);
    addMarkingIcon(position);
  };

  this.get2dPos = function (markerPos, levelId) {
    var floor = this.bimModel.floors.find(function (x) {
      return x.guid === levelId;
    });
    var box = this.bimModel.getFloorBoundingBox(floor);
    var size = new THREE.Vector3(0, 0, 0);
    size = box.getSize(size);
    var x = markerPos.x - box.min.x;
    var y = markerPos.y - box.min.y;
    return {
      x: size.x === 0 ? 0 : x / size.x,
      y: size.y === 0 ? 0 : y / size.y
    };
  };

  this.addCrossSection = function () {
    this.drawingTool = new BimCrossSectionCmd(this.viewer, this.overlay.scene, this.crossSection, this.cutter3d);
    this.drawingTool.setActive(true);
  };

  this.removeCrossSection = function () {
    if (this.drawingTool) {
      this.drawingTool.setActive(false);
      this.drawingTool = undefined;
    }

    this.crossSection.clear();
    this.cutter3d.clear();
    this.clipping = undefined;
  };

  this.hasClipping = function () {
    return self.clipping !== undefined;
  };

  this.getClipping = function () {
    if (self.clipping) {
      var size = self.clipping.plane.geometry.parameters;
      return {
        size: {
          width: size.width,
          height: size.height
        },
        matrix: self.clipping.plane.matrix.toArray(),
        normal: {
          x: self.clipping.normal.x,
          y: self.clipping.normal.y,
          z: self.clipping.normal.z
        }
      };
    }

    return undefined;
  };

  this.loadClipping = function (clipping) {
    if (!clipping || !clipping.size || !clipping.matrix || !clipping.normal || !clipping.matrix.length) {
      return;
    }

    this.clipping = clipping;
    var geometry = new THREE.PlaneGeometry(clipping.size.width, clipping.size.height);
    var mat = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      side: THREE.DoubleSide,
      opacity: 0.5
    });
    var entity = new THREE.Mesh(geometry, [mat]);
    entity.userData.unSnapable = true;
    entity.userData.unClippable = true;
    var matrix = new THREE.Matrix4();
    matrix.fromArray(clipping.matrix);
    entity.applyMatrix4(matrix);
    var normalVec = new THREE.Vector3(clipping.normal.x, clipping.normal.y, clipping.normal.z);
    this.crossSection.addClippingPlaneEntity(entity);
    this.cutter3d.addCutter(entity, normalVec);
    this.viewer.addObject(entity);
    this.viewer.signaler.clippingAdded.dispatch({
      plane: entity,
      normal: normalVec
    });
  };

  this.disableControl = function () {
    this.cutter3d.setEnabled(false);
    self.viewer.canvas.removeEventListener("pointerdown", mousedown, false);
  };

  function mousedown(event) {
    if (self.mouseStatus !== "marking" && self.mouseStatus !== 'removing') {
      return;
    }

    if (event.which !== 1) {
      //check if left button clicked
      return;
    }

    event.preventDefault();
    var canvas = self.viewer.canvas;
    var rayCaster = new THREE.Raycaster();
    var mousePosition = new THREE.Vector2();
    var rect = canvas.getBoundingClientRect();
    mousePosition.x = (event.clientX - rect.left) / self.viewer.width * 2 - 1;
    mousePosition.y = -((event.clientY - rect.top) / self.viewer.height) * 2 + 1;
    rayCaster.setFromCamera(mousePosition, self.viewer.camera);

    if (self.mouseStatus === 'marking') {
      var intersects = rayCaster.intersectObject(self.viewer.scene, true);

      if (intersects.length > 0) {
        var point = intersects[0].point;
        addMarkingIcon(point);
        self.setCursor('default');
        self.mouseStatus = undefined;
        self.signaler.markerPlaced.dispatch(true, {
          x: point.x,
          y: point.y,
          z: point.z
        });
      }
    } else {
      var _intersects = rayCaster.intersectObjects(self.markers, true);

      if (_intersects.length > 0) {
        removeMarkingIcon(_intersects[0].object);
        self.setCursor('default');
        self.mouseStatus = undefined;
        self.signaler.markerRemoved.dispatch(true);
      }
    }
  }

  function addMarkingIcon(pos) {
    if (pos.status === 'Open' && pos.hasMessages) {
      pos.status = 'Open-Message';
    }

    var hotspotUrl = self.hotspotUrls[pos.status];

    if (!hotspotUrl) {
      hotspotUrl = self.defaultHotspotUrl;
    }

    new THREE.TextureLoader().load(hotspotUrl, function (texture) {
      texture.minFilter = THREE.LinearFilter;
      texture.needsUpdate = true;
      var marker = new THREE.Sprite(new THREE.SpriteMaterial({
        map: texture,
        depthTest: false
      }));
      marker.scale.set(1.5, 1.5, 1.5);
      marker.position.set(pos.x, pos.y, pos.z);
      marker.renderOrder = 1000;
      marker.userData.fixedSize = true;
      marker.userData.unClippable = true;
      self.addObject(marker);
      self.viewer.setDirty(true);
      self.markers.push(marker);
    });
  }

  function removeMarkingIcon(marker) {
    self.viewer.removeObject(marker);
    self.viewer.setDirty(true);
    var index = self.markers.indexOf(marker);

    if (index !== -1) {
      self.markers.splice(index, 1);
    }
  }

  function clippingAdded(ev) {
    self.clipping = ev;
  }
}


"use strict";

function BimNavigationController(viewer3d, planViewer) {
  var self = this;
  this.viewer3d = viewer3d;
  this.viewer2d = planViewer;
  this.viewer3d.setCameraMode('walk');
  this.bimPlan = undefined;

  this.setBimModel = function (bimModel) {
    this.viewer3d.addBimModel(bimModel, true);
  };

  this.setBimPlan = function (bimPlan) {
    this.bimPlan = bimPlan;
  };

  this.start = function () {
    this.viewer2d.setNavigationMode(true);
    this.viewer3d.signaler.cameraControlChanged.add(this.onCameraControlChanged);
    this.viewer2d.setSize();
    this.viewer3d.setSize();
  };

  this.stop = function () {
    this.viewer3d.signaler.cameraControlChanged.remove(this.onCameraControlChanged);
    this.viewer2d.setNavigationMode(false);
    this.viewer2d.setSize();
    this.viewer3d.setSize();
  };

  this.onCameraControlChanged = function (camera) {
    if (self.viewer2d.isLoaded) {
      var iconPos = get2DIconPos(camera, self.bimPlan);
      self.viewer2d.setNavigationIconPos(iconPos.pos, iconPos.angle);
    }
  };

  function get2DIconPos(camera, plan) {
    var raycaster = new THREE.Raycaster();
    var cameraPosition = camera.position.clone();
    var normalVector = plan.normal.clone();
    raycaster.set(cameraPosition, normalVector);
    raycaster.camera = camera;
    var intersects = raycaster.intersectObject(plan.mesh);

    if (!intersects || intersects.length === 0) {
      normalVector = normalVector.multiplyScalar(-1);
      raycaster.set(cameraPosition, normalVector);
      intersects = raycaster.intersectObject(plan.mesh);
    }

    if (intersects && intersects.length > 0) {
      var cameraLookVector = new THREE.Vector3(0, 0, -1);
      cameraLookVector.applyEuler(camera.rotation, camera.rotation.order);
      cameraLookVector.normalize();
      cameraLookVector.projectOnPlane(normalVector);
      var vector2d;
      var kind = plan.kindOf();

      switch (kind.axis) {
        case 'xz':
          vector2d = new THREE.Vector2(cameraLookVector.x, cameraLookVector.z);
          break;

        case 'yz':
          vector2d = new THREE.Vector2(cameraLookVector.y, cameraLookVector.z);
          break;

        default:
          vector2d = new THREE.Vector2(cameraLookVector.x, cameraLookVector.y);
          break;
      }

      var angle = -vector2d.angle();
      var pt = intersects[0].uv;
      return {
        pos: pt,
        angle: angle
      };
    }

    return {};
  }
}


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function BimPlanGenerator() {
  this.objectList = [];
  this.shapeList = {};
  this.colorList = [];
  this.maxWallWidth = 0;
  this.guid = undefined;
  this.validShapeList = ["IfcWallStandardCase", "IfcDoor", "IfcSlab", "IfcWindow", "IfcStair", "IfcColumn"];
  this.alltogetherObj = undefined;
  var self = this;

  this.generate = function (items, bInventory, fabricCanvas, pageSize) {
    var _this = this;

    return new Promise(function (resolve) {
      setTimeout(function () {
        if (fabricCanvas) {
          _this.objectList = [];
          _this.shapeList = {};
          _this.colorList = [];
          _this.maxWallWidth = 0;
          _this.validShapeList = ["IfcWallStandardCase", "IfcDoor", "IfcSlab", "IfcWindow", "IfcStair", "IfcColumn"];

          var _iterator = _createForOfIteratorHelper(items),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;

              if (item) {
                getObjectListFromNode(item);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          createPlanFromObjectList(_this.objectList, bInventory, fabricCanvas, pageSize, items[0].name);
        } else {
          var canvas = document.createElement("canvas");
          canvas.width = pageSize.size.width;
          canvas.height = pageSize.size.height;
          canvas.id = 'plan-buffer-canvas';
          fabricCanvas = new fabric.Canvas(canvas.id, {
            width: canvas.width,
            height: canvas.height //imageSmoothingEnabled: false

          });
          var prevCanvas = _this.alltogetherObj.canvas;
          var zoomValue = canvas.width / prevCanvas.width;

          if (zoomValue > canvas.height / prevCanvas.height) {
            zoomValue = canvas.height / prevCanvas.height;
          }

          _this.alltogetherObj.set({
            left: canvas.width / 2,
            top: canvas.height / 2,
            originX: "center",
            originY: "center",
            scaleX: zoomValue,
            scaleY: zoomValue
          });

          fabricCanvas.add(_this.alltogetherObj);
          fabricCanvas.renderAll();
          exportPlan(fabricCanvas, items[0].name, pageSize);
        }

        resolve();
      }, 10);
    });
  };

  this.createCanvas = function (canvasElement) {
    var canvas = new fabric.Canvas(canvasElement.id, {
      width: canvasElement.width,
      height: canvasElement.height
    });
    fabric.zoom = 1;
    return canvas;
  };

  function getObjectListFromNode(node) {
    if (node.children) {
      node.children.forEach(function (child) {
        if (child) {
          getObjectListFromNode(child);
        }
      });
    } else if (node.object) {
      var bimObject = node.object;

      if (bimObject.mesh) {
        if (bimObject.type !== "IfcSpace") {
          self.objectList.push(bimObject);
        }
      }
    }
  }

  function calculate2DPlansForShape(objMatrix, vertices, normals, indices, matInv, scale, planSize, objectType, color) {
    var edges = [];

    for (var j = 0; j < indices.length / 3; j++) {
      var jnormal = new THREE.Vector3(normals[3 * 3 * j], normals[3 * 3 * j + 1], normals[3 * 3 * j + 2]);
      var knormal = new THREE.Vector3(0, 0, 1);
      var dotP = jnormal.dot(knormal);

      if (dotP >= -0.1) {
        edges.push([indices[3 * j], indices[3 * j + 1]]);
        edges.push([indices[3 * j + 1], indices[3 * j + 2]]);
        edges.push([indices[3 * j + 2], indices[3 * j]]);
      }
    }

    for (var _j = 0; _j < edges.length - 1; _j++) {
      for (var k = _j + 1; k < edges.length; k++) {
        if (edges[_j][0] == edges[k][1] && edges[_j][1] == edges[k][0] || edges[_j][0] == edges[k][0] && edges[_j][1] == edges[k][1]) {
          edges.splice(k, 1);
          edges.splice(_j, 1);
          _j--;
          break;
        }
      }
    }

    for (var j1 = 0; j1 < edges.length - 1; j1++) {
      if (edges[j1][1] == edges[j1 + 1][0]) {
        continue;
      } else {
        for (var j2 = j1 + 1; j2 < edges.length; j2++) {
          if (edges[j2][0] == edges[j1][1]) {
            var element = edges[j2];
            edges.splice(j2, 1);
            edges.splice(j1 + 1, 0, element);
            break;
          }
        }
      }
    }

    var edgesArray = [];
    var firstIdx = 0;
    var cnt = 1;

    for (var _j2 = 1; _j2 < edges.length; _j2++) {
      if (edges[_j2][0] == edges[_j2 - 1][1]) {
        cnt++;
        continue;
      } else {
        var subarray = edges.slice(firstIdx, firstIdx + cnt);
        edgesArray.push(subarray);
        firstIdx = _j2;
        cnt = 1;
      }
    }

    if (edgesArray.length <= 0) {
      edgesArray.push(edges);
    } else {
      var _subarray = edges.slice(firstIdx, firstIdx + cnt);

      edgesArray.push(_subarray);
    }

    for (var _j3 = 0; _j3 < edgesArray.length; _j3++) {
      var pts = [];
      edges = edgesArray[_j3];

      for (var _j4 = 0; _j4 < edges.length; _j4++) {
        var tpt3 = new THREE.Vector3(vertices[3 * edges[_j4][0]], vertices[3 * edges[_j4][0] + 1], vertices[3 * edges[_j4][0] + 2]);

        if (objMatrix) {
          var mat = new THREE.Matrix4();
          mat.elements = objMatrix;
          tpt3.applyMatrix4(mat);
        }

        tpt3.applyMatrix4(matInv);
        var pt = new THREE.Vector2(tpt3.x, tpt3.y);
        pt.x = pt.x * scale + planSize.w * 0.5;
        pt.y = planSize.h * 0.5 - pt.y * scale;
        pts.push(pt);
        tpt3 = new THREE.Vector3(vertices[3 * edges[_j4][1]], vertices[3 * edges[_j4][1] + 1], vertices[3 * edges[_j4][1] + 2]);

        if (objMatrix) {
          var _mat = new THREE.Matrix4();

          _mat.elements = objMatrix;
          tpt3.applyMatrix4(_mat);
        }

        tpt3.applyMatrix4(matInv);
        pt = new THREE.Vector2(tpt3.x, tpt3.y);
        pt.x = pt.x * scale + planSize.w * 0.5;
        pt.y = planSize.h * 0.5 - pt.y * scale;
        pts.push(pt);
      }

      if (!self.shapeList[objectType]) {
        self.shapeList[objectType] = [];
      }

      self.shapeList[objectType].push({
        color: color ? color.color : undefined,
        points: pts
      }); //check max wall width
      // if (object.type === "IfcWallStandardCase") {
      //   let w = pts[0].clone().sub(pts[1]).length();
      //   let h = pts[0].clone().sub(pts[3]).length();
      //   let ww = w < h ? w : h;
      //   if (self.maxWallWidth < ww) {
      //     self.maxWallWidth = ww;
      //   }
      // }
    }
  }

  function createPlanFromObjectList(objects, bInventory, fabricCanvas, pageSize, title) {
    if (objects.length <= 0) return;
    var bbox = getBoundingBoxFromObjects(objects);
    var boxSize = new THREE.Vector3();
    bbox.getSize(boxSize);
    var boxCenter = new THREE.Vector3();
    bbox.getCenter(boxCenter);
    var bForPreview = true;
    var planSize = undefined;

    if (fabricCanvas != undefined) {
      bForPreview = true;
      planSize = {
        w: fabricCanvas.width,
        h: fabricCanvas.height
      };
    } else {
      planSize = {
        w: pageSize.size.width,
        h: pageSize.size.height
      };
      bForPreview = false;
    }

    var boxRatio = boxSize.y / boxSize.x;
    var planRatio = planSize.h / planSize.w;
    var scale = planSize.w / boxSize.x * Bim.Plan3dRatio;

    if (planRatio < boxRatio) {
      scale = planSize.h / boxSize.y * Bim.Plan3dRatio;
    }

    var box = new THREE.Box3();
    var size = new THREE.Vector3();
    var center = new THREE.Vector3();
    var pt1;
    var pt2;
    var pt3;
    var pt4 = new THREE.Vector2();
    var pts = [];
    self.shapeList = {};
    self.maxWallWidth = 0;

    if (fabricCanvas == undefined) {
      var canvas = document.createElement("canvas");
      canvas.width = planSize.w;
      canvas.height = planSize.h;
      canvas.id = 'plan-buffer-canvas';
      fabricCanvas = new fabric.Canvas(canvas.id, {
        width: canvas.width,
        height: canvas.height //imageSmoothingEnabled: false

      });
    }

    fabricCanvas.backgroundColor = "white"; // let backgroundRect = new fabric.Rect({
    //   left: 0,
    //   right: 0,
    //   width:  planSize.w - 2,
    //   height:  planSize.h - 2,
    //   fill: 'white'
    // });
    // fabricCanvas.add(backgroundRect);
    // backgroundRect.tempInfo = {
    //   backgroundObject: true
    // };

    var mat = new THREE.Matrix4();
    mat.makeTranslation(boxCenter.x, boxCenter.y, boxCenter.z);
    var matInv = new THREE.Matrix4();
    matInv.copy(mat).invert(); //calculate plan corner 3d points

    pt1 = new THREE.Vector2((bbox.min.x * scale + planSize.w * 0.5) / planSize.w, (planSize.h * 0.5 - bbox.min.y * scale) / planSize.h);
    pt2 = new THREE.Vector2((bbox.max.x * scale + planSize.w * 0.5) / planSize.w, (planSize.h * 0.5 - bbox.max.y * scale) / planSize.h);
    pt3 = new THREE.Vector2(pt1.x, pt2.y);
    self.cornerPts = BimUtils.getPlanCorner3dPts(bbox.min, new THREE.Vector3(bbox.max.x, bbox.max.y, bbox.min.z), new THREE.Vector3(bbox.min.x, bbox.max.y, bbox.min.z), pt1.x, pt1.y, pt2.x, pt2.y, pt3.x, pt3.y);
    self.cornerPts.map(function (pt) {
      pt.x += boxCenter.x;
      pt.y += boxCenter.y;
    }); //get 2d points

    for (var i = 0; i < objects.length; i++) {
      pts = [];
      var object = objects[i];

      if (self.validShapeList.indexOf(object.type) < 0) {
        self.validShapeList.push(object.type);
      }

      box = box.setFromObject(object.mesh);
      box.applyMatrix4(matInv);
      size = box.getSize(size);
      center = box.getCenter(center);

      if (object.type === "IfcDoor") {
        (function () {
          pt1 = new THREE.Vector2(box.min.x * scale + planSize.w * 0.5, planSize.h * 0.5 - box.min.y * scale);
          pt3 = new THREE.Vector2(box.max.x * scale + planSize.w * 0.5, planSize.h * 0.5 - box.max.y * scale);
          pt2 = new THREE.Vector2(pt1.x, pt3.y);
          pt4 = new THREE.Vector2(pt3.x, pt1.y);
          pts.push(pt1, pt2, pt3, pt4);
          var color = object.getColorForPlan(bInventory);

          if (color) {
            if (color._id && self.colorList.findIndex(function (x) {
              return x._id === color._id;
            }) === -1) {
              self.colorList.push(color);
            }
          }

          if (!self.shapeList[object.type]) {
            self.shapeList[object.type] = [];
          }

          self.shapeList[object.type].push({
            color: color ? color.color : undefined,
            points: pts
          });
        })();
      } else {
        if (bInventory && object.inventoryInfo) {
          for (var idx = 0; idx < object.shapes.length; idx++) {
            var shp = object.shapes[idx];
            var normals = shp.normals; //let indices = shp.indices

            var usedFaces = [];

            for (var j = 0; j < object.inventoryInfo.materials.length; j++) {
              if (object.inventoryInfo.materials[j].selectedFace !== undefined && object.inventoryInfo.materials[j].selectedFace.length > 0) {
                (function () {
                  var faces = object.inventoryInfo.materials[j].selectedFace;

                  var _loop = function _loop(k) {
                    if (usedFaces.findIndex(function (item) {
                      return item == faces[k];
                    }) === -1) {
                      usedFaces.push(faces[k]);
                    }
                  };

                  for (var k = 0; k < faces.length; k++) {
                    _loop(k);
                  }
                })();
              }
            }

            var _loop2 = function _loop2(fi) {
              if (usedFaces.findIndex(function (item) {
                return item == fi;
              }) !== -1) {
                return "continue";
              }

              var color = object.getColorForPlan(bInventory, fi);

              if (color) {
                if (color._id && self.colorList.findIndex(function (x) {
                  return x._id === color._id;
                }) === -1) {
                  self.colorList.push(color);
                }
              }

              var indices = shp.indices.slice(object.mesh.geometry.groups[fi].start, object.mesh.geometry.groups[fi].start + object.mesh.geometry.groups[fi].count);
              calculate2DPlansForShape(shp.matrices, shp.vertices, normals, indices, matInv, scale, planSize, object.type, color);
            };

            for (var fi = 0; fi < object.mesh.geometry.groups.length; fi++) {
              var _ret = _loop2(fi);

              if (_ret === "continue") continue;
            }

            var _loop3 = function _loop3(_i) {
              var color = object.getColorForPlan(bInventory, usedFaces[_i]);

              if (color) {
                if (color._id && self.colorList.findIndex(function (x) {
                  return x._id === color._id;
                }) === -1) {
                  self.colorList.push(color);
                }
              }

              var indices = shp.indices.slice(object.mesh.geometry.groups[usedFaces[_i]].start, object.mesh.geometry.groups[usedFaces[_i]].start + object.mesh.geometry.groups[usedFaces[_i]].count);
              calculate2DPlansForShape(shp.matrices, shp.vertices, normals, indices, matInv, scale, planSize, object.type, color);
            };

            for (var _i = 0; _i < usedFaces.length; _i++) {
              _loop3(_i);
            }
          }
        } else {
          var _loop4 = function _loop4(_idx) {
            var shp = object.shapes[_idx];
            var normals = shp.normals;
            var indices = shp.indices;
            var color = object.getColorForPlan(bInventory);

            if (color) {
              if (color._id && self.colorList.findIndex(function (x) {
                return x._id === color._id;
              }) === -1) {
                self.colorList.push(color);
              }
            }

            calculate2DPlansForShape(shp.matrices, shp.vertices, normals, indices, matInv, scale, planSize, object.type, color);
          };

          for (var _idx = 0; _idx < object.shapes.length; _idx++) {
            _loop4(_idx);
          }
        }
      }
    }

    for (var _i2 = 0; _i2 < self.validShapeList.length; _i2++) {
      var type = self.validShapeList[_i2];
      var shapes = self.shapeList[type];

      if (!shapes || shapes.length <= 0) {
        continue;
      }

      for (var _j5 = 0; _j5 < shapes.length; _j5++) {
        addElementToPlan(fabricCanvas, shapes[_j5].points, shapes[_j5].color, type, bbox);
      }
    }

    var objs = []; //get all the objects into an array

    objs = fabricCanvas._objects.filter(function (obj) {
      return obj;
    }); //group all the objects 
    // var alltogetherObj = new fabric.Group(objs,{
    //   top:200,left:250,
    //   originX:'center',
    //   originY:'center'});

    self.alltogetherObj = new fabric.Group(objs);
    self.alltogetherObj.setControlsVisibility({
      mt: false,
      // middle top disable
      mb: false,
      // midle bottom
      ml: false,
      // middle left
      mr: false // I think you get it

    }); //clear previous objects

    fabricCanvas._objects.forEach(function (obj) {
      fabricCanvas.remove(obj);
    });

    fabricCanvas.add(self.alltogetherObj);
    self.alltogetherObj.setCoords();
    fabricCanvas.renderAll();

    if (bForPreview === false) {
      exportPlan(fabricCanvas, title, pageSize);
    }

    self.planScale = scale;
    self.bbox = bbox;
  }

  function getBoundingBoxFromObjects(objects) {
    var bbox = new THREE.Box3();

    for (var i = 0; i < objects.length; i++) {
      var obj = objects[i].mesh;
      bbox.expandByObject(obj);
    }

    return bbox;
  }

  function exportPlan(fCanvas, title, size) {
    var imageData = fCanvas.toDataURL({
      format: 'png',
      quality: 1.0,
      multiplier: 2
    });
    var width = fCanvas.getWidth();
    var height = fCanvas.getHeight();
    new PdfBimPlan({
      data: imageData,
      width: width,
      height: height
    }, self.colorList)["export"](title, size);
  }

  function addElementToPlan(fCanvas, pts, color, type, bbox) {
    if (type === "IfcDoor") {
      addIfcDoor(fCanvas, pts, color);
    } else {
      addPolygon(fCanvas, pts, {
        fill: 'rgba(0,0,0,0)',
        stroke: color ? color : 'black'
      });
    }

    return;

    switch (type) {
      case "IfcWallStandardCase":
        addPolygon(fCanvas, pts, {
          fill: color ? color : 'black',
          stroke: 'black'
        });
        break;

      case "IfcDoor":
        addIfcDoor(fCanvas, pts, color);
        break;

      case "IfcSlab":
        addPolygon(fCanvas, pts, {
          fill: 'rgba(0,0,0,0)',
          stroke: color ? color : 'black'
        });
        break;

      case "IfcWindow":
        addIfcWindow(fCanvas, pts, color);
        break;

      case "IfcStair":
        addIfcStair(fCanvas, pts, color, bbox);
        break;

      case "IfcColumn":
        addIfcColumn(fCanvas, pts, color);
        break;

      default:
        addDefault(fCanvas, pts, color);
        break;
    }

    fCanvas.renderAll();
  }

  function addIfcDoor(fCanvas, pts, color) {
    var newPts = refinePointsToWidth(pts);
    var midPt1 = newPts[0].clone().add(newPts[3]).multiplyScalar(0.5);
    var midPt2 = newPts[1].clone().add(newPts[2]).multiplyScalar(0.5);
    var dir = newPts[0].clone().sub(newPts[3]).normalize();
    var pt1 = midPt1.clone().add(dir.clone().multiplyScalar(self.maxWallWidth));
    var pt2 = midPt2.clone().add(dir.clone().multiplyScalar(self.maxWallWidth));
    var pt3 = midPt2.clone().sub(dir.clone().multiplyScalar(self.maxWallWidth));
    var pt4 = midPt1.clone().sub(dir.clone().multiplyScalar(self.maxWallWidth));
    var ptArray = [];
    ptArray.push(pt1, pt2, pt3, pt4);
    addPolygon(fCanvas, ptArray, {
      fill: 'white',
      stroke: 'white'
    }, true);
    var dir2 = newPts[1].clone().sub(newPts[0]).normalize();
    var radius = newPts[1].clone().sub(newPts[0]).length();
    pt1 = midPt1.clone();
    pt2 = pt1.clone().add(dir.clone().multiplyScalar(radius));
    pt3 = pt2.clone().add(dir2.clone().multiplyScalar(1));
    pt4 = pt1.clone().add(dir2.clone().multiplyScalar(1));
    var v1 = pt2.clone().sub(pt1);
    var v2 = pt4.clone().sub(pt1);
    var angle1 = Math.atan2(v1.y, v1.x);
    var angle2 = Math.atan2(v2.y, v2.x);
    var ccw = false;
    v1 = new THREE.Vector3(v1.x, v1.y, 0);
    v2 = new THREE.Vector3(v2.x, v2.y, 0);

    if (v1.clone().cross(v2).z < 0) {
      ccw = true;
    }

    if (ccw) {
      var temp = angle1;
      angle1 = angle2;
      angle2 = temp;
    }

    ptArray = [];
    ptArray.push(pt1, pt2, pt3, pt4);
    addPolygon(fCanvas, ptArray, {
      stroke: color ? color : 'black'
    });
    var polygon = new fabric.Circle({
      radius: radius,
      left: pt1.x,
      top: pt1.y,
      originX: 'center',
      originY: 'center',
      startAngle: angle1,
      endAngle: angle2,
      stroke: color ? color : 'black',
      fill: 'rgba(0,0,0,0)'
    });
    fCanvas.add(polygon);
  }

  function addIfcWindow(fCanvas, pts, color) {
    var newPts = refinePointsToWidth(pts);
    var midPt1 = newPts[0].clone().add(newPts[3]).multiplyScalar(0.5);
    var midPt2 = newPts[1].clone().add(newPts[2]).multiplyScalar(0.5);
    var dir = newPts[0].clone().sub(newPts[3]).normalize();
    var pt1 = midPt1.clone().add(dir.clone().multiplyScalar(self.maxWallWidth));
    var pt2 = midPt2.clone().add(dir.clone().multiplyScalar(self.maxWallWidth));
    var pt3 = midPt2.clone().sub(dir.clone().multiplyScalar(self.maxWallWidth));
    var pt4 = midPt1.clone().sub(dir.clone().multiplyScalar(self.maxWallWidth));
    var ptArray = [];
    ptArray.push(pt1, pt2, pt3, pt4);
    addPolygon(fCanvas, ptArray, {
      fill: 'white'
    }, true);
    pt1 = midPt1.clone().add(dir.clone().multiplyScalar(self.maxWallWidth * 0.25));
    pt2 = midPt2.clone().add(dir.clone().multiplyScalar(self.maxWallWidth * 0.25));
    pt3 = midPt2.clone().sub(dir.clone().multiplyScalar(self.maxWallWidth * 0.25));
    pt4 = midPt1.clone().sub(dir.clone().multiplyScalar(self.maxWallWidth * 0.25));
    ptArray = [];
    ptArray.push(pt1, pt2, pt3, pt4);
    addPolygon(fCanvas, ptArray, {
      stroke: 'black',
      fill: color ? color : 'white'
    });
    var polygon = new fabric.Line([midPt1.x, midPt1.y, midPt2.x, midPt2.y], {
      stroke: 'black'
    });
    fCanvas.add(polygon);
  }

  function addIfcStair(fCanvas, pts, color, bbox) {
    var newPts = refinePointsToWidth(pts);
    var width = newPts[0].clone().sub(newPts[1]).length();
    var height = newPts[0].clone().sub(newPts[3]).length();
    var nDiv = Math.floor(width / (height * 0.3));
    var dDiv = width / (nDiv + 0.8);
    var dashA = Math.max(Math.floor(dDiv * 0.2), 1);
    var dashB = Math.max(Math.floor(dDiv * 0.8), 1);
    addPolygon(fCanvas, pts, {
      fill: 'rgba(0,0,0,0)',
      stroke: color ? color : 'black',
      strokeWidth: dashA
    });
    var midPt1 = newPts[0].clone().add(newPts[3]).multiplyScalar(0.5);
    var midPt2 = newPts[1].clone().add(newPts[2]).multiplyScalar(0.5);
    var polygon = new fabric.Line([midPt1.x, midPt1.y, midPt2.x, midPt2.y], {
      stroke: color ? color : 'black',
      strokeWidth: height,
      strokeDashArray: [dashA, dashB],
      originX: 'center',
      originY: 'center'
    });
    fCanvas.add(polygon);
    polygon.tempInfo = {
      snapDisabled: true
    };
    var digDir = bbox.max.clone().sub(bbox.min).normalize();
    var dir = newPts[0].clone().sub(newPts[1]).normalize();
    var startPos = midPt2.clone();

    if (digDir.dot(digDir) < 0) {
      dir.multiplyScalar(-1);
      startPos = midPt1.clone();
    }

    var fromPos = startPos.clone().add(dir.clone().multiplyScalar(0.3 * dDiv));
    var toPos = startPos.clone().add(dir.clone().multiplyScalar(1.5 * dDiv));
    var arrowPts = generateArrow(fromPos.x, fromPos.y, toPos.x, toPos.y);
    polygon = new fabric.Polyline(arrowPts, {
      fill: color ? color : 'black',
      stroke: color ? color : 'black',
      originX: 'left',
      originY: 'top'
    });
    fCanvas.add(polygon);
    polygon.tempInfo = {
      snapDisabled: true
    };
  }

  function addIfcColumn(fCanvas, pts, color) {
    var center = pts[0].clone().add(pts[2]).multiplyScalar(0.5);
    var radius = pts[0].clone().sub(center).length();
    var polygon = new fabric.Circle({
      radius: radius,
      left: center.x,
      top: center.y,
      originX: 'center',
      originY: 'center',
      startAngle: 0,
      endAngle: 2 * Math.PI,
      stroke: color ? color : 'black',
      fill: 'rgba(0,0,0,0)'
    });
    fCanvas.add(polygon);
  }

  function addDefault(fCanvas, pts, color) {
    addPolygon(fCanvas, pts, {
      fill: 'rgba(0,0,0,0)',
      stroke: 'black'
    });
    var polygon = new fabric.Line([pts[0].x, pts[0].y, pts[2].x, pts[2].y], {
      stroke: color ? color : 'black'
    });
    fCanvas.add(polygon);
    polygon = new fabric.Line([pts[1].x, pts[1].y, pts[3].x, pts[3].y], {
      stroke: color ? color : 'black'
    });
    fCanvas.add(polygon);
  }

  function addPolygon(fCanvas, pts, option, snapDisabled) {
    // for(let i = 0; i < pts.length / 2; i++ ){
    //   let line = new fabric.Line([pts[2*i].x, pts[2*i].y, pts[2*i+1].x, pts[2*i+1].y], option);
    //   fCanvas.add(line);
    // }
    //let polygon = new fabric.Polygon(pts.slice(), option);
    var polygon = new fabric.Polyline(pts.slice(), option);
    fCanvas.add(polygon);

    if (snapDisabled) {
      polygon.tempInfo = {
        snapDisabled: true
      };
    }
  }

  function refinePointsToWidth(pts) {
    var newPts = pts.slice(0);

    if (pts[0].clone().sub(pts[1]).length() < pts[0].clone().sub(pts[3]).length()) {
      newPts[1] = pts[3].clone();
      newPts[3] = pts[1].clone();
    }

    return newPts;
  }

  function generateArrow(fromx, fromy, tox, toy) {
    var angle = Math.atan2(toy - fromy, tox - fromx);
    var headlen = 15; // arrow head size
    // bring the line end back some to account for arrow head.

    tox = tox - headlen * Math.cos(angle);
    toy = toy - headlen * Math.sin(angle); // calculate the points.

    var points = [{
      x: fromx,
      // start point
      y: fromy
    }, {
      x: fromx - headlen / 4 * Math.cos(angle - Math.PI / 2),
      y: fromy - headlen / 4 * Math.sin(angle - Math.PI / 2)
    }, {
      x: tox - headlen / 4 * Math.cos(angle - Math.PI / 2),
      y: toy - headlen / 4 * Math.sin(angle - Math.PI / 2)
    }, {
      x: tox - headlen * Math.cos(angle - Math.PI / 2),
      y: toy - headlen * Math.sin(angle - Math.PI / 2)
    }, {
      x: tox + headlen * Math.cos(angle),
      // tip
      y: toy + headlen * Math.sin(angle)
    }, {
      x: tox - headlen * Math.cos(angle + Math.PI / 2),
      y: toy - headlen * Math.sin(angle + Math.PI / 2)
    }, {
      x: tox - headlen / 4 * Math.cos(angle + Math.PI / 2),
      y: toy - headlen / 4 * Math.sin(angle + Math.PI / 2)
    }, {
      x: fromx - headlen / 4 * Math.cos(angle + Math.PI / 2),
      y: fromy - headlen / 4 * Math.sin(angle + Math.PI / 2)
    }, {
      x: fromx,
      y: fromy
    }];
    return points;
  }
}


"use strict";

function BimPlanViewer(container) {
  var self = this;
  this.container = container;
  this.canvas = undefined;
  this.isLoaded = false;
  this.planImage = undefined;
  this.icon = undefined;
  this.signaler = new BimSignaler();
  this.generator = new BimPlanGenerator();
  var zoomRange = {
    min: 0.1,
    max: 10
  };
  var isDragging = false;
  var lastPosX = 0;
  var lastPosY = 0;
  var markerIcon = '/assets/images/cgviewer/vp-issue-open.svg';
  this.markers = [];
  this.mouseStatus = undefined;

  this.initialize = function (offsetWidth, offsetHeight) {
    this.canvasElement = document.createElement('canvas');
    this.canvasElement.id = 'canvas-2d-' + container.id;
    this.canvasElement["class"] = 'canvas-2d';
    this.container.appendChild(this.canvasElement);
    this.canvasElement.width = offsetWidth;
    this.canvasElement.height = offsetHeight;
    this.canvas = new fabric.Canvas(this.canvasElement.id, {
      width: container.offsetWidth,
      height: container.offsetHeight
    });
    this.canvas.selection = false;
    fabric.zoom = 1;
    this.canvas.on('mouse:down', onMouseDown);
    this.canvas.on('mouse:move', onMouseMove);
    this.canvas.on('mouse:up', onMouseUp);
    this.canvas.on('mouse:wheel', onMouseWheel);
    window.addEventListener("resize", resizeEvent, false);
  };

  this.destroy = function () {
    this.canvas.off('mouse:down', onMouseDown);
    this.canvas.off('mouse:move', onMouseMove);
    this.canvas.off('mouse:up', onMouseUp);
    this.canvas.off('mouse:wheel', onMouseWheel);
    this.signaler.clear();
    window.removeEventListener("resize", resizeEvent, false);
    this.markers = [];
  };

  this.loadBimModel = function (bimModel, guid) {
    var _this = this;

    var floors = bimModel.floors;
    var floor = floors.find(function (x) {
      return x.guid === guid;
    });
    return new Promise(function (resolve, reject) {
      _this.generator.generate([floor], false, _this.canvas).then(function () {
        self.planImage = self.generator.alltogetherObj;
        self.planImage.set({
          id: 'image',
          left: self.canvas.width / 2,
          top: self.canvas.height / 2,
          originX: 'center',
          originY: 'center',
          hasControls: false,
          hasBorders: false,
          selectable: false
        });
        resolve();
      })["catch"](reject);
    });
  };
  /**
   * @param url {String}
   */


  this.loadImage = function (url) {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      if (url === undefined) {
        reject();
        return;
      }

      fabric.Image.fromURL(url, function (image) {
        var w = self.canvas.getWidth();
        var h = self.canvas.getHeight();
        image.set({
          id: 'image',
          left: self.canvas.width / 2,
          top: self.canvas.height / 2,
          originX: 'center',
          originY: 'center',
          hasControls: false,
          hasBorders: false,
          selectable: false
        });

        if (w < h) {
          image.scaleToWidth(w - 20);
        } else {
          image.scaleToHeight(h - 20);
        }

        image.filters.push(new fabric.Image.filters.Resize({
          resizeType: 'sliceHack',
          scaleX: 1,
          scaleY: 1
        }));
        image.applyFilters();
        self.canvas.add(image);
        image.sendToBack();
        render();
        self.planImage = image;
        self.isLoaded = true;
        resolve();
      }.bind(_this2), {
        crossOrigin: 'anonymous'
      });
    });
  };
  /**
   * @param markers {[{x: Number, y: Number}]}
   */


  this.loadMarkers = function (markers) {
    if (!markers || markers.length === 0 || this.planImage === undefined) return;
    var w = this.planImage.width * this.planImage.scaleX;
    var h = this.planImage.height * this.planImage.scaleY;
    var left = this.planImage.left - w / 2.0;
    var top = this.planImage.top - h / 2.0;

    for (var i = 0; i < markers.length; i++) {
      addMarkingIcon({
        x: markers[i].x * w + left,
        y: markers[i].y * h + top
      });
    }
  };

  this.getMarkers = function () {
    var data = [];
    if (this.markers.length === 0) return data;
    var w = this.planImage.width * this.planImage.scaleX;
    var h = this.planImage.height * this.planImage.scaleY;
    var left = this.planImage.left - w / 2.0;
    var top = this.planImage.top - h / 2.0;

    for (var i = 0; i < this.markers.length; i++) {
      data.push({
        x: (this.markers[i].left - left) / w,
        y: (this.markers[i].top - top) / h,
        z: 0
      });
    }

    return data;
  };

  this.addMarker = function () {
    this.mouseStatus = 'marking';
    this.setCursor('marker', true, true);
  };

  this.removeMarker = function () {
    this.mouseStatus = 'removing';
    this.setCursor('eraser', true, true);
  };

  this.removeAllMarkers = function () {
    if (this.markers.length === 0) return;

    for (var i = 0; i < this.markers.length; i++) {
      var marker = self.markers[i];
      self.canvas.remove(marker);
    }

    self.markers = [];
    render();
  };

  this.placeMarker = function (pos) {
    var w = this.planImage.width * this.planImage.scaleX;
    var h = this.planImage.height * this.planImage.scaleY;
    var left = this.planImage.left - w / 2.0;
    var top = this.planImage.top - h / 2.0;
    var x = pos.x * w + left;
    var y = pos.y * h + top;

    if (x >= left && x <= left + w && y >= top && y <= top + h) {
      addMarkingIcon({
        x: x,
        y: y
      });
    }
  };

  this.setSize = function (width, height) {
    var w = width || self.container.offsetWidth;
    var h = height || self.container.offsetHeight;
    this.canvas.setDimensions({
      width: w,
      height: h
    });
    this.canvas.viewportTransform[4] = 0;
    this.canvas.viewportTransform[5] = 0;

    if (this.planImage !== undefined) {
      var _w = this.canvas.getWidth();

      var _h = this.canvas.getHeight();

      this.planImage.set({
        id: 'image',
        left: _w / 2,
        top: _h / 2,
        originX: 'center',
        originY: 'center',
        hasControls: false,
        hasBorders: false,
        selectable: false
      });

      if (_w < _h) {
        this.planImage.scaleToWidth(_w - 20);
      } else {
        this.planImage.scaleToHeight(_h - 20);
      }

      render();
    }
  };

  this.setCursor = function (cursor, isUrl, isUp) {
    if (isUrl) {
      var cursorStyle;

      if (isUp) {
        if (cursor === "marker") {
          cursorStyle = "url('/assets/images/cgviewer/cursor/" + cursor + ".png') 12 12, auto";
        } else {
          cursorStyle = "url('/assets/images/cgviewer/cursor/" + cursor + ".png'), auto";
        }
      } else {
        cursorStyle = "url('/assets/images/cgviewer/cursor/" + cursor + ".png') 0 25, auto";
      }

      this.container.style.cursor = cursorStyle;
      this.canvas.defaultCursor = cursorStyle;
      this.canvas.hoverCursor = cursorStyle;
      this.canvas.freeDrawingCursor = cursorStyle;
    } else {
      this.container.style.cursor = cursor;
      this.canvas.defaultCursor = cursor;
      this.canvas.hoverCursor = cursor;
      this.canvas.freeDrawingCursor = cursor;
    }
  };

  this.on = function (type, callback) {
    if (this.signaler[type]) {
      this.signaler[type].add(callback);
    } else {
      console.error('there is no event type: ', type);
    }
  };

  this.takeImage = function () {
    return this.canvas.toDataURL({
      format: 'jpeg',
      quality: 1.0
    });
  };

  function resizeEvent() {
    if (self.container.offsetWidth === 0 || self.container.offsetHeight === 0) return;
    self.setSize();
  }

  function addIcon(url, pos) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      fabric.Image.fromURL(url, function (shape) {
        shape.set({
          left: pos.x,
          top: pos.y,
          originX: 'center',
          originY: 'center',
          hasControls: false,
          hasBorders: false,
          selectable: false,
          draggable: true,
          fill: ''
        });
        var scaleW = 60 * self.planImage.scaleX;
        shape.scaleToWidth(scaleW);
        shape.scaleToHeight(scaleW);
        self.canvas.add(shape);
        resolve(shape);
      }.bind(_this3), {
        crossOrigin: 'anonymous'
      });
    });
  }

  function addMarkingIcon(pos) {
    addIcon(markerIcon, pos).then(function (icon) {
      self.markers.push(icon);
      render();
    });
  }

  function removeMarkingIcon(pos) {
    for (var i = 0; i < self.markers.length; i++) {
      var marker = self.markers[i];

      if (Math.abs(marker.left - pos.x) <= marker.width / 2 && Math.abs(marker.top - pos.y) <= marker.height / 2) {
        self.canvas.remove(marker);
        self.markers.splice(i, 1);
        render();
        return true;
      }
    }

    return false;
  }

  function render() {
    self.canvas.renderAll();
  }

  function onMouseDown(e) {
    var ev = e.e;

    if (self.mouseStatus === 'marking') {
      var pointer = self.canvas.getPointer(ev);
      addMarkingIcon(pointer);
      self.setCursor('default');
      self.mouseStatus = undefined;
      self.signaler.markerPlaced.dispatch(false, getUV(pointer));
      return;
    } else if (self.mouseStatus === 'removing') {
      var _pointer = self.canvas.getPointer(ev);

      if (removeMarkingIcon(_pointer)) {
        self.setCursor('default');
        self.mouseStatus = undefined;
        self.signaler.markerRemoved.dispatch(false);
        return;
      }
    }

    isDragging = true;
    self.canvas.selection = false;
    lastPosX = ev.clientX;
    lastPosY = ev.clientY;
  }

  function onMouseMove(e) {
    if (isDragging) {
      var ev = e.e;
      self.canvas.viewportTransform[4] += ev.clientX - lastPosX;
      self.canvas.viewportTransform[5] += ev.clientY - lastPosY;
      self.canvas.requestRenderAll();
      lastPosX = ev.clientX;
      lastPosY = ev.clientY;
    }
  }

  function onMouseUp() {
    isDragging = false;
  }

  function onMouseWheel(e) {
    var delta = e.e.deltaY;
    var canvas = self.canvas;
    var pointer = canvas.getPointer(e.e);
    var zoom = canvas.getZoom();
    zoom = zoom - delta / 200;
    changeZoom({
      x: pointer.x,
      y: pointer.y
    }, zoom);
    canvas.requestRenderAll();
    e.e.preventDefault();
    e.e.stopPropagation();
  }

  function changeZoom(pointer, zoom) {
    var canvas = self.canvas;
    var oldZoom = canvas.getZoom();
    zoom = clamp(zoom, zoomRange.min, zoomRange.max);
    if (oldZoom === zoom) return;
    canvas.zoomToPoint(new fabric.Point(pointer.x, pointer.y), zoom);
    keepPositionInBounds();

    if (zoom !== 0) {
      for (var i = 0; i < self.markers.length; i++) {
        self.markers[i].scaleX = 1 / zoom;
        self.markers[i].scaleY = 1 / zoom;
      }
    }

    render();
  }

  function keepPositionInBounds() {
    var canvas = self.canvas;
    var width = canvas.getWidth();
    var height = canvas.getHeight();
    var zoom = canvas.getZoom();
    if (zoom < 1) zoom = 1;
    var xMin = width - zoom * width / 2;
    var xMax = zoom * width / 2;
    var yMin = height - zoom * height / 2;
    var yMax = zoom * height / 2;
    var point = new fabric.Point(canvas.getWidth() / 2, canvas.getHeight() / 2);
    var center = fabric.util.transformPoint(point, canvas.viewportTransform);
    var clampedCenterX = clamp(center.x, xMin, xMax);
    var clampedCenterY = clamp(center.y, yMin, yMax);
    var diffX = clampedCenterX - center.x;
    var diffY = clampedCenterY - center.y;

    if (diffX !== 0 || diffY !== 0) {
      canvas.relativePan(new fabric.Point(diffX, diffY));
    }
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
  }

  function getUV(pos) {
    var w = self.planImage.width * self.planImage.scaleX;
    var h = self.planImage.height * self.planImage.scaleY;
    var left = self.planImage.left - w / 2.0;
    var top = self.planImage.top - h / 2.0;
    return {
      x: (pos.x - left) / w,
      y: (pos.y - top) / h
    };
  }
}


"use strict";

function BimSimpleViewer(container, quality) {
  'use strict';

  if (!Detector.webgl) Detector.addGetWebGLMessage();
  var self = this; // signal manager

  this.signaler = new BimSignaler(); // viewer

  this.viewer = new BimViewer(container, this.signaler);

  if (quality) {
    this.viewer.quality = quality;
  }

  this.viewer.create({
    background: 'none'
  });
  this.bimModel = undefined;
  this.bimObjects = [];
  this.colorMode = 'normal';

  var resizeEvent = function resizeEvent() {
    self.setSize(container.clientWidth, container.clientHeight);
  };

  this.initialize = function () {
    this.setSize(container.clientWidth, container.clientHeight);
    window.addEventListener('resize', resizeEvent, false);
    this.signaler.start();
  };

  this.destroy = function () {
    this.bimModel = undefined;
    this.bimObjects = undefined;
    window.removeEventListener('resize', resizeEvent, false);
    this.signaler.clear();
    this.signaler.stop();
    this.viewer.destroy();
  };

  this.on = function (type, callback) {
    if (this.signaler[type]) {
      this.signaler[type].add(callback);
    } else {
      console.error('there is no event type: ', type);
    }
  };

  this.setVisible = function (visible) {
    this.viewer.setVisible(visible);
  };

  this.loadBim = function (model) {
    return new Promise(function (resolve, reject) {
      var bimLoader = new BimLoader();
      bimLoader.load(model, quality).then(function (bimModel) {
        self.addBimModel(bimModel, false);
        resolve();
      })["catch"](function (err) {
        console.error(err);
        reject(err);
      });
    });
  };

  this.getBimModel = function () {
    return this.bimModel;
  };
  /**
   * add bim model to viewer
   * @param bimModel {BimModel}
   * @param clone {Boolean}
   */


  this.addBimModel = function (bimModel, clone) {
    this.bimModel = bimModel;
    var mesh = clone ? bimModel.cloneMesh() : bimModel.mesh;
    this.viewer.addObject(mesh);
    this.viewer.fitScreen(false);
    this.viewer.setDirty(true);
  };
  /**
   * add bim object to viewer
   * @param bimObject {BimObject}
   */


  this.addBimObject = function (bimObject, toWorld) {
    if (bimObject.mesh === undefined) return;
    var mesh = bimObject.cloneMesh();

    if (toWorld) {
      mesh.applyMatrix4(bimObject.mesh.matrixWorld);
    }

    this.viewer.addObject(mesh);
    this.viewer.fitScreen(true);
    this.viewer.setDirty(true);
  };
  /**
   * add three.js object to viewer
   * @param object {THREE.Object3D}
   */


  this.addObject = function (object) {
    this.viewer.addObject(object);
  };

  this.addBimItem = function (item, quality) {
    addTreeItem(item, quality);
    this.viewer.fitScreen(true);
    this.viewer.setDirty(true);
  };

  this.removeBimItem = function (item) {
    removeTreeItem(item);
    this.viewer.fitScreen(true);
    this.viewer.setDirty(true);
  };
  /**
   * select object by ID
   * @param objectId {String}
   */


  this.selectObject = function (objectId) {
    if (!this.bimModel) return;
    this.bimModel.clearSelection();
    this.bimModel.setItemSelectedById(objectId);
    this.viewer.setDirty(true);
  };
  /**
   * show all objects
   */


  this.showAllObject = function () {
    if (!this.bimModel) return;
    this.bimModel.setAllItemVisible(true);
    this.viewer.fitScreen(true);
    this.viewer.setDirty(true);
  };
  /**
   * show only object by GUID
   * @param guid {String}
   */


  this.showObject = function (guid) {
    if (!this.bimModel) return;
    var item = this.bimModel.getItemByGuid(guid);

    if (item !== undefined) {
      this.bimModel.setItemVisibleOnly(item);
      this.viewer.fitScreen(true);
      this.viewer.setDirty(true);
    }
  };

  this.clear = function () {
    this.bimModel = undefined;
    this.viewer.clear();
  };

  this.fitScreen = function () {
    this.viewer.fitScreen(true);
  };

  this.setSize = function (width, height) {
    this.viewer.setSize(width, height);
  };

  this.setDragAction = function (mode) {
    this.viewer.setDragAction(mode);
  };

  this.setCursor = function (cursor, isUrl, isUp) {
    this.viewer.setCursor(cursor, isUrl, isUp);
  };

  this.setCameraMode = function (mode) {
    this.viewer.setCameraMode(mode);
  };

  this.invalidate = function () {
    this.viewer.setDirty(true);
  };

  this.setColorMode = function (colorMode) {
    if (this.colorMode === colorMode) return;
    this.colorMode = colorMode;

    if (this.bimModel) {
      this.bimModel.setColorMode(colorMode);
    } else if (this.bimObjects.length > 0) {
      this.bimObjects.forEach(function (bimObject) {
        return bimObject.setColorMode(colorMode);
      });
    }

    this.viewer.setDirty(true);
  };

  this.getImage = function () {
    return this.viewer.getImage();
  };

  this.getColoredInventories = function () {
    var bimObjects = this.bimObjects.length > 0 ? this.bimObjects : this.bimModel ? this.bimModel.getBimObjects() : [];
    var colorList = [];
    bimObjects.forEach(function (bimObject) {
      var color = bimObject.getMaterialColor();

      if (color) {
        if (colorList.findIndex(function (x) {
          return x._id === color._id;
        }) === -1) {
          colorList.push(color);
        }
      }
    });
    return colorList.length ? colorList : undefined;
  };

  function addTreeItem(item, quality) {
    if (item.children) {
      item.children.forEach(function (child) {
        if (child.object) {
          var bimObject = child.object.clone(quality);
          bimObject.ptr = item;

          if (self.colorMode !== 'normal') {
            bimObject.setColorMode(self.colorMode);
          }

          self.bimObjects.push(bimObject);
          self.addObject(bimObject.mesh);
        }

        addTreeItem(child, quality);
      });
    }
  }

  function removeTreeItem(item) {
    for (var i = self.bimObjects.length - 1; i >= 0; i--) {
      if (self.bimObjects[i].ptr === item) {
        self.bimObjects[i].ptr = undefined;
        self.viewer.removeObject(self.bimObjects[i].mesh);
        self.bimObjects.splice(i, 1);
      }
    }
  }
}


"use strict";

function BimVPViewer(container) {
  'use strict';

  if (!Detector.webgl) Detector.addGetWebGLMessage();
  var self = this; // data management

  this.data = new BimData(); // signal manager

  this.signaler = new BimSignaler(this); // viewer

  this.viewer = new BimViewer(container, this.signaler).create({
    grid: true,
    axes: true,
    cube: true,
    overlay: true,
    factor: 1.5
  }); // object picking

  this.objectPicker = new BimObjectPicker(this.viewer, this.data); // drawing command

  this.curCmd = undefined;
  this.planTransformer = undefined; //drawing

  this.currentUnit = 'm';
  this.fillColor = 'red';
  this.currentTexture = undefined;
  this.drawer2d = new BimDrawer2d(this.viewer);
  this.overlay = {
    scene: new THREE.Scene(),
    render: function render(renderer, camera) {
      this.scene.updateMatrixWorld();
      renderer.render(this.scene, camera);
    }
  }; //clipping

  this.clippingManager = new BimClippingManager();
  this.planSection = new CrossSection(this.viewer, this.clippingManager);
  this.clippingManager.add(this.planSection);
  this.planControl3d = new BimPlan3d(this.viewer, this.planSection, this.objectPicker);
  this.viewer.addOverlay(this.overlay);
  this.viewer.addOverlay(this.planControl3d); // register signals

  this.signaler.cameraControlChanged.add(function () {
    if (self.curCmd && self.curCmd.cameraControlChanged) self.curCmd.cameraControlChanged();
  });
  this.signaler.releaseCmd.add(function () {
    self.activateCmd(undefined);
    self.viewer.setDragAction('picker');
  });
  this.signaler.planTransformReady.add(function (plan) {
    if (self.planTransformer !== plan.transformer) {
      if (self.planTransformer !== undefined) {
        self.planTransformer.detach();
      }

      self.planTransformer = plan.transformer;
      self.planTransformer.attach();
    }
  });
  this.signaler.objectSelected.add(function () {
    if (self.planTransformer !== undefined) {
      self.planTransformer.detach();
      self.planTransformer = undefined;
    }
  });
  this.signaler.objectDblClicked.add(function () {
    if (self.planTransformer !== undefined) {
      self.planTransformer.detach();
      self.planTransformer = undefined;
    }
  });

  var resizeEvent = function resizeEvent() {
    self.setSize(container.clientWidth, container.clientHeight);
  };

  this.create = function () {
    this.setSize(container.clientWidth, container.clientHeight);
    window.addEventListener('resize', resizeEvent, false);
    this.signaler.start();
  };

  this.destroy = function () {
    window.removeEventListener('resize', resizeEvent, false);
    this.viewer.destroy();
    this.signaler.stop();
  };

  this.on = function (type, callback) {
    if (this.signaler[type] !== undefined) {
      this.signaler[type].add(callback);
    } else {
      console.warn('there is no event type: ', type);
    }
  };

  this.loadBim = function (model) {
    return new Promise(function (resolve, reject) {
      var bimLoader = new BimLoader();
      bimLoader.load(model).then(function (bimModel) {
        self.data.addModel(bimModel);
        self.viewer.addBimModel(bimModel);

        if (self.data.isModelFull()) {
          self.viewer.fitScreen(false);
        } else {
          self.viewer.fitInBimModel(bimModel, false);
        }

        resolve(bimModel);
      })["catch"](function (err) {
        console.error(err);
        reject(err);
      });
    });
  };

  this.getBimData = function () {
    return this.data;
  };

  this.activateCmd = function (drawer) {
    if (this.curCmd) {
      this.curCmd.setActive(false);
    }

    this.curCmd = drawer;

    if (drawer) {
      this.objectPicker.stop();
      drawer.drawer2d = this.drawer2d;
      drawer.setActive(true);
      drawer.drawer2d.clear();
    } else {
      this.objectPicker.start();
    }

    return drawer;
  };

  this.setSize = function (width, height) {
    this.viewer.setSize(width, height);
    this.drawer2d.reset();
  };

  this.newVPPlan = function (canvas) {
    this.activateCmd(new BimPlanMatchCmd(this.viewer, this.overlay.scene, canvas, addVPPlan));
  };

  this.matchVPPlan = function (canvas, params) {
    var vpPlan = new BimPlan(this.viewer, this.planSection, this.planControl3d);
    vpPlan.setNormal(new THREE.Vector3(params.normal.x, params.normal.y, params.normal.z));
    vpPlan.size = params.size;
    var planMaterial = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.6
    });
    var mesh = new THREE.Mesh(new THREE.PlaneGeometry(vpPlan.size.width, vpPlan.size.height), planMaterial);
    mesh.geometry.computeBoundingBox();
    mesh.name = 'plan';
    mesh.userData.type = 'plan';
    mesh.userData.unSnapable = true;
    mesh.userData.unClippable = true;
    mesh.matrix.identity();
    var matrix = new THREE.Matrix4();
    matrix.elements = params.matrix;
    mesh.applyMatrix4(matrix);
    var texture = new THREE.CanvasTexture(canvas);
    texture.flipY = false;
    planMaterial.map = texture;
    new THREE.TextureLoader().load('assets/images/cgviewer/marker-2d.png', function (markerTexture) {
      markerTexture.minFilter = THREE.LinearFilter;
      markerTexture.needsUpdate = true;
      var marker = new THREE.Sprite(new THREE.SpriteMaterial({
        map: markerTexture,
        depthTest: false,
        depthWrite: false
      }));
      marker.matrix.identity();
      marker.userData.type = 'plan-marker';
      marker.userData.unSnapable = true;
      marker.userData.unClippable = true;
      marker.userData.fixedSize = true;
      marker.renderOrder = 1000;
      marker.applyMatrix4(matrix);
      marker.visible = false;
      self.viewer.addObject(mesh);
      self.viewer.addObject(marker);
      vpPlan.mesh = mesh;
      vpPlan.marker = marker;
      self.data.addPlan(vpPlan);
      vpPlan.setup();
      vpPlan.setCompleted();
    }, undefined, function (err) {
      console.error(err);
    });
  };
  /**
   * complete vp plan
   * @param vpPlan {BimPlan}
   */


  this.completeVPPlan = function (vpPlan) {
    this.planTransformer = undefined;
    vpPlan.setCompleted();
  };
  /**
   * remove vp plan
   * @param vpPlan {BimPlan}
   */


  this.removeVPPlan = function (vpPlan) {
    this.planTransformer = undefined;
    vpPlan.destroy();
    this.data.removePlan(vpPlan);
    this.signaler.planRemoved.dispatch(vpPlan);
  };

  this.refreshVPPlan = function () {
    var vpPlan = this.data.firstPlan();

    if (vpPlan && vpPlan.mesh && vpPlan.mesh.material && vpPlan.mesh.material.map) {
      vpPlan.mesh.material.map.needsUpdate = true;
      this.invalidate();
    }
  };

  this.invalidate = function () {
    this.viewer.setDirty(true);
  };

  this.setCursor = function (cursor, isUrl, isUp) {
    this.viewer.setCursor(cursor, isUrl, isUp);
  };

  function addVPPlan(canvas, params) {
    var vpPlan = new BimPlan(self.viewer, self.planSection, self.planControl3d);
    vpPlan.setNormal(params.normal);
    var maxSize = params.rw * 3.5;

    if (canvas.width > canvas.height) {
      vpPlan.size = {
        width: maxSize * canvas.width / canvas.height,
        height: maxSize
      };
    } else {
      vpPlan.size = {
        width: maxSize,
        height: maxSize * canvas.height / canvas.width
      };
    }

    var texture = new THREE.CanvasTexture(canvas);
    texture.flipY = false;
    var mesh = new THREE.Mesh(new THREE.PlaneGeometry(vpPlan.size.width, vpPlan.size.height), new THREE.MeshBasicMaterial({
      map: texture,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.6
    }));
    mesh.name = 'plan';
    mesh.matrix.identity();
    var kind = vpPlan.kindOf();

    switch (kind.axis) {
      case 'yz':
        params.matrix.elements[12] += kind.dir ? 0.05 : -0.05;
        break;

      case 'xz':
        params.matrix.elements[13] += kind.dir ? 0.05 : -0.05;
        break;

      default:
        params.matrix.elements[14] += kind.dir ? 0.05 : -0.05;
        break;
    }

    mesh.applyMatrix4(params.matrix);
    mesh.geometry.computeBoundingBox();
    mesh.userData.type = 'plan';
    mesh.userData.unSnapable = true;
    mesh.userData.unClippable = true;
    self.viewer.addObject(mesh);
    vpPlan.mesh = mesh;
    new THREE.TextureLoader().load('assets/images/cgviewer/marker-2d.png', function (markerTexture) {
      var marker = new THREE.Sprite(new THREE.SpriteMaterial({
        map: markerTexture,
        depthTest: false,
        depthWrite: false
      }));
      marker.matrix.identity();
      marker.userData.type = 'plan-marker';
      marker.userData.unSnapable = true;
      marker.userData.unClippable = true;
      marker.userData.fixedSize = true;
      marker.renderOrder = 1000;
      marker.applyMatrix4(params.matrix);
      marker.visible = false;
      self.viewer.addObject(marker);
      vpPlan.marker = marker;
      vpPlan.transformer = new BimPlanTransformer(self.viewer, vpPlan, self.drawer2d);
      vpPlan.setup();
      self.data.addPlan(vpPlan);
      self.viewer.signaler.planAdded.dispatch(vpPlan);
      self.viewer.signaler.planTransformReady.dispatch(vpPlan, {
        x: params.x,
        y: params.y
      });
    }, undefined, function (err) {
      console.error(err);
    });
  }
}


"use strict";

function ExtSocket() {
  var socket = io("http://localhost:1337", {
    transports: ["websocket"],
    upgrade: false
  });

  this.sendData = function (data) {
    console.log("socket sendData");
    socket.emit('send_data', data);
  };

  this.on = function (callback) {
    socket.on("send_data", callback);
  };

  socket.on("connect", function () {
    console.log("socket is connected.", socket.id);
  });
  socket.on("disconnect", function (reason) {
    console.log("socket is disconnected.", reason);
  });
  socket.on("connect_error", function (error) {
    console.log("connection has error", error);
  });
  console.log("socket is created");
}


"use strict";

var ExtUtils = {
  isZero: function isZero(value) {
    return Math.abs(value) < 1e-10;
  },
  roundNumber: function roundNumber(number, fractiondigits) {
    return Math.round(number * Math.pow(10, fractiondigits)) / Math.pow(10, fractiondigits);
  },
  bsonId: function bsonId() {
    var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
      return (Math.random() * 16 | 0).toString(16);
    }).toLowerCase();
  },
  uuid4: function uuid4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  },
  comma2decimal: function comma2decimal(number, place) {
    if (number) {
      var data = Number(number).toFixed(place);
      var ret = data ? data.replace(".", ",") : 0;
      var NO = ret.split(",");
      var result = NO[0];
      var change = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
      ret = change + "," + NO[1];
      return ret;
    }

    return '';
  },
  ha2rgba: function ha2rgba(hex, alpha) {
    if (hex === undefined || alpha === undefined) return;
    var h = hex;
    var a = alpha;
    var r = 0,
        g = 0,
        b = 0;

    if (!h.startsWith('#')) {
      h = '#' + h;
    }

    if (h.length === 4) {
      // 3 digits
      r = "0x" + h[1] + h[1];
      g = "0x" + h[2] + h[2];
      b = "0x" + h[3] + h[3];
    } else if (h.length === 7) {
      // 6 digits
      r = "0x" + h[1] + h[2];
      g = "0x" + h[3] + h[4];
      b = "0x" + h[5] + h[6];
    } else if (h.length === 9) {
      // 8 digits
      r = "0x" + h[1] + h[2];
      g = "0x" + h[3] + h[4];
      b = "0x" + h[5] + h[6];
    }

    return "rgba(" + +r + "," + +g + "," + +b + "," + a + ")";
  },
  h2rgb: function h2rgb(hex) {
    if (hex === undefined) return;
    var h = hex;
    var r = 0,
        g = 0,
        b = 0;

    if (!h.startsWith('#')) {
      h = '#' + h;
    }

    if (h.length === 4) {
      // 3 digits
      r = "0x" + h[1] + h[1];
      g = "0x" + h[2] + h[2];
      b = "0x" + h[3] + h[3];
    } else if (h.length === 7) {
      // 6 digits
      r = "0x" + h[1] + h[2];
      g = "0x" + h[3] + h[4];
      b = "0x" + h[5] + h[6];
    } else if (h.length === 9) {
      // 8 digits
      r = "0x" + h[1] + h[2];
      g = "0x" + h[3] + h[4];
      b = "0x" + h[5] + h[6];
    }

    return "rgb(" + +r + "," + +g + "," + +b + ")";
  },
  rgba2color: function rgba2color(rgba) {
    var sep = rgba.indexOf(",") > -1 ? "," : " ";
    if (rgba.startsWith('rgba(')) rgba = rgba.substr(5);else rgba = rgba.substr(4);
    rgba = rgba.split(")")[0].split(sep);
    var r = +rgba[0],
        g = +rgba[1],
        b = +rgba[2],
        a = rgba[3];
    return {
      r: r,
      g: g,
      b: b,
      a: a
    };
  },
  num: function num(n) {
    if (n === undefined || n === null || !isFinite(n)) return 0;
    return Number(n);
  },
  getSizeToFit: function getSizeToFit(currentWidth, currentHeight, desiredWidth, desiredHeight) {
    var currentRatio = currentWidth / currentHeight;
    var targetRatio = desiredWidth / desiredHeight;
    var w = desiredWidth;
    var h = desiredHeight;
    var x = 0;
    var y = 0;

    if (currentRatio > targetRatio) {
      h = desiredWidth / currentRatio;
      y = (desiredHeight - h) / 2;
    } else if (currentRatio < targetRatio) {
      w = desiredHeight * currentRatio;
      x = (desiredWidth - w) / 2;
    }

    return {
      left: x,
      top: y,
      width: w,
      height: h
    };
  }
};


"use strict";

function GisViewer() {
  'use strict';

  var self = this;
  mapboxgl.accessToken = 'pk.eyJ1IjoiYnVudGVuZ3dhbmciLCJhIjoiY2trcG1rbTVlMDFpaDJvazU2cjVnMDJ1NCJ9.e1PPa2H_UxOU2nO-v18A8A';
  init();

  function init() {
    self.viewer = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/outdoors-v11',
      zoom: 19,
      maxZoom: 19,
      center: [-87.62712, 41.89033],
      pitch: 30,
      maxPitch: 60,
      antialias: true // create the gl context with MSAA antialiasing, so custom layers are antialiased

    });
  }

  this.setSattleteMap = function () {
    self.viewer.setStyle('mapbox://styles/mapbox-map-design/ckhqrf2tz0dt119ny6azh975y');
  };

  this.setStreetMap = function () {
    self.viewer.setStyle('mapbox://styles/mapbox/outdoors-v11');
  };

  this.setExtrusionMap = function () {
    self.viewer.setStyle('mapbox://styles/mapbox/light-v10');
  };

  this.getViewerInstance = function () {
    return self.viewer;
  };
}


"use strict";

function EarthViewer(containerId) {
  var self = this;
  this.markers = [];
  var pinBuilder = new Cesium.PinBuilder();
  var cartographic = new Cesium.Cartographic();
  var cartesian = new Cesium.Cartesian3();
  init();

  this.addMarker = function (marker) {
    this.markers.push(marker);
    var color = Cesium.Color.fromCssColorString(marker.color);
    var viewer = this.viewer;
    var height = marker.zoom === 'small' ? 50000.0 : 100.0;
    var entity = {
      name: marker.name,
      position: Cesium.Cartesian3.fromDegrees(marker.longitude, marker.latitude, height),
      billboard: {
        image: pinBuilder.fromUrl(marker.icon, color, 80),
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM
      },
      point: {
        pixelSize: 10,
        color: color,
        outlineWidth: 2,
        outlineColor: Cesium.Color.WHITE
      }
    };

    if (marker.zoom === 'large') {
      entity.billboard.distanceDisplayCondition = new Cesium.DistanceDisplayCondition(0.0, 100000.0);
      entity.point.distanceDisplayCondition = new Cesium.DistanceDisplayCondition(0.0, 100000.0);
    } else if (marker.zoom === 'small') {
      entity.billboard.distanceDisplayCondition = new Cesium.DistanceDisplayCondition(100000.1, Number.MAX_VALUE);
      entity.point.distanceDisplayCondition = new Cesium.DistanceDisplayCondition(100000.1, Number.MAX_VALUE);
    }

    viewer.entities.add(entity);
  };

  function init() {
    Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJkY2YzOWE0Ny02MWIxLTQ2MjUtODA0Ni1hYmIzYjYzMzE3OGQiLCJpZCI6Mzc0MDYsImlhdCI6MTYwNTAxNjg5NH0.wXWSF9NYAVRMgynDEI8tbmP0wliXMr8EPWCUVOJ4dMo';
    var viewer = new Cesium.Viewer(containerId, {
      selectionIndicator: false,
      terrainProvider: Cesium.createWorldTerrain({
        requestVertexNormals: true,
        requestWaterMask: true
      }),
      // imageryProvider :  new Cesium.ArcGisMapServerImageryProvider({
      //   url : 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer'
      // }),
      animation: false,
      timeline: false,
      baseLayerPicker: false,
      fullscreenButton: false,
      navigationHelpButton: false,
      sceneModePicker: false,
      infoBox: false
    });
    self.viewer = viewer;
    viewer.resolutionScale = window.devicePixelRatio;
    viewer.scene.globe.maximumScreenSpaceError = 1.5;
    viewer.scene.postProcessStages.fxaa.enabled = false; // viewer.scene.globe.enableLighting = true;

    viewer.scene.fog.enabled = false; // document.querySelector("#" + containerId + "> div > div.cesium-viewer-toolbar > span.cesium-sceneModePicker-wrapper.cesium-toolbar-button > button:nth-child(4)").style.display = 'none';

    var toolbar = document.querySelector("#" + containerId + "> div > div.cesium-viewer-toolbar");
    var geoCoderControl = document.querySelector("div.cesium-viewer-geocoderContainer");
    var homeButton = document.querySelector("button.cesium-home-button");
    var searchButton = document.querySelector("span.cesium-geocoder-searchButton");
    var zoomIn = document.createElement("button");
    var zoomOut = document.createElement("button");
    toolbar.removeChild(homeButton);
    toolbar.insertBefore(homeButton, geoCoderControl);
    zoomIn.classList.add("cesium-button", "cesium-toolbar-button", "cesium-zoom-in");
    zoomOut.classList.add("cesium-button", "cesium-toolbar-button", "cesium-zoom-out");
    homeButton.innerHTML = '<img src="/assets/icons/home-black.svg" alt="">';
    searchButton.innerHTML = '<img src="/assets/icons/search-black.svg" alt="">';
    zoomIn.innerHTML = '<img src="/assets/icons/plus-black.svg" alt="+">';
    zoomOut.innerHTML = '<img src="/assets/icons/minus-black.svg" alt="-">';
    toolbar.append(zoomIn);
    toolbar.append(zoomOut);
    viewer.selectedEntityChanged.addEventListener(function (entity) {
      self.viewer.flyTo(entity);
    });
    zoomIn.addEventListener("click", function () {
      zoom(false);
    }, false);
    zoomOut.addEventListener("click", function () {
      zoom(true);
    }, false);
  }

  function zoom(out) {
    var camera = self.viewer.scene.camera;
    var ellipsoid = self.viewer.scene.mapProjection.ellipsoid;
    ellipsoid.cartesianToCartographic(camera.position, cartographic);
    cartographic.height *= out ? 1.2 : 0.8;
    ellipsoid.cartographicToCartesian(cartographic, cartesian);
    camera.position = cartesian;
  }
}


"use strict";

function GMapDrawingViewer(mapElement, gmapConfig, data) {
  'use strict';

  var self = this;
  this.gmapConfig = gmapConfig || {
    zoom: 18,
    center: new google.maps.LatLng(55.6760968, 12.5683371),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    zoomControl: true
  };
  this.data = data;
  var map;
  var placeMarkers = [];
  var searchInput;
  var searchBox;
  var drawingManager;
  var selectedShape;
  var projectBounds;
  var marker;
  var areaShape;

  function clearSelection() {
    if (selectedShape) {
      if (typeof selectedShape.setEditable == 'function') {
        selectedShape.setEditable(false);
      }

      selectedShape = null;
    }
  }

  function clearShape(shape) {
    if (shape) {
      shape.setMap(null);
    }

    shape = null;
  }

  function setSelection(shape, isNotMarker) {
    clearSelection();
    selectedShape = shape;

    if (isNotMarker) {
      shape.setEditable(true);
    }
  }

  function createShape(shape, isNotMarker) {
    // if (!checkValidShape(shape)) {
    //   shape.setMap(null);
    //   return;
    // }
    if (isNotMarker) {
      clearShape(areaShape);
      areaShape = shape;
    } else {
      clearShape(marker);
      marker = shape;
    }

    setSelection(shape, isNotMarker);
  }

  function deleteSelectedShape() {
    if (selectedShape) {
      selectedShape.setMap(null);

      if (selectedShape.type === google.maps.drawing.OverlayType.MARKER) {
        marker = null;
      }
    }
  }

  function drawProjectViewport() {
    var viewport = self.data.geometry.viewport;
    projectBounds = {
      north: viewport.northeast.lat,
      south: viewport.southwest.lat,
      east: viewport.northeast.lng,
      west: viewport.southwest.lng
    };
    var projectRect = new google.maps.Rectangle({
      strokeColor: "#1E90FF",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#1E90FF",
      fillOpacity: 0.35,
      map: map,
      bounds: projectBounds
    });
    projectRect.setEditable(false);
  }

  function isValidPoint(lat, lng) {
    return !(lat > projectBounds.north || lat < projectBounds.south || lng > projectBounds.east || lng < projectBounds.west);
  }

  function checkValidShape(shape) {
    console.log('shape', shape);

    switch (shape.type) {
      case google.maps.drawing.OverlayType.MARKER:
        return isValidPoint(shape.position.lat(), shape.position.lng());

      case google.maps.drawing.OverlayType.RECTANGLE:
        var bounds = shape.bounds;
        return isValidPoint(bounds.Wa.i, bounds.Sa.i) && isValidPoint(bounds.Wa.j, bounds.Sa.j);

      case google.maps.drawing.OverlayType.POLYGON:
      case google.maps.drawing.OverlayType.POLYLINE:
        var mvcArray = shape.getPath();
        var latLngArray = mvcArray.getArray();
        var _isValid = true;

        for (var i = 0; i < latLngArray.length; i++) {
          var latLng = latLngArray[i];
          _isValid = isValidPoint(latLng.lat(), latLng.lng());

          if (!_isValid) {
            break;
          }
        }

        return _isValid;

      case google.maps.drawing.OverlayType.CIRCLE:
        return isValidPoint(shape.center.lat(), shape.center.lng());
    }

    return false;
  }

  function getShapeData() {
    if (!areaShape) {
      return null;
    }

    switch (areaShape.type) {
      case google.maps.drawing.OverlayType.RECTANGLE:
        var bounds = areaShape.bounds;
        return {
          type: areaShape.type,
          bounds: {
            north: bounds.Wa.j,
            south: bounds.Wa.i,
            east: bounds.Sa.j,
            west: bounds.Sa.i
          }
        };

      case google.maps.drawing.OverlayType.POLYGON:
      case google.maps.drawing.OverlayType.POLYLINE:
        var mvcArray = areaShape.getPath();
        var latLngArray = mvcArray.getArray();
        var coordinates = [];

        for (var i = 0; i < latLngArray.length; i++) {
          var latLng = latLngArray[i];
          isValid = isValidPoint(latLng.lat(), latLng.lng());
          coordinates.push({
            lat: latLng.lat(),
            lng: latLng.lng()
          });
        }

        return {
          type: areaShape.type,
          coordinates: coordinates
        };

      case google.maps.drawing.OverlayType.CIRCLE:
        return {
          type: areaShape.type,
          center: {
            lat: areaShape.center.lat(),
            lng: areaShape.center.lng()
          },
          radius: areaShape.radius
        };

      default:
        return null;
    }
  }

  function initMap() {
    map = new google.maps.Map(mapElement, self.gmapConfig);
    var polyOptions = {
      strokeWeight: 0,
      fillOpacity: 0.45,
      editable: true,
      fillColor: '#FF1493'
    };
    drawingManager = new google.maps.drawing.DrawingManager({
      drawingMode: google.maps.drawing.OverlayType.POLYGON,
      markerOptions: {
        draggable: true,
        editable: true
      },
      polylineOptions: {
        editable: true,
        strokeWeight: 2,
        strokeColor: '#FF1493'
      },
      rectangleOptions: polyOptions,
      circleOptions: polyOptions,
      polygonOptions: polyOptions,
      map: map
    });
    google.maps.event.addListener(drawingManager, 'overlaycomplete', function (e) {
      var isNotMarker = e.type !== google.maps.drawing.OverlayType.MARKER;
      drawingManager.setDrawingMode(null);
      var newShape = e.overlay;
      newShape.type = e.type;
      google.maps.event.addListener(newShape, 'click', function () {
        setSelection(newShape, isNotMarker);
      });
      createShape(newShape, isNotMarker);
    });
    google.maps.event.addListener(drawingManager, 'drawingmode_changed', clearSelection);
    google.maps.event.addListener(map, 'click', clearSelection);
  }

  function initDeleteShapeButton() {
    var deleteShapeButtonDiv = document.createElement('div');
    deleteShapeButtonDiv.id = 'delete-shape';
    deleteShapeButtonDiv.style.position = 'absolute';
    deleteShapeButtonDiv.style.top = '0';
    deleteShapeButtonDiv.style.left = '144px';
    deleteShapeButtonDiv.style.display = 'block';
    deleteShapeButtonDiv.style.backgroundColor = 'white';
    deleteShapeButtonDiv.style.border = 'none';
    deleteShapeButtonDiv.style.marginTop = '5px';
    deleteShapeButtonDiv.style.width = '24px';
    deleteShapeButtonDiv.style.height = '24px';
    deleteShapeButtonDiv.style.padding = '4px';
    deleteShapeButtonDiv.style.cursor = 'pointer';
    deleteShapeButtonDiv.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0 1px 4px -1px';
    deleteShapeButtonDiv.style.borderRadius = '2px';
    var deleteShapeButtonImage = document.createElement('img');
    deleteShapeButtonImage.src = '/assets/icons/delete-gray2.svg';
    deleteShapeButtonImage.alt = 'Delete a selected shape';
    deleteShapeButtonImage.style.cursor = 'pointer';
    deleteShapeButtonImage.style.width = '16px';
    deleteShapeButtonImage.style.height = '16px';
    deleteShapeButtonImage.draggable = false;
    deleteShapeButtonDiv.appendChild(deleteShapeButtonImage);
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(deleteShapeButtonDiv);
    google.maps.event.addDomListener(deleteShapeButtonDiv, 'click', deleteSelectedShape);
  }

  function initSearchInput() {
    searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.placeholder = 'Search location';
    searchInput.style.width = '100px';
    searchInput.style.margin = '5px';
    searchInput.style.height = '24px';
    searchInput.style.font = 'normal normal 11px/24px Inter';
    searchInput.style.color = '#464646';
    searchInput.style.padding = '0 4px';
    searchInput.style.border = '1px solid #e8e8e8';
    searchInput.style.borderRadius = '2px';
    searchInput.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0 1px 4px -1px';
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(searchInput);
    searchBox = new google.maps.places.SearchBox(searchInput);
    google.maps.event.addListener(searchBox, 'places_changed', function () {
      var places = searchBox.getPlaces();

      if (places.length === 0) {
        return;
      }

      for (var i = 0, placeMarker; placeMarker = placeMarkers[i]; i++) {
        placeMarker.setMap(null);
      }

      placeMarkers = [];
      var bounds = new google.maps.LatLngBounds();

      for (var _i = 0, place; place = places[_i]; _i++) {
        var image = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25)
        }; // Create a marker for each place.

        var _placeMarker = new google.maps.Marker({
          map: map,
          icon: image,
          title: place.name,
          position: place.geometry.location
        });

        placeMarkers.push(_placeMarker);
        bounds.extend(place.geometry.location);
      }

      map.fitBounds(bounds);
    });
    google.maps.event.addListener(map, 'bounds_changed', function () {
      var bounds = map.getBounds();
      searchBox.setBounds(bounds);
    });
  }

  this.initialize = function () {
    initMap();
    initDeleteShapeButton(); // initSearchInput();
    // drawProjectViewport();
  };

  this.getLocations = function () {
    if (!marker) {
      return null;
    }

    return {
      position: self.data.address,
      coordinates: [marker.position.lat(), marker.position.lng()],
      shape: getShapeData()
    };
  };
}


"use strict";

function PdfBimPlan(imageData, materials) {
  'use strict';

  this["export"] = function (fileName, pageSize) {
    var pdf = new jspdf.jsPDF('l', 'px', [pageSize.size.width, pageSize.size.height]);
    var width = pdf.internal.pageSize.getWidth();
    var height = pdf.internal.pageSize.getHeight();

    if (materials) {
      width -= 240;
    }

    var rect = ExtUtils.getSizeToFit(imageData.width, imageData.height, width, height);
    pdf.addImage(imageData.data, 'JPEG', rect.left, rect.top, rect.width, rect.height);

    if (materials) {
      drawMaterials(pdf, width, height, materials);
    }

    pdf.save(fileName + ".pdf");
  };

  function drawMaterials(pdf, left, height, materials) {
    var x = left;
    var y = (height - materials.length * 40) / 2;
    pdf.setDrawColor(70, 70, 70);
    pdf.setFont('Montserrat-Regular', 'normal');
    pdf.setTextColor(70, 70, 70);
    pdf.setFontSize(16);

    for (var i = 0; i < materials.length; i++) {
      var material = materials[i];
      var color = ExtUtils.rgba2color(material.color);
      pdf.setFillColor(color.r, color.g, color.b);
      pdf.circle(x, y, 12, 'DF');
      var lines = pdf.splitTextToSize(material.name, 200);
      pdf.text(x + 30, y, lines);
      y += 40;
    }
  }
}


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function PdfSemiPlan(data) {
  'use strict';

  this["export"] = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fileName, pageSize) {
      var sideWidth, pdf, width, height, rect;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sideWidth = pageSize.size.height * 285 / 1108;
              pdf = new jspdf.jsPDF({
                orientation: 'l',
                unit: 'px',
                format: [pageSize.size.width + sideWidth, pageSize.size.height],
                lineHeight: 1.5
              });
              width = pdf.internal.pageSize.getWidth();
              height = pdf.internal.pageSize.getHeight();
              sideWidth = height * 285 / 1108;
              width -= sideWidth;
              _context.next = 8;
              return drawSideBar(pdf, width, sideWidth, height);

            case 8:
              rect = ExtUtils.getSizeToFit(data.imageData.width, data.imageData.height, width, height);
              pdf.addImage(data.imageData.data, 'JPEG', rect.left, rect.top, rect.width, rect.height);

              if (data.materials) {
                drawMaterials(pdf, width, height, data.materials);
              }

              pdf.save(fileName + ".pdf");

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  function drawSideBar(_x3, _x4, _x5, _x6) {
    return _drawSideBar.apply(this, arguments);
  }

  function _drawSideBar() {
    _drawSideBar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(pdf, left, width, height) {
      var project, company, client, x, y, text, lines;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              project = data.project;
              company = data.company;
              client = project.client;
              x = left; // #f1f1f1

              pdf.setFillColor(241, 241, 241);
              pdf.rect(x, 0, width, height, 'F');
              y = 505;
              x += 40;
              pdf.setFont('Inter-Black', 'normal');
              setFontSize(pdf, 25, height);
              pdf.setTextColor(70, 70, 70);
              text = project.projectName.toUpperCase();
              lines = pdf.splitTextToSize(text, 500);
              pdf.text(x, y, lines, null, 90);
              x += lines.length * 30;
              setFontSize(pdf, 20, height);
              text = getAddressString(project.address);
              lines = pdf.splitTextToSize(text, 500);
              pdf.text(x, y, lines, null, 90);
              x = left + 26;
              y = height - 540;
              _context2.next = 23;
              return drawImage(pdf, company.companyLogo, x, y, width - 52, 90);

            case 23:
              y += 120;
              pdf.setFont('Montserrat-SemiBold', 'normal');
              setFontSize(pdf, 16, height);
              pdf.text(x, y, company.companyName);
              y += 26;
              pdf.setFont('Montserrat-Regular', 'normal');
              lines = getAddressLines(company.address1);
              pdf.text(x, y, lines);
              y += 20 * lines.length;
              pdf.text(x, y, 'Contact Person: ' + company.companyAdmin.displayName);
              y += 26;
              pdf.text(x, y, 'Mail: ' + company.email);
              y += 26;
              pdf.text(x, y, 'Phone: ' + company.companyContact.dialCode + company.companyContact.phoneNumber);

              if (client) {
                y += 50;
                pdf.setFont('Montserrat-SemiBold', 'normal');
                setFontSize(pdf, 16, height);
                pdf.text(x, y, client.clientName);
                pdf.setFont('Montserrat-Regular', 'normal');
                y += 26;
                lines = getAddressLines(client.address);
                pdf.text(x, y, lines);
                y += lines.length * 20 + 6;

                if (client.paymentTerms && client.paymentTerms.vatNumber) {
                  pdf.text(x, y, 'VAT ' + client.paymentTerms.vatNumber);
                  y += 26;
                }

                pdf.text(x, y, 'Mail: ' + client.email);
                y += 26;

                if (client.clientContact) {
                  pdf.text(x, y, 'Phone: ' + project.client.clientContact.dialCode + project.client.clientContact.phoneNumber);
                }
              }

              y = height - 64;
              x = left;
              pdf.setFillColor(70, 70, 70);
              pdf.rect(x, height - 64, width, 64, 'F');
              y += 45;
              x += 26;
              pdf.setFont('Inter-SemiBold', 'normal');
              pdf.setTextColor(255, 255, 255);
              setFontSize(pdf, 25, height);
              pdf.text(x, y, 'VERSION ');
              setFontSize(pdf, 50, height);
              pdf.text(left + width - 20, y, data.version, 'right');

            case 50:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _drawSideBar.apply(this, arguments);
  }

  function drawMaterials(pdf, width, height, materials) {
    var w = 240;
    var x = width - w;
    var y = (height - materials.length * 40) / 2;
    pdf.setDrawColor(70, 70, 70);
    pdf.setFont('Montserrat-Regular', 'normal');
    pdf.setTextColor(70, 70, 70);
    pdf.setFontSize(16);

    for (var i = 0; i < materials.length; i++) {
      var material = materials[i];
      var color = ExtUtils.rgba2color(material.color);
      pdf.setFillColor(color.r, color.g, color.b);
      pdf.circle(x, y, 12, 'DF');
      var lines = pdf.splitTextToSize(material.name, 200);
      pdf.text(x + 30, y, lines);
      y += 40;
    }
  }

  function getAddressString(address) {
    if (!address) {
      return '';
    }

    if (typeof address === 'string') {
      return address;
    }

    if (Array.isArray(address)) {
      address = address[0];
    }

    var addressList = [];

    if (address.line1) {
      addressList.push(address.line1);
    }

    if (address.city) {
      addressList.push(address.city);
    }

    if (address.postalCode) {
      addressList.push(address.postalCode);
    }

    if (address.countryCode) {
      addressList.push(address.countryCode);
    }

    return addressList.join(', ');
  }

  function getAddressLines(address) {
    if (!address) {
      return [''];
    }

    if (typeof address === 'string') {
      return [address];
    }

    if (Array.isArray(address)) {
      address = address[0];
    }

    var addressList = [];

    if (address.line1) {
      addressList.push(address.line1);
    }

    if (address.city || address.postalCode) {
      var str = '';

      if (address.postalCode) {
        str += address.postalCode + ' ';
      }

      if (address.city) {
        str += address.city;
      }

      addressList.push(str);
    }

    if (address.country) {
      addressList.push(address.country);
    }

    return addressList;
  }

  function setFontSize(pdf, size, height) {
    pdf.setFontSize(size * height / 1108);
  }

  function drawImage(pdf, src, x, y, width, height) {
    return new Promise(function (resolve, reject) {
      var image = new Image();

      image.onload = function () {
        var rect = ExtUtils.getSizeToFit(this.width, this.height, width, height);
        pdf.addImage(image, "JPEG", x, y + rect.top, rect.width, rect.height);
        resolve();
      };

      image.onerror = function (e) {
        reject(e);
      };

      image.src = src;
    });
  }
}


"use strict";

function PdfCalendar(fileName, element) {
  var width = Math.max(1165, element.clientWidth);
  var height = Math.max(720, element.clientHeight);
  var doc = new jspdf.jsPDF('l', 'px', [width, height]);
  doc.html(element, {
    callback: function callback(doc) {
      doc.save(fileName + '.pdf');
    },
    x: 0,
    y: 0
  });
}


"use strict";

function VPMainViewer(container) {
  'use strict';

  var _this = this;

  VPViewer.call(this, container);
  var self = this;
  this.history = new VPHistory(this);
  this.levels = [];

  this.loadPlan = function (plan) {
    return new Promise(function (resolve, reject) {
      self.clear();

      if (!plan.parentAsset) {
        reject({
          message: 'plan is damaged'
        });
        return;
      }

      self.setPlanInfo(plan._id, plan.assetObj.title);
      self.loadBackgroundImageWidthHD(plan.parentAsset.secure_url, plan.assetObj.pageNo).then(function () {
        var data;

        if (plan.plannerData) {
          if (plan.plannerData.jsonString) {
            data = JSON.parse(plan.plannerData.jsonString);

            if (data.json) {
              self.addFromJSON(data.json, data.planInfo, false, true);
            }

            if (data.levels) {
              self.levels = data.levels;
            }
          }

          if (plan.plannerData.calibration) {
            self.setCalibration(plan.plannerData.calibration);
          }
        }

        resolve(data);
      })["catch"](function (err) {
        reject(err);
      });
    });
  };

  this.toolbarEvent = function (id) {
    switch (id) {
      case 'select':
        this.onSelection();
        break;

      case 'pan':
        this.onPan();
        break;

      case 'rect':
        this.newRect();
        break;

      case 'sector':
        this.newSector();
        break;

      case 'circle':
        this.newCircle();
        break;

      case 'hexagon':
        this.newHexagon();
        break;

      case 'eraser':
        this.eraser();
        break;

      case 'line':
        this.newLine();
        break;

      case 'polyline':
        this.newPolyLine();
        break;

      case 'arc':
        this.newArc();
        break;

      case 'freeline':
        this.newFreeLine();
        break;

      case 'curve':
        this.newCurve();
        break;

      case 'wall':
        this.newWall();
        break;

      case 'arrow_line_up':
        this.newArrowLineUp();
        break;

      case 'arrow_line_down':
        this.newArrowLineDown();
        break;

      case 'arrow_line_both_sides':
        this.newArrowLineBoth();
        break;

      case 'calibrator':
        this.newCalibrator();
        break;

      case 'length':
        this.measureLength();
        break;

      case 'angle':
        this.measureAngle();
        break;

      case 'surface':
        this.measureArea();
        break;

      case 'text':
        this.newText();
        break;

      case 'bubble':
        this.newTextBubble();
        break;

      case 'zoom':
        this.newZoom();
        break;

      case 'color':
        this.pickColor();
        break;

      case 'bucket':
        this.newBucket();
        break;

      case 'front':
        this.bringToFront();
        break;

      case 'back':
        this.sendToBack();
        break;

      default:
        activateDrawing();
        break;
    }
  };
  /**drawing methods */


  this.onSelection = function () {
    activateDrawing();
  };

  this.onPan = function () {
    var drawing = getDrawingTool(VP.DrawerType.pan);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPPanMover(this));
    }

    drawing.newPan();
  };

  this.newRect = function () {
    var drawing = getDrawingTool(VP.DrawerType.rect);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPRectDrawer(this));
    }

    drawing.newRect();
  };

  this.newHexagon = function () {
    var drawing = getDrawingTool(VP.DrawerType.circle);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPCircleDrawer(this));
    }

    drawing.newHexagon();
  };

  this.eraser = function () {
    var drawing = getDrawingTool(VP.DrawerType.operator);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPShapeOperator(this));
    }

    drawing.newEraser();
  };

  this.newSector = function () {
    var drawing = getDrawingTool(VP.DrawerType.sector);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPSectorDrawer(this));
    }

    drawing.newSector();
  };

  this.newCircle = function () {
    var drawing = getDrawingTool(VP.DrawerType.circle);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPCircleDrawer(this));
    }

    drawing.newCircle();
  };

  this.newLine = function () {
    var drawing = getDrawingTool(VP.DrawerType.line);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPLineDrawer(this));
    }

    drawing.newLine();
  };

  this.newCurve = function () {
    var drawing = getDrawingTool(VP.DrawerType.freecurve);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPFreeCurveDrawer(this));
    }

    drawing.newCurve();
  };

  this.newArc = function () {
    var drawing = getDrawingTool(VP.DrawerType.curve);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPCurveDrawer(this));
    }

    drawing.newArc();
  };

  this.newFreeLine = function () {
    var drawing = getDrawingTool(VP.DrawerType.freeline);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPFreeLineDrawer(this));
    }

    drawing.newFreeLine();
  };

  this.newPolyLine = function () {
    var drawing = getDrawingTool(VP.DrawerType.polyline);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPPolyLineDrawer(this));
    }

    drawing.newPolyLine();
  };

  this.newWall = function () {
    var drawing = getDrawingTool(VP.DrawerType.wall);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPWallDrawer(this));
    }

    drawing.newWall();
  };

  this.newArrowLineUp = function () {
    var drawing = getDrawingTool(VP.DrawerType.arrowline);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPArrowLineDrawer(this));
    }

    drawing.newLine('up');
  };

  this.newArrowLineDown = function () {
    var drawing = getDrawingTool(VP.DrawerType.arrowline);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPArrowLineDrawer(this));
    }

    drawing.newLine('down');
  };

  this.newArrowLineBoth = function () {
    var drawing = getDrawingTool(VP.DrawerType.arrowline);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPArrowLineDrawer(this));
    }

    drawing.newLine('both');
  };

  this.newText = function () {
    var drawing = getDrawingTool(VP.DrawerType.text);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPTextDrawer(this));
    }

    drawing.newText();
  };

  this.newTextBubble = function () {
    var drawing = getDrawingTool(VP.DrawerType.text);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPTextDrawer(this));
    }

    drawing.newTextBubble();
  };

  this.newZoom = function () {
    var drawing = getDrawingTool(VP.DrawerType.zoom);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPZoomer(this));
    }

    drawing.newZoom();
  };

  this.pickColor = function () {
    var drawing = getDrawingTool(VP.DrawerType.color);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPColorPicker(this));
    }

    drawing.newPicker();
  };

  this.newBucket = function () {
    var drawing = getDrawingTool(VP.DrawerType.operator);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPShapeOperator(this));
    }

    drawing.newBucket();
  };

  this.newCalibrator = function () {
    var drawing = getDrawingTool(VP.DrawerType.calibrator);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPCalibrator(this));
    }

    drawing.newCalibrator();
  };

  this.measureLength = function () {
    var drawing = getDrawingTool(VP.DrawerType.length);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPLengthMeasurer(this));
    }

    drawing.measureLength();
  };

  this.measureAngle = function () {
    var drawing = getDrawingTool(VP.DrawerType.angle);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPAngleMeasurer(this));
    }

    drawing.measureAngle();
  };

  this.measureArea = function () {
    var drawing = getDrawingTool(VP.DrawerType.area);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPAreaMeasurer(this));
    }

    drawing.measureArea();
  };

  this.bringToFront = function () {
    var drawing = getDrawingTool(VP.DrawerType.operator);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPShapeOperator(this));
    }

    drawing.bringToFront();
  };

  this.sendToBack = function () {
    var drawing = getDrawingTool(VP.DrawerType.operator);

    if (drawing === undefined) {
      drawing = activateDrawing(new VPShapeOperator(this));
    }

    drawing.sendToBack();
  };

  this.undo = function () {
    this.history.undo();
  };

  this.redo = function () {
    this.history.redo();
  };

  this.setColor = function (color) {
    this.fill.type = 'color';
    this.fill.value = color;
    this.newBucket();
  };

  this.setTexture = function (texture) {
    this.fill.type = "texture";
    this.fill.value = texture;
    this.newBucket();
  };

  this.setDrawingDashType = function (type) {
    switch (type) {
      case VP.DashType.DashA:
        this.brush.strokeDashArray = [];
        break;

      case VP.DashType.DashB:
        this.brush.strokeDashArray = [1, 3];
        this.brush.strokeWidth = 1;
        break;

      case VP.DashType.DashC:
        this.brush.strokeDashArray = [1, 3];
        this.brush.strokeWidth = 10;
        break;

      default:
        break;
    }
  };

  this.setVisibility = function (ids, visible) {
    this.data.setVisibility(ids, visible);
    this.render();
  };

  this.getActiveObject = function () {
    return this.canvas.getActiveObject();
  };

  this.exportCalculationData = function (workLevel, sections) {
    return this.data.getCalculationData(workLevel, sections);
  };

  this.changeObjectInfo = function (prop, value) {
    if (prop === 'stroke') {
      this.brush.strokeColor = value;
    }

    var object = this.getActiveObject();

    if (object) {
      VPUtils.setProperty(object, prop, value);
      this.render();

      if (object.vpObject) {
        object.vpObject.set(prop, value);
      }
    }
  };

  this.changeTextInfo = function (prop, value) {
    if (prop === 'stroke') {
      this.textBrush.strokeColor = value;
    } else if (prop === 'fill') {
      this.textBrush.fillColor = value;
    }

    var object = this.getActiveObject();

    if (object) {
      object.set(prop, value);
      this.render();

      if (object.vpObject) {
        object.vpObject.set(prop, value);
      }
    }
  };

  this.changeDashType = function (type) {
    this.setDrawingDashType(type);
    var object = this.getActiveObject();

    if (object) {
      this.onChangeDashType(object, type);
    }
  };

  this.changeDashSpace = function (space) {
    this.brush.strokeDashArray = space;
    var object = this.getActiveObject();

    if (object) {
      this.onChangeDashSpace(object, space);
    }
  };

  this.changeThickness = function (thickness) {
    this.brush.strokeWidth = thickness;
    var object = this.getActiveObject();

    if (object) {
      this.onChangeStroke(object, thickness);
    }
  };

  this.addImage = function (url, size) {
    loadImage(url, size).then(function (icon) {
      activateDrawing(new VPIconDrawer(self)).newIcon(icon);
    });
  };

  this.clear = function () {
    if (this.canvas) {
      this.canvas.clear();
    }
  };

  this.onDragObject = function () {
    var object = this.canvas.getActiveObject();

    if (object) {
      activateDrawing(new VPIconDrawer(this)).dragObject(object);
    }
  };

  this.setColorMode = function (colorMode) {
    if (this.colorMode === colorMode) return;
    this.colorMode = colorMode;
    this.data.setColorMode(colorMode);
    this.render();
  };

  this.getColoredInventories = function () {
    var vpObjects = this.data.objects;
    var colorList = [];
    vpObjects.forEach(function (vpObject) {
      var color = vpObject.getMaterialColor();

      if (color) {
        if (colorList.findIndex(function (x) {
          return x._id === color._id;
        }) === -1) {
          colorList.push(color);
        }
      }
    });
    return colorList.length ? colorList : undefined;
  }; // -------- navigation mode -------------


  this.setNavigationMode = function (mode) {
    if (mode) {
      var vptCoords = self.canvas.vptCoords;
      var center = {
        x: (vptCoords.tl.x + vptCoords.tr.x) * 0.5,
        y: (vptCoords.tl.y + vptCoords.bl.y) * 0.5
      };
      var navIcon = '/assets/images/cgviewer/location-mark.png';
      addNavIcon(navIcon, center).then(function (icon) {
        self.navIcon = icon;
        self.navIcon.visible = false;
        self.render();
      });
      this.onPan();
    } else {
      if (this.navIcon !== undefined) {
        this.navIcon.visible = false;
        self.canvas.remove(this.navIcon);
        this.navIcon = undefined;
        self.render();
      }
    }
  };

  this.setNavigationIconPos = function (pos, angle) {
    if (this.navIcon) {
      if (pos === undefined) {
        this.navIcon.visible = false;
      } else {
        var w = this.planObject.width * this.planObject.scaleX;
        var h = this.planObject.height * this.planObject.scaleY;
        var left = this.planObject.left - w / 2.0 + w * pos.x;
        var top = this.planObject.top - h / 2.0 + h * pos.y;
        this.navIcon.left = left;
        this.navIcon.top = top;
        this.navIcon.visible = true;

        if (angle !== undefined) {
          this.navIcon.angle = angle * 180 / Math.PI;
        }
      }

      this.render();
    }
  }; // --------------------------------------
  //--------register events handlers---------


  this.on('shortcut:copyDrag', function () {
    var object = _this.canvas.getActiveObject();

    if (object) {
      _this.copy(object).then(function (cloned) {
        self.canvas.discardActiveObject();
        self.canvas.setActiveObject(cloned);
        activateDrawing(new VPIconDrawer(self)).newObject(cloned);
      });
    }
  });
  this.on('updateDrawer', function (drawer) {
    switch (drawer) {
      case 'pan':
        _this.onPan();

        break;

      default:
        break;
    }
  });

  function loadImage(src, size) {
    return new Promise(function (resolve, reject) {
      fabric.Image.fromURL(src, function (image) {
        if (size) {
          image.scaleToWidth(size);
        }

        resolve(image);
      });
    });
  }

  function getDrawingTool(drawingType) {
    return self.drawingTool && drawingType === self.drawingTool.drawer ? self.drawingTool : undefined;
  }

  function activateDrawing(drawer) {
    if (self.drawingTool) {
      self.drawingTool.setActive(false);
    }

    self.drawingTool = drawer;

    if (drawer) {
      drawer.setActive(true);
    } else {
      self.setSelectable(true);
    }

    return drawer;
  }

  function addNavIcon(url, pos) {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      fabric.Image.fromURL(url, function (shape) {
        shape.set({
          left: pos.x,
          top: pos.y,
          originX: 'center',
          originY: 'center',
          hasControls: false,
          hasBorders: false,
          selectable: false,
          fill: ''
        });
        var scaleW = 20 / 0.15 * self.planObject.scaleX;
        shape.scaleToWidth(scaleW);
        shape.scaleToHeight(scaleW);
        self.canvas.add(shape);
        resolve(shape);
      }.bind(_this2), {
        crossOrigin: 'anonymous'
      });
    });
  }
}


"use strict";

function VPMarkingViewer(container) {
  'use strict';

  VPViewer.call(this, container);
  this.markers = [];
  var self = this;
  var defaultMarkerIcon = '/assets/images/cgviewer/vp-issue-open.svg';
  var markerIcons = {
    'Open': '/assets/images/cgviewer/vp-issue-open.svg',
    'Open-Message': '/assets/images/cgviewer/vp-issue-open.svg',
    'On Hold': '/assets/images/cgviewer/vp-issue-hold.svg',
    'Resolved': '/assets/images/cgviewer/vp-issue-completed.svg',
    'Completed': '/assets/images/cgviewer/vp-issue-completed.svg'
  };
  var pan = new VPPanMover(this);
  pan.setActive(true);
  pan.newPan();
  self.setCursor('default');
  this.on('mouse:down', onMouseDown);
  this.on('zoom:changed', onZoomChanged);
  var destroy = this.destroy;

  this.destroy = function () {
    this.off('mouse:down', onMouseDown);
    this.off('zoom:changed', onZoomChanged);
    destroy();
  };

  this.loadPlan = function (plan) {
    return new Promise(function (resolve, reject) {
      self.clear();

      if (!plan.parentAsset) {
        reject({
          message: 'plan is damaged'
        });
        return;
      }

      self.setPlanInfo(plan._id, plan.assetObj.title);
      self.loadBackgroundImageWidthHD(plan.parentAsset.secure_url, plan.assetObj.pageNo).then(function () {
        if (plan.plannerData && plan.plannerData.jsonString) {
          var data = JSON.parse(plan.plannerData.jsonString);

          if (data.json) {
            self.addFromJSON(data.json, data.planInfo, false, true);
            self.canvas.forEachObject(function (object) {
              object.selectable = false;
              object.evented = false;
            });
          }
        }

        resolve();
      })["catch"](function (err) {
        reject(err);
      });
    });
  };

  this.loadMarkers = function (markers) {
    if (!markers || markers.length === 0) return;
    var w = this.planObject.width * this.planObject.scaleX;
    var h = this.planObject.height * this.planObject.scaleY;
    var left = this.planObject.left - w / 2.0;
    var top = this.planObject.top - w / 2.0;

    for (var i = 0; i < markers.length; i++) {
      addMarkingIcon({
        x: markers[i].x * w + left,
        y: markers[i].y * h + top
      }, markers[i]);
    }
  };

  this.removeAllMarkers = function () {
    if (this.markers.length === 0) return;

    for (var i = 0; i < this.markers.length; i++) {
      var marker = self.markers[i];
      self.canvas.remove(marker);
    }

    self.markers = [];
    self.render();
  };

  this.getMarkers = function () {
    var data = [];
    if (this.markers.length === 0) return data;
    var w = this.planObject.width * this.planObject.scaleX;
    var h = this.planObject.height * this.planObject.scaleY;
    var left = this.planObject.left - w / 2.0;
    var top = this.planObject.top - w / 2.0;

    for (var i = 0; i < this.markers.length; i++) {
      data.push({
        x: (this.markers[i].left - left) / w,
        y: (this.markers[i].top - top) / h,
        z: 0
      });
    }

    return data;
  };

  this.placeMarker = function (pos) {
    var w = this.planObject.width * this.planObject.scaleX;
    var h = this.planObject.height * this.planObject.scaleY;
    var left = this.planObject.left - w / 2.0;
    var top = this.planObject.top - w / 2.0;
    var x = pos.x * w + left;
    var y = pos.y * h + top;

    if (x >= left && x <= left + w && y >= top && y <= top + h) {
      addMarkingIcon({
        x: x,
        y: y
      });
    }
  };

  this.addMarker = function () {
    this.mouseStatus = 'marking';
    this.setCursor('marker', true, true);
  };

  this.removeMarker = function () {
    this.mouseStatus = 'removing';
    this.setCursor('eraser', true, true);
  };

  function onMouseDown(e) {
    var ev = e.e;

    if (self.mouseStatus === 'marking') {
      var pointer = self.canvas.getPointer(ev);
      addMarkingIcon(pointer);
      self.setCursor('default');
      self.mouseStatus = undefined;
      return;
    } else if (self.mouseStatus === 'removing') {
      var _pointer = self.canvas.getPointer(ev);

      if (removeMarkingIcon(_pointer)) {
        self.setCursor('default');
        self.mouseStatus = undefined;
        return;
      }
    }

    self.canvas.selection = false;
  }

  function onZoomChanged(e) {
    var level = e.level;

    if (level !== 0) {
      for (var i = 0; i < self.markers.length; i++) {
        self.markers[i].scaleX = 1 / level;
        self.markers[i].scaleY = 1 / level;
      }

      self.broadcast('scroll:changed', {
        scaleX: 1 / level,
        scaleY: 1 / level
      });
    }
  }

  function addMarkingIcon(pos, marker) {
    var markerIcon = defaultMarkerIcon;

    if (marker) {
      console.log(marker.hasMessages);

      if (marker.status === 'Open' && marker.hasMessages) {
        marker.status = 'Open-Message';
      }

      markerIcon = markerIcons[marker.status];

      if (!markerIcon) {
        markerIcon = defaultMarkerIcon;
      }
    }

    addIcon(markerIcon, pos).then(function (icon) {
      icon.marker = marker;
      self.markers.push(icon);
    });
  }

  function removeMarkingIcon(pos) {
    for (var i = 0; i < self.markers.length; i++) {
      var marker = self.markers[i];

      if (Math.abs(marker.left - pos.x) <= marker.width / 2 && Math.abs(marker.top - pos.y) <= marker.height / 2) {
        self.canvas.remove(marker);
        self.markers.splice(i, 1);
        self.render();
        return true;
      }
    }

    return false;
  }

  function addIcon(url, pos) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      fabric.Image.fromURL(url, function (shape) {
        shape.set({
          left: pos.x,
          top: pos.y,
          originX: 'center',
          originY: 'center',
          hasControls: false,
          hasBorders: false,
          selectable: false,
          fill: '',
          hoverCursor: 'pointer'
        });
        shape.on('mousedown', iconClicked);
        self.canvas.add(shape);
        resolve(shape);
      }.bind(_this), {
        crossOrigin: 'anonymous'
      });
    });
  }

  function iconClicked() {
    var pt = fabric.util.transformPoint(new fabric.Point(this.left, this.top), self.canvas.viewportTransform);
    self.broadcast('marker:click', {
      pos: {
        x: pt.x,
        y: pt.y
      },
      marker: this.marker
    });
  }
}


"use strict";

function VPSimpleViewer(container) {
  'use strict';

  VPViewer.call(this, container);
  var self = this;
  var pan = new VPPanMover(this);
  pan.setActive(true);
  pan.newPan();

  this.loadPlan = function (plan) {
    return new Promise(function (resolve, reject) {
      self.clear();

      if (!plan.parentAsset) {
        reject({
          message: 'plan is damaged'
        });
        return;
      }

      self.setPlanInfo(plan._id, plan.assetObj.title);
      self.loadBackgroundImageWidthHD(plan.parentAsset.secure_url, plan.assetObj.pageNo).then(function () {
        if (plan.plannerData && plan.plannerData.jsonString) {
          var data = JSON.parse(plan.plannerData.jsonString);

          if (data.json) {
            self.addFromJSON(data.json, data.planInfo, false, true);
            self.canvas.forEachObject(function (object) {
              object.selectable = false;
              object.evented = false;
            });
          }
        }

        resolve();
      })["catch"](function (err) {
        reject(err);
      });
    });
  };
}


"use strict";

var BimUtils = {
  CAD_ZERO: 10e-4,
  setRatioZero: function setRatioZero(ratio) {
    this.CAD_ZERO = 10e-4 * ratio;
  },
  isGPUAvailable: function isGPUAvailable() {
    var canvas = document.createElement('canvas');
    var gl;
    var debugInfo;
    var renderer;
    var found = false;

    try {
      gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    } catch (e) {}

    if (gl) {
      debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL); //console.log('****render-log****', renderer);

      if (renderer.toLowerCase().includes("nvidia")) {
        found = true;
      }
    }

    return found;
  },
  IsZero: function IsZero(v, precision) {
    precision = precision !== undefined ? precision : this.CAD_ZERO;
    return -precision < v && v < precision;
  },
  equalsValue: function equalsValue(a, b, precision) {
    var ab = Math.abs(a - b);
    return this.IsZero(ab, precision);
  },
  equalsVector3: function equalsVector3(a, b, precision) {
    if (a == b) return true;
    if (a.equals(b)) return true; // var d = a.distanceTo(b);
    // return this.IsZero(d, precision);

    return this.equalsValue(a.x, b.x, precision) && this.equalsValue(a.y, b.y, precision) && this.equalsValue(a.z, b.z, precision);
  },
  FVK: ['a', 'b', 'c'],
  // name(key) of vertices in Face3
  coplanarFaces: function coplanarFaces(coFaces, seedFace, fromFaces, precision) {
    var faces = fromFaces.slice();
    var self = this;
    return findCoplanar(seedFace);

    function findCoverFaces(fo) {
      var covers = [];
      var face, i, io, ifa, ko, kf, equal;

      for (i = faces.length - 1; i >= 0; i--) {
        face = faces[i];

        if (fo !== face) {
          equal = false;

          for (io = 0; io < self.FVK.length; io++) {
            ko = fo[self.FVK[io]];

            for (ifa = 0; ifa < self.FVK.length; ifa++) {
              kf = face[self.FVK[ifa]];
              equal = ko == kf;
              if (equal) break;
            }

            if (equal) break;
          }

          if (!equal) continue;
        }

        covers.push(face);
      }

      return covers;
    }

    function findCoplanar(fo) {
      var covers = findCoverFaces(fo);
      if (covers.length == 0) return false;
      var cop = [];
      covers.forEach(function (cover) {
        if (fo === cover || self.equalsVector3(fo.normal, cover.normal, precision)) {
          // is coplanar
          cop.push(cover);
          if (coFaces) coFaces.push(cover);
        }

        faces.splice(faces.indexOf(cover), 1); // 0 <= indexOf()
      });
      if (cop.length == 0) return false;
      var op = false;
      cop.forEach(function (cover) {
        if (fo !== cover && findCoplanar(cover)) op = true;
      });
      return op;
    }
  },
  copyGeoInfo: function copyGeoInfo(to, from) {
    to.vertices = [];
    to.faces = [];
    to.faceVertexUvs = [[]];
    from.vertices.forEach(function (vt) {
      to.vertices.push(vt.clone());
    });
    from.faces.forEach(function (face) {
      to.faces.push(face.clone());
    });
    from.faceVertexUvs.forEach(function (uvs, iuvs) {
      if (to.faceVertexUvs[iuvs] === undefined) to.faceVertexUvs[iuvs] = [];
      var uvs2 = to.faceVertexUvs[iuvs];
      uvs.forEach(function (uvv) {
        var uvv2 = [];
        uvv.forEach(function (uv) {
          uvv2.push(uv.clone());
        });
        uvs2.push(uvv2);
      });
    });
  },
  freeMaterial: function freeMaterial(material) {
    material.dispose();
    if (material.map) material.map.dispose();
  },
  freeEntity: function freeEntity(entity) {
    if (entity.parent) entity.parent.remove(entity);
    if (entity.geometry) entity.geometry.dispose();
    if (entity.material) this.freeMaterial(entity.material);
    if (entity.dispose) entity.dispose();
  },
  eraseHit: function eraseHit(edgeEntities) {
    edgeEntities.forEach(function (edgeEntity) {
      if (edgeEntity.userData.isSurfaceEditable && edgeEntity.isLineSegments) {
        edgeEntity.material.color.setHex(Bim.Colors.edgeDefault);
      }
    });
  },
  emphasizeHit: function emphasizeHit(edgeEntities) {
    edgeEntities.forEach(function (edgeEntity) {
      if (edgeEntity.userData.isSurfaceEditable && edgeEntity.isLineSegments) {
        edgeEntity.material.color.setHex(Bim.Colors.faceSelected);
      }
    });
  },
  newMatFill: function newMatFill() {
    return new THREE.MeshPhongMaterial({
      color: Bim.Colors.faceDefault,
      specular: 0x111111,
      shininess: 30,
      side: THREE.DoubleSide
    });
  },
  newMatStroke: function newMatStroke() {
    return new THREE.LineBasicMaterial({
      color: Bim.Colors.edgeDefault
    });
  },
  newMatGuideline: function newMatGuideline(dashSize) {
    return new THREE.LineDashedMaterial({
      color: Bim.Colors.guideline,
      // scale: 1,
      dashSize: dashSize,
      gapSize: dashSize,
      depthTest: false,
      depthWrite: false,
      side: THREE.DoubleSide
    });
  },
  newMatMeasureline: function newMatMeasureline() {
    return new THREE.LineBasicMaterial({
      color: Bim.Colors.edgeDefault,
      depthTest: false,
      depthWrite: false,
      side: THREE.DoubleSide
    });
  },
  createMeasureText: function createMeasureText(text, scale, transparent) {
    var textEntity = new THREE.TextSprite({
      alignment: 'left',
      backgroundColor: 'rgba(0,0,0,0)',
      color: '#000',
      fontSize: 10 * scale,
      fontVariant: 'normal',
      fontWeight: 'normal',
      fontFamily: 'Arial, Helvetica, sans-serif',
      text: text
    });
    textEntity.userData.unSnapable = true;
    return textEntity;
  },
  createEdgeEntity: function createEdgeEntity(posarray, mat, parent, origin) {
    var geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(posarray, 3));
    var edgeEntity = new THREE.LineSegments(geometry, mat);
    if (parent) parent.add(edgeEntity);

    if (origin) {
      edgeEntity.position.copy(origin);
      edgeEntity.updateMatrixWorld();
    }

    return edgeEntity;
  },
  isAloneOutline: function isAloneOutline(entity) {
    return entity.isLineSegments && entity.userData.isSurfaceEditable && !entity.parent.userData.isSurfaceEditable;
  },
  centerPosition: function centerPosition() {
    var v = new THREE.Vector3();
    return function (entity) {
      var position = entity.geometry.getAttribute('position'); // lineseg

      v.fromBufferAttribute(position, 0); // z

      v.x = 0;
      v.y = 0;
      return v.applyMatrix4(entity.matrixWorld);
    };
  },
  surfaceGeometry: function surfaceGeometry(geoInfo) {
    var geometry = new THREE.Geometry();
    this.copyGeoInfo(geometry, geoInfo);
    if (geoInfo.dispose) geoInfo.dispose();
    return geometry;
  },
  planeColor: function planeColor(planeFlag) {
    var color = Bim.Colors.edgeDefault;

    switch (planeFlag) {
      case Bim.PlaneFlag.onXY:
        color = Bim.Colors.onXY;
        break;

      case Bim.PlaneFlag.onYZ:
        color = Bim.Colors.onYZ;
        break;

      case Bim.PlaneFlag.onZX:
        color = Bim.Colors.onZX;
        break;

      case Bim.PlaneFlag.none:
        color = Bim.Colors.onNone;
        break;

      case Bim.PlaneFlag.onPararrelXY:
        color = Bim.Colors.onXY;
        break;

      case Bim.PlaneFlag.onPararrelYZ:
        color = Bim.Colors.onYZ;
        break;

      case Bim.PlaneFlag.onPararrelZX:
        color = Bim.Colors.onZX;
        break;
    }

    return color;
  },
  createAxisEntity: function createAxisEntity(parent, origin, type) {
    var size = Bim.AxisLimit;
    var axis = new THREE.Group();
    var vertices = [-size, 0, 0, size, 0, 0];
    var geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    var mat = new THREE.LineBasicMaterial({
      visible: false
    });
    var axisEntity = new THREE.LineSegments(geometry, mat);

    if (origin) {
      axisEntity.position.copy(origin);
      axisEntity.updateMatrixWorld();
    }

    axisEntity.name = 'onred';
    axisEntity.isTempAxis = true;
    axisEntity.axisType = type;
    axis.add(axisEntity);
    vertices = [0, -size, 0, 0, size, 0];
    geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    mat = new THREE.LineBasicMaterial({
      visible: false
    });
    axisEntity = new THREE.LineSegments(geometry, mat);

    if (origin) {
      axisEntity.position.copy(origin);
      axisEntity.updateMatrixWorld();
    }

    axisEntity.name = 'ongreen';
    axisEntity.isTempAxis = true;
    axisEntity.axisType = type;
    axis.add(axisEntity);
    vertices = [0, 0, -size, 0, 0, size];
    geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    mat = new THREE.LineBasicMaterial({
      visible: false
    });
    axisEntity = new THREE.LineSegments(geometry, mat);

    if (origin) {
      axisEntity.position.copy(origin);
      axisEntity.updateMatrixWorld();
    }

    axisEntity.name = 'onblue';
    axisEntity.isTempAxis = true;
    axisEntity.axisType = type;
    axis.add(axisEntity);
    if (parent) parent.add(axis);
    return axis;
  },
  createGuideLine: function createGuideLine(pos, dir, parent) {
    var start = pos.clone().add(dir.clone().multiplyScalar(Bim.AxisLimit));
    var end = pos.clone().add(dir.clone().multiplyScalar(Bim.AxisLimit * -1));
    var dashedVertices = [start.x, start.y, start.z, end.x, end.y, end.z];
    var dashedColors = [0.5, 0.5, 0.5, 0.5, 0.5, 0.5];
    var dashedGeometry = new THREE.BufferGeometry();
    dashedGeometry.setAttribute('position', new THREE.Float32BufferAttribute(dashedVertices, 3));
    dashedGeometry.setAttribute('color', new THREE.Float32BufferAttribute(dashedColors, 3));
    var dashedMaterial = new THREE.LineDashedMaterial({
      vertexColors: THREE.VertexColors,
      dashSize: 2,
      gapSize: 2
    });
    var guide = new THREE.LineSegments(dashedGeometry, dashedMaterial).computeLineDistances();
    if (parent) parent.add(guide);
    return guide;
  },
  getScaleFactorByCameraPos: function getScaleFactorByCameraPos(curPos, camPos) {
    return Bim.Constant.ratioToKeepSize * curPos.clone().sub(camPos).length();
  },
  getAreaVolume: function getAreaVolume(geom) {
    function AreaOfTriangle(p1, p2, p3) {
      var t = new THREE.Triangle(p1, p2, p3);
      return t.getArea();
    }

    function signedVolumeOfTriangle(p1, p2, p3) {
      return p1.dot(p2.cross(p3)) / 6.0;
    }

    var newGeom;

    if (!geom.isBufferGeometry) {
      newGeom = new THREE.BufferGeometry().fromGeometry(geom);
    } else {
      newGeom = geom;
    }

    var area = 0,
        volume = 0;

    for (var vi = 0; vi < newGeom.attributes.position.array.length; vi += 9) {
      var vx0 = newGeom.attributes.position.array[vi];
      var vy0 = newGeom.attributes.position.array[vi + 1];
      var vz0 = newGeom.attributes.position.array[vi + 2];
      var vx1 = newGeom.attributes.position.array[vi + 3];
      var vy1 = newGeom.attributes.position.array[vi + 4];
      var vz1 = newGeom.attributes.position.array[vi + 5];
      var vx2 = newGeom.attributes.position.array[vi + 6];
      var vy2 = newGeom.attributes.position.array[vi + 7];
      var vz2 = newGeom.attributes.position.array[vi + 8];
      var v0 = new THREE.Vector3(vx0, vy0, vz0);
      var v1 = new THREE.Vector3(vx1, vy1, vz1);
      var v2 = new THREE.Vector3(vx2, vy2, vz2);
      area += AreaOfTriangle(v0, v1, v2);
      volume += signedVolumeOfTriangle(v0, v1, v2);
    }

    return {
      area: Math.abs(area),
      volume: Math.abs(volume)
    };
  },
  getStraightLine3d: function getStraightLine3d(firstPos, lastPos) {
    //for 3d
    var newPos = lastPos.clone();
    var dx = Math.abs(lastPos.x - firstPos.x);
    var dy = Math.abs(lastPos.y - firstPos.y);

    if (dx > dy) {
      newPos.y = firstPos.y;
    } else {
      newPos.x = firstPos.x;
    }

    return newPos;
  },
  getLevelListFromStructureTree: function getLevelListFromStructureTree(tree) {
    var finalList = [];
    searchTree(tree, finalList);

    for (var i = 0; i < finalList.length; i++) {
      if (!finalList[i].name) {
        if (i === 0) {
          finalList[i].name = 'Roof';
        } else if (i === finalList.length - 1) {
          finalList[i].name = 'Ground';
        } else {
          finalList[i].name = (finalList.length - i).toString();
        }
      }
    }

    return finalList;

    function searchTree(node, list) {
      if (node.type && node.type === 'IfcBuildingStorey') {
        list.push({
          guid: node.guid,
          name: node.workLevel
        });
      }

      if (node.children && node.children.length > 0) {
        for (var _i = 0; _i < node.children.length; _i++) {
          searchTree(node.children[_i], list);
        }
      }
    }
  },
  getPlanCorner3dPts: function getPlanCorner3dPts(p1, p2, p3, u1, v1, u2, v2, u3, v3) {
    var matrix = new THREE.Matrix3();
    matrix.set(u1, v1, 1, u2, v2, 1, u3, v3, 1);
    var invM = matrix.clone(); //invM.getInverse(matrix);

    invM.copy(matrix).invert();
    var vecX = new THREE.Vector3(p1.x, p2.x, p3.x);
    var vecY = new THREE.Vector3(p1.y, p2.y, p3.y);
    var vecZ = new THREE.Vector3(p1.z, p2.z, p3.z);
    var coefVX = vecX.clone().applyMatrix3(invM);
    var coefVY = vecY.clone().applyMatrix3(invM);
    var coefVZ = vecZ.clone().applyMatrix3(invM);
    var V1 = new THREE.Vector3(coefVX.x * 0 + coefVX.y * 0 + coefVX.z, coefVY.x * 0 + coefVY.y * 0 + coefVY.z, coefVZ.x * 0 + coefVZ.y * 0 + coefVZ.z);
    var V2 = new THREE.Vector3(coefVX.x * 1 + coefVX.y * 0 + coefVX.z, coefVY.x * 1 + coefVY.y * 0 + coefVY.z, coefVZ.x * 1 + coefVZ.y * 0 + coefVZ.z);
    var V3 = new THREE.Vector3(coefVX.x * 1 + coefVX.y * 1 + coefVX.z, coefVY.x * 1 + coefVY.y * 1 + coefVY.z, coefVZ.x * 1 + coefVZ.y * 1 + coefVZ.z);
    var V4 = new THREE.Vector3(coefVX.x * 0 + coefVX.y * 1 + coefVX.z, coefVY.x * 0 + coefVY.y * 1 + coefVY.z, coefVZ.x * 0 + coefVZ.y * 1 + coefVZ.z);
    var PP1 = new THREE.Vector3(coefVX.x * u1 + coefVX.y * v1 + coefVX.z, coefVY.x * u1 + coefVY.y * v1 + coefVY.z, coefVZ.x * u1 + coefVZ.y * v1 + coefVZ.z);
    var PP2 = new THREE.Vector3(coefVX.x * u2 + coefVX.y * v2 + coefVX.z, coefVY.x * u2 + coefVY.y * v2 + coefVY.z, coefVZ.x * u2 + coefVZ.y * v2 + coefVZ.z);
    var PP3 = new THREE.Vector3(coefVX.x * u3 + coefVX.y * v3 + coefVX.z, coefVY.x * u3 + coefVY.y * v3 + coefVY.z, coefVZ.x * u3 + coefVZ.y * v3 + coefVZ.z);
    return [V1, V2, V3, V4];
  },
  getEventPosition: function getEventPosition(e) {
    var target = e.target;
    var posx = 0,
        posy = 0;

    if (e.touches && e.touches.length === 1) {
      posx = e.touches[0].pageX;
      posy = e.touches[0].pageY;
    } else if (e.changedTouches && e.changedTouches.length === 1) {
      posx = e.changedTouches[0].pageX;
      posy = e.changedTouches[0].pageY;
    } else if (e.pageX && e.pageY) {
      posx = e.pageX;
      posy = e.pageY;
    } else if (e.clientX && e.clientY) {
      posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
      posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }

    var divGlobalOffset = function divGlobalOffset(obj) {
      var x = obj.offsetLeft;
      var y = obj.offsetTop;
      var body = document.getElementsByTagName('body')[0];

      while (obj.offsetParent && obj !== body) {
        x += obj.offsetParent.offsetLeft;
        y += obj.offsetParent.offsetTop;
        obj = obj.offsetParent;
      }

      return [x, y];
    };

    var globalOffset = divGlobalOffset(target);
    var x = posx - globalOffset[0];
    var y = posy - globalOffset[1];
    return {
      x: x,
      y: y
    };
  }
};


"use strict";

var Bim = {
  VERSION: "1.0.0",
  DEBUG: false,
  Colors: {
    faceDefault: 0xDDDDDD,
    faceSelected: 0x0058e7,
    edgeDefault: 0x000000,
    onXY: 0x0000ff,
    onYZ: 0xff0000,
    onZX: 0x00ff00,
    onNone: 0xF529F5,
    guideline: 0x999999
  },
  Constant: {
    circleSegments: 25,
    hexagonSegments: 6,
    edgesThresholdAngle: 360 / 20,
    // maximum segments is circleSegments,
    snapSize: 3,
    snapperSize: 1,
    ratioToKeepSize: 0.005,
    crossRectSize: 50
  },
  SnapFlag: {
    // snap result flag
    none: 0,
    onFace: 1,
    onEdgeVt: 2,
    onEndVt: 3,
    onMidVt: 4,
    onCenterVt: 5,
    fromPointOnRed: 6,
    fromPointOnBlue: 7,
    fromPointOnGreen: 8,
    onRedAxis: 9,
    onBlueAxis: 10,
    onGreenAxis: 11,
    redAxis: 12,
    blueAxis: 13,
    greenAxis: 14,
    origin: 15
  },
  SnapStickerString: {
    1: "On Face",
    2: "On Edge",
    3: "Endpoint",
    4: "Midpoint",
    5: "Centerpoint",
    6: "From Point",
    7: "From Point",
    8: "From Point",
    9: "On Red Axis",
    10: "On Blue Axis",
    11: "On Green Axis",
    12: "Red Axis",
    13: "Blue Axis",
    14: "Green Axis",
    15: "Origin"
  },
  PlaneFlag: {
    // on-plane flag
    noPlane: -1,
    none: 0,
    onXY: 1,
    onYZ: 2,
    onZX: 3,
    onPararrelXY: 4,
    onPararrelYZ: 5,
    onPararrelZX: 6
  },
  Coords: {
    // coordinates system
    org: new THREE.Vector3(0, 0, 0),
    xaxis: new THREE.Vector3(1, 0, 0),
    yaxis: new THREE.Vector3(0, 1, 0),
    zaxis: new THREE.Vector3(0, 0, 1)
  },
  TempAxisType: {
    first: 'last',
    second: 'interest'
  },
  Units: ['inch', 'm', 'cm', 'mm', 'ft', 'km', 'mile'],
  Plan3dRatio: 0.7,
  FontPathPrefix: "../assets/three-fonts/",
  AxisLimit: 1e6
};


"use strict";

/**
 * @param viewer {BimViewer}
 * @param data {BimData}
 */
function BimObjectMover(viewer, data) {
  this.data = data;
  this.entities = [];
  this.stopped = false;
  var raycaster = new THREE.Raycaster();
  raycaster.camera = viewer.camera;
  var self = this;
  var curModel = undefined;
  var downPos = undefined;
  var snapPlane = new THREE.Plane(Bim.Coords.zaxis);
  var attachedMesh = undefined;
  var movable = true;
  data.getModels().forEach(function (model) {
    return self.entities.push(model.mesh);
  });

  this.start = function () {
    this.stopped = false;
    viewer.canvas.addEventListener("pointerdown", mouseDown, false);
    viewer.canvas.addEventListener('pointermove', mouseMove, false);
    viewer.canvas.addEventListener("pointerup", mouseUp, false);
  };

  this.stop = function () {
    this.stopped = true;
    viewer.canvas.removeEventListener("pointerdown", mouseDown, false);
    viewer.canvas.removeEventListener('pointermove', mouseMove, false);
    viewer.canvas.removeEventListener("pointerup", mouseUp, false);
  };

  this.destroy = function () {
    this.stop();
    this.data = undefined;
    this.entities = undefined;
    raycaster = undefined;
    snapPlane = undefined;
  };

  function mouseDown(event) {
    if (event.which !== 1 || !movable) return;
    var pos = BimUtils.getEventPosition(event);
    setRaycaster(pos.x, pos.y);
    var intersections = raycaster.intersectObjects(self.entities, true);

    if (intersections && intersections.length && intersections[0].object && intersections[0].object.parent) {
      curModel = self.data.getModelByMesh(intersections[0].object.parent);

      if (curModel) {
        curModel.setSelected(true);
        viewer.setDirty(true);
        viewer.cameraCtrl.pause();
        downPos = new THREE.Vector3(0, 0, 0);
        viewer.canvas.setPointerCapture(event.pointerId);

        if (!raycaster.ray.intersectPlane(snapPlane, downPos)) {
          downPos = undefined;
        }
      }
    }
  }

  function mouseMove(event) {
    if (!curModel || !downPos || !movable) return;
    var pos = BimUtils.getEventPosition(event);
    setRaycaster(pos.x, pos.y);
    var movePos = new THREE.Vector3();

    if (raycaster.ray.intersectPlane(snapPlane, movePos)) {
      curModel.mesh.position.add(movePos.clone().sub(downPos));
      viewer.setDirty(true);
      downPos.copy(movePos);
    }
  }

  function mouseUp(event) {
    if (curModel) {
      curModel.setSelected(false);
      viewer.canvas.releasePointerCapture(event.pointerId);
      viewer.cameraCtrl.resume();
      viewer.setDirty(true);

      if (attachedMesh !== curModel.mesh) {
        var bbox = new THREE.Box3();
        bbox.setFromObject(curModel.mesh);
        var center = new THREE.Vector3(0, 0, 0);
        center = bbox.getCenter(center);
        center.sub(curModel.mesh.position);
        attachedMesh = curModel.mesh;
      } else {
        attachedMesh = undefined;
      }

      viewer.signaler.modelMoved.dispatch(curModel);
      curModel = undefined;
    }

    downPos = undefined;
  }

  function setRaycaster(x, y) {
    var rect = viewer.canvas.getBoundingClientRect();
    x -= rect.left;
    y -= rect.top;
    var camera = viewer.camera;
    var vector = new THREE.Vector3(x / viewer.width * 2 - 1, -(y / viewer.height) * 2 + 1, 0.5);
    vector.unproject(camera);
    raycaster.set(viewer.camera.position, vector.sub(camera.position).normalize());
  }

  this.start();
}


"use strict";

/**
 * @param viewer {BimViewer}
 * @param data {BimData}
 */
function BimObjectPicker(viewer, data) {
  this.viewer = viewer;
  this.data = data;
  this.stopped = false;
  this.paused = false;
  this.xDown = 0;
  this.yDown = 0;
  this.isDblClick = false;
  var raycaster = new THREE.Raycaster();
  raycaster.camera = viewer.camera;
  var self = this;

  this.start = function () {
    this.stopped = false;
    this.viewer.canvas.addEventListener("pointerdown", mouseDown, false);
    this.viewer.canvas.addEventListener("pointerup", mouseUp, false);
    this.viewer.canvas.addEventListener("dblclick", dblClick, false);
    document.addEventListener("contextmenu", contextMenu, false);
  };

  this.stop = function () {
    this.stopped = true;
    this.viewer.canvas.removeEventListener("pointerdown", mouseDown, false);
    this.viewer.canvas.removeEventListener("pointerup", mouseUp, false);
    this.viewer.canvas.removeEventListener("dblclick", dblClick, false);
    document.removeEventListener("contextmenu", contextMenu, false);
  };

  this.pause = function () {
    this.paused = true;
  };

  this.resume = function () {
    this.paused = false;
  };

  function mouseDown(event) {
    if (self.paused) return;

    if ((isLeftMouseButton(event) || isRightMouseButton(event)) && !event.shiftKey) {
      var pos = BimUtils.getEventPosition(event);
      self.xDown = pos.x;
      self.yDown = pos.y;
    }

    self.isDblClick = false;
  }

  function mouseUp(event) {
    if (self.paused) {
      self.xDown = 0;
      self.yDown = 0;
      self.isDblClick = false;
      return;
    }

    if (isLeftMouseButton(event) && !event.shiftKey) {
      event.preventDefault();
      var pos = BimUtils.getEventPosition(event);
      var dx = self.xDown - pos.x;
      var dy = self.yDown - pos.y;
      var TOL = 5;

      if (Math.abs(dx) < TOL && Math.abs(dy) < TOL) {
        pickObject(pos.x, pos.y, event.ctrlKey);
      }
    } else if (isRightMouseButton(event)) {
      event.preventDefault();

      var _pos = BimUtils.getEventPosition(event);

      var objects = self.data.getSelectedObjects();

      if (objects && objects.length > 0) {
        picObjectByRight(_pos.x, _pos.y);
      }
    }
  }

  function dblClick(event) {
    if (self.paused) return;

    if (isLeftMouseButton(event) && !event.shiftKey) {
      event.preventDefault();
      var pos = BimUtils.getEventPosition(event);
      var dx = self.xDown - pos.x;
      var dy = self.yDown - pos.y;
      var TOL = 5;

      if (Math.abs(dx) < TOL && Math.abs(dy) < TOL) {
        self.isDblClick = true;
        pickObject(pos.x, pos.y, event.ctrlKey);
      }
    }
  }

  function contextMenu(event) {
    if (self.paused) return;
    event.preventDefault();
  }

  function pickObject(x, y, isCtrlKey) {
    var intersects = getIntersections(x, y);

    for (var i = 0; i < intersects.length; i++) {
      var mesh = intersects[i].object;

      if (mesh.userData.type === 'plan-marker' && mesh.visible) {
        var plan = self.data.getPlanByMarker(mesh);
        self.viewer.signaler.requestShowPlan.dispatch(plan);
        return;
      }
    }

    for (var _i = 0; _i < intersects.length; _i++) {
      var _mesh = intersects[_i].object;

      if (_mesh.userData.type === 'plan' && _mesh.visible) {
        var _plan = self.data.getPlanByMesh(_mesh);

        if (_plan !== undefined) {
          if (_plan.completed) {
            _plan.showControl();
          } else {
            self.viewer.signaler.planTransformReady.dispatch(_plan, {
              x: x,
              y: y
            });
          }

          return;
        }
      }
    }

    for (var idx = 0; idx < intersects.length; idx++) {
      console.log("in pick i valuse is " + idx);
      var _mesh2 = intersects[idx].object;

      if (_mesh2.parent) {
        var model = self.data.getModelByMesh(_mesh2.parent);

        if (model) {
          // bimObject
          var bimObject = model.getBimObject(_mesh2);

          if (bimObject && bimObject.isVisible) {
            if (self.isDblClick) {
              if (!isCtrlKey) {
                self.data.clearSelection();
              }

              self.data.setObjectSelected(bimObject, true, intersects[idx].faceIndex);
              self.viewer.signaler.objectDblClicked.dispatch(bimObject, self.data.getSelectedObjects(), {
                x: x,
                y: y
              });
              self.viewer.setDirty(true);
            } else {
              if (self.data.faceMode === undefined || self.data.faceMode === "pershape") {
                if (!isCtrlKey && !bimObject.isSelected) {
                  self.data.clearSelection();
                }
              } else {
                if (!isCtrlKey && (!bimObject.isSelected || intersects[idx].faceIndex !== bimObject.faceIndex)) {
                  self.data.clearSelection();
                }
              }

              self.data.setObjectSelected(bimObject, !bimObject.isSelected, intersects[idx].faceIndex);
              var objects = self.data.getSelectedObjects();
              self.viewer.signaler.objectSelected.dispatch(bimObject, objects);
              self.viewer.setDirty(true);
            }

            break;
          }
        }
      }
    }
  }

  function picObjectByRight(x, y) {
    var intersects = getIntersections(x, y);

    for (var i = 0; i < intersects.length; i++) {
      var mesh = intersects[i].object;

      if (mesh.userData.type === 'plan-marker' && mesh.visible) {
        return;
      }
    }

    for (var _i2 = 0; _i2 < intersects.length; _i2++) {
      var _mesh3 = intersects[_i2].object;

      if (_mesh3.userData.type === 'plan' && _mesh3.visible) {
        return;
      }
    }

    for (var _i3 = 0; _i3 < intersects.length; _i3++) {
      var _mesh4 = intersects[_i3].object;

      if (_mesh4.parent) {
        var model = self.data.getModelByMesh(_mesh4.parent);

        if (model) {
          // bimObject
          var bimObject = model.getBimObject(_mesh4);

          if (bimObject && bimObject.isVisible) {
            if (bimObject.isSelected) {
              var objects = self.data.getSelectedObjects();
              self.viewer.signaler.showContextMenu.dispatch(bimObject, objects, {
                x: x,
                y: y
              });
            }

            return;
          }
        }
      }
    }
  }

  function getIntersections(x, y) {
    var camera = self.viewer.camera;
    var vector = new THREE.Vector3(x / self.viewer.width * 2 - 1, -(y / self.viewer.height) * 2 + 1, 0.5);
    vector.unproject(camera);
    raycaster.set(viewer.camera.position, vector.sub(camera.position).normalize());
    raycaster.near = self.viewer.camera.near;
    raycaster.far = self.viewer.camera.far;
    return raycaster.intersectObjects(self.viewer.entities, true);
  }

  function isLeftMouseButton(event) {
    return event.which === 1;
  }

  function isRightMouseButton(event) {
    return event.which === 3;
  }

  this.start();
}


"use strict";

function BimSignaler(container) {
  var Signal = signals.Signal; // signals

  this.objectAdded = new Signal();
  this.objectRemoved = new Signal();
  this.objectSelected = new Signal();
  this.objectDblClicked = new Signal();
  this.showContextMenu = new Signal();
  this.cameraControlChanged = new Signal();
  this.cameraZoomChanged = new Signal();
  this.updateStatusData = new Signal();
  this.releaseCmd = new Signal();
  this.thumbnailReady = new Signal();
  this.planAdded = new Signal();
  this.planRemoved = new Signal();
  this.planTransformReady = new Signal();
  this.requestShowPlan = new Signal();
  this.textSelected = new Signal();
  this.textDeselected = new Signal();
  this.markerPlaced = new Signal();
  this.markerRemoved = new Signal();
  this.clippingAdded = new Signal();
  this.toolActivated = new Signal();
  this.modelMoved = new Signal();
  this.keyStatus = undefined; // event

  var self = this;

  this.clear = function () {
    this.objectAdded.removeAll();
    this.objectRemoved.removeAll();
    this.objectSelected.removeAll();
    this.objectDblClicked.removeAll();
    this.showContextMenu.removeAll();
    this.cameraControlChanged.removeAll();
    this.cameraZoomChanged.removeAll();
    this.updateStatusData.removeAll();
    this.releaseCmd.removeAll();
    this.thumbnailReady.removeAll();
    this.planAdded.removeAll();
    this.planRemoved.removeAll();
    this.planTransformReady.removeAll();
    this.requestShowPlan.removeAll();
    this.textSelected.removeAll();
    this.textDeselected.removeAll();
    this.markerPlaced.removeAll();
    this.markerRemoved.removeAll();
  };

  this.onKeyDown = function (e) {
    var command = container ? container.curCmd : undefined;
    if (!e.key) return;
    var key = e.key.toLowerCase();

    if (e.shiftKey) {
      // Shift
      self.keyStatus = 'shortcut:shift';
    } else if (e.ctrlKey) {
      // Ctrl
      self.keyStatus = 'shortcut:ctrl';
    } else if (key === 'escape' || key === 'esc' || e.keyCode === 27) {} else if (e.ctrlKey && e.shiftKey && e.keyCode === 90) {// Ctrl + Shift + Z
    } else if (e.ctrlKey && e.altKey && e.keyCode === 67) {//Ctrl + alt + C
    } else if (e.ctrlKey && e.keyCode === 67) {//Ctrl + C
    } else if (e.ctrlKey && e.keyCode === 86) {//Ctrl + V
    } else if (e.ctrlKey && e.keyCode === 90) {//Ctrl + Z
    } else if (e.ctrlKey && e.keyCode === 73) {// Ctrl + I
    } else if (e.ctrlKey && e.keyCode === 77) {// Ctrl + M
    } else if (e.keyCode === 46) {//delete
    } else if (e.keyCode === 32) {// spacebar
    }

    if (command && command.onKeyDown) command.onKeyDown(e);
  };

  this.onKeyUp = function (event) {
    var command = container ? container.curCmd : undefined;
    if (command && command.onKeyUp) command.onKeyUp(event);
    self.keyStatus = undefined;
  };

  this.start = function () {
    document.addEventListener('keydown', this.onKeyDown, false);
    document.addEventListener('keyup', this.onKeyUp, false);
  };

  this.stop = function () {
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('keyup', this.onKeyUp);
  };
}


"use strict";

function BimData() {
  this.models = [];
  this.plans = [];
  this.faceMode = undefined;
  /**
   * add Bim Model
   * @param model {BimModel}
   */

  this.addModel = function (model) {
    this.models.push(model);
  };

  this.removeLastModel = function () {
    return this.models.pop();
  };

  this.getModels = function () {
    return this.models;
  };

  this.isModelFull = function () {
    return this.models.length > 1;
  };

  this.getModelByMesh = function (_mesh) {
    for (var i = 0; i < this.models.length; i++) {
      var mesh = this.models[i].mesh;

      if (mesh === _mesh) {
        return this.models[i];
      }
    }

    return undefined;
  }; // plan functions

  /**
   * add bim plan
   * @param plan {BimPlan}
   */


  this.addPlan = function (plan) {
    this.plans.push(plan);
  };
  /**
   * remove bim plan
   * @param plan {BimPlan}
   */


  this.removePlan = function (plan) {
    var index = this.plans.indexOf(plan);

    if (0 <= index) {
      this.plans.splice(index, 1);
    }
  };

  this.firstPlan = function () {
    return this.plans[0];
  };

  this.getPlanByMesh = function (_mesh) {
    for (var i = 0; i < this.plans.length; i++) {
      var mesh = this.plans[i].mesh;

      if (mesh === _mesh) {
        return this.plans[i];
      }
    }

    return undefined;
  };

  this.getPlanByMarker = function (_marker) {
    for (var i = 0; i < this.plans.length; i++) {
      var mesh = this.plans[i].marker;

      if (mesh === _marker) {
        return this.plans[i];
      }
    }

    return undefined;
  };
  /**
   * set visibility to all plans
   * @param visible {Boolean}
   */


  this.setPlansVisible = function (visible) {
    for (var i = 0; i < this.plans.length; i++) {
      this.plans[i].setVisibleForce(visible);
    }
  }; // Selection Functions


  this.setObjectSelected = function (bimObject, isSelected, faceIndex) {
    if (!bimObject.isVisible) {
      return;
    }

    bimObject.setSelected(isSelected, faceIndex);
  };

  this.setObjectsSelected = function (bimObjects, isSelected) {
    if (bimObjects.length === 0) return;

    for (var i = 0; i < bimObjects.length; i++) {
      if (!bimObjects[i].isVisible) {
        continue;
      }

      bimObjects[i].setSelected(isSelected);
    }
  };

  this.clearSelection = function () {
    for (var i = 0; i < this.models.length; i++) {
      this.models[i].clearSelection();
    }
  };

  this.getSelectedObject = function () {
    if (this.models.length > 0) {
      var bimObjects = this.models[0].getBimObjects();
      return bimObjects.length > 0 ? bimObjects[0] : undefined;
    }

    return undefined;
  };

  this.getSelectedObjects = function () {
    var selectedObjects = [];

    for (var i = 0; i < this.models.length; i++) {
      var bimObjects = this.models[i].getBimObjects();

      for (var j = 0; j < bimObjects.length; j++) {
        if (bimObjects[j].isSelected) selectedObjects.push(bimObjects[j]);
      }
    }

    return selectedObjects;
  }; // Quality Function


  this.setQuality = function (quality) {
    for (var i = 0; i < this.models.length; i++) {
      this.models[i].setQuality(quality);
    }
  };

  this.setColorMode = function (colorMode) {
    for (var i = 0; i < this.models.length; i++) {
      this.models[i].setColorMode(colorMode);
    }
  };

  this.setSelectMode = function (faceMode) {
    this.faceMode = faceMode;

    for (var i = 0; i < this.models.length; i++) {
      this.models[i].setSelectMode(faceMode);
    }
  };

  this.getCalculationData = function (sections) {
    var model = this.models[0];

    if (model === undefined) {
      return undefined;
    }

    return model.getCalculationData(sections);
  };

  this.getModelsPosition = function () {
    var data = [];

    for (var i = 0; i < this.models.length; i++) {
      var model = this.models[i];
      var pos = model.mesh.position;
      data.push({
        _id: model.id,
        position: {
          x: pos.x,
          y: pos.y,
          z: pos.z
        }
      });
    }

    return data;
  };
}


"use strict";

function BimModel() {
  this.id = undefined; // bim model id

  this.tree = {}; // structure tree

  this.idMap = {}; // [ID : ITEM]

  this.typeMap = {}; // [type: ITEM]

  this.guidMap = {}; // [GUID: ITEM]

  this.objectMap = {}; // [ID: ITEM] has only BimObject

  this.objects = []; // [BimObject]

  this.floors = []; // floor list

  this.name = '';
  this.mesh = undefined;
  var self = this;

  this.load = function (id, name, data) {
    this.id = id;
    this.name = name;
    this.floors = [];
    this.tree = makeTree(data);
    this.treeData = [this.tree];
    arrangeFloors();
    return this;
  };

  this.toggleItemVisible = function (item) {
    setItemVisible(item, !item.visible);
  };

  this.toggleItemSelected = function (item) {
    setItemSelected(item, !item.selected);
  };

  this.setItemColor = function (item, color) {
    setItemColor(item, color);
  };

  this.setItemVisible = function (item, visible) {
    setItemVisible(item, visible);
  };

  this.setAllItemVisible = function (visible) {
    setItemVisible(this.tree, visible);
  };

  this.setItemVisibleOnly = function (item) {
    setItemVisible(this.tree, false);
    setItemVisible(item, true);
  };

  this.setBimObjectsVisible = function (bimObjects, visible) {
    if (!bimObjects) return;
    bimObjects.forEach(function (obj) {
      var item = self.getItem(obj.id);

      if (item) {
        setItemVisible(item, visible);
      }
    });
  };

  this.setItemSelectedById = function (id) {
    var item = this.getItem(id);

    if (item) {
      setItemSelected(item, true);
    }
  };

  this.setSelected = function (selected) {
    this.objects.forEach(function (object) {
      return object.setSelected(selected);
    });
  };

  this.getItem = function (id) {
    return id !== undefined ? this.idMap[id] : undefined;
  };

  this.getItemByGuid = function (guid) {
    return guid ? this.guidMap[guid] : undefined;
  };

  this.getBimObjects = function () {
    return this.objects;
  };

  this.getBimObjectsFrom = function (item) {
    var objects = [];
    getBimObjects(item, objects);
    return objects;
  };

  this.addBimObject = function (ID, bimObject) {
    if (bimObject === undefined) return;
    var item = this.idMap[ID];

    if (item) {
      item.object = bimObject;
      bimObject.id = item.id;
      bimObject.type = item.type;
      bimObject.guid = item.guid;
      bimObject.name = item.name;
      bimObject.description = item.description;
      bimObject.workLevel = item.workLevel;
    }

    this.objects.push(bimObject);
  };

  this.getBimObject = function (mesh) {
    for (var i = 0; i < this.objects.length; i++) {
      if (this.objects[i].mesh === mesh) {
        return this.objects[i];
      }
    }

    return undefined;
  };

  this.getBoundingBox = function () {
    return getBoundingBox(this.objects);
  };

  this.getFloorBoundingBox = function (floor) {
    return getBoundingBox(this.getBimObjectsFrom(floor));
  };

  this.clearSelection = function () {
    for (var i = 0; i < this.objects.length; i++) {
      var bimObject = this.objects[i];

      if (bimObject.isSelected) {
        bimObject.setSelected(false);
      }
    }
  };

  this.cloneMesh = function () {
    if (!this.mesh) {
      return undefined;
    }

    var mesh = new THREE.Group();

    for (var i = 0; i < this.objects.length; i++) {
      var bimObject = this.objects[i];
      mesh.add(bimObject.cloneMesh());
    }

    return mesh;
  };

  this.setInventoryData = function (inventoryData) {
    if (this.idMap === undefined) return;

    for (var i = 0; i < inventoryData.length; i++) {
      var info = inventoryData[i];
      var item = this.idMap[info.id];

      if (item !== undefined && item.object !== undefined) {
        item.object.setInventoryData(info);
      }
    }
  };

  this.getInventoryData = function () {
    var data = [];

    for (var i = 0; i < this.objects.length; i++) {
      if (this.objects[i]) {
        var inventory = this.objects[i].getInventory();

        if (inventory) {
          data.push(inventory);
        }
      }
    }

    return data;
  };

  this.setQuality = function (quality) {
    for (var i = 0; i < this.objects.length; i++) {
      this.objects[i].setQuality(quality);
    }
  };

  this.setColorMode = function (colorMode) {
    for (var i = 0; i < this.objects.length; i++) {
      this.objects[i].setColorMode(colorMode);
    }
  };

  this.setSelectMode = function (faceMode) {
    for (var i = 0; i < this.objects.length; i++) {
      this.objects[i].setSelectMode(faceMode);
    }
  };

  this.makeTransparent = function (opacity) {
    for (var i = 0; i < this.objects.length; i++) {
      this.objects[i].makeTransparent(opacity);
    }
  };

  this.getCalculationData = function (sections) {
    var _this = this;

    var calcData = [];
    var sectionMap = {};
    var find = sections.find(function (s) {
      return s.modelId && s.modelId === _this.id;
    });
    var modelSection = find ? find._id : 'new';

    for (var i = 0; i < this.objects.length; i++) {
      var object = this.objects[i];
      if (!object) continue;
      var calculationData = object.getCalculationData();
      if (!calculationData) continue;
      calculationData.modelId = this.id;
      var section = calculationData.section ? calculationData.section : modelSection;
      var workLevel = calculationData.workLevel;
      var group = sectionMap[section];

      if (!group) {
        group = {
          _id: section,
          levelMap: {}
        };
        sectionMap[section] = group;
      }

      var levelMap = group.levelMap;
      var level = levelMap[workLevel];

      if (!level) {
        level = {
          modelId: this.id,
          modelType: '3d',
          name: workLevel,
          children: []
        };
        levelMap[workLevel] = level;
      }

      level.children.push(calculationData);
    }

    for (var sectionId in sectionMap) {
      var _group = sectionMap[sectionId];

      if (_group) {
        var levels = [];

        for (var levelId in _group.levelMap) {
          var _level = _group.levelMap[levelId];

          if (_level) {
            levels.push(_level);
          }
        }

        calcData.push({
          _id: _group._id,
          modelId: this.id,
          modelType: '3d',
          levels: levels
        });
      }
    }

    return calcData.length === 0 ? undefined : calcData;
  };

  this.rebuildTree = function () {
    return rebuildTree(this.tree);
  };

  this.getWorkLevels = function () {
    var levels = [];
    this.floors.forEach(function (floor) {
      return levels.push({
        name: floor.workLevel
      });
    });
    return levels;
  };

  this.getPosition = function () {
    if (this.mesh) {
      var position = this.mesh.position;
      return {
        x: position.x,
        y: position.y,
        z: position.z,
        angle: this.mesh.rotation.z * 180 / Math.PI
      };
    } else {
      return undefined;
    }
  };

  this.updatePosition = function (position) {
    if (this.mesh) {
      this.mesh.position.set(position.x, position.y, position.z);
      this.mesh.rotation.set(0, 0, position.angle * Math.PI / 180);
    }
  };

  function makeTree(item) {
    var tree = {
      type: item.type,
      id: item.stepnr,
      guid: item.guid,
      name: item.name ? item.name : item.type,
      description: item.description,
      object: undefined,
      color: '#ffffff',
      parent: undefined,
      visible: true,
      selected: false
    };

    if (item.children && item.children.length > 0) {
      tree.children = [];

      for (var i = 0; i < item.children.length; i++) {
        var treeItem = makeTree(item.children[i]);
        treeItem.parent = tree;
        tree.children.push(treeItem);
      }
    }

    self.idMap[tree.id] = tree;
    self.guidMap[tree.guid] = tree;

    if (tree.type !== "IfcSpace" && (!tree.children || tree.children.length === 0)) {
      self.objectMap[tree.id] = tree;

      if (!self.typeMap[tree.type]) {
        self.typeMap[tree.type] = {
          name: tree.type,
          visible: true,
          children: []
        };
      }

      self.typeMap[tree.type].children.push(tree);
    }

    if (tree.type === 'IfcBuildingStorey') {
      tree.workLevel = item.workLevel;
      self.floors.push(tree);
    }

    return tree;
  }

  function arrangeFloors() {
    var _loop = function _loop(i) {
      if (!self.floors[i].workLevel) {
        if (i === 0) {
          self.floors[i].workLevel = 'Roof';
        } else if (i === self.floors.length - 1) {
          self.floors[i].workLevel = 'Ground';
        } else {
          self.floors[i].workLevel = (self.floors.length - i).toString();
        }
      }

      if (self.floors[i].children && self.floors[i].children.length) {
        self.floors[i].children.forEach(function (child) {
          setWorkLevel(child, self.floors[i].workLevel);
        });
      }
    };

    for (var i = 0; i < self.floors.length; i++) {
      _loop(i);
    }
  }

  function rebuildTree(item) {
    var tree = {
      type: item.type,
      stepnr: item.id,
      guid: item.guid,
      name: item.name,
      description: item.object ? item.object.description : item.description
    };

    if (item.type === 'IfcBuildingStorey') {
      tree.workLevel = item.workLevel;
    }

    if (item.children && item.children.length > 0) {
      tree.children = [];

      for (var i = 0; i < item.children.length; i++) {
        tree.children.push(rebuildTree(item.children[i]));
      }
    }

    return tree;
  }

  function setItemVisible(item, visible) {
    item.visible = visible;

    if (item.children) {
      for (var i = 0; i < item.children.length; i++) {
        setItemVisible(item.children[i], visible);
      }
    } else {
      if (item.object) {
        item.object.setVisible(visible);
      }
    }
  }

  function setItemColor(item, color) {
    item.color = color;

    if (item.children) {
      for (var i = 0; i < item.children.length; i++) {
        setItemColor(item.children[i], color);
      }
    } else {
      if (item.object) {
        item.object.setColor(color);
      }
    }
  }

  function setItemSelected(item, selected) {
    item.selected = selected;

    if (item.children) {
      for (var i = 0; i < item.children.length; i++) {
        setItemSelected(item.children[i], selected);
      }
    } else {
      if (item.object) {
        item.object.setSelected(selected);
      }
    }
  }

  function getBimObjects(item, objects) {
    if (item.children) {
      for (var i = 0; i < item.children.length; i++) {
        getBimObjects(item.children[i], objects);
      }
    }

    if (item.object) {
      objects.push(item.object);
    }
  }

  function setWorkLevel(item, workLevel) {
    if (item.children && item.children.length) {
      item.children.forEach(function (child) {
        setWorkLevel(child, workLevel);
      });
    }

    item.workLevel = workLevel;
  }

  function getBoundingBox(objects) {
    var bbox = undefined;

    for (var i = 0; i < objects.length; i++) {
      var bimObject = objects[i];
      var box = bimObject.getBoundingBox();

      if (box) {
        if (bbox) {
          bbox = bbox.union(box);
        } else {
          bbox = box.clone();
        }
      }
    }

    return bbox;
  }
}


"use strict";

function BimObject() {
  this.id = undefined;
  this.name = undefined;
  this.guid = undefined;
  this.type = undefined;
  this.description = undefined;
  this.workLevel = undefined; // work level

  this.inventoryInfo = undefined; //inventory data

  this.mesh = undefined; // mesh

  this.faceIndex = undefined;
  this.isSelected = false;
  this.isVisible = true;
  this.colorMode = 'normal';
  this.color = undefined;
  this.opacity = undefined;
  this.defaultInventoryColor = {
    color: '#464646',
    opacity: 0.3
  };
  this.colorOriginal = undefined;
  this.materialTrans = undefined;
  this.materialOpaque = undefined;
  var self = this;
  var SELECTION_COLOR = '#6464ff';
  var EDGE_COLOR = new THREE.Color(0, 0, 0);

  this.clone = function (quality) {
    var newObject = new BimObject();
    newObject.id = this.id;
    newObject.name = this.name;
    newObject.guid = this.guid;
    newObject.type = this.type;
    newObject.description = this.description;
    newObject.inventoryInfo = this.inventoryInfo;
    newObject.defaultInventoryColor = {
      color: this.defaultInventoryColor.color,
      opacity: this.defaultInventoryColor.opacity
    };
    newObject.mesh = this.cloneMesh(quality);
    newObject.colorOriginal = this.colorOriginal;
    newObject.materialTrans = this.materialTrans;
    newObject.materialOpaque = this.materialOpaque;
    return newObject;
  };

  this.setVisible = function (isVisible) {
    if (this.isVisible === isVisible) return false;

    if (this.mesh) {
      this.mesh.visible = isVisible;
    }

    this.isVisible = isVisible;
    return true;
  };

  this.setSelected = function (isSelected, faceIndex) {
    if (isSelected === this.isSelected) return;
    this.isSelected = isSelected;
    this.faceIndex = faceIndex;
    updateMaterialColor();
  };

  this.setColor = function (color) {
    this.color = color;
    updateMaterialColor();
  };

  this.cloneMesh = function (quality) {
    if (this.mesh === undefined) {
      return undefined;
    }

    var material = quality ? cloneMaterialWithQuality(this.mesh.material, quality, true) : cloneMaterial(this.mesh.material);
    var newMesh = new THREE.Mesh(this.mesh.geometry.clone(), material);
    var colors = newMesh.geometry.getAttribute('color');

    for (var idx = 0; idx < self.colorOriginal.length; idx++) {
      var originalColor = self.colorOriginal[idx];

      for (var i = newMesh.geometry.groups[idx].start; i < newMesh.geometry.groups[idx].start + newMesh.geometry.groups[idx].count; i++) {
        colors.array[4 * i] = originalColor[0];
        colors.array[4 * i + 1] = originalColor[1];
        colors.array[4 * i + 2] = originalColor[2];
        colors.array[4 * i + 3] = originalColor[3];
      }
    }

    newMesh.geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors.array, 4));

    if (quality) {
      // if (quality === 'high') {
      // newMesh.castShadow = true;
      // newMesh.receiveShadow = true;
      // }
      changeEdge(newMesh);
    } else {
      var edges = cloneEdge(this.mesh);

      if (edges) {
        newMesh.userData.edges = edges;
        newMesh.add(edges);
      }
    }

    return newMesh;
  };

  this.getBoundingBox = function () {
    if (this.mesh) {
      var matrix = this.mesh.matrixWorld;
      var bbox = this.mesh.geometry.boundingBox.clone();
      bbox.applyMatrix4(matrix);
      return bbox;
    }

    return undefined;
  };

  this.getGeometricalFaceInfo = function (ignoreFace) {
    if (!this.mesh) {
      return {};
    }

    if (!ignoreFace && this.faceMode === "perface") {
      var selIdx = 0;

      for (var i = 0; i < this.mesh.geometry.groups.length; i++) {
        if (self.faceIndex * 3 >= this.mesh.geometry.groups[i].start && self.faceIndex * 3 < this.mesh.geometry.groups[i].start + this.mesh.geometry.groups[i].count) {
          selIdx = i;
          break;
        }
      }

      var geometry = this.mesh.geometry;
      var positions = geometry.attributes.position.array;
      var normals = geometry.attributes.normal.array;
      var points = [];

      for (var _i = 0; 3 * (_i + 1) <= positions.length; _i++) {
        points.push(new THREE.Vector3(positions[3 * _i], positions[3 * _i + 1], positions[3 * _i + 2]));
      }

      var indexes = geometry.index.array.slice(geometry.groups[selIdx].start, geometry.groups[selIdx].start + geometry.groups[selIdx].count);
      var triangles = [];

      for (var _i2 = 0; 3 * (_i2 + 1) <= indexes.length; _i2++) {
        var triangle = {
          a: new THREE.Vector3(0, 0, 0).subVectors(points[indexes[3 * _i2 + 1]], points[indexes[3 * _i2]]),
          b: new THREE.Vector3(0, 0, 0).subVectors(points[indexes[3 * _i2 + 2]], points[indexes[3 * _i2]])
        };
        triangle.crossProduct = new THREE.Vector3(0, 0, 0).crossVectors(triangle.a, triangle.b);
        triangles.push(triangle);
      }

      var faces = [];
      var faceIndexes = [];

      for (var j = 0; j < triangles.length; j++) {
        faces.push(triangles[j]);
        faceIndexes.push(j);
      } // get unique indexes


      var aIndexes = [];

      for (var k = 0; k < faceIndexes.length; k++) {
        if (aIndexes.indexOf(indexes[3 * faceIndexes[k]]) === -1) {
          aIndexes.push(indexes[3 * faceIndexes[k]]);
        }

        if (aIndexes.indexOf(indexes[3 * faceIndexes[k] + 1]) === -1) {
          aIndexes.push(indexes[3 * faceIndexes[k] + 1]);
        }

        if (aIndexes.indexOf(indexes[3 * faceIndexes[k] + 2]) === -1) {
          aIndexes.push(indexes[3 * faceIndexes[k] + 2]);
        }
      } // get width, height


      var minX = 0,
          minY = 0,
          minZ = 0,
          maxX = 0,
          maxY = 0,
          maxZ = 0;
      minX = maxX = points[aIndexes[0]].x;
      minY = maxY = points[aIndexes[0]].y;
      minZ = maxZ = points[aIndexes[0]].z;

      for (var _i3 = 1; _i3 < aIndexes.length; _i3++) {
        if (points[aIndexes[_i3]].x < minX) {
          minX = points[aIndexes[_i3]].x;
        } else if (points[aIndexes[_i3]].x > maxX) {
          maxX = points[aIndexes[_i3]].x;
        }

        if (points[aIndexes[_i3]].y < minY) {
          minY = points[aIndexes[_i3]].y;
        } else if (points[aIndexes[_i3]].y > maxY) {
          maxY = points[aIndexes[_i3]].y;
        }

        if (points[aIndexes[_i3]].z < minZ) {
          minZ = points[aIndexes[_i3]].z;
        } else if (points[aIndexes[_i3]].z > maxZ) {
          maxZ = points[aIndexes[_i3]].z;
        }
      }

      var values = [maxX - minX, maxY - minY, maxZ - minZ];
      var yAxis = new THREE.Vector3(0, 1, 0);
      var baseNormal = new THREE.Vector3(normals[3 * aIndexes[0]], normals[3 * aIndexes[0] + 1], normals[3 * aIndexes[0] + 2]);
      var cosAngle = baseNormal.dot(yAxis);

      if (Math.abs(cosAngle) > 0.99) {
        values = values.sort(function (a, b) {
          return b - a;
        });
      } else {
        var rotAxis = new THREE.Vector3(0, 0, 0).crossVectors(baseNormal, yAxis).normalize();
        var angle = Math.acos(cosAngle);
        var rotMat = new THREE.Matrix4().makeRotationAxis(rotAxis, angle);
        minX = Number.MAX_VALUE;
        minZ = Number.MAX_VALUE;
        maxX = -Number.MAX_VALUE;
        maxZ = -Number.MAX_VALUE;

        for (var _i4 = 0; _i4 < aIndexes.length; _i4++) {
          var r = points[aIndexes[_i4]].clone();

          r.applyMatrix4(rotMat);
          if (r.x < minX) minX = r.x;
          if (r.x > maxX) maxX = r.x;
          if (r.z < minZ) minZ = r.z;
          if (r.z > maxZ) maxZ = r.z;
        }

        values = [maxX - minX, maxZ - minZ];
        values = values.sort(function (a, b) {
          return b - a;
        });
      } // get area


      var area = 0;

      for (var _i5 = 0; _i5 < faces.length; _i5++) {
        area += new THREE.Vector3(0, 0, 0).crossVectors(faces[_i5].a, faces[_i5].b).length() / 2;
      }

      var bbox = geometry.boundingBox.clone();
      var matrix = this.mesh.matrixWorld;
      bbox.applyMatrix4(matrix);
      var midVec = bbox ? bbox.max.clone().add(bbox.min).multiplyScalar(0.5) : new THREE.Vector3();
      var size = new THREE.Vector3(0, 0, 0);
      size = bbox.getSize(size);
      var areaVolume = BimUtils.getAreaVolume(geometry);
      return {
        x: midVec.x,
        y: midVec.y,
        z: midVec.z,
        size: size,
        perimeter: (values[0] + values[1]) * 2,
        face: {
          width: values[0],
          height: values[1]
        },
        area: area,
        volume: areaVolume ? areaVolume.volume : 0
      };
    } else {
      var _geometry = this.mesh.geometry;
      var faceIndex = this.faceIndex;
      var _positions = _geometry.attributes.position.array;
      var _points = [];

      for (var _i6 = 0; 3 * (_i6 + 1) <= _positions.length; _i6++) {
        _points.push(new THREE.Vector3(_positions[3 * _i6], _positions[3 * _i6 + 1], _positions[3 * _i6 + 2]));
      }

      var _indexes = _geometry.index.array;
      var _triangles = [];

      for (var _i7 = 0; 3 * (_i7 + 1) <= _indexes.length; _i7++) {
        var _triangle = {
          a: new THREE.Vector3(0, 0, 0).subVectors(_points[_indexes[3 * _i7 + 1]], _points[_indexes[3 * _i7]]),
          b: new THREE.Vector3(0, 0, 0).subVectors(_points[_indexes[3 * _i7 + 2]], _points[_indexes[3 * _i7]])
        };
        _triangle.crossProduct = new THREE.Vector3(0, 0, 0).crossVectors(_triangle.a, _triangle.b);

        _triangles.push(_triangle);
      }

      var _faces = [];
      var _faceIndexes = [];

      for (var _j = 0; _j < _triangles.length; _j++) {
        if (faceIndex === undefined) {
          _faces.push(_triangles[_j]);

          _faceIndexes.push(_j);
        } else {
          var dotProduct = _triangles[faceIndex].crossProduct.normalize().dot(_triangles[_j].crossProduct.normalize());

          if (Math.round(dotProduct) === 1) {
            // only when dot product is 1 (normal vectors are parallel)
            _faces.push(_triangles[_j]);

            _faceIndexes.push(_j);
          }
        }
      } // get unique indexes


      var _aIndexes = [];

      for (var _k = 0; _k < _faceIndexes.length; _k++) {
        if (_aIndexes.indexOf(_indexes[3 * _faceIndexes[_k]]) === -1) {
          _aIndexes.push(_indexes[3 * _faceIndexes[_k]]);
        }

        if (_aIndexes.indexOf(_indexes[3 * _faceIndexes[_k] + 1]) === -1) {
          _aIndexes.push(_indexes[3 * _faceIndexes[_k] + 1]);
        }

        if (_aIndexes.indexOf(_indexes[3 * _faceIndexes[_k] + 2]) === -1) {
          _aIndexes.push(_indexes[3 * _faceIndexes[_k] + 2]);
        }
      } // get width, height


      var _minX = 0,
          _minY = 0,
          _minZ = 0,
          _maxX = 0,
          _maxY = 0,
          _maxZ = 0;
      _minX = _maxX = _points[_aIndexes[0]].x;
      _minY = _maxY = _points[_aIndexes[0]].y;
      _minZ = _maxZ = _points[_aIndexes[0]].z;

      for (var _i8 = 1; _i8 < _aIndexes.length; _i8++) {
        if (_points[_aIndexes[_i8]].x < _minX) {
          _minX = _points[_aIndexes[_i8]].x;
        } else if (_points[_aIndexes[_i8]].x > _maxX) {
          _maxX = _points[_aIndexes[_i8]].x;
        }

        if (_points[_aIndexes[_i8]].y < _minY) {
          _minY = _points[_aIndexes[_i8]].y;
        } else if (_points[_aIndexes[_i8]].y > _maxY) {
          _maxY = _points[_aIndexes[_i8]].y;
        }

        if (_points[_aIndexes[_i8]].z < _minZ) {
          _minZ = _points[_aIndexes[_i8]].z;
        } else if (_points[_aIndexes[_i8]].z > _maxZ) {
          _maxZ = _points[_aIndexes[_i8]].z;
        }
      }

      var _values = [_maxX - _minX, _maxY - _minY, _maxZ - _minZ];
      _values = _values.sort(function (a, b) {
        return b - a;
      }); // get area

      var _area = 0;

      for (var _i9 = 0; _i9 < _faces.length; _i9++) {
        _area += new THREE.Vector3(0, 0, 0).crossVectors(_faces[_i9].a, _faces[_i9].b).length() / 2;
      }

      var _bbox = _geometry.boundingBox.clone();

      var _matrix = this.mesh.matrixWorld;

      _bbox.applyMatrix4(_matrix);

      var _midVec = _bbox ? _bbox.max.clone().add(_bbox.min).multiplyScalar(0.5) : new THREE.Vector3();

      var _size = new THREE.Vector3(0, 0, 0);

      _size = _bbox.getSize(_size);

      var _areaVolume = BimUtils.getAreaVolume(_geometry);

      return {
        x: _midVec.x,
        y: _midVec.y,
        z: _midVec.z,
        size: _size,
        perimeter: (_size.x + _size.y + _size.z) * 4,
        face: {
          width: _values[0],
          height: _values[1]
        },
        area: _areaVolume ? _areaVolume.area : 0,
        volume: _areaVolume ? _areaVolume.volume : 0
      };
    }
  };

  this.getGeometricalInfo = function () {
    if (!this.mesh) {
      return {};
    }

    this.mesh.geometry.computeBoundingBox();
    var bbox = this.mesh.geometry.boundingBox.clone();
    var matrix = this.mesh.matrixWorld;
    bbox.applyMatrix4(matrix);
    var areaVolume = BimUtils.getAreaVolume(this.mesh.geometry);
    var size = new THREE.Vector3();
    size = bbox.getSize(size);
    var midVec = bbox ? bbox.max.clone().add(bbox.min).multiplyScalar(0.5) : new THREE.Vector3();
    return {
      x: midVec.x,
      y: midVec.y,
      z: midVec.z,
      size: size,
      area: areaVolume ? areaVolume.area : 0,
      volume: areaVolume ? areaVolume.volume : 0
    };
  };

  this.isIntersect = function (bimObject) {
    var box1 = new THREE.Box3().setFromObject(this.mesh);
    var box2 = new THREE.Box3().setFromObject(bimObject.mesh);
    return box1.intersectsBox(box2);
  };

  this.setQuality = function (quality) {
    changeMaterialQuality(this.mesh, quality);
    changeEdge(this.mesh, quality);
  };

  this.setColorMode = function (colorMode) {
    this.colorMode = colorMode;
    updateMaterialColor();
  };

  this.setSelectMode = function (faceMode) {
    this.faceMode = faceMode;
    updateFaceSelectionMode();
  };

  this.makeTransparent = function (opacity) {
    this.opacity = opacity;
    var mesh = self.mesh;
    if (!mesh) return;

    for (var i = 0; i < mesh.material.length; i++) {
      var material = mesh.material[i];
      material.opacity = opacity !== undefined && opacity < material.origin.opacity ? opacity : material.origin.opacity;
      material.transparent = material.opacity < 0.99;
      material.needsUpdate = true;
    }

    updateMaterialColor();
  };

  this.getInventory = function () {
    return this.inventoryInfo;
  };

  this.hasInventory = function () {
    return this.inventoryInfo && this.inventoryInfo.materials && this.inventoryInfo.materials.length;
  };
  /**
   * set inventory data to bimObject
   * @param inventoryObj
   */


  this.setInventoryData = function (inventoryObj) {
    this.inventoryInfo = inventoryObj;

    if (this.colorMode === 'inventory') {
      updateMaterialColor();
    }
  };

  this.getCalculationData = function () {
    if (!this.isVisible || this.inventoryInfo === undefined) return;
    if (!this.workLevel) return;
    return {
      objectId: this.id,
      objectType: "3d",
      name: this.name,
      type: this.type === "IfcColumn" ? "Cylinder" : "Box",
      slope: 0,
      penetration: {
        area: 0,
        perimeter: 0
      },
      materials: this.inventoryInfo.materials,
      equipments: this.inventoryInfo.equipments,
      dcps: this.inventoryInfo.dcps,
      dcqs: this.inventoryInfo.dcqs,
      workLevel: this.workLevel,
      section: this.inventoryInfo.section
    };
  };

  this.getMaterialColor = function () {
    var inventory = getInventoryItem(this.inventoryInfo);

    if (inventory) {
      var color = inventory.color;
      var opacity = inventory.opacity !== undefined ? inventory.opacity / 100 : 1;
      return {
        _id: inventory._id,
        name: inventory.name,
        color: ExtUtils.ha2rgba(color, opacity)
      };
    }

    return undefined;
  };

  this.getColorForPlan = function (bInventory, fIndex) {
    if (bInventory === true) {
      var inventory = getInventoryItem(this.inventoryInfo, fIndex);

      if (inventory && fIndex !== undefined && fIndex != null) {
        var color = inventory.color;
        var opacity = inventory.opacity !== undefined ? inventory.opacity / 100 : 1;
        return {
          _id: inventory._id,
          name: inventory.name,
          color: ExtUtils.ha2rgba(color, 255)
        };
      } else {
        return {
          _id: undefined,
          name: undefined,
          color: ExtUtils.ha2rgba('#464646', 255)
        };
      }
    } else {
      var col = new THREE.Color(this.shapes[0].color[0], this.shapes[0].color[1], this.shapes[0].color[2]);

      if (col.r > 0.7 && col.g > 0.7 && col.b > 0.7) {
        col.r = 0.7;
        col.g = 0.7;
        col.b = 0.7;
      }

      return {
        _id: undefined,
        name: undefined,
        color: ExtUtils.ha2rgba(col.getHexString(), 255)
      };
    }
  };

  function cloneMaterial(material) {
    if (Array.isArray(material)) {
      var newMats = [];

      for (var i = 0; i < material.length; i++) {
        var newMat = material[i].clone();
        newMat.clippingPlanes = [];
        newMat.color.setStyle(material[i].origin.color);
        newMat.opacity = material[i].origin.opacity;
        newMat.map = material[i].origin.map;
        newMat.transparent = newMat.opacity < 0.99;
        newMat.origin = {
          color: material[i].origin.color,
          opacity: material[i].origin.opacity,
          map: material[i].origin.map
        };
        newMats.push(newMat);
      }

      return newMats;
    } else {
      var _newMat = material.clone();

      _newMat.clippingPlanes = [];

      _newMat.color.setStyle(material.origin.color);

      _newMat.opacity = material.origin.opacity;
      _newMat.map = material.origin.map;
      _newMat.transparent = _newMat.opacity < 0.99;
      _newMat.origin = {
        color: material.origin.color,
        opacity: material.origin.opacity,
        map: material.origin.map
      };
      return _newMat;
    }
  }

  function cloneEdge(mesh) {
    var edges = mesh.userData.edges;

    if (edges) {
      var material = edges.material.clone();
      material.clippingPlanes = [];
      var newEdges = new THREE.LineSegments(edges.geometry.clone(), material);
      newEdges.name = 'edge';
      return newEdges;
    }

    return undefined;
  }

  function cloneMaterialWithQuality(materials, quality, original) {
    if (!Array.isArray(materials)) {
      var material = materials;
      var newMat;

      if (quality === 'high') {
        newMat = new THREE.MeshStandardMaterial({
          color: original ? material.origin.color : material.color,
          opacity: original ? material.origin.opacity : material.opacity,
          vertexColors: material.vertexColors,
          side: THREE.DoubleSide,
          flatShading: false
        });
      } else if (quality === 'low' || quality === 'medium') {
        newMat = new THREE.MeshPhongMaterial({
          color: original ? material.origin.color : material.color,
          opacity: original ? material.origin.opacity : material.opacity,
          side: THREE.DoubleSide,
          vertexColors: material.vertexColors,
          specular: 0x111111,
          shininess: 50,
          flatShading: false
        });
      } else {
        newMat = new THREE.MeshBasicMaterial({
          color: original ? material.origin.color : material.color,
          opacity: original ? material.origin.opacity : material.opacity,
          vertexColors: material.vertexColors,
          side: THREE.DoubleSide
        });
      } //newMat.transparent = newMat.opacity < 0.99;


      newMat.transparent = material.transparent;
      newMat.needsUpdate = true;
      newMat.origin = {
        color: material.origin.color,
        opacity: material.origin.opacity,
        transparent: material.transparent,
        vertexColors: material.vertexColors,
        map: material.origin.map
      };
      newMat.clippingPlanes = material.clippingPlanes;
      return newMat;
    }

    var newMaterials = [];

    for (var i = 0; i < materials.length; i++) {
      var _material = materials[i];

      var _newMat2 = void 0;

      if (quality === 'high') {
        _newMat2 = new THREE.MeshStandardMaterial({
          color: original ? _material.origin.color : _material.color,
          opacity: original ? _material.origin.opacity : _material.opacity,
          side: THREE.DoubleSide,
          flatShading: false
        });
      } else if (quality === 'low' || quality === 'medium') {
        _newMat2 = new THREE.MeshPhongMaterial({
          color: original ? _material.origin.color : _material.color,
          opacity: original ? _material.origin.opacity : _material.opacity,
          side: THREE.DoubleSide,
          specular: 0x111111,
          shininess: 50,
          flatShading: false
        });
      } else {
        _newMat2 = new THREE.MeshBasicMaterial({
          color: original ? _material.origin.color : _material.color,
          opacity: original ? _material.origin.opacity : _material.opacity,
          side: THREE.DoubleSide
        });
      }

      _newMat2.transparent = _newMat2.opacity < 0.99;
      _newMat2.needsUpdate = true;
      _newMat2.origin = {
        color: _material.origin.color,
        opacity: _material.origin.opacity,
        map: _material.origin.map
      };
      _newMat2.clippingPlanes = _material.clippingPlanes;
      newMaterials.push(_newMat2);
    }

    return newMaterials;
  }

  function changeMaterialQuality(mesh, quality) {//mesh.material = cloneMaterialWithQuality(mesh.material, quality, false);
    // if (quality === 'high') {
    //   mesh.castShadow = true;
    //   mesh.receiveShadow = true;
    // } else {
    //   mesh.castShadow = false;
    //   mesh.receiveShadow = false;
    // }
    // if (quality === 'xlow'){
    //   mesh.material.shininess = 0;
    //   mesh.material.specular = new THREE.Color(0x000000);
    //   mesh.material.emissiveIntensity = 0.0;
    // }
    // else{
    //   mesh.material.shininess = 50;
    //   mesh.material.specular = new THREE.Color(0x111111);
    //   mesh.material.emissiveIntensity = 1.0;
    // }
  }

  function changeEdge(mesh, quality) {
    if (quality === 'low' || quality === 'xlow' || quality === 'medium') {
      if (mesh.userData.edges) {
        mesh.remove(mesh.userData.edges);
        mesh.userData.edges = undefined;
      }
    } else {
      if (!mesh.userData.edges) {
        // edge
        var edgeMaterial = new THREE.LineBasicMaterial({
          color: EDGE_COLOR,
          transparent: true,
          opacity: 0.7
        });

        if (!Array.isArray(mesh.material)) {
          edgeMaterial.clippingPlanes = mesh.material.clippingPlanes;
        } else {
          edgeMaterial.clippingPlanes = mesh.material[0].clippingPlanes;
        }

        var edges = new THREE.LineSegments(new THREE.EdgesGeometry(mesh.geometry), edgeMaterial);
        edges.name = 'edge';
        mesh.userData.edges = edges;
        mesh.add(edges);
      }
    }
  }

  function updateMaterialColor() {
    var mesh = self.mesh;
    if (!mesh) return;

    if (self.isSelected) {
      if (self.faceMode === undefined || self.faceMode === "pershape") {
        self.selIndex = undefined;
        setMeshColor(mesh, SELECTION_COLOR, 1.0);
      } else {
        var selIdx = 0;

        for (var i = 0; i < mesh.geometry.groups.length; i++) {
          if (self.faceIndex * 3 >= mesh.geometry.groups[i].start && self.faceIndex * 3 < mesh.geometry.groups[i].start + mesh.geometry.groups[i].count) {
            selIdx = i;
            break;
          }
        }

        self.selIndex = selIdx;
        setMeshFaceColor(mesh, SELECTION_COLOR, 1.0, selIdx);
      }
    } else if (self.colorMode === 'inventory') {
      mesh.material = self.materialTrans;

      if (!self.inventoryInfo) {
        setMeshColor(mesh, self.defaultInventoryColor.color, self.defaultInventoryColor.opacity);
      } else {
        var colors = mesh.geometry.getAttribute('color');
        var color = new THREE.Color(0, 0, 0);
        color.setStyle(self.defaultInventoryColor.color);

        for (var idx = 0; idx < self.colorOriginal.length; idx++) {
          for (var _i10 = mesh.geometry.groups[idx].start; _i10 < mesh.geometry.groups[idx].start + mesh.geometry.groups[idx].count; _i10++) {
            colors.array[4 * _i10] = color.r;
            colors.array[4 * _i10 + 1] = color.g;
            colors.array[4 * _i10 + 2] = color.b;
            colors.array[4 * _i10 + 3] = self.defaultInventoryColor.opacity;
          }
        }

        var usedFaces = [];

        for (var k = 0; k < self.inventoryInfo.materials.length; k++) {
          var faces = self.inventoryInfo.materials[k].selectedFace;

          if (faces && faces.length > 0) {
            var _loop = function _loop(j) {
              var selIdx = faces[j];

              if (usedFaces.findIndex(function (item) {
                return item === selIdx;
              }) === -1) {
                color.setStyle(ExtUtils.h2rgb(self.inventoryInfo.materials[k].color));

                for (var _i11 = mesh.geometry.groups[selIdx].start; _i11 < mesh.geometry.groups[selIdx].start + mesh.geometry.groups[selIdx].count; _i11++) {
                  colors.array[4 * _i11] = color.r;
                  colors.array[4 * _i11 + 1] = color.g;
                  colors.array[4 * _i11 + 2] = color.b;
                  colors.array[4 * _i11 + 3] = self.inventoryInfo.materials[k].opacity / 100.0;
                }

                usedFaces.push(selIdx);
              }
            };

            for (var j = 0; j < faces.length; j++) {
              _loop(j);
            }
          } else {
            color.setStyle(ExtUtils.h2rgb(self.inventoryInfo.materials[k].color));

            for (var _idx = 0; _idx < self.colorOriginal.length; _idx++) {
              for (var _i12 = mesh.geometry.groups[_idx].start; _i12 < mesh.geometry.groups[_idx].start + mesh.geometry.groups[_idx].count; _i12++) {
                colors.array[4 * _i12] = color.r;
                colors.array[4 * _i12 + 1] = color.g;
                colors.array[4 * _i12 + 2] = color.b;
                colors.array[4 * _i12 + 3] = self.defaultInventoryColor.opacity;
              }
            }

            break;
          }
        }

        mesh.geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors.array, 4));
      }
    } else if (self.color) {
      if (mesh.material.origin.opacity < 0.99) {
        mesh.material = self.materialTrans;
      } else {
        mesh.material = self.materialOpaque;
      }

      setMeshColor(mesh, self.color, mesh.material.origin.opacity);
    } else if (self.opacity !== undefined) {
      var opacity = self.opacity < mesh.material.origin.opacity ? self.opacity : mesh.material.origin.opacity;

      if (opacity < 0.99) {
        mesh.material = self.materialTrans;
      } else {
        mesh.material = self.materialOpaque;
      }

      resetMeshColor(mesh, opacity);
    } else {
      if (Array.isArray(mesh.material)) {} else if (mesh.material === self.materialPaint) {} else {
        if (isColorOriginalTransparent(self.colorOriginal)) {
          mesh.material = self.materialTrans;
        } else {
          mesh.material = self.materialOpaque;
        }
      }

      resetMeshColor(mesh);
    }
  }

  function setMeshColor(mesh, colorStyle, opacity) {
    var color = new THREE.Color(colorStyle);
    var colors = mesh.geometry.getAttribute('color');

    for (var idx = 0; idx < self.colorOriginal.length; idx++) {
      for (var i = mesh.geometry.groups[idx].start; i < mesh.geometry.groups[idx].start + mesh.geometry.groups[idx].count; i++) {
        colors.array[4 * i] = color.r;
        colors.array[4 * i + 1] = color.g;
        colors.array[4 * i + 2] = color.b;
        colors.array[4 * i + 3] = opacity;
      }
    }

    mesh.geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors.array, 4));
  }

  function setMeshFaceColor(mesh, colorStyle, opacity, selIdx) {
    var color = new THREE.Color(colorStyle);
    var colors = mesh.geometry.getAttribute('color');

    for (var i = mesh.geometry.groups[selIdx].start; i < mesh.geometry.groups[selIdx].start + mesh.geometry.groups[selIdx].count; i++) {
      colors.array[4 * i] = color.r;
      colors.array[4 * i + 1] = color.g;
      colors.array[4 * i + 2] = color.b;
      colors.array[4 * i + 3] = opacity;
    }

    mesh.geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors.array, 4));
  }

  function resetMeshColor(mesh, opacity) {
    var colors = mesh.geometry.getAttribute('color');

    for (var idx = 0; idx < self.colorOriginal.length; idx++) {
      var color = self.colorOriginal[idx];

      for (var i = mesh.geometry.groups[idx].start; i < mesh.geometry.groups[idx].start + mesh.geometry.groups[idx].count; i++) {
        colors.array[4 * i] = color[0];
        colors.array[4 * i + 1] = color[1];
        colors.array[4 * i + 2] = color[2];
        colors.array[4 * i + 3] = opacity !== undefined ? opacity : color[3];
      }
    }

    mesh.geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors.array, 4));
  }

  function isColorOriginalTransparent(colors) {
    for (var idx = 0; idx < colors.length; idx++) {
      if (colors[idx][3] < 0.99) return true;
    }

    return false;
  }

  function updateFaceSelectionMode() {
    console.log("called updateFaceSelectionMode.");
  }

  function getInventoryItem(inventoryInfo, fIndex) {
    if (!inventoryInfo) return;
    var materials = inventoryInfo.materials;

    if (materials && materials.length > 0) {
      for (var i = 0; i < materials.length; i++) {
        if (fIndex !== undefined) {
          if (materials[i].color && materials[i].selectedFace.findIndex(function (item) {
            return item === fIndex;
          }) !== -1) {
            return materials[i];
          }
        } else {
          if (materials[i].color) {
            return materials[i];
          }
        }
      }
    }

    var dcps = inventoryInfo.dcps;

    if (dcps && dcps.length > 0) {
      for (var _i13 = 0; _i13 < dcps.length; _i13++) {
        if (dcps[_i13].color) {
          return dcps[_i13];
        }
      }
    }

    return undefined;
  }
}


"use strict";

/**
 * @param viewer {BimViewer}
 * @param planSection {CrossSection}
 * @param plan3d {BimPlan3d}
 */
function BimPlan(viewer, planSection, plan3d) {
  this.id = undefined; // plan identifier

  this.name = undefined; // plan name

  this.workLevel = undefined; // work level

  this.image = undefined; // rendered image data or url

  this.pdfImage = undefined; // pdf image data or url

  this.pdf = undefined; // pdf data or url

  this.drawing = undefined; // drawing data

  this.normal = undefined; // normal vector

  this.completed = false; // plan completed

  this.visible = true;
  this.mesh = undefined; // three.js plan mesh

  this.marker = undefined; // marker for three.js

  this.size = undefined;
  this.sectionControl = undefined; // plan move control when plan is completed

  this.transformer = undefined; // plan transform control when plan is not completed

  this.planSection = planSection;
  this.plan3d = plan3d;
  var self = this;

  this.setup = function () {
    if (this.mesh) {
      this.planSection.addClippingPlaneEntity(this.mesh);
    }
  };
  /**
   * destroy bim plan
   */


  this.destroy = function () {
    if (this.mesh) {
      viewer.removeObject(this.mesh);
    }

    if (this.marker) {
      viewer.removeObject(this.marker);
    }

    this.planSection.removeClippingPlaneEntity(this.mesh);

    if (this.transformer) {
      this.transformer.dispose();
      this.transformer = undefined;
    }

    if (this.sectionControl) {
      this.plan3d.removeControl(this.sectionControl);
      this.sectionControl = undefined;
    }

    this.marker = undefined;
    this.mesh = undefined;
    this.planSection = undefined;
    this.plan3d = undefined;
  };

  this.setNormal = function (normal) {
    this.normal = normal.clone().normalize();
  };

  this.getNormal = function () {
    return this.normal.clone();
  };

  this.kindOf = function () {
    var value = Math.round(this.normal.x);

    if (value !== 0) {
      return {
        axis: 'yz',
        dir: value > 0
      };
    }

    value = Math.round(this.normal.y);

    if (value !== 0) {
      return {
        axis: 'xz',
        dir: value > 0
      };
    }

    value = Math.round(this.normal.z);

    if (value !== 0) {
      return {
        axis: 'xy',
        dir: value > 0
      };
    }

    return {
      axis: 'xy',
      dir: true
    };
  };

  this.cameraViewType = function () {
    var kind = this.kindOf();
    var type;

    switch (kind.axis) {
      case 'yz':
        type = kind.dir ? 'left' : 'right';
        break;

      case 'xz':
        type = kind.dir ? 'back' : 'front';
        break;

      default:
        type = kind.dir ? 'top' : 'bottom';
        break;
    }

    return type;
  };

  this.toggleVisible = function () {
    if (this.mesh) {
      this.setVisible(!this.visible);
    }
  };
  /**
   * @param visible {Boolean}
   */


  this.setVisible = function (visible) {
    if (this.visible === visible) return;
    this.visible = visible;
    var needUpdate = false;

    if (this.mesh) {
      this.mesh.visible = this.visible;
      updateClipping();
      needUpdate = true;
    }

    if (this.marker) {
      toggleMarker(!this.visible);
      needUpdate = true;
    }

    if (this.sectionControl && !visible) {
      this.plan3d.showControl(this.sectionControl, visible);
    }

    if (needUpdate) {
      viewer.setDirty(true);
    }
  };
  /**
   * @param visible {Boolean}
   */


  this.setVisibleForce = function (visible) {
    var needUpdate = false;

    if (visible) {
      if (this.mesh) {
        if (this.mesh.visible !== this.visible) {
          this.mesh.visible = this.visible;
          updateClipping();
          needUpdate = true;
        }
      }

      if (this.marker) {
        this.marker.visible = true;
        toggleMarker(!this.visible);
        needUpdate = true;
      }
    } else {
      if (this.mesh) {
        if (this.mesh.visible) {
          this.mesh.visible = false;
          updateClipping();
          needUpdate = true;
        }
      }

      if (this.marker) {
        this.marker.visible = false;
        needUpdate = true;
      }
    }

    if (needUpdate) {
      viewer.setDirty(true);
    }
  };

  this.isVisible = function () {
    return this.mesh !== undefined && this.mesh.visible;
  };

  this.setCompleted = function () {
    var _this = this;

    if (this.completed) return;
    this.completed = true;

    if (this.transformer !== undefined) {
      this.transformer.dispose();
      this.transformer = undefined;
    }

    this.plan3d.addControl(this, this.isVisible()).then(function (control) {
      _this.sectionControl = control;
    });
    this.setVisibleForce(true);
    viewer.setDirty(true);
  };

  this.showControl = function () {
    if (self.mesh.visible) {
      this.plan3d.showControl(this.sectionControl, true);
    }
  };

  this.toggleClipping = function () {
    this.planSection.toggleClippingPlaneEntity(this.mesh);
  };

  this.getBoundingBox = function () {
    if (this.mesh) {
      return this.mesh.geometry.boundingBox;
    }

    return undefined;
  };

  this.getSaveData = function () {
    var data = {
      normal: {
        x: this.normal.x,
        y: this.normal.y,
        z: this.normal.z
      },
      size: this.size,
      matrix: this.mesh.matrix.elements
    };
    if (this.name) data.name = this.name;
    if (this.image) data.image = this.image;
    if (this.pdf) data.pdf = this.pdf;
    if (this.workLevel) data.workLevel = this.workLevel;
    return data;
  };

  this.changeImage = function (imageData) {
    this.image = imageData;
    new THREE.TextureLoader().load(imageData, function (texture) {
      texture.flipY = false;
      self.mesh.material.map = texture;
      self.mesh.material.needsUpdate = true;
      viewer.setDirty(true);
    }, undefined, function (err) {
      console.error(err);
    });
  };

  function updateClipping() {
    if (self.completed) {
      if (self.mesh.visible) {
        self.planSection.addClippingPlaneEntity(self.mesh);
        self.plan3d.showControl(self.sectionControl, true);
      } else {
        self.planSection.removeClippingPlaneEntity(self.mesh);
        self.plan3d.disableControl();
      }
    }
  }

  function toggleMarker(d2) {
    var textureLoader = new THREE.TextureLoader();
    textureLoader.setCrossOrigin("anonymous");
    var image = d2 ? 'assets/images/cgviewer/marker-2d.png' : 'assets/images/cgviewer/marker-3d.png';
    textureLoader.load(image, function (texture) {
      if (self.marker) {
        texture.minFilter = THREE.LinearFilter;
        texture.needsUpdate = true;
        self.marker.material.map = texture;
        self.marker.material.needsUpdate = true;
        viewer.setDirty(true);
      }
    }, undefined, function (err) {
      console.error(err);
    });
  }
}


"use strict";

function BimBaseCmd(viewer, scene, type) {
  var ratio = viewer.getCameraZoom();
  Bim.Constant.snapSize = 3 * ratio;
  BimUtils.setRatioZero(ratio);
  this.type = type;
  this.scene = scene ? scene : viewer.scene;
  this.touch = new TouchTracker(viewer);
  this.active = false;
  this.currentPos = undefined;
  this.drawer2d = undefined; // activate command

  this.setActive = function (active) {
    if (this.active === active) {
      return;
    }

    this.active = active;

    if (active) {
      viewer.cameraCtrl.setRightButtonMode(true);
      var eventHandlers = {
        'pointerdown': this.onMouseDown.bind(this),
        'pointermove': this.onMouseMove.bind(this),
        'pointerup': this.onMouseUp.bind(this)
      };
      this.touch.start(eventHandlers);
      if (this.onActivate2) this.onActivate2();
      if (this.onActivate) this.onActivate();
    } else {
      viewer.cameraCtrl.setRightButtonMode(false);
      this.touch.stop();
      this.onDeactivate();
      if (this.onDeactivate2) this.onDeactivate2();
      this.setCursor('default');
    }
  };

  this.onDeactivate = function () {
    this.currentPos = undefined;
    viewer.signaler.updateStatusData.dispatch(this.currentPos);
    if (this.doEscape) return this.doEscape();
  };

  this.onActivate2 = function () {
    this.touch.setSnapMode(true);
  };

  this.onDeactivate2 = function () {
    this.touch.setPlaneMode(false);
    this.touch.setSnapMode(false);
    this.render();
  }; // event handlers


  this.onMouseDown = function (event) {
    event.preventDefault();
    if (isLeftMouseButton(event) && this.doMouseDown) this.doMouseDown(event);
  };

  this.onMouseMove = function (event) {
    event.preventDefault();

    if (this.doMouseMove) {
      this.doMouseMove(event);

      if (this.drawer2d) {
        this.drawer2d.showSnapSticker(event, this.touch);
      }
    }
  };

  this.onMouseUp = function (event) {
    event.preventDefault();
    if (isLeftMouseButton(event) && this.doMouseUp) this.doMouseUp(event);

    if (this.drawer2d) {
      this.drawer2d.clear();
    }
  };

  this.onKeyDown = function (event) {};

  this.onKeyUp = function (event) {
    var key = event.key.toLowerCase();
    var did = false;

    if (key === 'escape' || key === 'esc' || event.keyCode === 27) {
      did = this.doEscape && this.doEscape();
    }

    if (did) event.preventDefault();
  };

  this.render = function () {
    viewer.setDirty(true);
  };

  this.setCursor = function (cursor, isUrl, isUp) {
    viewer.setCursor(cursor, isUrl, isUp);
  };

  this.updateCurrentPos = function (pos) {
    this.currentPos = pos.clone();
    viewer.signaler.updateStatusData.dispatch(this.currentPos);
  };

  this.setSelectionMode = function () {
    this.setActive(false);
    viewer.setDragAction('picker');
  };

  this.releaseCurrentCmd = function () {
    viewer.signaler.releaseCmd.dispatch();
  };

  this.addObject = function (mesh) {
    this.scene.add(mesh);
  };

  function isLeftMouseButton(event) {
    return event.which === 1;
  }
}


"use strict";

function TouchTracker(viewer) {
  this.lastEndPoint = undefined;
  this.interestEndPoints = [];
  this.snappedPointFrom = undefined;
  this.lastAxisEntity = undefined;
  this.interestAxisEntity = [];
  var scene = viewer.scene;
  var camera = viewer.camera;
  var raycaster = new THREE.Raycaster();
  raycaster.params.Line.threshold = Bim.Constant.snapSize;
  raycaster.camera = camera;
  var ray = raycaster.ray;
  var lastPos = {
    x: 0,
    y: 0
  };
  var snapPos = new THREE.Vector3();
  var snapEdgeDir = new THREE.Vector3();
  var snapFlag = Bim.SnapFlag.none;
  var planeFlag = Bim.PlaneFlag.noPlane;
  var snapPlane = new THREE.Plane();
  var planeMode = false;
  var snapMode = false;
  var modelMode = false; // only track model

  var snappers;
  var curSnapper;
  var centerSnapper;
  var arcSnapperB; // arc-begin

  var arcSnapperE; // arc-end

  var guidelineSnapper;
  var guidelinePos;
  var SnapColor = {
    onFace: 0xff00ff,
    onEdgeVt: 0xff0000,
    onEndVt: 0x00ff00,
    onMidVt: 0xffff00
  };
  var self = this;

  function createSnappers() {
    var snapperSize = Bim.Constant.snapperSize;
    snappers = [// current snapper
    new THREE.Mesh(new THREE.SphereBufferGeometry(snapperSize), newMatSnapper()), // arc center
    new THREE.Mesh(new THREE.SphereBufferGeometry(snapperSize), newMatSnapper(0x7ca3e2)), // arc-begin
    new THREE.Mesh(new THREE.SphereBufferGeometry(snapperSize), newMatSnapper(0xa0a4aa)), // arc-end
    new THREE.Mesh(new THREE.SphereBufferGeometry(snapperSize), newMatSnapper(0xa0a4aa)), // guideline (0,1:track-line)
    BimUtils.createEdgeEntity(6 * 3, BimUtils.newMatGuideline(viewer.getCameraZoom()), scene)];
    curSnapper = snappers[0];
    centerSnapper = snappers[1];
    arcSnapperB = snappers[2]; // arc-begin

    arcSnapperE = snappers[3]; // arc-end

    guidelineSnapper = snappers[4];
    guidelinePos = guidelineSnapper.geometry.getAttribute('position');
  }

  function newMatSnapper(color) {
    if (color === undefined) color = SnapColor.onFace;
    return new THREE.MeshBasicMaterial({
      color: color,
      wireframe: true,
      depthTest: false,
      depthWrite: false,
      side: THREE.DoubleSide
    });
  }

  Object.defineProperty(this, 'ray', {
    get: function get() {
      return ray;
    }
  });

  this.setPlaneMode = function (flag) {
    planeMode = flag;
  };

  this.setSnapMode = function (flag) {
    snapMode = flag;
  };

  this.setModelMode = function (flag) {
    modelMode = flag;
  };

  this.start = function (handlers) {
    this.handlers = handlers;

    for (var eventName in this.handlers) {
      if (this.handlers.hasOwnProperty(eventName)) {
        viewer.canvas.addEventListener(eventName, this.handlers[eventName], false);
      }
    } // start snappers


    createSnappers();
    snappers.forEach(function (snapper) {
      //scene.add(snapper);
      snapper.visible = false;
    });
  };

  this.stop = function () {
    for (var eventName in this.handlers) {
      if (this.handlers.hasOwnProperty(eventName)) {
        viewer.canvas.removeEventListener(eventName, this.handlers[eventName], false);
      }
    } // free snappers


    snappers.forEach(function (snapper) {
      scene.remove(snapper);
      BimUtils.freeEntity(snapper);
    });
    delete centerSnapper.born;
  };

  this.castScene = function (event) {
    if (event) {
      lastPos = BimUtils.getEventPosition(event);
    }

    var vector = new THREE.Vector3(lastPos.x / viewer.width * 2 - 1, -(lastPos.y / viewer.height) * 2 + 1, 0.5);
    vector.unproject(camera);
    raycaster.set(viewer.camera.position, vector.sub(camera.position).normalize());
  };

  this.snapPosition = function () {
    return snapPos;
  };

  this.snapFlag = function () {
    return snapFlag;
  };

  this.planeFlag = function () {
    return planeFlag;
  };

  this.snapPointFrom = function () {
    return this.snappedPointFrom;
  };

  this.snapPlane = function () {
    var plane = new THREE.Plane();
    if (planeFlag === Bim.PlaneFlag.noPlane) return undefined;

    if (planeFlag === Bim.PlaneFlag.onXY) {
      plane.setFromNormalAndCoplanarPoint(Bim.Coords.zaxis, snapPos);
    } else if (planeFlag === Bim.PlaneFlag.onYZ) {
      plane.setFromNormalAndCoplanarPoint(Bim.Coords.xaxis, snapPos);
    } else if (planeFlag === Bim.PlaneFlag.onZX) {
      plane.setFromNormalAndCoplanarPoint(Bim.Coords.yaxis, snapPos);
    } else {
      plane = snapPlane.clone();
    }

    return plane;
  };

  this.graspSnapOnPlane = function (pf, paxis) {
    var plane = new THREE.Plane();
    var org = Bim.Coords.org;
    var axis = paxis;

    if (axis === undefined) {
      if (pf === Bim.PlaneFlag.onXY) axis = Bim.Coords.zaxis;else if (pf === Bim.PlaneFlag.onYZ) axis = Bim.Coords.xaxis;else if (pf === Bim.PlaneFlag.onZX) axis = Bim.Coords.yaxis;
    }

    plane.setFromNormalAndCoplanarPoint(axis, org);

    if (ray.intersectPlane(plane, snapPos)) {
      planeFlag = pf;
      return true;
    }

    return false;
  };
  /**
   * grasp snap on plane
   * @param plane {THREE.Plane}
   */


  this.graspSnapOn = function (plane) {
    return ray.intersectPlane(plane, snapPos);
  };

  this.graspSnap = function () {
    var v = new THREE.Vector3();
    var v1 = new THREE.Vector3();
    var v2 = new THREE.Vector3();
    var lineseg = new THREE.Line3(v1, v2);
    var plane = new THREE.Plane();
    var org = Bim.Coords.org;
    var xaxis = Bim.Coords.xaxis;
    var yaxis = Bim.Coords.yaxis;
    var zaxis = Bim.Coords.zaxis;
    var vxy = Math.cos(THREE.Math.degToRad(75));

    function snapEdge(edge, vt) {
      if (!edge.geometry.isBufferGeometry) return Bim.SnapFlag.none;
      var position = edge.geometry.getAttribute('position');
      v.fromBufferAttribute(position, 0);
      v.applyMatrix4(edge.matrixWorld);

      if (BimUtils.equalsVector3(v, vt, Bim.Constant.snapSize * 2)) {
        vt.copy(v);
        return Bim.SnapFlag.onEndVt; // snap start-pt
      }

      v.fromBufferAttribute(position, position.count - 1);
      v.applyMatrix4(edge.matrixWorld);

      if (BimUtils.equalsVector3(v, vt, Bim.Constant.snapSize * 2)) {
        vt.copy(v);
        return Bim.SnapFlag.onEndVt; // snap start-pt
      }

      for (var i = 0; i < position.count; i += 2) {
        v1.fromBufferAttribute(position, i);
        v1.applyMatrix4(edge.matrixWorld);
        v2.fromBufferAttribute(position, i + 1);
        v2.applyMatrix4(edge.matrixWorld);
        snapEdgeDir.subVectors(v1, v2);
        snapEdgeDir.normalize();

        if (BimUtils.equalsVector3(v1, vt, Bim.Constant.snapSize * 2)) {
          vt.copy(v1);
          return Bim.SnapFlag.onEndVt;
        }

        if (BimUtils.equalsVector3(v2, vt, Bim.Constant.snapSize * 2)) {
          vt.copy(v2);
          return Bim.SnapFlag.onEndVt;
        }

        v.addVectors(v1, v2).multiplyScalar(0.5);

        if (!edge.isTempAxis && BimUtils.equalsVector3(v, vt, Bim.Constant.snapSize * 2)) {
          vt.copy(v);
          return Bim.SnapFlag.onMidVt;
        }

        var t = lineseg.closestPointToPointParameter(vt);

        if (0 < t && t < 1) {
          lineseg.at(t, v);

          if (BimUtils.equalsVector3(v, vt, Bim.Constant.snapSize)) {
            vt.copy(v);
            return Bim.SnapFlag.onEdgeVt;
          }
        }
      }

      return Bim.SnapFlag.none;
    } // snap to plane


    planeFlag = Bim.PlaneFlag.noPlane;

    if (planeMode) {
      if (vxy < Math.abs(ray.direction.dot(zaxis))) self.graspSnapOnPlane(Bim.PlaneFlag.onXY, zaxis);

      if (planeFlag === Bim.PlaneFlag.noPlane) {
        if (Math.abs(ray.direction.dot(xaxis)) < Math.abs(ray.direction.dot(yaxis))) {
          self.graspSnapOnPlane(Bim.PlaneFlag.onZX, yaxis);
        }

        if (planeFlag === Bim.PlaneFlag.noPlane) {
          self.graspSnapOnPlane(Bim.PlaneFlag.onYZ, xaxis);
        }
      }
    }

    if (!modelMode) {
      if (planeFlag === Bim.PlaneFlag.noPlane) {
        var dist = -camera.position.z / ray.direction.z;
        snapPos.copy(ray.direction).multiplyScalar(dist).add(camera.position);
        planeFlag = Bim.PlaneFlag.onXY;
      }
    } // snap to entity


    snapFlag = Bim.SnapFlag.none;

    if (snapMode) {
      snappers.forEach(function (snapper) {
        snapper.visible = false;
      });
      var snapedge; //check endpoint first

      var found = false;
      var hitInfo = self.hitEntity(function (entity) {
        return !(entity.object.userData && entity.object.userData.unSnapable || entity.object.isTempAxis);
      });

      if (hitInfo) {
        snapPos.copy(hitInfo.point);
        var entity = hitInfo.object;
        var edges = [];

        if (hitInfo.face) {
          // face
          snapFlag = Bim.SnapFlag.onFace;

          if (BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.xaxis).length())) {
            if (BimUtils.IsZero(snapPos.x)) {
              planeFlag = Bim.PlaneFlag.onYZ;
            } else {
              planeFlag = Bim.PlaneFlag.onPararrelYZ;
            }
          } else if (BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.yaxis).length())) {
            if (BimUtils.IsZero(snapPos.x)) {
              planeFlag = Bim.PlaneFlag.onZX;
            } else {
              planeFlag = Bim.PlaneFlag.onPararrelZX;
            }
          } else if (BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.zaxis).length())) {
            if (BimUtils.IsZero(snapPos.x)) {
              planeFlag = Bim.PlaneFlag.onXY;
            } else {
              planeFlag = Bim.PlaneFlag.onPararrelXY;
            }
          } else if (!BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.xaxis).length()) && !BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.yaxis).length()) && !BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.zaxis).length())) {
            planeFlag = Bim.PlaneFlag.none;
          }

          snapPlane.setFromNormalAndCoplanarPoint(hitInfo.face.normal, hitInfo.point);
          if (entity.userData.isSurfaceEditable) edges = entity.children; // all edges
        } else {
          // one-edge
          edges.push(entity);
        }

        for (var i = 0; i < edges.length; i++) {
          var flag = snapEdge(edges[i], snapPos);

          if (flag === Bim.SnapFlag.onEndVt || flag === Bim.SnapFlag.onCenterVt || flag === Bim.SnapFlag.onMidVt) {
            snapFlag = flag;
            snapedge = edges[i];

            if (BimUtils.equalsVector3(snapPos, Bim.Coords.org)) {
              snapFlag = Bim.SnapFlag.origin;
            }

            self.updateInterestingEndPt(snapPos);
            found = true;
            break;
          }
        }
      }

      if (!found) {
        hitInfo = self.hitEntity(function (entity) {
          if (entity.object.userData && entity.object.userData.unSnapable) return false;else return true;
        });
      }

      if (hitInfo) {
        snapPos.copy(hitInfo.point);
        var _entity = hitInfo.object;
        var _edges = [];

        if (hitInfo.face) {
          // face
          snapFlag = Bim.SnapFlag.onFace;

          if (BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.xaxis).length())) {
            if (BimUtils.IsZero(snapPos.x)) {
              planeFlag = Bim.PlaneFlag.onYZ;
            } else {
              planeFlag = Bim.PlaneFlag.onPararrelYZ;
            }
          } else if (BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.yaxis).length())) {
            if (BimUtils.IsZero(snapPos.x)) {
              planeFlag = Bim.PlaneFlag.onZX;
            } else {
              planeFlag = Bim.PlaneFlag.onPararrelZX;
            }
          } else if (BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.zaxis).length())) {
            if (BimUtils.IsZero(snapPos.x)) {
              planeFlag = Bim.PlaneFlag.onXY;
            } else {
              planeFlag = Bim.PlaneFlag.onPararrelXY;
            }
          } else if (!BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.xaxis).length()) && !BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.yaxis).length()) && !BimUtils.IsZero(hitInfo.face.normal.clone().cross(Bim.Coords.zaxis).length())) {
            planeFlag = Bim.PlaneFlag.none;
          }

          snapPlane.setFromNormalAndCoplanarPoint(hitInfo.face.normal, hitInfo.point);
          if (_entity.userData.isSurfaceEditable) _edges = _entity.children; // all edges
        } else {
          // one-edge
          _edges.push(_entity);
        }

        for (var _i = 0; _i < _edges.length; _i++) {
          var _flag = snapEdge(_edges[_i], snapPos);

          if (_flag !== Bim.SnapFlag.none) {
            snapFlag = _flag;
            snapedge = _edges[_i];

            if (_flag === Bim.SnapFlag.onEndVt) {
              if (BimUtils.equalsVector3(snapPos, Bim.Coords.org)) {
                snapFlag = Bim.SnapFlag.origin;
              }

              self.updateInterestingEndPt(snapPos);
            } else if (_flag === Bim.SnapFlag.onCenterVt || _flag === Bim.SnapFlag.onMidVt) {
              self.updateInterestingEndPt(snapPos);
            } else if (_flag === Bim.SnapFlag.onEdgeVt) {
              if (snapedge.name === 'red') {
                snapFlag = Bim.SnapFlag.redAxis;
              } else if (snapedge.name === 'blue') {
                snapFlag = Bim.SnapFlag.blueAxis;
              } else if (snapedge.name === 'green') {
                snapFlag = Bim.SnapFlag.greenAxis;
              } else if (snapedge.name === 'onred') {
                if (snapedge.isTempAxis && snapedge.axisType === Bim.TempAxisType.first) {
                  snapFlag = Bim.SnapFlag.onRedAxis;
                } else if (snapedge.isTempAxis && snapedge.axisType === Bim.TempAxisType.second) {
                  snapFlag = Bim.SnapFlag.fromPointOnRed;
                }

                self.snappedPointFrom = snapedge.position.clone();
              } else if (snapedge.name === 'onblue') {
                if (snapedge.isTempAxis && snapedge.axisType === Bim.TempAxisType.first) {
                  snapFlag = Bim.SnapFlag.onBlueAxis;
                } else if (snapedge.isTempAxis && snapedge.axisType === Bim.TempAxisType.second) {
                  snapFlag = Bim.SnapFlag.fromPointOnBlue;
                }

                self.snappedPointFrom = snapedge.position.clone();
              } else if (snapedge.name === 'ongreen') {
                if (snapedge.isTempAxis && snapedge.axisType === Bim.TempAxisType.first) {
                  snapFlag = Bim.SnapFlag.onGreenAxis;
                } else if (snapedge.isTempAxis && snapedge.axisType === Bim.TempAxisType.second) {
                  snapFlag = Bim.SnapFlag.fromPointOnGreen;
                }

                self.snappedPointFrom = snapedge.position.clone();
              }
            }

            break;
          }
        }
      }

      var showcursnap = false;

      if (snapFlag === Bim.SnapFlag.none && centerSnapper.born && BimUtils.equalsVector3(centerSnapper.position, snapPos, Bim.Constant.snapSize * 2)) {
        centerSnapper.visible = true;
        snapPos.copy(centerSnapper.position);
        snapFlag = Bim.SnapFlag.onCenterVt;
      }

      if (snapFlag !== Bim.SnapFlag.none) {
        showcursnap = true;
        var color = SnapColor.onFace;

        switch (snapFlag) {
          case Bim.SnapFlag.onFace:
            {
              color = SnapColor.onFace;

              if (centerSnapper.born && BimUtils.equalsVector3(centerSnapper.position, snapPos, Bim.Constant.snapSize * 2)) {
                centerSnapper.visible = true;
                snapPos.copy(centerSnapper.position);
                showcursnap = false;
                snapFlag = Bim.SnapFlag.onCenterVt;
              }

              break;
            }

          case Bim.SnapFlag.onEndVt:
            {
              color = SnapColor.onEndVt;

              if (snapedge.userData.hasPolygonSnap || snapedge.userData.hasCircleSnap || snapedge.userData.hasArcSnap) {
                var center = BimUtils.centerPosition(snapedge);
                centerSnapper.position.copy(center);
                centerSnapper.visible = true;
                centerSnapper.born = true;
                guidelinePos.copyVector3sArray([center, center, center, center, center, center]);
                guidelinePos.setXYZ(0, center.x, center.y, center.z);
                guidelinePos.setXYZ(1, snapPos.x, snapPos.y, snapPos.z);
                guidelinePos.needsUpdate = true;
                guidelineSnapper.visible = true;
              }

              if (snapedge.userData.hasArcSnap) {
                var position = snapedge.geometry.getAttribute('position'); // arc-begin

                v.fromBufferAttribute(position, 0);
                v.applyMatrix4(snapedge.matrixWorld);
                guidelinePos.setXYZ(3, v.x, v.y, v.z);
                arcSnapperB.position.copy(v);
                if (!BimUtils.equalsVector3(snapPos, v)) arcSnapperB.visible = true; // arc-end

                v.fromBufferAttribute(position, position.count - 1);
                v.applyMatrix4(snapedge.matrixWorld);
                guidelinePos.setXYZ(5, v.x, v.y, v.z);
                arcSnapperE.position.copy(v);
                if (!BimUtils.equalsVector3(snapPos, v)) arcSnapperE.visible = true;
              }

              if (guidelineSnapper.visible) guidelineSnapper.computeLineDistances();
              break;
            }

          case Bim.SnapFlag.onEdgeVt:
            color = SnapColor.onEdgeVt;
            break;

          case Bim.SnapFlag.onMidVt:
            color = SnapColor.onMidVt;
            break;
        }

        curSnapper.material.color.setHex(color);
      }

      curSnapper.position.copy(snapPos);
      curSnapper.visible = showcursnap;
      var camPos = camera.position;
      var ratio = BimUtils.getScaleFactorByCameraPos(snapPos, camPos);
      curSnapper.scale.set(ratio, ratio, ratio);
      viewer.setDirty(true);
    }

    return planeFlag !== Bim.PlaneFlag.noPlane || snapFlag !== Bim.SnapFlag.none;
  };

  this.hitObjects = function (objects, filter) {
    var intersects;
    if (objects == null) intersects = raycaster.intersectObject(scene, true);else intersects = raycaster.intersectObjects(objects, true);

    if (0 < intersects.length && filter !== null) {
      var results = [];

      for (var i = 0; i < intersects.length; i++) {
        var intersect = intersects[i];
        if (filter(intersect)) results.push(intersect);
      }

      intersects = results;
    }

    return intersects;
  };

  this.hitObject = function (objects, filter) {
    var intersects = this.hitObjects(objects, filter);
    if (0 < intersects.length) return intersects[0];
    return null;
  };

  this.hitEntity = function (filter) {
    return this.hitObject(null, filter);
  };

  this.updateInterestingEndPt = function (pos) {
    if (!pos) {
      this.interestEndPoints = [];
      this.removeTempInterestAxis();
      return;
    }

    if (BimUtils.equalsVector3(pos, Bim.Coords.org)) return;
    var pts = [];

    for (var i = 0; i < this.interestEndPoints.length; i++) {
      var pt = this.interestEndPoints[i];

      if (BimUtils.equalsVector3(pt, pos) || this.lastEndPoint && BimUtils.equalsVector3(pt, this.lastEndPoint)) {
        continue;
      }

      pts.push(pt.clone());
    }

    if (!this.lastEndPoint || !BimUtils.equalsVector3(pos, this.lastEndPoint)) {
      if (pts.length < 5) {
        pts.push(pos.clone());
      } else {
        pts.splice(0, 1);
        pts.push(pos.clone());
      }
    }

    this.interestEndPoints = pts.slice(0);
    this.createTempAxis(Bim.TempAxisType.second);
  };

  this.createTempAxis = function (type) {
    if (type === Bim.TempAxisType.first) {
      if (this.lastAxisEntity) {
        this.removeTempAxis(Bim.TempAxisType.first);
      }

      this.lastAxisEntity = BimUtils.createAxisEntity(scene, this.lastEndPoint, type);
    } else if (type === Bim.TempAxisType.second) {
      if (this.interestAxisEntity.length > 0) {
        this.removeTempAxis(Bim.TempAxisType.second);
      }

      this.interestAxisEntity = [];
      var axis;

      for (var i = 0; i < this.interestEndPoints.length; i++) {
        axis = BimUtils.createAxisEntity(scene, this.interestEndPoints[i], type);
        this.interestAxisEntity.push(axis);
      }
    }
  };

  this.removeTempAxis = function (type) {
    if (type === Bim.TempAxisType.first && this.lastAxisEntity) {
      BimUtils.freeEntity(this.lastAxisEntity);
      this.lastAxisEntity = undefined;
    } else if (type === Bim.TempAxisType.second) {
      this.removeTempInterestAxis();
    } else if (type === undefined && this.lastAxisEntity) {
      BimUtils.freeEntity(this.lastAxisEntity);
      this.removeTempInterestAxis();
      this.lastAxisEntity = undefined;
    }
  };

  this.removeTempInterestAxis = function () {
    if (this.interestAxisEntity.length > 0) {
      for (var i = 0; i < this.interestAxisEntity.length; i++) {
        var entity = this.interestAxisEntity[i];
        BimUtils.freeEntity(entity);
      }

      this.interestAxisEntity = [];
    }
  };
}


"use strict";

/**
 * Enumeration of product types.
 * @readonly
 * @enum {number}
 */
var XProductType = {
  IFCDISTRIBUTIONELEMENT: 44,
  IFCDISTRIBUTIONFLOWELEMENT: 45,
  IFCDISTRIBUTIONCHAMBERELEMENT: 180,
  IFCENERGYCONVERSIONDEVICE: 175,
  IFCAIRTOAIRHEATRECOVERY: 1097,
  IFCBOILER: 1105,
  IFCBURNER: 1109,
  IFCCHILLER: 1119,
  IFCCOIL: 1124,
  IFCCONDENSER: 1132,
  IFCCOOLEDBEAM: 1141,
  IFCCOOLINGTOWER: 1142,
  IFCENGINE: 1164,
  IFCEVAPORATIVECOOLER: 1166,
  IFCEVAPORATOR: 1167,
  IFCHEATEXCHANGER: 1187,
  IFCHUMIDIFIER: 1188,
  IFCTUBEBUNDLE: 1305,
  IFCUNITARYEQUIPMENT: 1310,
  IFCELECTRICGENERATOR: 1160,
  IFCELECTRICMOTOR: 1161,
  IFCMOTORCONNECTION: 1216,
  IFCSOLARDEVICE: 1270,
  IFCTRANSFORMER: 1303,
  IFCFLOWCONTROLLER: 121,
  IFCELECTRICDISTRIBUTIONPOINT: 242,
  IFCAIRTERMINALBOX: 1096,
  IFCDAMPER: 1148,
  IFCFLOWMETER: 1182,
  IFCVALVE: 1311,
  IFCELECTRICDISTRIBUTIONBOARD: 1157,
  IFCELECTRICTIMECONTROL: 1162,
  IFCPROTECTIVEDEVICE: 1235,
  IFCSWITCHINGDEVICE: 1290,
  IFCFLOWFITTING: 467,
  IFCDUCTFITTING: 1153,
  IFCPIPEFITTING: 1222,
  IFCCABLECARRIERFITTING: 1111,
  IFCCABLEFITTING: 1113,
  IFCJUNCTIONBOX: 1195,
  IFCFLOWMOVINGDEVICE: 502,
  IFCCOMPRESSOR: 1131,
  IFCFAN: 1177,
  IFCPUMP: 1238,
  IFCFLOWSEGMENT: 574,
  IFCDUCTSEGMENT: 1154,
  IFCPIPESEGMENT: 1223,
  IFCCABLECARRIERSEGMENT: 1112,
  IFCCABLESEGMENT: 1115,
  IFCFLOWSTORAGEDEVICE: 371,
  IFCTANK: 1293,
  IFCELECTRICFLOWSTORAGEDEVICE: 1159,
  IFCFLOWTERMINAL: 46,
  IFCFIRESUPPRESSIONTERMINAL: 1179,
  IFCSANITARYTERMINAL: 1262,
  IFCSTACKTERMINAL: 1277,
  IFCWASTETERMINAL: 1315,
  IFCAIRTERMINAL: 1095,
  IFCMEDICALDEVICE: 1212,
  IFCSPACEHEATER: 1272,
  IFCAUDIOVISUALAPPLIANCE: 1099,
  IFCCOMMUNICATIONSAPPLIANCE: 1127,
  IFCELECTRICAPPLIANCE: 1156,
  IFCLAMP: 1198,
  IFCLIGHTFIXTURE: 1199,
  IFCOUTLET: 1219,
  IFCFLOWTREATMENTDEVICE: 425,
  IFCINTERCEPTOR: 1193,
  IFCDUCTSILENCER: 1155,
  IFCFILTER: 1178,
  IFCDISTRIBUTIONCONTROLELEMENT: 468,
  IFCPROTECTIVEDEVICETRIPPINGUNIT: 1236,
  IFCACTUATOR: 1091,
  IFCALARM: 1098,
  IFCCONTROLLER: 1139,
  IFCFLOWINSTRUMENT: 1181,
  IFCSENSOR: 1264,
  IFCUNITARYCONTROLELEMENT: 1308,
  IFCDISCRETEACCESSORY: 423,
  IFCFASTENER: 535,
  IFCMECHANICALFASTENER: 536,
  IFCREINFORCINGBAR: 571,
  IFCREINFORCINGMESH: 531,
  IFCTENDON: 261,
  IFCTENDONANCHOR: 675,
  IFCBUILDINGELEMENTPART: 220,
  IFCVIBRATIONISOLATOR: 1312,
  IFCCHAMFEREDGEFEATURE: 765,
  IFCROUNDEDEDGEFEATURE: 766,
  IFCOPENINGELEMENT: 498,
  IFCOPENINGSTANDARDCASE: 1217,
  IFCVOIDINGFEATURE: 1313,
  IFCPROJECTIONELEMENT: 384,
  IFCSURFACEFEATURE: 1287,
  IFCFOOTING: 120,
  IFCPILE: 572,
  IFCBEAM: 171,
  IFCBEAMSTANDARDCASE: 1104,
  IFCCOLUMN: 383,
  IFCCOLUMNSTANDARDCASE: 1126,
  IFCCURTAINWALL: 456,
  IFCDOOR: 213,
  IFCDOORSTANDARDCASE: 1151,
  IFCMEMBER: 310,
  IFCMEMBERSTANDARDCASE: 1214,
  IFCPLATE: 351,
  IFCPLATESTANDARDCASE: 1224,
  IFCRAILING: 350,
  IFCRAMP: 414,
  IFCRAMPFLIGHT: 348,
  IFCROOF: 347,
  IFCSLAB: 99,
  IFCSLABELEMENTEDCASE: 1268,
  IFCSLABSTANDARDCASE: 1269,
  IFCSTAIR: 346,
  IFCSTAIRFLIGHT: 25,
  IFCWALL: 452,
  IFCWALLSTANDARDCASE: 453,
  IFCWALLELEMENTEDCASE: 1314,
  IFCWINDOW: 667,
  IFCWINDOWSTANDARDCASE: 1316,
  IFCBUILDINGELEMENTPROXY: 560,
  IFCCOVERING: 382,
  IFCCHIMNEY: 1120,
  IFCSHADINGDEVICE: 1265,
  IFCELEMENTASSEMBLY: 18,
  IFCFURNISHINGELEMENT: 253,
  IFCFURNITURE: 1184,
  IFCSYSTEMFURNITUREELEMENT: 1291,
  IFCTRANSPORTELEMENT: 416,
  IFCVIRTUALELEMENT: 168,
  IFCELECTRICALELEMENT: 23,
  IFCEQUIPMENTELEMENT: 212,
  IFCCIVILELEMENT: 1122,
  IFCGEOGRAPHICELEMENT: 1185,
  IFCDISTRIBUTIONPORT: 178,
  IFCPROXY: 447,
  IFCSTRUCTURALLINEARACTION: 463,
  IFCSTRUCTURALLINEARACTIONVARYING: 464,
  IFCSTRUCTURALPLANARACTION: 39,
  IFCSTRUCTURALPLANARACTIONVARYING: 357,
  IFCSTRUCTURALPOINTACTION: 356,
  IFCSTRUCTURALCURVEACTION: 1279,
  IFCSTRUCTURALSURFACEACTION: 1284,
  IFCSTRUCTURALPOINTREACTION: 354,
  IFCSTRUCTURALCURVEREACTION: 1280,
  IFCSTRUCTURALSURFACEREACTION: 1285,
  IFCSTRUCTURALCURVECONNECTION: 534,
  IFCSTRUCTURALPOINTCONNECTION: 533,
  IFCSTRUCTURALSURFACECONNECTION: 264,
  IFCSTRUCTURALCURVEMEMBER: 224,
  IFCSTRUCTURALCURVEMEMBERVARYING: 227,
  IFCSTRUCTURALSURFACEMEMBER: 420,
  IFCSTRUCTURALSURFACEMEMBERVARYING: 421,
  IFCANNOTATION: 634,
  IFCBUILDING: 169,
  IFCBUILDINGSTOREY: 459,
  IFCSITE: 349,
  IFCSPACE: 454,
  IFCGRID: 564,
  IFCEXTERNALSPATIALELEMENT: 1174,
  IFCSPATIALZONE: 1275
};

function XBinaryReader() {
  this._buffer = null;
  this._position = 0;
}

XBinaryReader.prototype.onloaded = function () {};

XBinaryReader.prototype.onerror = function () {};

XBinaryReader.prototype.load = function (source) {
  this._position = 0;
  var self = this;
  if (typeof source == 'undefined' || source == null) throw 'Source must be defined';

  if (typeof source == 'string') {
    var xhr;
    xhr = new XMLHttpRequest();
    xhr.open("GET", source, true);

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var fReader = new FileReader();

        fReader.onloadend = function () {
          if (fReader.result) {
            //set data buffer for next processing
            self._buffer = fReader.result; //do predefined processing of the data

            if (self.onloaded) {
              self.onloaded();
            }
          }
        };

        fReader.readAsArrayBuffer(xhr.response);
      } //throw exception as a warning


      if (xhr.readyState === 4 && xhr.status !== 200) {
        var msg = 'Failed to fetch binary data from server. Server code: ' + xhr.status + '. This might be due to CORS policy of your browser if you run this as a local file.';
        if (self.onerror) self.onerror(msg);
        throw msg;
      }
    };

    xhr.responseType = 'blob';
    xhr.send();
  } else if (source instanceof Blob || source instanceof File) {
    var fReader = new FileReader();

    fReader.onloadend = function () {
      if (fReader.result) {
        //set data buffer for next processing
        self._buffer = fReader.result; //do predefined processing of the data

        if (self.onloaded) {
          self.onloaded();
        }
      }
    };

    fReader.readAsArrayBuffer(source);
  } else if (source instanceof ArrayBuffer) {
    this._buffer = source;
  }
};

XBinaryReader.prototype.getIsEOF = function (type, count) {
  if (typeof this._position === "undefined") throw "Position is not defined";
  return this._position === this._buffer.byteLength;
};

XBinaryReader.prototype.read = function (arity, count, ctor) {
  var length = arity * count;
  var offset = this._position;
  this._position += length;
  return count === 1 ? new ctor(this._buffer.slice(offset, offset + length))[0] : new ctor(this._buffer.slice(offset, offset + length));
};

XBinaryReader.prototype.readByte = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return this.read(1, count, Uint8Array);
};

XBinaryReader.prototype.readUint8 = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return this.read(1, count, Uint8Array);
};

XBinaryReader.prototype.readInt16 = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return this.read(2, count, Int16Array);
};

XBinaryReader.prototype.readUint16 = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return this.read(2, count, Uint16Array);
};

XBinaryReader.prototype.readInt32 = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return this.read(4, count, Int32Array);
};

XBinaryReader.prototype.readUint32 = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return this.read(4, count, Uint32Array);
};

XBinaryReader.prototype.readFloat32 = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return this.read(4, count, Float32Array);
};

XBinaryReader.prototype.readFloat64 = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return this.read(8, count, Float64Array);
}; //functions for a higher objects like points, colours and matrices


XBinaryReader.prototype.readChar = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var bytes = this.readByte(count);
  var result = new Array(count);

  for (var i = 0; i < count; i++) {
    result[i] = String.fromCharCode(bytes[i]);
  }

  return count === 1 ? result[0] : result;
};

XBinaryReader.prototype.readPoint = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var coords = this.readFloat32(count * 3);
  var result = new Array(count);

  for (var i = 0; i < count; i++) {
    var offset = i * 3 * 4; //only create new view on the buffer so that no new memory is allocated

    result[i] = new Float32Array(coords.buffer, offset, 3);
  }

  return count === 1 ? result[0] : result;
};

XBinaryReader.prototype.readRgba = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var values = this.readByte(count * 4);
  var result = new Array(count);

  for (var i = 0; i < count; i++) {
    var offset = i * 4;
    result[i] = new Uint8Array(values.buffer, offset, 4);
  }

  return count === 1 ? result[0] : result;
};

XBinaryReader.prototype.readPackedNormal = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var values = this.readUint8(count * 2);
  var result = new Array(count);

  for (var i = 0; i < count; i++) {
    result[i] = new Uint8Array(values.buffer, i * 2, 2);
  }

  return count === 1 ? result[0] : result;
};

XBinaryReader.prototype.readMatrix4x4 = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var values = this.readFloat32(count * 16);
  var result = new Array(count);

  for (var i = 0; i < count; i++) {
    var offset = i * 16 * 4;
    result[i] = new Float32Array(values.buffer, offset, 16);
  }

  return count === 1 ? result[0] : result;
};

XBinaryReader.prototype.readMatrix4x4_64 = function () {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var values = this.readFloat64(count * 16);
  var result = new Array(count);

  for (var i = 0; i < count; i++) {
    var offset = i * 16 * 8;
    result[i] = new Float64Array(values.buffer, offset, 16);
  }

  return count === 1 ? result[0] : result;
};

function XModelGeometry() {
  this.meter = 1000;
  this.productMap = {};
}

XModelGeometry.prototype.parse = function (binReader) {
  var _this = this;

  var br = binReader;
  var magicNumber = br.readInt32();
  if (magicNumber !== 94132117) throw 'Magic number mismatch.';
  var version = br.readByte();
  var numShapes = br.readInt32();
  var numVertices = br.readInt32();
  var numTriangles = br.readInt32();
  var numMatrices = br.readInt32();
  var numProducts = br.readInt32();
  var numStyles = br.readInt32();
  this.meter = br.readFloat32();
  var numRegions = br.readInt16(); //create target buffers of correct size (avoid reallocation of memory)

  this.productMap = {};
  this.regions = new Array(numRegions);
  var meter = this.meter !== 0 ? this.meter : 1; // read regions

  for (var i = 0; i < numRegions; i++) {
    this.regions[i] = {
      population: br.readInt32(),
      centre: br.readFloat32(3),
      bbox: br.readFloat32(6)
    };
  } // read colors


  var colorMap = {};

  for (var iStyle = 0; iStyle < numStyles; iStyle++) {
    var colorId = br.readInt32();
    var R = br.readFloat32();
    var G = br.readFloat32();
    var B = br.readFloat32();
    var A = br.readFloat32();
    colorMap[colorId] = [R, G, B, A];
  } // read products


  for (var _i = 0; _i < numProducts; _i++) {
    var productId = br.readInt32();
    var prodType = br.readInt16();
    var bBox = br.readFloat32(6);
    this.productMap[productId] = {
      productID: productId,
      type: prodType,
      bBox: bBox,
      shapes: []
    };
  } // read shapes


  var _loop = function _loop(iShape) {
    var repetition = br.readInt32();
    var shapeList = [];

    for (var iProduct = 0; iProduct < repetition; iProduct++) {
      var prodLabel = br.readInt32();
      var instanceTypeId = br.readInt16();
      var instanceLabel = br.readInt32();
      var styleId = br.readInt32();
      var transformation = null;

      if (repetition > 1) {
        transformation = version === 1 ? br.readFloat32(16) : br.readFloat64(16);
        transformation[12] /= meter;
        transformation[13] /= meter;
        transformation[14] /= meter;
      }

      shapeList.push({
        pLabel: prodLabel,
        iLabel: instanceLabel,
        matrices: transformation,
        color: colorMap[styleId] ? colorMap[styleId] : [1, 1, 1, 1]
      });
    } //read shape geometry


    var shapeGeom = new XTriangulatedShape();
    shapeGeom.parse(br);

    for (var ii = 0; ii < shapeGeom.vertices.length; ii++) {
      shapeGeom.vertices[ii] /= meter;
    }

    var shapeNormals = [];

    for (var ni = 0; ni < shapeGeom.normals.length;) {
      var nU = shapeGeom.normals[ni];
      ni++;
      var nV = shapeGeom.normals[ni];
      ni++;
      var lon = nU / 252.0 * 2.0 * Math.PI;
      var lat = nV / 252.0 * Math.PI;
      var nx = Math.sin(lon) * Math.sin(lat);
      var nz = Math.cos(lon) * Math.sin(lat);
      var ny = Math.cos(lat);
      shapeNormals.push(nx, ny, nz);
    } //copy shape data into inner array and set to null so it can be garbage collected


    shapeList.forEach(function (shape) {
      var map = this.productMap[shape.pLabel];

      if (map !== undefined) {
        map.shapes.push({
          indices: shapeGeom.indices.slice(),
          vertices: shapeGeom.vertices.slice(),
          normals: shapeNormals.slice(),
          matrices: shape.matrices ? shape.matrices.slice() : null,
          color: shape.color
        });
      }
    }, _this);
    shapeGeom = null;
    shapeNormals = null;
  };

  for (var iShape = 0; iShape < numShapes; iShape++) {
    _loop(iShape);
  } //binary reader should be at the end by now


  if (!br.getIsEOF()) {//throw 'Binary reader is not at the end of the file.';
  }
}; //Source has to be either URL of wexBIM file or Blob representing wexBIM file


XModelGeometry.prototype.load = function (source) {
  //binary reading
  var br = new XBinaryReader();
  var self = this;

  br.onloaded = function () {
    self.parse(br);
    if (self.onloaded) self.onloaded();
  };

  br.onerror = function (msg) {
    if (self.onerror) self.onerror(msg);
  };

  br.load(source);
};

XModelGeometry.prototype.onloaded = function () {};

XModelGeometry.prototype.onerror = function () {};

function XTriangulatedShape() {
  this.vertices = [];
  this.indices = [];
  this.normals = [];
} //this will get XBinaryReader on the current position and will parse it's content to fill itself with vertices, normals and vertex indices


XTriangulatedShape.prototype.parse = function (binReader) {
  var self = this;
  var version = binReader.readByte();
  var numVertices = binReader.readInt32();
  var numOfTriangles = binReader.readInt32();
  self.vertices = binReader.readFloat32(numVertices * 3); //allocate memory of defined size (to avoid reallocation of memory)

  self.indices = new Uint32Array(numOfTriangles * 3);
  self.normals = new Uint8Array(numOfTriangles * 6); //indices for incremental adding of indices and normals

  var iIndex = 0;
  var readIndex;

  if (numVertices <= 0xFF) {
    readIndex = function readIndex(count) {
      return binReader.readByte(count);
    };
  } else if (numVertices <= 0xFFFF) {
    readIndex = function readIndex(count) {
      return binReader.readUint16(count);
    };
  } else {
    readIndex = function readIndex(count) {
      return binReader.readInt32(count);
    };
  }

  var numFaces = binReader.readInt32();
  if (numVertices === 0 || numOfTriangles === 0) return;

  for (var i = 0; i < numFaces; i++) {
    var numTrianglesInFace = binReader.readInt32();
    if (numTrianglesInFace === 0) continue;
    var isPlanar = numTrianglesInFace > 0;
    numTrianglesInFace = Math.abs(numTrianglesInFace);

    if (isPlanar) {
      var normal = binReader.readByte(2); //read and set all indices

      var planarIndices = readIndex(3 * numTrianglesInFace);
      self.indices.set(planarIndices, iIndex);

      for (var j = 0; j < numTrianglesInFace * 3; j++) {
        //add three identical normals because this is planar but needs to be expanded for WebGL
        self.normals[iIndex * 2] = normal[0];
        self.normals[iIndex * 2 + 1] = normal[1];
        iIndex++;
      }
    } else {
      for (var _j = 0; _j < numTrianglesInFace; _j++) {
        self.indices[iIndex] = readIndex(); //a

        self.normals.set(binReader.readByte(2), iIndex * 2);
        iIndex++;
        self.indices[iIndex] = readIndex(); //b

        self.normals.set(binReader.readByte(2), iIndex * 2);
        iIndex++;
        self.indices[iIndex] = readIndex(); //c

        self.normals.set(binReader.readByte(2), iIndex * 2);
        iIndex++;
      }
    }
  }
};


"use strict";

function BimLoader() {
  var SELECTION_COLOR = '#6464ff';

  this.load = function (model, quality) {
    return new Promise(function (resolve, reject) {
      var geometry = new XModelGeometry();

      geometry.onloaded = function () {
        var bimModel = new BimModel();
        bimModel.load(model._id, model.url, model.tree);
        loadModel(geometry, bimModel, quality);
        resolve(bimModel);
      };

      geometry.onerror = function (msg) {
        reject(msg);
      };

      geometry.load(model.url);
    });
  };

  function loadModel(_geometry, bimModel, quality) {
    var group = new THREE.Group();
    var opaqueMtl = createMaterial(new THREE.Color(1, 1, 1), false, 1);
    var transMtl = createMaterial(new THREE.Color(1, 1, 1), true, 1); //let selectMtl = createSelectMaterial(SELECTION_COLOR);

    for (var ID in _geometry.productMap) {
      if (!_geometry.productMap.hasOwnProperty(ID)) continue;
      var map = _geometry.productMap[ID];

      if (map.type === XProductType.IFCSPACE || map.type === XProductType.IFCOPENINGELEMENT) {
        continue;
      }

      var geometries = [];
      var trans = false;
      var colors = [];

      for (var j = 0; j < map.shapes.length; j++) {
        var shape = map.shapes[j];

        if (shape.color[3] < 0.99) {
          trans = true;
        } //geometry.setIndex(new THREE.Uint16BufferAttribute(shape.indices, 1));
        //geometry.setAttribute('position', new THREE.Float32BufferAttribute(shape.vertices, 3));
        //geometry.setAttribute('normal', new THREE.Float32BufferAttribute(shape.normals, 3));
        //geometry.setAttribute('uv', new THREE.Float32BufferAttribute(getTexCoordsFromVertices(shape.vertices), 2));
        // let newPosition = new Float32Array(shape.indices.length * 3);
        // for( let i = 0; i < shape.indices.length; i ++){
        //   newPosition[3*i] = shape.vertices[3 * shape.indices[i]];
        //   newPosition[3*i + 1] = shape.vertices[3 * shape.indices[i] + 1];
        //   newPosition[3*i + 2] = shape.vertices[3 * shape.indices[i] + 2];
        // }
        // let newColor = new Float32Array(shape.indices.length * 4);
        // for( let i = 0; i < shape.indices.length; i ++){
        //   newColor[4*i] = shape.color[0];
        //   newColor[4*i + 1] = shape.color[1];
        //   newColor[4*i + 2] = shape.color[2];
        //   newColor[4*i + 3] = shape.color[3];
        // }
        // let newIndices = new Uint16Array(shape.indices.length);
        // for( let i = 0; i < shape.indices.length; i ++){
        //   newIndices[i] = i;
        // }
        // geometry.setAttribute('position', new THREE.Float32BufferAttribute(newPosition, 3));
        // geometry.setAttribute('normal', new THREE.Float32BufferAttribute(shape.normals, 3));
        // geometry.setAttribute('color', new THREE.Float32BufferAttribute(newColor, 4));
        // geometry.setIndex(new THREE.Uint16BufferAttribute(newIndices, 1));


        var baseNormal = new THREE.Vector3(shape.normals[0], shape.normals[1], shape.normals[2]);
        var normalsIndices = [0];

        for (var i = 0; i < shape.indices.length; i++) {
          var norm = new THREE.Vector3(shape.normals[3 * i], shape.normals[3 * i + 1], shape.normals[3 * i + 2]);

          if (baseNormal.dot(norm) > 0.95 || i % 3 > 0) {
            //if ( baseNormal[0] == shape.normals[3*i] && baseNormal[1] == shape.normals[3*i+1] && baseNormal[2] == shape.normals[3*i+2] ) {
            baseNormal = new THREE.Vector3(shape.normals[3 * i], shape.normals[3 * i + 1], shape.normals[3 * i + 2]);
            continue;
          } else {
            baseNormal = new THREE.Vector3(shape.normals[3 * i], shape.normals[3 * i + 1], shape.normals[3 * i + 2]);
            normalsIndices.push(i);
          }
        }

        normalsIndices.push(shape.indices.length);

        for (var _i = 1; _i < normalsIndices.length; _i++) {
          var _geometry2 = new THREE.BufferGeometry();

          var newPosition = new Float32Array((normalsIndices[_i] - normalsIndices[_i - 1]) * 3);

          for (var ii = 0; ii < normalsIndices[_i] - normalsIndices[_i - 1]; ii++) {
            newPosition[3 * ii] = shape.vertices[3 * shape.indices[ii + normalsIndices[_i - 1]] + 0];
            newPosition[3 * ii + 1] = shape.vertices[3 * shape.indices[ii + normalsIndices[_i - 1]] + 1];
            newPosition[3 * ii + 2] = shape.vertices[3 * shape.indices[ii + normalsIndices[_i - 1]] + 2];
          }

          var newColor = new Float32Array((normalsIndices[_i] - normalsIndices[_i - 1]) * 4);

          for (var _ii = 0; _ii < normalsIndices[_i] - normalsIndices[_i - 1]; _ii++) {
            newColor[4 * _ii] = shape.color[0];
            newColor[4 * _ii + 1] = shape.color[1];
            newColor[4 * _ii + 2] = shape.color[2];
            newColor[4 * _ii + 3] = shape.color[3];
          }

          var newNormal = shape.normals.slice(normalsIndices[_i - 1] * 3, normalsIndices[_i] * 3);
          var newIndices = new Uint16Array(normalsIndices[_i] - normalsIndices[_i - 1]);

          for (var _ii2 = 0; _ii2 < shape.indices.length; _ii2++) {
            newIndices[_ii2] = _ii2;
          }

          _geometry2.setAttribute('position', new THREE.Float32BufferAttribute(newPosition, 3));

          _geometry2.setAttribute('normal', new THREE.Float32BufferAttribute(newNormal, 3));

          _geometry2.setAttribute('color', new THREE.Float32BufferAttribute(newColor, 4));

          _geometry2.setAttribute('uv', new THREE.Float32BufferAttribute(getTexCoordsFromVertices(newPosition), 2));

          _geometry2.setIndex(new THREE.Uint16BufferAttribute(newIndices, 1));

          if (shape.matrices) {
            var mat = new THREE.Matrix4();
            mat.elements = shape.matrices;

            _geometry2.applyMatrix4(mat);
          }

          colors.push(shape.color);
          geometries.push(_geometry2);
        }
      }

      var geometry = THREE.BufferGeometryUtils.mergeBufferGeometries(geometries, true);
      geometry.computeBoundingBox();

      if (trans === false) {
        var mesh = new THREE.Mesh(geometry, opaqueMtl);
        group.add(mesh);

        if (quality === 'high') {
          createEdge(mesh);
        }

        var bimObject = new BimObject();
        bimObject.id = ID;
        bimObject.mesh = mesh;
        bimObject.colorOriginal = colors;
        bimModel.addBimObject(ID, bimObject);
        bimObject.materialTrans = transMtl;
        bimObject.materialOpaque = opaqueMtl;
        bimObject.shapes = map.shapes;
      } else {
        var _mesh = new THREE.Mesh(geometry, transMtl);

        group.add(_mesh);

        if (quality === 'high') {
          createEdge(_mesh);
        }

        var _bimObject = new BimObject();

        _bimObject.id = ID;
        _bimObject.mesh = _mesh;
        _bimObject.colorOriginal = colors;
        bimModel.addBimObject(ID, _bimObject);
        _bimObject.materialTrans = transMtl;
        _bimObject.materialOpaque = opaqueMtl;
        _bimObject.shapes = map.shapes;
      }
    }

    bimModel.mesh = group;
  }

  function createEdge(mesh) {
    var edgeMaterial = new THREE.LineBasicMaterial({
      color: new THREE.Color(0, 0, 0),
      transparent: true,
      opacity: 0.7
    });
    if (!Array.isArray(mesh.material)) edgeMaterial.clippingPlanes = mesh.material.clippingPlanes;else edgeMaterial.clippingPlanes = mesh.material[0].clippingPlanes;
    var edges = new THREE.LineSegments(new THREE.EdgesGeometry(mesh.geometry), edgeMaterial);
    edges.name = 'edge';
    mesh.userData.edges = edges;
    mesh.add(edges);
  } // Material functions


  function createMaterial(color, opaque, opacity) {
    var material = new THREE.MeshPhongMaterial({
      color: color,
      vertexColors: true,
      side: THREE.DoubleSide,
      specular: 0x111111,
      shininess: 50,
      //transparent: opacity < 0.99,
      transparent: opaque,
      opacity: opacity
    });
    material.origin = {
      color: color.getStyle(),
      transparent: opaque,
      vertexColors: true,
      opacity: opacity
    };
    return material;
  } // Material functions


  function createSelectMaterial(color) {
    var material = new THREE.MeshPhongMaterial({
      color: color,
      vertexColors: false,
      side: THREE.DoubleSide,
      specular: 0x111111,
      shininess: 50,
      transparent: false
    });
    material.origin = {
      color: color,
      vertexColors: false
    };
    return material;
  } // function createMaterial(color, opacity) {
  //   let material = new THREE.ShaderMaterial({
  //     color: color,
  //     vertexColors: true, 
  //     side: THREE.DoubleSide,
  //     specular: 0x111111,
  //     shininess: 50,
  //     //transparent: opacity < 0.99,
  //     transparent: true,
  //     opacity: 1.0
  //   });
  //   material.origin = {
  //     color: color.getStyle(),
  //     opacity: opacity
  //   };
  //   return material;
  // }


  function getTexCoordsFromVertices(vertices) {
    var coords = [];
    var minX = Number.MAX_SAFE_INTEGER;
    var minY = Number.MAX_SAFE_INTEGER;
    var minZ = Number.MAX_SAFE_INTEGER;
    var maxX = Number.MAX_SAFE_INTEGER * -1;
    var maxY = Number.MAX_SAFE_INTEGER * -1;
    var maxZ = Number.MAX_SAFE_INTEGER * -1;

    for (var i = 0; i < vertices.length; i += 3) {
      var x = vertices[i];
      var y = vertices[i + 1];
      var z = vertices[i + 2];

      if (x > maxX) {
        maxX = x;
      } else if (x < minX) {
        minX = x;
      }

      if (y > maxY) {
        maxY = y;
      } else if (y < minY) {
        minY = y;
      }

      if (z > maxZ) {
        maxZ = z;
      } else if (z < minZ) {
        minZ = z;
      }
    }

    var sx = maxX - minX;
    var sy = maxY - minY;
    var sz = maxZ - minZ;
    var size = (Math.max(sx, sy, sz) + Math.min(sx, sy, sz)) * 0.1;
    var bbox = new THREE.Box3(new THREE.Vector3(-size / 2, -size / 2, -size / 2), new THREE.Vector3(size / 2, size / 2, size / 2));

    var makeUVs = function makeUVs(v0, v1, v2) {
      var bbox_max_size = size; //get normal of the face, to know into which cube side it maps better

      var n = new THREE.Vector3();
      n.crossVectors(v1.clone().sub(v0), v1.clone().sub(v2)).normalize();
      n.x = Math.abs(n.x);
      n.y = Math.abs(n.y);
      n.z = Math.abs(n.z);
      var uv0 = new THREE.Vector2();
      var uv1 = new THREE.Vector2();
      var uv2 = new THREE.Vector2(); // xz mapping

      if (n.y > n.x && n.y > n.z) {
        uv0.x = (v0.x - bbox.min.x) / bbox_max_size;
        uv0.y = (bbox.max.z - v0.z) / bbox_max_size;
        uv1.x = (v1.x - bbox.min.x) / bbox_max_size;
        uv1.y = (bbox.max.z - v1.z) / bbox_max_size;
        uv2.x = (v2.x - bbox.min.x) / bbox_max_size;
        uv2.y = (bbox.max.z - v2.z) / bbox_max_size;
      } else if (n.x > n.y && n.x > n.z) {
        uv0.x = (v0.z - bbox.min.z) / bbox_max_size;
        uv0.y = (v0.y - bbox.min.y) / bbox_max_size;
        uv1.x = (v1.z - bbox.min.z) / bbox_max_size;
        uv1.y = (v1.y - bbox.min.y) / bbox_max_size;
        uv2.x = (v2.z - bbox.min.z) / bbox_max_size;
        uv2.y = (v2.y - bbox.min.y) / bbox_max_size;
      } else if (n.z > n.y && n.z > n.x) {
        uv0.x = (v0.x - bbox.min.x) / bbox_max_size;
        uv0.y = (v0.y - bbox.min.y) / bbox_max_size;
        uv1.x = (v1.x - bbox.min.x) / bbox_max_size;
        uv1.y = (v1.y - bbox.min.y) / bbox_max_size;
        uv2.x = (v2.x - bbox.min.x) / bbox_max_size;
        uv2.y = (v2.y - bbox.min.y) / bbox_max_size;
      }

      return {
        uv0: uv0,
        uv1: uv1,
        uv2: uv2
      };
    };

    for (var vi = 0; vi < vertices.length; vi += 9) {
      var vx0 = vertices[vi];
      var vy0 = vertices[vi + 1];
      var vz0 = vertices[vi + 2];
      var vx1 = vertices[vi + 3];
      var vy1 = vertices[vi + 4];
      var vz1 = vertices[vi + 5];
      var vx2 = vertices[vi + 6];
      var vy2 = vertices[vi + 7];
      var vz2 = vertices[vi + 8];
      var v0 = new THREE.Vector3(vx0, vy0, vz0);
      var v1 = new THREE.Vector3(vx1, vy1, vz1);
      var v2 = new THREE.Vector3(vx2, vy2, vz2);
      var uvs = makeUVs(v0, v1, v2);
      coords.push(uvs.uv0.x, uvs.uv0.y);
      coords.push(uvs.uv1.x, uvs.uv1.y);
      coords.push(uvs.uv2.x, uvs.uv2.y);
    }

    return coords;
  }
}


"use strict";

/**
 * @param planSection {CrossSection}
 * @param plan3d {BimPlan3d}
 */
function BimPlanLoader(planSection, plan3d) {
  /**
   * Load Bim Plan from server data
   * @param viewer {BimViewer}
   * @param plans {[]}
   * @param data {BimData}
   */
  this.load = function (viewer, plans, data) {
    for (var i = 0; i < plans.length; i++) {
      var plan = plans[i];
      loadPlan(viewer, plan, data);
    }
  };

  function loadPlan(viewer, plan, data) {
    var bimPlan = new BimPlan(viewer, planSection, plan3d);
    bimPlan.id = plan._id;
    bimPlan.name = plan.name;
    bimPlan.workLevel = plan.workLevel;
    bimPlan.image = plan.image;
    bimPlan.pdfImage = plan.pdfImage;
    bimPlan.drawing = plan.drawing;
    bimPlan.setNormal(new THREE.Vector3(plan.normal.x, plan.normal.y, plan.normal.z));
    bimPlan.size = plan.size;

    if (bimPlan.size.width === 0) {
      bimPlan.size.width = 20;
    }

    if (bimPlan.size.height === 0) {
      bimPlan.size.width = 20;
    }

    var mesh = new THREE.Mesh(new THREE.PlaneGeometry(bimPlan.size.width, bimPlan.size.height), new THREE.MeshBasicMaterial({
      color: 0xffffff,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.6
    }));
    mesh.geometry.computeBoundingBox();
    mesh.name = 'plan';
    mesh.userData.type = 'plan';
    mesh.userData.unSnapable = true;
    mesh.userData.unClippable = true;
    mesh.matrix.identity();
    var matrix = new THREE.Matrix4();
    matrix.elements = plan.matrix;
    mesh.applyMatrix4(matrix);
    var marker = new THREE.Sprite(new THREE.SpriteMaterial({
      depthTest: false,
      depthWrite: false
    }));
    marker.matrix.identity();
    marker.userData.type = 'plan-marker';
    marker.userData.fixedSize = true;
    marker.userData.unSnapable = true;
    marker.userData.unClippable = true;
    marker.renderOrder = 1000;
    marker.applyMatrix4(matrix);
    viewer.addObject(mesh);
    viewer.addObject(marker);
    bimPlan.mesh = mesh;
    bimPlan.marker = marker;
    data.addPlan(bimPlan);
    bimPlan.setVisible(false);
    bimPlan.setCompleted();
    var textureLoader = new THREE.TextureLoader();
    textureLoader.setCrossOrigin("anonymous");
    textureLoader.load(bimPlan.image, function (texture) {
      texture.flipY = false;
      mesh.material.map = texture;
      mesh.material.needsUpdate = true;
      viewer.setDirty(true);
    }, undefined, function (err) {
      console.error(err);
    });
    textureLoader.load('assets/images/cgviewer/marker-2d.png', function (texture) {
      texture.minFilter = THREE.LinearFilter;
      texture.needsUpdate = true;
      marker.material.map = texture;
      marker.material.needsUpdate = true;
      viewer.setDirty(true);
    }, undefined, function (err) {
      console.error(err);
    });
  }
}


"use strict";

function BimViewer(root, signaler) {
  'use strict';

  this.root = root;
  this.isGPUMode = BimUtils.isGPUAvailable();
  this.quality = 'low'; // data

  this.entities = [];
  this.fixedEntities = []; //canvas size

  this.width = root.offsetWidth || 200;
  this.height = root.offsetHeight || 200; // scenes

  this.scene = undefined;
  this.overlays = []; // render objects

  this.canvas = undefined;
  this.camera = undefined;
  this.renderer = undefined;
  this.composer = undefined;
  this.saoPass = undefined;
  this.animationID = undefined;
  this.cameraCtrl = undefined; // camera control

  this.cameraModel = new CameraModel();
  this.cameraModel.createStandardViews(this);
  this.signaler = signaler; // scene objects

  this.spotLight = undefined; // controller

  this.controller = undefined; // add-ons

  this.origin = undefined;
  this.grid = undefined;
  this.ground = undefined;
  this.axes = undefined;
  this.cameraCube = undefined; // dirty flag

  this.isDirty = false;
  var self = this;
  this.dirLight1 = undefined;
  this.dirLight2 = undefined;

  this.create = function (options) {
    if (options) options.factor = 2;
    options = options || {
      ground: true,
      cube: true,
      factor: 1.5
    }; // create scene

    createScene(options); //init camera

    this.camera = new THREE.PerspectiveCamera(45, this.width / this.height, 2, 1500);
    this.camera.up.set(0, 0, 1);
    this.camera.position.set(-5, -6, 5);
    this.camera.lookAt(new THREE.Vector3(0, 0, 0)); // create renderer

    createRenderer();
    this.cameraCtrl = new CameraControls(this);
    this.cameraCtrl.setSensitivities(undefined, 0.005, undefined);
    this.cameraCtrl.setEnabled(true);
    this.controller = new ViewerController(this);
    this.controller.fitInCorrectionFactor = options.factor;
    this.controller.fitInScene(false);
    this.setCursor('default');

    var animate = function animate() {
      self.cameraCtrl.update();
      self.animationID = requestAnimationFrame(animate);

      if (self.isDirty) {
        self.render();
        self.setDirty(false);
      }
    };

    animate();

    if (this.signaler) {
      this.signaler.cameraControlChanged.add(processFixedEntities);
    }

    return this;
  };

  this.destroy = function () {
    this.entities = [];

    var empty = function empty(elem) {
      while (elem.lastChild) {
        elem.removeChild(elem.lastChild);
      }
    };

    cancelAnimationFrame(this.animationID);
    this.scene = null;
    this.camera = null;
    this.cameraCtrl = null;
    this.renderer.forceContextLoss();
    this.renderer = null;
    empty(this.root);
  };

  this.setVisible = function (visible) {
    if (this.canvas) {
      this.canvas.style.display = visible ? 'block' : 'none';
    }
  };

  function createScene(options) {
    self.scene = new THREE.Scene();

    if (options.background === 'none') {
      self.scene.background = undefined;
    } else if (options.background) {
      self.scene.background = new THREE.Color(options.background);
    } else {
      self.scene.background = new THREE.Color(0xffffff);
    } // lighting -------------
    //ambient light


    var ambLight = new THREE.AmbientLight(0x666666);
    self.scene.add(ambLight); //directional light

    self.dirLight1 = new THREE.DirectionalLight(0xffffff, 1);
    self.dirLight1.position.set(-100, 100, -200);
    self.scene.add(self.dirLight1); //directional light

    self.dirLight2 = new THREE.DirectionalLight(0xffffff, 1);
    self.dirLight2.position.set(100, -100, 200);
    self.scene.add(self.dirLight2); // spot light

    if (self.quality === 'high') {// createSpotLight();
    } //origin


    if (options.origin) {
      self.origin = new Origin(self);
      self.origin.update(self.scene, self.quality);
    } //grid


    if (options.grid) {
      self.grid = new Grid(self);
      self.grid.update(self.scene, self.quality);
    } //ground


    if (options.ground) {
      self.ground = new Ground(self);
    } //axes


    if (options.axes) {
      self.axes = new Axes(self);
      self.axes.update(self.scene, self.quality);
    } //cube


    if (options.cube) {
      self.cameraCube = new CameraCube(self, root);
      self.cameraCube.initialize();
    }
  }

  function createSpotLight() {
    if (self.spotLight) return;
    self.spotLight = new THREE.SpotLight(0x888888, 1);
    self.spotLight.castShadow = true;
    self.spotLight.position.set(200, 200, 300);
    self.spotLight.name = "spotLight";
    self.spotLight.shadow.mapSize.x = 2048;
    self.spotLight.shadow.mapSize.y = 2048;
    self.scene.add(self.spotLight);
  }

  function removeSpotLight() {
    if (self.spotLight) {
      self.scene.remove(self.spotLight);
      self.spotLight = undefined;
    }
  }

  function createRenderer() {
    var devicePixelRatio = window.devicePixelRatio || 1;

    if (THREE.WEBGL.isWebGL2Available()) {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('webgl2', {
        alpha: true,
        antialias: true,
        preserveDrawingBuffer: true
      });
      self.renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        context: context
      });
      console.log('webgl 2.0');
    } else {
      self.renderer = new THREE.WebGLRenderer({
        alpha: true,
        antialias: true,
        preserveDrawingBuffer: true
      });
      console.log('webgl 1.0');
    }

    console.log('PixelRatio', devicePixelRatio);
    self.renderer.setClearColor(0x000000, 0);
    self.renderer.setPixelRatio(devicePixelRatio);
    self.renderer.setSize(self.width, self.height);
    self.renderer.localClippingEnabled = true;
    self.renderer.autoClear = false;
    self.canvas = self.renderer.domElement;
    self.root.appendChild(self.canvas);
  }

  function createComposer() {
    if (!THREE.WEBGL.isWebGL2Available()) return;
    if (self.composer) return;
    var devicePixelRatio = window.devicePixelRatio || 1;
    var size = self.renderer.getDrawingBufferSize(new THREE.Vector2());
    var renderTarget = new THREE.WebGLMultisampleRenderTarget(size.width, size.height, {
      format: THREE.RGBFormat,
      stencilBuffer: false
    });
    self.composer = new THREE.EffectComposer(self.renderer, renderTarget);
    self.composer.setPixelRatio(devicePixelRatio);
    self.ssaoPass = new THREE.SSAOPass(self.scene, self.camera, size.x, size.y); //self.ssaoPass.kernelRadius = 16;

    self.composer.addPass(self.ssaoPass);
  }

  this.addOverlay = function (overlay) {
    this.overlays.push(overlay);
  };

  this.removeOverlay = function (overlay) {
    for (var i = 0; i < this.overlays.length; i++) {
      if (this.overlays[i] === overlay) {
        this.overlays.splice(i, 1);
        break;
      }
    }
  };
  /**
   * add bim model to viewer
   * @param bimModel {BimModel}
   */


  this.addBimModel = function (bimModel) {
    this.addObject(bimModel.mesh);
  };
  /**
   * remove bim model from viewer
   * @param bimModel {BimModel}
   */


  this.removeBimModel = function (bimModel) {
    this.removeObject(bimModel.mesh);
  };

  this.addObject = function (object) {
    if (!object) return;
    this.scene.add(object);
    this.entities.push(object);

    if (object.userData && object.userData.fixedSize) {
      object.userData.scale = object.scale.clone();
      this.fixedEntities.push(object);
    }

    this.signaler.objectAdded.dispatch(object);
    this.setDirty(true);
  };

  this.removeObject = function (object) {
    this.scene.remove(object);
    var index = this.entities.indexOf(object);

    if (0 <= index) {
      this.entities.splice(index, 1);
    }

    if (object.userData && object.userData.fixedSize) {
      var _index = this.fixedEntities.indexOf(object);

      if (0 <= _index) {
        this.fixedEntities.splice(_index, 1);
      }
    }

    this.signaler.objectRemoved.dispatch(object);
    this.setDirty(true);
  };

  this.clear = function () {
    if (this.entities.length <= 0) return;

    for (var i = 0; i < this.entities.length; i++) {
      var object = this.entities[i];
      this.scene.remove(object);
    }

    this.entities = []; // clear camera

    this.camera.up.set(0, 0, 1);
    this.camera.position.set(-5, -6, 5);
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));
    this.setDirty(true);
  };
  /**
   * Renders the view. Must be invoked, if something has changed (e.g. camera position, colors, geometry, ...).
   * Normally, this method will be invoked by the methods that changes something in the view or the model.
   */


  this.render = function () {
    //var t0 = performance.now();
    this.scene.updateMatrixWorld();
    this.renderer.clear();

    if (this.composer) {
      this.composer.render();
    } else {
      this.renderer.render(this.scene, this.camera);
    }

    if (this.overlays.length > 0) {
      for (var i = 0; i < this.overlays.length; i++) {
        this.overlays[i].render(this.renderer, this.camera);
      }
    } //var t1 = performance.now()
    //console.log("Rendering Time " + (t1 - t0) + " milliseconds.")

  };
  /**
   * Changes the size of the canvas to the specified width and height and adapts the camera settings.
   * @param {Number} width - the new width in Pixel
   * @param {Number} height - the new height in Pixel
   */


  this.setSize = function (width, height) {
    var w = width || this.root.clientWidth;
    var h = height || this.root.clientHeight;
    if (w === 0 || h === 0) return;
    this.width = w;
    this.height = h;
    this.camera.aspect = w / h;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(w, h);

    if (this.composer) {
      this.composer.setSize(w, h);
    }

    this.setDirty(true);
  };

  this.setDirty = function (value) {
    this.isDirty = value;
  };

  this.setDragAction = function (mode) {
    this.cameraCtrl.setDragAction(mode);
  };

  this.setCursor = function (cursor, isUrl, isUp) {
    if (isUrl) {
      var cursorStyle;

      if (isUp) {
        cursorStyle = "url('/assets/images/cgviewer/cursor/" + cursor + ".png'), auto";
      } else {
        cursorStyle = "url('/assets/images/cgviewer/cursor/" + cursor + ".png') 0 25, auto";
      }

      this.root.style.cursor = cursorStyle;
    } else {
      this.root.style.cursor = cursor;
    }
  };
  /**
   * Changes the mode of camera control.
   * @param {String} mode - default or walk mode
   */


  this.setCameraMode = function (mode) {
    mode = mode.toLowerCase();
    this.cameraCtrl.setMode(mode);

    if (this.cameraCube) {
      this.cameraCube.setVisible(mode === 'default');
    }
  };
  /**
   * change camera control by direction
   * @param dir {{x: Number, y: Number}}
   */


  this.changeWalkCameraControl = function (dir) {
    this.cameraCtrl.goDirection(dir);
  };

  this.getCameraZoom = function () {
    var ratio = 1;
    var originDist = 627.231;
    var vec = new THREE.Vector3();
    var pos = new THREE.Vector3();
    var camera = this.camera;
    vec.set(0, 0, 0.5);
    vec.unproject(camera);
    vec.sub(camera.position).normalize();
    var distance = -camera.position.z / vec.z;
    pos.copy(camera.position).add(vec.multiplyScalar(distance));
    var difVec = pos.sub(camera.position);
    var currentDist = difVec.length();

    if (currentDist > 1E-20) {
      ratio = currentDist / originDist;
    }

    return ratio;
  };

  this.updateCameraRotation = function (angleX, angleY) {
    if (this.cameraCube) {
      this.cameraCube.rotateCamera(angleX, angleY);
    }
  };

  this.rotateCamera = function (angleX, angleY) {
    this.cameraCtrl.rotateCameraByAngle(angleX, angleY);
    this.setDirty(true);
  };
  /**
   * @param isAnimated {Boolean}
   */


  this.fitScreen = function (isAnimated) {
    var bbox = this.controller.fitInScene(isAnimated);
    this.controller.setInitialRotationPoint(bbox);
    this.controller.updateScene(bbox);
  };

  this.fitInBimModel = function (bimModel, isAnimated) {
    var bbox = this.controller.fitInBimModel(bimModel, isAnimated);
    this.controller.setInitialRotationPoint(bbox);
    this.controller.updateScene(bbox);
  };

  this.fitInBimObject = function (bimObject, isAnimated) {
    this.controller.fitInBimObject(bimObject, isAnimated);
  };
  /**
   * set theme to viewer
   * @param theme
   */


  this.setTheme = function (theme) {
    if (theme.empty) {
      if (this.canvas) {
        this.canvas.style.backgroundImage = 'linear-gradient(to bottom, #ffffff, #f5f5f5, #ececec, #e2e2e2, #d9d9d9,' + ' #d2d2d2, #cbcbcb, #c4c4c4, #bdbdbe, #b7b6b7, #b0b0b1, #aaa9aa)';
      }

      if (this.ground) {
        this.ground.removeFromScene(this.scene);
        this.ground = undefined;
      }

      if (!this.grid) {
        this.grid = new Grid(this);
        this.grid.update(this.scene, this.quality);
      }

      if (!this.axes) {
        this.axes = new Axes(this);
        this.axes.update(this.scene, this.quality);
      }
    } else {
      if (this.canvas) {
        this.canvas.style.background = 'transparent';
      }

      if (this.grid) {
        this.grid.removeFromScene(this.scene);
        this.grid = undefined;
      }

      if (this.axes) {
        this.axes.removeFromScene(this.scene);
        this.axes = undefined;
      }

      if (this.ground) {
        this.ground.setImage(theme.space, theme.ground);
      } else {
        this.ground = new Ground(this);
        this.ground.update(this.scene, this.quality);
        this.ground.setImage(theme.space, theme.ground);
      }
    }

    this.fitScreen(false);
  };
  /**
   * set viewer render quality
   * @param quality {String} medium | high | row
   */


  this.setQuality = function (quality) {
    var oldQuality = this.quality;
    if (oldQuality === quality) return false;
    this.quality = quality;
    self.dirLight1.intensity = 1.0;
    self.dirLight2.intensity = 1.0;

    if (quality === 'xlow') {
      self.dirLight1.intensity = 0.5;
      self.dirLight2.intensity = 0.5;
    }

    if (quality === 'high') {
      // createSpotLight();
      createComposer();
      this.renderer.shadowMap.enabled = true;
    } else if (quality === 'medium') {
      removeSpotLight();
      this.renderer.shadowMap.enabled = false;
      createComposer();
    } else {
      removeSpotLight();
      this.renderer.shadowMap.enabled = false;
      this.saoPass = undefined;
      this.composer = undefined;
    }

    if (oldQuality === 'high' || this.quality === 'high') {
      if (this.ground) {
        this.ground.setQuality(quality);
      }
    }

    return true;
  };
  /**
   * change camera viewport
   * @param type {String}
   */


  this.setCameraViews = function (type) {
    this.cameraModel.setCameraView(type);

    if (this.cameraCube) {
      this.cameraCube.setCameraView(type);
    }
  };

  this.getCameraData = function () {
    var data = {};

    if (this.camera) {
      data.camera = this.camera.matrix.toArray();
    }

    if (this.cameraCtrl) {
      var point = this.cameraCtrl.rotationPoint;
      data.point = point.toArray();
    }

    if (this.cameraCube) {
      data.cube = this.cameraCube.camera.matrix.toArray();
    }

    return data;
  };

  this.setCameraData = function (bimModel, cameraData) {
    var camera = this.camera;
    camera.matrix.fromArray(cameraData.camera);
    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
    this.cameraCtrl.rotationPoint.fromArray(cameraData.point);
    this.setDirty(true);

    if (this.cameraCube && cameraData.cube) {
      var cubeCamera = this.cameraCube.camera;
      cubeCamera.matrix.fromArray(cameraData.cube);
      cubeCamera.matrix.decompose(cubeCamera.position, cubeCamera.quaternion, cubeCamera.scale);
      this.cameraCube.setDirty(true);
    }
  };

  this.getImage = function () {
    this.renderer.setClearColor(0xffffff);
    this.renderer.domElement.backgroundColor = 'white';
    this.renderer.setPixelRatio(2);
    this.render();
    var image = this.renderer.domElement.toDataURL("image/jpeg", 1.0);
    this.renderer.setClearColor(0x000000, 0);
    this.renderer.setPixelRatio(window.devicePixelRatio || 1);
    return {
      data: image,
      width: this.renderer.domElement.width,
      height: this.renderer.domElement.height
    };
  };

  function processFixedEntities(camera) {
    var pixelRatio = window.devicePixelRatio || 1;
    var scaleVector = new THREE.Vector3();
    var scaleFactor = 26;

    for (var i = 0; i < self.fixedEntities.length; i++) {
      var object = self.fixedEntities[i];
      var length = scaleVector.subVectors(object.position, camera.position).length();
      var scale = length / scaleFactor * pixelRatio;
      var orgScale = object.userData.scale;

      if (orgScale) {
        object.scale.set(orgScale.x * scale, orgScale.y * scale, orgScale.z * scale);
      } else {
        object.scale.set(scale, scale, scale);
      }
    }
  }
}


"use strict";

// common constants
var VP = {
  Constants: {
    POLYGON_RANGE: 10,
    SNAP_THRESHOLD: 66,
    PAN_MOVE_SCALE: 10,
    ZERO: 1e-10
  },
  // type of drawing tool
  DrawerType: {
    pan: 'pan',
    circle: 'circle',
    curve: 'curve',
    freecurve: 'freecurve',
    icon: 'icon',
    line: 'line',
    polyline: 'polyline',
    freeline: 'freeline',
    arrowline: 'arrowline',
    rect: 'rect',
    sector: 'sector',
    wall: 'wall',
    operator: 'operator',
    text: 'text',
    calibrator: 'calibrator',
    angle: 'angle',
    area: 'area',
    length: 'length',
    zoom: 'zoom',
    color: 'color',
    marker: 'marker'
  },
  // type of drawing method
  DrawingType: {
    none: 'none',
    rectangle: 'rect',
    circle: 'circle',
    sector: 'sector',
    line: 'line',
    freeline: 'freeline',
    arrowline: 'arrowline',
    polyline: 'polyline',
    polygon: 'polygon',
    hexagon: 'hexagon',
    arc: 'arc',
    curve: 'curve',
    freecurve: 'freecurve',
    wall: 'wall',
    text: 'text',
    bubble: 'bubble',
    icon: 'icon',
    eraser: 'eraser',
    bucket: 'bucket',
    calibrator: 'calibrator',
    distance: 'distance',
    angle: 'angle',
    area: 'area',
    front: 'front',
    back: 'back',
    zoom: 'zoom',
    color: 'color',
    image: 'image',
    complex: 'complex'
  },
  Units: ['inch', 'm', 'cm', 'mm', 'ft', 'km', 'mile'],
  DashType: {
    DashA: 1,
    DashB: 2,
    DashC: 3,
    DashE: 4
  }
};


"use strict";

var VPUtils = {
  generateId: function generateId(object, type) {
    if (object.info === undefined) {
      object.info = {
        area: 0
      };
    }

    object.info.id = ExtUtils.bsonId();
    object.info.type = type;
    object.info.name = type;
  },
  getId: function getId(object) {
    return object.info ? object.info.id : ExtUtils.bsonId();
  },
  isTypeOf: function isTypeOf(object, type) {
    return object && object.info && type === object.info.type;
  },
  isDataObject: function isDataObject(object) {
    if (!object) return false;
    if (!object.info) return true;
    return object.info.type === VP.DrawingType.rectangle || object.info.type === VP.DrawingType.circle || object.info.type === VP.DrawingType.sector || object.info.type === VP.DrawingType.line || object.info.type === VP.DrawingType.freeline || object.info.type === VP.DrawingType.arrowline || object.info.type === VP.DrawingType.polyline || object.info.type === VP.DrawingType.polygon || object.info.type === VP.DrawingType.hexagon || object.info.type === VP.DrawingType.wall || object.info.type === VP.DrawingType.arc || object.info.type === VP.DrawingType.curve || object.info.type === VP.DrawingType.freecurve || object.info.type === VP.DrawingType.text || object.info.type === VP.DrawingType.bubble || object.info.type === VP.DrawingType.icon || object.info.type === VP.DrawingType.complex;
  },
  setArea: function setArea(object, area) {
    checkObjectInfo(object);
    object.info.area = area;
  },
  setPerimeter: function setPerimeter(object, perimeter) {
    checkObjectInfo(object);
    object.info.perimeter = perimeter;
  },
  setPerimeterIn: function setPerimeterIn(object, perimeterIn) {
    checkObjectInfo(object);
    object.info.perimeterIn = perimeterIn;
  },
  setZHeight: function setZHeight(object, height) {
    checkObjectInfo(object);
    object.info.zHeight = height;
  },
  area: function area(object) {
    return object && object.info && object.info.area ? object.info.area : 0;
  },
  perimeter: function perimeter(object) {
    return object && object.info && object.info.perimeter ? object.info.perimeter : 0;
  },
  perimeterIn: function perimeterIn(object) {
    return object && object.info && object.info.perimeterIn ? object.info.perimeterIn : 0;
  },
  zHeight: function zHeight(object) {
    return object && object.info ? object.info.zHeight : undefined;
  },
  setProperty: function setProperty(object, property, value) {
    if (object.type === 'group') {
      var objects = object.getObjects();

      for (var i = 0; i < objects.length; i++) {
        var child = objects[i];
        child.set(property, value);
      }

      object.set(property, value);
    } else {
      object.set(property, value);
    }
  },
  polygonArea: function polygonArea(points) {
    var area = 0;
    var numPoints = points.length;
    var j = numPoints - 1;
    var i;

    for (i = 0; i < numPoints; i++) {
      area = area + (points[j].x + points[i].x) * (points[j].y - points[i].y);
      j = i; //j is previous vertex to i
    }

    return Math.abs(area / 2);
  },
  getPerimeterFromPoints: function getPerimeterFromPoints(points) {
    var perimeter = 0;

    if (points.length > 1) {
      var firsPos = points[0];
      var secondPos;

      for (var i = 1; i < points.length; i++) {
        secondPos = points[i];
        perimeter += VPUtils.distanceOf(firsPos, secondPos);
        firsPos = points[i];
      }
    }

    return perimeter;
  },
  getMinMaxPos: function getMinMaxPos(pts) {
    var minX = 1e20;
    var minY = 1e20;

    for (var i = 0; i < pts.length; i++) {
      if (pts[i].x < minX) minX = pts[i].x;
      if (pts[i].y < minY) minY = pts[i].y;
    }

    return {
      minX: minX,
      minY: minY
    };
  },
  getTransformedPath: function getTransformedPath(obj) {
    var matrix = obj.calcTransformMatrix();
    var pts = getAllPointsFromPath(obj);
    var minX = 1e20;
    var minY = 1e20;

    for (var i = 0; i < pts.length; i++) {
      if (pts[i].x < minX) minX = pts[i].x;
      if (pts[i].y < minY) minY = pts[i].y;
    }

    var transformedPoints = [];

    for (var _i = 0; _i < obj.path.length; _i++) {
      var newItem = [];
      var item = obj.path[_i];
      newItem.push(item[0]);

      switch (item[0]) {
        case 'M':
        case 'L':
        case 'Q':
          for (var j = 1; j < item.length; j += 2) {
            var _valueX = item[j];
            var _valueY = item[j + 1];

            if (!isNaN(_valueX) && !isNaN(_valueY)) {
              var newPt = new fabric.Point(_valueX - minX - obj.width / 2, _valueY - minY - obj.height / 2);
              newPt = fabric.util.transformPoint(newPt, matrix);
              newItem.push(newPt.x);
              newItem.push(newPt.y);
            }
          }

          break;

        case 'A':
          for (var _j = 1; _j < 6; _j++) {
            newItem.push(item[_j]);
          }

          var valueX = item[6];
          var valueY = item[7];

          if (!isNaN(valueX) && !isNaN(valueY)) {
            var _newPt = new fabric.Point(valueX - minX - obj.width / 2, valueY - minY - obj.height / 2);

            _newPt = fabric.util.transformPoint(_newPt, matrix);
            newItem.push(_newPt.x);
            newItem.push(_newPt.y);
          }

          break;

        default:
          break;
      }

      transformedPoints.push(newItem);
    }

    function getAllPointsFromPath(obj) {
      var points = [];

      for (var _i2 = 0; _i2 < obj.path.length; _i2++) {
        var _item = obj.path[_i2];

        switch (_item[0]) {
          case 'M':
            if (_item.length > 2) {
              var _valueX2 = _item[1];
              var _valueY2 = _item[2];

              if (!isNaN(_valueX2) && !isNaN(_valueY2)) {
                points.push({
                  x: _valueX2,
                  y: _valueY2
                });
              }
            }

            break;

          case 'Q':
            if (_item.length > 4) {
              var _valueX3 = _item[1];
              var _valueY3 = _item[2];

              if (!isNaN(_valueX3) && !isNaN(_valueY3)) {
                points.push({
                  x: _valueX3,
                  y: _valueY3
                });
              }

              _valueX3 = _item[3];
              _valueY3 = _item[4];

              if (!isNaN(_valueX3) && !isNaN(_valueY3)) {
                points.push({
                  x: _valueX3,
                  y: _valueY3
                });
              }
            }

            break;

          case 'L':
            if (_item.length > 2) {
              var _valueX4 = _item[1];
              var _valueY4 = _item[2];

              if (!isNaN(_valueX4) && !isNaN(_valueY4)) {
                points.push({
                  x: _valueX4,
                  y: _valueY4
                });
              }
            }

            break;

          case 'A':
            if (_item.length > 7) {
              var _valueX5 = _item[6];
              var _valueY5 = _item[7];

              if (!isNaN(_valueX5) && !isNaN(_valueY5)) {
                points.push({
                  x: _valueX5,
                  y: _valueY5
                });
              }
            }

            break;

          default:
            break;
        }
      }

      return points;
    }

    return transformedPoints;
  },
  getScaleRatio: function getScaleRatio(input, output) {
    var scale = convertToMeter(input);
    var scaleTmp = convertToMeter(output);
    scale /= scaleTmp;

    function convertToMeter(unit) {
      var ratio = 1;

      switch (unit) {
        case 'inch':
          ratio = 0.0254;
          break;

        case 'm':
          ratio = 1;
          break;

        case 'cm':
          ratio = 0.01;
          break;

        case 'mm':
          ratio = 0.001;
          break;

        case 'ft':
          ratio = 0.3048;
          break;

        case 'km':
          ratio = 1000;
          break;

        case 'mile':
          ratio = 1609.34;
          break;

        default:
          break;
      }

      return ratio;
    }

    return scale;
  },
  getUnitDimension: function getUnitDimension(string) {
    var result = false;
    var index = string.indexOf('2');

    if (index >= 0) {
      result = {
        dim: 2,
        unit: string.slice(0, index)
      };
    } else {
      index = string.indexOf('3');

      if (index >= 0) {
        result = {
          dim: 3,
          unit: string.slice(0, index)
        };
      }
    }

    if (!result) {
      var subs = string.split('.');
      if (subs.length === 0 || subs.length > 2) return result;

      if (subs.length === 1) {
        result = {
          dim: 1,
          unit: string
        };
      } else {
        if (subs[0] === 'sq') {
          result = {
            dim: 2,
            unit: subs[1]
          };
        } else if (subs[0] === 'cu') {
          result = {
            dim: 3,
            unit: subs[1]
          };
        }
      }
    }

    return result;
  },
  checkUnitDefined: function checkUnitDefined(unit) {
    var newUnit = unit;

    if (newUnit === 'mt') {
      newUnit = 'm';
    }

    if (newUnit === 'in') {
      newUnit = 'inch';
    }

    if (VP.Units.indexOf(newUnit) >= 0) {
      return newUnit;
    } else {
      return false;
    }
  },
  getZIndex: function getZIndex(object, canvas) {
    return canvas.getObjects().indexOf(object);
  },
  findNearestIntersectingObj: function findNearestIntersectingObj(object, canvas) {
    var objects = canvas.getObjects();
    var index = objects.indexOf(object);
    var result;

    for (var i = index - 1; i >= 0; i--) {
      var obj = objects[i];

      if (obj.intersectsWithObject(object) && (!obj.info || !obj.info.backgroundImage)) {
        result = obj;
        break;
      }
    }

    return result;
  },
  getArea: function getArea(object, sX, sY) {
    var area = 0;

    if (object.get) {
      //check if object is fabric object
      area = object && object.info && object.info.area ? object.info.area : 0;
    } else {
      var type = object.type;
      var scaleX = sX ? sX : object.scaleX ? object.scaleX : 1;
      var scaleY = sY ? sY : object.scaleY ? object.scaleY : 1;
      var width = object.strokeWidth + object.width;
      var height = object.strokeWidth + object.height;

      if (type) {
        switch (type) {
          case 'rect':
            area = width * height * scaleX * scaleY;
            break;

          case 'circle':
            var radius = object.strokeWidth * 0.5 + object.radius;
            area = Math.PI * radius * radius * scaleX * scaleX;
            break;

          case 'polygon':
            area = VPUtils.area(object);
            break;

          default:
            area = width * height * scaleX * scaleX;
            break;
        }
      }
    }

    return area;
  },
  getPerimeter: function getPerimeter(object, sX, sY) {
    var perimeter = 0;
    var type;

    if (object.get) {
      //check if object is fabric object
      type = object.get('type');
    } else {
      type = object.type;
    }

    var scaleX = sX ? sX : object.scaleX ? object.scaleX : 1;
    var scaleY = sY ? sY : object.scaleY ? object.scaleY : 1;
    var width = object.strokeWidth + object.width;
    var height = object.strokeWidth + object.height;

    if (type) {
      switch (type) {
        case 'rect':
          perimeter = 2 * (width * scaleX + height * scaleY);
          break;

        case 'circle':
          var radius = object.strokeWidth * 0.5 + object.radius;
          perimeter = 2 * Math.PI * radius * scaleX;
          break;

        case 'polygon':
          perimeter = VPUtils.perimeter(object);
          break;

        default:
          perimeter = 2 * (width * scaleX + height * scaleY);
          break;
      }
    }

    return perimeter;
  },
  getAreaWithClipPath: function getAreaWithClipPath(object) {
    var area = 0;
    var group = object.clipPath;

    if (group) {
      var objects = group._objects;
      var sx = object.scaleX;
      var sy = object.scaleY;

      for (var i = 0; i < objects.length; i++) {
        area += VPUtils.getArea(objects[i], sx, sy);
      }
    }

    return area;
  },
  pixel2RealUnitValue: function pixel2RealUnitValue(calibration, value, isInverted) {
    if (isInverted) {
      return value / calibration;
    } else {
      return value * calibration;
    }
  },
  getFontSizeFromStroke: function getFontSizeFromStroke(strokeWidth) {
    var fontSize = 15;
    var fontWeight = 300;

    if (strokeWidth < 1) {
      fontWeight = 200;
    }

    fontSize = fontSize * strokeWidth;
    if (fontSize < 2) fontSize = 2;
    if (fontSize > 20) fontSize = 20;
    return {
      fontSize: fontSize,
      fontWeight: fontWeight
    };
  },
  dot: function dot(vec1, vec2) {
    return vec1.x * vec2.x + vec1.y * vec2.y;
  },
  crossDot: function crossDot(vec1, vec2) {
    return Math.abs(vec1.x * vec2.y - vec1.y * vec2.x);
  },
  distance: function distance(vector) {
    return Math.sqrt(vector.x * vector.x + vector.y * vector.y);
  },
  distanceOf: function distanceOf(p1, p2) {
    var vector = {
      x: p2.x - p1.x,
      y: p2.y - p1.y
    };
    return Math.sqrt(vector.x * vector.x + vector.y * vector.y);
  },
  multiplyScalar: function multiplyScalar(vec, scalar) {
    return {
      x: vec.x * scalar,
      y: vec.y * scalar
    };
  },
  add: function add(vec1, vec2) {
    return {
      x: vec1.x + vec2.x,
      y: vec1.y + vec2.y
    };
  },
  sub: function sub(vec1, vec2) {
    return {
      x: vec1.x - vec2.x,
      y: vec1.y - vec2.y
    };
  },
  newVector: function newVector(x, y) {
    return {
      x: x,
      y: y
    };
  },
  clone: function clone(vec) {
    return {
      x: vec.x,
      y: vec.y
    };
  },
  normalize: function normalize(vec) {
    var d = Math.sqrt(vec.x * vec.x + vec.y * vec.y);
    return {
      x: vec.x / d,
      y: vec.y / d
    };
  },
  getStraightLine2d: function getStraightLine2d(firstPos, lastPos) {
    var newPos = {
      x: lastPos.x,
      y: lastPos.y
    };
    var dx = Math.abs(lastPos.x - firstPos.x);
    var dy = Math.abs(lastPos.y - firstPos.y);

    if (dx > dy) {
      newPos.y = firstPos.y;
    } else {
      newPos.x = firstPos.x;
    }

    return newPos;
  },
  getPenetration: function getPenetration(shape) {
    if (shape.info && shape.info.type === VP.DrawingType.complex) {
      return {
        area: this.getAreaWithClipPath(shape),
        perimeter: this.perimeterIn(shape)
      };
    }

    return {
      area: 0,
      perimeter: 0
    };
  }
};

function checkObjectInfo(object) {
  if (object.info === undefined) {
    object.info = {
      id: ExtUtils.bsonId(),
      name: ''
    };
  }
}


"use strict";

function VPEventPool(viewer) {
  'use strict';

  var self = this;
  this.events = {
    'mouse:down': [],
    'mouse:move': [],
    'mouse:up': [],
    'mouse:wheel': [],
    'mouse:dblclick': [],
    'mouse:over': [],
    'mouse:out': [],
    'contextmenu': [],
    'object:added': [],
    'object:removed': [],
    'object:selected': [],
    'object:dblclick': [],
    'object:modified': [],
    'pan:start': [],
    'pan:move': [],
    'pan:end': [],
    'draw:dragging': [],
    'keydown': [],
    'keyup': [],
    'onkeydown': [],
    'onkeyup': [],
    'shortcut:redo': [],
    'shortcut:undo': [],
    'shortcut:copy': [],
    'shortcut:paste': [],
    'shortcut:showInformation': [],
    'shortcut:mirrow': [],
    'shortcut:copyDrag': [],
    'shortcut:normalDrag': [],
    'updateDrawer': [],
    'marker:click': []
  };

  this.destroy = function () {
    $('.upper-canvas').unbind('contextmenu', contextMenu);
    viewer.canvas.off('mouse:down', mouseDown);
    viewer.canvas.off('mouse:move', mouseMove);
    viewer.canvas.off('mouse:up', mouseUp);
    viewer.canvas.off('mouse:wheel', mouseWheel);
    viewer.canvas.off('selection:created', selectionChanged);
    viewer.canvas.off('selection:updated', selectionChanged);
    viewer.canvas.off('selection:cleared', selectionCleared);
    viewer.canvas.off('mouse:dblclick', mouseDblClick);
    viewer.canvas.off('mouse:over', mouseOver);
    viewer.canvas.off('mouse:out', mouseOut);
    viewer.canvas.off('object:modified', objectModified);
    viewer.canvas.off("after:render", afterRender);
    document.removeEventListener('keydown', keyDown, false);
    document.removeEventListener('keyup', keyUp, false);
  };

  self.broadcast = function (type, e) {
    var event = self.events[type];

    if (event) {
      for (var i in event) {
        if (event.hasOwnProperty(i) && event[i]) {
          event[i](e);
        }
      }
    }
  };

  self.on = function (type, func) {
    if (self.events[type] === undefined) {
      self.events[type] = [];
    }

    self.events[type].push(func);
  };

  self.off = function (type, func) {
    self.events[type].splice(self.events[type].indexOf(func), 1);
  };

  function mouseDown(e) {
    self.broadcast('mouse:down', e);
  }

  function mouseMove(e) {
    self.broadcast('mouse:move', e);
    var object = viewer.canvas.getActiveObject();
    var pointer = viewer.canvas.getPointer(e.e);
    self.broadcast('pointer:changed', {
      x: round(pointer.x, 0),
      y: round(pointer.y, 0),
      object: object
    });
  }

  function mouseOver(e) {
    self.broadcast('mouse:over', e);
  }

  function mouseOut(e) {
    self.broadcast('mouse:out', e);
  }

  function mouseUp(e) {
    self.broadcast('mouse:up', e);
  }

  function mouseWheel(e) {
    self.broadcast('mouse:wheel', e);
  }

  function mouseDblClick(e) {
    if (viewer.drawingTool || e.target == null || e.target.info && (e.target.info.isMeasureShape || e.target.info.backgroundImage || e.target.info.isTextShape)) {
      return;
    }

    var shape = e.target;
    var object = viewer.data.get(shape);
    self.broadcast('object:dblclick', {
      object: object,
      x: e.pointer.x,
      y: e.pointer.y
    });
  }

  function contextMenu(e) {
    e.preventDefault();
    self.broadcast('contextmenu', {
      x: e.clientX,
      y: e.clientY
    });
  }

  function selectionChanged(e) {
    var shape = e.target;
    var object = viewer.data.get(shape);

    if (VPUtils.isTypeOf(shape, VP.DrawingType.text)) {
      self.broadcast('text:selected', shape);
    } else {
      self.broadcast('object:selected', object);
    }
  }

  function selectionCleared() {
    self.broadcast('selection:cleared');
  }

  function keyDown(e) {
    if (!e.key) return;
    self.keyStatus = 'normal';
    var key = e.key.toLowerCase();

    if (key === 'escape' || key === 'esc' || e.keyCode === 27) {
      self.broadcast('drawing:escape', e);
    } else if (e.ctrlKey && e.shiftKey && e.keyCode === 90) {
      // Ctrl + Shift + Z
      self.broadcast('shortcut:redo');
    } else if (e.ctrlKey && e.altKey && e.keyCode === 67) {
      //Ctrl + alt + C
      self.broadcast('shortcut:copyDrag');
    } else if (e.ctrlKey && e.keyCode === 67) {
      //Ctrl + C
      self.broadcast('shortcut:copy');
    } else if (e.ctrlKey && e.keyCode === 86) {
      //Ctrl + V
      self.broadcast('shortcut:paste');
    } else if (e.ctrlKey && e.keyCode === 90) {
      //Ctrl + Z
      self.broadcast('shortcut:undo');
    } else if (e.ctrlKey && e.keyCode === 73) {
      // Ctrl + I
      self.broadcast('shortcut:showInformation');
    } else if (e.ctrlKey && e.keyCode === 77) {
      // Ctrl + M
      self.broadcast('shortcut:mirrow');
    } else if (e.shiftKey) {
      // Shift
      self.keyStatus = 'shortcut:shift';
    } else if (e.ctrlKey) {
      // Ctrl
      self.keyStatus = 'shortcut:ctrl';
    } else if (e.keyCode === 46) {
      //delete
      viewer.deleteCurrentObject();
    } else if (e.keyCode === 32) {
      // spacebar
      self.broadcast('drawing:deactivate', e);
    } else {//TODO: add other event later.
    }

    self.broadcast('keydown', self.keyStatus);
    self.broadcast('onkeydown', e);
  }

  function keyUp(e) {
    if (!e.key) return;
    self.keyStatus = 'none';
    self.broadcast('keyup', self.keyStatus);
    self.broadcast('onkeyup', e);
  }

  function objectModified(e) {
    var shape = e.target;
    var object = viewer.data.get(shape);

    if (object) {
      self.broadcast('object:modified', object);
    }
  }

  function afterRender(e) {
    self.broadcast('after:render', e);
  }

  function round(number, fraction) {
    return number !== undefined ? Math.round(number * Math.pow(10, fraction)) / Math.pow(10, fraction) : 0;
  }

  $('.upper-canvas').bind('contextmenu', contextMenu);
  viewer.canvas.on('mouse:down', mouseDown);
  viewer.canvas.on('mouse:move', mouseMove);
  viewer.canvas.on('mouse:up', mouseUp);
  viewer.canvas.on('mouse:wheel', mouseWheel);
  viewer.canvas.on('selection:created', selectionChanged);
  viewer.canvas.on('selection:updated', selectionChanged);
  viewer.canvas.on('selection:cleared', selectionCleared);
  viewer.canvas.on('mouse:dblclick', mouseDblClick);
  viewer.canvas.on('mouse:over', mouseOver);
  viewer.canvas.on('mouse:out', mouseOut);
  viewer.canvas.on('object:modified', objectModified);
  viewer.canvas.on("after:render", afterRender);
  document.addEventListener('keydown', keyDown, false);
  document.addEventListener('keyup', keyUp, false);
}


"use strict";

function VPHistory(viewer) {
  'use strict';

  var self = this;
  var canvas = viewer.canvas;
  canvas.counter = 0;
  var states = [];
  var mods = 0;
  canvas.on('object:modified', updateModifications);
  canvas.on('drawing:update', updateModifications);
  canvas.on('project:loaded', initialize);
  this.enabled = true;

  this.setEnabled = function (enable) {
    self.enabled = enable;
  };

  this.undo = function () {
    if (mods < states.length && states.length - 1 - mods - 1 >= 0) {
      viewer.addFromJSON(states[states.length - 1 - mods - 1].json, states[states.length - 1 - mods - 1].planData, true);
      mods += 1;
    }
  };

  this.redo = function () {
    if (mods > 0) {
      viewer.addFromJSON(states[states.length - 1 - mods + 1].json, states[states.length - 1 - mods + 1].planData, true);
      mods -= 1;
    }
  };

  viewer.on('shortcut:redo', self.redo);
  viewer.on('shortcut:undo', self.undo);

  function updateModifications() {
    if (self.enabled) {
      var json = viewer.getJSON();
      var planData = viewer.getPlanData();
      states.push({
        json: json,
        planData: planData
      });
    }
  }

  function initialize() {
    if (self.enabled) {
      states = [];
      var json = viewer.getJSON();
      var planData = viewer.getPlanData();
      states.push({
        json: json,
        planData: planData
      });
    }
  }
}


"use strict";

function VPData() {
  'use strict';

  this.id = undefined;
  this.title = undefined;
  this.objects = [];
  this.idMap = {};

  this.add = function (object) {
    this.objects.push(object);
    this.idMap[object.id] = object;
  };

  this.remove = function (shape) {
    var index = this.objects.findIndex(function (x) {
      return x.shape === shape;
    });

    if (0 <= index) {
      var object = this.objects[index];
      this.objects.splice(index, 1);
      delete this.idMap[object.id];
    }
  };

  this.get = function (shape) {
    for (var i = 0; i < this.objects.length; i++) {
      if (this.objects[i].hasShape(shape)) {
        return this.objects[i];
      }
    }

    return undefined;
  };

  this.find = function (id) {
    return this.idMap[id];
  };

  this.replace = function (oldShape, newShape) {
    for (var i = 0; i < this.objects.length; i++) {
      if (this.objects[i].hasShape(oldShape)) {
        this.objects[i].shape = newShape;
        break;
      }
    }
  };

  this.removeAll = function () {
    this.objects = [];
  };

  this.setVisibility = function (ids, visible) {
    for (var i in ids) {
      if (ids.hasOwnProperty(i) && this.idMap[ids[i]]) {
        this.idMap[ids[i]].setVisible(visible);
      }
    }
  };

  this.setSelectable = function (enable) {
    for (var i = 0; i < this.objects.length; i++) {
      var object = this.objects[i];
      object.setSelectable(enable);
    }
  };

  this.refresh = function () {
    for (var i = 0; i < this.objects.length; i++) {
      this.objects[i].refresh();
    }
  };

  this.setColorMode = function (colorMode) {
    for (var i = 0; i < this.objects.length; i++) {
      this.objects[i].setColorMode(colorMode);
    }
  };

  this.getCalculationData = function (workLevel, sections) {
    var _this = this;

    var calcData = [];
    var sectionMap = {};
    var find = sections.find(function (s) {
      return s.modelId && s.modelId === _this.id;
    });
    var modelSection = find ? find._id : 'new';

    for (var i = 0; i < this.objects.length; i++) {
      var object = this.objects[i];
      if (!object) continue;
      var calculationData = object.getCalculationData();
      if (!calculationData) continue;
      calculationData.modelId = this.id;
      calculationData.workLevel = workLevel;
      var section = calculationData.section ? calculationData.section : modelSection;
      var group = sectionMap[section];

      if (!group) {
        group = {
          _id: section,
          levelMap: {}
        };
        sectionMap[section] = group;
      }

      var levelMap = group.levelMap;
      var level = levelMap[workLevel];

      if (!level) {
        level = {
          modelId: this.id,
          modelType: 'vp',
          name: workLevel,
          children: []
        };
        levelMap[workLevel] = level;
      }

      level.children.push(calculationData);
    }

    for (var sectionId in sectionMap) {
      var _group = sectionMap[sectionId];
      var levels = [];

      for (var levelId in _group.levelMap) {
        var _level = _group.levelMap[levelId];
        levels.push(_level);
      }

      calcData.push({
        _id: _group._id,
        modelId: this.id,
        modelType: 'vp',
        levels: levels
      });
    }

    return calcData.length === 0 ? undefined : calcData;
  };

  this.setInventoryData = function (inventoryData) {
    if (this.idMap === undefined) return;

    for (var i = 0; i < inventoryData.length; i++) {
      var info = inventoryData[i];
      var item = this.idMap[info.id];

      if (item !== undefined) {
        item.setInventoryData(info);
      }
    }
  };

  this.getInventoryData = function () {
    var data = [];

    for (var i = 0; i < this.objects.length; i++) {
      if (this.objects[i]) {
        var inventory = this.objects[i].getInventory();

        if (inventory) {
          data.push(inventory);
        }
      }
    }

    return data;
  };
}


"use strict";

function VPObject(shape, viewer) {
  'use strict';

  var self = this;
  this.id = VPUtils.getId(shape);
  this.shape = shape;
  this.inventoryInfo = undefined; //inventory data

  this.colorMode = viewer.colorMode;
  this.inventoryColor = 'rgba(0,0,0,0.2)';
  this.properties = {
    fill: shape.fill,
    stroke: shape.stroke
  };
  shape.vpObject = this;

  if (shape.info && shape.info.type === 'complex') {
    this.properties.fill = shape.item(0).fill;
  }

  updateColor();

  this.hasShape = function (shape) {
    return this.shape === shape;
  };

  this.getInventory = function () {
    return this.inventoryInfo;
  };

  this.setInventoryData = function (inventoryObj) {
    if (inventoryObj) {
      this.inventoryInfo = Object.assign({}, inventoryObj);
      var inventory = getInventoryItem(this.inventoryInfo);

      if (inventory) {
        this.inventoryColor = ExtUtils.ha2rgba(inventory.color, inventory.opacity !== undefined ? inventory.opacity / 100 : 1);
      } else {
        this.inventoryColor = 'rgba(0,0,0,0)';
      }
    } else {
      this.inventoryColor = 'rgba(0,0,0,0)';
    }

    if (this.colorMode === 'inventory') {
      updateColor();
    }
  };

  this.setVisible = function (visible) {
    if (this.shape) {
      this.shape.visible = visible;
    }
  };

  this.setSelectable = function (enable) {
    this.shape.setCoords();
    this.shape.set('selectable', enable);
  };

  this.refresh = function () {
    this.shape.setCoords();
  };

  this.setColorMode = function (colorMode) {
    this.colorMode = colorMode;
    updateColor();
  };

  this.getMaterialColor = function () {
    var inventory = getInventoryItem(this.inventoryInfo);

    if (inventory) {
      var color = inventory.color;
      var opacity = inventory.opacity !== undefined ? inventory.opacity / 100 : 1;
      return {
        _id: inventory._id,
        name: inventory.name,
        color: ExtUtils.ha2rgba(color, opacity)
      };
    }

    return undefined;
  };

  this.getGeometricalInfo = function () {
    if (!this.shape) {
      return {};
    }

    var object = this.shape;
    var scaleX = object.scaleX === undefined ? 1 : object.scaleX;
    var scaleY = object.scaleY === undefined ? 1 : object.scaleY;
    var x = object.left;
    var y = object.top;
    var width = object.width + object.strokeWidth;
    var height = object.height + object.strokeWidth;
    var area = VPUtils.area(object);
    var perimeterOut = VPUtils.perimeter(object);
    var perimeterIn = VPUtils.perimeterIn(object);
    var wallHeight = VPUtils.zHeight(object);

    if (area === 0) {
      area = width * height;
    }

    if (perimeterOut === 0) {
      perimeterOut = Math.sqrt(width * width + height * height);
    }

    width *= scaleX;
    height *= scaleY;
    perimeterOut = perimeterOut * Math.sqrt(scaleX * scaleY);
    perimeterIn = perimeterIn * Math.sqrt(scaleX * scaleY);
    x *= viewer.calibration;
    y *= viewer.calibration;
    width *= viewer.calibration;
    height *= viewer.calibration;
    perimeterIn *= viewer.calibration;
    perimeterOut *= viewer.calibration;

    if (object.info && object.info.type === VP.DrawingType.wall) {
      if (width > height) {
        var temp = width;
        width = height;
        height = temp; //swap
      }

      area = height * wallHeight;
    } else {
      area = area * scaleX * scaleY;
      area *= viewer.calibration * viewer.calibration;
    }

    return {
      x: x,
      y: y,
      width: width,
      height: height,
      perimeterIn: perimeterIn,
      perimeterOut: perimeterOut,
      area: area,
      wallHeight: wallHeight
    };
  };

  this.getCalculationData = function () {
    if (!this.shape || !this.inventoryInfo) {
      return undefined;
    }

    var object = this.shape;
    var penetration = VPUtils.getPenetration(object);
    penetration.area *= viewer.calibration * viewer.calibration;
    penetration.perimeter *= viewer.calibration;
    return {
      objectId: object.objectId ? object.objectId : object.info.id,
      modelType: "vp",
      name: object.name ? object.name : object.info.type,
      type: object.info.type,
      slope: object.angle,
      penetration: penetration,
      materials: this.inventoryInfo.materials,
      dcps: this.inventoryInfo.dcps,
      equipments: this.inventoryInfo.equipments,
      dcqs: this.inventoryInfo.dcqs,
      section: this.inventoryInfo.section
    };
  };

  this.set = function (property, value) {
    this.properties[property] = value;
  };

  function updateColor() {
    if (self.colorMode === 'inventory') {
      VPUtils.setProperty(self.shape, 'fill', self.inventoryColor);
    } else {
      VPUtils.setProperty(self.shape, 'fill', self.properties.fill);
    }
  }

  function getInventoryItem(inventoryInfo) {
    if (!inventoryInfo) return;
    var materials = inventoryInfo.materials;

    if (materials && materials.length > 0) {
      for (var i = 0; i < materials.length; i++) {
        if (materials[i].color) {
          return materials[i];
        }
      }
    }

    var dcps = inventoryInfo.dcps;

    if (dcps && dcps.length > 0) {
      for (var _i = 0; _i < dcps.length; _i++) {
        if (dcps[_i].color) {
          return dcps[_i];
        }
      }
    }

    return undefined;
  }
}


"use strict";

function VPBaseDrawer(viewer, drawer) {
  'use strict';

  var self = this; // drawer type

  this.drawer = drawer; // viewer

  this.viewer = viewer; // canvas

  this.canvas = viewer.canvas; // snap tracker

  this.snap = new VPSnapHelper(); // active status

  this.active = false; // current action

  this.action = 0; //current shape

  this.currentObject = undefined;
  this.currentPt = undefined;
  this.snapEnabled = false; // current shape type

  this.type = VP.DrawingType.none; // active

  this.setActive = function (active) {
    if (this.active === active) {
      return;
    }

    this.active = active;

    if (active) {
      this.canvas.selection = false;

      if (this.mousedown) {
        this.viewer.on('mouse:down', this.mousedown.bind(this));
      }

      if (this.mousemove) {
        this.viewer.on('mouse:move', this.baseMousemove.bind(this));
        this.viewer.on('mouse:move', this.mousemove.bind(this));
      }

      if (this.mouseup) {
        this.viewer.on('mouse:up', this.mouseup.bind(this));
      }

      if (this.contextmenu) {
        this.viewer.on('contextmenu', this.contextmenu.bind(this));
      }

      if (this.doEscape) {
        this.viewer.on('drawing:escape', this.doEscape.bind(this));
      }

      if (this.doDeactivate) {
        this.viewer.on('drawing:deactivate', this.doDeactivate.bind(this));
      }

      this.viewer.on('keydown', this.onKeyUpDown.bind(this));
      this.viewer.on('keyup', this.onKeyUpDown.bind(this));
      this.viewer.on('onkeydown', this.onKeyDown.bind(this));
      this.viewer.on('onkeyup', this.onKeyUp.bind(this));
      this.viewer.setSelectable(false);
      this.setCursor('crosshair');
      this.snap.removeSnapCircle(this.viewer);
    } else {
      this.canvas.selection = true;
      this.canvas.isDrawingMode = false;

      if (this.onDeactivate) {
        this.onDeactivate();
      }

      if (this.mousedown) {
        this.viewer.off('mouse:down');
      }

      if (this.mousemove) {
        this.viewer.off('mouse:move', this.mousemove);
        this.viewer.off('mouse:move', this.baseMousemove.bind(this));
      }

      if (this.mouseup) {
        this.viewer.off('mouse:up', this.mouseup);
      }

      if (this.contextmenu) {
        this.viewer.off('contextmenu', this.contextmenu);
      }

      if (this.doEscape) {
        this.viewer.off('drawing:escape', this.doEscape);
      }

      if (this.doDeactivate) {
        this.viewer.off('drawing:deactivate', this.doDeactivate);
      }

      this.viewer.off('keydown', this.onKeyUpDown.bind(this));
      this.viewer.off('keyup', this.onKeyUpDown.bind(this));
      this.viewer.off('onkeydown', this.onKeyDown.bind(this));
      this.viewer.off('onkeyup', this.onKeyUp.bind(this));
      this.viewer.setSelectable(true);
      this.setCursor('default');
      this.snap.removeSnapCircle(this.viewer);
    }

    if (this.onActiveChanged) {
      this.onActiveChanged(this.active);
    }
  };

  this.baseMousemove = function (e) {
    this.currentPt = this.canvas.getPointer(e.e);
    this.snap.removeSnapCircle(this.viewer);
    if (!this.snapEnabled) return;
    var rlt = this.snap.workSnap(this.viewer, this.currentPt, this.currentObject);

    if (rlt) {
      this.currentPt = rlt;
      this.snap.addSnapCircle(this.viewer, this.currentPt);
    }
  };

  this.onKeyUpDown = function (status) {
    this.keyStatus = status;
  };

  this.onKeyDown = function (event) {};

  this.onKeyUp = function (event) {};

  this.getCurrentPt = function () {
    return this.currentPt;
  };

  this.setCurrentObject = function (object) {
    if (object) {
      this.currentObject = object;
    } else {
      this.currentObject = undefined;
    }
  };

  this.setSnapEnable = function (isEnable) {
    this.snapEnabled = isEnable;
  };

  this.addObject = function (object, addToCanvas, addToData) {
    this.addIdentifier(object);
    this.viewer.addObject(object, addToCanvas, addToData);
  };

  this.removeObject = function (object) {
    this.viewer.removeObject(object);
  };

  this.setCursor = function (cursor, isUrl, isUp) {
    this.viewer.setCursor(cursor, isUrl, isUp);
  };

  this.updateHistory = function () {
    this.canvas.fire("drawing:update", {});
  };

  this.fireOnUpdate = function (shape) {
    if (shape.vpObject) {
      viewer.broadcast('object:modified', shape.vpObject);
    }
  };

  this.newText = function (pos, text) {
    return new fabric.Text(text, {
      fontFamily: 'Arial',
      fontWeight: 200,
      fontSize: 16,
      left: pos.x,
      top: pos.y,
      fill: 'black',
      strokeWith: 0,
      stroke: 'transparent',
      originX: 'center',
      originY: 'center'
    });
  };

  this.distance = function (vector) {
    return Math.sqrt(vector.x * vector.x + vector.y * vector.y);
  };

  this.distanceOf = function (p1, p2) {
    return this.distance({
      x: p2.x - p1.x,
      y: p2.y - p1.y
    });
  };

  this.centerOf = function (p1, p2) {
    return {
      x: (p1.x + p2.x) / 2,
      y: (p1.y + p2.y) / 2
    };
  };

  this.angle1 = function (vector) {
    return Math.atan2(vector.x, vector.y);
  };

  this.angle2 = function (center, p0) {
    return Math.atan2(p0.x - center.x, p0.y - center.y);
  };

  this.angle3 = function (center, p0, p1, dir) {
    var v1 = {
      x: p0.x - center.x,
      y: p0.y - center.y
    };
    var v2 = {
      x: p1.x - center.x,
      y: p1.y - center.y
    };
    var angle = Math.atan2(v2.y - v1.y, v2.x - v1.x);
    return dir ? v1.x * v2.y - v2.x * v1.y >= 0 ? angle : Math.PI * 2 - angle : angle;
  };

  this.angleDegree3 = function (center, p0, p1, dir) {
    return ExtUtils.roundNumber(this.angle3(center, p0, p1, dir) * 180 / Math.PI, 0);
  };

  this.addIdentifier = function (object) {
    VPUtils.generateId(object, this.type);
  };
}


"use strict";

function VPSnapHelper() {
  'use strict';

  var self = this;
  this.snapCircle = undefined;
  this.lastSnappedObj = undefined;
  this.lastSnappedObjStroke = {
    dash: [],
    width: 1
  };
  this.guideObject = undefined;

  this.workSnap = function (viewer, pointer, currentObject) {
    var result = false;
    var minW = 1e10;
    var zoom = viewer.canvas.getZoom();

    if (this.lastSnappedObj) {
      this.lastSnappedObj.set({
        strokeDashArray: this.lastSnappedObjStroke.dash,
        strokeWidth: this.lastSnappedObjStroke.width
      });
    }

    viewer.canvas.forEachObject(function (obj) {
      if (obj === currentObject || obj.snapDisabled || obj.info && obj.info.snapDisabled) return;
      obj.setCoords();
      var coords = obj.aCoords;
      if (!isContained(pointer, coords, zoom)) return;
      var rlt = getSnapPoint(obj, pointer, minW, zoom);

      if (rlt) {
        result = rlt.point;
        self.lastSnappedObj = rlt.obj;
      }
    });

    if (result) {
      this.lastSnappedObjStroke = {
        dash: this.lastSnappedObj.strokeDashArray ? this.lastSnappedObj.strokeDashArray.slice(0) : [],
        width: this.lastSnappedObj.strokeWidth
      };
      this.lastSnappedObj.set({
        strokeDashArray: [5, 5],
        strokeWidth: 1
      });

      if (this.lastSnappedObj.info && (this.lastSnappedObj.info.type === VP.DrawingType.circle || this.lastSnappedObj.info.type === VP.DrawingType.line || this.lastSnappedObj.info.type === VP.DrawingType.arc)) {
        if (this.guideObject) {
          this.guideObject.set({
            left: this.lastSnappedObj.left,
            top: this.lastSnappedObj.top
          });
        } else {
          this.guideObject = new fabric.Rect({
            left: self.lastSnappedObj.left,
            top: self.lastSnappedObj.top,
            width: Math.ceil(VP.Constants.POLYGON_RANGE * 0.6 / zoom),
            height: Math.ceil(VP.Constants.POLYGON_RANGE * 0.6 / zoom),
            fill: 'blue',
            strokeWidth: 1,
            stroke: 'blue',
            originX: 'center',
            originY: 'center',
            selectable: false
          });
          this.guideObject.snapDisabled = true;
          viewer.canvas.add(this.guideObject);
        }
      }
    } else if (this.lastSnappedObj) {
      this.lastSnappedObj.set({
        strokeDashArray: this.lastSnappedObjStroke.dash,
        strokeWidth: this.lastSnappedObjStroke.width
      });
      this.lastSnappedObj = undefined;
      this.lastSnappedObjStroke = {
        dash: [],
        width: 1
      };

      if (this.guideObject) {
        viewer.canvas.remove(this.guideObject);
        this.guideObject = undefined;
      }
    }

    return result;
  };

  this.addSnapCircle = function (viewer, pointer) {
    var zoom = viewer.canvas.getZoom();
    this.snapCircle = new fabric.Rect({
      left: pointer.x,
      top: pointer.y,
      width: Math.ceil(VP.Constants.POLYGON_RANGE / 2 / zoom) * 1.5,
      height: Math.ceil(VP.Constants.POLYGON_RANGE / 2 / zoom) * 1.5,
      fill: '',
      strokeWidth: Math.ceil(2 / zoom) * 0.5,
      stroke: 'blue',
      originX: 'center',
      originY: 'center',
      selectable: false,
      excludeFromExport: true
    });
    viewer.canvas.add(this.snapCircle);
  };

  this.removeSnapCircle = function (viewer) {
    if (this.snapCircle) {
      viewer.canvas.remove(this.snapCircle);
      this.snapCircle = undefined;
    }
  };

  function getSnapPoint(obj, pointer, minW, zoom) {
    var result = false;
    var type = obj.get('type');
    var snapPoint = undefined;

    switch (type) {
      case 'line':
        snapPoint = getSnapPointFromLine(obj, pointer, minW, zoom);
        break;

      case 'rect':
        snapPoint = getSnapPointFromRect(obj, pointer, minW, zoom);
        break;

      case 'polygon':
        snapPoint = getSnapPointFromPolygon(obj, pointer, minW, zoom);
        break;

      case 'polyline':
        snapPoint = getSnapPointFromPolyline(obj, pointer, minW, zoom);
        break;

      case 'path':
        snapPoint = getSnapPointFromPath(obj, pointer, minW, zoom);
        break;

      case 'circle':
        snapPoint = getSnapPointFromCircle(obj, pointer, minW, zoom);
        break;

      case 'group':
        if (obj.info) {
          if (obj.info.type === VP.DrawingType.arrowline) {
            var objects = obj.getObjects();

            if (objects[0]) {
              obj.x1 = objects[0].x1;
              obj.y1 = objects[0].y1;
              obj.x2 = objects[0].x2;
              obj.y2 = objects[0].y2;
              snapPoint = getSnapPointFromLine(obj, pointer, minW, zoom);
              obj = objects[0];
            }
          } else if (obj.info.type === VP.DrawingType.complex) {
            var count = obj.size();

            for (var i = 0; i < count; i++) {
              var item = obj.item(i);

              if (item) {
                var newPoint = {
                  x: pointer.x - obj.aCoords.tl.x - obj.width / 2,
                  y: pointer.y - obj.aCoords.tl.y - obj.height / 2
                };
                var rlt = getSnapPoint(item, newPoint, minW, zoom);

                if (rlt) {
                  result = rlt;
                  result.point.x += obj.aCoords.tl.x;
                  result.point.y += obj.aCoords.tl.y;
                  result.point.x += obj.width / 2;
                  result.point.y += obj.height / 2;
                  return result;
                }
              }
            }
          }
        }

        break;

      default:
        break;
    }

    if (snapPoint) {
      result = {
        point: snapPoint,
        obj: obj
      };
    }

    return result;
  }

  function getSnapPointFromLine(obj, pointer, minW, zoom) {
    var res = false;
    var points = [];

    if (obj.top === undefined) {
      points.push({
        x: obj.x1,
        y: obj.y1
      });
      points.push({
        x: obj.x2,
        y: obj.y2
      });
    } else {
      obj.setCoords();
      var coords = obj.aCoords;
      var x1, x2, y1, y2;

      if (obj.x1 < obj.x2) {
        if (obj.y1 < obj.y2) {
          x1 = coords.tl.x;
          y1 = coords.tl.y;
          x2 = coords.br.x;
          y2 = coords.br.y;
        } else {
          x1 = coords.bl.x;
          y1 = coords.bl.y;
          x2 = coords.tr.x;
          y2 = coords.tr.y;
        }
      } else {
        if (obj.y1 < obj.y2) {
          x1 = coords.tr.x;
          y1 = coords.tr.y;
          x2 = coords.bl.x;
          y2 = coords.bl.y;
        } else {
          x1 = coords.br.x;
          y1 = coords.br.y;
          x2 = coords.tl.x;
          y2 = coords.tl.y;
        }
      }

      points.push({
        x: x1,
        y: y1
      });
      points.push({
        x: x2,
        y: y2
      });
    }

    for (var i = 0; i < points.length; i++) {
      var pt = points[i];
      var dist = distanceOf(pointer, pt);

      if (dist < VP.Constants.POLYGON_RANGE / zoom && dist < minW) {
        minW = dist;
        res = pt;
      }
    }

    if (res) return res;
    var vec1 = {
      x: pointer.x - points[0].x,
      y: pointer.y - points[0].y
    };
    var vec2 = {
      x: points[1].x - points[0].x,
      y: points[1].y - points[0].y
    };
    var sign = dot(vec1, vec2);
    if (sign < 0) return res;
    vec1 = {
      x: pointer.x - points[1].x,
      y: pointer.y - points[1].y
    };
    vec2 = {
      x: points[0].x - points[1].x,
      y: points[0].y - points[1].y
    };
    sign = dot(vec1, vec2);
    if (sign < 0) return res;
    var l = distance({
      x: points[0].x - points[1].x,
      y: points[0].y - points[1].y
    });
    var d = crossDot(vec1, vec2) / l;

    if (d < VP.Constants.POLYGON_RANGE / zoom && d < minW) {
      minW = d;
      res = {
        x: points[1].x + (points[0].x - points[1].x) * sign / l / l,
        y: points[1].y + (points[0].y - points[1].y) * sign / l / l
      };
    }

    return res;
  }

  function getSnapPointFromRect(obj, pointer, minW, zoom) {
    var res = false;
    var lines = [];
    obj.setCoords();
    var coords = obj.aCoords;
    lines.push({
      x1: coords.tl.x,
      y1: coords.tl.y,
      x2: coords.tr.x,
      y2: coords.tr.y
    });
    lines.push({
      x1: coords.tr.x,
      y1: coords.tr.y,
      x2: coords.br.x,
      y2: coords.br.y
    });
    lines.push({
      x1: coords.br.x,
      y1: coords.br.y,
      x2: coords.bl.x,
      y2: coords.bl.y
    });
    lines.push({
      x1: coords.bl.x,
      y1: coords.bl.y,
      x2: coords.tl.x,
      y2: coords.tl.y
    });

    for (var i = 0; i < lines.length; i++) {
      var r = getSnapPointFromLine(lines[i], pointer, minW, zoom);

      if (r) {
        res = r;
      }
    }

    return res;
  }

  function getSnapPointFromPolygon(obj, pointer, minW, zoom) {
    var res = false;
    var lines = [];
    var points = [];
    if (obj.points.length < 2) return;

    if (obj.transformedPoints) {
      points = obj.transformedPoints;
    } else {
      for (var i = 0; i < obj.points.length; i++) {
        var pt = {
          x: obj.points[i].x,
          y: obj.points[i].y
        };

        if (obj.originX === 'center' && obj.originY === 'center') {
          pt.x += obj.left;
          pt.y += obj.top;
        }

        points.push(pt);
      }
    }

    if (obj.points[0].x !== obj.points[obj.points.length - 1].x || obj.points[0].y !== obj.points[obj.points.length - 1].y) {
      points.push(points[0]);
    }

    for (var _i = 1; _i < points.length; _i++) {
      lines.push({
        x1: points[_i - 1].x,
        y1: points[_i - 1].y,
        x2: points[_i].x,
        y2: points[_i].y
      });
    }

    for (var _i2 = 0; _i2 < lines.length; _i2++) {
      var r = getSnapPointFromLine(lines[_i2], pointer, minW, zoom);

      if (r) {
        res = r;
        break;
      }
    }

    return res;
  }

  function getSnapPointFromPolyline(obj, pointer, minW, zoom) {
    var res = false;
    var lines = [];
    var points = [];
    if (obj.points.length < 2) return;

    if (obj.transformedPoints) {
      points = obj.transformedPoints;
    } else {
      for (var i = 0; i < obj.points.length; i++) {
        var pt = {
          x: obj.points[i].x,
          y: obj.points[i].y
        };

        if (obj.originX === 'center' && obj.originY === 'center') {
          pt.x += obj.left;
          pt.y += obj.top;
        }

        points.push(pt);
      }
    }

    for (var _i3 = 1; _i3 < points.length; _i3++) {
      lines.push({
        x1: points[_i3 - 1].x,
        y1: points[_i3 - 1].y,
        x2: points[_i3].x,
        y2: points[_i3].y
      });
    }

    for (var _i4 = 0; _i4 < lines.length; _i4++) {
      var r = getSnapPointFromLine(lines[_i4], pointer, minW, zoom);

      if (r) {
        res = r;
      }
    }

    return res;
  }

  function getSnapPointFromPath(obj, pointer, minW, zoom) {
    var res = false;
    var points = [];
    var lines = [];
    var curves = [];
    if (obj.path.length < 1) return;
    var pathPoints = obj.path;

    if (obj.transformedPoints) {
      pathPoints = obj.transformedPoints;
    }

    var centerPt = undefined;
    var radius = undefined;
    var prePt = undefined;
    var arcs = [];

    for (var i = 0; i < pathPoints.length; i++) {
      var item = pathPoints[i];

      switch (item[0]) {
        case 'M':
          if (item.length > 2) {
            var valueX = item[1];
            var valueY = item[2];

            if (!isNaN(valueX) && !isNaN(valueY)) {
              points.push({
                x: valueX,
                y: valueY
              });
              prePt = {
                x: valueX,
                y: valueY
              };
              centerPt = {
                x: valueX,
                y: valueY
              };
            }
          }

          break;

        case 'Q':
          if (item.length > 4) {
            var valueX1 = item[1];
            var valueY1 = item[2];
            var valueX2 = item[3];
            var valueY2 = item[4];

            if (!isNaN(valueX1) && !isNaN(valueY1) && !isNaN(valueX2) && !isNaN(valueY2)) {
              points.push({
                x: valueX1,
                y: valueY1
              });
              points.push({
                x: valueX2,
                y: valueY2
              });
              curves.push({
                x1: prePt.x,
                y1: prePt.y,
                x2: valueX1,
                y2: valueY1,
                x3: valueX2,
                y3: valueY2
              });
              prePt = {
                x: valueX2,
                y: valueY2
              };
            }
          }

          break;

        case 'L':
          if (item.length > 2) {
            var _valueX = item[1];
            var _valueY = item[2];

            if (!isNaN(_valueX) && !isNaN(_valueY) && prePt) {
              lines.push({
                x1: _valueX,
                y1: _valueY,
                x2: prePt.x,
                y2: prePt.y
              });
              prePt = {
                x: _valueX,
                y: _valueY
              };
            }
          }

          break;

        case 'A':
          if (item.length > 7) {
            var valueR = item[1];
            var _valueX2 = item[6];
            var _valueY2 = item[7];

            if (!isNaN(valueR) && !isNaN(_valueX2) && !isNaN(_valueY2) && prePt) {
              prePt = {
                x: _valueX2,
                y: _valueY2
              };
              radius = valueR;
            }
          }

          break;

        case 'C':
          if (item.length > 6) {
            var _valueX3 = item[1];
            var _valueY3 = item[2];
            var _valueX4 = item[3];
            var _valueY4 = item[4];
            var valueX3 = item[5];
            var valueY3 = item[6];

            if (!isNaN(_valueX3) && !isNaN(_valueY3) && !isNaN(_valueX4) && !isNaN(_valueY4) && !isNaN(valueX3) && !isNaN(valueY3)) {
              points.push({
                x: _valueX3,
                y: _valueY3
              });
              points.push({
                x: _valueX4,
                y: _valueY4
              });
              points.push({
                x: valueX3,
                y: valueY3
              });
              curves.push({
                x1: _valueX3,
                y1: _valueY3,
                x2: _valueX4,
                y2: _valueY4,
                x3: valueX3,
                y3: valueY3
              });
              prePt = {
                x: valueX3,
                y: valueY3
              };
            }
          }

          break;

        default:
          break;
      }
    }

    if (obj.info.type === 'sector' && obj.startAngle !== undefined && obj.endAngle !== undefined && centerPt && radius) {
      var stAngle = obj.startAngle;
      var enAngle = obj.endAngle;

      if (obj.angle) {
        stAngle += obj.angle / 180 * Math.PI;
        if (stAngle > 2 * Math.PI) stAngle -= 2 * Math.PI;
        if (stAngle < -2 * Math.PI) stAngle += 2 * Math.PI;
        enAngle += obj.angle / 180 * Math.PI;
        if (enAngle > 2 * Math.PI) enAngle -= 2 * Math.PI;
        if (enAngle < -2 * Math.PI) enAngle += 2 * Math.PI;
      }

      arcs.push({
        center: centerPt,
        radius: obj.scaleX ? radius * obj.scaleX : radius,
        start: stAngle,
        end: enAngle
      });
    }

    for (var _i5 = 0; _i5 < points.length; _i5++) {
      var pt = points[_i5];
      var dist = distanceOf(pointer, pt);

      if (dist < VP.Constants.POLYGON_RANGE / zoom && dist < minW) {
        minW = dist;
        res = pt;
        break;
      }
    }

    if (!res) {
      for (var _i6 = 0; _i6 < lines.length; _i6++) {
        var r = getSnapPointFromLine(lines[_i6], pointer, minW, zoom);

        if (r) {
          res = r;
          break;
        }
      }
    }

    if (!res) {
      for (var _i7 = 0; _i7 < arcs.length; _i7++) {
        var _r = getSnapPointFromArc(arcs[_i7], pointer, minW, zoom);

        if (_r) {
          res = _r;
          break;
        }
      }
    }

    if (!res) {
      for (var _i8 = 0; _i8 < curves.length; _i8++) {
        var _r2 = getSnapPointFromCurve(curves[_i8], pointer, minW, zoom);

        if (_r2) {
          res = _r2;
        }
      }
    }

    return res;
  }

  function getSnapPointFromCircle(obj, pointer, minW, zoom) {
    var res = false;
    var centerPt = {
      x: obj.left,
      y: obj.top
    };
    var radius = obj.scaleX ? obj.radius * obj.scaleX : obj.radius;
    var dist = distanceOf(pointer, centerPt);

    if (dist < VP.Constants.POLYGON_RANGE / zoom && dist < minW) {
      minW = dist;
      res = centerPt;
    }

    if (Math.abs(Math.abs(obj.startAngle - obj.endAngle) - Math.PI * 2) < 1e-10) {
      var d = distanceOf(pointer, centerPt);
      dist = Math.abs(d - radius);

      if (dist < VP.Constants.POLYGON_RANGE / zoom && dist < minW) {
        minW = dist;
        res = {
          x: centerPt.x + (pointer.x - centerPt.x) * radius / d,
          y: centerPt.y + (pointer.y - centerPt.y) * radius / d
        };
      }
    } else {
      var stAngle = obj.startAngle;
      var enAngle = obj.endAngle;

      if (obj.angle) {
        stAngle += obj.angle / 180 * Math.PI;
        if (stAngle > 2 * Math.PI) stAngle -= 2 * Math.PI;
        if (stAngle < -2 * Math.PI) stAngle += 2 * Math.PI;
        enAngle += obj.angle / 180 * Math.PI;
        if (enAngle > 2 * Math.PI) enAngle -= 2 * Math.PI;
        if (enAngle < -2 * Math.PI) enAngle += 2 * Math.PI;
      }

      var arc = {
        center: centerPt,
        radius: radius,
        start: stAngle,
        end: enAngle
      };
      var r = getSnapPointFromArc(arc, pointer, minW, zoom);

      if (r) {
        res = r;
      }
    }

    return res;
  }

  function getSnapPointFromArc(arc, pointer, minW, zoom) {
    var res = false;
    var centerPt = arc.center;
    var radius = arc.radius;
    var start = arc.start;
    var end = arc.end;
    var dist = distanceOf(pointer, centerPt);

    if (dist < VP.Constants.POLYGON_RANGE / zoom && dist < minW) {
      minW = dist;
      res = centerPt;
    }

    var d = distanceOf(pointer, centerPt);
    dist = Math.abs(d - radius);

    if (dist < VP.Constants.POLYGON_RANGE / zoom && dist < minW) {
      var difV = {
        x: pointer.x - centerPt.x,
        y: pointer.y - centerPt.y
      };
      var angle = Math.atan(difV.y / difV.x);

      if (difV.x > 0) {
        angle *= 1;
      } else {
        angle += Math.PI;
      }

      var state = false;

      if (start > end) {
        if (start < 0) {
          if (angle > end && angle < start) {
            state = false;
          } else {
            state = true;
          }
        } else {
          if (end < 0) {
            end += Math.PI * 2;

            if (angle > start && angle < end) {
              state = true;
            }
          } else {
            if (angle > end && angle < start) {
              state = false;
            } else {
              state = true;
            }
          }
        }
      } else {
        if (angle > start && angle < end) {
          state = true;
        }
      }

      if (state) {
        minW = dist;
        res = {
          x: centerPt.x + (pointer.x - centerPt.x) * radius / d,
          y: centerPt.y + (pointer.y - centerPt.y) * radius / d
        };
      }
    }

    return res;
  }

  function getSnapPointFromCurve(curve, pointer, minW, zoom) {
    var res = false;
    var bezier = new Bezier(curve.x1, curve.y1, curve.x2, curve.y2, curve.x3, curve.y3);
    var project = bezier.project(pointer);
    var dist = project.d;

    if (dist < VP.Constants.POLYGON_RANGE / zoom && dist < minW) {
      res = {
        x: project.x,
        y: project.y
      };
    }

    return res;
  }

  function dot(vec1, vec2) {
    return vec1.x * vec2.x + vec1.y * vec2.y;
  }

  function crossDot(vec1, vec2) {
    return Math.abs(vec1.x * vec2.y - vec1.y * vec2.x);
  }

  function distance(vector) {
    return Math.sqrt(vector.x * vector.x + vector.y * vector.y);
  }

  function distanceOf(p1, p2) {
    return distance({
      x: p2.x - p1.x,
      y: p2.y - p1.y
    });
  }

  function isContained(pointer, bRect, zoom) {
    var minX = Math.min(bRect.tl.x, bRect.tr.x, bRect.br.x, bRect.bl.x);
    var maxX = Math.max(bRect.tl.x, bRect.tr.x, bRect.br.x, bRect.bl.x);
    var minY = Math.min(bRect.tl.y, bRect.tr.y, bRect.br.y, bRect.bl.y);
    var maxY = Math.max(bRect.tl.y, bRect.tr.y, bRect.br.y, bRect.bl.y);
    return pointer.x >= minX - VP.Constants.POLYGON_RANGE / zoom && pointer.x <= maxX + VP.Constants.POLYGON_RANGE / zoom && pointer.y >= minY - VP.Constants.POLYGON_RANGE / zoom && pointer.y <= maxY + VP.Constants.POLYGON_RANGE / zoom;
  }
}


"use strict";

function VPBoard() {
  var self = this;
  this.boardId = ExtUtils.bsonId();
  this.channel = undefined;
  this.viewer = undefined;
  this.mouse = undefined;
  var planObject = undefined;

  this.setViewer = function (viewer, user) {
    this.viewer = viewer;
    this.mouse = new VPMouse(this, user);
    viewer.on('object:added', objectAdded);
    viewer.on('object:removed', objectRemoved);
    viewer.on('object:modified', objectModified);
    planObject = this.planObject;
  };

  this.enterMessaging = function (channel) {
    if (this.channel) {
      this.channel.removeListener('messageAdded', messageAdded);
    }

    console.log('Messaging Entered');
    this.channel = channel;
    channel.on('messageAdded', messageAdded);
  };

  this.leaveMessaging = function (channel) {
    if (this.channel === channel) {
      this.channel.removeListener('messageAdded', messageAdded);
      this.channel = undefined;
    }

    console.log('Messaging Left');
  };

  this.sendData = function (data) {
    if (!this.channel) return;

    try {
      data.boardId = this.boardId;
      this.channel.sendMessage(JSON.stringify(data));
    } catch (e) {
      console.error(e);
    }
  };

  function objectAdded(object) {
    self.sendData({
      action: 'added',
      data: getJSON(object)
    });
  }

  function objectRemoved(object) {
    self.sendData({
      action: 'removed',
      data: VPUtils.getId(object)
    });
  }

  function objectModified(object) {
    self.sendData({
      action: 'modified',
      data: getJSON(object.shape)
    });
  }

  function getJSON(object) {
    return object.toJSON(['info', 'visible', 'selectable', 'hasControls', 'hasBorders', 'lockMovementX', 'lockMovementY', 'crossOrigin', '_controlsVisibility']);
  }

  function messageAdded(message) {
    var data = JSON.parse(message.state.body);
    console.log('messageAdded', data);

    if (data.boardId === self.boardId) {
      console.log('self message arrived.');
      return;
    }

    switch (data.action) {
      case 'mouse-move':
        self.mouse.processMove(data.data);
        break;

      case 'mouse-out':
        self.mouse.processOut(data.data);
        break;

      case 'added':
        addObjectFromJSON(data.data);
        break;

      case 'removed':
        removeObjectFromJSON(data.data);
        break;

      case 'modified':
        modifyObjectFromJSON(data.data);
        break;
    }
  }

  function addObjectFromJSON(json) {
    var shape = createShape(json);

    if (shape) {
      self.viewer.canvas.add(shape);
      self.viewer.canvas.renderAll();

      if (shape.info) {
        self.viewer.data.add(new VPObject(shape, self.viewer));
      }

      self.mouse.makeTop();
    }
  }

  function modifyObjectFromJSON(json) {
    var id = json.info.id;

    if (id) {
      var object = self.viewer.data.find(id);
      console.log('modifyObjectFromJSON', object, json);

      if (object && object.shape) {
        var shape = object.shape;
        updateShape(shape, json);
        self.viewer.canvas.renderAll();
      }
    }
  }

  function removeObjectFromJSON(id) {
    if (id) {
      var object = self.viewer.data.find(id);

      if (object && object.shape) {
        self.viewer.canvas.remove(object.shape);
        self.viewer.data.remove(object.shape);
      }
    }
  }

  function createShape(json) {
    var type = json.type;
    var shape;

    switch (type) {
      case "rect":
        shape = createRect(json);
        break;

      case "circle":
        shape = createCircle(json);
        break;

      case "line":
        shape = createLine(json);
        break;

      case "polygon":
        shape = createPolygon(json);
        break;

      case "polyline":
        shape = createPolyline(json);
        break;

      case "path":
        shape = createPath(json);
        break;

      case "i-text":
        shape = createIText(json);
        break;

      case "text":
        shape = createText(json);
        break;

      case "group":
        shape = createGroup(json);
        break;
    }

    if (shape) {
      shape.info = json.info;
    }

    return shape;
  }

  function updateShape(shape, json) {
    var type = shape.type;

    switch (type) {
      case "rect":
        updateRect(shape, json);
        break;

      case "circle":
        updateCircle(shape, json);
        break;

      case "line":
        updateLine(shape, json);
        break;

      case "polygon":
        updatePolygon(shape, json);
        break;

      case "polyline":
        updatePolyline(shape, json);
        break;

      case "path":
        updatePath(shape, json);
        break;

      case "i-text":
        updateIText(shape, json);
        break;

      case "text":
        updateText(shape, json);
        break;

      case "group":
        updateGroup(shape, json);
        break;
    }
  }

  function createRect(json) {
    return new fabric.Rect({
      width: json.width,
      height: json.height,
      left: json.left,
      top: json.top,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      selectable: json.selectable,
      angle: json.angle
    });
  }

  function updateRect(shape, json) {
    shape.set({
      left: json.left,
      top: json.top,
      width: json.width,
      height: json.height,
      scaleX: json.scaleX,
      scaleY: json.scaleY,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      angle: json.angle
    });
  }

  function createCircle(json) {
    return new fabric.Circle({
      radius: json.radius,
      left: json.left,
      top: json.top,
      startAngle: json.startAngle,
      endAngle: json.endAngle,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      originX: json.originX,
      originY: json.originY,
      selectable: json.selectable,
      width: json.width,
      height: json.height,
      angle: json.angle
    });
  }

  function updateCircle(shape, json) {
    shape.set({
      radius: json.radius,
      left: json.left,
      top: json.top,
      startAngle: json.startAngle,
      endAngle: json.endAngle,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      originX: json.originX,
      originY: json.originY,
      selectable: json.selectable,
      width: json.width,
      height: json.height,
      scaleX: json.scaleX,
      scaleY: json.scaleY,
      angle: json.angle
    });
  }

  function createLine(json) {
    return new fabric.Line([json.x1, json.y1, json.x2, json.y2], {
      left: json.left,
      top: json.top,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      originX: json.originX,
      originY: json.originY,
      angle: json.angle
    });
  }

  function updateLine(shape, json) {
    shape.set({
      x1: json.x1,
      y1: json.y1,
      x2: json.x2,
      y2: json.y2,
      left: json.left,
      top: json.top,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      originX: json.originX,
      originY: json.originY,
      scaleX: json.scaleX,
      scaleY: json.scaleY,
      angle: json.angle
    });
  }

  function createPolygon(json) {
    return new fabric.Polygon(json.points, {
      left: json.left,
      top: json.top,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      selectable: json.selectable,
      objectCaching: false,
      originX: json.originX,
      originY: json.originY,
      angle: json.angle
    });
  }

  function updatePolygon(shape, json) {
    shape.set({
      points: json.points,
      left: json.left,
      top: json.top,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      selectable: json.selectable,
      objectCaching: false,
      originX: json.originX,
      originY: json.originY,
      scaleX: json.scaleX,
      scaleY: json.scaleY,
      angle: json.angle
    });
  }

  function createPolyline(json) {
    return new fabric.Polyline(json.points, {
      left: json.left,
      top: json.top,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      selectable: json.selectable,
      objectCaching: false,
      originX: json.originX,
      originY: json.originY,
      angle: json.angle
    });
  }

  function updatePolyline(shape, json) {
    shape.set({
      points: json.points,
      left: json.left,
      top: json.top,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      selectable: json.selectable,
      objectCaching: false,
      originX: json.originX,
      originY: json.originY,
      scaleX: json.scaleX,
      scaleY: json.scaleY,
      angle: json.angle
    });
  }

  function createPath(json) {
    return new fabric.Path(json.path, {
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      objectCaching: false,
      originX: json.originX,
      originY: json.originY,
      angle: json.angle
    });
  }

  function updatePath(shape, json) {
    shape.set({
      path: json.path,
      left: json.left,
      top: json.top,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      strokeDashArray: json.strokeDashArray,
      selectable: json.selectable,
      objectCaching: false,
      originX: json.originX,
      originY: json.originY,
      scaleX: json.scaleX,
      scaleY: json.scaleY,
      angle: json.angle
    });
  }

  function createIText(json) {
    return new fabric.IText(json.text, {
      fontFamily: json.fontFamily,
      fontSize: json.fontSize,
      left: json.left,
      top: json.top,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      originX: json.originX,
      originY: json.originY,
      angle: json.angle
    });
  }

  function updateIText(shape, json) {
    shape.set({
      text: json.text,
      fontFamily: json.fontFamily,
      fontSize: json.fontSize,
      left: json.left,
      top: json.top,
      fill: json.fill,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      originX: json.originX,
      originY: json.originY,
      scaleX: json.scaleX,
      scaleY: json.scaleY,
      angle: json.angle
    });
  }

  function createText(json) {
    return new fabric.Text(json.text, {
      fontFamily: json.fontFamily,
      fontWeight: json.fontWeight,
      fontSize: json.fontSize,
      left: json.left,
      top: json.top,
      fill: json.fill,
      strokeWith: json.strokeWidth,
      stroke: json.stroke,
      originX: json.originX,
      originY: json.originY,
      angle: json.angle
    });
  }

  function updateText(shape, json) {
    shape.set({
      text: json.text,
      fontFamily: json.fontFamily,
      fontWeight: json.fontWeight,
      fontSize: json.fontSize,
      left: json.left,
      top: json.top,
      fill: json.fill,
      strokeWith: json.strokeWidth,
      stroke: json.stroke,
      originX: json.originX,
      originY: json.originY,
      angle: json.angle
    });
  }

  function createGroup(json) {
    var objects = [];

    if (json.objects) {
      json.objects.forEach(function (x) {
        var shape = createShape(x);

        if (shape) {
          objects.push(shape);
        }
      });
    }

    var shape = new fabric.Group(objects, {
      left: json.left,
      top: json.top,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      originX: json.originX,
      originY: json.originY,
      perPixelTargetFind: json.perPixelTargetFind,
      targetFindTolerance: json.targetFindTolerance
    });

    if (json.clipPath) {
      shape.clipPath = createShape(json.clipPath);
      shape.clipPath.inverted = json.clipPath.inverted;
    }

    return shape;
  }

  function updateGroup(shape, json) {
    shape.set({
      left: json.left,
      top: json.top,
      stroke: json.stroke,
      strokeWidth: json.strokeWidth,
      originX: json.originX,
      originY: json.originY,
      scaleX: json.scaleX,
      scaleY: json.scaleY
    });
  }
}


"use strict";

function VPMouse(board, user) {
  var COLORS = ['rgba(0,0,255,1)', 'rgba(253,80,0,1)', 'rgba(125,102,7,1)', 'rgba(118,13,135,1)', 'rgba(80,80,80,1)'];
  var mouses = [];
  var oldPos;
  var colorIndex = 0;
  init(board);

  this.processMove = function (data) {
    draw(data.pos, data.id, data.name);
  };

  this.processOut = function (data) {
    remove(data.id);
  };

  this.destroy = function () {
    var viewer = board.viewer;
    viewer.off('mouse:move', onMouseMove);
    viewer.off('zoom:changed', onZoomChanged);
    viewer.off('object:added', onObjectAdded);
  };

  this.makeTop = function () {
    onObjectAdded();
  };

  function init(board) {
    var viewer = board.viewer;
    viewer.on('mouse:move', onMouseMove);
    viewer.on('zoom:changed', onZoomChanged);
    viewer.on('object:added', onObjectAdded);
  }

  function onMouseMove(e) {
    var viewer = board.viewer;
    var pos = viewer.canvas.getPointer(e.e);

    if (!oldPos) {
      oldPos = pos;
    } else if (Math.max(Math.abs(pos.x - oldPos.x), Math.abs(pos.y - oldPos.y)) > 50) {
      board.sendData({
        action: 'mouse-move',
        data: {
          id: user._id,
          pos: pos,
          name: user.displayName
        }
      });
      oldPos = pos;
    }
  }

  function onZoomChanged(e) {
    var level = e.level;
    mouses.forEach(function (mouse) {
      return mouse.shape.set({
        scaleX: 1 / level,
        scaleY: 1 / level
      });
    });
  }

  function onObjectAdded() {
    var viewer = board.viewer;
    mouses.forEach(function (mouse) {
      return viewer.canvas.bringToFront(mouse.shape);
    });
  }

  function draw(pos, id, name) {
    var viewer = board.viewer;
    var mouse = mouses.find(function (x) {
      return x.id === id;
    });

    if (mouse) {
      mouse.shape.set({
        left: pos.x,
        top: pos.y
      });
    } else {
      var color = COLORS[colorIndex++];
      var zoom = viewer.getZoom();
      var cursor = new fabric.Path("M4 0l16 12.279-6.951 1.17 4.325 8.817-3.596 1.734-4.35-8.879-5.428 4.702z", {
        left: 0,
        top: 0,
        fill: color,
        stroke: 'rgba(255,255,0,0.5)',
        strokeWidth: 1,
        originX: 'left',
        originY: 'top',
        selectable: false
      });
      var text = new fabric.Text(name, {
        left: 12,
        top: 24,
        fill: 'rgba(255,255,255,1)',
        stroke: 'rgba(255,255,255,1)',
        strokeWidth: 0.1,
        fontSize: 12,
        originX: 'left',
        originY: 'top',
        textBackgroundColor: color
      });
      var shape = new fabric.Group([cursor, text], {
        left: pos.x,
        top: pos.y,
        originX: 'left',
        originY: 'top',
        scaleX: 1 / zoom,
        scaleY: 1 / zoom
      });
      viewer.canvas.add(shape);
      mouses.push({
        id: id,
        shape: shape
      });
    }

    viewer.render();
  }

  function remove(id) {
    var index = mouses.findIndex(function (mouse) {
      return mouse.id === id;
    });

    if (index !== -1) {
      var viewer = board.viewer;
      viewer.canvas.remove(mouses[index].shape);
      mouses.splice(index, 1);
    }
  }
}


"use strict";

function VPPdfController(viewer) {
  'use strict';

  var self = this;
  this.pdfPage = undefined;
  this.updating = false;
  this.canvas = document.createElement("canvas");
  this.canvas.classList.add('pdf-canvas');
  this.context = this.canvas.getContext('2d', {
    alpha: false
  });
  this.originCanvas = document.createElement("canvas");
  this.offCanvas = document.createElement("canvas");
  this.scale = 1;
  viewer.on('zoom:changed', function () {
    if (self.updating) {
      updateStage();
    } else {
      requestRender();
    }
  });
  viewer.on('pan:start', function () {
    updateStage();
  });
  viewer.on('pan:move', function () {
    updateStage();
  });
  viewer.on('pan:end', function () {
    requestRender();
  });

  this.loadPDF = function (url, pageNo) {
    return new Promise(function (resolve, reject) {
      pdfjsLib.getDocument({
        url: url
      }).promise.then(function (pdf) {
        pdf.getPage(pageNo + 1).then(function (page) {
          self.pdfPage = page;
          var winWidth = viewer.canvas.getWidth();
          var winHeight = viewer.canvas.getHeight(); // you can now use *page* here

          var viewport = page.getViewport({
            scale: 1
          });
          var width = viewport.width;
          var height = viewport.height;
          var winRatio = winHeight / winWidth;
          var pdfRatio = height / width;
          var scale = pdfRatio > winRatio ? winHeight / height : winWidth / width;
          self.scale = scale;
          viewport = page.getViewport({
            scale: 1
          }); //
          // let viewBox = viewport.viewBox;
          // let centerX = (viewBox[2] + viewBox[0]) / 2;
          // let centerY = (viewBox[3] + viewBox[1]) / 2;
          //
          // let l, t, r, b;
          // if (pdfRatio > winRatio) {
          //   l = centerX - (centerX - viewBox[0]) * pdfRatio / winRatio;
          //   r = centerX + (viewBox[2] - centerX) * pdfRatio / winRatio;
          //   t = viewBox[1];
          //   b = viewBox[3];
          // } else {
          //   t = centerY - (centerY - viewBox[1]) * winRatio / pdfRatio;
          //   b = centerY + (viewBox[3] - centerY) * winRatio / pdfRatio;
          //   l = viewBox[0];
          //   r = viewBox[2];
          // }
          //
          // centerX = (l + r) / 2;
          // centerY = (t + b) / 2;
          //
          // let offsetX = viewport.offsetX;
          // let offsetY = viewport.offsetY;
          // let offsetCanvasX = Math.abs(centerX - l) * scale + offsetX;
          // let offsetCanvasY = Math.abs(centerY - t) * scale + offsetY;
          //
          // width = Math.abs(r - l) * scale;
          // height = Math.abs(b - t) * scale;
          //
          // viewport.width = width;
          // viewport.height = height;
          //
          // self.transform = [scale, 0, 0, -scale, offsetCanvasX -  scale * centerX, offsetCanvasY + scale * centerY];
          // viewport.transform = [scale, 0, 0, -scale, offsetCanvasX -  scale * centerX, offsetCanvasY + scale * centerY];

          self.canvas.width = winWidth;
          self.canvas.height = winHeight;
          self.originCanvas.width = viewport.width;
          self.originCanvas.height = viewport.height;
          self.offCanvas.width = viewport.width;
          self.offCanvas.height = viewport.height;
          viewer.container.insertBefore(self.canvas, viewer.container.firstChild); // viewport.transform = [scale, 0, 0, -scale, 0, viewport.height * scale];

          page.render({
            canvasContext: self.originCanvas.getContext('2d', {
              alpha: false
            }),
            viewport: viewport
          }).promise.then(function () {
            drawImage(self.context, self.originCanvas);
            resolve();
          })["catch"](function (err) {
            reject(err);
          });
        });
      })["catch"](function (err) {
        reject(err);
      });
    });
  };

  function requestRender() {
    requestAnimationFrame(function () {
      updateScene();
    });
  }

  function updateStage() {
    clearScene();
    var t = viewer.canvas.viewportTransform;
    self.context.setTransform(t[0], t[1], t[2], t[3], t[4], t[5]);
    drawImage(self.context, self.originCanvas);
    self.context.setTransform(1, 0, 0, 1, 0, 0);
  }

  function updateScene() {
    if (self.updating) return;
    self.updating = true;
    if (!self.pdfPage) return;
    var viewport = self.pdfPage.getViewport({
      scale: 1
    });
    var t = viewer.canvas.viewportTransform;
    viewport.transform = [t[0], t[1], t[2], -t[3], t[4], viewport.height * t[0] + t[5]];
    self.pdfPage.render({
      canvasContext: self.offCanvas.getContext("2d"),
      viewport: viewport
    }).promise.then(function () {
      drawImage(self.context, self.offCanvas);
      self.updating = false;
    })["catch"](function (err) {
      console.error(err);
      self.updating = false;
    });
  }

  function clearScene() {
    self.context.clearRect(0, 0, viewer.canvas.getWidth(), viewer.canvas.getHeight());
    self.context.beginPath();
    self.context.rect(0, 0, viewer.canvas.getWidth(), viewer.canvas.getHeight());
    self.context.fillStyle = "white";
    self.context.fill();
  }

  function drawImage(context, img) {
    context.drawImage(img, 0, 0);
  }
}


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function VPViewer(container) {
  'use strict';

  var self = this;
  this.fill = {
    type: 'color',
    value: 'red'
  };
  this.brush = {
    strokeColor: 'rgba(0,0,0,1)',
    fillColor: 'rgba(255,255,255,1)',
    strokeWidth: 0.5,
    strokeDashArray: [],
    dashType: VP.DashType.DashA
  };
  this.textBrush = {
    fontSize: 24,
    fontFamily: "Arial",
    fillColor: 'rgba(0,0,0,1)',
    strokeColor: 'rgba(0,0,0,1)'
  };
  this.calibration = 0.01; // 1 pixel = 0.01 meter

  this.selection = undefined;
  this.planObject = undefined;
  this.colorMode = 'normal';
  this.data = new VPData();
  this.inputMethod = 'eu';
  this._clipboard = undefined;
  this.activeGroup = [];
  this.isLoaded = false;

  this.init = function (container) {
    this.container = container;
    this.canvasId = 'canvas-2d-' + ExtUtils.bsonId();
    this.canvasElement = document.createElement('canvas');
    this.canvasElement.id = this.canvasId;
    this.canvasElement["class"] = 'canvas-2d';
    this.container.appendChild(this.canvasElement);
    var style = getComputedStyle(container, null);
    var margins = {
      x: parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
      y: parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)
    };
    this.canvas = new fabric.Canvas(this.canvasElement.id, {
      width: container.offsetWidth - margins.x,
      height: container.offsetHeight - margins.y
    });
    fabric.textureSize = 4096 * 4;
    fabric.zoom = 1;
    this.canvas.selection = false;
    this.canvas.preserveObjectStacking = true;
    this.canvas.filterBackend = new fabric.WebglFilterBackend();
    fabric.Object.prototype.cornerStyle = 'circle';
    this.rotateImg = new Image();
    this.rotateImg.src = '/assets/images/cgviewer/icons/custom-rotate.svg';

    fabric.Object.prototype.drawControls = function (ctx, styleOverride) {
      styleOverride = styleOverride || {};
      styleOverride.cornerStrokeColor = '#000000';
      styleOverride.cornerColor = 0;
      styleOverride.transparentCorners = true;
      ctx.save();
      ctx.setTransform(self.canvas.getRetinaScaling(), 0, 0, self.canvas.getRetinaScaling(), 0, 0);
      ctx.strokeStyle = ctx.fillStyle = styleOverride.cornerColor || this.cornerColor;

      if (!this.transparentCorners) {
        ctx.strokeStyle = styleOverride.cornerStrokeColor || this.cornerStrokeColor;
      }

      this._setLineDash(ctx, styleOverride.cornerDashArray || this.cornerDashArray, null);

      this.setCoords();
      this.forEachControl(function (control, key, fabricObject) {
        if (control.getVisibility(fabricObject, key)) {
          if (key === 'mtr' && self.rotateImg) {
            ctx.drawImage(self.rotateImg, fabricObject.oCoords[key].x - 12, fabricObject.oCoords[key].y - 12, 24, 24);
          } else {
            control.render(ctx, fabricObject.oCoords[key].x, fabricObject.oCoords[key].y, styleOverride, fabricObject);
          }
        }
      });
      ctx.restore();
      return this;
    };

    this.context = this.canvasElement.getContext("2d");
    window.addEventListener("resize", windowResizeEvent);
    this.canvas.on('object:scaling', function (e) {
      var o = e.target;

      if (!o.strokeWidthUnscaled && o.strokeWidth) {
        o.strokeWidthUnscaled = o.strokeWidth;
      }

      if (o.strokeWidthUnscaled) {
        o.strokeWidth = o.strokeWidthUnscaled / o.scaleX;
      }
    });
    this.canvas.on('object:added', function (e) {
      var o = e.target;
      o.setControlsVisibility({
        mb: false,
        ml: false,
        mr: false,
        mt: false
      });
    });
    /**Ovedride fabricjs prototype */

    var toFixed = fabric.util.toFixed;

    fabric.Pattern.prototype.toObject = function (propertiesToInclude) {
      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
          source,
          object;

      if (typeof this.source === "function") {
        source = String(this.source);
      } else if (typeof this.source.src === "string") {
        source = this.source.src;
      } else if (_typeof(this.source) === "object" && this.source.toDataURL) {
        source = this.source.toDataURL();
      }

      object = {
        type: "pattern",
        source: source,
        repeat: this.repeat,
        crossOrigin: this.crossOrigin,
        offsetX: toFixed(this.offsetX, NUM_FRACTION_DIGITS),
        offsetY: toFixed(this.offsetY, NUM_FRACTION_DIGITS),
        patternTransform: this.patternTransform ? this.patternTransform.concat() : null
      };
      fabric.util.populateWithProperties(this, object, propertiesToInclude);
      return object;
    };

    this.event = new VPEventPool(this);
    this.viewCtrl = new VPViewerController(this);
    this.on('mouse:down', onMouseDown);
    this.on('mouse:up', onMouseUp);
    this.on('mouse:wheel', onMouseWheel);
    this.on('keydown', onKeyDownUp);
    this.on('keyup', onKeyDownUp);
  };

  this.destroy = function () {
    this.off('mouse:down', onMouseDown);
    this.off('mouse:up', onMouseUp);
    this.off('mouse:wheel', onMouseWheel);
    this.off('keydown', onKeyDownUp);
    this.off('keyup', onKeyDownUp);
    window.removeEventListener('resize', windowResizeEvent);
    this.canvas.dispose();
    var element = document.getElementById(this.canvasId);

    if (element) {
      element.parentElement.removeChild(element);
    }

    if (this.event) {
      this.event.destroy();
      this.event = undefined;
    }

    this.canvas = undefined;
    this.viewCtrl = undefined;
  };

  this.setSize = function (width, height) {
    var w = width || self.container.offsetWidth;
    var h = height || self.container.offsetHeight;
    this.canvas.setDimensions({
      width: w,
      height: h
    });

    if (this.viewCtrl) {
      this.viewCtrl.fitScreen();
    }
  };

  this.setVisible = function (visible) {
    if (this.canvasElement && this.canvasElement.parentElement) {
      this.canvasElement.parentElement.style.display = visible ? 'block' : 'none';
    }
  };

  this.setCursor = function (cursor, isUrl, isUp) {
    if (isUrl) {
      var cursorStyle = "";

      if (isUp) {
        cursorStyle = "url('../../assets/images/cgviewer/cursor/" + cursor + ".png'), auto";
      } else {
        cursorStyle = "url('../../assets/images/cgviewer/cursor/" + cursor + ".png') 0 25, auto";
      }

      this.canvas.defaultCursor = cursorStyle;
      this.canvas.hoverCursor = cursorStyle;
      this.canvas.freeDrawingCursor = cursorStyle;
    } else {
      this.canvas.defaultCursor = cursor;
      this.canvas.hoverCursor = cursor;
      this.canvas.freeDrawingCursor = cursor;
    }
  };

  this.setZoom = function (zoom) {
    this.viewCtrl.setZoom(zoom);
  };

  this.getZoom = function () {
    return this.viewCtrl.getZoom();
  };

  this.zoomIn = function (pointer) {
    this.viewCtrl.zoomIn(pointer);
  };

  this.zoomOut = function (pointer) {
    this.viewCtrl.zoomOut(pointer);
  };

  this.setPlanInfo = function (id, title) {
    this.data.id = id;
    this.data.title = title;
  };

  this.setColorFilter = function (color, opacity) {
    if (this.planObject) {
      if (this.planObject.filters && this.planObject.filters.length === 2) {
        this.planObject.filters[1].color = color;
        this.planObject.filters[1].alpha = opacity;
      } else {
        this.planObject.filters.push(new fabric.Image.filters.BlendColor({
          color: color,
          mode: 'tint',
          alpha: opacity
        }));
      }

      this.planObject.applyFilters();
      this.canvas.requestRenderAll();
    }
  };

  this.removeColorFilter = function () {
    if (this.planObject) {
      if (this.planObject.filters && this.planObject.filters.length === 2) {
        this.planObject.filters.splice(1, 1);
      }

      this.planObject.applyFilters();
      this.canvas.requestRenderAll();
    }
  };

  this.setOpacity = function (opacity) {
    this.container.style.opacity = opacity;
  };

  this.loadBackgroundImageWidthHD = function (url, pageNo) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var max_pdf_size = _this.canvas.width * 3;
      pdfjsLib.getDocument({
        url: url
      }).promise.then(function (pdf) {
        pdf.getPage(pageNo + 1).then(function (page) {
          var viewport = page.getViewport({
            scale: 1
          });
          var ratio = viewport.height / viewport.width;
          var scale = ratio > 1 ? max_pdf_size / viewport.height : max_pdf_size / viewport.width;
          viewport = page.getViewport({
            scale: scale
          });
          var canvas = document.createElement("canvas");
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          page.render({
            canvasContext: canvas.getContext('2d', {
              alpha: true
            }),
            viewport: viewport,
            background: 'rgba(0,0,0,0)'
          }).promise.then(function () {
            self.loadBackgroundImage(canvas.toDataURL("image/png")).then(resolve)["catch"](reject);
          })["catch"](reject);
        })["catch"](reject);
      })["catch"](reject);
    });
  }; //for project load


  this.loadBackgroundImage = function (url) {
    return new Promise(function (resolve, reject) {
      fabric.Image.fromURL(url, function (image) {
        var w = self.canvas.getWidth();
        var h = self.canvas.getHeight();
        image.set({
          id: 'image',
          left: self.canvas.width / 2,
          top: self.canvas.height / 2,
          originX: 'center',
          originY: 'center',
          hasControls: false,
          hasBorders: false,
          selectable: false,
          backgroundColor: 'white'
        });

        if (w < h) {
          image.scaleToWidth(w - 20, false);
        } else {
          image.scaleToHeight(h - 20, false);
        }

        VPUtils.generateId(image, VP.DrawingType.image);
        image.info.backgroundImage = true;
        image.info.snapDisabled = true;
        image.filters.push(new fabric.Image.filters.Resize({
          resizeType: 'sliceHack',
          scaleX: 1,
          scaleY: 1
        }));
        image.applyFilters();
        image.excludeFromExport = true;
        self.canvas.add(image);
        image.sendToBack();
        self.render();
        self.planObject = image;
        self.isLoaded = true;
        resolve();
      }, {
        crossOrigin: 'anonymous'
      });
    });
  };

  this.addObject = function (object, addToCanvas, addToData) {
    if (addToCanvas === undefined) {
      addToCanvas = true;
    }

    if (addToCanvas) {
      this.canvas.add(object);
    }

    if (!object.info) {
      VPUtils.generateId(object, object.get('type'));
    }

    if (addToData) {
      this.data.add(new VPObject(object, this));
    }

    this.broadcast('object:added', object);
  };

  this.removeObject = function (object) {
    this.canvas.remove(object);
    this.data.remove(object);
    this.broadcast('object:removed', object);
  };

  this.clear = function () {
    this.canvas.clear();
    this.data.removeAll();
  };

  this.invalidate = function () {
    this.canvas.renderAll();
  };

  this.setSelectable = function (enable) {
    this.data.setSelectable(enable);
  };

  this.getImage = function () {
    var viewport = this.canvas.viewportTransform;
    var bg = this.canvas.backgroundColor;
    this.canvas.viewportTransform = [1, 0, 0, 1, 0, 0];
    this.canvas.backgroundColor = 'white';
    this.canvas.renderAll();
    var imgData = this.canvas.toDataURL({
      format: 'jpeg',
      quality: 1.0,
      multiplier: 4
    });
    this.canvas.backgroundColor = bg;
    this.canvas.viewportTransform = viewport;
    this.canvas.renderAll();
    return {
      data: imgData,
      width: this.canvas.width,
      height: this.canvas.height
    };
  };

  this.takeImage = function () {
    return this.canvas.toDataURL({
      format: 'jpeg',
      quality: 1.0
    });
  };

  this.setCalibration = function (calibration) {
    this.calibration = calibration;
  };

  this.setInputMethod = function (type) {
    this.inputMethod = type;
  };

  this.render = function () {
    this.canvas.renderAll();
  };

  this.on = function (type, func) {
    this.event.on(type, func);
  };

  this.off = function (type, func) {
    this.event.off(type, func);
  };

  this.broadcast = function (type, e) {
    this.event.broadcast(type, e);
  };

  this.addFromJSON = function (json, planData, needToClear, fireEvent) {
    if (planData) {
      if (planData.flipX !== undefined) {
        this.planObject.flipX = planData.flipX;
      }

      if (planData.flipY !== undefined) {
        this.planObject.flipY = planData.flipY;
      }

      if (planData.angle !== undefined) {
        this.planObject.angle = planData.angle;
      }
    }

    if (!json) return;
    var newJSON = beautifyJSON(json);
    var array = newJSON.objects;
    if (!array && array.length === 0) return;
    var currentPlanData;

    if (this.planObject) {
      currentPlanData = {
        left: this.planObject.left,
        top: this.planObject.top,
        scaleX: this.planObject.scaleX,
        scaleY: this.planObject.scaleY,
        width: this.planObject.width,
        height: this.planObject.height
      };
    }

    if (needToClear) {
      this.clearExceptBackground();
    }

    fabric.util.enlivenObjects(array, function (objects) {
      var originalRenderOnAddRemove = self.canvas.renderOnAddRemove;
      self.canvas.renderOnAddRemove = false;
      objects.forEach(function (object) {
        if (object.info) {
          self.data.add(new VPObject(object, self));
        }

        if (!VPUtils.isTypeOf(object, VP.DrawingType.image) && object.info) {
          object.selectable = true;
        }

        if (!object.info) {
          VPUtils.generateId(object, object.get('type'));
        } //define modify event for snap


        if (!object.tempInfo || !object.tempInfo.snapDisabled) {
          addSnapSettingByType(object);
        }

        if (currentPlanData && planData) {
          if (!planData.width) planData.width = currentPlanData.width;
          if (!planData.height) planData.height = currentPlanData.height;
          var scaleX = ExtUtils.num(currentPlanData.width / planData.width * currentPlanData.scaleX / planData.scaleX);
          var scaleY = ExtUtils.num(currentPlanData.height / planData.height * currentPlanData.scaleY / planData.scaleY);
          object.left = currentPlanData.left + (object.left - planData.left) * scaleX;
          object.top = currentPlanData.top + (object.top - planData.top) * scaleY;
          object.scaleX = object.scaleX * scaleX;
          object.scaleY = object.scaleY * scaleY;
        }

        self.canvas.add(object);
      });
      self.canvas.renderOnAddRemove = originalRenderOnAddRemove;
      self.canvas.renderAll();

      if (fireEvent) {
        self.canvas.fire("project:loaded");
      }
    }, undefined, undefined);
  };

  this.addFromJSONURL = function (url) {
    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      req.open("GET", url, true);
      req.setRequestHeader('Access-Control-Allow-Origin', '*');
      req.responseType = "text";

      req.onload = function (event) {
        var text = req.response;

        if (text) {
          try {
            self.addFromJSON(JSON.parse(text));
            resolve();
          } catch (error) {
            reject(error);
          }
        } else {
          reject({
            message: 'empty response'
          });
        }
      };

      req.onerror = function (error) {
        reject(error);
      };

      req.send(null);
    });
  };

  this.getJSON = function () {
    return JSON.stringify(this.canvas.toJSON(['info', 'visible', 'selectable', 'hasControls', 'hasBorders', 'lockMovementX', 'lockMovementY', 'crossOrigin', '_controlsVisibility']));
  };

  this.getPlanData = function () {
    if (!this.planObject) return;
    return {
      left: this.planObject.left,
      top: this.planObject.top,
      scaleX: this.planObject.scaleX,
      scaleY: this.planObject.scaleY,
      width: this.planObject.width,
      height: this.planObject.height,
      flipX: this.planObject.flipX,
      flipY: this.planObject.flipY,
      angle: this.planObject.angle
    };
  };

  this.deleteCurrentObject = function () {
    this.activeGroup = [];
    var objects = this.canvas.getActiveObjects();

    if (objects) {
      for (var i = 0; i < objects.length; i++) {
        this.removeObject(objects[i]);
      }
    }

    this.canvas.discardActiveObject();
  };

  this.isEmptyClipboard = function () {
    return !this._clipboard;
  };

  this.copy = function () {
    var object = this.getActiveObject();
    if (!object) return;
    return new Promise(function (resolve) {
      object.clone(function (cloned) {
        self._clipboard = cloned;

        self._clipboard.setCoords();

        resolve(self._clipboard);
      }, ['materialInfo', 'info']);
    });
  };

  this.cut = function () {
    var object = this.getActiveObject();
    if (!object) return;
    object.clone(function (cloned) {
      self._clipboard = cloned;

      self._clipboard.setCoords();

      self._clipboard.isCut = true;
    }, ['materialInfo', 'info']);
    self.removeObject(object);
  };

  this.paste = function (pos) {
    return new Promise(function (resolve) {
      self._clipboard.clone(function (clonedObj) {
        self.canvas.discardActiveObject();
        clonedObj.set({
          left: pos.x,
          top: pos.y,
          evented: true
        });

        if (clonedObj.type === 'activeSelection') {
          // active selection needs a reference to the canvas.
          clonedObj.canvas = self.canvas;
          clonedObj.forEachObject(function (obj) {
            self.addObject(obj, true, VPUtils.isDataObject(clonedObj));
          }); // this should solve the unselectability
        } else {
          self.addObject(clonedObj, true, VPUtils.isDataObject(clonedObj));
        }

        clonedObj.setCoords();
        self.canvas.setActiveObject(clonedObj);
        self.canvas.requestRenderAll();

        if (self._clipboard.isCut) {
          self._clipboard = undefined;
        }

        resolve();
      }, ['materialInfo', 'info']);
    });
  };

  this.onChangeDashType = function (object, type) {
    switch (type) {
      case VP.DashType.DashA:
        object.set({
          strokeDashArray: [],
          strokeWidth: 1
        });
        break;

      case VP.DashType.DashB:
        object.set({
          strokeDashArray: [1, 3],
          strokeWidth: 1
        });
        break;

      case VP.DashType.DashC:
        object.set({
          strokeDashArray: [1, 3],
          strokeWidth: 10
        });
        break;

      default:
        break;
    }

    object.info.dashType = type;
    this.render();
  };

  this.onChangeDashSpace = function (object, space) {
    object.set({
      strokeDashArray: space
    });
    this.render();
  };

  this.onChangeStroke = function (object, stroke) {
    if (object.get('type') === 'group' && object.info && object.info.type === VP.DrawingType.complex) {
      var size = object.size();

      for (var i = 0; i < size; i++) {
        var item = object.item(i);
        item.set({
          strokeWidth: stroke
        });
      }

      object.setCoords();
    }

    object.set({
      strokeWidth: stroke
    });
    this.render();
  };

  this.clearExceptBackground = function () {
    var objects = this.canvas.getObjects();
    if (objects.length < 2) return;

    for (var i = 1; i < objects.length; i++) {
      if (objects[i] !== this.planObject) {
        this.removeObject(objects[i]);
      }
    }
  };

  this.rotate = function (degrees) {
    var canvasCenter = new fabric.Point(this.canvas.getWidth() / 2, this.canvas.getHeight() / 2); // center of canvas

    var radians = fabric.util.degreesToRadians(degrees);
    this.canvas.getObjects().forEach(function (obj) {
      var objectOrigin = new fabric.Point(obj.left, obj.top);
      var location = fabric.util.rotatePoint(objectOrigin, canvasCenter, radians);
      obj.left = location.x;
      obj.top = location.y;
      obj.angle += degrees;
      obj.setCoords();
    });
    this.canvas.renderAll();
  };

  this.flipHorizontal = function () {
    var _this2 = this;

    var radians = fabric.util.degreesToRadians(180);
    this.canvas.getObjects().forEach(function (obj) {
      var objectOrigin = new fabric.Point(obj.left, obj.top);

      if (obj.originX === 'left') {
        objectOrigin.x += obj.width * obj.scaleX / 2;
      }

      if (obj.originY === 'top') {
        objectOrigin.y += obj.height * obj.scaleY / 2;
      }

      var flipCenter = new fabric.Point(_this2.canvas.getWidth() / 2, objectOrigin.y);
      var location = fabric.util.rotatePoint(objectOrigin, flipCenter, radians);
      obj.left = location.x;
      obj.top = location.y;
      obj.originX = 'center';
      obj.originY = 'center';
      obj.flipX = !obj.flipX;
      obj.setCoords();
    });
    this.canvas.renderAll();
  };

  this.flipVertical = function () {
    var _this3 = this;

    var radians = fabric.util.degreesToRadians(180);
    this.canvas.getObjects().forEach(function (obj) {
      var objectOrigin = new fabric.Point(obj.left, obj.top);

      if (obj.originX === 'left') {
        objectOrigin.x += obj.width * obj.scaleX / 2;
      }

      if (obj.originY === 'top') {
        objectOrigin.y += obj.height * obj.scaleY / 2;
      }

      var flipCenter = new fabric.Point(objectOrigin.x, _this3.canvas.getHeight() / 2);
      var location = fabric.util.rotatePoint(objectOrigin, flipCenter, radians);
      obj.left = location.x;
      obj.top = location.y;
      obj.originX = 'center';
      obj.originY = 'center';
      obj.flipY = !obj.flipY;
      obj.setCoords();
    });
    this.canvas.renderAll();
  };

  this.getWallProperty = function (wall) {
    return {
      zHeight: VPUtils.zHeight(wall)
    };
  };

  this.setWallProperty = function (wall, property) {
    VPUtils.setZHeight(wall, property.zHeight);
    VPUtils.setArea(wall, Math.max(wall.width, wall.height) * property.zHeight);
  };

  function windowResizeEvent() {
    if (self.container.offsetWidth === 0 || self.container.offsetHeight === 0) return;
    var style = getComputedStyle(self.container, null);
    var margins = {
      x: parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
      y: parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)
    };
    self.setSize(self.container.offsetWidth - margins.x, self.container.offsetHeight - margins.y);
  }

  function onMouseUp() {
    self.data.refresh();
  }

  function onMouseWheel() {
    self.data.refresh();
    self.render();
  }

  function onKeyDownUp(status) {
    self.keyStatus = status;
  }

  function onMouseDown(e) {
    if (self.keyStatus && self.keyStatus === 'shortcut:ctrl') {
      if (e.target && e.target.type !== 'activeSelection') {
        var object = e.target;
        self.canvas.discardActiveObject();
        var index = self.activeGroup.indexOf(object);

        if (index < 0) {
          self.activeGroup.push(object);
        } else {
          self.activeGroup.splice(index, 1);
        }

        var sel = new fabric.ActiveSelection(self.activeGroup, {
          canvas: self.canvas
        });
        self.canvas.setActiveObject(sel).renderAll();
      }
    } else {
      self.activeGroup = [];
    }
  }

  function beautifyJSON(data) {
    var datas;

    try {
      datas = JSON.parse(data);
    } catch (e) {
      datas = data;
    }

    var objects = datas.objects;

    for (var i = 0; i < objects.length; i++) {
      var object = objects[i];

      if (object.fill && object.fill.source) {
        var source = object.fill.source;
        var index = source.search('patternSourceCanvas');
        if (index >= 0) object.fill = "";
      }
    }

    return datas;
  }

  function addSnapSettingByType(object) {
    switch (object.type) {
      case 'polygon':
        object.on("modified", function () {
          var matrix = this.calcTransformMatrix();
          var pts = this.get("points");

          var _VPUtils$getMinMaxPos = VPUtils.getMinMaxPos(pts),
              minX = _VPUtils$getMinMaxPos.minX,
              minY = _VPUtils$getMinMaxPos.minY;

          var transformedPoints = this.get("points").map(function (p) {
            return new fabric.Point(p.x - minX - object.width / 2, p.y - minY - object.height / 2);
          }).map(function (p) {
            return fabric.util.transformPoint(p, matrix);
          });
          object.transformedPoints = transformedPoints;
        });
        break;

      default:
        break;
    }
  }

  this.init(container);
}


"use strict";

function VPViewerController(viewer) {
  'use strict';

  var self = this;
  var zoomRange = {
    min: 0.5,
    max: 10
  };
  var canvas = viewer.canvas;
  viewer.on('keydown', onKeyUpDown);
  viewer.on('keyup', onKeyUpDown);
  viewer.on('mouse:wheel', mouseWheel);

  this.setZoom = function (zoom) {
    changeZoom({
      x: canvas.width / 2,
      y: canvas.height / 2
    }, zoom);
  };

  this.zoomIn = function (pointer) {
    var zoom = canvas.getZoom();
    changeZoom({
      x: pointer.x,
      y: pointer.y
    }, zoom - 1);
  };

  this.zoomOut = function (pointer) {
    var zoom = canvas.getZoom();
    changeZoom({
      x: pointer.x,
      y: pointer.y
    }, zoom + 1);
  };

  this.getZoom = function () {
    return canvas.getZoom();
  };

  this.fitScreen = function () {
    this.setZoom(1);
  };

  function onKeyUpDown(status) {
    self.keyStatus = status;
  }

  function mouseWheel(e) {
    var delta = e.e.deltaY;

    if (self.keyStatus && self.keyStatus === 'shortcut:shift') {
      canvas.viewportTransform[4] -= delta;
      viewer.broadcast('pan:move', {
        x: delta,
        y: 0
      });
    } else if (self.keyStatus && self.keyStatus === 'shortcut:ctrl') {
      canvas.viewportTransform[5] -= delta;
      viewer.broadcast('pan:move', {
        x: 0,
        y: delta
      });
    } else {
      var pointer = canvas.getPointer(e.e);
      var zoom = canvas.getZoom();
      zoom = zoom - delta / 200;
      changeZoom({
        x: pointer.x,
        y: pointer.y
      }, zoom);
    }

    canvas.requestRenderAll();
    e.e.preventDefault();
    e.e.stopPropagation();
  }

  function changeZoom(pointer, zoom) {
    var oldZoom = canvas.getZoom();
    zoom = clamp(zoom, zoomRange.min, zoomRange.max);
    if (oldZoom === zoom) return;
    canvas.zoomToPoint(new fabric.Point(pointer.x, pointer.y), zoom);
    keepPositionInBounds();
    viewer.broadcast('zoom:changed', {
      target: viewer,
      level: zoom
    });
    viewer.data.refresh();
    viewer.render();
  }

  function keepPositionInBounds() {
    var width = canvas.getWidth();
    var height = canvas.getHeight();
    var zoom = canvas.getZoom();
    if (zoom < 1) zoom = 1;
    var xMin = width - zoom * width / 2;
    var xMax = zoom * width / 2;
    var yMin = height - zoom * height / 2;
    var yMax = zoom * height / 2;
    var point = new fabric.Point(width / 2, height / 2);
    var center = fabric.util.transformPoint(point, canvas.viewportTransform);
    var clampedCenterX = clamp(center.x, xMin, xMax);
    var clampedCenterY = clamp(center.y, yMin, yMax);
    var diffX = clampedCenterX - center.x;
    var diffY = clampedCenterY - center.y;

    if (diffX !== 0 || diffY !== 0) {
      canvas.relativePan(new fabric.Point(diffX, diffY));
    }
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
  }
}


"use strict";

function BimClippingManager() {
  this.sections = [];
  /**
   * add cross ection to clipping helper
   * @param section {CrossSection}
   */

  this.add = function (section) {
    this.sections.push(section);
  };

  this.getClippingPlanes = function () {
    var plans = [];

    for (var i = 0; i < this.sections.length; i++) {
      var section = this.sections[i];

      if (section.isClippingApplied) {
        for (var j = 0; j < section.clippingPlanes.length; j++) {
          plans.push(section.clippingPlanes[j]);
        }
      }
    }

    return plans;
  };

  this.setQuality = function (viewer) {
    if (viewer.saoPass) {
      var plans = this.getClippingPlanes();

      if (viewer.saoPass.depthMaterial) {
        viewer.saoPass.depthMaterial.clippingPlanes = plans;
      }

      if (viewer.saoPass.normalMaterial) {
        viewer.saoPass.normalMaterial.clippingPlanes = plans;
      }
    }
  };
}


"use strict";

function CrossSection(viewer, mgr, entities) {
  this.viewer = viewer;
  this.clippingPlanes = [];
  this.clippingPlaneEntities = [];
  this.isClippingApplied = true;
  this.entities = entities ? entities : viewer.entities;
  var self = this;
  viewer.signaler.objectRemoved.add(function (object) {
    self.onObjectRemoved(object);
  });

  this.clear = function () {
    this.clippingPlanes = [];
    this.clippingPlaneEntities = [];
    changeClippingPlane();
  };

  this.addClippingPlaneEntity = function (crossEntity) {
    this.clippingPlaneEntities.push(crossEntity);
    var matrix = crossEntity.matrix;
    var v1 = crossEntity.geometry.vertices[0].clone();
    v1.applyMatrix4(matrix);
    var v2 = crossEntity.geometry.vertices[1].clone();
    v2.applyMatrix4(matrix);
    var v3 = crossEntity.geometry.vertices[2].clone();
    v3.applyMatrix4(matrix);
    var lookAt = new THREE.Vector3();
    this.viewer.camera.getWorldDirection(lookAt);
    var cross = v2.clone().sub(v1).cross(v3.clone().sub(v1));
    crossEntity.userData.startDirection = cross.clone().dot(lookAt) > 0;
    this.updateClippingPlanes();
  };

  this.removeClippingPlaneEntity = function (crossEntity) {
    var changes = false;

    for (var i = 0; i < this.clippingPlaneEntities.length; i++) {
      var entity = this.clippingPlaneEntities[i];

      if (entity === crossEntity) {
        this.clippingPlaneEntities.splice(i, 1);
        changes = true;
        break;
      }
    }

    if (changes) {
      this.updateClippingPlanes();
    }
  };

  this.toggleClippingPlaneEntity = function (crossEntity) {
    crossEntity.userData.startDirection = !crossEntity.userData.startDirection;
    this.updateClippingPlanes();
  };

  this.updateClippingPlanes = function () {
    this.clippingPlanes = [];

    for (var i = 0; i < this.clippingPlaneEntities.length; i++) {
      var entity = this.clippingPlaneEntities[i];
      var matrix = entity.matrix;
      var v1 = entity.geometry.vertices[0].clone();
      v1.applyMatrix4(matrix);
      var v2 = entity.geometry.vertices[1].clone();
      v2.applyMatrix4(matrix);
      var v3 = entity.geometry.vertices[2].clone();
      v3.applyMatrix4(matrix);
      var plane = new THREE.Plane();

      if (entity.userData.startDirection) {
        plane.setFromCoplanarPoints(v1, v2, v3);
      } else {
        plane.setFromCoplanarPoints(v1, v3, v2);
      }

      this.clippingPlanes.push(plane);
    }

    if (this.isClippingApplied) {
      changeClippingPlane();
    }
  };

  this.applyCrossSection = function () {
    this.isClippingApplied = !this.isClippingApplied;
    changeClippingPlane();
    changeEntitiesVisibility();
    return this.isClippingApplied;
  };

  this.onObjectRemoved = function (object) {
    for (var i = 0; i < this.clippingPlaneEntities.length; i++) {
      var entity = this.clippingPlaneEntities[i];

      if (entity === object) {
        this.clippingPlaneEntities.splice(i, 1);
        break;
      }
    }

    this.updateClippingPlanes();
  };

  function changeClippingPlane() {
    var plans = mgr ? mgr.getClippingPlanes() : self.clippingPlanes;

    for (var i = 0; i < self.entities.length; i++) {
      var entity = self.entities[i];

      if (entity.type === 'Group') {
        // traverse
        entity.traverse(function (child) {
          if (child.isMesh && child.userData) {
            setClippingPlansToEntity(child, plans);
          }
        });
      } else {
        setClippingPlansToEntity(entity, plans);
      }
    }

    if (self.viewer.saoPass) {
      if (self.viewer.saoPass.depthMaterial) {
        self.viewer.saoPass.depthMaterial.clippingPlanes = plans;
      }

      if (self.viewer.saoPass.normalMaterial) {
        self.viewer.saoPass.normalMaterial.clippingPlanes = plans;
      }
    }

    self.viewer.setDirty(true);
  }

  function setClippingPlansToEntity(entity, plans) {
    if (entity.userData.unClippable) return;

    if (entity.material !== undefined) {
      if (Array.isArray(entity.material)) {
        for (var i = 0; i < entity.material.length; i++) {
          entity.material[i].clippingPlanes = plans;
          entity.material[i].needsUpdate = true;
        }
      } else {
        entity.material.clippingPlanes = plans;
        entity.material.needsUpdate = true;
      }
    }

    if (entity.userData.edges !== undefined) {
      var edges = entity.userData.edges;
      edges.material.clippingPlanes = plans;
      edges.material.needsUpdate = true;
    }
  }

  function changeEntitiesVisibility() {
    var entities = self.clippingPlaneEntities;
    entities.forEach(function (entity) {
      return entity.visible = self.isClippingApplied;
    });
  }
}


"use strict";

/**
 * @param viewer {BimViewer}
 * @param scene {THREE.Scene}
 * @param crossSection {CrossSection}
 * @param cutter3d {BimCutter3d}
 */
function BimCrossSectionCmd(viewer, scene, crossSection, cutter3d) {
  BimBaseCmd.call(this, viewer, scene, 'cross');
  var STEP = {
    STEP0: 0,
    STEP1: 1
  };
  this.step = STEP.STEP0;
  var outlineMat = null;
  var knob = null;
  var v0 = new THREE.Vector3();
  var v1 = new THREE.Vector3();
  var v2 = new THREE.Vector3();
  var v3 = new THREE.Vector3();
  var normalVec = new THREE.Vector3();
  var matrix = new THREE.Matrix4();
  var rw = 0,
      rh = 0;
  var self = this;

  function initCommand() {
    self.step = STEP.STEP0;
    if (knob) knob.visible = true;
  } // event handlers


  this.onActivate = function () {
    this.setCursor('default');
    outlineMat = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.6,
      depthTest: false
    });
    knob = new THREE.Mesh(new THREE.BufferGeometry().setFromPoints([v0, v1, v2, v0, v2, v3, v0]), outlineMat);
    this.scene.add(knob);
    knob.userData.unSnapable = true;
    this.touch.setModelMode(true);
    initCommand();
  };

  this.onDeactivate = function () {
    BimUtils.freeMaterial(outlineMat);
    BimUtils.freeEntity(knob);
    this.touch.setModelMode(false);

    if (this.drawer2d) {
      this.drawer2d.clear();
    }

    this.setSelectionMode();
  };

  this.doEscape = function () {
    this.onDeactivate();
  };

  this.doMouseMove = function (event) {
    this.touch.castScene(event);
    if (!this.touch.graspSnap()) return;
    var pos = this.touch.snapPosition();
    var pflag = this.touch.planeFlag();
    this.updateCurrentPos(pos);
    outlineMat.color.setHex(BimUtils.planeColor(pflag));
    var sPlane = this.touch.snapPlane();

    if (sPlane) {
      // knob
      var knobSize = 90;
      var ratio = viewer.getCameraZoom();
      var w = knobSize * ratio;
      var h = w;
      rw = w;
      rh = h;
      normalVec = sPlane.normal;
      matrix.identity();
      matrix.lookAt(Bim.Coords.org, normalVec, new THREE.Vector3(0, 0, 1));
      matrix.setPosition(pos);
      v0.set(-0.5 * w, 0.5 * h, 0);
      v1.set(0.5 * w, 0.5 * h, 0);
      v2.set(0.5 * w, -0.5 * h, 0);
      v3.set(-0.5 * w, -0.5 * h, 0);
      knob.geometry.setFromPoints([v0, v1, v2, v0, v2, v3, v0]);
      if (knob.geometry.matrix) knob.geometry.matrix.identity();
      knob.geometry.applyMatrix4(matrix);
    }
  };

  this.doMouseUp = function (event) {
    if (this.step === STEP.STEP0) {
      // surface entity
      var surfaceEntity = createSectionEntity();
      surfaceEntity.matrix.identity();
      surfaceEntity.applyMatrix4(matrix);
      crossSection.addClippingPlaneEntity(surfaceEntity);
      cutter3d.addCutter(surfaceEntity, normalVec);
      self.step = STEP.STEP1; // viewer.addObject(surfaceEntity);

      this.onDeactivate();
      viewer.signaler.clippingAdded.dispatch({
        plane: surfaceEntity,
        normal: normalVec
      });
    }
  };

  this.cameraControlChanged = function () {
    this.doMouseMove();
  };

  function createSectionEntity() {
    var geometry = new THREE.PlaneGeometry(rw * 8, rh * 8);
    var mat = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      side: THREE.DoubleSide,
      opacity: 0.5
    });
    var entity = new THREE.Mesh(geometry, [mat]);
    entity.userData.unSnapable = true;
    entity.userData.unClippable = true;
    return entity;
  }
}


"use strict";

function BimPaintCmd(viewer, data, scene, fillColor, fillTexture) {
  this.data = data;
  BimBaseCmd.call(this, viewer, scene, 'paint'); // utilities

  function filterIntersect(hit) {
    return hit.face != null && hit.object.visible && hit.object.name !== 'Ground' && hit.object.name !== 'Space' && hit.object.name !== 'plan';
  } // event handlers


  this.onActivate = function () {
    this.setCursor('bucket', true);
  };

  this.doMouseUp = function (event) {
    this.touch.castScene(event);
    var hit = this.touch.hitEntity(filterIntersect);

    if (hit) {
      this.applyCurrentMaterial(hit.object, hit.faceIndex);
    }
  };

  this.applyCurrentMaterial = function (object, findex) {
    var bimobj = this.data.getModelByMesh(object.parent).getBimObject(object);

    if (bimobj.faceMode === undefined || bimobj.faceMode === "pershape") {
      if (fillTexture !== undefined) {
        _loadTexturePromise(fillTexture).then(function (texture) {
          texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
          texture.needsUpdate = true;

          if (bimobj.materialPaint === undefined) {
            bimobj.materialPaint = object.material.clone();
            bimobj.materialPaint.vertexColors = false;
            bimobj.materialPaint.origin = {
              color: object.material.origin.color,
              opacity: object.material.origin.opacity,
              map: object.material.origin.map
            };
          }

          bimobj.materialPaint.map = texture;
          bimobj.materialPaint.color.setStyle("#ffffff");
          bimobj.materialPaint.needsUpdate = true;
          bimobj.materialPaint.origin.map = texture.clone();
          object.material = bimobj.materialPaint; // if (Array.isArray(object.material)) {
          //   for (let i = 0; i < object.material.length; i++) {
          //     object.material[i].map = texture;
          //     object.material[i].origin.map = texture.clone();
          //     object.material[i].needsUpdate = true;
          //   }
          // } else {
          //   object.material.map = texture;
          //   object.material.needsUpdate = true;
          //   object.material.origin.map = texture.clone();
          // }

          viewer.setDirty(true);
        })["catch"](function (error) {
          console.error(error);
        });
      } else {
        if (bimobj.materialPaint === undefined) {
          bimobj.materialPaint = object.material.clone();
          bimobj.materialPaint.vertexColors = false;
          bimobj.materialPaint.origin = {
            color: object.material.origin.color,
            opacity: object.material.origin.opacity,
            map: object.material.origin.map
          };
        }

        bimobj.materialPaint.color.setStyle(fillColor);
        bimobj.materialPaint.needsUpdate = true;
        bimobj.materialPaint.map = undefined;
        bimobj.materialPaint.origin.color = bimobj.materialPaint.color.getStyle();
        object.material = bimobj.materialPaint;
        viewer.setDirty(true);
      }
    } else {
      var selIdx = 0;

      for (var i = 0; i < object.geometry.groups.length; i++) {
        if (findex * 3 >= object.geometry.groups[i].start && findex * 3 < object.geometry.groups[i].start + object.geometry.groups[i].count) {
          selIdx = i;
          break;
        }
      }

      if (bimobj.materialPaintMap === undefined) {
        bimobj.materialPaintMap = [];

        for (var _i = 0; _i < object.geometry.groups.length; _i++) {
          var mat = object.material.clone();
          mat.origin = {
            color: object.material.origin.color,
            opacity: object.material.origin.opacity,
            map: object.material.origin.map
          };
          bimobj.materialPaintMap.push(mat);
        }
      }

      if (fillTexture !== undefined) {
        _loadTexturePromise(fillTexture).then(function (texture) {
          texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
          texture.needsUpdate = true;
          bimobj.materialPaintMap[selIdx].map = texture;
          bimobj.materialPaintMap[selIdx].color.setStyle("#ffffff");
          bimobj.materialPaintMap[selIdx].needsUpdate = true;
          bimobj.materialPaintMap[selIdx].vertexColors = false;
          bimobj.materialPaintMap[selIdx].origin.map = texture.clone();
          object.material = bimobj.materialPaintMap; // if (Array.isArray(object.material)) {
          //   for (let i = 0; i < object.material.length; i++) {
          //     object.material[i].map = texture;
          //     object.material[i].origin.map = texture.clone();
          //     object.material[i].needsUpdate = true;
          //   }
          // } else {
          //   object.material.map = texture;
          //   object.material.needsUpdate = true;
          //   object.material.origin.map = texture.clone();
          // }

          viewer.setDirty(true);
        })["catch"](function (error) {
          console.error(error);
        });
      } else {
        bimobj.materialPaintMap[selIdx].color.setStyle(fillColor);
        bimobj.materialPaintMap[selIdx].needsUpdate = true;
        bimobj.materialPaintMap[selIdx].map = undefined;
        bimobj.materialPaintMap[selIdx].vertexColors = false;
        bimobj.materialPaintMap[selIdx].origin.color = bimobj.materialPaintMap[selIdx].color.getStyle();
        object.material = bimobj.materialPaintMap; // if (Array.isArray(object.material)) {
        //   for (let i = 0; i < object.material.length; i++) {
        //     object.material[i].color.setStyle(fillColor);
        //     object.material[i].needsUpdate = true;
        //     object.material[i].origin.color = object.material[i].color.getStyle();
        //   }
        // } else {
        //   object.material.color.setStyle(fillColor);
        //   object.material.needsUpdate = true;
        //   object.material.origin.color = object.material.color.getStyle();
        // }

        viewer.setDirty(true);
      }
    }
  };

  function _loadTexturePromise(data) {
    return new Promise(function (resolve, reject) {
      new THREE.TextureLoader().load(data, function (texture) {
        resolve(texture);
      }, undefined, function (err) {
        reject(err);
      });
    });
  }
}


"use strict";

/**
 * @param viewer {BimViewer}
 * @param scene {THREE.Scene}
 * @param drawer2dText {BimDrawer2dText}
 * @param textBrush {Object}
 */
function BimText2dCmd(viewer, scene, drawer2dText, textBrush) {
  BimBaseCmd.call(this, viewer, scene, 'text2d');
  var STEP = {
    STEP0: 0
  };
  this.step = STEP.STEP0;
  var self = this;
  var LINE_HEIGHT = 1.5;
  var input = undefined;
  var newText = {};
  var hasInput = false;
  var curText = undefined; // utilities

  function initCommand() {
    self.step = STEP.STEP0;
  } // event handlers


  this.onActivate = function () {
    this.setCursor('text', true);
    initCommand();
  };

  this.onDeactivate = function () {
    this.doEscape();
  };

  this.doEscape = function () {
    initCommand();

    if (hasInput) {
      completeText();
    }
  };

  this.doMouseDown = function (event) {
    if (hasInput) {
      completeText();
    } else {
      var text = drawer2dText.getText(event.clientX, event.clientY);

      if (text) {
        editInput(text);
      } else {
        addInput(event.clientX, event.clientY);
      }
    }
  };

  this.doMouseMove = function (event) {};

  this.changeTextInfo = function (property, value) {
    if (!input) return;

    switch (property) {
      case 'fill':
        $(input).css({
          color: value
        });
        if (curText) curText.fillColor = value;
        break;

      case 'stroke':
        if (curText) curText.strokeColor = value;
        break;

      case 'text':
        $(input).val(value);
        break;

      case 'fontFamily':
        $(input).css({
          fontFamily: value
        });
        if (curText) curText.fontFamily = value;
        break;

      case 'fontStyle':
        $(input).css({
          fontStyle: value
        });
        if (curText) curText.fontStyle = value;
        break;

      case 'fontSize':
        $(input).css({
          fontSize: value + 'px'
        });
        if (curText) curText.fontSize = value;
        break;
    }
  };

  function addInput(x, y) {
    curText = undefined;
    input = document.createElement('textarea'); // SET TEXTAREA POSITION

    $(input).css({
      position: 'absolute',
      left: x,
      top: y,
      color: textBrush.fillColor,
      fontSize: textBrush.fontSize + 'px',
      fontFamily: textBrush.fontFamily,
      fontStyle: textBrush.fontStyle,
      lineHeight: LINE_HEIGHT
    });
    $(input).on('input', function () {
      this.style.height = "";
      this.style.height = this.scrollHeight + "px";
      newText.text = this.value;

      if (viewer.signaler) {
        viewer.signaler.textSelected.dispatch(newText);
      }
    });
    viewer.root.appendChild(input);
    input.focus();
    hasInput = true;
    newText = {
      text: '',
      fillColor: textBrush.fillColor,
      strokeColor: textBrush.strokeColor,
      fontFamily: textBrush.fontFamily,
      fontSize: textBrush.fontSize,
      fontStyle: textBrush.fontStyle,
      strokeWidth: 1
    };

    if (viewer.signaler) {
      viewer.signaler.textSelected.dispatch(newText);
    }
  }

  function editInput(text) {
    curText = text;
    input = document.createElement('textarea'); // SET TEXTAREA POSITION

    $(input).css({
      position: 'absolute',
      left: text.rect.x,
      top: text.rect.y,
      color: text.fillColor,
      fontSize: text.fontSize + 'px',
      fontFamily: text.fontFamily,
      fontStyle: text.fontStyle,
      lineHeight: LINE_HEIGHT
    });
    $(input).val(text.text);
    $(input).on('input', function () {
      this.style.height = "";
      this.style.height = this.scrollHeight + "px";
    });
    viewer.root.appendChild(input);
    input.focus();
    hasInput = true;
    drawer2dText.removeText(text);

    if (viewer.signaler) {
      viewer.signaler.textSelected.dispatch(text);
    }
  }

  function completeText() {
    if (curText) {
      drawer2dText.addText($(input).val(), parseFloat(input.style.left), parseFloat(input.style.top), {
        fontFamily: curText.fontFamily,
        fontSize: curText.fontSize,
        fontStyle: curText.fontStyle,
        fillColor: curText.fillColor,
        strokeColor: curText.strokeColor
      });
    } else {
      drawer2dText.addText($(input).val(), parseFloat(input.style.left), parseFloat(input.style.top), textBrush);
    }

    viewer.root.removeChild(input);
    hasInput = false;
    curText = undefined;

    if (viewer.signaler) {
      viewer.signaler.textDeselected.dispatch();
    }
  }
}


"use strict";

function BimMeasureAngleCmd(viewer, scene) {
  BimMeasureCmd.call(this, viewer, scene);
  var STEP = {
    STEP0: 0,
    STEP1: 1,
    STEP2: 2
  };
  this.step = STEP.STEP0;
  var measureLine;
  var measureText;
  var pos0 = new THREE.Vector3(0, 0, 0);
  var pos1 = new THREE.Vector3(0, 0, 0);
  var self = this; // event handlers

  this.onActivate = function () {
    self.setCursor('angle', true);
    initCommand();
  };

  this.doEscape = function () {
    if (measureLine) {
      BimUtils.freeEntity(measureLine);
      this.render();
    }

    if (measureText) {
      BimUtils.freeEntity(measureText);
      this.render();
    }

    initCommand();
  };

  this.doMouseUp = function (event) {
    this.touch.castScene(event);
    this.touch.graspSnap();
    var pos = this.touch.snapPosition();

    if (this.step === STEP.STEP0) {
      pos0.copy(pos); // start measure

      measureLine = BimUtils.createEdgeEntity(null, BimUtils.newMatMeasureline(), this.scene);
      measureLine.userData.hasArcSnap = true;
      this.step = STEP.STEP1;
    } else if (this.step === STEP.STEP1) {
      if (BimUtils.equalsVector3(pos0, pos, Bim.Constant.snapSize)) return; // start angle

      pos1.copy(pos);
      this.step = STEP.STEP2;
    } else if (this.step === STEP.STEP2) {
      if (makeMeasure(pos0, pos1, pos)) {
        initCommand();
      } else {
        this.doEscape();
      }
    }
  };

  this.doMouseMove = function (event) {
    this.touch.castScene(event);
    this.touch.graspSnap();
    var pos = this.touch.snapPosition();

    if (this.step === STEP.STEP1) {
      if (BimUtils.equalsVector3(pos0, pos, Bim.Constant.snapSize)) return;
      measureLine.geometry.setAttribute('position', new THREE.Float32BufferAttribute([pos0.x, pos0.y, pos0.z, pos.x, pos.y, pos.z], 3));
      this.render();
    } else if (this.step === STEP.STEP2) {
      if (makeMeasure(pos0, pos1, pos)) {
        this.render();
      }
    }
  };

  function initCommand() {
    measureLine = null;
    measureText = null;
    self.step = STEP.STEP0;
  }

  function makeMeasure(v0, v1, v2) {
    if (BimUtils.equalsVector3(v0, v1)) return false;
    if (BimUtils.equalsVector3(v0, v2)) return false;
    var coord3d = new THREE.Matrix4();
    var xAxis = new THREE.Vector3(0, 0, 0);
    var yAxis = new THREE.Vector3(0, 0, 0);
    var zAxis = new THREE.Vector3(0, 0, 0);
    var matInv = new THREE.Matrix4();
    var p0 = new THREE.Vector3(0, 0, 0);
    var p1 = new THREE.Vector3(0, 0, 0);
    var p2 = new THREE.Vector3(0, 0, 0); // make coord3d

    xAxis.subVectors(v1, v0).normalize();
    yAxis.subVectors(v2, v0).normalize(); // angle

    var radA = Math.acos(xAxis.dot(yAxis));
    var degA = THREE.Math.radToDeg(radA);
    zAxis.crossVectors(xAxis, yAxis).normalize();
    yAxis.crossVectors(zAxis, xAxis); // .normalize() ?

    coord3d.makeBasis(xAxis, yAxis, zAxis);
    coord3d.setPosition(v0);
    matInv.getInverse(coord3d);
    p0.copy(v0).applyMatrix4(matInv);
    p1.copy(v1).applyMatrix4(matInv);
    p2.copy(v2).applyMatrix4(matInv);
    if (BimUtils.IsZero(p2.y)) return false; // is on x-axis ?

    var path = new THREE.Path();
    path.autoClose = true;
    path.moveTo(p0.x, p0.y);
    path.lineTo(p1.x, p1.y);
    var radius = p0.distanceTo(p1);
    path.absarc(p0.x, p0.y, radius, 0, radA, p2.y < 0);
    var pts2d = path.getPoints();
    var pts3d = [];
    var pt;

    for (var i = 0, l = pts2d.length - 1; i < l; i++) {
      pt = pts2d[i];
      pts3d.push(pt.x);
      pts3d.push(pt.y);
      pts3d.push(0);
      pt = pts2d[i + 1];
      pts3d.push(pt.x);
      pts3d.push(pt.y);
      pts3d.push(0);
    } // measure-line


    measureLine.geometry.setAttribute('position', new THREE.Float32BufferAttribute(pts3d, 3));
    if (measureLine.geometry.matrix) measureLine.geometry.matrix.identity();
    measureLine.geometry.applyMatrix4(coord3d); // measure-text

    if (measureText) {
      BimUtils.freeEntity(measureText);
      measureText = null;
    }

    measureText = BimUtils.createMeasureText(self.angleString(degA), viewer.getCameraZoom());
    self.addObject(measureText);
    var txtPos = measureText.position;
    radA /= 2;
    txtPos.x = Math.cos(radA);
    txtPos.y = Math.sin(radA);
    if (p2.y < 0) txtPos.y = -txtPos.y;
    txtPos.z = 0;
    txtPos.multiplyScalar(radius).applyMatrix4(coord3d);
    return true;
  }
}


"use strict";

function BimMeasureCmd(viewer, scene) {
  BimBaseCmd.call(this, viewer, scene, 'measure');
  this.currentUnit = 'm';
  this.inputMethod = 'en';

  this.setCurrentUnit = function (unit) {
    this.currentUnit = unit;
    return this;
  };

  this.setInputMethod = function (method) {
    this.inputMethod = method;
    return this;
  };

  this.distanceString = function (value) {
    var scale = this.currentUnit;
    var ratio = getScaleRatio(scale);
    var realValue = value * ratio;
    var display = this.inputMethod === 'eu' ? ExtUtils.comma2decimal(realValue, 2) : ExtUtils.roundNumber(realValue, 2);
    return display + scale;
  };

  this.areaString = function (value) {
    var scale = this.currentUnit;
    var ratio = getScaleRatio(scale);
    var realValue = value * ratio * ratio;
    var display = this.inputMethod === 'eu' ? ExtUtils.comma2decimal(realValue, 2) : ExtUtils.roundNumber(realValue, 2);
    var unitStr = scale + '²';
    return display + unitStr;
  };

  this.volumeString = function (value) {
    var scale = this.currentUnit;
    var ratio = getScaleRatio(scale);
    var realValue = value * ratio * ratio * ratio;
    var display = this.inputMethod === 'eu' ? ExtUtils.comma2decimal(realValue, 2) : ExtUtils.roundNumber(realValue, 2);
    var unitStr = scale + '³';
    return display + unitStr;
  };

  this.angleString = function (value) {
    var display = this.inputMethod === 'eu' ? ExtUtils.comma2decimal(value, 1) : ExtUtils.roundNumber(value, 1);
    return display + '°';
  };

  function getScaleRatio(scale) {
    var ratio = 1;

    switch (scale) {
      case 'm':
        ratio = 1;
        break;

      case 'cm':
        ratio = 100;
        break;

      case 'mm':
        ratio = 1000;
        break;

      case 'inch':
        ratio = 39.37;
        break;

      default:
        break;
    }

    return ratio;
  }
}


"use strict";

function BimMeasureDistanceCmd(viewer, scene) {
  BimMeasureCmd.call(this, viewer, scene);
  var STEP = {
    STEP0: 0,
    STEP1: 1,
    STEP2: 2
  };
  this.step = STEP.STEP0;
  var measureLine;
  var measureText;
  var measureSideLine1;
  var measureSideLine2;
  var arrowMesh1;
  var arrowMesh2;
  var v0 = new THREE.Vector3(0, 0, 0);
  var v1 = new THREE.Vector3(0, 0, 0);
  var startPt1;
  var startPt2;
  var endPt1;
  var endPt2;
  var length;
  var rotPlane = new THREE.Plane(); // rotating plane

  var firstPos;
  var self = this; // event handlers

  this.onActivate = function () {
    this.setCursor('length', true);
    initCommand();
  };

  this.doEscape = function () {
    if (measureLine) {
      BimUtils.freeEntity(measureLine);
      this.render();
    }

    if (measureText) {
      BimUtils.freeEntity(measureText);
      this.render();
    }

    if (arrowMesh1) {
      BimUtils.freeEntity(arrowMesh1);
      this.render();
    }

    if (arrowMesh2) {
      BimUtils.freeEntity(arrowMesh2);
      this.render();
    }

    if (measureSideLine1) {
      BimUtils.freeEntity(measureSideLine1);
      this.render();
    }

    if (measureSideLine2) {
      BimUtils.freeEntity(measureSideLine2);
      this.render();
    }

    initCommand();
  };

  this.doMouseUp = function (event) {
    if (this.step === STEP.STEP0) {
      this.touch.castScene(event);
      this.touch.graspSnap();
      var pos = this.touch.snapPosition();
      firstPos = pos.clone(); // start measure

      measureLine = BimUtils.createEdgeEntity(2 * 3, BimUtils.newMatMeasureline(), this.scene);
      var position = measureLine.geometry.getAttribute('position');
      position.setXYZ(0, pos.x, pos.y, pos.z);
      position.setXYZ(1, pos.x, pos.y, pos.z);
      this.step = STEP.STEP1;
    } else if (this.step === STEP.STEP1) {
      var _position = measureLine.geometry.getAttribute('position');

      v0.fromBufferAttribute(_position, 0);
      v1.fromBufferAttribute(_position, 1);
      var dist = v0.distanceTo(v1);

      if (!BimUtils.IsZero(dist, Bim.Constant.snapSize)) {
        // register
        startPt1 = v0.clone();
        startPt2 = v1.clone();
        length = dist;
        measureSideLine1 = BimUtils.createEdgeEntity(2 * 3, BimUtils.newMatMeasureline(), this.scene);
        _position = measureSideLine1.geometry.getAttribute('position');

        _position.setXYZ(0, startPt1.x, startPt1.y, startPt1.z);

        _position.setXYZ(1, startPt1.x, startPt1.y, startPt1.z);

        measureSideLine2 = BimUtils.createEdgeEntity(2 * 3, BimUtils.newMatMeasureline(), this.scene);
        _position = measureSideLine2.geometry.getAttribute('position');

        _position.setXYZ(0, startPt2.x, startPt2.y, startPt2.z);

        _position.setXYZ(1, startPt2.x, startPt2.y, startPt2.z);

        var normal = startPt2.clone().sub(startPt1).normalize();
        rotPlane.setFromNormalAndCoplanarPoint(normal, startPt2); // rot-plane

        this.step = STEP.STEP2;
      } else {
        this.doEscape();
      }
    } else if (this.step === STEP.STEP2) {
      measureLine.userData.unSnapable = true;
      measureSideLine1.userData.unSnapable = true;
      measureSideLine2.userData.unSnapable = true;
      measureText.userData.unSnapable = true;
      var group = new THREE.Group();
      group.add(measureLine);
      group.add(measureText);
      group.add(measureSideLine1);
      group.add(measureSideLine2);
      group.add(arrowMesh1);
      group.add(arrowMesh2);
      this.addObject(group);
      initCommand();
    }
  };

  this.doMouseMove = function (event) {
    this.touch.castScene(event);
    this.touch.graspSnap();
    var pos = this.touch.snapPosition();

    if (this.step === STEP.STEP1 && viewer.signaler.keyStatus === 'shortcut:shift') {
      pos = BimUtils.getStraightLine3d(firstPos, pos);
    }

    if (this.step === STEP.STEP1) {
      var position = measureLine.geometry.getAttribute('position');
      position.setXYZ(1, pos.x, pos.y, pos.z);
      position.needsUpdate = true; // text

      if (measureText) {
        BimUtils.freeEntity(measureText);
        measureText = null;
      }

      v0.fromBufferAttribute(position, 0);
      v1.fromBufferAttribute(position, 1);
      var dist = v0.distanceTo(v1);

      if (!BimUtils.IsZero(dist, Bim.Constant.snapSize)) {
        measureText = BimUtils.createMeasureText(this.distanceString(dist), viewer.getCameraZoom());
        measureText.position.addVectors(v0, v1).multiplyScalar(0.5);
        this.addObject(measureText);
      }

      this.render();
    } else if (this.step === STEP.STEP2) {
      var vec = new THREE.Vector3();

      if (this.touch.ray.intersectPlane(rotPlane, vec)) {
        var v01 = vec.clone().sub(startPt1);
        var v02 = startPt2.clone().sub(startPt1);
        var normalVec = v02.clone().cross(v01);
        var dirVec = normalVec.clone().cross(v02);
        dirVec.normalize();

        var _dist = normalVec.length() / v02.length();

        endPt1 = startPt1.clone().add(dirVec.clone().multiplyScalar(_dist));
        endPt2 = startPt2.clone().add(dirVec.clone().multiplyScalar(_dist));

        var _position2 = measureLine.geometry.getAttribute('position');

        _position2.setXYZ(0, endPt1.x, endPt1.y, endPt1.z);

        _position2.setXYZ(1, endPt2.x, endPt2.y, endPt2.z);

        _position2.needsUpdate = true;

        if (measureText) {
          BimUtils.freeEntity(measureText);
        }

        measureText = BimUtils.createMeasureText(this.distanceString(length), viewer.getCameraZoom());
        measureText.position.addVectors(endPt1, endPt2).multiplyScalar(0.5);
        this.addObject(measureText);
        _position2 = measureSideLine1.geometry.getAttribute('position');

        _position2.setXYZ(0, startPt1.x, startPt1.y, startPt1.z);

        _position2.setXYZ(1, endPt1.x, endPt1.y, endPt1.z);

        _position2.needsUpdate = true;
        _position2 = measureSideLine2.geometry.getAttribute('position');

        _position2.setXYZ(0, startPt2.x, startPt2.y, startPt2.z);

        _position2.setXYZ(1, endPt2.x, endPt2.y, endPt2.z);

        _position2.needsUpdate = true;

        if (arrowMesh1) {
          BimUtils.freeEntity(arrowMesh1);
        }

        arrowMesh1 = createArrowEntity(v02.clone().normalize(), Bim.Constant.snapSize, true);
        arrowMesh1.position.copy(endPt1);

        if (arrowMesh2) {
          BimUtils.freeEntity(arrowMesh2);
        }

        arrowMesh2 = createArrowEntity(v02.clone().normalize(), Bim.Constant.snapSize, false);
        arrowMesh2.position.copy(endPt2);
        this.addObject(arrowMesh1);
        this.addObject(arrowMesh2);
      }
    }
  };

  function initCommand() {
    measureLine = null;
    measureText = null;
    arrowMesh1 = null;
    arrowMesh2 = null;
    measureSideLine1 = null;
    measureSideLine2 = null;
    self.step = STEP.STEP0;
  }

  function createArrowEntity(dir, size, isInside) {
    var arrowSize = size * 2;
    var cross = dir.clone().cross(Bim.Coords.zaxis);
    var v0 = new THREE.Vector3(0, 0, 0);
    var v00, v1, v2;

    if (isInside) {
      v00 = v0.clone().add(dir.clone().multiplyScalar(0.86 * arrowSize));
      v1 = v00.clone().add(cross.clone().multiplyScalar(0.5 * arrowSize));
      v2 = v00.clone().sub(cross.clone().multiplyScalar(0.5 * arrowSize));
    } else {
      v00 = v0.clone().sub(dir.clone().multiplyScalar(0.86 * arrowSize));
      v1 = v00.clone().add(cross.clone().multiplyScalar(0.5 * arrowSize));
      v2 = v00.clone().sub(cross.clone().multiplyScalar(0.5 * arrowSize));
    }

    var vertices = [v0.x, v0.y, v0.z, v1.x, v1.y, v1.z, v2.x, v2.y, v2.z];
    var colors = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    var geom = new THREE.BufferGeometry();
    geom.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    geom.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
    var material = new THREE.MeshBasicMaterial({
      side: THREE.DoubleSide,
      vertexColors: THREE.VertexColors
    });
    var arrow = new THREE.Mesh(geom, material);
    arrow.userData.unSnapable = true;
    return arrow;
  }
}


"use strict";

function BimMeasureValueCmd(viewer, scene, type) {
  BimMeasureCmd.call(this, viewer, scene);
  var v0 = new THREE.Vector3(0, 0, 0);
  var v1 = new THREE.Vector3(0, 0, 0); // event handlers

  this.onActivate = function () {
    var cursor;

    if (type === 'sameplane') {
      cursor = 'side';
    } else if (type === 'totalarea') {
      cursor = 'surface';
    } else {
      cursor = type;
    }

    this.setCursor(cursor, true);
  };

  this.doMouseUp = function (event) {
    this.touch.castScene(event);
    this.touch.graspSnap();
    var snapFlag = this.touch.snapFlag();
    var pos = this.touch.snapPosition();
    var hit = this.touch.hitEntity(filterIntersect);
    if (!hit) return false;
    var ts = viewer.getCameraZoom();
    var entity = hit.object;

    switch (type) {
      case 'circumference':
        {
          var position = entity.geometry.getAttribute('position');
          var value = 0;

          for (var i = 0, l = position.count - 1; i < l; i++) {
            v0.fromBufferAttribute(position, i);
            v1.fromBufferAttribute(position, i + 1);
            value += v0.distanceTo(v1);
          }

          if (!BimUtils.IsZero(value)) {
            var text = BimUtils.createMeasureText(this.distanceString(value), ts);
            text.position.copy(pos);
            this.addObject(text);
          }

          break;
        }

      case 'diameter':
        {
          if (snapFlag !== Bim.SnapFlag.onEndVt) break;
          var center = BimUtils.centerPosition(entity);

          var _value = center.distanceTo(pos);

          if (!BimUtils.IsZero(_value)) {
            var _text = BimUtils.createMeasureText(this.distanceString(_value), ts);

            _text.position.addVectors(center, pos).multiplyScalar(0.5);

            var line = BimUtils.createEdgeEntity(2 * 3, BimUtils.newMatMeasureline());

            var _position = line.geometry.getAttribute('position');

            _position.setXYZ(0, center.x, center.y, center.z);

            _position.setXYZ(1, pos.x, pos.y, pos.z);

            this.addObject(line);
            this.addObject(_text);
          }

          break;
        }

      case 'sameplane':
      case 'totalarea':
        {
          var faces = [];

          if (type === 'sameplane') {
            BimUtils.coplanarFaces(faces, hit.face, entity.geometry.faces);
          } else {
            faces = entity.geometry.faces;
          }

          var _value2 = 0;
          var vertices = entity.geometry.vertices;
          var triangle;
          faces.forEach(function (face) {
            triangle = new THREE.Triangle(vertices[face.a], vertices[face.b], vertices[face.c]);
            _value2 += triangle.getArea();
          });

          if (!BimUtils.IsZero(_value2)) {
            var _text2 = BimUtils.createMeasureText(this.areaString(_value2), ts);

            _text2.position.copy(pos);

            this.addObject(_text2);
          }

          break;
        }

      case 'volume':
        {
          entity.geometry.boundingBox.getSize(v0);

          var _value3 = v0.x * v0.y * v0.z;

          if (!BimUtils.IsZero(_value3)) {
            var _text3 = BimUtils.createMeasureText(this.volumeString(_value3), ts);

            _text3.position.copy(pos);

            this.addObject(_text3);
          }

          break;
        }
    }
  };

  this.doMouseMove = function (event) {
    this.touch.castScene(event);
    this.touch.graspSnap();
  };

  function filterIntersect(hit) {
    var entity = hit.object;
    if (!entity) return false;

    if (type === 'circumference') {
      return true;
    } else if (type === 'diameter') {
      return true;
    } else {
      return entity.isMesh;
    }
  }
}


"use strict";

function BimMeasureVertexCmd(viewer, scene) {
  BimMeasureCmd.call(this, viewer, scene);
  var STEP = {
    STEP0: 0,
    STEP1: 1
  };
  this.step = STEP.STEP0;
  var measureLine;
  var measureText;
  var v0 = new THREE.Vector3(0, 0, 0);
  var v1 = new THREE.Vector3(0, 0, 0);
  var self = this; // event handlers

  this.onActivate = function () {
    self.setCursor('vertex', true);
    initCommand();
  };

  this.doEscape = function () {
    if (measureLine) {
      BimUtils.freeEntity(measureLine);
      this.render();
    }

    if (measureText) {
      BimUtils.freeEntity(measureText);
      this.render();
    }

    initCommand();
  };

  this.doMouseUp = function (event) {
    this.touch.castScene(event);
    this.touch.graspSnap();
    var sflag = this.touch.snapFlag();
    if (sflag !== Bim.SnapFlag.onEndVt) return;

    if (this.step === STEP.STEP0) {
      var pos = this.touch.snapPosition(); // start measure

      measureLine = BimUtils.createEdgeEntity(2 * 3, BimUtils.newMatMeasureline(), this.scene);
      var position = measureLine.geometry.getAttribute('position');
      position.setXYZ(0, pos.x, pos.y, pos.z);
      position.setXYZ(1, pos.x, pos.y, pos.z);
      this.step = STEP.STEP1;
    } else if (this.step === STEP.STEP1) {
      var _position = measureLine.geometry.getAttribute('position');

      v0.fromBufferAttribute(_position, 0);
      v1.fromBufferAttribute(_position, 1);
      var dist = v0.distanceTo(v1);

      if (!BimUtils.IsZero(dist, Bim.Constant.snapSize)) {
        // register
        this.addObject(measureLine);
        this.addObject(measureText);
        initCommand();
      } else {
        this.doEscape();
      }
    }
  };

  this.doMouseMove = function (event) {
    this.touch.castScene(event);
    this.touch.graspSnap();

    if (this.step === STEP.STEP1) {
      var pos = this.touch.snapPosition();
      var position = measureLine.geometry.getAttribute('position');
      position.setXYZ(1, pos.x, pos.y, pos.z);
      position.needsUpdate = true; // text

      if (measureText) {
        BimUtils.freeEntity(measureText);
        measureText = null;
      }

      v0.fromBufferAttribute(position, 0);
      v1.fromBufferAttribute(position, 1);
      var dist = v0.distanceTo(v1);

      if (!BimUtils.IsZero(dist, Bim.Constant.snapSize)) {
        measureText = BimUtils.createMeasureText(this.distanceString(dist), viewer.getCameraZoom());
        measureText.position.addVectors(v0, v1).multiplyScalar(0.5);
        this.addObject(measureText);
      }

      this.render();
    }
  };

  function initCommand() {
    measureLine = null;
    measureText = null;
    self.step = STEP.STEP0;
  }
}


"use strict";

/**
 * @param viewer {BimViewer}
 * @param scene {THREE.Scene}
 * @param plan {Object}
 * @param callback {function}
 */
function BimPlanMatchCmd(viewer, scene, plan, callback) {
  BimBaseCmd.call(this, viewer, scene, 'plan');
  var STEP = {
    STEP0: 0,
    STEP1: 1
  };
  this.step = STEP.STEP0;
  var outlineMat = null;
  var knob = null;
  var v0 = new THREE.Vector3();
  var v1 = new THREE.Vector3();
  var v2 = new THREE.Vector3();
  var v3 = new THREE.Vector3();
  var normalVec = new THREE.Vector3();
  var matrix = new THREE.Matrix4();
  var rw = 0,
      rh = 0;
  var self = this;

  function initCommand() {
    self.step = STEP.STEP0;
    if (knob) knob.visible = true;
  } // event handlers


  this.onActivate = function () {
    this.setCursor('default');
    outlineMat = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.6,
      depthTest: false
    });
    knob = new THREE.Mesh(new THREE.BufferGeometry().setFromPoints([v0, v1, v2, v0, v2, v3, v0]), outlineMat);
    this.scene.add(knob);
    knob.userData.unSnapable = true;
    this.touch.setModelMode(true);
    initCommand();
  };

  this.onDeactivate = function () {
    BimUtils.freeMaterial(outlineMat);
    BimUtils.freeEntity(knob);
    this.touch.setModelMode(false);

    if (this.drawer2d) {
      this.drawer2d.clear();
    }

    this.releaseCurrentCmd();
  };

  this.doEscape = function () {
    this.onDeactivate();
  };

  this.doMouseMove = function (event) {
    this.touch.castScene(event);
    if (!this.touch.graspSnap()) return;
    var pos = this.touch.snapPosition();
    var pflag = this.touch.planeFlag();
    this.updateCurrentPos(pos);
    outlineMat.color.setHex(BimUtils.planeColor(pflag));
    var sPlane = this.touch.snapPlane();

    if (sPlane) {
      // knob
      var knobSize = 90;
      var ratio = viewer.getCameraZoom();
      var w = knobSize * ratio;
      var h = w;
      rw = w;
      rh = h;
      normalVec = sPlane.normal;
      matrix.identity();
      matrix.lookAt(Bim.Coords.org, normalVec, new THREE.Vector3(0, 0, 1));
      matrix.setPosition(pos);
      v0.set(-0.5 * w, 0.5 * h, 0);
      v1.set(0.5 * w, 0.5 * h, 0);
      v2.set(0.5 * w, -0.5 * h, 0);
      v3.set(-0.5 * w, -0.5 * h, 0);
      knob.geometry.setFromPoints([v0, v1, v2, v0, v2, v3, v0]);
      if (knob.geometry.matrix) knob.geometry.matrix.identity();
      knob.geometry.applyMatrix4(matrix);
    }
  };

  this.doMouseUp = function (event) {
    if (this.step === STEP.STEP0) {
      if (callback) {
        callback(plan, {
          normal: normalVec,
          rw: rw === 0 ? 10 : rw,
          matrix: matrix,
          x: event.clientX,
          y: event.clientY
        });
      }

      self.step = STEP.STEP1;
      this.onDeactivate();
    }
  };

  this.cameraControlChanged = function () {
    this.doMouseMove();
  };
}


"use strict";

/**
 * @param viewer {BimViewer}
 * @param bimPlan {BimPlan}
 * @param drawer2d {BimDrawer2d}
 */
function BimPlanTransformer(viewer, bimPlan, drawer2d) {
  'use strict';

  this.mesh = undefined;
  this.control1 = undefined; // xy 1

  this.control2 = undefined; // xy 2

  this.control3 = undefined; // z

  this.touch = new TouchTracker(viewer);
  this.normal = undefined;
  var controlObj = "assets/images/cgviewer/bim/arrow.obj";
  var loader = new THREE.OBJLoader();
  var curControl = undefined;
  var snapPlane = new THREE.Plane();
  var pointerId = undefined;
  var startPos = undefined;
  var basePlane = new THREE.Plane();
  var raycaster = new THREE.Raycaster();
  raycaster.camera = viewer.camera;
  var self = this;

  function init() {
    self.control1 = createControlPoint(0x00ff00);
    self.control2 = createControlPoint(0x00ff00);
    self.mesh = bimPlan.mesh;
    self.normal = bimPlan.normal.clone().normalize();
    snapPlane.setFromNormalAndCoplanarPoint(self.normal, self.mesh.position);
    var bbox = self.mesh.geometry.boundingBox;
    setControlPosition(self.control1, bbox.min);
    setControlPosition(self.control2, bbox.max);
    self.mesh.add(self.control1);
    self.mesh.add(self.control2);
    loadObject().then(function (object) {
      var matrix = new THREE.Matrix4();
      matrix.lookAt(Bim.Coords.org, self.normal, new THREE.Vector3(0, 0, 1));
      object.applyMatrix4(matrix);
      object.position.copy(self.mesh.position);
      object.position.add(self.normal.clone().multiplyScalar(0.5));
      self.control3 = object;
      viewer.scene.add(self.control3);
    });
  }

  this.attach = function () {
    this.control1.visible = true;
    this.control2.visible = true;

    if (self.control3) {
      self.control3.visible = true;
    }

    this.touch.setSnapMode(true);
    this.touch.setModelMode(true);
    this.touch.start({
      'pointerdown': onMouseDown,
      'pointermove': onMouseMove,
      'pointerup': onMouseUp
    });
    viewer.signaler.cameraControlChanged.add(cameraUpdated);
  };

  this.detach = function () {
    this.touch.setSnapMode(false);
    this.touch.setModelMode(false);
    this.touch.stop();
    this.control1.visible = false;
    this.control2.visible = false;

    if (self.control3) {
      self.control3.visible = false;
    }

    drawer2d.clear();
    viewer.signaler.cameraControlChanged.remove(cameraUpdated);
    viewer.cameraCtrl.resume();
  };

  this.dispose = function () {
    this.detach();
    this.mesh.remove(this.control1);
    this.mesh.remove(this.control2);

    if (self.control3) {
      viewer.scene.remove(self.control3);
    }

    if (pointerId !== undefined) {
      viewer.canvas.releasePointerCapture(pointerId);
      pointerId = undefined;
    }

    this.control1 = undefined;
    this.control2 = undefined;
    this.mesh = undefined;
    this.normal = undefined;
  };

  function createControlPoint(color) {
    var geometry = new THREE.CylinderGeometry(0.8, 0.8, 0.1, 32);
    geometry.applyMatrix4(new THREE.Matrix4().makeRotationX(Math.PI / 2));
    var mesh = new THREE.Mesh(geometry, new THREE.MeshPhongMaterial({
      color: color,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.7,
      depthTest: false
    }));
    mesh.userData.unSnapable = true;
    mesh.userData.unClippable = true;
    return mesh;
  }

  function setControlPosition(control, position) {
    control.position.set(position.x, position.y, 0);
  }

  function onMouseDown(event) {
    event.preventDefault();
    if (self.mesh === undefined) return;
    self.touch.castScene(event);
    var hitInfo = self.touch.hitObject([self.control1, self.control2, self.control3], null);

    if (hitInfo) {
      if (hitInfo.object === self.control1 || hitInfo.object === self.control2) {
        curControl = hitInfo.object;
        curControl.material.color.setStyle('#0000ff');
        viewer.setDirty(true);
        snapPlane.setFromNormalAndCoplanarPoint(self.normal, self.mesh.position);
        viewer.cameraCtrl.pause();
        viewer.canvas.setPointerCapture(event.pointerId);
        pointerId = event.pointerId;
      } else {
        snapPlane.setFromNormalAndCoplanarPoint(self.normal, self.mesh.position);
        setMaterialColor(self.control3, 0x0000ff);
        viewer.setDirty(true);
        setRaycaster(event.clientX, event.clientY);
        startPos = new THREE.Vector3();

        if (raycaster.ray.intersectPlane(snapPlane, startPos)) {
          var lookAt = new THREE.Vector3();
          viewer.camera.getWorldDirection(lookAt);
          basePlane.setFromNormalAndCoplanarPoint(lookAt, startPos);
          viewer.cameraCtrl.pause();
          viewer.canvas.setPointerCapture(event.pointerId);
          pointerId = event.pointerId;
        } else {
          startPos = undefined;
        }
      }
    }
  }

  function onMouseMove(event) {
    event.preventDefault();
    if (self.mesh === undefined) return;

    if (curControl) {
      self.touch.castScene(event);
      self.touch.graspSnap();
      drawer2d.showSnapSticker(event, self.touch);
      var newPos = new THREE.Vector3();
      setRaycaster(event.clientX, event.clientY);

      if (raycaster.ray.intersectPlane(snapPlane, newPos)) {
        if (viewer.signaler.keyStatus === 'shortcut:ctrl') {
          transformControl(curControl, newPos);
        } else {
          transformMesh(curControl, newPos);
        }
      }
    } else if (startPos) {
      var secondPos = new THREE.Vector3();
      setRaycaster(event.clientX, event.clientY);

      if (!raycaster.ray.intersectPlane(basePlane, secondPos)) {
        return;
      }

      var subVec = secondPos.clone().sub(startPos);
      var dot = self.normal.clone().dot(subVec);
      var moveVec = self.normal.clone().multiplyScalar(dot);
      self.control3.position.add(moveVec);
      self.mesh.position.add(moveVec);
      bimPlan.planSection.updateClippingPlanes();
      viewer.setDirty(true);
      startPos = secondPos;
    }
  }

  function onMouseUp(event) {
    event.preventDefault();

    if (curControl) {
      curControl.material.color.setStyle('#00ff00');
      curControl = undefined;
    }

    if (startPos) {
      setMaterialColor(self.control3, 0x00ff00);
      startPos = undefined;
    }

    viewer.setDirty(true);
    viewer.cameraCtrl.resume();
    drawer2d.clear();
    viewer.canvas.releasePointerCapture(event.pointerId);
    pointerId = undefined;
  }

  function cameraUpdated(camera) {
    if (self.mesh) {
      var scaleVector = new THREE.Vector3();
      var scaleFactor = 30;
      var length = scaleVector.subVectors(self.mesh.position, camera.position).length();
      var scale = length / scaleFactor;

      if (self.control1) {
        self.control1.scale.set(scale, scale, scale);
      }

      if (self.control2) {
        self.control2.scale.set(scale, scale, scale);
      }

      if (self.control3) {
        scale = length / 6;
        self.control3.scale.set(scale, scale, scale);
        self.control3.position.copy(self.mesh.position);
        self.control3.position.add(self.normal.clone().multiplyScalar(scale * 0.2));
      }
    }
  }

  function loadObject() {
    return new Promise(function (resolve, reject) {
      loader.load(controlObj, function (obj) {
        obj.scale.set(3, 3, 3);
        obj.rotation.x = Math.PI / 2;
        setMaterialColor(obj, 0x00ff00);
        resolve(obj);
      }, function () {}, function (err) {
        reject(err);
      });
    });
  }

  function setMaterialColor(object, color) {
    object.traverse(function (child) {
      if (child.isMesh) {
        child.material.color = new THREE.Color(color);
      }
    });
  }

  function setRaycaster(x, y) {
    var rect = viewer.canvas.getBoundingClientRect();
    x -= rect.left;
    y -= rect.top;
    var camera = viewer.camera;
    var vector = new THREE.Vector3(x / viewer.width * 2 - 1, -(y / viewer.height) * 2 + 1, 0.5);
    vector.unproject(camera);
    raycaster.set(camera.position, vector.sub(camera.position).normalize());
  }

  function transformControl(control, pos) {
    self.mesh.worldToLocal(pos);
    var bbox = self.mesh.geometry.boundingBox;
    var newX = THREE.MathUtils.clamp(pos.x, bbox.min.x, bbox.max.x);
    var newY = THREE.MathUtils.clamp(pos.y, bbox.min.y, bbox.max.y);
    var newZ = THREE.MathUtils.clamp(pos.z, bbox.min.z, bbox.max.z);
    control.position.set(newX, newY, newZ);
    viewer.setDirty(true);
  }

  function transformMesh(control, pos) {
    var originControl = self.control1 === control ? self.control2 : self.control1;
    var originPosition = originControl.position.clone();
    var controlPosition = control.position.clone();
    self.mesh.localToWorld(originPosition);
    self.mesh.localToWorld(controlPosition);
    var oldScale = originControl.scale.clone();
    var v1 = controlPosition.clone().sub(originPosition);
    var v2 = pos.sub(originPosition);
    var length1 = v1.length();
    var scale = length1 === 0 ? 1 : v2.length() / length1;
    var quaternion = new THREE.Quaternion();
    quaternion.setFromUnitVectors(v1.normalize(), v2.normalize());
    viewer.scene.attach(originControl);
    originControl.attach(self.mesh);
    originControl.applyQuaternion(quaternion);
    originControl.scale.set(originControl.scale.x * scale, originControl.scale.y * scale, originControl.scale.z * scale);
    viewer.scene.attach(self.mesh);
    self.mesh.attach(originControl);
    originControl.scale.copy(oldScale);

    if (scale !== 0) {
      control.scale.set(control.scale.x / scale, control.scale.y / scale, control.scale.z / scale);
      originControl.scale.set(originControl.scale.x / scale, originControl.scale.y / scale, originControl.scale.z / scale);
    }

    if (self.control3) {
      self.control3.position.copy(self.mesh.position);
      self.control3.position.add(self.normal.clone().multiplyScalar(0.5));
    }

    viewer.setDirty(true);
    bimPlan.planSection.updateClippingPlanes();
  }

  init();
}


"use strict";

function Axes() {
  this.line = undefined;
}

Axes.prototype = {
  addToScene: function addToScene(scene) {
    if (this.line) {
      scene.add(this.line);
    }
  },
  removeFromScene: function removeFromScene(scene) {
    if (this.line) {
      scene.remove(this.line);
    }
  },
  update: function update(scene) {
    this.removeFromScene(scene);
    var size = Bim.AxisLimit;
    this.line = new THREE.Group();
    var halfAxis;
    var redAxis = new THREE.Group();
    var dashedVertices = [-size, 0, 0, 0, 0, 0];
    var dashedColors = [1, 0, 0, 1, 0, 0];
    var dashedGeometry = new THREE.BufferGeometry();
    dashedGeometry.setAttribute('position', new THREE.Float32BufferAttribute(dashedVertices, 3));
    dashedGeometry.setAttribute('color', new THREE.Float32BufferAttribute(dashedColors, 3));
    var dashedMaterial = new THREE.LineDashedMaterial({
      vertexColors: THREE.VertexColors,
      dashSize: 0.5,
      gapSize: 0.5
    });
    halfAxis = new THREE.LineSegments(dashedGeometry, dashedMaterial).computeLineDistances();
    redAxis.add(halfAxis);
    halfAxis.name = 'red';
    var vertices = [0, 0, 0, size, 0, 0];
    var colors = [1, 0, 0, 1, 0, 0];
    var geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
    var material = new THREE.LineBasicMaterial({
      vertexColors: THREE.VertexColors
    });
    halfAxis = new THREE.LineSegments(geometry, material);
    redAxis.add(halfAxis);
    redAxis.name = 'redAxis';
    halfAxis.name = 'red';
    this.line.add(redAxis);
    var blueAxis = new THREE.Group();
    dashedVertices = [0, -size, 0, 0, 0, 0];
    dashedColors = [0, 1, 0, 0, 1, 0];
    dashedGeometry = new THREE.BufferGeometry();
    dashedGeometry.setAttribute('position', new THREE.Float32BufferAttribute(dashedVertices, 3));
    dashedGeometry.setAttribute('color', new THREE.Float32BufferAttribute(dashedColors, 3));
    dashedMaterial = new THREE.LineDashedMaterial({
      vertexColors: THREE.VertexColors,
      dashSize: 0.5,
      gapSize: 0.5
    });
    halfAxis = new THREE.LineSegments(dashedGeometry, dashedMaterial).computeLineDistances();
    blueAxis.add(halfAxis);
    halfAxis.name = 'green';
    vertices = [0, 0, 0, 0, size, 0];
    colors = [0, 1, 0, 0, 1, 0];
    geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
    material = new THREE.LineBasicMaterial({
      vertexColors: THREE.VertexColors
    });
    halfAxis = new THREE.LineSegments(geometry, material);
    blueAxis.add(halfAxis);
    blueAxis.name = 'greenAxis';
    halfAxis.name = 'green';
    this.line.add(blueAxis);
    var greenAxis = new THREE.Group();
    dashedVertices = [0, 0, -size, 0, 0, 0];
    dashedColors = [0, 0, 1, 0, 0, 1];
    dashedGeometry = new THREE.BufferGeometry();
    dashedGeometry.setAttribute('position', new THREE.Float32BufferAttribute(dashedVertices, 3));
    dashedGeometry.setAttribute('color', new THREE.Float32BufferAttribute(dashedColors, 3));
    dashedMaterial = new THREE.LineDashedMaterial({
      vertexColors: THREE.VertexColors,
      dashSize: 0.5,
      gapSize: 0.5
    });
    halfAxis = new THREE.LineSegments(dashedGeometry, dashedMaterial).computeLineDistances();
    greenAxis.add(halfAxis);
    halfAxis.name = 'blue';
    vertices = [0, 0, 0, 0, 0, size];
    colors = [0, 0, 1, 0, 0, 1];
    geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
    material = new THREE.LineBasicMaterial({
      vertexColors: THREE.VertexColors
    });
    halfAxis = new THREE.LineSegments(geometry, material);
    greenAxis.add(halfAxis);
    greenAxis.name = 'blueAxis';
    halfAxis.name = 'blue';
    this.line.add(greenAxis);
    this.line.name = "axis";
    this.addToScene(scene);
  }
};


"use strict";

function CameraCube(viewer, root) {
  this.root = root;
  this.viewer = viewer; //canvas size

  this.width = 200;
  this.height = 200;
  this.canvas = undefined;
  this.camera = undefined;
  this.cameraCtrl = undefined;
  this.scene = new THREE.Scene();
  this.renderer = undefined;
  this.animationID = undefined;
  this.controller = undefined;
  this.cameraModel = new CameraModel();
  this.cameraModel.createStandardViews(this);
  this.isCubeController = true;
  this.isDirty = undefined;
  var mouse = new THREE.Vector2();
  var lastPos = new THREE.Vector2();

  this.initialize = function () {
    //init view and camera
    this.camera = new THREE.PerspectiveCamera(45, this.width / this.height, 0.1, 1000);
    this.camera.up.set(0, 0, 1);
    this.camera.position.set(-5, -6, 5);
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));
    this.renderer = new THREE.WebGLRenderer({
      alpha: true,
      antialias: true
    }); // this.renderer.setPixelRatio(window.devicePixelRatio || 1);

    this.renderer.setSize(this.width, this.height);
    this.canvas = this.renderer.domElement;
    this.canvas.setAttribute('id', 'three-camera-controller-cube');
    this.root.appendChild(this.canvas); //init utils

    this.cameraCtrl = new CameraControls(this);
    this.cameraCtrl.setSensitivities(0.05, 1e-10, 1e-10);
    this.cameraCtrl.setEnabled(true);
    this.controller = new ViewerController(this);
    this.setDirty(true);
    this.canvas.addEventListener('pointerdown', this.onMouseDown.bind(this));
    this.canvas.addEventListener('pointermove', this.onMouseMove.bind(this));
    this.canvas.addEventListener('pointerup', this.onMouseUp.bind(this));
    var self = this;

    var animate = function animate() {
      self.cameraCtrl.update();
      self.animationID = requestAnimationFrame(animate);

      if (self.isDirty) {
        self.render();
        self.setDirty(false);
      }
    };

    this.createScene();
    animate();
  };

  this.createScene = function () {
    var size = 2;
    var texture_top = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAABz9JREFUeAHtnctLVV8Ux5dlqb00e4G9TMRMHNmDQsJeBj2ggUKINXUkSOC8v0FoEjQIGiROokn0oiYllBRpRVFIVNq7IAwr0/yx9o+jN++9y3Vvv18d1/puqHvuWWsf7/p+P3e79z4HzGlvbx8nNLcKzHJbOQoPCuRGOrS1tUWHeHWgQEdHR6gSI4ADs6USAYCkjoMYAHBgslQiAJDUcRADAA5MlkoEAJI6DmIAwIHJUokAQFLHQQwAODBZKhEASOo4iAEAByZLJQIASR0HMQDgwGSpRAAgqeMgBgAcmCyVCAAkdRzEAIADk6USAYCkjoMYAHBgslQiAJDUcRADAA5MlkoEAJI6DmIAwIHJUokAQFLHQQwAODBZKhEASOo4iAEAByZLJQIASR0HMQDgwGSpRAAgqeMgBgAcmCyVCAAkdRzEAIADk6USAYCkjoMYAHBgslQiAJDUcRADAA5MlkoEAJI6DmIAwIHJUokAQFLHQQwAODBZKhEASOo4iAEAByZLJQIASR0HMQDgwGSpRAAgqeMgBgAcmCyVCAAkdRzEAIADk6USAYCkjoOYWwCGh4fp8+fPNDY25sDm9CVO/M2g9Cl/NnLjxg168uRJ1j90xYoVdODAgaT+IyMj1NPTQ319ffTy5UsaHR2dyFm0aBFt2LCBNm/eTGvWrJk4n+qgs7OTGB6pzZ07l5YtW0bLly+n6upqmjNnjpT+V2OxA+Dt27f09OnTlKL8/PmTxsfHKScnh2bNSj14/fjxI6nvu3fv6MyZM8TX5jZv3jwqLy8nNv7Fixfh/K1bt+j27du0Z88eqq+vT7pGdILh/PLlC82ePTs6lfSaOKosWbKEDh06RJWVlUl5cTgROwAaGhqI/6VqN2/epPPnz9P27dvp4MGDqVKSzt2/f5+6urro+/fvtGPHDtqyZQstXbr0lzyOPX/+nM6dO0dXrlwJI0RTUxMVFBT8kpf45vjx45Sfn594auKYR4j3798Tj2a9vb10+vRpam1tpVWrVk3kxOUg9dcoLp/uNz8Hf1v5m8/D/eHDh2n//v1J5vOPyMvLo4qKimDS2rVr6fHjx8G0bH88jzB8nebmZtq3bx/xyMUQxrGZBuDChQtB86NHj9LGjRun1X/+/PnU0tJCq1evpmfPntGjR4+m7TNdAo86POK8efOGPn36NF36H4+bBYCH3levXoVvYlVVlVpYnrDt3bs35F+8eDHMOdSdUyTyfKWkpCREGIK4NbMA8O9ybrt3785Y8/Xr19PKlSvp9evX9ODBg4z7T+0QzSW+fv06NfTX35sEgJd8PPPnWX62s2+eLHLjJePvNv4s3HiJGrdmEoAPHz4EnafO9jMRn9fw3KJrZdI3MZd/DfFSMzc3N5YAxG4ZmChetse8BOP2OwAUFxeHa0TXCm8y/I8nkjz7530BXoHEcUPIJADRbLuwsDBDyybTi4qKwpvoWpORf494gphuM4g3injYHxwcDMk8Ca2rq5t6iVi8NwkAL+e4TbdlKzkQ9V2wYEHKtO7u7pTno5M88eO9ADaet4Pj2kwCwPvw3D5+/Ji17lHfdL9Gjh07lnYnkIf6dOBk/YH+p44AII2w0eQvgmlq2uLFi9MCMDU3zu9NrgL428fbsTyBi24AZWrCw4cPQ5doNZBp/5mSbxIAFr+2tjZ4cP369Yy9YHB4A4ghqqmpybj/TOpgFgCefPFIcO/evYz34K9duxa2gHft2mVimJeANAsAP5TB28B8J+7UqVPqDZ3Lly/TnTt3iJeQ27Ztk7QzETMLALuzdevWcP+fJ3QnTpyg/v7+tKbxLeOzZ8/S1atXwxYy30GM48ZN2gKyDJhcBURa8EZNY2MjlZaWhoc9Tp48GXYH+bEv/sf3CgYGBsLDILznz/cQysrK6MiRIzNmGRfVmu2raQAiUTZt2hTu7l26dCk8b8gjwt27d6NweOVHt/iZwJ07d4ZHzn4JGn6T097ePs71tbW1GS5zsrRv376F27xDQ0PhG79w4ULibd843qmb/NT//VFHR0e4qIsRIFE+fo5v3bp1iadcH5ueBLp2Vlk8AFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlkXAFAKZTUNAFh1VlnXxF8Mif6EiLIf0owogBHAiJHZlvEP0/OHTKpurz4AAAAASUVORK5CYII=';
    var texture_right = 'data:image/png;base64,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';
    var texture_left = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAABGZJREFUeAHtnb1KK1EUhU/MFQURRAux8yHS+VNoJYqthfgMsUjvM+QptLURfAB9BUUbC8FKtBAb0VwmkMCWYTkh15m5Wd9AMHv2yTlnrfU5ZEIgjU6n00sctg5M2SpHeN+BPwMf2u324Cl/DRzodrt9lVwBDMJWEgFAuWPQAwCDkJVEAFDuGPQAwCBkJREAlDsGPQAwCFlJBADljkEPAAxCVhIBQLlj0AMAg5CVRABQ7hj0AMAgZCURAJQ7Bj0AMAhZSQQA5Y5BDwAMQlYSAUC5Y9ADAIOQlUQAUO4Y9ADAIGQlEQCUOwY9ADAIWUkEAOWOQQ8ADEJWEgFAuWPQAwCDkJVEAFDuGPQAwCBkJREAlDsGPQAwCFlJBADljkEPAAxCVhIBQLlj0AMAg5CVRABQ7hj0AMAgZCURAJQ7Bj0AMAhZSQQA5Y5BDwAMQlYSAUC5Y9ADAIOQlUQAUO4Y9ADAIGQlEQCUOwY9ADAIWUkEAOWOQQ8ADEJWEgFAuWPQAwCDkJXE4W8GqUFl9M7OztL7+3s6OjpK09PTIy15e3ubrq+vR3pNNnhubi4dHBwMXzfYw/BEgScrKyvp6empwMj8IcvLy2l3dze/WcLZ2gBwd3eX3t7e0ufn58gAvLy8pAyCRqORpqaKX9QWFhaCxYM9NJvNcF4V2dj7+/vcIV9fX6nX68l9fXx85L62rJO1AeBfCF5bW0v7+/tjT3VycpJmZ2fHnufq6iqdn5+njY2NtLe3N/Z8vzFB8X+X31idOSt3AAAqj6DaDQBAtf5XvjoAVB5BtRsAgGr9r3x1AKg8gmo3MFG3gQ8PD+ni4qKwo1tbW7m3e5eXlz9+FpF95rCzs1N4rboOnCgAHh8fU/Yoeqyvr+cCkN2//3RkHwABwE8uldxvtVppe3u78Krz8/O5Y4+Pj9PMzExub9JOTtQVIPv0bmlpaeyMFhcXc68MY09cwwl4E1jDUMrcEgCU6XYN1wKAGoZS5pYAoEy3a7gWANQwlDK3BABlul3DtWp3G3h6epqKfiNndXU1bW5uDm29ublJr6+vw7rIk8PDw8LrFZnvfxtTOwCyEIse30F5fn5O2WOUI/vKlvPR6HQ6fQfa7bazD3bau91uXzPvAeyij4IBIPphVwGAXeRRMABEP+wqALCLPAoGgOiHXQUAdpFHwQAQ/bCrAMAu8igYAKIfdhUA2EUeBQNA9MOuAgC7yKNgAIh+2FUAYBd5FAwA0Q+7CgDsIo+CASD6YVcBgF3kUTAARD/sKgCwizwKBoDoh10FAHaRR8EAEP2wqwDALvIoGACiH3YVANhFHgUDQPTDrgIAu8ijYACIfthVAGAXeRQMANEPuwoA7CKPggEg+mFXAYBd5FEwAEQ/7CoAsIs8CgaA6IddBQB2kUfBABD9sKsAwC7yKBgAoh92FQDYRR4FA0D0w64CALvIo2AAiH7YVQBgF3kUDADRD7sKAOwij4IBIPphVw1/M2jwEyJ2DpgL5gpgDsBfeI905rJ3A+AAAAAASUVORK5CYII=';
    var texture_front = 'data:image/png;base64,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';
    var texture_back = 'data:image/png;base64,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';
    var texture_bottom = 'data:image/png;base64,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';
    var texture_shadow = 'data:image/png;base64,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';
    var back = this.createTexturedPlane(size, texture_back);
    back.position.y = size / 2;
    back.rotation.x = Math.PI / 2;
    back.rotation.y = Math.PI;
    back.name = 'back';
    this.scene.add(back);
    var top = this.createTexturedPlane(size, texture_top);
    top.position.z = size / 2;
    top.name = 'top';
    this.scene.add(top);
    var right = this.createTexturedPlane(size, texture_right);
    right.position.x = size / 2;
    right.rotation.y = Math.PI / 2;
    right.rotation.z = Math.PI / 2;
    right.name = 'right';
    this.scene.add(right);
    var left = this.createTexturedPlane(size, texture_left);
    left.position.x = -size / 2;
    left.rotation.y = -Math.PI / 2;
    left.rotation.z = -Math.PI / 2;
    left.name = 'left';
    this.scene.add(left);
    var bottom = this.createTexturedPlane(size, texture_bottom);
    bottom.position.z = -size / 2;
    bottom.rotation.y = Math.PI;
    bottom.name = 'bottom';
    this.scene.add(bottom);
    var front = this.createTexturedPlane(size, texture_front);
    front.position.y = -size / 2;
    front.rotation.x = Math.PI / 2;
    front.name = 'front';
    this.scene.add(front);
    var shadow = this.createTexturedPlane(size + 1.5, texture_shadow, false);
    shadow.position.z = -size / 2 - 0.4;
    shadow.name = 'shadow';
    this.scene.add(shadow);
    this.setDirty(true);
  };

  this.createTexturedPlane = function (size, texturePath) {
    var side = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : THREE.DoubleSide;
    var self = this;
    var texture = new THREE.TextureLoader().load(texturePath, function () {
      return self.setDirty(true);
    });
    var material = new THREE.MeshBasicMaterial({
      map: texture,
      transparent: false,
      visible: true,
      side: side
    });
    var geometry = new THREE.PlaneGeometry(size, size);
    return new THREE.Mesh(geometry, material);
  };

  this.setCameraView = function (type) {
    this.cameraModel.setCameraView(type);
  };
  /**
   * Renders the view. Must be invoked, if something has changed (e.g. camera position, colors, geometry, ...).
   * Normally, this method will be invoked by the methods that changes something in the view or the model.
   */


  this.render = function () {
    this.scene.updateMatrixWorld();
    this.renderer.render(this.scene, this.camera);
  };

  this.setDirty = function (value) {
    this.isDirty = value;
  };

  this.setVisible = function (visible) {
    if (this.canvas !== undefined) {
      this.canvas.style.visibility = visible ? 'visible' : 'hidden';
    }
  };

  this.destroy = function () {
    var empty = function empty(elem) {
      while (elem.lastChild) {
        elem.removeChild(elem.lastChild);
      }
    };

    cancelAnimationFrame(this.animationID);
    this.scene = null;
    this.camera = null;
    this.cameraCtrl = null;
    this.renderer.forceContextLoss();
    this.renderer.context = null;
    this.renderer.domElement = null;
    this.renderer = null;
    empty(this.root);
  };

  this.updateCameraRotation = function (angleX, angleY) {
    this.viewer.rotateCamera(angleX, angleY);
  };

  this.rotateCamera = function (angleX, angleY) {
    this.cameraCtrl.rotateCameraByAngle(angleX, angleY);
    this.setDirty(true);
  };

  this.onMouseDown = function (e) {
    lastPos = mouse.clone();
  };

  this.onMouseMove = function (e) {
    var rect = this.canvas.getBoundingClientRect();
    mouse.x = (e.clientX - rect.left) / rect.width * 2 - 1;
    mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
  };

  this.onMouseUp = function (e) {
    var pos = mouse.clone();
    var diff = lastPos.sub(pos).length();

    if (diff < 0.1) {
      var raycaster = new THREE.Raycaster();
      raycaster.setFromCamera(mouse, this.camera);
      var intersects = raycaster.intersectObject(this.scene, true);

      if (intersects.length > 0) {
        for (var i = 0; i < intersects.length; i++) {
          var object = intersects[i].object;

          if (object.name && object.name !== '') {
            this.viewer.setCameraViews(object.name);
            break;
          }
        }
      }
    }

    lastPos = pos.clone();
  };
}


"use strict";

function Grid() {
  this.lines = undefined;
}

Grid.prototype = {
  addToScene: function addToScene(scene) {
    if (this.lines) {
      this.lines.userData.unSnapable = true;
      scene.add(this.lines);
    }
  },
  removeFromScene: function removeFromScene(scene) {
    if (this.lines) {
      scene.remove(this.lines);
    }
  },
  update: function update(scene, quality, xStart, yStart, xEnd, yEnd, majorTick) {
    this.removeFromScene(scene);
    xStart = xStart ? xStart : -100;
    yStart = yStart ? yStart : -100;
    xEnd = xEnd ? xEnd : 100;
    yEnd = yEnd ? yEnd : 100;
    majorTick = majorTick ? majorTick : 20;
    var geometry = new THREE.Geometry();
    var gray = new THREE.Color(0x000);
    var TOL = 1e-5;

    for (var x = xStart; x < xEnd + TOL; x += majorTick) {
      geometry.vertices.push(new THREE.Vector3(x, yStart, -0.1));
      geometry.vertices.push(new THREE.Vector3(x, yEnd, -0.1));
      geometry.colors.push(gray);
      geometry.colors.push(gray);
    }

    for (var y = yStart; y <= yEnd + TOL; y += majorTick) {
      geometry.vertices.push(new THREE.Vector3(xStart, y, -0.1));
      geometry.vertices.push(new THREE.Vector3(xEnd, y, -0.1));
      geometry.colors.push(gray);
      geometry.colors.push(gray);
    }

    var material = new THREE.LineBasicMaterial({
      vertexColors: THREE.VertexColors,
      opacity: .3,
      linewidth: .1
    });
    this.lines = new THREE.LineSegments(geometry, material);
    this.lines.name = "grid";
    this.addToScene(scene);
  }
};


"use strict";

function Ground(viewer) {
  var self = this;
  this.ground = undefined;
  this.groundTexture = undefined;
  this.cubeTexture = undefined;
  this.scene = undefined;

  this.setImage = function (space, ground) {
    loadTextures(space, ground);

    if (this.ground) {
      var size = new THREE.Vector3();
      if (!self.ground.geometry.boundingBox) self.ground.geometry.computeBoundingBox();
      size = self.ground.geometry.boundingBox.getSize(size);
      this.groundTexture.repeat.set(Math.max(1, Math.floor(size.x * 0.1)), Math.max(1, Math.floor(size.y * 0.1)));
      var material = this.ground.material;
      material.map = this.groundTexture;
      material.needsUpdate = true;
      viewer.setDirty(true);
    }

    if (this.scene) {
      this.scene.background = self.cubeTexture;
    }
  };

  this.addToScene = function (scene) {
    scene.background = self.cubeTexture;

    if (this.ground) {
      this.ground.userData.unSnapable = true;
      scene.add(this.ground);
    }
  };

  this.removeFromScene = function (scene) {
    scene.background = undefined;

    if (this.ground) {
      scene.remove(this.ground);
      this.ground = null;
    }
  };

  this.update = function (scene, quality, xStart, yStart, xEnd, yEnd, zValue) {
    this.scene = scene;
    this.removeFromScene(scene);
    xStart = xStart ? xStart : -100;
    yStart = yStart ? yStart : -100;
    xEnd = xEnd ? xEnd : 100;
    yEnd = yEnd ? yEnd : 100;
    var width = Math.abs(xEnd - xStart);
    var height = Math.abs(yEnd - yStart);
    var radius = Math.max(width, height) * 4;
    this.groundTexture.repeat.set(Math.max(1, Math.floor(width)), Math.max(1, Math.floor(height)));
    var groundGeo = new THREE.PlaneGeometry(width * 50, height * 50);
    this.ground = new THREE.Mesh(groundGeo, createGroundMaterial(quality));
    this.ground.name = "Ground"; //this.ground.receiveShadow = (quality === 'high');

    this.ground.position.set(xStart + width / 2, yStart + height / 2, zValue);
    this.addToScene(scene);
  };

  this.setQuality = function (quality) {
    if (this.ground) {
      var newMat = createGroundMaterial(quality);
      newMat.map = this.ground.material.map;
      this.ground.material = newMat; // this.ground.receiveShadow = (quality === 'high');
    }
  };

  function createGroundMaterial(quality) {
    if (quality === 'high') {
      return new THREE.MeshStandardMaterial({
        map: self.groundTexture,
        side: THREE.DoubleSide,
        roughness: 0.65,
        metalness: 0.75
      });
    } else {
      return new THREE.MeshBasicMaterial({
        map: self.groundTexture,
        side: THREE.DoubleSide
      });
    }
  }

  function loadTextures(space, ground) {
    var textureLoader = new THREE.TextureLoader();
    var cubeTextureLoader = new THREE.CubeTextureLoader();
    var arr = space.split("/");
    var finalspace = space.replace(arr[arr.length - 1], "");
    var urls = [finalspace + "left.jpg", finalspace + "right.jpg", finalspace + "front.jpg", finalspace + "back.jpg", finalspace + "top.jpg", finalspace + "bottom.jpg"];
    self.cubeTexture = cubeTextureLoader.load(urls, function () {
      self.cubeTexture.needsUpdate = true;
      viewer.setDirty(true);
    });
    self.cubeTexture.mapping = THREE.CubeReflectionMapping;
    self.groundTexture = textureLoader.load(ground, function () {
      self.groundTexture.needsUpdate = true;
      viewer.setDirty(true);
    });
    self.groundTexture.wrapS = self.groundTexture.wrapT = THREE.RepeatWrapping;
  }

  loadTextures('/assets/images/cgviewer/bim/environment/space-01/back.jpg', '/assets/images/cgviewer/bim/environment/ground-01.jpg');
}


"use strict";

function Origin() {
  this.xArrow = undefined;
  this.yArrow = undefined;
  this.zArrow = undefined;
}

Origin.prototype = {
  addToScene: function addToScene(scene) {
    if (this.xArrow) {
      scene.add(this.xArrow);
      scene.add(this.yArrow);
      scene.add(this.zArrow);
    }
  },
  removeFromScene: function removeFromScene(scene) {
    if (this.xArrow) {
      scene.remove(this.xArrow);
      scene.remove(this.yArrow);
      scene.remove(this.zArrow);
    }
  },
  update: function update(scene, quality, l1, l2, r1, r2) {
    this.removeFromScene(scene); //settings

    l1 = l1 ? l1 : 9;
    l2 = l2 ? l2 : 2;
    r1 = r1 ? r1 : 0.2;
    r2 = r2 ? r2 : 1; //xArrow

    var xCylinder = new THREE.CylinderGeometry(r1, r1, l1);
    xCylinder.applyMatrix4(new THREE.Matrix4().makeTranslation(0, l1 / 2, 0));
    xCylinder.applyMatrix4(new THREE.Matrix4().makeRotationZ(-Math.PI / 2));
    var xCone = new THREE.CylinderGeometry(0, r2, l2);
    xCone.applyMatrix4(new THREE.Matrix4().makeTranslation(0, l1 + l2 / 2, 0));
    xCone.applyMatrix4(new THREE.Matrix4().makeRotationZ(-Math.PI / 2));
    xCylinder.merge(xCone);
    this.xArrow = new THREE.Mesh(xCylinder, new THREE.MeshBasicMaterial({
      color: 0xff0000
    }));
    this.xArrow.position.set(50, 50, 0); //yArrow

    var yCylinder = new THREE.CylinderGeometry(r1, r1, l1);
    yCylinder.applyMatrix4(new THREE.Matrix4().makeTranslation(0, l1 / 2, 0));
    var yCone = new THREE.CylinderGeometry(0, r2, l2);
    yCone.applyMatrix4(new THREE.Matrix4().makeTranslation(0, l1 + l2 / 2, 0));
    yCylinder.merge(yCone);
    this.yArrow = new THREE.Mesh(yCylinder, new THREE.MeshBasicMaterial({
      color: 0x00ff00
    }));
    this.yArrow.position.set(50, 50, 0); //zArrow

    var zCylinder = new THREE.CylinderGeometry(r1, r1, l1);
    zCylinder.applyMatrix4(new THREE.Matrix4().makeTranslation(0, l1 / 2, 0));
    zCylinder.applyMatrix4(new THREE.Matrix4().makeRotationX(Math.PI / 2));
    var zCone = new THREE.CylinderGeometry(0, r2, l2);
    zCone.applyMatrix4(new THREE.Matrix4().makeTranslation(0, l1 + l2 / 2, 0));
    zCone.applyMatrix4(new THREE.Matrix4().makeRotationX(Math.PI / 2));
    zCylinder.merge(zCone);
    this.zArrow = new THREE.Mesh(zCylinder, new THREE.MeshBasicMaterial({
      color: 0x0000ff
    }));
    this.zArrow.position.set(50, 50, 0);
    this.addToScene(scene);
  }
};


"use strict";

function CameraControls(viewer) {
  // self reference for anonymous functions
  var self = this;
  var camera = viewer.camera;
  var canvas = viewer.canvas; // rotation point

  this.rotationPoint = new THREE.Vector3(0.0, 0.0, 0.0); // control mode

  this.controlMode = 'default'; // mouse right button mode

  this.rightButtonMode = false;
  var isPaused = false; // mouse button controls (0=LEFT, 1=MIDDLE, 2=RIGHT)

  var NONE = -1,
      ROTATE = 0,
      ZOOM = 1,
      PAN = 2; // current mouse button pressed state

  var state = NONE; // mouse positions [px]

  var xStart = 0,
      yStart = 0,
      xEnd = 0,
      yEnd = 0; // keyboard actions

  var moveForward = false,
      moveBackward = false,
      moveLeft = false,
      moveRight = false,
      moveUp = false,
      moveDown = false;
  var rotateLeft = false,
      rotateRight = false,
      rotateUp = false,
      rotateDown = false; // control pad actions

  var moveDirection = undefined; // change flag

  var isMouseDown = false;
  var isDirty = false;
  var isTouchRunning = false; // mouse sensitivities

  var rotateSpeed = 0.01,
      zoomSpeed = 0.05,
      panSpeed = 0.15; // keyboard sensitivities

  var keyboardValue = viewer.isGPUMode ? 0.25 : 2;
  var keyboardMoveSpeed = 0.15,
      keyboardRotateSpeed = 0.01;
  var KeyboardMultiplyFactor = 1.1; // EXTERNAL methods

  var dragAction = 'orbit';
  var minDistance = 1;
  var maxDistance = 500;

  this.setDragAction = function (type) {
    dragAction = type;
  };
  /**
   * Set Camera Control mode
   * @param {String} mode - default or walk mode
   */


  this.setMode = function (mode) {
    if (this.controlMode === mode) return;
    this.setEnabled(false);
    this.controlMode = mode;
    this.setEnabled(true);
  };
  /**
   * Updates the 3D view.
   */


  this.update = function () {
    if (isPaused) return;
    var needUpdate = false;

    if (moveDirection !== undefined) {
      adjustCameraByDirection();
      keyboardValue *= KeyboardMultiplyFactor;
      needUpdate = true;
    }

    if (isKeyPressed()) {
      adjustCamera();
      keyboardValue *= KeyboardMultiplyFactor;
      needUpdate = true;
    }

    if (isDirty) {
      if (state === ROTATE) {
        rotateCamera();
      } else if (state === ZOOM) {
        zoomCamera();
      } else if (state === PAN) {
        panCamera();
      }

      xStart = xEnd;
      yStart = yEnd;
      isDirty = false;
      needUpdate = true;
    }

    if (needUpdate) {
      camera.updateMatrixWorld();
      viewer.setDirty(true);

      if (viewer.signaler) {
        viewer.signaler.cameraControlChanged.dispatch(camera);
      }
    }
  };
  /**
   * Sets the sensitivities for rotating, zooming and panning the model.
   * @param {Number} _rotateSpeed - the rotate speed to be set (default: 0.01).
   * @param {Number} _zoomSpeed - the zoom speed to be set (default: 0.09).
   * @param {Number} _panSpeed - the pan speed to be set (default: 0.09).
   */


  this.setSensitivities = function (_rotateSpeed, _zoomSpeed, _panSpeed) {
    rotateSpeed = _rotateSpeed ? _rotateSpeed : 0.01;
    zoomSpeed = _zoomSpeed ? _zoomSpeed : 0.01;
    panSpeed = _panSpeed ? _panSpeed : 0.09;
    keyboardMoveSpeed = panSpeed;
    keyboardRotateSpeed = rotateSpeed;
    if (Bim.DEBUG) console.log("rotateSpeed: " + rotateSpeed);
    if (Bim.DEBUG) console.log("zoomSpeed: " + zoomSpeed);
    if (Bim.DEBUG) console.log("panSpeed: " + panSpeed);
  };
  /**
   * @param min {Number} minimum distance
   * @param max {Number} maximum distance
   */


  this.setRange = function (min, max) {
    minDistance = min;
    maxDistance = max;
  };

  this.setEnabled = function (isEnabled) {
    if (isEnabled) {
      //register mouse events
      canvas.addEventListener('contextmenu', contextmenu, false);
      canvas.addEventListener('pointerdown', mousedown, false);
      canvas.addEventListener('pointerup', mouseup, false);
      canvas.addEventListener('pointerleave', mouseout, false);
      canvas.addEventListener('pointermove', mousemove, false);
      canvas.addEventListener('mousewheel', mousewheel, false);
      canvas.addEventListener('DOMMouseScroll', mousewheel, false); // firefox
      //register touch events

      canvas.addEventListener('touchstart', touchstart, false);
      canvas.addEventListener('touchend', touchend, false);
      canvas.addEventListener('touchmove', touchmove, false);

      if (this.controlMode === 'walk') {
        //register keyboard events
        window.addEventListener('keydown', keydown, false);
        window.addEventListener('keyup', keyup, false);
      }
    } else {
      //unregister mouse events
      canvas.removeEventListener('contextmenu', contextmenu, false);
      canvas.removeEventListener('pointerdown', mousedown, false);
      canvas.removeEventListener('pointerup', mouseup, false);
      canvas.removeEventListener('pointerleave', mouseout, false);
      canvas.removeEventListener('pointermove', mousemove, false);
      canvas.removeEventListener('mousewheel', mousewheel, false);
      canvas.removeEventListener('DOMMouseScroll', mousewheel, false); // firefox
      //unregister touch events

      canvas.removeEventListener('touchstart', touchstart, false);
      canvas.removeEventListener('touchend', touchend, false);
      canvas.removeEventListener('touchmove', touchmove, false);

      if (this.controlMode === 'walk') {
        //unregister keyboard events
        window.removeEventListener('keydown', keydown, false);
        window.removeEventListener('keyup', keyup, false);
      }

      state = NONE;
      isMouseDown = false;
    }
  };

  this.setRightButtonMode = function (isEnabled) {
    this.rightButtonMode = isEnabled;
  };

  this.pause = function () {
    isPaused = true;
  };

  this.resume = function () {
    isPaused = false;
  };

  this.rotateCameraByAngle = function (angleX, angleY) {
    var cameraLookVector = new THREE.Vector3(0, 0, -1);
    cameraLookVector.applyEuler(camera.rotation, camera.rotation.order);
    var cameraUpVector = camera.up.clone().normalize();
    var cameraSideVector = new THREE.Vector3().crossVectors(cameraLookVector, cameraUpVector).normalize();
    var cameraPosition = camera.position.clone();
    cameraPosition.sub(self.rotationPoint);
    var quat1 = new THREE.Quaternion(); //Rotation around local Y-Axis

    var axis1 = cameraSideVector.clone();
    quat1.setFromAxisAngle(axis1, -angleY);
    cameraPosition.applyQuaternion(quat1);
    cameraUpVector.applyQuaternion(quat1);
    cameraLookVector.applyQuaternion(quat1);
    quat1 = new THREE.Quaternion(); //Rotation around screen X-Axis (parallel to Canvas)

    axis1 = new THREE.Vector3(0, 0, 1);
    quat1.setFromAxisAngle(axis1, -angleX);
    cameraPosition.applyQuaternion(quat1);
    cameraUpVector.applyQuaternion(quat1); // move back

    cameraPosition.add(self.rotationPoint);
    camera.position.set(cameraPosition.x, cameraPosition.y, cameraPosition.z);
    cameraLookVector.applyQuaternion(quat1);
    var lookAt = new THREE.Vector3();
    lookAt.addVectors(cameraPosition, cameraLookVector);
    camera.up = cameraUpVector;
    camera.lookAt(lookAt);
  };

  this.goDirection = function (dir) {
    moveDirection = dir;

    if (dir === undefined) {
      clearKeyboardValue();
    }
  }; // INTERNAL methods


  function rotateCamera() {
    var angleX = (xEnd - xStart) * rotateSpeed;
    var angleY = (yEnd - yStart) * rotateSpeed;
    self.rotateCameraByAngle(angleX, angleY);

    if (viewer.updateCameraRotation) {
      viewer.updateCameraRotation(angleX, angleY);
    }
  }

  function zoomCamera() {
    var dy = (yEnd - yStart) * zoomSpeed;
    var cameraLookVector = new THREE.Vector3(0, 0, -1);
    cameraLookVector.applyEuler(camera.rotation, camera.rotation.order);
    cameraLookVector.normalize();
    var cameraPosition = camera.position.clone();
    cameraPosition.add(cameraLookVector.setLength(dy));
    setCameraPosition(cameraPosition);
  }

  function panCamera() {
    var cameraLookVector = new THREE.Vector3(0, 0, -1);
    cameraLookVector.applyEuler(camera.rotation, camera.rotation.order);
    var cameraUpVector = camera.up.clone().normalize();
    var cameraSideVector = new THREE.Vector3().crossVectors(cameraLookVector, cameraUpVector).normalize();
    var cameraPosition = camera.position.clone();
    var dx = (xStart - xEnd) * panSpeed;
    var dy = (yEnd - yStart) * panSpeed;
    cameraPosition.add(cameraSideVector.setLength(dx));
    cameraPosition.add(cameraUpVector.setLength(dy));
    setCameraPosition(cameraPosition);
  }

  function isKeyPressed() {
    return moveForward || moveBackward || moveLeft || moveRight || moveUp || moveDown || rotateLeft || rotateRight || rotateUp || rotateDown;
  }

  function adjustCamera() {
    if (moveForward || moveBackward) {
      var cameraLookVector = new THREE.Vector3(0, 0, -1);
      cameraLookVector.applyEuler(camera.rotation, camera.rotation.order);
      cameraLookVector.setZ(0);
      cameraLookVector.normalize();
      var cameraPosition = camera.position.clone();
      var dx = keyboardValue * keyboardMoveSpeed;
      if (moveBackward) dx *= -1;
      cameraPosition.add(cameraLookVector.setLength(dx));
      setCameraPosition(cameraPosition);
    }

    if (moveLeft || moveRight) {
      var _cameraLookVector = new THREE.Vector3(0, 0, -1);

      _cameraLookVector.applyEuler(camera.rotation, camera.rotation.order);

      _cameraLookVector.normalize();

      var cameraUpVector = camera.up.clone().normalize();
      var cameraSideVector = new THREE.Vector3().crossVectors(_cameraLookVector, cameraUpVector).normalize();

      var _cameraPosition = camera.position.clone();

      var dy = keyboardValue * keyboardMoveSpeed;
      if (moveLeft) dy *= -1;

      _cameraPosition.add(cameraSideVector.setLength(dy));

      setCameraPosition(_cameraPosition);
    }

    if (moveUp || moveDown) {
      var upVector = new THREE.Vector3(0, 0, 1);

      var _cameraPosition2 = camera.position.clone();

      var dz = keyboardValue * keyboardMoveSpeed;
      if (moveDown) dz *= -1;

      _cameraPosition2.add(upVector.setLength(dz));

      setCameraPosition(_cameraPosition2);
    }

    if (rotateLeft || rotateRight) {
      var angle = keyboardValue * keyboardRotateSpeed;
      if (rotateRight) angle *= -1;
      var axis1 = new THREE.Vector3(0, 0, 1);
      var quat1 = new THREE.Quaternion();
      quat1.setFromAxisAngle(axis1, angle);

      var _cameraLookVector2 = new THREE.Vector3(0, 0, -1);

      _cameraLookVector2.applyEuler(camera.rotation, camera.rotation.order);

      _cameraLookVector2.normalize();

      var _cameraUpVector = camera.up.clone().normalize();

      var _cameraPosition3 = camera.position.clone();

      _cameraUpVector.applyQuaternion(quat1);

      _cameraLookVector2.applyQuaternion(quat1);

      var lookAt = new THREE.Vector3();
      lookAt.addVectors(_cameraPosition3, _cameraLookVector2);
      camera.up = _cameraUpVector;
      camera.lookAt(lookAt);
    }

    if (rotateUp || rotateDown) {
      var _angle = keyboardValue * keyboardRotateSpeed;

      if (rotateDown) _angle *= -1;

      var _cameraLookVector3 = new THREE.Vector3(0, 0, -1);

      _cameraLookVector3.applyEuler(camera.rotation, camera.rotation.order);

      _cameraLookVector3.normalize();

      var _cameraUpVector2 = camera.up.clone().normalize();

      var _cameraSideVector = new THREE.Vector3().crossVectors(_cameraLookVector3, _cameraUpVector2).normalize();

      var _cameraPosition4 = camera.position.clone();

      var _quat = new THREE.Quaternion();

      _quat.setFromAxisAngle(_cameraSideVector, _angle);

      _cameraUpVector2.applyQuaternion(_quat);

      _cameraLookVector3.applyQuaternion(_quat);

      var _lookAt = new THREE.Vector3();

      _lookAt.addVectors(_cameraPosition4, _cameraLookVector3);

      camera.up = _cameraUpVector2;
      camera.lookAt(_lookAt);
    }
  }

  function adjustCameraByDirection() {
    var cameraLookVector = new THREE.Vector3(moveDirection.x, moveDirection.y, -1);
    cameraLookVector.applyEuler(camera.rotation, camera.rotation.order);
    cameraLookVector.setZ(0);
    cameraLookVector.normalize();
    var cameraPosition = camera.position.clone();
    var dx = keyboardValue * keyboardMoveSpeed;
    cameraPosition.add(cameraLookVector.setLength(dx));
    setCameraPosition(cameraPosition);
  }

  function preventDefault(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function mousedown(event) {
    if (isPaused) return;
    preventDefault(event);
    xStart = xEnd = event.clientX;
    yStart = yEnd = event.clientY;
    isDirty = false;
    isMouseDown = true;

    if (event.button === 0 && event.shiftKey) {
      state = ZOOM;
      return;
    }

    if (event.button === 1) {
      console.log("wheel button clicked");
      state = PAN;
    } else {
      if (self.rightButtonMode && event.which !== 3) {
        isMouseDown = false;
      } else {
        state = dragAction === 'pan' ? PAN : ROTATE;
      }
    }
  }

  function mousemove(event) {
    if (isPaused) {
      isMouseDown = false;
      return;
    }

    if (isMouseDown) {
      preventDefault(event);
      isDirty = true;
      xEnd = event.clientX;
      yEnd = event.clientY;
      canvas.setPointerCapture(event.pointerId);
    }
  }

  function mouseout(event) {
    if (isMouseDown) {
      preventDefault(event);
      isMouseDown = false;
    }
  }

  function mouseup(event) {
    if (isPaused) {
      isMouseDown = false;
      return;
    }

    if (isMouseDown) {
      preventDefault(event);
      isDirty = true;
      isMouseDown = false;
      xEnd = event.clientX;
      yEnd = event.clientY;
      canvas.releasePointerCapture(event.pointerId);
    }
  }

  function mousewheel(event) {
    preventDefault(event);
    isDirty = true;
    state = ZOOM;
    var delta = 0; // WebKit / Opera / Explorer 9

    if (event.wheelDelta) {
      delta = -event.wheelDelta;
    } // Firefox
    else if (event.detail) {
      delta = -event.detail;
    }

    yStart = delta;
    yEnd = 0;
  }

  function contextmenu(event) {
    preventDefault(event);
  }

  function touchstart(event) {
    //    preventDefault(event);
    //don't start new touch event as long one finger remains on display
    if (isTouchRunning) return; //one finger touch: rotate

    if (event.touches.length === 1) {
      state = dragAction === 'pan' ? PAN : ROTATE;
      xStart = xEnd = event.touches[0].pageX;
      yStart = yEnd = event.touches[0].pageY;
    } //two finger touch: zoom
    else if (event.touches.length === 2) {
      state = ZOOM;
      var dx = event.touches[0].pageX - event.touches[1].pageX;
      var dy = event.touches[0].pageY - event.touches[1].pageY;
      var distance = Math.sqrt(dx * dx + dy * dy);
      xStart = xEnd = 0;
      yStart = yEnd = -distance;
    } else {
      state = NONE;
    }

    isDirty = false;
  }

  function touchmove(event) {
    preventDefault(event); //don't process new touch event as long one finger remains on display

    if (isTouchRunning) return; //one finger touch: rotate

    if (event.touches.length === 1) {
      xEnd = event.touches[0].pageX;
      yEnd = event.touches[0].pageY;
    } //two finger touch: zoom
    else if (event.touches.length === 2) {
      var dx = event.touches[0].pageX - event.touches[1].pageX;
      var dy = event.touches[0].pageY - event.touches[1].pageY;
      var distance = Math.sqrt(dx * dx + dy * dy);
      xEnd = 0;
      yEnd = -distance;
    } //three finger touch: pan
    else if (event.touches.length === 3) {
      xEnd = event.touches[0].pageX;
      yEnd = event.touches[0].pageY;
    }

    isDirty = true;
  }

  function touchend(event) {
    preventDefault(event);
    isTouchRunning = event.touches.length > 0;
  }

  function keydown(event) {
    switch (event.keyCode) {
      //MOVE FORWARD
      case 87:
      /*W*/

      case 38:
      /*arrow-up*/

      case 104:
        /*Num 8*/
        moveForward = true;
        break;
      //MOVE BACKWARD

      case 83:
      /*S*/

      case 40:
      /*arrow-down*/

      case 98:
        /*Num 2*/
        moveBackward = true;
        break;
      //MOVE LEFT

      case 81:
      /*Q*/

      case 103:
        /*Num 7*/
        moveLeft = true;
        break;
      //MOVE RIGHT

      case 69:
      /*E*/

      case 105:
        /*Num 9*/
        moveRight = true;
        break;
      //MOVE UP

      case 82:
      /*R*/

      case 33:
      /*page-up*/

      case 107:
        /*Num +*/
        moveUp = true;
        break;
      //MOVE DOWN

      case 70:
      /*F*/

      case 34:
      /*page-down*/

      case 109:
        /*Num -*/
        moveDown = true;
        break;
      //ROTATE LEFT

      case 65:
      /*A*/

      case 37:
      /*arrow-left*/

      case 100:
        /*Num 4*/
        rotateLeft = true;
        break;
      //ROTATE RIGHT

      case 68:
      /*D*/

      case 39:
      /*arrow-right*/

      case 102:
        /*Num 6*/
        rotateRight = true;
        break;
      //ROTATE UP

      case 84:
      /*T*/

      case 97:
        /*Num 1*/
        rotateUp = true;
        break;
      //ROTATE DOWN

      case 71:
      /*G*/

      case 99:
        /*Num 3*/
        rotateDown = true;
        break;

      default:
        break;
    }
  }

  function keyup(event) {
    switch (event.keyCode) {
      //MOVE FORWARD
      case 87:
      /*W*/

      case 38:
      /*arrow-up*/

      case 104:
        /*Num 8*/
        moveForward = false;
        break;
      //MOVE BACKWARD

      case 83:
      /*S*/

      case 40:
      /*arrow-down*/

      case 98:
        /*Num 2*/
        moveBackward = false;
        break;
      //MOVE LEFT

      case 81:
      /*Q*/

      case 103:
        /*Num 7*/
        moveLeft = false;
        break;
      //MOVE RIGHT

      case 69:
      /*E*/

      case 105:
        /*Num 9*/
        moveRight = false;
        break;
      //MOVE UP

      case 82:
      /*R*/

      case 33:
      /*page-up*/

      case 107:
        /*Num +*/
        moveUp = false;
        break;
      //MOVE DOWN

      case 70:
      /*F*/

      case 34:
      /*page-down*/

      case 109:
        /*Num -*/
        moveDown = false;
        break;
      //ROTATE LEFT

      case 65:
      /*A*/

      case 37:
      /*arrow-left*/

      case 100:
        /*Num 4*/
        rotateLeft = false;
        break;
      //ROTATE RIGHT

      case 68:
      /*D*/

      case 39:
      /*arrow-right*/

      case 102:
        /*Num 6*/
        rotateRight = false;
        break;
      //ROTATE UP

      case 84:
      /*T*/

      case 97:
        /*Num 1*/
        rotateUp = false;
        break;
      //ROTATE DOWN

      case 71:
      /*G*/

      case 99:
        /*Num 3*/
        rotateDown = false;
        break;

      default:
        break;
    }

    clearKeyboardValue();
  }

  function setCameraPosition(position) {
    camera.position.set(position.x, position.y, position.z);
    camera.updateProjectionMatrix();
  }

  function clearKeyboardValue() {
    keyboardValue = viewer.isGPUMode ? 0.25 : 2;
  }
}


"use strict";

// CameraView
function CameraView(viewer, name, cameraDirection, cameraUpVector) {
  this.viewer = viewer;
  this.name = name;

  if (cameraDirection === undefined || cameraUpVector === undefined) {
    this.fromCurrentView();
  } else {
    this.cameraDirection = cameraDirection;
    this.cameraUpVector = cameraUpVector;
  }
}

CameraView.prototype = {
  applyView: function applyView(isAnimated) {
    var camera = this.viewer.camera;

    if (isAnimated) {
      //compute new position for fit in
      var bbox = this.viewer.controller.getSceneBoundingBox();
      var fitInVectors = this.viewer.controller.computeFitInBoxAndDir(bbox, this.cameraDirection.clone());
      var newPos = fitInVectors[0]; //start animation

      if (this.viewer.isCubeController) {
        newPos.multiplyScalar(0.03); //set default 50 in ViewController:setViewFromTopBBox
      }

      CameraUtils.flyTo(this.viewer, newPos, this.cameraUpVector, this.cameraDirection);
    } else {
      var lookAt = new THREE.Vector3();
      lookAt.addVectors(camera.position, this.cameraDirection);
      camera.up = this.cameraUpVector;
      camera.lookAt(lookAt);

      var _bbox = this.viewer.controller.getSceneBoundingBox();

      var _fitInVectors = this.viewer.controller.computeFitInBox(_bbox);

      var _newPos = _fitInVectors[0];
      camera.position.set(_newPos.x, _newPos.y, _newPos.z);
      this.viewer.setDirty(true);
    }
  },
  fromCurrentView: function fromCurrentView() {
    var camera = this.viewer.camera;
    this.cameraDirection = new THREE.Vector3(0, 0, -1);
    this.cameraDirection.applyEuler(camera.rotation, camera.rotation.order);
    this.cameraUpVector = camera.up.clone().normalize();
  }
}; // CameraModel

function CameraModel() {
  this.listeners = [];
  this.cameraViews = [];
  this.annotations = [];
  this.comments = [];
  this.isCameraAnimationEnabled = true;
}

CameraModel.prototype = {
  createStandardViews: function createStandardViews(viewer) {
    this.addCameraView(new CameraView(viewer, "FRONT", new THREE.Vector3(0, 1, 0), new THREE.Vector3(0, 0, 1)));
    this.addCameraView(new CameraView(viewer, "BACK", new THREE.Vector3(0, -1, 0), new THREE.Vector3(0, 0, 1)));
    this.addCameraView(new CameraView(viewer, "LEFT", new THREE.Vector3(1, 0, 0), new THREE.Vector3(0, 0, 1)));
    this.addCameraView(new CameraView(viewer, "RIGHT", new THREE.Vector3(-1, 0, 0), new THREE.Vector3(0, 0, 1)));
    this.addCameraView(new CameraView(viewer, "TOP", new THREE.Vector3(0, 0, -1), new THREE.Vector3(0, 1, 0)));
    this.addCameraView(new CameraView(viewer, "BOTTOM", new THREE.Vector3(0, 0, 1), new THREE.Vector3(0, 1, 0)));
    this.addCameraView(new CameraView(viewer, "REAR", new THREE.Vector3(0, -1, 0), new THREE.Vector3(0, 0, 1)));
  },
  setCameraView: function setCameraView(type) {
    switch (type) {
      case "top":
        this.applyCameraView(this.cameraViews[4]);
        break;

      case "bottom":
        this.applyCameraView(this.cameraViews[5]);
        break;

      case "front":
        this.applyCameraView(this.cameraViews[0]);
        break;

      case "back":
        this.applyCameraView(this.cameraViews[1]);
        break;

      case "left":
        this.applyCameraView(this.cameraViews[2]);
        break;

      case "right":
        this.applyCameraView(this.cameraViews[3]);
        break;
    }
  },
  addCameraView: function addCameraView(cameraView) {
    this.cameraViews.push(cameraView);
  },
  applyCameraView: function applyCameraView(cameraView) {
    cameraView.applyView(this.isCameraAnimationEnabled);
  }
};


"use strict";

var CameraUtils = {
  /**
   * animation camera
   * @param viewer {BimViewer}
   * @param cameraPosition {THREE.Vector3}
   * @param cameraUpVector {THREE.Vector3}
   * @param cameraDirection {THREE.Vector3}
   */
  flyTo: function flyTo(viewer, cameraPosition, cameraUpVector, cameraDirection) {
    if (!cameraPosition) {
      cameraPosition = viewer.camera.position.clone();
    }

    if (!cameraUpVector) {
      cameraUpVector = viewer.camera.up.clone();
    }

    if (!cameraDirection) {
      cameraDirection = new THREE.Vector3(0, 0, -1);
      cameraDirection.applyEuler(viewer.camera.rotation, viewer.camera.rotation.order);
    }

    cameraUpVector.normalize();
    cameraDirection.normalize(); //current camera values

    var currentPos = viewer.camera.position.clone();
    var currentUp = viewer.camera.up.clone().normalize();
    var currentDir = new THREE.Vector3(0, 0, -1);
    currentDir.applyEuler(viewer.camera.rotation, viewer.camera.rotation.order);
    currentDir.normalize(); //animation properties

    var duration = 500;
    var steps = 10;
    var delay = duration / steps; //delta position

    var deltaPos = new THREE.Vector3();
    deltaPos.subVectors(cameraPosition, currentPos);
    deltaPos.divideScalar(steps); //delta up vector

    var deltaUp = new THREE.Vector3();
    deltaUp.subVectors(cameraUpVector, currentUp);
    deltaUp.divideScalar(steps); //delta position

    var deltaDir = new THREE.Vector3();
    deltaDir.subVectors(cameraDirection, currentDir);
    deltaDir.divideScalar(steps); //animation function

    var doAnimation = function doAnimation() {
      currentPos.add(deltaPos);
      currentUp.add(deltaUp);
      currentDir.add(deltaDir);
      viewer.camera.position.set(currentPos.x, currentPos.y, currentPos.z);
      viewer.camera.up.set(currentUp.x, currentUp.y, currentUp.z);
      var lookAt = new THREE.Vector3();
      lookAt.addVectors(currentPos, currentDir);
      viewer.camera.lookAt(lookAt);
      viewer.setDirty(true);
    };

    for (var i = 0; i < steps; i++) {
      setTimeout(doAnimation, i * delay);
    }
  }
};


"use strict";

function ViewerController(viewer) {
  'use strict';

  this.viewer = viewer;
  this.IS_ANIMATION_ENABLED = true;
  this.fitInCorrectionFactor = 1.5;

  this.setInitialRotationPoint = function (boundingBox) {
    if (boundingBox) {
      //compute center of bounding box
      var center = new THREE.Vector3();
      center = boundingBox.getCenter(center);
      this.viewer.cameraCtrl.rotationPoint.set(center.x, center.y, center.z);
    }
  };

  this.updateScene = function (bbox) {
    if (!bbox) return;
    var lower = bbox.min;
    var upper = bbox.max;
    if (!lower) return;
    var dx = Math.abs(upper.x - lower.x);
    var dy = Math.abs(upper.y - lower.y);
    var max = Math.max(dx, dy);
    var gridFactor;
    var originFactor;
    var panSpeedFactor;
    var zoomSpeedFactor;

    if (max < 0.05) // scene < 5cm
      {
        gridFactor = 1000;
        originFactor = 8;
        panSpeedFactor = 125;
        zoomSpeedFactor = 125;
      } else if (max < 0.5) // 5cm < scene < 50cm
      {
        gridFactor = 100;
        originFactor = 4;
        panSpeedFactor = 25;
        zoomSpeedFactor = 25;
      } else if (max < 5) // 50cm < scene < 5m
      {
        gridFactor = 10;
        originFactor = 2;
        panSpeedFactor = 5;
        zoomSpeedFactor = 5;
      } else if (max < 50) // 5m < scene < 50m
      {
        gridFactor = 1;
        originFactor = 1;
        panSpeedFactor = 1;
        zoomSpeedFactor = 1;
      } else if (max < 500) // 50m < scene < 500m
      {
        gridFactor = 0.1;
        originFactor = 0.5;
        panSpeedFactor = 0.4;
        zoomSpeedFactor = 0.4;
      } else if (max < 5000) // 500m < scene < 5000m
      {
        gridFactor = 0.01;
        originFactor = 0.25;
        panSpeedFactor = 0.04;
        zoomSpeedFactor = 0.04;
      } else // 5000m < scene
      {
        gridFactor = 0.001;
        originFactor = 0.125;
        panSpeedFactor = 0.004;
        zoomSpeedFactor = 0.004;
      }

    if (this.viewer.grid) {
      var majorTick = 1 / gridFactor * 4;
      var minorTick = 0.2 / gridFactor;
      var xStart = lower.x - 0.5 * dx;
      var yStart = lower.y - 0.5 * dy;
      var xEnd = (Math.trunc(dx * 2 / majorTick) + 1) * majorTick + xStart;
      var yEnd = (Math.trunc(dy * 2 / majorTick) + 1) * majorTick + yStart;
      this.viewer.grid.update(this.viewer.scene, this.viewer.quality, xStart, yStart, xEnd, yEnd, majorTick, minorTick);
    }

    if (this.viewer.ground) {
      var extend = max * 2;
      var zValue = lower.z - 0.1;
      this.viewer.ground.update(this.viewer.scene, this.viewer.quality, lower.x - extend, lower.y - extend, upper.x + extend, upper.y + extend, zValue);
    } //update origin


    if (this.viewer.origin) {
      var l1 = 0.9 / originFactor;
      var l2 = 0.2 / originFactor;
      var r1 = 0.02 / originFactor;
      var r2 = 0.1 / originFactor;
      this.viewer.origin.update(this.viewer.scene, this.viewer.quality, l1, l2, r1, r2);
    } //update pan / zoom speed


    var zoomSpeed = 0.01 / zoomSpeedFactor;
    var panSpeed = 0.09 / panSpeedFactor;
    this.viewer.cameraCtrl.setRange(1, max * 10);
    this.viewer.cameraCtrl.setSensitivities(undefined, zoomSpeed, panSpeed);
  };

  this.getSceneBoundingBox = function () {
    var entities = this.viewer.entities || [];
    var bbox = undefined;

    function checkForList(list) {
      for (var i = 0; i < list.length; i++) {
        var entity = list[i];

        if (entity.type === "Mesh") {
          var geom = entity.geometry;
          geom.computeBoundingBox();
          var box = geom.boundingBox.clone();
          var matrix = entity.matrixWorld;
          box.applyMatrix4(matrix);

          if (bbox) {
            bbox = bbox.union(box);
          } else {
            bbox = box.clone();
          }
        }

        if (entity.children && entity.children.length > 0) {
          checkForList(entity.children);
        }
      }
    }

    checkForList(entities);
    return bbox;
  };
  /**
   *
   * @param isAnimated {Boolean}
   * @returns {*}
   */


  this.fitInScene = function (isAnimated) {
    var bbox = this.getSceneBoundingBox();
    this.fitInBoundingBox(bbox, isAnimated);
    return bbox;
  };
  /**
   * @param bimModel {BimModel}
   * @param isAnimated {Boolean}
   */


  this.fitInBimModel = function (bimModel, isAnimated) {
    var bbox = bimModel.getBoundingBox();
    this.fitInBoundingBox(bbox, isAnimated);
    return bbox;
  };
  /**
   * @param bimObject {BimObject}
   * @param isAnimated {Boolean}
   */


  this.fitInBimObject = function (bimObject, isAnimated) {
    this.fitInBoundingBox(bimObject.getBoundingBox(), isAnimated, 3);
  };

  this.fitInBoundingBox = function (bbox, isAnimated, factor) {
    isAnimated = isAnimated !== undefined ? isAnimated : this.IS_ANIMATION_ENABLED;
    var fitInVectors = this.computeFitInBox(bbox, factor);
    var newPos = fitInVectors[0];
    var lookAt = fitInVectors[1];

    if (isAnimated) {
      CameraUtils.flyTo(this.viewer, newPos, undefined, undefined);
    } else {
      this.viewer.camera.position.set(newPos.x, newPos.y, newPos.z);
      this.viewer.camera.lookAt(lookAt);
      this.viewer.setDirty(true);
    }
  };

  this.computeFitInBox = function (bbox, factor) {
    var cameraDirection = new THREE.Vector3(0, 0, -1);
    cameraDirection.applyEuler(this.viewer.camera.rotation, this.viewer.camera.rotation.order);
    return this.computeFitInBoxAndDir(bbox, cameraDirection, factor);
  };

  this.computeFitInBoxAndDir = function (bbox, dir, factor) {
    var min;
    var max;
    var center = new THREE.Vector3();
    if (factor === undefined || factor === null) factor = this.fitInCorrectionFactor;

    if (bbox) {
      min = bbox.min;
      max = bbox.max;
      center = bbox.getCenter(center);
    } else {
      var d = 50;
      min = new THREE.Vector3(-d, -d, -d);
      max = new THREE.Vector3(d, d, d);
      center.x = (max.x + min.x) * 0.5;
      center.y = (max.y + min.y) * 0.5;
      center.z = (max.z + min.z) * 0.5;
    } //compute distance


    var diag = new THREE.Vector3();
    diag = diag.subVectors(max, min);
    var radius = diag.length() * 0.5;
    var fov = this.viewer.camera.fov * Math.PI / 180.0 / 2.0;
    var tanfov = Math.tan(fov);
    var ratio = this.viewer.camera.aspect;
    var offset = radius / (ratio * tanfov);
    dir.multiplyScalar(-1);
    dir.setLength(offset * factor);
    var newPos = new THREE.Vector3();
    newPos.addVectors(center, dir);
    return [newPos, center];
  };
}


"use strict";

/**
 * @param viewer {BimViewer}
 * @param crossSection {CrossSection}
 * @param objectPicker {BimObjectPicker}
 */
function BimCutter3d(viewer, crossSection, objectPicker) {
  this.scene = new THREE.Scene();
  this.controls = [];
  this.stopDisable = false;
  this.isEnabled = true;
  var self = this;
  var loader = new THREE.OBJLoader();
  var controlObj = "assets/images/cgviewer/bim/arrow.obj";
  var raycaster = new THREE.Raycaster();
  raycaster.camera = viewer.camera;
  var startPos = undefined;
  var entityPlane = new THREE.Plane();
  var basePlane = new THREE.Plane();
  var moveControl = undefined;
  var eventRegistered = false;

  function init() {
    var dirLight1 = new THREE.DirectionalLight(0xffffff, 1);
    dirLight1.position.set(-100, 100, -200);
    self.scene.add(dirLight1); //directional light

    var dirLight2 = new THREE.DirectionalLight(0xffffff, 1);
    dirLight2.position.set(100, -100, 200);
    self.scene.add(dirLight2);
    viewer.signaler.cameraControlChanged.add(cameraUpdated);
  }

  this.render = function (renderer, camera) {
    this.scene.updateMatrixWorld();
    renderer.render(this.scene, camera);
  };

  this.addCutter = function (entity, normal) {
    loadObject().then(function (object) {
      self.scene.add(object);
      viewer.setDirty(true);
      object.entity = entity;
      object.normalVec = normal.clone().normalize();
      var matrix = new THREE.Matrix4();
      matrix.lookAt(Bim.Coords.org, object.normalVec, new THREE.Vector3(0, 0, 1));
      object.applyMatrix4(matrix);
      object.position.set(entity.position.x, entity.position.y, entity.position.z);
      object.position.add(object.normalVec.clone().multiplyScalar(0.5));
      self.controls.push(object);
      entityPlane.setFromNormalAndCoplanarPoint(object.normalVec, entity.position);

      if (self.isEnabled) {
        self.enableCutter();
      } else {
        self.disableCutter();
      }
    });
  };

  this.removeCutter = function (control) {
    if (control.entity) {
      viewer.removeObject(control.entity);
      control.entity = undefined;
    }

    this.scene.remove(control);

    for (var i = 0; i < this.controls.length; i++) {
      if (this.controls[i] === control) {
        this.controls.splice(i, 1);
        break;
      }
    }
  };

  this.disableCutter = function () {
    for (var i = 0; i < self.controls.length; i++) {
      self.controls[i].visible = false;
    }

    removeHandler();
  };

  this.enableCutter = function () {
    if (self.controls.length === 0) return;
    if (!crossSection.isClippingApplied) return;

    for (var i = 0; i < self.controls.length; i++) {
      var object = self.controls[i];
      var pos = object.entity.position;
      object.position.set(pos.x, pos.y, pos.z);
      object.position.add(object.normalVec.clone().multiplyScalar(0.5));
      object.visible = true;
    }

    viewer.setDirty(true);
    registerHandler();
  };

  this.clear = function () {
    for (var i = 0; i < self.controls.length; i++) {
      var control = self.controls[i];

      if (control.entity) {
        viewer.removeObject(control.entity);
        control.entity = undefined;
      }

      self.scene.remove(control);
    }

    self.controls = [];
    removeHandler();
  };

  this.setEnabled = function (enabled) {
    this.isEnabled = enabled;

    if (enabled) {
      this.enableCutter();
    } else {
      this.disableCutter();
    }
  };

  init();

  function loadObject() {
    return new Promise(function (resolve, reject) {
      loader.load(controlObj, function (obj) {
        obj.scale.set(3, 3, 3);
        obj.rotation.x = Math.PI / 2;
        setMaterialColor(obj, 0x00ff00);
        resolve(obj);
      }, function () {}, function (err) {
        reject(err);
      });
    });
  }

  function registerHandler() {
    if (eventRegistered) return;
    eventRegistered = true;
    viewer.canvas.addEventListener("pointerdown", onMouseDown, false);
    viewer.canvas.addEventListener("pointerup", onMouseUp, false);
    viewer.canvas.addEventListener("pointermove", onMove, false);
    viewer.canvas.addEventListener("dblclick", onMouseDblClick, false);
    viewer.canvas.addEventListener("pointercancel", onMouseUp, false);
  }

  function removeHandler() {
    if (!eventRegistered) return;
    eventRegistered = false;
    viewer.canvas.removeEventListener("pointerdown", onMouseDown, false);
    viewer.canvas.removeEventListener("pointerup", onMouseUp, false);
    viewer.canvas.removeEventListener("pointermove", onMove, false);
    viewer.canvas.removeEventListener("dblclick", onMouseDblClick, false);
    viewer.canvas.removeEventListener("pointercancel", onMouseUp, false);
  }

  function setRaycaster(x, y) {
    var rect = viewer.canvas.getBoundingClientRect();
    x -= rect.left;
    y -= rect.top;
    var vector = new THREE.Vector3(x / viewer.width * 2 - 1, -(y / viewer.height) * 2 + 1, 0.5);
    var camera = viewer.camera;
    vector.unproject(camera);
    raycaster.set(camera.position, vector.sub(camera.position).normalize());
  }

  function onMouseDown(e) {
    setRaycaster(e.clientX, e.clientY);
    var intersects = raycaster.intersectObject(self.scene, true);

    if (!intersects || !intersects.length) {
      startPos = undefined;

      if (!self.stopDisable) {
        self.disableCutter();
      }

      return;
    }

    moveControl = intersects[0].object.parent;
    setMaterialColor(moveControl, 0x0000ff);
    viewer.setDirty(true);
    pauseViewer();
    entityPlane.setFromNormalAndCoplanarPoint(moveControl.normalVec, moveControl.entity.position);
    startPos = new THREE.Vector3();

    if (!raycaster.ray.intersectPlane(entityPlane, startPos)) {
      startPos = undefined;
      return;
    }

    var lookAt = new THREE.Vector3();
    viewer.camera.getWorldDirection(lookAt);
    basePlane.setFromNormalAndCoplanarPoint(lookAt, startPos);
  }

  function onMove(e) {
    if (!startPos) return;
    var secondPos = new THREE.Vector3();
    setRaycaster(e.clientX, e.clientY);

    if (!raycaster.ray.intersectPlane(basePlane, secondPos)) {
      return;
    }

    if (!secondPos) return;
    var subVec = secondPos.clone().sub(startPos);
    var dot = moveControl.normalVec.clone().dot(subVec);
    var moveVec = moveControl.normalVec.clone().multiplyScalar(dot);
    moveControl.position.add(moveVec);
    moveControl.entity.position.add(moveVec);
    moveControl.entity.updateMatrix();
    crossSection.updateClippingPlanes();
    viewer.setDirty(true);
    startPos = secondPos;
  }

  function onMouseUp() {
    if (moveControl) {
      setMaterialColor(moveControl, 0x00ff00);
      viewer.setDirty(true);
    }

    startPos = undefined;
    moveControl = undefined;
    resumeViewer();
  }

  function onMouseDblClick(e) {
    setRaycaster(e.clientX, e.clientY);
    var intersects = raycaster.intersectObject(self.scene, true);

    if (intersects && intersects.length) {
      var control = intersects[0].object.parent;

      if (control) {
        crossSection.toggleClippingPlaneEntity(control.entity);
      }
    }

    resumeViewer();
  }

  function setMaterialColor(object, color) {
    object.traverse(function (child) {
      if (child.isMesh) {
        child.material.color = new THREE.Color(color);
      }
    });
  }

  function cameraUpdated(camera) {
    var scaleVector = new THREE.Vector3();
    var scaleFactor = 6;

    for (var i = 0; i < self.controls.length; i++) {
      var object = self.controls[i];
      var length = scaleVector.subVectors(object.position, camera.position).length();
      var scale = length / scaleFactor;
      object.scale.set(scale, scale, scale);
      var pos = object.entity.position;
      object.position.set(pos.x, pos.y, pos.z);
      object.position.add(object.normalVec.clone().multiplyScalar(scale * 0.2));
    }
  }

  function pauseViewer() {
    viewer.cameraCtrl.pause();

    if (objectPicker) {
      objectPicker.pause();
    }
  }

  function resumeViewer() {
    viewer.cameraCtrl.resume();

    if (objectPicker) {
      objectPicker.resume();
    }
  }
}


"use strict";

function BimDrawer2d(viewer, scene) {
  var _this = this;

  BimBaseCmd.call(this, viewer, scene, 'drawer2d');
  var TextMode = {
    none: 0,
    snap: 1,
    length: 2
  };
  this.textMode = TextMode.snap;
  this.canvas = undefined;
  this.touch = undefined;
  var self = this;
  var width = viewer.width;
  var height = viewer.height;
  var screenPos = new THREE.Vector2();
  var snapPos2d = new THREE.Vector2();
  var snapPosFrom2d = new THREE.Vector3();
  var snapSize = 4.5;
  var thickness = 0.5;

  function createDrawingCanvas2d() {
    self.canvas = document.createElement('canvas');
    self.canvas.setAttribute('id', 'three-canvas-2d');
    self.reset();
    viewer.root.appendChild(self.canvas);
  }

  function init() {
    createDrawingCanvas2d();
  }

  function displaySnapSticker() {
    self.clear();
    var snapFlag = self.touch.snapFlag();
    var snapPos = self.touch.snapPosition();
    var snapPosFrom = self.touch.snapPointFrom();
    if (self.textMode !== TextMode.length && snapFlag === Bim.SnapFlag.none) return;
    snapPos2d = get2dPtfrom3d(snapPos);

    if (snapPosFrom) {
      snapPosFrom2d = get2dPtfrom3d(snapPosFrom);
    }

    drawSnapShape(snapFlag);
    var ctx = self.canvas.getContext("2d");
    ctx.lineWidth = "0.5";
    ctx.strokeStyle = "#000";
    ctx.fillStyle = "#FFFFE1";
    ctx.font = "14px Arial";
    var text = Bim.SnapStickerString[snapFlag];

    if (self.textMode === TextMode.length) {
      text = self.currentText;
    }

    var size = ctx.measureText(text);
    ctx.beginPath();
    ctx.fillRect(screenPos.x + 13, screenPos.y + 8, size.width + 5, 14 + 5);
    ctx.strokeRect(screenPos.x + 13 - 0.5, screenPos.y + 8 - 0.5, size.width + 5 + 0.5 * 2, 14 + 5 + 0.5 * 2);
    ctx.fillStyle = "#000";
    ctx.fillText(text, screenPos.x + 13 + 2, screenPos.y + 8 + 15);
  }

  function get2dPtfrom3d(pos) {
    var pos3d = pos.clone().project(viewer.camera);
    var pos2d = new THREE.Vector2();
    pos2d.x = Math.round((pos3d.x + 1) * width / 2);
    pos2d.y = Math.round((-pos3d.y + 1) * height / 2);
    return pos2d;
  }

  function drawCircleShape(center, radius, fillColorMain, strokeColorMain, fillColorInside, strokeColorOutside) {
    var ctx = self.canvas.getContext("2d");
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.fillStyle = fillColorMain;
    ctx.strokeStyle = strokeColorMain;
    ctx.arc(center.x, center.y, radius, 0, 2 * Math.PI);
    ctx.fill();
    ctx.stroke();
    ctx.beginPath();
    ctx.fillStyle = fillColorInside;
    ctx.arc(center.x, center.y, radius - 3, 0, 2 * Math.PI);
    ctx.fill();
    ctx.beginPath();
    ctx.strokeStyle = strokeColorOutside;
    ctx.arc(center.x, center.y, radius + 1, 0, 2 * Math.PI);
    ctx.stroke();
  }

  function drawDashLine(startPt, endPt, color) {
    var ctx = self.canvas.getContext("2d");
    ctx.lineWidth = 1;
    ctx.strokeStyle = color;
    ctx.save();
    ctx.beginPath();
    ctx.setLineDash([2, 5]);
    ctx.moveTo(startPt.x, startPt.y);
    ctx.lineTo(endPt.x, endPt.y);
    ctx.stroke();
    ctx.restore();
  }

  function drawLine(startPt, endPt, color) {
    var ctx = self.canvas.getContext("2d");
    ctx.lineWidth = 2;
    ctx.strokeStyle = color;
    ctx.beginPath();
    ctx.moveTo(startPt.x, startPt.y);
    ctx.lineTo(endPt.x, endPt.y);
    ctx.stroke();
  }

  function drawSnapShape(sFlag) {
    var ctx = self.canvas.getContext("2d");

    switch (sFlag) {
      case Bim.SnapFlag.onFace:
        ctx.save();
        ctx.translate(snapPos2d.x, snapPos2d.y);
        ctx.rotate(Math.PI * 0.25);
        ctx.lineWidth = thickness;
        ctx.beginPath();
        ctx.fillStyle = "#636FCF";
        ctx.strokeStyle = "#2D39AE";
        ctx.rect(-snapSize, -snapSize, snapSize * 2, snapSize * 2);
        ctx.fill();
        ctx.stroke();
        ctx.strokeStyle = "#fff";
        ctx.strokeRect(-snapSize - thickness * 2, -snapSize - thickness * 2, snapSize * 2 + thickness * 4, snapSize * 2 + thickness * 4);
        ctx.restore();
        break;

      case Bim.SnapFlag.onEdgeVt:
      case Bim.SnapFlag.redAxis:
      case Bim.SnapFlag.blueAxis:
      case Bim.SnapFlag.greenAxis:
        ctx.lineWidth = thickness;
        ctx.beginPath();
        ctx.fillStyle = "#E6A88C";
        ctx.strokeStyle = "#A43434";
        ctx.rect(snapPos2d.x - snapSize, snapPos2d.y - snapSize, snapSize * 2, snapSize * 2);
        ctx.fill();
        ctx.stroke();
        ctx.strokeStyle = "#fff";
        ctx.strokeRect(snapPos2d.x - snapSize - thickness * 2, snapPos2d.y - snapSize - thickness * 2, snapSize * 2 + thickness * 4, snapSize * 2 + thickness * 4);
        break;

      case Bim.SnapFlag.onEndVt:
        drawCircleShape(snapPos2d, snapSize, "#7DDD73", "#2D6527", "#3C7D36", "#fff");
        break;

      case Bim.SnapFlag.onMidVt:
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.fillStyle = "#BAF1F3";
        ctx.strokeStyle = "#00E0E0";
        ctx.arc(snapPos2d.x, snapPos2d.y, snapSize, 0, 2 * Math.PI);
        ctx.fill();
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = "#fff";
        ctx.arc(snapPos2d.x, snapPos2d.y, snapSize + 1, 0, 2 * Math.PI);
        ctx.stroke();
        break;

      case Bim.SnapFlag.onCenterVt:
        drawCircleShape(snapPos2d, snapSize, "#6CC0E3", "#1040BF", "#225AC7", "#fff");
        break;

      case Bim.SnapFlag.fromPointOnRed:
        drawDashLine(snapPos2d, snapPosFrom2d, "#ff0000");
        drawCircleShape(snapPosFrom2d, snapSize, "#C5CCC9", "#000", "#000", "#fff");
        break;

      case Bim.SnapFlag.fromPointOnBlue:
        drawDashLine(snapPos2d, snapPosFrom2d, "#0000ff");
        drawCircleShape(snapPosFrom2d, snapSize, "#C5CCC9", "#000", "#000", "#fff");
        break;

      case Bim.SnapFlag.fromPointOnGreen:
        drawDashLine(snapPos2d, snapPosFrom2d, "#00ff00");
        drawCircleShape(snapPosFrom2d, snapSize, "#C5CCC9", "#000", "#000", "#fff");
        break;

      case Bim.SnapFlag.onRedAxis:
        drawLine(snapPos2d, snapPosFrom2d, "#ff0000");
        break;

      case Bim.SnapFlag.onBlueAxis:
        drawLine(snapPos2d, snapPosFrom2d, "#0000ff");
        break;

      case Bim.SnapFlag.onGreenAxis:
        drawLine(snapPos2d, snapPosFrom2d, "#00ff00");
        break;

      case Bim.SnapFlag.origin:
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.fillStyle = "#fff";
        ctx.strokeStyle = "#fff";
        ctx.arc(snapPos2d.x + thickness, snapPos2d.y + thickness, snapSize + 1, 0, 2 * Math.PI);
        ctx.fill();
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = "#000";
        ctx.arc(snapPos2d.x + thickness, snapPos2d.y + thickness, snapSize, 0, 2 * Math.PI);
        ctx.moveTo(snapPos2d.x + thickness, snapPos2d.y + thickness - snapSize);
        ctx.lineTo(snapPos2d.x + thickness, snapPos2d.y + thickness + snapSize);
        ctx.moveTo(snapPos2d.x + thickness - snapSize, snapPos2d.y + thickness);
        ctx.lineTo(snapPos2d.x + thickness + snapSize, snapPos2d.y + thickness);
        ctx.stroke();
        break;

      default:
        break;
    }
  }

  this.clear = function () {
    var ctx = self.canvas.getContext("2d");
    ctx.clearRect(0, 0, width, height);
  };

  this.reset = function () {
    width = viewer.width;
    height = viewer.height;
    self.canvas.height = height;
    self.canvas.width = width;
  };

  this.showSnapSticker = function (event, touch) {
    _this.touch = touch;
    screenPos = new THREE.Vector2(event.clientX, event.clientY);
    displaySnapSticker();
  };

  this.updateCurrentText = function (text) {
    _this.currentText = text;
  };

  init();
}


"use strict";

function BimDrawer2dText(viewer) {
  this.canvas = undefined;
  this.texts = [];
  var self = this;
  var width = 3000;
  var height = 3000;
  var context;
  var LINE_HEIGHT = 1.5;

  function init() {
    self.canvas = document.createElement('canvas');
    self.canvas.setAttribute('id', 'bim-canvas-2d-text');
    self.reset();
    viewer.root.appendChild(self.canvas);
    context = self.canvas.getContext("2d");
  }

  this.clear = function () {
    context.clearRect(0, 0, width, height);
  };

  this.reset = function () {
    self.canvas.height = height;
    self.canvas.width = width;
  };

  this.addText = function (text, x, y, textBrush) {
    if (!text || text === '') return;
    context.fillStyle = textBrush.fillColor;
    context.textBaseline = 'middle';
    context.textAlign = 'left';

    if (textBrush.fontStyle === 'italic' || textBrush.fontStyle === 'bold') {
      context.font = textBrush.fontStyle + ' ' + textBrush.fontSize + 'px ' + textBrush.fontFamily;
    } else {
      context.font = textBrush.fontSize + 'px ' + textBrush.fontFamily;
    }

    var width = 0,
        height = 0;
    var lines = text.split(/\r?\n/);

    for (var i = 0; i < lines.length; ++i) {
      var size = context.measureText(lines[i]);
      context.fillText(lines[i], x, y + (i + 0.5) * textBrush.fontSize * LINE_HEIGHT);
      width = Math.max(width, size.width);
      height += textBrush.fontSize * LINE_HEIGHT;
    }

    this.texts.push({
      lines: lines,
      text: text,
      rect: {
        x: x,
        y: y,
        width: width,
        height: height
      },
      fillColor: textBrush.fillColor,
      strokeColor: textBrush.strokeColor,
      fontFamily: textBrush.fontFamily,
      fontSize: textBrush.fontSize,
      fontStyle: textBrush.fontStyle,
      strokeWidth: 1
    });
  };

  this.getText = function (x, y) {
    return this.texts.find(function (text) {
      return ptInRect(x, y, text.rect);
    });
  };

  this.removeText = function (text) {
    var index = this.texts.findIndex(function (x) {
      return x === text;
    });

    if (index !== -1) {
      this.texts.splice(index, 1);
      context.clearRect(text.rect.x, text.rect.y, text.rect.width, text.rect.height);
    }
  };

  function ptInRect(x, y, rect) {
    return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && rect.y + rect.height;
  }

  init();
}


"use strict";

/**
 * @param viewer {BimViewer}
 * @param planSection {CrossSection}
 * @param objectPicker {BimObjectPicker}
 */
function BimPlan3d(viewer, planSection, objectPicker) {
  this.scene = new THREE.Scene();
  this.controls = [];
  var self = this;
  var loader = new THREE.OBJLoader();
  var controlObj = "assets/images/cgviewer/bim/arrow.obj";
  var raycaster = new THREE.Raycaster();
  raycaster.camera = viewer.camera;
  var startPos = undefined;
  var entityPlane = new THREE.Plane();
  var basePlane = new THREE.Plane();
  var moveControl = undefined;
  var eventRegistered = false;

  function init() {
    var dirLight1 = new THREE.DirectionalLight(0xffffff, 1);
    dirLight1.position.set(-100, 100, -200);
    self.scene.add(dirLight1); //directional light

    var dirLight2 = new THREE.DirectionalLight(0xffffff, 1);
    dirLight2.position.set(100, -100, 200);
    self.scene.add(dirLight2);
    viewer.signaler.cameraControlChanged.add(cameraUpdated);
  }

  function updateControlPosition(object) {
    var pos = object.entities[0].position;
    object.position.set(pos.x, pos.y, pos.z);
    object.position.add(object.normalVec.clone().multiplyScalar(0.5));
  }

  this.render = function (renderer, camera) {
    this.scene.updateMatrixWorld();
    renderer.render(this.scene, camera);
  };
  /**
   * add BimPlan control
   * @param bimPlan {BimPlan}
   * @param visibility {Boolean}
   * @returns {Promise<unknown>}
   */


  this.addControl = function (bimPlan, visibility) {
    return new Promise(function (resolve, reject) {
      loadObject().then(function (object) {
        self.scene.add(object);
        viewer.setDirty(true);
        object.bimPlan = bimPlan;
        object.entities = [bimPlan.mesh, bimPlan.marker];
        object.normalVec = bimPlan.normal.clone().normalize();
        object.visible = visibility;
        var matrix = new THREE.Matrix4();
        matrix.lookAt(Bim.Coords.org, object.normalVec, new THREE.Vector3(0, 0, 1));
        object.applyMatrix4(matrix);
        object.position.set(bimPlan.mesh.position.x, bimPlan.mesh.position.y, bimPlan.mesh.position.z);
        object.position.add(object.normalVec.clone().multiplyScalar(0.5));
        self.controls.push(object);
        entityPlane.setFromNormalAndCoplanarPoint(object.normalVec, bimPlan.mesh.position);

        if (visibility) {
          self.enableControl();
        }

        resolve(object);
      });
    });
  };

  this.removeControl = function (control) {
    this.scene.remove(control);

    for (var i = 0; i < this.controls.length; i++) {
      if (this.controls[i] === control) {
        this.controls.splice(i, 1);
        break;
      }
    }
  };

  this.disableControl = function () {
    removeHandler();

    for (var i = 0; i < self.controls.length; i++) {
      self.controls[i].visible = false;
    }

    onMouseUp();
  };

  this.enableControl = function () {
    if (self.controls.length === 0) return;
    registerHandler();

    for (var i = 0; i < self.controls.length; i++) {
      updateControlPosition(self.controls[i]);
    }

    viewer.setDirty(true);
  };
  /**
   * @param control {Object}
   * @param visibility {Boolean}
   */


  this.showControl = function (control, visibility) {
    if (visibility) {
      this.enableControl();
    } else {
      this.disableControl();
    }

    control.visible = visibility;
    viewer.setDirty(true);
  };

  init();

  function loadObject() {
    return new Promise(function (resolve, reject) {
      loader.load(controlObj, function (obj) {
        obj.scale.set(3, 3, 3);
        obj.rotation.x = Math.PI / 2;
        setMaterialColor(obj, 0x00ff00);
        resolve(obj);
      }, function () {}, function (err) {
        reject(err);
      });
    });
  }

  function registerHandler() {
    if (eventRegistered) return;
    eventRegistered = true;
    viewer.canvas.addEventListener("pointerdown", onMouseDown, false);
    viewer.canvas.addEventListener("pointerup", onMouseUp, false);
    viewer.canvas.addEventListener("pointermove", onMove, false);
    viewer.canvas.addEventListener("dblclick", onMouseDblClick, false);
    viewer.canvas.addEventListener("pointercancel", onMouseUp, false);
  }

  function removeHandler() {
    if (!eventRegistered) return;
    eventRegistered = false;
    viewer.canvas.removeEventListener("pointerdown", onMouseDown, false);
    viewer.canvas.removeEventListener("pointerup", onMouseUp, false);
    viewer.canvas.removeEventListener("pointermove", onMove, false);
    viewer.canvas.removeEventListener("dblclick", onMouseDblClick, false);
    viewer.canvas.removeEventListener("pointercancel", onMouseUp, false);
  }

  function setRaycaster(x, y) {
    var rect = viewer.canvas.getBoundingClientRect();
    x -= rect.left;
    y -= rect.top;
    var camera = viewer.camera;
    var vector = new THREE.Vector3(x / viewer.width * 2 - 1, -(y / viewer.height) * 2 + 1, 0.5);
    vector.unproject(camera);
    raycaster.set(camera.position, vector.sub(camera.position).normalize());
  }

  function onMouseDown(e) {
    setRaycaster(e.clientX, e.clientY);
    var intersects = raycaster.intersectObject(self.scene, true);

    if (!intersects || !intersects.length) {
      startPos = undefined;
      self.disableControl();
      return;
    }

    moveControl = intersects[0].object.parent;
    setMaterialColor(moveControl, 0x0000ff);
    viewer.setDirty(true);
    pauseViewer();
    entityPlane.setFromNormalAndCoplanarPoint(moveControl.normalVec, moveControl.bimPlan.mesh.position);
    startPos = new THREE.Vector3();

    if (!raycaster.ray.intersectPlane(entityPlane, startPos)) {
      startPos = undefined;
      return;
    }

    var lookAt = new THREE.Vector3();
    viewer.camera.getWorldDirection(lookAt);
    basePlane.setFromNormalAndCoplanarPoint(lookAt, startPos);
  }

  function onMove(e) {
    if (!startPos) return;
    var secondPos = new THREE.Vector3();
    setRaycaster(e.clientX, e.clientY);

    if (!raycaster.ray.intersectPlane(basePlane, secondPos)) {
      return;
    }

    if (!secondPos) return;
    var subVec = secondPos.clone().sub(startPos);
    var dot = moveControl.normalVec.clone().dot(subVec);
    var moveVec = moveControl.normalVec.clone().multiplyScalar(dot);
    moveControl.position.add(moveVec);

    for (var i = 0; i < moveControl.entities.length; i++) {
      moveControl.entities[i].position.add(moveVec);
    }

    planSection.updateClippingPlanes();
    viewer.setDirty(true);
    startPos = secondPos;
  }

  function onMouseUp() {
    if (moveControl) {
      setMaterialColor(moveControl, 0x00ff00);
      viewer.setDirty(true);
    }

    startPos = undefined;
    moveControl = undefined;
    resumeViewer();
  }

  function onMouseDblClick(e) {
    setRaycaster(e.clientX, e.clientY);
    var intersects = raycaster.intersectObject(self.scene, true);

    if (intersects && intersects.length) {
      var control = intersects[0].object.parent;

      if (control) {
        control.bimPlan.toggleClipping();
      }
    }

    resumeViewer();
  }

  function setMaterialColor(object, color) {
    object.traverse(function (child) {
      if (child.isMesh) {
        child.material.color = new THREE.Color(color);
      }
    });
  }

  function cameraUpdated(camera) {
    var scaleVector = new THREE.Vector3();
    var scaleFactor = 6;

    for (var i = 0; i < self.controls.length; i++) {
      var object = self.controls[i];
      var length = scaleVector.subVectors(object.position, camera.position).length();
      var scale = length / scaleFactor;
      object.scale.set(scale, scale, scale);
      var pos = object.entities[0].position;
      object.position.set(pos.x, pos.y, pos.z);
      object.position.add(object.normalVec.clone().multiplyScalar(scale * 0.2));
    }
  }

  function pauseViewer() {
    viewer.cameraCtrl.pause();

    if (objectPicker) {
      objectPicker.pause();
    }
  }

  function resumeViewer() {
    viewer.cameraCtrl.resume();

    if (objectPicker) {
      objectPicker.resume();
    }
  }
}


"use strict";

function VPColorPicker(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.color);
  var self = this;

  this.newPicker = function () {
    this.type = VP.DrawingType.color;
    this.setCursor('color', true);
  };

  function rgbToHex(r, g, b) {
    if (r > 255 || g > 255 || b > 255) throw "Invalid color component";
    return (r << 16 | g << 8 | b).toString(16);
  }

  this.mousedown = function (e) {
    var x = e.pointer.x;
    var y = e.pointer.y; // get the color array for the pixel under the mouse

    var px = self.viewer.context.getImageData(x, y, 1, 1).data;
    var newColor = '#' + ("000000" + rgbToHex(px[0], px[1], px[2])).slice(-6);
    self.viewer.fill.type = 'color';
    self.viewer.fill.value = newColor;
  };

  this.mousemove = function (e) {};

  this.mouseup = function (e) {};
}


"use strict";

VPMainViewer.prototype.negative = function () {
  'use strict';

  var self = this;
  var canvas = this.canvas;
  var object = this.canvas.getActiveObject();
  var mainObject = VPUtils.findNearestIntersectingObj(object, this.canvas);
  if (!mainObject) return;
  canvas.remove(object);
  canvas.remove(mainObject);
  object.clone(function (clone) {
    object.set({
      stroke: self.brush.strokeColor,
      strokeWidth: self.brush.strokeWidth
    });
    var areaOfObject = VPUtils.area(object);
    var perimeterOfObject = VPUtils.perimeter(object);
    var main = mainObject;

    if (main.get('type') !== 'group') {
      main = new fabric.Group([mainObject, object], {
        stroke: mainObject.strokeColor,
        strokeWidth: mainObject.strokeWidth
      });
      VPUtils.generateId(main, VP.DrawingType.complex);
      VPUtils.setArea(main, VPUtils.area(mainObject) - areaOfObject);
      VPUtils.setPerimeter(main, VPUtils.perimeter(mainObject));
      VPUtils.setPerimeterIn(main, perimeterOfObject);
    } else {
      main.addWithUpdate(object);
      var area = VPUtils.area(main) - areaOfObject;

      if (area < 0) {
        area = VPUtils.area(main);
      }

      VPUtils.setArea(main, area);
      VPUtils.setPerimeterIn(main, VPUtils.perimeterIn(main) + areaOfObject);
    }

    var left = clone.left - main.left - main.width / 2;
    var top = clone.top - main.top - main.height / 2;
    clone.set({
      left: left,
      top: top,
      fill: 'black',
      strokeWidth: 0
    });
    VPUtils.setArea(clone, areaOfObject);
    VPUtils.setPerimeter(clone, perimeterOfObject);
    var clipArea = main.clipPath;

    if (clipArea) {
      var count = clipArea.size();
      var mainCount = main.size();
      var clips = [];

      for (var i = 0; i < count; i++) {
        var item = main.item(mainCount - 1 - count + i);

        var _area = clipArea.item(i);

        _area.set({
          left: item.left,
          top: item.top,
          width: item.width,
          height: item.height,
          skewX: item.skewX,
          skewY: item.skewY,
          angle: item.angle,
          flipX: item.flipX,
          flipY: item.flipY,
          scaleX: item.scaleX,
          scaleY: item.scaleY,
          rx: item.rx,
          ry: item.ry
        });

        clips.push(_area);
      }

      clips.push(clone);
      clipArea = new fabric.Group(clips, {});
    } else {
      clipArea = new fabric.Group([clone], {});
    }

    clipArea.inverted = true;
    main.clipPath = clipArea;
    main.dirty = true;
    main.perPixelTargetFind = true;
    main.targetFindTolerance = 4;
    canvas.add(main);
    self.data.replace(mainObject, main);
    self.data.remove(object);
    self.render();
    self.broadcast('object:removed', mainObject);
    self.broadcast('object:removed', object);
    self.broadcast('object:added', main);
  });
};


"use strict";

function VPPanMover(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.pan);
  var self = this;
  var isDragging = false;
  var firstPos = {
    x: 0,
    y: 0
  };
  var lastPosX = 0;
  var lastPosY = 0;

  this.newPan = function () {
    this.type = VP.DrawingType.pan;
    this.setCursor('position', true, true);
  };

  this.mousedown = function (e) {
    isDragging = true;
    self.canvas.selection = false; //minX = self.canvas.getWidth() * (1 - self.canvas.getZoom());
    //minY = self.canvas.getHeight() * (1 - self.canvas.getZoom());

    e = e.e;
    lastPosX = e.clientX;
    lastPosY = e.clientY;
    firstPos.x = lastPosX;
    firstPos.y = lastPosY;
    viewer.broadcast('pan:start');
  };

  this.mousemove = function (e) {
    if (isDragging) {
      e = e.e;
      self.canvas.viewportTransform[4] += e.clientX - lastPosX;
      self.canvas.viewportTransform[5] += e.clientY - lastPosY;
      viewer.broadcast('pan:move', {
        x: e.clientX - lastPosX.x,
        y: e.clientY - lastPosX.y
      });
      self.canvas.requestRenderAll();
      lastPosX = e.clientX;
      lastPosY = e.clientY;
    }
  };

  this.mouseup = function (e) {
    if (isDragging) {
      isDragging = false;
      e = e.e;
      viewer.broadcast('pan:end', {
        x: e.clientX - firstPos.x,
        y: e.clientY - firstPos.y
      });
    }

    this.selection = true;
  };

  this.move = function (difX, difY) {
    var delta = VP.Constants.PAN_MOVE_SCALE;
    self.canvas.viewportTransform[4] += delta * difX;
    self.canvas.viewportTransform[5] += delta * difY;
    self.canvas.requestRenderAll();
    viewer.broadcast('pan:end', {
      x: delta * difX,
      y: delta * difY
    });
  };
}


"use strict";

function VPZoomer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.zoom);
  var self = this;

  this.newZoom = function () {
    self.type = VP.DrawingType.zoom;
    self.setCursor('zoom', true);
  };

  this.mousedown = function (e) {};

  this.mousemove = function (e) {};

  this.mouseup = function (e) {
    var pointer = self.canvas.getPointer(e.e);
    self.viewer.zoomOut(pointer);
  };
}


"use strict";

function VPArrowLineDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.arrowline);
  var actions = {
    NONE: 0,
    NEW: 1,
    DRAW: 2
  };
  var self = this;
  var shape = undefined;
  var firstPos, lastPos;
  var direction;
  var endArrowL = undefined;
  var endArrowR = undefined;

  this.newLine = function (type) {
    self.type = VP.DrawingType.arrowline;
    self.action = actions.NEW;
    self.canvas.isDrawingMode = false;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
    self.arrowType = type;
  };

  function newShape(pointer) {
    shape = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
      fill: '',
      stroke: viewer.brush.strokeColor,
      strokeWidth: viewer.brush.strokeWidth,
      strokeDashArray: viewer.brush.strokeDashArray,
      originX: 'center',
      originY: 'center'
    });
    self.canvas.add(shape);
    self.setCurrentObject(shape);
  }

  function updateLine(pointer) {
    shape.set({
      x2: pointer.x,
      y2: pointer.y
    });
    var difVec = {
      x: shape.x2 - shape.x1,
      y: shape.y2 - shape.y1
    };
    var d_difVec = self.distance(difVec);
    var vdifVec = {
      x: difVec.x / d_difVec,
      y: difVec.y / d_difVec
    };
    var ndifVec = {
      x: vdifVec.y,
      y: -vdifVec.x
    };

    if (vdifVec.y < 0) {
      ndifVec = {
        x: -vdifVec.y,
        y: vdifVec.x
      };
    }

    var sign = 1;

    if (vdifVec.x * vdifVec.y < 0) {
      sign = -1;
    }

    var thickness = shape.strokeWidth * 0.5;
    var endArrowPt1 = {
      x: shape.x1 + sign * ndifVec.x * thickness,
      y: shape.y1 + sign * ndifVec.x * thickness
    };
    var endArrowPt2 = {
      x: shape.x2 + sign * ndifVec.x * thickness,
      y: shape.y2 + sign * ndifVec.y * thickness
    };
    var arrowSize = [15, 5];
    var endArrowLPoints = [];
    endArrowLPoints.push(endArrowPt1);
    endArrowLPoints.push({
      x: endArrowPt1.x + vdifVec.x * (arrowSize[0] + arrowSize[1]) + ndifVec.x * arrowSize[1],
      y: endArrowPt1.y + vdifVec.y * (arrowSize[0] + arrowSize[1]) + ndifVec.y * arrowSize[1]
    });
    endArrowLPoints.push({
      x: endArrowPt1.x + vdifVec.x * arrowSize[0],
      y: endArrowPt1.y + vdifVec.y * arrowSize[0]
    });
    endArrowLPoints.push({
      x: endArrowPt1.x + vdifVec.x * (arrowSize[0] + arrowSize[1]) - ndifVec.x * arrowSize[1],
      y: endArrowPt1.y + vdifVec.y * (arrowSize[0] + arrowSize[1]) - ndifVec.y * arrowSize[1]
    });
    var left = endArrowLPoints[0].x;
    var top = endArrowLPoints[0].y;

    for (var i = 1; i < endArrowLPoints.length; i++) {
      left = Math.min(left, endArrowLPoints[i].x);
      top = Math.min(top, endArrowLPoints[i].y);
    }

    if (self.arrowType !== 'up') {
      if (endArrowL) {
        self.canvas.remove(endArrowL);
      }

      endArrowL = new fabric.Polygon(endArrowLPoints, {
        left: left,
        top: top,
        fill: 'black',
        stroke: 'black',
        strokeWidth: 1,
        selectable: false,
        objectCaching: false,
        originX: 'left',
        originY: 'top'
      });
      endArrowL.snapDisabled = true;
      self.canvas.add(endArrowL);
    }

    var endArrowRPoints = [];
    endArrowRPoints.push(endArrowPt2);
    endArrowRPoints.push({
      x: endArrowPt2.x - vdifVec.x * (arrowSize[0] + arrowSize[1]) + ndifVec.x * arrowSize[1],
      y: endArrowPt2.y - vdifVec.y * (arrowSize[0] + arrowSize[1]) + ndifVec.y * arrowSize[1]
    });
    endArrowRPoints.push({
      x: endArrowPt2.x - vdifVec.x * arrowSize[0],
      y: endArrowPt2.y - vdifVec.y * arrowSize[0]
    });
    endArrowRPoints.push({
      x: endArrowPt2.x - vdifVec.x * (arrowSize[0] + arrowSize[1]) - ndifVec.x * arrowSize[1],
      y: endArrowPt2.y - vdifVec.y * (arrowSize[0] + arrowSize[1]) - ndifVec.y * arrowSize[1]
    });
    left = endArrowRPoints[0].x;
    top = endArrowRPoints[0].y;

    for (var _i = 1; _i < endArrowRPoints.length; _i++) {
      left = Math.min(left, endArrowRPoints[_i].x);
      top = Math.min(top, endArrowRPoints[_i].y);
    }

    if (self.arrowType !== 'down') {
      if (endArrowR) {
        self.canvas.remove(endArrowR);
      }

      endArrowR = new fabric.Polygon(endArrowRPoints, {
        left: left,
        top: top,
        fill: 'black',
        stroke: 'black',
        strokeWidth: 1,
        selectable: false,
        objectCaching: false,
        originX: 'left',
        originY: 'top'
      });
      endArrowR.snapDisabled = true;
      self.canvas.add(endArrowR);
    }

    self.canvas.renderAll();
  }

  function finishDrawing() {
    self.canvas.remove(shape);

    if (endArrowR) {
      self.canvas.remove(endArrowR);
    }

    if (endArrowL) {
      self.canvas.remove(endArrowL);
    }

    var groups = [shape];

    if (endArrowL) {
      groups.push(endArrowL);
    }

    if (endArrowR) {
      groups.push(endArrowR);
    }

    var arrowline = new fabric.Group(groups, {});
    self.addObject(arrowline, true, true);
    self.updateHistory();
    shape = undefined;
    endArrowL = undefined;
    endArrowR = undefined;
    self.setCurrentObject(false);
    self.canvas.renderAll();
  }

  this.doEscape = function () {
    self.action = actions.NEW;
    self.removeObject(shape);
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.DRAW === self.action) {
      lastPos = this.getCurrentPt();

      if (this.keyStatus && this.keyStatus === 'shortcut:shift') {
        lastPos = VPUtils.getStraightLine2d(firstPos, lastPos);
      }

      updateLine(lastPos);
      direction = VPUtils.normalize(VPUtils.sub(lastPos, firstPos));
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      firstPos = this.getCurrentPt();
      newShape(firstPos);
      self.action = actions.DRAW;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.DRAW === self.action) {
      self.action = actions.NEW;
      finishDrawing();
      viewer.broadcast('draw:dragging', false);
    }
  }; // context menu handler


  this.contextmenu = function (e) {
    self.action = actions.NEW;
    self.updateHistory();
  };
}


"use strict";

function VPCircleDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.circle);
  var actions = {
    NONE: 0,
    NEW: 1,
    RADIUS: 2
  };
  var self = this;
  var shape;
  var center = undefined;
  var lastPos;
  var direction;

  this.newCircle = function () {
    self.type = VP.DrawingType.circle;
    self.action = actions.NEW;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  };

  this.newHexagon = function () {
    self.type = VP.DrawingType.hexagon;
    self.action = actions.NEW;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.RADIUS === self.action) {
      lastPos = this.getCurrentPt();
      updateShape(lastPos);
      direction = VPUtils.normalize(VPUtils.sub(lastPos, center));
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      center = this.getCurrentPt();
      newShape();
      self.action = actions.RADIUS;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.RADIUS === self.action) {
      self.action = actions.NEW;
      self.updateHistory();
      self.setCurrentObject(false);
      viewer.broadcast('draw:dragging', false);
    }
  }; // context menu handler


  this.contextmenu = function (e) {
    self.action = actions.NEW;
    self.updateHistory();
  };

  function newShape() {
    var radius = 1;

    if (VP.DrawingType.circle === self.type) {
      shape = new fabric.Circle({
        left: center.x,
        top: center.y,
        radius: radius,
        fill: viewer.brush.fillColor,
        stroke: viewer.brush.strokeColor,
        strokeWidth: viewer.brush.strokeWidth,
        strokeDashArray: viewer.brush.strokeDashArray,
        originX: 'center',
        originY: 'center',
        selectable: false
      });
      var extRadius = radius + shape.strokeWidth;
      VPUtils.setArea(shape, extRadius * extRadius * Math.PI);
    } else {
      shape = new fabric.Polygon(getHexagonPoints(radius), {
        left: center.x,
        top: center.y,
        width: radius * 2,
        height: radius * 2,
        strokeWidth: viewer.brush.strokeWidth,
        strokeLineJoin: 'bevil',
        strokeDashArray: viewer.brush.strokeDashArray,
        stroke: 'black',
        fill: 'white',
        originX: 'center',
        originY: 'center',
        selectable: false
      }, false);

      var _extRadius = radius + shape.strokeWidth;

      VPUtils.setArea(shape, Math.sqrt(3) * 1.5 * _extRadius * _extRadius);
      shape.on("modified", function () {
        var matrix = this.calcTransformMatrix();
        shape.transformedPoints = this.get("points").map(function (p) {
          return new fabric.Point(p.x, p.y);
        }).map(function (p) {
          return fabric.util.transformPoint(p, matrix);
        });
      });
    }

    self.addObject(shape, true, true);
    self.canvas.setActiveObject(shape);
    self.setCurrentObject(shape);
  }

  function updateShape(pointer) {
    var radius = self.distanceOf(center, pointer);

    if (VP.DrawingType.circle === self.type) {
      shape.set('radius', radius);
      var extRadius = radius + shape.strokeWidth;
      VPUtils.setArea(shape, extRadius * extRadius * Math.PI);
      VPUtils.setPerimeter(shape, extRadius * Math.PI * 2);
    } else {
      shape.set('points', getHexagonPoints(radius));
      shape.set('width', radius * 2);
      shape.set('height', radius * 2);

      var _extRadius2 = radius + shape.strokeWidth;

      VPUtils.setArea(shape, Math.sqrt(3) * 1.5 * _extRadius2 * _extRadius2);
      VPUtils.setPerimeter(shape, _extRadius2 * 6);
    }

    self.fireOnUpdate(shape);
    self.canvas.renderAll();
  }

  function getHexagonPoints(radius) {
    var points = [];
    var degree = 0;

    for (var i = 0; i < 6; i++) {
      points.push({
        x: radius * Math.cos(degree),
        y: radius * Math.sin(degree)
      });
      degree += Math.PI / 3.0;
    }

    return points;
  }
}


"use strict";

function VPCurveDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.curve);
  var actions = {
    NONE: 0,
    NEW: 1,
    RADIUS: 2,
    ANGLE: 3
  };
  var self = this;
  var center = undefined;
  var first = undefined;
  var last = undefined;
  var guideLine = undefined;
  var shape = undefined;
  var direction;

  this.newArc = function () {
    self.type = VP.DrawingType.arc;
    self.action = actions.NEW;
    self.setCursor('crosshair');
    shape = undefined;
    guideLine = undefined;
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.RADIUS === this.action) {
      first = this.getCurrentPt();
      updateGuideline(first);
      direction = VPUtils.normalize(VPUtils.sub(first, center));
    } else if (actions.ANGLE === this.action) {
      last = this.getCurrentPt();
      updateAngle(last);
      self.fireOnUpdate(shape);
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      center = this.getCurrentPt();
      newGuideline(center);
      self.action = actions.RADIUS;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.RADIUS === self.action) {
      self.action = actions.ANGLE;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.ANGLE === self.action) {
      removeGuideLine();
      shape = undefined;
      self.updateHistory();
      self.action = actions.NEW;
      viewer.broadcast('draw:dragging', false);
    }
  }; // context menu handler


  this.contextmenu = function (e) {
    removeGuideLine();
    shape = undefined;
    self.action = actions.NEW;
  };

  function newGuideline(pointer) {
    guideLine = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
      strokeWidth: 1,
      fill: '',
      strokeDashArray: [3, 3],
      stroke: '#888',
      originX: 'center',
      originY: 'center'
    });
    self.canvas.add(guideLine);
    self.setCurrentObject(guideLine);
  } // update guide line


  function updateGuideline(pointer) {
    guideLine.set({
      x2: pointer.x,
      y2: pointer.y
    });
    self.canvas.renderAll();
  }

  function updateAngle(pointer) {
    var v1 = {
      x: first.x - center.x,
      y: first.y - center.y
    };
    var v2 = {
      x: pointer.x - center.x,
      y: pointer.y - center.y
    };
    var angle2 = self.angle1(v2);
    var angle1 = self.angle1(v1);
    var angle = (360 - Math.round((angle2 - angle1) * 180 / Math.PI)) % 360;

    if (shape) {
      shape.set('endAngle', Math.PI / 2 - angle2);
      self.canvas.renderAll();
    } else {
      var radius = self.distance(v1);
      shape = new fabric.Circle({
        radius: radius,
        left: center.x,
        top: center.y,
        startAngle: Math.PI / 2 - angle1,
        endAngle: Math.PI / 2 - angle2,
        fill: '',
        stroke: viewer.brush.strokeColor,
        strokeWidth: viewer.brush.strokeWidth,
        strokeDashArray: viewer.brush.strokeDashArray,
        originX: 'center',
        originY: 'center',
        selectable: false
      });
      self.addObject(shape, true, true);
      self.setCurrentObject(false);
    }
  }

  function removeGuideLine() {
    if (guideLine) {
      self.canvas.remove(guideLine);
      self.canvas.renderAll();
      guideLine = undefined;
    }
  }
}


"use strict";

function VPFreeCurveDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.freecurve);
  var actions = {
    NONE: 0,
    NEW: 1,
    LINE: 2,
    CURVE: 3
  };
  var self = this;
  var shape = undefined;
  var curve = undefined;
  var firstPos, lastPos;
  var direction;

  this.newCurve = function () {
    self.type = VP.DrawingType.freecurve;
    self.action = actions.NEW;
    self.canvas.isDrawingMode = false;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  };

  this.doEscape = function () {
    self.action = actions.NEW;

    if (shape) {
      self.canvas.remove(shape);
    }

    if (curve) {
      self.canvas.remove(curve);
    }
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.LINE === self.action) {
      lastPos = this.getCurrentPt();

      if (this.keyStatus && this.keyStatus === 'shortcut:shift') {
        lastPos = VPUtils.getStraightLine2d(firstPos, lastPos);
      }

      updateLine(lastPos);
      direction = VPUtils.normalize(VPUtils.sub(lastPos, firstPos));
    } else if (self.action === actions.CURVE) {
      updateCurve(this.getCurrentPt());
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      firstPos = this.getCurrentPt();
      newShape(firstPos);
      self.action = actions.LINE;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.LINE === self.action) {
      self.action = actions.CURVE;
      viewer.broadcast('draw:dragging', false);
      makeCurrentLineToCurve();
    } else if (actions.CURVE === self.action) {
      completeCurve();
      self.action = actions.NEW;
      self.setCurrentObject(false);
      viewer.broadcast('draw:dragging', false);
      self.updateHistory();
    }
  }; // context menu handler


  this.contextmenu = function (e) {
    self.action = actions.NEW;
    self.updateHistory();
  };

  function newShape(pointer) {
    shape = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
      fill: '',
      stroke: viewer.brush.strokeColor,
      strokeWidth: viewer.brush.strokeWidth,
      strokeDashArray: viewer.brush.strokeDashArray,
      originX: 'center',
      originY: 'center'
    });
    self.canvas.add(shape);
    self.setCurrentObject(shape);
  }

  function updateLine(pointer) {
    shape.set({
      x2: pointer.x,
      y2: pointer.y
    });
    self.canvas.renderAll();
  }

  function makeCurrentLineToCurve() {
    var cmd = svgCommandFromPoints({
      x: shape.x1,
      y: shape.y1
    }, {
      x: shape.x2,
      y: shape.y2
    }, {
      x: shape.x2,
      y: shape.y2
    });
    curve = new fabric.Path(cmd, {
      fill: '',
      stroke: viewer.brush.strokeColor,
      strokeWidth: viewer.brush.strokeWidth,
      strokeDashArray: viewer.brush.strokeDashArray,
      objectCaching: false,
      originX: 'center',
      originY: 'center'
    });
    curve.set('selectable', false);
    self.addObject(curve, true, true);
    self.setCurrentObject(curve);
    self.canvas.remove(shape);
    self.canvas.renderAll();
    shape = undefined;
  }

  function updateCurve(pointer) {
    var path = curve.path;
    path[1][1] = pointer.x;
    path[1][2] = pointer.y;
    curve.setCoords();
    self.canvas.renderAll();
  }

  function completeCurve() {
    var path = curve.path;
    var cmd = svgCommandFromPoints({
      x: path[0][1],
      y: path[0][2]
    }, {
      x: path[1][1],
      y: path[1][2]
    }, {
      x: path[1][3],
      y: path[1][4]
    });
    self.removeObject(curve);
    curve = new fabric.Path(cmd, {
      fill: '',
      stroke: viewer.brush.strokeColor,
      strokeWidth: viewer.brush.strokeWidth,
      strokeDashArray: viewer.brush.strokeDashArray,
      objectCaching: false,
      originX: 'center',
      originY: 'center'
    });
    self.addObject(curve, true, true);
    curve = undefined;
  }

  function svgCommandFromPoints(p1, p2, p3) {
    return "M ".concat(p1.x, " ").concat(p1.y, " Q ").concat(p2.x, ", ").concat(p2.y, ", ").concat(p3.x, ", ").concat(p3.y);
  }
}


"use strict";

function VPFreeLineDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.freeline);
  var actions = {
    NONE: 0,
    NEW: 1,
    DRAW: 2
  };
  var self = this;

  this.newFreeLine = function () {
    self.type = VP.DrawingType.freeline;
    self.action = actions.NEW;
    self.canvas.isDrawingMode = true;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.DRAW === self.action) {
      self.canvas.getPointer(e.e);
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      self.action = actions.NEW;
      self.updateHistory();
      self.setCurrentObject(e.path);
    }
  }; // context menu handler


  this.contextmenu = function (e) {
    self.action = actions.NEW;
    self.updateHistory();
  };

  this.onActiveChanged = function (active) {
    if (active) {
      self.viewer.canvas.on('path:created', pathCreated);
    } else {
      self.viewer.canvas.off('path:created', pathCreated);
    }
  };

  function pathCreated(e) {
    self.addObject(e.path, false, true);
    self.setCurrentObject(false);
    e.path.on("modified", function () {
      e.path.transformedPoints = VPUtils.getTransformedPath(e.path); //transformed points
    });
  }
}


"use strict";

function VPIconDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.icon);
  var actions = {
    NONE: 0,
    NEW: 1
  };
  var self = this;
  var shape = undefined;

  this.newIcon = function (model, size) {
    self.action = actions.NEW;
    self.type = VP.DrawingType.icon;
    self.setActive(true);
    newShape(model, size);
  };

  this.newMatchIcon = function (model, size) {
    self.action = actions.NEW;
    self.type = VP.DrawingType.icon;
    self.setActive(true);
    newShape(model, size);
    self.matchIcon = true;
    shape.visible = false;
    self.setSnapEnable(true);
  };

  this.newObject = function (object) {
    self.action = actions.NEW;
    self.type = VP.DrawingType.icon;
    self.setActive(true);
    shape = object;
    shape.originX = 'center';
    shape.originY = 'center';
    self.addObject(shape, true, true);
  };

  this.dragObject = function (object) {
    self.action = actions.NEW;
    self.type = VP.DrawingType.icon;
    self.setActive(true);
    shape = object;
    shape.originX = 'center';
    shape.originY = 'center';
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.NEW === self.action) {
      updateShape(self.canvas.getPointer(e.e));
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      self.action = actions.NONE;
      self.setActive(false);
      self.updateHistory();
      self.viewer.broadcast('updateDrawer', 'pan');

      if (self.matchIcon) {
        shape.visible = true;
        self.canvas.renderAll();
      }
    }
  }; // mouse right button click handler


  this.contextmenu = function (e) {
    self.action = actions.NONE;
    self.setActive(false);
    self.updateHistory();
  };

  function newShape(model, size) {
    shape = model;
    var vptCoords = self.canvas.vptCoords;
    var center = {
      x: (vptCoords.tl.x + vptCoords.tr.x) * 0.5,
      y: (vptCoords.tl.y + vptCoords.bl.y) * 0.5
    };
    shape.left = center.x;
    shape.top = center.y;
    var scaleW = size ? size : 100;
    shape.scaleToWidth(scaleW);
    shape.scaleToHeight(scaleW);
    shape.originX = 'center';
    shape.originY = 'center';
    shape.fill = '';
    shape.stroke = viewer.brush.strokeColor;
    shape.strokeWidth = viewer.brush.strokeWidth;
    shape.strokeDashArray = viewer.brush.strokeDashArray;
    self.addObject(shape, true, true);

    if (model.name) {
      shape.excludeFromExport = true;
      shape.info.name = model.name;
    }
  }

  function updateShape(pointer) {
    shape.set({
      left: pointer.x,
      top: pointer.y
    });
    self.canvas.renderAll();
  }
}


"use strict";

function VPLineDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.line);
  var actions = {
    NONE: 0,
    NEW: 1,
    DRAW: 2
  };
  var self = this;
  var shape = undefined;
  var firstPos, lastPos;
  var direction;

  this.newLine = function () {
    self.type = VP.DrawingType.line;
    self.action = actions.NEW;
    self.canvas.isDrawingMode = false;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  };

  this.doEscape = function () {
    self.action = actions.NEW;
    self.removeObject(shape);
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.DRAW === self.action) {
      lastPos = this.getCurrentPt();

      if (this.keyStatus && this.keyStatus === 'shortcut:shift') {
        lastPos = VPUtils.getStraightLine2d(firstPos, lastPos);
      }

      updateLine(lastPos);
      direction = VPUtils.normalize(VPUtils.sub(lastPos, firstPos));
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      firstPos = this.getCurrentPt();
      newShape(firstPos);
      self.action = actions.DRAW;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.DRAW === self.action) {
      self.action = actions.NEW;
      self.updateHistory();
      self.setCurrentObject(false);
      viewer.broadcast('draw:dragging', false);
    }
  }; // context menu handler


  this.contextmenu = function (e) {
    self.action = actions.NEW;
    self.updateHistory();
  };

  function newShape(pointer) {
    shape = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
      fill: '',
      stroke: viewer.brush.strokeColor,
      strokeWidth: viewer.brush.strokeWidth,
      strokeDashArray: viewer.brush.strokeDashArray,
      originX: 'center',
      originY: 'center'
    });
    self.addObject(shape, true, true);
    self.setCurrentObject(shape);
    self.canvas.setActiveObject(shape);
  }

  function updateLine(pointer) {
    shape.set({
      x2: pointer.x,
      y2: pointer.y
    });
    self.canvas.renderAll();
    self.fireOnUpdate(shape);
  }
}


"use strict";

function VPPolyLineDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.polyline);
  var actions = {
    NONE: 0,
    NEW: 1,
    DRAW: 2
  };
  var self = this;
  var shape = undefined;
  var group = [];
  var points = [];
  var currentPoint = undefined;
  var canPolygon = false;
  var polygonCircle = undefined;
  var firstPos, lastPos;
  var direction;

  this.newPolyLine = function () {
    self.type = VP.DrawingType.polyline;
    self.action = actions.NEW;
    self.canvas.isDrawingMode = false;
    canPolygon = false;
    polygonCircle = undefined;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  };

  this.doEscape = function () {
    if (polygonCircle) {
      self.canvas.remove(polygonCircle);
      polygonCircle = undefined;
    }

    for (var i in group) {
      self.canvas.remove(group[i]);
    }

    self.setCurrentObject(false);
    points = [];
    group = [];
    self.action = actions.NEW;
    self.type = VP.DrawingType.polyline;
    viewer.broadcast('draw:dragging', false);
  };

  this.doDeactivate = function () {
    completeDrawing();
  };

  function newShape(pointer) {
    shape = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
      fill: 'black',
      stroke: viewer.brush.strokeColor,
      strokeWidth: viewer.brush.strokeWidth,
      strokeDashArray: viewer.brush.strokeDashArray,
      originX: 'center',
      originY: 'center'
    });
    self.canvas.add(shape);
    group.push(shape);
    points.push({
      x: pointer.x,
      y: pointer.y
    });
    currentPoint = {
      x: pointer.x,
      y: pointer.y
    };
    points.push(currentPoint);
    self.setCurrentObject(shape);
  }

  function addPoint(pointer) {
    shape = new fabric.Line([shape.x2, shape.y2, pointer.x, pointer.y], {
      fill: 'black',
      stroke: viewer.brush.strokeColor,
      strokeWidth: viewer.brush.strokeWidth,
      strokeDashArray: viewer.brush.strokeDashArray,
      originX: 'center',
      originY: 'center',
      selectable: false
    });
    self.canvas.add(shape);
    self.canvas.renderAll();
    group.push(shape);
    self.setCurrentObject(shape);
    currentPoint = {
      x: pointer.x,
      y: pointer.y
    };
    points.push(currentPoint);
    canPolygon = checkPolygon();
    self.canvas.renderAll();
  }

  function updateLine(pointer) {
    shape.set({
      x2: pointer.x,
      y2: pointer.y
    });
    currentPoint.x = pointer.x;
    currentPoint.y = pointer.y;
    canPolygon = checkPolygon();
    self.canvas.renderAll();
  }

  function checkPolygon() {
    if (polygonCircle) {
      self.canvas.remove(polygonCircle);
      polygonCircle = undefined;
    }

    if (points.length > 3) {
      var firstPoint = points[0];
      var distance = self.distanceOf(firstPoint, currentPoint);

      if (firstPoint !== currentPoint && distance < VP.Constants.POLYGON_RANGE / self.viewer.canvas.getZoom()) {
        return true;
      }
    }

    return false;
  }

  function completeDrawing() {
    if (polygonCircle) {
      self.canvas.remove(polygonCircle);
      polygonCircle = undefined;
    }

    for (var i in group) {
      self.canvas.remove(group[i]);
    }

    var left = points[0].x;
    var top = points[0].y;

    if (canPolygon) {
      points[points.length - 1].x = left;
      points[points.length - 1].y = top;

      for (var _i = 1; _i < points.length - 1; _i++) {
        left = Math.min(left, points[_i].x);
        top = Math.min(top, points[_i].y);
      }

      self.type = VP.DrawingType.polygon;
      var polygon = new fabric.Polygon(points, {
        left: left,
        top: top,
        fill: '',
        stroke: viewer.brush.strokeColor,
        strokeWidth: viewer.brush.strokeWidth,
        strokeDashArray: viewer.brush.strokeDashArray,
        selectable: false,
        objectCaching: false,
        originX: 'left',
        originY: 'top'
      });
      VPUtils.setArea(polygon, VPUtils.polygonArea(points));
      VPUtils.setPerimeter(polygon, VPUtils.getPerimeterFromPoints(points));
      self.addObject(polygon, true, true);
      polygon.on("modified", function () {
        var matrix = this.calcTransformMatrix();
        var pts = this.get("points");

        var _VPUtils$getMinMaxPos = VPUtils.getMinMaxPos(pts),
            minX = _VPUtils$getMinMaxPos.minX,
            minY = _VPUtils$getMinMaxPos.minY;

        var transformedPoints = this.get("points").map(function (p) {
          return new fabric.Point(p.x - minX - polygon.width / 2, p.y - minY - polygon.height / 2);
        }).map(function (p) {
          return fabric.util.transformPoint(p, matrix);
        });
        polygon.transformedPoints = transformedPoints;
        VPUtils.setArea(polygon, VPUtils.polygonArea(transformedPoints));
        VPUtils.setPerimeter(polygon, VPUtils.getPerimeterFromPoints(transformedPoints));
      });
    } else {
      for (var _i2 = 1; _i2 < points.length; _i2++) {
        left = Math.min(left, points[_i2].x);
        top = Math.min(top, points[_i2].y);
      }

      var polyline = new fabric.Polyline(points, {
        left: left,
        top: top,
        fill: '',
        stroke: viewer.brush.strokeColor,
        strokeWidth: viewer.brush.strokeWidth,
        strokeDashArray: viewer.brush.strokeDashArray,
        selectable: false,
        objectCaching: false,
        originX: 'left',
        originY: 'top'
      });
      VPUtils.setArea(polyline, 0);
      VPUtils.setPerimeter(polyline, VPUtils.getPerimeterFromPoints(points));
      self.addObject(polyline, true, true);
      polyline.info.type = VP.DrawingType.polyline;
      polyline.on("modified", function () {
        var matrix = this.calcTransformMatrix();
        var pts = this.get("points");

        var _VPUtils$getMinMaxPos2 = VPUtils.getMinMaxPos(pts),
            minX = _VPUtils$getMinMaxPos2.minX,
            minY = _VPUtils$getMinMaxPos2.minY;

        var transformedPoints = this.get("points").map(function (p) {
          return new fabric.Point(p.x - minX - polyline.width / 2, p.y - minY - polyline.height / 2);
        }).map(function (p) {
          return fabric.util.transformPoint(p, matrix);
        });
        polyline.transformedPoints = transformedPoints;
        VPUtils.setArea(polyline, 0);
        VPUtils.setPerimeter(polyline, VPUtils.getPerimeterFromPoints(transformedPoints));
      });
    }

    self.updateHistory();
    self.setCurrentObject(false);
    points = [];
    group = [];
    self.action = actions.NEW;
    self.type = VP.DrawingType.polyline;
    viewer.broadcast('draw:dragging', false);
  } // mouse move handler


  this.mousemove = function (e) {
    if (actions.DRAW === self.action) {
      if (VP.DrawingType.line === self.type || VP.DrawingType.polyline === self.type) {
        lastPos = this.getCurrentPt();
        updateLine(lastPos);
        direction = VPUtils.normalize(VPUtils.sub(lastPos, firstPos));
      }
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      firstPos = this.getCurrentPt();
      newShape(firstPos);
      self.action = actions.DRAW;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.DRAW === self.action) {
      if (canPolygon) {
        completeDrawing();
      } else {
        firstPos = this.getCurrentPt();
        addPoint(firstPos);
      }
    }
  };
}


"use strict";

function VPRectDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.rect);
  var actions = {
    NONE: 0,
    NEW: 1,
    DRAW: 2
  };
  var self = this;
  var shape = undefined;
  var origin = undefined;
  var firstPos;

  this.newRect = function () {
    self.type = VP.DrawingType.rectangle;
    self.action = actions.NEW;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.DRAW === self.action) {
      updateShape(this.getCurrentPt());
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      firstPos = this.getCurrentPt();
      newShape(firstPos);
      self.action = actions.DRAW;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.DRAW === self.action) {
      self.action = actions.NEW;
      self.updateHistory();
      self.setCurrentObject(false);
      viewer.broadcast('draw:dragging', false);
    }
  }; // mouse right click handler


  this.contextmenu = function (e) {
    self.action = actions.NEW;
    self.updateHistory();
  }; // create new shape


  function newShape(pointer) {
    origin = pointer;
    shape = new fabric.Rect({
      width: 0,
      height: 0,
      left: pointer.x,
      top: pointer.y,
      fill: viewer.brush.fillColor,
      stroke: viewer.brush.strokeColor,
      strokeWidth: viewer.brush.strokeWidth,
      strokeDashArray: viewer.brush.strokeDashArray,
      selectable: false
    });
    self.addObject(shape, true, true);
    self.canvas.setActiveObject(shape);
    self.setCurrentObject(shape);
  } // update shape


  function updateShape(pointer) {
    var w = Math.abs(pointer.x - origin.x);
    var h = Math.abs(pointer.y - origin.y);

    if (origin.x > pointer.x) {
      shape.set({
        left: pointer.x
      });
    }

    if (origin.y > pointer.y) {
      shape.set({
        top: pointer.y
      });
    }

    shape.set({
      width: w
    });
    shape.set({
      height: h
    });
    w += shape.strokeWidth;
    h += shape.strokeWidth;
    VPUtils.setArea(shape, w * h);
    VPUtils.setPerimeter(shape, w * 2 + h * 2);
    self.canvas.renderAll();
    self.fireOnUpdate(shape);
  }
}


"use strict";

function VPSectorDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.sector);
  var actions = {
    NONE: 0,
    NEW: 1,
    RADIUS: 2,
    ANGLE: 3
  };
  var self = this;
  var center = undefined;
  var first = undefined;
  var last = undefined;
  var radius = undefined;
  var angle = undefined;
  var arc = undefined;
  var group = [];
  var direction;

  this.newSector = function () {
    self.type = VP.DrawingType.sector;
    self.action = actions.NEW;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.RADIUS === this.action) {
      first = this.getCurrentPt();
      updateLine(0, first);
      direction = VPUtils.normalize(VPUtils.sub(first, center));
    } else if (actions.ANGLE === this.action) {
      updateAngle(this.getCurrentPt());
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      center = this.getCurrentPt();
      newLine(center);
      self.action = actions.RADIUS;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.RADIUS === self.action) {
      first = this.getCurrentPt();
      newLine(center, first);
      self.action = actions.ANGLE;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.ANGLE === self.action) {
      viewer.broadcast('draw:dragging', false);
      completeDrawing();
    }
  }; // context menu handler


  this.contextmenu = function (e) {
    cancelDrawing();
  };

  function newLine(point1, point2) {
    if (point2 === undefined) {
      point2 = point1;
    }

    var line = new fabric.Line([point1.x, point1.y, point2.x, point2.y], {
      fill: '',
      stroke: 'black',
      strokeWidth: viewer.brush.strokeWidth,
      strokeDashArray: viewer.brush.strokeDashArray,
      originX: 'center',
      originY: 'center'
    });
    self.canvas.add(line);
    self.setCurrentObject(line);
    group.push(line);
  } // update line


  function updateLine(index, pointer) {
    var shape = group[index];
    shape.set({
      x2: pointer.x,
      y2: pointer.y
    });
    self.canvas.renderAll();
  }

  function updateAngle(pointer) {
    var v1 = {
      x: first.x - center.x,
      y: first.y - center.y
    };
    var v2 = {
      x: pointer.x - center.x,
      y: pointer.y - center.y
    };
    radius = self.distance(v1);
    var angle2 = self.angle1(v2);
    var angle1 = self.angle1(v1);
    angle = (360 - Math.round((angle2 - angle1) * 180 / Math.PI)) % 360;
    var v2length = self.distance(v2);
    v2.x = v2.x * radius / v2length;
    v2.y = v2.y * radius / v2length;
    last = {
      x: center.x + v2.x,
      y: center.y + v2.y
    };
    updateLine(1, last);

    if (arc) {
      arc.set('endAngle', Math.PI / 2 - angle2);
      self.canvas.renderAll();
    } else {
      arc = new fabric.Circle({
        radius: radius,
        left: center.x,
        top: center.y,
        startAngle: Math.PI / 2 - angle1,
        endAngle: Math.PI / 2 - angle2,
        stroke: viewer.brush.strokeColor,
        strokeWidth: viewer.brush.strokeWidth,
        strokeDashArray: viewer.brush.strokeDashArray,
        fill: viewer.brush.fillColor,
        originX: 'center',
        originY: 'center',
        selectable: false
      });
      self.canvas.add(arc);
      self.setCurrentObject(arc);
      group.push(arc);
    }
  }

  function completeDrawing() {
    for (var i in group) {
      self.canvas.remove(group[i]);
    }

    group = []; //"M 255 135 A 50 50 0 0 1 200 110"

    var command = 'M ' + center.x + ' ' + center.y + ' L ' + first.x + ' ' + first.y + ' A ' + radius + ' ' + radius + (angle < 180 ? ' 0 0 1 ' : ' 1 1 1 ') + last.x + ' ' + last.y + ' ' + ' L ' + center.x + ' ' + center.y + ' z';
    var sector = new fabric.Path(command, {
      fill: viewer.brush.fillColor,
      stroke: viewer.brush.strokeColor,
      strokeWidth: viewer.brush.strokeWidth,
      strokeDashArray: viewer.brush.strokeDashArray,
      selectable: false
    });
    self.addObject(sector, true, true);
    self.setCurrentObject(false);
    var extRadius = radius + sector.strokeWidth;
    VPUtils.setArea(sector, extRadius * extRadius * Math.PI * angle / 360);
    VPUtils.setPerimeter(sector, extRadius * Math.PI * angle / 180);
    sector.on("modified", function () {
      sector.transformedPoints = VPUtils.getTransformedPath(sector);
    });
    self.canvas.renderAll();
    sector.startAngle = arc.startAngle;
    sector.endAngle = arc.endAngle;
    arc = undefined;
    center = undefined;
    first = undefined;
    last = undefined;
    radius = undefined;
    angle = undefined;
    self.action = actions.NEW;
    self.updateHistory();
  }

  function cancelDrawing() {
    for (var i in group) {
      self.canvas.remove(group[i]);
    }

    arc = undefined;
    group = [];
    center = undefined;
    first = undefined;
    last = undefined;
    self.action = actions.NEW;
  }
}


"use strict";

function VPShapeOperator(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.operator);
  var self = this;

  this.newEraser = function () {
    this.type = VP.DrawingType.eraser;
    this.viewer.setSelectable(true);
    this.setCursor('eraser', true);
  };

  this.newBucket = function () {
    self.type = VP.DrawingType.bucket;
    self.setCursor('bucket', true);
  };

  this.bringToFront = function () {
    self.type = VP.DrawingType.front;
    self.setCursor('front', true);
  };

  this.sendToBack = function () {
    self.type = VP.DrawingType.back;
    self.setCursor('back', true);
  };

  this.mousedown = function (e) {
    var shape = e.target;

    if (shape) {
      if (VP.DrawingType.eraser === self.type) {
        if (shape.info && !shape.info.backgroundImage && shape.selectable) {
          self.removeObject(shape);
          self.updateHistory();
        }
      } else if (VP.DrawingType.bucket === self.type) {
        if (self.viewer.fill.type === 'color') {
          if (shape.info && shape.info.type === VP.DrawingType.complex) {
            var item = shape.item(0);

            if (item) {
              item.set('fill', self.viewer.fill.value);
            }
          }

          shape.set('fill', self.viewer.fill.value);

          if (shape.vpObject) {
            shape.vpObject.set('fill', self.viewer.fill.value);
          }
        } else if (self.viewer.fill.type === 'texture') {
          var texture = self.viewer.fill.value;
          fabric.util.loadImage(texture.map, function (img) {
            var pattern = new fabric.Pattern({
              source: img,
              repeat: 'repeat'
            });

            if (shape.info && shape.info.type === VP.DrawingType.complex) {
              var _item = shape.item(0);

              if (_item) {
                _item.set('fill', pattern);
              }
            }

            shape.set('fill', pattern);
            self.canvas.renderAll();

            if (shape.vpObject) {
              shape.vpObject.set('fill', pattern);
            }
          });
        } else {
          shape.set('fill', self.viewer.fill.value);

          if (shape.vpObject) {
            shape.vpObject.set('fill', self.viewer.fill.value);
          }
        }

        self.canvas.renderAll();
        self.updateHistory();
        self.fireOnUpdate(shape);
      } else if (VP.DrawingType.front === self.type) {
        if (shape === self.viewer.planObject) return;
        shape.bringToFront();
        self.canvas.renderAll();
        self.updateHistory();
      } else if (VP.DrawingType.back === self.type) {
        if (shape === self.viewer.planObject) return;

        if (self.viewer.planObject) {
          shape.moveTo(1);
        } else {
          shape.sendToBack();
        }

        self.canvas.renderAll();
        self.updateHistory();
      }
    }
  };

  this.mousemove = function (e) {};

  this.mouseup = function (e) {};
}


"use strict";

function VPTextDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.text);
  var self = this;
  var actions = {
    NONE: 0,
    NEW: 1
  };
  var text = undefined;

  this.newText = function () {
    self.type = VP.DrawingType.text;
    self.action = actions.NEW;
    self.setCursor('text');
  };

  this.newTextBubble = function () {
    self.type = VP.DrawingType.bubble;
    self.action = actions.NEW;
    self.setCursor('text');
  };
  /* Mousedown */


  this.mousedown = function (e) {
    var mouse = self.canvas.getPointer(e.e);
    text = new fabric.IText('Please enter Text', {
      fontFamily: viewer.textBrush.fontFamily,
      fontSize: viewer.textBrush.fontSize,
      left: mouse.x,
      top: mouse.y,
      fill: viewer.textBrush.fillColor,
      stroke: viewer.textBrush.strokeColor,
      strokeWidth: 0.1,
      originX: 'center',
      originY: 'center'
    });
    text.on("modified", function () {
      self.fireOnUpdate(text);
    });

    if (VP.DrawingType.bubble === self.type) {
      var padding = 10,
          tailW = 10,
          tailH = 20;
      var left = text.left - text.width / 2 - padding;
      var top = text.top - text.height / 2 - padding;
      var right = left + text.width + padding * 2;
      var bottom = top + text.height + padding * 2;
      var center = (left + right) / 2;
      var path = new fabric.Path("M ".concat(left, " ").concat(top, " ") + "L ".concat(right, " ").concat(top, " ") + "L ".concat(right, " ").concat(bottom, " ") + "L ".concat(center + tailW, " ").concat(bottom, " ") + "L ".concat(center, " ").concat(bottom + tailH, " ") + "L ".concat(center - tailW, " ").concat(bottom, " ") + "L ".concat(left, " ").concat(bottom, " ") + "L ".concat(left, " ").concat(top, " z"));
      path.set({
        fill: 'transparent',
        stroke: viewer.brush.strokeColor,
        strokeWidth: viewer.brush.strokeWidth,
        originX: 'left',
        originY: 'top'
      });
      self.addObject(new fabric.Group([path, text], {}), true, true);
    } else {
      self.addObject(text, true, true);

      if (text.info) {
        text.info.isTextShape = true;
      }
    }

    text.enterEditing();
    text.hiddenTextarea.focus();
    text.selectAll();
    self.canvas.renderAll();
    self.updateHistory();
  };
  /* Mousemove */


  this.mousemove = function (e) {};
  /* Mouseup */


  this.mouseup = function (e) {};
}


"use strict";

function VPWallDrawer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.wall);
  var actions = {
    NONE: 0,
    NEW: 1,
    DRAW: 2
  };
  var self = this;
  var WALL_COLOR = 'rgb(250, 238, 0, 1)';
  var shape = undefined;
  var origin = undefined;
  var firstPos;

  this.newWall = function () {
    self.type = VP.DrawingType.wall;
    self.action = actions.NEW;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.DRAW === self.action) {
      updateShape(this.getCurrentPt());
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      firstPos = this.getCurrentPt();
      newShape(firstPos);
      self.action = actions.DRAW;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.DRAW === self.action) {
      self.action = actions.NEW;
      self.updateHistory();
      self.setCurrentObject(false);
      viewer.broadcast('draw:dragging', false);
      viewer.broadcast('wall', shape);
    }
  }; // mouse right click handler


  this.contextmenu = function (e) {
    self.action = actions.NEW;
    self.updateHistory();
  }; // create new shape


  function newShape(pointer) {
    origin = pointer;
    shape = new fabric.Rect({
      width: 0,
      height: 0,
      left: pointer.x,
      top: pointer.y,
      fill: WALL_COLOR,
      stroke: viewer.brush.strokeColor,
      strokeWidth: viewer.brush.strokeWidth,
      strokeDashArray: viewer.brush.strokeDashArray,
      selectable: false
    });
    self.addObject(shape, true, true);
    VPUtils.setZHeight(shape, 1);
    self.canvas.setActiveObject(shape);
    self.setCurrentObject(shape);
  } // update shape


  function updateShape(pointer) {
    var w = Math.abs(pointer.x - origin.x);
    var h = Math.abs(pointer.y - origin.y);

    if (origin.x > pointer.x) {
      shape.set({
        left: pointer.x
      });
    }

    if (origin.y > pointer.y) {
      shape.set({
        top: pointer.y
      });
    }

    shape.set({
      width: w
    });
    shape.set({
      height: h
    });
    w += shape.strokeWidth;
    h += shape.strokeWidth;
    VPUtils.setPerimeter(shape, w * 2 + h * 2);

    if (VPUtils.zHeight(shape) === undefined) {
      VPUtils.setZHeight(shape, 1);
      VPUtils.setArea(shape, Math.max(w, h));
    } else {
      VPUtils.setArea(shape, Math.max(w, h) * VPUtils.zHeight(shape));
    }

    self.canvas.renderAll();
    self.fireOnUpdate(shape);
  }
}


"use strict";

function VPAngleMeasurer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.angle);
  var actions = {
    NONE: 0,
    NEW: 1,
    LINE: 2,
    ANGLE: 3
  };
  var self = this;
  var strokeWidth = 1;
  var protractor = undefined;
  var shape = undefined;
  var text = undefined;
  var arc = undefined;
  var group = [];
  var first = undefined;
  var center = undefined;
  var last = undefined;

  this.measureAngle = function () {
    self.type = VP.DrawingType.angle;
    self.action = actions.NEW;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
    init();
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.LINE === self.action) {
      center = this.getCurrentPt();
      updateLine(center);
    } else if (actions.ANGLE === self.action) {
      last = this.getCurrentPt();
      updateAngle(last);
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      first = this.getCurrentPt();
      newShape(first);
      self.action = actions.LINE;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.LINE === self.action) {
      center = this.getCurrentPt();
      addPoint(center);
      createProtractor(center);
      self.action = actions.ANGLE;
    } else if (actions.ANGLE === self.action) {
      completeDrawing();
      self.action = actions.NEW;
      self.updateHistory();
      init();
      viewer.broadcast('draw:dragging', false);
    }
  }; // context menu handler


  this.contextmenu = function (e) {
    cancelDrawing();
    self.action = actions.NEW;
    init();
  };

  function init() {
    shape = undefined;
    text = undefined;
    arc = undefined;
    group = [];
    first = undefined;
    center = undefined;
    last = undefined;
  }

  function newShape(pointer) {
    shape = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
      strokeWidth: strokeWidth,
      fill: 'black',
      stroke: 'black',
      originX: 'center',
      originY: 'center'
    });
    shape.snapDisabled = true;
    self.canvas.add(shape);
    self.setCurrentObject(shape);
    group.push(shape);
  }

  function addPoint(pointer) {
    shape = new fabric.Line([shape.x2, shape.y2, pointer.x, pointer.y], {
      strokeWidth: strokeWidth,
      fill: 'black',
      stroke: 'black',
      originX: 'center',
      originY: 'center',
      selectable: false
    });
    shape.snapDisabled = true;
    self.canvas.add(shape);
    self.setCurrentObject(shape);
    self.canvas.renderAll();
    group.push(shape);
  }

  function updateLine(pointer) {
    shape.set({
      x2: pointer.x,
      y2: pointer.y
    });
    self.canvas.renderAll();
  }

  function updateAngle(pointer) {
    shape.set({
      x2: pointer.x,
      y2: pointer.y
    });
    var v1 = {
      x: first.x - center.x,
      y: first.y - center.y
    };
    var v2 = {
      x: last.x - center.x,
      y: last.y - center.y
    };
    var angle1 = self.angle1(v1);
    var angle2 = self.angle1(v2);
    var angle = (360 - Math.round((angle2 - angle1) * 180 / Math.PI)) % 360;
    var radius = Math.min(self.distance(v1), self.distance(v2), 20);
    radius = radius * strokeWidth;

    if (arc) {
      arc.set('radius', radius);
      arc.set('endAngle', Math.PI / 2 - angle2);
    } else {
      arc = new fabric.Circle({
        radius: radius,
        left: center.x,
        top: center.y,
        startAngle: Math.PI / 2 - angle1,
        endAngle: Math.PI / 2 - angle2,
        stroke: 'black',
        strokeWidth: strokeWidth,
        fill: '',
        originX: 'center',
        originY: 'center',
        selectable: false
      });
      arc.snapDisabled = true;
      self.canvas.add(arc);
    }

    var midAngle = Math.PI / 2 - (angle1 + angle2) / 2;
    var textPos = {
      x: center.x + Math.cos(midAngle) * 40 * strokeWidth,
      y: center.y + Math.sin(midAngle) * 40 * strokeWidth
    };
    var angleText;

    if (viewer.inputMethod === 'eu') {
      angleText = ExtUtils.comma2decimal(angle, 2);
    } else {
      angleText = ExtUtils.roundNumber(angle, 2);
    }

    var fonts = VPUtils.getFontSizeFromStroke(strokeWidth);

    if (text) {
      text.set({
        left: textPos.x,
        top: textPos.y,
        text: angleText + "°"
      });
    } else {
      text = self.newText(textPos, angleText + "°");
      text.set({
        fontSize: fonts.fontSize,
        fontWeight: fonts.fontWeight,
        strokeWidth: strokeWidth
      });
      text.snapDisabled = true;
      self.canvas.add(text);
    }

    self.canvas.renderAll();
  }

  function completeDrawing() {
    for (var i in group) {
      self.canvas.remove(group[i]);
    }

    self.canvas.remove(arc);
    self.canvas.remove(text);
    self.canvas.remove(protractor);

    if (!text || !arc) {
      return;
    }

    group.push(text);
    group.push(arc);
    var angleShape = new fabric.Group(group, {});
    self.addObject(angleShape, true, false);
    angleShape.set({
      hasControls: false,
      hasBorders: false,
      lockMovementX: true,
      lockMovementY: true
    });

    if (angleShape.info) {
      angleShape.info.isMeasureShape = true;
    }

    self.setCurrentObject(false);
    self.canvas.renderAll();
    group = [];
    self.action = actions.NEW;
    self.updateHistory();
  }

  function cancelDrawing() {
    for (var i in group) {
      self.canvas.remove(group[i]);
    }

    if (text) {
      self.canvas.remove(text);
      text = undefined;
    }

    if (arc) {
      self.canvas.remove(arc);
      arc = undefined;
    }

    if (protractor) {
      self.canvas.remove(protractor);
      protractor = undefined;
    }
  }

  function createProtractor(pointer) {
    fabric.Image.fromURL('/assets/images/cgviewer/bim/measure/protractor_blue.png', function (image) {
      image.set({
        id: 'image',
        left: pointer.x,
        top: pointer.y,
        originX: 'center',
        originY: 'center',
        hasControls: false,
        hasBorders: false,
        selectable: false
      });
      image.scaleToWidth(120, false);
      image.scaleToHeight(120, false);
      protractor = image;
      self.canvas.add(image);
      self.render();
    }.bind(this), {
      crossOrigin: 'anonymous'
    });
  }
}


"use strict";

function VPAreaMeasurer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.area);
  var actions = {
    NONE: 0,
    NEW: 1
  };
  var self = this;
  var text, shape;
  var lastPos;

  this.measureArea = function () {
    self.type = VP.DrawingType.area;
    self.action = actions.NEW;
    self.canvas.isDrawingMode = false;
    self.setCursor('crosshair');
  };

  this.mousedown = function (e) {};

  this.mousemove = function (e) {};

  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      shape = e.target;
      if (!shape) return;
      var type = shape.type;

      if (type === 'group' && shape.info) {
        type = shape.info.type;
      }

      if (type === 'line' || type === 'arrowline') return;

      if (shape && shape.info && !shape.info.backgroundImage && !shape.isMeasureShape) {
        lastPos = this.getCurrentPt();
        newMeasure(shape);
        self.updateHistory();
        viewer.broadcast('draw:dragging', false);
      }
    }
  };

  function newMeasure(shape) {
    var scale = viewer.calibration;
    var scaleX = shape.scaleX ? shape.scaleX : 1;
    var scaleY = shape.scaleY ? shape.scaleY : 1;
    var area = ExtUtils.roundNumber(VPUtils.area(shape) * scale * scale * scaleX * scaleY, 4);

    if (area === 0) {
      var width = (shape.width + shape.strokeWidth) * scale * scaleX;
      var height = (shape.height + shape.strokeWidth) * scale * scaleY;
      area = width * height;
    }

    if (viewer.inputMethod === 'eu') {
      area = ExtUtils.comma2decimal(area, 4);
    } else {
      area = ExtUtils.roundNumber(area, 4);
    }

    var stringOfArea = area + 'm²';
    text = self.newText({
      x: lastPos.x,
      y: lastPos.y
    }, stringOfArea);

    if (!shape.dimensionShapes) {
      shape.dimensionShapes = [];
    }

    shape.dimensionShapes.push(text);
    shape.isShowDim = true;
    text.set({
      fill: '#414141',
      hasControls: false,
      hasBorders: false,
      lockMovementX: true,
      lockMovementY: true
    });
    self.addObject(text, true, false);

    if (text.info) {
      text.info.isMeasureShape = true;
    }

    text.isMeasureShape = true;
  }
}


"use strict";

function VPCalibrator(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.calibrator);
  var actions = {
    NONE: 0,
    NEW: 1,
    DRAW: 2
  };
  var self = this;
  var strokeWidth = 1;
  var line = undefined;
  var first = undefined;
  var distance = 0;

  this.newCalibrator = function () {
    self.type = VP.DrawingType.calibrator;
    self.action = actions.NEW;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  }; // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.DRAW === self.action) {
      updateLine(this.getCurrentPt());
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      first = this.getCurrentPt();
      newShape(first);
      self.action = actions.DRAW;
    } else if (actions.DRAW === self.action) {
      self.action = actions.NEW;
      self.setCurrentObject(false);
      completeDrawing();
    }
  }; // context menu handler


  this.contextmenu = function (e) {};

  function newShape(pointer) {
    line = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
      strokeWidth: strokeWidth,
      fill: 'black',
      stroke: 'black',
      strokeDashArray: [5, 5],
      originX: 'center',
      originY: 'center'
    });
    self.canvas.add(line);
    self.setCurrentObject(line);
  }

  function updateLine(pointer) {
    line.set({
      x2: pointer.x,
      y2: pointer.y
    });
    distance = ExtUtils.roundNumber(self.distanceOf(first, pointer), 2);
    self.canvas.renderAll();
  }

  function completeDrawing() {
    self.canvas.remove(line);
    line = undefined;
    self.viewer.broadcast('calibration', distance);
  }
}


"use strict";

function VPLengthMeasurer(viewer) {
  'use strict';

  VPBaseDrawer.call(this, viewer, VP.DrawerType.length);
  var actions = {
    NONE: 0,
    NEW: 1,
    DRAW: 2,
    END: 3
  };
  var self = this;
  this.arrowSize = [15, 5];
  this.fontSize = 15;
  var strokeWidth = 1;
  var line = undefined;
  var text = undefined;
  var first = undefined;
  var last = undefined;
  var endLine1 = undefined;
  var endLine2 = undefined;
  var endDash = undefined;
  var endArrowLine = undefined;
  var endArrowL = undefined;
  var endArrowR = undefined;

  this.measureLength = function () {
    self.type = VP.DrawingType.distance;
    self.action = actions.NEW;
    self.setCursor('crosshair');
    self.setCurrentObject(false);
    self.setSnapEnable(true);
  };

  function newShape(pointer) {
    line = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
      strokeWidth: strokeWidth,
      fill: 'black',
      stroke: 'black',
      strokeDashArray: [5, 5],
      originX: 'center',
      originY: 'center'
    });
    line.snapDisabled = true;
    self.canvas.add(line);
    self.setCurrentObject(line);
  }

  function updateLine(pointer) {
    line.set({
      x2: pointer.x,
      y2: pointer.y
    });
    var scale = viewer.calibration;
    var distance = self.distanceOf(first, pointer) * scale;

    if (viewer.inputMethod === 'eu') {
      distance = ExtUtils.comma2decimal(distance, 2);
    } else {
      distance = ExtUtils.roundNumber(distance, 2);
    }

    var textPos = {
      x: (pointer.x + first.x) / 2 + 10 * strokeWidth,
      y: (pointer.y + first.y) / 2 + 10 * strokeWidth
    };
    var fonts = VPUtils.getFontSizeFromStroke(strokeWidth);

    if (text) {
      var angle = Math.atan((line.y2 - line.y1) / (line.x2 - line.x1));
      text.set({
        left: textPos.x,
        top: textPos.y,
        text: distance + 'm',
        angle: angle * 180 / Math.PI
      });
    } else {
      text = self.newText(textPos, distance + 'm');
      text.set({
        fontSize: fonts.fontSize,
        fontWeight: fonts.fontWeight,
        strokeWidth: strokeWidth
      });
      text.set('backgroundColor', 'rgba(0,0,0,0)');
      text.set('selectable', false);
      text.snapDisabled = true;
      self.canvas.add(text);
    }

    self.canvas.renderAll();
  }

  function updateGuideLine(pointer) {
    if (!text || !line) return;
    var difVec = {
      x: line.x2 - line.x1,
      y: line.y2 - line.y1
    };
    var d_difVec = self.distance(difVec);
    var vdifVec = {
      x: difVec.x / d_difVec,
      y: difVec.y / d_difVec
    };
    var ndifVec = {
      x: vdifVec.y,
      y: -vdifVec.x
    };
    var difVec2 = {
      x: pointer.x - line.x2,
      y: pointer.y - line.y2
    };
    var d = difVec2.x * vdifVec.y - difVec2.y * vdifVec.x;
    var endLinePt1 = {
      x: line.x1 + ndifVec.x * d,
      y: line.y1 + ndifVec.y * d
    };
    var endLinePt2 = {
      x: line.x2 + ndifVec.x * d,
      y: line.y2 + ndifVec.y * d
    };
    var d1 = d * 0.5;

    if (Math.abs(d) > 30) {
      if (d > 0) d1 = d - 30;else d1 = d + 30;
    }

    var endArrowPt1 = {
      x: line.x1 + ndifVec.x * d1,
      y: line.y1 + ndifVec.y * d1
    };
    var endArrowPt2 = {
      x: line.x2 + ndifVec.x * d1,
      y: line.y2 + ndifVec.y * d1
    };
    var arrowSize = [];
    arrowSize.push(self.arrowSize[0] * strokeWidth);
    arrowSize.push(self.arrowSize[1] * strokeWidth);

    if (self.distance(difVec) < arrowSize[0] * 3) {
      endArrowPt2 = {
        x: line.x1 + ndifVec.x * d1,
        y: line.y1 + ndifVec.y * d1
      };
      endArrowPt1 = {
        x: line.x2 + ndifVec.x * d1,
        y: line.y2 + ndifVec.y * d1
      };
    }

    var endArrowLPoints = [];
    endArrowLPoints.push(endArrowPt1);
    endArrowLPoints.push({
      x: endArrowPt1.x + vdifVec.x * (arrowSize[0] + arrowSize[1]) + ndifVec.x * arrowSize[1],
      y: endArrowPt1.y + vdifVec.y * (arrowSize[0] + arrowSize[1]) + ndifVec.y * arrowSize[1]
    });
    endArrowLPoints.push({
      x: endArrowPt1.x + vdifVec.x * arrowSize[0],
      y: endArrowPt1.y + vdifVec.y * arrowSize[0]
    });
    endArrowLPoints.push({
      x: endArrowPt1.x + vdifVec.x * (arrowSize[0] + arrowSize[1]) - ndifVec.x * arrowSize[1],
      y: endArrowPt1.y + vdifVec.y * (arrowSize[0] + arrowSize[1]) - ndifVec.y * arrowSize[1]
    });
    var left = endArrowLPoints[0].x;
    var top = endArrowLPoints[0].y;

    for (var i = 1; i < endArrowLPoints.length; i++) {
      left = Math.min(left, endArrowLPoints[i].x);
      top = Math.min(top, endArrowLPoints[i].y);
    }

    if (endArrowL) {
      endArrowL.set({
        left: left,
        top: top
      });
    } else {
      endArrowL = new fabric.Polygon(endArrowLPoints, {
        left: left,
        top: top,
        fill: 'black',
        stroke: 'black',
        strokeWidth: strokeWidth,
        selectable: false,
        objectCaching: false,
        originX: 'left',
        originY: 'top'
      });
      endArrowL.snapDisabled = true;
      self.canvas.add(endArrowL);
    }

    var endArrowRPoints = [];
    endArrowRPoints.push(endArrowPt2);
    endArrowRPoints.push({
      x: endArrowPt2.x - vdifVec.x * (arrowSize[0] + arrowSize[1]) + ndifVec.x * arrowSize[1],
      y: endArrowPt2.y - vdifVec.y * (arrowSize[0] + arrowSize[1]) + ndifVec.y * arrowSize[1]
    });
    endArrowRPoints.push({
      x: endArrowPt2.x - vdifVec.x * arrowSize[0],
      y: endArrowPt2.y - vdifVec.y * arrowSize[0]
    });
    endArrowRPoints.push({
      x: endArrowPt2.x - vdifVec.x * (arrowSize[0] + arrowSize[1]) - ndifVec.x * arrowSize[1],
      y: endArrowPt2.y - vdifVec.y * (arrowSize[0] + arrowSize[1]) - ndifVec.y * arrowSize[1]
    });
    left = endArrowRPoints[0].x;
    top = endArrowRPoints[0].y;

    for (var _i = 1; _i < endArrowRPoints.length; _i++) {
      left = Math.min(left, endArrowRPoints[_i].x);
      top = Math.min(top, endArrowRPoints[_i].y);
    }

    if (endArrowR) {
      endArrowR.set({
        left: left,
        top: top
      });
    } else {
      endArrowR = new fabric.Polygon(endArrowRPoints, {
        left: left,
        top: top,
        fill: 'black',
        stroke: 'black',
        strokeWidth: strokeWidth,
        selectable: false,
        objectCaching: false,
        originX: 'left',
        originY: 'top'
      });
      endArrowR.snapDisabled = true;
      self.canvas.add(endArrowR);
    }

    if (endLine1) {
      endLine1.set({
        x2: endLinePt1.x,
        y2: endLinePt1.y
      });
    } else {
      endLine1 = new fabric.Line([line.x1, line.y1, endLinePt1.x, endLinePt1.y], {
        strokeWidth: strokeWidth,
        fill: 'black',
        stroke: 'black',
        originX: 'center',
        originY: 'center'
      });
      endLine1.snapDisabled = true;
      self.canvas.add(endLine1);
    }

    if (endLine2) {
      endLine2.set({
        x2: endLinePt2.x,
        y2: endLinePt2.y
      });
    } else {
      endLine2 = new fabric.Line([line.x2, line.y2, endLinePt2.x, endLinePt2.y], {
        strokeWidth: strokeWidth,
        fill: 'black',
        stroke: 'black',
        originX: 'center',
        originY: 'center'
      });
      endLine2.snapDisabled = true;
      self.canvas.add(endLine2);
    }

    if (endDash) {
      endDash.set({
        x1: endLinePt1.x,
        y1: endLinePt1.y,
        x2: endLinePt2.x,
        y2: endLinePt2.y
      });
    } else {
      endDash = new fabric.Line([endLinePt1.x, endLinePt1.y, endLinePt2.x, endLinePt2.y], {
        strokeWidth: strokeWidth,
        fill: 'black',
        stroke: 'black',
        strokeDashArray: [5, 5],
        originX: 'center',
        originY: 'center'
      });
      endDash.snapDisabled = true;
      self.canvas.add(endDash);
    }

    if (endArrowLine) {
      endArrowLine.set({
        x1: endArrowPt1.x,
        y1: endArrowPt1.y,
        x2: endArrowPt2.x,
        y2: endArrowPt2.y
      });
    } else {
      endArrowLine = new fabric.Line([endArrowPt1.x, endArrowPt1.y, endArrowPt2.x, endArrowPt2.y], {
        strokeWidth: strokeWidth,
        fill: 'black',
        stroke: 'black',
        strokeDashArray: [5, 5],
        originX: 'center',
        originY: 'center'
      });
      endArrowLine.snapDisabled = true;
      self.canvas.add(endArrowLine);
    }

    text.set({
      left: (endLinePt1.x + endLinePt2.x) * 0.5,
      top: (endLinePt1.y + endLinePt2.y) * 0.5
    });
    text.bringToFront();
    self.setCurrentObject(endDash);
    self.canvas.renderAll();
  }

  function finishDrawing() {
    self.canvas.remove(line);
    self.canvas.remove(text);
    self.canvas.remove(endLine1);
    self.canvas.remove(endLine2);
    self.canvas.remove(endDash);
    self.canvas.remove(endArrowLine);
    self.canvas.remove(endArrowL);
    self.canvas.remove(endArrowR);
    var lengthShape = new fabric.Group([line, endLine1, endLine2, endDash, endArrowLine, endArrowL, endArrowR, text], {});
    lengthShape.on('selected', function () {
      lengthShape.set({
        stroke: 'blue'
      });
      self.canvas.renderAll();
    });
    lengthShape.on('deselected', function () {
      lengthShape.set({
        stroke: 'black'
      });
      self.canvas.renderAll();
    });
    lengthShape.set({
      hasControls: false,
      hasBorders: false,
      lockMovementX: true,
      lockMovementY: true
    });
    self.addObject(lengthShape, true, false);

    if (lengthShape.info) {
      lengthShape.info.isMeasureShape = true;
    }

    self.setCurrentObject(false);
    self.canvas.renderAll();
    self.updateHistory();
    line = undefined;
    text = undefined;
    endLine1 = undefined;
    endLine2 = undefined;
    endDash = undefined;
    endArrowLine = undefined;
    endArrowL = undefined;
    endArrowR = undefined;
  } // mouse down handler


  this.mousedown = function (e) {}; // mouse move handler


  this.mousemove = function (e) {
    if (actions.DRAW === self.action) {
      last = this.getCurrentPt();

      if (this.keyStatus && this.keyStatus === 'shortcut:shift') {
        last = VPUtils.getStraightLine2d(first, last);
      }

      updateLine(last);
    } else if (actions.END === self.action) {
      last = this.getCurrentPt(); // if (this.keyStatus && this.keyStatus == 'shortcut:shift') {
      //   last = VPUtils.getStraightLine2d(first, last);
      // }

      updateGuideLine(last);
    }
  }; // mouse up handler


  this.mouseup = function (e) {
    if (actions.NEW === self.action) {
      first = this.getCurrentPt();
      newShape(first);
      self.action = actions.DRAW;
      viewer.broadcast('draw:dragging', true);
    } else if (actions.DRAW === self.action) {
      self.action = actions.END;
    } else if (actions.END === self.action) {
      self.action = actions.NEW;
      finishDrawing();
      viewer.broadcast('draw:dragging', false);
    }
  }; // context menu handler


  this.contextmenu = function (e) {
    self.action = actions.NEW;
  };
}


"use strict";

(function () {
  'use strict';

  angular.module('app', ['app.core', 'pascalprecht.translate', 'tmh.dynamicLocale', 'app.mail', 'ngFileSaver', 'app.fileManage', 'app.settings']);
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeVatReports', {
    controller: financeVatReportsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-reports/finance-vat-report/finance-vat-reports/finance-vat-reports.view.html'
  });
  /** @ngInject */

  function financeVatReportsController($scope, globals, apiFactory, Notification, utils, $log) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    vm.reportList = [];
    vm.currentPage = 1;
    vm.numPerPage = 12;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];

    function chunk(arr, size) {
      var newArr = [];

      for (var i = 0; i < arr.length; i += size) {
        newArr.push(arr.slice(i, i + size));
      }

      return newArr;
    }

    function fetchData() {
      $scope.loading = true;
      apiFactory.listVatReports({
        page: vm.currentPage,
        chunk: vm.numPerPage
      }).then(function (res) {
        $scope.loading = false;
        vm.reportList = res.data.list;
        vm.totalCount = res.data.totalCount;
        $scope.noOfPages = Math.ceil(vm.totalCount / vm.numPerPage);
        $scope.chunkedReportList = chunk(vm.reportList, 2);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    fetchData();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchData();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeCreateVatReport', {
    controller: financeCreateVatReportController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-reports/finance-vat-report/finance-create-vat-report/finance-create-vat-report.view.html'
  });
  /** @ngInject */

  function financeCreateVatReportController(globals, $scope, apiFactory, utils, Notification, $log, $state, $stateParams) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.companyData = globals.companyStore.get();
    vm.vatReport = {
      incomes: [],
      deductions: [],
      startDate: new Date(),
      endDate: new Date(),
      sum: {
        income: 0,
        deduction: 0
      }
    };
    vm.income = {};
    vm.deduction = {};
    vm.vatReportId = $stateParams.id;

    function calcSum() {
      vm.vatReport.sum.income = vm.vatReport.incomes.map(function (x) {
        return x.vatAmount;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0);
      vm.vatReport.sum.income += utils.num(vm.income.vatAmount);
      vm.vatReport.sum.deduction = utils.isEmpty(vm.vatReport.deductions) ? 0 : vm.vatReport.deductions.map(function (x) {
        return x.vatAmount;
      }).reduce(function (acc, val) {
        return acc + val;
      });
      vm.vatReport.sum.deduction += utils.num(vm.deduction.vatAmount);
      vm.vatReport.sum.diff = vm.vatReport.sum.income + vm.vatReport.sum.deduction;
    }

    $scope.changeVatAccount = function () {
      $scope.changeIncomeVatAccount();
      $scope.changeDeductionVatAccount();
    };

    $scope.changeIncomeVatAccount = function () {
      var accountPlanId = vm.income.vatAccount;
      var startDate = new Date(vm.vatReport.startDate);
      var endDate = new Date(vm.vatReport.endDate);
      var fromDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0, 0);
      var toDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 999);

      if (angular.isDefined(accountPlanId)) {
        var query = {
          accountPlanId: accountPlanId,
          fromDate: fromDate,
          toDate: toDate
        };
        $scope.loading = true;
        apiFactory.getAccountPlanBalance(query).then(function (res) {
          $scope.loading = false;
          vm.income.vatAmount = res.data.data;
          calcSum();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }
    };

    $scope.changeDeductionVatAccount = function () {
      var accountPlanId = vm.deduction.vatAccount;
      var startDate = new Date(vm.vatReport.startDate);
      var endDate = new Date(vm.vatReport.endDate);
      var fromDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0, 0);
      var toDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 999);

      if (angular.isDefined(accountPlanId)) {
        var query = {
          accountPlanId: accountPlanId,
          fromDate: fromDate,
          toDate: toDate
        };
        $scope.loading = true;
        apiFactory.getAccountPlanBalance(query).then(function (res) {
          $scope.loading = false;
          vm.deduction.vatAmount = res.data.data;
          calcSum();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }
    };

    $scope.addIncome = function () {
      if (!vm.income.vatAccount) {
        Notification.error("Please select VAT Account");
        return;
      }

      vm.vatReport.incomes.push(vm.income);
      vm.income = {};
      calcSum();
    };

    $scope.removeIncome = function (index) {
      vm.vatReport.incomes.splice(index, 1);
      calcSum();
    };

    $scope.addDeduction = function () {
      if (!vm.deduction.vatAccount) {
        Notification.error("Please select VAT Account");
        return;
      }

      vm.vatReport.deductions.push(vm.deduction);
      vm.deduction = {};
      calcSum();
    };

    $scope.removeDeduction = function (index) {
      vm.vatReport.deductions.splice(index, 1);
      calcSum();
    };

    $scope.vatAccountName = function (accountPlanId) {
      var accountPlan = vm.accountPlans.find(function (x) {
        return x._id === accountPlanId;
      });

      if (!accountPlan) {
        return '&nbsp;';
      }

      return accountPlan.name;
    };

    $scope.vatAccountNumber = function (accountPlanId) {
      var accountPlan = vm.accountPlans.find(function (x) {
        return x._id === accountPlanId;
      });

      if (!accountPlan) {
        return '&nbsp;';
      }

      return accountPlan.number;
    };

    $scope.createVatReport = function () {
      if (utils.isEmpty(vm.vatReport.incomes) && !vm.income.vatAccount) {
        Notification.error('Please add Income');
        return;
      }

      if (utils.isEmpty(vm.vatReport.deductions) && !vm.deduction.vatAccount) {
        Notification.error('Please add Deduction');
        return;
      }

      if (utils.isEmpty(vm.vatReport.startDate)) {
        Notification.error('Please select Start of Period');
        return;
      }

      if (utils.isEmpty(vm.vatReport.endDate)) {
        Notification.error('Please select End of Period');
        return;
      }

      if (vm.income.vatAccount) {
        vm.vatReport.incomes.push(vm.income);
      }

      if (vm.deduction.vatAccount) {
        vm.vatReport.deductions.push(vm.deduction);
      }

      var promise = vm.vatReportId ? apiFactory.updateVatReport(vm.vatReportId, vm.vatReport) : apiFactory.createVatReport(vm.vatReport);
      $scope.loading = true;
      promise.then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        $state.go('financeVatReports');
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(err);
      });
    };

    function init() {
      var today = new Date();
      vm.vatReport.startDate = new Date(today.getFullYear(), 0, 1);
      vm.vatReport.endDate = new Date(today.getFullYear(), 11, 31);
      var promises = [apiFactory.listAccountPlans()];

      if (vm.vatReportId) {
        promises.push(apiFactory.getVatReport(vm.vatReportId));
      }

      $scope.loading = true;
      Promise.all(promises).then(function (res) {
        $scope.loading = false;
        vm.accountPlans = res[0].data.list;
        vm.accountPlans = vm.accountPlans.map(function (x) {
          x.label = x.number + ' - ' + x.name;
          return x;
        });

        if (vm.vatReportId) {
          vm.vatReport = res[1].data;
          vm.vatReport.startDate = new Date(vm.vatReport.startDate);
          vm.vatReport.endDate = new Date(vm.vatReport.endDate);
        }

        calcSum();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    init();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeDebitReports', {
    controller: financeDebitReportsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-reports/finance-debit-report/finance-debit-reports/finance-debit-reports.view.html'
  });
  /** @ngInject */

  function financeDebitReportsController($scope, globals, apiFactory, Notification, utils, $log, $uibModal, $filter, FileSaver) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    vm.currentPage = 1;
    vm.numPerPage = 12;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.sortOptions = [{
      label: 'Cust. ID#',
      value: 'vendorTag'
    }, {
      label: 'Client Name',
      value: 'vendorName'
    }, {
      label: 'Before',
      value: 'before'
    }, {
      label: 'Balance',
      value: 'balance'
    }, {
      label: 'Export Doc.',
      value: 'Export Doc.',
      iconUrl: '/assets/icons/export-black.svg'
    }, {
      label: 'Refresh',
      value: 'Refresh',
      iconUrl: '/assets/icons/cash-black.svg'
    }];
    $scope.financialYear = undefined;
    $scope.month = -1;

    $scope.dateFilterChanged = function () {
      if ($scope.loading) return;
      var fromDate = new Date(Date.UTC(vm.fromDate.getFullYear(), vm.fromDate.getMonth(), vm.fromDate.getDate()));
      var toDate = new Date(Date.UTC(vm.toDate.getFullYear(), vm.toDate.getMonth(), vm.toDate.getDate(), 23, 59, 59, 999));
      vm.currentPage = 1;
      $scope.fetchData(fromDate, toDate);
    };

    $scope.changeSortOption = function (val) {
      if (val === 'Export Doc.') {
        $scope.exportReport();
      } else if (val === 'Refresh') {
        $scope.fetchData();
      } else {
        $scope.sortOption = val;
        $scope.fetchData();
      }
    };

    $scope.searchData = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      vm.fromDate = new Date(vm.fromDate.getTime() - vm.fromDate.getTimezoneOffset() * 60 * 1000);
      vm.toDate = new Date(vm.toDate.getTime() - vm.toDate.getTimezoneOffset() * 60 * 1000);
      var fromDate = vm.fromDate;
      var toDate = vm.toDate;
      if (s) fromDate = s;
      if (e) toDate = e;
      $scope.loading = true;
      apiFactory.fetchDebitReports({
        fromDate: fromDate,
        toDate: toDate,
        search: $scope.searchText,
        page: vm.currentPage,
        chunk: vm.numPerPage,
        sort: $scope.sortOption
      }).then(function (res) {
        $scope.loading = false;
        vm.totalCount = res.data.total;
        $scope.reports = res.data.list;
        $scope.noOfPages = Math.ceil(vm.totalCount / vm.numPerPage);
        $scope.totalBeforeAmount = res.data.totalBeforeAmount;
        $scope.totalDays30Amount = res.data.totalDays30Amount;
        $scope.totalDays60Amount = res.data.totalDays60Amount;
        $scope.totalDays90Amount = res.data.totalDays90Amount;
        $scope.totalDaysAfterAmount = res.data.totalDaysAfterAmount;
        $scope.totalRemainingAmount = res.data.totalRemainingAmount;
        $scope.totalBankPostAmount = res.data.totalBankPostAmount;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error('Failed to get debit reports');
      });
    };

    vm.fromDate = new Date('2020-01-02');
    vm.toDate = new Date();
    $scope.fetchData();

    $scope.exportReport = function () {
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.toLowerCase().includes('.xlsx') || result.toLowerCase().includes('.xls') ? result : result + '.xlsx';
        $scope.loading = true;
        apiFactory.exportDebitReports({
          fileName: fileName,
          search: $scope.searchText,
          sort: $scope.sortOption
        }).then(function (res) {
          $scope.loading = false;
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, fileName);
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchData();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeCreditReports', {
    controller: financeCreditReportsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-reports/finance-credit-report/finance-credit-reports/finance-credit-reports.view.html'
  });
  /** @ngInject */

  function financeCreditReportsController($scope, globals, apiFactory, Notification, utils, $log, $uibModal, $filter, FileSaver) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    vm.currentPage = 1;
    vm.numPerPage = 12;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.sortOptions = [{
      label: 'Cust. ID#',
      value: 'vendorTag'
    }, {
      label: 'Client Name',
      value: 'vendorName'
    }, {
      label: 'Before',
      value: 'before'
    }, {
      label: 'Balance',
      value: 'balance'
    }, {
      label: 'Export Doc.',
      value: 'Export Doc.',
      iconUrl: '/assets/icons/export-black.svg'
    }, {
      label: 'Refresh',
      value: 'Refresh',
      iconUrl: '/assets/icons/cash-black.svg'
    }];
    $scope.financialYear = undefined;
    $scope.month = -1;

    $scope.dateFilterChanged = function () {
      if ($scope.loading) return;
      var fromDate = new Date(Date.UTC(vm.fromDate.getFullYear(), vm.fromDate.getMonth(), vm.fromDate.getDate()));
      var toDate = new Date(Date.UTC(vm.toDate.getFullYear(), vm.toDate.getMonth(), vm.toDate.getDate(), 23, 59, 59, 999));
      vm.currentPage = 1;
      $scope.fetchData(fromDate, toDate);
    };

    $scope.changeSortOption = function (val) {
      if (val === 'Export Doc.') {
        $scope.exportReport();
      } else if (val === 'Refresh') {
        $scope.fetchData();
      } else {
        $scope.sortOption = val;
        $scope.fetchData();
      }
    };

    $scope.searchData = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      vm.fromDate = new Date(vm.fromDate.getTime() - vm.fromDate.getTimezoneOffset() * 60 * 1000);
      vm.toDate = new Date(vm.toDate.getTime() - vm.toDate.getTimezoneOffset() * 60 * 1000);
      var fromDate = vm.fromDate;
      var toDate = vm.toDate;
      if (s) fromDate = s;
      if (e) toDate = e;
      $scope.loading = true;
      apiFactory.fetchCreditReports({
        fromDate: fromDate,
        toDate: toDate,
        search: $scope.searchText,
        page: vm.currentPage,
        chunk: vm.numPerPage,
        sort: $scope.sortOption,
        sortType: -1
      }).then(function (res) {
        $scope.loading = false;
        vm.totalCount = res.data.total;
        $scope.reports = res.data.list;
        $scope.noOfPages = Math.ceil(vm.totalCount / vm.numPerPage);
        $scope.totalBeforeAmount = res.data.totalBeforeAmount;
        $scope.totalDays30Amount = res.data.totalDays30Amount;
        $scope.totalDays60Amount = res.data.totalDays60Amount;
        $scope.totalDays90Amount = res.data.totalDays90Amount;
        $scope.totalDaysAfterAmount = res.data.totalDaysAfterAmount;
        $scope.totalRemainingAmount = res.data.totalRemainingAmount;
        $scope.totalBankPostAmount = res.data.totalBankPostAmount;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error('Failed to get credit reports');
      });
    };

    vm.fromDate = new Date('2020-01-02');
    vm.toDate = new Date();
    $scope.fetchData();

    $scope.exportReport = function () {
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.toLowerCase().includes('.xlsx') || result.toLowerCase().includes('.xls') ? result : result + '.xlsx';
        $scope.loading = true;
        apiFactory.exportCreditReports({
          fileName: fileName,
          search: $scope.searchText,
          sort: $scope.sortOption
        }).then(function (res) {
          $scope.loading = false;
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, fileName);
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchData();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').directive('vendorCredits', vendorCredits);

  function vendorCredits(ecoFactory, utils, globals, $log, apiFactory, Notification, $state, $timeout, pdfFactory, $document, $rootScope, $uibModal, $window) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/economic/bill/directives/vendorCredit/vendorCredits.view.html',
      replace: true,
      scope: {
        ngModel: "=",
        up: "=",
        memoList: '=',
        memo: '=',
        currentMemoIndex: '='
      },
      link: function link(scope) {
        var companyStore = globals.companyStore,
            projectStore = globals.projectStore,
            userStore = globals.userStore;
        var CANVAS_HEIGHT = 542 * $rootScope.scale;
        var CANVAS_SCALE_MUTIPLER = 2;
        scope.companyData = companyStore.get();
        scope.project = projectStore.get();
        scope.userData = userStore.get();
        scope.vendors = [];
        scope.projects = [];
        scope.currentVendorId = null;
        scope.billingGroups = [];
        scope.vaOrderList = []; // scope.memoList = [];

        scope.economicTypeList = []; // scope.memoList = [];

        scope.numPages = 0;
        scope.currentPageNum = 1; // scope.memo = null;
        // scope.currentMemoIndex = 0;

        scope.canvas = $document[0].getElementById("the-canvas");

        scope.init = function () {
          var promises = [apiFactory.listAllVariationOrders({
            projectId: scope.project._id,
            status: 'approved',
            isBill: false
          }), apiFactory.getAllMaterialGroup(), apiFactory.getAllEquipmentGroup(), apiFactory.getBillAccountPlans(), // apiFactory.listAllPendingBills({ projectId: scope.project._id })
          apiFactory.listAllOngoingProjects(), apiFactory.listAllClients(), apiFactory.getAllSubcontractors(), apiFactory.getAllSuppliers()];
          Promise.all(promises).then(function (resp) {
            scope.vaOrderList = resp[0].data.list;
            var materialGroup = resp[1].data.data;
            var equipmentGroup = resp[2].data.data;
            equipmentGroup.forEach(function (item) {
              return item.groupType = 'eq';
            });
            scope.billingGroups = materialGroup.concat(equipmentGroup);
            scope.modelReady = true;
            scope.economicTypeList = resp[3].data.data;
            scope.economicTypeList.forEach(function (x) {
              x.name = x.name + ' - ' + x.number;
            });
            scope.numPages = scope.memoList.length;
            scope.currentPageNum = 1; // scope.currentMemoIndex = 0;

            showBilling(scope.memo);
            scope.currentVendorId = scope.memo.vendor._id;
            scope.projects = resp[4].data.list.map(function (item) {
              return {
                projectName: "".concat(item.projectName, " - ").concat(item.systemTag),
                _id: item._id,
                systemTag: item.systemTag
              };
            });
            scope.projects.unshift({
              _id: 'other-cost',
              projectName: 'Other Cost'
            });
            var clients = resp[5].data.list;
            var subcontractors = resp[6].data.list;
            var suppliers = resp[7].data.list;
            var i;

            for (i = 0; i < clients.length; i++) {
              clients[i].displayName = 'Client - ' + clients[i].clientName;
              scope.vendors.push(clients[i]);
            }

            for (i = 0; i < suppliers.length; i++) {
              suppliers[i].displayName = 'Supplier - ' + suppliers[i].name;
              scope.vendors.push(suppliers[i]);
            }

            for (i = 0; i < subcontractors.length; i++) {
              subcontractors[i].displayName = 'Subcontractor - ' + subcontractors[i].name;
              scope.vendors.push(subcontractors[i]);
            }

            scope.isLoading = false;
          })["catch"](function (err) {
            scope.isLoading = false;
            $log.error(err);

            if (err.status === 403) {
              Notification.error(err.data.message);
              $state.go(globals.getDashboardRoute(scope.userData));
            } else {
              Notification.error(utils.getErrorMessage(err, "No data to show, please upload bill pdf first."));
            }
          });
        };

        scope.onChangeVendor = function (data) {
          scope.memo.vendor = scope.vendors.find(function (x) {
            return x._id == data;
          });
          $log.log(scope.memo.vendor);
          scope.currentVendorId = data;
          getVendorDetails(scope.memo);
          scope.$apply();
        };

        scope.onEditItem = function (item) {
          item.editMode = true;
          scope.editingSupply = angular.copy(item);
        };

        scope.onCancelEditItem = function (item) {
          item.editMode = false;
          scope.editingSupply = {};

          if (item.addMode) {
            scope.memo.customSupplierData.supplies.splice(scope.memo.customSupplierData.supplies.length - 1, 1);
          }

          _calculatePrices(scope.memo);
        };

        scope.onAddItem = function () {
          $log.log(scope.memo);

          if (utils.isEmpty(scope.memo.customSupplierData)) {
            resetCalcResult(scope.memo);
          }

          var find = scope.memo.customSupplierData.supplies.find(function (elem) {
            return elem.editMode == true;
          });

          if (find) {
            Notification.error("Please save editing item before adding");
            return;
          }

          scope.memo.customSupplierData.supplies.push({
            addMode: true
          });
          scope.onEditItem(scope.memo.customSupplierData.supplies[scope.memo.customSupplierData.supplies.length - 1]);
        };

        scope.onCheckEditing = function (index) {
          var supply = scope.memo.customSupplierData.supplies[index];

          if (supply.saveMode == true) {
            return;
          } // if (scope.isNormalType(scope.memo)) {


          if (utils.isEmpty(scope.editingSupply.description) || utils.isEmpty(scope.editingSupply.qty) || utils.isEmpty(scope.editingSupply.unitprice)) {
            Notification.error('Please input correct value');
            return;
          }

          supply.saveMode = true;
          supply.description = scope.editingSupply.description;
          supply.qty = scope.editingSupply.qty;
          supply.unitprice = scope.editingSupply.unitprice; // } else {
          //   if (
          //     utils.isEmpty(scope.editingSupply.description) ||
          //     utils.isEmpty(scope.editingSupply.qty)
          //   ) {
          //     Notification.error('Please input correct value');
          //     return;
          //   }
          //   supply.saveMode = true;
          //   supply.description = scope.editingSupply.description;
          //   supply.qty = scope.editingSupply.qty;
          // }

          scope.saveBillingData(scope.memo, index);
        };

        scope.onRemoveItem = function (index) {
          if (scope.memo.customSupplierData.supplies[index].saveMode == true) return;
          scope.memo.customSupplierData.supplies[index].saveMode = true;
          scope.saveBillingData(scope.memo, index, true);
        };

        scope.changedQtyAndUPrice = function (item) {
          // if (!scope.isNormalType(scope.memo)) {
          //   return;
          // }
          item.price = item.qty * item.unitprice;
          scope.memo.amountWithoutTax = 0;
          scope.memo.taxAmount = 0;
          scope.memo.totalAmount = 0;
          scope.memo.customSupplierData.supplies.filter(function (x) {
            return !x.editMode && !x.addMode;
          }).forEach(function (supply) {
            var price = supply.price;

            if (angular.isDefined(price) && price !== null) {
              var priceValue = Number(price);

              if (priceValue) {
                supply.vat = priceValue * utils.num(scope.vendorDetail.vat) / 100.0;
                supply.total = supply.vat + priceValue;
              }

              scope.memo.amountWithoutTax += priceValue;
              scope.memo.taxAmount += supply.vat;
              scope.memo.totalAmount += supply.total;
            }
          });

          if (!utils.isEmpty(scope.editingSupply) && !utils.isEmpty(scope.editingSupply.qty) && !utils.isEmpty(scope.editingSupply.unitprice)) {
            var price = scope.editingSupply.qty * scope.editingSupply.unitprice;
            scope.editingSupply.price = price;
            scope.editingSupply.vat = price * utils.num(scope.vendorDetail.vat) / 100.0;
            scope.editingSupply.total = scope.editingSupply.vat + price;
            item.description = scope.editingSupply.description;
            item.qty = scope.editingSupply.qty;
            item.unitprice = scope.editingSupply.unitprice;
            item.price = scope.editingSupply.price;
            item.vat = scope.editingSupply.vat;
            item.total = scope.editingSupply.total;
            scope.memo.amountWithoutTax += price;
            scope.memo.taxAmount += scope.editingSupply.vat;
            scope.memo.totalAmount += scope.editingSupply.total;
          }
        };

        scope.editAmountWithoutTax = function () {
          scope.memo.editMode = true;

          if (angular.isUndefined(scope.memo.amountWithoutTaxTemp)) {
            scope.memo.amountWithoutTaxTemp = scope.memo.amountWithoutTax;
          }
        };

        scope.updateAmountWithoutTax = function () {
          scope.memo.editMode = false;
          updateBillingTotalValues();
        };

        scope.changeAmountWithoutTax = function () {
          scope.memo.amountWithoutTax = scope.memo.amountWithoutTaxTemp;
          scope.memo.taxAmount = scope.memo.amountWithoutTax * utils.num(scope.vendorDetail.vat) / 100.0;
          scope.memo.totalAmount = scope.memo.amountWithoutTax + scope.memo.taxAmount;
        };

        scope.cancelAmountWithoutTax = function () {
          scope.memo.editMode = false;
          scope.memo.amountWithoutTaxTemp = scope.memo.amountWithoutTax;
          scope.memo.taxAmount = scope.memo.amountWithoutTax * utils.num(scope.vendorDetail.vat) / 100.0;
          scope.memo.totalAmount = scope.memo.amountWithoutTax + scope.memo.taxAmount;
        }; // scope.isNormalType = (billing) => {
        //   return true;
        //   if (!billing) {
        //     return true;
        //   }
        //   let template = billing.templateId;
        //   if (!template || !template.templateType) {
        //     return true;
        //   }
        //   return template.templateType.includes('normal');
        // }


        scope.getVat = function (billing) {
          var accountPlan = undefined;

          if (billing.billType && angular.isObject(billing.billType)) {
            accountPlan = billing.billType;
          } else {
            accountPlan = scope.economicTypeList.find(function (x) {
              return x._id === billing.billType;
            });
          }

          if (accountPlan && angular.isDefined(accountPlan.vat)) {
            return accountPlan.vat;
          }

          return billing && billing.vendor && billing.vendor.paymentTerms && billing.vendor.paymentTerms.vatPercent ? billing.vendor.paymentTerms.vatPercent : 0;
        };

        scope.getVatNumber = function (billing) {
          var vatNumber;

          if (billing && billing.vendor) {
            if (billing.vendor.paymentTerms) {
              vatNumber = billing.vendor.paymentTerms.vatNumber;
            }
          }

          return vatNumber;
        };

        scope.selEconomicTypeId = function (economicType) {
          scope.memo.billType = economicType;
          scope.vendorDetail.vat = scope.getVat(scope.memo);
          calculatePrices(scope.memo);
        };

        scope.selBillingGroupId = function (billingGroupId) {
          for (var i = 0; i < scope.billingGroups.length; i++) {
            if (scope.billingGroups[i]._id === billingGroupId) {
              scope.memo.group = scope.billingGroups[i];
            }
          }
        };

        scope.selBillingVAOrderId = function (billingVAOrderId) {
          if (scope.vaOrderList) {
            for (var i = 0; i < scope.vaOrderList.length; i++) {
              if (scope.vaOrderList[i]._id === billingVAOrderId) {
                var vaOrder = scope.vaOrderList[i];
                scope.memo.vaOrder = vaOrder;
                scope.memo.customSupplierData = {
                  invoicenumber: vaOrder.displaySeq,
                  supplies: []
                };

                if (vaOrder.vendorType === 'Client') {
                  scope.memo.customSupplierData.address2 = scope.addressString(vaOrder.vendor.address);
                  scope.memo.customSupplierData.postalCode = vaOrder.vendor.address[0].postalCode;
                  scope.memo.customSupplierData.countryCode = vaOrder.vendor.address[0].countryCode;
                  scope.memo.customSupplierData.city = vaOrder.vendor.address[0].city;
                  scope.memo.vendor = vaOrder.vendor;
                  scope.memo.vendor.name = vaOrder.vendor.clientName;
                  scope.memo.vendor.address = scope.addressString(vaOrder.vendor.address);
                  scope.memo.vendor.contact = vaOrder.vendor.clientContact;

                  if (vaOrder.vendor.paymentTerms) {
                    scope.memo.vendor.vat = vaOrder.vendor.paymentTerms.vatPercent;
                  } else {
                    scope.memo.vendor.vat = 0;
                  }

                  scope.memo.vendor.bankDetails = angular.copy(scope.companyData.economicSettings.paymentInfo);

                  if (scope.memo.vendor.bankDetails && scope.memo.vendor.bankDetails.length > 0) {
                    scope.memo.vendor.bankDetails[0].IBAN = scope.memo.vendor.bankDetails[0].ibanNumber;
                    scope.memo.vendor.bankDetails[0].sortCode = scope.memo.vendor.bankDetails[0].swiftCode;
                  }
                } else if (vaOrder.vendorType === 'Supplier' || vaOrder.vendorType === 'Subcontractor') {
                  scope.memo.customSupplierData.address2 = scope.memo.vendor.address;
                  scope.memo.vendor = vaOrder.vendor;
                  var address = scope.memo.vendor.address || '';
                  var addresses = address.spilt(',');
                  scope.memo.customSupplierData.postalCode = addresses[2];
                  scope.memo.customSupplierData.countryCode = addresses[1];
                  scope.memo.customSupplierData.city = addresses[0];
                }

                scope.memo.bill.secure_url = vaOrder.variationOrderDoc;

                for (var _i = 0; _i < vaOrder.items.length; _i++) {
                  var item = vaOrder.items[_i];
                  scope.memo.customSupplierData.supplies.push({
                    description: item.description,
                    qty: item.quantity,
                    unitprice: item.unitPrice,
                    vat: item.vatAmount,
                    price: item.price
                  });
                }

                calculatePrices(scope.memo);
                showBilling(scope.memo);
                return;
              }
            }
          }
        };

        scope.updateBillDate = function () {
          if (scope.memo) {
            scope.memo.billDate = new Date(scope.billDate);
          }
        };

        scope.updateDueDate = function () {
          if (scope.memo) {
            scope.memo.dueDate = new Date(scope.dueDate);
          }
        };

        scope.changePageInBill = function (isNext) {
          if (isNext) {
            scope.currentPageNum += 1;

            if (scope.currentPageNum > scope.numPages) {
              scope.currentPageNum = scope.numPages;
            }
          } else {
            scope.currentPageNum -= 1;

            if (scope.currentPageNum < 1) {
              scope.currentPageNum = 1;
            }
          }

          pdfFactory.getPageFromURL(scope.memo.bill.secure_url, scope.currentPageNum).then(function (page) {
            scope.canvasPage = page;
            $timeout(function () {
              scope.$apply();
            });
            renderPage(page, scope.canvas);
          })["catch"](function (e) {
            $log.error(e);
          });
        };

        scope.downloadInvoice = function (billing) {
          scope.isDownloading = true;
          utils.downloadFile(billing.bill.secure_url, "".concat(billing.billNo, ".pdf")).then(function () {
            scope.isDownloading = false;
            $timeout(function () {
              return scope.$apply();
            });
          })["catch"](function (err) {
            scope.isDownloading = false;
            $log.error(err);
            Notification.error('Cannot download.');
          });
        };

        scope.printDocument = function () {
          $window.open(scope.memo.bill.secure_url, "_blank");
        };

        scope.deleteBilling = function () {
          $uibModal.open({
            animation: true,
            component: 'confirmModal',
            size: 'sm',
            backdrop: 'static',
            keyboard: false
          }).result.then(function () {
            apiFactory.deleteBilling(scope.memo._id).then(function () {
              Notification.success("".concat(scope.memo.billNo, " removed successfully."));
              scope.init();
            })["catch"](function (err) {
              $log.error(err);
              Notification.error("Failed to remove!");
            });
          }, function () {});
        };

        scope.changeCanvasPage = function (direction) {
          var oldIndex = scope.currentMemoIndex;

          if (direction) {
            scope.currentMemoIndex = scope.currentMemoIndex === scope.memoList.length - 1 ? scope.currentMemoIndex : scope.currentMemoIndex + 1;
          } else {
            scope.currentMemoIndex = scope.currentMemoIndex === 0 ? scope.currentMemoIndex : scope.currentMemoIndex - 1;
          }

          if (oldIndex !== scope.currentMemoIndex) {
            scope.currentPageNum = 1;
            scope.numPages = 1;
            scope.memo = scope.memoList[scope.currentMemoIndex];
            showBilling(scope.memo); // startOCRProgress(scope.memo);
          }
        };

        scope.saveBillingData = function (_billing) {
          var supplyIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
          var isDeleting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

          if (_billing && _billing.customSupplierData && _billing.customSupplierData.invoicenumber) {
            var checkData = {
              id: _billing._id,
              vendorId: _billing.vendor ? _billing.vendor._id : undefined,
              customSupplierData: _billing.customSupplierData,
              projectId: _billing.projectId && _billing.projectId._id ? _billing.projectId._id : _billing.projectId
            };
            apiFactory.checkDuplicatedBillingData(checkData).then(function (resp) {
              if (resp.data.data.isDuplicated) {
                var duplicatedModal = $uibModal.open({
                  animation: true,
                  component: 'duplicatedModal',
                  windowClass: 'dupliated-modal',
                  size: 'sm',
                  backdrop: 'static',
                  keyboard: false,
                  resolve: {
                    oldBilling: function oldBilling() {
                      return resp.data.data.item;
                    },
                    billing: function billing() {
                      return _billing;
                    }
                  }
                });
                duplicatedModal.result.then(function (result) {
                  if (result) {
                    if (result.action === 'delete') {
                      // getBillingList();
                      scope.init();
                    } else {
                      _saveBillingData(_billing, resp.data.data.item._id, supplyIndex, isDeleting);
                    }
                  }
                });
              } else {
                _saveBillingData(_billing, null, supplyIndex, isDeleting);
              }
            })["catch"](function (err) {
              $log.log(err);
            });
          } else {
            Notification.error("Data is not ready yet.");
          }
        };

        scope.zoomCanvas = function (zoomIn) {
          scope.canvasScale = zoomIn ? scope.canvasScale + 0.1 : scope.canvasScale - 0.1;
          renderPage(scope.canvasPage, scope.canvas);
        };

        scope.resetCanvasZoom = function () {
          scope.canvasScale = scope.baseCanvasScale;
          renderPage(scope.canvasPage, scope.canvas);
        };

        function _saveBillingData(billing, dupId, supplyIndex, isDeleting) {
          var data;
          var customSupplierData = angular.copy(billing.customSupplierData);

          if (supplyIndex >= 0) {
            customSupplierData.supplies = customSupplierData.supplies.map(function (item, index) {
              var supply = angular.fromJson(angular.toJson(item));

              if (index == supplyIndex) {
                delete supply.saveMode;
                delete supply.editMode;
              }

              return supply;
            });

            if (isDeleting) {
              customSupplierData.supplies.splice(supplyIndex, 1);
            }
          }

          data = {
            dupId: dupId,
            templateId: billing.templateId ? billing.templateId : null,
            group: billing.group && billing.group._id ? billing.group._id : null,
            groupType: billing.group && billing.group.groupType ? billing.group.groupType : null,
            vaOrder: billing.vaOrder && billing.vaOrder._id ? billing.vaOrder._id : null,
            billDate: billing.billDate ? billing.billDate : customSupplierData ? customSupplierData.billdate : undefined,
            dueDate: billing.dueDate ? billing.dueDate : customSupplierData ? customSupplierData.duedate : undefined,
            customSupplierData: customSupplierData,
            amountWithoutTax: billing.amountWithoutTax,
            taxAmount: billing.taxAmount,
            totalAmount: billing.totalAmount,
            vatPercent: billing.vatPercent
          };

          if (!utils.isEmpty(billing.billType)) {
            data.billType = billing.billType;
          }

          apiFactory.updateBillingData(data, billing._id).then(function (resp) {
            Notification.success("".concat(billing.billNo, " successfully updated"));

            if (supplyIndex >= 0) {
              billing.customSupplierData.supplies[supplyIndex].saveMode = false;
              billing.customSupplierData.supplies[supplyIndex].editMode = false;

              if (isDeleting) {
                // if (scope.isNormalType(billing)) {
                billing.amountWithoutTax -= billing.customSupplierData.supplies[supplyIndex].price;
                billing.taxAmount -= billing.customSupplierData.supplies[supplyIndex].vat;
                billing.totalAmount -= billing.customSupplierData.supplies[supplyIndex].total; // }

                billing.customSupplierData.supplies.splice(supplyIndex, 1);
              }

              scope.$apply();
              updateBillingTotalValues(billing);
            }

            var index = scope.memoList.findIndex(function (x) {
              return x._id == billing._id;
            });
            var tempBilling = angular.copy(resp.data.data);
            var currentBillingGroup = {};

            if (scope.billingGroups) {
              for (var i = 0; i < scope.billingGroups.length; i++) {
                if (scope.billingGroups[i]._id === resp.data.data.group) {
                  currentBillingGroup = scope.billingGroups[i];
                  break;
                }
              }
            }

            var currentBillType = {};

            if (scope.economicTypeList && scope.economicTypeList.length) {
              for (var j = 0; j < scope.economicTypeList.length; j++) {
                if (scope.economicTypeList[j]._id === resp.data.data.billType) {
                  currentBillType = scope.economicTypeList[j];
                }
              }
            }

            tempBilling.billType = currentBillType;
            tempBilling.group = currentBillingGroup;
            scope.memoList[index] = tempBilling;
            billing = scope.memoList[index];
          })["catch"](function (err) {
            $log.log(err);
          });
        }

        function updateBillingTotalValues(billing) {
          var data = {
            amountWithoutTax: billing.amountWithoutTax,
            taxAmount: billing.taxAmount,
            totalAmount: billing.totalAmount
          };
          apiFactory.updateBillingTotalValues(data, billing._id).then(function () {
            scope.$apply();
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }

        function showBilling(billing) {
          if (!billing) return;
          scope.currentInvoiceId = billing._id;
          scope.economicTypeId = billing.billType;
          scope.billingGroupId = billing.group;
          scope.billingVAOrderId = billing.vaOrder ? billing.vaOrder._id : null;
          scope.isLoadBilling = true;
          $log.log('pdfFactory = ', pdfFactory);
          Promise.all([pdfFactory.numPagesFromURL(billing.bill.secure_url), pdfFactory.getPageFromURL(billing.bill.secure_url, scope.currentPageNum)]).then(function (res) {
            scope.numPages = res[0];
            var page = res[1];
            scope.canvasPage = page;
            $timeout(function () {
              scope.$apply();
            });
            scope.isLoadBilling = false;
            /* Render first page initially */

            renderPage(page, scope.canvas, true);
          })["catch"](function (e) {
            $log.error('pdfFactory error = ', e);
            scope.isLoadBilling = false;
          });

          if (!billing.customSupplierData) {
            resetCalcResult(billing);
          }

          if (billing.group && typeof billing.group == 'string') {
            var currentBillingGroup = {};

            if (scope.billingGroups) {
              for (var i = 0; i < scope.billingGroups.length; i++) {
                if (scope.billingGroups[i]._id === billing.group) {
                  currentBillingGroup = scope.billingGroups[i];
                }
              }
            }

            billing.group = currentBillingGroup;
          }

          if (billing.billType && typeof billing.billType == 'string') {
            var currentBillType = {};

            if (scope.economicTypeList.length) {
              for (var j = 0; j < scope.economicTypeList.length; j++) {
                if (scope.economicTypeList[j]._id === billing.billType) {
                  currentBillType = scope.economicTypeList[j];
                }
              }
            }

            billing.billType = currentBillType;
          }

          getVendorDetails(billing);
        }

        function renderPage(page, canvas) {
          var isInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

          if (scope.isRendering) {
            return;
          }

          scope.isRendering = true;
          clearCanvas();
          var originViewport = page.getViewport({
            scale: 1
          });

          if (isInit) {
            if (originViewport) {
              scope.baseCanvasScale = (originViewport.height ? CANVAS_HEIGHT / originViewport.height : 1) * CANVAS_SCALE_MUTIPLER;
            }

            scope.canvasScale = scope.baseCanvasScale;
          }

          var viewport = page.getViewport({
            scale: scope.canvasScale
          });

          if (viewport) {
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            canvas.style.width = viewport.width / 2 + 'px';
            canvas.style.height = viewport.height / 2 + 'px';
            canvas.style.marginTop = viewport.height / 2 - 542 + 'px';
          }

          var ctx = canvas.getContext("2d");
          page.render({
            canvasContext: ctx,
            viewport: viewport
          }).promise.then(function () {
            scope.isRendering = false;
          })["catch"](function (err) {
            $log.error(err);
            scope.isRendering = false;
          });
        }

        function clearCanvas() {
          var ctx = scope.canvas.getContext("2d");

          if (ctx) {
            ctx.clearRect(0, 0, scope.canvas.width, scope.canvas.height);
          }
        }

        function resetCalcResult(billing) {
          if (billing) {
            billing.customSupplierData = {
              supplies: []
            };
            delete billing.amountWithoutTax;
            delete billing.taxAmount;
            delete billing.totalAmount;
          }
        }

        function getVendorDetails(billing) {
          scope.dueDate = billing.dueDate ? new Date(billing.dueDate) : undefined;
          scope.billDate = billing.billDate ? new Date(billing.billDate) : undefined;

          if (!angular.isDate(scope.dueDate)) {
            scope.dueDate = null;
          }

          if (!angular.isDate(scope.billDate)) {
            scope.billDate = null;
          }

          scope.vendorDetail = {};
          if (!billing.vendor) return;
          var vendor = billing.vendor;
          var address = {};

          if (vendor.address) {
            address = vendor.address[0] ? vendor.address[0] : vendor.address ? vendor.address : vendor.address1 ? vendor.address1 : vendor.address2 ? vendor.address2 : '';
          }

          scope.vendorDetail.address = address;
          scope.vendorDetail.fullAddress = '';

          if (scope.vendorDetail.address.line1) {
            scope.vendorDetail.fullAddress += scope.vendorDetail.address.line1 + ', ';
          }

          if (scope.vendorDetail.address.city) {
            scope.vendorDetail.fullAddress += scope.vendorDetail.address.city + ', ';
          }

          if (scope.vendorDetail.address.countryCode) {
            scope.vendorDetail.fullAddress += scope.vendorDetail.address.countryCode + ', ';
          }

          scope.vendorDetail.email = vendor.email;
          scope.vendorDetail.phoneNumber = vendor.clientContact ? vendor.clientContact.dialCode + vendor.clientContact.phoneNumber : vendor.contact ? vendor.contact.dialCode + vendor.contact.phoneNumber : vendor.mobile ? vendor.mobile.dialCode + vendor.mobile.phoneNumber : '';
          scope.vendorDetail.vat = scope.getVat(billing);
          scope.vendorDetail.vatNumber = scope.getVatNumber(billing);
          scope.bankDetails = {};
          var requiredFields = ['IBAN', 'bicCode', 'accountNumber', 'bankName'];

          if (vendor.bankDetails && vendor.bankDetails.length > 0) {
            requiredFields.forEach(function (key) {
              scope.bankDetails[key] = vendor.bankDetails[0][key];
            });
          }

          scope.vendorDetail.dueDate = new Date(billing.dueDate);

          if (scope.vendorDetail.vat !== billing.vatPercent || billing.vatPercent && !billing.taxAmount) {
            billing.vatPercent = scope.vendorDetail.vat; // calculatePrices(billing);
          }

          $timeout(function () {
            scope.$apply();
          });
        }

        function refineValue(value) {
          return Math.round((value + Number.EPSILON * Math.pow(10, 10)) * 100) / 100;
        }

        function _calculatePrices(billing) {
          if (!billing || !billing.customSupplierData || !billing.customSupplierData.supplies) {
            return;
          } // if (scope.isNormalType(billing)) {


          billing.amountWithoutTax = 0;
          billing.taxAmount = 0;
          billing.totalAmount = 0;
          billing.customSupplierData.supplies.forEach(function (supply) {
            supply.price = Number.parseFloat(supply.qty) * Number.parseFloat(supply.unitprice);
            var price = supply.price;

            if (angular.isDefined(price) && price !== null) {
              var priceValue = Number(price);

              if (priceValue) {
                supply.vat = priceValue * utils.num(scope.vendorDetail.vat) / 100.0;
                supply.total = supply.vat + priceValue;
              }

              billing.amountWithoutTax += priceValue;
              billing.taxAmount += supply.vat;
              billing.totalAmount += supply.total;
            }
          }); // } else {
          //   billing.amountWithoutTax = refineValue(Number.parseFloat(billing.customSupplierData.totalprice));
          //   billing.taxAmount = refineValue(billing.amountWithoutTax * utils.num(scope.vendorDetail.vat) / 100.0);
          //   billing.totalAmount = refineValue(billing.amountWithoutTax + billing.taxAmount);
          // }

          billing.amountWithoutTax = refineValue(billing.amountWithoutTax);
          billing.taxAmount = refineValue(billing.taxAmount);
          billing.totalAmount = refineValue(billing.amountWithoutTax + billing.taxAmount);
          scope.proceedBillingId = null;
        }

        function calculatePrices(billing) {
          _calculatePrices(billing);

          scope.saveBillingData(billing);
          $timeout(function () {
            return scope.$apply();
          });
        }

        scope.init();
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').directive('pendingBills', pendingBills);

  function pendingBills(ecoFactory, utils, globals, $log, apiFactory, Notification, $state, $timeout, pdfFactory, $document, $rootScope, $uibModal, $window) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/economic/bill/directives/pending/pendingBills.view.html',
      replace: true,
      scope: {
        ngModel: "=",
        up: "=",
        billList: '=',
        vendors: '=',
        billing: '=',
        currentIndex: '=',
        deleteBilling: '&'
      },
      link: function link(scope) {
        var companyStore = globals.companyStore,
            projectStore = globals.projectStore,
            userStore = globals.userStore;
        var CANVAS_HEIGHT = 542 * $rootScope.scale;
        var CANVAS_SCALE_MUTIPLER = 2;
        scope.companyData = companyStore.get();
        scope.project = projectStore.get();
        scope.userData = userStore.get(); // scope.vendors = [];

        scope.projects = [];
        scope.billingGroups = [];
        scope.vaOrderList = []; // scope.billList = [];

        scope.economicTypeList = []; // scope.billList = [];

        scope.numPages = 0;
        scope.currentPageNum = 1; // scope.billing = null;
        // scope.currentIndex = 0;

        scope.canvas = $document[0].getElementById("the-canvas");

        scope.init = function () {
          var promises = [apiFactory.listAllVariationOrders({
            projectId: scope.project._id,
            status: 'approved',
            isBill: false
          }), apiFactory.getAllMaterialGroup(), apiFactory.getAllEquipmentGroup(), apiFactory.getBillAccountPlans(), // apiFactory.listAllPendingBills({ projectId: scope.project._id })
          apiFactory.listAllOngoingProjects()];
          Promise.all(promises).then(function (resp) {
            scope.vaOrderList = resp[0].data.list;
            var materialGroup = resp[1].data.data;
            var equipmentGroup = resp[2].data.data;
            equipmentGroup.forEach(function (item) {
              return item.groupType = 'eq';
            });
            scope.billingGroups = materialGroup.concat(equipmentGroup);
            scope.modelReady = true;
            scope.economicTypeList = resp[3].data.data;
            scope.economicTypeList.forEach(function (x) {
              x.name = x.name + ' - ' + x.number;
            });
            scope.numPages = scope.billList.length;
            scope.currentPageNum = 1; // scope.currentIndex = 0;

            if (scope.billing) {
              showBilling(scope.billing); // scope.currentVendorId = scope.billing.vendor ? scope.billing.vendor._id : 'none';
            }

            scope.projects = resp[4].data.list.map(function (item) {
              return {
                projectName: "".concat(item.projectName, " - ").concat(item.systemTag),
                _id: item._id,
                systemTag: item.systemTag
              };
            });
            scope.projects.unshift({
              _id: 'other-cost',
              projectName: 'Other Cost'
            });
            scope.currentVendorId = scope.billing.vendor ? scope.billing.vendor._id : 'none';
            scope.isLoading = false;
          })["catch"](function (err) {
            scope.isLoading = false;
            $log.error('======================', err);

            if (err.status === 403) {
              Notification.error(err.data.message);
              $state.go(globals.getDashboardRoute(scope.userData));
            } else {
              Notification.error(utils.getErrorMessage(err, "No data to show, please upload bill pdf first."));
            }
          });
        };

        scope.onEditItem = function (item) {
          item.editMode = true;
          scope.editingSupply = angular.copy(item);
        };

        scope.onCancelEditItem = function (item) {
          item.editMode = false;
          scope.editingSupply = {};

          if (item.addMode) {
            scope.billing.customSupplierData.supplies.splice(scope.billing.customSupplierData.supplies.length - 1, 1);
          }

          _calculatePrices(scope.billing);
        };

        scope.onAddItem = function () {
          $log.log(scope.billing);

          if (utils.isEmpty(scope.billing.customSupplierData)) {
            resetCalcResult(scope.billing);
          }

          var find = scope.billing.customSupplierData.supplies.find(function (elem) {
            return elem.editMode == true;
          });

          if (find) {
            Notification.error("Please save editing item before adding");
            return;
          }

          scope.billing.customSupplierData.supplies.push({
            addMode: true
          });
          scope.onEditItem(scope.billing.customSupplierData.supplies[scope.billing.customSupplierData.supplies.length - 1]);
        };

        scope.onCheckEditing = function (index) {
          var supply = scope.billing.customSupplierData.supplies[index];

          if (supply.saveMode == true) {
            return;
          } // if (scope.isNormalType(scope.billing)) {


          if (utils.isEmpty(scope.editingSupply.description)) {
            Notification.error('Please input item description');
            return;
          }

          if (utils.isEmpty(scope.editingSupply.qty)) {
            Notification.error('Please input item quantity');
            return;
          }

          if (utils.isEmpty(scope.editingSupply.unitprice)) {
            Notification.error('Please input item unit price');
            return;
          }

          if (scope.editingSupply.qty < 0) {
            Notification.error('Quantity cannot be minus.');
            return;
          }

          if (scope.editingSupply.unitprice < 0) {
            Notification.error('UnitPrice cannot be minus.');
            return;
          }

          supply.saveMode = true;
          supply.description = scope.editingSupply.description;
          supply.qty = scope.editingSupply.qty;
          supply.unitprice = scope.editingSupply.unitprice; // } else {
          //   if (
          //     utils.isEmpty(scope.editingSupply.description) ||
          //     utils.isEmpty(scope.editingSupply.qty)
          //   ) {
          //     Notification.error('Please input correct value');
          //     return;
          //   }
          //   supply.saveMode = true;
          //   supply.description = scope.editingSupply.description;
          //   supply.qty = scope.editingSupply.qty;
          // }

          scope.saveBillingData(scope.billing, index);
        };

        scope.onRemoveItem = function (index) {
          if (scope.billing.customSupplierData.supplies[index].saveMode == true) return;
          scope.billing.customSupplierData.supplies[index].saveMode = true;
          scope.saveBillingData(scope.billing, index, true);
        };

        scope.changedQtyAndUPrice = function (item) {
          // if (!scope.isNormalType(scope.billing)) {
          //   return;
          // }
          $log.log(scope.billing);
          item.price = item.qty * item.unitprice;
          scope.billing.amountWithoutTax = 0;
          scope.billing.taxAmount = 0;
          scope.billing.totalAmount = 0;
          scope.billing.customSupplierData.supplies.filter(function (x) {
            return !x.editMode;
          }).forEach(function (supply) {
            var price = supply.price;

            if (angular.isDefined(price) && price !== null) {
              var priceValue = Number(price);

              if (priceValue) {
                supply.vat = priceValue * utils.num(scope.vendorDetail.vat) / 100.0;
                supply.total = supply.vat + priceValue;
              }

              scope.billing.amountWithoutTax += priceValue;
              scope.billing.taxAmount += supply.vat;
              scope.billing.totalAmount += supply.total;
            }
          });

          if (!utils.isEmpty(scope.editingSupply) && !utils.isEmpty(scope.editingSupply.qty) && !utils.isEmpty(scope.editingSupply.unitprice)) {
            var price = scope.editingSupply.qty * scope.editingSupply.unitprice;
            scope.editingSupply.price = price;
            scope.editingSupply.vat = price * utils.num(scope.vendorDetail.vat) / 100.0;
            scope.editingSupply.total = scope.editingSupply.vat + price;
            item.description = scope.editingSupply.description;
            item.qty = scope.editingSupply.qty;
            item.unitprice = scope.editingSupply.unitprice;
            item.price = scope.editingSupply.price;
            item.vat = scope.editingSupply.vat;
            item.total = scope.editingSupply.total;
            scope.billing.amountWithoutTax += price;
            scope.billing.taxAmount += scope.editingSupply.vat;
            scope.billing.totalAmount += scope.editingSupply.total;
          }
        };

        scope.editAmountWithoutTax = function () {
          scope.billing.editMode = true;

          if (angular.isUndefined(scope.billing.amountWithoutTaxTemp)) {
            scope.billing.amountWithoutTaxTemp = scope.billing.amountWithoutTax;
          }
        };

        scope.updateAmountWithoutTax = function () {
          scope.billing.editMode = false;
          updateBillingTotalValues();
        };

        scope.changeAmountWithoutTax = function () {
          scope.billing.amountWithoutTax = scope.billing.amountWithoutTaxTemp;
          scope.billing.taxAmount = scope.billing.amountWithoutTax * utils.num(scope.vendorDetail.vat) / 100.0;
          scope.billing.totalAmount = scope.billing.amountWithoutTax + scope.billing.taxAmount;
        };

        scope.cancelAmountWithoutTax = function () {
          scope.billing.editMode = false;
          scope.billing.amountWithoutTaxTemp = scope.billing.amountWithoutTax;
          scope.billing.taxAmount = scope.billing.amountWithoutTax * utils.num(scope.vendorDetail.vat) / 100.0;
          scope.billing.totalAmount = scope.billing.amountWithoutTax + scope.billing.taxAmount;
        }; // scope.isNormalType = (billing) => {
        //   return true;
        //   if (!billing) {
        //     return true;
        //   }
        //   let template = billing.templateId;
        //   if (!template || !template.templateType) {
        //     return true;
        //   }
        //   return template.templateType.includes('normal');
        // }


        scope.getVat = function (billing) {
          var accountPlan = undefined;

          if (billing.billType && angular.isObject(billing.billType)) {
            accountPlan = billing.billType;
          } else {
            accountPlan = scope.economicTypeList.find(function (x) {
              return x._id === billing.billType;
            });
          }

          if (accountPlan && angular.isDefined(accountPlan.vat)) {
            return accountPlan.vat;
          }

          return billing && billing.vendor && billing.vendor.paymentTerms && billing.vendor.paymentTerms.vatPercent ? billing.vendor.paymentTerms.vatPercent : 0;
        };

        scope.getVatNumber = function (billing) {
          var vatNumber;

          if (billing && billing.vendor) {
            if (billing.vendor.paymentTerms) {
              vatNumber = billing.vendor.paymentTerms.vatNumber;
            }
          }

          return vatNumber;
        };

        scope.selEconomicTypeId = function (economicType) {
          scope.billing.billType = economicType;
          scope.vendorDetail.vat = scope.getVat(scope.billing);
          calculatePrices(scope.billing);
        };

        scope.selBillingGroupId = function (billingGroupId) {
          for (var i = 0; i < scope.billingGroups.length; i++) {
            if (scope.billingGroups[i]._id === billingGroupId) {
              scope.billing.group = scope.billingGroups[i];
            }
          }
        };

        scope.selBillingVAOrderId = function (billingVAOrderId) {
          if (scope.vaOrderList) {
            for (var i = 0; i < scope.vaOrderList.length; i++) {
              if (scope.vaOrderList[i]._id === billingVAOrderId) {
                var vaOrder = scope.vaOrderList[i];
                scope.billing.vaOrder = vaOrder;
                scope.billing.customSupplierData = {
                  invoicenumber: vaOrder.displaySeq,
                  supplies: []
                };

                if (vaOrder.vendorType === 'Client') {
                  scope.billing.customSupplierData.address2 = scope.addressString(vaOrder.vendor.address);
                  scope.billing.customSupplierData.postalCode = vaOrder.vendor.address[0].postalCode;
                  scope.billing.customSupplierData.countryCode = vaOrder.vendor.address[0].countryCode;
                  scope.billing.customSupplierData.city = vaOrder.vendor.address[0].city;
                  scope.billing.vendor = vaOrder.vendor;
                  scope.billing.vendor.name = vaOrder.vendor.clientName;
                  scope.billing.vendor.address = scope.addressString(vaOrder.vendor.address);
                  scope.billing.vendor.contact = vaOrder.vendor.clientContact;

                  if (vaOrder.vendor.paymentTerms) {
                    scope.billing.vendor.vat = vaOrder.vendor.paymentTerms.vatPercent;
                  } else {
                    scope.billing.vendor.vat = 0;
                  }

                  scope.billing.vendor.bankDetails = angular.copy(scope.companyData.economicSettings.paymentInfo);

                  if (scope.billing.vendor.bankDetails && scope.billing.vendor.bankDetails.length > 0) {
                    scope.billing.vendor.bankDetails[0].IBAN = scope.billing.vendor.bankDetails[0].ibanNumber;
                    scope.billing.vendor.bankDetails[0].sortCode = scope.billing.vendor.bankDetails[0].swiftCode;
                  }
                } else if (vaOrder.vendorType === 'Supplier' || vaOrder.vendorType === 'Subcontractor') {
                  scope.billing.customSupplierData.address2 = scope.billing.vendor.address;
                  scope.billing.vendor = vaOrder.vendor;
                  var address = scope.billing.vendor.address || '';
                  var addresses = address.spilt(',');
                  scope.billing.customSupplierData.postalCode = addresses[2];
                  scope.billing.customSupplierData.countryCode = addresses[1];
                  scope.billing.customSupplierData.city = addresses[0];
                }

                scope.billing.bill.secure_url = vaOrder.variationOrderDoc;

                for (var _i = 0; _i < vaOrder.items.length; _i++) {
                  var item = vaOrder.items[_i];
                  scope.billing.customSupplierData.supplies.push({
                    description: item.description,
                    qty: item.quantity,
                    unitprice: item.unitPrice,
                    vat: item.vatAmount,
                    price: item.price
                  });
                }

                calculatePrices(scope.billing);
                showBilling(scope.billing);
                return;
              }
            }
          }
        };

        scope.updateBillDate = function () {
          if (scope.billing) {
            scope.billing.billDate = new Date(scope.billDate);
          }
        };

        scope.updateDueDate = function () {
          if (scope.billing) {
            scope.billing.dueDate = new Date(scope.dueDate);
          }
        };

        scope.changePageInBill = function (isNext) {
          if (isNext) {
            scope.currentPageNum += 1;

            if (scope.currentPageNum > scope.numPages) {
              scope.currentPageNum = scope.numPages;
            }
          } else {
            scope.currentPageNum -= 1;

            if (scope.currentPageNum < 1) {
              scope.currentPageNum = 1;
            }
          }

          pdfFactory.getPageFromURL(scope.billing.bill.secure_url, scope.currentPageNum).then(function (page) {
            scope.canvasPage = page;
            $timeout(function () {
              scope.$apply();
            });
            renderPage(page, scope.canvas);
          })["catch"](function (e) {
            $log.error(e);
          });
        };

        scope.downloadInvoice = function (billing) {
          scope.isDownloading = true;
          utils.downloadFile(billing.bill.secure_url, "".concat(billing.billNo, ".pdf")).then(function () {
            scope.isDownloading = false;
            $timeout(function () {
              return scope.$apply();
            });
          })["catch"](function (err) {
            scope.isDownloading = false;
            $log.error(err);
            Notification.error('Cannot download.');
          });
        };

        scope.printDocument = function () {
          $window.open(scope.billing.bill.secure_url, "_blank");
        };

        scope.deleteCurrentBilling = function () {
          $log.log('---------delete billing--------');
          scope.deleteBilling(scope.billing); // $uibModal.open({
          //   animation: true,
          //   component: 'confirmModal',
          //   size: 'sm',
          //   backdrop: 'static',
          //   keyboard: false
          // }).result.then(function () {
          //   apiFactory.deleteBilling(scope.billing._id)
          //     .then(() => {
          //       Notification.success(`${scope.billing.billNo} removed successfully.`);
          //       scope.init();
          //     })
          //     .catch(err => {
          //       $log.error(err);
          //       Notification.error("Failed to remove!");
          //     });
          // }, () => {
          // })
        };

        scope.changeCanvasPage = function (direction) {
          var oldIndex = scope.currentIndex;
          $log.log('currentIndex = ', scope.currentIndex);

          if (direction) {
            scope.currentIndex = scope.currentIndex === scope.billList.length - 1 ? scope.currentIndex : scope.currentIndex + 1;
          } else {
            scope.currentIndex = scope.currentIndex === 0 ? scope.currentIndex : scope.currentIndex - 1;
          }

          if (oldIndex !== scope.currentIndex) {
            scope.currentPageNum = 1;
            scope.numPages = 1;
            scope.billing = scope.billList[scope.currentIndex];
            showBilling(scope.billing);
            $timeout(function () {
              scope.currentVendorId = scope.billing.vendor ? scope.billing.vendor._id : 'none';
              scope.$apply();
              $log.log('currentVendorId = ', scope.currentVendorId);
            });
          }
        };

        scope.saveBillingData = function (_billing) {
          var supplyIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
          var isDeleting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

          if (_billing && _billing.customSupplierData && _billing.customSupplierData.invoicenumber) {
            var checkData = {
              id: _billing._id,
              vendorId: _billing.vendor ? _billing.vendor._id : undefined,
              customSupplierData: _billing.customSupplierData,
              projectId: _billing.projectId && _billing.projectId._id ? _billing.projectId._id : _billing.projectId
            };
            apiFactory.checkDuplicatedBillingData(checkData).then(function (resp) {
              if (resp.data.data.isDuplicated) {
                var duplicatedModal = $uibModal.open({
                  animation: true,
                  component: 'duplicatedModal',
                  windowClass: 'dupliated-modal',
                  size: 'sm',
                  backdrop: 'static',
                  keyboard: false,
                  resolve: {
                    oldBilling: function oldBilling() {
                      return resp.data.data.item;
                    },
                    billing: function billing() {
                      return _billing;
                    }
                  }
                });
                duplicatedModal.result.then(function (result) {
                  if (result) {
                    if (result.action === 'delete') {
                      // getBillingList();
                      scope.init();
                    } else {
                      _saveBillingData(_billing, resp.data.data.item._id, supplyIndex, isDeleting);
                    }
                  }
                });
              } else {
                _saveBillingData(_billing, null, supplyIndex, isDeleting);
              }
            })["catch"](function (err) {
              $log.log(err);
            });
          } else {
            Notification.error("Please input invoice number.");
          }
        };

        scope.zoomCanvas = function (zoomIn) {
          scope.canvasScale = zoomIn ? scope.canvasScale + 0.1 : scope.canvasScale - 0.1;
          renderPage(scope.canvasPage, scope.canvas);
        };

        scope.resetCanvasZoom = function () {
          scope.canvasScale = scope.baseCanvasScale;
          renderPage(scope.canvasPage, scope.canvas);
        };

        scope.onChangeVendor = function (data) {
          if (scope.billing) {
            scope.billing.vendor = scope.vendors.find(function (x) {
              return x._id == data;
            });
            $log.log(data); // scope.currentVendorId = data;

            getVendorDetails(scope.billing);
          } else {
            Notification.error("Please upload bill pdf first.");
          } // scope.$apply();

        };

        function _saveBillingData(billing, dupId, supplyIndex, isDeleting) {
          var data;
          var customSupplierData = angular.copy(billing.customSupplierData);
          customSupplierData.supplies = customSupplierData.supplies.map(function (item) {
            var supply = angular.fromJson(angular.toJson(item)); // if (index == supplyIndex) {

            delete supply.saveMode;
            delete supply.editMode; // }

            return supply;
          });

          if (supplyIndex >= 0) {
            if (isDeleting) {
              customSupplierData.supplies.splice(supplyIndex, 1);
            }
          }

          data = {
            dupId: dupId,
            templateId: billing.templateId ? billing.templateId : null,
            group: billing.group && billing.group._id ? billing.group._id : null,
            groupType: billing.group && billing.group.groupType ? billing.group.groupType : null,
            vaOrder: billing.vaOrder && billing.vaOrder._id ? billing.vaOrder._id : null,
            billDate: billing.billDate ? billing.billDate : customSupplierData ? customSupplierData.billdate : undefined,
            dueDate: billing.dueDate ? billing.dueDate : customSupplierData ? customSupplierData.duedate : undefined,
            customSupplierData: customSupplierData,
            amountWithoutTax: billing.amountWithoutTax,
            taxAmount: billing.taxAmount,
            totalAmount: billing.totalAmount,
            vatPercent: billing.vatPercent
          };

          if (!utils.isEmpty(billing.billType)) {
            data.billType = billing.billType;
          }

          apiFactory.updateBillingData(data, billing._id).then(function (resp) {
            Notification.success("".concat(billing.billNo, " successfully updated"));

            if (supplyIndex >= 0) {
              billing.customSupplierData.supplies[supplyIndex].saveMode = false;
              billing.customSupplierData.supplies[supplyIndex].editMode = false;

              if (isDeleting) {
                // if (scope.isNormalType(billing)) {
                billing.amountWithoutTax -= billing.customSupplierData.supplies[supplyIndex].price;
                billing.taxAmount -= billing.customSupplierData.supplies[supplyIndex].vat;
                billing.totalAmount -= billing.customSupplierData.supplies[supplyIndex].total; // }

                billing.customSupplierData.supplies.splice(supplyIndex, 1);
              }

              scope.$apply();
              updateBillingTotalValues(billing);
            }

            var index = scope.billList.findIndex(function (x) {
              return x._id == billing._id;
            });
            var tempBilling = angular.copy(resp.data.data);
            var currentBillingGroup = {};

            if (scope.billingGroups) {
              for (var i = 0; i < scope.billingGroups.length; i++) {
                if (scope.billingGroups[i]._id === resp.data.data.group) {
                  currentBillingGroup = scope.billingGroups[i];
                  break;
                }
              }
            }

            var currentBillType = {};

            if (scope.economicTypeList && scope.economicTypeList.length) {
              for (var j = 0; j < scope.economicTypeList.length; j++) {
                if (scope.economicTypeList[j]._id === resp.data.data.billType) {
                  currentBillType = scope.economicTypeList[j];
                }
              }
            }

            tempBilling.billType = currentBillType;
            tempBilling.group = currentBillingGroup;
            scope.billList[index] = tempBilling;
            billing = scope.billList[index];
          })["catch"](function (err) {
            $log.log(err);
            Notification.error(err.data.message);
            billing.customSupplierData.supplies[supplyIndex].saveMode = false;
          });
        }

        function updateBillingTotalValues(billing) {
          var data = {
            amountWithoutTax: billing.amountWithoutTax,
            taxAmount: billing.taxAmount,
            totalAmount: billing.totalAmount
          };
          apiFactory.updateBillingTotalValues(data, billing._id).then(function () {
            scope.$apply();
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }

        function showBilling(billing) {
          if (!billing) return;
          scope.currentInvoiceId = billing._id;
          scope.economicTypeId = billing.billType;
          scope.billingGroupId = billing.group;
          scope.billingVAOrderId = billing.vaOrder ? billing.vaOrder._id : null;
          scope.isLoadBilling = true;
          $log.log('pdfFactory = ', pdfFactory);
          Promise.all([pdfFactory.numPagesFromURL(billing.bill.secure_url), pdfFactory.getPageFromURL(billing.bill.secure_url, scope.currentPageNum)]).then(function (res) {
            scope.numPages = res[0];
            var page = res[1];
            scope.canvasPage = page;
            $timeout(function () {
              scope.$apply();
            });
            scope.isLoadBilling = false;
            /* Render first page initially */

            renderPage(page, scope.canvas, true);
          })["catch"](function (e) {
            $log.error('pdfFactory error = ', e);
            scope.isLoadBilling = false;
          });

          if (!billing.customSupplierData) {
            resetCalcResult(billing);
          }

          if (billing.group && typeof billing.group == 'string') {
            var currentBillingGroup = {};

            if (scope.billingGroups) {
              for (var i = 0; i < scope.billingGroups.length; i++) {
                if (scope.billingGroups[i]._id === billing.group) {
                  currentBillingGroup = scope.billingGroups[i];
                }
              }
            }

            billing.group = currentBillingGroup;
          }

          if (billing.billType && typeof billing.billType == 'string') {
            var currentBillType = {};

            if (scope.economicTypeList.length) {
              for (var j = 0; j < scope.economicTypeList.length; j++) {
                if (scope.economicTypeList[j]._id === billing.billType) {
                  currentBillType = scope.economicTypeList[j];
                }
              }
            }

            billing.billType = currentBillType;
          }

          getVendorDetails(billing);
        }

        function renderPage(page, canvas) {
          var isInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

          if (scope.isRendering) {
            return;
          }

          scope.isRendering = true;
          clearCanvas();
          var originViewport = page.getViewport({
            scale: 1
          });

          if (isInit) {
            if (originViewport) {
              scope.baseCanvasScale = (originViewport.height ? CANVAS_HEIGHT / originViewport.height : 1) * CANVAS_SCALE_MUTIPLER;
            }

            scope.canvasScale = scope.baseCanvasScale;
          }

          var viewport = page.getViewport({
            scale: scope.canvasScale
          });

          if (viewport) {
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            canvas.style.width = viewport.width / 2 + 'px';
            canvas.style.height = viewport.height / 2 + 'px';
            canvas.style.marginTop = viewport.height / 2 - 542 + 'px';
          }

          var ctx = canvas.getContext("2d");
          page.render({
            canvasContext: ctx,
            viewport: viewport
          }).promise.then(function () {
            scope.isRendering = false;
          })["catch"](function (err) {
            $log.error(err);
            scope.isRendering = false;
          });
        }

        function clearCanvas() {
          var ctx = scope.canvas.getContext("2d");

          if (ctx) {
            ctx.clearRect(0, 0, scope.canvas.width, scope.canvas.height);
          }
        }

        function resetCalcResult(billing) {
          if (billing) {
            billing.customSupplierData = {
              supplies: []
            };
            delete billing.amountWithoutTax;
            delete billing.taxAmount;
            delete billing.totalAmount;
          }
        }

        function getVendorDetails(billing) {
          scope.currentVendorId = billing.vendor ? billing.vendor._id : 'none';
          scope.dueDate = billing.dueDate ? new Date(billing.dueDate) : undefined;
          scope.billDate = billing.billDate ? new Date(billing.billDate) : undefined;

          if (!angular.isDate(scope.dueDate)) {
            scope.dueDate = null;
          }

          if (!angular.isDate(scope.billDate)) {
            scope.billDate = null;
          }

          scope.vendorDetail = {};

          if (!billing.vendor) {
            // scope.$apply();
            return;
          } else {
            var vendor = billing.vendor;
            var address = {};

            if (vendor.address) {
              address = vendor.address[0] ? vendor.address[0] : vendor.address ? vendor.address : vendor.address1 ? vendor.address1 : vendor.address2 ? vendor.address2 : '';
            }

            scope.vendorDetail.address = address;
            scope.vendorDetail.fullAddress = '';

            if (scope.vendorDetail.address.line1) {
              scope.vendorDetail.fullAddress += scope.vendorDetail.address.line1 + ', ';
            }

            if (scope.vendorDetail.address.city) {
              scope.vendorDetail.fullAddress += scope.vendorDetail.address.city + ', ';
            }

            if (scope.vendorDetail.address.countryCode) {
              scope.vendorDetail.fullAddress += scope.vendorDetail.address.countryCode + ', ';
            }

            scope.vendorDetail.email = vendor.email;
            scope.vendorDetail.phoneNumber = vendor.clientContact ? vendor.clientContact.dialCode + vendor.clientContact.phoneNumber : vendor.contact ? vendor.contact.dialCode + vendor.contact.phoneNumber : vendor.mobile ? vendor.mobile.dialCode + vendor.mobile.phoneNumber : '';
            scope.vendorDetail.vat = scope.getVat(billing);
            scope.vendorDetail.vatNumber = scope.getVatNumber(billing);
            scope.bankDetails = {};
            var requiredFields = ['IBAN', 'bicCode', 'accountNumber', 'bankName'];

            if (vendor.bankDetails && vendor.bankDetails.length > 0) {
              requiredFields.forEach(function (key) {
                scope.bankDetails[key] = vendor.bankDetails[0][key];
              });
            }

            scope.vendorDetail.dueDate = new Date(billing.dueDate);

            if (scope.vendorDetail.vat !== billing.vatPercent || billing.vatPercent && !billing.taxAmount) {
              billing.vatPercent = scope.vendorDetail.vat;
            }

            $timeout(function () {
              scope.$apply();
            });
          }
        }

        function refineValue(value) {
          return Math.round((value + Number.EPSILON * Math.pow(10, 10)) * 100) / 100;
        }

        function _calculatePrices(billing) {
          if (!billing || !billing.customSupplierData || !billing.customSupplierData.supplies) {
            return;
          } // if (scope.isNormalType(billing)) {


          billing.amountWithoutTax = 0;
          billing.taxAmount = 0;
          billing.totalAmount = 0;
          billing.customSupplierData.supplies.forEach(function (supply) {
            supply.price = Number.parseFloat(supply.qty) * Number.parseFloat(supply.unitprice);
            var price = supply.price;

            if (angular.isDefined(price) && price !== null) {
              var priceValue = Number(price);

              if (priceValue) {
                supply.vat = priceValue * utils.num(scope.vendorDetail.vat) / 100.0;
                supply.total = supply.vat + priceValue;
              }

              billing.amountWithoutTax += priceValue;
              billing.taxAmount += supply.vat;
              billing.totalAmount += supply.total;
            }
          }); // } else {
          //   billing.amountWithoutTax = refineValue(Number.parseFloat(billing.customSupplierData.totalprice));
          //   billing.taxAmount = refineValue(billing.amountWithoutTax * utils.num(scope.vendorDetail.vat) / 100.0);
          //   billing.totalAmount = refineValue(billing.amountWithoutTax + billing.taxAmount);
          // }

          billing.amountWithoutTax = refineValue(billing.amountWithoutTax);
          billing.taxAmount = refineValue(billing.taxAmount);
          billing.totalAmount = refineValue(billing.amountWithoutTax + billing.taxAmount);
          scope.proceedBillingId = null;
        }

        function calculatePrices(billing) {
          _calculatePrices(billing);

          scope.saveBillingData(billing);
          $timeout(function () {
            return scope.$apply();
          });
        }

        scope.init();
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').directive('companyBills', companyBills);

  function companyBills(ecoFactory, utils, globals, $log, apiFactory, Notification, $state, $timeout, pdfFactory, $document, $rootScope, $uibModal, $window) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/economic/bill/directives/company/companyBills.view.html',
      replace: true,
      scope: {
        ngModel: "=",
        up: "=",
        companyBillList: '=',
        vendors: '=',
        companyBilling: '=',
        currentIndex: '='
      },
      link: function link(scope) {
        var companyStore = globals.companyStore,
            projectStore = globals.projectStore,
            userStore = globals.userStore;
        var CANVAS_HEIGHT = 542 * $rootScope.scale;
        var CANVAS_SCALE_MUTIPLER = 2;
        scope.companyData = companyStore.get();
        scope.project = projectStore.get();
        scope.userData = userStore.get(); // scope.vendors = [];

        scope.projects = [];
        scope.companyBillingGroups = [];
        scope.vaOrderList = []; // scope.companyBillList = [];

        scope.economicTypeList = []; // scope.companyBillList = [];

        scope.numPages = 0;
        scope.currentPageNum = 1; // scope.companyBilling = null;
        // scope.currentIndex = 0;

        scope.canvas = $document[0].getElementById("the-canvas");

        scope.init = function () {
          var promises = [apiFactory.listAllVariationOrders({
            projectId: scope.project._id,
            status: 'approved',
            isBill: false
          }), apiFactory.getAllMaterialGroup(), apiFactory.getAllEquipmentGroup(), apiFactory.getBillAccountPlans(), // apiFactory.listAllPendingBills({ projectId: scope.project._id })
          apiFactory.listAllOngoingProjects()];
          Promise.all(promises).then(function (resp) {
            scope.vaOrderList = resp[0].data.list;
            var materialGroup = resp[1].data.data;
            var equipmentGroup = resp[2].data.data;
            equipmentGroup.forEach(function (item) {
              return item.groupType = 'eq';
            });
            scope.companyBillingGroups = materialGroup.concat(equipmentGroup);
            scope.modelReady = true;
            scope.economicTypeList = resp[3].data.data;
            scope.economicTypeList.forEach(function (x) {
              x.name = x.name + ' - ' + x.number;
            });
            scope.numPages = scope.companyBillList.length;
            scope.currentPageNum = 1; // scope.currentIndex = 0;

            if (scope.companyBilling) {
              showBilling(scope.companyBilling); // scope.currentVendorId = scope.companyBilling.vendor ? scope.companyBilling.vendor._id : 'none';
            }

            scope.projects = resp[4].data.list.map(function (item) {
              return {
                projectName: "".concat(item.projectName, " - ").concat(item.systemTag),
                _id: item._id,
                systemTag: item.systemTag
              };
            });
            scope.projects.unshift({
              _id: 'other-cost',
              projectName: 'Other Cost'
            });
            scope.currentVendorId = scope.companyBilling.vendor ? scope.companyBilling.vendor._id : 'none';
            scope.isLoading = false;
          })["catch"](function (err) {
            scope.isLoading = false;
            $log.error('======================', err);

            if (err.status === 403) {
              Notification.error(err.data.message);
              $state.go(globals.getDashboardRoute(scope.userData));
            } else {
              Notification.error(utils.getErrorMessage(err, "No data to show, please upload bill pdf first."));
            }
          });
        };

        scope.onEditItem = function (item) {
          item.editMode = true;
          scope.editingSupply = angular.copy(item);
        };

        scope.onCancelEditItem = function (item) {
          item.editMode = false;
          scope.editingSupply = {};

          if (item.addMode) {
            scope.companyBilling.customSupplierData.supplies.splice(scope.companyBilling.customSupplierData.supplies.length - 1, 1);
          }

          _calculatePrices(scope.companyBilling);
        };

        scope.onAddItem = function () {
          $log.log(scope.companyBilling);

          if (utils.isEmpty(scope.companyBilling.customSupplierData)) {
            resetCalcResult(scope.companyBilling);
          }

          var find = scope.companyBilling.customSupplierData.supplies.find(function (elem) {
            return elem.editMode == true;
          });

          if (find) {
            Notification.error("Please save editing item before adding");
            return;
          }

          scope.companyBilling.customSupplierData.supplies.push({
            addMode: true
          });
          scope.onEditItem(scope.companyBilling.customSupplierData.supplies[scope.companyBilling.customSupplierData.supplies.length - 1]);
        };

        scope.onCheckEditing = function (index) {
          var supply = scope.companyBilling.customSupplierData.supplies[index];

          if (supply.saveMode == true) {
            return;
          } // if (scope.isNormalType(scope.companyBilling)) {


          if (utils.isEmpty(scope.editingSupply.description) || utils.isEmpty(scope.editingSupply.qty) || utils.isEmpty(scope.editingSupply.unitprice)) {
            Notification.error('Please input correct value');
            return;
          }

          supply.saveMode = true;
          supply.description = scope.editingSupply.description;
          supply.qty = scope.editingSupply.qty;
          supply.unitprice = scope.editingSupply.unitprice; // } else {
          //   if (
          //     utils.isEmpty(scope.editingSupply.description) ||
          //     utils.isEmpty(scope.editingSupply.qty)
          //   ) {
          //     Notification.error('Please input correct value');
          //     return;
          //   }
          //   supply.saveMode = true;
          //   supply.description = scope.editingSupply.description;
          //   supply.qty = scope.editingSupply.qty;
          // }

          scope.saveBillingData(scope.companyBilling, index);
        };

        scope.onRemoveItem = function (index) {
          if (scope.companyBilling.customSupplierData.supplies[index].saveMode == true) return;
          scope.companyBilling.customSupplierData.supplies[index].saveMode = true;
          scope.saveBillingData(scope.companyBilling, index, true);
        };

        scope.changedQtyAndUPrice = function (item) {
          // if (!scope.isNormalType(scope.companyBilling)) {
          //   return;
          // }
          item.price = item.qty * item.unitprice;
          scope.companyBilling.amountWithoutTax = 0;
          scope.companyBilling.taxAmount = 0;
          scope.companyBilling.totalAmount = 0;
          scope.companyBilling.customSupplierData.supplies.filter(function (x) {
            return !x.editMode && !x.addMode;
          }).forEach(function (supply) {
            var price = supply.price;

            if (angular.isDefined(price) && price !== null) {
              var priceValue = Number(price);

              if (priceValue) {
                supply.vat = priceValue * utils.num(scope.vendorDetail.vat) / 100.0;
                supply.total = supply.vat + priceValue;
              }

              scope.companyBilling.amountWithoutTax += priceValue;
              scope.companyBilling.taxAmount += supply.vat;
              scope.companyBilling.totalAmount += supply.total;
            }
          });

          if (!utils.isEmpty(scope.editingSupply) && !utils.isEmpty(scope.editingSupply.qty) && !utils.isEmpty(scope.editingSupply.unitprice)) {
            var price = scope.editingSupply.qty * scope.editingSupply.unitprice;
            scope.editingSupply.price = price;
            scope.editingSupply.vat = price * utils.num(scope.vendorDetail.vat) / 100.0;
            scope.editingSupply.total = scope.editingSupply.vat + price;
            item.description = scope.editingSupply.description;
            item.qty = scope.editingSupply.qty;
            item.unitprice = scope.editingSupply.unitprice;
            item.price = scope.editingSupply.price;
            item.vat = scope.editingSupply.vat;
            item.total = scope.editingSupply.total;
            scope.companyBilling.amountWithoutTax += price;
            scope.companyBilling.taxAmount += scope.editingSupply.vat;
            scope.companyBilling.totalAmount += scope.editingSupply.total;
          }
        };

        scope.editAmountWithoutTax = function () {
          scope.companyBilling.editMode = true;

          if (angular.isUndefined(scope.companyBilling.amountWithoutTaxTemp)) {
            scope.companyBilling.amountWithoutTaxTemp = scope.companyBilling.amountWithoutTax;
          }
        };

        scope.updateAmountWithoutTax = function () {
          scope.companyBilling.editMode = false;
          updateBillingTotalValues();
        };

        scope.changeAmountWithoutTax = function () {
          scope.companyBilling.amountWithoutTax = scope.companyBilling.amountWithoutTaxTemp;
          scope.companyBilling.taxAmount = scope.companyBilling.amountWithoutTax * utils.num(scope.vendorDetail.vat) / 100.0;
          scope.companyBilling.totalAmount = scope.companyBilling.amountWithoutTax + scope.companyBilling.taxAmount;
        };

        scope.cancelAmountWithoutTax = function () {
          scope.companyBilling.editMode = false;
          scope.companyBilling.amountWithoutTaxTemp = scope.companyBilling.amountWithoutTax;
          scope.companyBilling.taxAmount = scope.companyBilling.amountWithoutTax * utils.num(scope.vendorDetail.vat) / 100.0;
          scope.companyBilling.totalAmount = scope.companyBilling.amountWithoutTax + scope.companyBilling.taxAmount;
        }; // scope.isNormalType = (companyBilling) => {
        //   return true;
        //   if (!companyBilling) {
        //     return true;
        //   }
        //   let template = companyBilling.templateId;
        //   if (!template || !template.templateType) {
        //     return true;
        //   }
        //   return template.templateType.includes('normal');
        // }


        scope.getVat = function (companyBilling) {
          var accountPlan = undefined;

          if (companyBilling.billType && angular.isObject(companyBilling.billType)) {
            accountPlan = companyBilling.billType;
          } else {
            accountPlan = scope.economicTypeList.find(function (x) {
              return x._id === companyBilling.billType;
            });
          }

          if (accountPlan && angular.isDefined(accountPlan.vat)) {
            return accountPlan.vat;
          }

          return companyBilling && companyBilling.vendor && companyBilling.vendor.paymentTerms && companyBilling.vendor.paymentTerms.vatPercent ? companyBilling.vendor.paymentTerms.vatPercent : 0;
        };

        scope.getVatNumber = function (companyBilling) {
          var vatNumber;

          if (companyBilling && companyBilling.vendor) {
            if (companyBilling.vendor.paymentTerms) {
              vatNumber = companyBilling.vendor.paymentTerms.vatNumber;
            }
          }

          return vatNumber;
        };

        scope.selEconomicTypeId = function (economicType) {
          scope.companyBilling.billType = economicType;
          scope.vendorDetail.vat = scope.getVat(scope.companyBilling);
          calculatePrices(scope.companyBilling);
        };

        scope.selBillingGroupId = function (companyBillingGroupId) {
          for (var i = 0; i < scope.companyBillingGroups.length; i++) {
            if (scope.companyBillingGroups[i]._id === companyBillingGroupId) {
              scope.companyBilling.group = scope.companyBillingGroups[i];
            }
          }
        };

        scope.selBillingVAOrderId = function (companyBillingVAOrderId) {
          if (scope.vaOrderList) {
            for (var i = 0; i < scope.vaOrderList.length; i++) {
              if (scope.vaOrderList[i]._id === companyBillingVAOrderId) {
                var vaOrder = scope.vaOrderList[i];
                scope.companyBilling.vaOrder = vaOrder;
                scope.companyBilling.customSupplierData = {
                  invoicenumber: vaOrder.displaySeq,
                  supplies: []
                };

                if (vaOrder.vendorType === 'Client') {
                  scope.companyBilling.customSupplierData.address2 = scope.addressString(vaOrder.vendor.address);
                  scope.companyBilling.customSupplierData.postalCode = vaOrder.vendor.address[0].postalCode;
                  scope.companyBilling.customSupplierData.countryCode = vaOrder.vendor.address[0].countryCode;
                  scope.companyBilling.customSupplierData.city = vaOrder.vendor.address[0].city;
                  scope.companyBilling.vendor = vaOrder.vendor;
                  scope.companyBilling.vendor.name = vaOrder.vendor.clientName;
                  scope.companyBilling.vendor.address = scope.addressString(vaOrder.vendor.address);
                  scope.companyBilling.vendor.contact = vaOrder.vendor.clientContact;

                  if (vaOrder.vendor.paymentTerms) {
                    scope.companyBilling.vendor.vat = vaOrder.vendor.paymentTerms.vatPercent;
                  } else {
                    scope.companyBilling.vendor.vat = 0;
                  }

                  scope.companyBilling.vendor.bankDetails = angular.copy(scope.companyData.economicSettings.paymentInfo);

                  if (scope.companyBilling.vendor.bankDetails && scope.companyBilling.vendor.bankDetails.length > 0) {
                    scope.companyBilling.vendor.bankDetails[0].IBAN = scope.companyBilling.vendor.bankDetails[0].ibanNumber;
                    scope.companyBilling.vendor.bankDetails[0].sortCode = scope.companyBilling.vendor.bankDetails[0].swiftCode;
                  }
                } else if (vaOrder.vendorType === 'Supplier' || vaOrder.vendorType === 'Subcontractor') {
                  scope.companyBilling.customSupplierData.address2 = scope.companyBilling.vendor.address;
                  scope.companyBilling.vendor = vaOrder.vendor;
                  var address = scope.companyBilling.vendor.address || '';
                  var addresses = address.spilt(',');
                  scope.companyBilling.customSupplierData.postalCode = addresses[2];
                  scope.companyBilling.customSupplierData.countryCode = addresses[1];
                  scope.companyBilling.customSupplierData.city = addresses[0];
                }

                scope.companyBilling.bill.secure_url = vaOrder.variationOrderDoc;

                for (var _i = 0; _i < vaOrder.items.length; _i++) {
                  var item = vaOrder.items[_i];
                  scope.companyBilling.customSupplierData.supplies.push({
                    description: item.description,
                    qty: item.quantity,
                    unitprice: item.unitPrice,
                    vat: item.vatAmount,
                    price: item.price
                  });
                }

                calculatePrices(scope.companyBilling);
                showBilling(scope.companyBilling);
                return;
              }
            }
          }
        };

        scope.updateBillDate = function () {
          if (scope.companyBilling) {
            scope.companyBilling.billDate = new Date(scope.billDate);
          }
        };

        scope.updateDueDate = function () {
          if (scope.companyBilling) {
            scope.companyBilling.dueDate = new Date(scope.dueDate);
          }
        };

        scope.changePageInBill = function (isNext) {
          if (isNext) {
            scope.currentPageNum += 1;

            if (scope.currentPageNum > scope.numPages) {
              scope.currentPageNum = scope.numPages;
            }
          } else {
            scope.currentPageNum -= 1;

            if (scope.currentPageNum < 1) {
              scope.currentPageNum = 1;
            }
          }

          pdfFactory.getPageFromURL(scope.companyBilling.bill.secure_url, scope.currentPageNum).then(function (page) {
            scope.canvasPage = page;
            $timeout(function () {
              scope.$apply();
            });
            renderPage(page, scope.canvas);
          })["catch"](function (e) {
            $log.error(e);
          });
        };

        scope.downloadInvoice = function (companyBilling) {
          scope.isDownloading = true;
          utils.downloadFile(companyBilling.bill.secure_url, "".concat(companyBilling.billNo, ".pdf")).then(function () {
            scope.isDownloading = false;
            $timeout(function () {
              return scope.$apply();
            });
          })["catch"](function (err) {
            scope.isDownloading = false;
            $log.error(err);
            Notification.error('Cannot download.');
          });
        };

        scope.printDocument = function () {
          $window.open(scope.companyBilling.bill.secure_url, "_blank");
        };

        scope.deleteBilling = function () {
          $uibModal.open({
            animation: true,
            component: 'confirmModal',
            size: 'sm',
            backdrop: 'static',
            keyboard: false
          }).result.then(function () {
            apiFactory.deleteBilling(scope.companyBilling._id).then(function () {
              Notification.success("".concat(scope.companyBilling.billNo, " removed successfully."));
              scope.init();
            })["catch"](function (err) {
              $log.error(err);
              Notification.error("Failed to remove!");
            });
          }, function () {});
        };

        scope.changeCanvasPage = function (direction) {
          var oldIndex = scope.currentIndex;
          $log.log('currentIndex = ', scope.currentIndex);

          if (direction) {
            scope.currentIndex = scope.currentIndex === scope.companyBillList.length - 1 ? scope.currentIndex : scope.currentIndex + 1;
          } else {
            scope.currentIndex = scope.currentIndex === 0 ? scope.currentIndex : scope.currentIndex - 1;
          }

          if (oldIndex !== scope.currentIndex) {
            scope.currentPageNum = 1;
            scope.numPages = 1;
            scope.companyBilling = scope.companyBillList[scope.currentIndex];
            showBilling(scope.companyBilling);
            $timeout(function () {
              scope.currentVendorId = scope.companyBilling.vendor ? scope.companyBilling.vendor._id : 'none';
              scope.$apply();
              $log.log('currentVendorId = ', scope.currentVendorId);
            });
          }
        };

        scope.saveBillingData = function (_companyBilling) {
          var supplyIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
          var isDeleting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

          if (_companyBilling && _companyBilling.customSupplierData && _companyBilling.customSupplierData.invoicenumber) {
            var checkData = {
              id: _companyBilling._id,
              vendorId: _companyBilling.vendor ? _companyBilling.vendor._id : undefined,
              customSupplierData: _companyBilling.customSupplierData,
              projectId: _companyBilling.projectId && _companyBilling.projectId._id ? _companyBilling.projectId._id : _companyBilling.projectId
            };
            apiFactory.checkDuplicatedBillingData(checkData).then(function (resp) {
              if (resp.data.data.isDuplicated) {
                var duplicatedModal = $uibModal.open({
                  animation: true,
                  component: 'duplicatedModal',
                  windowClass: 'dupliated-modal',
                  size: 'sm',
                  backdrop: 'static',
                  keyboard: false,
                  resolve: {
                    oldBilling: function oldBilling() {
                      return resp.data.data.item;
                    },
                    companyBilling: function companyBilling() {
                      return _companyBilling;
                    }
                  }
                });
                duplicatedModal.result.then(function (result) {
                  if (result) {
                    if (result.action === 'delete') {
                      // getBillingList();
                      scope.init();
                    } else {
                      _saveBillingData(_companyBilling, resp.data.data.item._id, supplyIndex, isDeleting);
                    }
                  }
                });
              } else {
                _saveBillingData(_companyBilling, null, supplyIndex, isDeleting);
              }
            })["catch"](function (err) {
              $log.log(err);
            });
          } else {
            Notification.error("Please input invoice number.");
          }
        };

        scope.zoomCanvas = function (zoomIn) {
          scope.canvasScale = zoomIn ? scope.canvasScale + 0.1 : scope.canvasScale - 0.1;
          renderPage(scope.canvasPage, scope.canvas);
        };

        scope.resetCanvasZoom = function () {
          scope.canvasScale = scope.baseCanvasScale;
          renderPage(scope.canvasPage, scope.canvas);
        };

        scope.onChangeVendor = function (data) {
          if (scope.companyBilling) {
            scope.companyBilling.vendor = scope.vendors.find(function (x) {
              return x._id == data;
            });
            $log.log(data); // scope.currentVendorId = data;

            getVendorDetails(scope.companyBilling);
          } else {
            Notification.error("Please upload bill pdf first.");
          } // scope.$apply();

        };

        function _saveBillingData(companyBilling, dupId, supplyIndex, isDeleting) {
          var data;
          var customSupplierData = angular.copy(companyBilling.customSupplierData);

          if (supplyIndex >= 0) {
            customSupplierData.supplies = customSupplierData.supplies.map(function (item, index) {
              var supply = angular.fromJson(angular.toJson(item));

              if (index == supplyIndex) {
                delete supply.saveMode;
                delete supply.editMode;
              }

              return supply;
            });

            if (isDeleting) {
              customSupplierData.supplies.splice(supplyIndex, 1);
            }
          }

          data = {
            dupId: dupId,
            templateId: companyBilling.templateId ? companyBilling.templateId : null,
            group: companyBilling.group && companyBilling.group._id ? companyBilling.group._id : null,
            groupType: companyBilling.group && companyBilling.group.groupType ? companyBilling.group.groupType : null,
            vaOrder: companyBilling.vaOrder && companyBilling.vaOrder._id ? companyBilling.vaOrder._id : null,
            billDate: companyBilling.billDate ? companyBilling.billDate : customSupplierData ? customSupplierData.billdate : undefined,
            dueDate: companyBilling.dueDate ? companyBilling.dueDate : customSupplierData ? customSupplierData.duedate : undefined,
            customSupplierData: customSupplierData,
            amountWithoutTax: companyBilling.amountWithoutTax,
            taxAmount: companyBilling.taxAmount,
            totalAmount: companyBilling.totalAmount,
            vatPercent: companyBilling.vatPercent
          };

          if (!utils.isEmpty(companyBilling.billType)) {
            data.billType = companyBilling.billType;
          }

          apiFactory.updateBillingData(data, companyBilling._id).then(function (resp) {
            Notification.success("".concat(companyBilling.billNo, " successfully updated"));

            if (supplyIndex >= 0) {
              companyBilling.customSupplierData.supplies[supplyIndex].saveMode = false;
              companyBilling.customSupplierData.supplies[supplyIndex].editMode = false;

              if (isDeleting) {
                // if (scope.isNormalType(companyBilling)) {
                companyBilling.amountWithoutTax -= companyBilling.customSupplierData.supplies[supplyIndex].price;
                companyBilling.taxAmount -= companyBilling.customSupplierData.supplies[supplyIndex].vat;
                companyBilling.totalAmount -= companyBilling.customSupplierData.supplies[supplyIndex].total; // }

                companyBilling.customSupplierData.supplies.splice(supplyIndex, 1);
              }

              scope.$apply();
              updateBillingTotalValues(companyBilling);
            }

            var index = scope.companyBillList.findIndex(function (x) {
              return x._id == companyBilling._id;
            });
            var tempBilling = angular.copy(resp.data.data);
            var currentBillingGroup = {};

            if (scope.companyBillingGroups) {
              for (var i = 0; i < scope.companyBillingGroups.length; i++) {
                if (scope.companyBillingGroups[i]._id === resp.data.data.group) {
                  currentBillingGroup = scope.companyBillingGroups[i];
                  break;
                }
              }
            }

            var currentBillType = {};

            if (scope.economicTypeList && scope.economicTypeList.length) {
              for (var j = 0; j < scope.economicTypeList.length; j++) {
                if (scope.economicTypeList[j]._id === resp.data.data.billType) {
                  currentBillType = scope.economicTypeList[j];
                }
              }
            }

            tempBilling.billType = currentBillType;
            tempBilling.group = currentBillingGroup;
            scope.companyBillList[index] = tempBilling;
            companyBilling = scope.companyBillList[index];
          })["catch"](function (err) {
            $log.log(err);
            Notification.error(err.data.message);
            companyBilling.customSupplierData.supplies[supplyIndex].saveMode = false;
          });
        }

        function updateBillingTotalValues(companyBilling) {
          var data = {
            amountWithoutTax: companyBilling.amountWithoutTax,
            taxAmount: companyBilling.taxAmount,
            totalAmount: companyBilling.totalAmount
          };
          apiFactory.updateBillingTotalValues(data, companyBilling._id).then(function () {
            scope.$apply();
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }

        function showBilling(companyBilling) {
          if (!companyBilling) return;
          scope.currentInvoiceId = companyBilling._id;
          scope.economicTypeId = companyBilling.billType;
          scope.companyBillingGroupId = companyBilling.group;
          scope.companyBillingVAOrderId = companyBilling.vaOrder ? companyBilling.vaOrder._id : null;
          scope.isLoadBilling = true;
          $log.log('pdfFactory = ', pdfFactory);
          Promise.all([pdfFactory.numPagesFromURL(companyBilling.bill.secure_url), pdfFactory.getPageFromURL(companyBilling.bill.secure_url, scope.currentPageNum)]).then(function (res) {
            scope.numPages = res[0];
            var page = res[1];
            scope.canvasPage = page;
            $timeout(function () {
              scope.$apply();
            });
            scope.isLoadBilling = false;
            /* Render first page initially */

            renderPage(page, scope.canvas, true);
          })["catch"](function (e) {
            $log.error('pdfFactory error = ', e);
            scope.isLoadBilling = false;
          });

          if (!companyBilling.customSupplierData) {
            resetCalcResult(companyBilling);
          }

          if (companyBilling.group && typeof companyBilling.group == 'string') {
            var currentBillingGroup = {};

            if (scope.companyBillingGroups) {
              for (var i = 0; i < scope.companyBillingGroups.length; i++) {
                if (scope.companyBillingGroups[i]._id === companyBilling.group) {
                  currentBillingGroup = scope.companyBillingGroups[i];
                }
              }
            }

            companyBilling.group = currentBillingGroup;
          }

          if (companyBilling.billType && typeof companyBilling.billType == 'string') {
            var currentBillType = {};

            if (scope.economicTypeList.length) {
              for (var j = 0; j < scope.economicTypeList.length; j++) {
                if (scope.economicTypeList[j]._id === companyBilling.billType) {
                  currentBillType = scope.economicTypeList[j];
                }
              }
            }

            companyBilling.billType = currentBillType;
          }

          getVendorDetails(companyBilling);
        }

        function renderPage(page, canvas) {
          var isInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

          if (scope.isRendering) {
            return;
          }

          scope.isRendering = true;
          clearCanvas();
          var originViewport = page.getViewport({
            scale: 1
          });

          if (isInit) {
            if (originViewport) {
              scope.baseCanvasScale = (originViewport.height ? CANVAS_HEIGHT / originViewport.height : 1) * CANVAS_SCALE_MUTIPLER;
            }

            scope.canvasScale = scope.baseCanvasScale;
          }

          var viewport = page.getViewport({
            scale: scope.canvasScale
          });

          if (viewport) {
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            canvas.style.width = viewport.width / 2 + 'px';
            canvas.style.height = viewport.height / 2 + 'px';
            canvas.style.marginTop = viewport.height / 2 - 542 + 'px';
          }

          var ctx = canvas.getContext("2d");
          page.render({
            canvasContext: ctx,
            viewport: viewport
          }).promise.then(function () {
            scope.isRendering = false;
          })["catch"](function (err) {
            $log.error(err);
            scope.isRendering = false;
          });
        }

        function clearCanvas() {
          var ctx = scope.canvas.getContext("2d");

          if (ctx) {
            ctx.clearRect(0, 0, scope.canvas.width, scope.canvas.height);
          }
        }

        function resetCalcResult(companyBilling) {
          if (companyBilling) {
            companyBilling.customSupplierData = {
              supplies: []
            };
            delete companyBilling.amountWithoutTax;
            delete companyBilling.taxAmount;
            delete companyBilling.totalAmount;
          }
        }

        function getVendorDetails(companyBilling) {
          scope.currentVendorId = companyBilling.vendor ? companyBilling.vendor._id : 'none';
          scope.dueDate = companyBilling.dueDate ? new Date(companyBilling.dueDate) : undefined;
          scope.billDate = companyBilling.billDate ? new Date(companyBilling.billDate) : undefined;

          if (!angular.isDate(scope.dueDate)) {
            scope.dueDate = null;
          }

          if (!angular.isDate(scope.billDate)) {
            scope.billDate = null;
          }

          scope.vendorDetail = {};

          if (!companyBilling.vendor) {
            // scope.$apply();
            return;
          } else {
            var vendor = companyBilling.vendor;
            var address = {};

            if (vendor.address) {
              address = vendor.address[0] ? vendor.address[0] : vendor.address ? vendor.address : vendor.address1 ? vendor.address1 : vendor.address2 ? vendor.address2 : '';
            }

            scope.vendorDetail.address = address;
            scope.vendorDetail.fullAddress = '';

            if (scope.vendorDetail.address.line1) {
              scope.vendorDetail.fullAddress += scope.vendorDetail.address.line1 + ', ';
            }

            if (scope.vendorDetail.address.city) {
              scope.vendorDetail.fullAddress += scope.vendorDetail.address.city + ', ';
            }

            if (scope.vendorDetail.address.countryCode) {
              scope.vendorDetail.fullAddress += scope.vendorDetail.address.countryCode + ', ';
            }

            scope.vendorDetail.email = vendor.email;
            scope.vendorDetail.phoneNumber = vendor.clientContact ? vendor.clientContact.dialCode + vendor.clientContact.phoneNumber : vendor.contact ? vendor.contact.dialCode + vendor.contact.phoneNumber : vendor.mobile ? vendor.mobile.dialCode + vendor.mobile.phoneNumber : '';
            scope.vendorDetail.vat = scope.getVat(companyBilling);
            scope.vendorDetail.vatNumber = scope.getVatNumber(companyBilling);
            scope.bankDetails = {};
            var requiredFields = ['IBAN', 'bicCode', 'accountNumber', 'bankName'];

            if (vendor.bankDetails && vendor.bankDetails.length > 0) {
              requiredFields.forEach(function (key) {
                scope.bankDetails[key] = vendor.bankDetails[0][key];
              });
            }

            scope.vendorDetail.dueDate = new Date(companyBilling.dueDate);

            if (scope.vendorDetail.vat !== companyBilling.vatPercent || companyBilling.vatPercent && !companyBilling.taxAmount) {
              companyBilling.vatPercent = scope.vendorDetail.vat;
            }

            $timeout(function () {
              scope.$apply();
            });
          }
        }

        function refineValue(value) {
          return Math.round((value + Number.EPSILON * Math.pow(10, 10)) * 100) / 100;
        }

        function _calculatePrices(companyBilling) {
          if (!companyBilling || !companyBilling.customSupplierData || !companyBilling.customSupplierData.supplies) {
            return;
          } // if (scope.isNormalType(companyBilling)) {


          companyBilling.amountWithoutTax = 0;
          companyBilling.taxAmount = 0;
          companyBilling.totalAmount = 0;
          companyBilling.customSupplierData.supplies.forEach(function (supply) {
            supply.price = Number.parseFloat(supply.qty) * Number.parseFloat(supply.unitprice);
            var price = supply.price;

            if (angular.isDefined(price) && price !== null) {
              var priceValue = Number(price);

              if (priceValue) {
                supply.vat = priceValue * utils.num(scope.vendorDetail.vat) / 100.0;
                supply.total = supply.vat + priceValue;
              }

              companyBilling.amountWithoutTax += priceValue;
              companyBilling.taxAmount += supply.vat;
              companyBilling.totalAmount += supply.total;
            }
          }); // } else {
          //   companyBilling.amountWithoutTax = refineValue(Number.parseFloat(companyBilling.customSupplierData.totalprice));
          //   companyBilling.taxAmount = refineValue(companyBilling.amountWithoutTax * utils.num(scope.vendorDetail.vat) / 100.0);
          //   companyBilling.totalAmount = refineValue(companyBilling.amountWithoutTax + companyBilling.taxAmount);
          // }

          companyBilling.amountWithoutTax = refineValue(companyBilling.amountWithoutTax);
          companyBilling.taxAmount = refineValue(companyBilling.taxAmount);
          companyBilling.totalAmount = refineValue(companyBilling.amountWithoutTax + companyBilling.taxAmount);
          scope.proceedBillingId = null;
        }

        function calculatePrices(companyBilling) {
          _calculatePrices(companyBilling);

          scope.saveBillingData(companyBilling);
          $timeout(function () {
            return scope.$apply();
          });
        }

        scope.init();
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('replyNoteCommentModal', {
    controller: replyNoteCommentModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/typeWritter/modals/reply-note-comment-modal/reply-note-comment-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function replyNoteCommentModal($scope, utils, Notification, apiFactory, $log) {
    var vm = this;

    vm.$onInit = function () {
      vm.parentComment = vm.resolve.comment;
      $scope.commentData = {
        parentId: vm.parentComment._id
      };
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.postComment = function () {
      if (utils.isEmpty($scope.commentData.comment)) {
        Notification.error('Please input your comment.');
        return;
      }

      $scope.loading = true;
      apiFactory.replyCommentForNote(vm.parentComment.noteId, $scope.commentData).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close(res.data.data);
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
        Notification.error('Failed to post comment.');
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('pageSetupModal', {
    controller: pageSetupModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/typeWritter/modals/pageSetupModal/pageSetupModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function pageSetupModal($scope) {
    var vm = this;

    vm.$onInit = function () {
      vm.billing = {};
      initData();
    };

    function initData() {
      $scope.pageOrientation = vm.resolve.pageOrientation;
      vm.paperSize = vm.resolve.paperSize;
      vm.paperOptions = Constants.PaperSizeList.map(function (item) {
        var name = $scope.pageOrientation == "Portrait" ? "".concat(item.name, " (").concat(item.width, "\" x ").concat(item.height, "\")") : "".concat(item.name, " (").concat(item.height, "\" x ").concat(item.width, "\")");
        return {
          _id: item._id,
          name: name
        };
      });
    }

    $scope.$watch('pageOrientation', function (newVal, oldVal) {
      if (angular.isUndefined(newVal) || newVal == oldVal) {
        return;
      }

      vm.paperOptions = Constants.PaperSizeList.map(function (item) {
        var name = $scope.pageOrientation == "Portrait" ? "".concat(item.name, " (").concat(item.width, "\" x ").concat(item.height, "\")") : "".concat(item.name, " (").concat(item.height, "\" x ").concat(item.width, "\")");
        return {
          _id: item._id,
          name: name
        };
      });
    });

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onOK = function () {
      var width, height;
      var find = Constants.PaperSizeList.find(function (elem) {
        return elem._id == vm.paperSize;
      });

      if (find) {
        width = find.width * 96;
        height = find.height * 96;
      }

      vm.modalInstance.close({
        width: $scope.pageOrientation == "Portrait" ? width : height,
        height: $scope.pageOrientation == "Portrait" ? height : width,
        paperSize: vm.paperSize,
        pageOrientation: $scope.pageOrientation
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('addTypeWritterMemberModal', {
    controller: addTypeWritterMemberModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/typeWritter/modals/addTypeWritterMemberModal/addTypeWritterMemberModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function addTypeWritterMemberModal($scope, apiFactory, Notification, globals) {
    var vm = this;
    vm.member = {};
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.currentDesignation = "Manager";
    $scope.$watch("currentDesignation", function () {
      vm.users = vm.resolve.users.filter(function (it) {
        return it.designation == $scope.currentDesignation;
      });
    });

    vm.$onInit = function () {
      if (vm.resolve) {
        vm.users = vm.resolve.users.filter(function (it) {
          return it.designation == $scope.currentDesignation;
        });
        vm.membersByTeam = angular.isDefined(vm.resolve.membersByTeam) ? vm.resolve.membersByTeam : [];
      }

      if (vm.resolve.message) {
        vm.message = vm.resolve.message;
      }
    };

    $scope.onCancel = function () {
      vm.member = {};
      vm.modalInstance.dismiss('cancel');
    };

    var validateValues = function validateValues() {
      if (!vm.member.userId) {
        Notification.error("Please select user.");
        return false;
      }

      return true;
    };

    $scope.onCreate = function () {
      if (!validateValues()) return;
      var find = vm.users.find(function (elem) {
        return elem._id == vm.member.userId;
      });
      vm.membersByTeam.push(find);
    };

    $scope.onUpdate = function (id, member) {
      apiFactory.updateTeamMember(id, member).then(function (res) {
        Notification.success("Member updated successfully.");
        vm.modalInstance.close({
          type: 1,
          data: res.data.data
        });
      })["catch"](function () {
        Notification.error("Failed to update");
        vm.modalInstance.dismiss('cancel');
      });
    };

    $scope.onDelete = function (id) {
      var findIndex = vm.membersByTeam.findIndex(function (elem) {
        return elem._id == id;
      });

      if (~findIndex) {
        vm.membersByTeam.splice(findIndex, 1);
      }
    };

    $scope.getDesignationUsers = function (designation) {
      var tempUsers = vm.membersByTeam.filter(function (it) {
        return it.designation == designation;
      });
      return tempUsers;
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core', ['ui.router', 'ui.router.state.events', 'chart.js', 'ui.bootstrap', 'ui-notification', 'ngFileUpload', 'ngProgress', 'LocalStorageModule', 'ngMap', 'angularMoment', 'ngSanitize', 'ui.tree', "color.picker", 'external', 'angular-fullcalendar', 'ui.select', 'textAngular', 'ngTagsInput', 'colorpicker.module', 'dndLists', 'ui.tinymce', 'ui.bootstrap.accordion', 'webcam', 'ja.qr', 'xeditable', 'ngEmojiPicker', 'ui.multiselect']);
})();


"use strict";

(function () {
  angular.module("app.core").directive("typeWritterCard", typeWritterCard);

  function typeWritterCard($uibModal, apiFactory, Notification, $log, $window, $document, $state) {
    return {
      restrict: "E",
      templateUrl: "app/main/typeWritter/directives/type-writter-card/type-writter-card.view.html",
      scope: {
        data: '=',
        updatedEvent: "&",
        permission: "=",
        type: "="
      },
      link: function link($scope) {
        $scope["delete"] = function (id) {
          var confirmModal = $uibModal.open({
            animation: true,
            component: 'confirmModal',
            size: 'sm',
            backdrop: 'static',
            keyboard: false
          });
          confirmModal.result.then(function (result) {
            if (result) {
              $scope.loading = true;
              var endpoint = $scope.type == "note" ? "deleteConstructionNoteById" : "deleteSpreadSheetById";
              apiFactory[endpoint](id).then(function () {
                $scope.loading = false;
                $scope.updatedEvent();
                Notification.success('Typewriter deleted successfully');
              }, function () {
                $scope.loading = false;
                Notification.error('Something went wrong try later');
              })["catch"](function () {
                $scope.loading = false;
              });
            }
          }, function (reason) {
            $log.log(reason);
          });
        };

        function base64ToArrayBuffer(base64) {
          var binaryString = $window.atob(base64); // Comment this if not using base64

          var bytes = new Uint8Array(binaryString.length);
          return bytes.map(function (_byte, i) {
            return binaryString.charCodeAt(i);
          });
        }

        function createAndDownloadBlobFile(body, filename) {
          var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pdf';
          var blob = new Blob([body]);
          var fileName = "".concat(filename, ".").concat(extension);

          if (navigator.msSaveBlob) {
            // IE 10+
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = $document[0].createElement('a'); // Browsers that support HTML5 download attribute

            if (angular.isDefined(link.download)) {
              var url = URL.createObjectURL(blob);
              link.setAttribute('href', url);
              link.setAttribute('download', fileName);
              link.style.visibility = 'hidden';
              $document[0].body.appendChild(link);
              link.click();
              $document[0].body.removeChild(link);
            }
          }
        }

        function xtos(sdata) {
          var out = XLSX.utils.book_new();
          sdata.forEach(function (xws) {
            var aoa = [[]];
            var rowobj = xws.rows;

            for (var ri = 0; ri < rowobj.len; ++ri) {
              var row = rowobj[ri];
              if (!row) continue;
              aoa[ri] = [];
              Object.keys(row.cells).forEach(function (k) {
                var idx = +k;
                if (isNaN(idx)) return;
                aoa[ri][idx] = row.cells[k].text;
              });
            }

            var ws = XLSX.utils.aoa_to_sheet(aoa);
            XLSX.utils.book_append_sheet(out, ws, xws.name);
          });
          return out;
        }

        $scope.download = function (id) {
          if ($scope.type == "note") {
            $scope.downloadRichText();
          } else if ($scope.type == "sheet") {
            $scope.downloadSheet(id);
          }
        };

        $scope.downloadSheet = function (id) {
          apiFactory.getSpreadSheetById(id).then(function (resp) {
            var sheetInfo = resp.data.data;
            /* build workbook from the grid data */

            var new_wb = xtos(sheetInfo.contents);
            /* generate download */

            XLSX.writeFile(new_wb, "".concat(sheetInfo.title, ".xlsx"));
          })["catch"](function (e) {
            $log.log('error', e);
          });
        };

        $scope.downloadRichText = function () {
          apiFactory.downloadConstructionNote({
            content: $scope.data.content,
            title: $scope.data.title
          }).then(function (response) {
            var arrayBuffer = base64ToArrayBuffer(response.data);
            createAndDownloadBlobFile(arrayBuffer, $scope.data.title == '' ? 'New Note' : $scope.data.title);
          })["catch"](function (error) {
            $log.error(error);
          });
        };

        $scope.showDetail = function (id) {
          if ($scope.type == "note") {
            $state.go("typeWritterDetail", {
              id: id
            });
          } else if ($scope.type == "sheet") {
            $state.go("typeWritterSpreadSheetDetail", {
              id: id
            });
          }
        };

        $scope.cleanUp = function (content) {
          content = content || '';
          return content.replace(/<[^>]*>/g, '\n');
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("noteComment", noteComment);

  function noteComment($uibModal, globals) {
    return {
      restrict: "E",
      templateUrl: "app/main/typeWritter/directives/note-comment/note-comment.view.html",
      scope: {
        ngModel: "="
      },
      link: function link($scope) {
        var vm = this;
        var userStore = globals.userStore;
        vm.userData = userStore.get();

        $scope.expandReplies = function () {
          $scope.ngModel.expand = !$scope.ngModel.expand;
        };

        $scope.toggleReplyCommentModal = function () {
          var modal = $uibModal.open({
            animation: true,
            component: 'replyNoteCommentModal',
            windowClass: 'reply-note-comment-modal',
            resolve: {
              comment: function comment() {
                return $scope.ngModel;
              }
            }
          });
          modal.result.then(function (result) {
            result.createdComment.commentedBy = {
              profilePic: vm.userData.profilePic,
              displayName: vm.userData.displayName
            };
            $scope.ngModel.replies.push(result.createdComment);
          }, function () {});
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("tqtoolbox", tqtoolbox);

  function tqtoolbox() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/main/tq/directives/tq-toolbox/tq-toolbox.view.html',
      scope: {
        data: "=",
        onSelected: "="
      },
      link: function link($scope) {
        $scope.activeItem = undefined;
        $scope.expandedItem = undefined;

        $scope.onButtonClick = function (item, parent) {
          if (item.submenu) {
            if ($scope.expandedItem) {
              $scope.expandedItem = $scope.expandedItem === item ? undefined : item;
            } else {
              $scope.expandedItem = item;
            }

            $scope.activeItem = undefined;
          } else {
            $scope.expandedItem = undefined;

            if (parent) {
              parent.icon = item.icon;
              $scope.activeItem = parent;
            } else {
              $scope.activeItem = item;
            }

            if ($scope.onSelected) {
              $scope.onSelected(item.id);
            }
          }
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("tqlisttoolbox", tqlisttoolbox);

  function tqlisttoolbox() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/main/tq/directives/tq-list-toolbox/tq-list-toolbox.view.html',
      scope: {
        data: "=",
        onSelected: "="
      },
      link: function link($scope) {
        $scope.activeItem = undefined;
        $scope.expandedItem = undefined;

        $scope.onButtonClick = function (item, parent) {
          if (item.submenu) {
            if ($scope.expandedItem) {
              $scope.expandedItem = $scope.expandedItem === item ? undefined : item;
            } else {
              $scope.expandedItem = item;
            }

            $scope.activeItem = undefined;
          } else {
            $scope.expandedItem = undefined;

            if (parent) {
              parent.icon = item.icon;
              $scope.activeItem = parent;
            } else {
              $scope.activeItem = item;
            }

            if ($scope.onSelected) {
              $scope.onSelected(item.id);
            }
          }
        };
      }
    };
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('saveTodoModal', {
    controller: saveTodoModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/todo/modals/saveTodoModal/saveTodoModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function saveTodoModal(apiFactory, $scope, $log, Notification, utils, storageFactory) {
    var vm = this;
    vm.utils = utils;
    vm.files = [];
    vm.addedFiles = [];
    vm.removedFiles = [];
    $scope.EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    $scope.statusList = [{
      label: 'To Do',
      value: 0
    }, {
      label: 'In Progress',
      value: 1
    }, {
      label: 'Done',
      value: 2
    }];
    $scope.priorityList = [{
      label: 'Urgent',
      value: 0
    }, {
      label: 'High',
      value: 1
    }, {
      label: 'Normal',
      value: 2
    }, {
      label: 'Low',
      value: 3
    }];
    $scope.datepickerOptions = {
      minDate: new Date()
    };

    vm.$onInit = function () {
      $scope.id = vm.resolve.todoId;
      $scope.status = vm.resolve.status;
      vm.todo = {
        type: 0,
        assignedTo: [],
        tags: [],
        status: angular.isDefined($scope.status) ? $scope.status : 0,
        files: []
      };
      $scope.currentDesignation = 'Manager';

      if ($scope.id) {
        $scope.loading = true;
        apiFactory.listAllTodoList({
          todoId: $scope.id
        }).then(function (res) {
          $scope.loading = false;
          vm.todo = res.data.data;
          vm.todo.deadlineDate = new Date();
          vm.todo.deadlineDate.setHours(0, 0, 0, 0);
          vm.todo.deadlineDate.setDate(new Date(vm.todo.deadlineTime).getDate());

          if (angular.isUndefined(vm.todo.tags)) {
            vm.todo.tags = [];
          }

          if (angular.isUndefined(vm.todo.files)) {
            vm.todo.files = [];
          } else {
            vm.todo.files = vm.todo.files.map(function (x) {
              x.name = x.originalname;
              return x;
            });
          }
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
        });
      }

      initData();
    };

    function initData() {
      $scope.loading = true;
      Promise.all([apiFactory.getAllMembers(), storageFactory.listAllProjects(), apiFactory.getTagListAssignedTodo({
        deadlineTimeStart: new Date().toISOString()
      })]).then(function (res) {
        var users = res[0].data.list;
        vm.managers = users.filter(function (it) {
          return it.designation === 'Manager';
        });
        vm.subcontractors = users.filter(function (it) {
          return it.designation === 'Subcontractor';
        });
        vm.suppliers = users.filter(function (it) {
          return it.designation === 'Supplier';
        });
        vm.users = vm.managers;
        vm.projectOptions = res[1].data.list.map(function (item) {
          return {
            label: item.projectName,
            value: item._id
          };
        });
        vm.allTags = res[2].data.data.map(function (item) {
          return {
            label: item,
            value: item
          };
        });
        $scope.loading = false;
      })["catch"](function (err) {
        $log.error(err);
        $scope.loading = false;
      });
    }

    $scope.$watch("currentDesignation", function () {
      switch ($scope.currentDesignation) {
        case 'Manager':
          vm.users = vm.managers;
          break;

        case 'Subcontractor':
          vm.users = vm.subcontractors;
          break;

        case 'Supplier':
          vm.users = vm.suppliers;
          break;

        default:
          vm.users = [];
          break;
      }
    });

    var validateValues = function validateValues() {
      if (!vm.select_user) {
        Notification.error("Please select user.");
        return false;
      }

      return true;
    };

    $scope.addMember = function () {
      if (!validateValues()) return;

      if ($scope.currentDesignation !== "Other") {
        var find = vm.users.find(function (elem) {
          return elem._id == vm.select_user;
        });
        vm.todo.assignedTo.push(find);
        var index = vm.users.findIndex(function (x) {
          return x._id === vm.select_user;
        });

        if (index !== -1) {
          vm.users.splice(index, 1);
        }
      } else {// to do
      }

      vm.select_user = null;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    function validate() {
      if (utils.isEmpty(vm.todo.title)) {
        Notification.error("please enter To Do");
        return false;
      }

      if (angular.isUndefined(vm.todo.deadlineTime) || angular.isUndefined(vm.todo.deadlineDate)) {
        Notification.error("please enter deadline date and time");
        return false;
      }

      return true;
    }

    $scope.onSave = function () {
      if (!validate()) return;
      var payload = angular.fromJson(angular.toJson(vm.todo));
      payload.deadlineTime = new Date();
      payload.deadlineTime.setTime(new Date(vm.todo.deadlineTime).getTime());
      payload.deadlineTime.setDate(new Date(vm.todo.deadlineDate).getDate());
      payload.assignedTo = payload.assignedTo.map(function (x) {
        return x._id;
      });

      if (vm.removedFiles.length) {
        payload.removedFiles = vm.removedFiles;
      }

      delete payload.files;

      if (vm.addedFiles.length) {
        payload.files = [];

        var _iterator = _createForOfIteratorHelper(vm.addedFiles),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var file = _step.value;
            payload.files.push(file);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      delete payload.deadlineDate;
      delete payload.type;
      $scope.loading = true;
      var endpoint = $scope.id ? "updateTodoList" : "createTodoList";
      apiFactory[endpoint](payload).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (error) {
        $log.error(error);
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in save todo');
        $scope.loading = false;
      });
    };

    $scope.addTag = function () {
      vm.todo.tags.push(vm.addTag);
      vm.addTag = null;
    };

    vm.removeTagFunc = function (key) {
      vm.todo.tags.splice(key, 1);
    };

    function validateDupFile(files) {
      var _iterator2 = _createForOfIteratorHelper(files),
          _step2;

      try {
        var _loop = function _loop() {
          var file = _step2.value;
          var find = vm.todo.files.find(function (elem) {
            return elem.name === file.name;
          });

          if (find) {
            Notification.error("A file with the same name exist");
            return {
              v: false
            };
          }
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ret = _loop();

          if (_typeof(_ret) === "object") return _ret.v;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return true;
    }

    vm.fileUpdated = function (files) {
      if (!validateDupFile(files)) {
        return;
      }

      if (files && files.length) {
        vm.todo.files = vm.todo.files.concat(files);
        vm.addedFiles = vm.addedFiles.concat(files);
      }
    };

    vm.cancelUpload = function (file, index) {
      vm.todo.files.splice(index, 1);

      if (angular.isDefined(file._id)) {
        vm.removedFiles.push(file._id);
      } else {
        var _index = vm.addedFiles.findIndex(function (elem) {
          return elem.name === file.name;
        });

        vm.addedFiles.splice(_index, 1);
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("todoGroupByStatus", todoGroupByStatus);

  function todoGroupByStatus($uibModal, $log, apiFactory, Notification, utils, $timeout, $document) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/main/todo/directives/todo-group-by-status/todo-group-by-status.view.html',
      scope: {
        data: "=",
        refreshEvent: "&",
        permission: "=",
        grid: "="
      },
      link: function link(scope) {
        scope.utils = utils;

        scope.edit = function (id) {
          var todoModal = $uibModal.open({
            animation: true,
            component: 'saveTodoModal',
            windowClass: 'save-todo-modal',
            resolve: {
              todoId: function todoId() {
                return id;
              }
            }
          });
          todoModal.result.then(function () {
            scope.refreshEvent();
          }, function (reason) {
            $log.info(reason);
          });
        };

        scope.progress_value = 0;

        scope["delete"] = function (id) {
          var confirmModal = $uibModal.open({
            animation: true,
            component: 'confirmModal',
            size: 'sm',
            backdrop: 'static',
            keyboard: false
          });
          confirmModal.result.then(function (result) {
            if (result) {
              scope.loading = true;
              apiFactory.deleteTodoList(id).then(function () {
                scope.loading = false;
                scope.refreshEvent();
                Notification.success('Todo deleted successfully');
              })["catch"](function () {
                scope.loading = false;
              });
            }
          }, function (reason) {
            $log.log(reason);
          });
        };

        scope.addTodo = function (_status) {
          var todoModal = $uibModal.open({
            animation: true,
            component: 'saveTodoModal',
            windowClass: 'save-todo-modal',
            resolve: {
              status: function status() {
                var result = 0;

                if (_status == "in-progress") {
                  result = 1;
                } else if (_status == "done") {
                  result = 2;
                }

                return result;
              }
            }
          });
          todoModal.result.then(function () {
            scope.refreshEvent();
          }, function (reason) {
            $log.info(reason);
          });
        };

        scope.closeProgress = function () {
          scope.taskStatus = false;
        };

        scope.openEditProgressModal = function (item) {
          scope.selectedId = item._id;
          scope.taskStatus = true;
          scope.progress_value = item.progress ? item.progress : 0;
        };

        scope.updateProgress = function (item, progress_value) {
          if (angular.isUndefined(progress_value) || progress_value < 0 || progress_value > 100) {
            Notification.error("Not a valid percentage. Please type a value between 0 and 100.");
            return;
          }

          scope.loading = true;
          apiFactory.updateTodoList({
            _id: item._id,
            progress: progress_value
          }).then(function (res) {
            scope.loading = false;
            scope.closeProgress();
            scope.refreshEvent();
            Notification.success(res.data.message);
          })["catch"](function (error) {
            scope.loading = false;
            $log.error(error);
            if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in save todo');
          });
        };

        scope.movedTodo = function (index) {
          if (scope.data[scope.statusId].children.filter(function (elem) {
            return elem._id == scope.movingId;
          }).length == 1) {
            for (var i = 0; i < scope.data.length; i++) {
              if (i != scope.statusId) {
                var find = scope.data[i].children.find(function (elem) {
                  return elem._id == scope.movingId;
                });

                if (find) {
                  scope.loading = true;
                  apiFactory.updateTodoList({
                    _id: scope.movingId,
                    status: i
                  }).then(function (res) {
                    scope.loading = false;
                    scope.refreshEvent();
                    Notification.success(res.data.message);
                  })["catch"](function (error) {
                    scope.loading = false;
                    $log.error(error);
                    if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in save todo');
                  });
                }
              }
            }
          }

          if (scope.data[scope.statusId].children[index]._id == scope.movingId) {
            scope.data[scope.statusId].children.splice(index, 1);
          } else {
            for (var _i = index; _i < scope.data[scope.statusId].children.length; _i++) {
              if (scope.data[scope.statusId].children[_i]._id == scope.movingId) {
                scope.data[scope.statusId].children.splice(_i, 1);
                return;
              }
            }
          }
        };

        scope.startForMove = function (id, statusId) {
          scope.movingId = id;
          scope.statusId = statusId;
        };

        scope.$watch('data', function () {
          $timeout(imgSlider, 300);
        });

        function imgSlider() {
          angular.element(".slider").flexslider({
            // animation: "slide",
            start: function start() {
              angular.element('body').removeClass('loading');
            }
          });
        }

        scope.onShowAttach = function (file) {
          var link = $document[0].createElement("a");
          link.href = file.secure_url;
          link.target = '_blank';
          $document[0].body.appendChild(link);
          link.click();
          $document[0].body.removeChild(link);
        };

        scope.onExpandTitle = function (index) {
          if (scope.data[index].expanded === 'undefined') {
            scope.data.map(function (item) {
              item.expanded = false;
            });
          }

          scope.data[index].expanded = !scope.data[index].expanded;
        };

        scope.onExpand = function (index, statusId) {
          if (scope.data[statusId].children[index].expanded === 'undefined') {
            scope.data[statusId].children.map(function (item) {
              item.expanded = false;
            });
          }

          scope.data[statusId].children[index].expanded = !scope.data[statusId].children[index].expanded;
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('taskCommentReplyModal', {
    controller: taskCommentReplyModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/timeline/modals/task-comment-reply-modal/task-comment-reply-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function taskCommentReplyModal($scope, utils, Notification, apiFactory, $log) {
    var vm = this;

    vm.$onInit = function () {
      $scope.commentData = {
        taskId: vm.resolve.data.taskId,
        parent: vm.resolve.data.comment._id,
        files: []
      };
    };

    $scope.onChangeFiles = function (files) {
      var file = files[0];
      if (angular.isUndefined(file)) return;
      var fileData = {
        file: file
      };

      if (utils.isImageFile(file)) {
        fileData.isImage = true;
        fileData.imageURL = URL.createObjectURL(file);
      }

      $scope.commentData.files.push(fileData);
    };

    $scope.removeFile = function (index) {
      $scope.commentData.files.splice(index, 1);
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.postComment = function () {
      if (utils.isEmpty($scope.commentData.comment)) {
        Notification.error('Please input your comment.');
        return;
      }

      $scope.loading = true;
      apiFactory.addCommentToTask($scope.commentData).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
        Notification.error('Failed to post comment.');
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('splitTaskModal', {
    controller: splitTaskModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/timeline/modals/splitTaskModal/splitTaskModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function splitTaskModal($scope, utils, Notification) {
    var vm = this;
    vm.task = {};
    vm.tasks = [];
    vm.startDate = undefined;
    vm.endDate = undefined;
    vm.description = undefined;

    vm.$onInit = function () {
      vm.task = vm.resolve.task;
      vm.taskName = vm.task.text;
      vm.startDate = new Date(vm.task.start_date);
      vm.endDate = new Date(vm.task.end_date);
    };

    vm.addTask = function () {
      var startDate = new Date(vm.startDate);
      var endDate = new Date(vm.endDate);

      if (endDate.getTime() < startDate.getTime()) {
        Notification.error('End date cannot come before than start date.');
        return;
      }

      var taskStartDate = vm.tasks.length > 0 ? vm.tasks[vm.tasks.length - 1].start_date : vm.task.start_date;
      var taskEndDate = vm.task.end_date;

      if (startDate.getTime() < taskStartDate.getTime() || endDate.getTime() > taskEndDate.getTime()) {
        Notification.error('Please input date between start and end date of original task.');
        return;
      }

      var item = {
        id: utils.bsonId(),
        parent: vm.task.parent,
        text: vm.taskName + '#' + (vm.tasks.length + 1),
        start_date: startDate,
        end_date: endDate,
        description: vm.description,
        type: gantt.config.types.task,
        composeState: 'split',
        resources: vm.task.resources,
        status: vm.task.status,
        priority: vm.task.priority,
        progress: vm.task.progress,
        delay: vm.task.delay,
        workType: vm.task.workType,
        workLevel: vm.task.workLevel,
        from: vm.task.from ? vm.task.from : vm.task.id,
        modelId: vm.task.modelId,
        modelType: vm.task.modelType,
        objectId: vm.task.objectId,
        calcSheet: vm.task.calcSheet,
        calcItem: vm.task.calcItem,
        requiredWorkerCount: vm.task.requiredWorkerCount
      };
      vm.tasks.push(item);
      vm.startDate = new Date(endDate);
      vm.endDate = new Date(vm.task.end_date);
      vm.description = undefined;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSave = function () {
      var length = vm.tasks.length;
      var duration = 0;

      for (var i = 0; i < length; i++) {
        var task = vm.tasks[i];
        duration += task.end_date - task.start_date;
      }

      gantt.batchUpdate(function () {
        var index = gantt.getTaskIndex(vm.task.id);
        gantt.deleteTask(vm.task.id);

        for (var _i = 0; _i < length; _i++) {
          var _task = vm.tasks[_i];

          if (duration === 0) {
            _task.calcHours = 0;
          } else {
            _task.calcHours = vm.task.calcHours * (_task.end_date - _task.start_date) / duration;
          }

          gantt.addTask(_task, vm.task.parent, index + _i);
        }
      });
      vm.modalInstance.close();
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('hrsWModal', {
    controller: hrsWModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/timeline/modals/hrsWModal/hrsWModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function hrsWModal($scope, apiFactory, $log, Notification, utils) {
    var vm = this;
    vm.typeOfEmployee = 'Employee';
    vm.startWeekday = 1;
    vm.endWeekday = 5;
    vm.weekdays = [{
      key: 0,
      value: 'Sunday'
    }, {
      key: 1,
      value: 'Monday'
    }, {
      key: 2,
      value: 'Tuesday'
    }, {
      key: 3,
      value: 'Wednesday'
    }, {
      key: 4,
      value: 'Thursday'
    }, {
      key: 5,
      value: 'Friday'
    }, {
      key: 6,
      value: 'Saturday'
    }];
    vm.workers = [];
    vm.subContractors = [];
    vm.from = undefined;
    vm.to = undefined;
    vm.times = [];
    vm.selWorkers = [];

    vm.$onInit = function () {
      vm.projectId = vm.resolve.projectId;
      vm.workers = [];
      vm.subContractors = [];

      if (vm.resolve.workers) {
        vm.resolve.workers.forEach(function (x) {
          return vm.workers.push(x);
        });
      }

      if (vm.resolve.subContractors) {
        vm.resolve.subContractors.forEach(function (x) {
          return vm.subContractors.push(x);
        });
      }

      vm.resolve.times.forEach(function (x) {
        vm.times.push(x);

        if (x.worker.type === 'worker') {
          var index = vm.workers.findIndex(function (w) {
            return w._id === x.worker._id;
          });

          if (index !== -1) {
            vm.workers.splice(index, 1);
          }
        } else {
          var _index = vm.subContractors.findIndex(function (w) {
            return w._id === x.worker._id;
          });

          if (_index !== -1) {
            vm.subContractors.splice(_index, 1);
          }
        }
      });
    };

    vm.searchEmployee = function (query) {
      var all = {
        _id: 'all',
        name: 'All'
      };
      var workers = vm.workers.filter(function (x) {
        return x.name.toLowerCase().includes(query.toLowerCase());
      });

      if (!workers) {
        workers = [all];
      } else {
        workers.unshift(all);
      }

      return workers;
    };

    vm.searchSubcontractor = function (query) {
      var all = {
        _id: 'all',
        name: 'All'
      };
      var workers = vm.subContractors.filter(function (x) {
        return x.name.toLowerCase().includes(query.toLowerCase());
      });

      if (!workers) {
        workers = [all];
      } else {
        workers.unshift(all);
      }

      return workers;
    };

    vm.addTime = function () {
      if (utils.isEmpty(vm.selWorkers)) {
        Notification.error('Please select the member.');
        return;
      }

      if (angular.isUndefined(vm.startWeekday)) {
        Notification.error('Please select the start weekday.');
        return;
      }

      if (angular.isUndefined(vm.endWeekday)) {
        Notification.error('Please select the end weekday.');
        return;
      }

      if (!vm.from || !vm.to) {
        Notification.error('Please select the time.');
        return;
      }

      vm.selWorkers.forEach(function (worker) {
        vm.times.push({
          worker: worker._id,
          name: worker.name,
          type: vm.typeOfEmployee ? 'worker' : 'subcontractor',
          startWeekday: vm.startWeekday,
          endWeekday: vm.endWeekday,
          startTime: vm.from,
          endTime: vm.to
        });
      });
      vm.selWorkers = [];
    };

    vm.removeTime = function (index) {
      vm.times.splice(index, 1);
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSave = function () {
      $scope.isLoading = true;
      apiFactory.saveHrsw({
        projectId: vm.projectId,
        items: vm.times
      }).then(function () {
        Notification.success('Time is saved successfully');
        $scope.isLoading = false;
        vm.modalInstance.close(vm.times);
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
        Notification.error('Failed to save!');
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('editTaskModal', {
    controller: editTaskModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/timeline/modals/editTaskModal/editTaskModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function editTaskModal($scope, $log, apiFactory, globals, Notification, utils) {
    var projectStore = globals.projectStore;
    var vm = this;
    vm.utils = utils;
    vm.project = projectStore.get();
    vm.task = undefined;
    vm.isMainEstimate = false;
    vm.progress = 0;
    vm.delay = 0;
    vm.startDate = undefined;
    vm.endDate = undefined; // task comment

    vm.commentText = '';
    vm.attachedFiles = [];
    vm.taskComents = [];
    vm.priorityList = [{
      label: 'Low',
      value: 0
    }, {
      label: 'Medium',
      value: 1
    }, {
      label: 'High',
      value: 2
    }, {
      label: 'Very High',
      value: 3
    }];
    vm.priorityColorClasses = [{
      "class": 'low',
      value: 'Low'
    }, {
      "class": 'medium',
      value: 'Medium'
    }, {
      "class": 'high',
      value: 'High'
    }, {
      "class": 'very-high',
      value: 'Very High'
    }];
    vm.statusList = [{
      label: 'Not Started',
      value: 0
    }, {
      label: 'On Going',
      value: 1
    }, {
      label: 'On Hold',
      value: 2
    }, {
      label: 'Completed',
      value: 3
    }, {
      label: 'Delayed',
      value: 4
    }];

    vm.$onInit = function () {
      vm.task = vm.resolve.task;
      vm.isMainEstimate = vm.resolve.isMainEstimate;
      vm.progress = vm.task.progress;
      vm.delay = vm.task.delay;
      vm.project.startDate = new Date(vm.project.startDate);
      vm.project.endDate = new Date(vm.project.endDate);
      vm.startDate = new Date(vm.task.start_date);
      vm.endDate = new Date(vm.task.end_date);
      $scope.progress = vm.task.progress;
      vm.percentage = $scope.progress * 100;
      updateProgress();
      $scope.loading = true;
      apiFactory.getTaskComments(vm.task.id).then(function (resp) {
        $scope.loading = false;
        vm.taskComments = resp.data.list;
        vm.totalCommentsCount = resp.data.totalCount;
      })["catch"](function () {
        $scope.loading = false; // Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.changePercentage = function () {
      vm.task.progress = utils.num(vm.percentage) / 100;
      vm.task.progressChanged = true;
      updateTaskDelay();
      vm.progress = vm.task.progress;
      vm.delay = vm.task.delay;
      gantt.updateTask(vm.task.id);
      updateProgress();
    };

    $scope.fetchComments = function () {
      $scope.loading = true;
      apiFactory.getTaskComments(vm.task.id).then(function (res) {
        $scope.loading = false;
        vm.taskComments = res.data.list;
        vm.totalCommentsCount = res.data.totalCount;
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.changePriority = function () {
      gantt.updateTask(vm.task.id);
    };

    vm.changeStatus = function () {
      switch (vm.task.status) {
        case 0:
          vm.task.progress = 0;
          vm.task.delay = 1;
          break;

        case 1:
        case 2:
          vm.task.progress = vm.progress;
          vm.task.delay = vm.delay;
          break;

        case 3:
          vm.task.progress = 1;
          vm.task.delay = 0;
          break;
      }

      vm.task.progressChanged = true;
      gantt.updateTask(vm.task.id);
      updateProgress();
    };

    vm.changeStartDate = function (date) {
      if (angular.isUndefined(date)) {
        return;
      }

      var startDate = new Date(date);
      var endDate = new Date(vm.endDate);
      vm.startDate = startDate;

      if (startDate < vm.project.startDate || startDate > endDate || startDate > vm.project.endDate) {
        Notification.error('Invalid date');
      } else {
        vm.task.start_date = startDate;
        gantt.updateTask(vm.task.id);
        updateRemainingHours(vm.task.progress || 0);
        updateTaskDelay();
      }
    };

    vm.changeEndDate = function (date) {
      if (angular.isUndefined(date)) {
        return;
      }

      var startDate = new Date(vm.startDate);
      var endDate = new Date(date);
      vm.endDate = endDate;

      if (endDate < vm.project.startDate || endDate < startDate || endDate > vm.project.endDate) {
        Notification.error('Invalid date');
      } else {
        vm.task.end_date = endDate;
        gantt.updateTask(vm.task.id);
        updateRemainingHours(vm.task.progress || 0);
        updateTaskDelay();
      }
    };

    vm.reportDelay = function () {
      if (vm.task.progress < 1) {
        vm.task.delay = 1 - vm.task.progress;
        gantt.updateTask(vm.task.id);
      }
    };

    vm.markComplete = function () {
      vm.task.progress = 1;
      vm.task.delay = 0;
      vm.task.progressChanged = true;
      gantt.updateTask(vm.task.id);
      updateProgress();
    };

    vm.onChangeFiles = function (files) {
      if (angular.isUndefined(files) || !files.length) {
        return;
      }

      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var fileData = {
          file: file
        };

        if (utils.isImageFile(file)) {
          fileData.isImage = true;
          fileData.imageURL = URL.createObjectURL(file);
        } else {
          fileData.isImage = false;
        }

        vm.attachedFiles.push(fileData);
      }
    };

    vm.removeAttachedFile = function (index) {
      vm.attachedFiles.splice(index, 1);
    };

    vm.addComment = function () {
      if (utils.isEmpty(vm.commentText)) {
        Notification.error('Please type a message');
        return;
      }

      $scope.loading = true;
      apiFactory.addCommentToTask({
        taskId: vm.task.id,
        comment: vm.commentText,
        files: vm.attachedFiles
      }).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.commentText = "";
        vm.attachedFiles = [];
        $scope.fetchComments();
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function updateTaskDelay() {
      if (vm.task.status !== 3) {
        var progress = utils.progressOfDate(vm.task.start_date, vm.task.end_date, new Date(), true);

        if (vm.task.progress < progress) {
          vm.task.status = 4;
          vm.task.delay = progress - vm.task.progress;
        } else {
          vm.task.status = 1;
          vm.task.delay = 0;
        }
      }
    }

    function updateRemainingHours(progress) {
      vm.remainingHours = (1 - progress) * vm.task.duration;
    }

    function updateProgress() {
      var elProgressContainer = angular.element('#progress');
      var elProgressBar = angular.element('#progress-bar');
      var progress = vm.task.progress || 0;
      vm.percentage = Number.parseFloat((progress * 100).toFixed(2));
      updateRemainingHours(progress);
      vm.progressStyle = {};
      vm.progressBarStyle = {
        width: vm.percentage + '%'
      };

      switch (vm.task.status) {
        case 0:
          vm.progressStyle.background = '#e8e8e8';
          vm.progressBarStyle.background = 'linear-gradient(to top, #464646, #747474)';
          break;

        case 1:
          vm.progressStyle.background = '#D0E0F7';
          vm.progressBarStyle.background = 'linear-gradient(to top, #1166FB, #3F47FE)';
          break;

        case 2:
          vm.progressStyle.background = '#FEE4E2';
          vm.progressBarStyle.background = 'linear-gradient(to top, #EA3D2F, #FB891D)';
          break;

        case 3:
          vm.progressStyle.background = '#DCF7E3';
          vm.progressBarStyle.background = 'linear-gradient(to top, #2FA84F, #70FF00)';
          break;

        case 4:
          vm.progressStyle.background = '#DCF7E3';
          vm.progressBarStyle.background = 'linear-gradient(to top, #2FA84F, #70FF00)';
          break;

        default:
          vm.progressStyle.background = '#FEE4E2';
          vm.progressBarStyle.background = 'linear-gradient(to top, #ea3d2f, #fb8b00)';
          break;
      }

      elProgressContainer.css(vm.progressStyle);
      elProgressBar.css(vm.progressStyle);
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('editCombineTaskModal', {
    controller: editCombineTaskModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/timeline/modals/editCombineTaskModal/editCombineTaskModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function editCombineTaskModal($scope, utils, Notification) {
    var vm = this;
    vm.isEdit = false;
    vm.task = {};
    vm.tasks = [];
    vm.availableTasks = [];
    vm.addedTasks = [];
    vm.percentage = 50;

    vm.$onInit = function () {
      vm.task = vm.resolve.task;
      vm.tasks = vm.task.tasks;
      vm.parent = vm.task.type === gantt.config.types.project ? vm.task.id : gantt.getParent(vm.task.id);
      var tasks = gantt.getChildren(vm.parent);

      if (tasks) {
        tasks.forEach(function (id) {
          var task = gantt.getTask(id);

          if (task.type === gantt.config.types.task && task.composeState !== 'combined') {
            if (vm.tasks.findIndex(function (x) {
              return x.id === task.id;
            }) === -1) {
              vm.availableTasks.push(task);
            }
          }
        });
      }
    };

    vm.addTask = function () {
      var tasks = vm.availableTasks.filter(function (task) {
        return task.checked;
      });

      if (utils.isEmpty(tasks)) {
        Notification.error('Please select task.');
        return;
      }

      vm.availableTasks = vm.availableTasks.filter(function (task) {
        return !task.checked;
      });
      tasks.forEach(function (task) {
        task.percentage = vm.percentage;
        delete task.checked;
        vm.tasks.push(task);
        vm.addedTasks.push(task);
      });
      vm.percentage = 50;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onEdit = function () {
      vm.isEdit = true;
    };

    $scope.onSave = function () {
      var startDate = undefined,
          endDate = undefined,
          start = 0,
          end = 0;

      for (var i = 0; i < vm.tasks.length; i++) {
        if (i === 0) {
          startDate = vm.tasks[0].start_date;
          endDate = new Date(vm.tasks[0].end_date);
          start = startDate.getTime();
          end = endDate.getTime();
        } else {
          var percentage = utils.num(vm.tasks[i - 1].percentage) / 100;
          start += (end - start) * percentage;
          end = start + vm.tasks[i].end_date.getTime() - vm.tasks[i].start_date.getTime();

          if (endDate.getTime() < end) {
            endDate.setTime(end);
          }
        }
      }

      vm.task.start_date = startDate;
      vm.task.end_date = endDate;
      gantt.updateTask(vm.task.id);
      vm.modalInstance.close();
    };

    $scope.onCombine = function () {
      if (vm.addedTasks.length === 0) {
        vm.modalInstance.close();
        return;
      }

      var resources = [];
      var ids = [];
      var startDate = undefined,
          endDate = undefined,
          start = 0,
          end = 0;
      var progress = 0;
      var delay = 0;
      var status = 0;
      var calcHours = 0;
      var workedHours = 0;
      var modelId = undefined,
          modelType = undefined,
          objectId = undefined;
      var requiredWorkerCount = 0;

      for (var i = 0; i < vm.tasks.length; i++) {
        if (vm.tasks[i].resources) {
          vm.tasks[i].resources.forEach(function (r) {
            if (resources.findIndex(function (x) {
              return x.id === r.id;
            }) === -1) {
              resources.push(r);
              ids.push(r.id);
            }
          });
        }

        if (i === 0) {
          startDate = vm.tasks[0].start_date;
          endDate = new Date(vm.tasks[0].end_date);
          start = startDate.getTime();
          end = endDate.getTime();
        } else {
          var percentage = utils.num(vm.tasks[i].percentage) / 100;
          start += (end - start) * percentage;
          end = start + vm.tasks[i].end_date.getTime() - vm.tasks[i].start_date.getTime();

          if (endDate.getTime() < end) {
            endDate.setTime(end);
          }
        }

        progress += utils.num(vm.tasks[i].progress);
        delay += utils.num(vm.tasks[i].delay);
        calcHours += utils.num(vm.tasks[i].calcHours);
        workedHours += utils.num(vm.tasks[i].workedHours);
        vm.tasks[i].combined = true;

        if (vm.tasks[i].modelId && vm.tasks[i].modelType) {
          modelId = vm.tasks[i].modelId;
          modelType = vm.tasks[i].modelType;
          objectId = vm.tasks[i].objectId;
        }

        if (vm.tasks[i].requiredWorkerCount > requiredWorkerCount) {
          requiredWorkerCount = vm.tasks[i].requiredWorkerCount;
        }

        if (vm.tasks[i].status === 4) {
          status = 4;
        }
      }

      vm.task.start_date = startDate;
      vm.task.end_date = endDate;
      vm.task.resources = resources;
      vm.task.resourceIds = ids;
      vm.task.tasks = vm.tasks;
      vm.task.progress = progress / vm.tasks.length;
      vm.task.delay = delay / vm.tasks.length;
      vm.task.calcHours = calcHours;
      vm.task.workedHours = workedHours;
      vm.task.status = status;
      vm.task.requiredWorkerCount = requiredWorkerCount;

      if (!vm.task.modelId && modelId) {
        vm.task.modelId = modelId;
        vm.task.modelType = modelType;
        vm.task.objectId = objectId;
      }

      gantt.batchUpdate(function () {
        for (var _i = 0; _i < vm.addedTasks.length; _i++) {
          vm.addedTasks[_i].group = vm.task.id;
          gantt.deleteTask(vm.addedTasks[_i].id);
        }

        gantt.updateTask(vm.task.id);
      });
      vm.modalInstance.close();
    };

    $scope.onUncombine = function () {
      gantt.batchUpdate(function () {
        for (var i = 0; i < vm.tasks.length; i++) {
          vm.tasks[i].combined = false;
          delete vm.tasks[i].group;
          gantt.addTask(vm.tasks[i]);
        }

        gantt.deleteTask(vm.task.id);
      });
      vm.modalInstance.close();
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('combineTaskModal', {
    controller: combineTaskModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/timeline/modals/combineTaskModal/combineTaskModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function combineTaskModal($scope, utils, Notification) {
    var vm = this;
    vm.tasks = [];
    vm.availableTasks = [];
    vm.selectedTaskId = undefined;
    vm.percentage = 50;
    vm.description = undefined;
    vm.parent = 0;

    vm.$onInit = function () {
      var selectedTask = vm.resolve.selectedTask;
      vm.parent = selectedTask.type === gantt.config.types.project ? selectedTask.id : gantt.getParent(selectedTask.id);
      var tasks = gantt.getChildren(vm.parent);

      if (tasks) {
        tasks.forEach(function (id) {
          var task = gantt.getTask(id);

          if (task.type === gantt.config.types.task && task.composeState !== 'combined') {
            vm.availableTasks.push(task);
          }
        });
      }
    };

    vm.addTask = function () {
      var tasks = vm.availableTasks.filter(function (task) {
        return task.checked;
      });

      if (utils.isEmpty(tasks)) {
        Notification.error('Please select task.');
        return;
      }

      vm.availableTasks = vm.availableTasks.filter(function (task) {
        return !task.checked;
      });
      tasks.forEach(function (task) {
        task.percentage = vm.percentage;
        delete task.checked;
        vm.tasks.push(task);
      });
      vm.percentage = 50;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSave = function () {
      if (angular.isUndefined(vm.taskName)) {
        Notification.error('Please enter task name.');
        return;
      }

      if (vm.tasks.length === 0) {
        Notification.error("There is no tasks for combine.");
        return;
      }

      var resources = [];
      var ids = [];
      var startDate = undefined,
          endDate = undefined,
          start = 0,
          end = 0;
      var progress = 0;
      var delay = 0;
      var status = 0;
      var calcHours = 0;
      var workedHours = 0;
      var modelId = undefined,
          modelType = undefined,
          objectId = undefined;
      var requiredWorkerCount = 0;

      for (var i = 0; i < vm.tasks.length; i++) {
        if (vm.tasks[i].resources) {
          vm.tasks[i].resources.forEach(function (r) {
            if (resources.findIndex(function (x) {
              return x.id === r.id;
            }) === -1) {
              resources.push(r);
              ids.push(r.id);
            }
          });
        }

        if (i === 0) {
          startDate = vm.tasks[0].start_date;
          endDate = new Date(vm.tasks[0].end_date);
          start = startDate.getTime();
          end = endDate.getTime();
        } else {
          var percentage = utils.num(vm.tasks[i].percentage) / 100;
          start += (end - start) * percentage;
          end = start + vm.tasks[i].end_date.getTime() - vm.tasks[i].start_date.getTime();

          if (endDate.getTime() < end) {
            endDate.setTime(end);
          }
        }

        progress += utils.num(vm.tasks[i].progress);
        delay += utils.num(vm.tasks[i].delay);
        calcHours += utils.num(vm.tasks[i].calcHours);
        workedHours += utils.num(vm.tasks[i].workedHours);
        vm.tasks[i].combined = true;

        if (vm.tasks[i].modelId && vm.tasks[i].modelType) {
          modelId = vm.tasks[i].modelId;
          modelType = vm.tasks[i].modelType;
          objectId = vm.tasks[i].objectId;
        }

        if (vm.tasks[i].requiredWorkerCount > requiredWorkerCount) {
          requiredWorkerCount = vm.tasks[i].requiredWorkerCount;
        }

        if (vm.tasks[i].status === 4) {
          status = 4;
        }
      }

      var timelineItem = {
        id: utils.bsonId(),
        text: vm.taskName,
        description: vm.description,
        type: gantt.config.types.task,
        start_date: startDate,
        end_date: endDate,
        parent: vm.parent,
        resources: resources,
        resourceIds: ids,
        composeState: 'combined',
        tasks: vm.tasks,
        progress: progress / vm.tasks.length,
        delay: delay / vm.tasks.length,
        calcHours: calcHours,
        workedHours: workedHours,
        workType: vm.tasks[0].workType,
        workLevel: vm.tasks[0].workLevel,
        status: status,
        modelId: modelId,
        modelType: modelType,
        objectId: objectId,
        requiredWorkerCount: requiredWorkerCount
      };
      gantt.batchUpdate(function () {
        for (var _i = 0; _i < vm.tasks.length; _i++) {
          vm.tasks[_i].group = timelineItem.id;
          gantt.deleteTask(vm.tasks[_i].id);
        }

        gantt.addTask(timelineItem);
      });
      vm.modalInstance.close();
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('addWorkerModal', {
    controller: addWorkerModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/timeline/modals/addWorkerModal/addWorkerModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function addWorkerModal($scope, apiFactory, $log, Notification) {
    var vm = this;
    vm.workerTypes = [{
      key: 1,
      value: 'Employees'
    }, {
      key: 2,
      value: 'Sub-Contractors'
    }, {
      key: 3,
      value: 'EmployeeGroup'
    }];
    vm.workerType = undefined;
    vm.availableWorkers = [];
    vm.workers = [];
    vm.subContractors = [];
    vm.managers = [];
    vm.groups = [];
    vm.selectedWorkerId = undefined;
    vm.selectedWorkers = [];

    vm.$onInit = function () {
      vm.workers = [];
      vm.subContractors = [];

      if (vm.resolve.workers) {
        vm.resolve.workers.forEach(function (x) {
          return vm.workers.push(x);
        });
      }

      if (vm.resolve.subContractors) {
        vm.resolve.subContractors.forEach(function (x) {
          return vm.subContractors.push(x);
        });
      }

      if (vm.resolve.groups) {
        vm.resolve.groups.forEach(function (x) {
          return vm.groups.push(x);
        });
      }

      var task = vm.resolve.task;

      if (task.resources) {
        task.resources.forEach(function (x) {
          var index = vm.workers.findIndex(function (w) {
            return w._id === x;
          });

          if (index !== -1) {
            vm.selectedWorkers.push(vm.workers[index]);
            vm.workers.splice(index, 1);
          } else {
            index = vm.subContractors.findIndex(function (w) {
              return w._id === x;
            });

            if (index !== -1) {
              vm.selectedWorkers.push(vm.subContractors[index]);
              vm.subContractors.splice(index, 1);
            }
          }
        });
      }
    };

    vm.selectWorkerType = function (workerType) {
      switch (workerType) {
        case 1:
          vm.availableWorkers = vm.workers;
          break;

        case 2:
          vm.availableWorkers = vm.subContractors;
          break;

        case 3:
          vm.availableWorkers = vm.groups;
          break;
      }
    };

    vm.selectWorker = function (workerId) {
      if (angular.isUndefined(workerId)) return;
      var index = vm.availableWorkers.findIndex(function (x) {
        return x._id === workerId;
      });

      if (index > -1) {
        var worker = vm.availableWorkers[index];

        if (worker.type === 'group') {
          if (worker.leader) {
            worker.leader.type = 'worker';
            worker.leader.name = worker.leader.displayName;
            vm.selectedWorkers.push(worker.leader);
          }

          if (worker.employees) {
            worker.employees.forEach(function (employee) {
              employee.type = 'worker';
              employee.name = employee.displayName;
              vm.selectedWorkers.push(employee);
            });
          }
        } else {
          vm.selectedWorkers.push(worker);
        }

        vm.availableWorkers.splice(index, 1);
        vm.selectedWorkerId = undefined;
      }
    };

    vm.removeWorker = function (index) {
      var worker = vm.selectedWorkers[index];
      var workerType = worker.workerType;
      var availableWorkers = undefined;

      switch (workerType) {
        case 'worker':
          availableWorkers = vm.workers;
          break;

        case 'subcontractor':
          availableWorkers = vm.subContractors;
          break;
      }

      vm.selectedWorkers.splice(index, 1);

      if (availableWorkers) {
        availableWorkers.push(worker);
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onAdd = function () {
      if (vm.selectedWorkers.length === 0) {
        Notification.error('Please select workers.');
        return;
      }

      vm.modalInstance.close(vm.selectedWorkers);
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('addTaskModal', {
    controller: addTaskModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/timeline/modals/addTaskModal/addTaskModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function addTaskModal($scope, localStorageService, globals, utils, Notification) {
    var companyStore = globals.companyStore;
    $scope.companyData = companyStore.get();
    var vm = this;
    var wholeTasks = [];
    vm.mainTasks = [];
    vm.dependencyTasks = [];
    vm.workers = [];
    vm.subContractors = [];
    vm.groups = [];
    vm.resources = [];
    vm.workLevels = [];
    vm.workTypes = [];
    vm.taskType = 'Main';
    vm.mainTaskId = undefined;
    vm.taskName = undefined;
    vm.dependency = undefined;
    vm.description = undefined;
    vm.startDate = undefined;
    vm.endDate = undefined;
    vm.resourceType = undefined;
    vm.resourceId = undefined;
    vm.selectedWorkers = [];
    vm.workLevel = undefined;
    vm.workType = undefined;
    vm.resourceTypes = [{
      name: 'Employee',
      id: 'worker'
    }, {
      name: 'Sub-Contractor',
      id: 'subcontractor'
    }, {
      name: 'Group',
      id: 'group'
    }];
    gantt.eachTask(function (task) {
      if (task.$virtual) return;

      if (task.type === gantt.config.types.project) {
        vm.mainTasks.push(task);
      } else if (task.type === gantt.config.types.task) {
        wholeTasks.push(task);

        if (!task.parent) {
          vm.dependencyTasks.push(task);
        }
      }
    });

    vm.$onInit = function () {
      vm.workers = [];
      vm.subContractors = [];
      vm.groups = [];
      vm.workers.pushAll(vm.resolve.workers);
      vm.subContractors.pushAll(vm.resolve.subContractors);
      vm.groups.pushAll(vm.resolve.groups);
      vm.workLevels = vm.resolve.workLevels;
      vm.workTypes = vm.resolve.workTypes;
      var selectedTask = vm.resolve.selectedTask;

      if (selectedTask) {
        if (selectedTask.type === gantt.config.types.project) {
          vm.taskType = 'Sub';
          vm.mainTaskId = selectedTask.id;
        } else {
          var parent = gantt.getParent(selectedTask.id);

          if (parent !== 0) {
            vm.taskType = 'Sub';
            vm.mainTaskId = parent;
            vm.dependencyTasks = wholeTasks.filter(function (task) {
              return task.parent === vm.mainTaskId;
            });
          }
        }
      }
    };

    vm.selectTaskType = function () {
      vm.mainTaskId = undefined;
    };

    vm.selectMainTask = function () {
      vm.dependencyTasks = wholeTasks.filter(function (task) {
        return task.parent === vm.mainTaskId;
      });
    };

    vm.selectResourceType = function (type) {
      switch (type) {
        case 'worker':
          vm.resources = vm.workers;
          break;

        case 'subcontractor':
          vm.resources = vm.subContractors;
          break;

        case 'group':
          vm.resources = vm.groups;
          break;
      }
    };

    vm.addResource = function () {
      if (angular.isUndefined(vm.resourceId)) {
        Notification.error('Please select resources');
        return;
      }

      var index = vm.resources.findIndex(function (x) {
        return x._id === vm.resourceId;
      });

      if (index !== -1) {
        var resource = vm.resources[index];
        vm.resources.splice(index, 1);

        if (resource && vm.selectedWorkers.findIndex(function (x) {
          return x._id === vm.resourceId;
        }) === -1) {
          vm.selectedWorkers.push(resource);
        }
      }

      vm.resourceId = undefined;
    };

    vm.removeResource = function (index) {
      var worker = vm.selectedWorkers[index];
      vm.selectedWorkers.splice(index, 1);

      switch (worker.workerType) {
        case 'worker':
          vm.workers.push(worker);
          break;

        case 'subcontractor':
          vm.subContractors.push(worker);
          break;

        case 'group':
          vm.groups.push(worker);
          break;
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onAdd = function () {
      if (vm.taskType === 'Sub' && angular.isUndefined(vm.mainTaskId)) {
        Notification.error('Please select main task.');
        return;
      }

      if (utils.isEmpty(vm.taskName)) {
        Notification.error('Please input task name.');
        return;
      }

      if (!vm.startDate) {
        Notification.error('Please input start date');
        return;
      }

      if (!vm.endDate) {
        Notification.error('Please input due date');
        return;
      }

      if (angular.isUndefined(vm.workLevel)) {
        Notification.error('Please select level');
        return;
      }

      if (angular.isUndefined(vm.workType)) {
        Notification.error('Please input type');
        return;
      }

      var startDate = new Date(vm.startDate);
      var endDate = new Date(vm.endDate);

      if (startDate > endDate) {
        Notification.error('End date cannot be before than start date.');
        return;
      }

      var resources = [];
      var ids = [];

      if (vm.selectedWorkers) {
        vm.selectedWorkers.forEach(function (w) {
          resources.push({
            id: w._id,
            name: w.name,
            avatar: w.profilePic,
            type: w.type === 'worker' ? 1 : 2
          });
          ids.push(w._id);
        });
      }

      var task = {
        id: utils.bsonId(),
        text: vm.taskName,
        description: vm.description,
        type: gantt.config.types.task,
        start_date: startDate,
        end_date: endDate,
        resources: resources,
        resourceIds: ids,
        dependency: vm.dependency,
        workLevel: vm.workLevel,
        workType: vm.workType,
        calcHours: utils.getWorkingHours(startDate, endDate),
        workedHours: 0,
        progress: 0,
        delay: 0,
        composeState: 'new',
        status: 0
      };

      if (vm.mainTaskId) {
        task.parent = vm.mainTaskId;
      }

      var link = undefined;

      if (vm.dependency) {
        link = {
          id: utils.bsonId(),
          source: vm.dependency,
          target: task.id,
          type: gantt.config.links.finish_to_start,
          workType: $scope.type
        };
      }

      gantt.batchUpdate(function () {
        gantt.addTask(task);

        if (link) {
          gantt.addLink(link);
        }
      });
      vm.modalInstance.close(task);
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module("app").directive("workersBox", workersBox);

  function workersBox() {
    return {
      restrict: "E",
      templateUrl: "app/main/timeline/directives/workers-box/workers-box.view.html",
      scope: {
        workers: '=',
        onClose: '&'
      },
      link: function link() {}
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module("app").directive("weathersBox", weathersBox);

  function weathersBox(globals, apiFactory, $log, Notification) {
    return {
      restrict: "E",
      templateUrl: "app/main/timeline/directives/weathers-box/weathers-box.view.html",
      scope: {
        onClose: '&'
      },
      link: function link($scope) {
        function getWindData(wind) {
          if (angular.isUndefined(wind) || !wind.length) {
            return {
              velocity: 'Unknown',
              direction: 'Unkown'
            };
          } else {
            var arr = wind.split(',');

            if (arr.length < 2) {
              return {
                velocity: 'Unknown',
                direction: 'Unkown'
              };
            } else {
              var arr2 = arr[1].split('from');
              return {
                velocity: arr2[0],
                direction: arr2[1].trim() === 'undefined' ? undefined : arr2[1]
              };
            }
          }
        }

        function formatWeatherData(data) {
          data.minTempString = '/ ' + data.minTemp + '°';

          if (angular.isDefined(data.maxTime)) {
            data.timeString = data.minTime + ' - ' + data.maxTime;
          } else {
            data.timeString = data.minTimeString;
          }
        }

        function analyzeWeatherData(weatherData) {
          $scope.weatherList = [];
          weatherData.forEach(function (w) {
            var weather = {
              date: w.date,
              threeHour: []
            };

            for (var i = 0; i < w.threeHour.length; i++) {
              var d = w.threeHour[i];
              var prevData = weather.threeHour[weather.threeHour.length - 1];

              var _getWindData = getWindData(d.wind),
                  velocity = _getWindData.velocity,
                  direction = _getWindData.direction;

              if (angular.isUndefined(prevData) || d.type !== prevData.type) {
                var data = {};
                data.type = d.type;
                data.maxTemp = Number.parseInt(d.temp);
                data.minTemp = Number.parseInt(d.temp);
                data.precipitation = Number.parseFloat(d.precipitation);
                data.minTimeString = d.time;
                data.minTime = d.time.replace(' am', '').replace(' pm', '');
                data.maxTime = undefined;

                switch (d.type.toLowerCase()) {
                  case 'clear':
                    data["class"] = 'sunny';
                    data.icon = '/assets/images/timeline/weather-condition-sunny.svg';
                    data.condition = 'Sunny';
                    break;

                  case 'snow':
                    data["class"] = 'snowy';
                    data.icon = '/assets/images/timeline/weather-condition-snowy.svg';
                    data.condition = 'Snowy';
                    break;

                  case 'thunderstoms':
                    data["class"] = 'thunderstoms';
                    data.icon = '/assets/images/timeline/weather-condition-thunderstorms.svg';
                    data.condition = 'Thunderstorm';
                    break;

                  case 'rain':
                    data["class"] = 'rainy';
                    data.icon = '/assets/images/timeline/weather-condition-rainy.svg';
                    data.condition = 'Rainy';
                    break;

                  case 'clouds':
                    data["class"] = 'cloudy';
                    data.icon = '/assets/images/timeline/weather-condition-cloudy.svg';
                    data.condition = 'Cloudy';
                    break;
                }

                data.velocity = Number.parseFloat(velocity.replace('m/s', ''));
                data.direction = direction;
                formatWeatherData(data);
                weather.threeHour.push(data);
              } else {
                prevData.maxTemp = Math.max(Number.parseInt(d.temp), prevData.maxTemp);
                prevData.minTemp = Math.min(Number.parseInt(d.temp), prevData.minTemp);
                prevData.precipitation = Math.max(Number.parseFloat(d.precipitation), prevData.precipitation);
                prevData.maxTime = d.time.replace(' am', '').replace(' pm', '');
                prevData.velocity = Math.max(Number.parseFloat(velocity.replace('m/s', '')), prevData.velocity);

                if (angular.isUndefined(prevData.direction)) {
                  prevData.direction = direction;
                }

                formatWeatherData(prevData);
              }
            }

            $scope.weatherList.push(weather);
          });
        }

        function initData() {
          var projectStore = globals.projectStore;
          var selectedProject = projectStore.get();

          if (angular.isDefined(selectedProject) && angular.isObject(selectedProject) && selectedProject.address) {
            var currentLocation = selectedProject.address.loc.coordinates;
            apiFactory.createWeatherReport({
              latitude: currentLocation[0],
              longitude: currentLocation[1]
            }).then(function (resp) {
              analyzeWeatherData(resp.data.data);
            })["catch"](function (e) {
              $log.error(e);
              Notification.error("Location Not Found");
            });
          }
        }

        initData();
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("timelineSelectbox", timelineSelectbox);

  function timelineSelectbox() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/main/timeline/directives/timeline-selectbox/timeline-selectbox.view.html',
      scope: {
        ngModel: "=",
        options: "=",
        excludeItems: "=",
        isClickOpen: "@",
        placeholder: "@",
        labelField: "@",
        valueField: "@",
        selectEvent: "&",
        onClose: "&",
        toTop: "=",
        readonly: '=',
        isDisabled: '@',
        isStatus: '@',
        isPriority: '@'
      },
      link: function link(scope, element) {
        scope.isOpen = false;
        scope.cOptions = [];
        scope.selectedLabel = scope.placeholder;

        if (!scope.isClickOpen) {
          scope.isClickOpen = false;
        }

        if (angular.isDefined(scope.ngModel) && scope.options) {
          if (scope.ngModel != {}) {
            var selectedItem = scope.options.find(function (item) {
              return item[scope.valueField] == scope.ngModel;
            });
            if (selectedItem) scope.selectedLabel = selectedItem[scope.labelField];
          }
        }

        var expression = element.attr("exclude-items");
        scope.$parent.$watch(expression, function (newVal) {
          scope.filterExcludeOptions(newVal);
        });

        scope.filterExcludeOptions = function (excludeList) {
          if (excludeList && excludeList.length) {
            var newOptions = [];
            scope.cOptions.map(function (it) {
              if (!excludeList.includes(it[scope.labelField])) {
                newOptions.push(it);
              }
            });
            scope.cOptions = newOptions;
          }
        };

        scope.toggleList = function () {
          if (scope.readonly) return;
          scope.isOpen = !scope.isOpen;

          if (scope.isOpen) {
            scope.cOptions = scope.options;

            if (scope.isSearch) {
              scope.searchFunction(scope.selectedLabel);
            }

            scope.filterExcludeOptions(scope.excludeItems);
          }
        };

        scope.updateData = function () {
          if (scope.options && angular.isDefined(scope.ngModel)) {
            var _selectedItem = scope.options.find(function (item) {
              return item[scope.valueField] == scope.ngModel;
            });

            if (_selectedItem) scope.selectedLabel = _selectedItem[scope.labelField];
          } else {
            scope.selectedLabel = scope.placeholder;
          }

          scope.selectEvent({
            value: scope.ngModel
          });
        };

        scope.$watch('ngModel', function (newVal, oldVal) {
          if (newVal != oldVal) {
            scope.updateData();
          }
        });
        scope.$watch('options', function (newVal, oldVal) {
          var newLength = 0;
          var oldLength = 0;

          if (newVal) {
            newLength = newVal.length;
          }

          if (oldVal) {
            oldLength = oldVal.length;
          }

          if (newLength != oldLength) {
            scope.updateData();
          }
        });

        scope.selectItem = function (item) {
          if (scope.ngModel != item[scope.valueField]) {
            scope.ngModel = item[scope.valueField];
            scope.selectedLabel = item[scope.labelField];
          }

          scope.isOpen = false;
          scope.isselectedItem = true;
        };

        scope.closeList = function () {
          scope.isOpen = false;

          if (!scope.isselectedItem && scope.options) {
            for (var i = 0; i < scope.options.length; i++) {
              if (scope.options[i][scope.valueField] == scope.ngModel) {
                scope.originLabel = scope.options[i][scope.labelField];
              }
            }

            if (!scope.placeholder) {
              scope.selectedLabel = scope.originLabel;
            }
          }

          scope.onClose();
        };

        scope.openList = function () {
          if (scope.readonly) return;
          scope.isOpen = true;
          scope.cOptions = scope.options; // if (scope.isSearch) {
          //   scope.searchFunction(scope.selectedLabel);
          // }

          scope.filterExcludeOptions(scope.excludeItems);
        };

        scope.startSearch = function () {
          scope.isOpen = true;
        };

        scope.searchFunction = function (searchText) {
          scope.isselectedItem = false;
          var output = [];

          if (searchText || searchText == '') {
            if (searchText.length >= 0) {
              angular.forEach(scope.options, function (item) {
                if (item[scope.labelField].toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                  output.push(item);
                }
              });
            }
          }

          scope.cOptions = output;
          scope.filterExcludeOptions(scope.excludeItems);
        };

        scope.getColorClass = function () {
          if (scope.isPriority) {
            return {
              'white': true
            };
          }

          switch (scope.ngModel) {
            case 0:
              // not started
              return {
                'gray': true
              };

            case 1:
              // on going
              return {
                'blue': true
              };

            case 2:
              // on hold
              return {
                'red': true
              };

            case 3:
              // completed
              return {
                'green': true
              };

            default:
              return {
                'gray': true
              };
          }
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("taskComment", taskComment);

  function taskComment($uibModal) {
    return {
      restrict: "E",
      templateUrl: "app/main/timeline/directives/task-comment/task-comment.view.html",
      scope: {
        ngModel: "=",
        fetchComments: "&",
        taskId: '=',
        isFirst: '@'
      },
      link: function link($scope) {
        $scope.expandReplies = function () {
          $scope.ngModel.expand = !$scope.ngModel.expand;
        };

        $scope.toggleReplyCommentModal = function () {
          var modal = $uibModal.open({
            animation: true,
            component: 'taskCommentReplyModal',
            windowClass: 'task-comment-reply-modal',
            resolve: {
              data: function data() {
                return {
                  comment: $scope.ngModel,
                  taskId: $scope.taskId
                };
              }
            }
          });
          modal.result.then(function () {
            $scope.fetchComments();
          }, function () {});
        };
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module("app").directive("notificationsBox", notificationsBox);

  function notificationsBox() {
    return {
      restrict: "E",
      templateUrl: "app/main/timeline/directives/notifications-box/notifications-box.view.html",
      scope: {
        notifications: '=',
        onClose: '&'
      },
      link: function link($scope) {
        $scope.markAsRead = function () {};

        $scope.deleteNotifications = function () {};
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').directive("modelViewer", modelViewer);

  function modelViewer($timeout, $log, apiFactory, Bim, VP) {
    return {
      restrict: "E",
      templateUrl: "app/main/timeline/directives/modelViewer/modelViewer.view.html",
      replace: true,
      scope: {
        data: "=",
        refresh: "="
      },
      link: function link(scope) {
        var viewerElement = angular.element("#timeline-model-view")[0];
        var bimModel = undefined;
        var playMarker = undefined;
        var viewer3d = Bim.simpleViewer(viewerElement, 'high');
        viewer3d.initialize();
        viewer3d.setDragAction('orbit');
        viewer3d.setVisible(false);
        var viewer2d = VP.simpleViewer(viewerElement);
        viewer2d.setVisible(false);
        scope.$watch('data', function (newValue, oldValue) {
          if (angular.isUndefined(newValue)) {
            viewer3d.clear();
            viewer2d.clear();
            return;
          }

          if (angular.isUndefined(oldValue)) {
            loadModel();
          } else {
            if (newValue.modelId !== oldValue.modelId) {
              loadModel();
            } else {
              if (newValue.modelType === '3d' && newValue.objectId !== oldValue.objectId) {
                viewer3d.selectObject(newValue.objectId);
              }
            }
          }
        });
        scope.$watch(function () {
          return viewerElement.clientWidth;
        }, function (newVal) {
          if (newVal) {
            viewer3d.setSize(viewerElement.clientWidth, viewerElement.clientHeight);
            viewer2d.setSize(viewerElement.clientWidth, viewerElement.clientHeight);
          }
        });
        scope.$watch(function () {
          return viewerElement.clientHeight;
        }, function (newVal) {
          if (newVal) {
            viewer3d.setSize(viewerElement.clientWidth, viewerElement.clientHeight);
            viewer2d.setSize(viewerElement.clientWidth, viewerElement.clientHeight);
          }
        });

        scope.refresh = function () {
          if (angular.isDefined(viewer3d)) {
            viewer3d.setSize();
          }
        };

        scope.playModel = function () {
          if (!bimModel) return;
          var playData = preparePlay();
          if (playData.tasks.length === 0) return;
          $timeout(function () {
            processPlay(playData.tasks, playData.tasks[0].start_date, playData.lastDate);
          }, 500);
        };

        function loadModel() {
          viewer3d.clear();
          viewer2d.clear();
          viewer3d.setVisible(false);
          viewer2d.setVisible(false);

          if (scope.data.modelType === '3d') {
            showLoading();
            viewer3d.setVisible(true);
            apiFactory.get3dModel(scope.data.modelId).then(function (resp) {
              if (resp.data.data) {
                viewer3d.loadBim(resp.data.data).then(function () {
                  bimModel = viewer3d.getBimModel();
                  viewer3d.selectObject(scope.data.objectId);
                  hideLoading();
                })["catch"](function (err) {
                  $log.error(err);
                  hideLoading();
                });
              } else {
                hideLoading();
              }
            })["catch"](function (e) {
              $log.error(e);
              hideLoading();
            });
          } else if (scope.data.modelType === 'vp') {
            showLoading();
            viewer2d.setVisible(true);
            apiFactory.getRoofPlan(scope.data.modelId).then(function (resp) {
              var plan = resp.data.data;
              viewer2d.loadPlan(plan).then(function () {
                hideLoading();
              })["catch"](function (err) {
                $log.error(err);
                hideLoading();
              });
            })["catch"](function (e) {
              $log.error(e);
              hideLoading();
            });
          }
        }

        function showLoading() {
          angular.element('#timeline-model-viewer-loading').css('display', 'flex');
        }

        function hideLoading() {
          angular.element('#timeline-model-viewer-loading').css('display', 'none');
        }

        function preparePlay() {
          var tasks = [];
          var lastDate = undefined;
          gantt.eachTask(function (task) {
            if (task.type !== gantt.config.types.task || !task.start_date || !task.end_date || !task.modelId || task.modelId !== scope.data.modelId || task.modelType !== scope.data.modelType || !task.objectId) {
              return;
            }

            var endDate = new Date(task.end_date);
            tasks.push({
              id: task.id,
              start_date: new Date(task.start_date),
              end_date: endDate,
              objectId: task.objectId
            });

            if (!lastDate || lastDate.getTime() < endDate.getTime()) {
              lastDate = new Date(endDate);
            }
          });

          if (tasks.length > 0) {
            tasks.sort(function (a, b) {
              return a.start_date.getTime() - b.start_date.getTime();
            });
            bimModel.setAllItemVisible(false);
            viewer3d.invalidate();
            var date = new Date(tasks[0].start_date);
            playMarker = gantt.addMarker({
              start_date: date,
              css: "today",
              text: ""
            });
            gantt.renderMarkers();
            gantt.showDate(date);
          }

          return {
            tasks: tasks,
            lastDate: lastDate
          };
        }

        function processPlay(tasks, date, lastDate) {
          var showedTasks = tasks.filter(function (task) {
            return task.end_date.getTime() <= date.getTime();
          });

          if (showedTasks.length > 0) {
            showedTasks.forEach(function (task) {
              var item = bimModel.getItem(task.objectId);

              if (item) {
                bimModel.setItemVisible(item, true);
              }
            });
            viewer3d.invalidate();
          }

          if (playMarker) {
            var marker = gantt.getMarker(playMarker);
            marker.start_date = new Date(date);
            gantt.updateMarker(playMarker);
            gantt.showDate(date);
          }

          var next = new Date(date).addDays(1);

          if (next.getTime() < lastDate.getTime()) {
            $timeout(function () {
              processPlay(tasks, next, lastDate);
            }, 100);
          } else {
            releasePlay();
          }
        }

        function releasePlay() {
          bimModel.setAllItemVisible(true);
          viewer3d.invalidate();

          if (playMarker) {
            gantt.deleteMarker(playMarker);
            playMarker = undefined;
          }
        }
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').directive('miniGantt', miniGantt);

  function miniGantt($document, $window) {
    return {
      restrict: "E",
      templateUrl: 'app/main/timeline/directives/miniGantt/miniGantt.view.html',
      replace: true,
      scope: {
        ganttTasks: "="
      },
      link: function link($scope) {
        $scope.ELEMENT_WIDTH = 176;
        $scope.COLORS = ['#4299E1', 'linear-gradient(180deg, #797979 0%, #444444 100%)', '#ff5959', '#4dc9f6', '#f67019', '#f53794', '#537bc4', '#acc236', '#166a8f', '#00a950', '#58595b', '#8549ba'];

        function dragElement(element) {
          var pos1 = 0,
              pos2 = 0;
          element.onmousedown = dragMouseDown;

          function dragMouseDown(e) {
            e = e || $window.event;
            e.preventDefault(); // get the mouse cursor position at startup:

            pos2 = e.clientX;
            $document[0].onmouseup = closeDragElement; // call a function whenever the cursor moves:

            $document[0].onmousemove = elementDrag;
          }

          function elementDrag(e) {
            e = e || $window.event;
            e.preventDefault(); // calculate the new cursor position:

            pos1 = pos2 - e.clientX;
            pos2 = e.clientX; // set the element's new position:

            var elementId = element.id;

            if (elementId.startsWith("combine-cell-")) {
              elementId = elementId.substring(13);
              var indexValue = parseInt(elementId, 10);
              var min = 0;

              if (indexValue > 0) {
                min = getMarginLeft(getCellElement(indexValue - 1));
              }

              var prevMargin = setMarginLeft(element, pos1, min);
              var percentage = $scope.getPercentage(indexValue - 1);
              $scope.ganttTasks[indexValue].percentage = percentage;
              var percentageElement = getPercentageElement(indexValue - 1);

              if (percentageElement) {
                percentageElement.innerHTML = percentage + '%';
              }

              if (prevMargin.changed) {
                for (var i = indexValue + 1; i < $scope.ganttTasks.length; i++) {
                  var el = getCellElement(i);
                  prevMargin = setMarginLeft(el, pos1, prevMargin.value);
                }
              }
            }
          }

          function closeDragElement() {
            /* stop moving when mouse button is released:*/
            $document[0].onmouseup = null;
            $document[0].onmousemove = null;
          }

          function setMarginLeft(element, delta, min) {
            var max = min + $scope.ELEMENT_WIDTH;
            var value = getMarginLeft(element);
            var old = value;
            value = value - delta;
            if (value < min) value = min;
            if (value > max) value = max;

            if (value !== old) {
              element.style.marginLeft = value + "px";
              return {
                value: value,
                changed: true
              };
            }

            return {
              value: value,
              changed: false
            };
          }

          dragMouseDown();
        }

        $scope.elementMouseDown = function ($event) {
          var target = $event.target;

          if (target) {
            if (!target.classList.contains('combine-cell')) {
              target = target.parentElement;
            }

            dragElement(target);
          }
        };

        $scope.getCellStyle = function (index) {
          var value = 0;

          if (index > 0) {
            var element = getCellElement(index);
            value = getMarginLeft(element);

            if (value === 0) {
              element = getCellElement(index - 1);
              value = getMarginLeft(element);
              value += $scope.ELEMENT_WIDTH * $scope.ganttTasks[index].percentage * 0.01;
            }
          }

          return {
            'margin-left': value + "px"
          };
        };

        $scope.getPercentage = function (index) {
          var margin = 0;
          var value = 0;
          var main = getCellElement(index);

          if (main) {
            margin = getMarginLeft(main);
          }

          var next = getCellElement(index + 1);

          if (next) {
            var leftValue = getMarginLeft(next) - margin;
            value = Math.round(leftValue * 100 / $scope.ELEMENT_WIDTH);
          }

          return value;
        };

        function getMarginLeft(element) {
          var style = element.currentStyle || $window.getComputedStyle(element);
          return parseInt(style.marginLeft, 10);
        }

        function getCellElement(index) {
          return $document[0].getElementById("combine-cell-" + index);
        }

        function getPercentageElement(index) {
          return $document[0].getElementById("combine-cell-percentage-" + index);
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("mainGantt", mainGantt);

  function mainGantt($rootScope, $compile, $document, $log, $timeout, utils) {
    return {
      restrict: "A",
      scope: {
        data: "=",
        graphData: "=",
        showOverlay: "=",
        resources: "=",
        groups: "=",
        scale: "=",
        zoom: "=",
        search: "=",
        searchType: "=",
        groupType: "=",
        weather: "=",
        styles: "=",
        resourceMode: "=",
        deadline: "=",
        currentResources: "=",
        onTaskChanged: "=",
        onTaskDropped: "=",
        onTaskSelected: "=",
        onTaskUpdated: "&",
        onEditTask: "=",
        onWorkerCount: "=",
        onTotalCount: "=",
        onAddWorker: "=",
        onRemoveWorker: "=",
        onWorkerHours: "="
      },
      transclude: true,
      template: "<div id='main-gantt' class='no-zoom'><div ng-transclude></div></div>",
      link: function link($scope) {
        var resourceStore;
        var resourceMode = "hours";
        var resourceMap = {};
        var columnWidth = 24;
        var drag_id = null;
        var container = undefined;
        var TaskStyles = ['blue', //'#537bc4',
        'sky', //'#4dc9f6',
        'orange', //'#f67019',
        'pink', //'#f53794',
        'yellow', //'#acc236',
        'd-green', //'#166a8f',
        'green', //'#00a950',
        'grey', //'#58595b',
        'purple' //'#8549ba',
        ];
        var mainConfig = {
          scale_height: dp(43),
          row_height: dp(32),
          task_height: dp(18),
          columns: [{
            name: "wbs",
            label: "#",
            align: "left",
            width: dp(50),
            template: gantt.getWBSCode
          }, {
            name: "text",
            label: "Title",
            tree: true,
            width: '*',
            min_width: dp(180),
            template: function template(task) {
              return "<span title=\"".concat(task.text, "\">").concat(task.text, "</span>");
            }
          }, {
            name: "start_date",
            label: "Start<br/>Date",
            align: "center",
            width: dp(80),
            min_width: dp(80),
            template: function template(task) {
              return moment(task.start_date).format("D MMM, YYYY");
            }
          }, {
            name: "end_date",
            label: "End<br/>Date",
            align: "center",
            width: dp(80),
            min_width: dp(80),
            template: function template(task) {
              return moment(task.end_date).format("D MMM, YYYY");
            }
          }, {
            name: "status",
            label: "Status",
            align: "center",
            width: dp(40),
            template: function template(task) {
              switch (task.status) {
                case 0:
                  return '<img src="/assets/icons/status-waiting.svg" title="Not Started" alt="">';

                case 1:
                  return '<img src="/assets/icons/status-working.svg" title="On Going" alt="">';

                case 2:
                  return '<img src="/assets/icons/status-warning.svg" title="On Hold" alt="">';

                case 3:
                  return '<img src="/assets/icons/status-completed.svg" title="Completed" alt="">';

                case 4:
                  return '<img src="/assets/icons/status-warning.svg" title="Delayed" alt="">';

                default:
                  return '<img src="/assets/icons/status-waiting.svg" title="Not Started" alt="">';
              }
            }
          }, {
            name: "progress",
            label: "Percent<br/>Complete",
            align: "center",
            width: dp(50),
            template: function template(task) {
              return Math.ceil(task.progress * 100) + '%';
            }
          }, {
            name: "delay",
            label: "Delay",
            align: "center",
            width: dp(50),
            template: function template(task) {
              var delay = utils.num(task.delay);
              return "<div class=\"delay ".concat(delay > 0.5 ? 'delay-warning' : delay > 0 ? 'delay-small' : '', "\">").concat(Math.ceil(delay * 100), "%</div>");
            }
          }, // {
          //   name: "duration", label: "Est.<br/>Hours", align: "center", width: 50, template: function(task) {
          //     let duration = Math.ceil(utils.num(task.duration));
          //     return duration < 1 ? 1 : duration;
          //   }
          // },
          {
            name: "calc_duration",
            label: "Calc.<br/>Hours",
            align: "center",
            width: dp(50),
            template: function template(task) {
              return utils.getRoundNumWithLocale(utils.num(task.calcHours), 2, 'en');
            }
          }, {
            name: "days",
            label: "Working<br/>Days",
            align: "center",
            width: dp(60),
            template: function template(task) {
              var days = Math.ceil(parseFloat(task.duration) / 8.0);
              return days < 1 ? 1 : days;
            }
          }, {
            name: "needs",
            label: "Required<br/>Workers",
            align: "center",
            width: dp(40),
            template: function template(task) {
              return utils.num(task.requiredWorkerCount);
            }
          }, {
            name: "resources",
            label: "Resources",
            align: "center",
            width: 100,
            min_width: dp(100),
            template: function template(task) {
              var content = '<div class="d-flex h-100">';
              var assignments = [];
              getAssignments(task, assignments);

              if (!assignments.length) {
                content += "<div class=\"resource-avatar unassigned my-auto\"></div>unassigned";
              } else {
                if (assignments.length === 1) {
                  var resource = assignments[0];

                  if (resource) {
                    content += makeResourceAvatar(resource);
                  }
                } else {
                  content += makeResourceAvatar(assignments[0]);
                  content += makeResourceAvatar(assignments[1]);

                  if (assignments.length > 2) {
                    content += "+".concat(assignments.length - 2, " more");
                  }
                }
              }

              content += '</div>';
              return content;
            }
          }]
        };
        var simpleResourceConfig = {
          scale_height: 0,
          row_height: dp(26),
          columns: [{
            name: "number",
            label: "R",
            align: "center",
            width: dp(30),
            template: function template(resource) {
              return resource.id;
            }
          }, {
            name: "name",
            label: "name",
            align: "left",
            width: '*',
            min_width: dp(180),
            template: function template(resource) {
              return resource.text;
            }
          }, {
            name: "count",
            label: "count",
            align: "center",
            width: dp(180),
            template: function template(resource) {
              return $scope.onTotalCount ? $scope.onTotalCount(resource.id) : 0;
            }
          }]
        };
        var resourceLabelConfig = {
          scale_height: dp(40),
          columns: [{
            name: "text",
            label: "Name",
            width: dp(180)
          }, {
            name: "group",
            label: "Group",
            tree: true,
            width: dp(110)
          }, {
            name: "progress",
            label: "Complete",
            width: dp(60),
            align: "center"
          }, {
            name: "workload",
            label: "Workload",
            width: dp(80),
            align: "center"
          }, {
            name: "capacity",
            label: "Capacity",
            width: dp(80),
            align: "center"
          }, {
            name: 'worker',
            label: '<div class="d-flex">' + '<img id="plus-worker" class="cursor-point ml-auto" src="/assets/icons/plus-user.svg" alt="">' + '<img id="filter-worker" class="cursor-point ml-10 mr-20" src="/assets/icons/filter-sm.svg" alt="">' + '</div>',
            width: dp(70)
          }]
        };
        var resourceConfig = {
          scale_height: 0,
          row_height: dp(26),
          columns: [{
            name: "text",
            label: "Name",
            tree: true,
            width: dp(180),
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return resource.text;
              }

              if (resource.avatar) {
                return "<div class=\"d-flex\"><img src=\"".concat(resource.avatar, "\" class=\"resource-avatar\"  alt=\"avatar\"/>").concat(resource.text, "</div>");
              } else {
                return "<div class=\"d-flex\"><div class=\"resource-avatar my-auto\">".concat(resource.text ? resource.text.charAt(0).toUpperCase() : 'A', "</div>").concat(resource.text, "</div>");
              }
            }
          }, {
            name: "group",
            label: "Group",
            width: dp(110),
            template: function template(resource) {
              return resource.groupName ? resource.groupName : '';
            }
          }, {
            name: "progress",
            label: "Complete",
            width: dp(60),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                var tasks = gantt.getTaskBy('resourceIds', resource.id);
                var totalDuration = 0;
                var workDuration = 0;
                tasks.forEach(function (task) {
                  totalDuration += task.duration;
                  workDuration += task.duration * utils.num(task.progress);
                });
                var progress = totalDuration === 0 ? 0 : utils.num(Math.ceil(workDuration * 100 / totalDuration));
                return "".concat(progress, "%");
              }
            }
          }, {
            name: "workload",
            label: "Workload",
            width: dp(80),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                var tasks = gantt.getTaskBy('resourceIds', resource.id);
                var totalDuration = 0;
                tasks.forEach(function (task) {
                  totalDuration += task.duration;
                });
                return (totalDuration || 0) + "h";
              }
            }
          }, {
            name: "capacity",
            label: "Capacity",
            width: dp(80),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                // let store = gantt.getDatastore(gantt.config.resource_store);
                // let n = store.hasChild(resource.id) ? store.getChildren(resource.id).length : 1
                var state = gantt.getState();
                return gantt.calculateDuration(state.min_date, state.max_date) * 8 + "h"; //* n * 8 + "h";
              }
            }
          }, {
            name: "worker",
            label: "Worker",
            width: dp(68),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                return "<img src=\"/assets/icons/delete1.svg\" class=\"cursor-point\" name=\"remove-worker\" id=\"".concat(resource.id, "\" alt=\"\" />");
              }
            }
          }]
        };
        var defaultLayout = {
          css: "gantt_container",
          cols: [{
            rows: [{
              config: mainConfig,
              cols: [{
                width: dp(580),
                min_width: dp(400),
                rows: [{
                  view: "grid",
                  scrollX: "gridScroll",
                  scrollY: "scrollVer",
                  scrollable: true
                }]
              }, {
                view: "timeline",
                scrollX: "scrollHor",
                scrollY: "scrollVer"
              }]
            }, {
              id: "resource",
              css: "gantt-resource",
              height: dp(52),
              config: simpleResourceConfig,
              cols: [{
                width: dp(580),
                min_width: dp(400),
                rows: [{
                  view: "resourceGrid",
                  scrollX: "gridScroll",
                  scrollable: true
                }, {
                  view: "scrollbar",
                  id: "gridScroll",
                  scroll: "x"
                }]
              }, {
                rows: [{
                  view: "resourceTimeline",
                  scrollX: "scrollHor"
                }, {
                  view: "scrollbar",
                  id: "scrollHor",
                  group: "horizontal"
                }]
              }]
            }]
          }, {
            view: "scrollbar",
            id: "scrollVer",
            group: "vertical"
          }]
        };
        var resourceLayout = {
          css: "gantt_container",
          rows: [{
            config: mainConfig,
            cols: [{
              width: dp(580),
              min_width: dp(400),
              rows: [{
                view: "grid",
                scrollX: "gridScroll",
                scrollY: "scrollVer",
                scrollable: true
              }]
            }, {
              view: "timeline",
              scrollX: "scrollHor",
              scrollY: "scrollVer"
            }, {
              view: "scrollbar",
              id: "scrollVer",
              group: "horizontal"
            }]
          }, {
            resizer: true,
            width: 1,
            next: "resource"
          }, {
            height: dp(40),
            config: resourceLabelConfig,
            cols: [{
              view: "grid",
              width: dp(580),
              min_width: dp(400)
            }, {
              html: "Resource Usage",
              css: "resource-usage"
            }]
          }, {
            id: "resource",
            css: "gantt-resource",
            height: dp(104),
            config: resourceConfig,
            cols: [{
              width: dp(580),
              min_width: dp(400),
              rows: [{
                view: "resourceGrid",
                scrollX: "gridScroll",
                scrollY: "resourceVScroll",
                scrollable: true
              }, {
                view: "scrollbar",
                id: "gridScroll",
                scroll: "x"
              }]
            }, {
              rows: [{
                view: "resourceTimeline",
                scrollX: "scrollHor",
                scrollY: "resourceVScroll"
              }, {
                view: "scrollbar",
                id: "scrollHor",
                group: "horizontal"
              }]
            }, {
              view: "scrollbar",
              id: "resourceVScroll",
              group: "vertical"
            }]
          }]
        };
        initGanttConfig();
        $timeout(function () {
          return gantt.init('main-gantt');
        });

        function initGanttConfig() {
          gantt.plugins({
            auto_scheduling: true,
            grouping: true,
            marker: true,
            overlay: true
          }); // gantt config

          gantt.config.show_errors = false;
          gantt.config.static_background = false;
          gantt.config.show_task_cells = true;
          gantt.config.smart_scales = true;
          gantt.config.smart_rendering = true;
          gantt.config.show_progress = true;
          gantt.config.work_time = true;
          gantt.config.duration_unit = "hour";
          gantt.config.round_dnd_dates = false;
          gantt.config.min_duration = 24 * 3600000; // 1 day

          gantt.config.skip_off_time = false;
          gantt.config.order_branch = true;
          gantt.config.order_branch_free = false;
          gantt.config.fit_tasks = false;
          gantt.config.open_tree_initially = true;
          gantt.config.grid_resize = false;
          gantt.config.drag_links = false;
          gantt.config.drag_progress = false;
          gantt.config.drag_project = true;
          gantt.config.link_line_width = 1;
          gantt.config.show_links = false;
          gantt.config.auto_scheduling = true;
          gantt.config.auto_scheduling_initial = false;
          gantt.config.resource_store = "resource";
          gantt.config.resource_property = "resourceIds";
          gantt.config.layout = $scope.resourceMode ? resourceLayout : defaultLayout;
          gantt.config.resource_render_empty_cells = !$scope.resourceMode; // renderer

          gantt.config.type_renderers[gantt.config.types.project] = function (task) {
            if (gantt.isSplitTask(task)) return;
            var taskClass = getTaskClass(task.$virtual && $scope.groupType === 'workType' ? task.text : task.workType);
            var element = $document[0].createElement("div");
            element.setAttribute(gantt.config.task_attribute, task.id);
            var size = gantt.getTaskPosition(task);
            element.innerHTML = "<div class=\"gantt_task_content\"><div class='project-left'></div><div class='project-right'></div><div class=\"project-text\">".concat(task.text, "</div></div>");
            element.classList.add("gantt-group");
            element.classList.add(taskClass);
            element.classList.add("gantt_project");
            element.classList.add("gantt_bar_project");
            element.classList.add("gantt_dependent_task");
            element.style.left = size.left + "px";
            element.style.top = size.top + dp(6) + "px";
            element.style.width = size.width + "px";
            $compile(element)($scope);
            return element;
          };

          gantt.config.type_renderers[gantt.config.types.task] = function (task, defaultRender) {
            var element = defaultRender(task);
            if (!element) return;

            if (task.project) {
              element.classList.add("custom-project");
              $compile(element)($scope);
            } else {
              element.setAttribute("droppable", "");
              element.setAttribute("drop-data", "\"".concat(task.id, "\""));
              element.setAttribute("drop-event", "onTaskDropped");
              $compile(element)($scope);
            }

            return element;
          }; // gantt template


          gantt.templates.grid_header_class = function () {
            return "timeline-header-cell";
          };

          gantt.templates.grid_row_class = function (start, end, task) {
            if (drag_id && task.id !== drag_id) {
              if (task.parent !== gantt.getTask(drag_id).parent) {
                return "cant-drop";
              }
            }

            return "";
          };

          gantt.templates.task_class = function (start, end, task) {
            return getTaskClass(task.workType);
          };

          gantt.templates.task_row_class = function () {
            return "gantt-task-row";
          };

          gantt.templates.timeline_cell_class = function (task, date) {
            if (date.getDay() === 0 || date.getDay() === 6) {
              return 'weekend';
            }
          };

          gantt.templates.link_class = function (link) {
            var style = getTaskClass(link.workType);
            if (link.flag) style += ' ' + link.flag;
            return style;
          };

          gantt.templates.task_text = function (start, end, task) {
            return "<span class=\"task-text\">".concat(task.text, "</span><span class=\"progress-text\">").concat(Math.ceil(task.progress * 100), "%</span>");
          };

          gantt.templates.rightside_text = function () {
            return '';
          };

          gantt.templates.resource_cell_class = function (start, end, resource, tasks) {
            var css = [];
            css.push("resource_marker");

            if ($scope.resourceMode) {
              var scale = (end - start) / 3600000;
              if (scale !== 1) scale /= 3;
              var hours = getWorkerHours(resource, start, end, tasks);

              if (hours === scale) {
                css.push("workday_ok");
              } else if (hours > scale) {
                css.push("workday_over");
              } else {
                css.push("workday_less");
              }
            }

            return css.join(" ");
          };

          gantt.templates.resource_cell_value = function (start, end, resource, tasks) {
            var html = "<div>";

            if ($scope.resourceMode) {
              if (resourceMode === "hours") {
                html += getWorkerHours(resource, start, end, tasks);
              } else {
                html += tasks.length;
              }
            } else {
              var count = $scope.onWorkerCount ? $scope.onWorkerCount(gantt, start, end) : {
                working: 0,
                required: 0
              };

              if (resource.id === 'W') {
                html += count.working;
              } else {
                html += count.required;
              }
            }

            html += "</div>";
            return html;
          }; // resource store


          resourceStore = gantt.createDatastore({
            name: gantt.config.resource_store,
            type: "treeDatastore"
          });
          resourceStore.attachEvent("onAfterSelect", function () {
            gantt.refreshData();
          }); // set working time

          gantt.setWorkTime({
            hours: [10, 18]
          }); // lightbox

          gantt.showLightbox = function (taskId) {
            var task = gantt.getTask(taskId);

            if (task.type === gantt.config.types.task && $scope.onEditTask) {
              $scope.onEditTask(task);
            }

            return false;
          };

          gantt.hideLightbox = function () {}; // event


          gantt.attachEvent("onTaskDrag", function (id, mode, task) {
            var state = gantt.getState();
            var minDate = state.min_date,
                maxDate = state.max_date;
            var scaleStep = gantt.date.add(new Date(), state.scale_step * 3, state.scale_unit) - new Date();
            var showDate,
                repaint = false;

            if (mode === "resize" || mode === "move") {
              if (Math.abs(task.start_date - minDate) < scaleStep) {
                showDate = task.start_date;
                repaint = true;
              } else if (Math.abs(task.end_date - maxDate) < scaleStep) {
                showDate = task.end_date;
                repaint = true;
              } else {
                var range = gantt.getSubtaskDates();

                if (range.start_date && range.end_date) {
                  if (Math.abs(range.start_date - minDate) > scaleStep) {
                    repaint = true;
                    showDate = null;
                  } else if (Math.abs(maxDate - range.end_date) > scaleStep) {
                    repaint = true;
                    showDate = null;
                  }
                }
              }

              if (repaint) {
                gantt.render();

                if (showDate) {
                  gantt.showDate(showDate);
                }
              }
            }
          });
          gantt.attachEvent("onAfterTaskDrag", function (id, mode) {
            if (mode === "resize" || mode === "move") {
              if (angular.isDefined($scope.onTaskChanged)) {
                $scope.onTaskChanged(id, gantt.getTask(id));
              }
            }
          });
          gantt.attachEvent("onBeforeTaskDisplay", function (id, task) {
            return angular.isUndefined(task.show) || task.show;
          });
          gantt.attachEvent("onTaskSelected", function (id) {
            if (angular.isDefined($scope.onTaskSelected)) {
              $scope.onTaskSelected(id);
            }
          });
          gantt.attachEvent("onAfterTaskUpdate", function () {
            $scope.onTaskUpdated();
          });
          gantt.attachEvent("onLinkDblClick", function () {
            return false;
          });
          gantt.attachEvent("onRowDragStart", function (id) {
            drag_id = id;
            return true;
          });
          gantt.attachEvent("onRowDragEnd", function () {
            drag_id = null;
            gantt.render();
          });
          gantt.attachEvent("onBeforeTaskMove", function (id, parent) {
            return gantt.getTask(id).parent === parent;
          }); // gantt.attachEvent("onBeforeRowDragEnd", function(id, target) {
          //   return gantt.getTask(id).parent === target.parent;
          // });
          // markers

          gantt.attachEvent("onGanttRender", function () {
            addMarker('today', new Date(), 'TODAY');

            if ($scope.deadline) {
              addMarker('deadline', $scope.deadline, 'END');
            } else {
              removeMarker('deadline');
            }

            if (gantt.$container && container !== gantt.$container) {
              gantt.event(gantt.$container, "click", function (e) {
                var target = e.target; // check if the target element is our button:

                if (target.closest("[name='remove-worker']")) {
                  // if it's the resource button - do the action
                  var row = target.closest("[data-resource-id]");
                  var resourceId = row.getAttribute("data-resource-id");
                  $scope.onRemoveWorker(resourceId);
                }
              });
              container = gantt.$container;
            }
          });
        }

        function setScaleConfig(value) {
          var cssForScale = function cssForScale(date) {
            var weekday = date.getDay();

            if (weekday === 0 || weekday === 6) {
              return 'subscale scale-weekend';
            }

            return 'subscale';
          };

          switch (value) {
            case "day":
              gantt.config.scale_unit = "day";
              gantt.config.step = 1;
              gantt.config.date_scale = "%d %M";
              gantt.config.subscales = [{
                unit: "hour",
                step: 1,
                date: "%H",
                css: cssForScale
              }];
              gantt.templates.date_scale = null;
              columnWidth = dp(24);
              break;

            case "week":
              gantt.config.scale_unit = "week";
              gantt.config.step = 1;

              gantt.templates.date_scale = function (date) {
                var dateToStr = gantt.date.date_to_str("%d %M");
                var startDate = gantt.date.week_start(new Date(date));
                var endDate = gantt.date.add(gantt.date.add(startDate, 1, "week"), -1, "day");
                return dateToStr(startDate) + " - " + dateToStr(endDate);
              };

              gantt.config.subscales = [{
                unit: "day",
                step: 1,
                date: "%D",
                css: cssForScale
              }];
              columnWidth = dp(24);
              break;

            case "month":
              gantt.config.scale_unit = "month";
              gantt.config.date_scale = "%F %Y";
              gantt.config.subscales = [{
                unit: "day",
                step: 1,
                date: "%j",
                css: cssForScale
              }];
              gantt.templates.date_scale = null;
              columnWidth = dp(24);
              break;

            case "quarter":
              gantt.config.scale_unit = "month";
              gantt.config.step = 1;
              gantt.config.date_scale = "%M";
              gantt.templates.date_scale = null;
              gantt.config.subscales = [{
                unit: "quarter",
                step: 1,
                template: function template(date) {
                  var dateToStr = gantt.date.date_to_str("%M");
                  var endDate = gantt.date.add(gantt.date.add(date, 3, "month"), -1, "day");
                  return dateToStr(date) + " - " + dateToStr(endDate);
                },
                css: cssForScale
              }];
              columnWidth = dp(30);
              break;

            case "year":
              gantt.config.scale_unit = "year";
              gantt.config.step = 1;
              gantt.config.date_scale = "%Y";
              gantt.config.min_column_width = 50 * $scope.zoom;
              gantt.templates.date_scale = null;
              gantt.config.subscales = [{
                unit: "month",
                step: 1,
                date: "%M",
                css: cssForScale
              }];
              columnWidth = dp(40);
              break;
          }

          gantt.config.min_column_width = columnWidth * $scope.zoom;
          gantt.config.start_on_monday = false;
        }

        function searchGantt(keyword, type) {
          if (angular.isUndefined(keyword)) return;
          gantt.eachTask(function (task) {
            if (keyword === '') {
              task.show = true;
            } else {
              if (type === 'type') {
                task.show = angular.isDefined(task.workType) && task.workType.indexOf(keyword) !== -1;
              } else if (type === 'worker') {
                task.show = false;

                if (task.resources) {
                  for (var i = 0; i < task.resources.length; i++) {
                    if (task.resources[i].name && task.resources[i].name.indexOf(keyword) !== -1) {
                      task.show = true;
                      break;
                    }
                  }
                }
              } else {
                task.show = angular.isUndefined(task.text) || task.text.indexOf(keyword) !== -1;
              }
            }
          });
          gantt.refreshData();
        }

        function getWorkerHours(resource, start, end, tasks) {
          if ($scope.onWorkerHours) {
            var hours = $scope.onWorkerHours({
              id: resource.id,
              type: resource.parent
            }, start, end, tasks);
            return Math.ceil(hours);
          }

          return 0;
        }

        function getAssignments(task, assignments) {
          if (gantt.hasChild(task.id)) {
            var children = gantt.getChildren(task.id);

            for (var i = 0; i < children.length; i++) {
              getAssignments(gantt.getTask(children[i]), assignments);
            }
          } else {
            (function () {
              var resources = task.resources;

              if (resources) {
                var _loop = function _loop(_i) {
                  if (assignments.findIndex(function (x) {
                    return x.id === resources[_i].id;
                  }) === -1) {
                    assignments.push(resources[_i]);
                  }
                };

                for (var _i = 0; _i < resources.length; _i++) {
                  _loop(_i);
                }
              }
            })();
          }
        }

        function makeResourceAvatar(resource) {
          if (!resource) return '';

          if (resource.avatar) {
            return "<img src=\"".concat(resource.avatar, "\" class=\"resource-avatar my-auto\" alt=\"\" />");
          } else {
            return "<div class=\"resource-avatar my-auto\">".concat(resource.name ? resource.name.charAt(0).toUpperCase() : 'A', "</div>");
          }
        }

        function getTaskClass(workType) {
          if (!workType) return 'none';
          var index = utils.num($scope.styles[workType]);
          return TaskStyles[index % TaskStyles.length];
        }

        function addMarker(id, date, text) {
          var marker = angular.element("#" + id);

          if (!marker.length) {
            var elem = $document[0].createElement("div");
            elem.classList.add('gantt-marker');
            elem.classList.add(id);
            elem.id = id;
            elem.innerHTML = "<div class=\"top\">".concat(text, "</div><div class=\"line\"></div>");

            if (gantt.$task) {
              gantt.$task.appendChild(elem);
            }

            marker = angular.element(elem);
          }

          var pos = gantt.posFromDate(date) - 7;
          marker.css("left", pos + "px");
        }

        function removeMarker(id) {
          var marker = angular.element("#" + id);

          if (marker.length && gantt.$task) {
            gantt.$task.removeChild(marker[0]);
          }
        }

        function setupResourceUI() {
          var plusWorker = angular.element('#plus-worker');

          if (plusWorker) {
            gantt.event(plusWorker[0], "click", $scope.onAddWorker);
          }
        }

        function dp(n) {
          return Math.ceil(utils.num(n) * $rootScope.scale);
        }

        function getChartScaleRange() {
          var tasksRange = gantt.getSubtaskDates();
          var cells = [];
          var scale = gantt.getScale();

          if (!tasksRange.start_date) {
            return cells;
          }

          scale.trace_x.forEach(function (date) {
            if (date >= tasksRange.start_date && date <= tasksRange.end_date) {
              cells.push(date);
            }
          });
          return cells;
        }

        var overlayControl = gantt.ext.overlay;
        var myChart = null;
        var lineOverlay = overlayControl.addOverlay(function (container) {
          var scaleLabels = [];
          var values = $scope.graphData.allGraphData;
          var chartScale = getChartScaleRange();
          chartScale.forEach(function (date) {
            scaleLabels.push(moment(date).format("YYYY-MM-DD"));
          });
          var canvas = $document[0].createElement("canvas");
          container.appendChild(canvas);
          canvas.style.height = container.offsetHeight + "px";
          canvas.style.width = container.offsetWidth + "px";
          var ctx = canvas.getContext("2d");

          if (myChart) {
            myChart.destroy();
          }

          myChart = new Chart(ctx, {
            type: "line",
            data: {
              datasets: [{
                label: "Forcast Progress",
                backgroundColor: "#001eff",
                borderColor: "#001eff",
                data: values,
                fill: false,
                cubicInterpolationMode: 'monotone'
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              // layout: {
              //   padding: getScalePaddings()
              // },
              // onResize: function(chart, newSize) {
              //   var dataRange = gantt.getSubtaskDates();
              //   if(dataRange.start_date){
              //     // align chart with the scale range
              //     chart.options.layout.padding = getScalePaddings();
              //   }
              // },
              legend: {
                display: false
              },
              tooltips: {
                mode: "index",
                intersect: false,
                callbacks: {
                  label: function label(tooltipItem, data) {// var dataset = data.datasets[tooltipItem.datasetIndex];
                    // return dataset.label + ": " + dataset.data[tooltipItem.index] + "%";
                  }
                }
              },
              hover: {
                mode: "nearest",
                intersect: true
              },
              scales: {
                xAxes: [{
                  labels: scaleLabels,
                  gridLines: {
                    display: false
                  },
                  ticks: {
                    display: false
                  }
                }, {
                  position: "top",
                  labels: scaleLabels,
                  gridLines: {
                    display: false
                  },
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  display: true,
                  gridLines: {
                    display: false
                  },
                  ticks: {
                    display: true,
                    min: 0,
                    max: 100,
                    stepSize: 10,
                    callback: function callback(current) {// if (current > 100) {return "";}
                      // return current + "%";
                    }
                  }
                }, {
                  display: true,
                  position: "right",
                  gridLines: {
                    display: false
                  },
                  ticks: {
                    display: true,
                    min: 0,
                    max: 100,
                    stepSize: 10,
                    callback: function callback(current) {// if (current > 100) {return "";}
                      // return current + "%";
                    }
                  }
                }]
              }
            }
          });
          return canvas;
        });
        $scope.$watch('showOverlay', function (newValue) {
          if (newValue) {
            gantt.config.readonly = true;
            overlayControl.showOverlay(lineOverlay);
            gantt.$root.classList.add("overlay_visible");
          } else {
            gantt.config.readonly = false;
            overlayControl.hideOverlay(lineOverlay);
            gantt.$root.classList.remove("overlay_visible");
          }

          gantt.clearAll();
          gantt.parse($scope.data, "json");
          resourceStore.parse([{
            id: 'W',
            text: "Working"
          }, {
            id: 'R',
            text: "Required"
          }]);
        });
        $scope.$watch('data', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          $log.log(newValue);
          gantt.clearAll();
          gantt.parse(newValue, "json");
          resourceStore.parse([{
            id: 'W',
            text: "Working"
          }, {
            id: 'R',
            text: "Required"
          }]);
        });
        $scope.$watch('resources', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          for (var i = 0; i < newValue.length; i++) {
            resourceMap[newValue[i].id] = newValue[i];
          }
        });
        $scope.$watch('groups', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          for (var i = 0; i < newValue.length; i++) {
            var group = newValue[i];
            gantt.serverList(group.name, group.data);
          }
        });
        $scope.$watch('scale', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          setScaleConfig(newValue);
          gantt.render();
        });
        $scope.$watch('zoom', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          gantt.config.min_column_width = columnWidth * newValue;
          gantt.render();
        });
        $scope.$watch('search', function (newValue) {
          searchGantt(newValue, $scope.searchType);
        });
        $scope.$watch('searchType', function (newValue) {
          searchGantt($scope.search, newValue);
        });
        $scope.$watch('groupType', function (newValue) {
          if (newValue) {
            gantt.groupBy({
              groups: gantt.serverList(newValue),
              relation_property: newValue,
              group_id: "key",
              group_text: "label"
            });
            gantt.sort("start_date");
          } else {
            gantt.groupBy(false);
          }
        });
        $scope.$watch('resourceMode', function (newValue) {
          if (angular.isDefined(newValue)) {
            gantt.config.resource_render_empty_cells = !newValue;
            gantt.config.layout = newValue ? resourceLayout : defaultLayout;
            gantt.resetLayout();

            if (newValue) {
              resourceStore.clearAll();
              resourceStore.parse($scope.currentResources);
              setupResourceUI();
            } else {
              resourceStore.clearAll();
              resourceStore.parse([{
                id: 'W',
                text: "Working",
                count: 1
              }, {
                id: 'R',
                text: "Required",
                count: 1
              }]);
            }
          }
        });
        $scope.$watch('currentResources', function (newValue) {
          if (angular.isDefined(newValue) && $scope.resourceMode) {
            resourceStore.clearAll();
            resourceStore.parse(newValue);
            setupResourceUI();
          }
        });
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module("app").directive("flowline", flowline);

  function flowline($document, utils, globals, $log, $timeout, apiFactory, Notification) {
    return {
      restrict: "E",
      templateUrl: "app/main/timeline/directives/flowline/flowline.view.html",
      scope: {
        ganttType: '=',
        selectedTask: '=',
        styles: "=",
        refresh: '=',
        showType: '=',
        holidays: '=',
        expanded: '='
      },
      link: function link($scope) {
        var vm = this;
        vm.sections = [];
        vm.tasks = [];
        vm.chart = undefined;
        $scope.selectedSections = [];
        $scope.dates = [];
        vm.labels = [];
        vm.levelTags = [];
        vm.labeledDatasets = [];
        vm.zoom = true;
        vm.projectData = globals.projectStore.get();
        var COLORS = ['#2d74dc', '#00aace', '#ff8b00', '#ff5701', '#acc236', '#166a8f', '#00a950', '#58595b', '#8549ba'];
        var xLen = 0;
        var savedY = undefined;
        var dragStartPoint = {};
        var isDragStartPoint = false;
        var isDragEndPoint = false;
        vm.chartConfig = {
          type: 'scatter',
          data: {
            labels: [],
            datasets: []
          },
          options: {
            responsive: false,
            title: {
              display: false
            },
            tooltips: {
              enabled: false,
              mode: 'point',
              intersect: true
            },
            animation: {
              duration: 0
            },
            scales: {
              xAxes: [{
                display: false,
                type: 'linear',
                ticks: {
                  beginAtZero: true,
                  maxTicksLimit: 1,
                  stepSize: 1
                }
              }],
              yAxes: [{
                display: false,
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 100
                }
              }]
            },
            dragData: true,
            dragX: true,
            dragDataRound: 0,
            onDragStart: function onDragStart(e, element) {
              if (!utils.isEmpty(element)) {
                var dataset = vm.chartConfig.data.datasets[element._datasetIndex];
                dragStartPoint = Object.assign({}, dataset.data[element._index]);

                var _getValidData = getValidData(dataset),
                    startData = _getValidData.startData,
                    endData = _getValidData.endData;

                if (startData.point.x === dragStartPoint.x) {
                  isDragStartPoint = true;
                } else if (endData.point.x === dragStartPoint.x) {
                  isDragEndPoint = true;
                }
              }
            },
            onDrag: function onDrag(e, datasetIndex, index, value) {
              e.target.style.cursor = 'grabbing';
              var dataset = vm.chartConfig.data.datasets[datasetIndex];

              var _getValidData2 = getValidData(dataset),
                  lastIndex = _getValidData2.lastIndex,
                  startData = _getValidData2.startData,
                  endData = _getValidData2.endData;

              var dx = value.x - dragStartPoint.x;

              if (isDragStartPoint) {
                value.y = dragStartPoint.y;
                if (value.x < 0) value.x = 0;
                if (value.x >= endData.point.x) value.x = endData.point.x - 1;
                dataset.data[index] = value;
                updateTaskPeriod(datasetIndex, startData.point.x, true);
              } else if (isDragEndPoint) {
                value.y = dragStartPoint.y;
                if (value.x < startData.point.x + 1) value.x = startData.point.x + 1;
                if (value.x > lastIndex) value.x = lastIndex;
                dataset.data[index] = value;
                updateTaskPeriod(datasetIndex, endData.point.x, false);
              } else {
                if (startData.point.x === 0 && dx < 0 || endData.point.x === lastIndex && dx > 0) {
                  dx = 0;
                }

                for (var i = 0; i < xLen; i++) {
                  var point = dataset.data[i];

                  if (i === index) {
                    point.x = dragStartPoint.x + dx;
                    point.y = dragStartPoint.y;
                  } else {
                    point.x += dx;
                  }
                }

                if (dx) {
                  updateTaskPeriod(datasetIndex, startData.point.x, true);
                  updateTaskPeriod(datasetIndex, endData.point.x, false);
                }
              }

              vm.chart.update();
              makeLabels();
              dragStartPoint = Object.assign({}, value);
            },
            onDragEnd: function onDragEnd(e) {
              e.target.style.cursor = 'default';
              isDragStartPoint = false;
              isDragEndPoint = false;
              makeDatasets();
              makeLabels();
            },
            hover: {
              mode: 'point',
              intersect: true,
              onHover: function onHover(e) {
                var point = this.getElementAtEvent(e);

                if (point.length) {
                  e.target.style.cursor = 'grab';
                } else {
                  e.target.style.cursor = 'default';
                }
              }
            }
          }
        };
        var DEFAULT_DAY_WIDTH = 24;
        var DEFAULT_DAY_HEIGHT = 24;
        var DEFAULT_LEVEL_WIDTH = 60;
        var DEFAULT_LEVEL_HEIGHT = 24;
        var PI = 3.141592;
        var elFlowlineContainer = angular.element('#flowline')[0];
        $scope.flowlineContainerWidth = 0;
        $scope.flowlineContainerHeight = 0;
        var elChartContainer = angular.element('#chart-container')[0];
        $scope.chartContainerWidth = 0;
        $scope.chartContainerHeight = 0;
        $scope.numLevels = 1;
        $scope.levelHeight = 0;
        $scope.dayWidth = 0;

        $scope.getDayStyle = function (year, month, day) {
          var style = {
            width: $scope.dayWidth + 'px'
          };
          var y = year.toString().padStart(4, '0');
          var m = month.toString().padStart(2, '0');
          var d = day.toString().padStart(2, '0');

          if (isHoliday("".concat(y, "-").concat(m, "-").concat(d))) {
            style.background = '#f1f1f1';
          }

          return style;
        };

        function setLevelHeight() {
          if ($scope.numLevels * DEFAULT_LEVEL_HEIGHT < $scope.flowlineContainerHeight) {
            $scope.levelHeight = $scope.flowlineContainerHeight / $scope.numLevels;
          } else {
            $scope.levelHeight = DEFAULT_LEVEL_HEIGHT;
          }
        }

        function setDayWidth() {
          var dayCount = $scope.dates.map(function (x) {
            return x.days.length;
          }).reduce(utils.sumReducer, 0);

          if (dayCount * DEFAULT_DAY_WIDTH < $scope.flowlineContainerWidth) {
            $scope.dayWidth = $scope.flowlineContainerWidth / dayCount;
          } else {
            $scope.dayWidth = DEFAULT_DAY_WIDTH;
          }
        }

        function addDate(date) {
          var title = moment(date).format('MMM YYYY');
          var data = $scope.dates.filter(function (x) {
            return x.title == title;
          })[0];
          var day = date.getDate();

          if (data) {
            var index = data.days.findIndex(function (x) {
              return x == day;
            });

            if (index == -1) {
              data.days.push(day);
            }

            data.days.sort(function (a, b) {
              return a - b;
            });
          } else {
            data = {
              title: title,
              year: date.getFullYear(),
              month: date.getMonth() + 1,
              days: [day]
            };
            $scope.dates.push(data);
          }
        }

        function trimDate(date) {
          date.setHours(0);
          date.setMinutes(0);
          date.setSeconds(0);
        }

        function addDatesFromChildren(task) {
          addDate(task.start_date);
          addDate(task.end_date);
        }

        function loadDates() {
          $scope.dates = [];
          var startDate = new Date(vm.projectData.startDate);
          var endDate = new Date(vm.projectData.endDate);

          if (!utils.isEmpty($scope.selectedTask)) {
            var taskStartDate = $scope.selectedTask.start_date;
            var taskEndDate = $scope.selectedTask.end_date;

            if (taskStartDate < startDate) {
              startDate = taskStartDate;
            }

            if (taskEndDate > endDate) {
              endDate = taskEndDate;
            }
          } else {
            var _iterator = _createForOfIteratorHelper(vm.tasks),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var task = _step.value;

                if (task.start_date < startDate) {
                  startDate = task.start_date;
                }

                if (task.end_date > endDate) {
                  endDate = task.end_date;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }

          startDate = new Date(startDate.getTime() - 3600000 * 24);
          endDate = new Date(endDate.getTime() + 3600000 * 24);
          var daysInMonth = startDate.getDaysInMonth();
          var startGap = daysInMonth - startDate.getDate();

          if (startGap < 3) {
            startDate = new Date(startDate.getTime() - 3600000 * 24 * (3 - startGap));
          }

          if (endDate.getDate() < 3) {
            endDate = new Date(endDate.getTime() + 3600000 * 24 * (3 - endDate.getDate()));
          }

          trimDate(startDate);
          trimDate(endDate);
          addDate(startDate);
          var date = new Date(startDate);
          var oneday = 24 * 3600000;
          var seekday = vm.zoom ? oneday : 7 * oneday; // date.setTime(startDate.getTime() + (vm.zoom ? 1 : 6 - startDate.getDay()) * oneday);

          while (date < endDate) {
            addDate(date);
            date.setTime(date.getTime() + seekday);
          }

          if (endDate.getTime() > startDate.getTime() + seekday) {
            addDate(endDate);
          }

          var _iterator2 = _createForOfIteratorHelper($scope.selectedSections),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var section = _step2.value;

              var _iterator3 = _createForOfIteratorHelper(section.levels),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var level = _step3.value;

                  var _iterator4 = _createForOfIteratorHelper(level.types),
                      _step4;

                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                      var type = _step4.value;

                      var _iterator5 = _createForOfIteratorHelper(type.tasks),
                          _step5;

                      try {
                        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                          var _task2 = _step5.value;
                          addDatesFromChildren(_task2);
                        }
                      } catch (err) {
                        _iterator5.e(err);
                      } finally {
                        _iterator5.f();
                      }
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var firstDate = $scope.dates[0];
          var lastDate = $scope.dates[$scope.dates.length - 1];

          while (firstDate.days[0] > 25) {
            firstDate.days.unshift(firstDate.days[0] - 1);
          }

          while (lastDate.days[lastDate.days.length - 1] < 7) {
            lastDate.days.push(lastDate.days[lastDate.days.length - 1] + 1);
          }

          vm.chartConfig.data.labels = [];
          $scope.dates.forEach(function (date) {
            date.days.forEach(function (day) {
              vm.chartConfig.data.labels.push("".concat(date.year, "-").concat(date.month, "-").concat(day));
            });
          });
        }

        function renderChart() {
          $timeout(function () {
            if (vm.chart) {
              vm.chart.destroy();
            }

            var ctx = $document[0].getElementById('flow-canvas').getContext('2d');
            ctx.canvas.width = $scope.chartContainerWidth;
            ctx.canvas.height = $scope.chartContainerHeight;
            vm.chart = new Chart(ctx, vm.chartConfig);
          }, 0);
          makeDatasets();
          makeLabels();
        }

        function getColor(workType) {
          if (!workType) return COLORS[0];
          var index = utils.num($scope.styles[workType]);
          return COLORS[index % COLORS.length];
        }

        function diffDays(from, to) {
          var strFrom = "".concat(from.getFullYear().toString().padStart(4, '0'), "-").concat((from.getMonth() + 1).toString().padStart(2, '0'), "-").concat(from.getDate().toString().padStart(2, '0'));
          var strTo = "".concat(to.getFullYear().toString().padStart(4, '0'), "-").concat((to.getMonth() + 1).toString().padStart(2, '0'), "-").concat(to.getDate().toString().padStart(2, '0'));
          var mFrom = moment(strFrom);
          var mTo = moment(strTo);
          return mFrom.diff(mTo, 'days');
        }

        function isHoliday(strDate) {
          var date = new Date(strDate);

          if (!utils.isEmpty($scope.holidays)) {
            var _iterator6 = _createForOfIteratorHelper($scope.holidays),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var holidayInfo = _step6.value;
                var startDate = new Date(holidayInfo.startDate);
                var endDate = new Date(holidayInfo.endDate);

                if (date > startDate && date < endDate) {
                  return true;
                }
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
          }

          var day = date.getDay();
          return day == 6 || day == 0;
        }

        function fillDataToDataset(dataset, strDate, x, y) {
          var isHorizontal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

          if (isHorizontal) {
            dataset.data.push({
              x: x,
              y: NaN
            });
            return;
          }

          if (isHoliday(strDate)) {
            dataset.data.push({
              x: x,
              y: angular.isDefined(savedY) ? savedY : y
            });
            dataset.pointBackgroundColor.push('#a3a3a3');
            dataset.pointBorderColor.push('#a3a3a3');
          } else {
            dataset.data.push({
              x: x,
              y: y
            });
            savedY = y;
            dataset.pointBackgroundColor.push(dataset.backgroundColor);
            dataset.pointBorderColor.push(dataset.borderColor);
          }
        }

        function makeDatasetByTask(task, startPercent, endPercent) {
          var color = getColor(task.workType);
          var dataset = Object.assign({}, {
            label: task.text,
            backgroundColor: color,
            borderColor: color,
            showLine: true,
            data: [],
            fill: false,
            lineTension: 0,
            // pointRadius: 0,
            pointRadius: 3,
            // pointHoverRadius: 8,
            pointBackgroundColor: [],
            pointBorderColor: [],
            task: task
          });
          var diffTotal = diffDays(task.end_date, task.start_date);

          if (diffTotal > 0) {
            vm.chartConfig.data.labels.forEach(function (label, index) {
              var date = new Date(label);
              var diff = diffDays(date, task.start_date);

              if (diff == 0) {
                fillDataToDataset(dataset, label, index, startPercent);
              } else if (diff == diffTotal) {
                fillDataToDataset(dataset, label, index, endPercent);
              } else if (diff < 0) {
                fillDataToDataset(dataset, label, index, NaN);
              } else if (diff > diffTotal) {
                var lastValue = dataset.data[dataset.data.length - 1];

                if (lastValue.y == endPercent || !lastValue.y) {
                  fillDataToDataset(dataset, label, index, NaN);
                } else {
                  fillDataToDataset(dataset, label, index, endPercent);
                }
              } else if (diff > 0 && diff < diffTotal) {
                var percent = diff / diffTotal * (endPercent - startPercent) + startPercent;
                fillDataToDataset(dataset, label, index, percent);
              }
            });
          } else if (diffTotal == 0) {
            for (var i = 0; i < vm.chartConfig.data.labels.length; i++) {
              var label = vm.chartConfig.data.labels[i];
              var date = new Date(label);
              var diff = diffDays(date, task.start_date);

              if (diff == 0) {
                fillDataToDataset(dataset, label, i, startPercent);
                fillDataToDataset(dataset, label, ++i, endPercent);
              } else {
                fillDataToDataset(dataset, label, i, NaN);
              }
            }
          } else {
            vm.chartConfig.data.labels.forEach(function (label, index) {
              fillDataToDataset(dataset, label, index, NaN);
            });
          }

          vm.chartConfig.data.datasets.push(dataset);
        }

        function dateWithinPeriodOfType(date, type) {
          var _iterator7 = _createForOfIteratorHelper(type.tasks),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var task = _step7.value;

              if (date > task.start_date && date < task.end_date) {
                return false;
              }
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }

          return true;
        }

        function makeDatasetByType(type, startPercent, endPercent) {
          var color = getColor(type.text);
          var dataset = Object.assign({}, {
            label: type.text,
            backgroundColor: color,
            borderColor: color,
            showLine: true,
            data: [],
            fill: false,
            lineTension: 0,
            // pointRadius: 0,
            pointRadius: 3,
            // pointHoverRadius: 8,
            pointBackgroundColor: [],
            pointBorderColor: []
          });
          var start_date = type.tasks[0].start_date;
          var end_date = type.tasks[type.tasks.length - 1].end_date;
          var diffTotal = diffDays(end_date, start_date);

          if (diffTotal > 0) {
            vm.chartConfig.data.labels.forEach(function (label, index) {
              var date = new Date(label);
              var diff = diffDays(date, start_date);
              var isHorizontal = dateWithinPeriodOfType(date, type);

              if (diff == 0) {
                fillDataToDataset(dataset, label, index, startPercent, isHorizontal);
              } else if (diff == diffTotal) {
                fillDataToDataset(dataset, label, index, endPercent, isHorizontal);
              } else if (diff < 0) {
                fillDataToDataset(dataset, label, index, NaN, isHorizontal);
              } else if (diff > diffTotal) {
                var lastValue = dataset.data[dataset.data.length - 1];

                if (lastValue.y == endPercent || !lastValue.y) {
                  fillDataToDataset(dataset, label, index, NaN, isHorizontal);
                } else {
                  fillDataToDataset(dataset, label, index, endPercent, isHorizontal);
                }
              } else if (diff > 0 && diff < diffTotal) {
                var percent = diff / diffTotal * (endPercent - startPercent) + startPercent;
                fillDataToDataset(dataset, label, index, percent, isHorizontal);
              }
            });
          } else if (diffTotal == 0) {
            for (var i = 0; i < vm.chartConfig.data.labels.length; i++) {
              var label = vm.chartConfig.data.labels[i];
              var date = new Date(label);
              var diff = diffDays(date, start_date);

              if (diff == 0) {
                fillDataToDataset(dataset, label, i, startPercent);
                fillDataToDataset(dataset, label, ++i, endPercent);
              } else {
                fillDataToDataset(dataset, label, i, NaN);
              }
            }
          } else {
            vm.chartConfig.data.labels.forEach(function (label, index) {
              fillDataToDataset(dataset, label, index, NaN);
            });
          }

          vm.chartConfig.data.datasets.push(dataset);
        }

        function makeDatasets() {
          vm.chartConfig.data.datasets = [];
          var levelPercentUnit = Math.round(10000 / $scope.numLevels) / 100;
          var numSections = $scope.selectedSections.length;
          var index = 0;

          for (var i = 0; i < numSections; i++) {
            var section = $scope.selectedSections[i];

            for (var j = 0; j < section.levels.length; j++) {
              var level = section.levels[j];
              var startPercentInLevel = levelPercentUnit * index;
              var endPercentInLevel = levelPercentUnit * (index + 1);

              if ($scope.showType === 'Type') {
                var _iterator8 = _createForOfIteratorHelper(level.types),
                    _step8;

                try {
                  for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                    var type = _step8.value;
                    makeDatasetByType(type, startPercentInLevel, endPercentInLevel);
                  }
                } catch (err) {
                  _iterator8.e(err);
                } finally {
                  _iterator8.f();
                }
              } else {
                (function () {
                  var tasks = [];
                  level.types.forEach(function (type) {
                    tasks.pushAll(type.tasks);
                  });

                  for (var _i = 0, _tasks = tasks; _i < _tasks.length; _i++) {
                    var task = _tasks[_i];
                    makeDatasetByTask(task, startPercentInLevel, endPercentInLevel);
                  }
                })();
              }

              index++;
            }

            xLen = vm.chartConfig.data.labels.length;
            vm.chartConfig.options.scales.xAxes[0].ticks = {
              min: 0,
              max: xLen - 1
            };

            if (vm.chart) {
              vm.chart.update();
            }
          }
        }

        function getValidData(dataset) {
          if (angular.isUndefined(dataset)) {
            return undefined;
          }

          var length = dataset.data.length;
          var lastIndex = length - 1;
          var startData = undefined,
              endData = undefined;

          for (var i = 0; i < length; i++) {
            if (dataset.data[i].y >= 0) {
              startData = {
                index: i,
                point: dataset.data[i]
              };
              break;
            }
          }

          if (angular.isDefined(startData)) {
            for (var _i2 = lastIndex; _i2 > startData.index; _i2--) {
              if (dataset.data[_i2].y >= 0) {
                endData = {
                  index: _i2,
                  point: dataset.data[_i2]
                };
                break;
              }
            }
          }

          return {
            length: length,
            lastIndex: lastIndex,
            startData: startData,
            endData: endData
          };
        }

        function makeLabels() {
          var elLabelsContainer = angular.element('#labels-container');
          elLabelsContainer.css('width', $scope.chartContainerWidth + 'px');
          elLabelsContainer.css('height', $scope.chartContainerHeight + 'px');
          elLabelsContainer = elLabelsContainer[0];

          while (elLabelsContainer.lastChild) {
            elLabelsContainer.removeChild(elLabelsContainer.lastChild);
          }

          vm.labels = [];
          vm.labeledDatasets = [];
          vm.chartConfig.data.datasets.forEach(function (dataset) {
            var _getValidData3 = getValidData(dataset),
                length = _getValidData3.length,
                lastIndex = _getValidData3.lastIndex,
                startData = _getValidData3.startData,
                endData = _getValidData3.endData;

            if (length && lastIndex && angular.isDefined(startData) && angular.isDefined(endData)) {
              var xVector = (endData.point.x - startData.point.x) / length * $scope.chartContainerWidth;
              var yVector = (endData.point.y - startData.point.y) / 100 * $scope.chartContainerHeight;
              var angle = Math.atan(yVector / xVector) / PI * -180;
              var radian = angle / 180;
              var x = startData.point.x / length * $scope.chartContainerWidth;
              var y = dataset.data[startData.index].y / 100 * $scope.chartContainerHeight;
              var div = $document[0].createElement('div');
              div.classList.add('flow-item-label');
              div.style.cssText = ['left:' + x + 'px', 'bottom:' + y + 'px', // 'color:' + dataset.backgroundColor,
              'color: #464646', 'transform: rotate(' + angle + 'deg)'].join(";");
              div.innerText = dataset.label;
              elLabelsContainer.appendChild(div);
              var labelWidth = div.clientWidth;
              var labelHeight = div.clientHeight;
              var labelRadian = Math.atan(labelHeight / labelWidth) / PI * -1;
              x += labelRadian * labelWidth;
              y -= radian * labelWidth;

              if (x < $scope.chartContainerWidth / 2) {
                x += radian * labelWidth;
              }

              div.style.left = x + 'px';
              div.style.bottom = y + 'px';
              vm.labeledDatasets.push(dataset);
            }
          });
        }

        function isValidDate(d) {
          return d instanceof Date && !isNaN(d);
        }

        function updateTaskPeriod(datasetIndex, pointIndex, isStartDate) {
          var dataset = vm.chartConfig.data.datasets[datasetIndex];
          var date = new Date(vm.chartConfig.data.labels[pointIndex]);
          var task = gantt.getTask(dataset.task.id);

          if (isValidDate(date)) {
            if (isStartDate) {
              task.start_date = date;
              dataset.task.start_date = date;
            } else {
              task.end_date = date;
              dataset.task.end_date = date;
            }

            gantt.updateTask(task.id);
          }
        }

        function findTask(levelTask) {
          var childIds = gantt.getChildren(levelTask.id);

          if (utils.isEmpty(childIds)) {
            return levelTask;
          }

          var childTask = gantt.getTask(childIds[0]);
          return findTask(childTask);
        }

        function selectSection(task) {
          var section = angular.copy(findSection(task));

          if (utils.isEmpty(section)) {
            $scope.selectedSections = [];
            $scope.numLevels = 1;
            return;
          }

          if (task.parent) {
            if (!utils.isEmpty(task.workLevel) && !utils.isEmpty(task.workType)) {
              section.levels = section.levels.filter(function (x) {
                return x.text == task.workLevel;
              });

              if (!utils.isEmpty(section.levels)) {
                section.levels.forEach(function (level) {
                  level.types = level.types.filter(function (x) {
                    return x.text == task.workType;
                  });

                  if (!utils.isEmpty(level.types)) {
                    level.types.forEach(function (type) {
                      type.tasks = type.tasks.filter(function (x) {
                        return x.id == task.id;
                      });
                    });
                  }
                });
              }
            } else {
              var _task = findTask(task);

              section.levels = section.levels.filter(function (x) {
                return x.text == _task.workLevel;
              });

              if (task.workType) {
                section.levels.forEach(function (level) {
                  level.types = level.types.filter(function (x) {
                    return x.text == task.workType;
                  });

                  if (!utils.isEmpty(level.types)) {
                    level.types.forEach(function (type) {
                      type.tasks = type.tasks.filter(function (x) {
                        return x.id == task.id;
                      });
                    });
                  }
                });
              }
            }
          }

          $scope.selectedSections = [section];
          $scope.numLevels = utils.isEmpty($scope.selectedSections) ? 1 : $scope.selectedSections.map(function (x) {
            return x.levels.length;
          }).reduce(utils.sumReducer, 0);
        }

        function findSection(task) {
          if (!task.parent) {
            return vm.sections.find(function (x) {
              return x.id == task.id;
            });
          } else {
            return vm.sections.find(function (x) {
              return gantt.isChildOf(task.id, x.id);
            });
          }
        }

        function findLevel(section, task) {
          var level = section.levels.find(function (x) {
            return x.text == task.workLevel;
          });

          if (!level) {
            level = {
              text: task.workLevel,
              weight: getLevelWeight(task.workLevel),
              types: [],
              subSections: []
            };
            section.levels.push(level);
          }

          return level;
        }

        function findType(level, task) {
          var type = level.types.find(function (x) {
            return x.text == task.workType;
          });

          if (!type) {
            type = {
              text: task.workType,
              tasks: []
            };
            level.types.push(type);
          }

          return type;
        }

        function findSubSection(level, task) {
          var parentTaskId = gantt.getParent(task.id);

          if (!parentTaskId) {
            return undefined;
          }

          var parentTask = gantt.getTask(parentTaskId);
          var subSection = level.subSections.find(function (x) {
            return x.text == parentTask.text;
          });

          if (!subSection) {
            subSection = {
              text: parentTask.text,
              tasks: []
            };
            level.subSections.push(subSection);
          }

          return subSection;
        }

        function getLevelWeight(levelName) {
          var levelTag = vm.levelTags.find(function (x) {
            return x.tagName === levelName;
          });

          if (levelTag) {
            var tagValue = levelTag.tagValue;

            if (angular.isUndefined(tagValue)) {
              return 0;
            }

            return Number.parseInt(tagValue);
          } else {
            var num = Number.parseInt(levelName);

            if (isNaN(num)) {
              var name = levelName.toLowerCase();

              switch (name) {
                case 'gf-1':
                  return -1;

                case 'gf-2':
                  return -2;

                case 'gf-3':
                  return -3;

                case 'ground':
                  return 0;

                case 'roof':
                  return 999;

                default:
                  return 0;
              }
            } else {
              return num;
            }
          }
        }

        function loadTasks(ganttTasks) {
          // get tasks
          vm.tasks = ganttTasks.filter(function (x) {
            return !utils.isEmpty(x.workLevel) && !utils.isEmpty(x.workType);
          }); // get sections

          vm.sections = ganttTasks.filter(function (x) {
            return !x.parent && utils.isEmpty(x.workLevel) && utils.isEmpty(x.workType);
          });
          vm.sections = vm.sections.map(function (x) {
            return {
              id: x.id,
              text: x.text,
              start_date: x.start_date,
              end_date: x.end_date,
              levels: []
            };
          });
          vm.sections = vm.sections.sort(function (a, b) {
            return b.start_date.getTime() - a.start_date.getTime();
          }); // make section, level, task structure

          var section, level, type, subSection;

          var _iterator9 = _createForOfIteratorHelper(vm.tasks),
              _step9;

          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var task = _step9.value;
              section = findSection(task);

              if (!section) {
                $log.warn('Cannot find a section for task: ', task.id, task.text);
                continue;
              }

              level = findLevel(section, task);
              type = findType(level, task);
              type.tasks.push(task);
              subSection = findSubSection(level, task);

              if (subSection) {
                subSection.tasks.push(task);
              }
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        }

        function mousewheel(event) {
          event.preventDefault();

          if (!$scope.expanded) {
            return;
          }

          var _zoom = event.deltaY > 0;

          if (vm.zoom !== _zoom) {
            vm.zoom = _zoom;
            loadDates();
            setDayWidth();
            renderChart();
          }
        }

        function init() {
          apiFactory.listAllLevelTypes().then(function (res) {
            vm.levelTags = res.data.list;
            gantt.attachEvent('onParse', function () {
              if (angular.isUndefined($scope.ganttType)) {
                var ganttTasks = [];
                gantt.eachTask(function (task) {
                  ganttTasks.push(angular.copy(task));
                });
                loadTasks(ganttTasks);

                var _iterator10 = _createForOfIteratorHelper(vm.sections),
                    _step10;

                try {
                  for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                    var section = _step10.value;
                    section.levels.sort(function (a, b) {
                      return b.weight - a.weight;
                    });
                  }
                } catch (err) {
                  _iterator10.e(err);
                } finally {
                  _iterator10.f();
                }

                $scope.selectedSections = angular.copy(vm.sections);
                $scope.numLevels = utils.isEmpty($scope.selectedSections) ? 1 : $scope.selectedSections.map(function (x) {
                  return x.levels.length;
                }).reduce(utils.sumReducer, 0);
              }
            });
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
          gantt.attachEvent("onAfterTaskDrag", function (id, mode) {
            if (mode === "resize" || mode === "move") {
              var task = gantt.getTask(id);
              var index = vm.tasks.findIndex(function (x) {
                return x.id === id;
              });

              if (index !== -1) {
                vm.tasks[index] = task;
                $scope.selectedSections.forEach(function (section) {
                  section.levels.forEach(function (level) {
                    level.types.forEach(function (type) {
                      var foundIndex = type.tasks.findIndex(function (x) {
                        return x.id === id;
                      });

                      if (foundIndex !== -1) {
                        type.tasks[foundIndex] = task;
                      }
                    });
                  });
                });
                renderChart();
              }
            }
          });
          var el = $document[0].getElementById('chart-container');

          if (el) {
            el.addEventListener('mousewheel', mousewheel, false);
          }
        }

        init();
        $scope.$watch('selectedTask', function () {
          if (angular.isDefined($scope.selectedTask)) {
            selectSection($scope.selectedTask);
          } else {
            $scope.selectedSections = angular.copy(vm.sections);
            $scope.numLevels = utils.isEmpty($scope.selectedSections) ? 1 : $scope.selectedSections.map(function (x) {
              return x.levels.length;
            }).reduce(utils.sumReducer, 0);
          }

          loadDates();
          renderChart();
        });
        $scope.$watch('chartContainerWidth', function () {
          setLevelHeight();
          renderChart();
        });
        $scope.$watch('chartContainerHeight', function () {
          setLevelHeight();
          renderChart();
        });
        $scope.$watch('showType', function () {
          renderChart();
        });
        $scope.$watch('refresh', function () {
          if ($scope.refresh) {
            renderChart();
            $scope.refresh = false;
          }
        });
        $scope.$watch('ganttType', function () {
          $scope.selectedSections = [];
          $scope.selectedTask = undefined;
        });
        $scope.$watch(function () {
          return elFlowlineContainer.clientWidth;
        }, function (newVal) {
          $scope.flowlineContainerWidth = newVal ? newVal - DEFAULT_LEVEL_WIDTH * 2 : 0;
          setDayWidth();
        });
        $scope.$watch(function () {
          return elFlowlineContainer.clientHeight;
        }, function (newVal) {
          $scope.flowlineContainerHeight = newVal ? newVal - DEFAULT_DAY_HEIGHT * 2 : 0;
          setLevelHeight();
        });
        $scope.$watch(function () {
          return elChartContainer.clientWidth;
        }, function (newVal) {
          $scope.chartContainerWidth = newVal;
        });
        $scope.$watch(function () {
          return elChartContainer.clientHeight;
        }, function (newVal) {
          $scope.chartContainerHeight = newVal;
        });
        $scope.$watch('numLevels', function () {
          setLevelHeight();
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("extraGantt", extraGantt);

  function extraGantt($rootScope, $compile, $document, $log, $timeout, utils) {
    return {
      restrict: "A",
      scope: {
        data: "="
      },
      transclude: true,
      template: "<div id='extra-gantt' class='no-zoom' style='height:calc(100vh - 300px);'><div ng-transclude></div></div>",
      link: function link($scope) {
        var resourceStore;
        var resourceMode = "hours";
        var resourceMap = {};
        var columnWidth = 24;
        var drag_id = null;
        var container = undefined;
        var TaskStyles = ['blue', //'#537bc4',
        'sky', //'#4dc9f6',
        'orange', //'#f67019',
        'pink', //'#f53794',
        'yellow', //'#acc236',
        'd-green', //'#166a8f',
        'green', //'#00a950',
        'grey', //'#58595b',
        'purple' //'#8549ba',
        ];
        var mainConfig = {
          scale_height: dp(43),
          row_height: dp(32),
          task_height: dp(18),
          columns: [{
            name: "wbs",
            label: "#",
            align: "left",
            width: dp(50),
            template: gantt.getWBSCode
          }, {
            name: "text",
            label: "Title",
            tree: true,
            width: '*',
            min_width: dp(180),
            template: function template(task) {
              return "<span title=\"".concat(task.text, "\">").concat(task.text, "</span>");
            }
          }, {
            name: "start_date",
            label: "Start<br/>Date",
            align: "center",
            width: dp(100),
            min_width: dp(100),
            template: function template(task) {
              return moment(task.start_date).format("D MMM, YYYY");
            }
          }, {
            name: "end_date",
            label: "End<br/>Date",
            align: "center",
            width: dp(100),
            min_width: dp(100),
            template: function template(task) {
              return moment(task.end_date).format("D MMM, YYYY");
            }
          }]
        };
        var simpleResourceConfig = {
          scale_height: 0,
          row_height: dp(26),
          columns: [{
            name: "number",
            label: "R",
            align: "center",
            width: dp(30),
            template: function template(resource) {
              return resource.id;
            }
          }, {
            name: "name",
            label: "name",
            align: "left",
            width: '*',
            min_width: dp(180),
            template: function template(resource) {
              return resource.text;
            }
          }, {
            name: "count",
            label: "count",
            align: "center",
            width: dp(180),
            template: function template(resource) {
              return $scope.onTotalCount ? $scope.onTotalCount(resource.id) : 0;
            }
          }]
        };
        var resourceLabelConfig = {
          scale_height: dp(40),
          columns: [{
            name: "text",
            label: "Name",
            width: dp(180)
          }, {
            name: "group",
            label: "Group",
            tree: true,
            width: dp(110)
          }, {
            name: "progress",
            label: "Complete",
            width: dp(60),
            align: "center"
          }, {
            name: "workload",
            label: "Workload",
            width: dp(80),
            align: "center"
          }, {
            name: "capacity",
            label: "Capacity",
            width: dp(80),
            align: "center"
          }, {
            name: 'worker',
            label: '<div class="d-flex">' + '<img id="plus-worker" class="cursor-point ml-auto" src="/assets/icons/plus-user.svg" alt="">' + '<img id="filter-worker" class="cursor-point ml-10 mr-20" src="/assets/icons/filter-sm.svg" alt="">' + '</div>',
            width: dp(70)
          }]
        };
        var resourceConfig = {
          scale_height: 0,
          row_height: dp(26),
          columns: [{
            name: "text",
            label: "Name",
            tree: true,
            width: dp(180),
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return resource.text;
              }

              if (resource.avatar) {
                return "<div class=\"d-flex\"><img src=\"".concat(resource.avatar, "\" class=\"resource-avatar\"  alt=\"avatar\"/>").concat(resource.text, "</div>");
              } else {
                return "<div class=\"d-flex\"><div class=\"resource-avatar my-auto\">".concat(resource.text ? resource.text.charAt(0).toUpperCase() : 'A', "</div>").concat(resource.text, "</div>");
              }
            }
          }, {
            name: "group",
            label: "Group",
            width: dp(110),
            template: function template(resource) {
              return resource.groupName ? resource.groupName : '';
            }
          }, {
            name: "progress",
            label: "Complete",
            width: dp(60),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                var tasks = gantt.getTaskBy('resourceIds', resource.id);
                var totalDuration = 0;
                var workDuration = 0;
                tasks.forEach(function (task) {
                  totalDuration += task.duration;
                  workDuration += task.duration * utils.num(task.progress);
                });
                var progress = totalDuration === 0 ? 0 : utils.num(Math.ceil(workDuration * 100 / totalDuration));
                return "".concat(progress, "%");
              }
            }
          }, {
            name: "workload",
            label: "Workload",
            width: dp(80),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                var tasks = gantt.getTaskBy('resourceIds', resource.id);
                var totalDuration = 0;
                tasks.forEach(function (task) {
                  totalDuration += task.duration;
                });
                return (totalDuration || 0) + "h";
              }
            }
          }, {
            name: "capacity",
            label: "Capacity",
            width: dp(80),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                // let store = gantt.getDatastore(gantt.config.resource_store);
                // let n = store.hasChild(resource.id) ? store.getChildren(resource.id).length : 1
                var state = gantt.getState();
                return gantt.calculateDuration(state.min_date, state.max_date) * 8 + "h"; //* n * 8 + "h";
              }
            }
          }, {
            name: "worker",
            label: "Worker",
            width: dp(68),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                return "<img src=\"/assets/icons/delete1.svg\" class=\"cursor-point\" name=\"remove-worker\" id=\"".concat(resource.id, "\" alt=\"\" />");
              }
            }
          }]
        };
        var defaultLayout = {
          css: "gantt_container",
          cols: [{
            rows: [{
              config: mainConfig,
              cols: [{
                width: dp(580),
                min_width: dp(400),
                rows: [{
                  view: "grid",
                  scrollX: "gridScroll",
                  scrollY: "scrollVer",
                  scrollable: true
                }]
              }, {
                view: "timeline",
                scrollX: "scrollHor",
                scrollY: "scrollVer"
              }]
            }, {
              id: "resource",
              css: "gantt-resource",
              height: dp(52),
              config: simpleResourceConfig,
              cols: [{
                width: dp(580),
                min_width: dp(400),
                rows: [{
                  view: "resourceGrid",
                  scrollX: "gridScroll",
                  scrollable: true
                }, {
                  view: "scrollbar",
                  id: "gridScroll",
                  scroll: "x"
                }]
              }, {
                rows: [{
                  view: "resourceTimeline",
                  scrollX: "scrollHor"
                }, {
                  view: "scrollbar",
                  id: "scrollHor",
                  group: "horizontal"
                }]
              }]
            }]
          }, {
            view: "scrollbar",
            id: "scrollVer",
            group: "vertical"
          }]
        };
        var resourceLayout = {
          css: "gantt_container",
          rows: [{
            config: mainConfig,
            cols: [{
              width: dp(580),
              min_width: dp(400),
              rows: [{
                view: "grid",
                scrollX: "gridScroll",
                scrollY: "scrollVer",
                scrollable: true
              }]
            }, {
              view: "timeline",
              scrollX: "scrollHor",
              scrollY: "scrollVer"
            }, {
              view: "scrollbar",
              id: "scrollVer",
              group: "horizontal"
            }]
          }, {
            resizer: true,
            width: 1,
            next: "resource"
          }, {
            height: dp(40),
            config: resourceLabelConfig,
            cols: [{
              view: "grid",
              width: dp(580),
              min_width: dp(400)
            }, {
              html: "Resource Usage",
              css: "resource-usage"
            }]
          }, {
            id: "resource",
            css: "gantt-resource",
            height: dp(104),
            config: resourceConfig,
            cols: [{
              width: dp(580),
              min_width: dp(400),
              rows: [{
                view: "resourceGrid",
                scrollX: "gridScroll",
                scrollY: "resourceVScroll",
                scrollable: true
              }, {
                view: "scrollbar",
                id: "gridScroll",
                scroll: "x"
              }]
            }, {
              rows: [{
                view: "resourceTimeline",
                scrollX: "scrollHor",
                scrollY: "resourceVScroll"
              }, {
                view: "scrollbar",
                id: "scrollHor",
                group: "horizontal"
              }]
            }, {
              view: "scrollbar",
              id: "resourceVScroll",
              group: "vertical"
            }]
          }]
        };
        initGanttConfig();
        $timeout(function () {
          return gantt.init('extra-gantt');
        });

        function initGanttConfig() {
          gantt.plugins({
            auto_scheduling: true,
            grouping: true,
            marker: true,
            overlay: true
          }); // gantt config

          gantt.config.show_errors = false;
          gantt.config.static_background = false;
          gantt.config.show_task_cells = true;
          gantt.config.smart_scales = true;
          gantt.config.smart_rendering = true;
          gantt.config.show_progress = true;
          gantt.config.work_time = true;
          gantt.config.duration_unit = "hour";
          gantt.config.round_dnd_dates = false;
          gantt.config.min_duration = 24 * 3600000; // 1 day

          gantt.config.skip_off_time = false;
          gantt.config.order_branch = true;
          gantt.config.order_branch_free = false;
          gantt.config.fit_tasks = false;
          gantt.config.open_tree_initially = true;
          gantt.config.grid_resize = false;
          gantt.config.drag_links = true;
          gantt.config.drag_progress = false;
          gantt.config.drag_project = true;
          gantt.config.link_line_width = 1; // gantt.config.show_links = false;

          gantt.config.auto_scheduling = true;
          gantt.config.auto_scheduling_initial = false;
          gantt.config.resource_store = "resource";
          gantt.config.resource_property = "resourceIds";
          gantt.config.layout = $scope.resourceMode ? resourceLayout : defaultLayout;
          gantt.config.resource_render_empty_cells = !$scope.resourceMode; // renderer

          gantt.config.type_renderers[gantt.config.types.project] = function (task) {
            if (gantt.isSplitTask(task)) return;
            var taskClass = getTaskClass(task.$virtual && $scope.groupType === 'workType' ? task.text : task.workType);
            var element = $document[0].createElement("div");
            element.setAttribute(gantt.config.task_attribute, task.id);
            var size = gantt.getTaskPosition(task);
            element.innerHTML = "<div class=\"gantt_task_content\"><div class='project-left'></div><div class='project-right'></div><div class=\"project-text\">".concat(task.text, "</div></div>");
            element.classList.add("gantt-group");
            element.classList.add(taskClass);
            element.classList.add("gantt_project");
            element.classList.add("gantt_bar_project");
            element.classList.add("gantt_dependent_task");
            element.style.left = size.left + "px";
            element.style.top = size.top + dp(6) + "px";
            element.style.width = size.width + "px";
            $compile(element)($scope);
            return element;
          };

          gantt.config.type_renderers[gantt.config.types.task] = function (task, defaultRender) {
            var element = defaultRender(task);
            if (!element) return;

            if (task.project) {
              element.classList.add("custom-project");
              $compile(element)($scope);
            } else {
              element.setAttribute("droppable", "");
              element.setAttribute("drop-data", "\"".concat(task.id, "\""));
              element.setAttribute("drop-event", "onTaskDropped");
              $compile(element)($scope);
            }

            return element;
          }; // gantt template


          gantt.templates.grid_header_class = function () {
            return "timeline-header-cell";
          };

          gantt.templates.grid_row_class = function (start, end, task) {
            if (drag_id && task.id !== drag_id) {
              if (task.parent !== gantt.getTask(drag_id).parent) {
                return "cant-drop";
              }
            }

            return "";
          };

          gantt.templates.task_class = function (start, end, task) {
            return getTaskClass(task.workType);
          };

          gantt.templates.task_row_class = function () {
            return "gantt-task-row";
          };

          gantt.templates.timeline_cell_class = function (task, date) {
            if (date.getDay() === 0 || date.getDay() === 6) {
              return 'weekend';
            }
          };

          gantt.templates.link_class = function (link) {
            var style = getTaskClass(link.workType);
            if (link.flag) style += ' ' + link.flag;
            return style;
          };

          gantt.templates.task_text = function (start, end, task) {
            return "<span class=\"task-text\">".concat(task.text, "</span><span class=\"progress-text\">").concat(Math.ceil(task.progress * 100), "%</span>");
          };

          gantt.templates.rightside_text = function () {
            return '';
          };

          gantt.templates.resource_cell_class = function (start, end, resource, tasks) {
            var css = [];
            css.push("resource_marker");

            if ($scope.resourceMode) {
              var scale = (end - start) / 3600000;
              if (scale !== 1) scale /= 3;
              var hours = getWorkerHours(resource, start, end, tasks);

              if (hours === scale) {
                css.push("workday_ok");
              } else if (hours > scale) {
                css.push("workday_over");
              } else {
                css.push("workday_less");
              }
            }

            return css.join(" ");
          };

          gantt.templates.resource_cell_value = function (start, end, resource, tasks) {
            var html = "<div>";

            if ($scope.resourceMode) {
              if (resourceMode === "hours") {
                html += getWorkerHours(resource, start, end, tasks);
              } else {
                html += tasks.length;
              }
            } else {
              var count = $scope.onWorkerCount ? $scope.onWorkerCount(gantt, start, end) : {
                working: 0,
                required: 0
              };

              if (resource.id === 'W') {
                html += count.working;
              } else {
                html += count.required;
              }
            }

            html += "</div>";
            return html;
          }; // resource store


          resourceStore = gantt.createDatastore({
            name: gantt.config.resource_store,
            type: "treeDatastore"
          });
          resourceStore.attachEvent("onAfterSelect", function () {
            gantt.refreshData();
          }); // set working time

          gantt.setWorkTime({
            hours: [10, 18]
          }); // lightbox

          gantt.showLightbox = function (taskId) {
            var task = gantt.getTask(taskId);

            if (task.type === gantt.config.types.task && $scope.onEditTask) {
              $scope.onEditTask(task);
            }

            return false;
          };

          gantt.hideLightbox = function () {}; // event
          // gantt.attachEvent("onTaskDrag", function (id, mode, task) {
          //   let state = gantt.getState();
          //   let minDate = state.min_date, maxDate = state.max_date;
          //   let scaleStep = gantt.date.add(new Date(), state.scale_step * 3, state.scale_unit) - new Date();
          //   let showDate, repaint = false;
          //   if (mode === "resize" || mode === "move") {
          //     if (Math.abs(task.start_date - minDate) < scaleStep) {
          //       showDate = task.start_date;
          //       repaint = true;
          //     } else if (Math.abs(task.end_date - maxDate) < scaleStep) {
          //       showDate = task.end_date;
          //       repaint = true;
          //     } else {
          //       let range = gantt.getSubtaskDates();
          //       if (range.start_date && range.end_date) {
          //         if (Math.abs(range.start_date - minDate) > scaleStep) {
          //           repaint = true;
          //           showDate = null;
          //         } else if (Math.abs(maxDate - range.end_date) > scaleStep) {
          //           repaint = true;
          //           showDate = null;
          //         }
          //       }
          //     }
          //     if (repaint) {
          //       gantt.render();
          //       if (showDate) {
          //         gantt.showDate(showDate);
          //       }
          //     }
          //   }
          // });
          // gantt.attachEvent("onAfterTaskDrag", function (id, mode) {
          //   if (mode === "resize" || mode === "move") {
          //     if (angular.isDefined($scope.onTaskChanged)) {
          //       $scope.onTaskChanged(id, gantt.getTask(id));
          //     }
          //   }
          // });
          // gantt.attachEvent("onBeforeTaskDisplay", function (id, task) {
          //   return angular.isUndefined(task.show) || task.show;
          // });
          // gantt.attachEvent("onTaskSelected", function (id) {
          //   if (angular.isDefined($scope.onTaskSelected)) {
          //     $scope.onTaskSelected(id);
          //   }
          // });
          // gantt.attachEvent("onAfterTaskUpdate", function () {
          //   $scope.onTaskUpdated();
          // });


          gantt.attachEvent("onLinkDblClick", function () {
            return false;
          });
          gantt.attachEvent("onRowDragStart", function (id) {
            drag_id = id;
            return true;
          });
          gantt.attachEvent("onRowDragEnd", function () {
            drag_id = null;
            gantt.render();
          });
          gantt.attachEvent("onBeforeTaskMove", function (id, parent) {
            return gantt.getTask(id).parent === parent;
          }); // gantt.attachEvent("onBeforeRowDragEnd", function(id, target) {
          //   return gantt.getTask(id).parent === target.parent;
          // });
          // markers

          gantt.attachEvent("onGanttRender", function () {
            addMarker('today', new Date(), 'TODAY');

            if ($scope.deadline) {
              addMarker('deadline', $scope.deadline, 'END');
            } else {
              removeMarker('deadline');
            }

            if (gantt.$container && container !== gantt.$container) {
              gantt.event(gantt.$container, "click", function (e) {
                var target = e.target; // check if the target element is our button:

                if (target.closest("[name='remove-worker']")) {
                  // if it's the resource button - do the action
                  var row = target.closest("[data-resource-id]");
                  var resourceId = row.getAttribute("data-resource-id");
                  $scope.onRemoveWorker(resourceId);
                }
              });
              container = gantt.$container;
            }
          });
        }

        function setScaleConfig(value) {
          var cssForScale = function cssForScale(date) {
            var weekday = date.getDay();

            if (weekday === 0 || weekday === 6) {
              return 'subscale scale-weekend';
            }

            return 'subscale';
          };

          switch (value) {
            case "day":
              gantt.config.scale_unit = "day";
              gantt.config.step = 1;
              gantt.config.date_scale = "%d %M";
              gantt.config.subscales = [{
                unit: "hour",
                step: 1,
                date: "%H",
                css: cssForScale
              }];
              gantt.templates.date_scale = null;
              columnWidth = dp(24);
              break;

            case "week":
              gantt.config.scale_unit = "week";
              gantt.config.step = 1;

              gantt.templates.date_scale = function (date) {
                var dateToStr = gantt.date.date_to_str("%d %M");
                var startDate = gantt.date.week_start(new Date(date));
                var endDate = gantt.date.add(gantt.date.add(startDate, 1, "week"), -1, "day");
                return dateToStr(startDate) + " - " + dateToStr(endDate);
              };

              gantt.config.subscales = [{
                unit: "day",
                step: 1,
                date: "%D",
                css: cssForScale
              }];
              columnWidth = dp(24);
              break;

            case "month":
              gantt.config.scale_unit = "month";
              gantt.config.date_scale = "%F %Y";
              gantt.config.subscales = [{
                unit: "day",
                step: 1,
                date: "%j",
                css: cssForScale
              }];
              gantt.templates.date_scale = null;
              columnWidth = dp(24);
              break;

            case "quarter":
              gantt.config.scale_unit = "month";
              gantt.config.step = 1;
              gantt.config.date_scale = "%M";
              gantt.templates.date_scale = null;
              gantt.config.subscales = [{
                unit: "quarter",
                step: 1,
                template: function template(date) {
                  var dateToStr = gantt.date.date_to_str("%M");
                  var endDate = gantt.date.add(gantt.date.add(date, 3, "month"), -1, "day");
                  return dateToStr(date) + " - " + dateToStr(endDate);
                },
                css: cssForScale
              }];
              columnWidth = dp(30);
              break;

            case "year":
              gantt.config.scale_unit = "year";
              gantt.config.step = 1;
              gantt.config.date_scale = "%Y";
              gantt.config.min_column_width = 50 * $scope.zoom;
              gantt.templates.date_scale = null;
              gantt.config.subscales = [{
                unit: "month",
                step: 1,
                date: "%M",
                css: cssForScale
              }];
              columnWidth = dp(40);
              break;
          }

          gantt.config.min_column_width = columnWidth * $scope.zoom;
          gantt.config.start_on_monday = false;
        }

        function searchGantt(keyword, type) {
          if (angular.isUndefined(keyword)) return;
          gantt.eachTask(function (task) {
            if (keyword === '') {
              task.show = true;
            } else {
              if (type === 'type') {
                task.show = angular.isDefined(task.workType) && task.workType.indexOf(keyword) !== -1;
              } else if (type === 'worker') {
                task.show = false;

                if (task.resources) {
                  for (var i = 0; i < task.resources.length; i++) {
                    if (task.resources[i].name && task.resources[i].name.indexOf(keyword) !== -1) {
                      task.show = true;
                      break;
                    }
                  }
                }
              } else {
                task.show = angular.isUndefined(task.text) || task.text.indexOf(keyword) !== -1;
              }
            }
          });
          gantt.refreshData();
        }

        function getWorkerHours(resource, start, end, tasks) {
          if ($scope.onWorkerHours) {
            var hours = $scope.onWorkerHours({
              id: resource.id,
              type: resource.parent
            }, start, end, tasks);
            return Math.ceil(hours);
          }

          return 0;
        }

        function getAssignments(task, assignments) {
          if (gantt.hasChild(task.id)) {
            var children = gantt.getChildren(task.id);

            for (var i = 0; i < children.length; i++) {
              getAssignments(gantt.getTask(children[i]), assignments);
            }
          } else {
            (function () {
              var resources = task.resources;

              if (resources) {
                var _loop = function _loop(_i) {
                  if (assignments.findIndex(function (x) {
                    return x.id === resources[_i].id;
                  }) === -1) {
                    assignments.push(resources[_i]);
                  }
                };

                for (var _i = 0; _i < resources.length; _i++) {
                  _loop(_i);
                }
              }
            })();
          }
        }

        function makeResourceAvatar(resource) {
          if (!resource) return '';

          if (resource.avatar) {
            return "<img src=\"".concat(resource.avatar, "\" class=\"resource-avatar my-auto\" alt=\"\" />");
          } else {
            return "<div class=\"resource-avatar my-auto\">".concat(resource.name ? resource.name.charAt(0).toUpperCase() : 'A', "</div>");
          }
        }

        function getTaskClass(workType) {
          if (!workType) return 'none';
          var index = utils.num($scope.styles[workType]);
          return TaskStyles[index % TaskStyles.length];
        }

        function addMarker(id, date, text) {
          var marker = angular.element("#" + id);

          if (!marker.length) {
            var elem = $document[0].createElement("div");
            elem.classList.add('gantt-marker');
            elem.classList.add(id);
            elem.id = id;
            elem.innerHTML = "<div class=\"top\">".concat(text, "</div><div class=\"line\"></div>");

            if (gantt.$task) {
              gantt.$task.appendChild(elem);
            }

            marker = angular.element(elem);
          }

          var pos = gantt.posFromDate(date) - 7;
          marker.css("left", pos + "px");
        }

        function removeMarker(id) {
          var marker = angular.element("#" + id);

          if (marker.length && gantt.$task) {
            gantt.$task.removeChild(marker[0]);
          }
        }

        function setupResourceUI() {
          var plusWorker = angular.element('#plus-worker');

          if (plusWorker) {
            gantt.event(plusWorker[0], "click", $scope.onAddWorker);
          }
        }

        function dp(n) {
          return Math.ceil(utils.num(n) * $rootScope.scale);
        }

        function getChartScaleRange() {
          var tasksRange = gantt.getSubtaskDates();
          var cells = [];
          var scale = gantt.getScale();

          if (!tasksRange.start_date) {
            return cells;
          }

          scale.trace_x.forEach(function (date) {
            if (date >= tasksRange.start_date && date <= tasksRange.end_date) {
              cells.push(date);
            }
          });
          return cells;
        }

        var overlayControl = gantt.ext.overlay;
        var myChart = null;
        var lineOverlay = overlayControl.addOverlay(function (container) {
          var scaleLabels = [];
          var values = $scope.graphData.allGraphData;
          var chartScale = getChartScaleRange();
          chartScale.forEach(function (date) {
            scaleLabels.push(moment(date).format("YYYY-MM-DD"));
          });
          var canvas = $document[0].createElement("canvas");
          container.appendChild(canvas);
          canvas.style.height = container.offsetHeight + "px";
          canvas.style.width = container.offsetWidth + "px";
          var ctx = canvas.getContext("2d");

          if (myChart) {
            myChart.destroy();
          }

          myChart = new Chart(ctx, {
            type: "line",
            data: {
              datasets: [{
                label: "Forcast Progress",
                backgroundColor: "#001eff",
                borderColor: "#001eff",
                data: values,
                fill: false,
                cubicInterpolationMode: 'monotone'
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              // layout: {
              //   padding: getScalePaddings()
              // },
              // onResize: function(chart, newSize) {
              //   var dataRange = gantt.getSubtaskDates();
              //   if(dataRange.start_date){
              //     // align chart with the scale range
              //     chart.options.layout.padding = getScalePaddings();
              //   }
              // },
              legend: {
                display: false
              },
              tooltips: {
                mode: "index",
                intersect: false,
                callbacks: {
                  label: function label(tooltipItem, data) {// var dataset = data.datasets[tooltipItem.datasetIndex];
                    // return dataset.label + ": " + dataset.data[tooltipItem.index] + "%";
                  }
                }
              },
              hover: {
                mode: "nearest",
                intersect: true
              },
              scales: {
                xAxes: [{
                  labels: scaleLabels,
                  gridLines: {
                    display: false
                  },
                  ticks: {
                    display: false
                  }
                }, {
                  position: "top",
                  labels: scaleLabels,
                  gridLines: {
                    display: false
                  },
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  display: true,
                  gridLines: {
                    display: false
                  },
                  ticks: {
                    display: true,
                    min: 0,
                    max: 100,
                    stepSize: 10,
                    callback: function callback(current) {// if (current > 100) {return "";}
                      // return current + "%";
                    }
                  }
                }, {
                  display: true,
                  position: "right",
                  gridLines: {
                    display: false
                  },
                  ticks: {
                    display: true,
                    min: 0,
                    max: 100,
                    stepSize: 10,
                    callback: function callback(current) {// if (current > 100) {return "";}
                      // return current + "%";
                    }
                  }
                }]
              }
            }
          });
          return canvas;
        });
        $scope.$watch('data', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          newValue.forEach(function (x) {
            x.id = x._id;
            x.start_date = new Date(x.startDate);
            x.end_date = new Date(x.endDate);
            x.text = x.name;
            x.progress = 0;
            x.duration = 3;
          });
          var tempData = {
            data: newValue,
            links: []
          };
          $log.log(tempData);
          gantt.clearAll();
          gantt.parse(tempData, "json"); // resourceStore.parse([{id: 'W', text: "Working"}, {id: 'R', text: "Required"}]);
        });
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('createMeetingRoomModal', {
    controller: createMeetingRoomModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/synergies/modals/createMeetingRoomModal/createMeetingRoomModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function createMeetingRoomModal($scope, utils, apiFactory, Notification, globals, $log, $document) {
    var vm = this;

    function initDateInput(elementId, date) {
      var calendar = new dhx.Calendar(null, {
        dateFormat: "%m/%d/%Y %H:%i %A",
        css: "dhx_widget--bordered no-zoom",
        timePicker: true
      });
      var popup = new dhx.Popup();
      popup.attach(calendar);
      calendar.events.on("change", function () {
        dateInput.value = calendar.getValue(); // popup.hide();
      });
      var dateInput = $document[0].getElementById(elementId);
      dateInput.addEventListener("click", function () {
        popup.show(dateInput);
      });

      if (angular.isDefined(date)) {
        calendar.setValue(date);
      }
    }

    vm.$onInit = function () {
      vm.groupId = vm.resolve.groupId;
      vm.isCreate = vm.resolve.isCreate;
      vm.inviteMembers = angular.copy(vm.resolve.inviteMembers);
      vm.projectData = globals.projectStore.get();
      vm.userData = globals.userStore.get();
      vm.assignedTo = [];

      if (vm.isCreate) {
        $scope.meetingRoom = {
          projectId: vm.projectData._id,
          groupId: vm.groupId,
          title: undefined,
          description: undefined,
          dateFrom: undefined,
          dateTo: undefined,
          assignedTo: [vm.userData]
        };
      } else {
        $scope.meetingRoom = {
          projectId: vm.projectData._id,
          groupId: vm.groupId,
          title: vm.resolve.meetingRoom.title,
          description: vm.resolve.meetingRoom.description,
          dateFrom: new Date(vm.resolve.meetingRoom.dateFrom),
          dateTo: new Date(vm.resolve.meetingRoom.dateTo),
          assignedTo: angular.copy(vm.resolve.meetingRoom.assignedTo) || []
        };

        var _loop = function _loop(member) {
          var index = vm.inviteMembers.findIndex(function (x) {
            return x._id == member._id;
          });

          if (index !== -1) {
            vm.inviteMembers.splice(index, 1);
          }
        };

        for (var member in $scope.meetingRoom.assignedTo) {
          _loop(member);
        }
      }

      $scope.selectedMemberId = undefined;
      initDateInput('start-date-input', $scope.meetingRoom.dateFrom);
      initDateInput('end-date-input', $scope.meetingRoom.dateTo);
    };

    $scope.addMember = function () {
      var index = vm.inviteMembers.findIndex(function (x) {
        return x._id === $scope.selectedMemberId;
      });

      if (index !== -1) {
        var member = vm.inviteMembers[index];
        $scope.meetingRoom.assignedTo.push(member);
        vm.inviteMembers.splice(index, 1);
        $scope.selectedMemberId = undefined;
      }
    };

    $scope.removeMember = function (index) {
      var member = $scope.meetingRoom.assignedTo[index];
      vm.inviteMembers.push(member);
      $scope.meetingRoom.assignedTo.splice(index, 1);
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty($scope.meetingRoom.title)) {
        Notification.error('Please input title');
        return;
      }

      var startTime = angular.element('#start-date-input').val();
      var endTime = angular.element('#end-date-input').val();

      if (!startTime) {
        Notification.error('Please input start time');
        return;
      }

      if (!endTime) {
        Notification.error('Please input end time');
        return;
      }

      $scope.meetingRoom.dateFrom = new Date(startTime.slice(0, -3));
      $scope.meetingRoom.dateTo = new Date(endTime.slice(0, -3));
      var today = moment();

      if (moment($scope.meetingRoom.dateFrom).diff(today) < 0) {
        Notification.error('Start time must be greater than the current time');
        return;
      }

      if (moment($scope.meetingRoom.dateTo).diff(moment($scope.meetingRoom.dateFrom)) < 0) {
        Notification.error('End time must be greater than the start time');
        return;
      }

      if (utils.isEmpty($scope.meetingRoom.assignedTo) || $scope.meetingRoom.assignedTo.length < 2) {
        Notification.error('Please select members at least 2');
        return;
      }

      var payload = angular.copy($scope.meetingRoom);
      payload.assignedTo = payload.assignedTo.map(function (x) {
        return x._id;
      });
      var API = vm.isCreate ? apiFactory.createMeetingRoom(payload) : apiFactory.updateMeetingRoom(vm.resolve.meetingRoom._id, payload);
      $scope.loading = true;
      API.then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close(res.data.data);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("synergeNavbar", synergeNavbar);

  function synergeNavbar(globals, $state, Notification, authFactory, apiFactory, $rootScope, $log, $uibModal, utils, $window) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/synergies/directives/synerge-navbar/synerge-navbar.view.html',
      scope: {
        selectedTab: "=",
        changeTab: "="
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      var userStore = globals.userStore;
      var userDetail = userStore.get();
      scope.profilePic = userDetail.profilePic;
      scope.userName = userDetail.firstName + userDetail.lastName;
      scope.email = userDetail.email;
      scope.TAB = {
        CHAT: 1,
        CALL: 2,
        MEETINGS: 3,
        CONTACTS: 4
      }; // let AccessLabelList = Object.keys(Constants.AccessKey);
      // let AccessValueList = Object.values(Constants.AccessKey);
      // let dType = globals.getDashboardType(userDetail);
      // if (userDetail.designation === "Admin") {
      //   AccessLabelList.forEach(key => {
      //     scope[key + '_ACCESS_CREATE'] = 4;
      //   })
      // } else {
      //   apiFactory.getAccessSettingDetails({
      //     dType, list: AccessValueList
      //   }).then(res => {
      //     AccessLabelList.forEach(key => {
      //       scope[key + '_ACCESS_CREATE'] = res.data.data[Constants.AccessKey[key]] ? res.data.data[Constants.AccessKey[key]] : 0;
      //     })
      //   })
      //     .catch((e) => {
      //       $log.error(e);
      //       Notification.error('Something went wrong try later')
      //     });
      // }

      scope.goHome = function () {
        $state.go(globals.getDashboardRoute(userDetail));
      };

      scope.toggleEditProfile = function () {
        $uibModal.open({
          animation: true,
          component: 'editProfileModal',
          windowClass: 'edit-profile-modal'
        });
      };

      scope.toggleUpdateStatus = function () {
        $uibModal.open({
          animation: true,
          component: 'updateStatusModal',
          windowClass: 'update-status-modal'
        });
      };

      scope.toggleHelp = function () {
        $window.open('https://cloudes.one', 'blank');
      };

      scope.statusClass = function () {
        switch (userDetail.status) {
          case 'Active':
            return ['active'];

          case 'Away':
            return ['away'];

          case 'Do not disturb':
            return ['disturb'];

          case 'Invisible':
            return ['offline'];

          default:
            return ['active'];
        }
      };
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('settingSummaryModal', {
    controller: SettingSummaryModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/settingSummaryModal/settingSummaryModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function SettingSummaryModal(Notification) {
    var vm = this;
    vm.allFields = [];
    vm.fields = [];
    vm.equation = {
      type: '',
      name: 'SUM',
      expression: '',
      fields: []
    };
    var oldExpression = '';

    vm.$onInit = function () {
      vm.sections = vm.resolve.sections;
      vm.accountPlans = vm.resolve.accountPlans;
      vm.summary = vm.resolve.summary;
      vm.equation.type = vm.summary.equation;
      vm.equation.name = vm.equation.type.toUpperCase();
      vm.fields = [];
      vm.sections.forEach(function (section) {
        return addSectionToField(section);
      });
      vm.accountPlans.forEach(function (accountPlan) {
        return addAccountToField(accountPlan);
      });
      updateSummaryExpression();
    };

    vm.changeExpression = function () {
      if (!processExpression()) {
        var eg = vm.equation.type === 'math' ? 'A1001 - A1002 + A1003' : 'A1001, A1002, A1003';
        Notification.error('Please input expression correctly. eg. ' + eg);
      }
    };

    vm.selectFields = function () {
      var fields = vm.fields.filter(function (field) {
        return !field.selected;
      });
      vm.fields.forEach(function (field) {
        if (field.selected) {
          field.selected = false;
          vm.equation.fields.push(field);
        }
      });
      vm.fields = fields;
      updateSummaryExpression();
    };

    vm.done = function () {
      if (!processExpression()) {
        return;
      }

      vm.modalInstance.close(vm.equation);
    };

    vm.cancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    function addSectionToField(section) {
      var found = vm.summary.fields.find(function (x) {
        return x.type === 'section' && x.number === section.number;
      });
      var field;

      if (found) {
        field = {
          type: found.type,
          number: found.number,
          name: section.name,
          operator: found.operator,
          selected: false
        };
        vm.equation.fields.push(field);
      } else {
        field = {
          type: 'section',
          number: section.number,
          name: section.name,
          operator: '+',
          selected: false
        };
        vm.fields.push(field);
      }

      vm.allFields.push(field);
    }

    function addAccountToField(accountPlan) {
      var found = vm.summary.fields.find(function (x) {
        return x.type === 'account' && x.number === accountPlan.number;
      });
      var field;

      if (found) {
        field = {
          type: found.type,
          number: found.number,
          name: accountPlan.name,
          operator: found.operator,
          selected: false
        };
        vm.equation.fields.push(field);
      } else {
        field = {
          type: 'account',
          number: accountPlan.number,
          name: accountPlan.name,
          operator: '+',
          selected: false
        };
        vm.fields.push(field);
      }

      vm.allFields.push(field);
    }

    function processExpression() {
      if (oldExpression === vm.equation.expression) {
        return true;
      }

      var expression = vm.equation.expression.replace(/\s+/g, '');

      if (vm.equation.type === 'sum' || vm.equation.type === 'avg') {
        if (!/^([AS]\d+)?(?:,([AS]\d+))*$/.test(expression)) {
          return false;
        }

        vm.equation.fields = [];
        var fieldNumbers = expression.split(',');

        if (fieldNumbers) {
          fieldNumbers.forEach(function (number) {
            insertField('+', number);
          });
        }
      } else {
        if (!/^(?:[AS]\d+)*(?:[+-][AS]\d+)*$/.test(expression)) {
          return false;
        }

        vm.equation.fields = [];

        var _fieldNumbers = expression.split(/(?=[+-])/);

        if (_fieldNumbers) {
          _fieldNumbers.forEach(function (x) {
            var op, field;

            if (x.startsWith('+') || x.startsWith('-')) {
              op = x.charAt(0);
              field = x.substring(1);
            } else {
              op = '+';
              field = x;
            }

            insertField(op, field);
          });
        }
      }

      vm.fields = vm.allFields.filter(function (field) {
        return vm.equation.fields.findIndex(function (x) {
          return x.type === field.type && x.number === field.number;
        }) === -1;
      });
      updateSummaryExpression();
      return true;
    }

    function updateSummaryExpression() {
      var fields = vm.equation.fields;

      switch (vm.equation.type) {
        case "sum":
        case "avg":
          vm.equation.expression = fields.map(function (f) {
            return "".concat(f.type === 'section' ? 'S' : 'A').concat(f.number);
          }).join(', ');
          break;

        case "math":
          vm.equation.expression = fields.map(function (f) {
            return "".concat(f.operator).concat(f.type === 'section' ? 'S' : 'A').concat(f.number);
          }).join('').replace(/^\+/, '');
          break;
      }

      oldExpression = vm.equation.expression;
    }

    function insertField(operator, number) {
      var type = number.startsWith('S') ? 'section' : 'account';
      number = number.substring(1);

      if (vm.equation.fields.findIndex(function (f) {
        return f.type === type && f.number === number;
      }) === -1) {
        var field = vm.allFields.find(function (f) {
          return f.type === type && f.number === number;
        });

        if (field) {
          field.operator = operator;
          vm.equation.fields.push(field);
        }
      }
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.settings', ['app.core']);
})();


"use strict";

(function () {
  angular.module('app.settings').component('paymentInfoModal', {
    controller: paymentInfo,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/paymentInfo/paymentInfo.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function paymentInfo($scope, apiFactory, Notification, utils, $log) {
    var vm = this;

    vm.$onInit = function () {
      vm.data = angular.copy(vm.resolve.data);

      if (vm.data.logo) {
        vm.fileObjectUrl = vm.data.logo;
      }

      vm.isEdit = vm.resolve.isEdit;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty(vm.data.accountName)) {
        Notification.error("Please input Account Name.");
        return;
      }

      if (utils.isEmpty(vm.data.accountNumber)) {
        Notification.error("Please input Account Number.");
        return;
      }

      if (utils.isEmpty(vm.data.bankShortCode)) {
        Notification.error("Please input Bank Short Code.");
        return;
      }

      if (vm.data.bankShortCode.length !== 2) {
        Notification.error("Please input only 2 characters for Bank Short Code.");
        return;
      }

      vm.data.bankShortCode = vm.data.bankShortCode.toUpperCase();
      $scope.isLoading = true;
      apiFactory.isExistBankByBankCode({
        id: vm.data._id,
        bankShortCode: vm.data.bankShortCode
      }).then(function (res) {
        $scope.isLoading = false;

        if (res.data.data) {
          Notification.error("The Bank Short Code is already exists. Please input another one.");
        } else {
          vm.modalInstance.close(vm.data);
        }
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fileUpdated = function (files) {
      if (files && files.length) {
        var file = files[0];
        vm.data.file = file;
        vm.fileObjectUrl = URL.createObjectURL(file);
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app.settings').component('externalLogsModal', {
    controller: externalLogsModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/externalLogsModal/externalLogsModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function externalLogsModal($scope, apiFactory, $log) {
    var vm = this;
    $scope.numPerPage = 10;
    $scope.noOfPages = 1;
    vm.currentPage = 1;
    vm.logs = [];

    vm.$onInit = function () {
      vm.isInvoice = vm.resolve.isInvoice;
      loadLogs();
    };

    vm.loadPage = function () {
      loadLogs();
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      vm.modalInstance.close();
    };

    $scope.getExternLog = function (log) {
      var result = '';

      if (log.opDetails) {
        var externLogs = [];
        log.opDetails.forEach(function (x) {
          return externLogs.push(x.externLog);
        });
        result = externLogs.join(',');
      }

      return result;
    };

    $scope.getInvoiceUpdated = function (log) {
      var result = '';

      if (log.opDetails) {
        var updates = [];
        log.opDetails.forEach(function (x) {
          if (x.invoicesUpdated) {
            updates.push(x.invoicesUpdated);
          }
        });
        result = updates.join(',');
      }

      return result;
    };

    $scope.getBillUpdated = function (log) {
      var result = '';

      if (log.opDetails) {
        var updates = [];
        log.opDetails.forEach(function (x) {
          if (x.billsUpdated) {
            updates.push(x.billsUpdated);
          }
        });
        result = updates.join(',');
      }

      return result;
    };

    function loadLogs() {
      var result = vm.isInvoice ? apiFactory.externalInvoiceSyncOp(vm.currentPage, $scope.numPerPage) : apiFactory.externalBillingSyncOp(vm.currentPage, $scope.numPerPage);
      result.then(function (res) {
        vm.logs = res.data.list;
        $scope.noOfPages = Math.ceil(res.data.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $log.error(err);
      });
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('exportNetChangeModal', {
    controller: exportNetChangeModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/exportNetChangeModal/exportNetChangeModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function exportNetChangeModal(Notification) {
    var vm = this;
    vm.option = {
      fromAcc: undefined,
      toAcc: undefined,
      fromDate: undefined,
      toDate: undefined
    };

    vm.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    vm.onSubmit = function () {
      if (angular.isUndefined(vm.option.fromAcc)) {
        Notification.error("Please input from account number.");
        return;
      }

      if (angular.isUndefined(vm.option.toAcc)) {
        Notification.error("Please input to account number.");
        return;
      }

      if (angular.isUndefined(vm.option.fromDate)) {
        Notification.error("Please input from date.");
        return;
      }

      if (angular.isUndefined(vm.option.toDate)) {
        Notification.error("Please input to date.");
        return;
      }

      if (vm.option.toDate.getTime() < vm.option.fromDate.getTime()) {
        Notification.error("Please input from date and to date correctly.");
        return;
      }

      vm.modalInstance.close({
        fromAcc: vm.option.fromAcc.toString(),
        toAcc: vm.option.toAcc.toString(),
        fromDate: vm.option.fromDate,
        toDate: vm.option.toDate
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('editWarehouseModal', {
    controller: editWarehouseModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/editWarehouseModal/editWarehouseModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function editWarehouseModal() {
    var vm = this;

    vm.$onInit = function () {
      vm.warehouse = vm.resolve.warehouse;
    };

    vm.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    vm.onSubmit = function () {
      vm.modalInstance.close();
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('editTagModal', {
    controller: editTagModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/editTagModal/editTagModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function editTagModal($scope, apiFactory, utils, Notification) {
    var vm = this;

    vm.$onInit = function () {
      $scope.tag = Object.assign({}, vm.resolve.tag);
      $scope.tag.tagValue = Number.parseInt($scope.tag.tagValue);
      $scope.isLevelCategory = vm.resolve.category.categoryName === 'Level';
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSave = function () {
      if (utils.isEmpty($scope.tag.tagName)) {
        Notification.error('Tag Name must be a not empty string');
        return;
      }

      $scope.loading = true;
      apiFactory.updateSystemTag($scope.tag).then(function (res) {
        $scope.loading = false;
        vm.modalInstance.close(res.data.data);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(err.data.message || 'Internal server error');
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app.settings').component('editManager', {
    controller: editManager,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/editManager/editManager.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function editManager($scope, apiFactory, Notification, globals) {
    var vm = this;

    vm.$onInit = function () {
      $scope.employeeName = vm.resolve.data.employeeName;
      $scope.departmentList = vm.resolve.data.departmentList;
      $scope.designationList = vm.resolve.data.designationList;
      $scope.department = vm.resolve.data.department;
      $scope.subDesignation = vm.resolve.data.subDesignation;
      $scope.managerId = vm.resolve.data.id;
      $scope.dashboard = vm.resolve.data.dashboard;

      $scope.changeDepartment = function (item) {
        $scope.designationList = [];
        apiFactory.getDesignations(item.name).then(function (resp) {
          $scope.designationList = resp.data.data.map(function (item) {
            return {
              _id: item,
              name: item
            };
          });
        })["catch"](function (error) {
          if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to fetch designation");
        });
      }; // if (angular.isDefined($scope.department)) {
      //   $scope.changeDepartment({name: $scope.department});
      // }


      $scope.dashboardList = globals.getManagerList().map(function (item) {
        return {
          _id: item.dashboardType,
          name: item.name
        };
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      var manager = {
        department: $scope.department,
        subDesignation: $scope.subDesignation,
        dashboard: $scope.dashboard
      };
      apiFactory.updateManagerSetting(manager, $scope.managerId).then(function () {
        Notification.success("Manager updated.");
        vm.modalInstance.close();
      })["catch"](function (error) {
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Couldn't update manager.");
      });
    };

    vm.changeDepartment = function (item) {
      apiFactory.getDesignations(item.name).then(function (resp) {
        $scope.designationList = resp.data.data.map(function (item) {
          return {
            _id: item,
            name: item
          };
        });
      })["catch"](function (error) {
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to fetch designation");
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app.settings').component('editEntity', {
    controller: editEntity,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/editEntity/editEntity.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function editEntity($scope, apiFactory, utils, Notification) {
    var vm = this;

    vm.$onInit = function () {
      vm.entity = Object.assign({}, vm.resolve.entity);
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      // if (utils.isEmpty(vm.entity.currentTag)) {
      //   Notification.error('Tag is empty');
      //   return;
      // }
      // let regexStrList = vm.entity.currentTag.match(/[a-z]+|[^a-z]+/gi);
      //
      // if (regexStrList.length !== 2) {
      //   Notification.error('Tag is wrong');
      //   return;
      // }
      //
      // let prefix = regexStrList[0];
      // let count = Number.parseInt(regexStrList[1]);
      //
      // if (isNaN(count)) {
      //   Notification.error('Tag is wrong');
      //   return;
      // }
      if (utils.isEmpty(vm.entity.prefix)) {
        Notification.error('Tag is empty');
        return;
      }

      vm.entity.prefix = vm.entity.prefix.toUpperCase();
      $scope.loading = true;
      apiFactory.updateEntityTag(vm.entity).then(function (res) {
        $scope.loading = false;
        Notification.success('Updated entity');
        var entity = res.data;
        entity.currentTag = entity.prefix + entity.count;
        vm.modalInstance.close(entity);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('editCategoryModal', {
    controller: editCategoryModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/editCategoryModal/editCategoryModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function editCategoryModal($scope, apiFactory, utils, Notification) {
    var vm = this;

    vm.$onInit = function () {
      $scope.category = Object.assign({}, vm.resolve.category);
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSave = function () {
      if (utils.isEmpty($scope.category.categoryName)) {
        Notification.error('Category Name must be a not empty string');
        return;
      }

      $scope.loading = true;
      apiFactory.updateCategory($scope.category).then(function (res) {
        $scope.loading = false;
        vm.modalInstance.close(res.data.data);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(err.data.message || 'Internal server error');
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('buildingTagModal', {
    controller: buildingTagModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/buildingTagModal/buildingTagModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function buildingTagModal($scope, utils, Notification, apiFactory) {
    var vm = this;
    var DEFAULT_PERCENTAGE = 100;

    vm.$onInit = function () {
      $scope.loading = false;
      vm.tag = Object.assign({}, vm.resolve.tag);
      $scope.workTags = Object.assign([], vm.resolve.workTags);
      $scope.selectedWorkTag = undefined;
      $scope.percentage = DEFAULT_PERCENTAGE;
      $scope.items = [];
      $scope.loading = true;
      apiFactory.getWorkPatternById(vm.tag._id).then(function (res) {
        $scope.loading = false;
        $scope.items = res.data.data.items;
        $scope.workTags = [];
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(err.data.message || 'something went wrong');
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.addWorkTag = function () {
      if (angular.isUndefined($scope.selectedWorkTag)) {
        Notification.error('Please select work type');
        return;
      }

      if (angular.isUndefined($scope.percentage)) {
        Notification.error('Not valid percentage.');
        return;
      }

      var index = $scope.workTags.findIndex(function (x) {
        return x.tagName === $scope.selectedWorkTag;
      });

      if (index > -1) {
        var workTag = $scope.workTags[index];
        $scope.items.push({
          tagId: workTag._id,
          tagName: workTag.tagName,
          percentage: $scope.percentage
        });
        $scope.workTags.splice(index, 1);
        $scope.selectedWorkTag = undefined;
        $scope.percentage = DEFAULT_PERCENTAGE;
      }
    };

    $scope.$watch('items.length', function (newVal, oldVal) {
      if (newVal < oldVal) {
        $scope.workTags = [];
        vm.resolve.workTags.forEach(function (tag) {
          if ($scope.items.findIndex(function (x) {
            return x.tagId === tag._id;
          }) === -1) {
            $scope.workTags.push(tag);
          }
        });
      }
    });

    function paddingItems() {
      $scope.workTags.forEach(function (workTag) {
        $scope.items.push({
          tagId: workTag._id,
          tagName: workTag.tagName,
          percentage: DEFAULT_PERCENTAGE
        });
      });
    }

    function updateBuildingTag() {
      $scope.loading = true;
      apiFactory.updateSystemTag(vm.tag).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message || 'Updated building tag successfully');
        var updatedTag = res.data.data;
        paddingItems();
        var pattern = {
          tagId: updatedTag._id,
          items: $scope.items
        };
        $scope.loading = true;
        apiFactory.updateWorkPattern(pattern).then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message || 'Updated work pattern successfully');
          vm.modalInstance.close();
        })["catch"](function () {
          Notification.error('Something went wrong');
        });
      })["catch"](function () {
        $scope.loading = false;
        Notification.error("Something went wrong");
      });
    }

    $scope.onSave = function () {
      updateBuildingTag();
    };
  }
})();


"use strict";

(function () {
  angular.module('app.settings').component('billApproversModal', {
    controller: billApprovers,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/billApprovers/billApprovers.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function billApprovers($scope) {
    var vm = this;

    vm.$onInit = function () {
      vm.managerList = vm.resolve.managerList;
      vm.data = vm.resolve.data;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (vm.data.approver && vm.data.limit) {
        if (!vm.data.approver.displayName) {
          var manager = vm.managerList.find(function (item) {
            return item._id == vm.data.approver._id;
          });
          vm.data.approver.displayName = manager.displayName;
          vm.data.approver.profilePic = manager.profilePic;
        }

        vm.modalInstance.close(vm.data);
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('addDepartmentModal', {
    controller: addDepartmentModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/addDepartmentModal/addDepartmentModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function addDepartmentModal($scope, apiFactory, utils, Notification, $log) {
    var vm = this;

    vm.$onInit = function () {
      vm.department = vm.resolve.department ? angular.copy(vm.resolve.department) : {};
    };

    vm.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    vm.onSubmit = function () {
      if (utils.isEmpty(vm.department.description)) {
        Notification.error('Please input a description');
        return;
      }

      if (utils.isEmpty(vm.department.code)) {
        Notification.error('Please input a code');
        return;
      }

      var data = {
        description: vm.department.description,
        code: vm.department.code.toUpperCase()
      };
      var promise;

      if (vm.department._id) {
        promise = apiFactory.updateDepartment(vm.department._id, data);
      } else {
        promise = apiFactory.createDepartment(data);
      }

      $scope.loading = true;
      promise.then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close(res.data.data);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app.settings').component('accountNetChangesModal', {
    controller: accountNetChangesModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/modals/accountNetChangesModal/accountNetChangesModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function accountNetChangesModal($scope) {
    var vm = this;
    vm.accounts = [];

    vm.$onInit = function () {
      vm.accounts = vm.resolve.accounts;
    };

    vm.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.onSubmit = function () {
      vm.modalInstance.close();
    };

    $scope.getNetChange = function (item) {
      if (!item.NetChange || item.NetChange === "0" || item.NetChange === "0.00") return item.NetChange;

      if (item.NetChange.startsWith("-")) {
        return item.NetChange.substring(1);
      } else {
        return "-" + item.NetChange;
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module("app").directive("workTypes", workTypes);

  function workTypes($window, $document, utils) {
    return {
      restrict: "E",
      templateUrl: "app/main/settings/directives/work-types/work-types.view.html",
      scope: {
        items: '='
      },
      link: function link($scope) {
        $scope.COLORS = ['#4dc9f6', '#f67019', '#f53794', '#537bc4', '#acc236', '#166a8f', '#00a950', '#58595b', '#8549ba'];
        var ITEM_WIDTH = 160;
        var ITEM_HEIGHT = 32;
        var ITEM_Y_MARGIN = 16;
        var positions = [];

        function loadPositions() {
          positions = [];

          for (var i = 0; i < $scope.items.length; i++) {
            var curItem = $scope.items[i];
            var prevPosition = positions[i - 1];

            if (angular.isUndefined(prevPosition)) {
              positions.push({
                left: 0,
                top: i * (ITEM_HEIGHT + ITEM_Y_MARGIN)
              });
            } else {
              positions.push({
                left: prevPosition.left + ITEM_WIDTH - ITEM_WIDTH * ((100 - curItem.percentage) / 100),
                top: i * (ITEM_HEIGHT + ITEM_Y_MARGIN)
              });
            }
          }
        }

        $scope.removeItem = function (index) {
          $scope.items.splice(index, 1);
        };

        $scope.getItemStyle = function (index) {
          var position = positions[index];

          if (angular.isDefined(position)) {
            return {
              'top': positions[index].top,
              'left': positions[index].left
            };
          }
        };

        $scope.$watch('items.length', function () {
          if (!utils.isEmpty($scope.items)) {
            loadPositions();
          }
        });

        function dragElement(element) {
          var pos1 = 0,
              pos2 = 0;
          element.onmousedown = dragMouseDown;

          function dragMouseDown(e) {
            e = e || $window.event;
            e.preventDefault(); // get the mouse cursor position at startup:

            pos2 = e.clientX;
            $document[0].onmouseup = closeDragElement; // call a function whenever the cursor moves:

            $document[0].onmousemove = elementDrag;
          }

          function elementDrag(e) {
            e = e || $window.event;
            e.preventDefault(); // calculate the new cursor position:

            pos1 = pos2 - e.clientX;
            pos2 = e.clientX; // set the element's new position:

            var elementId = element.id;

            if (elementId.startsWith('work-type-')) {
              elementId = elementId.substring(10);
              var indexValue = parseInt(elementId, 10);
              var min = 0;

              if (indexValue > 0) {
                min = getLeft(getCellElement(indexValue - 1));
              }

              var prevLeft = setLeft(element, pos1, min);
              var percentage = $scope.getPercentage(indexValue);
              $scope.items[indexValue].percentage = percentage;
              var percentageElement = getPercentageElement(indexValue);

              if (percentageElement) {
                percentageElement.innerHTML = percentage + '%';
              }

              if (prevLeft.changed) {
                for (var i = indexValue + 1; i < $scope.items.length; i++) {
                  var el = getCellElement(i);
                  prevLeft = setLeft(el, pos1, prevLeft.value);
                }
              }
            }
          }

          function closeDragElement() {
            /* stop moving when mouse button is released:*/
            $document[0].onmouseup = null;
            $document[0].onmousemove = null;
          }

          dragMouseDown();
        }

        function setLeft(element, delta, min) {
          var max = min + ITEM_WIDTH;
          var value = getLeft(element);
          var old = value;
          value = value - delta;
          if (value < min) value = min;
          if (value > max) value = max;

          if (value !== old) {
            element.style.left = value + "px";
            return {
              value: value,
              changed: true
            };
          }

          return {
            value: value,
            changed: false
          };
        }

        function getLeft(element) {
          var style = element.currentStyle || $window.getComputedStyle(element);
          return parseInt(style.left, 10);
        }

        function getCellElement(index) {
          return $document[0].getElementById("work-type-" + index);
        }

        $scope.getPercentage = function (index) {
          var prevLeft = 0;
          var prevElement = getCellElement(index - 1);

          if (prevElement) {
            prevLeft = getLeft(prevElement);
          }

          var curElement = getCellElement(index);

          if (!curElement) {
            return 100;
          }

          var curLeft = getLeft(curElement);
          return Math.round((curLeft - prevLeft) * 100 / ITEM_WIDTH);
        };

        function getPercentageElement(index) {
          return $document[0].getElementById("work-type-percentage-" + index);
        }

        $scope.elementMouseDown = function ($event) {
          var target = $event.target;

          if (target) {
            if (!target.classList.contains('work-type-')) {
              target = target.parentElement;
            }

            dragElement(target);
          }
        };
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('updateChecklistModal', {
    controller: updateChecklistModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/reports/modals/update-checklist-modal/update-checklist-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function updateChecklistModalController($scope, $uibModal, apiFactory, utils) {
    var vm = this;

    vm.$onInit = function () {
      vm.checklist = angular.copy(vm.resolve.checklist);
      vm.checklist.checkListItem.forEach(function (item) {
        if (angular.isString(item.checkStatus)) {
          item.checkStatus = item.checkStatus === 'true';
        }

        if (angular.isString(item.acceptStatus)) {
          item.acceptStatus = item.acceptStatus === 'true';
        }

        if (angular.isString(item.createIssueStatus)) {
          item.createIssueStatus = item.createIssueStatus === 'true';
        }

        if (item.createIssueStatus && (!item.issueId || item.issueId == 'null' || item.issueId == 'undefined')) {
          item.createIssueStatus = false;
        }
      });
      var issueIds = [];
      vm.checklist.checkListItem.forEach(function (x) {
        if (x.issueId) {
          var id;

          if (angular.isString(x.issueId)) {
            id = x.issueId;
          } else if (angular.isObject(x.issueId)) {
            id = x.issueId._id;
          }

          if (id && id.toLowerCase() != 'null' && id.toLowerCase() != 'undefined') {
            issueIds.push(id);
          }
        }
      });

      if (!utils.isEmpty(issueIds)) {
        Promise.all(issueIds.map(function (x) {
          return apiFactory.getIssueById(x);
        })).then(function (res) {
          var issues = res.map(function (x) {
            return x.data.data;
          });

          var _iterator = _createForOfIteratorHelper(issues),
              _step;

          try {
            var _loop = function _loop() {
              var issue = _step.value;
              var item = vm.checklist.checkListItem.find(function (x) {
                return x.issueId == issue._id;
              });

              if (item) {
                item.issueSystemTag = issue.systemTag;
              }
            };

            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onChangeCreateIssueStatus = function (item) {
      if (item.createIssueStatus) {
        var modal = $uibModal.open({
          animation: true,
          component: 'createIssueModal',
          windowClass: 'create-issue-modal'
        });
        modal.result.then(function (result) {
          item.issueId = result._id;
          item.issueSystemTag = result.systemTag;
        }, function () {
          item.createIssueStatus = false;
        });
      } else {
        item.issueId = null;
      }
    };

    $scope.onSubmit = function () {
      vm.modalInstance.close(vm.checklist);
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('createIssueModal', {
    controller: createIssueModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/reports/modals/create-issue-modal/create-issue-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function createIssueModalController($scope, globals, utils, Notification, apiFactory, $log) {
    var vm = this;
    var projectStore = globals.projectStore;
    vm.project = projectStore.get();
    $scope.issueData = {
      projectId: vm.project._id
    };
    /* issueCategory */

    $scope.categoryList = [{
      label: 'Safety',
      key: 'Safety'
    }, {
      label: 'Quality',
      key: 'Quality'
    }, {
      label: 'Issue',
      key: 'Issue'
    }];
    /* priority */

    $scope.priorityList = [{
      label: 'High',
      key: 'High'
    }, {
      label: 'Medium',
      key: 'Medium'
    }, {
      label: 'Low',
      key: 'Low'
    }];
    /* status */

    $scope.statusList = [{
      label: 'Open',
      key: 'Open'
    }, {
      label: 'On Hold',
      key: 'On Hold'
    }, {
      label: 'Resolved',
      key: 'Resolved'
    }];

    vm.$onInit = function () {
      $scope.loading = true;
      Promise.all([apiFactory.listAllAdminUsers(vm.project._id), apiFactory.getUsersInProjectByApprovalType(vm.project._id, 'issue'), apiFactory.getIssuesList(), apiFactory.getWorkTypes(), apiFactory.listAllLevelTypes()]).then(function (res) {
        $scope.loading = false;
        vm.adminUsers = res[0].data.list.map(function (user) {
          return {
            label: user.firstName + ' ' + user.lastName,
            key: user._id
          };
        });
        vm.allRoofers = res[1].data.list.map(function (roofer) {
          return {
            label: roofer.firstName + ' ' + roofer.lastName,
            key: roofer._id
          };
        });
        vm.issueList = res[2].data.list;
        vm.workTypes = res[3].data.list;
        vm.levelTypes = res[4].data.list;

        for (var i = 1; i <= 100; i++) {
          vm.levelTypes.push({
            tagName: i.toString(),
            tagValue: i.toString()
          });
        }
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.changeFile = function (files) {
      if (files && files.length) {
        var file = files[0];
        $scope.FILE_IMAGE = URL.createObjectURL(file);
      }
    };

    function checkValidation() {
      var ret = {
        success: true,
        errorMsg: ''
      };
      var errorMsg = "";

      if (utils.isEmpty($scope.issueData.title)) {
        errorMsg = 'Please input title';
      } else if (utils.isEmpty($scope.issueData.issueCategory)) {
        errorMsg = 'Please select issue category';
      } else if (utils.isEmpty($scope.issueData.priority)) {
        errorMsg = 'Please select issue priority';
      } else if (utils.isEmpty($scope.issueData.status)) {
        errorMsg = 'Please select issue status';
      }

      if (errorMsg.length) {
        ret.success = false;
        ret.errorMsg = errorMsg;
      }

      return ret;
    }

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      var valid = checkValidation();

      if (!valid.success) {
        Notification.error(valid.errorMsg);
        return;
      }

      if ($scope.issueData.uploadImg) {
        $scope.issueData.photo = utils.dataURLtoFile($scope.issueData.uploadImg, 'issuePhoto');
        delete $scope.issueData.uploadImg;
      }

      $scope.loading = true;
      apiFactory.createIssue($scope.issueData).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close(res.data.data);
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to create issue");
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('addSiteDocModal', {
    controller: addSiteDocModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/reports/modals/add-sitedoc-modal/add-sitedoc-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function addSiteDocModalController($scope, globals, utils, localStorageService, Notification, apiFactory) {
    var vm = this;
    vm.utils = utils;
    var projectStore = globals.projectStore;

    vm.$onInit = function () {
      vm.reportId = vm.resolve.reportId;
      vm.siteDocId = vm.resolve.siteDocId;
      vm.isEdit = vm.resolve.isEdit;
      $scope.sitedocData = vm.resolve.sitedocData || {
        approvalStatus: 'Approved'
      };
      $scope.controlPlanItems = vm.resolve.controlPlanItems;
      $scope.tagsList = vm.resolve.tagsList;
      vm.project = projectStore.get();

      if (vm.isEdit && !utils.isEmpty($scope.sitedocData) && !utils.isEmpty($scope.sitedocData.documents)) {
        var location = $scope.sitedocData.documents[0].location;
        var names = location.split('.');
        var ext = names[names.length - 1].toLowerCase();

        if (ext === 'jpg' || ext === 'jpeg' || ext === 'png') {
          $scope.FILE_IMAGE = location;
          $scope.ICON_IMAGE = undefined;
        } else {
          $scope.FILE_IMAGE = undefined;
          $scope.ICON_IMAGE = utils.getFileIconFromName(location);
        }
      }
    };

    $scope.changeFile = function (files) {
      if (files && files.length) {
        var file = files[0];
        var names = file.type.split('/');

        if (names[0] === 'image') {
          $scope.FILE_IMAGE = URL.createObjectURL(file);
          $scope.ICON_IMAGE = undefined;
        } else {
          $scope.FILE_IMAGE = undefined;
          $scope.ICON_IMAGE = utils.getFileIconFromName(file.originalname);
        }

        $scope.sitedocData.docFile = file;
      }
    };

    function checkValidationSiteDoc() {
      var ret = {
        success: true,
        errorMsg: ''
      };
      var errorMsg = '';

      if (!localStorageService.get('regId')) {
        if (!$scope.sitedocData.docFile) {
          errorMsg = 'Please select the document file to upload.';
        } else if (!$scope.sitedocData.dateCreated) {
          errorMsg = 'Please select the Date Created.';
        }

        if (!utils.isEmpty(errorMsg)) {
          ret.success = false;
          ret.message = errorMsg;
        }
      }

      return ret;
    }

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (!checkValidationSiteDoc().success) {
        Notification.error(checkValidationSiteDoc().message);
        return;
      }

      $scope.sitedocData.projectId = vm.project._id;

      if ($scope.sitedocData.controlPlanItem) {
        $scope.sitedocData.controlPlanItems = [$scope.sitedocData.controlPlanItem];
      }

      var API = vm.isEdit ? apiFactory.updateReportSiteDoc(vm.siteDocId, $scope.sitedocData) : apiFactory.addReportSiteDoc(vm.reportId, $scope.sitedocData);
      $scope.loading = true;
      API.then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close(res.data.data);
      })["catch"](function (error) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(error));
      });
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component("orderDetailModal", {
    controller: orderDetailModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/modals/orderDetailModal/orderDetailModal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function orderDetailModalController($scope) {
    var vm = this;

    vm.$onInit = function () {
      vm.type = vm.resolve.data.type;
      vm.data = vm.resolve.data.data;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Tesseract;

(function () {
  'use strict';

  angular.module('app').component('billScanModal', {
    controller: billScanModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/modals/billScanModal/billScanModal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function billScanModalController($scope, $uibModal, $log, apiFactory, Notification, globals, $rootScope, $state, $timeout, $window, $document, utils, pdfFactory, localStorageService) {
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore,
        userStore = globals.userStore;
    var vm = this;
    vm.project = projectStore.get() || {
      _id: "all"
    };
    vm.userData = userStore.get();
    var CANVAS_HEIGHT = 635 * $rootScope.scale;
    var CANVAS_SCALE_MUTIPLER = 2;
    vm.companyData = companyStore.get();
    vm.billingGroups = [];
    vm.vaOrderList = [];
    vm.billList = [];
    vm.economicTypeList = [];
    vm.billing = null;
    vm.proceedBillingId = null;
    vm.ocrBillIdList = [];
    vm.modelReady = false;
    vm.canvasPage = undefined;
    vm.canvasScale = 1;
    vm.baseCanvasScale = 1.0;
    vm.tempInvoiceData = {};
    vm.errorCnt = 0;
    vm.billData = {};
    vm.minCnt = 10000000;
    vm.canvas = $document[0].getElementById("the-canvas");
    $scope.currentIndex = 0;
    $scope.economicTypeId = undefined;
    $scope.billingGroupId = undefined;
    var PROJECT_BILL = 0;
    var COMPANY_BILL = 1;
    var PENDING_BILL = 2;
    var FAILED_SYNC = 3;
    var VENDOR_CREDIT_MEMO = 4;
    $scope.currentTab = PROJECT_BILL;
    var rcThres = 20;
    var confThres = 30;
    vm.numPages = 1;
    vm.currentPageNum = 1;
    $scope.isBillDatepickerOpen = false;
    $scope.isDueDatepickerOpen = false;
    $scope.editingSupply = {};
    vm.isRemoveVAT = false;

    function initData() {
      $scope.isLoading = true;
      var billData = angular.copy(localStorageService.get('billData'));
      localStorageService.set('billData', undefined);
      var promises = [apiFactory.listAllVariationOrders({
        projectId: vm.project._id,
        status: 'approved',
        isBill: false
      }), apiFactory.getAllMaterialGroup(), apiFactory.getAllEquipmentGroup(), apiFactory.getBillAccountPlans()];

      if (billData) {
        if (billData.status === 'approved') {
          $scope.currentTab = FAILED_SYNC;
          promises.push(apiFactory.listAllBillings({
            failedSync: true,
            approval: 'approved',
            projectId: vm.project._id
          }));
        } else if (billData.isMemo) {
          $scope.currentTab = VENDOR_CREDIT_MEMO;
          promises.push(apiFactory.listAllBillings({
            isMemo: true,
            approval: 'pending',
            projectId: vm.project._id
          }));
        } else if (billData.projectId) {
          $scope.currentTab = PROJECT_BILL;
          promises.push(apiFactory.listAllBillings({
            projectBill: true,
            approval: 'pending',
            projectId: vm.project._id
          }));
        } else {
          $scope.currentTab = COMPANY_BILL;
          promises.push(apiFactory.listAllBillings({
            companyBill: true,
            approval: 'pending',
            projectId: vm.project._id
          }));
        }
      } else {
        promises.push(apiFactory.listAllBillings({
          projectBill: true,
          approval: 'pending',
          projectId: vm.project._id
        }));
      }

      Promise.all(promises).then(function (resp) {
        vm.vaOrderList = resp[0].data.list;
        var materialGroup = resp[1].data.data;
        var equipmentGroup = resp[2].data.data;
        equipmentGroup.forEach(function (item) {
          return item.groupType = 'eq';
        });
        vm.billingGroups = materialGroup.concat(equipmentGroup);
        vm.modelReady = true;
        vm.economicTypeList = resp[3].data.data;
        vm.economicTypeList.forEach(function (x) {
          x.name = x.name + ' - ' + x.number;
        });
        vm.billList = resp[4].data.list;

        if (billData) {
          $scope.currentIndex = vm.billList.findIndex(function (x) {
            return x._id == billData._id;
          });
        } else {
          $scope.currentIndex = 0;
        }

        if (vm.billList.length > 0 && $scope.currentIndex >= 0) {
          vm.billing = vm.billList[$scope.currentIndex];
          showBilling(vm.billing);
          startOCRProgress(vm.billing);
        } else {
          vm.billing = null;
          $scope.vendorDetail = {};
        }

        $scope.isLoading = false;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);

        if (err.status === 403) {
          Notification.error(err.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        } else {
          Notification.error(utils.getErrorMessage(err, "Couldn't load data."));
        }
      });
    }

    apiFactory.hasApprovalInProject({
      projectId: vm.project._id,
      approval: 'bill'
    }).then(function () {
      initData();
    })["catch"](function (err) {
      $log.error(err);
      Notification.error(utils.getErrorMessage(err, 'Permission denied'));
      $state.go(globals.getDashboardRoute(vm.userData));
    });

    vm.onProjectBills = function () {
      $scope.currentTab = PROJECT_BILL;
      getBillingList();
    };

    vm.onCompanyBills = function () {
      $scope.currentTab = COMPANY_BILL;
      getBillingList();
    };

    vm.onPendingBills = function () {
      $scope.currentTab = PENDING_BILL;
      getBillingList();
    };

    vm.onFailedSync = function () {
      $scope.currentTab = FAILED_SYNC;
      getBillingList();
    };

    vm.onMemo = function () {
      $scope.currentTab = VENDOR_CREDIT_MEMO;
      getBillingList();
    };

    vm.selEconomicTypeId = function (economicType) {
      vm.billing.billType = economicType;
      $scope.vendorDetail.vat = $scope.getVat(vm.billing);
      calculatePrices(vm.billing);
    };

    vm.selBillingGroupId = function (billingGroupId) {
      for (var i = 0; i < vm.billingGroups.length; i++) {
        if (vm.billingGroups[i]._id === billingGroupId) {
          vm.billing.group = vm.billingGroups[i];
        }
      }
    };

    vm.selBillingVAOrderId = function (billingVAOrderId) {
      if (vm.vaOrderList) {
        for (var i = 0; i < vm.vaOrderList.length; i++) {
          if (vm.vaOrderList[i]._id === billingVAOrderId) {
            var vaOrder = vm.vaOrderList[i];
            vm.billing.vaOrder = vaOrder;
            vm.billing.customSupplierData = {
              invoicenumber: vaOrder.displaySeq,
              supplies: []
            };

            if (vaOrder.vendorType === 'Client') {
              vm.billing.customSupplierData.address2 = $scope.addressString(vaOrder.vendor.address);
              vm.billing.customSupplierData.postalCode = vaOrder.vendor.address[0].postalCode;
              vm.billing.customSupplierData.countryCode = vaOrder.vendor.address[0].countryCode;
              vm.billing.customSupplierData.city = vaOrder.vendor.address[0].city;
              vm.billing.vendor = vaOrder.vendor;
              vm.billing.vendor.name = vaOrder.vendor.clientName;
              vm.billing.vendor.address = $scope.addressString(vaOrder.vendor.address);
              vm.billing.vendor.contact = vaOrder.vendor.clientContact;

              if (vaOrder.vendor.paymentTerms) {
                vm.billing.vendor.vat = vaOrder.vendor.paymentTerms.vatPercent;
              } else {
                vm.billing.vendor.vat = 0;
              }

              vm.billing.vendor.bankDetails = angular.copy(vm.companyData.economicSettings.paymentInfo);

              if (vm.billing.vendor.bankDetails && vm.billing.vendor.bankDetails.length > 0) {
                vm.billing.vendor.bankDetails[0].IBAN = vm.billing.vendor.bankDetails[0].ibanNumber;
                vm.billing.vendor.bankDetails[0].sortCode = vm.billing.vendor.bankDetails[0].swiftCode;
              }
            } else if (vaOrder.vendorType === 'Supplier' || vaOrder.vendorType === 'Subcontractor') {
              vm.billing.customSupplierData.address2 = vm.billing.vendor.address;
              vm.billing.vendor = vaOrder.vendor;
              var address = vm.billing.vendor.address || '';
              var addresses = address.spilt(',');
              vm.billing.customSupplierData.postalCode = addresses[2];
              vm.billing.customSupplierData.countryCode = addresses[1];
              vm.billing.customSupplierData.city = addresses[0];
            }

            vm.billing.bill.secure_url = vaOrder.variationOrderDoc;

            for (var _i = 0; _i < vaOrder.items.length; _i++) {
              var item = vaOrder.items[_i];
              vm.billing.customSupplierData.supplies.push({
                description: item.description,
                qty: item.quantity,
                unitprice: item.unitPrice,
                vat: item.vatAmount,
                price: item.price
              });
            }

            calculatePrices(vm.billing);
            showBilling(vm.billing);
            return;
          }
        }
      }
    };

    vm.openUploadNewBillModal = function () {
      var uploadModal = $uibModal.open({
        animation: true,
        component: 'uploadNewBillModal',
        windowClass: 'upload-new-bill-modal',
        resolve: {}
      });
      uploadModal.result.then(function (result) {
        if (result.action == 'upload') {
          if (!result.data) return;
          Notification.success("Uploading bills started. This might take some time");
          apiFactory.createBilling(result.data).then(function () {
            Notification.success("Bills successfully created. Updating Bill data again.");
            getBillingList();
          })["catch"](function (e) {
            $log.log(e);
            Notification.error("Uploading bills failed.");
          });
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.openPdfBrowse = function () {
      angular.element('#pdf-file').click();
    };

    vm.pdfBrowsed = function (ev) {
      var files = ev.target.files;

      if (files && files.length) {
        var billFiles = [];

        for (var i = 0; i < files.length; i++) {
          billFiles.push(files[i]);
        }

        vm.openEditModal(billFiles);
      }

      ev.target.value = '';
    };

    vm.saveBillingData = function (_billing) {
      var supplyIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var isDeleting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (_billing && _billing.customSupplierData && _billing.customSupplierData.invoicenumber) {
        var checkData = {
          id: _billing._id,
          vendorId: _billing.vendor ? _billing.vendor._id : undefined,
          customSupplierData: _billing.customSupplierData,
          projectId: _billing.projectId && _billing.projectId._id ? _billing.projectId._id : _billing.projectId
        };
        apiFactory.checkDuplicatedBillingData(checkData).then(function (resp) {
          if (resp.data.data.isDuplicated) {
            var duplicatedModal = $uibModal.open({
              animation: true,
              component: 'duplicatedModal',
              windowClass: 'dupliated-modal',
              size: 'sm',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                oldBilling: function oldBilling() {
                  return resp.data.data.item;
                },
                billing: function billing() {
                  return _billing;
                }
              }
            });
            duplicatedModal.result.then(function (result) {
              if (result) {
                if (result.action === 'delete') {
                  getBillingList();
                } else {
                  _saveBillingData(_billing, resp.data.data.item._id, supplyIndex, isDeleting);
                }
              }
            });
          } else {
            _saveBillingData(_billing, null, supplyIndex, isDeleting);
          }
        })["catch"](function (err) {
          $log.log(err);
        });
      } else {
        Notification.error("Data is not ready yet.");
      }
    };

    vm.approve = function () {
      if (angular.isUndefined(vm.billing)) return;

      if (angular.isUndefined(vm.billing.amountWithoutTax) || angular.isUndefined(vm.billing.totalAmount)) {
        Notification.error("Please input prices.");
        return;
      }

      if (!vm.billing.billType) {
        Notification.error("Please Select Bill Type");
        return;
      }

      if (angular.isUndefined(vm.billing.taxAmount)) {
        vm.billing.taxAmount = 0;
      }

      if (!vm.billing.customSupplierData.invoicenumber) {
        Notification.error("No Invoice Number.");
        return;
      }

      var checkData = {
        id: vm.billing._id,
        vendorId: vm.billing.vendor ? vm.billing.vendor._id : undefined,
        customSupplierData: vm.billing.customSupplierData,
        projectId: vm.billing.projectId && vm.billing.projectId._id ? vm.billing.projectId._id : vm.billing.projectId
      };
      apiFactory.checkDuplicatedBillingData(checkData).then(function (resp) {
        if (resp.data.data.isDuplicated) {
          Notification.error('Duplicated Invoice Number');
        } else {
          var approveModal = $uibModal.open({
            animation: true,
            component: 'approveBillModal',
            windowClass: 'approve-bill-modal',
            resolve: {
              billing: function billing() {
                return vm.billing;
              }
            }
          });
          approveModal.result.then(function (result) {
            $log.log(result);

            _approveBillingData(null, result);
          }, function (reason) {
            $log.info(reason);
          });
        }
      })["catch"](function (err) {
        $log.log(err);
      });
    };

    vm.decline = function () {
      if (angular.isUndefined(vm.billing)) {
        Notification.error('Invalid Billing Data');
        return;
      }

      if (!vm.billing.billType) {
        Notification.error('Please Select Billing Type');
        return;
      }

      apiFactory.approveBill({
        billId: vm.billing._id,
        status: "declined",
        customSupplierData: vm.billing.customSupplierData,
        billType: vm.billing.billType,
        amountWithoutTax: vm.billing.amountWithoutTax,
        taxAmount: vm.billing.taxAmount,
        totalAmount: vm.billing.totalAmount
      }).then(function () {
        Notification.success("Billing is declined.");
      })["catch"](function (err) {
        Notification.error(err.data.message);
      });
    };

    vm.startOCRProgress = function (billing) {
      startOCRProgress(billing, true);
    };

    vm.openEditModal = function () {
      $uibModal.open({
        animation: false,
        component: 'billEditModal',
        backdrop: 'none',
        windowClass: 'economic-bill-edit-modal',
        resolve: {
          billing: function billing() {
            return vm.billing;
          }
        }
      }).result.then(function (result) {
        if (result.billing && (result.billing.status === 'pending' || vm.billing.status === 'init')) {
          if (result.billing.projectId) {
            $scope.currentTab = PROJECT_BILL;
          } else {
            $scope.currentTab = COMPANY_BILL;
          }

          vm.proceedBillingId = result.billing._id;
          $timeout(function () {
            getBillingList();
          });
        }

        if (result.action === 'delete') {
          getBillingList();
        }
      }, function () {});
    };

    vm.downloadInvoice = function (billing) {
      $scope.isDownloading = true;
      utils.downloadFile(billing.bill.secure_url, "".concat(billing.billNo, ".pdf")).then(function () {
        $scope.isDownloading = false;
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.isDownloading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    vm.printDocument = function () {
      $window.open(vm.billing.bill.secure_url, "_blank");
    };

    vm.changeCanvasPage = function (direction) {
      var oldIndex = $scope.currentIndex;

      if (direction) {
        $scope.currentIndex = $scope.currentIndex === vm.billList.length - 1 ? $scope.currentIndex : $scope.currentIndex + 1;
      } else {
        $scope.currentIndex = $scope.currentIndex === 0 ? $scope.currentIndex : $scope.currentIndex - 1;
      }

      if (oldIndex !== $scope.currentIndex) {
        vm.currentPageNum = 1;
        vm.numPages = 1;
        vm.billing = vm.billList[$scope.currentIndex];
        showBilling(vm.billing);
        startOCRProgress(vm.billing);
      }
    };

    vm.changePageInBill = function (isNext) {
      if (isNext) {
        vm.currentPageNum += 1;

        if (vm.currentPageNum > vm.numPages) {
          vm.currentPageNum = vm.numPages;
        }
      } else {
        vm.currentPageNum -= 1;

        if (vm.currentPageNum < 1) {
          vm.currentPageNum = 1;
        }
      }

      pdfFactory.getPageFromURL(vm.billing.bill.secure_url, vm.currentPageNum).then(function (page) {
        vm.canvasPage = page;
        $timeout(function () {
          $scope.$apply();
        });
        renderPage(page, vm.canvas);
      })["catch"](function (e) {
        $log.error(e);
      });
    };

    vm.zoomCanvas = function (zoomIn) {
      vm.canvasScale = zoomIn ? vm.canvasScale + 0.1 : vm.canvasScale - 0.1;
      renderPage(vm.canvasPage, vm.canvas);
    };

    vm.resetCanvasZoom = function () {
      vm.canvasScale = vm.baseCanvasScale;
      renderPage(vm.canvasPage, vm.canvas);
    };

    vm.onEditItem = function (item) {
      item.editMode = true;
      $scope.editingSupply = angular.copy(item);
    };

    vm.onCancelEditItem = function (item) {
      item.editMode = false;
      $scope.editingSupply = {};

      if (item.addMode) {
        vm.billing.customSupplierData.supplies.splice(vm.billing.customSupplierData.supplies.length - 1, 1);
      }

      _calculatePrices(vm.billing);
    };

    vm.onAddItem = function () {
      if (utils.isEmpty(vm.billing.customSupplierData)) {
        resetCalcResult(vm.billing);
      }

      var find = vm.billing.customSupplierData.supplies.find(function (elem) {
        return elem.editMode == true;
      });

      if (find) {
        Notification.error("Please save editing item before adding");
        return;
      }

      vm.billing.customSupplierData.supplies.push({
        addMode: true
      });
      vm.onEditItem(vm.billing.customSupplierData.supplies[vm.billing.customSupplierData.supplies.length - 1]);
    };

    vm.onCheckEditing = function (index) {
      var supply = vm.billing.customSupplierData.supplies[index];

      if (supply.saveMode == true) {
        return;
      }

      if ($scope.isNormalType(vm.billing)) {
        if (utils.isEmpty($scope.editingSupply.description) || utils.isEmpty($scope.editingSupply.qty) || utils.isEmpty($scope.editingSupply.unitprice)) {
          Notification.error('Please input correct value');
          return;
        }

        supply.saveMode = true;
        supply.description = $scope.editingSupply.description;
        supply.qty = $scope.editingSupply.qty;
        supply.unitprice = $scope.editingSupply.unitprice;
      } else {
        if (utils.isEmpty($scope.editingSupply.description) || utils.isEmpty($scope.editingSupply.qty)) {
          Notification.error('Please input correct value');
          return;
        }

        supply.saveMode = true;
        supply.description = $scope.editingSupply.description;
        supply.qty = $scope.editingSupply.qty;
      }

      vm.saveBillingData(vm.billing, index);
    };

    vm.onRemoveItem = function (index) {
      if (vm.billing.customSupplierData.supplies[index].saveMode == true) return;
      vm.billing.customSupplierData.supplies[index].saveMode = true;
      vm.saveBillingData(vm.billing, index, true);
    };

    vm.changedQtyAndUPrice = function (item) {
      if (!$scope.isNormalType(vm.billing)) {
        return;
      }

      item.price = item.qty * item.unitprice;
      vm.billing.amountWithoutTax = 0;
      vm.billing.taxAmount = 0;
      vm.billing.totalAmount = 0;
      vm.billing.customSupplierData.supplies.filter(function (x) {
        return !x.editMode && !x.addMode;
      }).forEach(function (supply) {
        var price = supply.price;

        if (angular.isDefined(price) && price !== null) {
          var priceValue = Number(price);

          if (priceValue) {
            supply.vat = priceValue * utils.num($scope.vendorDetail.vat) / 100.0;
            supply.total = supply.vat + priceValue;
          }

          vm.billing.amountWithoutTax += priceValue;
          vm.billing.taxAmount += supply.vat;
          vm.billing.totalAmount += supply.total;
        }
      });

      if (!utils.isEmpty($scope.editingSupply) && !utils.isEmpty($scope.editingSupply.qty) && !utils.isEmpty($scope.editingSupply.unitprice)) {
        var price = $scope.editingSupply.qty * $scope.editingSupply.unitprice;
        $scope.editingSupply.price = price;
        $scope.editingSupply.vat = price * utils.num($scope.vendorDetail.vat) / 100.0;
        $scope.editingSupply.total = $scope.editingSupply.vat + price;
        item.description = $scope.editingSupply.description;
        item.qty = $scope.editingSupply.qty;
        item.unitprice = $scope.editingSupply.unitprice;
        item.price = $scope.editingSupply.price;
        item.vat = $scope.editingSupply.vat;
        item.total = $scope.editingSupply.total;
        vm.billing.amountWithoutTax += price;
        vm.billing.taxAmount += $scope.editingSupply.vat;
        vm.billing.totalAmount += $scope.editingSupply.total;
      }
    };

    vm.editAmountWithoutTax = function () {
      vm.billing.editMode = true;

      if (angular.isUndefined(vm.billing.amountWithoutTaxTemp)) {
        vm.billing.amountWithoutTaxTemp = vm.billing.amountWithoutTax;
      }
    };

    vm.updateAmountWithoutTax = function () {
      vm.billing.editMode = false;
      updateBillingTotalValues();
    };

    vm.changeAmountWithoutTax = function () {
      vm.billing.amountWithoutTax = vm.billing.amountWithoutTaxTemp;
      vm.billing.taxAmount = vm.billing.amountWithoutTax * utils.num($scope.vendorDetail.vat) / 100.0;
      vm.billing.totalAmount = vm.billing.amountWithoutTax + vm.billing.taxAmount;
    };

    vm.cancelAmountWithoutTax = function () {
      vm.billing.editMode = false;
      vm.billing.amountWithoutTaxTemp = vm.billing.amountWithoutTax;
      vm.billing.taxAmount = vm.billing.amountWithoutTax * utils.num($scope.vendorDetail.vat) / 100.0;
      vm.billing.totalAmount = vm.billing.amountWithoutTax + vm.billing.taxAmount;
    };

    function getBillingList() {
      return new Promise(function (resolve, reject) {
        $scope.economicTypeId = undefined;
        $scope.billingGroupId = undefined;
        var query = {};

        if ($scope.isProjectTab()) {
          query = {
            projectBill: true,
            approval: 'pending',
            projectId: vm.project._id
          };
        } else if ($scope.isMemoTab()) {
          query = {
            isMemo: true,
            approval: 'pending',
            projectId: vm.project._id
          };
        } else if ($scope.isCompanyTab()) {
          query = {
            companyBill: true,
            approval: 'pending',
            projectId: vm.project._id
          };
        } else if ($scope.isFailedSyncTab()) {
          query = {
            failedSync: true,
            approval: 'approved',
            projectId: vm.project._id
          };
        } else if ($scope.isPendingTab()) {
          query = {
            approval: 'init'
          };
        } else {
          reject();
        }

        $scope.isLoading = true;
        apiFactory.listAllBillings(query).then(function (resp) {
          vm.billList = resp.data.list;
          $scope.currentIndex = 0;

          if (vm.billList.length > 0) {
            if (vm.proceedBillingId) {
              vm.billing = vm.billList.find(function (x) {
                return x._id == vm.proceedBillingId;
              }) || vm.billList[$scope.currentIndex];
              showBilling(vm.billing);
              startOCRProgress(vm.billing, true);
            } else {
              vm.billing = vm.billList[$scope.currentIndex];
              showBilling(vm.billing);
              startOCRProgress(vm.billing);
            }
          } else {
            clearBill();
            $scope.vendorDetail = {};
          }

          $scope.isLoading = false;
          resolve();
        })["catch"](function (e) {
          $log.error(e);
          $scope.isLoading = false;
          reject(e);
        });
      });
    }

    function showBilling(billing) {
      if (!billing) return;
      vm.currentInvoiceId = billing._id;
      $scope.economicTypeId = billing.billType;
      $scope.billingGroupId = billing.group;
      $scope.billingVAOrderId = billing.vaOrder ? billing.vaOrder._id : null;
      $scope.isLoadBilling = true;
      Promise.all([pdfFactory.numPagesFromURL(billing.bill.secure_url), pdfFactory.getPageFromURL(billing.bill.secure_url, vm.currentPageNum)]).then(function (res) {
        vm.numPages = res[0];
        var page = res[1];
        vm.canvasPage = page;
        $timeout(function () {
          $scope.$apply();
        });
        $scope.isLoadBilling = false;
        /* Render first page initially */

        renderPage(page, vm.canvas, true);
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoadBilling = false;
      });

      if (!billing.customSupplierData) {
        resetCalcResult(billing);
      }

      if (billing.group && typeof billing.group == 'string') {
        var currentBillingGroup = {};

        if (vm.billingGroups) {
          for (var i = 0; i < vm.billingGroups.length; i++) {
            if (vm.billingGroups[i]._id === billing.group) {
              currentBillingGroup = vm.billingGroups[i];
            }
          }
        }

        billing.group = currentBillingGroup;
      }

      if (billing.billType && typeof billing.billType == 'string') {
        var currentBillType = {};

        if (vm.economicTypeList.length) {
          for (var j = 0; j < vm.economicTypeList.length; j++) {
            if (vm.economicTypeList[j]._id === billing.billType) {
              currentBillType = vm.economicTypeList[j];
            }
          }
        }

        billing.billType = currentBillType;
      }

      getVendorDetails(billing);
    }

    function clearCanvas() {
      var ctx = vm.canvas.getContext("2d");

      if (ctx) {
        ctx.clearRect(0, 0, vm.canvas.width, vm.canvas.height);
      }
    }

    function clearBill() {
      vm.billing = undefined;
      clearCanvas();
    }

    function renderPage(page, canvas) {
      var isInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if ($scope.isRendering) {
        return;
      }

      $scope.isRendering = true;
      clearCanvas();
      var originViewport = page.getViewport({
        scale: 1
      });

      if (isInit) {
        if (originViewport) {
          vm.baseCanvasScale = (originViewport.height ? CANVAS_HEIGHT / originViewport.height : 1) * CANVAS_SCALE_MUTIPLER;
        }

        vm.canvasScale = vm.baseCanvasScale;
      }

      var viewport = page.getViewport({
        scale: vm.canvasScale
      });

      if (viewport) {
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        canvas.style.width = viewport.width / 2 + 'px';
        canvas.style.height = viewport.height / 2 + 'px';
      }

      var ctx = canvas.getContext("2d");
      page.render({
        canvasContext: ctx,
        viewport: viewport
      }).promise.then(function () {
        $scope.isRendering = false;
      })["catch"](function (err) {
        $log.error(err);
        $scope.isRendering = false;
      });
    }

    function blobToBase64(blob, cb) {
      var reader = new $window.FileReader();

      if (blob instanceof Blob) {
        reader.readAsDataURL(blob);

        reader.onloadend = function () {
          cb(reader.result);
        };
      } else {
        cb("error");
      }
    }

    function canvasToBase64(canvas, cb) {
      canvas.toBlob(function (blob) {
        blobToBase64(blob, cb);
      }, 'image/jpeg');
    }

    function _approveBillingData(dupId, additionalReq) {
      apiFactory.approveBill({
        dupId: dupId,
        billId: vm.billing._id,
        status: "approved",
        customSupplierData: vm.billing.customSupplierData,
        billType: vm.billing.billType,
        amountWithoutTax: vm.billing.amountWithoutTax,
        taxAmount: vm.billing.taxAmount,
        totalAmount: vm.billing.totalAmount,
        approver: additionalReq.approverId,
        // to do confirm because generate on backend.
        projectId: additionalReq.projectId,
        vendor: additionalReq.vendorId,
        vendorType: additionalReq.vendorType
      }).then(function () {
        Notification.success("".concat(vm.billing.billNo, " is approved successfully."));
        getBillingList();
      })["catch"](function (err) {
        if (err.data && err.data.message) {
          Notification.error(err.data.message);
        } else {
          Notification.error("Failed in approve billing");
        }

        $log.log(err);
      });
    }

    function refineValue(value) {
      return Math.round((value + Number.EPSILON * Math.pow(10, 10)) * 100) / 100;
    }

    function _calculatePrices(billing) {
      if (!billing || !billing.customSupplierData || !billing.customSupplierData.supplies) {
        unsetRunningOCRBill(billing._id);
        return;
      }

      if ($scope.isNormalType(billing)) {
        billing.amountWithoutTax = 0;
        billing.taxAmount = 0;
        billing.totalAmount = 0;
        billing.customSupplierData.supplies.forEach(function (supply) {
          supply.price = Number.parseFloat(supply.qty) * Number.parseFloat(supply.unitprice);
          var price = supply.price;

          if (angular.isDefined(price) && price !== null) {
            var priceValue = Number(price);

            if (priceValue) {
              supply.vat = priceValue * utils.num($scope.vendorDetail.vat) / 100.0;
              supply.total = supply.vat + priceValue;
            }

            billing.amountWithoutTax += priceValue;
            billing.taxAmount += supply.vat;
            billing.totalAmount += supply.total;
          }
        });
      } else {
        billing.amountWithoutTax = refineValue(Number.parseFloat(billing.customSupplierData.totalprice));
        billing.taxAmount = refineValue(billing.amountWithoutTax * utils.num($scope.vendorDetail.vat) / 100.0);
        billing.totalAmount = refineValue(billing.amountWithoutTax + billing.taxAmount);
      }

      billing.amountWithoutTax = refineValue(billing.amountWithoutTax);
      billing.taxAmount = refineValue(billing.taxAmount);
      billing.totalAmount = refineValue(billing.amountWithoutTax + billing.taxAmount);
      vm.proceedBillingId = null;
      unsetRunningOCRBill(billing._id);
    }

    function calculatePrices(billing) {
      _calculatePrices(billing);

      vm.saveBillingData(billing);
      $timeout(function () {
        return $scope.$apply();
      });
    }

    $scope.onCancel = function () {
      vm.modalInstance.close();
    };

    $scope.getVat = function (billing) {
      var accountPlan = undefined;

      if (billing.billType && angular.isObject(billing.billType)) {
        accountPlan = billing.billType;
      } else {
        accountPlan = vm.economicTypeList.find(function (x) {
          return x._id === billing.billType;
        });
      }

      if (accountPlan && angular.isDefined(accountPlan.vat)) {
        return accountPlan.vat;
      }

      return billing && billing.vendor && billing.vendor.paymentTerms && billing.vendor.paymentTerms.vatPercent ? billing.vendor.paymentTerms.vatPercent : 0;
    };

    $scope.getVatNumber = function (billing) {
      var vatNumber;

      if (billing && billing.vendor) {
        if (billing.vendor.paymentTerms) {
          vatNumber = billing.vendor.paymentTerms.vatNumber;
        }
      }

      return vatNumber;
    };

    function _saveBillingData(billing, dupId, supplyIndex, isDeleting) {
      var data;
      var customSupplierData = angular.copy(billing.customSupplierData);

      if (supplyIndex >= 0) {
        customSupplierData.supplies = customSupplierData.supplies.map(function (item, index) {
          var supply = angular.fromJson(angular.toJson(item));

          if (index == supplyIndex) {
            delete supply.saveMode;
            delete supply.editMode;
          }

          return supply;
        });

        if (isDeleting) {
          customSupplierData.supplies.splice(supplyIndex, 1);
        }
      }

      data = {
        dupId: dupId,
        templateId: billing.templateId ? billing.templateId : null,
        group: billing.group && billing.group._id ? billing.group._id : null,
        groupType: billing.group && billing.group.groupType ? billing.group.groupType : null,
        vaOrder: billing.vaOrder && billing.vaOrder._id ? billing.vaOrder._id : null,
        billDate: billing.billDate ? billing.billDate : customSupplierData ? customSupplierData.billdate : undefined,
        dueDate: billing.dueDate ? billing.dueDate : customSupplierData ? customSupplierData.duedate : undefined,
        customSupplierData: customSupplierData,
        amountWithoutTax: billing.amountWithoutTax,
        taxAmount: billing.taxAmount,
        totalAmount: billing.totalAmount,
        vatPercent: billing.vatPercent
      };

      if (!utils.isEmpty(billing.billType)) {
        data.billType = billing.billType;
      }

      apiFactory.updateBillingData(data, billing._id).then(function (resp) {
        Notification.success("".concat(billing.billNo, " successfully updated"));

        if (supplyIndex >= 0) {
          billing.customSupplierData.supplies[supplyIndex].saveMode = false;
          billing.customSupplierData.supplies[supplyIndex].editMode = false;

          if (isDeleting) {
            if ($scope.isNormalType(billing)) {
              billing.amountWithoutTax -= billing.customSupplierData.supplies[supplyIndex].price;
              billing.taxAmount -= billing.customSupplierData.supplies[supplyIndex].vat;
              billing.totalAmount -= billing.customSupplierData.supplies[supplyIndex].total;
            }

            billing.customSupplierData.supplies.splice(supplyIndex, 1);
          }

          $scope.$apply();
          updateBillingTotalValues(billing);
          unsetRunningOCRBill(billing._id);
        }

        var index = vm.billList.findIndex(function (x) {
          return x._id == billing._id;
        });
        var tempBilling = angular.copy(resp.data.data);
        var currentBillingGroup = {};

        if (vm.billingGroups) {
          for (var i = 0; i < vm.billingGroups.length; i++) {
            if (vm.billingGroups[i]._id === resp.data.data.group) {
              currentBillingGroup = vm.billingGroups[i];
              break;
            }
          }
        }

        var currentBillType = {};

        if (vm.economicTypeList && vm.economicTypeList.length) {
          for (var j = 0; j < vm.economicTypeList.length; j++) {
            if (vm.economicTypeList[j]._id === resp.data.data.billType) {
              currentBillType = vm.economicTypeList[j];
            }
          }
        }

        tempBilling.billType = currentBillType;
        tempBilling.group = currentBillingGroup;
        vm.billList[index] = tempBilling;
        billing = vm.billList[index];
        unsetRunningOCRBill(billing._id);
      })["catch"](function (err) {
        $log.log(err);
      });
    }

    function updateBillingTotalValues(billing) {
      var data = {
        amountWithoutTax: billing.amountWithoutTax,
        taxAmount: billing.taxAmount,
        totalAmount: billing.totalAmount
      };
      apiFactory.updateBillingTotalValues(data, billing._id).then(function () {
        $scope.$apply();
      })["catch"](function (err) {
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    function getDueDate(billing) {
      var billDateString = billing.customSupplierData.billdate;
      var billDate = new Date(billDateString); // need to get from ocr

      if (billDate && billing && billing.vendor && billing.vendor.paymentTerms) {
        var term = vm.companyData.paymentConditions.find(function (elem) {
          return elem._id === billing.vendor.paymentTerms.paymentSetting;
        });

        if (term) {
          var additionalDays = utils.getDaysFromPaymentTermsCode(term.code);
          var newDate = moment(billDate).clone();

          if (additionalDays) {
            var endDate = moment(newDate);

            if (additionalDays.w) {
              endDate = moment(newDate).isoWeek(7);
            } else if (additionalDays.m) {
              endDate = moment(newDate).endOf('month');
            }

            var duedate = endDate.add(additionalDays.days, 'days');
            billing.customSupplierData.duedate = new Date(duedate);
            $scope.dueDate = new Date(duedate);
            $scope.billDate = new Date(billDate);

            if (!angular.isDate($scope.dueDate)) {
              $scope.dueDate = null;
            }

            if (!angular.isDate($scope.billDate)) {
              $scope.billDate = null;
            }
          }
        }
      }
    }

    function getVendorDetails(billing) {
      $scope.dueDate = new Date(billing.dueDate);
      $scope.billDate = new Date(billing.billDate);

      if (!angular.isDate($scope.dueDate)) {
        $scope.dueDate = null;
      }

      if (!angular.isDate($scope.billDate)) {
        $scope.billDate = null;
      }

      $scope.vendorDetail = {};
      if (!billing.vendor) return;
      var vendor = billing.vendor;
      var address = {};

      if (vendor.address) {
        address = vendor.address[0] ? vendor.address[0] : vendor.address ? vendor.address : vendor.address1 ? vendor.address1 : vendor.address2 ? vendor.address2 : '';
      }

      $scope.vendorDetail.address = address;
      $scope.vendorDetail.fullAddress = '';

      if ($scope.vendorDetail.address.line1) {
        $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.line1 + ', ';
      }

      if ($scope.vendorDetail.address.city) {
        $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.city + ', ';
      }

      if ($scope.vendorDetail.address.countryCode) {
        $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.countryCode + ', ';
      }

      $scope.vendorDetail.email = vendor.email;
      $scope.vendorDetail.phoneNumber = vendor.clientContact ? vendor.clientContact.dialCode + vendor.clientContact.phoneNumber : vendor.contact ? vendor.contact.dialCode + vendor.contact.phoneNumber : vendor.mobile ? vendor.mobile.dialCode + vendor.mobile.phoneNumber : '';
      $scope.vendorDetail.vat = $scope.getVat(billing);
      $scope.vendorDetail.vatNumber = $scope.getVatNumber(billing);
      $scope.bankDetails = {};
      var requiredFields = ['IBAN', 'bicCode', 'accountNumber', 'bankName'];

      if (vendor.bankDetails && vendor.bankDetails.length > 0) {
        requiredFields.forEach(function (key) {
          $scope.bankDetails[key] = vendor.bankDetails[0][key];
        });
      }

      $scope.vendorDetail.dueDate = new Date(billing.dueDate);

      if ($scope.vendorDetail.vat !== billing.vatPercent || billing.vatPercent && !billing.taxAmount) {
        billing.vatPercent = $scope.vendorDetail.vat;
        calculatePrices(billing);
      }

      $timeout(function () {
        $scope.$apply();
      });
    }

    $scope.addressString = function (address) {
      if (!address) {
        return '';
      }

      if (angular.isString(address)) {
        return address;
      }

      if (angular.isArray(address)) {
        address = address[0];
      }

      var addr = '';

      if (address.line2) {
        addr += address.line2;
        addr += ', ';
      }

      if (address.line1) {
        addr += address.line1;
        addr += ', ';
      }

      if (address.city) {
        addr += address.city;
        addr += ', ';
      }

      if (address.countryCode) {
        addr += address.countryCode;
        addr += ', ';
      }

      if (address.postalCode) {
        addr += address.postalCode;
      }

      return addr;
    };

    var DEV_ENV = false;

    function removeLines(imageData, canvas) {
      var src = cv.matFromImageData(imageData);
      var dst = new cv.Mat();
      var thresh = new cv.Mat();
      cv.cvtColor(src, dst, cv.COLOR_RGBA2GRAY);
      cv.threshold(dst, thresh, 0, 255, cv.THRESH_BINARY_INV + cv.THRESH_OTSU);
      var horizontal_kernel = cv.getStructuringElement(cv.MORPH_RECT, new cv.Size(30, 1));
      var remove_horizontal = new cv.Mat();
      cv.morphologyEx(thresh, remove_horizontal, cv.MORPH_OPEN, horizontal_kernel, new cv.Point(-1, -1), 2);
      var cnts = new cv.MatVector();
      var hierachies = new cv.Mat();
      cv.findContours(remove_horizontal, cnts, hierachies, cv.RETR_EXTERNAL, cv.CHAIN_APPROX_SIMPLE);

      for (var i = 0; i < cnts.size(); i++) {
        var color = new cv.Scalar(255, 255, 255);
        cv.drawContours(dst, cnts, i, color, 3, cv.LINE_8, hierachies, 5);
      }

      var vertical_kernel = cv.getStructuringElement(cv.MORPH_RECT, new cv.Size(1, 30));
      var remove_vertical = new cv.Mat();
      cv.morphologyEx(thresh, remove_vertical, cv.MORPH_OPEN, vertical_kernel, new cv.Point(-1, -1), 2);
      cv.findContours(remove_vertical, cnts, hierachies, cv.RETR_EXTERNAL, cv.CHAIN_APPROX_SIMPLE);

      for (var _i2 = 0; _i2 < cnts.size(); _i2++) {
        var _color = new cv.Scalar(255, 255, 255);

        cv.drawContours(dst, cnts, _i2, _color, 3, cv.LINE_8, hierachies, 5);
      }

      if (DEV_ENV) downloadCVImgDataAsImage(thresh, 'thres');
      if (DEV_ENV) downloadCVImgDataAsImage(dst, 'result');
      cv.imshow(canvas, dst);
    }

    var ocr_method = 1;
    var ocr_engine_ready = false;
    var worker = Tesseract.createWorker();
    var ocr_lang_config = 'eng+dan';

    function runFullOCR(pdfUrl, pageNum) {
      return new Promise(function (resolve, reject) {
        pdfFactory.getPageFromURL(pdfUrl, pageNum).then(function (page) {
          var viewport = page.getViewport({
            scale: 3
          });
          var hiddenCanvas = $document[0].createElement('canvas');

          if (viewport) {
            hiddenCanvas.height = viewport.height;
            hiddenCanvas.width = viewport.width;
          }

          var ctx = hiddenCanvas.getContext("2d");
          $scope.isRendering = true;
          page.render({
            canvasContext: ctx,
            viewport: viewport
          }).promise.then(function () {
            $scope.isRendering = false;
            if (DEV_ENV) downloadCanvasAsImage(hiddenCanvas, 'before');
            var imageData = ctx.getImageData(0, 0, hiddenCanvas.width, hiddenCanvas.height);
            removeLines(imageData, hiddenCanvas);
            if (DEV_ENV) downloadCanvasAsImage(hiddenCanvas, 'after');
            canvasToBase64(hiddenCanvas, function (b64) {
              if (b64 === "error") {
                Notification.error("Failed in OCR with current pdf");
                reject();
              } else {
                if (ocr_method == 0) {
                  Tesseract.recognize(b64).then(function (resp) {
                    resolve({
                      data: resp.data,
                      size: {
                        width: hiddenCanvas.width,
                        height: hiddenCanvas.height
                      }
                    });
                  })["catch"](function (err) {
                    reject(err);
                  });
                } else if (ocr_method == 1) {
                  if (ocr_engine_ready) {
                    worker.recognize(b64).then(function (resp) {
                      resolve({
                        data: resp.data,
                        size: {
                          width: hiddenCanvas.width,
                          height: hiddenCanvas.height
                        }
                      });
                    })["catch"](function (err) {
                      reject(err);
                    });
                  } else {
                    worker.load().then(function () {
                      worker.loadLanguage(ocr_lang_config).then(function () {
                        worker.initialize(ocr_lang_config).then(function () {
                          ocr_engine_ready = true;
                          worker.recognize(b64).then(function (resp) {
                            resolve({
                              data: resp.data,
                              size: {
                                width: hiddenCanvas.width,
                                height: hiddenCanvas.height
                              }
                            });
                          })["catch"](function (err) {
                            reject(err);
                          });
                        })["catch"](function (err) {
                          reject(err);
                        });
                      })["catch"](function (err) {
                        reject(err);
                      });
                    })["catch"](function (err) {
                      reject(err);
                    });
                  }
                }
              }
            });
          })["catch"](function (err) {
            $scope.isRendering = false;
            reject(err);
          });
        })["catch"](function (err) {
          return reject(err);
        });
      });
    }

    function startOCRProgress(billing) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if ($scope.isRunningOCRBill(billing)) {
        Notification.info("OCR is running for ".concat(billing.billNo, "."));
        return;
      }

      if (billing.status === 'init' || billing.status === 'approved' && billing.externEconomics.isNaviSynced) {
        if (force) {
          Notification.error('Billing state is not valid');
        }

        return;
      }

      if (!billing.bill || !billing.bill.secure_url) {
        Notification.error('Invalid billing. Please delete it.');
        return;
      }

      if (!billing.templateId) {
        Notification.error('No template has been set. Please try again after setting a template.');
        return;
      }

      if (!force && billing.customSupplierData && billing.customSupplierData.supplies && billing.customSupplierData.supplies.length) {
        return;
      }

      vm.ocrBillIdList.push(billing._id);
      $timeout(function () {
        $scope.$apply();
      });

      if (!billing.customSupplierData) {
        resetCalcResult(billing);
      }

      var pageCount = billing && billing.templateId ? billing.templateId.pages.length : 1;
      var pageNum = 1;
      var ocrDataList = [];
      runFullOCR(billing.bill.secure_url, pageNum).then(function (resp) {
        var data = refineOCRResult(resp.data);

        if (data) {
          ocrDataList.push({
            data: data,
            size: resp.size
          });
        }

        pageNum += 1;

        if (pageNum <= pageCount) {
          runFullOCR(billing.bill.secure_url, pageNum).then(function (resp) {
            var data = refineOCRResult(resp.data);

            if (data) {
              ocrDataList.push({
                data: data,
                size: resp.size
              });
            }

            pageNum += 1;

            if (pageNum <= pageCount) {
              runFullOCR(billing.bill.secure_url, pageNum).then(function (resp) {
                var data = refineOCRResult(resp.data);

                if (data) {
                  ocrDataList.push({
                    data: data,
                    size: resp.size
                  });
                }

                pageNum += 1;
                runFullOCR(billing.bill.secure_url, pageNum).then(function (resp) {
                  var data = refineOCRResult(resp.data);

                  if (data) {
                    ocrDataList.push({
                      data: data,
                      size: resp.size
                    });
                  }

                  createBillOcrData(billing, ocrDataList);
                })["catch"](function (err) {
                  unsetRunningOCRBill(billing._id);
                  $log.error(err);
                  Notification.error('Failed in OCR');
                });
              })["catch"](function (err) {
                unsetRunningOCRBill(billing._id);
                $log.error(err);
                Notification.error('Failed in OCR');
              });
            } else {
              createBillOcrData(billing, ocrDataList);
            }
          })["catch"](function (err) {
            unsetRunningOCRBill(billing._id);
            $log.error(err);
            Notification.error('Failed in OCR');
          });
        } else {
          createBillOcrData(billing, ocrDataList);
        }
      })["catch"](function (err) {
        unsetRunningOCRBill(billing._id);
        $log.error(err);
        Notification.error('Failed in OCR');
      });

      function createBillOcrData(billing, data) {
        Notification.success("All OCR quotes are successfully completed for ".concat(billing.billNo));
        billing.ocrData = data;
        processOCRData(billing);
      }
    }

    function refineOCRResult(data) {
      if (!data || !data.lines) return;
      var lines = [];
      data.lines.forEach(function (line) {
        var obj = {
          baseline: line.baseline,
          bbox: line.bbox,
          text: line.text,
          words: removePoorWords(line.words)
        };
        lines.push(obj);
      });

      function removePoorWords(words) {
        var rlt = [];
        words.forEach(function (word) {
          if (word.confidence < confThres) return;
          var obj = {
            baseline: word.baseline,
            bbox: word.bbox,
            text: word.text
          };
          rlt.push(obj);
        });
        return rlt;
      }

      return {
        lines: lines
      };
    }

    function processOCRData(billing) {
      if (billing.templateId) {
        var template = billing.templateId;

        var _iterator = _createForOfIteratorHelper(template.pages),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var page = _step.value;
            delete page._id;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (processOCRDataWithTemplate(billing, template)) {
          calculatePrices(billing);
        } else {
          resetCalcResult(billing);
          processForFail(billing);
        }
      } else {
        Notification.error("Cannot find template for this bill. Please add one");
        unsetRunningOCRBill(billing._id);
      }
    }

    function getLoopFields(templateType) {
      if (!templateType.includes('normal')) {
        return Constants.OCRTemplateLoopFieldsList.slice(0).filter(function (x) {
          return x != 'unitprice';
        });
      }

      return Constants.OCRTemplateLoopFieldsList.slice(0);
    }

    function processOCRDataWithTemplate(billing, template) {
      var loopFields = getLoopFields(template.templateType);
      var ret = true;
      var lastBillData = {};
      var dateMode = billing.dateMode || 'dmy';

      var _loop = function _loop(i) {
        var rawData = billing.ocrData[i];

        if (angular.isUndefined(rawData) || angular.isUndefined(rawData.data.lines)) {
          return "continue";
        }

        var templateSize = rawData.size;
        var page = template.pages[i];

        if (utils.isEmpty(page)) {
          return "continue";
        }

        var keys = Object.keys(page);
        loopFields = loopFields.filter(function (x) {
          return keys.includes(x);
        });

        for (var j = 0; j < keys.length; j++) {
          var key = keys[j];
          var text = '';

          var _iterator2 = _createForOfIteratorHelper(rawData.data.lines),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var line = _step2.value;

              if (rectIncludes(makeRcFromFieldArea(page[key], templateSize), line.bbox, 'y')) {
                var _iterator3 = _createForOfIteratorHelper(line.words),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var word = _step3.value;

                    if (rectIncludes(makeRcFromFieldArea(page[key], templateSize), word.bbox, 'x')) {
                      text += word.text + ' ';
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          if (key == 'invoicenumber' && utils.isEmpty(text)) {
            ret = false; // Notification.error('Invoice number is not recognized');
          }

          if (key == 'billdate') {
            text = getDateString(text, dateMode);

            if (utils.isEmpty(text)) {
              Notification.error('Bill date is not recognized. Please check the Date Mode');
            }
          }

          if (key == 'totalprice') {
            text = getValidValue(billing, text, key);
          }

          if (!utils.isEmpty(text) && !loopFields.includes(key)) {
            lastBillData[key] = text;
          }
        }

        billing.customSupplierData = lastBillData;

        if (billing.customSupplierData.billdate) {
          getDueDate(billing);
        }

        var supplies = void 0;

        if (template.billingId) {
          supplies = processManualLoopFields(billing, template);
        } else {
          supplies = processLoopFields(billing, page, template, rawData);
        }

        if (angular.isUndefined(billing.customSupplierData.supplies)) {
          billing.customSupplierData.supplies = [];
        }

        var _iterator4 = _createForOfIteratorHelper(supplies),
            _step4;

        try {
          var _loop2 = function _loop2() {
            var supply = _step4.value;

            if (!billing.customSupplierData.supplies.find(function (x) {
              return supply.description == x.description;
            })) {
              billing.customSupplierData.supplies.push(supply);
            }
          };

          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      };

      for (var i = 0; i < template.pages.length; i++) {
        var _ret = _loop(i);

        if (_ret === "continue") continue;
      }

      return ret;
    }

    function processLoopFields(billing, page, template, rawData) {
      var templateSize = rawData.size;
      var qtyRc = makeRcFromFieldArea(page.qty, templateSize);
      var supplies = [];
      var loopFields = getLoopFields(template.templateType);
      var loopLength = loopFields.length;

      for (var i = 0; i < rawData.data.lines.length; i++) {
        var line = rawData.data.lines[i];

        if (rectIncludes(qtyRc, line.bbox, 'y')) {
          var lastIndex = -1;

          var _loop3 = function _loop3(j) {
            var newLine = rawData.data.lines[j];
            var obj = {};
            loopFields.forEach(function (key) {
              var rc = makeRcFromFieldArea(page[key], templateSize);
              newLine.words.forEach(function (word) {
                if (rectIncludes(rc, word.bbox, 'x')) {
                  if (key == 'description') {
                    if (obj[key]) {
                      obj[key] += word.text + ' ';
                    } else {
                      obj[key] = word.text;
                    }
                  } else {
                    var value = getValidValue(billing, word.text, key);

                    if (!value) {
                      return;
                    }

                    obj[key] = value;
                  }
                }
              });
            });

            if (Object.keys(obj).length == loopLength && (lastIndex == -1 || j - lastIndex <= 3)) {
              supplies.push(obj);
              lastIndex = j;
            } else if (Object.keys(obj).length == 1 && obj.description && j - lastIndex <= 2) {
              if (supplies.length > 0) {
                supplies[supplies.length - 1].description += obj.description;
                lastIndex = j;
              }
            }
          };

          for (var j = i + 1; j < rawData.data.lines.length; j++) {
            _loop3(j);
          }

          break;
        }
      }

      return supplies;
    }

    function processManualLoopFields(billing, template) {
      var supplies = [];
      var loopFields = getLoopFields(template.templateType);
      var data = billing.customSupplierData;
      var MAX_SUPPLIES_COUNT = 10;

      for (var i = 1; i <= MAX_SUPPLIES_COUNT; i++) {
        var obj = {};

        for (var j = 0; j < loopFields.length; j++) {
          var field = loopFields[j];
          var key = field + i;

          if (data[key]) {
            obj[field] = data[key];

            if (j === loopFields.length - 1) {
              supplies.push(obj);
            }
          } else {
            break;
          }
        }
      }

      return supplies;
    }

    function rectIncludes(rectParent, rectChild, axis) {
      var rcThresY = (rectChild.y1 - rectChild.y0) * 0.5;
      var extendedParentRc = {
        x0: Math.max(0, rectParent.x0 - rcThres),
        y0: Math.max(0, rectParent.y0 - rcThresY),
        x1: rectParent.x1 + rcThres,
        y1: rectParent.y1 + rcThresY
      };

      if (axis == 'x') {
        return rectChild.x0 > extendedParentRc.x0 && rectChild.x1 < extendedParentRc.x1;
      } else if (axis == 'y') {
        return rectChild.y0 > extendedParentRc.y0 && rectChild.y1 < extendedParentRc.y1;
      } else {
        return rectChild.x0 > extendedParentRc.x0 && rectChild.y0 > extendedParentRc.y0 && rectChild.x1 < extendedParentRc.x1 && rectChild.y1 < extendedParentRc.y1;
      }
    }

    function makeRcFromFieldArea(field, templateSize) {
      return {
        x0: templateSize.width * field.x,
        y0: templateSize.height * field.y,
        x1: templateSize.width * field.width + templateSize.width * field.x,
        y1: templateSize.height * field.height + templateSize.height * field.y
      };
    }

    function getValidValue(billing, text, key) {
      if (key == 'description') {
        return text;
      }

      if (text.toString) {
        text = text.toString();
      }

      var locale = billing && billing.inputMethod ? billing.inputMethod : 'eu';
      var value = utils.getNormalNumber(text, locale);

      if (isNaN(value)) {
        return;
      }

      return value;
    }

    function processForFail(billing) {
      Notification.error('Failed in OCR. The invoice number was not recognized.');
      unsetRunningOCRBill(billing._id);
    }

    function getDateString(s, mode) {
      var regex = new RegExp('[a-z]', 'i');

      if (regex.test(s)) {
        var date = new Date(s);
        date = moment(date);
        return date.format('MMM.DD.yyyy');
      } else {
        var ary;
        s = s.replaceAll('-', '.');
        s = s.replaceAll('/', '.');
        ary = s.split('.');

        if (ary.length !== 3) {
          return '';
        }

        var y, m, d;

        switch (mode) {
          case 'mdy':
            m = ary[0];
            d = ary[1];
            y = ary[2];
            break;

          case 'dmy':
            d = ary[0];
            m = ary[1];
            y = ary[2];
            break;

          case 'ymd':
            y = ary[0];
            m = ary[1];
            d = ary[2];
            break;

          case 'ydm':
            y = ary[0];
            d = ary[1];
            m = ary[2];
            break;

          default:
            y = 0;
            d = 0;
            m = 0;
        }

        y = y.trim();
        m = m.trim();
        d = d.trim();
        var ny = Number.parseInt(y);
        var nm = Number.parseInt(m);
        var nd = Number.parseInt(d);

        if (isNaN(ny) || isNaN(nm) || isNaN(nd)) {
          return '';
        }

        if (ny < 100) {
          ny += 2000;
        }

        if (nm < 1 || nm > 12) {
          return '';
        }

        if (nd < 1 || nd > 31) {
          return '';
        }

        var _date = new Date("".concat(ny, "-").concat(nm, "-").concat(nd));

        _date = moment(_date);
        return _date.format('MMM.DD.yyyy');
      }
    }

    function resetCalcResult(billing) {
      if (billing) {
        billing.customSupplierData = {};
        delete billing.amountWithoutTax;
        delete billing.taxAmount;
        delete billing.totalAmount;
      }
    }

    $scope.updateBillDate = function () {
      if (vm.billing) {
        vm.billing.billDate = new Date($scope.billDate);
      }
    };

    $scope.updateDueDate = function () {
      if (vm.billing) {
        vm.billing.dueDate = new Date($scope.dueDate);
      }
    };

    $scope.isNormalType = function (billing) {
      if (!billing) {
        return true;
      }

      var template = billing.templateId;

      if (!template || !template.templateType) {
        return true;
      }

      return template.templateType.includes('normal');
    };

    $scope.isProjectTab = function () {
      return $scope.currentTab === PROJECT_BILL;
    };

    $scope.isCompanyTab = function () {
      return $scope.currentTab === COMPANY_BILL;
    };

    $scope.isPendingTab = function () {
      return $scope.currentTab === PENDING_BILL;
    };

    $scope.isFailedSyncTab = function () {
      return $scope.currentTab === FAILED_SYNC;
    };

    $scope.isMemoTab = function () {
      return $scope.currentTab === VENDOR_CREDIT_MEMO;
    };

    $scope.isRunningOCRBill = function (billing) {
      return billing && vm.ocrBillIdList.findIndex(function (x) {
        return x == billing._id;
      }) !== -1;
    };

    function unsetRunningOCRBill(billingId) {
      if (billingId == vm.proceedBillingId) {
        return;
      }

      var index = vm.ocrBillIdList.findIndex(function (x) {
        return x == billingId;
      });

      if (index !== -1) {
        vm.ocrBillIdList.splice(index, 1);
      }
    }

    $scope.deleteBilling = function () {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        apiFactory.deleteBilling(vm.billing._id).then(function () {
          Notification.success("".concat(vm.billing.billNo, " removed successfully."));
          getBillingList();
        })["catch"](function (err) {
          $log.error(err);
          Notification.error("Failed to remove!");
        });
      }, function () {});
    };

    function downloadCanvasAsImage(canvas, label) {
      var link = $document[0].createElement('a');
      link.download = label + '_' + Date.now() + '.png';
      link.href = canvas.toDataURL();
      link.click();
    }

    function downloadCVImgDataAsImage(imgData, label) {
      var outputCanvas = $document[0].createElement('canvas');
      cv.imshow(outputCanvas, imgData);
      downloadCanvasAsImage(outputCanvas, label);
    }

    $scope.changeIsRemoveVAT = function () {
      $scope.vendorDetail.vat = vm.isRemoveVAT ? 0 : $scope.getVat(vm.billing);
      calculatePrices(vm.billing);
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('filtersPanel', filtersPanel);

  function filtersPanel($state) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/orders/directives/filtersPanel/filtersPanel.view.html',
      scope: {
        activeMenu: "="
      },
      link: function link(scope) {
        scope.gotoPage = function (page) {
          $state.go(page);
        };
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail', ['app.core', 'pascalprecht.translate', 'tmh.dynamicLocale']);
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail').component('settingResponse', {
    controller: SettingResponseComponentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/setting/response/response.view.html'
  });
  /** @ngInject */

  function SettingResponseComponentController($scope, $log, $rootScope) {
    var vm = this;
    $scope.isDetail = false;
    $scope.isCompose = false;
    $scope.isCollapse = false;
    vm.currentName = '';
    vm.currentContent = '';
    vm.currentIndex = -1;
    vm.arrResponse = [{
      'name': 'Thank you for reaching out',
      'content': 'Thank you for reaching out'
    }, {
      'name': 'Thank you for contacting us',
      'content': 'Thank you for contacting us'
    }, {
      'name': '{Ticket Number} Your Support Request',
      'content': '{Ticket Number} Your Support Request'
    }, {
      'name': '{Forum} CloudES Summary',
      'content': '{Forum} CloudES Summary'
    }, {
      'name': '{Webinar} is scheduled on (Time} {Date}',
      'content': '{Webinar} is scheduled on (Time} {Date}'
    }, {
      'name': 'Thank you for reaching out',
      'content': 'Thank you for reaching out'
    }, {
      'name': 'Thank you for contacting us',
      'content': 'Thank you for contacting us'
    }, {
      'name': '{Ticket Number} Your Support Request',
      'content': '{Ticket Number} Your Support Request'
    }, {
      'name': '{Forum} CloudES Summary',
      'content': '{Forum} CloudES Summary'
    }, {
      'name': '{Webinar} is scheduled on (Time} {Date}',
      'content': '{Webinar} is scheduled on (Time} {Date}'
    }, {
      'name': 'Thank you for reaching out',
      'content': 'Thank you for reaching out'
    }, {
      'name': 'Thank you for contacting us',
      'content': 'Thank you for contacting us'
    }, {
      'name': '{Ticket Number} Your Support Request',
      'content': '{Ticket Number} Your Support Request'
    }, {
      'name': '{Forum} CloudES Summary',
      'content': '{Forum} CloudES Summary'
    }, {
      'name': '{Webinar} is scheduled on (Time} {Date}',
      'content': '{Webinar} is scheduled on (Time} {Date}'
    }, {
      'name': 'Thank you for reaching out',
      'content': 'Thank you for reaching out'
    }, {
      'name': 'Thank you for contacting us',
      'content': 'Thank you for contacting us'
    }, {
      'name': '{Ticket Number} Your Support Request',
      'content': '{Ticket Number} Your Support Request'
    }, {
      'name': '{Forum} CloudES Summary',
      'content': '{Forum} CloudES Summary'
    }, {
      'name': '{Webinar} is scheduled on (Time} {Date}',
      'content': '{Webinar} is scheduled on (Time} {Date}'
    }];

    $scope.updateResponse = function (index) {
      vm.currentName = vm.arrResponse[index].name;
      vm.currentContent = vm.arrResponse[index].content;
      vm.currentIndex = index;
    };

    $scope.saveResponse = function () {
      if (vm.currentIndex != '') {
        vm.arrResponse[vm.currentIndex].name = vm.currentName;
        vm.arrResponse[vm.currentIndex].content = vm.currentContent;
      } else {
        var newResponse = {
          'name': vm.currentName,
          'content': vm.currentContent
        };
        vm.arrResponse.push(newResponse);
      }
    };

    $scope.createResponse = function () {
      vm.currentName = '';
      vm.currentContent = '';
      vm.currentIndex = -1;
    };

    var mailComposeCallback = $rootScope.$on('mail-compose', function () {
      $scope.isDetail = true;
      $scope.isCompose = true;
    });
    var sideMenuCollapseCallback = $rootScope.$on('side-menu-collapse', function () {
      $scope.isCollapse = !$scope.isCollapse;
    });
    $rootScope.$on('$destroy', mailComposeCallback, sideMenuCollapseCallback);
  }
})();


"use strict";

(function () {
  angular.module("app.mail").component("createMailHost", {
    controller: createMailHostController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/modals/createMailHost/createMailHost.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function createMailHostController($scope, Notification, apiFactory, $log) {
    var vm = this;

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (!$scope.imap_server || !$scope.imap_port || !$scope.smtp_server || !$scope.smtp_port) {
        Notification.error('Please fill all fields.');
        return;
      }

      var hostInfo = {
        name: $scope.name,
        imap_server: $scope.imap_server,
        imap_port: $scope.imap_port,
        imap_tls: $scope.imap_tls ? $scope.imap_tls : false,
        smtp_server: $scope.smtp_server,
        smtp_port: $scope.smtp_port,
        smtp_tls: $scope.smtp_tls ? $scope.smtp_tls : false
      };
      apiFactory.createWebmailHost(hostInfo).then(function (resp) {
        vm.modalInstance.close(resp.data.data);
      })["catch"](function (e) {
        $log.error(e);
        Notification.error('Add Mail Host Failed.');
      }); // vm.modalInstance.close(mailInfo);
    };

    $scope.onAddHost = function () {};
  }
})();


"use strict";

(function () {
  angular.module('app').directive('settingMenu', settingMenu);

  function settingMenu($state) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/mail/directives/setting-menu/setting-menu.view.html',
      scope: {},
      link: function link(scope) {
        scope.currentRoute = $state.current.url;
        scope.parentRoute = $state.current.url.split('/')[2];
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('replyCommentModal', {
    controller: replyCommentModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/issues/modals/reply-comment-modal/reply-comment-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function replyCommentModal($scope, utils, Notification, apiFactory, $log) {
    var vm = this;

    vm.$onInit = function () {
      vm.parentComment = vm.resolve.comment;
      $scope.commentData = {
        parentId: vm.parentComment._id,
        files: []
      };
    };

    $scope.onChangeFiles = function (files) {
      var file = files[0];
      if (angular.isUndefined(file)) return;
      var fileData = {
        file: file
      };

      if (utils.isImageFile(file)) {
        fileData.isImage = true;
        fileData.imageURL = URL.createObjectURL(file);
      }

      $scope.commentData.files.push(fileData);
    };

    $scope.removeFile = function (index) {
      $scope.commentData.files.splice(index, 1);
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.postComment = function () {
      if (utils.isEmpty($scope.commentData.comment)) {
        Notification.error('Please input your comment.');
        return;
      }

      $scope.loading = true;
      apiFactory.postCommentForIssue(vm.parentComment.issueId, $scope.commentData).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close(res.data.data);
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
        Notification.error('Failed to post comment.');
      });
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("issueSelectbox", issueSelectbox);

  function issueSelectbox() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/main/issues/directives/issue-selectbox/issue-selectbox.view.html',
      scope: {
        ngModel: "=",
        options: "=",
        excludeItems: "=",
        isClickOpen: "@",
        placeholder: "@",
        labelField: "@",
        valueField: "@",
        enableAddItem: "=",
        addItemEvent: "&",
        selectEvent: "&",
        onClose: "&",
        toTop: "=",
        readonly: '=',
        isDisabled: '@'
      },
      link: function link(scope, element) {
        scope.isOpen = false;
        scope.cOptions = [];
        scope.selectedLabel = scope.placeholder;

        if (!scope.isClickOpen) {
          scope.isClickOpen = false;
        }

        if (scope.ngModel && scope.options) {
          if (scope.ngModel != {}) {
            var selectedItem = scope.options.find(function (item) {
              return item[scope.valueField] == scope.ngModel;
            });
            if (selectedItem) scope.selectedLabel = selectedItem[scope.labelField];
          }
        }

        var expression = element.attr("exclude-items");
        scope.$parent.$watch(expression, function (newVal) {
          scope.filterExcludeOptions(newVal);
        });

        scope.filterExcludeOptions = function (excludeList) {
          if (excludeList && excludeList.length) {
            var newOptions = [];
            scope.cOptions.map(function (it) {
              if (!excludeList.includes(it[scope.labelField])) {
                newOptions.push(it);
              }
            });
            scope.cOptions = newOptions;
          }
        };

        scope.toggleList = function () {
          if (scope.readonly) return;
          scope.isOpen = !scope.isOpen;

          if (scope.isOpen) {
            scope.cOptions = scope.options;

            if (scope.isSearch) {
              scope.searchFunction(scope.selectedLabel);
            }

            scope.filterExcludeOptions(scope.excludeItems);
          }
        };

        scope.updateData = function () {
          if (scope.options && scope.ngModel) {
            var _selectedItem = scope.options.find(function (item) {
              return item[scope.valueField] == scope.ngModel;
            });

            if (_selectedItem) scope.selectedLabel = _selectedItem[scope.labelField];
          } else {
            scope.selectedLabel = scope.placeholder;
          }

          scope.selectEvent({
            value: scope.ngModel
          });
        };

        scope.$watch('ngModel', function (newVal, oldVal) {
          if (newVal != oldVal) {
            scope.updateData();
          }
        });
        scope.$watch('options', function (newVal, oldVal) {
          var newLength = 0;
          var oldLength = 0;

          if (newVal) {
            newLength = newVal.length;
          }

          if (oldVal) {
            oldLength = oldVal.length;
          }

          if (newLength != oldLength) {
            scope.updateData();
          }
        });

        scope.selectItem = function (item) {
          if (scope.ngModel != item[scope.valueField]) {
            scope.ngModel = item[scope.valueField];
            scope.selectedLabel = item[scope.labelField];
          }

          scope.isOpen = false;
          scope.isselectedItem = true;
        };

        scope.closeList = function () {
          scope.isOpen = false;

          if (!scope.isselectedItem && scope.options) {
            for (var i = 0; i < scope.options.length; i++) {
              if (scope.options[i][scope.valueField] == scope.ngModel) {
                scope.originLabel = scope.options[i][scope.labelField];
              }
            }

            if (!scope.placeholder) {
              scope.selectedLabel = scope.originLabel;
            }
          }

          scope.onClose();
        };

        scope.openList = function () {
          if (scope.readonly) return;
          scope.isOpen = true;
          scope.cOptions = scope.options; // if (scope.isSearch) {
          //   scope.searchFunction(scope.selectedLabel);
          // }

          scope.filterExcludeOptions(scope.excludeItems);
        };

        scope.addItem = function () {
          scope.addItemEvent();
        };

        scope.startSearch = function () {
          scope.isOpen = true;
        };

        scope.searchFunction = function (searchText) {
          scope.isselectedItem = false;
          var output = [];

          if (searchText || searchText == '') {
            if (searchText.length >= 0) {
              angular.forEach(scope.options, function (item) {
                if (item[scope.labelField].toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                  output.push(item);
                }
              });
            }
          }

          scope.cOptions = output;
          scope.filterExcludeOptions(scope.excludeItems);
        };

        scope.getColorClass = function () {
          switch (scope.ngModel) {
            case 'Open':
              return {
                'open': true
              };

            case 'Resolved':
              return {
                'resolved': true
              };

            case 'Completed':
              return {
                'completed': true
              };

            case 'High':
              return {
                'high': true
              };

            case 'Medium':
              return {
                'medium': true
              };

            case 'Low':
              return {
                'low': true
              };

            case 'On Hold':
              return {
                'on-hold': true
              };

            default:
              return {
                'on-hold': true
              };
          }
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('issueHistory', issueHistory);

  function issueHistory() {
    return {
      restrict: "E",
      templateUrl: "app/main/issues/directives/issue-history/issue-history.view.html",
      scope: {
        ngModel: "="
      },
      link: function link($scope) {
        $scope.getImage = function (activity_text) {
          switch (activity_text) {
            case 'created_issue':
            case 'updated_issue':
              return '/assets/icons/edit_blue.svg';

            case 'added_comment':
              return '/assets/icons/message_blue.svg';

            default:
              return '/assets/icons/star_blue.svg';
          }
        };

        $scope.getHTML = function (activity) {
          switch (activity.activity) {
            case 'created_issue':
              return '<span class="text-bold text-blue">' + activity.userName + '</span>' + '<span class="text-bold">&nbsp;created an issue</span>';

            case 'updated_issue':
              return '<span class="text-bold text-blue">' + activity.userName + '</span>' + '<span class="text-bold">&nbsp;updated an issue</span>';

            case 'added_comment':
              return '<span class="text-bold text-blue">' + activity.userName + '</span>' + '<span class="text-bold">&nbsp;posted a comment</span>';

            default:
              return activity.activity;
          }
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("issueComment", issueComment);

  function issueComment($uibModal, utils) {
    return {
      restrict: "E",
      templateUrl: "app/main/issues/directives/issue-comment/issue-comment.view.html",
      scope: {
        ngModel: "="
      },
      link: function link($scope) {
        $scope.utils = utils;

        $scope.expandReplies = function () {
          $scope.ngModel.expand = !$scope.ngModel.expand;
        };

        $scope.toggleReplyCommentModal = function () {
          var modal = $uibModal.open({
            animation: true,
            component: 'replyCommentModal',
            windowClass: 'reply-comment-modal',
            resolve: {
              comment: function comment() {
                return $scope.ngModel;
              }
            }
          });
          modal.result.then(function (result) {
            $scope.ngModel.replies.push(result.createdComment);
          }, function () {});
        };
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('invoiceCopyModal', {
    controller: invoiceCopyModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/modals/invoice-copy-modal/invoice-copy-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function invoiceCopyModal(apiFactory, Notification, utils, $log, $scope, $uibModal) {
    var vm = this;
    vm.recipients = {
      emails: [],
      managers: []
    };

    vm.$onInit = function () {
      vm.invoice = vm.resolve.invoice;
      $scope.isLoading = true;
      apiFactory.getInvoice(vm.invoice._id).then(function (res) {
        $scope.isLoading = false;
        vm.invoice = res.data.data;
        $scope.companyCurrency = vm.invoice.companyCurrency;
        vm.invoice.vendor.name = vm.invoice.vendor.name || vm.invoice.vendor.clientName;
      })["catch"](function (e) {
        $scope.isLoading = false;
        $log.error("error", e);
        Notification.error(utils.getErrorMessage(e));
      });
    };

    vm.showRecipientsPopup = function () {
      $uibModal.open({
        animation: true,
        component: 'recipientsModal',
        windowClass: 'recipients-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          recipients: function recipients() {
            return vm.recipients;
          },
          title: function title() {
            return 'Invoice / Credit Memo';
          },
          send: function send() {
            return true;
          }
        }
      }).result.then(function (result) {
        if (result) {
          send();
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    function send() {
      var invoiceData = prepareInvoiceData(vm.invoice);

      if (invoiceData) {
        $scope.isLoading = true;
        apiFactory.createAndSendInvoice(invoiceData).then(function (resp) {
          $scope.isLoading = false;
          Notification.success("Invoice saved and sent successfully");
          vm.invoice.displaySeq = resp.data.data.displaySeq;
          vm.invoice.invoiceDoc = resp.data.data.invoiceDoc;
          vm.modalInstance.close(vm.invoice);
        })["catch"](function (e) {
          $scope.isLoading = false;
          $log.error(e);
          Notification.error(utils.getErrorMessage(e));
        });
      }
    }

    function prepareInvoiceData(data) {
      var items = [];
      data.items.forEach(function (item) {
        if (item.description) {
          var itemdata = {
            type: item.itemId,
            number: item.itemNum,
            description: item.description,
            quantity: item.quantity,
            unitPrice: item.unitPrice,
            vatPercent: item.vatPercent,
            vatAmount: item.vatAmount,
            taxPercent: item.taxPercent,
            taxAmount: item.taxAmount,
            price: item.price
          };

          if (item.matId) {
            itemdata.matId = item.matId;
          }

          if (item.eqId) {
            itemdata.eqId = item.eqId;
          }

          items.push(itemdata);
        }
      });
      var invoiceData = {
        date: moment(data.date).format(),
        dueDate: moment(data.dueDate).format(),
        projectId: data.projectId ? data.projectId : vm.project._id,
        projectSystemTag: data.projectSystemTag,
        termsAndConditions: data.termsAndConditions,
        items: items,
        recipients: vm.recipients,
        status: data.status,
        isCreditMemo: vm.AsCreditNoteTag,
        paymentTerms: data.paymentTerms,
        totalPrice: data.totalPrice,
        totalVat: data.totalVat,
        totalTax: data.totalTax,
        totalAmount: data.totalAmount,
        companyCurrency: data.companyCurrency ? data.companyCurrency : $scope.companyCurrency,
        fromVariationOrder: data.fromVariationOrder ? data.fromVariationOrder : false
      };
      delete vm.invoice._id;
      invoiceData.vendorType = data.vendorType;
      invoiceData.vendor = data.vendor._id ? data.vendor._id : data.vendor;
      invoiceData.staff = data.staff;
      return invoiceData;
    }

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('financeUploadPayrollModal', {
    controller: financeUploadPayrollModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/modals/finance-upload-payroll-modal/finance-upload-payroll-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function financeUploadPayrollModal($scope, globals, apiFactory, Notification, utils, $log, $timeout) {
    var vm = this;
    vm.companyData = globals.companyStore.get();
    vm.financePayroll = {
      name: "",
      description: "",
      list: [],
      creditRule: "minus"
    };
    vm.creditRules = [{
      label: "Credit = -",
      value: "minus"
    }, {
      label: "Credit = +",
      value: "plus"
    }];

    vm.$onInit = function () {
      vm.data = vm.resolve.data;
      vm.accountPlans = vm.resolve.accountPlans;
      vm.financePayroll.bankId = vm.resolve.bankId;
      var rows = vm.data.rows; // console.log(vm.data);

      var _iterator = _createForOfIteratorHelper(rows),
          _step;

      try {
        var _loop = function _loop() {
          var payroll = _step.value;
          var accountPlan = vm.accountPlans.find(function (x) {
            return x.number == payroll.accountPlanNumber;
          });

          if (accountPlan) {
            var totalAmount = payroll.totalAmount;
            var item = {
              accountPlan: accountPlan._id,
              date: new Date(payroll.date),
              description: payroll.description,
              totalAmount: totalAmount,
              remainingAmount: totalAmount,
              type: payroll.type
            };

            if (vm.financePayroll.creditRule === "minus") {
              item.credit = item.totalAmount < 0 ? item.totalAmount : 0;
              item.debit = item.totalAmount > 0 ? item.totalAmount : 0;
            } else {
              item.debit = item.totalAmount < 0 ? item.totalAmount : 0;
              item.credit = item.totalAmount > 0 ? item.totalAmount : 0;
            }

            vm.financePayroll.list.push(item);
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      calcSum();
    };

    function calcSum() {
      vm.financePayroll.totalDebit = 0;
      vm.financePayroll.totalCredit = 0;
      vm.financePayroll.totalAmount = 0;
      vm.financePayroll.list.forEach(function (x) {
        vm.financePayroll.totalDebit += x.debit;
        vm.financePayroll.totalCredit += x.credit;
        vm.financePayroll.totalAmount += x.totalAmount;
      });
    }

    $scope.changeValue = function (payroll, type) {
      if (type === 'debit') {
        payroll.totalAmount = payroll.debit;
        payroll.credit = 0;
      } else if (type === 'credit') {
        payroll.totalAmount = payroll.credit;
        payroll.debit = 0;
      } else if (type === 'balance') {
        if (vm.financePayroll.creditRule === "minus") {
          payroll.credit = payroll.totalAmount < 0 ? payroll.totalAmount : 0;
          payroll.debit = payroll.totalAmount > 0 ? payroll.totalAmount : 0;
        } else {
          payroll.debit = payroll.totalAmount < 0 ? payroll.totalAmount : 0;
          payroll.credit = payroll.totalAmount > 0 ? payroll.totalAmount : 0;
        }
      }

      $timeout(function () {
        calcSum();
      }, 100);
    };

    $scope.changeCreditRule = function () {
      vm.financePayroll.list.forEach(function (item) {
        if (vm.financePayroll.creditRule === "minus") {
          item.credit = item.totalAmount < 0 ? item.totalAmount : 0;
          item.debit = item.totalAmount > 0 ? item.totalAmount : 0;
        } else {
          item.debit = item.totalAmount < 0 ? item.totalAmount : 0;
          item.credit = item.totalAmount > 0 ? item.totalAmount : 0;
        }
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onSave = function () {
      if (utils.isEmpty(vm.financePayroll.name)) {
        Notification.error("Please input a name.");
        return;
      }

      if (!vm.financePayroll.startDate) {
        Notification.error("Please select a start date.");
        return;
      }

      if (!vm.financePayroll.endDate) {
        Notification.error("Please select an end date.");
        return;
      }

      $scope.loading = true;
      apiFactory.uploadFinancePayroll(vm.financePayroll).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('financeUploadGenPostModal', {
    controller: financeUploadGenPostModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/modals/finance-upload-gen-post-modal/finance-upload-gen-post-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function financeUploadGenPostModal($scope, globals, apiFactory, Notification, utils, $log, $timeout) {
    var vm = this;
    vm.companyData = globals.companyStore.get();
    vm.externEconomic = {
      name: "",
      description: "",
      list: [],
      creditRule: "Credit = -"
    };
    vm.creditRules = [{
      label: "Credit = -",
      value: "Credit = -"
    }, {
      label: "Credit = +",
      value: "Credit = +"
    }];
    vm.vendors = [];

    vm.$onInit = function () {
      $scope.loading = true;
      Promise.all([apiFactory.listAllClients(), apiFactory.getAllSuppliers(), apiFactory.getAllSubcontractors()]).then(function (res) {
        $scope.loading = false;
        var clients = res[0].data.list;
        var suppliers = res[1].data.list;
        var subcontractors = res[2].data.list;
        clients = clients.map(function (x) {
          return {
            _id: x._id,
            vendorName: 'Client - ' + x.clientName,
            vendorType: "Client"
          };
        });
        suppliers = suppliers.map(function (x) {
          return {
            _id: x._id,
            vendorName: 'Supplier - ' + x.name,
            vendorType: "Supplier"
          };
        });
        subcontractors = subcontractors.map(function (x) {
          return {
            _id: x._id,
            vendorName: 'Subcontractor - ' + x.name,
            vendorType: "Subcontractor"
          };
        });
        vm.vendors = clients.concat(suppliers).concat(subcontractors);
        vm.accountPlans = vm.resolve.accountPlans;

        var _iterator = _createForOfIteratorHelper(vm.resolve.data),
            _step;

        try {
          var _loop = function _loop() {
            var entry = _step.value;
            var accountPlan = vm.accountPlans.find(function (x) {
              return x.number == entry.accountPlanNumber;
            });
            var vendor = vm.vendors.find(function (x) {
              var vendorName = x.vendorName.split(' - ')[1];
              var result = utils.compareTwoStrings(vendorName, entry.vendorName);
              return result >= 0.8;
            });
            var item = {
              accountPlan: accountPlan ? accountPlan._id : undefined,
              vendor: vendor ? vendor._id : undefined,
              vendorType: vendor ? vendor.vendorType : undefined,
              vendorName: entry.vendorName,
              totalAmount: entry.totalAmount,
              remainingAmount: entry.totalAmount,
              code: entry.accountPlanNumber || ''
            };

            if (vm.externEconomic.creditRule === "Credit = -") {
              item.credit = entry.totalAmount < 0 ? item.totalAmount : 0;
              item.debit = entry.totalAmount > 0 ? item.totalAmount : 0;
            } else {
              item.debit = entry.totalAmount < 0 ? item.totalAmount : 0;
              item.credit = entry.totalAmount > 0 ? item.totalAmount : 0;
            }

            vm.externEconomic.list.push(item);
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        calcSum();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function calcSum() {
      vm.externEconomic.totalDebit = 0;
      vm.externEconomic.totalCredit = 0;
      vm.externEconomic.totalAmount = 0;
      vm.externEconomic.list.forEach(function (x) {
        vm.externEconomic.totalDebit += x.debit;
        vm.externEconomic.totalCredit += x.credit;
        vm.externEconomic.totalAmount += x.totalAmount;
      });
    }

    $scope.changeValue = function (entry, type) {
      if (type === 'debit') {
        entry.totalAmount = entry.debit;
        entry.credit = 0;
      } else if (type === 'credit') {
        entry.totalAmount = entry.credit;
        entry.debit = 0;
      }

      $timeout(function () {
        calcSum();
      }, 100);
    };

    $scope.changeCreditRule = function () {
      vm.externEconomic.list.forEach(function (item) {
        if (vm.externEconomic.creditRule === "Credit = -") {
          item.credit = item.totalAmount < 0 ? item.totalAmount : 0;
          item.debit = item.totalAmount > 0 ? item.totalAmount : 0;
        } else {
          item.debit = item.totalAmount < 0 ? item.totalAmount : 0;
          item.credit = item.totalAmount > 0 ? item.totalAmount : 0;
        }
      });
    };

    $scope.changeVendor = function (entry) {
      var vendor = vm.vendors.find(function (x) {
        return x._id == entry.vendor;
      });

      if (vendor) {
        entry.vendorType = vendor.vendorType;
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onSave = function () {
      if (utils.isEmpty(vm.externEconomic.name)) {
        Notification.error("Please input a name.");
        return;
      }

      if (!vm.externEconomic.date) {
        Notification.error("Please select a date.");
        return;
      }

      var valid = true;

      var _iterator2 = _createForOfIteratorHelper(vm.externEconomic.list),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var entry = _step2.value;

          if (!entry.accountPlan) {
            valid = false;
            break;
          }

          if (!entry.vendor || !entry.vendorType) {
            valid = false;
            break;
          }

          entry.creditRule = vm.externEconomic.creditRule;
          entry.date = vm.externEconomic.date;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (!valid) {
        Notification.error("Please select account plan and vendor for all entries.");
        return;
      }

      $scope.loading = true;
      apiFactory.uploadFinanceEntries(vm.externEconomic.list).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('financeUploadEntryModal', {
    controller: financeUploadEntryModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/modals/finance-upload-entry-modal/finance-upload-entry-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function financeUploadEntryModal($scope, globals, apiFactory, Notification, utils, $log, $timeout) {
    var vm = this;
    vm.companyData = globals.companyStore.get();
    vm.externEconomic = {
      name: "",
      description: "",
      list: [],
      creditRule: "Credit = -"
    };
    vm.creditRules = [{
      label: "Credit = -",
      value: "Credit = -"
    }, {
      label: "Credit = +",
      value: "Credit = +"
    }];
    vm.vendors = [];

    vm.$onInit = function () {
      $scope.loading = true;
      Promise.all([apiFactory.listAllClients(), apiFactory.getAllSuppliers(), apiFactory.getAllSubcontractors()]).then(function (res) {
        $scope.loading = false;
        var clients = res[0].data.list;
        var suppliers = res[1].data.list;
        var subcontractors = res[2].data.list;
        clients = clients.map(function (x) {
          return {
            _id: x._id,
            vendorName: 'Client - ' + x.clientName,
            vendorType: "Client"
          };
        });
        suppliers = suppliers.map(function (x) {
          return {
            _id: x._id,
            vendorName: 'Supplier - ' + x.name,
            vendorType: "Supplier"
          };
        });
        subcontractors = subcontractors.map(function (x) {
          return {
            _id: x._id,
            vendorName: 'Subcontractor - ' + x.name,
            vendorType: "Subcontractor"
          };
        });
        vm.vendors = clients.concat(suppliers).concat(subcontractors);
        vm.accountPlans = vm.resolve.accountPlans;

        var _iterator = _createForOfIteratorHelper(vm.resolve.data),
            _step;

        try {
          var _loop = function _loop() {
            var entry = _step.value;
            var accountPlan = vm.accountPlans.find(function (x) {
              return x.number == entry.accountPlanNumber;
            });
            var vendor = vm.vendors.find(function (x) {
              var vendorName = x.vendorName.split(' - ')[1];
              var result = utils.compareTwoStrings(vendorName, entry.vendorName);
              return result >= 0.8;
            });
            var item = {
              accountPlan: accountPlan ? accountPlan._id : undefined,
              vendor: vendor ? vendor._id : undefined,
              vendorType: vendor ? vendor.vendorType : undefined,
              vendorName: entry.vendorName,
              totalAmount: entry.totalAmount,
              remainingAmount: entry.totalAmount
            };

            if (vm.externEconomic.creditRule === "Credit = -") {
              item.credit = entry.totalAmount < 0 ? item.totalAmount : 0;
              item.debit = entry.totalAmount > 0 ? item.totalAmount : 0;
            } else {
              item.debit = entry.totalAmount < 0 ? item.totalAmount : 0;
              item.credit = entry.totalAmount > 0 ? item.totalAmount : 0;
            }

            vm.externEconomic.list.push(item);
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        calcSum();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function calcSum() {
      vm.externEconomic.totalDebit = 0;
      vm.externEconomic.totalCredit = 0;
      vm.externEconomic.totalAmount = 0;
      vm.externEconomic.list.forEach(function (x) {
        vm.externEconomic.totalDebit += x.debit;
        vm.externEconomic.totalCredit += x.credit;
        vm.externEconomic.totalAmount += x.totalAmount;
      });
    }

    $scope.changeValue = function (entry, type) {
      if (type === 'debit') {
        entry.totalAmount = entry.debit;
        entry.credit = 0;
      } else if (type === 'credit') {
        entry.totalAmount = entry.credit;
        entry.debit = 0;
      }

      $timeout(function () {
        calcSum();
      }, 100);
    };

    $scope.changeCreditRule = function () {
      vm.externEconomic.list.forEach(function (item) {
        if (vm.externEconomic.creditRule === "Credit = -") {
          item.credit = item.totalAmount < 0 ? item.totalAmount : 0;
          item.debit = item.totalAmount > 0 ? item.totalAmount : 0;
        } else {
          item.debit = item.totalAmount < 0 ? item.totalAmount : 0;
          item.credit = item.totalAmount > 0 ? item.totalAmount : 0;
        }
      });
    };

    $scope.changeVendor = function (entry) {
      var vendor = vm.vendors.find(function (x) {
        return x._id == entry.vendor;
      });

      if (vendor) {
        entry.vendorType = vendor.vendorType;
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onSave = function () {
      if (utils.isEmpty(vm.externEconomic.name)) {
        Notification.error("Please input a name.");
        return;
      }

      if (!vm.externEconomic.date) {
        Notification.error("Please select a date.");
        return;
      }

      var valid = true;

      var _iterator2 = _createForOfIteratorHelper(vm.externEconomic.list),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var entry = _step2.value;

          if (!entry.accountPlan) {
            valid = false;
            break;
          } // if (!entry.vendor || !entry.vendorType) {
          //   valid = false;
          //   break;
          // }


          entry.creditRule = vm.externEconomic.creditRule;
          entry.date = vm.externEconomic.date;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (!valid) {
        Notification.error("Please select account plan for all entries.");
        return;
      }

      $scope.loading = true;
      apiFactory.uploadFinanceEntries(vm.externEconomic.list).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  angular.module("app").component("financeUploadCSVModal", {
    controller: financeUploadCSVModal,
    controllerAs: "vm",
    templateUrl: "app/main/finance/modals/finance-upload-csv-modal/finance-upload-csv-modal.view.html",
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });

  function financeUploadCSVModal($scope, utils, Notification, $timeout) {
    var vm = this;
    $scope.delimiter = 'semicolon';
    $scope.inputMethod = 'European et al.';
    vm.textRows = [];
    vm.rows = [];
    vm.reader = new FileReader();

    vm.$onInit = function () {
      vm.title = vm.resolve.title || "Import a CSV File";
      vm.importType = vm.resolve.importType;
    };

    $scope.cancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.getCellClass = function (len, index) {
      if (!len) {
        len = 1;
      }

      var val = Math.floor(100 / len);
      var remain = 100 - val * len;

      if (index < remain) {
        val += 1;
      }

      return _defineProperty({
        td: true
      }, "flex-".concat(val), true);
    };

    $scope.$watch('delimiter', function (newVal) {
      vm.rows = [];

      var _iterator = _createForOfIteratorHelper(vm.textRows),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          var cells = row.split(newVal == 'semicolon' ? ";" : ",");
          cells = cells.filter(function (cell) {
            return !utils.isEmpty(cell);
          });

          if (cells.length) {
            vm.rows.push(cells);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      $timeout(function () {
        $scope.$apply();
      });
    });

    $scope["import"] = function () {
      var rows = [];

      if (vm.importType === "Payroll") {
        var _iterator2 = _createForOfIteratorHelper(vm.rows),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var row = _step2.value;

            if (angular.isUndefined(row[3]) || !isFinite(row[3]) || angular.isUndefined(row[5]) || !utils.numConsiderInputMethod(row[5], $scope.inputMethod)) {
              continue;
            }

            var payroll = {
              date: row[1],
              type: row[2],
              accountPlanNumber: row[3],
              totalAmount: utils.numConsiderInputMethod(row[5], $scope.inputMethod),
              remainingAmount: utils.numConsiderInputMethod(row[5], $scope.inputMethod),
              description: row[6],
              period: row[7]
            };
            rows.push(payroll);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        vm.modalInstance.close({
          inputMethod: $scope.inputMethod,
          rows: rows
        });
      } else if (vm.importType === "BankStatement") {
        var datePattern = /(\d{2})-(\d{2})-(\d{4})/;

        var _iterator3 = _createForOfIteratorHelper(vm.rows),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _row = _step3.value;

            if (angular.isUndefined(_row[1]) || angular.isUndefined(_row[3]) || !utils.numConsiderInputMethod(_row[3], $scope.inputMethod)) {
              continue;
            }

            var bankStatement = {
              date: new Date(_row[1].replace(datePattern, "$3-$2-$1")),
              description: _row[2],
              amount: utils.numConsiderInputMethod(_row[3], $scope.inputMethod),
              remainingAmount: utils.numConsiderInputMethod(_row[3], $scope.inputMethod)
            };
            rows.push(bankStatement);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        vm.modalInstance.close(rows);
      } else if (vm.importType === "ExternEconomic") {
        var _iterator4 = _createForOfIteratorHelper(vm.rows),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _row2 = _step4.value;
            _row2 = _row2.filter(function (item) {
              return item !== "";
            });

            if (angular.isDefined(_row2[2])) {
              _row2[2] = _row2[2].replace(' ', ',');
            }

            if (angular.isUndefined(_row2[0]) || angular.isUndefined(_row2[1]) || angular.isUndefined(_row2[2]) || !utils.numConsiderInputMethod(_row2[2], $scope.inputMethod)) {
              continue;
            }

            var externEconomicEntry = {
              accountPlanNumber: _row2[0],
              vendorName: _row2[1],
              totalAmount: utils.numConsiderInputMethod(_row2[2], $scope.inputMethod),
              remainingAmount: utils.numConsiderInputMethod(_row2[2], $scope.inputMethod)
            };
            rows.push(externEconomicEntry);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        vm.modalInstance.close(rows);
      }
    };

    $scope.fileUpdated = function (files) {
      if (files && files.length) {
        var file = files[0];

        if (angular.isUndefined(FileReader)) {
          Notification.error("This browser does not support HTML5.");
          return;
        }

        vm.reader.readAsText(file);
      }
    };

    vm.reader.onloadstart = function () {
      $scope.loading = true;
      vm.textRows = [];
      vm.rows = [];
    };

    vm.reader.onload = function (e) {
      $scope.loading = false;
      vm.textRows = e.target.result.split("\r\n");

      var _iterator5 = _createForOfIteratorHelper(vm.textRows),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var row = _step5.value;
          var cells = row.split($scope.delimiter === 'semicolon' ? ";" : ",");

          if (cells.length > 0 && !utils.isEmpty(cells[0])) {
            vm.rows.push(cells);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      $timeout(function () {
        $scope.$apply();
      });
    };

    vm.reader.onloadend = function () {
      $scope.loading = false;
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeDocTemplateModal', {
    controller: financeDocTemplateModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/modals/finance-doc-template-modal/finance-doc-template-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function financeDocTemplateModal(apiFactory, Notification, utils, $log, $scope) {
    var vm = this;
    vm.financeDocTemplate = {
      searchAttributes: []
    };
    $scope.attrText = undefined;
    $scope.bankAccountText = "";
    $scope.balanceAccountText = "";

    vm.$onInit = function () {
      vm.financeDocTemplates = vm.resolve.financeDocTemplates;
      vm.bankAccountPlans = vm.resolve.bankAccountPlans;
      vm.balanceAccountPlans = vm.resolve.balanceAccountPlans;
      vm.vatAccountPlans = vm.resolve.vatAccountPlans;
      vm.templateList = angular.copy(vm.financeDocTemplates);
      vm.templateList.unshift({
        _id: undefined,
        name: ''
      });
    };

    $scope.addAttribute = function () {
      if (utils.isEmpty($scope.attrText)) {
        Notification.error('Please input text for search attribute');
        return;
      }

      vm.financeDocTemplate.searchAttributes = vm.financeDocTemplate.searchAttributes || [];

      if (vm.financeDocTemplate.searchAttributes.find(function (x) {
        return x === $scope.attrText;
      })) {
        Notification.error('Already exists. Please type another text');
        return;
      }

      vm.financeDocTemplate.searchAttributes.push($scope.attrText);
      $scope.attrText = "";
    };

    $scope.changeTemplate = function () {
      var template = vm.templateList.find(function (x) {
        return x._id === $scope.selectedTemplate;
      });

      if (template) {
        vm.financeDocTemplate = template;
      } else {
        vm.financeDocTemplate = {
          searchAttributes: []
        };
      }
    };

    $scope.onSave = function () {
      if (utils.isEmpty(vm.financeDocTemplate.name)) {
        Notification.error('Please input a name.');
        return;
      }

      if (utils.isEmpty(vm.financeDocTemplate.searchAttributes)) {
        Notification.error("Please add search attributes.");
        return;
      }

      if (utils.isEmpty(vm.financeDocTemplate.bankAccountPlan)) {
        Notification.error("Please select a bank account plan.");
        return;
      }

      if (utils.isEmpty(vm.financeDocTemplate.balanceAccountPlan)) {
        Notification.error("Please select a balance account plan.");
        return;
      }

      if (utils.isEmpty(vm.financeDocTemplate.vatAccountPlan)) {
        Notification.error("You need to choose a VAT account plan.");
        return;
      }

      if (utils.isEmpty(vm.financeDocTemplate.vatAccountPlan2)) {
        Notification.error("You need to choose a VAT account plan.");
        return;
      }

      if ($scope.selectedTemplate) {
        $scope.isLoading = true;
        apiFactory.updateFinanceDocTemplate(vm.financeDocTemplate).then(function (res) {
          $scope.isLoading = false;
          var index = vm.financeDocTemplates.findIndex(function (x) {
            return x._id === $scope.selectedTemplate;
          });

          if (index !== -1) {
            vm.financeDocTemplates[index] = res.data;
          }

          vm.modalInstance.close();
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error("Failed to create finance doc");
        });
      } else {
        $scope.isLoading = true;
        apiFactory.createFinanceDocTemplate(vm.financeDocTemplate).then(function (res) {
          $scope.isLoading = false;
          vm.financeDocTemplates.push(res.data);
          vm.modalInstance.close(res.data);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error("Failed to create finance doc");
        });
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeVatSettings', {
    controller: financeVatSettingsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-vat-setting/finance-vat-settings/finance-vat-settings.view.html'
  });
  /** @ngInject */

  function financeVatSettingsController($scope, $state, globals, apiFactory, Notification, utils, $log) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    vm.vatList = [];
    vm.currentPage = 1;
    vm.numPerPage = 12;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];

    function chunk(arr, size) {
      var newArr = [];

      for (var i = 0; i < arr.length; i += size) {
        newArr.push(arr.slice(i, i + size));
      }

      return newArr;
    }

    function fetchData() {
      $scope.loading = true;
      apiFactory.listAllVatSettings({
        page: vm.currentPage,
        chunk: vm.numPerPage
      }).then(function (res) {
        $scope.loading = false;
        vm.vatList = res.data.list;
        vm.totalCount = res.data.totalCount;
        $scope.noOfPages = Math.ceil(vm.totalCount / vm.numPerPage);
        $scope.chunkedVatList = chunk(vm.vatList, 2);
      })["catch"](function (err) {
        $log.error(err);
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    }

    fetchData();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchData();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeEditVatSetting', {
    controller: financeEditVatSettingController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-vat-setting/finance-edit-vat-setting/finance-edit-vat-setting.view.html'
  });
  /** @ngInject */

  function financeEditVatSettingController($scope, $state, $stateParams, globals, apiFactory, Notification, utils, $log) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.vatSetting = {};
    vm.vatSettingId = $stateParams.id;

    $scope.updateVatSetting = function () {
      if (utils.isEmpty(vm.vatSetting.vatType)) {
        Notification.error('Please input VAT Type');
        return;
      }

      if (utils.isEmpty(vm.vatSetting.vatName)) {
        Notification.error('Please input VAT Name');
        return;
      }

      if (utils.isEmpty(vm.vatSetting.vatID)) {
        Notification.error('Please input VAT ID');
        return;
      }

      if (utils.isEmpty(vm.vatSetting.vatName)) {
        Notification.error('Please input VAT Percent');
        return;
      }

      if (utils.isEmpty(vm.vatSetting.vatName)) {
        Notification.error('Please input VAT Name');
        return;
      }

      $scope.loading = true;
      apiFactory.updateVatSetting(vm.vatSetting).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        $state.go('financeVatSettings');
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function init() {
      $scope.loading = true;
      Promise.all([apiFactory.getVatSetting(vm.vatSettingId), apiFactory.listAccountPlans()]).then(function (res) {
        $scope.loading = false;
        vm.vatSetting = res[0].data;
        vm.accountPlans = res[1].data.list;
        vm.accountPlans = vm.accountPlans.map(function (x) {
          x.label = x.name + ' - ' + x.number;
          return x;
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    init();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeCreateVatSetting', {
    controller: financeCreateVatSettingController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-vat-setting/finance-create-vat-setting/finance-create-vat-setting.view.html'
  });
  /** @ngInject */

  function financeCreateVatSettingController($scope, $state, globals, apiFactory, Notification, utils, $log) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.vatSetting = {};

    $scope.createVatSetting = function () {
      if (utils.isEmpty(vm.vatSetting.vatType)) {
        Notification.error('Please input VAT Type');
        return;
      }

      if (utils.isEmpty(vm.vatSetting.vatName)) {
        Notification.error('Please input VAT Name');
        return;
      }

      if (utils.isEmpty(vm.vatSetting.vatID)) {
        Notification.error('Please input VAT ID');
        return;
      }

      if (utils.isEmpty(vm.vatSetting.vatName)) {
        Notification.error('Please input VAT Percent');
        return;
      }

      if (utils.isEmpty(vm.vatSetting.vatName)) {
        Notification.error('Please input VAT Name');
        return;
      }

      $scope.loading = true;
      apiFactory.createVatSetting(vm.vatSetting).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        $state.go('financeVatSettings');
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function init() {
      $scope.loading = true;
      apiFactory.listAccountPlans().then(function (res) {
        $scope.loading = false;
        vm.accountPlans = res.data.list;
        vm.accountPlans = vm.accountPlans.map(function (x) {
          x.label = x.name + ' - ' + x.number;
          return x;
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    init();
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app').component('financeEditReEnterJournal', {
    controller: financeEditReEnterJournalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-journal/finance-edit-reenter-journal/finance-edit-reenter-journal.view.html'
  });
})();

function financeEditReEnterJournalController(globals, $scope, apiFactory, Notification, utils, $log, $state, $stateParams) {
  var vm = this;
  vm.userData = globals.userStore.get();
  vm.projectData = globals.projectStore.get();
  vm.journal = {
    date: new Date(),
    items: [],
    sum: {
      debit: 0,
      credit: 0
    }
  };
  vm.journalId = $stateParams.id;
  vm.uploadImages = [];
  vm.fromDate = new Date();
  vm.toDate = new Date();
  vm.fromDate.setFullYear(vm.fromDate.getFullYear() - 1);

  $scope.fileUpdated = function (files) {
    angular.forEach(files, function (x) {
      x.objectUrl = URL.createObjectURL(x);
      x.description = "";

      if (vm.uploadImages.length === 0) {
        vm.uploadImages.push(x);
      } else {
        var duplicateImg = false;
        angular.forEach(vm.uploadImages, function (y) {
          if (x.name === y.name) {
            duplicateImg = true;
          }
        });

        if (!duplicateImg) {
          vm.uploadImages.push(x);
        } else {
          Notification.error("File name already exist");
        }
      }
    });
  };

  $scope.addItem = function () {
    vm.journal.items.push({});
  };

  $scope.calcSum = function () {
    vm.journal.sum = {
      debit: 0,
      credit: 0
    };

    var _iterator = _createForOfIteratorHelper(vm.journal.items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        vm.journal.sum.debit += utils.num(item.debit);
        vm.journal.sum.credit += utils.num(item.credit);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  $scope.updateReJournal = function () {
    if (!vm.journal.number) {
      Notification.error('Please select number');
      return;
    }

    $scope.loading = true;
    apiFactory.updateReJournal(vm.journal).then(function (res) {
      $scope.loading = false;
      Notification.success(res.data.message);
      $state.go('financeFinance');
    })["catch"](function (err) {
      $scope.loading = false;
      $log.error(err);
      Notification.error(utils.getErrorMessage(err));
    });
  };

  function loadAccountPlans() {
    $scope.loading = true;
    apiFactory.listAccountPlans().then(function (res) {
      $scope.loading = false;
      vm.accountPlans = res.data.list;
      vm.accountPlans.forEach(function (accountPlan) {
        accountPlan.label = accountPlan.number + ' - ' + accountPlan.name;
      });
    })["catch"](function (err) {
      $scope.loading = false;
      $log.error(err);
      Notification.error(utils.getErrorMessage(err));
    });
  }

  function init() {
    $scope.loading = true;
    apiFactory.getReJournal(vm.journalId).then(function (res) {
      $scope.loading = false;
      loadAccountPlans();
      vm.journal = res.data;
      vm.journal.date = new Date(vm.journal.date);
      vm.journal.number = vm.journal.number.toString().padStart(5, '0');
    })["catch"](function (err) {
      $scope.loading = false;
      $log.error(err);
      Notification.error(utils.getErrorMessage(err));
    });
  }

  init();
}


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('financeEditPaymentJournal', {
    controller: financeCreatePaymentJournalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-journal/finance-create-payment-journal/finance-create-payment-journal.view.html'
  });
  /** @ngInject */

  function financeCreatePaymentJournalController(globals, $scope, apiFactory, Notification, utils, $log, $state, $stateParams) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.companyData = globals.companyStore.get();
    vm.projectData = globals.projectStore.get();
    vm.currency = vm.companyData.currentCurrency.symbol;
    vm.journal = {
      transactions: []
    };
    vm.journalId = $stateParams.id;
    $scope.journalTypes = [// { label: 'Financial Documents', value: 'Financial Documents' },
    {
      label: 'Client Payment',
      value: 'Client Payment'
    }, {
      label: 'Supplier Payment',
      value: 'Supplier Payment'
    }];
    $scope.nameList = [{
      label: 'Client Name',
      value: 'Client Name'
    }, {
      label: 'Supplier Name',
      value: 'Supplier Name'
    }, {
      label: 'Subcontractor Name',
      value: 'Subcontractor Name'
    }];
    $scope.financeTypeList = [{
      label: 'Debit',
      value: 'Debit'
    }, {
      label: 'Credit',
      value: 'Credit'
    }];
    $scope.bankAccountList = [{
      label: 'Bank Account',
      value: 'Bank Account'
    }];
    $scope.finances = [];
    vm.vendors = [];

    $scope.addTransaction = function () {
      var number = vm.financesCount + 1;
      var lastTransaction = vm.journal.transactions[vm.journal.transactions.length - 1];

      if (lastTransaction) {
        number = utils.num(lastTransaction.number) + 1;
      }

      var transaction = {
        date: new Date(),
        number: number
      };
      vm.journal.transactions.push(transaction);
    };

    $scope.changeType = function (transaction) {
      var type = transaction.type;

      if (type === 'Client Payment') {
        transaction.vendors = vm.clients;
        transaction.finances = vm.invoices.filter(function (x) {
          return x.vendorType === 'Client';
        });
      } else if (type === 'Supplier Payment') {
        transaction.vendors = vm.suppliers;
        transaction.finances = vm.billings.filter(function (x) {
          return x.vendorType === 'Supplier';
        });
      } else {
        transaction.vendors = [];
        transaction.finances = [];
      }
    };

    $scope.changeVendor = function (transaction) {
      var type = transaction.type;
      var vendor = transaction.vendor;

      if (type === 'Client Payment') {
        $scope.finances = vm.invoices.filter(function (x) {
          return x.vendorType === 'Client' && x.vendor && x.vendor._id == vendor;
        });
      } else if (type === 'Supplier Payment') {
        $scope.finances = vm.billings.filter(function (x) {
          return x.vendorType === 'Supplier' && x.vendor && x.vendor._id == vendor;
        });
      } else {
        vm.vendors = [];
      }
    };

    $scope.deleteTransactions = function () {
      vm.journal.transactions = vm.journal.transactions.filter(function (x) {
        return !x.checked;
      });
    };

    function getVendorType(vendorId) {
      var vendor = vm.vendors.find(function (x) {
        return x._id === vendorId;
      });

      if (vendor) {
        var arr = vendor.name.split(' - ');
        return arr[0];
      }

      return '';
    }

    $scope.changeFinance = function (transaction) {
      if (!transaction.finance) {
        transaction.description = undefined;
        transaction.amount = undefined;
        return;
      }

      var finance = vm.invoices.find(function (x) {
        return x._id === transaction.finance;
      }) || vm.billings.find(function (x) {
        return x._id === transaction.finance;
      });

      if (finance) {
        transaction.description = finance.displaySeq;
        transaction.amount = finance.totalAmount;
      } else {
        transaction.description = undefined;
        transaction.amount = undefined;
      }
    };

    $scope.createPaymentJournal = function () {
      if (utils.isEmpty(vm.journal.transactions)) {
        Notification.error('Please add transaction');
        return;
      }

      var _iterator = _createForOfIteratorHelper(vm.journal.transactions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var transaction = _step.value;

          if (!transaction.accountPlan) {
            Notification.error('Please select an Account Plan');
            return;
          }

          if (!transaction.type) {
            Notification.error('Please select a Type');
            return;
          }

          if (!transaction.date) {
            Notification.error('Please select a Date');
            return;
          }

          if (angular.isUndefined(transaction.amount)) {
            Notification.error('Please input amount');
            return;
          }

          transaction.vendorType = getVendorType(transaction.vendor);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var journal = angular.copy(vm.journal);

      var _iterator2 = _createForOfIteratorHelper(journal.transactions),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _transaction = _step2.value;
          delete _transaction.vendors;
          delete _transaction.finances;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      $scope.loading = true;
      apiFactory.updatePaymentJournal(journal).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        $state.go('financeFinance');
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function loadAccountPlans() {
      $scope.loading = true;
      apiFactory.listAccountPlans().then(function (res) {
        $scope.loading = false;
        vm.accountPlans = res.data.list;
        vm.accountPlans.forEach(function (accountPlan) {
          accountPlan.label = accountPlan.number + ' - ' + accountPlan.name;
        });
        vm.accountPlans = vm.accountPlans.filter(function (x) {
          return x.type === 'Bank' || x.type === 'Cash';
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    function init() {
      var query = {};

      if (vm.projectData && vm.projectData._id !== 'all') {
        query.projectId = vm.projectData._id;
      }

      $scope.loading = true;
      Promise.all([apiFactory.listAllClients(), apiFactory.getAllSuppliers(), apiFactory.listAllVatSettings(), apiFactory.listAllInvoices(query), apiFactory.listAllBillings(query), apiFactory.getPaymentJournal(vm.journalId)]).then(function (res) {
        $scope.loading = false;
        vm.clients = res[0].data.list;
        vm.clients = vm.clients.map(function (x) {
          return {
            name: "Client - ".concat(x.clientName),
            _id: x._id
          };
        });
        vm.suppliers = res[1].data.list;
        vm.suppliers = vm.suppliers.map(function (x) {
          return {
            name: "Supplier - ".concat(x.name),
            _id: x._id
          };
        });
        vm.vatSettings = res[2].data.list;
        loadAccountPlans();
        vm.invoices = res[3].data.list;
        vm.invoices.forEach(function (x) {
          var totalAmount = utils.numberWithCommas(utils.num(x.totalAmount).toFixed(2));
          var totalVat = utils.numberWithCommas(utils.num(x.totalVat).toFixed(2));
          var totalPrice = utils.numberWithCommas(utils.num(x.totalPrice).toFixed(2));
          x.label = "".concat(x.displaySeq, " ---- ").concat(moment(x.date).format('l'), " ---- ").concat(totalAmount, " ---- ").concat(totalVat, " ---- ").concat(totalPrice);
        });
        vm.billings = res[4].data.list;
        vm.billings.forEach(function (x) {
          var totalAmount = utils.numberWithCommas(utils.num(x.totalAmount).toFixed(2));
          var taxAmount = utils.numberWithCommas(utils.num(x.taxAmount).toFixed(2));
          var amountWithoutTax = utils.numberWithCommas(utils.num(x.amountWithoutTax).toFixed(2));
          x.label = "".concat(x.billNo, " ---- ").concat(moment(x.billDate).format('l'), " ---- ").concat(totalAmount, " ---- ").concat(taxAmount, " ---- ").concat(amountWithoutTax);
        });
        vm.journal = res[5].data;

        var _iterator3 = _createForOfIteratorHelper(vm.journal.transactions),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var transaction = _step3.value;
            transaction.date = new Date(transaction.date);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
        loadAccountPlans();
      });
    }

    init();
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('financeEditManualJournal', {
    controller: financeEditManualJournalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-journal/finance-edit-manual-journal/finance-edit-manual-journal.view.html'
  });
  /** @ngInject */

  function financeEditManualJournalController(globals, $scope, apiFactory, Notification, utils, $log, $state, $stateParams) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.companyData = globals.companyStore.get();
    vm.currency = vm.companyData.currentCurrency.symbol;
    vm.journalId = $stateParams.id;
    $scope.journalTypes = [{
      label: 'Client Payment',
      value: 'Client Payment'
    }, {
      label: 'Supplier Payment',
      value: 'Supplier Payment'
    }, {
      label: 'Finance Document',
      value: 'Finance Document'
    }];
    $scope.nameList = [{
      label: 'Client Name',
      value: 'Client Name'
    }, {
      label: 'Supplier Name',
      value: 'Supplier Name'
    }, {
      label: 'Subcontractor Name',
      value: 'Subcontractor Name'
    }];
    $scope.financeTypeList = [{
      label: 'Debit',
      value: 'Debit'
    }, {
      label: 'Credit',
      value: 'Credit'
    }];
    $scope.bankAccountList = [{
      label: 'Bank Account',
      value: 'Bank Account'
    }];

    $scope.addTransaction = function () {
      var number = vm.financesCount + 1;
      var lastTransaction = vm.journal.transactions[vm.journal.transactions.length - 1];

      if (lastTransaction) {
        number = utils.num(lastTransaction.number) + 1;
      }

      vm.journal.transactions.push({
        number: number,
        date: new Date(),
        items: [{}],
        contacts: [],
        debit: 0,
        credit: 0,
        balance: 0
      });
    };

    $scope.addLine = function (transaction) {
      transaction.items.push({});
    };

    $scope.changeType = function (transaction) {
      var type = transaction.type;

      if (type === 'Client Payment') {
        transaction.contacts = vm.clients;
      } else if (type === 'Supplier Payment') {
        transaction.contacts = vm.suppliers;
      } else {
        transaction.contacts = [];
      }
    };

    $scope.deleteTransactions = function () {
      vm.journal.transactions = vm.journal.transactions.filter(function (x) {
        return !x.checked;
      });
    };

    $scope.calculateSum = function () {
      var _iterator = _createForOfIteratorHelper(vm.journal.transactions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var transaction = _step.value;
          transaction.debit = 0;
          transaction.credit = 0;
          transaction.balance = 0;

          for (var i = 0; i < transaction.items.length; i++) {
            var item = transaction.items[i];

            if (i === 0) {
              transaction.debit += utils.num(item.amount);
            } else {
              transaction.credit += utils.num(item.amount);
            }
          }

          transaction.balance = transaction.debit - transaction.credit;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    function index2Text(index) {
      if (index === 0) {
        return 'first item';
      } else if (index === 1) {
        return 'second item';
      } else {
        return 'last item';
      }
    }

    function getContactType(transaction, contact) {
      var contactAccount = transaction.contacts.find(function (x) {
        return x._id === contact;
      });

      if (contactAccount) {
        var arr = contactAccount.name.split(' - ');
        return arr[0];
      }

      return '';
    }

    $scope.updateManualJournal = function () {
      if (utils.isEmpty(vm.journal.transactions)) {
        Notification.error('Please add transaction');
        return;
      }

      var _iterator2 = _createForOfIteratorHelper(vm.journal.transactions),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var transaction = _step2.value;

          if (!transaction.type) {
            Notification.error('Please select a Type');
            return;
          }

          if (!transaction.date) {
            Notification.error('Please select a Date');
            return;
          }

          for (var i = 0; i < transaction.items.length; i++) {
            var item = transaction.items[i];

            if (!item.description) {
              Notification.error('Enter a Description in the ' + index2Text(i));
              return;
            }

            if (!item.vatType) {
              Notification.error('Please select a Vat Type in the ' + index2Text(i));
              return;
            }

            if (!item.amount) {
              Notification.error('Enter Amount value in the' + index2Text(i));
              return;
            }

            if (item.contact) {
              item.contactType = getContactType(transaction, item.contact);
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      $scope.loading = true;
      apiFactory.updateManualJournal(vm.journalId, vm.journal).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        $state.go('financeFinance');
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function loadAccountPlans() {
      $scope.loading = true;
      apiFactory.listAccountPlans().then(function (res) {
        $scope.loading = false;
        vm.accountPlans = res.data.list;
        vm.accountPlans.forEach(function (accountPlan) {
          accountPlan.label = accountPlan.number + ' - ' + accountPlan.name;
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    function init() {
      $scope.loading = true;
      Promise.all([apiFactory.listAllClients(), apiFactory.getAllSuppliers(), apiFactory.listAllVatSettings(), apiFactory.getManualJournal(vm.journalId)]).then(function (res) {
        $scope.loading = false;
        vm.clients = res[0].data.list;
        vm.clients = vm.clients.map(function (x) {
          return {
            name: "Client - ".concat(x.clientName),
            _id: x._id
          };
        });
        vm.suppliers = res[1].data.list;
        vm.suppliers = vm.suppliers.map(function (x) {
          return {
            name: "Supplier - ".concat(x.name),
            _id: x._id
          };
        });
        vm.vatSettings = res[2].data.list;
        loadAccountPlans();
        vm.journal = res[3].data;

        if (vm.journal) {
          var _iterator3 = _createForOfIteratorHelper(vm.journal.transactions),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var transaction = _step3.value;
              transaction.date = new Date(transaction.date);
              $scope.changeType(transaction);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
        loadAccountPlans();
      });
    }

    init();
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app').component('financeCreateReEnterJournal', {
    controller: financeCreateReEnterJournalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-journal/finance-create-reenter-journal/finance-create-reenter-journal.view.html'
  });
})();

function financeCreateReEnterJournalController(globals, $scope, apiFactory, Notification, utils, $log, $state) {
  var vm = this;
  vm.userData = globals.userStore.get();
  vm.projectData = globals.projectStore.get();
  vm.journalList = [];
  vm.uploadImages = [];

  $scope.fileUpdated = function (files) {
    angular.forEach(files, function (x) {
      x.objectUrl = URL.createObjectURL(x);
      x.description = "";

      if (vm.uploadImages.length === 0) {
        vm.uploadImages.push(x);
      } else {
        var duplicateImg = false;
        angular.forEach(vm.uploadImages, function (y) {
          if (x.name === y.name) {
            duplicateImg = true;
          }
        });

        if (!duplicateImg) {
          vm.uploadImages.push(x);
        } else {
          Notification.error("File name already exist");
        }
      }
    });
  };

  $scope.calcSum = function (journal) {
    journal.totalDebit = 0;
    journal.totalCredit = 0;

    var _iterator = _createForOfIteratorHelper(journal.items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        journal.totalDebit += utils.num(item.debit);
        journal.totalCredit += utils.num(item.credit);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  $scope.addTransaction = function () {
    $scope.loading = true;
    apiFactory.systemTag("JOR").then(function (res) {
      $scope.loading = false;
      var prevJournal = vm.journalList[vm.journalList.length - 1];
      vm.journalList.push({
        systemTag: res.data.data,
        date: prevJournal && prevJournal.date ? prevJournal.date : new Date(),
        items: [{}, {}],
        totalDebit: 0,
        totalCredit: 0
      });
    })["catch"](function (err) {
      $scope.loading = false;
      $log.error(err);
      Notification.error(utils.getErrorMessage(err));
    });
  };

  $scope.createReJournal = function () {
    var _iterator2 = _createForOfIteratorHelper(vm.journalList),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var journal = _step2.value;

        var _iterator3 = _createForOfIteratorHelper(journal.items),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var item = _step3.value;

            if (utils.isEmpty(item.accountPlan)) {
              Notification.error("There is a journal not selected account plan.");
              return;
            }

            if (!utils.num(item.debit) && !utils.num(item.credit)) {
              Notification.error("Should input a debit or credit value for a journal.");
              return;
            }

            if (journal.totalCredit + journal.totalDebit !== 0) {
              Notification.error("The sum of a debit and credit must be zero.");
              return;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    $scope.loading = true;
    apiFactory.createReJournalMany(vm.journalList).then(function (res) {
      $scope.loading = false;
      Notification.success(res.data.message);
      $state.go('financeFinance');
    })["catch"](function (err) {
      $scope.loading = false;
      $log.error(err);
      Notification.error(utils.getErrorMessage(err));
    });
  };

  function loadAccountPlans() {
    $scope.loading = true;
    apiFactory.listAccountPlans().then(function (res) {
      $scope.loading = false;
      vm.accountPlans = res.data.list;
      vm.accountPlans.forEach(function (accountPlan) {
        accountPlan.label = accountPlan.number + ' - ' + accountPlan.name;
      });
    })["catch"](function (err) {
      $scope.loading = false;
      $log.error(err);
      Notification.error(utils.getErrorMessage(err));
    });
  }

  loadAccountPlans();
  $scope.addTransaction();
}


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('financeCreatePaymentJournal', {
    controller: financeCreatePaymentJournalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-journal/finance-create-payment-journal/finance-create-payment-journal.view.html'
  });
  /** @ngInject */

  function financeCreatePaymentJournalController(globals, $scope, apiFactory, Notification, utils, $log, $state) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.companyData = globals.companyStore.get();
    vm.projectData = globals.projectStore.get();
    vm.currency = vm.companyData.currentCurrency.symbol;
    vm.journalList = [];
    $scope.journalTypes = [// { label: 'Financial Documents', value: 'Financial Documents' },
    {
      label: 'Client Payment',
      value: 'Client Payment'
    }, {
      label: 'Supplier Payment',
      value: 'Supplier Payment'
    }];
    $scope.nameList = [{
      label: 'Client Name',
      value: 'Client Name'
    }, {
      label: 'Supplier Name',
      value: 'Supplier Name'
    }, {
      label: 'Subcontractor Name',
      value: 'Subcontractor Name'
    }];
    $scope.bankAccountList = [{
      label: 'Bank Account',
      value: 'Bank Account'
    }];
    $scope.finances = [];

    $scope.addTransaction = function () {
      $scope.loading = true;
      apiFactory.systemTag("JOP").then(function (res) {
        $scope.loading = false;
        vm.journalList.push({
          date: new Date(),
          systemTag: res.data.data
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.changeType = function (journal) {
      journal.vendors = [];
      journal.finances = [];
      journal.vendor = undefined;
      journal.vendorType = undefined;
      journal.finance = undefined;
      journal.financeType = undefined;
      journal.description = undefined;
      journal.amount = undefined;
      var type = journal.type;

      if (type === 'Client Payment') {
        journal.vendors = vm.clients;
        journal.finances = vm.invoices.filter(function (x) {
          return x.vendorType === 'Client';
        });
        journal.financeType = 'Invoice';
      } else if (type === 'Supplier Payment') {
        journal.vendors = vm.suppliers;
        journal.finances = vm.billings.filter(function (x) {
          return x.vendorType === 'Supplier';
        });
        journal.financeType = 'Billing';
      }
    };

    $scope.changeVendor = function (journal) {
      journal.finance = undefined;
      journal.description = undefined;
      journal.amount = undefined;
      var type = journal.type;
      var vendor = journal.vendor;

      if (type === 'Client Payment') {
        journal.finances = vm.invoices.filter(function (x) {
          return x.vendorType === 'Client' && x.vendor && x.vendor._id == vendor;
        });
      } else if (type === 'Supplier Payment') {
        journal.finances = vm.billings.filter(function (x) {
          return x.vendorType === 'Supplier' && x.vendor && x.vendor._id == vendor;
        });
      } else {
        journal.finances = [];
      }
    };

    $scope.changeFinance = function (journal) {
      var finance = vm.invoices.find(function (x) {
        return x._id === journal.finance;
      }) || vm.billings.find(function (x) {
        return x._id === journal.finance;
      });

      if (finance) {
        journal.description = finance.displaySeq;
        journal.amount = finance.totalAmount;
      } else {
        journal.description = undefined;
        journal.amount = undefined;
      }
    };

    $scope.deleteTransactions = function () {
      vm.journalList = vm.journalList.filter(function (x) {
        return !x.checked;
      });
    };

    function getVendorType(journal) {
      var vendor = journal.vendors.find(function (x) {
        return x._id === journal.vendor;
      });

      if (vendor) {
        var arr = vendor.name.split(' - ');
        return arr[0];
      }

      return '';
    }

    $scope.createPaymentJournal = function () {
      if (utils.isEmpty(vm.journalList)) {
        Notification.error('Please add transaction');
        return;
      }

      var _iterator = _createForOfIteratorHelper(vm.journalList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var journal = _step.value;

          if (!journal.accountPlan) {
            Notification.error('Please select an Account Plan');
            return;
          }

          if (!journal.type) {
            Notification.error('Please select a Type');
            return;
          }

          if (!journal.date) {
            Notification.error('Please select a Date');
            return;
          }

          if (angular.isUndefined(journal.amount)) {
            Notification.error('Please input amount');
            return;
          }

          journal.vendorType = getVendorType(journal);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var promises = [];
      var journalList = angular.copy(vm.journalList);

      var _iterator2 = _createForOfIteratorHelper(journalList),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _journal = _step2.value;
          delete _journal.vendors;
          delete _journal.finances;
          promises.push(apiFactory.createPaymentJournal(_journal));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      $scope.loading = true;
      Promise.all(promises).then(function (res) {
        $log.log(res);
        $scope.loading = false;
        Notification.success("Created successfully");
        $state.go('financeFinance');
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function loadAccountPlans() {
      $scope.loading = true;
      apiFactory.listAccountPlans().then(function (res) {
        $scope.loading = false;
        vm.accountPlans = res.data.list;
        vm.accountPlans = vm.accountPlans.filter(function (x) {
          return x.type === 'Bank' || x.type === 'Cash';
        });
        vm.accountPlans.forEach(function (accountPlan) {
          accountPlan.label = accountPlan.number + ' - ' + accountPlan.name;
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    function init() {
      var query = {};

      if (vm.projectData && vm.projectData._id !== 'all') {
        query.projectId = vm.projectData._id;
      }

      $scope.loading = true;
      Promise.all([apiFactory.listAllClients(), apiFactory.getAllSuppliers(), apiFactory.listAllVatSettings(), apiFactory.listAllInvoices(query), apiFactory.listAllBillings(query)]).then(function (res) {
        $scope.loading = false;
        vm.clients = res[0].data.list;
        vm.clients = vm.clients.map(function (x) {
          return {
            name: "Client - ".concat(x.clientName),
            _id: x._id
          };
        });
        vm.suppliers = res[1].data.list;
        vm.suppliers = vm.suppliers.map(function (x) {
          return {
            name: "Supplier - ".concat(x.name),
            _id: x._id
          };
        });
        vm.vatSettings = res[2].data.list;
        loadAccountPlans();
        vm.invoices = res[3].data.list;
        vm.invoices.forEach(function (x) {
          var totalAmount = utils.numberWithCommas(utils.num(x.totalAmount).toFixed(2));
          var totalVat = utils.numberWithCommas(utils.num(x.totalVat).toFixed(2));
          var totalPrice = utils.numberWithCommas(utils.num(x.totalPrice).toFixed(2));
          x.label = {
            item1: x.displaySeq,
            item2: moment(x.date).format('dd/MM/yyyy'),
            item3: totalAmount,
            item4: totalVat,
            item5: totalPrice
          };
        });
        vm.billings = res[4].data.list;
        vm.billings.forEach(function (x) {
          var totalAmount = utils.numberWithCommas(utils.num(x.totalAmount).toFixed(2));
          var taxAmount = utils.numberWithCommas(utils.num(x.taxAmount).toFixed(2));
          var amountWithoutTax = utils.numberWithCommas(utils.num(x.amountWithoutTax).toFixed(2));
          x.label = {
            item1: x.billNo,
            item2: moment(x.billDate).format('dd/MM/yyyy'),
            item3: totalAmount,
            item4: taxAmount,
            item5: amountWithoutTax
          };
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
        loadAccountPlans();
      });
    }

    init();
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('financeCreateManualJournal', {
    controller: financeCreateManualJournalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-journal/finance-create-manual-journal/finance-create-manual-journal.view.html'
  });
  /** @ngInject */

  function financeCreateManualJournalController(globals, $scope, apiFactory, Notification, utils, $log, $state) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.companyData = globals.companyStore.get();
    vm.currency = vm.companyData.currentCurrency.symbol;
    vm.journalList = [];
    $scope.journalTypes = [{
      label: 'Client Payment',
      value: 'Client Payment'
    }, {
      label: 'Supplier Payment',
      value: 'Supplier Payment'
    }, {
      label: 'Finance Document',
      value: 'Finance Document'
    }];
    $scope.nameList = [{
      label: 'Client Name',
      value: 'Client Name'
    }, {
      label: 'Supplier Name',
      value: 'Supplier Name'
    }, {
      label: 'Subcontractor Name',
      value: 'Subcontractor Name'
    }];
    $scope.financeTypeList = [{
      label: 'Debit',
      value: 'Debit'
    }, {
      label: 'Credit',
      value: 'Credit'
    }];
    $scope.bankAccountList = [{
      label: 'Bank Account',
      value: 'Bank Account'
    }];

    $scope.addTransaction = function () {
      $scope.loading = true;
      apiFactory.systemTag("JOM").then(function (res) {
        $scope.loading = false;
        vm.journalList.push({
          systemTag: res.data.data,
          date: new Date(),
          items: [{}],
          debit: 0,
          credit: 0,
          balance: 0
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.addLine = function (journal) {
      journal.items.push({});
    };

    $scope.deleteTransactions = function () {
      vm.journalList = vm.journalList.filter(function (x) {
        return !x.checked;
      });
    };

    $scope.calcSum = function () {
      var _iterator = _createForOfIteratorHelper(vm.journalList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var journal = _step.value;
          journal.totalDebit = 0;
          journal.totalCredit = 0;
          journal.totalBalance = 0;

          var _iterator2 = _createForOfIteratorHelper(journal.items),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              journal.totalDebit += utils.num(item.debit);
              journal.totalCredit += utils.num(item.credit);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          journal.totalBalance = journal.totalDebit - journal.totalCredit;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    function index2Text(index) {
      if (index === 0) {
        return 'first item';
      } else if (index === 1) {
        return 'second item';
      } else {
        return 'last item';
      }
    }

    $scope.createManualJournal = function () {
      if (utils.isEmpty(vm.journalList)) {
        Notification.error('Please add transaction');
        return;
      }

      var _iterator3 = _createForOfIteratorHelper(vm.journalList),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var journal = _step3.value;

          if (!journal.type) {
            Notification.error('Please select a Type in the ' + journal.systemTag);
            return;
          }

          if (!journal.date) {
            Notification.error('Please select a Date');
            return;
          }

          for (var i = 0; i < journal.items.length; i++) {
            var item = journal.items[i];

            if (!item.description) {
              Notification.error('Enter a Description in the ' + index2Text(i));
              return;
            }

            if (!item.vatType) {
              Notification.error('Please select a Vat Type in the ' + index2Text(i));
              return;
            }

            if (!item.credit && !item.debit) {
              Notification.error('Enter debit or credit in the' + index2Text(i));
              return;
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var promises = vm.journalList.map(function (x) {
        return apiFactory.createManualJournal(x);
      });
      $scope.loading = true;
      Promise.all(promises).then(function (res) {
        $log.log(res);
        $scope.loading = false;
        Notification.success("Created successfully");
        $state.go('financeFinance');
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function loadAccountPlans() {
      $scope.loading = true;
      apiFactory.listAccountPlans().then(function (res) {
        $scope.loading = false;
        vm.accountPlans = res.data.list;
        vm.accountPlans.forEach(function (accountPlan) {
          accountPlan.label = accountPlan.number + ' - ' + accountPlan.name;
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    function init() {
      $scope.loading = true;
      Promise.all([apiFactory.listAllClients(), apiFactory.getAllSuppliers(), apiFactory.listAllVatSettings(), apiFactory.getEconomicSetting()]).then(function (res) {
        $scope.loading = false;
        vm.clients = res[0].data.list;
        vm.clients = vm.clients.map(function (x) {
          return {
            name: "Client - ".concat(x.clientName),
            _id: x._id
          };
        });
        vm.suppliers = res[1].data.list;
        vm.suppliers = vm.suppliers.map(function (x) {
          return {
            name: "Supplier - ".concat(x.name),
            _id: x._id
          };
        });
        vm.vatSettings = res[2].data.list;
        loadAccountPlans();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
        loadAccountPlans();
      });
    }

    init();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeInvoiceDetail', {
    controller: financeInvoiceDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-invoice/detail/finance-detail-invoice.view.html'
  });
  /** @ngInject */

  function financeInvoiceDetailController($scope, $state, $stateParams, apiFactory, Notification, globals, $log, $document) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    vm.invoice = {
      displaySeq: '',
      reference: "",
      date: '',
      dueDate: '',
      termsAndConditions: true,
      items: [],
      status: "pending",
      paymentTerms: [],
      totalVat: 0,
      totalTax: 0,
      totalPrice: 0,
      totalAmount: 0
    };
    vm.pdfViewing = false;

    function initData() {
      $scope.isLoading = true;
      apiFactory.getInvoice($stateParams.id).then(function (resp) {
        vm.invoice = resp.data.data;
        $scope.companyCurrency = vm.invoice.companyCurrency;
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error("error", e);
        $scope.isLoading = false;
      });
      apiFactory.getCompanyById(vm.userData.companyId).then(function (resp) {
        vm.companyData = resp.data;
      })["catch"](function (e) {
        $log.log(e);
      });
    }

    initData();
    vm.paidBtn = [{
      id: 'paid',
      value: 'paid'
    }, {
      id: 'unpaid',
      value: 'unpaid'
    }];

    $scope.onPaidBtn = function (event) {
      vm.invoice.status = event.target.id;
    };

    vm.saveInvoice = function () {
      apiFactory.updateInvoice({
        _id: vm.invoice._id,
        status: vm.invoice.status
      }).then(function (resp) {
        $log.log(resp);
        Notification.success("Invoice updated successfully.");
      })["catch"](function (e) {
        $log.error(e);
        Notification.error("Something went wrong.");
      });
    };

    vm.paid = function () {
      vm.invoice.status = "paid";

      if (vm.invoice._id) {
        vm.saveInvoice();
      }
    };

    vm.pending = function () {
      vm.invoice.status = "pending";

      if (vm.invoice._id) {
        vm.saveInvoice();
      }
    };

    vm.viewAsPDF = function () {
      vm.pdfViewing = true;
    };

    vm.closePDFViewer = function () {
      vm.pdfViewing = false;
    };

    vm.exportAsPDF = function () {
      var a = $document[0].createElement("a");
      $document[0].body.appendChild(a);
      a.href = vm.invoice.invoiceDoc;
      a.download = 'invoice.pdf';
      a.click();
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('financeCreateInvoice', {
    controller: financeCreateInvoiceController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-invoice/create/finance-create-invoice.view.html'
  });
  /** @ngInject */

  function financeCreateInvoiceController($scope, $state, apiFactory, Notification, globals, utils, moment, $log, $uibModal, localStorageService, $stateParams, $window) {
    /* Requiring vars */
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get() || {
      _id: "all"
    };
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    vm.vendorIdTemp = undefined;
    $scope.isEdit = false;
    vm.recipients = {
      emails: [],
      managers: []
    };
    vm.invoice = {
      displaySeq: '',
      projectSystemTag: undefined,
      date: new Date(),
      dueDate: '',
      termsAndConditions: true,
      items: [{
        isEdit: true
      }],
      status: "draft",
      paymentTerms: [],
      totalVat: 0,
      totalTax: 0,
      totalPrice: 0,
      totalAmount: 0
    };
    vm.userListTemp = [];
    vm.teamUsers = {};
    vm.allItems = [];
    vm.accountPlans = [];
    vm.economicSettingItems = [];
    var showOverview = false;
    $scope.loading = true;
    apiFactory.hasApprovalInProject({
      projectId: vm.project._id,
      approval: 'bill'
    }).then(function () {
      $scope.loading = false;
      initData();
    })["catch"](function (err) {
      $scope.loading = false;
      $log.error(err);
      Notification.error(utils.getErrorMessage(err, 'Permission denied'));
      $state.go(globals.getDashboardRoute(vm.userData));
    });

    function initData() {
      $scope.invoiceDataVA = localStorageService.get('invoiceData');
      localStorageService.set('invoiceData', null);

      if ($stateParams.id) {
        $scope.isLoading = true;
        $scope.isEdit = true;
        apiFactory.getInvoice($stateParams.id).then(function (resp) {
          vm.invoice = resp.data.data;
          vm.invoice.items.forEach(function (item) {
            item.itemId = item.type._id;
          });
          vm.vendorIdTemp = 'Client_' + vm.invoice.vendor._id;
          vm.isCreditMemo = vm.invoice.isCreditMemo;
          $scope.companyCurrency = vm.invoice.companyCurrency;
          $scope.isLoading = false;
        })["catch"](function (e) {
          $log.error("error", e);
          $scope.isLoading = false;
        });
      } else {
        vm.invoice.vendor = vm.project.client;
        vm.invoice.vendorType = 'Client';
        vm.invoice.projectSystemTag = vm.project.systemTag;
        vm.invoice.createdByName = vm.userData.displayName;
        vm.invoice.staff = vm.project.staff;

        if (vm.invoice.vendor) {
          vm.vendorIdTemp = 'Client_' + vm.invoice.vendor._id;
          apiFactory.getClientById(vm.invoice.vendor._id).then(function (resp) {
            vm.invoice.vendor = resp.data.data;
            vm.recipients.emails = [resp.data.data.email];

            if (vm.invoice.vendor && vm.invoice.vendor.staffs) {
              vm.invoice.staff = vm.invoice.vendor.staffs[0] ? vm.invoice.vendor.staffs[0]._id : undefined;
            }
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }
      }

      if ($scope.invoiceDataVA) {
        vm.invoice = $scope.invoiceDataVA;
        vm.invoice.projectSystemTag = $scope.invoiceDataVA.projectSystemTag;
        vm.invoice.vendorType = $scope.invoiceDataVA.vendorType;
        vm.invoice.createdByName = vm.userData.displayName;

        if (vm.invoice.vendorType === 'Client') {
          vm.vendorIdTemp = 'Client_' + $scope.invoiceDataVA.vendor;
          apiFactory.getClientById($scope.invoiceDataVA.vendor).then(function (resp) {
            vm.invoice.vendor = resp.data.data;
            vm.recipients.emails = [resp.data.data.email];

            if (vm.invoice.vendor && vm.invoice.vendor.staffs) {
              vm.invoice.staff = vm.invoice.vendor.staffs[0] ? vm.invoice.vendor.staffs[0]._id : undefined;
            }
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        } else if (vm.invoice.vendorType === 'Supplier') {
          vm.vendorIdTemp = 'Supplier_' + $scope.invoiceDataVA.supplier;
          apiFactory.getSupplierById($scope.invoiceDataVA.supplier).then(function (resp) {
            vm.invoice.vendor = resp.data;
            vm.recipients.emails = [resp.data.email];

            if (vm.invoice.vendor && vm.invoice.vendor.staffs) {
              vm.invoice.staff = vm.invoice.vendor.staffs[0] ? vm.invoice.vendor.staffs[0]._id : undefined;
            }
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        } else {
          vm.vendorIdTemp = 'Subcontractor_' + $scope.invoiceDataVA.subcontractor;
          apiFactory.getSubcontractorById($scope.invoiceDataVA.subcontractor).then(function (resp) {
            vm.invoice.vendor = resp.data;
            vm.recipients.emails = [resp.data.email];

            if (vm.invoice.vendor && vm.invoice.vendor.staffs) {
              vm.invoice.staff = vm.invoice.vendor.staffs[0] ? vm.invoice.vendor.staffs[0]._id : undefined;
            }
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }

        vm.invoice.date = moment($scope.invoiceDataVA.date)._d;
        vm.invoice.dueDate = moment($scope.invoiceDataVA.dueDate)._d;

        for (var i = 0; i < vm.invoice.items.length; i++) {
          vm.invoice.items[i].itemId = vm.invoice.items[i].type;
          vm.invoice.items[i].itemNum = vm.invoice.items[i].number;
        }
      }

      $scope.loading = true;
      Promise.all([vm.project._id === 'all' ? apiFactory.listAllCompanyInvoiceUsers() : apiFactory.listAllProjectTeamUsers(vm.project._id), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.getCompanyById(vm.userData.companyId), apiFactory.getEconomicSettingInvoiceItems(), apiFactory.getInvoiceAccountPlans()]).then(function (resp) {
        $scope.loading = false;
        vm.userListTemp = [];
        vm.teamUsers = resp[0].data.data;

        if (vm.teamUsers.clients) {
          vm.teamUsers.clients.forEach(function (client) {
            vm.userListTemp.push({
              _id: 'Client_' + client._id,
              name: 'Client - ' + client.clientName
            });
          });
        }

        if (vm.teamUsers.suppliers) {
          vm.teamUsers.suppliers.forEach(function (user) {
            vm.userListTemp.push({
              _id: 'Supplier_' + user._id,
              name: 'Supplier - ' + user.name
            });
          });
        }

        if (vm.teamUsers.subContractors) {
          vm.teamUsers.subContractors.forEach(function (user) {
            vm.userListTemp.push({
              _id: 'Subcontractor_' + user._id,
              name: 'Subcontractor - ' + user.name
            });
          });
        }

        vm.allItems = [].concat(resp[1].data.list, resp[2].data.list, resp[3].data.list);
        vm.companyData = resp[4].data;
        vm.paymentConditions = angular.copy(vm.companyData.paymentConditions);
        vm.paymentConditions.map(function (x) {
          // x.range = `${x.from} - ${x.to} (${x.percentage}%)`;
          x.validate = false;
        });
        vm.economicSettingItems = resp[5].data.data || [];
        vm.economicSettingItems.forEach(function (item) {
          item.label = item.description || item.type;
          item.type = item.plan.name;
          item.type_id = item.plan._id;
          item.vat = item.plan.vat;
          item.tax = item.plan.tax;
        });
        vm.accountPlans = resp[6].data.data || [];
        vm.accountPlans.forEach(function (accountPlan) {
          accountPlan.label = accountPlan.number + "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0" + accountPlan.name;
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.log(err);
      });
      globals.getCurrency().then(function (resp) {
        var getCurrencyCode = resp.data;
        $scope.companyCurrency = getCurrencyCode.find(function (element) {
          return element.cc === vm.companyData.currentCurrency.currencyCode;
        });
      });
    }

    $scope.invoiceDateChanged = function () {
      getDueDate();
    };

    vm.addPaymentTerm = function (data) {
      if (!data) {
        return;
      }

      vm.invoice.paymentTerms = [data];
      getDueDate();
      angular.forEach(vm.invoice.paymentTerms, function (x) {
        angular.forEach(vm.paymentConditions, function (y) {
          if (x.from <= y.from) {
            y.validate = y.from <= x.to;
          } else {
            y.validate = x.from <= y.to ? y.to <= x.to : false;
          }
        });
      });
    };

    vm.deletePaymentTerm = function (index) {
      vm.invoice.paymentTerms.splice(index, 1);
      vm.invoice.dueDate = null;
    };

    vm.changeVendor = function (id) {
      if (!id) {
        return;
      }

      var vendorType;
      var userId;

      if (id.includes('_')) {
        vendorType = id.split('_')[0];
        userId = id.split('_')[1];
      } else {
        vendorType = 'Client';
        userId = id;
      }

      vm.invoice.vendorType = vendorType;
      var userList = (vendorType === 'Client' ? vm.teamUsers.clients : vendorType === 'Supplier' ? vm.teamUsers.suppliers : vm.teamUsers.subContractors) || [];
      var user = userList.find(function (x) {
        return x._id === userId;
      });

      if (user) {
        vm.invoice.vendor = user;

        if (vm.recipients.emails.length > 0) {
          vm.recipients.emails[0] = vm.invoice.vendor.email;
        } else {
          vm.recipients.emails = [vm.invoice.vendor.email];
        }
      }

      if (vm.invoice.vendor) {
        var address = vendorType === 'Client' ? vm.invoice.vendor.address[0] : vm.invoice.vendor.address;

        if (!utils.isEmpty(address)) {
          vm.invoice.vendorAddress = "".concat(address.line1, " ").concat(address.city, " ").concat(address.countryCode);
        }

        vm.invoice.staff = vm.invoice.vendor.staffs[0] ? vm.invoice.vendor.staffs[0]._id : undefined;
      }
    };

    vm.addInvoiceRow = function () {
      vm.invoice.items.push({
        isEdit: true
      });
    };

    vm.removeInvoiceRow = function (index) {
      if (vm.invoice.totalPrice && vm.invoice.items[index].price) {
        vm.invoice.totalPrice = vm.invoice.totalPrice - vm.invoice.items[index].price;
      }

      if (vm.invoice.totalVat && vm.invoice.items[index].vatAmount) {
        vm.invoice.totalVat = vm.invoice.totalVat - vm.invoice.items[index].vatAmount;
      }

      if (vm.invoice.totalTax && vm.invoice.items[index].taxAmount) {
        vm.invoice.totalTax = vm.invoice.totalTax - vm.invoice.items[index].taxAmount;
      }

      if (vm.invoice.totalAmount && vm.invoice.items[index].price && vm.invoice.items[index].vatAmount && vm.invoice.items[index].taxAmount) {
        vm.invoice.totalAmount = vm.invoice.totalAmount - vm.invoice.items[index].price - vm.invoice.items[index].vatAmount - vm.invoice.items[index].taxAmount;
      }

      vm.invoice.items.splice(index, 1);
      var rowCount = vm.invoice.items.length;

      if (rowCount < 1) {
        vm.addInvoiceRow();
      }
    };

    vm.editInvoiceRow = function (item) {
      item.isEdit = true;
    };

    vm.confirmInvoiceRow = function (item) {
      if (!item.itemId) {
        Notification.error('Please fill Sr.No.');
        return;
      }

      if (!item.itemNum) {
        Notification.error('Please fill type.');
        return;
      }

      if (utils.isEmpty(item.description)) {
        Notification.error('Please fill description');
        return;
      }

      item.isEdit = false;
    };

    vm.selectItemType = function (params, item, typeOrNum) {
      var type;

      if (item && params) {
        if (typeOrNum === 'accountPlan') {
          item.settingItems = vm.economicSettingItems.filter(function (it) {
            return it.type_id === params;
          });

          if (item.settingItems.length > 0) {
            type = item.settingItems[0];
            item.itemNum = type._id ? type._id : null;
            item.type = type;
          } else {
            item.itemNum = undefined;
          }
        } else if (typeOrNum === 'settingItem') {
          type = vm.economicSettingItems.find(function (it) {
            return it._id === params;
          });
          item.type = type;
        }

        if (type) {
          item.taxPercent = type.tax;
          item.vatPercent = type.vat; // item.description = '';

          if (type.category === "ServiceCar") {
            item.unitPrice = type.price;
            item.isServiceAndVAOrder = false;
            delete item.matId;
            delete item.eqId;
          }

          if (type.category == "Labor") {
            item.unitPrice = type.salesPrice;
            item.isServiceAndVAOrder = false;
            delete item.matId;
            delete item.eqId;
          }

          if (type.category == "ServiceAndVAOrder") {
            // item.unitPrice = 0;
            item.profit = type.profit;
            item.cost = type.cost;
            item.isServiceAndVAOrder = true;
          }
        }

        item.isSelType = true;
        vm.calculateItemPrice(item);
      }
    };

    vm.searchItemDescription = function (item, query) {
      vm.curItem = item;
      $scope.filteredItems = filterItems(vm.allItems, query);
    };

    vm.selectItemDescription = function (item, data) {
      vm.curItem = undefined;
      $scope.filteredItems = [];

      if (data.currentRate) {
        item.unitPrice = 0;

        if (data.currentRate.materialCost) {
          item.unitPrice += data.currentRate.materialCost.value;
        } // if (data.currentRate.rooferCost) {
        //   item.unitPrice += data.currentRate.rooferCost.value;
        // }


        if (data.currentRate.equipmentCost) {
          item.unitPrice += data.currentRate.equipmentCost.value;
        }

        if (item.type.profit && item.type.cost) {
          item.unitPrice = item.unitPrice * (100 + item.type.profit + item.type.cost) / 100;
        } else if (item.type.profit && !item.type.cost) {
          item.unitPrice = item.unitPrice * (100 + item.type.profit) / 100;
        } else if (!item.type.profit && item.type.cost) {
          item.unitPrice = item.unitPrice * (100 + item.type.cost) / 100;
        }

        if (item.unitPrice === 0) {
          item.unitPrice = 1;
        }
      } else {
        item.unitPrice = 1;
      }

      item.description = data.name;

      if (data.systemTag.includes('MATRL')) {
        item.matId = data._id;
        delete item.eqId;
      } else {
        item.eqId = data._id;
        delete item.matId;
      }

      if (utils.isEmpty(item.quantity)) {
        item.quantity = 1;
      }

      vm.calculateItemPrice(item);
    };

    function filterItems(items, filter) {
      var output = [];

      if (filter && filter.length >= 2) {
        angular.forEach(items, function (item) {
          if (item.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
            output.push(item);
          }
        });
      }

      return output;
    }

    vm.calculateItemPrice = function (item) {
      if (angular.isUndefined(item.quantity) || isNaN(item.quantity)) {
        item.quantity = 1;
      }

      if (angular.isUndefined(item.unitPrice) || isNaN(item.unitPrice)) return;
      item.price = item.quantity * item.unitPrice;

      if (angular.isDefined(item.vatPercent) && !isNaN(item.vatPercent)) {
        item.vatAmount = item.price * item.vatPercent / 100;
      }

      if (angular.isDefined(item.taxPercent) && !isNaN(item.taxPercent)) {
        item.taxAmount = item.price * item.taxPercent / 100;
      }

      calculateSummary();
    };

    function calculateSummary() {
      vm.invoice.totalPrice = 0;
      vm.invoice.totalVat = 0;
      vm.invoice.totalTax = 0;
      vm.invoice.totalAmount = 0;

      var _iterator = _createForOfIteratorHelper(vm.invoice.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.price) {
            vm.invoice.totalPrice += item.price;
          }

          if (item.vatAmount) {
            vm.invoice.totalVat += item.vatAmount;
          }

          if (item.taxAmount) {
            vm.invoice.totalTax += item.taxAmount;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      vm.invoice.totalAmount = vm.invoice.totalPrice + vm.invoice.totalVat + vm.invoice.totalTax;
    }

    vm.save = function (draft) {
      if (!checkValidate()) {
        return;
      }

      if ($scope.isEdit) {
        var invoiceData = prepareInvoiceData(vm.invoice);

        if (invoiceData != null) {
          if (!draft) {
            invoiceData.status = "pending";
          }

          $scope.loading = true;
          apiFactory.updateInvoice(invoiceData).then(function (resp) {
            $scope.loading = false;
            Notification.success("Invoice created successfully");
            vm.invoice._id = resp.data.data._id;
            vm.invoice.displaySeq = resp.data.data.displaySeq;
            vm.invoice.invoiceDoc = resp.data.data.invoiceDoc; // $state.go('financeSales');

            $window.history.back();
          })["catch"](function (e) {
            $scope.loading = false;
            Notification.error("Something went wrong");
            $log.error(e);
          });
        }
      } else {
        var _invoiceData = prepareInvoiceData(vm.invoice);

        if (_invoiceData != null) {
          if (!draft) {
            _invoiceData.status = "pending";
          }

          $scope.loading = true;
          apiFactory.createInvoice(_invoiceData).then(function (resp) {
            $scope.loading = false;
            Notification.success("Invoice created successfully");
            vm.invoice._id = resp.data.data._id;
            vm.invoice.displaySeq = resp.data.data.displaySeq;
            vm.invoice.invoiceDoc = resp.data.data.invoiceDoc; // $state.go('financeSales');

            $window.history.back();
          })["catch"](function (e) {
            $scope.loading = false;
            Notification.error("Something went wrong");
            $log.error(e);
          });
        }
      }
    };

    vm.showRecipientsPopup = function (needSend) {
      if (!checkValidate()) {
        return;
      }

      $uibModal.open({
        animation: true,
        component: 'recipientsModal',
        windowClass: 'recipients-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          recipients: function recipients() {
            return vm.recipients;
          },
          title: function title() {
            return 'Invoice / Credit Memo';
          },
          send: function send() {
            return needSend;
          }
        }
      }).result.then(function (result) {
        if (result) {
          send();
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.toggleProjectOverview = function () {
      showOverview = !showOverview;

      if (showOverview) {
        angular.element('#project-overview').css('visibility', 'visible');
      } else {
        angular.element('#project-overview').css('visibility', 'hidden');
      }
    };

    function getDueDate() {
      if (vm.invoice.date && vm.invoice.paymentTerms && vm.invoice.paymentTerms.length > 0) {
        var term = vm.invoice.paymentTerms[0];
        var additionalDays = utils.getDaysFromPaymentTermsCode(term.code);
        var newDate = moment(vm.invoice.date).clone();

        if (additionalDays) {
          var endDate = moment(newDate);

          if (additionalDays.w) {
            endDate = moment(newDate).isoWeek(7);
          } else if (additionalDays.m) {
            endDate = moment(newDate).endOf('month');
          }

          vm.invoice.dueDate = endDate.add(additionalDays.days, 'days');
          vm.invoice.dueDate = vm.invoice.dueDate._d;
        }
      }
    }

    function prepareInvoiceData(data) {
      if (!data.vendorType) {
        Notification.error("Please select user");
      } else if (data.vendor.staffs.length && !data.staff) {
        Notification.error('Please select staff');
      } else if (!data.date) {
        Notification.error("Please select date");
      } else if (!data.dueDate) {
        Notification.error("Please select Payment Terms");
      } else if (!vm.invoice.status) {
        Notification.error("Please select invoice status");
      } else if (data.items.length === 0) {
        Notification.error("Please add invoice Items");
      } else {
        var items = [];
        data.items.forEach(function (item) {
          if (item.description) {
            var itemdata = {
              type: item.itemId,
              number: item.itemNum,
              description: item.description,
              quantity: item.quantity,
              unitPrice: item.unitPrice,
              vatPercent: item.vatPercent,
              vatAmount: item.vatAmount,
              taxPercent: item.taxPercent,
              taxAmount: item.taxAmount,
              price: item.price
            };

            if (item.matId) {
              itemdata.matId = item.matId;
            }

            if (item.eqId) {
              itemdata.eqId = item.eqId;
            }

            items.push(itemdata);
          }
        });
        var invoiceData = {
          date: moment(data.date).format(),
          dueDate: moment(data.dueDate).format(),
          termsAndConditions: data.termsAndConditions,
          items: items,
          recipients: vm.recipients,
          status: data.status,
          isCreditMemo: vm.isCreditMemo,
          paymentTerms: data.paymentTerms,
          totalPrice: data.totalPrice,
          totalVat: data.totalVat,
          totalTax: data.totalTax,
          totalAmount: data.totalAmount,
          companyCurrency: data.companyCurrency ? data.companyCurrency : $scope.companyCurrency,
          fromVariationOrder: data.fromVariationOrder ? data.fromVariationOrder : false
        };

        if (vm.project._id !== 'all') {
          invoiceData.projectId = data.projectId ? data.projectId : vm.project._id;
        }

        if (data.projectSystemTag) {
          invoiceData.projectSystemTag = data.projectSystemTag;
        }

        if (vm.invoice._id) {
          invoiceData._id = vm.invoice._id;
        }

        invoiceData.vendorType = data.vendorType;
        invoiceData.vendor = data.vendor._id ? data.vendor._id : data.vendor;
        invoiceData.staff = data.staff;
        invoiceData.referenceNo = vm.invoice.referenceNo;
        return invoiceData;
      }

      return null;
    }

    function send() {
      var invoiceData = prepareInvoiceData(vm.invoice);

      if (invoiceData) {
        $scope.loading = true;
        apiFactory.createAndSendInvoice(invoiceData).then(function (resp) {
          $scope.loading = false;
          Notification.success("Invoice saved and sent successfully");
          vm.invoice.displaySeq = resp.data.data.displaySeq;
          vm.invoice.invoiceDoc = resp.data.data.invoiceDoc;
          $state.go('financeSales');
        })["catch"](function (e) {
          $scope.loading = false;
          Notification.error("Something went wrong");
          $log.error(e);
        });
      }
    }

    function checkValidate() {
      if (utils.isEmpty(vm.invoice.vendor)) {
        Notification.error('Please select customer');
        return false;
      }

      if (utils.isEmpty(vm.invoice.paymentTerms)) {
        Notification.error('Please Select Payment Terms');
        return false;
      }

      if (utils.isEmpty(vm.invoice.items)) {
        Notification.error('Please add lines');
        return false;
      }

      return true;
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeBankList', {
    controller: financeBankListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-bank/finance-bank-list/finance-bank-list.view.html'
  });
  /** @ngInject */

  function financeBankListController($scope, globals, apiFactory, Notification, utils, $log, $state) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.projectData = globals.projectStore.get();
    vm.bankAccounts = [{
      _id: 'citi-bank',
      name: 'Citi Bank',
      number: '4913 **** **** 6606',
      balance: '4,595,363',
      logo: '/assets/icons/finance/bank-logos/Citi-Bank.svg'
    }, {
      _id: 'deutsche-bank',
      name: 'Deutsche Bank',
      number: '5303 **** **** 7121',
      balance: '6,523,473',
      logo: '/assets/icons' + '/finance/bank-logos/Deutsche-Bank.svg'
    }, {
      _id: 'bank-of-america',
      name: 'Bank of America',
      number: '6394 **** **** 6523',
      balance: '3,732,654',
      logo: '/assets/icons/finance/bank-logos/Bank-of-America.svg'
    }, {
      _id: 'hsbc',
      name: 'HSBC',
      number: '0604 **** **** 2561',
      balance: '5,173,131',
      logo: '/assets/icons/finance/bank-logos/HSBC.svg'
    }];
    $scope.currentBank = vm.bankAccounts[0];

    $scope.changeBank = function (bankAccount) {
      $scope.currentBank = bankAccount;
      $state.go('financeBankDetail');
    };

    $scope.changeBankList = function (direction) {
      var bank;

      if (direction) {
        bank = vm.bankAccounts.shift();
        vm.bankAccounts.push(bank);
      } else {
        bank = vm.bankAccounts.pop();
        vm.bankAccounts.unshift(bank);
      }
    };

    function init() {
      var invoiceQuery = {
        sort: 'dueDate',
        sortType: 'false'
      };
      var billQuery = {
        sort: 'dueDate',
        sortType: 'false',
        approval: 'notdeclined'
      };

      if (vm.projectData && vm.projectData._id != 'all') {
        invoiceQuery.projectId = vm.projectData._id;
        billQuery.projectId = vm.projectData._id;
      }

      $scope.loading = true;
      Promise.all([apiFactory.listAllInvoices(invoiceQuery), apiFactory.queryBillings(billQuery)]).then(function (res) {
        $scope.loading = false;
        vm.invoiceList = res[0].data.list;
        vm.billingList = res[1].data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    init();
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var LeaderLine;
var AnimEvent;

(function () {
  'use strict';

  angular.module('app').component('financeBankDetail', {
    controller: financeBankDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-bank/finance-bank-detail/finance-bank-detail.view.html'
  });
  /** @ngInject */

  function financeBankDetailController($scope, globals, apiFactory, Notification, utils, $log, $uibModal, $timeout, $document, $state, $filter) {
    var vm = this;
    vm.utils = utils;
    vm.userData = globals.userStore.get();
    vm.projectData = globals.projectStore.get();
    vm.companyData = globals.companyStore.get();
    vm.bankStatements = [];
    $scope.bankStatements = [];
    vm.finances = [];
    $scope.finances = [];
    $scope.searchTextBankStatement = "";
    $scope.searchTextFinance = "";
    $scope.years = [];
    $scope.vendorTypes = [{
      label: 'Client',
      value: 'Client'
    }, {
      label: 'Vendor',
      value: 'Vendor'
    }, {
      label: $filter('translate')('Finance Posts'),
      value: 'All'
    }];
    $scope.selectedVendorTypes = ["Invoices", "C-Memo", "Billings", "V-Memo", "Finance Entries", "Finance Docs", "Finance Balances", "Finance Payrolls", "Finance Journals", "Bank Posts", "Bank Balances"];
    $scope.allVendorTypes = ["Invoices", "C-Memo", "Billings", "V-Memo", "Finance Entries", "Finance Docs", "Finance Balances", "Finance Payrolls", "Finance Journals", "Bank Posts", "Bank Balances"];
    $scope.transfers = [{
      value: $filter('translate')('All')
    }, {
      value: 'Income Transfer'
    }, {
      value: 'Outgoing Transfer'
    }];
    vm.paymentTemplates = [{
      _id: "payment",
      name: "Payment"
    }];
    $scope.needBillingMemo = false;
    $scope.needInvoiceMemo = false;
    $scope.months = [{
      label: $filter('translate')('Jan'),
      value: 1
    }, {
      label: $filter('translate')('Feb'),
      value: 2
    }, {
      label: $filter('translate')('Mar'),
      value: 3
    }, {
      label: $filter('translate')('Apr'),
      value: 4
    }, {
      label: $filter('translate')('May'),
      value: 5
    }, {
      label: $filter('translate')('Jun'),
      value: 6
    }, {
      label: $filter('translate')('Jul'),
      value: 7
    }, {
      label: $filter('translate')('Aug'),
      value: 8
    }, {
      label: $filter('translate')('Sep'),
      value: 9
    }, {
      label: $filter('translate')('Oct'),
      value: 10
    }, {
      label: $filter('translate')('Nov'),
      value: 11
    }, {
      label: $filter('translate')('Dec'),
      value: 12
    }, {
      label: $filter('translate')('All'),
      value: 0
    }];
    $scope.vendorType = 'All';
    $scope.transfer = $filter('translate')('All');
    $scope.selectedBankStatement = undefined;
    $scope.selectedFinance = undefined;
    vm.lines = [];
    vm.bankSortItems = [{
      sort: 'bankCode',
      sortDir: -1
    }, {
      sort: 'date',
      sortDir: -1
    }, {
      sort: 'description',
      sortDir: -1
    }, {
      sort: 'amount',
      sortDir: -1
    }];
    $scope.financeSortItems = [{
      sort: 'bankCode',
      sortDir: -1
    }, {
      sort: 'date',
      sortDir: -1
    }, {
      sort: 'doc',
      sortDir: -1
    }, {
      sort: 'vendor',
      sortDir: -1
    }, {
      sort: 'amount',
      sortDir: -1
    }];
    $scope.currentFinanceSortItem = $scope.financeSortItems[1];
    $scope.currentBankSortItem = vm.bankSortItems[1];
    $scope.bankStatements = [];
    $scope.allBankStatement = {
      _id: "all-bank-statement",
      linkStatus: "none",
      selected: false,
      amount: 0
    };
    $scope.needFinanceItem = undefined;

    $scope.changeBankSortItem = function (sort) {
      if (sort === $scope.currentBankSortItem.sort) {
        $scope.currentBankSortItem.sortDir *= -1;
      } else {
        $scope.currentBankSortItem = vm.bankSortItems.find(function (x) {
          return x.sort === sort;
        });
      }

      switch (sort) {
        case 'bankCode':
          $scope.bankStatements.sort(function (a, b) {
            var aa = a.bankCode ? Number.parseInt(a.bankCode.slice(3, a.length)) : 0;
            var bb = b.bankCode ? Number.parseInt(b.bankCode.slice(3, b.length)) : 0;
            return $scope.currentBankSortItem.sortDir < 0 ? bb - aa : aa - bb;
          });
          break;

        case 'date':
          $scope.bankStatements.sort(function (a, b) {
            var aa = new Date(a.date);
            var bb = new Date(b.date);
            return $scope.currentBankSortItem.sortDir < 0 ? bb.getTime() - aa.getTime() : aa.getTime() - bb.getTime();
          });
          break;

        case 'description':
          $scope.bankStatements.sort(function (a, b) {
            if ($scope.currentBankSortItem.sortDir < 0) {
              if (b.description > a.description) {
                return 1;
              } else if (b.description < a.description) {
                return -1;
              } else {
                return 0;
              }
            } else {
              if (a.description > b.description) {
                return 1;
              } else if (a.description < b.description) {
                return -1;
              } else {
                return 0;
              }
            }
          });
          break;

        case 'amount':
          $scope.bankStatements.sort(function (a, b) {
            return $scope.currentBankSortItem.sortDir < 0 ? b.amount - a.amount : a.amount - b.amount;
          });
          break;
      }
    };

    $scope.getFinanceItemTypeDoc = function (item) {
      var cut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var ret = '';
      if (item.item.billNo) ret = item.item.billNo;
      if (item.item.displaySeq) ret = item.item.displaySeq;
      if (item.item.systemTag) ret = item.item.systemTag;
      if (cut) return ret.substring(0, 10);
      return ret;
    };

    $scope.changeFinanceSortItem = function (sort) {
      if (sort === $scope.currentFinanceSortItem.sort) {
        $scope.currentFinanceSortItem.sortDir *= -1;
      } else {
        $scope.currentFinanceSortItem = $scope.financeSortItems.find(function (x) {
          return x.sort === sort;
        });
      }

      switch (sort) {
        case "bankCode":
          $scope.finances.sort(function (a, b) {
            var aa = a.bankCode ? Number.parseInt(a.bankCode.slice(3, a.length)) : 0;
            var bb = b.bankCode ? Number.parseInt(b.bankCode.slice(3, b.length)) : 0;
            return $scope.currentFinanceSortItem.sortDir < 0 ? bb - aa : aa - bb;
          });
          break;

        case "date":
          $scope.finances.sort(function (a, b) {
            var aa = new Date(a.billDate || a.date || a.createdAt);
            var bb = new Date(b.billDate || b.date || b.createdAt);
            return $scope.currentFinanceSortItem.sortDir < 0 ? bb.getTime() - aa.getTime() : aa.getTime() - bb.getTime();
          });
          break;

        case "doc":
          $scope.finances.sort(function (a, b) {
            var aa = a.billNo || a.displaySeq || a.systemTag;
            var bb = b.billNo || b.displaySeq || b.systemTag;

            if ($scope.currentFinanceSortItem.sortDir < 0) {
              if (bb > aa) {
                return 1;
              } else if (bb < aa) {
                return -1;
              } else {
                return 0;
              }
            } else {
              if (aa > bb) {
                return 1;
              } else if (aa < bb) {
                return -1;
              } else {
                return 0;
              }
            }
          });
          break;

        case "vendor":
          $scope.finances.sort(function (a, b) {
            var aa = a.vendor ? a.vendor.clientName || a.vendor.name : a.description;
            var bb = b.vendor ? b.vendor.clientName || b.vendor.name : b.description;

            if ($scope.currentFinanceSortItem.sortDir < 0) {
              if (bb > aa) {
                return 1;
              } else if (bb < aa) {
                return -1;
              } else {
                return 0;
              }
            } else {
              if (aa > bb) {
                return 1;
              } else if (aa < bb) {
                return -1;
              } else {
                return 0;
              }
            }
          });
          break;

        case "amount":
          $scope.finances.sort(function (a, b) {
            return $scope.currentFinanceSortItem.sortDir < 0 ? b.totalAmount - a.totalAmount : a.totalAmount - b.totalAmount;
          });
          break;
      }
    };

    $scope.changeBank = function () {
      if (!utils.isEmpty(vm.banks)) {
        $scope.currentBank = vm.banks.find(function (x) {
          return x._id === $scope.currentBankId;
        });
      }
    };

    $scope.clearStatements = function () {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.loading = true;
        apiFactory.clearBankStatements().then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message);
          clearLines();
          $scope.fetchData('bankStatement');
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }, function () {});
    };

    $scope.selectMonth = function (month) {
      $scope.selectedMonth = month;
      $scope.fetchData();
    };

    $scope.downloadInvoice = function (invoice) {
      if (!invoice.invoiceDoc) {
        Notification.info("No attachment");
        return;
      }

      $scope.loading = true;
      utils.downloadFile(invoice.invoiceDoc, "".concat(invoice.displaySeq, ".pdf")).then(function () {
        $scope.loading = false;
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    $scope.downloadBill = function (bill) {
      if (!bill.bill || !bill.bill.secure_url) {
        Notification.info("No attachment");
        return;
      }

      $scope.loading = true;
      utils.downloadFile(bill.bill.secure_url, "".concat(bill.billNo, ".pdf")).then(function () {
        $scope.loading = false;
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    $scope.downloadAttach = function (financeDoc) {
      if (!financeDoc.attachment) {
        Notification.info("No attachment");
        return;
      }

      $scope.loading = true;
      utils.downloadFile(financeDoc.attachment).then(function () {
        $scope.loading = false;
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    function makeLink(bankStatement, finance) {
      if (!bankStatement || !finance) {
        return;
      }

      var elBankStatement = $document[0].getElementById(bankStatement._id);
      var elFinance = $document[0].getElementById(finance._id);

      if (elBankStatement && elFinance) {
        var line = new LeaderLine(elBankStatement, elFinance, {
          startPlug: 'behind',
          endPlug: 'behind'
        });

        if (line) {
          line.color = '#4584E0';
          line.size = 2;
          line.billLine = false;
          line.invoiceLine = false;
          line.elBankStatement = elBankStatement;
          line.elFinance = elFinance;
          line.listener = AnimEvent.add(function () {
            if (line) {
              line.position();
            }
          });
          vm.leftScrollBox.addEventListener('scroll', line.listener, false);
          vm.rightScrollBox.addEventListener('scroll', line.listener, false);

          if (!isElementInView(vm.elStatementsTableBody, line.elBankStatement) || !isElementInView(vm.elFinancesTableBody, line.elFinance)) {
            line.hide();
          } else {
            line.show();
          }

          line.bankStatement = bankStatement;
          line.finance = finance;
          bankStatement.linkStatus = 'linked';
          finance.linkStatus = 'linked';
          $scope.selectedBankStatement = undefined;
          $scope.selectedFinance = undefined;
          line.amount = Math.abs(bankStatement.remainingAmount) < Math.abs(finance.remainingAmount) ? bankStatement.remainingAmount : finance.remainingAmount;
          bankStatement.financeItems.push({
            item: finance,
            itemType: finance.financeType,
            amount: line.amount
          });
          finance.financeItems.push({
            item: bankStatement,
            itemType: "BankStatement",
            amount: line.amount
          });

          if (Math.abs(bankStatement.remainingAmount) > Math.abs(finance.remainingAmount)) {
            var factor = bankStatement.remainingAmount > 0 ? 1 : -1;
            bankStatement.remainingAmount = (Math.abs(bankStatement.remainingAmount) - Math.abs(finance.remainingAmount)) * factor;
            finance.remainingAmount = 0;
          } else {
            var _factor = bankStatement.remainingAmount > 0 ? 1 : -1;

            finance.remainingAmount = (Math.abs(finance.remainingAmount) - Math.abs(bankStatement.remainingAmount)) * _factor;
            bankStatement.remainingAmount = 0;
          }

          vm.lines.push(line);
        }
      }
    }

    $scope.selectBankStatement = function (bankStatement) {
      vm.bankStatementForFinanceDoc = undefined;

      if (bankStatement.linkStatus !== 'approved') {
        if (bankStatement.selected) {
          bankStatement.selected = false;
          $scope.selectedBankStatement = undefined;
        } else {
          if ($scope.selectedBankStatement) {
            $scope.selectedBankStatement.selected = false;
          }

          bankStatement.selected = true;
          $scope.selectedBankStatement = bankStatement;
          makeLink($scope.selectedBankStatement, $scope.selectedFinance);
        }
      }
    };

    function isValidBillingLink(a, b) {
      if (a.financeType != "Billing" || b.financeType != "Billing") return false;
      if (a.isMemo == true && b.isMemo == true) return false;
      if (a.isMemo == false && b.isMemo == false) return false;
      return true;
    }

    function isValidInvoiceLink(a, b) {
      if (a.financeType != "Invoice" || b.financeType != "Invoice") return false;
      if (a.isCreditMemo == true && b.isCreditMemo == true) return false;
      if (a.isCreditMemo == false && b.isCreditMemo == false) return false;
      return true;
    }

    function makeCreditMemoLink(a, b) {
      if (!a || !b) {
        return;
      }

      var first = $document[0].getElementById(a._id);
      var second = $document[0].getElementById(b._id);

      if (first && second) {
        var line = new LeaderLine(first, second, {
          startPlug: "behind",
          endPlug: "behind"
        });

        if (line) {
          line.color = '#4584E0';
          line.size = 2;
          line.billLine = false;
          line.invoiceLine = true;
          line.elFirst = first;
          line.elSecond = second;
          line.listener = AnimEvent.add(function () {
            if (line) {
              line.position();
            }
          });
          vm.leftScrollBox.addEventListener('scroll', line.listener, false);
          vm.rightScrollBox.addEventListener('scroll', line.listener, false);

          if (!isElementInView(vm.elFinancesTableBody, line.elFirst) || !isElementInView(vm.elFinancesTableBody, line.elSecond)) {
            line.hide();
          } else {
            line.show();
          }

          line.first = a;
          line.second = b;
          a.linkStatus = 'linked';
          b.linkStatus = 'linked';
          $scope.selectedBankStatement = undefined;
          $scope.selectedFinance = undefined;
          line.amount = a.remainingAmount + b.remainingAmount;
          var minAmt = Math.min(Math.abs(a.remainingAmount), Math.abs(b.remainingAmount));
          $scope.invoiceMemoAmount = minAmt;

          if (a.isCreditMemo) {
            line.invoice = b;
            line.memo = a;
            $scope.needInvoiceItem = b;
            $scope.needMemoItem = a;
            b.remainingAmount -= minAmt;
            a.remainingAmount -= minAmt;
          } else {
            line.invoice = a;
            line.memo = b;
            $scope.needInvoiceItem = a;
            $scope.needMemoItem = b;
            b.remainingAmount -= minAmt;
            a.remainingAmount -= minAmt;
          }

          if (!a.subtractList) a.subtractList = [];
          a.subtractList.push({
            invoiceId: b._id,
            subtractTotalPrice: b.totalAmount - b.vatPercent,
            subtractTotalAmount: minAmt,
            subtractTotalVat: b.vatPercent
          });
          if (!b.subtractList || _typeof(b.subtractList) != Array) b.subtractList = [];
          b.subtractList.push({
            invoiceId: a._id,
            subtractTotalPrice: a.totalAmount - a.vatPercent,
            subtractTotalAmount: minAmt,
            subtractTotalVat: a.vatPercent
          });
          vm.lines.push(line);
          $scope.needInvoiceMemo = true;
        }
      }
    }

    function makeBillingMemoLink(a, b) {
      if (!a || !b) {
        return;
      }

      var first = $document[0].getElementById(a._id);
      var second = $document[0].getElementById(b._id);

      if (first && second) {
        var line = new LeaderLine(first, second, {
          startPlug: "behind",
          endPlug: "behind"
        });

        if (line) {
          line.color = '#4584E0';
          line.size = 2;
          line.billLine = true;
          line.invoiceLine = false;
          line.elFirst = first;
          line.elSecond = second;
          line.listener = AnimEvent.add(function () {
            if (line) {
              line.position();
            }
          });
          vm.leftScrollBox.addEventListener('scroll', line.listener, false);
          vm.rightScrollBox.addEventListener('scroll', line.listener, false);

          if (!isElementInView(vm.elFinancesTableBody, line.elFirst) || !isElementInView(vm.elFinancesTableBody, line.elSecond)) {
            line.hide();
          } else {
            line.show();
          }

          line.first = a;
          line.second = b;
          a.linkStatus = 'linked';
          b.linkStatus = 'linked';
          $scope.selectedBankStatement = undefined;
          $scope.selectedFinance = undefined;
          line.amount = a.remainingAmount + b.remainingAmount;
          var minAmt = Math.min(Math.abs(a.remainingAmount), Math.abs(b.remainingAmount));
          $scope.billMemoAmount = minAmt;

          if (a.isMemo) {
            line.bill = b;
            line.memo = a;
            $scope.needBillItem = b;
            $scope.needMemoItem = a;
            b.remainingAmount += minAmt;
            a.remainingAmount -= minAmt;
          } else {
            line.bill = a;
            line.memo = b;
            $scope.needBillItem = a;
            $scope.needMemoItem = b;
            b.remainingAmount -= minAmt;
            a.remainingAmount += minAmt;
          }

          if (!a.subtractList) a.subtractList = [];
          a.subtractList.push({
            billId: b._id,
            subtractTotalPrice: b.totalAmount - b.vatPercent,
            subtractTotalAmount: minAmt,
            subtractTotalVat: b.vatPercent
          });
          if (!b.subtractList) b.subtractList = [];
          b.subtractList.push({
            billId: a._id,
            subtractTotalPrice: a.totalAmount - a.vatPercent,
            subtractTotalAmount: minAmt,
            subtractTotalVat: a.vatPercent
          });
          vm.lines.push(line);
          $scope.needBillingMemo = true;
        }
      }
    }

    $scope.selectFinance = function (finance) {
      if (finance.linkStatus !== 'approved' && finance.linkStatus !== 'approved-memo' && finance.linkStatus !== 'approved-balance') {
        if (finance.selected) {
          finance.selected = false;
          $scope.selectedFinance = undefined;
        } else {
          if ($scope.selectedFinance && isValidBillingLink($scope.selectedFinance, finance)) {
            makeBillingMemoLink($scope.selectedFinance, finance);
          } else if ($scope.selectedFinance && isValidInvoiceLink($scope.selectedFinance, finance)) {
            makeCreditMemoLink($scope.selectedFinance, finance);
          } else {
            if ($scope.selectedFinance) {
              $scope.selectedFinance.selected = false;
            }

            finance.selected = true;
            $scope.selectedFinance = finance;
            makeLink($scope.selectedBankStatement, $scope.selectedFinance);
          }
        }
      }
    };

    $scope.approve = function () {
      var promises = [];

      var _iterator = _createForOfIteratorHelper(vm.lines),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var line = _step.value;

          if (line.billLine) {
            var bill = line.bill,
                memo = line.memo;
            bill.remainingAmount *= -1;
            promises.push(apiFactory.updateBillingLinkInfo(bill._id, {
              remainingAmount: bill.remainingAmount,
              subtractList: bill.subtractList
            }));
            promises.push(apiFactory.updateBillingLinkInfo(memo._id, {
              remainingAmount: memo.remainingAmount,
              subtractList: memo.subtractList
            }));
          } else if (line.invoiceLine) {
            var invoice = line.invoice,
                _memo = line.memo;
            promises.push(apiFactory.updateInvoiceLinkInfo(invoice._id, {
              remainingAmount: invoice.remainingAmount,
              subtractList: invoice.subtractList
            }));
            promises.push(apiFactory.updateInvoiceLinkInfo(_memo._id, {
              remainingAmount: _memo.remainingAmount,
              subtractList: _memo.subtractList
            }));
          } else {
            var bankStatement = line.bankStatement,
                finance = line.finance;

            if (bankStatement && finance) {
              promises.push(apiFactory.updateBankStatement(bankStatement._id, {
                financeItems: bankStatement.financeItems.map(function (x) {
                  return {
                    item: x.item._id,
                    itemType: x.itemType,
                    amount: x.amount
                  };
                }),
                remainingAmount: bankStatement.remainingAmount
              })); // update Finance

              var apiFuncName = undefined;

              if (finance.financeType === "Invoice") {
                apiFuncName = "updateInvoiceLinkInfo";
              } else if (finance.financeType === "Billing") {
                finance.remainingAmount *= -1; // reverse remaining amount for billing

                apiFuncName = "updateBillingLinkInfo";
              } else if (finance.financeType === "FinancePayroll") {
                apiFuncName = "updateFinancePayrollLinkInfo";
              } else if (finance.financeType === "FinanceEntry") {
                apiFuncName = "updateFinanceEntryInfo";
              }

              promises.push(apiFactory[apiFuncName](finance._id, {
                financeItems: finance.financeItems.map(function (x) {
                  return {
                    item: x.item._id,
                    itemType: x.itemType,
                    amount: x.amount
                  };
                }),
                remainingAmount: finance.remainingAmount,
                subtractList: finance.subtractList
              })); // Create Payment Journal

              var journalData = {
                date: bankStatement.date || new Date(),
                type: finance.systemTag ? 'Other' : finance.vendorType === 'Client' ? 'Client Payment' : finance.vendorType === 'Supplier' ? 'Supplier Payment' : 'Other',
                vendor: finance.vendor ? finance.vendor._id : null,
                vendorType: finance.vendorType,
                finance: finance._id,
                financeType: finance.financeType,
                amount: line.amount,
                accountPlan: vm.bankAccountPlans[0]._id,
                isLinkedWithBank: true
              };
              promises.push(apiFactory.createPaymentJournal(journalData));
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (promises.length) {
        $scope.loading = true;
        Promise.all(promises).then(function () {
          $scope.loading = false;
          clearLines();
          $scope.fetchData();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      } else {
        $scope.fetchData();
      }
    };

    $scope.removeLinkFromBankStatement = function (bankStatement) {
      bankStatement.selected = false;
      var promises = [];

      var _iterator2 = _createForOfIteratorHelper(bankStatement.financeItems),
          _step2;

      try {
        var _loop = function _loop() {
          var financeItem = _step2.value;
          var finance = $scope.finances.find(function (x) {
            return x._id === financeItem.item._id;
          });

          if (finance) {
            var index = finance.financeItems.findIndex(function (x) {
              return x.item === bankStatement._id;
            });

            if (index !== -1) {
              finance.remainingAmount += finance.financeItems[index].amount;
              finance.financeItems.splice(index, 1);
              setBankCodeToFinance(finance); // remove line

              var lineIndex = vm.lines.findIndex(function (x) {
                return x.bankStatement._id === bankStatement._id && x.finance._id === finance._id;
              });

              if (lineIndex !== -1) {
                var line = vm.lines[lineIndex];
                vm.leftScrollBox.removeEventListener('scroll', line.listener);
                vm.rightScrollBox.removeEventListener('scroll', line.listener);
                line.remove();
                vm.lines.splice(lineIndex, 1);
              }

              if (finance.linkStatus !== 'none') {
                var financePayload = {
                  financeItems: finance.financeItems.map(function (x) {
                    return {
                      item: x.item._id,
                      itemType: x.itemType,
                      amount: x.amount
                    };
                  }),
                  remainingAmount: finance.remainingAmount
                };

                if (finance.financeType === "FinanceDoc") {
                  promises.push(apiFactory.deleteFinanceDoc(finance._id));
                } else if (finance.financeType === "FinancePayroll") {
                  promises.push(apiFactory.updateFinancePayrollLinkInfo(finance._id, financePayload));
                } else {
                  // Invoice or Bill
                  promises.push(apiFactory.deletePaymentJournalByFinanceId(finance._id));

                  if (finance.financeType === "Invoice") {
                    promises.push(apiFactory.updateInvoiceLinkInfo(finance._id, financePayload));
                  } else if (finance.financeType === "Billing") {
                    promises.push(apiFactory.updateBillingLinkInfo(finance._id, financePayload));
                  }
                }
              }
            }
          }
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      $scope.selectedBankStatement = undefined;
      vm.bankStatementForFinanceDoc = undefined;

      if (bankStatement.linkStatus !== 'linked') {
        promises.unshift(apiFactory.updateBankStatement(bankStatement._id, {
          financeItems: [],
          remainingAmount: bankStatement.totalAmount
        }));
      } else {
        bankStatement.linkStatus = 'none';
        bankStatement.financeItems = [];
        bankStatement.remainingAmount = bankStatement.totalAmount;
      }

      if (promises.length) {
        $scope.loading = true;
        Promise.all(promises).then(function () {
          $scope.fetchData();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }
    };

    $scope.removeLinkFromFinance = function (finance) {
      finance.selected = false;
      var promises = [];

      var _iterator3 = _createForOfIteratorHelper(finance.financeItems),
          _step3;

      try {
        var _loop2 = function _loop2() {
          var financeItem = _step3.value;
          var bankStatement = $scope.bankStatements.find(function (x) {
            return x._id === financeItem.item._id;
          });

          if (bankStatement) {
            var index = bankStatement.financeItems.findIndex(function (x) {
              return x.finance === finance._id;
            });

            if (index !== -1) {
              bankStatement.remainingAmount += financeItem.amount;
              bankStatement.financeItems.splice(index, 1); // remove line

              var lineIndex = vm.lines.findIndex(function (x) {
                return x.bankStatement._id === bankStatement._id && x.finance._id === finance._id;
              });

              if (lineIndex !== -1) {
                var line = vm.lines[lineIndex];
                vm.leftScrollBox.removeEventListener('scroll', line.listener);
                vm.rightScrollBox.removeEventListener('scroll', line.listener);
                line.remove();
                vm.lines.splice(lineIndex, 1);
              }

              if (bankStatement.linkStatus !== 'linked') {
                promises.push(apiFactory.updateBankStatement(bankStatement._id, {
                  financeItems: bankStatement.financeItems.map(function (x) {
                    return {
                      item: x.item._id,
                      itemType: x.itemType,
                      amount: x.amount
                    };
                  }),
                  remainingAmount: bankStatement.remainingAmount
                }));
              }
            }
          }
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      $scope.selectedFinance = undefined;

      if (finance.linkStatus !== 'linked') {
        var financePayload = {
          financeItems: [],
          remainingAmount: finance.totalAmount
        };

        if (finance.financeType === "FinanceDoc") {
          promises.push(apiFactory.deleteFinanceDoc(finance._id));
        } else if (finance.financeType === "FinancePayroll") {
          promises.push(apiFactory.updateFinancePayrollLinkInfo(finance._id, financePayload));
        } else {
          // Invoice or Bill
          promises.push(apiFactory.deletePaymentJournalByFinanceId(finance._id));

          if (finance.financeType === "Invoice") {
            promises.push(apiFactory.updateInvoiceLinkInfo(finance._id, financePayload));
          } else if (finance.financeType === "Billing") {
            promises.push(apiFactory.updateBillingLinkInfo(finance._id, financePayload));
          }
        }
      } else {
        finance.financeItems = [];
        finance.remainingAmount = finance.totalAmount;
      }

      if (promises.length) {
        $scope.loading = true;
        Promise.all(promises).then(function () {
          $scope.fetchData();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }
    };

    $scope.advancedAutoLinking = function () {
      var finances = $scope.finances.filter(function (x) {
        return x.linkStatus === 'none';
      });
      var bankStatements = $scope.bankStatements.filter(function (x) {
        return x.linkStatus === 'none';
      });
      $scope.loading = true;

      var buildFinancesCombinations = function buildFinancesCombinations(arr, num) {
        var res = [];
        var temp,
            i,
            j,
            max = 1 << arr.length;

        for (i = 0; i < max; i++) {
          temp = [];

          for (j = 0; j < arr.length; j++) {
            if (i & 1 << j) {
              temp.push(arr[j]);
            }
          }

          if (temp.length === num) {
            res.push({
              arr: temp,
              sum: temp.reduce(function (a, b) {
                return a + b.totalAmount;
              }, 0)
            });
          }
        }

        return res;
      }; // const buildBankStatementCombinations = (arr, num) => {
      //   const res = [];
      //   let temp, i, j, max = 1 << arr.length;
      //   for(i = 0; i < max; i++){
      //       temp = [];
      //       for(j = 0; j < arr.length; j++){
      //         if (i & 1 << j){
      //             temp.push(arr[j]);
      //         }
      //       }
      //       if(temp.length === num){
      //         res.push({arr: temp, sum: temp.reduce(function (a, b) { return a + b.amount; }, 0)});
      //       }
      //   }
      //   return res;
      // }


      var autoFinanceCalc = function autoFinanceCalc(fArr, bArr, num) {
        if (num >= fArr.length || bArr.length == 0) return;
        var possibleArr = buildFinancesCombinations(fArr, num);

        var _loop3 = function _loop3(j) {
          var idx = possibleArr.findIndex(function (x) {
            return x.sum === bArr[j].amount;
          });

          if (idx > -1) {
            possibleArr[idx].arr.forEach(function (a) {
              makeLink(bArr[j], a);
              fArr = fArr.filter(function (x) {
                return x._id != a._id;
              });
            });
            bArr.splice(j, 1);
            return "break";
          }
        };

        for (var j = bArr.length - 1; j >= 0; j--) {
          var _ret = _loop3(j);

          if (_ret === "break") break;
        }

        autoFinanceCalc(fArr, bArr, num + 1);
      };

      autoFinanceCalc(finances, bankStatements, 2);
      $scope.loading = false;
    };

    $scope.autoLinking = function () {
      var invoiceRegex = /INV\d*-\d*-\d*/;

      var _iterator4 = _createForOfIteratorHelper($scope.bankStatements),
          _step4;

      try {
        var _loop4 = function _loop4() {
          var bankStatement = _step4.value;

          if (bankStatement.linkStatus !== 'none') {
            return "continue";
          }

          var description = bankStatement.description;
          var finance = undefined;

          if (angular.isDefined(description) && angular.isString(description) && description.length) {
            var result = description.match(invoiceRegex);

            if (result) {
              var displaySeq = result[0];
              finance = $scope.finances.find(function (x) {
                return x.displaySeq === displaySeq && x.linkStatus === 'none';
              });
            }
          }

          if (angular.isUndefined(finance)) {
            finance = $scope.finances.find(function (x) {
              return x.totalAmount === bankStatement.amount && x.linkStatus === 'none';
            });
          }

          if (finance) {
            makeLink(bankStatement, finance);
          }
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _ret2 = _loop4();

          if (_ret2 === "continue") continue;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    };

    $scope.fetchData = function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'both';
      var promises = [];
      var isBankStatement = false;
      var isFinance = false;

      if (type === 'both' || type === 'bankStatement') {
        var bankQuery = {
          year: $scope.bankStatementYear,
          month: $scope.selectedMonth.value,
          vendorType: $scope.vendorType,
          transfer: $scope.transfer,
          bankId: $scope.currentBankId
        };
        promises.push(apiFactory.getBankStatements(bankQuery));
        isBankStatement = true;
      }

      if (type === 'both' || type === 'finance') {
        var financeQuery = {
          year: $scope.financeYear,
          month: $scope.selectedMonth.value,
          vendorTypes: $scope.selectedVendorTypes,
          transfer: $scope.transfer
        };
        promises.push(apiFactory.listBankFinances(financeQuery));
        isFinance = true;
      }

      $scope.loading = true;
      Promise.all(promises).then(function (res) {
        $scope.loading = false;
        clearLines();

        if (res.length === 2) {
          vm.bankStatements = res[0].data;
          vm.finances = res[1].data || [];
        } else if (isBankStatement) {
          vm.bankStatements = res[0].data;
        } else if (isFinance) {
          vm.finances = res[0].data || [];
        }

        var _iterator5 = _createForOfIteratorHelper(vm.bankStatements),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var bankStatement = _step5.value;
            bankStatement.financeType = 'BankStatement';

            if (utils.isEmpty(bankStatement.financeItems) || bankStatement.totalAmount === bankStatement.remainingAmount) {
              bankStatement.linkStatus = 'none';
            } else if (!bankStatement.remainingAmount || Math.abs(bankStatement.remainingAmount) < 0.01) {
              bankStatement.linkStatus = 'approved';
            } else {
              bankStatement.linkStatus = 'pending';
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        var _iterator6 = _createForOfIteratorHelper(vm.finances),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var finance = _step6.value;

            if (finance.financeType === "Payment" || finance.financeType === "Posting") {
              continue;
            }

            if (!finance.remainingAmount || Math.abs(finance.remainingAmount) < 0.01) {
              finance.linkStatus = 'approved';
              if (finance.subtractList && finance.subtractList.length > 0 || finance.isMemo || finance.isCreditMemo) finance.linkStatus = 'approved-memo';else if (finance.financeItems[0] && finance.financeItems[0].itemType == "FinanceBalance" || finance.financeType == "FinanceBalance") finance.linkStatus = 'approved-balance';
            } else if (utils.isEmpty(finance.financeItems) && utils.isEmpty(finance.subtractList) || finance.totalAmount === finance.remainingAmount) {
              finance.linkStatus = 'none';
            } else {
              finance.linkStatus = 'pending';
            }

            setBankCodeToFinance(finance);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        $scope.bankStatements = angular.copy(vm.bankStatements);
        $scope.finances = angular.copy(vm.finances);

        if ($scope.searchTextBankStatement) {
          $scope.searchData('bankStatement');
        }

        if ($scope.searchTextFinance) {
          $scope.searchData('finance');
        }
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.searchData = function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'both';
      var regex;

      if (type === 'bankStatement' || type === 'both') {
        regex = new RegExp($scope.searchTextBankStatement, 'gi');
        $scope.bankStatements = angular.copy(vm.bankStatements);
        $scope.bankStatements = $scope.bankStatements.filter(function (x) {
          return bankStatementFilter(x, regex);
        });
      }

      if (type === 'finance' || type === 'both') {
        regex = new RegExp($scope.searchTextFinance, 'gi');
        $scope.finances = angular.copy(vm.finances);
        $scope.finances = $scope.finances.filter(function (x) {
          return financeFilter(x, regex);
        }) || [];
        $log.log($scope.finances);
      }

      clearLines();

      if (!utils.isEmpty($scope.bankStatements)) {
        $scope.allBankStatement.amount = 0;
        $scope.allBankStatement.bankStatements = [];
        $scope.bankStatements.forEach(function (bankStatement) {
          $scope.allBankStatement.amount += bankStatement.remainingAmount;

          if (bankStatement.linkStatus !== "approved") {
            $scope.allBankStatement.bankStatements.push(bankStatement);
          }
        });
        $scope.allBankStatement.linkStatus = utils.isEmpty($scope.allBankStatement.bankStatements) ? "approved" : "none";
      }
    };

    $scope.openFinanceDocTemplateModal = function () {
      if (!utils.isEmpty(vm.bankStatementForFinanceDoc)) {
        vm.bankStatementForFinanceDoc.selected = false;
        vm.bankStatementForFinanceDoc = undefined;
      }

      $uibModal.open({
        animation: true,
        component: "FinanceDocTemplateModal",
        windowClass: "finance-doc-template-modal",
        backdrop: 'static',
        resolve: {
          financeDocTemplates: function financeDocTemplates() {
            return vm.financeDocTemplates;
          },
          bankAccountPlans: function bankAccountPlans() {
            return vm.bankAccountPlans;
          },
          balanceAccountPlans: function balanceAccountPlans() {
            return vm.balanceAccountPlans;
          },
          vatAccountPlans: function vatAccountPlans() {
            return vm.vatAccountPlans;
          }
        }
      }).result.then(function () {
        $scope.fetchData();
      })["catch"](function () {
        vm.bankStatementForFinanceDoc = undefined;
      });
    };

    $scope.setBankStatementForFinanceDoc = function (bankStatement) {
      if (bankStatement.linkStatus !== 'none') {
        return;
      }

      if (!utils.isEmpty(vm.bankStatementForFinanceDoc)) {
        vm.bankStatementForFinanceDoc.selected = false;
        vm.bankStatementForFinanceDoc.linkStatus = 'none';
      }

      bankStatement.linkStatus = 'linked';
      vm.bankStatementForFinanceDoc = bankStatement;
      $timeout(function () {
        var elFinance = $document[0].getElementById(vm.bankStatementForFinanceDoc._id);
        var elPanel = $document[0].getElementById('finance-doc-panel-point');

        if (elFinance && elPanel) {
          var line = new LeaderLine(elFinance, elPanel, {
            startPlug: 'behind',
            endPlug: 'behind'
          });

          if (line) {
            line.color = '#4584E0';
            line.size = 2;
            line.billLine = false;
            line.invoiceLine = false;
            line.elBankStatement = elFinance;
            line.listener = AnimEvent.add(function () {
              if (line) {
                line.position();
              }
            });
            vm.leftScrollBox.addEventListener('scroll', line.listener, false);
            vm.rightScrollBox.addEventListener('scroll', line.listener, false);

            if (!isElementInView(vm.elStatementsTableBody, line.elBankStatement) || !isElementInView(vm.elFinancesTableBody, line.elFinance)) {
              line.hide();
            } else {
              line.show();
            }

            line.bankStatement = bankStatement;
            vm.lines.push(line);
          }
        }
      }, 1000);
    };

    $scope.setNeedFinanceItem = function (finance) {
      finance.linkStatus = 'linked';
      $scope.needFinanceItem = finance;
    };

    $scope.setBalanceFinanceItem = function (finance) {
      if (finance.financeType == 'Invoice' || finance.financeType == 'Billing') {
        $scope.balanceFinanceItem = finance;
        $timeout(function () {
          var elFinance = $document[0].getElementById($scope.balanceFinanceItem._id);
          var elPanel = $document[0].getElementById('finance-doc-panel-point');

          if (elFinance && elPanel) {
            var line = new LeaderLine(elFinance, elPanel, {
              startPlug: 'behind',
              endPlug: 'behind'
            });

            if (line) {
              line.color = '#4584E0';
              line.size = 2;
              line.billLine = false;
              line.invoiceLine = false;
              line.elFinance = elFinance;
              line.listener = AnimEvent.add(function () {
                if (line) {
                  line.position();
                }
              });
              vm.leftScrollBox.addEventListener('scroll', line.listener, false);
              vm.rightScrollBox.addEventListener('scroll', line.listener, false);
              $scope.balanceFinanceItem.linkStatus = 'linked';

              if (!isElementInView(vm.elStatementsTableBody, line.elBankStatement) || !isElementInView(vm.elFinancesTableBody, line.elFinance)) {
                line.hide();
              } else {
                line.show();
              }

              line.finance = finance;
              vm.lines.push(line);
            }
          }
        }, 1000);
      }
    };

    $scope.uploadBankStatements = function () {
      $uibModal.open({
        animation: true,
        component: "financeUploadCSVModal",
        windowClass: "finance-upload-csv-modal",
        backdrop: "static",
        resolve: {
          title: function title() {
            return "Upload a Bank Statements CSV File";
          },
          importType: function importType() {
            return "BankStatement";
          }
        }
      }).result.then(function (bankStatements) {
        $scope.loading = true;
        apiFactory.uploadBankStatements({
          bankId: $scope.currentBankId,
          bankStatements: bankStatements
        }).then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message);
          clearLines();
          $scope.fetchData('bankStatement');
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.checkAllItems = function () {
      $scope.bankStatements.forEach(function (item) {
        return item.isChecked = $scope.isAllChecked;
      });
    };

    $scope["delete"] = function () {
      var checkedItems = $scope.bankStatements.filter(function (item) {
        return item.isChecked;
      });
      var query = [];
      checkedItems.forEach(function (item) {
        if (!item.financeItems.length) {
          query.push(apiFactory.deleteBankStatement(item._id));
        }
      });
      $scope.loading = true;
      Promise.all(query).then(function (res) {
        $log.log(res);
        $scope.fetchData('bankStatement');
        Notification.success("BankStatements deleted successfully."); // $scope.loading = false;
      });
    };

    $scope.uploadGenPostData = function () {
      $uibModal.open({
        animation: true,
        component: "financeUploadCSVModal",
        windowClass: "finance-upload-csv-modal",
        backdrop: "static",
        resolve: {
          title: function title() {
            return "Upload an Gen Post Data";
          },
          importType: function importType() {
            return "ExternEconomic";
          }
        }
      }).result.then(function (_data) {
        //console.log(data);
        $uibModal.open({
          animation: true,
          component: "financeUploadGenPostModal",
          windowClass: "finance-upload-entry-modal",
          backdrop: "static",
          resolve: {
            data: function data() {
              return _data;
            },
            accountPlans: function accountPlans() {
              return vm.accountPlans;
            }
          }
        }).result.then(function () {
          $scope.fetchData();
        })["catch"](function () {});
      })["catch"](function () {});
    };

    $scope.uploadExternEconomicData = function () {
      $uibModal.open({
        animation: true,
        component: "financeUploadCSVModal",
        windowClass: "finance-upload-csv-modal",
        backdrop: "static",
        resolve: {
          title: function title() {
            return "Upload an Extern Economic Data";
          },
          importType: function importType() {
            return "ExternEconomic";
          }
        }
      }).result.then(function (data) {
        var trimdata = [];
        data.forEach(function (item) {
          var temp = {
            accountPlanNumber: item.accountPlanNumber.split(' ')[0],
            vendorName: item.vendorName,
            remainingAmount: item.remainingAmount,
            totalAmount: item.totalAmount
          };
          trimdata.push(temp);
        });
        $uibModal.open({
          animation: true,
          component: "financeUploadEntryModal",
          windowClass: "finance-upload-entry-modal",
          backdrop: "static",
          resolve: {
            data: function data() {
              return trimdata;
            },
            accountPlans: function accountPlans() {
              return vm.accountPlans;
            }
          }
        }).result.then(function () {
          $scope.fetchData();
        })["catch"](function () {});
      })["catch"](function () {});
    };

    $scope.uploadFinancePayrolls = function () {
      $uibModal.open({
        animation: true,
        component: "financeUploadCSVModal",
        windowClass: "finance-upload-csv-modal",
        backdrop: "static",
        resolve: {
          title: function title() {
            return "Upload a Payroll CSV File";
          },
          importType: function importType() {
            return "Payroll";
          }
        }
      }).result.then(function (_data2) {
        $uibModal.open({
          animation: true,
          component: "financeUploadPayrollModal",
          windowClass: "finance-upload-payroll-modal",
          backdrop: "static",
          resolve: {
            data: function data() {
              return _data2;
            },
            accountPlans: function accountPlans() {
              return vm.accountPlans;
            },
            bankId: function bankId() {
              return $scope.currentBankId;
            }
          }
        }).result.then(function () {
          $scope.fetchData();
        })["catch"](function () {});
      })["catch"](function () {});
    };

    $scope.selectAllBankStatement = function () {
      if ($scope.allBankStatement.linkStatus === "approved") {
        return;
      }

      $scope.allBankStatement.selected = !$scope.allBankStatement.selected;
    };

    $scope.dropdownClick = function (event) {
      event.stopPropagation();
      event.preventDefault();
    };

    $scope.reverseFinance = function (finance) {
      if (finance.isReverse || finance.reverseId) {
        return;
      }

      if (finance.postingType === 'Payment') {
        $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function data() {
              return {
                title: 'Confirm creating reverse journal',
                message: 'Are you sure create a reverse journal?',
                subMessage: 'Reverse payment journal will be created.',
                confirmButtonText: 'Create',
                icon: '/assets/icons/status-warning.svg'
              };
            }
          }
        }).result.then(function () {
          $scope.loading = true;
          apiFactory.createReversePaymentJournal(finance._id).then(function (res) {
            $scope.loading = false;
            Notification.success(res.data.message);
            $scope.fetchData();
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        })["catch"](function () {});
      } else if (finance.financeType === "FinanceDoc") {
        $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function data() {
              return {
                title: 'Confirm creating reverse finance doc',
                message: 'Are you sure create a reverse finance doc?',
                subMessage: 'Reverse finance doc will be created.',
                confirmButtonText: 'Create',
                icon: '/assets/icons/status-warning.svg'
              };
            }
          }
        }).result.then(function () {
          $scope.loading = true;
          apiFactory.createReverseFinanceDoc(finance._id).then(function (res) {
            $scope.loading = false;
            Notification.success(res.data.message);
            $scope.fetchData();
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        })["catch"](function () {});
      } else if (finance.postingType === 'BankBalance') {
        $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function data() {
              return {
                title: 'Confirm creating reverse bank balance',
                message: 'Are you sure create a reverse bank balance?',
                subMessage: 'Reverse bank balance will be created.',
                confirmButtonText: 'Create',
                icon: '/assets/icons/status-warning.svg'
              };
            }
          }
        }).result.then(function () {
          $scope.loading = true;
          apiFactory.createReverseBankBalance(finance._id).then(function (res) {
            $scope.loading = false;
            Notification.success(res.data.message);
            $scope.fetchData();
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        })["catch"](function () {});
      } else if (finance.postingType === 'BankPost') {
        $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function data() {
              return {
                title: 'Confirm creating reverse bank post',
                message: 'Are you sure create a reverse bank post?',
                subMessage: 'Reverse bank post will be created.',
                confirmButtonText: 'Create',
                icon: '/assets/icons/status-warning.svg'
              };
            }
          }
        }).result.then(function () {
          $scope.loading = true;
          apiFactory.createReverseBankPost(finance._id).then(function (res) {
            $scope.loading = false;
            Notification.success(res.data.message);
            $scope.fetchData();
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        })["catch"](function () {});
      }
    };

    function bankStatementFilter(bankStatement, regex) {
      return bankStatement.bankCode && bankStatement.bankCode.match(regex) || bankStatement.description && bankStatement.description.match(regex) || moment(bankStatement.date).format("dd/MM/yyyy").match(regex) || !!utils.convertNum(bankStatement.amount, 2).match(regex);
    }

    function financeFilter(finance, regex) {
      return finance.bankCode && finance.bankCode.match(regex) || finance.vendorName && finance.vendorName.match(regex) || finance.date && moment(finance.date).format("dd/MM/yyyy").match(regex) || finance.totalAmount && !!utils.convertNum(finance.totalAmount, 2).match(regex) || finance.amount && !!utils.convertNum(finance.amount, 2).match(regex) || finance.billNo && finance.billNo.match(regex) || finance.displaySeq && finance.displaySeq.match(regex) || finance.accountPlan && finance.accountPlan.name.match(regex) || finance.accountPlan && finance.accountPlan.number.match(regex) || finance.vendor && finance.vendor.clientName && finance.vendor.clientName.match(regex) || finance.vendor && finance.vendor.name && finance.vendor.name.match(regex) || finance.vendor && finance.vendor.description && finance.vendor.description.match(regex) || finance.systemTag && finance.systemTag.match(regex);
    }

    function setBankCodeToFinance(finance) {
      finance.bankCodes = [];

      var _iterator7 = _createForOfIteratorHelper(finance.financeItems),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var financeItem = _step7.value;

          if (financeItem.itemType === "BankStatement") {
            finance.bankCodes.push(financeItem.item.bankCode);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      finance.bankCode = finance.bankCodes.join(", ");
    }

    function clearLines() {
      var _iterator8 = _createForOfIteratorHelper(vm.lines),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var line = _step8.value;

          if (line.billLine) {
            var bill = line.bill;
            bill.remainingAmount += bill.financeItems.map(function (x) {
              return x.amount;
            }).reduce(function (acc, cur) {
              return acc + cur;
            }, 0);
          } else if (line.invoiceLine) {
            var invoice = line.invoice;
            invoice.remainingAmount += invoice.financeItems.map(function (x) {
              return x.amount;
            }).reduce(function (acc, cur) {
              return acc + cur;
            }, 0);
          } else {
            var bankStatement = line.bankStatement,
                finance = line.finance;

            if (bankStatement && finance) {
              bankStatement.remainingAmount += bankStatement.financeItems.map(function (x) {
                return x.amount;
              }).reduce(function (acc, cur) {
                return acc + cur;
              }, 0);
              bankStatement.financeItems = [];
              finance.remainingAmount += finance.financeItems.map(function (x) {
                return x.amount;
              }).reduce(function (acc, cur) {
                return acc + cur;
              }, 0);
              finance.financeItems = [];
            }
          }

          vm.leftScrollBox.removeEventListener('scroll', line.listener);
          vm.rightScrollBox.removeEventListener('scroll', line.listener);
          line.remove();
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      vm.lines = [];
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (!toState.redirectTo && !utils.isEmpty(vm.lines)) {
        event.preventDefault();
        clearLines();
        $state.go(toState, toParams);
      }
    });
    $scope.$on('onProjectChanged', function () {
      clearLines();
    });
    $scope.$on("close-finance-doc-panel", function () {
      if (!utils.isEmpty(vm.bankStatementForFinanceDoc)) {
        vm.bankStatementForFinanceDoc.selected = false;
        vm.bankStatementForFinanceDoc.linkStatus = 'none';
        var index = vm.lines.findIndex(function (e) {
          return e.bankStatement._id == vm.bankStatementForFinanceDoc._id;
        });

        if (index != -1) {
          vm.leftScrollBox.removeEventListener('scroll', vm.lines[index].listener);
          vm.rightScrollBox.removeEventListener('scroll', vm.lines[index].listener);
          vm.lines[index].remove();
          vm.lines.splice(index, 1);
        }

        vm.bankStatementForFinanceDoc = undefined;
      }

      if (!utils.isEmpty($scope.needFinanceItem)) {
        $scope.needFinanceItem.selected = false;
        $scope.needFinanceItem.linkStatus = 'none';
        $scope.needFinanceItem = undefined;
      }

      if (!utils.isEmpty($scope.balanceFinanceItem)) {
        $scope.balanceFinanceItem.selected = false;
        $scope.balanceFinanceItem.linkStatus = 'none';

        var _index = vm.lines.findIndex(function (e) {
          return e.finance._id == $scope.balanceFinanceItem._id;
        });

        if (_index != -1) {
          vm.leftScrollBox.removeEventListener('scroll', vm.lines[_index].listener);
          vm.rightScrollBox.removeEventListener('scroll', vm.lines[_index].listener);

          vm.lines[_index].remove();

          vm.lines.splice(_index, 1);
        }

        $scope.balanceFinanceItem = undefined;
      }

      $scope.needBillingMemo = false;
      $scope.needInvoiceMemo = false;
      $scope.allBankStatement.selected = false;
    });
    $scope.$on("clear-lines", function () {
      clearLines();
    });
    $scope.$on("approve-finances", function () {
      $timeout(function () {
        $scope.$apply();
      });

      if (!utils.isEmpty(vm.bankStatementForFinanceDoc)) {
        var index = vm.lines.findIndex(function (e) {
          return e.bankStatement._id == vm.bankStatementForFinanceDoc._id;
        });

        if (index != -1) {
          vm.leftScrollBox.removeEventListener('scroll', vm.lines[index].listener);
          vm.rightScrollBox.removeEventListener('scroll', vm.lines[index].listener);
          vm.lines[index].remove();
          vm.lines.splice(index, 1);
        }
      }

      $scope.approve();
    });
    $scope.$on("fetch-finances", function () {
      $log.info("Received fetch-finances message from the finance doc panel.");

      if (!utils.isEmpty(vm.bankStatementForFinanceDoc)) {
        vm.bankStatementForFinanceDoc.selected = false;
        vm.bankStatementForFinanceDoc = undefined;
      }

      $timeout(function () {
        $scope.$apply();
      });
      $scope.allBankStatement.selected = false;
      $scope.fetchData();
    });

    function loadAccountPlans() {
      $scope.loading = true;
      apiFactory.listAccountPlans().then(function (res) {
        $scope.loading = false;
        vm.accountPlans = res.data.list;
        vm.accountPlans.forEach(function (accountPlan) {
          accountPlan.label = accountPlan.number + ' - ' + accountPlan.name;
        });
        vm.bankAccountPlans = vm.accountPlans.filter(function (x) {
          return x.type === 'Bank' || x.type === 'Cash';
        });
        vm.balanceAccountPlans = vm.accountPlans.filter(function (x) {
          return x.type === 'Balance' || x.type === 'Statement';
        });
        vm.balanceOnlyAccountPlans = vm.accountPlans.filter(function (x) {
          return x.type === 'Balance';
        });
        vm.vatAccountPlans = vm.accountPlans.filter(function (x) {
          return x.type === 'Balance' || x.type === 'Statement';
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    function isElementInView(view, elem) {
      if (elem) {
        var docViewTop = view.offsetTop + view.scrollTop;
        var docViewBottom = docViewTop + view.clientHeight;
        var elemTop = elem.offsetTop;
        var elemBottom = elemTop + elem.clientHeight;
        return elemBottom <= docViewBottom && elemTop >= docViewTop;
      } else {
        return true;
      }
    }

    function handleScroll() {
      var _iterator9 = _createForOfIteratorHelper(vm.lines),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var line = _step9.value;

          if (isElementInView(vm.elStatementsTableBody, line.elBankStatement) && isElementInView(vm.elFinancesTableBody, line.elFinance)) {
            line.show();
          } else {
            line.hide('fade');
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }

    function loadClientsVendors() {
      $scope.loading = true;
      Promise.all([apiFactory.listAllClients(), apiFactory.getAllSuppliers(), apiFactory.getAllSubcontractors()]).then(function (res) {
        $scope.loading = false;
        vm.clients = res[0].data.list || [];
        vm.suppliers = res[1].data.list || [];
        vm.subcontractors = res[2].data.list || [];
        vm.vendors = vm.suppliers.concat(vm.subcontractors);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    function init() {
      var today = new Date();
      var thisYear = today.getFullYear();
      $scope.bankStatementYear = $scope.financeYear = thisYear;
      $scope.selectedMonth = $scope.months[$scope.months.length - 1];

      for (var year = thisYear; year > thisYear - 10; year--) {
        $scope.years.push({
          value: year
        });
      }

      vm.leftScrollBox = $document[0].getElementById('statements-table-body');
      vm.rightScrollBox = $document[0].getElementById('finances-table-body');
      $scope.loading = true;
      Promise.all([apiFactory.getPaymentAccounts(), apiFactory.listAllFinanceDocTemplates()]).then(function (resp) {
        vm.banks = resp[0].data;
        $scope.currentBankId = vm.banks[0] ? vm.banks[0]._id : undefined;
        vm.financeDocTemplates = resp[1].data;
        $scope.fetchData();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
      });
      loadAccountPlans();
      loadClientsVendors();
      vm.elStatementsTableBody = $document[0].getElementById('statements-table-body');
      vm.elStatementsTableBody.addEventListener('scroll', handleScroll, false);
      vm.rectStatementsTableBody = vm.elStatementsTableBody.getBoundingClientRect();
      vm.elFinancesTableBody = $document[0].getElementById('finances-table-body');
      vm.elFinancesTableBody.addEventListener('scroll', handleScroll, false);
      vm.rectFinancesTableBody = vm.elFinancesTableBody.getBoundingClientRect();
    }

    init();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').directive('sortDropdown', sortDropdown);

  function sortDropdown() {
    return {
      restrict: 'E',
      templateUrl: 'app/main/finance/directives/sort-dropdown/sort-dropdown.view.html',
      scope: {
        ngModel: '=',
        options: '=',
        selectEvent: '&'
      },
      link: function link(scope) {
        scope.changeValue = function (value) {
          scope.ngModel = value;
          scope.selectEvent({
            value: value
          });
        };
      }
    };
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function () {
  angular.module("app").directive("financeSelectboxInput", financeSelectboxInput);

  function financeSelectboxInput($timeout) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/main/finance/directives/finance-selectboxinput/finance-selectboxinput.view.html',
      scope: {
        ngModel: "=",
        options: "=",
        labelField: "@",
        valueField: "@",
        placeholder: "@",
        selectEvent: "&",
        onChange: "&",
        changeTrig: '&',
        onClose: "&",
        toTop: "=",
        ngDisabled: "=",
        financeType: '='
      },
      link: function link(scope, element) {
        scope.cOptions = [];
        scope.$watch('ngModel', function (newVal, oldVal) {
          if (scope.ngModel && _typeof(scope.ngModel) == 'object') {
            scope.ngModel = scope.ngModel._id;
          }

          scope.selected = scope.cOptions ? scope.cOptions.find(function (elem) {
            return elem[scope.valueField] === scope.ngModel;
          }) : null;
          scope.onChange({
            value: scope.ngModel
          });

          if (angular.isDefined(oldVal) && angular.isDefined(newVal) && oldVal != newVal) {
            scope.changeTrig({
              value: scope.ngModel
            });
          }
        });

        scope.onSelect = function (item) {
          scope.selectItem(item);
        };

        var expression1 = element.attr("options");
        scope.$parent.$watch(expression1, function (newVal) {
          scope.cOptions = newVal;
          scope.selected = scope.cOptions ? scope.cOptions.find(function (elem) {
            return elem[scope.valueField] === scope.ngModel;
          }) : null;
        });

        scope.selectItem = function (item) {
          scope.ngModel = item[scope.valueField];
          $timeout(function () {
            scope.selectEvent({
              value: scope.ngModel
            });
            scope.onChange({
              value: scope.ngModel
            });
          }, 100);
        };

        scope.clear = function ($event) {
          $event.stopPropagation();
          scope.ngModel = undefined;
          $timeout(function () {
            scope.selectEvent({
              value: scope.ngModel
            });
            scope.onChange({
              value: scope.ngModel
            });
          }, 100);
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('financeMenu', financeMenu);

  function financeMenu($state) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/finance/directives/finance-menu/finance-menu.view.html',
      scope: {},
      link: function link(scope) {
        scope.currentRoute = $state.current.url;

        if (scope.currentRoute.includes('/')) {
          scope.currentRoute = scope.currentRoute.split('/')[2];
        }

        scope.goBillScanner = function () {
          $state.go('billScanner');
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('financeLinkPoint', financeLinkPoint);

  function financeLinkPoint() {
    return {
      restrict: 'E',
      templateUrl: 'app/main/finance/directives/finance-link-point/finance-link-point.view.html',
      replace: true,
      scope: {
        elementId: '@',
        linkStatus: '=',
        isSelected: '=',
        rightDirection: '<',
        selectPoint: '&',
        removeLink: '&'
      },
      link: function link() {}
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('financeExpensePieChart', financeExpensePieChart);

  function financeExpensePieChart($log, utils, $filter) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/finance/directives/finance-expense-pie-chart/finance-expense-pie-chart.view.html',
      replace: true,
      scope: {
        ngModel: '=',
        currency: '='
      },
      link: function link(scope) {
        scope.pieData = [];
        var pieChart = new dhx.Chart("pie-chart", {
          type: "pie",
          series: [{
            value: "value",
            color: "color",
            text: "",
            stroke: "#FFFFFF",
            strokeWidth: 2,
            tooltip: true,
            tooltipTemplate: tooltipPie
          }]
        });
        scope.periods = [// {id: 'project', name: 'Project Period'},
        {
          id: 'month3',
          name: "3 " + $filter('translate')("Months")
        }, {
          id: 'month6',
          name: "6 " + $filter('translate')("Months")
        }, {
          id: 'month12',
          name: "12 " + $filter('translate')("Months")
        }];
        scope.piePeriod = 'month12';
        scope.$watch('ngModel', function (newVal) {
          if (newVal) {
            initData(newVal);
          }
        }); // scope.selectPiePeriod = function (period) {
        // }

        scope.getLegendColor = function (legend) {
          return {
            background: legend.color
          };
        };

        function initData(data) {
          scope.pieData = [];

          if (data.projects) {
            var sheetData = {
              groups: {},
              total: 0
            };
            data.projects.forEach(function (project) {
              if (project.calcSheet) {
                if (data.materials && data.equipments) {
                  arrangeSheetLevel(sheetData, project.calcSheet);
                }
              }
            });
            var groups = [];

            for (var key in sheetData.groups) {
              if (sheetData.groups[key]) {
                groups.push(sheetData.groups[key]);
              }
            }

            groups.sort(function (a, b) {
              return a.price > b.price ? -1 : a.price === b.price ? 0 : 1;
            });
            var Colors = ['#4584E0', '#458499', '#458455', '#458433', '#458411'];
            var sum = 0;

            for (var i = 0; i < groups.length; i++) {
              scope.pieData.push({
                name: groups[i].name,
                value: sheetData.total === 0 ? 1 : groups[i].price / sheetData.total,
                color: Colors[i]
              });
              sum += groups[i].price;
              if (i === 3) break;
            }

            if (groups.length > 4) {
              scope.pieData.push({
                name: 'Others',
                value: (sheetData.total - sum) / sheetData.total,
                color: Colors[4]
              });
            }

            if (scope.pieData.length > 0) {
              pieChart.data.parse(scope.pieData);
            }
          }
        }

        function arrangeSheetLevel(data, level) {
          if (level.levels) {
            level.levels.forEach(function (subLevel) {
              return arrangeSheetLevel(data, subLevel);
            });
          }

          if (level.items) {
            level.items.forEach(function (item) {
              if (item.items && item.items.length > 0) {
                item.items.forEach(function (subItem) {
                  return arrangeSheetItem(data, subItem);
                });
              } else {
                arrangeSheetItem(data, item);
              }
            });
          }
        }

        function arrangeSheetItem(data, item) {
          var materials = scope.ngModel.materials;
          var equipments = scope.ngModel.equipments;
          var inventory;

          if (item.inventoryType === 'Material') {
            inventory = materials.find(function (x) {
              return x._id === item.matID;
            });
          } else if (item.inventoryType === 'Equipment') {
            inventory = equipments.find(function (x) {
              return x._id === item.matID;
            });
          } else {
            inventory = materials.find(function (x) {
              return x._id === item.matID;
            });

            if (!inventory) {
              inventory = equipments.find(function (x) {
                return x._id === item.matID;
              });
            }
          }

          if (inventory) {
            var group = inventory.groupId;

            if (group) {
              var arranged = data.groups[group._id];

              if (!arranged) {
                arranged = {
                  name: group.name,
                  price: 0
                };
                data.groups[group._id] = arranged;
              }

              arranged.price += item.currentSalesPrice;
              data.total += item.currentSalesPrice;
            }
          }
        }

        function tooltipPie(p) {
          return utils.makeReadable(p[0] * 100, 2, utils.isEuropean()) + '%';
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("financeExpenseBarChart", financeExpenseBarChart);

  function financeExpenseBarChart($log, utils, globals, ecoFactory) {
    return {
      restrict: "E",
      templateUrl: "app/main/finance/directives/finance-expense-bar-chart/finance-expense-bar-chart.view.html",
      replace: true,
      scope: {
        revenue: "=",
        ecocash: "=",
        opcosts: "=",
        needRender: "="
      },
      link: function link(scope) {
        scope.year = 2021;
        scope.years = [{
          id: 2020,
          name: 2020
        }, {
          id: 2021,
          name: 2021
        }];
        scope.hasGraphData = false;
        scope.filterData = null;
        scope.total_revenue = 0;
        scope.total_expense = 0;
        var companyStore = globals.companyStore;
        var companyData = companyStore.get();
        var projectStore = globals.projectStore;
        var project = projectStore.get();
        var filterStore = globals.filterStore;
        var graphData = [];

        scope.getDisplayPrice = function (value) {
          if (Math.abs(value) > 1000000) {
            value /= 1000000;
            value = Math.round(value * 100) / 100;
            value += "M";
          } else if (Math.abs(value) > 1000) {
            value /= 1000;
            value = Math.round(value * 100) / 100;
            value += "K";
          }

          return scope.companyCurrency ? scope.companyCurrency.symbol + " " + value : value;
        };

        scope.calcLabourCost = function (payrolls) {
          var cost = 0;
          payrolls.forEach(function (p) {
            var amt = 0;
            var day = new Date(p.date).getDay() - 1;
            if (day < 0) day = 6;

            if (p.userId && p.userId.employeeSettingId) {
              var workingTime = p.userId.employeeSettingId.workingTimes[day];
              var totalTime = ecoFactory.getPayrollTotalHours(p);
              var rate = utils.num(p.userId.salaryAmount);
              var normalTime = Math.min(totalTime, workingTime.dailyHours);
              var overTime = totalTime - normalTime;
              amt += rate * normalTime;

              if (overTime > 0) {
                var fullOverTime = 0;
                var halfOverTime = 0;
                var fullPercent = 0;
                var halfPercent = 0;

                if (workingTime.overTime.split(";").length == 1) {
                  fullOverTime = overTime;
                  fullPercent = parseFloat(workingTime.overTime.split("+")[1]);
                } else {
                  halfOverTime = Math.min(parseFloat(workingTime.overTime.split(";")[0].split("+")[0]), overTime);
                  halfPercent = parseFloat(workingTime.overTime.split(";")[0].split("+")[1]);
                  fullOverTime = Math.min(parseFloat(workingTime.overTime.split(";")[1].split("+")[0]), overTime - halfOverTime);
                  fullPercent = parseFloat(workingTime.overTime.split(";")[1].split("+")[1]);
                }

                amt += rate * (fullOverTime * fullPercent + halfOverTime * halfPercent) / 100;
              }

              cost += amt;
              cost += amt * p.userId.employeeSettingId.employeePaidPension / 100;
              cost += amt * p.userId.employeeSettingId.holidayPay / 100;
              cost += amt * p.userId.employeeSettingId.additionalCosts[0].cost / 100;
              cost += amt * p.userId.employeeSettingId.additionalCosts[1].cost / 100;
            }
          });
          return cost;
        };

        scope.onSelectYear = function (type) {
          scope.type = type;
          scope.isLoading = false;
          graphData = []; // let graphBase = prepareGraphBase(type);
          // graphBase = graphBase.sort((a, b) => {
          //   return a.begin - b.begin;
          // });

          var data = scope.ecocash;

          if (data) {
            (function () {
              scope.cash = {
                totalCompanyCost: 0,
                totalWorkerCost: 0,
                totalInventoryCost: 0,
                totalSalesPrice: 0,
                totalProfit: 0
              };
              var projects = data.projects;
              projects.forEach(function (project) {
                var cash = ecoFactory.getProjectEconomicValue(project, data.invoices, data.billings, data.payrolls, data.vaOrders, companyData.companyCost);
                var operatingCost = utils.num(cash.totalCompanyCost);
                var labour = utils.num(cash.calcSheet.totalWorkerNegative);
                var inventory = utils.num(cash.calcSheet.totalInventoryNegative);
                var salesPrice = utils.num(cash.calcSheet.sumWithAdditionalCost);
                scope.cash.totalCompanyCost += operatingCost;
                scope.cash.totalWorkerCost += labour;
                scope.cash.totalInventoryCost += inventory;
                scope.cash.totalSalesPrice += salesPrice;
                var profit = salesPrice - operatingCost - labour - inventory - salesPrice;
                scope.cash.totalProfit += profit;
              });
              var revenue = scope.revenue;
              var allWorkingDays = 0;

              if (revenue) {
                if (project._id != "all") {
                  revenue = revenue.filter(function (r) {
                    return r.project == project._id;
                  });
                }

                revenue.forEach(function (r) {
                  var startDate = new Date(r.startDate);
                  var endDate = new Date(r.endDate);
                  r.workingDays = 0;
                  var workingDays = (endDate.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000);

                  if (!isNaN(workingDays) && workingDays > 0) {
                    r.workingDays = workingDays;
                    allWorkingDays += workingDays;
                  }
                });
              }

              var invoiceValues = [];
              var expenseValues = [];
              var opcostValues = [];
              var labourValues = [];

              var _loop = function _loop(i) {
                invoiceValues.push({
                  x: i,
                  y: 0
                });
                expenseValues.push({
                  x: i,
                  y: 0
                });
                var prog = 0;
                var mEnd = new Date(scope.year, i, 1);
                var days = mEnd.getDaysInMonth();
                mEnd.setDate(days);

                if (revenue) {
                  revenue.forEach(function (r) {
                    if (r.workingDays > 0) {
                      var startDate = new Date(r.startDate);
                      var endDate = new Date(r.endDate);

                      if (mEnd >= startDate && mEnd <= endDate) {
                        prog = utils.progressOfDate(startDate, endDate, mEnd, true);
                        prog = prog * r.workingDays / allWorkingDays;
                      } else if (mEnd > endDate) {
                        prog = r.workingDays / allWorkingDays;
                      }
                    }
                  });
                }

                if (scope.opcosts) {
                  var opcost = scope.opcosts.find(function (x) {
                    return x.key == "".concat(scope.year, "-").concat(i + 1);
                  });

                  if (opcost) {
                    opcostValues.push({
                      x: i,
                      y: prog * scope.cash.totalSalesPrice * opcost.val / 100
                    });
                  } else {
                    opcostValues.push({
                      x: i,
                      y: 0
                    });
                  }
                } else {
                  opcostValues.push({
                    x: i,
                    y: 0
                  });
                }

                var payrolls = data.payrolls.filter(function (p) {
                  var date = new Date(p.date);

                  if (date.getFullYear() == scope.year) {
                    var m = date.getMonth();
                    if (m == i) return true;
                  }

                  return false;
                });
                var labourAmt = scope.calcLabourCost(payrolls);
                labourValues.push({
                  x: i,
                  y: labourAmt
                });
              };

              for (var i = 0; i < 12; i++) {
                _loop(i);
              }

              if (scope.revenue) {// scope.revenue.forEach((r) => {
                // let prog = 0;
                // if (r.workingDays > 0) {
                //   let today = new Date(base.end)
                //   let startDate = new Date(r.startDate)
                //   let endDate = new Date(r.endDate)
                //   prog = utils.progressOfDate(startDate, endDate, today, true)
                //   prog = prog * r.workingDays / allWorkingDays;
                // }
                // });
              }

              data.invoices.forEach(function (x) {
                var date = new Date(x.date);

                if (date.getFullYear() == scope.year) {
                  var m = date.getMonth();
                  if (x.isCreditMemo) invoiceValues[m].y -= x.totalPrice;else invoiceValues[m].y += x.totalPrice;
                }
              });
              data.billings.forEach(function (x) {
                var date = new Date(x.billDate);

                if (date.getFullYear() == scope.year) {
                  var m = date.getMonth();
                  if (x.isMemo) expenseValues[m].y -= x.amountWithoutTax;else expenseValues[m].y += x.amountWithoutTax;
                }
              });
              graphData.push({
                values: invoiceValues,
                color: "#F3A72E",
                key: "Revenue"
              });
              graphData.push({
                values: expenseValues,
                color: "#6082DE",
                key: "Expenses"
              });
              graphData.push({
                values: opcostValues,
                color: "#79C7F7",
                key: "Operating Cost"
              });
              graphData.push({
                values: labourValues,
                color: "#3DD598",
                key: "Labour Cost"
              });
            })();
          }

          scope.hasGraphData = true;
          drawGraph();
        };

        scope.$on("onFilterChanged", function () {
          scope.filterData = filterStore.get();

          if (scope.filterData) {
            scope.onSelectYear("custom");
          }
        }); // function prepareGraphBase(type) {
        //   return [
        //     { key: 0, val: "Jan" },
        //     { key: 1, val: "Feb" },
        //     { key: 2, val: "Mar" },
        //     { key: 3, val: "Apr" },
        //     { key: 4, val: "May" },
        //     { key: 5, val: "Jun" },
        //     { key: 6, val: "Jul" },
        //     { key: 7, val: "Aug" },
        //     { key: 8, val: "Sep" },
        //     { key: 9, val: "Oct" },
        //     { key: 10, val: "Nov" },
        //     { key: 11, val: "Dec" },
        //   ];
        // }

        function getMonthString(d) {
          switch (d) {
            case 0:
              return "Jan";

            case 1:
              return "Feb";

            case 2:
              return "Mar";

            case 3:
              return "Apr";

            case 4:
              return "May";

            case 5:
              return "Jun";

            case 6:
              return "Jul";

            case 7:
              return "Aug";

            case 8:
              return "Sep";

            case 9:
              return "Oct";

            case 10:
              return "Nov";

            case 11:
              return "Dec";

            default:
              return "";
          }
        }

        function drawGraph() {
          nv.addGraph(function () {
            var chart = nv.models.multiBarChart().useInteractiveGuideline(true).reduceXTicks(false).showControls(false).legendPosition("bottom").showYAxis(true).showXAxis(true);
            chart.legend.align("center");
            chart.groupSpacing(0.355);
            chart.xAxis.tickFormat(function (d) {
              return getMonthString(d);
            });
            chart.yAxis.tickFormat(function (v) {
              return scope.getDisplayPrice(v);
            });
            d3.select("#eco-bar-chart svg").html("");
            d3.select("#eco-bar-chart svg").attr("height", 370).datum(graphData).call(chart);
            var legendContainer = d3.select("#eco-bar-chart .nv-legendWrap");

            if (legendContainer[0][0]) {
              var containerWidth = d3.select("#eco-bar-chart").node().getBoundingClientRect().width;
              var legendWidth = legendContainer.node().getBoundingClientRect().width;
              d3.select("#eco-bar-chart .nv-legendWrap").style("transform", "translate(".concat(legendWidth / 2 - containerWidth / 2 + 50, "px, 310px)"));
            }

            nv.utils.windowResize(function () {
              chart.update();
            });
            return chart;
          });
        }

        scope.$watchGroup(["needRender"], function (newVals) {
          if (newVals) {
            scope.onSelectYear(scope.type);
          }
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('financeDocPanel', financeDocPanel);

  function financeDocPanel(globals, $rootScope, utils, Notification, $log, apiFactory, $timeout) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/finance/directives/finance-doc-panel/finance-doc-panel.view.html',
      scope: {
        bankStatement: '=',
        templateList: "=",
        allBankStatement: "=",
        needFinanceItem: "=",
        balanceFinanceItem: "=",
        needBillItem: "=",
        needInvoiceItem: "=",
        needMemoItem: "=",
        accountPlan: "=",
        amount: "=",
        balancePlans: "=",
        clients: "=",
        vendors: "="
      },
      link: function link(scope) {
        scope.utils = utils;
        scope.description = "";
        scope.companyData = globals.companyStore.get();
        scope.type = "";
        scope.templateId = "";
        scope.accountPlanId = "";
        scope.typeList = [];
        scope.balancePlans.forEach(function (x) {
          x.label = "".concat(x.number, " - ").concat(x.name);
        });

        if (scope.bankStatement) {
          scope.type = "fastTrack";
          scope.typeList = [{
            name: "Client",
            value: "client"
          }, {
            name: "Vendor",
            value: "vendor"
          }, {
            name: "Fast Track",
            value: "fastTrack"
          }, {
            name: "Balance",
            value: "balance"
          }];
        } else if (scope.allBankStatement) {
          scope.type = "fastTrack";
          scope.typeList = [{
            name: "Client",
            value: "client"
          }, {
            name: "Vendor",
            value: "vendor"
          }, {
            name: "Fast Track",
            value: "fastTrack"
          }, {
            name: "Balance",
            value: "balance"
          }];
        } else if (scope.needFinanceItem) {
          scope.type = "fastTrack";
          scope.typeList = [{
            name: "Client",
            value: "client"
          }, {
            name: "Vendor",
            value: "vendor"
          }, {
            name: "Fast Track",
            value: "fastTrack"
          }, {
            name: "Balance",
            value: "balance"
          }];
        } else if (scope.needBillItem && scope.needMemoItem) {
          scope.type = "post";
          scope.typeList = [{
            name: "Post",
            value: "post"
          }, {
            name: "Balance",
            value: "balance"
          }];
        } else if (scope.needInvoiceItem && scope.needMemoItem) {
          scope.type = "post";
          scope.typeList = [{
            name: "Post",
            value: "post"
          }, {
            name: "Balance",
            value: "balance"
          }];
        } else if (scope.balanceFinanceItem) {
          scope.type = "balance";
          scope.typeList = [{
            name: "Post",
            value: "post"
          }, {
            name: "Balance",
            value: "balance"
          }];
        }

        scope.close = function () {
          $rootScope.$broadcast("close-finance-doc-panel");
        };

        scope.changeBalance = function () {
          $log.log(scope.balancePlans);
          $log.log(scope.accountPlanId);
        };

        scope.changeTemplate = function () {
          $log.log(scope.templateId);
          scope.template = scope.templateList.find(function (x) {
            return x._id === scope.templateId;
          });

          if (scope.template) {
            scope.description = scope.template.description;
            $timeout(function () {
              scope.$apply();
            });
          }
        };

        scope.fileUpdated = function (files) {
          if (files && files.length) {
            scope.file = files[0];
            scope.fileObjectUrl = URL.createObjectURL(scope.file);
          }
        };

        function createFinanceDoc() {
          if (utils.isEmpty(scope.template)) {
            Notification.error("Please select a template");
            return;
          }

          if (!scope.template.vatAccountPlan || !scope.template.vatAccountPlan2) {
            Notification.error("Please select vat account plans for the template.");
            return;
          }

          scope.loading = true;
          apiFactory.createFinanceDoc({
            templateId: scope.template._id,
            description: scope.description,
            totalAmount: scope.bankStatement.remainingAmount,
            date: scope.bankStatement.date,
            file: scope.file,
            finance: scope.bankStatement._id,
            financeType: scope.bankStatement.financeType,
            financeItems: [{
              item: scope.bankStatement._id,
              itemType: "BankStatement",
              amount: scope.bankStatement.remainingAmount
            }]
          }).then(function (res) {
            scope.loading = false;
            Notification.success(res.data.message);
            scope.close();
            $rootScope.$broadcast('approve-finances');
          })["catch"](function (err) {
            scope.loading = false;
            $log.error(err);
            Notification.error("Failed to create finance doc");
          });
        }

        function createFinanceDocsMany() {
          if (utils.isEmpty(scope.template)) {
            Notification.error("Please select a template");
            return;
          }

          if (!scope.template.vatAccountPlan || !scope.template.vatAccountPlan2) {
            Notification.error("Please select vat account plans for the template.");
            return;
          }

          var list = scope.allBankStatement.bankStatements.map(function (bankStatement) {
            return {
              templateId: scope.template._id,
              description: scope.description,
              totalAmount: bankStatement.amount,
              date: bankStatement.date,
              file: scope.file,
              finance: bankStatement._id,
              financeType: bankStatement.financeType,
              financeItems: [{
                item: bankStatement._id,
                itemType: "BankStatement",
                amount: bankStatement.remainingAmount
              }]
            };
          });

          if (!utils.isEmpty(list)) {
            scope.loading = true;
            apiFactory.createFinanceDocsMany({
              list: list,
              file: scope.file
            }).then(function (res) {
              scope.loading = false;
              Notification.success(res.data.message);
              scope.close();
              $rootScope.$broadcast('approve-finances');
            })["catch"](function (err) {
              scope.loading = false;
              $log.error(err);
              Notification.error("Failed to create finance doc");
            });
          } else {
            Notification.error("Failed to create finance documents");
          }
        }

        function createFinanceDocFromNeedFinance(finance) {
          if (utils.isEmpty(scope.template)) {
            Notification.error("Please select a template");
            return;
          }

          scope.loading = true;
          apiFactory.createFinanceDoc({
            templateId: scope.template._id,
            description: scope.description,
            totalAmount: finance.remainingAmount,
            date: finance.date || finance.billDate,
            file: scope.file,
            finance: finance._id,
            financeType: finance.financeType
          }).then(function (res) {
            scope.loading = false;
            Notification.success(res.data.message);
            scope.close();
            $rootScope.$broadcast('approve-finances');
          })["catch"](function (err) {
            scope.loading = false;
            $log.error(err);
            Notification.error("Failed to create finance doc");
          });
        }

        function createPostJournalForBilling() {
          if (!scope.needBillItem.vendor || !scope.needMemoItem.vendor) {
            scope.close();
            Notification.error("Finance Items has not vendor");
            $rootScope.$broadcast('fetch-finances');
            return;
          }

          if (scope.needBillItem.vendor._id != scope.needMemoItem.vendor._id) {
            scope.close();
            Notification.error("Bill and memo's vendor is different");
            $rootScope.$broadcast('fetch-finances');
            return;
          }

          var billJournal = {
            date: scope.needMemoItem.billDate || scope.needBillItem.billDate || new Date(),
            vendor: scope.needBillItem.vendor ? scope.needBillItem.vendor._id : null,
            vendorType: scope.needBillItem.vendorType,
            finance: scope.needBillItem._id,
            financeType: scope.needBillItem.financeType,
            amount: scope.amount * -1,
            accountPlan: scope.needBillItem.accountPlan.vatType.postingAccountCredit
          };
          var memoJournal = {
            date: scope.needMemoItem.billDate || scope.needBillItem.billDate || new Date(),
            vendor: scope.needMemoItem.vendor ? scope.needMemoItem.vendor._id : null,
            vendorType: scope.needMemoItem.vendorType,
            finance: scope.needMemoItem._id,
            financeType: scope.needMemoItem.financeType,
            amount: scope.amount,
            accountPlan: scope.needMemoItem.accountPlan.vatType.postingAccountCredit
          };
          scope.loading = true;
          apiFactory.createPostJournal({
            finance: billJournal,
            memo: memoJournal
          }).then(function (res) {
            scope.loading = false;
            Notification.success(res.data.message);
            scope.close();
            $rootScope.$broadcast('approve-finances');
          })["catch"](function (err) {
            scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }

        function createPostJournalForInvoice() {
          if (!scope.needInvoiceItem.vendor || !scope.needMemoItem.vendor) {
            scope.close();
            Notification.error("Finance Items has not vendor");
            $rootScope.$broadcast('fetch-finances');
            return;
          }

          if (scope.needInvoiceItem.vendor._id != scope.needMemoItem.vendor._id) {
            scope.close();
            Notification.error("Invoice and memo's vendor is different");
            $rootScope.$broadcast('fetch-finances');
            return;
          }

          var invoiceJournal = {
            date: scope.needMemoItem.date || scope.needInvoiceItem.date || new Date(),
            vendor: scope.needInvoiceItem.vendor ? scope.needInvoiceItem.vendor._id : null,
            vendorType: scope.needInvoiceItem.vendorType,
            finance: scope.needInvoiceItem._id,
            financeType: scope.needInvoiceItem.financeType,
            amount: scope.amount,
            accountPlan: scope.needInvoiceItem.accountPlan.vatType.postingAccountDebit
          };
          var memoJournal = {
            date: scope.needMemoItem.date || scope.needInvoiceItem.date || new Date(),
            vendor: scope.needMemoItem.vendor ? scope.needMemoItem.vendor._id : null,
            vendorType: scope.needMemoItem.vendorType,
            finance: scope.needMemoItem._id,
            financeType: scope.needMemoItem.financeType,
            amount: scope.amount * -1,
            accountPlan: scope.needMemoItem.accountPlan.vatType.postingAccountDebit
          };
          scope.loading = true;
          apiFactory.createPostJournal({
            finance: invoiceJournal,
            memo: memoJournal
          }).then(function (res) {
            scope.loading = false;
            Notification.success(res.data.message);
            scope.close();
            $rootScope.$broadcast('approve-finances');
          })["catch"](function (err) {
            scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }

        function createBankPost() {
          if (scope.type == "client" && !scope.clientId) {
            Notification.error("Please select client.");
            return;
          }

          if (scope.type == "vendor" && !scope.vendorId) {
            Notification.error("Please select client.");
            return;
          }

          scope.loading = true;
          apiFactory.createBankPost({
            date: scope.bankStatement.date,
            vendor: scope.type == "client" ? scope.clientId : scope.vendorId,
            vendorType: scope.type == "client" ? "Client" : "Supplier",
            description: scope.description,
            amount: scope.bankStatement.remainingAmount,
            bankStatementId: scope.bankStatement,
            accountPlan: scope.accountPlan
          }).then(function (res) {
            scope.loading = false;
            Notification.success(res.data.message);
            scope.close();
            $rootScope.$broadcast('approve-finances');
          })["catch"](function (err) {
            scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }

        function createBankBalance() {
          if (!scope.accountPlanId) {
            Notification.error("Please select account plan.");
            return;
          }

          scope.loading = true;
          apiFactory.createBankBalance({
            date: scope.bankStatement.date,
            description: scope.description,
            amount: scope.bankStatement.remainingAmount,
            bankStatementId: scope.bankStatement,
            accountPlan: scope.accountPlan,
            balanceAccountPlan: scope.accountPlanId
          }).then(function (res) {
            scope.loading = false;
            Notification.success(res.data.message);
            scope.close();
            $rootScope.$broadcast('approve-finances');
          })["catch"](function (err) {
            scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }

        function createFinanceBalance() {
          if (!scope.accountPlanId) {
            Notification.error("Please select account plan.");
            return;
          }

          scope.loading = true;
          apiFactory.createFinanceBalance({
            accountPlanId: scope.accountPlanId,
            description: scope.description,
            totalAmount: Math.abs(scope.balanceFinanceItem.remainingAmount),
            date: scope.balanceFinanceItem.date || scope.balanceFinanceItem.billDate,
            finance: scope.balanceFinanceItem._id,
            financeType: scope.balanceFinanceItem.financeType
          }).then(function (res) {
            scope.loading = false;
            Notification.success(res.data.message);
            scope.close();
            $rootScope.$broadcast('approve-finances');
          })["catch"](function (err) {
            scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }

        scope.save = function () {
          if (scope.bankStatement && scope.type == "fastTrack") {
            createFinanceDoc();
          } else if (scope.bankStatement && scope.type == "client") {
            createBankPost();
          } else if (scope.bankStatement && scope.type == "vendor") {
            createBankPost();
          } else if (scope.bankStatement && scope.type == "balance") {
            createBankBalance();
          } else if (scope.allBankStatement && scope.type == "fastTrack") {
            createFinanceDocsMany();
          } else if (scope.needFinanceItem && scope.type == "fastTrack") {
            createFinanceDocFromNeedFinance(scope.needFinanceItem);
          } else if (scope.needBillItem && scope.needMemoItem && scope.type == "post") {
            createPostJournalForBilling();
          } else if (scope.needInvoiceItem && scope.needMemoItem && scope.type == "post") {
            createPostJournalForInvoice();
          } else if (scope.balanceFinanceItem && scope.type == "balance") {
            createFinanceBalance();
          }
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("financeCashflow", financeCashflow);

  function financeCashflow($log, globals, $filter) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: "app/main/finance/directives/finance-cashflow/finance-cashflow.view.html",
      scope: {
        revenue: "=",
        ecocash: "=",
        opcosts: "=",
        needRender: "=",
        duration: "=",
        graphdata: "=",
        startDate: "=",
        endDate: "="
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.type = "custom";
      scope.start = new Date().getTime();
      scope.end = scope.start;
      scope.hasGraphData = false;
      scope.filterData = null;
      scope.cash = {};
      scope.incoming = 0;
      scope.outgoing = 0;
      scope.expOpcostGraphData = [];
      scope.expLaborGraphData = [];
      scope.expRevenueGraphData = [];
      scope.expExpenseGraphData = [];
      scope.expCashGraphData = [];
      scope.expAllGraphData = [];
      scope.opCostGraphData = [];
      scope.cashGraphData = [];
      scope.revenueGraphData = [];
      scope.expenseGraphData = [];
      scope.labourGraphData = [];
      scope.allGraphData = [];
      var filterStore = globals.filterStore;
      var graphData = [];

      scope.getDisplayPrice = function (value) {
        if (Math.abs(value) > 1000000) {
          value /= 1000000;
          value = Math.round(value * 100) / 100;
          value += "M";
        } else if (Math.abs(value) > 1000) {
          value /= 1000;
          value = Math.round(value * 100) / 100;
          value += "K";
        }

        return scope.companyCurrency ? scope.companyCurrency.symbol + " " + value : value;
      };

      scope.buildGraphData = function () {
        if (scope.graphdata) {
          scope.expOpcostGraphData = scope.graphdata.expOpcostGraphData;
          scope.expLaborGraphData = scope.graphdata.expLaborGraphData;
          scope.expRevenueGraphData = scope.graphdata.expRevenueGraphData;
          scope.expExpenseGraphData = scope.graphdata.expExpenseGraphData;
          scope.expCashGraphData = scope.graphdata.expCashGraphData;
          scope.expAllGraphData = scope.graphdata.expAllGraphData;
          scope.opCostGraphData = scope.graphdata.opCostGraphData;
          scope.cashGraphData = scope.graphdata.cashGraphData;
          scope.revenueGraphData = scope.graphdata.revenueGraphData;
          scope.expenseGraphData = scope.graphdata.expenseGraphData;
          scope.labourGraphData = scope.graphdata.labourGraphData;
          scope.allGraphData = scope.graphdata.allGraphData;
          scope.expOpcostGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.expLaborGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.expRevenueGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.expExpenseGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.expCashGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.expAllGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.opCostGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.cashGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.revenueGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.expenseGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.labourGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.allGraphData.forEach(function (x) {
            x.x = new Date(x.x);
          });
          scope.start = Math.min.apply(Math, scope.allGraphData.map(function (x) {
            return x.x;
          }));
          scope.end = Math.max.apply(Math, scope.allGraphData.map(function (x) {
            return x.x;
          }));
        }
      };

      scope.onSelectType = function (type) {
        scope.type = type;
        graphData = [];
        var graphBase = prepareGraphBase(type);
        graphBase = graphBase.sort(function (a, b) {
          return a.begin - b.begin;
        });
        var baseGraphData = [];
        var graphStart = new Date();
        var graphEnd = new Date();

        for (var i = 0; i < graphBase.length; i++) {
          var base = graphBase[i];
          var value = 0;
          baseGraphData.push({
            x: base.end,
            y: value
          });
          if (graphStart > new Date(base.begin)) graphStart = new Date(base.begin);
          if (graphEnd < new Date(base.end)) graphEnd = new Date(base.end);
        }

        graphData.push({
          values: baseGraphData,
          color: "transparent",
          classed: "dashed"
        });
        var expRevenueGraphData = scope.expRevenueGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        var revenueGraphData = scope.revenueGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        var expExpenseGraphData = scope.expExpenseGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        var expenseGraphData = scope.expenseGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        var expOpcostGraphData = scope.expOpcostGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        var opCostGraphData = scope.opCostGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        var expLaborGraphData = scope.expLaborGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        var labourGraphData = scope.labourGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        var expCashGraphData = scope.expCashGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        var cashGraphData = scope.cashGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        var expAllGraphData = scope.expAllGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        var allGraphData = scope.allGraphData.filter(function (x) {
          return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
        });
        graphData.push({
          values: expRevenueGraphData,
          key: $filter('translate')("Revenue") + $filter('translate')("(Forecast)"),
          color: "#FFBC25",
          classed: "dotted thin"
        });
        graphData.push({
          values: revenueGraphData,
          key: $filter('translate')("Revenue"),
          color: "#FFBC25",
          classed: "thin"
        });
        graphData.push({
          values: expExpenseGraphData,
          key: $filter('translate')("Expense") + $filter('translate')("(Forecast)"),
          color: "#6082DE",
          classed: "dotted thin"
        });
        graphData.push({
          values: expenseGraphData,
          key: $filter('translate')("Expense"),
          color: "#6082DE",
          classed: "thin"
        });
        graphData.push({
          values: expOpcostGraphData,
          key: $filter('translate')("Opr. Cost") + $filter('translate')("(Forecast)"),
          color: "#79C7F7",
          classed: "dotted thin"
        });
        graphData.push({
          values: opCostGraphData,
          key: $filter('translate')("Opr. Cost"),
          color: "#79C7F7",
          classed: "thin"
        });
        graphData.push({
          values: expLaborGraphData,
          key: $filter('translate')("Labour") + $filter('translate')("(Forecast)"),
          color: "#3DD598",
          classed: "dotted thin"
        });
        graphData.push({
          values: labourGraphData,
          key: $filter('translate')("Labour"),
          color: "#3DD598",
          classed: "thin"
        });
        graphData.push({
          values: expCashGraphData,
          key: $filter('translate')("Cash Flow") + $filter('translate')("(Forecast)"),
          color: "#D71414",
          classed: "dotted bolded"
        });
        graphData.push({
          values: cashGraphData,
          key: $filter('translate')("Cash Flow"),
          color: "#D71414",
          classed: "bolded"
        });
        graphData.push({
          values: expAllGraphData,
          key: $filter('translate')("All Cost") + $filter('translate')("(Forecast)"),
          color: "#30427E",
          classed: "dotted bolded"
        });
        graphData.push({
          values: allGraphData,
          key: $filter('translate')("All Cost"),
          color: "#30427E",
          classed: "bolded"
        });
        scope.hasGraphData = true;
        drawGraph();
      };

      scope.$on("onFilterChanged", function () {
        scope.filterData = filterStore.get();

        if (scope.filterData) {
          scope.onSelectType("custom");
        }
      });

      function prepareGraphBase(type) {
        var baseData = []; // let now = new Date(scope.start + (scope.end - scope.start) / 2);

        var now = new Date();

        if (type === "week") {
          var begin = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
          var end = now;

          for (var i = 0; i < 7; i++) {
            baseData.unshift({
              index: i,
              begin: new Date(begin),
              end: new Date(end),
              label: moment(begin).format("M-D")
            });
            end.setTime(begin.getTime() - 1);
            begin.setTime(begin.getTime() - 24 * 3600000);
          } // now = new Date(scope.start + (scope.end - scope.start) / 2);


          now = new Date();
          begin = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
          end = now;

          for (var _i = 0; _i <= 7; _i++) {
            baseData.push({
              index: _i + 7,
              begin: new Date(begin),
              end: new Date(end),
              label: moment(begin).format("M-D")
            });
            end.setTime(begin.getTime() + 1000);
            begin.setTime(begin.getTime() + 24 * 3600000);
          }
        } else if (type === "month") {
          var _begin = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);

          var _end = now;

          for (var _i2 = 0; _i2 < 30; _i2++) {
            baseData.push({
              index: _i2 + 30,
              begin: new Date(_begin),
              end: new Date(_end),
              label: moment(_begin).format("M-D")
            });

            _begin.setTime(_begin.getTime() + 24 * 3600000);

            _end.setTime(_begin.getTime() + 1000);
          } // now = new Date(scope.start + (scope.end - scope.start) / 2);


          now = new Date();
          _begin = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
          _end = now;

          for (var _i3 = 0; _i3 < 30; _i3++) {
            _end.setTime(_begin.getTime() - 1000);

            _begin.setTime(_begin.getTime() - 24 * 3600000);

            baseData.unshift({
              index: _i3,
              begin: new Date(_begin),
              end: new Date(_end),
              label: moment(_begin).format("M-D")
            });
          }
        } else if (type == "year") {
          var _begin2 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);

          var _end2 = now;

          for (var _i4 = 0; _i4 < 365; _i4++) {
            baseData.push({
              index: _i4 + 365,
              begin: new Date(_begin2),
              end: new Date(_end2),
              label: moment(_begin2).format("M-D")
            });

            _begin2.setTime(_begin2.getTime() + 24 * 3600000);

            _end2.setTime(_begin2.getTime() + 1000);
          } // now = new Date(scope.start + (scope.end - scope.start) / 2);


          now = new Date();
          _begin2 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
          _end2 = now;

          for (var _i5 = 0; _i5 < 365; _i5++) {
            _end2.setTime(_begin2.getTime() - 1000);

            _begin2.setTime(_begin2.getTime() - 24 * 3600000);

            baseData.unshift({
              index: _i5,
              begin: new Date(_begin2),
              end: new Date(_end2),
              label: moment(_begin2).format("M-D")
            });
          }
        } else if (type == "custom") {
          var _now = new Date(scope.startDate);

          var _begin3 = new Date(_now.getFullYear(), _now.getMonth(), _now.getDate(), 0, 0, 0);

          var _end3 = _now;

          _end3.setTime(_now.getTime() + 3600000 * 23.99);

          var idx = 0;

          while (_begin3 < new Date(scope.endDate)) {
            baseData.push({
              index: idx,
              begin: new Date(_begin3),
              end: new Date(_end3),
              label: moment(_begin3).format("M-D")
            });
            idx++;

            _begin3.setTime(_begin3.getTime() + 24 * 3600000);

            _end3.setTime(_begin3.getTime() + 3600000 * 23.99);
          }

          _begin3.setTime(_begin3.getTime() + 24 * 3600000);

          _end3.setTime(_begin3.getTime() + 3600000 * 23.99);

          baseData.push({
            index: idx,
            begin: new Date(_begin3),
            end: new Date(_end3),
            label: moment(_begin3).format("M-D")
          });
        }

        return baseData;
      }

      function drawGraph() {
        $log.log(graphData);
        $log.log(scope.graphdata);
        nv.addGraph(function () {
          var chart = nv.models.lineChart().margin({
            left: 30,
            right: 10
          }).useInteractiveGuideline(true).showLegend(true).showYAxis(true).showXAxis(true);
          chart.xTickFormat(function (d) {
            return moment(d).format("Y-M-D");
          });
          chart.yTickFormat(function (v) {
            return scope.getDisplayPrice(v);
          });
          d3.select("#eco-line-chart svg").html("");
          d3.select("#eco-line-chart svg").attr("height", 400).datum(graphData).call(chart);
          var linearGrad = d3.select("#eco-line-chart svg").append("linearGradient");
          linearGrad.attr("id", "grad3");
          linearGrad.attr("x1", "0%");
          linearGrad.attr("y1", "0%");
          linearGrad.attr("x2", "0%");
          linearGrad.attr("y2", "100%");
          linearGrad.html('<stop offset="0%" style="stop-color:#2FA84F;stop-opacity:1"/>' + '<stop offset="100%" style="stop-color:#ffffff;stop-opacity:0"/>'); // if (scope.type != "custom") {
          //   let axisContainer = d3.select(
          //     "#eco-line-chart svg .nv-background rect"
          //   );
          //   let rect = axisContainer.node().getBoundingClientRect();
          //   let width = rect.width / 2;
          //   d3.select("#eco-line-chart svg .nv-background")
          //     .append("g")
          //     .append("line")
          //     .attr("x1", width)
          //     .attr("y1", rect.height)
          //     .attr("x2", width)
          //     .attr("y2", 0)
          //     .style("stroke-width", 2)
          //     .style("stroke", "#1da1f2")
          //     .style("fill", "black");
          //   d3.select("#eco-line-chart svg .nv-background")
          //     .append("rect")
          //     .attr("x", 0)
          //     .attr("y", 0)
          //     .attr("width", width)
          //     .attr("height", rect.height)
          //     .attr("fill", "#f2f2f2");
          //   d3.select("#eco-line-chart svg .nv-background")
          //     .append("text")
          //     .attr("x", width + 5)
          //     .attr("y", 5)
          //     .attr("dy", "1em")
          //     .text("Today")
          //     .style("fill", "#1da1f2");
          // }

          nv.utils.windowResize(function () {
            chart.update();
          });
          return chart;
        });
      }

      scope.$watchGroup(["needRender"], function (newVals) {
        if (newVals) {
          scope.buildGraphData();
          scope.onSelectType(scope.type);
        }
      });
      scope.$watchGroup(["graphdata"], function (newVals, oldVals) {
        if (newVals != oldVals) {
          scope.buildGraphData();
          scope.onSelectType(scope.type);
        }
      });
    }
  }
})();


"use strict";

(function () {
  angular.module('app').directive('financeCard', financeCard);

  function financeCard() {
    return {
      restrict: 'E',
      templateUrl: 'app/main/finance/directives/finance-card/finance-card.view.html',
      replace: true,
      scope: {
        type: '<',
        ngModel: '=',
        currency: '='
      },
      link: function link(scope) {
        scope.totalUnpaidInvoices = 0;
        scope.totalUnpaidBills = 0;
        scope.totalInvoices = 0;
        scope.totalBills = 0;
        scope.colorClass = '';
        scope.$watch('ngModel', function (newVal) {
          if (newVal) {
            initData(newVal);
          }
        });

        scope.getProgress = function () {
          if (scope.type === 'invoice') {
            scope.colorClass = 'blue';
            return {
              width: scope.totalInvoices === 0 ? '0%' : scope.totalUnpaidInvoices / scope.totalInvoices * 100 + '%'
            };
          } else {
            scope.colorClass = 'orange';
            return {
              width: scope.totalBills === 0 ? '0%' : scope.totalUnpaidBills / scope.totalBills * 100 + '%'
            };
          }
        };

        function initData(data) {
          scope.totalUnpaidInvoices = data.totalUnpaidInvoices;
          scope.totalInvoices = data.totalInvoices;
          scope.totalUnpaidBills = data.totalUnpaidBills;
          scope.totalBills = data.totalBills;
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('financeBankingBlock', financeBankingBlock);

  function financeBankingBlock(globals) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/finance/directives/finance-banking-block/finance-banking-block.view.html',
      scope: {
        type: '<',
        list: '='
      },
      link: function link(scope) {
        var companyStore = globals.companyStore;
        scope.companyData = companyStore.get();
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('financeBankCard', financeBankCard);

  function financeBankCard() {
    return {
      restrict: 'E',
      templateUrl: 'app/main/finance/directives/finance-bank-card/finance-bank-card.view.html',
      scope: {
        ngModel: '=',
        selectedBankId: '='
      },
      link: function link() {}
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('filterDropdown', filterDropdown);

  function filterDropdown() {
    return {
      restrict: 'E',
      templateUrl: 'app/main/finance/directives/filter-dropdown/filter-dropdown.view.html',
      scope: {
        numberTitle: '<',
        onFilter: '&',
        clearFilter: '='
      },
      link: function link(scope) {
        scope.isOpen = false;
        scope.filterOption = {};

        scope.toggleDropdown = function () {
          scope.isOpen = !scope.isOpen;
        };

        scope.onReset = function () {
          scope.isOpen = false;
          scope.filterOption = {};
          scope.onFilter({
            filterOption: {}
          });
        };

        scope.onCancel = function () {
          scope.isOpen = false;
        };

        scope.onSubmit = function () {
          scope.isOpen = false;
          scope.onFilter({
            filterOption: scope.filterOption
          });
        };

        scope.$watch('clearFilter', function (newVal) {
          if (newVal) {
            scope.filterOption = {};
          }
        });
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.fileManage', ['app.core']);
})();


"use strict";

(function () {
  angular.module("app.fileManage").component("renameModal", {
    controller: renameModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/modals/rename/rename-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function renameModalController($scope) {
    var vm = this;

    vm.$onInit = function () {
      $scope.name = vm.resolve.name;
      $scope.type = vm.resolve.type;
      $scope.typeText = $scope.type ? 'File' : 'Folder';
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      vm.modalInstance.close($scope.name);
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('hierarchyTemplateTreeModal', {
    controller: hierarchyTemplateTreeModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/modals/hierarchy-template-tree/hierarchy-template-tree-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function hierarchyTemplateTreeModal($scope) {
    var vm = this;

    vm.$onInit = function () {
      $scope.template = vm.resolve.template;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSave = function () {
      vm.modalInstance.close();
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('hierarchyTemplateModal', {
    controller: hierarchyTemplateModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/modals/hierarchy-template/hierarchy-template-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function hierarchyTemplateModal($scope, utils, Notification, apiFactory) {
    var vm = this;

    vm.$onInit = function () {
      $scope.payload = vm.resolve.payload;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSave = function () {
      $scope.loading = true;
      apiFactory.saveHierarchyTree($scope.payload).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message || 'Hierarchy template saved successfully.');
        vm.modalInstance.close(res.data.data);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(err.data.message || 'Failed to save hierarchy template.');
      });
    };
  }
})();


"use strict";

(function () {
  angular.module("app.fileManage").component("fileViewerModal", {
    controller: fileViewerModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/modals/file-viewer/file-viewer-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function fileViewerModalController($scope, $document, $window, $log, $compile, $interval, Bim) {
    var vm = this;
    vm.loading3d = false;

    vm.$onInit = function () {
      vm.data = vm.resolve.data;

      if (vm.resolve.type == '3d') {
        $scope.modelView3dFile(vm.data);
      } else {
        $scope.maximizePreview(vm.data);
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      vm.modalInstance.close();
    };

    $scope.modelView3dFile = function (file) {
      vm.loading3d = true;
      $scope.maximizeView = 'file3d';
      var parent = $document[0].getElementById("file_manager_maximize_model_canvas");
      parent.innerHTML = '';
      var width = $window[0].innerWidth * 0.9;
      var height = $window[0].innerHeight * 0.9;
      vm.viewer3d = Bim.simpleViewer(parent);
      vm.viewer3d.initialize();
      vm.viewer3d.setSize(width, height);
      vm.viewer3d.load(file).then(function (resp) {
        $log.info(resp);
        vm.loading3d = false;
      });
    };

    $scope.maximizePreview = function (file) {
      if (file.mimetype == 'application/pdf' || file.mimetype == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.mimetype == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        $scope.maximizeView = 'pdf';
        $scope.maximizeViewUrl = file.secure_url;
        renderDoc(file.secure_url); // setTimeout(() => {
        // }, 3000);
        // vm.currPage = 1; //Pages are 1-based not 0-based
        // vm.numPages = 0;
        // vm.thePDF = null;
        // vm.rootSiteDocContainer = $document[0].getElementById("file_manager_maximize_pdf_canvas");
        // vm.rootSiteDocContainer.innerHTML = "";
        // vm.isCommentImageView = false;
        // let url = file.secure_url;
        // if (!url) return;
        // if (angular.isString(url) || url instanceof String) {
        //     pdfjsLib.getDocument({ url: url }).promise.then(function(pdf) {
        //         vm.thePDF = pdf;
        //         vm.numPages = pdf.numPages;
        //         // you can now use *pdf* here
        //         pdf.getPage(1).then(handlePages);
        //     });
        // } else {
        //     var fileReader = new FileReader();
        //     fileReader.onload = function() {
        //         var typedarray = new Uint8Array(this.result);
        //         pdfjsLib.getDocument(typedarray).promise.then(function(pdf) {
        //             // you can now use *pdf* here
        //             vm.thePDF = pdf;
        //             vm.numPages = pdf.numPages;
        //             // you can now use *pdf* here
        //             pdf.getPage(1).then(handlePages);
        //         });
        //     };
        //     fileReader.readAsArrayBuffer(url);
        // }
      } else if (file.mimetype == 'image/png' || file.mimetype == 'image/jpg' || file.mimetype == 'image/JPG' || file.mimetype == 'image/jpeg' || file.mimetype == 'image/JPEG') {
        $scope.maximizeView = 'image';
        $scope.maximizeViewUrl = file.secure_url;
      }
    };

    var interalId = undefined;

    var cancelInterval = function cancelInterval() {
      $log.info("interval is stopped");
      $interval.cancel(interalId);
      interalId = undefined;
      $scope.loadingIFrame = false;
      $scope.$apply();
    };

    function renderDoc(url) {
      vm.rootSiteDocContainer = $document[0].getElementById("file_manager_maximize_pdf_canvas");
      var close = $document[0].createElement("img");
      close.src = '/assets/icons/close-20.svg';
      close.style.width = "32px";
      close.style.height = "32px";
      close.style.position = "absolute";
      close.style.top = "-15px";
      close.style.right = "-15px";
      close.style.backgroundColor = "#ddd";
      close.style.borderRadius = "50%";
      close.style.cursor = "pointer";
      close.setAttribute('ng-click', 'onCancel()');
      $compile(close)($scope);
      var iframe = $document[0].createElement("iframe");
      iframe.style.display = "block";
      iframe.style.width = "1110px";
      iframe.style.height = "80vh";
      iframe.style.border = "none";
      iframe.setAttribute('id', 'file_manager_google_doc_viewer');
      iframe.setAttribute('src', "https://docs.google.com/gview?url=".concat(url, "&embedded=true"));
      iframe.onload = cancelInterval; // iframe.setAttribute('src', `${url}`);

      vm.rootSiteDocContainer.appendChild(iframe);
      vm.rootSiteDocContainer.appendChild(close);
      interalId = $interval(reloadIFrame, 1000);
      $scope.loadingIFrame = true;
    }

    function reloadIFrame() {
      if ($document[0].getElementById("file_manager_google_doc_viewer")) $document[0].getElementById("file_manager_google_doc_viewer").src = $document[0].getElementById("file_manager_google_doc_viewer").src;
      $log.info("interval is running");
    } // function handlePages(page) {
    //   //This gives us the page's dimensions at full scale
    //   var viewport = page.getViewport(1);
    //   if (vm.currPage == 1) {
    //     // create close icon
    //     var close = $document[0].createElement("img");
    //     close.src = '/assets/icons/close-20.svg';
    //     close.style.width = "32px";
    //     close.style.height = "32px";
    //     close.style.position = "absolute";
    //     close.style.top = "-15px";
    //     close.style.right = "-15px";
    //     close.style.backgroundColor = "#ddd";
    //     close.style.borderRadius = "50%";
    //     close.style.cursor = "pointer";
    //     close.setAttribute('ng-click','onCancel()');
    //     $compile(close)($scope);
    //     vm.rootSiteDocContainer.appendChild(close);
    //   }
    //   //We'll create a canvas for each page to draw it on
    //   var canvas = $document[0].createElement("canvas");
    //   canvas.style.display = "block";
    //   canvas.style.width = "100%";
    //   var context = canvas.getContext('2d');
    //   canvas.height = viewport.height;
    //   canvas.width = viewport.width;
    //   //Draw it on the canvas
    //   page.render({ canvasContext: context, viewport: viewport });
    //   //Add it to the web page
    //   vm.rootSiteDocContainer.appendChild(canvas);
    //   //Move to next page
    //   vm.currPage++;
    //   if (vm.thePDF !== null && vm.currPage <= vm.numPages) {
    //       vm.thePDF.getPage(vm.currPage).then(handlePages);
    //   }
    // }

  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module("app.fileManage").component("fileUploadModal", {
    controller: fileUploadModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/modals/file-upload/file-upload-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function fileUploadModalController($scope, apiFactory, $uibModal, $log, utils, Notification) {
    var vm = this;
    vm.utils = utils;

    vm.$onInit = function () {
      vm.hierarchyId = vm.resolve.data.hierarchyId;
      vm.parentType = vm.resolve.data.parentType;
      vm.companyId = vm.resolve.data.companyId;
      vm.projectId = vm.resolve.data.projectId;
      vm.parentFolder = vm.resolve.data.parentFolder;
      vm.files = [];
      vm.levels = [];
      $scope.loading = true;
      apiFactory.listAllLevelTypes().then(function (res) {
        $scope.loading = false;
        vm.levels = res.data.list.map(function (x) {
          return {
            _id: x._id,
            name: x.tagName
          };
        });

        for (var i = 1; i <= 100; i++) {
          vm.levels.push({
            _id: i.toString(),
            name: i.toString()
          });
        }
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.onClose = function () {
      vm.modalInstance.close(vm.files.length > 0);
    };

    vm.fileUpdated = function (files) {
      if (files && files.length) {
        vm.files = vm.files.concat(files);
        prepareUploadFiles();
      }
    };

    vm.getStyleWidth = function (percentage) {
      return {
        'width': percentage + '%'
      };
    };

    vm.cancelUpload = function (file, index) {
      if (file.upload && file.upload.abort) {
        file.upload.abort();
      }

      vm.files.splice(index, 1);
    };

    function uploadFiles() {
      var _iterator = _createForOfIteratorHelper(vm.files),
          _step;

      try {
        var _loop = function _loop() {
          var file = _step.value;

          if (file.progressPercentage === 100) {
            return "continue";
          }

          var payload = void 0;

          if (vm.parentFolder) {
            payload = {
              file: file,
              level: vm.level,
              hierarchyId: vm.hierarchyId
            };
          } else {
            payload = {
              file: file,
              level: vm.level,
              parentType: vm.parentType,
              companyId: vm.companyId,
              projectId: vm.projectId
            };
          }

          file.upload = apiFactory.addFileToHierarchy(payload).success(function () {
            file.progressPercentage = 100;
          }).error(function (error) {
            file.progressPercentage = 0;
            $log.error(error);
          }).progress(function (event) {
            var progressPercentage = parseInt(100.0 * event.loaded / event.total);

            if (progressPercentage === 100) {
              file.progressPercentage = 99;
            } else {
              file.progressPercentage = progressPercentage;
            }
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    function prepareUploadFiles() {
      var queryObj;

      if (vm.parentFolder) {
        queryObj = {
          names: vm.files.filter(function (x) {
            return !x.progressPercentage;
          }).map(function (file) {
            return file.name;
          }),
          hierarchyId: vm.hierarchyId
        };
      } else {
        queryObj = {
          names: vm.files.filter(function (x) {
            return !x.progressPercentage;
          }).map(function (file) {
            return file.name;
          }),
          parentType: vm.parentType,
          companyId: vm.companyId,
          projectId: vm.projectId
        };
      }

      $scope.loading = true;
      apiFactory.existsAssetsByNames(queryObj).then(function (res) {
        $scope.loading = false;
        var exists = res.data.data;

        if (!utils.isEmpty(exists)) {
          var names = exists.map(function (x) {
            return x.originalname;
          }).join(', ');
          var confirmModal = $uibModal.open({
            animation: true,
            component: 'confirmModal',
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              data: function data() {
                return {
                  title: 'Confirm replace files',
                  message: "The destination already have files named '".concat(names, "'"),
                  subMessage: 'Are you sure replace the files in the destination?',
                  confirmButtonText: 'Replace',
                  icon: '/assets/icons/status-warning.svg'
                };
              }
            }
          });
          confirmModal.result.then(function () {
            uploadFiles();
          }, function (reason) {
            $log.log(reason);
          });
        } else {
          uploadFiles();
        }
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    }
  }
})();


"use strict";

(function () {
  angular.module("app.fileManage").component("fileShareModal", {
    controller: fileShareModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/modals/file-share/file-share-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function fileShareModalController($scope, apiFactory, Notification) {
    var vm = this;
    vm.emails = [];
    $scope.auto_emails = [];
    vm.selectedEmails = [];
    apiFactory.getSiteEmailsForShareFiles().then(function (res) {
      vm.emails = res.data.data;
    });

    vm.addEmail = function () {
      if ($scope.email && $scope.email != '' && $scope.validateEmail($scope.email)) {
        vm.selectedEmails.push($scope.email);
        $scope.email = null;
      }
    };

    vm.removeEmail = function (item) {
      var index = vm.selectedEmails.indexOf(item);
      vm.selectedEmails.splice(index, 1);
    };

    $scope.validateEmail = function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.isOpenAutoComplete = false;

    $scope.group_autocomplete = function () {
      $scope.isOpenAutoComplete = true;
      var output = [];

      if ($scope.email && $scope.email != '') {
        angular.forEach(vm.emails, function (item) {
          if (item.email.toLowerCase().indexOf($scope.email.toLowerCase()) >= 0) {
            output.push(item);
          }
        });
      } else {
        angular.forEach(vm.emails, function (item) {
          output.push(item);
        });
      }

      $scope.auto_emails = output;
    };

    vm.selectedEmail = function (item) {
      $scope.email = item.email;
      $scope.isOpenAutoComplete = false;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (vm.selectedEmails.length) {
        vm.modalInstance.close(vm.selectedEmails);
      } else {
        Notification.error('Add email address to share files.');
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module("app.fileManage").component("filePermissionModal", {
    controller: filePermissionModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/modals/file-permission-modal/file-permission-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function filePermissionModalController($scope, apiFactory, globals, Notification, utils, $log) {
    var vm = this;
    $scope.searchOption = 'User'; // User, Team

    $scope.teams = [];
    $scope.users = [];
    $scope.employees = [];
    $scope.assignedMembers = [];
    $scope.permissions = [{
      label: 'View',
      value: 1
    }, {
      label: 'View & Edit',
      value: 3
    }]; // function removeDuplicates(list, id) {
    //   let index = list.findIndex(x => x._id === id);
    //   if (index !== -1) {
    //     list.splice(index, 1);
    //   }
    // }

    function loadData() {
      $scope.loading = true;
      var apis = [apiFactory.listAllTeams(vm.project._id), apiFactory.fetchInvitedMembersInProject(vm.project._id), apiFactory.getAllEmployees()]; // if (vm.kind === 'File') {
      //   apis.push(apiFactory.getAssetPermissions(vm.item._id));
      // } else if (vm.kind === 'Folder') {
      //   apis.push(apiFactory.getHierarchyPermissions(vm.item._id));
      // }

      Promise.all(apis).then(function (res) {
        $scope.loading = false;
        vm.teams = res[0].data.list.map(function (x) {
          x.type = 'Team';
          x.permission = 0;
          return x;
        });
        var partners = res[1].data.map(function (x) {
          return x.userId;
        });
        vm.users = partners.map(function (x) {
          x.type = 'User';
          x.permission = 0;
          return x;
        });
        vm.employees = res[2].data.list.map(function (x) {
          x.userId.type = 'Employee';
          x.userId.permission = 0;
          return x.userId;
        });
        $scope.teams = angular.copy(vm.teams);
        $scope.users = angular.copy(vm.users);
        $scope.employees = angular.copy(vm.employees); // $scope.assignedMembers = res[3].data.list.map(x => {
        //   if (x.type === 'User' || x.type === 'Employee') {
        //     x.userId.type = x.type;
        //     x.userId.permission = x.permission;
        //     return x.userId;
        //   } else if (x.type === 'Team') {
        //     x.teamId.type = x.type;
        //     x.teamId.permission = x.permission;
        //     return x.teamId;
        //   }
        // });
        //
        // $scope.assignedMembers.forEach(member => {
        //   if (member.type === 'User') {
        //     removeDuplicates($scope.users, member._id);
        //   } else if (member.type === 'Team') {
        //     removeDuplicates($scope.teams, member._id);
        //   } else if (member.type === 'Employee') {
        //     removeDuplicates($scope.employees, member._id);
        //   }
        // });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    vm.$onInit = function () {
      vm.items = vm.resolve.items;
      vm.project = globals.projectStore.get();
      vm.selectedTeamId = undefined;
      vm.selectedUserId = undefined;
      vm.selectedEmployeeId = undefined;
      loadData();
    };

    $scope.onAdd = function () {
      var index;

      if ($scope.searchOption === 'User') {
        index = $scope.users.findIndex(function (x) {
          return x._id === vm.selectedUserId;
        });

        if (index !== -1) {
          $scope.assignedMembers.push($scope.users[index]);
          $scope.users.splice(index, 1);
          vm.selectedUserId = undefined;
        }
      } else if ($scope.searchOption === 'Team') {
        index = $scope.teams.findIndex(function (x) {
          return x._id === vm.selectedTeamId;
        });

        if (index !== -1) {
          $scope.assignedMembers.push($scope.teams[index]);
          $scope.teams.splice(index, 1);
          vm.selectedTeamId = undefined;
        }
      } else if ($scope.searchOption === 'Employee') {
        index = $scope.employees.findIndex(function (x) {
          return x._id === vm.selectedEmployeeId;
        });

        if (index !== -1) {
          $scope.assignedMembers.push($scope.employees[index]);
          $scope.employees.splice(index, 1);
          vm.selectedEmployeeId = undefined;
        }
      }
    };

    $scope.onDelete = function (item) {
      var index = $scope.assignedMembers.findIndex(function (x) {
        return x._id === item._id;
      });

      if (index !== -1) {
        $scope.assignedMembers.splice(index, 1);
        var list = item.type === 'User' ? vm.users : item.type === 'Team' ? vm.teams : vm.employees;
        var scopeList = item.type === 'User' ? $scope.users : item.type === 'Team' ? $scope.teams : $scope.employees;
        var member = list.find(function (x) {
          return x._id === item._id;
        });

        if (angular.isDefined(member)) {
          scopeList.push(member);
        }
      }
    };

    $scope.nameLetter = function (member) {
      if (member.type === 'User' || member.type === 'Employee') {
        return utils.nameLetter(member.firstName, member.lastName);
      } else {
        return utils.nameLetter(member.name || member.displayName);
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      var badList = $scope.assignedMembers.filter(function (x) {
        return x.permission === 0;
      });

      if (!utils.isEmpty(badList)) {
        Notification.error('Please set permission to users or teams added.');
        return;
      }

      var permList = $scope.assignedMembers.map(function (x) {
        return {
          type: x.type,
          userId: x.type === 'User' || x.type === 'Employee' ? x._id : null,
          teamId: x.type === 'Team' ? x._id : null,
          permission: x.permission
        };
      });
      var promises = [];

      var _iterator = _createForOfIteratorHelper(vm.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var promise = item.isFolder ? apiFactory.saveHierarchyPermissions({
            id: item._id,
            permList: permList
          }) : apiFactory.saveAssetPermissions({
            id: item._id,
            permList: permList
          });
          promises.push(promise);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      Promise.all(promises).then(function () {
        $scope.loading = false;
        Notification.success('Saved permissions successfully.');
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  angular.module("app.fileManage").component("fileEditModal", {
    controller: fileEditModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/modals/file-edit/file-edit-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function fileEditModalController($scope, apiFactory, Notification, utils) {
    var vm = this;

    vm.$onInit = function () {
      vm.file = Object.assign({}, vm.resolve.file);
      vm.levels = [];
      $scope.loading = true;
      apiFactory.listAllLevelTypes().then(function (res) {
        $scope.loading = false;
        vm.levels = res.data.list.map(function (x) {
          return {
            name: x.tagName
          };
        });

        for (var i = 1; i <= 100; i++) {
          vm.levels.push({
            name: i.toString()
          });
        }
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      $scope.loading = true;
      apiFactory.updateAssetDescription({
        id: vm.file._id,
        description: vm.file.assetDescription,
        level: vm.file.level
      }).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close(res.data.data);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  angular.module("app.fileManage").component("fileAccessModal", {
    controller: fileAccessModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/modals/file-access/file-access-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function fileAccessModalController($scope, utils) {
    var vm = this;

    function filterArray(objArray, idArray) {
      var arr = [];

      if (!idArray.length) {
        return Object.assign([], objArray);
      }

      var _loop = function _loop(i) {
        var obj = objArray[i];

        if (idArray.findIndex(function (id) {
          return id === obj.id;
        }) === -1) {
          arr.push(obj);
        }
      };

      for (var i = 0; i < objArray.length; i++) {
        _loop(i);
      }

      return arr;
    }

    function filterArray2(objArray, idArray) {
      var arr = [];

      var _loop2 = function _loop2(i) {
        var id = idArray[i];
        var obj = objArray.find(function (x) {
          return x.id === id;
        });

        if (!utils.isEmpty(obj)) {
          arr.push(obj);
        }
      };

      for (var i = 0; i < idArray.length; i++) {
        _loop2(i);
      }

      return arr;
    }

    vm.$onInit = function () {
      var data = vm.resolve.data;
      vm.type = data.type;
      vm.item = Object.assign({}, data.item);
      $scope.blocks = [{
        title: 'Clients',
        blockId: 'clients',
        members: filterArray(data.allClients, vm.item.clients || []),
        selectedMemberId: undefined,
        addedMembers: filterArray2(data.allClients, vm.item.clients || []),
        viewPermission: vm.item.clientsViewPermission || false,
        uploadPermission: vm.item.clientsUploadPermission || false
      }, {
        title: 'Sub Contractors',
        blockId: 'subcontractors',
        members: filterArray(data.allSubcontractors, vm.item.subcontractors || []),
        selectedMemberId: undefined,
        addedMembers: filterArray2(data.allSubcontractors, vm.item.subcontractors || []),
        viewPermission: vm.item.subcontractorsViewPermission || false,
        uploadPermission: vm.item.subcontractorsUploadPermission || false
      }, {
        title: 'Suppliers',
        blockId: 'suppliers',
        members: filterArray(data.allSuppliers, vm.item.suppliers || []),
        selectedMemberId: undefined,
        addedMembers: filterArray2(data.allSuppliers, vm.item.suppliers || []),
        viewPermission: vm.item.suppliersViewPermission || false,
        uploadPermission: vm.item.suppliersUploadPermission || false
      }, {
        title: 'Managers',
        blockId: 'managers',
        members: filterArray(data.allManagers, vm.item.managers || []),
        selectedMemberId: undefined,
        addedMembers: filterArray2(data.allManagers, vm.item.managers || []),
        viewPermission: vm.item.managersViewPermission || false,
        uploadPermission: vm.item.managersUploadPermission || false
      }];
    };

    $scope.addMember = function (block) {
      var index = block.members.findIndex(function (x) {
        return x.id === block.selectedMemberId;
      });

      if (index > -1) {
        block.addedMembers.push(block.members[index]);
        block.members.splice(index, 1);
        block.selectedMemberId = undefined;
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {// let payload = {
      //   type: vm.type,
      //   id: vm.item._id,
      //   clients: $scope.blocks[0].addedMembers.map(x => x.id),
      //   clientsViewPermission: $scope.blocks[0].viewPermission,
      //   clientsUploadPermission: $scope.blocks[0].uploadPermission,
      //   subcontractors: $scope.blocks[1].addedMembers.map(x => x.id),
      //   subcontractorsViewPermission: $scope.blocks[1].viewPermission,
      //   subcontractorsUploadPermission: $scope.blocks[1].uploadPermission,
      //   suppliers: $scope.blocks[2].addedMembers.map(x => x.id),
      //   suppliersViewPermission: $scope.blocks[2].viewPermission,
      //   suppliersUploadPermission: $scope.blocks[2].uploadPermission,
      //   managers: $scope.blocks[3].addedMembers.map(x => x.id),
      //   managersViewPermission: $scope.blocks[3].viewPermission,
      //   managersUploadPermission: $scope.blocks[3].uploadPermission
      // }
      // $scope.loading = true;
      // apiFactory.updateAccessSettings(payload)
      //   .then(res => {
      //     $scope.loading = false;
      //     Notification.success(res.data.message || 'Updated access settings successfully');
      //     vm.modalInstance.close();
      //   })
      //   .catch(err => {
      //     $scope.loading = false
      //     Notification.error(err.data.message || 'Failed access settings');
      //   })
    };
  }
})();


"use strict";

(function () {
  angular.module("app.fileManage").component("createFolderModal", {
    controller: createFolderModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/modals/create-folder/create-folder-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function createFolderModalController($scope) {
    var vm = this;

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      vm.modalInstance.close($scope.name);
    };
  }
})();


"use strict";

(function () {
  angular.module("app.fileManage").directive("folderPreview", folderPreview);

  function folderPreview(globals, apiFactory, utils, Notification) {
    return {
      restrict: "E",
      templateUrl: "app/main/fileManage/directives/folder-preview/folder-preview.view.html",
      scope: {
        data: "=",
        preview: "="
      },
      link: function link(scope) {
        var projectStore = globals.projectStore,
            userStore = globals.userStore;
        scope.project = projectStore.get();
        scope.user = userStore.get();
        scope.utils = utils;
        scope.members = [];
        var colors = ["#FFB900", "#D83B01", "#B50E0E", "#E81123", "#B4009E", "#5C2D91", "#0078D7", "#00B4FF", "#008272", "#107C10"];

        function loadPermissionString() {
          if (!scope.data.userId) {
            return;
          }

          if (scope.data.userId && scope.user._id === scope.data.userId._id) {
            scope.permission = 'Full';
          } else if (!utils.isEmpty(scope.data.permission)) {
            scope.permission = scope.data.permission.permission === 3 ? 'View & Edit' : 'View';

            if (!scope.data.permission.notify) {
              scope.permission = scope.permission + ' (Wait for approve)';
            }
          } else {
            scope.permission = 'None';
          }
        }

        loadPermissionString();

        scope.updateApproval = function (approval) {
          scope.loading = true;
          apiFactory.updateHierarchyPermApproval({
            hierarchyId: scope.data._id,
            approval: approval
          }).then(function (res) {
            scope.loading = false;
            scope.data.permission.approval = approval;
            Notification.success(res.data.message);
          })["catch"](function (err) {
            scope.loading = false;
            utils.getErrorMessage(err);
          });
        };

        scope.closePreview = function () {
          scope.preview = 'None';
        };

        scope.getColor = function (name) {
          if (!name) {
            return;
          }

          name = name.replace(/"/g, '');
          var chars = name.split(' ');
          var codeNum = 0;

          if (chars.length < 2) {
            if (chars[0][0]) {
              codeNum = chars[0].charCodeAt(0);
            }
          } else {
            if (chars[0][0]) {
              codeNum = chars[0].charCodeAt(0);
            }

            if (chars[1][0]) {
              codeNum += chars[1].charCodeAt(0);
            }
          }

          return colors[codeNum % colors.length];
        };

        function loadPermUsers() {
          scope.loading = true;
          apiFactory.getHierarchyPermUsers(scope.data._id).then(function (res) {
            scope.loading = false;
            scope.members = res.data.list;
          })["catch"](function (err) {
            scope.loading = false;
            Notification.error(utils.getErrorMessage(err));
          });
        }

        scope.$watch('data', function () {
          if (angular.isDefined(scope.data)) {
            loadPermUsers();
          }
        });
        scope.$watch('data.permission', function () {
          loadPermissionString();
        });
        scope.$watch('data.permission.permission', function () {
          loadPermissionString();
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app.fileManage').directive('fileVersions', fileVersions);

  function fileVersions(apiFactory, utils, Notification) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/main/fileManage/directives/file-versions/file-versions.view.html',
      scope: {
        file: '=',
        goBack: '&'
      },
      link: function link($scope) {
        $scope.utils = utils;
        var files = [];
        $scope.groups = [];
        var ONE_DAY_TIMESTAMP = 24 * 3600000;

        $scope.getVersionDescription = function (file) {
          if (utils.isEmpty(file.action) || utils.isEmpty(file.userId) || utils.isEmpty(file.userId.firstName)) {
            return '';
          }

          return file.action + ' by ' + file.userId.firstName + ' ' + file.userId.lastName;
        };

        $scope.setFileToCurrentVersion = function (file) {
          apiFactory.setCurrentVersion({
            file: file
          }).then(function (res) {
            Notification.success(res.data.message);
            files = files.map(function (x) {
              x.isActive = false;
              return x;
            });
            file.isActive = true;
          })["catch"](function (err) {
            Notification.error(utils.getErrorMessage(err));
          });
        };

        function addFileToGroup(groupName, file) {
          var group = $scope.groups.find(function (x) {
            return x.name === groupName;
          });

          if (utils.isEmpty(group)) {
            $scope.groups.push({
              name: groupName,
              files: [file]
            });
          } else {
            group.files.push(file);
          }
        }

        function groupByDate() {
          var today = moment();
          files.forEach(function (file) {
            var date = moment(file.createdAt);

            if (today.diff(date) < ONE_DAY_TIMESTAMP) {
              addFileToGroup('Today', file);
            } else {
              addFileToGroup(date.format('MMM DD, YYYY'), file);
            }
          });
        }

        function loadData() {
          var query = {
            names: [$scope.file.originalname],
            parentType: $scope.file.parentType,
            companyId: $scope.file.companyId,
            projectId: $scope.file.projectId
          };

          if (!utils.isEmpty($scope.file.hierarchies)) {
            query.hierarchyId = $scope.file.hierarchies;
          }

          $scope.loading = true;
          apiFactory.getAssetsByNames(query).then(function (res) {
            $scope.loading = false;
            files = res.data.list;
            groupByDate();
          })["catch"](function (err) {
            $scope.loading = false;
            utils.getErrorMessage(err);
          });
        }

        loadData();
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.fileManage").directive("filePreview", filePreview);

  function filePreview(globals, apiFactory, utils, Notification) {
    return {
      restrict: "E",
      templateUrl: "app/main/fileManage/directives/file-preview/file-preview.view.html",
      scope: {
        data: "=",
        fileType: "=",
        preview: "="
      },
      link: function link(scope) {
        var projectStore = globals.projectStore,
            userStore = globals.userStore;
        scope.project = projectStore.get();
        scope.user = userStore.get();
        scope.utils = utils;
        scope.members = [];
        var colors = ["#FFB900", "#D83B01", "#B50E0E", "#E81123", "#B4009E", "#5C2D91", "#0078D7", "#00B4FF", "#008272", "#107C10"];

        function loadPermissionString() {
          if (scope.fileType === '3d') {
            return;
          }

          if (scope.data.userId && scope.user._id === scope.data.userId._id) {
            scope.permission = 'Full';
          } else if (!utils.isEmpty(scope.data.permission)) {
            scope.permission = scope.data.permission.permission === 3 ? 'View & Edit' : 'View';

            if (!scope.data.permission.notify) {
              scope.permission = scope.permission + ' (Wait for approve)';
            }
          } else {
            scope.permission = 'None';
          }
        }

        loadPermissionString();

        scope.openFileViewerModal = function () {
          scope.$emit('open-file-viewer-modal', {
            type: scope.fileType
          });
        };

        scope.previewThumbnail = function () {
          if (scope.fileType === '3d') {
            return utils.getFMFileIcon(scope.data.format);
          }

          var mimeTypes = scope.data.mimetype.split('/');

          if (mimeTypes[0] === 'image') {
            return scope.data.secure_url;
          }

          return utils.getFMFileIcon(scope.data.format);
        };

        scope.updateApproval = function (approval) {
          scope.loading = true;
          apiFactory.updateAssetPermApproval({
            assetId: scope.data._id,
            approval: approval
          }).then(function (res) {
            scope.loading = false;
            scope.data.permission.approval = approval;
            Notification.success(res.data.message);
          })["catch"](function (err) {
            scope.loading = false;
            utils.getErrorMessage(err);
          });
        };

        scope.closePreview = function () {
          scope.preview = 'None';
        };

        scope.getColor = function (name) {
          if (!name) {
            return;
          }

          name = name.replace(/"/g, '');
          var chars = name.split(' ');
          var codeNum = 0;

          if (chars.length < 2) {
            if (chars[0][0]) {
              codeNum = chars[0].charCodeAt(0);
            }
          } else {
            if (chars[0][0]) {
              codeNum = chars[0].charCodeAt(0);
            }

            if (chars[1][0]) {
              codeNum += chars[1].charCodeAt(0);
            }
          }

          return colors[codeNum % colors.length];
        };

        function loadPermUsers() {
          scope.loading = true;
          apiFactory.getAssetPermUsers(scope.data._id).then(function (res) {
            scope.loading = false;
            scope.members = res.data.list;
          })["catch"](function (err) {
            scope.loading = false;
            Notification.error(utils.getErrorMessage(err));
          });
        }

        scope.$watch('data', function () {
          if (angular.isDefined(scope.data)) {
            loadPermUsers();
          }
        });
        scope.$watch('data.permission', function () {
          loadPermissionString();
        });
        scope.$watch('data.permission.permission', function () {
          loadPermissionString();
        });
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('vaOrderList', {
    controller: VaOrderListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/va-order/list/list.view.html'
  });
  /** @ngInject */

  function VaOrderListController($scope, $log, $state, apiFactory, Notification, globals, $uibModal, utils, $timeout) {
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get();
    vm.companyData = companyStore.get();
    vm.userData = userStore.get();
    vm.companyInputMethod = vm.companyData ? vm.companyData.companyInputMethod : 'European et al.';
    $scope.ECO_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.ECO_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.ECO]
    //   })
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.ECO_ACCESS_CREATE = res.data.data[Constants.AccessKey.ECO];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.pdfViewing = false;
    vm.variationOrder = undefined;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    vm.sortItems = [{}, {
      sort: 'date',
      sortType: false
    }, {
      sort: 'client',
      sortType: false
    }, {
      sort: 'vaorderNo',
      sortType: false
    }, {
      sort: 'amount',
      sortType: false
    }, {
      sort: 'vatAmount',
      sortType: false
    }, {
      sort: 'total',
      sortType: false
    }, {
      sort: 'status',
      sortType: false
    }];
    vm.statusList = [{
      value: 'All Status'
    }, {
      value: 'approved'
    }, {
      value: 'declined'
    }, {
      value: 'draft'
    }, {
      value: 'pending'
    }];
    vm.status = 'All Status';
    $scope.sortItem = vm.sortItems[0];
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 0;
    vm.currentPage = 1;

    $scope.changeSortItem = function (sort) {
      if (sort === $scope.sortItem.sort) {
        $scope.sortItem.sortType = !$scope.sortItem.sortType;
      } else {
        $scope.sortItem = vm.sortItems.find(function (x) {
          return x.sort === sort;
        });
      }

      vm.fetchData();
    };

    $scope.selectedProject = function (status) {
      vm.status = status;
      vm.fetchData();
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchData();
    };

    vm.fetchData = function () {
      var query = {
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: $scope.sortItem.sort,
        sortType: $scope.sortItem.sortType,
        status: vm.status !== 'All Status' ? vm.status : ''
      };

      if (vm.project && vm.project._id !== "all") {
        query.projectId = vm.project._id;
      }

      $scope.isLoading = true;
      apiFactory.listAllVariationOrders(query).then(function (resp) {
        $scope.isLoading = false;
        vm.variationOrderList = resp.data.list;
        $scope.totalCount = resp.data.totalCount;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.log(err);

        if (err.status === 403) {
          Notification.error(err.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        }
      });
    };

    vm.fetchData();

    vm.viewVariationOrder = function (vaOrder) {
      if (vaOrder.status === 'draft') {
        $state.go("editVaOrder", {
          id: vaOrder._id
        });
      } else {
        $state.go("vaOrderDetail", {
          id: vaOrder._id
        });
      }
    };

    vm.downloadPdf = function (vaOrder) {
      $scope.isDownloading = true;
      utils.downloadFile(vaOrder.variationOrderDoc).then(function () {
        $scope.isDownloading = false;
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.isDownloading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    vm.print = function (vaOrder) {
      vm.pdfViewing = true;
      vm.variationOrder = vaOrder;
    };

    vm.closePDFViewer = function () {
      vm.pdfViewing = false;
      vm.variationOrder = undefined;
    };

    vm.deleteVariationOrder = function (vaOrder, index) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.isLoading = true;
          apiFactory.deleteVariationOrder(vaOrder._id).then(function (resp) {
            $log.log(resp);
            $scope.isLoading = false;
            Notification.success("Variation order removed successfully.");
            vm.variationOrderList.splice(index, 1);
            $scope.$apply();
          })["catch"](function (err) {
            $scope.isLoading = false;
            $log.error(err);
            Notification.error("Failed to remove!");
          });
        }
      });
    };

    vm.sendVariationOrderMail = function (variationOrder) {
      // let recipients = {emails: [variationOrder.vendor.email], managers: []};
      var _recipients = {
        emails: [],
        managers: []
      };
      $uibModal.open({
        animation: true,
        component: 'recipientsModal',
        windowClass: 'recipients-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          recipients: function recipients() {
            return _recipients;
          },
          title: function title() {
            return 'Variation Order';
          },
          send: function send() {
            return true;
          },
          isVaOrder: function isVaOrder() {
            return true;
          }
        }
      }).result.then(function (result) {
        if (result) {
          variationOrder.recipients = _recipients;
          $scope.isLoading = true;
          apiFactory.sendVariationOrderMail(variationOrder).then(function (res) {
            $scope.isLoading = false;
            Notification.success(res.data.message);
            vm.fetchData();
          })["catch"](function (err) {
            $scope.isLoading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('vaOrderDetail', {
    controller: VaOrderDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/va-order/detail/detail.view.html'
  });
  /** @ngInject */

  function VaOrderDetailController($scope, $state, $stateParams, apiFactory, Notification, globals, $log, $document, localStorageService) {
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    vm.pdfViewing = false;
    vm.invoice = {};
    vm.variationOrder = {
      displaySeq: '',
      reference: "",
      date: '',
      dueDate: '',
      termsAndConditions: true,
      items: [],
      paymentTerms: [],
      totalVat: 0,
      totalTax: 0,
      totalPrice: 0,
      totalAmount: 0
    };

    function initData() {
      $scope.isLoading = true;
      apiFactory.getVariationOrder($stateParams.id).then(function (resp) {
        vm.variationOrder = resp.data.data;
        $scope.companyCurrency = vm.variationOrder.companyCurrency;
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error("error", e);
        $scope.isLoading = false;
      });
      apiFactory.getCompanyById(vm.userData.companyId).then(function (resp) {
        vm.companyData = resp.data;
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.log(e);
      });
    }

    initData();

    vm.createInvoice = function () {
      var items = [];
      vm.variationOrder.items.forEach(function (item) {
        if (item.type && item.number && item.description) {
          items.push({
            type: item.type._id,
            number: item.number._id,
            description: item.description,
            quantity: item.quantity,
            unitPrice: item.unitPrice,
            vatPercent: item.vatPercent,
            vatAmount: item.vatAmount,
            taxPercent: item.taxPercent,
            taxAmount: item.taxAmount,
            price: item.price
          });
        }
      });
      var invoiceData = {
        date: vm.variationOrder.date,
        dueDate: vm.variationOrder.dueDate,
        projectId: vm.variationOrder.projectId,
        projectSystemTag: vm.variationOrder.projectSystemTag,
        termsAndConditions: vm.variationOrder.termsAndConditions,
        items: items,
        status: 'draft',
        isCreditMemo: false,
        paymentTerms: vm.variationOrder.paymentTerms,
        totalPrice: vm.variationOrder.totalPrice,
        totalVat: vm.variationOrder.totalVat,
        totalTax: vm.variationOrder.totalTax,
        totalAmount: vm.variationOrder.totalAmount,
        companyCurrency: vm.variationOrder.companyCurrency
      };
      invoiceData.vendorType = vm.variationOrder.vendorType;
      invoiceData.vendor = vm.variationOrder.vendor._id;
      invoiceData.fromVariationOrder = true;
      localStorageService.set('invoiceData', invoiceData);
      $state.go('createInvoice');
    };

    vm.save = function () {
      // if (vm.variationOrder.status != 'rejected') {
      //   return;
      // }
      apiFactory.updateVariationOrder({
        _id: vm.variationOrder._id,
        status: vm.variationOrder.status
      }).then(function () {
        Notification.success("Variation Order updated successfully."); // $scope.isSaved = true;
      })["catch"](function (e) {
        $log.error(e);
        Notification.error("Something went wrong.");
      });
    };

    vm.approve = function () {
      vm.variationOrder.status = "approved";

      if (vm.variationOrder._id) {
        vm.save();
      }
    };

    vm.pending = function () {
      vm.variationOrder.status = "pending";

      if (vm.variationOrder._id) {
        vm.save();
      }
    };

    vm.viewAsPDF = function () {
      vm.pdfViewing = true;
    };

    vm.closePDFViewer = function () {
      vm.pdfViewing = false;
    };

    vm.exportAsPDF = function () {
      var a = $document[0].createElement("a");
      $document[0].body.appendChild(a);
      a.href = vm.variationOrder.variationOrderDoc;
      a.download = 'variationOrder.pdf';
      a.click();
    };

    $scope.getTimeEffect = function (timeEffect) {
      if (!timeEffect || !timeEffect.hours) {
        return '';
      }

      return timeEffect.type === 'time' ? "".concat(timeEffect.hours, " Hours Additional Time") : "".concat(timeEffect.hours, " Hours Product Change");
    };

    vm.paidBtn = [{
      id: 'pending',
      value: 'pending'
    }, {
      id: 'approved',
      value: 'approved'
    }];

    $scope.onPaidBtn = function (event) {
      vm.variationOrder.status = event.target.id;
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('createVaOrder', {
    controller: CreateVaOrderController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/va-order/create/create.view.html'
  });
  /** @ngInject */

  function CreateVaOrderController($scope, $state, $stateParams, apiFactory, Notification, globals, utils, moment, $log, $uibModal) {
    /* Requiring vars */
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    vm.isEdit = angular.isDefined($stateParams.id);
    vm.clients = [];
    vm.vendorId = undefined;
    vm.recipients = {
      emails: [],
      managers: []
    };
    vm.vaOrder = {
      displaySeq: '',
      projectSystemTag: "",
      date: new Date(),
      dueDate: '',
      termsAndConditions: true,
      costAdditionPercent: 0,
      items: [{
        isEdit: true
      }],
      status: "draft",
      paymentTerms: [],
      totalVat: 0,
      totalTax: 0,
      totalPrice: 0,
      totalAmount: 0
    };
    vm.teamUsers = {};
    vm.userListTemp = [];
    vm.allItems = [];
    vm.accountPlans = [];
    vm.economicSettingItems = [];
    vm.selectedTime = '';
    vm.additionalTime = 0;
    vm.productChange = 0;
    vm.isNegative = false;
    $scope.isLoading = true;
    apiFactory.hasApprovalInProject({
      projectId: vm.project._id,
      approval: 'bill'
    }).then(function () {
      $scope.loading = false;
      initData();
    })["catch"](function (err) {
      $scope.loading = false;
      $log.error(err);
      Notification.error(utils.getErrorMessage(err, 'Permission denied'));
      $state.go(globals.getDashboardRoute(vm.userData));
    });

    function initData() {
      if (vm.isEdit) {
        apiFactory.getVariationOrder($stateParams.id).then(function (resp) {
          vm.vaOrder = resp.data.data;
          vm.vaOrder.createdByName = vm.userData.displayName;
          vm.vaOrder.date = moment(vm.vaOrder.date)._d;
          vm.vaOrder.dueDate = moment(vm.vaOrder.date)._d;
          $scope.companyCurrency = vm.vaOrder.companyCurrency;
          vm.vendorId = vm.vaOrder.vendor._id;

          if (vm.vaOrder.vendorType === 'Client') {
            vm.vendorIdTemp = 'Client_' + vm.vaOrder.vendor._id;
            vm.recipients.emails = [];
          } else if (vm.vaOrder.vendorType === 'Supplier') {
            vm.vendorIdTemp = 'Supplier_' + vm.vaOrder.vendor._id;
            vm.recipients.emails = [];
          } else if (vm.vaOrder.vendorType === 'Subcontractor') {
            vm.vendorIdTemp = 'Subcontractor_' + vm.vaOrder.vendor._id;
            vm.recipients.emails = [];
          }

          for (var i = 0; i < vm.vaOrder.items.length; i++) {
            vm.vaOrder.items[i].itemId = vm.vaOrder.items[i].type._id;
            vm.vaOrder.items[i].itemNum = vm.vaOrder.items[i].number._id;
          }

          if (vm.vaOrder.timeEffect) {
            if (vm.vaOrder.timeEffect.type === 'time') {
              vm.additionalTime = vm.vaOrder.timeEffect.hours;
              vm.selectTimeEffect(0);
            } else {
              vm.productChange = vm.vaOrder.timeEffect.hours;
              vm.selectTimeEffect(1);
            }
          }
        })["catch"](function (e) {
          $log.error("error", e);
        });
      } else {
        vm.vaOrder.createdByName = vm.userData.displayName;
        vm.vaOrder.vendor = vm.project.client;
        vm.vaOrder.vendorType = 'Client';
        vm.vaOrder.projectSystemTag = vm.project.systemTag;
        vm.vaOrder.staff = vm.project.staff;

        if (vm.vaOrder.vendor) {
          vm.vendorId = vm.vaOrder.vendor._id;
          vm.vendorIdTemp = 'Client_' + vm.vaOrder.vendor._id;
          apiFactory.getClientById(vm.vendorId).then(function (resp) {
            vm.vaOrder.vendor = resp.data.data;
            vm.recipients.emails = [];

            if (vm.vaOrder.vendor) {
              vm.vaOrder.staff = vm.vaOrder.vendor.staffs[0] ? vm.vaOrder.vendor.staffs[0]._id : undefined;
            }
          });
        }
      }

      Promise.all([apiFactory.listAllProjectTeamUsers(vm.project._id), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.getCompanyById(vm.userData.companyId), apiFactory.getEconomicSettingInvoiceItems(), apiFactory.getInvoiceAccountPlans()]).then(function (resp) {
        vm.userListTemp = [];
        vm.teamUsers = resp[0].data.data;

        if (vm.teamUsers.clients) {
          vm.teamUsers.clients.forEach(function (client) {
            vm.userListTemp.push({
              _id: 'Client_' + client._id,
              name: 'Client - ' + client.clientName
            });
          });
        }

        if (vm.teamUsers.suppliers) {
          vm.teamUsers.suppliers.forEach(function (user) {
            vm.userListTemp.push({
              _id: 'Supplier_' + user._id,
              name: 'Supplier - ' + user.name
            });
          });
        }

        if (vm.teamUsers.subContractors) {
          vm.teamUsers.subContractors.forEach(function (user) {
            vm.userListTemp.push({
              _id: 'Subcontractor_' + user._id,
              name: 'Subcontractor - ' + user.name
            });
          });
        }

        vm.allItems = [].concat(resp[1].data.list, resp[2].data.list, resp[3].data.list);
        vm.companyData = resp[4].data;
        vm.paymentConditions = angular.copy(vm.companyData.paymentConditions);
        vm.paymentConditions.map(function (x) {
          // x.range = `${x.from} - ${x.to} (${x.percentage}%)`;
          x.validate = false;
        });
        vm.economicSettingItems = resp[5].data.data || [];
        vm.economicSettingItems.forEach(function (item) {
          item.label = item.description || item.type;
          item.type = item.plan.name;
          item.type_id = item.plan._id;
          item.vat = item.plan.vat;
          item.tax = item.plan.tax;
        });
        vm.accountPlans = resp[6].data.data || [];
        vm.accountPlans.forEach(function (accountPlan) {
          accountPlan.label = accountPlan.number + "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0" + accountPlan.name;
        });
        $scope.isLoading = false;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.log(err);
      });
      globals.getCurrency().then(function (resp) {
        var getCurrencyCode = resp.data;
        $scope.companyCurrency = getCurrencyCode.find(function (element) {
          return element.cc === vm.companyData.currentCurrency.currencyCode;
        });
      });
    }

    $scope.invoiceDateChanged = function () {
      getDueDate();
    };

    vm.addPaymentTerm = function (data) {
      if (!data) {
        return;
      }

      vm.vaOrder.paymentTerms = [data];
      getDueDate();
      angular.forEach(vm.vaOrder.paymentTerms, function (x) {
        angular.forEach(vm.paymentConditions, function (y) {
          if (x.from <= y.from) {
            y.validate = y.from <= x.to;
          } else {
            y.validate = x.from <= y.to ? y.to <= x.to : false;
          }
        });
      });
    };

    vm.deletePaymentTerm = function (index) {
      vm.vaOrder.paymentTerms.splice(index, 1);
      vm.vaOrder.dueDate = null;
    };

    vm.clientChanged = function (id) {
      if (!id) {
        return;
      }

      var vendorType = '';
      var userId = '';

      if (id.includes('_')) {
        vendorType = id.split('_')[0];
        userId = id.split('_')[1];
      } else {
        vendorType = 'Client';
        userId = id;
      }

      vm.vaOrder.vendorType = vendorType;
      var userList = (vendorType === 'Client' ? vm.teamUsers.clients : vendorType === 'Supplier' ? vm.teamUsers.suppliers : vm.teamUsers.subContractors) || [];
      var user = userList.find(function (x) {
        return x._id === userId;
      });

      if (user) {
        vm.vaOrder.vendor = user;

        if (vm.vaOrder.vendor) {
          vm.vaOrder.staff = vm.vaOrder.vendor.staffs[0] ? vm.vaOrder.vendor.staffs[0]._id : undefined;
        } // if (vm.recipients.emails.length > 0) {
        //   vm.recipients.emails[0] = vm.vaOrder.vendor.email;
        // } else {
        //   vm.recipients.emails = [vm.vaOrder.vendor.email];
        // }

      }
    };

    vm.selectTimeEffect = function (index) {
      if (index === 0) {
        vm.selectedTime = "".concat(vm.additionalTime, " Hours    Additional Time");
        vm.timeEffectType = 'time';
      } else {
        vm.selectedTime = "".concat(vm.productChange, " Hours    Product Change");
        vm.timeEffectType = 'product';
      }
    };

    vm.addVariationOrderRow = function () {
      vm.vaOrder.items.push({
        isEdit: true
      });
    };

    vm.removeVariationOrderRow = function (index) {
      if (vm.vaOrder.totalPrice && vm.vaOrder.items[index].price) {
        vm.vaOrder.totalPrice = vm.vaOrder.totalPrice - vm.vaOrder.items[index].price;
      }

      if (vm.vaOrder.totalVat && vm.vaOrder.items[index].vatAmount) {
        vm.vaOrder.totalVat = vm.vaOrder.totalVat - vm.vaOrder.items[index].vatAmount;
      }

      if (vm.vaOrder.totalTax && vm.vaOrder.items[index].taxAmount) {
        vm.vaOrder.totalTax = vm.vaOrder.totalTax - vm.vaOrder.items[index].taxAmount;
      }

      if (vm.vaOrder.totalAmount && vm.vaOrder.items[index].price && vm.vaOrder.items[index].vatAmount && vm.vaOrder.items[index].taxAmount) {
        vm.vaOrder.totalAmount = vm.vaOrder.totalAmount - vm.vaOrder.items[index].price - vm.vaOrder.items[index].vatAmount - vm.vaOrder.items[index].taxAmount;
      }

      vm.vaOrder.items.splice(index, 1);
      var rowCount = vm.vaOrder.items.length;

      if (rowCount < 1) {
        vm.addVariationOrderRow();
      }
    };

    vm.editVariationOrderRow = function (item) {
      item.isEdit = true;
    };

    vm.confirmVariationOrderRow = function (item) {
      if (!item.itemId || !item.itemNum || angular.isUndefined(item.quantity) || angular.isUndefined(item.vatPercent) || angular.isUndefined(item.vatAmount)) {
        Notification.error('Please fill all required field.');
        return;
      }

      item.isEdit = false;
    };

    vm.selectItemType = function (params, item, typeOrNum) {
      var type;

      if (item && params) {
        if (typeOrNum === 'accountPlan') {
          item.settingItems = vm.economicSettingItems.filter(function (it) {
            return it.type_id === params;
          });

          if (item.settingItems.length > 0) {
            type = item.settingItems[0];
            item.itemNum = type._id ? type._id : null;
            item.type = type;
          } else {
            item.itemNum = undefined;
          }
        } else if (typeOrNum === 'settingItem') {
          type = vm.economicSettingItems.find(function (it) {
            return it._id === params;
          });
          item.type = type;
        }

        if (type) {
          item.taxPercent = type.tax;
          item.vatPercent = type.vat; // item.description = '';

          if (type.category === "ServiceCar") {
            item.unitPrice = type.price;
            item.isServiceAndVAOrder = false;
            delete item.matId;
            delete item.eqId;
          }

          if (type.category == "Labor") {
            item.unitPrice = type.salesPrice;
            item.isServiceAndVAOrder = false;
            delete item.matId;
            delete item.eqId;
          }

          if (type.category == "ServiceAndVAOrder") {
            // item.unitPrice = 0;
            item.profit = type.profit;
            item.cost = type.cost;
            item.isServiceAndVAOrder = true;
          }
        }

        item.isSelType = true;
        vm.calculateItemPrice(item);
      }
    };

    vm.searchItemDescription = function (item, query) {
      vm.curItem = item;
      $scope.filteredItems = filterItems(vm.allItems, query);
    };

    vm.selectItemDescription = function (item, data) {
      vm.curItem = undefined;
      $scope.filteredItems = [];

      if (data.currentRate) {
        item.unitPrice = 0;

        if (data.currentRate.materialCost) {
          item.unitPrice += data.currentRate.materialCost.value;
        } // if (data.currentRate.rooferCost) {
        //   item.unitPrice += data.currentRate.rooferCost.value;
        // }


        if (data.currentRate.equipmentCost) {
          item.unitPrice += data.currentRate.equipmentCost.value;
        }

        if (item.type.profit && item.type.cost) {
          item.unitPrice = item.unitPrice * (100 + item.type.profit + item.type.cost) / 100;
        } else if (item.type.profit && !item.type.cost) {
          item.unitPrice = item.unitPrice * (100 + item.type.profit) / 100;
        } else if (!item.type.profit && item.type.cost) {
          item.unitPrice = item.unitPrice * (100 + item.type.cost) / 100;
        }

        if (item.unitPrice === 0) {
          item.unitPrice = 1;
        }
      } else {
        item.unitPrice = 1;
      }

      item.description = data.name;

      if (data.systemTag.includes('MATRL')) {
        item.matId = data._id;
        delete item.eqId;
      } else {
        item.eqId = data._id;
        delete item.matId;
      }

      if (utils.isEmpty(item.quantity)) {
        item.quantity = 1;
      }

      vm.calculateItemPrice(item);
    };

    function filterItems(items, filter) {
      var output = [];

      if (filter && filter.length >= 2) {
        angular.forEach(items, function (item) {
          if (item.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
            output.push(item);
          }
        });
      }

      return output;
    }

    vm.calculateItemPrice = function (item) {
      if (!item.type) {
        return;
      }

      calculateItem(item);
      $scope.calculateSummary();
    };

    function calculateItem(item) {
      if (angular.isUndefined(item.quantity) || isNaN(item.quantity)) {
        item.quantity = 1;
      }

      if (angular.isUndefined(item.unitPrice) || isNaN(item.unitPrice)) return;

      if (angular.isUndefined(vm.vaOrder.costAdditionPercent) || isNaN(vm.vaOrder.costAdditionPercent)) {
        vm.vaOrder.costAdditionPercent = 0;
      }

      var addition = 1.0 + vm.vaOrder.costAdditionPercent / 100;
      item.price = item.quantity * item.unitPrice * addition;

      if (angular.isDefined(item.vatPercent) && !isNaN(item.vatPercent)) {
        item.vatAmount = item.price * item.vatPercent / 100;
      }

      if (angular.isDefined(item.taxPercent) && !isNaN(item.taxPercent)) {
        item.taxAmount = item.price * item.taxPercent / 100;
      }
    }

    $scope.calculateSummary = function () {
      vm.vaOrder.totalPrice = 0;
      vm.vaOrder.totalVat = 0;
      vm.vaOrder.totalTax = 0;
      vm.vaOrder.totalAmount = 0;
      vm.vaOrder.items.forEach(function (item) {
        if (item.price) {
          vm.vaOrder.totalPrice += item.price;
        }

        if (item.vatAmount) {
          vm.vaOrder.totalVat += item.vatAmount;
        }

        if (item.taxAmount) {
          vm.vaOrder.totalTax += item.taxAmount;
        }
      });
      vm.vaOrder.totalAmount = vm.vaOrder.totalPrice + vm.vaOrder.totalVat + vm.vaOrder.totalTax;
      var negative = vm.isNegative ? -1 : 1;
      vm.vaOrder.totalPrice *= negative;
      vm.vaOrder.totalVat *= negative;
      vm.vaOrder.totalTax *= negative;
      vm.vaOrder.totalAmount *= negative;
    };

    vm.save = function () {
      var vaOrderData = prepareVaOrderData(vm.vaOrder);

      if (vaOrderData != null) {
        $scope.isSaving = true;
        apiFactory.createVariationOrder(vaOrderData).then(function (resp) {
          $scope.isSaving = false;
          Notification.success("VariationOrder created successfully");
          vm.vaOrder._id = resp.data.data._id;
          vm.vaOrder.displaySeq = resp.data.data.displaySeq;
          vm.vaOrder.variationOrderDoc = resp.data.data.variationOrderDoc;
          $state.go('vaOrderList');
        })["catch"](function (e) {
          $scope.isSaving = false;
          Notification.error("Something went wrong");
          $log.error(e);
        });
      }
    };

    vm.showRecipientsPopup = function (needSend) {
      $uibModal.open({
        animation: true,
        component: 'recipientsModal',
        windowClass: 'economic-recipients-modal',
        resolve: {
          recipients: function recipients() {
            return vm.recipients;
          },
          title: function title() {
            return 'Variation Order';
          },
          send: function send() {
            return needSend;
          },
          isVaOrder: function isVaOrder() {
            return true;
          }
        }
      }).result.then(function (result) {
        if (result) {
          send();
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.send = function () {
      send();
    };

    vm.showImportVariationPopup = function () {
      $uibModal.open({
        animation: true,
        component: 'importVariationModal',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          variationOrder: function variationOrder() {
            return vm.vaOrder;
          }
        }
      }).result.then(function (result) {
        if (result) {
          vm.vaOrder.importData = result;
          importVariationOrderItems();
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.showCostPercentPopup = function () {
      $uibModal.open({
        animation: true,
        component: 'costPercentModal',
        backdrop: 'static',
        windowClass: 'economic-cost-percent-modal',
        resolve: {
          percent: function percent() {
            return vm.vaOrder.costAdditionPercent;
          }
        }
      }).result.then(function (result) {
        if (result) {
          vm.vaOrder.costAdditionPercent = utils.num(result);
          costAdditionPercentChanged();
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    function importVariationOrderItems() {
      vm.vaOrder.items = [];

      if (vm.vaOrder.importData.items) {
        vm.vaOrder.importData.items.forEach(function (item) {
          if (item.checked) {
            item.checked = false;
            item.itemId = item.type;
            item.itemNum = item.number;
            vm.vaOrder.items.push(item);
          }
        });
      }

      $scope.calculateSummary();
    }

    function getDueDate() {
      if (vm.vaOrder.date && vm.vaOrder.paymentTerms && vm.vaOrder.paymentTerms.length > 0) {
        var term = vm.vaOrder.paymentTerms[0];
        var additionalDays = utils.getDaysFromPaymentTermsCode(term.code);
        var newDate = moment(vm.vaOrder.date).clone();

        if (additionalDays) {
          var endDate = moment(newDate);

          if (additionalDays.w) {
            endDate = moment(newDate).isoWeek(7);
          } else if (additionalDays.m) {
            endDate = moment(newDate).endOf('month');
          }

          vm.vaOrder.dueDate = endDate.add(additionalDays.days, 'days');
          vm.vaOrder.dueDate = vm.vaOrder.dueDate._d;
        }
      }
    }

    function costAdditionPercentChanged() {
      vm.vaOrder.totalPrice = 0;
      vm.vaOrder.totalVat = 0;
      vm.vaOrder.totalTax = 0;
      vm.vaOrder.totalAmount = 0;
      vm.vaOrder.items.forEach(function (item) {
        calculateItem(item);

        if (item.price) {
          vm.vaOrder.totalPrice += item.price;
        }

        if (item.vatAmount) {
          vm.vaOrder.totalVat += item.vatAmount;
        }

        if (item.taxAmount) {
          vm.vaOrder.totalTax += item.taxAmount;
        }
      });
      vm.vaOrder.totalAmount = vm.vaOrder.totalPrice + vm.vaOrder.totalVat + vm.vaOrder.totalTax;
    }

    function prepareVaOrderData(data) {
      if (!data.vendorType) {
        Notification.error("Please select vendor");
      } else if (data.vendor.staffs.length && !data.staff) {
        Notification.error('Please select staff');
      } else if (!data.date) {
        Notification.error("Please select date");
      } else if (!data.dueDate) {
        Notification.error("Please Add Payment Term");
      } else if (!data.projectSystemTag) {
        Notification.error("Please select the project");
      } else if (!vm.vaOrder.status) {
        Notification.error("Please select approval status");
      } else if (data.items.length === 0) {
        Notification.error("Please add variation order Items");
      } else {
        $scope.isCreateable = true;
        var items = [];
        data.items.forEach(function (item) {
          if (item.type && item.description) {
            items.push({
              type: item.itemId,
              number: item.itemNum,
              description: item.description,
              quantity: item.quantity,
              unitPrice: item.unitPrice,
              vatPercent: item.vatPercent,
              vatAmount: item.vatAmount,
              taxPercent: item.taxPercent,
              taxAmount: item.taxAmount,
              price: item.price
            });
          } else {
            $scope.isCreateable = false;
          }
        });
        var vaOrderData = {
          date: moment(data.date).format(),
          dueDate: moment(data.dueDate).format(),
          projectId: vm.project._id,
          projectSystemTag: data.projectSystemTag,
          termsAndConditions: data.termsAndConditions,
          items: items,
          recipients: vm.recipients,
          status: data.status,
          isCreditMemo: vm.AsCreditNoteTag,
          paymentTerms: data.paymentTerms,
          costAdditionPercent: data.costAdditionPercent,
          totalPrice: data.totalPrice,
          totalVat: data.totalVat,
          totalTax: data.totalTax,
          totalAmount: data.totalAmount,
          companyCurrency: $scope.companyCurrency
        };

        if (vm.vaOrder._id) {
          vaOrderData._id = vm.vaOrder._id;
        }

        vaOrderData.vendorType = data.vendorType;
        vaOrderData.vendor = data.vendor._id;
        vaOrderData.staff = data.staff;
        vaOrderData.referenceNo = vm.vaOrder.referenceNo;

        if (vm.timeEffectType) {
          vaOrderData.timeEffect = {
            type: vm.timeEffectType,
            hours: vm.timeEffectType === 'time' ? utils.num(vm.additionalTime) : utils.num(vm.productChange)
          };
        }

        if ($scope.isCreateable) {
          return vaOrderData;
        } else {
          Notification.error("Select type and description");
          return null;
        }
      }

      return null;
    }

    function send() {
      vm.vaOrder.status = 'pending';
      var vaOrderData = prepareVaOrderData(vm.vaOrder);

      if (vaOrderData != null) {
        $scope.isSending = true;
        apiFactory.createAndSendVariationOrder(vaOrderData).then(function (resp) {
          $scope.isSending = false;
          Notification.success("VariationOrder saved and sent successfully");
          vm.vaOrder._id = resp.data.data._id;
          vm.vaOrder.displaySeq = resp.data.data.displaySeq;
          vm.vaOrder.variationOrderDoc = resp.data.data.variationOrderDoc;
          $state.go('vaOrderList');
        })["catch"](function (e) {
          $scope.isSending = false;
          Notification.error("Something went wrong");
          $log.error(e);
        });
      }
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('vaOrderAction', {
    controller: VAOrderActionController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/va-order/action/action.view.html'
  });
  /** @ngInject */

  function VAOrderActionController($scope, apiFactory, Notification, utils, $location, $state, $log) {
    var vm = this;

    var _$location$search = $location.search(),
        token = _$location$search.token;

    if (utils.isEmpty(token)) {
      Notification.error('Invalid operation');
      $state.go('login');
      return;
    }

    vm.vaOrder = undefined;
    vm.vaOrderPrevStatus = 'pending';
    $scope.isLoading = true;
    apiFactory.getVariationOrderStatusByToken(token).then(function (res) {
      $scope.isLoading = false;

      if (res.data) {
        vm.vaOrderPrevStatus = res.data.status;
        $scope.isLoading = true;
        apiFactory.actVariationOrder(token).then(function (resp) {
          $scope.isLoading = false;
          vm.vaOrder = resp.data.data;
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      } else {
        Notification.error('Invalid token');
      }
    })["catch"](function (err) {
      $scope.isLoading = false;
      $log.error(err);
      Notification.error(utils.getErrorMessage(err));
    });
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('uploadNewBillModal', {
    controller: uploadNewBillModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/uploadNewBillModal/uploadNewBillModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function uploadNewBillModal($scope, apiFactory, globals, $log, utils, Notification) {
    var vm = this;
    var companyStore = globals.companyStore;
    var companyData = companyStore.get();
    vm.utils = utils;
    vm.approvers = [];
    vm.projects = [];
    vm.vendors = [];
    vm.files = [];
    vm.isMemo = false;
    vm.projectId = undefined;
    vm.vendorId = undefined;
    vm.approverId = undefined;

    vm.$onInit = function () {
      vm.billing = {};
      initData();
    };

    function initData() {
      $scope.isLoading = true;
      Promise.all([apiFactory.listAllOngoingProjects(), apiFactory.listAllClients(), apiFactory.getAllSubcontractors(), apiFactory.getAllSuppliers()]).then(function (resp) {
        vm.projects = resp[0].data.list.map(function (item) {
          return {
            projectName: "".concat(item.projectName, " - ").concat(item.systemTag),
            _id: item._id,
            systemTag: item.systemTag
          };
        });
        vm.projects.unshift({
          _id: 'other-cost',
          projectName: 'Other Cost'
        });
        var approvers = companyData.billApprovers;

        if (approvers) {
          approvers.forEach(function (approver) {
            return vm.approvers.push(approver.approver);
          });
        }

        var clients = resp[1].data.list;
        var subcontractors = resp[2].data.list;
        var suppliers = resp[3].data.list;
        var i;

        for (i = 0; i < clients.length; i++) {
          vm.vendors.push({
            _id: 'Client_' + clients[i]._id,
            name: 'Client - ' + clients[i].clientName
          });
        }

        for (i = 0; i < suppliers.length; i++) {
          vm.vendors.push({
            _id: 'Supplier_' + suppliers[i]._id,
            name: 'Supplier - ' + suppliers[i].name
          });
        }

        for (i = 0; i < subcontractors.length; i++) {
          vm.vendors.push({
            _id: 'Subcontractor_' + subcontractors[i]._id,
            name: 'Subcontractor - ' + subcontractors[i].name
          });
        }

        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    }

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onUpload = function () {
      if (!vm.files || vm.files.length === 0) {
        Notification.error("Please add one bill at least");
        return;
      }

      var vendorType = '';
      var userId = '';

      if (vm.vendorId && vm.vendorId.includes('_')) {
        vendorType = vm.vendorId.split('_')[0];
        userId = vm.vendorId.split('_')[1];
      } else {
        vendorType = 'Client';
        userId = vm.vendorId;
      }

      var data = {
        data: {
          vendor: userId,
          vendorType: vendorType,
          approver: vm.approverId,
          inputMethod: 'eu',
          dateMode: 'dmy',
          file: vm.files,
          isMemo: vm.isMemo
        },
        isPreUpload: true
      };

      if (vm.projectId !== 'other-cost') {
        data.data.projectId = vm.projectId;
      }

      vm.modalInstance.close({
        action: 'upload',
        data: data
      });
    };

    function validate(files) {
      var _iterator = _createForOfIteratorHelper(files),
          _step;

      try {
        var _loop = function _loop() {
          var file = _step.value;
          var find = vm.files.find(function (elem) {
            return elem.name === file.name;
          });

          if (find) {
            Notification.error("A file with the same name exist");
            return {
              v: false
            };
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_typeof(_ret) === "object") return _ret.v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return true;
    }

    vm.fileUpdated = function (files) {
      if (!validate(files)) {
        return;
      }

      if (files && files.length) {
        vm.files = vm.files.concat(files);
      }
    };

    vm.getStyleWidth = function (percentage) {
      return {
        'width': percentage + '%'
      };
    };

    vm.cancelUpload = function (file, index) {
      if (file.upload && file.upload.abort) {
        file.upload.abort();
      }

      vm.files.splice(index, 1);
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('templateFieldModal', {
    controller: templateFieldModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/templateFieldModal/templateFieldModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function templateFieldModal($scope, $log, utils, Notification, localStorageService) {
    var vm = this;
    $scope.MAX_SUPPLIES_COUNT = 10;
    $scope.fieldList = [];
    $scope.selectedField = "";
    vm.currentIndex = Number(localStorageService.get('template-field-current-index')) || 1;

    vm.$onInit = function () {
      var rect = vm.resolve.rect;
      vm.posX = rect.x;
      vm.posY = rect.y;
      vm.rectWidth = rect.width;
      vm.rectHeight = rect.height;
      vm.startX = rect.viewX;
      vm.startY = rect.viewY;
      vm.viewWidth = rect.viewWidth;
      vm.viewHeight = rect.viewHeight;
      var templateType = vm.resolve.templateType;

      if (templateType.includes('normal')) {
        $scope.fieldList = Constants.OCRTemplateNormalFieldsList.slice(0);
      } else if (templateType.includes('price')) {
        $scope.fieldList = Constants.OCRTemplateOnePriceFieldsList.slice(0);
      } else {
        $scope.fieldList = [];
      }
    };

    $scope.onChangeField = function (fieldId) {
      if (fieldId) {
        for (var i = 0; i < $scope.fieldList.length; i++) {
          if ($scope.fieldList[i].name === fieldId) {
            $scope.selectedField = $scope.fieldList[i];
          }
        }
      }
    };

    $scope.isSelectedLoopField = function () {
      return $scope.selectedField && $scope.selectedField.name !== 'invoicenumber' && $scope.selectedField.name !== 'billdate' && $scope.selectedField.name !== 'totalprice';
    };

    $scope.onChangeCurrentIndex = function () {
      if (angular.isUndefined(vm.currentIndex)) {
        return;
      }

      localStorageService.set('template-field-current-index', vm.currentIndex);
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onSave = function () {
      if (utils.isEmpty($scope.selectedField)) {
        Notification.error("Please insert field name");
        return;
      }

      if (angular.isUndefined(vm.currentIndex)) {
        Notification.error("Invalid Number. Please input From 1 to ".concat($scope.MAX_SUPPLIES_COUNT));
        return;
      }

      var startX = Math.min(vm.startX, vm.posX);
      var endX = Math.max(vm.startX, vm.posX);
      var startY = Math.min(vm.startY, vm.posY);
      var endY = Math.max(vm.startY, vm.posY);
      var item = {
        x: startX / vm.viewWidth,
        y: startY / vm.viewHeight,
        width: (endX - startX) / vm.viewWidth,
        height: (endY - startY) / vm.viewHeight
      };

      if (angular.isUndefined(item.x) || angular.isUndefined(item.y) || angular.isUndefined(item.width) || angular.isUndefined(item.height)) {
        vm.modalInstance.dismiss();
        return;
      }

      if (vm.resolve.isManualTemplate && $scope.isSelectedLoopField()) {
        vm.modalInstance.close({
          field: $scope.selectedField.name + vm.currentIndex,
          item: item
        });
      } else {
        vm.modalInstance.close({
          field: $scope.selectedField.name,
          item: item
        });
      }
    };
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function () {
  angular.module('app').component('recipientsModal', {
    controller: recipientsModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/recipientsModal/recipientsModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function recipientsModal($scope, apiFactory, Notification, $log, utils, globals) {
    var vm = this;
    vm.utils = utils;
    $scope.EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    $scope.inputEmail = '';
    vm.companyManagers = [];
    $scope.inputManager = undefined;
    vm.showSend = false;
    vm.title = 'Add Recipients';
    $scope.currentDesignation = 'Manager';
    vm.projectData = globals.projectStore.get();
    $scope.assignedMembers = [];
    $scope.$watch('currentDesignation', function () {
      switch ($scope.currentDesignation) {
        case 'Manager':
          vm.users = vm.managers;
          break;

        case 'Subcontractor':
          vm.users = vm.subcontractorStaffs;
          break;

        case 'Supplier':
          vm.users = vm.supplierStaffs;
          break;

        case 'Client':
          vm.users = vm.clientStaffs;
          break;

        default:
          vm.users = [];
          break;
      }

      $log.log(vm.users);
    });

    vm.$onInit = function () {
      vm.title = vm.resolve.title || 'Add Recipients';
      vm.showSend = vm.resolve.send;
      $scope.recipients = vm.resolve.recipients;
      vm.isVaOrder = vm.resolve.isVaOrder;
      initData();
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.send = function () {
      if (vm.isVaOrder) {
        $scope.assignedMembers.forEach(function (x) {
          $scope.recipients.managers.push({
            manager: x.userId._id,
            displayName: x.userId.displayName,
            email: x.userId.email
          });
        });
      }

      if (utils.isEmpty($scope.recipients.emails) && utils.isEmpty($scope.recipients.managers)) {
        Notification.error('Please input email or select member');
        return;
      }

      vm.modalInstance.close(true);
    };

    $scope.addRecipientEmail = function (email) {
      if (angular.isUndefined(email) || email == '') {
        return;
      }

      if (!validateEmail(email)) {
        Notification.error("Invalid email address.");
        return;
      }

      $scope.recipients.emails.push(email);
      $scope.inputEmail = '';
    };

    $scope.removeUserList = function (key) {
      $scope.recipients.emails.splice(key, 1);
    };

    $scope.selCompanyManager = function (companyManagerId) {
      for (var i = 0; i < vm.companyManagers.length; i++) {
        if (vm.companyManagers[i]._id == companyManagerId) {
          $scope.inputManager = vm.companyManagers[i];
          return;
        }
      }
    };

    $scope.removeManagerList = function (key) {
      $scope.recipients.managers.splice(key, 1);
    };

    $scope.addRecipientManager = function (manager) {
      if (angular.isUndefined(manager) || manager == '') {
        return;
      }

      $scope.recipients.managers.push({
        manager: manager._id,
        displayName: manager.displayName,
        email: manager.email
      });
      $scope.inputManager = undefined;
    };

    function validateEmail(mail) {
      var re = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
      return re.test(String(mail).toLowerCase());
    }

    $scope.onAdd = function () {
      if (angular.isUndefined(vm.selectedUserId)) {
        Notification.error('Please select user');
        return;
      }

      var user = vm.users.find(function (x) {
        return x._id === vm.selectedUserId;
      });
      var member = {
        userId: user,
        type: 'Member',
        department: user.department,
        designation: user.subDesignation
      };

      if ($scope.currentDesignation !== 'Manager') {
        var parentManger = $scope.assignedMembers.find(function (x) {
          return x.userId.designation === 'Manager' && x.department === member.department;
        });

        if (parentManger) {
          member.parentId = parentManger.userId._id;
        }
      }

      $scope.assignedMembers.push(member);
      var index = vm.users.findIndex(function (x) {
        return x._id === vm.selectedUserId;
      });

      if (index !== -1) {
        vm.users.splice(index, 1);
      }

      vm.selectedUserId = undefined;
    };

    $scope.onDelete = function (index, userId) {
      var member = $scope.assignedMembers[index];
      $scope.assignedMembers.splice(index, 1);
      var arr;

      switch (member.userId.designation) {
        case 'Manager':
          arr = vm.managers;
          break;

        case 'Subcontractor':
          arr = vm.subcontractorStaffs;
          break;

        case 'Supplier':
          arr = vm.supplierStaffs;
          break;

        case 'Client':
          arr = vm.clientStaffs;
          break;

        default:
          arr = [];
      }

      arr.push(userId);
    };

    function initData() {
      $scope.loading = true;

      if (vm.isVaOrder) {
        if (vm.projectData && vm.projectData._id !== "all") {
          apiFactory.fetchInvitedMembersInProject(vm.projectData._id).then(function (res) {
            $scope.loading = false;
            var data = {
              clientStaffs: res.data.filter(function (x) {
                return x.userId.designation === 'Client' && x.inviteStatus !== 'None';
              }),
              subcontractorStaffs: res.data.filter(function (x) {
                return x.userId.designation === 'Subcontractor' && x.inviteStatus !== 'None';
              }),
              supplierStaffs: res.data.filter(function (x) {
                return x.userId.designation === 'Supplier' && x.inviteStatus !== 'None';
              }),
              managers: res.data.filter(function (x) {
                return x.userId.designation === 'Manager' && x.inviteStatus !== 'None';
              })
            };

            if (!utils.isEmpty(data)) {
              loadStaffs(data);
            }
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        } else {
          apiFactory.listCompanyStaffs().then(function (res) {
            $scope.loading = false;
            var data = res.data.data;

            if (!utils.isEmpty(data)) {
              loadStaffs(data);
            }
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }
      } else {
        apiFactory.listAllManagers().then(function (resp) {
          $scope.loading = false;
          vm.companyManagers = resp.data.list || [];
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }
    }

    function loadStaffs(data) {
      $log.log(_typeof(data));
      $log.log(data);
      vm.subcontractorStaffs = data.subcontractorStaffs.map(function (x) {
        return {
          _id: x.userId._id,
          firstName: x.userId.firstName,
          lastName: x.userId.lastName,
          displayName: x.parent.name + ' - ' + x.userId.displayName,
          email: x.userId.email,
          profilePic: x.parent.profilePic,
          designation: x.userId.designation,
          parent: x.parent
        };
      });
      vm.supplierStaffs = data.supplierStaffs.map(function (x) {
        return {
          _id: x.userId._id,
          firstName: x.userId.firstName,
          lastName: x.userId.lastName,
          displayName: x.parent.name + ' - ' + x.userId.displayName,
          email: x.userId.email,
          profilePic: x.parent.profilePic,
          designation: x.userId.designation,
          parent: x.parent
        };
      });
      vm.clientStaffs = data.clientStaffs.map(function (x) {
        return {
          _id: x.userId._id,
          firstName: x.userId.firstName,
          lastName: x.userId.lastName,
          displayName: x.parent.firstName + ' - ' + x.userId.displayName,
          email: x.userId.email,
          profilePic: x.parent.profilePic,
          designation: x.userId.designation,
          parent: x.parent
        };
      });
      vm.managers = data.managers.map(function (x) {
        return {
          _id: x.userId._id,
          firstName: x.userId.firstName,
          lastName: x.userId.lastName,
          displayName: x.userId.displayName,
          email: x.userId.email,
          profilePic: x.userId.profilePic,
          designation: x.userId.designation,
          department: x.userId.department
        };
      });
      vm.users = vm.managers;
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('payrollModal', {
    controller: payrollModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/payrollModal/payrollModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function payrollModal(ecoFactory, $log, NgMap) {
    var vm = this;
    vm.gmap = {
      url: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&libraries=places",
      path: [],
      styles: [],
      center: "",
      zoom: 8
    };

    vm.$onInit = function () {
      vm.payroll = vm.resolve.payroll;
      vm.totalHours = ecoFactory.getPayrollTotalHours(vm.payroll);
      vm.breakHours = ecoFactory.getPayrollBreak(vm.payroll);
      vm.workHours = vm.totalHours - vm.breakHours;
      vm.overHours = ecoFactory.getPayrollOverTime(vm.payroll);
      vm.receipts = vm.payroll.receipts ? vm.payroll.receipts : [];
      loadDriving();
      vm.loading = true;
      NgMap.getMap("driving_map").then(function (map) {
        vm.loading = false;
        vm.map = map;
        map.setOptions({
          styles: vm.gmap.styles,
          disableDefaultUI: true,
          mapTypeControl: true,
          mapTypeId: 'satellite',
          zoomControl: true,
          zoom: 1,
          center: {
            lat: 0,
            lng: 0
          }
        });

        if (vm.from) {
          vm.gmap.zoom = 15;
          vm.gmap.center = "".concat(vm.from.lat, ",").concat(vm.from.lng);
          vm.gmap.from = "".concat(vm.from.lat, ", ").concat(vm.from.lng);
          vm.gmap.path.push({
            location: "".concat(vm.from.lat, ", ").concat(vm.from.lng)
          });
        }

        if (vm.to) {
          vm.gmap.zoom = 15;
          vm.gmap.center = "".concat(vm.to.lat, ",").concat(vm.to.lng);
          vm.gmap.to = "".concat(vm.to.lat, ",").concat(vm.to.lng);
          vm.gmap.path.push({
            location: "".concat(vm.to.lat, ", ").concat(vm.to.lng)
          });
        }
      })["catch"](function (err) {
        vm.loading = false;
        $log.error(err);
      });
    };

    vm.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    function loadDriving() {
      if (vm.payroll.driving) {
        vm.from = vm.payroll.driving.from;
        vm.to = vm.payroll.driving.to;
      }
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('payrollFilterModal', {
    controller: payrollFilterModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/payrollFilterModal/payrollFilterModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function payrollFilterModal() {
    var vm = this;

    vm.$onInit = function () {
      vm.simpleFilter = vm.resolve.filter;
      vm.projects = vm.resolve.projects;
      vm.workers = vm.resolve.workers;
    };

    vm.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    vm.enableDisableDateFilter = function () {
      vm.simpleFilter.isDateFilter = !vm.simpleFilter.isDateFilter;

      if (vm.simpleFilter.isDateFilter === false) {
        vm.simpleFilter.startTime = null;
        vm.simpleFilter.endTime = null;
      }
    };

    vm.onChangeFilterTime = function () {
      if (vm.simpleFilter.endTime) {
        vm.simpleFilter.endTime = new Date(new Date(new Date(new Date(vm.simpleFilter.endTime).setHours(23)).setMinutes(59)).setSeconds(59));
      }

      if (vm.simpleFilter.startTime && vm.simpleFilter.endTime && vm.simpleFilter.endTime - vm.simpleFilter.startTime < 0) {
        Notification.error('Invalid Start Time and End Time');
      }
    };

    vm.addProjectTemp = function (projectId) {
      for (var i = 0; i < vm.projects.length; i++) {
        if (vm.projects[i]._id === projectId) {
          vm.simpleFilter.project = vm.projects[i];
          break;
        }
      }
    };

    vm.addWorkerTemp = function (workerId) {
      if (workerId) {
        for (var i = 0; i < vm.workers.length; i++) {
          if (vm.workers[i]._id === workerId) {
            vm.simpleFilter.client = vm.workers[i];
            break;
          }
        }
      }
    };

    vm.showFilterResult = function () {
      vm.modalInstance.close();
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('importVariationModal', {
    controller: importVariationModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/importVariationModal/importVariationModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function importVariationModal($scope, $log, apiFactory, globals, Notification) {
    var vm = this;
    var projectStore = globals.projectStore;
    $scope.isItemMode = false;
    vm.variationOrderList = [];
    vm.importData = {};
    $scope.isLoading = true;
    apiFactory.listAllVariationOrders({
      projectId: projectStore.get()._id
    }).then(function (resp) {
      vm.variationOrderList = resp.data.list;
      $scope.isLoading = false;
    })["catch"](function (e) {
      $log.error(e);
      $scope.isLoading = false;
      Notification.error('Cannot get variation orders.');
    });

    vm.$onInit = function () {
      vm.importData = vm.resolve.variationOrder.importData;
    };

    vm.importVariationOrderChecked = function (variationOrder, checked) {
      vm.importData = checked ? variationOrder : undefined;
    };

    $scope.nextStep = function () {
      if (!selectVariationOrderForImport()) {
        return;
      }

      $scope.isItemMode = true;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onProceed = function () {
      vm.modalInstance.close(vm.importData);
    };

    function selectVariationOrderForImport() {
      if (angular.isUndefined(vm.importData)) {
        Notification.error("Please select variation order.");
        return false;
      }

      if (angular.isUndefined(vm.importData.items)) {
        vm.importData.items = [];
      }

      var items = vm.importData.items;

      if (items && items.length > 0) {
        items.forEach(function (item) {
          item.checked = false;
        });
      }

      return true;
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('importInvoiceModal', {
    controller: importInvoiceModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/importInvoiceModal/importInvoiceModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function importInvoiceModal($scope, $log, apiFactory, globals, Notification, $timeout) {
    var vm = this;
    var projectStore = globals.projectStore;
    $scope.isItemMode = false;
    vm.invoiceList = [];
    vm.filteredList = [];
    vm.creditNote = {};
    vm.searchText = '';

    vm.$onInit = function () {
      vm.creditNote = vm.resolve.invoice.creditNote;
      var project = projectStore.get();
      var query = project && project._id !== "all" ? {
        projectId: project._id
      } : {};
      $scope.isLoading = true;
      apiFactory.listAllInvoices(query).then(function (resp) {
        vm.invoiceList = resp.data.list;
        vm.filteredList = resp.data.list;
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
        Notification.error('Cannot get invoices');
      });
    };

    vm.importInvoiceChecked = function (invoice, checked) {
      vm.creditNote = checked ? invoice : undefined;
    };

    $scope.nextStep = function () {
      if (!selectInvoiceForCredit()) {
        return;
      }

      $scope.isItemMode = true;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onProceed = function () {
      vm.modalInstance.close(vm.creditNote);
    };

    $scope.onSearch = function () {
      $timeout(filterList());
    };

    function filterList() {
      vm.filteredList = vm.invoiceList.filter(function (x) {
        var date = new Date(x.createdAt);

        if (x.displaySeq.toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0 || x.vendorType == 'Client' && x.vendor.clientName.toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0 || x.vendorType != 'Client' && x.vendor.name.toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0 || moment(date).format('MMM DD, YYYY').toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0) {
          return true;
        }
      });
    }

    function selectInvoiceForCredit() {
      if (angular.isUndefined(vm.creditNote)) {
        Notification.error("Please select invoice.");
        return false;
      }

      if (angular.isUndefined(vm.creditNote.items)) {
        vm.creditNote.items = [];
      }

      var items = vm.creditNote.items;

      if (items && items.length > 0) {
        items.forEach(function (item) {
          item.checked = false;
        });
      }

      return true;
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('imagePreviewModal', {
    controller: imagePreviewModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/imagePreviewModal/imagePreviewModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function imagePreviewModal($scope) {
    var vm = this;
    $scope.ImageURL = undefined;

    vm.$onInit = function () {
      $scope.ImageURL = vm.resolve.imageURL;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('drivingModal', {
    controller: drivingModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/drivingModal/drivingModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function drivingModal($scope, $log, NgMap, utils, Notification) {
    var vm = this;
    vm.gmap = {
      url: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&libraries=places",
      styles: [],
      center: "",
      zoom: 1,
      path: []
    };
    vm.addDriving = {
      from: {},
      to: {},
      distance: 0
    };
    vm.from = {};
    vm.to = {};
    $scope.isLoading = true;

    vm.$onInit = function () {
      var driving = vm.resolve.driving;

      if (driving) {
        vm.addDriving.distance = driving.distance;

        if (driving.from) {
          vm.addDriving.from = driving.from;
          vm.from = {
            lat: vm.addDriving.from.lat,
            lng: vm.addDriving.from.lng,
            address: vm.addDriving.from.address
          };
        }

        if (driving.to) {
          vm.addDriving.to = driving.to;
          vm.to = {
            lat: vm.addDriving.to.lat,
            lng: vm.addDriving.to.lng,
            address: vm.addDriving.to.address
          };
        }

        if (driving.from && driving.to) {
          updateMapMarkers();
          vm.gmap.zoom = 15;
          vm.gmap.center = "".concat(vm.to.lat, ",").concat(vm.to.lng);
        }
      }

      NgMap.getMap("driving_map").then(function (map) {
        vm.map = map;
        map.setOptions({
          styles: vm.gmap.styles,
          disableDefaultUI: true,
          mapTypeControl: true,
          mapTypeId: 'satellite',
          zoomControl: true,
          zoom: vm.gmap.zoom,
          center: {
            lat: vm.to.lat ? vm.to.lat : 0,
            lng: vm.to.lng ? vm.to.lng : 0
          }
        });
        $scope.isLoading = false;
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.updateMarker = function () {};

    vm.placeMarker = function () {
      var placeData = this.getPlace().geometry.location;

      if (this.id === 'location_input_from') {
        vm.addDriving.from = {
          lng: placeData.lng(),
          lat: placeData.lat(),
          address: vm.from.address
        };
      } else if (this.id === 'location_input_to') {
        vm.addDriving.to = {
          lng: placeData.lng(),
          lat: placeData.lat(),
          address: vm.to.address
        };
      }

      updateMapMarkers();
      getTotalDistance();
      vm.gmap.zoom = 15;
      vm.gmap.center = "".concat(placeData.lat(), ",").concat(placeData.lng());
    };

    vm.onAddNewDriving = function () {
      if (!vm.addDriving.from.address || !vm.addDriving.to.address) {
        Notification.error("Please fill all fields.");
        return;
      }

      if (vm.addDriving.endTime - vm.addDriving.startTime < 0) {
        Notification.error("Invalid Start Time and End Time.");
        return;
      }

      vm.modalInstance.close(vm.addDriving);
    };

    function updateMapMarkers() {
      if (vm.addDriving.from.address) {
        vm.gmap.from = "".concat(vm.addDriving.from.lat, ", ").concat(vm.addDriving.from.lng);
        vm.gmap.path.push({
          location: "".concat(vm.addDriving.from.lat, ", ").concat(vm.addDriving.from.lng)
        });
      }

      if (vm.addDriving.to.address) {
        vm.gmap.to = "".concat(vm.addDriving.to.lat, ", ").concat(vm.addDriving.to.lng);
        vm.gmap.path.push({
          location: "".concat(vm.addDriving.to.lat, ", ").concat(vm.addDriving.to.lng)
        });
      }
    }

    function getTotalDistance() {
      if (vm.addDriving.from.address && vm.addDriving.to.address) {
        vm.addDriving.distance = getDistance(vm.addDriving.from, vm.addDriving.to);
      } else {
        vm.addDriving.distance = 0;
      }
    }

    function rad(x) {
      return x * Math.PI / 180;
    }

    function getDistance(p1, p2) {
      var R = 6378.137; // Earth’s mean radius in km

      var dLat = rad(p2.lat - p1.lat);
      var dLong = rad(p2.lng - p1.lng);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c; // returns the distance in km
    }
  }
})();


"use strict";

(function () {
  angular.module("app").component("declineBillModal", {
    controller: declineBillModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/declineBillModal/declineBillModal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function declineBillModalController($scope, utils, Notification) {
    var vm = this;
    vm.description = "";

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onOk = function () {
      if (utils.isEmpty(vm.description)) {
        Notification.error("Please input description");
        return;
      }

      vm.modalInstance.close(vm.description);
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('costPercentModal', {
    controller: costPercentModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/costPercentModal/costPercentModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function costPercentModal($scope, utils, Notification) {
    var vm = this;

    vm.$onInit = function () {
      vm.percent = vm.resolve.percent;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty(vm.percent)) {
        Notification.error("Please input percent.");
        return;
      }

      vm.modalInstance.close(vm.percent);
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('approveBillModal', {
    controller: approveBillModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/approveBillModal/approveBillModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function approveBillModal($scope, apiFactory, globals, $log) {
    var vm = this;
    var companyStore = globals.companyStore;
    var companyData = companyStore.get();
    vm.approvers = [];
    vm.projects = [];
    vm.vendors = [];
    vm.projectId = undefined;
    vm.vendorId = undefined;
    vm.approverId = undefined;

    vm.$onInit = function () {
      vm.billing = vm.resolve.billing;
      vm.projectId = vm.billing.projectId ? vm.billing.projectId._id : 'other-cost';
      initData();
    };

    function initData() {
      $scope.isLoading = true;
      Promise.all([apiFactory.listAllOngoingProjects(), apiFactory.listAllClients(), apiFactory.getAllSubcontractors(), apiFactory.getAllSuppliers()]).then(function (resp) {
        vm.projects = resp[0].data.list.map(function (item) {
          return {
            projectName: "".concat(item.projectName, " - ").concat(item.systemTag),
            _id: item._id
          };
        });
        vm.projects.unshift({
          _id: 'other-cost',
          projectName: 'Other Cost'
        });
        var approvers = companyData.billApprovers;

        if (approvers) {
          approvers.forEach(function (approver) {
            return vm.approvers.push(approver.approver);
          });

          if (vm.billing && vm.billing.approver) {
            var approver = vm.approvers.find(function (x) {
              return x._id === vm.billing.approver._id;
            });

            if (approver) {
              vm.approverId = approver._id;
            }
          }
        }

        var clients = resp[1].data.list;
        var subcontractors = resp[2].data.list;
        var suppliers = resp[3].data.list;
        var i;

        for (i = 0; i < clients.length; i++) {
          vm.vendors.push({
            _id: 'Client_' + clients[i]._id,
            name: 'Client - ' + clients[i].clientName
          });
        }

        for (i = 0; i < suppliers.length; i++) {
          vm.vendors.push({
            _id: 'Supplier_' + suppliers[i]._id,
            name: 'Supplier - ' + suppliers[i].name
          });
        }

        for (i = 0; i < subcontractors.length; i++) {
          vm.vendors.push({
            _id: 'Subcontractor_' + subcontractors[i]._id,
            name: 'Subcontractor - ' + subcontractors[i].name
          });
        }

        $scope.isLoading = false;
        vm.vendorId = vm.billing ? "".concat(vm.billing.vendorType, "_").concat(vm.billing.vendor._id) : undefined;
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    }

    initData();

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onApprove = function () {
      vm.modalInstance.close({
        projectId: vm.projectId,
        vendorType: vm.vendorId.split('_')[0],
        vendorId: vm.vendorId.split('_')[1],
        approverId: vm.approverId
      });
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").component("duplicatedModal", {
    controller: duplicatedModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/modals/DuplicatedModal/DuplicatedModal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function duplicatedModalController($scope, utils, $uibModal, $log, apiFactory, Notification) {
    var vm = this;
    vm.utils = utils;

    vm.$onInit = function () {
      vm.oldBilling = vm.resolve.oldBilling;
      vm.billing = vm.resolve.billing;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      apiFactory.deleteBilling(vm.oldBilling._id).then(function () {
        Notification.success("Replaced from ".concat(vm.oldBilling.billNo, " to ").concat(vm.billing.billNo, " successfully."));
        vm.modalInstance.close();
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Cannot replace.");
      });
    };

    $scope.deleteBilling = function () {
      apiFactory.deleteBilling(vm.billing._id).then(function () {
        Notification.success("".concat(vm.billing.billNo, " removed successfully."));
        vm.modalInstance.close({
          action: 'delete',
          id: vm.billing._id
        });
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Failed to remove!");
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('invoiceList', {
    controller: InvoiceListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/invoice/list/list.view.html'
  });
  /** @ngInject */

  function InvoiceListController($scope, $log, $state, apiFactory, Notification, globals, $uibModal, utils, $timeout, $document, $window, $http) {
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get() || {
      _id: "all"
    };
    vm.companyData = companyStore.get();
    vm.userData = userStore.get();
    $scope.isInvoice = true;
    $scope.isAllChecked = false;
    $scope.searchText = "";

    vm.searchData = function () {
      vm.currentPage = 1;
      vm.currentPage1 = 1;
      vm.initData();
    };

    $scope.OnInvoiceList = function () {
      $scope.isInvoice = true;
      vm.initData();
    };

    $scope.OnCreditMemoList = function () {
      $scope.isInvoice = false;
      vm.initData();
    };

    vm.invoiceList = [];
    vm.creditMemoList = [];
    $scope.ECO_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.ECO_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.ECO]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.ECO_ACCESS_CREATE = res.data.data[Constants.AccessKey.ECO];
    //   })
    //   .catch((e) => {
    //     $scope.isLoading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    vm.pdfViewing = false;
    vm.invoice = undefined;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    vm.sortItems = [{}, {
      sort: 'date',
      sortType: false
    }, {
      sort: 'client',
      sortType: false
    }, {
      sort: 'invoiceNo',
      sortType: false
    }, {
      sort: 'amount',
      sortType: false
    }, {
      sort: 'vatAmount',
      sortType: false
    }, {
      sort: 'total',
      sortType: false
    }, {
      sort: 'status',
      sortType: false
    }];
    vm.statusList = [{
      value: 'All Status'
    }, {
      value: 'draft'
    }, {
      value: 'paid'
    }, {
      value: 'pending'
    }];
    vm.status = 'All Status';
    $scope.sortItem = vm.sortItems[0];
    $scope.totalCount = 0;
    $scope.totalCount1 = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 0;
    $scope.noOfPages1 = 0;
    vm.currentPage = 1;
    vm.currentPage1 = 1;

    $scope.changeSortItem = function (sort) {
      if (sort === $scope.sortItem.sort) {
        $scope.sortItem.sortType = !$scope.sortItem.sortType;
      } else {
        $scope.sortItem = vm.sortItems.find(function (x) {
          return x.sort === sort;
        });
      }

      vm.initData();
    };

    $scope.selectedProject = function (status) {
      vm.status = status;
      vm.initData();
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.initData();
    };

    vm.initData = function () {
      $scope.isLoading = true;
      var query = {
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: $scope.searchText,
        sort: $scope.sortItem.sort,
        sortType: $scope.sortItem.sortType,
        status: vm.status !== 'All Status' ? vm.status : ''
      };
      var query1 = {
        page: vm.currentPage1,
        chunk: $scope.numPerPage,
        search: $scope.searchText,
        sort: $scope.sortItem.sort,
        sortType: $scope.sortItem.sortType,
        status: vm.status !== 'All Status' ? vm.status : ''
      };

      if (vm.project && vm.project._id !== "all") {
        query.projectId = vm.project._id;
        query1.projectId = vm.project._id;
      }

      Promise.all([apiFactory.listAllInvoices(query), apiFactory.listAllCreditMemos(query1)]).then(function (resp) {
        $scope.isLoading = false;

        if ($scope.isInvoice) {
          getInvoiceList(resp[0]);
        } else {
          getCreditMemoList(resp[1]);
        }
      })["catch"](function (err) {
        $scope.isLoading = false;

        if (err.status === 403) {
          Notification.error(err.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        }
      });
    };

    vm.initData();

    vm.viewInvoice = function (invoice) {
      $state.go("invoiceDetail", {
        id: invoice._id
      });
    };

    vm.downloadPdf = function (invoice) {
      $scope.isDownloading = true;
      utils.downloadFile(invoice.invoiceDoc).then(function () {
        $scope.isDownloading = false;
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.isDownloading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    vm.downloadAll = function () {
      $scope.isDownloading = true;
      var data = [];
      var resFilename = '';

      if ($scope.isInvoice) {
        vm.invoiceList.forEach(function (invoice) {
          if (invoice.checked) {
            data.push({
              url: invoice.invoiceDoc,
              filename: invoice.displaySeq + " - " + moment(invoice.date).format('DD-MM-YYYY') + '.pdf'
            });
          }
        });
        resFilename = 'Invoices.zip';
      } else {
        vm.creditMemoList.forEach(function (invoice) {
          if (invoice.checked) {
            data.push({
              url: invoice.invoiceDoc,
              filename: invoice.displaySeq + " - " + moment(invoice.date).format('DD-MM-YYYY') + '.pdf'
            });
          }
        });
        resFilename = 'CreditMemos.zip';
      }

      if (!data.length) {
        Notification.error('Please select invoices to download pdf.');
        $scope.isDownloading = false;
        return;
      }

      apiFactory.downloadInvoicesZip({
        data: data,
        resFilename: resFilename
      }).then(function (resp) {
        $scope.isDownloading = false;
        $log.log(resp);
        $http.get(apiFactory.getBaseUrl() + '/' + resp.data.url, {
          responseType: "arraybuffer"
        }).then(function (response) {
          // resolve();
          var headers = response.headers();
          headers["Content-Disposition"] = "attachment";
          var blob = new Blob([response.data], {
            type: "octet/stream"
          });
          var link = $document[0].createElement("a");
          link.href = $window.URL.createObjectURL(blob);
          link.download = resFilename;
          $document[0].body.appendChild(link);
          link.click();
          $document[0].body.removeChild(link);
        })["catch"](function (err) {
          // reject(err);
          $log.err(err);
        });
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.isDownloading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    $scope.setAllChecked = function () {
      $scope.isAllChecked = !$scope.isAllChecked;

      if ($scope.isInvoice) {
        vm.invoiceList.forEach(function (invoice) {
          invoice.checked = $scope.isAllChecked;
        });
      } else {
        vm.creditMemoList.forEach(function (invoice) {
          invoice.checked = $scope.isAllChecked;
        });
      }

      $timeout(function () {
        return $scope.$apply();
      });
    };

    vm.print = function (invoice) {
      vm.pdfViewing = true;
      vm.invoice = invoice;
    };

    vm.closePDFViewer = function () {
      vm.pdfViewing = false;
      vm.invoice = undefined;
    };

    vm.sendInvoiceMail = function (invoice) {
      var _recipients = {
        emails: [invoice.vendor.email],
        managers: []
      };
      $uibModal.open({
        animation: true,
        component: 'recipientsModal',
        windowClass: 'recipients-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          recipients: function recipients() {
            return _recipients;
          },
          title: function title() {
            return 'Invoice / Credit Memo';
          },
          send: function send() {
            return true;
          }
        }
      }).result.then(function (result) {
        if (result) {
          invoice.recipients = _recipients;
          $scope.isLoading = true;
          apiFactory.sendInvoiceMail(invoice).then(function (res) {
            $scope.isLoading = false;
            Notification.success(res.data.message);
            vm.initData();
          })["catch"](function (err) {
            $scope.isLoading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.deleteInvoice = function (invoice, index) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          apiFactory.deleteInvoice(invoice._id).then(function () {
            Notification.success("Invoice removed successfully.");
            vm.invoiceList.splice(index, 1);
            $scope.$apply();
          })["catch"](function (err) {
            $log.error(err);
            Notification.error("Failed to remove!");
          });
        }
      });
    };

    vm.deleteCreditMemo = function (invoice, index) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          apiFactory.deleteInvoice(invoice._id).then(function () {
            Notification.success("Credit memo removed successfully.");
            vm.invoiceList.splice(index, 1);
            $scope.$apply();
          })["catch"](function (err) {
            $log.error(err);
            Notification.error("Failed to remove!");
          });
        }
      });
    };

    function getInvoiceList(resp) {
      $scope.totalCount = resp.data.totalCount;
      $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      vm.invoiceList = resp.data.list;

      var _iterator = _createForOfIteratorHelper(vm.invoiceList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var invoice = _step.value;

          if (invoice.displaySeq.includes('/')) {
            invoice.displaySeq = 'INV' + invoice.displaySeq.replace("/", "-");
            invoice.displaySeq = invoice.displaySeq.split('-')[0] + '-' + invoice.displaySeq.split('-')[1].padStart(3, '0') + '-' + invoice.displaySeq.split('-')[2];
          }

          invoice.showTotalPrice = invoice.totalPrice;
          invoice.showTotalAmount = invoice.totalAmount; // for (let subtract of invoice.subtractList) {
          //   invoice.showTotalPrice -= subtract.subtractTotalPrice;
          //   invoice.showTotalAmount -= subtract.subtractTotalAmount;
          //   invoice.showTotalVat -= subtract.subtractTotalVat;
          // }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      $scope.isInvoiceList = vm.invoiceList.length > 0;
    }

    function getCreditMemoList(resp) {
      $scope.totalCount1 = resp.data.totalCount;
      $scope.noOfPages1 = Math.ceil($scope.totalCount1 / $scope.numPerPage);
      vm.creditMemoList = resp.data.list;
      $scope.isCreditMemoList = vm.creditMemoList.length > 0;
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('invoiceDetail', {
    controller: InvoiceDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/invoice/detail/detail.view.html'
  });
  /** @ngInject */

  function InvoiceDetailController($scope, $state, $stateParams, apiFactory, Notification, globals, $log, $document) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    vm.invoice = {
      displaySeq: '',
      reference: "",
      date: '',
      dueDate: '',
      termsAndConditions: true,
      items: [],
      status: "pending",
      paymentTerms: [],
      totalVat: 0,
      totalTax: 0,
      totalPrice: 0,
      totalAmount: 0
    };
    vm.pdfViewing = false;

    function initData() {
      $scope.isLoading = true;
      apiFactory.getInvoice($stateParams.id).then(function (resp) {
        vm.invoice = resp.data.data;
        $scope.companyCurrency = vm.invoice.companyCurrency;
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error("error", e);
        $scope.isLoading = false;
      });
      apiFactory.getCompanyById(vm.userData.companyId).then(function (resp) {
        vm.companyData = resp.data;
      })["catch"](function (e) {
        $log.log(e);
      });
    }

    initData();
    vm.paidBtn = [{
      id: 'paid',
      value: 'paid'
    }, {
      id: 'unpaid',
      value: 'unpaid'
    }];

    $scope.onPaidBtn = function (event) {
      vm.invoice.status = event.target.id;
    };

    vm.saveInvoice = function () {
      $scope.isLoading = true;
      apiFactory.updateInvoice({
        _id: vm.invoice._id
      }).then(function () {
        $scope.isLoading = false;
        Notification.success("Invoice updated successfully.");
      })["catch"](function (e) {
        $scope.isLoading = false;
        $log.error(e);
        Notification.error("Something went wrong.");
      });
    };

    vm.saveInvoiceDoc = function () {
      $scope.isLoading = true;
      apiFactory.updateInvoiceDoc({
        _id: vm.invoice._id,
        isCreditMemo: vm.invoice.isCreditMemo
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.invoice.invoiceDoc = resp.data.data;
        Notification.success("Invoice updated successfully.");
      })["catch"](function (e) {
        $scope.isLoading = false;
        $log.error(e);
        Notification.error("Something went wrong.");
      });
    };

    vm.paid = function () {
      vm.invoice.status = "paid";

      if (vm.invoice._id) {
        vm.saveInvoice();
      }
    };

    vm.pending = function () {
      vm.invoice.status = "pending";

      if (vm.invoice._id) {
        vm.saveInvoice();
      }
    };

    vm.viewAsPDF = function () {
      vm.pdfViewing = true;
    };

    vm.closePDFViewer = function () {
      vm.pdfViewing = false;
    };

    vm.exportAsPDF = function () {
      var a = $document[0].createElement("a");
      $document[0].body.appendChild(a);
      a.href = vm.invoice.invoiceDoc;
      a.download = 'invoice.pdf';
      a.click();
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('createInvoice', {
    controller: CreateInvoiceController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/invoice/create/create.view.html'
  });
  /** @ngInject */

  function CreateInvoiceController($scope, $state, apiFactory, Notification, globals, utils, moment, $log, $uibModal, localStorageService) {
    /* Requiring vars */
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get() || {
      _id: "all"
    };
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    vm.vendorIdTemp = undefined;
    vm.finalInvoice = false;
    vm.isCreditMemo = false;
    vm.recipients = {
      emails: [],
      managers: []
    };
    vm.invoice = {
      displaySeq: '',
      projectSystemTag: undefined,
      date: new Date(),
      dueDate: '',
      termsAndConditions: true,
      items: [{
        isEdit: true
      }],
      status: "draft",
      paymentTerms: [],
      totalVat: 0,
      totalTax: 0,
      totalPrice: 0,
      totalAmount: 0
    };
    vm.userListTemp = [];
    vm.teamUsers = {};
    vm.allItems = [];
    vm.accountPlans = [];
    vm.economicSettingItems = [];
    var showOverview = false;
    $scope.loading = true;
    apiFactory.hasApprovalInProject({
      projectId: vm.project._id,
      approval: 'bill'
    }).then(function () {
      $scope.loading = false;
      initData();
    })["catch"](function (err) {
      $scope.loading = false;
      $log.error(err);
      Notification.error(utils.getErrorMessage(err, 'Permission denied'));
      $state.go(globals.getDashboardRoute(vm.userData));
    });

    function initData() {
      $scope.invoiceDataVA = localStorageService.get('invoiceData');
      localStorageService.set('invoiceData', null);
      vm.invoice.vendor = vm.project.client;
      vm.invoice.vendorType = 'Client';
      vm.invoice.projectSystemTag = vm.project.systemTag;
      vm.invoice.createdByName = vm.userData.displayName;
      vm.invoice.staff = vm.project.staff;

      if (vm.invoice.vendor) {
        vm.vendorIdTemp = 'Client_' + vm.invoice.vendor._id;
        apiFactory.getClientById(vm.invoice.vendor._id).then(function (resp) {
          vm.invoice.vendor = resp.data.data;
          vm.recipients.emails = [resp.data.data.email];

          if (vm.invoice.vendor && vm.invoice.vendor.staffs) {
            vm.invoice.staff = vm.invoice.vendor.staffs[0] ? vm.invoice.vendor.staffs[0]._id : undefined;
          }
        })["catch"](function (err) {
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }

      if ($scope.invoiceDataVA) {
        vm.invoice = $scope.invoiceDataVA;
        vm.invoice.projectSystemTag = $scope.invoiceDataVA.projectSystemTag;
        vm.invoice.vendorType = $scope.invoiceDataVA.vendorType;
        vm.invoice.createdByName = vm.userData.displayName;

        if (vm.invoice.vendorType === 'Client') {
          vm.vendorIdTemp = 'Client_' + $scope.invoiceDataVA.vendor;
          apiFactory.getClientById($scope.invoiceDataVA.vendor).then(function (resp) {
            vm.invoice.vendor = resp.data.data;
            vm.recipients.emails = [resp.data.data.email];

            if (vm.invoice.vendor && vm.invoice.vendor.staffs) {
              vm.invoice.staff = vm.invoice.vendor.staffs[0] ? vm.invoice.vendor.staffs[0]._id : undefined;
            }
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        } else if (vm.invoice.vendorType === 'Supplier') {
          vm.vendorIdTemp = 'Supplier_' + $scope.invoiceDataVA.supplier;
          apiFactory.getSupplierById($scope.invoiceDataVA.supplier).then(function (resp) {
            vm.invoice.vendor = resp.data;
            vm.recipients.emails = [resp.data.email];

            if (vm.invoice.vendor && vm.invoice.vendor.staffs) {
              vm.invoice.staff = vm.invoice.vendor.staffs[0] ? vm.invoice.vendor.staffs[0]._id : undefined;
            }
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        } else {
          vm.vendorIdTemp = 'Subcontractor_' + $scope.invoiceDataVA.subcontractor;
          apiFactory.getSubcontractorById($scope.invoiceDataVA.subcontractor).then(function (resp) {
            vm.invoice.vendor = resp.data;
            vm.recipients.emails = [resp.data.email];

            if (vm.invoice.vendor && vm.invoice.vendor.staffs) {
              vm.invoice.staff = vm.invoice.vendor.staffs[0] ? vm.invoice.vendor.staffs[0]._id : undefined;
            }
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }

        vm.invoice.date = moment($scope.invoiceDataVA.date)._d;
        vm.invoice.dueDate = moment($scope.invoiceDataVA.dueDate)._d;

        for (var i = 0; i < vm.invoice.items.length; i++) {
          vm.invoice.items[i].itemId = vm.invoice.items[i].type;
          vm.invoice.items[i].itemNum = vm.invoice.items[i].number;
        }
      }

      $scope.loading = true;
      Promise.all([vm.project._id === 'all' ? apiFactory.listAllCompanyInvoiceUsers() : apiFactory.listAllProjectTeamUsers(vm.project._id), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.getCompanyById(vm.userData.companyId), apiFactory.getEconomicSettingInvoiceItems(), apiFactory.getInvoiceAccountPlans()]).then(function (resp) {
        $scope.loading = false;
        vm.userListTemp = [];
        vm.teamUsers = resp[0].data.data;

        if (vm.teamUsers.clients) {
          vm.teamUsers.clients.forEach(function (client) {
            vm.userListTemp.push({
              _id: 'Client_' + client._id,
              name: 'Client - ' + client.clientName
            });
          });
        }

        if (vm.teamUsers.suppliers) {
          vm.teamUsers.suppliers.forEach(function (user) {
            vm.userListTemp.push({
              _id: 'Supplier_' + user._id,
              name: 'Supplier - ' + user.name
            });
          });
        }

        if (vm.teamUsers.subContractors) {
          vm.teamUsers.subContractors.forEach(function (user) {
            vm.userListTemp.push({
              _id: 'Subcontractor_' + user._id,
              name: 'Subcontractor - ' + user.name
            });
          });
        }

        vm.allItems = [].concat(resp[1].data.list, resp[2].data.list, resp[3].data.list);
        vm.companyData = resp[4].data;
        vm.paymentConditions = angular.copy(vm.companyData.paymentConditions);
        vm.paymentConditions.map(function (x) {
          // x.range = `${x.from} - ${x.to} (${x.percentage}%)`;
          x.validate = false;
        });
        vm.economicSettingItems = resp[5].data.data || [];
        vm.economicSettingItems.forEach(function (item) {
          item.label = item.description || item.type;
          item.type = item.plan.name;
          item.type_id = item.plan._id;
          item.vat = item.plan.vat;
          item.tax = item.plan.tax;
        });
        vm.accountPlans = resp[6].data.data || [];
        vm.accountPlans.forEach(function (accountPlan) {
          accountPlan.label = accountPlan.number + "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0" + accountPlan.name;
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.log(err);
      });
      globals.getCurrency().then(function (resp) {
        var getCurrencyCode = resp.data;
        $scope.companyCurrency = getCurrencyCode.find(function (element) {
          return element.cc === vm.companyData.currentCurrency.currencyCode;
        });
      });
    }

    $scope.invoiceDateChanged = function () {
      getDueDate();
    };

    vm.addPaymentTerm = function (data) {
      if (!data) {
        return;
      }

      vm.invoice.paymentTerms = [data];
      getDueDate();
      angular.forEach(vm.invoice.paymentTerms, function (x) {
        angular.forEach(vm.paymentConditions, function (y) {
          if (x.from <= y.from) {
            y.validate = y.from <= x.to;
          } else {
            y.validate = x.from <= y.to ? y.to <= x.to : false;
          }
        });
      });
    };

    vm.deletePaymentTerm = function (index) {
      vm.invoice.paymentTerms.splice(index, 1);
      vm.invoice.dueDate = null;
    };

    vm.changeVendor = function (id) {
      if (!id) {
        return;
      }

      var vendorType;
      var userId;

      if (id.includes('_')) {
        vendorType = id.split('_')[0];
        userId = id.split('_')[1];
      } else {
        vendorType = 'Client';
        userId = id;
      }

      vm.invoice.vendorType = vendorType;
      var userList = (vendorType === 'Client' ? vm.teamUsers.clients : vendorType === 'Supplier' ? vm.teamUsers.suppliers : vm.teamUsers.subContractors) || [];
      var user = userList.find(function (x) {
        return x._id === userId;
      });

      if (user) {
        vm.invoice.vendor = user;

        if (vm.recipients.emails.length > 0) {
          vm.recipients.emails[0] = vm.invoice.vendor.email;
        } else {
          vm.recipients.emails = [vm.invoice.vendor.email];
        }
      }

      if (vm.invoice.vendor) {
        var address = vendorType === 'Client' ? vm.invoice.vendor.address[0] : vm.invoice.vendor.address;

        if (!utils.isEmpty(address)) {
          vm.invoice.vendorAddress = "".concat(address.line1, " ").concat(address.city, " ").concat(address.countryCode);
        }

        vm.invoice.staff = vm.invoice.vendor.staffs[0] ? vm.invoice.vendor.staffs[0]._id : undefined;
      }
    };

    vm.addInvoiceRow = function () {
      vm.invoice.items.push({
        isEdit: true
      });
    };

    vm.removeInvoiceRow = function (index) {
      if (vm.invoice.totalPrice && vm.invoice.items[index].price) {
        vm.invoice.totalPrice = vm.invoice.totalPrice - vm.invoice.items[index].price;
      }

      if (vm.invoice.totalVat && vm.invoice.items[index].vatAmount) {
        vm.invoice.totalVat = vm.invoice.totalVat - vm.invoice.items[index].vatAmount;
      }

      if (vm.invoice.totalTax && vm.invoice.items[index].taxAmount) {
        vm.invoice.totalTax = vm.invoice.totalTax - vm.invoice.items[index].taxAmount;
      }

      if (vm.invoice.totalAmount && vm.invoice.items[index].price && vm.invoice.items[index].vatAmount && vm.invoice.items[index].taxAmount) {
        vm.invoice.totalAmount = vm.invoice.totalAmount - vm.invoice.items[index].price - vm.invoice.items[index].vatAmount - vm.invoice.items[index].taxAmount;
      }

      vm.invoice.items.splice(index, 1);
      var rowCount = vm.invoice.items.length;

      if (rowCount < 1) {
        vm.addInvoiceRow();
      }
    };

    vm.editInvoiceRow = function (item) {
      item.isEdit = true;
    };

    vm.confirmInvoiceRow = function (item) {
      if (!item.itemId) {
        Notification.error('Please fill Sr.No.');
        return;
      }

      if (!item.itemNum) {
        Notification.error('Please fill type.');
        return;
      }

      if (utils.isEmpty(item.description)) {
        Notification.error('Please fill description');
        return;
      }

      item.isEdit = false;
    };

    vm.selectItemType = function (params, item, typeOrNum) {
      var type;

      if (item && params) {
        if (typeOrNum === 'accountPlan') {
          item.settingItems = vm.economicSettingItems.filter(function (it) {
            return it.type_id === params;
          });

          if (item.settingItems.length > 0) {
            type = item.settingItems[0];
            item.itemNum = type._id ? type._id : null;
            item.type = type;
          } else {
            item.itemNum = undefined;
          }
        } else if (typeOrNum === 'settingItem') {
          type = vm.economicSettingItems.find(function (it) {
            return it._id === params;
          });
          item.type = type;
        }

        if (type) {
          item.taxPercent = type.tax;
          item.vatPercent = type.vat; // item.description = '';

          if (type.category === "ServiceCar") {
            item.unitPrice = type.price;
            item.isServiceAndVAOrder = false;
            delete item.matId;
            delete item.eqId;
          }

          if (type.category == "Labor") {
            item.unitPrice = type.salesPrice;
            item.isServiceAndVAOrder = false;
            delete item.matId;
            delete item.eqId;
          }

          if (type.category == "ServiceAndVAOrder") {
            // item.unitPrice = 0;
            item.profit = type.profit;
            item.cost = type.cost;
            item.isServiceAndVAOrder = true;
          }
        }

        item.isSelType = true;
        vm.calculateItemPrice(item);
      }
    };

    vm.searchItemDescription = function (item, query) {
      vm.curItem = item;
      $scope.filteredItems = filterItems(vm.allItems, query);
    };

    vm.selectItemDescription = function (item, data) {
      vm.curItem = undefined;
      $scope.filteredItems = [];

      if (data.currentRate) {
        item.unitPrice = 0;

        if (data.currentRate.materialCost) {
          item.unitPrice += data.currentRate.materialCost.value;
        } // if (data.currentRate.rooferCost) {
        //   item.unitPrice += data.currentRate.rooferCost.value;
        // }


        if (data.currentRate.equipmentCost) {
          item.unitPrice += data.currentRate.equipmentCost.value;
        }

        if (item.type.profit && item.type.cost) {
          item.unitPrice = item.unitPrice * (100 + item.type.profit + item.type.cost) / 100;
        } else if (item.type.profit && !item.type.cost) {
          item.unitPrice = item.unitPrice * (100 + item.type.profit) / 100;
        } else if (!item.type.profit && item.type.cost) {
          item.unitPrice = item.unitPrice * (100 + item.type.cost) / 100;
        }

        if (item.unitPrice === 0) {
          item.unitPrice = 1;
        }
      } else {
        item.unitPrice = 1;
      }

      item.description = data.name;

      if (data.systemTag.includes('MATRL')) {
        item.matId = data._id;
        delete item.eqId;
      } else {
        item.eqId = data._id;
        delete item.matId;
      }

      if (utils.isEmpty(item.quantity)) {
        item.quantity = 1;
      }

      vm.calculateItemPrice(item);
    };

    function filterItems(items, filter) {
      var output = [];

      if (filter && filter.length >= 2) {
        angular.forEach(items, function (item) {
          if (item.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
            output.push(item);
          }
        });
      }

      return output;
    }

    vm.calculateItemPrice = function (item) {
      if (angular.isUndefined(item.quantity) || isNaN(item.quantity)) {
        item.quantity = 1;
      }

      if (angular.isUndefined(item.unitPrice) || isNaN(item.unitPrice)) return;
      item.price = item.quantity * item.unitPrice;

      if (angular.isDefined(item.vatPercent) && !isNaN(item.vatPercent)) {
        item.vatAmount = item.price * item.vatPercent / 100;
      }

      if (angular.isDefined(item.taxPercent) && !isNaN(item.taxPercent)) {
        item.taxAmount = item.price * item.taxPercent / 100;
      }

      calculateSummary();
    };

    function calculateSummary() {
      vm.invoice.totalPrice = 0;
      vm.invoice.totalVat = 0;
      vm.invoice.totalTax = 0;
      vm.invoice.totalAmount = 0;

      var _iterator = _createForOfIteratorHelper(vm.invoice.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.price) {
            vm.invoice.totalPrice += item.price;
          }

          if (item.vatAmount) {
            vm.invoice.totalVat += item.vatAmount;
          }

          if (item.taxAmount) {
            vm.invoice.totalTax += item.taxAmount;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      vm.invoice.totalAmount = vm.invoice.totalPrice + vm.invoice.totalVat + vm.invoice.totalTax;
    }

    vm.save = function (draft) {
      if (!checkValidate()) {
        return;
      }

      var invoiceData = prepareInvoiceData(vm.invoice);

      if (vm.isCreditMemo && invoiceData.vendor != invoiceData.creditVendor) {
        Notification.error("Invoice and memo's vendor is different");
        return;
      }

      if (invoiceData != null) {
        if (!draft) {
          invoiceData.status = "pending";
        }

        $scope.loading = true;
        apiFactory.createInvoice(invoiceData).then(function (resp) {
          $scope.loading = false;
          Notification.success("Invoice created successfully");
          vm.invoice._id = resp.data.data._id;
          vm.invoice.displaySeq = resp.data.data.displaySeq;
          vm.invoice.invoiceDoc = resp.data.data.invoiceDoc;
          vm.isCreditMemo = false;
          $state.go('invoiceList');
        })["catch"](function (e) {
          $scope.loading = false;
          Notification.error(utils.getErrorMessage(e));
          $log.error(e);
        });
      }
    };

    vm.showRecipientsPopup = function (needSend) {
      if (!checkValidate()) {
        return;
      }

      $uibModal.open({
        animation: true,
        component: 'recipientsModal',
        windowClass: 'recipients-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          recipients: function recipients() {
            return vm.recipients;
          },
          title: function title() {
            return 'Invoice / Credit Memo';
          },
          send: function send() {
            return needSend;
          }
        }
      }).result.then(function (result) {
        if (result) {
          send();
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.showImportInvoicePopup = function () {
      $uibModal.open({
        animation: true,
        component: 'importInvoiceModal',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          invoice: function invoice() {
            return vm.invoice;
          }
        }
      }).result.then(function (result) {
        if (result) {
          vm.invoice.creditNote = result;
          importInvoiceItems();
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.toggleProjectOverview = function () {
      showOverview = !showOverview;

      if (showOverview) {
        angular.element('#project-overview').css('visibility', 'visible');
      } else {
        angular.element('#project-overview').css('visibility', 'hidden');
      }
    };

    function importInvoiceItems() {
      vm.invoice.items = [];
      vm.invoice.creditVendor = vm.invoice.creditNote.vendor ? vm.invoice.creditNote.vendor._id : '';

      if (vm.invoice.creditNote.items) {
        vm.invoice.creditNote.items.forEach(function (item) {
          if (item.checked) {
            item.checked = false;
            item.itemId = item.type && item.type._id ? item.type._id : item.type;
            item.itemNum = item.number;
            vm.invoice.items.push(item);
          }
        });
      }

      calculateSummary();
    }

    function getDueDate() {
      if (vm.invoice.date && vm.invoice.paymentTerms && vm.invoice.paymentTerms.length > 0) {
        var term = vm.invoice.paymentTerms[0];
        var additionalDays = utils.getDaysFromPaymentTermsCode(term.code);
        var newDate = moment(vm.invoice.date).clone();

        if (additionalDays) {
          var endDate = moment(newDate);

          if (additionalDays.w) {
            endDate = moment(newDate).isoWeek(7);
          } else if (additionalDays.m) {
            endDate = moment(newDate).endOf('month');
          }

          vm.invoice.dueDate = endDate.add(additionalDays.days, 'days');
          vm.invoice.dueDate = vm.invoice.dueDate._d;
        }
      }
    }

    function prepareInvoiceData(data) {
      if (!data.vendorType) {
        Notification.error("Please select user");
      } else if (data.vendor.staffs.length && !data.staff) {
        Notification.error('Please select staff');
      } else if (!data.date) {
        Notification.error("Please select date");
      } else if (!data.dueDate) {
        Notification.error("Please select Payment Terms");
      } else if (!vm.invoice.status) {
        Notification.error("Please select invoice status");
      } else if (data.items.length === 0) {
        Notification.error("Please add invoice Items");
      } else {
        var items = [];
        data.items.forEach(function (item) {
          if (item.description) {
            var itemdata = {
              type: item.itemId,
              number: item.itemNum,
              description: item.description,
              quantity: item.quantity,
              unitPrice: item.unitPrice,
              vatPercent: item.vatPercent,
              vatAmount: item.vatAmount,
              taxPercent: item.taxPercent,
              taxAmount: item.taxAmount,
              price: item.price
            };

            if (item.matId) {
              itemdata.matId = item.matId;
            }

            if (item.eqId) {
              itemdata.eqId = item.eqId;
            }

            items.push(itemdata);
          }
        });
        var invoiceData = {
          date: moment(data.date).format(),
          dueDate: moment(data.dueDate).format(),
          termsAndConditions: data.termsAndConditions,
          items: items,
          recipients: vm.recipients,
          status: data.status,
          isCreditMemo: vm.isCreditMemo,
          paymentTerms: data.paymentTerms,
          totalPrice: data.totalPrice,
          totalVat: data.totalVat,
          totalTax: data.totalTax,
          totalAmount: data.totalAmount,
          companyCurrency: data.companyCurrency ? data.companyCurrency : $scope.companyCurrency,
          fromVariationOrder: data.fromVariationOrder ? data.fromVariationOrder : false
        };

        if (vm.project._id !== 'all') {
          invoiceData.projectId = data.projectId ? data.projectId : vm.project._id;
        }

        if (data.projectSystemTag) {
          invoiceData.projectSystemTag = data.projectSystemTag;
        }

        if (vm.invoice._id) {
          invoiceData._id = vm.invoice._id;
        }

        invoiceData.vendorType = data.vendorType;
        invoiceData.vendor = data.vendor._id ? data.vendor._id : data.vendor;
        invoiceData.staff = data.staff;
        invoiceData.referenceNo = vm.invoice.referenceNo;

        if (vm.isCreditMemo) {
          if (data.creditNote) {
            invoiceData.creditNote = data.creditNote._id;
          }

          invoiceData.isCreditMemo = true;
        }

        return invoiceData;
      }

      return null;
    }

    function send() {
      var invoiceData = prepareInvoiceData(vm.invoice);

      if (invoiceData) {
        $scope.loading = true;
        apiFactory.createAndSendInvoice(invoiceData).then(function (resp) {
          $scope.loading = false;
          Notification.success("Invoice saved and sent successfully");
          vm.invoice.displaySeq = resp.data.data.displaySeq;
          vm.invoice.invoiceDoc = resp.data.data.invoiceDoc;
          vm.isCreditMemo = false;
          $state.go('invoiceList');
        })["catch"](function (e) {
          $scope.loading = false;
          Notification.error(utils.getErrorMessage(e));
          $log.error(e);
        });
      }
    }

    function checkValidate() {
      if (utils.isEmpty(vm.invoice.vendor)) {
        Notification.error('Please select customer');
        return false;
      }

      if (utils.isEmpty(vm.invoice.paymentTerms)) {
        Notification.error('Please Select Payment Terms');
        return false;
      }

      if (utils.isEmpty(vm.invoice.items)) {
        Notification.error('Please add lines');
        return false;
      }

      return true;
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("projectOverview", projectOverview);

  function projectOverview(globals, apiFactory, utils, $log, ecoFactory) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: "app/main/economic/directives/projectOverview/projectOverview.view.html",
      scope: {},
      link: function link($scope) {
        var projectStore = globals.projectStore,
            companyStore = globals.companyStore;
        var project = projectStore.get();
        var companyData = companyStore.get();
        $scope.currency = companyData.currentCurrency.currencyCode;
        $scope.rows = [{
          name: 'Subcontractor',
          cost: 0,
          approvedCost: 0,
          pendingCost: 0,
          profitPercent: 0,
          profit: 0,
          salesPrice: 0,
          approved: true,
          pending: true,
          option: true
        }, {
          name: 'Supplier',
          cost: 0,
          approvedCost: 0,
          pendingCost: 0,
          profitPercent: 0,
          profit: 0,
          salesPrice: 0,
          approved: true,
          pending: true,
          option: true
        }, {
          name: 'Labor cost',
          cost: 0,
          profitPercent: 0,
          profit: 0,
          salesPrice: 0,
          approved: true,
          pending: true,
          option: false
        }, {
          name: 'Company',
          cost: 0,
          profitPercent: 0,
          profit: 0,
          salesPrice: 0,
          approved: true,
          pending: true,
          option: false
        }];
        $scope.summary = [{
          name: 'Sum',
          cost: 0,
          profitPercent: 0,
          profit: 0,
          salesPrice: 0
        }, {
          name: 'Previously Invoiced',
          cost: 0,
          profitPercent: 0,
          profit: 0,
          salesPrice: 0
        }];
        var query1 = project && project._id !== "all" ? {
          projectId: project._id
        } : {};
        var query2 = project && project._id !== "all" ? {
          projects: [project._id]
        } : {};
        $scope.isLoading = true;
        Promise.all([apiFactory.getProfit(project._id), apiFactory.listAllBillings(query1), apiFactory.listAllPayrolls(query2), apiFactory.listAllInvoices(query1)]).then(function (resp) {
          var profit = utils.num(resp[0].data.data.profit);
          var billings = resp[1].data.list;

          if (billings) {
            billings.forEach(function (bill) {
              if (bill.vendorType === 'Subcontractor') {
                if (bill.status === 'approved') {
                  $scope.rows[0].approvedCost += utils.num(bill.totalAmount);
                } else if (bill.status === 'pending') {
                  $scope.rows[0].pendingCost += utils.num(bill.totalAmount);
                }
              } else {
                if (bill.status === 'approved') {
                  $scope.rows[1].approvedCost += utils.num(bill.totalAmount);
                } else if (bill.status === 'pending') {
                  $scope.rows[1].pendingCost += utils.num(bill.totalAmount);
                }
              }
            });
          }

          var payrolls = resp[2].data.list;

          if (payrolls) {
            payrolls.forEach(function (payroll) {
              var salary = ecoFactory.getPayrollWorkedSalary(payroll);
              $scope.rows[2].cost += salary;
            });
          }

          var invoices = resp[3].data.list;

          if (invoices) {
            invoices.forEach(function (invoice) {
              if (invoice.status === 'paid') {
                $scope.rows[3].cost += utils.num(invoice.totalPrice);
              }

              $scope.summary[1].cost += utils.num(invoice.totalPrice);
              $scope.summary[1].profit += utils.num(invoice.totalVat);
              $scope.summary[1].salesPrice += utils.num(invoice.totalAmount);
            });
          }

          $scope.rows[3].cost *= profit;
          $scope.summary[1].profitPercent = $scope.summary[1].profit / $scope.summary[1].cost * 100;

          for (var i = 0; i < 4; i++) {
            $scope.rows[i].profitPercent = profit;
            calcRow($scope.rows[i]);
          }

          calcSummary();
          $scope.isLoading = false;
        })["catch"](function (err) {
          $log.error(err);
          $scope.isLoading = false;
        });

        $scope.calculateRow = function (row) {
          calcRow(row);
          calcSummary();
        };

        function calcRow(row) {
          if (row.option) {
            row.cost = (row.approved ? utils.num(row.approvedCost) : 0) + (row.pending ? utils.num(row.pendingCost) : 0);
          } else {
            row.cost = utils.num(row.cost);
          }

          var percent = utils.num(row.profitPercent);
          row.profit = row.cost * percent / 100;
          row.salesPrice = row.cost + row.profit;
        }

        function calcSummary() {
          $scope.summary[0].cost = 0;
          $scope.summary[0].profit = 0;
          $scope.summary[0].salesPrice = 0;

          for (var i = 0; i < 4; i++) {
            $scope.summary[0].cost += $scope.rows[i].cost;
            $scope.summary[0].profit += $scope.rows[i].profit;
            $scope.summary[0].salesPrice += $scope.rows[i].salesPrice;
          }

          $scope.summary[0].profitPercent = $scope.summary[0].profit / $scope.summary[0].cost * 100;
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("pdfViewer", pdfViewer);

  function pdfViewer($sce, $log, $document) {
    return {
      restrict: "E",
      templateUrl: "app/main/economic/directives/pdfViewer/pdfViewer.view.html",
      scope: {
        url: "=",
        fileUrl: "=",
        ngClose: "="
      },
      link: function link($scope) {
        if ($scope.url) {
          $scope.embedUrl = $sce.trustAsResourceUrl('https://docs.google.com/gview?url=' + encodeURI($scope.url) + '&embedded=true');
        }

        if ($scope.fileUrl) {
          $scope.blobUrl = $sce.trustAsResourceUrl($scope.fileUrl + '#toolbar=0&navpanes=0');
        }

        $scope.$watch('url', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          $scope.embedUrl = $sce.trustAsResourceUrl('https://docs.google.com/gview?url=' + encodeURI(newValue) + '&embedded=true');
        });
        $scope.$watch('fileUrl', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          $scope.blobUrl = $sce.trustAsResourceUrl($scope.fileUrl + '#toolbar=0&navpanes=0');
        });

        $scope.closeViewer = function () {
          if ($scope.ngClose) {
            $scope.ngClose();
          }
        };

        $scope.downloadPdf = function () {
          var a = $document[0].createElement("a");
          $document[0].body.appendChild(a);
          a.href = $scope.url ? $scope.url : $scope.fileUrl;
          a.download = 'data.pdf';
          a.click();
        };
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').directive('payrollReceipt', payrollReceipt);

  function payrollReceipt(ecoFactory, $uibModal, $log, Notification) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/economic/directives/payrollReceipt/payrollReceipt.view.html',
      replace: true,
      scope: {
        ngModel: "=",
        up: "="
      },
      link: function link(scope) {
        scope.opened = false;

        scope.toggleDropdown = function () {
          scope.opened = !scope.opened;
        };

        scope.fileUpdated = function (files, event) {
          var fileObj = event.target.files;
          scope.fileNames = Object.keys(fileObj).map(function (x) {
            return fileObj[x].name;
          });
          angular.forEach(files, function (x) {
            x.description = "";

            if (scope.ngModel.receipt.length === 0) {
              scope.ngModel.receipt.push(x);
            } else {
              var duplicateImg = false;
              angular.forEach(scope.uploadImg, function (y) {
                if (x.name === y.name) {
                  duplicateImg = true;
                }
              });

              if (!duplicateImg) {
                scope.ngModel.receipt.push(x);
              } else {
                Notification.error("File name already exist");
              }
            }
          });
        };

        scope.deleteFile = function (indexVal, type) {
          if (type === 'image') {
            scope.ngModel.receipt.splice(indexVal, 1);
          } else if (type === 'recipient') {
            scope.ngModel.receipts.splice(indexVal, 1);
          }
        };

        scope.previewImage = function (f) {
          $uibModal.open({
            animation: true,
            component: 'imagePreviewModal',
            backdrop: 'static',
            windowClass: 'economic-preview-image-modal',
            resolve: {
              imageURL: function imageURL() {
                return f;
              }
            }
          }).result.then(function (result) {
            $log.info(result);
          }, function (reason) {
            $log.info(reason);
          });
        };

        scope.getReceiptsLength = function () {
          var length = 0;

          if (scope.ngModel) {
            if (scope.ngModel.receipts) {
              length += scope.ngModel.receipts.length;
            }

            if (scope.ngModel.receipt) {
              length += scope.ngModel.receipt.length;
            }
          }

          return length;
        };
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').directive('payrollDriving', payrollDriving);

  function payrollDriving(ecoFactory, $uibModal, $log, utils) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/economic/directives/payrollDriving/payrollDriving.view.html',
      replace: true,
      scope: {
        ngModel: "=",
        up: "="
      },
      link: function link(scope) {
        scope.showDriving = function () {
          $uibModal.open({
            animation: true,
            component: 'drivingModal',
            backdrop: 'static',
            windowClass: 'economic-driving-modal',
            resolve: {
              driving: function driving() {
                return scope.ngModel.driving;
              }
            }
          }).result.then(function (result) {
            scope.ngModel.driving = result;
            getTotalDistance();
          }, function (reason) {
            $log.info(reason);
          });
        };

        function getTotalDistance() {
          scope.ngModel.distance = utils.num(scope.ngModel.driving.distance);
        }
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').directive('payrollBreakup', payrollBreakup);

  function payrollBreakup(ecoFactory, utils, globals, $timeout) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/economic/directives/payrollBreakup/payrollBreakup.view.html',
      replace: true,
      scope: {
        ngModel: "=",
        up: "="
      },
      link: function link(scope, element) {
        var companyStore = globals.companyStore;
        var companyData = companyStore.get();
        scope.is12Format = companyData && companyData.timeShowMethod === '12 hr';
        scope.opened = false;
        scope.fromHour = 12;
        scope.fromMinute = 0;
        scope.fromPm = false;
        scope.toHour = scope.is12Format ? 1 : 13;
        scope.toMinute = 59;
        scope.toPm = scope.is12Format;
        var fromHours = element.find("#from-hours")[0];
        var fromMinutes = element.find("#from-minutes")[0];
        var toHours = element.find("#to-hours")[0];
        var toMinutes = element.find("#to-minutes")[0];
        fromHours.addEventListener("input", formatFromHours);
        fromMinutes.addEventListener("input", formatFromMinutes);
        toHours.addEventListener("input", formatToHours);
        toMinutes.addEventListener("input", formatToMinutes);

        scope.toggleDropdown = function () {
          scope.opened = !scope.opened;
        };

        scope.getBreak = function () {
          if (!scope.ngModel) return 0;
          return ecoFactory.getPayrollBreak(scope.ngModel);
        };

        scope.onOK = function () {
          if (utils.isEmpty(scope.fromHour) || utils.isEmpty(scope.fromMinute) || utils.isEmpty(scope.toHour) || utils.isEmpty(scope.toMinute)) {
            return;
          }

          if (!scope.ngModel.breakup) {
            scope.ngModel.breakup = {};
          }

          var startTime = new Date(),
              endTime = new Date();

          if (scope.is12Format) {
            startTime.setHours(utils.num(scope.fromHour) + (scope.fromPm ? 12 : 0), utils.num(scope.fromMinute), 0, 0);
            endTime.setHours(utils.num(scope.toHour) + (scope.toPm ? 12 : 0), utils.num(scope.toMinute), 0, 0);
          } else {
            startTime.setHours(utils.num(scope.fromHour), utils.num(scope.fromMinute), 0, 0);
            endTime.setHours(utils.num(scope.toHour), utils.num(scope.toMinute), 0, 0);
          }

          scope.ngModel.breakup.startTime = startTime;
          scope.ngModel.breakup.endTime = endTime;
          scope.opened = false;
        };

        scope.onAmPm = function ($event, pm, from) {
          $event.stopPropagation();

          if (from) {
            scope.fromPm = pm;
          } else {
            scope.toPm = pm;
          }
        };

        scope.$watch('ngModel', function (newVal) {
          if (newVal && newVal.breakup) {
            var startTime = new Date(newVal.breakup.startTime);
            var endTime = new Date(newVal.breakup.endTime);
            scope.fromHour = startTime.getHours();
            scope.fromMinute = startTime.getMinutes();
            scope.fromPm = scope.fromHour > 12;
            scope.toHour = endTime.getHours();
            scope.toMinute = endTime.getMinutes();
            scope.toPm = scope.toHour > 12;

            if (scope.is12Format) {
              scope.fromHour %= 12;
              scope.toHour %= 12;
            }

            $timeout(function () {
              formatFromHours();
              formatFromMinutes();
              formatToHours();
              formatToMinutes();
            });
          }
        });

        function formatFromHours() {
          fromHours.value = addLeadingZero(fromHours.value);
        }

        function formatFromMinutes() {
          fromMinutes.value = addLeadingZero(fromMinutes.value);
        }

        function formatToHours() {
          toHours.value = addLeadingZero(toHours.value);
        }

        function formatToMinutes() {
          toMinutes.value = addLeadingZero(toMinutes.value);
        }

        function addLeadingZero(value) {
          return value.length < 2 ? "0" + value : value;
        }

        $timeout(function () {
          formatFromHours();
          formatFromMinutes();
          formatToHours();
          formatToMinutes();
        });
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('billScanner', {
    controller: BillScannerController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/bill/billScanner/billScanner.view.html'
  });
  /** @ngInject */

  function BillScannerController($scope, $uibModal, $log, apiFactory, Notification, globals, $rootScope, $state, $timeout, $window, $document, utils, localStorageService) {
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore,
        userStore = globals.userStore;
    var vm = this;
    vm.project = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    $scope.currentPage = 'Pending';
    vm.bShowApproved = false;
    vm.pendingBills = [];
    vm.vendorCredits = [];
    vm.companyBills = [];
    vm.vendors = [];
    vm.billing = null;
    vm.memo = null;
    vm.companyBilling = null;
    vm.currentIndex = 0;
    vm.currentMemoIndex = 0;
    vm.currentCompanyIndex = 0;
    $scope.isLoading = false;

    $scope.setCurrentPage = function (page) {
      $scope.currentPage = page;
      getBillingList();
    }; // getPendingBillingList();


    getBillingList();

    vm.openUploadNewBillModal = function () {
      var uploadModal = $uibModal.open({
        animation: true,
        component: 'uploadNewBillModal',
        windowClass: 'upload-new-bill-modal',
        resolve: {}
      });
      uploadModal.result.then(function (result) {
        if (result.action == 'upload') {
          // if($scope.currentPage == 'Pending' && vm.project._id == 'all') {
          //   Notification.error("Please select project first");
          //   return;
          // }
          if (!result.data) return;
          $scope.isLoading = true;
          Notification.success("Uploading bills started. This might take some time");
          $log.log(result);
          apiFactory.uploadBillDocument(result.data).then(function (resp) {
            $scope.isLoading = false; // $log.log(resp);

            if (resp.data.list.length) {
              result.data.data.billDate = [];
              result.data.data.dueDate = [];
              result.data.data.vendorType = "Supplier";
              result.data.data.vendors = [];

              for (var i = 0; i < resp.data.list.length; i++) {
                var data = resp.data.list[i];
                result.data.data.billDate[i] = data.billDate;
                result.data.data.dueDate[i] = getDueDate(data.billDate, data.vendor); // result.data.data.vendorType[i] = "Supplier";

                result.data.data.vendors[i] = data.vendor ? data.vendor._id : "";
              }

              if ($scope.currentPage == 'Pending' || $scope.currentPage == 'VendorCredit') {
                result.data.data.projectId = vm.project._id;
              }

              Notification.success("Finish find out client from bill");
              $log.log("text = ", resp.data.data); // let vendor = resp.data.data.vendor;
              // $scope.vendorDetail = resp.data.data.vendor;
              // if (vendor.bankDetails && vendor.bankDetails[0]) {
              //   $scope.bankDetails = vendor.bankDetails[0];
              // }
              // let address = {};
              // if (vendor.address) {
              //   address = vendor.address[0] ? vendor.address[0] :
              //     vendor.address ? vendor.address :
              //       vendor.address1 ? vendor.address1 :
              //         vendor.address2 ? vendor.address2 : '';
              // }
              // $scope.vendorDetail.address = address;
              // $scope.vendorDetail.fullAddress = '';
              // if ($scope.vendorDetail.address.line1) {
              //   $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.line1 + ', ';
              // }
              // if ($scope.vendorDetail.address.city) {
              //   $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.city + ', ';
              // }
              // if ($scope.vendorDetail.address.countryCode) {
              //   $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.countryCode + ', ';
              // }
              // $scope.vendorDetail.phoneNumber = vendor.clientContact ? vendor.clientContact.dialCode + vendor.clientContact.phoneNumber :
              //   vendor.contact ? vendor.contact.dialCode + vendor.contact.phoneNumber :
              //     vendor.mobile ? vendor.mobile.dialCode + vendor.mobile.phoneNumber : '';
              // $scope.vendorDetail.vat = vendor.paymentTerms && vendor.paymentTerms.vatPercent ? vendor.paymentTerms.vatPercent : 0;
              // $scope.vendorDetail.vatNumber = vendor.paymentTerms && vendor.paymentTerms.vatNumber ? vendor.paymentTerms.vatNumber : 0;
              // $scope.billDateString = resp.data.data.billDate;

              apiFactory.createBilling(result.data).then(function () {
                Notification.success("Bills successfully created. Updating Bill data again.");
                getBillingList();

                if (result.data.data.isMemo) {
                  $scope.currentPage = 'VendorCredit';
                } else if (vm.project._id == 'all') {
                  $scope.currentPage = 'Company';
                } else {
                  $scope.currentPage = 'Pending';
                }
              })["catch"](function (e) {
                $log.log(e);
                Notification.error("Uploading bills failed.");
                Notification.error(utils.getErrorMessage(e));
              });
            } else {
              Notification.error(resp.message);
            }
          });
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.approve = function () {
      var _billing = null;

      if ($scope.currentPage == 'Pending') {
        _billing = vm.billing;
      } else if ($scope.currentPage == 'Company') {
        _billing = vm.companyBilling;
      } else {
        _billing = vm.memo;
      }

      if (angular.isUndefined(_billing)) return;

      if (angular.isUndefined(_billing.amountWithoutTax) || angular.isUndefined(_billing.totalAmount)) {
        Notification.error("Please input prices.");
        return;
      }

      if (!_billing.billType) {
        Notification.error("Please Select Bill Type");
        return;
      }

      if (angular.isUndefined(_billing.taxAmount)) {
        _billing.taxAmount = 0;
      }

      if (!_billing.customSupplierData.invoicenumber) {
        Notification.error("No Invoice Number.");
        return;
      }

      if (!_billing.billDate) {
        Notification.error("Bill Date is not selected.");
        return;
      }

      if (!_billing.dueDate) {
        Notification.error("Due Date is not selected.");
        return;
      }

      if (!_billing.vendor) {
        Notification.error("Vendor is not selected.");
        return;
      }

      var checkData = {
        id: _billing._id,
        vendorId: _billing.vendor ? _billing.vendor._id : undefined,
        customSupplierData: _billing.customSupplierData,
        projectId: _billing.projectId && _billing.projectId._id ? _billing.projectId._id : _billing.projectId
      };
      apiFactory.checkDuplicatedBillingData(checkData).then(function (resp) {
        if (resp.data.data.isDuplicated) {
          Notification.error('Duplicated Invoice Number');
        } else {
          var approveModal = $uibModal.open({
            animation: true,
            component: 'approveBillModal',
            windowClass: 'approve-bill-modal',
            resolve: {
              billing: function billing() {
                return _billing;
              }
            }
          });
          approveModal.result.then(function (result) {
            $log.log(result);

            _approveBillingData(null, result);
          }, function (reason) {
            $log.info(reason);
          });
        }
      })["catch"](function (err) {
        $log.log(err);
      });
    };

    vm.decline = function () {
      var billing = null;

      if ($scope.currentPage == 'Pending') {
        billing = vm.billing;
      } else if ($scope.currentPage == 'Company') {
        billing = vm.companyBilling;
      } else {
        billing = vm.memo;
      }

      if (angular.isUndefined(billing)) {
        Notification.error('Invalid Billing Data');
        return;
      }

      if (!billing.billType) {
        Notification.error('Please Select Billing Type');
        return;
      }

      $uibModal.open({
        animation: true,
        component: "declineBillModal",
        windowClass: "decline-bill-modal",
        backdrop: "static",
        keyboard: false
      }).result.then(function (description) {
        $scope.isLoading = true;
        apiFactory.approveBill({
          billId: billing._id,
          status: "declined",
          customSupplierData: billing.customSupplierData,
          billType: billing.billType,
          amountWithoutTax: billing.amountWithoutTax,
          taxAmount: billing.taxAmount,
          totalAmount: billing.totalAmount,
          description: description
        }).then(function () {
          $scope.isLoading = false;
          Notification.success("Billing is declined.");
          getBillingList();
        })["catch"](function (err) {
          $scope.isLoading = false;
          Notification.error(err.data.message);
        });
      })["catch"](function () {});
    };

    vm.pending = function () {
      var billing = null;

      if ($scope.currentPage == 'Pending') {
        billing = vm.billing;
      } else if ($scope.currentPage == 'Company') {
        billing = vm.companyBilling;
      } else {
        billing = vm.memo;
      }

      if (angular.isUndefined(billing.amountWithoutTax) || angular.isUndefined(billing.totalAmount)) {
        Notification.error("Please input prices.");
        return;
      }

      if (angular.isUndefined(billing)) {
        Notification.error('Invalid Billing Data');
        return;
      }

      if (!billing.billType) {
        Notification.error('Please Select Billing Type');
        return;
      }

      if (!billing.billDate) {
        Notification.error("Bill Date is not selected.");
        return;
      }

      if (!billing.dueDate) {
        Notification.error("Due Date is not selected.");
        return;
      }

      if (!billing.vendor) {
        Notification.error("Vendor is not selected.");
        return;
      }

      $scope.isLoading = true;
      apiFactory.approveBill({
        billId: billing._id,
        status: "pending",
        customSupplierData: billing.customSupplierData,
        billType: billing.billType,
        amountWithoutTax: billing.amountWithoutTax,
        taxAmount: billing.taxAmount,
        totalAmount: billing.totalAmount,
        vendor: billing.vendor ? billing.vendor._id : null
      }).then(function () {
        $scope.isLoading = false;
        Notification.success("Billing is on pending.");
        getBillingList();
      })["catch"](function (err) {
        $scope.isLoading = false;
        Notification.error(err.data.message);
      });
    };

    vm.saveBillingData = function () {
      var supplyIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      var isDeleting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // $log.log(billing);
      var _billing2 = null;

      if ($scope.currentPage == 'Pending') {
        _billing2 = vm.billing;
      } else if ($scope.currentPage == 'Company') {
        _billing2 = vm.companyBilling;
      } else {
        _billing2 = vm.memo;
      } // if (billing && billing.customSupplierData && billing.customSupplierData.invoicenumber) {


      var checkData = {
        id: _billing2._id,
        vendorId: _billing2.vendor ? _billing2.vendor._id : undefined,
        customSupplierData: _billing2.customSupplierData,
        projectId: _billing2.projectId && _billing2.projectId._id ? _billing2.projectId._id : _billing2.projectId
      };

      if ($scope.currentPage == 'Pending') {
        vm.billList = vm.pendingBills;
      } else if ($scope.currentPage == 'Company') {
        vm.billList = vm.companyBills;
      } else {
        vm.billList = vm.vendorCredits;
      }

      apiFactory.checkDuplicatedBillingData(checkData).then(function (resp) {
        if (resp.data.data.isDuplicated) {
          var duplicatedModal = $uibModal.open({
            animation: true,
            component: 'duplicatedModal',
            windowClass: 'dupliated-modal',
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              oldBilling: function oldBilling() {
                return resp.data.data.item;
              },
              billing: function billing() {
                return _billing2;
              }
            }
          });
          duplicatedModal.result.then(function (result) {
            if (result) {
              if (result.action === 'delete') {// getBillingList();
              } else {
                _saveBillingData(_billing2, resp.data.data.item._id, supplyIndex, isDeleting);
              }
            }
          });
        } else {
          _saveBillingData(_billing2, null, supplyIndex, isDeleting);
        }
      })["catch"](function (err) {
        $log.log(err);
      }); // } else {
      //   Notification.error("Data is not ready yet.");
      // }
    };

    vm.deleteBilling = function (billing) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        apiFactory.deleteBilling(billing._id).then(function () {
          Notification.success("".concat(billing.billNo, " removed successfully."));
          getBillingList();
        })["catch"](function (err) {
          $log.error(err);
          Notification.error("Failed to remove!");
        });
      }, function () {});
    };

    vm.onChangeShowApproved = function () {
      $log.log('bShowApproved = ', vm.bShowApproved);
      getBillingList();
    };

    function _saveBillingData(billing, dupId, supplyIndex, isDeleting) {
      var data;
      var customSupplierData = angular.copy(billing.customSupplierData);

      for (var i = 0; i < customSupplierData.supplies.length; i++) {
        var supply = angular.fromJson(angular.toJson(customSupplierData.supplies[i]));

        if (supply.editMode || supply.saveMode) {
          $log.log(supply);
          Notification.error("Please save the items first.");
          return;
        }
      }

      customSupplierData.supplies = customSupplierData.supplies.map(function (item) {
        var supply = angular.fromJson(angular.toJson(item)); // if (index == supplyIndex) {

        delete supply.saveMode;
        delete supply.editMode; // }

        return supply;
      });

      if (supplyIndex >= 0) {
        if (isDeleting) {
          customSupplierData.supplies.splice(supplyIndex, 1);
        }
      }

      data = {
        dupId: dupId,
        templateId: billing.templateId ? billing.templateId : null,
        group: billing.group && billing.group._id ? billing.group._id : null,
        groupType: billing.group && billing.group.groupType ? billing.group.groupType : null,
        vaOrder: billing.vaOrder && billing.vaOrder._id ? billing.vaOrder._id : null,
        billDate: billing.billDate ? billing.billDate : customSupplierData ? customSupplierData.billdate : undefined,
        dueDate: billing.dueDate ? billing.dueDate : customSupplierData ? customSupplierData.duedate : undefined,
        customSupplierData: customSupplierData,
        amountWithoutTax: billing.amountWithoutTax,
        taxAmount: billing.taxAmount,
        totalAmount: billing.totalAmount,
        vatPercent: billing.vatPercent,
        vendor: billing.vendor ? billing.vendor._id : null,
        projectId: billing.projectId._id
      }; // if($scope.currentPage != 'Company') {
      //   data.projectId = billing.projectId._id;
      // }

      if (!utils.isEmpty(billing.billType)) {
        data.billType = billing.billType;
      }

      apiFactory.updateBillingData(data, billing._id).then(function (resp) {
        Notification.success("".concat(billing.billNo, " successfully updated"));

        if (supplyIndex >= 0) {
          billing.customSupplierData.supplies[supplyIndex].saveMode = false;
          billing.customSupplierData.supplies[supplyIndex].editMode = false;

          if (isDeleting) {
            // if ($scope.isNormalType(billing)) {
            billing.amountWithoutTax -= billing.customSupplierData.supplies[supplyIndex].price;
            billing.taxAmount -= billing.customSupplierData.supplies[supplyIndex].vat;
            billing.totalAmount -= billing.customSupplierData.supplies[supplyIndex].total; // }

            billing.customSupplierData.supplies.splice(supplyIndex, 1);
          }

          $scope.$apply();
          updateBillingTotalValues(billing); // unsetRunningOCRBill(billing._id);
        }

        var index = vm.billList.findIndex(function (x) {
          return x._id == billing._id;
        });
        var tempBilling = angular.copy(resp.data.data);
        var currentBillingGroup = {};

        if (vm.billingGroups) {
          for (var _i = 0; _i < vm.billingGroups.length; _i++) {
            if (vm.billingGroups[_i]._id === resp.data.data.group) {
              currentBillingGroup = vm.billingGroups[_i];
              break;
            }
          }
        }

        var currentBillType = {};

        if (vm.economicTypeList && vm.economicTypeList.length) {
          for (var j = 0; j < vm.economicTypeList.length; j++) {
            if (vm.economicTypeList[j]._id === resp.data.data.billType) {
              currentBillType = vm.economicTypeList[j];
            }
          }
        }

        tempBilling.billType = currentBillType;
        tempBilling.group = currentBillingGroup;
        vm.billList[index] = tempBilling;
        billing = vm.billList[index]; // unsetRunningOCRBill(billing._id);

        getBillingList();
      })["catch"](function (err) {
        $log.log(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    function updateBillingTotalValues(billing) {
      var data = {
        amountWithoutTax: billing.amountWithoutTax,
        taxAmount: billing.taxAmount,
        totalAmount: billing.totalAmount
      };
      apiFactory.updateBillingTotalValues(data, billing._id).then(function () {
        $scope.$apply();
      })["catch"](function (err) {
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    function getPendingBillingList() {
      $scope.isLoading = true;
      apiFactory.listAllPendingBills({
        projectBill: true,
        projectId: vm.project._id,
        bShowApproved: vm.bShowApproved
      }).then(function (res) {
        $scope.isLoading = false;
        vm.pendingBills = res.data.list;
        var billData = angular.copy(localStorageService.get('billData'));
        localStorageService.set('billData', undefined);

        if (billData) {
          vm.billing = billData;
        } else {
          vm.billing = vm.pendingBills.length ? vm.pendingBills[0] : null;
        }

        vm.currentIndex = vm.pendingBills.findIndex(function (x) {
          return x._id == vm.billing._id;
        });
        $log.log(vm.currentIndex);
      });
    }

    function getVendorCredits() {
      $scope.isLoading = true;
      apiFactory.listAllPendingBills({
        isMemo: true,
        projectId: vm.project._id,
        bShowApproved: vm.bShowApproved
      }).then(function (res) {
        $scope.isLoading = false;
        vm.vendorCredits = res.data.list;
        vm.memo = vm.vendorCredits.length ? vm.vendorCredits[0] : null;
        vm.currentMemoIndex = 0;
        $log.log('vendorCredits = ', vm.vendorCredits);
      });
    }

    function getCompanyBillings() {
      $scope.isLoading = true;
      apiFactory.listAllPendingBills({
        companyBill: true,
        projectId: 'all',
        bShowApproved: vm.bShowApproved
      }).then(function (res) {
        $scope.isLoading = false;
        vm.companyBills = res.data.list;
        vm.companyBilling = vm.companyBills.length ? vm.companyBills[0] : null;
        vm.currentCompanyIndex = 0;
        $log.log('companyBills = ', vm.companyBills);
      });
    }

    function getVendors() {
      $scope.isLoading = true;
      var promises = [apiFactory.listAllClients(), apiFactory.getAllSubcontractors(), apiFactory.getAllSuppliers()];
      Promise.all(promises).then(function (resp) {
        var clients = resp[0].data.list;
        var subcontractors = resp[1].data.list;
        var suppliers = resp[2].data.list;
        var vendors = [];
        var i;

        for (i = 0; i < clients.length; i++) {
          clients[i].displayName = 'Client - ' + clients[i].clientName;
          vendors.push(clients[i]);
        }

        for (i = 0; i < suppliers.length; i++) {
          suppliers[i].displayName = 'Supplier - ' + suppliers[i].name;
          vendors.push(suppliers[i]);
        }

        for (i = 0; i < subcontractors.length; i++) {
          subcontractors[i].displayName = 'Subcontractor - ' + subcontractors[i].name;
          vendors.push(subcontractors[i]);
        }

        vendors.push({
          _id: 'none',
          displayName: "No vendor selected."
        });
        vm.vendors = vendors;
        $scope.isLoading = false;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error('======================', err);

        if (err.status === 403) {
          Notification.error(err.data.message);
          $state.go(globals.getDashboardRoute($scope.userData));
        } else {
          Notification.error(utils.getErrorMessage(err, "Couldn't load data."));
        }
      });
    }

    function _approveBillingData(dupId, additionalReq) {
      var billing = null;

      if ($scope.currentPage == 'Pending') {
        billing = vm.billing;
      } else if ($scope.currentPage == 'Company') {
        billing = vm.companyBilling;
      } else {
        billing = vm.memo;
      }

      $scope.isLoading = true;
      apiFactory.approveBill({
        dupId: dupId,
        billId: billing._id,
        status: "approved",
        customSupplierData: billing.customSupplierData,
        billType: billing.billType,
        amountWithoutTax: billing.amountWithoutTax,
        taxAmount: billing.taxAmount,
        totalAmount: billing.totalAmount,
        approver: additionalReq.approverId,
        // to do confirm because generate on backend.
        projectId: additionalReq.projectId,
        vendor: additionalReq.vendorId,
        vendorType: additionalReq.vendorType
      }).then(function () {
        $scope.isLoading = false;
        Notification.success("".concat(billing.billNo, " is approved successfully."));
        getBillingList();
      })["catch"](function (err) {
        $scope.isLoading = false;

        if (err.data && err.data.message) {
          Notification.error(err.data.message);
          getBillingList();
        } else {
          Notification.error("Failed in approve billing");
        }

        $log.log(err);
      });
    }

    function getDueDate(billDateString, vendor) {
      $log.log('billDate = ', billDateString);
      $log.log('vendor = ', vendor);
      var billDate = new Date(billDateString); // need to get from ocr         

      if (billDate && vendor && vendor.paymentTerms) {
        var term = vm.companyData.paymentConditions.find(function (elem) {
          return elem._id === vendor.paymentTerms.paymentSetting;
        });
        $log.log('paymentConditions = ', vm.companyData.paymentConditions);
        $log.log('term = ', term);

        if (term) {
          var additionalDays = utils.getDaysFromPaymentTermsCode(term.code);
          $log.log('additionalDays = ', additionalDays);
          var newDate = moment(billDate).clone();

          if (additionalDays) {
            var endDate = moment(newDate);

            if (additionalDays.w) {
              endDate = moment(newDate).isoWeek(7);
            } else if (additionalDays.m) {
              endDate = moment(newDate).endOf('month');
            }

            var dueDate = endDate.add(additionalDays.days, 'days');
            return new Date(dueDate);
          }
        } else {
          return "";
        }
      }
    }

    function getBillingList() {
      getPendingBillingList();
      getVendorCredits();
      getCompanyBillings();
      getVendors();
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('billList', {
    controller: BillListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/bill/bill-list/bill-list.view.html'
  });
  /** @ngInject */

  function BillListController($scope, $state, $log, apiFactory, globals, Notification, $uibModal, utils, $timeout, localStorageService, $document, $window, $http) {
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore;
    vm.project = projectStore.get();
    vm.userData = userStore.get();
    $scope.ECO_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.ECO_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.ECO]
    //   })
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.ECO_ACCESS_CREATE = res.data.data[Constants.AccessKey.ECO];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    var PROJECT_BILL = 0;
    var COMPANY_BILL = 1;
    var VENDOR_CREDIT_MEMO = 2;
    $scope.currentTab = PROJECT_BILL;
    vm.pdfViewing = false;
    vm.bill = undefined;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    vm.sortItems = [{}, {
      sort: 'date',
      sortType: false
    }, {
      sort: 'billNo',
      sortType: false
    }, {
      sort: 'invoiceNo',
      sortType: false
    }, {
      sort: 'vendor',
      sortType: false
    }, {
      sort: 'amount',
      sortType: false
    }, {
      sort: 'vatAmount',
      sortType: false
    }, {
      sort: 'total',
      sortType: false
    }, {
      sort: 'status',
      sortType: false
    }];
    vm.statusList = [{
      value: 'All Status'
    }, {
      value: 'approved'
    }, {
      value: 'declined'
    }, {
      value: 'draft'
    }, {
      value: 'pending'
    }];
    vm.status = 'All Status';
    $scope.sortItem = vm.sortItems[0];
    $scope.isAllChecked = false;
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.totalCount1 = 0;
    $scope.noOfPages1 = 0;
    vm.currentPage1 = 1;
    $scope.totalCount2 = 0;
    $scope.noOfPages2 = 0;
    vm.currentPage2 = 1;
    vm.billList = [];
    vm.otherList = [];
    $scope.searchText = "";

    $scope.changeSortItem = function (sort) {
      if (sort === $scope.sortItem.sort) {
        $scope.sortItem.sortType = !$scope.sortItem.sortType;
      } else {
        $scope.sortItem = vm.sortItems.find(function (x) {
          return x.sort === sort;
        });
      }

      vm.fetchData();
    };

    $scope.selectedProject = function (status) {
      vm.status = status;
      vm.fetchData();
    };

    vm.searchData = function () {
      vm.currentPage = 1;
      vm.currentPage1 = 1;
      vm.currentPage2 = 1;
      vm.fetchData();
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchData();
    };

    vm.fetchData = function () {
      if ($scope.currentTab === PROJECT_BILL) {
        $scope.isLoading = true;
        var query = {
          page: vm.currentPage,
          chunk: $scope.numPerPage,
          projectBill: true,
          search: $scope.searchText,
          sort: $scope.sortItem.sort,
          sortType: $scope.sortItem.sortType,
          status: vm.status !== 'All Status' ? vm.status : ''
        };

        if (vm.project && vm.project._id !== "all") {
          query.projectId = vm.project._id;
        }

        apiFactory.listAllBillings(query).then(function (resp) {
          $scope.isLoading = false;
          vm.billList = resp.data.list;
          $scope.totalCount = resp.data.total;
          $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);

          if (err.status === 403) {
            Notification.error(err.data.message);
            $state.go(globals.getDashboardRoute(vm.userData));
          }
        });
      } else if ($scope.currentTab === COMPANY_BILL) {
        $scope.isLoading = true;
        apiFactory.listAllBillings({
          page: vm.currentPage1,
          chunk: $scope.numPerPage,
          companyBill: true,
          search: $scope.searchText,
          sort: $scope.sortItem.sort,
          sortType: $scope.sortItem.sortType,
          status: vm.status !== 'All Status' ? vm.status : ''
        }).then(function (resp) {
          $scope.isLoading = false;
          vm.billList = resp.data.list;
          $scope.totalCount1 = resp.data.total;
          $scope.noOfPages1 = Math.ceil($scope.totalCount1 / $scope.numPerPage);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);

          if (err.status === 403) {
            Notification.error(err.data.message);
            $state.go(globals.getDashboardRoute(vm.userData));
          }
        });
      } else if ($scope.currentTab === VENDOR_CREDIT_MEMO) {
        $scope.isLoading = true;
        var _query = {
          page: vm.currentPage2,
          chunk: $scope.numPerPage,
          isMemo: true,
          search: $scope.searchText,
          sort: $scope.sortItem.sort,
          sortType: $scope.sortItem.sortType,
          status: vm.status !== 'All Status' ? vm.status : ''
        };

        if (vm.project && vm.project._id !== "all") {
          _query.projectId = vm.project._id;
        }

        apiFactory.listAllBillings(_query).then(function (resp) {
          $scope.isLoading = false;
          vm.billList = resp.data.list;
          vm.billList.forEach(function (x) {
            x.billNo = x.displaySeq;
          });
          $scope.totalCount2 = resp.data.total;
          $scope.noOfPages2 = Math.ceil($scope.totalCount2 / $scope.numPerPage);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);

          if (err.status === 403) {
            Notification.error(err.data.message);
            $state.go(globals.getDashboardRoute(vm.userData));
          }
        });
      }
    };

    vm.fetchData();

    vm.print = function (bill) {
      vm.pdfViewing = true;
      vm.bill = bill;
    };

    vm.closePDFViewer = function () {
      vm.pdfViewing = false;
      vm.bill = undefined;
    };

    vm.gotoEdit = function (bill) {
      localStorageService.set('billData', bill);
      $state.go('billScanner');
    };

    vm.downloadPdf = function (bill) {
      $scope.isDownloading = true;
      utils.downloadFile(bill.bill.secure_url, 'bill.pdf').then(function () {
        $scope.isDownloading = false;
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.isDownloading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    $scope.setAllChecked = function () {
      $log.log($scope.isAllChecked);
      $scope.isAllChecked = !$scope.isAllChecked;
      vm.billList.forEach(function (bill) {
        bill.checked = $scope.isAllChecked;
      });
      $timeout(function () {
        return $scope.$apply();
      });
    };

    vm.downloadAll = function () {
      $scope.isDownloading = true;
      var data = [];
      vm.billList.forEach(function (bill) {
        if (bill.checked) {
          data.push({
            url: bill.bill.secure_url,
            filename: bill.billNo + " - " + moment(bill.billDate).format('DD-MM-YYYY') + '.pdf'
          });
        }
      });

      if (!data.length) {
        Notification.error('Please select bills to download pdf.');
        $scope.isDownloading = false;
        return;
      }

      var resFilename = '';

      if ($scope.isProjectBills()) {
        resFilename = 'ProjectBills.zip';
      } else if ($scope.isCompanyBills()) {
        resFilename = 'CompanyBills.zip';
      } else if ($scope.isVendorCreditMemos()) {
        resFilename = 'VendorCreditMemos.zip';
      }

      apiFactory.downloadInvoicesZip({
        data: data,
        resFilename: resFilename
      }).then(function (resp) {
        $scope.isDownloading = false;
        $log.log(resp);
        $http.get(apiFactory.getBaseUrl() + '/' + resp.data.url, {
          responseType: "arraybuffer"
        }).then(function (response) {
          // resolve();
          var headers = response.headers();
          headers["Content-Disposition"] = "attachment";
          var blob = new Blob([response.data], {
            type: "octet/stream"
          });
          var link = $document[0].createElement("a");
          link.href = $window.URL.createObjectURL(blob);
          link.download = resFilename;
          $document[0].body.appendChild(link);
          link.click();
          $document[0].body.removeChild(link);
        })["catch"](function (err) {
          // reject(err);
          $log.err(err);
        });
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.isDownloading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    vm.deleteBill = function (bill, index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function (result) {
        if (result) {
          apiFactory.deleteBilling(bill._id).then(function (resp) {
            $log.log(resp);
            Notification.success("Bill removed successfully.");
            vm.billList.splice(index, 1);
            $scope.$apply();
          })["catch"](function (err) {
            $log.error(err);
            Notification.error("Failed to remove!");
          });
        }
      });
    };

    $scope.onProjectBills = function () {
      $scope.currentTab = PROJECT_BILL;
      vm.fetchData();
    };

    $scope.onCompanyBills = function () {
      $scope.currentTab = COMPANY_BILL;
      vm.fetchData();
    };

    $scope.onVendorCreditMemos = function () {
      $scope.currentTab = VENDOR_CREDIT_MEMO;
      vm.fetchData();
    };

    $scope.isProjectBills = function () {
      return $scope.currentTab === PROJECT_BILL;
    };

    $scope.isCompanyBills = function () {
      return $scope.currentTab === COMPANY_BILL;
    };

    $scope.isVendorCreditMemos = function () {
      return $scope.currentTab === VENDOR_CREDIT_MEMO;
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Tesseract;

(function () {
  'use strict';

  angular.module('app').component('approveBill', {
    controller: ApproveBillController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/bill/approveBill/approveBill.view.html'
  });
  /** @ngInject */

  function ApproveBillController($scope, $uibModal, $log, apiFactory, Notification, globals, $rootScope, $state, $timeout, $window, $document, utils, pdfFactory, localStorageService) {
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore,
        userStore = globals.userStore;
    var vm = this;
    vm.project = projectStore.get();
    vm.userData = userStore.get();
    var CANVAS_HEIGHT = 635 * $rootScope.scale;
    var CANVAS_SCALE_MUTIPLER = 2;
    vm.companyData = companyStore.get();
    vm.billingGroups = [];
    vm.vaOrderList = [];
    vm.billList = [];
    vm.economicTypeList = [];
    vm.billing = null;
    vm.proceedBillingId = null;
    vm.ocrBillIdList = [];
    vm.modelReady = false;
    vm.canvasPage = undefined;
    vm.canvasScale = 1;
    vm.baseCanvasScale = 1.0;
    vm.tempInvoiceData = {};
    vm.errorCnt = 0;
    vm.billData = {};
    vm.minCnt = 10000000;
    vm.canvas = $document[0].getElementById("the-canvas");
    $scope.currentIndex = 0;
    $scope.billDateString = "";
    $scope.economicTypeId = undefined;
    $scope.billingGroupId = undefined;
    var PROJECT_BILL = 0;
    var COMPANY_BILL = 1;
    var PENDING_BILL = 2;
    var FAILED_SYNC = 3;
    var VENDOR_CREDIT_MEMO = 4;
    $scope.currentTab = vm.project && vm.project._id !== "all" ? PROJECT_BILL : COMPANY_BILL;
    var rcThres = 20;
    var confThres = 30;
    vm.numPages = 1;
    vm.currentPageNum = 1;
    $scope.isBillDatepickerOpen = false;
    $scope.isDueDatepickerOpen = false;
    $scope.editingSupply = {};
    vm.isRemoveVAT = false;

    function initData() {
      $scope.isLoading = true;
      var billData = angular.copy(localStorageService.get('billData'));
      localStorageService.set('billData', undefined);
      var promises = [apiFactory.listAllVariationOrders({
        projectId: vm.project._id,
        status: 'approved',
        isBill: false
      }), apiFactory.getAllMaterialGroup(), apiFactory.getAllEquipmentGroup(), apiFactory.getBillAccountPlans()];

      if (billData) {
        if (billData.status === 'approved') {
          $scope.currentTab = FAILED_SYNC;
          promises.push(apiFactory.listAllBillings({
            failedSync: true,
            approval: 'approved',
            projectId: vm.project._id
          }));
        } else if (billData.isMemo) {
          $scope.currentTab = VENDOR_CREDIT_MEMO;
          promises.push(apiFactory.listAllBillings({
            isMemo: true,
            approval: 'pending',
            projectId: vm.project._id
          }));
        } else if (billData.projectId) {
          $scope.currentTab = PROJECT_BILL;
          promises.push(apiFactory.listAllBillings({
            projectBill: true,
            approval: 'pending',
            projectId: vm.project._id
          }));
        } else {
          $scope.currentTab = COMPANY_BILL;
          promises.push(apiFactory.listAllBillings({
            companyBill: true,
            approval: 'pending',
            projectId: vm.project._id
          }));
        }
      } else {
        promises.push(apiFactory.listAllBillings({
          projectBill: true,
          approval: 'pending',
          projectId: vm.project._id
        }));
      }

      Promise.all(promises).then(function (resp) {
        vm.vaOrderList = resp[0].data.list;
        var materialGroup = resp[1].data.data;
        var equipmentGroup = resp[2].data.data;
        equipmentGroup.forEach(function (item) {
          return item.groupType = 'eq';
        });
        vm.billingGroups = materialGroup.concat(equipmentGroup);
        vm.modelReady = true;
        vm.economicTypeList = resp[3].data.data;
        vm.economicTypeList.forEach(function (x) {
          x.name = x.name + ' - ' + x.number;
        });
        vm.billList = resp[4].data.list;
        $log.log(vm.billList);

        if (billData) {
          $scope.currentIndex = vm.billList.findIndex(function (x) {
            return x._id == billData._id;
          });
        } else {
          $scope.currentIndex = 0;
        }

        if (vm.billList.length > 0 && $scope.currentIndex >= 0) {
          vm.billing = vm.billList[$scope.currentIndex];
          showBilling(vm.billing);
          startOCRProgress(vm.billing);
        } else {
          vm.billing = null;
          $scope.vendorDetail = {};
        }

        $scope.isLoading = false;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);

        if (err.status === 403) {
          Notification.error(err.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        } else {
          Notification.error(utils.getErrorMessage(err, "Couldn't load data."));
        }
      });
    }

    apiFactory.hasApprovalInProject({
      projectId: vm.project._id,
      approval: 'bill'
    }).then(function () {
      initData();
    })["catch"](function (err) {
      $log.error(err);
      Notification.error(utils.getErrorMessage(err, 'Permission denied'));
      $state.go(globals.getDashboardRoute(vm.userData));
    });

    vm.onProjectBills = function () {
      $scope.currentTab = PROJECT_BILL;
      getBillingList();
    };

    vm.onCompanyBills = function () {
      $scope.currentTab = COMPANY_BILL;
      getBillingList();
    };

    vm.onPendingBills = function () {
      $scope.currentTab = PENDING_BILL;
      getBillingList();
    };

    vm.onFailedSync = function () {
      $scope.currentTab = FAILED_SYNC;
      getBillingList();
    };

    vm.onMemo = function () {
      $scope.currentTab = VENDOR_CREDIT_MEMO;
      getBillingList();
    };

    vm.selEconomicTypeId = function (economicType) {
      vm.billing.billType = economicType;
      $scope.vendorDetail.vat = $scope.getVat(vm.billing);
      calculatePrices(vm.billing);
    };

    vm.selBillingGroupId = function (billingGroupId) {
      for (var i = 0; i < vm.billingGroups.length; i++) {
        if (vm.billingGroups[i]._id === billingGroupId) {
          vm.billing.group = vm.billingGroups[i];
        }
      }
    };

    vm.selBillingVAOrderId = function (billingVAOrderId) {
      if (vm.vaOrderList) {
        for (var i = 0; i < vm.vaOrderList.length; i++) {
          if (vm.vaOrderList[i]._id === billingVAOrderId) {
            var vaOrder = vm.vaOrderList[i];
            vm.billing.vaOrder = vaOrder;
            vm.billing.customSupplierData = {
              invoicenumber: vaOrder.displaySeq,
              supplies: []
            };

            if (vaOrder.vendorType === 'Client') {
              vm.billing.customSupplierData.address2 = $scope.addressString(vaOrder.vendor.address);
              vm.billing.customSupplierData.postalCode = vaOrder.vendor.address[0].postalCode;
              vm.billing.customSupplierData.countryCode = vaOrder.vendor.address[0].countryCode;
              vm.billing.customSupplierData.city = vaOrder.vendor.address[0].city;
              vm.billing.vendor = vaOrder.vendor;
              vm.billing.vendor.name = vaOrder.vendor.clientName;
              vm.billing.vendor.address = $scope.addressString(vaOrder.vendor.address);
              vm.billing.vendor.contact = vaOrder.vendor.clientContact;

              if (vaOrder.vendor.paymentTerms) {
                vm.billing.vendor.vat = vaOrder.vendor.paymentTerms.vatPercent;
              } else {
                vm.billing.vendor.vat = 0;
              }

              vm.billing.vendor.bankDetails = angular.copy(vm.companyData.economicSettings.paymentInfo);

              if (vm.billing.vendor.bankDetails && vm.billing.vendor.bankDetails.length > 0) {
                vm.billing.vendor.bankDetails[0].IBAN = vm.billing.vendor.bankDetails[0].ibanNumber;
                vm.billing.vendor.bankDetails[0].sortCode = vm.billing.vendor.bankDetails[0].swiftCode;
              }
            } else if (vaOrder.vendorType === 'Supplier' || vaOrder.vendorType === 'Subcontractor') {
              vm.billing.customSupplierData.address2 = vm.billing.vendor.address;
              vm.billing.vendor = vaOrder.vendor;
              var address = vm.billing.vendor.address || '';
              var addresses = address.spilt(',');
              vm.billing.customSupplierData.postalCode = addresses[2];
              vm.billing.customSupplierData.countryCode = addresses[1];
              vm.billing.customSupplierData.city = addresses[0];
            }

            vm.billing.bill.secure_url = vaOrder.variationOrderDoc;

            for (var _i = 0; _i < vaOrder.items.length; _i++) {
              var item = vaOrder.items[_i];
              vm.billing.customSupplierData.supplies.push({
                description: item.description,
                qty: item.quantity,
                unitprice: item.unitPrice,
                vat: item.vatAmount,
                price: item.price
              });
            }

            calculatePrices(vm.billing);
            showBilling(vm.billing);
            return;
          }
        }
      }
    };

    vm.openUploadNewBillModal = function () {
      var uploadModal = $uibModal.open({
        animation: true,
        component: 'uploadNewBillModal',
        windowClass: 'upload-new-bill-modal',
        resolve: {}
      });
      uploadModal.result.then(function (result) {
        if (result.action == 'upload') {
          if (!result.data) return;
          $scope.isLoading = true;
          Notification.success("Uploading bills started. This might take some time");
          $log.log(result);
          /*pdfFactory.numPagesFromFile(result.data.data.file[0]).then(pageCount =>{
            if(pageCount != 0) {              */

          apiFactory.uploadBillDocument(result.data).then(function (resp) {
            $scope.isLoading = false;
            $log.log(resp);

            if (resp.data.data) {
              Notification.success("Finish find out client from bill");
              var vendor = resp.data.data.vendor;
              $scope.vendorDetail = resp.data.data.vendor;

              if (vendor.bankDetails && vendor.bankDetails[0]) {
                $scope.bankDetails = vendor.bankDetails[0];
              }

              var address = {};

              if (vendor.address) {
                address = vendor.address[0] ? vendor.address[0] : vendor.address ? vendor.address : vendor.address1 ? vendor.address1 : vendor.address2 ? vendor.address2 : '';
              }

              $scope.vendorDetail.address = address;
              $scope.vendorDetail.fullAddress = '';

              if ($scope.vendorDetail.address.line1) {
                $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.line1 + ', ';
              }

              if ($scope.vendorDetail.address.city) {
                $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.city + ', ';
              }

              if ($scope.vendorDetail.address.countryCode) {
                $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.countryCode + ', ';
              }

              $scope.vendorDetail.phoneNumber = vendor.clientContact ? vendor.clientContact.dialCode + vendor.clientContact.phoneNumber : vendor.contact ? vendor.contact.dialCode + vendor.contact.phoneNumber : vendor.mobile ? vendor.mobile.dialCode + vendor.mobile.phoneNumber : '';
              $scope.vendorDetail.vat = vendor.paymentTerms && vendor.paymentTerms.vatPercent ? vendor.paymentTerms.vatPercent : 0;
              $scope.vendorDetail.vatNumber = vendor.paymentTerms && vendor.paymentTerms.vatNumber ? vendor.paymentTerms.vatNumber : 0;
              $scope.billDateString = resp.data.data.billDate;
              getDueDateFromSupplier($scope.billDateString, vendor);
              pdfFactory.numPagesFromFile(result.data.data.file[0]).then(function (pageCount) {
                var pdfFile = result.data.data.file[0];
                Promise.all([pdfFactory.getPageFromFile(pdfFile, vm.currentPageNum)]).then(function (res) {
                  vm.numPages = pageCount;
                  var page = res[0];
                  vm.canvasPage = page;
                  $timeout(function () {
                    $scope.$apply();
                  });
                  $scope.isLoadBilling = false;
                  renderPage(page, vm.canvas, true);
                })["catch"](function (e) {
                  $log.error(e);
                  $scope.isLoadBilling = false;
                });
              });
            } else {
              Notification.error(resp.message);
            }
          });
          /*  }
          });
          */

          /*
          pdfFactory.numPagesFromFile(result.data.data.file[0]).then(pageCount =>{
            let pdfFile = result.data.data.file[0];
             Promise.all([              
              pdfFactory.getPageFromFile(pdfFile, vm.currentPageNum)
            ])
              .then(res => {
                vm.numPages = pageCount;
                let page = res[0];
                vm.canvasPage = page;
                $timeout(() => {
                  $scope.$apply();
                });
                $scope.isLoadBilling = false;
                       renderPage(page, vm.canvas, true);
              })
              .catch(e => {
                $log.error(e);
                $scope.isLoadBilling = false;
              });
                  let pageNum = 1;
            let ocrDataList = [];
            runFullOCR(pdfFile, pageNum, true)
              .then(resp => {
                let data = refineOCRResult(resp.data);
                if (data) {
                  ocrDataList.push({
                    data: data,
                    size: resp.size
                  })
                }
                 pageNum += 1;
                if (pageNum <= pageCount) {
                  runFullOCR(pdfFile, pageNum, true)
                    .then(resp => {
                      let data = refineOCRResult(resp.data);
                      if (data) {
                        ocrDataList.push({
                          data: data,
                          size: resp.size
                        })
                      }
                       pageNum += 1;
                      if (pageNum <= pageCount) {
                        runFullOCR(pdfFile, pageNum, true)
                          .then(resp => {
                            let data = refineOCRResult(resp.data);
                            if (data) {
                              ocrDataList.push({
                                data: data,
                                size: resp.size
                              })
                            }
                             pageNum += 1;
                            runFullOCR(pdfFile, pageNum, true)
                              .then(resp => {
                                let data = refineOCRResult(resp.data);
                                if (data) {
                                  ocrDataList.push({
                                    data: data,
                                    size: resp.size
                                  })
                                }
                                //createBillOcrData(billing, ocrDataList);
                                $scope.isLoading = false;
                                proceesFindClient(ocrDataList);
                              })
                              .catch(err => {                                
                                $log.error(err);
                                Notification.error('Failed in OCR');
                              })
                          })
                          .catch(err => {                            
                            $log.error(err);
                            Notification.error('Failed in OCR');
                          })
                      } else {
                        //createBillOcrData(billing, ocrDataList);
                        $scope.isLoading = false;
                        proceesFindClient(ocrDataList);
                      }
                    })
                    .catch(err => {                      
                      $log.error(err);
                      Notification.error('Failed in OCR');
                    })
                } else {
                  //createBillOcrData(billing, ocrDataList);
                  $scope.isLoading = false;
                  proceesFindClient(ocrDataList);
                }
              })
              .catch(err => {                
                $log.error(err);
                Notification.error('Failed in OCR');
              })
          })*/
        }
      }, function (reason) {
        $log.info(reason);
      });
    };
    /*
    function processFindSearchInfoOCR(ocrData){    
      $log.log(ocrData);
      let searchKey = [];
      for(let i = 0 ; i < ocrData.length; i++) {
        let ocrPageData = ocrData[i];        
        for(let j = 0; j < ocrPageData.data.lines.length ; j ++) {
          let lineData = ocrPageData.data.lines[j];
          for(let k = 0 ; k < lineData.words.length ; k++) {
            let word = lineData.words[k];
            //$log.log(word.text);
            if(word.text.includes('CVR') || word.text.includes('S.E.') || word.text.includes('SEnr')) {
               let searchKeyStr = lineData.words[k+1].text;
              let ii = 1;
              let keyLength = 8;
              if(searchKeyStr == 'DK' || searchKeyStr == 'dk') {
                ii = ii++;
                searchKeyStr = "";
              }
              while(searchKeyStr.length < keyLength) {
                searchKeyStr = searchKeyStr + lineData.words[k+1+ii].text;
                ii++;
              }
              searchKey.push(searchKeyStr);
              continue;
            }
            if(word.text.toUpperCase().includes('DATO') || word.text.toUpperCase().includes('FORFALDSDATO') || word.text.includes('Bogføringsdato')) {
              let dateString = lineData.words[k+1].text;
              //if(dateString)
               $scope.billDateString = getDateString(dateString,"dmy");
              if(angular.isUndefined($scope.billDateString) || $scope.billDateString == ""){
                $scope.billDateString = getDateString(dateString,"mdy");
              }
              if(angular.isUndefined($scope.billDateString) || $scope.billDateString == ""){
                $scope.billDateString = getDateString(dateString,"ymd");
              }
              if(angular.isUndefined($scope.billDateString) || $scope.billDateString == ""){
                $scope.billDateString = getDateString(dateString,"ydm");
              }
              $log.log(dateString);
              $log.log($scope.billDateString);
            }
          }
        }
      }
      return searchKey;
    }
     function proceesFindClient (ocrData) {
      let searchKey = processFindSearchInfoOCR(ocrData);
      $log.log(searchKey);
      apiFactory.getClientFromSearchKey({searchKey : searchKey}).then(resp =>{   
        $log.log(resp.data.data);
          if(resp.data.data) {
            Notification.success("Finish find out client from bill");
            let vendor = resp.data.data.vendor;
            $scope.vendorDetail = resp.data.data.vendor;
            if(vendor.bankDetails && vendor.bankDetails[0]) {
              $scope.bankDetails = vendor.bankDetails[0]; 
            }
             let address = {};
            if (vendor.address) {
              address = vendor.address[0] ? vendor.address[0] :
                vendor.address ? vendor.address :
                  vendor.address1 ? vendor.address1 :
                    vendor.address2 ? vendor.address2 : '';
            }
             $scope.vendorDetail.address = address;
            $scope.vendorDetail.fullAddress = '';
            if ($scope.vendorDetail.address.line1) {
              $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.line1 + ', ';
            }
            if ($scope.vendorDetail.address.city) {
              $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.city + ', ';
            }
            if ($scope.vendorDetail.address.countryCode) {
              $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.countryCode + ', ';
            }
            $scope.vendorDetail.phoneNumber = vendor.clientContact ? vendor.clientContact.dialCode + vendor.clientContact.phoneNumber :
            vendor.contact ? vendor.contact.dialCode + vendor.contact.phoneNumber :
              vendor.mobile ? vendor.mobile.dialCode + vendor.mobile.phoneNumber : '';
    
            $scope.vendorDetail.vat = vendor.paymentTerms && vendor.paymentTerms.vatPercent ? vendor.paymentTerms.vatPercent : 0;
            $scope.vendorDetail.vatNumber = vendor.paymentTerms && vendor.paymentTerms.vatNumber ? vendor.paymentTerms.vatNumber : 0;
             getDueDateFromSupplier($scope.billDateString, vendor);
           }
          else {
            Notification.error(resp.message);
          }
      });
    }*/


    vm.openPdfBrowse = function () {
      angular.element('#pdf-file').click();
    };

    vm.pdfBrowsed = function (ev) {
      var files = ev.target.files;

      if (files && files.length) {
        var billFiles = [];

        for (var i = 0; i < files.length; i++) {
          billFiles.push(files[i]);
        }

        vm.openEditModal(billFiles);
      }

      ev.target.value = '';
    };

    vm.saveBillingData = function (_billing) {
      var supplyIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var isDeleting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (_billing && _billing.customSupplierData && _billing.customSupplierData.invoicenumber) {
        var checkData = {
          id: _billing._id,
          vendorId: _billing.vendor ? _billing.vendor._id : undefined,
          customSupplierData: _billing.customSupplierData,
          projectId: _billing.projectId && _billing.projectId._id ? _billing.projectId._id : _billing.projectId
        };
        apiFactory.checkDuplicatedBillingData(checkData).then(function (resp) {
          if (resp.data.data.isDuplicated) {
            var duplicatedModal = $uibModal.open({
              animation: true,
              component: 'duplicatedModal',
              windowClass: 'dupliated-modal',
              size: 'sm',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                oldBilling: function oldBilling() {
                  return resp.data.data.item;
                },
                billing: function billing() {
                  return _billing;
                }
              }
            });
            duplicatedModal.result.then(function (result) {
              if (result) {
                if (result.action === 'delete') {
                  getBillingList();
                } else {
                  _saveBillingData(_billing, resp.data.data.item._id, supplyIndex, isDeleting);
                }
              }
            });
          } else {
            _saveBillingData(_billing, null, supplyIndex, isDeleting);
          }
        })["catch"](function (err) {
          $log.log(err);
        });
      } else {
        Notification.error("Data is not ready yet.");
      }
    };

    vm.approve = function () {
      if (angular.isUndefined(vm.billing)) return;

      if (angular.isUndefined(vm.billing.amountWithoutTax) || angular.isUndefined(vm.billing.totalAmount)) {
        Notification.error("Please input prices.");
        return;
      }

      if (!vm.billing.billType) {
        Notification.error("Please Select Bill Type");
        return;
      }

      if (angular.isUndefined(vm.billing.taxAmount)) {
        vm.billing.taxAmount = 0;
      }

      if (!vm.billing.customSupplierData.invoicenumber) {
        Notification.error("No Invoice Number.");
        return;
      }

      var checkData = {
        id: vm.billing._id,
        vendorId: vm.billing.vendor ? vm.billing.vendor._id : undefined,
        customSupplierData: vm.billing.customSupplierData,
        projectId: vm.billing.projectId && vm.billing.projectId._id ? vm.billing.projectId._id : vm.billing.projectId
      };
      apiFactory.checkDuplicatedBillingData(checkData).then(function (resp) {
        if (resp.data.data.isDuplicated) {
          Notification.error('Duplicated Invoice Number');
        } else {
          var approveModal = $uibModal.open({
            animation: true,
            component: 'approveBillModal',
            windowClass: 'approve-bill-modal',
            resolve: {
              billing: function billing() {
                return vm.billing;
              }
            }
          });
          approveModal.result.then(function (result) {
            $log.log(result);

            _approveBillingData(null, result);
          }, function (reason) {
            $log.info(reason);
          });
        }
      })["catch"](function (err) {
        $log.log(err);
      });
    };

    vm.decline = function () {
      if (angular.isUndefined(vm.billing)) {
        Notification.error('Invalid Billing Data');
        return;
      }

      if (!vm.billing.billType) {
        Notification.error('Please Select Billing Type');
        return;
      }

      $uibModal.open({
        animation: true,
        component: "declineBillModal",
        windowClass: "decline-bill-modal",
        backdrop: "static",
        keyboard: false
      }).result.then(function (description) {
        $scope.isLoading = true;
        apiFactory.approveBill({
          billId: vm.billing._id,
          status: "declined",
          customSupplierData: vm.billing.customSupplierData,
          billType: vm.billing.billType,
          amountWithoutTax: vm.billing.amountWithoutTax,
          taxAmount: vm.billing.taxAmount,
          totalAmount: vm.billing.totalAmount,
          description: description
        }).then(function () {
          $scope.isLoading = false;
          Notification.success("Billing is declined.");
        })["catch"](function (err) {
          $scope.isLoading = false;
          Notification.error(err.data.message);
        });
      })["catch"](function () {});
    };

    vm.startOCRProgress = function (billing) {
      startOCRProgress(billing, true);
    };

    vm.openEditModal = function () {
      $uibModal.open({
        animation: false,
        component: 'billEditModal',
        backdrop: 'none',
        windowClass: 'economic-bill-edit-modal',
        resolve: {
          billing: function billing() {
            return vm.billing;
          }
        }
      }).result.then(function (result) {
        if (result.billing && (result.billing.status === 'pending' || vm.billing.status === 'draft')) {
          if (result.billing.projectId) {
            $scope.currentTab = PROJECT_BILL;
          } else {
            $scope.currentTab = COMPANY_BILL;
          }

          vm.proceedBillingId = result.billing._id;
          $timeout(function () {
            getBillingList();
          });
        }

        if (result.action === 'delete') {
          getBillingList();
        }
      }, function () {});
    };

    vm.downloadInvoice = function (billing) {
      $scope.isDownloading = true;
      utils.downloadFile(billing.bill.secure_url, "".concat(billing.billNo, ".pdf")).then(function () {
        $scope.isDownloading = false;
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.isDownloading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    vm.printDocument = function () {
      $window.open(vm.billing.bill.secure_url, "_blank");
    };

    vm.changeCanvasPage = function (direction) {
      var oldIndex = $scope.currentIndex;

      if (direction) {
        $scope.currentIndex = $scope.currentIndex === vm.billList.length - 1 ? $scope.currentIndex : $scope.currentIndex + 1;
      } else {
        $scope.currentIndex = $scope.currentIndex === 0 ? $scope.currentIndex : $scope.currentIndex - 1;
      }

      if (oldIndex !== $scope.currentIndex) {
        vm.currentPageNum = 1;
        vm.numPages = 1;
        vm.billing = vm.billList[$scope.currentIndex];
        showBilling(vm.billing);
        startOCRProgress(vm.billing);
      }
    };

    vm.changePageInBill = function (isNext) {
      if (isNext) {
        vm.currentPageNum += 1;

        if (vm.currentPageNum > vm.numPages) {
          vm.currentPageNum = vm.numPages;
        }
      } else {
        vm.currentPageNum -= 1;

        if (vm.currentPageNum < 1) {
          vm.currentPageNum = 1;
        }
      }

      pdfFactory.getPageFromURL(vm.billing.bill.secure_url, vm.currentPageNum).then(function (page) {
        vm.canvasPage = page;
        $timeout(function () {
          $scope.$apply();
        });
        renderPage(page, vm.canvas);
      })["catch"](function (e) {
        $log.error(e);
      });
    };

    vm.zoomCanvas = function (zoomIn) {
      vm.canvasScale = zoomIn ? vm.canvasScale + 0.1 : vm.canvasScale - 0.1;
      renderPage(vm.canvasPage, vm.canvas);
    };

    vm.resetCanvasZoom = function () {
      vm.canvasScale = vm.baseCanvasScale;
      renderPage(vm.canvasPage, vm.canvas);
    };

    vm.onEditItem = function (item) {
      item.editMode = true;
      $scope.editingSupply = angular.copy(item);
    };

    vm.onCancelEditItem = function (item) {
      item.editMode = false;
      $scope.editingSupply = {};

      if (item.addMode) {
        vm.billing.customSupplierData.supplies.splice(vm.billing.customSupplierData.supplies.length - 1, 1);
      }

      _calculatePrices(vm.billing);
    };

    vm.onAddItem = function () {
      if (utils.isEmpty(vm.billing.customSupplierData)) {
        resetCalcResult(vm.billing);
      }

      var find = vm.billing.customSupplierData.supplies.find(function (elem) {
        return elem.editMode == true;
      });

      if (find) {
        Notification.error("Please save editing item before adding");
        return;
      }

      vm.billing.customSupplierData.supplies.push({
        addMode: true
      });
      vm.onEditItem(vm.billing.customSupplierData.supplies[vm.billing.customSupplierData.supplies.length - 1]);
    };

    vm.onCheckEditing = function (index) {
      var supply = vm.billing.customSupplierData.supplies[index];

      if (supply.saveMode == true) {
        return;
      }

      if ($scope.isNormalType(vm.billing)) {
        if (utils.isEmpty($scope.editingSupply.description) || utils.isEmpty($scope.editingSupply.qty) || utils.isEmpty($scope.editingSupply.unitprice)) {
          Notification.error('Please input correct value');
          return;
        }

        supply.saveMode = true;
        supply.description = $scope.editingSupply.description;
        supply.qty = $scope.editingSupply.qty;
        supply.unitprice = $scope.editingSupply.unitprice;
      } else {
        if (utils.isEmpty($scope.editingSupply.description) || utils.isEmpty($scope.editingSupply.qty)) {
          Notification.error('Please input correct value');
          return;
        }

        supply.saveMode = true;
        supply.description = $scope.editingSupply.description;
        supply.qty = $scope.editingSupply.qty;
      }

      vm.saveBillingData(vm.billing, index);
    };

    vm.onRemoveItem = function (index) {
      if (vm.billing.customSupplierData.supplies[index].saveMode == true) return;
      vm.billing.customSupplierData.supplies[index].saveMode = true;
      vm.saveBillingData(vm.billing, index, true);
    };

    vm.changedQtyAndUPrice = function (item) {
      if (!$scope.isNormalType(vm.billing)) {
        return;
      }

      item.price = item.qty * item.unitprice;
      vm.billing.amountWithoutTax = 0;
      vm.billing.taxAmount = 0;
      vm.billing.totalAmount = 0;
      vm.billing.customSupplierData.supplies.filter(function (x) {
        return !x.editMode && !x.addMode;
      }).forEach(function (supply) {
        var price = supply.price;

        if (angular.isDefined(price) && price !== null) {
          var priceValue = Number(price);

          if (priceValue) {
            supply.vat = priceValue * utils.num($scope.vendorDetail.vat) / 100.0;
            supply.total = supply.vat + priceValue;
          }

          vm.billing.amountWithoutTax += priceValue;
          vm.billing.taxAmount += supply.vat;
          vm.billing.totalAmount += supply.total;
        }
      });

      if (!utils.isEmpty($scope.editingSupply) && !utils.isEmpty($scope.editingSupply.qty) && !utils.isEmpty($scope.editingSupply.unitprice)) {
        var price = $scope.editingSupply.qty * $scope.editingSupply.unitprice;
        $scope.editingSupply.price = price;
        $scope.editingSupply.vat = price * utils.num($scope.vendorDetail.vat) / 100.0;
        $scope.editingSupply.total = $scope.editingSupply.vat + price;
        item.description = $scope.editingSupply.description;
        item.qty = $scope.editingSupply.qty;
        item.unitprice = $scope.editingSupply.unitprice;
        item.price = $scope.editingSupply.price;
        item.vat = $scope.editingSupply.vat;
        item.total = $scope.editingSupply.total;
        vm.billing.amountWithoutTax += price;
        vm.billing.taxAmount += $scope.editingSupply.vat;
        vm.billing.totalAmount += $scope.editingSupply.total;
      }
    };

    vm.editAmountWithoutTax = function () {
      vm.billing.editMode = true;

      if (angular.isUndefined(vm.billing.amountWithoutTaxTemp)) {
        vm.billing.amountWithoutTaxTemp = vm.billing.amountWithoutTax;
      }
    };

    vm.updateAmountWithoutTax = function () {
      vm.billing.editMode = false;
      updateBillingTotalValues();
    };

    vm.changeAmountWithoutTax = function () {
      vm.billing.amountWithoutTax = vm.billing.amountWithoutTaxTemp;
      vm.billing.taxAmount = vm.billing.amountWithoutTax * utils.num($scope.vendorDetail.vat) / 100.0;
      vm.billing.totalAmount = vm.billing.amountWithoutTax + vm.billing.taxAmount;
    };

    vm.cancelAmountWithoutTax = function () {
      vm.billing.editMode = false;
      vm.billing.amountWithoutTaxTemp = vm.billing.amountWithoutTax;
      vm.billing.taxAmount = vm.billing.amountWithoutTax * utils.num($scope.vendorDetail.vat) / 100.0;
      vm.billing.totalAmount = vm.billing.amountWithoutTax + vm.billing.taxAmount;
    };

    function getBillingList() {
      $log.log('1234567');
      return new Promise(function (resolve, reject) {
        $scope.economicTypeId = undefined;
        $scope.billingGroupId = undefined;
        var query = {};

        if ($scope.isProjectTab()) {
          query = {
            projectBill: true,
            approval: 'pending',
            projectId: vm.project._id
          };
        } else if ($scope.isMemoTab()) {
          query = {
            isMemo: true,
            approval: 'pending',
            projectId: vm.project._id
          };
        } else if ($scope.isCompanyTab()) {
          query = {
            companyBill: true,
            approval: 'pending',
            projectId: vm.project._id
          };
        } else if ($scope.isFailedSyncTab()) {
          query = {
            failedSync: true,
            approval: 'approved',
            projectId: vm.project._id
          };
        } else if ($scope.isPendingTab()) {
          query = {
            approval: 'init'
          };
        } else {
          reject();
        }

        $scope.isLoading = true;
        apiFactory.listAllBillings(query).then(function (resp) {
          vm.billList = resp.data.list;
          $scope.currentIndex = 0;
          $log.log(vm.billList);

          if (vm.billList.length > 0) {
            if (vm.proceedBillingId) {
              vm.billing = vm.billList.find(function (x) {
                return x._id == vm.proceedBillingId;
              }) || vm.billList[$scope.currentIndex];
              showBilling(vm.billing);
              startOCRProgress(vm.billing, true);
            } else {
              vm.billing = vm.billList[$scope.currentIndex];
              $log.log(vm.billing);
              showBilling(vm.billing);
              startOCRProgress(vm.billing);
            }
          } else {
            clearBill();
            $scope.vendorDetail = {};
          }

          $scope.isLoading = false;
          resolve();
        })["catch"](function (e) {
          $log.error(e);
          $scope.isLoading = false;
          reject(e);
        });
      });
    }

    function showBilling(billing) {
      if (!billing) return;
      vm.currentInvoiceId = billing._id;
      $scope.economicTypeId = billing.billType;
      $scope.billingGroupId = billing.group;
      $scope.billingVAOrderId = billing.vaOrder ? billing.vaOrder._id : null;
      $scope.isLoadBilling = true;
      Promise.all([pdfFactory.numPagesFromURL(billing.bill.secure_url), pdfFactory.getPageFromURL(billing.bill.secure_url, vm.currentPageNum)]).then(function (res) {
        vm.numPages = res[0];
        var page = res[1];
        vm.canvasPage = page;
        $timeout(function () {
          $scope.$apply();
        });
        $scope.isLoadBilling = false;
        /* Render first page initially */

        renderPage(page, vm.canvas, true);
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoadBilling = false;
      });

      if (!billing.customSupplierData) {
        resetCalcResult(billing);
      }

      if (billing.group && typeof billing.group == 'string') {
        var currentBillingGroup = {};

        if (vm.billingGroups) {
          for (var i = 0; i < vm.billingGroups.length; i++) {
            if (vm.billingGroups[i]._id === billing.group) {
              currentBillingGroup = vm.billingGroups[i];
            }
          }
        }

        billing.group = currentBillingGroup;
      }

      if (billing.billType && typeof billing.billType == 'string') {
        var currentBillType = {};

        if (vm.economicTypeList.length) {
          for (var j = 0; j < vm.economicTypeList.length; j++) {
            if (vm.economicTypeList[j]._id === billing.billType) {
              currentBillType = vm.economicTypeList[j];
            }
          }
        }

        billing.billType = currentBillType;
      }

      getVendorDetails(billing);
    }

    function clearCanvas() {
      var ctx = vm.canvas.getContext("2d");

      if (ctx) {
        ctx.clearRect(0, 0, vm.canvas.width, vm.canvas.height);
      }
    }

    function clearBill() {
      vm.billing = undefined;
      clearCanvas();
    }

    function renderPage(page, canvas) {
      var isInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if ($scope.isRendering) {
        return;
      }

      $scope.isRendering = true;
      clearCanvas();
      var originViewport = page.getViewport({
        scale: 1
      });

      if (isInit) {
        if (originViewport) {
          vm.baseCanvasScale = (originViewport.height ? CANVAS_HEIGHT / originViewport.height : 1) * CANVAS_SCALE_MUTIPLER;
        }

        vm.canvasScale = vm.baseCanvasScale;
      }

      var viewport = page.getViewport({
        scale: vm.canvasScale
      });

      if (viewport) {
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        canvas.style.width = viewport.width / 2 + 'px';
        canvas.style.height = viewport.height / 2 + 'px';
      }

      var ctx = canvas.getContext("2d");
      page.render({
        canvasContext: ctx,
        viewport: viewport
      }).promise.then(function () {
        $scope.isRendering = false;
      })["catch"](function (err) {
        $log.error(err);
        $scope.isRendering = false;
      });
    }

    function blobToBase64(blob, cb) {
      var reader = new $window.FileReader();

      if (blob instanceof Blob) {
        reader.readAsDataURL(blob);

        reader.onloadend = function () {
          cb(reader.result);
        };
      } else {
        cb("error");
      }
    }

    function canvasToBase64(canvas, cb) {
      canvas.toBlob(function (blob) {
        blobToBase64(blob, cb);
      }, 'image/jpeg');
    }

    function _approveBillingData(dupId, additionalReq) {
      $scope.isLoading = true;
      apiFactory.approveBill({
        dupId: dupId,
        billId: vm.billing._id,
        status: "approved",
        customSupplierData: vm.billing.customSupplierData,
        billType: vm.billing.billType,
        amountWithoutTax: vm.billing.amountWithoutTax,
        taxAmount: vm.billing.taxAmount,
        totalAmount: vm.billing.totalAmount,
        approver: additionalReq.approverId,
        // to do confirm because generate on backend.
        projectId: additionalReq.projectId,
        vendor: additionalReq.vendorId,
        vendorType: additionalReq.vendorType
      }).then(function () {
        $scope.isLoading = false;
        Notification.success("".concat(vm.billing.billNo, " is approved successfully."));
        getBillingList();
      })["catch"](function (err) {
        $scope.isLoading = false;

        if (err.data && err.data.message) {
          Notification.error(err.data.message);
        } else {
          Notification.error("Failed in approve billing");
        }

        $log.log(err);
      });
    }

    function refineValue(value) {
      return Math.round((value + Number.EPSILON * Math.pow(10, 10)) * 100) / 100;
    }

    function _calculatePrices(billing) {
      if (!billing || !billing.customSupplierData || !billing.customSupplierData.supplies) {
        unsetRunningOCRBill(billing._id);
        return;
      }

      if ($scope.isNormalType(billing)) {
        billing.amountWithoutTax = 0;
        billing.taxAmount = 0;
        billing.totalAmount = 0;
        billing.customSupplierData.supplies.forEach(function (supply) {
          supply.price = Number.parseFloat(supply.qty) * Number.parseFloat(supply.unitprice);
          var price = supply.price;

          if (angular.isDefined(price) && price !== null) {
            var priceValue = Number(price);

            if (priceValue) {
              supply.vat = priceValue * utils.num($scope.vendorDetail.vat) / 100.0;
              supply.total = supply.vat + priceValue;
            }

            billing.amountWithoutTax += priceValue;
            billing.taxAmount += supply.vat;
            billing.totalAmount += supply.total;
          }
        });
      } else {
        billing.amountWithoutTax = refineValue(Number.parseFloat(billing.customSupplierData.totalprice));
        billing.taxAmount = refineValue(billing.amountWithoutTax * utils.num($scope.vendorDetail.vat) / 100.0);
        billing.totalAmount = refineValue(billing.amountWithoutTax + billing.taxAmount);
      }

      billing.amountWithoutTax = refineValue(billing.amountWithoutTax);
      billing.taxAmount = refineValue(billing.taxAmount);
      billing.totalAmount = refineValue(billing.amountWithoutTax + billing.taxAmount);
      vm.proceedBillingId = null;
      unsetRunningOCRBill(billing._id);
    }

    function calculatePrices(billing) {
      _calculatePrices(billing);

      vm.saveBillingData(billing);
      $timeout(function () {
        return $scope.$apply();
      });
    }

    $scope.getVat = function (billing) {
      var accountPlan = undefined;

      if (billing.billType && angular.isObject(billing.billType)) {
        accountPlan = billing.billType;
      } else {
        accountPlan = vm.economicTypeList.find(function (x) {
          return x._id === billing.billType;
        });
      }

      if (accountPlan && angular.isDefined(accountPlan.vat)) {
        return accountPlan.vat;
      }

      return billing && billing.vendor && billing.vendor.paymentTerms && billing.vendor.paymentTerms.vatPercent ? billing.vendor.paymentTerms.vatPercent : 0;
    };

    $scope.getVatNumber = function (billing) {
      var vatNumber;

      if (billing && billing.vendor) {
        if (billing.vendor.paymentTerms) {
          vatNumber = billing.vendor.paymentTerms.vatNumber;
        }
      }

      return vatNumber;
    };

    function _saveBillingData(billing, dupId, supplyIndex, isDeleting) {
      var data;
      var customSupplierData = angular.copy(billing.customSupplierData);

      if (supplyIndex >= 0) {
        customSupplierData.supplies = customSupplierData.supplies.map(function (item, index) {
          var supply = angular.fromJson(angular.toJson(item));

          if (index == supplyIndex) {
            delete supply.saveMode;
            delete supply.editMode;
          }

          return supply;
        });

        if (isDeleting) {
          customSupplierData.supplies.splice(supplyIndex, 1);
        }
      }

      data = {
        dupId: dupId,
        templateId: billing.templateId ? billing.templateId : null,
        group: billing.group && billing.group._id ? billing.group._id : null,
        groupType: billing.group && billing.group.groupType ? billing.group.groupType : null,
        vaOrder: billing.vaOrder && billing.vaOrder._id ? billing.vaOrder._id : null,
        billDate: billing.billDate ? billing.billDate : customSupplierData ? customSupplierData.billdate : undefined,
        dueDate: billing.dueDate ? billing.dueDate : customSupplierData ? customSupplierData.duedate : undefined,
        customSupplierData: customSupplierData,
        amountWithoutTax: billing.amountWithoutTax,
        taxAmount: billing.taxAmount,
        totalAmount: billing.totalAmount,
        vatPercent: billing.vatPercent
      };

      if (!utils.isEmpty(billing.billType)) {
        data.billType = billing.billType;
      }

      apiFactory.updateBillingData(data, billing._id).then(function (resp) {
        Notification.success("".concat(billing.billNo, " successfully updated"));

        if (supplyIndex >= 0) {
          billing.customSupplierData.supplies[supplyIndex].saveMode = false;
          billing.customSupplierData.supplies[supplyIndex].editMode = false;

          if (isDeleting) {
            if ($scope.isNormalType(billing)) {
              billing.amountWithoutTax -= billing.customSupplierData.supplies[supplyIndex].price;
              billing.taxAmount -= billing.customSupplierData.supplies[supplyIndex].vat;
              billing.totalAmount -= billing.customSupplierData.supplies[supplyIndex].total;
            }

            billing.customSupplierData.supplies.splice(supplyIndex, 1);
          }

          $scope.$apply();
          updateBillingTotalValues(billing);
          unsetRunningOCRBill(billing._id);
        }

        var index = vm.billList.findIndex(function (x) {
          return x._id == billing._id;
        });
        var tempBilling = angular.copy(resp.data.data);
        var currentBillingGroup = {};

        if (vm.billingGroups) {
          for (var i = 0; i < vm.billingGroups.length; i++) {
            if (vm.billingGroups[i]._id === resp.data.data.group) {
              currentBillingGroup = vm.billingGroups[i];
              break;
            }
          }
        }

        var currentBillType = {};

        if (vm.economicTypeList && vm.economicTypeList.length) {
          for (var j = 0; j < vm.economicTypeList.length; j++) {
            if (vm.economicTypeList[j]._id === resp.data.data.billType) {
              currentBillType = vm.economicTypeList[j];
            }
          }
        }

        tempBilling.billType = currentBillType;
        tempBilling.group = currentBillingGroup;
        vm.billList[index] = tempBilling;
        billing = vm.billList[index];
        unsetRunningOCRBill(billing._id);
      })["catch"](function (err) {
        $log.log(err);
      });
    }

    function updateBillingTotalValues(billing) {
      var data = {
        amountWithoutTax: billing.amountWithoutTax,
        taxAmount: billing.taxAmount,
        totalAmount: billing.totalAmount
      };
      apiFactory.updateBillingTotalValues(data, billing._id).then(function () {
        $scope.$apply();
      })["catch"](function (err) {
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    function getDueDate(billing) {
      var billDateString = billing.customSupplierData.billdate;
      var billDate = new Date(billDateString); // need to get from ocr         

      if (billDate && billing && billing.vendor && billing.vendor.paymentTerms) {
        var term = vm.companyData.paymentConditions.find(function (elem) {
          return elem._id === billing.vendor.paymentTerms.paymentSetting;
        });

        if (term) {
          var additionalDays = utils.getDaysFromPaymentTermsCode(term.code);
          var newDate = moment(billDate).clone();

          if (additionalDays) {
            var endDate = moment(newDate);

            if (additionalDays.w) {
              endDate = moment(newDate).isoWeek(7);
            } else if (additionalDays.m) {
              endDate = moment(newDate).endOf('month');
            }

            var dueDate = endDate.add(additionalDays.days, 'days');
            billing.customSupplierData.duedate = new Date(dueDate);
            $scope.dueDate = dueDate ? new Date(dueDate) : undefined;
            $scope.billDate = billDate ? new Date(billDate) : undefined;

            if (!angular.isDate($scope.dueDate)) {
              $scope.dueDate = null;
            }

            if (!angular.isDate($scope.billDate)) {
              $scope.billDate = null;
            }
          }
        }
      }
    }

    function getDueDateFromSupplier(billDateString, supplier) {
      var billDate = new Date(billDateString); // need to get from ocr

      var billTmp = moment(billDate).clone();
      billTmp.add(4, "hours");
      $scope.billDate = new Date(billTmp);

      if (billDate && supplier.paymentTerms) {
        var term = vm.companyData.paymentConditions.find(function (elem) {
          return elem._id === supplier.paymentTerms.paymentSetting;
        });

        if (term) {
          var additionalDays = utils.getDaysFromPaymentTermsCode(term.code);
          var newDate = moment(billDate).clone();

          if (additionalDays) {
            var endDate = moment(newDate);

            if (additionalDays.w) {
              endDate = moment(newDate).isoWeek(7);
            } else if (additionalDays.m) {
              endDate = moment(newDate).endOf('month');
            }

            var dueDate = endDate.add(additionalDays.days, 'days'); //billing.customSupplierData.duedate = new Date(dueDate);

            $scope.dueDate = dueDate ? new Date(dueDate) : undefined;

            if (!angular.isDate($scope.dueDate)) {
              $scope.dueDate = null;
            }

            if (!angular.isDate($scope.billDate)) {
              $scope.billDate = null;
            }
          }
        }
      }
    }

    function getVendorDetails(billing) {
      $scope.dueDate = billing.dueDate ? new Date(billing.dueDate) : undefined;
      $scope.billDate = billing.billDate ? new Date(billing.billDate) : undefined;

      if (!angular.isDate($scope.dueDate)) {
        $scope.dueDate = null;
      }

      if (!angular.isDate($scope.billDate)) {
        $scope.billDate = null;
      }

      $scope.vendorDetail = {};
      if (!billing.vendor) return;
      var vendor = billing.vendor;
      var address = {};

      if (vendor.address) {
        address = vendor.address[0] ? vendor.address[0] : vendor.address ? vendor.address : vendor.address1 ? vendor.address1 : vendor.address2 ? vendor.address2 : '';
      }

      $scope.vendorDetail.address = address;
      $scope.vendorDetail.fullAddress = '';

      if ($scope.vendorDetail.address.line1) {
        $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.line1 + ', ';
      }

      if ($scope.vendorDetail.address.city) {
        $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.city + ', ';
      }

      if ($scope.vendorDetail.address.countryCode) {
        $scope.vendorDetail.fullAddress += $scope.vendorDetail.address.countryCode + ', ';
      }

      $scope.vendorDetail.email = vendor.email;
      $scope.vendorDetail.phoneNumber = vendor.clientContact ? vendor.clientContact.dialCode + vendor.clientContact.phoneNumber : vendor.contact ? vendor.contact.dialCode + vendor.contact.phoneNumber : vendor.mobile ? vendor.mobile.dialCode + vendor.mobile.phoneNumber : '';
      $scope.vendorDetail.vat = $scope.getVat(billing);
      $scope.vendorDetail.vatNumber = $scope.getVatNumber(billing);
      $scope.bankDetails = {};
      var requiredFields = ['IBAN', 'bicCode', 'accountNumber', 'bankName'];

      if (vendor.bankDetails && vendor.bankDetails.length > 0) {
        requiredFields.forEach(function (key) {
          $scope.bankDetails[key] = vendor.bankDetails[0][key];
        });
      }

      $scope.vendorDetail.dueDate = new Date(billing.dueDate);

      if ($scope.vendorDetail.vat !== billing.vatPercent || billing.vatPercent && !billing.taxAmount) {
        billing.vatPercent = $scope.vendorDetail.vat;
        calculatePrices(billing);
      }

      $timeout(function () {
        $scope.$apply();
      });
    }

    $scope.addressString = function (address) {
      if (!address) {
        return '';
      }

      if (angular.isString(address)) {
        return address;
      }

      if (angular.isArray(address)) {
        address = address[0];
      }

      var addr = '';

      if (address.line2) {
        addr += address.line2;
        addr += ', ';
      }

      if (address.line1) {
        addr += address.line1;
        addr += ', ';
      }

      if (address.city) {
        addr += address.city;
        addr += ', ';
      }

      if (address.countryCode) {
        addr += address.countryCode;
        addr += ', ';
      }

      if (address.postalCode) {
        addr += address.postalCode;
      }

      return addr;
    };

    var DEV_ENV = false;

    function removeLines(imageData, canvas) {
      var src = cv.matFromImageData(imageData);
      var dst = new cv.Mat();
      var thresh = new cv.Mat();
      cv.cvtColor(src, dst, cv.COLOR_RGBA2GRAY);
      cv.threshold(dst, thresh, 0, 255, cv.THRESH_BINARY_INV + cv.THRESH_OTSU);
      var horizontal_kernel = cv.getStructuringElement(cv.MORPH_RECT, new cv.Size(30, 1));
      var remove_horizontal = new cv.Mat();
      cv.morphologyEx(thresh, remove_horizontal, cv.MORPH_OPEN, horizontal_kernel, new cv.Point(-1, -1), 2);
      var cnts = new cv.MatVector();
      var hierachies = new cv.Mat();
      cv.findContours(remove_horizontal, cnts, hierachies, cv.RETR_EXTERNAL, cv.CHAIN_APPROX_SIMPLE);

      for (var i = 0; i < cnts.size(); i++) {
        var color = new cv.Scalar(255, 255, 255);
        cv.drawContours(dst, cnts, i, color, 3, cv.LINE_8, hierachies, 5);
      }

      var vertical_kernel = cv.getStructuringElement(cv.MORPH_RECT, new cv.Size(1, 30));
      var remove_vertical = new cv.Mat();
      cv.morphologyEx(thresh, remove_vertical, cv.MORPH_OPEN, vertical_kernel, new cv.Point(-1, -1), 2);
      cv.findContours(remove_vertical, cnts, hierachies, cv.RETR_EXTERNAL, cv.CHAIN_APPROX_SIMPLE);

      for (var _i2 = 0; _i2 < cnts.size(); _i2++) {
        var _color = new cv.Scalar(255, 255, 255);

        cv.drawContours(dst, cnts, _i2, _color, 3, cv.LINE_8, hierachies, 5);
      }

      if (DEV_ENV) downloadCVImgDataAsImage(thresh, 'thres');
      if (DEV_ENV) downloadCVImgDataAsImage(dst, 'result');
      cv.imshow(canvas, dst);
    }

    var ocr_method = 1;
    var ocr_engine_ready = false;
    var worker = Tesseract.createWorker();
    var ocr_lang_config = 'eng+dan';

    function runFullOCR(pdf, pageNum) {
      var isFile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return new Promise(function (resolve, reject) {
        if (!isFile) {
          pdfFactory.getPageFromURL(pdf, pageNum).then(function (page) {
            var viewport = page.getViewport({
              scale: 3
            });
            var hiddenCanvas = $document[0].createElement('canvas');

            if (viewport) {
              hiddenCanvas.height = viewport.height;
              hiddenCanvas.width = viewport.width;
            }

            var ctx = hiddenCanvas.getContext("2d");
            $scope.isRendering = true;
            page.render({
              canvasContext: ctx,
              viewport: viewport
            }).promise.then(function () {
              $scope.isRendering = false;
              if (DEV_ENV) downloadCanvasAsImage(hiddenCanvas, 'before');
              var imageData = ctx.getImageData(0, 0, hiddenCanvas.width, hiddenCanvas.height);
              removeLines(imageData, hiddenCanvas);
              if (DEV_ENV) downloadCanvasAsImage(hiddenCanvas, 'after');
              canvasToBase64(hiddenCanvas, function (b64) {
                if (b64 === "error") {
                  Notification.error("Failed in OCR with current pdf");
                  reject();
                } else {
                  if (ocr_method == 0) {
                    Tesseract.recognize(b64).then(function (resp) {
                      resolve({
                        data: resp.data,
                        size: {
                          width: hiddenCanvas.width,
                          height: hiddenCanvas.height
                        }
                      });
                    })["catch"](function (err) {
                      reject(err);
                    });
                  } else if (ocr_method == 1) {
                    if (ocr_engine_ready) {
                      worker.recognize(b64).then(function (resp) {
                        $log.log(resp);
                        resolve({
                          data: resp.data,
                          size: {
                            width: hiddenCanvas.width,
                            height: hiddenCanvas.height
                          }
                        });
                      })["catch"](function (err) {
                        reject(err);
                      });
                    } else {
                      worker.load().then(function () {
                        worker.loadLanguage(ocr_lang_config).then(function () {
                          worker.initialize(ocr_lang_config).then(function () {
                            ocr_engine_ready = true;
                            worker.recognize(b64).then(function (resp) {
                              resolve({
                                data: resp.data,
                                size: {
                                  width: hiddenCanvas.width,
                                  height: hiddenCanvas.height
                                }
                              });
                            })["catch"](function (err) {
                              reject(err);
                            });
                          })["catch"](function (err) {
                            reject(err);
                          });
                        })["catch"](function (err) {
                          reject(err);
                        });
                      })["catch"](function (err) {
                        reject(err);
                      });
                    }
                  }
                }
              });
            })["catch"](function (err) {
              $scope.isRendering = false;
              reject(err);
            });
          })["catch"](function (err) {
            return reject(err);
          });
        } else {
          pdfFactory.getPageFromFile(pdf, pageNum).then(function (page) {
            var viewport = page.getViewport({
              scale: 3
            });
            var hiddenCanvas = $document[0].createElement('canvas');

            if (viewport) {
              hiddenCanvas.height = viewport.height;
              hiddenCanvas.width = viewport.width;
            }

            var ctx = hiddenCanvas.getContext("2d");
            $scope.isRendering = true;
            page.render({
              canvasContext: ctx,
              viewport: viewport
            }).promise.then(function () {
              $scope.isRendering = false;
              if (DEV_ENV) downloadCanvasAsImage(hiddenCanvas, 'before');
              var imageData = ctx.getImageData(0, 0, hiddenCanvas.width, hiddenCanvas.height);
              removeLines(imageData, hiddenCanvas);
              if (DEV_ENV) downloadCanvasAsImage(hiddenCanvas, 'after');
              canvasToBase64(hiddenCanvas, function (b64) {
                if (b64 === "error") {
                  Notification.error("Failed in OCR with current pdf");
                  reject();
                } else {
                  if (ocr_method == 0) {
                    Tesseract.recognize(b64).then(function (resp) {
                      resolve({
                        data: resp.data,
                        size: {
                          width: hiddenCanvas.width,
                          height: hiddenCanvas.height
                        }
                      });
                    })["catch"](function (err) {
                      reject(err);
                    });
                  } else if (ocr_method == 1) {
                    if (ocr_engine_ready) {
                      worker.recognize(b64).then(function (resp) {
                        resolve({
                          data: resp.data,
                          size: {
                            width: hiddenCanvas.width,
                            height: hiddenCanvas.height
                          }
                        });
                      })["catch"](function (err) {
                        reject(err);
                      });
                    } else {
                      worker.load().then(function () {
                        worker.loadLanguage(ocr_lang_config).then(function () {
                          worker.initialize(ocr_lang_config).then(function () {
                            ocr_engine_ready = true;
                            worker.recognize(b64).then(function (resp) {
                              resolve({
                                data: resp.data,
                                size: {
                                  width: hiddenCanvas.width,
                                  height: hiddenCanvas.height
                                }
                              });
                            })["catch"](function (err) {
                              reject(err);
                            });
                          })["catch"](function (err) {
                            reject(err);
                          });
                        })["catch"](function (err) {
                          reject(err);
                        });
                      })["catch"](function (err) {
                        reject(err);
                      });
                    }
                  }
                }
              });
            })["catch"](function (err) {
              $scope.isRendering = false;
              reject(err);
            });
          })["catch"](function (err) {
            return reject(err);
          });
        }
      });
    }

    function startOCRProgress(billing) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if ($scope.isRunningOCRBill(billing)) {
        Notification.info("OCR is running for ".concat(billing.billNo, "."));
        return;
      }

      if (billing.status === 'init' || billing.status === 'approved' && billing.externEconomics.isNaviSynced) {
        if (force) {
          Notification.error('Billing state is not valid');
        }

        return;
      }

      if (!billing.bill || !billing.bill.secure_url) {
        Notification.error('Invalid billing. Please delete it.');
        return;
      }

      if (!billing.templateId) {
        Notification.error('No template has been set. Please try again after setting a template.');
        return;
      }

      if (!force && billing.customSupplierData && billing.customSupplierData.supplies && billing.customSupplierData.supplies.length) {
        return;
      }

      vm.ocrBillIdList.push(billing._id);
      $timeout(function () {
        $scope.$apply();
      });

      if (!billing.customSupplierData) {
        resetCalcResult(billing);
      }

      var pageCount = billing && billing.templateId ? billing.templateId.pages.length : 1;
      var pageNum = 1;
      var ocrDataList = [];
      runFullOCR(billing.bill.secure_url, pageNum).then(function (resp) {
        var data = refineOCRResult(resp.data);

        if (data) {
          ocrDataList.push({
            data: data,
            size: resp.size
          });
        }

        pageNum += 1;

        if (pageNum <= pageCount) {
          runFullOCR(billing.bill.secure_url, pageNum).then(function (resp) {
            var data = refineOCRResult(resp.data);

            if (data) {
              ocrDataList.push({
                data: data,
                size: resp.size
              });
            }

            pageNum += 1;

            if (pageNum <= pageCount) {
              runFullOCR(billing.bill.secure_url, pageNum).then(function (resp) {
                var data = refineOCRResult(resp.data);

                if (data) {
                  ocrDataList.push({
                    data: data,
                    size: resp.size
                  });
                }

                pageNum += 1;
                runFullOCR(billing.bill.secure_url, pageNum).then(function (resp) {
                  var data = refineOCRResult(resp.data);

                  if (data) {
                    ocrDataList.push({
                      data: data,
                      size: resp.size
                    });
                  }

                  createBillOcrData(billing, ocrDataList);
                })["catch"](function (err) {
                  unsetRunningOCRBill(billing._id);
                  $log.error(err);
                  Notification.error('Failed in OCR');
                });
              })["catch"](function (err) {
                unsetRunningOCRBill(billing._id);
                $log.error(err);
                Notification.error('Failed in OCR');
              });
            } else {
              createBillOcrData(billing, ocrDataList);
            }
          })["catch"](function (err) {
            unsetRunningOCRBill(billing._id);
            $log.error(err);
            Notification.error('Failed in OCR');
          });
        } else {
          createBillOcrData(billing, ocrDataList);
        }
      })["catch"](function (err) {
        unsetRunningOCRBill(billing._id);
        $log.error(err);
        Notification.error('Failed in OCR');
      });

      function createBillOcrData(billing, data) {
        Notification.success("All OCR quotes are successfully completed for ".concat(billing.billNo));
        billing.ocrData = data;
        processOCRData(billing);
      }
    }

    function refineOCRResult(data) {
      if (!data || !data.lines) return;
      var lines = [];
      data.lines.forEach(function (line) {
        var obj = {
          baseline: line.baseline,
          bbox: line.bbox,
          text: line.text,
          words: removePoorWords(line.words)
        };
        lines.push(obj);
      });

      function removePoorWords(words) {
        var rlt = [];
        words.forEach(function (word) {
          if (word.confidence < confThres) return;
          var obj = {
            baseline: word.baseline,
            bbox: word.bbox,
            text: word.text
          };
          rlt.push(obj);
        });
        return rlt;
      }

      return {
        lines: lines
      };
    }

    function processOCRData(billing) {
      if (billing.templateId) {
        var template = billing.templateId;

        var _iterator = _createForOfIteratorHelper(template.pages),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var page = _step.value;
            delete page._id;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (processOCRDataWithTemplate(billing, template)) {
          calculatePrices(billing);
        } else {
          resetCalcResult(billing);
          processForFail(billing);
        }
      } else {
        Notification.error("Cannot find template for this bill. Please add one");
        unsetRunningOCRBill(billing._id);
      }
    }

    function getLoopFields(templateType) {
      if (!templateType.includes('normal')) {
        return Constants.OCRTemplateLoopFieldsList.slice(0).filter(function (x) {
          return x != 'unitprice';
        });
      }

      return Constants.OCRTemplateLoopFieldsList.slice(0);
    }

    function processOCRDataWithTemplate(billing, template) {
      var loopFields = getLoopFields(template.templateType);
      var ret = true;
      var lastBillData = {};
      var dateMode = billing.dateMode || 'dmy';

      var _loop = function _loop(i) {
        var rawData = billing.ocrData[i];

        if (angular.isUndefined(rawData) || angular.isUndefined(rawData.data.lines)) {
          return "continue";
        }

        var templateSize = rawData.size;
        var page = template.pages[i];

        if (utils.isEmpty(page)) {
          return "continue";
        }

        var keys = Object.keys(page);
        loopFields = loopFields.filter(function (x) {
          return keys.includes(x);
        });

        for (var j = 0; j < keys.length; j++) {
          var key = keys[j];
          var text = '';

          var _iterator2 = _createForOfIteratorHelper(rawData.data.lines),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var line = _step2.value;

              if (rectIncludes(makeRcFromFieldArea(page[key], templateSize), line.bbox, 'y')) {
                var _iterator3 = _createForOfIteratorHelper(line.words),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var word = _step3.value;

                    if (rectIncludes(makeRcFromFieldArea(page[key], templateSize), word.bbox, 'x')) {
                      text += word.text + ' ';
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          if (key == 'invoicenumber' && utils.isEmpty(text)) {
            ret = false; // Notification.error('Invoice number is not recognized');
          }

          if (key == 'billdate') {
            $log.log('billDate--------------');
            text = getDateString(text, dateMode);

            if (utils.isEmpty(text)) {
              Notification.error('Bill date is not recognized. Please check the Date Mode');
            }
          }

          if (key == 'totalprice') {
            text = getValidValue(billing, text, key);
          }

          if (!utils.isEmpty(text) && !loopFields.includes(key)) {
            lastBillData[key] = text;
          }
        }

        billing.customSupplierData = lastBillData;

        if (billing.customSupplierData.billdate) {
          getDueDate(billing);
        }

        var supplies = void 0;

        if (template.billingId) {
          supplies = processManualLoopFields(billing, template);
          $log.log('222222222222222222222222');
          $log.log(supplies);
        } else {
          supplies = processLoopFields(billing, page, template, rawData);
          $log.log('333333333333333333333333');
          $log.log(supplies);
        }

        if (angular.isUndefined(billing.customSupplierData.supplies)) {
          billing.customSupplierData.supplies = [];
        }

        var _iterator4 = _createForOfIteratorHelper(supplies),
            _step4;

        try {
          var _loop2 = function _loop2() {
            var supply = _step4.value;

            if (!billing.customSupplierData.supplies.find(function (x) {
              return supply.description == x.description;
            })) {
              billing.customSupplierData.supplies.push(supply);
            }
          };

          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      };

      for (var i = 0; i < template.pages.length; i++) {
        var _ret = _loop(i);

        if (_ret === "continue") continue;
      }

      return ret;
    }

    function processLoopFields(billing, page, template, rawData) {
      var templateSize = rawData.size;
      var qtyRc = makeRcFromFieldArea(page.qty, templateSize);
      var supplies = [];
      var loopFields = getLoopFields(template.templateType);
      var loopLength = loopFields.length;

      for (var i = 0; i < rawData.data.lines.length; i++) {
        var line = rawData.data.lines[i];

        if (rectIncludes(qtyRc, line.bbox, 'y')) {
          var lastIndex = -1;

          var _loop3 = function _loop3(j) {
            var newLine = rawData.data.lines[j];
            var obj = {};
            loopFields.forEach(function (key) {
              var rc = makeRcFromFieldArea(page[key], templateSize);
              newLine.words.forEach(function (word) {
                if (rectIncludes(rc, word.bbox, 'x')) {
                  if (key == 'description') {
                    if (obj[key]) {
                      obj[key] += word.text + ' ';
                    } else {
                      obj[key] = word.text;
                    }
                  } else {
                    var value = getValidValue(billing, word.text, key);

                    if (!value) {
                      return;
                    }

                    obj[key] = value;
                  }
                }
              });
            });

            if (Object.keys(obj).length == loopLength && (lastIndex == -1 || j - lastIndex <= 3)) {
              supplies.push(obj);
              lastIndex = j;
            } else if (Object.keys(obj).length == 1 && obj.description && j - lastIndex <= 2) {
              if (supplies.length > 0) {
                supplies[supplies.length - 1].description += obj.description;
                lastIndex = j;
              }
            }
          };

          for (var j = i + 1; j < rawData.data.lines.length; j++) {
            _loop3(j);
          }

          break;
        }
      }

      return supplies;
    }

    function processManualLoopFields(billing, template) {
      var supplies = [];
      var loopFields = getLoopFields(template.templateType);
      var data = billing.customSupplierData;
      var MAX_SUPPLIES_COUNT = 10;

      for (var i = 1; i <= MAX_SUPPLIES_COUNT; i++) {
        var obj = {};

        for (var j = 0; j < loopFields.length; j++) {
          var field = loopFields[j];
          var key = field + i;

          if (data[key]) {
            obj[field] = data[key];

            if (j === loopFields.length - 1) {
              supplies.push(obj);
            }
          } else {
            break;
          }
        }
      }

      return supplies;
    }

    function rectIncludes(rectParent, rectChild, axis) {
      var rcThresY = (rectChild.y1 - rectChild.y0) * 0.5;
      var extendedParentRc = {
        x0: Math.max(0, rectParent.x0 - rcThres),
        y0: Math.max(0, rectParent.y0 - rcThresY),
        x1: rectParent.x1 + rcThres,
        y1: rectParent.y1 + rcThresY
      };

      if (axis == 'x') {
        return rectChild.x0 > extendedParentRc.x0 && rectChild.x1 < extendedParentRc.x1;
      } else if (axis == 'y') {
        return rectChild.y0 > extendedParentRc.y0 && rectChild.y1 < extendedParentRc.y1;
      } else {
        return rectChild.x0 > extendedParentRc.x0 && rectChild.y0 > extendedParentRc.y0 && rectChild.x1 < extendedParentRc.x1 && rectChild.y1 < extendedParentRc.y1;
      }
    }

    function makeRcFromFieldArea(field, templateSize) {
      return {
        x0: templateSize.width * field.x,
        y0: templateSize.height * field.y,
        x1: templateSize.width * field.width + templateSize.width * field.x,
        y1: templateSize.height * field.height + templateSize.height * field.y
      };
    }

    function getValidValue(billing, text, key) {
      if (key == 'description') {
        return text;
      }

      if (text.toString) {
        text = text.toString();
      }

      var locale = billing && billing.inputMethod ? billing.inputMethod : 'eu';
      var value = utils.getNormalNumber(text, locale);

      if (isNaN(value)) {
        return;
      }

      return value;
    }

    function processForFail(billing) {
      Notification.error('Failed in OCR. The invoice number was not recognized.');
      unsetRunningOCRBill(billing._id);
    }

    function getDateString(s, mode) {
      var regex = new RegExp('[a-z]', 'i');

      if (regex.test(s)) {
        var date = new Date(s);
        date = moment(date);
        return date.format('MMM.DD.yyyy');
      } else {
        var ary;
        s = s.replaceAll('-', '.');
        s = s.replaceAll('/', '.');
        ary = s.split('.');

        if (ary.length !== 3) {
          return '';
        }

        var y, m, d;

        switch (mode) {
          case 'mdy':
            m = ary[0];
            d = ary[1];
            y = ary[2];
            break;

          case 'dmy':
            d = ary[0];
            m = ary[1];
            y = ary[2];
            break;

          case 'ymd':
            y = ary[0];
            m = ary[1];
            d = ary[2];
            break;

          case 'ydm':
            y = ary[0];
            d = ary[1];
            m = ary[2];
            break;

          default:
            y = 0;
            d = 0;
            m = 0;
        }

        y = y.trim();
        m = m.trim();
        d = d.trim();
        var ny = Number.parseInt(y);
        var nm = Number.parseInt(m);
        var nd = Number.parseInt(d);

        if (isNaN(ny) || isNaN(nm) || isNaN(nd)) {
          return '';
        }

        if (ny < 100) {
          ny += 2000;
        }

        if (nm < 1 || nm > 12) {
          return '';
        }

        if (nd < 1 || nd > 31) {
          return '';
        }

        var _date = new Date("".concat(ny, "-").concat(nm, "-").concat(nd));

        _date = moment(_date);
        return _date.format('MMM.DD.yyyy');
      }
    }

    function resetCalcResult(billing) {
      if (billing) {
        billing.customSupplierData = {};
        delete billing.amountWithoutTax;
        delete billing.taxAmount;
        delete billing.totalAmount;
      }
    }

    $scope.updateBillDate = function () {
      if (vm.billing) {
        vm.billing.billDate = new Date($scope.billDate);
      }
    };

    $scope.updateDueDate = function () {
      if (vm.billing) {
        vm.billing.dueDate = new Date($scope.dueDate);
      }
    };

    $scope.isNormalType = function (billing) {
      if (!billing) {
        return true;
      }

      var template = billing.templateId;

      if (!template || !template.templateType) {
        return true;
      }

      return template.templateType.includes('normal');
    };

    $scope.isProjectTab = function () {
      return $scope.currentTab === PROJECT_BILL;
    };

    $scope.isCompanyTab = function () {
      return $scope.currentTab === COMPANY_BILL;
    };

    $scope.isPendingTab = function () {
      return $scope.currentTab === PENDING_BILL;
    };

    $scope.isFailedSyncTab = function () {
      return $scope.currentTab === FAILED_SYNC;
    };

    $scope.isMemoTab = function () {
      return $scope.currentTab === VENDOR_CREDIT_MEMO;
    };

    $scope.isRunningOCRBill = function (billing) {
      return billing && vm.ocrBillIdList.findIndex(function (x) {
        return x == billing._id;
      }) !== -1;
    };

    function unsetRunningOCRBill(billingId) {
      if (billingId == vm.proceedBillingId) {
        return;
      }

      var index = vm.ocrBillIdList.findIndex(function (x) {
        return x == billingId;
      });

      if (index !== -1) {
        vm.ocrBillIdList.splice(index, 1);
      }
    }

    $scope.deleteBilling = function () {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        apiFactory.deleteBilling(vm.billing._id).then(function () {
          Notification.success("".concat(vm.billing.billNo, " removed successfully."));
          getBillingList();
        })["catch"](function (err) {
          $log.error(err);
          Notification.error("Failed to remove!");
        });
      }, function () {});
    };

    function downloadCanvasAsImage(canvas, label) {
      var link = $document[0].createElement('a');
      link.download = label + '_' + Date.now() + '.png';
      link.href = canvas.toDataURL();
      link.click();
    }

    function downloadCVImgDataAsImage(imgData, label) {
      var outputCanvas = $document[0].createElement('canvas');
      cv.imshow(outputCanvas, imgData);
      downloadCanvasAsImage(outputCanvas, label);
    }

    $scope.changeIsRemoveVAT = function () {
      $scope.vendorDetail.vat = vm.isRemoveVAT ? 0 : $scope.getVat(vm.billing);
      calculatePrices(vm.billing);
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('sideMenuRegistrations', sideMenuRegistrations);

  function sideMenuRegistrations() {
    return {
      restrict: 'E',
      templateUrl: 'app/main/dashboard/directives/side-menu-registrations/side-menu-registrations.view.html',
      scope: {
        ngModel: '='
      },
      link: function link($scope) {
        $scope.registrations = Object.assign([], $scope.ngModel);

        $scope.onSearchRegistrations = function () {
          $scope.registrations = $scope.ngModel.filter(function (x) {
            return x.title.toLowerCase().includes($scope.searchText) || x.systemTag.toLowerCase().includes($scope.searchText);
          });
        };

        $scope.onClose = function () {
          var menu = angular.element('#side-menu-registrations');
          var isOpen = menu.hasClass('open');

          if (isOpen) {
            menu.removeClass('open');
          }
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('sideMenuIssues', sideMenuIssues);

  function sideMenuIssues() {
    return {
      restrict: 'E',
      templateUrl: 'app/main/dashboard/directives/side-menu-issues/side-menu-issues.view.html',
      scope: {
        ngModel: '='
      },
      link: function link($scope) {
        $scope.issues = Object.assign([], $scope.ngModel);

        $scope.onSearchIssue = function () {
          $scope.issues = $scope.ngModel.filter(function (x) {
            return x.title.toLowerCase().includes($scope.searchText) || x.systemTag.toLowerCase().includes($scope.searchText);
          });
        };

        $scope.onClose = function () {
          var menu = angular.element('#side-menu-issues');
          var isOpen = menu.hasClass('open');

          if (isOpen) {
            menu.removeClass('open');
          }
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardWeatherBlock", dashboardWeatherBlock);

  function dashboardWeatherBlock(globals, moment, $log) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-weather-block/dashboard-weather-block.view.html",
      scope: {
        type: '='
      },
      link: function link(scope) {
        var getWeather = globals.getWeather,
            projectStore = globals.projectStore;
        scope.project = projectStore.get();
        /**Weather */

        if ("geolocation" in navigator) {
          /* geolocation is available */
          navigator.geolocation.getCurrentPosition(function (position) {
            getWeather([position.coords.latitude, position.coords.longitude]).then(function (_ref) {
              var data = _ref.data;
              scope.weatherData = data;
              updateWeatherIcon();
              scope.$apply();
            });
          }, function (err) {
            $log.info(err);

            if (scope.project.address && scope.project.address.loc && scope.project.address.loc.coordinates) {
              getWeather(scope.project.address.loc.coordinates).then(function (_ref2) {
                var data = _ref2.data;
                scope.weatherData = data;
                updateWeatherIcon();
                scope.$apply();
              });
            }
          });
        } else {
          /* geolocation IS NOT available */
          $log.error("Cannot get geolocation in this browser");

          if (scope.project.address && scope.project.address.loc && scope.project.address.loc.coordinates) {
            getWeather(scope.project.address.loc.coordinates).then(function (_ref3) {
              var data = _ref3.data;
              scope.weatherData = data;
              updateWeatherIcon();
              scope.$apply();
            });
          }
        }

        function updateWeatherIcon() {
          if (scope.weatherData && scope.weatherData.weather[0]) {
            var description = scope.weatherData.weather[0].description;

            switch (description) {
              case "broken clouds":
              case "mist":
                scope.weatherIcon = "/assets/images/dashboard/weather-cloudy.png";
                break;

              case "shower rain":
              case "rain":
                scope.weatherIcon = "/assets/images/dashboard/weather-rain.png";
                break;

              case "thunderstorm":
                scope.weatherIcon = "/assets/images/dashboard/weather-thunderstorm.png";
                break;

              case "snow":
                scope.weatherIcon = "/assets/images/dashboard/weather-snow.png";
                break;

              default:
                //"clear sky", "few clouds",  "scattered clouds" others
                scope.weatherIcon = "/assets/images/dashboard/weather-sunny.png";
                break;
            }
          }
        }

        scope.getCurrentDate = function () {
          return moment().format("MMMM DD");
        };

        scope.getCurrentDay = function () {
          return moment().format("dddd");
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardTodoBlock", dashboardTodoBlock);

  function dashboardTodoBlock($uibModal, $log, apiFactory) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-todo-block/dashboard-todo-block.view.html",
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.fetchData = function () {
        scope.loading = true;
        apiFactory.listAllTodoList().then(function (res) {
          scope.loading = false;
          scope.todoList = [{
            _id: "to-do",
            name: "To Do",
            children: res.data.data.filter(function (elem) {
              return elem.status == 0;
            })
          }, {
            _id: "in-progress",
            name: "In Progress",
            children: res.data.data.filter(function (elem) {
              return elem.status == 1;
            })
          }];
        })["catch"](function (err) {
          scope.loading = false;
          $log.error(err);
        });
      };

      scope.fetchData();

      scope.addTodo = function () {
        var todoModal = $uibModal.open({
          animation: true,
          component: 'saveTodoModal',
          windowClass: 'save-todo-modal',
          resolve: {}
        });
        todoModal.result.then(function () {
          scope.fetchData();
        }, function (reason) {
          $log.info(reason);
        });
      };

      scope.editTodo = function (id) {
        var todoModal = $uibModal.open({
          animation: true,
          component: 'saveTodoModal',
          windowClass: 'save-todo-modal',
          resolve: {
            todoId: function todoId() {
              return id;
            }
          }
        });
        todoModal.result.then(function () {
          scope.refreshEvent();
        }, function (reason) {
          $log.info(reason);
        });
      };
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardTodayTaskBlock", dashboardTodayTaskBlock);

  function dashboardTodayTaskBlock($uibModal, $log, $timeout, apiFactory) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-today-task-block/dashboard-today-task-block.view.html",
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.tasks = [];
      fetchData();

      scope.getIcon = function (index) {
        // if (item.status === 2) {
        if (3 - index % 4 === 2 || 3 - index % 4 === 1) {
          return "/assets/icons/circle-check-green.svg"; // } else if (item.status === 3) {
        } else if (3 - index % 4 === 3) {
          return "/assets/icons/circle-check-red.svg";
        } else {
          return "/assets/icons/circle-check-empty.svg";
        }
      };

      scope.getTextStatus = function (status) {
        switch (3 - status % 4) {
          case 0:
            return 'Not yet Started';

          case 1:
            // return 'In-progress';
            return 'Completed';

          case 2:
            return 'Completed';

          case 3:
            return 'Failed';

          default:
            return '';
        }
      };

      scope.addTask = function () {
        $uibModal.open({
          animation: true,
          component: 'saveTodoModal',
          windowClass: 'save-todo-modal'
        }).result.then(function () {
          fetchData();
        }, function () {});
      };

      function fetchData() {
        scope.loading = true;
        Promise.all([apiFactory.listAllTodoList(), apiFactory.getMeetingRoomsForCompany()]).then(function (resp) {
          scope.loading = false;
          var todos = resp[0].data.data || [];
          var meetings = resp[1].data.data || [];
          var tasks = [];
          todos.forEach(function (todo) {
            todo.date = new Date(todo.deadlineTime);
            tasks.push(todo);
          });
          meetings.forEach(function (meeting) {
            meeting.date = new Date(meeting.dateFrom);
            tasks.push(meeting);
          });
          tasks.sort(function (a, b) {
            return a.date.getTime() - b.date.getTime();
          });
          scope.tasks = tasks;
        })["catch"](function (err) {
          scope.loading = false;
          $log.error(err);
        });
      }
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardTenderRequirementsBlock", dashboardTenderRequirementsBlock);

  function dashboardTenderRequirementsBlock(utils) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-tender-requirements-block/dashboard-tender-requirements-block.view.html",
      scope: {
        height: '=',
        data: '='
      },
      link: function link(scope) {
        scope.utils = utils;
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module("app").directive("dashboardTechnicalQueriesBlock", dashboardTechnicalQueriesBlock);

  function dashboardTechnicalQueriesBlock($log, apiFactory, globals, utils, $state, localStorageService, authFactory, Bim, $timeout, Notification) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-technical-queries-block/dashboard-technical-queries-block.view.html",
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc($scope) {
      var logout = globals.logout,
          projectStore = globals.projectStore,
          userStore = globals.userStore,
          companyStore = globals.companyStore;
      /* Get project */

      $scope.project = projectStore.get();
      $scope.userData = userStore.get();
      $scope.searchText = '';

      $scope.goDashboard = function () {
        $state.go(globals.getDashboardRoute($scope.userData));
      };

      if (!$scope.project || $scope.project._id === 'all') {
        Notification.error('Please select project first.');
        $state.go(globals.getDashboardRoute($scope.userData));
        return;
      }

      $scope.disType = 'Electrical';
      $scope.discipList = ['Electrical', 'Plumbing', 'Ventilation', 'Architect', 'Mechanical']; // let dType = globals.getDashboardType($scope.userData);
      // if ($scope.userData.designation === "Admin") {
      //   $scope.TQ_ACCESS_CREATE = 4;
      // } else {
      //   $scope.loading = true;
      //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.TQ]})
      //     .then(res => {
      //       $scope.loading = false;
      //       $scope.TQ_ACCESS_CREATE = res.data.data[Constants.AccessKey.TQ];
      //     })
      //     .catch((e) => {
      //       $scope.loading = false;
      //       $log.error(e);
      //       Notification.error('Something went wrong try later')
      //     });
      // }

      $scope.searchTextList = [];
      $scope.totalCount = 0;
      $scope.numPerPage = 12;
      $scope.totalPages = 0;
      $scope.currentPage = 1;
      $scope.periods = [{
        id: '12',
        name: '12'
      }, {
        id: '24',
        name: '24'
      }, {
        id: '48',
        name: '48'
      }];
      $scope.loading = false;

      $scope.searchTq = function () {
        if ($scope.searchText && utils.isEmpty($scope.searchTextList)) {
          $scope.searchTextList.push($scope.searchText);
        }

        $scope.loading = true;
        apiFactory.listAllTqs({
          projectId: $scope.project._id,
          page: $scope.currentPage,
          size: $scope.numPerPage,
          discipline: $scope.disType,
          sort: "updatedAt",
          sortType: "true",
          search: $scope.searchText
        }).then(function (resp) {
          $scope.loading = false;
          $scope.totalCount = resp.data.total;
          $scope.tqs = resp.data.list || [];
          $scope.totalPages = Math.ceil($scope.totalCount / $scope.numPerPage);
        })["catch"](function (e) {
          $scope.loading = false;
          $log.error(e);

          if (e.status === 403) {
            Notification.error(e.data.message);
            $state.go(globals.getDashboardRoute($scope.userData));
          }
        });
      };

      $scope.searchTq();

      $scope.onCreateTQ = function () {
        localStorageService.set('tqData', {});
        $state.go('createTq');
      };

      $scope.getTqStatusClass = function (status) {
        switch (status) {
          case 'Draft':
            return {
              'draft': true
            };

          case 'Open':
            return {
              'open': true
            };

          case 'Closed':
            return {
              'closed': true
            };

          case 'Answered':
            return {
              'answered': true
            };

          default:
            return {
              'draft': true
            };
        }
      };

      $scope.setDiscipType = function (discipline) {
        $scope.disType = discipline;
        $scope.searchTq();
      };

      $scope.deleteTq = function (index, id) {
        apiFactory.deleteTq(id).then(function (res) {
          Notification.success(res.data.message);
          $scope.tqs.splice(index, 1);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error('Cannot delete Technical Query!');
        });
      };

      $scope.gotoTqDetail = function (id) {
        $state.go('detailTq', {
          id: id
        });
      };

      $scope.$watch('tqs', function () {}); //Table Detail Tq part

      if (!authFactory.checkUser()) {
        logout();
        return;
      }

      $scope.companyData = companyStore.get();
      $scope.vppages = [];
      $scope.currentTab = 'attach';
      $scope.vpCurPage = undefined;
      $scope.modelTitle = '';
      $scope.isPlanViewer = false;
      $scope.files = [];
      $scope.TQ_ACCESS_CREATE = 100; // if ($scope.userData.designation === "Admin") {
      //   $scope.TQ_ACCESS_CREATE = 4;
      // } else {
      //   $scope.isLoadingDetail = true;
      //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.ISSUE]})
      //       .then(res => {
      //         $scope.isLoadingeDtail = false;
      //         $scope.TQ_ACCESS_CREATE = res.data.data[Constants.AccessKey.ISSUE];
      //       })
      //       .catch((e) => {
      //         $scope.isLoadingeDtail = false;
      //         $log.error(e);
      //         Notification.error('Something went wrong try later')
      //       });
      // }

      if (utils.isEmpty($scope.project)) {
        Notification.error('Please select project first.');
        $state.go(globals.getDashboardRoute($scope.userData));
        return;
      }

      $scope.m3dLevelList = [];
      /* status */

      $scope.statusList = [{
        label: 'Draft',
        key: 'Draft'
      }, {
        label: 'Open',
        key: 'Open'
      }, {
        label: 'Closed',
        key: 'Closed'
      }, {
        label: 'Answered',
        key: 'Answered'
      }];
      /* Discipline */
      // $scope.discipList = [
      //   { label: 'Electrical', key: 'Electrical' },
      //   { label: 'Plumbing', key: 'Plumbing' },
      //   { label: 'Ventilation', key: 'Ventilation' },
      //   { label: 'Architect', key: 'Architect' },
      //   { label: 'Mechanical', key: 'Mechanical' }
      // ];

      $scope.selected3dModel = undefined;
      /**Status bar section */

      $scope.unit = 'm';
      $scope.statusData = {
        pos: '',
        info: ''
      };
      $scope.statusDisplayData = {
        pos: '',
        info: ''
      };
      $scope.toolbarList = {
        moveTool: [{
          id: 'select',
          icon: "cursor.svg",
          description: "Select"
        }, {
          id: 'pan',
          icon: "pan-move.svg",
          description: "Pan move"
        }, {
          id: 'paint',
          icon: "paint-bucket.svg",
          description: "Fill bucket"
        }, {
          id: 'erase',
          icon: "eraser.svg",
          description: "Eraser"
        }],
        drawingTool: [{
          id: 'text',
          icon: "drawing-pen.svg",
          description: "Draw text"
        }, {
          id: 'polyline',
          icon: "drawing-line.svg",
          description: "Draw line"
        }, {
          id: 'rect',
          icon: "drawing-rect.svg",
          description: "Draw rect"
        }, {
          id: 'addCross',
          icon: "drawing-round-rect.svg",
          description: "Draw round rect"
        }, {
          id: 'visibleCross',
          icon: "drawing-12718.svg",
          description: "Show cross section"
        }, {
          id: 'visibleCross',
          icon: "drawing-76.svg",
          description: "Show cross section"
        }, {
          id: 'visibleCross',
          icon: "drawing-11.svg",
          description: "Show cross section"
        }, {
          id: 'visibleCross',
          icon: "drawing-30.svg",
          description: "Show cross section"
        }, {
          id: 'visibleCross',
          icon: "drawing-09.svg",
          description: "Show cross section"
        }, {
          id: 'visibleCross',
          icon: "drawing-127.svg",
          description: "Show cross section"
        }],
        measureTool: [{
          id: 'diameter',
          icon: "drawing-16.svg",
          description: "Measure diameter"
        }, {
          id: 'commonlength',
          icon: "drawing-52.svg",
          description: "Measure distance"
        }, {
          id: 'totalarea',
          icon: "drawing-12729.svg",
          description: "Measure area"
        }, {
          id: 'angle',
          icon: "drawing-12728.svg",
          description: "Measure angle"
        }]
      };
      $scope.propertyIndicator = {
        show: false
      };

      $scope.change3dModel = function () {
        if (!utils.isEmpty($scope.tqData.marker.info3d.modelId) && !$scope.isVP) {
          // angular.element("#initial_loading_popup").show();
          $scope.isLoadingDetail = true;
          Promise.all([apiFactory.get3dModel($scope.tqData.marker.info3d.modelId), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getWorkLevelAndTypes(), apiFactory.getCalcSheet($scope.projectId), apiFactory.listInventories($scope.tqData.marker.info3d.modelId)]).then(function (resp) {
            var model = resp[0].data.data;
            $scope.modelTitle = model.name;
            $scope.m3dLevelList = Bim.levelList(model);
            $scope.selected3dModel = model;

            if (model) {
              $scope.materials = resp[1].data.list;
              $scope.comboMaterials = resp[2].data.list;
              $scope.equipments = resp[3].data.list;
              $scope.comboEquipments = resp[4].data.list;

              if (resp[5].data.data) {
                $scope.workLevels = resp[5].data.data.workLevels;
                $scope.workTypes = resp[5].data.data.workTypes;
              }

              if (resp[6].data.data) {
                $scope.sections = resp[6].data.data.levels;
              }

              var inventories = resp[7].data.list;
              refactorInventories(inventories);
              $scope.isLoadingDetail = false;
              load3dViewer(model, inventories);
            }
          })["catch"](function (e) {
            $scope.loading = false;
            $log.error(e);
          });
        }
      };

      function load3dViewer(data, inventories) {
        $scope.viewer3d = Bim.mainViewer(angular.element("#bimviewer")[0]);
        $scope.viewer3d.create();
        $scope.viewer3d.setInputMethod($scope.companyData.companyInputMethod === 'European et al.' ? 'eu' : 'en');
        /* 2d viewer */

        $scope.viewer2d = Bim.planViewer(angular.element('#model2d')[0]);
        $scope.viewer2d.initialize(angular.element("#three-canvas-2d")[0].width, angular.element("#three-canvas-2d")[0].height);
        $scope.isLoadingDetail = false;
        $scope.bimData = $scope.viewer3d.getBimData();
        $scope.viewer3d.on('objectSelected', onObjectSelected);
        $scope.viewer3d.on('textSelected', onTextSelected);
        $scope.viewer3d.on('textDeselected', onTextDeselected);
        $scope.viewer3d.on('showContextMenu', onShowContextMenu); //$scope.viewer3d.on('updateStatusData', updateStatusData);

        $scope.viewer3d.on('objectDblClicked', onBimObjectDblClicked);
        $scope.viewer3d.on('thumbnailReady', onThumbnailReady);
        $scope.viewer3d.on('planAdded', applyData);
        $scope.viewer3d.on('planTransformReady', showPlanControlMark);
        $scope.viewer3d.on('cameraZoomChanged', function (zoom) {
          $scope.zoomLevel = zoom;
        });
        $scope.viewer3d.on('requestShowPlan', applyData);
        $scope.viewer3d.on('toolActivated', onToolActivated);
        $scope.viewer3d.on('markerPlaced', markerPlaced);
        $scope.viewer3d.on('markerRemoved', markerRemoved);
        $scope.applyTexture = false;
        $scope.showPlan = false;
        $scope.statusDisplayData.pos = {
          x: '',
          y: '',
          z: ''
        };
        $scope.statusDisplayData.info = {
          area: '',
          width: '',
          height: ''
        };
        $scope.themes = [{
          id: 0,
          space: '/assets/images/cgviewer/bim/environment/space-01/back.jpg',
          ground: '/assets/images/cgviewer/bim/environment/ground-01.jpg'
        }, {
          id: 1,
          space: '/assets/images/cgviewer/bim/environment/space-02/back.jpg',
          ground: '/assets/images/cgviewer/bim/environment/ground-02.jpg'
        }, {
          id: 2,
          space: '/assets/images/cgviewer/bim/environment/space-03/back.jpg',
          ground: '/assets/images/cgviewer/bim/environment/ground-03.jpg'
        }, {
          id: 3,
          space: '/assets/images/cgviewer/bim/environment/space-04/back.jpg',
          ground: '/assets/images/cgviewer/bim/environment/ground-04.jpg'
        }, {
          id: 4,
          space: '/assets/images/cgviewer/bim/environment/space-05/back.jpg',
          ground: '/assets/images/cgviewer/bim/environment/ground-05.jpg'
        }, {
          id: 5,
          space: '/assets/images/cgviewer/bim/environment/space-06/back.jpg',
          ground: '/assets/images/cgviewer/bim/environment/ground-06.jpg'
        }, {
          id: 6,
          space: '/assets/images/cgviewer/bim/environment/space-07/back.jpg',
          ground: '/assets/images/cgviewer/bim/environment/ground-07.jpg'
        }, {
          id: 7,
          image: '/assets/images/cgviewer/bim/environment/bg-empty.jpg',
          empty: true
        }];
        $scope.textBrush = $scope.viewer3d.textBrush;

        if (data.viewer) {
          $scope.theme = $scope.themes[data.viewer.theme];
          $scope.viewer3d.setTheme($scope.theme);
        }

        $scope.viewer3d.loadBim(data).then(function (bimModel) {
          angular.element("#initial_loading_popup").hide();
          $scope.bimModel = bimModel;
          $scope.productList = Object.values($scope.bimModel.objectMap);
          $scope.bimModel.setInventoryData(inventories);
          $scope.modelInfo = {
            bimModel: bimModel,
            location: $scope.location,
            gisTransformData: $scope.gisTransformData
          };

          if ($scope.tqData.marker.info3d && $scope.tqData.marker.info3d.level) {
            $scope.change3dModelLevel();
          } //if($scope.tqData.marker.info3d && )


          applyData();
        })["catch"](function (err) {
          $log.error(err);
          angular.element("#initial_loading_popup").hide();
          Notification.error('IFC file cannot open.');
        });
      }

      $scope.toolbarEvent = function (id) {
        if (!$scope.viewer) return;

        switch (id) {
          case 'select':
            $scope.viewer3d.setDragAction('picker');
            $scope.viewer3d.setCursor('default');
            break;

          case 'pan':
            $scope.viewer3d.setDragAction('pan');
            $scope.viewer3d.setCursor('position', true, true);
            break;

          case 'commonlength':
          case 'angle':
          case 'circumference':
          case 'diameter':
          case 'volume':
          case 'sameplane':
          case 'totalarea':
            $scope.viewer3d.newDimensions(id);
            break;

          case 'paint':
            $scope.viewer3d.newPaint();
            break;

          case 'text':
            $scope.textBrush.show = true;
            $scope.viewer3d.newText();
            break;

          case 'addCross':
            $scope.viewer3d.onAddCrossSection();
            break;

          case 'visibleCross':
            $scope.viewer3d.onVisibleCrossSection();
            break;

          case 'applyCross':
            $scope.viewer3d.onApplyCrossSection();
            break;

          case 'camera':
            $scope.viewer3d.takeScreenshot();
            break;
        }
      };

      function onObjectSelected(object, objects) {
        hidePlanControlMark();

        if (angular.isDefined(object) && (object.isSelected || objects.length >= 1)) {
          $scope.bimObject = object;
          $scope.propertyIndicator.bimObjects = objects;
        } else {
          $scope.bimObject = undefined;
          $scope.propertyIndicator.bimObjects = undefined;
          $scope.statusDisplayData.info = {
            area: '',
            width: '',
            height: ''
          };
          applyData();
        }
      }

      function onTextSelected(data) {
        $scope.textBrush = {
          show: true,
          text: data.text,
          fontSize: data.fontSize,
          fontStyle: data.fontStyle,
          fontFamily: data.fontFamily,
          strokeColor: data.strokeColor,
          fillColor: data.fillColor,
          strokeWidth: data.strokeWidth
        };
        applyData();
      }

      function onTextDeselected() {
        $scope.textBrush = $scope.viewer3d.textBrush;
        applyData();
      }

      function onShowContextMenu(bimObject, objects, pos) {
        $scope.propertyIndicator.show = true;
        $scope.propertyIndicator.bimObjects = objects;
        $scope.propertyIndicator.pos = pos;
        $timeout(function () {
          $scope.$apply();
        });
      }

      function onBimObjectDblClicked(bimObject, objects, pos) {
        $scope.propertyIndicator.show = true;
        $scope.propertyIndicator.bimObjects = objects;
        $scope.propertyIndicator.pos = pos;
        $timeout(function () {
          $scope.$apply();
        });
      }

      function onThumbnailReady(thumbnail) {
        if ($scope.modelId) {
          apiFactory.update3dThumbnail({
            modelId: $scope.modelId,
            thumbnail: thumbnail
          }).then(function () {
            Notification.success("Model Thumbnail has updated!");
          })["catch"](function (err) {
            Notification.error("Model Thumbnail has failed!");
            $log.error(err);
          });
        }
      }

      function onToolActivated(type) {
        if ($scope.textBrush) {
          $scope.textBrush.show = type === 'text2d';
          applyData();
        }
      }

      function markerPlaced(is3d, markerPos) {
        if (!$scope.levelId || $scope.levelId === 'All') return;

        if (is3d) {
          if ($scope.viewer2d) {
            $scope.viewer2d.removeAllMarkers();
            var pos = $scope.viewer3d.get2dPos(markerPos, $scope.levelId);

            if (pos) {
              $scope.viewer2d.placeMarker(pos);
            }
          }
        } else {
          if ($scope.viewer3d) {
            $scope.viewer3d.removeAllMarkers();
            $scope.viewer3d.placeMarker(markerPos, $scope.levelId);
          }
        }
      }

      function markerRemoved(is3d) {
        if (is3d) {
          if ($scope.viewer2d) {
            $scope.viewer2d.removeAllMarkers();
          }
        } else {
          if ($scope.viewer3d) {
            $scope.viewer3d.removeAllMarkers();
            $scope.viewer3d.invalidate();
          }
        }
      }

      function applyData() {
        $timeout(function () {
          return $scope.$apply();
        });
      }

      function showPlanControlMark(bimPlan, position) {
        $scope.selectedBimPlan = bimPlan;
        var bimPlanControl = angular.element('#bim-plan-control');
        bimPlanControl.css('left', position.x + 'px');
        bimPlanControl.css('top', position.y + 'px');
        bimPlanControl.show();
      }

      function hidePlanControlMark() {
        $scope.selectedBimPlan = undefined;
        angular.element('#bim-plan-control').hide();
      }

      function refactorInventories(inventories) {
        inventories.forEach(function (inventory) {
          // if (inventory.section) {
          //   let section = $scope.sections.find(s => s._id === inventory.section);
          //   inventory.section = section ? section._id : undefined;
          // }
          if (inventory.materials) {
            inventory.materials.forEach(function (mat) {
              var material = $scope.materials.find(function (x) {
                return x._id === mat._id;
              });

              if (material) {
                mat.name = material.name;
                mat.color = material.color;
                mat.opacity = material.opacity;
              }
            });
          }

          if (inventory.dcps) {
            inventory.dcps.forEach(function (mat) {
              var material = $scope.comboMaterials.find(function (x) {
                return x._id === mat._id;
              });

              if (material) {
                mat.name = material.name;
                mat.color = material.color;
                mat.opacity = material.opacity;
                mat.comboMaterialList = material.comboMaterialList;
              }
            });
          }
        });
      }

      $scope.change3dModelLevel = function () {
        if (!$scope.tqData.marker.info3d.modelId || !$scope.viewer3d || !$scope.tqData.marker.info3d.level) {
          return;
        }

        if ($scope.tqData.marker.info3d.level === 'All' || $scope.tqData.marker.info3d.level === 'Others') {
          $scope.viewer3d.showAllObject();
        } else {
          var levelId = $scope.tqData.marker.info3d.level;

          if (levelId) {
            $scope.viewer3d.showObject(levelId);
            changePlan($scope.viewer3d.getBimModel(), levelId);
          } else {
            $scope.tqData.marker.info3d.level = 'All';
          }
        }

        if ($scope.tqData.marker.info3d.location && $scope.tqData.marker.info3d.location.x) {
          $scope.viewer3d.loadMarkers([$scope.tqData.marker.info3d.location]);
        } else {
          $scope.viewer3d.loadMarkers([]);
        }
      };

      $scope.changeVP = function () {
        if (!$scope.tqData.marker.info2d || !$scope.tqData.marker.info2d.modelId) {
          return;
        }

        angular.element("#initial_loading_popup").show();
        Promise.all([apiFactory.getRoofPlan($scope.tqData.marker.info2d.modelId), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getWorkLevelAndTypes(), apiFactory.getCalcSheet($scope.projectId)]).then(function (resp) {
          $scope.isLoadingDetail = false;
          $scope.vppages = [];
          angular.element("#initial_loading_popup").hide();
          var plan = resp[0].data.data;
          $scope.modelTitle = plan.assetObj.title;
          $scope.materials = resp[1].data.list || [];
          $scope.comboMaterials = resp[2].data.list || [];
          $scope.equipments = resp[3].data.list || [];
          $scope.comboEquipments = resp[4].data.list || [];

          if (resp[5].data.data) {
            if (resp[5].data.data.workLevels) {
              $scope.workLevels = resp[5].data.data.workLevels;
            }

            if (resp[5].data.data.workTypes) {
              $scope.workTypes = resp[5].data.data.workTypes;
            }
          }

          if (resp[6].data.data) {
            $scope.sections = resp[6].data.data.levels;
          }

          var markers = [];
          markers.push($scope.tqData.marker.info2d.location);
          $scope.vpCurPage = {
            plan: plan,
            planId: plan._id,
            title: plan.assetObj.title,
            workLevel: plan.assetObj.level,
            materials: $scope.materials,
            comboMaterials: $scope.comboMaterials,
            sections: $scope.sections,
            marker: markers
          };
          $scope.vppages.push($scope.vpCurPage);
        })["catch"](function (err) {
          $log.error(err);
          Notification.error("Cannot load vp data.");
          angular.element("#vp_initial_loading_popup").hide();
        });
      };

      $scope.updateVPPreview = function (model) {
        angular.element('#loading3d-container').removeClass('d-none');
        angular.element('#model3d-preview-container').hide();
        $scope.viewer3d.clear();
        $scope.viewer3d.loadBim(model).then(function () {
          angular.element('#loading3d-container').addClass('d-none');
          angular.element('#model3d-preview-container').show();
        })["catch"](function () {
          angular.element('#loading3d-container').addClass('d-none');
          angular.element('#model3d-preview-container').show();
          Notification.error('IFC file cannot open.');
        });
      };

      $scope.cleartqData = function () {
        localStorageService.set('tqData', {});
      };

      $scope.ActiveItemIndex = 0;

      $scope.getData = function (index) {
        if (index == $scope.ActiveItemIndex && $scope.tqs[$scope.ActiveItemIndex].expand == true) {
          $scope.tqs[$scope.ActiveItemIndex].expand = false;
          return;
        }

        $scope.tqs[$scope.ActiveItemIndex].expand = false;
        $scope.tqs[index].expand = true;
        $scope.ActiveItemIndex = index;
        $scope.isLoadingDetail = true;
        $scope.tqId = $scope.tqs[index]._id;
        apiFactory.getTqById($scope.tqId).then(function (res) {
          $scope.tqData = res.data.data;

          if ($scope.tqData.marker) {
            $scope.tqData.marker = $scope.tqData.marker.model;

            if ($scope.tqData.marker.info3d && $scope.tqData.marker.info3d.image && $scope.tqData.marker.info3d.image.secure_url) {
              $scope.tqData.image3DPath = $scope.tqData.marker.info3d.image.secure_url;
            }

            if ($scope.tqData.marker.info2d && $scope.tqData.marker.info2d.image && $scope.tqData.marker.info2d.image.secure_url) {
              $scope.tqData.image2DPath = $scope.tqData.marker.info2d.image.secure_url;
            }
          }

          if (!$scope.tqData) {
            Notification.error('Can not find the Technical Query.');
            $state.go('tqList');
            return;
          }

          if ($scope.tqData.marker.modelType == "vp") {
            $scope.isVP = true;
            $scope.tqData.marker.info2d = $scope.tqData.marker.info3d;
            delete $scope.tqData.marker.info3d;
          } else {
            $scope.isVP = false;
          }

          if ($scope.isVP) {
            $scope.changeVP();
          } else {
            $scope.change3dModel();
          } // $scope.assignedTo = $scope.issue.assignedTo.map(a => "<img src='"+a.profilePic+"' />").join(' ');
          //remakeTqActivities();


          apiFactory.getTqAttachList($scope.tqData._id).then(function (res) {
            $scope.tqData.attachList = res.data.list;
            $scope.tqData.attachList.map(function (it) {
              return it.imgSrc = utils.getTQFileIcon(utils.getExtensionByName(it.fileName));
            });
          })["catch"](function (error) {
            $scope.loading = false;
            $log.error(error);
          });
        })["catch"](function (error) {
          $scope.loading = false;
          $log.error(error);
        });
      };

      $scope.updateTq = function (index) {
        var id = $scope.tqs[index]._id;
        $scope.loading = true;
        var tqDataTmp = {
          progress: $scope.tqs[index].progress,
          status: $scope.tqs[index].status
        };
        apiFactory.updateTq(tqDataTmp, id).then(function (resp) {
          $scope.loading = false;
          Notification.success(resp.data.message);
        })["catch"](function (error) {
          $scope.loading = false;
          $log.error(error);
          if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to update tq");
        });
      };

      function changePlan(bimModel, levelId) {
        if (!bimModel || !levelId || !$scope.viewer2d) {
          return;
        }

        $scope.loading = true;
        angular.element('#loading2d-container').removeClass('d-none');
        angular.element('#model2d-container').hide();
        $scope.viewer2d.loadBimModel(bimModel, levelId).then(function () {
          $scope.loading = false;
          angular.element('#loading2d-container').addClass('d-none');
          angular.element('#model2d-container').show();

          if ($scope.tqData.marker.info2d && $scope.tqData.marker.info2d.location && $scope.tqData.marker.info2d.location.x) {
            $scope.viewer2d.loadMarkers([$scope.tqData.marker.info2d.location]);
          } else {
            $scope.viewer2d.loadMarkers([]);
          }
        })["catch"](function (e) {
          $scope.loading = false;
          $log.error(e);
          angular.element('#loading2d-container').addClass('d-none');
          angular.element('#model2d-container').show();
        });
      }

      $scope.getTqStatusClass = function (status) {
        switch (status) {
          case 'Draft':
            return {
              'draft': true
            };

          case 'Open':
            return {
              'open': true
            };

          case 'Closed':
            return {
              'closed': true
            };

          case 'Answered':
            return {
              'answered': true
            };

          default:
            return {
              'draft': true
            };
        }
      };

      $scope.setCurrentTab = function (value) {
        $scope.currentTab = value;
      };

      $scope.fileUpdated = function (files) {
        if (files && files.length) {
          $scope.files = $scope.files.concat(files);
          uploadAttach();
        }
      };

      function uploadAttach() {
        var _iterator = _createForOfIteratorHelper($scope.files),
            _step;

        try {
          var _loop = function _loop() {
            var file = _step.value;

            if (file.progressPercentage === 100) {
              return "continue";
            }

            var payload = void 0;

            if ($scope.tqData) {
              payload = {
                file: file,
                tqId: $scope.tqData._id,
                projectId: $scope.tqData.projectId
              };
            }

            file.upload = apiFactory.uploadTqAttach(payload).success(function (res) {
              file.progressPercentage = 100;
              res.data.imgSrc = utils.getTQFileIcon(utils.getExtensionByName(res.data.fileName));
              $scope.tqData.attachList.push(res.data);
              Notification.success(res.message);
            }).error(function (error) {
              file.progressPercentage = 0;
              $log.error(error);
              Notification.error(error);
            }).progress(function (event) {
              var progressPercentage = parseInt(100.0 * event.loaded / event.total);

              if (progressPercentage === 100) {
                file.progressPercentage = 99;
              } else {
                file.progressPercentage = progressPercentage;
              }
            });
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ret = _loop();

            if (_ret === "continue") continue;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      $scope.getStyleWidth = function (percentage) {
        return {
          'width': percentage + '%'
        };
      };

      $scope.cancelUpload = function (file, index) {
        if (file.upload && file.upload.abort) {
          file.upload.abort();
        }

        $scope.files.splice(index, 1);
      };

      $scope.deleteAttach = function (index, id) {
        apiFactory.deleteTqAttach(id).then(function (res) {
          $scope.tqData.attachList.splice(index, 1);
          Notification.success(res.data.message);
        })["catch"](function (e) {
          $log.error(e);
          Notification.error(e);
        });
      }; // $scope.currentQuery = 'supplier';
      // $scope.onSelectQuery = (query) => {
      //   $scope.currentQuery = query;
      // }

    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardSubscribersBlock", dashboardSubscribersBlock);

  function dashboardSubscribersBlock($log, apiFactory, globals) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-subscribers-block/dashboard-subscribers-block.view.html",
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc(scope) {
      var companyStore = globals.companyStore;
      scope.companyData = companyStore.get();
      scope.licenses = [{
        label: "All",
        value: "all"
      }, {
        label: "Demo",
        value: "demo"
      }, {
        label: "Basic",
        value: "basic"
      }, {
        label: "Enterprise",
        value: "enterprise"
      }, {
        label: "Professional",
        value: "professional"
      }];
      scope.statuses = [{
        label: "All",
        value: "all"
      }, {
        label: "Active",
        value: "active"
      }, {
        label: "In-Active",
        value: "inactive"
      }];
      scope.isCheckAll = false;
      scope.license = "all";
      scope.status = "all";
      scope.subscribers = [];
    }
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function () {
  angular.module("app").directive("dashboardSubmitOffer", dashboardSubmitOffer);

  function dashboardSubmitOffer($state, $log, apiFactory, globals, Notification, utils, $uibModal) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-submit-offer/dashboard-submit-offer.view.html",
      replace: true,
      scope: {
        cType: '=collaboratorType'
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      var userStore = globals.userStore,
          companyStore = globals.companyStore,
          projectStore = globals.projectStore;
      scope.userData = userStore.get();
      scope.companyData = companyStore.get();
      scope.projectData = projectStore.get();

      scope.goDashboard = function () {
        $state.go(globals.getDashboardRoute(scope.userData));
      };

      scope.utils = utils;
      scope.designationFilter = "Client,Supplier,Subcontractor,Manager,Admin";
      scope.statusFilter = "Accepted,On Hold,Pending,Not Received";
      scope.dateFilter = undefined;
      scope.vendorList = [];
      scope.vendorList2 = [];
      scope.collaborators = [];
      scope.TEAM_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(scope.userData);
      // if (scope.userData.designation == "Admin") {
      //   scope.TEAM_ACCESS_CREATE = 4;
      // } else {
      //   apiFactory.getAccessSettingDetails({
      //     dType,
      //     list: [Constants.AccessKey.TEAM]
      //   }).then(res => {
      //     scope.TEAM_ACCESS_CREATE = res.data.data[Constants.AccessKey.TEAM];
      //   })
      //     .catch((e) => {
      //       $log.error(e);
      //       Notification.error('Something went wrong try later')
      //     });
      // }

      scope.periods = [{
        id: '12',
        name: '12'
      }, {
        id: '24',
        name: '24'
      }, {
        id: '48',
        name: '48'
      }];
      scope.currentPage = 1;
      scope.totalCount = 0;
      scope.numPerPage = 12;
      scope.statusOptions = [{
        value: 'Not Received',
        label: 'Not Received'
      }, {
        value: 'Pending',
        label: 'Pending'
      }, {
        value: 'Declined',
        label: 'Declined'
      }, {
        value: 'On Hold',
        label: 'On-Hold'
      }, {
        value: 'Accepted',
        label: 'Accepted'
      }];
      scope.offers = [];

      scope.searchOffers = function () {
        scope.currentPage = 1;
        scope.getOffers();
      };

      scope.selectNumPage = function (new_num) {
        scope.numPerPage = new_num;
        scope.getOffers();
      };

      scope.getOffers = function () {
        scope.isLoading = true;
        apiFactory.getCollaborationOffers({
          page: scope.currentPage,
          chunk: scope.numPerPage,
          search: scope.searchText,
          projectId: scope.projectData._id,
          designationFilter: scope.designationFilter,
          dateFilter: scope.dateFilter
        }).then(function (res) {
          scope.isLoading = false;
          scope.offers = res.data.list;
          scope.totalCount = res.data.total;
          scope.noOfPages = Math.ceil(scope.totalCount / scope.numPerPage);
          scope.makedata();
        })["catch"](function (err) {
          scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.getOffers();

      scope.updateStatus = function (offer, status) {
        scope.isLoading = true;
        apiFactory.updateCollaborationOfferStatus({
          id: offer._id,
          status: status
        }).then(function (res) {
          scope.isLoading = false;
          offer.status = status;
          Notification.success(res.data.message);
        })["catch"](function (err) {
          scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.saveOfferSubmit = function (offer) {
        scope.loading = true;
        apiFactory.updateCollaborationOffer(offer).then(function () {
          scope.loading = false;
          Notification.success('changed successfully');
        })["catch"](function (err) {
          scope.loading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.uploadOffer = function () {
        $uibModal.open({
          animation: true,
          component: 'uploadOfferModal',
          windowClass: 'upload-offer-modal'
        }).result.then(function () {
          scope.getOffers();
        }, function () {});
      };

      scope.selectAllOffers = function () {
        scope.offers.forEach(function (x) {
          x.selected = scope.selectedAll;
        });
      };

      scope.selectOffer = function (offer) {
        if (!offer.selected) {
          scope.selectedAll = false;
        }

        if (scope.offers.map(function (x) {
          return x.selected ? 1 : 0;
        }).reduce(function (acc, val) {
          return acc + val;
        }, 0) === scope.offers.length) {
          scope.selectedAll = true;
        }
      };

      scope.$on('filter_by_designation', function (event, data) {
        scope.designationFilter = data.filter(function (x) {
          return x.selected;
        }).map(function (x) {
          return x.value;
        }).join(",");
        scope.getOffers();
      });
      scope.$on('filter_by_status', function (event, data) {
        scope.statusFilter = data.filter(function (x) {
          return x.selected;
        }).map(function (x) {
          return x.value;
        }).join(",");
        scope.getOffers();
      });
      scope.$on("filter_by_date", function (event, data) {
        scope.dateFilter = data;
        scope.getOffers();
      });

      scope.makedata = function () {
        var source = scope.offers;
        $log.log(source);
        var bidObj = [];
        var bidlist = [];

        for (var i = 0; i < source.length; i++) {
          if (!bidlist.includes(source[i].bidPackageId._id)) {
            bidlist.push(source[i].bidPackageId._id);
            bidObj.push({
              offers: [],
              title: source[i].bidPackageId.title,
              bId: source[i].bidPackageId._id,
              systag: source[i].bidPackageId.sysTag
            });
          }
        }

        for (var _i = 0; _i < bidObj.length; _i++) {
          for (var j = 0; j < source.length; j++) {
            if (bidObj[_i].bId == source[j].bidPackageId._id) {
              var offer = source[j];

              if (offer.revision < offer.templateId.revision) {
                offer.levels = offer.templateId.levels;
                offer.revision = offer.templateId.revision;
              }

              bidObj[_i].offers.push(source[j]);
            }
          }
        }

        scope.bidPackages = bidObj;
        scope.bidPackages.forEach(function (bid) {
          bid.offers.forEach(function (offer) {
            offer.selectedGroup = {
              name: "All",
              levels: []
            };

            if (offer.groups) {
              offer.groups.forEach(function (group) {
                offer.selectedGroup.levels = offer.selectedGroup.levels.concat(group.levels);
              });
            }

            $log.log('selected group = ', offer.selectedGroup);
          });
        });
        scope.$apply();
      };

      scope.fetchSuppliers = function () {
        scope.isLoading = true;
        apiFactory.getAllSuppliers({}).then(function (res) {
          scope.isLoading = false;
          scope.vendorList = res.data.list;
        })["catch"](function (err) {
          $log.error(err);
          scope.isLoading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.fetchSuppliers(); // calc offer

      scope.calcOfferDays = function (offer) {
        var days = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            days += parseInt(lv.days);
          });
        });
        return days;
      };

      scope.calcOfferQuantity = function (offer) {
        var cnt = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            cnt += parseFloat(lv.quantity);
          });
        });
        return cnt;
      };

      scope.calcOfferUnitPrice = function (offer) {
        var cnt = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            cnt += parseFloat(lv.quantity);
          });
        });
        var cnt1 = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            cnt1 += parseFloat(lv.amount);
          });
        });
        if (cnt1 == 0) return 0;
        return cnt1 / cnt;
      };

      scope.calcOfferAmount = function (offer) {
        var cnt = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            cnt += parseFloat(lv.amount);
          });
        });
        return cnt;
      };

      scope.calcLevelAmount = function (lv) {
        lv.amount = lv.quantity * lv.unitPrice;
      }; // calc bid


      scope.calcBest = function (bid) {
        var mun = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == 'Accepted') {
            mun++;
          }
        });
        return mun;
      };

      scope.getSysTag = function (bid) {
        $log.log(bid);
      };

      scope.getCollaborator = function (bid) {
        var mun = "";
        var cnt = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == 'Accepted') {
            $log.log(offer);
            if (offer.supplierId && cnt == 0) mun += offer.supplierId.name;else if (offer.subcontractorId && cnt == 0) mun += offer.subcontractorId.name;
            cnt++;
          }
        });
        if (cnt <= 2) return mun;else return mun + " +" + (cnt - 1);
      };

      scope.getBidStaffs = function (bid) {
        var mun = "";
        var cnt = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            if (cnt == 0 && offer.staffId) mun += offer.staffId.displayName;
            cnt++;
          }
        });
        if (cnt <= 2) return mun;else return mun + " +" + (cnt - 1);
      };

      scope.calcBidLevels = function (bid) {
        var value = 0;
        bid.offers.forEach(function (offer) {
          offer.groups.forEach(function (group) {
            value = group.levels.length;
          });
        });
        return value;
      };

      scope.calcBidDays = function (bid) {
        var average = 0;
        var cnt = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            cnt++;
            offer.groups.forEach(function (group) {
              group.levels.forEach(function (lv) {
                average += parseInt(lv.days);
              });
            });
          }
        });
        if (average == 0) return 0;
        return average / cnt;
      };

      scope.calcBidQuantity = function (bid) {
        var sum = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            offer.groups.forEach(function (group) {
              group.levels.forEach(function (lv) {
                sum += parseInt(lv.quantity);
              });
            });
          }
        });
        return sum;
      };

      scope.calcBidUnitPrice = function (bid) {
        var cnt = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            offer.groups.forEach(function (group) {
              group.levels.forEach(function (lv) {
                cnt += parseInt(lv.quantity);
              });
            });
          }
        });
        var cnt1 = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            offer.groups.forEach(function (group) {
              group.levels.forEach(function (lv) {
                cnt1 += parseInt(lv.amount);
              });
            });
          }
        });
        if (cnt1 == 0 || cnt == 0) return 0;
        return cnt1 / cnt;
      };

      scope.calcBidOfferAmount = function (bid) {
        var sum = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            offer.groups.forEach(function (group) {
              group.levels.forEach(function (lv) {
                sum += parseInt(lv.amount);
              });
            });
          }
        });
        return sum;
      };

      scope.calcGroupQuantity = function (group) {
        var sum = 0;
        group.levels.forEach(function (lv) {
          sum += parseInt(lv.quantity);
        });
        return sum;
      };

      scope.calcGroupDays = function (group) {
        var total = 0;
        group.levels.forEach(function (lv) {
          total += parseInt(lv.days);
        });
        return total;
      };

      scope.calcGroupOfferAmount = function (group) {
        var sum = 0;
        group.levels.forEach(function (lv) {
          sum += parseInt(lv.amount);
        });
        return sum;
      };

      scope.getBidStatus = function (bid) {
        var flag1 = 0,
            flag2 = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == 'Accepted') flag1 = 1;
          if (offer.status == 'Decliended') flag2 = 1;
        });
        if (flag1) return 'Accepted';else if (flag2) return 'Decliended';else return 'Paused';
      };

      scope.getStaff = function (id) {
        var staff = null;
        scope.vendorList.forEach(function (v) {
          v.staffs.forEach(function (s) {
            if (s._id == id) staff = s;
          });
        });
        if (staff) return staff;
        scope.subcontactors.forEach(function (v) {
          v.staffs.forEach(function (s) {
            if (s._id == id) staff = s;
          });
        }); // if(staff)

        return staff;
      };

      scope.attachExcelFiles = function (offer) {
        angular.element('#fileSelector').triggerHandler('click');
        scope.currentOffer = offer;
      };

      scope.SelectFile = function (file) {
        scope.SelectedFile = file;
        scope.Upload(scope.currentOffer);
      };

      scope.Upload = function (tempoffer) {
        $log.log(11111);
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;

        if (regex.test(scope.SelectedFile.name.toLowerCase())) {
          if (angular.isDefined(typeof FileReader === "undefined" ? "undefined" : _typeof(FileReader))) {
            var reader = new FileReader(); //For Browsers other than IE.

            if (reader.readAsBinaryString) {
              reader.onload = function (e) {
                scope.ProcessExcel(e.target.result, tempoffer);
              };

              reader.readAsBinaryString(scope.SelectedFile);
            } else {
              //For IE Browser.
              reader.onload = function (e) {
                var data = "";
                var bytes = new Uint8Array(e.target.result);

                for (var i = 0; i < bytes.byteLength; i++) {
                  data += String.fromCharCode(bytes[i]);
                }

                scope.ProcessExcel(data, tempoffer);
              };

              reader.readAsArrayBuffer(scope.SelectedFile);
            }
          } else {
            Notification.error("This browser does not support HTML5.");
          }
        } else {
          Notification.error("Please upload a valid Excel file.");
        }
      };

      scope.ProcessExcel = function (data, tempOffer) {
        //Read the Excel File data.
        var workbook = XLSX.read(data, {
          type: 'binary'
        }); //Fetch the name of First Sheet.

        var firstSheet = workbook.SheetNames[0]; //Read all rows from First Sheet into an JSON array.

        var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
        $log.log(excelRows); //Display the data from Excel file in Table.

        scope.$apply(function () {
          if (excelRows.length != tempOffer.selectedGroup.levels.length) {
            Notification.error("Uploaded successfully, but the excel data has different column or row count.");
          } else {
            tempOffer.selectedGroup.levels.forEach(function (lv, index) {
              lv.days = excelRows[index].Days;
              lv.quantity = excelRows[index].Quantity;
              lv.unitPrice = excelRows[index].UnitPrice;
              lv.amount = excelRows[index].Amount;
            });
          }
        });
      };

      scope.selectGroup = function (offer, group) {
        if (group) {
          offer.selectedGroup = group;
        } else {
          offer.selectedGroup = {
            name: "All",
            levels: []
          };
          offer.groups.forEach(function (group) {
            offer.selectedGroup.levels = offer.selectedGroup.levels.concat(group.levels);
          });
        }
      };

      scope.getOfferStatusClass = function (status) {
        switch (status) {
          case 'Pending':
            return {
              'on-hold': true
            };

          case 'Not Received':
            return {
              'Not Received': true
            };

          case 'Accepted':
            return {
              'Accepted': true
            };

          case 'Declined':
            return {
              'Declined': true
            };

          case 'Paused':
            return {
              'Paused': true
            };

          default:
            return {
              'on-hold': true
            };
        }
      };
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardSiteManage", dashboardSiteManage);

  function dashboardSiteManage(NgMap, apiFactory, globals, $log, Bim, $document, utils, Notification, $state) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-site-manage/dashboard-site-manage.view.html",
      replace: true,
      scope: {
        type: '='
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      var project = globals.projectStore.get();

      if (!project || project.id === 'all') {
        return;
      }

      scope.isGIS = true;
      scope.viewer3d = Bim.markingViewer($document[0].getElementById('model-viewer'));
      scope.viewer3d.initialize();
      scope.sideMenu = 'Issue';
      scope.gmap = {
        url: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&libraries=places',
        markers: [],
        styles: [],
        center: [0, 0],
        zoom: 18
      };
      NgMap.getMap('service_map').then(function (map) {
        if (project.address && project.address.loc && project.address.loc.coordinates.length === 2) {
          scope.gmap.center = project.address.loc.coordinates;
        }

        map.setOptions({
          styles: scope.gmap.styles,
          // disableDefaultUI: true,
          mapTypeControl: true,
          mapTypeId: 'satellite',
          zoomControl: true,
          zoom: scope.gmap.zoom,
          center: scope.gmap.center
        });
      })["catch"](function (err) {
        $log.error(err);
      });

      function showLoading() {
        angular.element('#loading').css('display', 'flex');
      }

      function hideLoading() {
        angular.element('#loading').hide();
      }

      function loadIssuesByModel(model) {
        apiFactory.getIssuesBy3DModelId(model._id).then(function (res) {
          model.issues = res.data.list;

          if (!utils.isEmpty(model.issues)) {
            model.issues.forEach(function (issue) {
              issue.location = issue.marker.model.info3d.location;
              issue.location.status = issue.status;
              issue.location.hasMessages = issue.hasMessages;
              issue.location.issue = issue;
            });
            var locations = model.issues.map(function (x) {
              return x.location;
            });
            scope.viewer3d.loadMarkers(locations);
          }
        })["catch"](function (err) {
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }

      function loadRegistrationsByModel(model) {
        apiFactory.getRegistrationsByModelId(model._id).then(function (res) {
          model.registrations = res.data.list;

          if (!utils.isEmpty(model.registrations)) {
            model.registrations.forEach(function (registration) {
              registration.location = registration.marker.model.info3d.location;
              registration.location.status = 'Open';
              registration.location.hasMessages = true;
              registration.location.issue = registration;
            });
            var locations = model.registrations.map(function (x) {
              return x.location;
            });
            scope.viewer3d.loadMarkers(locations);
          }
        })["catch"](function (err) {
          $log.error(err); // Notification.error(utils.getErrorMessage(err));
        });
      }

      function loadModel(model) {
        scope.selectedModel = model;
        scope.viewer3d.clear();
        showLoading();
        scope.viewer3d.loadBim(model).then(function () {
          hideLoading();

          if (scope.sideMenu === 'Issue') {
            loadIssuesByModel(model);
          } else {
            loadRegistrationsByModel(model);
          }
        })["catch"](function (err) {
          hideLoading();
          $log.error(err);
        });
      }

      scope.changeModel = function (model) {
        scope.toggleIssuesSideMenu(false);
        scope.toggleRegistrationsSideMenu(false);
        scope.isGIS = false;
        loadModel(model);
      };

      scope.zoomLevel = 100;

      scope.zoomSlider = function (value) {
        scope.viewer3d.setZoom(value / 100);
      };

      function toggleSideMenu(elementId, open) {
        var menu = angular.element(elementId);
        var isOpen = menu.hasClass('open');

        if (!isOpen && open) {
          menu.addClass('open');
        }

        if (isOpen && !open) {
          menu.removeClass('open');
        }
      }

      scope.toggleIssuesSideMenu = function (open) {
        toggleSideMenu('#side-menu-registrations', false);
        toggleSideMenu('#side-menu-issues', open);
      };

      scope.toggleRegistrationsSideMenu = function (open) {
        toggleSideMenu('#side-menu-issues', false);
        toggleSideMenu('#side-menu-registrations', open);
      };

      scope.changeSideMenu = function (value) {
        scope.sideMenu = value;

        if (scope.isGIS) {
          scope.changeToGIS();
        } else {
          scope.changeModel(scope.selectedModel);
        }
      };

      scope.changeToGIS = function () {
        scope.toggleIssuesSideMenu(false);
        scope.toggleRegistrationsSideMenu(false);
        scope.selectedModel = undefined;
        scope.isGIS = true;
      };

      scope.gotoDetail = function (event) {
        var lat = event.latLng.lat();
        var lng = event.latLng.lng();
        var marker = scope.gmap.markers.find(function (x) {
          return x.coordinates[0] === lat && x.coordinates[1] === lng;
        });

        if (marker) {
          $state.go('bimDetail', {
            id: marker.model._id
          });
        }
      };
    }
  }
})();


"use strict";

/* eslint-disable no-unused-vars */
(function () {
  angular.module("app").directive("dashboardSideMenu", dashboardSideMenu);

  function dashboardSideMenu($state, $log, apiFactory, globals, localStorageService, Notification) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-side-menu/dashboard-side-menu.view.html",
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc(scope) {
      var userStore = globals.userStore,
          projectStore = globals.projectStore;
      var userData = userStore.get();
      var projectData = projectStore.get();
      scope.VP_ACCESS_CREATE = 0;
      scope.FMANAGER_ACCESS_CREATE = 0;
      scope.CPLAN_ACCESS_CREATE = 0;
      scope.ISSUE_ACCESS_CREATE = 0;
      scope.REPORT_ACCESS_CREATE = 0;
      scope.TQ_ACCESS_CREATE = 0;
      scope.DVIEWER_ACCESS_CREATE = 0;
      var dType = globals.getDashboardType(userData); // if (userData.designation === "Admin") {
      //   scope.VP_ACCESS_CREATE = 4;
      //   scope.FMANAGER_ACCESS_CREATE = 4;
      //   scope.CPLAN_ACCESS_CREATE = 4;
      //   scope.ISSUE_ACCESS_CREATE = 4;
      //   scope.REPORT_ACCESS_CREATE = 4;
      //   scope.TQ_ACCESS_CREATE = 4;
      //   scope.DVIEWER_ACCESS_CREATE = 4;
      // } else {
      //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.VP, Constants.AccessKey.FMANAGER, Constants.AccessKey.CPLAN, Constants.AccessKey.ISSUE, Constants.AccessKey.REPORT, Constants.AccessKey.DVIEWER]})
      //     .then(res => {
      //       scope.VP_ACCESS_CREATE = res.data.data[Constants.AccessKey.VP];
      //       scope.FMANAGER_ACCESS_CREATE = res.data.data[Constants.AccessKey.FMANAGER];
      //       scope.CPLAN_ACCESS_CREATE = res.data.data[Constants.AccessKey.CPLAN];
      //       scope.ISSUE_ACCESS_CREATE = res.data.data[Constants.AccessKey.ISSUE];
      //       scope.REPORT_ACCESS_CREATE = res.data.data[Constants.AccessKey.REPORT];
      //       scope.TQ_ACCESS_CREATE = res.data.data[Constants.AccessKey.TQ];
      //       scope.DVIEWER_ACCESS_CREATE = res.data.data[Constants.AccessKey.DVIEWER];
      //     })
      //     .catch((e) => {
      //       $log.error(e);
      //       Notification.error('Something went wrong try later')
      //     });
      // }

      scope.gotoPage = function (page, permission, flag) {
        permission = true;

        if (!permission) {
          Notification.error('Permission denied');
          return;
        }

        if (projectData && projectData._id !== 'all' || flag) {
          if (page === 'createIssue') {
            localStorageService.set('issueData', {});
          } else if (page === 'createReports') {
            localStorageService.set('reportData', {});
          }

          $state.go(page);
        } else {
          Notification.error('Please select project first.');
        }
      };
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardQualityBlock", dashboardQualityBlock);

  function dashboardQualityBlock() {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-quality-block/dashboard-quality-block.view.html",
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.items = [{
        name: "No Risk",
        percent: 0.25,
        color: "#28cd41"
      }, {
        name: "Moderate Risk",
        percent: 0.5,
        color: "#ffbc25"
      }, {
        name: "High Risk",
        percent: 0.25,
        color: "#ff464f"
      }];
      scope.status = "none";

      scope.getProgressStyle = function (item) {
        return {
          'stroke-dashoffset': 188 * (1 - item.percent),
          stroke: item.color
        };
      };
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardQsheManage", dashboardQsheManage);

  function dashboardQsheManage(apiFactory, globals, $log, VP, Notification, utils, $timeout) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-qshe-manage/dashboard-qshe-manage.view.html",
      replace: true,
      scope: {
        type: '='
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      var projectStore = globals.projectStore;
      var project = projectStore.get();

      if (!project || project.id === 'all') {
        return;
      }

      scope.viewer = VP.markingViewer(angular.element('#vp-viewer')[0]);
      scope.viewer.on('marker:click', onMakerClicked);
      scope.viewer.on('scroll:changed', closeIssueDetailView);
      scope.issue = undefined;
      scope.sbPos = {
        x: -1000,
        y: -1000
      };
      scope.levels = [];
      scope.zoomLevel = 100;

      scope.changePlan = function (plan) {
        scope.toggleIssuesSideMenu(false);
        scope.toggleRegistrationsSideMenu(false);
        loadPlan(plan);
      };

      scope.zoomSlider = function (value) {
        scope.sbPos = {
          x: -1000,
          y: -1000
        };
        $timeout(function () {
          scope.$apply();
        });
        scope.viewer.setZoom(value / 100);
      };

      scope.toggleIssuesSideMenu = function (open) {
        toggleSideMenu('#side-menu-registrations', false);
        toggleSideMenu('#side-menu-issues', open);
      };

      scope.toggleRegistrationsSideMenu = function (open) {
        toggleSideMenu('#side-menu-issues', false);
        toggleSideMenu('#side-menu-registrations', open);
      };

      scope.closeIssueDetailView = function () {
        closeIssueDetailView();
      };

      scope.getIssueDetailViewStyle = function () {
        return {
          'left': scope.sbPos.x + 'px',
          'top': scope.sbPos.y + 'px'
        };
      };

      scope.changeSideMenu = function (value) {
        scope.sideMenu = value;
        scope.changePlan(scope.selectedPlan);
      };

      function initData() {
        scope.sideMenu = 'Issue';
        loadPlans();
      }

      initData();

      function toggleSideMenu(elementId, open) {
        var menu = angular.element(elementId);
        var isOpen = menu.hasClass('open');

        if (!isOpen && open) {
          menu.addClass('open');
        }

        if (isOpen && !open) {
          menu.removeClass('open');
        }
      }

      function onMakerClicked(param) {
        scope.isOpenIssueDetailView = true;
        scope.sbPos = param.pos;
        scope.issue = param.marker.issue;
        $timeout(function () {
          scope.$apply();
        });
      }

      function closeIssueDetailView() {
        scope.sbPos = {
          x: -1000,
          y: -1000
        };
        $timeout(function () {
          scope.$apply();
        });
      }

      function showLoading() {
        angular.element('#loading').css('display', 'flex');
      }

      function hideLoading() {
        angular.element('#loading').hide();
      }

      function loadPlan(plan) {
        showLoading();
        scope.selectedPlan = plan;
        var apis = [scope.viewer.loadPlan(plan)];

        if (scope.sideMenu === 'Issue') {
          apis.push(loadIssuesByPlan(plan));
        } else {
          apis.push(loadRegistrationsByPlan(plan));
        }

        Promise.all(apis).then(function (resp) {
          hideLoading();
          var locations = resp[1].locations;

          if (!utils.isEmpty(locations)) {
            scope.viewer.loadMarkers(locations);
          }

          $timeout(function () {
            return scope.$apply();
          });
        })["catch"](function (err) {
          hideLoading();
          $log.error(err);
        });
      }

      function loadIssuesByPlan(plan) {
        return new Promise(function (resolve, reject) {
          apiFactory.getIssuesBy3DModelId(plan._id).then(function (res) {
            plan.issues = res.data.list;
            var locations = [];

            if (!utils.isEmpty(plan.issues)) {
              plan.issues.forEach(function (issue) {
                issue.location = issue.marker.model.info3d.location;
                issue.location.status = issue.status;
                issue.location.hasMessages = issue.hasMessages;
                issue.location.issue = issue;
              });
              locations = plan.issues.map(function (x) {
                return x.location;
              });
            }

            resolve({
              locations: locations
            });
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
            reject(err);
          });
        });
      }

      function loadRegistrationsByPlan(plan) {
        return new Promise(function (resolve, reject) {
          apiFactory.getRegistrationsByModelId(plan._id).then(function (res) {
            plan.registrations = res.data.list;
            var locations = [];

            if (!utils.isEmpty(plan.registrations)) {
              plan.registrations.forEach(function (registration) {
                registration.location = registration.marker.model.info3d.location;
                registration.location.status = 'Open';
                registration.location.hasMessages = true;
                registration.location.issue = registration;
              });
              locations = plan.registrations.map(function (x) {
                return x.location;
              });
            }

            resolve({
              locations: locations
            });
          })["catch"](function (err) {
            $log.error(err); // Notification.error(utils.getErrorMessage(err));

            reject(err);
          });
        });
      }

      function loadPlans() {
        showLoading();
        apiFactory.getProjectRoofPlans(project._id).then(function (resp) {
          hideLoading();
          var plans = resp.data.data || []; // scope.plans = plans.filter(function (value, index, self) {
          //   return self.findIndex(x => x.assetObj.level === value.assetObj.level) === index;
          // });

          plans = plans.filter(function (x) {
            return x.parentAsset && angular.isDefined(x.assetObj.level);
          });
          scope.plans = plans;
          scope.plans.sort(function (a, b) {
            return a.assetObj.level - b.assetObj.level;
          });
          var levelMap = {};
          plans.forEach(function (plan) {
            var level = levelMap[plan.assetObj.level];

            if (!level) {
              level = {
                name: plan.assetObj.level,
                plans: []
              };
              levelMap[plan.assetObj.level] = level;
            }

            level.plans.push(plan);
          });
          scope.levels = [];

          for (var key in levelMap) {
            if (levelMap[key]) {
              scope.levels.push(levelMap[key]);
            }
          }

          loadPlan(scope.plans[0]);
        })["catch"](function (e) {
          hideLoading();
          $log.error(e);
        });
      }
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module("app").directive("dashboardProjectTimeline", dashboardProjectTimeline);

  function dashboardProjectTimeline(apiFactory, utils, $log, $state, Notification, $timeout, storageFactory) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-project-timeline/dashboard-project-timeline.view.html",
      replace: true,
      link: function link($scope) {
        var vm = this;
        vm.isAllProject = !vm.project || vm.project._id === 'all';
        $scope.projects = [];
        vm.workers = [];
        vm.subContractors = [];
        $scope.deadline = vm.isAllProject ? undefined : new Date(vm.project.endDate);
        $scope.ganttData = {
          data: [],
          links: []
        };
        $scope.resourceData = [];
        $scope.isLoading = false; // color style for timeline

        $scope.styles = {};
        var styleIndex = 0;
        var FETCH_WORKPATTERNS_COUNT = 5;
        vm.timelineWorkPatterns = [];

        if (!vm.isAllProject) {
          vm.startline = new Date(vm.project.startDate);
          vm.startline.setHours(0, 0, 0, 0);
          vm.deadline = new Date(vm.project.endDate);
          vm.deadline.setHours(23, 59, 59, 999);
        }

        $scope.getWorkerCount = function (gantt, start, end) {
          var workerCount = 0;
          var requiredCount = 0;
          var startValue = start.getTime();
          var endValue = end.getTime();
          var gap = (endValue - startValue) / 3600000;
          var isWeekend = gap <= 24 && (start.getDay() === 6 || start.getDay() === 0) && (end.getDay() === 6 || end.getDay() === 0 || end.getDay() === 1);

          if (!isWeekend) {
            var resources = [];
            gantt.eachTask(function (task) {
              if (task.type !== gantt.config.types.project && task.start_date && task.end_date) {
                if (endValue >= task.start_date.getTime() && startValue <= task.end_date.getTime()) {
                  if (task.resources) {
                    task.resources.forEach(function (resource) {
                      if (resources.findIndex(function (x) {
                        return x.id === resource.id;
                      }) === -1) {
                        resources.push(resource);
                      }
                    });
                  }

                  requiredCount += task.requiredWorkerCount ? task.requiredWorkerCount : 0;
                }
              }
            });
            resources.forEach(function (resource) {
              if (getWorkableHours(resource, start, end) > 0) {
                workerCount++;
              }
            });
          }

          return {
            working: workerCount,
            required: requiredCount
          };
        };

        $scope.getTotalCount = function (type) {
          var count = 0;

          if (type === 'R') {
            gantt.eachTask(function (task) {
              if (task.type === gantt.config.types.task) {
                var need = utils.num(task.requiredWorkerCount);
                count = Math.max(need, count);
              }
            });
          } else {
            count = $scope.resourceData && $scope.resourceData.length ? $scope.resourceData.length - 2 : 0;
          }

          return count;
        };

        $scope.gotoTimeline = function () {
          if (!vm.project || vm.project._id !== 'all' && vm.project.projectStatus !== 1 && vm.project.projectStatus !== 6) {
            Notification.error('Only ON GOING or PRECAST project can see timeline.');
            return;
          }

          $state.go('timeline');
        }; // loading


        function initData() {
          $scope.isLoading = true;
          var apis = [apiFactory.getAllEmployees({
            isActive: true
          }), apiFactory.getAllSubcontractors(), apiFactory.listAllHolidays()];

          if (!vm.isAllProject) {
            apis.push(apiFactory.fetchTimelineWorkPatterns({
              projectId: vm.project._id,
              fetchCount: FETCH_WORKPATTERNS_COUNT
            }));
          }

          Promise.all(apis).then(function (resp) {
            // load workers
            var workers = resp[0].data.list || [];
            vm.workers = [];
            workers.forEach(function (element) {
              element.name = element.displayName;
              element.type = 'worker';
              vm.workers.push(element);
            });
            vm.subContractors = resp[1].data.list || [];
            vm.subContractors.forEach(function (x) {
              return x.type = 'subcontractor';
            });
            vm.holidays = resp[2].data.list;

            if (vm.project) {
              vm.availableHours = getWorkHours(vm.startline, vm.deadline);

              if (vm.availableHours === 0) {
                vm.availableHours = 8;
              } // if (!utils.isEmpty(vm.holidays)) {
              //   vm.holidays.forEach(holiday => {
              //     if (isHolidayInProject(holiday)) {
              //       vm.availableHours -= getWorkHours(holiday.startDate, holiday.endDate);
              //     }
              //   });
              // }

            } else {
              vm.availableHours = 0;
            }

            if (angular.isDefined(resp[3])) {
              vm.timelineWorkPatterns = resp[3].data.list;
            } // load timeline


            if (vm.isAllProject) {
              vm.timeline = undefined; // all project

              storageFactory.getBookmarks().then(function (resp) {
                $scope.projects = resp.data.bookmarks;
                loadTimelineWithAllProject();
                $scope.isLoading = false;
              })["catch"](function (err) {
                $log.error(err);
                Notification.error('Cannot load timeline data from the server.');
                $scope.isLoading = false;
              });
            } else {
              apiFactory.getTimeline(vm.project._id).then(function (resp) {
                $scope.isLoading = false;
                vm.timeline = resp.data.data;

                if (angular.isDefined(vm.project.buildingType)) {
                  $scope.isLoading = true;
                  apiFactory.getWorkPatternById(vm.project.buildingType._id ? vm.project.buildingType._id : vm.project.buildingType).then(function (res) {
                    $scope.isLoading = false;
                    var workPattern = res.data.data;

                    if (!utils.isEmpty(workPattern)) {
                      vm.sortMap = {};
                      workPattern.items.forEach(function (item, index) {
                        vm.sortMap[item.tagName] = index;
                      });
                      vm.workPattern = workPattern;
                    }

                    loadTimelineWithCalc();
                  })["catch"](function (err) {
                    $log.error(err);
                    $scope.isLoading = false;
                    loadTimelineWithCalc();
                  });
                } else {
                  loadTimelineWithCalc();
                }
              })["catch"](function (err) {
                $scope.isLoading = false;
                $log.error(err);
                Notification.error('Cannot load timeline data from the server.');
              });
            }
          })["catch"](function (err) {
            $log.error(err);
            $scope.isLoading = false;
          });
        }

        initData();

        function loadTimelineWithAllProject() {
          if ($scope.projects.length == 0) return;
          var items = [];
          var today = new Date();
          var tomorrow = new Date();
          tomorrow.setDate(today.getDate() + 1);
          var resources = {};

          for (var i = 0; i < $scope.projects.length; i++) {
            var project = $scope.projects[i];
            var startDate = project.startDate ? new Date(project.startDate) : new Date(today);
            var endDate = project.endDate ? new Date(project.endDate) : new Date(tomorrow);
            var item = {
              id: project._id,
              text: project.projectName,
              start_date: startDate,
              end_date: endDate,
              type: gantt.config.types.task,
              progress: 0,
              project: true,
              calcHours: 0,
              resources: [],
              resourceIds: []
            };

            if (project.timeline) {
              if (project.timeline.resources) {
                for (var j = 0; j < project.timeline.resources.length; j++) {
                  var resource = project.timeline.resources[j];
                  item.resourceIds.push(resource.id);

                  if (!resources[resource.id]) {
                    resources[resource.id] = resource;
                  }
                }

                item.resources = project.timeline.resources;
              }

              item.progress = utils.num(project.progress);
            }

            if (project.calcSheet && project.calcSheet.totalWorkHours) {
              item.calcHours = project.calcSheet.totalWorkHours;
            }

            var workHours = utils.getWorkingHours(item.start_date, item.end_date);
            item.requiredWorkerCount = workHours === 0 ? 1 : Math.max(1, Math.ceil(item.calcHours / workHours));
            items.push(item);
          }

          var resourceData = [];
          var workerCount = 0;
          var subcontractorCount = 0;

          for (var id in resources) {
            var _resource = resources[id];

            if (_resource) {
              resourceData.push({
                id: _resource.id,
                text: _resource.name,
                avatar: _resource.avatar,
                parent: _resource.type
              });

              if (_resource.type === 1) {
                workerCount++;
              } else {
                subcontractorCount++;
              }
            }
          }

          resourceData.unshift({
            id: 2,
            text: "Sub Contractors (".concat(subcontractorCount, ")"),
            type: gantt.config.types.project
          });
          resourceData.unshift({
            id: 1,
            text: "Workers (".concat(workerCount, ")"),
            type: gantt.config.types.project
          });
          $scope.ganttData = {
            data: items,
            links: []
          };
          $scope.resourceData = resourceData;
          $timeout(function () {
            gantt.showDate(new Date());
          }, 300);
        }

        function loadTimelineWithCalc(reload) {
          var groups = vm.timeline.groups;
          var tasks = vm.timeline.tasks;
          var timeline = {
            gantt: {
              data: [],
              links: []
            },
            resources: {
              workers: {},
              subcontractors: {}
            },
            groups: {
              workType: {},
              workLevel: {}
            }
          };
          $scope.styles = {};
          styleIndex = 0;
          vm.csTasks = [];
          var totalWorkHours = 0;

          if (groups) {
            groups.forEach(function (group) {
              loadGroup(group, timeline);
            });
          }

          if (tasks) {
            tasks.forEach(function (task) {
              var csTask = loadCalcTask(task);

              if (csTask) {
                vm.csTasks.push(csTask);
                totalWorkHours += csTask.workHours;
              }
            });
            var deltaHour = totalWorkHours === 0 ? 1 : vm.availableHours / totalWorkHours;
            vm.csTasks.forEach(function (csTask) {
              csTask.workHours *= deltaHour;
            });
            var date = new Date(vm.startline);
            tasks.forEach(function (task) {
              loadTask(task, date, reload, timeline);
            });
          }

          var resourceData = [];
          var workerCount = 0;
          var subcontractorCount = 0;

          for (var id in timeline.resources.workers) {
            var worker = timeline.resources.workers[id];

            if (worker) {
              resourceData.push({
                id: worker._id,
                text: worker.name,
                avatar: worker.avatar,
                parent: 1
              });
              workerCount++;
            }
          }

          for (var _id in timeline.resources.subcontractors) {
            var subcontractor = timeline.resources.subcontractors[_id];

            if (subcontractor) {
              resourceData.push({
                id: subcontractor._id,
                text: subcontractor.name,
                avatar: subcontractor.avatar,
                parent: 2
              });
              subcontractorCount++;
            }
          }

          resourceData.unshift({
            id: 2,
            text: "Sub Contractors (".concat(subcontractorCount, ")"),
            type: gantt.config.types.project
          });
          resourceData.unshift({
            id: 1,
            text: "Workers (".concat(workerCount, ")"),
            type: gantt.config.types.project
          });
          $scope.ganttData = timeline.gantt;
          $scope.resourceData = resourceData;
          $timeout(function () {
            gantt.showDate(new Date());
          }, 300);
        }

        function loadGroup(group, timeline) {
          var timelineItem = {
            id: group._id,
            text: group.name,
            type: gantt.config.types.project,
            calcHours: utils.num(group.calcHours),
            modelId: group.modelId,
            modelType: group.modelType,
            show: true
          };

          if (group.parent) {
            timelineItem.parent = group.parent;
          }

          timeline.gantt.data.push(timelineItem);
        }

        function loadCalcTask(task) {
          if (!task.calcSheet || task.taskStyle === 'Subcontractor') return;
          var csTask = {
            _id: task._id,
            skills: task.product ? task.product.skills : [],
            workHours: utils.num(task.calcHours),
            level: 0,
            workers: [],
            requiredWorkerCount: 1,
            workType: task.workType
          };

          if (csTask.skills && csTask.skills.length > 0) {
            csTask.skills.forEach(function (skill) {
              vm.workers.forEach(function (worker) {
                if (worker.listOfSkills) {
                  worker.listOfSkills.forEach(function (workerSkill) {
                    if (workerSkill.level > skill.level && (workerSkill.name === 'All' || workerSkill.name === skill.name)) {
                      csTask.workers.push(worker);
                    }
                  });
                }
              });

              if (skill.level) {
                csTask.level += Number.parseInt(skill.level);
              } else {
                csTask.level++;
              }
            });
          } else {
            // anyone can work
            vm.workers.forEach(function (worker) {
              csTask.workers.push(worker);
            });
          }

          return csTask;
        }

        function loadTask(task, date, reload, timeline) {
          var timelineItem = {
            id: task._id,
            text: task.name,
            type: gantt.config.types.task,
            calcHours: utils.num(task.calcHours),
            description: task.description,
            workLevel: task.workLevel || '1',
            workType: task.workType || '1',
            progress: task.progress,
            modelId: task.modelId,
            modelType: task.modelType,
            objectId: task.objectId,
            status: utils.num(task.status),
            priority: utils.num(task.priority),
            resources: [],
            resourceIds: [],
            owner: task.owner,
            tasks: task.tasks,
            combined: task.combined,
            calcItem: task.calcItem,
            taskStyle: task.taskStyle,
            project: task.project,
            show: true
          };

          if (task.parent) {
            timelineItem.parent = task.parent;
          }

          var csTask = vm.csTasks.find(function (csTask) {
            return csTask._id === task._id;
          });

          if ((!reload || !task.calcItem) && task.startDate && task.endDate) {
            // load from saved time
            timelineItem.start_date = new Date(task.startDate);
            timelineItem.end_date = new Date(task.endDate);
          } else {
            // set time
            var moveTimes = 0;
            var _workType = task.workType;

            if (angular.isDefined(vm.workPattern) && angular.isDefined(_workType)) {
              var prevItem = timeline.gantt.data[timeline.gantt.data.length - 1];

              if (angular.isDefined(prevItem) && prevItem.workType !== _workType) {
                var patternItem = vm.workPattern.items.find(function (x) {
                  return x.tagName === _workType;
                });

                if (angular.isDefined(patternItem)) {
                  var percentage = patternItem.percentage;

                  if (percentage >= 0 && percentage < 100) {
                    var prevItems = timeline.gantt.data.filter(function (x) {
                      return x.workType === prevItem.workType;
                    });
                    var prevFirstItem = prevItems[0];
                    var prevLastItem = prevItems[prevItems.length - 1];
                    var diffTimes = prevLastItem.end_date.getTime() - prevFirstItem.start_date.getTime();
                    moveTimes = Math.ceil(diffTimes * (100 - percentage) / 100);
                  }
                }
              }
            }

            var startDate = new Date(date.getTime() - moveTimes);
            var taskDuration = csTask ? csTask.workHours : timelineItem.calcHours;
            taskDuration *= 3600000;
            var dates = getTaskDates(startDate, taskDuration);
            timelineItem.start_date = dates.start;
            timelineItem.end_date = dates.end;
          }

          if (task.resources && task.resources.length > 0) {
            // load from saved workers
            timelineItem.resources = [];
            task.resources.forEach(function (res) {
              if (res.worker) {
                timelineItem.resources.push({
                  id: res.worker._id,
                  name: res.worker.name || res.worker.displayName,
                  avatar: res.worker.profilePic,
                  type: res.workerType === 'Employee' ? 1 : 2
                });
              }
            });
          } else {
            // set workers
            if (task.taskStyle === 'Subcontractor') {
              var subContractor = vm.subContractors.find(function (x) {
                return x._id === task.workerId;
              });

              if (subContractor) {
                var resource = {
                  id: subContractor._id,
                  name: subContractor.name,
                  avatar: subContractor.profilePic,
                  type: 2
                };
                timelineItem.resources = [resource];
              }
            } else if (task.taskStyle === 'Worker') {
              if (vm.workers.length > 0) {
                var _resource2 = {
                  id: vm.workers[0]._id,
                  name: vm.workers[0].displayName,
                  avatar: vm.workers[0].profilePic,
                  type: 1
                };
                timelineItem.resources = [_resource2];
              }
            } else {
              if (csTask) {
                for (var i = 0; i < csTask.requiredWorkerCount; i++) {
                  if (i >= csTask.workers.length) break;
                  var worker = csTask.workers[i];
                  var _resource3 = {
                    id: worker._id,
                    name: worker.displayName,
                    avatar: worker.profilePic,
                    type: 1
                  };

                  if (isWorkerAvailable(_resource3, timelineItem.start_date, timelineItem.end_date)) {
                    timelineItem.resources.push(_resource3);
                  }
                }
              }
            }
          }

          timelineItem.requiredWorkerCount = csTask ? csTask.requiredWorkerCount : task.requiredWorkerCount;

          for (var _i = 0; _i < timelineItem.resources.length; _i++) {
            var _resource4 = timelineItem.resources[_i];

            if (_resource4.type === 1) {
              if (!timeline.resources.workers[_resource4.id]) {
                timeline.resources.workers[_resource4.id] = _resource4;
              }
            } else {
              if (!timeline.resources.subcontractors[_resource4.id]) {
                timeline.resources.subcontractors[_resource4.id] = _resource4;
              }
            }

            timelineItem.resourceIds.push(_resource4.id);
          } // group


          var workType = timelineItem.workType;
          var workLevel = timelineItem.workLevel;

          if (timeline.groups.workType) {
            if (!timeline.groups.workType[workType]) {
              timeline.groups.workType[workType] = workType;
            }
          }

          if (timeline.groups.workLevel) {
            if (!timeline.groups.workLevel[workLevel]) {
              timeline.groups.workLevel[workLevel] = workLevel;
            }
          }

          timeline.gantt.data.push(timelineItem);

          if (task.dependency) {
            timelineItem.dependency = task.dependency;
            timeline.gantt.links.push({
              id: utils.bsonId(),
              source: timelineItem.dependency,
              target: timelineItem.id,
              type: gantt.config.links.finish_to_start,
              workType: timelineItem.workType
            });
          }

          date.setTime(timelineItem.end_date.getTime());
          setStyle(workType);

          if (task.taskStyle === 'Subcontractor') {
            setupSubcontractorTask(timelineItem, timeline.gantt);
          }

          return timelineItem;
        }

        function setupSubcontractorTask(task, ganttData) {
          var duration = task.calcHours * 3600000;
          var divider = 250 * 3600000; // 250 hours

          if (duration <= divider) return;
          var date = task.start_date;

          do {
            var timelineItem = angular.copy(task);
            var taskDuration = duration > divider ? divider : duration;
            timelineItem.id = utils.bsonId();
            timelineItem.start_date = new Date(date);
            timelineItem.end_date = new Date(date.getTime() + taskDuration);
            timelineItem.parent = task.id;
            timelineItem.composeState = 'sub-child';
            date = timelineItem.end_date;
            duration -= divider;
            ganttData.data.push(timelineItem);
            ganttData.links.push({
              id: utils.bsonId(),
              source: task.id,
              target: timelineItem.id,
              type: gantt.config.links.start_to_start,
              workType: timelineItem.workType
            });
          } while (duration > 0);
        }

        function setStyle(workType) {
          if (angular.isUndefined($scope.styles[workType])) {
            $scope.styles[workType] = styleIndex;
            styleIndex++;
          }
        }

        function getTaskDates(date, duration) {
          var availableHourFrom = str2hhss('10:00');
          var availableHourTo = str2hhss('18:00');
          var availableWeekdayFrom = 1;
          var availableWeekdayTo = 5;
          var startTimeValue = getHourMinMillis(date);

          if (startTimeValue < availableHourFrom.millisecs) {
            date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
          } else if (startTimeValue > availableHourTo.millisecs) {
            date.setDate(date.getDate() + 1);
            date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
          }

          considerWeekday(date, availableWeekdayFrom, availableWeekdayTo, availableHourFrom);
          var startTime = new Date(date);
          var firstAvailableDuration = availableHourTo.millisecs - getHourMinMillis(date);
          var availableDuration = availableHourTo.millisecs - availableHourFrom.millisecs;

          if (duration <= firstAvailableDuration) {
            date.setTime(date.getTime() + duration);
          } else {
            date.setDate(date.getDate() + 1);
            date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
            considerWeekday(date, availableWeekdayFrom, availableWeekdayTo, availableHourFrom);
            duration -= firstAvailableDuration;
            var dayCount = Math.floor(duration / availableDuration); // day count

            if (dayCount > 0) {
              addWorkDays(date, dayCount);
              date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
              considerWeekday(date, availableWeekdayFrom, availableWeekdayTo, availableHourFrom);
            }

            var remained = duration - availableDuration * dayCount;

            if (remained > 0) {
              date.setTime(date.getTime() + remained);
            }
          }

          var endTime = date;
          vm.holidays.forEach(function (holiday) {
            var holiday_startDate = new Date(holiday.startDate);
            var holiday_endDate = new Date(holiday.endDate);

            if (startTime < holiday_startDate) {
              var holiDuration = holiday_endDate - holiday_startDate;
              endTime = new Date(endTime.getTime() + holiDuration);
            }
          });
          return {
            start: startTime,
            end: endTime
          };
        }

        function str2hhss(str) {
          var a = str.split(':'); // split it at the colons
          // minutes are worth 60 seconds. Hours are worth 60 minutes.

          var millisecs = (+a[0] * 60 + +a[1]) * 60000;
          return {
            hours: +a[0],
            minutes: +a[1],
            millisecs: millisecs
          };
        }

        function getHourMinMillis(date) {
          var hour = date.getHours();
          var minutes = date.getMinutes();
          return (hour * 60 + minutes) * 60000;
        }

        function considerWeekday(date, weekFrom, weekTo, hourFrom) {
          var weekday = date.getDay();

          if (weekday < weekFrom) {
            var gap = weekFrom - weekday;
            date.setDate(date.getDate() + gap);
            date.setHours(hourFrom.hours, hourFrom.minutes, 0, 1);
          } else if (weekday > weekTo) {
            var _gap = 7 - weekday + weekFrom;

            date.setDate(date.getDate() + _gap);
            date.setHours(hourFrom.hours, hourFrom.minutes, 0, 1);
          }
        }

        function addWorkDays(date, days) {
          var weekday = date.getDay();
          var daysToAdd = parseInt(days); // If the current day is Sunday add one day

          if (weekday === 0) daysToAdd++; // If the start date plus the additional days falls on or after the closest Saturday calculate weekends

          if (weekday + daysToAdd >= 6) {
            //Subtract days in current working week from work days
            var remainingWorkDays = daysToAdd - (5 - weekday); //Add current working week's weekend

            daysToAdd += 2;

            if (remainingWorkDays > 5) {
              //Add two days for each working week by calculating how many weeks are included
              daysToAdd += 2 * Math.floor(remainingWorkDays / 5); //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks

              if (remainingWorkDays % 5 === 0) daysToAdd -= 2;
            }
          }

          date.setDate(date.getDate() + daysToAdd);
          return date;
        }

        function getWorkHours(startDate, endDate) {
          var mStartDate = moment(startDate);
          var mEndDate = moment(endDate);
          var startWeekday = mStartDate.weekday();
          var endWeekday = mEndDate.weekday();
          var workHours = Math.abs(mEndDate - mStartDate) / 3600000 / 3;
          var restDays = Math.floor(workHours / 8 / 7) * 2;

          if (startWeekday === 0 || startWeekday === 6) {
            restDays += 1;
          }

          if (endWeekday === 0 || endWeekday === 6) {
            restDays += 1;
          }

          workHours -= restDays * 8;
          return workHours;
        }

        function isWorkerAvailable(resource, startDate, endDate) {
          startDate = new Date(startDate);
          endDate = new Date(endDate);
          var end = new Date(startDate);
          end.setHours(23, 59, 59, 999);

          if (endDate <= end) {
            // it's one day
            return getHoursOnDay(resource, startDate, end) > 0;
          } else {
            var hour = 0;
            var start = startDate;

            while (start <= endDate) {
              hour += getHoursOnDay(resource, start, end);
              start.setDate(start.getDate() + 1);
              start.setHours(0, 0, 0, 0);
              end = new Date(start);
              end.setHours(23, 59, 59, 999);

              if (end.getTime() > endDate.getTime()) {
                end = endDate;
              }
            }

            return hour > 0;
          }
        }

        function getWorkableHours(resource, startTime, endTime, tasks) {
          var start = new Date(startTime);
          var end = new Date(endTime); //get available hour

          end.setTime(end.getTime() - 1000);
          var duration = (end - start) / 3600000;

          if (duration <= 24) {
            // it's small than one day
            return getHoursOnDay(resource, start, end, tasks);
          } else {
            var date = new Date(start);
            var hours = 0;
            var endDate = new Date();

            while (date.getTime() < end.getTime()) {
              endDate.setTime(date.getTime());
              endDate.setHours(23, 59, 59, 0);

              if (endDate.getTime() > end.getTime()) {
                endDate = end;
              }

              hours += getHoursOnDay(resource, date, endDate, tasks);
              date.setTime(date.getTime() + 24 * 3600000);
            }

            return hours;
          }
        }

        function getHoursOnDay(resource, start, end, tasks) {
          var weekday = start.getDay();

          if (weekday === 6 || weekday === 0) {
            return 0;
          }

          var hrsWItem = getHrsWItem(resource, weekday);

          if (hrsWItem) {
            if (weekday >= hrsWItem.startWeekday && weekday <= hrsWItem.endWeekday) {
              var startTime = new Date(start);
              var endTime = new Date(end);
              var time = new Date(hrsWItem.startTime);
              startTime.setHours(time.getHours(), time.getMinutes(), 0, 0);
              time = new Date(hrsWItem.endTime);
              endTime.setHours(time.getHours(), time.getMinutes(), 0, 0);
              return getHoursFromTasksOnDay(tasks, startTime, endTime);
            }

            return 0;
          }

          if (resource.type === 2) {
            return Math.min(8, end - start);
          } else {
            var workerSetting = getWorkerSetting(resource, weekday);

            if (workerSetting && workerSetting.dailyHours) {
              var _startTime = new Date(start);

              var _endTime = new Date(end);

              var _time = utils.getTimeFromString(workerSetting.start);

              _startTime.setHours(_time.hour, _time.minute, 0, 0);

              _time = utils.getTimeFromString(workerSetting.stop);

              _endTime.setHours(_time.hour, _time.minute, 0, 0);

              return getHoursFromTasksOnDay(tasks, _startTime, _endTime, workerSetting.dailyHours);
            }

            return 0;
          }
        }

        function getHrsWItem(resource) {
          var item = undefined;

          if (vm.hrswItems) {
            item = vm.hrswItems.find(function (x) {
              return x.worker === resource.id;
            });

            if (!item) {
              item = vm.hrswItems.find(function (x) {
                return x.worker === 'all';
              });
            }
          }

          return item;
        }

        function getWorkerSetting(resource, weekday) {
          if (resource.type === 1) {
            var worker = vm.workers.find(function (x) {
              return x._id === resource.id;
            });

            if (worker && worker.employeeSettingId) {
              var workingTimes = worker.employeeSettingId.workingTimes;

              if (workingTimes) {
                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                return workingTimes.find(function (it) {
                  return it.day === days[weekday];
                });
              }
            }
          }

          return undefined;
        }

        function getHoursFromTasksOnDay(tasks, start, end, maxHour) {
          var hours = (end - start) / 3600000;

          if (tasks) {
            var total = 0;
            tasks.forEach(function (task) {
              var duration = hours;

              if (start < task.start_date && task.start_date < end) {
                duration -= (task.start_date - start) / 3600000;
              }

              if (task.end_date < end && task.end_date > start) {
                duration -= (end - task.end_date) / 3600000;
              }

              if (angular.isDefined(maxHour)) {
                duration = Math.min(maxHour, duration);
              }

              total += duration;
            });
            hours = angular.isDefined(maxHour) ? Math.min(maxHour, total) : total;
          } else {
            if (angular.isDefined(maxHour)) {
              hours = Math.min(maxHour, hours);
            }
          }

          hours = Math.min(8, hours);
          return hours;
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardProjectSummary", dashboardProjectSummary);

  function dashboardProjectSummary(globals, $rootScope, apiFactory, $log, utils, storageFactory) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-project-summary/dashboard-project-summary.view.html",
      replace: true,
      scope: {
        hasNotStatus: '='
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      var projectStore = globals.projectStore;
      scope.project = projectStore.get();
      scope.isLoading = false;
      scope.progress = 0;
      scope.members = [];
      scope.projects = [];
      var onSelProject = $rootScope.$on('choosed-project', function () {
        if (!scope.project) {
          scope.project = projectStore.get();
          init();
        }
      });
      $rootScope.$on('$destroy', onSelProject);
      init();

      function init() {
        scope.isLoading = true;

        if (!scope.project || scope.project._id === 'all') {
          scope.progress = 0;
          scope.members = [];
          storageFactory.getBookmarks().then(function (resp) {
            scope.projects = resp.data.bookmarks;
            $log.error(scope.projects);
            scope.projects.forEach(function (p) {
              p.invitedMembers.forEach(function (m) {
                scope.members.push(m);
              });
              scope.progress += Math.round(utils.num(p.progress) * 100);
            });
            scope.progress = Math.round(utils.num(scope.progress) / 100);
            scope.isLoading = false;
          })["catch"](function (err) {
            $log.error(err);
            Notification.error('Cannot load timeline data from the server.');
            scope.isLoading = false;
          });
        } else {
          scope.project.duration = Math.ceil(utils.getDurationDayInRange(new Date(scope.project.startDate), new Date(scope.project.endDate)));
          scope.progress = Math.round(utils.num(scope.project.progress) * 100);
          Promise.all([apiFactory.getProjectById(scope.project._id), apiFactory.fetchInvitedMembersInProject(scope.project._id)]).then(function (resp) {
            scope.project = resp[0].data;
            scope.progress = Math.round(utils.num(scope.project.progress) * 100);
            scope.members = resp[1].data || [];
            scope.project.duration = Math.ceil(utils.getDurationDayInRange(new Date(scope.project.startDate), new Date(scope.project.endDate)));
          })["catch"](function (err) {
            $log.error(err);
          });
        }
      }
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module("app").directive("dashboardProjectMembers", dashboardProjectMembers);

  function dashboardProjectMembers($log, apiFactory) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-project-members/dashboard-project-members.view.html",
      replace: true,
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.members = [];
      scope.isCheckAll = true;
      scope.workTypes = [{
        _id: "Office",
        label: "Office"
      }, {
        _id: "wood",
        label: "Woodworking"
      }];
      scope.roles = [{
        _id: "manager",
        label: "General Manager"
      }, {
        _id: "worker",
        label: "Worker"
      }, {
        _id: "driver",
        label: "Driver"
      }, {
        _id: "plumber",
        label: "Plumber"
      }];
      scope.workType = undefined;
      scope.role = undefined;
      scope.loading = true;
      apiFactory.getAllEmployees({
        page: 1,
        chunk: 10,
        sort: 'createdAt',
        sortType: "false"
      }).then(function (resp) {
        scope.loading = false;
        scope.members = resp.data.list || [];
      })["catch"](function (err) {
        $log.error(err);
        scope.loading = false;
      });

      scope.selectRole = function () {};

      scope.selectWorkType = function () {};
    }
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module("app").directive("dashboardPipeline", dashboardPipeline);

  function dashboardPipeline(apiFactory, $log, utils, Notification, globals, $filter) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-pipeline/dashboard-pipeline.view.html",
      scope: {
        type: '=',
        data: '=',
        height: '='
      },
      link: function link(scope) {
        var projectStore = globals.projectStore,
            companyStore = globals.companyStore;
        scope.projectData = projectStore.get();
        scope.companyData = companyStore.get();
        scope.projectStatusList = ['Offer', 'OnGoing', 'Completed', 'Cancel', 'Lost', 'Postponed', 'Precast'];
        scope.tenderStatusList = ['Open', 'Approved', 'In-Progress', 'Declined', 'Created', 'In-Negotiation'];
        scope.materialStatusList = ['Open', 'Approved', 'In-Progress', 'Declined', 'Created', 'In-Negotiation'];
        scope.buildingTypeId = 'All';
        scope.buildingTypes = [{
          _id: 'All',
          tagName: 'All'
        }];
        scope.project = 'All Projects';
        scope.projectOptions = [{
          value: 'All Projects',
          label: $filter('translate')("All Projects")
        }];
        scope.projectId = undefined;
        scope.selectedAllRFPs = false;
        scope.rfps = [];
        scope.selectedAllOffers = false;
        scope.offers = [];

        scope.fetchRFPs = function () {
          var endpoint = scope.projectId === 'All Projects' ? apiFactory.getRFPs() : apiFactory.getRFPsForProject(scope.projectId);
          scope.loading = true;
          endpoint.then(function (res) {
            scope.loading = false;
            scope.rfps = res.data.list;
            var promises = [];

            var _iterator = _createForOfIteratorHelper(scope.rfps),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var rfp = _step.value;
                var staffs = rfp.staffs;
                var supplierIds = staffs.map(function (x) {
                  return x.subUserId._id;
                });
                promises.push(apiFactory.getTotalAmountsByVendors({
                  vendorIds: supplierIds.join(',')
                }));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            scope.loading = true;
            Promise.all(promises).then(function (res) {
              scope.loading = false;

              for (var i = 0; i < res.length; i++) {
                var rfp = scope.rfps[i];
                rfp.totalAmount = res[i].data.data;
              }
            })["catch"](function (err) {
              scope.loading = false;
              $log.error(err);
            });
          })["catch"](function (err) {
            scope.loading = false;
            $log.error(err);
          });
        };

        scope.fetchOffers = function () {
          var query = {};

          if (scope.projectId !== 'All Projects') {
            query.projectId = scope.projectId;
          }

          scope.loading = true;
          Promise.all([apiFactory.getCollaborationOffers(query), apiFactory.listAllOffers(query)]).then(function (res) {
            scope.loading = false;
            scope.offers = res[0].data.list.concat(res[1].data.list);
          })["catch"](function (err) {
            scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        };

        function initData() {
          scope.loading = true;
          Promise.all([apiFactory.listAllBuildingTypes(), apiFactory.listAllOngoingProjects()]).then(function (res) {
            scope.loading = false;
            scope.buildingTypes = scope.buildingTypes.concat(res[0].data.list);
            scope.ongoingProjects = res[1].data.list;
            scope.ongoingProjects.unshift({
              _id: 'All Projects',
              projectName: $filter('translate')("All Projects")
            });
            scope.projectId = 'All Projects';
            scope.fetchRFPs();
            scope.fetchOffers();
          })["catch"](function (err) {
            scope.loading = false;
            $log.error(err);
          });

          if (scope.type === 'project') {
            scope.ongoingProjects = angular.copy(scope.data);
          }
        }

        initData();

        function filterProjects() {
          if (scope.buildingTypeId === 'All' || angular.isUndefined(scope.buildingTypeId)) {
            scope.ongoingProjects = angular.copy(scope.data);
          } else {
            scope.ongoingProjects = scope.data.filter(function (x) {
              return x.buildingType && x.buildingType._id === scope.buildingTypeId;
            });
          }
        }

        scope.onChangeBuildingType = function (buildingTypeId) {
          scope.buildingTypeId = buildingTypeId;
          filterProjects();
        };

        scope.$watch('data', function () {
          if (scope.type === 'project') {
            filterProjects();
          }
        });
        /*
         * RFP relations -----------------------------------------
         */

        scope.selectAllRFPs = function () {
          scope.rfps.forEach(function (x) {
            return x.selected = scope.selectedAllRFPs;
          });
        };

        scope.selectRFP = function () {
          scope.selectedAllRFPs = false;
        };

        scope.getRFPSupplierNames = function (staffs) {
          var names = [];
          var suppliers = staffs.map(function (x) {
            return x.subUserId;
          });

          var _iterator2 = _createForOfIteratorHelper(suppliers),
              _step2;

          try {
            var _loop = function _loop() {
              var supplier = _step2.value;

              if (supplier && !names.find(function (x) {
                return x == supplier.name;
              })) {
                names.push(supplier.name);
              }
            };

            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          return names.join(', ');
        };

        scope.getRFPStatusStyle = function (status) {
          switch (status) {
            case "Created":
              return {
                color: '#747474',
                backgroundColor: '#E8E8E8'
              };

            case "Open":
              return {
                color: '#367BF5',
                backgroundColor: '#E6EFFF'
              };

            case "In-Negotiation":
              return {
                color: '#813AC8',
                backgroundColor: '#E7D7F7'
              };

            case "Declined":
              return {
                color: '#D71414',
                backgroundColor: '#FEE4E2'
              };

            case "Approved":
              return {
                color: '#2FA84F',
                backgroundColor: '#DCF7E3'
              };

            default:
              return {
                color: '#747474',
                backgroundColor: '#E8E8E8'
              };
          }
        }; //--------------------------- RFP relations END ----------------------------


        scope.selectAllOffers = function () {
          scope.offers.forEach(function (x) {
            return x.selected = scope.selectedAllOffers;
          });
        };

        scope.selectOffer = function () {
          scope.selectedAllOffers = false;
        };
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module("app").directive("dashboardOrderBlock", dashboardOrderBlock);

  function dashboardOrderBlock($log, apiFactory, globals) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-order-block/dashboard-order-block.view.html",
      replace: true,
      link: function link(scope) {
        var companyStore = globals.companyStore;
        var companyData = companyStore.get();
        scope.currency = companyData.currentCurrency.currencyCode;
        scope.supplier = 'all';
        scope.supplierOptions = [{
          _id: 'all',
          name: 'All Suppliers'
        }];
        scope.orders = [];
        var allOrders = [];
        globals.getCurrency().then(function (resp) {
          scope.currency = resp.data.find(function (cur) {
            return cur.cc === companyData.currentCurrency.currencyCode;
          }).symbol;
        })["catch"](function (err) {
          $log.error(err);
        });
        scope.loading = true;
        apiFactory.listAllOrders({
          po: true
        }).then(function (resp) {
          scope.loading = false;
          allOrders = resp.data.list;
          var suppliers = scope.supplierOptions;
          allOrders.forEach(function (order) {
            order.suppliers = getSuppliers(order);
            order.supplierName = order.suppliers.map(function (x) {
              return x.name;
            }).join(',');
            suppliers = suppliers.concat(order.suppliers);
          });
          scope.supplierOptions = suppliers.uniqBy(function (x) {
            return x._id;
          });
          scope.orders = allOrders;
        })["catch"](function (err) {
          scope.loading = false;
          $log.error(err);
        });

        scope.selectSupplier = function (supplierId) {
          scope.orders = supplierId === 'all' ? allOrders : allOrders.filter(function (x) {
            return x.suppliers.findIndex(function (s) {
              return s._id === supplierId;
            }) !== -1;
          });
        };

        function getSuppliers(order) {
          var suppliers = [];

          if (order.details) {
            order.details.forEach(function (detail) {
              if (detail.material && detail.material.supplier) {
                suppliers.push({
                  _id: detail.material.supplier._id,
                  name: detail.material.supplier.name
                });
              }
            });
          }

          return suppliers.uniqBy(function (x) {
            return x._id;
          });
        }
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module("app").directive("dashboardMeetingBlock", dashboardMeetingBlock);

  function dashboardMeetingBlock(globals, apiFactory, utils, Notification, $log, $uibModal, $timeout) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-meeting-block/dashboard-meeting-block.view.html",
      scope: {
        height: '='
      },
      link: function link($scope) {
        var projectData = globals.projectStore.get();
        $scope.meetings = {};
        $scope.today = moment().format('dddd MMM DD');

        function organizemeetingList() {
          $scope.meetings = {};

          var _iterator = _createForOfIteratorHelper($scope.meetingList),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var meetingRoom = _step.value;
              var date = moment(meetingRoom.dateFrom).format('dddd MMM DD');

              if (utils.isEmpty($scope.meetings[date])) {
                $scope.meetings[date] = [meetingRoom];
              } else {
                $scope.meetings[date].push(meetingRoom);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          $timeout(function () {
            $scope.$apply();
          });
        }

        if (projectData) {
          $scope.loading = true;
          Promise.all([apiFactory.getMeetingRoomsForCompany()]).then(function (res) {
            $scope.loading = false;
            $scope.meetingList = res[0].data.data;
            $scope.meetingList.sort(function (a, b) {
              return new Date(a.dateFrom).getTime() - new Date(b.dateFrom).getTime();
            });
            organizemeetingList();
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
          });
        }

        $scope.getDatesOfMeetings = function () {
          return Object.keys($scope.meetings);
        };

        $scope.getTextStatus = function (status) {
          switch (status) {
            case 0:
              return 'Not yet Started';

            case 1:
              return 'In-progress';

            case 2:
              return 'Completed';

            case 3:
              return 'Failed';

            default:
              return '';
          }
        };

        $scope.addMeetingRoom = function () {
          if (!projectData) {
            Notification.error('Please select a project');
            return;
          }

          $scope.loading = true;
          apiFactory.getInviteMembersForChat(projectData._id).then(function (res) {
            $scope.loading = false;
            $scope.inviteMembers = res.data.data;

            if (utils.isEmpty($scope.inviteMembers)) {
              Notification.error('There are no members invited to the project');
              return;
            }

            var modal = $uibModal.open({
              animation: true,
              component: 'createMeetingRoomModal',
              windowClass: 'create-meeting-room-modal',
              backdrop: 'static',
              keyboard: true,
              resolve: {
                inviteMembers: function inviteMembers() {
                  return $scope.inviteMembers;
                },
                isCreate: function isCreate() {
                  return true;
                }
              }
            });
            modal.result.then(function (newMeetingRoom) {
              $scope.meetingList.push(newMeetingRoom);
              organizemeetingList();
            });
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
          });
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardMatEqBlock", dashboardMatEqBlock);

  function dashboardMatEqBlock() {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-mat-eq-block/dashboard-mat-eq-block.view.html",
      scope: {
        height: '=',
        type: '='
      },
      link: function link() {}
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardIssuesStatisticsBlock", dashboardIssuesStatisticsBlock);

  function dashboardIssuesStatisticsBlock(apiFactory, globals) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-issues-statistics-block/dashboard-issues-statistics-block.view.html",
      scope: {
        type: '='
      },
      link: function link(scope) {
        var projectStore = globals.projectStore;
        scope.project = projectStore.get();
        scope.issueStatistic = {
          total: 0,
          safety: 0,
          completed: 0
        };
        apiFactory.getIssueStatistic(scope.project._id).then(function (res) {
          scope.issueStatistic = res.data.data;
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('dashboardIssueBlock', dashboardIssueBlock);

  function dashboardIssueBlock($log, apiFactory, globals) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/dashboard/directives/dashboard-issue-block/dashboard-issue-block.view.html',
      replace: true,
      link: linkFunc
    };

    function linkFunc(scope) {
      var projectStore = globals.projectStore;
      var project = projectStore.get();

      if (!project || project.id === 'all') {
        return;
      }

      scope.issue = undefined;
      scope.isDetails = true;
      scope.loading = true;
      apiFactory.listAllIssues({
        projectId: project._id,
        page: 1,
        chunk: 1
      }).then(function (resp) {
        scope.loading = false;
        var issues = resp.data.list || [];
        scope.issue = issues.length > 0 ? issues[0] : undefined;
      })["catch"](function (err) {
        $log.error(err);
        scope.loading = false;
      });

      scope.getIssueStatusClass = function () {
        switch (scope.issue.status) {
          case 'Open':
            return 'open';

          case 'Resolved':
            return 'resolved';

          case 'Completed':
            return 'completed';

          default:
            return 'open';
        }
      };
    }
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function () {
  angular.module("app").directive("dashboardIncomingOffer", dashboardIncomingOffer);

  function dashboardIncomingOffer($state, $log, apiFactory, globals, Notification, utils, $uibModal) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-incoming-offer/dashboard-incoming-offer.view.html",
      replace: true,
      scope: {},
      binding: {
        collaboratorType: '='
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      var userStore = globals.userStore,
          companyStore = globals.companyStore,
          projectStore = globals.projectStore;
      scope.userData = userStore.get();
      scope.companyData = companyStore.get();
      scope.projectData = projectStore.get();
      scope.vendorType = 0;
      scope.userIdFilter = null;

      scope.goDashboard = function () {
        $state.go(globals.getDashboardRoute(scope.userData));
      };

      scope.utils = utils;
      scope.designationFilter = "Client,Supplier,Subcontractor,Manager,Admin";
      scope.statusFilter = "Accepted,On Hold,Pending,Not Received";
      scope.dateFilter = undefined;
      scope.vendorList = [];
      scope.vendorList2 = [];
      scope.collaborators = [];
      scope.TEAM_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(scope.userData);
      // if (scope.userData.designation == "Admin") {
      //   scope.TEAM_ACCESS_CREATE = 4;
      // } else {
      //   apiFactory.getAccessSettingDetails({
      //     dType,
      //     list: [Constants.AccessKey.TEAM]
      //   }).then(res => {
      //     scope.TEAM_ACCESS_CREATE = res.data.data[Constants.AccessKey.TEAM];
      //   })
      //     .catch((e) => {
      //       $log.error(e);
      //       Notification.error('Something went wrong try later')
      //     });
      // }

      scope.periods = [{
        id: '12',
        name: '12'
      }, {
        id: '24',
        name: '24'
      }, {
        id: '48',
        name: '48'
      }];
      scope.currentPage = 1;
      scope.totalCount = 0;
      scope.numPerPage = 12;
      scope.statusOptions = [{
        value: 'Not Received',
        label: 'Not Received'
      }, {
        value: 'Pending',
        label: 'Pending'
      }, {
        value: 'Declined',
        label: 'Declined'
      }, {
        value: 'On Hold',
        label: 'On-Hold'
      }, {
        value: 'Accepted',
        label: 'Accepted'
      }];
      scope.offers = [];

      scope.searchOffers = function () {
        scope.currentPage = 1;
        scope.getOffers();
      };

      scope.selectNumPage = function (new_num) {
        scope.numPerPage = new_num;
        scope.getOffers();
      };

      scope.getOffers = function () {
        scope.isLoading = true;
        apiFactory.getCollaborationOffers({
          page: scope.currentPage,
          chunk: scope.numPerPage,
          search: scope.searchText,
          projectId: scope.projectData._id,
          designationFilter: scope.designationFilter,
          dateFilter: scope.dateFilter,
          vendorType: scope.vendorType,
          userIdFilter: scope.userIdFilter
        }).then(function (res) {
          scope.isLoading = false;
          scope.offers = res.data.list;
          scope.totalCount = res.data.total;
          scope.noOfPages = Math.ceil(scope.totalCount / scope.numPerPage);
          scope.makedata();
        })["catch"](function (err) {
          scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.getOffers();

      scope.selectGroup = function (offer, group) {
        if (group) {
          offer.selectedGroup = group;
        } else {
          offer.selectedGroup = {
            name: "All",
            levels: []
          };
          offer.groups.forEach(function (group) {
            offer.selectedGroup.levels = offer.selectedGroup.levels.concat(group.levels);
          });
        }
      };

      scope.updateStatus = function (offer, status) {
        scope.isLoading = true;
        apiFactory.updateCollaborationOfferStatus({
          id: offer._id,
          status: status
        }).then(function (res) {
          scope.isLoading = false;
          offer.status = status;
          Notification.success(res.data.message);
        })["catch"](function (err) {
          scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.saveOfferSubmit = function (offer) {
        scope.loading = true;
        apiFactory.updateCollaborationOffer(offer).then(function () {
          scope.loading = false;
          Notification.success('changed successfully');
        })["catch"](function (err) {
          scope.loading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.uploadOffer = function () {
        $uibModal.open({
          animation: true,
          component: 'uploadOfferModal',
          windowClass: 'upload-offer-modal'
        }).result.then(function () {
          scope.getOffers();
        }, function () {});
      };

      scope.selectAllOffers = function () {
        scope.offers.forEach(function (x) {
          x.selected = scope.selectedAll;
        });
      };

      scope.selectOffer = function (offer) {
        if (!offer.selected) {
          scope.selectedAll = false;
        }

        if (scope.offers.map(function (x) {
          return x.selected ? 1 : 0;
        }).reduce(function (acc, val) {
          return acc + val;
        }, 0) === scope.offers.length) {
          scope.selectedAll = true;
        }
      };

      scope.$on('filter_by_designation', function (event, data) {
        scope.designationFilter = data.filter(function (x) {
          return x.selected;
        }).map(function (x) {
          return x.value;
        }).join(",");
        scope.getOffers();
      });
      scope.$on('filter_by_status', function (event, data) {
        scope.statusFilter = data.filter(function (x) {
          return x.selected;
        }).map(function (x) {
          return x.value;
        }).join(",");
        scope.getOffers();
      });
      scope.$on("filter_by_date", function (event, data) {
        scope.dateFilter = data;
        scope.getOffers();
      });

      scope.makedata = function () {
        var source = scope.offers;
        $log.log(source);
        var bidObj = [];
        var bidlist = [];

        for (var i = 0; i < source.length; i++) {
          if (!bidlist.includes(source[i].bidPackageId._id)) {
            bidlist.push(source[i].bidPackageId._id);
            bidObj.push({
              offers: [],
              title: source[i].bidPackageId.title,
              bId: source[i].bidPackageId._id,
              systag: source[i].bidPackageId.sysTag
            });
          }
        }

        for (var _i = 0; _i < bidObj.length; _i++) {
          for (var j = 0; j < source.length; j++) {
            if (bidObj[_i].bId == source[j].bidPackageId._id) {
              var offer = source[j];

              if (offer.revision < offer.templateId.revision) {
                offer.levels = offer.templateId.levels;
                offer.revision = offer.templateId.revision;
              }

              bidObj[_i].offers.push(source[j]);
            }
          }
        }

        scope.bidPackages = bidObj;
        scope.bidPackages.forEach(function (bid) {
          bid.offers.forEach(function (offer) {
            offer.selectedGroup = {
              name: "All",
              levels: []
            };

            if (offer.groups) {
              offer.groups.forEach(function (group) {
                offer.selectedGroup.levels = offer.selectedGroup.levels.concat(group.levels);
              });
            }

            $log.log('selected group = ', offer.selectedGroup);
          });
        });
        scope.$apply();
      };

      scope.fetchSuppliers = function () {
        scope.isLoading = true;
        apiFactory.getAllSuppliers({}).then(function (res) {
          scope.isLoading = false;
          scope.vendorList = res.data.list;
        })["catch"](function (err) {
          $log.error(err);
          scope.isLoading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.fetchSuppliers(); // calc offer

      scope.calcOfferDays = function (offer) {
        var days = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            days += parseInt(lv.days);
          });
        });
        return days;
      };

      scope.calcOfferQuantity = function (offer) {
        var cnt = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            cnt += parseFloat(lv.quantity);
          });
        });
        return cnt;
      };

      scope.calcOfferUnitPrice = function (offer) {
        var cnt = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            cnt += parseFloat(lv.quantity);
          });
        });
        var cnt1 = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            cnt1 += parseFloat(lv.amount);
          });
        });
        if (cnt1 == 0) return 0;
        return cnt1 / cnt;
      };

      scope.calcOfferAmount = function (offer) {
        var cnt = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            cnt += parseFloat(lv.amount);
          });
        });
        return cnt;
      };

      scope.calcLevelAmount = function (lv) {
        lv.amount = lv.quantity * lv.unitPrice;
      }; // calc bid


      scope.calcBest = function (bid) {
        var mun = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == 'Accepted') {
            mun++;
          }
        });
        return mun;
      };

      scope.getSysTag = function (bid) {
        $log.log(bid);
      };

      scope.getCollaborator = function (bid) {
        var mun = "";
        var cnt = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == 'Accepted') {
            // $log.log(offer)
            if (offer.supplierId && cnt == 0) mun += offer.supplierId.name;else if (offer.subcontractorId && cnt == 0) mun += offer.subcontractorId.name;
            cnt++;
          }
        });
        if (cnt <= 2) return mun;else return mun + " +" + (cnt - 1);
      };

      scope.getBidStaffs = function (bid) {
        var mun = "";
        var cnt = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            if (cnt == 0 && offer.staffId) mun += offer.staffId.displayName;
            cnt++;
          }
        });
        if (cnt <= 2) return mun;else return mun + " +" + (cnt - 1);
      };

      scope.calcBidLevels = function (bid) {
        var value = 0;
        bid.offers.forEach(function (offer) {
          offer.groups.forEach(function (group) {
            value = group.levels.length;
          });
        });
        return value;
      };

      scope.calcBidDays = function (bid) {
        var average = 0;
        var cnt = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            cnt++;
            offer.groups.forEach(function (group) {
              group.levels.forEach(function (lv) {
                average += parseInt(lv.days);
              });
            });
          }
        });
        if (average == 0) return 0;
        return average / cnt;
      };

      scope.calcBidQuantity = function (bid) {
        var sum = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            offer.groups.forEach(function (group) {
              group.levels.forEach(function (lv) {
                sum += parseInt(lv.quantity);
              });
            });
          }
        });
        return sum;
      };

      scope.calcGroupQuantity = function (group) {
        var sum = 0;
        group.levels.forEach(function (lv) {
          sum += parseInt(lv.quantity);
        });
        return sum;
      };

      scope.calcGroupDays = function (group) {
        var total = 0;
        group.levels.forEach(function (lv) {
          total += parseInt(lv.days);
        });
        return total;
      };

      scope.calcGroupOfferAmount = function (group) {
        var sum = 0;
        group.levels.forEach(function (lv) {
          sum += parseInt(lv.amount);
        });
        return sum;
      };

      scope.calcBidUnitPrice = function (bid) {
        var cnt = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            offer.groups.forEach(function (group) {
              group.levels.forEach(function (lv) {
                cnt += parseInt(lv.quantity);
              });
            });
          }
        });
        var cnt1 = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            offer.groups.forEach(function (group) {
              group.levels.forEach(function (lv) {
                cnt1 += parseInt(lv.amount);
              });
            });
          }
        });
        if (cnt1 == 0 || cnt == 0) return 0;
        return cnt1 / cnt;
      };

      scope.calcBidOfferAmount = function (bid) {
        var sum = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == "Accepted") {
            offer.groups.forEach(function (group) {
              group.levels.forEach(function (lv) {
                sum += parseInt(lv.amount);
              });
            });
          }
        });
        return sum;
      };

      scope.getBidStatus = function (bid) {
        var flag1 = 0,
            flag2 = 0;
        bid.offers.forEach(function (offer) {
          if (offer.status == 'Accepted') flag1 = 1;
          if (offer.status == 'Decliended') flag2 = 1;
        });
        if (flag1) return 'Accepted';else if (flag2) return 'Decliended';else return 'Paused';
      };

      scope.getStaff = function (id) {
        var staff = null;
        scope.vendorList.forEach(function (v) {
          v.staffs.forEach(function (s) {
            if (s._id == id) staff = s;
          });
        });
        if (staff) return staff;
        scope.subcontactors.forEach(function (v) {
          v.staffs.forEach(function (s) {
            if (s._id == id) staff = s;
          });
        }); // if(staff)

        return staff;
      };

      scope.attachExcelFiles = function (offer) {
        angular.element('#fileSelector').triggerHandler('click');
        scope.currentOffer = offer;
      };

      scope.SelectFile = function (file) {
        scope.SelectedFile = file;
        scope.Upload(scope.currentOffer);
      };

      scope.Upload = function (tempoffer) {
        // $log.log(11111);
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;

        if (regex.test(scope.SelectedFile.name.toLowerCase())) {
          if (angular.isDefined(typeof FileReader === "undefined" ? "undefined" : _typeof(FileReader))) {
            var reader = new FileReader(); //For Browsers other than IE.

            if (reader.readAsBinaryString) {
              reader.onload = function (e) {
                scope.ProcessExcel(e.target.result, tempoffer);
              };

              reader.readAsBinaryString(scope.SelectedFile);
            } else {
              //For IE Browser.
              reader.onload = function (e) {
                var data = "";
                var bytes = new Uint8Array(e.target.result);

                for (var i = 0; i < bytes.byteLength; i++) {
                  data += String.fromCharCode(bytes[i]);
                }

                scope.ProcessExcel(data, tempoffer);
              };

              reader.readAsArrayBuffer(scope.SelectedFile);
            }
          } else {
            Notification.error("This browser does not support HTML5.");
          }
        } else {
          Notification.error("Please upload a valid Excel file.");
        }
      };

      scope.ProcessExcel = function (data, tempOffer) {
        //Read the Excel File data.
        var workbook = XLSX.read(data, {
          type: 'binary'
        }); //Fetch the name of First Sheet.

        var firstSheet = workbook.SheetNames[0]; //Read all rows from First Sheet into an JSON array.

        var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
        $log.log(excelRows); //Display the data from Excel file in Table.

        scope.$apply(function () {
          if (excelRows.length != tempOffer.levels.length) {
            Notification.error("Uploaded successfully, but the excel data has different column or row count.");
          } else {
            tempOffer.levels.forEach(function (lv, index) {
              lv.days = excelRows[index].Days;
              lv.quantity = excelRows[index].Quantity;
              lv.unitPrice = excelRows[index].UnitPrice;
              lv.amount = excelRows[index].Amount;
            });
          }
        });
      };

      scope.getOfferStatusClass = function (status) {
        switch (status) {
          case 'Pending':
            return {
              'on-hold': true
            };

          case 'Not Received':
            return {
              'Not Received': true
            };

          case 'Accepted':
            return {
              'Accepted': true
            };

          case 'Declined':
            return {
              'Declined': true
            };

          case 'Paused':
            return {
              'Paused': true
            };

          default:
            return {
              'on-hold': true
            };
        }
      };

      scope.$on('updateData', function (event, args) {
        $log.log(args);

        if (args.collaboratorType == 1) {
          scope.vendorType = 0;
        } else {
          scope.vendorType = 1;
        }

        if (args.userIdFilter == 'all') {
          scope.userIdFilter = null;
        } else {
          scope.userIdFilter = args.userIdFilter;
        }

        scope.getOffers();
      });
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardHeader", dashboardHeader);

  function dashboardHeader($log, $state, $uibModal, apiFactory, globals) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-header/dashboard-header.view.html",
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc(scope) {
      var userStore = globals.userStore;
      var userData = userStore.get();
      scope.profilePic = userData.profilePic;
      scope.firstName = userData.firstName; // scope.PROJECT_ACCESS_CREATE = 0;
      // scope.NOTE_ACCESS_CREATE = 0;
      // scope.TEAM_ACCESS_CREATE = 0;
      // let dType = globals.getDashboardType(userData);
      // if (userData.designation === "Admin") {
      //   scope.PROJECT_ACCESS_CREATE = 4;
      //   scope.NOTE_ACCESS_CREATE = 4;
      //   scope.TEAM_ACCESS_CREATE = 4;
      // } else {
      //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.PROJECT, Constants.AccessKey.NOTE, Constants.AccessKey.TEAM]})
      //     .then(res => {
      //       scope.PROJECT_ACCESS_CREATE = res.data.data[Constants.AccessKey.PROJECT];
      //       scope.NOTE_ACCESS_CREATE = res.data.data[Constants.AccessKey.NOTE];
      //       scope.TEAM_ACCESS_CREATE = res.data.data[Constants.AccessKey.TEAM];
      //     })
      //     .catch((e) => {
      //       $log.error(e);
      //       Notification.error('Something went wrong try later');
      //     });
      // }

      scope.onCreateProject = function () {
        $state.go('createProject', {
          id: 'create'
        });
      };
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("ecoMainGraph", ecoMainGraph);

  function ecoMainGraph(moment, globals, $filter, $log) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: "app/main/dashboard/directives/dashboard-economic-main-graph/dashboard-economic-main-graph.view.html",
      scope: {
        companyCurrency: "=",
        graphData: "=",
        needRender: "=",
        startDate: "=",
        endDate: "="
      },
      link: function link(scope) {
        var projectStore = globals.projectStore;
        scope.project = projectStore.get();
        scope.type = "custom";
        scope.start = new Date().getTime();
        scope.end = scope.start;
        scope.hasGraphData = false;
        scope.seriesOptionOpened = false;
        scope.filterData = null;
        scope.cash = {};
        var filterStore = globals.filterStore;
        scope.revenueGraphData = [];
        scope.laborGraphData = [];
        scope.companyCostGraphData = [];
        scope.profitGraphData = [];
        scope.inventoryGraphData = [];
        scope.allGraphData = [];
        var graphData = [];

        scope.getDisplayPrice = function (value) {
          if (value > 1000000) {
            value /= 1000000;
            value = Math.round(value * 100) / 100;
            value += "M";
          } else if (value > 1000) {
            value /= 1000;
            value = Math.round(value * 100) / 100;
            value += "K";
          }

          return scope.companyCurrency ? scope.companyCurrency.symbol + " " + value : value;
        };

        scope.buildGraphData = function () {
          if (scope.graphData) {
            scope.revenueGraphData = scope.graphData.revenueGraphData;
            scope.laborGraphData = scope.graphData.laborGraphData;
            scope.companyCostGraphData = scope.graphData.companyCostGraphData;
            scope.profitGraphData = scope.graphData.profitGraphData;
            scope.inventoryGraphData = scope.graphData.inventoryGraphData;
            scope.allGraphData = scope.graphData.allGraphData;
            scope.revenueGraphData.forEach(function (x) {
              x.x = new Date(x.x);
            });
            scope.laborGraphData.forEach(function (x) {
              x.x = new Date(x.x);
            });
            scope.companyCostGraphData.forEach(function (x) {
              x.x = new Date(x.x);
            });
            scope.profitGraphData.forEach(function (x) {
              x.x = new Date(x.x);
            });
            scope.inventoryGraphData.forEach(function (x) {
              x.x = new Date(x.x);
            });
            scope.allGraphData.forEach(function (x) {
              x.x = new Date(x.x);
            }); // $log.log('start = ', scope.startDate);

            scope.start = scope.startDate;
            scope.end = scope.endDate;
            scope.filterData = {
              start: scope.startDate,
              end: scope.endDate
            }; // scope.start = Math.min.apply(Math, scope.allGraphData.map(function(x) {
            //   return x.x;
            // }));
            // $log.log('---start = ', scope.start);
            // scope.end = Math.max.apply(Math, scope.allGraphData.map(function(x) {
            //   return x.x;
            // }));
          }
        };

        scope.onSelectType = function (type) {
          scope.type = type;
          scope.isLoading = false;

          if (type != "custom") {
            scope.start = Math.min.apply(Math, scope.allGraphData.map(function (x) {
              return x.x;
            }));
            $log.log('---start = ', scope.start);
            scope.end = Math.max.apply(Math, scope.allGraphData.map(function (x) {
              return x.x;
            }));
          } else {
            scope.start = scope.startDate;
            scope.end = scope.endDate;
            scope.filterData = {
              start: scope.startDate,
              end: scope.endDate
            };
          }

          graphData = [];
          var graphBase = prepareGraphBase(type);
          graphBase = graphBase.sort(function (a, b) {
            return a.begin - b.begin;
          });
          var baseGraphData = [];
          var graphStart = new Date(graphBase[0].begin);
          var graphEnd = new Date(graphBase[graphBase.length - 1].end);
          $log.log(graphBase);
          $log.log('graphStart = ', graphStart);
          $log.log('graphEnd = ', graphEnd);

          for (var i = 0; i < graphBase.length; i++) {
            var base = graphBase[i];
            var value = 0;
            baseGraphData.push({
              x: base.end,
              y: value
            }); // if (graphStart > new Date(base.begin)) graphStart = new Date(base.begin);
            // if (graphEnd < new Date(base.end)) graphEnd = new Date(base.end);
          }

          graphData.push({
            values: baseGraphData,
            color: "transparent",
            classed: "dashed"
          });
          var revenueGraphData = scope.revenueGraphData.filter(function (x) {
            return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
          });
          var laborGraphData = scope.laborGraphData.filter(function (x) {
            return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
          });
          var companyCostGraphData = scope.companyCostGraphData.filter(function (x) {
            return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
          });
          var profitGraphData = scope.profitGraphData.filter(function (x) {
            return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
          });
          var inventoryGraphData = scope.inventoryGraphData.filter(function (x) {
            return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
          });
          var allGraphData = scope.allGraphData.filter(function (x) {
            return new Date(graphStart) <= new Date(x.x) && new Date(x.x) <= new Date(graphEnd);
          });
          graphData.push({
            values: revenueGraphData,
            key: $filter('translate')("Revenue"),
            color: "#D71414",
            classed: "dashed",
            seriesIndex: 1,
            area: true
          });
          graphData.push({
            values: laborGraphData,
            key: $filter('translate')("Labour1"),
            color: "#2FA84F",
            classed: "dashed"
          });
          graphData.push({
            values: companyCostGraphData,
            key: $filter('translate')("Operating Cost"),
            color: "#4584E0",
            classed: "dashed"
          });
          graphData.push({
            values: inventoryGraphData,
            key: $filter('translate')("Inventory1"),
            color: "#99DDEB",
            classed: "dashed"
          });
          graphData.push({
            values: profitGraphData,
            key: $filter('translate')("Profit"),
            color: "#755FE2",
            classed: "dashed"
          });
          graphData.push({
            values: allGraphData,
            key: $filter('translate')("All Cost1"),
            color: "#FF7934",
            classed: "dashed",
            seriesIndex: 2,
            area: true
          });
          scope.hasGraphData = true;
          drawGraph();
        };

        scope.toggleSeriesOption = function () {
          scope.seriesOptionOpened = !scope.seriesOptionOpened;
        };

        scope.onShowSeries = function () {
          drawGraph();
        };

        scope.$on("onFilterChanged", function () {
          scope.filterData = filterStore.get();

          if (scope.filterData) {
            scope.onSelectType("custom");
          }
        });

        function prepareGraphBase(type) {
          var baseData = [];
          $log.log('start = ', scope.start);
          $log.log('end = ', scope.end); // let now = new Date(scope.start + (scope.end - scope.start) / 2);

          var now = new Date();
          $log.log('noew = ', now);

          if (type === "week") {
            var begin = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
            var end = now;

            for (var i = 0; i < 7; i++) {
              baseData.unshift({
                index: i,
                begin: new Date(begin),
                end: new Date(end),
                label: moment(begin).format("M-D")
              });
              end.setTime(begin.getTime() - 1);
              begin.setTime(begin.getTime() - 24 * 3600000);
            } // now = new Date(scope.start + (scope.end - scope.start) / 2);


            now = new Date();
            begin = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
            end = now;

            for (var _i = 0; _i < 7; _i++) {
              baseData.push({
                index: _i + 7,
                begin: new Date(begin),
                end: new Date(end),
                label: moment(begin).format("M-D")
              });
              end.setTime(begin.getTime() + 1000);
              begin.setTime(begin.getTime() + 24 * 3600000);
            }
          } else if (type === "month") {
            var _begin = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);

            var _end = now;

            for (var _i2 = 0; _i2 < 30; _i2++) {
              baseData.push({
                index: _i2 + 30,
                begin: new Date(_begin),
                end: new Date(_end),
                label: moment(_begin).format("M-D")
              });

              _end.setTime(_begin.getTime() + 1000);

              _begin.setTime(_begin.getTime() + 24 * 3600000);
            } // now = new Date(scope.start + (scope.end - scope.start) / 2);


            now = new Date();
            _begin = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
            _end = now;

            for (var _i3 = 0; _i3 < 30; _i3++) {
              _end.setTime(_begin.getTime() - 1000);

              _begin.setTime(_begin.getTime() - 24 * 3600000);

              baseData.unshift({
                index: _i3,
                begin: new Date(_begin),
                end: new Date(_end),
                label: moment(_begin).format("M-D")
              });
            }
          } else if (type == "year") {
            var _begin2 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);

            var _end2 = now;

            for (var _i4 = 0; _i4 < 365; _i4++) {
              baseData.push({
                index: _i4 + 365,
                begin: new Date(_begin2),
                end: new Date(_end2),
                label: moment(_begin2).format("M-D")
              });

              _end2.setTime(_begin2.getTime() + 1000);

              _begin2.setTime(_begin2.getTime() + 24 * 3600000);
            } // now = new Date(scope.start + (scope.end - scope.start) / 2);


            now = new Date();
            _begin2 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
            _end2 = now;

            for (var _i5 = 0; _i5 < 365; _i5++) {
              _end2.setTime(_begin2.getTime() - 1000);

              _begin2.setTime(_begin2.getTime() - 24 * 3600000);

              baseData.unshift({
                index: _i5,
                begin: new Date(_begin2),
                end: new Date(_end2),
                label: moment(_begin2).format("M-D")
              });
            }
          } else if (type == "custom") {
            var _now = new Date(scope.filterData.start);

            var _begin3 = new Date(_now.getFullYear(), _now.getMonth(), _now.getDate(), 0, 0, 0);

            var _end3 = _now;
            var idx = 0;

            while (_begin3 < new Date(scope.filterData.end)) {
              baseData.push({
                index: idx,
                begin: new Date(_begin3),
                end: new Date(_end3),
                label: moment(_begin3).format("M-D")
              });
              idx++;

              _end3.setTime(_begin3.getTime() + 1000);

              _begin3.setTime(_begin3.getTime() + 24 * 3600000);
            }

            _end3.setTime(_begin3.getTime() + 1000);

            _begin3.setTime(_begin3.getTime() + 24 * 3600000);

            baseData.push({
              index: idx,
              begin: new Date(_begin3),
              end: new Date(_end3),
              label: moment(_begin3).format("M-D")
            });
          }

          return baseData;
        }

        function drawGraph() {
          nv.addGraph(function () {
            var chart = nv.models.lineChart().margin({
              left: 100,
              right: 50
            }).useInteractiveGuideline(true).showLegend(true).showYAxis(true).showXAxis(true);
            chart.xTickFormat(function (d) {
              return moment(d).format("Y-M-D");
            });
            chart.yTickFormat(function (v) {
              return scope.getDisplayPrice(v);
            });
            d3.select("#eco-line-chart svg").html("");
            d3.select("#eco-line-chart svg").attr("height", 400).datum(graphData).call(chart);
            var linearGrad = d3.select("#eco-line-chart svg").append("linearGradient");
            linearGrad.attr("id", "grad3");
            linearGrad.attr("x1", "0%");
            linearGrad.attr("y1", "0%");
            linearGrad.attr("x2", "0%");
            linearGrad.attr("y2", "100%");
            linearGrad.html('<stop offset="0%" style="stop-color:#2FA84F;stop-opacity:1"/>' + '<stop offset="100%" style="stop-color:#ffffff;stop-opacity:0"/>'); // if (scope.type != "custom") {
            //   let axisContainer = d3.select(
            //     "#eco-line-chart svg .nv-background rect"
            //   );
            //   let rect = axisContainer.node().getBoundingClientRect();
            //   let width = rect.width / 2;
            //   d3.select("#eco-line-chart svg .nv-background")
            //     .append("g")
            //     .append("line")
            //     .attr("x1", width)
            //     .attr("y1", rect.height)
            //     .attr("x2", width)
            //     .attr("y2", 0)
            //     .style("stroke-width", 2)
            //     .style("stroke", "#1da1f2")
            //     .style("fill", "black");
            //   d3.select("#eco-line-chart svg .nv-background")
            //     .append("rect")
            //     .attr("x", 0)
            //     .attr("y", 0)
            //     .attr("width", width)
            //     .attr("height", rect.height)
            //     .attr("fill", "#f2f2f2");
            //   d3.select("#eco-line-chart svg .nv-background")
            //     .append("text")
            //     .attr("x", width + 5)
            //     .attr("y", 5)
            //     .attr("dy", "1em")
            //     .text("Today")
            //     .style("fill", "#1da1f2");
            // }

            nv.utils.windowResize(function () {
              chart.update();
            });
            return chart;
          });
        }

        scope.$watchGroup(["needRender"], function (newVals) {
          if (newVals) {
            scope.buildGraphData();
            scope.onSelectType(scope.type);
          }
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardEconomicCashflow", dashboardEconomicCashflow);

  function dashboardEconomicCashflow() {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-economic-cashflow/dashboard-economic-cashflow.view.html",
      replace: true,
      scope: {
        ngModel: '=',
        currency: '='
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.cash = {};
      scope.$watch('ngModel', function (newVal) {
        if (newVal) {
          initData(newVal);
        }
      });

      function initData(data) {
        scope.cash = data;
      }
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardCollaborationOffer", dashboardCollaborationOffer);

  function dashboardCollaborationOffer($state, $log, apiFactory, globals, Notification, utils, $filter) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-collaboration-offer/dashboard-collaboration-offer.view.html",
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc(scope) {
      var companyStore = globals.companyStore,
          userStore = globals.userStore,
          projectStore = globals.projectStore;
      scope.userData = userStore.get();
      scope.companyData = companyStore.get();
      scope.currentProject = projectStore.get();
      var supplier_page = $state.current.url.includes('supplier');
      var subContractor_page = $state.current.url.includes('subcontractor');
      scope.currentPage = supplier_page ? "supplier" : subContractor_page ? "subcontractor" : "bid/tender";
      scope.userRole = scope.userData.designation === "Admin" ? 1 : 0;
      if (scope.userRole == 1 && supplier_page) scope.userRole = 2;else if (scope.userRole == 1 && subContractor_page) scope.userRole = 3;
      scope.offers = [];
      scope.workTypes = [{
        _id: "Office",
        label: "Office"
      }, {
        _id: "wood",
        label: "Woodworking"
      }];
      scope.isCheckAll = false;
      scope.project = "all";
      scope.projects = [];
      scope.workType = undefined;
      scope.selSupplier = "all";
      scope.suppliers = [];
      scope.selSubContractor = "all";
      scope.subContractors = [];
      scope.loading = true;

      scope.selectSupplier = function () {
        var userIdFilter = [];
        if (scope.selSupplier != "all") userIdFilter.push(scope.selSupplier);
        if (scope.selSubContractor != "all") userIdFilter.push(scope.selSubContractor);
        userIdFilter = userIdFilter.length == 0 ? null : userIdFilter;
        var collaboratorType = scope.currentPage == "bid/tender" ? null : scope.userRole <= 2 ? 1 : 2;
        var query = {
          sort: 'createdAt',
          sortType: 'false',
          isTemplate: 'false',
          collaboratorType: collaboratorType,
          userIdFilter: userIdFilter,
          projectId: scope.project == "all" ? null : scope.project
        };
        Promise.all([apiFactory.getCollaborationOffers(query)]).then(function (resp) {
          scope.loading = false;
          var offers = resp[0].data.list || [];
          scope.colletoffers(offers);
        })["catch"](function (err) {
          scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.selectProject = function () {
        var query = {
          sort: 'createdAt',
          sortType: 'false',
          isTemplate: 'false',
          collaboratorType: scope.userRole <= 2 ? 1 : 2,
          userIdFilter: scope.selSupplier == "all" ? null : scope.selSupplier,
          projectId: scope.project == "all" ? null : scope.project
        };
        Promise.all([apiFactory.getCollaborationOffers(query)]).then(function (resp) {
          scope.loading = false;
          var offers = resp[0].data.list || [];
          scope.colletoffers(offers);
        })["catch"](function (err) {
          scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.editDcOffer = function (offer, lv, index) {
        offer.editData = {
          level: lv.level,
          days: lv.days,
          index: index
        };
      };

      scope.getAllSuppliers = function () {
        scope.loading = true;
        apiFactory.getAllSupplierName({}).then(function (resp) {
          scope.suppliers = resp.data.list;
          scope.suppliers.unshift({
            _id: 'all',
            name: $filter('translate')("All Suppliers")
          });
          scope.loading = false;
        })["catch"](function (err) {
          scope.loading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.getAllSubcontractors = function () {
        scope.loading = true;
        apiFactory.getAllSubcontractorName({}).then(function (resp) {
          scope.subContractors = resp.data.list;
          scope.subContractors.unshift({
            _id: 'all',
            name: $filter('translate')("All Subcontractors")
          });
          scope.loading = false;
        })["catch"](function (err) {
          scope.loading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope["goto"] = function (page) {
        $state.go(page);
      };

      if (scope.currentPage == "bid/tender") {
        scope.getAllSuppliers();
        scope.getAllSubcontractors();
      } else {
        if (scope.userRole == 2) scope.getAllSuppliers();
        if (scope.userRole == 3) scope.getAllSubcontractors();
      }

      scope.getAllProjectList = function () {
        scope.loading = true;
        apiFactory.listAllProjectNames().then(function (resp) {
          scope.projects = resp.data.list;
          scope.projects.unshift({
            _id: 'all',
            projectName: $filter('translate')("All Projects")
          });
          scope.loading = false;
        })["catch"](function (err) {
          scope.loading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.getAllProjectList();

      scope.cancelEdit = function (offer) {
        delete offer.editData;
      };

      scope.getOfferDays = function (offer) {
        var days = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            days += parseInt(lv.days);
          });
        });
        return days;
      };

      scope.getOfferAmount = function (offer) {
        var amount = 0;
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (lv) {
            amount += parseFloat(lv.amount);
          });
        });
        return amount;
      };

      scope.getlevelcount = function (offer) {
        var cnt = 0;
        offer.groups.forEach(function (group) {
          cnt += group.levels.length;
        });
        return cnt;
      };

      scope.gettotallevels = function (project) {
        var value = 0;

        for (var j = 0; j < project.bids.length; j++) {
          if (project.bids[j].offers[0].status == "Accepted") {
            project.bids[j].offers[0].groups.forEach(function (group) {
              value += scope.getlevelcount(group.levels);
            });
          }
        }

        return value;
      };

      scope.gettotaldays = function (project) {
        var value = 0;

        for (var j = 0; j < project.bids.length; j++) {
          if (project.bids[j].offers[0].status == "Accepted") value += scope.getOfferDays(project.bids[j].offers[0]);
        }

        return value;
      };

      scope.gettotalamounts = function (project) {
        var value = 0;

        for (var j = 0; j < project.bids.length; j++) {
          if (project.bids[j].offers[0].status == "Accepted") value += scope.getOfferAmount(project.bids[j].offers[0]);
        }

        return value;
      };

      scope.getOfferStatusClass = function (status) {
        switch (status) {
          case 'Pending':
            return {
              'on-hold': true
            };

          case 'Not Received':
            return {
              'Not Received': true
            };

          case 'Accepted':
            return {
              'Accepted': true
            };

          case 'Declined':
            return {
              'Declined': true
            };

          case 'Paused':
            return {
              'Paused': true
            };

          default:
            return {
              'on-hold': true
            };
        }
      };

      scope.getprojectStatuscss = function (status) {
        switch (status) {
          case 'OFFER':
            return {
              'completed': true
            };

          case 'ONGOING':
            return {
              'pending': true
            };

          case 'COMPLETED':
            return {
              'Accepted': true
            };

          case 'CANCEL':
            return {
              'Declined': true
            };

          case 'LOST':
            return {
              'lost': true
            };

          case 'POSTPONED':
            return {
              'Declined': true
            };

          case 'PRECAST':
            return {
              'lost': true
            };

          default:
            return {
              'OFFER': true
            };
        }
      };

      scope.getWorkTypes = function (workTypes) {
        if (workTypes) {
          return workTypes.map(function (x) {
            return x.tagName;
          }).join(", ");
        }
      };

      scope.getprojectStatus = function (status) {
        switch (status) {
          case 0:
            return "OFFER";

          case 1:
            return 'ONGOING';

          case 2:
            return "COMPLETED";

          case 3:
            return "CANCEL";

          case 4:
            return "LOST";

          case 5:
            return "POSTPONED";

          case 6:
            return "PRECAST";

          default:
            return "PRECAST";
        }
      };

      scope.updateofferstatus = function (offer, status) {
        offer.status = status;
        apiFactory.updateCollaborationOffer(offer).then(function () {
          Notification.success('Offer updated successfully.');
        })["catch"](function (error) {
          $log.error(error);

          if (error.data && error.data.message) {
            Notification.error(error.data.message);
          } else {
            Notification.error('Something was wrong.');
          }
        });
      };

      scope.colletoffers = function (offers) {
        var source = offers.filter(function (x) {
          // x.projectId._id == scope.currentProject._id
          if (scope.currentPage == 'supplier') {
            if (scope.currentProject._id == 'all') {
              return x.bidPackageId.vendorType == 0;
            } else {
              return x.projectId._id == scope.currentProject._id && x.bidPackageId.vendorType == 0;
            }
          } else if (scope.currentPage == 'subcontractor') {
            if (scope.currentProject._id == 'all') {
              return x.bidPackageId.vendorType != 0;
            } else {
              return x.projectId._id == scope.currentProject._id && x.bidPackageId.vendorType != 0;
            }
          } else {
            if (scope.currentProject._id == 'all') {
              return true;
            } else {
              return x.projectId._id == scope.currentProject._id;
            }
          }
        });
        $log.log(source);
        scope.offers = source; // let projectObj = [] ;
        // let projectlist = [] ;
        // for(let i = 0 ; i < source.length ; i++){
        //   if(!projectlist.includes(source[i].projectId._id)){
        //     projectlist.push(source[i].projectId._id) ;
        //     projectObj.push({
        //       bids : [],
        //       name : source[i].projectId.projectName,
        //       id : source[i].projectId._id,
        //       projectId : source[i].projectId.systemTag,
        //       projectName : source[i].projectId.projectName,
        //       workType : source[i].projectId.buildingType.tagName,
        //       status : source[i].projectId.projectStatus,
        //       checked : false,
        //       expanded : false,
        //     }) ;
        //   }
        // }
        // for(let i = 0 ; i < projectObj.length ; i++){            
        //   let tempbidlist = [] ;
        //   for(let j = 0 ; j < source.length ; j++){
        //     if(projectObj[i].id == source[j].projectId._id && !tempbidlist.includes(source[j].name)){
        //       tempbidlist.push(source[j].name) ;
        //       let tempbidObj = {
        //         offers : [],
        //         bid: source[j].bidPackageId._id,
        //         name : source[j].name,
        //         bidPackage: source[j].bidPackageId.title,
        //         status: source[j].status,
        //       };            
        //       projectObj[i].bids.push(tempbidObj);
        //       $log.log(tempbidlist);
        //     }
        //   } 
        // }          
        // for(let i = 0 ; i < projectObj.length ; i++){
        //   for(let j = 0 ; j < projectObj[i].bids.length ; j++){
        //     for(let k = 0 ; k < source.length ; k++){
        //       if(scope.currentPage == "bid/tender" && projectObj[i].bids[j].name == source[k].name){
        //         if(projectObj[i].bids[j].offers.length == 0)
        //           projectObj[i].bids[j].offers.push(source[k]);
        //       }else{
        //         if(projectObj[i].bids[j].name == source[k].name){
        //           projectObj[i].bids[j].offers.push(source[k]);
        //         }
        //       }
        //     }
        //   }
        // }
        // $log.log('offers = ', projectObj);
        // $log.log("currentProject = ", scope.currentProject)
        // scope.offers = projectObj.filter(x => x.id == scope.currentProject._id);
      };

      var query = {
        sort: 'createdAt',
        sortType: 'false',
        isTemplate: 'false',
        collaboratorType: scope.currentPage == "bid/tender" ? null : scope.userRole <= 2 ? 1 : 2
      };
      Promise.all([apiFactory.getCollaborationOffers(query)]).then(function (resp) {
        scope.loading = false; // scope.offers = resp[0].data.list || [];

        scope.colletoffers(resp[0].data.list);
      })["catch"](function (err) {
        scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('dashboardBudgetGroup', {
    controller: DashboardBudgetGroupController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/directives/dashboard-budget-block/dashboard-budget-group.view.html',
    bindings: {
      type: '=',
      ngModel: "<",
      currency: "="
    }
  });

  function DashboardBudgetGroupController($filter) {
    var vm = this;
    vm.filters = [{
      groups: [],
      groupId: undefined,
      group: undefined
    }];
    vm.budget = [];
    vm.level = undefined;

    vm.$onChanges = function (changes) {
      if (changes.ngModel) {
        vm.filters[0].groups = vm.ngModel;
        vm.filters[0].groupId = 'all';

        switch (vm.type) {
          case 'all':
            vm.groupTypeName = $filter('translate')('Budget Name');
            break;

          case 'mat':
            vm.groupTypeName = $filter('translate')('Material Group');
            break;

          case 'eqp':
            vm.groupTypeName = $filter('translate')('Equipment Group');
            break;

          case 'lab':
            vm.groupTypeName = $filter('translate')('Material Group');
            break;

          case 'sup':
            vm.groupTypeName = $filter('translate')('Supplier Name');
            break;

          case 'sub':
            vm.groupTypeName = $filter('translate')('Sub-Contractor Name');
            break;
        }

        vm.selectGroup(vm.filters[0], 0);
      }
    };

    vm.isLabor = function (budget) {
      return budget.type === 'lab' || vm.type === 'lab';
    };

    vm.isEquipment = function (budget) {
      return budget.type === 'eqp' || vm.type === 'eqp';
    };

    vm.selectGroup = function (filter, index) {
      if (!filter.groups) return;
      filter.group = filter.groups.find(function (x) {
        return x._id === filter.groupId;
      });

      if (vm.filters.length > index + 1) {
        vm.filters.splice(index + 1, vm.filters.length - index - 1);
      }

      if (filter.groupId !== 'all' && filter.group.levels && filter.group.levels.length > 0) {
        var newFilter = {
          groups: [{
            _id: 'all',
            name: $filter('translate')('All'),
            budgets: filter.group.budgets
          }],
          groupId: 'all'
        };
        filter.group.levels.forEach(function (level) {
          return newFilter.groups.push(level);
        });
        newFilter.group = newFilter.groups[0];
        vm.filters.push(newFilter);
      }

      vm.level = filter.group;
      vm.budget = getBudget(vm.level, vm.type);
    };

    function getBudget(group, budgetType) {
      switch (budgetType) {
        case 'mat':
          return group.budgets.material;

        case 'eqp':
          return group.budgets.equipment;

        case 'lab':
          return group.budgets.labor;

        case 'sup':
          return group.budgets.supplier;

        case 'sub':
          return group.budgets.subcontractor;

        default:
          return [];
      }
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardBudgetBlock", dashboardBudgetBlock);

  function dashboardBudgetBlock($log, apiFactory, globals, Notification, utils, $filter) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-budget-block/dashboard-budget-block.view.html",
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc(scope) {
      var projectStore = globals.projectStore;
      scope.tabs = [{
        id: 'mat',
        name: $filter('translate')("Materials")
      }, {
        id: 'sup',
        name: $filter('translate')("Supplier")
      }, {
        id: 'lab',
        name: $filter('translate')("Labour Cost")
      }, {
        id: 'sub',
        name: $filter('translate')("Sub-Contractor")
      }, {
        id: 'eqp',
        name: $filter('translate')("Equipments")
      }];
      var project = projectStore.get();

      if (!project || project._id === 'all') {
        return;
      }

      var materials = [];
      var equipments = [];
      scope.isLoading = true;
      Promise.all([apiFactory.getCalcSheet(project._id), apiFactory.listAllMaterials(), apiFactory.listAllEquipments()]).then(function (resp) {
        var sheet = resp[0].data.data;
        materials = resp[1].data.list;
        equipments = resp[2].data.list;
        scope.isLoading = false;
        var sheetMap = {
          material: {},
          labor: {},
          equipment: {},
          supplier: {},
          subcontractor: {}
        };
        scope.budgets = [{
          _id: 'all',
          name: $filter('translate')("All"),
          levels: []
        }];

        if (sheet.levels) {
          sheet.levels.forEach(function (level) {
            arrangeBudgetLevel(level, sheetMap);
            scope.budgets[0].levels.push(level);
            scope.budgets.push(level);
          });
        }

        fillLevelBudget(scope.budgets[0], sheetMap);
        scope.companyCurrency = sheet.companyCurrency;
      })["catch"](function (err) {
        scope.isLoading = false;
        $log.error(err);
        Notification.error('There is error during load budgets.');
      });

      function arrangeBudgetLevel(level, budgetMap) {
        var levelMap = {
          material: {},
          labor: {},
          equipment: {},
          supplier: {},
          subcontractor: {}
        };

        if (level.items && level.items.length > 0) {
          level.items.forEach(function (item) {
            arrangeBudgetItem(item, levelMap);
            arrangeBudgetItem(item, budgetMap);
          });
        }

        if (level.levels && level.levels.length > 0) {
          level.levels.forEach(function (subLevel) {
            arrangeBudgetLevel(subLevel, levelMap);
            arrangeBudgetLevel(subLevel, budgetMap);
          });
        }

        fillLevelBudget(level, levelMap);

        if (angular.isUndefined(level.sumN)) {
          level.sumN = level.sum;
          level.sumProfitN = 0;
        } else {
          level.sumProfitN = level.sumN - level.sum;
        }

        level.sumNOld = level.sumN;
      }

      function arrangeBudgetItem(item, budgetMap) {
        item.salesPriceN = item.salesPriceNOld ? item.salesPriceNOld : item.inventoryCostPrice;
        item.workersPriceN = item.workersPriceNOld ? item.workersPriceNOld : item.workerCostPrice;
        item.inventoryProfitN = item.inventoryCostPrice - item.salesPriceN;
        item.workerProfitN = item.workerCostPrice - item.workersPriceN;

        if (item.items && item.items.length > 0) {
          item.items.forEach(function (subItem) {
            return arrangeBudgetItem(subItem, budgetMap);
          });
        } else {
          if (item.rowStyle !== 'Worker' && item.rowStyle !== 'Subcontractor') {
            var supplierId = 'unknown';
            var supplierName = 'No Supplier';

            if (item.matID) {
              if (item.inventoryType === 'Material') {
                var material = materials.find(function (x) {
                  return x._id === item.matID;
                });

                if (material) {
                  if (material.groupId && material.groupId._id) {
                    var matItem = budgetMap.material[material.groupId._id];

                    if (!matItem) {
                      matItem = {
                        _id: material.groupId._id,
                        name: material.groupId.name,
                        items: [],
                        expand: false,
                        costPrice: 0,
                        calculatedPrice: 0,
                        negotiatedPrice: 0,
                        profitPercent: 0,
                        profit: 0,
                        profitN: 0
                      };
                      budgetMap.material[material.groupId._id] = matItem;
                    }

                    matItem.items.push(item);
                    matItem.costPrice += item.inventoryCostPrice;
                    matItem.calculatedPrice += item.salesPrice;
                    matItem.negotiatedPrice += item.salesPriceN;
                    matItem.profit += item.inventoryProfit;
                    matItem.profitN += item.inventoryProfitN;
                  }

                  if (material.supplier && material.supplier._id) {
                    supplierId = material.supplier._id;
                    supplierName = material.supplier.name;
                  }
                }
              } else if (item.inventoryType === 'Equipment') {
                var equipment = equipments.find(function (x) {
                  return x._id === item.matID;
                });

                if (equipment) {
                  if (equipment.groupId && equipment.groupId._id) {
                    var eqpItem = budgetMap.equipment[equipment.groupId._id];

                    if (!eqpItem) {
                      eqpItem = {
                        _id: equipment.groupId._id,
                        name: equipment.groupId.name,
                        items: [],
                        expand: false,
                        costPrice: 0,
                        calculatedPrice: 0,
                        negotiatedPrice: 0,
                        profitPercent: 0,
                        profit: 0,
                        profitN: 0
                      };
                      budgetMap.equipment[equipment.groupId._id] = eqpItem;
                    }

                    item.rentalPeriod = 0;
                    item.workerCost = 0;
                    item.deliveryCost = utils.num(equipment.deliveryCost);
                    item.deliveryUnit = equipment.unit;

                    if (equipment.currentRate && equipment.currentRate.rooferCost) {
                      item.workerCost = utils.num(equipment.currentRate.rooferCost.value);
                    }

                    if (equipment.owned) {
                      item.rentalPeriod = Math.ceil(Math.random() * 10);
                    }

                    eqpItem.items.push(item);
                    eqpItem.costPrice += item.inventoryCostPrice;
                    eqpItem.calculatedPrice += item.salesPrice;
                    eqpItem.negotiatedPrice += item.salesPriceN;
                    eqpItem.profit += item.inventoryProfit;
                    eqpItem.profitN += item.inventoryProfitN;
                  }

                  if (equipment.supplier && equipment.supplier._id) {
                    supplierId = equipment.supplier._id;
                    supplierName = equipment.supplier.name;
                  }
                }
              }
            }

            var supItem = budgetMap.supplier[supplierId];

            if (!supItem) {
              supItem = {
                _id: supplierId,
                name: supplierName,
                items: [],
                expand: false,
                costPrice: 0,
                calculatedPrice: 0,
                negotiatedPrice: 0,
                profitPercent: 0,
                profit: 0,
                profitN: 0
              };
              budgetMap.supplier[supplierId] = supItem;
            }

            supItem.items.push(item);
            supItem.costPrice += item.inventoryCostPrice;
            supItem.calculatedPrice += item.salesPrice;
            supItem.negotiatedPrice += item.salesPriceN;
            supItem.profit += item.inventoryProfit;
            supItem.profitN += item.inventoryProfitN;
          }

          if (item.rowStyle === 'Combined' || item.rowStyle === 'Worker') {
            var id = 'unknown';
            var name = 'No Material';

            if (item.rowStyle === 'Combined' && item.matID) {
              if (item.inventoryType === 'Material') {
                var _material = materials.find(function (x) {
                  return x._id === item.matID;
                });

                if (_material && _material.groupId && _material.groupId._id) {
                  id = _material.groupId._id;
                  name = _material.groupId.name;
                }
              } else if (item.inventoryType === 'Equipment') {
                var _equipment = equipments.find(function (x) {
                  return x._id === item.matID;
                });

                if (_equipment && _equipment.groupId && _equipment.groupId._id) {
                  id = _equipment.groupId._id;
                  name = _equipment.groupId.name;
                }
              }
            }

            var labItem = budgetMap.labor[id];

            if (!labItem) {
              labItem = {
                _id: id,
                name: name,
                items: [],
                expand: false,
                costPrice: 0,
                calculatedPrice: 0,
                negotiatedPrice: 0,
                profitPercent: 0,
                profit: 0,
                profitN: 0
              };
              budgetMap.labor[id] = labItem;
            }

            labItem.items.push(item);
            labItem.costPrice += item.workerCostPrice;
            labItem.calculatedPrice += item.workersPrice;
            labItem.negotiatedPrice += item.workersPriceN;
            labItem.profit += item.workerProfit;
            labItem.profitN += utils.num(item.workerProfitN);
          } else if (item.rowStyle === 'Subcontractor') {
            var sucItem = budgetMap.subcontractor[item._id];

            if (!sucItem) {
              sucItem = {
                _id: item._id,
                name: item.workerName,
                items: [],
                expand: false,
                costPrice: 0,
                calculatedPrice: 0,
                negotiatedPrice: 0,
                profitPercent: 0,
                profit: 0,
                profitN: 0
              };
              budgetMap.subcontractor[item._id] = sucItem;
            }

            sucItem.items.push(item);
            sucItem.costPrice += item.inventoryCostPrice;
            sucItem.calculatedPrice += item.salesPrice;
            sucItem.negotiatedPrice += item.salesPriceN;
            sucItem.profit += item.inventoryProfit;
            sucItem.profitN += utils.num(item.inventoryProfitN);
          }
        }
      }

      function fillLevelBudget(level, budgetMap) {
        level.budgets = {
          material: {
            budgets: [],
            name: 'Material',
            type: 'mat',
            subName: 'Material Name',
            expand: false
          },
          labor: {
            budgets: [],
            name: 'Labour',
            type: 'lab',
            subName: 'Task Name',
            expand: false
          },
          equipment: {
            budgets: [],
            name: 'Equipment',
            type: 'eqp',
            subName: 'Equipment Name',
            expand: false
          },
          supplier: {
            budgets: [],
            name: 'Supplier',
            type: 'sup',
            subName: 'Material Name',
            expand: false
          },
          subcontractor: {
            budgets: [],
            name: 'Sub-Contractor',
            type: 'sub',
            subName: 'Task Name',
            expand: false
          },
          all: {
            budgets: [],
            type: 'all'
          }
        };
        fillBudgetFromMap(level.budgets.material, budgetMap.material);
        fillBudgetFromMap(level.budgets.labor, budgetMap.labor);
        fillBudgetFromMap(level.budgets.equipment, budgetMap.equipment);
        fillBudgetFromMap(level.budgets.supplier, budgetMap.supplier);
        fillBudgetFromMap(level.budgets.subcontractor, budgetMap.subcontractor);
        calculateSum(level.budgets.material);
        calculateSum(level.budgets.labor);
        calculateSum(level.budgets.equipment);
        calculateSum(level.budgets.supplier);
        calculateSum(level.budgets.subcontractor);
        fillAll(level.budgets);
      }

      function fillBudgetFromMap(budget, map) {
        for (var key in map) {
          var item = map[key];

          if (item) {
            optimizeBudgetItem(item);
            item.type = budget.type;
            budget.budgets.push(item);
          }
        }
      }

      function calculateSum(budgetLevel) {
        budgetLevel.costPrice = 0;
        budgetLevel.calculatedPrice = 0;
        budgetLevel.negotiatedPrice = 0;
        budgetLevel.negotiatedPriceOld = 0;
        budgetLevel.profitPercent = 0;
        budgetLevel.profit = 0;
        budgetLevel.profitN = 0;
        budgetLevel.profitNPercent = 0;
        budgetLevel.budgets.forEach(function (budget) {
          budget.profitPercent = budget.calculatedPrice === 0 ? 0 : budget.profit / budget.calculatedPrice * 100;
          budgetLevel.costPrice += budget.costPrice;
          budgetLevel.calculatedPrice += budget.calculatedPrice;
          budgetLevel.negotiatedPrice += budget.negotiatedPrice;
          budgetLevel.profit += budget.profit;
          budgetLevel.profitN += budget.profitN;
        });
        budgetLevel.profitPercent = budgetLevel.calculatedPrice === 0 ? 0 : budgetLevel.profit / budgetLevel.calculatedPrice * 100;
        budgetLevel.profitNPercent = budgetLevel.negotiatedPrice === 0 ? 0 : budgetLevel.profitN / budgetLevel.negotiatedPrice * 100;
        budgetLevel.negotiatedPriceOld = budgetLevel.negotiatedPrice;
      }

      function fillAll(allBudget) {
        allBudget.all.costPrice = 0;
        allBudget.all.calculatedPrice = 0;
        allBudget.all.negotiatedPrice = 0;
        allBudget.all.negotiatedPriceOld = 0;
        allBudget.all.profitPercent = 0;
        allBudget.all.profit = 0;
        allBudget.all.profitN = 0;
        allBudget.all.profitNPercent = 0;
        var keys = ['material', 'supplier', 'labor', 'subcontractor', 'equipment'];

        for (var i = 0; i < keys.length; i++) {
          var budget = allBudget[keys[i]];

          if (budget.budgets.length > 0) {
            allBudget.all.budgets.push(budget);

            if (keys[i] !== 'material' && keys[i] !== 'equipment') {
              allBudget.all.costPrice += budget.costPrice;
              allBudget.all.calculatedPrice += budget.calculatedPrice;
              allBudget.all.negotiatedPrice += budget.negotiatedPrice;
              allBudget.all.profit += budget.profit;
              allBudget.all.profitN += budget.profitN;
            }
          }
        }

        allBudget.all.profitPercent = allBudget.all.calculatedPrice === 0 ? 0 : allBudget.all.profit / allBudget.all.calculatedPrice * 100;
        allBudget.all.profitNPercent = allBudget.all.negotiatedPrice === 0 ? 0 : allBudget.all.profitN / allBudget.all.negotiatedPrice * 100;
        allBudget.all.negotiatedPriceOld = allBudget.all.negotiatedPrice;
      }

      function optimizeBudgetItem(budget) {
        var matMap = {};
        budget.items.forEach(function (subItem) {
          var matId = subItem.matID ? subItem.matID : utils.bsonId();
          var matItem = matMap[matId];

          if (!matItem) {
            matMap[matId] = subItem;
          } else {
            if (!matItem.subItems) {
              matItem = {
                matID: matItem.matID,
                inventoryType: matItem.inventoryType,
                inventoryName: matItem.inventoryName,
                workerID: matItem.workerID,
                workerName: matItem.workerName,
                inventoryUnit: matItem.inventoryUnit,
                workerUnit: matItem.workerUnit,
                inventoryUnitPrice: matItem.inventoryUnitPrice,
                workerUnitPrice: matItem.workerUnitPrice,
                wastePercent: matItem.wastePercent,
                workerCompanyCost: matItem.workerCompanyCost,
                inventoryCompanyCost: matItem.inventoryCompanyCost,
                labourHours: matItem.labourHours,
                inventoryCostPrice: matItem.inventoryCostPrice,
                workerCostPrice: matItem.workerCostPrice,
                inventoryAmount: matItem.inventoryAmount,
                workerAmount: matItem.workerAmount,
                inventoryProfit: matItem.inventoryProfit,
                workerProfit: matItem.workerProfit,
                inventoryProfitPercent: matItem.inventoryProfitPercent,
                workerProfitPercent: matItem.workerProfitPercent,
                inventoryProfitN: matItem.inventoryProfitN,
                workerProfitN: matItem.workerProfitN,
                salesPrice: matItem.salesPrice,
                workersPrice: matItem.workersPrice,
                salesPriceN: matItem.salesPriceN,
                workersPriceN: matItem.workersPriceN,
                subItems: [matItem],
                modelId: matItem.modelId,
                objectId: matItem.objectId,
                modelType: matItem.modelType
              };
              matMap[matId] = matItem;
            }

            matItem.subItems.push(subItem);
            matItem.salesPrice += subItem.salesPrice;
            matItem.workersPrice += subItem.workersPrice;
            matItem.salesPriceN += subItem.salesPriceN;
            matItem.workersPriceN += subItem.workersPriceN;
            matItem.workerCompanyCost += subItem.workerCompanyCost;
            matItem.inventoryCompanyCost += subItem.inventoryCompanyCost;
            matItem.labourHours += subItem.labourHours;
            matItem.inventoryCostPrice += subItem.inventoryCostPrice;
            matItem.workerCostPrice += subItem.workerCostPrice;
            matItem.inventoryAmount += subItem.inventoryAmount;
            matItem.workerAmount += subItem.workerAmount;
            matItem.inventoryProfit += subItem.inventoryProfit;
            matItem.workerProfit += subItem.workerProfit;
            matItem.inventoryProfitN += subItem.inventoryProfitN;
            matItem.workerProfitN += subItem.workerProfitN;
          }
        });
        budget.items = [];

        for (var key in matMap) {
          if (matMap[key]) {
            budget.items.push(matMap[key]);
          }
        }

        budget.negotiatedPriceOld = budget.negotiatedPrice;
      }
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardBidTenderBlock", dashboardBidTenderBlock);

  function dashboardBidTenderBlock($log, apiFactory, globals, $filter) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-bid-tender-block/dashboard-bid-tender-block.view.html",
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc(scope) {
      var companyStore = globals.companyStore;
      scope.companyData = companyStore.get();
      scope.years = [{
        year: 2015
      }, {
        year: 2016
      }, {
        year: 2017
      }, {
        year: 2018
      }, {
        year: 2019
      }, {
        year: 2020
      }, {
        year: 2021
      }, {
        year: 2022
      }, {
        year: 2023
      }, {
        year: 2024
      }, {
        year: 2025
      }, {
        year: 2026
      }, {
        year: 2027
      }, {
        year: 2028
      }, {
        year: 2029
      }, {
        year: 2030
      }, {
        year: 2031
      }, {
        year: 2032
      }, {
        year: 2033
      }, {
        year: 2034
      }, {
        year: 2035
      }, {
        year: 2036
      }, {
        year: 2037
      }, {
        year: 2038
      }, {
        year: 2039
      }, {
        year: 2040
      }, {
        year: 2041
      }, {
        year: 2042
      }, {
        year: 2043
      }, {
        year: 2044
      }, {
        year: 2045
      }];
      scope.projectTypes = [{
        label: 'Offer',
        value: 0
      }, {
        label: 'OnGoing',
        value: 1
      }, {
        label: 'Completed',
        value: 2
      }, {
        label: 'Cancel',
        value: 3
      }, {
        label: 'Lost',
        value: 4
      }, {
        label: 'Postponed',
        value: 5
      }, {
        label: 'Precast',
        value: 6
      }];
      scope.year = new Date().getFullYear();
      scope.totalAmount = 0;
      scope.percent = 0;
      scope.offerCount = 0;
      scope.projectType = 0;
      scope.items = [{
        label: $filter('translate')("Contract"),
        amount: 0,
        percent: 0,
        color: "#6fcf97"
      }, {
        label: $filter('translate')("Precast"),
        amount: 0,
        percent: 0,
        color: "#ffbc25"
      }, {
        label: $filter('translate')("Completed"),
        amount: 0,
        percent: 0,
        color: "#2f80ed"
      }, {
        label: $filter('translate')("Lost"),
        amount: 0,
        percent: 0,
        color: "#eb5757"
      }];
      var offers = [];
      scope.loading = true;
      apiFactory.listAllOffers({}).then(function (resp) {
        scope.loading = false;
        offers = resp.data.list || [];
        calcValues(offers);
      })["catch"](function (err) {
        $log.error(err);
        scope.loading = false;
      });

      scope.getPercentStyle = function () {
        var value = scope.percent > 100 ? scope.percent - 100 : scope.percent;
        return {
          "stroke-dashoffset": 438 * (1 - value / 100)
        };
      };

      scope.getMarkStyle = function (item) {
        return {
          background: item.color
        };
      };

      scope.selectYear = function () {};

      scope.selectProjectType = function () {};

      function calcValues(offers) {
        var sum = 0;
        scope.percent = 0;
        scope.offerCount = offers.length;
        scope.items[0].amount = 0;
        scope.items[1].amount = 0;
        scope.items[2].amount = 0;
        scope.items[3].amount = 0;
        offers.forEach(function (offer) {
          sum += offer.offerTotal;
          var status = offer.projectId.projectStatus;

          if (status === 0 || status === 1) {
            scope.items[0].amount += offer.offerTotal;
          } else if (status === 6) {
            scope.items[1].amount += offer.offerTotal;
          } else if (status === 2) {
            scope.items[2].amount += offer.offerTotal;
          } else {
            scope.items[3].amount += offer.offerTotal;
          }
        });
        scope.items[0].percent = sum === 0 ? 0 : scope.items[0].amount * 100 / sum;
        scope.items[1].percent = sum === 0 ? 0 : scope.items[1].amount * 100 / sum;
        scope.items[2].percent = sum === 0 ? 0 : scope.items[2].amount * 100 / sum;
        scope.items[3].percent = sum === 0 ? 0 : scope.items[3].amount * 100 / sum;
        scope.totalAmount = sum;
        scope.percent = scope.items[0].percent;
      }
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardAuditRegulation", dashboardAuditRegulation);

  function dashboardAuditRegulation(globals, $log, Notification, apiFactory) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: "app/main/dashboard/directives/dashboard-audit-regulation/dashboard-audit-regulation.view.html",
      scope: {
        ngModel: '=',
        currency: '='
      },
      link: function link(scope) {
        var projectStore = globals.projectStore;
        scope.project = projectStore.get();
        scope.regulations = [{
          name: 'Labour Cost',
          editing: {
            amount: 0,
            percent: 0
          },
          calced: {
            amount: 0,
            percent: 0
          },
          budget: {
            amount: 0,
            percent: 0
          },
          status: {
            amount: 0,
            percent: 0
          },
          regulation: {
            amount: 0,
            percent: 0
          }
        }, {
          name: 'Inventory & Costs',
          editing: {
            amount: 0,
            percent: 0
          },
          calced: {
            amount: 0,
            percent: 0
          },
          budget: {
            amount: 0,
            percent: 0
          },
          status: {
            amount: 0,
            percent: 0
          },
          regulation: {
            amount: 0,
            percent: 0
          }
        }, {
          name: 'Sales',
          editing: {
            amount: 0,
            percent: 0
          },
          calced: {
            amount: 0,
            percent: 0
          },
          budget: {
            amount: 0,
            percent: 0
          },
          status: {
            amount: 0,
            percent: 0
          },
          regulation: {
            amount: 0,
            percent: 0
          }
        }, {
          name: 'Profit',
          editing: {
            amount: 0,
            percent: 0
          },
          calced: {
            amount: 0,
            percent: 0
          },
          budget: {
            amount: 0,
            percent: 0
          },
          status: {
            amount: 0,
            percent: 0
          },
          regulation: {
            amount: 0,
            percent: 0
          }
        }];
        scope.totalBudgetPercent = 0;
        scope.totalStatusPercent = 0;
        scope.totalWorkPercent = 0;
        scope.editingPercent = 0;
        scope.isShowWip = false;
        scope.isLoading = true;
        scope.hasStoredData = false;
        scope.storedId = '';
        apiFactory.getWipItem(scope.project._id).then(function (resp) {
          scope.isLoading = false;

          if (resp.data.data) {
            scope.editingPercent = angular.copy(resp.data.data.editingPercent);
            scope.regulations[0].editing = angular.copy(resp.data.data.labor);
            scope.regulations[1].editing = angular.copy(resp.data.data.inventory);
            scope.regulations[2].editing = angular.copy(resp.data.data.sales);
            scope.hasStoredData = true;
            scope.storedId = resp.data.data._id;
          }
        })["catch"](function (err) {
          $log.error(err);
          Notification.error('Something went wrong.');
          scope.isLoading = false;
        });
        scope.$watch('ngModel', function (newVal) {
          if (newVal) {
            $log.log(newVal);
            scope.data = newVal;
            scope.totalWorkPercent = newVal.progress * 100;
            if (!scope.hasStoredData) scope.editingPercent = newVal.progress * 100;
            initData(newVal);
          }
        });

        scope.toggleWip = function () {
          scope.isShowWip = !scope.isShowWip;
        };

        scope.changeTotalWorkPercent = function () {
          initData(scope.data);
        };

        scope.changeEditingAmount = function () {
          initData(scope.data);
        };

        scope.changeEditingPercent = function () {
          initData(scope.data);
        };

        scope.postWip = function () {
          if (scope.isLoading) {
            Notification.error('Processing Post Wip...');
            return;
          }

          scope.isLoading = true;
          apiFactory.postWip({
            storedId: scope.storedId,
            projectId: scope.project._id,
            workingPercent: scope.totalWorkPercent,
            editingPercent: scope.editingPercent,
            labor: scope.regulations[0].editing,
            inventory: scope.regulations[1].editing,
            sales: scope.regulations[2].editing,
            wip: {
              sales: scope.regulations[2].regulation.amount,
              proejctCost: scope.regulations[1].regulation.amount,
              labor: scope.regulations[0].regulation.amount + scope.regulations[0].editing.amount,
              contract: scope.totalWorkPercent * scope.regulations[2].calced.amount / 100,
              invoiced: scope.regulations[2].status.amount,
              wip: scope.totalWorkPercent * scope.regulations[2].calced.amount / 100 + scope.regulations[2].status.amount,
              assetsCost: scope.totalWorkPercent * (scope.regulations[1].calced.amount + scope.regulations[0].calced.amount) / 100 - (scope.totalWorkPercent * scope.regulations[2].calced.amount / 100 + scope.regulations[2].status.amount) - (scope.regulations[2].regulation.amount >= 0 ? -scope.regulations[2].regulation.amount : 0),
              balanceCost: -scope.totalWorkPercent * (scope.regulations[1].calced.amount + scope.regulations[0].calced.amount) / 100,
              upfront: scope.regulations[2].regulation.amount >= 0 ? -scope.regulations[2].regulation.amount : 0
            }
          }).then(function (resp) {
            Notification.success(resp.data.message);
            scope.isLoading = false;
          })["catch"](function (err) {
            $log.error(err);
            Notification.error('Something went wrong.');
            scope.isLoading = false;
          });
        };

        function initData(data) {
          var laborBudget = data.totalWorkerCost;
          var inventoryCostBudget = data.totalInventoryCost + data.totalCompanyCost;
          var salesBudget = data.totalSalesPrice;
          var labor = scope.regulations[0];
          var inventoryCost = scope.regulations[1];
          var sales = scope.regulations[2];
          var profit = scope.regulations[3];
          labor.editing.amount = -(scope.editingPercent - scope.totalWorkPercent) * laborBudget / 100;
          labor.editing.percent = scope.editingPercent;
          inventoryCost.editing.percent = inventoryCost.editing.amount / inventoryCost.calced.amount * 100;
          sales.editing.percent = sales.editing.amount / sales.calced.amount * 100;
          labor.calced.amount = laborBudget + labor.editing.amount;
          inventoryCost.calced.amount = inventoryCostBudget + inventoryCost.editing.amount;
          sales.calced.amount = salesBudget + sales.editing.amount;
          profit.calced.amount = sales.calced.amount - inventoryCost.calced.amount - labor.calced.amount;
          labor.calced.percent = labor.calced.amount / sales.calced.amount * 100;
          inventoryCost.calced.percent = inventoryCost.calced.amount / sales.calced.amount * 100;
          sales.calced.percent = 100;
          profit.calced.percent = profit.calced.amount / sales.calced.amount * 100;
          labor.status.amount = data.totalLaborCost;
          inventoryCost.status.amount = data.totalInventoryApprovedCost + data.totalCompanyRevCost;
          sales.status.amount = -data.totalInvoicedWithoutCredit;
          profit.status.amount = sales.status.amount + inventoryCost.status.amount + labor.status.amount;
          labor.status.percent = labor.status.amount / labor.calced.amount * 100;
          inventoryCost.status.percent = inventoryCost.status.amount / inventoryCost.calced.amount * 100;
          sales.status.percent = -sales.status.amount / sales.calced.amount * 100;
          profit.status.percent = -profit.status.amount / profit.calced.amount * 100;
          labor.regulation.amount = scope.totalWorkPercent * labor.calced.amount / 100 - labor.status.amount;
          inventoryCost.regulation.amount = scope.totalWorkPercent * inventoryCost.calced.amount / 100 - inventoryCost.status.amount;
          sales.regulation.amount = -(scope.totalWorkPercent * sales.calced.amount / 100) - sales.status.amount;
          profit.regulation.amount = sales.regulation.amount + inventoryCost.regulation.amount + labor.regulation.amount;
          labor.regulation.percent = labor.status.percent - scope.editingPercent;
          inventoryCost.regulation.percent = inventoryCost.status.percent - scope.editingPercent;
          sales.regulation.percent = sales.status.percent - sales.calced.percent;
          profit.regulation.percent = -profit.regulation.amount / sales.regulation.amount * 100;
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardAuditProjectBlock", dashboardAuditProjectBlock);

  function dashboardAuditProjectBlock(globals, ecoFactory, utils, $filter) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: "app/main/dashboard/directives/dashboard-audit-project-block/dashboard-audit-project-block.view.html",
      scope: {
        ngModel: '=',
        currency: '='
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      var companyStore = globals.companyStore;
      var companyData = companyStore.get();
      scope.viewModes = [{
        id: 'all',
        label: $filter('translate')('All')
      }, {
        id: 'service',
        label: 'Service'
      }];
      scope.viewMode = 'all';
      scope.isCheckAll = false;
      scope.totalContract = 0;
      scope.totalRegulation = 0;
      scope.totalProfit = 0;
      scope.totalPending = 0;
      scope.projects = [];
      var projectList = [];
      scope.$watch('ngModel', function (newVal) {
        if (newVal) {
          initData(newVal);
        }
      });

      scope.getProjectType = function (project) {
        return project.isServiceProject ? 'Service' : project.isTenderProject ? 'Tender' : 'Normal';
      };

      scope.selectViewMode = function (viewMode) {
        switch (viewMode) {
          case "all":
            scope.projects = projectList;
            break;

          case "service":
            scope.projects = projectList.filter(function (project) {
              return project.isServiceProject;
            });
            break;
        }

        var totalContract = 0;
        var totalRegulation = 0;
        var totalProfit = 0;
        var totalPending = 0;
        scope.projects.forEach(function (project) {
          totalContract += project.contract;
          totalProfit += project.profit;
          totalRegulation += project.regulation;
          totalPending += project.pending;
        });
        scope.totalContract = totalContract;
        scope.totalRegulation = totalRegulation;
        scope.totalProfit = totalProfit;
        scope.totalPending = totalPending;
      };

      function initData(data) {
        var totalContract = 0;
        var totalRegulation = 0;
        var totalProfit = 0;
        var totalPending = 0;
        projectList = [];
        var projects = data.projects;
        var invoices = data.invoices;
        var billings = data.billings;
        var payrolls = data.payrolls;
        var vaOrders = data.vaOrders;
        projects.forEach(function (project) {
          var cash = ecoFactory.getProjectEconomicValue(project, invoices, billings, payrolls, vaOrders, companyData.companyCost);
          var contract = 0;
          var profit = cash.totalProfitWithVAData;
          var regulationAmount = 0;

          if (project.calcSheet) {
            contract = utils.num(project.calcSheet.sumWithAdditionalCost);
          }

          if (project.audit && project.audit.regulation) {
            var regulation = project.audit.regulation;
            regulationAmount = regulation.profit.amount;
          }

          var invoiceTotal = 0;
          invoices.forEach(function (invoice) {
            if (invoice.projectId === project._id && invoice.status !== 'rejected') {
              invoiceTotal += utils.num(invoice.totalAmount);
            }
          });
          var projectItem = {
            projectName: project.projectName,
            systemTag: project.systemTag,
            projectStatus: project.projectStatus,
            isServiceProject: project.isServiceProject,
            isTenderProject: project.isTenderProject,
            manager: project.managers && project.managers[0] && project.managers[0].userId ? project.managers[0].userId.displayName : '',
            endDate: project.endDate,
            contract: contract,
            profit: profit,
            regulation: regulationAmount,
            pending: Math.max(0, contract - invoiceTotal)
          };
          projectList.push(projectItem);
          totalContract += projectItem.contract;
          totalProfit += projectItem.profit;
          totalRegulation += projectItem.regulation;
          totalPending += projectItem.pending;
        });
        scope.totalContract = totalContract;
        scope.totalRegulation = totalRegulation;
        scope.totalProfit = totalProfit;
        scope.totalPending = totalPending;
        scope.projects = projectList;
      }

      angular.element("#audit-project-table-footer-part").scroll(function () {
        angular.element("#audit-project-table-header-part").prop("scrollLeft", this.scrollLeft);
        angular.element("#audit-project-table-body-part").prop("scrollLeft", this.scrollLeft);
      });
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardAuditFinancialBlock", dashboardAuditFinancialBlock);

  function dashboardAuditFinancialBlock() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: "app/main/dashboard/directives/dashboard-audit-finanical-block/dashboard-audit-finanical-block.view.html",
      scope: {},
      link: function link(scope) {
        scope.items = [{
          name: 'Solvency Ratio',
          type: 'percent',
          color: 'blue',
          items: [{
            year: 2020,
            value: 40,
            status: 'Medium'
          }, {
            year: 2019,
            value: 41,
            status: 'Medium'
          }, {
            year: 2018,
            value: 34,
            status: 'Medium'
          }, {
            year: 2017,
            value: 42,
            status: 'Medium'
          }]
        }, {
          name: 'Liquidity Ratio',
          type: 'percent',
          color: 'orange',
          items: [{
            year: 2020,
            value: 160,
            status: 'Medium'
          }, {
            year: 2019,
            value: 158,
            status: 'Medium'
          }, {
            year: 2018,
            value: 155,
            status: 'Medium'
          }, {
            year: 2017,
            value: 154,
            status: 'Medium'
          }]
        }, {
          name: 'Financial Gearing',
          type: 'value',
          color: 'none',
          items: [{
            year: 2020,
            value: 2.11,
            status: 'N/A'
          }, {
            year: 2019,
            value: 1.11,
            status: 'N/A'
          }, {
            year: 2018,
            value: 1.74,
            status: 'N/A'
          }, {
            year: 2017,
            value: 1.19,
            status: 'N/A'
          }]
        }, {
          name: 'Operation Margin',
          type: 'percent',
          color: 'yellow',
          items: [{
            year: 2020,
            value: 10,
            status: 'Medium'
          }, {
            year: 2019,
            value: 9,
            status: 'Medium'
          }, {
            year: 2018,
            value: 11,
            status: 'Medium'
          }, {
            year: 2017,
            value: 10,
            status: 'Medium'
          }]
        }, {
          name: 'Return on Equity',
          type: 'percent',
          color: 'grey',
          items: [{
            year: 2020,
            value: 10,
            status: 'Medium'
          }, {
            year: 2019,
            value: 10,
            status: 'Medium'
          }, {
            year: 2018,
            value: 11,
            status: 'Medium'
          }, {
            year: 2017,
            value: 9,
            status: 'Medium'
          }]
        }];

        scope.getPercentStyle = function (item) {
          var value = item.items[0].value > 100 ? item.items[0].value - 100 : item.items[0].value;
          return {
            'stroke-dashoffset': 438 * (1 - value / 100)
          };
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardAuditCostBlock", dashboardAuditCostBlock);

  function dashboardAuditCostBlock(utils) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-audit-cost-block/dashboard-audit-cost-block.view.html",
      replace: true,
      scope: {
        ngModel: '=',
        currency: '='
      },
      link: function link(scope) {
        scope.costs = [{
          name: 'Labour Cost',
          overdueLabel: 'Overdue0',
          color: 'orange',
          budget: 0,
          current: 0,
          overdue: 0,
          progress: 0
        }, {
          name: 'Sub-Contractor Cost',
          overdueLabel: 'Overdue1',
          color: 'blue',
          budget: 0,
          current: 0,
          overdue: 0,
          progress: 0
        }, {
          name: 'Supplier Cost',
          overdueLabel: 'Overdue2',
          color: 'grey',
          budget: 0,
          current: 0,
          overdue: 0,
          progress: 0
        }];
        scope.budget = 0;
        scope.currentCostPercent = 0;
        scope.$watch('ngModel', function (newVal) {
          if (newVal) {
            initData(newVal);
          }
        });

        scope.getProgressStyle = function (cost) {
          return {
            width: cost.progress === 0 ? 0 : cost.progress * 100 + '%'
          };
        };

        scope.getCircleProgress = function (progress) {
          return {
            'stroke-dashoffset': 438 * (1 - progress)
          };
        };

        function initData(data) {
          var labor = scope.costs[0];

          if (data.project.calcSheet) {
            labor.budget = data.project.calcSheet.totalWorkerCost;
            labor.current = data.payrolls.reduce(function (acc, cur) {
              return acc + cur.workedSalary;
            }, 0);
            labor.overdue = Math.max(0, labor.current - labor.budget);
            labor.progress = labor.budget === 0 ? 0 : Math.min(1, labor.current / labor.budget);
            var subcontractor = scope.costs[1];
            subcontractor.budget = getSubcontractorBudget(data.project.calcSheet.levels);
            var supplier = scope.costs[2];
            supplier.budget = data.project.calcSheet.totalInventoryCost;
            data.billings.forEach(function (bill) {
              if (bill.vendorType === 'Supplier') {
                supplier.current += utils.num(bill.totalAmount);
              } else if (bill.vendorType === 'Subcontractor') {
                subcontractor.current += utils.num(bill.totalAmount);
              }
            });
            subcontractor.overdue = Math.max(0, subcontractor.current - subcontractor.budget);
            subcontractor.progress = labor.budget === 0 ? 0 : Math.min(1, subcontractor.current / subcontractor.budget);
            supplier.overdue = Math.max(0, supplier.current - supplier.budget);
            supplier.progress = labor.budget === 0 ? 0 : Math.min(1, supplier.current / supplier.budget);
            var budget = utils.num(data.project.calcSheet.sumWithAdditionalCost);
            scope.budget = angular.isDefined(data.project.calcSheet.sumN) ? budget - utils.num(data.project.calcSheet.sumN) : 0; // scope.currentCostPercent = (labor.current + subcontractor.current + supplier.current) / budget;

            scope.currentCostPercent = utils.num(data.project.progress); // scope.delayPercent = scope.currentCostPercent - utils.num(data.project.progress);

            if (scope.delayPercent < 0) {
              scope.delayPercent = 0;
            }

            var companyCost = utils.num(data.project.calcSheet.totalCompanyCost);
            scope.delayCost = scope.delayPercent * companyCost;
          }
        }

        function getSubcontractorBudget(levels) {
          var budget = 0;

          if (!levels || !levels.length) {
            return 0;
          }

          levels.forEach(function (level) {
            if (level.items) {
              level.items.forEach(function (item) {
                if (item.rowStyle === 'Subcontractor') {
                  budget += utils.num(item.inventoryCostPrice);
                }
              });
            }

            if (level.levels && level.levels.length > 0) {
              budget += getSubcontractorBudget(level.levels);
            }
          });
          return budget;
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardAuditChartBlock", dashboardAuditChartBlock);

  function dashboardAuditChartBlock(utils, $filter) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: "app/main/dashboard/directives/dashboard-audit-chart-block/dashboard-audit-chart-block.view.html",
      scope: {
        ngModel: '=',
        currency: '='
      },
      link: function link(scope) {
        scope.pieData = [];
        var barConfig = {
          type: "bar",
          barWidth: 12,
          scales: {
            bottom: {
              text: "month",
              grid: false
            },
            left: {
              maxTicks: 10,
              max: 100,
              min: 0,
              textTemplate: utils.unitize
            }
          },
          series: [{
            id: "A",
            value: $filter('translate')("Revenue"),
            color: "#ffbc25",
            fill: "#ffbc25",
            tooltipTemplate: tooltip
          }, {
            id: "B",
            value: $filter('translate')("Expense"),
            color: "#6082de",
            fill: "#6082de",
            tooltipTemplate: tooltip
          }, {
            id: "C",
            value: $filter('translate')("Operating Cost"),
            color: "#79c7f7",
            fill: "#79c7f7",
            tooltipTemplate: tooltip
          }, {
            id: "D",
            value: $filter('translate')("Labour Cost"),
            color: "#3dd598",
            fill: "#3dd598",
            tooltipTemplate: tooltip
          }],
          legend: {
            series: ["A", "B", "C", "D"],
            form: 'circle',
            halign: "center",
            valign: "bottom"
          }
        };
        var barChart = new dhx.Chart("bar-chart", barConfig);
        var pieChart = new dhx.Chart("pie-chart", {
          type: "pie",
          series: [{
            value: "value",
            color: "color",
            text: "",
            stroke: "#FFFFFF",
            strokeWidth: 2,
            tooltip: true,
            tooltipTemplate: tooltipPie
          }]
        });
        scope.periods = [// {id: 'project', name: 'Project Period'},
        {
          id: 'month3',
          name: '3 ' + $filter('translate')('Months')
        }, {
          id: 'month6',
          name: '6 ' + $filter('translate')('Months')
        }, {
          id: 'month12',
          name: '12 ' + $filter('translate')('Months')
        }];
        scope.barPeriod = 'month12';
        scope.piePeriod = 'month12';
        scope.totalIncome = 0;
        scope.totalExpense = 0;
        scope.totalProfit = 0;
        var totalIncomeNR = 0;
        var totalExpenseNR = 0;
        scope.$watch('ngModel', function (newVal) {
          if (newVal) {
            initData(newVal);
          }
        });
        scope.$watch('ngModel.regulation.labor.amount', function (newVal) {
          if (angular.isDefined(newVal)) {
            calcTotalValue();
          }
        });
        scope.$watch('ngModel.regulation.inventory.amount', function (newVal) {
          if (angular.isDefined(newVal)) {
            calcTotalValue();
          }
        });
        scope.$watch('ngModel.regulation.invoiced.amount', function (newVal) {
          if (angular.isDefined(newVal)) {
            calcTotalValue();
          }
        });

        scope.selectBarPeriod = function (period) {
          scope.totalIncome = 0;
          scope.totalExpense = 0;
          scope.totalProfit = 0;
          var count = 0;

          switch (period) {
            case 'project':
              count = 10;
              break;

            case 'month3':
              count = 3;
              break;

            case 'month6':
              count = 6;
              break;

            case 'month12':
              count = 12;
              break;
          }

          var barData = [];
          var now = new Date();
          var begin = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
          var end = now;
          var Month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          var maxVal = 10;
          var data = scope.ngModel;

          for (var i = 0; i < count; i++) {
            var income = 0;
            var expense = 0;
            var budgetPrice = 0;
            var budgetLabor = 0;

            if (data.invoices) {
              data.invoices.forEach(function (invoice) {
                if (invoice.status === 'rejected') return;
                var date = invoice.status === 'paid' ? new Date(invoice.paidAt) : new Date(invoice.createdAt);

                if (utils.timeInRange(date, begin, end)) {
                  var amount = utils.num(invoice.totalAmount);
                  income += amount;
                }
              });
            }

            if (data.billings) {
              data.billings.forEach(function (bill) {
                if (utils.timeInRange(new Date(bill.createdAt), begin, end)) {
                  expense += utils.num(bill.totalAmount);
                }
              });
            }

            if (data.payrolls) {
              data.payrolls.forEach(function (payroll) {
                if (utils.timeInRange(new Date(payroll.date), begin, end)) {
                  expense += payroll.workedSalary;
                }
              });
            }

            if (data.projects) {
              data.projects.forEach(function (project) {
                if (!project.calcSheet) return;
                var companyCost = utils.num(project.calcSheet.sum) * data.companyCost / 100;
                var projectDuration = project.endDate.getTime() - project.startDate.getTime();

                if (projectDuration > 0) {
                  var duration = utils.getDurationInRange(project.startDate, project.endDate, begin, end);

                  if (duration > 0) {
                    expense += companyCost * duration / projectDuration;
                  }
                }
              });
            }

            if (data.tasks) {
              data.tasks.forEach(function (task) {
                if (!task.startDate || !task.endDate) return;
                var price = utils.num(task.inventoryPrice);
                var labor = utils.num(task.laborPrice);
                if (price === 0 && labor === 0) return;
                var startDate = new Date(task.startDate);
                var endDate = new Date(task.endDate);
                var range = utils.getDurationInRange(startDate, endDate, begin, end);
                var duration = endDate.getTime() - startDate.getTime();

                if (range > 0) {
                  budgetPrice += duration === 0 ? price : price * range / duration;
                  budgetLabor += duration === 0 ? labor : labor * range / duration;
                }
              });
            }

            barData.unshift({
              'month': Month[begin.getMonth()],
              'Revenue': income,
              'Expense': expense,
              'Operating Cost': budgetPrice,
              'Labour Cost': budgetLabor
            });
            end.setTime(begin.getTime() - 1000);
            begin.setTime(end.getTime());
            begin.setDate(1);
            begin.setHours(0, 0, 0, 0);
            maxVal = Math.max(maxVal, income, expense, budgetLabor, budgetPrice);
          }

          barConfig.scales.left.max = maxVal;
          barChart.setConfig(barConfig);
          barChart.data.parse(barData);
        }; // scope.selectPiePeriod = function (period) {
        // }


        scope.getLegendColor = function (legend) {
          return {
            background: legend.color
          };
        };

        function initData(data) {
          scope.pieData = [];
          scope.selectBarPeriod(scope.barPeriod);
          totalIncomeNR = 0;
          totalExpenseNR = 0;
          totalIncomeNR = data.invoices.reduce(function (acc, cur) {
            return acc + (cur.status !== 'rejected' ? utils.num(cur.totalPrice) : 0);
          }, 0);
          totalExpenseNR = data.payrolls.reduce(function (acc, cur) {
            return acc + cur.workedSalary;
          }, 0);
          totalExpenseNR += data.billings.reduce(function (acc, cur) {
            return acc + (cur.status === 'approved' ? utils.num(cur.totalAmount) : 0);
          }, 0);

          if (data.projects) {
            var sheetData = {
              groups: {},
              total: 0
            };
            data.projects.forEach(function (project) {
              if (project.calcSheet) {
                if (data.materials && data.equipments) {
                  arrangeSheetLevel(sheetData, project.calcSheet);
                }

                var date = new Date();
                date.setHours(23, 59, 59, 0);
                totalExpenseNR += utils.num(project.calcSheet.sumWithAdditionalCost) * utils.num(project.calcSheet.companyCost) / 100 * utils.progressOfDate(project.startDate, project.endDate, date, true);

                if (!data.regulation && project.audit && project.audit.regulation) {
                  totalExpenseNR += utils.num(project.audit.regulation.labor.amount);
                  totalExpenseNR += utils.num(project.audit.regulation.inventory.amount);
                  totalIncomeNR += utils.num(project.audit.regulation.invoiced.amount);
                }
              }
            });
            var groups = [];

            for (var key in sheetData.groups) {
              if (sheetData.groups[key]) {
                groups.push(sheetData.groups[key]);
              }
            }

            groups.sort(function (a, b) {
              return a.price > b.price ? -1 : a.price === b.price ? 0 : 1;
            });
            var Colors = ['#ff8b00', '#ffb966', '#fbdb80', '#fdf1cc', '#fdf1cc'];
            var sum = 0;

            for (var i = 0; i < groups.length; i++) {
              scope.pieData.push({
                name: groups[i].name,
                value: sheetData.total === 0 ? 1 : groups[i].price / sheetData.total,
                color: Colors[i]
              });
              sum += groups[i].price;
              if (i === 3) break;
            }

            if (groups.length > 4) {
              scope.pieData.push({
                name: 'Others',
                value: (sheetData.total - sum) / sheetData.total,
                color: Colors[4]
              });
            }

            if (scope.pieData.length > 0) {
              pieChart.data.parse(scope.pieData);
            }
          }

          scope.totalIncome = totalIncomeNR;
          scope.totalExpense = totalExpenseNR;

          if (data.regulation) {
            scope.totalIncome += data.regulation.invoiced.amount;
            scope.totalExpense += data.regulation.labor.amount;
            scope.totalExpense += data.regulation.inventory.amount;
          }

          scope.totalProfit = scope.totalIncome - scope.totalExpense;
        }

        function arrangeSheetLevel(data, level) {
          if (level.levels) {
            level.levels.forEach(function (subLevel) {
              return arrangeSheetLevel(data, subLevel);
            });
          }

          if (level.items) {
            level.items.forEach(function (item) {
              if (item.items && item.items.length > 0) {
                item.items.forEach(function (subItem) {
                  return arrangeSheetItem(data, subItem);
                });
              } else {
                arrangeSheetItem(data, item);
              }
            });
          }
        }

        function arrangeSheetItem(data, item) {
          var materials = scope.ngModel.materials;
          var equipments = scope.ngModel.equipments;
          var inventory;

          if (item.inventoryType === 'Material') {
            inventory = materials.find(function (x) {
              return x._id === item.matID;
            });
          } else if (item.inventoryType === 'Equipment') {
            inventory = equipments.find(function (x) {
              return x._id === item.matID;
            });
          } else {
            inventory = materials.find(function (x) {
              return x._id === item.matID;
            });

            if (!inventory) {
              inventory = equipments.find(function (x) {
                return x._id === item.matID;
              });
            }
          }

          if (inventory) {
            var group = inventory.groupId;

            if (group) {
              var arranged = data.groups[group._id];

              if (!arranged) {
                arranged = {
                  name: group.name,
                  price: 0
                };
                data.groups[group._id] = arranged;
              }

              arranged.price += item.currentSalesPrice;
              data.total += item.currentSalesPrice;
            }
          }
        }

        function calcTotalValue() {
          scope.totalIncome = totalIncomeNR;
          scope.totalExpense = totalExpenseNR;

          if (scope.ngModel.regulation) {
            scope.totalIncome += scope.ngModel.regulation.invoiced.amount;
            scope.totalExpense += scope.ngModel.regulation.labor.amount;
            scope.totalExpense += scope.ngModel.regulation.inventory.amount;
          }

          scope.totalProfit = scope.totalIncome - scope.totalExpense;
        }

        function tooltip(p) {
          return utils.makeReadable(p[0], 2, utils.isEuropean());
        }

        function tooltipPie(p) {
          return utils.makeReadable(p[0] * 100, 2, utils.isEuropean()) + '%';
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('dashboardAuditCashflowBlock', dashboardAuditCashflowBlock);

  function dashboardAuditCashflowBlock($log) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/main/dashboard/directives/dashboard-audit-cashflow-block/dashboard-audit-cashflow-block.view.html',
      scope: {
        ngModel: '=',
        totalValues: '=',
        currency: '=',
        startDate: '=',
        endDate: '='
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.isLoading = true;
      scope.incoming = 0;
      scope.outgoing = 0;
      scope.startCash = 0;
      scope.endCash = 0;
      scope.startCashDate = new Date();
      scope.endCashDate = new Date();
      scope.totalUnpaidInvoices = 0;
      scope.totalUnpaidBills = 0;
      scope.totalInvoices = 0;
      scope.totalBills = 0;
      scope.$watch('totalValues', function (newVal) {
        if (newVal) {
          initData(newVal);
          scope.isLoading = false;
        }
      });

      scope.getProgress = function (type) {
        if (type === 'invoice') {
          return {
            width: scope.totalInvoices === 0 ? '0%' : scope.totalUnpaidInvoices / scope.totalInvoices * 100 + '%'
          };
        } else {
          return {
            width: scope.totalBills === 0 ? '0%' : scope.totalUnpaidBills / scope.totalBills * 100 + '%'
          };
        }
      };

      function initData(data) {
        $log.log(data);
        scope.totalUnpaidInvoices = data.totalUnpaidInvoices;
        scope.totalInvoices = data.totalInvoices;
        scope.totalUnpaidBills = data.totalUnpaidBills;
        scope.totalBills = data.totalBills;
      }
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardAuditBillBlock", dashboardAuditBillBlock);

  function dashboardAuditBillBlock($timeout, $log, apiFactory, Notification, utils, $filter) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: "app/main/dashboard/directives/dashboard-audit-bill-block/dashboard-audit-bill-block.view.html",
      scope: {
        bills: '=',
        currency: '=',
        companyBills: '=',
        creditBills: '='
      },
      link: function link(scope) {
        scope.viewModes = [{
          id: 'all',
          label: $filter('translate')("All")
        }, {
          id: 'pending',
          label: $filter('translate')('Pending')
        }, {
          id: 'approved',
          label: $filter('translate')('Approved')
        }, {
          id: 'declined',
          label: $filter('translate')('Declined')
        }];
        scope.categories = [{
          _id: 'project',
          label: $filter('translate')('Project Bill')
        }, {
          _id: 'company',
          label: $filter('translate')('Company Bill')
        }, {
          _id: 'vendorCreditMemo',
          label: $filter('translate')('Vendor Credit Memo')
        }];
        scope.viewMode = 'all';
        scope.category = 'project';
        scope.isCheckAll = false;
        scope.billList = [];
        scope.filteredList = [];
        scope.$watch('bills', function (newVal) {
          scope.billList = newVal;
        });

        scope.changeCategory = function (category) {
          scope.category = category;
          scope.billList = scope.category === 'company' ? scope.companyBills : scope.category === 'project' ? scope.bills : scope.creditBills;
        };

        scope.checkAll = function (bills) {
          bills.forEach(function (bill) {
            return bill.checked = !scope.isCheckAll;
          });
        };

        scope.checkBill = function (bill, bills) {
          if (bill.checked) {
            scope.isCheckAll = false;
          } else {
            var checked = true;

            for (var i = 0; i < bills.length; i++) {
              if (!bills.checked && bills[i] !== bill) {
                checked = false;
                break;
              }
            }

            scope.isCheckAll = checked;
          }
        };

        scope.requestApproval = function () {
          var bills = scope.bills.filter(function (bill) {
            return bill.checked && bill.status === 'pending';
          });

          if (!bills || bills.length === 0) {
            Notification.error('There is no valid selected bills.');
            return;
          }

          bills = bills.map(function (bill) {
            return {
              _id: bill._id,
              billNo: bill.billNo,
              projectId: bill.projectId._id
            };
          });
          apiFactory.sendBillApproveRequest({
            bills: bills
          }).then(function () {
            Notification.success('Bill approve requested successfully.');
          })["catch"](function (err) {
            $log.error(err);
            Notification.error('Failed to request');
          });
        };

        scope.getFilter = function () {
          return scope.viewMode === 'all' ? {} : {
            status: scope.viewMode
          };
        };

        scope.getTotalAmount = function (bills) {
          return bills ? bills.reduce(function (acc, cur) {
            return acc + utils.num(cur.amountWithoutTax);
          }, 0) : 0;
        };

        scope.getTotalBalance = function (bills) {
          return bills ? bills.reduce(function (acc, cur) {
            return acc + cur.balance;
          }, 0) : 0;
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dashboardActivityBlock", dashboardActivityBlock);

  function dashboardActivityBlock(globals, $state, $log, apiFactory, Notification, utils) {
    return {
      restrict: "E",
      templateUrl: "app/main/dashboard/directives/dashboard-activity-block/dashboard-activity-block.view.html",
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc(scope) {
      var projectStore = globals.projectStore;
      scope.project = projectStore.get();
      scope.activities = [];
      scope.loading = true;
      apiFactory.getActivity({
        page: 1,
        chunk: 10
      }).then(function (res) {
        scope.loading = false;
        scope.activities = res.data.data;
      })["catch"](function (err) {
        $log.error(err);
        scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });

      scope.getType = function (activity) {
        switch (activity % 5) {
          case 0:
            return "";

          case 1:
            return "project";

          case 2:
            return "issue";

          case 3:
            return "critical";

          case 4:
            return "warnning";
        } // if (activity.route) {
        //   if (activity.route.stateName === "issueDetail") {
        //     return "issue";
        //   } else if (activity.route.stateName === "projectDetail") {
        //     return "project";
        //   }
        // }
        // return "";

      };

      scope.getIcon = function (activity) {
        switch (activity % 5) {
          case 0:
            return "/assets/icons/act-flag.svg";

          case 1:
            return "/assets/icons/act-domain.svg";

          case 2:
            return "/assets/icons/act-warning.svg";

          case 3:
            return "/assets/icons/act-domain.svg";

          case 4:
            return "/assets/icons/act-warning.svg";
        } // if (activity.route) {
        //   if (activity.route.stateName === "issueDetail") {
        //     return "/assets/icons/act-warning.svg";
        //   } else if (activity.route.stateName === "projectDetail") {
        //     return "/assets/icons/act-domain.svg";
        //   }
        // }
        // return "/assets/icons/act-flag.svg";

      };

      scope.goToDetail = function (activity) {
        if (utils.isEmpty(activity.route)) {
          return;
        }

        if (utils.isEmpty(activity.route.id)) {
          $state.go(activity.route.stateName);
        } else {
          $state.go(activity.route.stateName, {
            id: activity.route.id
          });
        }
      };
    }
  }
})();


"use strict";

(function () {
  angular.module("app").component("uploadOfferModal", {
    controller: uploadOfferModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/upload-offer-modal/upload-offer-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function uploadOfferModal($scope, globals, apiFactory, Notification, utils, $log) {
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.projectData = projectStore.get();
    vm.uploadFile = undefined;
    vm.amount = undefined;

    vm.$onInit = function () {};

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.changeFile = function (files) {
      if (files && files.length) {
        vm.uploadFile = files[0];
      }
    };

    $scope.onSubmit = function () {
      if (angular.isUndefined(vm.uploadFile)) {
        Notification.error('Please select a file to upload');
        return;
      }

      if (angular.isUndefined(vm.amount)) {
        Notification.error('Please input an amount');
        return;
      }

      $scope.loading = true;
      apiFactory.createCollaborationOffer({
        projectId: vm.projectData._id,
        amount: vm.amount,
        file: vm.uploadFile
      }).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('teamCommentReplyModal', {
    controller: teamCommentReplyModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/team-comment-reply-modal/team-comment-reply-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function teamCommentReplyModal($scope, utils, Notification, apiFactory, $log) {
    var vm = this;

    vm.$onInit = function () {
      $scope.commentData = {
        teamId: vm.resolve.data.comment.teamId,
        parentId: vm.resolve.data.comment._id,
        files: []
      };
    };

    $scope.onChangeFiles = function (files) {
      var file = files[0];
      if (angular.isUndefined(file)) return;
      var fileData = {
        file: file
      };

      if (utils.isImageFile(file)) {
        fileData.isImage = true;
        fileData.imageURL = URL.createObjectURL(file);
      }

      $scope.commentData.files.push(fileData);
    };

    $scope.removeFile = function (index) {
      $scope.commentData.files.splice(index, 1);
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.postComment = function () {
      if (utils.isEmpty($scope.commentData.comment)) {
        Notification.error('Please input your comment.');
        return;
      }

      $scope.loading = true;
      apiFactory.addCommentToTeamGroup($scope.commentData).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
        Notification.error('Failed to post comment.');
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('setApprovalModal', {
    controller: setApprovalModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/setApprovalModal/setApprovalModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function setApprovalModal($scope, globals, apiFactory, Notification, utils, $log) {
    var vm = this;
    vm.utils = utils;
    vm.projectData = globals.projectStore.get();
    $scope.openStatus = {
      drawing: true,
      report: false,
      issue: false,
      vaOrder: false,
      invoice: false,
      bill: false
    };
    var DRAWING = 1;
    var REPORT = 2;
    var ISSUE = 4;
    var VA_ORDER = 8;
    var INVOICE = 16;
    var BILL = 32;
    vm.allSubcontractorStaffs = [];
    vm.allSupplierStaffs = [];
    vm.allClientStaffs = [];
    vm.allManagers = [];
    vm.availableDrawingSubcontractorStaffs = [];
    vm.availableDrawingSupplierStaffs = [];
    vm.availableDrawingClientStaffs = [];
    vm.availableDrawingManagers = [];
    vm.availableReportSubcontractorStaffs = [];
    vm.availableReportSupplierStaffs = [];
    vm.availableReportClientStaffs = [];
    vm.availableReportManagers = [];
    vm.availableIssueSubcontractorStaffs = [];
    vm.availableIssueSupplierStaffs = [];
    vm.availableIssueClientStaffs = [];
    vm.availableIssueManagers = [];
    vm.availableVAOrderSubcontractorStaffs = [];
    vm.availableVAOrderSupplierStaffs = [];
    vm.availableVAOrderClientStaffs = [];
    vm.availableVAOrderManagers = [];
    vm.availableInvoiceSubcontractorStaffs = [];
    vm.availableInvoiceSupplierStaffs = [];
    vm.availableInvoiceClientStaffs = [];
    vm.availableInvoiceManagers = [];
    vm.availableBillSubcontractorStaffs = [];
    vm.availableBillSupplierStaffs = [];
    vm.availableBillClientStaffs = [];
    vm.availableBillManagers = [];
    vm.assignedDrawingMembers = [];
    vm.assignedReportMembers = [];
    vm.assignedIssueMembers = [];
    vm.assignedVAOrderMembers = [];
    vm.assignedInvoiceMembers = [];
    vm.assignedBillMembers = [];

    function initSelectedStaff() {
      vm.selectedDrawingSubcontractorStaff = undefined;
      vm.selectedDrawingSupplierStaff = undefined;
      vm.selectedDrawingClientStaff = undefined;
      vm.selectedDrawingManager = undefined;
      vm.selectedReportSubcontractorStaff = undefined;
      vm.selectedReportSupplierStaff = undefined;
      vm.selectedReportClientStaff = undefined;
      vm.selectedReportManager = undefined;
      vm.selectedIssueSubcontractorStaff = undefined;
      vm.selectedIssueSupplierStaff = undefined;
      vm.selectedIssueClientStaff = undefined;
      vm.selectedIssueManager = undefined;
      vm.selectedVAOrderSubcontractorStaff = undefined;
      vm.selectedVAOrderSupplierStaff = undefined;
      vm.selectedVAOrderClientStaff = undefined;
      vm.selectedVAOrderManager = undefined;
      vm.selectedInvoiceSubcontractorStaff = undefined;
      vm.selectedInvoiceSupplierStaff = undefined;
      vm.selectedInvoiceClientStaff = undefined;
      vm.selectedInvoiceManager = undefined;
      vm.selectedBillSubcontractorStaff = undefined;
      vm.selectedBillSupplierStaff = undefined;
      vm.selectedBillClientStaff = undefined;
      vm.selectedBillManager = undefined;
    }

    vm.$onInit = function () {
      $scope.loading = true;
      Promise.all([apiFactory.fetchInvitedMembersInProject(vm.projectData._id), apiFactory.getAuditManagersForCompany(), apiFactory.getCeoForCompany()]).then(function (res) {
        $scope.loading = false;
        var invitedMembers = res[0].data;
        var auditManagers = res[1].data;
        var ceos = res[2].data;
        var managers = invitedMembers.filter(function (x) {
          return x.parentType === 'Manager';
        });

        var _iterator = _createForOfIteratorHelper(auditManagers),
            _step;

        try {
          var _loop = function _loop() {
            var manager = _step.value;

            if (!managers.find(function (x) {
              return x.userId._id == manager.userId._id;
            })) {
              invitedMembers.push(manager);
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var _iterator2 = _createForOfIteratorHelper(ceos),
            _step2;

        try {
          var _loop2 = function _loop2() {
            var ceo = _step2.value;

            if (!managers.find(function (x) {
              return x.userId._id == ceo.userId._id;
            })) {
              invitedMembers.managers.push(ceo);
            }
          };

          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        invitedMembers = invitedMembers.map(function (x) {
          return {
            _id: x.userId._id,
            firstName: x.userId.firstName,
            lastName: x.userId.lastName,
            displayName: x.parent ? x.parent.name + ' - ' + x.userId.displayName : '',
            email: x.userId.email,
            profilePic: x.parent ? x.parent.profilePic : '',
            designation: x.userId.designation,
            parent: x.parent,
            approval: x.approval || false
          };
        });
        vm.allSubcontractorStaffs = invitedMembers.filter(function (x) {
          return x.parentType === 'Subcontractor';
        });
        vm.allSupplierStaffs = invitedMembers.filter(function (x) {
          return x.parentType === 'Supplier';
        });
        vm.allClientStaffs = invitedMembers.filter(function (x) {
          return x.parentType === 'Client';
        });
        vm.allManagers = invitedMembers.filter(function (x) {
          return x.parentType === 'Manager';
        }); // subcontractors

        vm.availableDrawingSubcontractorStaffs = vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & DRAWING) !== DRAWING;
        });
        vm.availableReportSubcontractorStaffs = vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & REPORT) !== DRAWING;
        });
        vm.availableIssueSubcontractorStaffs = vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & ISSUE) !== ISSUE;
        });
        vm.availableVAOrderSubcontractorStaffs = vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & VA_ORDER) !== VA_ORDER;
        });
        vm.availableInvoiceSubcontractorStaffs = vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & INVOICE) !== INVOICE;
        });
        vm.availableBillSubcontractorStaffs = vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & BILL) !== BILL;
        });
        vm.assignedDrawingMembers = vm.assignedDrawingMembers.concat(vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & DRAWING) === DRAWING;
        }));
        vm.assignedReportMembers = vm.assignedReportMembers.concat(vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & REPORT) === REPORT;
        }));
        vm.assignedIssueMembers = vm.assignedIssueMembers.concat(vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & ISSUE) === ISSUE;
        }));
        vm.assignedVAOrderMembers = vm.assignedVAOrderMembers.concat(vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & VA_ORDER) === VA_ORDER;
        }));
        vm.assignedInvoiceMembers = vm.assignedInvoiceMembers.concat(vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & INVOICE) === INVOICE;
        }));
        vm.assignedBillMembers = vm.assignedBillMembers.concat(vm.allSubcontractorStaffs.filter(function (x) {
          return (x.approval & BILL) === BILL;
        })); // suppliers

        vm.availableDrawingSupplierStaffs = vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & DRAWING) !== DRAWING;
        });
        vm.availableReportSupplierStaffs = vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & REPORT) !== REPORT;
        });
        vm.availableIssueSupplierStaffs = vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & ISSUE) !== ISSUE;
        });
        vm.availableVAOrderSupplierStaffs = vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & VA_ORDER) !== VA_ORDER;
        });
        vm.availableInvoiceSupplierStaffs = vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & INVOICE) !== INVOICE;
        });
        vm.availableBillSupplierStaffs = vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & BILL) !== BILL;
        });
        vm.assignedDrawingMembers = vm.assignedDrawingMembers.concat(vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & DRAWING) == DRAWING;
        }));
        vm.assignedReportMembers = vm.assignedReportMembers.concat(vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & REPORT) === REPORT;
        }));
        vm.assignedIssueMembers = vm.assignedIssueMembers.concat(vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & ISSUE) === ISSUE;
        }));
        vm.assignedVAOrderMembers = vm.assignedVAOrderMembers.concat(vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & VA_ORDER) === VA_ORDER;
        }));
        vm.assignedInvoiceMembers = vm.assignedInvoiceMembers.concat(vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & INVOICE) === INVOICE;
        }));
        vm.assignedBillMembers = vm.assignedBillMembers.concat(vm.allSupplierStaffs.filter(function (x) {
          return (x.approval & BILL) === BILL;
        })); // clients

        vm.availableDrawingClientStaffs = vm.allClientStaffs.filter(function (x) {
          return (x.approval & DRAWING) !== DRAWING;
        });
        vm.availableReportClientStaffs = vm.allClientStaffs.filter(function (x) {
          return (x.approval & REPORT) !== REPORT;
        });
        vm.availableIssueClientStaffs = vm.allClientStaffs.filter(function (x) {
          return (x.approval & ISSUE) !== ISSUE;
        });
        vm.availableVAOrderClientStaffs = vm.allClientStaffs.filter(function (x) {
          return (x.approval & VA_ORDER) !== VA_ORDER;
        });
        vm.availableInvoiceClientStaffs = vm.allClientStaffs.filter(function (x) {
          return (x.approval & INVOICE) !== INVOICE;
        });
        vm.availableBillClientStaffs = vm.allClientStaffs.filter(function (x) {
          return (x.approval & BILL) !== BILL;
        });
        vm.assignedDrawingMembers = vm.assignedDrawingMembers.concat(vm.allClientStaffs.filter(function (x) {
          return (x.approval & DRAWING) === DRAWING;
        }));
        vm.assignedReportMembers = vm.assignedReportMembers.concat(vm.allClientStaffs.filter(function (x) {
          return (x.approval & REPORT) === REPORT;
        }));
        vm.assignedIssueMembers = vm.assignedIssueMembers.concat(vm.allClientStaffs.filter(function (x) {
          return (x.approval & ISSUE) === ISSUE;
        }));
        vm.assignedVAOrderMembers = vm.assignedVAOrderMembers.concat(vm.allClientStaffs.filter(function (x) {
          return (x.approval & VA_ORDER) === VA_ORDER;
        }));
        vm.assignedInvoiceMembers = vm.assignedInvoiceMembers.concat(vm.allClientStaffs.filter(function (x) {
          return (x.approval & INVOICE) === INVOICE;
        }));
        vm.assignedBillMembers = vm.assignedBillMembers.concat(vm.allClientStaffs.filter(function (x) {
          return (x.approval & BILL) === BILL;
        })); // managers

        vm.availableDrawingManagers = vm.allManagers.filter(function (x) {
          return (x.approval & DRAWING) !== DRAWING;
        });
        vm.availableReportManagers = vm.allManagers.filter(function (x) {
          return (x.approval & REPORT) !== REPORT;
        });
        vm.availableIssueManagers = vm.allManagers.filter(function (x) {
          return (x.approval & ISSUE) !== ISSUE;
        });
        vm.availableVAOrderManagers = vm.allManagers.filter(function (x) {
          return (x.approval & VA_ORDER) !== VA_ORDER;
        });
        vm.availableInvoiceManagers = vm.allManagers.filter(function (x) {
          return (x.approval & INVOICE) !== INVOICE;
        });
        vm.availableBillManagers = vm.allManagers.filter(function (x) {
          return (x.approval & BILL) !== BILL;
        });
        vm.assignedDrawingMembers = vm.assignedDrawingMembers.concat(vm.allManagers.filter(function (x) {
          return (x.approval & DRAWING) === DRAWING;
        }));
        vm.assignedReportMembers = vm.assignedReportMembers.concat(vm.allManagers.filter(function (x) {
          return (x.approval & REPORT) === REPORT;
        }));
        vm.assignedIssueMembers = vm.assignedIssueMembers.concat(vm.allManagers.filter(function (x) {
          return (x.approval & ISSUE) === ISSUE;
        }));
        vm.assignedVAOrderMembers = vm.assignedVAOrderMembers.concat(vm.allManagers.filter(function (x) {
          return (x.approval & VA_ORDER) === VA_ORDER;
        }));
        vm.assignedInvoiceMembers = vm.assignedInvoiceMembers.concat(vm.allManagers.filter(function (x) {
          return (x.approval & INVOICE) === INVOICE;
        }));
        vm.assignedBillMembers = vm.assignedBillMembers.concat(vm.allManagers.filter(function (x) {
          return (x.approval & BILL) === BILL;
        }));
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function getValues(type, subType) {
      var staffs, assignedMembers, selectedStaff;

      if (type === 'Drawing') {
        assignedMembers = vm.assignedDrawingMembers;

        switch (subType) {
          case 'Subcontractor':
            staffs = vm.availableDrawingSubcontractorStaffs;
            selectedStaff = vm.selectedDrawingSubcontractorStaff;
            break;

          case 'Supplier':
            staffs = vm.availableDrawingSupplierStaffs;
            selectedStaff = vm.selectedDrawingSupplierStaff;
            break;

          case 'Client':
            staffs = vm.availableDrawingClientStaffs;
            selectedStaff = vm.selectedDrawingClientStaff;
            break;

          case 'Manager':
            staffs = vm.availableDrawingManagers;
            selectedStaff = vm.selectedDrawingManager;
            break;

          default:
            staffs = undefined;
            selectedStaff = undefined;
        }
      } else if (type === 'Report') {
        assignedMembers = vm.assignedReportMembers;

        switch (subType) {
          case 'Subcontractor':
            staffs = vm.availableReportSubcontractorStaffs;
            selectedStaff = vm.selectedReportSubcontractorStaff;
            break;

          case 'Supplier':
            staffs = vm.availableReportSupplierStaffs;
            selectedStaff = vm.selectedReportSupplierStaff;
            break;

          case 'Client':
            staffs = vm.availableReportClientStaffs;
            selectedStaff = vm.selectedReportClientStaff;
            break;

          case 'Manager':
            staffs = vm.availableReportManagers;
            selectedStaff = vm.selectedReportManager;
            break;

          default:
            staffs = undefined;
            selectedStaff = undefined;
        }
      } else if (type === 'Issue') {
        assignedMembers = vm.assignedIssueMembers;

        switch (subType) {
          case 'Subcontractor':
            staffs = vm.availableIssueSubcontractorStaffs;
            selectedStaff = vm.selectedIssueSubcontractorStaff;
            break;

          case 'Supplier':
            staffs = vm.availableIssueSupplierStaffs;
            selectedStaff = vm.selectedIssueSupplierStaff;
            break;

          case 'Client':
            staffs = vm.availableIssueClientStaffs;
            selectedStaff = vm.selectedIssueClientStaff;
            break;

          case 'Manager':
            staffs = vm.availableIssueManagers;
            selectedStaff = vm.selectedIssueManager;
            break;

          default:
            staffs = undefined;
            selectedStaff = undefined;
        }
      } else if (type === 'VA Order') {
        assignedMembers = vm.assignedVAOrderMembers;

        switch (subType) {
          case 'Subcontractor':
            staffs = vm.availableVAOrderSubcontractorStaffs;
            selectedStaff = vm.selectedVAOrderSubcontractorStaff;
            break;

          case 'Supplier':
            staffs = vm.availableVAOrderSupplierStaffs;
            selectedStaff = vm.selectedVAOrderSupplierStaff;
            break;

          case 'Client':
            staffs = vm.availableVAOrderClientStaffs;
            selectedStaff = vm.selectedVAOrderClientStaff;
            break;

          case 'Manager':
            staffs = vm.availableVAOrderManagers;
            selectedStaff = vm.selectedVAOrderManager;
            break;

          default:
            staffs = undefined;
            selectedStaff = undefined;
        }
      } else if (type === 'Invoice') {
        assignedMembers = vm.assignedInvoiceMembers;

        switch (subType) {
          case 'Subcontractor':
            staffs = vm.availableInvoiceSubcontractorStaffs;
            selectedStaff = vm.selectedInvoiceSubcontractorStaff;
            break;

          case 'Supplier':
            staffs = vm.availableInvoiceSupplierStaffs;
            selectedStaff = vm.selectedInvoiceSupplierStaff;
            break;

          case 'Client':
            staffs = vm.availableInvoiceClientStaffs;
            selectedStaff = vm.selectedInvoiceClientStaff;
            break;

          case 'Manager':
            staffs = vm.availableInvoiceManagers;
            selectedStaff = vm.selectedInvoiceManager;
            break;

          default:
            staffs = undefined;
            selectedStaff = undefined;
        }
      } else if (type === 'Bill') {
        assignedMembers = vm.assignedBillMembers;

        switch (subType) {
          case 'Subcontractor':
            staffs = vm.availableBillSubcontractorStaffs;
            selectedStaff = vm.selectedBillSubcontractorStaff;
            break;

          case 'Supplier':
            staffs = vm.availableBillSupplierStaffs;
            selectedStaff = vm.selectedBillSupplierStaff;
            break;

          case 'Client':
            staffs = vm.availableBillClientStaffs;
            selectedStaff = vm.selectedBillClientStaff;
            break;

          case 'Manager':
            staffs = vm.availableBillManagers;
            selectedStaff = vm.selectedBillManager;
            break;

          default:
            staffs = undefined;
            selectedStaff = undefined;
        }
      }

      return {
        assignedMembers: assignedMembers,
        staffs: staffs,
        selectedStaff: selectedStaff
      };
    }

    $scope.addMember = function (type, subType) {
      var _getValues = getValues(type, subType),
          assignedMembers = _getValues.assignedMembers,
          staffs = _getValues.staffs,
          selectedStaff = _getValues.selectedStaff;

      var index = staffs.findIndex(function (x) {
        return x._id === selectedStaff;
      });

      if (index !== -1) {
        var staff = staffs[index];
        assignedMembers.push(staff);
        staffs.splice(index, 1);
        initSelectedStaff();
      }
    };

    $scope.removeMember = function (type, subType, index) {
      var _getValues2 = getValues(type, subType),
          assignedMembers = _getValues2.assignedMembers,
          staffs = _getValues2.staffs;

      var staff = assignedMembers[index];

      if (staff) {
        assignedMembers.splice(index, 1);
        staffs.push(staff);
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      $scope.loading = true;
      apiFactory.updateInvitedMembersApproval(vm.projectData._id, {
        drawingMembers: vm.assignedDrawingMembers,
        reportMembers: vm.assignedReportMembers,
        issueMembers: vm.assignedIssueMembers,
        vaOrderMembers: vm.assignedVAOrderMembers,
        invoiceMembers: vm.assignedInvoiceMembers,
        billMembers: vm.assignedBillMembers
      }).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('selectBIMLevelModal', {
    controller: selectBIMLevelModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/selectBIMLevelModal/selectBIMLevelModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function selectBIMLevelModal($scope, apiFactory, Notification, utils, globals) {
    var vm = this;
    vm.projectData = globals.projectStore.get();
    $scope.utils = utils;
    $scope.tree = null;
    $scope.searchedIds = [];
    $scope.retArr = [];
    $scope.searchText = '';

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onImport = function () {
      $scope.retArr = [];

      if ($scope.tree.checked) {
        $scope.retArr.push({
          guid: $scope.tree.guid,
          name: $scope.tree.name,
          stepnr: $scope.tree.stepnr,
          level_type: $scope.tree.type,
          description: $scope.tree.name
        });
      }

      $scope.getCheckedItems($scope.tree.children);
      vm.modalInstance.close({
        data: $scope.retArr
      });
    };

    $scope.assignIndexes = function (arr, id) {
      arr.forEach(function (a, idx) {
        a.idx = angular.copy(id);
        a.idx.push(idx + 1);
        if (a.children && a.children.length > 0) $scope.assignIndexes(a.children, a.idx);
      });
    };

    $scope.changeFlag = function (arr, flag) {
      arr.forEach(function (a) {
        a.checked = flag;
        if (a.children && a.children.length > 0) $scope.changeFlag(a.children, flag);
      });
    };

    $scope.searchItems = function (arr, search) {
      arr.forEach(function (a) {
        if (a.name.toLowerCase().indexOf(search.toLowerCase()) > -1 || a.type.toLowerCase().indexOf(search.toLowerCase()) > -1) {
          $scope.searchedIds.push(a.idx);
        }

        if (a.children && a.children.length > 0) $scope.searchItems(a.children, search);
      });
    };

    $scope.getCheckedItems = function (arr) {
      arr.forEach(function (a) {
        if (a.checked && $scope.isShow(a)) $scope.retArr.push({
          guid: a.guid,
          name: a.name,
          stepnr: a.stepnr,
          level_type: a.type,
          description: a.name
        });
        if (a.children && a.children.length > 0) $scope.getCheckedItems(a.children);
      });
    };

    $scope.isShow = function (item) {
      var idxLen = item.idx.length;
      var idx = item.idx.join('-');
      if ($scope.searchText == '') return true;

      for (var i = 0; i < $scope.searchedIds.length; i++) {
        var temp = $scope.searchedIds[i].slice(0, idxLen).join('-');
        if (temp === idx) return true;
      }

      return false;
    };

    $scope.searchLevels = function () {
      $scope.searchedIds = [];
      if ($scope.searchText == '') return;
      $scope.searchItems(vm.tree.children, $scope.searchText);
    };

    vm.$onInit = function () {
      vm.tree = vm.resolve.levels;
      vm.tree.idx = [1];
      $scope.assignIndexes(vm.tree.children, [1]);
      $scope.tree = vm.tree;
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('renameTeamModal', {
    controller: renameTeamModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/rename-team-modal/rename-team-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function renameTeamModal($scope, apiFactory, Notification, utils) {
    var vm = this;

    vm.$onInit = function () {
      vm.team = angular.copy(vm.resolve.team);
    };

    $scope.rename = function () {
      $scope.loading = true;
      apiFactory.renameTeam({
        teamId: vm.team._id,
        name: vm.team.name
      }).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close(vm.team.name);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.cancel = function () {
      vm.modalInstance.dismiss('cancel');
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('inviteStaffModal', {
    controller: inviteStaffModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/inviteStaffModal/inviteStaffModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function inviteStaffModal($scope, apiFactory, Notification, utils) {
    var vm = this;
    $scope.utils = utils;

    vm.$onInit = function () {
      vm.staffs = vm.resolve.staffs;
      vm.projectId = vm.resolve.projectId;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.selectStaff = function (staff) {
      if (staff.inviteStatus !== 'Accepted') {
        staff.selected = !staff.selected;
      }
    };

    $scope.onInvite = function () {
      var selectedUserIds = vm.staffs.filter(function (x) {
        return x.selected;
      }).map(function (x) {
        return x._id;
      });

      if (utils.isEmpty(selectedUserIds)) {
        Notification.error("Please select the staffs to invite");
        return;
      }

      $scope.loading = true;
      apiFactory.inviteMembers({
        projectId: vm.projectId,
        users: selectedUserIds
      }).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('inviteCollaboratorsModal', {
    controller: inviteCollaboratorsModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/inviteCollaboratorsModal/inviteCollaboratorsModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function inviteCollaboratorsModal($scope, apiFactory, Notification, utils, globals, $log) {
    var vm = this;
    vm.projectData = globals.projectStore.get();
    $scope.utils = utils;
    $scope.selectedVendorId = undefined;
    $scope.selectedCoordinatorId = undefined;
    vm.vendors = [];
    vm.vendorStaffs = [];
    vm.coordinators = [];

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onInvite = function () {
      var coordinators = vm.coordinators.filter(function (x) {
        return !x.isInvited;
      }).map(function (x) {
        return x._id;
      });

      if (utils.isEmpty(coordinators)) {
        Notification.error("Nothing co-ordinators to invite");
        return;
      }

      $scope.isLoading = true;
      Promise.all(coordinators.map(function (x) {
        return apiFactory.createCollaboration({
          projectId: vm.projectData._id,
          coordinator: x
        });
      })).then(function () {
        $scope.isLoading = false;
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.$onInit = function () {
      $scope.isLoading = true;
      Promise.all([apiFactory.getAllSubcontractors(), apiFactory.getAllSuppliers(), apiFactory.listCollaborations(vm.projectData._id)]).then(function (res) {
        $scope.isLoading = false;
        var subcontractors = res[0].data.list;
        var suppliers = res[1].data.list;
        vm.vendors = subcontractors.concat(suppliers);
        vm.collaborations = res[2].data.list;
        vm.coordinators = vm.collaborations.map(function (x) {
          return x.coordinator;
        });
        vm.coordinators.forEach(function (coordinator) {
          coordinator.isInvited = vm.collaborations.findIndex(function (x) {
            return x.coordinator._id === coordinator._id;
          }) !== -1;
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.changeVendor = function () {
      var selectedVendor = vm.vendors.find(function (x) {
        return x._id === $scope.selectedVendorId;
      });

      if (!selectedVendor) {
        return;
      }

      vm.vendorStaffs = selectedVendor.staffs || [];
      vm.vendorStaffs = vm.vendorStaffs.filter(function (x) {
        return !vm.coordinators.find(function (y) {
          return x._id == y._id;
        });
      });
    };

    $scope.addCoordinator = function () {
      var selectedStaff = vm.vendorStaffs.find(function (x) {
        return x._id === $scope.selectedCoordinatorId;
      });

      if (utils.isEmpty(selectedStaff)) {
        Notification.error("Please select a co-ordinator");
        return;
      }

      selectedStaff.isInvited = vm.collaborations.findIndex(function (x) {
        return x.coordinator._id === selectedStaff._id;
      }) !== -1;
      vm.coordinators.push(selectedStaff);
      $scope.selectedCoordinatorId = undefined;
      $scope.changeVendor();
    };

    $scope.removeCoordinator = function (index) {
      vm.coordinators.splice(index, 1);
      $scope.changeVendor();
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('importFromBIMModal', {
    controller: importFromBIMModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/importFromBIMModal/importFromBIMModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function importFromBIMModal($scope, apiFactory, Notification, utils, globals, $log) {
    var vm = this;
    vm.projectData = globals.projectStore.get();
    $scope.utils = utils;
    $scope.models = [];

    vm.fetchAllModels = function () {
      $scope.loading = true;
      apiFactory.list3d(vm.projectData._id, {
        sort: "createdAt",
        sortType: "false",
        page: vm.currentPage,
        chunk: $scope.numPerPage
      }).then(function (resp) {
        $scope.loading = false;
        $scope.models = resp.data.data;

        var _iterator = _createForOfIteratorHelper($scope.models),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var model = _step.value;

            if (model.size >= 1000000) {
              model.displaySize = model.size / 1000000;
              model.displaySizeUnit = 'MB';
            } else if (model.size >= 1000 && model.size < 1000000) {
              model.displaySize = model.size / 1000;
              model.displaySizeUnit = 'KB';
            } else if (model.size >= 0 && model.size < 1000) {
              model.displaySize = model.size;
              model.displaySizeUnit = 'B';
            } else {
              model.displaySize = 0;
              model.displaySizeUnit = 'B';
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);

        if (err.status === 403) {
          Notification.error(err.data.message);
        }
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onImport = function (modelId) {
      vm.modalInstance.close({
        modelId: modelId
      });
    };

    vm.$onInit = function () {
      vm.fetchAllModels();
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component("editTeamMemberModal", {
    controller: editTeamMemberModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/editTeamMemberModal/editTeamMemberModal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function editTeamMemberModalController($scope, Notification, utils) {
    var vm = this;

    vm.$onInit = function () {
      vm.member = angular.copy(vm.resolve.member);
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty(vm.member.designation)) {
        Notification.error('Please input designation');
      } else {
        vm.modalInstance.close(vm.member);
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('createTeamModal', {
    controller: createTeamModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/createTeamModal/createTeamModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function createTeamModal($scope, apiFactory, Notification, utils, globals) {
    var vm = this;
    vm.projectData = globals.projectStore.get();

    $scope.onCancel = function () {
      vm.team = {};
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onCreate = function () {
      if (utils.isEmpty(vm.team.name)) {
        Notification.error("Please enter name.");
        return;
      }

      var team = angular.fromJson(angular.toJson(vm.team));
      team.projectId = vm.projectData._id;
      apiFactory.createTeam(team).then(function () {
        Notification.success("Team created successfully.");
        vm.modalInstance.close(true);
      })["catch"](function () {
        Notification.error("Failed to create");
        vm.modalInstance.dismiss('cancel');
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('createOfferFilterModal', {
    controller: createOfferFilterModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/createOfferFilterModal/createOfferFilterModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function createOfferFilterModal($scope, Notification, $log, apiFactory, NgMap, globals, utils) {
    var vm = this;
    vm.projectData = globals.projectStore.get();
    $scope.utils = utils;
    $scope.filterText = "";
    $scope.models = [];
    $scope.initData = [];

    $scope.onCancel = function () {
      vm.modalInstance.close({
        data: $scope.initData
      });
    };

    $scope.onEnter = function (e) {
      var keyCode = e.which || e.keyCode;

      if (keyCode == 13) {
        var m_index = $scope.models.find(function (elem) {
          return elem == $scope.filterText;
        });
        if (!m_index) $scope.models.push($scope.filterText);
        $scope.filterText = "";
      }
    };

    $scope.removeFilter = function (mIndex) {
      $scope.models.splice(mIndex, 1);
    };

    $scope.onSubmit = function () {
      vm.modalInstance.close({
        data: $scope.models
      });
    };

    vm.$onInit = function () {
      $scope.initData = $scope.models = vm.resolve.filter_data;
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('addTeamMemberModal', {
    controller: addTeamMemberModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/addTeamMemberModal/addTeamMemberModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function addTeamMemberModal($scope, apiFactory, Notification, globals, utils, $log) {
    var vm = this;
    vm.utils = utils;
    vm.projectData = globals.projectStore.get();
    vm.selectedUserId = undefined;
    vm.departments = [];
    $scope.assignedMembers = [];
    $scope.EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    $scope.$watch('currentDesignation', function () {
      vm.department = '';
      vm.designation = '';

      switch ($scope.currentDesignation) {
        case 'Manager':
          vm.users = vm.managers;
          break;

        case 'Subcontractor':
          vm.users = vm.subcontractorStaffs;
          break;

        case 'Supplier':
          vm.users = vm.supplierStaffs;
          break;

        case 'Client':
          vm.users = vm.clientStaffs;
          break;

        default:
          vm.users = [];
          break;
      }
    });

    function removeDuplicates(list, id) {
      var index = list.findIndex(function (x) {
        return x._id === id;
      });

      if (index !== -1) {
        list.splice(index, 1);
      }
    }

    vm.$onInit = function () {
      vm.team = vm.resolve.team;
      $scope.assignedMembers = vm.team.members.slice(0);
      $scope.loading = true;
      Promise.all([apiFactory.fetchInvitedMembersInProject(vm.projectData._id), apiFactory.getDepartments()]).then(function (res) {
        $scope.loading = false;
        var invitedMembers = res[0].data;
        invitedMembers = invitedMembers.map(function (x) {
          return {
            _id: x.userId._id,
            firstName: x.userId.firstName,
            lastName: x.userId.lastName,
            displayName: x.parent.name + ' - ' + x.userId.displayName,
            email: x.userId.email,
            profilePic: x.parent.profilePic,
            designation: x.userId.designation,
            parent: x.parent
          };
        });
        vm.subcontractorStaffs = invitedMembers.filter(function (x) {
          return x.parentType === 'Subcontractor';
        });
        vm.supplierStaffs = invitedMembers.filter(function (x) {
          return x.parentType === 'Supplier';
        });
        vm.clientStaffs = invitedMembers.filter(function (x) {
          return x.parentType === 'Client';
        });
        vm.managers = invitedMembers.filter(function (x) {
          return x.parentType === 'Manager';
        });
        vm.assignedMembers = vm.team.members;
        $scope.assignedMembers.forEach(function (member) {
          if (member.type !== 'Guest') {
            removeDuplicates(vm.subcontractorStaffs, member.userId._id);
            removeDuplicates(vm.supplierStaffs, member.userId._id);
            removeDuplicates(vm.clientStaffs, member.userId._id);
            removeDuplicates(vm.managers, member.userId._id);
          }
        });
        $scope.currentDesignation = 'Manager';
        vm.users = vm.managers;
        var departments = res[1].data.data;
        vm.departments = departments.map(function (x) {
          return {
            name: x
          };
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.onAdd = function () {
      if ($scope.currentDesignation === 'Guest') {
        if (utils.isEmpty(vm.guestEmail)) {
          Notification.error('Please type an email address');
          return;
        }

        if ($scope.assignedMembers.find(function (x) {
          return x.email === vm.guestEmail;
        })) {
          Notification.error('The email already exists.');
          return;
        }

        $scope.assignedMembers.push({
          email: vm.guestEmail,
          teamId: vm.team._id,
          type: 'Guest'
        });
        vm.guestEmail = '';
      } else {
        if (angular.isUndefined(vm.selectedUserId)) {
          Notification.error('Please select user');
          return;
        }

        if ($scope.currentDesignation !== 'Manager') {
          if (utils.isEmpty(vm.department)) {
            Notification.error('Please select department');
            return;
          }

          if (utils.isEmpty(vm.designation)) {
            Notification.error('Please input designation');
            return;
          }
        }

        var user = vm.users.find(function (x) {
          return x._id === vm.selectedUserId;
        });
        var member = {
          userId: user,
          teamId: vm.team._id,
          type: 'Member',
          department: vm.department || user.department,
          designation: vm.designation || user.subDesignation
        };

        if ($scope.currentDesignation !== 'Manager') {
          var parentManger = $scope.assignedMembers.find(function (x) {
            return x.userId.designation === 'Manager' && x.department === member.department;
          });

          if (parentManger) {
            member.parentId = parentManger.userId._id;
          }
        }

        $scope.assignedMembers.push(member);
        var index = vm.users.findIndex(function (x) {
          return x._id === vm.selectedUserId;
        });

        if (index !== -1) {
          vm.users.splice(index, 1);
        }

        vm.selectedUserId = undefined;
        vm.department = undefined;
        vm.designation = undefined;
      }
    };

    $scope.onDelete = function (index, userId, isGuest) {
      if (isGuest) {
        $scope.assignedMembers.splice(index, 1);
      } else {
        var member = $scope.assignedMembers[index];
        $scope.assignedMembers.splice(index, 1);
        var arr;

        switch (member.userId.designation) {
          case 'Manager':
            arr = vm.managers;
            break;

          case 'Subcontractor':
            arr = vm.subcontractorStaffs;
            break;

          case 'Supplier':
            arr = vm.supplierStaffs;
            break;

          case 'Client':
            arr = vm.clientStaffs;
            break;

          default:
            arr = [];
        }

        arr.push(userId);
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      var payload = [];

      var _iterator = _createForOfIteratorHelper($scope.assignedMembers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var member = _step.value;
          var data = {
            teamId: member.teamId,
            type: member.type,
            parentId: member.parentId,
            department: member.department,
            designation: member.designation
          };

          if (member.type === 'Guest') {
            data.email = member.email;
          } else if (angular.isObject(member.userId)) {
            data.userId = member.userId._id;
          }

          payload.push(data);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      $scope.loading = true;
      apiFactory.updateTeamMembers(vm.team._id, payload).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close(res.data.list);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('addCollaborationMemberModal', {
    controller: addCollaborationMemberModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/modals/addCollaborationMemberModal/addCollaborationMemberModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function addCollaborationMemberModal($scope, apiFactory, Notification, globals, utils, $log) {
    var vm = this;
    vm.utils = utils;
    vm.selectedUserId = undefined;
    $scope.assignedMembers = [];

    function removeDuplicates(list, member) {
      var index = list.findIndex(function (x) {
        return x._id === member._id || x.email === member.email;
      });

      if (index !== -1) {
        list.splice(index, 1);
      }
    }

    vm.$onInit = function () {
      vm.project = vm.resolve.project;
      var apis = [apiFactory.getAllSubcontractors(), apiFactory.getAllSuppliers(), apiFactory.listAllManagers()];

      if (!utils.isEmpty(vm.project.client) && !utils.isEmpty(vm.project.client._id)) {
        apis.push(apiFactory.getClientById(vm.project.client._id));
      }

      $scope.loading = true;
      Promise.all(apis).then(function (res) {
        $scope.loading = false;
        vm.subcontractors = res[0].data.list;
        vm.suppliers = res[1].data.list;
        vm.managers = res[2].data.list;

        if (apis.length === 4) {
          vm.client = res[3].data.data;
        } else {
          vm.client = [];
        }

        vm.subcontractorStaffs = [];

        var _iterator = _createForOfIteratorHelper(vm.subcontractors),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var subcontractor = _step.value;

            if (utils.isEmpty(subcontractor.staffs)) {
              continue;
            }

            var _iterator4 = _createForOfIteratorHelper(subcontractor.staffs),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var _staff = _step4.value;
                _staff.parent = subcontractor;
                _staff.displayName = subcontractor.name + ' - ' + _staff.displayName;
                vm.subcontractorStaffs.push(_staff);
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        vm.supplierStaffs = [];

        var _iterator2 = _createForOfIteratorHelper(vm.suppliers),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var supplier = _step2.value;

            if (utils.isEmpty(supplier.staffs)) {
              continue;
            }

            var _iterator5 = _createForOfIteratorHelper(supplier.staffs),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _staff2 = _step5.value;
                _staff2.parent = supplier;
                _staff2.displayName = supplier.name + ' - ' + _staff2.displayName;
                vm.supplierStaffs.push(_staff2);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        vm.clientStaffs = [];

        if (!utils.isEmpty(vm.client.staffs)) {
          var _iterator3 = _createForOfIteratorHelper(vm.client.staffs),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var staff = _step3.value;
              staff.parent = vm.client;
              vm.clientStaffs.push(staff);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }

        vm.managers = vm.managers.map(function (x) {
          return x.userId;
        });
        vm.partners = vm.resolve.partners || {};
        $scope.assignedMembers = [];
        $scope.assignedMembers = $scope.assignedMembers.concat(vm.partners.subcontractorStaffs.map(function (x) {
          return {
            _id: x.userId._id,
            firstName: x.userId.firstName,
            lastName: x.userId.lastName,
            displayName: x.parent.name + ' - ' + x.userId.displayName,
            email: x.userId.email,
            designation: x.userId.designation,
            parent: x.parent
          };
        }));
        $scope.assignedMembers = $scope.assignedMembers.concat(vm.partners.supplierStaffs.map(function (x) {
          return {
            _id: x.userId._id,
            firstName: x.userId.firstName,
            lastName: x.userId.lastName,
            displayName: x.parent.name + ' - ' + x.userId.displayName,
            email: x.userId.email,
            designation: x.userId.designation,
            parent: x.parent
          };
        }));
        $scope.assignedMembers = $scope.assignedMembers.concat(vm.partners.clientStaffs.map(function (x) {
          return {
            _id: x.userId._id,
            firstName: x.userId.firstName,
            lastName: x.userId.lastName,
            displayName: x.userId.displayName,
            email: x.userId.email,
            designation: x.userId.designation,
            parent: x.parent
          };
        }));
        $scope.assignedMembers = $scope.assignedMembers.concat(vm.partners.managers.map(function (x) {
          return x.userId;
        }));
        $scope.assignedMembers.forEach(function (member) {
          removeDuplicates(vm.managers, member);
          removeDuplicates(vm.subcontractorStaffs, member);
          removeDuplicates(vm.supplierStaffs, member);
          removeDuplicates(vm.clientStaffs, member);
        });
        $scope.currentDesignation = 'Manager';
        vm.users = vm.managers;
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error('Failed to get users');
        $log.error(err);
      });
    };

    $scope.$watch('currentDesignation', function () {
      switch ($scope.currentDesignation) {
        case 'Manager':
          vm.users = vm.managers;
          break;

        case 'Subcontractor':
          vm.users = vm.subcontractorStaffs;
          break;

        case 'Supplier':
          vm.users = vm.supplierStaffs;
          break;

        case 'Staff':
          vm.users = vm.clientStaffs;
          break;

        default:
          vm.users = [];
          break;
      }
    });

    $scope.onAdd = function () {
      if (angular.isUndefined(vm.selectedUserId)) {
        Notification.error('Please select user');
        return;
      }

      var user = vm.users.find(function (x) {
        return x._id === vm.selectedUserId;
      });
      $scope.assignedMembers.push(user);
      var index = vm.users.findIndex(function (x) {
        return x._id === vm.selectedUserId;
      });

      if (index !== -1) {
        vm.users.splice(index, 1);
      }

      vm.selectedUserId = undefined;
    };

    $scope.onDelete = function (index) {
      var member = $scope.assignedMembers[index];
      $scope.assignedMembers.splice(index, 1);
      var arr;

      switch (member.designation) {
        case 'Manager':
          arr = vm.managers;
          break;

        case 'Subcontractor':
          arr = vm.subcontractorStaffs;
          break;

        case 'Supplier':
          arr = vm.supplierStaffs;
          break;

        case 'Staff':
          arr = vm.clientStaffs;
          break;

        default:
          arr = [];
      }

      arr.push(member);
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      var subcontractorStaffs = $scope.assignedMembers.filter(function (x) {
        return x.designation === 'Subcontractor';
      }).map(function (x) {
        return {
          parent: x.parent._id,
          userId: x._id
        };
      });
      var supplierStaffs = $scope.assignedMembers.filter(function (x) {
        return x.designation === 'Supplier';
      }).map(function (x) {
        return {
          parent: x.parent._id,
          userId: x._id
        };
      });
      var clientStaffs = $scope.assignedMembers.filter(function (x) {
        return x.designation === 'Client';
      }).map(function (x) {
        return {
          parent: x.parent._id,
          userId: x._id
        };
      });
      var managers = $scope.assignedMembers.filter(function (x) {
        return x.designation === 'Manager';
      }).map(function (x) {
        return {
          userId: x._id
        };
      });
      $scope.loading = true;
      apiFactory.updateInvitedMembers({
        projectId: vm.project._id,
        subcontractorStaffs: subcontractorStaffs,
        supplierStaffs: supplierStaffs,
        clientStaffs: clientStaffs,
        managers: managers
      }).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// const OrgChart = require("../../../../../assets/lib/OrgChart/OrgChart");
(function () {
  angular.module("app").directive("membersTree", membersTree);

  function membersTree($window, $document, apiFactory, Notification, utils, globals, $log, $state, $uibModal) {
    return {
      restrict: "E",
      templateUrl: "app/main/collaborations/directives/membersTree/membersTree.view.html",
      scope: {
        orgChart: '='
      },
      link: function link($scope) {
        $scope.projectData = globals.projectStore.get();
        $scope.invitedUsers = [];
        var hostURL = "https://cloudes.one";

        function setLevelTag(level, upperUserId) {
          var filtered_items = $scope.orgChart.members.filter(function (elem) {
            return angular.isUndefined(elem.tags) && elem.upperUserId == upperUserId;
          });
          filtered_items.forEach(function (item) {
            if (item.userId) {
              item.userId.tags = ["level-" + level];
              item.userId.id = item.userId._id;
              item.userId.pid = upperUserId;

              if (angular.isUndefined(item.userId.profilePic)) {
                item.userId.profilePic = hostURL + "/assets/images/employees/no-avatar.png";
              }

              setLevelTag(level + 1, item.userId._id);
            }
          });
        }

        function updateLevelTagForChildren(sender, data, level) {
          if (data.childrenIds.length > 0) {
            for (var i = 0; i < data.childrenIds.length; i++) {
              var childrenNode = sender.getNode(data.childrenIds[i]);
              var childrenNodeData = sender.get(data.childrenIds[i]);
              childrenNodeData.tags = ["level-" + (level + 1)];
              sender.updateNode(childrenNodeData);
              updateLevelTagForChildren(sender, childrenNode, level + 1);
            }
          }
        }

        function removeNode(nodeId) {
          var nodeData = $scope.chart.get(nodeId);

          if ($scope.chart.nodes[nodeId].children.length > 0) {
            Notification.error("Cannot delete parent node");
            return;
          }

          apiFactory.removeMemberFromOrgChart({
            projectId: $scope.projectData._id,
            userId: nodeData._id
          }).then(function () {
            var mIndex = $scope.orgChart.members.find(function (elem) {
              return elem.id == nodeData._id;
            });
            $scope.orgChart.members.splice(mIndex, 1);
            Notification.success("Removed a member successfully"); // renderChart();

            $state.reload();
          })["catch"](function (err) {
            Notification.error(utils.getErrorMessage(err));
          });
        }

        function editNode(nodeId) {
          var nodeData = $scope.chart.get(nodeId);
          $log.log(nodeData);
          $uibModal.open({
            animation: true,
            component: 'editTeamMemberModal',
            windowClass: 'file-name-modal',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              member: function member() {
                return {
                  designation: nodeData.designation,
                  description: nodeData.description
                };
              }
            }
          }).result.then(function (result) {
            $log.log(result);
            nodeData.designation = result.designation;
            nodeData.description = result.description;
            $scope.chart.updateNode(nodeData);
            saveOrgChart(nodeData).then(function (res) {
              $log.log(res);
            })["catch"](function (err) {
              $log.error(err);
              Notification.error(utils.getErrorMessage(err));
            }); // apiFactory.deleteBidPackage(bidPackage._id)
            //   .then(() => {
            //     Notification.success(`${bidPackage.title} removed successfully.`);
            //     $scope.fetchData();
            //   })
            //   .catch(err => {
            //     $log.error(err);
            //     Notification.error("Failed to remove!");
            //   });
          }, function () {}); // apiFactory.removeMemberFromOrgChart({
          //   projectId: $scope.projectData._id,
          //   userId: nodeData._id
          // })
          //   .then(() => {
          //     const mIndex = $scope.orgChart.members.find(elem=>elem.id == nodeData._id);
          //     $scope.orgChart.members.splice(mIndex,1);
          //     Notification.success("Removed a member successfully");
          //     // renderChart();
          //     $state.reload();
          //   })
          //   .catch(err => {
          //     Notification.error(utils.getErrorMessage(err));
          //   })
        }

        $scope.onExportPdf = function () {
          $scope.chart.exportPDF({
            landscape: true,
            //false
            format: "fit",
            //fit
            filename: "MyOrgChart.pdf",
            openInNewTab: false,
            expandChildren: true,
            margin: [40, 100, 40, 100],
            padding: 10,
            footer: 'Page {current-page} of {total-pages}',
            scale: '100' //100

          });
        };

        $scope.onRefresh = function () {
          $scope.chart.fit();
        };

        $scope.onZoomIn = function () {
          $scope.chart.zoom(2, [50, 50]);
        };

        $scope.onZoomOut = function () {
          $scope.chart.zoom(0.5, [50, 50]);
        };

        function renderChart() {
          setLevelTag(0);
          var userData = $scope.orgChart.members.map(function (x) {
            var data = x.userId;
            data.designation = x.designation;
            data.description = x.description;
            return data;
          }).filter(function (x) {
            return x;
          });
          OrgChart.templates.myTemplate = Object.assign({}, OrgChart.templates.olivia);
          OrgChart.templates.myTemplate.size = [220, 72];
          OrgChart.templates.myTemplate.node = '<rect x="0" y="0" fill="#F2F2F2" width="220" height="72"></rect>';
          OrgChart.templates.myTemplate.field_0 = '<text class="field_0" width="140" fill="#464646" x="60" y="23">{val}</text>';
          OrgChart.templates.myTemplate.field_1 = '<text class="field_1" width="140" fill="#464646" x="60" y="40">{val}</text>';
          OrgChart.templates.myTemplate.field_2 = '<text class="field_1" width="140" fill="#464646" x="60" y="57">{val}</text>';
          OrgChart.templates.myTemplate.field_3 = '<line x1="0" y1="0" x2="0" y2="72" stroke-width="4" stroke="#039BE5"></line>';
          OrgChart.templates.myTemplate.img_0 = '<clipPath id="ulaImg">' + '<circle cx="28" cy="30" r="20"></circle>' + '</clipPath>' + '<image preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="8" y="10" width="40" height="40">' + '</image>';
          OrgChart.templates.myTemplate.nodeMenuButton = '<g style="cursor:pointer;" transform="matrix(1,0,0,1,200,50)" data-ctrl-n-menu-id="{id}"">' + '<rect x="-10" y="0" fill="red" fill-opacity="0" width="22" height="22"></rect>' + '<circle cx="-2" cy="15" r="1" fill="red"></circle><circle cx="2" cy="15" r="1" fill="red"></circle><circle cx="6" cy="15" r="1" fill="red"></circle></g>';
          OrgChart.templates.myTemplate.plus = '<rect x="0" y="0" width="16" height="16" rx="8" ry="8" fill="#F1F1F1" stroke="#D1D1D1" stroke-width="1"></rect>' + '<line x1="3" y1="8" x2="13" y2="8" stroke-width="1" stroke="#A3A3A3"></line>' + '<line x1="8" y1="3" x2="8" y2="13" stroke-width="1" stroke="#A3A3A3"></line>';
          OrgChart.templates.myTemplate.minus = '<rect x="0" y="0" width="16" height="16" rx="8" ry="8" fill="#F1F1F1" stroke="#D1D1D1" stroke-width="1"></rect>' + '<line x1="3" y1="8" x2="13" y2="8" stroke-width="1" stroke="#A3A3A3"></line>';
          OrgChart.templates.myTemplate.expandCollapseSize = 16;
          $scope.chart = new OrgChart($document[0].getElementById("members-tree"), {
            template: 'myTemplate',
            mouseScrool: OrgChart.action.none,
            layout: OrgChart.treeRightOffset,
            // scaleInitial: 0.75,
            enableSearch: false,
            enableDragDrop: true,
            nodeBinding: {
              field_0: "displayName",
              field_1: "designation",
              field_2: "description",
              field_3: "_id",
              img_0: "profilePic"
            },
            nodes: userData,
            nodeMouseClick: OrgChart.action.none,
            nodeMenu: {
              edit: {
                text: "Edit",
                onClick: editNode,
                icon: OrgChart.icon.edit(16, 16, '#ccc')
              },
              remove: {
                text: "Remove",
                onClick: removeNode,
                icon: OrgChart.icon.remove(16, 16, '#ccc')
              }
            }
          });
          $scope.chart.on('exportstart', function (sender, args) {
            args.styles += '<link href="https://fonts.googleapis.com/css?family=Inter" rel="stylesheet">';
            args.styles += $document[0].getElementById("OrgChartExportStyle").outerHTML;
          });
          $scope.chart.on('drop', function (sender, draggedNodeId, droppedNodeId) {
            var draggedNode = sender.getNode(draggedNodeId);
            var droppedNode = sender.getNode(droppedNodeId);
            var draggedNodeData = sender.get(draggedNode.id);
            draggedNodeData.tags = ["level-" + (droppedNode.level + 1)];
            sender.updateNode(draggedNodeData);
            updateLevelTagForChildren(sender, draggedNode, droppedNode.level + 1);
            draggedNode.pid = droppedNode.id;
            saveOrgChart();
          });
        }

        $scope.$watch('orgChart.members', function () {
          if (!utils.isEmpty($scope.orgChart.members)) {
            renderChart();
          }
        });
        $scope.$watch('orgChart.members.length', function () {
          if (!utils.isEmpty($scope.orgChart.members)) {
            renderChart();
          }
        });

        function saveOrgChart() {
          return new Promise(function (resolve, reject) {
            var data = angular.copy($scope.orgChart);

            if ($scope.chart && $scope.chart.nodes) {
              var userList = Object.values($scope.chart.nodes).map(function (x) {
                return {
                  id: x.id,
                  pid: x.pid
                };
              });

              var _iterator = _createForOfIteratorHelper(userList),
                  _step;

              try {
                var _loop = function _loop() {
                  var user = _step.value;
                  var member = data.members.find(function (x) {
                    return x.userId._id === user.id;
                  });

                  if (member) {
                    member.upperUserId = user.pid;
                    node = $scope.chart.get(user.id);
                    $log.log(node);
                    member.designation = node.designation;
                    member.description = node.description;
                  }
                };

                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var node;

                  _loop();
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              data.members = data.members.map(function (member) {
                return {
                  userId: member.userId._id,
                  upperUserId: member.upperUserId,
                  designation: member.designation,
                  description: member.description
                };
              });
              $scope.loading = true;
              $log.log(data, "updateOrgchart");
              apiFactory.updateOrgChart(data).then(function (res) {
                $scope.loading = false;
                resolve(res.data.data);
              })["catch"](function (err) {
                $scope.loading = false;
                reject(err);
              });
            }
          });
        }

        $scope.$on('save_org_chart', function () {
          if (!$scope.chart.nodes) return;
          saveOrgChart().then(function (res) {
            $log.log(res);
            var SVGDomElement = $document[0].getElementsByTagName("svg")[0];
            var source = new XMLSerializer().serializeToString(SVGDomElement);
            source = source.replaceAll('x="10" y="20" width="80" height="80"', 'x="10" y="10" width="40" height="40"');
            source = source.replaceAll('<circle cx="50" cy="60" r="40"/>', '<circle cx="30" cy="30" r="20"/>'); //add name spaces.

            if (!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
              source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
            }

            if (!source.match(/^<svg[^>]+"http:\/\/www\.w3\.org\/1999\/xlink"/)) {
              source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
            }

            source = '<?xml version="1.0" standalone="no"?>\r\n' + source;
            var url = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(source);
            var link = $document[0].createElement("a");
            link.href = url;
            link.download = "".concat($scope.projectData.projectName, "_organization_chart.svg");
            $document[0].body.appendChild(link);
            link.click();
            $document[0].body.removeChild(link);
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        });
        $scope.$on('$stateChangeStart', function (event, toState, toParams) {
          saveOrgChart().then(function (res) {
            $log.log(res);
            $state.go(toState, toParams);
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
            $state.go(toState, toParams);
          });
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('collaborationTeamPanel', collaborationTeamPanel);

  function collaborationTeamPanel(globals, apiFactory, $rootScope, utils) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/collaborations/directives/collaborationTeamPanel/collaborationTeamPanel.view.html',
      scope: {
        currentTab: '=bindingCurrentTab',
        managers: '=bindingManagers',
        suppliers: '=bindingSuppliers',
        subcontractors: '=bindingSubcontractors',
        fetchData: "&"
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.utils = utils; // scope.fetchSuppliers = () => {
      //   scope.currentTab = 'Suppliers';
      //   scope.loading = true;
      //   apiFactory.getAllSuppliers({
      //     search: scope.searchText
      //   })
      //     .then(res => {
      //       scope.loading = false;
      //       scope.vendorList = res.data.list;
      //       scope.fetchData() ;
      //     })
      //     .catch(err => {
      //       scope.loading = false;
      //       $log.error(err);
      //       Notification.error(utils.getErrorMessage(err));
      //     })
      // }
      // scope.fetchSubcontractors = () => {
      //   scope.currentTab = 'Sub-contractors';
      //   scope.loading = true;
      //   apiFactory.getAllSubcontractors({
      //     search: scope.searchText
      //   })
      //     .then(res => {
      //       scope.loading = false;
      //       scope.vendorList = res.data.list;
      //       scope.fetchData() ;
      //     })
      //     .catch(err => {
      //       scope.loading = false;
      //       $log.error(err);
      //       Notification.error(utils.getErrorMessage(err));
      //     })
      // }
      // scope.searchData = () => {
      //   if (scope.currentTab === 'Suppliers') {
      //     scope.fetchSuppliers();
      //   } else {
      //     scope.fetchSubcontractors();
      //   }
      // }
      // init
      // scope.fetchSuppliers();

      scope.onClickTab = function (tab) {
        scope.currentTab = tab;
      };

      var colors = ["#FFB900", "#D83B01", "#B50E0E", "#E81123", "#B4009E", "#5C2D91", "#0078D7", "#00B4FF", "#008272", "#107C10"];

      scope.getColor = function (name) {
        if (!name) {
          return;
        }

        name = name.replace(/"/g, '');
        var chars = name.split(' ');
        var codeNum = 0;

        if (chars.length < 2) {
          if (chars[0][0]) {
            codeNum = chars[0].charCodeAt(0);
          }
        } else {
          if (chars[0][0]) {
            codeNum = chars[0].charCodeAt(0);
          }

          if (chars[1][0]) {
            codeNum += chars[1].charCodeAt(0);
          }
        }

        return colors[codeNum % colors.length];
      };
    }
  }
})();


"use strict";

(function () {
  angular.module('app').directive('collaborationManagersPanel', collaborationManagersPanel);

  function collaborationManagersPanel(globals, apiFactory, $rootScope, utils, $document, $log, Notification) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/collaborations/directives/collaborationManagersPanel/collaborationManagersPanel.view.html',
      scope: {
        isolatedBindingUserType: '=bindingUserType',
        isolatedBindingUserTypes: '=bindingUserTypes',
        isolatedBindingUserId: '=bindingUserId',
        isolatedBindingUserList: '=bindingUserList',
        isolatedExpressionFunc: '&'
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.utils = utils;
      scope.managers = [];

      scope.fetchManagers = function () {
        scope.loading = true;
        apiFactory.listAllManagers().then(function (res) {
          scope.loading = false;
          scope.managers = res.data.list;
          $log.error(scope.managers);
        })["catch"](function (err) {
          scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.fetchManagers();
    }
  }
})();


"use strict";

(function () {
  angular.module('app').directive('collaborationFiltersPanel', collaborationFiltersPanel);

  function collaborationFiltersPanel(globals, apiFactory, $rootScope, utils, $document, $log, Notification) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/collaborations/directives/collaborationFiltersPanel/collaborationFiltersPanel.view.html',
      scope: {
        currentTab: '=bindingCurrentTab',
        fetchData: "&"
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.utils = utils;

      scope.fetchSuppliers = function () {
        scope.currentTab = 'Suppliers';
        scope.loading = true;
        apiFactory.getAllSuppliers({
          search: scope.searchText
        }).then(function (res) {
          scope.loading = false;
          scope.vendorList = res.data.list;
          scope.fetchData();
        })["catch"](function (err) {
          scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.fetchSubcontractors = function () {
        scope.currentTab = 'Sub-contractors';
        scope.loading = true;
        apiFactory.getAllSubcontractors({
          search: scope.searchText
        }).then(function (res) {
          scope.loading = false;
          scope.vendorList = res.data.list;
          scope.fetchData();
        })["catch"](function (err) {
          scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      };

      scope.searchData = function () {
        if (scope.currentTab === 'Suppliers') {
          scope.fetchSuppliers();
        } else {
          scope.fetchSubcontractors();
        }
      }; // init


      scope.fetchSuppliers();
      var colors = ["#FFB900", "#D83B01", "#B50E0E", "#E81123", "#B4009E", "#5C2D91", "#0078D7", "#00B4FF", "#008272", "#107C10"];

      scope.getColor = function (name) {
        if (!name) {
          return;
        }

        name = name.replace(/"/g, '');
        var chars = name.split(' ');
        var codeNum = 0;

        if (chars.length < 2) {
          if (chars[0][0]) {
            codeNum = chars[0].charCodeAt(0);
          }
        } else {
          if (chars[0][0]) {
            codeNum = chars[0].charCodeAt(0);
          }

          if (chars[1][0]) {
            codeNum += chars[1].charCodeAt(0);
          }
        }

        return colors[codeNum % colors.length];
      };
    }
  }
})();


"use strict";

(function () {
  angular.module('app').directive('collaborationMenu', collaborationMenu);

  function collaborationMenu($state) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/collaborations/directives/collaboration-menu/collaboration-menu.view.html',
      scope: {},
      link: function link(scope) {
        scope.currentRoute = $state.current.url;
        scope.parentRoute = $state.current.url.split('/')[2];

        if (scope.currentRoute.includes('/')) {
          scope.currentRoute = "".concat(scope.currentRoute.split('/')[2], "/").concat(scope.currentRoute.split('/')[3]); // console.log(scope.currentRoute);
        }
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('editCheckListModal', {
    controller: editCheckListModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/checkList/modals/editCheckListModal/editCheckListModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function editCheckListModal($scope, apiFactory, Notification, globals, utils, $log, storageFactory) {
    var vm = this;
    var projectStore = globals.projectStore;
    vm.projectData = projectStore.get();

    vm.$onInit = function () {
      $scope.checkListData = angular.copy(vm.resolve.checkListData);
      $scope.isLoading = true;
      storageFactory.listAllProjects().then(function (res) {
        $scope.isLoading = false;
        vm.projects = res.data.list;
        vm.projects.unshift({
          _id: undefined,
          projectName: ''
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.removeCheckListItem = function (index) {
      $scope.checkListData.checkListItem.splice(index, 1);
    };

    $scope.addCheckListItem = function () {
      $scope.checkListData.checkListItem.push({
        check: '',
        accept: ''
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onUpdate = function () {
      var data = $scope.checkListData;

      if (utils.isEmpty(data.checkListItem)) {
        Notification.error('Checklist items is empty.');
        return;
      }

      var _iterator = _createForOfIteratorHelper(data.checkListItem),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (utils.isEmpty(item.check) || utils.isEmpty(item.accept)) {
            Notification.error('Fill up all check and accept input.');
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      $scope.isLoading = true;
      apiFactory.updateChecklistById(data._id, data).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err, 'Failed to update a checklist'));
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('createCheckListModal', {
    controller: createCheckListModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/checkList/modals/createCheckListModal/createCheckListModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function createCheckListModal($scope, apiFactory, Notification, globals, utils, $log, storageFactory) {
    var vm = this;
    var projectStore = globals.projectStore;
    vm.projectData = projectStore.get();
    $scope.checkListData = {
      projectId: undefined,
      title: '',
      checkListItem: [{
        check: '',
        accept: ''
      }]
    };

    vm.$onInit = function () {
      $scope.isLoading = true;
      storageFactory.listAllProjects().then(function (res) {
        $scope.isLoading = false;
        vm.projects = res.data.list;
        vm.projects.unshift({
          _id: undefined,
          projectName: ''
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.removeCheckListItem = function (index) {
      $scope.checkListData.checkListItem.splice(index, 1);
    };

    $scope.addCheckListItem = function () {
      $scope.checkListData.checkListItem.push({
        check: '',
        accept: ''
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onCreate = function () {
      var data = $scope.checkListData;

      if (utils.isEmpty(data.checkListItem)) {
        Notification.error('Checklist items is empty.');
        return;
      }

      var _iterator = _createForOfIteratorHelper(data.checkListItem),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (utils.isEmpty(item.check) || utils.isEmpty(item.accept)) {
            Notification.error('Fill up all check and accept input.');
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      $scope.isLoading = true;
      apiFactory.createChecklist(data).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err, 'Failed to create a checklist'));
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('vpGrid', {
    controller: vpGridController,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/vp/vpGrid/vpGrid.view.html'
  });
  /** @ngInject */

  function vpGridController($scope, $rootScope, apiFactory, $state, globals, $uibModal, $log, utils, Notification) {
    var vm = this;
    var projectStore = globals.projectStore,
        companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.project = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    vm.searchText = undefined;
    $scope.plans = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.isLoading = false;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.VP_ACCESS_CREATE = 0;

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    var dType = globals.getDashboardType(vm.userData);

    if (vm.userData.designation === "Admin") {
      $scope.VP_ACCESS_CREATE = 4;
    } else {
      $scope.isLoading = true;
      apiFactory.getAccessSettingDetails({
        dType: dType,
        list: [Constants.AccessKey.VP]
      }).then(function (res) {
        $scope.isLoading = false;
        $scope.VP_ACCESS_CREATE = res.data.data[Constants.AccessKey.VP];
      })["catch"](function (e) {
        $scope.isLoading = false;
        $log.error(e);
        Notification.error('Something went wrong try later');
      });
    }

    vm.fetchAllPlans = function () {
      $scope.isLoading = true;
      apiFactory.getProjectRoofPlans(vm.project._id, {
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.plans = resp.data.data;

        var _iterator = _createForOfIteratorHelper($scope.plans),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var plan = _step.value;

            if (plan.parentAsset && plan.parentAsset.bytes) {
              if (plan.parentAsset.bytes >= 1000000) {
                plan.displaySize = plan.parentAsset.bytes / 1000000;
                plan.displaySizeUnit = 'MB';
              } else if (plan.parentAsset.bytes >= 1000 && plan.parentAsset.bytes < 1000000) {
                plan.displaySize = plan.parentAsset.bytes / 1000;
                plan.displaySizeUnit = 'KB';
              } else {
                plan.displaySize = plan.parentAsset.bytes;
                plan.displaySizeUnit = 'B';
              }
            } else {
              plan.displaySize = 0;
              plan.displaySizeUnit = 'B';
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);

        if (err.status === 403) {
          Notification.error(err.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        }
      });
    };

    vm.fetchAllPlans();
    var searchCallback = $rootScope.$on('search-event', function (event, params) {
      $scope.isLoading = true;
      apiFactory.getProjectRoofPlans(vm.project._id, {
        sort: "created",
        sortType: "false",
        search: params
      }).then(function (data) {
        $scope.isLoading = false;
        $scope.models = data.data.data;
        $scope.totalCount = data.data.data.length;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);

        if (err.status === 403) {
          Notification.error(err.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        }
      });
    });

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.fetchAllPlans();
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchAllPlans();
    };

    $scope.deleteProjectRoofPlan = function (id) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        apiFactory.deleteprojectRoofPlans(id).then(function () {
          vm.fetchAllPlans();
          Notification.success('VP plan was deleted successfully.');
        })["catch"](function (err) {
          $log.error(err);
        });
      }, function (reason) {
        $log.info(reason);
      });
    };

    $rootScope.$on('$destroy', searchCallback);

    $scope.goToDetail = function (planId) {
      $state.go('vpDetail', {
        id: planId
      });
    };

    $scope.addNewPlan = function () {
      $uibModal.open({
        animation: true,
        component: 'filePickerModal',
        size: 'lg',
        keyboard: false
      }).result.then(function (result) {
        if (result) {
          vm.fetchAllPlans();
        }
      });
    };

    vm.downloadPdf = function (plan) {
      $scope.isDownloading = true;
      utils.downloadFile(plan.parentAsset.secure_url).then(function () {
        $scope.isDownloading = false; //$timeout(() => $scope.$apply());
      })["catch"](function (err) {
        $scope.isDownloading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('vpDetailPage', {
    controller: vpDetailPage,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/vp/vpDetailPage/vpDetailPage.view.html',
    bindings: {
      page: '='
    }
  });

  function vpDetailPage($scope, $element, $timeout, $uibModal, $log, VP, apiFactory, pdfFactory, globals, utils, Notification) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore;
    var companyData = companyStore.get();
    vm.projectId = projectStore.get()._id;
    vm.collision = undefined;
    vm.menuPos = {
      x: 0,
      y: 0
    };
    vm.vpObject = {};
    vm.vpObjectPos = {
      x: 0,
      y: 0
    };

    vm.$onInit = function () {
      vm.page.viewer1 = createViewer('#vp-viewer');
      vm.page.viewer = vm.page.viewer1;
      vm.page.brush = vm.page.viewer.brush;
      vm.page.textBrush = vm.page.viewer.textBrush;
      vm.page.zoomLevel = 100;
      vm.page.statusData = {
        isWall: false,
        pos: {
          x: 0.0,
          y: 0.0,
          z: 0.0
        },
        info: {
          area: '',
          width: '',
          height: ''
        }
      };
      vm.page.objectPropertyInfo = {
        width: 0,
        height: 0,
        area: 0,
        perimeterIn: 0,
        perimeterOut: 0
      };
      vm.page.isEdited = false;
      vm.page.unit = "m";
      vm.page.levelFactory = {
        setVisibility: function setVisibility(items, visible) {
          vm.page.viewer.setVisibility(items, visible);
        }
      };
      vm.page.indicator = {
        show: false
      };
      var plan = vm.page.plan;
      angular.element('#vp_initial_loading_popup').show();
      Promise.all([apiFactory.listInventories(plan._id), vm.page.viewer.loadPlan(plan)]).then(function (resp) {
        var inventories = resp[0].data.list;
        refactorInventories(inventories);
        console.log(inventories);

        if (resp[1]) {
          if (resp[1].json) {
            vm.page.viewer.data.setInventoryData(inventories);
          }

          if (resp[1].levels) {
            $scope.$broadcast('level:load', resp[1].levels);
          }
        }

        if (plan.modelData) {
          $scope.modelClosed = true;
          vm.page.bimModel = plan.modelData.model;
          vm.page.bimModel.saved = true;
          vm.page.matchData = plan.modelData.match;
        }

        $scope.$broadcast('level:default');
        angular.element('#vp_initial_loading_popup').hide();
      })["catch"](function (err) {
        $log.error(err);
        angular.element('#vp_initial_loading_popup').hide();
        Notification.error("Plan cannot open!");
      });
      initBoard();

      vm.page.toolbarEvent = function (id) {
        vm.page.viewer.toolbarEvent(id);
      };

      vm.page.undo = function () {
        vm.page.viewer.undo();
      };

      vm.page.redo = function () {
        vm.page.viewer.redo();
      };

      vm.page.closeContextMenu = function () {
        closeContextMenu();
      };

      vm.page.copy = function () {
        closeContextMenu();
        vm.page.viewer.copy();
      };

      vm.page.cut = function () {
        closeContextMenu();
        vm.page.viewer.cut();
      };

      vm.page.paste = function () {
        closeContextMenu();
        vm.page.viewer.paste(vm.menuPos);
      };

      vm.page.applyNegative = function () {
        closeContextMenu();
        vm.page.viewer.negative();
      };

      vm.page.zoomSlider = function (value) {
        vm.page.viewer.setZoom(value / 100);
      };

      vm.page.setColor = function (color) {
        color.replace('#', '0x');
        vm.page.viewer.color = color;
        vm.page.viewer.setColor(color);
      };

      vm.page.setTexture = function (url) {
        vm.page.viewer.setTexture({
          map: url,
          flip: false,
          repeatCountX: 1,
          repeatCountY: 1
        });
      };

      vm.page.onChangeUnit = function () {
        if (vm.selectedData) {
          updateStatusData(vm.selectedData);
        }
      };

      vm.page.changeTextInfo = function (type, value) {
        if (type && value) {
          vm.page.viewer.changeTextInfo(type, value);
        }
      };

      vm.page.onChangeTextFillColor = function (color) {
        vm.page.viewer.changeTextInfo('fill', color);
      };

      vm.page.onChangeTextStrokeColor = function (color) {
        vm.page.viewer.changeTextInfo('stroke', color);
      };

      vm.page.onChangeStrokeColor = function (color) {
        vm.page.viewer.changeObjectInfo('stroke', color);
      };

      vm.page.onChangeThickness = function (value) {
        if (angular.isUndefined(value) || isNaN(value)) return;
        vm.page.viewer.changeThickness(value);
      };

      vm.page.onChangeDashType = function (value) {
        vm.page.viewer.changeDashType(value);
      };

      vm.page.onChangeDashSpace = function (value) {
        vm.page.viewer.changeDashSpace(value);
      };

      vm.page.colorModeChanged = function (color) {
        vm.page.viewer.setColorMode(color.value);
      };

      vm.page.inventoryAssigned = function () {
        vm.page.isEdited = true;
        vm.page.viewer.invalidate();
      };

      vm.page.addCollision = function (plan) {
        vm.collision = plan;
        $timeout(loadCollision, 500);
      };

      vm.page.removeCollision = function () {
        vm.collision = undefined;
        vm.page.viewer = vm.page.viewer1;
        vm.page.viewer.removeColorFilter();

        if (vm.page.viewer2) {
          vm.page.viewer2.destroy();
          vm.page.viewer2 = undefined;
        }
      };

      vm.page.selectCollision = function (type) {
        vm.page.viewer = type === 'original' ? vm.page.viewer1 : vm.page.viewer2;
      };

      vm.page.rotateLeft = function () {
        vm.page.viewer.rotate(-90);
      };

      vm.page.rotateRight = function () {
        vm.page.viewer.rotate(90);
      };

      vm.page.flipHorizontal = function () {
        vm.page.viewer.flipHorizontal();
      };

      vm.page.flipVertical = function () {
        vm.page.viewer.flipVertical();
      };

      vm.page.changeWall = function () {
        if (vm.selectedData) {
          setWallProperty(vm.selectedData.shape);
        }
      };

      vm.page.exportPdf = function () {
        var imageData = vm.page.viewer.getImage();

        if (vm.page.viewer.colorMode === 'inventory') {
          var materials = vm.page.viewer.getColoredInventories();
          pdfFactory.exportPlan(vm.page.title, {
            imageData: imageData,
            materials: materials
          });
        } else {
          pdfFactory.exportPlan(vm.page.title, {
            imageData: imageData
          });
        }
      };

      vm.page.save = function () {
        return save();
      };

      vm.page.syncDataToCalculation = function () {
        return new Promise(function (resolve, reject) {
          var path = 'Root';
          var calcData = vm.page.viewer.exportCalculationData(vm.page.workLevel, vm.page.sections);

          if (angular.isDefined(calcData)) {
            var json = {
              projectId: vm.projectId,
              levelPath: path,
              modelId: vm.page.planId,
              modelName: vm.page.title,
              modelType: "vp",
              data: calcData
            };
            apiFactory.syncViewerToCalc(json).then(function () {
              Notification.success("Calculation data saved.");
              save().then(function () {
                resolve();
              })["catch"](function (err) {
                $log.log(err);
                Notification.error("Plan data was not saved.");
                reject(err);
              });
            })["catch"](function (e) {
              $log.log(e);
              Notification.error("Calculation data cannot be saved.");
              reject(e);
            });
          } else {
            Notification.error("There is no calculation data in plan.");
            reject({
              message: "There is no calculation data in plan."
            });
          }
        });
      };

      vm.page.close = function () {
        if (vm.page.viewer1) {
          vm.page.viewer1.destroy();
          vm.page.viewer1 = undefined;
        }

        if (vm.page.viewer2) {
          vm.page.viewer2.destroy();
          vm.page.viewer2 = undefined;
        }

        vm.page.viewer = undefined;
      };
    };

    function refactorInventories(inventories) {
      inventories.forEach(function (inventory) {
        // if (inventory.section) {
        //   let section = vm.page.sections.find(s => s._id === inventory.section);
        //   inventory.section = section ? section._id : undefined;
        // }
        if (inventory.materials) {
          inventory.materials.forEach(function (mat) {
            var material = vm.page.materials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
            }
          });
        }

        if (inventory.dcps) {
          inventory.dcps.forEach(function (mat) {
            var material = vm.page.comboMaterials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
              mat.comboMaterialList = material.comboMaterialList;
            }
          });
        }
      });
    }

    function loadCollision() {
      if (vm.page.viewer2) {
        vm.page.viewer2.destroy();
        vm.page.viewer2 = undefined;
      }

      vm.page.viewer2 = createViewer('#collision');
      angular.element('#vp_initial_loading_popup').show();
      vm.page.viewer2.loadPlan(vm.collision).then(function () {
        angular.element('#vp_initial_loading_popup').hide();
        vm.page.viewer = vm.page.viewer2;
      })["catch"](function (err) {
        $log.error(err);
        angular.element('#vp_initial_loading_popup').hide();
      });
    }

    function createViewer(container) {
      var viewer = VP.mainViewer($element.find(container)[0]);
      viewer.setInputMethod(companyData && companyData.companyInputMethod === 'European et al.' ? 'eu' : 'en');
      viewer.on('object:added', objectAdded);
      viewer.on('object:removed', objectRemoved);
      viewer.on('object:selected', objectSelected);
      viewer.on('object:modified', objectModified);
      viewer.on('text:selected', textSelected);
      viewer.on('selection:cleared', selectionCleared);
      viewer.on('object:dblclick', objectDblClicked);
      viewer.on('contextmenu', contextMenu);
      viewer.on('zoom:changed', zoomChanged);
      viewer.on('pointer:changed', pointerChanged);
      viewer.on('calibration', calibrate);
      viewer.on('wall', setWallProperty);
      viewer.on('mouse:down', closeContextMenu);
      viewer.on('shortcut:copy', shortcutCopy);
      viewer.on('shortcut:paste', shortcutPaste);
      viewer.on('after:render', afterRender);
      return viewer;
    }

    function objectAdded(object) {
      vm.page.isEdited = true;
      $scope.$broadcast('object:added', object);
    }

    function objectRemoved(object) {
      vm.page.isEdited = true;
      $scope.$broadcast('object:removed', object);
    }

    function objectModified(object) {
      vm.page.isEdited = true;
      vm.selectedData = object;
      vm.page.objectPropertyInfo = object.getGeometricalInfo();
      updateStatusData(object);
    }

    function objectSelected(object) {
      if (angular.isUndefined(object)) return;
      vm.selectedData = object;
      var shape = object.shape;
      vm.page.brush = {
        strokeColor: shape.stroke,
        strokeWidth: shape.strokeWidth,
        dashType: shape.info && shape.info.dashType ? shape.info.dashType : 1,
        strokeDashArray: shape.strokeDashArray
      };
      vm.page.objectPropertyInfo = object.getGeometricalInfo();
      updateStatusData(object);
    }

    function textSelected(data) {
      selectionCleared();
      vm.page.textBrush = {
        text: data.text,
        fontSize: data.fontSize,
        fontStyle: data.fontStyle,
        fontFamily: data.fontFamily,
        strokeColor: data.stroke,
        fillColor: data.fill,
        strokeWidth: data.strokeWidth
      };
      $timeout(function () {
        return $scope.$apply();
      });
    }

    function selectionCleared() {
      vm.page.brush = vm.page.viewer.brush;
      vm.page.textBrush = vm.page.viewer.textBrush;
      vm.selectedData = undefined;
      vm.page.objectPropertyInfo = {
        width: 0,
        height: 0,
        area: 0,
        perimeterIn: 0,
        perimeterOut: 0
      };
    }

    function pointerChanged(data) {
      vm.page.statusData.pos.x = data.x;
      vm.page.statusData.pos.y = data.y;
      $scope.$apply();
    }

    function zoomChanged(e) {
      vm.page.zoomLevel = Math.ceil(e.level * 100);
      $timeout(function () {
        return $scope.$apply();
      });

      if (vm.page.viewer1 && vm.page.viewer2) {
        var other = vm.page.viewer1 === e.target ? vm.page.viewer2 : vm.page.viewer1;
        other.setZoom(e.level);
      }
    }

    function objectDblClicked(data) {
      vm.vpObject = data.object;

      if (vm.vpObject) {
        vm.vpObject.guid = data.object.uuid;
        vm.vpObject.name = data.object.name;
      }

      vm.vpObjectPos = Object.assign({
        x: data.x,
        y: data.y
      });
      vm.page.indicator.vpObject = vm.vpObject;
      vm.page.indicator.pos = vm.vpObjectPos;
      angular.element('#vp-property-indicator').show();
      angular.element('#vp_property_expand_icon').css('left', vm.vpObjectPos.x - 15 + 'px');
      angular.element('#vp_property_expand_icon').css('top', vm.vpObjectPos.y - 15 + 'px');
    }

    function afterRender() {
      if (vm.page.bimModel) {
        $scope.$broadcast('after:render');
      }
    }

    function calibrate(_distance) {
      $uibModal.open({
        animation: true,
        component: 'calibrationModal',
        windowClass: 'vp-calibration-modal',
        backdropClass: 'vp-calibration-modal-backdrop',
        resolve: {
          distance: function distance() {
            return _distance;
          }
        }
      }).result.then(function (result) {
        vm.page.viewer.setCalibration(result);
        vm.page.isEdited = true;
      });
    }

    function setWallProperty(wall) {
      $uibModal.open({
        animation: true,
        component: 'wallModal',
        windowClass: 'vp-wall-modal',
        backdropClass: 'vp-wall-modal-backdrop',
        resolve: {
          property: function property() {
            return vm.page.viewer.getWallProperty(wall);
          }
        }
      }).result.then(function (result) {
        vm.page.viewer.setWallProperty(wall, {
          zHeight: result
        });
        vm.page.isEdited = true;

        if (vm.selectedData) {
          vm.page.objectPropertyInfo = vm.selectedData.getGeometricalInfo();
          updateStatusData(vm.selectedData);
        }
      });
    }

    function shortcutCopy() {
      vm.copy();
    }

    function shortcutPaste() {
      if (vm.page.viewer.isEmptyClipboard()) return;
      vm.page.viewer.paste({
        x: vm.page.viewer._clipboard.left + 10,
        y: vm.page.viewer._clipboard.top + 10
      });
    }

    function contextMenu(e) {
      angular.element("#context_menu_2d").show();

      if (vm.page.viewer.getActiveObject()) {
        angular.element("#context_menu_copy").removeClass('disabled');
        angular.element("#context_menu_cut").removeClass('disabled');
        angular.element("#context_menu_apply_negative").removeClass('disabled');
      } else {
        angular.element("#context_menu_copy").addClass('disabled');
        angular.element("#context_menu_cut").addClass('disabled');
        angular.element("#context_menu_apply_negative").addClass('disabled');
      }

      if (vm.page.viewer.isEmptyClipboard()) {
        angular.element("#context_menu_paste").addClass('disabled');
      } else {
        angular.element("#context_menu_paste").removeClass('disabled');
      }

      vm.menuPos.x = e.x;
      vm.menuPos.y = e.y;
      angular.element("#context_menu_2d").css({
        top: e.y + 'px',
        left: e.x + 'px'
      });
      return false;
    }

    function updateStatusData(object) {
      var scale = 1;
      var decimal = 4;

      if (vm.page.unit === 'cm') {
        scale = 100;
        decimal = 2;
      } else if (vm.page.unit === 'mm') {
        scale = 1000;
        decimal = 0;
      } else if (vm.page.unit === 'inch') {
        scale = 39.3701;
        decimal = 2;
      }

      var info = object.getGeometricalInfo();
      vm.page.statusData.info.area = utils.roundNumber(info.area * scale * scale, decimal);
      vm.page.statusData.info.width = utils.roundNumber(info.width * scale, decimal);
      vm.page.statusData.info.height = utils.roundNumber(info.height * scale, decimal);

      if (angular.isDefined(info.wallHeight)) {
        vm.page.statusData.isWall = true;
        vm.page.statusData.info.wallHeight = info.wallHeight * scale;
      } else {
        vm.page.statusData.isWall = false;
        vm.page.statusData.info.wallHeight = undefined;
      }

      $timeout(function () {
        return $scope.$apply();
      });
    }

    function closeContextMenu() {
      angular.element("#context_menu_2d").hide();
      angular.element("#context_menu_apply_negative").removeClass('disabled');
    }

    function saveViewer(viewer, title, workLevel) {
      var data = angular.toJson({
        json: viewer.getJSON(),
        planInfo: viewer.getPlanData(),
        levels: viewer.levels
      });
      var inventoryData = viewer.data.getInventoryData();
      var planData = {
        jsonString: data,
        calibration: viewer.calibration
      };

      if (title) {
        planData.title = title;
      }

      if (workLevel) {
        planData.workLevel = workLevel;
      }

      return Promise.all([apiFactory.saveRoofPlan(viewer.data.id, planData), apiFactory.saveInventories({
        project: vm.projectId,
        modelId: viewer.data.id,
        inventories: inventoryData
      })]);
    }

    function save() {
      var promises = [saveViewer(vm.page.viewer1, vm.page.title, vm.page.workLevel)];

      if (vm.page.viewer2) {
        promises.push(saveViewer(vm.page.viewer2));
      }

      return new Promise(function (resolve, reject) {
        Promise.all(promises).then(function () {
          vm.page.isEdited = false;
          Notification.success("Plan is saved successfully.");
          resolve();
        })["catch"](function (err) {
          Notification.error("Failed to save. Try again.");
          $log.log(err);
          reject(err);
        });
      });
    }

    function initBoard() {
      // if (vm.projectId !== "5e1373d1275c0808a814d240") return;
      var userData = globals.userStore.get();
      vm.page.board = VP.board();
      vm.page.board.setViewer(vm.page.viewer, userData);
      apiFactory.updateChannelMembersForBoard({
        projectId: vm.projectId,
        planId: vm.page.plan._id
      }).then(function () {
        apiFactory.generateTextChatAccessToken({
          identity: userData._id,
          chatType: 'board'
        }).then(function (resp) {
          Twilio.Chat.Client.create(resp.data.token).then(function (client) {
            client.on('channelAdded', function (channel) {
              if (channel.channelState.uniqueName === vm.page.plan._id && vm.page.board) {
                vm.page.board.enterMessaging(channel);
              }
            });
            client.on('channelLeft', function (channel) {
              vm.page.board.leaveMessaging(channel);
            });
            client.on('channelRemoved', function (channel) {
              vm.page.board.leaveMessaging(channel);
            });
          })["catch"](function (error) {
            $log.error(error);
            Notification.error('Something went wrong try later');
          });
        })["catch"](function (error) {
          $log.error(error);
          Notification.error('Something went wrong try later');
        });
      })["catch"](function (err) {
        $log.error(err);
      });
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('vpDetail', {
    controller: vpController,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/vp/vpDetail/vpDetail.view.html'
  }); // /////////////////////////////

  /** @ngInject */

  function vpController($scope, apiFactory, $state, $stateParams, $log, Notification, globals, localStorageService, $uibModal) {
    var projectStore = globals.projectStore,
        companyStore = globals.companyStore,
        userStore = globals.userStore;
    var vm = this;
    vm.project = projectStore.get();
    vm.userData = userStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    vm.companyData = companyStore.get();
    vm.projectId = vm.project._id;
    vm.pages = [];
    vm.curPage = undefined;
    vm.materials = [];
    vm.comboMaterials = [];
    vm.equipments = [];
    vm.comboEquipments = [];
    vm.workLevels = [];
    vm.workTypes = [];
    vm.sections = [];
    vm.propertyScale = 1;
    vm.propertyUnit = 'm';
    $scope.toolbarList = [{
      id: 'select',
      icon: "drawing-select.svg",
      description: "Select"
    }, {
      id: 'pan',
      icon: "pan-move.svg",
      description: "Pan move"
    }, {
      id: 0,
      icon: "drawing.svg",
      description: "Draw",
      submenu: [{
        id: 'rect',
        icon: "drawing-rect.svg",
        description: "Draw rectangle"
      }, {
        id: 'circle',
        icon: "drawing-circle.svg",
        description: "Draw circle"
      }, {
        id: 'sector',
        icon: "drawing-sector.svg",
        description: "Draw sector"
      }, {
        id: 'hexagon',
        icon: "drawing-hex.svg",
        description: "Draw hexagon"
      }, {
        id: 'line',
        icon: "drawing-line.svg",
        description: "Draw line"
      }, {
        id: 'polyline',
        icon: "drawing-polyline.svg",
        description: "Draw poly line"
      }, {
        id: 'curve',
        icon: "drawing-curve.svg",
        description: "Draw curve"
      }, {
        id: 'arc',
        icon: "drawing-arc.svg",
        description: "Draw arc"
      }, {
        id: 'freeline',
        icon: "drawing-path.svg",
        description: "Draw free line"
      }, {
        id: 'wall',
        icon: "drawing-wall.svg",
        description: "Draw wall"
      }, {
        id: 'arrow_line_up',
        icon: "arrow-up.svg",
        description: "Draw up arrow"
      }, {
        id: 'arrow_line_down',
        icon: "arrow-down.svg",
        description: "Draw down arrow"
      }, {
        id: 'arrow_line_both_sides',
        icon: "arrow-both.svg",
        description: "Draw arrow"
      }]
    }, {
      id: 'eraser',
      icon: "drawing-erase.svg",
      description: "Erase"
    }, {
      id: 0,
      icon: "drawing-measure.svg",
      description: "Measure",
      submenu: [{
        id: 'calibrator',
        icon: "drawing-unit.svg",
        description: "Calibrate distance"
      }, {
        id: 'length',
        icon: "drawing-measure-dist.svg",
        description: "Measure length"
      }, {
        id: 'angle',
        icon: "drawing-measure.svg",
        description: "Measure angle"
      }, {
        id: 'surface',
        icon: "drawing-measure-area.svg",
        description: "Measure area"
      }]
    }, {
      id: 'text',
      icon: "drawing-text.svg",
      description: "Draw text"
    }, {
      id: 'zoom',
      icon: "drawing-zoom.svg",
      description: "Zoom"
    }, {
      id: 'color',
      icon: "drawing-picker.svg",
      description: "Pick a color"
    }, {
      id: 'bucket',
      icon: "drawing-paint.svg",
      description: "Fill bucket"
    }, {
      id: 0,
      icon: "drawing-48.svg",
      description: "Z-order",
      submenu: [{
        id: 'front',
        icon: "drawing-45.svg",
        description: "Bring to front"
      }, {
        id: 'back',
        icon: "drawing-46.svg",
        description: "Move to back"
      }]
    }];
    $scope.modelClosed = true;
    $scope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (!toState.redirectTo && vm.curPage && vm.curPage.isEdited) {
        event.preventDefault();
        $uibModal.open({
          animation: true,
          component: 'alertModal',
          size: 'sm',
          resolve: {
            title: function title() {
              return 'Warning';
            },
            message: function message() {
              return 'You have unsaved edit. Do you want to save?';
            },
            positive: function positive() {
              return 'Save';
            }
          }
        }).result.then(function () {
          vm.curPage.save().then(function () {
            return $state.go(toState, toParams);
          })["catch"](function (err) {
            return $log.error(err);
          });
        }, function (reason) {
          if (reason === 'cancel') {
            vm.curPage.isEdited = false;
            $state.go(toState, toParams);
          }
        });
      }
    }); // option menu

    function OptionMenu() {
      this.menu = null;

      this.toggle = function (name) {
        this.menu = this.menu === name ? null : name;
      };

      this.isShow = function (name) {
        return this.menu === name;
      };
    }

    vm.optionMenu = {
      isShow: false,
      toggle: function toggle() {
        this.isShow = !this.isShow;

        if (this.isShow) {
          angular.element(".menu-collapse-button").addClass("open");
          angular.element(".option-menu").addClass("active");
        } else {
          angular.element(".menu-collapse-button").removeClass("open");
          angular.element(".option-menu").removeClass("active");
        }
      },
      close: function close() {
        this.isShow = false;
        angular.element(".menu-collapse-button").removeClass("open");
        angular.element(".option-menu").removeClass("active");
      },
      main: new OptionMenu(),
      model: new OptionMenu()
    };
    vm.issueMenu = {
      isShow: false,
      toggle: function toggle() {
        angular.element("#registration-menu").removeClass("active");
        angular.element("#vp-collision-menu").removeClass("active");
        this.isShow = !this.isShow;

        if (this.isShow) {
          angular.element("#issue-menu").addClass("active");
        } else {
          angular.element("#issue-menu").removeClass("active");
        }
      },
      close: function close() {
        this.isShow = false;
        angular.element("#issue-menu").removeClass("active");
      }
    };
    vm.registrationMenu = {
      isShow: false,
      toggle: function toggle() {
        angular.element("#issue-menu").removeClass("active");
        angular.element("#vp-collision-menu").removeClass("active");
        this.isShow = !this.isShow;

        if (this.isShow) {
          angular.element("#registration-menu").addClass("active");
        } else {
          angular.element("#registration-menu").removeClass("active");
        }
      },
      close: function close() {
        this.isShow = false;
        angular.element("#registration-menu").removeClass("active");
      }
    };
    vm.collisionMenu = {
      isShow: false,
      toggle: function toggle() {
        angular.element("#issue-menu").removeClass("active");
        angular.element("#registration-menu").removeClass("active");
        this.isShow = !this.isShow;

        if (this.isShow) {
          angular.element("#vp-collision-menu").addClass("active");
        } else {
          angular.element("#vp-collision-menu").removeClass("active");
        }
      },
      close: function close() {
        this.isShow = false;
        angular.element("#vp-collision-menu").removeClass("active");
      }
    };
    angular.element('#vp_initial_loading_popup').show();
    Promise.all([apiFactory.getRoofPlan($stateParams.id), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getWorkLevelAndTypes(), apiFactory.getCalcSheet(vm.projectId)]).then(function (resp) {
      angular.element('#vp_initial_loading_popup').hide();
      var plan = resp[0].data.data;
      vm.materials = resp[1].data.list || [];
      vm.comboMaterials = resp[2].data.list || [];
      vm.equipments = resp[3].data.list || [];
      vm.comboEquipments = resp[4].data.list || [];

      if (resp[5].data.data) {
        if (resp[5].data.data.workLevels) {
          vm.workLevels = resp[5].data.data.workLevels;
        }

        if (resp[5].data.data.workTypes) {
          vm.workTypes = resp[5].data.data.workTypes;
        }
      }

      if (resp[6].data.data) {
        vm.sections = resp[6].data.data.levels;
      }

      vm.curPage = {
        plan: plan,
        planId: plan._id,
        title: plan.assetObj.title,
        workLevel: plan.assetObj.level,
        materials: vm.materials,
        comboMaterials: vm.comboMaterials,
        sections: vm.sections
      };
      vm.pages.push(vm.curPage);
    })["catch"](function (err) {
      $log.error(err);
      Notification.error("Cannot load vp data.");
      angular.element('#vp_initial_loading_popup').hide();
    });

    vm.openPage = function () {
      $uibModal.open({
        animation: true,
        component: 'openVpModal',
        windowClass: 'vp-open-model-modal'
      }).result.then(function (result) {
        vm.curPage = {
          plan: result.plan,
          planId: result.plan._id,
          title: result.plan.assetObj.title,
          workLevel: result.plan.assetObj.level,
          materials: vm.materials,
          comboMaterials: vm.comboMaterials,
          sections: vm.sections
        };
        vm.pages.push(vm.curPage);
      });
    };

    vm.closePage = function (page, index) {
      if (page === vm.curPage) {
        vm.curPage = index > 0 ? vm.pages[index - 1] : vm.pages[index + 1];
      }

      page.close();
      vm.pages.splice(index, 1);
    };

    $scope.gotoHome = function () {
      $state.go('vpGrid');
    };

    $scope.gotoCalc = function () {
      if (vm.curPage) {
        vm.curPage.syncDataToCalculation().then(function () {
          return $state.go('calcMain');
        })["catch"](function (err) {
          return $log.error(err);
        });
      }
    };

    $scope.save = function () {
      if (vm.curPage) {
        vm.curPage.save();
      }
    };

    $scope.exportPdf = function () {
      if (vm.curPage) {
        vm.curPage.exportPdf();
      }
    };

    vm.onChangePropertyUnit = function (unit) {
      vm.propertyUnit = unit;
      var scale = 1;

      if (unit === 'cm') {
        scale = 100;
      } else if (unit === 'mm') {
        scale = 1000;
      } else if (unit === 'inch') {
        scale = 39.3701;
      }

      vm.propertyScale = scale;
    };

    vm.addModel = function () {
      $uibModal.open({
        animation: true,
        component: 'openModelModal',
        windowClass: 'bim-open-model-modal'
      }).result.then(function (result) {
        vm.optionMenu.close();
        $scope.modelClosed = false;
        vm.curPage.bimModel = result.model;
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.showModel = function () {
      vm.optionMenu.close();
      $scope.modelClosed = false;
    };

    vm.deleteModel = function () {
      vm.optionMenu.close();
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        if (vm.curPage.bimModel.saved) {
          apiFactory.deleteModelFromRoofPlan(vm.curPage.planId).then(function () {
            vm.curPage.bimModel = undefined;
            vm.curPage.matchData = undefined;
            $scope.modelClosed = true;
            Notification.success('Model deleted successfully.');
          })["catch"](function (err) {
            $log.error(err);
          });
        } else {
          vm.curPage.bimModel = undefined;
          $scope.modelClosed = true;
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.closeModel = function () {
      vm.optionMenu.close();
      $scope.modelClosed = true;
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('photoGrid', {
    controller: photoGridController,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/photo/photoGrid/photoGrid.view.html'
  });
  /** @ngInject */

  function photoGridController(globals, $scope, Notification, $log, apiFactory, $uibModal, $state, utils) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.PHOTO_ACCESS_CREATE = 4; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.PHOTO_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.PHOTO]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.PHOTO_ACCESS_CREATE = res.data.data[Constants.AccessKey.PHOTO];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later');
    //     });
    // }

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.periods = [{
      id: '8',
      name: '8'
    }, {
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.photos = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 8;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    vm.companyData = companyStore.get();
    $scope.isLoading = false;

    vm.fetchAllPhotos = function () {
      $scope.isLoading = true;
      apiFactory.listPanorama(vm.project._id, {
        sort: "createdAt",
        sortType: "false",
        page: vm.currentPage,
        chunk: $scope.numPerPage
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.photos = resp.data.data;

        var _iterator = _createForOfIteratorHelper($scope.photos),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var photo = _step.value;
            var funcName = void 0;

            if (vm.companyData.companyInputMethod == 'British/American et al.') {
              funcName = 'roundNumber';
            } else {
              funcName = 'comma2decimal';
            }

            if (photo.size >= 1000000) {
              photo.displaySize = utils[funcName](photo.size / 1000000, 1);
              photo.displaySizeUnit = 'MB';
            } else if (photo.size >= 1000 && photo.size < 1000000) {
              photo.displaySize = utils[funcName](photo.size / 1000, 1);
              photo.displaySizeUnit = 'KB';
            } else if (photo.size >= 0 && photo.size < 1000) {
              photo.displaySize = utils[funcName](photo.size, 1);
              photo.displaySizeUnit = 'B';
            } else {
              photo.displaySize = 0;
              photo.displaySizeUnit = 'B';
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);

        if (err.status === 403) {
          Notification.error(err.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        }
      });
    };

    vm.fetchAllPhotos();

    $scope.goToDetail = function (photoId) {
      $state.go('photoDetail', {
        id: photoId
      });
    };

    $scope.deletePhoto = function (id) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        apiFactory.deletePanorama(id).then(function () {
          vm.fetchAllPhotos();
          Notification.success('360 Degree Photo was deleted successfully.');
        })["catch"](function (err) {
          $log.error(err);
        });
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchAllPhotos();
    };

    vm.openDlgUpload = function () {
      $uibModal.open({
        animation: true,
        component: 'uploadPhotoModal',
        windowClass: 'upload-photo-modal'
      }).result.then(function (result) {
        if (result) {
          vm.fetchAllPhotos();
        }
      }, function (reason) {
        $log.log(reason);
      });
    };
  }
})();


"use strict";

var THREE;

(function () {
  'use strict';

  angular.module('app').component('photoDetail', {
    controller: photoDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/photo/photoDetail/photoDetail.view.html'
  });
  /** @ngInject */

  function photoDetailController($scope, authFactory, $state, $stateParams, $log, apiFactory, Notification, globals, $window) {
    var logout = globals.logout,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore,
        userStore = globals.userStore;
    var vm = this;
    vm.userData = userStore.get();
    $scope.PHOTO_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);

    var isUserInteracting = false,
        onPointerDownMouseX = 0,
        onPointerDownMouseY = 0,
        lon = 0,
        onPointerDownLon = 0,
        lat = 0,
        onPointerDownLat = 0,
        phi = 0,
        theta = 0; // if (vm.userData.designation === "Admin") {
    //   $scope.PHOTO_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.PHOTO]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.PHOTO_ACCESS_CREATE = res.data.data[Constants.AccessKey.PHOTO];
    //   })
    //   .catch((e) => {
    //     $scope.isLoading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    if (!authFactory.checkUser()) {
      logout();
      return;
    }

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go('clientManage');
      return;
    }

    vm.companyData = companyStore.get();
    vm.modelId = $stateParams.id;
    vm.title = "360 Degree Photo";
    vm.projectId = vm.project._id;
    $scope.isLoading = true;

    if ($stateParams && $stateParams.id) {
      angular.element("#initial_loading_popup").show();
      Promise.all([apiFactory.getPanoramaById($stateParams.id)]).then(function (resp) {
        var photo = resp[0].data.data;
        vm.pcdId = photo._id;
        vm.title = photo.name;
        $scope.isLoading = false;
        vm.pcdScene = new THREE.Scene();
        vm.pcdScene.background = new THREE.Color(0x000000);
        var divpcd = angular.element("#panorama")[0];
        vm.pcdCamera = new THREE.PerspectiveCamera(75, $window.innerWidth / $window.innerHeight, 1, 1100);
        vm.geometry = new THREE.SphereGeometry(500, 60, 40);
        vm.geometry.scale(-1, 1, 1);
        var texture = new THREE.TextureLoader().load(photo.sourceUrl);
        vm.material = new THREE.MeshBasicMaterial({
          map: texture
        }); // create sphere

        vm.sphere = new THREE.Mesh(vm.geometry, vm.material); // add scene

        vm.pcdScene.add(vm.sphere);
        vm.renderer = new THREE.WebGLRenderer();
        vm.renderer.setPixelRatio($window.devicePixelRatio);
        vm.renderer.setSize($window.innerWidth, $window.innerHeight);
        divpcd.appendChild(vm.renderer.domElement);
        animate();
        divpcd.addEventListener('pointerdown', onPointerDown);
        angular.element("#initial_loading_popup").hide();
        $window.document.addEventListener('wheel', onDocumentMouseWheel);
      })["catch"](function (e) {
        $log.error(e);
        angular.element("#initial_loading_popup").hide();
        Notification.error("Error occurred during load data.");
      });
    }

    vm.gotoHome = function () {
      vm.stopRendering = true;
      $state.go('photoGrid');
    };

    vm.stopRendering = false;

    function animate() {
      if (!vm.stopRendering) {
        if (isUserInteracting === false) {
          lon += 0.1;
        }

        lat = Math.max(-85, Math.min(85, lat));
        phi = THREE.MathUtils.degToRad(90 - lat);
        theta = THREE.MathUtils.degToRad(lon);
        var x = 500 * Math.sin(phi) * Math.cos(theta);
        var y = 500 * Math.cos(phi);
        var z = 500 * Math.sin(phi) * Math.sin(theta);
        requestAnimationFrame(animate);
        vm.pcdCamera.lookAt(x, y, z);
        vm.renderer.render(vm.pcdScene, vm.pcdCamera);
      }
    }

    function onPointerDown(event) {
      if (event.isPrimary === false) return;
      isUserInteracting = true;
      onPointerDownMouseX = event.clientX;
      onPointerDownMouseY = event.clientY;
      onPointerDownLon = lon;
      onPointerDownLat = lat;
      $window.document.addEventListener('pointermove', onPointerMove);
      $window.document.addEventListener('pointerup', onPointerUp);
    }

    function onPointerMove(event) {
      if (event.isPrimary === false) return;
      lon = (onPointerDownMouseX - event.clientX) * 0.1 + onPointerDownLon;
      lat = (event.clientY - onPointerDownMouseY) * 0.1 + onPointerDownLat;
    }

    function onPointerUp() {
      if (event.isPrimary === false) return;
      isUserInteracting = false;
      $window.document.removeEventListener('pointermove', onPointerMove);
      $window.document.removeEventListener('pointerup', onPointerUp);
    }

    function onDocumentMouseWheel(event) {
      var fov = vm.pcdCamera.fov + event.deltaY * 0.05;
      vm.pcdCamera.fov = THREE.MathUtils.clamp(fov, 10, 75);
      vm.pcdCamera.updateProjectionMatrix();
    }
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('pcdGrid', {
    controller: pcdGridController,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/pcd/pcdGrid/pcdGrid.view.html'
  });
  /** @ngInject */

  function pcdGridController(globals, $scope, Notification, $log, apiFactory, $uibModal, $state, utils) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.PCD_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.PCD_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.PCD]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.PCD_ACCESS_CREATE = res.data.data[Constants.AccessKey.PCD];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later');
    //     });
    // }

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.periods = [{
      id: '8',
      name: '8'
    }, {
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.pcds = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 8;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    vm.companyData = companyStore.get();
    $scope.isLoading = false;

    vm.fetchAllPCDs = function () {
      $scope.isLoading = true;
      apiFactory.listPCD(vm.project._id, {
        sort: "createdAt",
        sortType: "false",
        page: vm.currentPage,
        chunk: $scope.numPerPage
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.pcds = resp.data.data;

        var _iterator = _createForOfIteratorHelper($scope.pcds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var pcd = _step.value;
            var funcName = void 0;

            if (vm.companyData.companyInputMethod == 'British/American et al.') {
              funcName = 'roundNumber';
            } else {
              funcName = 'comma2decimal';
            }

            if (pcd.size >= 1000000) {
              pcd.displaySize = utils[funcName](pcd.size / 1000000, 1);
              pcd.displaySizeUnit = 'MB';
            } else if (pcd.size >= 1000 && pcd.size < 1000000) {
              pcd.displaySize = utils[funcName](pcd.size / 1000, 1);
              pcd.displaySizeUnit = 'KB';
            } else if (pcd.size >= 0 && pcd.size < 1000) {
              pcd.displaySize = utils[funcName](pcd.size, 1);
              pcd.displaySizeUnit = 'B';
            } else {
              pcd.displaySize = 0;
              pcd.displaySizeUnit = 'B';
            }

            if (pcd.url.includes(".pcd")) pcd.type = "PCD";else {
              pcd.type = "Raw File";
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);

        if (err.status === 403) {
          Notification.error(err.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        }
      });
    };

    vm.fetchAllPCDs();

    $scope.goToDetail = function (pcdId) {
      $state.go('pcdDetail', {
        id: pcdId
      });
    };

    $scope.deletePointCloud = function (id) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        apiFactory.deletePCD(id).then(function () {
          vm.fetchAllPCDs();
          Notification.success('Point cloud was deleted successfully.');
        })["catch"](function (err) {
          $log.error(err);
        });
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchAllPlans();
    };

    vm.openDlgUpload = function () {
      $uibModal.open({
        animation: true,
        component: 'uploadPcdModal',
        windowClass: 'upload-pcd-modal'
      }).result.then(function (result) {
        if (result) {
          vm.fetchAllPCDs();
        }
      }, function (reason) {
        $log.log(reason);
      });
    };
  }
})();


"use strict";

var THREE;

(function () {
  'use strict';

  angular.module('app').component('pcdGenerate', {
    controller: pcdGenerateController,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/pcd/pcdGenerate/pcdGenerate.view.html'
  });
  /** @ngInject */

  function pcdGenerateController($state, $log, $document) {
    var vm = this;
    vm.pcdScene = new THREE.Scene();
    vm.pcdScene.background = new THREE.Color(0x000000);
    var divpcd = angular.element("#pointCloud")[0];
    vm.pcdCamera = new THREE.PerspectiveCamera(15, divpcd.offsetWidth / divpcd.offsetHeight, 0.001, 100);
    vm.pcdScene.add(vm.pcdCamera);
    var pcdcanvas = $document[0].createElement('canvas');
    var pcdcontext = pcdcanvas.getContext('webgl2', {
      alpha: true,
      antialias: true,
      preserveDrawingBuffer: true
    });
    vm.pcdRenderer = new THREE.WebGLRenderer({
      canvas: pcdcanvas,
      context: pcdcontext
    });
    vm.pcdRenderer.setSize(divpcd.offsetWidth, divpcd.offsetHeight);
    divpcd.appendChild(pcdcanvas);
    animate();

    vm.gotoHome = function () {
      $state.go('pcdGrid');
    };

    vm.pcdFileUpdatedDepth = function (file) {
      if (!file) return;
      var reader = new FileReader();
      reader.readAsText(file);
      var pointArray = [];

      reader.onload = function () {
        $log.info(reader.result);

        if (reader.result) {
          pointArray = reader.result.split(",");
          pointArray = pointArray.map(function (elm) {
            return parseFloat(elm);
          });
          $log.info(pointArray);
        }

        calculatePointCloud(pointArray);
      };

      reader.onerror = function () {
        $log.error(reader.error);
      };
    };

    function animate() {
      var divpcd = angular.element("#pointCloud")[0];
      vm.pcdCamera.aspect = divpcd.offsetWidth / divpcd.offsetHeight;
      vm.pcdCamera.updateProjectionMatrix();
      requestAnimationFrame(animate);
      if (vm.pcdcontrols) vm.pcdcontrols.update();
      vm.pcdRenderer.render(vm.pcdScene, vm.pcdCamera);
    }

    vm.pcdFileUpdatedColor = function (file) {
      if (!file) return; // let fileURL = URL.createObjectURL(file);
      // let canvas = $document[0].createElement('canvas');
      // let ctx = canvas.getContext('2d');
      // let image = new Image();
      // image.onload = function () {
      //   canvas.width = image.width;
      //   canvas.height = image.height;
      //   ctx.drawImage(image, 0, 0);
      //   let imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      //   vm.colorMat = cv.matFromImageData(imgData);
      //   if( vm.depthMat ){
      //     calculatePointCloud();
      //   }
      // };
      // image.onerror = function (e) {
      //   $log.error(e);
      // }
      // image.src = fileURL;
    };

    function calculatePointCloud(pointArray) {
      var geometry = new THREE.BufferGeometry();
      var material = new THREE.PointsMaterial({
        color: new THREE.Color(1, 1, 1),
        size: 0.001,
        vertexColors: true
      });
      var pos = [];
      var col = [];

      for (var m = 0; m < (pointArray.length - 1) / 6; m++) {
        pos.push(pointArray[m * 6 + 0]);
        pos.push(pointArray[m * 6 + 1]);
        pos.push(pointArray[m * 6 + 2]);
        col.push(pointArray[m * 6 + 3] / 255.0);
        col.push(pointArray[m * 6 + 4] / 255.0);
        col.push(pointArray[m * 6 + 5] / 255.0);
        col.push(1.0);
      }

      geometry.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
      geometry.setAttribute('color', new THREE.Float32BufferAttribute(col, 4));
      var points = new THREE.Points(geometry, material);
      vm.pcdScene.add(points);
      points.geometry.computeBoundingSphere();
      var center = points.geometry.boundingSphere.center;
      var radius = points.geometry.boundingSphere.radius;
      if (radius) vm.pcdCamera.position.set(center.x, center.y, center.z - radius * 5);else vm.pcdCamera.position.set(center.x, center.y, -5);
      vm.pcdCamera.up.set(0, -1, 0);
      vm.pcdCamera.far = Math.max(10.0 * (center.length() + radius), 2000);
      vm.pcdcontrols = new THREE.TrackballControls(vm.pcdCamera, vm.pcdRenderer.domElement);
      vm.pcdcontrols.rotateSpeed = 2.0;
      vm.pcdcontrols.zoomSpeed = 2.0;
      vm.pcdcontrols.panSpeed = 0.2;
      vm.pcdcontrols.staticMoving = true;
      vm.pcdcontrols.minDistance = 0.3;
      vm.pcdcontrols.maxDistance = Math.max(10.0 * (center.length() + radius), 2000);
      vm.pcdcontrols.target.set(center.x, center.y, center.z);
      vm.pcdcontrols.update();
      vm.prevPoints = points;
    }
  }
})();


"use strict";

var THREE;

(function () {
  'use strict';

  angular.module('app').component('pcdDetail', {
    controller: pcdDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/pcd/pcdDetail/pcdDetail.view.html'
  });
  /** @ngInject */

  function pcdDetailController($scope, authFactory, $state, $stateParams, $document, $log, apiFactory, Notification, globals, utils) {
    var logout = globals.logout,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore,
        userStore = globals.userStore;
    var vm = this;
    vm.userData = userStore.get();
    $scope.DVIEWER_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.DVIEWER_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.DVIEWER]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.DVIEWER_ACCESS_CREATE = res.data.data[Constants.AccessKey.DVIEWER];
    //   })
    //   .catch((e) => {
    //     $scope.isLoading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    if (!authFactory.checkUser()) {
      logout();
      return;
    }

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go('clientManage');
      return;
    }

    vm.companyData = companyStore.get();
    vm.modelId = $stateParams.id;
    vm.title = "Point Cloud";
    vm.projectId = vm.project._id;
    $scope.isLoading = true;

    if ($stateParams && $stateParams.id) {
      angular.element("#initial_loading_popup").show();
      Promise.all([apiFactory.getPCDById($stateParams.id)]).then(function (resp) {
        var pcd = resp[0].data.data;
        vm.pcdId = pcd._id;
        vm.title = utils.changeExtension(pcd.name, "pcd");
        $scope.isLoading = false; //load3dViewer(model, inventories);

        vm.pcdScene = new THREE.Scene();
        vm.pcdScene.background = new THREE.Color(0x000000);
        var divpcd = angular.element("#pointCloud")[0];
        vm.pcdCamera = new THREE.PerspectiveCamera(15, divpcd.offsetWidth / divpcd.offsetHeight, 1, 4000);
        vm.pcdScene.add(vm.pcdCamera);
        var pcdcanvas = $document[0].createElement('canvas');
        var pcdcontext = pcdcanvas.getContext('webgl2', {
          alpha: true,
          antialias: true,
          preserveDrawingBuffer: true
        });
        vm.pcdRenderer = new THREE.WebGLRenderer({
          canvas: pcdcanvas,
          context: pcdcontext
        });
        vm.pcdRenderer.setSize(divpcd.offsetWidth, divpcd.offsetHeight);
        divpcd.appendChild(pcdcanvas);
        animate();

        if (pcd.url.includes(".pcd")) {
          var loader = new THREE.PCDLoader();
          loader.load(pcd.url, function (points) {
            vm.pcdScene.add(points);
            points.geometry.computeBoundingSphere();
            var center = points.geometry.boundingSphere.center;
            var radius = points.geometry.boundingSphere.radius;
            if (radius) vm.pcdCamera.position.set(center.x, center.y, center.z - radius * 5);else vm.pcdCamera.position.set(center.x, center.y, -5);
            vm.pcdCamera.up.set(0, -1, 0);
            vm.pcdCamera.far = Math.max(10.0 * (center.length() + radius), 2000);
            vm.pcdcontrols = new THREE.TrackballControls(vm.pcdCamera, vm.pcdRenderer.domElement);
            vm.pcdcontrols.rotateSpeed = 2.0;
            vm.pcdcontrols.zoomSpeed = 2.0;
            vm.pcdcontrols.panSpeed = 0.2;
            vm.pcdcontrols.staticMoving = true;
            vm.pcdcontrols.minDistance = 0.3;
            vm.pcdcontrols.maxDistance = Math.max(10.0 * (center.length() + radius), 2000);
            vm.pcdcontrols.target.set(center.x, center.y, center.z);
            vm.pcdcontrols.update();
            vm.prevPoints = points;
            angular.element("#initial_loading_popup").hide();
          }, function () {}, function (e) {
            angular.element("#initial_loading_popup").hide();
            Notification.error("error occured in reading pcd file." + e);
          });
        } else {
          var blob = null;
          var xhr = new XMLHttpRequest();
          xhr.open("GET", pcd.url);
          xhr.responseType = "blob";

          xhr.onload = function () {
            blob = xhr.response; // LoadAndDisplayFile(blob);
            // let pcdfile = new File(pcd.url);

            var reader = new FileReader();
            reader.readAsText(blob);

            reader.onload = function () {
              angular.element("#initial_loading_popup").hide();
              var pointArray = [];

              if (reader.result) {
                pointArray = reader.result.split(",");
                pointArray = pointArray.map(function (elm) {
                  return parseFloat(elm);
                });
                $log.info(pointArray);
              }

              var geometry = new THREE.BufferGeometry();
              var material = new THREE.PointsMaterial({
                color: new THREE.Color(1, 1, 1),
                size: 0.01,
                vertexColors: true
              });
              var pos = [];
              var col = [];

              for (var m = 0; m < (pointArray.length - 1) / 6; m++) {
                pos.push(pointArray[m * 6 + 0]);
                pos.push(pointArray[m * 6 + 1]);
                pos.push(pointArray[m * 6 + 2]);
                col.push(pointArray[m * 6 + 3] / 255.0);
                col.push(pointArray[m * 6 + 4] / 255.0);
                col.push(pointArray[m * 6 + 5] / 255.0);
                col.push(1.0);
              }

              geometry.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
              geometry.setAttribute('color', new THREE.Float32BufferAttribute(col, 4));
              var points = new THREE.Points(geometry, material);
              vm.pcdScene.add(points);
              points.geometry.computeBoundingSphere();
              var center = points.geometry.boundingSphere.center;
              var radius = points.geometry.boundingSphere.radius;
              if (radius) vm.pcdCamera.position.set(center.x, center.y, center.z - radius * 5);else vm.pcdCamera.position.set(center.x, center.y, -5);
              vm.pcdCamera.up.set(0, -1, 0);
              vm.pcdCamera.far = Math.max(10.0 * (center.length() + radius), 2000);
              vm.pcdcontrols = new THREE.TrackballControls(vm.pcdCamera, vm.pcdRenderer.domElement);
              vm.pcdcontrols.rotateSpeed = 2.0;
              vm.pcdcontrols.zoomSpeed = 2.0;
              vm.pcdcontrols.panSpeed = 0.2;
              vm.pcdcontrols.staticMoving = true;
              vm.pcdcontrols.minDistance = 0.3;
              vm.pcdcontrols.maxDistance = Math.max(10.0 * (center.length() + radius), 2000);
              vm.pcdcontrols.target.set(center.x, center.y, center.z);
              vm.pcdcontrols.update();
              vm.prevPoints = points;
            };

            reader.onerror = function () {
              Notification.error("error occured in reading pcd file." + reader.error);
            };
          };

          xhr.send();
        }
      })["catch"](function (e) {
        $log.error(e);
        angular.element("#initial_loading_popup").hide();
        Notification.error("Error occurred during load data.");
      });
    }

    vm.gotoHome = function () {
      vm.stopRendering = true;
      $state.go('pcdGrid');
    };

    vm.stopRendering = false;

    function animate() {
      if (!vm.stopRendering) {
        var divpcd = angular.element("#pointCloud")[0];
        vm.pcdCamera.aspect = divpcd.offsetWidth / divpcd.offsetHeight;
        vm.pcdCamera.updateProjectionMatrix();
        requestAnimationFrame(animate);
        if (vm.pcdcontrols) vm.pcdcontrols.update();
        vm.pcdRenderer.render(vm.pcdScene, vm.pcdCamera);
      }
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('wallModal', {
    controller: WallModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/wallModal/wallModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function WallModal($scope, globals, utils) {
    var companyStore = globals.companyStore;
    var vm = this;
    vm.companyData = companyStore.get();
    $scope.units = [{
      label: 'm',
      value: 1
    }, {
      label: 'cm',
      value: 0.01
    }, {
      label: 'mm',
      value: 0.001
    }, {
      label: 'in',
      value: 0.254
    }, {
      label: 'ft',
      value: 0.3048
    }, {
      label: 'km',
      value: 1000
    }, {
      label: 'mile',
      value: 1609.344
    }];

    vm.$onInit = function () {
      vm.height = utils.num(vm.resolve.property.zHeight);
      vm.unit = 1;
    };

    vm.onConfirm = function () {
      var height = vm.height;
      height *= vm.unit;
      vm.modalInstance.close(height);
    };

    vm.onClose = function () {
      vm.modalInstance.dismiss();
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('uploadPhotoModal', {
    controller: uploadPhotoModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/uploadPhotoModal/uploadPhotoModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function uploadPhotoModal($scope, $log, localStorageService, apiFactory, authFactory, globals, Notification, $document, $uibModal, NgMap, utils, GMap) {
    var vm = this;
    var logout = globals.logout,
        projectStore = globals.projectStore;

    if (!authFactory.checkUser()) {
      logout();
      return;
    }

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      return;
    }

    var request = undefined;
    vm.photoFile = undefined;
    vm.thumbFile = undefined;
    vm.description = undefined;
    vm.location = undefined;

    vm.$onInit = function () {
      if (!vm.project || vm.project._id === 'all') {
        vm.modalInstance.dismiss('cancel');
        return;
      }

      if (utils.isEmpty(vm.project.address) || utils.isEmpty(vm.project.address.loc) || utils.isEmpty(vm.project.address.loc.coordinates) || vm.project.address.loc.coordinates.length !== 2) {
        Notification.error('Project address is wrong. Please set correct the project\'s address');
        vm.modalInstance.dismiss('cancel');
        return;
      }

      $scope.isLoading = true;
      apiFactory.getGeoCodes(vm.project.address.loc.coordinates).then(function (res) {
        $scope.isLoading = false;
        var street_address = res.data.results[0];
        var formatted_address = street_address.formatted_address;
        var geometry = street_address.geometry;
        vm.gmap = GMap.drawingViewer($document[0].getElementById('gmap'), {
          zoom: 18,
          center: {
            lat: vm.project.address.loc.coordinates[0],
            lng: vm.project.address.loc.coordinates[1]
          },
          disableDefaultUI: true,
          zoomControl: true
        }, {
          address: formatted_address,
          geometry: geometry
        });
        vm.gmap.initialize();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.photoFileUpdated = function (files) {
      if (files && files.length) {
        vm.panoramaPhoto = files[0];
      }

      var photoreader = new FileReader();

      photoreader.onload = function (e) {
        angular.element('#photo-img').css('display', 'block');
        angular.element('#photo-img').attr('src', e.target.result);
      };

      photoreader.readAsDataURL(vm.panoramaPhoto);
    };

    vm.thumbFileUpdated = function (files) {
      if (files && files.length) {
        vm.thumbFile = files[0];
        var reader = new FileReader();

        reader.onload = function (e) {
          angular.element('#thumbnail-img').css('display', 'block');
          angular.element('#thumbnail-img').attr('src', e.target.result);
        };

        reader.readAsDataURL(vm.thumbFile);
      }
    };

    vm.upload = function () {
      var file = vm.photoFile;

      if (!file) {
        Notification.error("Please select a photo file.");
        return;
      }

      vm.location = vm.gmap.getLocations();

      if (!vm.location) {
        Notification.error("Please input location.");
        return;
      }

      if (!vm.location.shape) {
        delete vm.location.shape;
      }

      if (file.size > 60 * 1024 * 1024) {
        // large than 60MB
        //alertSize();
        return;
      }

      request = apiFactory.uploadPhoto({
        projectId: vm.project._id,
        name: vm.name,
        description: vm.description,
        location: vm.location,
        panoramaPhoto: vm.panoramaPhoto,
        thumbnail: vm.thumbFile
      }).success(onUploadSuccess).error(onUploadError).progress(onUploadProgress); //onUploadSuccess();
    };

    $scope.onCancel = function () {
      if (request) {
        request.abort();
        request = undefined;
      }

      vm.modalInstance.dismiss('cancel');
    };

    function onUploadSuccess(data) {
      showProgress(0, false);
      $scope.request = null;
      Notification.success("Uploaded successfully");
      vm.modalInstance.close(data);
    }

    function onUploadError(err) {
      showProgress(0, false);
      $log.error(err);
      $scope.request = undefined;
      Notification.error('The error has been occurred during processing on server.');
    }

    function onUploadProgress(event) {
      var percent = 0;
      var position = event.loaded || event.position;
      var total = event.total;

      if (event.lengthComputable) {
        percent = Math.ceil(position / total * 100);
      }

      var progress_bar_id = "#progress-wrp";
      angular.element(progress_bar_id + " .progressbar").css("width", +percent + "%");
      angular.element(progress_bar_id + " .status").text(percent + "%");
      angular.element(progress_bar_id).css('display', 'block');

      if (percent === 100) {
        angular.element(progress_bar_id + " .status").text("Processing. Please wait...");
      }
    }

    function showProgress(percent, visible) {
      var progress_bar_id = "#progress-wrp";
      angular.element(progress_bar_id + " .progressbar").css("width", +percent + "%");
      angular.element(progress_bar_id + " .status").text(percent + "%");
      angular.element(progress_bar_id).css('display', visible ? 'block' : 'none');
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('uploadPcdModal', {
    controller: uploadPcdModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/uploadPcdModal/uploadPcdModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function uploadPcdModal($scope, $log, localStorageService, apiFactory, authFactory, globals, Notification, $document, $uibModal, NgMap, utils, GMap) {
    var vm = this;
    var logout = globals.logout,
        projectStore = globals.projectStore;

    if (!authFactory.checkUser()) {
      logout();
      return;
    }

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      return;
    }

    var request = undefined;
    vm.bimFile = undefined;
    vm.thumbFile = undefined;
    vm.description = undefined;
    vm.location = undefined;

    vm.$onInit = function () {
      if (!vm.project || vm.project._id === 'all') {
        vm.modalInstance.dismiss('cancel');
        return;
      }

      if (utils.isEmpty(vm.project.address) || utils.isEmpty(vm.project.address.loc) || utils.isEmpty(vm.project.address.loc.coordinates) || vm.project.address.loc.coordinates.length !== 2) {
        Notification.error('Project address is wrong. Please set correct the project\'s address');
        vm.modalInstance.dismiss('cancel');
        return;
      }

      $scope.isLoading = true;
      apiFactory.getGeoCodes(vm.project.address.loc.coordinates).then(function (res) {
        $scope.isLoading = false;
        var street_address = res.data.results[0];
        var formatted_address = street_address.formatted_address;
        var geometry = street_address.geometry;
        vm.gmap = GMap.drawingViewer($document[0].getElementById('gmap'), {
          zoom: 18,
          center: {
            lat: vm.project.address.loc.coordinates[0],
            lng: vm.project.address.loc.coordinates[1]
          },
          disableDefaultUI: true,
          zoomControl: true
        }, {
          address: formatted_address,
          geometry: geometry
        });
        vm.gmap.initialize();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.bimFileUpdated = function (files) {
      if (files && files.length) {
        vm.bimFile = files[0];
      }
    };

    vm.thumbFileUpdated = function (files) {
      if (files && files.length) {
        vm.thumbFile = files[0];
        var reader = new FileReader();

        reader.onload = function (e) {
          angular.element('#thumbnail-img').css('display', 'block');
          angular.element('#thumbnail-img').attr('src', e.target.result);
        };

        reader.readAsDataURL(vm.thumbFile);
      }
    };

    vm.upload = function () {
      var file = vm.bimFile;
      var image = vm.thumbFile;

      if (!file) {
        Notification.error("Please select a pcd file.");
        return;
      }

      vm.location = vm.gmap.getLocations();

      if (!vm.location) {
        Notification.error("Please input location.");
        return;
      }

      if (!vm.location.shape) {
        delete vm.location.shape;
      }

      if (file.size > 60 * 1024 * 1024) {
        // large than 60MB
        alertSize();
        return;
      }

      request = apiFactory.uploadPCD({
        projectId: vm.project._id,
        //thumbnail: image,
        description: vm.description,
        location: vm.location,
        files: [file, image]
      }).success(onUploadSuccess).error(onUploadError).progress(onUploadProgress); //onUploadSuccess();
    };

    $scope.onCancel = function () {
      if (request) {
        request.abort();
        request = undefined;
      }

      vm.modalInstance.dismiss('cancel');
    };

    function alertSize() {
      $uibModal.open({
        animation: true,
        component: 'alertModal',
        size: 'sm',
        resolve: {
          title: function title() {
            return 'Warning';
          },
          message: function message() {
            return 'Attached file is too large. So it may not display correctly. ' + 'You can use CloudES local Viewer instead web. Do you want download viewer or continue uploading?';
          },
          positive: function positive() {
            return 'Download';
          },
          negative: function negative() {
            return 'Continue';
          }
        }
      }).result.then(function () {
        downloadViewer();
      }, function (reason) {
        if (reason === 'cancel') {
          continueUpload();
        }
      });
    }

    function continueUpload() {
      var file = vm.bimFile;
      var image = vm.thumbFile;
      request = apiFactory.upload3d({
        projectId: vm.project._id,
        thumbnail: image,
        description: vm.description,
        location: vm.location,
        model: file
      }).success(onUploadSuccess).error(onUploadError).progress(onUploadProgress);
    }

    function downloadViewer() {
      vm.modalInstance.close();
      var link = $document[0].createElement("a");
      link.href = "https://bimserver.cloudes.one/viewer-setup.rar";
      link.download = "viewer-setup.rar";
      $document[0].body.appendChild(link);
      link.click();
      $document[0].body.removeChild(link);
    }

    function onUploadSuccess(data) {
      showProgress(0, false);
      $scope.request = null;
      Notification.success("Uploaded successfully");
      vm.modalInstance.close(data);
    }

    function onUploadError(err) {
      showProgress(0, false);
      $log.error(err);
      $scope.request = undefined;
      Notification.error('The error has been occurred during processing on server.');
    }

    function onUploadProgress(event) {
      var percent = 0;
      var position = event.loaded || event.position;
      var total = event.total;

      if (event.lengthComputable) {
        percent = Math.ceil(position / total * 100);
      }

      var progress_bar_id = "#progress-wrp";
      angular.element(progress_bar_id + " .progressbar").css("width", +percent + "%");
      angular.element(progress_bar_id + " .status").text(percent + "%");
      angular.element(progress_bar_id).css('display', 'block');

      if (percent === 100) {
        angular.element(progress_bar_id + " .status").text("Processing. Please wait...");
      }
    }

    function showProgress(percent, visible) {
      var progress_bar_id = "#progress-wrp";
      angular.element(progress_bar_id + " .progressbar").css("width", +percent + "%");
      angular.element(progress_bar_id + " .status").text(percent + "%");
      angular.element(progress_bar_id).css('display', visible ? 'block' : 'none');
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('uploadModelModal', {
    controller: uploadModelModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/uploadModelModal/uploadModelModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function uploadModelModal($scope, $log, localStorageService, apiFactory, authFactory, globals, Notification, $document, $uibModal, NgMap, utils, GMap) {
    var vm = this;
    var logout = globals.logout,
        projectStore = globals.projectStore;

    if (!authFactory.checkUser()) {
      logout();
      return;
    }

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      return;
    }

    var request = undefined;
    vm.bimFile = undefined;
    vm.thumbFile = undefined;
    vm.description = undefined;
    vm.location = undefined;

    vm.$onInit = function () {
      if (!vm.project || vm.project._id === 'all') {
        vm.modalInstance.dismiss('cancel');
        return;
      } // if (
      //   utils.isEmpty(vm.project.address) ||
      //   utils.isEmpty(vm.project.address.loc) ||
      //   utils.isEmpty(vm.project.address.loc.coordinates) ||
      //   (vm.project.address.loc.coordinates.length !== 2) ||
      //   (vm.project.address.loc.coordinates[0] === 0 && vm.project.address.loc.coordinates[1] === 0)
      // ) {
      //   Notification.error('Project address is wrong. Please set correct the project\'s address');
      //   vm.modalInstance.dismiss('cancel');
      //   return;
      // }


      $scope.isLoading = true;
      apiFactory.getGeoCodes(vm.project.address.loc.coordinates).then(function (res) {
        $scope.isLoading = false;
        var street_address = res.data.results[0];
        var mapData = {
          address: ""
        };

        if (street_address) {
          mapData = {
            address: street_address.formatted_address,
            geometry: street_address.geometry
          };
        }

        vm.gmap = GMap.drawingViewer($document[0].getElementById('gmap'), {
          zoom: 18,
          center: {
            lat: vm.project.address.loc.coordinates[0],
            lng: vm.project.address.loc.coordinates[1]
          },
          disableDefaultUI: true,
          zoomControl: true
        }, mapData);
        vm.gmap.initialize();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.bimFileUpdated = function (files) {
      if (files && files.length) {
        vm.bimFile = files[0];
      }
    };

    vm.thumbFileUpdated = function (files) {
      if (files && files.length) {
        vm.thumbFile = files[0];
        var reader = new FileReader();

        reader.onload = function (e) {
          angular.element('#thumbnail-img').css('display', 'block');
          angular.element('#thumbnail-img').attr('src', e.target.result);
        };

        reader.readAsDataURL(vm.thumbFile);
      }
    };

    vm.upload = function () {
      var file = vm.bimFile;
      var image = vm.thumbFile;

      if (!file) {
        Notification.error("Please select a ifc file.");
        return;
      }

      vm.location = vm.gmap.getLocations();

      if (!vm.location) {
        Notification.error("Please input location.");
        return;
      }

      if (!vm.location.shape) {
        delete vm.location.shape;
      }

      if (file.size > 60 * 1024 * 1024) {
        // large than 60MB
        alertSize();
        return;
      }

      request = apiFactory.upload3d({
        projectId: vm.project._id,
        thumbnail: image,
        description: vm.description,
        location: vm.location,
        model: file
      }).success(onUploadSuccess).error(onUploadError).progress(onUploadProgress);
    };

    $scope.onCancel = function () {
      if (request) {
        request.abort();
        request = undefined;
      }

      vm.modalInstance.dismiss('cancel');
    };

    function alertSize() {
      $uibModal.open({
        animation: true,
        component: 'alertModal',
        size: 'sm',
        resolve: {
          title: function title() {
            return 'Warning';
          },
          message: function message() {
            return 'Attached file is too large. So it may not display correctly. ' + 'You can use CloudES local Viewer instead web. Do you want download viewer or continue uploading?';
          },
          positive: function positive() {
            return 'Download';
          },
          negative: function negative() {
            return 'Continue';
          }
        }
      }).result.then(function () {
        downloadViewer();
      }, function (reason) {
        if (reason === 'cancel') {
          continueUpload();
        }
      });
    }

    function continueUpload() {
      var file = vm.bimFile;
      var image = vm.thumbFile;
      request = apiFactory.upload3d({
        projectId: vm.project._id,
        thumbnail: image,
        description: vm.description,
        location: vm.location,
        model: file
      }).success(onUploadSuccess).error(onUploadError).progress(onUploadProgress);
    }

    function downloadViewer() {
      vm.modalInstance.close();
      var link = $document[0].createElement("a");
      link.href = "https://bimserver.cloudes.one/viewer-setup.rar";
      link.download = "viewer-setup.rar";
      $document[0].body.appendChild(link);
      link.click();
      $document[0].body.removeChild(link);
    }

    function onUploadSuccess(data) {
      showProgress(0, false);
      $scope.request = null;
      Notification.success("Uploaded successfully");
      vm.modalInstance.close(data);
    }

    function onUploadError(err) {
      showProgress(0, false);
      $log.error(err);
      $scope.request = undefined;
      Notification.error('The error has been occurred during processing on server.');
    }

    function onUploadProgress(event) {
      var percent = 0;
      var position = event.loaded || event.position;
      var total = event.total;

      if (event.lengthComputable) {
        percent = Math.ceil(position / total * 100);
      }

      var progress_bar_id = "#progress-wrp";
      angular.element(progress_bar_id + " .progressbar").css("width", +percent + "%");
      angular.element(progress_bar_id + " .status").text(percent + "%");
      angular.element(progress_bar_id).css('display', 'block');

      if (percent === 100) {
        angular.element(progress_bar_id + " .status").text("Processing. Please wait...");
      }
    }

    function showProgress(percent, visible) {
      var progress_bar_id = "#progress-wrp";
      angular.element(progress_bar_id + " .progressbar").css("width", +percent + "%");
      angular.element(progress_bar_id + " .status").text(percent + "%");
      angular.element(progress_bar_id).css('display', visible ? 'block' : 'none');
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('semiPlanModal', {
    controller: semiPlanModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/semiPlanModal/semiPlanModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function semiPlanModal($scope, $log, $timeout, globals, Bim, pdfFactory, utils, Notification) {
    var vm = this;
    var projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get();
    vm.company = companyStore.get();
    vm.renderMode = 'normal';
    vm.bimModel = undefined;
    vm.floors = [];
    vm.addedFloors = [];
    vm.floor = undefined;
    vm.pageSize = 10;
    vm.pageSizes = [{
      id: 1,
      label: 'Letter',
      desc: '8.5" x 11"',
      size: {
        width: 1650,
        height: 1275
      }
    }, //150dpi
    {
      id: 2,
      label: 'Tabloid',
      desc: '11" x 17"',
      size: {
        width: 2550,
        height: 1650
      }
    }, {
      id: 3,
      label: 'Legal',
      desc: '8.5" x 14"',
      size: {
        width: 2100,
        height: 1275
      }
    }, {
      id: 4,
      label: 'Statement',
      desc: '5.5" x 8.5"',
      size: {
        width: 1275,
        height: 825
      }
    }, {
      id: 5,
      label: 'Executive',
      desc: '7.25" x 10.5"',
      size: {
        width: 1575,
        height: 1087
      }
    }, {
      id: 6,
      label: 'A0',
      desc: '33.1 x 46.8"',
      size: {
        width: 7022,
        height: 4967
      }
    }, {
      id: 7,
      label: 'A1',
      desc: '23.4 x 33.1"',
      size: {
        width: 4967,
        height: 3508
      }
    }, {
      id: 8,
      label: 'A2',
      desc: '16.5 x 23.4"',
      size: {
        width: 3508,
        height: 2480
      }
    }, {
      id: 9,
      label: 'A3',
      desc: '11.69" x 16.54"',
      size: {
        width: 2480,
        height: 1754
      }
    }, {
      id: 10,
      label: 'A4',
      desc: '8.27" x 11.69"',
      size: {
        width: 1754,
        height: 1240
      }
    }, {
      id: 11,
      label: 'A5',
      desc: '5.8 x 8.3"',
      size: {
        width: 1240,
        height: 874
      }
    }, {
      id: 12,
      label: 'B4(JIS)',
      desc: '10.12" x 14.33"',
      size: {
        width: 2149,
        height: 1518
      }
    }, {
      id: 13,
      label: 'B5(JIS)',
      desc: '7.17" x 10.12"',
      size: {
        width: 1518,
        height: 1075
      }
    }];
    vm.description = '';
    vm.viewer = Bim.simpleViewer(angular.element('#viewer')[0], 'high');
    vm.viewer.initialize();
    vm.viewer.setDragAction('orbit');
    vm.viewer.setSize(1000, 728);
    globals.getCountryCode().then(function (resp) {
      var countries = resp.data;

      if (vm.company.address1) {
        var country = countries.find(function (elem) {
          return elem.code === vm.company.address1.countryCode;
        });

        if (country) {
          vm.company.address1.country = country.name;
        }
      }

      if (vm.project.client && vm.project.client.address) {
        var _country = countries.find(function (elem) {
          return elem.code === vm.project.client.address.countryCode;
        });

        if (_country) {
          vm.project.client.address.country = _country.name;
        }
      }
    });

    vm.$onInit = function () {
      vm.bimModel = vm.resolve.bimModel;
      var item = vm.resolve.floor;
      vm.viewer.addBimItem(item, 'high');
      vm.addedFloors.push(item);
      refreshFloors();
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onExport = function () {
      if (utils.isEmpty(vm.name)) {
        Notification.error('Please input section name.');
        return;
      }

      if (utils.isEmpty(vm.addedFloors)) {
        Notification.error('Please add levels.');
        return;
      }

      angular.element('#spinner').show();
      var size = vm.pageSizes[vm.pageSize - 1];
      exportToPdf(size).then(function () {
        vm.modalInstance.close();
        angular.element('#spinner').hide();
      })["catch"](function (e) {
        $log.error(e);
        angular.element('#spinner').hide();
      });
    };

    vm.selectRenderMode = function () {
      vm.viewer.setColorMode(vm.renderMode);
    };

    vm.addFloor = function () {
      if (vm.floor) {
        var floor = vm.floors.find(function (x) {
          return x.guid === vm.floor;
        });
        vm.addedFloors.push(floor);
        vm.floor = undefined;
        refreshFloors();
        vm.viewer.addBimItem(floor, 'high');
      }
    };

    vm.removeFloor = function (index) {
      var floor = vm.addedFloors[index];
      vm.addedFloors.splice(index, 1);
      refreshFloors();
      vm.viewer.removeBimItem(floor);
    };

    $scope.getLetter = function (floor) {
      return floor.name.match(/\b\w/g).join('').toUpperCase();
    };

    function refreshFloors() {
      vm.floors = vm.bimModel.floors.filter(function (floor) {
        return vm.addedFloors.findIndex(function (x) {
          return x.guid === floor.guid;
        }) === -1;
      });
    }

    function exportToPdf(pageSize) {
      return new Promise(function (resolve) {
        $timeout(function () {
          var imageData = vm.viewer.getImage();
          var materials = vm.renderMode === 'inventory' ? vm.viewer.getColoredInventories() : undefined;
          pdfFactory.exportSemiPlan(vm.name, pageSize, {
            imageData: imageData,
            project: vm.project,
            company: vm.company,
            materials: materials,
            version: '01'
          });
          resolve();
        });
      });
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('selectLevelModal', {
    controller: selectLevelModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/selectLevelModal/selectLevelModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function selectLevelModal($scope) {
    var vm = this;
    vm.workLevel = undefined;

    vm.$onInit = function () {
      var bimModel = vm.resolve.bimModel;
      $scope.workLevels = bimModel.getWorkLevels();
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onSelect = function () {
      vm.modalInstance.close(vm.workLevel);
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('planModal', {
    controller: planModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/planModal/planModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function planModal($scope, $log, $timeout, globals, Bim, pdfFactory, utils, Notification, $document) {
    var vm = this;
    var projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    $scope.isShowNormal = true;
    vm.planGenerator = Bim.planGenerator();
    vm.project = projectStore.get();
    vm.company = companyStore.get();
    vm.renderMode = 'normal';
    vm.bimModel = undefined;
    vm.floors = [];
    vm.addedFloors = [];
    vm.floor = undefined;
    vm.pageSize = 10;
    vm.pageSizes = [{
      id: 1,
      label: 'Letter',
      desc: '8.5" x 11"',
      size: {
        width: 1650,
        height: 1275
      }
    }, //150dpi
    {
      id: 2,
      label: 'Tabloid',
      desc: '11" x 17"',
      size: {
        width: 2550,
        height: 1650
      }
    }, {
      id: 3,
      label: 'Legal',
      desc: '8.5" x 14"',
      size: {
        width: 2100,
        height: 1275
      }
    }, {
      id: 4,
      label: 'Statement',
      desc: '5.5" x 8.5"',
      size: {
        width: 1275,
        height: 825
      }
    }, {
      id: 5,
      label: 'Executive',
      desc: '7.25" x 10.5"',
      size: {
        width: 1575,
        height: 1087
      }
    }, {
      id: 6,
      label: 'A0',
      desc: '33.1 x 46.8"',
      size: {
        width: 7022,
        height: 4967
      }
    }, {
      id: 7,
      label: 'A1',
      desc: '23.4 x 33.1"',
      size: {
        width: 4967,
        height: 3508
      }
    }, {
      id: 8,
      label: 'A2',
      desc: '16.5 x 23.4"',
      size: {
        width: 3508,
        height: 2480
      }
    }, {
      id: 9,
      label: 'A3',
      desc: '11.69" x 16.54"',
      size: {
        width: 2480,
        height: 1754
      }
    }, {
      id: 10,
      label: 'A4',
      desc: '8.27" x 11.69"',
      size: {
        width: 1754,
        height: 1240
      }
    }, {
      id: 11,
      label: 'A5',
      desc: '5.8 x 8.3"',
      size: {
        width: 1240,
        height: 874
      }
    }, {
      id: 12,
      label: 'B4(JIS)',
      desc: '10.12" x 14.33"',
      size: {
        width: 2149,
        height: 1518
      }
    }, {
      id: 13,
      label: 'B5(JIS)',
      desc: '7.17" x 10.12"',
      size: {
        width: 1518,
        height: 1075
      }
    }];
    globals.getCountryCode().then(function (resp) {
      var countries = resp.data;

      if (vm.company.address1) {
        var country = countries.find(function (elem) {
          return elem.code === vm.company.address1.countryCode;
        });

        if (country) {
          vm.company.address1.country = country.name;
        }
      }

      if (vm.project.client && vm.project.client.address) {
        var _country = countries.find(function (elem) {
          return elem.code === vm.project.client.address.countryCode;
        });

        if (_country) {
          vm.project.client.address.country = _country.name;
        }
      }
    });

    vm.$onInit = function () {
      vm.bimModel = vm.resolve.bimModel;
      var item = vm.resolve.floor;
      vm.addedFloors.push(item);
      $timeout(function () {
        refreshFloors();
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onExport = function () {
      if (utils.isEmpty(vm.addedFloors)) {
        Notification.error('Please add levels.');
        return;
      }

      angular.element('#spinner').show();
      var size = vm.pageSizes[vm.pageSize - 1];
      $timeout(function () {
        exportToPdf(size).then(function () {
          vm.modalInstance.close();
          angular.element('#spinner').hide();
        })["catch"](function (e) {
          $log.error(e);
          angular.element('#spinner').hide();
        });
      });
    };

    vm.selectRenderMode = function () {
      if (!vm.canvas) {
        var canvasElement = $document[0].getElementById("viewer");
        canvasElement.width = 1000;
        canvasElement.height = 728;
        vm.canvas = vm.planGenerator.createCanvas(canvasElement);
      }

      vm.canvas.clear();
      if (vm.addedFloors.length <= 0) return;

      if (vm.renderMode === 'normal') {
        angular.element('#spinner').show();
        vm.planGenerator.generate(vm.addedFloors, false, vm.canvas).then(function () {
          angular.element('#spinner').hide();
        });
      } else {
        angular.element('#spinner').show();
        vm.planGenerator.generate(vm.addedFloors, true, vm.canvas).then(function () {
          angular.element('#spinner').hide();
        });
      }
    };

    vm.selectPageSize = function () {//vm.selectRenderMode();
    };

    vm.addFloor = function () {
      if (vm.floor) {
        var floor = vm.floors.find(function (x) {
          return x.guid === vm.floor;
        });
        vm.addedFloors.push(floor);
        vm.floor = undefined;
        refreshFloors(); //vm.viewer.addBimItem(floor, 'high');
      }
    };

    vm.removeFloor = function (index) {
      vm.addedFloors.splice(index, 1);
      refreshFloors();
    };

    $scope.getLetter = function (floor) {
      return floor.name.match(/\b\w/g).join('').toUpperCase();
    };

    function refreshFloors() {
      vm.selectRenderMode();
      vm.floors = vm.bimModel.floors.filter(function (floor) {
        return vm.addedFloors.findIndex(function (x) {
          return x.guid === floor.guid;
        }) === -1;
      });
    }

    function exportToPdf(pageSize) {
      return new Promise(function (resolve) {
        if (vm.renderMode === 'normal') {
          vm.planGenerator.generate(vm.addedFloors, false, undefined, pageSize).then(function () {
            resolve();
          });
        } else {
          vm.planGenerator.generate(vm.addedFloors, true, undefined, pageSize).then(function () {
            resolve();
          });
        }
      });
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('openVpModal', {
    controller: openVpModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/openVpModal/openVpModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function openVpModal(apiFactory, authFactory, globals, $scope, $document, $log, Notification, utils) {
    var vm = this;
    var projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.companyData = companyStore.get();
    vm.virtualCards = [];
    vm.plans = [];
    vm.loading = true;
    vm.selectedIndex = -1;
    apiFactory.getProjectRoofPlans(projectStore.get()._id).then(function (response) {
      vm.loading = false;
      vm.plans = response.data.data;
      vm.numLacks = 3 - vm.plans.length % 3;
      vm.plans.forEach(function (plan) {
        var funcName;

        if (plan.parentAsset && plan.parentAsset.bytes) {
          if (vm.companyData.companyInputMethod === 'British/American et al.') {
            funcName = 'roundNumber';
          } else {
            funcName = 'comma2decimal';
          }

          if (plan.parentAsset.bytes >= 1000000) {
            plan.displaySize = utils[funcName](plan.parentAsset.bytes / 1000000, 1);
            plan.displaySizeUnit = 'MB';
          } else if (plan.parentAsset.bytes >= 1000 && plan.parentAsset.bytes < 1000000) {
            plan.displaySize = utils[funcName](plan.parentAsset.bytes / 1000, 1);
            plan.displaySizeUnit = 'KB';
          } else {
            plan.displaySize = utils[funcName](plan.parentAsset.bytes, 1);
            plan.displaySizeUnit = 'B';
          }
        } else {
          plan.displaySize = 0;
          plan.displaySizeUnit = 'B';
        }
      });
    })["catch"](function (err) {
      vm.loading = false;
      $log.error("error", err);
    });

    $scope.onOk = function () {
      if (vm.selectedIndex === -1) {
        Notification.error('Please select a plan');
        return;
      }

      var plan = vm.plans[vm.selectedIndex];
      vm.modalInstance.close({
        plan: plan,
        name: plan.name
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('openModelModal', {
    controller: openModelModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/openModelModal/openModelModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function openModelModal($scope, $document, $log, apiFactory, authFactory, globals, utils, Notification) {
    var vm = this;
    var projectStore = globals.projectStore,
        logout = globals.logout;

    if (!authFactory.checkUser()) {
      logout();
      return;
    }

    vm.virtualCards = [];
    vm.loading = true;
    vm.selectedIndex = -1;
    apiFactory.list3d(projectStore.get()._id).then(function (response) {
      vm.loading = false;
      vm.models = response.data.data;
      vm.numLacks = 3 - vm.models.length % 3;
    })["catch"](function (err) {
      vm.loading = false;
      $log.error("error", err);
    });

    $scope.onOk = function () {
      if (vm.selectedIndex === -1) {
        Notification.error('Please select a model');
        return;
      }

      var model = vm.models[vm.selectedIndex];
      vm.modalInstance.close({
        model: model,
        name: utils.changeExtension(model.name, "ifc")
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component("openPdfModal", {
    controller: openPdfModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/open-pdf-modal/open-pdf-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function openPdfModalController(Notification, apiFactory, globals, $log, $scope, $rootScope, utils, $document, $timeout) {
    var vm = this;
    $scope.folderPaths = [];
    var projectStore = globals.projectStore,
        userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.projectData = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    $scope.utils = utils;
    $scope.tab = 'remote';
    $scope.rootFolders = [];
    vm.selectedFolder = undefined;
    vm.breadCrumbList = [];
    vm.browseHistory = [];
    vm.browseHistoryIndex = 0;
    vm.selectedPageIndex = 0;
    vm.levels = [];
    apiFactory.listAllLevelTypes().then(function (res) {
      vm.levels = res.data.list.map(function (x) {
        return {
          _id: x._id,
          name: x.tagName
        };
      });

      for (var i = 1; i <= 100; i++) {
        vm.levels.push({
          _id: i.toString(),
          name: i.toString()
        });
      }
    })["catch"](function (err) {
      Notification.error(utils.getErrorMessage(err));
    });

    vm.$onInit = function () {
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'assets/lib/pdf.js/pdf.worker.js';
    };

    vm.getPrimaryFolders = function () {
      var payload = {
        projectId: vm.projectData._id
      };
      $scope.loading = true;
      apiFactory.getRootFolders(payload).then(function (resp) {
        $scope.loading = false;
        vm.rootFolders = [{
          _id: 'project',
          name: 'PROJECT',
          children: resp.data.data.project
        }, {
          _id: 'company',
          name: 'COMPANY',
          children: resp.data.data.company
        }, {
          _id: 'personal',
          name: 'PERSONAL',
          children: resp.data.data.personal
        }];
        $scope.selectFolder(vm.rootFolders[0]);
      })["catch"](function (err) {
        $log.error(err);
        $scope.loading = false;
      });
    };

    vm.getPrimaryFolders();

    $scope.isAvailableBackward = function () {
      return vm.browseHistoryIndex > 0;
    };

    $scope.isAvailableForward = function () {
      return vm.browseHistoryIndex < vm.browseHistory.length - 1;
    };

    $scope.backward = function () {
      if (vm.browseHistoryIndex === 0) {
        return;
      }

      vm.browseHistoryIndex--;
      $scope.selectFolder(vm.browseHistory[vm.browseHistoryIndex], true);
    };

    $scope.forward = function () {
      if (vm.browseHistoryIndex === vm.browseHistory.length - 1) {
        return;
      }

      vm.browseHistoryIndex++;
      $scope.selectFolder(vm.browseHistory[vm.browseHistoryIndex], true);
    };

    vm.isRootFolder = function () {
      return vm.selectedFolder._id === 'project' || vm.selectedFolder._id === 'company' || vm.selectedFolder._id === 'personal';
    };

    $scope.switchTab = function (tab) {
      vm.pdf = undefined;
      vm.selectedFile = undefined;
      vm.selectedPage = undefined;
      vm.selectedPageIndex = 0;
      $scope.tab = tab;
    };

    $scope.selectFolder = function (folder) {
      var historyAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      vm.selectedFolder = folder;
      vm.selectedFile = undefined;

      if (!historyAction) {
        vm.browseHistory.push(folder);
        vm.browseHistoryIndex = vm.browseHistory.length - 1;
      }

      if (vm.isRootFolder()) {
        vm.breadCrumbList = [vm.selectedFolder];
      } else {
        vm.breadCrumbList.push(vm.selectedFolder);
      }

      var API;

      if (folder._id === 'project') {
        API = apiFactory.getProjectHierarchy({
          projectId: vm.projectData._id
        });
      } else if (folder._id === 'company') {
        API = apiFactory.getCompanyHierarchy();
      } else if (folder._id === 'personal') {
        API = apiFactory.getPersonalHierarchy({
          projectId: vm.projectData._id,
          userId: vm.userData._id
        });
      } else {
        API = apiFactory.viewHierarchy(folder._id);
      }

      $scope.loading = true;
      API.then(function (resp) {
        $scope.loading = false;
        vm.currentFolders = angular.isDefined(resp.data.data) ? resp.data.data.hierarchies : resp.data.folders;
        vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
        vm.currentFiles = angular.isDefined(resp.data.data) ? resp.data.data.rootFiles.filter(function (x) {
          return x.format === 'pdf';
        }) : resp.data.files.filter(function (x) {
          return x.format === 'pdf';
        });
        vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);
      });
    };

    $scope.selectFile = function (file) {
      vm.selectedFile = file;
    };

    $scope.selectFileAndOpen = function (file) {
      vm.selectedFile = file;
      $scope.openPDF();
    };

    vm.searchCallback = function () {
      if (utils.isEmpty(vm.searchText)) {
        vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
        vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
      } else {
        vm.currentFilteredFolders = vm.currentFolders.filter(function (x) {
          return x.name.toLowerCase().includes(vm.searchText.toLowerCase());
        });
        vm.currentFilteredFiles = vm.currentFiles.filter(function (x) {
          return x.originalname.toLowerCase().includes(vm.searchText.toLowerCase());
        });
      }
    };

    function readPdfFile(inputFile) {
      var temporaryFileReader = new FileReader();
      return new Promise(function (resolve, reject) {
        temporaryFileReader.onerror = function () {
          temporaryFileReader.abort();
          reject(new DOMException('Problem parsing input file.'));
        };

        temporaryFileReader.onload = function () {
          resolve(temporaryFileReader.result);
        };

        temporaryFileReader.readAsArrayBuffer(inputFile);
      });
    }

    vm.fileUpdated = function (files) {
      if (files && files.length) {
        vm.files = files;

        if (files[0].type !== 'application/pdf') {
          Notification.error('Please select correct pdf file.');
          return;
        }

        $scope.loading = true;
        readPdfFile(files[0]).then(function (buffer) {
          pdfjsLib.getDocument(buffer).promise.then(function (pdf) {
            $scope.loading = false;
            vm.pdf = pdf;
            vm.getPage(1, 4096, true);
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
          });
        })["catch"](function () {
          $scope.loading = false;
        });
      }
    };

    $scope.backwardPage = function () {
      if (vm.selectedPageIndex === 0) {
        return;
      }

      vm.selectedPageIndex--;
      vm.getPage(vm.selectedPageIndex + 1, 4096);
    };

    $scope.forwardPage = function () {
      if (vm.selectedPageIndex === vm.pdf.numPages - 1) {
        return;
      }

      vm.selectedPageIndex++;
      vm.getPage(vm.selectedPageIndex + 1, 4096);
    };

    $scope.close = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.getPage = function (pageNum, maxSize) {
      var preview = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      $scope.loading = true;
      vm.pdf.getPage(pageNum).then(function (page) {
        var viewport = page.getViewport({
          scale: 1
        });

        if (angular.isUndefined(maxSize)) {
          var scale = viewport.height > viewport.width ? maxSize / viewport.height : maxSize / viewport.width;
          viewport = page.getViewport({
            scale: scale
          });
        }

        var canvas = $document[0].createElement("canvas");
        var context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        page.render({
          canvasContext: context,
          viewport: viewport
        }).promise.then(function () {
          $scope.loading = false;
          var page = {
            image: canvas.toDataURL("image/png"),
            size: {
              width: canvas.width,
              height: canvas.height
            }
          };

          if (preview) {
            vm.previewPage = page;
          } else {
            vm.selectedPage = page;
          }

          $timeout(function () {
            return $scope.$apply();
          });
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
      });
    };

    function _openPDF() {
      if (utils.isEmpty(vm.pdf)) {
        Notification.error('Could not parse pdf pages');
        return;
      }

      vm.getPage(1, 4096);
    }

    $scope.openPDF = function () {
      if ($scope.tab === 'local' && utils.isEmpty(vm.pdf) || $scope.tab === 'remote' && !vm.selectedFile) {
        Notification.error('Please select at least one file or upload one.');
        return;
      }

      if (vm.selectedFile) {
        $scope.loading = true;
        pdfjsLib.getDocument({
          url: vm.selectedFile.secure_url
        }).promise.then(function (pdf) {
          $scope.loading = false;
          vm.pdf = pdf;

          _openPDF();
        })["catch"](function (err) {
          $log.error(err);
          $scope.loading = false;
        });
      } else {
        _openPDF();
      }
    };

    $scope.cancelSelect = function () {
      vm.selectedPage = undefined;
    };

    $scope.select = function () {
      var data;

      if ($scope.tab === 'remote') {
        data = {
          name: vm.selectedFile.originalname,
          imageData: vm.selectedPage,
          pdfUrl: vm.selectedFile.secure_url,
          assetId: vm.selectedFile._id
        };
      } else if (!utils.isEmpty(vm.files)) {
        data = {
          name: vm.files[0].name,
          imageData: vm.selectedPage,
          file: vm.files[0]
        };
      } else {
        Notification.error('Please select one file or upload one at least.');
        return;
      }

      vm.modalInstance.close(data);
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('objectPropertiesModal', {
    controller: objectPropertiesModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/objectPropertiesModal/objectPropertiesModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function objectPropertiesModal(apiFactory, $scope, $timeout, globals, $q, utils, unitFactory) {
    var vm = this;
    var active;
    var companyStore = globals.companyStore;
    $scope.companyData = companyStore.get();
    $scope.unit = 'm';
    $scope.units = [{
      label: 'm',
      value: 'm'
    }, {
      label: 'cm',
      value: 'cm'
    }, {
      label: 'mm',
      value: 'mm'
    }];
    $scope.isWall = false;

    vm.$onInit = function () {
      $scope.isThree = vm.resolve.isThree;
      $scope.ngObject = vm.resolve.objectInfo;
      $scope.unit = 'm';
      $scope.isShape = vm.resolve.isShape;
      $scope.isWall = angular.isDefined($scope.ngObject.wallHeight);
      updateAreaAndPerimeter($scope.unit);
      var content = angular.element('.modal-content');
      content.css("left", 'calc(50vw - 110px)');
      content.css("top", 'calc(50vh - 113px)');
    };

    $scope.onClose = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.changeUnit = function () {
      updateAreaAndPerimeter($scope.unit);
    };

    function updateAreaAndPerimeter(unit) {
      if (!$scope.ngObject || angular.isUndefined(unit) || unit === '') return;
      var scale = 1;
      scale = unitFactory.getValueWithAbsoluteUnit(scale, unit, true);

      if ($scope.isThree) {
        $scope.perimeter = utils.num($scope.ngObject.perimeter) * scale;
        $scope.width = utils.num($scope.ngObject.width) * scale;
        $scope.height = utils.num($scope.ngObject.height) * scale;
        $scope.length = utils.num($scope.ngObject.length) * scale;
        $scope.area = utils.num($scope.ngObject.area) * scale * scale;
        $scope.volume = utils.num($scope.ngObject.volume) * scale * scale * scale;
      } else {
        $scope.width = $scope.ngObject.width * scale;
        $scope.height = $scope.ngObject.height * scale;

        if ($scope.ngObject.perimeter) {
          $scope.perimeter = utils.num($scope.ngObject.perimeter) * scale;

          if ($scope.ngObject.perimeterin) {
            $scope.perimeterin = $scope.ngObject.perimeterin * scale;
          }
        }

        if ($scope.ngObject.area) {
          $scope.area = $scope.ngObject.area * scale * scale;
        } else {
          $scope.area = $scope.ngObject.width * $scope.ngObject.height * scale * scale;
        }
      }

      applyData();
    }

    function applyData() {
      $timeout(function () {
        $scope.$apply();
      });
    }

    function makeDraggable() {
      var container = angular.element('.modal-content')[0];
      var headerElem = angular.element('#object-properties-header')[0];
      container.addEventListener("touchstart", dragStart, false);
      container.addEventListener("touchend", dragEnd, false);
      container.addEventListener("touchmove", drag, false);
      container.addEventListener("mousedown", dragStart, false);
      container.addEventListener("mouseup", dragEnd, false);
      container.addEventListener("mousemove", drag, false);
      active = false;
      var currentX;
      var currentY;
      var initialX;
      var initialY;
      var xOffset = 0;
      var yOffset = 0;

      function dragStart(e) {
        if (e.target !== headerElem) {
          return;
        }

        if (e.type === "touchstart") {
          initialX = e.touches[0].clientX - xOffset;
          initialY = e.touches[0].clientY - yOffset;
        } else {
          initialX = e.clientX - xOffset;
          initialY = e.clientY - yOffset;
        }

        active = true;
      }

      function dragEnd() {
        initialX = currentX;
        initialY = currentY;
        active = false;
      }

      function drag(e) {
        if (active) {
          e.preventDefault();

          if (e.type === "touchmove") {
            currentX = e.touches[0].clientX - initialX;
            currentY = e.touches[0].clientY - initialY;
          } else {
            currentX = e.clientX - initialX;
            currentY = e.clientY - initialY;
          }

          xOffset = currentX;
          yOffset = currentY;
          setTranslate(currentX, currentY, container);
        }
      }

      function setTranslate(xPos, yPos, el) {
        el.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
      }
    }

    makeDraggable();
  }
})();


"use strict";

(function () {
  angular.module('app').component('objectInventoriesModal', {
    controller: objectInventoriesModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/objectInventoriesModal/objectInventoriesModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function objectInventoriesModal($scope, localStorageService, $timeout, globals, $q, utils, Notification, unitFactory) {
    var vm = this;
    var active;
    var companyStore = globals.companyStore;
    $scope.companyData = companyStore.get();
    var Keys = ['materials', 'equipments', 'dcps', 'dcqs'];
    $scope.unit = 'm';
    $scope.units = [{
      label: 'm',
      value: 'm'
    }, {
      label: 'cm',
      value: 'cm'
    }, {
      label: 'mm',
      value: 'mm'
    }, {
      label: 'km',
      value: 'km'
    }, {
      label: 'pcs',
      value: 'pcs'
    }];
    $scope.units2 = [{
      label: 'm²',
      value: 'm2'
    }, {
      label: 'cm²',
      value: 'cm2'
    }, {
      label: 'mm²',
      value: 'mm2'
    }, {
      label: 'km²',
      value: 'km2'
    }, {
      label: 'pcs',
      value: 'pcs2'
    }];
    $scope.units3 = [{
      label: 'm³',
      value: 'm3'
    }, {
      label: 'cm³',
      value: 'cm3'
    }, {
      label: 'mm³',
      value: 'mm3'
    }, {
      label: 'km³',
      value: 'km3'
    }, {
      label: 'pcs',
      value: 'pcs3'
    }];
    $scope.units4 = [{
      label: 'hrs',
      value: 'hrs'
    }, {
      label: 'days',
      value: 'days'
    }, {
      label: 'weeks',
      value: 'weeks'
    }, {
      label: 'months',
      value: 'months'
    }];
    $scope.units5 = [{
      label: 'kg',
      value: 'kg'
    }, {
      label: 'g',
      value: 'g'
    }, {
      label: 'mg',
      value: 'mg'
    }];
    $scope.unitsEmpty = [{
      label: 'No unit',
      value: undefined
    }];
    vm.baseData = {
      materials: [],
      equipments: [],
      dcps: [],
      dcqs: []
    };
    vm.inventory = {
      materials: [],
      dcps: [],
      equipments: [],
      dcqs: []
    };
    $scope.lineType = false;
    vm.tabs = [{
      label: 'Materials',
      value: 'materials'
    }, {
      label: 'Equipments',
      value: 'equipments'
    }, {
      label: 'DCP',
      value: 'dcps'
    }, {
      label: 'DCQ',
      value: 'dcqs'
    }];
    vm.tab = 'materials';
    vm.sections = [];
    vm.options = [];
    vm.workTypes = [];
    vm.isMultiLevel = false;
    vm.isBim = true;
    vm.isSectionChanged = false;
    vm.objectInfo = {};
    vm.measureInfo = {};

    vm.$onInit = function () {
      vm.isBim = vm.resolve.isThree;
      $scope.unit = vm.resolve.unit;
      vm.objects = vm.resolve.objects;

      if (vm.isBim) {
        initObjectInfoFromBim();
      } else {
        initObjectInfoFromVp(vm.resolve.workLevel);
      }

      $scope.lineType = !vm.measureInfo.area;

      if (vm.isBim) {
        vm.options = [{
          label: 'Normal',
          value: 'none'
        }, {
          label: 'Width',
          value: 'width'
        }, {
          label: 'Height',
          value: 'height'
        }, {
          label: 'Length',
          value: 'length'
        }, {
          label: 'In',
          value: 'in'
        }, {
          label: 'Width*2',
          value: 'width2'
        }, {
          label: 'Height*2',
          value: 'height2'
        }, {
          label: 'Length*2',
          value: 'length2'
        }];
      } else {
        vm.options = [{
          label: 'Normal',
          value: 'none'
        }, {
          label: 'Width',
          value: 'width'
        }, {
          label: 'Height',
          value: 'height'
        }, {
          label: 'In',
          value: 'in'
        }, {
          label: 'Width*2',
          value: 'width2'
        }, {
          label: 'Height*2',
          value: 'height2'
        }];
      }

      vm.baseData.materials = vm.resolve.baseData.materials;
      vm.baseData.equipments = vm.resolve.baseData.equipments;
      vm.baseData.dcps = vm.resolve.baseData.dcps;
      vm.baseData.dcqs = vm.resolve.baseData.dcqs;
      vm.workTypes = vm.resolve.baseData.workTypes;
      vm.workLevel = vm.objectInfo.workLevel;
      vm.sections = vm.isMultiLevel ? vm.resolve.baseData.sections : filterSections(vm.workLevel);
      vm.section = vm.objectInfo.section;

      if (!vm.objectInfo.inventory) {
        for (var i = 0; i < Keys.length; i++) {
          var type = Keys[i];

          for (var j = 0; j < vm.baseData[type].length; j++) {
            var mat = vm.baseData[type][j];
            mat.option = 'none';
            mat.checked = false;
            mat.quantity = getMaterialQuantity(mat, type, vm.measureInfo);
            mat.workType = undefined;
            mat.originUnit = mat.unit;
          }
        }
      } else {
        vm.inventory = angular.copy(vm.objectInfo.inventory);

        for (var _i = 0; _i < Keys.length; _i++) {
          var _type = Keys[_i];

          if (!vm.inventory[_type]) {
            vm.inventory[_type] = [];
          }

          var list = vm.baseData[_type];

          for (var _i2 = 0; _i2 < list.length; _i2++) {
            list[_i2].option = 'none';
            list[_i2].checked = false;
            list[_i2].quantity = getMaterialQuantity(list[_i2], _type, vm.measureInfo);
            list[_i2].workType = undefined;
            list[_i2].originUnit = list[_i2].unit;
          }

          var _loop = function _loop(_i3) {
            var mat = vm.inventory[_type][_i3];
            var index = list.findIndex(function (item) {
              return item._id === mat._id;
            });

            if (index !== -1) {
              if (!vm.isBim || angular.isUndefined(vm.objects[0].faceMode) || vm.objects[0].faceMode === 'pershape') {
                list[index].checked = true;
              } else {
                list[index].checked = mat.selectedFace.findIndex(function (item) {
                  return vm.objects[0].selIndex === item;
                }) !== -1;
              }

              list[index].option = mat.option;
              list[index].unit = mat.unit;
              list[index].quantity = getMaterialQuantity(mat, _type, vm.measureInfo);
              list[index].workType = mat.workType;
            }
          };

          for (var _i3 = 0; _i3 < vm.inventory[_type].length; _i3++) {
            _loop(_i3);
          }
        }
      }
    };

    $scope.onTab = function (tab) {
      vm.tab = tab;
    };

    vm.selectMat = function (mat, type) {
      if (angular.isUndefined(vm.inventory) || angular.isUndefined(vm.inventory[type])) return;
      var arr = vm.inventory[type];
      mat.isIn = false;

      if (!vm.isBim || angular.isUndefined(vm.objects[0].faceMode) || vm.objects[0].faceMode === 'pershape') {
        var findIndex = arr.findIndex(function (x) {
          return x._id === mat._id;
        });

        if (findIndex !== -1) {
          if (mat.checked === false) {
            arr.splice(findIndex, 1);
            mat.checked = false;
          }
        } else {
          if (mat.checked === true) {
            mat.quantity = getMaterialQuantity(mat, type, vm.measureInfo);
            arr.push(angular.copy(mat));
            mat.checked = true;
          }
        }
      } else {
        var _findIndex = arr.findIndex(function (x) {
          return x._id === mat._id;
        });

        if (_findIndex !== -1) {
          if (mat.checked === false) {
            var idx = arr[_findIndex].selectedFace.findIndex(function (item) {
              return item === vm.objects[0].selIndex;
            });

            if (idx !== -1) {
              arr[_findIndex].selectedFace.splice(idx, 1);

              if (arr[_findIndex].selectedFace.length <= 0) {
                arr.splice(_findIndex, 1);
              }
            }
          } else {
            var _idx = arr[_findIndex].selectedFace.findIndex(function (item) {
              return item === vm.objects[0].selIndex;
            });

            if (_idx === -1) {
              arr[_findIndex].selectedFace.push(vm.objects[0].selIndex);
            }
          }
        } else {
          if (mat.checked === true) {
            mat.quantity = getMaterialQuantity(mat, type, vm.measureInfo);
            var newmat = angular.copy(mat);
            arr.push(newmat);

            if (angular.isUndefined(newmat.selectedFace)) {
              newmat.selectedFace = [];
            }

            newmat.selectedFace.push(vm.objects[0].selIndex);
          } else {// to do adding
          }
        }
      }
    };

    vm.changeOption = function (mat, type) {
      if (angular.isUndefined(vm.inventory) || angular.isUndefined(vm.inventory[type])) return;
      var arr = vm.inventory[type];
      mat.unit = getMaterialUnit(mat);
      mat.quantity = getMaterialQuantity(mat, type, vm.measureInfo);
      var find = arr.find(function (x) {
        return x._id === mat._id;
      });

      if (find) {
        find.option = mat.option;
        find.quantity = mat.quantity;
        find.unit = mat.unit;
      }
    };

    vm.changeUnit = function (mat, type) {
      if (angular.isUndefined(vm.inventory) || angular.isUndefined(vm.inventory[type])) return;
      mat.quantity = getMaterialQuantity(mat, type, vm.measureInfo);
      var arr = vm.inventory[type];
      var find = arr.find(function (x) {
        return x._id === mat._id;
      });

      if (find) {
        find.unit = mat.unit;
        find.quantity = mat.quantity;
      }
    };

    vm.changeWorkType = function (mat, type) {
      if (angular.isUndefined(vm.inventory) || angular.isUndefined(vm.inventory[type])) return;
      var arr = vm.inventory[type];
      var find = arr.find(function (x) {
        return x._id === mat._id;
      });

      if (find) {
        find.workType = mat.workType;
      }
    };

    vm.changeQuantity = function (mat, type) {
      if (angular.isUndefined(vm.inventory) || angular.isUndefined(vm.inventory[type])) return;
      var arr = vm.inventory[type];
      var find = arr.find(function (x) {
        return x._id === mat._id;
      });

      if (find) {
        find.quantity = mat.quantity;
      }
    };

    vm.selectSection = function () {
      vm.isSectionChanged = true;
    };

    $scope.getColor = function (mat) {
      if (!mat.color) return 'transparent';
      return utils.ha2rgba(mat.color, mat.opacity / 100);
    };

    $scope.onClose = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.assign = function () {
      if (!checkWorkTypes()) {
        Notification.error('Please select work type.');
        return;
      }

      var info = vm.inventory;
      info.unit = $scope.unit;
      info.section = vm.section;

      if (vm.isBim) {
        assignBimInventory(info);
      } else {
        assignVpInventory(info);
      }

      Notification.success('Inventory is assigned.');
      vm.modalInstance.close();
    };

    $scope.isLengthUnit = function (unit) {
      return unitFactory.isLength(unit);
    };

    $scope.isAreaUnit = function (unit) {
      return unitFactory.isArea(unit);
    };

    $scope.isVolumeUnit = function (unit) {
      return unitFactory.isVolume(unit);
    };

    $scope.isTimeUnit = function (unit) {
      return unitFactory.isTime(unit);
    };

    $scope.isWeightUnit = function (unit) {
      return unitFactory.isWeight(unit);
    };

    function getMaterialUnit(mat) {
      if (utils.isEmpty(mat.unit) || unitFactory.isTime(mat.unit) || unitFactory.isWeight(mat.unit)) {
        return mat.unit;
      }

      var newUnit = unitFactory.getDimension(mat.unit);
      var oldUnit = unitFactory.getDimension(mat.originUnit);

      if (!newUnit || !oldUnit) {
        return mat.unit;
      }

      if (mat.option === 'width' || mat.option === 'height' || mat.option === 'length' || mat.option === 'width2' || mat.option === 'height2' || mat.option === 'length2') {
        return newUnit.unit;
      }

      return oldUnit.dim > 1 ? newUnit.unit + oldUnit.dim : newUnit.unit;
    }

    function getMaterialQuantity(mat, type, measureInfo) {
      var unit = mat.unit;
      var quantity = 0;

      if (utils.isEmpty(unit)) {
        return 0;
      }

      if (unitFactory.isTime(unit) || unitFactory.isWeight(unit)) {
        return mat.quantity ? utils.num(mat.quantity) : 1;
      }

      var newUnit = unitFactory.getDimension(unit);

      if (newUnit === false) {
        return quantity;
      }

      var dim = newUnit.dim;
      var realUnit = unitFactory.checkUnitDefined(newUnit.unit);

      if (!realUnit) {
        return quantity;
      }

      var scale = unitFactory.getScaleRatio($scope.unit, realUnit);

      if (mat.option === 'width') {
        quantity = measureInfo.width * scale;
      } else if (mat.option === 'height') {
        quantity = measureInfo.height * scale;
      } else if (mat.option === 'length') {
        quantity = measureInfo.length * scale;
      } else if (mat.option === 'width2') {
        quantity = measureInfo.width * scale * 2;
      } else if (mat.option === 'height2') {
        quantity = measureInfo.height * scale * 2;
      } else if (mat.option === 'length2') {
        quantity = measureInfo.length * scale * 2;
      } else if (dim === 1) {
        quantity = mat.option === 'in' ? measureInfo.perimeterIn : measureInfo.perimeter;
        quantity *= scale;
      } else if (dim === 2) {
        quantity = measureInfo.area * scale * scale;
      } else if (dim === 3) {
        quantity = measureInfo.volume * scale * scale * scale;
      }

      if ((type === 'dcps' || type === 'dcqs') && newUnit.unit === 'pcs') {
        quantity *= 0.8;
      }

      return quantity;
    }

    function initObjectInfoFromBim() {
      var bimObjects = vm.objects;
      vm.objectInfo = {
        inventory: {},
        workLevel: bimObjects[0].workLevel,
        unit: 'm',
        measures: []
      };
      vm.measureInfo = {
        width: 0,
        height: 0,
        length: 0,
        perimeter: 0,
        perimeterIn: 0,
        area: 0,
        volume: 0
      };
      var isBlock = vm.resolve.isBlockMode;

      if (bimObjects.length <= 1) {
        var info = bimObjects[0].getGeometricalFaceInfo(isBlock);
        var measureInfo = {
          width: info.face.width,
          height: info.face.height,
          length: info.size.z,
          perimeter: info.perimeter,
          perimeterIn: info.perimeter,
          area: info.area,
          volume: info.volume
        };
        var size_items = [info.size.x, info.size.y, info.size.z];
        var face_items = [info.face.width, info.face.height];

        for (var _i4 = 0, _size_items = size_items; _i4 < _size_items.length; _i4++) {
          var item = _size_items[_i4];

          if (face_items.indexOf(item) === -1) {
            measureInfo.length = item;
            break;
          }
        }

        var inventory = bimObjects[0].getInventory();
        vm.objectInfo.inventory = angular.copy(inventory);
        vm.objectInfo.measures.push(measureInfo);

        if (inventory && inventory.section) {
          vm.objectInfo.section = inventory.section;
        }

        vm.measureInfo.width = measureInfo.width;
        vm.measureInfo.height = measureInfo.height;
        vm.measureInfo.length = measureInfo.length;
        vm.measureInfo.perimeter = measureInfo.perimeter;
        vm.measureInfo.perimeterIn = measureInfo.perimeterIn;
        vm.measureInfo.area = measureInfo.area;
        vm.measureInfo.volume = measureInfo.volume;
      } else {
        for (var i = 0; i < bimObjects.length; i++) {
          var bimObject = bimObjects[i];

          var _inventory = bimObject.getInventory();

          if (_inventory) {
            mergeInventory(vm.objectInfo.inventory, _inventory);
          }

          if (vm.objectInfo.workLevel !== bimObject.workLevel) {
            vm.objectInfo.workLevel = 'Multiple';
            vm.isMultiLevel = true;
          }

          var _info = bimObject.getGeometricalFaceInfo(isBlock);

          var _measureInfo = {
            width: _info.face.width,
            height: _info.face.height,
            length: _info.size.z,
            perimeter: _info.perimeter,
            perimeterIn: _info.perimeter,
            area: _info.area,
            volume: _info.volume
          };
          var _size_items2 = [_info.size.x, _info.size.y, _info.size.z];
          var _face_items = [_info.face.width, _info.face.height];

          for (var _i5 = 0, _size_items3 = _size_items2; _i5 < _size_items3.length; _i5++) {
            var _item = _size_items3[_i5];

            if (_face_items.indexOf(_item) === -1) {
              _measureInfo.length = _item;
              break;
            }
          }

          vm.objectInfo.measures.push(_measureInfo);
          vm.measureInfo.width += _measureInfo.width;
          vm.measureInfo.height += _measureInfo.height;
          vm.measureInfo.length += _measureInfo.length;
          vm.measureInfo.perimeter += _measureInfo.perimeter;
          vm.measureInfo.perimeterIn += _measureInfo.perimeterIn;
          vm.measureInfo.area += _measureInfo.area;
          vm.measureInfo.volume += _measureInfo.volume;
        }
      }

      if (!utils.isEmpty($scope.unit)) {
        var scale = unitFactory.getValueWithAbsoluteUnit(1, $scope.unit, true);
        vm.measureInfo.width *= scale;
        vm.measureInfo.height *= scale;
        vm.measureInfo.length *= scale;
        vm.measureInfo.perimeter *= scale;
        vm.measureInfo.perimeterIn *= scale;
        vm.measureInfo.area *= scale * scale;
        vm.measureInfo.volume *= scale * scale * scale;
      }
    }

    function mergeInventory(inventory, add) {
      if (utils.isEmpty(add)) {
        return;
      }

      if (utils.isEmpty(inventory)) {
        var _loop2 = function _loop2(i) {
          var key = Keys[i];
          inventory[key] = [];

          if (!utils.isEmpty(add[key])) {
            add[key].forEach(function (item) {
              return inventory[key].push(item);
            });
          }
        };

        for (var i = 0; i < Keys.length; i++) {
          _loop2(i);
        }
      } else {
        var _loop3 = function _loop3(_i6) {
          var key = Keys[_i6];
          var list = inventory[key];

          if (!list) {
            list = [];
            inventory[key] = list;
          }

          if (!utils.isEmpty(add[key])) {
            add[key].forEach(function (item) {
              if (list.findIndex(function (x) {
                return x._id === item._id;
              }) === -1) {
                list.push(item);
              }
            });
          }
        };

        for (var _i6 = 0; _i6 < Keys.length; _i6++) {
          _loop3(_i6);
        }
      }
    }

    function assignBimInventory(info) {
      var bimObjects = vm.objects;

      for (var i = 0; i < bimObjects.length; i++) {
        var matInfo = angular.copy(info);
        matInfo.id = bimObjects[i].id;
        matInfo.workLevel = bimObjects[i].workLevel;

        if (!vm.isSectionChanged) {
          var inventory = bimObjects[i].getInventory();
          matInfo.section = inventory ? inventory.section : undefined;
        }

        for (var j = 0; j < Keys.length; j++) {
          var type = Keys[j];
          var materials = matInfo[type];

          if (materials) {
            for (var k = 0; k < materials.length; k++) {
              materials[k].quantity = getMaterialQuantity(materials[k], type, vm.objectInfo.measures[i]); // if ( !materials[k].selectedFace ) {
              //   materials[k].selectedFace = [];
              // }
              // if( angular.isDefined(materials[k].checked) && materials[k].checked == true && materials[k].selectedFace.findIndex( item => item == bimObjects[i].selIndex ) === -1 ){
              //   materials[k].selectedFace.push(bimObjects[i].selIndex);
              // }
            }
          }
        }

        bimObjects[i].setInventoryData(matInfo);
      }
    }

    function initObjectInfoFromVp(workLevel) {
      var vpObject = vm.objects;
      vm.objectInfo = {
        inventory: {},
        workLevel: workLevel,
        workType: undefined,
        unit: 'm'
      };
      var inventory = vpObject.getInventory();
      vm.objectInfo.id = vpObject.guid;

      if (inventory) {
        vm.objectInfo.inventory = angular.copy(inventory);
        vm.objectInfo.section = inventory.section;
      }

      var info = vpObject.getGeometricalInfo();
      vm.measureInfo = {
        width: info.width,
        height: info.height,
        length: 0,
        perimeter: info.perimeterOut,
        perimeterIn: info.perimeterIn,
        area: info.area,
        volume: 0
      };

      if (!utils.isEmpty($scope.unit)) {
        var scale = unitFactory.getValueWithAbsoluteUnit(1, $scope.unit, true);
        vm.measureInfo.width *= scale;
        vm.measureInfo.height *= scale;
        vm.measureInfo.perimeter *= scale;
        vm.measureInfo.perimeterIn *= scale;
        vm.measureInfo.area *= scale * scale;
      }
    }

    function assignVpInventory(info) {
      var vpObject = vm.objects;
      var matInfo = angular.copy(info);
      matInfo.id = vpObject.id;
      vpObject.setInventoryData(matInfo);
    }

    function checkWorkTypes() {
      for (var i = 0; i < Keys.length; i++) {
        var type = Keys[i];
        var materials = vm.inventory[type];

        if (materials) {
          for (var j = 0; j < materials.length; j++) {
            if (utils.isEmpty(materials[j].workType)) {
              return false;
            }
          }
        }
      }

      return true;
    }

    function filterSections(workLevel) {
      var sections = [];
      vm.resolve.baseData.sections.forEach(function (group) {
        sections.push({
          _id: group._id,
          name: group.name
        });

        if (group.levels) {
          group.levels.forEach(function (level) {
            if (level.name === workLevel) {
              addLevelToSections(level, sections, '-');
            }
          });
        }
      });
      return sections;
    }

    function addLevelToSections(level, sections, prefix) {
      if (level.levels) {
        level.levels.forEach(function (subLevel) {
          sections.push({
            _id: subLevel._id,
            name: prefix + subLevel.name
          });
          addLevelToSections(subLevel, sections, prefix + '-');
        });
      }
    }

    function makeDraggable() {
      var container = angular.element('.modal-content')[0];
      var headerElem = angular.element('#object-inventories-header')[0];
      container.addEventListener("touchstart", dragStart, false);
      container.addEventListener("touchend", dragEnd, false);
      container.addEventListener("touchmove", drag, false);
      container.addEventListener("mousedown", dragStart, false);
      container.addEventListener("mouseup", dragEnd, false);
      container.addEventListener("mousemove", drag, false);
      active = false;
      var currentX;
      var currentY;
      var initialX;
      var initialY;
      var xOffset = 0;
      var yOffset = 0;

      function dragStart(e) {
        if (e.target !== headerElem) {
          return;
        }

        if (e.type === "touchstart") {
          initialX = e.touches[0].clientX - xOffset;
          initialY = e.touches[0].clientY - yOffset;
        } else {
          initialX = e.clientX - xOffset;
          initialY = e.clientY - yOffset;
        }

        active = true;
      }

      function dragEnd() {
        initialX = currentX;
        initialY = currentY;
        active = false;
      }

      function drag(e) {
        if (active) {
          e.preventDefault();

          if (e.type === "touchmove") {
            currentX = e.touches[0].clientX - initialX;
            currentY = e.touches[0].clientY - initialY;
          } else {
            currentX = e.clientX - initialX;
            currentY = e.clientY - initialY;
          }

          xOffset = currentX;
          yOffset = currentY;
          setTranslate(currentX, currentY, container);
        }
      }

      function setTranslate(xPos, yPos, el) {
        el.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
      }
    }

    makeDraggable();
  }
})();


"use strict";

(function () {
  angular.module('app').component('modelColorModal', {
    controller: modelColorModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/modelColorModal/modelColorModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function modelColorModal($scope) {
    var vm = this;
    $scope.color = undefined;
    $scope.opacity = 100;
    var selectedColor = undefined;

    vm.$onInit = function () {
      vm.item = vm.resolve.item;
      $scope.color = vm.item ? vm.item.color : undefined;
    };

    $scope.selectNoColor = function () {
      selectedColor = undefined;
      $scope.color = selectedColor;
    };

    $scope.select = function () {
      selectedColor = $scope.color;
      vm.modalInstance.close({
        item: vm.item,
        color: selectedColor
      });
    };

    $scope.cancel = function () {
      vm.modalInstance.dismiss('cancel');
    };
  }
})();


"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module("app").component("filePickerModal", {
    controller: filePickerModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/file-picker-modal/file-picker-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function filePickerModalController($document, Notification, apiFactory, globals, $log, $scope, $rootScope, utils, pdfFactory) {
    var vm = this;
    $scope.folderPaths = [];
    var projectStore = globals.projectStore,
        userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.projectData = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    $scope.utils = utils;
    $scope.tab = 'remote';
    $scope.rootFolders = [];
    vm.selectedFolder = undefined;
    vm.breadCrumbList = [];
    vm.browseHistory = [];
    vm.browseHistoryIndex = 0;
    vm.levels = [];
    vm.selectedLevel = 'Ground';

    vm.$onInit = function () {
      vm.levels = [];
      $scope.loading = true;
      apiFactory.listAllLevelTypes().then(function (res) {
        $scope.loading = false;
        vm.levels = res.data.list.map(function (x) {
          return {
            _id: x._id,
            name: x.tagName
          };
        });

        for (var i = 1; i <= 100; i++) {
          vm.levels.push({
            _id: i.toString(),
            name: i.toString()
          });
        }
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.getPrimaryFolders = function () {
      var payload = {
        projectId: vm.projectData._id
      };
      $scope.loading = true;
      apiFactory.getRootFolders(payload).then(function (resp) {
        $scope.loading = false;
        vm.rootFolders = [{
          _id: 'project',
          name: 'PROJECT',
          children: resp.data.data.project
        }, {
          _id: 'company',
          name: 'COMPANY',
          children: resp.data.data.company
        }, {
          _id: 'personal',
          name: 'PERSONAL',
          children: resp.data.data.personal
        }];
        $scope.selectFolder(vm.rootFolders[0]);
      })["catch"](function (err) {
        $log.error(err);
        $scope.loading = false;
      });
    };

    vm.getPrimaryFolders();

    $scope.isAvailableBackward = function () {
      return vm.browseHistoryIndex > 0;
    };

    $scope.isAvailableForward = function () {
      return vm.browseHistoryIndex < vm.browseHistory.length - 1;
    };

    $scope.backward = function () {
      if (vm.browseHistoryIndex === 0) {
        return;
      }

      vm.browseHistoryIndex--;
      $scope.selectFolder(vm.browseHistory[vm.browseHistoryIndex], true);
    };

    $scope.forward = function () {
      if (vm.browseHistoryIndex === vm.browseHistory.length - 1) {
        return;
      }

      vm.browseHistoryIndex++;
      $scope.selectFolder(vm.browseHistory[vm.browseHistoryIndex], true);
    };

    vm.isRootFolder = function () {
      return vm.selectedFolder._id === 'project' || vm.selectedFolder._id === 'company' || vm.selectedFolder._id === 'personal';
    };

    $scope.switchTab = function (tab) {
      $scope.pdfPages = [];
      vm.selectedFile = undefined;
      $scope.tab = tab;
    };

    $scope.selectFolder = function (folder) {
      var historyAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      vm.selectedFolder = folder;
      vm.selectedFile = undefined;

      if (!historyAction) {
        vm.browseHistory.push(folder);
        vm.browseHistoryIndex = vm.browseHistory.length - 1;
      }

      if (vm.isRootFolder()) {
        vm.breadCrumbList = [vm.selectedFolder];
      } else {
        vm.breadCrumbList.push(vm.selectedFolder);
      }

      var API;

      if (folder._id === 'project') {
        API = apiFactory.getProjectHierarchy({
          projectId: vm.projectData._id
        });
      } else if (folder._id === 'company') {
        API = apiFactory.getCompanyHierarchy();
      } else if (folder._id === 'personal') {
        API = apiFactory.getPersonalHierarchy({
          projectId: vm.projectData._id,
          userId: vm.userData._id
        });
      } else {
        API = apiFactory.viewHierarchy(folder._id);
      }

      $scope.loading = true;
      API.then(function (resp) {
        $scope.loading = false;
        vm.currentFolders = angular.isDefined(resp.data.data) ? resp.data.data.hierarchies : resp.data.folders;
        vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
        vm.currentFiles = angular.isDefined(resp.data.data) ? resp.data.data.rootFiles.filter(function (x) {
          return x.format === 'pdf';
        }) : resp.data.files.filter(function (x) {
          return x.format === 'pdf';
        });
        vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);
      });
    };

    $scope.selectFile = function (file) {
      vm.selectedFile = file;
    };

    $scope.selectFileAndOpen = function (file) {
      vm.selectedFile = file;
      $scope.openPDF();
    };

    vm.searchCallback = function () {
      if (utils.isEmpty(vm.searchText)) {
        vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
        vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
      } else {
        vm.currentFilteredFolders = vm.currentFolders.filter(function (x) {
          return x.name.toLowerCase().includes(vm.searchText.toLowerCase());
        });
        vm.currentFilteredFiles = vm.currentFiles.filter(function (x) {
          return x.originalname.toLowerCase().includes(vm.searchText.toLowerCase());
        });
      }
    };

    function readPdfFile(inputFile) {
      var temporaryFileReader = new FileReader();
      return new Promise(function (resolve, reject) {
        temporaryFileReader.onerror = function () {
          temporaryFileReader.abort();
          reject(new DOMException('Problem parsing input file.'));
        };

        temporaryFileReader.onload = function () {
          resolve(temporaryFileReader.result);
        };

        temporaryFileReader.readAsArrayBuffer(inputFile);
      });
    }

    vm.fileUpdated = function (files) {
      if (files && files.length) {
        vm.files = files;

        if (files[0].type !== 'application/pdf') {
          Notification.error('Please select correct pdf file.');
          return;
        }

        var name = utils.getFileNameWithoutExtension(files[0].name);
        $scope.loading = true;
        readPdfFile(files[0]).then(function (buffer) {
          pdfjsLib.getDocument(buffer).promise.then(function (pdf) {
            Promise.all(_toConsumableArray(Array(pdf.numPages).keys()).map(function (_, i) {
              return pdf.getPage(i + 1);
            })).then(function (pages) {
              Promise.all(pages.map(function (x, i) {
                var viewport = x.getViewport({
                  scale: 1
                });
                var canvas = $document[0].createElement("canvas");
                var context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                var task = x.render({
                  canvasContext: context,
                  viewport: viewport
                });
                return task.promise.then(function () {
                  return {
                    pageNo: i,
                    title: "".concat(name, "_").concat(Date.now()),
                    selected: false,
                    description: '',
                    url: canvas.toDataURL("image/png"),
                    getViewport: function getViewport() {}
                  };
                });
              })).then(function (results) {
                $scope.loading = false;
                $scope.pdfPages = results;
                $scope.$apply();
              })["catch"](function (e) {
                $scope.loading = false;
                $log.error(e);
              });
            })["catch"](function (e) {
              $scope.loading = false;
              $log.error(e);
            });
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
          });
        })["catch"](function () {
          $scope.loading = false;
        });
      }
    };

    $scope.backwardPage = function () {
      if (vm.selectedPageIndex === 0) {
        return;
      }

      vm.selectedPageIndex--;
      vm.selectedPage = $scope.pdfPages[vm.selectedPageIndex];
    };

    $scope.forwardPage = function () {
      if (vm.selectedPageIndex === $scope.pdfPages.length - 1) {
        return;
      }

      vm.selectedPageIndex++;
      vm.selectedPage = $scope.pdfPages[vm.selectedPageIndex];
    };

    $scope.close = function () {
      vm.modalInstance.dismiss('cancel');
    };

    function _openPDF() {
      if (utils.isEmpty($scope.pdfPages)) {
        Notification.error('Could not parse pdf pages');
        return;
      }

      vm.selectedPage = $scope.pdfPages[0];
      vm.selectedPageIndex = 0;
      $scope.submitStep = true;
    }

    $scope.openPDF = function () {
      if ($scope.tab === 'local' && utils.isEmpty($scope.pdfPages) || $scope.tab === 'remote' && !vm.selectedFile) {
        Notification.error('Please select at least one file or upload one.');
        return;
      }

      if (vm.selectedFile) {
        if (/cloudinary/.test(vm.selectedFile.secure_url)) {
          var fileArray = extractPagesFromPdf(vm.selectedFile.originalname, vm.selectedFile.secure_url, vm.selectedFile.pages, vm.selectedFile.level);
          $scope.pdfPages = angular.copy(fileArray);

          _openPDF();
        } else {
          var name = utils.getFileNameWithoutExtension(vm.selectedFile.originalname);

          if (vm.selectedFile.planDocument) {
            $scope.pdfPages = vm.selectedFile.planImages.map(function (x, i) {
              return {
                pageNo: i,
                title: "".concat(name, "_").concat(Date.now()),
                url: x,
                selected: false,
                description: "",
                getViewport: function getViewport() {}
              };
            });

            _openPDF();
          } else {
            $scope.loading = true;
            createPagesFromPdf(vm.selectedFile).then(function (pages) {
              $scope.loading = false;
              $scope.pdfPages = pages;

              _openPDF();

              $scope.$apply();
            })["catch"](function (err) {
              $scope.loading = false;
              $log.error(err);
              Notification.error('Could not parse pdf pages');
            });
          }
        }
      } else {
        _openPDF();
      }
    };

    $scope.cancelSubmit = function () {
      $scope.submitStep = false;
    };

    $scope.submit = function () {
      if (utils.isEmpty(vm.selectedPage.title)) {
        Notification.error('Please input title');
        return;
      } else if (utils.isEmpty(vm.selectedLevel)) {
        Notification.error('Please select level');
        return;
      }

      var asset = vm.selectedFile;

      if (angular.isUndefined(asset)) {
        asset = {};
        asset.planDocument = null;
        asset._id = null;
        asset.secure_url = null;
      }

      var endpoint = !asset.planDocument && /cloudinary/.test(asset.secure_url) ? "addProjectRoofPlan" : asset._id ? "addRoofPlansFromAsset" : "addRoofPlansFromAssetWithUpload";
      var payload = {
        assetId: asset._id,
        projectId: vm.projectData._id,
        pages: [vm.selectedPage],
        level: vm.selectedLevel
      };

      if (endpoint === 'addRoofPlansFromAssetWithUpload') {
        payload.files = vm.files;
        var thumbnailImg = utils.dataURLtoFile(payload.pages[0].url, "planThumbnailImage_".concat(payload.pages[0].title));
        payload.files.push(thumbnailImg);
        delete payload.pages[0].url;
      } else {
        payload.file = utils.dataURLtoFile(payload.pages[0].url, "planThumbnailImage_".concat(payload.pages[0].title));
        delete payload.pages[0].url;
      }

      $scope.loading = true;
      apiFactory[endpoint](payload).then(function (res) {
        $scope.loading = false;
        asset.roofPlanId = res.data.data[0]._id;
        Notification.success('Plan created successfully.');
        vm.modalInstance.close(true);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function extractPagesFromPdf(pdfName, pdfLink, pageCount, level) {
      var name = utils.getFileNameWithoutExtension(pdfName);
      return _toConsumableArray(Array(pageCount).keys()).reduce(function (acc, _, i) {
        var pageObj = {
          pageNo: i,
          url: pdfLink.replace("/upload/", "/upload/pg_".concat(i + 1, "/")).replace(/\.pdf$/, ".png"),
          title: "".concat(name, "_").concat(Date.now()),
          level: level || 'Ground',
          selected: false,
          description: "",
          getViewport: function getViewport() {}
        };
        acc.push(pageObj);
        return acc;
      }, []);
    }

    function createPagesFromPdf(pdf) {
      var name = utils.getFileNameWithoutExtension(pdf.originalname);
      return new Promise(function (resolve, reject) {
        pdfjsLib.getDocument(pdf.secure_url).promise.then(function (doc) {
          var apis = [];

          for (var i = 0; i < doc.numPages; i++) {
            apis.push(pdfFactory.getImageByUrl(pdf.secure_url, i + 1, 4096));
          }

          Promise.all(apis).then(function (imgDataList) {
            var result = imgDataList.map(function (imgData, index) {
              return {
                pageNo: index,
                title: "".concat(name, "_").concat(Date.now()),
                selected: false,
                description: '',
                url: imgData.image,
                getViewport: function getViewport() {}
              };
            });
            resolve(result);
          })["catch"](function (err) {
            reject(err);
          });
        })["catch"](function (e) {
          reject(e);
        });
      });
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('elementsModal', {
    controller: elementsModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/elementsModal/elementsModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function elementsModal($document, $window, $scope) {
    var vm = this;
    $scope.curTab = 'site';
    var iconNodes = undefined;
    var elementNodes = undefined;
    var icons = [];
    var elements = [];
    var selected = undefined;
    var iconNames = ["Sink", "Sink 2", "Sink 3", "Sink 4", "Sink 5", "Sink 6", "Sink 7", "Sink 8", "Sink 9", "Sink 10", "Sink 11", "Sink 12", "Counterto...", "Pedestal Sink", "Toilet 1", "Toilet 2", "Toilet 3", "Toilet 4", "Toilet 5", "Bidet", "Squat wc", "Shower", "Corner shower", "Corner Bath", "Bathroom", "Bathtub 1", "Bathtub 2", "Bathtub 3", "Bathtub 4", "Bathtub 5", "Water Tap 1", "Water Tap 2", "Water Tap 3", "Water Tap 4", "Water Tap 5", "Dustbin", "Toilet Paper", "Towel Rack", "Towel Rack 2", "Light", "Shower Lamp 1", "Shower Lamp 2", "Shower Lamp 3", "Shower Lamp 4", "Shower Lamp 5", "Shower Lamp 6"];

    function init() {
      iconNodes = $document[0].getElementById('icons_content');
      iconNodes.innerHTML = '';
      elementNodes = $document[0].getElementById('elements_content');
      elementNodes.innerHTML = '';

      for (var i = 0; i < 46; i++) {
        addIcon('/assets/images/cgviewer/icons/' + (i + 1) + '.svg', iconNames[i], true);
      }

      for (var _i = 1; _i < 154; _i++) {
        addElement('/assets/images/cgviewer/elements/' + _i + '.svg', true);
      }

      $document[0].getElementById('icons_assign').addEventListener('click', function () {
        assign();
      });
      $document[0].getElementById('icons_cancel').addEventListener('click', function () {
        $scope.cancel();
      });
      $document[0].getElementById('icons_add').addEventListener('click', function () {
        addCustom();
      });
    }

    $scope.searchIcons = function () {
      var filter = $scope.iconFilter;
      var divs = iconNodes.childNodes;

      for (var i = 0; i < icons.length; i++) {
        var div = divs[i];

        if (icons[i].name.toLowerCase().indexOf(filter) !== -1) {
          div.style.display = 'inline-grid';
        } else {
          div.style.display = 'none';
        }
      }
    };

    $scope.changeTab = function (tab) {
      $scope.curTab = tab;
    }; // Add new material in material dialog


    function addIcon(img, name, isUrl) {
      var divTag = $document[0].createElement('div');
      divTag.classList.add('icon');
      var imgTag = $document[0].createElement('img');

      if (isUrl) {
        imgTag.src = img;
      } else {
        imgTag.src = 'data:image/svg+xml;base64,' + $window[0].btoa(img);
      }

      imgTag.addEventListener('click', function () {
        onClickIcon(img, divTag, isUrl, false);
      }, false);
      var spanTag = $document[0].createElement('span');
      spanTag.textContent = name;
      divTag.appendChild(imgTag);
      divTag.appendChild(spanTag);
      iconNodes.appendChild(divTag);
      icons.push({
        name: name,
        icon: img
      });
    }

    function onClickIcon(img, node, isUrl, inElement) {
      if (selected) {
        selected.tag.classList.remove('active');
        selected = undefined;
      }

      selected = {
        tag: node,
        img: img,
        isUrl: isUrl,
        element: inElement
      };
      selected.tag.classList.add('active');
    }

    function addElement(img, isUrl) {
      var divTag = $document[0].createElement('div');
      divTag.classList.add('icon');
      var imgTag = $document[0].createElement('img');

      if (isUrl) {
        imgTag.src = img;
      } else {
        imgTag.src = 'data:image/svg+xml;base64,' + $window[0].btoa(img);
      }

      imgTag.addEventListener('click', function () {
        onClickIcon(img, divTag, isUrl, true);
      }, false);
      divTag.appendChild(imgTag);
      elementNodes.appendChild(divTag);
      elements.push({
        icon: img
      });
    }

    function assign() {
      if (selected.img) {
        vm.modalInstance.close({
          image: selected.img,
          isUrl: selected.isUrl,
          element: selected.element
        });
      }
    }

    $scope.cancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    function addCustom(toIcon) {
      var input = $document[0].createElement('input');
      input.type = 'file';
      input.accept = '.svg';

      input.onchange = function (e) {
        // getting a hold of the file reference
        var file = e.target.files[0]; // setting up the reader

        var reader = new FileReader();
        reader.readAsText(file, 'UTF-8'); // here we tell the reader what to do when it's done reading...

        reader.onload = function (readerEvent) {
          var content = readerEvent.target.result; // this is the content!

          if (toIcon) {
            addIcon(content, "Custom", false);
          } else {
            addElement(content, false);
          }
        };
      };

      input.click();
    }

    init();
  }
})();


"use strict";

(function () {
  angular.module('app').component('calibrationModal', {
    controller: calibrationModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/modals/calibrationModal/calibrationModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function calibrationModal($scope, globals) {
    var companyStore = globals.companyStore;
    var vm = this;
    vm.companyData = companyStore.get();
    $scope.units = [{
      label: 'm',
      value: 1
    }, {
      label: 'cm',
      value: 0.01
    }, {
      label: 'mm',
      value: 0.001
    }, {
      label: 'in',
      value: 0.254
    }, {
      label: 'ft',
      value: 0.3048
    }, {
      label: 'km',
      value: 1000
    }, {
      label: 'mile',
      value: 1609.344
    }];

    vm.$onInit = function () {
      vm.distance = vm.resolve.distance;
      vm.calibration = 0;
      vm.unit = 1;
    };

    vm.onConfirm = function () {
      var calibration = vm.calibration;
      calibration *= vm.unit;
      var scale = vm.distance !== 0 ? calibration / vm.distance : 1;
      vm.modalInstance.close(scale);
    };

    vm.onClose = function () {
      vm.modalInstance.dismiss();
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("vpSettings", vpSettings);

  function vpSettings() {
    return {
      restrict: "E",
      replace: 'true',
      templateUrl: 'app/main/cgviewer/directives/vp-settings/vp-settings.view.html',
      scope: {
        onChangeColorMode: '='
      },
      link: function link($scope) {
        $scope.colorModes = [{
          name: 'Normal',
          value: 'normal',
          icon: '/assets/icons/color-normal.svg'
        }, {
          name: 'Material',
          value: 'inventory',
          icon: '/assets/icons/color-material.svg'
        }];
        $scope.selectedColorMode = $scope.colorModes[0];

        $scope.colorModeSelected = function (color) {
          $scope.selectedColorMode = color;

          if ($scope.onChangeColorMode) {
            $scope.onChangeColorMode(color);
          }
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("vpPropertyIndicator", vpPropertyIndicator);

  function vpPropertyIndicator($timeout, $document, utils, $uibModal, $log) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/vp-property-indicator/vp-property-indicator.view.html',
      scope: {
        show: "=",
        vpObject: "=",
        pos: "=",
        unit: "=",
        viewer: "=",
        workLevel: "=",
        materials: "=",
        comboMaterials: "=",
        equipments: "=",
        comboEquipments: "=",
        workTypes: "=",
        sections: "=",
        onAssigned: "&"
      },
      link: function link($scope) {
        $scope.objectPropertyInfo = {
          materials: []
        };
        var indicatorRadius = 15;
        var expandMenuWidth = 247;
        var expandMenuHeight = 63;
        var popupIdList = ['object-information-properties', 'object-information-items'];
        $scope.curPopupId = -1;

        $scope.onClickExpandIcon = function ($event) {
          $event.stopPropagation();
          if (getPopupShowingStatus()) return;
          if (angular.isUndefined($scope.pos)) return;
          angular.element('#vp_property_expand_menu').show();
          angular.element('#vp_property_expand_menu').css("left", $scope.pos.x - expandMenuWidth / 2 + 'px');
          angular.element('#vp_property_expand_menu').css("top", $scope.pos.y - indicatorRadius - expandMenuHeight + 'px');
        };

        $scope.onClickPropertiesIcon = function () {
          if (getPopupShowingStatus()) return;
          if (angular.isUndefined($scope.pos)) return;
          var pos = {
            x: $scope.pos.x - indicatorRadius,
            y: $scope.pos.y + 40
          };
          showObjectPropertiesPopup(pos);
          $scope.curPopupId = 0;
        };

        $scope.onClickItemsIcon = function () {
          if (getPopupShowingStatus()) return;
          if (angular.isUndefined($scope.pos)) return;
          var pos = {
            x: $scope.pos.x - indicatorRadius,
            y: $scope.pos.y + 40
          };
          showObjectInventoriesPopup(pos);
          $scope.curPopupId = 1;
        };

        $scope.onClickCollapseIcon = function () {
          if (getPopupShowingStatus()) return;
          angular.element('#vp_property_expand_menu').hide();
        };

        $scope.onClickEvent = function () {
          angular.element('#vp_property_expand_menu').hide(); // angular.element('#vp_property_background_element').hide();

          angular.element('#vp_property_menu_model_info_window').hide();
          angular.element('#vp_property_expand_menu').hide();
          angular.element('#vp-property-indicator').hide();
          $scope.curPopupId = -1;
        };

        function getPopupShowingStatus() {
          for (var i = 0; i < popupIdList.length; i++) {
            var elem = $document[0].getElementById(popupIdList[i]);
            if (!elem) continue;
            var visibility = angular.element('#' + popupIdList[i]).css('display');

            if (visibility !== 'none') {
              $scope.curPopupId = i;
              return true;
            }
          }

          return false;
        }

        function showObjectPropertiesPopup(_pos) {
          if (angular.isUndefined($scope.vpObject)) return;
          var _objectInfo = {
            materials: [],
            width: 0,
            height: 0,
            length: 0,
            perimeter: 0,
            area: 0,
            volume: 0,
            unit: 'm'
          };
          var info = $scope.vpObject.getGeometricalInfo();
          _objectInfo.width = info.width;
          _objectInfo.height = info.height;
          _objectInfo.length = 0;
          _objectInfo.perimeter = info.perimeterOut;
          _objectInfo.area = info.area;
          _objectInfo.unit = $scope.unit;
          _objectInfo.id = $scope.vpObject.guid;

          if (angular.isDefined(info.wallHeight)) {
            _objectInfo.wallHeight = info.wallHeight;
          }

          var modal = $uibModal.open({
            animation: true,
            component: 'objectPropertiesModal',
            windowClass: 'object-properties-modal-window',
            backdropClass: 'object-properties-modal-backdrop',
            resolve: {
              objectInfo: function objectInfo() {
                return _objectInfo;
              },
              isThree: function isThree() {
                return false;
              },
              pos: function pos() {
                return _pos;
              }
            }
          });
          modal.result.then(function (result) {
            $log.log(result);
            $scope.curPopupId = -1;
          }, function (reason) {
            $log.log(reason);
            $scope.curPopupId = -1;
          });
        }

        function showObjectInventoriesPopup(_pos2) {
          if (angular.isUndefined($scope.vpObject)) return;
          $uibModal.open({
            animation: true,
            component: 'objectInventoriesModal',
            windowClass: 'object-inventories-modal-window',
            backdropClass: 'object-inventories-modal-backdrop',
            resolve: {
              objects: function objects() {
                return $scope.vpObject;
              },
              unit: function unit() {
                return $scope.unit;
              },
              workLevel: function workLevel() {
                return $scope.workLevel;
              },
              isThree: function isThree() {
                return false;
              },
              pos: function pos() {
                return _pos2;
              },
              baseData: function baseData() {
                return {
                  materials: $scope.materials,
                  dcps: $scope.comboMaterials,
                  equipments: $scope.equipments,
                  dcqs: $scope.comboEquipments,
                  workTypes: $scope.workTypes,
                  sections: $scope.sections
                };
              }
            }
          }).result.then(function () {
            $scope.curPopupId = -1;

            if ($scope.onAssigned) {
              $scope.onAssigned();
            }
          }, function (reason) {
            $log.log(reason);
            $scope.curPopupId = -1;
          });
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("vpObjectProperties", vpObjectProperties);

  function vpObjectProperties($timeout) {
    return {
      restrict: "E",
      templateUrl: "app/main/cgviewer/directives/vp-object-properties/object-properties.view.html",
      scope: {
        ngObject: "=",
        changeUnit: "=",
        inputMethod: "=",
        scaleTimes: "=",
        onChangeWall: "="
      },
      link: function link(scope) {
        scope.unit = 'm';
        scope.units = [{
          label: "m",
          value: "m"
        }, {
          label: "cm",
          value: "cm"
        }, {
          label: "mm",
          value: "mm"
        }];
        scope.euFormat = scope.inputMethod && scope.inputMethod === 'European et al.';

        scope.onChange = function () {
          if (scope.changeUnit) {
            scope.changeUnit(scope.unit);
            updateAreaAndPerimeter(scope.unit);
          }
        };

        function updateAreaAndPerimeter(unit, isRemoving) {
          if (!scope.ngObject) return;
          var scale = 1;

          if (isRemoving) {
            scope.perimeter = undefined;
            scope.perimeterIn = undefined;
            scope.area = undefined;
          } else {
            if (scope.ngObject.perimeter) {
              scope.perimeter = scope.ngObject.perimeter * scale;

              if (scope.ngObject.perimeterIn) {
                scope.perimeterIn = scope.ngObject.perimeterIn * scale;
              }
            }

            if (scope.ngObject.area) {
              scope.area = scope.ngObject.area * scale * scale;
            } else {
              scope.area = scope.ngObject.width * scope.ngObject.height * scale * scale;
            }
          }

          $timeout(function () {
            return scope.$apply();
          });
        }
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').directive("vpModel", vpModel);

  function vpModel($timeout, $log, Bim, VP, apiFactory, Notification, utils) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/vp-model/vpModel.view.html',
      scope: {
        ngModel: "=",
        ngVpId: "=",
        ngVp: "=",
        ngMatch: "="
      },
      link: function link($scope) {
        var vm = this;
        vm.bimModel = {};

        if ($scope.ngModel) {
          vm.modelId = $scope.ngModel._id;
          vm.title = utils.changeExtension($scope.ngModel.name, "ifc");
          load3dViewer($scope.ngModel);
        }

        vm.selectedVPPlan = undefined;

        $scope.confirmVPPlan = function () {
          if (vm.selectedVPPlan) {
            var bimPlan = vm.selectedVPPlan;
            vm.viewer.completeVPPlan(bimPlan);
            apiFactory.addModelToRoofPlan($scope.ngVpId, {
              modelId: $scope.ngModel._id,
              match: bimPlan.getSaveData()
            }).then(function () {
              $scope.ngModel.saved = true;
              Notification.success('Model saved successfully.');
            })["catch"](function (err) {
              $log.error(err);
            });
          }

          hidePlanControlMark();
        };

        $scope.removeVPPlan = function () {
          if (vm.selectedVPPlan) {
            vm.viewer.removeVPPlan(vm.selectedVPPlan);
            vm.selectedVPPlan = undefined;
          }

          if ($scope.ngVp) {
            vm.viewer.newVPPlan($scope.ngVp.canvasElement);
          }

          hidePlanControlMark();
        };

        $scope.$on('after:render', function () {
          vm.viewer.refreshVPPlan();
        });

        function load3dViewer(data) {
          vm.viewer = Bim.vpViewer(angular.element("#bimviewer")[0]);
          vm.viewer.create();
          vm.bimData = vm.viewer.getBimData();
          vm.viewer.on('objectSelected', onObjectSelect);
          vm.viewer.on('planAdded', applyData);
          vm.viewer.on('planTransformReady', showPlanControlMark);
          vm.viewer.on('requestShowPlan', applyData);
          $scope.applyTexture = false;
          $scope.showPlan = false;
          $scope.selectedElement = '';
          angular.element("#initial_loading_popup").show();
          vm.viewer.loadBim(data).then(function (bimModel) {
            vm.bimModel = bimModel;

            if ($scope.ngVp) {
              if ($scope.ngMatch) {
                vm.viewer.matchVPPlan($scope.ngVp.canvasElement, $scope.ngMatch);
              } else {
                vm.viewer.newVPPlan($scope.ngVp.canvasElement);
              }
            }

            angular.element("#initial_loading_popup").hide();
          })["catch"](function (err) {
            angular.element("#initial_loading_popup").hide();
            $log.error(err);
          });
        }

        function onObjectSelect() {
          hidePlanControlMark();
        }

        function applyData() {
          $timeout(function () {
            $scope.$apply();
          });
        }

        function showPlanControlMark(bimPlan, position) {
          vm.selectedVPPlan = bimPlan;
          var bimPlanControl = angular.element('#bim-plan-control');
          bimPlanControl.css('left', position.x + 'px');
          bimPlanControl.css('top', position.y + 'px');
          bimPlanControl.show();
        }

        function hidePlanControlMark() {
          vm.selectedVPPlan = undefined;
          angular.element('#bim-plan-control').hide();
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("drawingLayers", drawingLayers);

  function drawingLayers($timeout) {
    return {
      restrict: "E",
      templateUrl: "app/main/cgviewer/directives/vp-layers/layers.view.html",
      scope: {
        levels: "=",
        ngFactory: "="
      },
      link: function link($scope) {
        $scope.levels = [];
        var itemMap = {};

        function newNode(name) {
          return {
            id: Date.now().toString(),
            name: name,
            editable: false,
            expand: false,
            visible: true,
            items: []
          };
        }

        function newItem(id, name) {
          var level = $scope.levels[$scope.levels.length - 1];
          if (!level) return;
          var layer = level.items[level.items.length - 1];
          var item = {
            objectid: id,
            name: name,
            editable: false,
            visible: true
          };
          layer.items.push(item);
          itemMap[id] = {
            item: item,
            layer: layer
          };
        }

        function deleteItem(id) {
          var data = itemMap[id];

          if (data && data.layer) {
            data.layer.items.splice(data.layer.items.indexOf(data.item), 1); //itemMap.splice(itemMap.indexOf(data), 1);

            delete itemMap[id];
          }
        }

        $scope.newLevel = function () {
          var level = newNode('Level ' + $scope.levels.length);
          $scope.levels.push(level);
          $scope.newLayer();
        };

        $scope.newLayer = function () {
          var level = $scope.levels[$scope.levels.length - 1];
          var layer = newNode('Layer ' + level.items.length);
          level.items.push(layer);
        };

        $scope.toggleShowLevel = function (level) {
          var factory = $scope.ngFactory || {};
          level.visible = !level.visible;

          if (factory.setVisibility) {
            var items = [];

            for (var i in level.items) {
              var layer = level.items[i];

              for (var j in layer.items) {
                items.push(layer.items[j].objectid);
              }
            }

            factory.setVisibility(items, level.visible);
          }
        };

        $scope.toggleShowLayer = function (layer) {
          var factory = $scope.ngFactory || {};
          layer.visible = !layer.visible;

          if (factory.setVisibility) {
            var items = [];

            for (var j in layer.items) {
              items.push(layer.items[j].objectid);
            }

            factory.setVisibility(items, layer.visible);
          }
        };

        $scope.$on('object:added', function (event, args) {
          if (!args) return;
          var object = args;

          if (object.info) {
            newItem(object.info.id, object.info.name);
          }
        });
        $scope.$on('object:removed', function (event, args) {
          var object = args;

          if (object.info) {
            deleteItem(object.info.id);
          }
        });
        $scope.$on('level:default', function () {
          $timeout(function () {
            $scope.levels = [];
            $scope.newLevel();
          });
        });
        $scope.$on('level:load', function (event, args) {
          var levels = args;
          itemMap = {};
          angular.forEach(levels, function (level) {
            angular.forEach(level.items, function (layer) {
              angular.forEach(layer.items, function (item) {
                itemMap[item.objectid] = {
                  item: item,
                  layer: layer
                };
              });
            });
          });
          $timeout(function () {
            $scope.levels = levels;
          });
        });
        $scope.newLevel();
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("vpEquipmentMaterials", vpEquipmentMaterials);

  function vpEquipmentMaterials() {
    return {
      restrict: "E",
      templateUrl: "app/main/cgviewer/directives/vp-equipment-materials/vp-equipment-materials.view.html",
      scope: {
        ngColorEvents: "=",
        ngMaterials: "="
      },
      link: function link($scope) {
        $scope.visible = true;

        $scope.changeVisible = function () {
          $scope.visible = !$scope.visible;
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("vpCollision", vpCollision);

  function vpCollision($log, $uibModal, $timeout, apiFactory, Notification) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/vp-collision/vp-collision.view.html',
      scope: {
        isShow: '=',
        vpPage: '=',
        planId: '=',
        originalView: '=',
        collisionView: '='
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.current = 'collision';
      scope.activeCollision = undefined;
      scope.opacity1 = 100;
      scope.color1 = '#ffffff';
      scope.colorOpacity1 = 100;
      scope.collisions = [];
      init();

      scope.addCollision = function () {
        $uibModal.open({
          animation: true,
          component: 'openVpModal',
          windowClass: 'vp-open-model-modal'
        }).result.then(function (result) {
          if (scope.vpPage) {
            scope.vpPage.addCollision(result.plan);
          }

          createCollision(result.plan);
        });
      };

      scope.removeCollision = function (index) {
        var collision = scope.collisions[index];
        $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false
        }).result.then(function () {
          apiFactory.deleteCollisionVp(collision._id).then(function () {
            scope.collisions.splice(index, 1);

            if (collision === scope.activeCollision) {
              if (scope.vpPage) {
                scope.vpPage.removeCollision();
              }

              scope.activeCollision = undefined;
            }

            Notification.success("Collision is deleted successfully.");
          })["catch"](function (err) {
            $log.error(err);
            Notification.error("Failed to delete");
          });
        });
      };

      scope.selectCollision = function (collision) {
        if (scope.activeCollision === collision) {
          scope.activeCollision = undefined;

          if (scope.vpPage) {
            scope.vpPage.removeCollision();
          }
        } else {
          if (scope.activeCollision) {
            if (scope.vpPage) {
              scope.vpPage.removeCollision();
            }
          }

          scope.activeCollision = collision;
          loadCollision(collision);
        }
      };

      scope.selectItem = function (layer, collision) {
        if (layer === 'original') {
          if (scope.originalView) {
            scope.originalView.container.style.zIndex = 1;
          }

          if (scope.collisionView) {
            scope.collisionView.container.style.zIndex = 0;
          }
        } else {
          if (scope.activeCollision !== collision) return;

          if (scope.originalView) {
            scope.originalView.container.style.zIndex = 0;
          }

          if (scope.collisionView) {
            scope.collisionView.container.style.zIndex = 1;
          }
        }

        scope.current = layer;

        if (scope.vpPage) {
          scope.vpPage.selectCollision(layer);
        }
      };

      scope.changeOpacity = function (viewer, opacity) {
        viewer.setOpacity(opacity / 100);
      };

      scope.changeColor1 = function () {
        scope.originalView.setColorFilter(scope.color1, scope.colorOpacity1 / 100);
      };

      scope.changeColor = function (collision) {
        scope.collisionView.setColorFilter(collision.color, collision.colorOpacity / 100);
      };

      function init() {
        if (!scope.planId) return;
        apiFactory.listCollisionVp(scope.planId).then(function (resp) {
          scope.collisions = resp.data.list || [];
          scope.collisions.forEach(function (collision) {
            collision.name = collision.plan2.assetObj.title;
            collision.opacity = 100;
            collision.color = '#ffffff';
            collision.colorOpacity = 100;
          });
        })["catch"](function (err) {
          $log.error(err);
        });
      }

      function createCollision(plan) {
        apiFactory.createCollisionVp({
          plan1: scope.planId,
          plan2: plan._id
        }).then(function (resp) {
          var collision = resp.data.data;
          collision.plan = plan;
          collision.name = plan.assetObj.title;
          collision.opacity = 100;
          collision.color = '#ffffff';
          collision.colorOpacity = 100;
          scope.collisions.push(collision);
          scope.activeCollision = scope.collisions[scope.collisions.length - 1];
          $timeout(function () {
            return scope.$apply();
          });
        })["catch"](function (err) {
          $log.error(err);
          Notification.error("Failed to save!");
        });
      }

      function loadCollision(collision) {
        if (collision.plan) {
          if (scope.vpPage) {
            scope.vpPage.addCollision(collision.plan);
          }
        } else {
          showLoading();
          apiFactory.getRoofPlan(collision.plan2._id).then(function (resp) {
            if (scope.vpPage) {
              scope.vpPage.addCollision(resp.data.data);
            }

            hideLoading();
            collision.plan = resp.data.data;
          })["catch"](function (err) {
            $log.error(err);
            hideLoading();
          });
        }
      }

      function showLoading() {
        angular.element("#vp_initial_loading_popup").show();
      }

      function hideLoading() {
        angular.element("#vp_initial_loading_popup").hide();
      }
    }
  }
})();


"use strict";

(function () {
  angular.module('app').directive("toolbox", toolbox);

  function toolbox() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/main/cgviewer/directives/toolbox/toolbox.view.html',
      scope: {
        data: "=",
        onSelected: "="
      },
      link: function link($scope) {
        $scope.activeItem = undefined;
        $scope.expandedItem = undefined;

        $scope.onButtonClick = function (item, parent) {
          if (item.submenu) {
            if ($scope.expandedItem) {
              $scope.expandedItem = $scope.expandedItem === item ? undefined : item;
            } else {
              $scope.expandedItem = item;
            }

            $scope.activeItem = undefined;
          } else {
            $scope.expandedItem = undefined;

            if (parent) {
              parent.icon = item.icon;
              $scope.activeItem = parent;
            } else {
              $scope.activeItem = item;
            }

            if ($scope.onSelected) {
              $scope.onSelected(item.id);
            }
          }
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("textProperties", textProperties);

  function textProperties(utils) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/text-properties/text-properties.view.html',
      scope: {
        ngProperties: "=",
        ngTextChange: "=",
        ngChangeFillColor: "=",
        ngChangeStrokeColor: "="
      },
      link: function link(scope) {
        scope.colorOptions = {
          swatch: true,
          format: "hex",
          "case": "lower",
          pos: 'bottom right'
        };
        scope.webSafeFontFamilies = [{
          label: "Arial",
          value: "Arial"
        }, {
          label: "Calibri",
          value: "Calibri"
        }, {
          label: "Helvetica",
          value: "Helvetica"
        }, {
          label: "Times New Roman",
          value: "Times New Roman"
        }, {
          label: "Times",
          value: "Times"
        }, {
          label: "Courier New",
          value: "Courier New"
        }, {
          label: "Courier",
          value: "Courier"
        }, {
          label: "Verdana",
          value: "Verdana"
        }, {
          label: "Georgia",
          value: "Georgia"
        }, {
          label: "Palatino",
          value: "Palatino"
        }, {
          label: "Garamond",
          value: "Garamond"
        }, {
          label: "Bookman",
          value: "Bookman"
        }, {
          label: "Comic Sans MS",
          value: "Comic Sans MS"
        }, {
          label: "Trebuchet MS",
          value: "Trebuchet MS"
        }, {
          label: "Arial Black",
          value: "Arial Black"
        }, {
          label: "Impact",
          value: "Impact"
        }];
        scope.webFontStyles = [{
          label: 'Regular',
          value: 'regular'
        }, {
          label: 'Bold',
          value: 'bold'
        }, {
          label: 'Italic',
          value: 'italic'
        }];
        scope.webFontSizes = [{
          label: "8",
          value: 8
        }, {
          label: "9",
          value: 9
        }, {
          label: "10",
          value: 10
        }, {
          label: "11",
          value: 11
        }, {
          label: "12",
          value: 12
        }, {
          label: "13",
          value: 13
        }, {
          label: "14",
          value: 14
        }, {
          label: "15",
          value: 15
        }, {
          label: "16",
          value: 16
        }, {
          label: "17",
          value: 17
        }, {
          label: "18",
          value: 18
        }, {
          label: "19",
          value: 19
        }, {
          label: "20",
          value: 20
        }, {
          label: "21",
          value: 21
        }, {
          label: "22",
          value: 22
        }, {
          label: "23",
          value: 23
        }, {
          label: "24",
          value: 24
        }, {
          label: "25",
          value: 25
        }, {
          label: "26",
          value: 26
        }, {
          label: "27",
          value: 27
        }, {
          label: "28",
          value: 28
        }, {
          label: "29",
          value: 29
        }, {
          label: "30",
          value: 30
        }];
        scope.textHeights = [{
          label: 'Auto',
          value: 'auto'
        }];
        scope.charSpaces = [{
          label: '5',
          value: 5
        }, {
          label: '6',
          value: 6
        }, {
          label: '7',
          value: 7
        }, {
          label: '8',
          value: 8
        }, {
          label: '9',
          value: 9
        }, {
          label: '10',
          value: 10
        }];
        scope.lineSpaces = [{
          label: '10',
          value: 10
        }, {
          label: '15',
          value: 15
        }, {
          label: '20',
          value: 20
        }];
        scope.fillColor = '#000000';
        scope.fillOpacity = 100;
        scope.strokeColor = '#000000';
        scope.strokeOpacity = 100;
        initColors();
        scope.$watch('ngProperties', function () {
          return initColors();
        });

        scope.changeFillColor = function () {
          var color = scope.fillColor;
          var rgba = utils.ha2rgba(color, scope.fillOpacity / 100);

          if (scope.ngProperties) {
            scope.ngProperties.fillColor = rgba;
          }

          if (scope.ngChangeFillColor) {
            scope.ngChangeFillColor(rgba);
          }
        };

        scope.changeStrokeColor = function (color) {
          if (!color) color = scope.strokeColor;
          var rgba = utils.ha2rgba(color, scope.strokeOpacity / 100);

          if (scope.ngProperties) {
            scope.ngProperties.strokeColor = rgba;
          }

          if (scope.ngChangeStrokeColor) {
            scope.ngChangeStrokeColor(rgba);
          }
        };

        function initColors() {
          if (scope.ngProperties) {
            if (scope.ngProperties.fillColor) {
              var ha = utils.rgba2ha(scope.ngProperties.fillColor);
              scope.fillColor = ha.color;
              scope.fillOpacity = Math.ceil(ha.opacity * 100);
            }

            if (scope.ngProperties.strokeColor) {
              var _ha = utils.rgba2ha(scope.ngProperties.strokeColor);

              scope.strokeColor = _ha.color;
              scope.strokeOpacity = Math.ceil(_ha.opacity * 100);
            }
          }
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('sideMenuRegistrationCard', sideMenuRegistrationCard);

  function sideMenuRegistrationCard($uibModal, $log, $timeout, apiFactory, globals, utils) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/cgviewer/directives/side-menu-registration-card/side-menu-registration-card.view.html',
      scope: {
        ngModel: '=',
        customHeight: '@'
      },
      link: function link($scope) {
        var userStore = globals.userStore;
        $scope.isExpanded = false;
        $scope.isDetails = true;
        $scope.messages = [];
        $scope.user = userStore.get();

        $scope.registrationImageByType = function (file) {
          $uibModal.open({
            animation: true,
            component: 'imageViewerModal',
            backdrop: 'static',
            keyboard: true,
            windowClass: 'file-viewer-modal',
            windowTopClass: 'file-viewer-modal-wrapper',
            resolve: {
              imageURL: function imageURL() {
                return file.secure_url;
              }
            }
          });
        };

        $scope.toggleExpand = function () {
          $scope.isExpanded = !$scope.isExpanded;
        };

        $scope.switchTab = function (isDetails) {
          $scope.isDetails = isDetails;
        };

        $scope.registrationStatusClass = function () {
          switch ($scope.ngModel.status) {
            case 'Open':
              return ['status-ellipse', 'open'];

            case 'On Hold':
              return ['status-ellipse', 'on-hold'];

            case 'Resolved':
              return ['status-ellipse', 'resolved'];

            case 'Completed':
              return ['status-ellipse', 'completed'];

            default:
              return ['status-ellipse', 'open'];
          }
        };

        $scope.getFileIcon = function (name) {
          return utils.getFileIconFromName(name);
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('sideMenuIssueCard', sideMenuIssueCard);

  function sideMenuIssueCard($uibModal, $log, $timeout, apiFactory, globals, utils) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/cgviewer/directives/side-menu-issue-card/side-menu-issue-card.view.html',
      scope: {
        ngModel: '=',
        customHeight: '@'
      },
      link: function link($scope) {
        var userStore = globals.userStore;
        $scope.isExpanded = false;
        $scope.isDetails = true;
        $scope.messages = [];
        $scope.user = userStore.get();

        $scope.issueImageByType = function (file) {
          $uibModal.open({
            animation: true,
            component: 'imageViewerModal',
            backdrop: 'static',
            keyboard: true,
            windowClass: 'file-viewer-modal',
            windowTopClass: 'file-viewer-modal-wrapper',
            resolve: {
              imageURL: function imageURL() {
                return file.secure_url;
              }
            }
          });
        };

        $scope.toggleExpand = function () {
          $scope.isExpanded = !$scope.isExpanded;
        };

        $scope.switchTab = function (isDetails) {
          $scope.isDetails = isDetails;
        };

        $scope.issueStatusClass = function () {
          switch ($scope.ngModel.status) {
            case 'Open':
              return ['status-ellipse', 'open'];

            case 'On Hold':
              return ['status-ellipse', 'on-hold'];

            case 'Resolved':
              return ['status-ellipse', 'resolved'];

            case 'Completed':
              return ['status-ellipse', 'completed'];

            default:
              return ['status-ellipse', 'open'];
          }
        };

        $scope.getFileIcon = function (name) {
          return utils.getFileIconFromName(name);
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('sideMenu', sideMenu);

  function sideMenu() {
    return {
      restrict: 'A',
      scope: {},
      link: function link() {
        angular.element('#menuToggle').click(function (e) {
          var $parent = angular.element(this).parent('nav');
          $parent.toggleClass("open");
          e.preventDefault();
        });
        angular.element('#menuToggleBottom').click(function (e) {
          var $parent = angular.element(this).parent('nav');
          $parent.toggleClass("open");
          e.preventDefault();
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('registrationMenu', registrationMenu);

  function registrationMenu(apiFactory, $log, Notification, utils) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/cgviewer/directives/registration-menu/registration-menu.view.html',
      scope: {
        isVp: '=',
        isShow: '=',
        modelId: '='
      },
      link: function link($scope) {
        $scope.levelSearchText = "";
        $scope.issueSearchText = "";
        $scope.registrations = [];

        function getRegistrationsByModelId() {
          $scope.registrations = [];
          $scope.loading = true;
          apiFactory.getRegistrationsByModelId($scope.modelId).then(function (res) {
            $scope.loading = false;
            $scope.registrations = res.data.list;
          })["catch"](function (err) {
            $scope.loading = false;
            $scope.registrations = [];
            Notification.error(err.data.message || 'Failed to fetch issues.');
          });
        }

        $scope.$watch('modelId', function () {
          if (!utils.isEmpty($scope.modelId)) {
            getRegistrationsByModelId();
          }
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("objectDropdown", objectDropdown);

  function objectDropdown() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/main/cgviewer/directives/object-dropdown/object-dropdown.view.html',
      scope: {
        ngModel: "=",
        options: "=",
        ngChange: "&",
        placeholder: "@",
        labelField: "@",
        valueField: "@",
        icon: "@",
        upward: "="
      },
      link: function link(scope) {
        scope.isOpen = false;

        if (scope.options) {
          scope.optionsTemp = scope.options;
        }

        scope.selectedLabel = scope.placeholder || (scope.options && scope.options[0] ? scope.options[0].label : '');

        if (scope.ngModel && scope.options) {
          if (scope.ngModel != {}) {
            var selectedItem = scope.options.find(function (item) {
              return item[scope.valueField] == scope.ngModel;
            });

            if (selectedItem) {
              scope.selectedLabel = selectedItem[scope.labelField];
            }
          }
        }

        scope.toggleList = function () {
          scope.isOpen = !scope.isOpen;
        };

        scope.$watch('ngModel', function () {
          if (scope.options && scope.ngModel) {
            var _selectedItem = scope.options.find(function (item) {
              return item[scope.valueField] == scope.ngModel;
            });

            if (_selectedItem) {
              scope.selectedLabel = _selectedItem[scope.labelField];
            }
          } else {
            scope.selectedLabel = scope.placeholder;
          }

          scope.ngChange();
        });

        scope.selectItem = function (item) {
          if (scope.ngModel != item[scope.valueField]) {
            scope.ngModel = item[scope.valueField];
            scope.selectedLabel = item[scope.labelField];
          }

          scope.isOpen = false;
        };

        scope.closeList = function () {
          scope.isOpen = false;
          scope.options = scope.optionsTemp;
        };

        scope.addItem = function () {
          scope.addItemEvent();
        };

        scope.searchFunction = function (searchText) {
          scope.options = scope.optionsTemp;
          var output = [];

          if (searchText.length >= 0) {
            angular.forEach(scope.options, function (item) {
              if (item[scope.labelField].toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                output.push(item);
              }
            });
          }

          scope.options = output;
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("drawingMaterials", drawingMaterials);

  function drawingMaterials(utils) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/materials/materials.view.html',
      scope: {
        ngSelectcolor: "=",
        ngSelecttexture: "=",
        ngFliptexture: "=",
        ngChangetextureinput: "=",
        cpColor: "="
      },
      link: function link($scope) {
        $scope.showPreview = true;
        $scope.colors = ["#ff8b00", "#00aace", "#4584e0", "#464646", "#eece4e", "#707070", "#2468ea", "#ffae47", "#86a5ab", "#4a5d6d", "#727171", "#341D1D"];
        $scope.textures = ["/assets/images/cgviewer/textures/texture-01.jpg", "/assets/images/cgviewer/textures/texture-02.jpg", "/assets/images/cgviewer/textures/texture-03.jpg", "/assets/images/cgviewer/textures/texture-04.jpg", "/assets/images/cgviewer/textures/texture-05.jpg", "/assets/images/cgviewer/textures/texture-06.jpg", "/assets/images/cgviewer/textures/texture-07.jpg", "/assets/images/cgviewer/textures/texture-08.jpg", "/assets/images/cgviewer/textures/texture-09.jpg", "/assets/images/cgviewer/textures/texture-10.jpg", "/assets/images/cgviewer/textures/texture-11.jpg", "/assets/images/cgviewer/textures/texture-12.jpg"];
        $scope.newColor = '#ff8b00';
        $scope.newOpacity = 100;
        $scope.material = undefined; // selected material

        var textureInput = angular.element('#material_texture_add_input')[0];
        textureInput.addEventListener('change', changeTextureInput);

        $scope.selectColor = function (color) {
          $scope.material = color;

          if ($scope.ngSelectcolor) {
            $scope.ngSelectcolor(color);
          }
        };

        $scope.selectTexture = function (texture) {
          $scope.material = texture;

          if ($scope.ngSelecttexture) {
            $scope.ngSelecttexture(texture);
          }
        };

        $scope.requestColorAdd = function () {
          var newColor = utils.ha2rgba($scope.newColor, $scope.newOpacity / 100);
          $scope.colors.push(newColor);
        };

        $scope.requestTextureAdd = function () {
          textureInput.click();
        };

        $scope.isLight = function (color) {
          var r, g, b, a, hsp;

          if (color.match(/^rgb/)) {
            color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
            r = color[1];
            g = color[2];
            b = color[3];
            a = color[4];
            if (angular.isDefined(a) && a < 0.4) return true;
          } else {
            color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
            r = color >> 16;
            g = color >> 8 & 255;
            b = color & 255;
          }

          hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
          return hsp > 200;
        };

        function changeTextureInput(event) {
          var input = event.srcElement;

          if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
              $scope.textures.push(e.target.result);
            };

            reader.readAsDataURL(input.files[0]);
          }
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('materialTab', materialTab);

  function materialTab() {
    return {
      restrict: 'A',
      scope: {},
      link: function link($scope) {
        angular.element('.material-tab-header').each(function () {
          var $active;
          var $content;
          var $links = angular.element(this).find('a');
          $active = angular.element($links[0]);
          $active.addClass('active');
          $content = angular.element($active[0].hash);
          $links.not($active).each(function () {
            angular.element(this.hash).hide();
          });
          angular.element(this).on('click', 'a', function (e) {
            $active = angular.element(this);
            $content = angular.element(this.hash);
            $active.addClass('active');
            $content.show();
            $links.not($active).each(function () {
              angular.element(this).removeClass('active');
              angular.element(this.hash).hide();
            });
            e.preventDefault();
          });
        });

        $scope.selectTab = function (container, tab) {
          var $links = angular.element(container).find('a');
          var $active = angular.element(tab);
          var $content = angular.element($active[0].hash);
          $active.addClass('active');
          $content.show();
          $links.not($active).each(function () {
            angular.element(this).removeClass('active');
            angular.element(this.hash).hide();
          });
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("lineProperties", lineProperties);

  function lineProperties(utils) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/line-properties/line-properties.view.html',
      scope: {
        ngProperties: "=",
        ngInputMethod: "=",
        ngChangeDashType: "=",
        ngChangeDashSpace: "=",
        ngChangeThickness: "=",
        ngChangeStrokeColor: "="
      },
      link: function link(scope) {
        scope.dashTypes = [{
          label: "───────",
          value: 1
        }, {
          label: "------------",
          value: 2
        }, {
          label: "||||||||||||",
          value: 3
        } // "////////////",
        // "////   ////",
        // "←−−−−−−→",
        // "|∕\\/\\/\\/\\/\\|"
        ];
        scope.dashDots = [{
          label: "1,3",
          value: [1, 3]
        }, {
          label: "2,3",
          value: [2, 3]
        }, {
          label: "3,3",
          value: [3, 3]
        }];
        var euLists = [{
          label: '0,1',
          value: 0.1
        }, {
          label: '0,2',
          value: 0.2
        }, {
          label: '0,3',
          value: 0.3
        }, {
          label: '0,4',
          value: 0.4
        }, {
          label: '0,5',
          value: 0.5
        }, {
          label: '0,6',
          value: 0.6
        }, {
          label: '0,7',
          value: 0.7
        }, {
          label: '0,8',
          value: 0.8
        }, {
          label: '0,9',
          value: 0.9
        }, {
          label: '1',
          value: 1
        }, {
          label: '2',
          value: 2
        }, {
          label: '3',
          value: 3
        }, {
          label: '4',
          value: 4
        }, {
          label: '5',
          value: 5
        }, {
          label: '6',
          value: 6
        }, {
          label: '7',
          value: 7
        }, {
          label: '8',
          value: 8
        }, {
          label: '9',
          value: 9
        }, {
          label: '10',
          value: 10
        }, {
          label: '11',
          value: 11
        }, {
          label: '12',
          value: 12
        }, {
          label: '13',
          value: 13
        }, {
          label: '14',
          value: 14
        }, {
          label: '15',
          value: 15
        }, {
          label: '16',
          value: 16
        }, {
          label: '17',
          value: 17
        }, {
          label: '18',
          value: 18
        }, {
          label: '19',
          value: 19
        }, {
          label: '20',
          value: 20
        }, {
          label: '21',
          value: 21
        }, {
          label: '22',
          value: 22
        }, {
          label: '23',
          value: 23
        }, {
          label: '24',
          value: 24
        }, {
          label: '25',
          value: 25
        }, {
          label: '26',
          value: 26
        }, {
          label: '27',
          value: 27
        }, {
          label: '28',
          value: 28
        }, {
          label: '29',
          value: 29
        }, {
          label: '30',
          value: 30
        }];
        var amLists = [{
          label: '0.1',
          value: 0.1
        }, {
          label: '0.2',
          value: 0.2
        }, {
          label: '0.3',
          value: 0.3
        }, {
          label: '0.4',
          value: 0.4
        }, {
          label: '0.5',
          value: 0.5
        }, {
          label: '0.6',
          value: 0.6
        }, {
          label: '0.7',
          value: 0.7
        }, {
          label: '0.8',
          value: 0.8
        }, {
          label: '0.9',
          value: 0.9
        }, {
          label: '1',
          value: 1
        }, {
          label: '2',
          value: 2
        }, {
          label: '3',
          value: 3
        }, {
          label: '4',
          value: 4
        }, {
          label: '5',
          value: 5
        }, {
          label: '6',
          value: 6
        }, {
          label: '7',
          value: 7
        }, {
          label: '8',
          value: 8
        }, {
          label: '9',
          value: 9
        }, {
          label: '10',
          value: 10
        }, {
          label: '11',
          value: 11
        }, {
          label: '12',
          value: 12
        }, {
          label: '13',
          value: 13
        }, {
          label: '14',
          value: 14
        }, {
          label: '15',
          value: 15
        }, {
          label: '16',
          value: 16
        }, {
          label: '17',
          value: 17
        }, {
          label: '18',
          value: 18
        }, {
          label: '19',
          value: 19
        }, {
          label: '20',
          value: 20
        }, {
          label: '21',
          value: 21
        }, {
          label: '22',
          value: 22
        }, {
          label: '23',
          value: 23
        }, {
          label: '24',
          value: 24
        }, {
          label: '25',
          value: 25
        }, {
          label: '26',
          value: 26
        }, {
          label: '27',
          value: 27
        }, {
          label: '28',
          value: 28
        }, {
          label: '29',
          value: 29
        }, {
          label: '30',
          value: 30
        }];

        if (scope.ngInputMethod && scope.ngInputMethod === 'European et al.') {
          scope.strokeWidths = euLists;
        } else {
          scope.strokeWidths = amLists;
        }

        scope.strokeColor = '#000000';
        scope.strokeOpacity = 100;
        initStrokeColor();
        scope.$watch('ngProperties', function () {
          return initStrokeColor();
        });

        scope.changeDashType = function () {
          if (scope.ngChangeDashType) {
            scope.ngChangeDashType(scope.ngProperties.dashType);
          }

          if (scope.ngProperties && scope.ngProperties.dashType !== 1) {
            if (!scope.ngProperties.strokeDashArray || scope.ngProperties.strokeDashArray.length === 0) {
              scope.ngProperties.strokeDashArray = scope.dashDots[0].value;
              scope.changeDashSpace();
            }
          }
        };

        scope.changeDashSpace = function () {
          if (scope.ngChangeDashSpace) {
            scope.ngChangeDashSpace(scope.ngProperties.strokeDashArray);
          }
        };

        scope.changeThickness = function () {
          if (scope.ngChangeThickness) {
            scope.ngChangeThickness(scope.ngProperties.strokeWidth);
          }
        };

        scope.changeStrokeColor = function () {
          var color = scope.strokeColor;
          var rgba = utils.ha2rgba(color, scope.strokeOpacity / 100);

          if (scope.ngProperties) {
            scope.ngProperties.strokeColor = rgba;
          }

          if (scope.ngChangeStrokeColor) {
            scope.ngChangeStrokeColor(rgba);
          }
        };

        function initStrokeColor() {
          if (scope.ngProperties && scope.ngProperties.strokeColor) {
            var ha = utils.rgba2ha(scope.ngProperties.strokeColor);
            scope.strokeColor = ha.color;
            scope.strokeOpacity = Math.ceil(ha.opacity * 100);
          }
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('issueMenu', issueMenu);

  function issueMenu(apiFactory, $log, Notification, utils) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/cgviewer/directives/issue-menu/issue-menu.view.html',
      scope: {
        isVp: '=',
        isShow: '=',
        modelId: '='
      },
      link: function link($scope) {
        $scope.levelSearchText = "";
        $scope.issueSearchText = "";
        $scope.issues = [];

        function getIssuesBy3DModelId() {
          $scope.issues = [];
          $scope.loading = true;
          apiFactory.getIssuesBy3DModelId($scope.modelId).then(function (res) {
            $scope.loading = false;
            $scope.issues = res.data.list;
          })["catch"](function (err) {
            $scope.loading = false;
            $scope.issues = [];
            Notification.error(err.data.message || 'Failed to fetch issues.');
          });
        }

        $scope.$watch('modelId', function () {
          if (!utils.isEmpty($scope.modelId)) {
            getIssuesBy3DModelId();
          }
        });
      }
    };
  }
})();


"use strict";

var THREE;

(function () {
  angular.module('app').directive("gisWrapper", gisWrapper);

  function gisWrapper(GIS, $document, apiFactory, $log) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/gis-wrapper/gis-wrapper.view.html',
      scope: {
        modelInfo: "=",
        injectGis: "=",
        callBack: "="
      },
      link: function link($scope) {
        $scope.mapViewMode = "street";
        $scope.isShowModelInfoOnGis = false;
        $scope.showControl = false;
        $scope.isShowModel = true;
        $scope.location = {
          coordinates: [0, 0]
        };
        $scope.gisView = GIS.mainViewer();
        $scope.gisViewer = $scope.gisView.getViewerInstance();
        $scope.gismesh = null;
        $scope.customLayer = undefined;
        $scope.modelTransform = null;
        $scope.modelOrigin = [0, 0];

        $scope.injectGis = function () {
          if ($scope.modelInfo) {
            $scope.bimModel = $scope.modelInfo.bimModel;
            $scope.location = $scope.modelInfo.location;
            $scope.gisTransformData = $scope.modelInfo.gisTransformData;
          }

          $scope.init();
        };

        $scope.init = function () {
          $scope.gisViewer.jumpTo({
            center: [$scope.location.coordinates[1], $scope.location.coordinates[0]]
          });

          if (!$scope.gisViewer.getLayer('3d-model')) {
            $scope.gismesh = $scope.bimModel && $scope.bimModel.mesh;
            if ($scope.gismesh) createEdge($scope.gismesh);
            apiFactory.getHeightinLonLatFromMapBox($scope.location.coordinates[1], $scope.location.coordinates[0], 'pk.eyJ1IjoiYnVudGVuZ3dhbmciLCJhIjoiY2trcG1rbTVlMDFpaDJvazU2cjVnMDJ1NCJ9.e1PPa2H_UxOU2nO-v18A8A').then(function (resp) {
              // Get all the returned features
              var allFeatures = resp.data.features; // $log.info('allFeatures', allFeatures);
              // Create an empty array to add elevation data to

              var elevations = []; // For each returned feature, add elevation data to the elevations array

              for (var i = 0; i < allFeatures.length; i++) {
                elevations.push(allFeatures[i].properties.ele);
              } // $log.info('elevations', elevations);
              // In the elevations array, find the largest value


              var highestElevation = Math.max.apply(Math, elevations); // $log.info('highestElevation', highestElevation);

              $scope.altitude = highestElevation;
              setUpModelToGIS([$scope.location.coordinates[1], $scope.location.coordinates[0]], $scope.gismesh, [$scope.gisTransformData.move.moveY, $scope.gisTransformData.move.moveX], $scope.gisTransformData.rotate, $scope.gisTransformData.scale);
            })["catch"](function (err) {
              $log.error(err);
            });
          } else {
            $scope.customLayer.scene.add($scope.gismesh);
          }
        };

        $scope.gisViewer.on('style.load', function () {
          $scope.gisViewer.addSource('mapbox-dem', {
            'type': 'raster-dem',
            'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
            'tileSize': 512,
            'maxzoom': 14
          }); // add the DEM source as a terrain layer with exaggerated height

          $scope.gisViewer.setTerrain({
            'source': 'mapbox-dem',
            'exaggeration': 1.5
          }); //add a sky layer that will show when the map is highly pitched

          $scope.gisViewer.addLayer({
            'id': 'sky',
            'type': 'sky',
            'paint': {
              'sky-type': 'atmosphere',
              'sky-atmosphere-sun': [0.0, 0.0],
              'sky-atmosphere-sun-intensity': 15
            }
          });

          if (!$scope.gisViewer.getLayer('3d-model') && $scope.bimModel && $scope.bimModel.mesh) {
            setUpModelToGIS([$scope.location.coordinates[1], $scope.location.coordinates[0]], $scope.gismesh);
          }

          var stylename = $scope.gisViewer.getStyle().name;

          if (stylename != "Mapbox Light") {
            return;
          } // Insert the layer beneath any symbol layer.


          var layers = $scope.gisViewer.getStyle().layers;
          var labelLayerId;

          for (var i = 0; i < layers.length; i++) {
            if (layers[i].type === 'symbol' && layers[i].layout['text-field']) {
              labelLayerId = layers[i].id;
              break;
            }
          }

          $scope.gisViewer.addLayer({
            'id': '3d-buildings',
            'source': 'composite',
            'source-layer': 'building',
            'filter': ['==', 'extrude', 'true'],
            'type': 'fill-extrusion',
            'minzoom': 15,
            'paint': {
              'fill-extrusion-color': '#aaa',
              // use an 'interpolate' expression to add a smooth transition effect to the
              // buildings as the user zooms in
              'fill-extrusion-height': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'height']],
              'fill-extrusion-base': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'min_height']],
              'fill-extrusion-opacity': 0.6
            }
          }, labelLayerId);
        }); //--------------------------------------------

        $scope.setSattleteMap = function () {
          $scope.mapViewMode = "satellite";
          $scope.gisView.setSattleteMap();
        };

        $scope.setStreetMap = function () {
          $scope.mapViewMode = "street";
          $scope.gisView.setStreetMap();
        };

        $scope.setExtrusionMap = function () {
          $scope.mapViewMode = "extrusion";
          $scope.gisView.setExtrusionMap();
        };

        $scope.toggleBuilding = function () {
          $scope.showControl = !$scope.showControl;
        };

        $scope.showHideModel = function () {
          $scope.isShowModel = !$scope.isShowModel;

          if ($scope.isShowModel) {
            $scope.gisViewer.setLayoutProperty('3d-model', 'visibility', 'visible');
          } else {
            $scope.gisViewer.setLayoutProperty('3d-model', 'visibility', 'none');
          }
        };

        $scope.showModelInfoDialog = function () {
          $scope.isShowModelInfoOnGis = !$scope.isShowModelInfoOnGis;
        };

        $scope.saveModelInfoInMap = function () {
          $scope.save();
        };

        $scope.backtoHome = function () {
          $scope.customLayer.scene.remove($scope.gismesh);

          if ($scope.callBack) {
            $scope.callBack('home');
          }
        };

        $scope.save = function () {
          var modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat($scope.modelOrigin, 0);
          var gisTransformData = {
            scale: $scope.modelTransform.scale / modelAsMercatorCoordinate.meterInMercatorCoordinateUnits(),
            rotate: $scope.modelTransform.rotateZ,
            move: {
              moveX: $scope.modelOrigin[1] - $scope.location.coordinates[0],
              moveY: $scope.modelOrigin[0] - $scope.location.coordinates[1]
            }
          };

          if ($scope.callBack) {
            $scope.callBack('save', gisTransformData);
          }
        };

        function setUpModelToGIS(lonlat, mesh, deltaLonLat, rotate, scale) {
          if (deltaLonLat) {
            $scope.modelOrigin = [lonlat[0] + deltaLonLat[0], lonlat[1] + deltaLonLat[1]];
            var modelRotate = [0, 0, rotate];
            var modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat($scope.modelOrigin, Math.floor(($scope.altitude * 1.5 + 10) / 10) * 10); // transformation parameters to position, rotate and scale the 3D model onto the map

            $scope.modelTransform = {
              translateX: modelAsMercatorCoordinate.x,
              translateY: modelAsMercatorCoordinate.y,
              translateZ: modelAsMercatorCoordinate.z,
              rotateX: modelRotate[0],
              rotateY: modelRotate[1],
              rotateZ: modelRotate[2],

              /* Since our 3D model is in real world meters, a scale transform needs to be
              * applied since the CustomLayerInterface expects units in MercatorCoordinates.
              */
              scale: modelAsMercatorCoordinate.meterInMercatorCoordinateUnits() * scale
            };
          } // configuration of the custom layer for a 3D model per the CustomLayerInterface


          $scope.customLayer = {
            id: '3d-model',
            type: 'custom',
            renderingMode: '3d',
            layout: {
              // make layer visible by default
              'visibility': 'visible'
            },
            onAdd: function onAdd(map, gl) {
              //this.camera = new THREE.Camera();
              this.scene = new THREE.Scene();
              this.width = map.getCanvas().width;
              this.height = map.getCanvas().height;
              this.camera = new THREE.PerspectiveCamera(45, this.width / this.height, 2, 1500);
              var ambLight = new THREE.AmbientLight(0x666666);
              this.scene.add(ambLight);
              var directionalLight = new THREE.DirectionalLight(0xffffff);
              directionalLight.position.set(-0.5, -1, 1);
              this.scene.add(directionalLight);
              var directionalLight2 = new THREE.DirectionalLight(0xffffff);
              directionalLight2.position.set(0.5, 1, 1);
              this.scene.add(directionalLight2);
              this.scene.add(mesh);
              this.map = map;
              this.createRenderer(gl);
            },
            createRenderer: function createRenderer(gl) {
              if (THREE.WEBGL.isWebGL2Available()) {
                var canvas = this.map.getCanvas();
                var context = gl;
                this.renderer = new THREE.WebGLRenderer({
                  canvas: canvas,
                  context: context
                });
              } else {
                this.renderer = new THREE.WebGLRenderer({
                  alpha: true,
                  antialias: true,
                  preserveDrawingBuffer: true
                });
              }

              this.renderer.autoClear = false;
            },
            render: function render(gl, matrix) {
              var rotationX = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(1, 0, 0), $scope.modelTransform.rotateX);
              var rotationY = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(0, 1, 0), $scope.modelTransform.rotateY);
              var rotationZ = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(0, 0, 1), $scope.modelTransform.rotateZ);
              var m = new THREE.Matrix4().fromArray(matrix);
              var l = new THREE.Matrix4().makeTranslation($scope.modelTransform.translateX, $scope.modelTransform.translateY, $scope.modelTransform.translateZ).scale(new THREE.Vector3($scope.modelTransform.scale, -$scope.modelTransform.scale, $scope.modelTransform.scale)).multiply(rotationX).multiply(rotationY).multiply(rotationZ);
              this.camera.projectionMatrix = m.multiply(l);
              this.renderer.state.reset();
              this.renderer.render(this.scene, this.camera);
              this.map.triggerRepaint();
            }
          };

          if (!$scope.gisViewer.getLayer('3d-model')) {
            $scope.gisViewer.addLayer($scope.customLayer, 'waterway-label'); //$scope.gisViewer.removeLayer('3d-model');
          }
        }

        function createEdge(group) {
          var edgeMaterial = new THREE.LineBasicMaterial({
            color: new THREE.Color(0, 0, 0),
            transparent: true,
            opacity: 0.7
          });
          group.children.forEach(function (mesh) {
            if (!angular.isArray(mesh.material)) edgeMaterial.clippingPlanes = mesh.material.clippingPlanes;else edgeMaterial.clippingPlanes = mesh.material[0].clippingPlanes;
            var edges = new THREE.LineSegments(new THREE.EdgesGeometry(mesh.geometry), edgeMaterial);
            edges.name = 'edge';
            mesh.userData.edges = edges;
            mesh.add(edges);
          });
        } //-----------event handler--------------


        $document[0].getElementById('button-rotate-left').addEventListener("mousedown", function () {
          $scope.modelTransform.rotateZ = $scope.modelTransform.rotateZ - Math.PI / 18;
          $scope.gisViewer.triggerRepaint();
        });
        $document[0].getElementById('button-rotate-right').addEventListener("mousedown", function () {
          $scope.modelTransform.rotateZ = $scope.modelTransform.rotateZ + Math.PI / 18;
          $scope.gisViewer.triggerRepaint();
        });
        $document[0].getElementById('button-scale-positive').addEventListener("mousedown", function () {
          $scope.modelTransform.scale = 1.05 * $scope.modelTransform.scale;
          $scope.gisViewer.triggerRepaint();
        });
        $document[0].getElementById('button-scale-negative').addEventListener("mousedown", function () {
          $scope.modelTransform.scale = $scope.modelTransform.scale / 1.05;
          $scope.gisViewer.triggerRepaint();
        });
        $document[0].getElementById('button-move-up').addEventListener("mousedown", function () {
          $scope.modelOrigin[1] = $scope.modelOrigin[1] + 0.00001; //$scope.location.coordinates[0] = $scope.location.coordinates[0] + 0.00001;

          var origin = [$scope.modelOrigin[0], $scope.modelOrigin[1]];
          var modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat(origin, Math.floor(($scope.altitude * 1.5 + 10) / 10) * 10);
          $scope.modelTransform.translateX = modelAsMercatorCoordinate.x;
          $scope.modelTransform.translateY = modelAsMercatorCoordinate.y;
          $scope.modelTransform.translateZ = modelAsMercatorCoordinate.z;
          $scope.gisViewer.triggerRepaint();
        });
        $document[0].getElementById('button-move-left').addEventListener("mousedown", function () {
          $scope.modelOrigin[0] = $scope.modelOrigin[0] - 0.00001; //$scope.location.coordinates[1] = $scope.location.coordinates[1] - 0.00001;

          var origin = [$scope.modelOrigin[0], $scope.modelOrigin[1]];
          var modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat(origin, Math.floor(($scope.altitude * 1.5 + 10) / 10) * 10);
          $scope.modelTransform.translateX = modelAsMercatorCoordinate.x;
          $scope.modelTransform.translateY = modelAsMercatorCoordinate.y;
          $scope.modelTransform.translateZ = modelAsMercatorCoordinate.z;
          $scope.gisViewer.triggerRepaint();
        });
        $document[0].getElementById('button-move-right').addEventListener("mousedown", function () {
          $scope.modelOrigin[0] = $scope.modelOrigin[0] + 0.00001; //$scope.location.coordinates[1] = $scope.location.coordinates[1] + 0.00001;

          var origin = [$scope.modelOrigin[0], $scope.modelOrigin[1]];
          var modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat(origin, Math.floor(($scope.altitude * 1.5 + 10) / 10) * 10);
          $scope.modelTransform.translateX = modelAsMercatorCoordinate.x;
          $scope.modelTransform.translateY = modelAsMercatorCoordinate.y;
          $scope.modelTransform.translateZ = modelAsMercatorCoordinate.z;
          $scope.gisViewer.triggerRepaint();
        });
        $document[0].getElementById('button-move-down').addEventListener("mousedown", function () {
          $scope.modelOrigin[1] = $scope.modelOrigin[1] - 0.00001; //$scope.location.coordinates[0] = $scope.location.coordinates[0] - 0.00001;

          var origin = [$scope.modelOrigin[0], $scope.modelOrigin[1]];
          var modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat(origin, Math.floor(($scope.altitude * 1.5 + 10) / 10) * 10);
          $scope.modelTransform.translateX = modelAsMercatorCoordinate.x;
          $scope.modelTransform.translateY = modelAsMercatorCoordinate.y;
          $scope.modelTransform.translateZ = modelAsMercatorCoordinate.z;
          $scope.gisViewer.triggerRepaint();
        });
        $document[0].getElementById('button-reset').addEventListener("mousedown", function () {
          var lonlat = [$scope.location.coordinates[1], $scope.location.coordinates[0]];
          var deltaLonLat = [$scope.gisTransformData.move.moveY, $scope.gisTransformData.move.moveX];
          var rotate = $scope.gisTransformData.rotate;
          var scale = $scope.gisTransformData.scale;
          $scope.modelOrigin = [lonlat[0] + deltaLonLat[0], lonlat[1] + deltaLonLat[1]];
          var modelRotate = [0, 0, rotate];
          var modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat($scope.modelOrigin, 0); // transformation parameters to position, rotate and scale the 3D model onto the map

          $scope.modelTransform = {
            translateX: modelAsMercatorCoordinate.x,
            translateY: modelAsMercatorCoordinate.y,
            translateZ: modelAsMercatorCoordinate.z,
            rotateX: modelRotate[0],
            rotateY: modelRotate[1],
            rotateZ: modelRotate[2],

            /* Since our 3D model is in real world meters, a scale transform needs to be
            * applied since the CustomLayerInterface expects units in MercatorCoordinates.
            */
            scale: modelAsMercatorCoordinate.meterInMercatorCoordinateUnits() * scale
          };
          $scope.gisViewer.triggerRepaint();
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("cgviewerDropdown", cgviewerDropdown);

  function cgviewerDropdown() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/main/cgviewer/directives/cgviewer-dropdown/cgviewer-dropdown.view.html',
      scope: {
        ngModel: "=",
        options: "=",
        ngChange: "&",
        placeholder: "@",
        labelField: "@",
        valueField: "@",
        icon: "@"
      },
      link: function link(scope) {
        scope.isOpen = false;

        if (scope.options) {
          scope.optionsTemp = scope.options;
        }

        scope.selectedLabel = scope.placeholder || scope.options[0].label;

        if (scope.ngModel && scope.options) {
          if (scope.ngModel != {}) {
            var selectedItem = scope.options.find(function (item) {
              return angular.equals(item[scope.valueField], scope.ngModel);
            });

            if (selectedItem) {
              scope.selectedLabel = selectedItem[scope.labelField];
            }
          }
        }

        scope.toggleList = function () {
          scope.isOpen = !scope.isOpen;
        };

        scope.$watch('ngModel', function () {
          if (scope.options && scope.ngModel) {
            var _selectedItem = scope.options.find(function (item) {
              return angular.equals(item[scope.valueField], scope.ngModel);
            });

            if (_selectedItem) {
              scope.selectedLabel = _selectedItem[scope.labelField];
            }
          } else {
            scope.selectedLabel = scope.placeholder;
          }

          scope.ngChange();
        });

        scope.selectItem = function (item) {
          if (!angular.equals(item[scope.valueField], scope.ngModel)) {
            scope.ngModel = item[scope.valueField];
            scope.selectedLabel = item[scope.labelField];
          }

          scope.isOpen = false;
        };

        scope.closeList = function () {
          scope.isOpen = false;
          scope.options = scope.optionsTemp;
        };

        scope.addItem = function () {
          scope.addItemEvent();
        };

        scope.searchFunction = function (searchText) {
          scope.options = scope.optionsTemp;
          var output = [];

          if (searchText.length >= 0) {
            angular.forEach(scope.options, function (item) {
              if (item[scope.labelField].toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                output.push(item);
              }
            });
          }

          scope.options = output;
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('card', card);

  function card() {
    return {
      restrict: 'A',
      scope: {},
      link: function link() {
        angular.element('.card').on('card:toggle', function () {
          var $this, direction;
          $this = angular.element(this);
          direction = $this.hasClass('card-collapsed') ? 'Down' : 'Up';
          $this.find('.card-body, .card-footer')['slide' + direction](200, function () {
            $this[(direction === 'Up' ? 'add' : 'remove') + 'Class']('card-collapsed');
          });
        }).on('card:dismiss', function () {
          var $this = angular.element(this);

          if (!!($this.parent('div').attr('class') || '').match(/col-(xs|sm|md|lg)/g) && $this.siblings().length === 0) {
            var $row = $this.closest('.row');
            $this.parent('div').remove();

            if ($row.children().length === 0) {
              $row.remove();
            }
          } else {
            $this.remove();
          }
        }).on('click', '[data-card-toggle]', function (e) {
          e.preventDefault();
          angular.element(this).closest('.card').trigger('card:toggle');
        }).on('click', '[data-card-dismiss]', function (e) {
          e.preventDefault();
          angular.element(this).closest('.card').trigger('card:dismiss');
        })
        /* Deprecated */
        .on('click', '.card-actions a.fa-caret-up', function (e) {
          e.preventDefault();
          var $this = angular.element(this);
          $this.removeClass('fa-caret-up').addClass('fa-caret-down');
          $this.closest('.card').trigger('card:toggle');
        }).on('click', '.card-actions a.fa-caret-down', function (e) {
          e.preventDefault();
          var $this = angular.element(this);
          $this.removeClass('fa-caret-down').addClass('fa-caret-up');
          $this.closest('.card').trigger('card:toggle');
        }).on('click', '.card-actions a.fa-times', function (e) {
          e.preventDefault();
          var $this = angular.element(this);
          $this.closest('.card').trigger('card:dismiss');
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("bimSettings", bimSettings);

  function bimSettings() {
    return {
      restrict: "E",
      replace: 'true',
      templateUrl: 'app/main/cgviewer/directives/bim-settings/bim-settings.view.html',
      scope: {
        themes: '=',
        selectedTheme: '=',
        onThemeSelect: "=",
        onChangeQuality: "=",
        onChangeColorMode: '=',
        onChangeSelectMode: '='
      },
      link: function link($scope) {
        $scope.qualities = [{
          name: 'Very Low',
          value: 'xlow',
          icon: '/assets/images/cgviewer/bim/quality/low.png'
        }, {
          name: 'Low',
          value: 'low',
          icon: '/assets/images/cgviewer/bim/quality/low.png'
        }, {
          name: 'Medium',
          value: 'medium',
          icon: '/assets/images/cgviewer/bim/quality/medium.png'
        }, {
          name: 'High',
          value: 'high',
          icon: '/assets/images/cgviewer/bim/quality/high.png'
        }];
        $scope.colorModes = [{
          name: 'Normal',
          value: 'normal',
          icon: '/assets/icons/color-normal.svg'
        }, {
          name: 'Material',
          value: 'inventory',
          icon: '/assets/icons/color-material.svg'
        }];
        $scope.selectModes = [{
          name: 'Shape',
          value: 'pershape',
          icon: '/assets/icons/select-object.svg'
        }, {
          name: 'Face',
          value: 'perface',
          icon: '/assets/icons/select-surface.svg'
        }];
        $scope.selectedQuality = $scope.qualities[1];
        $scope.selectedColorMode = $scope.colorModes[0];
        $scope.selectedSelectMode = $scope.selectModes[0];

        $scope.themeSelected = function (theme) {
          $scope.selectedTheme = theme;

          if ($scope.onThemeSelect) {
            $scope.onThemeSelect(theme);
          }
        };

        $scope.qualitySelected = function (quality) {
          $scope.selectedQuality = quality;

          if ($scope.onChangeQuality) {
            $scope.onChangeQuality(quality);
          }
        };

        $scope.colorModeSelected = function (color) {
          $scope.selectedColorMode = color;

          if ($scope.onChangeColorMode) {
            $scope.onChangeColorMode(color);
          }
        };

        $scope.selectModeSelected = function (facemode) {
          $scope.selectedSelectMode = facemode;

          if ($scope.onChangeSelectMode) {
            $scope.onChangeSelectMode(facemode);
          }
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("bimPropertyIndicator", bimPropertyIndicator);

  function bimPropertyIndicator($timeout, $document, utils, $uibModal, $log) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/bim-property-indicator/bim-property-indicator.view.html',
      scope: {
        show: "=",
        bimObjects: "=",
        pos: "=",
        unit: "=",
        viewer: "=",
        materials: "=",
        comboMaterials: "=",
        equipments: "=",
        comboEquipments: "=",
        workTypes: "=",
        sections: "=",
        onAssigned: "="
      },
      link: function link($scope) {
        var indicatorRadius = 15;
        var expandMenuWidth = 154;
        var expandMenuHeight = 63;
        var popupIdList = ['object-information-properties', 'object-information-items'];

        $scope.posStyle = function () {
          if (!$scope.pos) return {};
          return {
            left: $scope.pos.x - indicatorRadius + 'px',
            top: $scope.pos.y - indicatorRadius + 'px'
          };
        };

        $scope.curPopupId = -1;

        $scope.onClickVisible = function () {
          $scope.show = false;

          if ($scope.viewer) {
            var model = $scope.viewer.getBimModel();
            model.setBimObjectsVisible($scope.bimObjects, false);
            $scope.viewer.invalidate();
          }
        };

        $scope.onClickExpandIcon = function ($event) {
          $event.stopPropagation();
          if (getPopupShowingStatus()) return;
          if (angular.isUndefined($scope.pos)) return;
          angular.element('#property_expand_menu').show();
          angular.element('#property_expand_menu').css("left", $scope.pos.x - expandMenuWidth / 2 + 'px');
          angular.element('#property_expand_menu').css("top", $scope.pos.y - indicatorRadius - expandMenuHeight + 'px');
        };

        $scope.onClickPropertiesIcon = function () {
          if (getPopupShowingStatus()) return;
          if (angular.isUndefined($scope.pos)) return;
          var propertiesMenuWidth = 220;
          var pos = {
            x: $scope.pos.x - propertiesMenuWidth / 2,
            y: $scope.pos.y + indicatorRadius
          };
          showObjectPropertiesPopup(pos);
          $scope.curPopupId = 0;
        };

        $scope.onClickItemsIcon = function () {
          if (getPopupShowingStatus()) return;
          if (angular.isUndefined($scope.pos)) return;
          var itemsMenuWidth = 422;
          var pos = {
            x: $scope.pos.x - itemsMenuWidth / 2,
            y: $scope.pos.y + indicatorRadius
          };
          showObjectInventoriesPopup(pos);
          $scope.curPopupId = 1;
        };

        $scope.onClickCollapseIcon = function () {
          if (getPopupShowingStatus()) return;
          angular.element('#property_expand_menu').hide();
        };

        $scope.onClickEvent = function () {
          angular.element('#property_expand_menu').hide();
          angular.element('#property_background_element').hide();
          angular.element('#property_menu_model_info_window').hide();
          angular.element('#property_expand_menu').hide();
          $scope.show = false;
          $scope.curPopupId = -1;
        };

        function getPopupShowingStatus() {
          for (var i = 0; i < popupIdList.length; i++) {
            var elem = $document[0].getElementById(popupIdList[i]);
            if (!elem) continue;
            var visibility = angular.element('#' + popupIdList[i]).css('display');

            if (visibility !== 'none') {
              $scope.curPopupId = i;
              return true;
            }
          }

          return false;
        }

        function showObjectPropertiesPopup(_pos) {
          if (angular.isUndefined($scope.bimObjects)) return;
          var _objectInfo = {
            materials: [],
            width: 0,
            height: 0,
            length: 0,
            perimeter: 0,
            area: 0,
            volume: 0,
            unit: 'm'
          };

          if ($scope.bimObjects.length <= 1) {
            var info = $scope.bimObjects[0].getGeometricalFaceInfo(false);
            _objectInfo.width = info.face.width;
            _objectInfo.height = info.face.height; // objectInfo.length = info.size.z;

            var size_items = [info.size.x, info.size.y, info.size.z];
            var face_items = [info.face.width, info.face.height];

            for (var _i = 0, _size_items = size_items; _i < _size_items.length; _i++) {
              var item = _size_items[_i];

              if (face_items.indexOf(item) === -1) {
                _objectInfo.length = item;
                break;
              }
            }

            _objectInfo.perimeter = (info.size.x + info.size.y + info.size.z) * 4; //needed for get quantity in material setting

            _objectInfo.area = info.area;
            _objectInfo.volume = info.volume;
            _objectInfo.unit = $scope.unit;
          } else {
            for (var i = 0; i < $scope.bimObjects.length; i++) {
              var bimObject = $scope.bimObjects[i];

              var _info = bimObject.getGeometricalFaceInfo(false);

              _objectInfo.width = _info.face.width;
              _objectInfo.height = _info.face.height; // objectInfo.length = info.size.z;

              var _size_items2 = [_info.size.x, _info.size.y, _info.size.z];
              var _face_items = [_info.face.width, _info.face.height];

              for (var _i2 = 0, _size_items3 = _size_items2; _i2 < _size_items3.length; _i2++) {
                var _item = _size_items3[_i2];

                if (_face_items.indexOf(_item) === -1) {
                  _objectInfo.length = _item;
                  break;
                }
              }

              _objectInfo.perimeter += (_info.size.x + _info.size.y + _info.size.z) * 4; //needed for get quantity in material setting

              _objectInfo.area += _info.area;
              _objectInfo.volume += _info.volume;
            }

            _objectInfo.unit = $scope.unit;
          }

          $uibModal.open({
            animation: true,
            component: 'objectPropertiesModal',
            windowClass: 'object-properties-modal-window',
            backdropClass: 'object-properties-modal-backdrop',
            resolve: {
              objectInfo: function objectInfo() {
                return _objectInfo;
              },
              isThree: function isThree() {
                return true;
              },
              isShape: function isShape() {
                return angular.isUndefined($scope.bimObjects[0].faceMode) || $scope.bimObjects[0].faceMode === "pershape";
              },
              pos: function pos() {
                return _pos;
              }
            }
          }).result.then(function (result) {
            $log.log(result);
            $scope.curPopupId = -1;
          }, function (reason) {
            $log.log(reason);
            $scope.curPopupId = -1;
          });
        }

        function showObjectInventoriesPopup(_pos2) {
          $uibModal.open({
            animation: true,
            component: 'objectInventoriesModal',
            windowClass: 'object-inventories-modal-window',
            backdropClass: 'object-inventories-modal-backdrop',
            resolve: {
              objects: function objects() {
                return $scope.bimObjects;
              },
              unit: function unit() {
                return $scope.unit;
              },
              isThree: function isThree() {
                return true;
              },
              pos: function pos() {
                return _pos2;
              },
              baseData: function baseData() {
                return {
                  materials: $scope.materials,
                  dcps: $scope.comboMaterials,
                  equipments: $scope.equipments,
                  dcqs: $scope.comboEquipments,
                  workTypes: $scope.workTypes,
                  sections: $scope.sections
                };
              }
            }
          }).result.then(function () {
            $scope.curPopupId = -1;

            if ($scope.viewer) {
              $scope.viewer.invalidate();
            }

            if ($scope.onAssigned) {
              $scope.onAssigned();
            }
          }, function (reason) {
            $log.log(reason);
            $scope.curPopupId = -1;
          });
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("bimPlan", bimPlan);

  function bimPlan(Bim, $timeout, VP, $log, apiFactory, Notification, utils) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/bim-plan/bimPlan.view.html',
      scope: {
        bimModel: "=",
        plans: "=",
        selectedPlan: "=",
        onShowPlan: "="
      },
      link: function link($scope) {
        $scope.navMode = false;
        $scope.bimPlan = undefined;
        $scope.toolbarList = [{
          id: 'select',
          icon: "drawing-select.svg"
        }, {
          id: 'pan',
          icon: "pan-move.svg"
        }, {
          id: 0,
          icon: "drawing.svg",
          submenu: [{
            id: 'rect',
            icon: "drawing-rect.svg"
          }, {
            id: 'circle',
            icon: "drawing-circle.svg"
          }, {
            id: 'sector',
            icon: "drawing-sector.svg"
          }, {
            id: 'hexagon',
            icon: "drawing-hex.svg"
          }, {
            id: 'line',
            icon: "drawing-line.svg"
          }, {
            id: 'polyline',
            icon: "drawing-polyline.svg"
          }, {
            id: 'curve',
            icon: "drawing-curve.svg"
          }, {
            id: 'arc',
            icon: "drawing-arc.svg"
          }, {
            id: 'freeline',
            icon: "drawing-path.svg"
          }, {
            id: 'arrow_line_up',
            icon: "arrow-up.svg"
          }, {
            id: 'arrow_line_down',
            icon: "arrow-down.svg"
          }, {
            id: 'arrow_line_both_sides',
            icon: "arrow-both.svg"
          }]
        }, {
          id: 'eraser',
          icon: "drawing-erase.svg"
        }, {
          id: 0,
          icon: "drawing-measure.svg",
          submenu: [{
            id: 'calibrator',
            icon: "drawing-unit.svg"
          }, {
            id: 'length',
            icon: "drawing-measure-dist.svg"
          }, {
            id: 'angle',
            icon: "drawing-measure.svg"
          }, {
            id: 'surface',
            icon: "drawing-measure-area.svg"
          }]
        }, {
          id: 'text',
          icon: "drawing-text.svg"
        }, {
          id: 'zoom',
          icon: "drawing-zoom.svg"
        }, {
          id: 'color',
          icon: "drawing-picker.svg"
        }, {
          id: 'bucket',
          icon: "drawing-paint.svg"
        }];
        var navigationController = null;
        var planViewer = undefined;

        function loadNavigation() {
          var element3d = angular.element("#bim-navigation-3d")[0];
          element3d.innerHTML = '';
          var element2d = angular.element("#bim-plan-2d")[0];
          element2d.innerHTML = '';
          planViewer = VP.mainViewer(element2d);
          var modelViewer = Bim.simpleViewer(element3d);
          modelViewer.initialize();
          navigationController = Bim.navigationController(modelViewer, planViewer);
          navigationController.setBimModel($scope.bimModel);
        }

        $scope.selectPlan = function (plan) {
          $scope.bimPlan = plan;
          planViewer.clear();

          if (plan && plan.pdfImage) {
            if (navigationController) {
              navigationController.setBimPlan(plan);
            }

            planViewer.loadBackgroundImage(plan.pdfImage).then(function () {
              if (plan.drawing) {
                if (utils.isServerURL(plan.drawing)) {
                  planViewer.addFromJSONURL(plan.drawing);
                } else {
                  planViewer.addFromJSON(plan.drawing);
                }
              }
            })["catch"](function (err) {
              $log.error(err);
            });
          }
        };

        $scope.toggleNavigation = function () {
          $scope.navMode = !$scope.navMode;
          $timeout(function () {
            if (navigationController) {
              if ($scope.navMode) {
                navigationController.start();
              } else {
                navigationController.stop();
              }
            }
          });
        };

        $scope.gotoPlan = function () {
          if (angular.isDefined($scope.onShowPlan) && $scope.bimPlan) {
            $scope.onShowPlan($scope.bimPlan);
          }
        };

        $scope.savePlan = function () {
          if ($scope.bimPlan && planViewer) {
            planViewer.getImageData().then(function (imageData) {
              $scope.bimPlan.changeImage(imageData);
              $scope.bimPlan.drawing = planViewer.save();

              if ($scope.bimPlan.id) {
                var planData = $scope.bimPlan.getSaveData();

                if (utils.isServerURL(planData.image)) {
                  delete planData.image;
                } else {
                  planData.image = utils.makeBlob(planData.image, $scope.bimPlan.id);
                }

                if ($scope.bimPlan.drawing) {
                  planData.drawing = utils.makeTextBlob($scope.bimPlan.drawing, $scope.bimPlan.id);
                }

                apiFactory.updatePlan($scope.bimPlan.id, planData).then(function () {
                  Notification.success('Plan saved successfully.');
                })["catch"](function (err) {
                  $log.error(err);
                });
              } else {
                Notification.success('Plan saved successfully.');
              }
            })["catch"](function (err) {
              $log.error(err);
            });
          }
        };

        $scope.toolbarEvent = function (id) {
          planViewer.toolbarEvent(id);
        };

        $timeout(function () {
          loadNavigation();
          $scope.selectPlan($scope.selectedPlan);
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("bimOptional", bimOptional);

  function bimOptional(NgMap, $log, $timeout) {
    return {
      restrict: "E",
      replace: 'true',
      templateUrl: 'app/main/cgviewer/directives/bim-optional/bim-optional.view.html',
      scope: {
        canChange: "=",
        thumbFile: "=",
        thumbnail: "=",
        description: "=",
        location: "=",
        loaded: "=",
        onChange: "="
      },
      link: function link($scope) {
        var vm = this;
        $scope.gmap = {
          url: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&libraries=places",
          markers: [],
          styles: [],
          center: "41,-87",
          zoom: 3
        };
        $timeout(function () {
          return $scope.$apply();
        });
        $scope.isLoading = true;
        NgMap.getMap("service_map").then(function (map) {
          vm.map = map;
          map.setOptions({
            styles: $scope.gmap.styles,
            disableDefaultUI: true,
            mapTypeControl: true,
            mapTypeId: 'satellite',
            zoomControl: true,
            zoom: 1,
            center: {
              lat: 0,
              lng: 0
            }
          });
          $scope.isLoading = false;
        })["catch"](function (err) {
          $log.error(err);
          $scope.isLoading = false;
        });

        $scope.browseThumbnail = function () {
          angular.element('#thumbnail').click();
        };

        $scope.changeThumbnail = function (ev) {
          var files = ev.target.files;
          $scope.thumbFile = files[0];
          var reader = new FileReader();

          reader.onload = function (e) {
            angular.element('#preview-img').attr('src', e.target.result);
          };

          reader.readAsDataURL($scope.thumbFile);
          $scope.onChange();
        };

        $scope.placeMarker = function () {
          var place = this.getPlace();
          var latLng = place.geometry.location;
          $scope.gmap.markers = [[latLng.lat(), latLng.lng()]];
          $scope.gmap.zoom = 15;
          $scope.gmap.center = "".concat(latLng.lat(), ",").concat(latLng.lng());
          $scope.location = {
            coordinates: [latLng.lat(), latLng.lng()],
            position: place.formatted_address
          };
          $scope.onChange();
        };

        $scope.updateMarker = function () {
          var pos = this.getPosition();
          $scope.location = {
            coordinates: [pos.lat(), pos.lng()],
            position: $scope.address
          };
          $scope.onChange();
        };

        $scope.$watch('loaded', function (newVal) {
          if (newVal && $scope.location) {
            $scope.address = $scope.location.position;
            var placeData = {
              lat: $scope.location.coordinates[0],
              lng: $scope.location.coordinates[1]
            };
            $scope.gmap.markers = [[placeData.lat, placeData.lng]];
            $scope.gmap.zoom = 15;
            $scope.gmap.center = "".concat(placeData.lat, ",").concat(placeData.lng);
          }
        });
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').directive("bimObjectProperties", bimObjectProperties);

  function bimObjectProperties(Bim) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/bim-object-properties/bim-object-properties.view.html',
      scope: {
        bimObject: "=",
        products: "=",
        onSelect: "=",
        onChanged: "="
      },
      link: function link($scope) {
        $scope.selectedElement = '';
        var componentPreviewer = Bim.simpleViewer(angular.element("#component-preview")[0]);
        componentPreviewer.initialize();

        $scope.onElementSelected = function (selected) {
          var object = $scope.products.find(function (x) {
            return x.id === selected;
          });

          if (object) {
            $scope.onSelect(object.object);
          }
        };

        $scope.$watch('bimObject', function (newVal) {
          var object = newVal;

          if (object) {
            $scope.selectedElement = object.id;
            componentPreviewer.clear();
            componentPreviewer.addBimObject(object, false);
          } else {
            $scope.selectedElement = undefined;
            componentPreviewer.clear();
          }
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('bimLookAround', bimLookAround);

  function bimLookAround($document) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/bim-look-around/bim-look-around.view.html',
      scope: {
        controlEvent: "="
      },
      link: function link($scope) {
        $scope.active = false;
        var container = $document[0].getElementById('bim-look-around-container');
        var controlElem = $document[0].getElementById('bim-look-around-control');
        $document[0].addEventListener("touchstart", dragStart, false);
        $document[0].addEventListener("touchend", dragEnd, false);
        $document[0].addEventListener("touchmove", drag, false);
        $document[0].addEventListener("mousedown", dragStart, false);
        $document[0].addEventListener("mouseup", dragEnd, false);
        $document[0].addEventListener("mousemove", drag, false);
        var currentX = 0;
        var currentY = 0;
        var initialX = 0;
        var initialY = 0;
        var radius = (container.offsetWidth || 140) / 2;

        function dragStart(e) {
          if (e.target !== controlElem) {
            return;
          }

          e.preventDefault();

          if (e.type === "touchstart") {
            initialX = e.touches[0].clientX;
            initialY = e.touches[0].clientY;
          } else {
            initialX = e.clientX;
            initialY = e.clientY;
          }

          $scope.active = true;
          controlElem.classList.add('active');
        }

        function dragEnd(e) {
          if (!$scope.active) return;
          e.preventDefault();
          setTranslate(0, 0, controlElem);
          $scope.active = false;
          controlElem.classList.remove('active');

          if (angular.isDefined($scope.controlEvent)) {
            $scope.controlEvent();
          }
        }

        function drag(e) {
          if (!$scope.active) return;
          e.preventDefault();

          if (e.type === "touchmove") {
            currentX = e.touches[0].clientX - initialX;
            currentY = e.touches[0].clientY - initialY;
          } else {
            currentX = e.clientX - initialX;
            currentY = e.clientY - initialY;
          }

          var distance = Math.sqrt(currentX * currentX + currentY * currentY);

          if (distance > radius) {
            currentX = radius * currentX / distance;
            currentY = radius * currentY / distance;
          }

          if (distance >= radius - 10) {
            if (angular.isDefined($scope.controlEvent)) {
              $scope.controlEvent({
                x: currentX,
                y: -currentY
              });
            }
          }

          setTranslate(currentX, currentY, controlElem);
        }

        function setTranslate(xPos, yPos, el) {
          el.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("bimEquipmentMaterials", bimEquipmentMaterials);

  function bimEquipmentMaterials() {
    return {
      restrict: "E",
      templateUrl: "app/main/cgviewer/directives/bim-equipment-materials/bim-equipment-materials.view.html",
      scope: {
        ngColorEvents: "=",
        ngMaterials: "="
      },
      link: function link($scope) {
        $scope.visible = true;

        $scope.changeVisible = function () {
          $scope.visible = !$scope.visible;
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive("bimCollision", bimCollision);

  function bimCollision($log, $uibModal, $timeout, apiFactory, utils, Notification, Bim) {
    return {
      restrict: "E",
      templateUrl: 'app/main/cgviewer/directives/bim-collision/bim-collision.view.html',
      scope: {
        isShow: '=',
        modelId: "=",
        viewer: "=",
        onShowItem: "<"
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.collisions = [];
      scope.activeCollision = undefined;
      scope.selectedCollisionItem = null;
      var viewer = null;
      var eventAdded = false;
      apiFactory.listCollisionBim(scope.modelId).then(function (resp) {
        scope.collisions = resp.data.list || [];
        scope.collisions.forEach(function (collision) {
          collision.name = collision.bim2.name;
        });
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Failed to load collision");
      });
      scope.$watch('viewer', function (newVal) {
        if (newVal && scope.viewer && !eventAdded) {
          scope.viewer.on('modelMoved', modelMoved);
          eventAdded = true;
        }
      });
      scope.$on('$destroy', function () {
        if (scope.viewer && eventAdded) {
          scope.viewer.off('modelMoved');
        }
      });

      scope.addCollision = function () {
        $uibModal.open({
          animation: true,
          component: 'openModelModal',
          windowClass: 'bim-open-model-modal'
        }).result.then(function (result) {
          var model = result.model;

          if (scope.viewer) {
            if (scope.viewer.isModelFull()) {
              scope.viewer.removeCollision();
            }

            showLoading();
            scope.viewer.loadBim(model).then(function (bimModel) {
              createCollision(model, bimModel);
            })["catch"](function () {
              hideLoading();
              Notification.error('IFC file cannot open.');
            });
          }
        });
      };

      scope.removeCollision = function (collision, index) {
        $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false
        }).result.then(function () {
          apiFactory.deleteCollisionBim(collision._id).then(function () {
            scope.collisions.splice(index, 1);

            if (collision === scope.activeCollision) {
              scope.viewer.removeCollision();
              scope.activeCollision = undefined;
            }

            Notification.success("Collision is deleted successfully.");
          })["catch"](function (err) {
            $log.error(err);
            Notification.error("Failed to delete");
          });
        });
      };

      scope.refreshCollision = function (collision) {
        collision.items = scope.viewer.detectCollision();
      };

      scope.selectCollision = function (collision) {
        if (scope.activeCollision === collision) {
          scope.activeCollision = undefined;
          scope.viewer.removeCollision();
        } else {
          if (scope.activeCollision) {
            scope.viewer.removeCollision();
          }

          scope.activeCollision = collision;
          loadCollision(collision);
        }
      };

      scope.showCollisionItem = function (item, index) {
        scope.viewer.showCollision(item);
        scope.selectedCollisionItem = scope.selectedCollisionItem === item ? null : item;
        destroyViewer();

        if (scope.selectedCollisionItem) {
          $timeout(function () {
            return createViewer(item, index);
          });
        }
      };

      scope.changePosition = function (collision) {
        collision.model.updatePosition(collision.position);
        collision.items = scope.viewer.detectCollision();
        scope.viewer.invalidate();
      };

      function createCollision(model, bimModel) {
        var items = scope.viewer.detectCollision();
        apiFactory.createCollisionBim({
          bim1: scope.modelId,
          bim2: model._id,
          items: items.map(function (x) {
            return {
              object1: x.object1.guid,
              object2: x.object2.guid
            };
          })
        }).then(function (resp) {
          var collision = resp.data.data;
          collision.name = utils.changeExtension(model.name, "ifc");
          collision.model = bimModel;
          collision.items = items;
          collision.position = bimModel.getPosition();
          scope.collisions.push(collision);
          scope.activeCollision = scope.collisions[scope.collisions.length - 1];
          $timeout(function () {
            return scope.$apply();
          });
          hideLoading();
        })["catch"](function (err) {
          $log.error(err);
          Notification.error("Failed to save!");
          hideLoading();
        });
      }

      function loadCollision(collision) {
        if (collision.model) {
          scope.viewer.loadBimModel(collision.model);
        } else {
          showLoading();
          apiFactory.get3dModel(collision.bim2._id).then(function (resp) {
            scope.viewer.loadBim(resp.data.data).then(function (bimModel) {
              collision.model = bimModel;
              collision.items = scope.viewer.detectCollision();
              collision.position = bimModel.getPosition();
              hideLoading();
            })["catch"](function () {
              hideLoading();
              Notification.error('IFC file cannot open.');
            });
          })["catch"](function (err) {
            $log.error(err);
            hideLoading();
          });
        }
      }

      function showLoading() {
        angular.element("#initial_loading_popup").show();
      }

      function hideLoading() {
        angular.element("#initial_loading_popup").hide();
      }

      function createViewer(collisionItem, index) {
        viewer = Bim.simpleViewer(angular.element("#preview-container-".concat(index))[0]);
        viewer.initialize();
        viewer.addBimObject(collisionItem.object1, true);
        viewer.addBimObject(collisionItem.object2, true);
        viewer.fitScreen();
        viewer.invalidate();
      }

      function destroyViewer() {
        if (viewer) {
          viewer.destroy();
          viewer = null;
        }
      }

      function modelMoved(bimModel) {
        if (scope.activeCollision) {
          scope.activeCollision.items = scope.viewer.detectCollision();

          if (bimModel === scope.activeCollision.model) {
            scope.activeCollision.position = bimModel.getPosition();
          }

          $timeout(function () {
            return scope.$apply();
          });
        }
      }
    }
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('bimGrid', {
    controller: bimGridController,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/bim/bimGrid/bimGrid.view.html'
  });
  /** @ngInject */

  function bimGridController($scope, $rootScope, apiFactory, $state, $log, $uibModal, globals, utils, Notification) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.DVIEWER_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.DVIEWER_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.DVIEWER]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.DVIEWER_ACCESS_CREATE = res.data.data[Constants.AccessKey.DVIEWER];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.models = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    vm.companyData = companyStore.get();
    $scope.isLoading = false;

    vm.fetchAllModels = function () {
      $scope.isLoading = true;
      apiFactory.list3d(vm.project._id, {
        sort: "createdAt",
        sortType: "false",
        page: vm.currentPage,
        chunk: $scope.numPerPage
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.models = resp.data.data;

        var _iterator = _createForOfIteratorHelper($scope.models),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var model = _step.value;

            if (model.size >= 1000000) {
              model.displaySize = model.size / 1000000;
              model.displaySizeUnit = 'MB';
            } else if (model.size >= 1000 && model.size < 1000000) {
              model.displaySize = model.size / 1000;
              model.displaySizeUnit = 'KB';
            } else if (model.size >= 0 && model.size < 1000) {
              model.displaySize = model.size;
              model.displaySizeUnit = 'B';
            } else {
              model.displaySize = 0;
              model.displaySizeUnit = 'B';
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);

        if (err.status === 403) {
          Notification.error(err.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        }
      });
    };

    vm.fetchAllModels();

    $scope.deleteModel3D = function (id) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        apiFactory.deleteModel3d(id).then(function () {
          vm.fetchAllModels();
          Notification.success('3D Model was deleted successfully.');
        })["catch"](function (err) {
          $log.error(err);
        });
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchAllPlans();
    };

    var searchCallback = $rootScope.$on('search-event', function (event, params) {
      $scope.isLoading = true;
      apiFactory.list3d(vm.project._id, {
        sort: "created",
        sortType: "false",
        search: params
      }).then(function (data) {
        $scope.isLoading = false;
        $scope.models = data.data.data;
        $scope.totalCount = data.data.data.length;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);

        if (err.status === 403) {
          Notification.error(err.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        }
      });
    });
    $rootScope.$on('$destroy', searchCallback);

    $scope.goToDetail = function (modelId) {
      $state.go('bimDetail', {
        id: modelId
      });
    };

    vm.openDlgUpload = function () {
      $uibModal.open({
        animation: true,
        component: 'uploadModelModal',
        windowClass: 'upload-bim-modal'
      }).result.then(function (result) {
        if (result) {
          vm.fetchAllModels();
        }
      });
    };

    vm.downloadPdf = function (plan) {
      $scope.isDownloading = true;
      utils.downloadFile(plan.parentAsset.secure_url).then(function () {
        $scope.isDownloading = false; //$timeout(() => $scope.$apply());
      })["catch"](function (err) {
        $scope.isDownloading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('bimDetail', {
    controller: bimDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/cgviewer/bim/bimDetail/bimDetail.view.html'
  });
  /** @ngInject */

  function bimDetailController($scope, $timeout, authFactory, $state, $stateParams, apiFactory, utils, Notification, globals, $document, $log, Bim, $uibModal) {
    var logout = globals.logout,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore,
        userStore = globals.userStore;
    var vm = this;
    vm.userData = userStore.get();
    $scope.DVIEWER_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.DVIEWER_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.DVIEWER]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.DVIEWER_ACCESS_CREATE = res.data.data[Constants.AccessKey.DVIEWER];
    //   })
    //   .catch((e) => {
    //     $scope.isLoading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    if (!authFactory.checkUser()) {
      logout();
      return;
    }

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.isShowGisMap = false;
    vm.companyData = companyStore.get();
    vm.modelId = $stateParams.id;
    vm.title = "3D Model";
    vm.mode = 'default';
    vm.projectId = vm.project._id;
    vm.bimModel = undefined;
    vm.bimObject = undefined;
    vm.productList = [];
    vm.materials = [];
    vm.comboMaterials = [];
    vm.equipments = [];
    vm.comboEquipments = [];
    vm.workLevels = [];
    vm.workTypes = [];
    vm.sections = [];
    vm.zoomLevel = 100;
    vm.propertyIndicator = {
      show: false
    };
    vm.collision = undefined;
    $scope.isLoading = true;
    vm.modelInfo = undefined;
    vm.themes = [{
      id: 0,
      space: '/assets/images/cgviewer/bim/environment/space-01/back.jpg',
      ground: '/assets/images/cgviewer/bim/environment/ground-01.jpg'
    }, {
      id: 1,
      space: '/assets/images/cgviewer/bim/environment/space-02/back.jpg',
      ground: '/assets/images/cgviewer/bim/environment/ground-02.jpg'
    }, {
      id: 2,
      space: '/assets/images/cgviewer/bim/environment/space-03/back.jpg',
      ground: '/assets/images/cgviewer/bim/environment/ground-03.jpg'
    }, {
      id: 3,
      space: '/assets/images/cgviewer/bim/environment/space-04/back.jpg',
      ground: '/assets/images/cgviewer/bim/environment/ground-04.jpg'
    }, {
      id: 4,
      space: '/assets/images/cgviewer/bim/environment/space-05/back.jpg',
      ground: '/assets/images/cgviewer/bim/environment/ground-05.jpg'
    }, {
      id: 5,
      space: '/assets/images/cgviewer/bim/environment/space-06/back.jpg',
      ground: '/assets/images/cgviewer/bim/environment/ground-06.jpg'
    }, {
      id: 6,
      space: '/assets/images/cgviewer/bim/environment/space-07/back.jpg',
      ground: '/assets/images/cgviewer/bim/environment/ground-07.jpg'
    }, // {
    //   space: '/assets/images/cgviewer/bim/environment/space-08/back.jpg',
    //   ground: '/assets/images/cgviewer/bim/environment/ground-08.jpg',
    // },
    {
      id: 7,
      image: '/assets/images/cgviewer/bim/environment/bg-empty.jpg',
      empty: true
    }];
    vm.theme = vm.themes[0];
    vm.isEdited = false;
    $scope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (!toState.redirectTo && vm.isEdited) {
        event.preventDefault();
        $uibModal.open({
          animation: true,
          component: 'alertModal',
          size: 'sm',
          resolve: {
            title: function title() {
              return 'Warning';
            },
            message: function message() {
              return 'You have unsaved edit. Do you want to save?';
            },
            positive: function positive() {
              return 'Save';
            }
          }
        }).result.then(function () {
          save().then(function () {
            $state.go(toState, toParams);
          });
        }, function (reason) {
          if (reason === 'cancel') {
            vm.isEdited = false;
            $state.go(toState, toParams);
          }
        });
      }
    }); // option menu

    function OptionMenu() {
      this.menu = null;

      this.toggle = function (name) {
        this.menu = this.menu === name ? null : name;
      };

      this.isShow = function (name) {
        return this.menu === name;
      };
    }

    vm.optionMenu = {
      isShow: false,
      toggle: function toggle() {
        this.isShow = !this.isShow;

        if (this.isShow) {
          angular.element(".menu-collapse-button").addClass("open");
          angular.element(".option-menu").addClass("active");
        } else {
          angular.element(".menu-collapse-button").removeClass("open");
          angular.element(".option-menu").removeClass("active");
        }
      },
      close: function close() {
        this.isShow = false;
        angular.element(".menu-collapse-button").removeClass("open");
        angular.element(".option-menu").removeClass("active");
      },
      main: new OptionMenu(),
      model: new OptionMenu()
    };
    vm.issueMenu = {
      isShow: false,
      toggle: function toggle() {
        angular.element("#registration-menu").removeClass("active");
        angular.element("#collision-menu").removeClass("active");
        this.isShow = !this.isShow;

        if (this.isShow) {
          angular.element("#issue-menu").addClass("active");
        } else {
          angular.element("#issue-menu").removeClass("active");
        }
      },
      close: function close() {
        this.isShow = false;
        angular.element("#issue-menu").removeClass("active");
      }
    };
    vm.registrationMenu = {
      isShow: false,
      toggle: function toggle() {
        angular.element("#issue-menu").removeClass("active");
        angular.element("#collision-menu").removeClass("active");
        this.isShow = !this.isShow;

        if (this.isShow) {
          angular.element("#registration-menu").addClass("active");
        } else {
          angular.element("#registration-menu").removeClass("active");
        }
      },
      close: function close() {
        this.isShow = false;
        angular.element("#registration-menu").removeClass("active");
      }
    };
    vm.collisionMenu = {
      isShow: false,
      toggle: function toggle() {
        angular.element("#issue-menu").removeClass("active");
        angular.element("#registration-menu").removeClass("active");
        this.isShow = !this.isShow;

        if (this.isShow) {
          angular.element("#collision-menu").addClass("active");
        } else {
          angular.element("#collision-menu").removeClass("active");
        }
      },
      close: function close() {
        this.isShow = false;
        angular.element("#collision-menu").removeClass("active");
      }
    };

    if ($stateParams && $stateParams.id) {
      angular.element("#initial_loading_popup").show();
      Promise.all([apiFactory.get3dModel($stateParams.id), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getWorkLevelAndTypes(), apiFactory.getCalcSheet(vm.projectId), apiFactory.listInventories($stateParams.id)]).then(function (resp) {
        var model = resp[0].data.data;
        vm.modelId = model._id;
        vm.title = utils.changeExtension(model.name, "ifc");
        vm.thumbnail = model.thumbnail;
        vm.description = model.description;
        vm.location = model.location;
        vm.gisTransformData = model.gisTransformData;
        vm.materials = resp[1].data.list;
        vm.comboMaterials = resp[2].data.list;
        vm.equipments = resp[3].data.list;
        vm.comboEquipments = resp[4].data.list;

        if (resp[5].data.data) {
          vm.workLevels = resp[5].data.data.workLevels;
          vm.workTypes = resp[5].data.data.workTypes;
        }

        if (resp[6].data.data) {
          vm.sections = resp[6].data.data.levels;
        }

        var inventories = resp[7].data.list;
        refactorInventories(inventories);
        $scope.isLoading = false;
        load3dViewer(model, inventories);
      })["catch"](function (e) {
        $log.error(e);
        angular.element("#initial_loading_popup").hide();
        Notification.error("Error occurred during load data.");
      });
    }

    vm.gotoHome = function () {
      $state.go('bimGrid');
    };

    vm.backtoHome = function () {
      $scope.isShowGisMap = false;
      vm.viewer.viewer.addBimModel(vm.bimModel);
    };

    vm.gotoGIS = function () {
      $scope.isShowGisMap = true;
      vm.viewer.viewer.removeBimModel(vm.bimModel);
      vm.injectGis();
    };

    vm.save = function () {
      if (vm.viewer && vm.viewer.isModelFull()) {
        saveCollision();
      } else {
        save();
      }
    };

    vm.gotoCalc = function () {
      syncDataToCalculation();
    };

    vm.openPDF = function () {
      var modal = $uibModal.open({
        animation: true,
        component: 'openPdfModal',
        windowClass: 'open-pdf-modal'
      });
      modal.result.then(function (result) {
        if (vm.viewer) {
          vm.viewer.newBimPlan({
            name: result.name,
            data: result.imageData.image,
            size: result.imageData.size,
            pdfData: result.pdf
          });
        }

        vm.pdfUrl = result.pdfUrl;
        vm.assetId = result.assetId;
        vm.optionMenu.close();
        vm.pdf = result.file;
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.deleteBimPlan = function (plan) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        if (plan.id) {
          apiFactory.deletePlan(plan.id).then(function () {
            vm.viewer.removeBimPlan(plan);
            Notification.success('Plan deleted successfully.');
          })["catch"](function (err) {
            $log.error(err);
          });
        } else {
          vm.viewer.removeBimPlan(plan);
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.setColor = function (color) {
      if (vm.viewer) vm.viewer.setFillColor(color);
    };

    vm.setTexture = function (texture) {
      if (vm.viewer) {
        vm.viewer.setCurrentTexture(texture);
      }
    };

    vm.flipTexture = function () {
      if (vm.viewer) {
        vm.viewer.flipTexture();
      }
    };
    /**Status bar section */


    vm.unit = 'm';
    vm.statusData = {
      pos: '',
      info: ''
    };
    vm.statusDisplayData = {
      pos: '',
      info: ''
    };

    function updateStatusData(pos) {
      if (pos) {
        vm.statusData.pos = pos.clone();
      } else {
        vm.statusData.pos = undefined;
      }

      if (vm.statusData.pos) {
        vm.statusDisplayData.pos = getDisplayPosData(vm.statusData.pos);
      } else {
        vm.statusDisplayData.pos = {
          x: '',
          y: '',
          z: ''
        };
      }

      $timeout(function () {
        $scope.$apply();
      });
    }

    function getDisplayPosData(pos) {
      var data = {};
      var scale = 1;
      var decimal = 4;

      if (vm.unit === 'cm') {
        scale = 100;
        decimal = 2;
      } else if (vm.unit === 'mm') {
        scale = 1000;
        decimal = 0;
      } else if (vm.unit === 'inch') {
        scale = 39.37;
        decimal = 2;
      }

      data.x = utils.roundNumber(pos.x * scale, decimal);
      data.y = utils.roundNumber(pos.y * scale, decimal);
      data.z = utils.roundNumber(pos.z * scale, decimal);
      return data;
    }

    function updateStatusDataForBim(object) {
      var scale = 1;
      var decimal = 4;

      if (vm.unit === 'cm') {
        scale = 100;
        decimal = 2;
      } else if (vm.unit === 'mm') {
        scale = 1000;
        decimal = 0;
      } else if (vm.unit === 'inch') {
        scale = 39.37;
        decimal = 2;
      }

      var info = object.getGeometricalFaceInfo(false);
      var pos = {
        x: info.x,
        y: info.y,
        z: info.z
      };
      vm.statusDisplayData.pos = getDisplayPosData(pos);

      if (object.isSelected) {
        vm.statusDisplayData.info.width = utils.roundNumber(info.face.width * scale, decimal);
        vm.statusDisplayData.info.height = utils.roundNumber(info.face.height * scale, decimal);
        vm.statusDisplayData.info.area = utils.roundNumber(info.area * scale, decimal);
      } else {
        vm.statusDisplayData.info.width = 0;
        vm.statusDisplayData.info.height = 0;
        vm.statusDisplayData.info.area = 0;
      }

      if (vm.propertyIndicator.bimObjects) {
        var objectInfo = {
          materials: [],
          width: 0,
          height: 0,
          length: 0,
          perimeter: 0,
          area: 0,
          volume: 0,
          unit: 'm'
        };

        for (var i = 0; i < vm.propertyIndicator.bimObjects.length; i++) {
          var bimObject = vm.propertyIndicator.bimObjects[i];
          if (bimObject.id === object.id) continue;

          var _info = bimObject.getGeometricalFaceInfo(false);

          objectInfo.width = _info.face.width;
          objectInfo.height = _info.face.height;
          var size_items = [_info.size.x, _info.size.y, _info.size.z];
          var face_items = [_info.face.width, _info.face.height];

          for (var _i = 0, _size_items = size_items; _i < _size_items.length; _i++) {
            var item = _size_items[_i];

            if (face_items.indexOf(item) === -1) {
              objectInfo.length = item;
              break;
            }
          }

          objectInfo.area = _info.area;
          vm.statusDisplayData.info.width = utils.roundNumber(objectInfo.width * scale, decimal);
          vm.statusDisplayData.info.height = utils.roundNumber(objectInfo.height * scale, decimal);
          vm.statusDisplayData.info.area += utils.roundNumber(objectInfo.area * scale, decimal);
        }
      }

      applyData();
    }
    /**End of Status bar section */


    vm.onChangeUnit = function () {
      vm.viewer.updateCurrentUnit(vm.unit);

      if (vm.bimObject) {
        updateStatusDataForBim(vm.bimObject);
      }
    };

    vm.selectedBimPlan = undefined;

    function showPlanControlMark(bimPlan, position) {
      vm.selectedBimPlan = bimPlan;
      var bimPlanControl = angular.element('#bim-plan-control');
      bimPlanControl.css('left', position.x + 'px');
      bimPlanControl.css('top', position.y + 'px');
      bimPlanControl.show();
    }

    function hidePlanControlMark() {
      vm.selectedBimPlan = undefined;
      angular.element('#bim-plan-control').hide();
    }

    vm.confirmBimPlan = function () {
      if (!vm.selectedBimPlan) return;
      $uibModal.open({
        animation: true,
        component: 'selectLevelModal',
        windowClass: 'bim-select-level-modal',
        resolve: {
          bimModel: function bimModel() {
            return vm.bimModel;
          }
        }
      }).result.then(function (result) {
        var bimPlan = vm.selectedBimPlan;
        bimPlan.workLevel = result;
        var data = bimPlan.getSaveData();
        data.modelId = vm.modelId;
        data.projectId = vm.projectId;

        if (!utils.isEmpty(data.image) && !utils.isServerURL(data.image)) {
          data.image = utils.makeBlob(data.image);
        }

        if (utils.isPdfFile(vm.pdf)) {
          data.pdf = vm.pdf;
        }

        if (!utils.isEmpty(vm.pdfUrl) && utils.isServerURL(vm.pdfUrl)) {
          data.pdf = vm.pdfUrl;
        }

        if (!utils.isEmpty(vm.assetId)) {
          data.assetId = vm.assetId;
        }

        apiFactory.createPlan(data).then(function (resp) {
          bimPlan.id = resp.data.data._id;
          Notification.success('Plan saved successfully.');
        })["catch"](function (err) {
          $log.error(err);
        });
        vm.viewer.completeBimPlan(bimPlan);
        hidePlanControlMark();
      }, function () {});
    };

    vm.removeBimPlan = function () {
      if (vm.selectedBimPlan) {
        vm.viewer.removeBimPlan(vm.selectedBimPlan);
        vm.selectedBimPlan = undefined;
      }

      hidePlanControlMark();
    };

    vm.onSelectObject = function (bimObject) {
      vm.viewer.selectBimObject(bimObject);
    }; // $scope.toolbarList = [
    //   {id: 'select',          icon: "drawing-select.svg", description: "Select"},
    //   {id: 'pan',             icon: "pan-move.svg", description: "Pan move"},
    //   {id: 0,                 icon: "drawing-measure.svg", description: "Measure", submenu: [
    //     {id: 'commonlength',  icon: "drawing-measure-dist.svg", description: "Measure distance"},
    //     {id: 'angle',         icon: "drawing-measure.svg", description: "Measure angle"},
    //     {id: 'circumference', icon: "drawing-36.svg", description: "Measure circumference"},
    //     {id: 'diameter',      icon: "drawing-37.svg", description: "Measure diameter"},
    //     {id: 'sameplane',     icon: "drawing-41.svg", description: "Measure same plane"},
    //     {id: 'totalarea',     icon: "drawing-42.svg", description: "Measure area"}
    //   ]},
    //   {id: 'paint',          icon: "drawing-paint.svg", description: "Fill bucket"},
    //   {id: 'text',          icon: "drawing-text.svg", description: "Draw text"},
    //   {id: 0,                 icon: "cross.svg", description: "Cross section", submenu: [
    //     {id: 'addCross',          icon: "cross-add.svg", description: "Add cross section"},
    //     {id: 'visibleCross',         icon: "cross-visible.svg", description: "Show cross section"},
    //     {id: 'applyCross',        icon: "cross-apply.svg", description: "Apply cross section"},
    //   ]},
    //   {id: 'camera',          icon: "drawing-3d-camera.svg", description: "Take screenshot"}
    // ];


    $scope.toolbarList = {
      moveTools: [{
        id: 'select',
        icon: "drawing-select.svg",
        description: "Select"
      }, {
        id: 'pan',
        icon: "pan-move.svg",
        description: "Pan move"
      }, {
        id: 'paint',
        icon: "drawing-paint.svg",
        description: "Fill bucket"
      }, {
        id: 'camera',
        icon: "drawing-3d-camera.svg",
        description: "Take screenshot"
      }],
      drawingTools: [{
        id: 'commonlength',
        icon: "drawing-measure-dist.svg",
        description: "Measure distance"
      }, {
        id: 'angle',
        icon: "drawing-measure.svg",
        description: "Measure angle"
      }, {
        id: 'circumference',
        icon: "drawing-36.svg",
        description: "Measure circumference"
      }, {
        id: 'diameter',
        icon: "drawing-37.svg",
        description: "Measure diameter"
      }, {
        id: 'sameplane',
        icon: "drawing-41.svg",
        description: "Measure same plane"
      }, {
        id: 'totalarea',
        icon: "drawing-42.svg",
        description: "Measure area"
      }, {
        id: 'text',
        icon: "drawing-text.svg",
        description: "Draw text"
      }, {
        id: 'addCross',
        icon: "cross-add.svg",
        description: "Add cross section"
      }, {
        id: 'visibleCross',
        icon: "cross-visible.svg",
        description: "Show cross section"
      }, {
        id: 'applyCross',
        icon: "cross-apply.svg",
        description: "Apply cross section"
      }]
    };

    vm.toolbarEvent = function (id) {
      if (!vm.viewer) return;

      switch (id) {
        case 'select':
          vm.viewer.setDragAction('picker');
          vm.viewer.setCursor('default');
          break;

        case 'pan':
          vm.viewer.setDragAction('pan');
          vm.viewer.setCursor('position', true, true);
          break;

        case 'commonlength':
        case 'angle':
        case 'circumference':
        case 'diameter':
        case 'volume':
        case 'sameplane':
        case 'totalarea':
          vm.viewer.newDimensions(id);
          break;

        case 'paint':
          vm.viewer.newPaint();
          break;

        case 'text':
          vm.textBrush.show = true;
          vm.viewer.newText();
          break;

        case 'addCross':
          vm.viewer.onAddCrossSection();
          break;

        case 'visibleCross':
          vm.viewer.onVisibleCrossSection();
          break;

        case 'applyCross':
          vm.viewer.onApplyCrossSection();
          break;

        case 'camera':
          vm.viewer.takeScreenshot();
          break;
      }
    };

    vm.showColorPicker = function (_item) {
      $uibModal.open({
        animation: true,
        component: 'modelColorModal',
        windowClass: 'bim-model-color-modal',
        resolve: {
          item: function item() {
            return _item;
          }
        }
      }).result.then(function (result) {
        vm.bimModel.setItemColor(result.item, result.color);
        vm.viewer.invalidate();
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.getModelItemColor = function (item) {
      return {
        'background-color': item.color ? item.color : 'transparent'
      };
    };

    vm.themeSelected = function (theme) {
      vm.viewer.setTheme(theme);
      vm.isEdited = true;
    };

    vm.qualityChanged = function (quality) {
      vm.viewer.setQuality(quality.value);
    };

    vm.colorModeChanged = function (color) {
      vm.viewer.setColorMode(color.value);
    };

    vm.selectModeChanged = function (facemode) {
      vm.viewer.setSelectMode(facemode.value);
    }; // view mode functions


    vm.enterDefaultMode = function () {
      vm.mode = 'default';
      vm.viewer.setCameraMode('default');
      applyData();
    };

    vm.enterPlanMode = function (plan) {
      vm.mode = 'plan';
      vm.viewer.setCameraMode('default');
      vm.bimPlanNeedShow = plan;
      applyData();
    };

    vm.enterGameMode = function () {
      vm.mode = 'game';
      vm.viewer.setCameraMode('walk');
      hidePlanControlMark();
      var documentElement = $document[0].documentElement;

      if (documentElement.addEventListener) {
        documentElement.addEventListener('webkitfullscreenchange', exitHandler, false);
        documentElement.addEventListener('mozfullscreenchange', exitHandler, false);
        documentElement.addEventListener('MSFullscreenChange', exitHandler, false);
      }

      var rfs = documentElement.requestFullScreen || documentElement.webkitRequestFullScreen || documentElement.mozRequestFullScreen;
      rfs.call(documentElement);

      function exitHandler() {
        if ($document[0].fullscreen === false) {
          if (documentElement.removeEventListener) {
            documentElement.removeEventListener('webkitfullscreenchange', exitHandler, false);
            documentElement.removeEventListener('mozfullscreenchange', exitHandler, false);
            documentElement.removeEventListener('MSFullscreenChange', exitHandler, false);
          }

          vm.enterDefaultMode();
        }
      }

      applyData();
    };

    vm.enterWalkMode = function () {
      vm.mode = 'walk';
      vm.viewer.setCameraMode('walk');
      hidePlanControlMark();
    };

    vm.onWalkControlEvent = function (dir) {
      vm.viewer.changeWalkCameraControl(dir);
    };

    vm.onShowPlan = function (bimPlan) {
      vm.mode = 'default';
      $timeout(function () {
        $scope.$apply();
        vm.viewer.showBimPlan(bimPlan);
      });
    };

    vm.contentEdited = function () {
      vm.isEdited = true;
    };

    vm.exportPlan = function (item) {
      $uibModal.open({
        animation: true,
        component: 'planModal',
        windowClass: 'bim-plan-modal',
        resolve: {
          bimModel: function bimModel() {
            return vm.bimModel;
          },
          floor: function floor() {
            return item;
          }
        }
      }).result.then(function () {}, function (reason) {
        $log.log(reason);
      });
    };

    vm.exportSemiPlan = function (item) {
      $uibModal.open({
        animation: true,
        component: 'semiPlanModal',
        windowClass: 'bim-semi-plan-modal',
        resolve: {
          bimModel: function bimModel() {
            return vm.bimModel;
          },
          floor: function floor() {
            return item;
          }
        }
      }).result.then(function () {}, function (reason) {
        $log.log(reason);
      });
    };

    vm.changeTextInfo = function (type, value) {
      if (type && value) {
        vm.viewer.changeTextInfo(type, value);
      }
    };

    vm.onChangeTextFillColor = function (color) {
      vm.viewer.changeTextInfo('fill', color);
    };

    vm.onChangeTextStrokeColor = function (color) {
      vm.viewer.changeTextInfo('stroke', color);
    };

    vm.assignMaterial = function (item) {
      var bimObjects = vm.bimModel.getBimObjectsFrom(item);
      $uibModal.open({
        animation: true,
        component: 'objectInventoriesModal',
        windowClass: 'object-inventories-modal-window',
        backdropClass: 'object-inventories-modal-backdrop',
        resolve: {
          objects: function objects() {
            return bimObjects;
          },
          unit: function unit() {
            return vm.unit;
          },
          isThree: function isThree() {
            return true;
          },
          baseData: function baseData() {
            return {
              materials: vm.materials,
              dcps: vm.comboMaterials,
              equipments: vm.equipments,
              dcqs: vm.comboEquipments,
              workTypes: vm.workTypes,
              sections: vm.sections
            };
          },
          isBlockMode: function isBlockMode() {
            return true;
          }
        }
      }).result.then(function () {
        vm.viewer.invalidate();
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.toggleSelected = function (item) {
      vm.viewer.toggleModelItemSelected(vm.bimModel, item);
    };

    function refactorInventories(inventories) {
      inventories.forEach(function (inventory) {
        // if (inventory.section) {
        //   let section = vm.sections.find(s => s._id === inventory.section);
        //   inventory.section = section ? section._id : undefined;
        // }
        if (inventory.materials) {
          inventory.materials.forEach(function (mat) {
            var material = vm.materials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
            }
          });
        }

        if (inventory.dcps) {
          inventory.dcps.forEach(function (mat) {
            var material = vm.comboMaterials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
              mat.comboMaterialList = material.comboMaterialList;
            }
          });
        }
      });
    }

    function load3dViewer(data, inventories) {
      vm.viewer = Bim.mainViewer(angular.element("#bimviewer")[0]);
      vm.viewer.create();
      vm.viewer.setInputMethod(vm.companyData.companyInputMethod === 'European et al.' ? 'eu' : 'en');
      vm.bimData = vm.viewer.getBimData();
      vm.viewer.on('objectSelected', onObjectSelected);
      vm.viewer.on('textSelected', onTextSelected);
      vm.viewer.on('textDeselected', onTextDeselected);
      vm.viewer.on('showContextMenu', onShowContextMenu);
      vm.viewer.on('updateStatusData', updateStatusData);
      vm.viewer.on('objectDblClicked', onBimObjectDblClicked);
      vm.viewer.on('thumbnailReady', onThumbnailReady);
      vm.viewer.on('planAdded', applyData);
      vm.viewer.on('planTransformReady', showPlanControlMark);
      vm.viewer.on('cameraZoomChanged', function (zoom) {
        vm.zoomLevel = zoom;
      });
      vm.viewer.on('requestShowPlan', applyData);
      vm.viewer.on('toolActivated', onToolActivated);
      $scope.applyTexture = false;
      $scope.showPlan = false;
      vm.statusDisplayData.pos = {
        x: '',
        y: '',
        z: ''
      };
      vm.statusDisplayData.info = {
        area: '',
        width: '',
        height: ''
      };
      vm.textBrush = vm.viewer.textBrush;

      if (data.viewer) {
        vm.theme = vm.themes[data.viewer.theme];
        vm.viewer.setTheme(vm.theme);
      }

      vm.viewer.loadBim(data).then(function (bimModel) {
        angular.element("#initial_loading_popup").hide();
        vm.bimModel = bimModel;
        vm.productList = Object.values(vm.bimModel.objectMap);
        vm.bimModel.setInventoryData(inventories);
        vm.modelInfo = {
          bimModel: bimModel,
          location: vm.location,
          gisTransformData: vm.gisTransformData
        };
        applyData();
      })["catch"](function (err) {
        $log.error(err);
        angular.element("#initial_loading_popup").hide();
        Notification.error('IFC file cannot open.');
      });
    }

    function onObjectSelected(object, objects) {
      hidePlanControlMark();

      if (angular.isDefined(object) && (object.isSelected || objects.length >= 1)) {
        vm.bimObject = object;
        vm.propertyIndicator.bimObjects = objects;
        updateStatusDataForBim(vm.bimObject);
      } else {
        vm.bimObject = undefined;
        vm.propertyIndicator.bimObjects = undefined;
        vm.statusDisplayData.info = {
          area: '',
          width: '',
          height: ''
        };
        applyData();
      }
    }

    function onTextSelected(data) {
      vm.textBrush = {
        show: true,
        text: data.text,
        fontSize: data.fontSize,
        fontStyle: data.fontStyle,
        fontFamily: data.fontFamily,
        strokeColor: data.strokeColor,
        fillColor: data.fillColor,
        strokeWidth: data.strokeWidth
      };
      applyData();
    }

    function onTextDeselected() {
      vm.textBrush = vm.viewer.textBrush;
      applyData();
    }

    function onShowContextMenu(bimObject, objects, pos) {
      vm.propertyIndicator.show = true;
      vm.propertyIndicator.bimObjects = objects;
      vm.propertyIndicator.pos = pos;
      $timeout(function () {
        $scope.$apply();
      });
    }

    function onBimObjectDblClicked(bimObject, objects, pos) {
      vm.propertyIndicator.show = true;
      vm.propertyIndicator.bimObjects = objects;
      vm.propertyIndicator.pos = pos;
      $timeout(function () {
        $scope.$apply();
      });
    }

    function onThumbnailReady(thumbnail) {
      if (vm.modelId) {
        apiFactory.update3dThumbnail({
          modelId: vm.modelId,
          thumbnail: thumbnail
        }).then(function () {
          Notification.success("Model Thumbnail has updated!");
        })["catch"](function (err) {
          Notification.error("Model Thumbnail has failed!");
          $log.error(err);
        });
      }
    }

    function onToolActivated(type) {
      if (vm.textBrush) {
        vm.textBrush.show = type === 'text2d';
        applyData();
      }
    }

    function applyData() {
      $timeout(function () {
        return $scope.$apply();
      });
    }

    function syncDataToCalculation() {
      var calcData = vm.viewer.exportCalculationData(vm.sections);

      if (!calcData) {
        Notification.error("There is no calculation data in model.");
      }

      apiFactory.syncViewerToCalc({
        projectId: vm.projectId,
        modelId: vm.modelId,
        modelName: vm.title,
        modelType: "3d",
        data: calcData
      }).then(function () {
        Notification.success("Calculation data saved.");

        if (vm.bimModel) {
          save().then(function () {
            return $state.go('calcMain');
          });
        } else {
          $state.go('calcMain');
        }
      })["catch"](function (e) {
        $log.log(e);
        Notification.error("Calculation data cannot be saved.");
      });
    }

    function save() {
      return new Promise(function (resolve, reject) {
        var inventoryData = vm.bimModel.getInventoryData();
        var treeData = vm.bimModel.rebuildTree();
        var cameraData = vm.viewer.getCameraData();
        var theme = vm.viewer.getTheme();
        Promise.all([apiFactory.saveInventories({
          project: vm.projectId,
          modelId: vm.modelId,
          inventories: inventoryData
        }), apiFactory.update3dModel({
          modelId: vm.modelId,
          tree: treeData,
          description: vm.description,
          thumbnail: vm.thumbFile,
          location: vm.location,
          gisTransformData: vm.gisTransformData,
          viewer: {
            camera: cameraData,
            theme: theme
          }
        })]).then(function () {
          Notification.success("Data saved successfully.");
          vm.thumbFile = undefined;
          vm.isEdited = false;
          resolve();
        })["catch"](function (err) {
          $log.error(err);
          Notification.error("Data save failed.");
          reject(err);
        });
      });
    }

    function saveCollision() {
      var positions = vm.viewer.getModelsPosition();
      apiFactory.update3dModelPositions({
        positions: positions
      }).then(function () {
        Notification.success('Collision saved successfully.');
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Data save failed.");
      });
    }

    vm.gisCallBack = function (type, data) {
      switch (type) {
        case 'home':
          $scope.isShowGisMap = false;
          vm.viewer.viewer.addBimModel(vm.bimModel);
          break;

        case 'save':
          vm.gisTransformData = data;
          save();
          break;

        default:
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('scheduleModal', {
    controller: ScheduleModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calendar/modals/scheduleModal/scheduleModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function ScheduleModal($scope, $uibModal, $log, apiFactory, NgMap, utils, Notification) {
    var vm = this;
    $scope.types = Constants.ScheduleTypeList;
    $scope.EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    $scope.calendars = [{
      _id: 0,
      name: 'Teams',
      children: [{
        _id: 0,
        name: $scope.types[0].label
      }, {
        _id: 1,
        name: $scope.types[1].label
      }, {
        _id: 2,
        name: $scope.types[2].label
      }, {
        _id: 3,
        name: $scope.types[3].label
      }, {
        _id: 4,
        name: $scope.types[4].label
      }]
    }, {
      _id: 1,
      name: 'Designation',
      children: [{
        _id: 0,
        name: $scope.types[5].label
      }, {
        _id: 1,
        name: $scope.types[6].label
      }]
    }];
    vm.eventCategoryId1 = 0;
    vm.eventCategoryId2 = 0;
    vm.isRepeat = false;
    vm.isPrivate = false; // vm.managers = [];

    vm.employees = [];

    vm.$onInit = function () {
      var members = vm.resolve.members; // vm.managers.pushAll(members.managers);

      vm.employees.pushAll(members.employees);
      $scope.currentDesignation = 'Employee';
      vm.users = vm.employees;
      $scope.id = vm.resolve.id;

      if ($scope.id) {
        $scope.loading = true;
        apiFactory.getSchedule($scope.id).then(function (res) {
          $scope.loading = false;
          vm.schedule = res.data.data;
          vm.eventCategoryId1 = parseInt(vm.schedule.type / 5);
          vm.eventCategoryId2 = vm.schedule.type % 5;
          vm.schedule.fromDate = new Date(vm.schedule.startDate);
          vm.schedule.fromDate.setHours(0, 0, 0, 0);
          vm.schedule.fromTime = new Date(vm.schedule.startDate);
          vm.schedule.toDate = new Date(vm.schedule.endDate);
          vm.schedule.toDate.setHours(0, 0, 0, 0);
          vm.schedule.toTime = new Date(vm.schedule.endDate);
          var schedule_members = [];
          schedule_members.pushAll(vm.schedule.members);
          vm.schedule.members.length = 0;
          schedule_members.forEach(function (member) {
            var users = vm.employees;
            var findIndex = users.findIndex(function (elem) {
              return elem.memberId === member.memberId;
            });

            if (findIndex !== -1) {
              vm.schedule.members.push(users[findIndex]);
              users.splice(findIndex, 1);
            }
          });
        })["catch"](function (error) {
          $log.error(error);
          $scope.loading = false;
        });
      } else {
        vm.schedule = {
          type: $scope.types[0].key,
          members: []
        };
      }
    };

    vm.close = function (memberId) {
      //const findIndex = vm.users.findIndex(elem => elem.memberId === memberId);
      var findIndex = vm.schedule.members.findIndex(function (elem) {
        return elem.memberId === memberId;
      });

      if (findIndex !== -1) {
        vm.users.push(vm.schedule.members[findIndex]);
        vm.schedule.members.splice(findIndex, 1);
      }
    };

    $scope.$watch('currentDesignation', function () {
      switch ($scope.currentDesignation) {
        case 'Manager':
          //vm.users = vm.managers;
          break;

        case 'Employee':
          vm.users = vm.employees;
          break;

        default:
          vm.users = [];
          break;
      }
    });

    $scope.onCancel = function () {
      // vm.schedule = {
      //   type: $scope.types[0].key,
      //   members: []
      // };
      vm.modalInstance.dismiss('cancel');
    };

    $scope.addAttendee = function () {
      if (!vm.select_user) {
        Notification.error("Please select user.");
        return;
      }

      var findIndex = vm.users.findIndex(function (elem) {
        return elem.memberId === vm.select_user;
      });

      if (findIndex !== -1) {
        vm.schedule.members.push(vm.users[findIndex]);
        vm.users.splice(findIndex, 1);
      }

      vm.select_user = null;
    };

    $scope.onSave = function () {
      if (angular.isUndefined(vm.schedule.name) || vm.schedule.name.trim() === '') {
        Notification.error("Please enter title");
        return;
      }

      if (angular.isUndefined(vm.schedule.fromDate)) {
        Notification.error("Please enter start date");
        return;
      }

      if (angular.isUndefined(vm.schedule.fromTime)) {
        Notification.error("Please enter start time");
        return;
      }

      if (angular.isUndefined(vm.schedule.toDate)) {
        Notification.error("Please enter end date");
        return;
      }

      if (angular.isUndefined(vm.schedule.toTime)) {
        Notification.error("Please enter end time");
        return;
      }

      vm.schedule.startDate = new Date();
      vm.schedule.startDate.setFullYear(vm.schedule.fromDate.getFullYear(), vm.schedule.fromDate.getMonth(), vm.schedule.fromDate.getDate());
      vm.schedule.startDate.setHours(vm.schedule.fromTime.getHours(), vm.schedule.fromTime.getMinutes(), vm.schedule.fromTime.getSeconds(), vm.schedule.fromTime.getMilliseconds());
      vm.schedule.endDate = new Date();
      vm.schedule.endDate.setFullYear(vm.schedule.toDate.getFullYear(), vm.schedule.toDate.getMonth(), vm.schedule.toDate.getDate());
      vm.schedule.endDate.setHours(vm.schedule.toTime.getHours(), vm.schedule.toTime.getMinutes(), vm.schedule.toTime.getSeconds(), vm.schedule.toTime.getMilliseconds());

      if (vm.schedule.startDate >= vm.schedule.endDate) {
        Notification.error("End time must be grater than start time");
        return;
      }

      vm.schedule.type = vm.eventCategoryId1 * 5 + vm.eventCategoryId2;
      var payload = angular.fromJson(angular.toJson(vm.schedule));
      payload.members = payload.members.map(function (x) {
        return {
          memberId: x.memberId,
          role: x.role
        };
      });
      delete payload.fromDate;
      delete payload.fromTime;
      delete payload.toDate;
      delete payload.toTime;
      $scope.loading = true;
      var endpoint = $scope.id ? 'updateSchedule' : 'createSchedule';
      apiFactory[endpoint](payload).then(function (res) {
        $scope.loading = false;
        Notification.success("Schedule has been saved successfully");
        vm.modalInstance.close(res.data.data);
      })["catch"](function (error) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(error, 'Failed to save schedule'));
      });
    };

    $scope.onDelete = function () {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function (result) {
        if (result) {
          $scope.loading = true;
          apiFactory.deleteSchedule($scope.id).then(function () {
            $scope.loading = false;
            vm.modalInstance.close();
            Notification.success('Event has been deleted successfully');
          })["catch"](function () {
            $scope.loading = false;
            Notification.error('Something went wrong try later');
          });
        }
      });
    };

    $scope.getEventTypeColor = function (key) {
      var color = "--".concat($scope.types[key].key, "-color");
      var result = {};
      result[color] = $scope.types[key].textColor;
      return result;
    };
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('saveEventModal', {
    controller: saveEventModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calendar/modals/saveEventModal/saveEventModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function saveEventModal($scope, Notification, $log, apiFactory, NgMap, globals, utils) {
    var vm = this;
    vm.utils = utils;
    var projectData = globals.projectStore.get();
    vm.addedFiles = [];
    vm.removedFiles = [];
    $scope.types = Constants.EventTypeList;
    $scope.EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    vm.gmap = {
      url: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&libraries=places",
      markers: [],
      styles: [],
      center: "41,-87",
      zoom: 3
    };
    NgMap.getMap("service_map").then(function (map) {
      vm.map = map;
      map.setOptions({
        styles: vm.gmap.styles,
        disableDefaultUI: true,
        mapTypeControl: true,
        mapTypeId: 'satellite',
        zoomControl: true,
        zoom: 1,
        center: {
          lat: 0,
          lng: 0
        }
      });
    });
    $scope.calendars = [{
      _id: 0,
      name: 'My Calendars',
      children: [{
        _id: 0,
        name: $scope.types[0].label
      }, {
        _id: 1,
        name: $scope.types[1].label
      }, {
        _id: 2,
        name: $scope.types[2].label
      }, {
        _id: 3,
        name: $scope.types[3].label
      }]
    }, {
      _id: 1,
      name: 'Other Calendars',
      children: [{
        _id: 0,
        name: $scope.types[4].label
      }, {
        _id: 1,
        name: $scope.types[5].label
      }]
    }];
    vm.eventCategoryId1 = 0;
    vm.eventCategoryId2 = 0;
    $scope.repeatTypes = [{
      _id: 1,
      name: 'Daily'
    }, {
      _id: 2,
      name: 'Weekly'
    }, {
      _id: 3,
      name: 'Monthly'
    }, {
      _id: 4,
      name: 'Yearly'
    }];
    $scope.repeatType = 1;
    $scope.repeatDays = [{
      _id: 0,
      value: 1
    }, {
      _id: 1,
      value: 2
    }, {
      _id: 2,
      value: 3
    }, {
      _id: 3,
      value: 4
    }, {
      _id: 4,
      value: 5
    }];
    vm.everyWeekday = false;
    $scope.months = [{
      _id: 0,
      value: 'January'
    }, {
      _id: 1,
      value: 'Feburary'
    }, {
      _id: 2,
      value: 'March'
    }, {
      _id: 3,
      value: 'April'
    }, {
      _id: 4,
      value: 'May'
    }, {
      _id: 5,
      value: 'June'
    }, {
      _id: 6,
      value: 'July'
    }, {
      _id: 7,
      value: 'August'
    }, {
      _id: 8,
      value: 'September'
    }, {
      _id: 9,
      value: 'October'
    }, {
      _id: 10,
      value: 'November'
    }, {
      _id: 11,
      value: 'December'
    }];
    $scope.nths = [{
      _id: 0,
      value: 'First'
    }, {
      _id: 1,
      value: 'Second'
    }, {
      _id: 2,
      value: 'Third'
    }, {
      _id: 3,
      value: 'Fourth'
    }, {
      _id: 4,
      value: 'Last'
    }];
    $scope.weekdays = [{
      _id: 0,
      value: 'Sunday',
      checked: true
    }, {
      _id: 1,
      value: 'Monday',
      checked: false
    }, {
      _id: 2,
      value: 'Tuesday',
      checked: false
    }, {
      _id: 3,
      value: 'Wednesday',
      checked: false
    }, {
      _id: 4,
      value: 'Thursday',
      checked: false
    }, {
      _id: 5,
      value: 'Friday',
      checked: false
    }, {
      _id: 6,
      value: 'Saturday',
      checked: false
    }];
    var today = new Date();
    $scope.month = today.getMonth();
    $scope.date = {
      date: 0,
      day: {
        nth: 0,
        weekday: 0
      }
    };
    $scope.days = [];
    var this_year = today.getFullYear();
    var this_month = today.getMonth();

    if (this_month == 11) {
      this_year++;
      this_month = 0;
    } else {
      this_month++;
    }

    var lastdate = new Date(this_year, this_month, 0).getDate();

    for (var i = 0; i < lastdate; i++) {
      var item = {
        value: i + 1
      };
      $scope.days.push(item);
    }

    $scope.date.date = today.getDate();
    $scope.date.day.nth = 0;
    $scope.date.day.weekday = 0;
    vm.isRepeat = false;
    vm.isReminder = false;
    $scope.reminder_time = [{
      _id: 1,
      value: '5 min'
    }, {
      _id: 2,
      value: '15 min'
    }, {
      _id: 3,
      value: '30 min'
    }, {
      _id: 4,
      value: '1 hr'
    }, {
      _id: 5,
      value: '12 hrs'
    }, {
      _id: 6,
      value: '1 day'
    }, {
      _id: 7,
      value: '1 week'
    }];
    $scope.reminder_order = [{
      _id: 1,
      value: 'before'
    }, {
      _id: 2,
      value: 'after'
    }];
    $scope.reminder_gateway = [{
      _id: 1,
      value: 'by email'
    }, {
      _id: 2,
      value: 'by sms'
    }];

    function markCurrentLoc() {
      if (vm.event.location) {
        var placeData = {
          lat: vm.event.location.coordinates[0],
          lng: vm.event.location.coordinates[1]
        };
        vm.gmap.markers = [[placeData.lat, placeData.lng]];
        vm.gmap.zoom = 15;
        vm.gmap.center = "".concat(placeData.lat, ",").concat(placeData.lng);
        vm.address = vm.event.location.position;
      }
    }

    function removeDuplicates(list, id) {
      var index = list.findIndex(function (x) {
        return x._id === id;
      });

      if (index !== -1) {
        list.splice(index, 1);
      }
    }

    vm.$onInit = function () {
      $scope.loading = true;
      vm.event = {
        type: 0,
        listMembers: [],
        files: [],
        isPrivate: false,
        isAllDay: false,
        repeatType: {
          type: 0,
          every: {
            everyWeekday: false,
            value: 0
          },
          weekDays: [],
          month: 0,
          date: {
            date: 1,
            day: {
              nth: 0,
              weekday: 0
            }
          }
        },
        reminder: {
          time: 0,
          order: 0,
          gateway: 0
        }
      };
      Promise.all([apiFactory.fetchInvitedMembersInProject(projectData._id), apiFactory.getAllEmployees()]).then(function (resp) {
        $scope.loading = false;
        var invitedMembers = resp[0].data;
        invitedMembers = invitedMembers.map(function (x) {
          return {
            _id: x.userId._id,
            firstName: x.userId.firstName,
            lastName: x.userId.lastName,
            displayName: x.userId.displayName,
            email: x.userId.email,
            profilePic: x.userId.profilePic,
            designation: x.userId.designation //parent: x.parent

          };
        });
        vm.subcontractorStaffs = invitedMembers.filter(function (x) {
          return x.parentType === 'Subcontractor';
        });
        vm.supplierStaffs = invitedMembers.filter(function (x) {
          return x.parentType === 'Supplier';
        });
        vm.clientStaffs = invitedMembers.filter(function (x) {
          return x.parentType === 'Client';
        });
        vm.managers = invitedMembers.filter(function (x) {
          return x.parentType === 'Manager';
        });
        var employees = resp[1].data.list;
        vm.employees = employees.map(function (x) {
          return {
            _id: x.userId._id,
            firstName: x.userId.firstName,
            lastName: x.userId.lastName,
            displayName: x.userId.displayName,
            email: x.userId.email,
            profilePic: x.userId.profilePic,
            designation: x.userId.designation,
            department: x.userId.department
          };
        });
        $scope.currentDesignation = 'Manager';
        vm.users = vm.managers;

        var _iterator = _createForOfIteratorHelper(vm.supplierStaffs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _item = _step.value;
            vm.users.push(_item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var _iterator2 = _createForOfIteratorHelper(vm.clientStaffs),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item2 = _step2.value;
            vm.users.push(_item2);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        var _iterator3 = _createForOfIteratorHelper(vm.subcontractorStaffs),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item3 = _step3.value;
            vm.users.push(_item3);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        var _iterator4 = _createForOfIteratorHelper(vm.employees),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _item4 = _step4.value;
            vm.users.push(_item4);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
      });
      $scope.id = vm.resolve.id;

      if (angular.isDefined($scope.id)) {
        $scope.loading = true;
        apiFactory.getEvent($scope.id).then(function (res) {
          $scope.loading = false;
          vm.event = res.data.data;

          if (vm.event.repeatType.type != 0 && _typeof(vm.event.repeatType.type) != angular.isUndefined) {
            vm.isRepeat = true;

            if (vm.event.repeatType.type == 2) {
              for (var _i = 0; _i < 7; _i++) {
                $scope.weekdays[_i].checked = false;
              }

              for (var _i2 = 0; _i2 < vm.event.repeatType.weekDays.length; _i2++) {
                $scope.weekdays[vm.event.repeatType.weekDays[_i2]].checked = true;
              }
            }
          }

          if (vm.event.reminder.time != 0) {
            vm.isReminder = true;
          }

          if (angular.isUndefined(vm.event.files)) {
            vm.event.files = [];
          } else {
            vm.event.files = vm.event.files.map(function (x) {
              x.name = x.originalname;
              return x;
            });
          }

          vm.eventCategoryId1 = parseInt(vm.event.type / 4);
          vm.eventCategoryId2 = vm.event.type % 4;
          var fromDate = new Date();
          fromDate.setYear(new Date(vm.event.startTime).getYear() + 1900);
          fromDate.setMonth(new Date(vm.event.startTime).getMonth());
          fromDate.setDate(new Date(vm.event.startTime).getDate());
          vm.event.fromDate = fromDate;
          var fromTime = new Date();
          fromTime.setHours(new Date(vm.event.startTime).getHours());
          fromTime.setMinutes(new Date(vm.event.startTime).getMinutes());
          vm.event.fromTime = fromTime;
          var toDate = new Date();
          toDate.setYear(new Date(vm.event.endTime).getYear() + 1900);
          toDate.setMonth(new Date(vm.event.endTime).getMonth());
          toDate.setDate(new Date(vm.event.endTime).getDate());
          vm.event.toDate = toDate;
          var toTime = new Date();
          toTime.setHours(new Date(vm.event.endTime).getHours());
          toTime.setMinutes(new Date(vm.event.endTime).getMinutes());
          vm.event.toTime = toTime;
          markCurrentLoc();
          vm.event.listMembers.forEach(function (member) {
            removeDuplicates(vm.users, member._id);
          });
        })["catch"](function (error) {
          $log.error(error);
          $scope.loading = false;
        });
      }
    };

    $scope.$watch('currentDesignation', function () {
      switch ($scope.currentDesignation) {
        case 'Manager':
          vm.users = vm.managers;
          break;

        case 'Subcontractor':
          vm.users = vm.subcontractorStaffs;
          break;

        case 'Supplier':
          vm.users = vm.supplierStaffs;
          break;

        case 'Client':
          vm.users = vm.clientStaffs;
          break;

        case 'Employee':
          vm.users = vm.employees;
          break;

        default:
          vm.users = [];
          break;
      }
    });

    $scope.onCancel = function () {
      // vm.event = {
      //   type: 'calendar',
      //   listMembers: []
      // };
      vm.modalInstance.dismiss('cancel');
    };

    $scope.addReminder = function () {
      vm.isReminder = !vm.isReminder;

      if (vm.isReminder) {
        vm.event.reminder.time = 1;
        vm.event.reminder.order = 1;
        vm.event.reminder.gateway = 1;
      }
    };

    $scope.closeReminder = function () {
      vm.event.reminder.time = 0;
      vm.event.reminder.order = 0;
      vm.event.reminder.gateway = 0;
      vm.isReminder = false;
    };

    $scope.addAttendee = function () {
      if (!vm.select_user) {
        Notification.error("Please select user.");
        return;
      }

      if ($scope.currentDesignation !== "Other") {
        var find = vm.users.find(function (elem) {
          return elem._id == vm.select_user;
        });
        vm.event.listMembers.push(find);
        var index = vm.users.findIndex(function (x) {
          return x._id === vm.select_user;
        });

        if (index !== -1) {
          vm.users.splice(index, 1);
        }
      } else {// to do
      }

      vm.select_user = null;
    };

    $scope.onChangeRepeatType = function () {
      if (vm.isRepeat) {
        vm.event.repeatType.type = 2;
        vm.event.repeatType.weekDays.push(0);
      } else {
        vm.event.repeatType.type = 0;
      }
    };

    $scope.onChangeMonth = function (month) {
      var today = new Date();
      $scope.days.length = 0;
      var this_year = today.getFullYear();
      var this_month = month;

      if (this_month == 11) {
        this_year++;
        this_month = 0;
      } else {
        this_month++;
      }

      var lastdate = new Date(this_year, this_month, 0).getDate();

      for (var _i3 = 0; _i3 < lastdate; _i3++) {
        var _item5 = {
          value: _i3 + 1
        };
        $scope.days.push(_item5);
      }
    };

    $scope.onChangeWeekday = function () {
      vm.event.repeatType.weekDays.length = 0;

      for (var _i4 = 0; _i4 < 7; _i4++) {
        if ($scope.weekdays[_i4].checked) {
          vm.event.repeatType.weekDays.push(_i4);
        }
      }
    };

    $scope.onSave = function () {
      if (angular.isUndefined(vm.event.name) || vm.event.name.trim() == '') {
        Notification.error("Please enter title");
        return;
      }

      if (angular.isUndefined(vm.event.fromDate)) {
        Notification.error("Please enter start date");
        return;
      }

      if (angular.isUndefined(vm.event.fromTime)) {
        Notification.error("Please enter start time");
        return;
      }

      if (angular.isUndefined(vm.event.toDate)) {
        Notification.error("Please enter end date");
        return;
      }

      if (angular.isUndefined(vm.event.toTime)) {
        Notification.error("Please enter end time");
        return;
      }

      vm.event.startTime = new Date();
      vm.event.startTime.setTime(new Date(vm.event.fromTime).getTime());
      vm.event.startTime.setDate(new Date(vm.event.fromDate).getDate());
      vm.event.endTime = new Date();
      vm.event.endTime.setTime(new Date(vm.event.toTime).getTime());
      vm.event.endTime.setDate(new Date(vm.event.toDate).getDate());

      if (vm.event.startTime >= vm.event.endTime) {
        Notification.error("End time must be grater than start time");
        return;
      }

      vm.event.type = vm.eventCategoryId1 * 4 + vm.eventCategoryId2;
      var payload = angular.fromJson(angular.toJson(vm.event));
      delete payload.fromDate;
      delete payload.fromTime;
      delete payload.toDate;
      delete payload.toTime;
      $scope.loading = true;

      if (vm.removedFiles.length) {
        payload.removedFiles = vm.removedFiles;
      }

      delete payload.files;

      if (vm.addedFiles.length) {
        payload.files = [];

        var _iterator5 = _createForOfIteratorHelper(vm.addedFiles),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var file = _step5.value;
            payload.files.push(file);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      var endpoint = angular.isDefined($scope.id) ? 'updateEvent' : 'createEvent';
      apiFactory[endpoint](payload).then(function (res) {
        $scope.loading = false;
        Notification.success("Event has been saved successfully");
        vm.modalInstance.close(res.data.data);
      })["catch"](function (error) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(error, 'Failed to save event'));
      });
    };

    $scope.getEventTypeColor = function (key) {
      var color = "--".concat($scope.types[key].key, "-color");
      var result = {};
      result[color] = $scope.types[key].textColor;
      return result;
    };

    vm.locationMarker = function () {
      var placeData = this.getPlace().geometry.location;
      vm.gmap.markers = [[placeData.lat(), placeData.lng()]];
      vm.gmap.zoom = 15;
      vm.gmap.center = "".concat(placeData.lat(), ",").concat(placeData.lng());
      vm.event.location = {
        coordinates: [placeData.lat(), placeData.lng()],
        position: vm.address
      };
    };

    vm.updateMarker = function () {
      var pos = this.getPosition();
      vm.event.location = {
        coordinates: [pos.lat(), pos.lng()],
        position: vm.address
      };
    };

    function validateDupFile(files) {
      var _iterator6 = _createForOfIteratorHelper(files),
          _step6;

      try {
        var _loop = function _loop() {
          var file = _step6.value;
          var find = vm.event.files.find(function (elem) {
            return elem.name === file.name;
          });

          if (find) {
            Notification.error("A file with the same name exist");
            return {
              v: false
            };
          }
        };

        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ret = _loop();

          if (_typeof(_ret) === "object") return _ret.v;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return true;
    }

    vm.fileUpdated = function (files) {
      if (!validateDupFile(files)) {
        return;
      }

      if (files && files.length) {
        vm.event.files = vm.event.files.concat(files);
        vm.addedFiles = vm.addedFiles.concat(files);
      }
    };

    vm.cancelUpload = function (file, index) {
      vm.event.files.splice(index, 1);

      if (angular.isDefined(file._id)) {
        vm.removedFiles.push(file._id);
      } else {
        var _index = vm.addedFiles.findIndex(function (elem) {
          return elem.name === file.name;
        });

        vm.addedFiles.splice(_index, 1);
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('detailEventModal', {
    controller: detailEventModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calendar/modals/detailEventModal/detailEventModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function detailEventModal($scope, Notification, $log, apiFactory, $uibModal) {
    var vm = this;

    vm.$onInit = function () {
      $scope.event = angular.isDefined(vm.resolve) ? vm.resolve.event : {};
      $scope.event.start = moment($scope.event.start).format('MMM D, YYYY h:mm a');
      $scope.event.end = moment($scope.event.end).format('MMM D, YYYY h:mm a');
      $scope.users = angular.isDefined(vm.resolve) ? vm.resolve.users : {};
      $scope.permission = angular.isDefined(vm.resolve.permission) ? vm.resolve.permission : 0;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.editEvent = function (_id) {
      var eventModal = $uibModal.open({
        animation: true,
        component: 'saveEventModal',
        windowClass: 'save-event-modal',
        resolve: {
          users: function users() {
            return $scope.users;
          },
          id: function id() {
            return _id;
          }
        }
      });
      eventModal.result.then(function (result) {
        if (result) {
          $log.log(result);
          vm.modalInstance.close({
            isEdited: true,
            result: result
          });
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.deleteEvent = function (id) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.loading = true;
          apiFactory.deleteEvent(id).then(function () {
            $scope.loading = false;
            vm.modalInstance.close({
              isEdited: false,
              result: id
            });
            Notification.success('Event has been deleted successfully');
          }, function () {
            $scope.loading = false;
            Notification.error('Something went wrong try later');
          })["catch"](function () {
            $scope.loading = false;
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('scheduler', {
    controller: Scheduler,
    controllerAs: 'vm',
    templateUrl: 'app/main/calendar/directives/scheduler/scheduler.view.html',
    bindings: {
      ngModel: '<',
      viewType: '<',
      date: '<',
      onSelectSchedule: '='
    }
  });

  function Scheduler(globals) {
    var vm = this;
    var companyStore = globals.companyStore;
    var companyData = companyStore.get();
    vm.types = Constants.ScheduleTypeList;
    vm.data = [];
    vm.scales = [];
    vm.sections = [];
    vm.viewType = 'day';
    vm.dayRange = {
      first: new Date(),
      last: new Date()
    };
    vm.weekRange = {
      first: new Date(),
      last: new Date()
    };
    vm.monthRange = {
      first: new Date(),
      last: new Date()
    }; //vm.range = (vm.viewType === 'month') ? vm.monthRange : vm.weekRange;

    var taskContentElement = angular.element("#scheduler-task-content");

    vm.$onInit = function () {
      changeDate();
      changeViewType();
    };

    vm.$onChanges = function (changes) {
      if (changes.date) {
        changeDate();
      }

      if (changes.viewType || changes.date) {
        changeViewType();
      }

      if (changes.ngModel || changes.date || changes.viewType) {
        refreshData();
      }
    };

    vm.getTaskLineStyle = function (schedule) {
      var divWidth = taskContentElement[0].clientWidth;
      return {
        left: divWidth === 0 ? 0 : schedule.drawing ? Math.floor(schedule.drawing.start * divWidth).toString() + "px" : '',
        width: divWidth === 0 ? 0 : schedule.drawing ? Math.round(schedule.drawing.width * divWidth).toString() - 8 + "px" : '',
        borderColor: vm.types[schedule.type].textColor,
        backgroundColor: vm.types[schedule.type].backgroundColor
      };
    };

    vm.getTaskLineWidth_d = function (schedule) {
      var divWidth = taskContentElement[0].clientWidth;
      return divWidth === 0 ? 0 : schedule.drawing ? Math.round(schedule.drawing.width * divWidth - 6).toString() : 0;
    };

    vm.getTaskLineWidth_w = function () {
      var divWidth = taskContentElement[0].clientWidth;
      return (divWidth - 6) / 7;
    };

    vm.selectSchedule = function (schedule) {
      if (vm.onSelectSchedule) {
        vm.onSelectSchedule(schedule);
      }
    };

    vm.getColor = function (name) {
      return globals.getAvatarColor(name);
    };

    angular.element("#scheduler-scroller-content").scroll(function () {
      angular.element("#scheduler-grid-content").prop("scrollTop", this.scrollTop);
      taskContentElement.prop("scrollTop", this.scrollTop);
    });
    angular.element("#scheduler-grid-content").scroll(function () {
      taskContentElement.prop("scrollTop", this.scrollTop);
      angular.element("#scheduler-scroller-content").prop("scrollTop", this.scrollTop);
    });
    taskContentElement.scroll(function () {
      angular.element("#scheduler-grid-content").prop("scrollTop", this.scrollTop);
      angular.element("#scheduler-scroller-content").prop("scrollTop", this.scrollTop);
    });

    function changeViewType() {
      vm.scales = [];

      if (vm.viewType === 'day') {
        for (var i = 0; i < 24; i++) {
          var k = i;

          if (companyData && companyData.timeShowMethod === '12 hr') {
            if (i == 0) {
              k = 12;
            } else if (i > 12) {
              k = i - 12;
            }

            if (k == 12 && i == 0 || k == 11 && i == 11) {
              vm.scales.push({
                name: k,
                item: 'AM'
              });
            } else if (k == 12 && i > 11 || k == 11 && i == 23) {
              vm.scales.push({
                name: k,
                item: 'PM'
              });
            } else {
              vm.scales.push({
                name: k
              });
            }
          } else {
            vm.scales.push({
              name: k
            });
          }
        }
      } else if (vm.viewType === 'week') {
        var date = new Date(vm.weekRange.first);

        for (var _i = 0; _i < 7; _i++) {
          vm.scales.push({
            key: _i,
            date: new Date(date)
          });
          date.addDays(1);
        }
      } else if (vm.viewType === 'month') {
        var _date = new Date(vm.monthRange.first);

        for (var _i2 = 0; _i2 < vm.monthRange.last.getDate(); _i2++) {
          vm.scales.push({
            key: _i2,
            date: new Date(_date),
            month: moment(_date).format('MMM')
          });

          _date.addDays(1);
        } // vm.sections = [];
        // const monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
        // let first = new Date(vm.monthRange.first);
        // let last = new Date(first);
        // last.setDate(first.getDate() + 6);
        // let month = 0, index = 0;
        // let section = { name: monthNames[month], scales: [] };
        // while (month < 12) {
        //   section.scales.push({
        //     week: index,
        //     first: new Date(first),
        //     last: new Date(last),
        //   });
        //   vm.scales.push({
        //     key: index,
        //     first: new Date(first),
        //     last: new Date(last),
        //   });
        //   first.setDate(first.getDate() + 7);
        //   last.setDate(last.getDate() + 7);
        //   index ++;
        //   if ((month !== first.getMonth()) || (month !== last.getMonth() && last.getDate() > 2)) {
        //     vm.sections.push(section);
        //     month ++;
        //     section = { name: monthNames[month], scales: [] };
        //   }
        // }

      } //vm.range = (vm.viewType === 'month') ? vm.monthRange : vm.weekRange;

    }

    function changeDate() {
      vm.dayRange.first = new Date(vm.date);
      vm.dayRange.last = new Date(vm.date);
      vm.dayRange.first.setHours(0, 0, 0, 0);
      vm.dayRange.last.setHours(23, 59, 59, 999);
      vm.weekRange = getWeekRange(vm.date);
      vm.monthRange = getMonthRange(vm.date);
    }

    function getWeekRange(date) {
      var current = new Date(date);
      var first = current.getDate() - current.getDay();
      var last = first + 6;
      return {
        first: new Date(current.setDate(first)),
        last: new Date(current.setDate(last))
      };
    }

    function getMonthRange(date) {
      var first = new Date(date.getFullYear(), date.getMonth(), 1);
      var last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      last.setHours(23, 59, 59, 999);
      return {
        first: first,
        last: last
      };
    }

    function refreshData() {
      vm.data = [];

      if (vm.ngModel) {
        switch (vm.viewType) {
          case "day":
            vm.ngModel.forEach(function (item) {
              return vm.data.push(getDayItem(item));
            });
            break;

          case "week":
            vm.ngModel.forEach(function (item) {
              return vm.data.push(getWeekItem(item));
            });
            break;

          case "month":
            vm.ngModel.forEach(function (item) {
              return vm.data.push(getMonthItem(item));
            });
            break;
        }
      }
    }

    function getDayItem(item) {
      var schedules = [];
      var firstTime = vm.dayRange.first.getTime();
      var lastTime = vm.dayRange.last.getTime();
      var totalDuration = lastTime - firstTime;
      item.schedules.forEach(function (schedule) {
        var fromTime = schedule.startDate.getTime();
        var toTime = schedule.endDate.getTime();
        if (fromTime > lastTime || toTime < firstTime) return;

        if (fromTime < firstTime) {
          fromTime = firstTime;
        }

        if (toTime > lastTime) {
          toTime = lastTime;
        }

        var duration = toTime - fromTime;
        if (duration == 0) return;
        var fromDate = new Date();
        fromDate.setTime(fromTime);
        var toDate = new Date();
        toDate.setTime(toTime);
        schedules.push({
          _id: schedule._id,
          title: schedule.name,
          description: schedule.description,
          type: schedule.type,
          startTime: fromDate,
          endTime: toDate,
          duration: duration / 1000,
          drawing: {
            start: totalDuration === 0 ? 0 : (fromTime - firstTime) / totalDuration,
            width: totalDuration === 0 ? 0 : duration / totalDuration
          }
        });
      });
      return {
        displayName: item.displayName,
        role: item.role,
        profilePic: item.profilePic,
        schedules: schedules
      };
    }

    function getWeekItem(item) {
      var schedules = {};
      var firstTime = vm.weekRange.first.getTime();
      var lastTime = vm.weekRange.last.getTime();
      item.schedules.forEach(function (schedule) {
        var fromTime = schedule.startDate.getTime();
        var toTime = schedule.endDate.getTime();
        if (fromTime > lastTime || toTime < firstTime) return;
        var date = new Date(vm.weekRange.first);

        for (var i = 0; i < 7; i++) {
          fromTime = schedule.startDate.getTime();
          toTime = schedule.endDate.getTime();
          var range1 = new Date(date);
          range1.setHours(0, 0, 0, 0);
          var range2 = new Date(date);
          range2.setHours(23, 59, 59, 999);
          var range1Time = range1.getTime();
          var range2Time = range2.getTime();

          if (fromTime > range2Time || toTime < range1Time) {
            date.addDays(1);
            continue;
          }

          if (fromTime < range1Time) {
            fromTime = range1Time;
          }

          if (toTime > range2Time) {
            toTime = range2Time;
          }

          var duration = toTime - fromTime;
          if (duration == 0) return;
          var fromDate = new Date();
          fromDate.setTime(fromTime);
          var toDate = new Date();
          toDate.setTime(toTime);
          schedules[i] = {
            _id: schedule._id,
            title: schedule.name,
            description: schedule.description,
            type: schedule.type,
            startTime: fromDate,
            endTime: toDate,
            duration: duration / 1000
          };
          date.addDays(1);
        }
      });
      return {
        displayName: item.displayName,
        role: item.role,
        profilePic: item.profilePic,
        schedules: schedules
      };
    }

    function getMonthItem(item) {
      var schedules = [];
      var firstTime = vm.monthRange.first.getTime();
      var lastTime = vm.monthRange.last.getTime();
      var totalDuration = lastTime - firstTime;
      var divDuration = totalDuration / vm.monthRange.last.getDate();
      item.schedules.forEach(function (schedule) {
        var fromTime = schedule.startDate.getTime();
        var toTime = schedule.endDate.getTime();
        var endHour = schedule.endDate.getHours();
        var range1 = new Date(schedule.startDate);
        range1.setHours(0, 0, 0, 0);
        var leftTime = range1.getTime();
        var range2 = new Date(schedule.endDate);

        if (endHour == 0) {
          range2.setDate(schedule.endDate.getDate() - 1);
          range2.setHours(23, 59, 59, 999);
          toTime = range2.getTime();
        } //let toTime = new Date(schedule.endDate.getTime());
        //toTime.setHours(23, 59, 59, 999);


        if (fromTime > lastTime || toTime < firstTime) return;

        if (fromTime < firstTime) {
          fromTime = firstTime;
        }

        if (toTime > lastTime) {
          toTime = lastTime;
        }

        var duration = divDuration * (range2.getDate() - schedule.startDate.getDate() + 1);
        var fromDate = new Date();
        fromDate.setTime(fromTime);
        var toDate = new Date();
        toDate.setTime(toTime);
        schedules.push({
          _id: schedule._id,
          title: schedule.name,
          description: schedule.description,
          type: schedule.type,
          startTime: fromDate,
          endTime: toDate,
          duration: duration / 1000,
          drawing: {
            start: totalDuration === 0 ? 0 : (leftTime - firstTime) / totalDuration,
            width: totalDuration === 0 ? 0 : duration / totalDuration
          }
        });
      });
      return {
        displayName: item.displayName,
        role: item.role,
        profilePic: item.profilePic,
        schedules: schedules
      }; // return {
      //   displayName: item.displayName,
      //   role: item.role,
      //   profilePic: item.profilePic,
      //   schedules: schedules
      // };
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('viewDetailModal', {
    controller: viewDetailModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/viewDetailModal/viewDetailModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function viewDetailModal($scope, localStorageService) {
    var vm = this;
    var viewDetailModalData = localStorageService.get('viewDetailModalData');
    vm.currentVersion = viewDetailModalData.currentVersion;
    vm.selectedVersion = viewDetailModalData.selectedVersion;

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.showVersionDetail = function () {
      vm.modalInstance.close();
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('versionModal', {
    controller: versionModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/versionModal/versionModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function versionModal($scope) {
    var vm = this;

    vm.$onInit = function () {
      var versionModalData = vm.resolve.data;
      $scope.companyCurrency = versionModalData.companyCurrency;
      $scope.lastVersion = versionModalData.lastVersion;
      $scope.totalCompanyCost = versionModalData.totalCompanyCost;
      $scope.totalCostPrice = versionModalData.totalCostPrice;
      $scope.totalProfit = versionModalData.totalProfit;
      $scope.totalWorkingHours = versionModalData.totalWorkingHours;
      $scope.totalSum = versionModalData.totalSum;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.saveSheet = function () {
      vm.modalInstance.close($scope.versionMessage);
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var LeaderLine;
var AnimEvent;

(function () {
  angular.module("app").component('syncMainEstimateModal', {
    controller: syncMainEstimateModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/syncMainEstimateModal/syncMainEstimateModal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function syncMainEstimateModalController($scope, utils, Notification, globals, apiFactory, $log, $document, $state, $timeout, $uibModal) {
    var vm = this;
    $scope.bidPackage = null;
    var projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.projectData = projectStore.get();
    vm.companyData = companyStore.get();
    $scope.bidPackage = null;
    vm.lines = [];
    $scope.elLeft = null;
    $scope.elRight = null;
    $scope.fields = ["SysTag", "Quantity", "Unit", "Unit Price", "Level", "Size", "Days", "Amount"];
    $scope.fieldTable = {
      "SysTag": ["tag", "tag"],
      "Quantity": ["qty", "quantity"],
      "Unit": ["unit", "unit"],
      "Unit Price": ["unitPrice", "unitPrice"],
      "Level": ["level", "level"],
      "Size": ["dimension", "size"],
      "Days": ["days", "days"],
      "Amount": ["cost", "amount"]
    };

    $scope.fetchData = function () {
      $scope.loading = true;
      Promise.all([apiFactory.getBidPackages({
        projectId: vm.projectData._id
      }), apiFactory.getCalcSheetExtra(vm.projectData._id)]).then(function (res) {
        $scope.loading = false;
        vm.bidPackages = res[0].data.list;
        $log.log('calcData = ', res[1].data);

        if (res[1].data.data) {
          vm.calcData = res[1].data.data.items;
          vm.additional = res[1].data.data.additional;
        } else {
          vm.calcData = [{
            id: "design",
            items: [],
            groups: []
          }, {
            id: "estimate",
            items: [],
            groups: []
          }];
          apiFactory.createSheetExtra({
            projectId: vm.projectData._id,
            sheet: vm.calcData,
            additional: 0
          }).then(function (res) {
            Notification.success('Calculation saved successfully.');
            $log.log(res);
            vm.calcData = res.data.data.items; // $scope.onSubmit();
          })["catch"](function (e) {
            $log.error(e);
            Notification.error("Calculation couldn't save.");
          });
        }

        $log.log(vm.bidPackages);
        $timeout(function () {
          vm.calcData.forEach(function (data) {
            data.groups.forEach(function (group) {
              data.items.forEach(function (item) {
                if (group.id == item.group) {
                  if (item.linkStatus == 'approved' || item.linkStatus == 'linked') {
                    makeLink(item, item.linkedBidPackage, 'item', group, data);
                  }

                  if (item.worker.linkStatus == 'approved' || item.worker.linkStatus == 'linked') {
                    makeLink(item, item.worker.linkedBidPackage, 'item_worker', group, data);
                  }
                }
              });
            });
          });
          handleScroll();
          updateLinkStatus();
        }, 1000);
        $log.log('data = ', vm.calcData);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
      clearLines();
    };

    $scope.onSubmit = function () {
      clearLines();
      vm.modalInstance.close(vm.calcData);
    };

    $scope.onExpand = function (data, value) {
      data.opened = value;
      $timeout(function () {
        handleScroll();
      });
    };

    $scope.setCurrentData = function (group) {
      $scope.currentData = group;
      vm.calcData.forEach(function (data) {
        if (data == group) {
          data.isActive = true;
        } else {
          data.isActive = false;
        }
      });
    };

    $scope.onRemoveMeItem = function (item, type) {
      $log.log('dblclicked = ', item);

      if (type == 'item') {
        item.linkStatus = 'none';
        delete item.linkedBidPackage;
      } else if (type == 'item_worker') {
        item.worker.linkStatus = 'none';
        delete item.worker.linkedBidPackage;
      }

      $log.log(vm.lines);
      var index = vm.lines.findIndex(function (x) {
        return x.meItem == item && x.type == type;
      });
      vm.lines[index].hide();
      vm.lines.splice(index, 1);
      updateLinkStatus();
    };

    $scope.onImport = function () {
      var query = {
        projectId: vm.projectData._id
      };
      apiFactory.getCollaborationOfferTemplates(query).then(function (res) {
        var offers = res.data.list;
        $log.log('data = ', vm.calcData);
        $log.log('offers = ', offers);
        vm.calcData.forEach(function (data) {
          data.items.forEach(function (item) {
            var temp = findItem(offers, item.item.tag);

            if (item.rowStyle == 'Combined') {
              if (item.item.selectedImportFields) {
                item.item.selectedImportFields.forEach(function (field) {
                  item.item[$scope.fieldTable[field][0]] = temp[0][$scope.fieldTable[field][1]];
                });
              }

              if (item.worker.selectedImportFields) {
                item.worker.selectedImportFields.forEach(function (field) {
                  item.worker[$scope.fieldTable[field][0]] = temp[1][$scope.fieldTable[field][1]];
                });
              }
            } else if (item.rowStyle == 'Worker') {
              if (item.selectedImportFields) {
                item.selectedImportFields.forEach(function (field) {
                  if (field != 'SysTag' && temp.length) {
                    item.worker[$scope.fieldTable[field][0]] = temp[0][$scope.fieldTable[field][1]];
                  }
                });
              }
            } else {
              if (item.selectedImportFields) {
                item.selectedImportFields.forEach(function (field) {
                  item.item[$scope.fieldTable[field][0]] = temp[0][$scope.fieldTable[field][1]];
                });
              }
            }
          });
        });
        $log.log('result = ', vm.calcData);
        apiFactory.createSheetExtra({
          projectId: vm.projectData._id,
          sheet: vm.calcData,
          additional: vm.additional
        }).then(function (res) {
          Notification.success('Calculation saved successfully.');
          $log.log(res);
          vm.calcData = res.data.data.items;
          $scope.onSubmit();
        })["catch"](function (e) {
          $log.error(e);
          Notification.error("Calculation couldn't save.");
        });
      });
    };

    function findLevels(offer, meGroup, items) {
      var res = [];

      for (var j = 0; j < offer.groups.length; j++) {
        var group = offer.groups[j];

        if (group.name == meGroup.title) {
          var _loop = function _loop(i) {
            if (items[i].group == meGroup.id) {
              var tmp = null;

              if (items[i].rowStyle == 'Combined') {
                if (items[i].selectedExportFields) {
                  tmp = items[i].item;
                  group.levels.forEach(function (level) {
                    if (level.tag == items[i].item.tag) {
                      tmp = level;
                    }
                  });
                  res.push(tmp);
                }

                if (items[i].worker.selectedExportFields) {
                  tmp = items[i].worker;
                  group.levels.forEach(function (level) {
                    if (level.tag == items[i].item.tag) {
                      tmp = level;
                    }
                  });
                  res.push(tmp);
                }
              } else if (items[i].rowStyle == 'Worker') {
                if (items[i].worker.selectedExportFields) {
                  tmp = items[i].worker;
                  group.levels.forEach(function (level) {
                    if (level.tag == items[i].item.tag) {
                      tmp = level;
                    }
                  });
                  res.push(tmp);
                }
              } else {
                if (items[i].selectedExportFields) {
                  tmp = items[i].item;
                  group.levels.forEach(function (level) {
                    if (level.tag == items[i].item.tag) {
                      tmp = level;
                    }
                  });
                  res.push(tmp);
                }
              }
            }
          };

          for (var i = 0; i < items.length; i++) {
            _loop(i);
          } // res = group.levels.filter(level => {
          //   for (let i = 0; i < items.length; i++) {
          //     if (items[i].group == meGroup.id) {
          //       if (items[i].item.tag == level.tag) {
          //         return true;
          //       }
          //     }
          //   }
          //   return false;
          // });

        }
      }

      return res;
    }

    function findGroupItem(levels, tag) {
      var temp = null;
      levels.forEach(function (level) {
        if (level.tag == tag) {
          temp = level;
        }
      });
      return temp;
    }

    $scope.onExport = function () {
      $log.log('data = ', vm.calcData);
      updateCollaborationOfferTemplate();
      saveCalcData();
    };

    $scope.getTitle = function (data, index) {
      return index < 2 ? 'Project ' + data.id : data.id;
    };

    $scope.importBidPackage = function (bidPackage) {
      if (!$scope.currentData) {
        Notification.error("Please select a group");
        return;
      }

      if ($scope.currentData.items.length) {
        var confirmModal = $uibModal.open({
          animation: true,
          component: 'confirmModal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function data() {
              return {
                title: 'Confirm import BidPackage',
                message: 'Are you sure update current main estimate?',
                subMessage: 'Items in the current main estimate group will be deleted.',
                confirmButtonText: 'Import',
                icon: '/assets/icons/status-warning.svg'
              };
            }
          }
        });
        confirmModal.result.then(function () {
          $scope.loading = true;
          apiFactory.getCollaborationOfferTemplateByBidPackageId(bidPackage._id).then(function (res) {
            var offers = res.data;
            $log.log('offers = ', offers);
            $log.log('currentData = ', $scope.currentData);
            var idx = 0;
            $scope.currentData.items = [];
            $scope.currentData.groups = [];
            offers.groups.forEach(function (group) {
              $scope.currentData.groups.push({
                id: group.name,
                title: group.name,
                linkStatus: 'none'
              });
              group.levels.forEach(function (level) {
                idx++;
                $scope.currentData.items.push({
                  idx: idx,
                  rowStyle: 'Collaborator',
                  group: group.name,
                  name: level.name,
                  linkStatus: 'none',
                  item: {
                    tag: level.tag,
                    days: level.days,
                    qty: level.quantity,
                    unit: level.unit,
                    level: level.level,
                    unitPrice: level.unitPrice,
                    cost: level.amount,
                    name: level.name,
                    profitP: vm.companyData.profit,
                    type: level.type
                  },
                  worker: {
                    tag: level.tag,
                    work: bidPackage.vendorType ? 'Subcontractor' : 'Supplier',
                    unitPrice: 0,
                    profitP: vm.companyData.profit,
                    name: level.description
                  }
                });
              });
            });
            $scope.currentData.items.forEach(function (item) {
              calcSingleItem(item);
            });
            saveSheet(true);
          });
        }, function () {});
      } else {
        $scope.loading = true;
        apiFactory.getCollaborationOfferTemplateByBidPackageId(bidPackage._id).then(function (res) {
          var offers = res.data;
          $log.log('offers = ', offers);
          $log.log('currentData = ', $scope.currentData);
          var idx = 0;
          offers.groups.forEach(function (group) {
            $scope.currentData.groups.push({
              id: group.name,
              title: group.name,
              linkStatus: 'none'
            });
            group.levels.forEach(function (level) {
              idx++;
              $scope.currentData.items.push({
                idx: idx,
                rowStyle: 'Collaborator',
                group: group.name,
                name: level.name,
                linkStatus: 'none',
                item: {
                  tag: level.tag,
                  days: level.days,
                  qty: level.quantity,
                  unit: level.unit,
                  level: level.level,
                  unitPrice: level.unitPrice,
                  cost: level.amount,
                  name: level.name,
                  profitP: vm.companyData.profit,
                  type: level.type
                },
                worker: {
                  tag: level.tag,
                  work: bidPackage.vendorType ? 'Subcontractor' : 'Supplier',
                  unitPrice: 0,
                  profitP: vm.companyData.profit,
                  name: level.description
                }
              });
            });
          });
          $scope.currentData.items.forEach(function (item) {
            calcSingleItem(item);
          });
          saveSheet(true);
        });
      }
    };

    function calcSingleItem(item) {
      $log.log(vm.companyData.companyCost);
      item.item.cost = item.item.qty * item.item.unitPrice;
      item.item.salesPrice = 1 - item.item.profitP / 100 - vm.companyData.companyCost / 100 > 0 ? item.item.cost / (1 - item.item.profitP / 100 - vm.companyData.companyCost / 100) : 0;
      item.item.opCost = item.item.salesPrice * (vm.companyData.companyCost / 100);
      item.item.profit = item.item.salesPrice * (item.item.profitP / 100);
      item.worker.cost = item.worker.qty * item.worker.unitPrice;
      item.worker.salesPrice = 1 - item.worker.profitP / 100 - vm.companyData.companyCost / 100 > 0 ? item.worker.cost / (1 - item.worker.profitP / 100 - vm.companyData.companyCost / 100) : 0;
      item.worker.opCost = item.worker.salesPrice * (vm.companyData.companyCost / 100);
      item.worker.profit = item.worker.salesPrice * (item.worker.profitP / 100);
      item.worker.labor = item.worker.qty * item.worker.unitPrice / vm.workerCost;
      item.item.waste = (item.item.cost / item.item.unitPrice - item.item.qty) / item.item.qty * 100;
      if (item.item.waste < 0) item.item.waste = 0;
      item.worker.waste = (item.worker.cost / item.worker.unitPrice - item.worker.qty) / item.worker.qty * 100;
      if (item.worker.waste < 0) item.worker.waste = 0;
    }

    function syncSystags(dataIndex) {
      var query = {
        projectId: vm.projectData._id
      };
      apiFactory.getCollaborationOfferTemplates(query).then(function (res) {
        $log.log('collaboration offer template = ', res);
        var offers = res.data.list;
        offers.forEach(function (offer) {
          offer.groups.forEach(function (group) {
            var items = vm.calcData[dataIndex].items.filter(function (item) {
              return item.group == group.name;
            });
            $log.log('items = ', items);

            for (var i = 0; i < items.length; i++) {
              group.levels[i].tag = items[i].item.tag;
            }
          });
          $timeout(function () {
            apiFactory.updateCollaborationOfferTemplate(offer).then(function (res1) {
              $log.log('collaboration offer template = ', res1);
              Notification.success("Data for BidPackage '" + offer.bidPackageId.title + "' was exported successfully!");
            });
          });
        });
        $log.log('offers = ', offers);
      });
    }

    function saveSheet() {
      var bImportBidpackage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var dataIndex = vm.calcData.indexOf($scope.currentData);
      $scope.isLoading = true;
      apiFactory.createSheetExtra({
        projectId: vm.projectData._id,
        sheet: vm.calcData,
        additional: vm.additional
      }).then(function (res) {
        Notification.success('Calculation saved successfully.');
        $log.log(res);
        vm.calcData = res.data.data.items;

        if (bImportBidpackage) {
          syncSystags(dataIndex);
        }

        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error(e);
        Notification.error("Calculation couldn't save.");
        $scope.isLoading = false;
      });
    }

    function updateCollaborationOfferTemplate() {
      var query = {
        projectId: vm.projectData._id
      };
      apiFactory.getCollaborationOfferTemplates(query).then(function (res) {
        $log.log('collaboration offer template = ', res);
        var offers = res.data.list;
        offers.forEach(function (offer) {
          updateCollaborationIncomingOffer(offer.bidPackageId._id, query);
          var tmpGroups = [];
          vm.calcData.forEach(function (data) {
            data.groups.forEach(function (group) {
              tmpGroups.push({
                id: group.id,
                name: group.title,
                levels: findLevels(offer, group, data.items)
              });
            });
            $log.log('bidPackage = ', offer.bidPackageId._id);
            data.items.forEach(function (item) {
              if (item.rowStyle == 'Combined') {
                if ((item.linkStatus == 'linked' || item.linkStatus == 'approved') && item.linkedBidPackage == offer.bidPackageId._id) {
                  tmpGroups.forEach(function (group) {
                    if (group.id == item.group) {
                      var temp = findGroupItem(group.levels, item.item.tag);

                      if (temp == null) {
                        temp = {
                          name: item.item.name
                        };

                        if (item.selectedExportFields) {
                          item.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.item[$scope.fieldTable[field][0]];
                          });
                          group.levels.push(temp);
                        }
                      } else {
                        if (item.selectedExportFields) {
                          item.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.item[$scope.fieldTable[field][0]];
                          });
                        }
                      }
                    }
                  });
                }

                if ((item.worker.linkStatus == 'linked' || item.worker.linkStatus == 'approved') && item.worker.linkedBidPackage == offer.bidPackageId._id) {
                  tmpGroups.forEach(function (group) {
                    if (group.id == item.group) {
                      var temp = findGroupItem(group.levels, item.item.tag);

                      if (temp == null) {
                        temp = {
                          name: item.item.name
                        };

                        if (item.worker.selectedExportFields) {
                          item.worker.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.worker[$scope.fieldTable[field][0]];
                          });
                          group.levels.push(temp);
                        }
                      } else {
                        if (item.worker.selectedExportFields) {
                          item.worker.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.worker[$scope.fieldTable[field][0]];
                          });
                        }
                      }
                    }
                  });
                }
              } else if (item.rowStyle == 'Worker') {
                if ((item.linkStatus == 'linked' || item.linkStatus == 'approved') && item.linkedBidPackage == offer.bidPackageId._id) {
                  tmpGroups.forEach(function (group) {
                    if (group.id == item.group) {
                      var temp = findGroupItem(group.levels, item.item.tag);

                      if (temp == null) {
                        temp = {
                          name: item.item.name
                        };

                        if (item.worker.selectedExportFields) {
                          item.worker.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.worker[$scope.fieldTable[field][0]];
                          });
                          group.levels.push(temp);
                        }
                      } else {
                        if (item.worker.selectedExportFields) {
                          item.worker.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.worker[$scope.fieldTable[field][0]];
                          });
                        }
                      }
                    }
                  });
                }
              } else {
                if ((item.linkStatus == 'linked' || item.linkStatus == 'approved') && item.linkedBidPackage == offer.bidPackageId._id) {
                  tmpGroups.forEach(function (group) {
                    if (group.id == item.group) {
                      var temp = findGroupItem(group.levels, item.item.tag);

                      if (temp == null) {
                        temp = {
                          name: item.item.name
                        };

                        if (item.selectedExportFields) {
                          item.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.item[$scope.fieldTable[field][0]];
                          });
                          group.levels.push(temp);
                        }
                      } else {
                        if (item.selectedExportFields) {
                          item.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.item[$scope.fieldTable[field][0]];
                          });
                        }
                      }
                    }
                  });
                }
              }
            });
          });
          $log.log('groups = ', tmpGroups);
          offer.groups = tmpGroups;
          $timeout(function () {
            $log.log('temp groups = ', tmpGroups);
            apiFactory.updateCollaborationOfferTemplate({
              _id: offer._id,
              groups: tmpGroups
            }).then(function (res1) {
              $log.log('collaboration offer template = ', res1);
              Notification.success("Data for BidPackage '" + offer.bidPackageId.title + "' was exported successfully!");
            });
          });
        });
        $log.log('offers = ', offers);
      });
    }

    function updateCollaborationIncomingOffer(bidPackageId, query) {
      query.bidPackageId = bidPackageId;
      apiFactory.getCollaborationOffers(query).then(function (res) {
        var realOffers = res.data.list;
        realOffers.forEach(function (offer) {
          var tmpGroups = [];
          vm.calcData.forEach(function (data) {
            data.groups.forEach(function (group) {
              tmpGroups.push({
                id: group.id,
                name: group.title,
                levels: findLevels(offer, group, data.items)
              });
            });
            $log.log('bidPackage = ', offer.bidPackageId._id);
            data.items.forEach(function (item) {
              if (item.rowStyle == 'Combined') {
                if ((item.linkStatus == 'linked' || item.linkStatus == 'approved') && item.linkedBidPackage == offer.bidPackageId._id) {
                  tmpGroups.forEach(function (group) {
                    if (group.id == item.group) {
                      var temp = findGroupItem(group.levels, item.item.tag);

                      if (temp == null) {
                        temp = {
                          name: item.item.name
                        };

                        if (item.item.selectedExportFields) {
                          item.item.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.item[$scope.fieldTable[field][0]];
                          });
                          group.levels.push(temp);
                        }
                      } else {
                        if (item.item.selectedExportFields) {
                          item.item.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.item[$scope.fieldTable[field][0]];
                          });
                        }
                      }
                    }
                  });
                }

                if ((item.worker.linkStatus == 'linked' || item.worker.linkStatus == 'approved') && item.worker.linkedBidPackage == offer.bidPackageId._id) {
                  tmpGroups.forEach(function (group) {
                    if (group.id == item.group) {
                      var temp = findGroupItem(group.levels, item.item.tag);

                      if (temp == null) {
                        temp = {
                          name: item.item.name
                        };

                        if (item.item.selectedExportFields) {
                          item.worker.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.worker[$scope.fieldTable[field][0]];
                          });
                          group.levels.push(temp);
                        }
                      } else {
                        if (item.item.selectedExportFields) {
                          item.worker.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.worker[$scope.fieldTable[field][0]];
                          });
                        }
                      }
                    }
                  });
                }
              } else if (item.rowStyle == 'Worker') {
                if ((item.linkStatus == 'linked' || item.linkStatus == 'approved') && item.linkedBidPackage == offer.bidPackageId._id) {
                  tmpGroups.forEach(function (group) {
                    if (group.id == item.group) {
                      var temp = findGroupItem(group.levels, item.item.tag);

                      if (temp == null) {
                        temp = {
                          name: item.item.name
                        };

                        if (item.item.selectedExportFields) {
                          item.worker.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.worker[$scope.fieldTable[field][0]];
                          });
                          group.levels.push(temp);
                        }
                      } else {
                        if (item.item.selectedExportFields) {
                          item.worker.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.worker[$scope.fieldTable[field][0]];
                          });
                        }
                      }
                    }
                  });
                }
              } else {
                if ((item.linkStatus == 'linked' || item.linkStatus == 'approved') && item.linkedBidPackage == offer.bidPackageId._id) {
                  tmpGroups.forEach(function (group) {
                    if (group.id == item.group) {
                      var temp = findGroupItem(group.levels, item.item.tag);

                      if (temp == null) {
                        temp = {
                          name: item.item.name
                        };

                        if (item.item.selectedExportFields) {
                          item.worker.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.worker[$scope.fieldTable[field][0]];
                          });
                          group.levels.push(temp);
                        }
                      } else {
                        if (item.item.selectedExportFields) {
                          item.selectedExportFields.forEach(function (field) {
                            temp[$scope.fieldTable[field][1]] = item.item[$scope.fieldTable[field][0]];
                          });
                        }
                      }
                    }
                  });
                }
              }
            });
          });
          $log.log('groups = ', tmpGroups);
          offer.groups = tmpGroups;
          $timeout(function () {
            $log.log('temp groups = ', tmpGroups);
            apiFactory.updateCollaborationOffer({
              _id: offer._id,
              groups: tmpGroups
            }).then(function (res1) {
              $log.log('collaboration offer template = ', res1);
              Notification.success("Data for BidPackage '" + offer.bidPackageId.title + "' was exported successfully!");
            });
          });
        });
      });
    }

    function makeLink(item, bidPackageId, type, group, data) {
      if (type == 'item') {
        $scope.elLeft = $document[0].getElementById("data_" + data.id + "_group_" + group.id + "_item_" + item.idx);
        item.isSelected = true;
        $scope.selectedItemType = 'item';
      } else if (type == 'item_worker') {
        $scope.elLeft = $document[0].getElementById("data_" + data.id + "_group_" + group.id + "_item_worker_" + item.idx);
        item.worker.tag = item.item.tag;
        item.worker.isSelected = true;
        $scope.selectedItemType = 'item_worker';
      }

      $scope.selectedItem = item;
      var tmp = vm.bidPackages.filter(function (x) {
        return x._id == bidPackageId;
      });

      if (tmp.length) {
        $scope.selectedBidPackage = tmp[0];
      }

      $scope.elRight = $document[0].getElementById(bidPackageId);
      var line = new LeaderLine($scope.elLeft, $scope.elRight, {
        startPlug: 'behind',
        endPlug: 'behind',
        hide: true
      });
      line.color = '#4584E0';
      line.size = 2;
      line.opacity = 1;
      line.elLeft = $scope.elLeft;
      line.elRight = $scope.elRight;
      line.meItem = $scope.selectedItem;
      line.bidPackage = $scope.selectedBidPackage;
      line.type = type;
      line.listener = AnimEvent.add(function () {
        if (line) {
          line.position();
        }
      });
      vm.leftScrollBox.addEventListener('scroll', line.listener, false);
      vm.rightScrollBox.addEventListener('scroll', line.listener, false);
      vm.lines.push(line);
    }

    $scope.onSelectMeItem = function (type, item, group, data) {
      if (type == 'item_worker' && (item.worker.linkStatus == 'approved' || item.worker.linkStatus == 'linked')) {
        $scope.selectedItem = null;
        return;
      } else if (type == 'group' && (group.linkStatus == 'approved' || group.linkStatus == 'linked')) {
        $scope.selectedItem = null;
        return;
      } else if (type != 'item_worker' && type != 'group' && (item.linkStatus == 'approved' || item.linkStatus == 'linked')) {
        $scope.selectedItem = null;
        return;
      }

      $log.log('item = ', item);
      $log.log('type = ', type);
      clearSelection();

      if (type == 'data') {
        $scope.elLeft = $document[0].getElementById("data_" + item.id);
        item.isSelected = true;
        item.groups.forEach(function (group) {
          group.isSelected = true;
        });
        item.items.forEach(function (x) {
          if (x.rowStyle == 'Combined') {
            x.worker.isSelected = true;
          }

          x.isSelected = true;
        });
      } else if (type == 'group') {
        $scope.elLeft = $document[0].getElementById("data_" + data.id + "_group_" + group.id);
        group.isSelected = true;
        $scope.selectedItemType = 'group';
        data.items.forEach(function (x) {
          if (x.group == group.id) {
            x.isSelected = true;

            if (x.rowStyle == 'Combined') {
              x.worker.isSelected = true;
            }
          }
        });
      } else if (type == 'item') {
        $scope.elLeft = $document[0].getElementById("data_" + data.id + "_group_" + group.id + "_item_" + item.idx);
        item.isSelected = true;
        $scope.selectedItemType = 'item';
      } else if (type == 'item_worker') {
        $scope.elLeft = $document[0].getElementById("data_" + data.id + "_group_" + group.id + "_item_worker_" + item.idx);
        item.worker.tag = item.item.tag;
        item.worker.isSelected = true;
        $scope.selectedItemType = 'item_worker';
      }

      $scope.selectedItem = item;
      $scope.selectedGroup = group;
      $scope.selectedData = data;
    };

    $scope.onSelectBidPackage = function (bidPackage) {
      if (bidPackage.linkStatus == 'approved') {
        return;
      }

      if ($scope.selectedItemType == 'group' && $scope.selectedGroup == null) {
        return;
      }

      if (($scope.selectedItemType == 'item' || $scope.selectedItemType == 'item_worker') && $scope.selectedItem == null) {
        return;
      }

      if ($scope.selectedItemType == 'item' && ($scope.selectedItem.linkStatus == 'approved' || $scope.selectedItem.linkStatus == 'linked')) {
        return;
      }

      if ($scope.selectedItemType == 'item_worker' && ($scope.selectedItem.worker.linkStatus == 'approved' || $scope.selectedItem.worker.linkStatus == 'linked')) {
        return;
      }

      bidPackage.isSelected = true;
      $scope.selectedBidPackage = bidPackage;
      $log.log('item = ', $scope.selectedItem);
      $log.log('type = ', $scope.selectedItemType);

      if ($scope.selectedItemType == 'item_worker') {
        $scope.selectedItem.worker.linkStatus = 'linked';
        $scope.selectedItem.worker.linkedBidPackage = bidPackage._id;
      } else if ($scope.selectedItemType == 'group') {
        $scope.selectedGroup.linkStatus = 'linked';
        $scope.selectedGroup.linkedBidPackage = bidPackage._id;
      } else {
        $scope.selectedItem.linkStatus = 'linked';
        $scope.selectedItem.linkedBidPackage = bidPackage._id;
      }

      $scope.selectedBidPackage.linkStatus = 'linked'; // updateLinkStatus();

      $scope.elRight = $document[0].getElementById(bidPackage._id);
      var line = new LeaderLine($scope.elLeft, $scope.elRight, {
        startPlug: 'behind',
        endPlug: 'behind'
      });
      line.color = '#4584E0';
      line.size = 2;
      line.opacity = 1;
      line.elLeft = $scope.elLeft;
      line.elRight = $scope.elRight;
      line.meItem = $scope.selectedItem;
      line.bidPackage = $scope.selectedBidPackage;
      line.type = $scope.selectedItemType;
      line.listener = AnimEvent.add(function () {
        if (line) {
          line.position();
        }
      });
      vm.leftScrollBox.addEventListener('scroll', line.listener, false);
      vm.rightScrollBox.addEventListener('scroll', line.listener, false);
      vm.lines.push(line);

      if ($scope.selectedItemType == 'group') {
        $scope.selectedData.items.forEach(function (item) {
          if (item.group == $scope.selectedGroup.id) {
            if (item.rowStyle == 'Combined') {
              item.linkStatus = 'linked';
              item.linkedBidPackage = $scope.selectedBidPackage._id;
              item.worker.linkedBidPackage = $scope.selectedBidPackage._id;
              item.worker.linkStatus = 'linked';
              makeLink(item, $scope.selectedBidPackage._id, 'item', $scope.selectedGroup, $scope.selectedData);
              makeLink(item, $scope.selectedBidPackage._id, 'item_worker', $scope.selectedGroup, $scope.selectedData);
            } else {
              item.linkStatus = 'linked';
              item.linkedBidPackage = $scope.selectedBidPackage._id;
              makeLink(item, $scope.selectedBidPackage._id, 'item', $scope.selectedGroup, $scope.selectedData);
            }
          }
        });
      }

      handleScroll();
      updateLinkStatus();
    };

    $scope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (!toState.redirectTo && !utils.isEmpty(vm.lines)) {
        event.preventDefault();
        clearLines();
        $state.go(toState, toParams);
      }
    });
    $scope.$on('onProjectChanged', function () {
      clearLines();
    });

    $scope.onChangeImportFields = function (data, type, group) {
      if (type == 'data') {
        data.groups.forEach(function (group) {
          group.selectedImportFields = data.selectedImportFields;
        });
        data.items.forEach(function (x) {
          if (x.rowStyle == 'Combined') {
            x.item.selectedImportFields = data.selectedImportFields;
            x.worker.selectedImportFields = data.selectedImportFields;
          } else {
            x.selectedImportFields = data.selectedImportFields;
          }
        });
      } else if (type == 'group') {
        data.items.forEach(function (x) {
          if (x.group == group.id) {
            if (x.rowStyle == 'Combined') {
              x.item.selectedImportFields = group.selectedImportFields;
              x.worker.selectedImportFields = group.selectedImportFields;
            } else {
              x.selectedImportFields = group.selectedImportFields;
            }
          }
        });
      }
    };

    $scope.onChangeExportFields = function (data, type, group) {
      if (type == 'data') {
        data.groups.forEach(function (group) {
          group.selectedExportFields = data.selectedExportFields;
        });
        data.items.forEach(function (x) {
          if (x.rowStyle == 'Combined') {
            x.item.selectedExportFields = data.selectedExportFields;
            x.worker.selectedExportFields = data.selectedExportFields;
          } else {
            x.selectedExportFields = data.selectedExportFields;
          }
        });
      } else if (type == 'group') {
        data.items.forEach(function (x) {
          if (x.group == group.id) {
            if (x.rowStyle == 'Combined') {
              x.item.selectedExportFields = group.selectedExportFields;
              x.worker.selectedExportFields = group.selectedExportFields;
            } else {
              x.selectedExportFields = group.selectedExportFields;
            }
          }
        });
      }
    };

    function updateLinkStatus() {
      var globalItemCnt = 0;
      var globalLinkedCnt = 0;
      vm.calcData.forEach(function (data) {
        var dataCnt = 0;
        var totalCnt = 0;
        data.items.forEach(function (item) {
          totalCnt++;

          if (item.linkStatus == 'linked' || item.linkStatus == 'approved') {
            dataCnt++;
          }

          if (item.rowStyle == 'Combined') {
            totalCnt++;
          }

          if (item.rowStyle == 'Combined' && (item.worker.linkStatus == 'linked' || item.worker.linkStatus == 'approved')) {
            dataCnt++;
          }
        });

        if (dataCnt == totalCnt) {
          data.linkStatus = 'approved';
        } else if (dataCnt > 0 && dataCnt < totalCnt) {
          data.linkStatus = 'pending';
        } else {
          data.linkStatus = 'none';
        }

        data.groups.forEach(function (group) {
          var groupCnt = 0;
          var groupLinkedCnt = 0;
          data.items.forEach(function (item) {
            if (group.id == item.group) {
              groupCnt++;

              if (item.linkStatus == 'linked' || item.linkStatus == 'approved') {
                groupLinkedCnt++;
              }

              if (item.rowStyle == 'Combined') {
                groupCnt++;
              }

              if (item.rowStyle == 'Combined' && (item.worker.linkStatus == 'linked' || item.worker.linkStatus == 'approved')) {
                groupLinkedCnt++;
              }
            }
          });

          if (groupCnt == groupLinkedCnt) {
            group.linkStatus = 'approved';
          } else if (groupLinkedCnt > 0 && groupLinkedCnt < groupCnt) {
            group.linkStatus = 'pending';
          } else {
            group.linkStatus = 'none';
          }
        });
        globalItemCnt += totalCnt;
        globalLinkedCnt += dataCnt;
      });

      if (globalLinkedCnt == globalItemCnt) {
        $scope.dataLinkStatus = 'approved';
      } else if (globalLinkedCnt > 0 && globalLinkedCnt < globalItemCnt) {
        $scope.dataLinkStatus = 'pending';
      } else {
        $scope.dataLinkStatus = 'none';
      }

      var globalBPCnt = vm.bidPackages.length;
      var globalSelectedBPCnt = 0;
      vm.bidPackages.forEach(function (bidPackage) {
        bidPackage.linkStatus = 'none';
        vm.calcData.forEach(function (data) {
          data.items.forEach(function (item) {
            if (item.linkedBidPackage == bidPackage._id) {
              bidPackage.linkStatus = 'linked';
            }

            if (item.rowStyle == 'Combined' && item.worker.linkedBidPackage == bidPackage._id) {
              bidPackage.linkStatus = 'linked';
            }
          });
        });

        if (bidPackage.linkStatus == 'linked') {
          globalSelectedBPCnt++;
        }
      });

      if (globalSelectedBPCnt == globalBPCnt) {
        $scope.BPLinkStatus = 'approved';
      } else if (globalSelectedBPCnt > 0 && globalSelectedBPCnt < globalBPCnt) {
        $scope.BPLinkStatus = 'linked';
      } else {
        $scope.BPLinkStatus = 'none';
      }
    }

    function clearLines() {
      var _iterator = _createForOfIteratorHelper(vm.lines),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var line = _step.value;
          vm.leftScrollBox.removeEventListener('scroll', line.listener);
          vm.rightScrollBox.removeEventListener('scroll', line.listener);
          line.remove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      vm.lines = [];
    }

    var isVisible = function isVisible(container, ele) {
      var _ele$getBoundingClien = ele.getBoundingClientRect(),
          bottom = _ele$getBoundingClien.bottom,
          height = _ele$getBoundingClien.height,
          top = _ele$getBoundingClien.top;

      var containerRect = container.getBoundingClientRect();
      return top <= containerRect.top ? containerRect.top - top <= height : bottom - containerRect.bottom <= height;
    };

    function handleScroll() {
      var _iterator2 = _createForOfIteratorHelper(vm.lines),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var line = _step2.value;

          if (isVisible(vm.leftScrollBox, line.elLeft) && isVisible(vm.rightScrollBox, line.elRight)) {
            line.show();
            line.position();
          } else {
            line.hide('fade');
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    function clearSelection() {
      vm.calcData.forEach(function (data) {
        data.isSelected = false;
        data.groups.forEach(function (group) {
          group.isSelected = false;
        });
        data.items.forEach(function (item) {
          if (item.rowStyle == 'Combined') {
            item.worker.isSelected = false;
          }

          item.isSelected = false;
        });
      });
    }

    function findItem(offers, systag) {
      var res = [];
      offers.forEach(function (offer) {
        offer.groups.forEach(function (group) {
          group.levels.forEach(function (level) {
            if (level.tag == systag) {
              res.push(level);
            }
          });
        });
      });
      return res;
    }

    function saveCalcData() {
      $scope.isLoading = true;

      for (var i = 0; i < vm.calcData.length; i++) {
        var data = vm.calcData[i];
        delete data.opened;
        delete data.isSelected;

        for (var j = 0; j < data.groups.length; j++) {
          delete data.groups[j].isSelected;
          delete data.groups[j].opened;
        }

        for (var _j = 0; _j < data.items.length; _j++) {
          var item = data.items[_j];
          delete item.isSelected;
          delete item.worker.isSelected;
          delete item.opened;

          if (item.linkStatus == 'linked') {
            item.linkStatus = 'approved';
          }

          if (item.rowStyle == 'Combined' && item.worker.linkStatus == 'linked') {
            item.worker.linkStatus = 'approved';
          }
        }
      }

      apiFactory.createSheetExtra({
        projectId: vm.projectData._id,
        sheet: vm.calcData,
        additional: vm.additional
      }).then(function (res) {
        Notification.success('Calculation saved successfully.');
        $log.log(res);
        vm.calcData = res.data.data.items;
        clearLines();
        $timeout(function () {
          vm.calcData.forEach(function (data) {
            data.groups.forEach(function (group) {
              data.items.forEach(function (item) {
                if (group.id == item.group) {
                  if (item.linkStatus == 'approved' || item.linkStatus == 'linked') {
                    makeLink(item, item.linkedBidPackage, 'item', group, data);
                  }

                  if (item.worker.linkStatus == 'approved' || item.worker.linkStatus == 'linked') {
                    makeLink(item, item.worker.linkedBidPackage, 'item_worker', group, data);
                  }
                }
              });
            });
          });
          handleScroll();
          $scope.onSubmit();
          $scope.isLoading = true;
        }, 1000);
      })["catch"](function (e) {
        $log.error(e);
        Notification.error("Calculation couldn't save.");
      });
    }

    $scope.init = function () {
      $scope.fetchData();
      vm.leftScrollBox = $document[0].getElementById('me-table-body');
      vm.leftScrollBox.addEventListener('scroll', handleScroll, false);
      vm.rightScrollBox = $document[0].getElementById('bidpackages-table-body');
      vm.rightScrollBox.addEventListener('scroll', handleScroll, false);
    };

    $scope.init();
  }
})();


"use strict";

(function () {
  angular.module('app').component('structureModal', {
    controller: structureModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/structureModal/structureModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function structureModal($scope) {
    var vm = this;
    $scope.treeOptions = {
      accept: function accept() {
        return false;
      }
    };

    vm.$onInit = function () {
      $scope.tableInventory = vm.resolve.data;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('organizeModal', {
    controller: organizeModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/organizeModal/organizeModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function organizeModal($scope) {
    var vm = this;
    vm.treeOptions = {
      accept: function accept(sourceNodeScope, destNodesScope) {
        return sourceNodeScope.$parentNodesScope && sourceNodeScope.$parentNodesScope.$id === destNodesScope.$id;
      }
    };

    vm.$onInit = function () {
      vm.calcLevels = angular.copy(vm.resolve.data);
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      vm.modalInstance.close(vm.calcLevels);
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component('newMainEstimateTabModal', {
    controller: newMainEstimateTabModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/newMainEstimateTabModal/newMainEstimateTabModal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function newMainEstimateTabModalController($scope, utils, Notification) {
    var vm = this;
    vm.name = '';

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty(vm.name)) {
        Notification.error('Please input group name.');
        return;
      }

      vm.modalInstance.close(vm.name);
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component('newGroupModal', {
    controller: newGroupModalController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/newGroupModal/newGroupModal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function newGroupModalController($scope, utils, Notification) {
    var vm = this;
    vm.name = '';

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty(vm.name)) {
        Notification.error('Please input group name.');
        return;
      }

      vm.modalInstance.close(vm.name);
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('modelViewModal', {
    controller: modelViewModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/modelViewModal/modelViewModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function modelViewModal($scope, $log, apiFactory, Bim, VP) {
    var vm = this;
    vm.viewer = undefined;
    vm.model = {};
    var viewerElement = angular.element('#viewer')[0];

    vm.$onInit = function () {
      vm.model = vm.resolve.model;

      if (vm.model.type === '3d') {
        vm.viewer = Bim.simpleViewer(viewerElement, 'high');
        vm.viewer.initialize();
        vm.isLoading = true;
        apiFactory.get3dModel(vm.model.modelId).then(function (resp) {
          if (resp.data.data) {
            vm.viewer.loadBim(resp.data.data).then(function () {
              vm.viewer.selectObject(vm.model.objectId);
              vm.isLoading = false;
            })["catch"](function (err) {
              $log.error(err);
              vm.isLoading = false;
            });
          } else {
            vm.isLoading = false;
          }
        })["catch"](function (e) {
          $log.error(e);
          vm.isLoading = false;
        });
      } else {
        vm.viewer = VP.simpleViewer(angular.element('#viewer')[0]);
        vm.isLoading = true;
        apiFactory.getRoofPlan(vm.model.modelId).then(function (resp) {
          var plan = resp.data.data;
          vm.viewer.loadPlan(plan).then(function () {
            vm.isLoading = false;
          })["catch"](function (err) {
            $log.error(err);
            vm.isLoading = false;
          });
        })["catch"](function (e) {
          $log.error(e);
          vm.isLoading = false;
        });
      }
    };

    $scope.$watch(function () {
      return viewerElement.clientWidth;
    }, function (newVal) {
      if (newVal) {
        vm.viewer.setSize(viewerElement.clientWidth, viewerElement.clientHeight);
      }
    });
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app').component('editMailFolder', {
    controller: editMailFolderModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/editMailFolder/editMailFolder.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function editMailFolderModal($scope, utils, Notification, $timeout) {
    var vm = this;
    $scope.tags = [];
    $scope.invitedManagers = [];

    $scope.addManager = function () {
      var man = vm.managers.find(function (x) {
        return x._id === $scope.manager;
      });

      if (man && !$scope.invitedManagers.find(function (x) {
        return x._id === man._id;
      })) {
        $scope.invitedManagers.push(man);
        vm.userids.push(man._id);
      }

      $scope.manager = undefined;
      $timeout(function () {
        $scope.$apply();
      });
    };

    $scope._nameLetter = function (name) {
      var names = name.split(' ');

      if (names.length > 1) {
        return (names[0].charAt(0) + names[1].charAt(0)).toUpperCase();
      } else if (name.charAt(0).match(/[a-z]/i) && /[0-9]/g.test(name)) {
        var strNum = name.replace(/^\D+/g, '');
        return (name.charAt(0) + strNum.charAt(0)).toUpperCase();
      }

      return name.substring(0, 2).toUpperCase();
    }, $scope.removeManager = function (index) {
      $scope.invitedManagers.splice(index, 1);
      vm.userids.splice(index, 1);
    };

    $scope.addTag = function () {
      if ($scope.tag && !$scope.tags.find(function (x) {
        return x === $scope.tag;
      })) {
        $scope.tags.push($scope.tag);
      }

      $scope.tag = '';
      $timeout(function () {
        $scope.$apply();
      });
    };

    $scope.removeTag = function (index) {
      $scope.tags.splice(index, 1);
    };

    vm.$onInit = function () {
      vm.managers = vm.resolve.data.managers;
      vm.folderName = vm.resolve.data.foldername;
      vm.mode = vm.resolve.data.mode;
      $scope.tags = vm.resolve.data.tags;
      vm.userids = vm.resolve.data.inviteUsers;
      $scope.invitedManagers = [];

      var _iterator = _createForOfIteratorHelper(vm.userids),
          _step;

      try {
        var _loop = function _loop() {
          var userid = _step.value;
          var man = vm.managers.find(function (x) {
            return x._id === userid;
          });
          $scope.invitedManagers.push(man);
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty(vm.folderName)) {
        Notification.error("Please input foldername.");
        return;
      }

      if ($scope.tags.length == 0) {
        Notification.error("Please add tags.");
        return;
      }

      vm.modalInstance.close({
        customFolderName: vm.folderName,
        tags: $scope.tags,
        inviteUsers: vm.userids
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('configModal2', {
    controller: configModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/configModal2/configModal2.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function configModal($scope, utils, Notification) {
    var vm = this;

    vm.$onInit = function () {
      vm.config = vm.resolve.data;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty(vm.config.opCost)) {
        Notification.error("Please input average working cost.");
        return;
      }

      if (utils.isEmpty(vm.config.profit)) {
        Notification.error("Please input profit percentage.");
        return;
      }

      vm.modalInstance.close({
        profit: vm.config.profit,
        opCost: vm.config.opCost
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('configModal', {
    controller: configModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/configModal/configModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function configModal($scope, utils, Notification) {
    var vm = this;

    vm.$onInit = function () {
      vm.config = vm.resolve.data;
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty(vm.config.workerCost)) {
        Notification.error("Please input average working cost.");
        return;
      }

      if (utils.isEmpty(vm.config.profit)) {
        Notification.error("Please input profit percentage.");
        return;
      }

      vm.modalInstance.close({
        profit: vm.config.profit,
        workerCost: vm.config.workerCost
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('calcExtraTemplateModal', {
    controller: CalcExtraTemplateModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/calcExtraTemplateModal/calcExtraTemplateModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function CalcExtraTemplateModal($log, apiFactory, Notification, utils) {
    var vm = this;
    vm.templateName = "";
    vm.data = {};

    vm.$onInit = function () {
      vm.data = vm.resolve.data;
    };

    vm.cancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.done = function () {
      if (utils.isEmpty(vm.templateName)) {
        Notification.error("Please input template name.");
        return;
      }

      vm.loading = true;
      apiFactory.saveCalcTemplate({
        name: vm.templateName,
        calcData: vm.data
      }).then(function () {
        vm.loading = false;
        Notification.success("Template saved successfully.");
        vm.modalInstance.close();
      })["catch"](function (err) {
        vm.loading = false;
        $log.error(err);
        Notification.error("Failed to save.");
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('budgetSummaryModal', {
    controller: BudgetSummaryModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/budgetSummaryModal/budgetSummaryModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function BudgetSummaryModal(Notification, utils) {
    var vm = this;
    vm.allFields = [];
    vm.fields = [];
    vm.equation = {
      type: '',
      name: '',
      expression: '',
      fields: []
    };
    var oldExpression = '';

    vm.$onInit = function () {
      vm.budgets = vm.resolve.budgets;
      vm.summary = vm.resolve.summary;
      vm.equation.type = vm.summary.equation.type;
      vm.equation.name = vm.equation.type.toUpperCase();
      vm.fields = [];
      vm.budgets.forEach(function (budget) {
        addBudgetToField(budget);

        if (budget.children && budget.children.length > 0) {
          budget.children.forEach(function (child, index) {
            return addBudgetToField(budget, child, index + 1);
          });
        }
      });
      updateSummaryExpression();
    };

    vm.changeExpression = function () {
      if (!processExpression()) {
        var eg = vm.equation.type === 'math' ? '4 - 5 + 7' : 'eg. 1, 3:6, 7';
        Notification.error('Please input expression correctly. ' + eg);
      }
    };

    vm.selectFields = function () {
      var fields = vm.fields.filter(function (field) {
        return !field.selected;
      });
      vm.fields.forEach(function (field) {
        if (field.selected) {
          field.selected = false;
          vm.equation.fields.push(field);
        }
      });
      vm.fields = fields;
      updateSummaryExpression();
    };

    vm.done = function () {
      if (!processExpression()) {
        return;
      }

      vm.modalInstance.close(vm.equation);
    };

    vm.cancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    function addBudgetToField(budget, child, childIndex) {
      var found = vm.summary.equation.fields.find(function (x) {
        return x.index === budget.index && x.childIndex === childIndex;
      });
      var field;

      if (found) {
        field = {
          index: found.index,
          childIndex: found.childIndex,
          operator: found.operator,
          title: child ? child.title : budget.title,
          selected: false
        };
        vm.equation.fields.push(field);
      } else {
        field = {
          index: budget.index,
          childIndex: childIndex,
          operator: '+',
          title: child ? child.title : budget.title,
          selected: false
        };
        vm.fields.push(field);
      }

      vm.allFields.push(field);
    }

    function processExpression() {
      if (oldExpression === vm.equation.expression) {
        return true;
      }

      var expression = vm.equation.expression.replace(/\s+/g, '');

      if (vm.equation.type === 'sum' || vm.equation.type === 'avg') {
        if (!/^\d+(?:[:.]\d+)?(?:,\d+(?:[:.]\d+)?)*$/.test(expression)) {
          ///^\d+(?::\d+)?(?:,\d+(?::\d+)?)*$/
          return false;
        }

        vm.equation.fields = [];
        var fieldIndexes = expression.split(',');

        if (fieldIndexes) {
          fieldIndexes.forEach(function (field) {
            if (field.includes(':')) {
              var array = field.split(':');
              if (array.length < 2) return;
              var start = utils.num(array[0]);
              var end = utils.num(array[1]);

              for (var i = start; i <= end; i++) {
                insertField('+', i);
              }
            } else {
              if (field.includes('.')) {
                var a = field.split('.');
                insertField('+', utils.num(a[0]), utils.num(a[1]));
              } else {
                insertField('+', utils.num(field));
              }
            }
          });
        }
      } else {
        if (!/^(?:\d+)*(?:\.)*(?:\d+)*(?:[+-]\d+(?:\.)*(?:\d+)*)*$/.test(expression)) {
          // ^(?:\d+)*(?:[+-]\d+)*$ //^\d+(?:[+-]\d+)*$
          return false;
        }

        vm.equation.fields = [];

        var _fieldIndexes = expression.split(/(?=[+-])/);

        if (_fieldIndexes) {
          _fieldIndexes.forEach(function (x) {
            var op, field;

            if (x.startsWith('+') || x.startsWith('-')) {
              op = x.charAt(0);
              field = x.substring(1);
            } else {
              op = '+';
              field = x;
            }

            if (field.includes('.')) {
              var a = field.split('.');
              insertField(op, utils.num(a[0]), utils.num(a[1]));
            } else {
              insertField(op, utils.num(field));
            }
          });
        }
      }

      vm.fields = vm.allFields.filter(function (field) {
        return vm.equation.fields.findIndex(function (x) {
          return x.index === field.index && x.childIndex === field.childIndex;
        }) === -1;
      });
      updateSummaryExpression();
      return true;
    }

    function updateSummaryExpression() {
      var fields = vm.equation.fields;

      switch (vm.equation.type) {
        case "sum":
          vm.equation.expression = fields.map(getIndex).join(', ');
          break;

        case 'avg':
          vm.equation.expression = fields.map(getIndex).join(', ');
          break;

        case 'math':
          vm.equation.expression = fields.map(function (f) {
            return "".concat(f.operator).concat(getIndex(f));
          }).join('').replace(/^\+/, '');
          break;
      }

      oldExpression = vm.equation.expression;
    }

    function getIndex(field) {
      return field.index + (field.childIndex ? "." + field.childIndex : "");
    }

    function insertField(operator, index, childIndex) {
      if (vm.equation.fields.findIndex(function (f) {
        return f.index === index && childIndex === f.childIndex;
      }) === -1) {
        var field = vm.allFields.find(function (f) {
          return f.index === index && f.childIndex === childIndex;
        });

        if (field) {
          field.operator = operator;
          vm.equation.fields.push(field);
        }
      }
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('addCostModal', {
    controller: addCostModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/modals/addCostModal/addCostModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function addCostModal($scope, localStorageService, Notification, $uibModal, $log, utils) {
    var vm = this;

    vm.$onInit = function () {
      vm.rootCollapsed = true;
      $scope.isGlobalCost = false;
      $scope.isEdit = vm.resolve.isEdit;

      if (!$scope.isEdit) {
        $scope.tableInventory = vm.resolve.costData.tableInventory;
        $scope.hierarchicalCostSeqLast = vm.resolve.costData.hierarchicalCostSeqLast;
        $scope.costPercents = vm.resolve.costData.costPercents;
      } else {
        $scope.tableInventory = vm.resolve.costData.tableInventory;
        $scope.hierarchicalCostSeqLast = vm.resolve.costData.hierarchicalCostSeqLast;
        $scope.costPercents = vm.resolve.costData.costPercents;
        vm.addCostConfig = angular.copy(vm.resolve.costData.currentCost);
        vm.addCostConfig.currentApplyTo = vm.addCostConfig.applyTo;
        loadSelected(vm.addCostConfig);
        $scope.isGlobalCost = vm.addCostConfig.type === 'global';
      }
    };

    $scope.expandRoot = function () {
      vm.rootCollapsed = !vm.rootCollapsed;
    };

    $scope.expandNode = function (icon) {
      if (icon.collapsed) {
        icon.collapsed = false;
        icon.toggle();
      } else {
        icon.collapsed = true;
        icon.toggle();
      }
    };

    $scope.tickSelected = function (node, check, root) {
      if (root) {
        node.isSelected = !check;
      }

      if (node.levels || node.items) {
        parentCheckChange(node, !check);
      }
    };

    function parentCheckChange(node, check) {
      if (node) {
        node.isSelected = check;

        if (node.items) {
          node.items.forEach(function (item) {
            item.isSelected = check;

            if (item.items) {
              item.items.forEach(function (subItem) {
                return subItem.isSelected = check;
              });
            }
          });
        }

        if (node.levels) {
          node.levels.forEach(function (level) {
            return parentCheckChange(level);
          });
        }
      }
    } //apply percentages


    $scope.applyPercentageToSelectedGroup = function () {
      if (!$scope.isGlobalCost && angular.isUndefined(vm.addCostConfig.currentApplyTo)) {
        Notification.error("please select Apply To option");
        return;
      }

      if (utils.isEmpty(vm.addCostConfig.name)) {
        Notification.error("Please input Name.");
        return;
      }

      vm.addCostConfig.value = vm.addCostConfig.value || 0;
      var costSequence = ++$scope.hierarchicalCostSeqLast;
      $scope.costPercents.push({
        addCostSeq: costSequence,
        name: vm.addCostConfig.name,
        value: vm.addCostConfig.value,
        applyTo: vm.addCostConfig.currentApplyTo,
        type: $scope.isGlobalCost ? 'global' : 'normal'
      });

      if (!$scope.isGlobalCost) {
        $scope.tableInventory.forEach(function (group) {
          if (group.isSelected) {
            group.selectedFor.push({
              addCostSeq: costSequence,
              name: vm.addCostConfig.name,
              value: vm.addCostConfig.value,
              applyTo: vm.addCostConfig.currentApplyTo
            });
          }

          markSelected(group, costSequence, vm.addCostConfig.name, vm.addCostConfig.value, vm.addCostConfig.currentApplyTo);
        });
      }

      vm.modalInstance.close({
        costPercents: $scope.costPercents
      });
    };

    $scope.onChangeGlobalCost = function () {
      $scope.isGlobalCost = !$scope.isGlobalCost;
    };

    $scope.editPercentageToSelectedGroup = function () {
      if (!$scope.isGlobalCost && angular.isUndefined(vm.addCostConfig.currentApplyTo)) {
        Notification.error("please select Apply To option");
        return;
      }

      if (utils.isEmpty(vm.addCostConfig.name)) {
        Notification.error("Please input Name.");
        return;
      }

      vm.addCostConfig.value = vm.addCostConfig.value || 0;
      var index = $scope.costPercents.findIndex(function (x) {
        return x.addCostSeq === vm.addCostConfig.addCostSeq;
      });

      if (index === -1) {
        return;
      }

      var updatedItem = {
        addCostSeq: vm.addCostConfig.addCostSeq,
        name: vm.addCostConfig.name,
        value: vm.addCostConfig.value,
        applyTo: vm.addCostConfig.currentApplyTo,
        type: $scope.isGlobalCost ? 'global' : 'normal'
      };
      $scope.costPercents[index] = updatedItem;
      var isGlobalAddtionalCost = $scope.isGlobalCost;
      $scope.tableInventory.forEach(function (group) {
        var index = group.selectedFor.findIndex(function (x) {
          return x.addCostSeq === updatedItem.addCostSeq;
        });

        if (!isGlobalAddtionalCost && group.isSelected) {
          if (index > -1) {
            group.selectedFor[index] = updatedItem;
          } else {
            group.selectedFor.push(updatedItem);
          }
        } else {
          if (index > -1) {
            group.selectedFor.splice(index, 1);
          }
        }

        updateSelected(group, updatedItem, isGlobalAddtionalCost);
      });
      vm.modalInstance.close({
        type: 'update',
        costPercents: $scope.costPercents
      });
    };

    $scope.deletePercentageToSelectedGroup = function () {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        vm.modalInstance.close({
          isGlobal: $scope.isGlobalCost,
          type: 'delete',
          tableInventory: $scope.tableInventory,
          currentCostItem: vm.addCostConfig,
          costPercents: $scope.costPercents
        });
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    function markSelected(level, costSequence, currentCostItem, currentCostPercent, currentApplyTo) {
      if (level.items) {
        level.items.map(function (item) {
          markItemSelected(item, level, costSequence, currentCostItem, currentCostPercent, currentApplyTo);

          if (item.items) {
            item.items.map(function (subItem) {
              markItemSelected(subItem, item, costSequence, currentCostItem, currentCostPercent, currentApplyTo);
            });
          }
        });
      }

      if (level.levels != null) {
        level.levels.forEach(function (item) {
          if ((level.isSelected || item.isSelected) && item.selectedFor) {
            item.isSelected = true;
            item.selectedFor.push({
              addCostSeq: costSequence,
              name: currentCostItem,
              value: currentCostPercent,
              applyTo: currentApplyTo
            });
          }

          markSelected(item, costSequence, currentCostItem, currentCostPercent, currentApplyTo);
        });
      }
    }

    function markItemSelected(item, level, costSequence, currentCostItem, currentCostPercent, currentApplyTo) {
      if (item.inventoryName && (item.isSelected || level.isSelected)) {
        item.isSelected = true;
        item.selectedFor.push({
          addCostSeq: costSequence,
          name: currentCostItem,
          value: currentCostPercent,
          applyTo: currentApplyTo
        });
      }
    }

    function updateSelected(level, currentCostItem, isGlobalAddtionalCost) {
      if (level.items) {
        level.items.map(function (item) {
          updateItemSelected(item, currentCostItem, isGlobalAddtionalCost);

          if (item.items) {
            for (var i = 0; i < item.items.length; i++) {
              updateItemSelected(item.items[i], currentCostItem, isGlobalAddtionalCost);
            }
          }
        });
      }

      if (level.levels != null) {
        level.levels.forEach(function (item) {
          updateSelected(item, currentCostItem);
        });
      }
    }

    function updateItemSelected(item, currentCostItem, isGlobalAddtionalCost) {
      var index = item.selectedFor.findIndex(function (x) {
        return x.addCostSeq === currentCostItem.addCostSeq;
      });

      if (!isGlobalAddtionalCost && item.isSelected) {
        if (index > -1) {
          item.selectedFor[index] = currentCostItem;
        } else {
          item.selectedFor.push(currentCostItem);
        }
      } else {
        if (index > -1) {
          item.selectedFor.splice(index, 1);
        }
      }
    }

    function loadSelected(percent) {
      var seqId = percent.addCostSeq;

      for (var i = 0; i < $scope.tableInventory.length; i++) {
        var group = $scope.tableInventory[i];
        group.isSelected = group.selectedFor.findIndex(function (x) {
          return x.addCostSeq === seqId;
        }) >= 0;
        recurseToMarkSelectedWhenEdit(group, seqId);
      }
    }

    function recurseToMarkSelectedWhenEdit(level, seqId) {
      if (level.items) {
        for (var i = 0; i < level.items.length; i++) {
          var item = level.items[i];
          markSelectedItemWhenEdit(item, seqId);

          if (item.items) {
            for (var j = 0; j < item.items.length; j++) {
              markSelectedItemWhenEdit(item.items[j], seqId);
            }
          }
        }
      }

      if (level.levels) {
        for (var _j = 0; _j < level.levels.length; _j++) {
          var _item = level.levels[_j];

          if (_item.selectedFor) {
            _item.isSelected = _item.selectedFor.findIndex(function (x) {
              return x.addCostSeq === seqId;
            }) >= 0;
            recurseToMarkSelectedWhenEdit(_item, seqId);
          }
        }
      }
    }

    function markSelectedItemWhenEdit(item, seqId) {
      if (item.inventoryName) {
        item.isSelected = item.selectedFor.findIndex(function (x) {
          return x.addCostSeq === seqId;
        }) >= 0;
      } else {
        item.isSelected = false;
      }
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("calcVersionTreediff", calcVersionTreeDiff);

  function calcVersionTreeDiff($timeout) {
    return {
      restrict: "E",
      templateUrl: "app/main/calc/directives/calcVersionTreeDiff/calcVersionTreeDiff.view.html",
      scope: {
        oldData: "=",
        newData: "=",
        oldVersionSeq: "=",
        newVersionSeq: "="
      },
      link: function link($scope) {
        $scope.oldtree = [{
          name: 'Structure Tree',
          levels: []
        }];
        $scope.newtree = [{
          name: 'Structure Tree',
          levels: []
        }];
        $scope.$watch('oldData', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          $scope.oldtree[0].levels = newValue;
          refreshTree();
        });
        $scope.$watch('newData', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          $scope.newtree[0].levels = newValue;
          refreshTree();
        });

        function refreshTree() {
          $timeout(function () {
            $scope.$apply();
            $scope.$broadcast('angular-ui-tree:expand-all');
          });
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("calcVersionDiffContent", calcVersionDiffContent);

  function calcVersionDiffContent($rootScope) {
    return {
      restrict: "E",
      templateUrl: "app/main/calc/directives/calcVersionContent/calcVersionContent.view.html",
      scope: {
        tag: "=",
        version: "=",
        companyData: "=",
        companyCurrency: "="
      },
      link: function link($scope) {
        $scope.openLevel = false;
        $scope.currentStateList = [];
        $scope.levelId = 0;

        $scope.gotoBreadCrumb = function (indexno) {
          $scope.openLevel = true;
          $scope.breadCrumbIndex = indexno;
          $scope.currentState = $scope.version.levels[indexno];
          $scope.currentStateList.push($scope.currentState);
          broadcastLevelEvent($scope.currentState.id, 'inlevels');
        };

        $scope.breadCrumbSubLevel = function (index, sublevel) {
          $scope.currentState = sublevel;
          $scope.currentStateList.push($scope.currentState);
          broadcastLevelEvent($scope.currentState.id, 'fromChild');
        };

        $scope.goToRoot = function () {
          $scope.openLevel = false;
          $scope.currentStateList = [];
          broadcastLevelEvent(null, 'gotoRoot');
        };

        $scope.changeBreadCrumb = function (index) {
          $scope.currentState = $scope.currentStateList[index];
          $scope.currentStateList = $scope.currentStateList.slice(0, index + 1);
          broadcastLevelEvent($scope.currentState.id, 'inStateList');
        };

        $scope.callBreadCrumb = function (index, innerindex, sublevel) {
          $scope.openLevel = true;
          $scope.breadCrumbIndex = index;
          var current = $scope.version.levels[index];
          $scope.currentStateList.push(current);
          $scope.currentState = sublevel;
          $scope.currentStateList.push($scope.currentState);
          broadcastLevelEvent($scope.currentState.id, 'fromRoot');
        };

        function broadcastLevelEvent(id, action) {
          if ($scope.tag == 'left-calc-container') {
            $rootScope.$broadcast('calcLeftLevelChanged', id, action);
          } else {
            $rootScope.$broadcast('calcRightLevelChanged', id, action);
          }
        }

        function onLevelEvent(ev, id, action) {
          if (id) {
            if (action == 'inlevels') {
              var array = $scope.version.levels;

              for (var i = 0; i < array.length; i++) {
                if (array[i].id == id) {
                  $scope.openLevel = true;
                  $scope.breadCrumbIndex = i;
                  $scope.currentState = array[i];
                  $scope.currentStateList.push($scope.currentState);
                  break;
                }
              }
            } else if (action == 'inStateList') {
              var _array = $scope.currentStateList;

              for (var _i = 0; _i < _array.length; _i++) {
                if (_array[_i].id == id) {
                  $scope.currentState = _array[_i];
                  $scope.currentStateList = _array.slice(0, _i + 1);
                  break;
                }
              }
            } else if (action == 'fromRoot') {
              for (var _i2 = 0; _i2 < $scope.version.levels.length; _i2++) {
                var level = $scope.version.levels[_i2];

                if (level.levels && level.levels.length > 0) {
                  for (var j = 0; j < level.levels.length; j++) {
                    if (level.levels[j].id == id) {
                      $scope.openLevel = true;
                      $scope.breadCrumbIndex = _i2;
                      $scope.currentStateList.push(level);
                      $scope.currentState = level.levels[j];
                      $scope.currentStateList.push($scope.currentState);
                      return;
                    }
                  }
                }
              }
            } else if (action == 'fromChild') {
              var _array2 = $scope.currentState.levels;

              if (_array2 && _array2.length > 0) {
                for (var _i3 = 0; _i3 < _array2.length; _i3++) {
                  if (_array2[_i3].id == id) {
                    $scope.currentState = _array2[_i3];
                    $scope.currentStateList.push($scope.currentState);
                    break;
                  }
                }
              }
            }
          } else {
            $scope.openLevel = false;
            $scope.currentStateList = [];
          }
        }

        if ($scope.tag == 'left-calc-container') {
          var calcRightLevelChanged = $rootScope.$on('calcRightLevelChanged', onLevelEvent);
          $rootScope.$on('$destroy', calcRightLevelChanged);
        } else {
          var calcLeftLevelChanged = $rootScope.$on('calcLeftLevelChanged', onLevelEvent);
          $rootScope.$on('$destroy', calcLeftLevelChanged);
        }
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module("app").directive("calcSelector", calcSelector);

  function calcSelector() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/main/calc/directives/calcSelector/calcSelector.view.html',
      require: 'ngModel',
      scope: {
        ngModel: "=",
        ngSelected: "&"
      },
      link: function link($scope) {
        $scope.options = [{
          _id: "Combined",
          name: "Combined",
          sub: [{
            _id: "Combined",
            name: "Material"
          }, {
            _id: "Combined",
            name: "Building Part"
          }, {
            _id: "Combined",
            name: "DCP"
          }, {
            _id: "Combined",
            name: "Equipment"
          }, {
            _id: "Combined",
            name: "DCQ"
          }, {
            _id: "Combined",
            name: "Custom"
          }]
        }, {
          _id: "Inventory",
          name: "Inventory",
          sub: [{
            _id: "Inventory",
            name: "Material"
          }, {
            _id: "Inventory",
            name: "Building Part"
          }, {
            _id: "Inventory",
            name: "DCP"
          }, {
            _id: "Inventory",
            name: "Equipment"
          }, {
            _id: "Inventory",
            name: "DCQ"
          }, {
            _id: "Inventory",
            name: "Custom"
          }]
        }, {
          _id: "Worker",
          name: "Worker"
        }, {
          _id: "Collaborator",
          name: "Collaborator",
          sub: [{
            _id: "Collaborator",
            name: "Supplier"
          }, {
            _id: "Collaborator",
            name: "Subcontractor"
          }]
        }];

        $scope.onShowSub = function (item) {
          item.showSub = true;
        };

        $scope.onHideSub = function (item) {
          item.showSub = false;
        };

        $scope.onItemSelect = function (item) {
          if (item.sub) {
            item.showSub = true;
            return;
          }

          var row = $scope.ngModel;
          row.rowStyle = item._id;
          row.subStyle = item.name;

          if (row.rowStyle == 'Collaborator') {
            row.worker.work = item.name;
          }

          if (row.items) {
            if (row.rowStyle === 'Combined' || row.rowStyle === 'Inventory') {
              row.items.forEach(function (x) {
                return x.rowStyle = row.rowStyle;
              });
            } else {
              row.items = [];
            }
          }

          $scope.ngSelected();
        };
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('calcGroup', {
    controller: CalcGroupController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/directives/calcGroup/calcGroup.view.html',
    bindings: {
      index: '=',
      levelId: "=",
      ngModel: "<",
      workTypes: "=",
      workLevels: '=',
      materials: "=",
      buildingparts: "=",
      dcps: "=",
      equipments: "=",
      dcqs: "=",
      workers: "=",
      subcontractors: "=",
      levelDepth: "=",
      companyCurrency: "=",
      currentStateList: "=",
      globalProfit: "=",
      workerCost: "=",
      costPercents: "=",
      // events
      onRemoveLevel: "=",
      onEnterChild: "=",
      onDeleteSubLevel: "=",
      onUpdateItem: "=",
      onRemoveItem: "=",
      onItemChanged: "=",
      permission: "="
    }
  });

  function CalcGroupController($state, $timeout, $uibModal, apiFactory, globals, utils, Notification, unitFactory) {
    var vm = this;
    var companyStore = globals.companyStore;
    vm.companyData = companyStore.get();
    vm.isFilter = false;
    vm.filterWorkTypes = [{
      name: 'All',
      selected: true
    }];
    vm.mUnits = unitFactory.materialUnits();
    vm.model = [];
    vm.excludeWorkLevelList = [];

    vm.$onInit = function () {
      vm.model = vm.ngModel;
      loadModel();
    };

    vm.$onChanges = function (changes) {
      if (changes.ngModel) {
        vm.model = changes.ngModel.currentValue;
        loadModel();
      }
    };

    vm.onEditLevelName = function () {
      vm.model.isEdit = true;
    };

    vm.onChangeLevelName = function (name) {
      vm.model.name = name;
      vm.model.isEdit = false;

      if (vm.model !== vm.ngModel) {
        vm.ngModel.name = name;
        vm.ngModel.isEdit = false;
      }
    };

    vm.onFilterWorkType = function (model, type) {
      type.selected = !type.selected;
      var newModel = {
        name: model.name,
        items: [],
        levels: [],
        isEdit: false,
        sumCostPrice: 0,
        sumHours: 0,
        sumCompanyCost: 0,
        sumProfit: 0,
        sum: 0
      };

      if (type.name === 'All') {
        vm.filterWorkTypes.forEach(function (item) {
          if (item.name !== 'All') {
            item.selected = false;
          }
        });
        vm.model = type.selected ? model : newModel;
        vm.isFilter = !type.selected;
      } else {
        vm.isFilter = true;
        vm.filterWorkTypes[0].selected = false; // deselect 'all'

        vm.filterWorkTypes.forEach(function (item) {
          if (item.selected) {
            filterItemsByWorkType(item.name, model, newModel);
          }
        });
        newModel.items.forEach(function (item) {
          newModel.sumCostPrice += utils.num(item.currentCostPrice);
          newModel.sumHours += utils.num(item.currentLabourHr);
          newModel.sumCompanyCost += utils.num(item.currentCompanyCost);
          newModel.sumProfit += utils.num(item.currentProfit);
          newModel.sum += utils.num(item.currentSalesPrice);
        });
        vm.model = newModel;
      }
    };

    vm.toggleTree = function (tree) {
      tree.open = !tree.open;
    };

    vm.onAddNewLevel = function () {
      if (vm.levelDepth < 2) {
        vm.excludeWorkLevelList = [];
        vm.model.levels.map(function (le) {
          vm.excludeWorkLevelList.push(le.name);
        });
      }

      var level = {
        id: ++vm.levelId,
        name: "",
        items: [],
        levels: [],
        sum: 0,
        sumHours: 0,
        sumProfit: 0,
        sumCompanyCost: 0,
        sumCostPrice: 0,
        sumInventoryCost: 0,
        sumWorkerCost: 0,
        selectedFor: angular.copy(vm.costPercents),
        isEdit: true,
        isSelected: true
      };
      vm.model.levels.push(level);
    };

    vm.onAddNewItem = function () {
      var item = {
        tempId: utils.bsonId(),
        rowStyle: "Combined",
        subStyle: "Material",
        workLevel: vm.currentStateList[1].name,
        workType: getFilteredWorkType(),
        editMode: 'new'
      };
      vm.model.items.push(item);

      if (vm.model !== vm.ngModel) {
        vm.ngModel.items.push(item);
      }
    };

    vm.onEditSubLevel = function (level) {
      level.isEdit = true;
      vm.excludeWorkLevelList = [];

      if (vm.levelDepth === 1 || vm.levelDepth === 0 || !vm.levelDepth) {
        vm.model.levels.map(function (le) {
          if (level.id !== le.id) {
            vm.excludeWorkLevelList.push(le.name);
          }
        });
      }
    };

    vm.onCancelSubLevelEdit = function (level) {
      var levels = vm.model.levels;

      if (level.name) {
        if (vm.levelDepth < 2) {
          var checkLevel = vm.workLevels.find(function (it) {
            return it.tagName === level.name;
          });

          if (!checkLevel) {
            Notification.error("Please select correct level");
            return;
          }
        }

        $timeout(function () {
          level.isEdit = false;
        }, 500);
      } else {
        if (level.levels && level.levels.length || level.items && level.items.length) {
          if (vm.levelDepth === 1 || vm.levelDepth === 0) {
            Notification.error("Please select level or remove it");
          } else {
            Notification.error("Please input section name");
          }
        } else {
          var index = levels.indexOf(level);
          levels.splice(index, 1);
        }
      }

      if (vm.levelDepth < 2) {
        vm.excludeWorkLevelList = [];
        levels.map(function (le) {
          if (level.id !== le.id) {
            vm.excludeWorkLevelList.push(le.name);
          }
        });
      }
    };

    vm.onCloneLevel = function (level) {
      vm.excludeWorkLevelList = [];
      vm.model.levels.map(function (le) {
        vm.excludeWorkLevelList.push(le.name);
      });
      var newLevel = angular.copy(level);
      newLevel._id = utils.bsonId();
      newLevel.id = ++vm.levelId;
      newLevel.name = "";
      newLevel.isEdit = true;
      newLevel.isSelected = true;
      refreshIdFromLevel(newLevel);
      vm.model.levels.push(newLevel);
      vm.onUpdateItem();
    };

    vm.onChangeWorkLevel = function (level) {
      changeItemsWorkLevel(level, level.name);
    };

    vm.onEditItem = function (item) {
      item.editMode = 'edit';
    };

    vm.onSelectStyle = function (row) {
      if (row.subStyle === "Custom") {
        row.isSelected = true;
        row.inventoryAmount = 1;
        row.workerAmount = 1;
        row.selectedFor = [];
        row.workLevel = vm.currentStateList[1].name;
        row.inventoryUnit = "m";
        row.workerUnit = "hrs";
        row.inventoryUnitPrice = 1;
        row.workerUnitPrice = utils.num(vm.workerCost);
        row.inventoryProfitPercent = vm.globalProfit;
        row.workerProfitPercent = vm.globalProfit;
        row.editMode = 'new';
      } else if (row.subStyle === 'Collaborator') {
        row.inventoryType = 'Material';
        row.workerName = "Collaborator";
        row.workerUnitPrice = utils.num(vm.workerCost);
        row.workerUnit = 'hrs';
        row.inventoryProfitPercent = vm.globalProfit;
        row.workerProfitPercent = vm.globalProfit;
      }

      vm.onUpdateItem(row, 'style');
    };

    vm.onChangeInventory = function (rowStyle, subStyle, materialId, index) {
      var inventories = [];

      switch (subStyle) {
        case 'Material':
          inventories = vm.materials;
          break;

        case 'Building Part':
          inventories = vm.buildingparts;
          break;

        case 'DCP':
          inventories = vm.dcps;
          break;

        case 'Equipment':
          inventories = vm.equipments;
          break;

        case 'DCQ':
          inventories = vm.dcqs;
          break;

        case 'Worker':
          inventories = vm.workers;
          break;

        case 'Collaborator':
          inventories = vm.materials;
          break;
      }

      for (var i = 0; i < inventories.length; i++) {
        if (inventories[i]._id === materialId) {
          var item = vm.model.items[index];
          newRow(item, inventories[i], vm.model, rowStyle, subStyle, item.workType);
          vm.onUpdateItem(item);
          break;
        }
      }
    };

    vm.onChangeWorker = function (item, workerId, index) {
      for (var i = 0; i < vm.workers.length; i++) {
        if (vm.workers[i]._id === workerId) {
          item.workerID = workerId;
          item.workerName = vm.workers[i].description;
          item.workerAmount = 1;
          item.workerProfitPercent = vm.globalProfit;
          vm.model.items[index] = item;
          break;
        }
      }
    };

    vm.onChangeWorkType = function (item) {
      var workType = item.workType;
      var index = vm.filterWorkTypes.findIndex(function (x) {
        return x.name === workType;
      });

      if (index === -1) {
        vm.filterWorkTypes.push({
          name: workType,
          selected: vm.isFilter
        });
      }

      var workTypes = getWorkTypes();
      vm.filterWorkTypes = vm.filterWorkTypes.filter(function (filter) {
        return filter.name === 'All' || workTypes.findIndex(function (x) {
          return x === filter.name;
        }) !== -1;
      });
    };

    vm.onLocViewLevel = function (subLevel) {
      if (subLevel.modelId && subLevel.modelType) {
        $uibModal.open({
          animation: true,
          component: 'modelViewModal',
          windowClass: 'calc-model-view-modal',
          resolve: {
            model: function model() {
              return {
                modelId: subLevel.modelId,
                type: subLevel.modelType
              };
            }
          }
        });
      }
    };

    vm.onLocViewItem = function (item) {
      if (item.modelId && item.modelType) {
        $uibModal.open({
          animation: true,
          component: 'modelViewModal',
          windowClass: 'calc-model-view-modal',
          resolve: {
            model: function model() {
              return {
                modelId: item.modelId,
                type: item.modelType,
                objectId: item.objectId
              };
            }
          }
        });
      }
    };

    vm.onViewDetailLevel = function () {//TODO: need to work
    };

    vm.onViewDetailItem = function () {//TODO: need to work
    };

    vm.onOpenUnitsDropdown = function (key) {
      if (key === "MAT") {
        vm.rowForUnit = "MAT";
        vm.mUnits = unitFactory.materialUnits();
      } else if (key === "WOR") {
        vm.rowForUnit = "WOR";
        vm.mUnits = unitFactory.timeUnits();
      } else if (key === "SUB") {
        vm.rowForUnit = "SUB";
        vm.mUnits = unitFactory.timeUnits();
      }
    };

    vm.onUnitSelect = function (unit, item, key, isSub) {
      if (key === "MAT") {
        if (item.subStyle === 'DCP' || item.subStyle === 'DCQ' || isSub) {
          if (unit.name === 'pcs') {
            if (item.inventoryUnit !== unit.name) {
              item.inventoryAmount = utils.num(item.inventoryAmount) * 0.8;
              item.inventoryUnitPrice = utils.num(item.inventoryUnitPrice) / 0.8;
            }
          } else if (item.inventoryUnit === 'pcs') {
            item.inventoryAmount = utils.num(item.inventoryAmount) / 0.8;
            item.inventoryUnitPrice = utils.num(item.inventoryUnitPrice) * 0.8;
          }
        }

        item.inventoryUnit = unit.name;
      } else {
        // WOR
        if (item.subStyle === 'DCP' || item.subStyle === 'DCQ' || isSub) {
          if (unit.name === 'pcs') {
            if (item.workerUnit !== unit.name) {
              item.workerAmount = utils.num(item.workerAmount) * 0.8;
              item.workerUnitPrice = utils.num(item.workerUnitPrice) / 0.8;
            }
          } else if (item.workerUnit === 'pcs') {
            item.workerAmount = utils.num(item.workerAmount) / 0.8;
            item.workerUnitPrice = utils.num(item.workerUnitPrice) * 0.8;
          }
        }

        item.workerUnit = unit.name;
      }
    };

    vm.onConfirmEditItem = function (item) {
      var emptyField = false;

      switch (item.rowStyle) {
        case 'Combined':
          emptyField = utils.isEmpty(item.workerName) || utils.isEmpty(item.workType) || utils.isEmpty(item.inventoryAmount) || utils.isEmpty(item.workerAmount) || utils.isEmpty(item.inventoryUnitPrice) || utils.isEmpty(item.workerUnitPrice);

          if (item.subStyle !== "Custom") {
            emptyField = emptyField || utils.isEmpty(item.matID);
          }

          break;

        case 'Inventory':
          emptyField = utils.isEmpty(item.workType) || utils.isEmpty(item.inventoryAmount) || utils.isEmpty(item.inventoryUnitPrice);

          if (item.subStyle !== "Custom") {
            emptyField = emptyField || utils.isEmpty(item.matID);
          }

          break;

        case 'Worker':
          emptyField = utils.isEmpty(item.workerName) || utils.isEmpty(item.workType) || utils.isEmpty(item.workerAmount) || utils.isEmpty(item.workerUnit) || utils.isEmpty(item.workerUnitPrice);
          break;

        case 'Collaborator':
          emptyField = utils.isEmpty(item.inventoryName) || utils.isEmpty(item.workType) || utils.isEmpty(item.inventoryAmount) || utils.isEmpty(item.inventoryUnitPrice) || utils.isEmpty(item.workerAmount);
          break;
      }

      if (emptyField) {
        Notification.error('Please input empty field.');
      } else {
        item.editMode = undefined;
      }

      vm.onItemChanged();
    };

    vm.onDeleteItem = function (level, index) {
      var item = level.items[index];
      level.items.splice(index, 1);

      if (vm.model !== vm.ngModel) {
        removeRow(vm.ngModel, item);
      }

      vm.onRemoveItem(item);
    };

    function loadModel() {
      var filterWorkTypes = [{
        name: 'All',
        selected: true
      }];

      if (vm.model) {
        var workTypes = {};
        loadCalcLevel(vm.model, workTypes);

        for (var key in workTypes) {
          filterWorkTypes.push({
            name: workTypes[key],
            selected: false
          });
        }
      }

      vm.filterWorkTypes = filterWorkTypes;
    }

    function loadCalcLevel(level, workTypes) {
      if (level.levels) {
        level.levels.forEach(function (group) {
          loadCalcLevel(group, workTypes);
        });
      }

      if (level.items) {
        var _loop = function _loop(i) {
          var item = level.items[i];

          if (!item.modelId && level.modelId) {
            item.modelId = level.modelId;
            item.modelType = level.modelType;
          }

          if (item.subStyle == 'DCP') {
            // item.quantity = vm.dcps[i].quantity;
            var dcp = vm.dcps.find(function (x) {
              return x.name == item.inventoryName;
            });
            item.items.forEach(function (x, index) {
              x.quantity = dcp.comboMaterialList[index].quantity;
            });
          }

          if (item.inventoryName) {
            if (item.workType) {
              workTypes[item.workType] = item.workType;
            }
          }
        };

        for (var i = 0; i < level.items.length; i++) {
          _loop(i);
        }
      }
    }

    function filterItemsByWorkType(type, model, newModel) {
      if (model.levels) {
        model.levels.forEach(function (group) {
          filterItemsByWorkType(type, group, newModel);
        });
      }

      if (model.items) {
        model.items.forEach(function (item) {
          if (item.workType === type) {
            newModel.items.push(item);
          }
        });
      }
    }

    function changeItemsWorkLevel(level, levelName) {
      if (level.items && level.items.length > 0) {
        for (var i = 0; i < level.items.length; i++) {
          var item = level.items[i];

          if (item != null) {
            item.workLevel = levelName;
          }
        }
      }

      if (level.levels != null && level.levels.length > 0) {
        level.levels.forEach(function (sublevel) {
          changeItemsWorkLevel(sublevel, levelName);
        });
      }
    } //New Row Calculations


    function newRow(row, inventory, parent, rowStyle, subStyle, workType) {
      row.isSelected = true;
      row.matID = inventory._id;
      row.inventoryName = inventory.name;
      row.inventoryAmount = 1;
      row.workerAmount = 1;
      row.inventoryUnit = inventory.unit;
      row.workerUnit = inventory.unit;
      row.rowStyle = rowStyle;
      row.subStyle = subStyle;
      row.selectedFor = [];
      row.workType = workType;
      row.workLevel = vm.currentStateList[1].name;
      row.editMode = 'new';

      if (subStyle === 'Material') {
        row.inventoryType = 'Material';
        row.workerName = "Worker";
        row.inventoryUnitPrice = utils.num(inventory.baseRate.materialCost);
        row.workerUnitPrice = utils.num(inventory.baseRate.rooferCost);
      } else if (subStyle === 'DCP') {
        // DCP
        row.inventoryType = 'ComboMaterial';
        row.workerName = "Worker";
        row.inventoryUnitPrice = utils.num(inventory.totalMaterialCost);
        row.workerUnitPrice = utils.num(inventory.totalRooferCost);
        row.items = [];

        if (inventory.comboMaterialList) {
          inventory.comboMaterialList.map(function (comboMaterial) {
            if (comboMaterial.materialId) {
              var material = comboMaterial.materialId;
              material.baseRate = comboMaterial.baseCost;
              var sub = {};
              sub.quantity = comboMaterial.quantity;
              newRow(sub, material, parent, rowStyle, 'Material', workType);
              sub.editMode = undefined;
              row.items.push(sub);
            } else if (comboMaterial.equipmentId) {
              var equipment = comboMaterial.equipmentId;
              equipment.baseRate = comboMaterial.baseCost;
              var _sub = {};
              newRow(_sub, equipment, parent, rowStyle, 'Equipment', workType);
              _sub.editMode = undefined;
              row.items.push(_sub);
            }
          });
        }
      } else if (subStyle === 'Equipment') {
        row.inventoryType = 'Equipment';
        row.workerName = "Worker";
        row.inventoryUnitPrice = utils.num(inventory.baseRate.equipmentCost);
        row.workerUnitPrice = utils.num(inventory.baseRate.rooferCost);
      } else if (subStyle === 'DCQ') {
        // DCQ
        row.inventoryType = 'ComboEquipment';
        row.workerName = "Worker";
        row.inventoryUnitPrice = utils.num(inventory.totalEquipmentCost);
        row.workerUnitPrice = utils.num(inventory.totalRooferCost);
        row.items = [];

        if (inventory.comboMaterialList) {
          inventory.comboMaterialList.map(function (comboMaterial) {
            if (comboMaterial.materialId) {
              var material = comboMaterial.materialId;
              material.baseRate = comboMaterial.baseCost;
              var sub = {};
              newRow(sub, material, parent, rowStyle, 'Material', workType);
              sub.editMode = undefined;
              row.items.push(sub);
            } else if (comboMaterial.equipmentId) {
              var equipment = comboMaterial.equipmentId;
              equipment.baseRate = comboMaterial.baseCost;
              var _sub2 = {};
              newRow(_sub2, equipment, parent, rowStyle, 'Equipment', workType);
              _sub2.editMode = undefined;
              row.items.push(_sub2);
            }
          });
        }
      } else if (subStyle === 'Worker') {
        row.workerID = inventory._id;
        row.workerName = inventory.description;
        row.inventoryUnitPrice = 0;
        row.workerUnitPrice = utils.num(vm.workerCost);
        row.workerUnit = 'hrs';
      } else if (subStyle === 'Collaborator') {
        row.inventoryType = 'Material';
        row.workerName = "Collaborator";
        row.inventoryUnitPrice = utils.num(inventory.baseRate.materialCost);
        row.workerUnitPrice = utils.num(vm.workerCost);
        row.workerUnit = 'hrs';
      } else {
        row.workerName = "Worker";
        row.inventoryUnitPrice = 0;
        row.workerUnitPrice = 0;
      }

      row.systemTag = inventory.systemTag; // Waste Percent

      if (inventory.wastePercentage) {
        row.wastePercent = inventory.wastePercentage;
        row.wasteAmount = row.inventoryAmount * (row.wastePercent / 100);
      } else {
        row.wastePercent = 0;
        row.wasteAmount = row.inventoryAmount * (row.wastePercent / 100);
      } // Profit Percent


      row.inventoryProfitPercent = vm.globalProfit;
      row.workerProfitPercent = vm.globalProfit;
    }

    function removeRow(level, row) {
      var deletedIndex = -1;

      if (row._id) {
        deletedIndex = level.items.findIndex(function (x) {
          return x._id === row._id;
        });
      } else if (row.tempId) {
        deletedIndex = level.items.findIndex(function (x) {
          return x.tempId === row.tempId;
        });
      }

      if (deletedIndex !== -1) {
        level.items.splice(deletedIndex, 1);
        return true;
      } else {
        if (level.levels) {
          for (var i = 0; i < level.levels.length; i++) {
            if (removeRow(level.levels[i], row)) return true;
          }
        }
      }

      return false;
    }

    function getFilteredWorkType() {
      var workTypes = [];
      vm.filterWorkTypes.forEach(function (filter) {
        if (filter.selected && filter.name !== 'All') {
          workTypes.push(filter.name);
        }
      });
      return workTypes.length === 1 ? workTypes[0] : undefined;
    }

    function getWorkTypes() {
      var allWorkTypes = [];
      var workTypes = {};
      getLevelWorkTypes(vm.model, workTypes);

      for (var key in workTypes) {
        if (workTypes[key]) {
          allWorkTypes.push(workTypes[key]);
        }
      }

      return allWorkTypes;
    }

    function getLevelWorkTypes(level, workTypes) {
      if (level.levels) {
        level.levels.forEach(function (group) {
          getLevelWorkTypes(group, workTypes);
        });
      }

      if (level.items) {
        level.items.forEach(function (item) {
          if (item.workType) {
            workTypes[item.workType] = item.workType;
          }
        });
      }
    }

    function refreshIdFromLevel(level) {
      level._id = utils.bsonId();

      if (level.levels && level.levels.length > 0) {
        level.levels.forEach(function (subLevel) {
          refreshIdFromLevel(subLevel);
        });
      }

      if (level.items && level.items.length > 0) {
        level.items.forEach(function (item) {
          item._id = utils.bsonId();

          if (item.items && item.items.length > 0) {
            item.items.forEach(function (subItem) {
              return subItem._id = utils.bsonId();
            });
          }
        });
      }
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('calcFixedGroup', {
    controller: CalcFixedGroupController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/directives/calcFixedGroup/calcFixedGroup.view.html',
    bindings: {
      index: '=',
      ngModel: "<",
      checkable: "@",
      companyCurrency: "=",
      onEnterChild: "="
    }
  });

  function CalcFixedGroupController() {
    var vm = this;
    vm.model = [];

    vm.$onInit = function () {
      vm.model = vm.ngModel;
    };

    vm.$onChanges = function (changes) {
      if (changes.ngModel) {
        vm.model = changes.ngModel.currentValue;
      }
    };

    vm.toggleTree = function (tree) {
      tree.open = !tree.open;
    };
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("calcExtraGroup", {
    controller: CalcExtraGroupController,
    controllerAs: "vm",
    templateUrl: "app/main/calc/directives/calcExtraGroup/calcExtraGroup.view.html",
    bindings: {
      ngModel: "<",
      currency: "=",
      types: "=",
      workLevels: "="
    }
  });

  function CalcExtraGroupController(globals, utils, unitFactory) {
    var vm = this;
    var companyStore = globals.companyStore;
    var companyData = companyStore.get();
    vm.companyCost = utils.num(companyData.companyCost) / 100;
    vm.companyProfit = utils.num(companyData.profit);
    vm.rows = [];
    vm.summary = {};
    vm.units = unitFactory.materialUnits() || [];

    vm.$onChanges = function (changes) {
      if (changes.ngModel) {
        vm.rows = vm.ngModel.items || [];
        vm.summary = vm.ngModel.summary;
      }
    };

    vm.addType = function () {};

    vm.addRow = function (index) {
      var row = {
        type: "",
        name: "",
        duration: 0,
        quantity: 0,
        unit: "m",
        unitPrice: 0,
        costPrice: 0,
        companyCost: 0,
        profitPercent: 0,
        profit: 0,
        salesPrice: 0,
        items: []
      };

      if (angular.isDefined(index)) {
        vm.rows.insert(index + 1, row);
      } else {
        vm.rows.push(row);
      }
    };

    vm.removeRow = function (index) {
      vm.rows.splice(index, 1);
    };

    vm.addItem = function (row, index) {
      var item = {
        type: row.type,
        name: "",
        duration: 0,
        quantity: 0,
        unit: "m",
        unitPrice: 0,
        costPrice: 0,
        companyCost: 0,
        profitPercent: vm.companyProfit,
        profit: 0,
        salesPrice: 0
      };

      if (angular.isDefined(index)) {
        row.items.insert(index + 1, item);
      } else {
        row.items.push(item);
      }

      row.expand = true;
    };

    vm.removeItem = function (row, index) {
      row.items.splice(index, 1);
    };

    vm.updateItem = function (item, fieldName, parent) {
      if (fieldName === "quantity" || fieldName === "unitPrice" || fieldName === "profitPercent") {
        calcItem(item);
      }

      if (parent) {
        updateParent(parent, item, fieldName);
      }

      calcSummary(vm.summary, vm.rows);
    };

    function calcItem(item) {
      var profitPercent = item.profitPercent / 100;
      item.costPrice = utils.num(item.quantity) * utils.num(item.unitPrice);
      item.salesPrice = 1 - profitPercent - vm.companyCost > 0 ? item.costPrice / (1 - profitPercent - vm.companyCost) : 0;
      item.companyCost = item.salesPrice * vm.companyCost;
      item.profit = item.salesPrice * profitPercent;
    }

    function updateParent(parent, item, fieldName) {
      if (fieldName === "quantity") {
        parent.quantity = parent.items.reduce(function (acc, x) {
          return acc + utils.num(x.quantity);
        }, 0);
      } else if (fieldName === "duration") {
        parent.duration = parent.items.reduce(function (acc, x) {
          return acc + utils.num(x.duration);
        }, 0);
      } else if (fieldName === "unitPrice") {
        parent.unitPrice = parent.items.reduce(function (acc, x) {
          return acc + utils.num(x.unitPrice);
        }, 0);
      }

      calcSummary(parent, parent.items);
    }

    function calcSummary(summary, items) {
      var costPrice = 0,
          companyCost = 0,
          profit = 0,
          salesPrice = 0;
      items.forEach(function (item) {
        costPrice += utils.num(item.costPrice);
        companyCost += utils.num(item.companyCost);
        profit += utils.num(item.profit);
        salesPrice += utils.num(item.salesPrice);
      });
      summary.costPrice = costPrice;
      summary.companyCost = companyCost;
      summary.profit = profit;
      summary.salesPrice = salesPrice;
      summary.profitPercent = salesPrice === 0 ? 0 : profit / salesPrice * 100;
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('budgetGroup', {
    controller: BudgetGroupController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/directives/budgetGroup/budgetGroup.view.html',
    bindings: {
      type: '=',
      ngModel: "<",
      currency: "=",
      permission: "="
    }
  });

  function BudgetGroupController($state, $uibModal, $log, utils, $filter) {
    var vm = this;
    vm.filters = [{
      groups: [],
      groupId: undefined,
      group: undefined
    }];
    vm.budget = [];
    vm.level = undefined;

    vm.$onChanges = function (changes) {
      if (changes.ngModel) {
        vm.filters[0].groups = vm.ngModel;
        vm.filters[0].groupId = 'all';

        switch (vm.type) {
          case 'all':
            vm.groupTypeName = 'Budget Name';
            break;

          case 'mat':
            vm.groupTypeName = 'Material Group';
            break;

          case 'eqp':
            vm.groupTypeName = 'Equipment Group';
            break;

          case 'lab':
            vm.groupTypeName = 'Material Group';
            break;

          case 'sup':
            vm.groupTypeName = 'Supplier Name';
            break;

          case 'sub':
            vm.groupTypeName = $filter('translate')('Sub-Contractor Name');
            break;
        }

        vm.selectGroup(vm.filters[0], 0);
      }
    };

    vm.isLabor = function (budget) {
      return budget.type === 'lab' || vm.type === 'lab';
    };

    vm.isEquipment = function (budget) {
      return budget.type === 'eqp' || vm.type === 'eqp';
    };

    vm.selectGroup = function (filter, index) {
      if (!filter.groups) return;
      filter.group = filter.groups.find(function (x) {
        return x._id === filter.groupId;
      });

      if (vm.filters.length > index + 1) {
        vm.filters.splice(index + 1, vm.filters.length - index - 1);
      }

      if (filter.groupId !== 'all' && filter.group.levels && filter.group.levels.length > 0) {
        var newFilter = {
          groups: [{
            _id: 'all',
            name: $filter('translate')('All'),
            budgets: filter.group.budgets
          }],
          groupId: 'all'
        };
        filter.group.levels.forEach(function (level) {
          return newFilter.groups.push(level);
        });
        newFilter.group = newFilter.groups[0];
        vm.filters.push(newFilter);
      }

      vm.level = filter.group;
      vm.budget = getBudget(vm.level, vm.type);
    };

    vm.changeItemNegotiated = function (item, budget, isLabour) {
      var diff;

      if (isLabour) {
        diff = item.workersPriceNOld ? item.workersPriceN - item.workersPriceNOld : item.workersPriceN - item.workerCostPrice;
        item.workerProfitN = item.workerCostPrice - item.workersPriceN;
        item.workersPriceNOld = item.workersPriceN;
        applyNToSubItems(item.subItems, item.workersPriceN, true);
      } else {
        diff = item.salesPriceNOld ? item.salesPriceN - item.salesPriceNOld : item.salesPriceN - item.inventoryCostPrice;
        item.inventoryProfitN = item.inventoryCostPrice - item.salesPriceN;
        item.salesPriceNOld = item.salesPriceN;
        applyNToSubItems(item.subItems, item.salesPriceN, false);
      }

      budget.negotiatedPrice += diff;
      budget.profitN -= diff;
      budget.negotiatedPriceOld = budget.negotiatedPrice;
      applyNDiffToTotal(vm.budget, diff); // if (budget.type === 'mat' || budget.type === 'eqp') {
      //   rearrangeBudgetLevel(vm.level.budgets.supplier);
      // } else if (budget.type === 'sup') {
      //   rearrangeBudgetLevel(vm.level.budgets.material);
      //   rearrangeBudgetLevel(vm.level.budgets.equipment);
      // }

      refreshBudgetGroups(vm.ngModel, budget.type);
    };

    vm.changeBudgetNegotiated = function (budget) {
      changeBudgetNegotiated(budget);
      var diff = budget.negotiatedPrice - budget.negotiatedPriceOld;
      budget.negotiatedPriceOld = budget.negotiatedPrice;
      applyNDiffToTotal(vm.budget, diff);

      if (vm.type === 'all') {
        vm.budget.budgets.forEach(function (budget) {
          return applyNDiffToTotal(budget, diff);
        });
      } else {
        applyNDiffToTotal(vm.level.budgets.all, diff);
      } // if (budget.type === 'mat' || budget.type === 'eqp') {
      //   rearrangeBudgetLevel(vm.level.budgets.supplier);
      // } else if (budget.type === 'sup') {
      //   rearrangeBudgetLevel(vm.level.budgets.material);
      //   rearrangeBudgetLevel(vm.level.budgets.equipment);
      // }


      refreshBudgetGroups(vm.ngModel, budget.type);
    };

    vm.changeBudgetAllNegotiated = function (budget) {
      if (budget.budgets) {
        var total = 0;
        var isZero = true;
        var negotiated = budget.negotiatedPrice;
        budget.budgets.forEach(function (item) {
          total += item.negotiatedPrice;

          if (item.negotiatedPrice !== 0) {
            isZero = false;
          }
        });

        if (isZero) {
          var length = budget.budgets.length;
          budget.budgets.forEach(function (item) {
            item.negotiatedPrice = negotiated / length;
            changeBudgetNegotiated(item);
            item.negotiatedPriceOld = item.negotiatedPrice;
          });
        } else {
          if (total === 0) total = 1;
          budget.budgets.forEach(function (item) {
            item.negotiatedPrice = negotiated * item.negotiatedPrice / total;
            changeBudgetNegotiated(item);
            item.negotiatedPriceOld = item.negotiatedPrice;
          });
        }
      }

      budget.profitN = budget.costPrice - budget.negotiatedPrice;
      var diff = budget.negotiatedPrice - budget.negotiatedPriceOld;
      budget.negotiatedPriceOld = budget.negotiatedPrice;
      budget.profitNPercent = budget.negotiatedPrice === 0 ? 0 : budget.profitN * 100 / budget.negotiatedPrice;
      applyNDiffToTotal(vm.budget, diff); // if (budget.type === 'mat' || budget.type === 'eqp') {
      //   rearrangeBudgetLevel(vm.level.budgets.supplier);
      // } else if (budget.type === 'sup') {
      //   rearrangeBudgetLevel(vm.level.budgets.material);
      //   rearrangeBudgetLevel(vm.level.budgets.equipment);
      // }

      refreshBudgetGroups(vm.ngModel, budget.type);
    };

    vm.viewItem = function (item) {
      if (item.matID) {
        if (item.inventoryType === 'Equipment') {
          $state.go('equipmentDetail', {
            id: item.matID
          });
        } else {
          $state.go('materialDetail', {
            id: item.matID
          });
        }
      }
    };

    vm.locViewItem = function (item) {
      if (item.modelId && item.modelType) {
        $uibModal.open({
          animation: true,
          component: 'modelViewModal',
          windowClass: 'calc-model-view-modal',
          resolve: {
            model: function model() {
              return {
                modelId: item.modelId,
                type: item.modelType,
                objectId: item.objectId
              };
            }
          }
        });
      }
    };
    /*
    vm.deleteItem = function (item) {
    }
     vm.deleteBudget = function (budget) {
    }
    */


    function changeBudgetNegotiated(budget) {
      if (budget.items) {
        var total = 0;
        var isZero = true;
        var negotiated = budget.negotiatedPrice;
        budget.items.forEach(function (item) {
          var ne = budget.type === 'lab' ? utils.num(item.workersPriceN) : utils.num(item.salesPriceN);
          total += ne;

          if (ne !== 0) {
            isZero = false;
          }
        });
        if (total === 0) total = 1;
        budget.items.forEach(function (item) {
          if (budget.type === 'lab') {
            item.workersPriceN = isZero ? negotiated / budget.items.length : negotiated * utils.num(item.workersPriceN) / total;
            item.workerProfitN = item.workerCostPrice - item.workersPriceN;
            item.workersPriceNOld = item.workersPriceN;
            applyNToSubItems(item.subItems, item.workersPriceN, true);
          } else {
            item.salesPriceN = isZero ? negotiated / budget.items.length : negotiated * utils.num(item.salesPriceN) / total;
            item.inventoryProfitN = item.inventoryCostPrice - item.salesPriceN;
            item.salesPriceNOld = item.salesPriceN;
            applyNToSubItems(item.subItems, item.salesPriceN, false);
          }
        });
      }

      budget.profitN = budget.costPrice - budget.negotiatedPrice;
    }

    function applyNToSubItems(items, negotiated, isLabor) {
      if (!items || items.length === 0) return;
      var total = 0;
      var isZero = true;
      items.forEach(function (item) {
        var ne = isLabor ? utils.num(item.workersPriceN) : utils.num(item.salesPriceN);
        total += ne;

        if (ne !== 0) {
          isZero = false;
        }
      });
      if (total === 0) total = 1;
      items.forEach(function (item) {
        if (isLabor) {
          item.workersPriceN = isZero ? negotiated / items.length : negotiated * utils.num(item.workersPriceN) / total;
          item.workerProfitN = item.workerCostPrice - item.workersPriceN;
          item.workersPriceNOld = item.workersPriceN;
          item.workerProfitNPercent = item.workersPriceN === 0 ? 0 : item.workerProfitN * 100 / item.workersPriceN;
        } else {
          item.salesPriceN = isZero ? negotiated / items.length : negotiated * utils.num(item.salesPriceN) / total;
          item.inventoryProfitN = item.inventoryCostPrice - item.salesPriceN;
          item.salesPriceNOld = item.salesPriceN;
          item.inventoryProfitNPercent = item.salesPriceN === 0 ? 0 : item.inventoryProfitN * 100 / item.salesPriceN;
        }
      });
    }

    function applyNDiffToTotal(budgetTotal, diff) {
      budgetTotal.negotiatedPrice += diff;
      budgetTotal.profitN -= diff;
      budgetTotal.profitNPercent = budgetTotal.negotiatedPrice === 0 ? 0 : budgetTotal.profitN / budgetTotal.negotiatedPrice * 100;
      budgetTotal.negotiatedPriceOld = budgetTotal.negotiatedPrice;
    }

    function rearrangeBudgetLevel(budgetLevel) {
      budgetLevel.costPrice = 0;
      budgetLevel.calculatedPrice = 0;
      budgetLevel.negotiatedPrice = 0;
      budgetLevel.negotiatedPriceOld = 0;
      budgetLevel.profitPercent = 0;
      budgetLevel.profit = 0;
      budgetLevel.profitN = 0;
      budgetLevel.profitNPercent = 0;
      budgetLevel.budgets.forEach(function (budget) {
        budget.costPrice = 0;
        budget.calculatedPrice = 0;
        budget.negotiatedPrice = 0;
        budget.negotiatedPriceOld = 0;
        budget.profitPercent = 0;
        budget.profit = 0;
        budget.profitN = 0;
        budget.profitNPercent = 0;

        if (budget.budgets && budget.budgets.length > 0) {
          rearrangeBudgetLevel(budget);
        }

        if (budget.items) {
          budget.items.forEach(function (item) {
            if (item.subItems) {
              if (budget.type === 'lab') {
                item.workersPriceN = 0;
                item.workerProfitN = 0;
                item.subItems.forEach(function (subItem) {
                  item.workersPriceN += subItem.workersPriceN;
                  item.workerProfitN += subItem.workerProfitN;
                });
                item.workersPriceNOld = item.workersPriceN;
                item.workerProfitNPercent = item.workersPriceN === 0 ? 0 : item.workerProfitN / item.workersPriceN * 100;
              } else {
                item.salesPriceN = 0;
                item.inventoryProfitN = 0;
                item.subItems.forEach(function (subItem) {
                  item.salesPriceN += subItem.salesPriceN;
                  item.inventoryProfitN += subItem.inventoryProfitN;
                });
                item.salesPriceNOld = item.salesPriceN;
                item.inventoryProfitNPercent = item.salesPriceN === 0 ? 0 : item.inventoryProfitN / item.salesPriceN * 100;
              }
            }

            if (budget.type === 'lab') {
              budget.costPrice += item.workerCostPrice;
              budget.calculatedPrice += item.workersPrice;
              budget.negotiatedPrice += item.workersPriceN;
              budget.profit += item.workerProfit;
              budget.profitN += item.workerProfitN;
            } else {
              budget.costPrice += item.inventoryCostPrice;
              budget.calculatedPrice += item.salesPrice;
              budget.negotiatedPrice += item.salesPriceN;
              budget.profit += item.inventoryProfit;
              budget.profitN += item.inventoryProfitN;
            }
          });
        }

        budget.profitPercent = budget.calculatedPrice === 0 ? 0 : budget.profit / budget.calculatedPrice * 100;
        budget.profitNPercent = budget.negotiatedPrice === 0 ? 0 : budget.profitN / budget.negotiatedPrice * 100;
        budget.negotiatedPriceOld = budget.negotiatedPrice;
        budgetLevel.costPrice += budget.costPrice;
        budgetLevel.calculatedPrice += budget.calculatedPrice;
        budgetLevel.negotiatedPrice += budget.negotiatedPrice;
        budgetLevel.profit += budget.profit;
        budgetLevel.profitN += budget.profitN;
      });
      budgetLevel.negotiatedPriceOld = budgetLevel.negotiatedPrice;
      budgetLevel.profitPercent = budgetLevel.calculatedPrice === 0 ? 0 : budgetLevel.profit / budgetLevel.calculatedPrice * 100;
      budgetLevel.profitNPercent = budgetLevel.negotiatedPrice === 0 ? 0 : budgetLevel.profitN / budgetLevel.negotiatedPrice * 100;
    }

    function rearrangeBudgetLevelAll(budgetLevel) {
      budgetLevel.all.costPrice = 0;
      budgetLevel.all.calculatedPrice = 0;
      budgetLevel.all.negotiatedPrice = 0;
      budgetLevel.all.negotiatedPriceOld = 0;
      budgetLevel.all.profitPercent = 0;
      budgetLevel.all.profit = 0;
      budgetLevel.all.profitN = 0;
      budgetLevel.all.profitNPercent = 0;
      var keys = ['supplier', 'labor', 'subcontractor'];

      for (var i = 0; i < keys.length; i++) {
        var budget = budgetLevel[keys[i]];

        if (budget.budgets.length > 0) {
          budgetLevel.all.costPrice += budget.costPrice;
          budgetLevel.all.calculatedPrice += budget.calculatedPrice;
          budgetLevel.all.negotiatedPrice += budget.negotiatedPrice;
          budgetLevel.all.profit += budget.profit;
          budgetLevel.all.profitN += budget.profitN;
        }
      }

      budgetLevel.all.profitPercent = budgetLevel.all.calculatedPrice === 0 ? 0 : budgetLevel.all.profit / budgetLevel.all.calculatedPrice * 100;
      budgetLevel.all.profitNPercent = budgetLevel.all.negotiatedPrice === 0 ? 0 : budgetLevel.all.profitN / budgetLevel.all.negotiatedPrice * 100;
      budgetLevel.all.negotiatedPriceOld = budgetLevel.all.negotiatedPrice;
    }

    function refreshBudgetGroups(groups, budgetType) {
      if (utils.isEmpty(groups)) return;
      groups.forEach(function (group) {
        var budget = getBudget(group, budgetType);
        rearrangeBudgetLevel(budget);

        if (budgetType === 'mat' || budgetType === 'eqp') {
          rearrangeBudgetLevel(group.budgets.supplier);
        } else if (budgetType === 'sup') {
          rearrangeBudgetLevel(group.budgets.material);
          rearrangeBudgetLevel(group.budgets.equipment);
        }

        rearrangeBudgetLevelAll(group.budgets);

        if (group.levels && group.levels.length > 0) {
          refreshBudgetGroups(group.levels, budgetType);
        }
      });
    }

    function getBudget(group, budgetType) {
      switch (budgetType) {
        case 'all':
          return group.budgets.all;

        case 'mat':
          return group.budgets.material;

        case 'eqp':
          return group.budgets.equipment;

        case 'lab':
          return group.budgets.labor;

        case 'sup':
          return group.budgets.supplier;

        case 'sub':
          return group.budgets.subcontractor;

        default:
          return [];
      }
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('companyBudgetTemplate', {
    controller: CompanyBudgetTemplateController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/companyBudget/template/companyBudgetTemplate.view.html'
  });

  function CompanyBudgetTemplateController($scope, $state, $log, $uibModal, apiFactory, localStorageService, utils, Notification, $filter) {
    var vm = this;
    vm.templates = [];
    vm.sections = [];
    vm.budgets = [];
    vm.summaries = [];
    vm.equations = [{
      id: 'sum',
      label: 'SUM'
    }, {
      id: 'avg',
      label: 'AVG'
    }, {
      id: 'math',
      label: 'MATH'
    }];
    vm.year = getYear();
    $scope.isLoading = true;
    apiFactory.listAllCompanyBudgets().then(function (resp) {
      var templates = resp.data.list;
      var found = false;
      templates.forEach(function (template) {
        if (template.year === vm.year) {
          vm.templateId = template._id;
          vm.sections = template.sections;
          vm.summaries = template.summaries || [];
          found = true;
        } else {
          if (template.sections) {
            template.sections.forEach(function (section) {
              section.budgets.forEach(function (budget) {
                clearValues(budget, false);
                budget.children.forEach(function (child) {
                  return clearValues(child, true);
                });
              });
              section.summaries.forEach(function (summary) {
                return clearValues(summary, false);
              });
            });
          }

          if (template.summaries) {
            template.summaries.forEach(function (summary) {
              return clearValues(summary, false);
            });
          }
        }
      });
      vm.templates = templates;
      $scope.isLoading = false;

      if (!found) {
        loadDummies();
      }

      vm.sections.forEach(function (section) {
        return section.budgets.forEach(function (budget) {
          return vm.budgets.push(budget);
        });
      });
    })["catch"](function (err) {
      $log.error(err);
      $scope.isLoading = false;
    });

    vm.selectTemplate = function () {
      var template = vm.templates.find(function (x) {
        return x._id === vm.templateId;
      });
      vm.sections = template.sections;
    };

    vm.addSection = function (type) {
      var newSection = {
        name: type === 'revenue' ? 'Revenue' : 'Expense',
        type: type,
        budgets: [{
          index: 0,
          title: 'New Line 1',
          subtitle: 'description',
          expand: false,
          children: [{
            title: 'Dynamic Data',
            subtitle: '% of service',
            values: [],
            sum: 0
          }, {
            title: 'Forecast Data',
            subtitle: '% of service',
            values: [],
            sum: 0
          }],
          values: [],
          sum: 0
        }],
        summaries: [{
          title: type === 'revenue' ? $filter('translate')('Total Revenue') : $filter('translate')('Total Expense'),
          values: [],
          sum: 0,
          equation: {
            type: 'sum',
            fields: []
          }
        }],
        dynamicSum: {
          values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          sum: 0
        }
      };
      clearValues(newSection.budgets[0], false);
      clearValues(newSection.budgets[0].children[0], true);
      clearValues(newSection.budgets[0].children[1], true);
      clearValues(newSection.summaries[0], false);
      vm.sections.push(newSection);
      arrangeIndexes();
    };

    vm.removeSection = function (index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm'
      }).result.then(function () {
        vm.sections.splice(index, 1);
        arrangeIndexes();
      });
    };

    vm.addTotalSum = function () {
      vm.summaries.push({
        name: 'Total Sum',
        title: 'Sum',
        values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        sum: 0,
        equation: {
          type: 'sum',
          fields: []
        }
      });
    };

    vm.removeTotalSum = function (index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm'
      }).result.then(function () {
        vm.summaries.splice(index, 1);
      });
    };

    vm.addBudget = function (section) {
      var budget = {
        index: 0,
        title: 'New Line ' + (section.budgets.length + 1),
        subtitle: 'description',
        expand: false,
        children: [{
          title: 'Dynamic Data',
          subtitle: '% of service',
          values: [],
          sum: 0
        }, {
          title: 'Forecast Data',
          subtitle: '% of service',
          values: [],
          sum: 0
        }],
        values: [],
        sum: 0
      };
      section.budgets.push(budget);
      clearValues(budget, false);
      clearValues(budget.children[0], true);
      clearValues(budget.children[1], true);
      arrangeIndexes();
    };

    vm.removeBudget = function (index, section) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm'
      }).result.then(function () {
        section.budgets.splice(index, 1);
        arrangeIndexes();
      });
    };

    vm.removeBudgetChild = function (index, budget) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm'
      }).result.then(function () {
        budget.children.splice(index, 1);
      });
    };

    vm.addSummary = function (section) {
      section.summaries.push({
        index: 0,
        title: section.type === 'revenue' ? $filter('translate')('Total Revenue') : $filter('translate')('Total Expense'),
        values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        sum: 0,
        equation: {
          type: 'sum',
          fields: []
        }
      });
      arrangeIndexes();
    };

    vm.removeSummary = function (index, section) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm'
      }).result.then(function () {
        section.summaries.splice(index, 1);
        arrangeIndexes();
      });
    };

    vm.changeSubtitle = function (budget) {
      budget.children.forEach(function (child) {
        return child.subtitle = budget.subtitle;
      });
    };

    vm.changeSumField = function (_summary) {
      $uibModal.open({
        animation: true,
        component: 'budgetSummaryModal',
        windowClass: 'company-budget-summary-modal',
        backdrop: 'static',
        resolve: {
          budgets: function budgets() {
            return vm.budgets;
          },
          summary: function summary() {
            return _summary;
          }
        }
      }).result.then(function (result) {
        _summary.equation.fields = result.fields.map(function (x) {
          return {
            index: x.index,
            childIndex: x.childIndex,
            operator: x.operator
          };
        });
      });
    };

    $scope.getSummaryFields = function (summary) {
      return summary.equation.fields.map(function (x) {
        return x.index + (x.childIndex ? "." + x.childIndex : "");
      }).join(',');
    };

    vm.save = function () {
      apiFactory.saveCompanyBudget({
        year: vm.year,
        sections: vm.sections,
        summaries: vm.summaries
      }).then(function () {
        Notification.success('Budget template is saved successfully.');
        localStorageService.set('company-budget-year', vm.year);
        $state.go('companyBudget');
      })["catch"](function (err) {
        $log.error(err);
        Notification.error('Failed to save.');
      });
    };

    function getYear() {
      var year = localStorageService.get('company-budget-year');
      return year ? utils.num(year) : new Date().getFullYear();
    }

    function clearValues(budget, child) {
      if (!budget) return;

      if (child) {
        budget.values = [];

        for (var i = 0; i < 12; i++) {
          budget.values.push({
            amount: 0,
            percent: 0
          });
        }
      } else {
        budget.values = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
    }

    function arrangeIndexes() {
      var index = 0;
      vm.sections.forEach(function (section) {
        var indexTable = [];
        section.budgets.forEach(function (budget) {
          var oldIndex = budget.index;
          budget.index = ++index;
          indexTable.push({
            old: oldIndex,
            current: budget.index
          });
        });
        section.summaries.forEach(function (summary) {
          summary.index = ++index;

          var _loop = function _loop(i) {
            var find = indexTable.find(function (t) {
              return t.old === summary.equation.fields[i];
            });

            if (find) {
              summary.equation.fields[i] = find.current;
            }
          };

          for (var i = 0; i < summary.equation.fields.length; i++) {
            _loop(i);
          }
        });
      });
    }

    function loadDummies() {
      vm.sections = [{
        name: 'Labour Cost',
        type: 'expense',
        budgets: [{
          index: 1,
          title: 'Labour Cost',
          subtitle: '% of turnover',
          expand: false,
          values: [],
          children: [{
            title: 'Dynamic Data',
            subtitle: '% of service',
            values: [],
            sum: 0
          }],
          sum: 0
        }, {
          index: 2,
          title: 'Pension',
          subtitle: '% of service',
          expand: false,
          values: [],
          children: [{
            title: 'Dynamic Data',
            subtitle: '% of service',
            values: [],
            sum: 0
          }, {
            title: 'Forecast Data',
            subtitle: '% of service',
            values: [],
            sum: 0
          }],
          sum: 0
        }],
        summaries: [{
          index: 3,
          title: 'TOTAL COST',
          equation: {
            type: 'sum',
            fields: [{
              index: 1,
              operator: '+'
            }, {
              index: 2,
              operator: '+'
            }]
          },
          values: [],
          sum: 0
        }],
        dynamicSum: {
          title: 'Dynamic Sum',
          values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          sum: 0
        }
      }, {
        name: 'Expenses',
        type: 'expense',
        budgets: [{
          index: 4,
          title: 'Car Cost',
          subtitle: '% of turnover',
          expand: false,
          values: [],
          children: [{
            title: 'Dynamic Data',
            subtitle: '% of service',
            values: [],
            sum: 0
          }],
          sum: 0
        }, {
          index: 5,
          title: 'Materials and Equipment',
          subtitle: '% of service',
          expand: false,
          values: [],
          children: [{
            title: 'Dynamic Data',
            subtitle: '% of service',
            values: [],
            sum: 0
          }, {
            title: 'Forecast Data',
            subtitle: '% of service',
            values: [],
            sum: 0
          }],
          sum: 0
        }],
        summaries: [{
          index: 6,
          title: 'TOTAL COST',
          equation: {
            type: 'sum',
            fields: [{
              index: 4,
              operator: '+'
            }, {
              index: 5,
              operator: '+'
            }]
          },
          values: [],
          sum: 0
        }],
        dynamicSum: {
          title: 'Dynamic Sum',
          values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          sum: 0
        }
      }, {
        name: 'Finans Cost',
        type: 'expense',
        budgets: [{
          index: 7,
          title: 'Bank interest',
          subtitle: '% of turnover',
          expand: false,
          values: [{
            title: 'Dynamic Data',
            subtitle: '% of service',
            values: [],
            sum: 0
          }],
          children: [],
          sum: 0
        }, {
          index: 8,
          title: 'Loan Cost',
          subtitle: '% of service',
          expand: false,
          values: [],
          children: [{
            title: 'Dynamic Data',
            subtitle: '% of service',
            values: [],
            sum: 0
          }, {
            title: 'Forecast Data',
            subtitle: '% of service',
            values: [],
            sum: 0
          }],
          sum: 0
        }],
        summaries: [{
          index: 9,
          title: 'TOTAL COST',
          equation: {
            type: 'sum',
            fields: [{
              index: 7,
              operator: '+'
            }, {
              index: 8,
              operator: '+'
            }]
          },
          values: [],
          sum: 0
        }],
        dynamicSum: {
          title: 'Dynamic Sum',
          values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          sum: 0
        }
      }];
      vm.sections.forEach(function (section) {
        section.budgets.forEach(function (budget) {
          clearValues(budget, false);
          budget.children.forEach(function (child) {
            return clearValues(child, true);
          });
        });
        section.summaries.forEach(function (summary) {
          return clearValues(summary, false);
        });
      });
      vm.summaries = [];
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('authCompaniesModal', {
    controller: authCompaniesModal,
    controllerAs: 'vm',
    templateUrl: 'app/main/auth/modals/authCompaniesModal/authCompaniesModal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  /** @ngInject */

  function authCompaniesModal() {
    var vm = this;
    vm.companies = [];

    vm.$onInit = function () {
      vm.companies = vm.resolve.companies || [];
    };

    vm.cancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.select = function (company) {
      vm.modalInstance.close(company._id);
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module("app").directive("loginLeftBlock", loginLeftBlock);

  function loginLeftBlock() {
    return {
      restrict: "E",
      templateUrl: "app/main/auth/directives/login-left-block/login-left-block.view.html",
      replace: true,
      link: function link() {}
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('typeWritterSpreadSheetGrid', {
    controller: TypeWritterSpreadSheetGridController,
    controllerAs: 'vm',
    templateUrl: 'app/main/typeWritter/typeWritterSpreadSheetGrid/typeWritterSpreadSheetGrid.view.html'
  });
  /** @ngInject */

  function TypeWritterSpreadSheetGridController($scope, apiFactory, Notification, globals, $log, $state) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.NOTE_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.NOTE_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.NOTE]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.NOTE_ACCESS_CREATE = res.data.data[Constants.AccessKey.NOTE];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.totalCount = 0;
    $scope.isLoading = false;
    vm.currentPage = 1;
    $scope.numPerPage = globals.numPerPage();
    $scope.noOfPages = 0;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];

    $scope.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchTypeWritter();
    };

    $scope.isList = false;
    $scope.isGrid = true;

    $scope.onListView = function () {
      $scope.isGrid = false;
      $scope.isList = true;
    };

    $scope.onGridView = function () {
      $scope.isGrid = true;
      $scope.isList = false;
    };

    vm.fetchTypeWritter = function () {
      $scope.isLoading = true;
      apiFactory.getSpreadSheetsByUserId({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.constructionNotes = resp.data.notes;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (error) {
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed to fetch type writter list');
        $scope.isLoading = false;
      });
    };

    vm.fetchTypeWritter();

    $scope.download = function (id) {
      $scope.downloadSheet(id);
    };

    $scope.showDetail = function (id) {
      $state.go("typeWritterSpreadSheetDetail", {
        id: id
      });
    };

    $scope.searchCallback = function () {
      vm.currentPage = 1;
      vm.fetchTypeWritter();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('typeWritterRichTextGrid', {
    controller: TypeWritterRichTextGridController,
    controllerAs: 'vm',
    templateUrl: 'app/main/typeWritter/typeWritterRichTextGrid/typeWritterRichTextGrid.view.html'
  });
  /** @ngInject */

  function TypeWritterRichTextGridController($scope, apiFactory, Notification, globals, $log, $state) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.NOTE_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.NOTE_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.NOTE]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.NOTE_ACCESS_CREATE = res.data.data[Constants.AccessKey.NOTE];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.totalCount = 0;
    $scope.isLoading = false;
    vm.currentPage = 1;
    $scope.numPerPage = globals.numPerPage();
    $scope.noOfPages = 0;

    $scope.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchTypeWritter();
    };

    vm.fetchTypeWritter = function () {
      $scope.isLoading = true;
      apiFactory.getConstructionNotesByUserId({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.constructionNotes = resp.data.notes;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (error) {
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed to fetch type writter list');
        $scope.isLoading = false;
      });
    };

    vm.fetchTypeWritter();

    $scope.searchCallback = function () {
      vm.currentPage = 1;
      vm.fetchTypeWritter();
    };

    $scope.isList = false;
    $scope.isGrid = true;

    $scope.onListView = function () {
      $scope.isGrid = false;
      $scope.isList = true;
    };

    $scope.onGridView = function () {
      $scope.isGrid = true;
      $scope.isList = false;
    };

    $scope.cleanUp = function (content) {
      content = content || '';
      return content.replace(/<[^>]*>/g, '\n');
    };

    $scope.showDetail = function (id) {
      $state.go("typeWritterDetail", {
        id: id
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('typeWritterDetailSpreadSheet', {
    controller: typeWritterDetailSpreadSheet,
    controllerAs: 'vm',
    templateUrl: 'app/main/typeWritter/typeWritterDetailSpreadSheet/typeWritterDetailSpreadSheet.view.html'
  });
  /** @ngInject */

  function typeWritterDetailSpreadSheet($scope, $stateParams, $log, apiFactory, $state, Notification, utils, $uibModal, globals, $document, $interval, $window) {
    var vm = this;
    vm.utils = utils;
    $scope.id = $stateParams.id;
    vm.sheetInfo = {
      title: "Untitled Spreadsheet"
    };
    $scope.isShowAll = false;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.menudata = [{
      title: "File",
      child: [{
        title: "New Sheet",
        func: ""
      }, {
        title: "Open",
        shortkey: "Ctrl+O",
        func: ""
      }, {
        title: "Import",
        func: ""
      }, {
        title: "Make a copy",
        func: ""
      }, {
        seperator: true
      }, {
        title: "Email",
        child: [{
          title: "Email this file",
          func: ""
        }, {
          title: "Email to collaborators",
          disabled: "",
          func: ""
        }]
      }, {
        title: "Download",
        child: [{
          title: "Microsoft Excel(.xlsx)",
          func: ""
        }, {
          title: "PDF document(.pdf)",
          func: ""
        }, {
          title: "Comma-seperated values(.csv)"
        }]
      }, {
        title: "Version History",
        child: [{
          title: "Name current version"
        }, {
          title: "See version history",
          shortkey: "Ctrl+Alt+Shift+H"
        }]
      }, {
        title: "Rename"
      }, {
        title: "Move"
      }, {
        title: "Move to bin"
      }, {
        title: "Publish"
      }, {
        title: "Document Details"
      }, {
        title: "Print",
        shortkey: "Ctrl+p"
      }]
    }, {
      title: "Edit",
      child: [{
        title: "Undo",
        shortkey: "Ctrl+Z"
      }, {
        title: "Redo",
        shortkey: "Ctrl+Z"
      }, {
        seperator: true
      }, {
        title: "Cut",
        shortkey: "Ctrl+X"
      }, {
        title: "Copy",
        shortkey: "Ctrl+C"
      }, {
        title: "Paste",
        shortkey: "Ctrl+V"
      }, {
        title: "Paste Special",
        child: [{
          title: "Paste values only",
          shortkey: "Ctrl+Shift+V"
        }, {
          title: "Paste format only"
        }, {
          title: "Paste all except borders"
        }, {
          title: "Paste columns widths only"
        }, {
          seperator: true
        }, {
          title: "Paste formula only"
        }, {
          title: "Paste data validation only"
        }, {
          title: "Paste conditional formatting only"
        }, {
          title: "Paste transposed"
        }]
      }, {
        seperator: true
      }, {
        title: "Find and Replace",
        shortkey: "Ctrl+H"
      }, {
        seperator: true
      }, {
        title: "Delete values"
      }, {
        title: "Delete row 1"
      }, {
        title: "Delete column A"
      }, {
        title: "Delete cells and shift up"
      }, {
        title: "Delete cells and shift right"
      }]
    }, {
      title: "View",
      child: [{
        title: "Freeze",
        check: true,
        child: [{
          title: "No rows"
        }, {
          title: "1 row"
        }, {
          title: "2 rows"
        }, {
          title: "Up to current row(1)"
        }, {
          seperator: true
        }, {
          title: "No columns"
        }, {
          title: "1 column"
        }, {
          title: "2 columns"
        }, {
          title: "Up to current column(A)"
        }]
      }, {
        seperator: true
      }, {
        title: "Gridlines",
        check: true
      }, {
        title: "Protected ranges",
        check: true
      }, {
        seperator: true
      }, {
        title: "Formula bar",
        check: true
      }, {
        title: "Show formula",
        check: true,
        shortkey: "Ctrl+'"
      }, {
        seperator: true
      }, {
        title: "Hidden sheets(1)",
        check: true,
        child: [{
          title: "Audit Sheet"
        }, {
          title: "Sheet 4"
        }]
      }, {
        title: "Zoom",
        check: true,
        child: [{
          title: "50%",
          check: true
        }, {
          title: "75%",
          check: true
        }, {
          title: "90%",
          check: true
        }, {
          title: "100%",
          check: true
        }, {
          title: "125%",
          check: true
        }, {
          title: "150%",
          check: true
        }, {
          title: "200%",
          check: true
        }]
      }, {
        seperator: true
      }, {
        title: "Fullscreen",
        check: true
      }]
    }, {
      title: "Insert"
    }, {
      title: "Format"
    }, {
      title: "Data"
    }, {
      title: "Tools"
    }];
    $scope.newAttachments = [];
    $scope.removedFiles = [];
    $scope.field = {
      left: 0,
      top: 0,
      leftContent: 0,
      topContent: 0
    };
    var xs = x_spreadsheet('#ssheet', {
      showTooltip: false,
      view: {
        height: function height() {
          return $document[0].documentElement.clientHeight - 193;
        },
        width: function width() {
          return $document[0].documentElement.clientWidth - 56 - 288;
        }
      },
      row: {
        len: 100,
        height: 24
      },
      col: {
        len: 26,
        width: 96,
        indexWidth: 60,
        minWidth: 60
      }
    });
    var defaultContent = [{
      cols: {
        len: 26
      },
      freeze: "A1",
      merges: [],
      name: "sheet1",
      rows: {
        len: 100
      },
      len: 100,
      styles: [{
        bgcolor: '#fbdb80'
      }],
      validations: []
    }];
    xs.loadData(defaultContent);
    xs.on('cell-selected', function (cell, ri, ci) {
      var e = $window.event;
      var selectedComment = vm.comments.filter(function (x) {
        return x.position && x.position.xPosition == ri && x.position.yPosition == ci;
      });

      if (selectedComment.length != 0) {
        var activeCommentId = selectedComment[0]._id;
        var tempItems = angular.element("#right_block_comment_list div.comment-list");

        for (var i = 0; i < tempItems.length; i++) {
          angular.element("#right_block_comment_list div.comment-list").eq(i).removeClass('active');

          if (activeCommentId == tempItems[i].attributes['data-comment-id'].value) {
            angular.element("#right_block_comment_list").animate({
              "scrollTop": angular.element("#right_block_comment_list div.comment-list")[i].offsetTop - 250
            });
            angular.element("#right_block_comment_list div.comment-list").eq(i).addClass('active');
          }
        }
      }

      $scope.isAddingCommentContent = false;
      $scope.field.left = e.clientX;
      $scope.field.top = e.clientY;
      $scope.field.leftContent = e.clientX;
      $scope.field.topContent = e.clientY;
      $scope.popover = true;
      $scope.selectedXIndex = ri;
      $scope.selectedYIndex = ci;
      $scope.$apply();
    });
    xs.on('cells-selected', function () {
      $scope.popover = false;
    });
    Promise.all([apiFactory.getAllMembers()]).then(function (res) {
      $scope.users = res[0].data.list;
    })["catch"](function () {
      Notification.error("Failed to get data");
    });

    if (angular.isDefined($scope.id)) {
      $scope.isLoading = true;
      Promise.all([apiFactory.getSpreadSheetById($scope.id), apiFactory.getNoteComments($scope.id)]).then(function (resp) {
        $scope.isLoading = false;
        vm.sheetInfo = resp[0].data.data;
        vm.comments = resp[1].data.data.filter(function (x) {
          return !x.parentId;
        });
        vm.comments.forEach(function (item) {
          if (item.replies) {
            item.replies = item.replies.reverse();
          }
        });
        vm.sheetInfo.contents.forEach(function (item, index) {
          if (vm.sheetInfo.contents[index].styles && vm.sheetInfo.contents[index].styles.length != 0) {
            if (vm.sheetInfo.contents[index].styles[0]['bgcolor'] != "#fbdb80") vm.sheetInfo.contents[index].styles.unshift({
              bgcolor: "#fbdb80"
            });
          } else {
            vm.sheetInfo.contents[index].styles = [];
            vm.sheetInfo.contents[index].styles.push({
              bgcolor: "#fbdb80"
            });
          }
        });
        xs.loadData(vm.sheetInfo.contents);
        vm.logHis = resp[0].data.data.logHistory;

        if (vm.logHis) {
          vm.logHis = vm.logHis.reverse();
        }
      })["catch"](function (e) {
        $log.log('error', e);
        $scope.isLoading = false;
      });
    }

    $scope.isComment = true;
    $scope.isAddingCommentContent = false;

    $scope.OnCommentList = function () {
      $scope.isComment = true; // todo more function
    };

    $scope.OnInfoList = function () {
      $scope.isComment = false; // todo more function
    };

    $scope.showAddComment = function (isShow) {
      $scope.isAddingComment = isShow;
    };

    $scope.submitComment = function () {
      if (angular.isUndefined(vm.comment) || vm.comment == '') {
        Notification.error("Please enter comment");
        return;
      }

      $scope.isLoading = true;
      $scope.isAddingCommentContent = false;
      apiFactory.addNoteComment($scope.id, {
        comment: vm.comment,
        position: {
          xPosition: $scope.selectedXIndex,
          yPosition: $scope.selectedYIndex
        }
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.comment = '';
        var addedComment = resp.data.data;
        addedComment.commentedBy = {
          displayName: vm.userData.displayName,
          profilePic: vm.userData.profilePic,
          _id: vm.userData._id
        };
        vm.comments.splice(0, 0, addedComment); // var content = vm.editor.selection.getContent({'format':'html'});
        // var new_selection_content = '<span data-comment-id = '+ "'" + addedComment._id + "'" +' data-ng-click="changeActiveComment('+ "'" + addedComment._id + "'" +')"  style="background-color: #FBDB80; cursor:pointer" class="pop-availability">' + content + '</span>';
        // vm.editor.execCommand('insertHTML', true, new_selection_content);

        $scope.popover = !$scope.popover;
        vm.contents = xs.getData();
        vm.contents[0].rows[$scope.selectedXIndex + ""].cells[$scope.selectedYIndex]['style'] = 0;
        xs.loadData(vm.contents);
        $scope.saveSpreadSheet(false); // $scope.saveTypeWriter() ;

        Notification.success('Comment saved successfully');
      })["catch"](function (error) {
        $log.log('error', error);
        $scope.isLoading = false;
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in create Typewriter1');
      });
    };

    $scope.getActiveColor = function (comment) {
      return comment == $scope.active ? "#FBDB80" : "#E8E8E8";
    };

    $scope.changeActiveComment = function (comment, index) {
      angular.element("#right_block_comment_list").animate({
        "scrollTop": angular.element("#right_block_comment_list div.comment-list")[index].offsetTop - 250
      });
      angular.element("#right_block_comment_list div.comment-list").siblings('div').removeClass('active');
      angular.element("#right_block_comment_list div.comment-list").eq(index).addClass('active'); // let iframe = $document[0].getElementsByTagName("iframe")[0];
      // iframe.contentWindow.scrollTo(comment.position.xPosition, comment.position.yPosition);
    };

    $scope.expandReplies = function (comment) {
      comment.expand = !comment.expand;
    };

    $scope.toggleReplyCommentModal = function (_comment) {
      var modal = $uibModal.open({
        animation: true,
        component: 'replyNoteCommentModal',
        windowClass: 'reply-note-comment-modal',
        resolve: {
          comment: function comment() {
            return _comment;
          }
        }
      });
      modal.result.then(function (result) {
        result.createdComment.commentedBy = {
          profilePic: vm.userData.profilePic,
          displayName: vm.userData.displayName
        };

        _comment.replies.unshift(result.createdComment);
      }, function () {});
    };

    $scope.saveSpreadSheet = function () {
      var isPublish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      vm.contents = xs.getData();

      if (utils.isEmpty(vm.sheetInfo)) {
        Notification.error('Please fill out the required information');
        return;
      }

      if (utils.isEmpty(vm.sheetInfo.title)) {
        Notification.error('Please enter name details');
        return;
      }

      if (utils.isEmpty(vm.contents)) {
        Notification.error('Please enter content');
        return;
      }

      var payload = {
        id: vm.sheetInfo._id,
        title: vm.sheetInfo.title,
        contents: vm.contents,
        members: utils.isEmpty(vm.sheetInfo.members) ? [] : vm.sheetInfo.members.map(function (item) {
          return item._id;
        })
      };
      $scope.isLoading = true;
      apiFactory.saveSpreadSheet(payload).then(function () {
        $scope.isLoading = false;
        Notification.success('SpreadSheet saved successfully');

        if (isPublish || !vm.sheetInfo._id) {
          $state.go("typeWritterSpreadSheetGrid");
        } else {
          if (vm.logHis) {
            vm.logHis.unshift({
              contents: vm.contents,
              createdBy: vm.userData,
              updated: Date.now()
            });
          }
        }
      })["catch"](function (error) {
        $log.log('error', error);
        $scope.isLoading = false;
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in create SpreadSheet');
      });
    };

    $scope.restoreContent = function (contents) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Confirm restore content',
              message: 'Are you sure restore your content?',
              subMessage: ' ',
              confirmButtonText: 'Restore',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      });
      confirmModal.result.then(function (result) {
        if (result) {
          xs.loadData(contents);
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.removeContent = function (id) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Confirm remove content',
              message: 'Are you sure remove your log?',
              subMessage: ' ',
              confirmButtonText: 'Remove',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      });
      confirmModal.result.then(function (result) {
        if (result) {
          vm.logHis = vm.logHis.filter(function (item) {
            return item._id != id;
          });
          var payload = {
            id: vm.sheetInfo._id,
            logHistory: vm.logHis
          };
          $scope.isLoading = true;
          apiFactory.deleteSpreadSheetNoteHistory(payload).then(function (resp) {
            $log.log(resp);
            $scope.isLoading = false;
            Notification.success('Removed successfully');
          })["catch"](function (error) {
            $log.log('error', error);
            $scope.isLoading = false;
            if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in Remove');
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.addMember = function () {
      $uibModal.open({
        animation: true,
        component: 'addTypeWritterMemberModal',
        windowClass: 'add-type-writter-member-modal',
        resolve: {
          users: function users() {
            return $scope.users;
          },
          membersByTeam: function membersByTeam() {
            if (utils.isEmpty(vm.sheetInfo.members)) {
              vm.sheetInfo.members = [];
            }

            return vm.sheetInfo.members;
          }
        }
      }).result.then(function (result) {
        $log.log(result);
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.gotoPage = function () {
      $log.log("gotopage");
    };

    $scope.getColor = function (name) {
      return globals.getAvatarColor(name);
    }; // auto save log history


    $interval($scope.saveSpreadSheet, 1000 * 60 * 30);
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('typeWritterDetail', {
    controller: TypeWritterDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/typeWritter/typeWritterDetail/typeWritterDetail.view.html'
  });
  /** @ngInject */

  function TypeWritterDetailController($document, $scope, $stateParams, $log, apiFactory, $state, Notification, utils, $uibModal, globals, $window, $compile, $interval) {
    var vm = this;
    vm.utils = utils;
    $scope.id = $stateParams.id;
    vm.noteInfo = {};
    $scope.isShowAll = false;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.commentActive = false;
    vm.commentEvent = "";
    vm.noteInfo = {
      title: "Untitled Typewriter"
    };

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.height = 1056;
    vm.width = 816;
    vm.paperSize = "letter";
    vm.pageOrientation = "Portrait";
    $scope.field = {
      left: 0,
      top: 0,
      leftContent: 0,
      topContent: 0
    };
    $scope.newAttachments = [];
    $scope.removedFiles = [];
    vm.editor = null;
    apiFactory.getAllMembers().then(function (resp) {
      $scope.users = resp.data.list;
    })["catch"](function (err) {
      $log.error(err);
      Notification.error("Failed to get data");
    });

    if (angular.isDefined($scope.id)) {
      $scope.isLoading = true;
      Promise.all([apiFactory.getConstructionNoteById($scope.id), apiFactory.getNoteComments($scope.id)]).then(function (resp) {
        $scope.isLoading = false;
        vm.noteInfo = resp[0].data.note;
        vm.content = resp[0].data.content;
        vm.comments = resp[1].data.data.filter(function (x) {
          return !x.parentId;
        });
        vm.comments.forEach(function (item) {
          if (item.replies) {
            item.replies = item.replies.reverse();
          }
        });
        vm.paperSize = resp[0].data.note.pageSetting.sizeType;
        vm.pageOrientation = resp[0].data.note.pageSetting.isPortrait ? "Portrait" : "Landscape";
        vm.logHis = resp[0].data.note.logHistory;

        if (vm.logHis) {
          vm.logHis = vm.logHis.reverse();
        }

        var find = Constants.PaperSizeList.find(function (elem) {
          return elem._id == vm.paperSize;
        });

        if (find) {
          vm.width = vm.pageOrientation == "Portrait" ? find.width * 96 : find.height * 96;
          vm.height = vm.pageOrientation == "Portrait" ? find.height * 96 : find.width * 96;
        }
      })["catch"](function (e) {
        $log.log('error', e);
        $scope.isLoading = false;
      });
    }

    $scope.saveTypeWriter = function () {
      if (angular.isUndefined(vm.noteInfo) || angular.isUndefined(vm.noteInfo.title) || vm.noteInfo.title == '') {
        Notification.error("Please enter title");
        return;
      }

      if (angular.isUndefined(vm.content) || vm.content == '') {
        Notification.error("Please enter content");
        return;
      }

      var iframe = $document[0].getElementsByTagName("iframe")[0];
      var iframeHtml = iframe.contentWindow.document.getElementsByTagName("body")[0].innerHTML;
      var payload = {
        id: vm.noteInfo._id,
        title: vm.noteInfo.title,
        content: iframeHtml,
        attachments: $scope.newAttachments,
        removedFiles: $scope.removedFiles,
        members: angular.isUndefined(vm.noteInfo.members) ? [] : vm.noteInfo.members.map(function (item) {
          return item._id;
        }),
        pageSetting: {
          sizeType: vm.paperSize,
          isPortrait: vm.pageOrientation == "Portrait" ? true : false
        }
      };
      $scope.isLoading = true;
      apiFactory.saveConstructionNote(payload).then(function (resp) {
        $log.log(resp);
        $scope.isLoading = false;
        Notification.success('Typewriter saved successfully'); // $state.go("typeWritterRichTextGrid");
      })["catch"](function (error) {
        $log.log('error', error);
        $scope.isLoading = false;
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in create Typewriter');
      });
    };

    vm.fileUpdated = function (files) {
      // let fileObj = event.target.files;
      angular.forEach(files, function (x) {
        if (/image/.test(x.type)) {
          if (angular.isUndefined(vm.noteInfo.attachments)) {
            vm.noteInfo.attachments = [];
          }

          vm.noteInfo.attachments.push(x);
          $scope.newAttachments.push(x);
        }
      });
    };

    vm.deleteFile = function (indexVal) {
      if (vm.noteInfo.attachments[indexVal]._id) {
        $scope.removedFiles.push(vm.noteInfo.attachments[indexVal]._id);
      } else {
        var findIndex = $scope.newAttachments.findIndex(function (elem) {
          return elem['$$hashkey'] === vm.noteInfo.attachments[indexVal]['$$hashkey'];
        });

        if (~findIndex) {
          $scope.newAttachments.splice(findIndex, 1);
        }
      }

      vm.noteInfo.attachments.splice(indexVal, 1);
    };

    $scope.addMember = function () {
      $uibModal.open({
        animation: true,
        component: 'addTypeWritterMemberModal',
        windowClass: 'add-type-writter-member-modal',
        resolve: {
          users: function users() {
            return $scope.users;
          },
          membersByTeam: function membersByTeam() {
            if (angular.isUndefined(vm.noteInfo.members)) {
              vm.noteInfo.members = [];
            }

            return vm.noteInfo.members;
          }
        }
      }).result.then(function (result) {
        $log.log(result);
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.showAddComment = function (isShow) {
      $scope.isAddingComment = isShow;
    };

    $scope.submitComment = function () {
      if (angular.isUndefined(vm.comment) || vm.comment == '') {
        Notification.error("Please enter comment");
        return;
      }

      $scope.isLoading = true;
      $scope.isAddingCommentContent = false; // comment add in iframe

      var iframe = $document[0].getElementsByTagName("iframe")[0];
      var elmnt = iframe.contentWindow.document.getElementsByTagName("html")[0];
      apiFactory.addNoteComment($scope.id, {
        comment: vm.comment,
        position: {
          xPosition: $scope.field.left,
          yPosition: $scope.field.top + elmnt.scrollTop
        }
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.comment = '';
        var addedComment = resp.data.data;
        addedComment.commentedBy = {
          displayName: vm.userData.displayName,
          profilePic: vm.userData.profilePic,
          _id: vm.userData._id
        };
        vm.comments.splice(0, 0, addedComment);
        var content = vm.editor.selection.getContent({
          'format': 'html'
        });
        var new_selection_content = '<span data-comment-id = ' + "'" + addedComment._id + "'" + ' data-ng-click="changeActiveComment(' + "'" + addedComment._id + "'" + ')"  style="background-color: #FBDB80; cursor:pointer" class="pop-availability">' + content + '</span>';
        vm.editor.execCommand('insertHTML', true, new_selection_content);
        $scope.popover = !$scope.popover;
        $scope.saveTypeWriter();
        Notification.success('Comment saved successfully');
      })["catch"](function (error) {
        $log.log('error', error);
        $scope.isLoading = false;
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in create Typewriter');
      });
    }, $scope.showAll = function () {
      $scope.isShowAll = !$scope.isShowAll;
    };
    $scope.isComment = true;

    $scope.OnCommentList = function () {
      $scope.isComment = true; // todo more function
    };

    $scope.OnInfoList = function () {
      $scope.isComment = false; // todo more function
    };

    $scope.tinymceOptions = {
      menubar: true,
      statusbar: false,
      plugins: 'link image textcolor print fullscreen lists advlist table pagebreak preview',
      external_plugins: {
        wave: "https://cdn2.codox.io/waveTinymce/2.x/plugin.min.js"
      },
      wave: {
        "docId": $scope.id,
        // unique document id,
        "user": {
          name: vm.userData.displayName
        },
        "apiKey": "7bdf58a1-e722-4868-bee9-b7e7c65a09b6",
        // this is your actual API Key
        "cursorAlwaysOn": true,
        "showPointer": true
      },
      toolbar: 'preview undo redo print | bold italic underline strikethrough fontselect fontsizeselect forecolor backcolor removeformat subscript superscript | ' + 'formatselect alignleft aligncenter alignright alignjustify bullist numlist outdent indent | table link image |  pagebreak fullscreen | pagesetup addComment',
      images_upload_handler: function images_upload_handler(blobInfo, success, failure) {
        apiFactory.saveConstructionNoteImage({
          file: blobInfo.blob()
        }).then(function (resp) {
          success(resp.data.data.location);
        })["catch"](function (err) {
          Notification.error(utils.getErrorMessage(err));
          failure();
        });
      },
      setup: function setup(editor) {
        vm.editor = editor;
        editor.addButton('pagesetup', {
          icon: 'settings',
          tooltip: 'Pagesetup',
          onclick: function onclick() {
            var pageSetupModal = $uibModal.open({
              animation: true,
              component: 'pageSetupModal',
              windowClass: 'page-setup-modal',
              resolve: {
                paperSize: function paperSize() {
                  return vm.paperSize;
                },
                pageOrientation: function pageOrientation() {
                  return vm.pageOrientation;
                }
              }
            });
            pageSetupModal.result.then(function (result) {
              vm.width = result.width;
              vm.height = result.height;
              vm.paperSize = result.paperSize;
              vm.pageOrientation = result.pageOrientation;
            }, function (reason) {
              $log.info(reason);
            });
          }
        });
        editor.addButton('addComment', {
          title: "Comment",
          image: "/assets/icons/add-comment.svg",
          tooltip: 'Pagesetup',
          onclick: function onclick() {
            $scope.showAddComment(true);
          }
        });
        editor.on('MouseDown', function (e) {
          if (!e) {
            e = $window.event;
          }

          $scope.isAddingCommentContent = false;
          $scope.field.left = e.clientX;
          $scope.field.top = e.clientY;
          $scope.field.leftContent = e.clientX;
          $scope.field.topContent = e.clientY;
          $scope.popover = false;
        });
        editor.on('MouseUp', function (e) {
          if (!e) {
            e = $window.event;
          }

          $scope.isAddingCommentContent = false;

          if ($scope.field.left != e.clientX && $scope.field.top != e.clientY && $scope.field.leftContent != e.clientX && $scope.field.topContent != e.clientY) {
            $scope.popover = true;
          }

          $scope.field.left = e.clientX;
          $scope.field.top = e.clientY;
          $scope.field.leftContent = e.clientX;
          $scope.field.topContent = e.clientY;
        });
        editor.on('click', function (e) {
          vm.commentEvent = e; // e.target.append('this is ok') ;

          $log.log(e); // comment case

          if (e.target.className.includes('pop-availability')) {
            $scope.popover = false;
            var activeCommentId = e.target.attributes['data-comment-id'].value;
            var tempItems = angular.element("#right_block_comment_list div.comment-list");

            for (var i = 0; i < tempItems.length; i++) {
              angular.element("#right_block_comment_list div.comment-list").eq(i).removeClass('active');

              if (activeCommentId == tempItems[i].attributes['data-comment-id'].value) {
                angular.element("#right_block_comment_list").animate({
                  "scrollTop": angular.element("#right_block_comment_list div.comment-list")[i].offsetTop - 150
                });
                angular.element("#right_block_comment_list div.comment-list").eq(i).addClass('active');
              }
            }

            e.target.attributes['data-mce-selected'].value = 0;
          }
        });
      }
    };
    var colors = ["#FFB900", "#D83B01", "#B50E0E", "#E81123", "#B4009E", "#5C2D91", "#0078D7", "#00B4FF", "#008272", "#107C10"];

    $scope.getColor = function (name) {
      if (!name) {
        return;
      }

      name = name.replace(/"/g, '');
      var chars = name.split(' ');
      var codeNum = 0;

      if (chars.length < 2) {
        if (chars[0][0]) {
          codeNum = chars[0].charCodeAt(0);
        }
      } else {
        if (chars[0][0]) {
          codeNum = chars[0].charCodeAt(0);
        }

        if (chars[1][0]) {
          codeNum += chars[1].charCodeAt(0);
        }
      }

      return colors[codeNum % colors.length];
    };

    $scope.getActiveColor = function (comment) {
      return comment == $scope.active ? "#FBDB80" : "#E8E8E8";
    };

    $scope.changeActiveComment = function (comment, index) {
      angular.element("#right_block_comment_list").animate({
        "scrollTop": angular.element("#right_block_comment_list div.comment-list")[index].offsetTop - 150
      });
      angular.element("#right_block_comment_list div.comment-list").siblings('div').removeClass('active');
      angular.element("#right_block_comment_list div.comment-list").eq(index).addClass('active');
      var iframe = $document[0].getElementsByTagName("iframe")[0];
      iframe.contentWindow.scrollTo(comment.position.xPosition, comment.position.yPosition);
    };

    $scope.expandReplies = function (comment) {
      comment.expand = !comment.expand;
    };

    $scope.toggleReplyCommentModal = function (_comment) {
      var modal = $uibModal.open({
        animation: true,
        component: 'replyNoteCommentModal',
        windowClass: 'reply-note-comment-modal',
        resolve: {
          comment: function comment() {
            return _comment;
          }
        }
      });
      modal.result.then(function (result) {
        result.createdComment.commentedBy = {
          profilePic: vm.userData.profilePic,
          displayName: vm.userData.displayName
        };

        _comment.replies.unshift(result.createdComment);
      }, function () {});
    }; // get log content by log url


    $scope.getConstructionContent = function (logUrl) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Confirm restore content',
              message: 'Are you sure restore your content?',
              subMessage: ' ',
              confirmButtonText: 'Restore',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.isLoading = true;
          apiFactory.getConstructionContent({
            url: logUrl
          }).then(function (resp) {
            $log.log(resp);
            $scope.isLoading = false;
            vm.content = resp.data.content;
          })["catch"](function (error) {
            $log.log('error', error);
            $scope.isLoading = false;
            if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in create Typewriter');
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    }; // remove log content by log url


    $scope.removeConstructionContent = function (id, url) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Confirm restore content',
              message: 'Are you sure remove your log?',
              subMessage: ' ',
              confirmButtonText: 'Remove',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      });
      confirmModal.result.then(function (result) {
        if (result) {
          vm.logHis = vm.logHis.filter(function (item) {
            return item._id != id;
          });
          var payload = {
            id: vm.noteInfo._id,
            logHistory: vm.logHis,
            url: url
          };
          $scope.isLoading = true;
          apiFactory.deleteConstructionNoteHistory(payload).then(function (resp) {
            $log.log(resp);
            $scope.isLoading = false;
            Notification.success('Typewriter saved successfully');
          })["catch"](function (error) {
            $log.log('error', error);
            $scope.isLoading = false;
            if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in create Typewriter');
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    }; // doc log save 


    $scope.saveConstuctionNoteContent = function () {
      if (angular.isUndefined(vm.noteInfo) || angular.isUndefined(vm.noteInfo.title) || vm.noteInfo.title == '') {
        Notification.error("Please enter title");
        return;
      }

      if (angular.isUndefined(vm.content) || vm.content == '') {
        Notification.error("Please enter content");
        return;
      }

      var iframe = $document[0].getElementsByTagName("iframe")[0];
      var iframeHtml = iframe.contentWindow.document.getElementsByTagName("body")[0].innerHTML;
      var payload = {
        id: vm.noteInfo._id,
        content: iframeHtml
      };
      $scope.isLoading = true;
      apiFactory.saveConstructionNote(payload).then(function (resp) {
        $log.log(resp);
        $scope.isLoading = false;
        Notification.success('Typewriter saved successfully');
      })["catch"](function (error) {
        $log.log('error', error);
        $scope.isLoading = false;
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in create Typewriter');
      });
    }; // auto save log history


    $interval($scope.saveTypeWriter, 1000 * 60 * 30);
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('tqVpDetailPage', {
    controller: tqVpDetailPage,
    controllerAs: 'vm',
    templateUrl: 'app/main/tq/tqVpDetailPage/tqVpDetailPage.view.html',
    bindings: {
      page: '='
    }
  });

  function tqVpDetailPage($scope, $element, $timeout, $uibModal, $log, VP, apiFactory, pdfFactory, globals, utils, Notification) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore;
    var companyData = companyStore.get();
    vm.projectId = projectStore.get()._id;
    vm.collision = undefined;
    vm.menuPos = {
      x: 0,
      y: 0
    };
    vm.vpObject = {};
    vm.vpObjectPos = {
      x: 0,
      y: 0
    };

    vm.$onInit = function () {
      vm.page.viewer1 = createViewer('#tq-vp-viewer');
      vm.page.viewer = vm.page.viewer1;
      vm.page.brush = vm.page.viewer.brush;
      vm.page.textBrush = vm.page.viewer.textBrush;
      vm.page.zoomLevel = 100;
      vm.page.statusData = {
        isWall: false,
        pos: {
          x: 0.0,
          y: 0.0,
          z: 0.0
        },
        info: {
          area: '',
          width: '',
          height: ''
        }
      };
      vm.page.objectPropertyInfo = {
        width: 0,
        height: 0,
        area: 0,
        perimeterIn: 0,
        perimeterOut: 0
      };
      vm.page.isEdited = false;
      vm.page.unit = "m";
      vm.page.levelFactory = {
        setVisibility: function setVisibility(items, visible) {
          vm.page.viewer.setVisibility(items, visible);
        }
      };
      vm.page.indicator = {
        show: false
      };
      var plan = vm.page.plan;
      angular.element('#vp_initial_loading_popup').show();
      Promise.all([apiFactory.listInventories(plan._id), vm.page.viewer.loadPlan(plan)]).then(function (resp) {
        var inventories = resp[0].data.list;
        refactorInventories(inventories);

        if (resp[1]) {
          if (resp[1].json) {
            vm.page.viewer.data.setInventoryData(inventories);
          }

          if (resp[1].levels) {
            $scope.$broadcast('level:load', resp[1].levels);
          }
        }

        if (plan.modelData) {
          $scope.modelClosed = true;
          vm.page.bimModel = plan.modelData.model;
          vm.page.bimModel.saved = true;
          vm.page.matchData = plan.modelData.match;
        }

        if (!utils.isEmpty(vm.page.marker) && vm.page.marker.length > 0) {
          vm.page.viewer.loadMarkers(vm.page.marker);
        }

        $scope.$broadcast('level:default');
        angular.element('#vp_initial_loading_popup').hide();
      })["catch"](function (err) {
        $log.error(err);
        angular.element('#vp_initial_loading_popup').hide();
        Notification.error("Plan cannot open!");
      });
      initBoard();

      vm.page.toolbarEvent = function (id) {
        vm.page.viewer.toolbarEvent(id);
      };

      vm.page.undo = function () {
        vm.page.viewer.undo();
      };

      vm.page.redo = function () {
        vm.page.viewer.redo();
      };

      vm.page.closeContextMenu = function () {
        closeContextMenu();
      };

      vm.page.copy = function () {
        closeContextMenu();
        vm.page.viewer.copy();
      };

      vm.page.cut = function () {
        closeContextMenu();
        vm.page.viewer.cut();
      };

      vm.page.paste = function () {
        closeContextMenu();
        vm.page.viewer.paste(vm.menuPos);
      };

      vm.page.applyNegative = function () {
        closeContextMenu();
        vm.page.viewer.negative();
      };

      vm.page.zoomSlider = function (value) {
        vm.page.viewer.setZoom(value / 100);
      };

      vm.page.setColor = function (color) {
        color.replace('#', '0x');
        vm.page.viewer.color = color;
        vm.page.viewer.setColor(color);
      };

      vm.page.setTexture = function (url) {
        vm.page.viewer.setTexture({
          map: url,
          flip: false,
          repeatCountX: 1,
          repeatCountY: 1
        });
      };

      vm.page.onChangeUnit = function () {
        if (vm.selectedData) {
          updateStatusData(vm.selectedData);
        }
      };

      vm.page.changeTextInfo = function (type, value) {
        if (type && value) {
          vm.page.viewer.changeTextInfo(type, value);
        }
      };

      vm.page.onChangeTextFillColor = function (color) {
        vm.page.viewer.changeTextInfo('fill', color);
      };

      vm.page.onChangeTextStrokeColor = function (color) {
        vm.page.viewer.changeTextInfo('stroke', color);
      };

      vm.page.onChangeStrokeColor = function (color) {
        vm.page.viewer.changeObjectInfo('stroke', color);
      };

      vm.page.onChangeThickness = function (value) {
        if (angular.isUndefined(value) || isNaN(value)) return;
        vm.page.viewer.changeThickness(value);
      };

      vm.page.onChangeDashType = function (value) {
        vm.page.viewer.changeDashType(value);
      };

      vm.page.onChangeDashSpace = function (value) {
        vm.page.viewer.changeDashSpace(value);
      };

      vm.page.colorModeChanged = function (color) {
        vm.page.viewer.setColorMode(color.value);
      };

      vm.page.inventoryAssigned = function () {
        vm.page.isEdited = true;
        vm.page.viewer.invalidate();
      };

      vm.page.addCollision = function (plan) {
        vm.collision = plan;
        $timeout(loadCollision, 500);
      };

      vm.page.removeCollision = function () {
        vm.collision = undefined;
        vm.page.viewer = vm.page.viewer1;
        vm.page.viewer.removeColorFilter();

        if (vm.page.viewer2) {
          vm.page.viewer2.destroy();
          vm.page.viewer2 = undefined;
        }
      };

      vm.page.selectCollision = function (type) {
        vm.page.viewer = type === 'original' ? vm.page.viewer1 : vm.page.viewer2;
      };

      vm.page.rotateLeft = function () {
        vm.page.viewer.rotate(-90);
      };

      vm.page.rotateRight = function () {
        vm.page.viewer.rotate(90);
      };

      vm.page.flipHorizontal = function () {
        vm.page.viewer.flipHorizontal();
      };

      vm.page.flipVertical = function () {
        vm.page.viewer.flipVertical();
      };

      vm.page.changeWall = function () {
        if (vm.selectedData) {
          setWallProperty(vm.selectedData.shape);
        }
      };

      vm.page.exportPdf = function () {
        var imageData = vm.page.viewer.getImage();

        if (vm.page.viewer.colorMode === 'inventory') {
          var materials = vm.page.viewer.getColoredInventories();
          pdfFactory.exportPlan(vm.page.title, {
            imageData: imageData,
            materials: materials
          });
        } else {
          pdfFactory.exportPlan(vm.page.title, {
            imageData: imageData
          });
        }
      };

      vm.page.save = function () {
        return save();
      };

      vm.page.getViewer = function () {
        return vm.page.viewer;
      };

      vm.page.syncDataToCalculation = function () {
        return new Promise(function (resolve, reject) {
          var path = 'Root';
          var calcData = vm.page.viewer.exportCalculationData(vm.page.workLevel, vm.page.sections);

          if (angular.isDefined(calcData)) {
            var json = {
              projectId: vm.projectId,
              levelPath: path,
              modelId: vm.page.planId,
              modelName: vm.page.title,
              modelType: "vp",
              data: calcData
            };
            apiFactory.syncViewerToCalc(json).then(function () {
              Notification.success("Calculation data saved.");
              save().then(function () {
                resolve();
              })["catch"](function (err) {
                $log.log(err);
                Notification.error("Plan data was not saved.");
                reject(err);
              });
            })["catch"](function (e) {
              $log.log(e);
              Notification.error("Calculation data cannot be saved.");
              reject(e);
            });
          } else {
            Notification.error("There is no calculation data in plan.");
            reject({
              message: "There is no calculation data in plan."
            });
          }
        });
      };

      vm.page.close = function () {
        if (vm.page.viewer1) {
          vm.page.viewer1.destroy();
          vm.page.viewer1 = undefined;
        }

        if (vm.page.viewer2) {
          vm.page.viewer2.destroy();
          vm.page.viewer2 = undefined;
        }

        vm.page.viewer = undefined;
      };
    };

    function refactorInventories(inventories) {
      inventories.forEach(function (inventory) {
        // if (inventory.section) {
        //   let section = vm.page.sections.find(s => s._id === inventory.section);
        //   inventory.section = section ? section._id : undefined;
        // }
        if (inventory.materials) {
          inventory.materials.forEach(function (mat) {
            var material = vm.page.materials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
            }
          });
        }

        if (inventory.dcps) {
          inventory.dcps.forEach(function (mat) {
            var material = vm.page.comboMaterials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
              mat.comboMaterialList = material.comboMaterialList;
            }
          });
        }
      });
    }

    function loadCollision() {
      if (vm.page.viewer2) {
        vm.page.viewer2.destroy();
        vm.page.viewer2 = undefined;
      }

      vm.page.viewer2 = createViewer('#collision');
      angular.element('#vp_initial_loading_popup').show();
      vm.page.viewer2.loadPlan(vm.collision).then(function () {
        angular.element('#vp_initial_loading_popup').hide();
        vm.page.viewer = vm.page.viewer2;
      })["catch"](function (err) {
        $log.error(err);
        angular.element('#vp_initial_loading_popup').hide();
      });
    }

    function createViewer(container) {
      var viewer = VP.mainViewer($element.find(container)[0]);
      viewer.setInputMethod(companyData && companyData.companyInputMethod === 'European et al.' ? 'eu' : 'en');
      viewer.on('object:added', objectAdded);
      viewer.on('object:removed', objectRemoved);
      viewer.on('object:selected', objectSelected);
      viewer.on('object:modified', objectModified);
      viewer.on('text:selected', textSelected);
      viewer.on('selection:cleared', selectionCleared);
      viewer.on('object:dblclick', objectDblClicked);
      viewer.on('contextmenu', contextMenu);
      viewer.on('zoom:changed', zoomChanged); //viewer.on('pointer:changed',pointerChanged);

      viewer.on('calibration', calibrate);
      viewer.on('wall', setWallProperty);
      viewer.on('mouse:down', closeContextMenu);
      viewer.on('shortcut:copy', shortcutCopy);
      viewer.on('shortcut:paste', shortcutPaste);
      viewer.on('after:render', afterRender);
      return viewer;
    }

    function objectAdded(object) {
      vm.page.isEdited = true;
      $scope.$broadcast('object:added', object);
    }

    function objectRemoved(object) {
      vm.page.isEdited = true;
      $scope.$broadcast('object:removed', object);
    }

    function objectModified(object) {
      vm.page.isEdited = true;
      vm.selectedData = object;
      vm.page.objectPropertyInfo = object.getGeometricalInfo();
      updateStatusData(object);
    }

    function objectSelected(object) {
      if (angular.isUndefined(object)) return;
      vm.selectedData = object;
      var shape = object.shape;
      vm.page.brush = {
        strokeColor: shape.stroke,
        strokeWidth: shape.strokeWidth,
        dashType: shape.info && shape.info.dashType ? shape.info.dashType : 1,
        strokeDashArray: shape.strokeDashArray
      };
      vm.page.objectPropertyInfo = object.getGeometricalInfo();
      updateStatusData(object);
    }

    function textSelected(data) {
      selectionCleared();
      vm.page.textBrush = {
        text: data.text,
        fontSize: data.fontSize,
        fontStyle: data.fontStyle,
        fontFamily: data.fontFamily,
        strokeColor: data.stroke,
        fillColor: data.fill,
        strokeWidth: data.strokeWidth
      };
      $timeout(function () {
        return $scope.$apply();
      });
    }

    function selectionCleared() {
      vm.page.brush = vm.page.viewer.brush;
      vm.page.textBrush = vm.page.viewer.textBrush;
      vm.selectedData = undefined;
      vm.page.objectPropertyInfo = {
        width: 0,
        height: 0,
        area: 0,
        perimeterIn: 0,
        perimeterOut: 0
      };
    }
    /*
        function pointerChanged(data) {
          vm.page.statusData.pos.x = data.x;
          vm.page.statusData.pos.y = data.y;
          $scope.$apply();
        }*/


    function zoomChanged(e) {
      vm.page.zoomLevel = Math.ceil(e.level * 100);
      $timeout(function () {
        return $scope.$apply();
      });

      if (vm.page.viewer1 && vm.page.viewer2) {
        var other = vm.page.viewer1 === e.target ? vm.page.viewer2 : vm.page.viewer1;
        other.setZoom(e.level);
      }
    }

    function objectDblClicked(data) {
      vm.vpObject = data.object;

      if (vm.vpObject) {
        vm.vpObject.guid = data.object.uuid;
        vm.vpObject.name = data.object.name;
      }

      vm.vpObjectPos = Object.assign({
        x: data.x,
        y: data.y
      });
      vm.page.indicator.vpObject = vm.vpObject;
      vm.page.indicator.pos = vm.vpObjectPos;
      angular.element('#vp-property-indicator').show();
      angular.element('#vp_property_expand_icon').css('left', vm.vpObjectPos.x - 15 + 'px');
      angular.element('#vp_property_expand_icon').css('top', vm.vpObjectPos.y - 15 + 'px');
    }

    function afterRender() {
      if (vm.page.bimModel) {
        $scope.$broadcast('after:render');
      }
    }

    function calibrate(_distance) {
      $uibModal.open({
        animation: true,
        component: 'calibrationModal',
        windowClass: 'vp-calibration-modal',
        backdropClass: 'vp-calibration-modal-backdrop',
        resolve: {
          distance: function distance() {
            return _distance;
          }
        }
      }).result.then(function (result) {
        vm.page.viewer.setCalibration(result);
        vm.page.isEdited = true;
      });
    }

    function setWallProperty(wall) {
      $uibModal.open({
        animation: true,
        component: 'wallModal',
        windowClass: 'vp-wall-modal',
        backdropClass: 'vp-wall-modal-backdrop',
        resolve: {
          property: function property() {
            return vm.page.viewer.getWallProperty(wall);
          }
        }
      }).result.then(function (result) {
        vm.page.viewer.setWallProperty(wall, {
          zHeight: result
        });
        vm.page.isEdited = true;

        if (vm.selectedData) {
          vm.page.objectPropertyInfo = vm.selectedData.getGeometricalInfo();
          updateStatusData(vm.selectedData);
        }
      });
    }

    function shortcutCopy() {
      vm.copy();
    }

    function shortcutPaste() {
      if (vm.page.viewer.isEmptyClipboard()) return;
      vm.page.viewer.paste({
        x: vm.page.viewer._clipboard.left + 10,
        y: vm.page.viewer._clipboard.top + 10
      });
    }

    function contextMenu(e) {
      angular.element("#context_menu_2d").show();

      if (vm.page.viewer.getActiveObject()) {
        angular.element("#context_menu_copy").removeClass('disabled');
        angular.element("#context_menu_cut").removeClass('disabled');
        angular.element("#context_menu_apply_negative").removeClass('disabled');
      } else {
        angular.element("#context_menu_copy").addClass('disabled');
        angular.element("#context_menu_cut").addClass('disabled');
        angular.element("#context_menu_apply_negative").addClass('disabled');
      }

      if (vm.page.viewer.isEmptyClipboard()) {
        angular.element("#context_menu_paste").addClass('disabled');
      } else {
        angular.element("#context_menu_paste").removeClass('disabled');
      }

      vm.menuPos.x = e.x;
      vm.menuPos.y = e.y;
      angular.element("#context_menu_2d").css({
        top: e.y + 'px',
        left: e.x + 'px'
      });
      return false;
    }

    function updateStatusData(object) {
      var scale = 1;
      var decimal = 4;

      if (vm.page.unit === 'cm') {
        scale = 100;
        decimal = 2;
      } else if (vm.page.unit === 'mm') {
        scale = 1000;
        decimal = 0;
      } else if (vm.page.unit === 'inch') {
        scale = 39.3701;
        decimal = 2;
      }

      var info = object.getGeometricalInfo();
      vm.page.statusData.info.area = utils.roundNumber(info.area * scale * scale, decimal);
      vm.page.statusData.info.width = utils.roundNumber(info.width * scale, decimal);
      vm.page.statusData.info.height = utils.roundNumber(info.height * scale, decimal);

      if (angular.isDefined(info.wallHeight)) {
        vm.page.statusData.isWall = true;
        vm.page.statusData.info.wallHeight = info.wallHeight * scale;
      } else {
        vm.page.statusData.isWall = false;
        vm.page.statusData.info.wallHeight = undefined;
      }

      $timeout(function () {
        return $scope.$apply();
      });
    }

    function closeContextMenu() {
      angular.element("#context_menu_2d").hide();
      angular.element("#context_menu_apply_negative").removeClass('disabled');
    }

    function saveViewer(viewer, title, workLevel) {
      var data = angular.toJson({
        json: viewer.getJSON(),
        planInfo: viewer.getPlanData(),
        levels: viewer.levels
      });
      var inventoryData = viewer.data.getInventoryData();
      var planData = {
        jsonString: data,
        calibration: viewer.calibration
      };

      if (title) {
        planData.title = title;
      }

      if (workLevel) {
        planData.workLevel = workLevel;
      }

      return Promise.all([apiFactory.saveRoofPlan(viewer.data.id, planData), apiFactory.saveInventories({
        project: vm.projectId,
        modelId: viewer.data.id,
        inventories: inventoryData
      })]);
    }

    function save() {
      var promises = [saveViewer(vm.page.viewer1, vm.page.title, vm.page.workLevel)];

      if (vm.page.viewer2) {
        promises.push(saveViewer(vm.page.viewer2));
      }

      return new Promise(function (resolve, reject) {
        Promise.all(promises).then(function () {
          vm.page.isEdited = false;
          Notification.success("Plan is saved successfully.");
          resolve();
        })["catch"](function (err) {
          Notification.error("Failed to save. Try again.");
          $log.log(err);
          reject(err);
        });
      });
    }

    $scope.$on('addMarkerEvent', function () {
      vm.page.viewer.removeAllMarkers();
      vm.page.viewer.addMarker();
    });

    function initBoard() {
      // if (vm.projectId !== "5e1373d1275c0808a814d240") return;
      var userData = globals.userStore.get();
      vm.page.board = VP.board();
      vm.page.board.setViewer(vm.page.viewer, userData);
      apiFactory.updateChannelMembersForBoard({
        projectId: vm.projectId,
        planId: vm.page.plan._id
      }).then(function () {
        apiFactory.generateTextChatAccessToken({
          identity: userData._id,
          chatType: 'board'
        }).then(function (resp) {
          Twilio.Chat.Client.create(resp.data.token).then(function (client) {
            client.on('channelAdded', function (channel) {
              if (channel.channelState.uniqueName === vm.page.plan._id && vm.page.board) {
                vm.page.board.enterMessaging(channel);
              }
            });
            client.on('channelLeft', function (channel) {
              vm.page.board.leaveMessaging(channel);
            });
            client.on('channelRemoved', function (channel) {
              vm.page.board.leaveMessaging(channel);
            });
          })["catch"](function (error) {
            $log.error(error);
            Notification.error('Something went wrong try later');
          });
        })["catch"](function (error) {
          $log.error(error);
          Notification.error('Something went wrong try later');
        });
      })["catch"](function (err) {
        $log.error(err);
      });
    }
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('tqList', {
    controller: TqListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/tq/tq-list/tq-list.view.html'
  });
  /** @ngInject */

  function TqListController($scope, $timeout, $state, $stateParams, $log, $location, localStorageService, authFactory, apiFactory, Bim, VP, Notification, globals, utils) {
    var vm = this;
    var logout = globals.logout,
        projectStore = globals.projectStore,
        userStore = globals.userStore,
        companyStore = globals.companyStore;
    /* Get project */

    vm.project = projectStore.get();
    vm.userData = userStore.get();
    vm.searchText = '';

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.TQ_ACCESS_CREATE = 0;
    $scope.disType = 'Electrical';
    $scope.discipList = ['Electrical', 'Plumbing', 'Ventilation', 'Architect', 'Mechanical'];
    var dType = globals.getDashboardType(vm.userData);

    if (vm.userData.designation === "Admin") {
      $scope.TQ_ACCESS_CREATE = 4;
    } else {
      $scope.loading = true;
      apiFactory.getAccessSettingDetails({
        dType: dType,
        list: [Constants.AccessKey.TQ]
      }).then(function (res) {
        $scope.loading = false;
        $scope.TQ_ACCESS_CREATE = res.data.data[Constants.AccessKey.TQ];
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);
        Notification.error('Something went wrong try later');
      });
    }

    $scope.searchTextList = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.totalPages = 0;
    vm.currentPage = 1;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.loading = false;

    $scope.searchTq = function () {
      if ($scope.searchText && utils.isEmpty($scope.searchTextList)) {
        $scope.searchTextList.push($scope.searchText);
      }

      $scope.loading = true;
      apiFactory.listAllTqs({
        projectId: vm.project._id,
        page: vm.currentPage,
        size: $scope.numPerPage,
        discipline: $scope.disType,
        sort: "updatedAt",
        sortType: "true",
        search: $scope.searchText
      }).then(function (resp) {
        $scope.loading = false;
        $scope.totalCount = resp.data.total;
        vm.tqs = resp.data.list || [];
        $scope.totalPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);

        if (e.status === 403) {
          Notification.error(e.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        }
      });
    };

    $scope.searchTq();

    $scope.onCreateTQ = function () {
      localStorageService.set('tqData', {});
      $state.go('createTq');
    };

    $scope.getTqStatusClass = function (status) {
      switch (status) {
        case 'Draft':
          return {
            'draft': true
          };

        case 'Open':
          return {
            'open': true
          };

        case 'Closed':
          return {
            'closed': true
          };

        case 'Answered':
          return {
            'answered': true
          };

        default:
          return {
            'draft': true
          };
      }
    };

    $scope.setDiscipType = function (discipline) {
      $scope.disType = discipline;
      $scope.searchTq();
    };

    $scope.deleteTq = function (index, id) {
      apiFactory.deleteTq(id).then(function (res) {
        Notification.success(res.data.message);
        vm.tqs.splice(index, 1);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error('Cannot delete Technical Query!');
      });
    };

    $scope.gotoTqDetail = function (id) {
      $state.go('detailTq', {
        id: id
      });
    };

    $scope.$watch('tqs', function () {}); //Table Detail Tq part

    if (!authFactory.checkUser()) {
      logout();
      return;
    }

    vm.companyData = companyStore.get();
    vm.vppages = [];
    $scope.currentTab = 'attach';
    vm.vpCurPage = undefined;
    $scope.modelTitle = '';
    $scope.isPlanViewer = false;
    vm.files = [];

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.TQ_ACCESS_CREATE = 0;

    if (vm.userData.designation === "Admin") {
      $scope.TQ_ACCESS_CREATE = 4;
    } else {
      $scope.isLoadingDetail = true;
      apiFactory.getAccessSettingDetails({
        dType: dType,
        list: [Constants.AccessKey.ISSUE]
      }).then(function (res) {
        $scope.isLoadingeDtail = false;
        $scope.TQ_ACCESS_CREATE = res.data.data[Constants.AccessKey.ISSUE];
      })["catch"](function (e) {
        $scope.isLoadingeDtail = false;
        $log.error(e);
        Notification.error('Something went wrong try later');
      });
    }

    if (utils.isEmpty(vm.project)) {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.m3dLevelList = [];
    /* status */

    $scope.statusList = [{
      label: 'Draft',
      key: 'Draft'
    }, {
      label: 'Open',
      key: 'Open'
    }, {
      label: 'Closed',
      key: 'Closed'
    }, {
      label: 'Answered',
      key: 'Answered'
    }];
    /* Discipline */
    // $scope.discipList = [
    //   { label: 'Electrical', key: 'Electrical' },
    //   { label: 'Plumbing', key: 'Plumbing' },
    //   { label: 'Ventilation', key: 'Ventilation' },
    //   { label: 'Architect', key: 'Architect' },
    //   { label: 'Mechanical', key: 'Mechanical' }
    // ];

    vm.selected3dModel = undefined;
    /**Status bar section */

    vm.unit = 'm';
    vm.statusData = {
      pos: '',
      info: ''
    };
    vm.statusDisplayData = {
      pos: '',
      info: ''
    };
    $scope.toolbarList = {
      moveTool: [{
        id: 'select',
        icon: "cursor.svg",
        description: "Select"
      }, {
        id: 'pan',
        icon: "pan-move.svg",
        description: "Pan move"
      }, {
        id: 'paint',
        icon: "paint-bucket.svg",
        description: "Fill bucket"
      }, {
        id: 'erase',
        icon: "eraser.svg",
        description: "Eraser"
      }],
      drawingTool: [{
        id: 'text',
        icon: "drawing-pen.svg",
        description: "Draw text"
      }, {
        id: 'polyline',
        icon: "drawing-line.svg",
        description: "Draw line"
      }, {
        id: 'rect',
        icon: "drawing-rect.svg",
        description: "Draw rect"
      }, {
        id: 'addCross',
        icon: "drawing-round-rect.svg",
        description: "Draw round rect"
      }, {
        id: 'visibleCross',
        icon: "drawing-12718.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-76.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-11.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-30.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-09.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-127.svg",
        description: "Show cross section"
      }],
      measureTool: [{
        id: 'diameter',
        icon: "drawing-16.svg",
        description: "Measure diameter"
      }, {
        id: 'commonlength',
        icon: "drawing-52.svg",
        description: "Measure distance"
      }, {
        id: 'totalarea',
        icon: "drawing-12729.svg",
        description: "Measure area"
      }, {
        id: 'angle',
        icon: "drawing-12728.svg",
        description: "Measure angle"
      }]
    };
    vm.propertyIndicator = {
      show: false
    };

    $scope.change3dModel = function () {
      if (!utils.isEmpty($scope.tqData.marker.info3d.modelId) && !$scope.isVP) {
        // angular.element("#initial_loading_popup").show();
        $scope.isLoadingDetail = true;
        Promise.all([apiFactory.get3dModel($scope.tqData.marker.info3d.modelId), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getWorkLevelAndTypes(), apiFactory.getCalcSheet(vm.projectId), apiFactory.listInventories($scope.tqData.marker.info3d.modelId)]).then(function (resp) {
          var model = resp[0].data.data;
          $scope.modelTitle = model.name;
          $scope.m3dLevelList = Bim.levelList(model);
          vm.selected3dModel = model;

          if (model) {
            vm.materials = resp[1].data.list;
            vm.comboMaterials = resp[2].data.list;
            vm.equipments = resp[3].data.list;
            vm.comboEquipments = resp[4].data.list;

            if (resp[5].data.data) {
              vm.workLevels = resp[5].data.data.workLevels;
              vm.workTypes = resp[5].data.data.workTypes;
            }

            if (resp[6].data.data) {
              vm.sections = resp[6].data.data.levels;
            }

            var inventories = resp[7].data.list;
            refactorInventories(inventories);
            $scope.isLoadingDetail = false;
            load3dViewer(model, inventories);
          }
        })["catch"](function (e) {
          $scope.loading = false;
          $log.error(e);
        });
      }
    };

    function load3dViewer(data, inventories) {
      vm.viewer3d = Bim.mainViewer(angular.element("#bimviewer")[0]);
      vm.viewer3d.create();
      vm.viewer3d.setInputMethod(vm.companyData.companyInputMethod === 'European et al.' ? 'eu' : 'en');
      /* 2d viewer */

      vm.viewer2d = Bim.planViewer(angular.element('#model2d')[0]);
      vm.viewer2d.initialize(angular.element("#three-canvas-2d")[0].width, angular.element("#three-canvas-2d")[0].height);
      $scope.isLoadingDetail = false;
      vm.bimData = vm.viewer3d.getBimData();
      vm.viewer3d.on('objectSelected', onObjectSelected);
      vm.viewer3d.on('textSelected', onTextSelected);
      vm.viewer3d.on('textDeselected', onTextDeselected);
      vm.viewer3d.on('showContextMenu', onShowContextMenu); //vm.viewer3d.on('updateStatusData', updateStatusData);

      vm.viewer3d.on('objectDblClicked', onBimObjectDblClicked);
      vm.viewer3d.on('thumbnailReady', onThumbnailReady);
      vm.viewer3d.on('planAdded', applyData);
      vm.viewer3d.on('planTransformReady', showPlanControlMark);
      vm.viewer3d.on('cameraZoomChanged', function (zoom) {
        vm.zoomLevel = zoom;
      });
      vm.viewer3d.on('requestShowPlan', applyData);
      vm.viewer3d.on('toolActivated', onToolActivated);
      vm.viewer3d.on('markerPlaced', markerPlaced);
      vm.viewer3d.on('markerRemoved', markerRemoved);
      $scope.applyTexture = false;
      $scope.showPlan = false;
      vm.statusDisplayData.pos = {
        x: '',
        y: '',
        z: ''
      };
      vm.statusDisplayData.info = {
        area: '',
        width: '',
        height: ''
      };
      vm.themes = [{
        id: 0,
        space: '/assets/images/cgviewer/bim/environment/space-01/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-01.jpg'
      }, {
        id: 1,
        space: '/assets/images/cgviewer/bim/environment/space-02/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-02.jpg'
      }, {
        id: 2,
        space: '/assets/images/cgviewer/bim/environment/space-03/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-03.jpg'
      }, {
        id: 3,
        space: '/assets/images/cgviewer/bim/environment/space-04/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-04.jpg'
      }, {
        id: 4,
        space: '/assets/images/cgviewer/bim/environment/space-05/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-05.jpg'
      }, {
        id: 5,
        space: '/assets/images/cgviewer/bim/environment/space-06/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-06.jpg'
      }, {
        id: 6,
        space: '/assets/images/cgviewer/bim/environment/space-07/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-07.jpg'
      }, {
        id: 7,
        image: '/assets/images/cgviewer/bim/environment/bg-empty.jpg',
        empty: true
      }];
      vm.textBrush = vm.viewer3d.textBrush;

      if (data.viewer) {
        vm.theme = vm.themes[data.viewer.theme];
        vm.viewer3d.setTheme(vm.theme);
      }

      vm.viewer3d.loadBim(data).then(function (bimModel) {
        angular.element("#initial_loading_popup").hide();
        vm.bimModel = bimModel;
        vm.productList = Object.values(vm.bimModel.objectMap);
        vm.bimModel.setInventoryData(inventories);
        vm.modelInfo = {
          bimModel: bimModel,
          location: vm.location,
          gisTransformData: vm.gisTransformData
        };

        if ($scope.tqData.marker.info3d && $scope.tqData.marker.info3d.level) {
          $scope.change3dModelLevel();
        } //if($scope.tqData.marker.info3d && )


        applyData();
      })["catch"](function (err) {
        $log.error(err);
        angular.element("#initial_loading_popup").hide();
        Notification.error('IFC file cannot open.');
      });
    }

    vm.toolbarEvent = function (id) {
      if (!vm.viewer) return;

      switch (id) {
        case 'select':
          vm.viewer3d.setDragAction('picker');
          vm.viewer3d.setCursor('default');
          break;

        case 'pan':
          vm.viewer3d.setDragAction('pan');
          vm.viewer3d.setCursor('position', true, true);
          break;

        case 'commonlength':
        case 'angle':
        case 'circumference':
        case 'diameter':
        case 'volume':
        case 'sameplane':
        case 'totalarea':
          vm.viewer3d.newDimensions(id);
          break;

        case 'paint':
          vm.viewer3d.newPaint();
          break;

        case 'text':
          vm.textBrush.show = true;
          vm.viewer3d.newText();
          break;

        case 'addCross':
          vm.viewer3d.onAddCrossSection();
          break;

        case 'visibleCross':
          vm.viewer3d.onVisibleCrossSection();
          break;

        case 'applyCross':
          vm.viewer3d.onApplyCrossSection();
          break;

        case 'camera':
          vm.viewer3d.takeScreenshot();
          break;
      }
    };

    function onObjectSelected(object, objects) {
      hidePlanControlMark();

      if (angular.isDefined(object) && (object.isSelected || objects.length >= 1)) {
        vm.bimObject = object;
        vm.propertyIndicator.bimObjects = objects;
      } else {
        vm.bimObject = undefined;
        vm.propertyIndicator.bimObjects = undefined;
        vm.statusDisplayData.info = {
          area: '',
          width: '',
          height: ''
        };
        applyData();
      }
    }

    function onTextSelected(data) {
      vm.textBrush = {
        show: true,
        text: data.text,
        fontSize: data.fontSize,
        fontStyle: data.fontStyle,
        fontFamily: data.fontFamily,
        strokeColor: data.strokeColor,
        fillColor: data.fillColor,
        strokeWidth: data.strokeWidth
      };
      applyData();
    }

    function onTextDeselected() {
      vm.textBrush = vm.viewer3d.textBrush;
      applyData();
    }

    function onShowContextMenu(bimObject, objects, pos) {
      vm.propertyIndicator.show = true;
      vm.propertyIndicator.bimObjects = objects;
      vm.propertyIndicator.pos = pos;
      $timeout(function () {
        $scope.$apply();
      });
    }

    function onBimObjectDblClicked(bimObject, objects, pos) {
      vm.propertyIndicator.show = true;
      vm.propertyIndicator.bimObjects = objects;
      vm.propertyIndicator.pos = pos;
      $timeout(function () {
        $scope.$apply();
      });
    }

    function onThumbnailReady(thumbnail) {
      if (vm.modelId) {
        apiFactory.update3dThumbnail({
          modelId: vm.modelId,
          thumbnail: thumbnail
        }).then(function () {
          Notification.success("Model Thumbnail has updated!");
        })["catch"](function (err) {
          Notification.error("Model Thumbnail has failed!");
          $log.error(err);
        });
      }
    }

    function onToolActivated(type) {
      if (vm.textBrush) {
        vm.textBrush.show = type === 'text2d';
        applyData();
      }
    }

    function markerPlaced(is3d, markerPos) {
      if (!vm.levelId || vm.levelId === 'All') return;

      if (is3d) {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
          var pos = vm.viewer3d.get2dPos(markerPos, vm.levelId);

          if (pos) {
            vm.viewer2d.placeMarker(pos);
          }
        }
      } else {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.placeMarker(markerPos, vm.levelId);
        }
      }
    }

    function markerRemoved(is3d) {
      if (is3d) {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
        }
      } else {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.invalidate();
        }
      }
    }

    function applyData() {
      $timeout(function () {
        return $scope.$apply();
      });
    }

    function showPlanControlMark(bimPlan, position) {
      vm.selectedBimPlan = bimPlan;
      var bimPlanControl = angular.element('#bim-plan-control');
      bimPlanControl.css('left', position.x + 'px');
      bimPlanControl.css('top', position.y + 'px');
      bimPlanControl.show();
    }

    function hidePlanControlMark() {
      vm.selectedBimPlan = undefined;
      angular.element('#bim-plan-control').hide();
    }

    function refactorInventories(inventories) {
      inventories.forEach(function (inventory) {
        // if (inventory.section) {
        //   let section = vm.sections.find(s => s._id === inventory.section);
        //   inventory.section = section ? section._id : undefined;
        // }
        if (inventory.materials) {
          inventory.materials.forEach(function (mat) {
            var material = vm.materials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
            }
          });
        }

        if (inventory.dcps) {
          inventory.dcps.forEach(function (mat) {
            var material = vm.comboMaterials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
              mat.comboMaterialList = material.comboMaterialList;
            }
          });
        }
      });
    }

    $scope.change3dModelLevel = function () {
      if (!$scope.tqData.marker.info3d.modelId || !vm.viewer3d || !$scope.tqData.marker.info3d.level) {
        return;
      }

      if ($scope.tqData.marker.info3d.level === 'All' || $scope.tqData.marker.info3d.level === 'Others') {
        vm.viewer3d.showAllObject();
      } else {
        var levelId = $scope.tqData.marker.info3d.level;

        if (levelId) {
          vm.viewer3d.showObject(levelId);
          changePlan(vm.viewer3d.getBimModel(), levelId);
        } else {
          $scope.tqData.marker.info3d.level = 'All';
        }
      }

      if ($scope.tqData.marker.info3d.location && $scope.tqData.marker.info3d.location.x) {
        vm.viewer3d.loadMarkers([$scope.tqData.marker.info3d.location]);
      } else {
        vm.viewer3d.loadMarkers([]);
      }
    };

    $scope.changeVP = function () {
      if (!$scope.tqData.marker.info2d || !$scope.tqData.marker.info2d.modelId) {
        return;
      }

      angular.element("#initial_loading_popup").show();
      Promise.all([apiFactory.getRoofPlan($scope.tqData.marker.info2d.modelId), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getWorkLevelAndTypes(), apiFactory.getCalcSheet(vm.projectId)]).then(function (resp) {
        $scope.isLoadingDetail = false;
        vm.vppages = [];
        angular.element("#initial_loading_popup").hide();
        var plan = resp[0].data.data;
        $scope.modelTitle = plan.assetObj.title;
        vm.materials = resp[1].data.list || [];
        vm.comboMaterials = resp[2].data.list || [];
        vm.equipments = resp[3].data.list || [];
        vm.comboEquipments = resp[4].data.list || [];

        if (resp[5].data.data) {
          if (resp[5].data.data.workLevels) {
            vm.workLevels = resp[5].data.data.workLevels;
          }

          if (resp[5].data.data.workTypes) {
            vm.workTypes = resp[5].data.data.workTypes;
          }
        }

        if (resp[6].data.data) {
          vm.sections = resp[6].data.data.levels;
        }

        var markers = [];
        markers.push($scope.tqData.marker.info2d.location);
        vm.vpCurPage = {
          plan: plan,
          planId: plan._id,
          title: plan.assetObj.title,
          workLevel: plan.assetObj.level,
          materials: vm.materials,
          comboMaterials: vm.comboMaterials,
          sections: vm.sections,
          marker: markers
        };
        vm.vppages.push(vm.vpCurPage);
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Cannot load vp data.");
        angular.element("#vp_initial_loading_popup").hide();
      });
    };

    vm.updateVPPreview = function (model) {
      angular.element('#loading3d-container').removeClass('d-none');
      angular.element('#model3d-preview-container').hide();
      vm.viewer3d.clear();
      vm.viewer3d.loadBim(model).then(function () {
        angular.element('#loading3d-container').addClass('d-none');
        angular.element('#model3d-preview-container').show();
      })["catch"](function () {
        angular.element('#loading3d-container').addClass('d-none');
        angular.element('#model3d-preview-container').show();
        Notification.error('IFC file cannot open.');
      });
    };

    vm.cleartqData = function () {
      localStorageService.set('tqData', {});
    };

    vm.ActiveItemIndex = 0;

    vm.getData = function (index) {
      if (index == vm.ActiveItemIndex && vm.tqs[vm.ActiveItemIndex].expand == true) {
        vm.tqs[vm.ActiveItemIndex].expand = false;
        return;
      }

      vm.tqs[vm.ActiveItemIndex].expand = false;
      vm.tqs[index].expand = true;
      vm.ActiveItemIndex = index;
      $scope.isLoadingDetail = true;
      vm.tqId = vm.tqs[index]._id;
      apiFactory.getTqById(vm.tqId).then(function (res) {
        $scope.tqData = res.data.data;

        if ($scope.tqData.marker) {
          $scope.tqData.marker = $scope.tqData.marker.model;

          if ($scope.tqData.marker.info3d && $scope.tqData.marker.info3d.image && $scope.tqData.marker.info3d.image.secure_url) {
            $scope.tqData.image3DPath = $scope.tqData.marker.info3d.image.secure_url;
          }

          if ($scope.tqData.marker.info2d && $scope.tqData.marker.info2d.image && $scope.tqData.marker.info2d.image.secure_url) {
            $scope.tqData.image2DPath = $scope.tqData.marker.info2d.image.secure_url;
          }
        }

        if (!$scope.tqData) {
          Notification.error('Can not find the Technical Query.');
          $state.go('tqList');
          return;
        }

        if ($scope.tqData.marker.modelType == "vp") {
          $scope.isVP = true;
          $scope.tqData.marker.info2d = $scope.tqData.marker.info3d;
          delete $scope.tqData.marker.info3d;
        } else {
          $scope.isVP = false;
        }

        if ($scope.isVP) {
          $scope.changeVP();
        } else {
          $scope.change3dModel();
        } // $scope.assignedTo = $scope.issue.assignedTo.map(a => "<img src='"+a.profilePic+"' />").join(' ');
        //remakeTqActivities();


        apiFactory.getTqAttachList($scope.tqData._id).then(function (res) {
          $scope.tqData.attachList = res.data.list;
          $scope.tqData.attachList.map(function (it) {
            return it.imgSrc = utils.getTQFileIcon(utils.getExtensionByName(it.fileName));
          });
        })["catch"](function (error) {
          $scope.loading = false;
          $log.error(error);
        });
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
      });
    };

    $scope.updateTq = function (index) {
      var id = vm.tqs[index]._id;
      $scope.loading = true;
      var tqDataTmp = {
        progress: vm.tqs[index].progress,
        status: vm.tqs[index].status
      };
      apiFactory.updateTq(tqDataTmp, id).then(function (resp) {
        $scope.loading = false;
        Notification.success(resp.data.message);
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to update tq");
      });
    };

    function changePlan(bimModel, levelId) {
      if (!bimModel || !levelId || !vm.viewer2d) {
        return;
      }

      $scope.loading = true;
      angular.element('#loading2d-container').removeClass('d-none');
      angular.element('#model2d-container').hide();
      vm.viewer2d.loadBimModel(bimModel, levelId).then(function () {
        $scope.loading = false;
        angular.element('#loading2d-container').addClass('d-none');
        angular.element('#model2d-container').show();

        if ($scope.tqData.marker.info2d && $scope.tqData.marker.info2d.location && $scope.tqData.marker.info2d.location.x) {
          vm.viewer2d.loadMarkers([$scope.tqData.marker.info2d.location]);
        } else {
          vm.viewer2d.loadMarkers([]);
        }
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);
        angular.element('#loading2d-container').addClass('d-none');
        angular.element('#model2d-container').show();
      });
    }

    $scope.gotoEditTq = function (id) {
      //localStorageService.set('tqId',id)
      $state.go('editTq', {
        id: id
      });
    };

    $scope.gotoDashboard = function () {
      $location.path('dashboard/auditmanager-page');
    };

    $scope.gotoList = function () {
      $state.go('tqList');
    };

    $scope.getTqStatusClass = function (status) {
      switch (status) {
        case 'Draft':
          return {
            'draft': true
          };

        case 'Open':
          return {
            'open': true
          };

        case 'Closed':
          return {
            'closed': true
          };

        case 'Answered':
          return {
            'answered': true
          };

        default:
          return {
            'draft': true
          };
      }
    };

    $scope.setCurrentTab = function (value) {
      $scope.currentTab = value;
    };

    vm.fileUpdated = function (files) {
      if (files && files.length) {
        vm.files = vm.files.concat(files);
        uploadAttach();
      }
    };

    function uploadAttach() {
      var _iterator = _createForOfIteratorHelper(vm.files),
          _step;

      try {
        var _loop = function _loop() {
          var file = _step.value;

          if (file.progressPercentage === 100) {
            return "continue";
          }

          var payload = void 0;

          if ($scope.tqData) {
            payload = {
              file: file,
              tqId: $scope.tqData._id,
              projectId: $scope.tqData.projectId
            };
          }

          file.upload = apiFactory.uploadTqAttach(payload).success(function (res) {
            file.progressPercentage = 100;
            res.data.imgSrc = utils.getTQFileIcon(utils.getExtensionByName(res.data.fileName));
            $scope.tqData.attachList.push(res.data);
            Notification.success(res.message);
          }).error(function (error) {
            file.progressPercentage = 0;
            $log.error(error);
            Notification.error(error);
          }).progress(function (event) {
            var progressPercentage = parseInt(100.0 * event.loaded / event.total);

            if (progressPercentage === 100) {
              file.progressPercentage = 99;
            } else {
              file.progressPercentage = progressPercentage;
            }
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    vm.getStyleWidth = function (percentage) {
      return {
        'width': percentage + '%'
      };
    };

    vm.cancelUpload = function (file, index) {
      if (file.upload && file.upload.abort) {
        file.upload.abort();
      }

      vm.files.splice(index, 1);
    };

    $scope.deleteAttach = function (index, id) {
      apiFactory.deleteTqAttach(id).then(function (res) {
        $scope.tqData.attachList.splice(index, 1);
        Notification.success(res.data.message);
      })["catch"](function (e) {
        $log.error(e);
        Notification.error(e);
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('detailTq', {
    controller: DetailTqController,
    controllerAs: 'vm',
    templateUrl: 'app/main/tq/detail-tq/detail-tq.view.html'
  });
  /** @ngInject */

  function DetailTqController($scope, $timeout, $state, $stateParams, $log, $location, localStorageService, authFactory, apiFactory, Bim, VP, Notification, globals, utils) {
    var vm = this;
    vm.utils = utils;
    var logout = globals.logout,
        projectStore = globals.projectStore,
        userStore = globals.userStore,
        companyStore = globals.companyStore;

    if (!authFactory.checkUser()) {
      logout();
      return;
    }

    vm.tqId = $stateParams.id;
    /* project */

    vm.project = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    vm.vppages = [];
    $scope.currentTab = 'attach';
    vm.vpCurPage = undefined;
    $scope.modelTitle = '';
    $scope.level = "";
    $scope.isPlanViewer = false;
    vm.files = [];

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.TQ_ACCESS_CREATE = 0;
    var dType = globals.getDashboardType(vm.userData);

    if (vm.userData.designation === "Admin") {
      $scope.TQ_ACCESS_CREATE = 4;
    } else {
      $scope.isLoading = true;
      apiFactory.getAccessSettingDetails({
        dType: dType,
        list: [Constants.AccessKey.ISSUE]
      }).then(function (res) {
        $scope.isLoading = false;
        $scope.TQ_ACCESS_CREATE = res.data.data[Constants.AccessKey.ISSUE];
      })["catch"](function (e) {
        $scope.isLoading = false;
        $log.error(e);
        Notification.error('Something went wrong try later');
      });
    }

    if (utils.isEmpty(vm.project)) {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.m3dLevelList = [];
    /* status */

    $scope.statusList = [{
      label: 'Draft',
      key: 'Draft'
    }, {
      label: 'Open',
      key: 'Open'
    }, {
      label: 'Closed',
      key: 'Closed'
    }, {
      label: 'Answered',
      key: 'Answered'
    }];
    /* Discipline */

    $scope.discipList = [{
      label: 'Electrical',
      key: 'Electrical'
    }, {
      label: 'Plumbing',
      key: 'Plumbing'
    }, {
      label: 'Ventilation',
      key: 'Ventilation'
    }, {
      label: 'Architect',
      key: 'Architect'
    }, {
      label: 'Mechanical',
      key: 'Mechanical'
    }];
    vm.selected3dModel = undefined;
    /**Status bar section */

    vm.unit = 'm';
    vm.statusData = {
      pos: '',
      info: ''
    };
    vm.statusDisplayData = {
      pos: '',
      info: ''
    };
    $scope.toolbarList = {
      moveTool: [{
        id: 'select',
        icon: "cursor.svg",
        description: "Select"
      }, {
        id: 'pan',
        icon: "pan-move.svg",
        description: "Pan move"
      }, {
        id: 'paint',
        icon: "paint-bucket.svg",
        description: "Fill bucket"
      }, {
        id: 'erase',
        icon: "eraser.svg",
        description: "Eraser"
      }],
      drawingTool: [{
        id: 'text',
        icon: "drawing-pen.svg",
        description: "Draw text"
      }, {
        id: 'polyline',
        icon: "drawing-line.svg",
        description: "Draw line"
      }, {
        id: 'rect',
        icon: "drawing-rect.svg",
        description: "Draw rect"
      }, {
        id: 'addCross',
        icon: "drawing-round-rect.svg",
        description: "Draw round rect"
      }, {
        id: 'visibleCross',
        icon: "drawing-12718.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-76.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-11.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-30.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-09.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-127.svg",
        description: "Show cross section"
      }],
      measureTool: [{
        id: 'diameter',
        icon: "drawing-16.svg",
        description: "Measure diameter"
      }, {
        id: 'commonlength',
        icon: "drawing-52.svg",
        description: "Measure distance"
      }, {
        id: 'totalarea',
        icon: "drawing-12729.svg",
        description: "Measure area"
      }, {
        id: 'angle',
        icon: "drawing-12728.svg",
        description: "Measure angle"
      }]
    };
    vm.propertyIndicator = {
      show: false
    };

    $scope.change3dModel = function () {
      if (!utils.isEmpty($scope.tqData.marker.info3d.modelId) && !$scope.isVP) {
        angular.element("#initial_loading_popup").show();
        $scope.loading = true;
        Promise.all([apiFactory.get3dModel($scope.tqData.marker.info3d.modelId), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getWorkLevelAndTypes(), apiFactory.getCalcSheet(vm.projectId), apiFactory.listInventories($scope.tqData.marker.info3d.modelId)]).then(function (resp) {
          $scope.loading = false;
          var model = resp[0].data.data;
          $scope.modelTitle = model.name;
          $scope.level = $scope.tqData.marker.info3d.levelName != 'null' ? $scope.tqData.marker.info3d.levelName : '';
          $scope.m3dLevelList = Bim.levelList(model);
          vm.selected3dModel = model;

          if (model) {
            vm.materials = resp[1].data.list;
            vm.comboMaterials = resp[2].data.list;
            vm.equipments = resp[3].data.list;
            vm.comboEquipments = resp[4].data.list;

            if (resp[5].data.data) {
              vm.workLevels = resp[5].data.data.workLevels;
              vm.workTypes = resp[5].data.data.workTypes;
            }

            if (resp[6].data.data) {
              vm.sections = resp[6].data.data.levels;
            }

            var inventories = resp[7].data.list;
            refactorInventories(inventories);
            $scope.isLoading = false;
            load3dViewer(model, inventories);
          }
        })["catch"](function (e) {
          $scope.loading = false;
          $log.error(e);
        });
      }
    };

    function load3dViewer(data, inventories) {
      vm.viewer3d = Bim.mainViewer(angular.element("#bimviewer")[0]);
      vm.viewer3d.create();
      vm.viewer3d.setInputMethod(vm.companyData.companyInputMethod === 'European et al.' ? 'eu' : 'en');
      /* 2d viewer */

      vm.viewer2d = Bim.planViewer(angular.element('#model2d')[0]);
      vm.viewer2d.initialize(angular.element("#three-canvas-2d")[0].width, angular.element("#three-canvas-2d")[0].height);
      vm.bimData = vm.viewer3d.getBimData();
      vm.viewer3d.on('objectSelected', onObjectSelected);
      vm.viewer3d.on('textSelected', onTextSelected);
      vm.viewer3d.on('textDeselected', onTextDeselected);
      vm.viewer3d.on('showContextMenu', onShowContextMenu); //vm.viewer3d.on('updateStatusData', updateStatusData);

      vm.viewer3d.on('objectDblClicked', onBimObjectDblClicked);
      vm.viewer3d.on('thumbnailReady', onThumbnailReady);
      vm.viewer3d.on('planAdded', applyData);
      vm.viewer3d.on('planTransformReady', showPlanControlMark);
      vm.viewer3d.on('cameraZoomChanged', function (zoom) {
        vm.zoomLevel = zoom;
      });
      vm.viewer3d.on('requestShowPlan', applyData);
      vm.viewer3d.on('toolActivated', onToolActivated);
      vm.viewer3d.on('markerPlaced', markerPlaced);
      vm.viewer3d.on('markerRemoved', markerRemoved);
      $scope.applyTexture = false;
      $scope.showPlan = false;
      vm.statusDisplayData.pos = {
        x: '',
        y: '',
        z: ''
      };
      vm.statusDisplayData.info = {
        area: '',
        width: '',
        height: ''
      };
      vm.themes = [{
        id: 0,
        space: '/assets/images/cgviewer/bim/environment/space-01/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-01.jpg'
      }, {
        id: 1,
        space: '/assets/images/cgviewer/bim/environment/space-02/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-02.jpg'
      }, {
        id: 2,
        space: '/assets/images/cgviewer/bim/environment/space-03/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-03.jpg'
      }, {
        id: 3,
        space: '/assets/images/cgviewer/bim/environment/space-04/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-04.jpg'
      }, {
        id: 4,
        space: '/assets/images/cgviewer/bim/environment/space-05/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-05.jpg'
      }, {
        id: 5,
        space: '/assets/images/cgviewer/bim/environment/space-06/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-06.jpg'
      }, {
        id: 6,
        space: '/assets/images/cgviewer/bim/environment/space-07/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-07.jpg'
      }, {
        id: 7,
        image: '/assets/images/cgviewer/bim/environment/bg-empty.jpg',
        empty: true
      }];
      vm.textBrush = vm.viewer3d.textBrush;

      if (data.viewer) {
        vm.theme = vm.themes[data.viewer.theme];
        vm.viewer3d.setTheme(vm.theme);
      }

      vm.viewer3d.loadBim(data).then(function (bimModel) {
        angular.element("#initial_loading_popup").hide();
        vm.bimModel = bimModel;
        vm.productList = Object.values(vm.bimModel.objectMap);
        vm.bimModel.setInventoryData(inventories);
        vm.modelInfo = {
          bimModel: bimModel,
          location: vm.location,
          gisTransformData: vm.gisTransformData
        };

        if ($scope.tqData.marker.info3d && $scope.tqData.marker.info3d.level) {
          $scope.change3dModelLevel();
        } //if($scope.tqData.marker.info3d && )


        applyData();
      })["catch"](function (err) {
        $log.error(err);
        angular.element("#initial_loading_popup").hide();
        Notification.error('IFC file cannot open.');
      });
    }

    vm.toolbarEvent = function (id) {
      if (!vm.viewer) return;

      switch (id) {
        case 'select':
          vm.viewer3d.setDragAction('picker');
          vm.viewer3d.setCursor('default');
          break;

        case 'pan':
          vm.viewer3d.setDragAction('pan');
          vm.viewer3d.setCursor('position', true, true);
          break;

        case 'commonlength':
        case 'angle':
        case 'circumference':
        case 'diameter':
        case 'volume':
        case 'sameplane':
        case 'totalarea':
          vm.viewer3d.newDimensions(id);
          break;

        case 'paint':
          vm.viewer3d.newPaint();
          break;

        case 'text':
          vm.textBrush.show = true;
          vm.viewer3d.newText();
          break;

        case 'addCross':
          vm.viewer3d.onAddCrossSection();
          break;

        case 'visibleCross':
          vm.viewer3d.onVisibleCrossSection();
          break;

        case 'applyCross':
          vm.viewer3d.onApplyCrossSection();
          break;

        case 'camera':
          vm.viewer3d.takeScreenshot();
          break;
      }
    };

    function onObjectSelected(object, objects) {
      hidePlanControlMark();

      if (angular.isDefined(object) && (object.isSelected || objects.length >= 1)) {
        vm.bimObject = object;
        vm.propertyIndicator.bimObjects = objects;
      } else {
        vm.bimObject = undefined;
        vm.propertyIndicator.bimObjects = undefined;
        vm.statusDisplayData.info = {
          area: '',
          width: '',
          height: ''
        };
        applyData();
      }
    }

    function onTextSelected(data) {
      vm.textBrush = {
        show: true,
        text: data.text,
        fontSize: data.fontSize,
        fontStyle: data.fontStyle,
        fontFamily: data.fontFamily,
        strokeColor: data.strokeColor,
        fillColor: data.fillColor,
        strokeWidth: data.strokeWidth
      };
      applyData();
    }

    function onTextDeselected() {
      vm.textBrush = vm.viewer3d.textBrush;
      applyData();
    }

    function onShowContextMenu(bimObject, objects, pos) {
      vm.propertyIndicator.show = true;
      vm.propertyIndicator.bimObjects = objects;
      vm.propertyIndicator.pos = pos;
      $timeout(function () {
        $scope.$apply();
      });
    }

    function onBimObjectDblClicked(bimObject, objects, pos) {
      vm.propertyIndicator.show = true;
      vm.propertyIndicator.bimObjects = objects;
      vm.propertyIndicator.pos = pos;
      $timeout(function () {
        $scope.$apply();
      });
    }

    function onThumbnailReady(thumbnail) {
      if (vm.modelId) {
        apiFactory.update3dThumbnail({
          modelId: vm.modelId,
          thumbnail: thumbnail
        }).then(function () {
          Notification.success("Model Thumbnail has updated!");
        })["catch"](function (err) {
          Notification.error("Model Thumbnail has failed!");
          $log.error(err);
        });
      }
    }

    function onToolActivated(type) {
      if (vm.textBrush) {
        vm.textBrush.show = type === 'text2d';
        applyData();
      }
    }

    function markerPlaced(is3d, markerPos) {
      if (!vm.levelId || vm.levelId === 'All') return;

      if (is3d) {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
          var pos = vm.viewer3d.get2dPos(markerPos, vm.levelId);

          if (pos) {
            vm.viewer2d.placeMarker(pos);
          }
        }
      } else {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.placeMarker(markerPos, vm.levelId);
        }
      }
    }

    function markerRemoved(is3d) {
      if (is3d) {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
        }
      } else {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.invalidate();
        }
      }
    }

    function applyData() {
      $timeout(function () {
        return $scope.$apply();
      });
    }

    function showPlanControlMark(bimPlan, position) {
      vm.selectedBimPlan = bimPlan;
      var bimPlanControl = angular.element('#bim-plan-control');
      bimPlanControl.css('left', position.x + 'px');
      bimPlanControl.css('top', position.y + 'px');
      bimPlanControl.show();
    }

    function hidePlanControlMark() {
      vm.selectedBimPlan = undefined;
      angular.element('#bim-plan-control').hide();
    }

    function refactorInventories(inventories) {
      inventories.forEach(function (inventory) {
        // if (inventory.section) {
        //   let section = vm.sections.find(s => s._id === inventory.section);
        //   inventory.section = section ? section._id : undefined;
        // }
        if (inventory.materials) {
          inventory.materials.forEach(function (mat) {
            var material = vm.materials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
            }
          });
        }

        if (inventory.dcps) {
          inventory.dcps.forEach(function (mat) {
            var material = vm.comboMaterials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
              mat.comboMaterialList = material.comboMaterialList;
            }
          });
        }
      });
    }

    $scope.change3dModelLevel = function () {
      if (!$scope.tqData.marker.info3d.modelId || !vm.viewer3d || !$scope.tqData.marker.info3d.level) {
        return;
      }

      if ($scope.tqData.marker.info3d.level === 'All' || $scope.tqData.marker.info3d.level === 'Others') {
        vm.viewer3d.showAllObject();
      } else {
        var levelId = $scope.tqData.marker.info3d.level;

        if (levelId) {
          vm.viewer3d.showObject(levelId);
          changePlan(vm.viewer3d.getBimModel(), levelId);
        } else {
          $scope.tqData.marker.info3d.level = 'All';
        }
      }

      if ($scope.tqData.marker.info3d.location && $scope.tqData.marker.info3d.location.x) {
        vm.viewer3d.loadMarkers([$scope.tqData.marker.info3d.location]);
      } else {
        vm.viewer3d.loadMarkers([]);
      }
    };

    $scope.changeVP = function () {
      if (!$scope.tqData.marker.info2d || !$scope.tqData.marker.info2d.modelId) {
        return;
      }

      angular.element("#initial_loading_popup").show();
      Promise.all([apiFactory.getRoofPlan($scope.tqData.marker.info2d.modelId), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getWorkLevelAndTypes(), apiFactory.getCalcSheet(vm.projectId)]).then(function (resp) {
        vm.vppages = [];
        angular.element("#initial_loading_popup").hide();
        var plan = resp[0].data.data;
        $scope.modelTitle = plan.assetObj.title;
        $scope.level = $scope.tqData.marker.info2d.levelName != 'null' ? $scope.tqData.marker.info2d.levelName : "";
        vm.materials = resp[1].data.list || [];
        vm.comboMaterials = resp[2].data.list || [];
        vm.equipments = resp[3].data.list || [];
        vm.comboEquipments = resp[4].data.list || [];

        if (resp[5].data.data) {
          if (resp[5].data.data.workLevels) {
            vm.workLevels = resp[5].data.data.workLevels;
          }

          if (resp[5].data.data.workTypes) {
            vm.workTypes = resp[5].data.data.workTypes;
          }
        }

        if (resp[6].data.data) {
          vm.sections = resp[6].data.data.levels;
        }

        var markers = [];
        markers.push($scope.tqData.marker.info2d.location);
        vm.vpCurPage = {
          plan: plan,
          planId: plan._id,
          title: plan.assetObj.title,
          workLevel: plan.assetObj.level,
          materials: vm.materials,
          comboMaterials: vm.comboMaterials,
          sections: vm.sections,
          marker: markers
        };
        vm.vppages.push(vm.vpCurPage);
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Cannot load vp data.");
        angular.element("#vp_initial_loading_popup").hide();
      });
    };

    vm.updateVPPreview = function (model) {
      angular.element('#loading3d-container').removeClass('d-none');
      angular.element('#model3d-preview-container').hide();
      vm.viewer3d.clear();
      vm.viewer3d.loadBim(model).then(function () {
        angular.element('#loading3d-container').addClass('d-none');
        angular.element('#model3d-preview-container').show();
      })["catch"](function () {
        angular.element('#loading3d-container').addClass('d-none');
        angular.element('#model3d-preview-container').show();
        Notification.error('IFC file cannot open.');
      });
    };

    vm.cleartqData = function () {
      localStorageService.set('tqData', {});
    };

    vm.readMoreClick = false;

    vm.showReadMore = function () {
      vm.readMoreClick = !vm.readMoreClick;
      if (vm.readMoreClick) vm.readMore = false;
    };

    vm.init = function () {
      $scope.isLoading = true;
      apiFactory.getTqById(vm.tqId).then(function (res) {
        $scope.isLoading = false;
        $scope.tqData = res.data.data;
        vm.readMoreText = $scope.tqData.description;
        vm.readMore = false;

        if ($scope.tqData.description.length > 250) {
          vm.readMore = true;
          vm.readMoreText = $scope.tqData.description.substring(0, 250);
        }

        if ($scope.tqData.marker) {
          $scope.tqData.marker = $scope.tqData.marker.model;

          if ($scope.tqData.marker.info3d && $scope.tqData.marker.info3d.image && $scope.tqData.marker.info3d.image.secure_url) {
            $scope.tqData.image3DPath = $scope.tqData.marker.info3d.image.secure_url;
          }

          if ($scope.tqData.marker.info2d && $scope.tqData.marker.info2d.image && $scope.tqData.marker.info2d.image.secure_url) {
            $scope.tqData.image2DPath = $scope.tqData.marker.info2d.image.secure_url;
          }
        }

        if (!$scope.tqData) {
          Notification.error('Can not find the Technical Query.');
          $state.go('tqList');
          return;
        }

        if ($scope.tqData.marker.modelType == "vp") {
          $scope.isVP = true;
          $scope.tqData.marker.info2d = $scope.tqData.marker.info3d;
          delete $scope.tqData.marker.info3d;
        } else {
          $scope.isVP = false;
        }

        if ($scope.isVP) {
          $scope.changeVP();
        } else {
          $scope.change3dModel();
        } // $scope.assignedTo = $scope.issue.assignedTo.map(a => "<img src='"+a.profilePic+"' />").join(' ');
        //remakeTqActivities();


        apiFactory.getTqAttachList($scope.tqData._id).then(function (res) {
          $scope.tqData.attachList = res.data.list;
          $scope.tqData.attachList.map(function (it) {
            return it.imgSrc = utils.getTQFileIcon(utils.getExtensionByName(it.fileName));
          });
        })["catch"](function (error) {
          $scope.loading = false;
          $log.error(error);
        });
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
      });
    };

    vm.init();

    function changePlan(bimModel, levelId) {
      if (!bimModel || !levelId || !vm.viewer2d) {
        return;
      }

      $scope.loading = true;
      angular.element('#loading2d-container').removeClass('d-none');
      angular.element('#model2d-container').hide();
      vm.viewer2d.loadBimModel(bimModel, levelId).then(function () {
        $scope.loading = false;
        angular.element('#loading2d-container').addClass('d-none');
        angular.element('#model2d-container').show();

        if ($scope.tqData.marker.info2d && $scope.tqData.marker.info2d.location && $scope.tqData.marker.info2d.location.x) {
          vm.viewer2d.loadMarkers([$scope.tqData.marker.info2d.location]);
        } else {
          vm.viewer2d.loadMarkers([]);
        }
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);
        angular.element('#loading2d-container').addClass('d-none');
        angular.element('#model2d-container').show();
      });
    }

    $scope.gotoEditTq = function (id) {
      //localStorageService.set('tqId',id)
      $state.go('editTq', {
        id: id
      });
    };

    $scope.gotoDashboard = function () {
      $location.path('dashboard/auditmanager-page');
    };

    $scope.gotoList = function () {
      $state.go('tqList');
    };

    $scope.getTqStatusClass = function (status) {
      switch (status) {
        case 'Draft':
          return {
            'draft': true
          };

        case 'Open':
          return {
            'open': true
          };

        case 'Closed':
          return {
            'closed': true
          };

        case 'Answered':
          return {
            'answered': true
          };

        default:
          return {
            'draft': true
          };
      }
    };

    $scope.setCurrentTab = function (value) {
      $scope.currentTab = value;
    };

    vm.fileUpdated = function (files) {
      if (files && files.length) {
        vm.files = vm.files.concat(files);
        uploadAttach();
      }
    };

    function uploadAttach() {
      var _iterator = _createForOfIteratorHelper(vm.files),
          _step;

      try {
        var _loop = function _loop() {
          var file = _step.value;

          if (file.progressPercentage === 100) {
            return "continue";
          }

          var payload = void 0;

          if ($scope.tqData) {
            payload = {
              file: file,
              tqId: $scope.tqData._id,
              projectId: $scope.tqData.projectId
            };
          }

          file.upload = apiFactory.uploadTqAttach(payload).success(function (res) {
            file.progressPercentage = 100;
            res.data.imgSrc = utils.getTQFileIcon(utils.getExtensionByName(res.data.fileName));
            $scope.tqData.attachList.push(res.data);
            Notification.success(res.message);
          }).error(function (error) {
            file.progressPercentage = 0;
            $log.error(error);
            Notification.error(error);
          }).progress(function (event) {
            var progressPercentage = parseInt(100.0 * event.loaded / event.total);

            if (progressPercentage === 100) {
              file.progressPercentage = 99;
            } else {
              file.progressPercentage = progressPercentage;
            }
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    vm.getStyleWidth = function (percentage) {
      return {
        'width': percentage + '%'
      };
    };

    vm.cancelUpload = function (file, index) {
      if (file.upload && file.upload.abort) {
        file.upload.abort();
      }

      vm.files.splice(index, 1);
    };

    $scope.deleteAttach = function (index, id) {
      apiFactory.deleteTqAttach(id).then(function (res) {
        $scope.tqData.attachList.splice(index, 1);
        Notification.success(res.data.message);
      })["catch"](function (e) {
        $log.error(e);
        Notification.error(e);
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('createTq', {
    controller: CreateTqController,
    controllerAs: 'vm',
    templateUrl: 'app/main/tq/create-tq/create-tq.view.html'
  });
  /** @ngInject */

  function CreateTqController($scope, $timeout, $state, $stateParams, $log, $location, $document, localStorageService, authFactory, apiFactory, Bim, VP, Notification, globals, utils) {
    var vm = this;
    var logout = globals.logout,
        projectStore = globals.projectStore,
        userStore = globals.userStore,
        companyStore = globals.companyStore;

    if (!authFactory.checkUser()) {
      logout();
      return;
    }
    /* project */


    vm.project = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    vm.vppages = [];
    vm.vpCurPage = undefined;
    $scope.modelTitle = '';
    $scope.isPlanViewer = false;
    vm.tqId = $stateParams.id;
    vm.editMode = false;

    if (vm.tqId) {
      vm.editMode = true;
    }

    if (utils.isEmpty(vm.project)) {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.m3dLevelList = [];
    /* status */

    $scope.statusList = [{
      label: 'Draft',
      key: 'Draft'
    }, {
      label: 'Open',
      key: 'Open'
    }, {
      label: 'Closed',
      key: 'Closed'
    }, {
      label: 'Answered',
      key: 'Answered'
    }];
    /* Discipline */

    $scope.discipList = [{
      label: 'Electrical',
      key: 'Electrical'
    }, {
      label: 'Plumbing',
      key: 'Plumbing'
    }, {
      label: 'Ventilation',
      key: 'Ventilation'
    }, {
      label: 'Architect',
      key: 'Architect'
    }, {
      label: 'Mechanical',
      key: 'Mechanical'
    }];
    vm.selected3dModel = undefined;
    /**Status bar section */

    vm.unit = 'm';
    vm.statusData = {
      pos: '',
      info: ''
    };
    vm.statusDisplayData = {
      pos: '',
      info: ''
    };
    $scope.toolbarList = {
      moveTool: [{
        id: 'select',
        icon: "cursor.svg",
        description: "Select"
      }, {
        id: 'pan',
        icon: "pan-move.svg",
        description: "Pan move"
      }, {
        id: 'paint',
        icon: "paint-bucket.svg",
        description: "Fill bucket"
      }, {
        id: 'erase',
        icon: "eraser.svg",
        description: "Eraser"
      }],
      drawingTool: [{
        id: 'text',
        icon: "drawing-pen.svg",
        description: "Draw text"
      }, {
        id: 'polyline',
        icon: "drawing-line.svg",
        description: "Draw line"
      }, {
        id: 'rect',
        icon: "drawing-rect.svg",
        description: "Draw rect"
      }, {
        id: 'addCross',
        icon: "drawing-round-rect.svg",
        description: "Draw round rect"
      }, {
        id: 'visibleCross',
        icon: "drawing-12718.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-76.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-11.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-30.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-09.svg",
        description: "Show cross section"
      }, {
        id: 'visibleCross',
        icon: "drawing-127.svg",
        description: "Show cross section"
      }],
      measureTool: [{
        id: 'diameter',
        icon: "drawing-16.svg",
        description: "Measure diameter"
      }, {
        id: 'commonlength',
        icon: "drawing-52.svg",
        description: "Measure distance"
      }, {
        id: 'totalarea',
        icon: "drawing-12729.svg",
        description: "Measure area"
      }, {
        id: 'angle',
        icon: "drawing-12728.svg",
        description: "Measure angle"
      }]
    };
    vm.propertyIndicator = {
      show: false
    };

    $scope.checkValidation = function () {
      var ret = {
        success: true,
        errorMsg: ''
      };
      var errorMsg = "";

      if (utils.isEmpty($scope.tqData.title)) {
        errorMsg = 'Please input title';
      } else if (utils.isEmpty($scope.tqData.status)) {
        errorMsg = 'Please select tq status';
      }

      if (!$scope.isVP && !$scope.tqData.marker.info3d.modelId) {
        errorMsg = 'Please select a 3d model for new tq.';
      }

      if ($scope.isVP && !$scope.tqData.marker.info2d.modelId) {
        errorMsg = 'Please select a 2d model for new tq.';
      }

      if (errorMsg.length) {
        ret.success = false;
        ret.errorMsg = errorMsg;
        return ret;
      }

      $scope.tqData.drawings = [];

      if ($scope.tqData.marker.modelType === '3d') {
        if (vm.viewer3d) {
          $scope.tqData.marker.info3d.location = vm.viewer3d.getMarkers()[0];

          if ($scope.tqData.marker.info3d.location) {
            var image3D = vm.viewer3d.takeImage();
            $scope.tqData.drawings.push({
              image3D: image3D
            });
          } //$scope.tqData.marker.info3d.clipping = vm.viewer3d.getClipping();

        }

        if (vm.viewer2d) {
          if (!$scope.tqData.marker.info2d) {
            $scope.tqData.marker.info2d = {
              location: {
                x: 0,
                y: 0
              }
            };
          }

          $scope.tqData.marker.info2d.location = vm.viewer2d.getMarkers()[0];

          if ($scope.tqData.marker.info2d.location) {
            var image2D = vm.viewer2d.takeImage();
            $scope.tqData.drawings.push({
              image2D: image2D
            });
          }
        }
      } else {
        $scope.vpViewer = vm.vpCurPage.getViewer();
        $scope.tqData.marker.info3d = {};
        $scope.tqData.marker.info3d.location = $scope.vpViewer.getMarkers()[0];
        $scope.tqData.marker.info3d.modelId = $scope.tqData.marker.info2d.modelId;
        $scope.tqData.marker.info3d.level = $scope.tqData.marker.info2d.level;
        $scope.tqData.marker.info3d.levelName = $scope.tqData.marker.info2d.levelName;

        if ($scope.tqData.marker.info3d.location) {
          var _image2D = $scope.vpViewer.takeImage();

          $scope.tqData.drawings.push({
            image3D: _image2D
          });
        }

        delete $scope.tqData.marker.info2d;
      }

      if ($scope.tqData.drawings) {
        $scope.tqData.drawings.forEach(function (item) {
          if (item.image2D) {
            $scope.tqData.image2d = utils.dataURLtoFile(item.image2D, 'image2D');
          } else if (item.image3D) {
            $scope.tqData.image3d = utils.dataURLtoFile(item.image3D, 'image3D');
          }
        });
        $scope.tqData.drawings = undefined;
      }

      if (errorMsg.length) {
        ret.success = false;
        ret.errorMsg = errorMsg;
      }

      return ret;
    };

    $scope.change3dModel = function () {
      if (!utils.isEmpty($scope.tqData.marker.info3d.modelId) && !$scope.isVP) {
        angular.element("#initial_loading_popup").show();
        Promise.all([apiFactory.get3dModel($scope.tqData.marker.info3d.modelId), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getWorkLevelAndTypes(), apiFactory.getCalcSheet(vm.projectId), apiFactory.listInventories($scope.tqData.marker.info3d.modelId)]).then(function (resp) {
          var model = resp[0].data.data;
          $scope.modelTitle = model.name;
          $scope.m3dLevelList = Bim.levelList(model);
          vm.selected3dModel = model;

          if (model) {
            vm.materials = resp[1].data.list;
            vm.comboMaterials = resp[2].data.list;
            vm.equipments = resp[3].data.list;
            vm.comboEquipments = resp[4].data.list;

            if (resp[5].data.data) {
              vm.workLevels = resp[5].data.data.workLevels;
              vm.workTypes = resp[5].data.data.workTypes;
            }

            if (resp[6].data.data) {
              vm.sections = resp[6].data.data.levels;
            }

            var inventories = resp[7].data.list;
            refactorInventories(inventories);
            load3dViewer(model, inventories);
          }
        })["catch"](function (e) {
          angular.element("#initial_loading_popup").hide();
          $log.error(e);
        });
      }
    };

    function load3dViewer(data, inventories) {
      vm.viewer3d = Bim.mainViewer(angular.element("#bimviewer")[0]);
      vm.viewer3d.create();
      vm.viewer3d.setInputMethod(vm.companyData.companyInputMethod === 'European et al.' ? 'eu' : 'en');
      /* 2d viewer */

      vm.viewer2d = Bim.planViewer($document[0].getElementById('model2d-preview'));
      vm.viewer2d.initialize();
      vm.bimData = vm.viewer3d.getBimData();
      vm.viewer3d.on('objectSelected', onObjectSelected);
      vm.viewer3d.on('textSelected', onTextSelected);
      vm.viewer3d.on('textDeselected', onTextDeselected);
      vm.viewer3d.on('showContextMenu', onShowContextMenu);
      vm.viewer3d.on('updateStatusData', updateStatusData);
      vm.viewer3d.on('objectDblClicked', onBimObjectDblClicked);
      vm.viewer3d.on('thumbnailReady', onThumbnailReady);
      vm.viewer3d.on('planAdded', applyData);
      vm.viewer3d.on('planTransformReady', showPlanControlMark);
      vm.viewer3d.on('cameraZoomChanged', function (zoom) {
        vm.zoomLevel = zoom;
      });
      vm.viewer3d.on('requestShowPlan', applyData);
      vm.viewer3d.on('toolActivated', onToolActivated);
      vm.viewer3d.on('markerPlaced', markerPlaced);
      vm.viewer3d.on('markerRemoved', markerRemoved);
      $scope.applyTexture = false;
      $scope.showPlan = false;
      vm.statusDisplayData.pos = {
        x: '',
        y: '',
        z: ''
      };
      vm.statusDisplayData.info = {
        area: '',
        width: '',
        height: ''
      };
      vm.themes = [{
        id: 0,
        space: '/assets/images/cgviewer/bim/environment/space-01/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-01.jpg'
      }, {
        id: 1,
        space: '/assets/images/cgviewer/bim/environment/space-02/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-02.jpg'
      }, {
        id: 2,
        space: '/assets/images/cgviewer/bim/environment/space-03/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-03.jpg'
      }, {
        id: 3,
        space: '/assets/images/cgviewer/bim/environment/space-04/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-04.jpg'
      }, {
        id: 4,
        space: '/assets/images/cgviewer/bim/environment/space-05/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-05.jpg'
      }, {
        id: 5,
        space: '/assets/images/cgviewer/bim/environment/space-06/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-06.jpg'
      }, {
        id: 6,
        space: '/assets/images/cgviewer/bim/environment/space-07/back.jpg',
        ground: '/assets/images/cgviewer/bim/environment/ground-07.jpg'
      }, {
        id: 7,
        image: '/assets/images/cgviewer/bim/environment/bg-empty.jpg',
        empty: true
      }];
      vm.textBrush = vm.viewer3d.textBrush;

      if (data.viewer) {
        vm.theme = vm.themes[data.viewer.theme];
        vm.viewer3d.setTheme(vm.theme);
      }

      vm.viewer3d.loadBim(data).then(function (bimModel) {
        angular.element("#initial_loading_popup").hide();
        vm.bimModel = bimModel;
        vm.productList = Object.values(vm.bimModel.objectMap);
        vm.bimModel.setInventoryData(inventories);
        vm.modelInfo = {
          bimModel: bimModel,
          location: vm.location,
          gisTransformData: vm.gisTransformData
        };
        applyData();
      })["catch"](function (err) {
        $log.error(err);
        angular.element("#initial_loading_popup").hide();
        Notification.error('IFC file cannot open.');
      });
    }

    vm.toolbarEvent = function (id) {
      if (!vm.viewer) return;

      switch (id) {
        case 'select':
          vm.viewer3d.setDragAction('picker');
          vm.viewer3d.setCursor('default');
          break;

        case 'pan':
          vm.viewer3d.setDragAction('pan');
          vm.viewer3d.setCursor('position', true, true);
          break;

        case 'commonlength':
        case 'angle':
        case 'circumference':
        case 'diameter':
        case 'volume':
        case 'sameplane':
        case 'totalarea':
          vm.viewer3d.newDimensions(id);
          break;

        case 'paint':
          vm.viewer3d.newPaint();
          break;

        case 'text':
          vm.textBrush.show = true;
          vm.viewer3d.newText();
          break;

        case 'addCross':
          vm.viewer3d.onAddCrossSection();
          break;

        case 'visibleCross':
          vm.viewer3d.onVisibleCrossSection();
          break;

        case 'applyCross':
          vm.viewer3d.onApplyCrossSection();
          break;

        case 'camera':
          vm.viewer3d.takeScreenshot();
          break;
      }
    };

    function onObjectSelected(object, objects) {
      hidePlanControlMark();

      if (angular.isDefined(object) && (object.isSelected || objects.length >= 1)) {
        vm.bimObject = object;
        vm.propertyIndicator.bimObjects = objects;
      } else {
        vm.bimObject = undefined;
        vm.propertyIndicator.bimObjects = undefined;
        vm.statusDisplayData.info = {
          area: '',
          width: '',
          height: ''
        };
        applyData();
      }
    }

    function onTextSelected(data) {
      vm.textBrush = {
        show: true,
        text: data.text,
        fontSize: data.fontSize,
        fontStyle: data.fontStyle,
        fontFamily: data.fontFamily,
        strokeColor: data.strokeColor,
        fillColor: data.fillColor,
        strokeWidth: data.strokeWidth
      };
      applyData();
    }

    function onTextDeselected() {
      vm.textBrush = vm.viewer3d.textBrush;
      applyData();
    }

    function onShowContextMenu(bimObject, objects, pos) {
      vm.propertyIndicator.show = true;
      vm.propertyIndicator.bimObjects = objects;
      vm.propertyIndicator.pos = pos;
      $timeout(function () {
        $scope.$apply();
      });
    }

    function onBimObjectDblClicked(bimObject, objects, pos) {
      vm.propertyIndicator.show = true;
      vm.propertyIndicator.bimObjects = objects;
      vm.propertyIndicator.pos = pos;
      $timeout(function () {
        $scope.$apply();
      });
    }

    function onThumbnailReady(thumbnail) {
      if (vm.modelId) {
        apiFactory.update3dThumbnail({
          modelId: vm.modelId,
          thumbnail: thumbnail
        }).then(function () {
          Notification.success("Model Thumbnail has updated!");
        })["catch"](function (err) {
          Notification.error("Model Thumbnail has failed!");
          $log.error(err);
        });
      }
    }

    function onToolActivated(type) {
      if (vm.textBrush) {
        vm.textBrush.show = type === 'text2d';
        applyData();
      }
    }

    function markerPlaced(is3d, markerPos) {
      if (!vm.levelId || vm.levelId === 'All') return;

      if (is3d) {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
          var pos = vm.viewer3d.get2dPos(markerPos, vm.levelId);

          if (pos) {
            vm.viewer2d.placeMarker(pos);
          }
        }
      } else {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.placeMarker(markerPos, vm.levelId);
        }
      }
    }

    function markerRemoved(is3d) {
      if (is3d) {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
        }
      } else {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.invalidate();
        }
      }
    }

    function applyData() {
      $timeout(function () {
        return $scope.$apply();
      });
    }

    function showPlanControlMark(bimPlan, position) {
      vm.selectedBimPlan = bimPlan;
      var bimPlanControl = angular.element('#bim-plan-control');
      bimPlanControl.css('left', position.x + 'px');
      bimPlanControl.css('top', position.y + 'px');
      bimPlanControl.show();
    }

    function hidePlanControlMark() {
      vm.selectedBimPlan = undefined;
      angular.element('#bim-plan-control').hide();
    }

    function refactorInventories(inventories) {
      inventories.forEach(function (inventory) {
        // if (inventory.section) {
        //   let section = vm.sections.find(s => s._id === inventory.section);
        //   inventory.section = section ? section._id : undefined;
        // }
        if (inventory.materials) {
          inventory.materials.forEach(function (mat) {
            var material = vm.materials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
            }
          });
        }

        if (inventory.dcps) {
          inventory.dcps.forEach(function (mat) {
            var material = vm.comboMaterials.find(function (x) {
              return x._id === mat._id;
            });

            if (material) {
              mat.name = material.name;
              mat.color = material.color;
              mat.opacity = material.opacity;
              mat.comboMaterialList = material.comboMaterialList;
            }
          });
        }
      });
    }

    function updateStatusData(pos) {
      if (pos) {
        vm.statusData.pos = pos.clone();
      } else {
        vm.statusData.pos = undefined;
      }

      if (vm.statusData.pos) {
        vm.statusDisplayData.pos = getDisplayPosData(vm.statusData.pos);
      } else {
        vm.statusDisplayData.pos = {
          x: '',
          y: '',
          z: ''
        };
      }

      $timeout(function () {
        $scope.$apply();
      });
    }

    function getDisplayPosData(pos) {
      var data = {};
      var scale = 1;
      var decimal = 4;

      if (vm.unit === 'cm') {
        scale = 100;
        decimal = 2;
      } else if (vm.unit === 'mm') {
        scale = 1000;
        decimal = 0;
      } else if (vm.unit === 'inch') {
        scale = 39.37;
        decimal = 2;
      }

      data.x = utils.roundNumber(pos.x * scale, decimal);
      data.y = utils.roundNumber(pos.y * scale, decimal);
      data.z = utils.roundNumber(pos.z * scale, decimal);
      return data;
    }

    $scope.change3dModelLevel = function () {
      var filteredLevels = $scope.m3dLevelList.filter(function (el) {
        return el.guid == $scope.tqData.marker.info3d.level;
      });
      $scope.tqData.marker.info3d.levelName = filteredLevels.length > 0 ? filteredLevels[0].name : "";

      if (!$scope.tqData.marker.info3d.modelId || !vm.viewer3d || !$scope.tqData.marker.info3d.level) {
        return;
      }

      if ($scope.tqData.marker.info3d.level === 'All' || $scope.tqData.marker.info3d.level === 'Others') {
        vm.viewer3d.showAllObject();
      } else {
        var levelId = $scope.tqData.marker.info3d.level;

        if (levelId) {
          vm.viewer3d.showObject(levelId);
          changePlan(vm.viewer3d.getBimModel(), levelId);
        } else {
          $scope.tqData.marker.info3d.level = 'All';
          vm.levelId = 'All';
        }
      }

      if ($scope.tqData.marker.info3d.location && $scope.tqData.marker.info3d.location.x) {
        vm.viewer3d.loadMarkers([$scope.tqData.marker.info3d.location]);
      } else {
        vm.viewer3d.loadMarkers([]);
      }
    };

    $scope.changeVP = function () {
      angular.element("#initial_loading_popup").show();

      if (!$scope.tqData.marker.info2d || !$scope.tqData.marker.info2d.modelId) {
        return;
      }

      Promise.all([apiFactory.getRoofPlan($scope.tqData.marker.info2d.modelId), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getWorkLevelAndTypes(), apiFactory.getCalcSheet(vm.projectId)]).then(function (resp) {
        vm.vppages = [];
        angular.element("#initial_loading_popup").hide();
        var plan = resp[0].data.data;
        $scope.modelTitle = plan.assetObj.title;
        vm.materials = resp[1].data.list || [];
        vm.comboMaterials = resp[2].data.list || [];
        vm.equipments = resp[3].data.list || [];
        vm.comboEquipments = resp[4].data.list || [];

        if (resp[5].data.data) {
          if (resp[5].data.data.workLevels) {
            vm.workLevels = resp[5].data.data.workLevels;
          }

          if (resp[5].data.data.workTypes) {
            vm.workTypes = resp[5].data.data.workTypes;
          }
        }

        if (resp[6].data.data) {
          vm.sections = resp[6].data.data.levels;
        }

        var markers = [];

        if ($scope.tqData.marker.info2d && $scope.tqData.marker.info2d.location) {
          markers.push($scope.tqData.marker.info2d.location);
        }

        vm.vpCurPage = {
          plan: plan,
          planId: plan._id,
          title: plan.assetObj.title,
          workLevel: plan.assetObj.level,
          materials: vm.materials,
          comboMaterials: vm.comboMaterials,
          sections: vm.sections,
          marker: markers
        };
        vm.vppages.push(vm.vpCurPage);
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Cannot load vp data.");
        angular.element("#vp_initial_loading_popup").hide();
      });
    };

    $scope.changeVPLevel = function () {
      var filteredLevels = vm.workLevels.filter(function (el) {
        return el._id == $scope.tqData.marker.info2d.level;
      });
      $scope.tqData.marker.info2d.levelName = filteredLevels.length > 0 ? filteredLevels[0].tagName : "";
    };

    vm.updateVPPreview = function (model) {
      angular.element('#loading3d-container').removeClass('d-none');
      angular.element('#model3d-preview-container').hide();
      vm.viewer3d.clear();
      vm.viewer3d.loadBim(model).then(function () {
        angular.element('#loading3d-container').addClass('d-none');
        angular.element('#model3d-preview-container').show();
      })["catch"](function () {
        angular.element('#loading3d-container').addClass('d-none');
        angular.element('#model3d-preview-container').show();
        Notification.error('IFC file cannot open.');
      });
    };

    $scope.goAddMarking = function () {
      if (!$scope.isVP) {
        $scope.tqData.marker.modelType = '3d';

        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.addMarker();
        }

        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
          vm.viewer2d.addMarker();
        }
      } else {
        $scope.tqData.marker.modelType = 'vp';

        if (vm.vpCurPage) {
          $scope.$broadcast('addMarkerEvent');
        }
      }
    };

    $scope.exitCreatetq = function () {
      var id = $scope.tqData._id;
      localStorageService.set('tqData', {});

      if (id && vm.editMode) {
        $state.go('detailTq', {
          id: id
        });
      } else {
        $state.go('tqList');
      }
    };

    vm.cleartqData = function () {
      localStorageService.set('tqData', {});
    };

    $scope.createTq = function () {
      var valid = $scope.checkValidation();

      if (!valid.success) {
        Notification.error(valid.errorMsg);
        return;
      }

      $scope.tqData.projectId = vm.project._id;

      if ($scope.tqData.marker.info2d && !$scope.tqData.marker.info3d.level || $scope.tqData.marker.modelType === 'vp') {
        delete $scope.tqData.marker.info2d;
        delete $scope.tqData.image2d;
      }

      var id = $scope.tqData._id;

      if (utils.isEmpty($scope.tqData.deadLine)) {
        $scope.tqData.deadLine = $scope.tqData.deadLine1;
      }

      if (id && vm.editMode) {
        $scope.loading = true;
        $scope.tqData.userId = vm.userData._id;
        $scope.tqData.companyId = vm.userData.companyId;
        apiFactory.updateTq($scope.tqData, id).then(function (resp) {
          $scope.loading = false;
          Notification.success(resp.data.message);
          vm.cleartqData();
          $state.go("tqDetail", {
            id: id
          });
        })["catch"](function (error) {
          $scope.loading = false;
          $log.error(error);
          if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to update tq");
          vm.cleartqData();
        });
      } else {
        $scope.isLoading = true;
        $scope.tqData.userId = vm.userData._id;
        $scope.tqData.companyId = vm.userData.companyId;
        apiFactory.createTq($scope.tqData).then(function (resp) {
          $scope.isLoading = false;
          Notification.success(resp.data.message);
          vm.cleartqData();
          $state.go('tqList');
        })["catch"](function (error) {
          $scope.isLoading = false;
          $log.error(error);
          if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to create tq");
          vm.cleartqData();
        });
      }
    };

    vm.init = function () {
      $scope.isLoading = true;
      Promise.all([apiFactory.listAllAdminUsers(vm.project._id), apiFactory.getUsersInProjectByApprovalType(vm.project._id, 'issue'), apiFactory.list3d(vm.project._id), apiFactory.getProjectRoofPlans(vm.project._id), apiFactory.listAllQshedAssets(vm.project._id), apiFactory.getWorkTypes(), apiFactory.listAllLevelTypes()]).then(function (resp) {
        $scope.userList = resp[0].data.list.map(function (user) {
          return {
            label: user.firstName + ' ' + user.lastName,
            key: user._id
          };
        });
        $scope.allRoofers = resp[1].data.list.map(function (roofer) {
          return {
            label: roofer.displayName,
            key: roofer._id
          };
        });
        $scope.m3dList = resp[2].data.data || [];
        $scope.vpList = [];

        for (var i = 0; i < resp[3].data.data.length; i++) {
          var plan = resp[3].data.data[i];
          $scope.vpList.push({
            _id: plan._id,
            title: plan.assetObj.title,
            url: plan.parentAsset ? plan.parentAsset.secure_url : '',
            pageNo: plan.assetObj.pageNo,
            level: plan.level
          });
        }

        for (var _i = 0; _i < resp[4].data.list.length; _i++) {
          var asset = resp[4].data.list[_i];
          $scope.vpList.push({
            _id: asset._id,
            title: asset.originalname,
            url: asset.secure_url,
            pageNo: 0,
            level: asset.level
          });
        }

        $scope.workTypes = resp[5].data.list;
        $scope.levelTypes = resp[6].data.list;

        for (var _i2 = 1; _i2 <= 100; _i2++) {
          $scope.levelTypes.push({
            tagName: _i2.toString(),
            tagValue: _i2.toString()
          });
        }

        if (vm.editMode) {
          $scope.isLoading = true;
          apiFactory.getTqById(vm.tqId).then(function (res) {
            $scope.tqData._id = vm.tqId;
            $scope.isLoading = false;
            $scope.tqData = res.data.data;
            $scope.tqData.deadLine = moment($scope.tqData.deadLine)._d;

            if ($scope.tqData.marker) {
              $scope.tqData.marker = $scope.tqData.marker.model;

              if ($scope.tqData.marker.info3d && $scope.tqData.marker.info3d.image && $scope.tqData.marker.info3d.image.secure_url) {
                $scope.tqData.image3DPath = $scope.tqData.marker.info3d.image.secure_url;
              }

              if ($scope.tqData.marker.info2d && $scope.tqData.marker.info2d.image && $scope.tqData.marker.info2d.image.secure_url) {
                $scope.tqData.image2DPath = $scope.tqData.marker.info2d.image.secure_url;
              }
            }

            if (!$scope.tqData) {
              Notification.error('Can not find the Technical Query.');
              $state.go('tqList');
              return;
            }

            if ($scope.tqData.marker.modelType == "vp") {
              $scope.isVP = true;
              $scope.tqData.marker.info2d = $scope.tqData.marker.info3d;
              delete $scope.tqData.marker.info3d;
            } else {
              $scope.isVP = false;
            }

            if ($scope.isVP) {
              $scope.changeVP();
            } else {
              $scope.change3dModel();
            }
          })["catch"](function (error) {
            $scope.loading = false;
            $log.error(error);
          });
        } else {
          $scope.isLoading = false;

          if ($scope.isVP) {
            $scope.changeVP();
          } else {
            $scope.change3dModel();
          }
        }
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
      });
      $scope.tqData = localStorageService.get('tqData') || {};

      if ($scope.tqData.deadLine) {
        $scope.tqData.deadLine1 = new Date($scope.tqData.deadLine);
      }

      $scope.isVP = $scope.tqData.marker && $scope.tqData.marker.modelType === 'vp';

      if (!$scope.tqData.marker) {
        $scope.tqData.marker = {
          modelType: '3d',
          info2d: {
            modelId: null,
            image: null,
            location: {
              x: 0,
              y: 0
            }
          },
          info3d: {
            level: null,
            modelId: null,
            image: null,
            location: {
              x: 0,
              y: 0,
              z: 0
            }
          }
        };
      }
    };

    vm.init();

    function changePlan(bimModel, levelId) {
      if (!bimModel || !levelId || !vm.viewer2d) {
        return;
      }

      angular.element("#initial_loading_popup").show();
      angular.element('#model2d-preview-container').hide();
      vm.viewer2d.loadBimModel(bimModel, levelId).then(function () {
        vm.levelId = levelId;
        angular.element("#initial_loading_popup").hide();
        angular.element('#loading2d-container').addClass('d-none');
        angular.element('#model2d-preview-container').show();

        if ($scope.tqData.marker.info2d && $scope.tqData.marker.info2d.location && $scope.tqData.marker.info2d.location.x) {
          vm.viewer2d.loadMarkers([$scope.tqData.marker.info2d.location]);
        } else {
          vm.viewer2d.loadMarkers([]);
        }

        vm.viewer2d.on('markerPlaced', markerPlaced);
        vm.viewer2d.on('markerRemoved', markerRemoved);
      })["catch"](function (e) {
        $scope.isLoading = false;
        $log.error(e);
        angular.element('#loading2d-container').addClass('d-none');
        angular.element('#model2d-preview-container').show();
      });
    }

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.setVPMode = function (value) {
      $scope.isVP = value;
    };

    vm.placeMarker = function () {
      $timeout(function () {// const placeData = this.getPlace().geometry.location;
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('todoBoard', {
    controller: todoBoardController,
    controllerAs: 'vm',
    templateUrl: 'app/main/todo/todoBoard/todoBoard.view.html'
  });
  /** @ngInject */

  function todoBoardController($scope, apiFactory, $log, $stateParams, globals, Notification, utils, $filter) {
    var vm = this;
    var userStore = globals.userStore;
    $scope.userName = userStore.get().displayName;
    $scope.isGrid = true;
    $scope.rootFolders = [{
      _id: '01',
      name: 'Favorites',
      color: '#D71414',
      children: [{
        name: 'Accounting Tasks',
        color: '#755FE2',
        type: 'circle'
      }]
    }, {
      _id: '02',
      name: 'Projects',
      color: '#F3A72E',
      children: [{
        name: 'Daily Tasks',
        color: '#FFC542',
        type: 'circle',
        val: '9'
      }, {
        name: 'Personal',
        color: '#FF575F',
        type: 'circle',
        val: '2'
      }, {
        name: 'Marina Bay Sands',
        color: '#3DD598',
        type: 'circle',
        val: '3'
      }, {
        name: 'Accounting Tasks',
        color: '#755FE2',
        type: 'circle',
        val: '20'
      }]
    }, {
      _id: '03',
      name: 'Labels',
      color: '#F3A72E',
      children: [{
        name: 'Marketing',
        color: '#FFD199',
        type: 'tag',
        src: '/assets/icons/todo/tag-fill-yellow.svg'
      }, {
        name: 'Design',
        color: '#069697',
        type: 'tag',
        src: '/assets/icons/todo/tag-fill-green.svg'
      }]
    }, {
      _id: '04',
      name: 'Filters',
      color: '#F3A72E',
      children: [{
        name: 'Assigned To Me',
        color: '#747474',
        type: 'checkbox',
        border: '1'
      }, {
        name: 'Assigned To All',
        color: '#747474',
        type: 'checkbox',
        border: '1'
      }, {
        name: 'High Priority',
        color: '#747474',
        type: 'checkbox',
        border: '1'
      }, {
        name: 'Medium Priority',
        color: '#747474',
        type: 'checkbox',
        border: '1'
      }, {
        name: 'Low Priority',
        color: '#747474',
        type: 'checkbox',
        border: '1'
      }, {
        name: 'View All',
        color: '#747474',
        type: 'checkbox',
        border: '1'
      }]
    }];

    var isToday = function isToday(someDate) {
      var today = new Date();
      return someDate.getDate() == today.getDate() && someDate.getMonth() == today.getMonth() && someDate.getFullYear() == today.getFullYear();
    }; // var calendar = new dhx.Calendar("side_calendar", {
    //   range: true,
    //   width: '280',
    //   // disabledDates: function(date) {
    //   //   if (isToday(date))
    //   //     return false;
    //   //   else
    //   //     return date < new Date();
    //   // },
    //   mark: function(date) {
    //     if (isToday(date)) {
    //       return "highlight-date";
    //     }
    //   },
    // });
    // calendar.events.on("Change",function(){
    //   var tdate = calendar.getValue(true);
    //   if (angular.isDefined(tdate[0])) {
    //     vm.deadlineFromDate = tdate[0];
    //   }
    //   else {
    //     vm.deadlineFromDate = null;
    //   }
    //   if (angular.isDefined(tdate[1])) {
    //     vm.deadlineToDate = tdate[1];
    //   }
    //   else {
    //     vm.deadlineToDate = null;
    //   }
    //   $scope.$apply();
    //   $scope.onChangeFilterDate();
    // });


    $scope.options = {
      showWeeks: false,
      minDate: new Date()
    };
    $scope.datepickerOptions = {
      showWeeks: false,
      minDate: new Date()
    };
    vm.todoCategories = [{
      _id: "category_projects",
      name: $filter('translate')("All Projects"),
      icon: "/assets/icons/todo-projects.svg",
      children: []
    }, {
      _id: "category_personal",
      name: $filter('translate')("Personal"),
      icon: "/assets/icons/todo-person.svg",
      children: []
    }, {
      _id: "category_tags",
      name: $filter('translate')("Tags"),
      icon: "/assets/icons/todo-tags.svg",
      children: []
    }];
    vm.todoItems = [{
      _id: "to-do",
      name: $filter('translate')("To Do"),
      children: []
    }, {
      _id: "in-progress",
      name: $filter('translate')("In Progress"),
      children: []
    }, {
      _id: "done",
      name: $filter('translate')("Done"),
      children: []
    }];

    $scope.initData = function () {
      var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (isInit) {
        vm.selectedCategory = {
          _id: angular.isDefined($stateParams.type) ? $stateParams.type : 'inbox'
        };
      }

      vm.selectedSubCategory = {
        _id: null
      };
      vm.deadlineToDate = null;
      vm.searchText = null;
      $scope.$broadcast('angular-ui-tree:expand-all');
      $scope.isLoading = true;
      Promise.all([apiFactory.getProjectListAssignedTodo(), apiFactory.getMemberListAssignedTodo(), apiFactory.getTagListAssignedTodo()]).then(function (res) {
        $scope.isLoading = false;
        var find = vm.todoCategories.find(function (elem) {
          return elem._id == "category_projects";
        });
        find.children = res[0].data.data.map(function (item) {
          return {
            _id: item._id,
            name: item.projectName,
            type: "project"
          };
        });
        find = vm.todoCategories.find(function (elem) {
          return elem._id == "category_personal";
        });
        find.children = res[1].data.data.map(function (item) {
          return {
            _id: item._id,
            name: item.displayName,
            type: "personal"
          };
        });
        find = vm.todoCategories.find(function (elem) {
          return elem._id == "category_tags";
        });
        find.children = res[2].data.data.map(function (item) {
          return {
            _id: item,
            name: item,
            type: "tag"
          };
        });
        $scope.fetchTodoList();
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    $scope.initData();

    $scope.fetchTodoList = function () {
      $scope.isLoading = true;
      var payload = {
        search: vm.searchText
      };

      if (vm.deadlineFromDate) {
        payload.deadlineTimeStart = vm.deadlineFromDate.toISOString();
      }

      if (vm.deadlineToDate) {
        payload.deadlineTimeEnd = vm.deadlineToDate.toISOString();
      }

      if (vm.selectedSubCategory.type === "project") {
        payload.projectId = vm.selectedSubCategory._id;
      } else if (vm.selectedSubCategory.type === "personal") {
        payload.memberId = vm.selectedSubCategory._id;
      } else if (vm.selectedSubCategory.type === "tag") {
        payload.tag = vm.selectedSubCategory._id;
      }

      apiFactory.listAllTodoList(payload).then(function (res) {
        $scope.isLoading = false;

        if (vm.selectedCategory._id == "inbox" || vm.selectedCategory._id == "category_projects" || vm.selectedCategory._id == "category_personal" || vm.selectedCategory._id == "category_tags" || vm.selectedSubCategory.type == "project" || vm.selectedSubCategory.type == "personal" || vm.selectedSubCategory.type == "tag") {
          vm.todoItems = [{
            _id: "to-do",
            name: "To Do",
            children: res.data.data.filter(function (elem) {
              return elem.status == 0;
            })
          }, {
            _id: "in-progress",
            name: "In Progress",
            children: res.data.data.filter(function (elem) {
              return elem.status == 1;
            }).map(function (item) {
              item.pieBg = '#d1d1d1';

              if (item.progress == 100) {
                item.pieBg = '#2FA84F';
              } else {
                if (item.progress > 50) {
                  item.percentage = 180;
                  item.revice = 360 / 100 * (item.progress - 50) + 1;
                } else item.percentage = 360 / 100 * item.progress;
              }

              return item;
            })
          }, {
            _id: "done",
            name: "Done",
            children: res.data.data.filter(function (elem) {
              return elem.status == 2;
            })
          }];
          var todayEnd = new Date();
          todayEnd.setHours(23, 59, 59, 999);
          vm.leftTaskForToday = {}, vm.completedTaskForToday = {}; // vm.leftTaskForToday.total = res.data.data.filter(elem => new Date(elem.deadlineTime) <= todayEnd && elem.status < 1);

          vm.leftTaskForToday.total = res.data.data.filter(function (elem) {
            return elem.status < 1;
          });
          vm.leftTaskForToday.totalCnt = vm.leftTaskForToday.total.length;

          if (vm.leftTaskForToday.totalCnt) {
            vm.leftTaskForToday.urgentCnt = vm.leftTaskForToday.total.filter(function (elem) {
              return elem.priority == 0;
            }).length;
            vm.leftTaskForToday.highCnt = vm.leftTaskForToday.total.filter(function (elem) {
              return elem.priority == 1;
            }).length;
            vm.leftTaskForToday.normalCnt = vm.leftTaskForToday.total.filter(function (elem) {
              return elem.priority == 2;
            }).length;
            vm.leftTaskForToday.lowCnt = vm.leftTaskForToday.total.filter(function (elem) {
              return elem.priority == 3;
            }).length;
            vm.leftTaskForToday.detail = [];

            if (vm.leftTaskForToday.urgentCnt) {
              vm.leftTaskForToday.detail.push("".concat(vm.leftTaskForToday.urgentCnt, " urgent priority"));
            }

            if (vm.leftTaskForToday.highCnt) {
              vm.leftTaskForToday.detail.push("".concat(vm.leftTaskForToday.highCnt, " high priority"));
            }

            if (vm.leftTaskForToday.normalCnt) {
              vm.leftTaskForToday.detail.push("".concat(vm.leftTaskForToday.normalCnt, " normal priority"));
            }

            if (vm.leftTaskForToday.lowCnt) {
              vm.leftTaskForToday.detail.push("".concat(vm.leftTaskForToday.lowCnt, " low priority"));
            }

            vm.leftTaskForToday.detail = vm.leftTaskForToday.detail.join(", ");
          } // vm.completedTaskForToday.totalCnt = res.data.data.filter(elem => new Date(elem.deadlineTime) <= todayEnd && elem.status === 2).length;


          vm.completedTaskForToday.totalCnt = res.data.data.filter(function (elem) {
            return elem.status === 2;
          }).length; // vm.todoItems = [
          //   {
          //     _id: "content_today",
          //     name: "Today",
          //     children: res.data.data.filter(elem => new Date(elem.deadlineTime) <= todayEnd)
          //   },
          //   {
          //     _id: "content_upcoming",
          //     name: "Upcoming",
          //     children: res.data.data.filter(elem => new Date(elem.deadlineTime) > todayEnd)
          //   }
          // ]
        }
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    $scope.selectSubCategory = function (subCategory) {
      if (vm.selectedSubCategory._id === subCategory._id) return;
      vm.selectedSubCategory = subCategory;

      if (vm.selectedSubCategory.type === "project" || vm.selectedSubCategory.type === "personal" || vm.selectedSubCategory.type === "tag") {
        $scope.fetchTodoList();
      }
    };

    $scope.selectCategory = function (category) {
      if (vm.selectedCategory._id === category._id) {
        $scope.initData(false);
        return;
      }

      vm.selectedCategory = category;

      if (vm.selectedCategory._id == "inbox" || vm.selectedCategory._id == "today" || vm.selectedCategory._id == "upcoming" || vm.selectedCategory.type === "project" || vm.selectedCategory.type === "personal" || vm.selectedCategory.type === "tag") {
        $scope.fetchTodoList();
      } else {
        $scope.initData(false);
        $scope.$broadcast('angular-ui-tree:expand-all');
      }
    };

    $scope.onChangeFilterDate = function () {
      if (isToday(vm.deadlineFromDate)) {
        vm.deadlineFromDate = new Date();
      } else {
        vm.deadlineFromDate.setHours(0, 0, 0, 0);
      }

      if (!utils.isEmpty(vm.deadlineToDate)) {
        vm.deadlineToDate.setHours(23, 59, 59, 999);
      }

      if (!utils.isEmpty(vm.deadlineToDate) && vm.deadlineFromDate > vm.deadlineToDate) {
        Notification.error("Invalid Start and End Time.");
        return;
      }

      $scope.fetchTodoList();
    };

    $scope.onExpand = function (index) {
      if ($scope.expandedIndex === index) {
        $scope.expandedIndex = null;
      } else {
        $scope.expandedIndex = index;
      } // if($scope.expandedIndex != null){
      //   apiFactory.getTqListByProjectId({
      //     projectId: vm.selectedProject._id,
      //     discipline: deiscipline
      //   })
      //     .then(resp => {
      //       vm.selectedfolder = vm.rootFolders[index];
      //       vm.selectedfolder.children = resp.data.list;
      //     })
      //     .catch(e => {
      //       $scope.isLoading = false;
      //       $log.error(e);
      //     });
      // }


      $scope.selectedSubIndex = null;
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('teamsMeeting', {
    controller: teamsMeetingController,
    controllerAs: 'vm',
    templateUrl: 'app/main/synergies/teamsMeeting/teamsMeeting.view.html'
  });
  /** @ngInject */

  function teamsMeetingController($scope, apiFactory, $log, Notification, globals, $stateParams, $document, $state, utils, localStorageService, $location) {
    var vm = this;
    var userStore = globals.userStore,
        logout = globals.logout;
    vm.userData = userStore.get();
    vm.meetingId = $stateParams.id;
    $scope.isReadyJoin = false;
    var activeRoom;
    $scope.room = null;

    function roomJoined(data) {
      $scope.room = data;
      activeRoom = $scope.room;
      initRoom();

      if ($document[0].getElementById('mainTrack') && !$document[0].getElementById('mainTrack').querySelector('video')) {
        var tracks = Array.from($scope.room.localParticipant.tracks.values());
        attachTracks(tracks, true, $scope.room.localParticipant.identity);
      }

      function switchScreen(e) {
        var index = parseInt(e.currentTarget.getAttribute("index"));

        if (index > 0) {
          $document[0].getElementById('mainTrack').childNodes[0].setAttribute("index", index);

          if ($document[0].getElementById('mainTrack-voice').childNodes[0]) {
            $document[0].getElementById('mainTrack-voice').childNodes[0].setAttribute("index", index);
          }

          $document[0].getElementById('remote-media').childNodes[index].setAttribute("index", -1);

          if ($document[0].getElementById('remote-media-voice').childNodes[index]) {
            $document[0].getElementById('remote-media-voice').childNodes[index].setAttribute("index", -1);
          }

          $document[0].getElementById('remote-media').insertBefore($document[0].getElementById('mainTrack').childNodes[0], $document[0].getElementById('remote-media').childNodes[index]);
          $document[0].getElementById('mainTrack').appendChild($document[0].getElementById('remote-media').childNodes[index + 1]);

          if ($document[0].getElementById('mainTrack-voice').childNodes[0]) {
            $document[0].getElementById('remote-media-voice').insertBefore($document[0].getElementById('mainTrack-voice').childNodes[0], $document[0].getElementById('remote-media-voice').childNodes[index]);

            if ($document[0].getElementById('remote-media-voice').childNodes[index + 1]) {
              $document[0].getElementById('mainTrack-voice').appendChild($document[0].getElementById('remote-media-voice').childNodes[index + 1]);
            }
          } else {
            var audioEl = $document[0].getElementById('remote-media-voice').childNodes[index];

            if (audioEl && audioEl.getAttribute("index") == -1) {
              $document[0].getElementById('mainTrack-voice').appendChild(audioEl);
            }
          }

          angular.element($document[0].querySelector("#remote-media > div:nth-child(".concat(index + 1, ")"))).click(function (e) {
            switchScreen(e);
          });
        }
      }

      function prepareParticipantWrapper(videoTrack, id, index) {
        var isHaveDisabledAudio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var participantWrapper = $document[0].createElement("div");
        participantWrapper.setAttribute("index", index);
        participantWrapper.setAttribute("id", "video-".concat(id));
        participantWrapper.setAttribute("class", "pos-relative participant-wrapper");
        var labelEl = $document[0].createElement("div");
        labelEl.setAttribute("class", "ft_12_regular_white pos-absolute name-label flex-center");
        var participant = getParticipantInfo(id);
        var icon = $document[0].createElement("img");
        icon.setAttribute("class", "mute");
        icon.src = "/assets/icons/mute.svg";
        var muted = $document[0].getElementById("audio-".concat(id)) ? $document[0].getElementById("audio-".concat(id)).getAttribute("is-disabled") : null;

        if (muted == null && isHaveDisabledAudio) {
          labelEl.appendChild(icon);
          var unmutedIcon = $document[0].createElement("img");
          unmutedIcon.src = "/assets/icons/unmute.svg";
          unmutedIcon.setAttribute("class", "unmute");
          unmutedIcon.style.display = "none";
          labelEl.appendChild(unmutedIcon);
        } else {
          if (muted != "true") icon.style.display = "none";
          labelEl.appendChild(icon);
          icon = $document[0].createElement("img");
          icon.src = "/assets/icons/unmute.svg";
          icon.setAttribute("class", "unmute");
          if (muted == "true") icon.style.display = "none";
          labelEl.appendChild(icon);
        }

        labelEl.appendChild($document[0].createTextNode(!utils.isEmpty(participant) ? participant.displayName : ""));
        participantWrapper.appendChild(labelEl);
        if (!utils.isEmpty(videoTrack)) participantWrapper.appendChild(videoTrack.attach());
        var avatarEl = $document[0].createElement("div");
        avatarEl.setAttribute("class", "avatar-wrapper");
        var avatarImg = $document[0].createElement("img");
        avatarImg.src = !utils.isEmpty(participant) && !utils.isEmpty(participant.profilePic) ? participant.profilePic : "/assets/icons/main-img.svg";
        avatarEl.appendChild(avatarImg);

        if (!utils.isEmpty(videoTrack) && videoTrack.isEnabled) {
          avatarEl.style.display = "none";
        }

        participantWrapper.appendChild(avatarEl);
        return participantWrapper;
      }

      function attachTracks(tracks, isLocal, id) {
        if (isLocal === true) {
          var idLabel = 'mainTrack';
          var index = -1;

          if ($document[0].getElementById('mainTrack').childElementCount != 0) {
            idLabel = 'remote-media';
            index = 0;
          }

          if (!utils.isEmpty(tracks)) {
            if (tracks.length == 2) {
              tracks.forEach(function (track) {
                if (track.kind === 'audio') {
                  var audioTrack = track.attach();
                  audioTrack.setAttribute("index", index);
                  audioTrack.setAttribute("id", "audio-".concat(id));

                  if (index == -1) {
                    $document[0].getElementById("".concat(idLabel, "-voice")).appendChild(audioTrack);
                  } else {
                    $document[0].getElementById("".concat(idLabel, "-voice")).insertBefore(audioTrack, $document[0].getElementById("".concat(idLabel, "-voice")).childNodes[0]);
                  }
                }

                if (track.kind === 'video') {
                  if (index == -1) {
                    $document[0].getElementById(idLabel).appendChild(prepareParticipantWrapper(track, id, index));
                  } else {
                    $document[0].getElementById(idLabel).insertBefore(prepareParticipantWrapper(track, id, index), $document[0].getElementById(idLabel).childNodes[0]);
                  }
                }
              });
            } else if (tracks.length == 1) {
              var track = tracks[0];

              if (track.kind === 'audio') {
                var audioTrack = track.attach();
                audioTrack.setAttribute("index", index);
                audioTrack.setAttribute("id", "audio-".concat(id));
                $document[0].getElementById("".concat(idLabel, "-voice")).appendChild(audioTrack);
                vm.videoFlag = false;
                vm.videoDisabled = true;
                vm.audioFlag = true;
                vm.audioDisabled = false;
                $scope.$apply();

                if (index == -1) {
                  $document[0].getElementById(idLabel).appendChild(prepareParticipantWrapper(null, id, index));
                } else {
                  $document[0].getElementById(idLabel).insertBefore(prepareParticipantWrapper(null, id, index), $document[0].getElementById(idLabel).childNodes[0]);
                }
              } else if (track.kind === 'video') {
                vm.audioFlag = false;
                vm.audioDisabled = true;
                vm.videoFlag = true;
                vm.videoDisabled = false;
                $scope.$apply();

                if (index == -1) {
                  $document[0].getElementById(idLabel).appendChild(prepareParticipantWrapper(track, id, index, true));
                } else {
                  $document[0].getElementById(idLabel).insertBefore(prepareParticipantWrapper(track, id, index, true), $document[0].getElementById(idLabel).childNodes[0]);
                }
              }
            }
          } else {
            vm.audioFlag = false;
            vm.audioDisabled = true;
            vm.videoFlag = false;
            vm.videoDisabled = true;
            $scope.$apply();

            if (index == -1) {
              $document[0].getElementById(idLabel).appendChild(prepareParticipantWrapper(null, id, index, true));
            } else {
              $document[0].getElementById(idLabel).insertBefore(prepareParticipantWrapper(null, id, index, true), $document[0].getElementById(idLabel).childNodes[0]);
            }
          }
        } else {
          if (!utils.isEmpty(tracks)) {
            tracks.forEach(function (track) {
              if (track.kind === 'audio') {
                var count = $document[0].getElementById('remote-media-voice').childElementCount;

                if (count == 0 && $scope.room.participants.size == 1) {
                  var mainList = $document[0].getElementById('mainTrack-voice');

                  if (!utils.isEmpty(mainList.childNodes[0])) {
                    mainList.childNodes[0].setAttribute("index", 0);
                    $document[0].getElementById('remote-media-voice').appendChild(mainList.childNodes[0]);
                  }

                  var _audioTrack = track.attach();

                  _audioTrack.setAttribute("index", -1);

                  _audioTrack.setAttribute("id", "audio-".concat(id));

                  if (!track.isEnabled) {
                    _audioTrack.setAttribute("is-disabled", true);

                    if ($document[0].getElementById("video-".concat(id))) {
                      $document[0].getElementById("video-".concat(id)).childNodes[0].childNodes[0].style.display = "block";
                      $document[0].getElementById("video-".concat(id)).childNodes[0].childNodes[1].style.display = "none";
                    }
                  } else {
                    if ($document[0].getElementById("video-".concat(id))) {
                      $document[0].getElementById("video-".concat(id)).childNodes[0].childNodes[0].style.display = "none";
                      $document[0].getElementById("video-".concat(id)).childNodes[0].childNodes[1].style.display = "block";
                    }
                  }

                  mainList.appendChild(_audioTrack);

                  if ("video-".concat(id) != $document[0].getElementById('mainTrack').childNodes[0].getAttribute("id")) {
                    mainList = $document[0].getElementById('mainTrack');
                    mainList.childNodes[0].setAttribute("index", 0);
                    $document[0].getElementById('remote-media').appendChild(mainList.childNodes[0]);
                    mainList.appendChild(prepareParticipantWrapper(null, id, -1));
                  }
                } else {
                  var _index = parseInt($document[0].getElementById("video-".concat(id)).getAttribute("index"));

                  var _idLabel = 'mainTrack-voice';

                  if (_index > 0) {
                    _idLabel = 'remote-media-voice';
                  }

                  var trackElement = track.attach();
                  trackElement.setAttribute("index", _index);
                  trackElement.setAttribute("id", "audio-".concat(id));

                  if (!track.isEnabled) {
                    trackElement.setAttribute("is-disabled", true);

                    if ($document[0].getElementById("video-".concat(id))) {
                      $document[0].getElementById("video-".concat(id)).childNodes[0].childNodes[0].style.display = "block";
                      $document[0].getElementById("video-".concat(id)).childNodes[0].childNodes[1].style.display = "none";
                    }
                  } else {
                    if ($document[0].getElementById("video-".concat(id))) {
                      $document[0].getElementById("video-".concat(id)).childNodes[0].childNodes[0].style.display = "none";
                      $document[0].getElementById("video-".concat(id)).childNodes[0].childNodes[1].style.display = "block";
                    }
                  }

                  $document[0].getElementById(_idLabel).appendChild(trackElement);
                }
              }

              if (track.kind === 'video') {
                if ($document[0].getElementById("video-".concat(id))) {
                  var _index2 = parseInt($document[0].getElementById("video-".concat(id)).getAttribute("index"));

                  var _idLabel2 = 'mainTrack';

                  if (_index2 > 0) {
                    _idLabel2 = 'remote-media';
                  }

                  $document[0].getElementById(_idLabel2).insertBefore(prepareParticipantWrapper(track, id, _index2), $document[0].getElementById(_idLabel2).childNodes[_index2]);
                  $document[0].getElementById(_idLabel2).removeChild($document[0].getElementById(_idLabel2).childNodes[_index2 + 1]);
                  angular.element($document[0].querySelector("#video-".concat(id))).click(function (e) {
                    switchScreen(e);
                  });
                } else {
                  var element = $document[0].getElementById('remote-media');

                  if (element.childElementCount == 0) {
                    var _mainList = $document[0].getElementById('mainTrack');

                    _mainList.childNodes[0].setAttribute("index", 0);

                    $document[0].getElementById('remote-media').appendChild(_mainList.childNodes[0]);

                    if ($document[0].getElementById("audio-".concat(id))) {
                      _mainList.appendChild(prepareParticipantWrapper(track, id, -1));
                    } else {
                      _mainList.appendChild(prepareParticipantWrapper(track, id, -1, true));
                    }
                  } else {
                    var _mainList2 = $document[0].getElementById('mainTrack');

                    if (_mainList2.childNodes[0].getAttribute("id") == "video-".concat(id)) {
                      _mainList2.removeChild(_mainList2.childNodes[0]);

                      _mainList2.appendChild(prepareParticipantWrapper(track, id, -1));
                    } else {
                      $document[0].getElementById('remote-media').appendChild(prepareParticipantWrapper(track, id, element.childElementCount));
                    }
                  }

                  if (element.childElementCount > 1) {
                    angular.element($document[0].querySelector("#remote-media > div:nth-child(".concat(element.childElementCount, ")"))).click(function (e) {
                      switchScreen(e);
                    });
                  }
                }
              }
            });
          } else {
            var count = $document[0].getElementById('remote-media-voice').childElementCount;

            if (count == 0 && $scope.room.participants.size == 1) {
              var mainList = $document[0].getElementById('mainTrack-voice');

              if (!utils.isEmpty(mainList.childNodes[0])) {
                mainList.childNodes[0].setAttribute("index", 0);
                $document[0].getElementById('remote-media-voice').appendChild(mainList.childNodes[0]);
              }
            }

            var element = $document[0].getElementById('remote-media');

            if (element.childElementCount == 0) {
              var _mainList3 = $document[0].getElementById('mainTrack');

              _mainList3.childNodes[0].setAttribute("index", 0);

              $document[0].getElementById('remote-media').appendChild(_mainList3.childNodes[0]);

              _mainList3.appendChild(prepareParticipantWrapper(null, id, -1, true));
            } else {
              $document[0].getElementById('remote-media').appendChild(prepareParticipantWrapper(null, id, element.childElementCount, true));
              angular.element($document[0].querySelector("#remote-media > div:nth-child(".concat(element.childElementCount, ")"))).click(function (e) {
                switchScreen(e);
              });
            }
          }
        }
      }

      function detachTracks(tracks) {
        tracks.forEach(function (track) {
          track.detach().forEach(function (detachedElement) {
            detachedElement.remove();
          });
        });
      }

      function getParticipantInfo(id) {
        if (id == vm.userData._id) {
          return {
            displayName: "You",
            profilePic: vm.userData.profilePic
          };
        }

        var find = $scope.selectedRoom.participants.find(function (elem) {
          return elem._id == id;
        });

        if (!utils.isEmpty(find)) {
          return find;
        } else return {};
      }

      function attachParticipantTracks(participant) {
        var tracks = Array.from(participant.tracks.values());
        attachTracks(tracks, false, participant.identity);
      }

      function detachParticipantTracks(participant) {
        var tracks = Array.from(participant.tracks.values());

        if ($scope.room.participants.size == 0) {
          if ($document[0].getElementById('mainTrack-voice').childElementCount) {
            $document[0].getElementById('mainTrack-voice').removeChild($document[0].getElementById('mainTrack-voice').childNodes[0]);
          }

          $document[0].getElementById('mainTrack').removeChild($document[0].getElementById('mainTrack').childNodes[0]);
          var localEl = $document[0].getElementById('remote-media').childNodes[0];
          localEl.setAttribute("index", -1);
          $document[0].getElementById('mainTrack').appendChild(localEl);
          localEl = $document[0].getElementById('remote-media-voice').childNodes[0];

          if (localEl) {
            localEl.setAttribute("index", -1);
            $document[0].getElementById('mainTrack-voice').appendChild(localEl);
          }
        } else {
          var removeIndex = parseInt($document[0].getElementById("video-".concat(participant.identity)).getAttribute("index"));
          var lastIndex = $document[0].getElementById('remote-media').childElementCount - 1;
          $document[0].getElementById('remote-media').childNodes[lastIndex].setAttribute("index", removeIndex);
          var lastId = $document[0].getElementById('remote-media').childNodes[lastIndex].getAttribute("id").split("-")[1];

          if ($document[0].getElementById("audio-".concat(lastId))) {
            $document[0].getElementById("audio-".concat(lastId)).setAttribute("index", removeIndex);
          }

          if (removeIndex == -1) {
            $document[0].getElementById('mainTrack').removeChild($document[0].getElementById('mainTrack').childNodes[0]);
            $document[0].getElementById('mainTrack').appendChild($document[0].getElementById('remote-media').childNodes[lastIndex]);

            if ($document[0].getElementById("audio-".concat(lastId))) {
              $document[0].getElementById('mainTrack-voice').appendChild($document[0].getElementById("audio-".concat(lastId)));
            }
          } else if (removeIndex == lastIndex) {
            $document[0].getElementById('remote-media').removeChild($document[0].getElementById('remote-media').childNodes[removeIndex]);
          } else {
            $document[0].getElementById('remote-media').insertBefore($document[0].getElementById('remote-media').childNodes[lastIndex], $document[0].getElementById('remote-media').childNodes[removeIndex]);
            $document[0].getElementById('remote-media').removeChild($document[0].getElementById('remote-media').childNodes[removeIndex + 1]);

            if ($document[0].getElementById("audio-".concat(lastId))) {
              var condition = 1;

              while (condition == 1) {
                if (!$document[0].getElementById('remote-media').childNodes[removeIndex].nextElementSibling) {
                  break;
                }

                var nextId = $document[0].getElementById('remote-media').childNodes[removeIndex].nextElementSibling.getAttribute("id").split("-")[1];

                if ($document[0].getElementById("audio-".concat(nextId))) {
                  $document[0].getElementById('remote-media-voice').insertBefore($document[0].getElementById("audio-".concat(lastId)), $document[0].getElementById("audio-".concat(nextId)));
                  break;
                } else continue;
              }
            }
          }
        }

        detachTracks(tracks);
      }

      $scope.room.on("participantConnected", attachParticipantTracks);
      $scope.room.on('participantDisconnected', detachParticipantTracks);
      $scope.room.on('trackAdded', function (track, participant) {
        $scope.$apply();
        attachTracks([track], false, participant.identity);
        participant.on('trackDisabled', function (track) {
          if (track.kind == "video") {
            $document[0].getElementById("video-".concat(participant.identity)).childNodes[1].style.display = "none";
            $document[0].getElementById("video-".concat(participant.identity)).childNodes[2].style.display = "block";
          }

          if (track.kind == "audio") {
            $document[0].getElementById("video-".concat(participant.identity)).childNodes[0].childNodes[0].style.display = "block";
            $document[0].getElementById("video-".concat(participant.identity)).childNodes[0].childNodes[1].style.display = "none";
          }
        });
        participant.on('trackEnabled', function (track) {
          if (track.kind == "video") {
            $document[0].getElementById("video-".concat(participant.identity)).childNodes[1].style.display = "block";
            $document[0].getElementById("video-".concat(participant.identity)).childNodes[2].style.display = "none";
          }

          if (track.kind == "audio") {
            $document[0].getElementById("video-".concat(participant.identity)).childNodes[0].childNodes[0].style.display = "none";
            $document[0].getElementById("video-".concat(participant.identity)).childNodes[0].childNodes[1].style.display = "block";

            if ($document[0].getElementById("audio-".concat(participant.identity)).getAttribute("is-disabled") == "true") {
              $document[0].getElementById("audio-".concat(participant.identity)).removeAttribute("is-disabled");
            }
          }
        });
      });

      function initRoom() {
        var i = 0;

        var _iterator = _createForOfIteratorHelper($scope.room.participants),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var participant = _step.value;

            if (i == 0) {
              $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(null, participant[1].identity, -1, true));
            } else {
              $document[0].getElementById('remote-media').appendChild(prepareParticipantWrapper(null, participant[1].identity, i, true));
              angular.element($document[0].querySelector("#remote-media > div:nth-child(".concat(i, ")"))).click(function (e) {
                switchScreen(e);
              });
            }

            i++;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }

    vm.leaveRoomIfJoined = function () {
      if (activeRoom) {
        activeRoom.disconnect();
      }

      if (!vm.audioFlag) {
        vm.audioFlag = true;
      }

      if (!vm.videoFlag) {
        vm.videoFlag = true;
      }

      $scope.isReadyJoin = false;
    };

    $scope.leaveRoom = function () {
      vm.leaveRoomIfJoined();
    };

    function connectMeetingRoom() {
      $scope.isLoading = true;
      apiFactory.generateVideoAccessToken({
        identity: vm.userData._id,
        device: 'browser'
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.videoAccessToken = resp.data.token;
        var twilio = Twilio,
            Video = twilio.Video;
        apiFactory.twilioGetRoomInfo($scope.selectedRoom.videoRoomSid).then(function (resp) {
          var connectOptions = {
            name: resp.data.data.uniqueName
          };
          navigator.mediaDevices.enumerateDevices().then(function (devices) {
            var microphones = devices.filter(function (d) {
              return d.kind === 'audioinput';
            });
            var cameras = devices.filter(function (d) {
              return d.kind === 'videoinput';
            });

            if (cameras.length == 0) {
              connectOptions.video = false;
            } else {
              connectOptions.video = true;
            }

            if (microphones.length == 0) {
              connectOptions.audio = false;
            } else {
              connectOptions.audio = true;
            }

            if (!connectOptions.video && !connectOptions.audio) {
              Video.connect($scope.videoAccessToken, {
                name: connectOptions.name,
                tracks: []
              }).then(roomJoined, function (error) {
                $log.error(error);
              });
            } else {
              Video.createLocalTracks({
                video: connectOptions.video,
                audio: connectOptions.audio
              }).then(function (tracks) {
                Video.connect($scope.videoAccessToken, {
                  name: connectOptions.name,
                  tracks: tracks
                }).then(roomJoined, function (error) {
                  $log.error(error);
                });
              })["catch"](function (error) {
                $log.error(error);
                Notification.error('Failed to get media device');
              });
            }
          })["catch"](function (error) {
            $log.error(error);
            Notification.error('Failed to get media device');
          });
        })["catch"](function (error) {
          $scope.isLoading = false;
          $log.error(error);
          Notification.error('Something went wrong try later');
        });
      })["catch"](function (error) {
        $scope.isLoading = false;
        $log.error(error);
        Notification.error('Something went wrong try later');
      });
    }

    function fetchMeetingRoom() {
      var token = localStorageService.get("access-token");

      if (utils.isEmpty(token)) {
        localStorageService.set("redirect-meeting-url", $location.url());
        logout();
      } else {
        $scope.isLoading = true;
        apiFactory.getMeetingRoomDetail(vm.meetingId).then(function (res) {
          $scope.isLoading = false;
          $scope.selectedRoom = res.data;

          if (utils.isEmpty($scope.selectedRoom.assignedTo.find(function (elem) {
            return elem._id == vm.userData._id;
          })) && utils.isEmpty($scope.selectedRoom.managers.find(function (elem) {
            return elem._id == vm.userData._id;
          }))) {
            Notification.error("You haven't permission for the meeting");
            $state.go(globals.getDashboardRoute(vm.userData));
          }

          $scope.selectedRoom.participants = $scope.selectedRoom.assignedTo.concat($scope.selectedRoom.managers);
          $scope.$apply();
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }
    }

    $scope.joinRoom = function () {
      connectMeetingRoom();
      $scope.isReadyJoin = true;
      $scope.cameraTested = false;
    };

    $scope.getMeetingStatusText = function () {
      var startTime = moment($scope.selectedRoom.dateFrom);
      var today = moment();

      switch ($scope.selectedRoom.status) {
        case 0:
          return 'Start ' + startTime.from(today);

        case 1:
          return 'In-progress';

        case 2:
          return 'Completed';

        case 3:
          return 'Failed';
      }
    };

    $scope.onSuccess = function () {
      $scope.cameraTested = true;
    };

    $scope.onError = function (err) {
      $log.error("err: ", err);
      $scope.cameraTested = true;
    };

    vm.videoFlag = true;

    vm.closeVideo = function () {
      if (!$scope.room && vm.videoDisabled) {
        return;
      }

      var localParticipant = $scope.room.localParticipant;
      localParticipant.videoTracks.forEach(function (videoTrack) {
        if (vm.videoFlag) {
          videoTrack.disable();

          if ($scope.room.participants.size > 0) {
            $document[0].getElementById('remote-media').childNodes[0].childNodes[2].style.display = "block";
          } else {
            $document[0].getElementById('mainTrack').childNodes[0].childNodes[2].style.display = "block";
          }
        } else {
          videoTrack.enable();

          if ($scope.room.participants.size > 0) {
            $document[0].getElementById('remote-media').childNodes[0].childNodes[2].style.display = "none";
          } else {
            $document[0].getElementById('mainTrack').childNodes[0].childNodes[2].style.display = "none";
          }
        }

        vm.videoFlag = !vm.videoFlag;
      });
    };

    vm.audioFlag = true;

    vm.closeAudio = function () {
      if (!$scope.room || vm.audioDisabled) {
        return;
      }

      var localParticipant = $scope.room.localParticipant;
      localParticipant.audioTracks.forEach(function (audioTrack) {
        if (vm.audioFlag) {
          audioTrack.disable();
          $document[0].getElementById("video-".concat(localParticipant.identity)).childNodes[0].childNodes[0].style.display = "block";
          $document[0].getElementById("video-".concat(localParticipant.identity)).childNodes[0].childNodes[1].style.display = "none";
        } else {
          audioTrack.enable();
          $document[0].getElementById("video-".concat(localParticipant.identity)).childNodes[0].childNodes[0].style.display = "none";
          $document[0].getElementById("video-".concat(localParticipant.identity)).childNodes[0].childNodes[1].style.display = "block";
        }

        vm.audioFlag = !vm.audioFlag;
      });
    };

    vm.init = function () {
      $scope.myChannel = {
        // the fields below are all optional
        videoHeight: 800,
        videoWidth: 600,
        video: null // Will reference the video element on success

      };
      fetchMeetingRoom();
    };

    vm.init();
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var firebase;

(function () {
  'use strict';

  angular.module('app').component('synergies', {
    controller: synergiesController,
    controllerAs: 'vm',
    templateUrl: 'app/main/synergies/teams/teams.view.html'
  });
  /** @ngInject */

  function synergiesController($scope, $uibModal, $log, apiFactory, Notification, localStorageService, globals, utils, $timeout, $state, $http, $document, $window, $location) {
    var vm = this;
    vm.utils = utils;
    var userStore = globals.userStore,
        projectStore = globals.projectStore,
        notificationStore = globals.notificationStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.project = projectStore.get();
    vm.companyData = companyStore.get();
    vm.notificationData = notificationStore.get();
    $scope.baseUrl = $location.absUrl();
    $scope.isInitializedTwilio = false;
    $scope.TAB = {
      CHAT: 1,
      CALL: 2,
      MEETINGS: 3,
      CONTACTS: 4
    };
    $scope.today = moment().format('dddd MMM DD');
    vm.selectedTab = $scope.TAB.CHAT;

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $scope.goDashboard();
      return;
    }

    function selectChannel(sid) {
      if (angular.isUndefined(sid)) {
        return;
      }

      if (!$scope.activeChannel || $scope.activeChannel.sid !== sid) {
        var index = $scope.channels.findIndex(function (x) {
          return x.sid === sid;
        });

        if (index !== -1) {
          $scope.setActiveMeeting($scope.channels[index]);
        }
      }
    }

    function organizeMeetingRoomList() {
      $scope.meetingRooms = {};

      var _iterator = _createForOfIteratorHelper($scope.meetingRoomList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var meetingRoom = _step.value;
          var date = moment(meetingRoom.dateFrom).format('dddd MMM DD');

          if (utils.isEmpty($scope.meetingRooms[date])) {
            $scope.meetingRooms[date] = [meetingRoom];
          } else {
            $scope.meetingRooms[date].push(meetingRoom);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var roomValues = Object.values($scope.meetingRooms);

      if (roomValues.length && !$scope.selectedRoom) {
        $scope.selectedRoom = roomValues[0][0];
      }

      $timeout(function () {
        $scope.$apply();
      });
    }

    function videoInit(videoFlag) {
      var isAccept = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var twilio = Twilio,
          Video = twilio.Video;
      var activeRoom, previewTracks;
      $scope.room = null;

      if (!navigator.webkitGetUserMedia && !navigator.mozGetUserMedia) {
        Notification.error('WebRTC is not available in your browser.');
      }

      vm.leaveRoomIfJoined = function () {
        if (activeRoom) {
          activeRoom.disconnect();
        }

        vm.screen = 1;
      };

      var connectOptions = {
        name: $scope.activeMeetingRoomId.uniqueName
      };

      if (previewTracks) {
        connectOptions.tracks = previewTracks;
      }

      if (!$scope.isGroupCall) {
        if (utils.isEmpty(vm.activeUsers)) {
          vm.activeUsers.push({
            displayName: $scope.incomingName,
            profilePic: $scope.incomingAvatar
          });
        }
      }

      $scope.isReady = false;

      function roomJoined(data) {
        $scope.room = data;
        activeRoom = $scope.room;
        $scope.selectedRoom.participants = $scope.selectedRoom.assignedTo.concat($scope.selectedRoom.managers);
        var localParticipant = $scope.room.localParticipant;
        localParticipant.videoTracks.forEach(function (videoTrack) {
          if (!vm.videoFlag) {
            videoTrack.disable();
          }
        });

        if ($document[0].getElementById('mainTrack') && !$document[0].getElementById('mainTrack').querySelector('video')) {
          var tracks = Array.from($scope.room.localParticipant.tracks.values());
          attachTracks(tracks, true, $scope.room.localParticipant.identity);
        }

        function getParticipantInfo(id) {
          if (id == vm.userData._id) {
            return {
              displayName: "You",
              profilePic: vm.userData.profilePic
            };
          }

          if ($scope.isGroupCall) {
            var find = $scope.activeChannel.memberUsers.find(function (elem) {
              return elem._id == id;
            });

            if (!utils.isEmpty(find)) {
              return find;
            } else return {};
          } else {
            return {
              displayName: vm.activeUsers[0].displayName,
              profilePic: vm.activeUsers[0].profilePic
            };
          }
        }

        function prepareParticipantWrapper(videoTrack, id, index) {
          var isHaveDisabledAudio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
          var participantWrapper = $document[0].createElement("div");
          participantWrapper.setAttribute("index", index);
          participantWrapper.setAttribute("id", "video-".concat(id));
          participantWrapper.setAttribute("class", "pos-relative participant-wrapper");
          var labelEl = $document[0].createElement("div");
          labelEl.setAttribute("class", "ft_12_regular_white pos-absolute name-label flex-center");
          var participant = getParticipantInfo(id);
          var icon = $document[0].createElement("img");
          icon.setAttribute("class", "mute");
          icon.src = "/assets/icons/mute.svg";
          var muted = $document[0].getElementById("audio-".concat(id)) ? $document[0].getElementById("audio-".concat(id)).getAttribute("is-disabled") : null;

          if (muted == null && isHaveDisabledAudio) {
            labelEl.appendChild(icon);
          } else {
            if (muted != "true") icon.style.display = "none";
            labelEl.appendChild(icon);
            icon = $document[0].createElement("img");
            icon.src = "/assets/icons/unmute.svg";
            icon.setAttribute("class", "unmute");
            if (muted == "true") icon.style.display = "none";
            labelEl.appendChild(icon);
          }

          labelEl.appendChild($document[0].createTextNode(!utils.isEmpty(participant) ? participant.displayName : ""));
          participantWrapper.appendChild(labelEl);

          if (!utils.isEmpty(videoTrack)) {
            var videoEl = videoTrack.attach();

            if (!vm.videoFlag) {
              if (index != 0 && videoTrack.isEnabled) {
                videoEl.style.display = "block";
              } else {
                videoEl.style.display = "none";
              }
            }

            participantWrapper.appendChild(videoEl);
          }

          var avatarContainerEl = $document[0].createElement("div");
          avatarContainerEl.setAttribute("class", "avatar-container");
          var avatarEl = $document[0].createElement("div");
          avatarEl.setAttribute("class", "avatar-wrapper");
          var avatarImg = $document[0].createElement("img");
          avatarImg.src = !utils.isEmpty(participant) && !utils.isEmpty(participant.profilePic) ? participant.profilePic : index > -1 ? "/assets/icons/user1.svg" : "/assets/icons/main-img.svg";
          avatarEl.appendChild(avatarImg);
          avatarContainerEl.appendChild(avatarEl);

          if (index != 0) {
            var nameLabel = $document[0].createElement("div");
            nameLabel.setAttribute("class", "ft_24_600_white mt-20 flex-center");
            nameLabel.appendChild($document[0].createTextNode(!utils.isEmpty(participant) ? participant.displayName : ""));
            avatarContainerEl.appendChild(nameLabel);
          }

          if (vm.videoFlag && !utils.isEmpty(videoTrack) && videoTrack.isEnabled) {
            avatarContainerEl.style.display = "none";
          } else if (!vm.videoFlag && index != 0 && !utils.isEmpty(videoTrack) && videoTrack.isEnabled) {
            avatarContainerEl.style.display = "none";
          }

          participantWrapper.appendChild(avatarContainerEl);
          return participantWrapper;
        }

        function attachTracks(tracks, isLocal, id) {
          if (isLocal === true) {
            if (!utils.isEmpty(tracks)) {
              if (tracks.length == 2) {
                tracks.forEach(function (track) {
                  if (track.kind === 'audio') {
                    var audioTrack = track.attach();
                    audioTrack.setAttribute("index", 0);
                    audioTrack.setAttribute("id", "audio-".concat(id));
                    $document[0].getElementById('remote-media-voice').appendChild(audioTrack);
                  }

                  if (track.kind === 'video') {
                    $document[0].getElementById('remote-media').appendChild(prepareParticipantWrapper(track, id, 0));
                  }
                });
              } else if (tracks.length == 1) {
                var track = tracks[0];

                if (track.kind === 'audio') {
                  var audioTrack = track.attach();
                  audioTrack.setAttribute("index", 0);
                  audioTrack.setAttribute("id", "audio-".concat(id));
                  $document[0].getElementById('remote-media-voice').appendChild(audioTrack);
                  $document[0].getElementById('remote-media').appendChild(prepareParticipantWrapper(null, id, 0));
                } else if (track.kind === 'video') {
                  if (vm.videoFlag) {
                    $document[0].getElementById('remote-media').appendChild(prepareParticipantWrapper(track, id, 0, true));
                  } else {
                    $document[0].getElementById('remote-media').appendChild(prepareParticipantWrapper(null, id, 0, true));
                  }
                }
              }
            } else {
              $document[0].getElementById('remote-media').appendChild(prepareParticipantWrapper(null, id, 0, true));
            }
          } else {
            if (!utils.isEmpty(tracks)) {
              tracks.forEach(function (track) {
                if (track.kind === 'audio') {
                  var _audioTrack = track.attach();

                  _audioTrack.setAttribute("id", "audio-".concat(id));

                  if (!$scope.isGroupCall) {
                    _audioTrack.setAttribute("index", -1);

                    $document[0].getElementById('mainTrack-voice').appendChild(_audioTrack);

                    if ($document[0].getElementById("video-".concat(id))) {
                      $document[0].getElementById('mainTrack').removeChild($document[0].getElementById('mainTrack').childNodes[0]);
                      $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(null, id, -1));
                    } else {
                      $document[0].getElementById('mainTrack-voice').nextElementSibling.style.display = "none";
                      $document[0].getElementById('mainTrack').style.display = "block";
                      $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(null, id, -1));
                    }
                  } else {
                    var element = $document[0].getElementById('remote-media-voice');

                    if (element.childElementCount == 1 && $scope.room.participants.size == 1) {
                      _audioTrack.setAttribute("index", -1);

                      $document[0].getElementById('mainTrack-voice').appendChild(_audioTrack);
                      $document[0].getElementById('mainTrack').removeChild($document[0].getElementById('mainTrack').childNodes[0]);
                      $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(null, id, -1));
                    } else {
                      var idLabel = "mainTrack-voice";

                      if ($document[0].getElementById("mainTrack-voice").childElementCount == 0) {
                        _audioTrack.setAttribute("index", -1);
                      } else {
                        _audioTrack.setAttribute("index", $scope.room.participants.size - 1);

                        idLabel = "remote-media-voice";
                      }

                      $document[0].getElementById(idLabel).appendChild(_audioTrack);

                      if ($document[0].getElementById("video-".concat(id))) {
                        var replaceIndex = parseInt($document[0].getElementById("video-".concat(id)).getAttribute("index"));

                        if (replaceIndex > 0) {
                          $document[0].getElementById('remote-media').insertBefore(prepareParticipantWrapper(null, id, replaceIndex), $document[0].getElementById('remote-media').childNodes[replaceIndex]);
                          $document[0].getElementById('remote-media').removeChild($document[0].getElementById('remote-media').childNodes[replaceIndex + 1]);
                        } else {
                          $document[0].getElementById('mainTrack').removeChild($document[0].getElementById('mainTrack').childNodes[0]);
                          $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(null, id, -1));
                        }
                      }
                    }
                  }
                }

                if (track.kind === 'video') {
                  if (!$scope.isGroupCall) {
                    $document[0].getElementById('mainTrack-voice').nextElementSibling.style.display = "none";
                    $document[0].getElementById('mainTrack').style.display = "block";

                    if (!$document[0].getElementById('mainTrack').childNodes[0]) {
                      if (!$document[0].getElementById('mainTrack-voice').childNodes[0]) {
                        $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(track, id, -1, true));
                      } else {
                        $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(track, id, -1));
                      }
                    } else {
                      $document[0].getElementById('mainTrack').removeChild($document[0].getElementById('mainTrack').childNodes[0]);
                      $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(track, id, -1));
                    }
                  } else {
                    var _element = $document[0].getElementById('remote-media');

                    if (_element.childElementCount == 1 && $scope.room.participants.size == 1) {
                      if ($document[0].getElementById('mainTrack').childNodes[0].getAttribute("id") == "video-".concat(id)) {
                        $document[0].getElementById('mainTrack').removeChild($document[0].getElementById('mainTrack').childNodes[0]);
                        $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(track, id, -1));
                      } else {
                        $document[0].getElementById('mainTrack-voice').nextElementSibling.style.display = "none";
                        $document[0].getElementById('mainTrack').style.display = "block";
                        $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(track, id, -1));
                      }
                    } else {
                      var _replaceIndex = parseInt($document[0].getElementById("video-".concat(id)).getAttribute("index"));

                      if (_replaceIndex > 0) {
                        $document[0].getElementById('remote-media').insertBefore(prepareParticipantWrapper(track, id, _replaceIndex), $document[0].getElementById('remote-media').childNodes[_replaceIndex]);
                        $document[0].getElementById('remote-media').removeChild($document[0].getElementById('remote-media').childNodes[_replaceIndex + 1]);
                      } else {
                        $document[0].getElementById('mainTrack').removeChild($document[0].getElementById('mainTrack').childNodes[0]);
                        $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(track, id, -1));
                      }
                    }
                  }
                }

                if ($scope.isGroupCall) {
                  angular.element($document[0].querySelector("#video-".concat(id))).click(function (e) {
                    switchScreen(e);
                  });
                }
              });
            } else {
              if ($scope.isGroupCall && $scope.room.participants.size > 1) {
                if ($document[0].getElementById('mainTrack').style.display == "none") {
                  $document[0].getElementById('mainTrack-voice').nextElementSibling.style.display = "none";
                  $document[0].getElementById('mainTrack').style.display = "block";
                  $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(null, id, -1, true));
                } else {
                  $document[0].getElementById('remote-media').appendChild(prepareParticipantWrapper(null, id, $scope.room.participants.size - 1, true));
                }
              } else {
                $document[0].getElementById('mainTrack-voice').nextElementSibling.style.display = "none";
                $document[0].getElementById('mainTrack').style.display = "block";
                $document[0].getElementById('mainTrack').appendChild(prepareParticipantWrapper(null, id, -1, true));
              }

              if ($scope.isGroupCall) {
                angular.element($document[0].querySelector("#video-".concat(id))).click(function (e) {
                  switchScreen(e);
                });
              }
            }
          }
        }

        function switchScreen(e) {
          var index = parseInt(e.currentTarget.getAttribute("index"));

          if (index > 0) {
            $document[0].getElementById('mainTrack').childNodes[0].setAttribute("index", index);

            if ($document[0].getElementById('mainTrack-voice').childNodes[0]) {
              $document[0].getElementById('mainTrack-voice').childNodes[0].setAttribute("index", index);
            }

            $document[0].getElementById('remote-media').childNodes[index].setAttribute("index", -1);

            if ($document[0].getElementById('remote-media-voice').childNodes[index]) {
              $document[0].getElementById('remote-media-voice').childNodes[index].setAttribute("index", -1);
            }

            $document[0].getElementById('remote-media').insertBefore($document[0].getElementById('mainTrack').childNodes[0], $document[0].getElementById('remote-media').childNodes[index]);
            $document[0].getElementById('mainTrack').appendChild($document[0].getElementById('remote-media').childNodes[index + 1]);

            if ($document[0].getElementById('mainTrack-voice').childNodes[0]) {
              $document[0].getElementById('remote-media-voice').insertBefore($document[0].getElementById('mainTrack-voice').childNodes[0], $document[0].getElementById('remote-media-voice').childNodes[index]);

              if ($document[0].getElementById('remote-media-voice').childNodes[index + 1]) {
                $document[0].getElementById('mainTrack-voice').appendChild($document[0].getElementById('remote-media-voice').childNodes[index + 1]);
              }
            } else {
              var audioEl = $document[0].getElementById('remote-media-voice').childNodes[index];

              if (audioEl && audioEl.getAttribute("index") == -1) {
                $document[0].getElementById('mainTrack-voice').appendChild(audioEl);
              }
            }

            angular.element($document[0].querySelector("#remote-media > div:nth-child(".concat(index + 1, ")"))).click(function (e) {
              switchScreen(e);
            });
          }
        }

        function detachTracks(tracks) {
          tracks.forEach(function (track) {
            track.detach().forEach(function (detachedElement) {
              detachedElement.remove();
            });
          });
        }

        function detachParticipantTracks(participant) {
          var tracks = Array.from(participant.tracks.values());

          if ($scope.isGroupCall) {
            if ($scope.room.participants.size == 0) {
              if ($document[0].getElementById('mainTrack-voice').childElementCount) {
                $document[0].getElementById('mainTrack-voice').removeChild($document[0].getElementById('mainTrack-voice').childNodes[0]);
              }

              $document[0].getElementById('mainTrack').removeChild($document[0].getElementById('mainTrack').childNodes[0]);
              var localEl = $document[0].getElementById('remote-media').childNodes[0];
              localEl.setAttribute("index", -1);
              $document[0].getElementById('mainTrack').appendChild(localEl);
              localEl = $document[0].getElementById('remote-media-voice').childNodes[0];

              if (localEl) {
                localEl.setAttribute("index", -1);
                $document[0].getElementById('mainTrack-voice').appendChild(localEl);
              }
            } else {
              var removeIndex = parseInt($document[0].getElementById("video-".concat(participant.identity)).getAttribute("index"));
              var lastIndex = $document[0].getElementById('remote-media').childElementCount - 1;
              $document[0].getElementById('remote-media').childNodes[lastIndex].setAttribute("index", removeIndex);
              var lastId = $document[0].getElementById('remote-media').childNodes[lastIndex].getAttribute("id").split("-")[1];

              if ($document[0].getElementById("audio-".concat(lastId))) {
                $document[0].getElementById("audio-".concat(lastId)).setAttribute("index", removeIndex);
              }

              if (removeIndex == -1) {
                $document[0].getElementById('mainTrack').removeChild($document[0].getElementById('mainTrack').childNodes[0]);
                $document[0].getElementById('mainTrack').appendChild($document[0].getElementById('remote-media').childNodes[lastIndex]);

                if ($document[0].getElementById("audio-".concat(lastId))) {
                  $document[0].getElementById('mainTrack-voice').appendChild($document[0].getElementById("audio-".concat(lastId)));
                }
              } else if (removeIndex == lastIndex) {
                $document[0].getElementById('remote-media').removeChild($document[0].getElementById('remote-media').childNodes[removeIndex]);
              } else {
                $document[0].getElementById('remote-media').insertBefore($document[0].getElementById('remote-media').childNodes[lastIndex], $document[0].getElementById('remote-media').childNodes[removeIndex]);
                $document[0].getElementById('remote-media').removeChild($document[0].getElementById('remote-media').childNodes[removeIndex + 1]);

                if ($document[0].getElementById("audio-".concat(lastId))) {
                  var condition = 1;

                  while (condition == 1) {
                    if (!$document[0].getElementById('remote-media').childNodes[removeIndex].nextElementSibling) {
                      break;
                    }

                    var nextId = $document[0].getElementById('remote-media').childNodes[removeIndex].nextElementSibling.getAttribute("id").split("-")[1];

                    if ($document[0].getElementById("audio-".concat(nextId))) {
                      $document[0].getElementById('remote-media-voice').insertBefore($document[0].getElementById("audio-".concat(lastId)), $document[0].getElementById("audio-".concat(nextId)));
                      break;
                    } else continue;
                  }
                }
              }
            }
          }

          detachTracks(tracks);
        }

        function attachParticipantTracks(participant) {
          $scope.isAttachedPaticipant = true;
          $scope.$apply();
          var tracks = Array.from(participant.tracks.values());
          attachTracks(tracks, false, participant.identity);
        }

        $scope.participantList = [];
        $scope.callConnecteddUser = [];
        $scope.participantListings = {};
        $scope.room.on("participantConnected", attachParticipantTracks);
        $scope.room.on('participantDisconnected', detachParticipantTracks);
        $scope.room.on('trackAdded', function (track, participant) {
          $scope.$apply();
          attachTracks([track], false, participant.identity);
          participant.on('trackDisabled', function (track) {
            if (track.kind == "video") {
              if ($document[0].getElementById("video-".concat(participant.identity)).childElementCount === 3) {
                $document[0].getElementById("video-".concat(participant.identity)).childNodes[1].style.display = "none";
                $document[0].getElementById("video-".concat(participant.identity)).childNodes[2].style.display = "block";
              }
            }

            if (track.kind == "audio") {
              $document[0].getElementById("video-".concat(participant.identity)).childNodes[0].childNodes[0].style.display = "block";
              $document[0].getElementById("video-".concat(participant.identity)).childNodes[0].childNodes[1].style.display = "none";
            }
          });
          participant.on('trackEnabled', function (track) {
            if (track.kind == "video") {
              $document[0].getElementById("video-".concat(participant.identity)).childNodes[1].style.display = "block";
              $document[0].getElementById("video-".concat(participant.identity)).childNodes[2].style.display = "none";
            }

            if (track.kind == "audio") {
              $document[0].getElementById("video-".concat(participant.identity)).childNodes[0].childNodes[0].style.display = "none";
              $document[0].getElementById("video-".concat(participant.identity)).childNodes[0].childNodes[1].style.display = "block";

              if ($document[0].getElementById("audio-".concat(participant.identity)).getAttribute("is-disabled") == "true") {
                $document[0].getElementById("audio-".concat(participant.identity)).removeAttribute("is-disabled");
              }
            }
          });
        });
        $scope.room.on('disconnected', function () {
          $scope.room.participants.forEach(detachParticipantTracks);
          activeRoom = null;
          vm.screen = 1;
        });
        $scope.room.participants.forEach(function (participant) {
          var previewContainer = $document[0].getElementById('remote-media');
          attachParticipantTracks(participant, previewContainer);
        });

        vm.closeVideo = function () {
          if (!$scope.room) {
            return;
          }

          var localParticipant = $scope.room.localParticipant;
          localParticipant.videoTracks.forEach(function (videoTrack) {
            if (vm.videoFlag) {
              videoTrack.disable();

              if ($scope.room.participants.size > 0) {
                $document[0].getElementById('remote-media').childNodes[0].childNodes[1].style.display = "none";
                $document[0].getElementById('remote-media').childNodes[0].childNodes[2].style.display = "block";
              } else {
                $document[0].getElementById('mainTrack').childNodes[0].childNodes[1].style.display = "none";
                $document[0].getElementById('mainTrack').childNodes[0].childNodes[2].style.display = "block";
              }
            } else {
              videoTrack.enable();

              if ($scope.room.participants.size > 0) {
                $document[0].getElementById('remote-media').childNodes[0].childNodes[1].style.display = "block";
                $document[0].getElementById('remote-media').childNodes[0].childNodes[2].style.display = "none";
              } else {
                $document[0].getElementById('mainTrack').childNodes[0].childNodes[1].style.display = "block";
                $document[0].getElementById('mainTrack').childNodes[0].childNodes[2].style.display = "none";
              }
            }

            vm.videoFlag = !vm.videoFlag;
          });
        };

        vm.closeAudio = function () {
          if (!$scope.room) {
            return;
          }

          var localParticipant = $scope.room.localParticipant;
          localParticipant.audioTracks.forEach(function (audioTrack) {
            if (vm.audioFlag) {
              audioTrack.disable();
              $document[0].getElementById("video-".concat(localParticipant.identity)).childNodes[0].childNodes[0].style.display = "block";
              $document[0].getElementById("video-".concat(localParticipant.identity)).childNodes[0].childNodes[1].style.display = "none";
            } else {
              audioTrack.enable();
              $document[0].getElementById("video-".concat(localParticipant.identity)).childNodes[0].childNodes[0].style.display = "none";
              $document[0].getElementById("video-".concat(localParticipant.identity)).childNodes[0].childNodes[1].style.display = "block";
            }

            vm.audioFlag = !vm.audioFlag;
          });
        };
      }

      navigator.mediaDevices.enumerateDevices().then(function (devices) {
        var microphones = devices.filter(function (d) {
          return d.kind === 'audioinput';
        });
        var cameras = devices.filter(function (d) {
          return d.kind === 'videoinput';
        });

        if (cameras.length == 0) {
          connectOptions.video = false;
        } else {
          connectOptions.video = true;
        }

        if (microphones.length == 0) {
          connectOptions.audio = false;
        } else {
          connectOptions.audio = true;
        }

        if (!connectOptions.video && !connectOptions.audio) {
          Video.connect($scope.videoAccessToken, {
            name: connectOptions.name,
            tracks: []
          }).then(roomJoined, function (error) {
            $log.error(error);
          });
        } else {
          Video.createLocalTracks({
            video: connectOptions.video,
            audio: connectOptions.audio
          }).then(function (tracks) {
            Video.connect($scope.videoAccessToken, {
              name: connectOptions.name,
              tracks: tracks
            }).then(roomJoined, function (error) {
              $log.error(error);
            });
          })["catch"](function (error) {
            $log.error(error);
            Notification.error('Failed to get media device');
          });
        }
      })["catch"](function (error) {
        $log.error(error);
        Notification.error('Failed to get media device');
      });
      $window.addEventListener('beforeunload', vm.leaveRoomIfJoined);

      if (isAccept) {
        var notifyData = {
          identity: vm.userData._id,
          title: "",
          body: $scope.incomingRoom,
          data: {
            isVideo: vm.videoFlag,
            callerId: $scope.incomingUserId,
            callerName: $scope.incomingName,
            callerAvatar: $scope.incomingAvatar,
            roomName: $scope.incomingRoom,
            actionType: "accept",
            notificationType: "twilio.video.call"
          }
        };
        apiFactory.twilioSendNotification(notifyData).then(function (res) {
          $log.info(res);
        });
      }
    }

    function initTwilio() {
      $scope.isLoading = true;
      Twilio.Chat.Client.create($scope.accessToken).then(function (createdClient) {
        $scope.isLoading = false;
        $scope.isInitializedTwilio = true;
        var client = createdClient; // A channel has become visible to the Client

        client.on('channelAdded', function (channel) {
          channel.memberUsers = [];
          channel.getMembers().then(function (res) {
            if (res && res.length) {
              var _loop = function _loop(i) {
                var member = res[i];

                if (member.identity !== vm.userData._id) {
                  var userMember = $scope.inviteMembers.find(function (it) {
                    return it._id === member.identity;
                  });

                  if (userMember) {
                    channel.memberUsers.push(userMember);
                  }
                }
              };

              for (var i = 0; i < res.length; i++) {
                _loop(i);
              }
            }

            $timeout(function () {
              $scope.$apply();
            });
          });
          channel.getMessages(1).then(function (res) {
            if (res.items && res.items.length) {
              channel.lastMsg = res.items[0].state.body;
              channel.lastMsgTime = channel.lastMessage ? $scope.getCreateTime(channel.lastMessage.timestamp) : null;
            } else {
              channel.lastMsg = '';
              channel.lastMsgTime = null;
            }

            $timeout(function () {
              $scope.$apply();
            });
          }); // Listen for members joining a channel

          channel.on('memberJoined', function (member) {
            $log.info(member.identity + 'has joined the channel.');

            if (member.identity !== vm.userData._id) {
              var userMember = $scope.inviteMembers.find(function (it) {
                return it._id === member.identity;
              });

              if (userMember) {
                channel.memberUsers.push(userMember);
              }
            }
          }); // Listen for members user info changing

          channel.on('memberInfoUpdated', function (member) {
            $log.info(member.identity + 'updated their info.');
          }); // Listen for members leaving a channel

          channel.on('memberLeft', function (member) {
            var find = channel.memberUsers.find(function (it) {
              return it._id === member.identity;
            });

            if (find) {
              var index = channel.memberUsers.indexOf(find);
              channel.memberUsers.splice(index, 1);
              $timeout(function () {
                $scope.$apply();
              });
            }

            $log.info(member.identity + 'has left the channel.');
          });
          $scope.channels.push(channel);
          $timeout(function () {
            $scope.$apply();
            vm.goToDirectCallScreen();
          });
        }); // A channel is no longer visible to the Client

        client.on('channelRemoved', function (channel) {
          $log.info('Channel removed: ' + channel);
          var existing = $scope.channels.find(function (it) {
            return it.sid === channel.sid;
          });

          if (existing) {
            var index = $scope.channels.indexOf(existing);
            $scope.channels.splice(index, 1);
            $timeout(function () {
              $scope.$apply();
            });
          }
        }); // A channel's attributes or metadata have changed.

        client.on('channelUpdated', function (channel) {
          $log.info('Channel updates: ', channel);
          var existing = $scope.channels.find(function (it) {
            return it.sid === channel.sid;
          });

          if (existing) {
            var index = $scope.channels.indexOf(existing);
            $scope.channels[index] = channel;
            $timeout(function () {
              $scope.$apply();
            });
          }
        });
      })["catch"](function (error) {
        $scope.isLoading = false;
        $scope.isInitializedTwilio = true;
        $log.error(error);
        Notification.error('Something went wrong try later');
      });
    }

    function getAccessToken() {
      $scope.isLoading = true;
      apiFactory.generateSynergyChatAccessToken({
        identity: vm.userData._id,
        device: 'browser'
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.accessToken = resp.data.token;
        initTwilio();
      })["catch"](function (error) {
        $scope.isLoading = false;
        $log.error(error);
        Notification.error('Something went wrong try later');
      });
    }

    function getVideoAccessToken() {
      $scope.isLoading = true;
      apiFactory.generateVideoAccessToken({
        identity: vm.userData._id,
        device: 'browser'
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.videoAccessToken = resp.data.token;
      })["catch"](function (error) {
        $scope.isLoading = false;
        $log.error(error);
        Notification.error('Something went wrong try later');
      });
    }

    $scope.updateCallLogs = function () {
      var channels = $scope.getPrivateChannels();
      var uniqueNames = channels.map(function (x) {
        return x.uniqueName;
      });
      $scope.callLogLoading = true;
      apiFactory.twilioGetUserRecentCallLogs({
        uniqueNames: uniqueNames
      }).then(function (resp) {
        $scope.callLogLoading = false;
        $scope.callLogs = [];
        var list = resp.data.list;

        var _loop2 = function _loop2(i) {
          var obj = {};
          obj.profilePic = channels[i].memberUsers[0].profilePic;
          obj.displayName = $scope.getChannelMemberName(channels[i]);
          obj.firstName = channels[i].memberUsers[0].firstName;
          obj.lastName = channels[i].memberUsers[0].lastName;
          obj.sid = channels[i].sid;
          var find = list.find(function (elem) {
            return elem.uniqueName == channels[i].uniqueName;
          });

          if (find) {
            obj.time = find.time;
            obj.status = find.status;
            obj.type = find.type;
          }

          $scope.callLogs.push(obj);
        };

        for (var i = 0; i < channels.length; i++) {
          _loop2(i);
        }

        $scope.callLogs = $scope.callLogs.sort(function (a, b) {
          return new Date(a.time).getTime() < new Date(b.time).getTime() ? 1 : -1;
        });

        var _iterator2 = _createForOfIteratorHelper($scope.callLogs),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;

            if (vm.utils.isEmpty(item.time)) {
              item.time = "";
            } else {
              if (vm.utils.isToday(new Date(item.time))) {
                item.time = moment(new Date(item.time)).format("hh:mm a");
              } else {
                item.time = moment(new Date(item.time)).format("DD-MM-YYYY");
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      })["catch"](function (err) {
        $scope.callLogLoading = false;
        $log.error(err);
      });
    };

    $scope.changeTab = function (tab) {
      vm.selectedTab = tab;

      if (tab == $scope.TAB.CHAT) {
        var channels = $scope.getPrivateChannels();

        if (channels.length) {
          $scope.setActiveMeeting(channels[0]);
        }
      } else if (tab == $scope.TAB.CALL) {
        $scope.updateCallLogs();
      }
    };

    $scope.setActiveUser = function (user) {
      $scope.selectedUser = user;
    };

    $scope.setActiveRoom = function (room) {
      $scope.selectedRoom = room;
    };

    $scope.onChatCall = function (type) {
      $scope.isLoading = true;
      apiFactory.fetchPrivateChannel(vm.project._id, $scope.selectedUser._id).then(function (res) {
        var channel = $scope.channels.find(function (x) {
          return x.sid === res.data.sid;
        });

        if (!channel) {
          $timeout(function () {
            $scope.isLoading = false;
            channel = $scope.channels.find(function (x) {
              return x.sid === res.data.sid;
            });

            if (!channel) {
              Notification.error('Not found channel. Please try again later');
            } else {
              selectChannel(channel.sid);
              vm.selectedTab = $scope.TAB.CHAT;

              if (type === 'audio' || type === 'video') {
                $scope.initVideo(type === 'video');
              }
            }
          }, 500);
        } else {
          $scope.isLoading = false;
          selectChannel(channel.sid);
          vm.selectedTab = $scope.TAB.CHAT;

          if (type === 'audio' || type === 'video') {
            $scope.initVideo(type === 'video');
          }
        }
      })["catch"](function (err) {
        $scope.isLoading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.setActiveMeeting = function (m) {
      if (!m) {
        return;
      }

      $scope.activeChannel = m;
      $scope.activeMeetingRoomId = angular.copy(m);
      vm.activeUsers = angular.copy($scope.activeChannel.memberUsers);

      if (!utils.isEmpty(vm.activeUsers) && vm.activeUsers.length == 0) {
        vm.activeUsers.push({
          _id: $scope.incomingUserId,
          displayName: $scope.incomingName,
          profilePic: $scope.incomingAvatar
        });
      }
    };

    $scope.setActiveMeetingBySID = function (sid) {
      var channel = $scope.channels.find(function (x) {
        return x.sid === sid;
      });

      if (channel) {
        $scope.setActiveMeeting(channel);
      } else {
        $timeout(function () {
          $scope.setActiveMeeting(channel);
        }, 500);
      }
    };

    $scope.getChannelMemberName = function (c) {
      var channel = $scope.activeChannel;

      if (c) {
        channel = c;
      }

      return channel && channel.memberUsers && channel.memberUsers[0] ? channel.memberUsers[0].displayName : '';
    };

    $scope.onShowMsg = function () {
      $scope.isShowMsg = true;
    };

    $scope.onHideMsg = function () {
      $scope.isShowMsg = false;
    };

    $scope.acceptCall = function (flag) {
      if (flag === false) {
        $scope.audioCall = true;
        vm.videoFlag = false;
      } else {
        $scope.audioCall = false;
        vm.videoFlag = true;
      }

      navigator.mediaDevices.enumerateDevices().then(function (devices) {
        var microphones = devices.filter(function (d) {
          return d.kind === 'audioinput';
        });
        var cameras = devices.filter(function (d) {
          return d.kind === 'videoinput';
        });

        if (cameras.length == 0) {
          vm.videoFlag = false;
          vm.videoDisabled = true;
        } else {
          if (vm.videoFlag != false) {
            vm.videoFlag = true;
          }

          vm.videoDisabled = false;
        }

        if (microphones.length == 0) {
          vm.audioFlag = false;
          vm.audioDisabled = true;
        } else {
          vm.audioFlag = true;
          vm.audioDisabled = false;
        }

        videoInit(vm.videoFlag, true);
      });
    };

    $scope.cancelCall = function () {
      vm.screen = 1;
      $scope.isReady = false;
      $scope.isAttachedPaticipant = false;
      notificationStore.reset();
      var notifyData = {
        identity: vm.userData._id,
        title: "",
        body: $scope.incomingRoom,
        data: {
          callerId: vm.userData._id,
          callerName: vm.userData.displayName,
          callerAvatar: vm.userData.profilePic,
          roomName: $scope.incomingRoom,
          actionType: "cancel",
          notificationType: "twilio.video.call"
        }
      };
      apiFactory.twilioSendNotification(notifyData).then(function (res) {
        $log.info(res);
      });

      if (!$scope.isGroupCall) {
        var _notifyData = {
          identity: vm.activeUsers[0]._id,
          title: "",
          body: $scope.incomingRoom,
          data: {
            callerId: vm.userData._id,
            callerName: vm.userData.displayName,
            callerAvatar: vm.userData.profilePic,
            roomName: $scope.incomingRoom,
            actionType: "cancel",
            notificationType: "twilio.video.call"
          }
        };
        apiFactory.twilioSendNotification(_notifyData).then(function (res) {
          $log.info(res);
        });
      } else {
        for (var i = 0; i < vm.activeUsers.length; i++) {
          var activeUser = vm.activeUsers[i];
          var identity = activeUser._id;
          var _notifyData2 = {
            identity: identity,
            title: "",
            body: $scope.incomingRoom,
            data: {
              callerId: vm.userData._id,
              callerName: vm.userData.displayName,
              callerAvatar: vm.userData.profilePic,
              roomName: $scope.incomingRoom,
              actionType: "cancel",
              notificationType: "twilio.video.call"
            }
          };
          apiFactory.twilioSendNotification(_notifyData2).then(function (res) {
            $log.info(res);
          });
        }
      }

      if (vm.leaveRoomIfJoined) {
        vm.leaveRoomIfJoined();
      }
    };

    $scope.initVideo = function (flag) {
      var isGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      $scope.isGroupCall = isGroup;

      if (flag === false) {
        $scope.audioCall = true;
        vm.videoFlag = false;
      } else {
        $scope.audioCall = false;
        vm.videoFlag = true;
      }

      navigator.mediaDevices.enumerateDevices().then(function (devices) {
        var microphones = devices.filter(function (d) {
          return d.kind === 'audioinput';
        });
        var cameras = devices.filter(function (d) {
          return d.kind === 'videoinput';
        });

        if (cameras.length == 0) {
          vm.videoFlag = false;
          vm.videoDisabled = true;
        } else {
          if (vm.videoFlag != false) {
            vm.videoFlag = true;
          }

          vm.videoDisabled = false;
        }

        if (microphones.length == 0) {
          vm.audioFlag = false;
          vm.audioDisabled = true;
        } else {
          vm.audioFlag = true;
          vm.audioDisabled = false;
        }

        $scope.curentuser = vm.userData.displayName;
        var identity;

        for (var i = 0; i < vm.activeUsers.length; i++) {
          var activeUser = vm.activeUsers[i];
          identity = activeUser._id;
          var notifyData = {
            identity: identity,
            title: "",
            body: $scope.activeMeetingRoomId.uniqueName,
            data: {
              isVideo: flag,
              callerId: vm.userData._id,
              callerName: vm.userData.displayName,
              callerAvatar: vm.userData.profilePic,
              roomName: $scope.activeMeetingRoomId.uniqueName,
              projectId: vm.project._id,
              actionType: !isGroup ? "invite" : "inviteGroup",
              notificationType: "twilio.video.call"
            }
          };
          apiFactory.twilioSendNotification(notifyData).then(function (res) {
            $log.info(res);
          });
        }

        $scope.isReady = false;
        vm.screen = 2;
        videoInit(flag);
      });
    };

    $scope.getCreateTime = function (dateCreated) {
      return moment().isSame(moment(new Date(dateCreated)), 'd') ? moment(new Date(dateCreated)).format('LT') : moment(new Date(dateCreated)).format('L');
    };

    $scope.getChatTime = function (date) {
      return moment().isSame(moment(new Date(date)), 'd') ? moment(new Date(date)).format('LT') : date;
    };

    $scope.getMainStyle = function () {
      if (vm.screen === 2) {
        return {
          top: 0
        };
      }
    };

    $scope.getPrivateChannels = function () {
      return $scope.channels.filter(function (x) {
        return x.memberUsers && x.memberUsers.length === 1 && x.channelState && x.channelState.uniqueName && x.channelState.uniqueName.includes(vm.userData._id) && x.channelState.uniqueName.includes(vm.project._id);
      });
    };

    $scope.getDatesOfMeetings = function () {
      if ($scope.meetingRooms) {
        return Object.keys($scope.meetingRooms);
      } else {
        return [];
      }
    };

    $scope.createMeetingRoom = function () {
      var modal = $uibModal.open({
        animation: true,
        component: 'createMeetingRoomModal',
        windowClass: 'create-meeting-room-modal',
        backdrop: 'static',
        keyboard: true,
        resolve: {
          inviteMembers: function inviteMembers() {
            return $scope.inviteMembers;
          },
          isCreate: function isCreate() {
            return true;
          }
        }
      });
      modal.result.then(function (newMeetingRoom) {
        $scope.meetingRoomList.push(newMeetingRoom);
      });
    };

    $scope.editMeetingRoom = function () {
      if (!$scope.selectedRoom) {
        return;
      }

      $scope.isLoading = true;
      apiFactory.getMeetingRoomDetail($scope.selectedRoom._id).then(function (res) {
        $scope.isLoading = false;
        $scope.selectedRoom = res.data;

        if ($scope.selectedRoom.status != 0) {
          Notification.error('The room\'s status is valid and cannot be updated.');
          return;
        }

        var modal = $uibModal.open({
          animation: true,
          component: 'createMeetingRoomModal',
          windowClass: 'create-meeting-room-modal',
          backdrop: 'static',
          keyboard: true,
          resolve: {
            inviteMembers: function inviteMembers() {
              return $scope.inviteMembers;
            },
            isCreate: function isCreate() {
              return false;
            },
            meetingRoom: function meetingRoom() {
              return $scope.selectedRoom;
            }
          }
        });
        modal.result.then(function (result) {
          $scope.selectedRoom = result;
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.deleteMeetingRoom = function () {
      if (!$scope.selectedRoom) {
        return;
      }

      $scope.isLoading = true;
      apiFactory.getMeetingRoomDetail($scope.selectedRoom._id).then(function (res) {
        $scope.isLoading = false;
        $scope.selectedRoom = res.data;

        if ($scope.selectedRoom.status == 1) {
          Notification.error('The room\'s status is in progress and cannot be deleted.');
          return;
        }

        var confirmModal = $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false
        });
        confirmModal.result.then(function () {
          $scope.isLoading = true;
          apiFactory.deleteMeetingRoom($scope.selectedRoom._id).then(function (res) {
            $scope.isLoading = false;
            Notification.success(res.data.message);
            var index = $scope.meetingRoomList.findIndex(function (x) {
              return x._id === $scope.selectedRoom._id;
            });

            if (index !== -1) {
              $scope.selectedRoom = undefined;
              $scope.meetingRoomList.splice(index, 1);
            }
          })["catch"](function (err) {
            $scope.isLoading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }, function () {});
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.getMeetingStatusText = function () {
      var startTime = moment($scope.selectedRoom.dateFrom);
      var today = moment();

      switch ($scope.selectedRoom.status) {
        case 0:
          return 'Start ' + startTime.from(today);

        case 1:
          return 'In-progress';

        case 2:
          return 'Completed';

        case 3:
          return 'Failed';
      }
    };

    $scope.getMeetingRoomMemberNames = function () {
      return $scope.selectedRoom.assignedTo.map(function (x) {
        return x.displayName;
      }).join(', ');
    };

    $scope.getStatusCSS = function (status) {
      switch (status) {
        case 'Active':
          return {
            bgColor: 'bg-active',
            color: 'active'
          };

        case 'Away':
          return {
            bgColor: 'bg-away',
            color: 'away'
          };

        case 'Do not disturb':
          return {
            bgColor: 'bg-disturb',
            color: 'disturb'
          };

        case 'Invisible':
          return {
            bgColor: 'bg-offline',
            color: 'offline'
          };

        default:
          return {
            bgColor: 'bg-offline',
            color: 'offline'
          };
      }
    };

    $scope.$watch('meetingRoomList.length', function () {
      organizeMeetingRoomList();
    });
    $scope.$watch('activeChannel', function () {
      $timeout(function () {
        $scope.$apply();
      });
    });

    vm.initMessaging = function () {
      $scope.participantList = [];
      $scope.todayDate = moment();
      $scope.accessToken = null;
      $scope.videoAccessToken = null;
      getAccessToken();
      getVideoAccessToken();
      var firebaseConfig = {
        apiKey: "AIzaSyAMRTh6THgKQ0bwGOd64U9DZ6gL9GBEX7g",
        authDomain: "cloudes-ocr.firebaseapp.com",
        databaseURL: "https://cloudes-ocr.firebaseio.com",
        projectId: "cloudes-ocr",
        storageBucket: "cloudes-ocr.appspot.com",
        messagingSenderId: "358322205035",
        appId: "1:358322205035:web:b967454ba29168771b9c2e",
        measurementId: "G-8S6QYEFYQZ"
      };

      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      } // Retrieve Firebase Messaging object.


      var messaging = firebase.messaging();
      messaging.onMessage(function (payload) {
        if ($location.url() != '/teams') {
          return;
        }

        notificationStore.reset();

        if ($scope.isGroupCall && payload.data.actionType === "cancel" && $scope.room.participants.size > 0) {
          var audioEl = $document[0].getElementById("audio-".concat(payload.data.callerId));

          if (audioEl) {
            var parentAudioId = audioEl.parentElement.getAttribute("id");
            $document[0].getElementById(parentAudioId).removeChild(audioEl);
          }

          var videoEl = $document[0].getElementById("video-".concat(payload.data.callerId));

          if (videoEl) {
            var parentVideoId = videoEl.parentElement.getAttribute("id");

            if (videoEl) {
              $document[0].getElementById(parentVideoId).removeChild(videoEl);
            }

            if (parentVideoId.includes("mainTrack")) {
              var audioElement = $document[0].getElementById('remote-media-voice');
              var elementNode = audioElement.childNodes[audioElement.childElementCount - 1];
              elementNode.setAttribute("index", -1);
              $document[0].getElementById("mainTrack-voice").appendChild(elementNode);
              var videoElement = $document[0].getElementById('remote-media');
              elementNode = videoElement.childNodes[videoElement.childElementCount - 1];
              elementNode.setAttribute("index", -1);
              $document[0].getElementById("mainTrack").appendChild(elementNode);
            }
          }
        }

        if (!$scope.isGroupCall && payload.data.actionType === "cancel" || $scope.isReady == true && payload.data.actionType === "accept" || $scope.isGroupCall && payload.data.actionType === "cancel" && $scope.room.participants.size == 0) {
          if (vm.leaveRoomIfJoined) {
            vm.leaveRoomIfJoined();
          }

          vm.screen = 1;
          $scope.isReady = false;
          $timeout(function () {
            $scope.$apply();
          });
        } else if (payload.data.actionType === "invite" || payload.data.actionType === "inviteGroup") {
          navigator.mediaDevices.enumerateDevices().then(function (devices) {
            var microphones = devices.filter(function (d) {
              return d.kind === 'audioinput';
            });
            var cameras = devices.filter(function (d) {
              return d.kind === 'videoinput';
            });

            if (cameras.length == 0) {
              vm.videoFlag = false;
              vm.videoDisabled = true;
            } else {
              vm.videoFlag = true;
              vm.videoDisabled = false;
            }

            if (microphones.length == 0) {
              vm.audioFlag = false;
              vm.audioDisabled = true;
            } else {
              vm.audioFlag = true;
              vm.audioDisabled = false;
            }

            $scope.isGroupCall = payload.data.actionType === "invite" ? false : true;
            vm.screen = 2;
            $scope.isReady = true;
            $scope.incomingAvatar = payload.data.callerAvatar;
            $scope.incomingName = payload.data.callerName;
            $scope.incomingRoom = payload.data.roomName;
            $scope.incomingUserId = payload.data.callerId;
            vm.videoFlag = payload.data.isVideo == "false" ? false : true;
            var room = $scope.channels.find(function (it) {
              return it.uniqueName === $scope.incomingRoom;
            });
            $scope.setActiveMeeting(room);
            $timeout(function () {
              $scope.$apply();
            });
          });
        }
      });
    };
    /**
     * Init
     */


    function onInit() {
      vm.screen = 1;
      globals.getCountryCode().then(function (resp) {
        vm.countries = resp.data;
      });
      $scope.isShowMsg = false;
      $scope.activeChannel = null;
      $scope.activeChannelPage = null;
      vm.activeUsers = [];
      vm.inActiveUsers = [];
      $scope.meetingRoomList = [];
      $scope.channels = [];
      vm.attachmentFiles = [];
      $scope.TEAM_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
      // if (vm.userData.designation === 'Admin') {
      //   $scope.TEAM_ACCESS_CREATE = 4;
      // } else {
      //   $scope.isLoading = true;
      //   apiFactory.getAccessSettingDetails({
      //     dType,
      //     list: [Constants.AccessKey.TEAM]
      //   })
      //     .then(res => {
      //       $scope.isLoading = false;
      //       $scope.TEAM_ACCESS_CREATE = res.data.data[Constants.AccessKey.TEAM];
      //     })
      //     .catch((e) => {
      //       $scope.isLoading = false;
      //       $log.error(e);
      //       Notification.error('Something went wrong try later')
      //     });
      // }

      $scope.isLoading = true;
      Promise.all([apiFactory.getMeetingRoomsForProject(vm.project._id), // apiFactory.getInviteMembersForChat(vm.project._id)
      apiFactory.getAllMembersInCurrentCompany(vm.companyData._id)]).then(function (resp) {
        $scope.isLoading = false;
        $scope.meetingRoomList = resp[0].data.data;
        $scope.inviteMembers = resp[1].data.data;

        if ($scope.inviteMembers.length) {
          $scope.setActiveUser($scope.inviteMembers[0]);
        }

        vm.initMessaging();
      })["catch"](function (error) {
        $scope.isLoading = false;
        $log.error(error);
        Notification.error('Something went wrong try later');
      });
      $scope.changeTab($scope.TAB.CHAT);
    }

    onInit();

    vm.goToDirectCallScreen = function () {
      if (utils.isEmpty(vm.notificationData)) {
        return;
      }

      vm.screen = 2;
      $scope.isReady = true;
      $scope.isGroupCall = vm.notificationData.actionType === "invite" ? false : true;
      $scope.incomingAvatar = vm.notificationData.callerAvatar;
      $scope.incomingName = vm.notificationData.callerName;
      $scope.incomingRoom = vm.notificationData.roomName;
      $scope.incomingUserId = vm.notificationData.callerId;
      vm.videoFlag = vm.notificationData.isVideo == "false" ? false : true;
      var room = $scope.channels.find(function (it) {
        return it.uniqueName === $scope.incomingRoom;
      });
      $scope.setActiveMeeting(room);
      $timeout(function () {
        $scope.$apply();
      });
    };

    $scope.$on('$destroy', function () {
      notificationStore.reset();
    });

    $scope.goToMeeting = function (id) {
      $window.open($state.href('teamsMeeting', {
        id: id
      }), '_blank');
    };
  }
})();


"use strict";

/* eslint-disable no-unused-vars */
(function () {
  'use strict';

  angular.module('app').component('suppliersGrid', {
    controller: SuppliersGridController,
    controllerAs: 'vm',
    templateUrl: 'app/main/suppliers/suppliersGrid/suppliersGrid.view.html'
  });
  /** @ngInject */

  function SuppliersGridController($scope, apiFactory, $state, utils, globals, $log, Notification) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.SUPPLIER_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.SUPPLIER_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.SUPPLIER]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.SUPPLIER_ACCESS_CREATE = res.data.data[Constants.AccessKey.SUPPLIER];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.utils = utils;
    $scope.periods = [// {id: 'project', name: 'Project Period'},
    {
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.labelChecked = false;
    $scope.isGrid = true;
    $scope.suppliers = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 12; //globals.numPerPage();

    $scope.noOfPages = 0;
    $scope.isFinalPage = false;
    $scope.isFirstPage = true;
    vm.currentPage = 1;
    vm.searchText = undefined;
    vm.sortMenuList = [{
      label: 'Name',
      key: 'name'
    }, {
      label: 'Created Date',
      key: 'created'
    }, {
      label: 'Modified Date',
      key: 'updatedAt'
    }, {
      label: 'Supplier Tag',
      key: 'systemTag'
    }];
    vm.sortMenu = "created";
    $scope.isLoading = false;

    vm.fetchAllSuppliers = function () {
      $scope.isLoading = true;
      apiFactory.getAllSuppliers({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        sort: vm.sortMenu,
        sortType: "false"
      }).then(function (resp) {
        $scope.isLoading = false;
        $log.log(resp.data.list);
        $scope.suppliers = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function () {
        $scope.isLoading = false;
      });
    };

    vm.fetchAllSuppliers();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchAllSuppliers();
    };

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.fetchAllSuppliers();
    };

    $scope.goToDetail = function (supplierId) {
      $state.go('suppliersDetail', {
        id: supplierId
      });
    };

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      $scope.suppliers.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };

    $scope.getColor = function (name) {
      return globals.getAvatarColor(name);
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('suppliersEdit', {
    controller: SuppliersEditController,
    controllerAs: 'vm',
    templateUrl: 'app/main/suppliers/suppliersEdit/suppliersEdit.view.html'
  });
  /** @ngInject */

  function SuppliersEditController($scope, $stateParams, apiFactory, globals, Notification, $state, utils, $log, $uibModal) {
    var vm = this;
    vm.utils = utils;
    vm.supplierId = $stateParams.id;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    $scope.paymentConditions = vm.companyData.paymentConditions;

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.supplierType = undefined;
    $scope.staff = {
      mobile: {
        dialCode: null,
        phoneNumber: null
      },
      firstName: null,
      lastName: null,
      email: null
    };
    /**Insert Supplier functions */

    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x, _index) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    globals.getCountryCode().then(function (resp) {
      vm.countryCodes = resp.data;
      vm.countryCodes = vm.countryCodes.map(function (x) {
        return {
          name: x.name,
          dialCode: x.dialCode,
          code: x.code,
          dialCodeName: "".concat(x.dialCode, " (").concat(x.name, ")")
        };
      });
    });

    $scope.addStaff = function () {
      var staff = $scope.staff;
      var messages = [];
      var reg = /\S+@\S+\.\S+/;

      if (!reg.test(staff.email)) {
        messages[messages.length] = 'Enter valid email';
      }

      if (!staff.mobile.dialCode) {
        messages[messages.length] = 'Select dial code';
      }

      if (!staff.mobile.phoneNumber || staff.mobile.phoneNumber.length <= 6) {
        messages[messages.length] = 'Enter valid phone number';
      }

      if (utils.isEmpty(staff.firstName)) {
        messages.push('Please input first name');
      }

      if (utils.isEmpty(staff.lastName)) {
        messages.push('Please input last name');
      } // if (utils.isEmpty(staff.password)) {
      //   messages.push('Please input password');
      // }
      // if (utils.isEmpty(staff.confirmPassword)) {
      //   messages.push('Please confirm password');
      // }


      if (!utils.isEmpty(staff.password) && !utils.isEmpty(staff.confirmPassword) && staff.password != staff.confirmPassword) {
        messages.push('Confirm password is not correct');
      }

      if (messages.length > 0) {
        messages.forEach(function (v) {
          Notification.error(v);
        });
        return;
      }

      $scope.staffList.push(staff);
      $scope.staff = {
        mobile: {
          dialCode: null,
          phoneNumber: null
        },
        firstName: null,
        lastName: null,
        email: null
      };
    };

    $scope.deleteStaff = function (index, staff) {
      if (staff._id) {
        $scope.isLoading = true;
        apiFactory.isInvitedStaff({
          userId: staff._id
        }).then(function (res) {
          $scope.isLoading = false;
          var isInvitedUser = res.data.data;

          if (isInvitedUser) {
            var confirmModal = $uibModal.open({
              animation: true,
              component: 'confirmModal',
              size: 'sm',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                data: function data() {
                  return {
                    title: 'Confirm delete staff',
                    message: 'Are you sure you want to delete this staff?',
                    subMessage: 'This staff has already been invited as a collaboration member',
                    confirmButtonText: 'Delete',
                    icon: '/assets/icons/status-warning.svg'
                  };
                }
              }
            });
            confirmModal.result.then(function () {
              $scope.staffList.splice(index, 1);
            });
          } else {
            $scope.staffList.splice(index, 1);
          }
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      } else {
        $scope.staffList.splice(index, 1);
      }
    };

    $scope.editStaff = function (_staff) {
      $uibModal.open({
        animation: true,
        component: 'editStaffModal',
        windowClass: 'edit-staff-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          staff: function staff() {
            return _staff;
          }
        }
      }).result.then(function (result) {
        _staff.firstName = result.firstName;
        _staff.lastName = result.lastName;
        _staff.email = result.email;
        _staff.mobile = angular.copy(result.mobile);
      }, function () {});
    };

    $scope.updateSupplier = function () {
      if ($scope.bank) {
        $scope.accountHolderName = $scope.bank.accountHolderName;
        $scope.accountNumber = $scope.bank.accountNumber;
        $scope.IBAN = $scope.bank.IBAN;
        $scope.bankName = $scope.bank.bankName;
        $scope.bankAddress = $scope.bank.bankAddress;
        $scope.sortCode = $scope.bank.sortCode;
        $scope.routingNo = $scope.bank.routingNo;
        $scope.bicCode = $scope.bank.bicCode;
        $scope.ifscCode = $scope.bank.ifscCode;
        $scope.routingCode = $scope.bank.routingCode;
      }

      var messages = [];
      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);

      if (!$scope.supplierData.name) {
        messages[messages.length] = 'Enter Name';
      }

      if (!$scope.supplierData.contact || !$scope.supplierData.contact.dialCode || !$scope.supplierData.contact.phoneNumber) {
        messages[messages.length] = 'Enter Contact Number';
      }

      if (!$scope.supplierData.email) {
        messages[messages.length] = 'Enter Email';
      }

      if (!$scope.supplierData.address.line1) {
        messages[messages.length] = 'Enter Address';
      } //add payment data


      if (angular.isUndefined($scope.supplierData.paymentTerms)) {
        Notification.error('Please select payment terms');
        return;
      }

      if (!$scope.supplierData.paymentTerms.paymentSetting) {
        Notification.error('Please select payment setting');
        return;
      }

      if ($scope.supplierData.paymentTerms.vatPercent === null || angular.isUndefined($scope.supplierData.paymentTerms.vatPercent)) {
        Notification.error('Please select vatPercent');
        return;
      }

      if (!$scope.supplierData.paymentTerms.vatNumber) {
        Notification.error('Please select vatNumber');
        return;
      }

      var staffList = $scope.staffList;
      var removedStaffs = [];

      if ($scope.supplierData.staffs) {
        var _iterator = _createForOfIteratorHelper($scope.supplierData.staffs),
            _step;

        try {
          var _loop = function _loop() {
            var oldStaff = _step.value;
            var find = staffList.find(function (x) {
              return x._id === oldStaff._id;
            });

            if (!find) {
              removedStaffs.push(oldStaff._id);
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      if (utils.isEmpty(staffList)) {
        Notification.error("Please add staff at least one");
        return;
      }

      if (messages.length > 0) {
        messages.forEach(function (v) {
          Notification.error(v);
        });
        return;
      }

      var obj = {
        name: $scope.supplierData.name,
        contact: {
          dialCode: 'contact' in $scope.supplierData ? $scope.supplierData.contact.dialCode : null,
          phoneNumber: 'contact' in $scope.supplierData ? $scope.supplierData.contact.phoneNumber + '' : null
        },
        email: $scope.supplierData.email,
        address: $scope.supplierData.address,
        paymentTerms: $scope.supplierData.paymentTerms,
        types: $scope.supplierTypes.map(function (x) {
          return x.tagName;
        }),
        staffList: staffList,
        removedStaffs: removedStaffs,
        searchKey: $scope.supplierData.searchKey,
        bankDetails: [{
          accountHolderName: $scope.accountHolderName,
          accountNumber: $scope.accountNumber,
          IBAN: $scope.IBAN,
          bankName: $scope.bankName,
          bankAddress: $scope.bankAddress,
          sortCode: $scope.sortCode,
          routingNo: $scope.routingNo,
          bicCode: $scope.bicCode,
          ifscCode: $scope.ifscCode,
          routingCode: $scope.routingCode
        }],
        _id: vm.supplierId,
        files: $scope.imgAndFiles //vm.files

      };

      if (0 === messages.length) {
        $scope.isLoading = true;
        apiFactory.updateSupplier(obj).then(function () {
          $scope.isLoading = false;
          Notification.success('Supplier successfully updated');
          $state.go('suppliersDetail', {
            id: vm.supplierId
          });
        }, function (error) {
          $scope.isLoading = false;
          if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Something went wrong try later');
        })["catch"](function () {
          $scope.isLoading = false;
        });
      }
    };

    vm.allSupplierTypes = [];
    $scope.supplierTypes = [];

    $scope.addSupplierType = function () {
      if ($scope.supplierType) {
        var index = vm.allSupplierTypes.findIndex(function (x) {
          return x._id == $scope.supplierType;
        });

        if (index !== -1) {
          var supplierType = vm.allSupplierTypes[index];
          $scope.supplierTypes.push(supplierType);
          vm.allSupplierTypes.splice(index, 1);
          $scope.supplierType = undefined;
        }
      }
    };

    $scope.deleteSupplierType = function (index) {
      var result = $scope.supplierTypes.splice(index, 1);
      vm.allSupplierTypes.push(result[0]);
    };

    function getSupplierDetail() {
      $scope.isLoading = true;
      Promise.all([apiFactory.listAllSupplierTypes(), apiFactory.getSupplierById(vm.supplierId)]).then(function (resp) {
        $scope.isLoading = false;
        vm.allSupplierTypes = resp[0].data.list;
        $scope.supplierData = resp[1].data;
        $scope.staffList = angular.copy($scope.supplierData.staffs) || [];

        if (angular.isString($scope.supplierData.address)) {
          $scope.supplierData.address = {};
        }

        $scope.FILEIMG = $scope.supplierData.profilePic;
        $scope.supplierData.contact.phoneNumber = parseInt($scope.supplierData.contact.phoneNumber);

        if (resp[1].data.bankDetails != null && resp[1].data.bankDetails.length > 0) {
          $scope.bank = resp[1].data.bankDetails[0];
        }

        $scope.supplierData.types = $scope.supplierData.types || [];

        var _iterator2 = _createForOfIteratorHelper($scope.supplierData.types),
            _step2;

        try {
          var _loop2 = function _loop2() {
            var type = _step2.value;
            var index = vm.allSupplierTypes.findIndex(function (x) {
              return x.tagName == type;
            });

            if (index != -1) {
              var result = vm.allSupplierTypes.splice(index, 1);
              $scope.supplierTypes.push(result[0]);
            }
          };

          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    getSupplierDetail();

    $scope.removeStaff = function (index) {
      $scope.staffList.splice(index, 1);
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('suppliersDetail', {
    controller: SuppliersDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/suppliers/suppliersDetail/suppliersDetail.view.html'
  });
  /** @ngInject */

  function SuppliersDetailController($scope, $stateParams, apiFactory, Notification, globals, $location, $uibModal, $log, utils, $state) {
    var vm = this;
    vm.utils = utils;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.SUPPLIER_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.SUPPLIER_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.SUPPLIER]
    //   })
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.SUPPLIER_ACCESS_CREATE = res.data.data[Constants.AccessKey.SUPPLIER];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.companyData = companyStore.get();
    $scope.paymentConditions = vm.companyData.paymentConditions;
    vm.supplierId = $stateParams.id;

    function getSupplierDetail() {
      $scope.isLoading = true;
      apiFactory.getSupplierById(vm.supplierId).then(function (resp) {
        $scope.isLoading = false;
        $scope.showDetails = true;
        $scope.supplierData = resp.data;
        $scope.FILEIMG = $scope.supplierData.profilePic;
        $scope.types = $scope.supplierData.types || [];

        if (resp.data.bankDetails != null && resp.data.bankDetails.length > 0) {
          var bank = resp.data.bankDetails[0];
          $scope.accountHolderName = bank.accountHolderName;
          $scope.accountNumber = bank.accountNumber;
          $scope.IBAN = bank.IBAN;
          $scope.bankName = bank.bankName;
          $scope.bankAddress = bank.bankAddress;
          $scope.sortCode = bank.sortCode;
          $scope.routingNo = bank.routingNo;
          $scope.bicCode = bank.bicCode;
          $scope.ifscCode = bank.ifscCode;
          $scope.routingCode = bank.routingCode;
        }

        if (resp.data.paymentConditions) {
          $scope.paymentTerms = $scope.paymentConditions.filter(function (x) {
            var index = resp.data.paymentConditions.indexOf(x._id);
            return index >= 0;
          });

          if ($scope.paymentTerms.length > 0) {
            $scope.payment = {
              terms: $scope.paymentTerms[0]
            };
          }
        }

        $scope.terms = $scope.supplierData.paymentTerms;

        if ($scope.terms) {
          $scope.terms.paymentSetting = $scope.paymentConditions.find(function (x) {
            return x._id == $scope.terms.paymentSetting;
          });
        }
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    getSupplierDetail();

    $scope.deleteSupplier = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.isLoading = true;
          apiFactory.deleteSupplier(vm.supplierId).then(function (resp) {
            $scope.isLoading = false;
            Notification.success('Suppier deleted successfully');
            $location.path('/suppliers');
          }, function (error) {
            $scope.isLoading = false;
            Notification.error('Something went wrong try later');
          })["catch"](function (e) {
            $scope.isLoading = false;
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('suppliersAdd', {
    controller: SuppliersAddController,
    controllerAs: 'vm',
    templateUrl: 'app/main/suppliers/suppliersAdd/suppliersAdd.view.html'
  });
  /** @ngInject */

  function SuppliersAddController($scope, $state, apiFactory, globals, Notification, utils, $uibModal) {
    var vm = this; //vm.utils = utils;

    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.companyData = companyStore.get();
    $scope.paymentConditions = vm.companyData.paymentConditions;
    $scope.address = {};
    $scope.supplierData = {};
    $scope.staff = {
      mobile: {
        dialCode: null,
        phoneNumber: null
      },
      firstName: null,
      lastName: null,
      email: null
    };
    /**Insert Supplier functions */

    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x, _index) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    $scope.supplierType = undefined;
    vm.allSupplierTypes = [];
    $scope.supplierTypes = [];

    $scope.addSupplierType = function () {
      if ($scope.supplierType) {
        var index = vm.allSupplierTypes.findIndex(function (x) {
          return x._id == $scope.supplierType;
        });

        if (index !== -1) {
          var supplierType = vm.allSupplierTypes[index];
          $scope.supplierTypes.push(supplierType);
          vm.allSupplierTypes.splice(index, 1);
          $scope.supplierType = undefined;
        }
      }
    };

    $scope.deleteSupplierType = function (index) {
      var result = $scope.supplierTypes.splice(index, 1);
      vm.allSupplierTypes.push(result[0]);
    };

    apiFactory.listAllSupplierTypes().then(function (resp) {
      vm.allSupplierTypes = resp.data.list;
    });
    globals.getCountryCode().then(function (resp) {
      vm.countryCodes = resp.data;
      vm.countryCodes = vm.countryCodes.map(function (x) {
        return {
          name: x.name,
          dialCode: x.dialCode,
          code: x.code,
          dialCodeName: "".concat(x.dialCode, " (").concat(x.name, ")")
        };
      });
    });
    $scope.staffList = [];

    $scope.addStaff = function () {
      var staff = $scope.staff;
      var messages = [];
      var reg = /\S+@\S+\.\S+/;

      if (!reg.test(staff.email)) {
        messages[messages.length] = 'Enter valid email';
      }

      if (!staff.mobile.dialCode) {
        messages[messages.length] = 'Select dial code';
      }

      if (!staff.mobile.phoneNumber || staff.mobile.phoneNumber.length <= 6) {
        messages[messages.length] = 'Enter valid phone number';
      }

      if (utils.isEmpty(staff.firstName)) {
        messages.push('Please input first name');
      }

      if (utils.isEmpty(staff.lastName)) {
        messages.push('Please input last name');
      }

      if (messages.length > 0) {
        messages.forEach(function (v) {
          Notification.error(v);
        });
        return;
      }

      $scope.staffList.push(staff);
      $scope.staff = {
        firstName: null,
        lastName: null,
        email: null,
        mobile: {
          dialCode: null,
          phoneNumber: null
        }
      };
    };

    $scope.removeStaff = function (index) {
      $scope.staffList.splice(index, 1);
    };

    $scope.editStaff = function (_staff) {
      $uibModal.open({
        animation: true,
        component: 'editStaffModal',
        windowClass: 'edit-staff-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          staff: function staff() {
            return _staff;
          }
        }
      }).result.then(function (result) {
        _staff.firstName = result.firstName;
        _staff.lastName = result.lastName;
        _staff.email = result.email;
        _staff.mobile = angular.copy(result.mobile);
      }, function () {});
    };

    $scope.createSupplier = function () {
      var messages = [];
      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);

      if (!$scope.supplier_name) {
        messages[messages.length] = 'Enter Name';
      }

      if (!$scope.dialCode || !$scope.phoneNumber) {
        messages[messages.length] = 'Enter Contact Number';
      }

      if (!$scope.email) {
        messages[messages.length] = 'Enter Email';
      }

      if (!$scope.address.line1) {
        messages[messages.length] = 'Enter Address';
      }

      if (utils.isEmpty($scope.staffList)) {
        Notification.error("Please add staff at least one");
        return;
      }

      if (!$scope.supplierData) {
        Notification.error("Please input payment data.");
        return;
      } //add payment data


      if (angular.isUndefined(!$scope.supplierData.paymentTerms)) {
        Notification.error('Please select payment terms');
        return;
      }

      if (!$scope.supplierData.paymentTerms) {
        Notification.error('Enter Terms');
        return;
      } else {
        if (!$scope.supplierData.paymentTerms.paymentSetting) {
          Notification.error('Please select payment setting');
          return;
        }

        if ($scope.supplierData.paymentTerms.vatPercent === null || angular.isUndefined($scope.supplierData.paymentTerms.vatPercent)) {
          Notification.error('Please select Vat Percent');
          return;
        }

        if (!$scope.supplierData.paymentTerms.vatNumber) {
          Notification.error('Please select vatNumber');
          return;
        }
      }

      if (messages.length > 0) {
        messages.forEach(function (v) {
          Notification.error(v);
        });
        return;
      }

      var obj = {
        name: $scope.supplier_name,
        contact: {
          dialCode: $scope.dialCode,
          phoneNumber: $scope.phoneNumber.toString()
        },
        email: $scope.email,
        address: $scope.address,
        picFile: $scope.picFile,
        staffList: $scope.staffList,
        paymentTerms: $scope.supplierData.paymentTerms,
        searchKey: $scope.searchKey,
        types: $scope.supplierTypes.map(function (x) {
          return x.tagName;
        }),
        bankDetails: [{
          accountHolderName: $scope.accountHolderName,
          accountNumber: $scope.accountNumber,
          IBAN: $scope.IBAN,
          bankName: $scope.bankName,
          bankAddress: $scope.bankAddress,
          sortCode: $scope.sortCode,
          routingNo: $scope.routingNo,
          bicCode: $scope.bicCode,
          ifscCode: $scope.ifscCode,
          routingCode: $scope.routingCode
        }],
        files: $scope.imgAndFiles //vm.files

      };

      if (0 === messages.length) {
        $scope.isLoading = true;
        apiFactory.createNewSupplier(obj).then(function () {
          $scope.isLoading = false;
          vm.supp = {};
          Notification.success('Supplier successfully created');
          $state.go('suppliersGrid');
        }, function (error) {
          $scope.isLoading = false;
          if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Something went wrong try later');
        })["catch"](function () {
          $scope.isLoading = false;
        });
      }
    };
  }
})();


"use strict";

/* eslint-disable no-unused-vars */
(function () {
  'use strict';

  angular.module('app').component('subContractorsGrid', {
    controller: subContractorsGridController,
    controllerAs: 'vm',
    templateUrl: 'app/main/subContractors/subContractorsGrid/subContractorsGrid.view.html'
  });
  /** @ngInject */

  function subContractorsGridController($scope, apiFactory, $state, utils, globals, Notification, $log) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.SUBCONTRACTOR_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.SUBCONTRACTOR_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.SUBCONTRACTOR]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.SUBCONTRACTOR_ACCESS_CREATE = res.data.data[Constants.AccessKey.SUBCONTRACTOR];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.utils = utils;
    $scope.subContractors = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 12; //globals.numPerPage();

    $scope.noOfPages = 0;
    vm.currentPage = 1;
    vm.searchText = undefined;
    vm.sortMenuList = [{
      label: 'Name',
      key: 'name'
    }, {
      label: 'Created Date',
      key: 'created'
    }, {
      label: 'Modified Date',
      key: 'updatedAt'
    }, {
      label: 'Sub Contractor Tag',
      key: 'systemTag'
    }];
    vm.sortMenu = "created";
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.labelChecked = false;
    $scope.isLoading = false;
    $scope.isGrid = true;

    vm.fetchAllSubcontractors = function () {
      $scope.isLoading = true;
      apiFactory.getAllSubcontractors({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        sort: vm.sortMenu,
        sortType: "false"
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.subContractors = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function () {
        $scope.isLoading = false;
      });
    };

    vm.fetchAllSubcontractors();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchAllSuppliers();
    };

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.fetchAllSubcontractors();
    };

    $scope.goToDetail = function (subContractorId) {
      $state.go('subContractorsDetail', {
        id: subContractorId
      });
    };

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      $scope.subContractors.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };

    $scope.getColor = function (name) {
      return globals.getAvatarColor(name);
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('subContractorsEdit', {
    controller: SubContractorsEditController,
    controllerAs: 'vm',
    templateUrl: 'app/main/subContractors/subContractorsEdit/subContractorsEdit.view.html'
  });
  /** @ngInject */

  function SubContractorsEditController($scope, $stateParams, apiFactory, Notification, $state, globals, utils, $log, $uibModal) {
    var vm = this;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.companyData = companyStore.get();
    $scope.paymentConditions = vm.companyData.paymentConditions;
    globals.getCountryCode().then(function (resp) {
      vm.countryCodes = resp.data;
      vm.countryCodes = vm.countryCodes.map(function (x) {
        return {
          name: x.name,
          dialCode: x.dialCode,
          code: x.code,
          dialCodeName: "".concat(x.dialCode, " (").concat(x.name, ")")
        };
      });
    });
    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    vm.subContractorId = $stateParams.id;
    $scope.staff = {
      mobile: {
        dialCode: null,
        phoneNumber: null
      },
      firstName: null,
      lastName: null,
      email: null
    };
    globals.getCountryCode().then(function (resp) {
      $scope.countryCodes = resp.data;
    });
    /** Types */

    vm.allWorkTypes = [];
    $scope.workTypes = [];
    $scope.workType = undefined;

    $scope.addWorkType = function () {
      if ($scope.workType) {
        var index = vm.allWorkTypes.findIndex(function (x) {
          return x._id == $scope.workType;
        });

        if (index !== -1) {
          var workType = vm.allWorkTypes[index];
          $scope.workTypes.push(workType);
          vm.allWorkTypes.splice(index, 1);
          $scope.workType = undefined;
        }
      }
    };

    $scope.deleteWorkType = function (index) {
      var result = $scope.workTypes.splice(index, 1);
      vm.allWorkTypes.push(result[0]);
    };
    /** Staff */


    $scope.addStaff = function () {
      var staff = $scope.staff;
      var messages = [];
      var reg = /\S+@\S+\.\S+/;

      if (!reg.test(staff.email)) {
        messages[messages.length] = 'Enter valid email';
      }

      if (!staff.mobile.dialCode) {
        messages[messages.length] = 'Select dial code';
      }

      if (!staff.mobile.phoneNumber || staff.mobile.phoneNumber.length <= 6) {
        messages[messages.length] = 'Enter valid phone number';
      }

      if (utils.isEmpty(staff.firstName)) {
        messages.push('Please input first name');
      }

      if (utils.isEmpty(staff.lastName)) {
        messages.push('Please input last name');
      } // if (utils.isEmpty(staff.password)) {
      //   messages.push('Please input password');
      // }
      // if (utils.isEmpty(staff.confirmPassword)) {
      //   messages.push('Please confirm password');
      // }


      if (!utils.isEmpty(staff.password) && !utils.isEmpty(staff.confirmPassword) && staff.password != staff.confirmPassword) {
        messages.push('Confirm password is not correct');
      }

      if (messages.length > 0) {
        messages.forEach(function (v) {
          Notification.error(v);
        });
        return;
      }

      $scope.staffList.push(staff);
      $scope.staff = {
        mobile: {
          dialCode: null,
          phoneNumber: null
        },
        firstName: null,
        lastName: null,
        email: null
      };
    };

    $scope.deleteStaff = function (index, staff) {
      if (staff._id) {
        $scope.isLoading = true;
        apiFactory.isInvitedStaff({
          userId: staff._id
        }).then(function (res) {
          $scope.isLoading = false;
          var isInvitedUser = res.data.data;

          if (isInvitedUser) {
            var confirmModal = $uibModal.open({
              animation: true,
              component: 'confirmModal',
              size: 'sm',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                data: function data() {
                  return {
                    title: 'Confirm delete staff',
                    message: 'Are you sure you want to delete this staff?',
                    subMessage: 'This staff has already been invited as a collaboration member',
                    confirmButtonText: 'Delete',
                    icon: '/assets/icons/status-warning.svg'
                  };
                }
              }
            });
            confirmModal.result.then(function () {
              $scope.staffList.splice(index, 1);
            });
          } else {
            $scope.staffList.splice(index, 1);
          }
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      } else {
        $scope.staffList.splice(index, 1);
      }
    };

    $scope.editStaff = function (_staff) {
      $uibModal.open({
        animation: true,
        component: 'editStaffModal',
        windowClass: 'edit-staff-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          staff: function staff() {
            return _staff;
          }
        }
      }).result.then(function (result) {
        _staff.firstName = result.firstName;
        _staff.lastName = result.lastName;
        _staff.email = result.email;
        _staff.mobile = angular.copy(result.mobile);
      }, function () {});
    };

    $scope.updateSubContractor = function (paymentVat, bank, picFile) {
      $scope.paymentVat = paymentVat;
      $scope.picFile = picFile;

      if (bank) {
        $scope.accountHolderName = bank.accountHolderName;
        $scope.accountNumber = bank.accountNumber;
        $scope.IBAN = bank.IBAN;
        $scope.bankName = bank.bankName;
        $scope.bankAddress = bank.bankAddress;
        $scope.sortCode = bank.sortCode;
        $scope.routingNo = bank.routingNo;
        $scope.bicCode = bank.bicCode;
        $scope.ifscCode = bank.ifscCode;
        $scope.routingCode = bank.routingCode;
      }

      var messages = [];
      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);

      if (!$scope.SubContractorData.name) {
        messages[messages.length] = 'Enter Name';
      }

      if (!$scope.SubContractorData.contact || !$scope.SubContractorData.contact.phoneNumber || !$scope.SubContractorData.contact.dialCode) {
        messages[messages.length] = 'Enter Contact Number';
      }

      if (!$scope.SubContractorData.email) {
        messages[messages.length] = 'Enter Email';
      }

      if (!$scope.SubContractorData.address) {
        messages[messages.length] = 'Enter Address';
      }

      var staffList = $scope.staffList;
      var removedStaffs = [];

      if ($scope.SubContractorData.staffs) {
        var _iterator = _createForOfIteratorHelper($scope.SubContractorData.staffs),
            _step;

        try {
          var _loop = function _loop() {
            var oldStaff = _step.value;
            var find = staffList.find(function (x) {
              return x._id === oldStaff._id;
            });

            if (!find) {
              removedStaffs.push(oldStaff._id);
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } //add payment data


      if (angular.isUndefined($scope.SubContractorData.paymentTerms)) {
        Notification.error('Please select payment terms');
        return;
      }

      if (!$scope.SubContractorData.paymentTerms.paymentSetting) {
        Notification.error('Please select payment setting');
        return;
      }

      if ($scope.SubContractorData.paymentTerms.vatPercent === null || angular.isUndefined($scope.SubContractorData.paymentTerms.vatPercent)) {
        Notification.error('Please input Vat Percent');
        return;
      }

      if (!$scope.SubContractorData.paymentTerms.vatNumber) {
        Notification.error('Please input Vat registration number');
        return;
      }

      if (utils.isEmpty($scope.staffList)) {
        Notification.error("Please add staff at least one");
        return;
      }

      if (messages.length > 0) {
        messages.forEach(function (v) {
          Notification.error(v);
        });
        return;
      }

      var obj = {
        name: $scope.SubContractorData.name,
        picFile: $scope.imgAndFiles,
        contact: {
          dialCode: 'contact' in $scope.SubContractorData ? $scope.SubContractorData.contact.dialCode : null,
          phoneNumber: 'contact' in $scope.SubContractorData ? $scope.SubContractorData.contact.phoneNumber + '' : null
        },
        email: $scope.SubContractorData.email,
        address: $scope.SubContractorData.address,
        paymentTerms: $scope.SubContractorData.paymentTerms,
        types: $scope.workTypes.map(function (x) {
          return x.tagName;
        }),
        staffList: staffList,
        removedStaffs: removedStaffs,
        bankDetails: [{
          accountHolderName: $scope.accountHolderName,
          accountNumber: $scope.accountNumber,
          IBAN: $scope.IBAN,
          bankName: $scope.bankName,
          bankAddress: $scope.bankAddress,
          sortCode: $scope.sortCode,
          routingNo: $scope.routingNo,
          bicCode: $scope.bicCode,
          ifscCode: $scope.ifscCode,
          routingCode: $scope.routingCode
        }],
        _id: vm.subContractorId
      };

      if (0 === messages.length) {
        $scope.isLoading = true;
        apiFactory.updateSubcontractor(obj).then(function () {
          $scope.isLoading = false;
          Notification.success('Subcontractor successfully updated');
          $state.go('subContractorsDetail', {
            id: vm.subContractorId
          });
        })["catch"](function (e) {
          $scope.isLoading = false;

          if (e.data && e.data.message) {
            Notification.error(e.data.message);
          } else {
            Notification.error("Failed to update subcontractor");
          }
        });
      }
    };

    function getSubContractorDetail() {
      $scope.isLoading = true;
      Promise.all([apiFactory.listAllWorkTypes(), apiFactory.getSubcontractorById(vm.subContractorId)]).then(function (resp) {
        $scope.isLoading = false;
        vm.allWorkTypes = resp[0].data.list;
        $scope.SubContractorData = resp[1].data;
        $scope.staffList = angular.copy($scope.SubContractorData.staffs) || [];

        if (angular.isString($scope.SubContractorData.address)) {
          $scope.SubContractorData.address = {};
        }

        $scope.SubContractorData.contact.phoneNumber = parseInt($scope.SubContractorData.contact.phoneNumber);
        $scope.FILEIMG = $scope.SubContractorData.profilePic;

        if (resp[1].data.bankDetails != null && resp[1].data.bankDetails.length > 0) {
          $scope.bank = resp[1].data.bankDetails[0];
        }

        $scope.SubContractorData.types = $scope.SubContractorData.types || [];

        var _iterator2 = _createForOfIteratorHelper($scope.SubContractorData.types),
            _step2;

        try {
          var _loop2 = function _loop2() {
            var type = _step2.value;
            var index = vm.allWorkTypes.find(function (x) {
              return x.tagName == type;
            });

            if (index !== -1) {
              var result = vm.allWorkTypes.splice(index, 1);
              $scope.workTypes.push(result[0]);
            }
          };

          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    getSubContractorDetail();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('subContractorsDetail', {
    controller: subContractorsDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/subContractors/subContractorsDetail/subContractorsDetail.view.html'
  });
  /** @ngInject */

  function subContractorsDetailController($scope, $stateParams, apiFactory, Notification, globals, $state, $uibModal, $log, $location, utils) {
    var vm = this;
    vm.utils = utils;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.SUBCONTRACTOR_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.SUBCONTRACTOR_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.SUBCONTRACTOR]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.SUBCONTRACTOR_ACCESS_CREATE = res.data.data[Constants.AccessKey.SUBCONTRACTOR];
    //   })
    //   .catch((e) => {
    //     $scope.isLoading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    vm.companyData = companyStore.get();
    $scope.paymentConditions = vm.companyData.paymentConditions;
    globals.getCountryCode().then(function (resp) {
      $scope.dialCodes = resp.data;
    });
    vm.subContractorId = $stateParams.id;

    function getSubContractorDetail() {
      $scope.isLoading = true;
      apiFactory.getSubcontractorById(vm.subContractorId).then(function (resp) {
        $scope.isLoading = false;
        $scope.subContractorData = resp.data;
        $scope.subContractorData.staffs = $scope.subContractorData.staffs || [];
        $scope.FILEIMG = $scope.subContractorData.profilePic;
        $scope.types = $scope.subContractorData.types || [];

        if (resp.data.bankDetails != null && resp.data.bankDetails.length > 0) {
          var bank = resp.data.bankDetails[0];
          $scope.accountHolderName = bank.accountHolderName;
          $scope.accountNumber = bank.accountNumber;
          $scope.IBAN = bank.IBAN;
          $scope.bankName = bank.bankName;
          $scope.bankAddress = bank.bankAddress;
          $scope.sortCode = bank.sortCode;
          $scope.routingNo = bank.routingNo;
          $scope.bicCode = bank.bicCode;
          $scope.ifscCode = bank.ifscCode;
          $scope.routingCode = bank.routingCode;
        }

        if (resp.data.paymentConditions) {
          $scope.paymentTerms = $scope.paymentConditions.filter(function (x) {
            var index = resp.data.paymentConditions.indexOf(x._id);
            return index >= 0;
          });

          if ($scope.paymentTerms.length > 0) {
            $scope.payment = {
              terms: $scope.paymentTerms[0]
            };
          }

          $scope.paymentVat = resp.data.vat;
        }

        $scope.terms = $scope.subContractorData.paymentTerms;

        if ($scope.terms) {
          $scope.terms.paymentSetting = $scope.paymentConditions.find(function (x) {
            return x._id == $scope.terms.paymentSetting;
          });
        }
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
      });
    }

    getSubContractorDetail();

    $scope.onDelete = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Delete Sub-Contractor',
              message: 'Are you want to delete?'
            };
          }
        }
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.deleteSubContractor();
        }
      }, function (reason) {
        vm.onClose();
        $log.info(reason);
      });
    };

    $scope.deleteSubContractor = function () {
      $scope.isLoading = true;
      apiFactory.deleteSubcontractor(vm.subContractorId).then(function () {
        $scope.isLoading = false;
        Notification.success('Sub Contractor deleted successfully');
        $state.go("subContractorsGrid");
        $location.path('/sub-contractors/grid');
      })["catch"](function (e) {
        $scope.isLoading = false;
        $log(e);
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('subContractorsAdd', {
    controller: SubContractorsAddController,
    controllerAs: 'vm',
    templateUrl: 'app/main/subContractors/subContractorsAdd/subContractorsAdd.view.html'
  });
  /** @ngInject */

  function SubContractorsAddController($scope, $state, apiFactory, Notification, globals, utils, $uibModal) {
    var vm = this;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.companyData = companyStore.get();
    $scope.paymentConditions = vm.companyData.paymentConditions;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.staff = {
      mobile: {
        dialCode: null,
        phoneNumber: null
      },
      firstName: null,
      lastName: null,
      email: null
    };
    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    globals.getCountryCode().then(function (resp) {
      vm.countryCodes = resp.data;
      vm.countryCodes = vm.countryCodes.map(function (x) {
        return {
          name: x.name,
          dialCode: x.dialCode,
          code: x.code,
          dialCodeName: "".concat(x.dialCode, " (").concat(x.name, ")")
        };
      });
    });
    /** Types */

    vm.allWorkTypes = [];
    $scope.workTypes = [];
    $scope.workType = undefined;
    apiFactory.listAllWorkTypes().then(function (resp) {
      vm.allWorkTypes = resp.data.list;
    });

    $scope.addWorkType = function () {
      if ($scope.workType) {
        var index = vm.allWorkTypes.findIndex(function (x) {
          return x._id == $scope.workType;
        });

        if (index !== -1) {
          var workType = vm.allWorkTypes[index];
          $scope.workTypes.push(workType);
          vm.allWorkTypes.splice(index, 1);
          $scope.workType = undefined;
        }
      }
    };

    $scope.deleteWorkType = function (index) {
      var result = $scope.workTypes.splice(index, 1);
      vm.allWorkTypes.push(result[0]);
    };

    $scope.staffList = [];

    $scope.addStaff = function (staff) {
      var messages = [];
      var reg = /\S+@\S+\.\S+/;

      if (!reg.test(staff.email)) {
        messages[messages.length] = 'Enter valid email';
      }

      if (!staff.mobile.dialCode) {
        messages[messages.length] = 'Select dial code';
      }

      if (!staff.mobile.phoneNumber || staff.mobile.phoneNumber.length <= 6) {
        messages[messages.length] = 'Enter valid phone number';
      }

      if (utils.isEmpty(staff.firstName)) {
        messages.push('Please input first name');
      }

      if (utils.isEmpty(staff.lastName)) {
        messages.push('Please input last name');
      }

      if (messages.length > 0) {
        messages.forEach(function (v) {
          Notification.error(v);
        });
        return;
      }

      $scope.staffList.push(staff);
      $scope.staff = {
        firstName: null,
        lastName: null,
        email: null,
        mobile: {
          dialCode: null,
          phoneNumber: null
        }
      };
    };

    $scope.removeStaff = function (index) {
      $scope.staffList.splice(index, 1);
    };

    $scope.editStaff = function (_staff) {
      $uibModal.open({
        animation: true,
        component: 'editStaffModal',
        windowClass: 'edit-staff-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          staff: function staff() {
            return _staff;
          }
        }
      }).result.then(function (result) {
        _staff.firstName = result.firstName;
        _staff.lastName = result.lastName;
        _staff.email = result.email;
        _staff.mobile = angular.copy(result.mobile);
      }, function () {});
    };

    $scope.addSubContractor = function () {
      var messages = [];
      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);

      if (angular.isUndefined($scope.SubContractorData) || $scope.SubContractorData === null) {
        Notification.error('Please fill out the required information');
        return;
      }

      if (!$scope.SubContractorData.name) {
        messages[messages.length] = 'Enter Name';
      }

      if (!$scope.SubContractorData.contact || !$scope.SubContractorData.contact.dialCode || !$scope.SubContractorData.contact.phoneNumber) {
        messages[messages.length] = 'Enter Contact Number';
      }

      if (!$scope.SubContractorData.email) {
        messages[messages.length] = 'Enter Email';
      }

      if (!$scope.SubContractorData.address.line1) {
        messages[messages.length] = 'Enter Address';
      }

      if (utils.isEmpty($scope.staffList)) {
        Notification.error("Please add staff at least one");
        return;
      } //add payment data


      if (angular.isUndefined(!$scope.SubContractorData.paymentTerms)) {
        Notification.error('Please select payment terms');
        return;
      }

      if (!$scope.SubContractorData.paymentTerms) {
        Notification.error('Enter Terms');
        return;
      } else {
        if (!$scope.SubContractorData.paymentTerms.paymentSetting) {
          Notification.error('Please select payment setting');
          return;
        }

        if ($scope.SubContractorData.paymentTerms.vatPercent === null || angular.isUndefined($scope.SubContractorData.paymentTerms.vatPercent)) {
          Notification.error('Please input Vat Percent');
          return;
        }

        if (!$scope.SubContractorData.paymentTerms.vatNumber) {
          Notification.error('Please input vatNumber');
          return;
        }
      }

      if (messages.length > 0) {
        messages.forEach(function (v) {
          Notification.error(v);
        });
        return;
      }

      var obj = {
        picFile: $scope.imgAndFiles,
        name: $scope.SubContractorData.name,
        contact: $scope.SubContractorData.contact,
        email: $scope.SubContractorData.email,
        address: $scope.SubContractorData.address,
        paymentTerms: $scope.SubContractorData.paymentTerms,
        types: $scope.workTypes.map(function (x) {
          return x.tagName;
        }),
        staffList: $scope.staffList,
        bankDetails: [{
          accountHolderName: $scope.accountHolderName,
          accountNumber: $scope.accountNumber,
          IBAN: $scope.IBAN,
          bankName: $scope.bankName,
          bankAddress: $scope.bankAddress,
          sortCode: $scope.sortCode,
          routingNo: $scope.routingNo,
          bicCode: $scope.bicCode,
          ifscCode: $scope.ifscCode,
          routingCode: $scope.routingCode
        }]
      };

      if (0 === messages.length) {
        $scope.isLoading = true;
        apiFactory.createNewSubcontractor(obj).then(function () {
          $scope.isLoading = false;
          Notification.success('Subcontractor successfully created');
          $state.go('subContractorsGrid');
        })["catch"](function (e) {
          $scope.isLoading = false;

          if (e.data && e.data.message) {
            Notification.error(e.data.message);
          } else {
            Notification.error("Failed to create subcontractor");
          }
        });
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('warehouses', {
    controller: warehousesController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/warehouses/warehouses.view.html'
  });
  /** @ngInject */

  function warehousesController($scope, globals, apiFactory, Notification, $log, utils, $uibModal) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    vm.warehouses = [];
    $scope.warehouse = {};

    function initData() {
      $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
      // if (vm.userData.designation === 'Admin') {
      //   $scope.SETTING_ACCESS_CREATE = 4;
      // } else {
      //   $scope.loading = true;
      //   apiFactory.getAccessSettingDetails({
      //     dType,
      //     list: [Constants.AccessKey.SETTING]
      //   })
      //     .then(res => {
      //       $scope.loading = false;
      //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
      //     })
      //     .catch(err => {
      //       $scope.loading = false;
      //       $log.error(err);
      //       Notification.error(utils.getErrorMessage(err, 'Something went wrong try later'))
      //     });
      // }

      $scope.loading = true;
      apiFactory.listAllWarehouses().then(function (resp) {
        $scope.loading = false;
        vm.warehouses = resp.data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
      });
    }

    initData();

    $scope.addWarehouse = function () {
      var warehouse = Object.assign({}, $scope.warehouse);

      if (utils.isEmpty(warehouse.name)) {
        Notification.error('Please input a name');
        return;
      }

      if (utils.isEmpty(warehouse.contactPerson)) {
        Notification.error('Please input a contact person');
        return;
      }

      if (utils.isEmpty(warehouse.contactNumber)) {
        Notification.error('Please input a contact number');
        return;
      }

      if (utils.isEmpty(warehouse.address)) {
        Notification.error('Please input an address');
        return;
      }

      $scope.loading = true;
      apiFactory.createWarehouse(warehouse).then(function (resp) {
        $scope.loading = false;
        Notification.success(resp.data.message);
        vm.warehouses.push(resp.data.data);
        $scope.warehouse = {};
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.editWarehouse = function (_warehouse, index) {
      var backup = Object.assign({}, _warehouse);
      $uibModal.open({
        animation: true,
        component: 'editWarehouseModal',
        windowClass: 'editWarehouseModal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          warehouse: function warehouse() {
            return _warehouse;
          }
        }
      }).result.then(function () {
        $scope.loading = true;
        apiFactory.updateWarehouse(_warehouse).then(function (resp) {
          $scope.loading = false;
          Notification.success(resp.data.message);
          vm.warehouses[index] = resp.data.data;
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
          _warehouse.name = backup.name;
          _warehouse.contactPerson = backup.contactPerson;
          _warehouse.contactNumber = backup.contactNumber;
          _warehouse.address = backup.address;
        });
      });
    };

    $scope.deleteWarehouse = function (warehouse, index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.loading = true;
        apiFactory.deleteWarehouse(warehouse._id).then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message);
          vm.warehouses.splice(index, 1);
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      });
    };

    $scope.updateWarehouses = function () {};
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('systemTags', {
    controller: systemTagsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/systemTags/systemTags.view.html'
  });
  /** @ngInject */

  function systemTagsController($scope, apiFactory, $uibModal, Notification, $log, $timeout, utils, globals) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.tagName = undefined;
    $scope.categoryName = undefined;
    $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.SETTING_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.SETTING]
    //   })
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }
    //System tags

    function getAllSystemTags() {
      $scope.loading = true;
      Promise.all([apiFactory.getSystemTags(), apiFactory.getAllMaterialGroup(), apiFactory.getAllEquipmentGroup()]).then(function (resp) {
        $scope.loading = false;
        vm.allSystemTags = resp[0].data.list;
        vm.allMaterialGroups = resp[1].data.data;
        vm.allEquipmentGroups = resp[2].data.data;
        vm.allSystemTags.forEach(function (x) {
          x.tmpTagName = x.tagName;
        });
        vm.allMaterialGroups.forEach(function (x) {
          x.tmpName = x.name;
        });
        vm.allEquipmentGroups.forEach(function (x) {
          x.tmpName = x.name;
        });
      })["catch"](function () {
        $scope.loading = false;
      });
    }

    function updateCatetorySet() {
      $scope.loading = true;
      apiFactory.getCategoriesList().then(function (resp) {
        $scope.loading = false;
        $scope.categoryList = resp.data.list;
        $scope.categoryList.push({
          categoryName: 'Material Group'
        });
        $scope.categoryList.push({
          categoryName: 'Equipment Group'
        });
        getAllSystemTags();
      })["catch"](function () {
        $scope.loading = false;
      });
    }

    updateCatetorySet();
    $scope.categoryList = [];
    $scope.nameList = [{
      item1: 'Supplier Materials',
      item2: 'Category: Supplier'
    }, {
      item1: 'Construction Materials',
      item2: 'Category: Bill'
    }];
    var filterTextTimeout;
    $scope.$watch("categoryName", function () {
      if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
      filterTextTimeout = $timeout(function () {
        if (utils.isEmpty($scope.categoryName)) return;
        $scope.tagName = null;
        $scope.tagValue = null;
        $scope.isLevelCategory = $scope.categoryName === 'Level';
        $scope.isBuildingCategory = $scope.categoryName === 'Building';
      }, 500); // delay 500 ms
    });

    vm.isWritableTag = function (category, systemTag) {
      return !(category.categoryName === 'Level' && (systemTag.tagName === 'Ground' || systemTag.tagName === 'Roof') || category.categoryName === 'Employee' && (systemTag.tagName === 'Driver' || systemTag.tagName === 'Manager' || systemTag.tagName === 'Plumber' || systemTag.tagName === 'Roofer') || category.categoryName === 'Enterprise' && (systemTag.tagName === 'Corporation' || systemTag.tagName === 'Private Limited' || systemTag.tagName === 'Private Sector' || systemTag.tagName === 'Public Sector') || category.categoryName === 'Building' && (systemTag.tagName === 'Factory' || systemTag.tagName === 'Hospital' || systemTag.tagName === 'Office' || systemTag.tagName === 'Shopping') || category.categoryName === 'Work' && (systemTag.tagName === 'Driver' || systemTag.tagName === 'Manager' || systemTag.tagName === 'Plumbing' || systemTag.tagName === 'Roofing') || category.categoryName === 'Weather' && (systemTag.tagName === 'Rain' || systemTag.tagName === 'Snow' || systemTag.tagName === 'Temperature' || systemTag.tagName === 'Wind') || category.categoryName === 'Report' && systemTag.tagName === 'Overflow' || category.categoryName === 'Control Method' && (systemTag.tagName === 'Text' || systemTag.tagName === 'Site Doc' || systemTag.tagName === 'Process Check') || category.categoryName === 'Supplier' && systemTag.tagName === 'Roofing');
    };

    vm.isWritableCategory = function (category) {
      return !(category.categoryName === 'Level' || category.categoryName === 'Employee' || category.categoryName === 'Enterprise' || category.categoryName === 'Building' || category.categoryName === 'Work' || category.categoryName === 'Weather' || category.categoryName === 'Report' || category.categoryName === 'Control Method' || category.categoryName === 'Supplier' || category.categoryName === 'Calculation');
    };

    vm.editCategory = function (_category) {
      $uibModal.open({
        animation: true,
        component: 'editCategoryModal',
        windowClass: 'system-tag-modal',
        resolve: {
          category: function category() {
            return _category;
          }
        }
      }).result.then(function (result) {
        var category = $scope.categoryList.find(function (category) {
          return category._id === result._id;
        });

        if (angular.isDefined(category)) {
          category.categoryName = result.categoryName;
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.deleteCategory = function (category) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.loading = true;
        apiFactory.deleteCategory(category._id).then(function () {
          $scope.loading = false;
          Notification.success("system category deleted successfully.");
          updateCatetorySet();
        })["catch"](function () {
          $scope.loading = false;
          Notification.error("Something went wrong");
        });
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.editSystemTag = function (_tag) {
      var buildingCategory = $scope.categoryList.find(function (c) {
        return c.categoryName === 'Building';
      });
      var isBuildingCategory = buildingCategory._id === _tag.categoryId;

      if (isBuildingCategory) {
        var workCategory = $scope.categoryList.find(function (c) {
          return c.categoryName === 'Work';
        });

        if (angular.isUndefined(buildingCategory)) {
          Notification.error('Not exists building category. Please create the category first.');
          return;
        }

        if (angular.isUndefined(workCategory)) {
          Notification.error('Not exists work category. Please create the category first.');
          return;
        }

        $uibModal.open({
          animation: true,
          component: 'buildingTagModal',
          windowClass: 'system-tag-modal',
          resolve: {
            tag: function tag() {
              return _tag;
            },
            workTags: function workTags() {
              return vm.allSystemTags.filter(function (tag) {
                return tag.categoryId === workCategory._id;
              });
            }
          }
        }).result.then(function () {
          getAllSystemTags();
        }, function (reason) {
          $log.log(reason);
        });
      } else {
        $uibModal.open({
          animation: true,
          component: 'editTagModal',
          windowClass: 'system-tag-modal',
          resolve: {
            tag: function tag() {
              return _tag;
            },
            category: function category() {
              return $scope.categoryList.find(function (c) {
                return c._id === _tag.categoryId;
              });
            }
          }
        }).result.then(function (result) {
          var tag = vm.allSystemTags.find(function (tag) {
            return tag._id === result._id;
          });

          if (angular.isDefined(tag)) {
            tag.tagName = result.tagName;
            tag.tagValue = result.tagValue;
          }
        }, function (reason) {
          $log.log(reason);
        });
      }
    };

    vm.updateSystemTag = function (tag) {
      if (utils.isEmpty(tag.tmpTagName)) {
        Notification.error('Tag Name cannot be empty');
        return;
      }

      $scope.loading = true;
      apiFactory.updateSystemTag({
        _id: tag._id,
        tagName: tag.tmpTagName
      }).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        tag.tagName = angular.copy(tag.tmpTagName);
        tag.isEditMode = false;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.deleteSystemTag = function (tag) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        var category = $scope.categoryList.find(function (elem) {
          return elem._id === tag.categoryId;
        });
        var apis = [apiFactory.deleteSystemTag(tag._id)];

        if (category.categoryName === 'Building') {
          apis.push(apiFactory.deleteWorkPattern(tag._id));
        }

        $scope.loading = true;
        Promise.all(apis).then(function () {
          $scope.loading = false;
          Notification.success("System tag deleted successfully.");
          var index = vm.allSystemTags.indexOf(tag);
          vm.allSystemTags.splice(index, 1);
        })["catch"](function () {
          $scope.loading = false;
          Notification.error("Something went wrong");
        });
      }, function (reason) {
        $log.info(reason);
      });
    };

    function validate() {
      if (utils.isEmpty($scope.tagName)) {
        Notification.error("please enter Tag name");
        return false;
      }

      if (utils.isEmpty($scope.categoryName)) {
        Notification.error("please enter Category name");
        return false;
      }

      return true;
    }

    function paddingItems(workTags) {
      var items = [];
      workTags.forEach(function (workTag) {
        items.push({
          tagId: workTag._id,
          tagName: workTag.tagName,
          percentage: 100
        });
      });
      return items;
    }

    vm.createTag = function () {
      if (!validate()) {
        return;
      }

      var category = $scope.categoryList.find(function (elem) {
        return elem.categoryName === $scope.categoryName;
      });

      if (utils.isEmpty(category)) {
        var systemTag = {
          tagName: $scope.tagName,
          categoryName: $scope.categoryName
        };
        $scope.loading = true;
        apiFactory.createSystemTag(systemTag).then(function () {
          $scope.loading = false;
          Notification.success("new system tag added.");
          $scope.tagName = "";
          $scope.categoryName = "";
          $scope.tagValue = "";
          updateCatetorySet();
        })["catch"](function () {
          $scope.loading = false;
          Notification.error("something went wrong");
        });
      } else {
        if (category.categoryName === 'Material Group' || category.categoryName === 'Equipment Group') {
          var endpoint = category.categoryName === 'Material Group' ? apiFactory.createMaterialGroup({
            name: $scope.tagName
          }) : apiFactory.createEquipmentGroup({
            name: $scope.tagName
          });
          $scope.loading = true;
          endpoint.then(function (res) {
            $scope.loading = false;
            Notification.success(res.data.message);
            $scope.tagName = "";
            $scope.categoryName = "";
            $scope.tagValue = "";
            getAllSystemTags();
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        } else {
          var find = vm.allSystemTags.find(function (elem) {
            return elem.categoryId === category._id && elem.tagName === $scope.tagName;
          });

          if (find) {
            Notification.error("Already exist tag with the name");
            return false;
          }

          if ($scope.isLevelCategory) {
            if (utils.isEmpty($scope.tagValue)) {
              Notification.error("please enter Tag value");
              return false;
            }

            var _find = vm.allSystemTags.find(function (elem) {
              return elem.categoryId === category._id && elem.tagValue === $scope.tagValue;
            });

            if (angular.isDefined(_find)) {
              Notification.error("already exist tag with the value");
              return false;
            }
          }

          var _systemTag = {
            tagName: $scope.tagName,
            categoryId: category._id
          };

          if ($scope.isLevelCategory) {
            _systemTag.tagValue = $scope.tagValue;
          }

          if ($scope.isBuildingCategory) {
            var workCategory = $scope.categoryList.find(function (c) {
              return c.categoryName === 'Work';
            });

            if (angular.isUndefined(workCategory)) {
              Notification.error('Not exists work category. Please create the category first.');
              return;
            }

            $scope.loading = true;
            apiFactory.createSystemTag(_systemTag).then(function (res) {
              $scope.loading = false;
              Notification.success(res.data.message || 'Created building tag successfully');
              var createdTag = res.data.data;
              var workTags = vm.allSystemTags.filter(function (tag) {
                return tag.categoryId === workCategory._id;
              });
              var items = paddingItems(workTags);
              var pattern = {
                tagId: createdTag._id,
                items: items
              };
              $scope.loading = true;
              apiFactory.createWorkPattern(pattern).then(function (res) {
                $scope.loading = false;
                Notification.success(res.data.message || 'Created work pattern successfully');
                getAllSystemTags();
              })["catch"](function (err) {
                Notification.error(err.data.message || 'Something went wrong');
              });
            })["catch"](function () {
              $scope.loading = false;
              Notification.error("Something went wrong");
            });
          } else {
            $scope.loading = true;
            apiFactory.createSystemTag(_systemTag).then(function () {
              $scope.loading = false;
              Notification.success("new system tag added.");
              $scope.tagName = "";
              $scope.categoryName = "";
              $scope.tagValue = "";
              getAllSystemTags();
            })["catch"](function () {
              $scope.loading = false;
              Notification.error("something went wrong");
            });
          }
        }
      }
    };

    function deleteGroup(id, type) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        var endpoint = type === 'Material Group' ? apiFactory.deleteMaterialGroup(id) : apiFactory.deleteEquipmentGroup(id);
        $scope.loading = true;
        endpoint.then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message);
          getAllSystemTags();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }, function () {});
    }

    vm.deleteMaterialGroup = function (id) {
      deleteGroup(id, 'Material Group');
    };

    vm.deleteEquipmentGroup = function (id) {
      deleteGroup(id, 'Equipment Group');
    };

    vm.updateMaterialGroup = function (matGroup) {
      if (utils.isEmpty(matGroup.tmpName)) {
        Notification.error('Tag Name cannot be empty');
        return;
      }

      $scope.loading = true;
      apiFactory.updateMaterialGroup(matGroup).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        matGroup.name = matGroup.tmpName;
        matGroup.isEditMode = false;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.updateEquipmentGroup = function (equGroup) {
      if (utils.isEmpty(equGroup.tmpName)) {
        Notification.error('Tag Name cannot be empty');
        return;
      }

      $scope.loading = true;
      apiFactory.updateEquipmentGroup(equGroup).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        equGroup.name = equGroup.tmpName;
        equGroup.isEditMode = false;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.cancelEditSystemTag = function (systemTag) {
      systemTag.tmpTagName = systemTag.tagName;
      systemTag.isEditMode = false;
    };

    vm.cancelEditMatGroup = function (matGroup) {
      matGroup.tmpName = matGroup.name;
      matGroup.isEditMode = false;
    };

    vm.cancelEditEquGroup = function (equGroup) {
      equGroup.tmpName = equGroup.name;
      equGroup.isEditMode = false;
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('settingsGeneral', {
    controller: SettingsGeneralController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/settingsGeneral/settingsGeneral.view.html'
  });
  /** @ngInject */

  function SettingsGeneralController($scope, $log, globals, apiFactory, Notification, $translate, utils, localStorageService) {
    var vm = this;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.SETTING_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.SETTING]
    //   })
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.companyData = companyStore.get();
    $scope.settingGeneral = {
      chosenLanguage: null,
      chosenCompanyCurrency: null,
      smsEnabled: false,
      emailEnabled: false,
      timeShowMethod: '24 hr'
    };
    globals.getCurrency().then(function (resp) {
      vm.currencies = resp.data;
      vm.currenciesList = vm.currencies.map(function (c) {
        return {
          cc: c.cc,
          label: c.cc + ' - ' + c.name,
          symbol: c.symbol
        };
      });
      /* get company currency */

      if (vm.companyData && "currentCurrency" in vm.companyData) {
        var find = vm.currenciesList.find(function (c) {
          return c.cc == vm.companyData.currentCurrency.currencyCode;
        });

        if (find) {
          $scope.settingGeneral.chosenCompanyCurrency = {
            label: find.label,
            cc: find.cc,
            symbol: find.symbol
          };
        }
      }
    });
    vm.languages = [{
      key: "EN",
      label: 'English'
    }, {
      key: "DK",
      label: 'Danish'
    }];

    vm.onChangeLanguage = function () {
      if ($scope.settingGeneral.chosenLanguage.key == 'EN') {
        localStorageService.set('lang', 'en');
        $translate.use('en');
      } else if ($scope.settingGeneral.chosenLanguage.key == 'DK') {
        localStorageService.set('lang', 'da');
        $translate.use('da');
      }
    };

    vm.getCompanyLanguage = function () {
      $scope.settingGeneral.chosenLanguage = {};

      if (vm.companyData) {
        if (vm.companyData.language == 'DK') {
          $scope.settingGeneral.chosenLanguage.label = 'Danish';
          $scope.settingGeneral.chosenLanguage.key = 'DK';
        } else {
          $scope.settingGeneral.chosenLanguage.label = 'English';
          $scope.settingGeneral.chosenLanguage.key = 'EN';
        }

        vm.onChangeLanguage();
      }
    };

    vm.getCompanyLanguage();
    vm.inputMethods = [{
      key: "European et al.",
      label: "European et al."
    }, {
      key: "British/American et al.",
      label: "British/American et al."
    }];
    vm.timeShowMethods = [{
      label: '24 hr',
      value: '24 hr'
    }, {
      label: '12 hr',
      value: '12 hr'
    }];

    if (vm.companyData) {
      if (!vm.companyData.companyInputMethod) {
        $scope.settingGeneral.chosenInputMethod = "British/American et al.";
      } else {
        $scope.settingGeneral.chosenInputMethod = vm.companyData.companyInputMethod;
      }
    }

    $scope.settingGeneral.smsEnabled = vm.companyData ? vm.companyData.smsNotification : false;
    $scope.settingGeneral.emailEnabled = vm.companyData ? vm.companyData.emailNotification : false;
    $scope.settingGeneral.timeShowMethod = vm.companyData && !utils.isEmpty(vm.companyData.timeShowMethod) ? vm.companyData.timeShowMethod : '24 hr';

    $scope.onSave = function () {
      $scope.isEdit = false;
      var payload = {
        currentCurrency: vm.companyData.currentCurrency,
        language: $scope.settingGeneral.chosenLanguage.key,
        companyInputMethod: $scope.settingGeneral.chosenInputMethod,
        timeShowMethod: $scope.settingGeneral.timeShowMethod,
        smsNotification: $scope.settingGeneral.smsEnabled,
        emailNotification: $scope.settingGeneral.emailEnabled
      };

      if ($scope.settingGeneral.chosenCompanyCurrency.cc) {
        var currency = vm.currenciesList.find(function (item) {
          return item.cc === $scope.settingGeneral.chosenCompanyCurrency.cc;
        });
        $scope.settingGeneral.chosenCompanyCurrency.label = currency.label;

        if (payload.currentCurrency && payload.currentCurrency.currencyCode) {
          payload.currentCurrency.currencyCode = currency.cc;
          payload.currentCurrency.symbol = currency.symbol;
        } else {
          payload.currentCurrency = {
            currencyCode: $scope.settingGeneral.chosenCompanyCurrency.cc,
            symbol: $scope.settingGeneral.chosenCompanyCurrency.symbol
          };
        }
      }

      $scope.loading = true;
      apiFactory.updateCompanyById(vm.companyData._id, payload).then(function (resp) {
        $scope.loading = false;
        Notification.success("General setting updated successfully");
        companyStore.set(resp.data);
        vm.companyData = resp.data;
        $scope.settingGeneral.chosenCompanyCurrency.label = vm.currenciesList.find(function (item) {
          return item.cc == vm.companyData.currentCurrency.currencyCode;
        }).label;

        if (vm.companyData.language == 'DK') {
          $scope.settingGeneral.chosenLanguage.label = 'Danish';
          $scope.settingGeneral.chosenLanguage.key = 'DK';
        } else {
          $scope.settingGeneral.chosenLanguage.label = 'English';
          $scope.settingGeneral.chosenLanguage.key = 'EN';
        }

        vm.onChangeLanguage();
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);
        Notification.error(utils.getErrorMessage(e));
      });
    };

    $scope.editSetting = function () {
      $scope.isEdit = true;
    };

    $scope.exitEdit = function () {
      $scope.isEdit = false;
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('settingCtrlPlan', {
    controller: settingCtrlPlanController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/settingCtrlPlan/settingCtrlPlan.view.html'
  });
  /** @ngInject */

  function settingCtrlPlanController(globals, $uibModal, $scope, $log, Notification, apiFactory) {
    var vm = this;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.SETTING_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.SETTING]
    //   })
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.companyData = companyStore.get();
    vm.companyControlPlans = vm.companyData.controlPlans; //Control Plan settings

    vm.isControlPlanItemEditing = -1;

    vm.controlPlanItemEdit = function (item) {
      item.isEdit = true;
    };

    vm.completeEdit = function (item) {
      item.isEdit = false;
    };

    $scope.newPlanName = null;

    $scope.deleteItem = function (index) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        vm.companyControlPlans.splice(index, 1);
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.addCtrlPlan = function () {
      if ($scope.newPlanName) {
        var newItem = {
          name: $scope.newPlanName,
          visibility: true
        };
        vm.companyControlPlans.push(newItem);
        $scope.newPlanName = null;
      }
    };

    $scope.onSave = function () {
      $scope.loading = true;
      apiFactory.setControlPlanForCompany(vm.companyControlPlans).then(function (resp) {
        $scope.loading = false;
        Notification.success("Company settings updated.");
        var updatedData = Object.assign(companyStore.get(), {
          controlPlans: resp.data.data
        });
        companyStore.set(updatedData);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error("couldn't set default control plan'd columns.");
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('segments', {
    controller: segmentsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/segments/segments.view.html'
  });

  function segmentsController($scope, globals, apiFactory, Notification, $log, utils, $uibModal, $timeout) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.periods = [{
      id: '5',
      name: '5'
    }, {
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '50',
      name: '50'
    }];
    $scope.departments = [];
    $scope.selectedAll = false;
    vm.currentPage = 1;
    $scope.totalCount = 0;
    $scope.numPerPage = 5;

    $scope.fetchDepartments = function () {
      $scope.loading = true;
      apiFactory.fetchDepartments({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        // search: vm.searchText,
        sort: 'updatedAt',
        sortType: "false"
      }).then(function (res) {
        $scope.loading = false;
        $scope.departments = res.data.list;
        $scope.totalCount = res.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
      });
    };

    function initData() {
      $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
      // if (vm.userData.designation === 'Admin') {
      //   $scope.SETTING_ACCESS_CREATE = 4;
      // } else {
      //   $scope.loading = true;
      //   apiFactory.getAccessSettingDetails({
      //     dType,
      //     list: [Constants.AccessKey.SETTING]
      //   })
      //     .then(res => {
      //       $scope.loading = false;
      //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
      //     })
      //     .catch(err => {
      //       $scope.loading = false;
      //       $log.error(err);
      //       Notification.error(utils.getErrorMessage(err, 'Something went wrong try later'))
      //     });
      // }

      $scope.fetchDepartments();
    }

    initData();

    $scope.addDepartment = function () {
      var modal = $uibModal.open({
        animation: true,
        component: 'addDepartmentModal',
        windowClass: 'addDepartmentModal',
        backdrop: 'static',
        keyboard: false
      });
      modal.result.then(function (result) {
        $log.log(result);
        $scope.fetchDepartments();
      });
    };

    $scope.editDepartment = function (_department, index) {
      var modal = $uibModal.open({
        animation: true,
        component: 'addDepartmentModal',
        windowClass: 'addDepartmentModal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          department: function department() {
            return _department;
          }
        }
      });
      modal.result.then(function (result) {
        $scope.departments[index] = result;
      });
    };

    $scope.deleteDepartment = function (id, index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.loading = true;
        apiFactory.deleteDepartment(id).then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message);
          $scope.departments.splice(index, 1);
          $scope.totalCount--;
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      });
    };

    $scope.selectAll = function (selectedAll) {
      $scope.selectedAll = selectedAll;
      $scope.departments.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
      $timeout(function () {
        $scope.$apply();
      });
    };

    $scope.selectDepartment = function () {
      $scope.selectedAll = false;
      $timeout(function () {
        $scope.$apply();
      });
    };

    $scope.deleteDepartments = function () {
      var departments = $scope.departments.filter(function (x) {
        return x.selected;
      });

      if (utils.isEmpty(departments)) {
        Notification.error('Please select departments to delete');
        return;
      }

      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        var promises = [];

        var _iterator = _createForOfIteratorHelper(departments),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var department = _step.value;
            promises.push(apiFactory.deleteDepartment(department._id));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $scope.loading = true;
        Promise.all(promises).then(function () {
          $scope.loading = false;
          Notification.success('Deleted the departments successfully');
          $scope.fetchDepartments();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      });
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchDepartments();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('paymentTerms', {
    controller: paymentTermsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/paymentTerms/paymentTerms.view.html'
  });
  /** @ngInject */

  function paymentTermsController($scope, $log, globals, Notification, apiFactory, utils) {
    var vm = this;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.SETTING_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.SETTING]})
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.companyData = companyStore.get();
    vm.paymentConditions = angular.copy(vm.companyData.paymentConditions);
    $scope.category = 'noData';
    $scope.categoryList = [{
      key: 'noData',
      label: 'No Data'
    }];
    $scope.nameList = ['CM+20D', 'CQ+15D', 'D15'];
    $scope.paymentItem = {
      code: '',
      description: '',
      formula: ''
    };

    $scope.addPaymentTerm = function () {
      if ($scope.paymentItem.code) {
        vm.paymentConditions.push($scope.paymentItem);
        $scope.paymentItem = {
          code: '',
          description: ''
        };
        $scope.onSave();
      }
    };

    $scope.removePaymentItem = function (item) {
      var index = vm.paymentConditions.indexOf(item);
      vm.paymentConditions.splice(index, 1);
    };

    $scope.onSave = function () {
      $scope.loading = true;
      apiFactory.createPaymentTerm(vm.paymentConditions).then(function (resp) {
        $scope.loading = false;
        Notification.success("Payment term created successfully");
        vm.paymentConditions = resp.data.data;
        var updatedData = Object.assign(companyStore.get(), {
          paymentConditions: vm.paymentConditions
        });
        companyStore.set(updatedData);
        $scope.paymentItem = {
          code: '',
          description: '',
          formula: ''
        };
      })["catch"](function (e) {
        $scope.loading = false;
        $log.info(e);
        Notification.error(utils.getErrorMessage(e));
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('manageSettings', {
    controller: ManageSettingsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/manageSettings/manageSettings.view.html'
  });
  /** @ngInject */

  function ManageSettingsController($scope, apiFactory, globals, $uibModal, $log, utils, Notification) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.SETTING_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.SETTING]
    //   })
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.periods = [{
      id: '5',
      name: '5'
    }, {
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '50',
      name: '50'
    }];
    $scope.numPerPage = 5;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.currentPage = 1;
    $scope.totalCount = 0;
    $scope.dashboardTypes = globals.getManagerList();
    $scope.category = 'noData';
    $scope.categoryList = [{
      key: 'noData',
      label: 'No Data'
    }];
    vm.designationList = [];
    vm.departmentList = [];
    Promise.all([apiFactory.getDepartments()]).then(function (data) {
      vm.departmentList = data[0].data.data.map(function (item) {
        return {
          _id: item,
          name: item
        };
      });
      vm.getManagers();
    })["catch"](function () {
      Notification.error("Couldn't load data.");
    });

    vm.getManagers = function () {
      $scope.loading = true;
      apiFactory.listAllManagers({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText
      }).then(function (resp) {
        $scope.loading = false;
        $scope.currentPage = vm.currentPage;
        vm.allManagers = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function () {
        $scope.loading = false;
      });
    };

    $scope.openModal = function (manager) {
      var createEditManagerModal = $uibModal.open({
        animation: true,
        // size: 'sm',
        component: 'editManager',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              employeeName: manager.displayName,
              department: manager.department,
              subDesignation: manager.subDesignation,
              dashboard: manager.dashboard,
              departmentList: vm.departmentList,
              designationList: vm.designationList,
              id: manager._id
            };
          }
        }
      });
      createEditManagerModal.result.then(function () {
        vm.getManagers();
      }, function (reason) {
        $log.info(reason); // console.log(reason);
      });
    };

    $scope.editManager = function (manager) {
      $scope.loading = true;
      apiFactory.getDesignations().then(function (resp) {
        $scope.loading = false;
        vm.designationList = resp.data.data.map(function (item) {
          return {
            _id: item,
            name: item
          };
        });
        $scope.openModal(manager);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.deleteManager = function (id) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.loading = true;
          apiFactory.deleteManager(id).then(function () {
            $scope.loading = false;
            vm.getManagers();
            Notification.success('Manager deleted successfully');
          }, function () {
            $scope.loading = false;
            Notification.error('Something went wrong try later');
          })["catch"](function () {
            $scope.loading = false;
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.getDashboardType = function (type) {
      if (angular.isUndefined(type)) return "";
      var find = $scope.dashboardTypes.find(function (elem) {
        return elem.dashboardType === type;
      });

      if (find) {
        return find.name;
      } else {
        return "";
      }
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.getManagers();
    };

    $scope.getColor = function (name) {
      return globals.getAvatarColor(name);
    };
  }
})();


"use strict";

(function () {
  angular.module('app.settings').component('integrationLogs', {
    controller: integrationLogs,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/integrationLogs/integrationLogs.view.html'
  });
  /** @ngInject */

  function integrationLogs($scope, $log, apiFactory) {
    var vm = this;
    $scope.numPerPage = 12;
    $scope.noOfPages = 1;
    vm.currentPage = 1;
    vm.logs = [];
    $scope.totalCount = 0;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.isLoading = false;

    vm.nextPage = function () {
      $scope.isLoading = true;
      apiFactory.companyEconomicIntegrationLogs(vm.currentPage, $scope.numPerPage).then(function (res) {
        $scope.isLoading = false;
        vm.logs = res.data.list;
        $scope.totalCount = res.data.totalCount;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    vm.nextPage();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.nextPage();
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      vm.modalInstance.close();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('externalEconomic', {
    controller: externalEconomicController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/externalEconomic/externalEconomic.view.html'
  });
  /** @ngInject */

  function externalEconomicController($scope, $uibModal, $log, apiFactory, globals, Notification) {
    var vm = this;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.companyData = companyStore.get();
    vm.userData = userStore.get();
    vm.defaultPeriodId = null;
    vm.paymentTerms = vm.companyData.paymentConditions ? vm.companyData.paymentConditions : [];
    vm.economicTypeOptions = [{
      id: 'NAV',
      name: 'NAV'
    }];
    vm.typeMappingOptions = [{
      value: "GLAccount",
      name: "GLAccount"
    }, {
      value: "Item",
      name: "Item"
    }, {
      value: "Resource",
      name: "Resource"
    }, {
      value: "NoSync",
      name: "NoSync"
    }];
    vm.syncOptions = [{
      value: "NoSync",
      name: "NoSync"
    }, {
      value: "Daily",
      name: "Daily"
    }, {
      value: "Weekly",
      name: "Weekly"
    }, {
      value: "Monthly",
      name: "Monthly"
    }];
    vm.vatPeriodOptions = [{
      label: "Monthly",
      value: "month1"
    }, {
      label: "2 Month",
      value: "month2"
    }, {
      label: "3 Month",
      value: "month3"
    }, {
      label: "6 Month",
      value: "month6"
    }, {
      label: "12 Month",
      value: "month12"
    }];
    vm.activeOptions = [{
      label: "Yes",
      value: true
    }, {
      label: "No",
      value: false
    }];
    vm.vatPeriod = "month1";
    $scope.paymentCode = null;
    $scope.externCode = null;
    vm.externAddedCodes = [];
    vm.externalCredential = {
      systemType: 'NAV',
      credentials: {
        userName: "svc_nav_CE3469",
        password: "AlvorligHukommelse79",
        apiUrl: "https://ce3469.navisionhosting.nu:7057/EndUserNavCert/WS/Testregnskab%20WIG/Codeunit/CloudES",
        domain: "",
        apiId: "1234",
        apiKey: "Q3#Kp1_iT",
        isActive: true
      },
      paymentTerms: [],
      typeMapping: {},
      naviExport: {
        invoiceSyncFrequency: 'NoSync',
        billingSyncFrquency: 'NoSync',
        isInvSyncJobEnabled: false,
        isBillSyncJobEnabled: false
      }
    };
    vm.serviceCars = [];
    vm.isEdit = false;
    vm.balancePeriodList = [];
    vm.fromAccountDate = new Date();
    vm.toAccountDate = new Date();
    vm.fromAccountDate.setFullYear(vm.fromAccountDate.getFullYear() - 1);

    $scope.buildBalancePeriodList = function () {
      vm.balancePeriodList.forEach(function (x) {
        x.start = new Date(x.start);
        x.end = new Date(x.end);
      });
      var defaultPeriod = vm.balancePeriodList.find(function (x) {
        return x["default"] == true;
      });
      if (!defaultPeriod) defaultPeriod = vm.balancePeriodList[0];
      if (defaultPeriod) vm.defaultPeriodId = defaultPeriod._id;
    };

    $scope.isLoading = false;
    Promise.all([apiFactory.getCompanyExternalEconomics(), apiFactory.getEconomicSettingInvoiceItems(), apiFactory.getEconomicSetting(), apiFactory.getEconomicBalanceSetting()]).then(function (resp) {
      var externalData = resp[0].data.data;

      if (externalData) {
        vm.externalCredential = {
          systemType: 'NAV',
          credentials: externalData.naviCreds ? externalData.naviCreds : {},
          paymentTerms: externalData.naviPayTerms ? externalData.naviPayTerms : [],
          typeMapping: externalData.naviTypeMapping ? externalData.naviTypeMapping : {},
          naviExport: {
            invoiceSyncFrequency: externalData.naviExport ? externalData.naviExport.invoiceSyncFrequency : 'NoSync',
            billingSyncFrquency: externalData.naviExport ? externalData.naviExport.billingSyncFrquency : 'NoSync',
            isInvSyncJobEnabled: externalData.naviExport ? externalData.naviExport.isInvSyncJobEnabled : false,
            isBillSyncJobEnabled: externalData.naviExport ? externalData.naviExport.isBillSyncJobEnabled : false,
            invSyncNextInvocation: externalData.naviExport ? externalData.naviExport.invSyncNextInvocation : undefined,
            billSyncNextInvocation: externalData.naviExport ? externalData.naviExport.billSyncNextInvocation : undefined
          }
        };
      }

      var accountPlanSubItems = resp[1].data.data;
      vm.serviceCars = accountPlanSubItems.filter(function (item) {
        return item.category === "ServiceCar";
      });
      var economicSetting = resp[2].data.data;

      if (economicSetting) {
        if (economicSetting.fromAccountDate) {
          vm.fromAccountDate = new Date(economicSetting.fromAccountDate);
        }

        if (economicSetting.toAccountDate) {
          vm.toAccountDate = new Date(economicSetting.toAccountDate);
        }

        vm.vatPeriod = economicSetting.vatPeriod;
      }

      vm.balancePeriodList = resp[3].data.list;
      $scope.buildBalancePeriodList();
    })["catch"](function (err) {
      $log.error(err);
    });

    vm.selectPaymentCode = function (code) {
      $log.info(code); // let paymentItem = vm.paymentTerms.find(it => it.code == code);
      // $scope.codeDescription = paymentItem.description;
    };

    $scope.onUnlockPeriod = function (period) {
      $scope.isLoading = true;
      period.locked = false;
      apiFactory.updateEconomicBalanceSetting(period).then(function () {
        Notification.success("Succeed to save.");
        apiFactory.getEconomicBalanceSetting().then(function (resp) {
          vm.balancePeriodList = resp.data.list;
          $scope.buildBalancePeriodList();
          $scope.isLoading = false;
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error('Failed to save.');
      });
    };

    $scope.onLockPeriod = function (period) {
      $scope.isLoading = true;
      period.locked = true;
      apiFactory.updateEconomicBalanceSetting(period).then(function () {
        Notification.success("Succeed to save.");
        apiFactory.getEconomicBalanceSetting().then(function (resp) {
          vm.balancePeriodList = resp.data.list;
          $scope.buildBalancePeriodList();
          $scope.isLoading = false;
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error('Failed to save.');
      });
    };

    $scope.onUpdateDefaultPeriod = function (id) {
      $scope.isLoading = true;
      apiFactory.setDefaultEconomicBalanceSetting({
        _id: id
      }).then(function () {
        Notification.success("Succeed to save.");
        apiFactory.getEconomicBalanceSetting().then(function (resp) {
          vm.balancePeriodList = resp.data.list;
          $scope.buildBalancePeriodList();
          $scope.isLoading = false;
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error('Failed to save.');
      });
    };

    $scope.onSaveBalancePeriod = function (period) {
      $scope.isLoading = true;

      if (period._id) {
        apiFactory.updateEconomicBalanceSetting(period).then(function () {
          Notification.success("Succeed to save.");
          apiFactory.getEconomicBalanceSetting().then(function (resp) {
            vm.balancePeriodList = resp.data.list;
            $scope.buildBalancePeriodList();
            $scope.isLoading = false;
          });
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error('Failed to save.');
        });
      } else {
        apiFactory.createEconomicBalanceSetting(period).then(function () {
          Notification.success("Succeed to save.");
          apiFactory.getEconomicBalanceSetting().then(function (resp) {
            vm.balancePeriodList = resp.data.list;
            $scope.buildBalancePeriodList();
            $scope.isLoading = false;
          });
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error('Failed to save.');
        });
      }
    };

    $scope.onDeleteBalancePeriod = function (period) {
      $scope.isLoading = true;
      apiFactory.deleteEconomicBalanceSetting(period._id).then(function () {
        Notification.success("Succeed to delete.");
        apiFactory.getEconomicBalanceSetting().then(function (resp) {
          vm.balancePeriodList = resp.data.list;
          $scope.buildBalancePeriodList();
          $scope.isLoading = false;
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error('Failed to delete.');
      });
    };

    $scope.addBalancePeriod = function () {
      vm.balancePeriodList.push({
        year: '',
        start: new Date(),
        end: new Date(),
        editing: true
      });
    };

    $scope.addExternCode = function (paymentCodeId, externCode) {
      if (paymentCodeId && externCode) {
        var paymentCode = vm.paymentTerms.find(function (it) {
          return it._id == paymentCodeId;
        });
        vm.externalCredential.paymentTerms.push({
          cesId: paymentCode._id,
          cesCode: paymentCode.code,
          externCode: externCode
        });
      }
    };

    $scope.removeExternCode = function (item) {
      var index = vm.externalCredential.paymentTerms.indexOf(item);
      vm.externalCredential.paymentTerms.splice(index, 1);
    };

    vm.showInvoiceLogs = function () {
      $uibModal.open({
        animation: true,
        component: 'externalLogsModal',
        windowClass: 'eco-external-logs-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          isInvoice: function isInvoice() {
            return true;
          }
        }
      }).result.then(function () {}, function (reason) {
        $log.info(reason);
      });
    };

    vm.showBillingLogs = function () {
      $uibModal.open({
        animation: true,
        component: 'externalLogsModal',
        windowClass: 'eco-external-logs-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          isInvoice: function isInvoice() {
            return false;
          }
        }
      }).result.then(function () {}, function (reason) {
        $log.info(reason);
      });
    };

    vm.saveExternalCredential = function () {
      if (!vm.externalCredential.systemType) {
        Notification.error('Economic Type is required.');
        return;
      }

      if (!vm.externalCredential.credentials.userName) {
        Notification.error('Username is required.');
        return;
      }

      if (!vm.externalCredential.credentials.password) {
        Notification.error('Password is required.');
        return;
      }

      if (!vm.externalCredential.credentials.apiUrl) {
        Notification.error('Api Url is required.');
        return;
      }

      if (!vm.externalCredential.credentials.apiKey) {
        Notification.error('Api Key is required.');
        return;
      }

      if (!vm.externalCredential.credentials.apiId) {
        Notification.error('Api ID is required.');
        return;
      }

      if (!vm.externalCredential.naviExport.invoiceSyncFrequency) {
        Notification.error('Please select invoice sync option.');
        return;
      }

      if (!vm.externalCredential.naviExport.billingSyncFrquency) {
        Notification.error('Please select billing sync option.');
        return;
      }

      apiFactory.updateExternalEconomics(vm.externalCredential).then(function (resp) {
        Notification.success(resp.data.message);
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Failed to save external economic credentials");
      });
    };

    vm.syncInvoice = function () {
      apiFactory.updateExternalInvoices().then(function (resp) {
        Notification.success(resp.data.message);
      })["catch"](function (err) {
        $log.error(err);
        Notification.error('Failed to sync.');
      });
    };

    vm.syncBilling = function () {
      apiFactory.updateExternalBillings().then(function (resp) {
        Notification.success(resp.data.message);
      })["catch"](function (err) {
        $log.error(err);
        Notification.error('Failed to sync.');
      });
    };

    vm.saveAccountDate = function () {
      if (!vm.fromAccountDate || !vm.toAccountDate) {
        Notification.error("Please input date.");
        return;
      }

      if (vm.fromAccountDate > vm.toAccountDate) {
        Notification.error("Please input date correctly.");
        return;
      }

      if (!vm.vatPeriod) {
        Notification.error("Please select VAT period.");
        return;
      }

      apiFactory.saveEconomicSetting({
        fromAccountDate: vm.fromAccountDate,
        toAccountDate: vm.toAccountDate,
        vatPeriod: vm.vatPeriod
      }).then(function () {
        Notification.success("Succeed to save.");
      })["catch"](function (err) {
        $log.error(err);
        Notification.error('Failed to save.');
      });
    };

    vm.exportAccountNetChange = function () {
      $uibModal.open({
        animation: true,
        component: 'exportNetChangeModal',
        windowClass: 'exportNetChangeModal'
      }).result.then(function (result) {
        $scope.isLoading = true;
        apiFactory.glAccountsNetChange(result).then(function (resp) {
          $scope.isLoading = false;
          showAccountNetChanges(resp.data.glAccounts);
        })["catch"](function (err) {
          $log.error(err);
          $scope.isLoading = false;
          Notification.error('Cannot get accounts net change.');
        });
      });
    };

    function showAccountNetChanges(_accounts) {
      $uibModal.open({
        animation: true,
        component: 'accountNetChangesModal',
        windowClass: 'accountNetChangesModal',
        backdrop: 'static',
        resolve: {
          accounts: function accounts() {
            return _accounts;
          }
        }
      });
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('entityKeys', {
    controller: entityKeysController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/entityKeys/entityKeys.view.html'
  });
  /** @ngInject */

  function entityKeysController($scope, $log, $uibModal, apiFactory, globals) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.SETTING_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.SETTING]
    //   })
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.getTags = function () {
      $scope.loading = true;
      apiFactory.getAllSystemTags().then(function (resp) {
        $scope.loading = false;
        vm.allTags = resp.data.data;
      })["catch"](function () {
        $scope.loading = false;
      });
    };

    vm.getTags();

    $scope.editEntity = function (_entity) {
      var modal = $uibModal.open({
        animation: true,
        component: 'editEntity',
        windowClass: 'edit-entity-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          entity: function entity() {
            return _entity;
          }
        }
      });
      modal.result.then(function (result) {
        var entity = vm.allTags.find(function (x) {
          return x._id === result._id;
        });

        if (entity) {
          entity.prefix = result.prefix;
          entity.currentTag = result.prefix + entity.count;
          entity.name = result.name;
        }
      }, function (reason) {
        $log.info(reason);
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('companyEmployee', {
    controller: companyEmployeeController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/employee/employee.view.html'
  });
  /** @ngInject */

  function companyEmployeeController($scope, apiFactory, Notification, globals, $uibModal, $log, utils) {
    var vm = this;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.SETTING_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.SETTING]})
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.loading = false;
    vm.presets = [];
    vm.salaryDurationsList = [{
      label: 'Monthly',
      key: 'Monthly'
    }, {
      label: 'Weekly',
      key: 'Weekly'
    }, {
      label: 'Daily',
      key: 'Daily'
    }];
    vm.paidByList = [{
      label: "Hours",
      key: "Hours"
    }, {
      label: "Weeks",
      key: "Weeks"
    }, {
      label: "Months",
      key: "Months"
    }, {
      label: "14 Days Month",
      key: "14 Days Month"
    }];
    vm.paymentSchedulesList = [{
      label: 'End of Month',
      key: 'End of Month'
    }, {
      label: 'Start of Month',
      key: 'Start of Month'
    }];
    vm.paidHolidaysList = [{
      label: 'Yes',
      key: 'Yes'
    }, {
      label: 'No',
      key: 'No'
    }];
    vm.weekdays = [{
      name: 'Sunday'
    }, {
      name: 'Monday'
    }, {
      name: 'Tuesday'
    }, {
      name: 'Wednesday'
    }, {
      name: 'Thursday'
    }, {
      name: 'Friday'
    }, {
      name: 'Saturday'
    }];
    vm.typeList = [];
    vm.preset = {
      workingTimes: [],
      additionalCosts: [],
      drivingCosts: [],
      taskBonus: [],
      workingHours: {
        from: new Date(new Date(new Date(new Date().setHours(8)).setMinutes(0)).setSeconds(0)),
        to: new Date(new Date(new Date(new Date().setHours(18)).setMinutes(0)).setSeconds(0))
      }
    };
    vm.additionalCostUnits = [{
      value: '%'
    }, {
      value: 'hr'
    }];
    vm.drivingCostUnits = [{
      value: 'km'
    }, {
      value: 'm'
    }, {
      value: 'mile'
    }];
    vm.otherCostUnits = [{
      value: 'hr'
    }, {
      value: 'day'
    }];
    $scope.loading = true;
    Promise.all([apiFactory.getAllEmployeeSettings(), apiFactory.getEmployeeTypes()]).then(function (resp) {
      $scope.loading = false;
      vm.presets = resp[0].data.data;
      vm.typeList = resp[1].data.list;
    })["catch"](function () {
      $scope.loading = false;
      Notification.error("Something went wrong.");
    });
    $scope.isCreating = false;

    $scope.createEmployeeSetting = function () {
      $scope.isCreating = true;
      vm.preset = {
        workingTimes: [],
        additionalCosts: [],
        drivingCosts: [],
        taskBonus: [],
        otherTypeCosts: [],
        checkBoxApps: [],
        workingHours: {
          from: new Date(new Date(new Date(new Date().setHours(8)).setMinutes(0)).setSeconds(0)),
          to: new Date(new Date(new Date(new Date().setHours(18)).setMinutes(0)).setSeconds(0))
        }
      };
    };

    function validateValues() {
      if (utils.isEmpty(vm.preset.presetName)) {
        Notification.error("Please enter name.");
        return false;
      }

      if (!vm.preset.systemTagId) {
        Notification.error("Please select employee type.");
        return;
      }

      if (vm.preset.workingHours) {
        var diff = new Date(vm.preset.workingHours.to) - new Date(vm.preset.workingHours.from);

        if (diff < 0) {
          Notification.error("Working Hours (To) need to be greater than Working Hours (From)");
          return;
        }
      }

      return true;
    }

    $scope.cancel = function () {
      $scope.isCreating = false;
      $scope.isEditing = false;
    };

    $scope.createNewPreset = function () {
      if (!validateValues()) {
        return;
      }

      var preset = angular.fromJson(angular.toJson(vm.preset));

      if (preset.workingHours) {
        preset.workingHours.from = new Date(preset.workingHours.from).toISOString().substring(11, 16);
        preset.workingHours.to = new Date(preset.workingHours.to).toISOString().substring(11, 16);
      }

      preset.paidHolidays = preset.paidHolidays === 'Yes';
      apiFactory.createEmployeeSetting(preset).then(function () {
        Notification.success("EmployeeSetting saved.");
        getAllEmployeeSettings();
        $scope.isCreating = false;
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Failed EmployeeSetting save");
      });
    };

    $scope.isEditing = false;

    $scope.onEditEmployeeSetting = function (id) {
      vm.preset = {
        workingTimes: [],
        additionalCosts: [],
        drivingCosts: [],
        taskBonus: []
      };
      $scope.isEditing = true;
      $scope.loading = true;
      apiFactory.getEmployeeSetting(id).then(function (resp) {
        $scope.loading = false;
        vm.preset = resp.data.data;
        vm.preset.paidHolidays = vm.preset.paidHolidays === true ? 'Yes' : 'No';

        if (vm.preset.workingHours) {
          if (vm.preset.workingHours.from) {
            vm.preset.workingHours.from = new Date(new Date(new Date(new Date().setHours(vm.preset.workingHours.from.split(':')[0])).setMinutes(vm.preset.workingHours.from.split(':')[1])).setSeconds(0));
            vm.preset.workingHours.from = moment(vm.preset.workingHours.from).add(moment().utcOffset() / 60, 'hours');
          }

          if (vm.preset.workingHours.to) {
            vm.preset.workingHours.to = new Date(new Date(new Date(new Date().setHours(vm.preset.workingHours.to.split(':')[0])).setMinutes(vm.preset.workingHours.to.split(':')[1])).setSeconds(0));
            vm.preset.workingHours.to = moment(vm.preset.workingHours.to).add(moment().utcOffset() / 60, 'hours');
          }
        }
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error("Failed EmployeeSetting getting");
      });
    };

    $scope.deleteEmployeeSetting = function (id) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        $scope.loading = true;
        apiFactory.deleteEmployeeSetting(id).then(function () {
          $scope.loading = false;
          getAllEmployeeSettings();
        })["catch"](function () {
          $scope.loading = false;
          Notification.error("Failed EmployeeSetting delete");
        });
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.updatePreset = function (id) {
      if (!validateValues()) return;
      $scope.loading = true;
      var preset = angular.fromJson(angular.toJson(vm.preset));
      preset.paidHolidays = preset.paidHolidays === 'Yes';

      if (preset.workingHours) {
        preset.workingHours.from = new Date(preset.workingHours.from).toISOString().substring(11, 16);
        preset.workingHours.to = new Date(preset.workingHours.to).toISOString().substring(11, 16);
      }

      apiFactory.updateEmployeeSetting(id, preset).then(function () {
        $scope.loading = false;
        $scope.isEditing = false;
        Notification.success("EmployeeSetting saved successfully.");
      })["catch"](function () {
        $scope.loading = false;
        Notification.error("Failed EmployeeSetting updating");
      });
    };

    vm.onEdit = function (item) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (type === 'WorkingTime') {
        if (!utils.isEmpty(item.start)) {
          item.start = str2time(item.start);
          item.stop = str2time(item.stop);
        }
      }

      item.isItemEdit = true;
    };

    vm.onSave = function (item, type) {
      // if (!checkAvailableNumber(item.number)) {
      //   Notification.error('Duplicated Number.');
      //   return;
      // }
      if (type === 'WorkingTime') {
        if (!angular.isNumber(item.dailyHours)) {
          Notification.error('Daily hours need to be number');
          return;
        }

        if (utils.isValidDate(item.start)) {
          item.start = time2str(item.start);
        }

        if (utils.isValidDate(item.stop)) {
          item.stop = time2str(item.stop);
        }

        if (!utils.isEmpty(item.overTime)) {
          var overtimes = item.overTime.split(';');

          var _iterator = _createForOfIteratorHelper(overtimes),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var overtime = _step.value;
              var arr = overtime.split('+');

              if (arr.length !== 2) {
                Notification.error('Invalid Overtime value. Hours or percentage value missing.');
                return;
              }

              var timeVal = Number.parseFloat(arr[0]);
              var percentVal = Number.parseFloat(arr[1]);

              if (timeVal <= 0 || timeVal > 24) {
                Notification.error('Invalid Overtime hours value.');
                return;
              }

              if (percentVal < 0 || percentVal > 100) {
                Notification.error('Invalid Overtime percentage value.');
                return;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }

      item.isItemEdit = false;
    };

    vm.addNewItem = function (type) {
      switch (type) {
        case 'WorkingTime':
          vm.preset.workingTimes.push({
            number: getFreeNumber(),
            isItemEdit: true
          });
          break;

        case 'AdditionalCost':
          vm.preset.additionalCosts.push({
            number: getFreeNumber(),
            isItemEdit: true
          });
          break;

        case 'DrivingCost':
          vm.preset.drivingCosts.push({
            number: getFreeNumber(),
            isItemEdit: true
          });
          break;

        case 'TaskBonus':
          vm.preset.taskBonus.push({
            number: getFreeNumber(),
            isItemEdit: true
          });
          break;

        case 'OtherTypeCost':
          vm.preset.otherTypeCosts.push({
            number: getFreeNumber(),
            isItemEdit: true
          });
          break;

        case 'CheckBoxApp':
          vm.preset.checkBoxApps.push({
            number: getFreeNumber(),
            isItemEdit: true
          });
          break;

        default:
          break;
      }
    };

    $scope.changed = function () {
      var diff = new Date(vm.preset.workingHours.to) - new Date(vm.preset.workingHours.from);

      if (diff < 0) {
        Notification.error("Working Hours (To) need to be greater than Working Hours (From)");
      }
    };

    function getAllEmployeeSettings() {
      $scope.loading = true;
      apiFactory.getAllEmployeeSettings().then(function (resp) {
        $scope.loading = false;
        vm.presets = resp.data.data;
      })["catch"](function () {
        $scope.loading = false;
        Notification.error("Failed All EmployeeSettings getting");
      });
    }

    function getFreeNumber() {
      var number = 1000;
      var items = [].concat(vm.preset.workingTimes, vm.preset.additionalCosts, vm.preset.drivingCosts, vm.preset.taskBonus, vm.preset.otherTypeCosts, vm.preset.checkBoxApps);

      while (items.find(function (item) {
        return utils.num(item.number) === number;
      })) {
        number++;
      }

      return number;
    } // function checkAvailableNumber(number) {
    //   let items = [].concat(
    //     vm.preset.workingTimes,
    //     vm.preset.additionalCosts,
    //     vm.preset.drivingCosts,
    //     vm.preset.taskBonus,
    //     vm.preset.otherTypeCosts,
    //     vm.preset.checkBoxApps);
    //   return !items.find(item => utils.num(item.number) === number && !item.isItemEdit);
    // }


    function time2str(date) {
      var hours = date.getHours().toString().padStart(2, '0');
      var minutes = date.getMinutes().toString().padStart(2, '0');
      return hours + '.' + minutes;
    }

    function str2time(str) {
      var arr = str.split('.');
      var hours = Number.parseInt(arr[0]) || 0;
      var minutes = arr[1] || 0;
      return new Date(new Date().setHours(hours, minutes, 0, 0));
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('companyEconomic', {
    controller: companyEconomicController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/economic/economic.view.html'
  });
  /** @ngInject */

  function companyEconomicController($scope, $uibModal, $log, $element, apiFactory, globals, Notification, unitFactory, utils) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    vm.isVatSection = false;
    vm.accountSections = [];
    vm.accountPlans = [];
    vm.accountPlanSubItems = [];
    vm.accountPlanOptions = [];
    vm.serviceAndVAOrders = [];
    vm.labors = [];
    vm.serviceCars = [];
    vm.paymentAccounts = [];
    $scope.defaultPaymentAccountId = undefined;
    vm.budgets = [];
    vm.sumOfAccountPlan = 0;
    vm.equations = [{
      id: 'sum',
      label: 'SUM'
    }, {
      id: 'avg',
      label: 'AVG'
    }, {
      id: 'math',
      label: 'MATH'
    }];
    vm.fromDate = new Date();
    vm.toDate = new Date();
    vm.fromDate.setFullYear(vm.fromDate.getFullYear() - 1);
    vm.units = unitFactory.distanceUnits();
    vm.accountPlanTypes = [{
      id: 'Statement',
      label: 'Statement'
    }, {
      id: 'Balance',
      label: 'Balance'
    }, {
      id: 'Bank',
      label: 'Bank'
    }];
    vm.accountPlanCategories = {
      Statement: [{
        id: 'Invoice',
        label: 'Invoice'
      }, {
        id: 'Sales',
        label: 'Sales'
      }, {
        id: 'Bill',
        label: 'Bill'
      }, {
        id: "Labour",
        label: "Labour management"
      }, {
        id: "LabourOnSite",
        label: "Labour on site"
      }],
      Balance: [{
        id: "Liability",
        label: "Liability"
      }, {
        id: "Assets",
        label: "Assets"
      }, {
        id: "Equity",
        label: "Equity"
      }],
      Bank: [{
        id: "Assets",
        label: "Assets"
      }]
    };
    vm.activeOptions = [{
      value: 'yes',
      name: 'Yes'
    }, {
      value: 'no',
      name: 'No'
    }];
    vm.periodOptions = [{
      id: 'accounting',
      type: 'Accounting Period'
    }, {
      id: 'primo',
      type: 'Primo Balance'
    }];
    vm.primoVatOptions = [{
      id: 'yes',
      type: 'Yes'
    }, {
      id: 'no',
      type: 'No'
    }];
    vm.valueUseOptions = [{
      id: 'highest',
      type: 'Use Highest Value'
    }, {
      id: 'internal',
      type: 'Internal Balance'
    }, {
      id: 'external',
      type: 'External Balance'
    }];
    vm.wipOptions = [{
      id: 'none',
      type: 'None'
    }, {
      id: 'wipSales',
      type: 'WIP - Sales (Statement)'
    }, {
      id: 'wipCosts',
      type: 'WIP - Costs (Statement)'
    }, {
      id: 'wipLabour',
      type: 'WIP - Labour (Statement)'
    }, {
      id: 'wipContract',
      type: 'WIP - Contract (Balance/Current Assets)'
    }, {
      id: 'wipInvoiced',
      type: 'WIP - Invoiced (Balance/Current Assets)'
    }, {
      id: 'wipWip',
      type: 'WIP - Work In Progress (Balance/Current Assets)'
    }, {
      id: 'wipAssets',
      type: 'WIP - Costs (assets)'
    }, {
      id: 'wipShort',
      type: 'WIP - Costs (Balance/Short-term debt)'
    }, {
      id: 'wipUpfront',
      type: 'WIP - Upfront Payment'
    }];
    $scope.loading = true;
    apiFactory.getEconomicSetting().then(function (resp) {
      if (resp.data.data && resp.data.data.fromAccountDate) {
        vm.fromDate = new Date(resp.data.data.fromAccountDate);
        vm.toDate = new Date(resp.data.data.toAccountDate);
      }

      loadSetting();
    })["catch"](function (err) {
      $log.error(err);
      loadSetting();
    });

    function loadSetting() {
      Promise.all([apiFactory.listAccountPlanSections(), apiFactory.listAccountBalances({
        fromDate: vm.fromDate,
        toDate: vm.toDate
      }), apiFactory.getEconomicSettingInvoiceItems(), apiFactory.getPaymentAccounts(), apiFactory.getCompanyBudget(new Date().getFullYear()), apiFactory.listAllVatSettings()]).then(function (resp) {
        $scope.loading = false;
        vm.accountSections = resp[0].data.list || [];
        vm.accountSections.forEach(function (x) {
          if (!x.isVatSection) x.isVatSection = false;
        });
        vm.accountPlans = resp[1].data.list;
        vm.accountPlanSubItems = resp[2].data.data;
        vm.paymentAccounts = resp[3].data;
        vm.budgets = filterDynamic(resp[4].data.data);
        vm.vatSettings = resp[5].data.list || [];
        vm.accountPlans.forEach(function (item) {
          if (!item.pCategory) {
            item.pCategory = 'Invoice';
          }

          if (item.vatType) {
            item.vatTypeName = item.vatType.vatName;
            item.vatType = item.vatType._id;
          }

          item.internalBalance = item.credit || item.debit;
          item.expand = false;
        });
        vm.accountSections.forEach(function (section, index) {
          section.number = (index + 1).toString();
          section.items = vm.accountPlans.filter(function (item) {
            return item.sectionId === section._id;
          });
        });
        vm.accountPlanOptions = vm.accountPlans.filter(function (item) {
          return !!item._id && item.pCategory === 'Invoice';
        });
        vm.accountPlanSubItems.forEach(function (item) {
          if (item.plan) {
            item.type = item.plan.name;
            item.plan = item.plan._id;
          }
        });
        vm.serviceAndVAOrders = vm.accountPlanSubItems.filter(function (item) {
          return item.category === 'ServiceAndVAOrder';
        });
        vm.labors = vm.accountPlanSubItems.filter(function (item) {
          return item.category === 'Labor';
        });
        vm.serviceCars = vm.accountPlanSubItems.filter(function (item) {
          return item.category === 'ServiceCar';
        });
        var defaultPaymentAccount = vm.paymentAccounts.find(function (x) {
          return x.isDefault;
        });
        $scope.defaultPaymentAccountId = defaultPaymentAccount ? defaultPaymentAccount._id : undefined;
        calcAccountPlanSum();
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Something went wrong.");
        $scope.loading = false;
      });
    }

    vm.onSelectType = function (id, item) {
      var plan = vm.accountPlanOptions.find(function (it) {
        return it._id === id;
      });

      if (plan) {
        item.type = plan.name;
      }
    };

    vm.addNewItem = function (type) {
      if (!vm.accountPlanOptions.length) {
        Notification.error('Please add more invoice account plan first.');
        return;
      }

      var number;

      switch (type) {
        case 'ServiceAndVAOrder':
          number = getFreeNumber([].concat(vm.serviceAndVAOrders, vm.serviceCars, vm.labors));
          vm.serviceAndVAOrders.push({
            isItemEdit: true,
            category: type,
            number: number
          });
          break;

        case 'Labor':
          number = getFreeNumber([].concat(vm.serviceAndVAOrders, vm.serviceCars, vm.labors));
          vm.labors.push({
            isItemEdit: true,
            category: type,
            number: number
          });
          break;

        case 'ServiceCar':
          number = getFreeNumber([].concat(vm.serviceAndVAOrders, vm.serviceCars, vm.labors));
          vm.serviceCars.push({
            isItemEdit: true,
            category: type,
            number: number
          });
          break;
      }
    };

    vm.onEdit = function (item, type) {
      item.isItemEdit = true;

      if (type !== 'AccountPlan') {
        refreshTypeOptions();
      }
    };

    vm.onExpand = function (item) {
      item.expand = !item.expand;
    };

    vm.onSave = function (index, item, type) {
      var items = [];

      switch (type) {
        case 'ServiceAndVAOrder':
          if (!item.plan || !item.profit || !item.cost) {
            Notification.error('Please input all fields for ServiceAndVAOrder.');
            return;
          }

          items = vm.serviceAndVAOrders;
          break;

        case 'Labor':
          if (!item.plan || !item.salesPrice) {
            Notification.error('Please input all fields for Labor.');
            return;
          }

          items = vm.labors;
          break;

        case 'ServiceCar':
          if (!item.plan || !item.unit || !item.price) {
            Notification.error('Please Input All Fields for ServiceCar.');
            return;
          }

          items = vm.serviceCars;
          break;

        default:
          return;
      }

      apiFactory.saveEconomicSettingItem(item).then(function (resp) {
        var result = resp.data.data;

        if (result.plan) {
          result.type = result.plan.name;
          result.plan = result.plan._id;
        }

        items[index] = result;
        Notification.success("Economic setting item saved successfully.");
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Failed to save economic setting item.");
      });
      item.isItemEdit = false;
    };

    vm.onDelete = function (index, item, type) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        if (item._id) {
          apiFactory.deleteEconomicSettingItem(item._id).then(function () {
            Notification.success("Economic setting item deleted successfully.");
            deleteEconomicSettingItem(index, type);
          })["catch"](function (err) {
            $log.error(err);
            Notification.success("Failed to delete economic setting item.");
          });
        } else {
          deleteEconomicSettingItem(index, type);
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.addPlanSection = function () {
      vm.accountSections.push({
        isEdit: true,
        name: "Section",
        items: [],
        summaries: [],
        sum: 0,
        order: vm.accountSections.length + 1,
        number: (vm.accountSections.length + 1).toString(),
        isVatSection: false
      });
      $element.find('.plan-section')[$element.find('.plan-section').length - 1].scrollIntoView();
    };

    vm.addNewPlan = function (section) {
      var number = getFreeNumber(vm.accountPlans);
      section.items.push({
        isItemEdit: true,
        sectionId: section._id,
        type: 'Statement',
        pCategory: 'Invoice',
        number: number,
        valueUse: 'highest',
        operationCost: 'No',
        useForecast: 'No',
        showAsSeparate: 'No',
        wip: 'none'
      });
    };

    $scope.getVatPrimoNumber = function (section) {
      var ret = "";
      section.items.forEach(function (x) {
        if (x.isPrimoVat == 'yes') {
          if (ret.length > 0) ret += ";";
          ret += x.number;
        }
      });
      return ret;
    };

    vm.saveAccountPlan = function (section, index, item) {
      if (!item.number || !item.type || item.vat == null && item.tax == null) {
        Notification.error('Please Input All Fields for Account Plan.');
        return;
      }

      var existingTaxPlan = vm.accountPlans.find(function (it) {
        return it.pCategory === "Tax" && it.number !== item.number;
      });

      if (item.pCategory === 'Tax' && existingTaxPlan) {
        Notification.error('Already Exist Tax Plan.');
        return;
      }

      if (item._id) {
        $scope.loading = true;
        apiFactory.updateAccountPlan(item._id, item).then(function (resp) {
          $scope.loading = false;

          if (resp.data.data.vatType) {
            resp.data.data.vatTypeName = resp.data.data.vatType.vatName;
            resp.data.data.vatType = resp.data.data.vatType._id;
          }

          section.items[index] = resp.data.data;
          var idx = vm.accountPlans.findIndex(function (x) {
            return x._id === item._id;
          });

          if (idx !== -1) {
            vm.accountPlans[idx] = resp.data.data;
          }

          calcAccountPlanSum();
          refreshTypeOptions();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error('Failed to update account plan.');
        });
      } else {
        $scope.loading = true;
        apiFactory.createAccountPlan(item).then(function (resp) {
          $scope.loading = false;

          if (resp.data.data.vatType) {
            resp.data.data.vatTypeName = resp.data.data.vatType.vatName;
            resp.data.data.vatType = resp.data.data.vatType._id;
          }

          section.items[index] = resp.data.data;
          vm.accountPlans.push(resp.data.data);
          calcAccountPlanSum();
          refreshTypeOptions();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error('Failed to create account plan.');
        });
      }
    };

    vm.deleteAccountPlan = function (section, index, item) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        if (item._id) {
          $scope.loading = true;
          apiFactory.deleteAccountPlan(item._id).then(function () {
            $scope.loading = false;
            deleteAccountPlan(section, index, item);
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error('Failed to delete economic setting item');
          });
        } else {
          deleteAccountPlan(section, index, item);
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.addSummary = function (section) {
      section.summaries.push({
        name: 'Sum',
        equation: 'sum',
        value: 0,
        fields: []
      });
    };

    vm.saveSummary = function (section) {
      vm.savePlanSection(section);
    };

    vm.deleteSummary = function (index, section) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        section.summaries.splice(index, 1);
      });
    };

    vm.changeSumField = function (_summary) {
      $uibModal.open({
        animation: true,
        component: 'settingSummaryModal',
        windowClass: 'economic-setting-summary-modal',
        backdrop: 'static',
        resolve: {
          sections: function sections() {
            return vm.accountSections;
          },
          accountPlans: function accountPlans() {
            return vm.accountPlans;
          },
          summary: function summary() {
            return _summary;
          }
        }
      }).result.then(function (result) {
        _summary.fields = result.fields.map(function (x) {
          return {
            type: x.type,
            number: x.number,
            operator: x.operator
          };
        });
        calcSummary(_summary);
      });
    };

    vm.getSummaryFields = function (summary) {
      return summary.fields.map(function (x) {
        return "".concat(x.type === 'section' ? 'S' : 'A').concat(x.number);
      }).join(',');
    };

    vm.editPlanSection = function (section) {
      section.isEdit = true;
    };

    vm.savePlanSection = function (section) {
      if (section._id) {
        $scope.loading = true;
        apiFactory.updateAccountPlanSection(section._id, section).then(function () {
          $scope.loading = false;
          section.isEdit = false;
          Notification.success("Success to save.");
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error("Failed to save.");
        });
      } else {
        $scope.loading = true;
        apiFactory.createAccountPlanSection(section).then(function (resp) {
          $scope.loading = false;
          section._id = resp.data.data._id;
          section.isEdit = false;
          Notification.success("Success to save.");
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error("Failed to save.");
        });
      }
    };

    vm.deletePlanSection = function (index, section) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        if (section._id) {
          $scope.loading = true;
          apiFactory.deleteAccountPlanSection(section._id).then(function (res) {
            $scope.loading = false;
            vm.accountSections.splice(index, 1);
            vm.accountSections.forEach(function (section, index) {
              section.order = index + 1;
              section.number = (index + 1).toString();
            });
            Notification.success(res.data.message);
            calcAccountPlanSum();
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error('Failed to delete economic setting item');
          });
        } else {
          vm.accountSections.splice(index, 1);
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.savePlanSectionOrder = function (section) {
      vm.savePlanSection(section);
      vm.accountSections.sort(function (a, b) {
        return a.order - b.order;
      });
      var sections = vm.accountSections.map(function (section) {
        return {
          _id: section._id,
          order: section.order
        };
      });
      apiFactory.updateAccountPlanSections({
        sections: sections
      }).then(function () {
        $scope.loading = false;
        section.isEdit = false;
      })["catch"](function (err) {
        $scope.loading = false;
        section.isEdit = false;
        $log.error(err);
      });
    };

    vm.movePlanSection = function (index) {
      vm.accountSections.splice(index, 1);
      vm.accountSections.forEach(function (section, index) {
        section.order = index + 1;
        section.number = (index + 1).toString();
      });
      var sections = vm.accountSections.map(function (section) {
        return {
          _id: section._id,
          order: section.order
        };
      });
      apiFactory.updateAccountPlanSections({
        sections: sections
      }).then(function () {})["catch"](function (err) {
        $log.error(err);
      });
    };

    vm.selectUnit = function (unit, item) {
      item.unit = unit.name;
    };

    vm.openAddPaymentInfoModal = function (paymentAccount) {
      var _isEdit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var paymentInfoModal = $uibModal.open({
        animation: true,
        component: 'paymentInfoModal',
        windowClass: 'add-payment-info-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return paymentAccount;
          },
          isEdit: function isEdit() {
            return _isEdit;
          }
        }
      });
      paymentInfoModal.result.then(function (result) {
        if (utils.isEmpty(paymentAccount)) {
          $scope.loading = true;
          apiFactory.addPaymentAccount(result).then(function (res) {
            $scope.loading = false;
            vm.paymentAccounts.push(res.data.data);
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        } else {
          $scope.loading = true;
          apiFactory.updatePaymentAccount(result).then(function (res) {
            $scope.loading = false;
            Notification.success(res.data.message);
            var updated = res.data.data;
            var index = vm.paymentAccounts.findIndex(function (x) {
              return x._id === updated._id;
            });

            if (index !== -1) {
              vm.paymentAccounts[index] = updated;
            }
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.onDeletePayment = function (index, item) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        if (item.isDefault) {
          Notification.error('Default payment cannot delete.');
          return;
        }

        apiFactory.deletePaymentAccount(item._id).then(function () {
          Notification.success('Payment Account is deleted successfully.');
          vm.paymentAccounts.splice(index, 1);
        })["catch"](function (err) {
          $log.error(err);
          Notification.error('Failed to delete.');
        });
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.clickedPaymentAccount = function (paymentAccount) {
      $scope.loading = true;
      apiFactory.changeDefaultPaymentAccount(paymentAccount._id).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        paymentAccount.isDefault = true;
        vm.paymentAccounts.forEach(function (x) {
          if (x._id !== paymentAccount._id) {
            x.isDefault = false;
          }
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error('Failed to set default payment account');
        paymentAccount.isDefault = false;
      });
    };

    $scope.getItemPeriod = function (item) {
      var period = {
        'accounting': 'Accounting Period',
        // 'custom': 'See In Period',
        'primo': 'Primo Balance'
      };
      return period[item.period];
    };

    $scope.getItemPrimoVat = function (item) {
      if (!item.isPrimoVat) return 'No';
      var ret = {
        'yes': 'Yes',
        'no': 'No'
      };
      return ret[item.isPrimoVat];
    };

    $scope.getItemValueUse = function (item) {
      var value = {
        'highest': 'Use Highest Value',
        'internal': 'Internal Balance',
        'external': 'External Balance'
      };
      return value[item.valueUse];
    };

    $scope.getItemWip = function (item) {
      var value = {
        'none': 'None',
        'wipSales': 'WIP - Sales (Statement)',
        'wipCosts': 'WIP - Costs (Statement)',
        'wipLabour': 'WIP - Labour (Statement)',
        'wipContract': 'WIP - Contract (Balance/Current Assets)',
        'wipInvoiced': 'WIP - Invoiced (Balance/Current Assets)',
        'wipWip': 'WIP - Work In Progress (Balance/Current Assets)',
        'wipAssets': 'WIP - Costs (assets)',
        'wipShort': 'WIP - Costs (Balance/Short-term debt)',
        'wipUpfront': 'WIP - Upfront Payment'
      };
      return value[item.wip];
    };

    $scope.getAccountPlanForecast = function (accountPlan) {
      var internal = utils.num(accountPlan.internalBalance);
      var external = utils.num(accountPlan.externalBalance);
      var value;

      switch (accountPlan.valueUse) {
        case 'internal':
          value = internal;
          break;

        case 'external':
          value = external;
          break;

        case 'highest':
        default:
          value = Math.max(internal, external);
          break;
      }

      return value;
    };

    $scope.getAccountPlanCategories = function (accountPlan) {
      return vm.accountPlanCategories[accountPlan.type];
    };

    function getFreeNumber(items) {
      var number = 1000;

      while (items.find(function (item) {
        return utils.num(item.number) === number;
      })) {
        number++;
      }

      return number;
    }

    function deleteAccountPlan(section, index, item) {
      section.items.splice(index, 1);
      var idx = vm.accountPlans.findIndex(function (x) {
        return x._id === item._id;
      });

      if (idx !== -1) {
        vm.accountPlans.splice(idx, 1);
      }

      if (item.pCategory === 'Invoice') {
        if (item.category === 'ServiceAndVAOrder') {
          vm.serviceAndVAOrders = vm.serviceAndVAOrders.filter(function (it) {
            return it.plan !== item.id;
          });
        }

        if (item.category === 'Labor') {
          vm.labors = vm.labors.filter(function (it) {
            return it.plan !== item.id;
          });
        }

        if (item.category === 'ServiceCar') {
          vm.serviceCars = vm.serviceCars.filter(function (it) {
            return it.plan !== item.id;
          });
        }
      }

      refreshTypeOptions();
      calcAccountPlanSum();
    }

    function deleteEconomicSettingItem(index, type) {
      switch (type) {
        case 'ServiceAndVAOrder':
          vm.serviceAndVAOrders.splice(index, 1);
          break;

        case 'Labor':
          vm.labors.splice(index, 1);
          break;

        case 'ServiceCar':
          vm.serviceCars.splice(index, 1);
          break;

        default:
          return;
      }
    }

    function refreshTypeOptions() {
      vm.accountPlanOptions = vm.accountPlans.filter(function (item) {
        return item.pCategory === 'Invoice';
      });
    }

    function filterDynamic(companyBudget) {
      if (!companyBudget || !companyBudget.sections) return;
      var budgets = [];
      companyBudget.sections.forEach(function (section) {
        if (!section.budgets) return;
        section.budgets.forEach(function (budget) {
          if (budget.children && budget.children[0]) {
            budgets.push({
              index: "".concat(budget.index, ".1"),
              name: "".concat(budget.index, ".1 ").concat(budget.title)
            });
          }
        });
      });
      return budgets;
    }

    function calcAccountPlanSum() {
      vm.accountSections.forEach(function (section) {
        if (section.summaries) {
          section.summaries.forEach(function (summary) {
            return calcSummary(summary);
          });
        }
      });
    }

    function calcSummary(summary) {
      summary.credit = 0;
      summary.debit = 0;
      summary.balance = 0;
      summary.value = {};

      if (summary.fields) {
        if (summary.equation === 'math') {
          summary.fields.forEach(function (field) {
            if (field.type === 'section') {
              var section = vm.accountSections.find(function (x) {
                return x.number === field.number;
              });

              if (section) {
                var value = getSectionSum(section);
                summary.credit += field.operator === '-' ? -value.credit : value.credit;
                summary.debit += field.operator === '-' ? -value.debit : value.debit;
                summary.balance += field.operator === '-' ? -value.balance : value.balance;
              }
            } else {
              var accountPlan = vm.accountPlans.find(function (plan) {
                return plan.number === field.number;
              });

              if (accountPlan) {
                summary.credit += field.operator === '-' ? -accountPlan.credit : accountPlan.credit;
                summary.debit += field.operator === '-' ? -accountPlan.debit : accountPlan.debit;
                summary.balance += field.operator === '-' ? -accountPlan.balance : accountPlan.balance;
              }
            }
          });
        } else {
          var count = 0;
          summary.fields.forEach(function (field) {
            if (field.type === 'section') {
              var section = vm.accountSections.find(function (x) {
                return x.number === field.number;
              });

              if (section) {
                var value = getSectionSum(section);
                summary.credit += value.credit;
                summary.debit += value.debit;
                summary.balance += value.balance;
                count++;
              }
            } else {
              var accountPlan = vm.accountPlans.find(function (plan) {
                return plan.number === field.number;
              });

              if (accountPlan) {
                summary.credit += accountPlan.credit;
                summary.debit += accountPlan.debit;
                summary.balance += accountPlan.balance;
                count++;
              }
            }
          });

          if (summary.equation === 'avg') {
            summary.value = count === 0 ? 0 : summary.value / count;
          }
        }
      }

      var balance = summary.credit + summary.debit;
      summary.balance = balance;
      summary.debit = balance > 0 ? balance : 0;
      summary.credit = balance < 0 ? balance : 0;
      summary.value = summary.balance;
    }

    function getSectionSum(section) {
      var credit = section.summaries.map(function (x) {
        return utils.num(x.credit);
      }).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
      var debit = section.summaries.map(function (x) {
        return utils.num(x.debit);
      }).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
      var balance = section.summaries.map(function (x) {
        return utils.num(x.balance);
      }).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
      return {
        credit: credit,
        debit: debit,
        balance: balance
      };
    }
  }
})();


"use strict";

(function () {
  angular.module("app").directive("companyRoles", companyRoles);

  function companyRoles($timeout, apiFactory) {
    return {
      restrict: "E",
      templateUrl: "app/main/settings/companyRoles/companyRoles.view.html",
      scope: {
        newData: "=",
        showLevel: "="
      },
      link: function link($scope) {
        $scope.loading = true;
        apiFactory.getCompanyRolesTree().then(function (resp) {
          $scope.loading = false;
          $scope.newtree = [{
            name: 'Admin',
            levels: resp.data.data
          }];
        })["catch"](function (error) {
          $scope.loading = false;
          if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to fetch role tree");
        });
        $scope.$watch('newData', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          $scope.newtree[0].levels = newValue;
          refreshTree();
        });

        function refreshTree() {
          $timeout(function () {
            $scope.$apply();
            $scope.$broadcast('angular-ui-tree:expand-all');
          });
        }
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('companyInfo', {
    controller: CompanyInfoController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/companyInfo/companyInfo.view.html'
  });
  /** @ngInject */

  function CompanyInfoController($scope, globals, apiFactory, Notification, $log) {
    var vm = this;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.SETTING_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.SETTING]
    //   })
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.companyData = companyStore.get();
    vm.gmap = {
      url: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&libraries=places",
      markers: [vm.companyData.location.coordinates],
      styles: [],
      center: "".concat(vm.companyData.location.coordinates[0], ",").concat(vm.companyData.location.coordinates[1]),
      zoom: 8
    };

    vm.placeMarker = function () {
      var placeData = this.getPlace().geometry.location;
      vm.gmap.markers = [[placeData.lat(), placeData.lng()]];
      vm.gmap.zoom = 15;
      vm.gmap.center = "".concat(placeData.lat(), ",").concat(placeData.lng());
      $scope.companyInfo.location.coordinates = [placeData.lat(), placeData.lng()];
    };

    $scope.companyInfo = angular.copy(vm.companyData);
    $scope.companyInfo.industry = $scope.companyInfo.industry.join(', ');
    globals.getCountryCode().then(function (resp) {
      vm.getCountryCode = resp.data;
    });
    globals.getIndustry().then(function (resp) {
      vm.getIndustries = resp.data;
    });
    globals.getCurrency().then(function (resp) {
      vm.currencies = resp.data;
    });

    $scope.ClientDialCode = function (event) {
      $scope.companyInfo.companyContact.dialCode = event.target.id;
    };

    $scope.ClientIndustry = function (event) {
      $scope.companyInfo.industry = event.target.id;
    };

    $scope.onChange = function (files) {
      if (angular.isUndefined(files[0])) return;
      $scope.companyInfo.companyLogo = URL.createObjectURL(files[0]);
      vm.companyLogoImg = files[0];
    };

    $scope.isEdit = false;

    $scope.onEdit = function () {
      $scope.isEdit = true;
    };

    $scope.exitEdit = function () {
      $scope.companyInfo = angular.copy(vm.companyData);
      $scope.companyInfo.industry = $scope.companyInfo.industry.join(', ');
      $scope.isEdit = false;
    };

    $scope.onSave = function () {
      $scope.loading = true;
      apiFactory.updateCompanyById($scope.companyInfo._id, $scope.companyInfo).then(function (result) {
        $scope.loading = false;
        $scope.isEdit = false;
        Notification.success("Company info updated successfully");
        companyStore.set(result.data);
        $scope.companyInfo = angular.copy(result.data);
        $scope.companyInfo.industry = $scope.companyInfo.industry.join(', ');

        if (vm.companyLogoImg) {
          $scope.loading = true;
          apiFactory.updateCompanyLogo({
            image: vm.companyLogoImg
          }).then(function (resp) {
            $scope.loading = false;
            var updatedData = Object.assign(companyStore.get(), {
              companyLogo: resp.data.url
            });
            companyStore.set(updatedData);
          })["catch"](function (err) {
            $log.error(err);
            $scope.loading = false;
          });
        }
      })["catch"](function (err) {
        $log.error(err);
        $scope.loading = false;
        Notification.error('Update Failed.');
      });
    };

    vm.category = 'noData';
    vm.categoryList = [{
      key: 'noData',
      label: "No Data"
    }];
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('calculationSetting', {
    controller: CalculationSettingController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/calculationSetting/calculationSetting.view.html'
  });
  /** @ngInject */

  function CalculationSettingController($scope, globals, apiFactory, Notification, utils, $log, $uibModal, storageFactory) {
    var vm = this;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.SETTING_ACCESS_CREATE = 4;
    // } else {
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.SETTING]})
    //     .then(res => {
    //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
    //     })
    //     .catch((e) => {
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.monthlyCosts = [{
      name: "Jan",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "Feb",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "Mar",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "Apr",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "May",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "Jun",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "Jul",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "Aug",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "Sep",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "Oct",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "Nov",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "Dec",
      percent: 0,
      cost: 0,
      revenue: 0
    }, {
      name: "All",
      percent: 0,
      cost: 0,
      revenue: 0
    }];
    $scope.isEdit = false;
    vm.companyData = companyStore.get();
    $scope.calculationSetting = {};

    $scope.onEdit = function () {
      $scope.isEdit = true;
    };

    $scope.onCancel = function () {
      $scope.isEdit = false;
      initData();
    };

    $scope.onUpdate = function () {
      var workerCost = $scope.calculationSetting.averageWorkerCost;
      var companyCost = $scope.calculationSetting.companyCost;
      var profit = $scope.calculationSetting.profit;
      var compData = {
        averageWorkerCost: workerCost,
        companyCost: companyCost,
        profit: profit
      };
      $scope.loading = true;
      apiFactory.saveCompanyData(compData).then(function (resp) {
        $scope.loading = false;
        $scope.isEdit = false;
        Notification.success("company Data has been updated successfully.");
        var updatedData = Object.assign(companyStore.get(), {
          averageWorkerCost: resp.data.data.averageWorkerCost,
          profit: resp.data.data.profit,
          companyCost: resp.data.data.companyCost
        });
        companyStore.set(updatedData);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function paddingItems(workTags) {
      var items = [];
      workTags.forEach(function (workTag) {
        items.push({
          tagId: workTag._id,
          tagName: workTag.tagName,
          percentage: 100
        });
      });
      return items;
    }

    $scope.onAddBuildingTag = function () {
      if (utils.isEmpty(vm.tagName)) {
        Notification.error('Please enter Tag name');
        return;
      }

      var find = vm.buildingTags.find(function (elem) {
        return elem.tagName === vm.tagName;
      });

      if (find) {
        Notification.error("Already exist tag with the name");
        return;
      }

      var systemTag = {
        tagName: vm.tagName,
        categoryName: 'Building'
      };

      if (!utils.isEmpty(vm.buildingCategory)) {
        systemTag.categoryId = vm.buildingCategory._id;
      }

      var workCategory = vm.categoryList.find(function (c) {
        return c.categoryName === 'Work';
      });

      if (angular.isUndefined(workCategory)) {
        Notification.error('Not exists work category. Please create the category first.');
        return;
      }

      $scope.loading = true;
      apiFactory.createSystemTag(systemTag).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message || 'Created building tag successfully');
        var createdTag = res.data.data;
        vm.buildingTags.push(createdTag);
        vm.tagName = '';
        var workTags = vm.allSystemTags.filter(function (tag) {
          return tag.categoryId === workCategory._id;
        });
        var items = paddingItems(workTags);
        var pattern = {
          tagId: createdTag._id,
          items: items
        };
        $scope.loading = true;
        apiFactory.createWorkPattern(pattern).then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message || 'Created work pattern successfully');
        })["catch"](function (err) {
          Notification.error(err.data.message || 'Something went wrong');
        });
      })["catch"](function () {
        $scope.loading = false;
        Notification.error("Something went wrong");
      });
    };

    $scope.deleteBuildingTag = function (tag) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        $scope.loading = true;
        Promise.all([apiFactory.deleteSystemTag(tag._id), apiFactory.deleteWorkPattern(tag._id)]).then(function () {
          $scope.loading = false;
          Notification.success("Building tag deleted successfully.");
          var index = vm.buildingTags.indexOf(tag);
          vm.buildingTags.splice(index, 1);
        })["catch"](function () {
          $scope.loading = false;
          Notification.error("Something went wrong");
        });
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.rebuildFinanceAggregation = function () {
      $scope.loading = true;
      storageFactory.listAllProjects().then(function (resp) {
        var query = {};
        var projects = resp.data.list;
        query.projects = projects.filter(function (x) {
          return x.projectStatus == 1 || x.projectStatus == 2 || x.isServiceProject == true;
        }).map(function (element) {
          return element._id;
        });
        apiFactory.rebuildFinanceAggregationData(query).then(function () {
          $scope.loading = false;
        });
      });
    };

    $scope.selectYear = function () {
      for (var i = 0; i < 13; i++) {
        $scope.monthlyCosts[i].percent = 0;
        $scope.monthlyCosts[i].cost = 0;
        $scope.monthlyCosts[i].revenue = 0;
      }

      apiFactory.getOperationCostPercent(vm.selectedYear).then(function (resp) {
        var data = resp.data.data;
        var costs = resp.data.costs;
        var revenues = resp.data.revenues;

        for (var _i = 0; _i < data.length; _i++) {
          $scope.monthlyCosts[_i].percent = utils.num(data[_i]);
          $scope.monthlyCosts[_i].cost = utils.num(costs[_i]);
          $scope.monthlyCosts[_i].revenue = utils.num(revenues[_i]);
        }
      })["catch"](function (err) {
        $log.error(err);
      });
    };

    function initData() {
      var today = new Date();
      var thisYear = today.getFullYear();
      $scope.years = [];

      for (var year = thisYear; year > thisYear - 10; year--) {
        $scope.years.push({
          value: year
        });
      }

      vm.selectedYear = thisYear;
      $scope.selectYear();
      vm.companyData = companyStore.get();
      $scope.calculationSetting = {};
      $scope.calculationSetting.averageWorkerCost = vm.companyData.averageWorkerCost;
      $scope.calculationSetting.companyCost = vm.companyData.companyCost;
      $scope.calculationSetting.profit = vm.companyData.profit;
      vm.tagName = '';
      globals.getCurrency().then(function (resp) {
        vm.currencies = resp.data;
        vm.currenciesList = vm.currencies.map(function (c) {
          return {
            cc: c.cc,
            label: c.cc + ' - ' + c.name,
            symbol: c.symbol
          };
        });
      });
      $scope.loading = true;
      Promise.all([apiFactory.getCategoriesList(), apiFactory.getSystemTags()]).then(function (resp) {
        $scope.loading = false;
        vm.categoryList = resp[0].data.list;
        vm.buildingCategory = vm.categoryList.find(function (x) {
          return x.categoryName === 'Building';
        });
        vm.allSystemTags = resp[1].data.list;

        if (vm.buildingCategory) {
          vm.buildingTags = vm.allSystemTags.filter(function (x) {
            return x.categoryId === vm.buildingCategory._id;
          });
        } else {
          vm.buildingTags = [];
        }
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
      });
    }

    initData();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('billApprovers', {
    controller: BillApproversController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/billApprovers/billApprovers.view.html'
  });
  /** @ngInject */

  function BillApproversController($scope, $uibModal, $log, apiFactory, globals, Notification, utils) {
    var vm = this;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.SETTING_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.SETTING]
    //   })
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.companyData = companyStore.get();
    vm.managerList = [];

    vm.getManagers = function () {
      $scope.loading = true;
      apiFactory.listAllManageUsers().then(function (resp) {
        $scope.loading = false;
        vm.managerList = resp.data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
      });
    };

    vm.getManagers();
    $scope.billApprovers = angular.copy(vm.companyData.billApprovers);
    $scope.periods = [{
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '40',
      name: '40'
    }];
    $scope.pageLimit = 10;
    $scope.pageCount = Math.ceil($scope.billApprovers.length / $scope.pageLimit);
    $scope.currentPage = 1;
    $scope.pageItems = $scope.billApprovers.slice(($scope.currentPage - 1) * $scope.pageLimit, $scope.currentPage * $scope.pageLimit);
    $scope.totalCount = $scope.billApprovers.length;

    function updateApprovers() {
      var approverItems = $scope.billApprovers.filter(function (item) {
        return item.approver && item.approver._id !== null;
      });
      var payload = approverItems.map(function (item) {
        return {
          approver: item.approver._id,
          limit: item.limit
        };
      });
      $scope.loading = true;
      apiFactory.updateCompanyBillingApprover(payload).then(function (resp) {
        $scope.loading = false;
        $log.info(resp);
        Notification.success(resp.data.message);
        $scope.billApprovers = approverItems;
        $scope.pageItems = $scope.billApprovers.slice(($scope.currentPage - 1) * $scope.pageLimit, $scope.currentPage * $scope.pageLimit);
        vm.companyData.billApprovers = approverItems;
        companyStore.set(vm.companyData);
        $scope.pageItems = $scope.billApprovers.slice(($scope.currentPage - 1) * $scope.pageLimit, $scope.currentPage * $scope.pageLimit);
        vm.approver = undefined;
        vm.limit = undefined;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    $scope.addApprover = function () {
      if (utils.isEmpty(vm.approver)) {
        Notification.error('Please select user');
        return;
      }

      if (utils.isEmpty(vm.limit)) {
        Notification.error('Please input limit');
      }

      var approver = vm.managerList.find(function (item) {
        return item._id == vm.approver;
      });
      $scope.billApprovers.push({
        approver: {
          _id: approver._id,
          displayName: approver.displayName,
          profilePic: approver.profilePic
        },
        limit: vm.limit
      });
      updateApprovers();
    };

    $scope.onEdit = function (approver) {
      var createEditBillModal = $uibModal.open({
        animation: true,
        component: 'billApproversModal',
        windowClass: 'billApproversModal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          managerList: function managerList() {
            return vm.managerList;
          },
          data: function data() {
            return approver;
          }
        }
      });
      createEditBillModal.result.then(function (result) {
        var index = $scope.billApprovers.indexOf(approver);
        $scope.billApprovers[index] = result;
        $scope.pageItems = $scope.billApprovers.slice(($scope.currentPage - 1) * $scope.pageLimit, $scope.currentPage * $scope.pageLimit);
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.onDelete = function (item) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        var index = $scope.billApprovers.indexOf(item);
        $scope.billApprovers.splice(index, 1);
        $scope.pageItems = $scope.billApprovers.slice(($scope.currentPage - 1) * $scope.pageLimit, $scope.currentPage * $scope.pageLimit);
        updateApprovers();
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.setPage = function () {
      $scope.pageItems = $scope.billApprovers.slice(($scope.currentPage - 1) * $scope.pageLimit, $scope.currentPage * $scope.pageLimit);
    };

    vm.selectNumPage = function (new_num) {
      $scope.pageLimit = new_num;
      $scope.pageCount = Math.ceil($scope.billApprovers.length / $scope.pageLimit);
      $scope.setPage();
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app.settings').component('accessSettings', {
    controller: AccessSettingsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/accessSettings/accessSettings.view.html'
  });
  /** @ngInject */

  function AccessSettingsController($scope, apiFactory, $log, globals, Notification, utils) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.SETTING_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.SETTING_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.SETTING]
    //   })
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.SETTING_ACCESS_CREATE = res.data.data[Constants.AccessKey.SETTING];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.accessTypes = ['None', 'Read', 'Edit', 'Create', 'Full'];
    $scope.menuTypes = Constants.AccessArea;
    $scope.userTypes = Constants.UserTypeList.filter(function (x) {
      return x.key !== "admin";
    });

    var _iterator = _createForOfIteratorHelper($scope.menuTypes),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var menuType = _step.value;
        vm[menuType.key] = {};
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    $scope.contentMenuIndex = 0;

    $scope.selContentMenu = function (index) {
      $scope.contentMenuIndex = index;
    };

    vm.changeList = [];

    $scope.clickedOption = function (type, value) {
      if ($scope.isEdit) {
        if (vm[$scope.menuTypes[$scope.contentMenuIndex].key][type] != value) {
          vm[$scope.menuTypes[$scope.contentMenuIndex].key][type] = value;
          var find = vm.changeList.find(function (elem) {
            return elem.accessKey == Constants.AccessKey[$scope.menuTypes[$scope.contentMenuIndex].key] && elem.userDType == globals.getDashboardValue(type);
          });

          if (find) {
            find.value = $scope.accessTypes.findIndex(function (elem) {
              return elem == value;
            });
          } else {
            vm.changeList.push({
              accessKey: Constants.AccessKey[$scope.menuTypes[$scope.contentMenuIndex].key],
              userDType: globals.getDashboardValue(type),
              value: $scope.accessTypes.findIndex(function (elem) {
                return elem == value;
              })
            });
          }
        }
      }
    };

    function prepareView(access) {
      var menuType = globals.getAccessKey(access.accessKey);
      var userType = globals.getDashboardKey(access.userDType);
      var accessType = $scope.accessTypes[access.value];
      vm[menuType][userType] = accessType;
    }

    $scope.fetchAccessSettings = function () {
      $scope.loading = true;
      apiFactory.getAccessSetting().then(function (resp) {
        $scope.loading = false;

        var _iterator2 = _createForOfIteratorHelper($scope.menuTypes),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var menuType = _step2.value;
            vm[menuType.key] = {};

            var _iterator4 = _createForOfIteratorHelper($scope.userTypes),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var userType = _step4.value;
                vm[menuType.key][userType.key] = 'None';
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        vm.backupData = resp.data.data;

        var _iterator3 = _createForOfIteratorHelper(resp.data.data),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var access = _step3.value;
            prepareView(access);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      })["catch"](function (error) {
        $log.error(error);
        $scope.loading = false;
      });
    };

    $scope.fetchAccessSettings();
    $scope.isEdit = false;

    $scope.onEdit = function () {
      $scope.isEdit = true;
    };

    $scope.exitEdit = function () {
      $scope.isEdit = false;

      var _iterator5 = _createForOfIteratorHelper(vm.backupData),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var access = _step5.value;
          prepareView(access);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      vm.changeList = [];
    };

    function prepareSave() {
      var payload = {};
      payload.data = [];

      var _iterator6 = _createForOfIteratorHelper($scope.menuTypes),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var menuType = _step6.value;

          var _iterator7 = _createForOfIteratorHelper($scope.userTypes),
              _step7;

          try {
            var _loop = function _loop() {
              var userType = _step7.value;
              var temp = {};
              temp.accessKey = Constants.AccessKey[menuType.key];
              var find = Constants.UserTypeList.find(function (elem) {
                return elem.key == userType.key;
              });
              if (find) temp.userDType = find.dashboardType;
              temp.value = $scope.accessTypes.indexOf(vm[menuType.key][userType.key]);
              payload.data.push(temp);
            };

            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return payload;
    }

    $scope.onSave = function () {
      if (utils.isEmpty(vm.changeList)) {
        $scope.isEdit = false;
        return;
      }

      $scope.loading = true;
      var payload = prepareSave();

      var _iterator8 = _createForOfIteratorHelper(vm.changeList),
          _step8;

      try {
        var _loop3 = function _loop3() {
          var item = _step8.value;
          var find = payload.data.find(function (elem) {
            return elem.accessKey == item.accessKey && elem.userDType == item.userDType;
          });

          if (find) {
            if (item.value != find.value) {
              item.value = find.value;
            }
          }
        };

        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          _loop3();
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      apiFactory.saveAccessSetting({
        data: vm.changeList
      }).then(function (resp) {
        $log.log(resp);
        $scope.loading = false;
        $scope.isEdit = false;

        var _iterator9 = _createForOfIteratorHelper(vm.changeList),
            _step9;

        try {
          var _loop2 = function _loop2() {
            var item = _step9.value;
            var find = vm.backupData.find(function (elem) {
              return elem.accessKey == item.accessKey && elem.userDType == item.userDType;
            });

            if (find) {
              find.value = item.value;
            }
          };

          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }

        Notification.success("Access setting saved successfully");
      })["catch"](function (e) {
        $log.error(e);
        $scope.loading = false;

        if (e.data && e.data.message) {
          Notification.error(e.data.message);
        } else {
          Notification.error("Failed to save");
        }
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('reportsMarking', {
    controller: reportsMarkingController,
    controllerAs: 'vm',
    templateUrl: 'app/main/reports/reports-marking/reports-marking.view.html'
  });
  /** @ngInject */

  function reportsMarkingController($scope, localStorageService, $state, apiFactory, Bim, VP, $document, $log, $stateParams, Notification, utils) {
    var vm = this;
    vm.reportId = $stateParams.id;
    $scope.is3D = false;
    $scope.isOnly3D = false;
    vm.viewer3d = undefined;
    vm.viewer2d = undefined;
    vm.levelId = undefined;
    var showLoadingCount = 0;

    $scope.onCancel = function () {
      $state.go('addRegistration', {
        id: vm.reportId
      });
    };

    $scope.onContinue = function () {
      if (vm.viewer3d) {
        vm.viewer3d.disableControl();
        vm.viewer3d.invalidate();
      }

      save();
    };

    $scope.addMarker = function () {
      if ($scope.is3D) {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.addMarker();
        }
      } else {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
          vm.viewer2d.addMarker();
        }
      }
    };

    $scope.removeMarker = function () {
      if ($scope.is3D) {
        if (vm.viewer3d) {
          vm.viewer3d.removeMarker();
        }
      } else {
        if (vm.viewer2d) {
          vm.viewer2d.removeMarker();
        }
      }
    };

    $scope.viewTypeChanged = function () {
      if ($scope.is3D) {
        angular.element('#marking-viewer-3d').css('visibility', 'visible');
        angular.element('#marking-viewer-2d').css('visibility', 'hidden');
      } else {
        angular.element('#marking-viewer-3d').css('visibility', 'hidden');
        angular.element('#marking-viewer-2d').css('visibility', 'visible');
      }
    };

    vm.addCutter = function () {
      vm.viewer3d.addCrossSection();
    };

    vm.removeCutter = function () {
      vm.viewer3d.removeCrossSection();
    };

    vm.hasCutter = function () {
      return vm.viewer3d.hasClipping();
    };

    function initData() {
      vm.regData = localStorageService.get('regData');
      vm.regId = localStorageService.get('regId');
      var bimModelId = vm.regData.marker && vm.regData.marker.info3d && vm.regData.marker.info3d.modelId ? vm.regData.marker.info3d.modelId : null;
      vm.levelId = vm.regData.marker && vm.regData.marker.info3d && vm.regData.marker.info3d.level ? vm.regData.marker.info3d.level : null;

      if (angular.isUndefined(vm.regData.drawings)) {
        vm.regData.drawings = [];
      }

      if (angular.isDefined(bimModelId)) {
        if (vm.regData.marker.modelType === '3d') {
          showLoading(true);
          apiFactory.get3dModel(bimModelId).then(function (resp) {
            showLoading(false);

            if (resp.data.data) {
              vm.viewer3d = Bim.markingViewer($document[0].getElementById('marking-viewer-3d'));
              vm.viewer3d.initialize();
              vm.viewer3d.loadBim(resp.data.data).then(function () {
                if (angular.isDefined(vm.levelId) && vm.levelId !== 'All') {
                  vm.viewer3d.showObject(vm.levelId);
                  loadPlan(vm.viewer3d.getBimModel(), vm.levelId);
                }

                if (vm.regData.marker.info3d && vm.regData.marker.info3d.location && vm.regData.marker.info3d.location.x) {
                  vm.viewer3d.loadMarkers([vm.regData.marker.info3d.location]);
                } else {
                  vm.viewer3d.loadMarkers([]);
                }

                if (vm.regData.marker.info3d.clipping) {
                  vm.viewer3d.loadClipping(vm.regData.marker.info3d.clipping);
                }
              })["catch"](function (err) {
                $log.error(err);
              });
              vm.viewer3d.on('markerPlaced', markerPlaced);
              vm.viewer3d.on('markerRemoved', markerRemoved);
              vm.viewer3d.on('clippingAdded', clippingAdded);
            }
          })["catch"](function (e) {
            showLoading(false);
            $log.error(e);
          });
        } else {
          showLoading(true);
          var planUrl = vm.regData.marker.info3d.url;
          var pageNo = vm.regData.marker.info3d.pageNo;
          vm.viewer2d = VP.markingViewer(angular.element('#marking-viewer-2d')[0]);
          vm.viewer2d.loadBackgroundImageWidthHD(planUrl, pageNo).then(function () {
            if (vm.regData.marker.info3d.location && vm.regData.marker.info3d.location.x) {
              vm.viewer2d.loadMarkers([vm.regData.marker.info3d.location]);
            }

            showLoading(false);
          })["catch"](function (err) {
            showLoading(false);
            $log.error(err);
          });
        }
      }

      $scope.isOnly3D = false;

      if (vm.regData.marker.modelType === '3d' && (!vm.levelId || vm.levelId === 'All')) {
        $scope.isOnly3D = true;
        $scope.is3D = true;
      }
    }

    initData();

    function showLoading(show) {
      showLoadingCount += show ? 1 : -1;

      if (showLoadingCount === 1) {
        angular.element('#loading').css('display', 'flex');
      } else if (showLoadingCount === 0) {
        angular.element('#loading').hide();
      }
    }

    function loadPlan(bimModel, levelId) {
      showLoading(true);
      vm.viewer2d = Bim.planViewer($document[0].getElementById('marking-viewer-2d'));
      vm.viewer2d.initialize();
      vm.viewer2d.loadBimModel(bimModel, levelId).then(function () {
        showLoading(false);

        if (vm.regData.marker.info2d && vm.regData.marker.info2d.location && vm.regData.marker.info2d.location.x) {
          vm.viewer2d.loadMarkers([vm.regData.marker.info2d.location]);
        } else {
          vm.viewer2d.loadMarkers([]);
        }
      })["catch"](function (err) {
        showLoading(false);
        $log.error(err);
      });
      vm.viewer2d.on('markerPlaced', markerPlaced);
      vm.viewer2d.on('markerRemoved', markerRemoved);
    }

    function markerPlaced(is3d, markerPos) {
      if (!vm.levelId || vm.levelId === 'All') return;

      if (is3d) {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
          var pos = vm.viewer3d.get2dPos(markerPos, vm.levelId);

          if (pos) {
            vm.viewer2d.placeMarker(pos);
          }
        }
      } else {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.placeMarker(markerPos, vm.levelId);
        }
      }
    }

    function markerRemoved(is3d) {
      if (is3d) {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
        }
      } else {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.invalidate();
        }
      }
    }

    function clippingAdded() {
      $scope.$apply();
    }

    function save() {
      var canvas;

      if (vm.viewer3d) {
        vm.regData.marker.info3d.location = vm.viewer3d.getMarkers()[0];
        vm.regData.marker.info3d.location.z = vm.regData.marker.info3d.location.z - 0.55;

        if (vm.regData.marker.info3d.location) {
          canvas = $document[0].getElementById("marking-viewer-3d").childNodes[0];
          var image3D = canvas.toDataURL("image/jpg");
          vm.regData.drawings.push({
            image3D: image3D
          });
        }

        vm.regData.marker.info3d.clipping = vm.viewer3d.getClipping();
      }

      if (vm.viewer2d) {
        if (vm.regData.marker.modelType === '3d') {
          if (!vm.regData.marker.info2d) {
            vm.regData.marker.info2d = {
              location: {
                x: 0,
                y: 0
              }
            };
          }

          vm.regData.marker.info2d.location = vm.viewer2d.getMarkers()[0];

          if (vm.regData.marker.info2d.location) {
            var image2D = vm.viewer2d.takeImage();
            vm.regData.drawings.push({
              image2D: image2D
            });
          }
        } else {
          vm.regData.marker.info3d.location = vm.viewer2d.getMarkers()[0];

          if (vm.regData.marker.info3d.location) {
            var _image2D = vm.viewer2d.takeImage();

            vm.regData.drawings.push({
              image3D: _image2D
            });
          }
        }
      }

      localStorageService.set('regData', vm.regData);

      if (vm.regId) {
        if (vm.regData.uploadImg) {
          vm.regData.photo = utils.dataURLtoFile(vm.regData.uploadImg, 'issuePhoto');
        }

        delete vm.regData.uploadImg;

        if (vm.regData.drawings) {
          vm.regData.drawings.forEach(function (item) {
            if (item.image2D) {
              vm.regData.image2d = utils.dataURLtoFile(item.image2D, 'image2D');
            } else if (item.image3D) {
              vm.regData.image3d = utils.dataURLtoFile(item.image3D, 'image3D');
            }
          });
        }

        $scope.loading = true;
        apiFactory.updateReportRegistration(vm.regId, vm.regData).then(function (resp) {
          $scope.loading = false;
          Notification.success(resp.data.message);
          localStorageService.set('regData', {});
          $state.go('reportsDetails', {
            id: vm.reportId
          });
        })["catch"](function (e) {
          $scope.loading = false;
          $log.error(e);
          localStorageService.set('regData', {});
          $state.go('reportsDetails', {
            id: vm.reportId
          });
        });
      } else {
        $state.go('addRegistration', {
          id: vm.reportId
        });
      }
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('reportsList', {
    controller: ReportsListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/reports/reports-list/reports-list.view.html'
  });
  /** @ngInject */

  function ReportsListController($scope, localStorageService, $state, globals, apiFactory, $log, utils, Notification) {
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.REPORT_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.REPORT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.REPORT]})
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.REPORT_ACCESS_CREATE = res.data.data[Constants.AccessKey.REPORT];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    /* Get project */

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.totalCount = 0; // $scope.numPerPage = globals.numPerPage();

    $scope.numPerPage = 12;
    $scope.totalPages = 0;
    vm.currentPage = 1;
    $scope.isList = false;
    $scope.isGrid = true;

    $scope.init = function () {
      vm.allIssues = [];
      $scope.loading = false;
      $scope.searchReports();
    };

    $scope.labelChecked = false;

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      vm.reports.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };

    $scope.onListView = function () {
      $scope.isGrid = false;
      $scope.isList = true;
    };

    $scope.onGridView = function () {
      $scope.isGrid = true;
      $scope.isList = false;
    };

    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.searchTextList = [];

    $scope.searchReports = function () {
      if ($scope.searchText && utils.isEmpty($scope.searchTextList)) {
        $scope.searchTextList.push($scope.searchText);
      }

      $scope.loading = true;
      apiFactory.getAllReports({
        projectId: vm.project._id,
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: "updatedAt",
        sortType: "false",
        search: $scope.searchText
      }).then(function (resp) {
        $scope.loading = false;
        $scope.totalCount = resp.data.total;
        vm.reports = resp.data.data || [];
        $log.log(vm.reports);
        $scope.totalPages = Math.ceil($scope.totalCount / $scope.numPerPage); // $state.reload();
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);

        if (e.status === 403) {
          Notification.error(e.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        }
      });
    };

    $scope.removeSearchText = function (index) {
      $scope.searchTextList.splice(index, 1);
      $scope.searchText = "";
      $scope.searchReports();
    };

    $scope.onCreateReports = function () {
      localStorageService.set('reportData', {});
      $state.go('createReports');
    };

    $scope.goToDetail = function (reportId) {
      $state.go('reportsDetails', {
        id: reportId
      });
    };

    $scope.getRegIntervalText = function (regInterval) {
      switch (regInterval) {
        case 1:
          return 'Daily';

        case 7:
          return 'Weekly';

        case 14:
          return 'Bi Weekly';

        case 30:
          return 'Monthly';

        default:
          return '';
      }
    };

    $scope.init();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('reportsDetails', {
    controller: ReportsDetailsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/reports/reports-details/reports-details.view.html'
  });
  /** @ngInject */

  function ReportsDetailsController($scope, $state, $stateParams, localStorageService, apiFactory, pdfFactory, $log, utils, $uibModal, Notification, Bim, $document, globals) {
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.REPORT_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.REPORT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.REPORT]
    //   }).then(res => {
    //     $scope.loading = false;
    //     $scope.REPORT_ACCESS_CREATE = res.data.data[Constants.AccessKey.REPORT];
    //   })
    //   .catch((e) => {
    //     $scope.loading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.isRegAndDoc = true;
    $scope.isMedia = false; // let showLoadingCount = 0;

    $scope.is3D = false;
    $scope.isRegistrationType = false;
    $scope.entityType = '3d';
    vm.pdfViewing = false;
    $scope.loading = false;

    $scope.onRegistration = function () {
      $scope.isRegAndDoc = true;
      $scope.isMedia = false;
    };

    $scope.onMedia = function () {
      $scope.isRegAndDoc = false;
      $scope.isMedia = true;
    };

    $scope.editReport = function () {
      var reportData = $scope.report;
      reportData.checkList = reportData.checkList ? reportData.checkList : [];
      reportData.editMode = true;
      reportData.step = 1;
      localStorageService.set('reportData', reportData);
      $state.go('editReports');
    };

    $scope.onAddRegistration = function () {
      $state.go('addRegistration', {
        id: $scope.report._id
      });
    };

    $scope.getRegIntervalText = function (regInterval) {
      switch (regInterval) {
        case 1:
          return 'Daily';

        case 7:
          return 'Weekly';

        case 14:
          return 'Bi Weekly';

        case 30:
          return 'Monthly';

        default:
          return '';
      }
    };

    $scope.onAddSiteDocument = function () {
      var modal = $uibModal.open({
        animation: true,
        component: 'addSiteDocModal',
        windowClass: 'site-doc-modal',
        keyboard: false,
        backdrop: 'static',
        resolve: {
          reportId: function reportId() {
            return vm.reportId;
          },
          isEdit: function isEdit() {
            return false;
          },
          controlPlanItems: function controlPlanItems() {
            return $scope.controlPlanItems;
          },
          tagsList: function tagsList() {
            return $scope.tagsList;
          }
        }
      });
      modal.result.then(function (result) {
        $log.log(result);
        vm.refreshReport();
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.deleteReport = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.loading = true;
          apiFactory.deleteReports($scope.report._id).then(function (res) {
            $scope.loading = false;
            Notification.success(res.data.message);
            $state.go('reportsList');
          })["catch"](function (e) {
            $scope.loading = false;
            $log.error(e);
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.sortRSList = function () {
      $scope.totalEntities = $scope.report.registrations.length + $scope.report.siteDocs.length;
    };

    $scope.regIntervalToString = function (regInterval) {
      switch (regInterval) {
        case 1:
          return 'Daily';

        case 7:
          return 'Weekly';

        case 14:
          return 'Bi Weekly';

        case 30:
          return 'Monthly';

        default:
          return 'Unknown';
      }
    };

    vm.refreshReport = function () {
      $scope.loading = true;
      apiFactory.getReportById(vm.reportId).then(function (res) {
        $scope.loading = false;
        $scope.report = res.data.data;
        $scope.report.imageURL = $scope.report.image ? $scope.report.image.secure_url : null;
        $scope.pagingEntities();
        $scope.pagingMedias();
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
      });
    };

    $scope.editEntity = function (entity, isReg) {
      localStorageService.set("regId", entity._id);

      if (isReg) {
        $state.go('addRegistration', {
          id: $scope.report._id
        });
      } else {
        var _sitedocData = entity;

        if (_sitedocData.controlPlanItems && _sitedocData.controlPlanItems.length) {
          _sitedocData.controlPlanItem = _sitedocData.controlPlanItems[0];
        }

        _sitedocData.dateCreated = new Date(entity.dateCreated);
        var modal = $uibModal.open({
          animation: true,
          component: 'addSiteDocModal',
          windowClass: 'site-doc-modal',
          keyboard: false,
          backdrop: 'static',
          resolve: {
            reportId: function reportId() {
              return vm.reportId;
            },
            siteDocId: function siteDocId() {
              return localStorageService.get('regId');
            },
            isEdit: function isEdit() {
              return true;
            },
            sitedocData: function sitedocData() {
              return _sitedocData;
            },
            controlPlanItems: function controlPlanItems() {
              return $scope.controlPlanItems;
            },
            tagsList: function tagsList() {
              return $scope.tagsList;
            }
          }
        });
        modal.result.then(function (result) {
          $log.log(result);
          vm.refreshReport();
        }, function (reason) {
          $log.log(reason);
        });
      }
    };

    $scope.deleteEntity = function (entityId, isReg) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          if (isReg) {
            $scope.loading = true;
            apiFactory.deleteReportRegistration(entityId, {
              reportId: vm.reportId
            }).then(function (res) {
              $scope.loading = false;
              Notification.success(res.data.message);
              vm.refreshReport();
            })["catch"](function (error) {
              $scope.loading = false;
              $log.error(error);
            });
          } else {
            $scope.loading = true;
            apiFactory.deleteReportSiteDoc(entityId, {
              reportId: vm.reportId
            }).then(function (res) {
              $scope.loading = false;
              Notification.success(res.data.message);
              vm.refreshReport();
            })["catch"](function (error) {
              $scope.loading = false;
              $log.error(error);
            });
          }
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.uploadMediaFile = function (files) {
      if (files[0]) {
        var payload = {
          mediaFile: files[0]
        };
        $scope.loading = true;
        apiFactory.addReportMedia(vm.reportId, payload).then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message);
          vm.refreshReport();
        })["catch"](function (error) {
          $scope.loading = false;
          $log.error(error);
        });
      }
    };

    vm.exportReport = function () {
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (filename) {
        var registrations = [];
        var siteDocs = [];
        $scope.selectedEntities.map(function (x) {
          if (x.registrationType) {
            registrations.push(x._id);
          } else {
            siteDocs.push(x._id);
          }
        });
        var promises = [];
        var STEP = 5;
        var registrationLength = registrations.length;
        var siteDocsLength = siteDocs.length;
        var totalLength = registrationLength + siteDocsLength;
        var partCount = Math.ceil(totalLength / STEP);

        if (totalLength > STEP) {
          var regIndex = 0;
          var docIndex = 0;
          var pageIndex = 0;

          for (var i = 0; i < totalLength; i += STEP) {
            var subRegistrations = [];
            var subSiteDocs = [];
            pageIndex++;
            subRegistrations = registrations.slice(regIndex, regIndex + STEP);
            regIndex += STEP;
            var regLen = subRegistrations.length;

            if (regLen < STEP) {
              var diffLen = STEP - regLen;
              subSiteDocs = siteDocs.slice(docIndex, docIndex + diffLen);
              docIndex += diffLen;
            }

            promises.push(apiFactory.exportReportData(vm.reportId, {
              registrations: subRegistrations,
              siteDocs: subSiteDocs,
              filename: filename,
              isMultiPart: true,
              partCount: partCount,
              pageIndex: pageIndex
            }));
          }
        } else {
          promises.push(apiFactory.exportReportData(vm.reportId, {
            registrations: registrations,
            siteDocs: siteDocs,
            filename: filename
          }));
        }

        $scope.loading = true;
        Promise.all(promises).then(function (res) {
          $scope.loading = false;
          var urls = res.map(function (x) {
            return x.data.link;
          }); // download pdfs

          utils.downloadFiles(urls).then(function () {})["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          }); // save pdfs to hierarchy

          var modal = $uibModal.open({
            animation: true,
            component: 'folderPickerModal',
            keyboard: false,
            windowClass: 'folder-picker-modal',
            resolve: {
              data: function data() {
                return {
                  selectedFolderType: 'project',
                  parentFolder: null
                };
              }
            }
          });
          modal.result.then(function (result) {
            var hierarchyId = result._id;
            $scope.loading = true;
            apiFactory.addPdfUrlsToHierarchy({
              hierarchyId: hierarchyId,
              urls: urls,
              projectId: vm.project._id
            }).then(function (res) {
              $scope.loading = false;
              Notification.success(res.data.message);
            })["catch"](function (err) {
              $scope.loading = false;
              $log.error(err);
              Notification.error(utils.getErrorMessage(err));
            });
          }, function (reason) {
            $log.error(reason);
          });
        })["catch"](function (e) {
          $scope.loading = false;
          $log.error(e);
          Notification.error("Failed in exporting, please try again later.");
        });
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.pagingEntities = function () {
      var entities = $scope.report.entities;

      if (entities) {
        $scope.totalEntities = entities.length;
        $scope.totalPagesForEntities = Math.ceil($scope.totalEntities / $scope.numEntitiesPerPage);
        $scope.entities = entities.slice((vm.currentPageForEntity - 1) * $scope.numEntitiesPerPage, vm.currentPageForEntity * $scope.numEntitiesPerPage);
      }
    };

    $scope.pagingMedias = function () {
      var medias = $scope.report.medias;

      if (medias) {
        $scope.totalMedias = medias.length;
        $scope.totalPagesForMedias = Math.ceil($scope.totalMedias / $scope.numMediasPerPage);
        $scope.medias = medias.slice((vm.currentPageForMedia - 1) * $scope.numMediasPerPage, vm.currentPageForMedia * $scope.numMediasPerPage);
      }
    };
    /* pagination for entities */


    $scope.entities = [];
    $scope.selectedEntities = [];
    $scope.totalEntities = 0;
    $scope.numEntitiesPerPage = 12;
    $scope.totalPagesForEntities = 0;
    vm.currentPageForEntity = 1;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    /* pagination for medias */

    $scope.medias = [];
    $scope.totalMedias = 0;
    $scope.numMediasPerPage = 12;
    $scope.totalPagesForMedias = 0;
    vm.currentPageForMedia = 1;

    vm.selectEntityNumPage = function (new_num) {
      $scope.numEntitiesPerPage = new_num;
      $scope.pagingEntities();
    };

    vm.selectMediaNumPage = function (new_num) {
      $scope.numMediasPerPage = new_num;
      $scope.pagingMedias();
    };

    vm.init = function () {
      $scope.report = {};
      localStorageService.set('regId', null);
      vm.reportId = $stateParams.id;
      $scope.loading = true;
      Promise.all([apiFactory.getReportById(vm.reportId), apiFactory.getAllReportTypes(), apiFactory.listAllAdminUsers(vm.project._id)]).then(function (res) {
        $scope.loading = false;
        $scope.report = res[0].data.data;

        if ($scope.report.createdBy.lastName) {
          $scope.report.createdBy.displayName = $scope.report.createdBy.firstName + ' ' + $scope.report.createdBy.lastName;
        }

        $scope.tagsList = res[1].data.list;
        $scope.userList = res[2].data.list || [];
        $scope.report.imageURL = $scope.report.image ? $scope.report.image.secure_url : null;
        $scope.controlPlanItems = $scope.report.controlPlan && $scope.report.controlPlan.plan ? $scope.report.controlPlan.plan : [];
        $scope.checkListTags = $scope.report.checkList.map(function (x) {
          return x.systemTag;
        }).join(', ');
        $scope.pagingEntities();
        $scope.pagingMedias();
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
      });
    };

    vm.init();

    $scope.deleteIcon = function (id) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.loading = true;
          apiFactory.deleteReportMedia(id).then(function () {
            $scope.loading = false;
            vm.refreshReport();
          })["catch"](function (error) {
            $scope.loading = false;
            $log.error(error);
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.onSelEntity = function (entity) {
      $scope.data_url = undefined;

      if (!entity.selected) {
        var index = $scope.selectedEntities.indexOf(entity);
        $scope.selectedEntities.splice(index, 1);
      } else {
        $scope.selectedEntities.push(entity);
      }

      var item = $scope.selectedEntities[0];
      $log.log(item, "item");
      $scope.isRegImageView = true;

      if (item) {
        if (item.registrationType) {
          $scope.isRegistrationType = true;
          $scope.entityType = item.marker && item.marker.model ? item.marker.model.modelType : "3d";
          $scope.reportRegPhotoPath = item.image && item.image.secure_url ? item.image.secure_url : null;
          $scope.reportRegimage3DPath = item.marker && item.marker.model && item.marker.model.info3d && item.marker.model.info3d.image ? item.marker.model.info3d.image.secure_url : null;
          $scope.reportRegimage2DPath = item.marker && item.marker.model && item.marker.model.info2d && item.marker.model.info2d.image ? item.marker.model.info2d.image.secure_url : null;
        } else {
          $scope.isRegistrationType = false;
          $scope.reportRegimage3DPath = null;
          $scope.reportRegimage2DPath = null;
          $scope.isRegImageView = false;
        }
      } else {
        $scope.reportRegimage3DPath = null;
        $scope.reportRegimage2DPath = null;
        $scope.reportRegPhotoPath = null;
        $scope.isRegImageView = false;
      }
    };

    vm.print = function (entity) {
      if (entity.documents && entity.documents.length) {
        var url = entity.documents[0].secure_url ? entity.documents[0].secure_url : entity.documents[0].location;
        var ext = utils.getExtensionByName(url);

        if (ext.toLowerCase() != 'pdf') {
          $scope.reportImageByType(url);
        } else {
          $scope.reportDocURL = url;
          vm.pdfViewing = true;
        }
      } else {
        Notification.error('Not found Site Doc file');
      }
    };

    vm.closePDFViewer = function () {
      vm.pdfViewing = false;
      $scope.reportDocURL = undefined;
    };

    $scope.issueImageByType = function (entity) {
      $scope.reportRegImageURL = entity.image ? entity.image.secure_url : null;
      var imageViewerModal = $uibModal.open({
        animation: true,
        component: 'imageViewerModal',
        backdrop: 'static',
        keyboard: true,
        windowClass: 'file-viewer-modal',
        windowTopClass: 'file-viewer-modal-wrapper',
        resolve: {
          imageURL: function imageURL() {
            return $scope.reportRegImageURL;
          }
        }
      });
      imageViewerModal.result.then(function () {}, function (reason) {
        $log.log(reason);
      });
    };

    $scope.reportImageByType = function (url) {
      var imageViewerModal = $uibModal.open({
        animation: true,
        component: 'imageViewerModal',
        backdrop: 'static',
        keyboard: true,
        windowClass: 'file-viewer-modal',
        windowTopClass: 'file-viewer-modal-wrapper',
        resolve: {
          imageURL: function imageURL() {
            return url;
          }
        }
      });
      imageViewerModal.result.then(function () {}, function (reason) {
        $log.log(reason);
      });
    };

    $scope.reportRegModelImageByType = function () {
      var _imageURL;

      if ($scope.entityType !== '3d') {
        _imageURL = $scope.reportRegimage3DPath;
      } else if ($scope.entityType === '3d') {
        if ($scope.is3D) {
          _imageURL = $scope.reportRegimage3DPath;
        } else if (!$scope.is3D) {
          _imageURL = $scope.reportRegimage2DPath;
        }
      }

      var imageViewerModal = $uibModal.open({
        animation: true,
        component: 'imageViewerModal',
        backdrop: 'static',
        keyboard: true,
        windowClass: 'file-viewer-modal',
        windowTopClass: 'file-viewer-modal-wrapper',
        resolve: {
          imageURL: function imageURL() {
            return _imageURL;
          }
        }
      });
      imageViewerModal.result.then(function () {}, function (reason) {
        $log.log(reason);
      });
    };

    $scope.clearReportRegImage = function () {
      $scope.reportRegImageURL = null;
    };
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function () {
  'use strict';

  angular.module('app').component('createReports', {
    controller: CreateReportsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/reports/create-reports/create-reports.view.html'
  });
  /** @ngInject */

  function CreateReportsController($scope, $state, localStorageService, authFactory, apiFactory, pdfFactory, $document, Notification, globals, $log, utils) {
    var vm = this;
    var logout = globals.logout,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.checkValidation = function () {
      var ret = {
        success: true,
        errorMsg: ''
      };
      var errorMsg = "";

      if (utils.isEmpty($scope.reportData.title)) {
        errorMsg = 'Please input title';
      } else if (utils.isEmpty($scope.reportData.reportType)) {
        errorMsg = 'Please select report category';
      }

      if (errorMsg.length) {
        ret.success = false;
        ret.errorMsg = errorMsg;
        $scope.goStep(1);
        return ret;
      }

      $scope.reportData.image = vm.uploadImg[0];

      if ($scope.reportData.checkList == null) {
        delete $scope.reportData.checkList;
      }

      if (errorMsg.length) {
        ret.success = false;
        ret.errorMsg = errorMsg;
      }

      return ret;
    };

    $scope.goStep = function (step) {
      if (step > $scope.reportData.step) {
        var valid = $scope.checkValidation();

        if (!valid.success) {
          Notification.error(valid.errorMsg);
          return;
        }
      }

      $scope.reportData.step = step;
      localStorageService.set('reportData', $scope.reportData);
    };
    /* file */


    vm.uploadImg = [];

    $scope.changeImage = function (files) {
      if (angular.isUndefined(files[0])) return;
      vm.uploadImg[0] = files[0];
      $scope.imageURL = URL.createObjectURL(vm.uploadImg[0]);
    };

    $scope.exitCreateReport = function () {
      localStorageService.set('reportData', {});
      var id = $scope.reportData._id;

      if (id && $scope.reportData.editMode) {
        $state.go('reportsDetails', {
          id: id
        });
      } else {
        $state.go('reportsList');
      }
    };

    $scope.createReport = function () {
      var valid = $scope.checkValidation();

      if (!valid.success) {
        Notification.error(valid.errorMsg);
        return;
      }

      $scope.reportData.projectId = vm.project._id;

      if (!$scope.reportData.subContractor) {
        $scope.reportData.subContractor = undefined;
      }

      var id = $scope.reportData._id;

      if (id && $scope.reportData.editMode) {
        $scope.loading = true;
        var reportData = $scope.reportData;
        apiFactory.updateReportById(id, {
          aboutCompany: reportData.aboutCompany,
          checkList: reportData.checkList,
          controlPlan: reportData.controlPlan,
          createdBy: reportData.createdBy._id,
          description: reportData.description,
          image: reportData.image,
          imageURL: reportData.imageURL,
          medias: reportData.medias,
          projectId: reportData.projectId,
          registrationInterval: reportData.registrationInterval,
          reportType: reportData.reportType,
          status: reportData.status,
          step: reportData.step,
          subContractor: reportData.subContractor,
          systemTag: reportData.systemTag,
          title: reportData.title
        }).then(function (resp) {
          $scope.loading = false;
          Notification.success(resp.data.message);
          $scope.exitCreateReport();
        })["catch"](function (error) {
          $scope.loading = false;
          $log.error(error);
          if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to update report"); // $scope.exitCreateReport();
        });
      } else {
        $scope.loading = true;
        apiFactory.createReports($scope.reportData).then(function (resp) {
          $scope.loading = false;
          Notification.success(resp.data.message);
          $scope.exitCreateReport();
        })["catch"](function (error) {
          $scope.loading = false;
          Notification.error(error);
          if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to create report"); // $scope.exitCreateReport();
        });
      }
    };

    $scope.checkList = null;

    $scope.selectCheckList = function () {
      if ($scope.reportData.checkList) {
        if (!$scope.reportData.checkList.includes($scope.checkList)) {
          if ($scope.reportData.checkList.length < 5) {
            $scope.reportData.checkList.push($scope.checkList);
          }
        }
      } else {
        $scope.reportData.checkList = [$scope.checkList];
      }

      $scope.checkList = null;
    };

    $scope.removeCheckList = function (item) {
      var index = $scope.reportData.checkList.indexOf(item);
      $scope.reportData.checkList.splice(index, 1);
    };

    $scope.getChecklistTitle = function (item) {
      if ($scope.allCheckList) {
        var checklist = $scope.allCheckList.find(function (it) {
          return it._id == item;
        });

        if (checklist) {
          return checklist.title;
        }
      }

      return null;
    };

    $scope.init = function () {
      if (!authFactory.checkUser()) {
        logout();
        return;
      }

      $scope.loading = false;
      /* project */

      vm.project = projectStore.get();

      if (utils.isEmpty(vm.project) || vm.project._id === 'all') {
        Notification.error('Please select project first.');
        $state.go(globals.getDashboardRoute(vm.userData));
        return;
      }

      $scope.reportData = localStorageService.get('reportData') || {};

      if (!$scope.reportData.checkList || !angular.isArray($scope.reportData.checkList)) {
        if ($scope.reportData.checkList) {
          if (_typeof($scope.reportData.checkList) == 'object') {
            $scope.reportData.checkList = [$scope.reportData.checkList._id];
          } else {
            $scope.reportData.checkList = [$scope.reportData.checkList];
          }
        } else {
          $scope.reportData.checkList = [];
        }
      } else {
        $scope.reportData.checkList = $scope.reportData.checkList.map(function (it) {
          if (_typeof(it) == 'object') {
            return it._id;
          } else {
            return it;
          }
        });
      }

      if (utils.isEmpty($scope.reportData.aboutCompany)) {
        if (companyStore.get()) $scope.reportData.aboutCompany = companyStore.get().description;
      }

      $scope.goStep($scope.reportData.step || 1);
      /* category */

      $scope.reportTypeList = [{
        label: 'Safety',
        key: 'Safety'
      }, {
        label: 'Quality',
        key: 'Quality'
      }, {
        label: 'Issue',
        key: 'Issue'
      }, {
        label: 'Other',
        key: 'Other'
      }];
      /* Registration interval */

      $scope.regIntervalList = [{
        label: '',
        key: 0
      }, {
        label: 'Daily (1)',
        key: 1
      }, {
        label: 'Weekly (7)',
        key: 7
      }, {
        label: 'Bi Weekly (14)',
        key: 14
      }, {
        label: 'Monthly',
        key: 30
      }];
      var apis = [apiFactory.listAllAdminUsers(vm.project._id), apiFactory.getAllSubcontractors(), apiFactory.getControlPlans({
        projectid: vm.project._id
      }), apiFactory.getAllChecklist({
        projectId: vm.project._id
      })];
      $scope.loading = true;
      Promise.all(apis).then(function (resp) {
        $scope.loading = false;
        /* admin */

        var userList = resp[0].data.list || [];
        $scope.userList = userList.map(function (user) {
          return {
            label: user.firstName + ' ' + user.lastName,
            key: user._id
          };
        });
        /* sub-contractors */

        $scope.subContractorsList = resp[1].data.list;
        /* control plans */

        $scope.controlPlanList = resp[2].data.list;
        $scope.controlPlanList.unshift({
          _id: null,
          systemTag: ''
        });
        /* checkList */

        $scope.allCheckList = resp[3].data.list;
        $log.log($scope.allCheckList);
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
      });
    };

    $scope.init();
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('addRegistration', {
    controller: addRegistrationController,
    controllerAs: 'vm',
    templateUrl: 'app/main/reports/add-registration/add-registration.view.html'
  });
  /** @ngInject */

  function addRegistrationController($scope, $state, $stateParams, apiFactory, $log, Bim, VP, utils, Notification, globals, $document, localStorageService, $uibModal) {
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore;
    vm.project = projectStore.get();
    vm.userData = userStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }
    /* registration types */


    $scope.registrationTypeList = [{
      label: "QA-Registration",
      value: "QA-Registration"
    }, {
      label: "Safety",
      value: "Safety"
    }, {
      label: "Issue",
      value: "Issue"
    }, {
      label: "Other",
      value: "Other"
    }];

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    }; // /* control method */
    // $scope.controlMethodList = [
    //   {label: 'Text', value: 'Text'},
    //   {label: 'Site Doc', value: 'Site Doc'},
    //   {label: 'Process Check', value: 'Process Check'}
    // ];


    $scope.m3dLevelList = [];
    vm.uploadImg = [];

    vm.changeImage = function (files) {
      if (angular.isUndefined(files[0])) return;
      vm.uploadImg[0] = files[0];
      $scope.imageURL = URL.createObjectURL(vm.uploadImg[0]);
      utils.getBase64(vm.uploadImg[0]).then(function (data) {
        return $scope.regData.uploadImg = data;
      });
    };

    $scope.change3dModel = function () {
      if (!$scope.isVP && $scope.regData.marker.info3d && $scope.regData.marker.info3d.modelId) {
        apiFactory.get3dModel($scope.regData.marker.info3d.modelId).then(function (resp) {
          var model = resp.data.data;

          if (model) {
            $scope.m3dLevelList = Bim.levelList(model);
            angular.element('#loading3d-container').removeClass('d-none');
            angular.element('#model3d-preview-container').hide();
            vm.viewer3d.clear();
            vm.viewer3d.loadBim(model).then(function () {
              angular.element('#loading3d-container').addClass('d-none');
              angular.element('#model3d-preview-container').show();

              if ($scope.regData.marker.info3d.clipping) {
                vm.viewer3d.loadClipping($scope.regData.marker.info3d.clipping);
              }

              $scope.change3dModelLevel();
            })["catch"](function (err) {
              $log.error(err);
              angular.element('#loading3d-container').addClass('d-none');
              angular.element('#model3d-preview-container').show();
              Notification.error('IFC file cannot open.');
            });
          }

          vm.viewer2d.initialize();
        })["catch"](function (e) {
          $log.error(e);
        });
      }
    };

    $scope.change3dModelLevel = function () {
      if (!$scope.regData.marker.info3d || !$scope.regData.marker.info3d.modelId || !vm.viewer3d || !$scope.regData.marker.info3d.level) {
        return;
      }

      if ($scope.regData.marker.info3d.level === 'All' || $scope.regData.marker.info3d.level === 'Others') {
        vm.viewer3d.showAllObject();
      } else {
        if ($scope.regData.marker.info3d.level) {
          vm.viewer3d.showObject($scope.regData.marker.info3d.level);
          changePlan(vm.viewer3d.getBimModel(), $scope.regData.marker.info3d.level);
        } else {
          $scope.regData.marker.info3d.level = 'All';
        }
      }

      if ($scope.regData.marker.info3d.location && $scope.regData.marker.info3d.location.x) {
        vm.viewer3d.loadMarkers([$scope.regData.marker.info3d.location]);
      } else {
        vm.viewer3d.loadMarkers([]);
      }
    };

    $scope.changeVP = function () {
      if (vm.viewervp && $scope.regData.marker && $scope.regData.marker.info3d && $scope.regData.marker.info3d.modelId && $scope.isVP) {
        var plan = $scope.vpList.find(function (x) {
          return x._id === $scope.regData.marker.info3d.modelId;
        });

        if (plan) {
          $scope.regData.marker.info3d.url = plan.url;
          $scope.regData.marker.info3d.pageNo = plan.pageNo;
          $scope.regData.level = plan.level;
          angular.element('#loadingvp-container').removeClass('d-none');
          angular.element('#vp-preview-container').hide();
          vm.viewervp.clear();
          vm.viewervp.loadBackgroundImageWidthHD(plan.url, plan.pageNo).then(function () {
            angular.element('#loadingvp-container').addClass('d-none');
            angular.element('#vp-preview-container').show();

            if ($scope.regData.marker.info3d.location && $scope.regData.marker.info3d.location.x) {
              vm.viewervp.loadMarkers([$scope.regData.marker.info3d.location]);
            }
          })["catch"](function (err) {
            $log.error(err);
          });
        }
      }
    };

    $scope.addRegistration = function () {
      var valid = vm.checkValidation();

      if (!valid.success) {
        Notification.error(valid.errorMsg);
        return;
      }

      if ($scope.regData.uploadImg) {
        $scope.regData.photo = utils.dataURLtoFile($scope.regData.uploadImg, 'issuePhoto');
        delete $scope.regData.uploadImg;
      }

      $scope.regData.reportId = vm.reportId;
      $scope.regData.projectId = projectStore.get()._id;
      $scope.regData.marker.modelType = $scope.isVP ? 'vp' : '3d';

      if ($scope.regData.marker.info2d && !$scope.regData.marker.info3d.level || $scope.regData.marker.modelType === 'vp') {
        delete $scope.regData.marker.info2d;
        delete $scope.regData.image2d;
      }

      if ($scope.regData._id) {
        vm.regId = $scope.regData._id;
      }

      if ($scope.regData.controlPlanItem) {
        $scope.regData.controlPlanItems = [$scope.regData.controlPlanItem];
      } // refine checkList of regData


      if (!utils.isEmpty($scope.regData) && !utils.isEmpty($scope.regData.checkList)) {
        var checkList = $scope.regData.checkList;
        var refinedCheckList = {
          _id: checkList._id,
          updatedAt: checkList.updatedAt,
          createdAt: checkList.createdAt,
          title: checkList.title,
          companyId: checkList.companyId,
          systemTag: checkList.systemTag,
          isActive: checkList.isActive,
          checkListItem: []
        };

        var _iterator = _createForOfIteratorHelper(checkList.checkListItem),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            refinedCheckList.checkListItem.push({
              _id: item._id,
              checkStatus: item.checkStatus,
              acceptStatus: item.acceptStatus,
              createIssueStatus: item.createIssueStatus,
              check: item.check,
              accept: item.accept,
              issueId: item.issueId
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $scope.regData.checkList = refinedCheckList;
      }

      if (vm.regId) {
        $scope.loading = true;
        apiFactory.updateReportRegistration(vm.regId, $scope.regData).then(function (resp) {
          $scope.loading = false;
          Notification.success(resp.data.message);
          localStorageService.set('regData', {});
          $state.go('reportsDetails', {
            id: vm.reportId
          });
        })["catch"](function (e) {
          $scope.loading = false;
          $log.error(e);
          localStorageService.set('regData', {});
          $state.go('reportsDetails', {
            id: vm.reportId
          });
        });
      } else {
        $scope.loading = true;
        apiFactory.addReportRegistration(vm.reportId, $scope.regData).then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message);
          localStorageService.set('regData', {});
          $state.go('reportsDetails', {
            id: vm.reportId
          });
        })["catch"](function (error) {
          $scope.loading = false;
          $log.error(error);
        });
      }
    };

    vm.updateVPPreview = function (model) {
      angular.element('#loading3d-container').removeClass('d-none');
      angular.element('#model3d-preview-container').hide();
      vm.viewer3d.clear();
      vm.viewer3d.loadBim(model).then(function () {
        angular.element('#loading3d-container').addClass('d-none');
        angular.element('#model3d-preview-container').show();
      })["catch"](function () {
        angular.element('#loading3d-container').addClass('d-none');
        angular.element('#model3d-preview-container').show();
        Notification.error('IFC file cannot open.');
      });
    };

    $scope.goAddMarking = function () {
      if ($scope.isVP) {
        $scope.regData.marker.modelType = 'vp';
      } else {
        $scope.regData.marker.modelType = '3d';
      }

      if ($scope.regData.marker && $scope.regData.marker.info3d && $scope.regData.marker.info3d.modelId) {
        localStorageService.set('regData', $scope.regData);
        $state.go('reportsMarking', {
          id: vm.reportId
        });
      } else {
        Notification.error('Please select model first.');
      }
    };

    $scope.cancelRegistration = function () {
      $state.go('reportsDetails', {
        id: vm.reportId
      });
    };

    $scope.$watch('checkListId', function () {
      if ($scope.checkListId) {
        if (utils.isEmpty($scope.regData) || utils.isEmpty($scope.report) || utils.isEmpty($scope.report.checkList)) {
          return;
        }

        $scope.regData.checkList = $scope.report.checkList.find(function (it) {
          return it._id == $scope.checkListId;
        });
      }
    });

    $scope.openUpdateChecklistModal = function () {
      var checkList = $scope.regData.checkList || $scope.report.checkList.find(function (it) {
        return it._id == $scope.checkListId;
      });

      if (utils.isEmpty(checkList)) {
        Notification.error('Please select a Checklist');
        return;
      }

      $uibModal.open({
        animation: true,
        component: 'updateChecklistModal',
        windowClass: 'update-checklist-modal',
        resolve: {
          checklist: function checklist() {
            return checkList;
          }
        }
      }).result.then(function (result) {
        $scope.regData.checkList = result;
      }, function () {});
    };

    vm.checkValidation = function () {
      var ret = {
        success: true,
        errorMsg: ''
      };
      var errorMsg = '';

      if (utils.isEmpty($scope.regData.registrationType)) {
        errorMsg = 'Please select the registration type.';
      } else if (utils.isEmpty($scope.regData.group)) {
        errorMsg = 'Please select the group.';
      }

      if (errorMsg.length) {
        ret.success = false;
        ret.errorMsg = errorMsg;
        $scope.goStep(1);
        return ret;
      }

      if ($scope.regData.drawings) {
        $scope.regData.drawings.forEach(function (item) {
          if (item.image2D) {
            $scope.regData.image2d = utils.dataURLtoFile(item.image2D, 'image2D');
          } else if (item.image3D) {
            $scope.regData.image3d = utils.dataURLtoFile(item.image3D, 'image3D');
          }
        });
        $scope.regData.drawings = undefined;
      } // $scope.regData.files = vm.uploadImg;


      if ($scope.regData.step === 2) {
        if (utils.isEmpty($scope.regData.marker.info3d.modelId)) {
          errorMsg = 'Please select a 3d model for new registration.';
        }
      }

      if (errorMsg.length) {
        ret.success = false;
        ret.errorMsg = errorMsg;
      }

      return ret;
    };

    $scope.goStep = function (step) {
      if (step > $scope.regData.step) {
        var valid = vm.checkValidation();

        if (!valid.success) {
          Notification.error(valid.errorMsg);
          return;
        }
      }

      $scope.regData.step = step;
      localStorageService.set('regData', $scope.regData);
    };

    $scope.exitCreateRegisteration = function () {
      localStorageService.set('regData', {});
      $state.go('reportsDetails', {
        id: vm.reportId
      });
    };

    function init() {
      /* 3d viewer */
      vm.viewer3d = Bim.markingViewer($document[0].getElementById('model3d-preview'));
      vm.viewer3d.initialize();
      vm.viewer3d.disableControl();
      /* 2d viewer */

      vm.viewer2d = Bim.planViewer($document[0].getElementById('model2d-preview'));
      vm.viewer2d.initialize();
      /* vp viewer */

      vm.viewervp = VP.markingViewer(angular.element('#vp-preview')[0]);
      vm.reportId = $stateParams.id;
      vm.regId = localStorageService.get('regId') || null;
      var apis = [apiFactory.getReportById(vm.reportId), apiFactory.getControlPlans({
        projectid: vm.project._id
      }), apiFactory.getAllReportTypes(), apiFactory.list3d(vm.project._id), apiFactory.getProjectRoofPlans(vm.project._id), apiFactory.listAllQshedAssets(vm.project._id)];
      $scope.regData = localStorageService.get('regData') || {};

      if (!vm.regId && angular.isDefined($scope.regData.step) && $scope.regData.step > 1) {
        if ($scope.regData.controlPlanItems && $scope.regData.controlPlanItems.length) {
          $scope.regData.controlPlanItem = $scope.regData.controlPlanItems[0];
        }
      } else if (vm.regId) {
        apis.push(apiFactory.getRegistrationById(vm.regId));
      }

      $scope.loading = true;
      Promise.all(apis).then(function (res) {
        $scope.loading = false;
        $scope.report = res[0].data.data;

        if (!$scope.regData.controlPlan) {
          $scope.regData.controlPlan = $scope.report.controlPlan;
        }

        $scope.controlPlanItems = $scope.report.controlPlan && $scope.report.controlPlan.plan ? $scope.report.controlPlan.plan : [];
        $scope.tagsList = res[2].data.list;
        /* 3d model */

        $scope.m3dList = res[3].data.data || [];
        /* vp plans */

        $scope.vpList = [];
        var list = res[4].data.data || [];

        for (var i = 0; i < list.length; i++) {
          var plan = list[i];
          $scope.vpList.push({
            _id: plan._id,
            title: plan.assetObj.title,
            url: plan.parentAsset.secure_url,
            pageNo: plan.assetObj.pageNo,
            level: plan.level
          });
        }

        list = res[5].data.list || [];

        for (var _i = 0; _i < list.length; _i++) {
          var asset = list[_i];
          $scope.vpList.push({
            _id: asset._id,
            title: asset.originalname,
            url: asset.secure_url,
            pageNo: 0,
            level: asset.level
          });
        }

        if (res[6]) {
          $scope.regData = res[6].data.data;
          $scope.checkListId = $scope.regData.checkList ? $scope.regData.checkList._id : undefined;
          var index = $scope.report.checkList.findIndex(function (x) {
            return x._id == $scope.checkListId;
          });

          if (index !== -1) {
            $scope.report.checkList[index] = $scope.regData.checkList;
          }

          if ($scope.regData.controlPlanItems && $scope.regData.controlPlanItems.length) {
            $scope.regData.controlPlanItem = $scope.regData.controlPlanItems[0];
          }

          $scope.regData.step = 1;

          if ($scope.regData.image) {
            $scope.imageURL = $scope.regData.image.secure_url;
          }

          $scope.regData.marker = angular.copy($scope.regData.marker.model);
          $scope.isVP = $scope.regData.marker && $scope.regData.marker.modelType === 'vp'; // localStorageService.set('regData', $scope.regData);
        }

        $scope.goStep($scope.regData.step || 1);
        $scope.isVP = $scope.regData.marker && $scope.regData.marker.modelType === 'vp';

        if (!$scope.regData.marker) {
          $scope.regData.marker = {
            modelType: '3d',
            info2d: {
              modelId: null,
              image: null,
              location: {
                x: 0,
                y: 0
              }
            },
            info3d: {
              level: null,
              modelId: null,
              image: null,
              location: {
                x: 0,
                y: 0,
                z: 0
              }
            }
          };
        }

        if ($scope.isVP) {
          $scope.changeVP();
        } else {
          $scope.change3dModel();
        }
      })["catch"](function (error) {
        $scope.loading = false;
        $log.log(error);
      });
    }

    init();

    function changePlan(bimModel, levelId) {
      if (!bimModel || !levelId || !vm.viewer2d) {
        return;
      }

      angular.element('#loading2d-container').removeClass('d-none');
      angular.element('#model2d-preview-container').hide();
      vm.viewer2d.loadBimModel(bimModel, levelId).then(function () {
        angular.element('#loading2d-container').addClass('d-none');
        angular.element('#model2d-preview-container').show();

        if ($scope.regData.marker.info2d && $scope.regData.marker.info2d.location && $scope.regData.marker.info2d.location.x) {
          vm.viewer2d.loadMarkers([$scope.regData.marker.info2d.location]);
        } else {
          vm.viewer2d.loadMarkers([]);
        }
      })["catch"](function (err) {
        angular.element('#loading2d-container').addClass('d-none');
        angular.element('#model2d-preview-container').show();
        $log.error(err);
      });
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('workOrderList', {
    controller: WorkOrderListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/projects/workOrderList/workOrderList.view.html'
  });
  /** @ngInject */

  function WorkOrderListController($scope, $uibModal) {
    var vm = this;

    $scope.toggleCreateWorkOrderModal = function () {
      $uibModal.open({
        animation: true,
        component: 'createWorkOrderModal',
        windowClass: 'create-work-order-modal'
      });
    };

    $scope.itemPerPage = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.numPerPage = 12;
    vm.workOrderFields = [{
      id: "",
      title: "Created On"
    }, {
      id: "",
      title: "#WO"
    }, {
      id: "",
      title: "Status"
    }, {
      id: "",
      title: "Client Name"
    }, {
      id: "",
      title: "Work Order Title"
    }, {
      id: "",
      title: "Priority"
    }, {
      id: "",
      title: "Assigned To"
    }, {
      id: "",
      title: "Expected Productions Date"
    }];
    vm.workOrderList = [{
      createdOn: "08/08/2021",
      wo: "#33886",
      status: "Complete",
      clientName: "Flynn Rider",
      workOrderTitle: "Replace Vaccum Filter",
      priority: "low",
      assignedTo: "Livia Bator",
      expectedProductionsDate: "08/08/2021"
    }, {
      createdOn: "08/08/2021",
      wo: "#33886",
      status: "Complete",
      clientName: "Flynn Rider",
      workOrderTitle: "Replace Vaccum Filter",
      priority: "high",
      assignedTo: "Livia Bator",
      expectedProductionsDate: "08/08/2021"
    }, {
      createdOn: "08/08/2021",
      wo: "#33886",
      status: "Complete",
      clientName: "Flynn Rider",
      workOrderTitle: "Replace Vaccum Filter",
      priority: "medium",
      assignedTo: "Livia Bator",
      expectedProductionsDate: "08/08/2021"
    }];
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('projectList', {
    controller: ProjectListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/projects/projectList/projectList.view.html'
  });
  /** @ngInject */

  function ProjectListController($scope, apiFactory, $log, $state, $timeout, $uibModal, Notification, globals, storageFactory) {
    var vm = this;
    $scope.projectType = "Project";
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.PROJECT_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);

    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }]; // if (vm.userData.designation === "Admin") {
    //   $scope.PROJECT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.PROJECT]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.PROJECT_ACCESS_CREATE = res.data.data[Constants.AccessKey.PROJECT];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later');
    //     });
    // }

    $scope.fetchProjects = function (type) {
      $scope.projectType = type;
      if (vm.currentPage > 1) vm.currentPage = 1;
      $scope.fetchAllProjects();
    };

    $scope.isGrid = true;
    $scope.status = [{
      _id: 0,
      name: 'Ongoing',
      isChecked: false
    }, {
      _id: 1,
      name: 'Completed',
      isChecked: false
    }, {
      _id: 2,
      name: 'Tender',
      isChecked: true
    }, {
      _id: 3,
      name: 'Offer',
      isChecked: false
    }, {
      _id: 4,
      name: 'Cancelled',
      isChecked: true
    }, {
      _id: 5,
      name: 'Lost',
      isChecked: true
    }];
    $scope.clients = [];
    $scope.totalCount = 0; // $scope.numPerPage = globals.numPerPage();

    $scope.numPerPage = 12;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    vm.searchText = undefined;
    $scope.isLoading = true;

    $scope.fetchAllProjects = function () {
      $scope.isLoading = true;
      var api = 'listAllProjects';
      apiFactory[api]({
        search: vm.searchText,
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: 'createdAt',
        sortType: 'false',
        type: $scope.projectType
      }).then(function (resp) {
        vm.projectList = resp.data.list;

        var _iterator = _createForOfIteratorHelper(vm.projectList),
            _step;

        try {
          var _loop = function _loop() {
            var item = _step.value;
            item.displayAddress = '';

            if (item.address && item.address.loc) {
              item.displayAddress = item.address.loc.position;
            }

            var selectedItem = vm.selectedProject.find(function (it) {
              return it._id == item._id;
            });

            if (selectedItem) {
              item.index = true;
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $scope.isLoading = false;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    };

    $scope.fetchAllProjects();
    vm.sortParams = {
      field: "created",
      type: false
    };
    vm.bookmarks = [];
    storageFactory.getBookmarks().then(function (resp) {
      vm.bookmarks = resp.data.bookmarks;
    })["catch"](function (err) {
      $log.error(err);
    });
    /* Function to sort projects */

    vm.sort = function (field) {
      $scope.isLoading = true;

      if (vm.sortParams.field === field) {
        vm.sortParams.type = !vm.sortParams.type;
      } else {
        vm.sortParams.field = field;
        vm.sortParams.type = true;
      }

      storageFactory.listAllProjects({
        search: vm.searchText,
        chunk: $scope.numPerPage,
        page: 1,
        sort: vm.sortParams.field,
        sortType: vm.sortParams.type
      }).then(function (resp) {
        vm.projectList = resp.data.list;
        $scope.isLoading = false; // $scope.totalCount = resp.data.total;

        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (e) {
        $scope.isLoading = false;
        $log.log(e);
      });
    };

    $scope.selProject = function (project) {
      $scope.$root.$emit('on-select-project', project);
      $timeout(function () {
        $scope.goDashboard();
      }, 100);
    };

    $scope.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchAllProjects();
    };

    vm.selectedProject = [];

    $scope.selProjectForInvite = function (project) {
      var item = vm.selectedProject.find(function (it) {
        return it._id == project._id;
      });

      if (item) {
        var index = vm.selectedProject.indexOf(item);
        vm.selectedProject.splice(index, 1);
      } else {
        vm.selectedProject.push(project);
      }
    };

    $scope.goToDetail = function (project) {
      $state.go('projectDetail', {
        id: project._id
      });
    };

    $scope.goToCreate = function () {
      $state.go('createProject');
    };

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      $scope.fetchAllProjects();
    };

    $scope.isBookmark = function (project) {
      return vm.bookmarks.findIndex(function (x) {
        return x._id === project._id;
      }) >= 0;
    };

    $scope.bookmarkProject = function (project) {
      var bookmarked = $scope.isBookmark(project);
      apiFactory.bookMarkProject(project._id, !bookmarked).then(function () {
        if (bookmarked) {
          var index = vm.bookmarks.findIndex(function (x) {
            return x._id === project._id;
          });

          if (0 <= index) {
            vm.bookmarks.splice(index, 1);
          }
        } else {
          vm.bookmarks.push(project);
        }

        $scope.$broadcast('bookmark:reload');
        Notification.success('Bookmark is succeed.');
      })["catch"](function (err) {
        Notification.success('Failed to bookmark.');
        $log.error(err);
      });
    };

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('projectDetail', {
    controller: ProjectDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/projects/projectDetail/projectDetail.view.html'
  });
  /** @ngInject */

  function ProjectDetailController($scope, $stateParams, apiFactory, $timeout, globals, $uibModal, Notification, $log, $state, unitFactory, $filter) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore,
        userStore = globals.userStore;
    vm.projectType = "None";
    vm.companyData = companyStore.get();
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.PROJECT_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.PROJECT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.PROJECT]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.PROJECT_ACCESS_CREATE = res.data.data[Constants.AccessKey.PROJECT];
    //   })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    var id = $stateParams.id;
    vm.gmap = {
      url: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&libraries=places",
      markers: [],
      styles: [],
      center: "41,-87",
      zoom: 3
    };
    init();

    function init() {
      $scope.isLoading = true;
      apiFactory.getProjectById(id).then(function (resp) {
        vm.projectData = resp.data;
        vm.projectImage = vm.projectData.projectImage;

        if (vm.projectData.companyId) {
          apiFactory.getCompanyById(vm.projectData.companyId).then(function (resp) {
            vm.projectData.companyName = resp.data.companyName;
            $scope.isLoading = false;
          });
        }

        prepareProjectData();
        $log.log(vm.projectData);

        if (vm.projectData.address && vm.projectData.address.loc) {
          var placeData = {
            lat: vm.projectData.address.loc.coordinates[0],
            lng: vm.projectData.address.loc.coordinates[1]
          };
          vm.gmap.markers = [[placeData.lat, placeData.lng]];
          vm.gmap.zoom = 15;
          vm.gmap.center = "".concat(placeData.lat, ",").concat(placeData.lng);
        }
      });
    }

    function prepareProjectData() {
      var projectStatus = ["Offer", "Ongoing", "Completed", "Cancel", "Lost", "Postponed"];
      vm.p_status = angular.isUndefined(vm.projectData.projectStatus) ? '' : projectStatus[vm.projectData.projectStatus];
      if (vm.projectData.isServiceProject == true) vm.projectType = 'Service';else if (vm.projectData.isTenderProject == true) {
        if (angular.isDefined(vm.projectData.tenderDate)) vm.projectData.tenderDate = moment(vm.projectData.tenderDate).format("YYYY/MM/DD");
        if (vm.projectData.isPublicTender) vm.projectType = 'Public Tender';else vm.projectType = 'Private Tender';
      }
      vm.uploadImg = vm.projectData.serviceProjectData.files.images;
      vm.uploadFiles = vm.projectData.serviceProjectData.files.docs;
      vm.projectData.startDateFormated = vm.projectData.startDate ? moment(vm.projectData.startDate).format("YYYY/MM/DD") : null;
      vm.projectData.endDateFormated = vm.projectData.endDate ? moment(vm.projectData.endDate).format("YYYY/MM/DD") : null;
      vm.projectData.startDateFormated = $filter('date')(vm.projectData.startDate, "dd/MM/yyyy", "UTC");
      vm.projectData.endDateFormated = $filter('date')(vm.projectData.endDate, "dd/MM/yyyy", "UTC");

      if (vm.projectData.address && vm.projectData.address.loc) {
        vm.address = vm.projectData.address.loc.position;
      }

      if (vm.companyData.companyInputMethod == 'British/American et al.') {
        vm.projectData.addressLocationOffset = vm.projectData.addressLocationOffset * unitFactory.meterToFeetRate;
      }

      if (vm.projectType == 'Service') {
        if (vm.projectData.serviceProjectData && angular.isDefined(vm.projectData.serviceProjectData.description)) vm.projectData.service_description = vm.projectData.serviceProjectData.description;
        if (vm.projectData.serviceProjectData && angular.isDefined(vm.projectData.serviceProjectData.date)) vm.projectData.date = moment(vm.projectData.serviceProjectData.date).format("YYYY/MM/DD");
        if (vm.projectData.serviceProjectData && angular.isDefined(vm.projectData.serviceProjectData.assignedTo)) vm.projectData.assignedTo = vm.projectData.serviceProjectData.assignedTo; // $scope.$evalAsync(function() {
        //   // angular.element('#assignedTo').select2('val', vm.projectData.assignedTo);
        //   // angular.element("#serviceDate").val(vm.projectData.date);
        //   $timeout(() => {
        //     // angular.element('#assignedTo').trigger("change");
        //     // angular.element("#serviceDate").trigger("change")
        //    },300);
        //   $timeout(() => {            
        //     vm.projectData.startDateFormated = moment(vm.projectData.startDate).format("YYYY/MM/DD");
        //     vm.projectData.endDateFormated = moment(vm.projectData.endDate).format("YYYY/MM/DD");
        //     if (vm.projectData.serviceProjectData) {
        //       vm.projectData.date = moment(vm.projectData.serviceProjectData.date).format("YYYY/MM/DD");
        //     }
        //   // angular.element("#serviceDate").trigger("change")
        //   },1000);
        // });        
      }

      if (vm.projectData.staff) {
        if (vm.projectData.client && vm.projectData.client.staffs.length > 0) {
          var find = vm.projectData.client.staffs.find(function (elem) {
            return elem._id === vm.projectData.staff;
          });

          if (find) {
            vm.staffName = find.displayName || "".concat(find.firstName, " ").concat(find.lastName);
          }
        }
      }
    }

    vm.deleteProject = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          apiFactory.deleteProject(id).then(function () {
            Notification.success("Project deleted successfully.");
            projectStore.reset();
            vm.projectData = undefined;
            $state.go('projectList');
          })["catch"](function (err) {
            $log.error(err);
            Notification.failed("Project delete failed.");
          });
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.goToCreate = function () {
      $state.go('updateProject', {
        id: id
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('createProject', {
    controller: CreateProjectController,
    controllerAs: 'vm',
    templateUrl: 'app/main/projects/createProject/createProject.view.html'
  });
  /** @ngInject */

  function CreateProjectController($scope, apiFactory, Notification, NgMap, globals, $log, $state, $location, $stateParams, $timeout, utils) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.projectType = $location.url() == "/createServiceProject" ? "Service" : "None";
    vm.clients = [];
    $scope.staffs = [];
    vm.buildingTypeList = [];
    vm.enterpriseTypeList = [];
    vm.companyData = companyStore.get();
    vm.selectedHierarchyTemplate = undefined;
    var id = $stateParams.id;
    vm.gmap = {
      url: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&libraries=places",
      markers: [],
      styles: [],
      center: "41,-87",
      zoom: 3
    };
    vm.projectStatus = [{
      _id: 0,
      name: 'Offer'
    }, {
      _id: 1,
      name: 'Ongoing'
    }, {
      _id: 2,
      name: 'Completed'
    }, {
      _id: 3,
      name: 'Cancel'
    }, {
      _id: 4,
      name: 'Lost'
    }, {
      _id: 5,
      name: 'Postponed'
    }, {
      _id: 6,
      name: 'Precast'
    }];
    vm.projectData = {};
    $scope.isLoading = true;
    Promise.all([apiFactory.listAllClients(), apiFactory.listAllBuildingTypes(), apiFactory.listAllEnterpriseTypes(), apiFactory.getHierarchyTemplates()]).then(function (resp) {
      $scope.isLoading = false;
      vm.clients = resp[0].data.list;
      vm.buildingTypeList = resp[1].data.list;
      vm.enterpriseTypeList = resp[2].data.list;
      vm.hierarchyTemplates = resp[3].data.list;

      if (!id) {
        vm.edit_project_mode = 0;
        var startDate = new Date();
        startDate.setHours(0, 0, 0, 0);
        var endDate = new Date();
        endDate.setHours(23, 59, 59, 999);
        vm.projectData = {
          endDateFormated: endDate,
          startDateFormated: startDate,
          date: new Date()
        };
      } else {
        vm.edit_project_mode = 1;
        $scope.isLoading = true;
        apiFactory.getProjectById(id).then(function (resp) {
          $scope.isLoading = false;
          vm.projectData = resp.data;
          vm.clientIdBackUp = vm.projectData.client ? vm.projectData.client._id : null;
          vm.staffIdTemp = vm.projectData.staff ? vm.projectData.staff._id : null;
          prepareProjectData();
          markCurrentLoc();
        })["catch"](function (err) {
          $log.error(err);
          $scope.isLoading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      }
    })["catch"](function (e) {
      $log.log(e);
    });
    apiFactory.getAllEmployees({
      isActive: true
    }).then(function (resp) {
      vm.companyUsers = resp.data.list;
    })["catch"](function (err) {
      Notification.error(err.data.message);
    });

    vm.onSelassignedTo = function (assignedToId) {
      if (assignedToId && vm.companyUsers) {
        for (var i = 0; i < vm.companyUsers.length; i++) {
          if (vm.companyUsers[i]._id === assignedToId) {
            vm.projectData.assignedTo = [vm.companyUsers[i]._id];
            return;
          }
        }
      }
    };

    vm.projectData.address = {};

    vm.changeClient = function (clientIdTemp) {
      if (clientIdTemp) {
        for (var i = 0; i < vm.clients.length; i++) {
          if (vm.clients[i]._id === clientIdTemp) {
            vm.projectData.client = vm.clients[i];
          }
        }

        var client = vm.projectData.client;

        if (client.companyId) {
          apiFactory.getCompanyById(client.companyId).then(function (resp) {
            vm.projectData.companyName = resp.data.companyName;
          });
        }

        if (client.address && client.address.length > 0) {
          var location = vm.projectData.address ? vm.projectData.address.loc : null;
          vm.projectData.address = client.address[0] || {};
          vm.projectData.address.loc = location ? location : vm.projectData.address.loc;
        }

        if (client.clientContact) {
          vm.projectData.clientContact = client.clientContact || {};
        }

        if (client.staffs && client.staffs.length > 0) {
          $scope.staffs = [];

          var _iterator = _createForOfIteratorHelper(client.staffs),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var staff = _step.value;
              $scope.staffs.push(staff);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          $timeout(function () {
            $log.log($scope.staffs);
            $scope.$apply();
          });
        }
      }
    };

    vm.changeStaff = function (staffIdTemp) {
      if (staffIdTemp) {
        vm.projectData.staff = $scope.staffs.find(function (x) {
          return x._id == staffIdTemp;
        });
      }
    };

    vm.placeMarker = function () {
      var _this = this;

      $timeout(function () {
        var placeData = _this.getPlace().geometry.location;

        vm.gmap.markers = [[placeData.lat(), placeData.lng()]];
        vm.gmap.zoom = 15;
        vm.gmap.center = "".concat(placeData.lat(), ",").concat(placeData.lng());

        if (angular.isUndefined(vm.projectData.address)) {
          vm.projectData.address = {};
        }

        vm.projectData.address.loc = {
          coordinates: [placeData.lat(), placeData.lng()],
          position: vm.address
        };
      });
    };

    globals.getCurrency().then(function (resp) {
      vm.getCurrencyCode = resp.data;
      $scope.companyCurrency = vm.getCurrencyCode.find(function (element) {
        return element.cc === vm.companyData.currentCurrency.currencyCode;
      });
    });

    function saveCalcSheet(projectId) {
      vm.workerCost = vm.companyData.averageWorkerCost;
      vm.globalCompanyCost = vm.companyData.companyCost;

      if (vm.companyData.profit) {
        vm.globalProfit = vm.companyData.profit;
      } else {
        vm.globalProfit = 0;
      }

      var sheetData = {
        additionalCosts: [],
        averageWorkerCost: vm.workerCost,
        companyCost: vm.globalCompanyCost,
        companyCurrency: $scope.companyCurrency,
        companyProfit: vm.globalProfit,
        hierarchicalCostSeqLast: 0,
        lastGroupId: 0,
        levels: [],
        projectId: projectId,
        sum: 0,
        sumWithAdditionalCost: 0,
        totalCompanyCost: 0,
        totalCostPrice: 0,
        totalProfit: 0,
        totalWorkHours: 0,
        totalInventoryCost: 0,
        totalWorkerCost: 0,
        versionMessage: ''
      };
      apiFactory.createSheet({
        sheet: sheetData
      }).then(function () {
        Notification.success("Project has created successfully");
        $state.go('projectList');
      })["catch"](function (e) {
        $log.log(e);
        Notification.error("Something went wrong");
      });
    }

    vm.addProject = function (formData) {
      if (!vm.clientIdTemp) {
        Notification.error("Please select client.");
        return;
      }

      if (!formData.projectName || formData.projectName === '') {
        Notification.error("Please input Project Name!");
        return;
      }

      if (!formData.buildingType || formData.buildingType === '') {
        Notification.error("Please input building type.");
        return;
      }

      if (!formData.enterpriseType || formData.enterpriseType === '') {
        Notification.error("Please input enterprise type.");
        return;
      }

      if (angular.isUndefined(vm.projectData.projectStatus) || vm.projectData.projectStatus === '') {
        Notification.error("Please select project status.");
        return;
      } else {
        formData.projectStatus = vm.projectData.projectStatus;
      }

      if (!formData.address || !formData.address.loc || utils.isEmpty(formData.address.loc.position) || utils.isEmpty(formData.address.loc.coordinates) || formData.address.loc.coordinates[0] === 0 && formData.address.loc.coordinates[1] === 0) {
        Notification.error('Please select correct location');
        return;
      }

      formData.client = formData.client ? formData.client._id : undefined;

      if (vm.projectData.staff) {
        formData.staff = vm.projectData.staff;
      }

      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);

      if (vm.projectType === 'Service') {
        formData.isServiceProject = true;
        formData.isTenderProject = false;
      } else if (vm.projectType === 'Public Tender' || vm.projectType === 'Private Tender') {
        formData.isServiceProject = false;
        formData.isTenderProject = true;
        formData.tenderDate = moment(formData.tenderDate).format();
        formData.isPublicTender = vm.projectType === 'Public Tender';
      } else if (vm.projectType === 'None') {
        formData.isTenderProject = false;
        formData.isServiceProject = false;
      }

      formData.serviceProjectData = {};

      if (formData.isServiceProject) {
        if (formData.date) {
          if (!isNaN(formData.date.getTime())) {
            // d.valueOf() could also work
            formData.serviceProjectData.date = moment(formData.date).format();
          } else {
            delete formData.date;
          }
        }

        formData.serviceProjectData.assignedTo = formData.assignedTo;
        formData.serviceProjectData.description = formData.service_description;
        formData.serviceProjectData.files = {
          images: [],
          docs: []
        };

        if (vm.uploadImg) {
          formData.serviceProjectData.files.images = vm.uploadImg;
        }

        if (vm.uploadFiles) {
          formData.serviceProjectData.files.docs = vm.uploadFiles;
        }
      } else {
        if (formData.date && isNaN(formData.date.getTime())) {
          delete formData.date;
        }

        formData.serviceProjectData = {
          date: moment(formData.date).format(),
          assignedTo: formData.assignedTo,
          description: formData.service_description,
          files: {
            images: [],
            docs: []
          }
        };
      }

      formData.endDateFormated.setHours(23, 59, 59, 999);
      formData.startDate = moment(new Date(formData.startDate)).format();
      formData.endDate = moment(new Date(formData.endDate)).format();
      formData.progress = formData.progress ? formData.progress : 0;

      if (!utils.isValidDuration(new Date(formData.startDate), new Date(formData.endDate))) {
        Notification.error("Invalid Start and End Time.");
        return;
      } // $log.log(formData)


      if (vm.projectImage && vm.projectImage.name) {
        formData.projectImageFile = vm.projectImage;
      }

      if (vm.selectedHierarchyTemplate) {
        formData.hierarchyTemplateId = vm.selectedHierarchyTemplate;
      }

      if (formData.isServiceProject) {
        if (vm.edit_project_mode === 0) {
          $scope.isLoading = true;
          apiFactory.createProject(formData).then(function (res) {
            $scope.isLoading = false;
            saveCalcSheet(res.data._id);
          })["catch"](function (e) {
            $scope.isLoading = false;
            $log.log(e);
            if (e.data && e.data.message) Notification.error(e.data.message);else Notification.error("Something went wrong");
          });
        } else {
          $scope.isLoading = true;
          apiFactory.updateProject(vm.projectData._id, formData).then(function (resp) {
            $scope.isLoading = false;
            Notification.success(resp.data.message);
            $state.go('projectList');
            projectStore.update(resp.data.data);
          })["catch"](function (e) {
            $log.log(e);
            $scope.isLoading = false;
            if (e.data && e.data.message) Notification.error(e.data.message);else Notification.error("Something went wrong");
          });
        }
      } else {
        formData.serviceProjectData = {};

        if (vm.edit_project_mode === 0) {
          $scope.isLoading = true;
          apiFactory.createProject(formData).then(function (res) {
            $scope.isLoading = false;
            saveCalcSheet(res.data._id);
          })["catch"](function (e) {
            $log.log(e);
            $scope.isLoading = false;
            if (e.data && e.data.message) Notification.error(e.data.message);else Notification.error("Something went wrong");
          });
        } else {
          $scope.isLoading = true;
          apiFactory.updateProject(vm.projectData._id, formData).then(function (resp) {
            $scope.isLoading = false;
            vm.edit_project_mode = 0;
            Notification.success(resp.data.message);
            projectStore.update(resp.data.data);
            $state.go('projectList');
          })["catch"](function (e) {
            $log.log(e);
            $scope.isLoading = false;
            if (e.data && e.data.message) Notification.error(e.data.message);else Notification.error("Something went wrong");
          });
        }
      }
    };

    vm.updateMarker = function () {
      var pos = this.getPosition();
      vm.projectData.address.loc = {
        coordinates: [pos.lat(), pos.lng()],
        position: vm.address
      };
    };

    NgMap.getMap("service_map").then(function (map) {
      vm.map = map;
      map.setOptions({
        styles: vm.gmap.styles,
        disableDefaultUI: true,
        mapTypeControl: true,
        mapTypeId: 'satellite',
        zoomControl: true,
        zoom: 1,
        center: {
          lat: 0,
          lng: 0
        }
      });
    });
    vm.inputImg = [];
    vm.uploadImg = [];
    vm.inputFiles = [];
    vm.uploadFiles = [];
    vm.projectImages = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x) {
        x.description = "";

        if (modal === "image") {
          if (vm.uploadImg.length === 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (modal === 'projectImage') {
          vm.projectImage = x;
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.deleteFile = function (indexVal, type) {
      if (type === "image") {
        vm.uploadImg.splice(indexVal, 1);
      } else {
        vm.uploadFiles.splice(indexVal, 1);
      }
    };

    function prepareProjectData() {
      vm.projectImage = vm.projectData.projectImage;
      vm.clientIdTemp = vm.projectData.client ? vm.projectData.client._id : null;
      vm.projectData.buildingType = vm.projectData.buildingType ? vm.projectData.buildingType._id : null;
      vm.projectData.enterpriseType = vm.projectData.enterpriseType ? vm.projectData.enterpriseType._id : null;
      vm.assignedToId = vm.projectData.serviceProjectData.assignedTo[0] ? vm.projectData.serviceProjectData.assignedTo[0]._id : null;
      var projectStatus = ["Offer", "Ongoing", "Completed", "Cancel", "Lost", "Postponed", "Precast"];
      vm.projectStatusId = angular.isUndefined(vm.projectData.projectStatus) ? '' : projectStatus[vm.projectData.projectStatus];

      if (vm.projectData.isServiceProject === true) {
        vm.projectType = 'Service';
      } else if (vm.projectData.isTenderProject === true) {
        if (angular.isDefined(vm.projectData.tenderDate)) {
          vm.projectData.tenderDate = new Date(vm.projectData.tenderDate);
        }

        if (vm.projectData.isPublicTender) {
          vm.projectType = 'Public Tender';
        } else {
          vm.projectType = 'Private Tender';
        }
      }

      vm.projectData.startDateFormated = new Date(vm.projectData.startDate);
      vm.projectData.endDateFormated = new Date(vm.projectData.endDate);
      vm.projectData.startDate = new Date(vm.projectData.startDate);
      vm.projectData.endDate = new Date(vm.projectData.endDate);

      if (vm.projectData.address && vm.projectData.address.loc) {
        vm.address = vm.projectData.address.loc.position;
      } // if (vm.companyData.companyInputMethod=='British/American et al.') {
      //   vm.projectData.addressLocationOffset = vm.projectData.addressLocationOffset * unitFactory.meterToFeetRate;
      // }


      if (vm.projectType === 'Service') {
        vm.uploadImg = vm.projectData.serviceProjectData.files.images;
        vm.uploadFiles = vm.projectData.serviceProjectData.files.docs;
        if (vm.projectData.serviceProjectData && angular.isDefined(vm.projectData.serviceProjectData.description)) vm.projectData.service_description = vm.projectData.serviceProjectData.description;
        if (vm.projectData.serviceProjectData && angular.isDefined(vm.projectData.serviceProjectData.date)) vm.projectData.date = new Date(vm.projectData.serviceProjectData.date);
        if (vm.projectData.serviceProjectData && angular.isDefined(vm.projectData.serviceProjectData.assignedTo)) vm.projectData.assignedTo = vm.projectData.serviceProjectData.assignedTo;
        $scope.$evalAsync(function () {
          // angular.element('#assignedTo').select2('val', vm.projectData.assignedTo);
          // angular.element("#serviceDate").val(vm.projectData.date);
          // $timeout(() => {
          // angular.element('#assignedTo').trigger("change");
          // angular.element("#serviceDate").trigger("change")
          // },300);
          $timeout(function () {
            vm.projectData.startDateFormated = new Date(vm.projectData.startDate);
            vm.projectData.endDateFormated = new Date(vm.projectData.endDate);

            if (vm.projectData.serviceProjectData) {
              vm.projectData.date = new Date(vm.projectData.serviceProjectData.date);
            } // angular.element("#serviceDate").trigger("change")

          }, 1000);
        });
      }
    }

    function markCurrentLoc() {
      if (vm.projectData.address && vm.projectData.address.loc) {
        var placeData = {
          lat: vm.projectData.address.loc.coordinates[0],
          lng: vm.projectData.address.loc.coordinates[1]
        };
        vm.gmap.markers = [[placeData.lat, placeData.lng]];
        vm.gmap.zoom = 15;
        vm.gmap.center = "".concat(placeData.lat, ",").concat(placeData.lng);
      }
    }
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('warehouseOrders', {
    controller: WarehouseOrdersController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/warehouseOrders/warehouseOrders.view.html'
  });
  /** @ngInject */

  function WarehouseOrdersController($scope, utils, $state, apiFactory, $log, globals, Notification, $uibModal) {
    var vm = this;
    vm.currencyCode = globals.companyStore.get().currentCurrency.currencyCode;
    $scope.activemenu = "warehouseOrders";
    $scope.filtertypelistvalue1 = '1';
    $scope.filtertypelist1 = [{
      _id: '1',
      tagName: "Bulk Actions"
    }];
    $scope.filtertypelistvalue2 = '1';
    $scope.filtertypelist2 = [{
      _id: '1',
      tagName: "Select a Category"
    }];
    $scope.filtertypelistvalue3 = '1';
    $scope.filtertypelist3 = [{
      _id: '1',
      tagName: "Filter By Supplier"
    }];
    $scope.filtertypelistvalue4 = '1';
    $scope.filtertypelist4 = [{
      _id: '1',
      tagName: "Filter by Stock Level"
    }];
    $scope.utils = utils;
    $scope.subType = 'materials';

    $scope.changeSubTab = function (subType) {
      vm.selectedAll = false;
      $scope.subType = subType;
      $scope.fetchData();
    };

    $scope.totalCount = 0;
    $scope.numPerPage = 10;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.periods = [{
      id: '5',
      name: '5'
    }, {
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '50',
      name: '50'
    }];

    $scope.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchData();
    };

    vm.warehouseOptions = [];
    $scope.filterDates = [];

    $scope.initData = function () {
      $scope.isLoading = true;
      apiFactory.listAllWarehouses().then(function (resp) {
        vm.currentWarehouse = resp.data.list[0]._id;
        vm.warehouseOptions = resp.data.list.map(function (item) {
          return {
            label: item.name,
            value: item._id
          };
        });
        $scope.fetchData();
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    };

    $scope.initData();

    $scope.searchData = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      if ($scope.subType === 'materials' || $scope.subType === 'lowStatus') {
        $scope.isLoading = true;
        apiFactory.listWarehouseMaterials({
          page: vm.currentPage,
          chunk: $scope.numPerPage,
          search: vm.searchText,
          warehouseId: vm.currentWarehouse,
          lowStatus: $scope.subType === 'lowStatus'
        }).then(function (resp) {
          $scope.isLoading = false;
          vm.materials = resp.data.list;

          var _iterator = _createForOfIteratorHelper(vm.materials),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var material = _step.value;
              material.warehouseStatus = material.qty <= 0 ? 'Low' : material.qty >= 10 ? 'High' : 'Medium';
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          $scope.totalCount = resp.data.total;
          $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
        })["catch"](function (e) {
          $log.error(e);
          $scope.isLoading = false;
          Notification.error(utils.getErrorMessage(e));
        });
      } else if ($scope.subType === 'matGroup') {
        $scope.isLoading = true;
        apiFactory.listWarehouseMatGroups({
          page: vm.currentPage,
          chunk: $scope.numPerPage,
          search: vm.searchText,
          warehouseId: vm.currentWarehouse
        }).then(function (resp) {
          $scope.isLoading = false;
          vm.materialGroups = resp.data.list;

          var _iterator2 = _createForOfIteratorHelper(vm.materialGroups),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var matGroup = _step2.value;
              matGroup.warehouseStatus = matGroup.qty < 10 ? 'Low' : matGroup.qty >= 20 ? 'High' : 'Medium';
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          $scope.totalCount = resp.data.total;
          $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
        })["catch"](function (e) {
          $log.error(e);
          $scope.isLoading = false;
          Notification.error(utils.getErrorMessage(e));
        });
      } else if ($scope.subType === 'supplier') {
        $scope.isLoading = true;
        apiFactory.listWarehouseSuppliers({
          page: vm.currentPage,
          chunk: $scope.numPerPage,
          search: vm.searchText,
          warehouseId: vm.currentWarehouse
        }).then(function (resp) {
          $scope.isLoading = false;
          vm.suppliers = resp.data.list;

          var _iterator3 = _createForOfIteratorHelper(vm.suppliers),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var supplier = _step3.value;
              supplier.warehouseStatus = supplier.qty < 10 ? 'Low' : supplier.qty >= 20 ? 'High' : 'Medium';
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          $scope.totalCount = resp.data.total;
          $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
        })["catch"](function (e) {
          $log.error(e);
          $scope.isLoading = false;
          Notification.error(utils.getErrorMessage(e));
        });
      } else {
        $scope.totalCount = 0;
        $scope.noOfPages = 0;
        vm.currentPage = 1;
      }
    };

    $scope.getCurrentWarehouseLabel = function () {
      var find = vm.warehouseOptions.find(function (x) {
        return x.value === vm.currentWarehouse;
      });
      return find ? find.label : 'Warehouse';
    };

    $scope.getStatusTagColor = function (status) {
      var find = $scope.statusTagColors.find(function (elem) {
        return elem.key == status;
      });

      if (find) {
        return {
          color: find.color,
          bgColor: find.bgColor
        };
      } else {
        return {
          color: '#FF8B00',
          bgColor: '#FFE8CC'
        };
      }
    };

    $scope.statusTagColors = [{
      key: 'Low',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'Medium',
      color: '#367BF5',
      bgColor: '#E5EFFF'
    }, {
      key: 'High',
      color: '#2FA84F',
      bgColor: '#DCF7E3'
    }];
    $scope.paymentTagColors = [{
      key: 'paid',
      color: '#2FA84F'
    }, {
      key: 'unpaid',
      color: '#FF7934'
    }, {
      key: 'overdue',
      color: '#D71414'
    }, {
      key: 'partially_paid',
      color: '#367BF5'
    }, {
      key: 'open',
      color: '#00AACE'
    }, {
      key: 'draft',
      color: '#747474'
    }, {
      key: 'void',
      color: '#FF8B00'
    }];

    $scope.updatedDateFilter = function (dates) {
      $scope.filterDates = dates;
      $scope.fetchData();
    };

    $scope.showDetail = function (type, _data) {
      $uibModal.open({
        animation: true,
        component: 'OrderDetailModal',
        windowClass: 'order-detail-modal',
        resolve: {
          data: function data() {
            return {
              type: type,
              data: _data
            };
          }
        }
      });
    };

    function getCurrentOrders() {
      var orders = [];

      if ($scope.subType == 'materials' || $scope.subType == 'lowStatus') {
        orders = vm.materials;
      } else if ($scope.subType === 'matGroup') {
        orders = vm.materialGroups;
      } else if ($scope.subType === 'supplier') {
        orders = vm.suppliers;
      }

      return orders;
    }

    $scope.selectAllOrders = function () {
      var orders = getCurrentOrders();
      orders.forEach(function (x) {
        x.selected = vm.selectedAll;
      });
    };

    $scope.selectOrder = function (order) {
      if (!order.selected) {
        vm.selectedAll = false;
      }

      var orders = getCurrentOrders();

      if (orders.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === orders.length) {
        vm.selectedAll = true;
      }
    };

    $scope.returnOrders = function () {
      if ($scope.subType === 'materials' || $scope.subType === 'lowStatus') {
        var materials = vm.materials.filter(function (x) {
          return x.selected;
        });

        if (utils.isEmpty(materials)) {
          Notification.error("Please select materials");
          return;
        }

        returnOrders(materials);
      } else if ($scope.subType === 'matGroup') {
        var matGroups = vm.materialGroups.filter(function (x) {
          return x.selected;
        });

        if (utils.isEmpty(matGroups)) {
          Notification.error("Please select material groups");
          return;
        }

        var _materials = [];
        matGroups.map(function (x) {
          return x.materials;
        }).forEach(function (x) {
          _materials = _materials.concat(x);
        });
        returnOrders(_materials);
      } else if ($scope.subType === "supplier") {
        var suppliers = vm.suppliers.filter(function (x) {
          return x.selected;
        });

        if (utils.isEmpty(suppliers)) {
          Notification.error("Please select suppliers");
          return;
        }

        var _materials2 = [];
        suppliers.map(function (x) {
          return x.materials;
        }).forEach(function (x) {
          _materials2 = _materials2.concat(x);
        });
        returnOrders(_materials2);
      }
    };

    $scope.billScan = function () {
      $uibModal.open({
        animation: true,
        component: 'billScanModal',
        windowClass: 'bill-scan-modal'
      });
    };

    function returnOrders(materials) {
      var reqData = {
        reference: vm.currentWarehouse,
        details: materials.map(function (x) {
          return {
            material: x._id,
            quantity: x.qty,
            price: x.costPrice,
            total: x.salesPrice,
            vatPercent: x.vatPercent,
            vat: x.costPrice * x.vatPercent / 100
          };
        }),
        status: 'pending'
      };
      $scope.isLoading = true;
      apiFactory.createReturnOrder(reqData).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('salesOrders', {
    controller: SalesOrdersController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/salesOrders/salesOrders.view.html'
  });
  /** @ngInject */

  function SalesOrdersController($scope, utils, $state, apiFactory, $log, globals, $uibModal, Notification) {
    var vm = this;
    var companyStore = globals.companyStore;
    $scope.utils = utils;
    $scope.activemenu = "salesOrders";
    $scope.filtertypelistvalue1 = '1';
    $scope.filtertypelist1 = [{
      _id: '1',
      tagName: "Bulk Actions"
    }];
    $scope.filtertypelistvalue2 = '1';
    $scope.filtertypelist2 = [{
      _id: '1',
      tagName: "Select a Category"
    }];
    $scope.filtertypelistvalue3 = '1';
    $scope.filtertypelist3 = [{
      _id: '1',
      tagName: "Filter By OrderStatus"
    }];
    $scope.filtertypelistvalue4 = '1';
    $scope.filtertypelist4 = [{
      _id: '1',
      tagName: "Filter By Bill State"
    }];
    vm.salesOrders = [{
      name: 'Adidas NMD R1',
      image: '/assets/images/sales/Rectangle1.png',
      id: '1292',
      category: 'Electrical',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Taparia CLH 450 Claw Hammer',
      image: '/assets/images/sales/Rectangle2.png',
      id: '1293',
      category: 'Security',
      supplier: 'Binford Ltd',
      stock: 56,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Original Hu',
      image: '/assets/images/sales/Rectangle3.png',
      id: '1294',
      category: 'Carpentry',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Futurecraft 4D',
      image: '/assets/images/sales/Rectangle4.png',
      id: '1295',
      category: 'Stainless Steel',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Ultra Boost20',
      image: '/assets/images/sales/Rectangle1.png',
      id: '1296',
      category: 'Scaffolding',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas NMD R1',
      image: '/assets/images/sales/Rectangle2.png',
      id: '1297',
      category: 'Electrical',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Yeezy Boost 3D',
      image: '/assets/images/sales/Rectangle3.png',
      id: '1298',
      category: 'Carpentry',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Original Hu',
      image: '/assets/images/sales/Rectangle4.png',
      id: '1299',
      category: 'Electrical',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Futurecraft 4D',
      image: '/assets/images/sales/Rectangle1.png',
      id: '1300',
      category: 'Carpentry',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas NMD R1',
      image: '/assets/images/sales/Rectangle2.png',
      id: '1301',
      category: 'Security',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Taparia CLH 450 Claw Hammer',
      image: '/assets/images/sales/Rectangle3.png',
      id: '1302',
      category: 'Electrical',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Ultra Boost20',
      image: '/assets/images/sales/Rectangle4.png',
      id: '1303',
      category: 'Electrical',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }];
    $scope.isLoading = false;
    $scope.periods = [{
      id: '5',
      name: '5'
    }, {
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '50',
      name: '50'
    }];
    $scope.totalCount = vm.salesOrders.length;
    $scope.numPerPage = 10;
    $scope.noOfPages = 1;
    vm.currentPage = 1; // vm.salesOrders = [];

    vm.currentCurrency = companyStore.get().currentCurrency;
    $scope.paymentStatus = [];
    $scope.orderStatus = [];
    $scope.filterDates = [];
    $scope.statusTagColors = [{
      key: 'ready_for_pickup',
      color: '#FF7934',
      bgColor: '#FFE8CC'
    }, {
      key: 'shipped',
      color: '#367BF5',
      bgColor: '#E5EFFF'
    }, {
      key: 'invoiced',
      color: '#2FA84F',
      bgColor: '#DCF7E3'
    }, {
      key: 'ready_for_custom',
      color: '#1AB2D3',
      bgColor: '#CCEEF5'
    }, {
      key: "packed",
      color: "#367BF5",
      bgColor: "#E5EFFF"
    }, {
      key: "cancelled",
      color: "#D71414",
      bgColor: "#FEE4E2"
    }];
    $scope.paymentTagColors = [{
      key: 'paid',
      color: '#2FA84F'
    }, {
      key: 'unpaid',
      color: '#FF7934'
    }, {
      key: 'overdue',
      color: '#D71414'
    }, {
      key: 'partially_paid',
      color: '#367BF5'
    }, {
      key: 'open',
      color: '#00AACE'
    }, {
      key: 'draft',
      color: '#747474'
    }, {
      key: 'void',
      color: '#FF8B00'
    }];

    $scope.getStatusTagColor = function (status) {
      var find = $scope.statusTagColors.find(function (elem) {
        return elem.key == status;
      });

      if (find) {
        return {
          color: find.color,
          bgColor: find.bgColor
        };
      } else {
        return {
          color: '#FF8B00',
          bgColor: '#FFE8CC'
        };
      }
    };

    $scope.getPaymentTagColor = function (type) {
      if (utils.isEmpty(type)) {
        return;
      }

      return $scope.paymentTagColors.find(function (elem) {
        return elem.key == type;
      }).color;
    };

    $scope.getPaymentStatus = function (type) {
      if (utils.isEmpty(type)) return '';
      var status = type.split('_');

      if (status.length > 1) {
        var result = [];

        var _iterator = _createForOfIteratorHelper(status),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            result.push(item.substring(0, 1).toUpperCase() + item.slice(1));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return result.join(' ');
      } else return type.substring(0, 1).toUpperCase() + type.slice(1);
    };

    $scope.getStatus = function (status) {
      if (utils.isEmpty(status)) return '';
      var s = status.split('_');

      if (s.length > 1) {
        var result = [];

        var _iterator2 = _createForOfIteratorHelper(s),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            result.push(item.substring(0, 1).toUpperCase() + item.slice(1));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return result.join(' ');
      } else return status.substring(0, 1).toUpperCase() + status.slice(1);
    };

    $scope.editOrder = function (order) {
      if (order.deliverToType === 3) {
        // sro?
        $state.go('editRefillOrder', {
          id: order._id
        });
      } else {
        $state.go('editSalesOrder', {
          id: order._id
        });
      }
    };

    $scope.sendOrder = function (order) {
      $scope.isLoading = true;
      apiFactory.sendSalesOrder(order._id).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        order.status = 'shipped';
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.cancelOrder = function (order) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Cancel Order',
              message: "Are you sure cancel the order?",
              subMessage: order.status === 'shipped' ? 'The cancellation mail will be sent to the supplier.' : "The cancellation mail won't be sent to the supplier.",
              confirmButtonText: 'Ok',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.cancelSalesOrder(order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          order.status = 'cancelled';
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.deleteOrder = function (order, index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.deleteSalesOrder(order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          vm.salesOrders.splice(index, 1);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.updatedPaymentStatusFilter = function (status) {
      $scope.paymentStatus = status;
      $scope.initData();
    };

    $scope.updatedOrderStatusFilter = function (status) {
      $scope.orderStatus = status;
      $scope.initData();
    };

    $scope.updatedDateFilter = function (dates) {
      $scope.filterDates = dates;
      $scope.initData();
    };

    $scope.fetchOrderList = function () {
      $scope.isLoading = true;
      apiFactory.listAllSalesOrders({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        orderType: Constants.OrderTypes.SALES,
        paymentStatus: $scope.paymentStatus.join(","),
        status: $scope.orderStatus.join(","),
        fromDate: $scope.filterDates[0],
        toDate: $scope.filterDates[1]
      }).then(function (resp) {
        vm.salesOrders = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.floor(($scope.totalCount + $scope.numPerPage - 1) / $scope.numPerPage);
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    }; // $scope.fetchOrderList();


    $scope.searchOrderList = function () {
      vm.currentPage = 1;
      $scope.fetchOrderList();
    };

    $scope.selectAllOrders = function () {
      vm.salesOrders.forEach(function (x) {
        x.selected = vm.selectedAll;
      });
    };

    $scope.selectOrder = function (order) {
      if (!order.selected) {
        vm.selectedAll = false;
      }

      if (vm.salesOrders.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.salesOrders.length) {
        vm.selectedAll = true;
      }
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.initData();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('salesOrderAction', {
    controller: salesOrderActionController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/salesOrderAction/salesOrderAction.view.html'
  });
  /** @ngInject */

  function salesOrderActionController($scope, apiFactory, Notification, utils, $location, $state, $log) {
    var vm = this;

    var _$location$search = $location.search(),
        token = _$location$search.token;

    if (utils.isEmpty(token)) {
      Notification.error('Invalid operation');
      $state.go('login');
      return;
    }

    $scope.isLoading = true;
    vm.order = undefined;
    apiFactory.actSalesOrder(token).then(function (resp) {
      $scope.isLoading = false;
      vm.order = resp.data.data;
    })["catch"](function (e) {
      $scope.isLoading = false;
      $log.error(e);
      Notification.error('Something went wrong');
    });
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('returnOrders', {
    controller: ReturnOrdersController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/returnOrders/returnOrders.view.html'
  });
  /** @ngInject */

  function ReturnOrdersController($scope, utils, $state, apiFactory, $log, globals, $uibModal, Notification) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore;
    vm.projectData = projectStore.get();
    $scope.utils = utils;
    $scope.periods = [{
      id: '5',
      name: '5'
    }, {
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '50',
      name: '50'
    }];
    $scope.totalCount = 0;
    $scope.numPerPage = 10;
    $scope.noOfPages = 1;
    vm.currentPage = 1;
    vm.returnOrders = [];
    vm.currentCurrency = companyStore.get().currentCurrency;
    $scope.orderStatus = [];
    $scope.filterDates = [];
    $scope.statusTagColors = [{
      key: 'draft',
      color: '#367BF5',
      bgColor: '#E5EFFF'
    }, {
      key: 'Confirmed',
      color: '#367BF5',
      bgColor: '#E5EFFF'
    }, {
      key: 'cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'Cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'declined',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'pending',
      color: '#FF8B00',
      bgColor: '#FFE8CC'
    }, {
      key: 'Pending',
      color: '#FF8B00',
      bgColor: '#FFE8CC'
    }, {
      key: 'approved',
      color: '#2FA84F',
      bgColor: '#DCF7E3'
    }];
    $scope.paymentTagColors = [{
      key: 'paid',
      color: '#2FA84F'
    }, {
      key: 'unpaid',
      color: '#FF7934'
    }, {
      key: 'overdue',
      color: '#D71414'
    }, {
      key: 'partially_paid',
      color: '#367BF5'
    }, {
      key: 'open',
      color: '#00AACE'
    }, {
      key: 'draft',
      color: '#747474'
    }, {
      key: 'void',
      color: '#FF8B00'
    }];

    $scope.getStatusTagColor = function (status) {
      var find = $scope.statusTagColors.find(function (elem) {
        return elem.key == status;
      });

      if (find) {
        return {
          color: find.color,
          bgColor: find.bgColor
        };
      } else {
        return {
          color: '#FF8B00',
          bgColor: '#FFE8CC'
        };
      }
    };

    $scope.getStatus = function (status) {
      if (utils.isEmpty(status)) return '';
      var s = status.split('_');

      if (s.length > 1) {
        var result = [];

        var _iterator = _createForOfIteratorHelper(s),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            result.push(item.substring(0, 1).toUpperCase() + item.slice(1));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return result.join(' ');
      } else return status.substring(0, 1).toUpperCase() + status.slice(1);
    };

    $scope.updatedOrderStatusFilter = function (status) {
      $scope.orderStatus = status;
      $scope.fetchOrderList();
    };

    $scope.updatedDateFilter = function (dates) {
      $scope.filterDates = dates;
      $scope.fetchOrderList();
    };

    $scope.fetchOrderList = function () {
      $scope.isLoading = true;
      apiFactory.listAllReturnOrders({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: "date",
        search: vm.searchText,
        sortType: false,
        status: $scope.orderStatus.join(","),
        fromDate: $scope.filterDates[0],
        toDate: $scope.filterDates[1],
        projectId: vm.projectData._id === "all" ? null : vm.projectData._id
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.returnOrders = resp.data.list;

        var _iterator2 = _createForOfIteratorHelper(vm.returnOrders),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var order = _step2.value;
            order.price = order.details.map(function (x) {
              return x.price;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
            order.vat = order.details.map(function (x) {
              return x.vat;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
            order.total = order.details.map(function (x) {
              return x.total;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.floor(($scope.totalCount + $scope.numPerPage - 1) / $scope.numPerPage);
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    };

    $scope.fetchOrderList();

    $scope.searchOrderList = function () {
      vm.currentPage = 1;
      $scope.fetchOrderList();
    };

    $scope.sendOrder = function (order) {
      $scope.isLoading = true;
      apiFactory.sendReturnOrder(order._id).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        order.status = 'pending';
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.cancelOrder = function (order) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Cancel Order',
              message: "Are you sure cancel the order?",
              subMessage: order.status === 'pending' ? 'The cancellation mail will be sent to the supplier.' : "The cancellation mail won't be sent to the supplier.",
              confirmButtonText: 'Ok',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.cancelReturnOrder(order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          order.status = 'canceled';
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.deleteOrder = function (order, index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.deleteReturnOrder(order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          vm.returnOrders.splice(index, 1);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.selectAllOrders = function () {
      vm.returnOrders.forEach(function (x) {
        x.selected = vm.selectedAll;
      });
    };

    $scope.selectOrder = function (order) {
      if (!order.selected) {
        vm.selectedAll = false;
      }

      if (vm.returnOrders.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.returnOrders.length) {
        vm.selectedAll = true;
      }
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchOrderList();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('returnOrderAction', {
    controller: returnOrderActionController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/returnOrderAction/returnOrderAction.view.html'
  });
  /** @ngInject */

  function returnOrderActionController($scope, apiFactory, Notification, utils, $location, $state, $log) {
    var vm = this;

    var _$location$search = $location.search(),
        token = _$location$search.token;

    if (utils.isEmpty(token)) {
      Notification.error('Invalid operation');
      $state.go('login');
      return;
    }

    $scope.isLoading = true;
    vm.order = undefined;
    apiFactory.actReturnOrder(token).then(function (resp) {
      $scope.isLoading = false;
      vm.order = resp.data.data;
    })["catch"](function (e) {
      $scope.isLoading = false;
      $log.error(e);
      Notification.error('Something went wrong');
    });
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('rentalOrders', {
    controller: RentalOrdersController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/rentalOrders/rentalOrders.view.html'
  });
  /** @ngInject */

  function RentalOrdersController($scope, utils, $state, apiFactory, $log, globals, Notification, $uibModal) {
    var vm = this;
    var companyStore = globals.companyStore;
    $scope.utils = utils;
    $scope.activemenu = "rentalOrders";
    $scope.periods = [{
      id: '5',
      name: '5'
    }, {
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '50',
      name: '50'
    }];
    $scope.totalCount = 0;
    $scope.numPerPage = 10;
    $scope.noOfPages = 1;
    vm.currentPage = 1;
    vm.rentalOrders = [];
    vm.currentCurrency = companyStore.get().currentCurrency;
    $scope.orderStatus = [];
    $scope.filterDates = [];

    $scope.initData = function () {
      $scope.isLoading = true;
      apiFactory.listAllRentalOrders({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: "created",
        search: vm.searchText,
        sortType: false,
        status: $scope.orderStatus.join(","),
        fromDate: $scope.filterDates[0],
        toDate: $scope.filterDates[1]
      }).then(function (resp) {
        vm.rentalOrders = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.floor(($scope.totalCount + $scope.numPerPage - 1) / $scope.numPerPage);
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    };

    $scope.initData();
    $scope.statusTagColors = [{
      key: 'placed',
      color: '#FF7934',
      bgColor: '#FFE8CC'
    }, {
      key: 'reserved',
      color: '#FF7934',
      bgColor: '#FFE8CC'
    }, {
      key: 'picked_up',
      color: '#367BF5',
      bgColor: '#E5EFFF'
    }, {
      key: 'returned',
      color: '#2FA84F',
      bgColor: '#DCF7E3'
    }, {
      key: 'cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }];
    $scope.paymentTagColors = [{
      key: 'paid',
      color: '#2FA84F'
    }, {
      key: 'unpaid',
      color: '#FF7934'
    }, {
      key: 'overdue',
      color: '#D71414'
    }, {
      key: 'partially_paid',
      color: '#367BF5'
    }, {
      key: 'open',
      color: '#00AACE'
    }, {
      key: 'draft',
      color: '#747474'
    }, {
      key: 'void',
      color: '#FF8B00'
    }];

    $scope.getStatusTagColor = function (status) {
      var find = $scope.statusTagColors.find(function (elem) {
        return elem.key == status;
      });

      if (find) {
        return {
          color: find.color,
          bgColor: find.bgColor
        };
      } else {
        return {
          color: '#FF8B00',
          bgColor: '#FFE8CC'
        };
      }
    };

    $scope.getStatus = function (status) {
      if (utils.isEmpty(status)) return '';
      var s = status.split('_');

      if (s.length > 1) {
        var result = [];

        var _iterator = _createForOfIteratorHelper(s),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            result.push(item.substring(0, 1).toUpperCase() + item.slice(1));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return result.join(' ');
      } else return status.substring(0, 1).toUpperCase() + status.slice(1);
    };

    $scope.editOrder = function (order) {
      if (order.deliverToType === 3) {
        // sro?
        $state.go('editRefillOrder', {
          id: order._id
        });
      } else {
        $state.go('editRentalOrder', {
          id: order._id
        });
      }
    };

    $scope.sendOrder = function (order) {
      $scope.isLoading = true;
      apiFactory.sendRentalOrder(order._id).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        order.status = 'reserved';
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.cancelOrder = function (order) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Cancel Order',
              message: "Are you sure cancel the order?",
              subMessage: order.status === 'pending' ? 'The cancellation mail will be sent to the supplier.' : "The cancellation mail won't be sent to the supplier.",
              confirmButtonText: 'Ok',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.cancelRentalOrder(order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          order.status = 'cancelled';
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.deleteOrder = function (order, index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.deleteRentalOrder(order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          vm.purchaseOrders.splice(index, 1);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.updatedOrderStatusFilter = function (status) {
      $scope.orderStatus = status;
      $scope.initData();
    };

    $scope.updatedDateFilter = function (dates) {
      $scope.filterDates = dates;
      $scope.initData();
    };

    $scope.selectAllOrders = function () {
      vm.rentalOrders.forEach(function (x) {
        x.selected = vm.selectedAll;
      });
    };

    $scope.selectOrder = function (order) {
      if (!order.selected) {
        vm.selectedAll = false;
      }

      if (vm.rentalOrders.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.rentalOrders.length) {
        vm.selectedAll = true;
      }
    };

    $scope.returnOrders = function () {
      var orders = vm.rentalOrders.filter(function (x) {
        return x.selected;
      });

      if (utils.isEmpty(orders)) {
        Notification.error("Please select orders to return");
        return;
      }

      var pickedUpOrders = orders.filter(function (x) {
        return x.status === 'picked_up';
      });

      if (pickedUpOrders.length !== orders.length) {
        Notification.error("Please select only orders with status as 'Picked Up'");
        return;
      }

      $scope.isLoading = true;
      Promise.all(pickedUpOrders.map(function (x) {
        return apiFactory.returnRentalOrder(x._id);
      })).then(function () {
        $scope.isLoading = false;
        Notification.success("Returned successfully");

        var _iterator2 = _createForOfIteratorHelper(pickedUpOrders),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var order = _step2.value;
            order.status = 'returned';
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.returnOrder = function (order) {
      $scope.isLoading = true;
      apiFactory.returnRentalOrder(order._id).then(function () {
        $scope.isLoading = false;
        Notification.success("Returned successfully");
        order.status = 'returned';
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.initData();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('rentalOrderAction', {
    controller: rentalOrderActionController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/rentalOrderAction/rentalOrderAction.view.html'
  });
  /** @ngInject */

  function rentalOrderActionController($scope, apiFactory, Notification, utils, $location, $state, $log) {
    var vm = this;

    var _$location$search = $location.search(),
        token = _$location$search.token;

    if (utils.isEmpty(token)) {
      Notification.error('Invalid operation');
      $state.go('login');
      return;
    }

    $scope.isLoading = true;
    vm.order = undefined;
    apiFactory.actRentalOrder(token).then(function (resp) {
      $scope.isLoading = false;
      vm.order = resp.data.data;
    })["catch"](function (e) {
      $scope.isLoading = false;
      $log.error(e);
      Notification.error('Something went wrong');
    });
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('purchaseOrders', {
    controller: PurchaseOrdersController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/purchaseOrders/purchaseOrders.view.html'
  });
  /** @ngInject */

  function PurchaseOrdersController($scope, utils, $state, apiFactory, $log, globals, $uibModal, Notification) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore;
    vm.projectData = projectStore.get();
    $scope.utils = utils;
    $scope.activemenu = "purchaseOrders";
    $scope.filtertypelistvalue1 = '1';
    $scope.filtertypelist1 = [{
      _id: '1',
      tagName: "Bulk Actions"
    }];
    $scope.filtertypelistvalue2 = '1';
    $scope.filtertypelist2 = [{
      _id: '1',
      tagName: "Select a Category"
    }];
    $scope.filtertypelistvalue3 = '1';
    $scope.filtertypelist3 = [{
      _id: '1',
      tagName: "Filter By OrderStatus"
    }];
    $scope.filtertypelistvalue4 = '1';
    $scope.filtertypelist4 = [{
      _id: '1',
      tagName: "Filter By Bill State"
    }];
    $scope.periods = [{
      id: '5',
      name: '5'
    }, {
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '50',
      name: '50'
    }];
    $scope.totalCount = 0;
    $scope.numPerPage = 10;
    $scope.noOfPages = 1;
    vm.currentPage = 1;
    vm.purchaseOrders = [];
    vm.currentCurrency = companyStore.get().currentCurrency;
    $scope.orderStatus = [];
    $scope.filterDates = [];
    $scope.statusTagColors = [{
      key: 'draft',
      color: '#AAB8C2',
      bgColor: '#E5EFFF'
    }, {
      key: 'Confirmed',
      color: '#1DA1F2',
      bgColor: '#E5EFFF'
    }, {
      key: 'cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'Cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'declined',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'pending',
      color: '#FF8B00',
      bgColor: '#FFE8CC'
    }, {
      key: 'Pending',
      color: '#FF8B00',
      bgColor: '#FFE8CC'
    }, {
      key: 'approved',
      color: '#2FA84F',
      bgColor: '#DCF7E3'
    }];
    $scope.paymentTagColors = [{
      key: 'paid',
      color: '#2FA84F'
    }, {
      key: 'unpaid',
      color: '#FF7934'
    }, {
      key: 'overdue',
      color: '#D71414'
    }, {
      key: 'partially_paid',
      color: '#367BF5'
    }, {
      key: 'open',
      color: '#00AACE'
    }, {
      key: 'draft',
      color: '#747474'
    }, {
      key: 'void',
      color: '#FF8B00'
    }];

    $scope.getStatusTagColor = function (status) {
      var find = $scope.statusTagColors.find(function (elem) {
        return elem.key == status;
      });

      if (find) {
        return {
          color: find.color,
          bgColor: find.bgColor
        };
      } else {
        return {
          color: '#FF8B00',
          bgColor: '#FFE8CC'
        };
      }
    };

    $scope.getStatus = function (status) {
      if (utils.isEmpty(status)) return '';
      var s = status.split('_');

      if (s.length > 1) {
        var result = [];

        var _iterator = _createForOfIteratorHelper(s),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            result.push(item.substring(0, 1).toUpperCase() + item.slice(1));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return result.join(' ');
      } else return status.substring(0, 1).toUpperCase() + status.slice(1);
    };

    $scope.editOrder = function (order) {
      if (order.deliverToType === 3) {
        // sro?
        $state.go('editRefillOrder', {
          id: order._id
        });
      } else {
        $state.go('editPurchaseOrder', {
          id: order._id
        });
      }
    };

    $scope.updatedOrderStatusFilter = function (status) {
      $scope.orderStatus = status;
      $scope.fetchOrderList();
    };

    $scope.updatedDateFilter = function (dates) {
      $scope.filterDates = dates;
      $scope.fetchOrderList();
    };

    $scope.fetchOrderList = function () {
      $scope.isLoading = true;
      apiFactory.listAllOrders({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: "date",
        search: vm.searchText,
        sortType: false,
        orderType: Constants.OrderTypes.PURCHASE,
        status: $scope.orderStatus.join(","),
        fromDate: $scope.filterDates[0],
        toDate: $scope.filterDates[1],
        projectId: vm.projectData._id === "all" ? null : vm.projectData._id
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.purchaseOrders = resp.data.list;

        var _iterator2 = _createForOfIteratorHelper(vm.purchaseOrders),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var order = _step2.value;
            order.price = order.details.map(function (x) {
              return x.price;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
            order.vat = order.details.map(function (x) {
              return x.vat;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
            order.total = order.details.map(function (x) {
              return x.total;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.floor(($scope.totalCount + $scope.numPerPage - 1) / $scope.numPerPage);
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    };

    $scope.fetchOrderList();

    $scope.searchOrderList = function () {
      vm.currentPage = 1;
      $scope.fetchOrderList();
    };

    $scope.sendOrder = function (order) {
      var apiFuncName = order.reference ? 'sendOrder' : 'sendProjectOrder';
      $scope.isLoading = true;
      apiFactory[apiFuncName](order._id).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        order.status = order.reference ? 'pending' : 'Pending';
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.cancelOrder = function (order) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Cancel Order',
              message: "Are you sure cancel the order?",
              subMessage: order.status === 'pending' ? 'The cancellation mail will be sent to the supplier.' : "The cancellation mail won't be sent to the supplier.",
              confirmButtonText: 'Ok',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      }).result.then(function () {
        var apiFuncName = order.reference ? 'cancelOrder' : 'cancelProjectOrder';
        $scope.isLoading = true;
        apiFactory[apiFuncName](order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          order.status = order.reference ? 'canceled' : 'Cancelled';
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.deleteOrder = function (order, index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.deleteOrder(order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          vm.purchaseOrders.splice(index, 1);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.selectAllOrders = function () {
      vm.purchaseOrders.forEach(function (x) {
        x.selected = vm.selectedAll;
      });
    };

    $scope.selectOrder = function (order) {
      if (!order.selected) {
        vm.selectedAll = false;
      }

      if (vm.purchaseOrders.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.purchaseOrders.length) {
        vm.selectedAll = true;
      }
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchOrderList();
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('projectOrders', {
    controller: ProjectOrdersController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/projectOrders/projectOrders.view.html'
  });
  /** @ngInject */

  function ProjectOrdersController(globals, $scope, utils, $state, apiFactory, $log, Notification, storageFactory) {
    var vm = this;
    vm.companyData = globals.companyStore.get();
    vm.projectData = globals.projectStore.get();
    $scope.utils = utils;
    $scope.activemenu = "projectOrders";
    $scope.periods = [{
      id: '5',
      name: '5'
    }, {
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '50',
      name: '50'
    }];
    $scope.totalCount = 0;
    $scope.numPerPage = 10;
    $scope.noOfPages = 1;
    vm.currentPage = 1;
    vm.matGroups = [];
    $scope.orderStatus = [];
    $scope.filterDates = [];
    $scope.statusTagColors = [{
      key: 'Confirmed',
      color: '#367BF5',
      bgColor: '#E5EFFF'
    }, {
      key: 'Cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'Pending',
      color: '#FF8B00',
      bgColor: '#FFE8CC'
    }];
    $scope.paymentTagColors = [{
      key: 'paid',
      color: '#2FA84F'
    }, {
      key: 'unpaid',
      color: '#FF7934'
    }, {
      key: 'overdue',
      color: '#D71414'
    }, {
      key: 'partially_paid',
      color: '#367BF5'
    }, {
      key: 'open',
      color: '#00AACE'
    }, {
      key: 'draft',
      color: '#747474'
    }, {
      key: 'void',
      color: '#FF8B00'
    }];

    $scope.getStatusTagColor = function (status) {
      var find = $scope.statusTagColors.find(function (elem) {
        return elem.key == status;
      });

      if (find) {
        return {
          color: find.color,
          bgColor: find.bgColor
        };
      } else {
        return {
          color: 'transparent',
          bgColor: 'transparent'
        };
      }
    };

    vm.edit = function (order) {
      if (order.deliverToType === 3) {
        // sro?
        $state.go('editRefillOrder', {
          id: order._id
        });
      } else {
        $state.go('editProjectOrder', {
          id: order._id
        });
      }
    };

    $scope.updatedOrderStatusFilter = function (status) {
      $scope.orderStatus = status;
      $scope.fetchData();
    };

    $scope.updatedDateFilter = function (dates) {
      $scope.filterDates = dates;
      $scope.fetchData();
    };

    $scope.selectAllOrders = function () {
      vm.matGroups.forEach(function (x) {
        x.selected = vm.selectedAll;
      });
    };

    $scope.selectOrder = function (order) {
      if (!order.selected) {
        vm.selectedAll = false;
      }

      if (vm.matGroups.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.matGroups.length) {
        vm.selectedAll = true;
      }
    };

    $scope.createOrderWithSelected = function () {
      var matGroups = vm.matGroups.filter(function (x) {
        return x.selected;
      });

      if (utils.isEmpty(matGroups)) {
        Notification.error("Please select Material Groups to order");
        return;
      }

      createProjectOrder(matGroups);
    };

    $scope.createOrderWithPercentage = function (matGroup) {
      if (angular.isUndefined(matGroup.percentage)) {
        Notification.error("Please input percentage value to order");
        return;
      }

      if (matGroup.percentage <= 0 || matGroup.percentage > 100) {
        Notification.error("Invalid percentage value");
        return;
      }

      createProjectOrder([matGroup]);
    };

    $scope.createOrderAll = function (matGroup) {
      createProjectOrder([matGroup]);
    };

    function createProjectOrder(matGroups) {
      var reqDataList = [];

      var _iterator = _createForOfIteratorHelper(matGroups),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var matGroup = _step.value;

          if (!matGroup.percentage || matGroup.percentage > 100) {
            matGroup.percentage = 100;
          }

          var reqData = {
            projectId: vm.projectData._id,
            matGroupId: matGroup._id,
            orderType: matGroup.percentage === 100 ? 'Normal' : 'Split',
            ordered: matGroup.percentage,
            details: []
          };

          var _iterator2 = _createForOfIteratorHelper(matGroup.list),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var mat = _step2.value;
              var detail = {
                material: mat._id,
                quantity: mat.quantity * matGroup.percentage / 100,
                price: mat.costPrice * matGroup.percentage / 100,
                vat: mat.vat * matGroup.percentage / 100,
                vatPercent: mat.vatPercent,
                total: mat.total * matGroup.percentage / 100
              };
              reqData.details.push(detail);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          reqDataList.push(reqData);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      $scope.isLoading = true;
      Promise.all(reqDataList.map(function (x) {
        return apiFactory.createProjectOrder(x);
      })).then(function () {
        $scope.isLoading = false;
        Notification.success("Created project order successfully");
        $scope.fetchData();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    $scope.searchData = function () {
      vm.currentPage = 1;
      $scope.searchData();
    };

    $scope.fetchData = function () {
      if (!vm.selectedProject) {
        return;
      }

      $scope.isLoading = true;
      apiFactory.listProjectMaterials({
        projectId: vm.selectedProject,
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.matGroups = resp.data.list;

        var _iterator3 = _createForOfIteratorHelper(vm.matGroups),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var matGroup = _step3.value;

            var _iterator4 = _createForOfIteratorHelper(matGroup.list),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var mat = _step4.value;

                if (mat.supplier && mat.supplier.paymentTerms) {
                  mat.vatPercent = mat.supplier.paymentTerms.vatPercent;
                  mat.vat = mat.costPrice * utils.num(mat.vatPercent) / 100;
                  mat.total = mat.costPrice + mat.vat;
                } else {
                  mat.vatPercent = 0;
                  mat.vat = 0;
                  mat.total = utils.num(mat.costPrice);
                }
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.floor(($scope.totalCount + $scope.numPerPage - 1) / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
      });
    };

    function initData() {
      if (!vm.projectData || !vm.projectData._id || vm.projectData._id === "all") return;
      vm.selectedProject = vm.projectData._id;
      $scope.isLoading = true;
      Promise.all([apiFactory.listProjectMaterials({
        projectId: vm.projectData._id,
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText
      }), storageFactory.listAllProjects()]).then(function (resp) {
        $scope.isLoading = false;
        vm.matGroups = resp[0].data.list;

        var _iterator5 = _createForOfIteratorHelper(vm.matGroups),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var matGroup = _step5.value;

            var _iterator6 = _createForOfIteratorHelper(matGroup.list),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var mat = _step6.value;

                if (mat.supplier && mat.supplier.paymentTerms) {
                  mat.vatPercent = mat.supplier.paymentTerms.vatPercent;
                  mat.vat = mat.costPrice * utils.num(mat.vatPercent) / 100;
                  mat.total = mat.costPrice + mat.vat;
                } else {
                  mat.vatPercent = 0;
                  mat.vat = 0;
                  mat.total = utils.num(mat.costPrice);
                }
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        $scope.totalCount = resp[0].data.total;
        $scope.noOfPages = Math.floor(($scope.totalCount + $scope.numPerPage - 1) / $scope.numPerPage);
        vm.projects = resp[1].data.list;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
      });
    }

    initData();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchData();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('projectOrderAction', {
    controller: projectOrderActionController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/projectOrderAction/projectOrderAction.view.html'
  });
  /** @ngInject */

  function projectOrderActionController($scope, apiFactory, Notification, utils, $location, $state, $log) {
    var vm = this;

    var _$location$search = $location.search(),
        token = _$location$search.token;

    if (utils.isEmpty(token)) {
      Notification.error('Invalid operation');
      $state.go('login');
      return;
    }

    $scope.isLoading = true;
    vm.order = undefined;
    apiFactory.actProjectOrder(token).then(function (resp) {
      $scope.isLoading = false;
      vm.order = resp.data.data;
    })["catch"](function (e) {
      $scope.isLoading = false;
      $log.error(e);
      Notification.error('Something went wrong');
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('salesProducts', {
    controller: salesProductsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/products/products.view.html'
  });
  /** @ngInject */

  function salesProductsController($scope, utils) {
    var vm = this;
    $scope.utils = utils;
    $scope.activemenu = "salesProducts";
    $scope.periods = [{
      id: '5',
      name: '5'
    }, {
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '50',
      name: '50'
    }];
    $scope.totalCount = 0;
    $scope.numPerPage = 10;
    $scope.noOfPages = 1;
    vm.currentPage = 1;

    $scope.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
    };

    $scope.filtertypelistvalue1 = '1';
    $scope.filtertypelist1 = [{
      _id: '1',
      tagName: "Bulk Actions"
    }];
    $scope.filtertypelistvalue2 = '1';
    $scope.filtertypelist2 = [{
      _id: '1',
      tagName: "Select a Category"
    }];
    $scope.filtertypelistvalue3 = '1';
    $scope.filtertypelist3 = [{
      _id: '1',
      tagName: "Filter By Supplier"
    }];
    $scope.filtertypelistvalue4 = '1';
    $scope.filtertypelist4 = [{
      _id: '1',
      tagName: "Filter by Stock Level"
    }];
    vm.products = [{
      name: 'Adidas NMD R1',
      image: '/assets/images/sales/Rectangle1.png',
      id: '1292',
      category: 'Electrical',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Taparia CLH 450 Claw Hammer',
      image: '/assets/images/sales/Rectangle2.png',
      id: '1293',
      category: 'Security',
      supplier: 'Binford Ltd',
      stock: 56,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Original Hu',
      image: '/assets/images/sales/Rectangle3.png',
      id: '1294',
      category: 'Carpentry',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Futurecraft 4D',
      image: '/assets/images/sales/Rectangle4.png',
      id: '1295',
      category: 'Stainless Steel',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Ultra Boost20',
      image: '/assets/images/sales/Rectangle1.png',
      id: '1296',
      category: 'Scaffolding',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas NMD R1',
      image: '/assets/images/sales/Rectangle2.png',
      id: '1297',
      category: 'Electrical',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Yeezy Boost 3D',
      image: '/assets/images/sales/Rectangle3.png',
      id: '1298',
      category: 'Carpentry',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Original Hu',
      image: '/assets/images/sales/Rectangle4.png',
      id: '1299',
      category: 'Electrical',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Futurecraft 4D',
      image: '/assets/images/sales/Rectangle1.png',
      id: '1300',
      category: 'Carpentry',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas NMD R1',
      image: '/assets/images/sales/Rectangle2.png',
      id: '1301',
      category: 'Security',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Taparia CLH 450 Claw Hammer',
      image: '/assets/images/sales/Rectangle3.png',
      id: '1302',
      category: 'Electrical',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }, {
      name: 'Adidas Ultra Boost20',
      image: '/assets/images/sales/Rectangle4.png',
      id: '1303',
      category: 'Electrical',
      supplier: 'Binford Ltd',
      stock: 20,
      costprice: 824,
      sellingprice: 900
    }];
    $scope.totalCount = vm.products.length;
    $scope.isLoading = false;
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('orderAction', {
    controller: orderActionController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/orderAction/orderAction.view.html'
  });
  /** @ngInject */

  function orderActionController($scope, apiFactory, Notification, utils, $location, $state, $log) {
    var vm = this;

    var _$location$search = $location.search(),
        token = _$location$search.token;

    if (utils.isEmpty(token)) {
      Notification.error('Invalid operation');
      $state.go('login');
      return;
    }

    $scope.isLoading = true;
    vm.order = undefined;
    apiFactory.actOrder(token).then(function (resp) {
      $scope.isLoading = false;
      vm.order = resp.data.data;
    })["catch"](function (e) {
      $scope.isLoading = false;
      $log.error(e);
      Notification.error('Something went wrong');
    });
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('salesInvoices', {
    controller: InvoicesController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/invoices/invoices.view.html'
  });
  /** @ngInject */

  function InvoicesController($scope, utils, $state, apiFactory, $log, globals, $uibModal, Notification) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore;
    vm.projectData = projectStore.get();
    $scope.utils = utils;
    $scope.activemenu = "salesInvoices";
    $scope.filtertypelistvalue1 = '1';
    $scope.filtertypelist1 = [{
      _id: '1',
      tagName: "Bulk Actions"
    }];
    $scope.filtertypelistvalue2 = '1';
    $scope.filtertypelist2 = [{
      _id: '1',
      tagName: "Select a Category"
    }];
    $scope.filtertypelistvalue3 = '1';
    $scope.filtertypelist3 = [{
      _id: '1',
      tagName: "Filter By OrderStatus"
    }];
    $scope.filtertypelistvalue4 = '1';
    $scope.filtertypelist4 = [{
      _id: '1',
      tagName: "Filter By Bill State"
    }];
    $scope.periods = [{
      id: '5',
      name: '5'
    }, {
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '50',
      name: '50'
    }];
    $scope.totalCount = 0;
    $scope.numPerPage = 10;
    $scope.noOfPages = 1;
    vm.currentPage = 1;
    vm.purchaseOrders = [];
    vm.currentCurrency = companyStore.get().currentCurrency;
    $scope.orderStatus = [];
    $scope.filterDates = [];
    $scope.statusTagColors = [{
      key: 'draft',
      color: '#AAB8C2',
      bgColor: '#E5EFFF'
    }, {
      key: 'Confirmed',
      color: '#1DA1F2',
      bgColor: '#E5EFFF'
    }, {
      key: 'cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'Cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'declined',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'pending',
      color: '#FF8B00',
      bgColor: '#FFE8CC'
    }, {
      key: 'Pending',
      color: '#FF8B00',
      bgColor: '#FFE8CC'
    }, {
      key: 'approved',
      color: '#2FA84F',
      bgColor: '#DCF7E3'
    }];
    $scope.paymentTagColors = [{
      key: 'paid',
      color: '#2FA84F'
    }, {
      key: 'unpaid',
      color: '#FF7934'
    }, {
      key: 'overdue',
      color: '#D71414'
    }, {
      key: 'partially_paid',
      color: '#367BF5'
    }, {
      key: 'open',
      color: '#00AACE'
    }, {
      key: 'draft',
      color: '#747474'
    }, {
      key: 'void',
      color: '#FF8B00'
    }];

    $scope.getStatusTagColor = function (status) {
      var find = $scope.statusTagColors.find(function (elem) {
        return elem.key == status;
      });

      if (find) {
        return {
          color: find.color,
          bgColor: find.bgColor
        };
      } else {
        return {
          color: '#FF8B00',
          bgColor: '#FFE8CC'
        };
      }
    };

    $scope.getStatus = function (status) {
      if (utils.isEmpty(status)) return '';
      var s = status.split('_');

      if (s.length > 1) {
        var result = [];

        var _iterator = _createForOfIteratorHelper(s),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            result.push(item.substring(0, 1).toUpperCase() + item.slice(1));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return result.join(' ');
      } else return status.substring(0, 1).toUpperCase() + status.slice(1);
    };

    $scope.editOrder = function (order) {
      if (order.deliverToType === 3) {
        // sro?
        $state.go('editRefillOrder', {
          id: order._id
        });
      } else {
        $state.go('editPurchaseOrder', {
          id: order._id
        });
      }
    };

    $scope.updatedOrderStatusFilter = function (status) {
      $scope.orderStatus = status;
      $scope.fetchOrderList();
    };

    $scope.updatedDateFilter = function (dates) {
      $scope.filterDates = dates;
      $scope.fetchOrderList();
    };

    $scope.fetchOrderList = function () {
      $scope.isLoading = true;
      apiFactory.listAllOrders({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: "date",
        search: vm.searchText,
        sortType: false,
        orderType: Constants.OrderTypes.PURCHASE,
        status: $scope.orderStatus.join(","),
        fromDate: $scope.filterDates[0],
        toDate: $scope.filterDates[1],
        projectId: vm.projectData._id === "all" ? null : vm.projectData._id
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.purchaseOrders = resp.data.list;

        var _iterator2 = _createForOfIteratorHelper(vm.purchaseOrders),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var order = _step2.value;
            order.price = order.details.map(function (x) {
              return x.price;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
            order.vat = order.details.map(function (x) {
              return x.vat;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
            order.total = order.details.map(function (x) {
              return x.total;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.floor(($scope.totalCount + $scope.numPerPage - 1) / $scope.numPerPage);
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    };

    $scope.fetchOrderList();

    $scope.searchOrderList = function () {
      vm.currentPage = 1;
      $scope.fetchOrderList();
    };

    $scope.sendOrder = function (order) {
      var apiFuncName = order.reference ? 'sendOrder' : 'sendProjectOrder';
      $scope.isLoading = true;
      apiFactory[apiFuncName](order._id).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        order.status = order.reference ? 'pending' : 'Pending';
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.cancelOrder = function (order) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Cancel Order',
              message: "Are you sure cancel the order?",
              subMessage: order.status === 'pending' ? 'The cancellation mail will be sent to the supplier.' : "The cancellation mail won't be sent to the supplier.",
              confirmButtonText: 'Ok',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      }).result.then(function () {
        var apiFuncName = order.reference ? 'cancelOrder' : 'cancelProjectOrder';
        $scope.isLoading = true;
        apiFactory[apiFuncName](order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          order.status = order.reference ? 'canceled' : 'Cancelled';
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.deleteOrder = function (order, index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.deleteOrder(order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          vm.purchaseOrders.splice(index, 1);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.selectAllOrders = function () {
      vm.purchaseOrders.forEach(function (x) {
        x.selected = vm.selectedAll;
      });
    };

    $scope.selectOrder = function (order) {
      if (!order.selected) {
        vm.selectedAll = false;
      }

      if (vm.purchaseOrders.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.purchaseOrders.length) {
        vm.selectedAll = true;
      }
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchOrderList();
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('createSalesOrder', {
    controller: CreateSalesOrderController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/createSalesOrder/createSalesOrder.view.html'
  });
  /** @ngInject */

  function CreateSalesOrderController($scope, apiFactory, $log, globals, utils, Notification, $state, $stateParams, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    $scope.activemenu = "salesOrders";

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.materials = [];
    vm.now = new Date();
    vm.order = {
      deliverToType: 0,
      address: undefined,
      date: vm.now,
      deliveryDate: vm.now,
      orderBy: vm.userData,
      details: [],
      price: 0,
      vat: 0,
      total: 0
    };
    $scope.id = $stateParams.id;
    var apis = [apiFactory.listAllWarehouses(), apiFactory.listAllClients(), storageFactory.listAllProjects()];

    if ($scope.id) {
      apis.push(apiFactory.getSalesOrder($scope.id));
    }

    $scope.loading = true;
    Promise.all(apis).then(function (resp) {
      $scope.loading = false;
      vm.referenceOptions = []; // vm.referenceOptions.push(resp[0].data.list.map(item => {
      //   return {
      //     label: item.name,
      //     value: item._id,
      //     address1: item.address,
      //     type: 'Warehouse'
      //   }
      // }));

      vm.warehouseOptions = resp[0].data.list.map(function (item) {
        return {
          name: item.name,
          _id: item._id
        };
      });
      vm.referenceOptions.push(resp[1].data.list.map(function (item) {
        var temp = {
          label: item.clientName,
          value: item._id,
          type: 'Client',
          systemTag: item.systemTag
        };

        for (var i = 0; i < item.address.length; i++) {
          temp["address".concat(i + 1)] = item.address[i];
        }

        return temp;
      }));
      vm.referenceOptions.push(resp[2].data.list.map(function (item) {
        return {
          label: item.projectName,
          value: item._id,
          address1: item.address.loc ? item.address.loc.position : '',
          type: 'Project'
        };
      }));

      if ($scope.id) {
        vm.order = resp[3].data.data;
        vm.order.date = new Date(vm.order.date);
        vm.order.deliveryDate = new Date(vm.order.deliveryDate);

        var _iterator = _createForOfIteratorHelper(vm.order.details),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var detail = _step.value;
            detail.materialId = detail.material._id;
            detail.material.materialType = 'Material';
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        vm.changeSellTo();
      }
    })["catch"](function (err) {
      $log.error(err);
      Notification.error("Couldn't load data.");
      $scope.loading = false;
    });
    vm.currentCurrency = vm.companyData.currentCurrency;
    globals.getCurrency().then(function (res) {
      var currencies = res.data;
      vm.currentCurrency = currencies.find(function (element) {
        return element.cc === vm.currentCurrency.currencyCode;
      });
    });

    vm.changeSellTo = function () {
      var reference = vm.referenceOptions[0].find(function (elem) {
        return elem.value === vm.order.sellTo;
      });

      if (reference) {
        vm.reference = reference.systemTag;
      }
    };

    vm.changeReference = function () {
      var reference = vm.referenceOptions[vm.order.deliverToType].find(function (elem) {
        return elem.value === vm.order.reference;
      });

      if (reference) {
        vm.order.address = utils.getAddressString(reference.address1);
      }
    };

    vm.addDetail = function () {
      vm.order.details.push({
        quantity: 1
      });
    };

    vm.removeDetail = function (index) {
      vm.order.details.splice(index, 1);
      calcTotal();
    };

    vm.changeWarehouse = function (detail, id) {
      if (!id) {
        return;
      }

      $scope.loading = true;
      apiFactory.listWarehouseMaterials({
        warehouseId: id
      }).then(function (res) {
        $scope.loading = false;
        vm.materials = res.data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error("Couldn't load warehouse data.");
      });
    };

    vm.changeMaterial = function (detail, materialId) {
      detail.material = vm.materials.find(function (elem) {
        return elem._id === materialId;
      });
      detail.materialType = detail.material.materialType;

      if (detail.material) {
        detail.vatPercent = detail.material.vatPercent || 0;
      }

      calcDetail(detail);
      calcTotal();
    };

    vm.changeQuantity = function (detail) {
      if (!detail.material) {
        return;
      }

      if (detail.quantity === 0) {
        Notification.error('Invalid quantity.');
        return;
      }

      calcDetail(detail);
      calcTotal();
    };

    vm.save = function (type) {
      var order = prepareData(type);

      if (!order) {
        return;
      }

      var endpoint = $scope.id ? 'updateSalesOrder' : 'createSalesOrder';
      $scope.loading = true;
      apiFactory[endpoint](order).then(function (resp) {
        $scope.loading = false;
        Notification.success(resp.data.message);
        vm.gotoBack();
      })["catch"](function (err) {
        $log.error(err);

        if (err.data && err.data.message) {
          Notification.error(err.data.message);
        } else {
          var message = $scope.id ? "Failed to update order" : "Failed to add order";
          Notification.error(message);
        }

        $scope.loading = false;
      });
    };

    vm.gotoBack = function () {
      $state.go("salesOrders");
    };

    function calcDetail(detail) {
      detail.price = detail.material.materialCost * utils.num(detail.quantity) * (utils.num(detail.material.unitSize) || 1);
      detail.vat = detail.price * utils.num(detail.vatPercent) / 100;
      detail.total = detail.price + detail.vat;
    }

    function calcTotal() {
      vm.order.price = 0;
      vm.order.vat = 0;
      vm.order.total = 0;
      vm.order.details.forEach(function (detail) {
        vm.order.price += detail.price;
        vm.order.vat += detail.vat;
        vm.order.total += detail.total;
      });
    }

    function prepareData(type) {
      if (utils.isEmpty(vm.order.reference)) {
        Notification.error('Please select deliver to');
        return false;
      }

      if (utils.isEmpty(vm.order.details)) {
        Notification.error('Please add one details at least.');
        return;
      }

      var find = vm.referenceOptions[vm.order.deliverToType].find(function (elem) {
        return elem.value === vm.order.reference;
      });
      var order = angular.copy(vm.order);
      order.referenceType = find.type;
      order.paymentStatus = 'draft';

      if ($scope.id) {
        order._id = vm.order._id;
      }

      if (type === "send") {
        order.status = "shipped";
      } else if (type == "draft") {
        order.status = "ready_for_pickup";
      } else if (type == "cancel") {
        order.status = "cancelled";
      }

      order.details.forEach(function (detail) {
        detail.material = detail.material._id;
      });
      return order;
    }
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('createRentalOrder', {
    controller: CreateRentalOrderController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/createRentalOrder/createRentalOrder.view.html'
  });
  /** @ngInject */

  function CreateRentalOrderController($scope, apiFactory, $log, globals, utils, Notification, $state, $stateParams, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    $scope.activemenu = "rentalOrders";

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.equipments = [];
    vm.now = new Date();
    vm.order = {
      deliverToType: 0,
      address: undefined,
      date: new Date().setDate(vm.now.getDate() + 1),
      deliveryDate: new Date().setDate(vm.now.getDate()),
      orderBy: vm.userData,
      details: [],
      price: 0,
      vat: 0,
      total: 0
    };
    $scope.id = $stateParams.id;
    var apis = [apiFactory.listAllWarehouses(), apiFactory.listAllClients(), storageFactory.listAllProjects(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments()];

    if ($scope.id) {
      apis.push(apiFactory.getRentalOrder($scope.id));
    }

    $scope.loading = true;
    Promise.all(apis).then(function (resp) {
      $scope.loading = false;
      vm.referenceOptions = [];
      vm.referenceOptions.push(resp[0].data.list.map(function (item) {
        return {
          label: item.name,
          value: item._id,
          address1: item.address,
          type: 'Warehouse'
        };
      }));
      vm.referenceOptions.push(resp[1].data.list.map(function (item) {
        var temp = {
          label: item.clientName,
          value: item._id,
          type: 'Client'
        };

        for (var i = 0; i < item.address.length; i++) {
          temp["address".concat(i + 1)] = item.address[i];
        }

        return temp;
      }));
      vm.referenceOptions.push(resp[2].data.list.map(function (item) {
        return {
          label: item.projectName,
          value: item._id,
          address1: item.address.loc ? item.address.loc.position : '',
          type: 'Project'
        };
      }));
      var equipments = resp[3].data.list;
      equipments.forEach(function (equipment) {
        equipment.name = 'Equipment: ' + equipment.name;
        equipment.equipmentType = 'Equipment';
        vm.equipments.push(equipment);
      });
      var dcqs = resp[4].data.list;
      dcqs.forEach(function (dcq) {
        dcq.name = 'DCQ' + ': ' + dcq.name;
        dcq.equipmentType = 'ComboEquipment';
        vm.equipments.push(dcq);
      });

      if ($scope.id) {
        vm.order = resp[5].data.data;
        vm.order.date = new Date(vm.order.date);
        vm.order.deliveryDate = new Date(vm.order.deliveryDate);
      }
    })["catch"](function (err) {
      $log.error(err);
      Notification.error("Couldn't load data.");
      $scope.loading = false;
    });
    vm.currentCurrency = vm.companyData.currentCurrency;
    globals.getCurrency().then(function (res) {
      var currencies = res.data;
      vm.currentCurrency = currencies.find(function (element) {
        return element.cc === vm.currentCurrency.currencyCode;
      });
    });

    vm.changeReference = function () {
      var reference = vm.referenceOptions[vm.order.deliverToType].find(function (elem) {
        return elem.value === vm.order.reference;
      });

      if (reference) {
        vm.order.address = utils.getAddressString(reference.address1);
      }
    };

    vm.addDetail = function () {
      vm.order.details.push({
        quantity: 1
      });
    };

    vm.removeDetail = function (index) {
      vm.order.details.splice(index, 1);
      calcTotal();
    };

    vm.changeEquipment = function (detail) {
      detail.equipment = vm.equipments.find(function (elem) {
        return elem._id === detail.equipmentId;
      });
      detail.equipmentType = detail.equipment.equipmentType;

      if (detail.equipment && detail.equipment.supplier && detail.equipment.supplier.paymentTerms) {
        detail.vatPercent = detail.equipment.supplier.paymentTerms.vatPercent;
      } else {
        detail.vatPercent = 0;
      }

      calcDetail(detail);
      calcTotal();
    };

    vm.changeQuantity = function (detail) {
      calcDetail(detail);
      calcTotal();
    };

    vm.save = function (type) {
      var order = prepareData(type);

      if (!order) {
        return;
      }

      var endpoint = $scope.id ? 'updateRentalOrder' : 'createRentalOrder';
      $scope.loading = true;
      apiFactory[endpoint](order).then(function (resp) {
        $scope.loading = false;
        Notification.success(resp.data.message);
        vm.gotoBack();
      })["catch"](function (err) {
        $log.error(err);

        if (err.data && err.data.message) {
          Notification.error(err.data.message);
        } else {
          var message = $scope.id ? "Failed to update order" : "Failed to add order";
          Notification.error(message);
        }

        $scope.loading = false;
      });
    };

    vm.gotoBack = function () {
      $state.go("rentalOrders");
    };

    vm.changeDate = function () {
      calcTotal();
    }; // function calcDetailForCustomCharge(detail) {
    //   detail.vat = detail.price * utils.num(detail.vatPercent) / 100;
    //   detail.total = detail.price + detail.vat;
    // }


    function calcDetail(detail) {
      var cost = 0;

      if (detail.equipment) {
        cost = detail.equipment.equipmentType === 'Equipment' ? detail.equipment.baseRate.equipmentCost : detail.equipment.totalEquipmentCost;
      }

      detail.price = cost * utils.num(detail.quantity);
      detail.vat = detail.price * utils.num(detail.vatPercent) / 100;
      detail.total = detail.price + detail.vat;
    }

    function calcTotal() {
      vm.order.price = 0;
      vm.order.vat = 0;
      vm.order.total = 0;
      vm.order.details.forEach(function (detail) {
        vm.order.price += detail.price;
        vm.order.vat += detail.vat;
        vm.order.total += detail.total;
      });
      var rentDays = Math.ceil(utils.getDurationDayInRange(vm.order.deliveryDate, vm.order.date));
      vm.order.total = vm.order.total * rentDays;
    }

    function prepareData(type) {
      if (utils.isEmpty(vm.order.reference)) {
        Notification.error('Please select reference');
        return false;
      }

      if (utils.isEmpty(vm.order.details)) {
        Notification.error('Please add one details at least.');
        return;
      }

      var find = vm.referenceOptions[vm.order.deliverToType].find(function (elem) {
        return elem.value === vm.order.reference;
      });
      var order = angular.copy(vm.order);
      order.referenceType = find.type;
      order.orderType = Constants.OrderTypes.PURCHASE;
      var details = [];

      var _iterator = _createForOfIteratorHelper(order.details),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var detail = _step.value;

          if (detail.equipmentType === 'ComboEquipment') {
            var _iterator2 = _createForOfIteratorHelper(detail.equipment.comboMaterialList),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var comboEqu = _step2.value;
                var _detail = {};
                _detail.equipment = comboEqu.equipmentId._id;
                _detail.quantity = detail.quantity;
                _detail.price = comboEqu.equipmentId.baseRate.equipmentCost * _detail.quantity;
                _detail.vatPercent = detail.vatPercent;
                _detail.vat = _detail.price * utils.num(_detail.vatPercent) / 100;
                _detail.total = _detail.price + _detail.vat;
                _detail.status = detail.status;
                _detail.description = detail.description;
                details.push(_detail);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          } else {
            var _detail2 = angular.copy(detail);

            _detail2.equipment = _detail2.equipment._id;
            delete _detail2.equipmentId;
            delete _detail2.equipmentType;
            details.push(_detail2);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      order.details = details;

      if (type === "send") {
        order.status = "reserved";
      } else if (type == "draft") {
        order.status = "placed";
      } else if (type == "cancel") {
        order.status = "cancelled";
      }

      return order;
    }

    $scope.supplierNames = function (suppliers) {
      if (utils.isEmpty(suppliers)) {
        return '';
      }

      var names = [];

      var _iterator3 = _createForOfIteratorHelper(suppliers),
          _step3;

      try {
        var _loop = function _loop() {
          var supplier = _step3.value;

          if (supplier.name && !names.find(function (x) {
            return x === supplier.name;
          })) {
            names.push(supplier.name);
          }
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return names.join(', ');
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('createPurchaseOrder', {
    controller: CreatePurchaseOrderController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/createPurchaseOrder/createPurchaseOrder.view.html'
  });
  /** @ngInject */

  function CreatePurchaseOrderController($scope, apiFactory, $log, globals, utils, Notification, $state, $stateParams, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.activemenu = "purchaseOrders";
    vm.vatpercents = [{
      _id: '5',
      name: '5.00'
    }];
    vm.materials = [];
    vm.now = new Date();
    vm.order = {
      deliverToType: 0,
      address: undefined,
      date: vm.now,
      deliveryDate: vm.now,
      orderBy: vm.userData,
      details: [],
      price: 0,
      vat: 0,
      total: 0
    };
    $scope.id = $stateParams.id;
    $scope.warehouseId = $stateParams.warehouseId;
    var apis = [apiFactory.listAllWarehouses(), apiFactory.listAllClients(), storageFactory.listAllProjects(), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials()];

    if ($scope.id) {
      apis.push(apiFactory.getOrder($scope.id));
    }

    $scope.loading = true;
    Promise.all(apis).then(function (resp) {
      $scope.loading = false;
      vm.referenceOptions = [];
      vm.referenceOptions.push(resp[0].data.list.map(function (item) {
        return {
          label: item.name,
          value: item._id,
          address1: item.address,
          type: 'Warehouse'
        };
      }));

      if ($scope.warehouseId) {
        vm.order.reference = $scope.warehouseId;
        vm.order.referenceType = 'Warehouse';
        vm.changeReference();
      }

      vm.referenceOptions.push(resp[1].data.list.map(function (item) {
        var temp = {
          label: item.clientName,
          value: item._id,
          type: 'Client'
        };

        for (var i = 0; i < item.address.length; i++) {
          temp["address".concat(i + 1)] = item.address[i];
        }

        return temp;
      }));
      vm.referenceOptions.push(resp[2].data.list.map(function (item) {
        return {
          label: item.projectName,
          value: item._id,
          address1: item.address.loc ? item.address.loc.position : '',
          type: 'Project'
        };
      }));
      var materials = resp[3].data.list;
      materials.forEach(function (material) {
        material.name = 'Material: ' + material.name;
        material.materialType = 'Material';
        vm.materials.push(material);
      });
      var dcps = resp[4].data.list;
      dcps.forEach(function (dcp) {
        dcp.name = 'DCP' + ': ' + dcp.name;
        dcp.materialType = 'ComboMaterial';
        vm.materials.push(dcp);
      });

      if ($scope.id) {
        vm.order = resp[5].data.data;
        vm.order.date = new Date(vm.order.date);
        vm.order.deliveryDate = new Date(vm.order.deliveryDate);

        var _iterator = _createForOfIteratorHelper(vm.order.details),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var detail = _step.value;
            detail.materialId = detail.material._id;
            detail.material.materialType = 'Material';
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    })["catch"](function (err) {
      $log.error(err);
      Notification.error("Couldn't load data.");
      $scope.loading = false;
    });
    vm.currentCurrency = vm.companyData.currentCurrency;
    globals.getCurrency().then(function (res) {
      var currencies = res.data;
      vm.currentCurrency = currencies.find(function (element) {
        return element.cc === vm.currentCurrency.currencyCode;
      });
    });

    vm.changeReference = function () {
      var reference = vm.referenceOptions[vm.order.deliverToType].find(function (elem) {
        return elem.value === vm.order.reference;
      });

      if (reference) {
        vm.order.address = utils.getAddressString(reference.address1);
      }
    };

    vm.addDetail = function () {
      vm.order.details.push({
        quantity: 1,
        vatpercent: 5
      });
    };

    vm.removeDetail = function (index) {
      vm.order.details.splice(index, 1);
      calcTotal();
    };

    vm.changeMaterial = function (detail) {
      detail.material = vm.materials.find(function (elem) {
        return elem._id === detail.materialId;
      });
      detail.materialType = detail.material.materialType;

      if (detail.material) {
        if (detail.material.supplier && detail.material.supplier.paymentTerms) {
          detail.vatPercent = detail.material.supplier.paymentTerms.vatPercent;
        } else {
          detail.vatPercent = 0;
        }
      }

      calcDetail(detail);
      calcTotal();
    };

    vm.changeQuantity = function (detail) {
      if (!detail.material) {
        return;
      }

      if (detail.quantity === 0) {
        Notification.error('Invalid quantity.');
        return;
      }

      calcDetail(detail);
      calcTotal();
    };

    vm.save = function (type) {
      var order = prepareData(type);

      if (!order) {
        return;
      }

      var endpoint = $scope.id ? 'updateOrder' : 'createOrder';
      $scope.loading = true;
      apiFactory[endpoint](order).then(function (resp) {
        $scope.loading = false;
        Notification.success(resp.data.message);
        vm.gotoBack();
      })["catch"](function (err) {
        $log.error(err);

        if (err.data && err.data.message) {
          Notification.error(err.data.message);
        } else {
          var message = $scope.id ? "Failed to update order" : "Failed to add order";
          Notification.error(message);
        }

        $scope.loading = false;
      });
    };

    vm.gotoBack = function () {
      $state.go("purchaseOrders");
    };

    function calcDetail(detail) {
      var cost = 0;

      if (detail.material) {
        cost = detail.material.materialType === 'Material' ? detail.material.baseRate.materialCost : detail.material.totalMaterialCost;
      }

      detail.price = cost * utils.num(detail.quantity) * (utils.num(detail.material.unitSize) || 1);
      detail.vat = detail.price * utils.num(detail.vatPercent) / 100;
      detail.total = detail.price + detail.vat;
    }

    function calcTotal() {
      vm.order.price = 0;
      vm.order.vat = 0;
      vm.order.total = 0;
      vm.order.details.forEach(function (detail) {
        vm.order.price += detail.price;
        vm.order.vat += detail.vat;
        vm.order.total += detail.total;
      });
    }

    function prepareData(type) {
      if (utils.isEmpty(vm.order.reference)) {
        Notification.error('Please select reference');
        return false;
      }

      if (utils.isEmpty(vm.order.details)) {
        Notification.error('Please add one details at least.');
        return;
      }

      var find = vm.referenceOptions[vm.order.deliverToType].find(function (elem) {
        return elem.value === vm.order.reference;
      });
      var order = angular.copy(vm.order);
      order.referenceType = find.type;
      order.orderType = Constants.OrderTypes.PURCHASE;
      var details = [];

      var _iterator2 = _createForOfIteratorHelper(order.details),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var detail = _step2.value;

          if (detail.materialType === 'ComboMaterial') {
            var _iterator3 = _createForOfIteratorHelper(detail.material.comboMaterialList),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var comboMat = _step3.value;
                var _detail = {};
                _detail.material = comboMat.materialId._id;
                _detail.quantity = detail.quantity;
                _detail.price = comboMat.materialId.baseRate.materialCost * _detail.quantity;
                _detail.vatPercent = detail.vatPercent;
                _detail.vat = _detail.price * utils.num(_detail.vatPercent) / 100;
                _detail.total = _detail.price + _detail.vat;
                _detail.status = detail.status;
                _detail.description = detail.description;
                details.push(_detail);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          } else {
            var _detail2 = angular.copy(detail);

            _detail2.material = _detail2.material._id;
            delete _detail2.materialId;
            delete _detail2.materialType;
            details.push(_detail2);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      order.details = details;

      if (type === "send") {
        order.status = "pending";
      } else if (type == "draft") {
        order.status = "draft";
      } else if (type == "cancel") {
        order.status = "cancelled";
      }

      return order;
    }

    $scope.supplierNames = function (suppliers) {
      if (utils.isEmpty(suppliers)) {
        return '';
      }

      var names = [];

      var _iterator4 = _createForOfIteratorHelper(suppliers),
          _step4;

      try {
        var _loop = function _loop() {
          var supplier = _step4.value;

          if (supplier.name && !names.find(function (x) {
            return x === supplier.name;
          })) {
            names.push(supplier.name);
          }
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return names.join(', ');
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('createInvoiceOrder', {
    controller: CreateInvoiceOrderController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/createInvoiceOrder/createInvoiceOrder.view.html'
  });
  /** @ngInject */

  function CreateInvoiceOrderController($scope, apiFactory, $log, globals, utils, Notification, $state, $stateParams, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.activemenu = "salesInvoices";
    vm.vatpercents = [{
      _id: '5',
      name: '5.00'
    }];
    vm.materials = [];
    vm.now = new Date();
    vm.order = {
      deliverToType: 0,
      address: undefined,
      date: vm.now,
      deliveryDate: vm.now,
      orderBy: vm.userData,
      details: [],
      price: 0,
      vat: 0,
      total: 0
    };
    $scope.id = $stateParams.id;
    $scope.warehouseId = $stateParams.warehouseId;
    var apis = [apiFactory.listAllWarehouses(), apiFactory.listAllClients(), storageFactory.listAllProjects(), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials()];

    if ($scope.id) {
      apis.push(apiFactory.getOrder($scope.id));
    }

    $scope.loading = true;
    Promise.all(apis).then(function (resp) {
      $scope.loading = false;
      vm.referenceOptions = [];
      vm.referenceOptions.push(resp[0].data.list.map(function (item) {
        return {
          label: item.name,
          value: item._id,
          address1: item.address,
          type: 'Warehouse'
        };
      }));

      if ($scope.warehouseId) {
        vm.order.reference = $scope.warehouseId;
        vm.order.referenceType = 'Warehouse';
        vm.changeReference();
      }

      vm.referenceOptions.push(resp[1].data.list.map(function (item) {
        var temp = {
          label: item.clientName,
          value: item._id,
          type: 'Client'
        };

        for (var i = 0; i < item.address.length; i++) {
          temp["address".concat(i + 1)] = item.address[i];
        }

        return temp;
      }));
      vm.referenceOptions.push(resp[2].data.list.map(function (item) {
        return {
          label: item.projectName,
          value: item._id,
          address1: item.address.loc ? item.address.loc.position : '',
          type: 'Project'
        };
      }));
      var materials = resp[3].data.list;
      materials.forEach(function (material) {
        material.name = 'Material: ' + material.name;
        material.materialType = 'Material';
        vm.materials.push(material);
      });
      var dcps = resp[4].data.list;
      dcps.forEach(function (dcp) {
        dcp.name = 'DCP' + ': ' + dcp.name;
        dcp.materialType = 'ComboMaterial';
        vm.materials.push(dcp);
      });

      if ($scope.id) {
        vm.order = resp[5].data.data;
        vm.order.date = new Date(vm.order.date);
        vm.order.deliveryDate = new Date(vm.order.deliveryDate);

        var _iterator = _createForOfIteratorHelper(vm.order.details),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var detail = _step.value;
            detail.materialId = detail.material._id;
            detail.material.materialType = 'Material';
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    })["catch"](function (err) {
      $log.error(err);
      Notification.error("Couldn't load data.");
      $scope.loading = false;
    });
    vm.currentCurrency = vm.companyData.currentCurrency;
    globals.getCurrency().then(function (res) {
      var currencies = res.data;
      vm.currentCurrency = currencies.find(function (element) {
        return element.cc === vm.currentCurrency.currencyCode;
      });
    });

    vm.changeReference = function () {
      var reference = vm.referenceOptions[vm.order.deliverToType].find(function (elem) {
        return elem.value === vm.order.reference;
      });

      if (reference) {
        vm.order.address = utils.getAddressString(reference.address1);
      }
    };

    vm.addDetail = function () {
      vm.order.details.push({
        quantity: 1,
        vatpercent: 5
      });
    };

    vm.removeDetail = function (index) {
      vm.order.details.splice(index, 1);
      calcTotal();
    };

    vm.changeMaterial = function (detail) {
      detail.material = vm.materials.find(function (elem) {
        return elem._id === detail.materialId;
      });
      detail.materialType = detail.material.materialType;

      if (detail.material) {
        if (detail.material.supplier && detail.material.supplier.paymentTerms) {
          detail.vatPercent = detail.material.supplier.paymentTerms.vatPercent;
        } else {
          detail.vatPercent = 0;
        }
      }

      calcDetail(detail);
      calcTotal();
    };

    vm.changeQuantity = function (detail) {
      if (!detail.material) {
        return;
      }

      if (detail.quantity === 0) {
        Notification.error('Invalid quantity.');
        return;
      }

      calcDetail(detail);
      calcTotal();
    };

    vm.save = function (type) {
      var order = prepareData(type);

      if (!order) {
        return;
      }

      var endpoint = $scope.id ? 'updateOrder' : 'createOrder';
      $scope.loading = true;
      apiFactory[endpoint](order).then(function (resp) {
        $scope.loading = false;
        Notification.success(resp.data.message);
        vm.gotoBack();
      })["catch"](function (err) {
        $log.error(err);

        if (err.data && err.data.message) {
          Notification.error(err.data.message);
        } else {
          var message = $scope.id ? "Failed to update order" : "Failed to add order";
          Notification.error(message);
        }

        $scope.loading = false;
      });
    };

    vm.gotoBack = function () {
      $state.go("purchaseOrders");
    };

    function calcDetail(detail) {
      var cost = 0;

      if (detail.material) {
        cost = detail.material.materialType === 'Material' ? detail.material.baseRate.materialCost : detail.material.totalMaterialCost;
      }

      detail.price = cost * utils.num(detail.quantity) * (utils.num(detail.material.unitSize) || 1);
      detail.vat = detail.price * utils.num(detail.vatPercent) / 100;
      detail.total = detail.price + detail.vat;
    }

    function calcTotal() {
      vm.order.price = 0;
      vm.order.vat = 0;
      vm.order.total = 0;
      vm.order.details.forEach(function (detail) {
        vm.order.price += detail.price;
        vm.order.vat += detail.vat;
        vm.order.total += detail.total;
      });
    }

    function prepareData(type) {
      if (utils.isEmpty(vm.order.reference)) {
        Notification.error('Please select reference');
        return false;
      }

      if (utils.isEmpty(vm.order.details)) {
        Notification.error('Please add one details at least.');
        return;
      }

      var find = vm.referenceOptions[vm.order.deliverToType].find(function (elem) {
        return elem.value === vm.order.reference;
      });
      var order = angular.copy(vm.order);
      order.referenceType = find.type;
      order.orderType = Constants.OrderTypes.PURCHASE;
      var details = [];

      var _iterator2 = _createForOfIteratorHelper(order.details),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var detail = _step2.value;

          if (detail.materialType === 'ComboMaterial') {
            var _iterator3 = _createForOfIteratorHelper(detail.material.comboMaterialList),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var comboMat = _step3.value;
                var _detail = {};
                _detail.material = comboMat.materialId._id;
                _detail.quantity = detail.quantity;
                _detail.price = comboMat.materialId.baseRate.materialCost * _detail.quantity;
                _detail.vatPercent = detail.vatPercent;
                _detail.vat = _detail.price * utils.num(_detail.vatPercent) / 100;
                _detail.total = _detail.price + _detail.vat;
                _detail.status = detail.status;
                _detail.description = detail.description;
                details.push(_detail);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          } else {
            var _detail2 = angular.copy(detail);

            _detail2.material = _detail2.material._id;
            delete _detail2.materialId;
            delete _detail2.materialType;
            details.push(_detail2);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      order.details = details;

      if (type === "send") {
        order.status = "pending";
      } else if (type == "draft") {
        order.status = "draft";
      } else if (type == "cancel") {
        order.status = "cancelled";
      }

      return order;
    }

    $scope.supplierNames = function (suppliers) {
      if (utils.isEmpty(suppliers)) {
        return '';
      }

      var names = [];

      var _iterator4 = _createForOfIteratorHelper(suppliers),
          _step4;

      try {
        var _loop = function _loop() {
          var supplier = _step4.value;

          if (supplier.name && !names.find(function (x) {
            return x === supplier.name;
          })) {
            names.push(supplier.name);
          }
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return names.join(', ');
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('createBillsOrder', {
    controller: CreateBillsOrderController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/createBillsOrder/createBillsOrder.view.html'
  });
  /** @ngInject */

  function CreateBillsOrderController($scope, apiFactory, $log, globals, utils, Notification, $state, $stateParams, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.activemenu = "salesBills";
    vm.vatpercents = [{
      _id: '5',
      name: '5.00'
    }];
    vm.materials = [];
    vm.now = new Date();
    vm.order = {
      deliverToType: 0,
      address: undefined,
      date: vm.now,
      deliveryDate: vm.now,
      orderBy: vm.userData,
      details: [],
      price: 0,
      vat: 0,
      total: 0
    };
    $scope.id = $stateParams.id;
    $scope.warehouseId = $stateParams.warehouseId;
    var apis = [apiFactory.listAllWarehouses(), apiFactory.listAllClients(), storageFactory.listAllProjects(), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials()];

    if ($scope.id) {
      apis.push(apiFactory.getOrder($scope.id));
    }

    $scope.loading = true;
    Promise.all(apis).then(function (resp) {
      $scope.loading = false;
      vm.referenceOptions = [];
      vm.referenceOptions.push(resp[0].data.list.map(function (item) {
        return {
          label: item.name,
          value: item._id,
          address1: item.address,
          type: 'Warehouse'
        };
      }));

      if ($scope.warehouseId) {
        vm.order.reference = $scope.warehouseId;
        vm.order.referenceType = 'Warehouse';
        vm.changeReference();
      }

      vm.referenceOptions.push(resp[1].data.list.map(function (item) {
        var temp = {
          label: item.clientName,
          value: item._id,
          type: 'Client'
        };

        for (var i = 0; i < item.address.length; i++) {
          temp["address".concat(i + 1)] = item.address[i];
        }

        return temp;
      }));
      vm.referenceOptions.push(resp[2].data.list.map(function (item) {
        return {
          label: item.projectName,
          value: item._id,
          address1: item.address.loc ? item.address.loc.position : '',
          type: 'Project'
        };
      }));
      var materials = resp[3].data.list;
      materials.forEach(function (material) {
        material.name = 'Material: ' + material.name;
        material.materialType = 'Material';
        vm.materials.push(material);
      });
      var dcps = resp[4].data.list;
      dcps.forEach(function (dcp) {
        dcp.name = 'DCP' + ': ' + dcp.name;
        dcp.materialType = 'ComboMaterial';
        vm.materials.push(dcp);
      });

      if ($scope.id) {
        vm.order = resp[5].data.data;
        vm.order.date = new Date(vm.order.date);
        vm.order.deliveryDate = new Date(vm.order.deliveryDate);

        var _iterator = _createForOfIteratorHelper(vm.order.details),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var detail = _step.value;
            detail.materialId = detail.material._id;
            detail.material.materialType = 'Material';
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    })["catch"](function (err) {
      $log.error(err);
      Notification.error("Couldn't load data.");
      $scope.loading = false;
    });
    vm.currentCurrency = vm.companyData.currentCurrency;
    globals.getCurrency().then(function (res) {
      var currencies = res.data;
      vm.currentCurrency = currencies.find(function (element) {
        return element.cc === vm.currentCurrency.currencyCode;
      });
    });

    vm.changeReference = function () {
      var reference = vm.referenceOptions[vm.order.deliverToType].find(function (elem) {
        return elem.value === vm.order.reference;
      });

      if (reference) {
        vm.order.address = utils.getAddressString(reference.address1);
      }
    };

    vm.addDetail = function () {
      vm.order.details.push({
        quantity: 1,
        vatpercent: 5
      });
    };

    vm.removeDetail = function (index) {
      vm.order.details.splice(index, 1);
      calcTotal();
    };

    vm.changeMaterial = function (detail) {
      detail.material = vm.materials.find(function (elem) {
        return elem._id === detail.materialId;
      });
      detail.materialType = detail.material.materialType;

      if (detail.material) {
        if (detail.material.supplier && detail.material.supplier.paymentTerms) {
          detail.vatPercent = detail.material.supplier.paymentTerms.vatPercent;
        } else {
          detail.vatPercent = 0;
        }
      }

      calcDetail(detail);
      calcTotal();
    };

    vm.changeQuantity = function (detail) {
      if (!detail.material) {
        return;
      }

      if (detail.quantity === 0) {
        Notification.error('Invalid quantity.');
        return;
      }

      calcDetail(detail);
      calcTotal();
    };

    vm.save = function (type) {
      var order = prepareData(type);

      if (!order) {
        return;
      }

      var endpoint = $scope.id ? 'updateOrder' : 'createOrder';
      $scope.loading = true;
      apiFactory[endpoint](order).then(function (resp) {
        $scope.loading = false;
        Notification.success(resp.data.message);
        vm.gotoBack();
      })["catch"](function (err) {
        $log.error(err);

        if (err.data && err.data.message) {
          Notification.error(err.data.message);
        } else {
          var message = $scope.id ? "Failed to update order" : "Failed to add order";
          Notification.error(message);
        }

        $scope.loading = false;
      });
    };

    vm.gotoBack = function () {
      $state.go("purchaseOrders");
    };

    function calcDetail(detail) {
      var cost = 0;

      if (detail.material) {
        cost = detail.material.materialType === 'Material' ? detail.material.baseRate.materialCost : detail.material.totalMaterialCost;
      }

      detail.price = cost * utils.num(detail.quantity) * (utils.num(detail.material.unitSize) || 1);
      detail.vat = detail.price * utils.num(detail.vatPercent) / 100;
      detail.total = detail.price + detail.vat;
    }

    function calcTotal() {
      vm.order.price = 0;
      vm.order.vat = 0;
      vm.order.total = 0;
      vm.order.details.forEach(function (detail) {
        vm.order.price += detail.price;
        vm.order.vat += detail.vat;
        vm.order.total += detail.total;
      });
    }

    function prepareData(type) {
      if (utils.isEmpty(vm.order.reference)) {
        Notification.error('Please select reference');
        return false;
      }

      if (utils.isEmpty(vm.order.details)) {
        Notification.error('Please add one details at least.');
        return;
      }

      var find = vm.referenceOptions[vm.order.deliverToType].find(function (elem) {
        return elem.value === vm.order.reference;
      });
      var order = angular.copy(vm.order);
      order.referenceType = find.type;
      order.orderType = Constants.OrderTypes.PURCHASE;
      var details = [];

      var _iterator2 = _createForOfIteratorHelper(order.details),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var detail = _step2.value;

          if (detail.materialType === 'ComboMaterial') {
            var _iterator3 = _createForOfIteratorHelper(detail.material.comboMaterialList),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var comboMat = _step3.value;
                var _detail = {};
                _detail.material = comboMat.materialId._id;
                _detail.quantity = detail.quantity;
                _detail.price = comboMat.materialId.baseRate.materialCost * _detail.quantity;
                _detail.vatPercent = detail.vatPercent;
                _detail.vat = _detail.price * utils.num(_detail.vatPercent) / 100;
                _detail.total = _detail.price + _detail.vat;
                _detail.status = detail.status;
                _detail.description = detail.description;
                details.push(_detail);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          } else {
            var _detail2 = angular.copy(detail);

            _detail2.material = _detail2.material._id;
            delete _detail2.materialId;
            delete _detail2.materialType;
            details.push(_detail2);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      order.details = details;

      if (type === "send") {
        order.status = "pending";
      } else if (type == "draft") {
        order.status = "draft";
      } else if (type == "cancel") {
        order.status = "cancelled";
      }

      return order;
    }

    $scope.supplierNames = function (suppliers) {
      if (utils.isEmpty(suppliers)) {
        return '';
      }

      var names = [];

      var _iterator4 = _createForOfIteratorHelper(suppliers),
          _step4;

      try {
        var _loop = function _loop() {
          var supplier = _step4.value;

          if (supplier.name && !names.find(function (x) {
            return x === supplier.name;
          })) {
            names.push(supplier.name);
          }
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return names.join(', ');
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('salesCars', {
    controller: carsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/cars/cars.view.html'
  });
  /** @ngInject */

  function carsController($scope, utils, $state, apiFactory, $log, globals, $uibModal, Notification) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore;
    vm.projectData = projectStore.get();
    $scope.utils = utils;
    $scope.activemenu = "salesCars";
    $scope.filtertypelistvalue1 = '1';
    $scope.filtertypelist1 = [{
      _id: '1',
      tagName: "Bulk Actions"
    }];
    $scope.filtertypelistvalue2 = '1';
    $scope.filtertypelist2 = [{
      _id: '1',
      tagName: "Select a Category"
    }];
    $scope.filtertypelistvalue3 = '1';
    $scope.filtertypelist3 = [{
      _id: '1',
      tagName: "Filter By OrderStatus"
    }];
    $scope.filtertypelistvalue4 = '1';
    $scope.filtertypelist4 = [{
      _id: '1',
      tagName: "Filter By Bill State"
    }];
    $scope.periods = [{
      id: '5',
      name: '6'
    }, {
      id: '10',
      name: '12'
    }, {
      id: '20',
      name: '24'
    }, {
      id: '50',
      name: '48'
    }];
    vm.cars = [{
      name: 'Vehicle No. !M 383335',
      type: 'Car',
      model: 'Volvo VX8',
      registered: 'Ronald Richards',
      driver: 'Jacob Jones',
      licenseno: 'S3JX-RERE-MM3Q-2HUY',
      phone: '466-827-6961',
      email: 'Edwin_Wyman60@yahoo.com'
    }];
    $scope.totalCount = vm.cars.length;
    $scope.numPerPage = 10;
    $scope.noOfPages = 1;
    vm.currentPage = 1;
    vm.currentCurrency = companyStore.get().currentCurrency;
    $scope.orderStatus = [];
    $scope.filterDates = [];
    $scope.statusTagColors = [{
      key: 'draft',
      color: '#AAB8C2',
      bgColor: '#E5EFFF'
    }, {
      key: 'Confirmed',
      color: '#1DA1F2',
      bgColor: '#E5EFFF'
    }, {
      key: 'cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'Cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'declined',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'pending',
      color: '#FF8B00',
      bgColor: '#FFE8CC'
    }, {
      key: 'Pending',
      color: '#FF8B00',
      bgColor: '#FFE8CC'
    }, {
      key: 'approved',
      color: '#2FA84F',
      bgColor: '#DCF7E3'
    }];
    $scope.paymentTagColors = [{
      key: 'paid',
      color: '#2FA84F'
    }, {
      key: 'unpaid',
      color: '#FF7934'
    }, {
      key: 'overdue',
      color: '#D71414'
    }, {
      key: 'partially_paid',
      color: '#367BF5'
    }, {
      key: 'open',
      color: '#00AACE'
    }, {
      key: 'draft',
      color: '#747474'
    }, {
      key: 'void',
      color: '#FF8B00'
    }];

    $scope.getStatusTagColor = function (status) {
      var find = $scope.statusTagColors.find(function (elem) {
        return elem.key == status;
      });

      if (find) {
        return {
          color: find.color,
          bgColor: find.bgColor
        };
      } else {
        return {
          color: '#FF8B00',
          bgColor: '#FFE8CC'
        };
      }
    };

    $scope.getStatus = function (status) {
      if (utils.isEmpty(status)) return '';
      var s = status.split('_');

      if (s.length > 1) {
        var result = [];

        var _iterator = _createForOfIteratorHelper(s),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            result.push(item.substring(0, 1).toUpperCase() + item.slice(1));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return result.join(' ');
      } else return status.substring(0, 1).toUpperCase() + status.slice(1);
    };

    $scope.editOrder = function (order) {
      if (order.deliverToType === 3) {
        // sro?
        $state.go('editRefillOrder', {
          id: order._id
        });
      } else {
        $state.go('editPurchaseOrder', {
          id: order._id
        });
      }
    };

    $scope.updatedOrderStatusFilter = function (status) {
      $scope.orderStatus = status;
      $scope.fetchOrderList();
    };

    $scope.updatedDateFilter = function (dates) {
      $scope.filterDates = dates;
      $scope.fetchOrderList();
    };

    $scope.fetchOrderList = function () {
      $scope.isLoading = true;
      apiFactory.listAllOrders({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: "date",
        search: vm.searchText,
        sortType: false,
        orderType: Constants.OrderTypes.PURCHASE,
        status: $scope.orderStatus.join(","),
        fromDate: $scope.filterDates[0],
        toDate: $scope.filterDates[1],
        projectId: vm.projectData._id === "all" ? null : vm.projectData._id
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.cars = resp.data.list;

        var _iterator2 = _createForOfIteratorHelper(vm.cars),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var order = _step2.value;
            order.price = order.details.map(function (x) {
              return x.price;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
            order.vat = order.details.map(function (x) {
              return x.vat;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
            order.total = order.details.map(function (x) {
              return x.total;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.floor(($scope.totalCount + $scope.numPerPage - 1) / $scope.numPerPage);
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    }; // $scope.fetchOrderList();


    $scope.searchOrderList = function () {
      vm.currentPage = 1;
      $scope.fetchOrderList();
    };

    $scope.sendOrder = function (order) {
      var apiFuncName = order.reference ? 'sendOrder' : 'sendProjectOrder';
      $scope.isLoading = true;
      apiFactory[apiFuncName](order._id).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        order.status = order.reference ? 'pending' : 'Pending';
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.cancelOrder = function (order) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Cancel Order',
              message: "Are you sure cancel the order?",
              subMessage: order.status === 'pending' ? 'The cancellation mail will be sent to the supplier.' : "The cancellation mail won't be sent to the supplier.",
              confirmButtonText: 'Ok',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      }).result.then(function () {
        var apiFuncName = order.reference ? 'cancelOrder' : 'cancelProjectOrder';
        $scope.isLoading = true;
        apiFactory[apiFuncName](order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          order.status = order.reference ? 'canceled' : 'Cancelled';
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.deleteOrder = function (order, index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.deleteOrder(order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          vm.cars.splice(index, 1);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.selectAllOrders = function () {
      vm.cars.forEach(function (x) {
        x.selected = vm.selectedAll;
      });
    };

    $scope.selectOrder = function (order) {
      if (!order.selected) {
        vm.selectedAll = false;
      }

      if (vm.cars.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.cars.length) {
        vm.selectedAll = true;
      }
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchOrderList();
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('salesBills', {
    controller: billsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/orders/bills/bills.view.html'
  });
  /** @ngInject */

  function billsController($scope, utils, $state, apiFactory, $log, globals, $uibModal, Notification) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore;
    vm.projectData = projectStore.get();
    $scope.utils = utils;
    $scope.activemenu = "salesBills";
    $scope.filtertypelistvalue1 = '1';
    $scope.filtertypelist1 = [{
      _id: '1',
      tagName: "Bulk Actions"
    }];
    $scope.filtertypelistvalue2 = '1';
    $scope.filtertypelist2 = [{
      _id: '1',
      tagName: "Select a Category"
    }];
    $scope.filtertypelistvalue3 = '1';
    $scope.filtertypelist3 = [{
      _id: '1',
      tagName: "Filter By OrderStatus"
    }];
    $scope.filtertypelistvalue4 = '1';
    $scope.filtertypelist4 = [{
      _id: '1',
      tagName: "Filter By Bill State"
    }];
    $scope.periods = [{
      id: '5',
      name: '5'
    }, {
      id: '10',
      name: '10'
    }, {
      id: '20',
      name: '20'
    }, {
      id: '50',
      name: '50'
    }];
    $scope.totalCount = 0;
    $scope.numPerPage = 10;
    $scope.noOfPages = 1;
    vm.currentPage = 1;
    vm.purchaseOrders = [];
    vm.currentCurrency = companyStore.get().currentCurrency;
    $scope.orderStatus = [];
    $scope.filterDates = [];
    $scope.statusTagColors = [{
      key: 'draft',
      color: '#AAB8C2',
      bgColor: '#E5EFFF'
    }, {
      key: 'Confirmed',
      color: '#1DA1F2',
      bgColor: '#E5EFFF'
    }, {
      key: 'cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'Cancelled',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'declined',
      color: '#D71414',
      bgColor: '#FEE4E2'
    }, {
      key: 'pending',
      color: '#FF8B00',
      bgColor: '#FFE8CC'
    }, {
      key: 'Pending',
      color: '#FF8B00',
      bgColor: '#FFE8CC'
    }, {
      key: 'approved',
      color: '#2FA84F',
      bgColor: '#DCF7E3'
    }];
    $scope.paymentTagColors = [{
      key: 'paid',
      color: '#2FA84F'
    }, {
      key: 'unpaid',
      color: '#FF7934'
    }, {
      key: 'overdue',
      color: '#D71414'
    }, {
      key: 'partially_paid',
      color: '#367BF5'
    }, {
      key: 'open',
      color: '#00AACE'
    }, {
      key: 'draft',
      color: '#747474'
    }, {
      key: 'void',
      color: '#FF8B00'
    }];

    $scope.getStatusTagColor = function (status) {
      var find = $scope.statusTagColors.find(function (elem) {
        return elem.key == status;
      });

      if (find) {
        return {
          color: find.color,
          bgColor: find.bgColor
        };
      } else {
        return {
          color: '#FF8B00',
          bgColor: '#FFE8CC'
        };
      }
    };

    $scope.getStatus = function (status) {
      if (utils.isEmpty(status)) return '';
      var s = status.split('_');

      if (s.length > 1) {
        var result = [];

        var _iterator = _createForOfIteratorHelper(s),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            result.push(item.substring(0, 1).toUpperCase() + item.slice(1));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return result.join(' ');
      } else return status.substring(0, 1).toUpperCase() + status.slice(1);
    };

    $scope.editOrder = function (order) {
      if (order.deliverToType === 3) {
        // sro?
        $state.go('editRefillOrder', {
          id: order._id
        });
      } else {
        $state.go('editPurchaseOrder', {
          id: order._id
        });
      }
    };

    $scope.updatedOrderStatusFilter = function (status) {
      $scope.orderStatus = status;
      $scope.fetchOrderList();
    };

    $scope.updatedDateFilter = function (dates) {
      $scope.filterDates = dates;
      $scope.fetchOrderList();
    };

    $scope.fetchOrderList = function () {
      $scope.isLoading = true;
      apiFactory.listAllOrders({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: "date",
        search: vm.searchText,
        sortType: false,
        orderType: Constants.OrderTypes.PURCHASE,
        status: $scope.orderStatus.join(","),
        fromDate: $scope.filterDates[0],
        toDate: $scope.filterDates[1],
        projectId: vm.projectData._id === "all" ? null : vm.projectData._id
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.purchaseOrders = resp.data.list;

        var _iterator2 = _createForOfIteratorHelper(vm.purchaseOrders),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var order = _step2.value;
            order.price = order.details.map(function (x) {
              return x.price;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
            order.vat = order.details.map(function (x) {
              return x.vat;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
            order.total = order.details.map(function (x) {
              return x.total;
            }).reduce(function (acc, val) {
              return acc + val;
            }, 0);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.floor(($scope.totalCount + $scope.numPerPage - 1) / $scope.numPerPage);
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    };

    $scope.fetchOrderList();

    $scope.searchOrderList = function () {
      vm.currentPage = 1;
      $scope.fetchOrderList();
    };

    $scope.sendOrder = function (order) {
      var apiFuncName = order.reference ? 'sendOrder' : 'sendProjectOrder';
      $scope.isLoading = true;
      apiFactory[apiFuncName](order._id).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        order.status = order.reference ? 'pending' : 'Pending';
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.cancelOrder = function (order) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Cancel Order',
              message: "Are you sure cancel the order?",
              subMessage: order.status === 'pending' ? 'The cancellation mail will be sent to the supplier.' : "The cancellation mail won't be sent to the supplier.",
              confirmButtonText: 'Ok',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      }).result.then(function () {
        var apiFuncName = order.reference ? 'cancelOrder' : 'cancelProjectOrder';
        $scope.isLoading = true;
        apiFactory[apiFuncName](order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          order.status = order.reference ? 'canceled' : 'Cancelled';
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.deleteOrder = function (order, index) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.deleteOrder(order._id).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          vm.purchaseOrders.splice(index, 1);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function () {});
    };

    $scope.selectAllOrders = function () {
      vm.purchaseOrders.forEach(function (x) {
        x.selected = vm.selectedAll;
      });
    };

    $scope.selectOrder = function (order) {
      if (!order.selected) {
        vm.selectedAll = false;
      }

      if (vm.purchaseOrders.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.purchaseOrders.length) {
        vm.selectedAll = true;
      }
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchOrderList();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('offers', {
    controller: OffersController,
    controllerAs: 'vm',
    templateUrl: 'app/main/offer/offers/offers.view.html'
  });
  /** @ngInject */

  function OffersController($scope, apiFactory, $log, $state, $timeout, globals, Notification, utils) {
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore;
    vm.project = projectStore.get();
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.OFFER_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.OFFER_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.OFFER]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.OFFER_ACCESS_CREATE = res.data.data[Constants.AccessKey.OFFER];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.totalCount = 0; // $scope.numPerPage = globals.numPerPage();

    $scope.numPerPage = 12;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    vm.searchText = undefined;
    vm.sortMenuList = [{
      label: 'Name',
      key: 'offerName'
    }, {
      label: 'Created Date',
      key: 'createdAt'
    }, {
      label: 'Modified Date',
      key: 'updatedAt'
    }, {
      label: 'Offer Tag',
      key: 'systemTag'
    }];
    vm.sortMenu = "createdAt";
    vm.sortType = true;

    $scope.initData = function () {
      $scope.isLoading = true;
      apiFactory.listAllOffers({
        projectId: vm.project._id,
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        sort: vm.sortMenu,
        sortType: vm.sortType
      }).then(function (resp) {
        vm.offers = resp.data.list;
        $log.log(vm.offers, "sales offers");
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.floor(($scope.totalCount + $scope.numPerPage - 1) / $scope.numPerPage);
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    };

    $scope.initData();

    $scope.getAddress = function (address) {
      return address && address[0] ? "".concat(address[0].line1, ", ").concat(address[0].city, ", ").concat(address[0].postalCode, ", ").concat(address[0].countryCode) : 'Unknown';
    };

    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.initData();
    };

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) {
        vm.currentPage = 1;
      }

      $scope.initData();
    };

    $scope.isList = false;
    $scope.isGrid = true;

    $scope.onListView = function () {
      $scope.isGrid = false;
      $scope.isList = true;
    };

    $scope.onGridView = function () {
      $scope.isGrid = true;
      $scope.isList = false;
    };

    $scope.goToDetail = function (offer) {
      $state.go('offerDetail', {
        id: offer._id
      });
    };

    $scope.goToCreate = function () {
      $state.go('createOffer');
    };

    $scope.getIndex = function (listIndex) {
      return $scope.totalCount - ($scope.numPerPage * (vm.currentPage - 1) + listIndex);
    };

    vm.selectSort = function () {
      vm.sortType = vm.sortMenu === 'createdAt' || vm.sortMenu === 'updatedAt';
      $scope.searchCallback();
    };

    vm.downloadPdf = function (offer) {
      $scope.isDownloading = true;
      utils.downloadFile(offer.offerPdf, 'offer.pdf').then(function () {
        $scope.isDownloading = false;
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.isDownloading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    $scope.getColor = function (name) {
      return globals.getAvatarColor(name);
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('offerDetail', {
    controller: OfferDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/offer/offerDetail/offerDetail.view.html'
  });
  /** @ngInject */

  function OfferDetailController($scope, $timeout, $log, $state, $stateParams, apiFactory, Notification, globals, localStorageService, $uibModal) {
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.OFFER_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.OFFER_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.OFFER]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.OFFER_ACCESS_CREATE = res.data.data[Constants.AccessKey.OFFER];
    //   })
    //   .catch((e) => {
    //     $scope.isLoading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }
    // offer

    vm.offer = {
      date: '',
      validTill: '',
      offerDetails: []
    };

    function initData() {
      $scope.isLoading = true;
      localStorageService.set('offerDetail', null);
      Promise.all([apiFactory.listAllAdminUsers(vm.project._id), apiFactory.getOfferDetail($stateParams.id)]).then(function (resp) {
        vm.allManagers = resp[0].data.list;
        vm.offer = resp[1].data.data;
        localStorageService.set('offerDetail', vm.offer.offerDetails);
        vm.offerstaff = vm.offer.staff ? vm.offer.staff._id : null;
        vm.offer.date = new Date(vm.offer.date);
        vm.offer.validTill = new Date(vm.offer.validTill);
        $scope.companyCurrency = '';

        if (vm.offer.offerDetails && vm.offer.offerDetails.length > 0) {
          $scope.companyCurrency = vm.offer.offerDetails[0].currency;
        }

        $scope.companyAddress = vm.getCompanyAddress();
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }

    initData();

    $scope.selStaff = function (id) {
      var staff = vm.offer.clientId.staffs.find(function (x) {
        return x._id === id;
      });

      if (staff) {
        vm.offer.staff = staff;
      }
    };

    vm.saveOffer = function () {
      var offerData = makeOfferData();

      if (!offerData) {
        return;
      }

      apiFactory.updateOffer(vm.offer._id, offerData).then(function () {
        Notification.success('Offer saved successfully.');
        $state.go('offerList');
      })["catch"](function (error) {
        $log.error(error);

        if (error.data && error.data.message) {
          Notification.error(error.data.message);
        } else {
          Notification.error('Something was wrong.');
        }
      });
    };

    vm.sendOffer = function () {
      var offerData = makeOfferData();

      if (!offerData) {
        return;
      }

      $scope.isLoading = true;
      apiFactory.updateAndSendOffer(vm.offer._id, offerData).then(function (resp) {
        $log.log(resp);
        $scope.isLoading = false;
        Notification.success('Offer saved successfully.');
        $state.go('offerList');
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error('Something was wrong.');
      });
    };

    vm.deleteOffer = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          apiFactory.deleteOffer(vm.offer._id).then(function (resp) {
            $log.log(resp);
            Notification.success('Offer deleted successfully.');
            $state.go('offerList');
          })["catch"](function (err) {
            $log.error(err);
            Notification.error('Something was wrong.');
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.onCombine = function () {
      var temp = {},
          tempItems;
      var selectedNum = 0;
      vm.offer.offerDetails.map(function (item) {
        if (item.index === true) {
          selectedNum++;
        }
      });

      if (selectedNum < 2) {
        Notification.error('Please Select Items');
        return;
      }

      vm.offer.offerDetails.map(function (item) {
        if (item.index == true) {
          if (angular.isUndefined(temp.total)) {
            temp = item;
          } else {
            temp.total += item.total;
          }
        }
      });
      temp.quantity = undefined;
      temp.unitPrice = undefined;
      tempItems = [temp];
      vm.offer.offerDetails.forEach(function (item) {
        if (item.index != true) {
          tempItems.push(item);
        }
      });
      vm.offer.offerDetails = tempItems;
      vm.offer.offerDetails.forEach(function (item) {
        item.index = false;
      });
    };

    $scope.onRefresh = function () {
      vm.offer.offerDetails = localStorageService.get('offerDetail');
    };

    function makeOfferData() {
      if (!vm.offer.offerName) {
        Notification.error('Offer Name is required.');
        return null;
      }

      if (!vm.offer.staff) {
        Notification.error('Staff Contact is required.');
        return null;
      }

      vm.offer.offerDetails.forEach(function (element) {
        element._id = undefined;
      });
      return {
        offerName: vm.offer.offerName,
        clientId: vm.offer.clientId._id,
        projectId: vm.offer.projectId._id,
        companyId: vm.companyData._id,
        staff: vm.offer.staff ? vm.offer.staff._id : null,
        date: vm.offer.date,
        validTill: vm.offer.validTill,
        description: vm.offer.description,
        termsAndConditions: vm.offer.termsAndConditions,
        totalNetAmount: vm.offer.totalNetAmount,
        totalTaxAmount: vm.offer.totalTaxAmount,
        offerTotal: vm.offer.offerTotal,
        offerDetails: vm.offer.offerDetails,
        version: vm.offer.version
      };
    }

    $scope.companyAddress = '';

    vm.getCompanyAddress = function () {
      if (!vm.offer || !vm.offer.projectId || !vm.offer.projectId.client) return '';
      var address = vm.offer.projectId.client.address ? vm.offer.projectId.client.address[0] : '';

      if (address != '') {
        address = "".concat(address.line1, ", ").concat(address.city, ", ").concat(address.postalCode, ", ").concat(address.countryCode);
      }

      $scope.isLoading = false;
      return address;
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('createOffer', {
    controller: CreateOfferController,
    controllerAs: 'vm',
    templateUrl: 'app/main/offer/createOffer/createOffer.view.html'
  });
  /** @ngInject */

  function CreateOfferController($scope, localStorageService, $timeout, $location, $state, utils, apiFactory, Notification, globals, $log) {
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please Select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.isExported = false;
    localStorageService.set('offerDetail', null);
    $scope.tableInventory = [];
    vm.openBreadCumb = false;
    vm.currentStateList = [];
    vm.extraCosts = []; // offer

    vm.offer = {
      date: '',
      validTill: '',
      offerDetails: []
    };
    vm.clientAddress = '';

    function initData() {
      $scope.isLoading = true;
      globals.getCurrency().then(function (resp) {
        vm.getCurrencyCode = resp.data;
        $scope.companyCurrency = vm.getCurrencyCode.find(function (element) {
          return element.cc === vm.companyData.currentCurrency.currencyCode;
        });
      });
      apiFactory.getCalcSheet(vm.project._id).then(function (resp) {
        var sheet = resp.data.data;

        if (sheet) {
          $scope.companyCurrency = sheet.companyCurrency;
          $scope.totalSum = sheet.sum;
          $scope.tableInventory = sheet.levels;
          vm.extraCosts = sheet.additionalCosts ? sheet.additionalCosts.filter(function (it) {
            return it.type === 'global';
          }) : [];
        }

        $scope.isLoading = false;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
      });
    }

    initData();
    $scope.headers = [{
      name: "Items"
    }, {
      name: "Amount"
    }, {
      name: "Unit"
    }, {
      name: "Unit price"
    }, {
      name: "Cost Price"
    }, {
      name: "Labour Hours"
    }, {
      name: "Operating Cost"
    }, {
      name: "Profit"
    }, {
      name: "Sales Price"
    }, {
      name: "Export"
    }];

    $scope.selectedItem = function (item, index, array) {
      item.Quantity = 1;
      array[index] = item;
      $scope.filterCity = [];
    };

    $scope.gotoBreadCrumb = function (index) {
      vm.openBreadCumb = true;
      vm.breadCrumbIndex = index;
      vm.currentState = $scope.tableInventory[index];
      vm.currentStateList.push(vm.currentState);
      vm.breadCrumbItem = vm.breadCrumbIndex.name;
    };

    $scope.breadCrumbSubLevel = function (index, innerIndex, sublevel) {
      vm.currentState = sublevel;
      vm.currentStateList.push(vm.currentState);
    };

    vm.changeBreadCrumb = function (index) {
      vm.currentState = vm.currentStateList[index];
      vm.currentStateList = vm.currentStateList.slice(0, index + 1);
    };

    vm.callBreadCrumb = function (index, innerindex, sublevel) {
      vm.openBreadCumb = true;
      vm.breadCrumbIndex = index;
      var current = $scope.tableInventory[index];
      vm.currentStateList.push(current);
      vm.currentState = sublevel;
      vm.currentStateList.push(vm.currentState);
    };

    vm.goToRoot = function () {
      vm.openBreadCumb = false;
      vm.currentStateList = [];
    };

    $scope.sortProperty = null;
    $scope.sortSublevelProperty = null;

    vm.sort = function () {
      $scope.sortProperty = $scope.sortProperty == null ? 'inventoryName' : null;
      $scope.sortSublevelProperty = $scope.sortSublevelProperty == null ? 'name' : null;
    };

    $scope.RootChange = function (rootselected, tableInventory) {
      tableInventory.forEach(function (inventory) {
        $scope.tickSelected(inventory, rootselected, "root");
      });
    };

    vm["export"] = function () {
      $scope.isExported = true;
      prepareOffer();
      prepareExport();
    };

    $scope.selStaff = function (id) {
      var staff = vm.offer.client.staffs.find(function (x) {
        return x._id === id;
      });

      if (staff) {
        vm.offer.staff = staff;
      }
    };

    function prepareOffer() {
      vm.offer.client = vm.project.client;
      vm.offer.project = vm.project;
      apiFactory.getClientById(vm.project.client._id).then(function (resp) {
        vm.offer.client = resp.data.data;
      })["catch"](function (e) {
        $log.log(e);
      });
      apiFactory.listAllAdminUsers(vm.project._id).then(function (resp) {
        vm.allManagers = resp.data.list;
      });
      var date = new moment();
      vm.offer.date = new Date(date.format("YYYY/MM/DD"));
      vm.offer.validTill = new Date(date.add('30', 'd').format("YYYY/MM/DD"));
      apiFactory.getOfferVersion(vm.offer.project._id).then(function (resp) {
        var number = resp.data.data;
        var newStr = pad(number, 3);
        vm.offer.version = newStr;
      });
    }

    function pad(num, size) {
      var s = num + "";

      while (s.length < size) {
        s = "0" + s;
      }

      return s;
    }

    function prepareExport() {
      vm.offer.offerDetails = [];
      var summary = {
        sum: 0
      };

      for (var i = 0; i < $scope.tableInventory.length; i++) {
        var level = $scope.tableInventory[i];
        exportLevel(level, summary);
      }

      for (var _i = 0; _i < vm.extraCosts.length; _i++) {
        var cost = vm.extraCosts[_i];

        if (cost.checked) {
          var calcData = {
            productName: cost.name,
            currency: $scope.companyCurrency ? $scope.companyCurrency.symbol : '',
            productId: cost.name,
            total: $scope.totalSum * cost.value / 100
          };
          vm.offer.offerDetails.push(calcData);
          summary.sum += calcData.total;
          localStorageService.set('offerDetail', vm.offer.offerDetails);
        }
      }

      vm.offer.totalNetAmount = summary.sum;
      vm.offer.totalTaxAmount = vm.offer.totalNetAmount * 0.25;
      vm.offer.offerTotal = vm.offer.totalNetAmount + vm.offer.totalTaxAmount;
    }

    function exportLevel(level, summary) {
      if (level.items) {
        for (var j = 0; j < level.items.length; j++) {
          var item = level.items[j];

          if (item.checked) {
            var calcData = {
              productName: item.inventoryName,
              quantity: item.inventoryAmount,
              currency: $scope.companyCurrency.symbol,
              productId: item.systemTag,
              total: item.salesPrice
            };

            if (item.rowStyle === 'Combined') {
              calcData.total += item.workersPrice;
            }

            calcData.unitPrice = calcData.total / calcData.quantity;
            vm.offer.offerDetails.push(calcData);

            if (angular.isDefined(calcData.total)) {
              summary.sum += calcData.total;
            }

            localStorageService.set('offerDetail', vm.offer.offerDetails);
          }
        }
      }

      if (level.levels) {
        level.levels.forEach(function (sublevel) {
          exportLevel(sublevel, summary);
        });
      }

      if (level.checked) {
        var _calcData = {
          productName: level.name,
          currency: $scope.companyCurrency ? $scope.companyCurrency.symbol : '',
          productId: level.name,
          total: level.sum
        };
        vm.offer.offerDetails.push(_calcData);
        localStorageService.set('offerDetail', vm.offer.offerDetails);
        if (angular.isDefined(_calcData.total)) summary.sum += _calcData.total;
      }
    }

    vm.saveOffer = function () {
      var offerData = makeOfferData();

      if (!offerData) {
        return;
      }

      apiFactory.createOffer(offerData).then(function (resp) {
        $log.log(resp.data.message);
        Notification.success('Offer saved successfully.');
        $state.go('offerList');
      })["catch"](function (error) {
        $log.error(error);
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Something was wrong.');
      });
    };

    $scope.onCombine = function () {
      var temp = {},
          tempItems;
      var selectedNum = 0;
      vm.offer.offerDetails.map(function (item) {
        if (item.index == true) {
          selectedNum++;
        }
      });

      if (selectedNum < 2) {
        Notification.error('Please Select Items');
        return;
      }

      vm.offer.offerDetails.map(function (item) {
        if (item.index == true) {
          if (angular.isUndefined(temp.total)) {
            temp = item;
          } else {
            temp.total += item.total;
          }
        }
      });
      temp.quantity = undefined;
      temp.unitPrice = undefined;
      tempItems = [temp];
      vm.offer.offerDetails.forEach(function (item) {
        if (item.index != true) {
          tempItems.push(item);
        }
      });
      vm.offer.offerDetails = tempItems;
      vm.offer.offerDetails.forEach(function (item) {
        item.index = false;
      });
    };

    $scope.onRefresh = function () {
      vm.offer.offerDetails = localStorageService.get('offerDetail');
      vm.offer.offerDetails.forEach(function (item) {
        item.index = false;
      });
    };

    vm.sendOffer = function () {
      var offerData = makeOfferData();

      if (!offerData) {
        return;
      }

      apiFactory.createAndSendOffer(offerData).then(function (resp) {
        $log.log(resp.data.message);
        Notification.success('Offer saved successfully.');
      })["catch"](function (err) {
        $log.error(err);
        Notification.error('Something was wrong.');
      });
    };

    function makeOfferData() {
      if (!vm.offer.offerName) {
        Notification.error('Offer Name is required.');
        return null;
      }

      if (!vm.offer.staff) {
        Notification.error('Offer is required.');
        return null;
      }

      for (var i = 0; i < vm.offer.offerDetails.length; i++) {
        if (!vm.offer.offerDetails[i].description) {
          vm.offer.offerDetails[i].description = '';
        }
      }

      return {
        offerName: vm.offer.offerName,
        clientId: vm.offer.client._id,
        projectId: vm.offer.project._id,
        companyId: vm.companyData._id,
        staff: vm.offer.staff._id,
        date: vm.offer.date,
        validTill: vm.offer.validTill,
        description: vm.offer.description,
        termsAndConditions: vm.offer.termsAndConditions,
        totalNetAmount: vm.offer.totalNetAmount,
        totalTaxAmount: vm.offer.totalTaxAmount,
        offerTotal: vm.offer.offerTotal,
        offerDetails: vm.offer.offerDetails,
        version: vm.offer.version
      };
    }

    vm.cancelOfferView = function () {
      $scope.isExported = false;
    };

    vm.getCompanyAddress = function () {
      var address = vm.offer.project.client.address ? vm.offer.project.client.address[0] : '';

      if (address != '') {
        address = "".concat(address.line1, ", ").concat(address.city, ", ").concat(address.postalCode, ", ").concat(address.countryCode);
      }

      return address;
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('materialList', {
    controller: materialListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/materialList/materialList.view.html'
  });
  /** @ngInject */

  function materialListController($scope, apiFactory, FileSaver, Notification, globals, $log, $state) {
    var vm = this;
    var userStore = globals.userStore;
    $scope.MAT_ACCESS_CREATE = 100;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    }; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.MAT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.MAT]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.MAT_ACCESS_CREATE = res.data.data[Constants.AccessKey.MAT];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }


    $scope.periods = [{
      id: '8',
      name: '8'
    }, {
      id: '16',
      name: '16'
    }, {
      id: '32',
      name: '32'
    }];
    $scope.labelChecked = false;
    $scope.materials = [];
    $scope.totalCount = 0; // $scope.numPerPage = globals.numPerPage();

    $scope.numPerPage = 8;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.totalCountForGroup = 0;
    $scope.numPerPageForGroup = globals.numPerPage();
    $scope.noOfPagesForGroup = 0;
    vm.currentPageForGroup = 1;
    $scope.isLoading = false;
    $scope.isGrid = true;
    vm.searchText = undefined;
    vm.materialGroup = [];
    vm.category = 'all';
    vm.isViewGroupList = false;
    vm.selectedGroupName = '';
    vm.groupBy = null;
    vm.isViewGroupDetail = false;
    vm.sortMenuMaterial = "createdAt";
    vm.sortMenuMaterialList = [{
      label: 'Name',
      key: 'name'
    }, {
      label: 'Created Date',
      key: 'createdAt'
    }, {
      label: 'Material Tag',
      key: 'systemTag'
    }];
    vm.groupCategories = [{
      label: 'All',
      key: 'all'
    }, {
      label: 'GroupBy',
      key: 'group_by'
    }, {
      label: 'UnGrouped',
      key: 'other'
    }];
    vm.currencies = [];
    globals.getCurrency().then(function (res) {
      vm.currencies = res.data;
    });

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.sortMaterials();
    };

    vm.fetchMaterialGroup = function () {
      $scope.isLoading = true;
      var payload = {
        page: vm.currentPageForGroup,
        chunk: $scope.numPerPageForGroup
      };
      apiFactory.getAllMaterialGroup(payload).then(function (resp) {
        $scope.isLoading = false;
        vm.materialGroup = resp.data.data;
        $scope.totalCountForGroup = resp.data.total;
        $scope.noOfPagesForGroup = Math.ceil($scope.totalCountForGroup / $scope.numPerPageForGroup);
        vm.isViewGroupList = true;
        vm.isViewGroupDetail = false;
      });
    };

    vm.sortMaterials = function () {
      $scope.isLoading = true;
      var payload = {
        sort: vm.sortMenuMaterial,
        search: vm.searchText,
        sortType: "false",
        page: vm.currentPage,
        chunk: $scope.numPerPage
      };

      if (vm.category !== 'all') {
        if (vm.category === 'other') payload.groupBy = vm.category;else payload.groupBy = vm.groupBy;
      }

      apiFactory.listAllMaterials(payload).then(function (resp) {
        $scope.isLoading = false;
        $scope.totalCount = resp.data.total;
        $scope.materials = resp.data.list;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    vm.sortMaterials();

    $scope.upLoadExcelFile = function (filetosave) {
      var filedata = {
        file: filetosave
      };
      apiFactory.uploadExcel(filedata).then(function () {
        angular.element("#uploadmatModal").modal("hide");
        Notification.success("New material saved.");
      })["catch"](function (err) {
        $log.error(err);
      });
    };

    $scope.downLoadExcel = function () {
      $scope.isLoading = true;
      apiFactory.downLoadExcel().then(function (resp) {
        $scope.isLoading = false;
        var blob = new Blob([resp.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        FileSaver.saveAs(blob, "materials.xlsx");
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    vm.changedCategory = function () {
      if (vm.category !== 'group_by') {
        vm.isViewGroupList = false;
        vm.isViewGroupDetail = false;
        vm.sortMaterials();
      } else {
        vm.fetchMaterialGroup();
      }
    };

    vm.showMaterialsByGroup = function (id) {
      vm.isViewGroupDetail = true;
      vm.isViewGroupList = false;
      vm.groupBy = id;
      var find = vm.materialGroup.find(function (elem) {
        return elem._id === id;
      });
      if (find) vm.selectedGroupName = find.name;
      vm.sortMaterials();
    };

    vm.showAllList = function () {
      vm.category = 'all';
      vm.sortMaterials();
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.sortMaterials();
    };

    vm.selectNumPage_group = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchMaterialGroup();
    };

    $scope.switchViewMode = function (isGrid) {
      $scope.isGrid = isGrid;
    };

    $scope.getCurrencySymbol = function (mat) {
      if (angular.isUndefined(mat) || angular.isUndefined(mat.currentRate) || angular.isUndefined(mat.currentRate.materialCost.currencyCode)) {
        return 'Kr';
      }

      var find = vm.currencies.find(function (x) {
        return x.cc === mat.currentRate.materialCost.currencyCode;
      });

      if (find) {
        return find.symbol;
      } else {
        return 'Kr';
      }
    };

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      $scope.materials.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('materialDetail', {
    controller: materialDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/materialDetail/materialDetail.view.html'
  });
  /** @ngInject */

  function materialDetailController($scope, apiFactory, globals, moment, $stateParams, $state, utils, $timeout, $log, Notification, $uibModal) {
    var vm = this;
    vm.utils = utils;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    /* Get project list */

    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.MAT_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.MAT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.MAT]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.MAT_ACCESS_CREATE = res.data.data[Constants.AccessKey.MAT];
    //   })
    //   .catch((e) => {
    //     $scope.isLoading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    vm.materialId = $stateParams.id;
    $scope.isLoading = false;
    vm.currentImageIndex = 0;

    function getMatDetail() {
      $scope.isLoading = true;
      apiFactory.getMaterialById(vm.materialId).then(function (resp) {
        $scope.isLoading = false;
        vm.material = resp.data;
        vm.uploadImages = resp.data.files.images;
        vm.uploadFiles = resp.data.files.docs;

        if (vm.material.baseRate.currencyCode === vm.material.currentRate.materialCost.currencyCode && vm.material.baseRate.currencyCode === vm.material.currentRate.rooferCost.currencyCode) {
          $scope.boxes = [{
            img: "/assets/icons/scale-white.svg",
            title: "Unit",
            unit: vm.material.unit
          }, {
            img: "/assets/icons/dollar-white.svg",
            title: "Material Cost",
            value: vm.material.currentRate.materialCost.value,
            currencyCode: vm.material.currentRate.materialCost.currencyCode
          }, {
            img: "/assets/icons/dollar-white.svg",
            title: "Worker Cost",
            value: vm.material.currentRate.rooferCost.value,
            currencyCode: vm.material.currentRate.rooferCost.currencyCode
          }, {
            img: "/assets/icons/dollar-white.svg",
            title: "Delivery Cost",
            value: vm.material.currentRate.materialCost.value,
            currencyCode: vm.material.currentRate.materialCost.currencyCode
          }];
        } else {
          $scope.boxes = [{
            img: "/assets/icons/scale-white.svg",
            title: "Unit",
            unit: vm.material.unit
          }, {
            img: "/assets/icons/dollar-white.svg",
            title: "Material Cost",
            value: vm.material.currentRate.materialCost.value,
            baseValue: vm.material.baseRate.materialCost,
            currencyCode: vm.material.currentRate.materialCost.currencyCode,
            baseCurrencyCode: vm.material.baseRate.currencyCode
          }, {
            img: "/assets/icons/dollar-white.svg",
            title: "Worker Cost",
            value: vm.material.currentRate.rooferCost.value,
            baseValue: vm.material.baseRate.rooferCost,
            currencyCode: vm.material.currentRate.rooferCost.currencyCode,
            baseCurrencyCode: vm.material.baseRate.currencyCode
          }, {
            img: "/assets/icons/dollar-white.svg",
            title: "Delivery Cost",
            value: vm.material.currentRate.materialCost.value,
            baseValue: vm.material.baseRate.materialCost,
            currencyCode: vm.material.currentRate.materialCost.currencyCode,
            baseCurrencyCode: vm.material.baseRate.currencyCode
          }];
        }

        vm.designImage = vm.material.files.images.find(function (x) {
          return x.assetDescription === "designImage";
        });
        $timeout(imgSlider, 1500);
        nextMaintenanceDateCalc(vm.material.createdAt, vm.material.maintenancePeriod);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
      });
    }

    getMatDetail();

    function nextMaintenanceDateCalc(createdAt, maintenancePeriod) {
      var createdDate = Number.parseInt(moment(createdAt).format("X"));
      var nextMaintenanceDate = Number.parseInt(moment(createdAt).add(maintenancePeriod, "days").format("X"));

      if (createdDate < nextMaintenanceDate) {
        vm.nextMaintenanceDate = moment(createdAt).add(maintenancePeriod, "days").format("MMM DD, YYYY");
      } else {
        var createdDate1 = moment.utc(createdAt).add(maintenancePeriod, "days").format();
        nextMaintenanceDateCalc(createdDate1, maintenancePeriod);
      }
    }

    $scope.deleteMaterial = function () {
      $scope.isLoading = true;
      apiFactory.deleteMaterialById(vm.materialId).then(function () {
        $scope.isLoading = false;
        $state.go('materialList');
        Notification.success('Material deleted successfully');
      }, function () {
        Notification.error('Something went wrong try later');
      })["catch"](function () {});
    };

    function imgSlider() {
      angular.element(".slider").flexslider({
        animation: "slide",
        start: function start() {
          angular.element('body').removeClass('loading');
        }
      });
    }

    $scope.showImage = function (imageUrl) {
      $uibModal.open({
        animation: true,
        component: 'imageViewerModal',
        windowClass: 'image-viewer-modal',
        resolve: {
          imageURL: function imageURL() {
            return imageUrl;
          }
        }
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('materialAI', {
    controller: materialAIController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/materialAI/materialAI.view.html'
  });
  /** @ngInject */

  function materialAIController($scope, apiFactory, globals, moment, $stateParams, $state, utils, $timeout, $log, Notification, $uibModal) {
    var vm = this;
    vm.utils = utils;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    /* Get project list */

    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.MAT_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.MAT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.MAT]})
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.MAT_ACCESS_CREATE = res.data.data[Constants.AccessKey.MAT];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.materialId = $stateParams.id;
    $scope.loading = false;
    vm.currentImageIndex = 0;
    $scope.geometricTypes = [{
      label: 'Triangle',
      value: 'Triangle'
    }, {
      label: 'Square',
      value: 'Square'
    }, {
      label: 'Cone',
      value: 'Cone'
    }, {
      label: 'Cylinder',
      value: 'Cylinder'
    }];
    $scope.seasons = [{
      label: 'Spring',
      value: 'Spring'
    }, {
      label: 'Summer',
      value: 'Summer'
    }, {
      label: 'Autumn',
      value: 'Autumn'
    }, {
      label: 'Winter',
      value: 'Winter'
    }];
    vm.isPlaying = false;
    vm.aiInfos = [];
    vm.aiPlayData = [];
    initData();

    vm.togglePlay = function () {
      vm.isPlaying = !vm.isPlaying;

      if (vm.isPlaying) {
        Plotly.newPlot('chart', [{
          z: vm.aiPlayData,
          type: 'surface'
        }], {
          title: 'AI Data',
          showlegend: false
        }, {
          displayModeBar: false
        });
      }
    };

    function initData() {
      $scope.loading = true;
      Promise.all([apiFactory.getMaterialById(vm.materialId), apiFactory.listMaterialAI(vm.materialId)]).then(function (resp) {
        $scope.loading = false;
        vm.material = resp[0].data;
        vm.aiInfos = resp[1].data.list || [];
        vm.aiPlayData = getAIPlayData();
        vm.uploadImages = vm.material.files.images;
        vm.uploadFiles = vm.material.files.docs;
        var aiWorkerCost = getAIWorkerCost(vm.aiInfos);
        $scope.boxes = [{
          img: "/assets/icons/scale-white.svg",
          title: "Unit",
          unit: vm.material.unit
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Material Cost",
          value: vm.material.currentRate.materialCost.value,
          currencyCode: vm.material.currentRate.materialCost.currencyCode
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Worker Cost",
          value: vm.material.currentRate.rooferCost.value,
          currencyCode: vm.material.currentRate.rooferCost.currencyCode
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "AI Worker Cost",
          value: aiWorkerCost,
          currencyCode: vm.material.currentRate.materialCost.currencyCode
        }];
        vm.designImage = vm.material.files.images.find(function (x) {
          return x.assetDescription === "designImage";
        });
        $timeout(imgSlider, 1500);
        nextMaintenanceDateCalc(vm.material.createdAt, vm.material.maintenancePeriod);
      })["catch"](function (err) {
        $log.error(err);
        $scope.loading = false;
        Notification.error("Failed to get material AI information.");
      });
    }

    function nextMaintenanceDateCalc(createdAt, maintenancePeriod) {
      var createdDate = Number.parseInt(moment(createdAt).format("X"));
      var nextMaintenanceDate = Number.parseInt(moment(createdAt).add(maintenancePeriod, "days").format("X"));

      if (createdDate < nextMaintenanceDate) {
        vm.nextMaintenanceDate = moment(createdAt).add(maintenancePeriod, "days").format("MMM DD, YYYY");
      } else {
        var createdDate1 = moment.utc(createdAt).add(maintenancePeriod, "days").format();
        nextMaintenanceDateCalc(createdDate1, maintenancePeriod);
      }
    }

    $scope.deleteMaterial = function () {
      $scope.loading = true;
      apiFactory.deleteMaterialById(vm.materialId).then(function () {
        $scope.loading = false;
        $state.go('materialList');
        Notification.success('Material deleted successfully');
      }, function () {
        Notification.error('Something went wrong try later');
      })["catch"](function () {});
    };

    function imgSlider() {
      angular.element(".slider").flexslider({
        animation: "slide",
        start: function start() {
          angular.element('body').removeClass('loading');
        }
      });
    }

    $scope.showImage = function (imageUrl) {
      $uibModal.open({
        animation: true,
        component: 'imageViewerModal',
        windowClass: 'image-viewer-modal',
        resolve: {
          imageURL: function imageURL() {
            return imageUrl;
          }
        }
      });
    };

    function getAIWorkerCost(aiInfos) {
      var sumCost = 0;
      aiInfos.forEach(function (info) {
        sumCost += info.avgLaborCost;
      });
      return aiInfos.length === 0 ? 0 : sumCost / aiInfos.length;
    }

    function getAIPlayData() {
      var arr = [];
      vm.aiInfos.forEach(function (info) {
        arr.push([info.size, info.avgMaterialCost, info.avgLaborCost, Math.random() * info.avgMaterialCost, Math.random() * info.avgLaborCost, Math.random() * info.size]);
      });
      return arr;
    }
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('itemList', {
    controller: itemListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/itemList/itemList.view.html'
  });
  /** @ngInject */

  function itemListController($scope, apiFactory, FileSaver, Notification, globals, $log, $state) {
    var vm = this;
    var userStore = globals.userStore;
    $scope.MAT_ACCESS_CREATE = 100;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    }; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.MAT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.MAT]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.MAT_ACCESS_CREATE = res.data.data[Constants.AccessKey.MAT];
    //     }).catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }


    $scope.periods = [{
      id: '8',
      name: '8'
    }, {
      id: '16',
      name: '16'
    }, {
      id: '32',
      name: '32'
    }];
    $scope.labelChecked = false;
    $scope.materials = [];
    $scope.totalCount = 0; // $scope.numPerPage = globals.numPerPage();

    $scope.numPerPage = 8;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.totalCountForGroup = 0;
    $scope.numPerPageForGroup = globals.numPerPage();
    $scope.noOfPagesForGroup = 0;
    vm.currentPageForGroup = 1;
    $scope.isLoading = false;
    $scope.isGrid = true;
    vm.searchText = undefined;
    vm.materialGroup = [];
    vm.category = 'all';
    vm.isViewGroupList = false;
    vm.selectedGroupName = '';
    vm.groupBy = null;
    vm.isViewGroupDetail = false;
    vm.sortMenuMaterial = "createdAt";
    vm.sortMenuMaterialList = [{
      label: 'Name',
      key: 'name'
    }, {
      label: 'Created Date',
      key: 'createdAt'
    }, {
      label: 'Material Tag',
      key: 'systemTag'
    }];
    vm.groupCategories = [{
      label: 'All',
      key: 'all'
    }, {
      label: 'GroupBy',
      key: 'group_by'
    }, {
      label: 'UnGrouped',
      key: 'other'
    }];
    vm.currencies = [];
    globals.getCurrency().then(function (res) {
      vm.currencies = res.data;
    });

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.sortMaterials();
    };

    vm.fetchMaterialGroup = function () {
      $scope.isLoading = true;
      var payload = {
        page: vm.currentPageForGroup,
        chunk: $scope.numPerPageForGroup
      };
      apiFactory.getAllMaterialGroup(payload).then(function (resp) {
        $scope.isLoading = false;
        vm.materialGroup = resp.data.data;
        $scope.totalCountForGroup = resp.data.total;
        $scope.noOfPagesForGroup = Math.ceil($scope.totalCountForGroup / $scope.numPerPageForGroup);
        vm.isViewGroupList = true;
        vm.isViewGroupDetail = false;
      });
    };

    vm.sortMaterials = function () {
      $scope.isLoading = true;
      var payload = {
        sort: vm.sortMenuMaterial,
        search: vm.searchText,
        sortType: "false",
        page: vm.currentPage,
        chunk: $scope.numPerPage
      };
      apiFactory.listAllItems(payload).then(function (resp) {
        $scope.isLoading = false;
        $scope.totalCount = resp.data.total;
        $scope.materials = resp.data.list;
        $log.log($scope.materials);
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    vm.sortMaterials();

    $scope.upLoadExcelFile = function (filetosave) {
      var filedata = {
        file: filetosave
      };
      apiFactory.uploadExcel(filedata).then(function () {
        angular.element("#uploadmatModal").modal("hide");
        Notification.success("New material saved.");
      })["catch"](function (err) {
        $log.error(err);
      });
    };

    $scope.downLoadExcel = function () {
      $scope.isLoading = true;
      apiFactory.downLoadExcel().then(function (resp) {
        $scope.isLoading = false;
        var blob = new Blob([resp.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        FileSaver.saveAs(blob, "materials.xlsx");
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    vm.changedCategory = function () {
      if (vm.category !== 'group_by') {
        vm.isViewGroupList = false;
        vm.isViewGroupDetail = false;
        vm.sortMaterials();
      } else {
        vm.fetchMaterialGroup();
      }
    };

    vm.showMaterialsByGroup = function (id) {
      vm.isViewGroupDetail = true;
      vm.isViewGroupList = false;
      vm.groupBy = id;
      var find = vm.materialGroup.find(function (elem) {
        return elem._id === id;
      });
      if (find) vm.selectedGroupName = find.name;
      vm.sortMaterials();
    };

    vm.showAllList = function () {
      vm.category = 'all';
      vm.sortMaterials();
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.sortMaterials();
    };

    vm.selectNumPage_group = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchMaterialGroup();
    };

    $scope.switchViewMode = function (isGrid) {
      $scope.isGrid = isGrid;
    };

    $scope.getCurrencySymbol = function (mat) {
      if (angular.isUndefined(mat) || angular.isUndefined(mat.cost[0]) || angular.isUndefined(mat.cost[0].currencyCode)) {
        return 'Kr';
      }

      var find = vm.currencies.find(function (x) {
        return x.cc === mat.cost[0].currencyCode;
      });

      if (find) {
        return find.symbol;
      } else {
        return 'Kr';
      }
    };

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      $scope.materials.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('itemDetail', {
    controller: itemDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/itemDetail/itemDetail.view.html'
  });
  /** @ngInject */

  function itemDetailController($scope, apiFactory, globals, moment, $stateParams, $state, utils, $timeout, $log, Notification, $uibModal) {
    var vm = this;
    vm.utils = utils;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    /* Get project list */

    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.MAT_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.MAT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.MAT]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.MAT_ACCESS_CREATE = res.data.data[Constants.AccessKey.MAT];
    //   })
    //   .catch((e) => {
    //     $scope.isLoading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    vm.materialId = $stateParams.id;
    $scope.isLoading = false;
    vm.currentImageIndex = 0;

    function getMatDetail() {
      $scope.isLoading = true;
      apiFactory.getItemById(vm.materialId).then(function (resp) {
        $scope.isLoading = false;
        vm.material = resp.data;
        vm.uploadImages = resp.data.files.images;
        vm.uploadFiles = resp.data.files.docs;
        $scope.boxes = [{
          img: "/assets/icons/scale-white.svg",
          title: "Unit",
          unit: vm.material.unit
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Items Cost",
          value: vm.material.cost[0].itemsCost,
          currencyCode: vm.material.cost[0].currencyCode
        }]; // if (vm.material.baseRate.currencyCode === vm.material.currentRate.materialCost.currencyCode && vm.material.baseRate.currencyCode === vm.material.currentRate.rooferCost.currencyCode ) {
        //   $scope.boxes = [{
        //     img: "/assets/icons/scale-white.svg",
        //     title: "Unit",
        //     unit: vm.material.unit
        //   },
        //   {
        //     img: "/assets/icons/dollar-white.svg",
        //     title: "Item Cost",
        //     value: vm.material.currentRate.materialCost.value,
        //     currencyCode: vm.material.currentRate.materialCost.currencyCode
        //   },
        //   {
        //     img: "/assets/icons/dollar-white.svg",
        //     title: "Worker Cost",
        //     value: vm.material.currentRate.rooferCost.value,
        //     currencyCode: vm.material.currentRate.rooferCost.currencyCode
        //   },
        //   {
        //     img: "/assets/icons/dollar-white.svg",
        //     title: "Delivery Cost",
        //     value: vm.material.currentRate.materialCost.value,
        //     currencyCode: vm.material.currentRate.materialCost.currencyCode
        //   }];
        // } else {
        //   $scope.boxes = [{
        //     img: "/assets/icons/scale-white.svg",
        //     title: "Unit",
        //     unit: vm.material.unit
        //   },
        //   {
        //     img: "/assets/icons/dollar-white.svg",
        //     title: "Material Cost",
        //     value: vm.material.currentRate.materialCost.value,
        //     baseValue: vm.material.baseRate.materialCost,
        //     currencyCode: vm.material.currentRate.materialCost.currencyCode,
        //     baseCurrencyCode: vm.material.baseRate.currencyCode
        //   },
        //   {
        //     img: "/assets/icons/dollar-white.svg",
        //     title: "Worker Cost",
        //     value: vm.material.currentRate.rooferCost.value,
        //     baseValue: vm.material.baseRate.rooferCost,
        //     currencyCode: vm.material.currentRate.rooferCost.currencyCode,
        //     baseCurrencyCode: vm.material.baseRate.currencyCode
        //   },
        //   {
        //     img: "/assets/icons/dollar-white.svg",
        //     title: "Delivery Cost",
        //     value: vm.material.currentRate.materialCost.value,
        //     baseValue: vm.material.baseRate.materialCost,
        //     currencyCode: vm.material.currentRate.materialCost.currencyCode,
        //     baseCurrencyCode: vm.material.baseRate.currencyCode
        //   }];
        // }

        vm.designImage = vm.material.files.images.find(function (x) {
          return x.assetDescription === "designImage";
        });
        $timeout(imgSlider, 1500);
        nextMaintenanceDateCalc(vm.material.createdAt, vm.material.maintenancePeriod);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
      });
    }

    getMatDetail();

    function nextMaintenanceDateCalc(createdAt, maintenancePeriod) {
      var createdDate = Number.parseInt(moment(createdAt).format("X"));
      var nextMaintenanceDate = Number.parseInt(moment(createdAt).add(maintenancePeriod, "days").format("X"));

      if (createdDate < nextMaintenanceDate) {
        vm.nextMaintenanceDate = moment(createdAt).add(maintenancePeriod, "days").format("MMM DD, YYYY");
      } else {
        var createdDate1 = moment.utc(createdAt).add(maintenancePeriod, "days").format();
        nextMaintenanceDateCalc(createdDate1, maintenancePeriod);
      }
    }

    $scope.deleteMaterial = function () {
      $scope.isLoading = true;
      apiFactory.deleteMaterialById(vm.materialId).then(function () {
        $scope.isLoading = false;
        $state.go('materialList');
        Notification.success('Material deleted successfully');
      }, function () {
        Notification.error('Something went wrong try later');
      })["catch"](function () {});
    };

    function imgSlider() {
      angular.element(".slider").flexslider({
        animation: "slide",
        start: function start() {
          angular.element('body').removeClass('loading');
        }
      });
    }

    $scope.showImage = function (imageUrl) {
      $uibModal.open({
        animation: true,
        component: 'imageViewerModal',
        windowClass: 'image-viewer-modal',
        resolve: {
          imageURL: function imageURL() {
            return imageUrl;
          }
        }
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('editMaterial', {
    controller: editMaterialController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/editMaterial/editMaterial.view.html'
  });
  /** @ngInject */

  function editMaterialController($scope, apiFactory, globals, $timeout, moment, Notification, $state, $stateParams, utils, $log, unitFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    init();

    function init() {
      vm.utils = utils;
      vm.userData = userStore.get();

      $scope.goDashboard = function () {
        $state.go(globals.getDashboardRoute(vm.userData));
      };

      vm.materialId = $stateParams.id;

      if (angular.isUndefined(vm.materialId)) {
        $state.go('materialList');
        return;
      }

      $scope.material = {
        materialCost: {},
        rooferCost: {},
        orderingUnit: {
          orderingDenomination: {}
        },
        dimensions: {
          unit: {}
        },
        weatherConditions: [],
        files: []
      };
      $scope.color = 'ffffff';
      $scope.opacity = 100;
      $scope.oldMaterialId = undefined;
      vm.materialGroups = [];
      vm.removedFiles = [];
      vm.inputImages = [];
      vm.inputFiles = [];
      vm.inputImagesForAR = [];
      vm.uploadImages = [];
      vm.uploadFiles = [];
      vm.uploadImagesForAR = [];
      $scope.isCertifiedMaintenanceList = [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }];
      $scope.weatherCondition = {
        option: {}
      };
      $scope.weatherRemarks = [{
        label: 'Work',
        value: true
      }, {
        label: 'No Work',
        value: false
      }];
      /* get all material List */

      vm.mUnits = unitFactory.materialUnits();
      globals.getCurrency().then(function (res) {
        vm.currencies = res.data;
      });
      $scope.isLoading = true;
      Promise.all([apiFactory.getAllMaterialGroup(), apiFactory.getAllSuppliers(), apiFactory.getAllWeatherTypes(), apiFactory.listAllMaterials(), apiFactory.getCompanyById(vm.userData.companyId)]).then(function (res) {
        vm.materialGroups = res[0].data.data;
        vm.suppliers = res[1].data.list;
        vm.weatherTypes = res[2].data.list;
        vm.materials = res[3].data.list;
        vm.materials.unshift({
          _id: undefined,
          name: ''
        });
        vm.companyData = res[4].data;
        companyStore.set(vm.companyData);
        $scope.material.currency = angular.copy(vm.companyData.currentCurrency.currencyCode);
        $scope.changeMaterialCurrency();
        apiFactory.getMaterialById(vm.materialId).then(function (resp) {
          $scope.isLoading = false;
          $scope.material = resp.data;
          $scope.material.materialCost = $scope.material.currentRate.materialCost;
          $scope.material.rooferCost = $scope.material.currentRate.rooferCost;
          $scope.material.currency = $scope.material.materialCost.currencyCode;
          $scope.material.materialCost.value = utils.convertNum($scope.material.materialCost.value);
          $scope.material.rooferCost.value = utils.convertNum($scope.material.rooferCost.value);
          vm.uploadImages = [];

          if (!utils.isEmpty($scope.material.files) && !utils.isEmpty($scope.material.files.images)) {
            vm.uploadImages = $scope.material.files.images.filter(function (x) {
              return x.assetDescription !== 'arImage';
            });
            vm.uploadFiles = $scope.material.files.docs || [];
            vm.uploadImagesForAR = $scope.material.files.images.filter(function (x) {
              return x.assetDescription === 'arImage';
            });
          }
        })["catch"](function (error) {
          $scope.isLoading = false;
          $log.error(error);
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error("Couldn't load data.");
      });
    }

    $scope.changeMaterialCurrency = function () {
      if (utils.isEmpty($scope.material)) {
        return;
      }

      $scope.material.materialCost.currencyCode = $scope.material.currency;
      $scope.material.rooferCost.currencyCode = $scope.material.currency;
    };

    $scope.changeMaintenancePeriod = function () {
      if ($scope.material.maintenancePeriod > 1000) {
        Notification.error('please enter less than 1000 days');
      }
    };

    $scope.addWeatherCondition = function () {
      if (utils.isEmpty($scope.weatherCondition.condition)) {
        Notification.error('Please select weather condition');
        return;
      }

      if (utils.isEmpty($scope.weatherCondition.option)) {
        Notification.error('Please select weather remarks');
        return;
      }

      if (utils.isEmpty($scope.weatherCondition.limited)) {
        Notification.error('Please input weather limited value');
        return;
      }

      $scope.material.weatherConditions.push($scope.weatherCondition);
      $scope.weatherCondition = {
        option: {}
      };
    };

    $scope.removeWeatherCondition = function (index) {
      $scope.material.weatherConditions.splice(index, 1);
    };

    $scope.changedWeatherCondition = function () {
      $scope.weatherCondition.option.isWork = undefined;
      $scope.weatherCondition.limited = undefined;
    };

    $scope.getWeatherConditionInfo = function (weatherCondition) {
      if (angular.isUndefined(weatherCondition) || utils.isEmpty(vm.weatherTypes)) {
        return '';
      }

      var weatherConditionId = angular.isString(weatherCondition.condition) ? weatherCondition.condition : angular.isObject(weatherCondition.condition) ? weatherCondition.condition._id : undefined;
      var type = vm.weatherTypes.find(function (x) {
        return x._id == weatherConditionId;
      });
      var remark = weatherCondition.option ? weatherCondition.option.isWork ? 'Work' : 'No Work' : undefined;
      var tagName = utils.isEmpty(type) ? '' : type.tagName;
      var ret = '';

      if (tagName) {
        ret = ret + ' ' + tagName;
      }

      if (remark) {
        ret = ret + ' ' + remark;
      }

      if (weatherCondition.limited) {
        ret = ret + ' ' + weatherCondition.limited;
      }

      return ret;
    };

    $scope.fileUpdated = function (files, type) {
      angular.forEach(files, function (x) {
        x.objectUrl = URL.createObjectURL(x);
        x.description = "";

        if (type === "image") {
          if (vm.uploadImages.length === 0) {
            vm.uploadImages.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImages, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImages.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (type === "image_for_ar") {
          if (vm.uploadImagesForAR.length === 0) {
            x.description = "arImage";
            vm.uploadImagesForAR.push(x);
          } else {
            var _duplicateImg = false;
            angular.forEach(vm.uploadImagesForAR, function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              x.description = "arImage";
              vm.uploadImagesForAR.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImages.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg2 = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImages), function (y) {
              if (x.name === y.name) {
                _duplicateImg2 = true;
              }
            });

            if (!_duplicateImg2) {
              if (/image/.test(x.type)) {
                vm.uploadImages.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.deleteFile = function (indexVal, type) {
      if (type === "image") {
        if (vm.uploadImages[indexVal]._id) {
          vm.removedFiles.push(vm.uploadImages[indexVal]._id);
        } else {
          var findIndex = vm.inputImages.findIndex(function (elem) {
            return elem['$$hashkey'] === vm.uploadImages[indexVal]['$$hashkey'];
          });

          if (~findIndex) {
            vm.inputImages.splice(findIndex, 1);
          }
        }

        vm.uploadImages.splice(indexVal, 1);
      } else if (type === 'image_for_ar') {
        if (vm.uploadImagesForAR[indexVal]._id) {
          vm.removedFiles.push(vm.uploadImagesForAR[indexVal]._id);
        } else {
          var _findIndex = vm.inputImagesForAR.findIndex(function (elem) {
            return elem['$$hashkey'] === vm.uploadImages[indexVal]['$$hashkey'];
          });

          if (~_findIndex) {
            vm.inputImagesForAR.splice(_findIndex, 1);
          }
        }

        vm.uploadImagesForAR.splice(indexVal, 1);
      } else {
        vm.removedFiles.push($scope.material.files.docs[indexVal]._id);
        vm.uploadFiles.splice(indexVal, 1);
      }
    };

    vm.updateMaterial = function () {
      var material = $scope.material;

      if (utils.isEmpty(material.name)) {
        Notification.error('Please input material name');
        return;
      }

      if (utils.isEmpty(material.unit)) {
        Notification.error('Please select material unit');
        return;
      }

      if (utils.isEmpty(material.materialCost.value)) {
        Notification.error('Please input Material Cost');
        return;
      }

      material.materialCost.value = utils.convertNumFromEuropean(material.materialCost.value);

      if (utils.isEmpty(material.rooferCost.value)) {
        Notification.error('Please input Worker Cost');
        return;
      }

      material.rooferCost.value = utils.convertNumFromEuropean(material.rooferCost.value);

      if (utils.isEmpty(material.supplier)) {
        Notification.error('Please select supplier');
        return;
      }

      material.files = [].concat(vm.inputImages, vm.inputFiles, vm.inputImagesForAR);
      material.assetObj = material.files.map(function (x) {
        return {
          assetDescription: x.description
        };
      });
      var description = [];

      if (material.files.length > 0) {
        material.files.map(function (x) {
          description.push({
            assetDescription: x.description
          });
        });
      }

      material.assetObj = description;
      material.removedFiles = vm.removedFiles;
      $scope.isLoading = true;
      apiFactory.updateMaterialById(material._id, material).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        $state.go('materialDetail', {
          id: vm.materialId
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('editItem', {
    controller: editItemController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/editItem/editItem.view.html'
  });
  /** @ngInject */

  function editItemController($scope, apiFactory, globals, $timeout, moment, Notification, $state, $stateParams, utils, $log, unitFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore; // gantt chart

    $scope.ganttData = {
      data: [],
      links: []
    };
    $scope.gantttimelength = 1000 * 24 * 3600;

    function ganttinit() {
      var items = [];
      var today = new Date();
      var yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      var lastdate = new Date();
      lastdate.setDate(today.getDate() + 9);
      var item = {
        id: 1,
        text: "",
        start_date: new Date(today),
        end_date: new Date(lastdate),
        type: gantt.config.types.project,
        progress: 1,
        showprogress: (lastdate - today) / lastdate,
        project: true,
        calcHours: 0,
        resources: [],
        resourceIds: [],
        duration: 10
      };
      items.push(item);
      gantt.config.auto_scheduling = true;
      gantt.config.min_column_width = 40;
      gantt.config.start_date = today;
      gantt.config.end_date = lastdate;
      gantt.config.layout = {
        css: "gantt_container",
        rows: [{
          config: {
            scale_height: 2,
            row_height: 40,
            task_height: 21
          },
          cols: [{
            view: "timeline",
            scrollX: "scrollHor",
            scrollY: "scrollVer"
          }, {
            view: "scrollbar",
            id: "scrollVer",
            group: "vertical"
          }],
          gravity: 2
        }]
      };
      gantt.init("dhx-gantt");
      $scope.ganttData = {
        data: items,
        links: []
      };
      gantt.render();

      gantt.templates.task_text = function (start, end, task) {
        return "<span class=\"task-text\">".concat(task.text, "</span><span class=\"progress-text\">").concat(Math.ceil(task.showprogress * 100), "%</span>");
      };

      gantt.attachEvent("onAfterTaskDrag", function (id, mode) {
        if (mode === "resize" || mode === "move") {
          var state = gantt.getState();
          var mindate = state.min_date,
              maxdate = state.max_date;
          var totaldate = maxdate - mindate;
          var task = gantt.getTask(id);
          task.showprogress = (task.end_date - task.start_date) / totaldate;
          gantt.updateTask(id);
        }
      });
      gantt.render();
    }

    function updategantttask(datas) {
      var today = new Date();
      var state = gantt.getState();
      var mindate = state.min_date,
          maxdate = state.max_date;
      var totaldate = maxdate - mindate;

      for (var i = 0; i < datas.length; i++) {
        var lastdate = new Date();
        lastdate.setDate(today.getDate() + datas[i].endDate);
        lastdate.setHours(0);
        var startdate = new Date();
        startdate.setDate(today.getDate() + datas[i].startDate);
        startdate.setHours(0);
        var item = {
          id: datas[i].id,
          text: datas[i].text,
          start_date: new Date(startdate),
          end_date: new Date(lastdate),
          type: gantt.config.types.task,
          progress: 1,
          showprogress: (lastdate - startdate) / totaldate,
          project: true,
          calcHours: 0,
          resources: [],
          resourceIds: [],
          duration: 10
        };
        $scope.ganttData.data.push(item);
        gantt.addTask(item);
      }
    }

    function addganttitem(typename, task_id) {
      var today = new Date();
      var lastdate = new Date();
      lastdate.setDate(today.getDate() + 1);
      lastdate.setHours(0);
      var startdate = new Date();
      startdate.setHours(0);
      var state = gantt.getState();
      var mindate = state.min_date,
          maxdate = state.max_date;
      var totaldate = maxdate - mindate;
      var item = {
        id: task_id,
        text: typename,
        start_date: new Date(startdate),
        end_date: new Date(lastdate),
        type: gantt.config.types.task,
        progress: 1,
        showprogress: (lastdate - startdate) / totaldate,
        project: true,
        calcHours: 0,
        resources: [],
        resourceIds: [],
        duration: 10
      };
      $scope.ganttData.data.push(item);
      gantt.addTask(item);
    }

    function deleteganttitem(index) {
      var item = $scope.ganttData.data[index + 1];
      $scope.ganttData.data.splice(index + 1, 1);
      gantt.deleteTask(item.id);
    }

    init();

    function init() {
      vm.utils = utils;
      vm.userData = userStore.get();

      $scope.goDashboard = function () {
        $state.go(globals.getDashboardRoute(vm.userData));
      };

      vm.materialId = $stateParams.id;

      if (angular.isUndefined(vm.materialId)) {
        $state.go('materialList');
        return;
      }

      $scope.material = {
        cost: {},
        weatherConditions: [],
        files: [],
        typeOfSub: []
      };
      $scope.color = 'ffffff';
      $scope.opacity = 100;
      $scope.oldMaterialId = undefined;
      vm.materialGroups = [];
      vm.removedFiles = [];
      vm.inputImages = [];
      vm.inputFiles = [];
      vm.inputImagesForAR = [];
      vm.uploadImages = [];
      vm.uploadFiles = [];
      vm.uploadImagesForAR = [];
      $scope.isCertifiedMaintenanceList = [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }];
      $scope.weatherCondition = {
        option: {}
      };
      $scope.weatherRemarks = [{
        label: 'Work',
        value: true
      }, {
        label: 'No Work',
        value: false
      }];
      /* get all material List */

      vm.mUnits = unitFactory.materialUnits();
      globals.getCurrency().then(function (res) {
        vm.currencies = res.data;
      });
      $scope.isLoading = true;
      Promise.all([apiFactory.getAllMaterialGroup(), apiFactory.getAllSuppliers(), apiFactory.getAllWeatherTypes(), apiFactory.getWorkTypes(), apiFactory.getCompanyById(vm.userData.companyId)]).then(function (res) {
        vm.materialGroups = res[0].data.data;
        vm.suppliers = res[1].data.list;
        vm.weatherTypes = res[2].data.list;
        vm.workTypes = res[3].data.list; // vm.materials = res[3].data.list;
        // vm.materials.unshift({_id: undefined, name: ''});

        vm.companyData = res[4].data;
        companyStore.set(vm.companyData); // $scope.material.currency = angular.copy(vm.companyData.currentCurrency.currencyCode);
        // $scope.changeMaterialCurrency();

        apiFactory.getItemById(vm.materialId).then(function (resp) {
          $scope.isLoading = false;
          $scope.material = resp.data; // $scope.material.currency = $scope.material.materialCost.currencyCode;

          vm.uploadImages = [];

          if (!utils.isEmpty($scope.material.files) && !utils.isEmpty($scope.material.files.images)) {
            vm.uploadImages = $scope.material.files.images.filter(function (x) {
              return x.assetDescription !== 'arImage';
            });
            vm.uploadFiles = $scope.material.files.docs || [];
            vm.uploadImagesForAR = $scope.material.files.images.filter(function (x) {
              return x.assetDescription === 'arImage';
            });
          }

          ganttinit();

          if ($scope.material.partItems) {
            $log.log($scope.material.partItems);
            updategantttask($scope.material.partItems);
          }
        })["catch"](function (error) {
          $scope.isLoading = false;
          $log.error(error);
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error("Couldn't load data.");
      });
    }

    $scope.addWorkType = function () {
      var workType = vm.workTypes.find(function (x) {
        return x._id === $scope.workType;
      });

      if (workType && !$scope.material.typeOfSub.find(function (x) {
        return x._id === workType._id;
      })) {
        $scope.material.typeOfSub.push(workType);
        addganttitem(workType.tagName, workType._id);
      }

      $scope.workType = undefined;
      $timeout(function () {
        $scope.$apply();
      });
    };

    $scope.removeWorkType = function (index) {
      $scope.material.typeOfSub.splice(index, 1);
      deleteganttitem(index);
    }; // $scope.changeMaterialCurrency = () => {
    //   if (utils.isEmpty($scope.material)) {
    //     return;
    //   }
    //   $scope.material.materialCost.currencyCode = $scope.material.currency;
    //   $scope.material.rooferCost.currencyCode = $scope.material.currency;
    // }


    $scope.changeMaintenancePeriod = function () {
      if ($scope.material.maintenancePeriod > 1000) {
        Notification.error('please enter less than 1000 days');
      }
    };

    $scope.addWeatherCondition = function () {
      if (utils.isEmpty($scope.weatherCondition.condition)) {
        Notification.error('Please select weather condition');
        return;
      }

      if (utils.isEmpty($scope.weatherCondition.option)) {
        Notification.error('Please select weather remarks');
        return;
      }

      if (utils.isEmpty($scope.weatherCondition.limited)) {
        Notification.error('Please input weather limited value');
        return;
      }

      $scope.material.weatherConditions.push($scope.weatherCondition);
      $scope.weatherCondition = {
        option: {}
      };
    };

    $scope.removeWeatherCondition = function (index) {
      $scope.material.weatherConditions.splice(index, 1);
    };

    $scope.changedWeatherCondition = function () {
      $scope.weatherCondition.option.isWork = undefined;
      $scope.weatherCondition.limited = undefined;
    };

    $scope.getWeatherConditionInfo = function (weatherCondition) {
      if (angular.isUndefined(weatherCondition) || utils.isEmpty(vm.weatherTypes)) {
        return '';
      }

      var weatherConditionId = angular.isString(weatherCondition.condition) ? weatherCondition.condition : angular.isObject(weatherCondition.condition) ? weatherCondition.condition._id : undefined;
      var type = vm.weatherTypes.find(function (x) {
        return x._id == weatherConditionId;
      });
      var remark = weatherCondition.option ? weatherCondition.option.isWork ? 'Work' : 'No Work' : undefined;
      var tagName = utils.isEmpty(type) ? '' : type.tagName;
      var ret = '';

      if (tagName) {
        ret = ret + ' ' + tagName;
      }

      if (remark) {
        ret = ret + ' ' + remark;
      }

      if (weatherCondition.limited) {
        ret = ret + ' ' + weatherCondition.limited;
      }

      return ret;
    };

    $scope.fileUpdated = function (files, type) {
      angular.forEach(files, function (x) {
        x.objectUrl = URL.createObjectURL(x);
        x.description = "";

        if (type === "image") {
          if (vm.uploadImages.length === 0) {
            vm.uploadImages.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImages, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImages.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (type === "image_for_ar") {
          if (vm.uploadImagesForAR.length === 0) {
            x.description = "arImage";
            vm.uploadImagesForAR.push(x);
          } else {
            var _duplicateImg = false;
            angular.forEach(vm.uploadImagesForAR, function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              x.description = "arImage";
              vm.uploadImagesForAR.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImages.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg2 = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImages), function (y) {
              if (x.name === y.name) {
                _duplicateImg2 = true;
              }
            });

            if (!_duplicateImg2) {
              if (/image/.test(x.type)) {
                vm.uploadImages.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.deleteFile = function (indexVal, type) {
      if (type === "image") {
        if (vm.uploadImages[indexVal]._id) {
          vm.removedFiles.push(vm.uploadImages[indexVal]._id);
        } else {
          var findIndex = vm.inputImages.findIndex(function (elem) {
            return elem['$$hashkey'] === vm.uploadImages[indexVal]['$$hashkey'];
          });

          if (~findIndex) {
            vm.inputImages.splice(findIndex, 1);
          }
        }

        vm.uploadImages.splice(indexVal, 1);
      } else if (type === 'image_for_ar') {
        if (vm.uploadImagesForAR[indexVal]._id) {
          vm.removedFiles.push(vm.uploadImagesForAR[indexVal]._id);
        } else {
          var _findIndex = vm.inputImagesForAR.findIndex(function (elem) {
            return elem['$$hashkey'] === vm.uploadImages[indexVal]['$$hashkey'];
          });

          if (~_findIndex) {
            vm.inputImagesForAR.splice(_findIndex, 1);
          }
        }

        vm.uploadImagesForAR.splice(indexVal, 1);
      } else {
        vm.removedFiles.push($scope.material.files.docs[indexVal]._id);
        vm.uploadFiles.splice(indexVal, 1);
      }
    };

    vm.updateMaterial = function () {
      var material = $scope.material;

      if (utils.isEmpty(material.name)) {
        Notification.error('Please input material name');
        return;
      }

      if (utils.isEmpty(material.unit)) {
        Notification.error('Please select material unit');
        return;
      }

      if (utils.isEmpty(material.cost[0].itemsCost)) {
        Notification.error('Please input Item Cost');
        return;
      }

      if (utils.isEmpty(material.cost[0].productionTime)) {
        Notification.error('Please input Production Time');
        return;
      }

      material.files = [].concat(vm.inputImages, vm.inputFiles, vm.inputImagesForAR);
      material.assetObj = material.files.map(function (x) {
        return {
          assetDescription: x.description
        };
      });
      var description = [];

      if (material.files.length > 0) {
        material.files.map(function (x) {
          description.push({
            assetDescription: x.description
          });
        });
      }

      material.assetObj = description;
      material.removedFiles = vm.removedFiles; // $scope.ganttData.data.splice(0, 1);

      material.partItems = [];
      var today = new Date();
      today.setHours(0);

      for (var i = 1; i < $scope.ganttData.data.length; i++) {
        var item = {
          startDate: Math.round(($scope.ganttData.data[i].start_date - today) / $scope.gantttimelength),
          endDate: Math.round(($scope.ganttData.data[i].end_date - today) / $scope.gantttimelength),
          id: $scope.ganttData.data[i].id,
          text: $scope.ganttData.data[i].text
        };
        material.partItems.push(item);
      }

      $scope.isLoading = true;
      apiFactory.updateItemById(material._id, material).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        $state.go('itemDetail', {
          id: vm.materialId
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('editDcp', {
    controller: EditDcpController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/editDcp/editDcp.view.html'
  });
  /** @ngInject */

  function EditDcpController($stateParams, apiFactory, globals, $scope, Notification, $state, utils, $log, unitFactory) {
    var vm = this;
    vm.utils = utils;
    vm.userData = globals.userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.companyData = globals.companyStore.get();
    vm.comboId = $stateParams.id;
    $scope.isLoading = false;
    vm.typeAddings = [{
      _id: "Both",
      name: "Both"
    }, {
      _id: "Labor",
      name: "Labour"
    }, {
      _id: "Material",
      name: "Material"
    }];
    vm.mUnits = unitFactory.materialUnits();
    vm.comboMaterialList = [];
    $scope.comboMaterialList = [];
    $scope.comboMat = {
      quantity: 1,
      typeAdding: 'Both',
      percentage: 0,
      matCostRate: 0,
      workerCostRate: 0,
      matCost: 0,
      workerCost: 0
    };

    $scope.fileUpdated = function (files, type) {
      angular.forEach(files, function (x) {
        x.objectUrl = URL.createObjectURL(x);
        x.description = "";

        if (type === "image") {
          if (vm.uploadImages.length === 0) {
            vm.uploadImages.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImages, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImages.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (type === "image_for_ar") {
          if (vm.uploadImagesForAR.length === 0) {
            x.description = "arImage";
            vm.uploadImagesForAR.push(x);
          } else {
            var _duplicateImg = false;
            angular.forEach(vm.uploadImagesForAR, function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              x.description = "arImage";
              vm.uploadImagesForAR.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImages.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg2 = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImages), function (y) {
              if (x.name === y.name) {
                _duplicateImg2 = true;
              }
            });

            if (!_duplicateImg2) {
              if (/image/.test(x.type)) {
                vm.uploadImages.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.removedFiles = [];

    vm.deleteFile = function (indexVal, type) {
      if (type === "image") {
        vm.removedFiles.push(vm.comboData.files.images[indexVal]._id);
        vm.uploadImages.splice(indexVal, 1);
      } else {
        vm.removedFiles.push(vm.comboData.files.docs[indexVal]._id);
        vm.uploadFiles.splice(indexVal, 1);
      }
    };

    function getValidTypeAdding(typeAdding) {
      if (typeAdding !== 'Both' && typeAdding !== 'Labor' && typeAdding !== 'Material') {
        return 'Both';
      } else {
        return typeAdding;
      }
    }

    function getComboMatDetail() {
      $scope.isLoading = true;
      apiFactory.getComboMaterialById(vm.comboId).then(function (resp) {
        $scope.isLoading = false;
        vm.comboData = resp.data.data;
        vm.uploadImages = resp.data.data.files.images;
        vm.uploadFiles = resp.data.data.files.docs;
        vm.comboMaterialList = vm.comboData.comboMaterialList;
        $scope.comboMaterialList = vm.comboMaterialList.map(function (item) {
          return {
            _id: item._id,
            matId: item.materialId._id,
            name: item.materialId.name,
            date: item.materialId.createdAt,
            quantity: item.quantity,
            unit: item.materialId.unit,
            typeAdding: getValidTypeAdding(item.percentageAdditions[0].percentageType),
            percentage: item.percentageAdditions[0].value,
            matCostRate: item.materialId.baseRate.materialCost,
            workerCostRate: item.materialId.baseRate.rooferCost
          };
        });
        $scope.comboMaterialList.forEach(function (material) {
          $scope.calcComboMatCost(material);
        });
        $log.log('vm.comboMaterialList = ', vm.comboMaterialList);
        $log.log('comboMaterialList = ', $scope.comboMaterialList);
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }

    function loadAllMaterials() {
      $scope.isLoading = true;
      apiFactory.listAllMaterials().then(function (resp) {
        $scope.isLoading = false;
        vm.matList = resp.data.list;
        vm.backupMatList = angular.copy(vm.matList);
        getComboMatDetail();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
      });
    }

    loadAllMaterials();

    $scope.addMaterial = function () {
      var comboMat = $scope.comboMat;

      if (angular.isUndefined(comboMat.matId)) {
        Notification.error('Please select a material');
        return false;
      }

      if (angular.isUndefined(comboMat.quantity)) {
        Notification.error('Please input quantity value');
        return false;
      }

      if (angular.isUndefined(comboMat.percentage) || comboMat.percentage < 0 || comboMat.percentage > 100) {
        Notification.error('Invalid percentage. Please input a value between 0 and 100');
        return false;
      }

      var index = vm.matList.findIndex(function (x) {
        return x._id == $scope.comboMat.matId;
      });

      if (index !== -1) {
        $scope.comboMaterialList.push($scope.comboMat);
        $scope.comboMat = {
          quantity: 1,
          typeAdding: 'Both',
          percentage: 0,
          matCostRate: 0,
          workerCostRate: 0,
          matCost: 0,
          workerCost: 0
        };
        vm.matList.splice(index, 1);
      }
    };

    $scope.removeMaterial = function (index, matId) {
      $scope.comboMaterialList.splice(index, 1);
      var mat = vm.backupMatList.find(function (x) {
        return x._id == matId;
      });

      if (mat) {
        vm.matList.push(mat);
      }
    };

    $scope.getMatCost = function (comboMat) {
      switch (comboMat.typeAdding) {
        case 'Both':
        case 'Material':
          comboMat.matCost = comboMat.quantity * (comboMat.matCostRate + comboMat.percentage / 100 * comboMat.matCostRate);
          break;

        default:
          comboMat.matCost = comboMat.quantity * comboMat.matCostRate;
      }
    };

    $scope.getWorkerCost = function (comboMat) {
      switch (comboMat.typeAdding) {
        case 'Both':
        case 'Labor':
          comboMat.workerCost = comboMat.quantity * (comboMat.workerCostRate + comboMat.percentage / 100 * comboMat.workerCostRate);
          break;

        default:
          comboMat.workerCost = comboMat.quantity * comboMat.workerCostRate;
      }
    };

    $scope.getTotalCost = function (which) {
      if (utils.isEmpty($scope.comboMaterialList)) {
        return 0;
      }

      return $scope.comboMaterialList.map(function (x) {
        return x[which];
      }).reduce(utils.sumReducer, 0);
    };

    $scope.calcComboMatCost = function (comboMat) {
      switch (comboMat.typeAdding) {
        case 'Both':
        case 'Material':
          comboMat.matCost = utils.roundNumber(comboMat.quantity * (comboMat.matCostRate + comboMat.percentage / 100 * comboMat.matCostRate));
          comboMat.workerCost = utils.roundNumber(comboMat.quantity * (comboMat.workerCostRate + comboMat.percentage / 100 * comboMat.workerCostRate));
          break;

        case 'Labor':
          comboMat.matCost = utils.roundNumber(comboMat.quantity * comboMat.matCostRate);
          comboMat.workerCost = utils.roundNumber(comboMat.quantity * comboMat.workerCostRate);
          break;
      }
    };

    $scope.onChangeMat = function (comboMat) {
      var mat = vm.matList.find(function (x) {
        return x._id == comboMat.matId;
      });

      if (angular.isDefined(mat)) {
        comboMat.name = mat.name;
        comboMat.date = mat.createdAt;
        comboMat.matCostRate = mat.baseRate.materialCost;
        comboMat.workerCostRate = mat.baseRate.rooferCost;
        $scope.calcComboMatCost(comboMat);
      }
    };

    function checkValidation() {
      if (utils.isEmpty(vm.comboData.name)) {
        Notification.error('Please input DCP Name');
        return false;
      }

      if (utils.isEmpty(vm.comboData.unit)) {
        Notification.error('Please select Unit');
        return false;
      }

      if ($scope.comboMaterialList.length < 2) {
        Notification.error("Combination list should be more 2 items at least.");
        return false;
      }

      return true;
    }

    vm.updateCombo = function () {
      if (!checkValidation()) {
        return;
      }

      $scope.imgAndFiles = [].concat(vm.uploadImages, vm.uploadFiles);
      $scope.uploadallFiles = [].concat(vm.uploadImages, vm.uploadFiles);
      var description = [];

      if (vm.uploadImages.length > 0 || vm.uploadFiles.length > 0) {
        $scope.imgAndFiles.map(function (x) {
          description.push({
            assetDescription: x.description
          });
        });
      }

      var data = {
        name: vm.comboData.name,
        unit: vm.comboData.unit,
        color: vm.comboData.color,
        opacity: vm.comboData.opacity,
        description: vm.comboData.description,
        files: $scope.imgAndFiles,
        assetObj: description,
        removedFiles: vm.removedFiles
      };
      var comboListArray = $scope.comboMaterialList.map(function (x) {
        return {
          _id: x._id,
          materialId: x.matId,
          type: 1,
          quantity: x.quantity,
          percentageAdditions: [{
            value: x.percentage,
            percentageType: x.typeAdding
          }]
        };
      });
      var deletedComboList = [];
      var changedComboList = comboListArray.filter(function (x) {
        return angular.isDefined(x._id);
      });
      vm.comboMaterialList.forEach(function (x) {
        var index = changedComboList.findIndex(function (y) {
          return y._id === x._id;
        });

        if (index === -1) {
          deletedComboList.push(x._id);
        }
      });
      var comboListData = {
        comboListArray: comboListArray,
        deletedComboList: deletedComboList
      };
      $scope.isLoading = true;
      Promise.all([apiFactory.updateComboMaterialList(vm.comboData._id, comboListData), apiFactory.updateComboMaterial(vm.comboData._id, data)]).then(function (resp) {
        $scope.isLoading = false;
        Notification.success(resp[0].data.message);
        Notification.success(resp[1].data.message);
        angular.element("#edit_dcp_modal.dcp_modal").modal("hide");
        getComboMatDetail();
        vm.fileNames = [];
        $state.go("dcpDetail", {
          id: vm.comboData._id
        });
      })["catch"](function (e) {
        $scope.isLoading = false;

        if (e.data && e.data.message) {
          Notification.error(e.data.message);
        } else {
          Notification.error("Failed to update");
        }
      });
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('dcpList', {
    controller: dcpListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/dcpList/dcpList.view.html'
  });
  /** @ngInject */

  function dcpListController($scope, apiFactory, FileSaver, Notification, globals, $log, $state) {
    var vm = this;
    var userStore = globals.userStore;
    $scope.MAT_ACCESS_CREATE = 100;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    }; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.MAT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.MAT]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.MAT_ACCESS_CREATE = res.data.data[Constants.AccessKey.MAT];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }


    $scope.periods = [{
      id: '8',
      name: '8'
    }, {
      id: '16',
      name: '16'
    }, {
      id: '32',
      name: '32'
    }];
    $scope.labelChecked = false;
    $scope.combos = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 8;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.isLoading = false;
    $scope.isGrid = true;
    vm.searchText = undefined;
    vm.sortMenuComboMaterialList = [{
      label: 'Name',
      key: 'name'
    }, {
      label: 'Created Date',
      key: 'createdAt'
    }, {
      label: 'Modified Date',
      key: 'updatedAt'
    }, {
      label: 'Material Tag',
      key: 'systemTag'
    }];
    vm.sortMenuCombo = "createdAt";
    vm.currencies = [];
    globals.getCurrency().then(function (res) {
      vm.currencies = res.data;
    });

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.sortComboMaterials();
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.sortComboMaterials();
    };

    vm.sortComboMaterials = function () {
      $scope.isLoading = true;
      apiFactory.listAllComboMaterials({
        sort: vm.sortMenuCombo,
        search: vm.searchText,
        sortType: "false",
        page: vm.currentPage,
        chunk: $scope.numPerPage
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.combos = resp.data.list;
        $log.log($scope.combos);
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    vm.sortComboMaterials();

    $scope.upLoadCmbExcelFile = function (filetosave) {
      var filedata = {
        file: filetosave
      };
      apiFactory.uploadComboMatExcel(filedata).then(function () {
        angular.element("#uploadcmbModal").modal("hide");
        Notification.success("New material saved.");
      })["catch"](function (err) {
        $log.error(err);
      });
    };

    $scope.downLoadDCPExcel = function () {
      $scope.isLoading = true;
      apiFactory.downLoadDcpExcel().then(function (resp) {
        $scope.isLoading = false;
        var blob = new Blob([resp.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        FileSaver.saveAs(blob, "dcp.xlsx");
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    $scope.switchViewMode = function (isGrid) {
      $scope.isGrid = isGrid;
    };

    $scope.getCurrencySymbol = function (item) {
      var find = vm.currencies.find(function (x) {
        return x.cc === item.currencyCode;
      });

      if (find) {
        return find.symbol;
      } else {
        return 'Kr';
      }
    };

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      $scope.materials.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('dcpDetail', {
    controller: dcpDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/dcpDetail/dcpDetail.view.html'
  });
  /** @ngInject */

  function dcpDetailController(apiFactory, $scope, $timeout, moment, $stateParams, $state, Notification, utils, globals, $log, $uibModal) {
    var vm = this;
    vm.utils = utils;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.MAT_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.MAT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.MAT]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.MAT_ACCESS_CREATE = res.data.data[Constants.AccessKey.MAT];
    //   })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.comboId = $stateParams.id;
    $scope.isLoading = false;

    $scope.deleteDcp = function () {
      $scope.isLoading = true;
      apiFactory.deleteComboMaterialById(vm.comboId).then(function () {
        $scope.isLoading = false;
        Notification.success('Material deleted successfully');
        $state.go('dcpList');
      }, function () {
        $scope.isLoading = false;
        Notification.error('Something went wrong try later');
      })["catch"](function () {
        $scope.isLoading = false;
      });
    };

    function getMaintenaceDate(comboMaterialList) {
      var maxMaintenance = moment('1970-01-01');
      comboMaterialList.forEach(function (comboMat) {
        var date = moment(comboMat.materialId.createdAt).add(comboMat.materialId.maintenancePeriod, 'days');

        if (date > maxMaintenance) {
          maxMaintenance = date;
        }
      });
      return maxMaintenance;
    }

    function getComboMatDetail() {
      $scope.isLoading = true;
      apiFactory.getComboMaterialById(vm.comboId).then(function (resp) {
        $scope.isLoading = false;
        vm.comboData = resp.data.data;
        vm.comboData.maintenanceDate = getMaintenaceDate(vm.comboData.comboMaterialList);
        vm.uploadImages = vm.comboData.files.images;
        vm.uploadFiles = vm.comboData.files.docs;
        vm.description = vm.comboData.description;
        $scope.boxes = [{
          img: "/assets/icons/scale-white.svg",
          title: "Unit",
          unit: vm.comboData.unit
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Material Cost",
          value: vm.comboData.totalMaterialCost,
          currencyCode: vm.comboData.currencyCode
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Worker Cost",
          value: vm.comboData.totalRooferCost,
          currencyCode: vm.comboData.currencyCode
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Delivery Cost",
          value: vm.comboData.totalMaterialCost,
          currencyCode: vm.comboData.currencyCode
        }];
        $timeout(imgSlider, 1500);
      })["catch"](function () {
        $scope.isLoading = false;
      });
    }

    getComboMatDetail();

    function imgSlider() {
      angular.element(".slider").flexslider({
        animation: "slide",
        start: function start() {
          angular.element('body').removeClass('loading');
        }
      });
    }

    $scope.getMatCost = function (comboMat) {
      var type = utils.isEmpty(comboMat.percentageAdditions) ? 'Both' : comboMat.percentageAdditions[0].percentageType;
      var percentage = utils.isEmpty(comboMat.percentageAdditions[0]) ? 0 : comboMat.percentageAdditions[0].value;
      var matCostRate = utils.isEmpty(comboMat.materialId) || utils.isEmpty(comboMat.materialId.baseRate) || utils.isEmpty(comboMat.materialId.baseRate.materialCost) ? 0 : comboMat.materialId.baseRate.materialCost;

      switch (type) {
        case 'Both':
        case 'Material':
          return comboMat.quantity * (matCostRate + percentage / 100 * matCostRate);

        default:
          return comboMat.quantity * matCostRate;
      }
    };

    $scope.showImage = function (imageUrl) {
      $uibModal.open({
        animation: true,
        component: 'imageViewerModal',
        windowClass: 'image-viewer-modal',
        resolve: {
          imageURL: function imageURL() {
            return imageUrl;
          }
        }
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('addMaterial', {
    controller: addMaterialController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/addMaterial/addMaterial.view.html'
  });

  function addMaterialController($scope, apiFactory, globals, $timeout, moment, Notification, $state, utils, $log, unitFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    init();

    function initMaterial() {
      $scope.material = {
        materialCost: {},
        rooferCost: {},
        orderingUnit: {
          orderingDenomination: {}
        },
        dimensions: {
          unit: {}
        },
        weatherConditions: [],
        files: []
      };
    }

    function init() {
      vm.utils = utils;
      vm.userData = userStore.get();
      initMaterial();
      $scope.color = 'ffffff';
      $scope.opacity = 100;
      $scope.oldMaterialId = undefined;
      vm.materialGroups = [];
      vm.uploadImages = [];
      vm.uploadFiles = [];
      vm.uploadImagesForAR = [];
      $scope.isCertifiedMaintenanceList = [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }];
      $scope.weatherCondition = {
        option: {}
      };
      $scope.weatherRemarks = [{
        label: 'Work',
        value: true
      }, {
        label: 'No Work',
        value: false
      }];
      /* get all material List */

      vm.mUnits = unitFactory.materialUnits();
      globals.getCurrency().then(function (res) {
        vm.currencies = res.data;
      });
      $scope.isLoading = true;
      Promise.all([apiFactory.getAllMaterialGroup(), apiFactory.getAllSuppliers(), apiFactory.getAllWeatherTypes(), apiFactory.listAllMaterials(), apiFactory.getCompanyById(vm.userData.companyId)]).then(function (res) {
        $scope.isLoading = false;
        vm.materialGroups = res[0].data.data;
        vm.suppliers = res[1].data.list;
        vm.weatherTypes = res[2].data.list;
        vm.materials = res[3].data.list;
        vm.materials.unshift({
          _id: undefined,
          name: ''
        });
        vm.companyData = res[4].data;
        companyStore.set(vm.companyData);
        $scope.material.currency = angular.copy(vm.companyData.currentCurrency.currencyCode);
        $scope.changeMaterialCurrency();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error("Couldn't load data.");
      });
    }

    $scope.selectOldMaterial = function () {
      if (utils.isEmpty(vm.materials)) {
        return;
      }

      var selectedMaterial = vm.materials.find(function (x) {
        return x._id === $scope.oldMaterialId;
      });

      if (selectedMaterial._id) {
        $scope.material.unit = selectedMaterial.unit;
        $scope.material.materialCost = selectedMaterial.currentRate.materialCost;
        $scope.material.rooferCost = selectedMaterial.currentRate.rooferCost;

        if (selectedMaterial.orderingUnit && selectedMaterial.orderingUnit.orderingDenomination) {
          $scope.material.orderingQuantity = selectedMaterial.orderingUnit.orderingDenomination.quantity;
        }

        $scope.material.numPiecesInPackage = selectedMaterial.numPiecesInPackage;
        $scope.material.maintenancePeriod = selectedMaterial.maintenancePeriod;
        $scope.material.wastePercentage = selectedMaterial.wastePercentage;
        $scope.material.ccs = selectedMaterial.ccs;
        $scope.material.certifiedMaintenance = selectedMaterial.certifiedMaintenance;
        $scope.material.dimensions = selectedMaterial.dimensions;
        $scope.material.groupId = selectedMaterial.groupId;
      } else {
        initMaterial();
      }
    };

    $scope.changeMaterialCurrency = function () {
      $scope.material.materialCost.currencyCode = $scope.material.currency;
      $scope.material.rooferCost.currencyCode = $scope.material.currency;
    };

    $scope.changeMaintenancePeriod = function () {
      if ($scope.material.maintenancePeriod > 1000) {
        Notification.error('please enter less than 1000 days');
      }
    };

    $scope.addWeatherCondition = function () {
      if (utils.isEmpty($scope.weatherCondition.condition)) {
        Notification.error('Please select weather condition');
        return;
      }

      if (utils.isEmpty($scope.weatherCondition.option)) {
        Notification.error('Please select weather remarks');
        return;
      }

      if (utils.isEmpty($scope.weatherCondition.limited)) {
        Notification.error('Please input weather limited value');
        return;
      }

      $scope.material.weatherConditions.push($scope.weatherCondition);
      $scope.weatherCondition = {
        option: {}
      };
    };

    $scope.removeWeatherCondition = function (index) {
      $scope.material.weatherConditions.splice(index, 1);
    };

    $scope.changedWeatherCondition = function () {
      $scope.weatherCondition.option.isWork = undefined;
      $scope.weatherCondition.limited = undefined;
    };

    $scope.getWeatherConditionInfo = function (weatherCondition) {
      if (angular.isUndefined(weatherCondition) || utils.isEmpty(vm.weatherTypes)) {
        return '';
      }

      var weatherConditionId = angular.isString(weatherCondition.condition) ? weatherCondition.condition : angular.isObject(weatherCondition.condition) ? weatherCondition.condition._id : undefined;
      var type = vm.weatherTypes.find(function (x) {
        return x._id == weatherConditionId;
      });
      var remark = weatherCondition.option ? weatherCondition.option.isWork ? 'Work' : 'No Work' : undefined;
      var tagName = utils.isEmpty(type) ? '' : type.tagName;
      var ret = '';

      if (tagName) {
        ret = ret + ' ' + tagName;
      }

      if (remark) {
        ret = ret + ' ' + remark;
      }

      if (weatherCondition.limited) {
        ret = ret + ' ' + weatherCondition.limited;
      }

      return ret;
    };

    $scope.fileUpdated = function (files, type) {
      angular.forEach(files, function (x) {
        x.objectUrl = URL.createObjectURL(x);
        x.description = "";

        if (type === "image") {
          if (vm.uploadImages.length === 0) {
            vm.uploadImages.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImages, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImages.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (type === "image_for_ar") {
          if (vm.uploadImagesForAR.length === 0) {
            x.description = "arImage";
            vm.uploadImagesForAR.push(x);
          } else {
            var _duplicateImg = false;
            angular.forEach(vm.uploadImagesForAR, function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              x.description = "arImage";
              vm.uploadImagesForAR.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImages.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg2 = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImages), function (y) {
              if (x.name === y.name) {
                _duplicateImg2 = true;
              }
            });

            if (!_duplicateImg2) {
              if (/image/.test(x.type)) {
                vm.uploadImages.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.addMaterial = function () {
      var material = $scope.material;

      if (utils.isEmpty(material.name)) {
        Notification.error('Please input material name');
        return;
      }

      if (utils.isEmpty(material.unit)) {
        Notification.error('Please select material unit');
        return;
      } //material.unit = material.unit;


      if (utils.isEmpty(material.materialCost.value)) {
        Notification.error('Please input Material Cost');
        return;
      }

      material.materialCost.value = utils.convertNumFromEuropean(material.materialCost.value);

      if (utils.isEmpty(material.rooferCost.value)) {
        Notification.error('Please input Worker Cost');
        return;
      }

      material.rooferCost.value = utils.convertNumFromEuropean(material.rooferCost.value);

      if (utils.isEmpty(material.supplier)) {
        Notification.error('Please select supplier');
        return;
      }

      var imgAndFiles = [].concat(vm.uploadImages, vm.uploadFiles, vm.uploadImagesForAR);
      imgAndFiles.forEach(function (x) {
        delete x.objectUrl;
      });
      material.files = imgAndFiles;
      material.assetObj = imgAndFiles.map(function (x) {
        return {
          assetDescription: x.description
        };
      });
      $scope.isLoading = true;
      apiFactory.createMaterial(material).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        $state.go('materialDetail', {
          id: res.data.data
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('addItem', {
    controller: addItemController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/addItem/addItem.view.html'
  });

  function addItemController($scope, apiFactory, globals, $timeout, moment, Notification, $state, utils, $log, unitFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.deadline = vm.isAllProject ? undefined : new Date(); // gantt chart

    $scope.ganttData = {
      data: [],
      links: []
    };
    $scope.gantttimelength = 1000 * 24 * 3600;

    function ganttinit() {
      var items = [];
      var today = new Date();
      var yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      var lastdate = new Date();
      lastdate.setDate(today.getDate() + 9);
      var item = {
        id: 1,
        text: "",
        start_date: new Date(today),
        end_date: new Date(lastdate),
        type: gantt.config.types.project,
        progress: 1,
        showprogress: (lastdate - today) / lastdate,
        project: true,
        calcHours: 0,
        resources: [],
        resourceIds: [],
        duration: 10
      };
      items.push(item);
      gantt.config.auto_scheduling = true;
      gantt.config.min_column_width = 40;
      gantt.config.start_date = today;
      gantt.config.end_date = lastdate;
      gantt.config.layout = {
        css: "gantt_container",
        rows: [{
          config: {
            scale_height: 2,
            row_height: 40,
            task_height: 21
          },
          cols: [{
            view: "timeline",
            scrollX: "scrollHor",
            scrollY: "scrollVer"
          }, {
            view: "scrollbar",
            id: "scrollVer",
            group: "vertical"
          }],
          gravity: 2
        }]
      };
      gantt.init("dhx-gantt");
      $scope.ganttData = {
        data: items,
        links: []
      };
      gantt.render();

      gantt.templates.task_text = function (start, end, task) {
        return "<span class=\"task-text\">".concat(task.text, "</span><span class=\"progress-text\">").concat(Math.ceil(task.showprogress * 100), "%</span>");
      };

      gantt.attachEvent("onAfterTaskDrag", function (id, mode) {
        if (mode === "resize" || mode === "move") {
          var state = gantt.getState();
          var mindate = state.min_date,
              maxdate = state.max_date;
          var totaldate = maxdate - mindate;
          var task = gantt.getTask(id);
          task.showprogress = (task.end_date - task.start_date) / totaldate;
          gantt.updateTask(id);
        }
      });
    }

    function addganttitem(typename, task_id) {
      var today = new Date();
      var lastdate = new Date();
      lastdate.setDate(today.getDate() + 1);
      lastdate.setHours(0);
      var startdate = new Date();
      startdate.setHours(0);
      var state = gantt.getState();
      var mindate = state.min_date,
          maxdate = state.max_date;
      var totaldate = maxdate - mindate;
      var item = {
        id: task_id,
        text: typename,
        start_date: new Date(startdate),
        end_date: new Date(lastdate),
        type: gantt.config.types.task,
        progress: 1,
        showprogress: (lastdate - startdate) / totaldate,
        project: true,
        calcHours: 0,
        resources: [],
        resourceIds: [],
        duration: 10
      };
      $scope.ganttData.data.push(item);
      gantt.addTask(item);
    }

    function deleteganttitem(index) {
      var item = $scope.ganttData.data[index + 1];
      $scope.ganttData.data.splice(index + 1, 1);
      gantt.deleteTask(item.id);
    }

    init();

    function initMaterial() {
      $scope.material = {
        cost: {},
        weatherConditions: [],
        files: [],
        typeOfSub: []
      };
    }

    function init() {
      vm.utils = utils;
      vm.userData = userStore.get();
      initMaterial();
      $scope.color = 'ffffff';
      $scope.opacity = 100;
      $scope.oldMaterialId = undefined;
      vm.materialGroups = [];
      vm.uploadImages = [];
      vm.uploadFiles = [];
      vm.uploadImagesForAR = [];
      $scope.isCertifiedMaintenanceList = [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }];
      $scope.weatherCondition = {
        option: {}
      };
      $scope.weatherRemarks = [{
        label: 'Work',
        value: true
      }, {
        label: 'No Work',
        value: false
      }];
      /* get all material List */

      vm.mUnits = unitFactory.materialUnits();
      globals.getCurrency().then(function (res) {
        vm.currencies = res.data;
      });
      $scope.isLoading = true;
      Promise.all([apiFactory.getAllMaterialGroup(), apiFactory.getAllSuppliers(), apiFactory.getAllWeatherTypes(), apiFactory.getWorkTypes(), apiFactory.getCompanyById(vm.userData.companyId)]).then(function (res) {
        $scope.isLoading = false;
        vm.materialGroups = res[0].data.data;
        vm.suppliers = res[1].data.list;
        vm.weatherTypes = res[2].data.list;
        vm.workTypes = res[3].data.list;
        vm.companyData = res[4].data;
        companyStore.set(vm.companyData);
        $scope.material.currency = angular.copy(vm.companyData.currentCurrency.currencyCode);
        ganttinit();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error("Couldn't load data.");
      });
    }

    $scope.selectOldMaterial = function () {
      initMaterial();
    };

    $scope.changeMaterialCurrency = function () {
      $scope.material.cost.currencyCode = $scope.material.currency;
      $scope.material.currencyCode = $scope.material.currency;
    };

    $scope.changeMaintenancePeriod = function () {
      if ($scope.material.maintenancePeriod > 1000) {
        Notification.error('please enter less than 1000 days');
      }
    };

    $scope.addWorkType = function () {
      var workType = vm.workTypes.find(function (x) {
        return x._id === $scope.workType;
      });

      if (workType && !$scope.material.typeOfSub.find(function (x) {
        return x._id === workType._id;
      })) {
        $scope.material.typeOfSub.push(workType);
        addganttitem(workType.tagName, workType._id);
      }

      $scope.workType = undefined;
      $timeout(function () {
        $scope.$apply();
      });
    };

    $scope.removeWorkType = function (index) {
      $scope.material.typeOfSub.splice(index, 1);
      deleteganttitem(index);
    };

    $scope.addWeatherCondition = function () {
      if (utils.isEmpty($scope.weatherCondition.condition)) {
        Notification.error('Please select weather condition');
        return;
      }

      if (utils.isEmpty($scope.weatherCondition.option)) {
        Notification.error('Please select weather remarks');
        return;
      }

      if (utils.isEmpty($scope.weatherCondition.limited)) {
        Notification.error('Please input weather limited value');
        return;
      }

      $scope.material.weatherConditions.push($scope.weatherCondition);
      $scope.weatherCondition = {
        option: {}
      };
    };

    $scope.removeWeatherCondition = function (index) {
      $scope.material.weatherConditions.splice(index, 1);
    };

    $scope.changedWeatherCondition = function () {
      $scope.weatherCondition.option.isWork = undefined;
      $scope.weatherCondition.limited = undefined;
    };

    $scope.getWeatherConditionInfo = function (weatherCondition) {
      if (angular.isUndefined(weatherCondition) || utils.isEmpty(vm.weatherTypes)) {
        return '';
      }

      var weatherConditionId = angular.isString(weatherCondition.condition) ? weatherCondition.condition : angular.isObject(weatherCondition.condition) ? weatherCondition.condition._id : undefined;
      var type = vm.weatherTypes.find(function (x) {
        return x._id == weatherConditionId;
      });
      var remark = weatherCondition.option ? weatherCondition.option.isWork ? 'Work' : 'No Work' : undefined;
      var tagName = utils.isEmpty(type) ? '' : type.tagName;
      var ret = '';

      if (tagName) {
        ret = ret + ' ' + tagName;
      }

      if (remark) {
        ret = ret + ' ' + remark;
      }

      if (weatherCondition.limited) {
        ret = ret + ' ' + weatherCondition.limited;
      }

      return ret;
    };

    $scope.fileUpdated = function (files, type) {
      angular.forEach(files, function (x) {
        x.objectUrl = URL.createObjectURL(x);
        x.description = "";

        if (type === "image") {
          if (vm.uploadImages.length === 0) {
            vm.uploadImages.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImages, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImages.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (type === "image_for_ar") {
          if (vm.uploadImagesForAR.length === 0) {
            x.description = "arImage";
            vm.uploadImagesForAR.push(x);
          } else {
            var _duplicateImg = false;
            angular.forEach(vm.uploadImagesForAR, function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              x.description = "arImage";
              vm.uploadImagesForAR.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImages.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg2 = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImages), function (y) {
              if (x.name === y.name) {
                _duplicateImg2 = true;
              }
            });

            if (!_duplicateImg2) {
              if (/image/.test(x.type)) {
                vm.uploadImages.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.addMaterial = function () {
      var material = $scope.material;

      if (utils.isEmpty(material.name)) {
        Notification.error('Please input material name');
        return;
      }

      if (utils.isEmpty(material.unit)) {
        Notification.error('Please select material unit');
        return;
      }

      if (utils.isEmpty(material.cost.itemsCost)) {
        Notification.error('Please input Item Cost');
        return;
      }

      if (utils.isEmpty(material.cost.productionTime)) {
        Notification.error('Please input Production Time');
        return;
      }

      var imgAndFiles = [].concat(vm.uploadImages, vm.uploadFiles, vm.uploadImagesForAR);
      imgAndFiles.forEach(function (x) {
        delete x.objectUrl;
      });
      material.files = imgAndFiles;
      material.assetObj = imgAndFiles.map(function (x) {
        return {
          assetDescription: x.description
        };
      }); // $scope.ganttData.data.splice(0, 1);

      material.partItems = [];
      var today = new Date();
      today.setHours(0);

      for (var i = 1; i < $scope.ganttData.data.length; i++) {
        var item = {
          startDate: Math.round(($scope.ganttData.data[i].start_date - today) / $scope.gantttimelength),
          endDate: Math.round(($scope.ganttData.data[i].end_date - today) / $scope.gantttimelength),
          id: $scope.ganttData.data[i].id,
          text: $scope.ganttData.data[i].text
        };
        material.partItems.push(item);
      }

      $scope.isLoading = true;
      $log.log(material);
      apiFactory.createItem(material).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
        $state.go('itemDetail', {
          id: res.data.data
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('addDcp', {
    controller: AddDcpController,
    controllerAs: 'vm',
    templateUrl: 'app/main/materials/addDcp/addDcp.view.html'
  });
  /** @ngInject */

  function AddDcpController($stateParams, apiFactory, globals, $scope, Notification, $state, utils, $log, unitFactory) {
    var vm = this;
    vm.utils = utils;
    $scope.loading = false;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.companyData = companyStore.get();
    $scope.companyCurrencyCode = utils.isEmpty(vm.companyData) || utils.isEmpty(vm.companyData.currentCurrency) || utils.isEmpty(vm.companyData.currentCurrency.currencyCode) ? 'DKK' : vm.companyData.currentCurrency.currencyCode;
    vm.typeAddings = [{
      _id: "Both",
      name: "Both"
    }, {
      _id: "Labor",
      name: "Labour"
    }, {
      _id: "Material",
      name: "Material"
    }];
    vm.mUnits = unitFactory.materialUnits();
    vm.comboData = {
      color: 'ffffff',
      opacity: 100
    };
    $scope.comboMaterialList = [];
    vm.uploadImages = [];
    vm.uploadFiles = [];
    $scope.comboMat = {
      quantity: 1,
      typeAdding: 'Both',
      percentage: 0,
      matCostRate: 0,
      workerCostRate: 0,
      matCost: 0,
      workerCost: 0
    };

    $scope.fileUpdated = function (files, type) {
      angular.forEach(files, function (x) {
        x.objectUrl = URL.createObjectURL(x);
        x.description = "";

        if (type === "image") {
          if (vm.uploadImages.length === 0) {
            vm.uploadImages.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImages, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImages.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (type === "image_for_ar") {
          if (vm.uploadImagesForAR.length === 0) {
            x.description = "arImage";
            vm.uploadImagesForAR.push(x);
          } else {
            var _duplicateImg = false;
            angular.forEach(vm.uploadImagesForAR, function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              x.description = "arImage";
              vm.uploadImagesForAR.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImages.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg2 = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImages), function (y) {
              if (x.name === y.name) {
                _duplicateImg2 = true;
              }
            });

            if (!_duplicateImg2) {
              if (/image/.test(x.type)) {
                vm.uploadImages.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.deleteFile = function (indexVal, type) {
      if (type === "image") {
        vm.uploadImages.splice(indexVal, 1);
      } else {
        vm.uploadFiles.splice(indexVal, 1);
      }
    };

    function loadMaterials() {
      $scope.loading = true;
      Promise.all([apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials()]).then(function (resp) {
        $scope.loading = false;
        vm.matList = resp[0].data.list;
        vm.backupMatList = angular.copy(vm.matList);
        vm.dcpList = resp[1].data.list;
        vm.dcpList.unshift({
          _id: undefined,
          name: ''
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
      });
    }

    loadMaterials();

    $scope.addMaterial = function () {
      var comboMat = $scope.comboMat;

      if (angular.isUndefined(comboMat.matId)) {
        Notification.error('Please select a material');
        return false;
      }

      if (angular.isUndefined(comboMat.quantity)) {
        Notification.error('Please input quantity value');
        return false;
      }

      if (angular.isUndefined(comboMat.percentage) || comboMat.percentage < 0 || comboMat.percentage > 100) {
        Notification.error('Invalid percentage. Please input a value between 0 and 100');
        return false;
      }

      var index = vm.matList.findIndex(function (x) {
        return x._id == comboMat.matId;
      });

      if (index !== -1) {
        $scope.comboMaterialList.push(comboMat);
        $scope.comboMat = {
          quantity: 1,
          typeAdding: 'Both',
          percentage: 0,
          matCostRate: 0,
          workerCostRate: 0,
          matCost: 0,
          workerCost: 0
        };
        vm.matList.splice(index, 1);
      }
    };

    $scope.removeMaterial = function (index, matId) {
      $scope.comboMaterialList.splice(index, 1);
      var mat = vm.backupMatList.find(function (x) {
        return x._id == matId;
      });

      if (mat) {
        vm.matList.push(mat);
      }
    };

    $scope.getTotalCost = function (which) {
      if (utils.isEmpty($scope.comboMaterialList)) {
        return 0;
      }

      return $scope.comboMaterialList.map(function (x) {
        return x[which];
      }).reduce(utils.sumReducer, 0);
    };

    $scope.calcComboMatCost = function (comboMat) {
      switch (comboMat.typeAdding) {
        case 'Both':
          comboMat.matCost = utils.roundNumber(comboMat.quantity * (comboMat.matCostRate + comboMat.percentage / 100 * comboMat.matCostRate));
          comboMat.workerCost = utils.roundNumber(comboMat.quantity * (comboMat.workerCostRate + comboMat.percentage / 100 * comboMat.workerCostRate));
          break;

        case 'Material':
          comboMat.matCost = utils.roundNumber(comboMat.quantity * (comboMat.matCostRate + comboMat.percentage / 100 * comboMat.matCostRate));
          comboMat.workerCost = utils.roundNumber(comboMat.quantity * comboMat.workerCostRate);
          break;

        case 'Labor':
          comboMat.matCost = utils.roundNumber(comboMat.quantity * comboMat.matCostRate);
          comboMat.workerCost = utils.roundNumber(comboMat.quantity * (comboMat.workerCostRate + comboMat.percentage / 100 * comboMat.workerCostRate));
          break;
      }
    };

    $scope.onChangeMat = function (comboMat) {
      var mat = vm.matList.find(function (x) {
        return x._id == comboMat.matId;
      });

      if (angular.isDefined(mat)) {
        comboMat.name = mat.name;
        comboMat.date = mat.createdAt;
        comboMat.matCostRate = mat.baseRate.materialCost;
        comboMat.workerCostRate = mat.baseRate.rooferCost;
        $scope.calcComboMatCost(comboMat);
      }
    };

    $scope.selectOldDcp = function () {
      if (utils.isEmpty(vm.dcpList)) {
        return;
      }

      var selectedDcp = vm.dcpList.find(function (x) {
        return x._id === $scope.selectedDcpId;
      });

      if (selectedDcp._id) {
        vm.comboData.unit = selectedDcp.unit;
        $scope.comboMaterialList = [];

        var _iterator = _createForOfIteratorHelper(selectedDcp.comboMaterialList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var comboMat = _step.value;

            if (utils.isEmpty(comboMat.percentageAdditions) || utils.isEmpty(comboMat.materialId)) {
              continue;
            }

            var material = {
              matId: comboMat.materialId._id,
              name: comboMat.materialId.name,
              date: comboMat.materialId.createdAt,
              quantity: comboMat.quantity,
              unit: comboMat.materialId.unit,
              typeAdding: comboMat.percentageAdditions[0].percentageType,
              percentage: comboMat.percentageAdditions[0].value,
              matCostRate: comboMat.materialId.baseRate.materialCost,
              workerCostRate: comboMat.materialId.baseRate.rooferCost
            };
            $scope.calcComboMatCost(material);
            $scope.comboMaterialList.push(material);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var _iterator2 = _createForOfIteratorHelper($scope.comboMaterialList),
            _step2;

        try {
          var _loop = function _loop() {
            var comboMat = _step2.value;
            var index = vm.matList.findIndex(function (x) {
              return x._id == comboMat.matId;
            });

            if (index !== -1) {
              vm.matList.splice(index, 1);
            }
          };

          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else {
        vm.comboData.unit = undefined;
        $scope.comboMaterialList = [];
      }
    };

    function checkValidation() {
      if (utils.isEmpty(vm.comboData.name)) {
        Notification.error('Please input DCP Name');
        return false;
      }

      if (utils.isEmpty(vm.comboData.unit)) {
        Notification.error('Please select Unit');
        return false;
      }

      if ($scope.comboMaterialList.length < 2) {
        Notification.error("Combination list should be more 2 items at least.");
        return false;
      }

      return true;
    }

    vm.createCombo = function () {
      if (!checkValidation()) {
        return;
      }

      var imgAndFiles = [].concat(vm.uploadImages, vm.uploadFiles);
      var data = {
        files: imgAndFiles,
        assetObj: imgAndFiles.map(function (x) {
          return {
            assetDescription: x.description
          };
        }),
        comboMaterialList: $scope.comboMaterialList.map(function (x) {
          return {
            _id: x._id,
            materialId: x.matId,
            type: 1,
            quantity: x.quantity,
            percentageAdditions: [{
              value: x.percentage,
              percentageType: x.typeAdding
            }]
          };
        }),
        name: vm.comboData.name,
        unit: vm.comboData.unit,
        description: vm.comboData.description,
        color: vm.comboData.color,
        opacity: vm.comboData.opacity
      };
      $scope.loading = true;
      apiFactory.getSystemTag().then(function (res) {
        data.systemTag = res.data.comboTag;
        apiFactory.createComboMaterial(data).then(function (resp) {
          $scope.loading = false;
          Notification.success(resp.data.message);
          $state.go('dcpDetail', {
            id: resp.data.data
          });
        })["catch"](function (err) {
          $scope.loading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('managersGrid', {
    controller: managersGridController,
    controllerAs: 'vm',
    templateUrl: 'app/main/managers/managersGrid/managersGrid.view.html'
  });
  /** @ngInject */

  function managersGridController($scope, apiFactory, utils, globals, $log, Notification, $state) {
    var vm = this;
    var userStore = globals.userStore;
    vm.showAll = false;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.dashboardTypes = globals.getManagerList();
    $scope.MANAGER_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.MANAGER_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.EMPLOYEE]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.MANAGER_ACCESS_CREATE = res.data.data[Constants.AccessKey.EMPLOYEE];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.utils = utils;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.labelChecked = false;
    $scope.managers = [];
    $scope.numPerPage = 12; //globals.numPerPage();

    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.totalCount = 0;
    $scope.isLoading = false;
    $scope.isGrid = true;
    vm.searchText = undefined;
    vm.sortMenuList = [{
      label: 'Name',
      key: 'firstName'
    }, {
      label: 'Created Date',
      key: 'createdAt'
    }, {
      label: 'Modified Date',
      key: 'updatedAt'
    }, {
      label: 'Manager Tag',
      key: 'systemTag'
    }];
    vm.sortMenu = "createdAt";

    vm.fetchAllManagers = function () {
      $scope.isLoading = true;
      apiFactory.listAllManagers({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        isActive: !vm.showAll
      }).then(function (resp) {
        $scope.isLoading = false;
        $log.log(resp.data.list);
        $scope.managers = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function () {
        $scope.isLoading = false;
      });
    };

    vm.fetchAllManagers();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchAllEmployees();
    };

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.fetchAllManagers();
    };

    $scope.goToDetail = function (clientId) {
      $state.go('managersDetail', {
        id: clientId
      });
    };

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      $scope.managers.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };

    $scope.getColor = function (name) {
      return globals.getAvatarColor(name);
    };

    $scope.getDashboardType = function (type) {
      if (angular.isUndefined(type)) return "";
      var find = $scope.dashboardTypes.find(function (elem) {
        return elem.dashboardType === type;
      });

      if (find) {
        return find.name;
      } else {
        return "";
      }
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('managersEdit', {
    controller: managersEditController,
    controllerAs: 'vm',
    templateUrl: 'app/main/managers/managersEdit/managersEdit.view.html'
  });
  /** @ngInject */

  function managersEditController($scope, $state, apiFactory, globals, Notification, $stateParams) {
    var vm = this;
    vm.userData = globals.userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    }; // $scope.dashboardList = globals.getManagerList().map((item) => {
    //   return {
    //     _id: item.dashboardType,
    //     name: item.name
    //   }
    // });


    $scope.dashboardList = ["Executive Manager", "CEO", "Sales Executive Manager", "Procurement Manager", "Service & FM Manager", "Finance Manager", "Audit Manager", "Bid Manager", "Sales Manager", "Design Manager", "Project Manager", "Site Manager", "QSHE Manager"];

    vm.selectDashboard = function (dashboard) {
      var idx = vm.Manager.dashboard.indexOf(dashboard);

      if (idx > -1) {
        vm.Manager.dashboard.splice(idx, 1);
      } else {
        vm.Manager.dashboard.push(dashboard);
      }
    };

    vm.managerId = $stateParams.id;
    $scope.loading = false;
    vm.currentCountry = {
      primary: 'Country',
      secondary: 'Country'
    };
    vm.addSkillLevelList = globals.gSkillLevelList; // vm.isManager = false;

    vm.weekDays = ["Sunday", "Monday", "Tuesday", "Wednsday", "Thursday", "Friday", "Saturday"];
    vm.enableList = [{
      value: 'active',
      name: 'Enable'
    }, {
      value: 'inactive',
      name: 'Disable'
    }];
    vm.genderList = [{
      value: 'male',
      name: 'Male'
    }, {
      value: 'female',
      name: 'Female'
    }];
    var companyStore = globals.companyStore;
    vm.companyData = companyStore.get();
    vm.taskType = [];

    vm.getTaskType = function () {
      if (vm.companyData.employee) {
        vm.taskType = vm.companyData.employee.taskList;
      }
    };

    vm.getTaskType();
    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x, _index) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    vm.allskills = [];

    function updateSkillSet() {
      apiFactory.getSkillTags().then(function (resp) {
        vm.allskills = [];

        for (var i = 0; i < resp.data.list.length; i++) {
          vm.allskills.push(resp.data.list[i].tagName);
        }
      });
    }

    updateSkillSet();
    vm.drivingCostList = [];

    vm.getDrivingCostList = function () {
      if (vm.companyData.employee) {
        vm.drivingCostList = vm.companyData.employee.drivingCostList;
      }

      if (vm.drivingCostList) {
        var defaultCost = vm.drivingCostList.find(function (x) {
          return x.isDefault;
        });

        if (defaultCost) {
          vm.defaultDrivingCost = defaultCost.value + defaultCost.currencyCode + ' ' + defaultCost.unit;
        }
      }
    };

    vm.getDrivingCostList();
    vm.designationList = [];
    vm.departmentList = [];
    Promise.all([apiFactory.getAllEmployeeSettings(), apiFactory.getDepartments(), apiFactory.getDesignations()]).then(function (data) {
      vm.laberSettingsList = data[0].data.data;
      vm.laberSettingsList = vm.laberSettingsList.filter(function (it) {
        return it.isManager;
      });
      vm.departmentList = data[1].data.data.map(function (item) {
        return {
          _id: item,
          name: item
        };
      });
      vm.designationList = data[2].data.data.map(function (item) {
        return {
          _id: item,
          name: item
        };
      });
      $scope.getManagerDetails();
    })["catch"](function () {
      Notification.error("Couldn't load data.");
    });

    $scope.getManagerDetails = function () {
      $scope.loading = true;
      apiFactory.getManagerById(vm.managerId).then(function (resp) {
        $scope.loading = false;
        vm.Manager = resp.data;
        if (vm.Manager.roleId) $scope.changeOption('Designation', vm.Manager.roleId);

        if (vm.Manager.employeeSettingId) {
          $scope.changeOption('EmployeeSetting', vm.Manager.employeeSettingId);
        } else {
          vm.isManager = vm.Manager.designation === 'manager';
        }

        $scope.FILEIMG = vm.Manager.profilePic;
        var name = [];
        if (vm.Manager.firstName.trim()) name.push(vm.Manager.firstName.trim());
        if (vm.Manager.middleName.trim()) name.push(vm.Manager.middleName.trim());
        if (vm.Manager.lastName.trim()) name.push(vm.Manager.lastName.trim());
        vm.Manager.name = vm.Manager.displayName;
        $scope.skills = vm.Manager.listOfSkills;

        if (vm.Manager.mobile) {
          vm.Manager.mobile.phoneNumber = parseInt(vm.Manager.mobile.phoneNumber);

          if (vm.Manager.mobile.dialCode.trim().charAt(0) === '+') {
            vm.dialCode = vm.Manager.mobile.dialCode.trim().slice(1);
            vm.Manager.mobile.dialCode = vm.dialCode;
          }
        }

        vm.Manager.dob = new Date(vm.Manager.dateOfBirth);
        vm.Manager.doj = new Date(vm.Manager.dateOfJoin);
        var find = vm.countryCodes.find(function (elem) {
          return elem.code === vm.Manager.address1.countryCode;
        });

        if (find) {
          vm.currentCountry.primary = find.name;
        }

        find = vm.countryCodes.find(function (elem) {
          return elem.code === vm.Manager.address2.countryCode;
        });

        if (find) {
          vm.currentCountry.secondary = find.name;
        }

        vm.Manager.isActive = vm.Manager.isActive === true ? 'active' : 'inactive';

        if (angular.isDefined(vm.Manager.department)) {
          vm.changeDepartment({
            name: vm.Manager.department
          });
        }
      })["catch"](function () {
        $scope.loading = false;
      });
    };

    vm.updateManager = function (reqBody) {
      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);
      reqBody.profilePic = $scope.imgAndFiles;
      var manager = angular.fromJson(angular.toJson(reqBody));

      if (!manager.name || manager.name === '') {
        Notification.error("Please enter name.");
        return;
      }

      if (!manager.gender) {
        Notification.error("Please select gender.");
        return;
      }

      if (!manager.isActive) {
        Notification.error("Please select active.");
        return;
      } else {
        manager.isActive = manager.isActive === 'active';
      }

      if (!manager.mobile || !manager.mobile.dialCode || !manager.mobile.phoneNumber) {
        Notification.error("Please enter contact number.");
        return;
      } else {
        if (!manager.mobile.dialCode.includes('+')) {
          manager.mobile.dialCode = '+' + manager.mobile.dialCode;
        }
      }

      if (!manager.email) {
        Notification.error("Please enter email.");
        return;
      }

      if (!manager.dob) {
        Notification.error("Please enter birth date.");
        return;
      } else {
        manager.dob = moment(manager.dob);
      }

      if (!manager.doj) {
        Notification.error("Please enter join date.");
        return;
      } else {
        manager.doj = moment(manager.doj);
      }

      if (!manager.address1 || !manager.address1.line1 || !manager.address1.city || angular.isUndefined(manager.address1.postalCode) || !manager.address1.countryCode) {
        Notification.error("Please fill up all primary address fields.");
        return;
      }

      if (!manager.salaryAmount) {
        Notification.error("Please enter salary.");
        return;
      }

      if (manager.listOfSkills) delete manager.listOfSkills;
      if ($scope.picFile) manager.picFile = $scope.picFile;
      $scope.loading = true;
      apiFactory.updateManager(manager, vm.managerId).then(function () {
        $scope.loading = false;
        Notification.success("Manager updated.");
        $state.go("managersDetail", {
          id: vm.managerId
        });
      })["catch"](function (error) {
        $scope.loading = false;
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Couldn't update manager.");
      });
    };

    vm.bonus = {};

    $scope.changedTask = function (task) {
      $scope.bonus_task = task;
      var find = vm.taskType.find(function (elem) {
        return elem.name === task;
      });

      if (find) {
        vm.bonus.currencyCode = find.currencyCode;
        vm.bonus.value = find.value;
      }
    };

    $scope.paymentConditions = vm.companyData.paymentConditions;
    /**Insert Supplier functions */

    $scope.onChange = function (files) {
      if (angular.isUndefined(files[0])) return;
      vm.Manager.profilePic = URL.createObjectURL(files[0]); // $scope.fileExt = files[0].name.split('.').pop()
    };

    globals.getCurrency().then(function (resp) {
      vm.currencies = resp.data; // vm.currenciesList = vm.currencies.map(i => )

      vm.currenciesList = vm.currencies.map(function (c) {
        return {
          cc: c.cc // label: c.cc + ' - ' + c.name

        };
      });
    });
    globals.getCountryCode().then(function (resp) {
      vm.countryCodes = resp.data;
      vm.countryCodes = vm.countryCodes.map(function (x) {
        return {
          name: x.name,
          dialCode: x.dialCode,
          code: x.code,
          dialCodeName: "".concat(x.dialCode, " (").concat(x.name, ")")
        };
      });
    });
    var clientPaymentSetting;

    $scope.ClientPaymentSetting = function (event) {
      clientPaymentSetting = event.target.id;
      $scope.paymentTerms = [clientPaymentSetting];
    };

    $scope.selectWorkRate = function (event) {
      vm.Manager.workRate.currencyCode = event.target.id;
    };

    $scope.deleteManager = function () {
      $scope.loading = true;
      apiFactory.deleteManager(vm.managerId).then(function () {
        $scope.loading = false;
        $state.go('employees');
        Notification.success('Manager deleted successfully');
      }, function () {
        $scope.loading = false;
        Notification.error('Something went wrong try later');
      })["catch"](function () {
        $scope.loading = false;
      });
    };

    vm.addSkillAction = function () {
      if (!vm.addSkill || angular.isUndefined(vm.addSkillLevel)) {
        Notification.error("Please enter skill");
        return;
      }

      $scope.skills.push({
        level: vm.addSkillLevel,
        name: vm.addSkill
      });
      vm.addSkill = '';
      vm.addSkillLevel = undefined;
    };

    $scope.changeOption = function (type, value) {
      var list = [];

      if (type === 'Designation') {
        list = vm.designationList;
        vm.Manager.roleId = value;
      } else if (type === 'EmployeeSetting') {
        list = vm.laberSettingsList;
        vm.Manager.employeeSettingId = value;
      }

      if (angular.isUndefined(list)) return;
      var find = list.find(function (elem) {
        return elem._id === value;
      });

      if (find) {
        if (type === 'EmployeeSetting') {
          vm.isManager = find.isManager;
        }
      }
    };

    $scope.isOpenAutoCompleteForSkill = false;

    $scope.skill_autocomplete = function () {
      $scope.isOpenAutoCompleteForSkill = true;
      var output = [];

      if (vm.addSkill && vm.addSkill !== '') {
        angular.forEach(vm.allskills, function (skill) {
          if (skill.toLowerCase().indexOf(vm.addSkill.toLowerCase()) >= 0) {
            output.push(skill);
          }
        });
      } else {
        angular.forEach(vm.allskills, function (skill) {
          output.push(skill);
        });
      }

      $scope.auto_skills = output;
    };

    vm.selectedSkill = function (skill) {
      vm.addSkill = skill;
      $scope.isOpenAutoCompleteForSkill = false;
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('managersDetail', {
    controller: managersDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/managers/managersDetail/managersDetail.view.html'
  });
  /** @ngInject */

  function managersDetailController($scope, $state, apiFactory, globals, Notification, $stateParams, $uibModal, $log, utils) {
    var vm = this;
    vm.utils = utils;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.dashboardTypes = globals.getManagerList();
    $scope.EMPLOYEE_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.EMPLOYEE_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.EMPLOYEE]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.EMPLOYEE_ACCESS_CREATE = res.data.data[Constants.AccessKey.EMPLOYEE];
    //   })
    //   .catch((e) => {
    //     $scope.isLoading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    vm.companyData = companyStore.get();
    $scope.paymentConditions = vm.companyData.paymentConditions;
    vm.managerId = $stateParams.id;
    $scope.isLoading = false;
    Promise.all([apiFactory.getAllEmployeeSettings(), apiFactory.getRolesForCompany()]).then(function (data) {
      vm.laberSettingsList = data[0].data.data;
      vm.laberSettingsList = vm.laberSettingsList.filter(function (it) {
        return it.isManager;
      });
      vm.designationList = data[1].data.data;
      $scope.getManagerDetails();
    })["catch"](function () {
      Notification.error("Couldn't load data.");
    });

    $scope.getManagerDetails = function () {
      $scope.isLoading = true;
      apiFactory.getManagerById(vm.managerId).then(function (resp) {
        $scope.isLoading = false;
        vm.Manager = resp.data;
        $scope.FILEIMG = vm.Manager.profilePic;
        $scope.getLabel('Designation', vm.Manager.roleId);
        $scope.getLabel('EmployeeSetting', vm.Manager.employeeSettingId);
        var skills = [];
        vm.Manager.listOfSkills.forEach(function (item) {
          skills.push(item.name);
        });
        vm.strSkills = skills.join(', ');
      })["catch"](function () {
        $scope.isLoading = false;
      });
    };

    $scope.deleteManager = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.isLoading = true;
          apiFactory.deleteManager(vm.managerId).then(function () {
            $scope.isLoading = false;
            $state.go('managers');
            Notification.success('Manager deleted successfully');
          }, function () {
            $scope.isLoading = false;
            Notification.error('Something went wrong try later');
          })["catch"](function () {
            $scope.isLoading = false;
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };
    /**Insert Supplier functions */


    $scope.onChange = function (files) {
      if (angular.isUndefined(files[0])) return;
      $scope.FILEIMG = URL.createObjectURL(files[0]);
      $scope.fileExt = files[0].name.split('.').pop();
    };

    globals.getCountryCode().then(function (resp) {
      vm.getCountryCode = resp.data;

      vm.loadCountryCode = function () {
        return new Promise(function (resolve, reject) {
          resolve(resp.data);
        });
      };
    });
    var clientPaymentSetting; //, staffDialCode, clientDialCode, 

    $scope.ClientDialCode = function (event) {// clientDialCode = event.target.id
    };

    $scope.ClientPaymentSetting = function (event) {
      clientPaymentSetting = event.target.id;
      $scope.paymentTerms = [clientPaymentSetting];
    };

    $scope.StaffDialCode = function (event) {// staffDialCode=event.target.id
    };

    $scope.createManager = function () {};

    $scope.getLabel = function (type, value) {
      var list = [];

      if (type == 'Designation') {
        list = vm.designationList;
        vm.Manager.roleId = value;
      } else if (type == 'EmployeeSetting') {
        list = vm.laberSettingsList;
        vm.Manager.managerSettingId = value;
      }

      if (angular.isUndefined(list)) return;
      var find = list.find(function (elem) {
        return elem._id == value;
      });

      if (find) {
        if (type == 'Designation') vm.designationLabel = find.name;else if (type == 'EmployeeSetting') vm.managerSettingLabel = find.presetName;
      }
    };

    $scope.getDashboardType = function (type) {
      if (angular.isUndefined(type)) return "";
      var find = $scope.dashboardTypes.find(function (elem) {
        return elem.dashboardType === type;
      });

      if (find) {
        return find.name;
      } else {
        return "";
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('managersAdd', {
    controller: managersAddController,
    controllerAs: 'vm',
    templateUrl: 'app/main/managers/managersAdd/managersAdd.view.html'
  });
  /** @ngInject */

  function managersAddController($scope, $state, apiFactory, globals, Notification) {
    var vm = this;
    vm.userData = globals.userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.dashboardList = globals.getManagerList().map(function (item) {
      return {
        _id: item.dashboardType,
        name: item.name
      };
    });
    vm.Manager = {};
    vm.overtime = {};
    vm.weekendPay = {};
    vm.enableList = [{
      value: 'active',
      name: 'Enable'
    }, {
      value: 'inactive',
      name: 'Disable'
    }];
    vm.genderList = [{
      value: 'male',
      name: 'Male'
    }, {
      value: 'female',
      name: 'Female'
    }];
    $scope.isLoading = false;
    vm.currentCountry = {
      primary: 'Country',
      secondary: 'Country'
    };
    vm.addSkillLevelList = globals.gSkillLevelList;
    vm.weekDays = ["Sunday", "Monday", "Tuesday", "Wednsday", "Thursday", "Friday", "Saturday"];
    var companyStore = globals.companyStore;
    vm.companyData = companyStore.get();
    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x, _index) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    vm.taskType = [];

    vm.getTaskType = function () {
      if (vm.companyData.employee) {
        vm.taskType = vm.companyData.employee.taskList;
      }
    };

    vm.getTaskType();
    vm.allskills = [];

    function updateSkillSet() {
      apiFactory.getSkillTags().then(function (resp) {
        vm.allskills = [];

        for (var i = 0; i < resp.data.list.length; i++) {
          vm.allskills.push(resp.data.list[i].tagName);
        }
      });
    }

    updateSkillSet();
    vm.drivingCostList = [];

    vm.getDrivingCostList = function () {
      if (vm.companyData.employee) {
        vm.drivingCostList = vm.companyData.employee.drivingCostList;
      }

      if (vm.drivingCostList) {
        var defaultCost = vm.drivingCostList.find(function (x) {
          return x.isDefault;
        });

        if (defaultCost) {
          vm.defaultDrivingCost = defaultCost.value + defaultCost.currencyCode + ' ' + defaultCost.unit;
        }
      }
    };

    vm.getDrivingCostList();
    vm.bonus = {};
    vm.designationList = [];
    vm.departmentList = [];
    Promise.all([apiFactory.getAllEmployeeSettings(), apiFactory.getDepartments(), apiFactory.getDesignations()]).then(function (data) {
      vm.laberSettingsList = data[0].data.data; // vm.laberSettingsList = vm.laberSettingsList.filter(it => it.isManager);

      vm.departmentList = data[1].data.data.map(function (item) {
        return {
          _id: item,
          name: item
        };
      });
      vm.designationList = data[2].data.data.map(function (item) {
        return {
          _id: item,
          name: item
        };
      });
    })["catch"](function () {
      Notification.error("Couldn't load data.");
    });

    $scope.changedTask = function (task) {
      $scope.bonus_task = task;
      var find = vm.taskType.find(function (elem) {
        return elem.name === task;
      });

      if (find) {
        vm.bonus.currencyCode = find.currencyCode;
        vm.bonus.value = find.value;
      }
    };

    $scope.paymentConditions = vm.companyData.paymentConditions;
    /**Insert Supplier functions */

    $scope.onChange = function (files) {
      if (angular.isUndefined(files[0])) return;
      vm.Manager.profilePic = URL.createObjectURL(files[0]); // $scope.fileExt = files[0].name.split('.').pop()
    };

    globals.getCurrency().then(function (resp) {
      vm.currencies = resp.data; // vm.currenciesList = vm.currencies.map(i => )

      vm.currenciesList = vm.currencies.map(function (c) {
        return {
          cc: c.cc // label: c.cc + ' - ' + c.name

        };
      });
    });
    globals.getCountryCode().then(function (resp) {
      vm.countryCodes = resp.data;
      vm.countryCodes = vm.countryCodes.map(function (x) {
        return {
          name: x.name,
          dialCode: x.dialCode,
          code: x.code,
          dialCodeName: "".concat(x.dialCode, " (").concat(x.name, ")")
        };
      });
    });

    $scope.createManager = function () {
      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);
      vm.Manager.profilePic = $scope.imgAndFiles;
      var manager = angular.fromJson(angular.toJson(vm.Manager));

      if (!manager.name || manager.name === '') {
        Notification.error("Please enter name.");
        return;
      }

      if (!manager.gender) {
        Notification.error("Please select gender.");
        return;
      }

      if (!manager.isActive) {
        Notification.error("Please select active.");
        return;
      } else {
        manager.isActive = manager.isActive === 'active';
      }

      if (!manager.mobile || !manager.mobile.dialCode || !manager.mobile.phoneNumber) {
        Notification.error("Please enter contact number.");
        return;
      } else {
        if (!manager.mobile.dialCode.includes('+')) {
          manager.mobile.dialCode = '+' + manager.mobile.dialCode;
        }
      }

      if (!manager.email) {
        Notification.error("Please enter email.");
        return;
      }

      if (!manager.dob) {
        Notification.error("Please enter birth date.");
        return;
      } else {
        manager.dob = moment(manager.dob);
      }

      if (!manager.doj) {
        Notification.error("Please enter join date.");
        return;
      } else {
        manager.doj = moment(manager.doj);
      }

      if (!manager.address1 || !manager.address1.line1 || !manager.address1.city || angular.isUndefined(manager.address1.postalCode) || !manager.address1.countryCode) {
        Notification.error("Please fill up all primary address fields.");
        return;
      }

      if (!manager.salaryAmount) {
        Notification.error("Please enter salary.");
        return;
      }

      if ($scope.bonus_task) {
        manager.bonus = {
          taskList: [{
            name: $scope.bonus_task,
            currencyCode: vm.bonus.currencyCode,
            value: vm.bonus.value
          }]
        };
      }

      manager.listOfSkills = [];

      var _iterator = _createForOfIteratorHelper($scope.skills),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          manager.listOfSkills.push({
            level: item.level,
            name: item.name
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if ($scope.picFile) manager.picFile = $scope.picFile;
      $scope.isLoading = true;
      apiFactory.createManager(manager).then(function () {
        $scope.isLoading = false;
        Notification.success("Manager saved.");
        $state.go("managers");
      })["catch"](function (error) {
        $scope.isLoading = false;
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed Manager save");
      });
    };

    $scope.skills = [];
    vm.addSkill = '';

    $scope.changeOption = function (type, value) {
      var list = [];

      if (type === 'Designation') {
        list = vm.designationList;
        vm.Manager.roleId = value;
      } else if (type === 'EmployeeSetting') {
        list = vm.laberSettingsList;
        vm.Manager.employeeSettingId = value;
      }

      if (angular.isUndefined(list)) return;
      var find = list.find(function (elem) {
        return elem._id === value;
      });

      if (find) {
        if (type === 'Designation') vm.designationLabel = find.name;else if (type === 'EmployeeSetting') {
          vm.employeeSettingLabel = find.presetName;
        }
      }
    };

    $scope.isOpenAutoCompleteForSkill = false;

    $scope.skill_autocomplete = function () {
      $scope.isOpenAutoCompleteForSkill = true;
      var output = [];

      if (vm.addSkill && vm.addSkill !== '') {
        angular.forEach(vm.allskills, function (skill) {
          if (skill.toLowerCase().indexOf(vm.addSkill.toLowerCase()) >= 0) {
            output.push(skill);
          }
        });
      } else {
        angular.forEach(vm.allskills, function (skill) {
          output.push(skill);
        });
      }

      $scope.auto_skills = output;
    };

    vm.selectedSkill = function (skill) {
      vm.addSkill = skill;
      $scope.isOpenAutoCompleteForSkill = false;
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail').component('mailTrash1', {
    controller: MailTrashComponentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/trash/trash.view.html'
  });
  /** @ngInject */

  function MailTrashComponentController($scope, $log, apiFactory, $rootScope, $location, $state, localStorageService) {
    // const vm = this
    $scope.checked = 0;
    $scope.mails = [];
    $scope.limit = 10;
    $scope.page = 0;
    $scope.total = 0;
    $scope.selectedEmail = null;
    $scope.isDetail = false;
    $scope.isCompose = false;
    $scope.loading = false;
    var token = localStorageService.get('mail-token');

    if (!token) {
      $state.go('appMailLogin');
    }

    $scope.getMails = function (params) {
      $scope.loading = true;
      apiFactory.getTrashMails(params).then(function (res) {
        $scope.loading = false;
        $log.info(res.data.data);
        $scope.mails = $scope.mails.concat(res.data.data.mails);
        $scope.total = res.data.data.total;

        if ($scope.mails.length && !params) {
          $scope.onMailItemClick($scope.mails[0]);
        }
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.getMails();

    $scope.refreshMail = function () {
      var params = {
        page: 0,
        limit: $scope.page * $scope.limit
      };
      $scope.loading = true;
      apiFactory.getTrashMails(params).then(function (res) {
        $scope.loading = false;
        $log.info(res.data.data);
        $scope.mails = res.data.data.mails;
        $scope.total = res.data.data.total;

        if ($scope.mails.length) {
          $scope.onMailItemClick($scope.mails[0]);
        }
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        } // localStorageService.set('mail-token', null);
        // $state.go('appMailLogin');


        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.loadMore = function () {
      if ($scope.loading) {
        return;
      }

      $scope.page++;
      var params = {
        page: $scope.page,
        limit: $scope.limit
      };
      $scope.getMails(params);
    };

    $scope.onMailItemClick = function (item) {
      var data = {
        seqNo: item.seqNo,
        box: "Trash"
      };
      $scope.loading = true;
      apiFactory.getMailDetails(data).then(function (res) {
        $scope.selectedEmail = res.data.data;
        $scope.loading = false;
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.onCheckboxClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
    };

    $scope.onDetailsPaneClose = function () {};

    var mailCompose = $rootScope.$on('mail-compose', function () {
      $scope.isDetail = true;
      $scope.isCompose = true;
    });
    $rootScope.$on('$destroy', mailCompose);
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail').component('mailStared', {
    controller: MailStaredComponentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/stared/stared.view.html'
  });
  /** @ngInject */

  function MailStaredComponentController($scope, $log, $rootScope, $location, $state, apiFactory, localStorageService) {
    // const vm = this
    $scope.checked = 0;
    $scope.mails = [];
    $scope.limit = 10;
    $scope.page = 0;
    $scope.total = 0;
    $scope.selectedEmail = null;
    $scope.isDetail = false;
    $scope.isCompose = false;
    $scope.loading = false;
    var token = localStorageService.get('mail-token');

    if (!token) {
      $state.go('appMailLogin');
    }

    $scope.getMails = function (params) {
      $scope.loading = true;
      apiFactory.getStarredMails(params).then(function (res) {
        $scope.loading = false;
        $log.info(res.data.data);
        $scope.mails = $scope.mails.concat(res.data.data.mails);
        $scope.total = res.data.data.total;

        if ($scope.mails.length && !params) {
          $scope.onMailItemClick($scope.mails[0]);
        }
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.getMails();

    $scope.refreshMail = function () {
      var params = {
        page: 0,
        limit: $scope.page * $scope.limit
      };
      $scope.loading = true;
      apiFactory.getStarredMails(params).then(function (res) {
        $scope.loading = false;
        $log.info(res.data.data);
        $scope.mails = res.data.data.mails;
        $scope.total = res.data.data.total;

        if ($scope.mails.length) {
          $scope.onMailItemClick($scope.mails[0]);
        }
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        } // localStorageService.set('mail-token', null);
        // $state.go('appMailLogin');


        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.loadMore = function () {
      if ($scope.loading) {
        return;
      }

      $scope.page++;
      var params = {
        page: $scope.page,
        limit: $scope.limit
      };
      $scope.getMails(params);
    };

    $scope.onMailItemClick = function (item) {
      var data = {
        seqNo: item.seqNo,
        box: "Starred"
      };
      $scope.loading = true;
      apiFactory.getMailDetails(data).then(function (res) {
        $scope.selectedEmail = res.data.data;
        $scope.loading = false;
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.onCheckboxClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
    };

    $scope.onDetailsPaneClose = function () {};

    var mailComposeCallback = $rootScope.$on('mail-compose', function () {
      $scope.isDetail = true;
      $scope.isCompose = true;
    });
    $rootScope.$on('$destroy', mailComposeCallback);
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail').component('mailSetting', {
    controller: MailSettingComponentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/setting/setting.view.html'
  });
  /** @ngInject */

  function MailSettingComponentController($scope, $log, apiFactory, $rootScope, $location, $state, localStorageService, globals, Notification) {
    var vm = this;
    var userStore = globals.userStore;
    $scope.isDetail = false;
    $scope.isCompose = false;
    $scope.isCollapse = false;
    $scope.isLoading = true;
    vm.fileObjectUrl = '';
    vm.userData = userStore.get();
    vm.responseData = {};
    vm.mailSignatureId = '';

    this.$onInit = function () {
      apiFactory.getUserMailSignatures().then(function (res) {
        var data = res.data.data;

        if (data.length) {
          vm.mailSignatureId = data[0]._id;
          apiFactory.getMailSignature(vm.mailSignatureId).then(function (sign) {
            var signData = sign.data.data;
            vm.responseData = signData;
            vm.fileObjectUrl = signData.image.url;
            $scope.isLoading = false;
          });
        }
      });
    };

    $scope.savePersonalInfo = function () {
      var fd = new FormData();
      fd.append('name', vm.responseData.name);
      fd.append('emailID', vm.responseData.emailID);
      fd.append('address', vm.responseData.address);
      fd.append('description', vm.responseData.description);
      fd.append('telephoneNumber', vm.responseData.telephoneNumber);
      fd.append('mobileNumber', vm.responseData.mobileNumber);
      fd.append('website', vm.responseData.website);
      fd.append('image', vm.responseData.image);

      if (vm.mailSignatureId) {
        apiFactory.updateMailSignature(fd, vm.mailSignatureId).then(function (res) {
          Notification.success(res.data.message);
        });
      } else {
        apiFactory.addMailSignature(fd).then(function (res) {
          Notification.success(res.data.message);
        });
      }
    };

    $scope.fileUpdated = function (files) {
      if (files && files.length) {
        var file = files[0];
        vm.fileObjectUrl = URL.createObjectURL(file);
        vm.responseData.image = file;
      }
    };

    $scope.onCloseComposer = function () {
      $scope.isCompose = false;
      $scope.composeType = 0;
    };

    var mailCompose = $rootScope.$on('mail-compose', function () {
      $scope.isDetail = true;
      $scope.isCompose = true;
    });
    var sideMenuCollapseCallback = $rootScope.$on('side-menu-collapse', function () {
      $scope.isCollapse = !$scope.isCollapse;
    });
    $rootScope.$on('$destroy', mailCompose, sideMenuCollapseCallback);
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail').component('mailSent', {
    controller: MailSentComponentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/sent/sent.view.html'
  });
  /** @ngInject */

  function MailSentComponentController($scope, $log, $rootScope, $location, $state, apiFactory, localStorageService) {
    // const vm = this
    $scope.checked = 0;
    $scope.mails = [];
    $scope.limit = 10;
    $scope.page = 0;
    $scope.total = 0;
    $scope.selectedEmail = null;
    $scope.isDetail = false;
    $scope.isCompose = false;
    $scope.loading = false;
    $scope.seartchtxt = "";
    var token = localStorageService.get('mail-token');

    if (!token) {
      $state.go('appMailLogin');
    }

    $scope.stopSearch = true;

    $scope.searchSentMails = function (params, limit, cnt) {
      if (limit === cnt || $scope.stopSearch === true) {
        return;
      } else {
        apiFactory.searchSentMails(params).then(function (res) {
          $scope.loading = false;

          if ($scope.stopSearch === true) {
            return;
          }

          if (res.data.data.mails && Object.keys(res.data.data.mails).length === 0 && Object.getPrototypeOf(res.data.data.mails) === Object.prototype) {
            return;
          }

          if (cnt === 0) {
            $scope.mails = [res.data.data.mails];
          } else {
            $scope.mails.push(res.data.data.mails);
          }

          $scope.total = res.data.data.total;

          if ($scope.mails.length && res.data.data.total != 0) {
            if (cnt === 0) {
              $scope.onMailItemClick($scope.mails[0]);
            }

            params.uid = $scope.mails[$scope.mails.length - 1]['seqNo'] - 1;
            $scope.searchSentMails(params, limit, cnt + 1);
          }
        })["catch"](function (err) {
          $log.error(err);

          if (err && err.data && err.data.data && err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
            localStorageService.set('mail-token', null);
            $state.go('appMailLogin');
          } // localStorageService.set('mail-token', null);
          // $state.go('appMailLogin');


          $scope.loading = false;
          Notification.error("Connection Failed");
        });
      }
    };

    $scope.getMails = function (params) {
      $scope.loading = true;
      apiFactory.getSentMails(params).then(function (res) {
        $scope.loading = false;
        $scope.mails = $scope.mails.concat(res.data.data.mails);
        $scope.total = res.data.data.total;

        if ($scope.mails.length && !params) {
          $scope.onMailItemClick($scope.mails[0]);
        }
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.getMails();

    $scope.refreshMail = function () {
      var params = {
        page: 0,
        limit: $scope.page * $scope.limit,
        search: $scope.seartchtxt
      };
      $scope.loading = true;

      if (params.search) {
        $scope.stopSearch = false;
        $scope.searchSentMails(params, 1000, 0);
      } else {
        $scope.stopSearch = true;
        apiFactory.getSentMails(params).then(function (res) {
          $scope.loading = false;
          $scope.mails = res.data.data.mails;
          $scope.total = res.data.data.total;

          if ($scope.mails.length) {
            $scope.onMailItemClick($scope.mails[0]);
          }
        })["catch"](function (err) {
          $log.error(err);

          if (err && err.data && err.data.data && err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
            localStorageService.set('mail-token', null);
            $state.go('appMailLogin');
          } // localStorageService.set('mail-token', null);
          // $state.go('appMailLogin');


          $scope.loading = false;
          Notification.error("Connection Failed");
        });
      }
    };

    $scope.loadMore = function () {
      if ($scope.loading) {
        return;
      }

      $scope.page++;
      var params = {
        page: $scope.page,
        limit: $scope.limit
      };
      $scope.getMails(params);
    };

    $scope.onMailItemClick = function (item) {
      var data = {
        seqNo: item.seqNo,
        box: "Sent"
      };
      $scope.loading = true;
      apiFactory.getMailDetails(data).then(function (res) {
        $scope.selectedEmail = res.data.data;
        $scope.loading = false;
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.onCheckboxClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
    };

    $scope.onDetailsPaneClose = function () {};

    var mailComposeCallback = $rootScope.$on('mail-compose', function () {
      $scope.isDetail = true;
      $scope.isCompose = true;
    });
    $rootScope.$on('$destroy', mailComposeCallback);
  }
})();


"use strict";

(function () {
  angular.module("app.mail").component("mailLogin", {
    controller: mailLoginController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/login/login.view.html' // bindings: {
    //   $close: "&",
    //   $dismiss: "&",
    //   modalInstance: "<",
    //   resolve: "<"
    // }

  });
  /** @ngInject */

  function mailLoginController($scope, $state, Notification, apiFactory, $log, $uibModal, localStorageService) {
    // const vm = this;
    $scope.errorLoginPage = false;
    $scope.hosts = [];

    $scope.getWebmailHosts = function () {
      apiFactory.listWebmailHost().then(function (resp) {
        $scope.hosts = resp.data.data;
      });
    };

    $scope.getWebmailHosts(); // $scope.onCancel = function () {
    //   vm.modalInstance.dismiss('cancel');
    // }

    $scope.onSubmit = function () {
      // $state.go('appMailInbox');
      if (!$scope.email || !$scope.password) {
        Notification.error('Please fill all fields.');
        return;
      }

      var mailInfo = {
        email: $scope.email,
        password: $scope.password,
        hosting_server: $scope.hosting_server
      };
      apiFactory.mailLogin(mailInfo).then(function (resp) {
        // vm.modalInstance.close(resp.data.data);
        var token = resp.data.token;
        localStorageService.set('mail-token', token);
        $state.go('appMailInbox');
      })["catch"](function (e) {
        $scope.errorLoginPage = true;
        Notification.error('Mail Login Failed.');
        $log.error(e);
      }); // vm.modalInstance.close(mailInfo);
    };

    $scope.onAddHost = function () {
      var createMailHostModal = $uibModal.open({
        animation: true,
        // size: 'sm',
        component: 'createMailHost',
        backdrop: 'static',
        keyboard: false
      });
      createMailHostModal.result.then(function (result) {
        $scope.hosts.push(result);
      }, function (reason) {
        $log.info(reason); // console.log(reason);
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail').component('mailInbox', {
    controller: MailInboxComponentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/inbox/inbox.view.html'
  });
  /** @ngInject */

  function MailInboxComponentController($scope, $location, $rootScope, $state, Notification, apiFactory, $log, localStorageService) {
    // const vm = this
    $scope.checked = 0;
    $scope.mails = [];
    $scope.limit = 10;
    $scope.page = 0;
    $scope.total = 0;
    $scope.selectedEmail = null;
    $scope.isDetail = false;
    $scope.isCompose = false;
    $scope.loading = false;
    $scope.seartchtxt = "";
    var token = localStorageService.get('mail-token');

    if (!token) {
      $state.go('appMailLogin');
    }

    $scope.stopSearch = true;

    $scope.searchInboxMails = function (params, limit, cnt) {
      if (limit === cnt || $scope.stopSearch === true) {
        return;
      } else {
        apiFactory.searchInboxMails(params).then(function (res) {
          $scope.loading = false;
          if ($scope.stopSearch === true) return;

          if (res.data.data.mails && Object.keys(res.data.data.mails).length === 0 && Object.getPrototypeOf(res.data.data.mails) === Object.prototype) {
            return;
          }

          if (cnt === 0) {
            $scope.mails = [res.data.data.mails];
          } else {
            $scope.mails.push(res.data.data.mails);
          }

          $scope.total = res.data.data.total;

          if ($scope.mails.length && res.data.data.total != 0) {
            if (cnt === 0) {
              $scope.onMailItemClick($scope.mails[0]);
            }

            params.uid = $scope.mails[$scope.mails.length - 1]['seqNo'] - 1;
            $scope.searchInboxMails(params, limit, cnt + 1);
          }
        })["catch"](function (err) {
          $log.error(err);

          if (err && err.data && err.data.data && err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
            localStorageService.set('mail-token', null);
            $state.go('appMailLogin');
          } // localStorageService.set('mail-token', null);
          // $state.go('appMailLogin');


          $scope.loading = false;
          Notification.error("Connection Failed");
        });
      }
    };

    $scope.getMails = function (params) {
      $scope.loading = true;
      apiFactory.getInboxMails(params).then(function (res) {
        $scope.loading = false;
        $scope.mails = $scope.mails.concat(res.data.data.mails);
        $scope.total = res.data.data.total;

        if ($scope.mails.length && !params) {
          $scope.onMailItemClick($scope.mails[0]);
        }
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.getMails();

    $scope.refreshMail = function () {
      var params = {
        page: 0,
        limit: $scope.page * $scope.limit,
        search: $scope.seartchtxt
      };
      $scope.loading = true;

      if (params.search) {
        $scope.stopSearch = false;
        $scope.searchInboxMails(params, 1000, 0);
      } else {
        $scope.stopSearch = true;
        apiFactory.getInboxMails(params).then(function (res) {
          $scope.loading = false;
          $scope.mails = res.data.data.mails;
          $scope.total = res.data.data.total;

          if ($scope.mails.length) {
            $scope.onMailItemClick($scope.mails[0]);
          }
        })["catch"](function (err) {
          $log.error(err);

          if (err && err.data && err.data.data && err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
            localStorageService.set('mail-token', null);
            $state.go('appMailLogin');
          } // localStorageService.set('mail-token', null);
          // $state.go('appMailLogin');


          $scope.loading = false;
          Notification.error("Connection Failed");
        });
      }
    };

    $scope.loadMore = function () {
      if ($scope.seartchtxt) {
        return;
      }

      if ($scope.total > $scope.mails.length) {
        if ($scope.loading) {
          return;
        }

        $scope.page++;
        var params = {
          page: $scope.page,
          limit: $scope.limit
        };
        $scope.getMails(params);
      }
    };

    $scope.onMailItemClick = function (item) {
      var data = {
        seqNo: item.seqNo,
        uid: item.uid,
        box: "Inbox"
      };
      $scope.loading = true;
      apiFactory.getMailDetails(data).then(function (res) {
        if (!item.flags.includes("\\Seen")) {
          item.flags.push("\\Seen");
          $rootScope.$emit('reduce_unseen_count');
        }

        $scope.selectedEmail = res.data.data;
        $scope.loading = false;
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.onCheckboxClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
    };

    $scope.onDetailsPaneClose = function () {};

    var mailComposeCallback = $rootScope.$on('mail-compose', function () {
      $scope.isDetail = true;
      $scope.isCompose = true;
    });
    $rootScope.$on('$destroy', mailComposeCallback);
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail').component('mailFolders', {
    controller: MailFolderComponentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/folders/folders.view.html'
  });
  /** @ngInject */

  function MailFolderComponentController($scope, $log, apiFactory, $rootScope, $location, $state, localStorageService, Notification) {
    // const vm = this
    $scope.checked = 0;
    $scope.mails = [];
    $scope.limit = 10;
    $scope.page = 0;
    $scope.total = 0;
    $scope.selectedEmail = null;
    $scope.isDetail = false;
    $scope.isCompose = false;
    $scope.loading = false;
    var token = localStorageService.get('mail-token');

    if (!token) {
      $state.go('appMailLogin');
    }

    $scope.getMails = function (params) {
      $scope.loading = true;
      apiFactory.getTrashMails(params).then(function (res) {
        $scope.loading = false;
        $log.info(res.data.data);
        $scope.mails = $scope.mails.concat(res.data.data.mails);
        $scope.total = res.data.data.total;

        if ($scope.mails.length && !params) {
          $scope.onMailItemClick($scope.mails[0]);
        }
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.getMails();

    $scope.refreshMail = function () {
      var params = {
        page: 0,
        limit: $scope.page * $scope.limit
      };
      $scope.loading = true;
      apiFactory.getTrashMails(params).then(function (res) {
        $scope.loading = false;
        $log.info(res.data.data);
        $scope.mails = res.data.data.mails;
        $scope.total = res.data.data.total;

        if ($scope.mails.length) {
          $scope.onMailItemClick($scope.mails[0]);
        }
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        } // localStorageService.set('mail-token', null);
        // $state.go('appMailLogin');


        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.loadMore = function () {
      if ($scope.loading) {
        return;
      }

      $scope.page++;
      var params = {
        page: $scope.page,
        limit: $scope.limit
      };
      $scope.getMails(params);
    };

    $scope.onMailItemClick = function (item) {
      var data = {
        seqNo: item.seqNo,
        box: "Trash"
      };
      $scope.loading = true;
      apiFactory.getMailDetails(data).then(function (res) {
        $scope.selectedEmail = res.data.data;
        $scope.loading = false;
      })["catch"](function (err) {
        $log.error(err); // if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
        //   localStorageService.set('mail-token', null);
        //   $state.go('appMailLogin');
        // }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.onCheckboxClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
    };

    $scope.onDetailsPaneClose = function () {};

    var mailCompose = $rootScope.$on('mail-compose', function () {
      $scope.isDetail = true;
      $scope.isCompose = true;
    });
    $rootScope.$on('$destroy', mailCompose);
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail').component('mailDraft', {
    controller: MailDraftComponentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/draft/draft.view.html'
  });
  /** @ngInject */

  function MailDraftComponentController($scope, $log, apiFactory, $location, $rootScope, $state, localStorageService) {
    // const vm = this
    $scope.checked = 0;
    $scope.mails = [];
    $scope.limit = 10;
    $scope.page = 0;
    $scope.total = 0;
    $scope.selectedEmail = null;
    $scope.isDetail = false;
    $scope.isCompose = false;
    $scope.loading = false;
    var token = localStorageService.get('mail-token');

    if (!token) {
      $state.go('appMailLogin');
    }

    $scope.getMails = function (params) {
      $scope.loading = true;
      apiFactory.getDraftMails(params).then(function (res) {
        $scope.loading = false;
        $log.info(res.data.data);
        $scope.mails = $scope.mails.concat(res.data.data.mails);
        $scope.total = res.data.data.total;

        if ($scope.mails.length && !params) {
          $scope.onMailItemClick($scope.mails[0]);
        }
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.getMails();

    $scope.refreshMail = function () {
      var params = {
        page: 0,
        limit: $scope.page * $scope.limit
      };
      $scope.loading = true;
      apiFactory.getDraftMails(params).then(function (res) {
        $scope.loading = false;
        $log.info(res.data.data);
        $scope.mails = res.data.data.mails;
        $scope.total = res.data.data.total;
        $rootScope.$emit('update_draft_count', $scope.total);

        if ($scope.mails.length) {
          $scope.onMailItemClick($scope.mails[0]);
        }
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        } // localStorageService.set('mail-token', null);
        // $state.go('appMailLogin');


        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.loadMore = function () {
      if ($scope.loading) {
        return;
      }

      $scope.page++;
      var params = {
        page: $scope.page,
        limit: $scope.limit
      };
      $scope.getMails(params);
    };

    $scope.onMailItemClick = function (item) {
      var data = {
        seqNo: item.seqNo,
        box: "Drafts"
      };
      $scope.loading = true;
      apiFactory.getMailDetails(data).then(function (res) {
        $scope.selectedEmail = res.data.data;
        $scope.loading = false;
      })["catch"](function (err) {
        $log.error(err);

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }

        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };

    $scope.onCheckboxClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
    };

    var mailCompose = $rootScope.$on('mail-compose', function () {
      $scope.isDetail = true;
      $scope.isCompose = true;
    });
    $rootScope.$on('$destroy', mailCompose);
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail').component('mailDetails', {
    controller: MailDetailComponentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/detail/detail.view.html',
    bindings: {
      onClose: "&",
      onMinimize: "&",
      onMailItemSelected: "&",
      onLoadMore: "&",
      refreshMail: "&",
      mails: "=",
      selectedEmail: "=",
      type: "@",
      isCompose: "=",
      search: "="
    }
  });
  /** @ngInject */

  function MailDetailComponentController($scope, $rootScope, globals, $state, $document, $log, $uibModal, localStorageService, apiFactory, $window) {
    var vm = this; // var colors = [
    //   "#FFB900",
    //   "#D83B01",
    //   "#B50E0E",
    //   "#E81123",
    //   "#B4009E",
    //   "#5C2D91",
    //   "#0078D7",
    //   "#00B4FF",
    //   "#008272",
    //   "#107C10"
    // ];

    $scope.mails = [];
    $scope.checked = 0;
    vm.selectedEmail = null;
    $scope.isCompose = false;
    $scope.mailLoading = false;
    $scope.isCollapse = false;
    vm.tagselected = true;
    vm.warnningtag = false;
    vm.personaltag = false;
    vm.worktag = false;
    vm.paymenttag = false;
    vm.projectdata = '';
    vm.tqdata = '';
    vm.isshared = true;
    vm.selected = false; // Compose Type: 0 - compose new mail, 1 - reply mail, 2 - forward mail

    $scope.composeType = 0;

    if (vm.type == "Drafts") {
      $scope.composeType = 3;
    }

    $scope.limit = 10;
    $scope.page = 0;
    $scope.total = 0;
    var token = localStorageService.get('mail-token');

    if (!token) {
      $state.go('appMailLogin');
    }

    vm.importanttag = false;

    this.$onInit = function () {
      $scope.mails = vm.mails;

      if (!vm.selectedEmail) {
        vm.selectedEmail = vm.mails[0];
      }

      if (vm.selectedEmail) {
        $scope.mailLoading = true;
        var data = {
          seqNo: vm.selectedEmail.seqNo,
          uid: vm.selectedEmail.uid,
          box: vm.type
        };
        apiFactory.getMailDetails(data).then(function (res) {
          if (!vm.selectedEmail.flags.includes("\\Seen")) {
            $rootScope.$emit('reduce_unseen_count');
          }

          vm.selectedEmail = res.data.data;
          $scope.splitemail();

          if (vm.selectedEmail.attachments && vm.selectedEmail.attachments.length) {
            for (var i = 0; i < vm.selectedEmail.attachments.length; i++) {
              var item = vm.selectedEmail.attachments[i];
              item.url = $scope.getBlobUrl(item);
            }
          }

          $scope.mailLoading = false;
        });
      }

      $scope.isCompose = vm.isCompose;
    };

    $scope.getBlobUrl = function (attachment) {
      var uint8array = new Uint8Array(attachment.content.data);
      var blob = new Blob([uint8array.buffer], {
        type: attachment.contentType
      });
      var url = URL.createObjectURL(blob);
      return url;
    };

    $scope.onMailItemClick = function (item) {
      var myDiv = $document[0].getElementById('message-content-wrap');
      myDiv.scrollTop = 0;
      $scope.mailLoading = true;
      var data = {
        seqNo: item.seqNo,
        uid: item.uid,
        box: vm.type
      };
      vm.selected = true;
      apiFactory.getMailDetails(data).then(function (res) {
        vm.selectedEmail = res.data.data;

        if (!item.flags.includes("\\Seen")) {
          item.flags.push("\\Seen");
          $rootScope.$emit('reduce_unseen_count');
        }

        if (vm.selectedEmail.attachments && vm.selectedEmail.attachments.length) {
          for (var i = 0; i < vm.selectedEmail.attachments.length; i++) {
            var _item = vm.selectedEmail.attachments[i];
            _item.url = $scope.getBlobUrl(_item);
          }
        }

        $scope.splitemail();
        $scope.mailLoading = false;
      })["catch"](function (err) {
        $scope.mailLoading = false;

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }
      }); // vm.onMailItemSelected({mail: item});

      $scope.isCompose = false;
    };

    $scope.showtag = function () {
      vm.tagselected = true;
    };

    $scope.hidetag = function () {
      vm.tagselected = false;
    };

    $scope.splitemail = function () {
      if (!vm.selectedEmail) return;
      var mailhtml = vm.selectedEmail.html;

      if (vm.selectedEmail.html) {
        var tagsignhtml = mailhtml.indexOf('<p>Project name:') > -1 ? mailhtml.substring(mailhtml.indexOf('<p>Project name:'), mailhtml.length) : '';

        if (tagsignhtml != '') {
          var signhtml = tagsignhtml.substring(tagsignhtml.indexOf('<img'), tagsignhtml.length);
          var taghtml = tagsignhtml.substring(0, tagsignhtml.indexOf('<img'));
          var contenthtml = mailhtml.substring(0, mailhtml.indexOf('<p>Project name:'));
          vm.htmlbody = vm.selectedEmail.html;
          vm.selectedEmail.html = contenthtml + signhtml;
          vm.importanttag = taghtml.indexOf("Important") > -1 ? true : false;
          vm.warnningtag = taghtml.indexOf("Warnning") > -1 ? true : false;
          vm.personaltag = taghtml.indexOf("Personal") > -1 ? true : false;
          vm.worktag = taghtml.indexOf("Work") > -1 ? true : false;
          vm.paymenttag = taghtml.indexOf("Payment") > -1 ? true : false;
          vm.projectdata = taghtml.substring(taghtml.indexOf("<p>Project name:") + 16, taghtml.indexOf("</p><p>Project Id:"));
          vm.projectid = taghtml.substring(taghtml.indexOf("<p>Project Id:") + 14, taghtml.indexOf("</p><p>TQ:"));
          vm.tqdata = taghtml.substring(taghtml.indexOf("<p>TQ:") + 6, taghtml.indexOf("</p><p>Tags"));
        } else {
          vm.htmlbody = vm.selectedEmail.html;
          vm.importanttag = false;
          vm.warnningtag = false;
          vm.personaltag = false;
          vm.worktag = false;
          vm.paymenttag = false;
          vm.projectdata = '';
          vm.tqdata = '';
        }
      } else {
        vm.selectedEmail.html = vm.selectedEmail.textAsHtml;
      }
    };

    var mailComposeCallback = $rootScope.$on('mail-compose', function () {
      $scope.isCompose = true;
      vm.selectedEmail = '';
    });
    var sideMenuCollapseCallback = $rootScope.$on('side-menu-collapse', function () {
      $scope.isCollapse = !$scope.isCollapse;
    });
    $rootScope.$on('$destroy', mailComposeCallback, sideMenuCollapseCallback);

    $scope.onCloseComposer = function () {
      $scope.isCompose = false;
      $scope.composeType = 0;
    };

    $scope.reply = function () {
      if (vm.selectedEmail) {
        $scope.isCompose = true;
        vm.selectedEmail.html = vm.htmlbody;
        $scope.composeType = 1;
      }
    };

    $scope.forward = function () {
      if (vm.selectedEmail) {
        $scope.isCompose = true;
        $scope.composeType = 2;
        vm.selectedEmail.html = vm.htmlbody;
      }
    };

    $scope.downloadAttachment = function (attachment) {
      var uint8array = new Uint8Array(attachment.content.data);
      var blob = new Blob([uint8array.buffer], {
        type: attachment.contentType
      });
      var fileName = attachment.filename;

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = $document[0].createElement('a'); // Browsers that support HTML5 download attribute

        if (angular.isDefined(link.download)) {
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', fileName);
          link.style.visibility = 'hidden';
          $document[0].body.appendChild(link);
          link.click();
          $document[0].body.removeChild(link);
        }
      }
    };

    $scope.printDiv = function () {
      $window.print();
    };

    $scope.deleteMail = function (mail) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          var uids = [mail.uid];
          var params = {
            uids: uids,
            box: vm.type
          };
          apiFactory.deleteMail(params).then(function () {
            vm.refreshMail();
          })["catch"](function (err) {
            $log.info(err);
          });
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.moveToTrash = function (mail) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: "Move To Trash",
              message: "Are you sure move to Trash?",
              subMessage: "Once moved to trash it can be restored."
            };
          }
        }
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $log.info(mail);
          var params;

          if (vm.type == 'Trash') {
            params = {
              uids: [mail.uid],
              box: vm.type
            };
            apiFactory.deleteMail(params).then(function () {
              vm.refreshMail();
            })["catch"](function (err) {
              $log.info(err);
            });
          } else {
            params = {
              uid: mail.uid,
              box: vm.type
            };
            apiFactory.moveToTrash(params).then(function () {
              vm.refreshMail();
            })["catch"](function (err) {
              $log.info(err);
            });
          }
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.addFlag = function (ev, mail) {
      ev.stopPropagation();
      var params = {
        uid: mail.uid,
        box: vm.type,
        flag: 'Flagged'
      };
      apiFactory.addFlag(params).then(function () {
        vm.mails.forEach(function (item, index) {
          if (item.uid == mail.uid) {
            vm.mails[index].flags.push("\\Flagged");
          }
        });
        vm.selectedEmail.flags.push("\\Flagged");
      })["catch"](function (err) {
        $log.info(err);
      });
    };

    $scope.deleteFlag = function (ev, mail) {
      ev.stopPropagation();
      var params = {
        uid: mail.uid,
        box: vm.type,
        flag: 'Flagged'
      };
      apiFactory.deleteFlag(params).then(function () {
        vm.mails.forEach(function (item, index) {
          if (item.uid == mail.uid) {
            var ind = vm.mails[index].flags.indexOf("\\Flagged");
            vm.mails[index].flags.splice(ind, 1);
          }
        });
        var index1 = vm.selectedEmail.flags.indexOf("\\Flagged");
        vm.selectedEmail.flags.splice(index1, 1);
      })["catch"](function (err) {
        $log.info(err);
      });
    };

    $scope.restore = function (mail) {
      if (vm.type != "Trash") {
        return;
      }

      var params = {
        uid: mail.uid,
        box: vm.type
      };
      apiFactory.restoreFromTrash(params).then(function () {
        // vm.mails.forEach((item, index) => {
        //   if (item.uid == mail.uid) {
        //     let ind = vm.mails[index].flags.indexOf("\\Flagged");
        //     vm.mails[index].flags.splice(ind, 1);
        //   }
        // });
        // let index1 = vm.selectedEmail.flags.indexOf("\\Flagged");
        // vm.selectedEmail.flags.splice(index1, 1);
        vm.refreshMail();
      })["catch"](function (err) {
        $log.info(err);
      });
    };

    $scope.loadMore = function () {
      vm.onLoadMore();
    };

    $scope.getColor = function (name) {
      return globals.getAvatarColor(name);
    };

    $scope.removeDot = function (name) {
      return name ? name.replace(/'/g, '').replace(/"/g, '') : '';
    };

    $scope.onSearchKeypress = function (e) {
      var keyCode = e.which || e.keyCode;

      if (keyCode === 13 && !e.ctrlKey) {
        e.preventDefault();
        vm.refreshMail();
      }
    }; // let filterTextTimeout = undefined;
    // $scope.$watch("vm.search", function() {
    //   if (filterTextTimeout) {
    //     $timeout.cancel(filterTextTimeout);
    //   }
    //   filterTextTimeout = $timeout(function() {
    //     if (vm.search && vm.search!='') {
    //       vm.refreshMail();
    //     }
    //   }, 500); // delay 500 ms
    // });


    $scope.$watch("vm.selectedEmail", function () {
      if (!vm.selected) {
        $scope.splitemail();
      }
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail').component('mailCompose', {
    controller: MailComposeComponentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/compose/compose.view.html',
    bindings: {
      onClose: "&",
      onMinimize: "&",
      refreshMail: "&",
      data: "=",
      type: "=",
      isDraft: "="
    }
  });
  /** @ngInject */

  function MailComposeComponentController(globals, $scope, $log, $state, $element, $uibModal, Notification, apiFactory, localStorageService, $window, utils) {
    var projectStore = globals.projectStore;
    var vm = this;
    $scope.checked = 0;
    $scope.isCc = false;
    $scope.isBcc = false;
    $scope.subject = '';
    $scope.message = '';
    vm.projectList = [{
      label: "PRJ1256",
      value: "PRJ1256"
    }, {
      label: "PRJ0716",
      value: "PRJ0716"
    }];
    /* Discipline */

    vm.discipList = [{
      label: 'Electrical',
      key: 'Electrical'
    }, {
      label: 'Plumbing',
      key: 'Plumbing'
    }, {
      label: 'Ventilation',
      key: 'Ventilation'
    }, {
      label: 'Architect',
      key: 'Architect'
    }, {
      label: 'Mechanical',
      key: 'Mechanical'
    }];
    vm.tags = [{
      label: 'Warnning',
      checked: false,
      "class": 'warnning',
      unclass: 'warnning-unselect',
      activeclass: 'warnning-unselect'
    }, {
      label: 'Personal',
      checked: false,
      "class": 'personal',
      unclass: 'personal-unselect',
      activeclass: 'personal-unselect'
    }, {
      label: 'Work',
      checked: false,
      "class": 'work',
      unclass: 'work-unselect',
      activeclass: 'work-unselect'
    }, {
      label: 'Payment',
      checked: false,
      "class": 'payment',
      unclass: 'payment-unselect',
      activeclass: 'payment-unselect'
    }];
    vm.importanttag = false;
    vm.tag = vm.tags[0].label;
    vm.tqDiscipline = 'Electrical';
    vm.tos = [];
    vm.ccs = [];
    vm.bccs = [];
    vm.attachCount = 0;
    vm.isSignature = true;
    vm.mailSignatureId = '';
    vm.responseData = {};
    vm.fileObjectUrl = '';
    vm.tqlist = [];
    vm.tqtitle = '';
    var token = localStorageService.get('mail-token');

    if (!token) {
      $state.go('appMailLogin');
    }

    $window.CKEDITOR.replace('message_area', {
      // Define the toolbar groups as it is a more accessible solution.
      toolbarGroups: [{
        name: 'document',
        groups: ['mode', 'document', 'doctools']
      }, {
        name: 'clipboard',
        groups: ['clipboard', 'undo']
      }, {
        name: 'editing',
        groups: ['find', 'selection', 'spellchecker', 'editing']
      }, {
        name: 'forms',
        groups: ['forms']
      }, {
        name: 'basicstyles',
        groups: ['basicstyles', 'cleanup']
      }, {
        name: 'paragraph',
        groups: ['align', 'list', 'indent', 'bidi', 'blocks', 'paragraph']
      }, {
        name: 'links',
        groups: ['links']
      }, {
        name: 'insert',
        groups: ['insert']
      }, {
        name: 'styles',
        groups: ['styles']
      }, {
        name: 'colors',
        groups: ['colors']
      }, {
        name: 'tools',
        groups: ['tools']
      }, {
        name: 'others',
        groups: ['others']
      }, {
        name: 'about',
        groups: ['about']
      }],
      // Remove the redundant buttons from toolbar groups defined above.
      removeButtons: 'Strike,Subscript,Superscript,Language,CreateDiv,CopyFormatting,RemoveFormat,Source,Save,NewPage,ExportPdf,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Anchor,Flash,HorizontalRule,SpecialChar,PageBreak,Iframe,BGColor,Styles,Maximize,ShowBlocks,About,SelectAll,Scayt'
    });
    var expression = $element.attr("data");
    $scope.$parent.$watch(expression, function (newVal) {
      if (!newVal) vm.type = 0;
      var newhtml = '';

      if (vm.type == 1 || vm.type == 2) {
        newhtml = $scope.getProjectAndTqData(newVal.html ? newVal.html : newVal.text);
      } else {
        vm.projectdata = '';
        vm.tqdata = '';
        vm.projectid = '';
      }

      if (vm.type == 1) {
        vm.tos = [newVal.from.value[0].address];
        vm.ccs = newVal.cc ? [newVal.cc.value[0].address] : [];
        $scope.subject = 'Re: ' + newVal.subject;
        $scope.message = newhtml;
      } else if (vm.type == 2) {
        $scope.subject = 'Forward: ' + newVal.subject;
        $scope.message = newhtml;
      } else {
        if (newVal && newVal.to && newVal.to.value[0].address) {
          vm.tos = [newVal.to.value[0].address];
        } else {
          vm.tos = [];
        }

        $scope.subject = newVal ? newVal.subject : '';
        $scope.message = newVal ? newVal.html ? newVal.html : newVal.text : '';
        $window.CKEDITOR.instances.message_area.setData("");
      }
    });
    $scope.$on('onProjectChanged', function () {
      vm.selectedProject = projectStore.get();
      $scope.changetqDiscipline(vm.tqDiscipline);
    });

    this.$onInit = function () {
      vm.selectedProject = projectStore.get();

      if (vm.type == 0) {
        $scope.changetqDiscipline(vm.tqDiscipline);
      }

      vm.isDraft = vm.isDraft ? true : false;

      if (vm.data) {
        var newhtml = '';

        if (vm.type == 1 || vm.type == 2) {
          newhtml = $scope.getProjectAndTqData(vm.data.html ? vm.data.html : vm.data.text);
        } else {
          vm.projectdata = '';
          vm.tqdata = '';
          vm.projectid = '';
        }

        if (vm.type == 1) {
          vm.tos = [vm.data.from.value[0].address];
          $scope.subject = 'Re: ' + vm.data.subject;
          $scope.message = newhtml; //vm.data.html ? vm.data.html : vm.data.text;
        } else if (vm.type == 2) {
          $scope.subject = 'Forward: ' + vm.data.subject;
          $scope.message = newhtml; //vm.data.html ? vm.data.html : vm.data.text;
        } else {
          if (vm.data.to.value[0].address) {
            vm.tos = [vm.data.to.value[0].address];
          }

          $scope.subject = vm.data.subject;
          $scope.message = vm.data.html ? vm.data.html : vm.data.text;
        }
      }

      apiFactory.getUserMailSignatures().then(function (res) {
        var data = res.data.data;

        if (data.length) {
          vm.mailSignatureId = data[0]._id;
          apiFactory.getMailSignature(vm.mailSignatureId).then(function (sign) {
            var signData = sign.data.data;
            vm.responseData = signData;
            vm.fileObjectUrl = signData.image.url;
            $scope.isLoading = false;
          });
        }
      });
    };

    $scope.changetqDiscipline = function (deiscipline) {
      $scope.isLoading = true;
      apiFactory.getTqListByProjectId({
        projectId: vm.selectedProject._id,
        discipline: deiscipline
      }).then(function (resp) {
        vm.tqlist = resp.data.list.length > 0 ? resp.data.list : null;

        if (vm.type == 1 || vm.type == 2) {
          if (vm.tqdata != '') {
            vm.deiscipline = vm.tqdata.split("-")[0];
            vm.tqtitle = vm.tqdata.split("-")[1]; // vm.type = 0;
          }
        } else {
          vm.tqtitle = vm.tqlist == null ? '' : vm.tqlist[0].title;
        }
      })["catch"](function (e) {
        $scope.isLoading = false;
        $log.error(e);
      });
    };

    $scope.selecttag = function (tag) {
      tag.checked = tag.checked ? false : true;
      tag.activeclass = tag.checked ? tag["class"] : tag.unclass;
    };

    $scope.changetag = function (tag) {
      tag.checked = tag.checked ? false : true;
    };

    $scope.addimportanttag = function () {
      vm.importanttag = true;
    };

    $scope.deleteimportanttag = function () {
      vm.importanttag = false;
    };

    $scope.onKeyupMessage = function (e) {
      var el = e.target;
      el.style.height = "1px";
      el.style.height = 20 + el.scrollHeight + "px";
    };

    $scope.onKeyupSendto = function (e) {
      if (e.keyCode == 13 && $scope.to && $scope.to != '') {
        var dupItem = vm.tos.find(function (item) {
          return item == $scope.to;
        });

        if (!dupItem) {
          vm.tos.push($scope.to);
        }

        $scope.to = '';
      }
    };

    $scope.onBlurSendto = function () {
      var dupItem = vm.tos.find(function (item) {
        return item == $scope.to;
      });

      if (!dupItem && $scope.to && $scope.to != '') {
        vm.tos.push($scope.to);
      }

      $scope.to = '';
    };

    $scope.onKeyupCc = function (e) {
      if (e.keyCode == 13 && vm.cc && vm.cc != '') {
        var dupItem = vm.ccs.find(function (item) {
          return item == vm.cc;
        });

        if (!dupItem) {
          vm.ccs.push(vm.cc);
        }

        vm.cc = '';
      }
    };

    $scope.onBlurCc = function () {
      var dupItem = vm.ccs.find(function (item) {
        return item == vm.cc;
      });

      if (!dupItem && vm.cc && vm.cc != '') {
        vm.ccs.push(vm.cc);
      }

      vm.cc = '';
    };

    $scope.onKeyupBcc = function (e) {
      if (e.keyCode == 13 && vm.bcc && vm.bcc != '') {
        var dupItem = vm.bccs.find(function (item) {
          return item == vm.bcc;
        });

        if (!dupItem) {
          vm.bccs.push(vm.bcc);
        }

        vm.bcc = '';
      }
    };

    $scope.onBlurBcc = function () {
      var dupItem = vm.bccs.find(function (item) {
        return item == vm.bcc;
      });

      if (!dupItem && vm.bcc && vm.bcc != '') {
        vm.bccs.push(vm.bcc);
      }

      vm.bcc = '';
    };

    $scope.removeSignature = function () {
      vm.isSignature = false;
    };

    $scope.removeToItem = function (item) {
      var index = vm.tos.indexOf(item);
      vm.tos.splice(index, 1);
    };

    $scope.removeCcItem = function (item) {
      var index = vm.ccs.indexOf(item);
      vm.ccs.splice(index, 1);
    };

    $scope.removeBccItem = function (item) {
      var index = vm.bccs.indexOf(item);
      vm.bccs.splice(index, 1);
    };

    $scope.onClose = function () {
      if (vm.isDraft) {
        $scope.moveToTrash(vm.data);
      } else {
        var confirmModal = $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function data() {
              return {
                title: 'Save Draft',
                message: 'Are you want to save as a draft?'
              };
            }
          }
        });
        confirmModal.result.then(function (result) {
          if (result) {
            var data = {
              tos: vm.tos,
              ccs: vm.ccs,
              bccs: vm.bccs,
              subject: $scope.subject,
              message: $scope.message
            };
            apiFactory.saveDraftMail(data).then(function () {
              vm.onClose();
            })["catch"](function (err) {
              $log.info(err);
              Notification.error("Save as draft failed");
            });
          }
        }, function (reason) {
          vm.onClose();
          $log.info(reason);
        });
      }
    };

    $scope.getProjectAndTqData = function (_html) {
      var mailhtml = _html;
      var retmailbody = '';
      var tagsignhtml = mailhtml.indexOf('<p>Project name:') > -1 ? mailhtml.substring(mailhtml.indexOf('<p>Project name:'), mailhtml.length) : '';

      if (tagsignhtml != '') {
        var signhtml = tagsignhtml.substring(tagsignhtml.indexOf('<img'), tagsignhtml.length);
        var taghtml = tagsignhtml.substring(0, tagsignhtml.indexOf('<img'));
        var contenthtml = mailhtml.substring(0, mailhtml.indexOf('<p>Project name:'));
        retmailbody = contenthtml + signhtml;
        vm.importanttag = taghtml.indexOf("Important") > -1 ? true : false;
        vm.warnningtag = taghtml.indexOf("Warnning") > -1 ? true : false;
        vm.personaltag = taghtml.indexOf("Personal") > -1 ? true : false;
        vm.worktag = taghtml.indexOf("Work") > -1 ? true : false;
        vm.paymenttag = taghtml.indexOf("Payment") > -1 ? true : false;
        vm.projectdata = taghtml.substring(taghtml.indexOf("<p>Project name:") + 16, taghtml.indexOf("</p><p>Project Id:"));
        vm.projectid = taghtml.substring(taghtml.indexOf("<p>Project Id:") + 14, taghtml.indexOf("</p><p>TQ:"));
        if (taghtml.indexOf("<p>Project Id:") == -1) vm.projectid = '';
        vm.tqdata = taghtml.substring(taghtml.indexOf("<p>TQ:") + 6, taghtml.indexOf("</p><p>Tags"));
        if (taghtml.indexOf("<p>TQ:") == -1) vm.tqdata = '';

        if (vm.projectid != '') {
          Promise.all([apiFactory.getProjectById(vm.projectid)]).then(function (resp) {
            projectStore.set(resp[0].data);
          })["catch"](function (err) {
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }
      } else {
        retmailbody = _html;
        vm.importanttag = false;
        vm.warnningtag = false;
        vm.personaltag = false;
        vm.worktag = false;
        vm.paymenttag = false;
        vm.projectdata = '';
        vm.tqdata = '';
        vm.projectid = '';
      }

      return retmailbody;
    };

    $scope.sendEmail = function () {
      if (!vm.tos.length) {
        Notification.error('Please input emails to send mail');
        return;
      }

      if (!$scope.subject && !$scope.message) {
        Notification.error('Please input subject or message');
        return;
      }

      var additionaldata = '';
      additionaldata = '<p>Project name:' + vm.selectedProject.projectName + '(' + vm.selectedProject.systemTag + ')</p>';
      additionaldata += '<p>Project Id:' + vm.selectedProject._id + '</p>';
      additionaldata += '<p>TQ:' + vm.tqDiscipline + '-' + vm.tqtitle + '</p>';
      additionaldata += '<p>Tags:' + (vm.importanttag ? 'Important&nbsp;&nbsp;' : '');

      for (var i = 0; i < vm.tags.length; i++) {
        additionaldata += vm.tags[i].checked ? vm.tags[i].label + '&nbsp;&nbsp;' : '';
      }

      additionaldata += '</p>'; // $log.info(additionaldata);return;

      var signatureContent = '<img src="' + vm.fileObjectUrl + '"/></div>';
      var data = {
        tos: vm.tos,
        ccs: vm.ccs,
        bccs: vm.bccs,
        subject: $scope.subject,
        // message: $scope.message,
        message: $window.CKEDITOR.instances.message_area.getData() + additionaldata + signatureContent,
        attachments: vm.attachedFiles
      };

      if (vm.isDraft) {
        data.uid = vm.data.uid;
      }

      apiFactory.sendEmail(data).then(function () {
        Notification.success("Sent");

        if (vm.isDraft) {
          vm.refreshMail();
        } else {
          vm.onClose();
        }
      })["catch"](function (err) {
        Notification.error("Failed");

        if (err && err.data && err.data.data && err.data.data.name == 'TokenExpiredError') {
          localStorageService.set('mail-token', null);
          $state.go('appMailLogin');
        }
      });
    };

    $scope.moveToTrash = function (mail) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $log.info(mail);
          var params;
          params = {
            uid: mail.uid,
            box: 'Drafts'
          };
          apiFactory.moveToTrash(params).then(function () {
            vm.refreshMail();
          })["catch"](function (err) {
            $log.info(err);
          });
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.removeFile = function (index) {
      vm.attachedFiles = vm.attachedFiles.filter(function (item, _index) {
        return _index !== index;
      });
      vm.arrFilesUrl = vm.arrFilesUrl.filter(function (item, _index) {
        return _index !== index;
      });
      vm.attachCount--;
    };

    $scope.removeAll = function () {
      if (!vm.attachCount) {
        var confirmModal = $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function data() {
              return {
                title: 'Warning',
                message: 'No attachment to remove.',
                subMessage: 'Select the attachments using Attach File button.',
                confirmButtonText: 'Ok',
                icon: '/assets/icons/status-warning.svg'
              };
            }
          }
        });
        confirmModal.result.then(function () {
          return;
        });
      } else {
        $uibModal.open({
          animation: true,
          component: 'alertModal',
          size: 'sm',
          resolve: {
            title: function title() {
              return 'Warning';
            },
            message: function message() {
              return 'Do you want to remove all?';
            }
          }
        }).result.then(function () {
          vm.attachedFiles = [];
          vm.attachCount = 0;
          vm.arrFilesUrl = [];
        });
      }
    };

    vm.attachedFiles = [];
    vm.arrFilesUrl = [];

    vm.fileUpdated = function (files) {
      if (files && files.length) {
        var file = files[0];
        var existFile = vm.attachedFiles.filter(function (x) {
          return x.name === file.name;
        });

        if (existFile.length) {
          var confirmModal = $uibModal.open({
            animation: true,
            component: 'confirmModal',
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              data: function data() {
                return {
                  title: 'Warning',
                  message: 'Attach files duplicated.',
                  subMessage: 'Select another file.',
                  confirmButtonText: 'Ok',
                  icon: '/assets/icons/status-warning.svg'
                };
              }
            }
          });
          confirmModal.result.then(function () {
            return;
          });
        } else {
          vm.arrFilesUrl.push(URL.createObjectURL(file));
          vm.attachedFiles = vm.attachedFiles.concat(files);
          vm.attachCount = vm.attachedFiles.length;
        }
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('issuesMarking', {
    controller: issuesMarkingController,
    controllerAs: 'vm',
    templateUrl: 'app/main/issues/issues-marking/issues-marking.view.html'
  });
  /** @ngInject */

  function issuesMarkingController($scope, $timeout, localStorageService, $state, apiFactory, Bim, VP, $document, $log, globals) {
    var vm = this;
    $scope.is3D = false;
    $scope.isOnly3D = false;
    vm.viewer3d = undefined;
    vm.viewer2d = undefined;
    vm.levelId = undefined;
    var showLoadingCount = 0;

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.onCancel = function () {
      if (vm.issueData.editMode) {
        $state.go('editIssue');
      } else {
        $state.go('createIssue');
      }
    };

    $scope.onContinue = function () {
      if (vm.viewer3d) {
        vm.viewer3d.disableControl();
        vm.viewer3d.invalidate();
      }

      save();
    };

    $scope.addMarker = function () {
      if ($scope.is3D) {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.addMarker();
        }
      } else {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
          vm.viewer2d.addMarker();
        }
      }
    };

    $scope.removeMarker = function () {
      if ($scope.is3D) {
        if (vm.viewer3d) {
          vm.viewer3d.removeMarker();
        }
      } else {
        if (vm.viewer2d) {
          vm.viewer2d.removeMarker();
        }
      }
    };

    $scope.viewTypeChanged = function () {
      if ($scope.is3D) {
        angular.element('#marking-viewer-3d').css('visibility', 'visible');
        angular.element('#marking-viewer-2d').css('visibility', 'hidden');
      } else {
        angular.element('#marking-viewer-3d').css('visibility', 'hidden');
        angular.element('#marking-viewer-2d').css('visibility', 'visible');
      }
    };

    vm.addCutter = function () {
      vm.viewer3d.addCrossSection();
    };

    vm.removeCutter = function () {
      vm.viewer3d.removeCrossSection();
    };

    vm.hasCutter = function () {
      return vm.viewer3d.hasClipping();
    };

    function initData() {
      vm.issueData = localStorageService.get('issueData');
      var bimModelId = vm.issueData.marker && vm.issueData.marker.info3d && vm.issueData.marker.info3d.modelId ? vm.issueData.marker.info3d.modelId : null;
      vm.levelId = vm.issueData.marker && vm.issueData.marker.info3d && vm.issueData.marker.info3d.level ? vm.issueData.marker.info3d.level : null;

      if (angular.isUndefined(vm.issueData.drawings)) {
        vm.issueData.drawings = [];
      }

      if (angular.isDefined(bimModelId)) {
        if (vm.issueData.marker.modelType === '3d') {
          showLoading(true);
          apiFactory.get3dModel(bimModelId).then(function (resp) {
            showLoading(false);

            if (resp.data.data) {
              vm.viewer3d = Bim.markingViewer($document[0].getElementById('marking-viewer-3d'));
              vm.viewer3d.initialize();
              vm.viewer3d.loadBim(resp.data.data).then(function () {
                if (angular.isDefined(vm.levelId) && vm.levelId !== 'All') {
                  vm.viewer3d.showObject(vm.levelId);
                  loadPlan(vm.viewer3d.getBimModel(), vm.levelId);
                }

                if (vm.issueData.marker.info3d.location.x) {
                  vm.viewer3d.loadMarkers([vm.issueData.marker.info3d.location]);
                } else {
                  vm.viewer3d.loadMarkers([]);
                }

                if (vm.issueData.marker.info3d.clipping) {
                  vm.viewer3d.loadClipping(vm.issueData.marker.info3d.clipping);
                }
              })["catch"](function (err) {
                $log.error(err);
              });
              vm.viewer3d.on('markerPlaced', markerPlaced);
              vm.viewer3d.on('markerRemoved', markerRemoved);
              vm.viewer3d.on('clippingAdded', clippingAdded);
            }
          })["catch"](function (e) {
            showLoading(false);
            $log.error(e);
          });
        } else {
          showLoading(true);
          var planUrl = vm.issueData.marker.info3d.url;
          var pageNo = vm.issueData.marker.info3d.pageNo;
          vm.viewer2d = VP.markingViewer(angular.element('#marking-viewer-2d')[0]);
          vm.viewer2d.loadBackgroundImageWidthHD(planUrl, pageNo).then(function () {
            if (vm.issueData.marker.info3d.location && vm.issueData.marker.info3d.location.x) {
              vm.viewer2d.loadMarkers([vm.issueData.marker.info3d.location]);
            }

            showLoading(false);
          })["catch"](function (err) {
            showLoading(false);
            $log.error(err);
          });
        }
      }

      $scope.isOnly3D = false;

      if (vm.issueData.marker.modelType === '3d' && (!vm.levelId || vm.levelId === 'All')) {
        $scope.isOnly3D = true;
        $scope.is3D = true;
      }
    }

    initData();

    function showLoading(show) {
      showLoadingCount += show ? 1 : -1;

      if (showLoadingCount === 1) {
        angular.element('#loading').css('display', 'flex');
      } else if (showLoadingCount === 0) {
        angular.element('#loading').hide();
      }
    }

    function loadPlan(bimModel, levelId) {
      showLoading(true);
      vm.viewer2d = Bim.planViewer($document[0].getElementById('marking-viewer-2d'));
      vm.viewer2d.initialize();
      vm.viewer2d.loadBimModel(bimModel, levelId).then(function () {
        showLoading(false);

        if (vm.issueData.marker.info2d && vm.issueData.marker.info2d.location && vm.issueData.marker.info2d.location.x) {
          vm.viewer2d.loadMarkers([vm.issueData.marker.info2d.location]);
        } else {
          vm.viewer2d.loadMarkers([]);
        }
      })["catch"](function (err) {
        showLoading(false);
        $log.error(err);
      });
      vm.viewer2d.on('markerPlaced', markerPlaced);
      vm.viewer2d.on('markerRemoved', markerRemoved);
    }

    function markerPlaced(is3d, markerPos) {
      if (!vm.levelId || vm.levelId === 'All') return;

      if (is3d) {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
          var pos = vm.viewer3d.get2dPos(markerPos, vm.levelId);

          if (pos) {
            vm.viewer2d.placeMarker(pos);
          }
        }
      } else {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.placeMarker(markerPos, vm.levelId);
        }
      }
    }

    function markerRemoved(is3d) {
      if (is3d) {
        if (vm.viewer2d) {
          vm.viewer2d.removeAllMarkers();
        }
      } else {
        if (vm.viewer3d) {
          vm.viewer3d.removeAllMarkers();
          vm.viewer3d.invalidate();
        }
      }
    }

    function clippingAdded() {
      $scope.$apply();
    }

    function save() {
      var canvas;

      if (vm.issueData.marker.modelType === '3d') {
        if (vm.viewer3d) {
          vm.issueData.marker.info3d.location = vm.viewer3d.getMarkers()[0];

          if (vm.issueData.marker.info3d.location) {
            canvas = $document[0].getElementById("marking-viewer-3d").childNodes[0];
            var image3D = canvas.toDataURL("image/jpg");
            vm.issueData.drawings.push({
              image3D: image3D
            });
          }

          vm.issueData.marker.info3d.clipping = vm.viewer3d.getClipping();
        }

        if (vm.viewer2d) {
          if (!vm.issueData.marker.info2d) {
            vm.issueData.marker.info2d = {
              location: {
                x: 0,
                y: 0
              }
            };
          }

          vm.issueData.marker.info2d.location = vm.viewer2d.getMarkers()[0];

          if (vm.issueData.marker.info2d.location) {
            var image2D = vm.viewer2d.takeImage();
            vm.issueData.drawings.push({
              image2D: image2D
            });
          }
        }
      } else {
        vm.issueData.marker.info3d.location = vm.viewer2d.getMarkers()[0];

        if (vm.issueData.marker.info3d.location) {
          var _image2D = vm.viewer2d.takeImage();

          vm.issueData.drawings.push({
            image3D: _image2D
          });
        }

        delete vm.issueData.marker.info2d;
      }

      localStorageService.set('issueData', vm.issueData);
      $state.go('createIssue');
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('issuesList', {
    controller: IssuesListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/issues/issues-list/issues-list.view.html'
  });
  /** @ngInject */

  function IssuesListController($scope, localStorageService, $state, globals, apiFactory, $log, Notification, utils) {
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore;
    /* Get project */

    vm.project = projectStore.get();
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    $scope.ISSUE_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.ISSUE_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.ISSUE]})
    //     .then(res => {
    //       $scope.loading = false;
    //       $scope.ISSUE_ACCESS_CREATE = res.data.data[Constants.AccessKey.ISSUE];
    //     })
    //     .catch((e) => {
    //       $scope.loading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.issues = [];
    vm.usersList = [];
    $scope.maxShowUsers = 4;
    $scope.isList = false;
    $scope.isGrid = true;

    $scope.onListView = function () {
      $scope.isGrid = false;
      $scope.isList = true;
    };

    $scope.onGridView = function () {
      $scope.isGrid = true;
      $scope.isList = false;
    };

    $scope.searchTextList = [];
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.totalCount = 0; // $scope.numPerPage = globals.numPerPage();

    $scope.numPerPage = 12;
    $scope.totalPages = 0;
    vm.currentPage = 1;
    $scope.loading = false;

    $scope.searchIssues = function () {
      if ($scope.searchText && utils.isEmpty($scope.searchTextList)) {
        $scope.searchTextList.push($scope.searchText);
      }

      $scope.loading = true;
      apiFactory.listAllIssues({
        projectId: vm.project._id,
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: "updatedAt",
        sortType: "false",
        search: $scope.searchText
      }).then(function (resp) {
        $scope.loading = false;
        $scope.totalCount = resp.data.total;
        vm.issues = resp.data.list || [];
        $scope.totalPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);

        if (e.status === 403) {
          Notification.error(e.data.message);
          $state.go(globals.getDashboardRoute(vm.userData));
        }
      });
    };

    $scope.searchIssues();

    $scope.removeSearchText = function (index) {
      $scope.searchTextList.splice(index, 1);
      $scope.searchText = "";
      $scope.searchIssues();
    };

    $scope.onCreateIssue = function () {
      localStorageService.set('issueData', {});
      $state.go('createIssue');
    };

    $scope.goToDetail = function (issueId) {
      $state.go('issueDetail', {
        id: issueId
      });
    };

    $scope.getIssueStatusClass = function (status) {
      switch (status) {
        case 'Open':
          return {
            'open': true
          };

        case 'Resolved':
          return {
            'resolved': true
          };

        case 'Completed':
          return {
            'completed': true
          };

        default:
          return {
            'on-hold': true
          };
      }
    };

    $scope.getIssuePriorityClass = function (priority) {
      switch (priority) {
        case 'High':
          return {
            'high': true
          };

        case 'Medium':
          return {
            'medium': true
          };

        case 'Low':
          return {
            'low': true
          };

        case 'On Hold':
          return {
            'on-hold': true
          };

        default:
          return {
            'on-hold': true
          };
      }
    };

    $scope.labelChecked = false;

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      vm.issues.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('issueDetail', {
    controller: IssueDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/issues/issue-detail/issue-detail.view.html'
  });
  /** @ngInject */

  function IssueDetailController($scope, $state, $stateParams, $log, $uibModal, localStorageService, apiFactory, authFactory, globals, utils, Notification) {
    var vm = this;
    var logout = globals.logout,
        userStore = globals.userStore;

    if (!authFactory.checkUser()) {
      logout();
      return;
    }

    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.ISSUE_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.ISSUE_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.ISSUE]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.ISSUE_ACCESS_CREATE = res.data.data[Constants.AccessKey.ISSUE];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.issue = {};
    $scope.userList = ['8/10-Protector', 'Commision', '3/10-Flexible', 'Handle Over'];
    $scope.currentTab = 'Conversations';
    $scope.is3D = false; // let showLoadingCount = 0;

    $scope.loading = false;
    /* priority */

    $scope.priorityList = [{
      label: 'High',
      value: 'High'
    }, {
      label: 'Medium',
      value: 'Medium'
    }, {
      label: 'Low',
      value: 'Low'
    }];
    /* status */

    $scope.statusList = [{
      label: 'Open',
      value: 'Open'
    }, {
      label: 'On Hold',
      value: 'On Hold'
    }, {
      label: 'Resolved',
      value: 'Resolved'
    }];

    $scope.getIssueStatusClass = function (status) {
      switch (status) {
        case 'Open':
          return {
            'open': true
          };

        case 'Resolved':
          return {
            'resolved': true
          };

        case 'Completed':
          return {
            'completed': true
          };

        default:
          return {
            'on-hold': true
          };
      }
    };

    $scope.getIssuePriorityClass = function (priority) {
      switch (priority) {
        case 'High':
          return {
            'high': true
          };

        case 'Medium':
          return {
            'medium': true
          };

        case 'Low':
          return {
            'low': true
          };

        case 'On Hold':
          return {
            'on-hold': true
          };

        default:
          return {
            'on-hold': true
          };
      }
    };

    var LOAD_COUNT_PER_TIME = 3;
    $scope.loadCount = LOAD_COUNT_PER_TIME;
    vm.issueId = $stateParams.id;

    $scope.loadMore = function () {
      $scope.loadCount += LOAD_COUNT_PER_TIME;
    };

    $scope.switchTab = function (tab) {
      $scope.currentTab = tab;
    };
    /* issue conversations */


    function remakeIssueActivities() {
      var activities = {};
      $scope.activities = [];

      var _iterator = _createForOfIteratorHelper($scope.issue.issueActivity),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var activity = _step.value;
          var dt = moment(activity.addedTime).format('DD MMM YYYY');

          if (utils.isEmpty(activities[dt])) {
            activities[dt] = [activity];
          } else {
            activities[dt].push(activity);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      Object.keys(activities).forEach(function (key) {
        var value = activities[key];
        $scope.activities.push({
          date: key,
          list: value
        });
      });
    }

    $scope.issueImageByType = function (file) {
      var imageViewerModal = $uibModal.open({
        animation: true,
        component: 'imageViewerModal',
        backdrop: 'static',
        keyboard: true,
        windowClass: 'file-viewer-modal',
        windowTopClass: 'file-viewer-modal-wrapper',
        resolve: {
          imageURL: function imageURL() {
            return file.secure_url;
          }
        }
      });
      imageViewerModal.result.then(function () {}, function (reason) {
        $log.log(reason);
      });
    };

    $scope.issueModelImageByType = function (issue) {
      var _imageURL;

      if (issue.marker.modelType !== '3d') {
        _imageURL = issue.image3DPath;
      } else if (issue.marker.modelType === '3d') {
        if ($scope.is3D) {
          _imageURL = issue.image3DPath;
        } else if (!$scope.is3D) {
          _imageURL = issue.image2DPath;
        }
      }

      var imageViewerModal = $uibModal.open({
        animation: true,
        component: 'imageViewerModal',
        backdrop: 'static',
        keyboard: true,
        windowClass: 'file-viewer-modal',
        windowTopClass: 'file-viewer-modal-wrapper',
        resolve: {
          imageURL: function imageURL() {
            return _imageURL;
          }
        }
      });
      imageViewerModal.result.then(function () {}, function (reason) {
        $log.log(reason);
      });
    };

    $scope.editIssue = function () {
      var issueData = $scope.issue; // issueData.admin = issueData.admin._id;

      if (issueData.assignedTo && issueData.assignedTo.length > 0) {
        issueData.assignedTo = issueData.assignedTo[0]._id;
      }

      issueData.step = 1;
      issueData.editMode = true;
      localStorageService.set('issueData', issueData);
      $state.go('editIssue');
    };

    $scope.exportPdf = function () {
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        $scope.isLoading = true;
        apiFactory.exportIssueAsPDF(vm.issueId).then(function (resp) {
          var url = resp.data.data;
          var pos = result.lastIndexOf(".");
          var fileName = result.substr(0, pos < 0 ? result.length : pos) + ".pdf";
          utils.downloadFile(url, fileName).then(function () {
            return $scope.isLoading = false;
          })["catch"](function (err) {
            $log.error(err);
            $scope.isLoading = false;
            Notification.error('Failed to export.');
          });
        })["catch"](function (err) {
          $log.error(err);
          Notification.error('Failed to export.');
          $scope.isLoading = false;
        });
      });
    };

    $scope.deleteIssue = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.loading = true;
          apiFactory.deleteIssue(vm.issueId).then(function (res) {
            $scope.loading = false;
            Notification.success(res.data.message);
            $state.go('issuesList');
          })["catch"](function (e) {
            $scope.loading = false;
            $log.error(e);
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.hasModel = function () {
      return $scope.issue.vp || $scope.issue.m3d;
    };

    $scope.viewTypeChanged = function () {
      $scope.is3D = !$scope.is3D;
    };

    $scope.markIssueAsComplete = function () {
      $scope.loading = true;
      apiFactory.saveIssueAsComplete(vm.issueId).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        $scope.statusList.push({
          label: 'Closed',
          value: 'Completed'
        });
        $scope.issue.status = 'Completed';
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
      });
    };

    $scope.updateIssueStatusOrPriority = function () {
      $scope.loading = true;
      apiFactory.updateIssueStatusOrPriority(vm.issueId, {
        status: $scope.issue.status,
        priority: $scope.issue.priority
      }).then(function (res) {
        $scope.loading = false;
        $scope.issue.status = res.data.data.status;
        $scope.issue.priority = res.data.data.priority;
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
      });
    };

    function initData() {
      $scope.loading = true;
      apiFactory.getIssueById(vm.issueId).then(function (res) {
        $scope.loading = false;
        $scope.issue = res.data.data;

        if ($scope.issue.status === 'Completed') {
          $scope.statusList.push({
            label: 'Closed',
            value: 'Completed'
          });
        }

        if ($scope.issue.marker) {
          $scope.issue.marker = $scope.issue.marker.model;

          if ($scope.issue.marker.info3d && $scope.issue.marker.info3d.image && $scope.issue.marker.info3d.image.secure_url) {
            $scope.issue.image3DPath = $scope.issue.marker.info3d.image.secure_url;
          }

          if ($scope.issue.marker.info2d && $scope.issue.marker.info2d.image && $scope.issue.marker.info2d.image.secure_url) {
            $scope.issue.image2DPath = $scope.issue.marker.info2d.image.secure_url;
          }
        }

        if (!$scope.issue) {
          Notification.error('Can not find the issue.');
          $state.go('issuesList');
          return;
        } // $scope.assignedTo = $scope.issue.assignedTo.map(a => "<img src='"+a.profilePic+"' />").join(' ');


        remakeIssueActivities();
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
      });
    }

    initData();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('createIssue', {
    controller: CreateIssueController,
    controllerAs: 'vm',
    templateUrl: 'app/main/issues/create-issue/create-issue.view.html'
  });
  /** @ngInject */

  function CreateIssueController($scope, $state, $log, localStorageService, authFactory, apiFactory, Bim, VP, Notification, globals, utils) {
    var vm = this;
    var logout = globals.logout,
        projectStore = globals.projectStore,
        userStore = globals.userStore;

    if (!authFactory.checkUser()) {
      logout();
      return;
    }
    /* project */


    vm.project = projectStore.get();
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    if (utils.isEmpty(vm.project)) {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }
    /* issueCategory */


    $scope.categoryList = [{
      label: 'Safety',
      key: 'Safety'
    }, {
      label: 'Quality',
      key: 'Quality'
    }, {
      label: 'Issue',
      key: 'Issue'
    }];
    $scope.m3dLevelList = [];
    /* priority */

    $scope.priorityList = [{
      label: 'High',
      key: 'High'
    }, {
      label: 'Medium',
      key: 'Medium'
    }, {
      label: 'Low',
      key: 'Low'
    }];
    /* status */

    $scope.statusList = [{
      label: 'Open',
      key: 'Open'
    }, {
      label: 'On Hold',
      key: 'On Hold'
    }, {
      label: 'Resolved',
      key: 'Resolved'
    }];
    vm.selected3dModel = undefined;

    $scope.checkValidation = function () {
      var ret = {
        success: true,
        errorMsg: ''
      };
      var errorMsg = "";

      if (utils.isEmpty($scope.issueData.title)) {
        errorMsg = 'Please input title';
      } else if (utils.isEmpty($scope.issueData.issueCategory)) {
        errorMsg = 'Please select issue category';
      } else if (utils.isEmpty($scope.issueData.priority)) {
        errorMsg = 'Please select issue priority';
      } else if (utils.isEmpty($scope.issueData.status)) {
        errorMsg = 'Please select issue status';
      }

      if ($scope.issueData.drawings) {
        $scope.issueData.drawings.forEach(function (item) {
          if (item.image2D) {
            $scope.issueData.image2d = utils.dataURLtoFile(item.image2D, 'image2D');
          } else if (item.image3D) {
            $scope.issueData.image3d = utils.dataURLtoFile(item.image3D, 'image3D');
          }
        });
        $scope.issueData.drawings = undefined;
      }

      if (errorMsg.length) {
        ret.success = false;
        ret.errorMsg = errorMsg;
        $scope.goStep(1);
        return ret;
      }

      if ($scope.issueData.step === 2) {
        if (utils.isEmpty($scope.issueData.marker.info3d.modelId)) {
          errorMsg = 'Please select a 3d model for new issue.';
        }
      }

      if (errorMsg.length) {
        ret.success = false;
        ret.errorMsg = errorMsg;
      }

      return ret;
    };

    $scope.goStep = function (step) {
      if (step > $scope.issueData.step) {
        var valid = $scope.checkValidation();

        if (!valid.success) {
          Notification.error(valid.errorMsg);
          return;
        }
      }

      $scope.issueData.step = step;
      $scope.issueData.deadLine = $scope.issueData.deadLine1;
      vm.clearIssueData();
    };
    /* file */


    vm.uploadImg = [];

    $scope.changeImage = function (files) {
      if (angular.isUndefined(files[0])) return;
      vm.uploadImg[0] = files[0];
      $scope.imageURL = URL.createObjectURL(vm.uploadImg[0]);
      utils.getBase64(vm.uploadImg[0]).then(function (data) {
        return $scope.issueData.uploadImg = data;
      });
    };

    $scope.change3dModel = function () {
      if ($scope.issueData.marker.info3d.modelId && !$scope.isVP) {
        $scope.loading = true;
        apiFactory.get3dModel($scope.issueData.marker.info3d.modelId).then(function (resp) {
          $scope.loading = false;
          var model = resp.data.data;
          vm.selected3dModel = model;

          if (model) {
            $scope.m3dLevelList = Bim.levelList(model);
            angular.element('#loading3d-container').removeClass('d-none');
            angular.element('#model3d-preview-container').hide();
            vm.viewer3d.clear();
            vm.viewer3d.loadBim(model).then(function () {
              angular.element('#loading3d-container').addClass('d-none');
              angular.element('#model3d-preview-container').show();

              if ($scope.issueData.marker.info3d.clipping) {
                vm.viewer3d.loadClipping($scope.issueData.marker.info3d.clipping);
              }

              $scope.change3dModelLevel();
            })["catch"](function () {
              angular.element('#loading3d-container').addClass('d-none');
              angular.element('#model3d-preview-container').show();
              Notification.error('IFC file cannot open.');
            });
          }
        })["catch"](function (e) {
          $scope.loading = false;
          $log.error(e);
        });
      }
    };

    $scope.change3dModelLevel = function () {
      if (!$scope.issueData.marker.info3d.modelId || !vm.viewer3d || !$scope.issueData.marker.info3d.level) {
        return;
      }

      if ($scope.issueData.marker.info3d.level === 'All' || $scope.issueData.marker.info3d.level === 'Others') {
        vm.viewer3d.showAllObject();
      } else {
        var levelId = $scope.issueData.marker.info3d.level;

        if (levelId) {
          vm.viewer3d.showObject(levelId);
          changePlan(vm.viewer3d.getBimModel(), levelId);
        } else {
          $scope.issueData.marker.info3d.level = 'All';
        }
      }

      if ($scope.issueData.marker.info3d.location && $scope.issueData.marker.info3d.location.x) {
        vm.viewer3d.loadMarkers([$scope.issueData.marker.info3d.location]);
      } else {
        vm.viewer3d.loadMarkers([]);
      }
    };

    $scope.changeVP = function () {
      if (vm.viewervp && $scope.issueData.marker && $scope.issueData.marker.info3d && $scope.issueData.marker.info3d.modelId && $scope.isVP) {
        var plan = $scope.vpList.find(function (x) {
          return x._id === $scope.issueData.marker.info3d.modelId;
        });

        if (plan) {
          $scope.issueData.marker.info3d.url = plan.url;
          $scope.issueData.marker.info3d.pageNo = plan.pageNo;
          $scope.issueData.level = plan.level;
          angular.element('#loadingvp-container').removeClass('d-none');
          angular.element('#vp-preview-container').hide();
          vm.viewervp.clear();
          vm.viewervp.loadBackgroundImageWidthHD(plan.url, plan.pageNo).then(function () {
            if ($scope.issueData.marker.info3d.location && $scope.issueData.marker.info3d.location.x) {
              vm.viewervp.loadMarkers([$scope.issueData.marker.info3d.location]);
            }

            angular.element('#loadingvp-container').addClass('d-none');
            angular.element('#vp-preview-container').show();
          })["catch"](function (err) {
            $log.error(err);
            angular.element('#loadingvp-container').addClass('d-none');
            angular.element('#vp-preview-container').show();
          });
        }
      }
    };

    vm.updateVPPreview = function (model) {
      angular.element('#loading3d-container').removeClass('d-none');
      angular.element('#model3d-preview-container').hide();
      vm.viewer3d.clear();
      vm.viewer3d.loadBim(model).then(function () {
        angular.element('#loading3d-container').addClass('d-none');
        angular.element('#model3d-preview-container').show();
      })["catch"](function () {
        angular.element('#loading3d-container').addClass('d-none');
        angular.element('#model3d-preview-container').show();
        Notification.error('IFC file cannot open.');
      });
    };

    $scope.goAddMarking = function () {
      if ($scope.isVP) {
        $scope.issueData.marker.modelType = 'vp';
      } else {
        $scope.issueData.marker.modelType = '3d';
      }

      vm.clearIssueData();
      $state.go('issuesMarking');
    };

    $scope.exitCreateIssue = function () {
      var id = $scope.issueData._id;
      localStorageService.set('issueData', {});

      if (id && $scope.issueData.editMode) {
        $state.go('issueDetail', {
          id: id
        });
      } else {
        $state.go('issuesList');
      }
    };

    vm.clearIssueData = function () {
      localStorageService.set('issueData', $scope.issueData);
    };

    vm.createIssue = function () {
      var valid = $scope.checkValidation();

      if (!valid.success) {
        Notification.error(valid.errorMsg);
        return;
      }

      $scope.issueData.projectId = vm.project._id;

      if ($scope.issueData.uploadImg) {
        $scope.issueData.photo = utils.dataURLtoFile($scope.issueData.uploadImg, 'issuePhoto');
        delete $scope.issueData.uploadImg;
      }

      if ($scope.issueData.marker.info2d && !$scope.issueData.marker.info3d.level || $scope.issueData.marker.modelType === 'vp') {
        delete $scope.issueData.marker.info2d;
        delete $scope.issueData.image2d;
      }

      var id = $scope.issueData._id;

      if (id && $scope.issueData.editMode) {
        $scope.loading = true;
        apiFactory.updateIssue($scope.issueData, id).then(function (resp) {
          $scope.loading = false;
          Notification.success(resp.data.message);
          vm.clearIssueData();
          $state.go("issueDetail", {
            id: id
          });
        })["catch"](function (error) {
          $scope.loading = false;
          $log.error(error);
          if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to update issue");
          vm.clearIssueData();
        });
      } else {
        $scope.loading = true;
        apiFactory.createIssue($scope.issueData).then(function (resp) {
          $scope.loading = false;
          Notification.success(resp.data.message);
          $scope.goStep(3);
          vm.clearIssueData();
        })["catch"](function (error) {
          $scope.loading = false;
          $log.error(error);
          if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed to create issue");
          vm.clearIssueData();
        });
      }
    };

    vm.init = function () {
      $scope.loading = true;
      Promise.all([apiFactory.listAllAdminUsers(vm.project._id), apiFactory.getUsersInProjectByApprovalType(vm.project._id, 'issue'), apiFactory.getIssuesList(), apiFactory.list3d(vm.project._id), apiFactory.getProjectRoofPlans(vm.project._id), apiFactory.listAllQshedAssets(vm.project._id), apiFactory.getWorkTypes(), apiFactory.listAllLevelTypes()]).then(function (resp) {
        $scope.loading = false;
        $scope.userList = resp[0].data.list.map(function (user) {
          return {
            label: user.firstName + ' ' + user.lastName,
            key: user._id
          };
        });
        $scope.allRoofers = resp[1].data.list.map(function (roofer) {
          return {
            label: roofer.displayName,
            key: roofer._id
          };
        });
        $scope.issueList = resp[2].data.list;
        $scope.m3dList = resp[3].data.data || [];
        $scope.vpList = [];

        for (var i = 0; i < resp[4].data.data.length; i++) {
          var plan = resp[4].data.data[i];
          $scope.vpList.push({
            _id: plan._id,
            title: plan.assetObj.title,
            url: plan.parentAsset.secure_url,
            pageNo: plan.assetObj.pageNo,
            level: plan.level
          });
        }

        for (var _i = 0; _i < resp[5].data.list.length; _i++) {
          var asset = resp[5].data.list[_i];
          $scope.vpList.push({
            _id: asset._id,
            title: asset.originalname,
            url: asset.secure_url,
            pageNo: 0,
            level: asset.level
          });
        }

        $scope.workTypes = resp[6].data.list;
        $scope.levelTypes = resp[7].data.list;

        for (var _i2 = 1; _i2 <= 100; _i2++) {
          $scope.levelTypes.push({
            tagName: _i2.toString(),
            tagValue: _i2.toString()
          });
        }

        if ($scope.isVP) {
          $scope.changeVP();
        } else {
          $scope.change3dModel();
        }
      })["catch"](function (error) {
        $scope.loading = false;
        $log.error(error);
      });
      /* 3d viewer */

      vm.viewer3d = Bim.markingViewer(angular.element('#model3d-preview')[0]);
      vm.viewer3d.initialize();
      vm.viewer3d.disableControl();
      /* 2d viewer */

      vm.viewer2d = Bim.planViewer(angular.element('#model2d-preview')[0]);
      vm.viewer2d.initialize();
      /* vp viewer */

      vm.viewervp = VP.markingViewer(angular.element('#vp-preview')[0]);
      $scope.issueData = localStorageService.get('issueData') || {};

      if ($scope.issueData.deadLine) {
        $scope.issueData.deadLine1 = new Date($scope.issueData.deadLine);
      }

      $scope.isVP = $scope.issueData.marker && $scope.issueData.marker.modelType === 'vp';

      if (!$scope.issueData.marker) {
        $scope.issueData.marker = {
          modelType: '3d',
          info2d: {
            modelId: null,
            image: null,
            location: {
              x: 0,
              y: 0
            }
          },
          info3d: {
            level: null,
            modelId: null,
            image: null,
            location: {
              x: 0,
              y: 0,
              z: 0
            }
          }
        };
      }

      $scope.goStep($scope.issueData.step || 1);
    };

    vm.init();

    function changePlan(bimModel, levelId) {
      if (!bimModel || !levelId || !vm.viewer2d) {
        return;
      }

      $scope.loading = true;
      angular.element('#loading2d-container').removeClass('d-none');
      angular.element('#model2d-preview-container').hide();
      vm.viewer2d.loadBimModel(bimModel, levelId).then(function () {
        $scope.loading = false;
        angular.element('#loading2d-container').addClass('d-none');
        angular.element('#model2d-preview-container').show();

        if ($scope.issueData.marker.info2d && $scope.issueData.marker.info2d.location && $scope.issueData.marker.info2d.location.x) {
          vm.viewer2d.loadMarkers([$scope.issueData.marker.info2d.location]);
        } else {
          vm.viewer2d.loadMarkers([]);
        }
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);
        angular.element('#loading2d-container').addClass('d-none');
        angular.element('#model2d-preview-container').show();
      });
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('financeVendor', {
    controller: financeVendorController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-vendor/finance-vendor.view.html'
  });

  function financeVendorController(globals, $scope, apiFactory, Notification, utils, $log) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.vendors = [];
    vm.currentVendor = {};
    vm.selectedVendorId = undefined;
    $scope.typeData = [{
      value: 'Sales Offer'
    }, {
      value: 'Invoice'
    }, {
      value: 'Sales Memo'
    }, {
      value: 'Purchase Bill'
    }, {
      value: 'Purchase Memo'
    }];
    vm.statistics = [{
      name: 'Sales Offers',
      qty: 0,
      amount: 0
    }, {
      name: 'Ongoing',
      qty: 0,
      amount: 0
    }, {
      name: 'Completed',
      qty: 0,
      amount: 0
    }, {
      name: 'Lost & Cancel',
      qty: 0,
      amount: 0
    }];
    vm.overdueAndBalance = {
      overdue: 0,
      balance: 0
    };
    $scope.selectedType = 'Sales Offer';

    function fetchStatisticsData() {
      $scope.loading = true;
      Promise.all([apiFactory.getStatisticsData({
        vendorId: vm.selectedVendorId,
        type: $scope.selectedType
      }), apiFactory.getOverdueAndBalanceByVendorId(vm.selectedVendorId)]).then(function (res) {
        $scope.loading = false;
        vm.statistics = res[0].data;
        vm.overdueAndBalance = res[1].data;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    $scope.changeTypeData = function () {
      fetchStatisticsData();
    };

    $scope.changeVendor = function () {
      if (vm.selectedVendorId) {
        vm.currentVendor = vm.vendors.find(function (x) {
          return x._id === vm.selectedVendorId;
        }) || {};
        fetchStatisticsData();
      } else {
        vm.currentVendor = {};
      }
    };

    $scope.saveVendor = function () {};

    function init() {
      $scope.loading = true;
      apiFactory.getAllSuppliers().then(function (res) {
        $scope.loading = false;
        vm.vendors = res.data.list;
        vm.currentVendor = vm.vendors[0];
        vm.selectedVendorId = vm.currentVendor ? vm.currentVendor._id : undefined;
        $scope.changeVendor();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    init();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("financeScript", {
    controller: financeScriptController,
    controllerAs: "vm",
    templateUrl: "app/main/finance/finance-script/finance-script.view.html"
  });
  /** @ngInject */

  function financeScriptController($scope, $state, utils, $log, $timeout, apiFactory, $uibModal, Notification) {
    var vm = this;
    $scope.scripts = [];
    vm.currentPage = 1;
    vm.totalCount = 0;
    $scope.numPerPage = 20;
    $scope.selectedAll = false;
    $scope.periods = [{
      id: '20',
      name: '20'
    }, {
      id: '40',
      name: '40'
    }, {
      id: '80',
      name: '80'
    }];

    $scope.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchData();
    };

    $scope.selectAll = function () {
      $scope.scripts.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectItem = function () {
      $scope.selectedAll = false;
      $timeout(function () {
        $scope.$apply();
      });
    };

    $scope.deleteScript = function (id) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.deleteFinanceScript(id).then(function () {
          $scope.isLoading = false;
          Notification.success('Deleted the selected items successfully');
          $scope.fetchData();
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }, function () {});
    };

    $scope.deleteScripts = function () {
      var selectedScripts = $scope.scripts.filter(function (x) {
        return x.selected;
      });
      var promises = [];
      selectedScripts.forEach(function (script) {
        promises.push(apiFactory.deleteFinanceScript(script._id));
      });

      if (utils.isEmpty(promises)) {
        Notification.error('Please select the script items');
        return;
      }

      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        Promise.all(promises).then(function () {
          $scope.isLoading = false;
          Notification.success('Deleted the selected items successfully');
          $scope.fetchData();
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }, function () {});
    };

    $scope.isDanger = function (type, item) {
      if (type == 'debit') {
        return Math.abs(item.reportDebit - item.posted5800) > 0.01 || Math.abs(item.reportDebit - item.balance5800) > 0.01;
      } else if (type == 'credit') {
        return Math.abs(item.reportCredit - item.posted6800) > 0.01 || Math.abs(item.reportCredit - item.balance6800) > 0.01;
      } else {
        return false;
      }
    };

    $scope.generateScript = function () {
      $scope.isLoading = true;
      apiFactory.generateFinanceScript().then(function () {
        $scope.isLoading = false;
        $scope.fetchData();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err, 'Failed to generate finance script'));
      });
    };

    $scope.selectedCount = function () {
      if (utils.isEmpty($scope.scripts)) {
        return '0 item selected';
      }

      var scripts = $scope.scripts.filter(function (x) {
        return x.selected;
      });

      if (utils.isEmpty(scripts)) {
        return '0 item selected';
      }

      return "".concat(scripts.length, " items selected");
    };

    $scope.fetchData = function () {
      var query = {
        page: vm.currentPage,
        chunk: $scope.numPerPage
      };
      apiFactory.getFinanceScripts(query).then(function (res) {
        $scope.scripts = res.data.list;
        vm.totalCount = res.data.totalCount;
        $scope.isLoading = false;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err, 'Failed to get finance scripts'));
      });
    };

    $scope.fetchData();
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('financeSales', {
    controller: financeSalesController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-sales/finance-sales.view.html'
  });
  /** @ngInject */

  function financeSalesController($scope, $state, globals, apiFactory, Notification, utils, $log, $uibModal, FileSaver) {
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.projectData = projectStore.get();
    vm.currentPage = 1;
    vm.totalCount = 0;
    vm.numPerPage = 12;
    vm.glAccounts = [];
    $scope.list = [];
    $scope.currentTab = 'Invoice';
    $scope.selectedAll = false;
    $scope.sortOption = 'date';
    $scope.clearFilter = false;
    $scope.searchText = undefined;
    $scope.filterOption = {};
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.invoiceOptions = [{
      label: 'Created Time',
      value: 'createdAt'
    }, {
      label: 'Last Updated Time',
      value: 'updatedAt'
    }, {
      label: 'Date',
      value: 'date'
    }, {
      label: 'Invoice #',
      value: 'displaySeq'
    }, {
      label: 'Customer Name',
      value: 'customerName'
    }, {
      label: 'Due Date',
      value: 'dueDate'
    }, {
      label: 'Amount',
      value: 'totalAmount'
    }, {
      label: 'Balance Amount',
      value: 'balanceDue'
    }, {
      label: 'Import Invoices',
      value: 'Import Invoices',
      iconUrl: '/assets/icons/import-black.svg'
    }, {
      label: 'Export Invoices',
      value: 'Export Invoices',
      iconUrl: '/assets/icons/export-black.svg'
    }, {
      label: 'Refresh',
      value: 'Refresh',
      iconUrl: '/assets/icons/cash-black.svg'
    }];
    $scope.creditMemoOptions = [{
      label: 'Created Time',
      value: 'createdAt'
    }, {
      label: 'Last Updated Time',
      value: 'updatedAt'
    }, {
      label: 'Date',
      value: 'date'
    }, {
      label: 'Credit Memo #',
      value: 'displaySeq'
    }, {
      label: 'Customer Name',
      value: 'customerName'
    }, {
      label: 'Due Date',
      value: 'dueDate'
    }, {
      label: 'Amount',
      value: 'totalAmount'
    }, {
      label: 'Balance Amount',
      value: 'balanceDue'
    }, {
      label: 'Import Credit Memos',
      value: 'Import Credit Memos',
      iconUrl: '/assets/icons/import-black.svg'
    }, {
      label: 'Export Credit Memos',
      value: 'Export Credit Memos',
      iconUrl: '/assets/icons/export-black.svg'
    }, {
      label: 'Refresh',
      value: 'Refresh',
      iconUrl: '/assets/icons/cash-black.svg'
    }];
    vm.fromDate = new Date();
    vm.toDate = new Date();
    vm.fromDate.setFullYear(vm.fromDate.getFullYear() - 1);

    $scope.changeTab = function (tab) {
      $scope.currentTab = tab;
      $scope.clearFilter = true;
      vm.currentPage = 1;
      vm.totalCount = 0;
      vm.noOfPages = 0;
      $scope.fetchData();
    };

    $scope.selectAll = function () {
      $scope.list.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectItem = function () {
      $scope.selectedAll = false;
    };

    $scope.statusColor = function (status) {
      switch (status) {
        case 'draft':
          return {
            color: '#D71414'
          };

        case 'pending':
          return {
            color: '#4584E0'
          };

        case 'paid':
          return {
            color: '#2FA84F'
          };

        default:
          return {
            color: '#464646'
          };
      }
    };

    $scope.searchData = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      var query = {
        page: vm.currentPage,
        chunk: vm.numPerPage,
        search: $scope.searchText
      };

      if (vm.projectData && vm.projectData._id !== 'all') {
        query.projectId = vm.projectData._id;
      }

      if ($scope.filterOption !== {}) {
        query = $scope.getFilterQuery(query, $scope.filterOption);
      }

      var endpoint = $scope.currentTab === 'Invoice' ? apiFactory.listAllInvoices(query) : apiFactory.listAllCreditMemos(query);
      $scope.isLoading = true;
      endpoint.then(function (res) {
        $scope.isLoading = false;
        vm.list = res.data.list;
        vm.list = vm.list.filter(function (x) {
          return x.totalAmount;
        });

        var _iterator = _createForOfIteratorHelper(vm.list),
            _step;

        try {
          var _loop = function _loop() {
            var invoice = _step.value;
            var item = invoice.items[0];
            invoice.customerName = invoice.vendor.name || invoice.vendor.clientName;
            invoice.creditMemos = invoice.subtractList && _typeof(invoice.subtractList) == Array && invoice.subtractList.length ? invoice.subtractList.filter(function (x) {
              return x.invoiceId;
            }).map(function (x) {
              return x.invoiceId.displaySeq;
            }).join(", ") : "";

            if (item && item.type) {
              var glAccount = vm.glAccounts.find(function (x) {
                return x.No == item.type.number;
              });

              if (glAccount) {
                invoice.balanceDue = glAccount.NetChange;
              }
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        vm.totalCount = res.data.totalCount;
        vm.noOfPages = Math.ceil(vm.totalCount / vm.numPerPage);
        $scope.clearFilter = false;
        $scope.list = angular.copy(vm.list);
        $scope.noOfPages = vm.noOfPages;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.changeSortOption = function (val) {
      $scope.sortOption = val;

      switch (val) {
        case 'Refresh':
          $scope.fetchData();
          break;

        case 'Import Invoices':
        case 'Export Invoices':
        case 'Import Credit Memos':
        case 'Export Credit Memos':
          break;

        default:
          $scope.fetchData();
      }
    };

    $scope.onFilter = function (filterOption) {
      $scope.filterOption = angular.copy(filterOption);
      $scope.fetchData();
    };

    $scope.getFilterQuery = function (query, filterOption) {
      if (!utils.isEmpty(filterOption.dateFrom) && !utils.isEmpty(filterOption.dateTo)) {
        query.startDate = filterOption.dateFrom;
        query.endDate = filterOption.dateTo;
      }

      if (!utils.isEmpty(filterOption.number)) {
        query.displaySeq = filterOption.number;
      }

      if (!utils.isEmpty(filterOption.amountFrom) && !utils.isEmpty(filterOption.amountTo)) {
        query.amountFrom = filterOption.amountFrom;
        query.amountTo = filterOption.amountTo;
      }

      if (!utils.isEmpty(filterOption.customerName)) {
        query.customerName = filterOption.customerName;
      }

      return query;
    }; // $scope.sendCopy = (invoice) => {
    //   $uibModal.open({
    //     component: 'invoiceCopyModal',
    //     windowClass: 'invoice-copy-modal',
    //     animation: true,
    //     resolve: {
    //       invoice: function () {
    //         return invoice
    //       }
    //     }
    //   }).result
    //   .then(function () {
    //     $scope.fetchData();
    //   })
    //   .catch(function () {
    //     // Modal dismissed.
    //   });
    // }


    $scope.sendInvoiceMail = function (invoice) {
      var _recipients = {
        emails: [invoice.vendor.email],
        managers: []
      };
      $uibModal.open({
        animation: true,
        component: 'recipientsModal',
        windowClass: 'recipients-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          recipients: function recipients() {
            return _recipients;
          },
          title: function title() {
            return 'Invoice / Credit Memo';
          },
          send: function send() {
            return true;
          }
        }
      }).result.then(function (result) {
        if (result) {
          invoice.recipients = _recipients;
          $scope.isLoading = true;
          apiFactory.sendInvoiceMail(invoice).then(function (res) {
            $scope.isLoading = false;
            Notification.success(res.data.message);
          })["catch"](function (err) {
            $scope.isLoading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.exportToExcel = function () {
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.toLowerCase().includes('.xlsx') || result.toLowerCase().includes('.xls') ? result : result + '.xlsx';
        var query = {
          fileName: fileName,
          search: $scope.searchText
        };

        if (vm.projectData && vm.projectData._id !== 'all') {
          query.projectId = vm.projectData._id;
        }

        $scope.isLoading = true;
        apiFactory.downloadInvoicesExcel(query).then(function (res) {
          $scope.isLoading = false;
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, fileName);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err, 'Failed to export excel file'));
        });
      })["catch"](function () {});
    };

    function init() {
      $scope.isLoading = true;
      $scope.fetchData();
    }

    init();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchData();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financePurchases', {
    controller: financePurchasesController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-purchases/finance-purchases.view.html'
  });
  /** @ngInject */

  function financePurchasesController($scope, globals, apiFactory, Notification, utils, $log, $uibModal, localStorageService, $state, FileSaver) {
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.projectData = projectStore.get();
    vm.currentPage = 1;
    vm.totalCount = 0;
    vm.numPerPage = 12;
    vm.list = [];
    $scope.list = [];
    $scope.currentTab = 'Bill';
    $scope.selectedAll = false;
    $scope.sortOption = 'billDate';
    $scope.clearFilter = false;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.billOptions = [{
      label: 'Created Time',
      value: 'createdAt'
    }, {
      label: 'Last Updated Time',
      value: 'updatedAt'
    }, {
      label: 'Date',
      value: 'billDate'
    }, {
      label: 'Bill #',
      value: 'billNo'
    }, {
      label: 'Customer Name',
      value: 'customerName'
    }, {
      label: 'Due Date',
      value: 'dueDate'
    }, {
      label: 'Amount',
      value: 'totalAmount'
    }, {
      label: 'Balance Amount',
      value: 'balanceDue'
    }, {
      label: 'Import Bills',
      value: 'Import Bills',
      iconUrl: '/assets/icons/import-black.svg'
    }, {
      label: 'Export Bills',
      value: 'Export Bills',
      iconUrl: '/assets/icons/export-black.svg'
    }, {
      label: 'Refresh',
      value: 'Refresh',
      iconUrl: '/assets/icons/cash-black.svg'
    }];

    $scope.changeTab = function (tab) {
      $scope.currentTab = tab;
      $scope.clearFilter = true;
      vm.currentPage = 1;
      vm.totalCount = 0;
      vm.noOfPages = 0;
      $scope.fetchData();
    };

    $scope.selectAll = function () {
      $scope.list.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectItem = function () {
      $scope.selectedAll = false;
    };

    $scope.statusColor = function (status) {
      switch (status) {
        case 'declined':
          return {
            color: '#D71414'
          };

        case 'pending':
          return {
            color: '#4584E0'
          };

        case 'approved':
          return {
            color: '#2FA84F'
          };

        default:
          return {
            color: '#464646'
          };
      }
    };

    $scope.searchData = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      var query = {
        page: vm.currentPage,
        chunk: vm.numPerPage,
        sort: $scope.sortOption,
        sortType: "false",
        isMemo: $scope.currentTab === 'Memo',
        search: $scope.searchText
      };

      if (vm.projectData && vm.projectData._id !== 'all') {
        query.projectId = vm.projectData._id;
      }

      $scope.isLoading = true;
      apiFactory.listAllBillings(query).then(function (res) {
        $scope.isLoading = false;
        vm.list = res.data.list;
        vm.list.forEach(function (bill) {
          bill.balance = getBillBalance(bill);
          if ($scope.currentTab === 'Memo') bill.billNo = bill.displaySeq;
        });
        vm.totalCount = res.data.total;
        vm.noOfPages = Math.ceil(vm.totalCount / vm.numPerPage);
        $scope.onFilter({});
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchData();

    $scope.changeSortOption = function (val) {
      $scope.sortOption = val;

      switch (val) {
        case 'Refresh':
          $scope.fetchData();
          break;

        case 'Import Bills':
        case 'Export Bills':
          break;

        default:
          $scope.fetchData();
      }
    };

    $scope.onFilter = function (filterOption) {
      $scope.clearFilter = false;
      $scope.list = angular.copy(vm.list);
      $scope.noOfPages = vm.noOfPages;

      if (!utils.isEmpty(filterOption.number)) {
        $scope.list = $scope.list.filter(function (x) {
          return x.billNo.includes(filterOption.number);
        });
        vm.currentPage = 1;
        var totalCount = $scope.list.length;
        $scope.noOfPages = Math.ceil(totalCount / vm.numPerPage);
      }

      if (!utils.isEmpty(filterOption.amountFrom) && !utils.isEmpty(filterOption.amountTo)) {
        $scope.list = $scope.list.filter(function (x) {
          return x.amountWithoutTax >= filterOption.amountFrom && x.amountWithoutTax <= filterOption.amountTo;
        });
        vm.currentPage = 1;
        var _totalCount = $scope.list.length;
        $scope.noOfPages = Math.ceil(_totalCount / vm.numPerPage);
      }

      if (!utils.isEmpty(filterOption.dateFrom) && !utils.isEmpty(filterOption.dateTo)) {
        $scope.list = $scope.list.filter(function (x) {
          var date = new Date(x.dueDate);
          return date >= filterOption.dateFrom && date <= filterOption.dateTo;
        });
        vm.currentPage = 1;
        var _totalCount2 = $scope.list.length;
        $scope.noOfPages = Math.ceil(_totalCount2 / vm.numPerPage);
      }

      if (!utils.isEmpty(filterOption.customerName)) {
        $scope.list = $scope.list.filter(function (x) {
          return x.customerName.toLowerCase().includes(filterOption.customerName.toLowerCase());
        });
        vm.currentPage = 1;
        var _totalCount3 = $scope.list.length;
        $scope.noOfPages = Math.ceil(_totalCount3 / vm.numPerPage);
      }
    };

    function getBillBalance(bill) {
      bill.customerName = bill.vendor ? bill.vendor.name || bill.vendor.clientName : "";
      var amount = utils.num(bill.remainingAmount);
      if (amount === 0) return amount;

      if (bill.vendor && bill.vendor.paymentTerms) {
        var vatPercent = utils.num(bill.vendor.paymentTerms.vatPercent);
        amount = amount / (1 + vatPercent / 100);
        amount = Math.max(0, amount);
      }

      return amount;
    }

    $scope.exportToExcel = function () {
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.toLowerCase().includes('.xlsx') || result.toLowerCase().includes('.xls') ? result : result + '.xlsx';
        var query = {
          fileName: fileName,
          search: $scope.searchText
        };

        if (vm.projectData && vm.projectData._id !== 'all') {
          query.projectId = vm.projectData._id;
        }

        if ($scope.currentTab == 'Memo') {
          query.isMemo = true;
        }

        $scope.isLoading = true;
        apiFactory.downloadBillingsExcel(query).then(function (res) {
          $scope.isLoading = false;
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, fileName);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err, 'Failed to export excel file'));
        });
      })["catch"](function () {});
    };

    vm.gotoEdit = function (bill) {
      localStorageService.set('billData', bill);
      $state.go('billScanner');
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchData();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financePosts3', {
    controller: financePosts3Controller,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-posts3/finance-posts3.view.html'
  });
  /** @ngInject */

  function financePosts3Controller(globals, $scope, apiFactory, Notification, utils, $log, $stateParams, $uibModal, FileSaver) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.projectData = globals.projectStore.get();
    vm.vendorId = $stateParams.vendorId;
    vm.overdue = $stateParams.overdue;
    $scope.periods = [{
      id: '15',
      name: '15'
    }, {
      id: '30',
      name: '30'
    }, {
      id: '60',
      name: '60'
    }];
    vm.currentPage = 1;
    vm.totalCount = 0;
    vm.numPerPage = 15;
    $scope.selectedAll = false;

    $scope.selectAll = function () {
      vm.finances.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectNumPage = function (new_num) {
      vm.numPerPage = new_num;
      $scope.fetchData();
    };

    $scope.selectItem = function () {
      $scope.selectedAll = false;
    };

    $scope.getSerialNo = function (index) {
      return (vm.totalCount - (vm.currentPage - 1) * vm.numPerPage - index).toString().padStart(5, '0');
    };

    $scope.getDescription = function (item) {
      $log.log(item);

      if (item.postingType == 'Payment') {
        return item.finance.billNo || item.finance.displaySeq || item.finance.systemTag;
      }

      return item.description;
    };

    $scope.getBalAccountType = function (item) {
      if (item.postingType == 'Posting') {
        if (item.financeType == 'Invoice') return 'Debit';else if (item.financeType == 'Billing') return 'Credit';else return '';
      }

      return '';
    };

    $scope.getBalAccountNo = function (item) {
      if (item.postingType == 'Posting') {
        return item.vendor.clientName || item.vendor.name;
      }

      return '';
    };

    $scope.getType = function (finance) {
      if (finance.postingType === "Invoice") {
        $scope.title = "Client";
        return finance.isCreditMemo ? 'C-Memo' : 'Invoice';
      } else if (finance.postingType === "Bill") {
        $scope.title = "Vendor";
        return finance.isMemo ? 'V-Memo' : 'Bill';
      } else {
        return finance.postingType;
      }
    };

    $scope.selectedCount = function () {
      if (utils.isEmpty(vm.finances)) {
        return '0 item selected';
      }

      var finances = vm.finances.filter(function (x) {
        return x.selected;
      });

      if (utils.isEmpty(finances)) {
        return '0 item selected';
      }

      return "".concat(finances.length, " items selected");
    };

    $scope.exportToExcel = function () {
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.toLowerCase().includes('.xlsx') || result.toLowerCase().includes('.xls') ? result : result + '.xlsx';
        var query = {
          fileName: fileName,
          vendorId: vm.vendorId,
          overdue: vm.overdue
        };
        $scope.isLoading = true;
        apiFactory.downloadFinancesExcelByVendorId(query).then(function (res) {
          $scope.isLoading = false;
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, fileName);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err, 'Failed to export excel file'));
        });
      }, function () {});
    };

    $scope.fetchData = function () {
      var query = {
        page: vm.currentPage,
        chunk: vm.numPerPage,
        overdue: vm.overdue
      };
      $scope.isLoading = true;
      apiFactory.getFinancesByVendorId(vm.vendorId, query).then(function (res) {
        $scope.isLoading = false;
        vm.finances = res.data.list;
        vm.totalCount = res.data.totalCount;
        vm.totalPrice = res.data.totalPrice;
        vm.totalBalance = res.data.totalBalance;
        vm.noOfPages = Math.ceil(vm.totalCount / vm.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchData();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financePosts2', {
    controller: financePosts2Controller,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-posts2/finance-posts2.view.html'
  });
  /** @ngInject */

  function financePosts2Controller(globals, $scope, apiFactory, Notification, utils, $log, $stateParams, $uibModal, FileSaver) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.projectData = globals.projectStore.get();
    vm.currentPage = 1;
    vm.totalCount = 0;
    vm.numPerPage = 20;
    $scope.selectedAll = false;
    vm.type = $stateParams.type;
    vm.type2 = $stateParams.type2;
    vm.accountPlanId = $stateParams.accountPlanId;
    vm.accountPlanNumber = $stateParams.accountPlanNumber;
    vm.fromDate = new Date($stateParams.fromDate);
    vm.toDate = new Date($stateParams.toDate);
    vm.isOnlyApprovedBills = $stateParams.isOnlyApprovedBills === "true";
    vm.financialYear = $stateParams.financialYear;

    $scope.selectAll = function () {
      vm.finances.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectItem = function () {
      $scope.selectedAll = false;
    };

    $scope.getSerialNo = function (index) {
      return (vm.totalCount - (vm.currentPage - 1) * vm.numPerPage - index).toString().padStart(5, '0');
    };

    $scope.getType = function (finance) {
      if (finance.invoiceDoc) {
        return finance.isCreditMemo ? 'C-Memo' : 'Invoice';
      } else {
        return finance.isMemo ? 'V-Memo' : 'Bill';
      }
    };

    $scope.exportToExcel = function () {
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.toLowerCase().includes('.xlsx') || result.toLowerCase().includes('.xls') ? result : result + '.xlsx';
        var query = {
          type: vm.type,
          accountPlanId: vm.accountPlanId,
          fromDate: vm.fromDate,
          toDate: vm.toDate,
          fileName: fileName,
          isOnlyApprovedBills: vm.isOnlyApprovedBills,
          search: $scope.searchText
        };

        if (vm.projectData && vm.projectData._id !== 'all') {
          query.projectId = vm.projectData._id;
        }

        $scope.isLoading = true;
        apiFactory.downloadFinancesExcelByType(query).then(function (res) {
          $scope.isLoading = false;
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, fileName);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err, 'Failed to export excel file'));
        });
      }, function () {});
    };

    $scope.searchData = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      if (vm.type !== vm.type2) {
        vm.finances = [];
        vm.totalCount = 0;
        vm.noOfPages = 1;
        return;
      }

      var query = {
        type: vm.type,
        accountPlanId: vm.accountPlanId,
        fromDate: vm.fromDate,
        toDate: vm.toDate,
        page: vm.currentPage,
        chunk: vm.numPerPage,
        isOnlyApprovedBills: vm.isOnlyApprovedBills,
        search: $scope.searchText,
        financialYear: vm.financialYear
      };

      if (vm.projectData && vm.projectData._id !== 'all') {
        query.projectId = vm.projectData._id;
      }

      $scope.isLoading = true;
      apiFactory.listPostedFinancesByType(query).then(function (res) {
        $scope.isLoading = false;
        vm.finances = res.data.list;
        vm.totalCount = res.data.totalCount;
        vm.noOfPages = Math.ceil(vm.totalCount / vm.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchData();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financePostsWip', {
    controller: financePostsWipController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-posts-wip/finance-posts-wip.view.html'
  });
  /** @ngInject */

  function financePostsWipController(globals, $scope, apiFactory, Notification, utils, $log, $stateParams, $uibModal, FileSaver) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.projectData = globals.projectStore.get();
    vm.sum = 0;
    vm.currentPage = 1;
    vm.totalCount = 0;
    vm.numPerPage = 20;
    $scope.selectedAll = false;
    vm.wip = $stateParams.wip;
    vm.type = $stateParams.type;
    vm.type2 = $stateParams.type2;
    vm.accountPlanId = $stateParams.accountPlanId;
    vm.accountPlanNumber = $stateParams.accountPlanNumber;
    vm.fromDate = new Date($stateParams.fromDate);
    vm.toDate = new Date($stateParams.toDate);
    vm.isOnlyApprovedBills = $stateParams.isOnlyApprovedBills === "true";

    $scope.selectAll = function () {
      vm.finances.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectItem = function () {
      $scope.selectedAll = false;
    };

    $scope.getSerialNo = function (index) {
      return (vm.totalCount - (vm.currentPage - 1) * vm.numPerPage - index).toString().padStart(5, '0');
    };

    $scope.getType = function (finance) {
      if (finance.invoiceDoc) {
        return finance.isCreditMemo ? 'C-Memo' : 'Invoice';
      } else {
        return finance.isMemo ? 'V-Memo' : 'Bill';
      }
    };

    $scope.getWipName = function (value) {
      switch (value) {
        case 'wipSales':
          return 'WIP - Sales (Statement)';

        case 'wipLabour':
          return 'WIP - Labour (Statement)';

        case 'wipCosts':
          return 'WIP - Costs (Statement)';

        case 'wipContract':
          return 'WIP - Contract (Balance/Current Assets)';

        case 'wipInvoiced':
          return 'WIP - Invoiced (Balance/Current Assets)';

        case 'wipUpfront':
          return 'WIP - Upfront Payment';

        case 'wipWip':
          return 'WIP - Work In Progress (Balance/Current Assets)';

        case 'wipAssets':
          return 'WIP - Costs (assets)';

        case 'wipShort':
          return 'WIP - Costs (Balance/Short-term debt)';
      }
    };

    $scope.addZeroes = function (number, width) {
      if (vm.projectData && vm.projectData._id !== 'all') return new Array(+width + 1 - (number + (vm.currentPage - 1) * vm.numPerPage * 2 + '').length).join('0') + (number + (vm.currentPage - 1) * vm.numPerPage * 2);else return new Array(+width + 1 - (number + (vm.currentPage - 1) * vm.numPerPage + '').length).join('0') + (number + (vm.currentPage - 1) * vm.numPerPage);
    };

    $scope.addPercent = function (description) {
      if (description.split('%').length === 1) {
        return "".concat(description, "%");
      } else {
        return description;
      }
    };

    $scope.exportToExcel = function () {
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.toLowerCase().includes('.xlsx') || result.toLowerCase().includes('.xls') ? result : result + '.xlsx';
        var query = {
          type: vm.type,
          accountPlanId: vm.accountPlanId,
          fromDate: vm.fromDate,
          toDate: vm.toDate,
          fileName: fileName,
          isOnlyApprovedBills: vm.isOnlyApprovedBills,
          search: $scope.searchText
        };

        if (vm.projectData && vm.projectData._id !== 'all') {
          query.projectId = vm.projectData._id;
        }

        $scope.isLoading = true;
        apiFactory.downloadFinancesWipExcel(query).then(function (res) {
          $scope.isLoading = false;
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, fileName);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err, 'Failed to export excel file'));
        });
      }, function () {});
    };

    $scope.deletePostedWip = function (wipItemId) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.isLoading = true;
          apiFactory.deletePostedWip(wipItemId).then(function (res) {
            Notification.success(res.data.message);
            $scope.fetchData();
          })["catch"](function (e) {
            $scope.isLoading = false;
            $log.error(e);
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    $scope.searchData = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      var query = {
        type: vm.type,
        accountPlanId: vm.accountPlanId,
        fromDate: vm.fromDate,
        toDate: vm.toDate,
        page: vm.currentPage,
        chunk: vm.numPerPage,
        isOnlyApprovedBills: vm.isOnlyApprovedBills,
        search: $scope.searchText
      };

      if (vm.projectData && vm.projectData._id !== 'all') {
        query.projectId = vm.projectData._id;
      }

      $scope.isLoading = true;
      vm.newFinances = [];
      apiFactory.listPostedFinancesByWip(query).then(function (res) {
        vm.finances = res.data.list;
        vm.sum = 0;
        vm.finances.forEach(function (x) {
          if (x.isWip) {
            if (vm.wip === "wipSales") {
              x.amount = x.wip.sales;
            } else if (vm.wip === "wipLabour") {
              x.amount = x.wip.labor;
            } else if (vm.wip === "wipCosts") {
              x.amount = x.wip.proejctCost;
            } else if (vm.wip === "wipContract") {
              x.amount = x.wip.contract;
            } else if (vm.wip === "wipInvoiced") {
              x.amount = x.wip.invoiced;
            } else if (vm.wip === "wipUpfront") {
              x.amount = x.wip.upfront;
            } else if (vm.wip === "wipWip") {
              x.amount = x.wip.wip;
            } else if (vm.wip === "wipAssets") {
              x.amount = x.wip.assetsCost;
            } else if (vm.wip === "wipShort") {
              x.amount = x.wip.balanceCost;
            }

            x.description = "".concat(x.projectId.projectName, " - ").concat(x.workingPercent, "%");
            x.financeKind = 'WIP';
            x.postingType = $scope.getWipName(vm.wip);
          } else {
            x.amount = x.totalAmount;
          }

          vm.sum += x.amount;
        });
        vm.totalCount = res.data.totalCount;
        vm.noOfPages = Math.ceil(vm.totalCount / vm.numPerPage);
        $scope.isLoading = false;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchData();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financePosts', {
    controller: financePostsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-posts/finance-posts.view.html'
  });
  /** @ngInject */

  function financePostsController(globals, $scope, apiFactory, Notification, utils, $log, $stateParams, $uibModal, FileSaver) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.projectData = globals.projectStore.get();
    var accountPlanId = $stateParams.id;
    vm.currentPage = 1;
    vm.totalCount = 0;
    vm.numPerPage = 20;
    $scope.selectedAll = false;

    $scope.selectAll = function () {
      vm.finances.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectItem = function () {
      $scope.selectedAll = false;
    };

    $scope.getSerialNo = function (index) {
      return (vm.totalCount - (vm.currentPage - 1) * vm.numPerPage - index).toString().padStart(5, '0');
    };

    $scope.getType = function (finance) {
      if (finance.invoiceDoc) {
        return finance.isCreditMemo ? 'C-Memo' : 'Invoice';
      } else {
        return finance.isMemo ? 'V-Memo' : 'Bill';
      }
    };

    $scope.exportToExcel = function () {
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.toLowerCase().includes('.xlsx') || result.toLowerCase().includes('.xls') ? result : result + '.xlsx';
        var query = {
          accountPlanId: accountPlanId,
          fileName: fileName
        };

        if (vm.projectData && vm.projectData._id !== 'all') {
          query.projectId = vm.projectData._id;
        }

        $scope.isLoading = true;
        apiFactory.downloadFinancesExcelByAccountPlanId(query).then(function (res) {
          $scope.isLoading = false;
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, fileName);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err, 'Failed to export excel file'));
        });
      }, function () {});
    };

    $scope.fetchData = function () {
      var query = {
        page: vm.currentPage,
        chunk: vm.numPerPage
      };

      if (vm.projectData && vm.projectData._id !== 'all') {
        query.projectId = vm.projectData._id;
      }

      $scope.isLoading = true;
      apiFactory.listPostedFinancesByAccountPlanId(accountPlanId, query).then(function (res) {
        $scope.isLoading = false;
        vm.finances = res.data.list;
        vm.totalCount = res.data.totalCount;
        vm.noOfPages = Math.ceil(vm.totalCount / vm.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchData();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeFinance', {
    controller: financeFinanceController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-finance/finance-finance.view.html'
  });
  /** @ngInject */

  function financeFinanceController(globals, $scope, apiFactory, Notification, utils, $log, $uibModal, $timeout, FileSaver) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.projectData = globals.projectStore.get();
    vm.currentPage = 1;
    vm.totalCount = 0;
    $scope.numPerPage = 20;
    $scope.selectedAll = false;
    $scope.periods = [{
      id: '20',
      name: '20'
    }, {
      id: '40',
      name: '40'
    }, {
      id: '80',
      name: '80'
    }];

    $scope.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchData();
    };

    $scope.selectAll = function () {
      $scope.finances.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectItem = function () {
      $scope.selectedAll = false;
      $timeout(function () {
        $scope.$apply();
      });
    }; // $scope.getSerialNo = index => {
    //   let idx = 4 - Number.parseInt(index / 3);
    //   return ((vm.noOfPages - vm.currentPage - 1) * $scope.numPerPage + idx).toString().padStart(5, '0');
    // }
    // $scope.getDocumentNo = (finance, index) => {
    //   if (!finance || !finance.accountPlan) {
    //     return ''
    //   }
    //
    //   let accountPlan = finance.accountPlan;
    //   let vatType = accountPlan.vatType;
    //   let isInvoice = !utils.isEmpty(finance.invoiceDoc);
    //
    //   if (index % 3 === 0) {
    //     return accountPlan.number;
    //   } else if (index % 3 === 1) {
    //     if (!vatType) {
    //       return '';
    //     }
    //     if (isInvoice) {
    //       return vatType.salesVatAccount ? vatType.salesVatAccount.number : '';
    //     } else {
    //       return vatType.purchaseVatAccount ? vatType.purchaseVatAccount.number : '';
    //     }
    //   } else if (index % 3 === 2) {
    //     if (!vatType) {
    //       return ''
    //     }
    //     if (isInvoice) {
    //       return vatType.postingAccountDebit ? vatType.postingAccountDebit.number : '';
    //     } else {
    //       return vatType.postingAccountCredit ? vatType.postingAccountCredit.number : '';
    //     }
    //   }
    // }
    // $scope.getType = finance => {
    //   if (finance.invoiceDoc) {
    //     return finance.isCreditMemo ? 'C-Memo' : 'Invoice';
    //   } else {
    //     return finance.isMemo ? 'V-Memo' : 'Bill';
    //   }
    // }


    $scope.selectedCount = function () {
      if (utils.isEmpty($scope.finances)) {
        return '0 item selected';
      }

      var finances = $scope.finances.filter(function (x) {
        return x.selected;
      });

      if (utils.isEmpty(finances)) {
        return '0 item selected';
      }

      return "".concat(finances.length, " items selected");
    };

    $scope.exportToExcel = function () {
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.toLowerCase().includes('.xlsx') || result.toLowerCase().includes('.xls') ? result : result + '.xlsx';
        var query = {
          fileName: fileName,
          search: $scope.searchText
        };

        if (vm.projectData && vm.projectData._id !== 'all') {
          query.projectId = vm.projectData._id;
        }

        $scope.isLoading = true;
        apiFactory.downloadFinancesExcel(query).then(function (res) {
          $scope.isLoading = false;
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, fileName);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err, 'Failed to export excel file'));
        });
      }, function () {});
    }; // $scope.editFinance = finance => {
    // }


    $scope.deleteFinances = function () {
      var selectedFinances = $scope.finances.filter(function (x) {
        return x.selected;
      });
      var promises = [];
      selectedFinances.forEach(function (finance) {
        if (finance.postingType === 'Re-enter') {
          promises.push(apiFactory.deleteReJournal(finance._id));
        } else if (finance.postingType === 'Manual') {
          promises.push(apiFactory.deleteManualJournal(finance._id));
        }
      });

      if (utils.isEmpty(promises)) {
        Notification.error('Please select the journal items');
        return;
      }

      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        Promise.all(promises).then(function () {
          $scope.isLoading = false;
          Notification.success('Deleted the selected items successfully');
          $scope.fetchData();
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }, function () {});
    };

    $scope.searchData = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      var query = {
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: $scope.searchText
      };

      if (vm.projectData && vm.projectData._id !== 'all') {
        query.projectId = vm.projectData._id;
      }

      $scope.isLoading = true;
      apiFactory.listPostedFinances(query).then(function (res) {
        $scope.isLoading = false;
        vm.finances = res.data.list;
        vm.totalCount = res.data.totalCount;
        vm.noOfPages = Math.ceil(vm.totalCount / $scope.numPerPage);
        $scope.finances = vm.finances;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchData();
  }
})();


"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('financeDashboard', {
    controller: financeDashboardController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-dashboard/finance-dashboard.view.html'
  });
  /** @ngInject */

  function financeDashboardController($scope, $state, $filter, $log, globals, apiFactory, storageFactory, Notification) {
    var vm = this;
    var companyStore = globals.companyStore,
        projectStore = globals.projectStore,
        userStore = globals.userStore,
        filterStore = globals.filterStore;
    vm.project = projectStore.get();
    vm.companyData = companyStore.get();
    vm.userData = userStore.get();
    vm.filter = {
      projectId: undefined,
      clientId: undefined,
      project: undefined,
      client: undefined,
      startDate: undefined,
      endDate: undefined
    };
    vm.clients = [];
    vm.billings = [];
    vm.invoices = [];
    vm.vaOrders = [];
    vm.tasks = [];
    vm.duration = null;
    vm.projectTypeOptioins = [{
      label: 'All Projects',
      value: 'all'
    }, {
      label: 'Ongoing Projects',
      value: 'ongoing'
    }, {
      label: 'Completed Projects',
      value: 'completed'
    }, {
      label: 'Service Projects',
      value: 'service'
    }];
    vm.projectType = 'all';
    vm.projectFilter = [];
    vm.allProjects = [];
    vm.ongoingProjects = [];
    vm.completedProjects = [];
    vm.serviceProjects = [];
    vm.filterSelection = ['ongoing', 'completed', 'service'];
    vm.bShowFilter = false;
    vm.filterData = filterStore.get();

    if (vm.filterData && vm.filterData.clientId) {
      vm.filter.clientId = vm.filterData.clientId;
    }

    vm.selectFilterProject = function (projectId) {
      if (vm.selProjects) {
        vm.filter.project = vm.selProjects.find(function (x) {
          return x._id === projectId;
        }); // projectStore.set(vm.filter.project);
        // $state.reload();

        applyFilter();
      }
    };

    vm.onShowFilter = function () {
      vm.bShowFilter = !this.bShowFilter;
      vm.tempFilter = _toConsumableArray(vm.filterSelection);
      vm.tempProjectFilter = _toConsumableArray(vm.projectFilter);
    };

    vm.selectProjectType = function (type) {
      $log.log(type);

      if (type == 'all') {
        // if(vm.tempFilter.length == 3) {
        //   vm.tempFilter = [];
        // } else {
        vm.tempFilter = ['ongoing', 'completed', 'service'];
        vm.filterProjectList = vm.allProjects; // }
      } else if (type == 'ongoing') {
        // var idx = vm.tempFilter.indexOf('ongoing');
        // if(idx > -1) {
        //   vm.tempFilter.splice(idx, 1);
        // } else {
        //   vm.tempFilter.push('ongoing');
        // }
        vm.tempFilter = ['ongoing'];
        vm.filterProjectList = vm.ongoingProjects;
      } else if (type == 'completed') {
        // idx = vm.tempFilter.indexOf('completed');
        // if(idx > -1) {
        //   vm.tempFilter.splice(idx, 1);
        // } else {
        //   vm.tempFilter.push('completed');
        // }
        vm.tempFilter = ['completed'];
        vm.filterProjectList = vm.completedProjects;
      } else if (type == 'service') {
        // idx = vm.tempFilter.indexOf('service');
        // if(idx > -1) {
        //   vm.tempFilter.splice(idx, 1);
        // } else {
        //   vm.tempFilter.push('service');
        // }
        vm.tempFilter = ['service'];
        vm.filterProjectList = vm.serviceProjects;
      }
    };

    vm.checkProject = function (projectId) {
      $log.log(projectId);
      var idx = vm.tempProjectFilter.indexOf(projectId);

      if (idx > -1) {
        vm.tempProjectFilter.splice(idx, 1);
      } else {
        vm.tempProjectFilter.push(projectId);
      }
    };

    vm.filterSelectAll = function () {
      vm.tempProjectFilter = vm.filterProjectList.map(function (project) {
        return project._id;
      });
    };

    vm.filterClearAll = function () {
      vm.tempProjectFilter = [];
    };

    vm.onFilterOk = function () {
      vm.filterSelection = _toConsumableArray(vm.tempFilter);
      vm.projectFilter = _toConsumableArray(vm.tempProjectFilter);
      vm.projects = []; // vm.filterSelection.forEach(selection => {
      //   if(selection == 'ongoing') {
      //     vm.projects = vm.projects.concat(vm.ongoingProjects);
      //   } else if(selection == 'completed') {
      //     vm.projects = vm.projects.concat(vm.completedProjects);
      //   } else if(selection == 'service') {
      //     vm.projects = vm.projects.concat(vm.serviceProjects);
      //   }
      // })

      vm.projects = vm.allProjects.filter(function (project) {
        return vm.projectFilter.indexOf(project._id) > -1;
      });
      vm.selProjects = [{
        _id: "all",
        projectName: "All Project"
      }];
      vm.selProjects = vm.selProjects.concat(vm.projects);
      vm.filter.projectId = 'all';
      vm.isAllProject = true;
      $log.log('list of projects = ', vm.selProjects);
      vm.bShowFilter = false;
      loadDataWithAll();
    };

    vm.onFilterCancel = function () {
      vm.tempFilter = [];
      vm.tempProjectFilter = [];
      vm.bShowFilter = false;
    };

    vm.selectFilterClient = function (clientId) {
      if (vm.clients) {
        vm.filter.client = vm.clients.find(function (x) {
          return x._id === clientId;
        });
        var filterData = filterStore.get();

        if (filterData) {
          filterStore.set({
            clientId: clientId,
            start: filterData.start,
            end: filterData.end
          });
        } else {
          filterStore.set({
            clientId: clientId
          });
        }

        vm.filter.project = vm.selProjects.find(function (x) {
          return x._id === 'all';
        });
        projectStore.set(vm.filter.project);
        $state.reload();
        applyFilter();
      }
    };

    vm.changeFilterDate = function () {
      if (vm.filter.startDate && vm.filter.endDate) {
        if (vm.filter.startDate.getTime() > vm.filter.endDate.getTime()) {
          Notification.error("Start period cannot after than end period.");
          return;
        }

        var filterData = filterStore.get();

        if (filterData) {
          filterStore.set({
            clientId: filterData.clientId,
            start: new Date(vm.filter.startDate),
            end: new Date(vm.filter.endDate)
          });
        } else {
          filterStore.set({
            start: new Date(vm.filter.startDate),
            end: new Date(vm.filter.endDate)
          });
        }
      }

      applyFilter();
    };

    function initData() {
      globals.getCurrency().then(function (resp) {
        vm.getCurrencyCode = resp.data;
        $scope.companyCurrency = vm.getCurrencyCode.find(function (element) {
          return element.cc === vm.companyData.currentCurrency.currencyCode;
        });
      });
      $scope.isLoading = true;
      Promise.all([storageFactory.listAllProjects(), apiFactory.getFinanceDashboardInitData()]).then(function (resp) {
        vm.projects = resp[0].data.list;
        vm.clients = resp[1].data.clients || [];
        vm.bankAccounts = resp[1].data.paymentAccounts; // vm.filterProjects = [
        //   {_id: "all", projectName: $filter('translate')("All Projects")}
        // ];
        // if (vm.filterData && vm.filterData.clientId) {
        //   vm.filterProjects.pushAll(vm.projects.filter((p) => {
        //     return p.client == vm.filterData.clientId
        //   }));
        // } else {
        //   vm.filterProjects.pushAll(vm.projects);
        // }
        // let filterProject = vm.project ? vm.project : undefined;
        // if (filterProject) {
        //   vm.filter.project = filterProject;
        //   vm.filter.projectId = filterProject._id;
        //   vm.filter.startDate = new Date(filterProject.startDate);
        //   vm.filter.endDate = new Date(filterProject.endDate);
        // } else {
        //   vm.filter.project = vm.filterProjects[0];
        //   vm.filter.projectId = vm.filterProjects[0]._id;
        //   vm.filter.startDate = new Date(vm.filterProjects[0].startDate);
        //   vm.filter.endDate = new Date(vm.filterProjects[0].endDate);
        // }

        var projects = [{
          _id: 'all',
          projectName: $filter('translate')("All Projects")
        } // {_id: 'ongoing', projectName: $filter('translate')("All Ongoings")},
        // {_id: 'completed', projectName: $filter('translate')("All Completed")},
        // {_id: 'service', projectName: $filter('translate')("All Service")},
        ];
        vm.projects.forEach(function (project) {
          if (project.managers) {
            project.managers.forEach(function (manager) {
              return manager.displayName = manager.userId ? manager.userId.displayName : 'Manager';
            });
          }

          project.startDate = new Date(project.startDate);
          project.endDate = new Date(project.endDate);
          project.endDate.setHours(23, 59, 59, 0);
          var type = '';

          if (project.projectStatus == 1) {
            type = 'Ongoing';
            vm.ongoingProjects.push(project);
          } else if (project.projectStatus == 2) {
            type = 'Completed';
            vm.completedProjects.push(project);
          } else if (project.isServiceProject) {
            type = 'Service';
            vm.serviceProjects.push(project);
          }

          project.projectName = project.projectName + ' (' + type + ')'; // projects.push(project);
        });
        vm.allProjects = vm.allProjects.concat(vm.ongoingProjects, vm.completedProjects, vm.serviceProjects);
        projects = projects.concat(vm.ongoingProjects, vm.completedProjects, vm.serviceProjects);
        vm.selProjects = projects;
        var curProject = projectStore.get();
        var filterProject = curProject ? vm.selProjects.find(function (x) {
          return x._id === curProject._id;
        }) : undefined;

        if (filterProject) {
          vm.project = filterProject;
          vm.filter.projectId = vm.project._id;
          vm.isAllProject = false;
        }

        vm.filterProjectList = vm.allProjects;
        vm.filter.startDate = new Date(vm.project.startDate);
        vm.filter.endDate = new Date(vm.project.endDate);
        vm.clients.unshift({
          clientName: ""
        });
        $scope.$apply();
        applyFilter();
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }

    initData();

    function loadDataWithAll() {
      var projectIds = [];
      projectIds = vm.projects.map(function (x) {
        return x._id;
      });
      $log.log('project ids = ', projectIds);
      var isAudit = false;

      if (vm.projects.length > 0) {
        isAudit = true;

        for (var i = 0; i < vm.projects.length; i++) {
          if (!vm.projects[i].isAudit) {
            isAudit = false;
            break;
          }
        }
      }

      vm.isAudit = isAudit;
      vm.chartData = undefined;
      vm.projectData = undefined;
      $scope.isLoading = true;
      var query = {};

      if (vm.filter.clientId) {
        var projects = [];
        vm.projects.forEach(function (project) {
          var find = false;

          if (project.client && vm.filter.clientId) {
            find = vm.filter.clientId === project.client;
          }

          if (find) {
            projects.push(project);
          }
        });

        var _projectIds = projects.map(function (x) {
          return x._id;
        });

        query.projects = _projectIds;
        query.clients = [vm.filter.clientId];
      } else if (vm.filter.project && vm.filter.project._id !== 'all') {
        var _projects = [vm.filter.project._id];
        query.projects = _projects;
      } else {
        var totalProjectIds = vm.projects.filter(function (x) {
          return x.projectStatus == 1 || x.projectStatus == 2 || x.isServiceProject == true;
        }).map(function (element) {
          return element._id;
        });
        query.projects = totalProjectIds;
      }

      if (vm.filter.startDate) {
        query.startDate = vm.filter.startDate;
      }

      if (vm.filter.endDate) {
        query.endDate = vm.filter.endDate;
      }

      apiFactory.getFinanceDashboardData(query).then(function (resp) {
        vm.total = resp.data.total;
        vm.cashGraphData = resp.data.graphData;
        $scope.isLoading = false;
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }

    function applyFilter() {
      $scope.isLoading = true;
      var query = {};

      if (vm.filter.clientId) {
        var projects = [];
        vm.projects.forEach(function (project) {
          var find = false;

          if (project.client && vm.filter.clientId) {
            find = vm.filter.clientId === project.client;
          }

          if (find) {
            projects.push(project);
          }
        });
        var projectIds = projects.map(function (x) {
          return x._id;
        });
        query.projects = projectIds;
        query.clients = [vm.filter.clientId];
      } else if (vm.filter.project && vm.filter.project._id !== 'all') {
        var _projects2 = [vm.filter.project._id];
        query.projects = _projects2;
        vm.filter.startDate = new Date(vm.filter.project.startDate);
        vm.filter.endDate = new Date(vm.filter.project.endDate);
      } else {
        var totalProjectIds = vm.projects.filter(function (x) {
          return x.projectStatus == 1 || x.projectStatus == 2 || x.isServiceProject == true;
        }).map(function (element) {
          return element._id;
        });
        query.projects = totalProjectIds;
      }

      if (vm.filter.startDate) {
        query.startDate = vm.filter.startDate;
      }

      if (vm.filter.endDate) {
        query.endDate = vm.filter.endDate;
      }

      apiFactory.getFinanceDashboardData(query).then(function (resp) {
        vm.total = resp.data.total;
        vm.cashGraphData = resp.data.graphData;
        $scope.isLoading = false;
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }
  }
})();


"use strict";

(function () {
  angular.module('app').component('financeClient', {
    controller: financeClientController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-client/finance-client.view.html'
  });

  function financeClientController(globals, $scope, apiFactory, Notification, utils, $log, $filter) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.clients = [];
    vm.currentClient = {};
    vm.selectedClientId = undefined;
    $scope.typeData = [{
      value: 'Sales Offer'
    }, {
      value: 'Invoice'
    }, {
      value: 'Sales Memo'
    }, {
      value: 'Purchase Bill'
    }, {
      value: 'Purchase Memo'
    }];
    vm.statistics = [{
      name: $filter('translate')('Sales Offer'),
      qty: 0,
      amount: 0
    }, {
      name: $filter('translate')('Ongoing1'),
      qty: 0,
      amount: 0
    }, {
      name: $filter('translate')('Completed'),
      qty: 0,
      amount: 0
    }, {
      name: $filter('translate')('Lost & Cancel'),
      qty: 0,
      amount: 0
    }];
    vm.overdueAndBalance = {
      overdue: 0,
      balance: 0
    };
    $scope.selectedType = 'Sales Offer';

    function fetchStatisticsData() {
      $scope.loading = true;
      Promise.all([apiFactory.getStatisticsData({
        vendorId: vm.selectedClientId,
        type: $scope.selectedType
      }), apiFactory.getOverdueAndBalanceByVendorId(vm.selectedClientId)]).then(function (res) {
        $scope.loading = false;
        vm.statistics = res[0].data;
        vm.overdueAndBalance = res[1].data;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    $scope.changeTypeData = function () {
      fetchStatisticsData();
    };

    $scope.changeClient = function () {
      if (vm.selectedClientId) {
        vm.currentClient = vm.clients.find(function (x) {
          return x._id === vm.selectedClientId;
        }) || {};
        fetchStatisticsData();
      } else {
        vm.currentClient = {};
      }
    };

    $scope.saveClient = function () {};

    function init() {
      $scope.loading = true;
      apiFactory.listAllClients().then(function (res) {
        $scope.loading = false;
        vm.clients = res.data.list;
        vm.clients.forEach(function (client) {
          client.address = client.address[0] || {};
        });
        vm.currentClient = vm.clients[0];
        vm.selectedClientId = vm.currentClient ? vm.currentClient._id : undefined;
        $scope.changeClient();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    init();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('financeBillEdit', {
    controller: financeBillEditController,
    controllerAs: 'vm',
    templateUrl: 'app/main/finance/finance-bill-edit/finance-bill-edit.view.html'
  });
  /** @ngInject */

  function financeBillEditController($scope, $rootScope, $state, $stateParams, $log, apiFactory, Notification, utils, $timeout, pdfFactory, $document, globals) {
    var vm = this;
    vm.projectData = globals.projectStore.get();
    vm.companyData = globals.companyStore.get();
    $scope.vat = 0;
    $scope.isBillDatepickerOpen = false;
    $scope.isDueDatepickerOpen = false;
    $scope.billingGroupId = undefined;
    vm.canvas = $document[0].getElementById("the-canvas");
    vm.numPages = 1;
    vm.currentPageNum = 1;
    vm.canvasPage = undefined;
    vm.canvasScale = 1;
    vm.baseCanvasScale = 1.0;
    var CANVAS_HEIGHT = 635 * $rootScope.scale;
    var CANVAS_SCALE_MUTIPLER = 2;

    vm.editItem = function (item) {
      item.editMode = true;
    };

    vm.confirmEdit = function (item) {
      if (utils.isEmpty(item.description) || utils.isEmpty(item.qty) || utils.isEmpty(item.unitprice)) {
        Notification.error('Please input correct value');
        return;
      }

      item.editMode = false;
    };

    vm.addItem = function () {
      vm.billing.customSupplierData.supplies.push({
        editMode: true
      });
    };

    vm.deleteItem = function (item, index) {
      vm.billing.customSupplierData.supplies.splice(index, 1);
      calculateTotal();
    };

    vm.changedQtyAndUPrice = function (item) {
      item.price = utils.num(item.qty) * utils.num(item.unitprice);
      calculateTotal();
    };

    vm.updateBill = function () {
      if (vm.billing.customSupplierData.supplies.find(function (x) {
        return x.editMode;
      })) {
        Notification.error("Please complete edit.");
        return;
      }

      if (!vm.billing.billDate) {
        Notification.error("Please input bill date.");
        return;
      }

      if (!vm.billing.dueDate) {
        Notification.error("Please input due date.");
        return;
      }

      var billData = {
        billDate: vm.billing.billDate,
        dueDate: vm.billing.dueDate,
        customSupplierData: vm.billing.customSupplierData,
        amountWithoutTax: vm.billing.amountWithoutTax,
        taxAmount: vm.billing.taxAmount,
        totalAmount: vm.billing.totalAmount,
        billType: vm.billing.billType
      };

      if (vm.billing.billType) {
        billData.billType = vm.billing.billType;
      }

      if (vm.billing.group) {
        billData.group = vm.billing.group._id;
        billData.groupType = vm.billing.group.groupType;
      }

      if (vm.billing.vaOrder) {
        billData.vaOrder = vm.billing.vaOrder._id;
      }

      $scope.loading = true;
      apiFactory.updateBillingData(billData, vm.billing._id).then(function () {
        $scope.loading = false;
        Notification.success("Bill is updated successfully.");
        $state.go("financePurchases");
      })["catch"](function (err) {
        $log.error(err);
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.downloadBill = function (billing) {
      $scope.isDownloading = true;
      utils.downloadFile(billing.bill.secure_url, "".concat(billing.billNo, ".pdf")).then(function () {
        $scope.isDownloading = false;
        $timeout(function () {
          return $scope.$apply();
        });
      })["catch"](function (err) {
        $scope.isDownloading = false;
        $log.error(err);
        Notification.error('Cannot download.');
      });
    };

    vm.changePageInBill = function (isNext) {
      if (isNext) {
        vm.currentPageNum += 1;

        if (vm.currentPageNum > vm.numPages) {
          vm.currentPageNum = vm.numPages;
        }
      } else {
        vm.currentPageNum -= 1;

        if (vm.currentPageNum < 1) {
          vm.currentPageNum = 1;
        }
      }

      pdfFactory.getPageFromURL(vm.billing.bill.secure_url, vm.currentPageNum).then(function (page) {
        vm.canvasPage = page;
        $timeout(function () {
          $scope.$apply();
        });
        renderPage(page, vm.canvas);
      })["catch"](function (e) {
        $log.error(e);
      });
    };

    vm.zoomCanvas = function (zoomIn) {
      vm.canvasScale = zoomIn ? vm.canvasScale + 0.1 : vm.canvasScale - 0.1;
      renderPage(vm.canvasPage, vm.canvas);
    };

    vm.selEconomicTypeId = function () {
      $scope.vat = getVat(vm.billing);
      calculateTotal();
    };

    vm.selBillingGroupId = function (billingGroupId) {
      for (var i = 0; i < vm.billingGroups.length; i++) {
        if (vm.billingGroups[i]._id === billingGroupId) {
          vm.billing.group = vm.billingGroups[i];
        }
      }
    };

    vm.selBillingVAOrderId = function (billingVAOrderId) {
      if (vm.vaOrderList) {
        for (var i = 0; i < vm.vaOrderList.length; i++) {
          if (vm.vaOrderList[i]._id === billingVAOrderId) {
            var vaOrder = vm.vaOrderList[i];
            vm.billing.vaOrder = vaOrder;
            vm.billing.customSupplierData = {
              invoicenumber: vaOrder.displaySeq,
              supplies: []
            };

            if (vaOrder.vendorType === 'Client') {
              vm.billing.customSupplierData.address2 = $scope.addressString(vaOrder.vendor.address);
              vm.billing.customSupplierData.postalCode = vaOrder.vendor.address[0].postalCode;
              vm.billing.customSupplierData.countryCode = vaOrder.vendor.address[0].countryCode;
              vm.billing.customSupplierData.city = vaOrder.vendor.address[0].city;
              vm.billing.vendor = vaOrder.vendor;
              vm.billing.vendor.name = vaOrder.vendor.clientName;
              vm.billing.vendor.address = $scope.addressString(vaOrder.vendor.address);
              vm.billing.vendor.contact = vaOrder.vendor.clientContact;

              if (vaOrder.vendor.paymentTerms) {
                vm.billing.vendor.vat = vaOrder.vendor.paymentTerms.vatPercent;
              } else {
                vm.billing.vendor.vat = 0;
              }

              vm.billing.vendor.bankDetails = angular.copy(vm.companyData.economicSettings.paymentInfo);

              if (vm.billing.vendor.bankDetails && vm.billing.vendor.bankDetails.length > 0) {
                vm.billing.vendor.bankDetails[0].IBAN = vm.billing.vendor.bankDetails[0].ibanNumber;
                vm.billing.vendor.bankDetails[0].sortCode = vm.billing.vendor.bankDetails[0].swiftCode;
              }
            } else if (vaOrder.vendorType === 'Supplier' || vaOrder.vendorType === 'Subcontractor') {
              vm.billing.customSupplierData.address2 = vm.billing.vendor.address;
              vm.billing.vendor = vaOrder.vendor;
              var address = vm.billing.vendor.address || '';
              var addresses = address.spilt(',');
              vm.billing.customSupplierData.postalCode = addresses[2];
              vm.billing.customSupplierData.countryCode = addresses[1];
              vm.billing.customSupplierData.city = addresses[0];
            }

            vm.billing.bill.secure_url = vaOrder.variationOrderDoc;

            for (var _i = 0; _i < vaOrder.items.length; _i++) {
              var item = vaOrder.items[_i];
              vm.billing.customSupplierData.supplies.push({
                description: item.description,
                qty: item.quantity,
                unitprice: item.unitPrice,
                vat: item.vatAmount,
                price: item.price
              });
            }

            calculateTotal();
            showBilling(vm.billing);
            return;
          }
        }
      }
    };

    $scope.updateBillDate = function () {
      if (vm.billing) {
        vm.billing.billDate = new Date($scope.billDate);
      }
    };

    $scope.updateDueDate = function () {
      if (vm.billing) {
        vm.billing.dueDate = new Date($scope.dueDate);
      }
    };

    function getVat(billing) {
      var accountPlan = undefined;

      if (billing.billType && angular.isObject(billing.billType)) {
        accountPlan = billing.billType;
      }

      if (accountPlan && angular.isDefined(accountPlan.vat)) {
        return accountPlan.vat;
      }

      return billing && billing.vendor && billing.vendor.paymentTerms && billing.vendor.paymentTerms.vatPercent ? billing.vendor.paymentTerms.vatPercent : 0;
    }

    function calculateTotal() {
      vm.billing.amountWithoutTax = 0;
      vm.billing.taxAmount = 0;
      vm.billing.totalAmount = 0;
      vm.billing.customSupplierData.supplies.forEach(function (supply) {
        var price = utils.num(supply.price);
        supply.vat = price * utils.num($scope.vat) / 100.0;
        supply.total = supply.vat + price;
        vm.billing.amountWithoutTax += price;
        vm.billing.taxAmount += supply.vat;
        vm.billing.totalAmount += supply.total;
      });
    }

    function showBilling(billing) {
      $scope.isLoadBilling = true;
      Promise.all([pdfFactory.numPagesFromURL(billing.bill.secure_url), pdfFactory.getPageFromURL(billing.bill.secure_url, vm.currentPageNum)]).then(function (res) {
        vm.numPages = res[0];
        var page = res[1];
        vm.canvasPage = page;
        $timeout(function () {
          $scope.$apply();
        });
        $scope.isLoadBilling = false;
        /* Render first page initially */

        renderPage(page, vm.canvas, true);
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoadBilling = false;
      });
    }

    function clearCanvas() {
      var ctx = vm.canvas.getContext("2d");

      if (ctx) {
        ctx.clearRect(0, 0, vm.canvas.width, vm.canvas.height);
      }
    }

    function renderPage(page, canvas) {
      var isInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if ($scope.isRendering) {
        return;
      }

      $scope.isRendering = true;
      clearCanvas();
      var originViewport = page.getViewport({
        scale: 1
      });

      if (isInit) {
        if (originViewport) {
          vm.baseCanvasScale = (originViewport.height ? CANVAS_HEIGHT / originViewport.height : 1) * CANVAS_SCALE_MUTIPLER;
        }

        vm.canvasScale = vm.baseCanvasScale;
      }

      var viewport = page.getViewport({
        scale: vm.canvasScale
      });

      if (viewport) {
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        canvas.style.width = viewport.width / 2 + 'px';
        canvas.style.height = viewport.height / 2 + 'px';
      }

      var ctx = canvas.getContext("2d");
      page.render({
        canvasContext: ctx,
        viewport: viewport
      }).promise.then(function () {
        $scope.isRendering = false;
      })["catch"](function (err) {
        $log.error(err);
        $scope.isRendering = false;
      });
    }

    function init() {
      $scope.loading = true;
      Promise.all([apiFactory.getBillDetails($stateParams.id), apiFactory.listAllVariationOrders({
        projectId: vm.projectData._id,
        status: 'approved',
        isBill: false
      }), apiFactory.getAllMaterialGroup(), apiFactory.getAllEquipmentGroup(), apiFactory.getBillAccountPlans()]).then(function (resp) {
        $scope.loading = false;
        vm.billing = resp[0].data.data;
        $scope.dueDate = vm.billing.dueDate ? new Date(vm.billing.dueDate) : undefined;
        $scope.billDate = vm.billing.billDate ? new Date(vm.billing.billDate) : undefined;

        if (!angular.isDate($scope.dueDate)) {
          $scope.dueDate = undefined;
        }

        if (!angular.isDate($scope.billDate)) {
          $scope.billDate = undefined;
        }

        $scope.billingGroupId = vm.billing.group ? vm.billing.group._id : undefined;
        $scope.vat = getVat(vm.billing);

        if (!vm.billing.customSupplierData) {
          vm.billing.customSupplierData = {
            supplies: []
          };
        } else if (!vm.billing.customSupplierData.supplies) {
          vm.billing.customSupplierData.supplies = [];
        }

        showBilling(vm.billing);
        vm.vaOrderList = resp[1].data.list;
        var materialGroup = resp[2].data.data;
        materialGroup.forEach(function (x) {
          return x.groupType = "MaterialGroup";
        });
        var equipmentGroup = resp[3].data.data;
        equipmentGroup.forEach(function (item) {
          return item.groupType = 'EquipmentGroup';
        });
        vm.billingGroups = materialGroup.concat(equipmentGroup);
        vm.selBillingGroupId($scope.billingGroupId);
        vm.economicTypeList = resp[4].data.data;
        vm.economicTypeList.forEach(function (x) {
          x.name = "".concat(x.number, " - ").concat(x.name);
        });
      })["catch"](function (err) {
        $log.error(err);
        $scope.loading = false;
        Notification.error("Failed to get billing");
      });
    }

    init();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("financeBalance", {
    controller: financeBalanceController,
    controllerAs: "vm",
    templateUrl: "app/main/finance/finance-balance/finance-balance.view.html"
  });
  /** @ngInject */

  function financeBalanceController(globals, $scope, Notification, utils, apiFactory, $log, $state, $uibModal, $timeout, $filter, FileSaver) {
    var vm = this;
    vm.userData = globals.userStore.get();
    var companyData = globals.companyStore.get();
    vm.project = globals.projectStore.get();
    $scope.financialYear = undefined;
    $scope.filterType = 0;
    $scope.periodType = 'all';
    $scope.compareYear = undefined;
    $scope.month = -1;
    $scope.hideZeroBalance = false;
    $scope.isOnlyApprovedBills = false;
    $scope.isShowWip = false;
    $scope.isWipOnly = false;
    $scope.auditWipData = {
      sales: 0,
      proejctCost: 0,
      labor: 0,
      contract: 0,
      invoiced: 0,
      upfront: 0,
      wip: 0,
      assetsCost: 0,
      balanceCost: 0
    };

    function getSectionSum(section) {
      var credit = section.summaries.map(function (x) {
        return utils.num(x.credit);
      }).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
      var debit = section.summaries.map(function (x) {
        return utils.num(x.debit);
      }).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
      var balance = section.summaries.map(function (x) {
        return utils.num(x.balance);
      }).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
      var creditWip = section.summaries.map(function (x) {
        return utils.num(x.creditWip);
      }).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
      var debitWip = section.summaries.map(function (x) {
        return utils.num(x.debitWip);
      }).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
      return {
        credit: credit,
        debit: debit,
        balance: balance,
        creditWip: creditWip,
        debitWip: debitWip
      };
    }

    function calcSummary(summary) {
      summary.credit = 0;
      summary.debit = 0;
      summary.balance = 0;
      summary.value = {};

      if (summary.fields) {
        if (summary.equation === "math") {
          summary.fields.forEach(function (field) {
            if (field.type === "section") {
              var section = vm.accountSections.find(function (x) {
                return x.number === field.number;
              });

              if (section) {
                var value = getSectionSum(section);
                summary.credit += field.operator === "-" ? -value.credit : value.credit;
                summary.debit += field.operator === "-" ? -value.debit : value.debit;
                summary.creditWip += field.operator === "-" ? -value.creditWip : value.creditWip;
                summary.debitWip += field.operator === "-" ? -value.debitWip : value.debitWip;
                summary.balance += field.operator === "-" ? -value.balance : value.balance;
                var wipItems = section.items.filter(function (item) {
                  return item.wip != "none" && item.wip;
                });
                wipItems.forEach(function (wipItem) {
                  summary.creditWip += field.operator === "-" ? -wipItem.creditWip : wipItem.creditWip;
                  summary.debitWip += field.operator === "-" ? -wipItem.debitWip : wipItem.debitWip;
                });
              }
            } else {
              var accountPlan = vm.accountPlans.find(function (plan) {
                return plan.number === field.number;
              });

              if (accountPlan) {
                summary.credit += field.operator === "-" ? -accountPlan.credit : accountPlan.credit;
                summary.debit += field.operator === "-" ? -accountPlan.debit : accountPlan.debit;
                summary.balance += field.operator === "-" ? -accountPlan.balance : accountPlan.balance;
              }
            }
          });
        } else {
          var count = 0;
          summary.fields.forEach(function (field) {
            if (field.type === "section") {
              var section = vm.accountSections.find(function (x) {
                return x.number === field.number;
              });

              if (section) {
                var value = getSectionSum(section);
                summary.credit += value.credit;
                summary.debit += value.debit;
                summary.creditWip += value.creditWip;
                summary.debitWip += value.debitWip;
                summary.balance += value.balance;
                count++;
                var wipItems = section.items.filter(function (item) {
                  return item.wip != "none" && item.wip;
                });
                wipItems.forEach(function (wipItem) {
                  summary.debitWip += wipItem.debitWip;
                  summary.creditWip += wipItem.creditWip;
                });
              }
            } else {
              var accountPlan = vm.accountPlans.find(function (plan) {
                return plan.number === field.number;
              });

              if (accountPlan) {
                summary.credit += accountPlan.credit;
                summary.debit += accountPlan.debit;
                summary.balance += accountPlan.balance;
                count++;
              }
            }
          });

          if (summary.equation === "avg") {
            summary.value = count === 0 ? 0 : summary.value / count;
          }
        }
      }

      var balance = summary.credit + summary.debit;
      summary.balance = balance;
      summary.debit = balance > 0 ? balance : 0;
      summary.credit = balance < 0 ? balance : 0;
    }

    function calcAccountPlanSum() {
      vm.accountSections.forEach(function (section) {
        if (section.summaries) {
          section.summaries.forEach(function (summary) {
            calcSummary(summary);
          });
        }
      });
    }

    $scope.getAccountPlanCnt = function (section) {
      var cnt = 0;

      if (section.items) {
        section.items.forEach(function (x) {
          if ($scope.showAccountPlan(x) && $scope.showAccountPlanByPeriodType(x) && $scope.showWipAccountPlan(x)) cnt++;
        });
      }

      return cnt;
    };

    $scope.showWipAccountPlan = function (accountPlan) {
      if ($scope.isShowWip && $scope.isWipOnly) {
        return accountPlan.wipName ? true : false;
      }

      return true;
    };

    $scope.showAccountPlan = function (accountPlan) {
      if (!utils.isEmpty($scope.searchText)) {
        if (accountPlan.number.indexOf($scope.searchText) == -1 && accountPlan.name.indexOf($scope.searchText) == -1) return false;
      }

      if ($scope.filterType == 0) return true;else if ($scope.filterType == 1 && accountPlan.type == 'Statement') return true;else if ($scope.filterType == 2 && accountPlan.type == 'Balance') return true;else if ($scope.filterType == 3 && accountPlan.type == 'Bank') return true;
      return false;
    };

    $scope.showAccountPlanByPeriodType = function (accountPlan) {
      if ($scope.periodType == 'all') return true;else if ($scope.periodType == 'accounting' && (accountPlan.period == 'accounting' || !accountPlan.period)) return true;else if ($scope.periodType == 'primo' && accountPlan.period == 'primo') return true; // else if ($scope.periodType == 'custom' && (accountPlan.period == 'custom' || !accountPlan.period)) return true;

      return false;
    };

    $scope.getSummary = function (item) {
      if ($scope.isShowWip) {
        return item.debitWip + item.creditWip;
      } else {
        return item.debit + item.credit;
      }
    };

    $scope.getSummayDebit = function (item) {
      if ($scope.isShowWip) {
        var sum = item.debitWip + item.creditWip;
        return sum < 0 ? "" : sum;
      } else {
        return item.debit == 0 ? "" : item.debit;
      }
    };

    $scope.getSummayCredit = function (item) {
      if ($scope.isShowWip) {
        var sum = item.debit + (isNaN(item.debitWip) ? 0 : item.debitWip) + item.credit + (isNaN(item.creditWip) ? 0 : item.creditWip);
        return sum > 0 ? "" : sum;
      } else {
        return item.credit == 0 ? "" : item.credit;
      }
    };

    $scope.goFinancePosts2 = function (type, accountPlan) {
      var fromDate = new Date(vm.fromDate.getUTCFullYear(), vm.fromDate.getUTCMonth(), vm.fromDate.getUTCDate());
      var toDate = new Date(vm.toDate.getUTCFullYear(), vm.toDate.getUTCMonth(), vm.toDate.getUTCDate(), 23, 59, 59, 999);
      $state.go("financePosts2", {
        type: type,
        type2: accountPlan.credit ? "credit" : "debit",
        accountPlanId: accountPlan._id,
        accountPlanNumber: accountPlan.number,
        fromDate: fromDate,
        toDate: toDate,
        isOnlyApprovedBills: $scope.isOnlyApprovedBills,
        period: accountPlan.period,
        financialYear: $scope.financialYear
      });
    };

    $scope.getAccountPlanPeriodSetting = function (value) {
      if (value == 'accounting') return 'Accounting Period'; // else if (value == 'custom') return 'See In Period';
      else if (value == 'primo') return 'Primo Balance'; // return 'See In Period';

      return 'Accounting Period';
    };

    $scope.goFinancePostsWip = function (type, accountPlan) {
      var fromDate = new Date(vm.fromDate.getUTCFullYear(), vm.fromDate.getUTCMonth(), vm.fromDate.getUTCDate());
      var toDate = new Date(vm.toDate.getUTCFullYear(), vm.toDate.getUTCMonth(), vm.toDate.getUTCDate(), 23, 59, 59, 999);
      $state.go("financePostsWip", {
        wip: accountPlan.wip,
        type: type,
        type2: accountPlan.credit ? "credit" : "debit",
        accountPlanId: accountPlan._id,
        accountPlanNumber: accountPlan.number,
        fromDate: fromDate,
        toDate: toDate,
        isOnlyApprovedBills: $scope.isOnlyApprovedBills,
        period: accountPlan.period
      });
    };

    vm.fetchData = function () {
      var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      vm.fromDate = new Date(vm.fromDate.getTime() - vm.fromDate.getTimezoneOffset() * 60 * 1000);
      vm.toDate = new Date(vm.toDate.getTime() - vm.toDate.getTimezoneOffset() * 60 * 1000);
      var fromDate = vm.fromDate;
      var toDate = vm.toDate;
      if (s) fromDate = s;
      if (e) toDate = e;
      var query = {
        fromDate: fromDate,
        toDate: toDate,
        hideZeroBalance: $scope.hideZeroBalance,
        isOnlyApprovedBills: $scope.isOnlyApprovedBills,
        // search: $scope.searchText,
        projectId: vm.project._id,
        financialYear: $scope.financialYear
      };
      $scope.loading = true;
      Promise.all([apiFactory.getFinanceBalancesData(query)]).then(function (res) {
        $scope.loading = false;
        vm.accountPlans = res[0].data.plans;
        $scope.invoices = res[0].data.invoices;
        $scope.payrolls = res[0].data.payrolls;
        $scope.billings = res[0].data.billings;
        vm.accountSections.forEach(function (section, index) {
          section.number = (index + 1).toString();
          section.items = vm.accountPlans.filter(function (item) {
            return item.sectionId == section._id;
          });
          section.items.forEach(function (item) {
            item.debitWip = angular.copy(item.debit);
            item.creditWip = angular.copy(item.credit);

            if (angular.isDefined(item.wip) && item.wip !== "none") {
              item.wipName = getWipName(item.wip);
              vm.getItemForWip(item);
            }
          });
          vm.getSummayForWip(section);
        }); // if (!utils.isEmpty($scope.searchText)) {
        //   vm.accountSections = vm.accountSections.filter(
        //     (x) => !utils.isEmpty(x.items)
        //   );
        // }

        calcAccountPlanSum();
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.onPost = function () {
      var query = {
        interval: "one day"
      };
      apiFactory.postedFinancesByWip(query).then(function (res) {
        $log.log(res);
      })["catch"](function (err) {
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.getItemForWip = function (item) {
      var data = 0;
      var projects = [];

      if (vm.project._id === "all") {
        projects = vm.projects;
      } else {
        projects = [vm.project];
      }

      $scope.totalWorkPercent = 0;
      projects.forEach(function (project) {
        $scope.totalWorkPercent += utils.num(project.progress);
      });
      $scope.totalWorkPercent = $scope.totalWorkPercent / projects.length;
      $scope.totalBudget = 0;
      $scope.laborBudget = 0;
      $scope.inventoryBudget = 0;
      $scope.salesBudget = 0;
      $scope.profitBudget = 0;
      $scope.totalCompanyRevCost = 0;
      $scope.costPercent = companyData ? companyData.companyCost : 8;
      projects.forEach(function (project) {
        if (project.calcSheet) {
          $scope.totalBudget += utils.num(project.calcSheet.sumWithAdditionalCost);
          $scope.laborBudget += utils.num(project.calcSheet.totalWorkerCost);
          $scope.inventoryBudget += utils.num(project.calcSheet.totalInventoryCost);
          $scope.salesBudget += utils.num(project.calcSheet.sumWithAdditionalCost);
          $scope.profitBudget += utils.num(project.calcSheet.totalProfit);
          var date = new Date();
          date.setHours(23, 59, 59, 0);
          var startDate = new Date(project.startDate);
          var endDate = new Date(project.endDate);
          endDate.setHours(23, 59, 59, 0);
          $scope.totalCompanyRevCost += utils.num(project.calcSheet.sumWithAdditionalCost) * utils.num(project.calcSheet.companyCost) / 100 * utils.progressOfDate(startDate, endDate, date, true);
        }
      });
      $scope.totalCompanyCost = $scope.totalBudget * $scope.costPercent / 100;
      $scope.inventoryBudget += $scope.totalCompanyCost;
      var isWip = false;

      if (item.wip === "wipSales") {
        data = $scope.auditWipData.sales;
        isWip = true;
      } else if (item.wip === "wipLabour") {
        data = $scope.auditWipData.labor;
        isWip = true;
      } else if (item.wip === "wipCosts") {
        data = $scope.auditWipData.proejctCost;
        isWip = true;
      } else if (item.wip === "wipContract") {
        data = $scope.auditWipData.contract;
        isWip = true;
      } else if (item.wip === "wipInvoiced") {
        data = $scope.auditWipData.invoiced;
        isWip = true;
      } else if (item.wip === "wipUpfront") {
        data = $scope.auditWipData.upfront;
        isWip = true;
      } else if (item.wip === "wipWip") {
        data = $scope.auditWipData.wip;
        isWip = true;
      } else if (item.wip === "wipAssets") {
        data = $scope.auditWipData.assetsCost;
        isWip = true;
      } else if (item.wip === "wipShort") {
        data = $scope.auditWipData.balanceCost;
        isWip = true;
      }

      if (isWip) {
        if (item.debit != 0) {
          item.debitWip = item.debit + data;
        } else if (item.credit != 0) {
          item.creditWip = item.credit + data;
        } else if (data > 0) {
          item.debitWip = data;
        } else if (data < 0) {
          item.creditWip = data;
        }
      }
    };

    vm.getSummayForWip = function (section) {
      section.summaries.forEach(function (summary) {
        summary.debitWip = 0;
        summary.creditWip = 0;
        section.items.forEach(function (wipItem) {
          summary.debitWip += wipItem.debitWip;
          summary.creditWip += wipItem.creditWip;
        });
      });
    };

    function getWipName(value) {
      switch (value) {
        case 'wipSales':
          return 'WIP - Sales (Statement)';

        case 'wipLabour':
          return 'WIP - Labour (Statement)';

        case 'wipCosts':
          return 'WIP - Costs (Statement)';

        case 'wipContract':
          return 'WIP - Contract (Balance/Current Assets)';

        case 'wipInvoiced':
          return 'WIP - Invoiced (Balance/Current Assets)';

        case 'wipUpfront':
          return 'WIP - Upfront Payment';

        case 'wipWip':
          return 'WIP - Work In Progress (Balance/Current Assets)';

        case 'wipAssets':
          return 'WIP - Costs (assets)';

        case 'wipShort':
          return 'WIP - Costs (Balance/Short-term debt)';
      }
    }

    vm.disableAfterEndDate = function (date) {
      return date > vm.endDate;
    };

    vm.disableBeforeStartDate = function (date) {
      return date < vm.startDate;
    };

    $scope.onChangeFinancialYear = function () {
      if ($scope.loading) return;
      var period = vm.financialYears.find(function (x) {
        return x.year == $scope.financialYear;
      });
      vm.fromDate = new Date(period.start);
      vm.fromDate.setHours(0, 0, 0, 0);
      vm.toDate = new Date(period.end);
      vm.toDate.setHours(23, 59, 59, 999);

      if ($scope.month >= 0 && $scope.month <= 11) {
        var monthDay = new Date(vm.fromDate.getFullYear(), $scope.month, 1);
        var days = monthDay.getDaysInMonth();
        vm.toDate = new Date(vm.fromDate.getFullYear(), $scope.month, days, 23, 59, 59, 999);
      } else if ($scope.month != -1) {
        return;
      }

      vm.fetchData();
    };

    $scope.dateFilterChanged = function () {
      if ($scope.loading) return;
      var fromDate = new Date(Date.UTC(vm.fromDate.getFullYear(), vm.fromDate.getMonth(), vm.fromDate.getDate()));
      var toDate = new Date(Date.UTC(vm.toDate.getFullYear(), vm.toDate.getMonth(), vm.toDate.getDate(), 23, 59, 59, 999));
      vm.fetchData(fromDate, toDate);
    };

    $scope.onChangeMonth = function () {
      if ($scope.loading) return;
      var period = vm.financialYears.find(function (x) {
        return x.year == $scope.financialYear;
      });
      vm.fromDate = new Date(period.start);
      vm.fromDate.setHours(0, 0, 0, 0);
      vm.toDate = new Date(period.end);
      vm.toDate.setHours(23, 59, 59, 999);

      if ($scope.month >= 0 && $scope.month <= 11) {
        var monthDay = new Date(vm.fromDate.getFullYear(), $scope.month, 1);
        var days = monthDay.getDaysInMonth();
        vm.fromDate = new Date(vm.fromDate.getFullYear(), $scope.month, 1);
        vm.toDate = new Date(vm.fromDate.getFullYear(), $scope.month, days, 23, 59, 59, 999);
      } else if ($scope.month != -1) {
        return;
      }

      vm.fetchData();
    };

    $scope.exportBalances = function () {
      $uibModal.open({
        animation: true,
        component: "exportModal",
        windowClass: "export-modal",
        backdrop: "static",
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.fileName;
        var format = result.format;

        if (format === "pdf") {
          fileName = fileName.toLowerCase().includes(".pdf") ? fileName : fileName + ".pdf";
        } else {
          fileName = fileName.toLowerCase().includes(".xlsx") ? fileName : fileName + ".xlsx";
        } // vm.fromDate = new Date($scope.financialYear, 0, 1);
        // if ($scope.month === -1) {
        //   vm.toDate = new Date($scope.financialYear, 11, 31, 23, 59, 59, 999);
        // } else if ($scope.month >= 0 && $scope.month <= 11) {
        //   let monthDay = new Date($scope.financialYear, $scope.month, 1);
        //   let days = monthDay.getDaysInMonth();
        //   vm.toDate = new Date($scope.financialYear, $scope.month, days, 23, 59, 59, 999);
        // }


        var query = {
          fromDate: vm.fromDate,
          toDate: vm.toDate,
          hideZeroBalance: $scope.hideZeroBalance,
          isOnlyApprovedBills: $scope.isOnlyApprovedBills,
          // search: $scope.searchText,
          fileName: fileName,
          financialYear: $scope.financialYear
        };

        if (format === "pdf") {
          $scope.loading = true;
          apiFactory.exportAccountPlanBalancesToPdf(query).then(function (res) {
            utils.downloadFile(res.data.url, fileName).then(function () {
              $scope.loading = false;
              $timeout(function () {
                return $scope.$apply();
              });
            })["catch"](function (err) {
              $scope.loading = false;
              $log.error(err);
              Notification.error("Failed to download.");
            });
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        } else {
          $scope.loading = true;
          apiFactory.exportAccountPlanBalancesToExcel(query).then(function (res) {
            $scope.loading = false;
            var blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            FileSaver.saveAs(blob, fileName);
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        }
      })["catch"](function () {});
    };

    $scope.onChangeFilterType = function () {};

    function init() {
      vm.financialYears = [];
      vm.compareYears = [];
      vm.filterTypes = [{
        label: 'All',
        value: 0
      }, {
        label: 'Statement',
        value: 1
      }, {
        label: 'Balance',
        value: 2
      }, {
        label: 'Bank',
        value: 3
      }];
      vm.periodTypes = [{
        label: 'All',
        value: 'all'
      }, {
        label: 'Accounting Period',
        value: 'accounting'
      }, {
        label: 'Primo Balance',
        value: 'primo'
      } // {
      //   label: 'See in Period',
      //   value: 'custom'
      // },
      ];
      $scope.loading = true;
      Promise.all([apiFactory.listAccountPlanSections(), apiFactory.listAllAuditProjects(), apiFactory.getEconomicBalanceSetting(), apiFactory.getWipItems()]).then(function (res) {
        $scope.loading = false;
        vm.accountSections = res[0].data.list;
        vm.projects = res[1].data.list;
        vm.financialYears = res[2].data.list;
        vm.auditWipItems = res[3].data.data;
        vm.auditWipItems.forEach(function (x) {
          $scope.auditWipData.sales += x.wip.sales;
          $scope.auditWipData.proejctCost += x.wip.proejctCost;
          $scope.auditWipData.labor += x.wip.labor;
          $scope.auditWipData.contract += x.wip.contract;
          $scope.auditWipData.invoiced += x.wip.invoiced;
          $scope.auditWipData.upfront += x.wip.upfront;
          $scope.auditWipData.wip += x.wip.wip;
          $scope.auditWipData.assetsCost += x.wip.assetsCost;
          $scope.auditWipData.balanceCost += x.wip.balanceCost;
        });

        if (!vm.financialYears[0]) {
          Notification.error('Please check economic setting, finance years.');
        } else {
          $scope.financialYear = vm.financialYears[0].year;
          vm.months = [{
            label: $filter('translate')("All"),
            value: -1
          }, {
            label: "Jan",
            value: 0
          }, {
            label: "Feb",
            value: 1
          }, {
            label: "Mar",
            value: 2
          }, {
            label: "Apr",
            value: 3
          }, {
            label: "May",
            value: 4
          }, {
            label: "Jun",
            value: 5
          }, {
            label: "Jul",
            value: 6
          }, {
            label: "Aug",
            value: 7
          }, {
            label: "Sep",
            value: 8
          }, {
            label: "Oct",
            value: 9
          }, {
            label: "Nov",
            value: 10
          }, {
            label: "Dec",
            value: 11
          }];
          $scope.onChangeMonth();
        } // $scope.compareYear = lastYear;

      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    init();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('hierarchyTemplates', {
    controller: hierarchyTemplatesController,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/hierarchyTemplates/hierarchyTemplates.view.html'
  });
  /** @ngInject */

  function hierarchyTemplatesController($scope, apiFactory, Notification, $uibModal) {
    $scope.loading = true;
    apiFactory.getHierarchyTemplates().then(function (res) {
      $scope.loading = false;
      $scope.templates = res.data.list;
    })["catch"](function (err) {
      $scope.loading = false;
      Notification.error(err.data.message || 'Could not be load hierarchy templates.');
    });

    $scope.showTemplate = function (_template) {
      var modal = $uibModal.open({
        animation: true,
        component: 'hierarchyTemplateTreeModal',
        windowClass: 'hierarchy-template-tree-modal',
        resolve: {
          template: function template() {
            return _template;
          }
        }
      });
      modal.result.then(function () {}, function () {});
    };

    $scope.applyTemplate = function (template) {
      $scope.loading = true;
      apiFactory.updateHierarchyTreeToLatest(template).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message || 'Set to latest version successfully');
        template.updatedAt = res.data.data.updatedAt;
        $scope.templates.sort(function (a, b) {
          var aVal = new Date(a.updatedAt);
          var bVal = new Date(b.updatedAt);

          if (aVal < bVal) {
            return 1;
          } else if (aVal > bVal) {
            return -1;
          } else {
            return 0;
          }
        });
      })["catch"](function (err) {
        Notification.error(err.data.message || 'Failed to set to latest version');
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('fileManageList', {
    controller: FileManageListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/fileManageList/fileManageList.view.html'
  });
  /** @ngInject */

  function FileManageListController($rootScope, $element, $scope, $log, $document, $uibModal, globals, fileManagerFactory, apiFactory, Notification, $window, utils) {
    var vm = this;
    var projectStore = globals.projectStore,
        companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.selectedProject = projectStore.get();
    vm.companyData = companyStore.get();
    vm.userData = userStore.get();
    vm.stackFolders = [];
    $scope.FMANAGER_ACCESS_CREATE = 100;
    $scope.selectedVendor = null;
    $scope.selFolders = [];
    $scope.selFiles = []; // let dType = globals.getDashboardType(vm.userData);

    $scope.$on('selected-project', function (event, data) {
      vm.selectedProject = data;
    }); // if (vm.userData.designation == "Admin") {
    //   $scope.FMANAGER_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.FMANAGER]
    //   }).then(res => {
    //     $scope.loading = false;
    //     $scope.FMANAGER_ACCESS_CREATE = res.data.data[Constants.AccessKey.FMANAGER];
    //   })
    //   .catch((e) => {
    //     $scope.loading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    var colors = ["#FFB900", "#D83B01", "#B50E0E", "#E81123", "#B4009E", "#5C2D91", "#0078D7", "#00B4FF", "#008272", "#107C10"];
    vm.selectedData = {};
    vm.currentFolders = [];
    vm.currentFiles = [];
    vm.currentFilteredFolders = [];
    vm.currentFilteredFiles = [];
    vm.selectedFolderType = 'project';
    vm.isPreview = false; // vm.previewType = 'folder';

    vm.previewFileType = 'img';
    vm.selectedAll = false;
    vm.isVersionView = false;
    vm.isCopyMove = false;

    $scope.initVariables = function () {
      vm.currentFolders = [];
      vm.currentFiles = [];
      vm.isPreview = false; // vm.previewType = 'folder';
    };

    $scope.searchCallback = function () {
      $rootScope.$emit('searchItem', $scope.searchText);
    };

    var searchItemCallback = $rootScope.$on('searchItem', function (event, searchText) {
      if (utils.isEmpty(searchText)) {
        vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
        vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
      }

      vm.currentFilteredFiles = vm.currentFiles.filter(function (x) {
        return x.originalname.toLowerCase().includes(searchText.toLowerCase());
      });
      vm.currentFilteredFolders = vm.currentFolders.filter(function (x) {
        return x.name.toLowerCase().includes(searchText.toLowerCase());
      });
    });
    $rootScope.$on('$destroy', searchItemCallback); // $scope.toggled = function (open) {
    // };

    vm.resolveAssetIcon = function (assetObj) {
      var assetFormat = assetObj.format.trim(),
          icon;

      if (/jp*g/.test(assetFormat)) {
        icon = "jpg";
      } else if (/png/.test(assetFormat)) {
        icon = "png";
      } else if (/pdf/.test(assetFormat)) {
        icon = "pdf";
      }

      return icon;
    };

    $scope.$on('initialize', function (event, data) {
      loadRootFolder(data);
    });
    $scope.$on("change_folder_type", function (event, folderType) {
      vm.selectedFolderType = folderType;
      $scope.initVariables();
      loadRootFolder();
      vm.isPreview = false;
      vm.previewType = null;
      vm.isVersionView = false;
    });
    $scope.$on('open-file-viewer-modal', function (event, data) {
      vm.openFileViewer(data.type);
    });
    $scope.$on('select_root_item', function (event, type) {
      vm.selectedFolderType = type;
      vm.parentFolder = null;
      vm.breadCrumbList = [];
      vm.isVersionView = false;
      vm.getPrimaryFolders();
    });
    $scope.$on('change_folder', function (event, folder) {
      vm.isVersionView = false;
      vm.showChildHierarchy(folder);
    });
    $scope.$on('manage_versions', function () {
      if (!utils.isEmpty($scope.getSelectedFolders())) {
        Notification.error('Please select only a file.');
        return;
      }

      var selectedFiles = $scope.getSelectedFiles();

      if (utils.isEmpty(selectedFiles)) {
        Notification.error('Please select a file to manage versions.');
        return;
      }

      if (selectedFiles.length > 1) {
        Notification.error('Please select only one file.');
        return;
      }

      vm.isVersionView = true;
    });
    $scope.$on('send_approval', function () {
      var hierarchyIds = vm.currentFolders.map(function (x) {
        return x._id;
      });
      var assetIds = vm.currentFiles.map(function (x) {
        return x._id;
      });
      var APIs = [];

      if (!utils.isEmpty(hierarchyIds)) {
        APIs.push(apiFactory.notifyHierarchiesPermStatus({
          hierarchyIds: hierarchyIds
        }));
      }

      if (!utils.isEmpty(assetIds)) {
        APIs.push(apiFactory.notifyAssetsPermStatus({
          assetIds: assetIds
        }));
      }

      $scope.loading = true;
      Promise.all(APIs).then(function () {
        $scope.loading = false;
        Notification.success('Send for approval successfully.');
        $scope.$emit('clear_permission_count');
        vm.showChildHierarchy(vm.parentFolder);
      })["catch"](function () {
        $scope.loading = false;
        Notification.error('Could not send approval');
      });
    });

    vm.viewIcon = function (file) {
      var extension;

      if (angular.isObject(vm.parentFolder) && vm.parentFolder.is3DFolder) {
        var name = file.sourceUrl.split('/')[file.sourceUrl.split('/').length - 1];
        extension = name.split('.')[name.split('.').length - 1];
      } else {
        extension = file.format;
      }

      if (extension) {
        extension = extension.toLowerCase();
      }

      return utils.getFMFileIcon(extension);
    };

    vm.getTitleStr = function () {
      var titleStr = vm.parentFolder && vm.parentFolder.name ? vm.parentFolder.name : utils.capitaliseFirstLetter(vm.selectedFolderType);
      return titleStr;
    };

    vm.getPrimaryFolders = function () {
      if (vm.selectedFolderType === 'project' || vm.selectedFolderType === 'company' || vm.selectedFolderType === 'personal') {
        vm.parentFolder = null;
      }

      $scope.$emit('select_root_folder', vm.selectedFolderType);

      switch (vm.selectedFolderType) {
        case 'company':
          $scope.loading = true;
          apiFactory.getCompanyHierarchy().then(function (resp) {
            $scope.loading = false;
            vm.currentFolders = resp.data.data.hierarchies;
            vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
            vm.currentFiles = resp.data.data.rootFiles;
            vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
            reloadSelectedData();
          })["catch"](function (err) {
            $scope.loading = false;
            Notification.error(utils.getErrorMessage(err));
          });
          break;

        case 'project':
          $scope.loading = true;
          apiFactory.getProjectHierarchy({
            projectId: vm.selectedProject._id
          }).then(function (resp) {
            $scope.loading = false;
            vm.currentFolders = resp.data.data.hierarchies;
            vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
            vm.currentFiles = resp.data.data.rootFiles;
            vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
            reloadSelectedData();
          })["catch"](function (e) {
            $scope.loading = false;
            $log.error(e);
          });
          break;

        case 'personal':
          $scope.loading = true;
          apiFactory.getPersonalHierarchy().then(function (resp) {
            $scope.loading = false;
            vm.currentFolders = resp.data.data.hierarchies;
            vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
            vm.currentFiles = resp.data.data.rootFiles;
            vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
            reloadSelectedData();
          })["catch"](function (e) {
            $scope.loading = false;
            $log.error(e);
          });
          break;

        default:
          $scope.loading = true;
          apiFactory.getProjectHierarchy({
            projectId: vm.selectedProject._id
          }).then(function (resp) {
            $scope.loading = false;
            vm.currentFolders = resp.data.data.hierarchies;
            vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
            vm.currentFiles = resp.data.data.rootFiles;
            vm.currentFilteredFolders = Object.assign([], vm.currentFiles);
            reloadSelectedData();
          })["catch"](function (e) {
            $scope.loading = false;
            $log.error(e);
          });
      }
    };

    $scope.openPermission = function (isFolder, item) {
      item.isFolder = isFolder;
      var modal = $uibModal.open({
        animation: true,
        component: 'filePermissionModal',
        windowClass: 'fm-file-permission-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          items: function items() {
            return [item];
          }
        }
      });
      modal.result.then(function () {
        $scope.$emit('add_permission_count', 1);
        vm.showChildHierarchy(vm.parentFolder);
      }, function (reason) {
        $log.error(reason);
      });
    };

    vm.openFileViewer = function (_type) {
      var fileViewerModal = $uibModal.open({
        animation: true,
        // size: 'sm',
        component: 'fileViewerModal',
        resolve: {
          data: function data() {
            return vm.selectedData;
          },
          type: function type() {
            return _type;
          }
        },
        backdrop: 'static',
        keyboard: true,
        windowClass: 'file-viewer-modal',
        windowTopClass: 'file-viewer-modal-wrapper'
      });
      fileViewerModal.result.then(function () {}, function () {});
    };

    vm.show3dFolder = function (folder) {
      var projectId = projectStore.get()._id;

      $scope.loading = true;
      apiFactory.list3d(projectId).then(function (resp) {
        $scope.loading = false;
        vm.parentFolder = folder;
        $scope.$emit('change_folder_child', {
          _id: folder._id
        });
        vm.currentFiles = resp.data.data || [];
        vm.currentFiles = vm.currentFiles.map(function (x) {
          x.format = 'ifc';
          return x;
        });
        vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
        vm.currentFolders = [];
        vm.currentFilteredFolders = []; // reloadSelectedData();

        vm.breadCrumbList = [{
          _id: 'project',
          name: 'Project'
        }, {
          name: '3D Files',
          _id: folder._id
        }];
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);
      });
    };

    function reloadSelectedData() {
      var id = vm.selectedData ? vm.selectedData._id : null;

      if (vm.previewType === 'folder') {
        vm.selectedData = vm.currentFilteredFolders.find(function (x) {
          return x._id === id;
        });
      } else {
        vm.selectedData = vm.currentFilteredFiles.find(function (x) {
          return x._id === id;
        });
      }
    }

    vm.showChildHierarchy = function (folder) {
      vm.selectedAll = false;

      if (folder) {
        if (folder.is3DFolder) {
          vm.show3dFolder(folder);
        } else {
          vm.stackFolders.push(folder);
          $scope.loading = true;
          apiFactory.viewHierarchy(folder._id).then(function (resp) {
            $scope.loading = false;
            vm.parentFolder = folder;
            $scope.$emit('change_folder_child', vm.parentFolder);
            vm.currentFiles = resp.data.files;
            vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
            vm.currentFolders = resp.data.folders;
            vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
            vm.breadCrumbList = resp.data.breadcrumbs;
            reloadSelectedData();

            switch (vm.selectedFolderType) {
              case 'project':
                vm.breadCrumbList.unshift({
                  _id: 'project',
                  name: 'Project'
                });
                break;

              case 'company':
                vm.breadCrumbList.unshift({
                  _id: 'company',
                  name: 'Company'
                });
                break;

              case 'personal':
                vm.breadCrumbList.unshift({
                  _id: 'personal',
                  name: 'Personal'
                });
                break;
            }
          })["catch"](function (err) {
            $scope.loading = false;
            Notification.error(utils.getErrorMessage(err));
          });
        }
      } else {
        loadRootFolder();
      }
    };

    vm.addFolder = function () {
      var newFolderModal = $uibModal.open({
        animation: true,
        component: 'createFolderModal',
        windowClass: 'fm-create-folder-modal',
        backdrop: 'static',
        keyboard: false
      });
      newFolderModal.result.then(function (name) {
        var payload;

        if (vm.parentFolder) {
          payload = {
            name: name,
            isParent: false,
            parent: vm.parentFolder._id
          };
        } else {
          payload = {
            name: name,
            isParent: true,
            parentType: vm.selectedFolderType,
            projectId: vm.selectedProject._id
          };
        }

        apiFactory.addHierarchy(payload).then(function (resp) {
          vm.currentFolders.push(resp.data.data);
          vm.currentFilteredFolders.push(resp.data.data);

          if (!vm.parentFolder) {
            $scope.$emit('add_root_folder', {
              type: vm.selectedFolderType,
              folder: resp.data.data
            });
          } else {
            $scope.$emit('add_sub_folder', {
              type: vm.selectedFolderType,
              folder: resp.data.data,
              parentFolder: vm.parentFolder
            });
          }

          Notification.success(resp.data.message);
        })["catch"](function (e) {
          $log.error(e);
        });
      }, function (reason) {
        $log.error('err', reason);
      });
    };

    vm.clipboard = function (mode) {
      if (!$scope.getSelectedFolders().length && !$scope.getSelectedFiles().length) {
        var confirmModal = $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function data() {
              return {
                title: 'Confirm copy or move files',
                message: 'No files selected.',
                subMessage: 'Select the folder or file.',
                confirmButtonText: 'OK',
                icon: '/assets/icons/status-warning.svg'
              };
            }
          }
        });
        confirmModal.result.then(function () {
          return;
        }, function (reason) {
          $log.info(reason);
        });
      } else {
        vm.isCopyMove = true;
        var req = {
          folders: $scope.getSelectedFolders(),
          files: $scope.getSelectedFiles(),
          mode: mode
        };

        if (vm.parentFolder) {
          req.parentId = vm.parentFolder._id;
        }

        req.sourceType = vm.selectedFolderType;
        vm.clipboardMode = mode;
        fileManagerFactory.clipBoard.copy(req);
      }
    };
    /** drag and drop */


    vm.dragDrop = function (selFolder, selFile, mode) {
      $scope.selFiles = [];
      $scope.selFiles.push(selFile);
      var req = {
        folders: $scope.selFolders,
        files: $scope.selFiles,
        mode: mode
      };

      if (vm.parentFolder) {
        req.parentId = vm.parentFolder._id;
      }

      req.sourceType = vm.selectedFolderType;
      vm.clipboardMode = mode;
      fileManagerFactory.clipBoard.copy(req);
      vm.parentFolder = selFolder;
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Confirm move files',
              message: 'Are you sure to move files?',
              subMessage: 'Click OK button to continue',
              confirmButtonText: 'OK',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      });
      confirmModal.result.then(function () {
        paste();
      }, function (reason) {
        $log.info(reason);
      });
    };

    function paste() {
      var req = {
        projectId: vm.selectedProject._id
      };

      if (vm.parentFolder) {
        req.destId = vm.parentFolder._id;
      } else {
        req.rootType = vm.selectedFolderType;

        if (vm.selectedFolderType === 'project') {
          req.projectId = vm.selectedProject._id;
        }
      }

      $scope.loading = true;
      fileManagerFactory.clipBoard.paste(req).then(function () {
        $scope.loading = false;

        if (vm.clipboardMode === 1) {
          $scope.$emit('remove_folders', {
            data: fileManagerFactory.clipBoard.getBuffer().folders
          });
        }

        if (!vm.parentFolder) {
          fileManagerFactory.clipBoard.getBuffer().folders.forEach(function (folder) {
            folder.parentType = vm.selectedFolderType;
            folder.isParent = true;
            $scope.$emit('add_root_folder', {
              type: vm.selectedFolderType,
              folder: folder
            });
          });
        } else {
          fileManagerFactory.clipBoard.getBuffer().folders.forEach(function (folder) {
            folder.isParent = false;
            folder.parent = vm.parentFolder._id;
            $scope.$emit('add_sub_folder', {
              type: vm.selectedFolderType,
              folder: folder,
              parentFolder: vm.parentFolder
            });
          });
        }

        fileManagerFactory.clipBoard.emptyClipboard();
        vm.isCopyMove = false;
        vm.showChildHierarchy(vm.parentFolder);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    }

    vm.paste = function () {
      var folders = fileManagerFactory.clipBoard.getBuffer().folders;
      var files = fileManagerFactory.clipBoard.getBuffer().files;
      var apis = [];
      var query = {};

      if (!utils.isEmpty(folders)) {
        query = {
          names: folders.map(function (folder) {
            return folder.name;
          })
        };

        if (vm.parentFolder) {
          query.hierarchyId = vm.parentFolder._id;
        } else {
          query.parentType = vm.selectedFolderType || 'project';
          query.companyId = vm.companyData._id;
          query.projectId = vm.selectedProject._id;
        }

        apis.push(apiFactory.existsHierarchiesByNames(query));
      }

      if (!utils.isEmpty(files)) {
        query = {
          names: files.map(function (file) {
            return file.originalname;
          })
        };

        if (vm.parentFolder) {
          query.hierarchyId = vm.parentFolder._id;
        } else {
          query.parentType = vm.selectedFolderType || 'project';
          query.companyId = vm.companyData._id;
          query.projectId = vm.selectedProject._id;
        }

        apis.push(apiFactory.existsAssetsByNames(query));
      }

      $scope.loading = true;
      Promise.all(apis).then(function (res) {
        $scope.loading = false;
        var names = [];
        var exists0 = res[0].data.data;

        if (!utils.isEmpty(exists0)) {
          names = exists0.map(function (x) {
            return x.name ? x.name : x.originalname;
          });
        }

        if (res[1] && res[1].data && res[1].data.data) {
          var exists1 = res[1].data.data;

          if (!utils.isEmpty(exists1)) {
            names = names.concat(exists1.map(function (x) {
              return x.name ? x.name : x.originalname;
            }));
          }
        }

        if (!utils.isEmpty(names)) {
          var strNames = names.join(', ');
          var confirmModal = $uibModal.open({
            animation: true,
            component: 'confirmModal',
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              data: function data() {
                return {
                  title: 'Confirm replace folder or files',
                  message: "The destination already have folders or files named '".concat(strNames, "'"),
                  subMessage: 'Are you sure replace the folders or files in the destination?',
                  confirmButtonText: 'Replace',
                  icon: '/assets/icons/status-warning.svg'
                };
              }
            }
          });
          confirmModal.result.then(function () {
            paste();
          }, function (reason) {
            $log.info(reason);
          });
        } else {
          paste();
        }
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.cancelPaste = function () {
      vm.isCopyMove = false;
      fileManagerFactory.clipBoard.emptyClipboard();
    };

    vm.rewindFolder = function () {
      vm.showChildHierarchy(vm.parentFolder);
    };

    vm.rename = function () {
      var selectedFolder = $scope.getSelectedFolders()[0];
      var selectedFile = $scope.getSelectedFiles()[0];

      var _type2 = angular.isDefined(selectedFolder) ? 0 : selectedFile.format == 'ifc' ? 2 : 1;

      var _name = _type2 ? selectedFile.originalname || selectedFile.assetName || selectedFile.name : selectedFolder.name;

      var renameModal = $uibModal.open({
        animation: true,
        component: 'renameModal',
        windowClass: 'fm-rename-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          name: function name() {
            return _name;
          },
          type: function type() {
            return _type2;
          }
        }
      });
      renameModal.result.then(function (name) {
        var payload = {
          name: name,
          type: _type2,
          id: _type2 ? selectedFile._id : selectedFolder._id
        };
        $scope.loading = true;
        apiFactory.renameFMItem(payload).then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message || 'Renamed successfully.');
          vm.showChildHierarchy(vm.parentFolder);

          if (_type2 === 0 && !vm.parentFolder) {
            $scope.$emit('rename_root_folder', {
              type: vm.selectedFolderType,
              folder: res.data.data
            });
          } else if (_type2 === 0 && vm.parentFolder) {
            $scope.$emit('rename_sub_folder', {
              type: vm.selectedFolderType,
              folder: res.data.data
            });
          }
        })["catch"](function (err) {
          $scope.loading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      }, function (reason) {
        $log.error(reason);
      });
    };

    vm.moveTo = function () {
      vm.clipboard(1);
      var modal = $uibModal.open({
        animation: true,
        component: 'folderPickerModal',
        keyboard: false,
        windowClass: 'folder-picker-modal',
        resolve: {
          data: function data() {
            return {
              selectedFolderType: vm.selectedFolderType,
              parentFolder: vm.parentFolder,
              isMoveTo: true
            };
          }
        }
      });
      modal.result.then(function result(result) {
        if (angular.isUndefined(result.parentType)) {
          vm.selectedFolderType = result._id;
        } else {
          vm.parentFolder = result;
        }

        paste();
      }, function (reason) {
        fileManagerFactory.clipBoard.emptyClipboard();
        $log.error(reason);
      });
    };

    vm.shareFiles = function () {
      if (!vm.selectedProject) {
        Notification.error('Please select project first');
        return;
      }

      var selectedFiles = $scope.getSelectedFiles();

      if (selectedFiles.length) {
        $uibModal.open({
          animation: true,
          component: 'fileShareModal',
          windowClass: 'fm-file-share-modal',
          backdrop: 'static',
          keyboard: false
        }).result.then(function (res) {
          apiFactory.shareFileViaEmail({
            projectName: vm.selectedProject.projectName,
            tos: res,
            attachments: selectedFiles.map(function (it) {
              return {
                name: it.originalname,
                url: it.secure_url ? encodeURI(it.secure_url) : encodeURI(it.location)
              };
            }),
            company: vm.companyData
          }).then(function () {
            Notification.success("Successfully Shared.");
          })["catch"](function (err) {
            $log.error(err);
            Notification.error("Share files failed.");
          });
        }, function (reason) {
          $log.error('err', reason);
        });
      } else {
        Notification.error('Select file to share.');
      }
    };

    vm.starItems = function () {
      var selectedFolders = $scope.getSelectedFolders();
      var selectedFiles = $scope.getSelectedFiles();

      if (selectedFolders.length) {
        Promise.all(selectedFolders.map(function (folder) {
          apiFactory.starFolder(folder._id).then(function (res) {
            if (res) {
              if (res.star) {
                Notification.success("Folder '" + folder.name + "' was stared successfully.");
              } else {
                Notification.success("Folder '" + folder.name + "' was unstared successfully.");
              }
            } else {
              $log.error(res);
              Notification.error("Starring Folder '" + folder.name + "' was failed");
            }
          });
        })).then(function () {
          vm.showChildHierarchy(vm.parentFolder);
        });
      }

      if (selectedFiles.length) {
        Promise.all(selectedFiles.map(function (file) {
          if (file.format == 'ifc') {
            apiFactory.starModel3D(file._id).then(function (res) {
              if (res) {
                if (res.star) {
                  Notification.success("File '" + file.name + "' was stared successfully.");
                } else {
                  Notification.success("File '" + file.name + "' was unstared successfully.");
                }
              } else {
                $log.error(res);
                Notification.error("Starring file '" + file.name + "' was failed");
              }
            });
          } else {
            apiFactory.starAsset(file._id).then(function (res) {
              if (res) {
                if (res.star) {
                  Notification.success("File '" + file.originalname + "' was stared successfully.");
                } else {
                  Notification.success("File '" + file.originalname + "' was unstared successfully.");
                }
              } else {
                $log.error(res);
                Notification.error("Starring file '" + file.originalname + "' was failed");
              }
            });
          }
        })).then(function () {
          vm.showChildHierarchy(vm.parentFolder);
        });
      }
    };

    vm.openFileUploadModal = function () {
      var modal = $uibModal.open({
        animation: true,
        component: 'fileUploadModal',
        windowClass: 'fm-file-upload-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              hierarchyId: vm.parentFolder ? vm.parentFolder._id : null,
              parentType: vm.selectedFolderType || 'project',
              companyId: vm.companyData._id,
              projectId: vm.selectedProject._id,
              parentFolder: vm.parentFolder
            };
          }
        }
      });
      modal.result.then(function (result) {
        if (result) {
          vm.showChildHierarchy(vm.parentFolder);
        }
      });
    };

    vm.previewFolder = function (folder) {
      vm.selectedData = folder;
      vm.isPreview = true;
      vm.previewType = 'folder';
    };

    vm.previewFile = function (file) {
      if (file.mimetype && file.mimetype === 'application/pdf') {
        // $scope.loading = true;
        // pdfFactory.getImageByUrl(file.secure_url, 1, 4096)
        //   .then(imgData => {
        //     $scope.loading = false;
        //     file.data_url = imgData.image;
        //     vm.selectedData = file;
        //     vm.isPreview = true;
        //     vm.previewType = 'file';
        //     if (angular.isObject(vm.parentFolder) && vm.parentFolder.is3DFolder) {
        //       vm.previewFileType = '3d';
        //     } else if (angular.isObject(vm.parentFolder) && vm.parentFolder.is2DFolder) {
        //       vm.previewFileType = '2d';
        //     } else {
        //       vm.previewFileType = 'others';
        //     }
        //     $scope.$apply();
        //   })
        //   .catch(() => {
        //     $scope.loading = false;
        //   })
        vm.selectedData = file;
        vm.isPreview = true;
        vm.previewType = 'file';

        if (angular.isObject(vm.parentFolder) && vm.parentFolder.is3DFolder) {
          vm.previewFileType = '3d';
        } else {
          vm.previewFileType = 'others';
        }
      } else {
        vm.selectedData = file;
        vm.isPreview = true;
        vm.previewType = 'file';

        if (angular.isObject(vm.parentFolder) && vm.parentFolder.is3DFolder) {
          vm.previewFileType = '3d';
        } else {
          vm.previewFileType = 'others';
        }
      }
    };

    vm.onClickSharedFolder = function () {
      $scope.loading = true;
      apiFactory.getSharedFolderItems().then(function (resp) {
        $scope.loading = false;
        vm.currentFiles = resp.data.files;
        vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
        vm.currentFolders = resp.data.folders;
        vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
        vm.breadCrumbList = resp.data.breadcrumbs;
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);
      });
    };

    vm.selectAll = function () {
      if (vm.selectedAll) {
        vm.currentFolders.map(function (item) {
          return item.selected = true;
        });
        vm.currentFiles.map(function (item) {
          return item.selected = true;
        });
        vm.currentFilteredFolders.map(function (item) {
          return item.selected = true;
        });
        vm.currentFilteredFiles.map(function (item) {
          return item.selected = true;
        });
      } else {
        vm.currentFolders.map(function (item) {
          return item.selected = false;
        });
        vm.currentFiles.map(function (item) {
          return item.selected = false;
        });
        vm.currentFilteredFolders.map(function (item) {
          return item.selected = false;
        });
        vm.currentFilteredFiles.map(function (item) {
          return item.selected = false;
        });
      }
    };

    $scope.getColor = function (name) {
      if (!name) {
        return;
      }

      name = name.replace(/"/g, '');
      var chars = name.split(' ');
      var codeNum = 0;

      if (chars.length < 2) {
        if (chars[0][0]) {
          codeNum = chars[0].charCodeAt(0);
        }
      } else {
        if (chars[0][0]) {
          codeNum = chars[0].charCodeAt(0);
        }

        if (chars[1][0]) {
          codeNum += chars[1].charCodeAt(0);
        }
      }

      return colors[codeNum % colors.length];
    };

    $scope.selectFolder = function (folder) {
      vm.isVersionView = false;

      var _folder = vm.currentFilteredFolders.find(function (x) {
        return x._id === folder._id;
      });

      if (_folder) {
        _folder.selected = folder.selected;
      }

      vm.selectedAll = false;
    };

    vm.selectFile = function (file) {
      var _file = vm.currentFilteredFiles.find(function (x) {
        return x._id === file._id;
      });

      if (_file) {
        _file.selected = file.selected;
      }

      vm.selectedAll = false;
    };

    vm.permissionItems = function () {
      var selectedFolders = $scope.getSelectedFolders();
      selectedFolders.forEach(function (x) {
        x.isFolder = true;
      });
      var selectedFiles = $scope.getSelectedFiles();
      selectedFiles.forEach(function (x) {
        x.isFolder = false;
      });

      if (!selectedFiles.length && !selectedFolders.length) {
        Notification.error('No selected items.');
        return;
      }

      var modal = $uibModal.open({
        animation: true,
        component: 'filePermissionModal',
        windowClass: 'fm-file-permission-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          items: function items() {
            return selectedFolders.concat(selectedFiles);
          }
        }
      });
      modal.result.then(function () {
        $scope.$emit('add_permission_count', 1);
        vm.showChildHierarchy(vm.parentFolder);
      }, function (reason) {
        $log.error(reason);
      });
    };

    vm.deleteItems = function () {
      if (!$scope.getSelectedFolders().length && !$scope.getSelectedFiles().length) {
        var confirmModal = $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function data() {
              return {
                title: 'Confirm delete files',
                message: 'No files selected.',
                subMessage: 'Select the folder or file.',
                confirmButtonText: 'OK',
                icon: '/assets/icons/status-warning.svg'
              };
            }
          }
        });
        confirmModal.result.then(function () {
          return;
        }, function (reason) {
          $log.info(reason);
        });
      } else {
        var selectedFolders = $scope.getSelectedFolders();
        var selectedFiles = $scope.getSelectedFiles();

        if (!selectedFiles.length && !selectedFolders.length) {
          Notification.error('No selected items.');
          return;
        }

        var _confirmModal = $uibModal.open({
          animation: true,
          component: 'confirmModal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false
        });

        _confirmModal.result.then(function (result) {
          if (result) {
            var payload = {
              folders: selectedFolders.map(function (item) {
                return item._id;
              }),
              files: selectedFiles.map(function (item) {
                return item._id;
              })
            };
            $scope.loading = true;
            apiFactory.deleteFMItems(payload).then(function () {
              $scope.loading = false;
              vm.currentFiles = vm.currentFiles.filter(function (item) {
                return item.selected !== true;
              });
              vm.currentFilteredFiles = vm.currentFilteredFiles.filter(function (item) {
                return item.selected !== true;
              });
              vm.removedFolders = $scope.getSelectedFolders();
              $scope.$emit('remove_folders', {
                type: vm.selectedFolderType,
                data: vm.removedFolders
              });
              vm.currentFolders = vm.currentFolders.filter(function (item) {
                return item.selected !== true;
              });
              vm.currentFilteredFolders = vm.currentFilteredFolders.filter(function (item) {
                return item.selected !== true;
              });
              vm.previewType = 'None';
            })["catch"](function (e) {
              $scope.loading = false;
              $log.error(e);
            });
          }
        }, function () {});
      }
    };

    vm.downloadFiles = function () {
      var files = $scope.getSelectedFiles();

      if (files.length) {
        var urls = files.map(function (x) {
          return x.secure_url;
        });
        utils.downloadFiles(urls).then(function () {
          $log.log('Done downloads: ', urls);
        })["catch"](function (err) {
          $log.error(err);
          Notification.error('Files could not be found.');
        });
      }
    };

    vm.goPrev = function () {
      if (vm.breadCrumbList.length > 2) {
        var parentFolder = vm.breadCrumbList[vm.breadCrumbList.length - 2];
        vm.showChildHierarchy(parentFolder);
      } else if (vm.breadCrumbList.length === 2) {
        vm.getPrimaryFolders();
      }
    };

    vm.goNext = function () {
      var folder = vm.stackFolders.pop();

      if (folder) {
        vm.showChildHierarchy(folder);
      }
    };

    vm.checkApp = function (item, isFolder) {
      var promise = isFolder ? apiFactory.updateHierarchyApp({
        hierarchyId: item._id,
        app: item.app
      }) : apiFactory.updateAssetApp({
        assetId: item._id,
        app: item.app
      });
      promise.then(function () {
        return $log.log('updated app');
      })["catch"](function (err) {
        return $log.error(err);
      });
    };

    vm.checkQshe = function (item, isFolder) {
      var promise = isFolder ? apiFactory.updateHierarchyQshe({
        hierarchyId: item._id,
        qshe: item.qshe
      }) : apiFactory.updateAssetQshe({
        assetId: item._id,
        qshe: item.qshe
      });
      promise.then(function () {
        return $log.log('updated qshe');
      })["catch"](function (err) {
        return $log.error(err);
      });
    };

    $scope.getSelectedFiles = function () {
      return utils.isEmpty(vm.currentFilteredFiles) ? [] : vm.currentFilteredFiles.filter(function (item) {
        return item.selected === true;
      });
    };

    $scope.getSelectedFolders = function () {
      return utils.isEmpty(vm.currentFilteredFolders) ? [] : vm.currentFilteredFolders.filter(function (item) {
        return item.selected === true;
      });
    };

    function getSelectedItems() {
      return $scope.getSelectedFolders().concat($scope.getSelectedFiles());
    }

    $scope.isSelectedFolder = function () {
      return $scope.getSelectedFolders().length > 0;
    };

    $scope.isSelectedFile = function () {
      return $scope.getSelectedFiles().length > 0;
    };

    $scope.isSelectedItem = function () {
      return $scope.isSelectedFile() || $scope.isSelectedFolder();
    };

    $scope.isOneSelectedItem = function () {
      return getSelectedItems().length === 1;
    };

    $scope.isAvailablePaste = function () {
      return !fileManagerFactory.clipBoard.isEmptyClipboard();
    };

    $scope.isAvailableUpload = function () {
      if ($scope.isSelectedItem() || $scope.isAvailablePaste()) {
        return false;
      }

      return !(vm.parentFolder && vm.parentFolder.is3DFolder);
    };

    $scope.isValidSelects = function () {
      var isDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var selectedFiles = $scope.getSelectedFiles();

      for (var i = 0; i < selectedFiles.length; i++) {
        var file = selectedFiles[i];

        if (!utils.isEmpty(file.webUrl)) {
          return false;
        }
      }

      if (isDelete) {
        var selectedFolders = $scope.getSelectedFolders();

        for (var _i = 0; _i < selectedFolders.length; _i++) {
          var folder = selectedFolders[_i];

          if (folder.is3DFolder) {
            return false;
          }
        }
      }

      return true;
    };

    vm.sortIndex = -1;
    vm.sortDirections = [false, // name desc
    false, // type desc
    false, // level desc
    false, // qshe desc
    false, // modified desc
    false, // status desc
    false // actions desc
    ];

    $scope.sortItems = function (index) {
      vm.sortIndex = index;
      var desc = vm.sortDirections[index];
      var attr;

      switch (index) {
        case 0:
          // Name
          attr = angular.isObject(vm.parentFolder) && vm.parentFolder.is3DFolder ? 'name' : 'originalname';

          if (desc) {
            vm.currentFilteredFolders.sort(function (a, b) {
              if (a.name > b.name) {
                return 1;
              } else if (a.name < b.name) {
                return -1;
              } else {
                return 0;
              }
            });
            vm.currentFilteredFiles.sort(function (a, b) {
              if (a[attr].name > b[attr].name) {
                return 1;
              } else if (a[attr].name < b[attr].name) {
                return -1;
              } else {
                return 0;
              }
            });
          } else {
            vm.currentFilteredFolders.sort(function (a, b) {
              if (b.name > a.name) {
                return 1;
              } else if (b.name < a.name) {
                return -1;
              } else {
                return 0;
              }
            });
            vm.currentFilteredFiles.sort(function (a, b) {
              if (b[attr].name > a[attr].name) {
                return 1;
              } else if (b[attr].name < a[attr].name) {
                return -1;
              } else {
                return 0;
              }
            });
          }

          break;

        case 1:
          // Type
          if (desc) {
            vm.currentFilteredFiles.sort(function (a, b) {
              if (a.format.toLowerCase() > b.format.toLowerCase()) {
                return 1;
              } else if (a.format.toLowerCase() < b.format.toLowerCase()) {
                return -1;
              } else {
                return 0;
              }
            });
          } else {
            vm.currentFilteredFiles.sort(function (a, b) {
              if (b.format.toLowerCase() > a.format.toLowerCase()) {
                return 1;
              } else if (b.format.toLowerCase() < a.format.toLowerCase()) {
                return -1;
              } else {
                return 0;
              }
            });
          }

          break;

        case 5:
          // Modified
          if (desc) {
            vm.currentFilteredFolders.sort(function (a, b) {
              var aVal = new Date(a.updatedAt);
              var bVal = new Date(b.updatedAt);

              if (aVal > bVal) {
                return 1;
              } else if (aVal < bVal) {
                return -1;
              } else {
                return 0;
              }
            });
            vm.currentFilteredFiles.sort(function (a, b) {
              var aVal = new Date(a.updatedAt);
              var bVal = new Date(b.updatedAt);

              if (aVal > bVal) {
                return 1;
              } else if (aVal < bVal) {
                return -1;
              } else {
                return 0;
              }
            });
          } else {
            vm.currentFilteredFolders.sort(function (a, b) {
              var aVal = new Date(a.updatedAt);
              var bVal = new Date(b.updatedAt);

              if (bVal > aVal) {
                return 1;
              } else if (bVal < aVal) {
                return -1;
              } else {
                return 0;
              }
            });
            vm.currentFilteredFiles.sort(function (a, b) {
              var aVal = new Date(a.updatedAt);
              var bVal = new Date(b.updatedAt);

              if (bVal > aVal) {
                return 1;
              } else if (bVal < aVal) {
                return -1;
              } else {
                return 0;
              }
            });
          }

          break;
        // case 3: // Size
        //   if (desc) {
        //     vm.currentFilteredFiles.sort(function (a, b) {
        //       let aVal = Number.parseInt(a.bytes);
        //       let bVal = Number.parseInt(b.bytes);
        //       return bVal - aVal;
        //     });
        //   } else {
        //     vm.currentFilteredFiles.sort(function (a, b) {
        //       let aVal = Number.parseInt(a.bytes);
        //       let bVal = Number.parseInt(b.bytes);
        //       return aVal - bVal;
        //     });
        //   }
        //   break;
      }

      vm.sortDirections[index] = !vm.sortDirections[index];
    };

    vm.sortIcons = ['/assets/icons/fm_arrow_downward_deactivated.svg', '/assets/icons/fm_arrow_upward_deactivated.svg', '/assets/icons/fm_arrow_downward.svg', '/assets/icons/fm_arrow_upward.svg'];

    $scope.getSortIcon = function (index) {
      var direction = vm.sortDirections[index];

      if (index === vm.sortIndex) {
        if (direction) {
          return vm.sortIcons[3];
        } else {
          return vm.sortIcons[2];
        }
      } else {
        if (direction) {
          return vm.sortIcons[1];
        } else {
          return vm.sortIcons[0];
        }
      }
    };

    $scope.viewVersionHistory = function (file) {
      vm.selectedAll = false;
      vm.currentFolders.map(function (item) {
        return item.selected = false;
      });
      vm.currentFiles.map(function (item) {
        return item.selected = false;
      });
      vm.currentFilteredFolders.map(function (item) {
        return item.selected = false;
      });
      vm.currentFilteredFiles.map(function (item) {
        return item.selected = false;
      });
      file.selected = true;
      vm.isVersionView = true;
    };

    $scope.onComeback = function () {
      vm.isVersionView = false;
      vm.showChildHierarchy(vm.parentFolder);
    };

    $scope.editFile = function (_file2) {
      var modal = $uibModal.open({
        animation: true,
        component: 'fileEditModal',
        windowClass: 'fm-file-edit-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          file: function file() {
            return _file2;
          }
        }
      });
      modal.result.then(function (data) {
        _file2.assetDescription = data.assetDescription;
        _file2.level = data.level;
      });
    };

    $scope.showPopup = function (event, fileId) {
      angular.element("#button-group-" + fileId).css('display', 'flex');
      angular.element("#button-group-" + fileId).css('left', event.clientX - 30 + 'px');
      angular.element("#button-group-" + fileId).css('top', event.clientY - 70 + 'px');
    };

    $scope.downloadFiles = function (fileId) {
      $scope.selFiles = [];
      $scope.selFiles.push(vm.currentFilteredFiles.find(function (b) {
        return b._id == fileId;
      }));

      if ($scope.selFiles.length) {
        var urls = vm.parentFolder && vm.parentFolder.is3DFolder ? $scope.selFiles.map(function (x) {
          return x.sourceUrl;
        }) : $scope.selFiles.map(function (x) {
          return x.secure_url;
        });
        utils.downloadFiles(urls).then(function () {
          $log.log('Done downloads: ', urls);
        })["catch"](function (err) {
          $log.error(err);
          Notification.error('Files could not be found.');
        });
      }
    };

    $scope.nameLetter = function (member) {
      return utils.nameLetter(member.firstName, member.lastName);
    };

    $scope.showFileMembers = function (event, fileId) {
      var selFile = vm.currentFilteredFiles.find(function (b) {
        return b._id == fileId;
      });

      if (selFile.members && selFile.members.length) {
        angular.element("#members-group-" + fileId).css('display', 'block');
        angular.element("#members-group-" + fileId).css('left', event.clientX - 30 + 'px');
        angular.element("#members-group-" + fileId).css('top', event.clientY - 70 + 'px');
      }
    };

    $scope.showFolderMembers = function (event, folderId) {
      var selFolder = vm.currentFilteredFolders.find(function (b) {
        return b._id == folderId;
      });

      if (selFolder.members && selFolder.members.length) {
        angular.element("#members-group-" + folderId).css('display', 'block');
        angular.element("#members-group-" + folderId).css('left', event.clientX - 30 + 'px');
        angular.element("#members-group-" + folderId).css('top', event.clientY - 70 + 'px');
      }
    };
    /** star Files */


    vm.starFiles = function (fileId) {
      var file = vm.currentFilteredFiles.find(function (b) {
        return b._id == fileId;
      });

      if (file.format == 'ifc') {
        apiFactory.starModel3D(file._id).then(function (res) {
          if (res) {
            if (res.data.star) {
              Notification.success("File '" + file.name + "' was stared successfully.");
            } else {
              Notification.success("File '" + file.name + "' was unstared successfully.");
            }
          } else {
            $log.error(res);
            Notification.error("Starring file '" + file.name + "' was failed");
          }
        });
      } else {
        apiFactory.starAsset(file._id).then(function (res) {
          if (res) {
            if (res.data.star) {
              Notification.success("File '" + file.originalname + "' was stared successfully.");
            } else {
              Notification.success("File '" + file.originalname + "' was unstared successfully.");
            }
          } else {
            $log.error(res);
            Notification.error("Starring file '" + file.originalname + "' was failed");
          }
        });
      }

      vm.showChildHierarchy(vm.parentFolder);
    };
    /** star Folders */


    vm.starFolders = function (folderId) {
      var folder = vm.currentFilteredFolders.find(function (b) {
        return b._id == folderId;
      });
      apiFactory.starFolder(folder._id).then(function (res) {
        if (res) {
          if (res.data.star) {
            Notification.success("Folder '" + folder.name + "' was stared successfully.");
          } else {
            Notification.success("Folder '" + folder.name + "' was unstared successfully.");
          }
        } else {
          $log.error(res);
          Notification.error("Starring Folder '" + folder.name + "' was failed");
        }

        vm.showChildHierarchy(vm.parentFolder);
      });
    };

    function loadRootFolder() {
      vm.parentFolder = null;
      vm.breadCrumbList = [];
      vm.getPrimaryFolders();
    }
    /** drag and drop */


    $element.on('dragover', function (event) {
      event.preventDefault();
    });
    $element.on('dragenter', function (event) {
      if (event.target.getAttribute('ref') == 'drop-zone') {
        event.target.style.background = '#E8E8E8';
      }
    });
    $element.on('drop', function (event) {
      event.preventDefault();

      if (event.target.getAttribute('ref') == 'drop-zone') {
        if (event.target.getAttribute('class').indexOf('angular-ui-tree-handle') !== -1) {
          event.target.style.border = 'none';
        } else {
          event.target.style.background = '';
        }

        var folderId = event.target.getAttribute('ref-id');
        var selFolder = vm.currentFilteredFolders.find(function (b) {
          return b._id == folderId;
        });

        if (selFolder) {
          $rootScope.$broadcast('selected-folder', selFolder);
          vm.dragDrop(selFolder, $scope.selectedVendor, 1);
          $scope.$apply();
        }
      }

      $scope.selectedVendor = null;
    });
    $element.on('dragstart', function (event) {
      $scope.selectedVendor = vm.currentFilteredFiles.find(function (v) {
        return v._id == event.target.getAttribute('vId');
      });
      $rootScope.$broadcast('selected-file', $scope.selectedVendor);
      $rootScope.$broadcast('parent-folder', vm.parentFolder);
    });
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('equipmentList', {
    controller: equipmentListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/equipments/equipmentList/equipmentList.view.html'
  });
  /** @ngInject */

  function equipmentListController($scope, apiFactory, localStorageService, $state, FileSaver, Notification, globals, $log) {
    var vm = this;
    var userStore = globals.userStore;
    $scope.EQ_ACCESS_CREATE = 100;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    }; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.EQ_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.EQ]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.EQ_ACCESS_CREATE = res.data.data[Constants.AccessKey.EQ];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }


    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.labelChecked = false;
    $scope.equipments = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.totalCountForGroup = 0;
    $scope.numPerPageForGroup = globals.numPerPage();
    $scope.noOfPagesForGroup = 0;
    vm.currentPageForGroup = 1;
    $scope.isLoading = false;
    $scope.isGrid = true;
    vm.searchText = undefined;
    vm.groupBy = null;
    vm.category = 'all';
    vm.isViewGroupList = false;
    vm.isViewGroupDetail = false;
    vm.selectedGroupName = '';
    vm.groupCategories = [{
      label: 'All',
      key: 'all'
    }, {
      label: 'GroupBy',
      key: 'group_by'
    }, {
      label: 'UnGrouped',
      key: 'other'
    }];
    vm.sortMenu = "createdAt";
    vm.sortMenuList = [{
      label: 'Name',
      key: 'name'
    }, {
      label: 'Created Date',
      key: 'createdAt'
    }, {
      label: 'Material Tag',
      key: 'systemTag'
    }];
    vm.currencies = [];
    globals.getCurrency().then(function (res) {
      vm.currencies = res.data;
    });

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.sortEquipments();
    };

    vm.fetchEquipmentGroup = function () {
      $scope.isLoading = true;
      var payload = {
        page: vm.currentPageForGroup,
        chunk: $scope.numPerPageForGroup
      };
      apiFactory.getAllEquipmentGroup(payload).then(function (resp) {
        $scope.isLoading = false;
        vm.equipmentGroup = resp.data.data;
        $scope.totalCountForGroup = resp.data.total;
        $scope.noOfPagesForGroup = Math.ceil($scope.totalCountForGroup / $scope.numPerPageForGroup);
        vm.isViewGroupList = true;
        vm.isViewGroupDetail = false;
      });
    };

    vm.sortEquipments = function () {
      $scope.isLoading = true;
      var payload = {
        sort: vm.sortMenu,
        sortType: "false",
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText
      };

      if (vm.category !== 'all') {
        if (vm.category === 'other') {
          payload.groupBy = vm.category;
        } else {
          payload.groupBy = vm.groupBy;
        }
      }

      apiFactory.listAllEquipments(payload).then(function (resp) {
        $scope.isLoading = false;
        $scope.equipments = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    vm.sortEquipments();

    $scope.goToDetail = function (equipmentId) {
      localStorageService.set('equipmentId', equipmentId);
      $state.go('equipmentDetail');
    };

    $scope.upLoadEQExcelFile = function (filetosave) {
      var filedata = {
        file: filetosave
      };
      apiFactory.uploadEquipmentExcel(filedata).then(function () {
        angular.element("#uploadEqModal").modal("hide");
        Notification.success("New Equipment saved.");
      })["catch"](function (err) {
        $log.error(err);
      });
    };

    $scope.downLoadEqExcel = function () {
      apiFactory.downLoadEqExcel().then(function (resp) {
        var blob = new Blob([resp.data], {
          type: "application/vnd.ms-excel;charset=utf-8"
        });
        FileSaver.saveAs(blob, "equipment.xlsx");
      })["catch"](function (err) {
        $log.error(err);
      });
    };

    vm.changedCategory = function () {
      if (vm.category !== 'group_by') {
        vm.isViewGroupList = false;
        vm.isViewGroupDetail = false;
        vm.sortEquipments();
      } else {
        vm.fetchEquipmentGroup();
      }
    };

    vm.showEquipmentByGroup = function (id) {
      vm.isViewGroupDetail = true;
      vm.isViewGroupList = false;
      vm.groupBy = id;
      var find = vm.equipmentGroup.find(function (elem) {
        return elem._id === id;
      });
      if (find) vm.selectedGroupName = find.name;
      vm.sortEquipments();
    };

    vm.showAllList = function () {
      vm.category = 'all';
      vm.sortEquipments();
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.sortEquipments();
    };

    $scope.switchViewMode = function (isGrid) {
      $scope.isGrid = isGrid;
    };

    $scope.getCurrencySymbol = function (equipment) {
      if (angular.isUndefined(equipment) || angular.isUndefined(equipment.currentRate) || angular.isUndefined(equipment.currentRate.equipmentCost.currencyCode)) {
        return 'Kr';
      }

      var find = vm.currencies.find(function (x) {
        return x.cc === equipment.currentRate.equipmentCost.currencyCode;
      });

      if (find) {
        return find.symbol;
      } else {
        return 'Kr';
      }
    };

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      $scope.materials.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('equipmentDetail', {
    controller: equipmentDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/equipments/equipmentDetail/equipmentDetail.view.html'
  });
  /** @ngInject */

  function equipmentDetailController( // NgMap,
  apiFactory, $stateParams, Notification, $scope, $state, utils, $timeout, $log, globals, $uibModal) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.EQ_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.EQ_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.EQ]
    //   }).then(res => {
    //     $scope.loading = false;
    //     $scope.EQ_ACCESS_CREATE = res.data.data[Constants.AccessKey.EQ];
    //   })
    //   .catch((e) => {
    //     $scope.loading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    vm.utils = utils;
    vm.equipmentId = $stateParams.id;
    $scope.loading = false;

    $scope.deleteEquipment = function () {
      apiFactory.deleteEquipmentById(vm.equipmentId).then(function (resp) {
        $state.go("equipmentList");
        Notification.success(resp.data.message);
      })["catch"](function () {
        Notification.error('Something went wrong try later');
      });
    };

    function getEquipmentDetail() {
      $scope.loading = true;
      apiFactory.getEquipmentById(vm.equipmentId).then(function (resp) {
        $scope.loading = false;
        vm.equipment = resp.data;
        vm.uploadImages = vm.equipment.files.images;
        vm.uploadFiles = vm.equipment.files.docs;
        vm.equipment.unit = resp.data.unit;
        vm.locationEq = vm.equipment.locationEq;

        if (vm.equipment.owned === true) {
          vm.equipment.owned = "Owned";
        } else {
          vm.equipment.owned = "Rented";
        }

        $scope.boxes = [{
          img: "/assets/icons/scale-white.svg",
          title: "Unit",
          unit: vm.equipment.unit
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Rental Cost",
          value: vm.equipment.currentRate.equipmentCost.value,
          currencyCode: vm.equipment.currentRate.equipmentCost.currencyCode
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Worker Cost",
          value: vm.equipment.currentRate.rooferCost.value,
          currencyCode: vm.equipment.currentRate.rooferCost.currencyCode
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Delivery Cost",
          value: vm.equipment.currentRate.equipmentCost.value,
          currencyCode: vm.equipment.currentRate.equipmentCost.currencyCode
        }];
        $timeout(imgSlider, 1500);
      })["catch"](function (err) {
        $log.error(err);
      });
    }

    getEquipmentDetail();

    function imgSlider() {
      angular.element(".slider").flexslider({
        animation: "slide",
        start: function start() {
          angular.element('body').removeClass('loading');
        }
      });
    }

    $scope.showImage = function (imageUrl) {
      $uibModal.open({
        animation: true,
        component: 'imageViewerModal',
        windowClass: 'image-viewer-modal',
        resolve: {
          imageURL: function imageURL() {
            return imageUrl;
          }
        }
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('editEquipment', {
    controller: EditEquipmentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/equipments/editEquipment/editEquipment.view.html'
  });
  /** @ngInject */

  function EditEquipmentController( // NgMap,
  $stateParams, apiFactory, $timeout, globals, $scope, Notification, $state, utils, $log, unitFactory) {
    var vm = this;
    vm.utils = utils;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.companyData = companyStore.get();
    vm.equipmentId = $stateParams.id;
    /* Get project list */

    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.mUnits = unitFactory.materialUnits();
    globals.getCurrency().then(function (resp) {
      vm.currencies = resp.data;
    });
    vm.workers = null;
    vm.unitList = [{
      label: 'hrs',
      value: 'hrs'
    }, {
      label: 'days',
      value: 'days'
    }, {
      label: 'weeks',
      value: 'weeks'
    }, {
      label: 'months',
      value: 'months'
    }, {
      label: 'm3',
      value: 'm3'
    }, {
      label: 'pcs',
      value: 'pcs'
    }];
    vm.chargingModeList = [{
      label: 'Yes',
      value: false
    }, {
      label: 'No',
      value: true
    }];
    vm.equipmentGroup = []; // image and file upload funtion -start

    vm.uploadImages = [];
    vm.uploadFiles = [];

    $scope.fileUpdated = function (files, type) {
      angular.forEach(files, function (x) {
        x.objectUrl = URL.createObjectURL(x);
        x.description = "";

        if (type === "image") {
          if (vm.uploadImages.length === 0) {
            vm.uploadImages.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImages, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImages.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (type === "image_for_ar") {
          if (vm.uploadImagesForAR.length === 0) {
            x.description = "arImage";
            vm.uploadImagesForAR.push(x);
          } else {
            var _duplicateImg = false;
            angular.forEach(vm.uploadImagesForAR, function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              x.description = "arImage";
              vm.uploadImagesForAR.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImages.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg2 = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImages), function (y) {
              if (x.name === y.name) {
                _duplicateImg2 = true;
              }
            });

            if (!_duplicateImg2) {
              if (/image/.test(x.type)) {
                vm.uploadImages.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.removedFiles = [];

    vm.deleteFile = function (indexVal, type) {
      if (type === "image") {
        vm.removedFiles.push(vm.editEquipment.files.images[indexVal]._id);
        vm.uploadImages.splice(indexVal, 1);
      } else {
        vm.removedFiles.push(vm.editEquipment.files.docs[indexVal]._id);
        vm.uploadFiles.splice(indexVal, 1);
      }
    };

    $scope.isLoading = true;
    Promise.all([apiFactory.getAllEquipmentGroup(), apiFactory.getAllEmployees(), apiFactory.getAllSuppliers()]).then(function (data) {
      $scope.isLoading = false;
      vm.equipmentGroup = data[0].data.data;
      vm.employees = data[1].data.list;
      vm.employees.unshift({
        _id: undefined,
        displayName: ''
      });
      vm.suppliers = data[2].data.list;
      getEquipmentDetail();
    })["catch"](function (err) {
      $log.error(err);
      $scope.isLoading = false;
    });

    function getEquipmentDetail() {
      $scope.isLoading = true;
      apiFactory.getEquipmentById(vm.equipmentId).then(function (resp) {
        $scope.isLoading = false;
        vm.editEquipment = resp.data;
        vm.editEquipment.equipmentCost = resp.data.currentRate.equipmentCost.value;

        if (resp.data.currentRate.rooferCost) {
          vm.editEquipment.rooferCost = resp.data.currentRate.rooferCost.value;
        }

        if (vm.editEquipment.workers[0]) {
          vm.workers = vm.editEquipment.workers[0]._id;
        }

        vm.editEquipment.currency = resp.data.currentRate.equipmentCost.currencyCode;
        vm.editEquipment.conversionFactor = Number.parseFloat(vm.editEquipment.conversionFactor.toFixed(2));
        vm.uploadImages = vm.editEquipment.files.images;
        vm.uploadFiles = vm.editEquipment.files.docs;
        vm.locationEq = vm.editEquipment.locationEq;
        var find = vm.equipmentGroup.find(function (elem) {
          return elem._id === vm.editEquipment.groupId;
        });

        if (find) {
          vm.editEquipment.equipmentGroupName = find.name;
        }

        vm.editEquipment.owned = vm.editEquipment.owned || true;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
      });
    }

    vm.changeCost = function (cost, conversionRate) {
      return cost * conversionRate;
    };

    $scope.totalCountEq = 0;

    vm.addLocationandCount = function (location, count) {
      if (!!$scope.location && $scope.eqCount) {
        $scope.totalCountEq = $scope.totalCountEq + count;
        vm.editEquipment.locationEq.push({
          location: {
            coordinates: $scope.currentAddedLoc
          },
          locationCountEq: count,
          name: location
        });
      } else {
        Notification.error("Please add location and count");
      }

      $scope.eqCount = "";
      $scope.location = "";
      angular.element("#locationinput").val("");
      angular.element("#locationcountinput").val("");
    }; // $scope.removeFromArray = function (index, array) {
    //   array.splice(index, 1);
    //   vm.gmap.markers.splice(index, 1);
    // };


    vm.updateEquipment = function () {
      var equipment = vm.editEquipment;

      if (!equipment.name) {
        Notification.error("Please enter equipment name");
        return;
      } else if (!equipment.rooferCost) {
        Notification.error('Please enter worker cost');
        return;
      } else if (!equipment.equipmentGroupName) {
        Notification.error('Please enter equipment group');
        return;
      } else if (!equipment.deliveryCost) {
        Notification.error('Please enter delivery cost');
        return;
      } else if (!equipment.unit) {
        Notification.error('Please select charging unit');
        return;
      } else if (utils.isEmpty(equipment.supplier)) {
        Notification.error('Please select supplier');
        return;
      }

      if (!equipment.conversionFactor) {
        equipment.conversionFactor = 1;
      }

      $scope.imgAndFiles = [].concat(vm.inputImg, vm.inputFiles);
      var formData = {
        name: equipment.name,
        currentRate: {
          equipmentCost: {
            value: vm.changeCost(equipment.equipmentCost || 0, equipment.conversionFactor),
            currencyCode: equipment.currency ? equipment.currency : vm.companyData.currentCurrency.currencyCode
          }
        },
        workers: vm.workers ? [vm.workers] : [],
        removedFiles: vm.removedFiles,
        files: $scope.imgAndFiles,
        totalCountEq: $scope.totalCountEq,
        locationEq: angular.fromJson(angular.toJson(vm.editEquipment.locationEq)),
        owned: equipment.owned,
        oneTimeDelivery: equipment.oneTimeDelivery,
        deliveryCost: equipment.deliveryCost,
        supplierInfo: equipment.supplierInfo,
        supplier: equipment.supplier
      };

      if (vm.editEquipment.rooferCost) {
        formData.currentRate.rooferCost = {
          value: vm.changeCost(equipment.rooferCost, equipment.conversionFactor),
          currencyCode: equipment.currency ? equipment.currency : vm.companyData.currentCurrency.currencyCode
        };
      }

      if (equipment.unit) {
        formData.unit = equipment.unit;
      }

      if (vm.editEquipment.equipmentGroupName) {
        var find = vm.equipmentGroup.find(function (elem) {
          return elem.name === vm.editEquipment.equipmentGroupName;
        });

        if (find) {
          formData.groupId = find._id;
        } else {
          formData.equipmentGroupName = vm.editEquipment.equipmentGroupName;
        }
      }

      $scope.isLoading = true;
      apiFactory.updateEquipmentById(equipment._id, formData).then(function (resp) {
        $scope.isLoading = false;
        Notification.success(resp.data.message);
        $state.go('equipmentDetail', {
          id: vm.equipmentId
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err, 'Failed to update Equipment'));
      });
    }; // let gAryLocation = [];
    // vm.placeMarker = function() {
    //   const placeData = this.getPlace().geometry.location;
    //   vm.gmap.markers.push([placeData.lat(), placeData.lng()]);
    //   vm.gmap.zoom = 5;
    //   vm.gmap.center = `${placeData.lat()},${placeData.lng()}`;
    //   gAryLocation = [placeData.lat(), placeData.lng()];
    //   $scope.currentAddedLoc = gAryLocation;
    // };

    /* Google map config */
    // vm.gmap = {
    //   url: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&libraries=places",
    //   markers: [],
    //   styles: [],
    //   center: "",
    //   zoom: 8
    // };
    // NgMap.getMap().then(function (map) {
    //   vm.map = map;
    //   map.setOptions({
    //     styles: vm.gmap.styles,
    //     disableDefaultUI: true,
    //     zoomControl: true,
    //     zoom: 1,
    //     center: {
    //       lat: 0,
    //       lng: 0
    //     }
    //   });
    // });


    $scope.isOpenAutoComplete = false;

    $scope.group_autocomplete = function () {
      $scope.isOpenAutoComplete = true;
      var output = [];

      if (vm.editEquipment.equipmentGroupName && vm.editEquipment.equipmentGroupName !== '') {
        angular.forEach(vm.equipmentGroup, function (group) {
          if (group.name.toLowerCase().indexOf(vm.editEquipment.equipmentGroupName.toLowerCase()) >= 0) {
            output.push(group);
          }
        });
      } else {
        angular.forEach(vm.equipmentGroup, function (group) {
          output.push(group);
        });
      }

      $scope.auto_groups = output;
    };

    vm.selectedGroup = function (group) {
      vm.editEquipment.equipmentGroupName = group.name;
      vm.editEquipment.groupId = group._id;
      $scope.isOpenAutoComplete = false;
    };

    $scope.onChangeCurrency = function () {
      $scope.isGetExchangeRate = true;
      apiFactory.getExchangeRate({
        currencyCode: vm.editEquipment.currency
      }).then(function (res) {
        $scope.isGetExchangeRate = false;
        vm.editEquipment.conversionFactor = Number.parseFloat(res.data.data.toFixed(2));
      })["catch"](function (err) {
        $scope.isGetExchangeRate = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('editDcq', {
    controller: EditDcqController,
    controllerAs: 'vm',
    templateUrl: 'app/main/equipments/editDcq/editDcq.view.html'
  });
  /** @ngInject */

  function EditDcqController($stateParams, apiFactory, globals, $scope, Notification, $state, utils, $log) {
    var vm = this;
    vm.utils = utils;
    vm.userData = globals.userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.companyData = globals.companyStore.get();
    vm.comboId = $stateParams.id;
    $scope.isLoading = false;
    vm.typeAddings = [{
      _id: "Both",
      name: "Both"
    }, {
      _id: "Labor",
      name: "Labour"
    }, {
      _id: "Equipment",
      name: "Equipment"
    }];
    vm.mUnits = [{
      label: 'hrs',
      value: 'hrs'
    }, {
      label: 'days',
      value: 'days'
    }, {
      label: 'weeks',
      value: 'weeks'
    }, {
      label: 'months',
      value: 'months'
    }, {
      label: 'm3',
      value: 'm3'
    }, {
      label: 'pcs',
      value: 'pcs'
    }];
    vm.comboMaterialList = [];
    $scope.comboMaterialList = [];
    $scope.comboEqu = {
      quantity: 1,
      typeAdding: 'Both',
      percentage: 0,
      equCostRate: 0,
      workerCostRate: 0,
      baseEquCost: 0,
      baseWorkerCost: 0
    };

    $scope.fileUpdated = function (files, type) {
      angular.forEach(files, function (x) {
        x.objectUrl = URL.createObjectURL(x);
        x.description = "";

        if (type === "image") {
          if (vm.uploadImages.length === 0) {
            vm.uploadImages.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImages, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImages.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (type === "image_for_ar") {
          if (vm.uploadImagesForAR.length === 0) {
            x.description = "arImage";
            vm.uploadImagesForAR.push(x);
          } else {
            var _duplicateImg = false;
            angular.forEach(vm.uploadImagesForAR, function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              x.description = "arImage";
              vm.uploadImagesForAR.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImages.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg2 = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImages), function (y) {
              if (x.name === y.name) {
                _duplicateImg2 = true;
              }
            });

            if (!_duplicateImg2) {
              if (/image/.test(x.type)) {
                vm.uploadImages.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.removedFiles = [];

    vm.deleteFile = function (indexVal, type) {
      if (type === "image") {
        vm.removedFiles.push(vm.comboData.files.images[indexVal]._id);
        vm.uploadImages.splice(indexVal, 1);
      } else {
        vm.removedFiles.push(vm.comboData.files.docs[indexVal]._id);
        vm.uploadFiles.splice(indexVal, 1);
      }
    };

    function getValidTypeAdding(typeAdding) {
      if (typeAdding !== 'Both' && typeAdding !== 'Labor' && typeAdding !== 'Equipment') {
        return 'Both';
      } else {
        return typeAdding;
      }
    }

    function getComboEquDetail() {
      $scope.isLoading = true;
      apiFactory.getComboEquipmentById(vm.comboId).then(function (resp) {
        $scope.isLoading = false;
        vm.comboData = resp.data.data;
        vm.uploadImages = resp.data.data.files.images;
        vm.uploadFiles = resp.data.data.files.docs;
        vm.comboMaterialList = vm.comboData.comboMaterialList;
        $scope.comboMaterialList = vm.comboMaterialList.map(function (item) {
          return {
            _id: item._id,
            equId: item.equipmentId._id,
            name: item.equipmentId.name,
            date: item.equipmentId.createdAt,
            quantity: item.quantity,
            typeAdding: getValidTypeAdding(item.percentageAdditions[0].percentageType),
            percentage: item.percentageAdditions[0].value,
            equCostRate: item.equipmentId.baseRate.equipmentCost,
            workerCostRate: item.equipmentId.baseRate.rooferCost
          };
        });
        $scope.comboMaterialList.forEach(function (equ) {
          $scope.calcComboEquCost(equ);
        });
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }

    function loadAllEquipments() {
      $scope.isLoading = true;
      apiFactory.listAllEquipments().then(function (resp) {
        $scope.isLoading = false;
        vm.equList = resp.data.list;
        vm.backupEquList = angular.copy(vm.equList);
        getComboEquDetail();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
      });
    }

    loadAllEquipments();

    $scope.addEquipment = function () {
      var comboEqu = $scope.comboEqu;

      if (angular.isUndefined(comboEqu.equId)) {
        Notification.error('Please select an equipment');
        return false;
      }

      if (angular.isUndefined(comboEqu.quantity)) {
        Notification.error('Please input quantity value');
        return false;
      }

      if (angular.isUndefined(comboEqu.percentage) || comboEqu.percentage < 0 || comboEqu.percentage > 100) {
        Notification.error('Invalid percentage. Please input a value between 0 and 100');
        return false;
      }

      var index = vm.equList.findIndex(function (x) {
        return x._id == comboEqu.equId;
      });

      if (index !== -1) {
        $scope.comboMaterialList.push(comboEqu);
        $scope.comboEqu = {
          quantity: 1,
          typeAdding: 'Both',
          percentage: 0,
          equCostRate: 0,
          workerCostRate: 0,
          baseEquCost: 0,
          baseWorkerCost: 0
        };
        vm.equList.splice(index, 1);
      }
    };

    $scope.removeEquipment = function (index, equId) {
      $scope.comboMaterialList.splice(index, 1);
      var equ = vm.backupEquList.find(function (x) {
        return x._id == equId;
      });

      if (equ) {
        vm.equList.push(equ);
      }
    };

    $scope.getTotalCost = function (which) {
      if (utils.isEmpty($scope.comboMaterialList)) {
        return 0;
      }

      return $scope.comboMaterialList.map(function (x) {
        return x[which];
      }).reduce(utils.sumReducer, 0);
    };

    $scope.calcComboEquCost = function (comboEqu) {
      switch (comboEqu.typeAdding) {
        case 'Both':
          comboEqu.baseEquCost = comboEqu.quantity * (comboEqu.equCostRate + comboEqu.percentage / 100 * comboEqu.equCostRate);
          comboEqu.baseWorkerCost = comboEqu.quantity * (comboEqu.workerCostRate + comboEqu.percentage / 100 * comboEqu.workerCostRate);
          break;

        case 'Equipment':
          comboEqu.baseEquCost = comboEqu.quantity * (comboEqu.equCostRate + comboEqu.percentage / 100 * comboEqu.equCostRate);
          comboEqu.baseWorkerCost = comboEqu.quantity * comboEqu.workerCostRate;
          break;

        case 'Labor':
          comboEqu.baseWorkerCost = comboEqu.quantity * (comboEqu.workerCostRate + comboEqu.percentage / 100 * comboEqu.workerCostRate);
          comboEqu.baseEquCost = comboEqu.quantity * comboEqu.equCostRate;
          break;
      }
    };

    $scope.onChangeEqu = function (comboEqu) {
      var equ = vm.equList.find(function (x) {
        return x._id === comboEqu.equId;
      });

      if (angular.isDefined(equ)) {
        comboEqu.name = equ.name;
        comboEqu.date = equ.createdAt;
        comboEqu.equCostRate = equ.baseRate.equipmentCost;
        comboEqu.workerCostRate = equ.baseRate.rooferCost;
        $scope.calcComboEquCost(comboEqu);
      }
    };

    function checkValidation() {
      if (utils.isEmpty(vm.comboData.name)) {
        Notification.error('Please enter combo equipment name');
        return false;
      }

      if (utils.isEmpty(vm.comboData.unit)) {
        Notification.error('Please select unit');
        return false;
      }

      if ($scope.comboMaterialList.length < 2) {
        Notification.error("Combination list should be more 2 items at least.");
        return false;
      }

      return true;
    }

    vm.updateCombo = function () {
      if (!checkValidation()) {
        return;
      }

      $scope.imgAndFiles = [].concat(vm.uploadImages, vm.uploadFiles);
      $scope.uploadallFiles = [].concat(vm.uploadImages, vm.uploadFiles);
      var description = [];

      if (vm.uploadImages.length > 0 || vm.uploadFiles.length > 0) {
        $scope.imgAndFiles.map(function (x) {
          description.push({
            assetDescription: x.description
          });
        });
      }

      var data = {
        name: vm.comboData.name,
        unit: vm.comboData.unit,
        description: vm.comboData.description,
        files: $scope.imgAndFiles,
        assetObj: description,
        removedFiles: vm.removedFiles
      };
      var comboListArray = $scope.comboMaterialList.map(function (x) {
        return {
          _id: x._id,
          equipmentId: x.equId,
          type: 2,
          quantity: x.quantity,
          percentageAdditions: [{
            value: x.percentage,
            percentageType: x.typeAdding
          }]
        };
      });
      var deletedComboList = [];
      var changedComboList = comboListArray.filter(function (x) {
        return angular.isDefined(x._id);
      });
      vm.comboMaterialList.forEach(function (x) {
        var index = changedComboList.findIndex(function (y) {
          return y._id === x._id;
        });

        if (index === -1) {
          deletedComboList.push(x._id);
        }
      });
      var comboListData = {
        comboListArray: comboListArray,
        deletedComboList: deletedComboList
      };
      $scope.isLoading = true;
      Promise.all([apiFactory.updateComboMaterialList(vm.comboData._id, comboListData), apiFactory.updateComboEquipmentById(vm.comboData._id, data)]).then(function (resp) {
        $scope.isLoading = false;
        Notification.success(resp[0].data.message);
        Notification.success(resp[1].data.message);
        angular.element("#edit_dcq_modal.dcq_modal").modal("hide");
        getComboEquDetail();
        vm.fileNames = [];
        $state.go("dcqDetail", {
          id: vm.comboData._id
        });
      })["catch"](function (e) {
        $scope.isLoading = false;

        if (e.data && e.data.message) {
          Notification.error(e.data.message);
        } else {
          Notification.error("Failed to update");
        }
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('dcqList', {
    controller: dcqListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/equipments/dcqList/dcqList.view.html'
  });
  /** @ngInject */

  function dcqListController($scope, apiFactory, FileSaver, Notification, globals, $log, $state) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.EQ_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.EQ_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.EQ]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.EQ_ACCESS_CREATE = res.data.data[Constants.AccessKey.EQ];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.combos = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.isLoading = false;
    $scope.isGrid = true;
    vm.searchText = undefined;
    vm.sortMenuComboEquipmentList = [{
      label: 'Name',
      key: 'name'
    }, {
      label: 'Created Date',
      key: 'createdAt'
    }, {
      label: 'Modified Date',
      key: 'updatedAt'
    }, {
      label: 'Equipment Tag',
      key: 'systemTag'
    }];
    vm.sortMenuCombo = "createdAt";
    vm.currencies = [];
    globals.getCurrency().then(function (res) {
      vm.currencies = res.data;
    });

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.sortComboEquipments();
    };

    vm.sortComboEquipments = function () {
      $scope.isLoading = true;
      apiFactory.listAllComboEquipments({
        sort: vm.sortMenuCombo,
        search: vm.searchText,
        sortType: "false",
        page: vm.currentPage,
        chunk: $scope.numPerPage
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.combos = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    vm.sortComboEquipments();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.sortComboEquipments();
    };

    $scope.switchViewMode = function (isGrid) {
      $scope.isGrid = isGrid;
    };

    $scope.getCurrencySymbol = function (item) {
      var find = vm.currencies.find(function (x) {
        return x.cc === item.currencyCode;
      });

      if (find) {
        return find.symbol;
      } else {
        return 'Kr';
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('dcqDetail', {
    controller: dcqDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/equipments/dcqDetail/dcqDetail.view.html'
  });
  /** @ngInject */

  function dcqDetailController(apiFactory, $document, $scope, $timeout, moment, $stateParams, $state, Notification, utils, globals, $log, $uibModal) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.EQ_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.EQ_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.EQ]
    //   }).then(res => {
    //     $scope.loading = false;
    //     $scope.EQ_ACCESS_CREATE = res.data.data[Constants.AccessKey.EQ];
    //   })
    //   .catch((e) => {
    //     $scope.loading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    vm.utils = utils;
    vm.comboId = $stateParams.id;
    $scope.loading = false;

    $scope.deleteDcq = function () {
      $scope.loading = true;
      apiFactory.deleteComboEquipmentById(vm.comboId).then(function () {
        $scope.loading = false;
        Notification.success('Equipment deleted successfully');
        $state.go('dcqList');
      }, function () {
        $scope.loading = false;
        Notification.error('Something went wrong try later');
      })["catch"](function () {
        $scope.loading = false;
      });
    };

    function getComboMatDetail() {
      $scope.loading = true;
      apiFactory.getComboEquipmentById(vm.comboId).then(function (resp) {
        $scope.loading = false;
        vm.comboData = resp.data.data;
        vm.uploadImages = vm.comboData.files.images;
        vm.uploadFiles = vm.comboData.files.docs;
        vm.description = vm.comboData.description;
        var owned = true;
        var skills = [];

        var _iterator = _createForOfIteratorHelper(vm.comboData.comboMaterialList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var comboEqu = _step.value;
            var equipment = comboEqu.equipmentId;

            if (!utils.isEmpty(equipment)) {
              owned = owned && equipment.owned;
            }

            skills = skills.concat(equipment.skills.map(function (x) {
              return x.name;
            }));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (owned === true) {
          vm.comboData.owned = "Owned";
        } else {
          vm.comboData.owned = "Rented";
        }

        vm.comboData.skills = [];
        skills.forEach(function (skill) {
          if (vm.comboData.skills.indexOf(skill) === -1) {
            vm.comboData.skills.push(skill);
          }
        });
        $scope.boxes = [{
          img: "/assets/icons/scale-white.svg",
          title: "Unit",
          unit: vm.comboData.unit
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Material Cost",
          value: vm.comboData.totalEquipmentCost,
          currencyCode: vm.comboData.currencyCode
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Worker Cost",
          value: vm.comboData.totalRooferCost,
          currencyCode: vm.comboData.currencyCode
        }, {
          img: "/assets/icons/dollar-white.svg",
          title: "Delivery Cost",
          value: vm.comboData.totalEquipmentCost,
          currencyCode: vm.comboData.currencyCode
        }];
        $timeout(imgSlider, 1500);
      })["catch"](function () {
        $scope.loading = false;
      });
    }

    getComboMatDetail();

    function imgSlider() {
      angular.element(".slider").flexslider({
        animation: "slide",
        start: function start() {
          angular.element('body').removeClass('loading');
        }
      });
    }

    $scope.getMatCost = function (comboMat) {
      var type = utils.isEmpty(comboMat.percentageAdditions) ? 'Both' : comboMat.percentageAdditions[0].percentageType;
      var percentage = utils.isEmpty(comboMat.percentageAdditions[0]) ? 0 : comboMat.percentageAdditions[0].value;
      var matCostRate = utils.isEmpty(comboMat.equipmentId) || utils.isEmpty(comboMat.equipmentId.baseRate) || utils.isEmpty(comboMat.equipmentId.baseRate.equipmentCost) ? 0 : comboMat.equipmentId.baseRate.equipmentCost;

      switch (type) {
        case 'Both':
        case 'Equipment':
          return comboMat.quantity * (matCostRate + percentage / 100 * matCostRate);

        default:
          return comboMat.quantity * matCostRate;
      }
    };

    $scope.showImage = function (imageUrl) {
      $uibModal.open({
        animation: true,
        component: 'imageViewerModal',
        windowClass: 'image-viewer-modal',
        resolve: {
          imageURL: function imageURL() {
            return imageUrl;
          }
        }
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('addEquipment', {
    controller: AddEquipmentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/equipments/addEquipment/addEquipment.view.html'
  });
  /** @ngInject */

  function AddEquipmentController( // NgMap,
  globals, apiFactory, $scope, Notification, $state, $log, utils) {
    var vm = this;
    vm.utils = utils;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.companyData = companyStore.get();
    $scope.isLoading = false;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.addEquipment = {
      conversionFactor: 1,
      locationEq: [],
      currency: vm.companyData.currentCurrency.currencyCode,
      owned: true,
      equipmentCost: 0,
      rooferCost: 0
    };
    vm.unitList = [{
      label: 'hrs',
      value: 'hrs'
    }, {
      label: 'days',
      value: 'days'
    }, {
      label: 'weeks',
      value: 'weeks'
    }, {
      label: 'months',
      value: 'months'
    }, {
      label: 'm3',
      value: 'm3'
    }, {
      label: 'pcs',
      value: 'pcs'
    }];
    vm.chargingModeList = [{
      label: 'Yes',
      value: false
    }, {
      label: 'No',
      value: true
    }];
    vm.equipmentGroup = [];
    globals.getCurrency().then(function (resp) {
      vm.currencies = resp.data;
    }); // image and file upload funtion -start

    vm.uploadImages = [];
    vm.uploadFiles = [];

    $scope.fileUpdated = function (files, type) {
      angular.forEach(files, function (x) {
        x.objectUrl = URL.createObjectURL(x);
        x.description = "";

        if (type === "image") {
          if (vm.uploadImages.length === 0) {
            vm.uploadImages.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImages, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImages.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (type === "image_for_ar") {
          if (vm.uploadImagesForAR.length === 0) {
            x.description = "arImage";
            vm.uploadImagesForAR.push(x);
          } else {
            var _duplicateImg = false;
            angular.forEach(vm.uploadImagesForAR, function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              x.description = "arImage";
              vm.uploadImagesForAR.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImages.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg2 = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImages), function (y) {
              if (x.name === y.name) {
                _duplicateImg2 = true;
              }
            });

            if (!_duplicateImg2) {
              if (/image/.test(x.type)) {
                vm.uploadImages.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.deleteFile = function (indexVal, type) {
      if (type === "image") {
        vm.uploadImages.splice(indexVal, 1);
      } else {
        vm.uploadFiles.splice(indexVal, 1);
      }
    };

    Promise.all([apiFactory.getAllEquipmentGroup(), apiFactory.getAllEmployees(), apiFactory.getAllSuppliers()]).then(function (data) {
      vm.equipmentGroup = data[0].data.data;
      vm.companyEmployees = data[1].data.list;
      vm.companyEmployees.unshift({
        _id: undefined,
        displayName: ''
      });
      vm.suppliers = data[2].data.list;
    })["catch"](function (err) {
      $log.error(err);
      Notification.error("Couldn't load data.");
    });

    vm.changeCost = function (cost, conversionRate) {
      return cost / conversionRate;
    }; // Add Equpment -start


    vm.addNewEquipment = function () {
      var equipment = vm.addEquipment;

      if (!equipment.name) {
        Notification.error("Please enter equipment name");
        return;
      } else if (!equipment.rooferCost) {
        Notification.error('Please enter worker cost');
        return;
      } else if (!equipment.equipmentGroupName) {
        Notification.error('Please enter equipment group');
        return;
      } else if (!equipment.deliveryCost) {
        Notification.error('Please enter delivery cost');
        return;
      } else if (!equipment.unit) {
        Notification.error('Please select charging unit');
        return;
      } else if (utils.isEmpty(equipment.supplier)) {
        Notification.error('Please select supplier');
        return;
      }

      if (!equipment.conversionFactor) {
        equipment.conversionFactor = 1;
      }

      $scope.imgAndFiles = [].concat(vm.uploadImages, vm.uploadFiles);
      var formData = {
        name: equipment.name,
        files: $scope.imgAndFiles,
        equipmentCost: {
          value: vm.changeCost(equipment.equipmentCost || 0, equipment.conversionFactor),
          currencyCode: equipment.currency ? equipment.currency : vm.companyData.currentCurrency.currencyCode
        },
        workers: equipment.workers ? [equipment.workers] : [],
        // location: {
        //   coordinates: gAryLocation
        // }
        totalCountEq: $scope.totalCountEq,
        locationEq: equipment.locationEq,
        owned: equipment.owned,
        oneTimeDelivery: equipment.oneTimeDelivery,
        deliveryCost: equipment.deliveryCost,
        supplierInfo: equipment.supplierInfo,
        supplier: equipment.supplier
      };

      if (equipment.unit) {
        formData.unit = equipment.unit;
      }

      if (vm.addEquipment.rooferCost) {
        formData.rooferCost = {
          value: vm.changeCost(equipment.rooferCost, equipment.conversionFactor),
          currencyCode: equipment.currency ? equipment.currency : vm.companyData.currentCurrency.currencyCode
        };
      }

      if (vm.addEquipment.equipmentGroupName) {
        var find = vm.equipmentGroup.find(function (elem) {
          return elem.name === vm.addEquipment.equipmentGroupName;
        });

        if (find) {
          formData.groupId = find._id;
        } else {
          formData.equipmentGroupName = vm.addEquipment.equipmentGroupName;
        }
      }

      $scope.isLoading = true;
      apiFactory.createEquipment(formData).then(function (resp) {
        $scope.isLoading = false;
        Notification.success(resp.data.message);
        $state.go('equipmentDetail', {
          id: resp.data.data._id
        });
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err, 'Failed to create Equipment'));
      });
    };

    $scope.onChangeCurrency = function () {
      $scope.isGetExchangeRate = true;
      apiFactory.getExchangeRate({
        currencyCode: vm.addEquipment.currency
      }).then(function (res) {
        $scope.isGetExchangeRate = false;
        vm.addEquipment.conversionFactor = Number.parseFloat(res.data.data.toFixed(2));
      })["catch"](function (err) {
        $scope.isGetExchangeRate = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('addDcq', {
    controller: AddDcqController,
    controllerAs: 'vm',
    templateUrl: 'app/main/equipments/addDcq/addDcq.view.html'
  });
  /** @ngInject */

  function AddDcqController($stateParams, apiFactory, globals, $scope, Notification, $state, utils, $log) {
    var vm = this;
    vm.utils = utils;
    $scope.loading = false;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.companyData = companyStore.get();
    $scope.companyCurrencyCode = utils.isEmpty(vm.companyData) || utils.isEmpty(vm.companyData.currentCurrency) || utils.isEmpty(vm.companyData.currentCurrency.currencyCode) ? 'DKK' : vm.companyData.currentCurrency.currencyCode;
    vm.typeAddings = [{
      _id: "Both",
      name: "Both"
    }, {
      _id: "Labor",
      name: "Labour"
    }, {
      _id: "Equipment",
      name: "Equipment"
    }];
    vm.mUnits = [{
      label: 'hrs',
      value: 'hrs'
    }, {
      label: 'days',
      value: 'days'
    }, {
      label: 'weeks',
      value: 'weeks'
    }, {
      label: 'months',
      value: 'months'
    }, {
      label: 'm3',
      value: 'm3'
    }, {
      label: 'pcs',
      value: 'pcs'
    }];
    vm.comboData = {};
    $scope.comboMaterialList = [];
    vm.uploadImages = [];
    vm.uploadFiles = [];
    $scope.comboEqu = {
      quantity: 1,
      typeAdding: 'Both',
      percentage: 0,
      equCostRate: 0,
      workerCostRate: 0,
      baseEquCost: 0,
      baseWorkerCost: 0
    };

    $scope.fileUpdated = function (files, type) {
      angular.forEach(files, function (x) {
        x.objectUrl = URL.createObjectURL(x);
        x.description = "";

        if (type === "image") {
          if (vm.uploadImages.length === 0) {
            vm.uploadImages.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImages, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImages.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (type === "image_for_ar") {
          if (vm.uploadImagesForAR.length === 0) {
            x.description = "arImage";
            vm.uploadImagesForAR.push(x);
          } else {
            var _duplicateImg = false;
            angular.forEach(vm.uploadImagesForAR, function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              x.description = "arImage";
              vm.uploadImagesForAR.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImages.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg2 = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImages), function (y) {
              if (x.name === y.name) {
                _duplicateImg2 = true;
              }
            });

            if (!_duplicateImg2) {
              if (/image/.test(x.type)) {
                vm.uploadImages.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.deleteFile = function (indexVal, type) {
      if (type === "image") {
        vm.uploadImages.splice(indexVal, 1);
      } else {
        vm.uploadFiles.splice(indexVal, 1);
      }
    };

    function loadEquipments() {
      $scope.loading = true;
      apiFactory.listAllEquipments().then(function (resp) {
        $scope.loading = false;
        vm.equList = resp.data.list;
        vm.backupEquList = angular.copy(vm.equList);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
      });
    }

    loadEquipments();

    $scope.addEquipment = function () {
      var comboEqu = $scope.comboEqu;

      if (angular.isUndefined(comboEqu.equId)) {
        Notification.error('Please select an equipment');
        return false;
      }

      if (angular.isUndefined(comboEqu.quantity)) {
        Notification.error('Please input quantity value');
        return false;
      }

      if (angular.isUndefined(comboEqu.percentage) || comboEqu.percentage < 0 || comboEqu.percentage > 100) {
        Notification.error('Invalid percentage. Please input a value between 0 and 100');
        return false;
      }

      var index = vm.equList.findIndex(function (x) {
        return x._id == comboEqu.equId;
      });

      if (index !== -1) {
        $scope.comboMaterialList.push(comboEqu);
        $scope.comboEqu = {
          quantity: 1,
          typeAdding: 'Both',
          percentage: 0,
          equCostRate: 0,
          workerCostRate: 0,
          baseEquCost: 0,
          baseWorkerCost: 0
        };
        vm.equList.splice(index, 1);
      }
    };

    $scope.removeEquipment = function (index, equId) {
      $scope.comboMaterialList.splice(index, 1);
      var equ = vm.backupEquList.find(function (x) {
        return x._id == equId;
      });

      if (equ) {
        vm.equList.push(equ);
      }
    };

    $scope.getTotalCost = function (which) {
      if (utils.isEmpty($scope.comboMaterialList)) {
        return 0;
      }

      return $scope.comboMaterialList.map(function (x) {
        return x[which];
      }).reduce(utils.sumReducer, 0);
    };

    $scope.calcComboEquCost = function (comboEqu) {
      switch (comboEqu.typeAdding) {
        case 'Both':
          comboEqu.baseEquCost = comboEqu.quantity * (comboEqu.equCostRate + comboEqu.percentage / 100 * comboEqu.equCostRate);
          comboEqu.baseWorkerCost = comboEqu.quantity * (comboEqu.workerCostRate + comboEqu.percentage / 100 * comboEqu.workerCostRate);
          break;

        case 'Equipment':
          comboEqu.baseEquCost = comboEqu.quantity * (comboEqu.equCostRate + comboEqu.percentage / 100 * comboEqu.equCostRate);
          comboEqu.baseWorkerCost = comboEqu.quantity * comboEqu.workerCostRate;
          break;

        case 'Labor':
          comboEqu.baseWorkerCost = comboEqu.quantity * (comboEqu.workerCostRate + comboEqu.percentage / 100 * comboEqu.workerCostRate);
          comboEqu.baseEquCost = comboEqu.quantity * comboEqu.equCostRate;
          break;
      }
    };

    $scope.onChangeEqu = function (comboEqu) {
      var equ = vm.equList.find(function (x) {
        return x._id === comboEqu.equId;
      });

      if (angular.isDefined(equ)) {
        comboEqu.name = equ.name;
        comboEqu.date = equ.createdAt;
        comboEqu.equCostRate = equ.baseRate.equipmentCost;
        comboEqu.workerCostRate = equ.baseRate.rooferCost;
        $scope.calcComboEquCost(comboEqu);
      }
    };

    function checkValidation() {
      if (utils.isEmpty(vm.comboData.name)) {
        Notification.error('Please enter combo equipment name');
        return false;
      }

      if (utils.isEmpty(vm.comboData.unit)) {
        Notification.error('Please select unit');
        return false;
      }

      if ($scope.comboMaterialList.length < 2) {
        Notification.error("Combination list should be more 2 items at least.");
        return false;
      }

      return true;
    }

    vm.createCombo = function () {
      if (!checkValidation()) {
        return;
      }

      var imgAndFiles = [].concat(vm.uploadImages, vm.uploadFiles);
      var data = {
        files: imgAndFiles,
        assetObj: imgAndFiles.map(function (x) {
          return {
            assetDescription: x.description
          };
        }),
        comboMaterialList: $scope.comboMaterialList.map(function (x) {
          return {
            _id: x._id,
            equipmentId: x.equId,
            type: 2,
            quantity: x.quantity,
            percentageAdditions: [{
              value: x.percentage,
              percentageType: x.typeAdding
            }]
          };
        }),
        name: vm.comboData.name,
        unit: vm.comboData.unit,
        description: vm.comboData.description
      };
      $scope.loading = true;
      apiFactory.getComboEquSystemTag().then(function (res) {
        $scope.loading = false;
        data.systemTag = res.data.comboEquTag;
        $scope.loading = true;
        apiFactory.createComboEquipment(data).then(function (resp) {
          Notification.success(resp.data.message);
          $state.go('dcqList');
        })["catch"](function (err) {
          $scope.loading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('groupEdit', {
    controller: GroupEditController,
    controllerAs: 'vm',
    templateUrl: 'app/main/employees/groupEdit/groupEdit.view.html'
  });
  /** @ngInject */

  function GroupEditController($scope, $state, $stateParams, $log, apiFactory, Notification, utils, globals) {
    var vm = this;
    vm.userData = globals.userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.groupId = $stateParams.id;
    vm.employees = [];
    vm.leaders = [];
    vm.group = {
      name: undefined,
      leader: undefined,
      employees: [],
      skills: []
    };
    vm.leader = undefined;
    vm.employee = undefined;
    vm.image = undefined;
    $scope.isLoading = true;
    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    function getGroupSkills() {
      vm.group.skills = [];

      var _iterator = _createForOfIteratorHelper(vm.group.employees),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var employee = _step.value;

          var _iterator2 = _createForOfIteratorHelper(employee.skills),
              _step2;

          try {
            var _loop = function _loop() {
              var skill = _step2.value;

              if (!vm.group.skills.find(function (x) {
                return x._id === skill._id && x.level === skill.level;
              })) {
                vm.group.skills.push(skill);
              }
            };

            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    Promise.all([apiFactory.getAllEmployees({}), apiFactory.getEmployeeGroup(vm.groupId)]).then(function (resp) {
      $scope.isLoading = false;
      vm.employees = resp[0].data.list;
      vm.leaders.pushAll(vm.employees);
      var group = resp[1].data.data;
      vm.leader = group.leader._id;
      vm.image = group.image;
      vm.group.name = group.name;
      vm.group.leader = group.leader;
      $scope.FILEIMG = vm.image;
      var index = vm.employees.findIndex(function (x) {
        return x._id === vm.group.leader._id;
      });

      if (index !== -1) {
        vm.employees.splice(index, 1);
      }

      group.employees.forEach(function (employee) {
        vm.group.employees.push(employee);
        var findIndex = vm.employees.findIndex(function (x) {
          return x._id === employee._id;
        });

        if (findIndex !== -1) {
          vm.employees.splice(findIndex, 1);
        }
      });
      getGroupSkills();
    })["catch"](function (err) {
      $log.error(err);
      $scope.isLoading = false;
    });

    vm.changeImage = function (files) {
      if (!files || !files.length) {
        return;
      }

      var file = files[0];
      vm.image = URL.createObjectURL(file);
      vm.group.file = file;
    };

    vm.changeLeader = function (leaderId) {
      var oldLeader = vm.group.leader;
      vm.group.leader = vm.leaders.find(function (x) {
        return x._id === leaderId;
      });
      var findIndex = vm.employees.findIndex(function (x) {
        return x._id === leaderId;
      });

      if (findIndex !== -1) {
        vm.employees.splice(findIndex, 1);
      }

      findIndex = vm.group.employees.findIndex(function (x) {
        return x._id === leaderId;
      });

      if (findIndex !== -1) {
        vm.group.employees.splice(findIndex, 1);
      }

      if (oldLeader && oldLeader._id !== leaderId) {
        vm.employees.push(oldLeader);
        vm.employees = vm.employees.sort(function (a, b) {
          return a._id < b._id ? 1 : -1;
        });
      }

      getGroupSkills();
    };

    vm.changeEmployee = function (employeeId) {
      vm.employee = undefined;
      var findIndex = vm.employees.findIndex(function (x) {
        return x._id === employeeId;
      });

      if (findIndex !== -1) {
        vm.group.employees.push(vm.employees[findIndex]);
        vm.employees.splice(findIndex, 1);
        getGroupSkills();
      }
    };

    $scope.cancelSelectWorker = function (key, item) {
      vm.group.employees.splice(key, 1);
      vm.employees.push(item);
      vm.employees = vm.employees.sort(function (a, b) {
        return a._id < b._id ? 1 : -1;
      });
      getGroupSkills();
    };

    vm.save = function () {
      if (utils.isEmpty(vm.group.name)) {
        Notification.error("Please enter name.");
        return;
      }

      if (angular.isUndefined(vm.group.leader)) {
        Notification.error("Please select leader.");
        return;
      }

      if (!vm.group.employees || vm.group.employees.length === 0) {
        Notification.error("Please select worker.");
        return;
      }

      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);
      var group = {
        name: vm.group.name,
        leader: vm.group.leader._id,
        employees: vm.group.employees.map(function (x) {
          return x._id;
        }),
        skills: vm.group.skills.map(function (x) {
          return {
            name: x.name,
            level: x.level
          };
        }),
        image: $scope.imgAndFiles
      };

      if (vm.group.file) {
        group.image = vm.group.file;
      }

      $scope.isLoading = true;
      apiFactory.updateEmployeeGroup(vm.groupId, group).then(function () {
        $scope.isLoading = false;
        Notification.success("Employee Group successfully updated");
        $state.go("groupDetail", {
          id: vm.groupId
        });
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;

        if (err.data && err.data.message) {
          Notification.error(err.data.message);
        } else {
          Notification.error("Cannot update Employee Group");
        }
      });
    };

    $scope.gotoDetail = function () {
      $state.go("groupDetail", {
        id: vm.groupId
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('groupDetail', {
    controller: GroupDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/employees/groupDetail/groupDetail.view.html'
  });
  /** @ngInject */

  function GroupDetailController($scope, $state, apiFactory, $uibModal, Notification, $stateParams, $log, utils, globals) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.EMPLOYEE_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.EMPLOYEE_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.EMPLOYEE]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.EMPLOYEE_ACCESS_CREATE = res.data.data[Constants.AccessKey.EMPLOYEE];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.utils = utils;
    vm.groupId = $stateParams.id;

    function getGroupSkills() {
      vm.group.skills = [];

      var _iterator = _createForOfIteratorHelper(vm.group.employees),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var employee = _step.value;

          var _iterator2 = _createForOfIteratorHelper(employee.skills),
              _step2;

          try {
            var _loop = function _loop() {
              var skill = _step2.value;

              if (!vm.group.skills.find(function (x) {
                return x._id === skill._id && x.level === skill.level;
              })) {
                vm.group.skills.push(skill);
              }
            };

            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    $scope.isLoading = true;
    apiFactory.getEmployeeGroup(vm.groupId).then(function (resp) {
      $scope.isLoading = false;
      vm.group = resp.data.data;
      getGroupSkills();
      var workers = [];
      vm.group.employees.forEach(function (employee) {
        return workers.push(employee.displayName);
      });
      vm.strWorkers = workers.join(', ');
    })["catch"](function () {
      $scope.isLoading = false;
    });
    vm.employeesInTotal = [];

    vm.getEmployeesInTotal = function () {
      apiFactory.getAllEmployees({}).then(function (resp) {
        vm.employeesInTotal = resp.data.list;
      })["catch"](function () {});
    };

    vm.getEmployeesInTotal();

    vm.deleteEmplGroup = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          apiFactory.deleteEmployeeGroup(vm.groupId).then(function () {
            Notification.success("Group deleted successfully");
            $state.go("employeeGroup");
          })["catch"](function () {
            Notification.error("Group delete failed");
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('groupAdd', {
    controller: GroupAddController,
    controllerAs: 'vm',
    templateUrl: 'app/main/employees/groupAdd/groupAdd.view.html'
  });
  /** @ngInject */

  function GroupAddController($scope, $state, $log, apiFactory, Notification, utils, globals) {
    var vm = this;
    vm.userData = globals.userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.employees = [];
    vm.leaders = [];
    vm.group = {
      file: undefined,
      leader: undefined,
      employees: [],
      skills: []
    };
    vm.leader = undefined;
    vm.employee = undefined;
    vm.image = undefined;
    $scope.isLoading = true;
    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    apiFactory.getAllEmployees({}).then(function (resp) {
      $scope.isLoading = false;
      vm.employees = resp.data.list;
      vm.leaders.pushAll(vm.employees);
    })["catch"](function (err) {
      $log.error(err);
      $scope.isLoading = false;
    });

    vm.changeImage = function (files) {
      if (!files || !files.length) {
        return;
      }

      var file = files[0];
      vm.image = URL.createObjectURL(file);
      vm.group.file = file;
    };

    vm.changeLeader = function (leaderId) {
      var oldLeader = vm.group.leader;
      vm.group.leader = vm.leaders.find(function (x) {
        return x._id === leaderId;
      });
      var findIndex = vm.employees.findIndex(function (x) {
        return x._id === leaderId;
      });

      if (findIndex !== -1) {
        vm.employees.splice(findIndex, 1);
      }

      findIndex = vm.group.employees.findIndex(function (x) {
        return x._id === leaderId;
      });

      if (findIndex !== -1) {
        vm.group.employees.splice(findIndex, 1);
      }

      if (oldLeader && oldLeader._id !== leaderId) {
        vm.employees.push(oldLeader);
        vm.employees = vm.employees.sort(function (a, b) {
          return a._id < b._id ? 1 : -1;
        });
      }

      updateSkills();
    };

    vm.changeEmployee = function (employeeId) {
      vm.employee = undefined;
      var findIndex = vm.employees.findIndex(function (x) {
        return x._id === employeeId;
      });

      if (findIndex !== -1) {
        vm.group.employees.push(vm.employees[findIndex]);
        vm.employees.splice(findIndex, 1);
        updateSkills();
      }
    };

    $scope.cancelSelectWorker = function (key, item) {
      vm.group.employees.splice(key, 1);
      vm.employees.push(item);
      vm.employees = vm.employees.sort(function (a, b) {
        return a._id < b._id ? 1 : -1;
      });
      updateSkills();
    };

    vm.save = function () {
      if (utils.isEmpty(vm.group.name)) {
        Notification.error("Please enter name.");
        return;
      }

      if (angular.isUndefined(vm.group.leader)) {
        Notification.error("Please select leader.");
        return;
      }

      if (!vm.group.employees || vm.group.employees.length === 0) {
        Notification.error("Please select worker.");
        return;
      }

      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);
      var group = {
        name: vm.group.name,
        leader: vm.group.leader._id,
        employees: vm.group.employees.map(function (x) {
          return x._id;
        }),
        skills: vm.group.skills.map(function (x) {
          return {
            name: x.name,
            level: x.level
          };
        }),
        image: $scope.imgAndFiles
      };
      $scope.isLoading = true;
      apiFactory.createEmployeeGroup(group).then(function () {
        $scope.isLoading = false;
        Notification.success("Employee Group successfully added");
        $state.go("employeeGroup");
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;

        if (err.data && err.data.message) {
          Notification.error(err.data.message);
        } else {
          Notification.error("Cannot save Employee Group");
        }
      });
    };

    function updateSkills() {
      var skills = [];

      if (vm.group.leader) {
        skills.pushAll(vm.group.leader.listOfSkills);
      }

      vm.group.employees.forEach(function (employee) {
        return skills.pushAll(employee.listOfSkills);
      });
      vm.group.skills = skills.uniqBy(function (x) {
        return x.name;
      });
    }
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('employeeGroup', {
    controller: EmployeeGroupController,
    controllerAs: 'vm',
    templateUrl: 'app/main/employees/group/group.view.html'
  });
  /** @ngInject */

  function EmployeeGroupController($scope, $log, apiFactory, utils, globals, Notification, $state) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.EMPLOYEE_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.EMPLOYEE_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.EMPLOYEE]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.EMPLOYEE_ACCESS_CREATE = res.data.data[Constants.AccessKey.EMPLOYEE];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.utils = utils;
    vm.groups = [];
    $scope.numPerPage = 8; //globals.numPerPage();

    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.totalCount = 0;
    $scope.isGrid = true;
    vm.searchText = undefined;
    vm.sortMenuList = [{
      label: 'Name',
      key: 'name'
    }, {
      label: 'Created Date',
      key: 'createdAt'
    }, {
      label: 'Modified Date',
      key: 'updatedAt'
    }, {
      label: 'Employee Group Tag',
      key: 'systemTag'
    }];
    vm.sortMenu = "createdAt";
    $scope.periods = [{
      id: '8',
      name: '8'
    }, {
      id: '16',
      name: '16'
    }, {
      id: '32',
      name: '32'
    }];
    $scope.labelChecked = false;
    getEmployeeGroups();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.getEmployeeGroups();
    };

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      getEmployeeGroups();
    };

    function getGroupSkills() {
      var _iterator = _createForOfIteratorHelper(vm.groups),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var group = _step.value;
          group.skills = [];

          var _iterator2 = _createForOfIteratorHelper(group.employees),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var employee = _step2.value;

              var _iterator3 = _createForOfIteratorHelper(employee.skills),
                  _step3;

              try {
                var _loop = function _loop() {
                  var skill = _step3.value;

                  if (!group.skills.find(function (x) {
                    return x._id === skill._id && x.level === skill.level;
                  })) {
                    group.skills.push(skill);
                  }
                };

                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  _loop();
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      vm.groups.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };

    function getEmployeeGroups() {
      $scope.isLoading = true;
      apiFactory.listAllEmployeeGroups({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        sort: vm.sortMenu,
        sortType: "false"
      }).then(function (resp) {
        $scope.isLoading = false;
        vm.groups = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
        getGroupSkills();
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }

    $scope.goToDetail = function (clientId) {
      $state.go('groupDetail', {
        id: clientId
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('employeesEdit', {
    controller: EmployeesEditController,
    controllerAs: 'vm',
    templateUrl: 'app/main/employees/employeesEdit/employeesEdit.view.html'
  });
  /** @ngInject */

  function EmployeesEditController($scope, $state, $stateParams, $log, apiFactory, globals, Notification, utils) {
    var vm = this;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.employeeId = $stateParams.id;
    vm.currentCountry = {
      primary: 'Country',
      secondary: 'Country'
    };
    vm.addSkillLevelList = globals.gSkillLevelList;
    vm.isManager = false;
    vm.enableList = [{
      value: true,
      name: 'Enable'
    }, {
      value: false,
      name: 'Disable'
    }];
    vm.genderList = [{
      value: 'male',
      name: 'Male'
    }, {
      value: 'female',
      name: 'Female'
    }];
    vm.weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    vm.companyData = companyStore.get();
    vm.taskType = [];
    vm.allSkills = [{
      _id: 'all',
      name: 'All'
    }];
    vm.bonus = {};
    vm.drivingCostList = [];

    if (vm.companyData.employee) {
      vm.taskType = vm.companyData.employee.taskList;
      vm.drivingCostList = vm.companyData.employee.drivingCostList;

      if (vm.drivingCostList) {
        var defaultCost = vm.drivingCostList.find(function (x) {
          return x.isDefault;
        });

        if (defaultCost) {
          vm.defaultDrivingCost = defaultCost.value + defaultCost.currencyCode + ' ' + defaultCost.unit;
        }
      }
    }

    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    $scope.paymentConditions = vm.companyData.paymentConditions;
    $scope.isLoading = true;
    Promise.all([globals.getCountryCode(), apiFactory.getEmployeeById(vm.employeeId), apiFactory.getAllEmployeeSettings(), apiFactory.getRolesForCompany(), apiFactory.getAllMaterialGroup(), apiFactory.getAllEquipmentGroup()]).then(function (resp) {
      $scope.isLoading = false;
      vm.countryCodes = resp[0].data.map(function (x) {
        return {
          name: x.name,
          dialCode: x.dialCode,
          code: x.code,
          dialCodeName: "".concat(x.dialCode, " (").concat(x.name, ")")
        };
      });
      vm.employee = resp[1].data;
      vm.laberSettingsList = resp[2].data.data;
      vm.designationList = resp[3].data.data; // vm.laberSettingsList = vm.laberSettingsList.filter(it => !it.isManager);

      $scope.FILEIMG = vm.employee.profilePic;

      var _iterator = _createForOfIteratorHelper(resp[4].data.data),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var matGroup = _step.value;
          vm.allSkills.push({
            _id: matGroup._id,
            name: matGroup.name,
            type: 'MaterialGroup'
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(resp[5].data.data),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var eqpGroup = _step2.value;
          vm.allSkills.push({
            _id: eqpGroup._id,
            name: eqpGroup.name,
            type: 'EquipmentGroup'
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(vm.employee.skills),
          _step3;

      try {
        var _loop = function _loop() {
          var skill = _step3.value;
          var index = vm.allSkills.findIndex(function (x) {
            return x._id == skill._id;
          });

          if (index !== -1) {
            vm.allSkills.splice(index, 1);
          }
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (vm.employee.roleId) {
        $scope.changeOption('Designation', vm.employee.roleId);
      }

      if (vm.employee.employeeSettingId) {
        $scope.changeOption('EmployeeSetting', vm.employee.employeeSettingId);
      } else {
        vm.isManager = vm.employee.designation === 'manager';
      }

      vm.employee.name = vm.employee.displayName;

      if (vm.employee.mobile) {
        vm.employee.mobile.phoneNumber = parseInt(vm.employee.mobile.phoneNumber);

        if (vm.employee.mobile.dialCode.trim().charAt(0) === '+') {
          vm.dialCode = vm.employee.mobile.dialCode.trim().slice(1);
          vm.employee.mobile.dialCode = vm.dialCode;
        }
      }

      vm.employee.dob = new Date(vm.employee.dateOfBirth);
      vm.employee.doj = new Date(vm.employee.dateOfJoin);
      var find = vm.countryCodes.find(function (elem) {
        return elem.code === vm.employee.address1.countryCode;
      });

      if (find) {
        vm.currentCountry.primary = find.name;
      }

      find = vm.countryCodes.find(function (elem) {
        return elem.code === vm.employee.address2.countryCode;
      });

      if (find) {
        vm.currentCountry.secondary = find.name;
      }
    })["catch"](function (err) {
      $scope.isLoading = false;
      $log.error(err);
      Notification.error("Couldn't load data.");
    });

    $scope.changedTask = function (task) {
      $scope.bonus_task = task;
      var find = vm.taskType.find(function (elem) {
        return elem.name === task;
      });

      if (find) {
        vm.bonus.currencyCode = find.currencyCode;
        vm.bonus.value = find.value;
      }
    };

    $scope.onChangePhoto = function (files) {
      if (angular.isUndefined(files[0])) return;
      vm.employee.profilePic = URL.createObjectURL(files[0]);
    };

    vm.addSkillAction = function () {
      if (!vm.addSkill) {
        Notification.error("Please select skill");
        return;
      }

      if (!vm.addSkillLevel) {
        Notification.error("Please select skill level");
        return;
      }

      if (vm.employee.skills.find(function (x) {
        return x._id === vm.addSkill;
      })) {
        Notification.error('The skill already exists and cannot be added');
        return;
      }

      var skill = vm.allSkills.find(function (x) {
        return x._id === vm.addSkill;
      });

      if (!utils.isEmpty(skill)) {
        if (vm.addSkill === 'all') {
          var _loop2 = function _loop2(i) {
            var skill = vm.allSkills[i];

            if (!vm.employee.skills.find(function (x) {
              return x._id === skill._id;
            }) && skill._id !== 'all') {
              vm.employee.skills.push({
                level: vm.addSkillLevel,
                _id: skill._id,
                name: skill.name,
                type: skill.type
              });
              skill.added = true;
            }
          };

          for (var i = 0; i < vm.allSkills.length; i++) {
            _loop2(i);
          }

          vm.allSkills = vm.allSkills.filter(function (x) {
            return !x.added;
          });
        } else {
          vm.employee.skills.push({
            level: vm.addSkillLevel,
            _id: skill._id,
            name: skill.name,
            skillType: skill.type
          });
          var index = vm.allSkills.findIndex(function (x) {
            return x._id === vm.addSkill;
          });

          if (index !== -1) {
            vm.allSkills.splice(index, 1);
          }
        }

        vm.addSkill = '';
        vm.addSkillLevel = '';
      }
    };

    vm.editMode = function (skill) {
      skill.editMode = true;
    };

    vm.changeSkillLevel = function (skill) {
      var intValue = Number.parseInt(skill.level);

      if (isNaN(intValue) || intValue < 1 || intValue > 10) {
        Notification.error('Invalid skill level. Please input from 1 to 10.');
        return;
      }

      delete skill.editMode;
    };

    vm.deleteSkillAction = function (skill) {
      var index = vm.employee.skills.findIndex(function (x) {
        return x._id === skill._id;
      });

      if (index !== -1) {
        vm.employee.skills.splice(index, 1);
        vm.allSkills.push(skill);
      }
    };

    $scope.changeOption = function (type, value) {
      var list = [];

      if (type === 'Designation') {
        list = vm.designationList;
        vm.employee.roleId = value;
      } else if (type === 'EmployeeSetting') {
        list = vm.laberSettingsList;
        vm.employee.employeeSettingId = value;
      }

      if (angular.isUndefined(list)) {
        return;
      }

      var find = list.find(function (elem) {
        return elem._id === value;
      });

      if (find) {
        if (type === 'EmployeeSetting') {
          vm.isManager = find.isManager;
        }
      }
    };

    vm.save = function () {
      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);
      vm.employee.profilePic = $scope.imgAndFiles;
      var employee = angular.fromJson(angular.toJson(vm.employee));

      if (utils.isEmpty(employee.name)) {
        Notification.error("Please enter name.");
        return;
      }

      if (!employee.gender) {
        Notification.error("Please select gender.");
        return;
      }

      if (!employee.mobile || !employee.mobile.dialCode || !employee.mobile.phoneNumber) {
        Notification.error("Please enter contact number.");
        return;
      }

      if (!employee.email) {
        Notification.error("Please enter email.");
        return;
      }

      if (!employee.dob) {
        Notification.error("Please enter birth date.");
        return;
      }

      if (!employee.doj) {
        Notification.error("Please enter join date.");
        return;
      }

      if (utils.isEmpty(employee.skills)) {
        Notification.error('Please add skills');
        return;
      }

      if (!employee.address1 || !employee.address1.line1 || !employee.address1.city || angular.isUndefined(employee.address1.postalCode) || !employee.address1.countryCode) {
        Notification.error("Please fill up all primary address fields.");
        return;
      }

      if (!employee.salaryAmount) {
        Notification.error("Please enter salary.");
        return;
      }

      employee.doj = moment(employee.doj);
      employee.dob = moment(employee.dob);

      if ($scope.picFile) {
        employee.picFile = $scope.picFile;
      }

      var _iterator4 = _createForOfIteratorHelper(employee.skills),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var skill = _step4.value;
          delete skill.editMode;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      $scope.isLoading = true;
      apiFactory.updateEmployee(employee, vm.employeeId).then(function () {
        $scope.isLoading = false;
        Notification.success("Employee updated.");
        $state.go("employeesDetail", {
          id: vm.employeeId
        });
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;

        if (err.data && err.data.message) {
          Notification.error(err.data.message);
        } else {
          Notification.error("Couldn't update employee.");
        }
      });
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('employeesDetail', {
    controller: EmployeesDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/employees/employeesDetail/employeesDetail.view.html'
  });
  /** @ngInject */

  function EmployeesDetailController($scope, $state, apiFactory, globals, Notification, $stateParams, $uibModal, $log, utils) {
    var vm = this;
    vm.utils = utils;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.EMPLOYEE_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.EMPLOYEE_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.EMPLOYEE]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.EMPLOYEE_ACCESS_CREATE = res.data.data[Constants.AccessKey.EMPLOYEE];
    //   })
    //   .catch((e) => {
    //     $scope.isLoading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    vm.companyData = companyStore.get();
    $scope.paymentConditions = vm.companyData.paymentConditions;
    vm.employeeId = $stateParams.id;
    $scope.isLoading = false;
    Promise.all([apiFactory.getAllEmployeeSettings(), apiFactory.getRolesForCompany()]).then(function (data) {
      vm.laberSettingsList = data[0].data.data;
      vm.designationList = data[1].data.data;
      $scope.getEmployeeDetails();
    })["catch"](function () {
      Notification.error("Couldn't load data.");
    });

    $scope.getEmployeeDetails = function () {
      $scope.isLoading = true;
      apiFactory.getEmployeeById(vm.employeeId).then(function (resp) {
        $scope.isLoading = false;
        vm.Employee = resp.data;
        $scope.getLabel('Designation', vm.Employee.roleId);
        $scope.getLabel('EmployeeSetting', vm.Employee.employeeSettingId);
      })["catch"](function () {
        $scope.isLoading = false;
      });
    };

    $scope.deleteEmployee = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.isLoading = true;
          apiFactory.deleteEmployee(vm.employeeId).then(function () {
            $scope.isLoading = false;
            $state.go('employees');
            Notification.success('Employee deleted successfully');
          }, function () {
            $scope.isLoading = false;
            Notification.error('Something went wrong try later');
          })["catch"](function () {
            $scope.isLoading = false;
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };
    /**Insert Supplier functions */


    $scope.onChange = function (files) {
      if (angular.isUndefined(files[0])) return;
      $scope.FILEIMG = URL.createObjectURL(files[0]);
      $scope.fileExt = files[0].name.split('.').pop();
    };

    globals.getCountryCode().then(function (resp) {
      vm.getCountryCode = resp.data;

      vm.loadCountryCode = function () {
        return new Promise(function (resolve, reject) {
          resolve(resp.data);
        });
      };
    });
    var clientPaymentSetting; //, staffDialCode, clientDialCode,

    $scope.ClientDialCode = function (event) {// clientDialCode = event.target.id
    };

    $scope.ClientPaymentSetting = function (event) {
      clientPaymentSetting = event.target.id;
      $scope.paymentTerms = [clientPaymentSetting];
    };

    $scope.StaffDialCode = function (event) {// staffDialCode=event.target.id
    };

    $scope.createEmployee = function () {};

    $scope.getLabel = function (type, value) {
      var list = [];

      if (type == 'Designation') {
        list = vm.designationList;
        vm.Employee.roleId = value;
      } else if (type == 'EmployeeSetting') {
        list = vm.laberSettingsList;
        vm.Employee.employeeSettingId = value;
      }

      if (angular.isUndefined(list)) return;
      var find = list.find(function (elem) {
        return elem._id == value;
      });

      if (find) {
        if (type == 'Designation') vm.designationLabel = find.name;else if (type == 'EmployeeSetting') vm.employeeSettingLabel = find.presetName;
      }
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('employeesAdd', {
    controller: EmployeesAddController,
    controllerAs: 'vm',
    templateUrl: 'app/main/employees/employeesAdd/employeesAdd.view.html'
  });
  /** @ngInject */

  function EmployeesAddController($scope, $state, apiFactory, globals, Notification, utils) {
    var vm = this;
    vm.userData = globals.userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.employee = {
      skills: []
    };
    vm.overtime = {};
    vm.weekendPay = {};
    $scope.isLoading = false;
    vm.currentCountry = {
      primary: 'Country',
      secondary: 'Country'
    };
    vm.addSkillLevelList = globals.gSkillLevelList;
    vm.weekDays = ["Sunday", "Monday", "Tuesday", "Wednsday", "Thursday", "Friday", "Saturday"];
    var companyStore = globals.companyStore;
    vm.companyData = companyStore.get();
    vm.taskType = [];
    vm.allSkills = [];

    vm.getTaskType = function () {
      if (vm.companyData.employee) {
        vm.taskType = vm.companyData.employee.taskList;
      }
    };

    vm.getTaskType();
    vm.drivingCostList = [];

    vm.getDrivingCostList = function () {
      if (vm.companyData.employee) {
        vm.drivingCostList = vm.companyData.employee.drivingCostList;
      }

      if (vm.drivingCostList) {
        var defaultCost = vm.drivingCostList.find(function (x) {
          return x.isDefault;
        });

        if (defaultCost) {
          vm.defaultDrivingCost = defaultCost.value + defaultCost.currencyCode + ' ' + defaultCost.unit;
        }
      }
    };

    vm.getDrivingCostList();
    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x, _index) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    vm.bonus = {};
    Promise.all([apiFactory.getAllEmployeeSettings(), apiFactory.getRolesForCompany(), apiFactory.getAllMaterialGroup(), apiFactory.getAllEquipmentGroup()]).then(function (data) {
      vm.laberSettingsList = data[0].data.data; // vm.laberSettingsList = vm.laberSettingsList.filter(it => !it.isManager);

      vm.designationList = data[1].data.data;

      for (var i = 0; i < data[2].data.data.length; i++) {
        var matGroup = data[2].data.data[i];
        vm.allSkills.push({
          _id: matGroup._id,
          name: matGroup.name,
          type: 'MaterialGroup'
        });
      }

      for (var _i = 0; _i < data[3].data.data.length; _i++) {
        var eqpGroup = data[3].data.data[_i];
        vm.allSkills.push({
          _id: eqpGroup._id,
          name: eqpGroup.name,
          type: 'EquipmentGroup'
        });
      }

      vm.allSkills.unshift({
        _id: 'all',
        name: 'All'
      });
    })["catch"](function () {
      Notification.error("Couldn't load data.");
    });

    $scope.changedTask = function (task) {
      $scope.bonus_task = task;
      var find = vm.taskType.find(function (elem) {
        return elem.name === task;
      });

      if (find) {
        vm.bonus.currencyCode = find.currencyCode;
        vm.bonus.value = find.value;
      }
    };

    $scope.paymentConditions = vm.companyData.paymentConditions;
    /**Insert Supplier functions */

    $scope.onChange = function (files) {
      if (angular.isUndefined(files[0])) return;
      vm.employee.profilePic = URL.createObjectURL(files[0]); // $scope.fileExt = files[0].name.split('.').pop()
    };

    globals.getCurrency().then(function (resp) {
      vm.currencies = resp.data; // vm.currenciesList = vm.currencies.map(i => )

      vm.currenciesList = vm.currencies.map(function (c) {
        return {
          cc: c.cc // label: c.cc + ' - ' + c.name

        };
      });
    });
    globals.getCountryCode().then(function (resp) {
      vm.countryCodes = resp.data;
      vm.countryCodes = vm.countryCodes.map(function (x) {
        return {
          name: x.name,
          dialCode: x.dialCode,
          code: x.code,
          dialCodeName: "".concat(x.dialCode, " (").concat(x.name, ")")
        };
      });
    }); // vm.employee.isEnabled = true;

    vm.enableList = [{
      value: true,
      name: 'Enable'
    }, {
      value: false,
      name: 'Disable'
    }];
    vm.genderList = [{
      value: 'male',
      name: 'Male'
    }, {
      value: 'female',
      name: 'Female'
    }];

    $scope.isExistsAllSkill = function () {
      return !utils.isEmpty(vm.employee) && !utils.isEmpty(vm.employee.skills) && vm.employee.skills.findIndex(function (x) {
        return x._id === 'all';
      }) !== -1;
    };

    $scope.createEmployee = function () {
      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);
      vm.employee.profilePic = $scope.imgAndFiles;
      var employee = angular.fromJson(angular.toJson(vm.employee));

      if (!employee.name || employee.name === '') {
        Notification.error("Please enter name.");
        return;
      }

      if (!employee.gender) {
        Notification.error("Please select gender.");
        return;
      }

      if (!employee.mobile || !employee.mobile.dialCode || !employee.mobile.phoneNumber) {
        Notification.error("Please enter contact number.");
        return;
      }

      if (!employee.email) {
        Notification.error("Please enter email.");
        return;
      }

      if (!employee.dob) {
        Notification.error("Please enter birth date.");
        return;
      } else {
        employee.dob = moment(employee.dob);
      }

      if (!employee.doj) {
        Notification.error("Please enter join date.");
        return;
      } else {
        employee.doj = moment(employee.doj);
      }

      if (utils.isEmpty(employee.skills)) {
        Notification.error('Please add skills');
        return;
      }

      if (!employee.address1 || !employee.address1.line1 || !employee.address1.city || angular.isUndefined(employee.address1.postalCode) || !employee.address1.countryCode) {
        Notification.error("Please fill up all primary address fields.");
        return;
      }

      if ($scope.bonus_task) {
        employee.bonus = {
          taskList: [{
            name: $scope.bonus_task,
            currencyCode: vm.bonus.currencyCode,
            value: vm.bonus.value
          }]
        };
      }

      if ($scope.picFile) employee.picFile = $scope.picFile;

      if (!employee.salaryAmount) {
        Notification.error("Please enter salary.");
        return;
      }

      $scope.isLoading = true;
      apiFactory.createEmployee(employee).then(function (resp) {
        $scope.isLoading = false;
        Notification.success("Employee saved.");
        $state.go("employees");
      })["catch"](function (error) {
        $scope.isLoading = false;
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error("Failed Employee save");
      });
    };

    vm.addSkillAction = function () {
      if ($scope.isExistsAllSkill()) {
        return;
      }

      if (!vm.addSkill) {
        Notification.error("Please select skill");
        return;
      }

      if (!vm.addSkillLevel) {
        Notification.error("Please select skill level");
        return;
      }

      var skill = vm.allSkills.find(function (x) {
        return x._id === vm.addSkill;
      });

      if (!utils.isEmpty(skill)) {
        if (vm.addSkill === 'all') {
          vm.allSkills = vm.allSkills.concat(vm.employee.skills);
          vm.employee.skills = [];
        }

        vm.employee.skills.push({
          level: vm.addSkillLevel,
          _id: skill._id,
          name: skill.name,
          skillType: skill.type
        });
        var index = vm.allSkills.findIndex(function (x) {
          return x._id === vm.addSkill;
        });

        if (index !== -1) {
          vm.allSkills.splice(index, 1);
        }

        vm.addSkill = '';
        vm.addSkillLevel = '';
      }
    };

    vm.deleteSkillAction = function (skill) {
      var index = vm.employee.skills.find(function (x) {
        return x._id === skill._id;
      });

      if (index !== -1) {
        if (skill._id === 'all') {
          vm.allSkills.unshift({
            _id: 'all',
            name: 'All'
          });
        } else {
          vm.allSkills.push(skill);
        }

        vm.employee.skills.splice(index, 1);
      }
    };

    vm.isManager = false;

    $scope.changeOption = function (type, value) {
      var list = [];

      if (type === 'Designation') {
        list = vm.designationList;
        vm.employee.roleId = value;
      } else if (type === 'EmployeeSetting') {
        list = vm.laberSettingsList;
        vm.employee.employeeSettingId = value;
      }

      if (angular.isUndefined(list)) {
        return;
      }

      var find = list.find(function (elem) {
        return elem._id === value;
      });

      if (find) {
        if (type === 'Designation') {
          vm.designationLabel = find.name;
        } else if (type === 'EmployeeSetting') {
          vm.employeeSettingLabel = find.presetName;
          vm.isManager = find.isManager;
        }
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('employees', {
    controller: EmployeesController,
    controllerAs: 'vm',
    templateUrl: 'app/main/employees/employees/employees.view.html'
  });
  /** @ngInject */

  function EmployeesController($scope, apiFactory, utils, globals, $log, Notification, $state) {
    var vm = this;
    var userStore = globals.userStore;
    vm.showAll = false;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.EMPLOYEE_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.EMPLOYEE_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.EMPLOYEE]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.EMPLOYEE_ACCESS_CREATE = res.data.data[Constants.AccessKey.EMPLOYEE];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.utils = utils;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.labelChecked = false;
    $scope.employees = [];
    $scope.numPerPage = 12; //globals.numPerPage();

    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.totalCount = 0;
    $scope.isLoading = false;
    $scope.isGrid = true;
    vm.searchText = undefined;
    vm.sortMenuList = [{
      label: 'Name',
      key: 'firstName'
    }, {
      label: 'Created Date',
      key: 'created'
    }, {
      label: 'Modified Date',
      key: 'updatedAt'
    }, {
      label: 'Employee Tag',
      key: 'systemTag'
    }];
    vm.sortMenu = "created";

    vm.fetchAllEmployees = function () {
      $scope.isLoading = true;
      apiFactory.getAllEmployees({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        sort: vm.sortMenu,
        sortType: "false",
        isActive: !vm.showAll
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.employees = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function () {
        $scope.isLoading = false;
      });
    };

    vm.fetchAllEmployees();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchAllEmployees();
    };

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) {
        vm.currentPage = 1;
      }

      vm.fetchAllEmployees();
    };

    $scope.goToDetail = function (clientId) {
      $state.go('employeesDetail', {
        id: clientId
      });
    };

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      $scope.employees.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };

    $scope.getColor = function (name) {
      return globals.getAvatarColor(name);
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('payroll', {
    controller: PayrollController,
    controllerAs: 'vm',
    templateUrl: 'app/main/economic/payroll/payroll.view.html'
  });
  /** @ngInject */

  function PayrollController($scope, $log, $uibModal, $state, apiFactory, ecoFactory, Notification, globals, utils) {
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    vm.userData = userStore.get();
    $scope.ECO_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.ECO_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.ECO]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.ECO_ACCESS_CREATE = res.data.data[Constants.AccessKey.ECO];
    //     }).catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.payrolls = [];
    vm.workers = [];
    vm.clients = [];
    vm.tasks = [];
    vm.total = {
      count: 0,
      breaks: 0,
      hours: 0,
      overtime: 0,
      distance: 0
    };
    vm.groups = [];
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    vm.sortItems = [{}, {
      sort: 'name',
      sortType: false
    }, {
      sort: 'projectName',
      sortType: false
    }, {
      sort: 'tasks',
      sortType: false
    }, {
      sort: 'date',
      sortType: false
    }];
    $scope.sortItem = vm.sortItems[0];
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    vm.simpleFilter = {
      startTime: null,
      endTime: null,
      project: null,
      client: null,
      isDateFilter: false,
      isProjectFilter: true,
      isClientFilter: false
    };

    $scope.changeSortItem = function (sort) {
      if (sort === $scope.sortItem.sort) {
        $scope.sortItem.sortType = !$scope.sortItem.sortType;
      } else {
        $scope.sortItem = vm.sortItems.find(function (x) {
          return x.sort === sort;
        });
      }

      vm.initData();
    };

    vm.initData = function () {
      $scope.isLoading = true;
      Promise.all([apiFactory.listAllOngoingProjects(), apiFactory.listAllClients(), apiFactory.getAllEmployees(), apiFactory.queryTasks({
        projectId: vm.project._id
      }), apiFactory.getTimeline(vm.project._id)]).then(function (resp) {
        vm.projects = resp[0].data.list;
        vm.clients = resp[1].data.list;
        vm.workers = resp[2].data.list;
        vm.tasks = resp[3].data.list;
        vm.groups = resp[4].data.data.groups;
        vm.simpleFilter.project = vm.project;
        getInitPayroll();
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    $scope.getDisplayTaskName = function (payroll) {
      if (payroll.task && payroll.task.parent) {
        var group = vm.groups.find(function (x) {
          return x._id == payroll.task.parent;
        });
        if (group) return "".concat(group.name, " - ").concat(payroll.taskName);
      } else {
        return payroll.taskName;
      }
    };

    vm.initData();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.nextPage();
    };

    vm.nextPage = function () {
      $scope.isLoading = true;
      var query = {
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: $scope.sortItem.sort,
        sortType: $scope.sortItem.sortType
      };

      if (vm.simpleFilter.isDateFilter) {
        var startTime = vm.simpleFilter.startTime;
        var endTime;
        if (!vm.simpleFilter.endTime) endTime = new Date();else endTime = vm.simpleFilter.endTime;

        if (startTime) {
          if (endTime - startTime > 0) {
            if (startTime) query.startDate = startTime;
            query.endDate = endTime;

            if ($scope.startDate !== vm.simpleFilter.startTime) {
              $scope.startDate = vm.simpleFilter.startTime;
            }

            if ($scope.endDate !== vm.simpleFilter.endTime) {
              $scope.endDate = vm.simpleFilter.endTime;
            }

            angular.element("#filter_simple_modal").modal('hide');
          } else {
            Notification.error("Invalid Start and End Time.");
            return;
          }
        } else {
          query.endDate = endTime;
        }
      } else {
        if (vm.simpleFilter.isDateFilter) {
          Notification.error("Input start and end time.");
          return;
        }
      }

      if (vm.simpleFilter.isProjectFilter && vm.simpleFilter.project) {
        query.projects = [vm.simpleFilter.project._id];
      }

      if (vm.simpleFilter.isClientFilter && vm.simpleFilter.client) {
        query.users = [vm.simpleFilter.client._id];
      }

      if (!vm.simpleFilter.isProjectFilter && !vm.simpleFilter.isClientFilter) {
        query.projects = vm.projects.map(function (element) {
          return element._id;
        });
      }

      $scope.isLoading = true;
      apiFactory.listAllPayrolls(query).then(function (resp) {
        getPayrollList(resp);
        $scope.isLoading = false;
      })["catch"](function (error) {
        $log.error(error);
        $scope.isLoading = false;
      });
    };

    $scope.searchFunction = function (search) {
      vm.payrolls = vm.payrollsTemp;

      if (search) {
        var searchedItems = [];

        for (var i = 0; i < vm.payrolls.length; i++) {
          if (vm.payrolls[i].userId) {
            var name = vm.payrolls[i].userId.firstName + ' ' + vm.payrolls[i].userId.lastName;

            if (name.toLowerCase().includes(search.toLowerCase())) {
              searchedItems.push(vm.payrolls[i]);
            }
          }
        }

        vm.payrolls = searchedItems;
      }
    };

    $scope.getBreak = function (payroll) {
      return ecoFactory.getPayrollBreak(payroll);
    };

    $scope.getTotalHours = function (payroll) {
      return ecoFactory.getPayrollTotalHours(payroll);
    };

    $scope.getOverTime = function (payroll) {
      return ecoFactory.getPayrollOverTime(payroll);
    };

    $scope.getOtherCost = function (payroll) {
      if (utils.isEmpty(payroll.otherTypeCosts)) return '';
      if (!payroll.userId || !payroll.userId.employeeSettingId || utils.isEmpty(payroll.userId.employeeSettingId.otherTypeCosts)) return '';
      var otherTypeCost = payroll.userId.employeeSettingId.otherTypeCosts.find(function (x) {
        return x._id === payroll.otherTypeCosts[0].id;
      });
      return otherTypeCost ? otherTypeCost.costType : '';
    };

    vm.changeTrackingStatus = function (payroll) {
      var data = {
        trackingEnabled: payroll.trackingEnabled,
        _id: payroll._id
      };
      apiFactory.enablePayrollTracking(data).then(function (resp) {
        for (var i = 0; i < vm.payrolls.length; i++) {
          if (vm.payrolls[i]._id === resp.data.data._id) {
            vm.payrolls[i] = resp.data.data;
          }
        }
      })["catch"](function (error) {
        $log.error(error);
      });
    };

    vm.addPayroll = function () {
      var editData = {
        projectId: vm.project._id,
        client: vm.userData._id,
        date: new Date(),
        distance: 0,
        receipt: [],
        otherTypeCosts: []
      };
      vm.payrolls.unshift({
        mode: 'new',
        projectId: {
          projectName: vm.project.projectName
        },
        client: vm.userData._id,
        date: editData.date,
        editData: editData,
        tasks: []
      });
    };

    vm.editPayroll = function (payroll) {
      payroll.editData = {
        _id: payroll._id,
        projectId: payroll.projectId._id,
        userId: payroll.userId._id,
        client: payroll.client,
        task: payroll.task ? payroll.task._id : undefined,
        taskName: payroll.taskName,
        type: payroll.type,
        startTime: new Date(payroll.startTime),
        endTime: new Date(payroll.endTime),
        driving: payroll.driving,
        breakup: payroll.breakup,
        hours: payroll.hours,
        distance: payroll.distance,
        receipt: [],
        receipts: payroll.receipts,
        otherTypeCost: utils.isEmpty(payroll.otherTypeCosts) ? undefined : payroll.otherTypeCosts[0].id,
        otherTypeCosts: payroll.userId.employeeSettingId.otherTypeCosts || []
      };
    };

    vm.cancelEdit = function (payroll, index) {
      if (payroll.mode === 'new') {
        vm.payrolls.splice(index, 1);
      }

      delete payroll.editData;
    };

    vm.updatePayroll = function (payroll) {
      if (utils.isEmpty(payroll.editData.userId) || utils.isEmpty(payroll.editData.client) || utils.isEmpty(payroll.editData.taskName) || !payroll.editData.startTime || !payroll.editData.endTime) {
        Notification.error('Please fill input field.');
        return;
      }

      var payrollData = {
        _id: payroll.editData._id,
        projectId: payroll.editData.projectId,
        userId: payroll.editData.userId,
        client: payroll.editData.client,
        task: payroll.editData.task,
        taskName: payroll.editData.taskName,
        type: payroll.editData.type,
        startTime: payroll.editData.startTime,
        endTime: payroll.editData.endTime,
        driving: payroll.editData.driving,
        breakup: payroll.editData.breakup,
        hours: payroll.editData.hours,
        distance: payroll.editData.distance,
        receipt: payroll.editData.receipt,
        receipts: payroll.editData.receipts,
        otherTypeCosts: []
      };

      if (payroll.editData.otherTypeCost) {
        var otherTypeCost = payroll.editData.otherTypeCosts.find(function (x) {
          return x._id === payroll.editData.otherTypeCost;
        });
        payrollData.otherTypeCosts = [{
          id: payroll.editData.otherTypeCost,
          costType: otherTypeCost.costType,
          startTime: payrollData.startTime,
          endTime: payrollData.endTime
        }];
      }

      if (payroll.mode === 'new') {
        $scope.isLoading = true;
        apiFactory.createPayroll(payrollData).then(function () {
          $scope.isLoading = false;
          onFilter();
          Notification.success('Payroll is created successfully.');
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(err.message || 'Error occurred during create.');
        });
      } else {
        $scope.isLoading = true;
        apiFactory.updatePayroll(payrollData).then(function () {
          $scope.isLoading = false;
          onFilter();
          Notification.success('Payroll is updated successfully.');
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(err.message || 'Error occurred during update.');
        });
      }
    };

    vm.removePayroll = function (payroll) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function (result) {
        if (result) {
          apiFactory.deletePayroll(payroll).then(function (resp) {
            $log.log(resp);
            Notification.success("Payroll removed successfully.");
            var index = vm.payrolls.indexOf(payroll);
            vm.payrolls.splice(index, 1);
            $scope.$apply();
          })["catch"](function (error) {
            $log.error(error);
            Notification.error("Failed to remove!");
          });
        }
      });
    };

    vm.viewPayroll = function (_payroll) {
      $uibModal.open({
        animation: true,
        component: 'payrollModal',
        backdrop: 'static',
        windowClass: 'economic-payroll-modal',
        resolve: {
          payroll: function payroll() {
            return _payroll;
          }
        }
      });
    };

    vm.selectTask = function (payroll) {
      var task = vm.tasks.find(function (x) {
        return x._id === payroll.editData.task;
      });

      if (task) {
        payroll.editData.taskName = task.name;
      }
    };

    vm.selectWorker = function (payroll) {
      var worker = vm.workers.find(function (x) {
        return x._id === payroll.editData.userId;
      });

      if (worker && worker.employeeSettingId) {
        payroll.editData.otherTypeCosts = worker.employeeSettingId.otherTypeCosts;
      } else {
        payroll.editData.otherTypeCosts = [];
      }
    };

    vm.exportAsCSV = function () {
      $scope.isLoading = true;
      var query = {};

      if (vm.simpleFilter.project) {
        query.projects = [vm.simpleFilter.project._id];
      } else {
        query.projects = vm.projects.map(function (element) {
          return element._id;
        });
      }

      apiFactory.exportPayrollsToCSV(query).then(function (resp) {
        var url = resp.data.data;
        utils.downloadFile(url, 'payroll.csv').then(function () {
          return $scope.isLoading = false;
        })["catch"](function (err) {
          $log.error(err);
          $scope.isLoading = false;
          Notification.error('Failed to export.');
        });
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
        Notification.error('Failed to export');
      });
    };

    vm.openFilterModal = function () {
      if ($scope.startDate || $scope.endDate) vm.simpleFilter.isDateFilter = true;

      if (vm.simpleFilter.startTime !== $scope.startDate) {
        vm.simpleFilter.startTime = $scope.startDate;
      }

      if (vm.simpleFilter.endTime !== $scope.endDate) {
        vm.simpleFilter.endTime = $scope.endDate;
      }

      $uibModal.open({
        animation: true,
        component: 'payrollFilterModal',
        backdrop: 'static',
        windowClass: 'economic-payroll-filter-modal',
        resolve: {
          filter: function filter() {
            return vm.simpleFilter;
          },
          projects: function projects() {
            return vm.projects;
          },
          workers: function workers() {
            return vm.workers;
          }
        }
      }).result.then(function () {
        if (vm.simpleFilter.startTime !== $scope.startDate) {
          $scope.startDate = vm.simpleFilter.startTime;
        }

        if (vm.simpleFilter.endTime !== $scope.endDate) {
          $scope.endDate = vm.simpleFilter.endTime;
        }

        onFilter();
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.onChangeFilterDate = function () {
      vm.simpleFilter.isDateFilter = $scope.startDate || $scope.endDate;

      if ($scope.endDate) {
        $scope.endDate = new Date($scope.endDate);
        $scope.endDate.setHours(23, 59, 59, 0);
      }

      if (vm.simpleFilter.isProjectFilter && !vm.simpleFilter.project) {
        vm.simpleFilter.isProjectFilter = false;
      }

      if (vm.simpleFilter.isClientFilter && !vm.simpleFilter.client) {
        vm.simpleFilter.isClientFilter = false;
      }

      if ($scope.startDate !== vm.simpleFilter.startTime) {
        vm.simpleFilter.startTime = $scope.startDate;
      }

      if ($scope.endDate !== vm.simpleFilter.endTime) {
        vm.simpleFilter.endTime = $scope.endDate;
      }

      onFilter();
    };

    function getInitPayroll() {
      var query = {
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        sort: $scope.sortItem.sort,
        sortType: $scope.sortItem.sortType
      };

      if (vm.simpleFilter.project) {
        query.projects = [vm.simpleFilter.project._id];
      } else {
        query.projects = vm.projects.map(function (element) {
          return element._id;
        });
      }

      if (vm.simpleFilter.client) {
        query.users = [vm.simpleFilter.client._id];
      }

      $scope.isLoading = true;
      apiFactory.listAllPayrolls(query).then(function (resp) {
        getPayrollList(resp);
        $scope.isLoading = false;
      })["catch"](function (error) {
        $log.error(error);
        $scope.isLoading = false;
      });
    }

    function onFilter() {
      var query = {
        page: 1,
        chunk: 10,
        sort: $scope.sortItem.sort,
        sortType: $scope.sortItem.sortType
      };

      if (vm.simpleFilter.isDateFilter) {
        var startTime = vm.simpleFilter.startTime;
        var endTime = vm.simpleFilter.endTime ? vm.simpleFilter.endTime : new Date();

        if (startTime) {
          if (endTime - startTime > 0) {
            query.startDate = startTime;
            query.endDate = endTime;

            if ($scope.startDate !== vm.simpleFilter.startTime) {
              $scope.startDate = vm.simpleFilter.startTime;
            }

            if ($scope.endDate !== vm.simpleFilter.endTime) {
              $scope.endDate = vm.simpleFilter.endTime;
            }

            angular.element("#filter_simple_modal").modal('hide');
          } else {
            Notification.error("Invalid Start and End Time.");
            return;
          }
        } else {
          query.endDate = endTime;
        }
      } else {
        if (vm.simpleFilter.isDateFilter) {
          Notification.error("Input start and end time.");
          return;
        }
      }

      if (vm.simpleFilter.isProjectFilter && vm.simpleFilter.project) {
        query.projects = [vm.simpleFilter.project._id];
      } else {
        if (vm.simpleFilter.isProjectFilter) {
          Notification.error("Please Select Project.");
          return;
        }
      }

      if (vm.simpleFilter.isClientFilter && vm.simpleFilter.client) {
        query.users = [vm.simpleFilter.client._id];
      } else {
        if (vm.simpleFilter.isClientFilter) {
          Notification.error("Please Select Client.");
          return;
        }
      }

      if (!vm.simpleFilter.isProjectFilter && !vm.simpleFilter.isClientFilter) {
        query.projects = vm.projects.map(function (element) {
          return element._id;
        });
      }

      $scope.isLoading = true;
      apiFactory.listAllPayrolls(query).then(function (resp) {
        getPayrollList(resp);
        $scope.isLoading = false;
      })["catch"](function (error) {
        $scope.isLoading = false;
        $log.error(error);
      });
    }

    function getPayrollList(resp) {
      vm.payrolls = resp.data.list;
      vm.payrollsTemp = vm.payrolls;
      vm.total = resp.data.total;
      $scope.totalCount = resp.data.total.count;
      $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('workOrder', {
    controller: WorkOrderController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/workOrder/workOrder.view.html'
  });
  /** @ngInject */

  function WorkOrderController(globals, apiFactory, $scope) {
    $scope.orderFilters = [{
      id: 'week',
      label: 'This Week'
    }, {
      id: 'unschedule',
      label: 'Unscheduled'
    }, {
      id: 'pending',
      label: 'Pending'
    }, {
      id: 'late',
      label: 'Late'
    }];
    $scope.orderFilter = 'week';
    $scope.billFilters = [{
      id: 'week',
      label: 'This Week'
    }, {
      id: 'pending',
      label: 'Pending'
    }, {
      id: 'late',
      label: 'Late Approvel'
    }];
    $scope.billFilter = 'week';
    $scope.orders = [{
      id: 72,
      title: '# 1725 - Check hot plate Welder A',
      state: 'high'
    }, {
      id: 72,
      title: '# 1725 - Frayed wire causing power outage',
      state: 'medium'
    }, {
      id: 72,
      title: '# 1725 - Switch to backup generator x2',
      state: 'low'
    }, {
      id: 72,
      title: '# 1725 - Ensure conveyor belt is running smoothly',
      state: 'medium'
    }, {
      id: 72,
      title: '# 1725 - Inspect control valve',
      state: 'medium'
    }];
    $scope.bills = [{
      id: '113',
      title: 'AHJ Building Department',
      state: 'approve',
      overDue: false,
      price: '2,409.00'
    }, {
      id: 'BL-279',
      title: 'Information Security Systems',
      state: 'paid',
      overDue: true,
      dueDate: 5,
      price: '2,409.00'
    }, {
      id: '#171',
      title: 'Mechanical Systems, Inc.',
      state: 'paid',
      overDue: false,
      price: '2,409.00'
    }, {
      id: 'BILL-567',
      title: 'Moment Engineering',
      state: 'approve',
      overDue: true,
      dueDate: 10,
      price: '2,409.00'
    }, {
      id: 'BL-5678',
      title: 'Tessellated Perceptions',
      state: 'approve',
      overDue: false,
      price: '2,409.00'
    }];

    $scope.sort = function (type, id) {
      if (type == 'order') {
        $scope.orderFilter = id;
      } else {
        $scope.billFilter = id;
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('supplierManage', {
    controller: SupplierManageController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/supplierManage/supplierManage.view.html'
  });
  /** @ngInject */

  function SupplierManageController(globals, apiFactory, $scope, $state, $rootScope, $log, storageFactory, localStorageService) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    $scope.projects = [];
    $scope.tenders = [];
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    localStorageService.set('collaboratorType', 1);
    var onSelProject = $rootScope.$on('on-select-project-no-bookmark', function () {
      if (vm.dashboardData && vm.dashboardData.projects.length > 0) $scope.$root.$emit('on-select-project', vm.dashboardData.projects[0]);
    });
    $rootScope.$on('$destroy', onSelProject);
    Promise.all([apiFactory.getCompanyById(vm.userData.companyId), storageFactory.listAllProjects(), storageFactory.listAllProjects({
      type: 'ongoing'
    }), storageFactory.listAllProjects({
      type: 'tender'
    })]).then(function (data) {
      /* Add companyData to store */
      companyStore.set(data[0].data);
      vm.dashboardData = {
        company: data[0].data,
        projects: data[1].data.list
      };
      $scope.projects = data[2].data.list;
      $scope.tenders = data[3].data.list;
    })["catch"](function (err) {
      $log.error(err);
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('subContractorManage', {
    controller: SubContractorManageController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/subContractorManage/subContractorManage.view.html'
  });
  /** @ngInject */

  function SubContractorManageController(globals, apiFactory, $scope, $state, $rootScope, $log, storageFactory, localStorageService) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    localStorageService.set('collaboratorType', 2);
    var onSelProject = $rootScope.$on('on-select-project-no-bookmark', function () {
      if (vm.dashboardData && vm.dashboardData.projects.length > 0) $scope.$root.$emit('on-select-project', vm.dashboardData.projects[0]);
    });
    $rootScope.$on('$destroy', onSelProject);
    Promise.all([apiFactory.getCompanyById(vm.userData.companyId), storageFactory.listAllProjects()]).then(function (data) {
      /* Add companyData to store */
      companyStore.set(data[0].data);
      vm.dashboardData = {
        company: data[0].data,
        projects: data[1].data.list
      };
    })["catch"](function (err) {
      $log.error(err);
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('siteManage1', {
    controller: SiteManageController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/siteManage/siteManage.view.html'
  });
  /** @ngInject */

  function SiteManageController(globals, apiFactory, $scope, $state, $rootScope, $log, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    var onSelProject = $rootScope.$on('on-select-project-no-bookmark', function () {
      if (vm.dashboardData && vm.dashboardData.projects.length > 0) $scope.$root.$emit('on-select-project', vm.dashboardData.projects[0]);
    });
    $rootScope.$on('$destroy', onSelProject);
    Promise.all([apiFactory.getCompanyById(vm.userData.companyId), storageFactory.listAllProjects()]).then(function (data) {
      /* Add companyData to store */
      companyStore.set(data[0].data);
      vm.dashboardData = {
        company: data[0].data,
        projects: data[1].data.list
      };
    })["catch"](function (err) {
      $log.error(err);
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('salesManage', {
    controller: salesManageController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/salesManage/salesManage.view.html'
  });
  /** @ngInject */

  function salesManageController($scope, globals, $state) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.create = function (page) {
      if (page == 0) {
        $state.go('createOffer');
      } else if (page == 1) {
        $state.go('calcMain');
      } else if (page == 2) {
        $state.go('calcExtra');
      } else if (page == 3) {
        $state.go('fileManage');
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('qsheManage', {
    controller: QsheManageController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/qsheManage/qsheManage.view.html'
  });
  /** @ngInject */

  function QsheManageController(globals, apiFactory, $scope, $state, $rootScope, $log, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    var onSelProject = $rootScope.$on('on-select-project-no-bookmark', function () {
      if (vm.dashboardData && vm.dashboardData.projects.length > 0) $scope.$root.$emit('on-select-project', vm.dashboardData.projects[0]);
    });
    $rootScope.$on('$destroy', onSelProject);
    Promise.all([apiFactory.getCompanyById(vm.userData.companyId), storageFactory.listAllProjects()]).then(function (data) {
      /* Add companyData to store */
      companyStore.set(data[0].data);
      vm.dashboardData = {
        company: data[0].data,
        projects: data[1].data.list
      };
    })["catch"](function (err) {
      $log.error(err);
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('projectDesign', {
    controller: projectDesignController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/projectDesign/projectDesign.view.html'
  });
  /** @ngInject */

  function projectDesignController(globals, apiFactory, $scope, $state, $rootScope, $log, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    var onSelProject = $rootScope.$on('on-select-project-no-bookmark', function () {
      if (vm.dashboardData && vm.dashboardData.projects.length > 0) $scope.$root.$emit('on-select-project', vm.dashboardData.projects[0]);
    });

    $scope.gotoTimeline = function () {
      $state.go('timeline');
    };

    $rootScope.$on('$destroy', onSelProject);
    Promise.all([apiFactory.getCompanyById(vm.userData.companyId), storageFactory.listAllProjects()]).then(function (data) {
      /* Add companyData to store */
      companyStore.set(data[0].data);
      vm.dashboardData = {
        company: data[0].data,
        projects: data[1].data.list
      };
    })["catch"](function (err) {
      $log.error(err);
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('productionsBoard', {
    controller: ProductionsBoardController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/productionsBoard/productionsBoard.view.html'
  });
  /** @ngInject */

  function ProductionsBoardController(globals, apiFactory, $scope, $state, $rootScope, $log, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    var onSelProject = $rootScope.$on('on-select-project-no-bookmark', function () {
      if (vm.dashboardData && vm.dashboardData.projects.length > 0) $scope.$root.$emit('on-select-project', vm.dashboardData.projects[0]);
    });

    $scope.gotoTimeline = function () {
      $state.go('timeline');
    };

    $rootScope.$on('$destroy', onSelProject);
    Promise.all([apiFactory.getCompanyById(vm.userData.companyId), storageFactory.listAllProjects()]).then(function (data) {
      /* Add companyData to store */
      companyStore.set(data[0].data);
      vm.dashboardData = {
        company: data[0].data,
        projects: data[1].data.list
      };
    })["catch"](function (err) {
      $log.error(err);
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('procurement', {
    controller: ProcurementController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/procurement/procurement.view.html'
  });
  /** @ngInject */

  function ProcurementController(globals, apiFactory, $scope) {
    $scope.percent = 0.89;
    $scope.sortTypes = [{
      id: 'all',
      label: 'All'
    }, {
      id: 'inventory',
      label: 'Inventory'
    }, {
      id: 'sub',
      label: 'Sub-Contractors'
    }];
    $scope.sortType = 'all';
    $scope.topItems = [{
      name: 'Product 1',
      percent: 0.89,
      total_amount: 2.5
    }, {
      name: 'Product 2',
      percent: 0.48,
      total_amount: 200
    }, {
      name: 'Product 3',
      percent: 0.22,
      total_amount: 1500
    }];
    $scope.bottomItems = [{
      name: 'Product 1',
      percent: 0.74,
      total_amount: 2.5
    }, {
      name: 'Product 2',
      percent: 0.51,
      total_amount: 20
    }, {
      name: 'Product 3',
      percent: 0.20,
      total_amount: 150
    }];
    $scope.filtertypelistvalue1 = '1';
    $scope.filtertypelist1 = [{
      _id: '1',
      tagName: "Products"
    }];
    $scope.filtertypelistvalue2 = '1';
    $scope.filtertypelist2 = [{
      _id: '1',
      tagName: "20/12/2021 - 30/12/2021"
    }];
    $scope.filtertypelistvalue3 = '1';
    $scope.filtertypelist3 = [{
      _id: '1',
      tagName: "Purchasing Volume"
    }];
    $scope.categories = [{
      name: 'Electrical',
      price: 53.3
    }, {
      name: 'Metalworking',
      price: 32.3
    }, {
      name: 'Safety & Health',
      price: 4.7
    }, {
      name: 'Stainless Steel',
      price: 1.3
    }, {
      name: 'Security',
      price: 0.8
    }, {
      name: 'Woodworking',
      price: 0.2
    }, {
      name: 'Ceiling and Particular',
      price: 0.2
    }, {
      name: 'Tiling & Plasterial',
      price: 0.0
    }, {
      name: 'Stainless Steel',
      price: 0.0
    }];
    $scope.vendors = [{
      name: 'Vendor_422',
      price: 22.2
    }, {
      name: 'Vendor_356',
      price: 14.0
    }, {
      name: 'Vendor_183',
      price: 6.9
    }, {
      name: 'Vendor_146',
      price: 6.0
    }, {
      name: 'Vendor_158',
      price: 5.8
    }, {
      name: 'Vendor_445',
      price: 4.8
    }, {
      name: 'Vendor_525',
      price: 3.2
    }, {
      name: 'Vendor_593',
      price: 2.0
    }, {
      name: 'Vendor_189',
      price: 1.9
    }, {
      name: 'Vendor_307',
      price: 1.7
    }, {
      name: 'Vendor_151',
      price: 1.7
    }, {
      name: 'Vendor_441',
      price: 1.6
    }, {
      name: 'Vendor_472',
      price: 1.4
    }, {
      name: 'Vendor_470',
      price: 1.4
    }, {
      name: 'Vendor_120',
      price: 1.3
    }];
    $scope.products = [{
      name: 'Product_1288',
      volume: 3558,
      avg_price: 10.61,
      avg_percent: 5.1
    }, {
      name: 'Product_1421',
      volume: 3218,
      avg_price: 82.55,
      avg_percent: -0.6
    }, {
      name: 'Product_1913',
      volume: 2409,
      avg_price: 8.72,
      avg_percent: 6.1
    }, {
      name: 'Product_2277',
      volume: 2267,
      avg_price: 12.45,
      avg_percent: 2.1
    }, {
      name: 'Product_2281',
      volume: 2209,
      avg_price: 73.32,
      avg_percent: -2.0
    }, {
      name: 'Product_2589',
      volume: 1809,
      avg_price: 212.43,
      avg_percent: 0.1
    }, {
      name: 'Product_2723',
      volume: 1571,
      avg_price: 4.36,
      avg_percent: 9.8
    }, {
      name: 'Product_3032',
      volume: 1556,
      avg_price: 24.75,
      avg_percent: -1.2
    }, {
      name: 'Product_3068',
      volume: 1348,
      avg_price: 79.61,
      avg_percent: -0.4
    }, {
      name: 'Product_3409',
      volume: 1317,
      avg_price: 25.80,
      avg_percent: -0.3
    }];
    $scope.colors1 = ["#3DD598", "#657786"];
    $scope.colors2 = ["#3DD598"];
    $scope.colors3 = ["#FFBC25"];
    $scope.labels = ["January", "February", "March", "April", "May", "June", "July"];
    $scope.series1 = ['Series A', 'Series B'];
    $scope.series2 = ['Series A'];
    $scope.data1 = [[0, 59, 80, 81, 56, 55, 40], [0, 48, 40, 19, 86, 27, 90]];
    $scope.data2 = [[0, 59, 80, 81, 56, 55, 40]];
    $scope.data3 = [[0, 48, 40, 19, 86, 27, 90]];
    $scope.datasetOverride1 = [{
      yAxisID: 'y-axis-1',
      xAxisID: 'x-axis-1'
    }, {
      yAxisID: 'y-axis-2',
      xAxisID: 'x-axis-2'
    }];
    $scope.datasetOverride2 = [{
      yAxisID: 'y-axis-1',
      xAxisID: 'x-axis-1'
    }];
    $scope.options1 = {
      scales: {
        yAxes: [{
          id: 'y-axis-1',
          type: 'linear',
          display: false,
          position: 'left',
          ticks: {
            display: false
          }
        }, {
          id: 'y-axis-2',
          type: 'linear',
          display: false,
          position: 'right',
          ticks: {
            display: false
          }
        }],
        xAxes: [{
          id: 'x-axis-1',
          display: false,
          ticks: {
            display: false
          }
        }, {
          id: 'x-axis-2',
          display: false,
          ticks: {
            display: false
          }
        }]
      },
      elements: {
        point: {
          radius: 0
        },
        line: {
          fill: false
        }
      }
    };
    $scope.options2 = {
      scales: {
        yAxes: [{
          id: 'y-axis-1',
          type: 'linear',
          display: false,
          position: 'left',
          ticks: {
            display: false
          }
        }],
        xAxes: [{
          id: 'x-axis-1',
          display: false,
          ticks: {
            display: false
          }
        }]
      },
      elements: {
        point: {
          radius: 0
        },
        line: {
          fill: true
        }
      }
    };
    $scope.options3 = {
      scales: {
        yAxes: [{
          id: 'y-axis-1',
          type: 'linear',
          display: false,
          position: 'left',
          ticks: {
            display: false
          }
        }],
        xAxes: [{
          id: 'x-axis-1',
          display: false,
          ticks: {
            display: false
          }
        }]
      },
      elements: {
        point: {
          radius: 0
        },
        line: {
          fill: false
        }
      }
    };

    $scope.getProgressStyle = function (item) {
      return {
        'stroke-dashoffset': 188 * (1 - item),
        stroke: item.color
      };
    };

    $scope.sort = function (id) {
      $scope.sortType = id;
    };
  }
})();


"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('economicManage', {
    controller: EconomicManageController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/economicManage/economicManage.view.html'
  });
  /** @ngInject */

  function EconomicManageController($document, $scope, $state, apiFactory, Notification, globals, moment, $log, utils, ecoFactory, storageFactory, $filter) {
    var vm = this;
    /* Requiring vars */

    var companyStore = globals.companyStore,
        projectStore = globals.projectStore,
        userStore = globals.userStore,
        filterStore = globals.filterStore;
    vm.project = projectStore.get();
    vm.companyData = companyStore.get();
    vm.userData = userStore.get();
    vm.filter = {
      projectId: undefined,
      clientId: undefined,
      project: undefined,
      client: undefined,
      startDate: undefined,
      endDate: undefined
    };
    vm.issuesCount = {
      opened: 0,
      resolved: 0
    };
    vm.reportsCount = {
      opened: 0,
      resolved: 0
    };
    $scope.accidentPopoverOpen = false;
    $scope.subcontractorHourPopoverOpen = false;
    vm.projectTypeOptioins = [{
      label: 'All Projects',
      value: 'all'
    }, {
      label: 'Ongoing Projects',
      value: 'ongoing'
    }, {
      label: 'Completed Projects',
      value: 'completed'
    }, {
      label: 'Service Projects',
      value: 'service'
    }];
    vm.projectType = 'all';
    vm.projectFilter = [];
    vm.allProjects = [];
    vm.ongoingProjects = [];
    vm.completedProjects = [];
    vm.serviceProjects = [];
    vm.filterSelection = ['ongoing', 'completed', 'service'];
    vm.bShowFilter = false;
    vm.clients = [];
    vm.workers = [];
    vm.subcontractors = [];
    vm.totalWorkingHours = 0;
    vm.projectCompletePercent = 0;
    vm.billings = [];
    vm.duration = null;
    vm.sheets = [];
    vm.laborItems = [];
    vm.laborSalesPriceToal = 0;
    vm.accidentCount = 0;
    vm.subcontractorHours = 0;
    vm.supplierNegotiatedPrice = 0;
    vm.subcontractorNegotiatedPrice = 0;
    vm.accident = {}; // for add accident popup

    vm.subcontractorHour = {}; // for add subcontractor hour popup

    vm.billingGraph = {
      data: []
    };
    vm.tabs = [{
      id: 'supplier',
      name: 'Supplier'
    }, {
      id: 'labor',
      name: 'Labour'
    }, {
      id: 'subcontractor',
      name: 'Sub Contractor'
    }, {
      id: 'va-order',
      name: 'VA Order'
    }];
    vm.filterData = filterStore.get();

    if (vm.filterData && vm.filterData.clientId) {
      vm.filter.clientId = vm.filterData.clientId;
    }

    vm.onShowFilter = function () {
      vm.bShowFilter = !this.bShowFilter;
      vm.tempFilter = _toConsumableArray(vm.filterSelection);
      vm.tempProjectFilter = _toConsumableArray(vm.projectFilter);
    };

    vm.selectProjectType = function (type) {
      $log.log(type);

      if (type == 'all') {
        // if(vm.tempFilter.length == 3) {
        //   vm.tempFilter = [];
        // } else {
        vm.tempFilter = ['ongoing', 'completed', 'service'];
        vm.filterProjectList = vm.allProjects; // }
      } else if (type == 'ongoing') {
        // var idx = vm.tempFilter.indexOf('ongoing');
        // if(idx > -1) {
        //   vm.tempFilter.splice(idx, 1);
        // } else {
        //   vm.tempFilter.push('ongoing');
        // }
        vm.tempFilter = ['ongoing'];
        vm.filterProjectList = vm.ongoingProjects;
      } else if (type == 'completed') {
        // idx = vm.tempFilter.indexOf('completed');
        // if(idx > -1) {
        //   vm.tempFilter.splice(idx, 1);
        // } else {
        //   vm.tempFilter.push('completed');
        // }
        vm.tempFilter = ['completed'];
        vm.filterProjectList = vm.completedProjects;
      } else if (type == 'service') {
        // idx = vm.tempFilter.indexOf('service');
        // if(idx > -1) {
        //   vm.tempFilter.splice(idx, 1);
        // } else {
        //   vm.tempFilter.push('service');
        // }
        vm.tempFilter = ['service'];
        vm.filterProjectList = vm.serviceProjects;
      }
    };

    vm.checkProject = function (projectId) {
      $log.log(projectId);
      var idx = vm.tempProjectFilter.indexOf(projectId);

      if (idx > -1) {
        vm.tempProjectFilter.splice(idx, 1);
      } else {
        vm.tempProjectFilter.push(projectId);
      }
    };

    vm.filterSelectAll = function () {
      vm.tempProjectFilter = vm.filterProjectList.map(function (project) {
        return project._id;
      });
    };

    vm.filterClearAll = function () {
      vm.tempProjectFilter = [];
    };

    vm.onFilterOk = function () {
      vm.filterSelection = _toConsumableArray(vm.tempFilter);
      vm.projectFilter = _toConsumableArray(vm.tempProjectFilter);
      vm.projects = []; // vm.filterSelection.forEach(selection => {
      //   if(selection == 'ongoing') {
      //     vm.projects = vm.projects.concat(vm.ongoingProjects);
      //   } else if(selection == 'completed') {
      //     vm.projects = vm.projects.concat(vm.completedProjects);
      //   } else if(selection == 'service') {
      //     vm.projects = vm.projects.concat(vm.serviceProjects);
      //   }
      // })

      vm.projects = vm.allProjects.filter(function (project) {
        return vm.projectFilter.indexOf(project._id) > -1;
      });
      vm.selProjects = [{
        _id: "all",
        projectName: "All Project"
      }];
      vm.selProjects = vm.selProjects.concat(vm.projects);
      vm.filter.projectId = 'all';
      vm.isAllProject = true;
      $log.log('list of projects = ', vm.selProjects);
      vm.bShowFilter = false;
      applyFilter();
    };

    vm.onFilterCancel = function () {
      vm.tempFilter = [];
      vm.tempProjectFilter = [];
      vm.bShowFilter = false;
    };

    vm.selectFilterProject = function (projectId) {
      if (vm.selProjects) {
        vm.filter.project = vm.selProjects.find(function (x) {
          return x._id === projectId;
        });
        $log.log(vm.filter.project); // projectStore.set(vm.filter.project);
        // $state.reload();

        applyFilter();
      }
    };

    vm.selectFilterClient = function (clientId) {
      if (vm.clients) {
        vm.filter.client = vm.clients.find(function (x) {
          return x._id === clientId;
        });
        var filterData = filterStore.get();

        if (filterData) {
          filterStore.set({
            clientId: clientId,
            start: filterData.start,
            end: filterData.end
          });
        } else {
          filterStore.set({
            clientId: clientId
          });
        }

        vm.filter.project = vm.selProjects.find(function (x) {
          return x._id === 'all';
        });
        projectStore.set(vm.filter.project);
        $state.reload();
        applyFilter();
      }
    };

    vm.changeFilterDate = function () {
      if (vm.filter.startDate && vm.filter.endDate) {
        if (vm.filter.startDate.getTime() > vm.filter.endDate.getTime()) {
          Notification.error("Start period cannot after than end period.");
          return;
        }

        var filterData = filterStore.get();

        if (filterData) {
          filterStore.set({
            clientId: filterData.clientId,
            start: new Date(vm.filter.startDate),
            end: new Date(vm.filter.endDate)
          });
        } else {
          filterStore.set({
            start: new Date(vm.filter.startDate),
            end: new Date(vm.filter.endDate)
          });
        }
      } // applyFilter();

    };

    vm.dropLabor = function (labor, dragData) {
      if (!dragData.payrolls || !dragData.payrolls.length) {
        Notification.error('There is no payroll items.');
        return;
      }

      $scope.isProcessing = true;
      apiFactory.assignGroupToPayrolls({
        group: labor._id,
        groupType: labor.groupType,
        payrolls: dragData.payrolls
      }).then(function () {
        var item = vm.laborItems.find(function (x) {
          return x._id === labor._id;
        });

        if (item) {
          item.expense += dragData.expense;
          item.budget += dragData.budget;
        }

        var index = vm.laborItems.findIndex(function (x) {
          return x._id === dragData._id;
        });

        if (index !== -1) {
          vm.laborItems.splice(index, 1);
        }

        $scope.isProcessing = false;
      })["catch"](function (err) {
        $log.error(err);
        Notification.error('Something went wrong.');
        $scope.isProcessing = false;
      });
    };

    function initData() {
      globals.getCurrency().then(function (resp) {
        vm.getCurrencyCode = resp.data;
        $scope.companyCurrency = vm.getCurrencyCode.find(function (element) {
          return element.cc === vm.companyData.currentCurrency.currencyCode;
        });
      });
      $scope.isLoading = true;
      Promise.all([storageFactory.listAllProjects(), apiFactory.listAllClients()]).then(function (resp) {
        var index = 0;
        vm.projects = resp[index++].data.list;
        vm.clients = resp[index++].data.list || []; // vm.filterProjects = [
        //   {_id: "all", projectName: $filter('translate')('All Projects')}
        // ];
        // if (vm.filterData && vm.filterData.clientId) {
        //   vm.filterProjects.pushAll(vm.projects.filter((p) => {
        //     return p.client == vm.filterData.clientId
        //   }));
        // } else {
        //   vm.filterProjects.pushAll(vm.projects);
        // }
        // let filterProject = vm.project ? vm.project : undefined;
        // if (filterProject) {
        //   vm.filter.project = filterProject;
        //   vm.filter.projectId = filterProject._id;
        //   vm.filter.startDate = new Date(filterProject.startDate);
        //   vm.filter.endDate = new Date(filterProject.endDate);
        // } else {
        //   vm.filter.project = vm.filterProjects[0];
        //   vm.filter.projectId = vm.filterProjects[0]._id;
        //   // $log.log('================filter projects = ', vm.filterProjects);
        //   // vm.filter.startDate = new Date(vm.filterProjects[0].startDate);
        //   // vm.filter.endDate = new Date(vm.filterProjects[0].endDate);
        // }

        var projects = [{
          _id: 'all',
          projectName: $filter('translate')("All Projects")
        } // {_id: 'ongoing', projectName: $filter('translate')("All Ongoings")},
        // {_id: 'completed', projectName: $filter('translate')("All Completed")},
        // {_id: 'service', projectName: $filter('translate')("All Service")},
        ];
        vm.projects.forEach(function (project) {
          if (project.managers) {
            project.managers.forEach(function (manager) {
              return manager.displayName = manager.userId ? manager.userId.displayName : 'Manager';
            });
          }

          project.startDate = new Date(project.startDate);
          project.endDate = new Date(project.endDate);
          project.endDate.setHours(23, 59, 59, 0);
          var type = '';

          if (project.projectStatus == 1) {
            type = 'Ongoing';
            vm.ongoingProjects.push(project);
          } else if (project.projectStatus == 2) {
            type = 'Completed';
            vm.completedProjects.push(project);
          } else if (project.isServiceProject) {
            type = 'Service';
            vm.serviceProjects.push(project);
          }

          project.projectName = project.projectName + ' (' + type + ')'; // projects.push(project);
        });
        vm.allProjects = vm.allProjects.concat(vm.ongoingProjects, vm.completedProjects, vm.serviceProjects);
        projects = projects.concat(vm.ongoingProjects, vm.completedProjects, vm.serviceProjects);
        vm.selProjects = projects;
        var curProject = projectStore.get();
        var filterProject = curProject ? vm.selProjects.find(function (x) {
          return x._id === curProject._id;
        }) : undefined;

        if (filterProject) {
          vm.project = filterProject;
          vm.filter.projectId = vm.project._id;
          vm.isAllProject = false;
        }

        vm.filterProjectList = vm.allProjects;
        vm.filter.startDate = new Date();
        vm.filter.endDate = new Date();

        if (vm.filter.projectId == 'all') {
          vm.projects.forEach(function (project) {
            var projectStartDate = new Date(project.startDate);
            var projectEndDate = new Date(project.endDate);

            if (vm.filter.startDate > projectStartDate) {
              vm.filter.startDate = projectStartDate;
            }

            if (vm.filter.endDate < projectEndDate) {
              vm.filter.endDate = projectEndDate;
            }
          });
        } else {
          vm.filter.startDate = new Date(vm.project.startDate);
          vm.filter.endDate = new Date(vm.project.endDate);
        }

        vm.clients.unshift({
          clientName: ""
        });
        $scope.$apply();
        $log.log(vm.filter);
        applyFilter();
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }

    initData();

    function applyFilter() {
      vm.cash = {
        totalCompanyCost: 0,
        totalWorkerCost: 0,
        totalInventoryCost: 0,
        totalSalesPrice: 0,
        totalProfit: 0,
        totalCompanyRevCost: 0,
        totalLaborCost: 0,
        totalInventoryApprovedCost: 0,
        totalInvoiced: 0,
        totalCostProfit: 0,
        companyCostPercent: 0,
        costPercent: 0,
        laborPercent: 0,
        inventoryPercent: 0,
        invoicePercent: 0,
        profitPercent: 0,
        vaApproved: 0,
        vaPending: 0,
        vaBill: 0,
        vaInvoiced: 0,
        vaProfit: 0,
        progress: 0,
        totalProfitWithVAData: 0
      };
      $scope.isLoading = true;
      var query = {};

      if (vm.filter.clientId) {
        var projects = [];
        vm.projects.forEach(function (project) {
          var find = false;

          if (project.client && vm.filter.clientId) {
            find = vm.filter.clientId === project.client;
          }

          if (find) {
            projects.push(project);
          }
        });
        var projectIds = projects.map(function (x) {
          return x._id;
        });
        query.projects = projectIds;
        query.clients = [vm.filter.clientId];
      } else if (vm.filter.project && vm.filter.project._id !== 'all') {
        var _projects = [vm.filter.project._id];
        query.projects = _projects;
        vm.filter.startDate = new Date(vm.filter.project.startDate);
        vm.filter.endDate = new Date(vm.filter.project.endDate);
      } else {
        var totalProjectIds = vm.projects.filter(function (x) {
          return x.projectStatus == 1 || x.projectStatus == 2 || x.isServiceProject == true;
        }).map(function (element) {
          return element._id;
        });
        query.projects = totalProjectIds;
      }

      if (vm.filter.startDate) {
        query.startDate = vm.filter.startDate;
      }

      if (vm.filter.endDate) {
        query.endDate = vm.filter.endDate;
      }

      Promise.all([apiFactory.getEconomicDashboardData(query), apiFactory.getEconomicDashboardTableData(query)]).then(function (resp) {
        vm.accidentCount = resp[0].data.cntAccident;
        vm.subcontractorHours = resp[0].data.subcontractorHrs;
        var issuesData = resp[0].data.cntIssues;
        vm.issuesCount.opened = issuesData.open;
        vm.issuesCount.resolved = issuesData.resolved;
        var reportsData = resp[0].data.cntReports;
        vm.reportsCount.opened = reportsData.open;
        vm.reportsCount.resolved = reportsData.resolved;
        vm.graphData = resp[0].data.graphData;
        vm.cashflowData = resp[0].data.cashflowData;
        vm.tableData = resp[1].data.tableData;
        $scope.isLoading = false;
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('clientManage', {
    controller: ClientManageController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/clientManage/clientManage.view.html'
  });
  /** @ngInject */

  function ClientManageController(globals, apiFactory, $scope, $rootScope, $log, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    $scope.needToUpdate = false;
    var onSelProject = $rootScope.$on('on-select-project-no-bookmark', function () {
      $scope.needToUpdate = true;
    });
    $rootScope.$on('$destroy', onSelProject);
    Promise.all([apiFactory.getCompanyById(vm.userData.companyId), storageFactory.listAllProjects()]).then(function (data) {
      /* Add companyData to store */
      companyStore.set(data[0].data);
      vm.dashboardData = {
        company: data[0].data,
        projects: data[1].data.list
      };

      if ($scope.needToUpdate) {
        if (vm.dashboardData && vm.dashboardData.projects.length > 0) {
          $scope.$root.$emit('on-select-project', vm.dashboardData.projects[0]);
        }
      }
    })["catch"](function (err) {
      $log.error(err);
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('ceoSpash', {
    controller: CeoSpashController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/ceoSpash/ceoSpash.view.html'
  });
  /** @ngInject */

  function CeoSpashController(globals, apiFactory, $scope) {
    $scope.filter1 = '1';
    $scope.filterList1 = [{
      _id: '1',
      tagName: "2021"
    }, {
      _id: '2',
      tagName: "2020"
    }, {
      _id: '3',
      tagName: "2019"
    }];
    $scope.filter2 = '1';
    $scope.filterList2 = [{
      _id: '1',
      tagName: "2021"
    }, {
      _id: '2',
      tagName: "2020"
    }, {
      _id: '3',
      tagName: "2019"
    }];
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('ceoEconomics', {
    controller: ceoEconomics,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/ceoEconomics/ceoEconomics.view.html'
  });
  /** @ngInject */

  function ceoEconomics(globals, apiFactory, $scope, $log, Notification, utils, NgMap, $rootScope, GMap) {
    var vm = this;
    var companyStore = globals.companyStore;
    vm.companyData = companyStore.get();
    var COLORS = ['#2FA84F', '#D71414', '#367BF5', '#58B9F5', '#88A1E6', '#FFA233', '#1AB2D3', '#FCE299', '#FF5701', '#A2C1EF', '#657786'];
    var BUILDING_ICONS = ['apartment.svg', 'hospital.svg', 'museum.svg'];
    $scope.economicData = [];
    $scope.totalExpense = 0;
    vm.costItems = [{
      label: "Revenue",
      amount: 0,
      items: [],
      isDetail: true
    }, {
      label: "Expense",
      amount: 0,
      items: [],
      isDetail: false
    }, {
      label: "EBITDA",
      amount: 0,
      items: [],
      isDetail: false
    }];
    var earthView = undefined;
    init();

    $scope.bgColor = function (n) {
      return {
        backgroundColor: COLORS[n % COLORS.length]
      };
    };

    $scope.countryIcon = function (n) {
      return "/assets/icons/".concat(BUILDING_ICONS[n % BUILDING_ICONS.length]);
    };

    $scope.currentYear = function () {
      return new Date().getYear() + 1900;
    };

    function init() {
      earthView = GMap.earthViewer("earth-view");
      apiFactory.getEconomicStatisticsAllCountries().then(function (resp) {
        var ecoData = resp.data.data;
        $scope.totalExpense = 0;
        $scope.countriesEconomicData = ecoData ? ecoData.countries : [];
        var totalBudget = ecoData.total.budget;
        var totalExpense = ecoData.total.expense;
        var totalRevenue = ecoData.total.revenue;
        var totalEbitda = totalBudget - totalExpense;
        ecoData.projects.forEach(function (project) {
          vm.costItems[0].items.push({
            name: project.projectName,
            price: project.revenue,
            percentage: totalRevenue === 0 ? 0 : project.revenue * 100 / totalRevenue
          });
          vm.costItems[1].items.push({
            name: project.projectName,
            price: project.expense,
            percentage: totalExpense === 0 ? 0 : project.expense * 100 / totalExpense
          });
          vm.costItems[2].items.push({
            name: project.projectName,
            price: project.budget - project.expense,
            percentage: totalEbitda === 0 ? 0 : (project.budget - project.expense) * 100 / totalEbitda
          });
        });
        $scope.totalExpense = totalExpense;
        vm.costItems[0].amount = totalRevenue;
        vm.costItems[1].amount = totalExpense;
        vm.costItems[2].amount = totalEbitda;
        $scope.countriesEconomicData.forEach(function (x) {
          x.expensePercentage = Math.round((x.expense + Number.EPSILON) / ($scope.totalExpense || 1) * 100);
        });
        makeGMapMarkers();
      })["catch"](function (err) {
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    function makeGMapMarkers() {
      var countries = $scope.countriesEconomicData.map(function (x) {
        return x.country;
      });
      Promise.all(countries.map(function (x) {
        return apiFactory.getCountryGeoData({
          country: x
        });
      })).then(function (res) {
        var geoList = res.map(function (x) {
          return x.data;
        });

        for (var i = 0; i < geoList.length; i++) {
          var geo = geoList[i];

          if (geo.status !== 'OK' || !geo.results || !geo.results.length || !geo.results[0].geometry || !geo.results[0].geometry.location) {
            continue;
          }

          var location = geo.results[0].geometry.location;
          var eco = $scope.countriesEconomicData[i];
          var index = earthView.markers.length;
          earthView.addMarker({
            latitude: location.lat,
            longitude: location.lng,
            name: eco.country,
            icon: $scope.countryIcon(0),
            color: COLORS[index % COLORS.length],
            zoom: 'small'
          });
        }
      })["catch"](function (err) {
        $log.error(err);
      });
      $scope.countriesEconomicData.forEach(function (item) {
        item.projects.forEach(function (project) {
          if (!project.address || !project.address.loc || !project.address.loc.coordinates || project.address.loc.coordinates.length !== 2) {
            return;
          }

          var index = earthView.markers.length;
          earthView.addMarker({
            latitude: project.address.loc.coordinates[0],
            longitude: project.address.loc.coordinates[1],
            name: item.country,
            icon: $scope.countryIcon(index),
            color: COLORS[index % COLORS.length],
            zoom: 'large'
          });
        });
      });
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('ceo', {
    controller: CeoController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/ceo/ceo.view.html'
  });
  /** @ngInject */

  function CeoController(globals, apiFactory, $scope, $rootScope, $log, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    vm.projectData = projectStore.get();
    $scope.needToUpdate = false;
    var onSelProject = $rootScope.$on('on-select-project-no-bookmark', function () {
      $scope.needToUpdate = true;
    });
    $rootScope.$on('$destroy', onSelProject);
    $scope.issueData = [{
      id: "Resolved",
      value: 0,
      count: 0,
      color: "#FF8B00"
    }, {
      id: "Un-resolved",
      value: 0,
      count: 0,
      color: "#FFB966"
    }, {
      id: "In-Progress",
      value: 0,
      count: 0,
      color: "#FFD199"
    }, {
      id: "Zero",
      value: Number.EPSILON,
      count: 0,
      color: "#FDE9B3"
    }];
    $scope.vaOrderData = [{
      id: "Approved",
      value: 0,
      count: 0,
      color: "#FF8B00"
    }, {
      id: "Pending",
      value: 0,
      count: 0,
      color: "#FFB966"
    }, {
      id: "Zero",
      value: Number.EPSILON,
      count: 0,
      color: "#FDE9B3"
    }];
    $scope.economicData = [{
      id: "Paid",
      value: 0,
      count: 0,
      color: "#FF8B00"
    }, {
      id: "Rest",
      value: 0,
      count: 0,
      color: "#FFB966"
    }, {
      id: "Zero",
      value: Number.EPSILON,
      count: 0,
      color: "#FDE9B3"
    }];
    $scope.curPage = "overview";
    $scope.isShowIssue = true;
    $scope.isShowVAOrder = true;
    $scope.isShowEconomic = true;
    Promise.all([apiFactory.getCompanyById(vm.userData.companyId), storageFactory.listAllProjects(), apiFactory.getIssueStatistics(vm.projectData._id), apiFactory.getVariationOrderStatistics(vm.projectData._id), apiFactory.getEconomicStatistics()]).then(function (data) {
      /* Add companyData to store */
      companyStore.set(data[0].data);
      vm.dashboardData = {
        company: data[0].data,
        projects: data[1].data.list
      };

      if ($scope.needToUpdate) {
        if (vm.dashboardData && vm.dashboardData.projects.length > 0) {
          $scope.$root.$emit('on-select-project', vm.dashboardData.projects[0]);
        }
      }

      var issueStatistics = data[2].data;
      var issueTotal = issueStatistics.inProgress + issueStatistics.unResolved + issueStatistics.resolved;
      $scope.issueData[0].value = issueStatistics.resolved / (issueTotal || 1) * 100;
      $scope.issueData[0].count = issueStatistics.resolved;
      $scope.issueData[1].value = issueStatistics.unResolved / (issueTotal || 1) * 100;
      $scope.issueData[1].count = issueStatistics.unResolved;
      $scope.issueData[2].value = issueStatistics.inProgress / (issueTotal || 1) * 100;
      $scope.issueData[2].count = issueStatistics.inProgress;
      var variationOrderStatistics = data[3].data;
      var vaOrderTotal = variationOrderStatistics.approved + variationOrderStatistics.pending;
      $scope.vaOrderData[0].count = variationOrderStatistics.approved;
      $scope.vaOrderData[0].value = variationOrderStatistics.approved / (vaOrderTotal || 1) * 100;
      $scope.vaOrderData[1].count = variationOrderStatistics.pending;
      $scope.vaOrderData[1].value = variationOrderStatistics.pending / (vaOrderTotal || 1) * 100;
      var economicStatistics = data[4].data;
      $scope.economicData[0].count = economicStatistics.paid;
      $scope.economicData[0].value = economicStatistics.paid / (economicStatistics.contract || 1) * 100;
      $scope.economicData[1].count = economicStatistics.rest;
      $scope.economicData[1].value = economicStatistics.rest / (economicStatistics.contract || 1) * 100;
    })["catch"](function (err) {
      $log.error(err);
    });

    $scope.getProgressStyle = function (type, index) {
      if (type === "issue") {
        return {
          width: "".concat($scope.issueData[index].value, "%")
        };
      } else if (type === "va-order") {
        return {
          width: "".concat($scope.vaOrderData[index].value, "%")
        };
      } else {
        return {
          width: "".concat($scope.economicData[index].value, "%")
        };
      }
    };

    $scope.selectPage = function (page) {
      $scope.curPage = page;
    };

    $scope.currentMenu = "finance";

    $scope.setCurrentMenu = function (menu) {
      $scope.currentMenu = menu;
    };

    $scope.showReport = function () {
      $scope.currentMenu = 'report';
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('bidManage', {
    controller: BidManageController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/bidManage/bidManage.view.html'
  });
  /** @ngInject */

  function BidManageController(globals, apiFactory, $scope, $state, $rootScope, $log, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    vm.dashboardData = {};
    var onSelProject = $rootScope.$on('on-select-project-no-bookmark', function () {
      if (vm.dashboardData && vm.dashboardData.projects.length > 0) $scope.$root.$emit('on-select-project', vm.dashboardData.projects[0]);
    });
    $rootScope.$on('$destroy', onSelProject);
    Promise.all([apiFactory.getCompanyById(vm.userData.companyId), storageFactory.listAllProjects()]).then(function (data) {
      /* Add companyData to store */
      companyStore.set(data[0].data);
      vm.dashboardData = {
        company: data[0].data,
        projects: data[1].data.list
      };
    })["catch"](function (err) {
      $log.error(err);
    });
  }
})();


"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('auditManage', {
    controller: AuditManageController,
    controllerAs: 'vm',
    templateUrl: 'app/main/dashboard/auditManage/auditManage.view.html'
  });
  /** @ngInject */

  function AuditManageController($scope, $log, globals, apiFactory, ecoFactory, Notification, utils, $filter, storageFactory) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.company = companyStore.get(); // $scope.PROJECT_ACCESS_CREATE = 0;
    // $scope.NOTE_ACCESS_CREATE = 0;
    // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.NOTE_ACCESS_CREATE = 4;
    // } else {
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.PROJECT, Constants.AccessKey.NOTE]})
    //     .then(res => {
    //       $scope.NOTE_ACCESS_CREATE = res.data.data[Constants.AccessKey.NOTE];
    //     })
    //     .catch((e) => {
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    var today = new Date();
    var thisYear = today.getFullYear();
    vm.audit = {
      projectId: "all",
      startDate: new Date(thisYear, 0, 1),
      endDate: new Date(thisYear, 11, 31, 23, 59, 59, 999),
      duration: 0,
      regulation: {
        labor: {
          amount: 0,
          percent: 0
        },
        inventory: {
          amount: 0,
          percent: 0
        },
        invoiced: {
          amount: 0,
          percent: 0
        },
        profit: {
          amount: 0,
          percent: 0
        }
      },
      manager: vm.userData
    };
    vm.profilePic = vm.userData.profilePic;
    vm.firstName = vm.userData.firstName;
    vm.project = {
      _id: "all",
      projectName: "All Project"
    };
    vm.isAllProject = true;
    vm.isAudit = false;
    vm.selProjects = [];
    vm.cashflowData = undefined;
    vm.costData = undefined;
    vm.chartData = undefined;
    vm.auditCash = undefined;
    vm.projectData = undefined;
    vm.invoices = [];
    vm.payrolls = [];
    vm.bills = [];
    vm.companyBills = undefined;
    vm.projects = [];
    vm.tasks = [];
    var materials = [];
    var equipments = [];
    vm.allProjects = [];
    vm.ongoingProjects = [];
    vm.completedProjects = [];
    vm.serviceProjects = [];
    vm.projectTypeOptioins = [{
      label: 'All Projects',
      value: 'all'
    }, {
      label: 'Ongoing Projects',
      value: 'ongoing'
    }, {
      label: 'Completed Projects',
      value: 'completed'
    }, {
      label: 'Service Projects',
      value: 'service'
    }];
    vm.projectType = 'all';
    vm.projectFilter = [];
    vm.filterSelection = ['ongoing', 'completed', 'service'];
    vm.bShowFilter = false;
    $scope.isLoading = true;
    Promise.all([apiFactory.getCompanyById(vm.userData.companyId), storageFactory.listAllProjects(), apiFactory.listAllMaterials(), apiFactory.listAllEquipments()]).then(function (resp) {
      companyStore.set(resp[0].data);
      vm.company = resp[0].data;
      vm.projects = resp[1].data.list;
      materials = resp[2].data.list;
      equipments = resp[3].data.list;
      globals.getCurrency().then(function (resp) {
        var getCurrencyCode = resp.data;
        vm.companyCurrency = getCurrencyCode.find(function (element) {
          return element.cc === vm.company.currentCurrency.currencyCode;
        });
      });
      $scope.isLoading = false;
      var projects = [{
        _id: 'all',
        projectName: $filter('translate')("All Projects")
      } // {_id: 'ongoing', projectName: $filter('translate')("All Ongoings")},
      // {_id: 'completed', projectName: $filter('translate')("All Completed")},
      // {_id: 'service', projectName: $filter('translate')("All Service")},
      ];
      vm.projects.forEach(function (project) {
        if (project.managers) {
          project.managers.forEach(function (manager) {
            return manager.displayName = manager.userId ? manager.userId.displayName : 'Manager';
          });
        }

        project.startDate = new Date(project.startDate);
        project.endDate = new Date(project.endDate);
        project.endDate.setHours(23, 59, 59, 0);
        var type = '';

        if (project.projectStatus == 1) {
          type = 'Ongoing';
          vm.ongoingProjects.push(project);
        } else if (project.projectStatus == 2) {
          type = 'Completed';
          vm.completedProjects.push(project);
        } else if (project.isServiceProject) {
          type = 'Service';
          vm.serviceProjects.push(project);
        }

        project.projectName = project.projectName + ' (' + type + ')'; // projects.push(project);
      });
      vm.allProjects = vm.allProjects.concat(vm.ongoingProjects, vm.completedProjects, vm.serviceProjects);
      projects = projects.concat(vm.ongoingProjects, vm.completedProjects, vm.serviceProjects);
      vm.selProjects = projects;
      var curProject = projectStore.get();
      var filterProject = curProject ? vm.selProjects.find(function (x) {
        return x._id === curProject._id;
      }) : undefined;

      if (filterProject) {
        vm.project = filterProject;
        vm.audit.projectId = vm.project._id;
        vm.isAllProject = false;
      }

      vm.filterProjectList = vm.allProjects;

      if (vm.isAllProject) {
        loadDataWithAll();
      } else {
        vm.selectProject(vm.project._id);
      }
    })["catch"](function (err) {
      $log.error(err);
      $scope.isLoading = false;
    });

    vm.onShowFilter = function () {
      vm.bShowFilter = !this.bShowFilter;
      vm.tempFilter = _toConsumableArray(vm.filterSelection);
      vm.tempProjectFilter = _toConsumableArray(vm.projectFilter);
    };

    vm.selectProjectType = function (type) {
      $log.log(type);

      if (type == 'all') {
        // if(vm.tempFilter.length == 3) {
        //   vm.tempFilter = [];
        // } else {
        vm.tempFilter = ['ongoing', 'completed', 'service'];
        vm.filterProjectList = vm.allProjects; // }
      } else if (type == 'ongoing') {
        // var idx = vm.tempFilter.indexOf('ongoing');
        // if(idx > -1) {
        //   vm.tempFilter.splice(idx, 1);
        // } else {
        //   vm.tempFilter.push('ongoing');
        // }
        vm.tempFilter = ['ongoing'];
        vm.filterProjectList = vm.ongoingProjects;
      } else if (type == 'completed') {
        // idx = vm.tempFilter.indexOf('completed');
        // if(idx > -1) {
        //   vm.tempFilter.splice(idx, 1);
        // } else {
        //   vm.tempFilter.push('completed');
        // }
        vm.tempFilter = ['completed'];
        vm.filterProjectList = vm.completedProjects;
      } else if (type == 'service') {
        // idx = vm.tempFilter.indexOf('service');
        // if(idx > -1) {
        //   vm.tempFilter.splice(idx, 1);
        // } else {
        //   vm.tempFilter.push('service');
        // }
        vm.tempFilter = ['service'];
        vm.filterProjectList = vm.serviceProjects;
      }
    };

    vm.checkProject = function (projectId) {
      $log.log(projectId);
      var idx = vm.tempProjectFilter.indexOf(projectId);

      if (idx > -1) {
        vm.tempProjectFilter.splice(idx, 1);
      } else {
        vm.tempProjectFilter.push(projectId);
      }
    };

    vm.filterSelectAll = function () {
      vm.tempProjectFilter = vm.filterProjectList.map(function (project) {
        return project._id;
      });
    };

    vm.filterClearAll = function () {
      vm.tempProjectFilter = [];
    };

    vm.onFilterOk = function () {
      vm.filterSelection = _toConsumableArray(vm.tempFilter);
      vm.projectFilter = _toConsumableArray(vm.tempProjectFilter);
      vm.projects = []; // vm.filterSelection.forEach(selection => {
      //   if(selection == 'ongoing') {
      //     vm.projects = vm.projects.concat(vm.ongoingProjects);
      //   } else if(selection == 'completed') {
      //     vm.projects = vm.projects.concat(vm.completedProjects);
      //   } else if(selection == 'service') {
      //     vm.projects = vm.projects.concat(vm.serviceProjects);
      //   }
      // })

      vm.projects = vm.allProjects.filter(function (project) {
        return vm.projectFilter.indexOf(project._id) > -1;
      });
      vm.selProjects = [{
        _id: "all",
        projectName: "All Project"
      }];
      vm.selProjects = vm.selProjects.concat(vm.projects);
      vm.audit.projectId = 'all';
      vm.isAllProject = true;
      vm.selProjects.forEach(function (project) {
        if (project._id != 'all') {
          var tmpDate = new Date(project.startDate);

          if (vm.audit.startDate > tmpDate) {
            vm.audit.startDate = tmpDate;
          }

          tmpDate = new Date(project.endDate);

          if (vm.audit.endDate < tmpDate) {
            vm.audit.endDate = tmpDate;
          }
        }
      });
      $log.log('list of projects = ', vm.selProjects);
      vm.bShowFilter = false;
      loadDataWithAll();
    };

    vm.onFilterCancel = function () {
      vm.tempFilter = [];
      vm.tempProjectFilter = [];
      vm.bShowFilter = false;
    };

    vm.selectProject = function (projectId) {
      $log.log('project id = ', projectId); // if (vm.isAllProject) {
      //   if (projectId && projectId !== 'all') {
      //     vm.isAllProject = false;
      //   }
      // } else {

      if (projectId === 'all') {
        vm.isAllProject = true;
        loadDataWithAll('all');
        return;
      } else if (projectId === 'ongoing') {
        vm.isAllProject = true;
        loadDataWithAll('ongoing');
        return;
      } else if (projectId === 'completed') {
        vm.isAllProject = true;
        loadDataWithAll('completed');
        return;
      } else if (projectId === 'service') {
        vm.isAllProject = true;
        loadDataWithAll('service');
        return;
      } else {
        vm.isAllProject = false;
      } // }


      vm.companyBills = undefined;
      vm.chartData = undefined;
      vm.project = vm.projects.find(function (project) {
        return project._id === projectId;
      });
      if (!vm.project) return;
      vm.isAudit = vm.project.isAudit;

      if (vm.isAudit) {
        if (vm.project.audit) {
          vm.audit.startDate = new Date(vm.project.audit.startDate);
          vm.audit.endDate = new Date(vm.project.audit.endDate);
          vm.audit.duration = vm.project.audit.duration;
          vm.audit.regulation = angular.copy(vm.project.audit.regulation);
        } else {
          vm.audit.startDate = new Date(vm.project.startDate);
          vm.audit.endDate = new Date();
        }
      } else {
        vm.audit.startDate = vm.project.auditOpenAt ? new Date(vm.project.auditOpenAt) : new Date(vm.project.startDate);
        vm.audit.endDate = new Date();
      }

      $scope.isLoading = true;
      Promise.all([apiFactory.getEconomicDashboardData({
        projects: [projectId]
      }), apiFactory.listAllBillings({
        projectBill: true
      }), apiFactory.listAllBillings({
        companyBill: true
      }), apiFactory.listAllBillings({
        isMemo: true
      }), apiFactory.listAllPayrolls(vm.project && vm.project._id !== "all" ? {
        projects: [vm.project._id]
      } : {}), apiFactory.listAllInvoices(vm.project && vm.project._id !== "all" ? {
        projects: vm.project._id
      } : {}), apiFactory.queryTasks()]).then(function (resp) {
        $scope.isLoading = false;
        vm.cashflowData = resp[0].data.cashflowData;
        var billings = resp[1].data.list;
        var companyBillings = resp[2].data.list;
        var creditBillings = resp[3].data.list;
        var payrolls = resp[4].data.list;
        var invoices = resp[5].data.list;
        var tasks = resp[6].data.tasks;
        billings.forEach(function (bill) {
          bill.balance = getBillBalance(bill);
        });
        companyBillings.forEach(function (bill) {
          bill.balance = getBillBalance(bill);
        });
        creditBillings.forEach(function (bill) {
          bill.balance = getBillBalance(bill);
        });
        payrolls.forEach(function (payroll) {
          payroll.workedSalary = ecoFactory.getPayrollWorkedSalary(payroll);
        });
        var project = vm.project;
        vm.costData = {
          project: project,
          payrolls: payrolls,
          billings: billings
        };
        vm.chartData = {
          projects: [project],
          invoices: invoices,
          billings: billings,
          payrolls: payrolls,
          tasks: tasks,
          materials: materials,
          equipments: equipments,
          companyCost: vm.company.companyCost,
          regulation: vm.audit.regulation
        };
        vm.invoices = invoices;
        vm.payrolls = payrolls;
        vm.bills = billings;

        if (!vm.isAllProject) {
          vm.bills = billings.filter(function (x) {
            return x.projectId._id == vm.project._id;
          });
        }

        vm.companyBills = companyBillings;
        vm.creditMemoBills = creditBillings;
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    vm.publish = function () {
      if (vm.isAllProject) {
        $scope.isLoading = true;
        var projects = [];
        vm.projects.forEach(function (project) {
          if (!project.isAudit) {
            projects.push({
              projectId: project._id,
              startDate: project.auditOpenAt ? new Date(project.auditOpenAt) : new Date(project.startDate),
              endDate: vm.audit.endDate,
              remainAmount: calcRemainAmount(project)
            });
          }
        });

        if (projects.length > 0) {
          apiFactory.createAudits(projects).then(function () {
            Notification.success('Audits published successfully.');
            $scope.isLoading = false;
            vm.projects.forEach(function (project) {
              return project.isAudit = true;
            });
            vm.isAudit = true;
          })["catch"](function (err) {
            $log.error(err);
            Notification.error('Failed to publish.');
            $scope.isLoading = false;
          });
        } else {
          Notification.success('All audits is published already.');
        }
      } else {
        $scope.isLoading = true;
        vm.audit.remainAmount = calcRemainAmount(vm.project);
        apiFactory.createAudit(vm.audit).then(function (resp) {
          Notification.success('Audit published successfully.');
          $scope.isLoading = false;
          vm.project.isAudit = true;
          vm.isAudit = true;
          vm.project.audit = resp.data.data;
        })["catch"](function (err) {
          $log.error(err);
          Notification.error('Failed to publish.');
          $scope.isLoading = false;
        });
      }
    };

    vm.reopen = function () {
      $scope.isLoading = true;

      if (vm.isAllProject) {
        var projectIds = vm.projects.map(function (x) {
          return x._id;
        });
        apiFactory.reopenAudit({
          projects: projectIds
        }).then(function () {
          Notification.success('Audits is reopen successfully.');
          $scope.isLoading = false;
          vm.projects.forEach(function (project) {
            project.isAudit = false;
            project.auditOpenAt = new Date();
          });
          vm.isAudit = false;
        })["catch"](function (err) {
          $log.error(err);
          Notification.error('Failed to reopen.');
          $scope.isLoading = false;
        });
      } else {
        apiFactory.reopenAudit({
          projectId: vm.audit.projectId
        }).then(function () {
          Notification.success('Audits is reopen successfully.');
          $scope.isLoading = false;
          vm.project.isAudit = false;
          vm.project.auditOpenAt = new Date();
          vm.audit.startDate = vm.project.auditOpenAt;
          vm.isAudit = false;
        })["catch"](function (err) {
          $log.error(err);
          Notification.error('Failed to reopen.');
          $scope.isLoading = false;
        });
      }
    };

    function loadDataWithAll() {
      var projectIds = [];
      projectIds = vm.projects.map(function (x) {
        return x._id;
      });
      $log.log('project ids = ', projectIds);
      var isAudit = false;

      if (vm.projects.length > 0) {
        isAudit = true;

        for (var i = 0; i < vm.projects.length; i++) {
          if (!vm.projects[i].isAudit) {
            isAudit = false;
            break;
          }
        }
      }

      vm.isAudit = isAudit;
      vm.chartData = undefined;
      vm.projectData = undefined;
      $scope.isLoading = true;
      Promise.all([apiFactory.getEconomicDashboardData({
        projects: projectIds
      }), apiFactory.getFinanceDashboardData({
        projects: projectIds
      }), apiFactory.queryBillings({
        projectBill: true,
        projects: projectIds
      }), apiFactory.queryBillings({
        companyBill: true,
        projects: projectIds
      }), apiFactory.queryBillings({
        isMemo: true,
        projects: projectIds
      }), apiFactory.listAllPayrolls(vm.project && vm.project._id !== "all" ? {
        projects: [vm.project._id]
      } : {
        projects: projectIds
      }), apiFactory.queryInvoices(vm.project && vm.project._id !== "all" ? {
        projects: [vm.project._id]
      } : {
        projects: projectIds
      }), apiFactory.queryTasks(), apiFactory.listAllVariationOrders({
        projectId: vm.project._id
      })]).then(function (resp) {
        $scope.isLoading = false;
        var billings = resp[2].data.list;
        var invoices = resp[5].data.list;
        var payrolls = resp[4].data.list;
        var tasks = resp[7].data.list;
        var vaOrders = resp[8].data.list;
        vm.cashflowData = resp[0].data.cashflowData;
        var companyBills = resp[1].data.list || [];
        var creditMemoBills = resp[2].data.list || [];
        vm.totalValues = resp[1].data.total;
        vm.cashGraphData = resp[1].data.graphData;
        billings.forEach(function (bill) {
          bill.balance = getBillBalance(bill);
        });
        companyBills.forEach(function (bill) {
          bill.balance = getBillBalance(bill);
        });
        creditMemoBills.forEach(function (bill) {
          bill.balance = getBillBalance(bill);
        });
        payrolls.forEach(function (payroll) {
          payroll.workedSalary = ecoFactory.getPayrollWorkedSalary(payroll);
        });
        vm.auditCash = {
          projects: vm.projects,
          invoices: invoices,
          billings: billings,
          payrolls: payrolls,
          companyCost: vm.company.companyCost
        };
        vm.chartData = {
          projects: vm.projects,
          invoices: invoices,
          billings: billings,
          payrolls: payrolls,
          tasks: tasks,
          materials: materials,
          equipments: equipments,
          companyCost: vm.company.companyCost
        };
        vm.projectData = {
          projects: vm.projects,
          invoices: invoices,
          billings: billings,
          payrolls: payrolls,
          vaOrders: vaOrders
        };
        vm.invoices = invoices;
        vm.payrolls = payrolls;
        vm.bills = billings;

        if (!vm.isAllProject) {
          vm.bills = billings.filter(function (x) {
            return x.projectId._id == vm.project._id;
          });
        }

        vm.companyBills = companyBills;
        vm.creditMemoBills = creditMemoBills;
        $scope.$apply();
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }

    function calcRemainAmount(project) {
      var invoiceTotal = 0;
      var payrollTotal = 0;
      var billTotal = 0;
      vm.invoices.forEach(function (invoice) {
        if (invoice.projectId === project._id && invoice.status !== 'rejected') {
          invoiceTotal += utils.num(invoice.totalAmount);
        }
      });
      vm.payrolls.forEach(function (payroll) {
        if (payroll.projectId === project._id) {
          payrollTotal += payroll.workedSalary;
        }
      });
      vm.bills.forEach(function (bill) {
        if (bill.projectId === project._id && bill.status !== 'rejected') {
          billTotal += utils.num(bill.totalAmount);
        }
      });
      return invoiceTotal - billTotal - payrollTotal;
    }

    function getBillBalance(bill) {
      var amount = utils.num(bill.remainingAmount);
      if (amount === 0) return amount;

      if (bill.vendor && bill.vendor.paymentTerms) {
        var vatPercent = utils.num(bill.vendor.paymentTerms.vatPercent);
        amount = amount / (1 + vatPercent / 100);
        amount = Math.max(0, amount);
      }

      return amount;
    }
  }
})();


"use strict";

/* eslint-disable no-unused-vars */
(function () {
  'use strict';

  angular.module('app').component('controlPlanGrid', {
    controller: controlPlanGridController,
    controllerAs: 'vm',
    templateUrl: 'app/main/controlPlan/controlPlanGrid/controlPlanGrid.view.html'
  });
  /** @ngInject */

  function controlPlanGridController($scope, apiFactory, $state, globals, $log, Notification) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.CPLAN_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.CPLAN_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.CPLAN]})
    //     .then(res => {
    //     $scope.isLoading = false;
    //       $scope.CPLAN_ACCESS_CREATE = res.data.data[Constants.AccessKey.CPLAN];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.controlPlans = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 20; // globals.numPerPage();

    $scope.noOfPages = 0;
    vm.currentPage = 1;
    vm.searchText = undefined;
    vm.sortMenuList = [{
      label: 'Created Date',
      key: 'createdAt'
    }, {
      label: 'Modified Date',
      key: 'updatedAt'
    }, {
      label: 'Control plan Tag',
      key: 'systemTag'
    }];
    vm.sortMenu = "createdAt";
    $scope.periods = [{
      id: '20',
      name: '20'
    }, {
      id: '40',
      name: '40'
    }, {
      id: '60',
      name: '60'
    }];
    $scope.isLoading = false;

    vm.fetchAllControlPlans = function () {
      $scope.isLoading = true;
      apiFactory.getControlPlans({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        sort: vm.sortMenu,
        sortType: "false"
      }).then(function (data) {
        $scope.isLoading = false;
        $scope.controlPlans = data.data.list;
        $scope.totalCount = data.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      });
    };

    vm.fetchAllControlPlans();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchAllControlPlans();
    };

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.fetchAllControlPlans();
    };

    $scope.goToDetail = function (controlPlanId) {
      $state.go('controlPlanEdit', {
        id: controlPlanId
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('controlPlanEdit', {
    controller: controlPlanEditController,
    controllerAs: 'vm',
    templateUrl: 'app/main/controlPlan/controlPlanEdit/controlPlanEdit.view.html'
  });
  /** @ngInject */

  function controlPlanEditController($scope, $state, $stateParams, apiFactory, Notification, globals) {
    /* Requiring vars */
    var vm = this;
    vm.userData = globals.userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.responsibleUsers = [];
    $scope.addState = false;

    $scope.ControlMethod = function (event, index, outerIndex) {
      var find = $scope.controlMethods.find(function (x) {
        return x._id == event.target.id;
      });
      if (find) vm.Plan.plan[outerIndex].groupItems[index].controlMethod = find._id;
    };

    vm.planId = $stateParams.id;

    $scope.getAllControlMethodTypes = function () {
      apiFactory.getAllControlMethodTypes().then(function (resp) {
        $scope.controlMethods = resp.data.list.map(function (item) {
          return {
            _id: item.tagName,
            code: item.tagName
          };
        });
        $scope.getPlanDetails();
      })["catch"](function (error) {
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in get control methods');
        $scope.isLoading = false;
      });
    };

    $scope.getAllControlMethodTypes();

    $scope.getPlanDetails = function () {
      $scope.isLoading = true;
      apiFactory.getcontrolPlanById(vm.planId).then(function (resp) {
        $scope.isLoading = false;
        vm.Plan = resp.data; // console.log('PLAN: ', vm.Plan)

        vm.tablePlan = vm.Plan.plan;
        $scope.responsibleUsers = vm.Plan.responsibleUsers; // console.log('usrt: ', $scope.responsibleUsers)

        vm.Plan.plan.map(function (plan) {
          plan.groupItems.map(function (item) {
            item.frequency = Number(item.frequency);
          });
        });
      });
    };

    vm.updateControlPlan = function (tableplan) {
      // console.log('resp users are: ', $scope.responsibleUsers)
      // console.log('tableplan is:', tableplan)
      var planObj = {
        plan: tableplan,
        responsibleUsers: $scope.responsibleUsers
      };
      $scope.isLoading = true;
      apiFactory.updateProjectPlan(planObj, vm.planId).then(function () {
        $scope.isLoading = false;
        Notification.success('project plan updated successfully.');
        $state.go('controlPlanGrid');
      })["catch"](function () {
        $scope.isLoading = false;
        Notification.error("Couldn't update plan");
      });
    };

    $scope.addRow = function (index) {
      vm.tablePlan[index].groupItems.push({
        controlOf: '',
        controlMethod: '',
        controlScope: '',
        frequency: 0,
        accept: '',
        documentation: '',
        responsibility: '',
        comments: ''
      });
    };

    $scope.removeRow = function (eleindex, array) {
      array.splice(eleindex, 1);
      array.map(function (element, index) {
        var mapp = element.index.split('.');
        var valTo = mapp[0];

        if (index >= eleindex) {
          var newIn = mapp[1] - 1;
          element.index = valTo + '.' + newIn;
        }
      });
    };

    $scope.addGroup = function () {
      vm.tablePlan.push({
        groupName: 'Group',
        groupItems: [{
          controlOf: '',
          controlMethod: '',
          controlScope: '',
          frequency: 0,
          accept: '',
          documentation: '',
          responsibility: '',
          comments: ''
        }, {
          controlOf: '',
          controlMethod: '',
          controlScope: '',
          frequency: 0,
          accept: '',
          documentation: '',
          responsibility: '',
          comments: ''
        }],
        isEdit: false,
        isnameChanged: 0
      });
    };

    $scope.editGroupName = function (plan) {
      plan.isEdit = true;
    };

    $scope.changeGroupName = function (plan) {
      plan.isEdit = false;
      plan.isnameChanged = 1;
    };

    $scope.getResponsibleUser = function (users) {
      users.map(function (user) {
        $scope.responsibleUsers.push(user.firstName + ' ' + user.lastName);
      });
    };

    $scope.$on('dragToReorder.dropped', function (evt, data) {
      var changedIndex = data.list[data.newIndex].index;
      var changedWithIndex = data.list[data.prevIndex].index;
      data.list[data.newIndex].index = changedWithIndex;
      data.list[data.prevIndex].index = changedIndex;
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('controlPlanAdd', {
    controller: controlPlanAddController,
    controllerAs: 'vm',
    templateUrl: 'app/main/controlPlan/controlPlanAdd/controlPlanAdd.view.html'
  });
  /** @ngInject */

  function controlPlanAddController($scope, apiFactory, Notification, $state, globals) {
    var vm = this;
    vm.userData = globals.userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.controlMethods = [{
      _id: 'Text',
      code: 'Text'
    }, {
      _id: 'Site Doc',
      code: 'Site Doc'
    }, {
      _id: 'Process Check',
      code: 'Process Check'
    }];
    $scope.responsibleUsers = [];
    $scope.addState = false;
    vm.tablePlan = [{
      groupName: 'Group_1',
      groupItems: [{
        controlOf: '',
        controlMethod: '',
        controlScope: '',
        frequency: 0,
        accept: '',
        documentation: '',
        responsibility: '',
        comments: ''
      }, {
        controlOf: '',
        controlMethod: '',
        controlScope: '',
        frequency: 0,
        accept: '',
        documentation: '',
        responsibility: '',
        comments: ''
      }],
      isEdit: false,
      isnameChanged: 0
    }, {
      groupName: 'Group_2',
      groupItems: [{
        controlOf: '',
        controlMethod: '',
        controlScope: '',
        frequency: 0,
        accept: '',
        documentation: '',
        responsibility: '',
        comments: ''
      }, {
        controlOf: '',
        controlMethod: '',
        controlScope: '',
        frequency: 0,
        accept: '',
        documentation: '',
        responsibility: '',
        comments: ''
      }],
      isEdit: false,
      isnameChanged: 0
    }];

    $scope.getAllControlMethodTypes = function () {
      apiFactory.getAllControlMethodTypes().then(function (resp) {
        $scope.controlMethods = resp.data.list.map(function (item) {
          return {
            _id: item.tagName,
            code: item.tagName
          };
        });
      })["catch"](function (error) {
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('Failed in get control methods');
        $scope.isLoading = false;
      });
    };

    $scope.getAllControlMethodTypes();

    $scope.ControlMethod = function (event, index, outerIndex) {
      var find = $scope.controlMethods.find(function (x) {
        return x._id == event.target.id;
      });
      if (find) vm.tablePlan[outerIndex].groupItems[index].controlMethod = find._id;
    };

    vm.saveControlPlan = function (tableplan) {
      // console.log('tableplan here is: ', tableplan)
      // console.log('resp users are: ', $scope.responsibleUsers)
      // console.log('tableplan is:', tableplan)
      var planObj = {
        projectId: vm.projectId,
        plan: tableplan,
        responsibleUsers: $scope.responsibleUsers
      }; //api

      apiFactory.saveProjectPlan(planObj).then(function () {
        // console.log(resp)
        Notification.success('project plan save successfully.'); // vm.getControlPlan("created");

        $scope.addState = false;
        $state.go("controlPlanGrid");
      });
    };

    $scope.addRow = function (index) {
      vm.tablePlan[index].groupItems.push({
        controlOf: '',
        controlMethod: '',
        controlScope: '',
        frequency: 0,
        accept: '',
        documentation: '',
        responsibility: '',
        comments: ''
      });
    };

    $scope.removeRow = function (eleindex, array) {
      array.splice(eleindex, 1);
      array.map(function (element, index) {
        var mapp = element.index.split('.');
        var valTo = mapp[0];

        if (index >= eleindex) {
          var newIn = mapp[1] - 1;
          element.index = valTo + '.' + newIn;
        }
      });
    };

    $scope.addGroup = function () {
      vm.tablePlan.push({
        groupName: 'Group',
        groupItems: [{
          controlOf: '',
          controlMethod: '',
          controlScope: '',
          frequency: 0,
          accept: '',
          documentation: '',
          responsibility: '',
          comments: ''
        }, {
          controlOf: '',
          controlMethod: '',
          controlScope: '',
          frequency: 0,
          accept: '',
          documentation: '',
          responsibility: '',
          comments: ''
        }],
        isEdit: false,
        isnameChanged: 0
      });
    };

    $scope.editGroupName = function (plan) {
      plan.isEdit = true;
    };

    $scope.changeGroupName = function (plan) {
      plan.isEdit = false;
      plan.isnameChanged = 1;
    };

    $scope.getResponsibleUser = function (users) {
      users.map(function (user) {
        $scope.responsibleUsers.push(user.firstName + ' ' + user.lastName);
      });
    };

    $scope.$on('dragToReorder.dropped', function (evt, data) {
      var changedIndex = data.list[data.newIndex].index;
      var changedWithIndex = data.list[data.prevIndex].index;
      data.list[data.newIndex].index = changedWithIndex;
      data.list[data.prevIndex].index = changedIndex;
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('submitOffers', {
    controller: SubmitOffersController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/submitOffers/submitOffers.view.html'
  });
  /** @ngInject */

  function SubmitOffersController($scope, $uibModal, $state, globals, apiFactory, $log, Notification, utils, localStorageService, $filter) {
    var vm = this;
    $scope.utils = utils;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.designationFilter = "Client,Supplier,Subcontractor,Manager,Admin";
    vm.statusFilter = "Accepted,On Hold,Pending,Not Received";
    vm.dateFilter = undefined;
    vm.projectData = projectStore.get();
    $scope.TEAM_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.TEAM_ACCESS_CREATE = 4;
    // } else {
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.TEAM]})
    //     .then(res => {
    //       $scope.TEAM_ACCESS_CREATE = res.data.data[Constants.AccessKey.TEAM];
    //     })
    //     .catch((e) => {
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.userRole = vm.userData.designation == "Admin" ? 1 : 0;
    if ($scope.userRole == 1 && localStorageService.get('collaboratorType') == 1) $scope.userRole = 2;else if ($scope.userRole == 1 && localStorageService.get('collaboratorType') == 2) $scope.userRole = 3;
    $scope.selectedProject = "all";
    $scope.selSupplier = "all";
    vm.currentPage = 1;
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 1;
    $scope.totalCount = 10;
    vm.bidPackages = [];

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.getOfferDays = function (offer) {
      var days = 0;
      offer.levels.forEach(function (lv) {
        days += parseInt(lv.days);
      });
      return days;
    };

    $scope.deleteBidPackage = function (bidPackage) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        apiFactory.deleteBidPackage(bidPackage._id).then(function () {
          Notification.success("".concat(bidPackage.title, " removed successfully."));
          $scope.fetchData();
        })["catch"](function (err) {
          $log.error(err);
          Notification.error("Failed to remove!");
        });
      }, function () {});
    };

    $scope.selectAllBidPackages = function () {
      vm.bidPackages.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectBidPackage = function (bidPackage) {
      if (!bidPackage.selected) {
        $scope.selectedAll = false;
      }

      if (vm.bidPackages.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.bidPackages.length) {
        $scope.selectedAll = true;
      }
    };

    $scope.workTypes = function (workTypes) {
      return workTypes.map(function (x) {
        return x.tagName;
      }).join(", ");
    };

    $scope.searchBidPackages = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      $scope.loading = true;
      apiFactory.getCollaborationOffers({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        designationFilter: vm.designationFilter,
        statusFilter: vm.statusFilter,
        dateFilter: vm.dateFilter
      }).then(function (res) {
        $scope.loading = false;
        vm.bidPackages = res.data.list;
        $scope.totalCount = res.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchWorkTypes = function () {
      apiFactory.getWorkTypes().then(function (res) {
        $scope.loading = false;
        vm.workTypes = res.data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.onRemoveOffer = function (id) {
      $log.log(id);
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function (result) {
        if (result) {
          apiFactory.deleteCollaborationOffer(id).then(function (resp) {
            $log.log(resp);
            Notification.success("Offer removed successfully.");
            $scope.fetchData();
          })["catch"](function (error) {
            $log.error(error);
            Notification.error("Failed to remove!");
          });
        }
      });
    }; // init


    $scope.fetchData();
    $scope.fetchWorkTypes();

    $scope.getAllSuppliers = function () {
      $scope.loading = true;
      apiFactory.getAllSuppliers({}).then(function (resp) {
        $scope.suppliers = resp.data.list;
        $scope.suppliers.unshift({
          _id: 'all',
          name: $filter('translate')("All Suppliers")
        });
        $scope.loading = false;
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.getAllSubcontractors = function () {
      $scope.loading = true;
      apiFactory.getAllSubcontractors({}).then(function (resp) {
        $scope.subContractors = resp.data.list;
        $scope.subContractors.unshift({
          _id: 'all',
          name: $filter('translate')("All Subcontractors")
        });
        $scope.loading = false;
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    if ($scope.userRole == 2) {
      $scope.getAllSuppliers();
    } else {
      $scope.getAllSubcontractors();
    } // $scope.getAllProjectList = function() {
    //   $scope.loading = true;
    //   apiFactory.listAllProjectNames()
    //     .then(resp => {
    //       $scope.projects = resp.data.list;            
    //       $scope.projects.unshift({_id: 'all', projectName: $filter('translate')("All Projects")});
    //       $scope.loading = false;
    //     })
    //     .catch((err) => {
    //       $scope.loading = false;
    //       Notification.error(utils.getErrorMessage(err));
    //     });
    // }
    // $scope.getAllProjectList() ;
    // $scope.selectProject = function () {
    //   let dquery = {sort: 'bid',vendorType : $scope.userRole == 2 ? 0 : 1, isTemplate: 'false',userIdFilter: $scope.selSupplier == "all" ? null : $scope.selSupplier, projectId: $scope.selectedProject == "all" ? null : $scope.selectedProject};
    //   // $scope.fetchData(dquery);
    //   $scope.$broadcast('SelectfetchData', dquery); ;
    // }


    $scope.selectSupplier = function () {
      var dquery = {
        sort: 'bid',
        vendorType: $scope.userRole == 2 ? 0 : 1,
        isTemplate: 'false',
        userIdFilter: $scope.selSupplier == "all" ? 'null' : $scope.selSupplier,
        projectId: $scope.selectedProject == "all" ? null : $scope.selectedProject
      };
      $scope.$broadcast('SelectfetchData', dquery);
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('projectInvite', {
    controller: ProjectInviteController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/projectInvite/projectInvite.view.html'
  });
  /** @ngInject */

  function ProjectInviteController($log, $uibModal, globals, $scope, utils, $state, apiFactory, Notification) {
    var vm = this;
    $scope.utils = utils;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.projectData = projectStore.get();
    $scope.currentPartnerType = 'Subcontractor';
    $scope.totalCount = 0;
    $scope.numPerPage = 10;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    $scope.statusList = [{
      label: 'Accepted',
      value: 'Accepted'
    }, {
      label: 'Declined',
      value: 'Declined'
    }, {
      label: 'On Hold',
      value: 'On Hold'
    }, {
      label: 'Negotiating',
      value: 'Negotiating'
    }, {
      label: 'Not Received',
      value: 'Not Received'
    }];
    $scope.status = "Accepted";
    vm.designationFilter = "Client,Supplier,Subcontractor,Manager";
    vm.statusFilter = "Accepted,On Hold,Pending,Not Received";

    $scope.getContactInfo = function (userId) {
      var contact = userId.mobile || userId.contact;

      if (!contact) {
        return '';
      }

      return "".concat(contact.dialCode, "-").concat(contact.phoneNumber);
    };

    $scope.setApproval = function () {
      $uibModal.open({
        animation: true,
        component: 'setApprovalModal',
        windowClass: 'set-approval-modal',
        backdrop: 'static',
        keyboard: false
      });
    };

    $scope.getManagerDashboardDesignation = function (dashboardType) {
      var userType = Constants.UserTypeList.find(function (x) {
        return x.dashboardType === dashboardType;
      });

      if (!userType) {
        return 'Manager';
      }

      return userType.name;
    };

    $scope.getInviteStatusClass = function (status) {
      switch (status) {
        case 'None':
          return 'none';

        case 'Pending':
          return 'pending';

        case 'Accepted':
          return 'accepted';

        case 'On Hold':
          return 'on-hold';

        default:
          return 'none';
      }
    };

    $scope.selectAllVendorAndManagers = function () {
      vm.companyVendorAndManagers.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectVendorOrUser = function (user) {
      if (!user.selected) {
        $scope.selectedAll = false;
      }

      if (vm.companyVendorAndManagers.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.companyVendorAndManagers.length) {
        $scope.selectedAll = true;
      }
    };

    $scope.view = function (vendorOrManager) {
      if (vendorOrManager.designation === "Manager") {// Manager
      } else {
        // Client or Supplier or Subcontractor
        $uibModal.open({
          component: "inviteStaffModal",
          windowClass: "invite-staff-modal",
          animation: true,
          backdrop: "static",
          keyboard: false,
          resolve: {
            staffs: function staffs() {
              return vendorOrManager.staffs;
            },
            projectId: function projectId() {
              return vm.projectData._id;
            }
          }
        }).result.then(function () {
          $scope.fetchData();
        })["catch"](function () {});
      }
    };

    $scope.invite = function (vendorOrManager) {
      if (vendorOrManager.designation === "Manager") {
        // Manager
        if (vendorOrManager.inviteStatus === 'Accept') {
          Notification.info('Already accepted');
          return;
        }

        $scope.loading = true;
        apiFactory.inviteMembers({
          projectId: vm.projectData._id,
          users: [vendorOrManager.userId._id]
        }).then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message);
          var invitedMembers = res.data.data;
          var find = invitedMembers.find(function (x) {
            return x.userId === vendorOrManager.userId._id;
          });

          if (find) {
            vendorOrManager.inviteStatus = find.inviteStatus;
          }
        })["catch"](function (err) {
          $scope.loading = false;
          Notification.error(utils.getErrorMessage(err));
        });
      } else {
        // Client or Supplier or Subcontractor
        $uibModal.open({
          component: "inviteStaffModal",
          windowClass: "invite-staff-modal",
          animation: true,
          backdrop: "static",
          keyboard: false,
          resolve: {
            staffs: function staffs() {
              return vendorOrManager.staffs;
            },
            projectId: function projectId() {
              return vm.projectData._id;
            }
          }
        }).result.then(function () {
          $scope.fetchData();
        })["catch"](function () {});
      }
    };

    $scope.inviteSelected = function () {
      var selectedVendorOrManagers = vm.companyVendorAndManagers.filter(function (x) {
        return x.selected;
      });

      if (utils.isEmpty(selectedVendorOrManagers)) {
        Notification.error('Please select vendor or manager to invite');
        return;
      }

      selectedVendorOrManagers = selectedVendorOrManagers.filter(function (x) {
        return x.inviteStatus !== 'Accept';
      });

      if (utils.isEmpty(selectedVendorOrManagers)) {
        Notification.info('Already invited');
        return;
      }

      var staffIds = [];

      var _iterator = _createForOfIteratorHelper(selectedVendorOrManagers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var vendorOrMember = _step.value;

          if (vendorOrMember.designation === "Manager") {
            staffIds.push(vendorOrMember.userId._id);
          } else {
            var _iterator2 = _createForOfIteratorHelper(vendorOrMember.staffs),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var staff = _step2.value;
                staffIds.push(staff._id);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      $scope.loading = true;
      apiFactory.inviteMembers({
        projectId: vm.projectData._id,
        users: staffIds
      }).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message);
        $scope.fetchData();
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.searchData = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      $scope.selectedAll = false;
      $scope.loading = true;
      apiFactory.getCompanyVendorAndManagers({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: $scope.searchText,
        projectId: vm.projectData._id === 'all' ? null : vm.projectData._id,
        designationFilter: vm.designationFilter,
        statusFilter: vm.statusFilter
      }).then(function (res) {
        $scope.loading = false;
        vm.companyVendorAndManagers = res.data.list;
        $scope.totalCount = res.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error("Failed to get users");
        $log.error(err);
      });
    };

    $scope.$on('filter_by_designation', function (event, data) {
      vm.designationFilter = data.filter(function (x) {
        return x.selected;
      }).map(function (x) {
        return x.value;
      }).join(",");
      vm.currentPage = 1;
      $scope.fetchData();
    });
    $scope.$on('filter_by_status', function (event, data) {
      vm.statusFilter = data.filter(function (x) {
        return x.selected;
      }).map(function (x) {
        return x.value;
      }).join(",");
      vm.currentPage = 1;
      $scope.fetchData();
    });

    function init() {
      if (!vm.projectData || vm.projectData._id === 'all') {
        Notification.error('Please select project first.');
        $state.go(globals.getDashboardRoute(vm.userData));
        return;
      }

      $scope.loading = true;
      Promise.all([apiFactory.getCompanyAdminUser(), apiFactory.listAllWorkTypes(), apiFactory.getCompanyVendorAndManagers({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: $scope.searchText,
        projectId: vm.projectData._id === 'all' ? null : vm.projectData._id,
        designationFilter: vm.designationFilter,
        statusFilter: vm.statusFilter
      })]).then(function (res) {
        $scope.loading = false;
        vm.adminUser = res[0].data;
        vm.workTypes = res[1].data.list;
        vm.companyVendorAndManagers = res[2].data.list;
        $scope.totalCount = res[2].data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error("Failed to get users");
        $log.error(err);
      });
    }

    init();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('offerTemplates', {
    controller: OfferTemplatesController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/offerTemplates/offerTemplates.view.html'
  });
  /** @ngInject */

  function OfferTemplatesController($scope, $uibModal, $state, globals, apiFactory, $log, Notification, utils) {
    var vm = this;
    $scope.utils = utils;
    var userStore = globals.userStore,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.userData = userStore.get();
    vm.designationFilter = "Client,Supplier,Subcontractor,Manager,Admin";
    vm.statusFilter = "Accepted,On Hold,Pending,Not Received";
    vm.dateFilter = undefined;
    vm.projectData = projectStore.get();
    vm.companyData = companyStore.get();
    $scope.TEAM_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.TEAM_ACCESS_CREATE = 4;
    // } else {
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.TEAM]})
    //     .then(res => {
    //       $scope.TEAM_ACCESS_CREATE = res.data.data[Constants.AccessKey.TEAM];
    //     })
    //     .catch((e) => {
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    vm.currentPage = 1;
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 1;
    $scope.totalCount = 10;
    vm.bidPackages = [];

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.getOfferDays = function (offer) {
      var days = 0;
      offer.levels.forEach(function (lv) {
        days += utils.num(lv.days);
      });
      return days;
    };

    $scope.deleteBidPackage = function (bidPackage) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        apiFactory.deleteBidPackage(bidPackage._id).then(function () {
          Notification.success("".concat(bidPackage.title, " removed successfully."));
          $scope.fetchData();
        })["catch"](function (err) {
          $log.error(err);
          Notification.error("Failed to remove!");
        });
      }, function () {});
    };

    $scope.selectAllBidPackages = function () {
      vm.bidPackages.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectGroup = function (offer, group) {
      if (group) {
        // offer.selectedGroup = group.name;
        offer.selectedGroup = group;
      } else {
        // offer.selectedGroup = 'All';
        offer.selectedGroup = {
          name: "All",
          levels: []
        };
        offer.groups.forEach(function (group) {
          offer.selectedGroup.levels = offer.selectedGroup.levels.concat(group.levels);
        });
      }
    };

    $scope.selectBidPackage = function (bidPackage) {
      if (!bidPackage.selected) {
        $scope.selectedAll = false;
      }

      if (vm.bidPackages.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.bidPackages.length) {
        $scope.selectedAll = true;
      }
    };

    $scope.workTypes = function (workTypes) {
      return workTypes.map(function (x) {
        return x.tagName;
      }).join(", ");
    };

    $scope.searchBidPackages = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      $scope.loading = true;
      apiFactory.getCollaborationOfferTemplates({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        projectId: vm.projectData._id,
        search: vm.searchText,
        designationFilter: vm.designationFilter,
        statusFilter: vm.statusFilter,
        dateFilter: vm.dateFilter,
        isTemplate: true
      }).then(function (res) {
        $scope.loading = false;
        vm.bidPackages = res.data.list;
        $scope.totalCount = res.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
        $log.log(res.data.list);
        vm.bidPackages.forEach(function (offer) {
          // offer.selectedGroup = 'All';
          offer.selectedGroup = {
            name: "All",
            levels: []
          };

          if (offer.groups) {
            offer.groups.forEach(function (group) {
              offer.selectedGroup.levels = offer.selectedGroup.levels.concat(group.levels);
            });
          }
        }); // $scope.makedata() ;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.calcGroupQuantity = function (group) {
      var sum = 0;

      if (group.levels && group.levels.length) {
        group.levels.forEach(function (lv) {
          sum += utils.num(lv.quantity);
        });
      }

      return sum;
    };

    $scope.calcGroupDays = function (group) {
      var total = 0;

      if (group.levels && group.levels.length) {
        group.levels.forEach(function (lv) {
          total += utils.num(lv.days);
        });
      }

      return total;
    };

    $scope.calcGroupOfferAmount = function (group) {
      var sum = 0;

      if (group.levels && group.levels.length) {
        group.levels.forEach(function (lv) {
          sum += utils.num(lv.amount);
        });
      }

      return sum;
    };

    $scope.gotoCreateOfferTemplate = function () {
      if (vm.bidPackages.length) {
        $state.go('createBidOfferTemplate', {});
      } else {
        Notification.error("Please create Bid Package before setup offer template.");
      }
    };

    $scope.fetchWorkTypes = function () {
      apiFactory.getWorkTypes().then(function (res) {
        $scope.loading = false;
        vm.workTypes = res.data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.onRemoveOffer = function (id) {
      $log.log(id);
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function (result) {
        if (result) {
          apiFactory.deleteCollaborationOfferTemplate(id).then(function (resp) {
            $log.log(resp);
            Notification.success("Offer removed successfully.");
            $scope.fetchData();
          })["catch"](function (error) {
            $log.error(error);
            Notification.error("Failed to remove!");
          });
        }
      });
    };

    $scope.makedata = function () {
      var source = vm.bidPackages;
      $log.log(source);
      var projectObj = [];
      var projectlist = [];

      for (var i = 0; i < source.length; i++) {
        if (!projectlist.includes(source[i].projectId._id)) {
          projectlist.push(source[i].projectId._id);
          projectObj.push({
            offerTemplate: [],
            name: source[i].projectId.projectName,
            id: source[i].projectId._id,
            projectId: source[i].projectId.systemTag,
            workType: source[i].projectId.buildingType.tagName,
            status: source[i].projectId.projectStatus
          });
        }
      }

      for (var _i = 0; _i < projectObj.length; _i++) {
        for (var j = 0; j < source.length; j++) {
          if (projectObj[_i].id == source[j].projectId._id) {
            projectObj[_i].offerTemplate.push(source[j]);
          }
        }
      }

      $scope.projectlist = projectObj;
    }; // init


    $scope.fetchData();
    $scope.fetchWorkTypes();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('incomingOffers', {
    controller: IncomingOffersController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/incomingOffers/incomingOffers.view.html'
  });
  /** @ngInject */

  function IncomingOffersController($scope, $uibModal, $state, globals, apiFactory, $log, Notification, utils, $filter) {
    var vm = this;
    $scope.utils = utils;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.designationFilter = "Client,Supplier,Subcontractor,Manager,Admin";
    vm.statusFilter = "Accepted,Declined,Paused";
    vm.dateFilter = undefined;
    vm.projectData = projectStore.get();
    $scope.SupOrSub = 'Supplier';
    $scope.TEAM_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.TEAM_ACCESS_CREATE = 4;
    // } else {
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.TEAM]})
    //     .then(res => {
    //       $scope.TEAM_ACCESS_CREATE = res.data.data[Constants.AccessKey.TEAM];
    //     })
    //     .catch((e) => {
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.currentPage = 1;
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 1;
    $scope.totalCount = 10;
    vm.bidPackages = [];
    $scope.selectedProject = "all";
    $scope.projects = [];
    $scope.selSupplier = "all";
    $scope.suppliers = [];
    $scope.selSubContractor = "all";
    $scope.subContractors = [];
    $scope.cType = 1;

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.selectSupplier = function () {
      var dquery = {
        sort: 'bid',
        collaboratorType: $scope.cType,
        isTemplate: 'false',
        userIdFilter: $scope.selSupplier == "all" ? null : $scope.selSupplier,
        projectId: $scope.selectedProject == "all" ? null : $scope.selectedProject
      };
      $scope.$broadcast('updateData', dquery);
    };

    $scope.selectSubcontractor = function () {
      var dquery = {
        sort: 'bid',
        collaboratorType: $scope.cType,
        isTemplate: 'false',
        userIdFilter: $scope.selSubContractor == "all" ? null : $scope.selSubContractor,
        projectId: $scope.selectedProject == "all" ? null : $scope.selectedProject
      };
      $scope.$broadcast('updateData', dquery);
    };

    $scope.selectProject = function () {
      var dquery = {
        sort: 'bid',
        collaboratorType: $scope.cType,
        isTemplate: 'false',
        userIdFilter: $scope.selSupplier == "all" ? null : $scope.selSupplier,
        projectId: $scope.selectedProject == "all" ? null : $scope.selectedProject
      };
      $scope.$broadcast('updateData', dquery);
    };

    $scope.getOfferDays = function (offer) {
      var days = 0;
      offer.levels.forEach(function (lv) {
        days += parseInt(lv.days);
      });
      return days;
    };

    $scope.deleteBidPackage = function (bidPackage) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        apiFactory.deleteBidPackage(bidPackage._id).then(function () {
          Notification.success("".concat(bidPackage.title, " removed successfully."));
          $scope.fetchData();
        })["catch"](function (err) {
          $log.error(err);
          Notification.error("Failed to remove!");
        });
      }, function () {});
    };

    $scope.getAllSuppliers = function () {
      $scope.loading = true;
      apiFactory.getAllSuppliers({}).then(function (resp) {
        $scope.suppliers = resp.data.list;
        $scope.suppliers.unshift({
          _id: 'all',
          name: $filter('translate')("All Suppliers")
        });
        $scope.loading = false;
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.getAllSuppliers();

    $scope.selectAllBidPackages = function () {
      vm.bidPackages.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.getAllProjectList = function () {
      $scope.loading = true;
      apiFactory.listAllProjectNames().then(function (resp) {
        $scope.projects = resp.data.list;
        $scope.projects.unshift({
          _id: 'all',
          projectName: $filter('translate')("All Projects")
        });
        $scope.loading = false;
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.getAllProjectList();

    $scope.getAllSubcontractors = function () {
      $scope.loading = true;
      apiFactory.getAllSubcontractors({}).then(function (resp) {
        $scope.subContractors = resp.data.list;
        $scope.subContractors.unshift({
          _id: 'all',
          name: $filter('translate')("All Subconstractors")
        });
        $scope.loading = false;
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.getAllSubcontractors();

    $scope.selectBidPackage = function (bidPackage) {
      if (!bidPackage.selected) {
        $scope.selectedAll = false;
      }

      if (vm.bidPackages.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.bidPackages.length) {
        $scope.selectedAll = true;
      }
    };

    $scope.workTypes = function (workTypes) {
      return workTypes.map(function (x) {
        return x.tagName;
      }).join(", ");
    };

    $scope.searchBidPackages = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      $scope.loading = true;
      apiFactory.getCollaborationOffers({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        designationFilter: vm.designationFilter,
        statusFilter: vm.statusFilter,
        collaboratorType: $scope.cType,
        dateFilter: vm.dateFilter
      }).then(function (res) {
        $scope.loading = false;
        vm.bidPackages = res.data.list;
        $scope.totalCount = res.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchWorkTypes = function () {
      apiFactory.getWorkTypes().then(function (res) {
        $scope.loading = false;
        vm.workTypes = res.data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.onRemoveOffer = function (id) {
      $log.log(id);
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function (result) {
        if (result) {
          apiFactory.deleteCollaborationOffer(id).then(function (resp) {
            $log.log(resp);
            Notification.success("Offer removed successfully.");
            $scope.fetchData();
          })["catch"](function (error) {
            $log.error(error);
            Notification.error("Failed to remove!");
          });
        }
      });
    };

    $scope.setTab = function (mode) {
      $scope.SupOrSub = mode;
      if ($scope.SupOrSub == 'Supplier') $scope.cType = 1;else $scope.cType = 2;
      $log.log($scope.subContractors);
      $scope.selectedProject = 'all';
      var dquery = {
        sort: 'bid',
        collaboratorType: $scope.cType,
        isTemplate: 'false',
        userIdFilter: "all",
        projectId: $scope.selectedProject == "all" ? null : $scope.selectedProject
      };
      $scope.$broadcast('updateData', dquery);
    };

    $scope.fetchWorkTypes();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('createTeam', {
    controller: createTeamController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/createTeam/createTeam.view.html'
  });
  /** @ngInject */

  function createTeamController($scope, $log, globals, apiFactory, Notification, utils, $state, $element) {
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.projectData = projectStore.get();
    vm.invitedUsers = [];
    vm.orgChart = {
      members: []
    };
    vm.selectedUserId = undefined;
    $scope.managers = [];
    $scope.invitedVendors = [];
    $scope.invitedStaffs = [];
    $scope.subcontractors = [];
    $scope.suppliers = [];
    $scope.userList = [];
    $scope.selectedManager = null;
    $scope.userType = 1;
    $scope.userTypes = [{
      id: 1,
      name: 'Supplier'
    }, {
      id: 2,
      name: 'Sub-Contractor'
    }];
    $scope.userList = $scope.suppliers;
    $scope.$watch('userType', function () {
      switch ($scope.userType) {
        case 1:
          $scope.userList = $scope.suppliers;
          break;

        case 2:
          $scope.userList = $scope.subcontractors;
          break;
      }

      $scope.$apply();
    });
    $element.on('dragover', function (event) {
      event.preventDefault();
    });
    $element.on('drop', function (event) {
      event.preventDefault();
      var exists = vm.orgChart.members.find(function (x) {
        return x.userId._id === $scope.selectedManager.userId._id;
      });

      if (exists) {
        Notification.error("The member has already been added");
        return;
      }

      $scope.loading = true;
      var user = $scope.selectedManager.userId;
      apiFactory.addMemberToOrgChart({
        projectId: vm.projectData._id,
        userId: user._id
      }).then(function () {
        $scope.loading = false;
        vm.orgChart.members.push({
          userId: user
        });
        vm.invitedUsers = vm.invitedUsers.filter(function (x) {
          return !vm.orgChart.members.find(function (y) {
            return y.userId._id === x._id;
          });
        });
        $scope.selectedManager = null;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
        $scope.selectedManager = null;
      });
    });
    $element.on('dragstart', function (event) {
      $scope.selectedManager = $scope.managers.find(function (v) {
        return v._id == event.target.getAttribute('mId');
      });
      $scope.$apply();
    });

    $scope.addMember = function () {
      if (!vm.selectedUserId) {
        Notification.error("Please select a member");
        return;
      }

      var exists = vm.orgChart.members.find(function (x) {
        return x.userId._id === vm.selectedUserId;
      });

      if (exists) {
        Notification.error("The member has already been added");
        return;
      }

      var user = $scope.userList.find(function (x) {
        return x._id === vm.selectedUserId;
      });

      if (!user) {
        Notification.error("Could not find member");
        return;
      }

      $scope.loading = true;
      apiFactory.addMemberToOrgChart({
        projectId: vm.projectData._id,
        userId: user._id
      }).then(function () {
        $scope.loading = false;
        vm.orgChart.members.push({
          userId: user
        });
        $scope.suppliers = $scope.suppliers.filter(function (x) {
          return !vm.orgChart.members.find(function (y) {
            return y.userId._id === x._id;
          });
        });
        $scope.subcontractors = $scope.subcontractors.filter(function (x) {
          return !vm.orgChart.members.find(function (y) {
            return y.userId._id === x._id;
          });
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.exportOrgChart = function () {
      $scope.$broadcast('save_org_chart');
    };

    $scope.fetchManagers = function () {
      $scope.loading = true;
      apiFactory.listAllManagers().then(function (res) {
        $scope.loading = false;
        $scope.managers = res.data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchInvitedList = function () {
      $scope.loading = true;
      apiFactory.getAllInvitedList(vm.projectData._id, {}).then(function (res) {
        $scope.invitedVendors = res.data.companyIds;
        $scope.invitedStaffs = res.data.staffIds;
        apiFactory.getAllSubcontractors().then(function (res) {
          $scope.loading = false;
          var vendorList = res.data.list;
          vendorList.forEach(function (v) {
            v.staffs.forEach(function (s) {
              if ($scope.invitedStaffs.indexOf(s._id) > -1 && !vm.orgChart.members.find(function (y) {
                return y.userId._id === s._id;
              })) $scope.subcontractors.push(s);
            });
          });
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
        apiFactory.getAllSuppliers().then(function (res) {
          $scope.loading = false;
          var vendorList = res.data.list;
          vendorList.forEach(function (v) {
            v.staffs.forEach(function (s) {
              if ($scope.invitedStaffs.indexOf(s._id) > -1 && !vm.orgChart.members.find(function (y) {
                return y.userId._id === s._id;
              })) $scope.suppliers.push(s);
            });
          });
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    function init() {
      if (!vm.projectData || vm.projectData._id === 'all') {
        Notification.error('Please select project first.');
        $state.go(globals.getDashboardRoute(vm.userData));
        return;
      }

      $scope.fetchManagers(); // $scope.fetchSuppliers()
      // $scope.fetchSubcontractors()

      $scope.fetchInvitedList();
      $scope.loading = true;
      Promise.all([apiFactory.fetchInvitedMembersInProject(vm.projectData._id), apiFactory.getOrgChart(vm.projectData._id)]).then(function (res) {
        $scope.loading = false;
        var invitedMembers = res[0].data;
        vm.invitedUsers = invitedMembers.map(function (x) {
          return x.userId;
        });
        vm.orgChart = res[1].data;
        vm.invitedUsers = vm.invitedUsers.filter(function (x) {
          return !vm.orgChart.members.find(function (y) {
            return y.userId._id === x._id;
          });
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    init();
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('createBidPackage', {
    controller: createBidPackageController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/createBidPackage/createBidPackage.view.html'
  });
  /** @ngInject */

  function createBidPackageController($state, $scope, apiFactory, $log, Notification, $document, utils, globals, $timeout, $stateParams) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.projectData = globals.projectStore.get();
    vm.bpId = $stateParams.id;
    vm.editMode = vm.bpId ? true : false;
    $scope.bidPackage = {
      projectId: vm.projectData._id,
      typeOfWork: [],
      attached: [],
      vendorType: 0,
      createBy: vm.editMode ? '' : vm.userData._id,
      email: vm.editMode ? '' : vm.userData.email,
      contactNo: {
        dialCode: vm.editMode ? '' : vm.userData.mobile.dialCode,
        phoneNumber: vm.editMode ? '' : vm.userData.mobile.phoneNumber
      }
    };

    if (this.editMode) {
      Promise.all([apiFactory.getBidPackage(vm.bpId)]).then(function (res) {
        $scope.loading = false;
        $scope.bidPackage = res[0].data;
        $scope.attached = $scope.bidPackage.attached;
        $log.log(123, res[0].data);
        initDateInput('accept-deadline-input-date', vm.editMode ? !$scope.bidPackage.acceptUntil ? '' : $scope.bidPackage.acceptUntil.split("T")[0] : '');
        initDateInput('tender-deadline-input-date', vm.editMode ? !$scope.bidPackage.tenderDate ? '' : $scope.bidPackage.tenderDate.split("T")[0] : '');
        initDateInput('bid-deadline-input-date', vm.editMode ? !$scope.bidPackage.bidDeadline ? '' : $scope.bidPackage.bidDeadline.split("T")[0] : '');
        initTimeInput('accept-deadline-input-time', vm.editMode ? !$scope.bidPackage.acceptUntil ? '' : $scope.bidPackage.acceptUntil.split("T")[1] : '');
        initTimeInput('tender-deadline-input-time', vm.editMode ? !$scope.bidPackage.tenderDate ? '' : $scope.bidPackage.tenderDate.split("T")[1] : '');
        initTimeInput('bid-deadline-input-time', vm.editMode ? !$scope.bidPackage.bidDeadline ? '' : $scope.bidPackage.bidDeadline.split("T")[1] : '');
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.utils = utils;
    vm.createByName = vm.userData.displayName;
    vm.collaborators = [{
      label: "Supplier",
      value: 0
    }, {
      label: "Sub-Contractor",
      value: 1
    }];

    function initTimeInput(elementId, time) {
      var picker = new dhx.Timepicker(null, {
        dateFormat: "%m/%d/%Y",
        css: "dhx_widget--bordered no-zoom",
        value: new Date()
      });
      var popup = new dhx.Popup();
      popup.attach(picker);
      picker.events.on("change", function () {
        timeInput.value = picker.getValue(); // popup.hide();
      });
      var timeInput = $document[0].getElementById(elementId);
      timeInput.addEventListener("click", function () {
        timeInput.value = picker.getValue();
        popup.show(timeInput);
      });

      if (angular.isDefined(time) && time != '') {
        picker.setValue(time);
      }
    }

    globals.getCountryCode().then(function (resp) {
      vm.getCountryCode = resp.data;

      vm.loadCountryCode = function () {
        return new Promise(function (resolve) {
          resolve(resp.data);
        });
      };
    });
    globals.getCountryCode().then(function (resp) {
      vm.getCountries = resp.data;
      vm.getCountries.sort(function (a, b) {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });

      vm.loadCountries = function () {
        return new Promise(function (resolve) {
          resolve(resp.data);
        });
      };
    });

    function initDateInput(elementId, date) {
      var calendar = new dhx.Calendar(null, {
        dateFormat: "%m/%d/%Y",
        css: "dhx_widget--bordered no-zoom",
        timePicker: false,
        value: new Date()
      });
      var popup = new dhx.Popup();
      popup.attach(calendar);
      calendar.events.on("change", function () {
        dateInput.value = calendar.getValue(); // popup.hide();
      });
      var dateInput = $document[0].getElementById(elementId);
      dateInput.addEventListener("click", function () {
        dateInput.value = calendar.getValue();
        popup.show(dateInput);
      });

      if (angular.isDefined(date) && date != '') {
        calendar.setValue(date.split('-')[1] + '/' + date.split('-')[2] + '/' + date.split('-')[0]);
      }
    }

    $scope.onDiscard = function () {
      $state.go('bidPackages');
    };

    $scope.selectWorkType = function () {
      var workType = vm.workTypes.find(function (x) {
        return x._id === $scope.workType;
      });

      if (workType && !$scope.bidPackage.typeOfWork.find(function (x) {
        return x._id === workType._id;
      })) {
        $scope.bidPackage.typeOfWork.push(workType);
      }

      $scope.workType = undefined;
      $timeout(function () {
        $scope.$apply();
      });
    };

    $scope.removeWorkType = function (index) {
      $scope.bidPackage.typeOfWork.splice(index, 1);
    };

    $scope.changeFiles = function (files) {
      $scope.attached = $scope.attached || [];

      if (files && files.length) {
        var _iterator = _createForOfIteratorHelper(files),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var file = _step.value;
            $scope.attached.push({
              fileName: file.name,
              bytes: file.size,
              secure_url: URL.createObjectURL(file),
              format: file.type
            });
            $log.log($scope.attached);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    };

    $scope.removeFile = function (attach) {
      $scope.attached = $scope.attached.filter(function (a) {
        return a.secure_url != attach.secure_url;
      });
    };

    $scope.attachFiles = function () {
      angular.element('#fileSelector').triggerHandler('click');
    };

    $scope.onSave = function () {
      var data = angular.copy($scope.bidPackage); // validate title

      if (utils.isEmpty(data.title)) {
        Notification.error("Please input a title.");
        return;
      } // validate work types


      if (utils.isEmpty(data.typeOfWork)) {
        Notification.error("Please input a type of work at least one.");
        return;
      } // validate accept deadline


      var deadline_date = angular.element('#accept-deadline-input-date').val();

      if (!deadline_date) {
        Notification.error("Please input a accept deadline date.");
        return;
      }

      var deadline_time = angular.element('#accept-deadline-input-time').val();

      if (!deadline_time) {
        Notification.error("Please input a accept deadline time.");
        return;
      }

      var deadline = "".concat(deadline_date, " ").concat(deadline_time) + ' UTC';
      data.acceptUntil = new Date(deadline);

      if (!angular.isDate(data.acceptUntil)) {
        Notification.error("Invalid accept deadline date.");
        return;
      } // validate tender deadline


      deadline_date = angular.element('#tender-deadline-input-date').val();

      if (!deadline) {
        Notification.error("Please input a tender deadline date.");
        return;
      }

      deadline_time = angular.element('#tender-deadline-input-time').val();

      if (!deadline_time) {
        Notification.error("Please input a tender deadline time.");
        return;
      }

      deadline = "".concat(deadline_date, " ").concat(deadline_time) + ' UTC';
      data.tenderDate = new Date(deadline);

      if (!angular.isDate(data.tenderDate)) {
        Notification.error("Invalid tender deadline date.");
        return;
      } // validate bid deadline


      deadline_date = angular.element('#bid-deadline-input-date').val();

      if (!deadline) {
        Notification.error("Please input a bid deadline date.");
        return;
      }

      deadline_time = angular.element('#bid-deadline-input-time').val();

      if (!deadline_time) {
        Notification.error("Please input a bid deadline time.");
        return;
      }

      deadline = "".concat(deadline_date, " ").concat(deadline_time) + ' UTC';
      data.bidDeadline = new Date(deadline);

      if (!angular.isDate(data.bidDeadline)) {
        Notification.error("Invalid bid deadline date.");
        return;
      } // work types


      data.typeOfWork = data.typeOfWork.map(function (x) {
        return x._id;
      }); // attachments

      if ($scope.attached) data.attached = $scope.attached;else data.attached = [];
      $scope.loading = true;
      $log.log(data);

      if (vm.editMode) {
        data._id = vm.bpId;
        apiFactory.updateBidPackage(vm.bpId, data).then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message);
          $state.go('bidPackages');
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      } else {
        apiFactory.createBidPackage(data).then(function (res) {
          $scope.loading = false;
          Notification.success(res.data.message);
          $state.go('bidPackages');
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }
    };

    function init() {
      if (!vm.editMode) {
        initDateInput('accept-deadline-input-date');
        initDateInput('tender-deadline-input-date');
        initDateInput('bid-deadline-input-date');
        initTimeInput('accept-deadline-input-time');
        initTimeInput('tender-deadline-input-time');
        initTimeInput('bid-deadline-input-time');
      }

      $scope.loading = true;
      apiFactory.getWorkTypes().then(function (res) {
        $scope.loading = false;
        vm.workTypes = res.data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    init();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('createBidOfferTemplate', {
    controller: createBidOfferTemplateController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/createBidOfferTemplate/createBidOfferTemplate.view.html'
  });

  function createBidOfferTemplateController($scope, $state, globals, apiFactory, $document, $log, Notification, utils, $uibModal, $stateParams, FileSaver) {
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.projectData = projectStore.get();
    vm.bpId = $stateParams.id;
    $scope.bidPackages = [];
    $scope.vendorList = [];
    $scope.vendorList2 = [];
    $scope.collaborators = [];
    vm.bidOfferTemplate = {
      name: '',
      isTemplate: true,
      isBest: false,
      bidPackageId: '',
      emailAddress: vm.userData.email,
      dialCode: vm.userData.mobile.dialCode,
      phoneNumber: vm.userData.mobile.phoneNumber,
      createdBy: vm.userData.displayName,
      projectId: vm.projectData._id,
      levels: [],
      userId: vm.userData._id,
      companyId: vm.userData.companyId
    };
    globals.getCountryCode().then(function (resp) {
      vm.getCountryCode = resp.data;

      vm.loadCountryCode = function () {
        return new Promise(function (resolve) {
          resolve(resp.data);
        });
      };
    });

    $scope.exportToExcel = function (bidPackageId) {
      $log.log(bidPackageId);
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.toLowerCase().includes('.xlsx') || result.toLowerCase().includes('.xls') ? result : result + '.xlsx';
        var query = {
          fileName: fileName,
          bidPackageId: bidPackageId // search: vm.searchText

        };
        $scope.isLoading = true;
        apiFactory.downloadOfferTemplatesExcel(query).then(function (res) {
          $log.log(res);
          $scope.isLoading = false;
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, fileName);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err, 'Failed to export excel file'));
        });
      }, function () {});
    };

    $scope.changeFiles = function (files) {
      $scope.isLoading = true;
      var reader = new FileReader();

      reader.onload = function (e) {
        var data = e.target.result;
        data = new Uint8Array(data);
        var workbook = XLSX.read(data, {
          type: "array"
        });
        var first_sheet_name = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[first_sheet_name];
        var json = XLSX.utils.sheet_to_json(worksheet, {
          header: 1
        });
        var bidPackage = $scope.bidPackages.find(function (x) {
          return x._id == vm.bidOfferTemplate.bidPackageId;
        });
        var vendorType = bidPackage.vendorType;
        json.forEach(function (d, idx) {
          if (idx == 0 || idx == 1 || !d.length || d[0] == 'SUM') {
            return;
          } // if (idx != 0) {


          vm.bidOfferTemplate.levels.push({
            name: d[0],
            size: d[3],
            level: d[2],
            days: vendorType ? parseInt(d[6]) : parseInt(d[5]),
            // supplier_days: d[5],
            // subcontractor_days: d[6],
            amount: parseFloat(d[10]),
            unit: d[8],
            quantity: parseInt(d[7]),
            unitPrice: parseFloat(d[9]),
            type: d[1],
            description: d[4]
          }); // }
        });
        $scope.isLoading = false;
      };

      reader.readAsArrayBuffer(files[0]);
    };

    $scope.addItem = function () {
      vm.bidOfferTemplate.levels.push({
        name: '',
        size: '',
        level: '',
        days: '',
        amount: '',
        quantity: '',
        unitPrice: '',
        type: '',
        description: '',
        addType: 1
      });
    };

    $scope.removeLevel = function (index) {
      vm.bidOfferTemplate.levels.splice(index, 1);
    };

    $scope.levelString = function (index) {
      return "Level " + (index + 1).toString().padStart(2, "0");
    };

    $scope["import"] = function () {
      $document[0].getElementById('import_levels').click();
    };

    $scope.download = function () {};

    $scope.update = function () {
      $scope.isLoading = true;
      vm.bidOfferTemplate.revision++;
      var groups = [];

      for (var i = 0; i < vm.bidOfferTemplate.levels.length; i++) {
        var item = vm.bidOfferTemplate.levels[i];

        if (item.isChecked) {
          groups.push({
            name: item.name,
            levels: []
          });
        } else {
          groups[groups.length - 1].levels.push(item);
        }
      }

      groups.forEach(function (group) {
        var duplicated = groups.filter(function (x) {
          return x.name == group.name;
        });

        if (duplicated.length >= 2) {
          duplicated.forEach(function (x, i) {
            return x.name += i;
          });
        }
      });
      vm.bidOfferTemplate.groups = groups;
      apiFactory.updateCollaborationOfferTemplate(vm.bidOfferTemplate).then(function (res) {
        $scope.isLoading = false;
        Notification.success(res.data.message);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchBidPackages = function () {
      $scope.isLoading = true;
      apiFactory.getBidPackages({
        projectId: vm.projectData._id
      }).then(function (res) {
        $scope.isLoading = false;
        $scope.bidPackages = res.data.list;
        if ($scope.bidPackages.length) vm.bidOfferTemplate.bidPackageId = $scope.bidPackages[0]._id;
        $scope.getBidOfferTemplateByBidId(vm.bidOfferTemplate.bidPackageId);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.openLevelSelectDlg = function (model) {
      $uibModal.open({
        animation: true,
        component: 'selectBIMLevelModal',
        windowClass: 'select-bim-level-modal',
        resolve: {
          levels: function levels() {
            return model.tree;
          }
        }
      }).result.then(function (result) {
        var levels = result.data;
        vm.bidOfferTemplate.levels = vm.bidOfferTemplate.levels.concat(levels);
      });
    };

    $scope.filter_data = [];

    $scope.openFilter = function () {
      $uibModal.open({
        animation: true,
        component: 'createOfferFilterModal',
        windowClass: 'create-offer-filter-modal',
        resolve: {
          filter_data: function filter_data() {
            return $scope.filter_data;
          }
        }
      }).result.then(function (result) {
        $scope.filter_data = result.data;
      });
    };

    $scope.checkFilter = function (mItem) {
      var mType = mItem.type;
      if ($scope.filter_data.length == 0 || mItem.addType == 1) return true;
      var filterData = $scope.filter_data.map(function (item) {
        if (mType.toLowerCase().indexOf(item.toLowerCase()) !== -1) {
          return true;
        }
      });
      filterData = filterData.includes(true);
      return filterData;
    };

    $scope.openBIMDlg = function () {
      $uibModal.open({
        animation: true,
        component: 'importFromBIMModal',
        windowClass: 'import-from-bim-modal'
      }).result.then(function (result) {
        var modelId = result.modelId;
        apiFactory.get3dModel(modelId).then(function (resp) {
          var model = resp.data.data;
          $scope.openLevelSelectDlg(model);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      });
    };

    $scope.exportLevels = function () {
      var content = "data:text/csv;charset=utf-8,";
      content += 'Level,Time-Days,Offer Amount, Type, Description';
      content += "\r\n";
      vm.bidOfferTemplate.levels.forEach(function (lv) {
        var row = "".concat(lv.level ? lv.level : '', ",").concat(lv.days ? lv.days : '', ",").concat(lv.amount ? lv.amount : '', ",").concat(lv.type ? lv.type : '', ",").concat(lv.description ? lv.description : '');
        content += row + "\r\n";
      });
      var encodedUri = encodeURI(content);
      var link = $document[0].createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "offer_levels.csv");
      $document[0].body.appendChild(link);
      link.click();
    };

    $scope.init = function () {
      $scope.fetchBidPackages();
    }; // init


    $scope.init(); // left part filter

    $scope.filterText = "";
    $scope.models = [];
    $scope.initData = [];

    $scope.onCancel = function () {
      vm.modalInstance.close({
        data: $scope.initData
      });
    };

    $scope.onEnter = function (e) {
      var keyCode = e.which || e.keyCode;

      if (keyCode == 13) {
        var m_index = $scope.models.find(function (elem) {
          return elem == $scope.filterText;
        });
        if (!m_index) $scope.models.push($scope.filterText);
        $scope.filterText = "";
      }
    };

    $scope.removeFilter = function (mIndex) {
      $scope.models.splice(mIndex, 1);
    };

    $scope.onSubmit = function () {
      vm.modalInstance.close({
        data: $scope.models
      });
    };

    vm.$onInit = function () {// $scope.initData = $scope.models = vm.resolve.filter_data;
    }; // get offer template line by bid package id


    $scope.changeOfferTemplate = function () {
      $scope.getBidOfferTemplateByBidId(vm.bidOfferTemplate.bidPackageId);
    };

    $scope.getBidOfferTemplateByBidId = function (id) {
      $scope.isLoading = true;
      apiFactory.getCollaborationOfferTemplateByBidPackageId(id).then(function (res) {
        $scope.isLoading = false;
        if (res.data) vm.bidOfferTemplate = res.data;else vm.bidOfferTemplate.levels = [];
        var levels = [];

        if (vm.bidOfferTemplate.groups) {
          for (var i = 0; i < vm.bidOfferTemplate.groups.length; i++) {
            var group = vm.bidOfferTemplate.groups[i];
            levels.push({
              name: group.name,
              isChecked: true
            });

            for (var j = 0; j < group.levels.length; j++) {
              levels.push(group.levels[j]);
            }
          }

          vm.bidOfferTemplate.levels = levels;
        }
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('collaborationTeam', {
    controller: CollaborationTeamController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/collaborationTeam/collaborationTeam.view.html'
  });
  /** @ngInject */

  function CollaborationTeamController($scope, $log, $timeout, $uibModal, apiFactory, globals, Notification, utils, $state, $element) {
    var vm = this;
    vm.userData = globals.userStore.get();
    vm.projectData = globals.projectStore.get();
    $scope.currentTab = 'Suppliers';
    $scope.selectedStaff = '';
    $element.on('dragover', function (event) {
      event.preventDefault();
    });
    $element.on('drop', function (event) {
      event.preventDefault();
      var teamId = event.target.getAttribute('refId');
      $log.log(teamId);

      if (teamId) {
        var team = $scope.suppliers.find(function (c) {
          return c._id == teamId;
        });
        var members = [];

        if (event.target.getAttribute('ref') == 'drop-zone-tq-manager') {
          members = team.tqManagers;
        } else if (event.target.getAttribute('ref') == 'drop-zone-tq-collaborators') {
          members = team.tqCollaborators;
        } else if (event.target.getAttribute('ref') == 'drop-zone-issue-manager') {
          members = team.issueManagers;
        } else if (event.target.getAttribute('ref') == 'drop-zone-issue-collaborators') {
          members = team.issueCollaborators;
        } else if (event.target.getAttribute('ref') == 'drop-zone-report-manager') {
          members = team.reportManagers;
        } else if (event.target.getAttribute('ref') == 'drop-zone-report-collaborators') {
          members = team.reportCollaborators;
        }

        if ($scope.selectedStaff) {
          if (!members.find(function (x) {
            return x._id == $scope.selectedStaff._id;
          })) {
            members.push($scope.selectedStaff);
          }
        }

        calcCollaborationStatus(team);
      }

      $scope.selectedStaff = '';
      $scope.$apply();
    });
    $element.on('dragstart', function (event) {
      if ($scope.currentTab == "Suppliers") {
        $scope.selectedVendor = $scope.suppliers.find(function (v) {
          return v._id == event.target.getAttribute('vId');
        });
        $scope.selectedStaff = $scope.selectedVendor ? $scope.selectedVendor.staffs.find(function (s) {
          return s._id == event.target.getAttribute('sId');
        }) : undefined;
      } else {
        $scope.selectedVendor = $scope.subcontactors.find(function (v) {
          return v._id == event.target.getAttribute('vId');
        });
        $scope.selectedStaff = $scope.selectedVendor ? $scope.selectedVendor.staffs.find(function (s) {
          return s._id == event.target.getAttribute('sId');
        }) : undefined;
      }

      $log.log($scope.selectedStaff);
      $scope.$apply();
    });

    $scope.removeMember = function (collaboration, members, index) {
      members.splice(index, 1); // updateCollaboration(collaboration);
    };

    function calcCollaborationStatus(collaboration) {
      if (collaboration.members.qaMembers.length && collaboration.members.issueMembers.length && collaboration.members.vaOrderMembers.length && collaboration.members.drawingMembers.length && collaboration.members.safetyMembers.length && collaboration.members.tqEletricalMembers.length && collaboration.members.tqPlummingMembers.length && collaboration.members.tqArchitectMembers.length && collaboration.members.tqVentilationMembers.length && collaboration.members.tqMechanicalMembers.length) {
        collaboration.members.status = 'Finished';
      } else if (!collaboration.members.qaMembers.length && !collaboration.members.issueMembers.length && !collaboration.members.vaOrderMembers.length && !collaboration.members.drawingMembers.length && !collaboration.members.safetyMembers.length && !collaboration.members.tqEletricalMembers.length && !collaboration.members.tqPlummingMembers.length && !collaboration.members.tqArchitectMembers.length && !collaboration.members.tqVentilationMembers.length && !collaboration.members.tqMechanicalMembers.length) {
        collaboration.members.status = 'Not yet';
      } else {
        collaboration.members.status = 'Not completed';
      }
    }

    $scope.saveCollaborationTeam = function (collaboration) {
      var data = angular.copy(collaboration.members);
      data.qaMembers = data.qaMembers.map(function (x) {
        return x._id;
      });
      data.drawingMembers = data.drawingMembers.map(function (x) {
        return x._id;
      });
      data.safetyMembers = data.safetyMembers.map(function (x) {
        return x._id;
      });
      data.issueMembers = data.issueMembers.map(function (x) {
        return x._id;
      });
      data.vaOrderMembers = data.vaOrderMembers.map(function (x) {
        return x._id;
      });
      data.tqEletricalMembers = data.tqEletricalMembers.map(function (x) {
        return x._id;
      });
      data.tqArchitectMembers = data.tqArchitectMembers.map(function (x) {
        return x._id;
      });
      data.tqMechanicalMembers = data.tqMechanicalMembers.map(function (x) {
        return x._id;
      });
      data.tqPlummingMembers = data.tqPlummingMembers.map(function (x) {
        return x._id;
      });
      data.tqVentilationMembers = data.tqVentilationMembers.map(function (x) {
        return x._id;
      });
      $scope.isLoading = true;
      apiFactory.updateCollaborationTeam(data).then(function () {
        $scope.isLoading = false;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err, "Failed to update members"));
      });
    };

    $scope.init = function () {
      if (!vm.projectData || vm.projectData._id === 'all') {
        Notification.error('Please select project first.');
        $state.go(globals.getDashboardRoute(vm.userData));
        return;
      }

      $scope.loading = true;
      Promise.all([apiFactory.getAllSuppliers(), apiFactory.getAllSubcontractors(), apiFactory.getOrgChart(vm.projectData._id), apiFactory.getBidPackages({
        projectId: vm.projectData._id
      }), apiFactory.listAllManagers()]).then(function (res) {
        $scope.loading = false;
        var suppliers = res[0].data.list;
        var subcontractors = res[1].data.list;
        $scope.orgChart = res[2].data;
        $scope.bidPackages = res[3].data.list;
        $scope.managers = res[4].data.list;
        $log.log('bidpackages = ', $scope.bidPackages);
        $scope.suppliers = suppliers.filter(function (x) {
          return $scope.bidPackages.find(function (y) {
            return y.invited.find(function (z) {
              return z === x._id;
            });
          });
        });
        $scope.subcontractors = subcontractors.filter(function (x) {
          return $scope.bidPackages.find(function (y) {
            return y.invited.find(function (z) {
              return z === x._id;
            });
          });
        });
        $scope.suppliers.forEach(function (supplier) {
          var item = $scope.orgChart.members.find(function (x) {
            return x.userId.subUserId && x.userId.subUserId._id == supplier._id;
          });

          if (item) {
            var parent = $scope.orgChart.members.find(function (x) {
              return x.userId._id == item.upperUserId;
            });
            supplier.parent = parent;
          }
        });
        $log.log('suppliers = ', $scope.suppliers);
        $log.log('subcontractors = ', $scope.subcontractors);
        $log.log('orgChart = ', $scope.orgChart);
        $scope.suppliers.forEach(function (supplier) {
          apiFactory.getCollaborationTeamByProjectId({
            projectId: vm.projectData._id,
            vendor: supplier._id,
            vendorType: "Supplier"
          }).then(function (result) {
            supplier.members = result.data;
          });
        });
        $scope.subcontractors.forEach(function (subcontractor) {
          apiFactory.getCollaborationTeamByProjectId({
            projectId: vm.projectData._id,
            vendor: subcontractor._id,
            vendorType: "Subcontractor"
          }).then(function (result) {
            subcontractor.members = result.data;
          });
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.init();
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function () {
  'use strict';

  angular.module('app').component('collaborationOffers', {
    controller: CollaborationOffersController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/collaborationOffers/collaborationOffers.view.html'
  });
  /** @ngInject */

  function CollaborationOffersController($scope, globals, apiFactory, $log, Notification, utils, $uibModal, $state) {
    var vm = this;
    var userStore = globals.userStore,
        companyStore = globals.companyStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    vm.projectData = projectStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    vm.utils = utils;
    vm.designationFilter = "Client,Supplier,Subcontractor,Manager,Admin";
    vm.statusFilter = "Accepted,On Hold,Pending,Not Received";
    vm.dateFilter = undefined;
    vm.vendorList = [];
    vm.vendorList2 = [];
    vm.collaborators = [];
    $scope.TEAM_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.TEAM_ACCESS_CREATE = 4;
    // } else {
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.TEAM]
    //   }).then(res => {
    //     $scope.TEAM_ACCESS_CREATE = res.data.data[Constants.AccessKey.TEAM];
    //   })
    //   .catch((e) => {
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    vm.currentPage = 1;
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    vm.statusOptions = [{
      value: 'Not Received',
      label: 'Not Received'
    }, {
      value: 'Pending',
      label: 'Pending'
    }, {
      value: 'Declined',
      label: 'Declined'
    }, {
      value: 'On Hold',
      label: 'On-Hold'
    }, {
      value: 'Accepted',
      label: 'Accepted'
    }];
    $scope.offers = [];

    $scope.searchOffers = function () {
      vm.currentPage = 1;
      $scope.getOffers();
    };

    $scope.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.getOffers();
    };

    $scope.selectGroup = function (offer, group) {
      if (group) {
        offer.selectedGroup = group;
      } else {
        // offer.selectedGroup = 'All';
        offer.selectedGroup = {
          name: "All",
          levels: []
        };
        offer.groups.forEach(function (group) {
          offer.selectedGroup.levels = offer.selectedGroup.levels.concat(group.levels);
        });
      }
    };

    $scope.getOffers = function () {
      $scope.isLoading = true;
      apiFactory.getCollaborationOffers({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        projectId: vm.projectData._id,
        designationFilter: vm.designationFilter,
        dateFilter: vm.dateFilter
      }).then(function (res) {
        $scope.isLoading = false;
        $scope.offers = res.data.list;
        $scope.totalCount = res.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
        $scope.makedata();
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.getOffers();

    $scope.updateStatus = function (offer, status) {
      $scope.isLoading = true;
      apiFactory.updateCollaborationOfferStatus({
        id: offer._id,
        status: status
      }).then(function (res) {
        $scope.isLoading = false;
        offer.status = status;
        Notification.success(res.data.message);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.saveOfferSubmit = function (offer) {
      $scope.loading = true;
      apiFactory.updateCollaborationOffer(offer).then(function () {
        $scope.loading = false;
        Notification.success('changed successfully');
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.uploadOffer = function () {
      $uibModal.open({
        animation: true,
        component: 'uploadOfferModal',
        windowClass: 'upload-offer-modal'
      }).result.then(function () {
        $scope.getOffers();
      }, function () {});
    };

    $scope.selectAllOffers = function () {
      $scope.offers.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectOffer = function (offer) {
      if (!offer.selected) {
        $scope.selectedAll = false;
      }

      if ($scope.offers.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === $scope.offers.length) {
        $scope.selectedAll = true;
      }
    };

    $scope.$on('filter_by_designation', function (event, data) {
      vm.designationFilter = data.filter(function (x) {
        return x.selected;
      }).map(function (x) {
        return x.value;
      }).join(",");
      $scope.getOffers();
    });
    $scope.$on('filter_by_status', function (event, data) {
      vm.statusFilter = data.filter(function (x) {
        return x.selected;
      }).map(function (x) {
        return x.value;
      }).join(",");
      $scope.getOffers();
    });
    $scope.$on("filter_by_date", function (event, data) {
      vm.dateFilter = data;
      $scope.getOffers();
    });

    $scope.makedata = function () {
      var source = $scope.offers;
      $log.log(source);
      var bidObj = [];
      var bidlist = [];

      for (var i = 0; i < source.length; i++) {
        if (!bidlist.includes(source[i].bidPackageId._id)) {
          bidlist.push(source[i].bidPackageId._id);
          bidObj.push({
            offers: [],
            title: source[i].bidPackageId.title,
            bId: source[i].bidPackageId._id,
            systag: source[i].bidPackageId.sysTag
          });
        }
      }

      for (var _i = 0; _i < bidObj.length; _i++) {
        for (var j = 0; j < source.length; j++) {
          if (bidObj[_i].bId == source[j].bidPackageId._id) {
            var offer = source[j];

            if (offer.revision < offer.templateId.revision) {
              offer.levels = offer.templateId.levels;
              offer.revision = offer.templateId.revision;
            }

            bidObj[_i].offers.push(source[j]);
          }
        }
      }

      $scope.bidPackages = bidObj;
      $scope.bidPackages.forEach(function (bid) {
        bid.offers.forEach(function (offer) {
          offer.selectedGroup = {
            name: "All",
            levels: []
          };

          if (offer.groups) {
            offer.groups.forEach(function (group) {
              offer.selectedGroup.levels = offer.selectedGroup.levels.concat(group.levels);
            });
          }

          $log.log('selected group = ', offer.selectedGroup);
        });
      });
      $scope.$apply();
    };

    $scope.fetchSuppliers = function () {
      $scope.isLoading = true;
      apiFactory.getAllSuppliers({}).then(function (res) {
        $scope.isLoading = false;
        $scope.vendorList = res.data.list;
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchSuppliers();

    $scope.calcItemAmount = function (item) {
      item.amount = utils.num(item.quantity) * utils.num(item.unitPrice);
    }; // calc offer


    $scope.calcOfferDays = function (offer) {
      var days = 0;
      offer.groups.forEach(function (group) {
        group.levels.forEach(function (lv) {
          days += utils.num(lv.days);
        });
      });
      return days;
    };

    $scope.calcOfferQuantity = function (offer) {
      var cnt = 0;
      offer.groups.forEach(function (group) {
        group.levels.forEach(function (lv) {
          cnt += utils.num(lv.quantity);
        });
      });
      return cnt;
    };

    $scope.calcOfferUnitPrice = function (offer) {
      var cnt = 0;
      offer.groups.forEach(function (group) {
        group.levels.forEach(function (lv) {
          cnt += utils.num(lv.quantity);
        });
      });
      var cnt1 = 0;
      offer.groups.forEach(function (group) {
        group.levels.forEach(function (lv) {
          cnt1 += utils.num(lv.amount);
        });
      });
      if (cnt1 == 0) return 0;
      return cnt1 / cnt;
    };

    $scope.calcOfferAmount = function (offer) {
      var cnt = 0;
      offer.groups.forEach(function (group) {
        group.levels.forEach(function (lv) {
          cnt += utils.num(lv.amount);
        });
      });
      return cnt;
    };

    $scope.calcLevelAmount = function (lv) {
      lv.amount = lv.quantity * lv.unitPrice;
    }; // calc bid


    $scope.calcBest = function (bid) {
      var mun = 0;
      bid.offers.forEach(function (offer) {
        if (offer.status == 'Accepted') {
          mun++;
        }
      });
      return mun;
    };

    $scope.getSysTag = function (bid) {
      $log.log(bid);
    };

    $scope.getCollaborator = function (bid) {
      var mun = "";
      var cnt = 0;
      bid.offers.forEach(function (offer) {
        if (offer.status == 'Accepted') {
          $log.log(offer);
          if (offer.supplierId && cnt == 0) mun += offer.supplierId.name;else if (offer.subcontractorId && cnt == 0) mun += offer.subcontractorId.name;
          cnt++;
        }
      });
      if (cnt <= 2) return mun;else return mun + " +" + (cnt - 1);
    };

    $scope.getBidStaffs = function (bid) {
      var mun = "";
      var cnt = 0;
      bid.offers.forEach(function (offer) {
        if (offer.status == "Accepted") {
          if (cnt == 0 && offer.staffId) mun += offer.staffId.displayName;
          cnt++;
        }
      });
      if (cnt <= 2) return mun;else return mun + " +" + (cnt - 1);
    };

    $scope.calcBidLevels = function (bid) {
      var value = 0;
      bid.offers.forEach(function (offer) {
        offer.groups.forEach(function (group) {
          value = group.levels.length;
        });
      });
      return value;
    };

    $scope.calcBidDays = function (bid) {
      var average = 0;
      var cnt = 0;
      bid.offers.forEach(function (offer) {
        if (offer.status == "Accepted") {
          cnt++;
          offer.groups.forEach(function (group) {
            group.levels.forEach(function (lv) {
              average += utils.num(lv.days);
            });
          });
        }
      });
      if (average == 0) return 0;
      return average / cnt;
    };

    $scope.calcBidQuantity = function (bid) {
      var sum = 0;
      bid.offers.forEach(function (offer) {
        if (offer.status == "Accepted") {
          offer.groups.forEach(function (group) {
            group.levels.forEach(function (lv) {
              sum += utils.num(lv.quantity);
            });
          });
        }
      });
      return sum;
    };

    $scope.calcGroupQuantity = function (group) {
      var sum = 0;
      group.levels.forEach(function (lv) {
        sum += utils.num(lv.quantity);
      });
      return sum;
    };

    $scope.calcGroupDays = function (group) {
      var total = 0;
      group.levels.forEach(function (lv) {
        total += utils.num(lv.days);
      });
      return total;
    };

    $scope.calcGroupOfferAmount = function (group) {
      var sum = 0;
      group.levels.forEach(function (lv) {
        sum += utils.num(lv.amount);
      });
      return sum;
    };

    $scope.calcBidUnitPrice = function (bid) {
      var cnt = 0;
      bid.offers.forEach(function (offer) {
        if (offer.status == "Accepted") {
          offer.groups.forEach(function (group) {
            group.levels.forEach(function (lv) {
              cnt += utils.num(lv.quantity);
            });
          });
        }
      });
      var cnt1 = 0;
      bid.offers.forEach(function (offer) {
        if (offer.status == "Accepted") {
          offer.groups.forEach(function (group) {
            group.levels.forEach(function (lv) {
              cnt1 += utils.num(lv.amount);
            });
          });
        }
      });
      if (cnt1 == 0 || cnt == 0) return 0;
      return cnt1 / cnt;
    };

    $scope.calcBidOfferAmount = function (bid) {
      var sum = 0;
      bid.offers.forEach(function (offer) {
        if (offer.status == "Accepted") {
          offer.groups.forEach(function (group) {
            group.levels.forEach(function (lv) {
              sum += utils.num(lv.amount);
            });
          });
        }
      });
      return sum;
    };

    $scope.getBidStatus = function (bid) {
      var flag1 = 0,
          flag2 = 0;
      bid.offers.forEach(function (offer) {
        if (offer.status == 'Accepted') flag1 = 1;
        if (offer.status == 'Decliended') flag2 = 1;
      });
      if (flag1) return 'Accepted';else if (flag2) return 'Decliended';else return 'Paused';
    };

    $scope.getStaff = function (id) {
      var staff = null;
      $scope.vendorList.forEach(function (v) {
        v.staffs.forEach(function (s) {
          if (s._id == id) staff = s;
        });
      });
      if (staff) return staff;
      $scope.subcontactors.forEach(function (v) {
        v.staffs.forEach(function (s) {
          if (s._id == id) staff = s;
        });
      }); // if(staff)

      return staff;
    };

    $scope.attachExcelFiles = function (offer) {
      angular.element('#fileSelector').triggerHandler('click');
      $scope.currentOffer = offer;
    };

    $scope.SelectFile = function (file) {
      $scope.SelectedFile = file;
      $scope.Upload($scope.currentOffer);
    };

    $scope.Upload = function (tempoffer) {
      $log.log($scope.SelectedFile.name);
      $log.log('offer = ', tempoffer);
      var regex = /^(.*)+(.xls|.xlsx)$/;

      if (regex.test($scope.SelectedFile.name.toLowerCase())) {
        if (angular.isDefined(typeof FileReader === "undefined" ? "undefined" : _typeof(FileReader))) {
          var reader = new FileReader(); //For Browsers other than IE.

          if (reader.readAsBinaryString) {
            reader.onload = function (e) {
              $scope.ProcessExcel(e.target.result, tempoffer);
            };

            reader.readAsArrayBuffer($scope.SelectedFile);
          } else {
            //For IE Browser.
            reader.onload = function (e) {
              var data = "";
              var bytes = new Uint8Array(e.target.result);

              for (var i = 0; i < bytes.byteLength; i++) {
                data += String.fromCharCode(bytes[i]);
              }

              $scope.ProcessExcel(data, tempoffer);
            };

            reader.readAsArrayBuffer($scope.SelectedFile);
          }
        } else {
          Notification.error("This browser does not support HTML5.");
        }
      } else {
        Notification.error("Please upload a valid Excel file.");
      }
    };

    $scope.ProcessExcel = function (data, tempOffer) {
      //Read the Excel File data.
      // var workbook = XLSX.read(data, {
      //     type: 'binary'
      // });
      // //Fetch the name of First Sheet.
      // var firstSheet = workbook.SheetNames[0];
      // //Read all rows from First Sheet into an JSON array.
      // var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
      // $log.log('rows = ', excelRows) ;
      var workbook = XLSX.read(data, {
        type: "array"
      });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      var json = XLSX.utils.sheet_to_json(worksheet, {
        header: 1
      });
      $log.log(json);
      var vendorType = tempOffer.bidPackageId.vendorType;
      var ary = [];
      json.forEach(function (d, idx) {
        if (idx == 0 || idx == 1 || !d.length || d[0] == 'SUM') {
          return;
        } // if (idx != 0) {


        ary.push({
          name: d[0],
          size: d[3],
          level: d[2],
          days: vendorType ? d[6] : d[5],
          // supplier_days: d[5],
          // subcontractor_days: d[6],
          amount: d[10],
          unit: d[8],
          quantity: d[7],
          unitPrice: d[9],
          type: d[1],
          description: d[4]
        }); // }
      });
      $log.log('ary = ', ary); //Display the data from Excel file in Table.

      $scope.$apply(function () {
        if (ary.length != tempOffer.selectedGroup.levels.length) {
          Notification.error("Uploaded successfully, but the excel data has different column or row count.");
        } else {
          tempOffer.selectedGroup.levels.forEach(function (lv, index) {
            lv.days = ary[index].days;
            lv.quantity = ary[index].quantity;
            lv.unitPrice = ary[index].unitPrice;
            lv.amount = ary[index].amount;
          });
        }
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('collaborationInvites', {
    controller: collaborationInvitesController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/collaborationInvites/collaborationInvites.view.html'
  });
  /** @ngInject */

  function collaborationInvitesController($log, globals, $scope, utils, $state, apiFactory, Notification, $element, $uibModal, FileSaver) {
    var vm = this;
    $scope.utils = utils;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.projectData = projectStore.get();
    vm.searchText = '';
    $scope.currentPartnerType = 'Subcontractor';
    $scope.currentTab = "Suppliers";
    $scope.vendorList = [];
    $scope.subcontactors = [];
    $scope.selectedVendor = null;
    $scope.selectedStaff = null;
    $scope.offertemplates = [];
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    vm.currentPage = 1;
    $scope.totalCount = 0;
    $scope.numPerPage = 12;

    $scope.getManagerDashboardDesignation = function (dashboardType) {
      var userType = Constants.UserTypeList.find(function (x) {
        return x.dashboardType === dashboardType;
      });

      if (!userType) {
        return 'Manager';
      }

      return userType.name;
    };

    $scope.exportToExcel = function (bidPackageId) {
      $log.log(bidPackageId);
      $uibModal.open({
        animation: true,
        component: 'fileNameModal',
        windowClass: 'file-name-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function (result) {
        var fileName = result.toLowerCase().includes('.xlsx') || result.toLowerCase().includes('.xls') ? result : result + '.xlsx';
        var query = {
          fileName: fileName,
          bidPackageId: bidPackageId // search: vm.searchText

        };
        $scope.isLoading = true;
        apiFactory.downloadOfferTemplatesExcel(query).then(function (res) {
          $log.log(res);
          $scope.isLoading = false;
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, fileName);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err, 'Failed to export excel file'));
        });
      }, function () {});
    };

    $scope.invite = function () {};

    $scope.searchData = function () {
      $scope.fetchData();
    };

    $scope.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.currentPage = 1;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      $scope.loading = true;
      apiFactory.getBidPackages({
        projectId: vm.projectData._id,
        search: vm.searchText,
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        vendorType: $scope.currentTab == "Suppliers" ? '0' : '1'
      }).then(function (res) {
        $scope.loading = false;
        $scope.offertemplates = res.data.list;
        $scope.totalCount = res.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.getCompanyList = function (id, index) {
      var p = $scope.offertemplates.find(function (b) {
        return b._id == id;
      });
      if (!p.invited) return '';
      var vList = $scope.vendorList.filter(function (v) {
        return v._id == index;
      });
      var nameList = vList.map(function (c) {
        return c.name;
      });
      var ret = nameList.length > 0 ? nameList[0] : '';
      if (ret != '') return ret;
      vList = $scope.subcontactors.filter(function (v) {
        return v._id == index;
      });
      nameList = vList.map(function (c) {
        return c.name;
      });
      return ret = nameList.length > 0 ? nameList[0] : '';
    };

    $scope.removeCompany = function (p, cid) {
      if (p) {
        if (!p.invited) p.invited = [];
        var rc = $scope.vendorList.find(function (c) {
          return c._id == cid;
        });
        if (!rc || rc.length == 0) rc = $scope.subcontactors.find(function (c) {
          return c._id == cid;
        });
        var removeusers = [];
        p.invitedStaffs.forEach(function (lv) {
          rc.staffs.forEach(function (s) {
            if (s._id == lv) removeusers.push(s._id);
          });
        });
        p.invited = p.invited.filter(function (s) {
          return s != cid;
        });
        if (!p.invitedStaffs) p.invitedStaffs = [];

        var _loop = function _loop(i) {
          p.invitedStaffs = p.invitedStaffs.filter(function (s) {
            return s != removeusers[i];
          });
        };

        for (var i = 0; i < removeusers.length; i++) {
          _loop(i);
        }

        $scope.loading = true;
        apiFactory.updateBidInvite(p).then(function () {
          var filter = {
            bidPackageId: p._id,
            vendorId: cid,
            vendorType: $scope.currentTab == "Suppliers" ? '0' : '1'
          };
          apiFactory.deleteBidPackageInvite(filter).then(function () {
            $scope.isLoading = false;
            Notification.success("Removed Successfully");
          })["catch"](function (err) {
            $scope.isLoading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
          $scope.loading = false;
          $scope.fetchData();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        }); // $scope.$apply();
      }
    };

    $scope.getStaff = function (id) {
      var staff = null;
      $scope.vendorList.forEach(function (v) {
        v.staffs.forEach(function (s) {
          if (s._id == id) staff = s;
        });
      });
      if (staff) return staff;
      $scope.subcontactors.forEach(function (v) {
        v.staffs.forEach(function (s) {
          if (s._id == id) staff = s;
        });
      });
      if (staff) return staff;
    };

    $scope.fetchSuppliers = function () {
      $scope.loading = true;
      apiFactory.getAllSuppliers({}).then(function (res) {
        $scope.loading = false;
        $scope.vendorList = res.data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.fetchSubcontractors = function () {
      $scope.currentTab = 'Sub-contractors';
      $scope.loading = true;
      apiFactory.getAllSubcontractors({
        search: $scope.searchText
      }).then(function (res) {
        $scope.loading = false;
        $scope.subcontactors = res.data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $element.on('dragover', function (event) {
      event.preventDefault();
    });
    $element.on('drop', function (event) {
      event.preventDefault();

      if (event.target.getAttribute('ref') == 'drop-zone') {
        var offerId = event.target.getAttribute('ref-id');
        $log.log('offerId = ', offerId);
        var p = $scope.offertemplates.find(function (b) {
          return b._id == offerId;
        });
        $log.log('template = ', p);

        if (p) {
          var updateFlag = false;
          $log.log('selectedVendor = ', $scope.selectedVendor);

          if ($scope.selectedVendor) {
            if (!p.invited) p.invited = [];
            var c = p.invited.find(function (c) {
              return c == $scope.selectedVendor._id;
            });

            if (!c) {
              p.invited.push($scope.selectedVendor._id);
              updateFlag = true;
            } else {
              updateFlag = false;
              Notification.warning("Already Invited");
              return;
            }

            $log.log('updateFlag = ', updateFlag);

            if ($scope.selectedStaff) {
              if (!p.invitedStaffs) p.invitedStaffs = [];
              var s = p.invitedStaffs.filter(function (s) {
                return s == $scope.selectedStaff._id;
              });

              if (!s || s.length == 0) {
                p.invitedStaffs.push($scope.selectedStaff._id);
                updateFlag = true;
              } else {
                updateFlag = false;
                Notification.warning("Already Invited");
                return;
              }
            }
          }

          if (updateFlag) {
            $scope.loading = true;
            var selectedstaffid = $scope.selectedStaff._id;
            var selectedcomid = $scope.selectedVendor._id;
            apiFactory.updateBidInvite(p).then(function (resp) {
              var template = resp.data;
              var offer = {
                bidPackageId: template.bidPackageId,
                companyId: template.companyId,
                projectId: template.projectId,
                templateId: template._id,
                // levels: template.levels ? template.levels : [],
                groups: template.groups ? template.groups : [],
                vendorType: template.vendorType,
                revision: template.revision
              };

              if ($scope.currentTab == "Suppliers") {
                offer.supplierId = selectedcomid;
              } else {
                offer.subcontractorId = selectedcomid;
              }

              offer.staffId = selectedstaffid;
              apiFactory.createCollaborationOffer(offer).then(function () {
                $scope.isLoading = false;
                Notification.success("Invited Successfully");
              })["catch"](function (err) {
                $scope.isLoading = false;
                $log.error(err);
                Notification.error(utils.getErrorMessage(err));
              });
              $scope.loading = false;
              $scope.fetchData();
            })["catch"](function (err) {
              $scope.loading = false;
              $log.error(err);
              Notification.error(utils.getErrorMessage(err));
            });
          }
        } else {
          Notification.error("No offer template");
        }

        $scope.selectedVendor = null;
        $scope.selectedStaff = null;
      }
    });
    $element.on('dragstart', function (event) {
      if ($scope.currentTab == "Suppliers") {
        $scope.selectedVendor = $scope.vendorList.find(function (v) {
          return v._id == event.target.getAttribute('vId');
        });
        $scope.selectedStaff = $scope.selectedVendor ? $scope.selectedVendor.staffs.find(function (s) {
          return s._id == event.target.getAttribute('sId');
        }) : undefined;
      } else {
        $scope.selectedVendor = $scope.subcontactors.find(function (v) {
          return v._id == event.target.getAttribute('vId');
        });
        $scope.selectedStaff = $scope.selectedVendor ? $scope.selectedVendor.staffs.find(function (s) {
          return s._id == event.target.getAttribute('sId');
        }) : undefined;
      }

      $scope.$apply();
    });
    var colors = ["#FFB900", "#D83B01", "#B50E0E", "#E81123", "#B4009E", "#5C2D91", "#0078D7", "#00B4FF", "#008272", "#107C10"];

    $scope.getColor = function (name) {
      if (!name) {
        return;
      }

      name = name.replace(/"/g, '');
      var chars = name.split(' ');
      var codeNum = 0;

      if (chars.length < 2) {
        if (chars[0][0]) {
          codeNum = chars[0].charCodeAt(0);
        }
      } else {
        if (chars[0][0]) {
          codeNum = chars[0].charCodeAt(0);
        }

        if (chars[1][0]) {
          codeNum += chars[1].charCodeAt(0);
        }
      }

      return colors[codeNum % colors.length];
    };

    function init() {
      if (!vm.projectData || vm.projectData._id === 'all') {
        Notification.error('Please select project first.');
        $state.go(globals.getDashboardRoute(vm.userData));
        return;
      } // $scope.fetchData();


      $scope.fetchSuppliers();
      $scope.fetchSubcontractors();
    }

    init();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('bidPackages', {
    controller: BidPackagesController,
    controllerAs: 'vm',
    templateUrl: 'app/main/collaborations/bidPackages/bidPackages.view.html'
  });
  /** @ngInject */

  function BidPackagesController($scope, $uibModal, $state, globals, apiFactory, $log, Notification, utils) {
    var vm = this;
    $scope.utils = utils;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.projectData = projectStore.get();
    $scope.TEAM_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.TEAM_ACCESS_CREATE = 4;
    // } else {
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.TEAM]})
    //     .then(res => {
    //       $scope.TEAM_ACCESS_CREATE = res.data.data[Constants.AccessKey.TEAM];
    //     })
    //     .catch((e) => {
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    vm.currentPage = 1;
    $scope.totalCount = 0;
    $scope.numPerPage = 12;
    $scope.noOfPages = 1;
    $scope.totalCount = 10;
    vm.bidPackages = [];

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.deleteBidPackage = function (bidPackage) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        apiFactory.deleteBidPackage(bidPackage._id).then(function () {
          Notification.success("".concat(bidPackage.title, " removed successfully."));
          $scope.fetchData();
        })["catch"](function (err) {
          $log.error(err);
          Notification.error("Failed to remove!");
        });
      }, function () {});
    };

    $scope.selectAllBidPackages = function () {
      vm.bidPackages.forEach(function (x) {
        x.selected = $scope.selectedAll;
      });
    };

    $scope.selectBidPackage = function (bidPackage) {
      if (!bidPackage.selected) {
        $scope.selectedAll = false;
      }

      if (vm.bidPackages.map(function (x) {
        return x.selected ? 1 : 0;
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) === vm.bidPackages.length) {
        $scope.selectedAll = true;
      }
    };

    $scope.workTypes = function (workTypes) {
      return workTypes.map(function (x) {
        return x.tagName;
      }).join(", ");
    };

    $scope.searchBidPackages = function () {
      vm.currentPage = 1;
      $scope.fetchData();
    };

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      $scope.fetchData();
    };

    $scope.fetchData = function () {
      $scope.loading = true;
      apiFactory.getBidPackages({
        projectId: vm.projectData._id,
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText
      }).then(function (res) {
        $scope.loading = false;
        vm.bidPackages = res.data.list;
        $scope.totalCount = res.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    $scope.gotoEditBidPackage = function (id) {
      $state.go('editBidPackage', {
        id: id
      });
    };

    $scope.gotoEditOfferTemplate = function (id) {
      $state.go('editOfferTemplate', {
        id: id
      });
    };

    $scope.fetchWorkTypes = function () {
      apiFactory.getWorkTypes().then(function (res) {
        $scope.loading = false;
        vm.workTypes = res.data.list;
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }; // init


    $scope.fetchData();
    $scope.fetchWorkTypes();
  }
})();


"use strict";

/* eslint-disable no-unused-vars */
(function () {
  'use strict';

  angular.module('app').component('clientsGrid', {
    controller: clientsGridController,
    controllerAs: 'vm',
    templateUrl: 'app/main/clients/clientsGrid/clientsGrid.view.html'
  });
  /** @ngInject */

  function clientsGridController($scope, apiFactory, $state, utils, globals, $log, Notification) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.CLIENT_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.CLIENT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.CLIENT]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.CLIENT_ACCESS_CREATE = res.data.data[Constants.AccessKey.CLIENT];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.utils = utils;
    $scope.periods = [{
      id: '12',
      name: '12'
    }, {
      id: '24',
      name: '24'
    }, {
      id: '48',
      name: '48'
    }];
    $scope.labelChecked = false;
    $scope.clients = [];
    $scope.totalCount = 0; // $scope.numPerPage = globals.numPerPage();

    $scope.numPerPage = 12;
    $scope.noOfPages = 0;
    vm.currentPage = 1;
    vm.searchText = undefined;
    vm.sortMenuList = [{
      label: 'Name',
      key: 'clientName'
    }, {
      label: 'Created Date',
      key: 'created'
    }, {
      label: 'Modified Date',
      key: 'updatedAt'
    }, {
      label: 'Client Tag',
      key: 'systemTag'
    }];
    vm.sortMenu = "created";
    $scope.isLoading = false;
    $scope.isGrid = true;

    vm.fetchAllClients = function () {
      $scope.isLoading = true;
      apiFactory.listAllClients({
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        sort: vm.sortMenu,
        sortType: "false"
      }).then(function (resp) {
        $scope.isLoading = false;
        $scope.clients = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function () {
        $scope.isLoading = false;
      });
    };

    vm.fetchAllClients();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.fetchAllClients();
    };

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.fetchAllClients();
    };

    $scope.goToDetail = function (clientId) {
      $state.go('clientsDetail', {
        id: clientId
      });
    };

    $scope.setAllChecked = function () {
      $scope.labelChecked = !$scope.labelChecked;
      $scope.clients.map(function (item) {
        item.checked = $scope.labelChecked;
      });
    };

    $scope.getColor = function (name) {
      return globals.getAvatarColor(name);
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('clientsEdit', {
    controller: ClientsEditController,
    controllerAs: 'vm',
    templateUrl: 'app/main/clients/clientsEdit/clientsEdit.view.html'
  });
  /** @ngInject */

  function ClientsEditController($scope, $stateParams, apiFactory, globals, Notification, $state, utils, $log, $uibModal) {
    var vm = this;
    vm.utils = utils; //get client data including stuff

    vm.userData = globals.userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    }; // image and file upload funtion -start


    vm.inputImg = [];
    vm.inputFiles = [];
    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x, _index) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    vm.clientId = $stateParams.id;
    var companyStore = globals.companyStore;
    vm.companyData = companyStore.get();
    $scope.paymentConditions = vm.companyData.paymentConditions;
    $scope.staff = {
      mobile: {
        dialCode: null,
        phoneNumber: null
      },
      firstName: null,
      lastName: null,
      email: null
    };

    function getClientDetail() {
      $scope.isLoading = true;
      apiFactory.getClientById(vm.clientId).then(function (resp) {
        $scope.isLoading = false;
        $scope.clientData = resp.data.data;
        $log.log($scope.clientData);
        $scope.staffList = angular.copy($scope.clientData.staffs) || [];
        $scope.clientData.line1 = $scope.clientData.address[0].line1;
        $scope.clientData.line2 = $scope.clientData.address[0].line2;
        $scope.clientData.city = $scope.clientData.address[0].city;
        $scope.clientData.postalCode = $scope.clientData.address[0].postalCode / 1;
        $scope.clientData.countryCode = $scope.clientData.address[0].countryCode;
        $scope.FILEIMG = $scope.clientData.clientLogo;
        $scope.clientData.clientContact.phoneNumber = parseInt($scope.clientData.clientContact.phoneNumber);

        if (resp.data.data.bankDetails != null && resp.data.data.bankDetails.length > 0) {
          $scope.bank = resp.data.data.bankDetails[0];
        }

        $scope.clientData.yearFounded /= 1;
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    }

    getClientDetail();
    globals.getCountryCode().then(function (resp) {
      vm.countryCodes = resp.data;
      vm.countryCodes = vm.countryCodes.map(function (x) {
        return {
          name: x.name,
          dialCode: x.dialCode,
          code: x.code,
          dialCodeName: "".concat(x.dialCode, " (").concat(x.name, ")")
        };
      });
    });
    globals.getIndustry().then(function (resp) {
      vm.getIndustries = resp.data;

      vm.loadIndustry = function () {
        return new Promise(function (resolve) {
          resolve(resp.data);
        });
      };
    });
    globals.getCurrency().then(function (resp) {
      vm.getCurrencies = resp.data;

      vm.loadCurrency = function () {
        return new Promise(function (resolve) {
          resolve(resp.data);
        });
      };
    });
    globals.getCountryCode().then(function (resp) {
      $scope.dialCodes = resp.data;
    }, function () {});

    $scope.onChange = function (files) {
      if (angular.isUndefined(files[0])) return;
      $scope.FILEIMG = URL.createObjectURL(files[0]);
      $scope.fileExt = files[0].name.split('.').pop();
    };

    $scope.addStaff = function (staff) {
      var messages = [];
      var reg = /\S+@\S+\.\S+/;

      if (!reg.test(staff.email)) {
        messages[messages.length] = 'Enter valid email';
      }

      if (!staff.mobile.dialCode) {
        messages[messages.length] = 'Select dial code';
      }

      if (!staff.mobile.phoneNumber || staff.mobile.phoneNumber.length <= 6) {
        messages[messages.length] = 'Enter valid phone number';
      }

      if (utils.isEmpty(staff.firstName)) {
        messages.push('Please input first name');
      }

      if (utils.isEmpty(staff.lastName)) {
        messages.push('Please input last name');
      } // if (utils.isEmpty(staff.password)) {
      //   messages.push('Please input password');
      // }
      // if (utils.isEmpty(staff.confirmPassword)) {
      //   messages.push('Please confirm password');
      // }


      if (!utils.isEmpty(staff.password) && !utils.isEmpty(staff.confirmPassword) && staff.password != staff.confirmPassword) {
        messages.push('Confirm password is not correct');
      }

      if (messages.length > 0) {
        messages.forEach(function (v) {
          Notification.error(v);
        });
        return;
      }

      $scope.staffList.push(staff);
      $scope.staff = {
        firstName: null,
        lastName: null,
        email: null,
        mobile: {
          dialCode: null,
          phoneNumber: null
        }
      };
    };

    $scope.deleteStaff = function (index, staff) {
      if (staff._id) {
        $scope.isLoading = true;
        apiFactory.isInvitedStaff({
          userId: staff._id
        }).then(function (res) {
          $scope.isLoading = false;
          var isInvitedUser = res.data.data;

          if (isInvitedUser) {
            var confirmModal = $uibModal.open({
              animation: true,
              component: 'confirmModal',
              size: 'sm',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                data: function data() {
                  return {
                    title: 'Confirm delete staff',
                    message: 'Are you sure you want to delete this staff?',
                    subMessage: 'This staff has already been invited as a collaboration member',
                    confirmButtonText: 'Delete',
                    icon: '/assets/icons/status-warning.svg'
                  };
                }
              }
            });
            confirmModal.result.then(function () {
              $scope.staffList.splice(index, 1);
            });
          } else {
            $scope.staffList.splice(index, 1);
          }
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      } else {
        $scope.staffList.splice(index, 1);
      }
    };

    $scope.editStaff = function (_staff) {
      $uibModal.open({
        animation: true,
        component: 'editStaffModal',
        windowClass: 'edit-staff-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          staff: function staff() {
            return _staff;
          }
        }
      }).result.then(function (result) {
        _staff.firstName = result.firstName;
        _staff.lastName = result.lastName;
        _staff.email = result.email;
        _staff.mobile = angular.copy(result.mobile);
      }, function () {});
    }; // edit client data


    $scope.updateClient = function () {
      var clientData = $scope.clientData;
      var client = {};

      if ($scope.picFile) {
        client.clientLogo = $scope.picFile;
      }

      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);
      client.clientName = $scope.clientData.clientName;

      if (utils.isEmpty(client.clientName)) {
        Notification.error('Please enter company name');
        return;
      }

      if (angular.isUndefined(clientData) || clientData === null) {
        Notification.error('Please fill out the required information');
        return;
      }

      if (utils.isEmpty(clientData.clientContact.phoneNumber) || utils.isEmpty(clientData.clientContact.dialCode)) {
        Notification.error('Please enter phone details');
        return;
      } else {
        client.clientContact = clientData.clientContact;
      }

      var reg = /\S+@\S+\.\S+/;

      if (!reg.test(clientData.email)) {
        Notification.error('Enter valid email');
        return;
      } else {
        client.email = clientData.email;
      }

      client.address = [];
      client.address = [{
        line1: clientData.line1,
        line2: clientData.line2,
        city: clientData.city,
        postalCode: clientData.postalCode,
        countryCode: clientData.countryCode
      }];

      if (!clientData.industry) {
        Notification.error('Please enter industry');
        return;
      }

      client.industry = clientData.industry[0];

      if (angular.isDefined(clientData.yearFounded)) {
        client.yearFounded = clientData.yearFounded;
      }

      if (angular.isDefined(clientData.clientWebsite)) {
        client.clientWebsite = clientData.clientWebsite;
      }

      client.files = $scope.imgAndFiles;
      client.staffList = $scope.staffList;

      if (utils.isEmpty(client.staffList)) {
        Notification.error("Please add staff at least one");
        return;
      }

      if (clientData.staffs) {
        client.removedStaffs = [];

        var _iterator = _createForOfIteratorHelper(clientData.staffs),
            _step;

        try {
          var _loop = function _loop() {
            var oldStaff = _step.value;
            var find = client.staffList.find(function (x) {
              return x._id === oldStaff._id;
            });

            if (!find) {
              client.removedStaffs.push(oldStaff._id);
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } //add payment data


      if (angular.isUndefined(clientData.paymentTerms)) {
        Notification.error('Please select payment terms');
        return;
      }

      if (!clientData.paymentTerms.paymentSetting) {
        Notification.error('Please select payment setting');
        return;
      }

      if (clientData.paymentTerms.vatPercent === null || angular.isUndefined(clientData.paymentTerms.vatPercent)) {
        Notification.error('Please input vatPercent');
        return;
      }

      if (!clientData.paymentTerms.vatNumber) {
        Notification.error('Please input vatNumber');
        return;
      }

      client.paymentTerms = clientData.paymentTerms;
      client.bankDetails = [$scope.bank];
      $scope.isLoading = true;
      $log.log(client);
      apiFactory.updateClientById(client, vm.clientId).then(function () {
        $scope.isLoading = false;
        $state.go('clientsDetail', {
          id: vm.clientId
        });
        Notification.success('Member Updated successfully.');
      })["catch"](function (error) {
        $scope.isLoading = false;
        if (error.data && error.data.message) Notification.error(error.data.message);else Notification.error('could not update client.');
      });
    };

    $scope.removeStaff = function (index) {
      $scope.staffList.splice(index, 1);
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('clientsDetail', {
    controller: ClientsDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/clients/clientsDetail/clientsDetail.view.html'
  });
  /** @ngInject */

  function ClientsDetailController($scope, apiFactory, Notification, globals, $stateParams, $state, $uibModal, $log, utils) {
    var vm = this;
    vm.utils = utils;
    vm.clientId = $stateParams.id;
    var companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.CLIENT_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.CLIENT_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.CLIENT]
    //   }).then(res => {
    //     $scope.isLoading = false;
    //     $scope.CLIENT_ACCESS_CREATE = res.data.data[Constants.AccessKey.CLIENT];
    //   })
    //   .catch((e) => {
    //     $scope.isLoading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    vm.companyData = companyStore.get();
    vm.editMode = false;
    $scope.paymentConditions = vm.companyData.paymentConditions;
    $scope.projectStatus = ['Offer', 'Ongoing', 'Completed'];

    function getClientDetail() {
      $scope.isLoading = true;
      apiFactory.getClientById(vm.clientId).then(function (resp) {
        $scope.isLoading = false;
        $scope.clientData = resp.data.data;
        $log.log($scope.clientData);
        $scope.clientData.firstName = $scope.clientData.clientName.split(/(\s+)/)[0];
        $scope.clientData.middleName = $scope.clientData.clientName.split(/(\s+)/)[2];
        $scope.clientData.lastName = $scope.clientData.clientName.split(/(\s+)/)[4];
        $scope.clientData.staffs = $scope.clientData.staffs || [];
        $scope.terms = $scope.clientData.paymentTerms;

        if ($scope.terms) {
          $scope.terms.paymentSetting = $scope.paymentConditions.find(function (x) {
            return x._id == $scope.terms.paymentSetting;
          });
        }

        if (resp.data.data.bankDetails != null && resp.data.data.bankDetails.length > 0) {
          var bank = resp.data.data.bankDetails[0];
          $scope.accountHolderName = bank.accountHolderName;
          $scope.accountNumber = bank.accountNumber;
          $scope.IBAN = bank.IBAN;
          $scope.bankName = bank.bankName;
          $scope.bankAddress = bank.bankAddress;
          $scope.sortCode = bank.sortCode;
          $scope.routingNo = bank.routingNo;
          $scope.bicCode = bank.bicCode;
          $scope.ifscCode = bank.ifscCode;
          $scope.routingCode = bank.routingCode;
        }
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
      });
    }

    getClientDetail();

    $scope.onChangeEdit = function (files) {
      if (angular.isUndefined(files[0])) return;
      $scope.EditFILEIMG = URL.createObjectURL(files[0]);
      $scope.EditfileExt = files[0].name.split('.').pop();
    };

    $scope.deleteClient = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function (result) {
        if (result) {
          $scope.isLoading = true;
          apiFactory.deleteClientById(vm.clientId).then(function () {
            $scope.isLoading = false;
            $state.go('clientsGrid');
            Notification.success('Client deleted successfully');
          })["catch"](function (e) {
            $scope.isLoading = false;
            $log.error(e);
            Notification.error('Something went wrong try later');
          });
        }
      }, function (reason) {
        $log.log(reason);
      });
    };
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app').component('clientsAdd', {
    controller: ClientsAddController,
    controllerAs: 'vm',
    templateUrl: 'app/main/clients/clientsAdd/clientsAdd.view.html'
  });
  /** @ngInject */

  function ClientsAddController($scope, apiFactory, Notification, globals, $state, utils, $uibModal) {
    var vm = this;
    vm.userData = globals.userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.staff = {
      firstName: null,
      lastName: null,
      email: null,
      mobile: {
        dialCode: null,
        phoneNumber: null
      }
    };
    globals.getCountryCode().then(function (resp) {
      vm.countryCodes = resp.data;
      vm.countryCodes = vm.countryCodes.map(function (x) {
        return {
          name: x.name,
          dialCode: x.dialCode,
          code: x.code,
          dialCodeName: "".concat(x.dialCode, " (").concat(x.name, ")")
        };
      });
    });
    globals.getIndustry().then(function (resp) {
      vm.getIndustries = resp.data;

      vm.loadIndustry = function () {
        return new Promise(function (resolve) {
          resolve(resp.data);
        });
      };
    });
    globals.getCurrency().then(function (resp) {
      vm.getCurrencies = resp.data;

      vm.loadCurrency = function () {
        return new Promise(function (resolve) {
          resolve(resp.data);
        });
      };
    }); // image and file upload funtion -start

    vm.inputImg = [];
    vm.inputFiles = [];
    vm.uploadImg = [];
    vm.uploadFiles = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x, _index) {
        x.description = '';

        if (modal == 'image') {
          if (vm.uploadImg.length == 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name == y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error('File name already exist');
            }
          }
        } else {
          if (vm.uploadFiles.length == 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name == y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error('File name already exist');
            }
          }
        }

        $scope.FILEIMG = URL.createObjectURL(vm.uploadImg[0]);
      });
    };

    var companyStore = globals.companyStore;
    vm.companyData = companyStore.get();
    $scope.paymentConditions = vm.companyData.paymentConditions;

    $scope.createClient = function (clientdata) {
      var client = {};
      $scope.imgAndFiles = [].concat(vm.uploadImg, vm.uploadFiles);

      if (utils.isEmpty(clientdata)) {
        Notification.error('Please fill out the required information');
        return;
      }

      if (utils.isEmpty(clientdata.clientName)) {
        Notification.error('Please enter name details');
        return;
      }

      client.clientName = clientdata.clientName;

      if (utils.isEmpty(clientdata.phoneNumber) || utils.isEmpty(clientdata.dialCode)) {
        Notification.error('Please enter phone details');
        return;
      } else {
        client.clientContact = {
          dialCode: clientdata.dialCode,
          phoneNumber: clientdata.phoneNumber
        };
      }

      var reg = /\S+@\S+\.\S+/;

      if (!reg.test(clientdata.email)) {
        Notification.error('Enter valid email');
        return;
      } else {
        client.email = clientdata.email;
      }

      if (utils.isEmpty(clientdata.address)) {
        Notification.error('Please enter address');
        return;
      }

      if (utils.isEmpty(clientdata.city)) {
        Notification.error('Please enter city');
        return;
      }

      if (utils.isEmpty(clientdata.postalCode)) {
        Notification.error('Please enter postalCode');
        return;
      }

      if (utils.isEmpty(clientdata.countryCode)) {
        Notification.error('Please enter country');
        return;
      }

      client.address = [];
      client.address.push({
        line1: clientdata.address,
        line2: clientdata.address1,
        city: clientdata.city,
        postalCode: clientdata.postalCode,
        countryCode: clientdata.countryCode
      });

      if (utils.isEmpty(clientdata.industry)) {
        Notification.error('Please enter industry');
        return;
      }

      client.industry = clientdata.industry;

      if (angular.isDefined(clientdata.yearFounded)) {
        client.yearFounded = clientdata.yearFounded;
      }

      if (angular.isDefined(clientdata.clientWebsite)) {
        client.clientWebsite = clientdata.clientWebsite;
      }

      client.files = $scope.imgAndFiles;
      client.staffList = $scope.staffList;

      if (utils.isEmpty(client.staffList)) {
        Notification.error("Please add staff at least one");
        return;
      } //add payment data


      if (angular.isUndefined(!clientdata.paymentTerms)) {
        Notification.error('Please select payment terms');
        return;
      }

      if (!clientdata.paymentTerms) {
        Notification.error('Enter Terms');
        return;
      } else {
        if (!clientdata.paymentTerms.paymentSetting) {
          Notification.error('Please select payment setting');
          return;
        }

        if (clientdata.paymentTerms.vatPercent === null || angular.isUndefined(clientdata.paymentTerms.vatPercent)) {
          Notification.error('Please input vatPercent');
          return;
        }

        if (!clientdata.paymentTerms.vatNumber) {
          Notification.error('Please input vatNumber');
          return;
        }
      }

      client.paymentTerms = clientdata.paymentTerms;
      client.bankDetails = [{
        accountHolderName: $scope.accountHolderName,
        accountNumber: $scope.accountNumber,
        IBAN: $scope.IBAN,
        bankName: $scope.bankName,
        bankAddress: $scope.bankAddress,
        sortCode: $scope.sortCode,
        routingNo: $scope.routingNo,
        bicCode: $scope.bicCode,
        ifscCode: $scope.ifscCode,
        routingCode: $scope.routingCode
      }];
      $scope.isLoading = true;
      apiFactory.createClient(client).then(function () {
        $scope.isLoading = false;
        vm.clientdata = {};
        Notification.success('Client created successfully');
        $state.go('clientsGrid');
      })["catch"](function (error) {
        $scope.isLoading = false;
        Notification.error(utils.getErrorMessage(error), 'Something went wrong');
      });
    };

    $scope.staffList = [];

    $scope.addStaff = function (staff) {
      var messages = [];
      var reg = /\S+@\S+\.\S+/;

      if (!reg.test(staff.email)) {
        messages[messages.length] = 'Enter valid email';
      }

      if (!staff.mobile.dialCode) {
        messages[messages.length] = 'Select dial code';
      }

      if (!staff.mobile.phoneNumber || staff.mobile.phoneNumber.length <= 6) {
        messages[messages.length] = 'Enter valid phone number';
      }

      if (utils.isEmpty(staff.firstName)) {
        messages.push('Please input first name');
      }

      if (utils.isEmpty(staff.lastName)) {
        messages.push('Please input last name');
      }

      if (messages.length > 0) {
        messages.forEach(function (v) {
          Notification.error(v);
        });
        return;
      }

      $scope.staffList.push(staff);
      $scope.staff = {
        firstName: null,
        lastName: null,
        email: null,
        mobile: {
          dialCode: null,
          phoneNumber: null
        }
      };
    };

    $scope.removeStaff = function (index) {
      $scope.staffList.splice(index, 1);
    };

    $scope.editStaff = function (_staff) {
      $uibModal.open({
        animation: true,
        component: 'editStaffModal',
        windowClass: 'edit-staff-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          staff: function staff() {
            return _staff;
          }
        }
      }).result.then(function (result) {
        _staff.firstName = result.firstName;
        _staff.lastName = result.lastName;
        _staff.email = result.email;
        _staff.mobile = angular.copy(result.mobile);
      }, function () {});
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('companyCalendar', {
    controller: CompanyCalendarController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calendar/company/companyCalendar.view.html'
  });
  /** @ngInject */

  function CompanyCalendarController($scope, $log, $uibModal, apiFactory, Notification, globals, $state, pdfFactory) {
    /* Requiring vars */
    var vm = this;
    var userStore = globals.userStore;
    var userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(userData));
    };

    vm.filterOptions = [{
      _id: "category_projects",
      name: "Projects",
      children: []
    }, {
      _id: "category_employee_type",
      name: "Type of Work",
      children: [{
        name: "Manager",
        checked: true
      }, {
        name: "Employee",
        checked: true
      }]
    }, {
      _id: "category_teams",
      name: "Teams",
      children: [{
        name: "Team1",
        checked: true
      }, {
        name: "Team2",
        checked: true
      }]
    }];
    vm.data = [];
    vm.managers = [];
    vm.employees = [];
    vm.schedules = [];
    vm.date = new Date();
    vm.range = getWeekRange(vm.date);
    $scope.viewStyle = 'day';
    $scope.isLoading = true;
    $scope.isCollapse = false;
    $scope.calendars = [{
      _id: 0,
      name: 'Teams',
      children: [{
        name: 'Design Team',
        color: '#2FA84F',
        checked: true
      }, {
        name: 'QA Team',
        color: '#F3A72E',
        checked: true
      }, {
        name: 'Marketing Team',
        color: '#813AC8',
        checked: true
      }, {
        name: 'Development Team',
        color: '#D71414',
        checked: true
      }, {
        name: 'Productivity Team',
        color: '#367BF5',
        checked: true
      }]
    }, {
      _id: 1,
      name: 'Designation',
      children: [{
        name: 'Program Manager',
        color: '#A3A3A3',
        checked: true
      }, {
        name: 'Trainee Engineer',
        color: '#A3A3A3',
        checked: true
      }]
    }];
    Promise.all([apiFactory.listAllOngoingProjects(), apiFactory.listAllManagers(), apiFactory.getAllEmployees({
      isActive: true
    }), apiFactory.listAllSchedules()]).then(function (resp) {
      $scope.isLoading = false;
      var projects = resp[0].data.list || [];
      var managers = resp[1].data.list;
      var workers = resp[2].data.list;
      vm.schedules = resp[3].data.list || [];
      projects.forEach(function (project) {
        project.name = project.projectName;
        project.checked = true;
      });
      vm.filterOptions[0].children = projects;

      if (managers) {
        managers.forEach(function (manager) {
          vm.managers.push({
            memberId: manager._id,
            displayName: manager.displayName,
            email: manager.email,
            profilePic: manager.profilePic,
            role: 'Manager',
            schedules: []
          });
        });
      }

      if (workers) {
        workers.forEach(function (worker) {
          vm.employees.push({
            memberId: worker._id,
            displayName: worker.displayName,
            email: worker.email,
            profilePic: worker.profilePic,
            role: 'Employee',
            schedules: []
          });
        });
      }

      vm.schedules.forEach(function (schedule) {
        return setSchedule(schedule);
      });
      var data = []; //data.pushAll(vm.managers);

      data.pushAll(vm.employees);
      vm.data = data;
    })["catch"](function (err) {
      $log.error(err);
      $scope.isLoading = false;
    });

    $scope.selectViewStyle = function (style) {
      $scope.viewStyle = style;

      if (style == 'week') {
        vm.range = getWeekRange(vm.date);
      } else if (style == 'month') {
        vm.range = getMonthRange(vm.date);
      }
    };

    vm.addSchedule = function () {
      $uibModal.open({
        animation: true,
        component: 'scheduleModal',
        windowClass: 'schedule-modal',
        resolve: {
          members: function members() {
            return {
              managers: vm.managers,
              employees: vm.employees
            };
          }
        }
      }).result.then(function (result) {
        if (result) {
          vm.schedules.push(result);
          setSchedule(result);
          refreshData();
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.editSchedule = function (schedule) {
      $uibModal.open({
        animation: true,
        component: 'scheduleModal',
        windowClass: 'schedule-modal',
        resolve: {
          members: function members() {
            return {
              managers: vm.managers,
              employees: vm.employees
            };
          },
          id: function id() {
            return schedule._id;
          }
        }
      }).result.then(function (result) {
        if (result) {
          var index = vm.schedules.findIndex(function (x) {
            return x._id === result._id;
          });

          if (index !== -1) {
            vm.schedules[index] = result;
          }

          setSchedule(result, true);
          refreshData();
        } else {
          var _index = vm.schedules.findIndex(function (x) {
            return x._id === schedule._id;
          });

          if (_index !== -1) {
            deleteSchedule(vm.schedules[_index]);
            vm.schedules.splice(_index, 1);
          }
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.changeFilter = function (item, option) {
      if (option._id === "category_employee_type") {
        var data = [];

        if (vm.filterOptions[1].children[0].checked) {
          data.pushAll(vm.managers);
        }

        if (vm.filterOptions[1].children[1].checked) {
          data.pushAll(vm.employees);
        }

        vm.data = data;
      }
    };

    vm.goPrevious = function () {
      var date = new Date(vm.date);

      switch ($scope.viewStyle) {
        case "day":
          date.setDate(date.getDate() - 1);
          break;

        case "week":
          date.setDate(date.getDate() - 7);
          vm.range = getWeekRange(date);
          break;

        case "month":
          date.setMonth(date.getMonth() - 1); //date.setFullYear(date.getFullYear() - 1);

          vm.range = getMonthRange(date);
          break;
      }

      vm.date = date;
    };

    vm.goNext = function () {
      var date = new Date(vm.date);

      switch ($scope.viewStyle) {
        case "day":
          date.setDate(date.getDate() + 1);
          break;

        case "week":
          date.setDate(date.getDate() + 7);
          vm.range = getWeekRange(date);
          break;

        case "month":
          date.setMonth(date.getMonth() + 1); //date.setFullYear(date.getFullYear() + 1);

          vm.range = getMonthRange(date);
          break;
      }

      vm.date = date;
    };

    vm.goToday = function () {
      vm.date = new Date();

      if (vm.viewStyle == 'week') {
        vm.range = getWeekRange(vm.date);
      } else if (vm.viewStyle == 'month') {
        vm.range = getMonthRange(vm.date);
      }
    };

    function getWeekRange(date) {
      var current = new Date(date);
      var first = current.getDate() - current.getDay();
      var last = first + 6;
      return {
        first: new Date(current.setDate(first)),
        last: new Date(current.setDate(last))
      };
    }

    function getMonthRange(date) {
      var first = new Date(date.getFullYear(), date.getMonth(), 1);
      var last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return {
        first: first,
        last: last
      };
    }

    vm.publish = function () {
      pdfFactory.exportCalendar('calendar', angular.element('#scheduler')[0]);
    };

    function setSchedule(schedule) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      schedule.members.forEach(function (member) {
        var members = getMembersByRole(member.role);
        if (!members) return;
        var find = members.find(function (x) {
          return x.memberId === member.memberId;
        });

        if (update && find) {
          find.schedules.pop();
        }

        if (find) {
          find.schedules.push({
            _id: schedule._id,
            name: schedule.name,
            description: schedule.description,
            startDate: new Date(schedule.startDate),
            endDate: new Date(schedule.endDate),
            type: schedule.type
          });
        }
      });
    }

    function deleteSchedule(schedule) {
      schedule.members.forEach(function (member) {
        var members = getMembersByRole(member.role);
        if (!members) return;
        var find = members.find(function (x) {
          return x.memberId === member.memberId;
        });

        if (find) {
          var index = find.schedules.findIndex(function (x) {
            return x._id === schedule._id;
          });

          if (index !== -1) {
            find.schedules.splice(index, 1);
          }
        }
      });
      refreshData();
    }

    function getMembersByRole(role) {
      switch (role) {
        case "Manager":
          return vm.managers;

        case "Employee":
          return vm.employees;

        default:
          return null;
      }
    }

    function refreshData() {
      var data = [];
      data.pushAll(vm.data);
      vm.data = data;
    }

    var isToday = function isToday(someDate) {
      var today = new Date();
      return someDate.getDate() == today.getDate() && someDate.getMonth() == today.getMonth() && someDate.getFullYear() == today.getFullYear();
    };

    var side_calendar = new dhx.Calendar("side_calendar", {
      range: true,
      width: '280',
      // disabledDates: function(date) {
      //   if (isToday(date))
      //     return false;
      //   else
      //     return date < new Date();
      // },
      mark: function mark(date) {
        if (isToday(date)) {
          return "highlight-date";
        }
      }
    });
    side_calendar.events.on("Change", function () {
      var tdate = side_calendar.getValue(true);

      if (angular.isDefined(tdate[0])) {
        vm.deadlineFromDate = tdate[0];
      } else {
        vm.deadlineFromDate = null;
      }

      if (angular.isDefined(tdate[1])) {
        vm.deadlineToDate = tdate[1];
      } else {
        vm.deadlineToDate = null;
      }

      $scope.$apply();
      $scope.onChangeFilterDate();
    });

    $scope.onExpand = function (index) {
      if ($scope.calendars[index].expanded === 'undefined') {
        $scope.calendars.map(function (item) {
          item.expanded = false;
        });
      }

      $scope.calendars[index].expanded = !$scope.calendars[index].expanded;
    };

    $scope.onChangeFilterDate = function () {// if (isToday(vm.deadlineFromDate)) {
      //   vm.deadlineFromDate = new Date();
      // }
      // else {
      //   vm.deadlineFromDate.setHours(0, 0, 0, 0);
      // }
      // if (!utils.isEmpty(vm.deadlineToDate)) {
      //   vm.deadlineToDate.setHours(23,59,59,999);
      // }
      // if (!utils.isEmpty(vm.deadlineToDate) && vm.deadlineFromDate > vm.deadlineToDate) {
      //   Notification.error("Invalid Start and End Time.");
      //   return;
      // }
      // initData();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('companyBudget', {
    controller: CompanyBudgetController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/companyBudget/companyBudget.view.html'
  });

  function CompanyBudgetController($scope, $state, $stateParams, $log, $uibModal, apiFactory, ecoFactory, globals, localStorageService, utils, Notification) {
    var vm = this;
    var companyStore = globals.companyStore;
    var companyData = companyStore.get();
    vm.isEdited = false;
    vm.years = [{
      year: 2015
    }, {
      year: 2016
    }, {
      year: 2017
    }, {
      year: 2018
    }, {
      year: 2019
    }, {
      year: 2020
    }, {
      year: 2021
    }, {
      year: 2022
    }, {
      year: 2023
    }, {
      year: 2024
    }, {
      year: 2025
    }, {
      year: 2026
    }, {
      year: 2027
    }, {
      year: 2028
    }, {
      year: 2029
    }, {
      year: 2030
    }, {
      year: 2031
    }, {
      year: 2032
    }, {
      year: 2033
    }, {
      year: 2034
    }, {
      year: 2035
    }, {
      year: 2036
    }, {
      year: 2037
    }, {
      year: 2038
    }, {
      year: 2039
    }, {
      year: 2040
    }, {
      year: 2041
    }, {
      year: 2042
    }, {
      year: 2043
    }, {
      year: 2044
    }, {
      year: 2045
    }];
    vm.dates = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    vm.year = getYear();
    vm.sections = [];
    vm.budgets = [];
    vm.summaries = [];
    vm.totalValues = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    vm.totalSum = 0;
    globals.getCurrency().then(function (resp) {
      var currency = resp.data.find(function (element) {
        return element.cc === companyData.currentCurrency.currencyCode;
      });
      vm.currency = currency.symbol;
    })["catch"](function (err) {
      $log.error(err);
    });
    $scope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (!toState.redirectTo && vm.isEdited) {
        event.preventDefault();
        $uibModal.open({
          animation: true,
          component: 'alertModal',
          size: 'sm',
          resolve: {
            title: function title() {
              return 'Warning';
            },
            message: function message() {
              return 'You have unsaved edit. Do you want to save?';
            },
            positive: function positive() {
              return 'Save';
            }
          }
        }).result.then(function () {
          save().then(function () {
            $state.go(toState, toParams);
          });
        }, function (reason) {
          if (reason === 'cancel') {
            vm.isEdited = false;
            $state.go(toState, toParams);
          }
        });
      }
    });

    vm.selectYear = function () {
      vm.isEdited = false;
      vm.budgets = [];
      vm.sections = [];
      $scope.isLoading = true;
      apiFactory.getCompanyBudget(vm.year).then(function (resp) {
        $scope.isLoading = false;

        if (resp.data.data && resp.data.data.sections) {
          vm.sections = resp.data.data.sections;
          vm.summaries = resp.data.data.summaries || [];
          vm.sections.forEach(function (section) {
            section.budgets.forEach(function (budget) {
              return vm.budgets.push(budget);
            });
            calcSummaries(section);
            calcPercents(section);
          });
          vm.summaries.forEach(function (summary) {
            return calcSummary(summary);
          });
          calcTotal();
          loadDynamicForecastData();
        } else {
          vm.editTemplate();
        }
      })["catch"](function (err) {
        $log.error(err);
        Notification.error('Cannot get company budget');
        $scope.isLoading = false;
      });
    };

    vm.editTemplate = function () {
      localStorageService.set('company-budget-year', vm.year);
      $state.go('companyBudgetTemplate');
    };

    vm.setFocus = function (budget) {
      budget.focus = true;
    };

    vm.changeBudgetValue = function (section, budget) {
      vm.isEdited = true;
      budget.focus = false;
      budget.sum = budget.values.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
      calcPercent(budget);
      calcSummaries(section);
      calcTotal();
    };

    vm.save = function () {
      save();
    };

    vm.selectYear();

    function getYear() {
      var year = localStorageService.get('company-budget-year');
      return year ? utils.num(year) : new Date().getFullYear();
    }

    function calcPercents(section) {
      if (section.budgets) {
        section.budgets.forEach(function (budget) {
          return calcPercent(budget);
        });
      }
    }

    function calcPercent(budget) {
      if (budget.children) {
        budget.children.forEach(function (child) {
          if (child.values && child.values.length > 11) {
            for (var i = 0; i < 12; i++) {
              var value = utils.num(budget.values[i]);
              var childValue = utils.num(child.values[i].amount);
              child.values[i].percent = value === 0 ? 0 : childValue * 100 / value;
            }
          }
        });
      }
    }

    function calcSummaries(section) {
      section.summaries.forEach(function (summary) {
        return calcSummary(summary);
      });
    }

    function calcSummary(summary) {
      summary.values = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      var budgets = [];
      summary.equation.fields.forEach(function (field) {
        var budget = vm.budgets.find(function (x) {
          return x.index === field.index;
        });

        if (budget) {
          if (field.childIndex) {
            if (budget.children && budget.children[field.childIndex - 1]) {
              budgets.push({
                child: budget.children[field.childIndex - 1],
                operator: field.operator
              });
            }
          } else {
            budgets.push({
              budget: budget,
              operator: field.operator
            });
          }
        }
      });

      if (budgets && budgets.length > 0) {
        if (summary.equation.type === 'math') {
          budgets.forEach(function (item) {
            if (item.operator === '-') {
              if (item.child) {
                for (var i = 0; i < 12; i++) {
                  summary.values[i] -= item.child.values[i].amount;
                }
              } else {
                for (var _i = 0; _i < 12; _i++) {
                  summary.values[_i] -= item.budget.values[_i];
                }
              }
            } else {
              if (item.child) {
                for (var _i2 = 0; _i2 < 12; _i2++) {
                  summary.values[_i2] += item.child.values[_i2].amount;
                }
              } else {
                for (var _i3 = 0; _i3 < 12; _i3++) {
                  summary.values[_i3] += item.budget.values[_i3];
                }
              }
            }
          });
        } else {
          budgets.forEach(function (item) {
            if (item.child) {
              for (var i = 0; i < 12; i++) {
                summary.values[i] += item.child.values[i].amount;
              }
            } else {
              for (var _i4 = 0; _i4 < 12; _i4++) {
                summary.values[_i4] += item.budget.values[_i4];
              }
            }
          });

          if (summary.equation.type === 'avg') {
            for (var i = 0; i < 12; i++) {
              summary.values[i] /= budgets.length;
            }
          }
        }
      }

      summary.sum = summary.values.reduce(utils.sumReducer, 0);
    }

    function calcTotal() {
      vm.totalValues = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      vm.totalSum = 0;
      vm.sections.forEach(function (section) {
        section.budgets.forEach(function (budget) {
          for (var i = 0; i < 12; i++) {
            vm.totalValues[i] += budget.values[i];
            vm.totalSum += budget.values[i];
          }
        });
      });
    }

    function loadDynamicForecastData() {
      $scope.isLoading = true;
      apiFactory.listAllOngoingProjects().then(function (resp) {
        var projects = resp.data.list;
        var projectIds = projects.map(function (project) {
          return project._id;
        });
        apiFactory.queryTasks({
          projects: projectIds,
          calcSheet: true
        }).then(function (resp) {
          $scope.isLoading = false;
          var tasks = resp.data.list;
          var forecastData = {
            inventory: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            labor: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            sales: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            total: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          };
          fillForecastValues(forecastData, tasks); // setDynamicForcast(vm.sections[0], dynamicData.invoice, forecastData.sales);

          setForcast('Labour Cost', forecastData.labor);
          setForcast('Expenses', forecastData.inventory);
          setForcast('Finans Cost', forecastData.total);
          vm.sections.forEach(function (section) {
            calcSummaries(section);
            calcPercents(section);
          });
          vm.summaries.forEach(function (summary) {
            return calcSummary(summary);
          });
          calcTotal();
        })["catch"](function (err) {
          $log.error(err);
          $scope.isLoading = false;
        });
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }

    function fillForecastValues(forecast, tasks) {
      tasks.forEach(function (task) {
        if (!task.startDate || !task.endDate) return;
        var inventory = utils.num(task.inventoryPrice);
        var labor = utils.num(task.laborPrice);
        if (inventory === 0 && labor === 0) return;
        var range = makeDateRange();

        for (var i = 0; i < 12; i++) {
          var startDate = new Date(task.startDate);
          var endDate = new Date(task.endDate);
          var duration = utils.getDurationInRange(startDate, endDate, range.begin, range.end);
          var taskDuration = endDate.getTime() - startDate.getTime();

          if (duration > 0) {
            forecast.inventory[i] += taskDuration === 0 ? inventory : inventory * duration / taskDuration;
            forecast.labor[i] += taskDuration === 0 ? labor : labor * duration / taskDuration;
            forecast.sales[i] += forecast.inventory[i] + forecast.labor[i];
          }

          range.begin.addMonths(1);
          range.end.addMonths(1);
        }
      });
    }

    function makeDateRange() {
      var begin = new Date();
      begin.setFullYear(vm.year, 0, 1);
      begin.setHours(0, 0, 0, 0);
      var end = new Date();
      end.setFullYear(vm.year, 0, 31);
      end.setHours(23, 59, 59, 999);
      return {
        begin: begin,
        end: end
      };
    }

    function setForcast(sectionName, forecast) {
      var section = vm.sections.find(function (x) {
        return x.type === 'expense' && x.name === sectionName;
      });

      if (section && section.budgets[1] && section.budgets[1].children.length > 1) {
        var forecastChild = section.budgets[1].children[1];

        for (var i = 0; i < 12; i++) {
          forecastChild.values[i].amount = forecast[i];
          forecastChild.sum += forecast[i];
        }

        calcSummaries(section);
      }
    }

    function save() {
      return new Promise(function (resolve, reject) {
        apiFactory.saveCompanyBudget({
          year: vm.year,
          sections: vm.sections,
          summaries: vm.summaries
        }).then(function () {
          vm.isEdited = false;
          Notification.success('Company budget is saved successfully.');
          resolve();
        })["catch"](function (err) {
          $log.error(err);
          Notification.error('Failed to save!');
          reject(err);
        });
      });
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('calcMain', {
    controller: CalcMainController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/calcMain/calcMain.view.html'
  });

  function CalcMainController($scope, $state, apiFactory, Notification, globals, $log, $uibModal, FileSaver, utils) {
    /* Requiring vars */
    var vm = this;
    var projectStore = globals.projectStore,
        companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.CALC_ACCESS_CREATE = 10; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.CALC_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.CALC]
    //   })
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.CALC_ACCESS_CREATE = res.data.data[Constants.AccessKey.CALC];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    /* Get project list */

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    vm.projectId = vm.project._id;
    vm.companyData = companyStore.get();
    $scope.isLoading = true;
    vm.isEdited = false;
    vm.costPercents = [];
    vm.extraCosts = [];
    vm.lastVersion = {};
    vm.levelDepth = 0;
    $scope.tableInventory = [];
    $scope.levelId = 0;
    $scope.totalProfit = 0;
    $scope.totalWorkingHours = 0;
    $scope.totalCostPrice = 0;
    $scope.totalCompanyCost = 0;
    $scope.hierarchicalCostSeqLast = 0;
    vm.openBreadCumb = false;
    vm.currentStateList = [];
    vm.workTypes = [];
    vm.workLevels = [];
    vm.materials = [];
    vm.buildingparts = [];
    vm.dcps = [];
    vm.equipments = [];
    vm.dcqs = [];
    vm.workers = [];
    vm.subcontractors = [];
    vm.deletedModels = [];
    vm.deletedInventories = [];
    apiFactory.getCalcSheetCount(vm.projectId).then(function (res) {
      if (res.data.mainCnt > 0) {
        Notification.error('This project has MAIN estimate, will switch to MAIN estimate.');
        $state.go('calcExtra');
      }

      Promise.all([apiFactory.getWorkLevelAndTypes(), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getEconomicSettingInvoiceItems(), apiFactory.getAllSubcontractors(), apiFactory.getCalcSheet(vm.projectId), apiFactory.listAllItems()]).then(function (resp) {
        vm.workLevels = resp[0].data.data.workLevels;
        vm.workTypes = resp[0].data.data.workTypes;
        vm.materials = resp[1].data.list;
        vm.dcps = resp[2].data.list;
        vm.equipments = resp[3].data.list;
        vm.dcqs = resp[4].data.list;
        vm.workers = resp[5].data.data.filter(function (item) {
          return item.category === "Labor";
        });
        vm.subcontractors = resp[6].data.list;
        loadSheet(resp[7].data.data);
        vm.buildingparts = resp[8].data.list;
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error(e);
      });
    })["catch"](function (e) {
      $log.error(e);
    });
    $scope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (!toState.redirectTo && vm.isEdited) {
        event.preventDefault();
        $uibModal.open({
          animation: true,
          component: 'alertModal',
          size: 'sm',
          resolve: {
            title: function title() {
              return 'Warning';
            },
            message: function message() {
              return 'You have unsaved edit. Do you want to save?';
            },
            positive: function positive() {
              return 'Save';
            }
          }
        }).result.then(function () {
          if (checkEmptyItemOnSheet()) {
            var customPath = vm.emptyCustomPaths[0];
            Notification.error({
              message: 'Please fill empty fields or remove it. <br/>Path: ' + customPath
            });
            return;
          }

          saveSheet().then(function () {
            $state.go(toState, toParams);
          });
        }, function (reason) {
          if (reason === 'cancel') {
            vm.isEdited = false;
            $state.go(toState, toParams);
          }
        });
      }
    });

    vm.gotoVersion = function () {
      $state.go('calVersions');
    };

    vm.addNewGroup = function () {
      $scope.sideIconNum = 1;
      $uibModal.open({
        animation: true,
        component: 'newGroupModal',
        windowClass: 'new-group-modal',
        backdrop: 'static',
        keyboard: false
      }).result.then(function (result) {
        $scope.sideIconNum = 0;
        $scope.tableInventory.push({
          id: ++$scope.levelId,
          name: result,
          items: [],
          levels: [],
          sum: 0,
          sumHours: 0,
          sumProfit: 0,
          sumCompanyCost: 0,
          sumCostPrice: 0,
          sumInventoryCost: 0,
          sumWorkerCost: 0,
          isEdit: false,
          isSelected: true,
          selectedFor: vm.costPercents
        });
        vm.isEdited = true;
      }, function (reason) {
        $scope.sideIconNum = 0;
        $log.info(reason);
      });
    };

    vm.deleteRootLevel = function (level) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        $scope.totalSum = $scope.totalSum - level.sum;
        var index = $scope.tableInventory.indexOf(level);
        $scope.tableInventory.splice(index, 1);
        findSums();
        vm.isEdited = true;
        addModelToDeletedInventories(level);
      }, function (reason) {
        $log.info(reason);
      });
    };

    vm.deleteSubLevel = function (index, array, outindex) {
      if (!array[index].sum) {
        var level = array[index];
        array.splice(index, 1);
        addLevelToDeletedInventories(level);
      } else {
        if (vm.openBreadCumb) {
          var _level = array[index];
          vm.currentStateList.forEach(function (tree) {
            tree.sumCostPrice = tree.sumCostPrice - array[index].sumCostPrice;
            tree.sumHours = tree.sumHours - array[index].sumHours;
            tree.sumCompanyCost = tree.sumCompanyCost - array[index].sumCompanyCost;
            tree.sumProfit = tree.sumProfit - array[index].sumProfit;
            tree.sum = tree.sum - array[index].sum;
          });
          $scope.totalSum = $scope.totalSum - array[index].sum;
          array.splice(index, 1);
          addLevelToDeletedInventories(_level);
        } else {
          var _level2 = $scope.tableInventory[outindex];
          $scope.tableInventory[outindex].sumCostPrice = $scope.tableInventory[outindex].sumCostPrice - array[index].sumCostPrice;
          $scope.tableInventory[outindex].sumHours = $scope.tableInventory[outindex].sumHours - array[index].sumHours;
          $scope.tableInventory[outindex].sumCompanyCost = $scope.tableInventory[outindex].sumCompanyCost - array[index].sumCompanyCost;
          $scope.tableInventory[outindex].sumProfit = $scope.tableInventory[outindex].sumProfit - array[index].sumProfit;
          $scope.tableInventory[outindex].sum = $scope.tableInventory[outindex].sum - array[index].sum;
          $scope.totalSum = $scope.totalSum - array[index].sum;
          array.splice(index, 1);
          addModelToDeletedInventories(_level2);
        }
      }

      findSums();
      refreshSheet();
      vm.isEdited = true;
    };

    vm.deleteItem = function (item) {
      vm.onUpdateItem();
      addItemToDeletedInventories(item);
    };

    vm.onUpdateItem = function (item, field, oldVal, parent) {
      if (item) {
        calcRow(item);
        checkRow(item);
        oldVal = utils.num(oldVal);

        if (item.items) {
          updateRowItems(item, field, oldVal);
        }

        if (parent) {
          updateParentRow(item, field, oldVal, parent);
        }
      }

      refreshSheet();
      vm.isEdited = true;
    };

    vm.onItemChanged = function () {
      vm.isEdited = true;
    };

    vm.changeBreadCrumb = function (index) {
      if (checkEmptyItemOnCurrentState()) {
        Notification.error('Please fill empty fields or remove it.');
        return;
      }

      vm.currentState = vm.currentStateList[index];
      vm.currentStateList = vm.currentStateList.slice(0, index + 1);
      vm.levelDepth = vm.currentStateList.length;
    };

    vm.callBreadCrumb = function (mainIndex, innerindex, subLevel) {
      if (!subLevel.name) {
        Notification.error("Please input level or type");
        return;
      }

      vm.openBreadCumb = true;
      vm.breadCrumbIndex = mainIndex;
      var current = $scope.tableInventory[mainIndex];
      vm.currentStateList.push(current);
      vm.currentState = subLevel;
      vm.currentStateList.push(vm.currentState);
      vm.levelDepth = vm.currentStateList.length;
    };

    vm.callBreadCrumbSubLevel = function (mainIndex, index, subLevel) {
      if (!subLevel.name) {
        Notification.error("Please input level or type");
        return;
      }

      vm.currentState = subLevel;
      vm.currentStateList.push(vm.currentState);
      vm.levelDepth = vm.currentStateList.length;
    };

    vm.goToRoot = function () {
      vm.openBreadCumb = false;
      vm.currentStateList = [];
      vm.levelDepth = vm.currentStateList.length;
    };

    $scope.downloadCalcSheet = function () {
      $scope.sideIconNum = 3;

      if (angular.isDefined(vm.calcSheetId)) {
        apiFactory.downloadCalcSheetExcel(vm.calcSheetId).then(function (resp) {
          var blob = new Blob([resp.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          FileSaver.saveAs(blob, "calc.xlsx");
        })["catch"](function (e) {
          $log.error(e);
        });
      } else {
        Notification.error("Requested calc sheet is not saved in database. please save before you export");
      }
    };

    $scope.removeAdditionalCost = function (percent) {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      });
      confirmModal.result.then(function () {
        deleteAdditionalCost(percent);
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.onRefreshSheet = function () {
      $scope.isLoading = true;
      apiFactory.getCalcSheet(vm.projectId).then(function (resp) {
        loadSheet(resp.data.data);
        vm.goToRoot();
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
        Notification.error('There is error during load calculation.');
      });
    }; // Open Add Cost Modal


    $scope.openAddCostConfig = function () {
      $uibModal.open({
        animation: true,
        component: 'addCostModal',
        backdrop: 'static',
        keyboard: false,
        windowClass: 'add-cost-modal',
        resolve: {
          isEdit: function isEdit() {
            return false;
          },
          costData: function costData() {
            return {
              tableInventory: $scope.tableInventory,
              costPercents: vm.costPercents,
              hierarchicalCostSeqLast: $scope.hierarchicalCostSeqLast
            };
          }
        }
      }).result.then(function (result) {
        vm.costPercents = result.costPercents;
        vm.extraCosts = vm.costPercents ? vm.costPercents.filter(function (it) {
          return it.type === 'global';
        }) : [];
        refreshSheet();
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.openEditCostConfig = function (percent) {
      $uibModal.open({
        animation: true,
        component: 'addCostModal',
        backdrop: 'static',
        keyboard: false,
        windowClass: 'add-cost-modal',
        resolve: {
          isEdit: function isEdit() {
            return true;
          },
          costData: function costData() {
            return {
              tableInventory: $scope.tableInventory,
              costPercents: vm.costPercents,
              hierarchicalCostSeqLast: $scope.hierarchicalCostSeqLast,
              currentCost: percent
            };
          }
        }
      }).result.then(function (result) {
        if (result.type === 'update') {
          vm.costPercents = result.costPercents;
          vm.extraCosts = vm.costPercents ? vm.costPercents.filter(function (it) {
            return it.type === 'global';
          }) : [];
          refreshSheet();
        } else {
          deleteAdditionalCost(percent);
        }
      }, function (reason) {
        $log.info(reason);
      });
    }; // Open Config Modal


    $scope.openConfigModal = function () {
      $scope.sideIconNum = 5;
      $uibModal.open({
        animation: true,
        component: 'configModal',
        windowClass: 'calc-config-modal',
        resolve: {
          data: function data() {
            return {
              workerCost: vm.workerCost,
              profit: vm.globalProfit
            };
          }
        }
      }).result.then(function (result) {
        var changed = false;

        if (result.workerCost !== vm.workerCost) {
          changed = true;
          vm.workerCost = result.workerCost;
        }

        if (result.profit !== vm.globalProfit) {
          changed = true;
          vm.globalProfit = result.profit;
          $scope.tableInventory.map(function (group) {
            setProfitToLevel(group, vm.globalProfit);
          });
        }

        if (changed) {
          vm.isEdited = true;
          refreshSheet();
        }
      });
    }; // Open Organize Modal


    $scope.openOrganizeModal = function () {
      $scope.sideIconNum = 6;
      $uibModal.open({
        animation: true,
        component: 'organizeModal',
        windowClass: 'calc-organize-modal',
        resolve: {
          data: function data() {
            return $scope.tableInventory;
          }
        }
      }).result.then(function (result) {
        vm.isEdited = true;
        $scope.tableInventory = result;
        refreshSheet();
      }, function (reason) {
        $log.log(reason);
      });
    }; // Open Structure Modal


    $scope.openStructureModal = function () {
      $scope.sideIconNum = 7;
      $uibModal.open({
        animation: true,
        component: 'structureModal',
        windowClass: 'calc-structure-modal',
        resolve: {
          data: function data() {
            return $scope.tableInventory;
          }
        }
      }).result.then(function (result) {
        $log.log(result);
      }, function (reason) {
        $log.log(reason);
      });
    }; // Open Version Modal


    $scope.openVersionModal = function () {
      if (checkEmptyItemOnSheet()) {
        var customPath = vm.emptyCustomPaths[0];
        Notification.error({
          message: 'Please fill empty fields or remove it. <br/>Path: ' + customPath
        });
        return;
      }

      $scope.sideIconNum = 8;
      $uibModal.open({
        animation: true,
        component: 'versionModal',
        resolve: {
          data: function data() {
            return {
              companyCurrency: $scope.companyCurrency,
              lastVersion: vm.lastVersion,
              totalCompanyCost: $scope.totalCompanyCost,
              totalCostPrice: $scope.totalCostPrice,
              totalProfit: $scope.totalProfit,
              totalWorkingHours: $scope.totalWorkingHours,
              totalSum: $scope.totalSum
            };
          }
        }
      }).result.then(function (result) {
        vm.versionMessage = result;
        saveSheet();
      }, function (reason) {
        $log.log(reason);
      });
    };

    function loadSheet(sheet) {
      if (sheet) {
        vm.calcSheetId = sheet._id; //To get sheet Id its used to export excel function.

        $scope.companyCurrency = sheet.companyCurrency;
        $scope.tableInventory = sheet.levels;
        $scope.totalSum = utils.num(sheet.sum);
        $scope.totalSumWithAdditionalCost = utils.num(sheet.sumWithAdditionalCost);
        $scope.totalProfit = sheet.totalProfit;
        $scope.totalWorkingHours = sheet.totalWorkHours;
        $scope.totalCostPrice = sheet.totalCostPrice;
        $scope.totalCompanyCost = sheet.totalCompanyCost;
        $scope.levelId = sheet.lastGroupId;
        $scope.hierarchicalCostSeqLast = sheet.hierarchicalCostSeqLast;

        if (sheet.additionalCosts.length > 0) {
          vm.costPercents = sheet.additionalCosts;

          if (vm.costPercents.length) {
            for (var l = 0; l < vm.costPercents.length; l++) {
              var adCostItem = vm.costPercents[l];

              if (adCostItem.name === 'Administrators Cost' || adCostItem.name === 'Risk Profile' || adCostItem.name === 'Company Cost') {
                adCostItem.type = 'global';
              }
            }
          }

          vm.extraCosts = vm.costPercents.filter(function (it) {
            return it.type === 'global';
          });
        }

        var maxSeqLast = 0;

        for (var i = 0; i < vm.costPercents.length; i++) {
          var costItem = vm.costPercents[i];

          if (maxSeqLast < costItem.addCostSeq) {
            maxSeqLast = costItem.addCostSeq;
          }
        }

        if ($scope.hierarchicalCostSeqLast < maxSeqLast) {
          $scope.hierarchicalCostSeqLast = maxSeqLast;
        }

        vm.workerCost = sheet.averageWorkerCost;
        vm.globalProfit = sheet.companyProfit;
        vm.lastVersion = sheet.versioning && sheet.versioning.length > 0 ? sheet.versioning[sheet.versioning.length - 1] : {};
        vm.globalCompanyCost = vm.companyData.companyCost;
      } else {
        //If new sheet to show
        $scope.companyCurrency = vm.companyData.currentCurrency;
        vm.isEdited = true;

        if (!vm.companyData.averageWorkerCost || vm.companyData.averageWorkerCost === 0) {
          $scope.openConfigModal();
        } else {
          vm.workerCost = vm.companyData.averageWorkerCost;
        }

        vm.globalCompanyCost = utils.num(vm.companyData.companyCost);
        vm.globalProfit = utils.num(vm.companyData.profit);
        $scope.tableInventory = [];
        $scope.totalSum = 0;
      }

      refreshSheet();
    }

    function saveSheet() {
      return new Promise(function (resolve, reject) {
        var sheetData = {
          companyCurrency: $scope.companyCurrency,
          projectId: vm.projectId,
          levels: $scope.tableInventory,
          sum: $scope.totalSum,
          sumWithAdditionalCost: $scope.totalSumWithAdditionalCost,
          totalProfit: $scope.totalProfit,
          totalWorkHours: $scope.totalWorkingHours,
          totalCompanyCost: $scope.totalCompanyCost,
          totalCostPrice: $scope.totalCostPrice,
          totalInventoryCost: $scope.totalInventoryCost,
          totalWorkerCost: $scope.totalWorkerCost,
          averageWorkerCost: vm.workerCost,
          additionalCosts: vm.costPercents,
          companyProfit: vm.globalProfit,
          companyCost: vm.globalCompanyCost,
          hierarchicalCostSeqLast: $scope.hierarchicalCostSeqLast,
          lastGroupId: $scope.levelId,
          versionMessage: vm.versionMessage
        };
        apiFactory.createSheet({
          sheet: sheetData,
          deletedInventories: {
            models: vm.deletedModels,
            inventories: vm.deletedInventories
          }
        }).then(function () {
          vm.isEdited = false;
          Notification.success('Calculation saved successfully.');
          resolve();
        })["catch"](function (e) {
          $log.error(e);
          Notification.error("Calculation couldn't save.");
          reject(e);
        });
      });
    }

    function refreshSheet() {
      $scope.totalSum = 0;
      $scope.totalProfit = 0;
      $scope.totalCostPrice = 0;
      $scope.totalCompanyCost = 0;
      $scope.totalWorkingHours = 0;
      $scope.totalInventoryCost = 0;
      $scope.totalWorkerCost = 0;
      $scope.tableInventory.forEach(function (group) {
        refreshLevel(group);
        $scope.totalSum += group.sum;
        $scope.totalProfit += group.sumProfit;
        $scope.totalCostPrice += group.sumCostPrice;
        $scope.totalCompanyCost += group.sumCompanyCost;
        $scope.totalWorkingHours += group.sumHours;
        $scope.totalInventoryCost += group.sumInventoryCost;
        $scope.totalWorkerCost += group.sumWorkerCost;
      });
      $scope.totalSumWithAdditionalCost = $scope.totalSum;

      if (vm.costPercents) {
        var globalPercent = 0;
        vm.extraCosts.forEach(function (item) {
          return globalPercent += utils.num(item.value);
        });
        $scope.totalSumWithAdditionalCost += $scope.totalSum * globalPercent / 100;
      }
    }

    function refreshLevel(level) {
      level.sum = 0;
      level.sumHours = 0;
      level.sumProfit = 0;
      level.sumCompanyCost = 0;
      level.sumCostPrice = 0;
      level.sumInventoryCost = 0;
      level.sumWorkerCost = 0;

      if (level.levels != null && level.levels.length > 0) {
        level.levels.forEach(function (sublevel) {
          refreshLevel(sublevel);
          level.sum += sublevel.sum;
          level.sumHours += sublevel.sumHours;
          level.sumProfit += sublevel.sumProfit;
          level.sumCompanyCost += sublevel.sumCompanyCost;
          level.sumCostPrice += sublevel.sumCostPrice;
          level.sumInventoryCost += sublevel.sumInventoryCost;
          level.sumWorkerCost += sublevel.sumWorkerCost;
        });
      }

      if (level.items) {
        var _loop = function _loop(i) {
          var item = level.items[i];

          if (item) {
            if (item.items && item.items.length > 0) {
              item.inventoryCostPrice = 0;
              item.workerCostPrice = 0;
              item.labourHours = 0;
              item.inventoryCompanyCost = 0;
              item.workerCompanyCost = 0;
              item.inventoryProfit = 0;
              item.workerProfit = 0;
              item.salesPrice = 0;
              item.workersPrice = 0;
              item.items.forEach(function (subItem) {
                calcRow(subItem);
                checkRow(subItem);
                item.inventoryCostPrice += subItem.inventoryCostPrice;
                item.workerCostPrice += subItem.workerCostPrice;
                item.labourHours += subItem.labourHours;
                item.inventoryCompanyCost += subItem.inventoryCompanyCost;
                item.workerCompanyCost += subItem.workerCompanyCost;
                item.inventoryProfit += subItem.inventoryProfit;
                item.workerProfit += subItem.workerProfit;
                item.salesPrice += subItem.salesPrice;
                item.workersPrice += subItem.workersPrice;
              });
              checkRow(item);
            } else {
              calcRow(item);
              checkRow(item);
            }

            level.sum += item.currentSalesPrice;
            level.sumHours += item.currentLabourHr;
            level.sumProfit += item.currentProfit;
            level.sumCompanyCost += item.currentCompanyCost;
            level.sumCostPrice += item.currentCostPrice;
            level.sumInventoryCost += utils.num(item.inventoryCostPrice);
            level.sumWorkerCost += utils.num(item.workerCostPrice);
          }
        };

        for (var i = 0; i < level.items.length; i++) {
          _loop(i);
        }
      }
    }

    function findSums() {
      $scope.totalProfit = 0;
      $scope.totalCostPrice = 0;
      $scope.totalCompanyCost = 0;
      $scope.totalWorkingHours = 0;
      $scope.tableInventory.map(function (table) {
        $scope.totalProfit = $scope.totalProfit + (table.sumProfit ? table.sumProfit : 0);
        $scope.totalCostPrice = $scope.totalCostPrice + (table.sumCostPrice ? table.sumCostPrice : 0);
        $scope.totalCompanyCost = $scope.totalCompanyCost + (table.sumCompanyCost ? table.sumCompanyCost : 0);
        $scope.totalWorkingHours = $scope.totalWorkingHours + (table.sumHours ? table.sumHours : 0);
      });
    }

    function updateRowItems(row, field, oldVal) {
      switch (field) {
        case 'inventoryAmount':
        case 'workerAmount':
        case 'wastePercent':
        case 'inventoryProfitPercent':
        case 'workerProfitPercent':
          for (var i = 0; i < row.items.length; i++) {
            row.items[i][field] = row[field];
            calcRow(row.items[i]);
          }

          break;

        case 'inventoryUnitPrice':
        case 'workerUnitPrice':
          for (var _i = 0; _i < row.items.length; _i++) {
            row.items[_i][field] = oldVal === 0 ? row[field] / row.items.length : row[field] * row.items[_i][field] / oldVal;
            calcRow(row.items[_i]);
          }

          break;
      }
    }

    function updateParentRow(row, field, oldVal, parent) {
      switch (field) {
        case 'inventoryAmount':
        case 'workerAmount':
          parent[field] = 0;

          for (var i = 0; i < parent.items.length; i++) {
            if (parent.items[i][field] > parent[field]) {
              parent[field] = parent.items[i][field];
            }
          }

          break;

        case 'inventoryUnitPrice':
        case 'workerUnitPrice':
          parent[field] += row[field] - oldVal;
          calcRow(parent);
          break;

        case 'wastePercent':
          if (parent.items) {
            var totalCostPrice = 0;

            for (var _i2 = 0; _i2 < parent.items.length; _i2++) {
              totalCostPrice += utils.num(parent.items[_i2].inventoryCostPrice);
            }

            var unitPrice = utils.num(parent.inventoryUnitPrice);
            var inventoryAmount = utils.num(parent.inventoryAmount);

            if (unitPrice !== 0 && inventoryAmount !== 0) {
              var wasteAmount = totalCostPrice / unitPrice - inventoryAmount;
              parent.wastePercent = wasteAmount <= 0 ? 0 : wasteAmount / inventoryAmount * 100;
            } else {
              parent.wastePercent = 0;
            }
          }

          break;

        case 'inventoryProfitPercent':
        case 'workerProfitPercent':
          parent[field] = 0;

          for (var _i3 = 0; _i3 < parent.items.length; _i3++) {
            parent[field] += parent.items[_i3][field];
          }

          parent[field] /= parent.items.length;
          break;
      }
    }

    function calcRow(row) {
      row.inventoryUnitPrice = utils.num(row.inventoryUnitPrice);
      row.workerUnitPrice = utils.num(row.workerUnitPrice);
      row.inventoryAmount = utils.num(row.inventoryAmount);
      row.workerAmount = utils.num(row.workerAmount);
      row.inventoryProfitPercent = utils.num(row.inventoryProfitPercent);
      row.workerProfitPercent = utils.num(row.workerProfitPercent);
      row.wastePercent = utils.num(row.wastePercent);
      row.wasteAmount = row.inventoryAmount * (row.wastePercent / 100);
      var matAndWaste = row.wasteAmount + row.inventoryAmount;
      row.inventoryCostPrice = matAndWaste * row.inventoryUnitPrice;
      row.workerCostPrice = row.workerAmount * row.workerUnitPrice;
      var workerCost = vm.workerCost;

      if (row.selectedFor) {
        row.selectedFor.map(function (element) {
          if (element.type !== "global") {
            if (element.applyTo === "inventory" || element.applyTo === "both") {
              var inventoryPercent = 1 + element.value / 100;
              row.inventoryCostPrice *= inventoryPercent;
            }

            if (element.applyTo === "worker" || element.applyTo === "both") {
              var workerPercent = 1 + element.value / 100;
              row.workerCostPrice *= workerPercent;
            }
          }
        });
      }

      row.labourHours = row.rowStyle === "Worker" || row.rowStyle === 'Collaborator' ? row.workerAmount : row.workerCostPrice / workerCost;
      row.salesPrice = 1 - row.inventoryProfitPercent / 100 - vm.globalCompanyCost / 100 > 0 ? row.inventoryCostPrice / (1 - row.inventoryProfitPercent / 100 - vm.globalCompanyCost / 100) : 0;
      row.workersPrice = 1 - row.workerProfitPercent / 100 - vm.globalCompanyCost / 100 > 0 ? row.workerCostPrice / (1 - row.workerProfitPercent / 100 - vm.globalCompanyCost / 100) : 0;
      row.inventoryCompanyCost = row.salesPrice * (vm.globalCompanyCost / 100);
      row.workerCompanyCost = row.workersPrice * (vm.globalCompanyCost / 100);
      row.inventoryProfit = row.salesPrice * (row.inventoryProfitPercent / 100);
      row.workerProfit = row.workersPrice * (row.workerProfitPercent / 100);
    }

    function checkRow(row) {
      if (row.rowStyle === 'Inventory') {
        row.currentLabourHr = 0;
        row.currentCostPrice = row.inventoryCostPrice;
        row.currentCompanyCost = row.inventoryCompanyCost;
        row.currentProfit = row.inventoryProfit;
        row.currentSalesPrice = row.salesPrice;
        row.workersPrice = 0;
      } else if (row.rowStyle === 'Worker') {
        row.currentLabourHr = row.labourHours;
        row.currentCostPrice = row.workerCostPrice;
        row.currentCompanyCost = row.workerCompanyCost;
        row.currentProfit = row.workerProfit;
        row.currentSalesPrice = row.workersPrice;
        row.salesPrice = 0;
      } else if (row.rowStyle === 'Collaborator') {
        row.currentLabourHr = row.labourHours;
        row.currentCostPrice = row.inventoryCostPrice;
        row.currentCompanyCost = row.inventoryCompanyCost;
        row.currentProfit = row.inventoryProfit;
        row.currentSalesPrice = row.salesPrice;
        row.workersPrice = 0;
      } else {
        row.currentLabourHr = row.labourHours;
        row.currentCostPrice = row.inventoryCostPrice + row.workerCostPrice;
        row.currentCompanyCost = row.inventoryCompanyCost + row.workerCompanyCost;
        row.currentProfit = row.inventoryProfit + row.workerProfit;
        row.currentSalesPrice = row.salesPrice + row.workersPrice;
      }
    }

    function setProfitToLevel(level, profit) {
      if (level.items) {
        level.items.forEach(function (item) {
          item.inventoryProfitPercent = profit;
          item.workerProfitPercent = profit;

          if (item.items) {
            item.items.forEach(function (subItem) {
              subItem.inventoryProfitPercent = profit;
              subItem.workerProfitPercent = profit;
            });
          }
        });
      }

      if (level.levels) {
        level.levels.forEach(function (subLevel) {
          return setProfitToLevel(subLevel, profit);
        });
      }
    }

    function deleteAdditionalCost(item) {
      var index = vm.costPercents.indexOf(item);

      if (index > -1) {
        vm.costPercents.splice(index, 1);
        vm.extraCosts = vm.costPercents.filter(function (it) {
          return it.type === 'global';
        });
      }

      $scope.tableInventory.forEach(function (group) {
        var index1 = group.selectedFor.findIndex(function (x) {
          return x.addCostSeq === item.addCostSeq;
        });

        if (index1 > -1) {
          group.selectedFor.splice(index1, 1);
        }

        deleteSelected(group, item);
      });
      refreshSheet();
    }

    function deleteSelected(level, currentCostItem) {
      if (level.items) {
        level.items.map(function (item) {
          var index = item.selectedFor.findIndex(function (x) {
            return x.addCostSeq === currentCostItem.addCostSeq;
          });

          if (index > -1) {
            item.selectedFor.splice(index, 1);
          }
        });
      }

      if (level.levels != null) {
        level.levels.forEach(function (item) {
          deleteSelected(item, currentCostItem);
        });
      }
    }

    vm.isEmptyItemOnSheet = false;
    vm.emptyCustomPaths = [];

    function checkEmptyItemOnSheet() {
      vm.isEmptyItemOnSheet = false;
      vm.emptyCustomPaths = [];
      $scope.tableInventory.forEach(function (group) {
        checkEmptyItemOnGroup(group, 'Root');
      });
      return vm.isEmptyItemOnSheet;
    }

    function checkEmptyItemOnGroup(level, path) {
      path = path + '/' + level.name;

      if (level.items && level.items.length) {
        for (var i = 0; i < level.items.length; i++) {
          var item = level.items[i];

          if (angular.isDefined(item)) {
            if (item.rowStyle === 'Inventory' || item.rowStyle === 'Combined') {
              if (!item.inventoryName && !item.matID) {
                vm.emptyCustomPaths.push(path);
                vm.isEmptyItemOnSheet = true;
                return;
              }
            }
          }
        }
      }

      if (level.levels && level.levels.length) {
        for (var j = 0; j < level.levels.length; j++) {
          var sub = level.levels[j];
          checkEmptyItemOnGroup(sub, path);
        }
      }
    }

    function checkEmptyItemOnCurrentState() {
      var isEmptyItemOnCurrentState = false;

      if (vm.openBreadCumb) {
        if (vm.currentState.items && vm.currentState.items.length) {
          for (var i = 0; i < vm.currentState.items.length; i++) {
            var item = vm.currentState.items[i];

            if ((item.rowStyle === 'Inventory' || item.rowStyle === 'Combined') && !item.matID && !item.inventoryName) {
              isEmptyItemOnCurrentState = true;
              break;
            }
          }
        }
      } else {
        $scope.tableInventory.forEach(function (group) {
          if (group.items && group.items.length) {
            for (var _i4 = 0; _i4 < group.items.length; _i4++) {
              var _item = group.items[_i4];

              if ((_item.rowStyle === 'Inventory' || _item.rowStyle === 'Combined') && !_item.matID && !_item.inventoryName) {
                isEmptyItemOnCurrentState = true;
                break;
              }
            }
          }
        });
      }

      return isEmptyItemOnCurrentState;
    }

    function addModelToDeletedInventories(level) {
      if (!level.modelId) return;
      vm.deletedModels.push({
        modelId: level.modelId
      });
      var newInventories = [];

      for (var i = 0; i < vm.deletedInventories.length; i++) {
        if (vm.deletedInventories[i].modelId !== level.modelId) {
          newInventories.push(vm.deletedInventories[i]);
        }
      }

      vm.deletedInventories = newInventories;
    }

    function addLevelToDeletedInventories(level) {
      if (!level.modelId) return;

      if (level.levels) {
        for (var i = 0; i < level.levels.length; i++) {
          addLevelToDeletedInventories(level.levels[i]);
        }
      }

      if (level.items) {
        for (var _i5 = 0; _i5 < level.items.length; _i5++) {
          addItemToDeletedInventories(level.items[_i5]);
        }
      }
    }

    function addItemToDeletedInventories(item) {
      if (item.modelId && item.objectId && item.matID) {
        vm.deletedInventories.push({
          modelId: item.modelId,
          objectId: item.objectId,
          inventoryId: item.matID,
          inventoryType: item.subStyle
        });
      }
    }
  }
})();


"use strict";

/* eslint-disable no-unused-vars */
(function () {
  'use strict';

  angular.module('app').component('calcExtra', {
    controller: CalcExtraController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/calcExtra/calcExtra.view.html'
  });

  function CalcExtraController($scope, $state, unitFactory, $log, $uibModal, globals, apiFactory, Notification, $filter, utils, $timeout) {
    var vm = this;
    var projectStore = globals.projectStore,
        companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();
    vm.materials = [];
    vm.buildingparts = [];
    vm.dcps = [];
    vm.equipments = [];
    vm.dcqs = [];
    vm.workers = [];
    vm.subcontractors = [];

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.CALC_ACCESS_CREATE = 100;
    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    vm.projectId = vm.project._id;
    vm.companyData = companyStore.get();
    vm.globalCompanyCost = vm.companyData.companyCost;
    vm.workerCost = vm.companyData.averageWorkerCost;
    $scope.companyCurrency = vm.companyData.currentCurrency;
    $scope.navItems = [{
      id: "design",
      title: $filter('translate')("Project Design")
    }, {
      id: "estimate",
      title: $filter('translate')("Project Estimate")
    }];
    $scope.activeNavItem = "design";
    $scope.activeGroupItem = null;
    $scope.calcData = [{
      id: "design",
      items: [],
      groups: []
    }, {
      id: "estimate",
      items: [],
      groups: []
    }];
    vm.additional = 0;
    $scope.currentData = {
      id: "design",
      items: [],
      groups: []
    };
    $scope.isLoading = true;
    vm.categoryTags = [];
    vm.units = unitFactory.materialUnits();
    vm.levels = [{
      id: 1,
      name: "1"
    }, {
      id: 2,
      name: "2"
    }, {
      id: 3,
      name: "3"
    }, {
      id: 4,
      name: "4"
    }, {
      id: 5,
      name: "5"
    }];

    function fetchData() {
      apiFactory.getCalcSheetCount(vm.projectId).then(function (res) {
        if (res.data.partCnt > 0) {
          Notification.error('This project has PART estimate, will switch to PART estimate.');
          $state.go('calcMain');
        }

        Promise.all([apiFactory.getCalcSheetExtra(vm.projectId), apiFactory.getCategoriesList(), apiFactory.getSystemTags(), apiFactory.listAllMaterials(), apiFactory.listAllComboMaterials(), apiFactory.listAllEquipments(), apiFactory.listAllComboEquipments(), apiFactory.getEconomicSettingInvoiceItems(), apiFactory.getAllSubcontractors(), apiFactory.listAllItems()]).then(function (resp) {
          if (resp[0].data.data) {
            $scope.calcData = resp[0].data.data.items;
            vm.additional = utils.num(resp[0].data.data.additional);
            $log.log(resp[0].data.data);
          } else {
            $scope.calcData = [{
              id: "design",
              items: [],
              groups: []
            }, {
              id: "estimate",
              items: [],
              groups: []
            }];
          }

          $scope.currentData = $scope.calcData.find(function (x) {
            return x.id == $scope.activeNavItem;
          });
          $scope.calcData.forEach(function (x, idx) {
            if (idx >= 2) {
              $scope.navItems.push({
                id: x.id.toLowerCase(),
                title: x.id
              });
            }
          });
          var categoryList = resp[1].data.list;
          var calcCategory = categoryList.find(function (x) {
            return x.categoryName === 'Calculation';
          });
          var allSystemTags = resp[2].data.list;

          if (calcCategory) {
            vm.categoryTags = allSystemTags.filter(function (x) {
              return x.categoryId === calcCategory._id;
            });
          } else {
            vm.categoryTags = [];
          }

          vm.materials = resp[3].data.list;
          vm.dcps = resp[4].data.list;
          vm.equipments = resp[5].data.list;
          vm.dcqs = resp[6].data.list;
          vm.workers = resp[7].data.data.filter(function (x) {
            return x.category === "Labor";
          });
          vm.subcontractors = resp[8].data.list;
          vm.buildingparts = resp[9].data.list;
          $scope.calcData.forEach(function (data) {
            data.items.forEach(function (item) {
              item.item.profitP = vm.companyData.profit;
              item.worker.profitP = vm.companyData.profit;
              $scope.calcSingleItem(item);
            });
          });
          $scope.isLoading = false;
        });
      })["catch"](function (e) {
        $log.error(e);
        $scope.isLoading = false;
      });
    }

    $scope.gotoPage = function (navItem) {
      if (!navItem.active) {
        $scope.activeNavItem = navItem.id;
        $scope.currentData = $scope.calcData.find(function (x) {
          return x.id == $scope.activeNavItem;
        });
      }
    };

    $scope.selectGroup = function () {
      var groupItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (groupItem == null) {
        $scope.activeGroupItem = null;
      } else if (!groupItem.active) {
        $scope.activeGroupItem = groupItem.id;
      }
    };

    $scope.onTagSelect = function (tag, item) {
      item.tag = tag.tagName;
    };

    $scope.onUnitSelect = function (unit, item) {
      item.unit = unit.name;
    };

    $scope.onLevelSelect = function (level, item) {
      item.level = level.name;
    };

    $scope.saveSheet = function () {
      $scope.isLoading = true;
      apiFactory.createSheetExtra({
        projectId: vm.projectId,
        sheet: $scope.calcData,
        additional: vm.additional
      }).then(function (res) {
        Notification.success('Calculation saved successfully.');
        $log.log(res);
        $scope.calcData = res.data.data.items;
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.error(e);
        Notification.error("Calculation couldn't save.");
        $scope.isLoading = false;
      });
    };

    $scope.addNewPage = function () {
      $uibModal.open({
        animation: true,
        component: 'newMainEstimateTabModal',
        windowClass: 'new-main-estimate-tab-modal',
        backdrop: 'static',
        keyboard: false
      }).result.then(function (result) {
        $scope.navItems.push({
          id: result.toLowerCase(),
          title: result
        });
        $scope.calcData.push({
          id: result.toLowerCase(),
          items: [],
          groups: []
        });
      });
    };

    $scope.onSyncToTimeline = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Confirm Sync to Timeline',
              message: 'Are you sure sync data to timeline?',
              subMessage: 'If you sync data, the existing timeline data will be loat and overwitten.',
              confirmButtonText: 'Confirm',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      });
      confirmModal.result.then(function () {
        $scope.isLoading = true;
        apiFactory.syncCalcExtraToTimeline({
          projectId: vm.projectId
        }).then(function (res) {
          $scope.isLoading = false;
          Notification.success('Estimation data has been synced with timeline.');
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error('Failed to sync to timeline');
        });
      }, function () {});
    };

    $scope.onSync = function () {
      $uibModal.open({
        animation: true,
        component: 'syncMainEstimateModal',
        windowClass: 'sync-main-estimate-modal',
        backdrop: 'static',
        keyboard: false
      }).result.then(function (result) {
        fetchData(); // $log.log('selected bidPackage = ', result);
        // $log.log('calcData = ', $scope.currentData);
        // $scope.calcData = result;
        // $timeout(() => {
        //   $scope.$apply();
        // })
        // apiFactory.getCollaborationOfferTemplateByBidPackageId(result)
        //   .then(res => {
        //     $log.log('collaboration offer template = ', res);
        //     // let tmpGroups = [];
        //     // $scope.currentData.groups.forEach(group => {
        //     //   tmpGroups.push({
        //     //     id: group.id,
        //     //     name: group.title,
        //     //     levels: []
        //     //   })
        //     // });
        //     // $scope.currentData.items.forEach(item => {
        //     //   tmpGroups.forEach(group => {
        //     //     if(group.id == item.group) {
        //     //       if(item.rowStyle == 'Combined') {
        //     //         group.levels.push({
        //     //           amount: item.item.cost,
        //     //           days: item.item.days,
        //     //           name: item.item.name,
        //     //           nameId: item.item.work,
        //     //           quantity: item.item.qty,
        //     //           type: "",
        //     //           unit: item.item.unit,
        //     //           unitPrice: item.item.unitPrice,
        //     //           size: item.item.dimension,
        //     //           level: item.item.level
        //     //         });
        //     //         group.levels.push({
        //     //           amount: item.worker.cost,
        //     //           days: item.worker.days,
        //     //           name: item.worker.name,
        //     //           nameId: item.worker.work,
        //     //           quantity: item.worker.qty,
        //     //           type: "",
        //     //           unit: item.worker.unit,
        //     //           unitPrice: item.worker.unitPrice
        //     //         });
        //     //       } else if(item.rowStyle == 'Material') {
        //     //         group.levels.push({
        //     //           amount: item.item.cost,
        //     //           days: item.item.days,
        //     //           name: item.item.name,
        //     //           nameId: item.item.work,
        //     //           quantity: item.item.qty,
        //     //           type: "",
        //     //           unit: item.item.unit,
        //     //           unitPrice: item.item.unitPrice,
        //     //           size: item.item.dimension,
        //     //           level: item.item.level
        //     //         });
        //     //       } else if(item.rowStyle == 'Worker') {
        //     //         group.levels.push({
        //     //           amount: item.worker.cost,
        //     //           days: item.worker.days,
        //     //           name: item.worker.name,
        //     //           nameId: item.worker.work,
        //     //           quantity: item.worker.qty,
        //     //           type: "",
        //     //           unit: item.worker.unit,
        //     //           unitPrice: item.worker.unitPrice
        //     //         });
        //     //       } else {
        //     //         group.levels.push({
        //     //           amount: item.item.cost,
        //     //           days: item.item.days,
        //     //           name: item.item.name,
        //     //           nameId: item.item.work,
        //     //           quantity: item.item.qty,
        //     //           type: "",
        //     //           unit: item.item.unit,
        //     //           unitPrice: item.item.unitPrice,
        //     //           size: item.item.dimension,
        //     //           level: item.item.level
        //     //         });
        //     //       }
        //     //     }
        //     //   })
        //     // })
        //     // $timeout(() => {
        //     //   $log.log('temp groups = ', tmpGroups);
        //     //   apiFactory.updateCollaborationOfferTemplate({_id: res.data._id, groups: tmpGroups})
        //     //     .then(res1 => {
        //     //       $log.log('collaboration offer template = ', res1);
        //     //     })
        //     // })
        //   })
        // if (!$scope.currentData.groups) {
        //   $scope.currentData.groups = [];
        // }
        // $scope.currentData.groups.push({id: result.toLowerCase(), title: $filter('translate')(result)});
        // $log.log($scope.currentData)
      });
    };

    $scope.changeProjectSetting = function () {
      $uibModal.open({
        animation: true,
        component: 'configModal2',
        windowClass: 'calc-config-modal2',
        resolve: {
          data: function data() {
            return {
              opCost: vm.companyData.companyCost,
              profit: vm.companyData.profit
            };
          }
        }
      }).result.then(function (result) {
        vm.companyData.companyCost = result.opCost;
        vm.companyData.profit = result.profit;
        $scope.calcData.forEach(function (data) {
          data.items.forEach(function (item) {
            item.item.profitP = vm.companyData.profit;
            item.worker.profitP = vm.companyData.profit;
            $scope.calcSingleItem(item);
          });
        });
      });
    };

    $scope.addNewGroup = function () {
      $uibModal.open({
        animation: true,
        component: 'newMainEstimateTabModal',
        windowClass: 'new-main-estimate-tab-modal',
        backdrop: 'static',
        keyboard: false
      }).result.then(function (result) {
        if (!$scope.currentData.groups) {
          $scope.currentData.groups = [];
        }

        $scope.currentData.groups.push({
          id: result.toLowerCase(),
          title: result
        });
        $log.log($scope.currentData);
      });
    };

    $scope.removeItem = function (item) {
      var index = $scope.currentData.items.findIndex(function (x) {
        return x.idx == item.idx;
      });
      $scope.currentData.items.splice(index, 1);
    };

    $scope.addNewLine = function () {
      var idx = 1;

      if ($scope.currentData.items.length > 0) {
        idx = $scope.currentData.items[$scope.currentData.items.length - 1].idx + 1;
      }

      $scope.currentData.items.push({
        idx: idx,
        item: {
          tag: '',
          work: '',
          days: 0,
          qty: 0,
          unit: '',
          unitPrice: 0,
          dimension: '',
          waste: 0,
          level: '',
          cost: 0,
          companyCost: 0,
          profitP: vm.companyData.profit,
          profit: 0,
          salesPrice: 0
        },
        worker: {
          work: '',
          days: 0,
          qty: 0,
          unit: '',
          unitPrice: 0,
          waste: 0,
          labor: 0,
          cost: 0,
          companyCost: 0,
          profitP: vm.companyData.profit,
          profit: 0,
          salesPrice: 0
        },
        rowStyle: 'Combined',
        subStyle: 'Material',
        group: $scope.activeGroupItem
      });
    };

    $scope.calcSingleItem = function (item) {
      $log.log(vm.companyData.companyCost);
      item.item.cost = item.item.qty * item.item.unitPrice;
      item.item.salesPrice = 1 - item.item.profitP / 100 - vm.companyData.companyCost / 100 > 0 ? item.item.cost / (1 - item.item.profitP / 100 - vm.companyData.companyCost / 100) : 0;
      item.item.opCost = item.item.salesPrice * (vm.companyData.companyCost / 100);
      item.item.profit = item.item.salesPrice * (item.item.profitP / 100);
      item.worker.cost = item.worker.qty * item.worker.unitPrice;
      item.worker.salesPrice = 1 - item.worker.profitP / 100 - vm.companyData.companyCost / 100 > 0 ? item.worker.cost / (1 - item.worker.profitP / 100 - vm.companyData.companyCost / 100) : 0;
      item.worker.opCost = item.worker.salesPrice * (vm.companyData.companyCost / 100);
      item.worker.profit = item.worker.salesPrice * (item.worker.profitP / 100);
      item.worker.labor = item.worker.qty * item.worker.unitPrice / vm.workerCost;
      item.item.waste = (item.item.cost / item.item.unitPrice - item.item.qty) / item.item.qty * 100;
      if (item.item.waste < 0) item.item.waste = 0;
      item.worker.waste = (item.worker.cost / item.worker.unitPrice - item.worker.qty) / item.worker.qty * 100;
      if (item.worker.waste < 0) item.worker.waste = 0;
    };

    $scope.calcTotalLabor = function () {
      var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var sum = 0;
      $scope.currentData.items.filter(function (x) {
        if (groupId == null) return !$scope.activeGroupItem || x.group == $scope.activeGroupItem;else return x.group == groupId;
      }).forEach(function (x) {
        sum += utils.num(x.item ? x.item.labor : 0);
        sum += utils.num(x.worker ? x.worker.labor : 0);
      });
      return sum;
    };

    $scope.calcTotalCost = function () {
      var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var sum = 0;
      $scope.currentData.items.filter(function (x) {
        if (groupId == null) return !$scope.activeGroupItem || x.group == $scope.activeGroupItem;else return x.group == groupId;
      }).forEach(function (x) {
        sum += utils.num(x.item ? x.item.cost : 0);
        sum += utils.num(x.worker ? x.worker.cost : 0);
      });
      return sum;
    };

    $scope.calcTotalCompanyCost = function () {
      var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var sum = 0;
      $scope.currentData.items.filter(function (x) {
        if (groupId == null) return !$scope.activeGroupItem || x.group == $scope.activeGroupItem;else return x.group == groupId;
      }).forEach(function (x) {
        sum += utils.num(x.item ? x.item.opCost : 0);
        sum += utils.num(x.worker ? x.worker.opCost : 0);
      });
      return sum;
    };

    $scope.calcTotalProfitPercent = function () {
      var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var sum = 0;
      var cnt = 0;
      $scope.currentData.items.filter(function (x) {
        if (groupId == null) return !$scope.activeGroupItem || x.group == $scope.activeGroupItem;else return x.group == groupId;
      }).forEach(function (x) {
        cnt++;
        sum += utils.num(x.item ? x.item.profitP : 0);
        sum += utils.num(x.worker ? x.worker.profitP : 0);
      });
      return sum / cnt / 2;
    };

    $scope.calcTotalProfit = function () {
      var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var sum = 0;
      $scope.currentData.items.filter(function (x) {
        if (groupId == null) return !$scope.activeGroupItem || x.group == $scope.activeGroupItem;else return x.group == groupId;
      }).forEach(function (x) {
        sum += utils.num(x.item ? x.item.profit : 0);
        sum += utils.num(x.worker ? x.worker.profit : 0);
      });
      return sum;
    };

    $scope.calcTotalSalesPrice = function () {
      var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var sum = 0;
      $scope.currentData.items.filter(function (x) {
        if (groupId == null) return !$scope.activeGroupItem || x.group == $scope.activeGroupItem;else return x.group == groupId;
      }).forEach(function (x) {
        sum += utils.num(x.item ? x.item.salesPrice : 0);
        sum += utils.num(x.worker ? x.worker.salesPrice : 0);
      });
      return sum;
    };

    vm.onSelectStyle = function (item) {
      if (item.subStyle === "Custom") {
        item.item.work = '';
        item.item.qty = 1;
        item.worker.qty = 1;
        item.item.unit = 'm';
        item.worker.unit = 'hrs';
        item.item.unitPrice = 1;
        item.worker.unitPrice = utils.num(vm.workerCost);
      }

      if (item.rowStyle === 'Collaborator') {
        item.item.work = ''; // item.worker.work = 'Collaborator';
      }
    };

    vm.onChangeInventory = function (item, materialId) {
      $log.log('materialId = ', materialId);
      var subStyle = item.subStyle;
      var inventories = [];

      switch (subStyle) {
        case 'Material':
          inventories = vm.materials;
          break;

        case 'Building Part':
          inventories = vm.buildingparts;
          break;

        case 'DCP':
          inventories = vm.dcps;
          break;

        case 'Equipment':
          inventories = vm.equipments;
          break;

        case 'DCQ':
          inventories = vm.dcqs;
          break;

        case 'Worker':
          inventories = vm.workers;
          break;

        case 'Collaborator':
          inventories = vm.materials;
          break;
      }

      if (item.rowStyle == 'Combined') {
        for (var i = 0; i < vm.workers.length; i++) {
          if (vm.workers[i]._id == item.worker.work) {
            item.worker.name = vm.workers[i].description;
          }
        }
      }

      for (var _i = 0; _i < inventories.length; _i++) {
        if (inventories[_i]._id === materialId) {
          var inventory = inventories[_i];
          item.item.unit = inventory.unit;

          if (subStyle == 'Worker') {
            item.worker.name = inventory.description;
          } else {
            item.item.name = inventory.name;
          }

          if (subStyle === 'Material') {
            item.item.unitPrice = utils.num(inventory.baseRate.materialCost);
            item.worker.unitPrice = utils.num(inventory.baseRate.rooferCost);
            item.worker.work = 'Worker';
          } else if (subStyle === 'DCP') {
            item.item.unitPrice = utils.num(inventory.totalMaterialCost);
            item.worker.unitPrice = utils.num(inventory.totalRooferCost);
            item.worker.work = 'Worker';
          } else if (subStyle === 'Equipment') {
            item.item.unitPrice = utils.num(inventory.baseRate.equipmentCost);
            item.worker.unitPrice = utils.num(inventory.baseRate.rooferCost);
            item.worker.work = 'Worker';
          } else if (subStyle === 'DCQ') {
            item.item.unitPrice = utils.num(inventory.totalEquipmentCost);
            item.worker.unitPrice = utils.num(inventory.totalRooferCost);
            item.worker.work = 'Worker';
          } else if (subStyle === 'Worker') {
            // item.worker.work = inventory.description;
            item.item.unitPrice = 0;
            item.worker.unitPrice = utils.num(vm.workerCost);
            item.worker.unit = 'hrs';
          } else {
            item.item.unitPrice = 0;
            item.worker.work = 'Worker';
            item.worker.unitPrice = 0;
          }

          break;
        }
      }
    };

    fetchData();
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('calcVersions', {
    controller: CalcVersionsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/calVersions/calVersions.view.html'
  });
  /** @ngInject */

  function CalcVersionsController($scope, $state, apiFactory, Notification, globals, $log, $uibModal, localStorageService) {
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get();
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    vm.projectId = vm.project._id;
    vm.companyData = companyStore.get();
    vm.selectedVersion = undefined;
    vm.compareVersionIds = [];
    vm.overNum = false;
    $scope.isLoading = true;
    apiFactory.getCalcVersions(vm.projectId).then(function (resp) {
      $scope.isLoading = false;
      vm.AllVersions = resp.data.data.all;
      vm.currentVersion = resp.data.data.now;
    })["catch"](function (err) {
      $log.error(err);
    });

    vm.showVersionInfo = function (version) {
      vm.selectedVersion = version;
      var viewDetailModalData = {
        selectedVersion: vm.selectedVersion,
        currentVersion: vm.currentVersion
      };
      localStorageService.set('viewDetailModalData', viewDetailModalData);
      var modal = $uibModal.open({
        animation: true,
        component: 'viewDetailModal'
      });
      modal.result.then(function () {
        vm.showVersionDetail();
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.showVersionDetail = function () {
      $state.go("calVersionDetail", {
        id: vm.selectedVersion.versionId
      });
    };

    vm.restoreVersion = function (version) {
      apiFactory.restoreCalcVersion(version.versionId, vm.currentVersion.sheetId).then(function (resp) {
        Notification.success("Calculation version is successfully restored.");
        var calcSheet = resp.data.data;
        var user = userStore.get();
        vm.calcSheet = {
          sheetId: calcSheet._id,
          versionSeq: calcSheet.currentVersion,
          savedBy: user.firstName + " " + user.lastName,
          sum: calcSheet.sum,
          totalCompanyCost: calcSheet.totalCompanyCost,
          totalWorkHours: calcSheet.totalWorkHours,
          totalProfit: calcSheet.totalProfit,
          totalCostPrice: calcSheet.totalCostPrice,
          versionMessage: calcSheet.versionMessage
        };
        $scope.$apply();
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Calculation version couldn't be restored.");
      });
    };

    $scope.onSelVersionId = function (version) {
      if (version.index && vm.compareVersionIds.length < 2) {
        vm.compareVersionIds.push(version.versionId);
      } else if (version.index && vm.compareVersionIds.length === 2) {
        version.index = false;
      } else if (!version.index) {
        var reIndex = vm.compareVersionIds.indexOf(version.versionId);

        if (reIndex > -1) {
          vm.compareVersionIds.splice(reIndex, 1);
        }
      }
    };

    vm.compareVersion = function () {
      if (vm.compareVersionIds.length === 2) {
        var compareData = {
          left: vm.compareVersionIds[0],
          right: vm.compareVersionIds[1]
        };
        localStorageService.set('compareData', compareData);
        $state.go("calVersionDetail", {
          id: "compare"
        });
      } else {
        Notification.error("Please Select For Compare");
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('calVersionDetail', {
    controller: CalVersionDetailController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/calVersionDetail/calVersionDetail.view.html'
  });
  /** @ngInject */

  function CalVersionDetailController($scope, $timeout, $log, $state, $stateParams, apiFactory, Notification, globals, localStorageService, unitFactory) {
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore,
        companyStore = globals.companyStore;
    /* Get project list */

    vm.project = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    vm.projectId = vm.project._id;
    vm.mUnits = unitFactory.mUnits;
    vm.selectedVersionSummary = undefined;
    vm.selectedVersionIndex = -1;
    vm.calcSheet = undefined;
    vm.leftVersion = undefined;
    vm.rightVersion = undefined;
    vm.rightVersionSeq = undefined;
    vm.mode = 'detail';
    vm.diffedVersion = {
      left: {},
      right: {}
    };
    vm.openBreadCumb = false;
    vm.currentStateList = [];
    vm.popover = {};
    $scope.outerIndex = 0;
    $scope.innerIndex = 0;
    $scope.openSelectBox = false;
    $scope.tableInventory = [];
    $scope.levelId = 0;
    $scope.selectedRow = 0;
    $scope.selectedUnit = 0;
    $scope.totalProfit = 0;
    $scope.totalWorkingHours = 0;
    $scope.totalCostPrice = 0;
    $scope.totalCompanyCost = 0;

    function initData() {
      if ($stateParams.id === 'compare') {
        var compareData = localStorageService.get('compareData');
        $scope.compareright = compareData.right;
        $scope.compareleft = compareData.left;
        localStorageService.set('compareData', null);
        loadCalcSheet();
      } else {
        vm.mode = 'detail';
        loadCalcSheet().then(function (resp) {
          vm.rightVersion = resp;
          loadVersioning($stateParams.id);
          loadVersion($stateParams.id).then(function () {
            diffVersion();
          });
        });
      }
    }

    initData();

    vm.showPrevVersion = function () {
      goVersion(vm.selectedVersionIndex - 1);
    };

    vm.showNextVersion = function () {
      goVersion(vm.selectedVersionIndex + 1);
    };

    $scope.isLoading = true;

    vm.restoreVersion = function () {
      apiFactory.restoreCalcVersion(vm.leftVersion._id, vm.calcSheet._id).then(function (resp) {
        Notification.success("Calculation version is successfully restored.");
        vm.calcSheet = resp.data.data;
        $scope.$apply();
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Calculation version couldn't be restored.");
      });
    };

    vm.viewCurrentVersion = function () {
      $state.go("calcMain");
    };

    vm.mergeVersion = function () {
      mergeVersion(vm.selectedVersion, vm.calcSheet);
      apiFactory.createSheet(vm.calcSheet).then(function (resp) {
        Notification.success("Calculation version is successfully merged.");
        vm.calcSheet = resp.data.data;
        $scope.$apply();
      })["catch"](function (err) {
        $log.error(err);
        Notification.error("Calculation version couldn't be merged.");
      });
    };

    vm.compareVersion = function (ver1, ver2) {
      loadVersioning(ver1);
      var versioning = vm.calcSheet.versioning;

      for (var i = 0; i < versioning.length; i++) {
        if (versioning[i].versionId == ver2) {
          vm.rightVersionSeq = versioning[i].versionSeq;
          break;
        }
      }

      Promise.all([loadVersion(ver1), apiFactory.getCalcVersion(ver2)]).then(function (resp) {
        if (resp[1].data.data) {
          vm.rightVersion = resp[1].data.data;
        }

        diffVersion();
        vm.mode = 'contentdiff';
        $scope.$apply();
        $timeout(function () {
          $scope.$evalAsync(function () {
            contentDiff();
          });
        });
      })["catch"](function (err) {
        $log.error("error", err);
      });
    };

    globals.getCurrency().then(function (resp) {
      vm.getCurrencyCode = resp.data;
      $scope.companyCurrency = vm.getCurrencyCode.find(function (element) {
        return element.cc === vm.companyData.currentCurrency.currencyCode;
      });
    });

    var goVersion = function goVersion(index) {
      var versioning = vm.calcSheet.versioning;

      if (index >= 0 && index < versioning.length) {
        vm.selectedVersionSummary = versioning[index];
        vm.selectedVersionIndex = index;
        loadVersion(vm.selectedVersionSummary.versionId).then(function () {
          diffVersion();
        });
      }
    };

    $scope.openSelect = function (outindex) {
      vm.addrowIndex = outindex;
      $scope.openSelectBox = true;
    }; //Root calculations when adding inventory
    // $scope.showWasteAmt = (item, index, outerIndex) => {
    //   angular.element('[data-toggle="popover"]').popover();
    // };


    $scope.getPopoverTitle = function (item) {
      if (item.wastePercent > 0) {
        return "Waste - ".concat(item.wastePercent || "", "% (").concat(item.wasteAmount || 0, ") ").concat(item.inventoryUnit || "");
      } else if (item.wastePercent == 0) {
        return "Waste - ".concat(item.wastePercent || 0, "% (N/A)");
      } else {
        return "Waste - ".concat(item.wastePercent || "", "%");
      }
    };

    $scope.gotoBreadCrumb = function (index) {
      vm.openBreadCumb = true;
      vm.breadCrumbIndex = index;
      vm.currentState = $scope.tableInventory[index];
      vm.currentStateList.push(vm.currentState);
      vm.breadCrumbItem = vm.breadCrumbIndex.name;
    };

    $scope.breadCrumbSubLevel = function (index, innerindex, sublevel) {
      vm.currentState = sublevel;
      vm.currentStateList.push(vm.currentState);
    };

    vm.changeBreadCrumb = function (index) {
      vm.currentState = vm.currentStateList[index];
      vm.currentStateList = vm.currentStateList.slice(0, index + 1);
    };

    vm.callBreadCrumb = function (index, innerindex, sublevel) {
      vm.openBreadCumb = true;
      vm.breadCrumbIndex = index;
      var current = $scope.tableInventory[index];
      vm.currentStateList.push(current);
      vm.currentState = sublevel;
      vm.currentStateList.push(vm.currentState);
    };

    vm.goToRoot = function () {
      vm.openBreadCumb = false;
      vm.currentStateList = [];
    };

    $scope.showImage = function (item, outerimg, innerimg) {
      vm.outImg = outerimg;
      vm.innImg = innerimg;
    }; // merge function


    function mergeVersion(calcVersion, sheet) {
      function combineCalcData(old, current, root, sheet) {
        var currentDataMap = [];

        if (current && current.length > 0) {
          for (var i = 0; i < current.length; i++) {
            var item = current[i];
            currentDataMap[item.id] = {
              index: i,
              data: item
            };
          }
        }

        if (old && old.length > 0) {
          var insertIndex = 0;
          var indexIncrement = 1;

          for (var _i = 0; _i < old.length; _i++) {
            var oldItem = old[_i];
            var equalItem = currentDataMap[oldItem.id];

            if (equalItem && equalItem._id && equalItem._id === oldItem._id) {
              // compare deep
              combineDeep(oldItem, equalItem.data, root, sheet);
              combineCalcData(old.levels, current.levels, current, sheet);
              insertIndex = equalItem.index;
            } else {
              // add old to current
              insertAt(current, oldItem, insertIndex + indexIncrement);
              indexIncrement++;
              sheet.sum = sheet.sum + oldItem.sum;
              sheet.totalWorkHours = sheet.totalWorkHours + oldItem.Hours;
              sheet.totalCompanyCost = sheet.totalCompanyCost + oldItem.CompanyCost;
              sheet.totalCostPrice = sheet.totalCostPrice + oldItem.CostPrice;
              sheet.totalProfit = sheet.totalProfit + oldItem.profit;
            }
          }
        }
      }

      function combineDeep(old, current, root, sheet) {
        if (current.materialID && current.materialID === old.materialID) {
          // compare IfcData
          var oldData = old.IfcData;
          var currentData = current.IfcData;
          var currentDataMap = [];

          for (var i = 0; i < currentData.length; i++) {
            var item = currentData[i];
            currentDataMap[item.objectId] = {
              index: i,
              data: item
            };
          }

          var insertIndex = 0;
          var indexIncrement = 1;

          for (var _i2 = 0; _i2 < oldData.length; _i2++) {
            var oldItem = oldData[_i2];
            var newItem = currentDataMap[oldItem.objectId];

            if (newItem) {
              insertIndex = newItem.index + indexIncrement;
            } else {
              // insert item to IfcData
              insertAt(currentData, oldItem, insertIndex);
              indexIncrement++; // update items

              findAndAddItems(old.items, oldItem.objectId, current, root, sheet);
            }
          }
        }
      }

      function findAndAddItems(items, objectId, current, root, sheet) {
        for (var i = 0; i < items.length; i++) {
          var item = items[i];

          if (items[i].objectId == objectId) {
            // newItems.push(items[i]);
            current.items.push(items[i]); // update sum

            current.sum = current.sum + item.currentSalesPrice;
            current.sumHours = current.sumHours + item.currentLabourHr;
            current.sumProfit = current.sumProfit + item.currentProfit;
            current.sumCompanyCost = current.sumCompanyCost + item.currentCompanyCost;
            current.sumCostPrice = current.sumCostPrice + item.currentCostPrice; // update root sum

            if (root && current != root) {
              root.sum = root.sum + item.currentSalesPrice;
              root.sumHours = root.sumHours + item.currentLabourHr;
              root.sumProfit = root.sumProfit + item.currentProfit;
              root.sumCompanyCost = root.sumCompanyCost + item.currentCompanyCost;
              root.sumCostPrice = root.sumCostPrice + item.currentCostPrice;
            } // update sheet sum


            sheet.sum = sheet.sum + item.currentSalesPrice;
            sheet.totalWorkHours = sheet.totalWorkHours + item.currentLabourHr; // sheet.totalCompanyCost = sheet.totalCompanyCost + oldItem.CompanyCost;

            sheet.totalCompanyCost = sheet.totalCompanyCost + item.currentCompanyCost; // sheet.totalCostPrice = sheet.totalCostPrice + item.currentCompanyCost;

            sheet.totalCostPrice = sheet.totalCostPrice + item.currentCostPrice; // sheet.totalProfit = sheet.totalProfit + item.currentCostPrice;

            sheet.totalProfit = sheet.totalProfit + item.currentProfit;
          }
        }
      }

      function insertAt(arr, item, index) {
        arr.splice(index, 0, item);
      }

      combineCalcData(calcVersion.levels, sheet.levels, null, sheet);
    } // diff content function


    function diffVersion() {
      function compareCalcData(old, current, diffLeft, diffRight) {
        var equal = true;
        var oldDataMap = [];

        if (old && old.length > 0) {
          for (var i = 0; i < old.length; i++) {
            oldDataMap[old[i].id] = old[i];
          }
        }

        if (current && current.length > 0) {
          for (var _i3 = 0; _i3 < current.length; _i3++) {
            var currentItem = current[_i3];
            var oldItem = oldDataMap[currentItem.id]; // if there is item in old same as current id

            if (oldItem && oldItem._id && oldItem._id === currentItem._id) {
              // compare deep
              var diffSubLeft = [];
              var diffSubRight = [];
              equal = compareDeep(oldItem, currentItem, diffSubLeft, diffSubRight);
              oldItem.items = diffSubLeft;
              currentItem.items = diffSubRight;
              diffSubLeft = [];
              diffSubRight = [];
              var subEqual = compareCalcData(oldItem.levels, currentItem.levels, diffSubLeft, diffSubRight);
              oldItem.levels = diffSubLeft;
              currentItem.levels = diffSubRight;

              if (!equal || !subEqual) {
                equal = false;
                oldItem.diff = 'diff-nonequal';
                currentItem.diff = 'diff-nonequal';
              }

              oldDataMap[currentItem.id] = undefined;
              diffLeft.push(oldItem);
              diffRight.push(currentItem);
            } else {
              setDiff(currentItem, 'diff-nonequalnew');
              equal = false;
              diffLeft.push({
                empty: true
              });
              diffRight.push(currentItem);
            }
          }
        }

        for (var key in oldDataMap) {
          var _oldItem = oldDataMap[key];

          if (_oldItem) {
            setDiff(_oldItem, 'diff-nonequalnew');
            equal = false;
            diffLeft.push(_oldItem);
            diffRight.push({
              empty: true
            });
          }
        }

        return equal;
      }

      function compareDeep(old, current, left, right) {
        // compare data
        var oldData = old.items;
        var currentData = current.items;
        var allEqual = true;
        var oldDataMap = [];

        for (var i = 0; i < oldData.length; i++) {
          oldDataMap[oldData[i]._id] = oldData[i];
        }

        for (var _i4 = 0; _i4 < currentData.length; _i4++) {
          var newItem = currentData[_i4];
          var oldItem = oldDataMap[newItem._id];

          if (oldItem) {
            // same id
            oldDataMap[newItem._id] = undefined;
            var equal = true;
            var numberKeys = ['currentSalesPrice', 'currentProfit', 'currentCompanyCost', 'currentCostPrice', 'currentLabourHr', 'workersPrice', 'salesPrice', 'workerProfit', 'inventoryProfit', 'workerProfitPercent', 'inventoryProfitPercent', 'workerCompanyCost', 'inventoryCompanyCost', 'labourHours', 'inventoryCostPrice', 'workerCostPrice', 'wasteAmount', 'wastePercent', 'workerUnitPrice', 'inventoryUnitPrice', 'inventoryAmount', 'deliveryCost', 'workerAmount'];
            var otherKeys = ['objectId', 'rowStyle', 'matID', 'inventoryName', 'inventoryUnit', 'systemTag', 'workerName', 'workerUnit'];

            for (var _i5 = 0, _numberKeys = numberKeys; _i5 < _numberKeys.length; _i5++) {
              var key = _numberKeys[_i5];

              if (Math.abs(oldItem[key] - newItem[key]) > 0.0001) {
                oldItem.diff = 'diff-nonequal';
                newItem.diff = 'diff-nonequal';
                equal = false;
                allEqual = false;
                break;
              }
            }

            for (var _i6 = 0, _otherKeys = otherKeys; _i6 < _otherKeys.length; _i6++) {
              var _key = _otherKeys[_i6];

              if (oldItem[_key] != newItem[_key]) {
                oldItem.diff = 'diff-nonequal';
                newItem.diff = 'diff-nonequal';
                equal = false;
                allEqual = false;
                break;
              }
            }

            if (equal) {
              oldItem.diff = 'diff-equal';
              newItem.diff = 'diff-equal';
            }

            left.push(oldItem);
            right.push(newItem);
          } else {
            // update items
            newItem.diff = 'diff-nonequalnew';
            allEqual = false;
            left.push({
              empty: true
            });
            right.push(newItem);
          }
        }

        for (var _key2 in oldDataMap) {
          var _oldItem2 = oldDataMap[_key2];

          if (_oldItem2) {
            _oldItem2.diff = 'diff-nonequalnew';
            allEqual = false;
            left.push(_oldItem2);
            right.push({
              empty: true
            });
          }
        }

        return allEqual;
      }

      function setDiff(level, diff) {
        level.diff = diff;

        if (level.items && level.items.length > 0) {
          for (var i = 0; i < level.items.length; i++) {
            level.items[i].diff = diff;
          }
        }

        if (level.levels && level.levels.length > 0) {
          for (var _i7 = 0; _i7 < level.levels.length; _i7++) {
            setDiff(level.levels[_i7], diff);
          }
        }
      }

      vm.diffedVersion = {
        left: angular.copy(vm.leftVersion),
        right: angular.copy(vm.rightVersion)
      };
      var left = vm.diffedVersion.left.levels;
      var right = vm.diffedVersion.right.levels;
      vm.diffedVersion.left.levels = [];
      vm.diffedVersion.right.levels = [];
      compareCalcData(left, right, vm.diffedVersion.left.levels, vm.diffedVersion.right.levels);
    }

    function loadVersion(versionId) {
      return new Promise(function (resolve, reject) {
        apiFactory.getCalcVersion(versionId).then(function (resp) {
          if (resp.data.data) {
            $scope.isLoading = false;
            var data = resp.data.data;
            vm.selectedVersion = data;
            $scope.companyCurrency = data.companyCurrency;
            $scope.tableInventory = data.levels;
            $scope.totalSum = data.sum;
            $scope.totalSumWithAdditionalCost = data.sumWithAdditionalCost;
            $scope.totalProfit = data.totalProfit;
            $scope.totalWorkingHours = data.totalWorkHours;
            $scope.totalCostPrice = data.totalCostPrice;
            $scope.totalCompanyCost = data.totalCompanyCost;
            $scope.totalInventoryCost = data.totalInventoryCost;
            $scope.totalWorkerCost = data.totalWorkerCost;
            $scope.levelId = data.lastGroupId;
            vm.leftVersion = data;
          }

          resolve();
        })["catch"](function (err) {
          $log.error(err);
          reject(err);
        });
      });
    }

    function loadVersioning(versionId) {
      var versioning = vm.calcSheet.versioning;

      for (var i = 0; i < versioning.length; i++) {
        if (versioning[i].versionId == versionId) {
          vm.selectedVersionSummary = versioning[i];
          vm.selectedVersionIndex = i;
          break;
        }
      }
    }

    function loadCalcSheet() {
      return new Promise(function (resolve, reject) {
        apiFactory.getCalcSheet(vm.projectId).then(function (resp) {
          if (resp.data.data) {
            vm.calcSheet = resp.data.data;
          }

          resolve(resp.data.data);

          if ($scope.compareleft && $scope.compareright) {
            vm.compareVersion($scope.compareleft, $scope.compareright);
          }
        })["catch"](function (err) {
          $log.error(err);
          reject(err);
        });
      });
    }

    vm.showDetail = function () {
      vm.mode = 'detail';
    };

    vm.showDiff = function () {
      vm.mode = 'contentdiff';
      $timeout(function () {
        $scope.$apply();
        contentDiff();
      });
    };

    vm.showTreeDiff = function () {
      vm.mode = 'treediff';
    };

    function contentDiff() {
      angular.element('#left-calc-container').scroll(function () {
        angular.element('#right-calc-container').scrollLeft(angular.element('#left-calc-container').scrollLeft());
      });
      angular.element('#right-calc-container').scroll(function () {
        angular.element('#left-calc-container').scrollLeft(angular.element('#right-calc-container').scrollLeft());
      });
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('budget', {
    controller: BudgetController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calc/budget/budget.view.html'
  });
  /** @ngInject */

  function BudgetController($scope, $compile, $templateCache, $state, apiFactory, Notification, globals, $log, utils, $filter) {
    var vm = this;
    var projectStore = globals.projectStore,
        companyStore = globals.companyStore,
        userStore = globals.userStore;
    vm.userData = userStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.BUDGET_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.BUDGET_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.BUDGET]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.BUDGET_ACCESS_CREATE = res.data.data[Constants.AccessKey.BUDGET];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.project = projectStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    vm.projectId = vm.project._id;
    vm.companyData = companyStore.get();
    $scope.isLoading = true;
    vm.extraCosts = [];
    $scope.totalWorkingHours = 0;
    $scope.totalCostPrice = 0;
    vm.tabs = [{
      id: 'all',
      name: $filter('translate')("All")
    }, {
      id: 'mat',
      name: $filter('translate')("Materials")
    }, {
      id: 'sup',
      name: $filter('translate')("Supplier")
    }, {
      id: 'lab',
      name: $filter('translate')("Labour")
    }, {
      id: 'sub',
      name: $filter('translate')("Sub-Contractor")
    }, {
      id: 'eqp',
      name: $filter('translate')("Equipments")
    }];
    vm.sheet = undefined;
    vm.materials = [];
    vm.equipments = [];
    $scope.isLoading = true;
    Promise.all([apiFactory.getCalcSheet(vm.projectId), apiFactory.listAllMaterials(), apiFactory.listAllEquipments()]).then(function (resp) {
      var sheet = resp[0].data.data;
      vm.sheet = sheet;
      vm.materials = resp[1].data.list;
      vm.equipments = resp[2].data.list;
      $scope.isLoading = false;
      var sheetMap = {
        material: {},
        labor: {},
        equipment: {},
        supplier: {},
        subcontractor: {}
      };
      vm.budgets = [{
        _id: 'all',
        name: $filter('translate')('All'),
        levels: []
      }];

      if (sheet.levels) {
        sheet.levels.forEach(function (level) {
          arrangeBudgetLevel(level, sheetMap);
          vm.budgets[0].levels.push(level);
          vm.budgets.push(level);
        });
      }

      fillLevelBudget(vm.budgets[0], sheetMap);
      $scope.companyCurrency = sheet.companyCurrency;
      $scope.totalSum = sheet.sum;
      $scope.totalSumWithAdditionalCost = utils.num(sheet.sumWithAdditionalCost);
      $scope.totalWorkingHours = sheet.totalWorkHours;
      $scope.totalCostPrice = sheet.totalCostPrice;
      $scope.totalCompanyCost = sheet.totalCompanyCost;
      $scope.totalProfit = sheet.totalProfit;
      $scope.totalInventoryCost = sheet.totalInventoryCost;
      $scope.totalWorkerCost = sheet.totalWorkerCost;
      $scope.hierarchicalCostSeqLast = sheet.hierarchicalCostSeqLast;

      if (sheet.additionalCosts.length > 0) {
        var costPercents = sheet.additionalCosts;

        if (costPercents) {
          for (var l = 0; l < costPercents.length; l++) {
            var adCostItem = costPercents[l];

            if (adCostItem.name === 'Administrators Cost' || adCostItem.name === 'Risk Profile' || adCostItem.name === 'Company Cost') {
              adCostItem.type = 'global';
            }
          }
        }

        vm.extraCosts = costPercents ? costPercents.filter(function (it) {
          return it.type === 'global';
        }) : [];
      }
    })["catch"](function (err) {
      $scope.isLoading = false;
      $log.error(err);
      Notification.error('There is error during load budgets.');
    });

    vm.saveSheet = function () {
      getSumsByRoStyle();
      vm.sheet.levels.forEach(function (group) {
        if (group.levels) {
          group.levels.forEach(function (level) {
            delete level.budgets;
          });
        }
      });
      var sheetData = {
        companyCurrency: $scope.companyCurrency,
        projectId: vm.projectId,
        levels: vm.sheet.levels,
        sum: $scope.totalSum,
        totalProfit: $scope.totalProfit,
        totalWorkHours: $scope.totalWorkingHours,
        totalCompanyCost: $scope.totalCompanyCost,
        totalCostPrice: $scope.totalCostPrice,
        totalInventoryCost: $scope.totalInventoryCost,
        totalWorkerCost: $scope.totalWorkerCost,
        averageWorkerCost: vm.workerCost,
        additionalCosts: vm.costPercents,
        companyProfit: vm.globalProfit,
        companyCost: vm.globalCompanyCost,
        hierarchicalCostSeqLast: $scope.hierarchicalCostSeqLast,
        lastGroupId: $scope.levelId,
        versionMessage: vm.versionMessage
      };
      apiFactory.createSheet({
        sheet: sheetData
      }).then(function (resp) {
        $scope.isEdited = false;
        Notification.success(resp.data.message);
      })["catch"](function (e) {
        $log.log(e);
        Notification.error("Something went wrong");
      });
    };

    function getSumsByRoStyle() {
      $scope.hoverIn = !$scope.hoverIn;

      if ($scope.hoverIn) {
        $scope.totalInventoryCost = 0;
        $scope.totalWorkerCost = 0;
        vm.sheet.levels.map(function (table) {
          findTotals(table);
        });
      }
    }

    function arrangeBudgetLevel(level, budgetMap) {
      var levelMap = {
        material: {},
        labor: {},
        equipment: {},
        supplier: {},
        subcontractor: {}
      };

      if (level.items && level.items.length > 0) {
        level.items.forEach(function (item) {
          arrangeBudgetItem(item, levelMap);
          arrangeBudgetItem(item, budgetMap);
        });
      }

      if (level.levels && level.levels.length > 0) {
        level.levels.forEach(function (subLevel) {
          arrangeBudgetLevel(subLevel, levelMap);
          arrangeBudgetLevel(subLevel, budgetMap);
        });
      }

      fillLevelBudget(level, levelMap);

      if (angular.isUndefined(level.sumN)) {
        level.sumN = level.sum;
        level.sumProfitN = 0;
      } else {
        level.sumProfitN = level.sumN - level.sum;
      }

      level.sumNOld = level.sumN;
    }

    function arrangeBudgetItem(item, budgetMap) {
      item.salesPriceN = item.salesPriceNOld ? item.salesPriceNOld : item.inventoryCostPrice;
      item.workersPriceN = item.workersPriceNOld ? item.workersPriceNOld : item.workerCostPrice;
      item.inventoryProfitN = item.inventoryCostPrice - item.salesPriceN;
      item.workerProfitN = item.workerCostPrice - item.workersPriceN;

      if (item.items && item.items.length > 0) {
        item.items.forEach(function (subItem) {
          return arrangeBudgetItem(subItem, budgetMap);
        });
      } else {
        if (item.rowStyle !== 'Worker' && item.rowStyle !== 'Subcontractor') {
          var supplierId = 'unknown';
          var supplierName = 'No Supplier';

          if (item.matID) {
            if (item.inventoryType === 'Material') {
              var material = vm.materials.find(function (x) {
                return x._id === item.matID;
              });

              if (material) {
                if (material.groupId && material.groupId._id) {
                  var matItem = budgetMap.material[material.groupId._id];

                  if (!matItem) {
                    matItem = {
                      _id: material.groupId._id,
                      name: material.groupId.name,
                      items: [],
                      expand: false,
                      costPrice: 0,
                      calculatedPrice: 0,
                      negotiatedPrice: 0,
                      profitPercent: 0,
                      profit: 0,
                      profitN: 0
                    };
                    budgetMap.material[material.groupId._id] = matItem;
                  }

                  matItem.items.push(item);
                  matItem.costPrice += item.inventoryCostPrice;
                  matItem.calculatedPrice += item.salesPrice;
                  matItem.negotiatedPrice += item.salesPriceN;
                  matItem.profit += item.inventoryProfit;
                  matItem.profitN += item.inventoryProfitN;
                }

                if (material.supplier && material.supplier._id) {
                  supplierId = material.supplier._id;
                  supplierName = material.supplier.name;
                }
              }
            } else if (item.inventoryType === 'Equipment') {
              var equipment = vm.equipments.find(function (x) {
                return x._id === item.matID;
              });

              if (equipment) {
                if (equipment.groupId && equipment.groupId._id) {
                  var eqpItem = budgetMap.equipment[equipment.groupId._id];

                  if (!eqpItem) {
                    eqpItem = {
                      _id: equipment.groupId._id,
                      name: equipment.groupId.name,
                      items: [],
                      expand: false,
                      costPrice: 0,
                      calculatedPrice: 0,
                      negotiatedPrice: 0,
                      profitPercent: 0,
                      profit: 0,
                      profitN: 0
                    };
                    budgetMap.equipment[equipment.groupId._id] = eqpItem;
                  }

                  item.rentalPeriod = 0;
                  item.workerCost = 0;
                  item.deliveryCost = utils.num(equipment.deliveryCost);
                  item.deliveryUnit = equipment.unit;

                  if (equipment.currentRate && equipment.currentRate.rooferCost) {
                    item.workerCost = utils.num(equipment.currentRate.rooferCost.value);
                  }

                  if (equipment.owned) {
                    item.rentalPeriod = Math.ceil(Math.random() * 10);
                  }

                  eqpItem.items.push(item);
                  eqpItem.costPrice += item.inventoryCostPrice;
                  eqpItem.calculatedPrice += item.salesPrice;
                  eqpItem.negotiatedPrice += item.salesPriceN;
                  eqpItem.profit += item.inventoryProfit;
                  eqpItem.profitN += item.inventoryProfitN;
                }

                if (equipment.supplier && equipment.supplier._id) {
                  supplierId = equipment.supplier._id;
                  supplierName = equipment.supplier.name;
                }
              }
            }
          }

          var supItem = budgetMap.supplier[supplierId];

          if (!supItem) {
            supItem = {
              _id: supplierId,
              name: supplierName,
              items: [],
              expand: false,
              costPrice: 0,
              calculatedPrice: 0,
              negotiatedPrice: 0,
              profitPercent: 0,
              profit: 0,
              profitN: 0
            };
            budgetMap.supplier[supplierId] = supItem;
          }

          supItem.items.push(item);
          supItem.costPrice += item.inventoryCostPrice;
          supItem.calculatedPrice += item.salesPrice;
          supItem.negotiatedPrice += item.salesPriceN;
          supItem.profit += item.inventoryProfit;
          supItem.profitN += item.inventoryProfitN;
        }

        if (item.rowStyle === 'Combined' || item.rowStyle === 'Worker') {
          var id = 'unknown';
          var name = 'No Material';

          if (item.rowStyle === 'Combined' && item.matID) {
            if (item.inventoryType === 'Material') {
              var _material = vm.materials.find(function (x) {
                return x._id === item.matID;
              });

              if (_material && _material.groupId && _material.groupId._id) {
                id = _material.groupId._id;
                name = _material.groupId.name;
              }
            } else if (item.inventoryType === 'Equipment') {
              var _equipment = vm.equipments.find(function (x) {
                return x._id === item.matID;
              });

              if (_equipment && _equipment.groupId && _equipment.groupId._id) {
                id = _equipment.groupId._id;
                name = _equipment.groupId.name;
              }
            }
          }

          var labItem = budgetMap.labor[id];

          if (!labItem) {
            labItem = {
              _id: id,
              name: name,
              items: [],
              expand: false,
              costPrice: 0,
              calculatedPrice: 0,
              negotiatedPrice: 0,
              profitPercent: 0,
              profit: 0,
              profitN: 0
            };
            budgetMap.labor[id] = labItem;
          }

          labItem.items.push(item);
          labItem.costPrice += item.workerCostPrice;
          labItem.calculatedPrice += item.workersPrice;
          labItem.negotiatedPrice += item.workersPriceN;
          labItem.profit += item.workerProfit;
          labItem.profitN += utils.num(item.workerProfitN);
        } else if (item.rowStyle === 'Subcontractor') {
          var sucItem = budgetMap.subcontractor[item._id];

          if (!sucItem) {
            sucItem = {
              _id: item._id,
              name: item.workerName,
              items: [],
              expand: false,
              costPrice: 0,
              calculatedPrice: 0,
              negotiatedPrice: 0,
              profitPercent: 0,
              profit: 0,
              profitN: 0
            };
            budgetMap.subcontractor[item._id] = sucItem;
          }

          sucItem.items.push(item);
          sucItem.costPrice += item.inventoryCostPrice;
          sucItem.calculatedPrice += item.salesPrice;
          sucItem.negotiatedPrice += item.salesPriceN;
          sucItem.profit += item.inventoryProfit;
          sucItem.profitN += utils.num(item.inventoryProfitN);
        }
      }
    }

    function fillLevelBudget(level, budgetMap) {
      level.budgets = {
        material: {
          budgets: [],
          name: $filter('translate')("Materials"),
          type: 'mat',
          subName: 'Material Name',
          expand: false
        },
        labor: {
          budgets: [],
          name: $filter('translate')("Labour"),
          type: 'lab',
          subName: 'Task Name',
          expand: false
        },
        equipment: {
          budgets: [],
          name: $filter('translate')("Equipments"),
          type: 'eqp',
          subName: 'Equipment Name',
          expand: false
        },
        supplier: {
          budgets: [],
          name: $filter('translate')("Supplier"),
          type: 'sup',
          subName: 'Material Name',
          expand: false
        },
        subcontractor: {
          budgets: [],
          name: $filter('translate')("Sub-Contractor"),
          type: 'sub',
          subName: 'Task Name',
          expand: false
        },
        all: {
          budgets: [],
          type: 'all'
        }
      };
      fillBudgetFromMap(level.budgets.material, budgetMap.material);
      fillBudgetFromMap(level.budgets.labor, budgetMap.labor);
      fillBudgetFromMap(level.budgets.equipment, budgetMap.equipment);
      fillBudgetFromMap(level.budgets.supplier, budgetMap.supplier);
      fillBudgetFromMap(level.budgets.subcontractor, budgetMap.subcontractor);
      calculateSum(level.budgets.material);
      calculateSum(level.budgets.labor);
      calculateSum(level.budgets.equipment);
      calculateSum(level.budgets.supplier);
      calculateSum(level.budgets.subcontractor);
      fillAll(level.budgets);
    }

    function fillBudgetFromMap(budget, map) {
      for (var key in map) {
        var item = map[key];

        if (item) {
          optimizeBudgetItem(item);
          item.type = budget.type;
          budget.budgets.push(item);
        }
      }
    }

    function calculateSum(budgetLevel) {
      budgetLevel.costPrice = 0;
      budgetLevel.calculatedPrice = 0;
      budgetLevel.negotiatedPrice = 0;
      budgetLevel.negotiatedPriceOld = 0;
      budgetLevel.profitPercent = 0;
      budgetLevel.profit = 0;
      budgetLevel.profitN = 0;
      budgetLevel.profitNPercent = 0;
      budgetLevel.budgets.forEach(function (budget) {
        budget.profitPercent = budget.calculatedPrice === 0 ? 0 : budget.profit / budget.calculatedPrice * 100;
        budgetLevel.costPrice += budget.costPrice;
        budgetLevel.calculatedPrice += budget.calculatedPrice;
        budgetLevel.negotiatedPrice += budget.negotiatedPrice;
        budgetLevel.profit += budget.profit;
        budgetLevel.profitN += budget.profitN;
      });
      budgetLevel.profitPercent = budgetLevel.calculatedPrice === 0 ? 0 : budgetLevel.profit / budgetLevel.calculatedPrice * 100;
      budgetLevel.profitNPercent = budgetLevel.negotiatedPrice === 0 ? 0 : budgetLevel.profitN / budgetLevel.negotiatedPrice * 100;
      budgetLevel.negotiatedPriceOld = budgetLevel.negotiatedPrice;
    }

    function fillAll(allBudget) {
      allBudget.all.costPrice = 0;
      allBudget.all.calculatedPrice = 0;
      allBudget.all.negotiatedPrice = 0;
      allBudget.all.negotiatedPriceOld = 0;
      allBudget.all.profitPercent = 0;
      allBudget.all.profit = 0;
      allBudget.all.profitN = 0;
      allBudget.all.profitNPercent = 0;
      var keys = ['material', 'supplier', 'labor', 'subcontractor', 'equipment'];

      for (var i = 0; i < keys.length; i++) {
        var budget = allBudget[keys[i]];

        if (budget.budgets.length > 0) {
          allBudget.all.budgets.push(budget);

          if (keys[i] !== 'material' && keys[i] !== 'equipment') {
            allBudget.all.costPrice += budget.costPrice;
            allBudget.all.calculatedPrice += budget.calculatedPrice;
            allBudget.all.negotiatedPrice += budget.negotiatedPrice;
            allBudget.all.profit += budget.profit;
            allBudget.all.profitN += budget.profitN;
          }
        }
      }

      allBudget.all.profitPercent = allBudget.all.calculatedPrice === 0 ? 0 : allBudget.all.profit / allBudget.all.calculatedPrice * 100;
      allBudget.all.profitNPercent = allBudget.all.negotiatedPrice === 0 ? 0 : allBudget.all.profitN / allBudget.all.negotiatedPrice * 100;
      allBudget.all.negotiatedPriceOld = allBudget.all.negotiatedPrice;
    }

    function optimizeBudgetItem(budget) {
      var matMap = {};
      budget.items.forEach(function (subItem) {
        var matId = subItem.matID ? subItem.matID : utils.bsonId();
        var matItem = matMap[matId];

        if (!matItem) {
          matMap[matId] = subItem;
        } else {
          if (!matItem.subItems) {
            matItem = {
              matID: matItem.matID,
              inventoryType: matItem.inventoryType,
              inventoryName: matItem.inventoryName,
              workerID: matItem.workerID,
              workerName: matItem.workerName,
              inventoryUnit: matItem.inventoryUnit,
              workerUnit: matItem.workerUnit,
              inventoryUnitPrice: matItem.inventoryUnitPrice,
              workerUnitPrice: matItem.workerUnitPrice,
              wastePercent: matItem.wastePercent,
              workerCompanyCost: matItem.workerCompanyCost,
              inventoryCompanyCost: matItem.inventoryCompanyCost,
              labourHours: matItem.labourHours,
              inventoryCostPrice: matItem.inventoryCostPrice,
              workerCostPrice: matItem.workerCostPrice,
              inventoryAmount: matItem.inventoryAmount,
              workerAmount: matItem.workerAmount,
              inventoryProfit: matItem.inventoryProfit,
              workerProfit: matItem.workerProfit,
              inventoryProfitPercent: matItem.inventoryProfitPercent,
              workerProfitPercent: matItem.workerProfitPercent,
              inventoryProfitN: matItem.inventoryProfitN,
              workerProfitN: matItem.workerProfitN,
              salesPrice: matItem.salesPrice,
              workersPrice: matItem.workersPrice,
              salesPriceN: matItem.salesPriceN,
              workersPriceN: matItem.workersPriceN,
              subItems: [matItem],
              modelId: matItem.modelId,
              objectId: matItem.objectId,
              modelType: matItem.modelType
            };
            matMap[matId] = matItem;
          }

          matItem.subItems.push(subItem);
          matItem.salesPrice += subItem.salesPrice;
          matItem.workersPrice += subItem.workersPrice;
          matItem.salesPriceN += subItem.salesPriceN;
          matItem.workersPriceN += subItem.workersPriceN;
          matItem.workerCompanyCost += subItem.workerCompanyCost;
          matItem.inventoryCompanyCost += subItem.inventoryCompanyCost;
          matItem.labourHours += subItem.labourHours;
          matItem.inventoryCostPrice += subItem.inventoryCostPrice;
          matItem.workerCostPrice += subItem.workerCostPrice;
          matItem.inventoryAmount += subItem.inventoryAmount;
          matItem.workerAmount += subItem.workerAmount;
          matItem.inventoryProfit += subItem.inventoryProfit;
          matItem.workerProfit += subItem.workerProfit;
          matItem.inventoryProfitN += subItem.inventoryProfitN;
          matItem.workerProfitN += subItem.workerProfitN;
        }
      });
      budget.items = [];

      for (var key in matMap) {
        if (matMap[key]) {
          budget.items.push(matMap[key]);
        }
      }

      budget.negotiatedPriceOld = budget.negotiatedPrice;
    }

    function findTotals(table) {
      if (table.items.length > 0) {
        table.items.map(function (item) {
          if (item.inventoryName) {
            $scope.totalInventoryCost = $scope.totalInventoryCost + item.inventoryCostPrice;
          }

          if (item.workerName) {
            $scope.totalWorkerCost = $scope.totalWorkerCost + item.workerCostPrice;
          }
        });
      }

      if (table.levels) {
        table.levels.map(function (subLevel) {
          return findTotals(subLevel);
        });
      }
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('termsAndConditions', {
    controller: TermsAndConditionsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/auth/termsAndConditions/termsAndConditions.view.html'
  });
  /** @ngInject */

  function TermsAndConditionsController() {// const vm = this
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('tenderList', {
    controller: TenderListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/auth/tenderList/tenderList.view.html'
  });
  /** @ngInject */

  function TenderListController($scope, apiFactory, Notification, $log, utils, $uibModal, globals) {
    var vm = this;
    vm.currentPage = 1;
    $scope.totalCount = 0;
    $scope.numPerPage = globals.numPerPage();
    $scope.noOfPages = 0;
    $scope.isList = true;

    $scope.onListView = function (is_list) {
      $scope.isList = is_list;
    };

    $scope.selTender = function (event, index) {
      var type = event.target.type || event.target.nodeName;
      type = angular.isDefined(type) ? type.toLowerCase() : undefined;

      if (type == 'img' || type == 'btn' || type == 'submit') {
        event.stopPropagation();
      } else {
        $scope.activedTender = index + 1;
        angular.element('#tenderModal').modal('show');
      }
    };

    $scope.publicTenders = [];
    $scope.isLoading = true;

    $scope.getPublicTenders = function () {
      apiFactory.publicTenders({
        page: vm.currentPage,
        chunk: $scope.numPerPage
      }).then(function (resp) {
        $scope.publicTenders = resp.data.list;
        $scope.totalCount = resp.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
        $scope.isLoading = false;
      })["catch"](function (err) {
        Notification.error('Failed in login');
        $log.error(err);
        $scope.isLoading = false;
      });
    };

    $scope.getPublicTenders();

    $scope.deleteProject = function (projectId) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.deletePublicTender(projectId).then(function (res) {
          $scope.isLoading = false;
          Notification.success(res.data.message);
          $scope.getPublicTenders();
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }, function () {});
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('setPassword', {
    controller: SetPasswordController,
    controllerAs: 'vm',
    templateUrl: 'app/main/auth/setPassword/setPassword.view.html'
  });
  /** @ngInject */

  function SetPasswordController($scope, apiFactory, Notification, $timeout, $location, $state, $log, utils) {
    var vm = this;

    var _$location$search = $location.search(),
        token = _$location$search.token;

    if (!token) {
      Notification.error("Token is invalid.");
      return;
    }

    vm.user = undefined;
    $scope.loading = true;
    apiFactory.isTokenValid({
      token: token
    }).then(function (resp) {
      if (resp.data.tokenValid) {
        vm.user = resp.data.user;
      } else {
        Notification.error("Token is invalid.");
      }

      $scope.loading = false;
    })["catch"](function (e) {
      $scope.loading = false;
      $log.error(e);
      Notification.error("Something is wrong.");
    });
    vm.resetPassData = {};

    vm.resetPass = function () {
      if (utils.isEmpty(vm.user)) {
        Notification.error("Token is invalid.");
        return;
      }

      if (utils.isEmpty(vm.resetPassData.password)) {
        Notification.error("Please enter new password");
        return;
      }

      if (utils.isEmpty(vm.resetPassData.c_password)) {
        Notification.error("Please enter confirm password");
        return;
      }

      if (vm.resetPassData.password !== vm.resetPassData.c_password) {
        Notification.error("Password Mismatch, Please enter same password");
        return;
      }

      apiFactory.setPassword({
        password: vm.resetPassData.password,
        user: vm.user
      }).then(function (resp) {
        Notification.success(resp.data.message);
        $state.go("login");
      })["catch"](function (e) {
        $log.info(e);
      });
    };

    vm.back = function () {
      $timeout(function () {
        $state.go("login");
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('register', {
    controller: RegisterController,
    controllerAs: 'vm',
    templateUrl: 'app/main/auth/register/register.view.html'
  });
  /** @ngInject */

  function RegisterController(apiFactory, Notification, $state, globals, $scope) {
    var vm = this;
    vm.registerData = {};
    vm.registerData.dialCode = '45';
    globals.getCountryCode().then(function (resp) {
      vm.getCountryCode = resp.data;

      vm.loadCountryCode = function () {
        return new Promise(function (resolve) {
          resolve(resp.data);
        });
      };
    });
    globals.getCountryCode().then(function (resp) {
      vm.getCountries = resp.data;
      vm.getCountries.sort(function (a, b) {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });

      vm.loadCountries = function () {
        return new Promise(function (resolve) {
          resolve(resp.data);
        });
      };
    });

    vm.register = function (formData) {
      if (!vm.registerData.name) {
        Notification.error('Please enter name');
        return;
      }

      var reg = /\S+@\S+\.\S+/;

      if (!reg.test(vm.registerData.email)) {
        Notification.error('Please enter valid email');
        return;
      }

      if (!vm.registerData.dialCode) {
        Notification.error('Please enter dial code');
        return;
      }

      if (!vm.registerData.phoneNumber) {
        Notification.error('Please enter phone number');
        return;
      }

      if (!vm.registerData.companyName) {
        Notification.error('Please enter company name');
        return;
      }

      if (!vm.registerData.addressLine1) {
        Notification.error('Please enter address');
        return;
      }

      if (!vm.registerData.postalCode) {
        Notification.error('Please enter postal code');
        return;
      } // if (!vm.registerData.countryCode) {
      //   Notification.error('Please enter countryCode')
      //   return;
      // }


      if (!vm.registerData.city) {
        Notification.error('Please enter city');
        return;
      }

      vm.registerData.countryCode = vm.registerData.dialCode;

      if (!$scope.isAccepted) {
        Notification.error('Please confirm if you accept terms and policy');
        return;
      }

      if (!vm.registerData.countryName) {
        Notification.error('Please select country');
        return;
      }

      apiFactory.registration(formData).then(function (resp) {
        Notification.success(resp.data.message);
        vm.registerData.companyName = "";
        vm.registerData.name = "";
        vm.registerData.email = "";
        vm.registerData.dialCode = "";
        vm.registerData.phoneNumber = "";
        vm.registerData.addressLine1 = "";
        vm.registerData.addressLine2 = "";
        vm.registerData.city = "";
        vm.registerData.postalCode = "";
        vm.registerData.countryCode = "";
        Notification.success('Register success');
        $state.go('login');
      })["catch"](function (err) {
        Notification.error(err.data.message);
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('preLogin', {
    controller: preLoginController,
    controllerAs: 'vm',
    templateUrl: 'app/main/auth/preLogin/preLogin.view.html'
  });
  /** @ngInject */

  function preLoginController() {//   const vm = this;
  }
})();


"use strict";

var firebase;

(function () {
  'use strict';

  angular.module('app').component('login', {
    controller: LoginController,
    controllerAs: 'vm',
    templateUrl: 'app/main/auth/login/login.view.html'
  });
  /** @ngInject */

  function LoginController($state, $scope, $window, $location, $log, $uibModal, apiFactory, Notification, localStorageService, globals, utils, $filter, storageFactory, synergySocket, synergyOrgChatSocket) {
    // reset synergy socket connection
    synergySocket.reset();
    synergyOrgChatSocket.reset();
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore;
    vm.loginData = localStorageService.get('cloud-loginData');

    if (vm.loginData) {
      vm.loginData.designation = vm.loginData.designation ? vm.loginData.designation : "subscriber";

      if (vm.loginData.rememberMe) {
        if (globals.checkLogin()) {
          var user = userStore.get();
          processLogin(user);
          return;
        }
      }
    } else {
      vm.loginData = {
        email: '',
        password: '',
        rememberMe: false,
        designation: 'subscriber'
      };
    }

    vm.setDesignation = function (value) {
      vm.loginData.designation = value;
    };

    vm.login = function (formData) {
      var loginData = {
        email: formData.email,
        password: formData.password,
        rememberMe: formData.rememberMe
      };
      $scope.loading = true;

      if (formData.designation === "subscriber") {
        apiFactory.login(loginData).then(function (resp) {
          localStorageService.set('access-token', resp.data.token);
          processLogin(resp.data.user);
        })["catch"](function (err) {
          $scope.loading = false;
          Notification.error('Failed in login');
          $log.error(err);
        });
      } else if (formData.designation === "client") {
        apiFactory.loginAsClient(loginData).then(function (resp) {
          if (resp.data.verified) {
            localStorageService.set('access-token', resp.data.token);
            processLogin(resp.data.user);
          } else {
            $scope.loading = false;
            showCompaniesPopup(resp.data.companies);
          }
        })["catch"](function (err) {
          $scope.loading = false;
          Notification.error('Failed in login');
          $log.error(err);
        });
      } else {
        apiFactory.loginAsGuest(loginData).then(function (resp) {
          if (resp.data.verified) {
            localStorageService.set('access-token', resp.data.token);
            processLogin(resp.data.user);
          } else {
            $scope.loading = false;
            showCompaniesPopup(resp.data.companies.user);
          }
        })["catch"](function (err) {
          $scope.loading = false;
          Notification.error('Failed in login');
          $log.error(err);
        });
      }
    };

    function processLogin(data) {
      initFirebase();
      init(data);
      /*  .then(currentToken => {
          if (currentToken) {
            apiFactory.twilioRegisterBinding({
              'identity': data.user._id,
              'address': currentToken,
              'bindingType': 'fcm'
            })
              .then(() => {
                $scope.loading = false;
                init(data);
              })
              .catch(err => {
                $log.error(err);
                $scope.loading = false;
                init(data);
              })
          } else {
            Notification.error('No Instance ID token available. Request permission to generate one.');
          }
        })
        .catch(err => {
          $scope.loading = false;
          $log.error('An error occurred while retrieving token. ', err);
          Notification.error('Firebase push notification is blocked. Please unblock it in your browser settings');
        });*/
    }

    function initFirebase() {
      var firebaseConfig = {
        apiKey: "AIzaSyAMRTh6THgKQ0bwGOd64U9DZ6gL9GBEX7g",
        authDomain: "cloudes-ocr.firebaseapp.com",
        databaseURL: "https://cloudes-ocr.firebaseio.com",
        projectId: "cloudes-ocr",
        storageBucket: "cloudes-ocr.appspot.com",
        messagingSenderId: "358322205035",
        appId: "1:358322205035:web:b967454ba29168771b9c2e",
        measurementId: "G-8S6QYEFYQZ"
      };

      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }
      /*
      // Retrieve Firebase Messaging object.
      const messaging = firebase.messaging();
       return new Promise((resolve, reject) => {
        messaging.requestPermission()
          .then(() => {
            // Get Instance ID token. Initially this makes a network call, once retrieved
            // subsequent calls to getToken will return from cache.
            messaging.getToken()
              .then(currentToken => {
                resolve(currentToken);
              })
              .catch(err => {
                reject(err);
              });
          })
          .catch(err => {
            reject(err);
          });
      });*/

    }

    function init(user) {
      var userData = userStore.get();

      if (user.email !== userData.email) {
        projectStore.reset();
      }

      userStore.set(user);

      if (vm.loginData.rememberMe) {
        localStorageService.set('cloud-loginData', vm.loginData);
      } else {
        localStorageService.remove('cloud-loginData');
      }

      if (!projectStore.get()) {
        storageFactory.getBookmarks().then(function (resp) {
          var bookmarks = resp.data.bookmarks;

          if (bookmarks && bookmarks.length > 0) {
            projectStore.set(bookmarks[0]);
          } else {
            projectStore.set({
              _id: "all",
              projectName: $filter('translate')("All Projects")
            });
          }

          storageFactory.listAllProjects().then(function (res) {
            var query = {};
            var projects = res.data.list;
            query.projects = projects.map(function (element) {
              return element._id;
            });
            apiFactory.rebuildFinanceAggregationData(query);
            initSynergyChat(user);
          });
        })["catch"](function (err) {
          userStore.reset();
          globals.logout();
          $location.path('/login');
          $scope.loading = false;
          $log.error(err);
        });
      } else {
        initSynergyChat(user);
      }
    }

    function initSynergyChat(user) {
      $scope.loading = true;
      var promises = [apiFactory.getSynergyChatToken(), apiFactory.getSynergyOrgChatToken()];
      Promise.all(promises).then(function (resp) {
        var chatTokenResp = resp[0];
        $log.log("login component -- init synergy chat -- chat token resp -- ", chatTokenResp);

        if (chatTokenResp && chatTokenResp.data && chatTokenResp.data.success) {
          globals.syenrgyStore.setClientToken(chatTokenResp.data); // reset socket connection to establish identity

          synergySocket.reset();
        } else {
          $log.log("login component -- init synergy chat -- ", "invalid chat token response -- ", chatTokenResp);
        }

        var orgChatTokenResp = resp[1];
        $log.log("login component -- init synergy chat -- org chat token resp -- ", orgChatTokenResp);

        if (orgChatTokenResp && orgChatTokenResp.data && orgChatTokenResp.data.success) {
          globals.syenrgyOrgChatStore.setOrgChatClientToken(orgChatTokenResp.data); // reset org chat socket connection to establish identity

          synergyOrgChatSocket.reset();
        } else {
          $log.log("login component -- init synergy chat -- ", "invalid org chat token response -- ", orgChatTokenResp);
        }

        $scope.loading = false;
        gotoPage(user);
      })["catch"](function (err) {
        $log.error(err);
        $scope.loading = false;
        gotoPage(user);
      });
    }

    function gotoPage(user) {
      if (!utils.isEmpty(localStorageService.get("redirect-meeting-url"))) {
        $window.location.href = localStorageService.get("redirect-meeting-url");
        localStorageService.remove("redirect-meeting-url");
      } else {
        $state.go(globals.getDashboardRoute(user));
      }

      vm.loginData.email = null;
      vm.loginData.password = null;
      Notification.success('Login success');
    }

    function showCompaniesPopup(_companies) {
      $uibModal.open({
        animation: false,
        component: 'authCompaniesModal',
        windowClass: 'auth-companies-modal',
        keyboard: false,
        resolve: {
          companies: function companies() {
            return _companies;
          }
        }
      }).result.then(function (result) {
        $scope.loading = true;
        var endPoint = vm.loginData.designation === "client" ? "loginAsClient" : "loginAsGuest";
        apiFactory[endPoint]({
          email: vm.loginData.email,
          password: vm.loginData.password,
          rememberMe: vm.loginData.rememberMe,
          companyId: result
        }).then(function (resp) {
          if (resp.data.verified) {
            processLogin(resp.data);
          } else {
            $scope.loading = false;
            Notification.error('Failed in login');
          }
        })["catch"](function (err) {
          $scope.loading = false;
          Notification.error('Failed in login');
          $log.error(err);
        });
      }, function () {});
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('forgetPassword', {
    controller: ForgetPasswordController,
    controllerAs: 'vm',
    templateUrl: 'app/main/auth/forgetPassword/forgetPassword.view.html'
  });
  /** @ngInject */

  function ForgetPasswordController(apiFactory, Notification, utils) {
    var vm = this;
    vm.forgotPassData = {};

    vm.forgotPass = function (formData) {
      if (utils.isEmpty(formData.email)) {
        Notification.error('Please enter valid email address.');
      }

      apiFactory.forgotPassword(formData).then(function (resp) {
        Notification.success(resp.data.message);
      })["catch"](function (err) {
        Notification.error(err.data.message);
      });
    };
  }
})();


"use strict";

(function () {
  angular.module('app.core').directive('waitingIndicator', waitingIndicator);

  function waitingIndicator() {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/waiting-indicator/waiting-indicator.view.html',
      link: function link() {}
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').directive('timePicker', timePicker);

  function timePicker($timeout, globals) {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/time-picker/time-picker.view.html',
      replace: true,
      scope: {
        ngModel: "=",
        ngChange: "=",
        icon: "@",
        placeholder: "@",
        disabled: "="
      },
      link: function link(scope, element) {
        var companyStore = globals.companyStore;
        var companyData = companyStore.get();
        scope.is12Format = companyData && companyData.timeShowMethod === '12 hr';
        scope.opened = false;
        scope.hour = 0;
        scope.minute = 0;
        scope.isPm = false;
        var hours = element.find("#time-picker-hours")[0];
        var minutes = element.find("#time-picker-minutes")[0];
        hours.addEventListener("input", formatHours);
        minutes.addEventListener("input", formatMinutes);
        scope.$watch('ngModel', function (newVal) {
          if (angular.isDefined(newVal)) {
            var date = new Date(newVal);
            setFields(date);
          }
        });

        scope.onAmPm = function ($event, pm) {
          $event.stopPropagation();
          scope.isPm = pm;
        };

        scope.onOK = function () {
          var date = scope.ngModel ? scope.ngModel : new Date();

          if (scope.is12Format) {
            date.setHours(scope.hour + (scope.isPm ? 12 : 0), scope.minute, 0, 0);
          } else {
            date.setHours(scope.hour, scope.minute, 0, 0);
          }

          scope.ngModel = date;

          if (scope.ngChange) {
            scope.ngChange(scope.ngModel);
          }
        };

        function setFields(date) {
          if (date) {
            scope.hour = date.getHours();
            scope.minute = date.getMinutes();
            scope.isPm = scope.hour > 12;

            if (scope.is12Format) {
              scope.hour %= 12;
            }
          } else {
            scope.hour = 0;
            scope.minute = 0;
            scope.isPm = false;
          }
        }

        function formatHours() {
          hours.value = addLeadingZero(hours.value);
        }

        function formatMinutes() {
          minutes.value = addLeadingZero(minutes.value);
        }

        function addLeadingZero(value) {
          return value.length < 2 ? "0" + value : value;
        }

        $timeout(function () {
          formatHours();
          formatMinutes();
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app.core').directive('tabContainer', tabContainer);
  angular.module('app.core').directive('tabPage', tabPage);

  function tabContainer($timeout) {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      templateUrl: 'app/core/directives/tab/tab.view.html',
      scope: {
        tabs: '=',
        add: '@',
        newTab: '&'
      },
      link: function link(scope) {
        scope.curTab = undefined;

        scope.selectTab = function (tab) {
          if (scope.curTab === tab.id) return;
          scope.curTab = tab.id;
          var elements = angular.element('.common-tab-container .tab-page');

          if (elements) {
            for (var i = 0; i < elements.length; i++) {
              var element = angular.element(elements[i]);

              if (element.attr('tab-id') === scope.curTab) {
                element.show();
              } else {
                element.hide();
              }
            }
          }
        };

        scope.$watch('tabs', function (newVal) {
          if (newVal) {
            $timeout(function () {
              return scope.selectTab(scope.tabs[0]);
            });
          }
        });
      }
    };
  }

  function tabPage() {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      template: '<div class="tab-page" ng-transclude></div>',
      link: function link() {}
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module("app").directive("synergyChat", synergyChat);

  function synergyChat(globals, $log, apiFactory, Notification, synergySocket, SYNERGY_CONSTANTS, utils, $timeout) {
    return {
      restrict: "E",
      templateUrl: "app/core/directives/synergy-chat/synergy-chat.view.html",
      scope: {
        externLoading: "=",
        roomEid: "@"
      },
      link: function link($scope) {
        $scope.userData = globals.userStore.get();
        $scope.projectData = globals.projectStore.get();
        var messageParams = undefined;
        var currTotal = 0;
        var editingMessage = undefined;
        var editedMessageList = [];
        /**
         * use this before roomEid is available
         */

        function init() {
          $scope.isValidRoom = false;
          messageParams = undefined;
          currTotal = 0;
        }

        init();

        function updateTypingIndicator() {
          var message = "Typing: ";
          var names = Array.from($scope.typingMembers).slice(0, 3);

          if ($scope.typingMembers.size) {
            message += names.join(", ");
          }

          if ($scope.typingMembers.size > 3) {
            message += ", and " + ($scope.typingMembers.size - 3) + "more";
          }

          if ($scope.typingMembers.size) {
            message += "...";
          } else {
            message = "";
          }

          $scope.typingMessage = message;
        }

        function onNewMessageReceived(data) {
          $log.log("synergy chat directive -- on new message received -- data -- ", data);
          var roomEid = data.roomEid,
              post = data.post;

          if (!roomEid || !post) {
            $log.log("on new message received -- invalid roomEid or post");
            return;
          }

          var authorUid = post.postedByUser.uid;

          if (roomEid === $scope.roomEid && $scope.userData._id.toString() !== authorUid) {
            // update message listing with new post
            addMessage(post, true);

            if (Number.isInteger(currTotal)) {
              currTotal = currTotal + 1;
              $log.log("on new message received -- ", "incremented total messages by 1 -- ", currTotal);
            }
          }
        } // data - { roomEid, uid }


        function computeTypingUserName(data) {
          var typingUserName = "";
          var roomEid = data.roomEid,
              uid = data.uid;

          if (!roomEid || !uid) {
            // invalid roomEid or uid
            return typingUserName;
          }

          if (roomEid !== $scope.roomEid) {
            // event doesn't belong to selected issue chat room
            return;
          }

          if ($scope.userData._id.toString() === uid) {
            // need not show typing message for self
            return typingUserName;
          }

          var typingUser = $scope.memberUsers.find(function (mu) {
            return mu._id.toString() === uid;
          });

          if (!typingUser) {
            // typing member user not found
            return typingUserName;
          }

          typingUserName = uid;

          if (typingUser.displayName) {
            typingUserName = typingUser.displayName;
          } else if (typingUser.firstName) {
            typingUserName = typingUser.firstName;
          }

          return typingUserName;
        }

        function onTypingStarts(data) {
          // $log.log("on typing starts -- data: ", data);
          var typingUserName = computeTypingUserName(data);

          if (typingUserName) {
            $scope.typingMembers.add(typingUserName);
            updateTypingIndicator();
          }
        }

        function onTypingStops(data) {
          // $log.log("on typing stops -- data: ", data);
          var typingUserName = computeTypingUserName(data);

          if (typingUserName) {
            $scope.typingMembers["delete"](typingUserName);
            updateTypingIndicator();
          }
        }

        function onMessageUpdated(data) {
          $log.log("on message updated -- data: ", data);
          var roomEid = data.roomEid,
              post = data.post;

          if (roomEid !== $scope.roomEid) {
            // message doesn't belong to selected issue chat room
            return;
          }

          var messageEid = post.messageEid;
          var mIndex = $scope.currentMessages.findIndex(function (cm) {
            return cm.messageEid === messageEid;
          });

          if (mIndex < 0) {
            // updated message not available in current messages
            return;
          }

          var currPost = $scope.currentMessages[mIndex];
          var messageText = post.message.messageText;
          currPost.message.messageText = messageText;
          $scope.currentMessages[mIndex] = currPost;
          editedMessageList.push(messageEid);
          $timeout(function () {
            $scope.$apply();
          });
        }

        function onMessageDeleted(data) {
          // $log.log("on message deleted -- data: ", data);
          var roomEid = data.roomEid,
              messageEid = data.messageEid;

          if (roomEid !== $scope.roomEid) {
            // message doesn't belong to selected issue chat room
            return;
          }

          var mIndex = $scope.currentMessages.findIndex(function (cm) {
            return cm.messageEid === messageEid;
          });

          if (mIndex < 0) {
            // deleted message not available in current messages
            return;
          }

          $scope.currentMessages.splice(mIndex, 1); // Update "currTotal" and "messageParams"

          if (currTotal && messageParams && messageParams.total) {
            currTotal = currTotal - 1;
            messageParams.total = messageParams.total - 1;
          }
        }

        function subscribeChatEvents() {
          $log.log("synergy chat directive -- subscribe chat events");
          synergySocket.on(SYNERGY_CONSTANTS.SERVER_EVENT_NEW_MESSAGE, onNewMessageReceived);
          synergySocket.on(SYNERGY_CONSTANTS.SERVER_EVENT_TYPING_STARTS, onTypingStarts);
          synergySocket.on(SYNERGY_CONSTANTS.SERVER_EVENT_TYPING_STOPS, onTypingStops);
          synergySocket.on(SYNERGY_CONSTANTS.SERVER_EVENT_MESSAGE_EDIT, onMessageUpdated);
          synergySocket.on(SYNERGY_CONSTANTS.SERVER_EVENT_MESSAGE_DELETE, onMessageDeleted);
        }

        function unsubscribeChatEvents() {
          $log.log("synergy chat directive -- unsubscribe chat events");
          synergySocket.off(SYNERGY_CONSTANTS.SERVER_EVENT_NEW_MESSAGE);
        }

        function makeSearchText() {
          var words = $scope.messageBody.split(" ");
          var searchWords = words.filter(function (x) {
            return x.includes("@");
          });

          if (searchWords.length) {
            $scope.searchText = searchWords[searchWords.length - 1].replace("@", "");
          }
        }

        function applySelectedName() {
          $scope.messageBody = $scope.messageBody.replace("@" + $scope.searchText, "@" + $scope.selectedName);
        }
        /**
         * use this after roomEid is available
         */


        function initChatData() {
          $log.log("synergy-chat.directive.js -- initChatData");
          $scope.isValidRoom = true;
          $scope.currentMessages = [];
          $scope.memberUsers = [];
          $scope.typingMembers = new Set();
          $scope.typingMessage = "";
          $scope.attachmentFiles = [];
          $scope.isSearch = false;
          $scope.memberNames = [];
          $scope.selectedName = "";
          $scope.searchText = "";

          if (!$scope.roomEid) {
            $log.log("initChatData -- error -- invalid roomEid");
            return;
          }

          fetchIssueChatMemberUsers();
        }

        function fetchIssueChatMemberUsers() {
          $scope.loading = true;
          apiFactory.getMemberUsersInIssue($scope.roomEid).then(function (resp) {
            if (resp && resp.data && resp.data.success) {
              if (resp.data.users && angular.isArray(resp.data.users) && resp.data.users.length > 0) {
                $scope.loading = false;
                $log.log("fetched member users for issue room -- ", resp.data.users);
                $scope.memberUsers = resp.data.users;
                var otherUsers = $scope.memberUsers.filter(function (mu) {
                  return mu._id.toString() !== $scope.userData._id.toString();
                });
                $scope.memberNames = otherUsers.map(function (u) {
                  return u.firstName;
                }); // $log.log("members names: ", $scope.memberNames);
              }

              subscribeChatEvents();
              initFetchMsgsInRoom();
            } else {
              throw new Error("error -- ", "synergy-chat directive -- ", "init chat data -- ", "invalid response");
            }
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error("Error in fetching issue chat users");
          });
        }

        function initFetchMsgsInRoom() {
          if (!$scope.roomEid) {
            $log.log("initFetchMsgsInRoom -- error -- invalid roomEid");
            return;
          }

          var token = globals.syenrgyStore.getValidClientToken();

          if (!token) {
            fetchToken();
          } else {
            $scope.token = token;
            fetchMsgsInRoom();
          }
        }

        function fetchToken() {
          $scope.loading = true;
          apiFactory.getSynergyChatToken().then(function (resp) {
            if (resp && resp.data && resp.data.success) {
              globals.syenrgyStore.setClientToken(resp.data);
              $scope.token = resp.data.token;
              $scope.loading = false;
              fetchMsgsInRoom();
            } else {
              throw new Error("error -- ", "synergy-chat directive -- ", "get synergy chat token -- ", "invalid response");
            }
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error("Error in fetching token");
          });
        }

        function fetchMsgsInRoom() {
          if (!$scope.roomEid || !$scope.token) {
            $log.log("fetchMsgsInRoom -- error -- invalid roomEid, token");
            return;
          }

          if ($scope.loading) {
            $log.log("fetchMsgsInRoom -- already loading");
            return;
          }

          $scope.loading = true; // default page request options

          var options = {
            page: 0,
            limit: SYNERGY_CONSTANTS.CHAT_MESSAGES_FETCH_LIMIT
          }; // calculate page and limit request param based on total messages and message params

          if (messageParams && Number.isInteger(currTotal) && currTotal > 0) {
            var countNewMessages = currTotal - messageParams.total;
            var pagesNew = Math.floor(countNewMessages / messageParams.limit);
            $log.log("fetchMsgsInRoom -- pagesNew -- ", pagesNew);
            options.page = messageParams.page + 1 + pagesNew;
            options.limit = messageParams.limit;
          }

          $log.log("fetchMsgsInRoom -- options -- ", options);
          /**
           * options - { page, limit, search }
           * get messages request data -- { token, roomEid, options }
           */

          var getMsgsReqData = {
            token: $scope.token,
            roomEid: $scope.roomEid,
            options: options
          };
          synergySocket.emit(SYNERGY_CONSTANTS.CLIENT_EVENT_GET_MESSAGES, getMsgsReqData, function (_ref) {
            var error = _ref.error,
                messages = _ref.messages,
                params = _ref.params;

            if (!utils.isEmpty(error)) {
              $log.log("fetchMsgsInRoom callback -- error -- ", error);
              $scope.loading = false;
              Notification.error(utils.getErrorMessage(error, "Unable to fetch messages"));
            } else {
              $log.log("fetchMsgsInRoom callback -- params -- ", params);
              messageParams = params;

              if (params && params.total && Number.isInteger(params.total)) {
                currTotal = params.total;
                $log.log("fetchMsgsInRoom -- ", "setting total messages from params received -- ", currTotal);
              }

              $scope.loading = false; // add message after processing the list to omit already present messages

              if ($scope.currentMessages && angular.isArray($scope.currentMessages) && $scope.currentMessages.length > 0) {
                var lastMsg = $scope.currentMessages[$scope.currentMessages.length - 1];
                var lastMsgNdx = messages.findIndex(function (m) {
                  return m._id === lastMsg._id;
                });
                $log.log("fetchMsgsInRoom callback -- last message index -- ", lastMsgNdx);

                if (lastMsgNdx >= 0) {
                  messages.splice(0, lastMsgNdx + 1);
                }
              }

              messages.forEach(function (msg) {
                return addMessage(msg);
              });
            }
          });
        }

        function addMessage(message) {
          var isNew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          $log.log("addMessage -- ", message);
          message.userType = false;
          var authorUid = message.postedByUser.uid;
          message.updatedAt = moment(new Date(message.updatedAt)).format("lll");

          if ($scope.userData._id.toString() === authorUid) {
            message.authorName = $scope.userData.displayName;
            message.profilePic = $scope.userData.profilePic;
            message.userType = true;
          } else {
            var index = $scope.memberUsers.findIndex(function (mu) {
              return mu._id.toString() === authorUid;
            });
            message.authorName = index !== -1 ? $scope.memberUsers[index].firstName : authorUid;
            message.profilePic = index !== -1 ? $scope.memberUsers[index].profilePic : null;
          } // keep latest message at top


          $log.log("addMessage -- isNew -- ", isNew);

          if (isNew) {
            $scope.currentMessages.unshift(message);
          } else {
            $scope.currentMessages.push(message);
          }

          $timeout(function () {
            $scope.$apply();
          });
        }

        function updateChatMessage() {
          $log.log("synergy chat directive -- update chat message");
          var _editingMessage = editingMessage,
              messageEid = _editingMessage.messageEid;
          var updateMsgReqData = {
            token: $scope.token,
            messageEid: messageEid,
            messageText: $scope.messageBody
          };
          $scope.loading = true;
          synergySocket.emit(SYNERGY_CONSTANTS.CLIENT_EVENT_EDIT_MESSAGE, updateMsgReqData, function (_ref2) {
            var error = _ref2.error,
                roomEid = _ref2.roomEid;
            $scope.loading = false;
            editingMessage = undefined;

            if (utils.isEmpty(error)) {
              $log.log("update chat message success -- room eid: ", roomEid); // $log.log("update chat message success -- post: ", post);
              // Edit message success UI using socket client listener

              Notification.info("Message updated successfully");
              $scope.messageBody = undefined;
            } else {
              $log.error("update chat message callback error -- ", error);
              Notification.error(error);
            }
          });
        }

        function sendMessage(sendBody) {
          if ($scope.attachmentFiles && $scope.attachmentFiles.length > 0) {
            // TODO: File attachments
            $log.log("send message -- handle attachments");
          } else {
            if (!$scope.messageBody && !sendBody) {
              $log.error("sendMessage -- invalid messageBody, sendBody");
              Notification.error("Please enter a valid message.");
              return;
            }

            if (angular.isDefined(editingMessage)) {
              // TODO: Quote message
              updateChatMessage();
            } else {
              var body = sendBody ? sendBody : $scope.messageBody;
              $log.log("sendMessage -- body :: ", body); // TODO: Advanced Message UI/UX -- "Sending...", "Send Error"
              // using current timestamp as author sequence

              var currTime = moment().valueOf();
              var postMsgReqData = {
                token: $scope.token,
                roomEid: $scope.roomEid,
                messageText: body,
                authorSeq: currTime
              };
              $scope.loading = true;
              synergySocket.emit(SYNERGY_CONSTANTS.CLIENT_EVENT_POST_MESSAGE, postMsgReqData, function (_ref3) {
                var error = _ref3.error,
                    authorSeq = _ref3.authorSeq,
                    roomEid = _ref3.roomEid,
                    post = _ref3.post;
                $scope.loading = false;

                if (!utils.isEmpty(error)) {
                  $log.error("post msg -- callback -- error -- ", error);
                  Notification.error(error);
                } else {
                  $log.log("post msg -- callback -- authorSeq -- ", authorSeq);
                  $log.log("post msg -- callback -- roomEid -- ", roomEid);
                  $log.log("post msg -- callback -- post -- ", post);
                  addMessage(post, true);

                  if (Number.isInteger(currTotal)) {
                    currTotal = currTotal + 1;
                    $log.log("send message success callback -- ", "incremented total messages by 1 -- ", currTotal);
                  }
                }
              });
              $scope.messageBody = undefined;
            }
          }
        }

        $scope.messageBodyInput = function (e, messageBody) {
          var keyCode = e.which || e.keyCode;

          if (keyCode === 13 && !e.ctrlKey) {
            // Pressed key : 'Enter'
            e.preventDefault();

            if ($scope.isSearch) {
              // User mention, Search text
              $scope.isSearch = false;
              applySelectedName();
            } else {
              sendMessage(messageBody);
              return false;
            }
          } else if (keyCode === 64) {
            // Pressed key : '@'
            $scope.isSearch = true;
          } else {
            // User typing in room emit event
            var userTypingReqData = {
              token: $scope.token,
              roomEid: $scope.roomEid
            };
            synergySocket.emit(SYNERGY_CONSTANTS.CLIENT_EVENT_USER_TYPING, userTypingReqData, // ({ error, isNew, roomEid, uid }) => {
            function (_ref4) {
              var error = _ref4.error;

              if (utils.isEmpty(error)) {
                // $log.log("user typing callback -- isNew: ", isNew);
                // $log.log("user typing callback -- roomEid: ", roomEid);
                // $log.log("user typing callback -- uid: ", uid);
                $log.log("user typing callback success");
              } else {
                $log.error("user typing -- callback error: ", error);
              }
            }); // new line on Shift-Enter

            if (keyCode === 13 && e.ctrlKey) {
              $scope.messageBody += "\n";
            } // TODO: Handle Backspace and Delete

          }
        };

        $scope.isEditedMessage = function (eid) {
          return editedMessageList.findIndex(function (x) {
            return x === eid;
          }) !== -1;
        };

        $scope.isFileMessage = function (message) {
          return message.message.messageText.includes("#file#");
        };

        $scope.copyMessage = function (message) {
          $scope.messageBody = angular.copy(message.message.messageText);
          angular.element("#message-input").focus();
          $timeout(function () {
            $scope.$apply();
          });
        };

        $scope.insertSmiley = function () {
          $log.log("synergy chat directive -- insert smiley");
          Notification.info("Coming Soon !!");
        };

        $scope.onAttachFile = function () {
          $log.log("synergy chat directive -- on attach file");
          Notification.info("Coming Soon !!");
        };

        $scope.changeAttacheFiles = function (files) {
          $log.log("synergy chat directive -- chat attache files length -- ", files.length);
        };

        $scope.editMessage = function (message) {
          editingMessage = angular.copy(message);
          $scope.copyMessage(message);
        };

        $scope.deleteMessage = function (message) {
          // $log.log("synergy chat directive -- delete message -- ", message);
          $scope.loading = true;
          var messageEid = message.messageEid;
          var delMsgReqData = {
            token: $scope.token,
            messageEid: messageEid
          };
          synergySocket.emit(SYNERGY_CONSTANTS.CLIENT_EVENT_DELETE_MESSAGE, delMsgReqData, function (_ref5) {
            var error = _ref5.error,
                roomEid = _ref5.roomEid,
                messageEid = _ref5.messageEid;
            $scope.loading = false;

            if (utils.isEmpty(error)) {
              $log.log("delete message success -- room eid: ", roomEid);
              $log.log("delete message success -- message eid: ", messageEid); // $log.log("delete message success -- result: ", result);
              // todo: remove deleted message from current messages list

              Notification.info("Message deleted successfully");
            } else {
              $log.error("delete message failed error: ", error);
              Notification.error(error);
            }
          });
        };

        $scope.quoteMessage = function (message) {
          $log.log("synergy chat directive -- quote message -- ", message);
          $scope.quotingMessage = angular.copy(message);
          angular.element("#message-input").focus();
        };

        $scope.getMessageBody = function (data) {
          if (data.includes("#file#")) {
            var content = data.split("#file#")[1];
            var contentSplits = content.split("#url#");

            if (contentSplits.length < 2) {
              var url = contentSplits[0];
              var names = url.split("/");
              var name = names[names.length - 1];

              if (url.toLowerCase().includes(".jpg") || url.toLowerCase().includes(".png")) {
                data = "<a target=\"_blank\" href=\"".concat(url, "\"><img src=\"").concat(url, "\" class=\"attached-image\" alt=\"\" /></a>");
              } else {
                data = "<a target=\"_blank\" href=\"".concat(url, "\"><img src=\"").concat(utils.getFileIcon(url), "\" class=\"attach-file-icon\" alt=\"\" /><span>").concat(name, "</span></a>");
              }
            } else {
              var _url = contentSplits[1];
              var _name = contentSplits[2].split("#name#")[1];

              if (!utils.isEmpty(_name) && (_name.toLowerCase().includes(".jpg") || _name.toLowerCase().includes(".png"))) {
                data = "<a target=\"_blank\" href=\"".concat(_url, "\"><img src=\"").concat(_url, "\" class=\"attached-image\" alt=\"\" /></a>");
              } else {
                data = "<a target=\"_blank\" href=\"".concat(_url, "\"><img src=\"").concat(utils.getFileIcon(_name), "\" class=\"attach-file-icon\" alt=\"\" /><span>").concat(_name, "</span></a>");
              }
            }
          } else if (data.includes("#quote#")) {
            var quoteBody = data.split("#quoteBody#")[1];
            var quoteDesc = data.split("#quoteDesc#")[1];
            var messageBody = data.split("#messageBody#")[1];
            return "<div class=\"quote-msg\" ng-if=\"ngModel\">\n                      <img class=\"quote-icon\" src=\"/assets/icons/message_orange.svg\" alt=\"\">\n                      <div class=\"message-content\">\n                        <div class=\"message-body\">\n                          ".concat(quoteBody, "\n                        </div>\n                        <div class=\"message-desc\">\n                          ").concat(quoteDesc, "\n                        </div>\n                        <hr>\n                        <div>").concat(messageBody, "</div>\n                      </div>\n                    </div>");
          }

          var words = data.split(" ");
          var atWords = words.filter(function (x) {
            return x.includes("@");
          });

          var _iterator = _createForOfIteratorHelper(atWords),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var word = _step.value;
              data = data.replace(word, "<span style=\"color: #1665D8; font-size: 16px;\">".concat(word, "</span>"));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return data;
        };

        $scope.getChatTime = function (date) {
          return moment().isSame(moment(new Date(date)), "d") ? moment(new Date(date)).format("LT") : date;
        };

        $scope.loadMore = function () {
          if (!messageParams) {
            $log.log("synergy chat directive -- load more -- message params undefined");
            return;
          }

          var _messageParams = messageParams,
              page = _messageParams.page,
              limit = _messageParams.limit,
              total = _messageParams.total;

          if ((page + 1) * limit >= total) {
            $log.log("synergy chat directive", " -- load more", " -- all pages fetched", " -- message parms -- ", messageParams);
            return;
          }

          $log.log("synergy chat directive -- load more -- message params -- ", messageParams); // fetch next page messages

          fetchMsgsInRoom();
        };

        $scope.selectUserName = function (name) {
          $scope.isSearch = false;
          $scope.selectedName = name;
          applySelectedName();
        };

        $scope.selectUserNameCandidate = function (name) {
          $scope.selectedName = name;
        };

        $scope.$watch("roomEid", function () {
          if (!$scope.roomEid) {
            $log.log("scope watch -- error -- roomEid invalid");
            return;
          }

          initChatData();
        });
        $scope.$watch("messageBody", function () {
          if (utils.isEmpty($scope.messageBody)) {
            $scope.searchText = undefined;
            $scope.isSearch = false;
          } else if ($scope.isSearch) {
            makeSearchText();
          }
        });
        $scope.$on("$destroy", function () {
          $log.log("synergy chat directive -- scope on -- $destroy");
          unsubscribeChatEvents();
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app.core').directive('spinner', spinner);

  function spinner() {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/spinner/spinner.html',
      scope: {
        needMask: "="
      },
      link: function link(scope) {
        scope.isProgressing = true;

        scope.bgclick = function () {
          scope.isProgressing = false;
        };
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').directive('sideNavbar', sideNavbar);

  function sideNavbar() {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/side-navbar/side-navbar.view.html',
      replace: true,
      scope: {
        page: "@"
      },
      link: function link() {}
    };
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function () {
  angular.module("app.core").directive("selectboxInput", selectboxInput);

  function selectboxInput($timeout) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/core/directives/selectboxinput/selectboxinput.view.html',
      scope: {
        ngModel: "=",
        options: "=",
        excludeItems: "=",
        labelField: "@",
        valueField: "@",
        shortLabelField: "@",
        placeholder: "@",
        selectEvent: "&",
        onChange: "&",
        changeTrig: '&',
        onClose: "&",
        toTop: "=",
        ngDisabled: "=",
        hasClear: "=",
        useShortLabel: '<'
      },
      link: function link(scope, element) {
        scope.cOptions = [];
        scope.selectedLabel = scope.placeholder;
        scope.$watch('ngModel', function (newVal, oldVal) {
          if (scope.ngModel && _typeof(scope.ngModel) == 'object') {
            scope.ngModel = scope.ngModel._id;
          }

          scope.selected = scope.cOptions ? scope.cOptions.find(function (elem) {
            return elem[scope.valueField] === scope.ngModel;
          }) : null;
          scope.onChange({
            value: scope.ngModel
          });

          if (angular.isDefined(newVal) && oldVal != newVal) {
            scope.changeTrig({
              value: scope.ngModel
            });
          }
        });

        scope.onSelect = function (item) {
          scope.selectItem(item);
        };

        var expression1 = element.attr("options");
        scope.$parent.$watch(expression1, function (newVal) {
          scope.cOptions = newVal;
          scope.selected = scope.cOptions ? scope.cOptions.find(function (elem) {
            return elem[scope.valueField] === scope.ngModel;
          }) : null;
        });
        var expression = element.attr("exclude-items");
        scope.$parent.$watch(expression, function (newVal) {
          scope.filterExcludeOptions(newVal);
        });

        scope.filterExcludeOptions = function (excludeList) {
          if (excludeList && excludeList.length) {
            var newOptions = [];
            scope.cOptions.map(function (it) {
              if (!excludeList.includes(it[scope.labelField])) {
                newOptions.push(it);
              }
            });
            scope.cOptions = newOptions;
          }
        };

        scope.selectItem = function (item) {
          scope.ngModel = item[scope.valueField];
          $timeout(function () {
            scope.selectEvent({
              value: scope.ngModel
            });
            scope.onChange({
              value: scope.ngModel
            });
          }, 100);
        };

        scope.clear = function ($event) {
          $event.stopPropagation();
          scope.ngModel = undefined;
          $timeout(function () {
            scope.selectEvent({
              value: scope.ngModel
            });
            scope.onChange({
              value: scope.ngModel
            });
          }, 100);
        };
      }
    };
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function () {
  angular.module("app.core").directive("selectbox2", selectbox2);

  function selectbox2($timeout) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/core/directives/selectbox2/selectbox2.view.html',
      scope: {
        ngModel: "=",
        options: "=",
        excludeItems: "=",
        labelField: "@",
        valueField: "@",
        selectEvent: "&",
        onClose: "&",
        toTop: "@",
        isTitle: "=",
        onChange: '&',
        changeTrig: '&',
        ngDisabled: "="
      },
      link: function link(scope, element) {
        scope.cOptions = [];

        function findSelect() {
          scope.selected = scope.cOptions.find(function (elem) {
            return elem[scope.valueField] == scope.ngModel;
          });
        }

        scope.$watch('ngModel', function (newVal, oldVal) {
          if (scope.ngModel && _typeof(scope.ngModel) == 'object') {
            scope.ngModel = scope.ngModel._id;
          }

          findSelect();
          scope.onChange();

          if (oldVal && newVal && oldVal != newVal) {
            scope.changeTrig();
          }
        });

        scope.onSelect = function (item) {
          scope.selectItem(item);
        };

        var expression1 = element.attr("options");
        scope.$parent.$watch(expression1, function (newVal) {
          scope.cOptions = angular.isDefined(newVal) ? newVal : [];
          findSelect();
        });
        var expression = element.attr("exclude-items");
        scope.$parent.$watch(expression, function (newVal) {
          scope.filterExcludeOptions(newVal);
        });

        scope.filterExcludeOptions = function (excludeList) {
          if (excludeList && excludeList.length) {
            var newOptions = [];
            scope.cOptions.map(function (it) {
              if (!excludeList.includes(it[scope.labelField])) {
                newOptions.push(it);
              }
            });
            scope.cOptions = newOptions;
          }
        };

        scope.selectItem = function (item) {
          scope.ngModel = item[scope.valueField];
          $timeout(function () {
            return scope.selectEvent({
              value: scope.ngModel
            });
          });
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app.core').directive('selectbox', selectbox);

  function selectbox() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/core/directives/selectbox/selectbox.view.html',
      scope: {
        ngModel: '=',
        options: '=',
        excludeItems: '=',
        isSearch: '@',
        isClickOpen: '@',
        placeholder: '@',
        labelField: '@',
        valueField: '@',
        enableAddItem: '=',
        addItemEvent: '&',
        selectEvent: '&',
        onClose: '&',
        toTop: '=',
        noIcon: '=',
        isSmall: '@',
        inputClass: '@',
        readonly: '=',
        shortLabelField: '@'
      },
      link: function link(scope, element) {
        scope.isOpen = false;
        scope.cOptions = [];
        scope.topMenu = false;
        scope.selectedLabel = scope.placeholder;

        if (!scope.isClickOpen) {
          scope.isClickOpen = false;
        }

        if (angular.isDefined(scope.ngModel) && scope.options) {
          if (scope.ngModel != {}) {
            var selectedItem = scope.options.find(function (item) {
              return item[scope.valueField] == scope.ngModel;
            });
            if (selectedItem) scope.selectedLabel = selectedItem[scope.labelField];
          }
        }

        var expression = element.attr('exclude-items');
        scope.$parent.$watch(expression, function (newVal) {
          scope.filterExcludeOptions(newVal);
        });

        scope.filterExcludeOptions = function (excludeList) {
          if (excludeList && excludeList.length) {
            var newOptions = [];
            scope.cOptions.map(function (it) {
              if (!excludeList.includes(it[scope.labelField])) {
                newOptions.push(it);
              }
            });
            scope.cOptions = newOptions;
          }
        };

        scope.toggleList = function () {
          var mainScreenHeight = angular.element(document).find('main').prop('clientHeight');
          var height = element[0].offsetTop;
          if (mainScreenHeight > height + 120) scope.topMenu = false;else scope.topMenu = true;
          if (scope.readonly) return;
          scope.isOpen = !scope.isOpen;

          if (scope.isOpen) {
            scope.cOptions = scope.options;

            if (scope.isSearch) {
              scope.searchFunction(scope.selectedLabel);
            }

            scope.filterExcludeOptions(scope.excludeItems);
          }
        };

        scope.updateData = function () {
          if (scope.options && angular.isDefined(scope.ngModel)) {
            var _selectedItem = scope.options.find(function (item) {
              return item[scope.valueField] == scope.ngModel;
            });

            if (_selectedItem) {
              scope.selectedLabel = _selectedItem[scope.labelField];
              scope.selectedShortLabel = _selectedItem[scope.shortLabelField];
            }
          } else {
            scope.selectedLabel = scope.placeholder;
          }

          scope.selectEvent({
            value: scope.ngModel
          });
        };

        scope.$watch('ngModel', function (newVal, oldVal) {
          if (newVal != oldVal) {
            scope.updateData();
          }
        });
        scope.$watch('options', function (newVal, oldVal) {
          var newLength = 0;
          var oldLength = 0;

          if (newVal) {
            newLength = newVal.length;
          }

          if (oldVal) {
            oldLength = oldVal.length;
          }

          if (newLength != oldLength) {
            scope.updateData();
          }
        });

        scope.selectItem = function (item) {
          if (scope.ngModel != item[scope.valueField]) {
            scope.ngModel = item[scope.valueField];
            scope.selectedLabel = item[scope.labelField];
            scope.selectedShortLabel = item[scope.shortLabelField];
          }

          scope.isOpen = false;
          scope.isselectedItem = true;
        };

        scope.closeList = function () {
          scope.isOpen = false;

          if (!scope.isselectedItem && scope.options) {
            for (var i = 0; i < scope.options.length; i++) {
              if (scope.options[i][scope.valueField] == scope.ngModel) {
                scope.originLabel = scope.options[i][scope.labelField];
              }
            }

            if (!scope.placeholder) {
              scope.selectedLabel = scope.originLabel;
            }
          }

          scope.onClose();
        };

        scope.openList = function () {
          if (scope.readonly) return;
          scope.isOpen = true;
          scope.cOptions = scope.options; // if (scope.isSearch) {
          //   scope.searchFunction(scope.selectedLabel);
          // }

          scope.filterExcludeOptions(scope.excludeItems);
        };

        scope.addItem = function () {
          scope.addItemEvent();
        };

        scope.startSearch = function () {
          scope.isOpen = true;
        };

        scope.searchFunction = function (searchText) {
          scope.isselectedItem = false;
          var output = [];

          if (searchText || searchText == '') {
            if (searchText.length >= 0) {
              angular.forEach(scope.options, function (item) {
                if (item[scope.labelField].toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                  output.push(item);
                }
              });
            }
          }

          scope.cOptions = output;
          scope.filterExcludeOptions(scope.excludeItems);
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("searchbox", searchBox);

  function searchBox($timeout) {
    return {
      restrict: "E",
      templateUrl: "app/core/directives/searchbox/searchbox.view.html",
      scope: {
        type: '=',
        searchEvent: "&",
        searchText: '=',
        placeHolder: '@',
        isSmall: '@',
        inputClass: '@',
        isIcon: '@',
        iconFile: '@'
      },
      link: function link(scope) {
        var filterTextTimeout = undefined; // scope.isInit = true;

        scope.$watch("searchText", function () {
          if (filterTextTimeout) {
            $timeout.cancel(filterTextTimeout);
          }

          filterTextTimeout = $timeout(function () {
            if (scope.searchText || scope.searchText === '') {
              // if (scope.isInit) {
              //   scope.isInit = !scope.isInit;
              //   return;
              // }
              scope.searchEvent();
            }
          }, 500); // delay 500 ms
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('searchList', searchList);

  function searchList(utils) {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/search-list/search-list.view.html',
      scope: {
        options: '=',
        searchText: '=',
        selectEvent: '&',
        selectCandidate: '&'
      },
      link: function link($scope) {
        $scope.selectedOption = undefined;
        $scope.$watch('searchText', function () {
          if (!utils.isEmpty($scope.searchText)) {
            $scope.filteredOptions = $scope.options.filter(function (x) {
              return x.toLowerCase().includes($scope.searchText.toLowerCase());
            });
          } else {
            $scope.filteredOptions = $scope.options;
          }

          if ($scope.filteredOptions.length > 0) {
            $scope.selectedOption = $scope.filteredOptions[0];
            $scope.selectCandidate({
              name: $scope.selectedOption
            });
          }
        });

        $scope.selectOption = function (option) {
          $scope.selectEvent({
            name: option
          });
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("radio", radio);

  function radio() {
    return {
      restrict: "E",
      templateUrl: 'app/core/directives/radio/radio.html',
      scope: {
        ngModel: "=",
        ngValue: "=",
        ngDisabled: "=",
        clickEvent: "&"
      },
      link: function link() {}
    };
  }
})();


"use strict";

(function () {
  angular.module('app').directive('quoteMessage', quoteMessage);

  function quoteMessage() {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/quote-message/quote-message.view.html',
      scope: {
        ngModel: '=',
        cancelQuote: '&'
      },
      link: function link($scope) {
        $scope.getMessageDescription = function () {
          var dt = new Date($scope.ngModel.timestamp);
          var mdt = moment(dt);
          return $scope.ngModel.authorName + ', ' + mdt.format('dd/MM/yyyy HH:mm');
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("projectTimeline", projectTimeline);

  function projectTimeline($rootScope, $compile, $document, $log, $timeout, utils, globals, apiFactory, $uibModal, $state, pdfFactory, storageFactory) {
    return {
      restrict: "A",
      scope: {},
      transclude: true,
      template: "<div id='project-timeline' class='no-zoom'><div ng-transclude></div></div>",
      link: function link($scope) {
        var resourceStore;
        var resourceMode = "hours";
        var resourceMap = {};
        var columnWidth = 24;
        var drag_id = null;
        var container = undefined;
        var projectStore = globals.projectStore,
            userStore = globals.userStore;
        $scope.project = projectStore.get();
        $scope.isAllProject = !$scope.project || $scope.project._id === 'all';
        $scope.user = userStore.get();
        $scope.TIMELINE_ACCESS_CREATE = 100; // let dType = globals.getDashboardType($scope.user);
        // if ($scope.user.designation === "Admin") {
        //   $scope.TIMELINE_ACCESS_CREATE = 4;
        // } else {
        //   $scope.isLoading = true;
        //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.TIMELINE]})
        //     .then(res => {
        //       $scope.isLoading = false;
        //       $scope.TIMELINE_ACCESS_CREATE = res.data.data[Constants.AccessKey.TIMELINE];
        //     })
        //     .catch((e) => {
        //       $scope.isLoading = false;
        //       $log.error(e);
        //       Notification.error('Something went wrong try later')
        //     });
        // }

        $scope.groups = [];
        $scope.workers = [];
        $scope.subContractors = [];
        $scope.workTypes = [];
        $scope.workLevels = [];
        $scope.events = [];
        $scope.selectedTask = undefined;
        $scope.selectedGroup = undefined;
        $scope.modelViewer = undefined;
        $scope.refreshModelViewer = undefined;
        $scope.ganttData = {
          data: [],
          links: []
        };
        $scope.resourceData = [];
        $scope.groupData = [];
        $scope.showResources = false;
        $scope.currentResources = [];
        $scope.searchText = undefined;
        $scope.notifications = [];
        $scope.hrswItems = [];
        $scope.zoomValue = 1;
        $scope.isEdited = false;
        $scope.isLoading = false;
        $scope.updating = false;
        $scope.sideBoxItems = [{
          name: 'weather',
          icon: '/assets/icons/weather-white.svg'
        }, {
          name: 'notification',
          icon: '/assets/icons/bell-white.svg'
        }, {
          name: 'worker',
          icon: '/assets/icons/add-worker-white.svg'
        }, {
          name: 'setting',
          icon: '/assets/icons/settings-white.svg'
        }]; // color style for timeline

        $scope.styles = {};
        var styleIndex = 0;
        var FETCH_WORKPATTERNS_COUNT = 5;
        var MINT_MATCH_WORKPATTERNS_COUNT = 3;
        $scope.timelineWorkPatterns = [];

        if (!$scope.isAllProject) {
          $scope.startline = new Date($scope.project.startDate);
          $scope.startline.setHours(0, 0, 0, 0);
          $scope.deadline = new Date($scope.project.endDate);
          $scope.deadline.setHours(23, 59, 59, 999);
        } // expand area


        $scope.expandedArea = undefined;

        $scope.expandArea = function (area) {
          $scope.expandedArea = area;
          $scope.showResources = false;
          $timeout(function () {
            if (angular.isDefined($scope.refreshModelViewer)) {
              $scope.refreshModelViewer();
            }
          });
        };

        $scope.showType = 'Type';

        $scope.isShowArea = function (area) {
          return $scope.isAllProject ? area === 'gantt' : $scope.expandedArea === area || angular.isUndefined($scope.expandedArea);
        };

        $scope.expandedClass = function (area) {
          return $scope.isAllProject && area === 'gantt' || $scope.expandedArea === area ? 'expanded' : '';
        };

        $scope.isExpanded = function (area) {
          return $scope.isAllProject && area === 'gantt' || $scope.expandedArea === area;
        };

        $scope.searchType = 'name';
        $scope.viewStyle = 'month';
        $scope.ganttType = undefined; // refresh flowline

        $scope.refreshFlowline = false;
        $scope.$on('$stateChangeStart', function (event, toState, toParams) {
          if (!toState.redirectTo && $scope.isEdited) {
            event.preventDefault();
            $uibModal.open({
              animation: true,
              component: 'alertModal',
              size: 'sm',
              resolve: {
                title: function title() {
                  return 'Warning';
                },
                message: function message() {
                  return 'You have unsaved edit. Do you want to save?';
                },
                positive: function positive() {
                  return 'Save';
                }
              }
            }).result.then(function () {
              saveTimeline().then(function () {
                $state.go(toState, toParams);
              });
            }, function (reason) {
              if (reason === 'cancel') {
                $scope.isEdited = false;
                $state.go(toState, toParams);
              }
            });
          }
        });

        $scope.selectSearchType = function (type) {
          $scope.searchType = type;
        };

        $scope.selectViewStyle = function (style) {
          $scope.viewStyle = style;
        };

        $scope.selectGanttType = function (type) {
          $scope.ganttType = type;
        };

        $scope.addTask = function () {
          $uibModal.open({
            animation: true,
            component: 'addTaskModal',
            windowClass: 'timeline-add-task-modal',
            backdrop: 'static',
            resolve: {
              groups: function groups() {
                return $scope.groups;
              },
              workers: function workers() {
                return $scope.workers;
              },
              subContractors: function subContractors() {
                return $scope.subContractors;
              },
              workLevels: function workLevels() {
                return $scope.workLevels;
              },
              workTypes: function workTypes() {
                return $scope.workTypes;
              },
              selectedTask: function selectedTask() {
                return $scope.selectedTask ? $scope.selectedTask : $scope.selectedGroup;
              }
            }
          }).result.then(function (result) {
            $scope.isEdited = true;
            var task = result;
            var groupData = [$scope.groupData[0], $scope.groupData[1]];

            if (groupData[0].data.findIndex(function (x) {
              return x.key === task.workType;
            }) === -1) {
              groupData[0].data.push({
                key: task.workType,
                label: task.workType
              });
            }

            if (groupData[1].data.findIndex(function (x) {
              return x.key === task.workLevel;
            }) === -1) {
              groupData[1].data.push({
                key: task.workLevel,
                label: task.workLevel
              });
            }

            $scope.groupData = groupData;
            setStyle(task.workType);
          }, function (reason) {
            $log.log(reason);
          });
        };

        $scope.toggleResources = function () {
          $scope.showResources = !$scope.showResources;
        };

        $scope.editTask = function (task) {
          if (task) {
            $scope.selectedTask = task;
          }

          $uibModal.open({
            animation: true,
            component: 'editTaskModal',
            windowClass: 'timeline-edit-task-modal',
            backdrop: 'static',
            resolve: {
              task: function task() {
                return $scope.selectedTask;
              }
            }
          }).result.then(function () {
            $scope.isEdited = true;

            if (angular.isDefined($scope.selectedTask)) {
              gantt.updateTask($scope.selectedTask.id);
            }
          }, function (reason) {
            $log.log(reason);
          });
        };

        $scope.splitTask = function () {
          $uibModal.open({
            animation: true,
            component: 'splitTaskModal',
            windowClass: 'timeline-split-task-modal',
            backdrop: 'static',
            resolve: {
              task: function task() {
                return $scope.selectedTask;
              }
            }
          }).result.then(function () {
            $scope.isEdited = true;
          });
        };

        $scope.combineTask = function () {
          $uibModal.open({
            animation: true,
            component: 'combineTaskModal',
            windowClass: 'timeline-combine-task-modal',
            backdrop: 'static',
            resolve: {
              selectedTask: function selectedTask() {
                return $scope.selectedTask ? $scope.selectedTask : $scope.selectedGroup;
              }
            }
          }).result.then(function () {
            $scope.isEdited = true;
          });
        };

        $scope.editCombinedTask = function () {
          $uibModal.open({
            animation: true,
            component: 'editCombineTaskModal',
            windowClass: 'timeline-edit-combine-task-modal',
            backdrop: 'static',
            resolve: {
              task: function task() {
                return $scope.selectedTask;
              }
            }
          }).result.then(function (result) {
            $log.log(result);
          }, function (reason) {
            $log.log(reason);
          });
        };

        $scope.hrsW = function () {
          $uibModal.open({
            animation: true,
            component: 'hrsWModal',
            windowClass: 'timeline-hrs-w-modal',
            backdrop: 'static',
            resolve: {
              projectId: function projectId() {
                return $scope.project._id;
              },
              workers: function workers() {
                return $scope.workers;
              },
              subContractors: function subContractors() {
                return $scope.subContractors;
              },
              times: function times() {
                return $scope.hrswItems;
              }
            }
          }).result.then(function (result) {
            $scope.hrswItems = result;
            refreshWorkersToTimeline();
          }, function (reason) {
            $log.log(reason);
          });
        };

        $scope.zoomPlus = function () {
          if ($scope.zoomValue >= 10) return;
          $scope.zoomValue++;
        };

        $scope.zoomMinus = function () {
          if ($scope.zoomValue <= 1) return;
          $scope.zoomValue--;
        };

        $scope.saveTimeline = function () {
          $uibModal.open({
            animation: true,
            component: 'alertModal',
            size: 'sm',
            resolve: {
              title: function title() {
                return 'Save';
              },
              message: function message() {
                return 'Are you going to save?';
              },
              positive: function positive() {
                return 'Save';
              }
            }
          }).result.then(function () {
            saveTimeline();
            updateWorkPattern();
          }, function (reason) {
            $log.log(reason);
          });
        };

        $scope.exportPdf = function () {
          pdfFactory.exportGantt("timeline", gantt, $scope.styles, {
            icon: '/assets/images/logo.png',
            logo: 'CloudES',
            title: $scope.project.projectName,
            statusIcons: ["/assets/images/timeline/status-waiting.png", "/assets/images/timeline/status-working.png", "/assets/images/timeline/status-warning.png", "/assets/images/timeline/status-completed.png", "/assets/images/timeline/status-warning.png"],
            ganttType: $scope.ganttType,
            pageSize: {
              width: 1754,
              height: 1240
            } //A4

          });
        };

        $scope.exportMpp = function () {
          gantt.exportToMSProject({
            name: 'timeline.xml'
          });
        };

        $scope.reloadTimeline = function () {
          $uibModal.open({
            animation: true,
            component: 'alertModal',
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              title: function title() {
                return 'Reload';
              },
              message: function message() {
                return 'Are you going to reload?';
              },
              positive: function positive() {
                return 'Reload';
              }
            }
          }).result.then(function () {
            loadTimelineWithCalc(true);
            $scope.isEdited = true;
          });
        };

        $scope.showToggleMenus = function (index) {
          $scope.toggleIndex = index;
          var nav = angular.element('#right-side-box');
          var isOpen = nav.hasClass('open');

          if (isOpen) {
            nav.removeClass('open');
          } else {
            nav.addClass('open');
          }

          var toggleItems = $document[0].getElementsByClassName('side-box-item');
          var toggleItemsVisible = isOpen ? 'visible' : 'hidden';

          for (var i = 0; i < toggleItems.length; i++) {
            toggleItems[i].style.visibility = toggleItemsVisible;
          }

          toggleItems[index].style.visibility = 'visible';
        };

        $scope.taskChanged = function (id, task) {
          var labourHours = utils.num(task.calcHours);
          var duration = Math.max(8, task.duration);
          var workerCount = labourHours > duration ? Math.ceil(labourHours / duration) : 1;
          task.requiredWorkerCount = workerCount;

          if (task.resources) {
            if (task.resources.length > workerCount) {
              task.resources.splice(workerCount, task.resources.length - workerCount);
            } else if (task.resources.length < workerCount) {
              var workersMap = {};
              var count = task.resources.length;

              for (var i = 0; i < count; i++) {
                workersMap[task.resources[i].id] = task.resources[i];
              }

              for (var _i = 0; _i < $scope.workers.length; _i++) {
                var worker = $scope.workers[_i];

                if (angular.isUndefined(workersMap[worker._id])) {
                  task.resources.push({
                    id: worker._id,
                    name: worker.displayName,
                    avatar: worker.profilePic,
                    type: 1
                  });
                  count++;

                  if (count >= workerCount) {
                    break;
                  }
                }
              }
            }
          }

          updateTaskDelay(task);
          gantt.updateTask(id);
          $scope.isEdited = true;
        };

        $scope.taskSelected = function (taskId) {
          var task = gantt.getTask(taskId);
          $scope.ganttTask = task;

          if (task.type === gantt.config.types.project) {
            $scope.selectedGroup = task;
            $scope.selectedTask = undefined;
          } else {
            $scope.selectedGroup = undefined;
            $scope.selectedTask = task;
          }

          if ($scope.selectedTask) {
            loadCurrentResources($scope.selectedTask);
          } else {
            $scope.currentResources = $scope.resourceData;
          }

          if (task.type === gantt.config.types.project) {
            var calcLevel = task.calcLevel;

            if (calcLevel) {
              if (calcLevel.modelId) {
                $scope.modelViewer = {
                  modelType: calcLevel.modelType,
                  modelId: calcLevel.modelId,
                  objectId: calcLevel.objectId
                };
                $timeout(function () {
                  return $scope.$apply();
                });
                return;
              }
            } else {
              if (selectTask(task)) return;
            }
          } else {
            if (selectTask(task)) return;
          }

          $scope.modelViewer = undefined;
          $timeout(function () {
            return $scope.$apply();
          });
        };

        $scope.taskUpdated = function () {
          $scope.isEdited = true;
        };

        $scope.getWorkerCount = function (gantt, start, end) {
          var workerCount = 0;
          var requiredCount = 0;
          var startValue = start.getTime();
          var endValue = end.getTime();
          var gap = (endValue - startValue) / 3600000;
          var isWeekend = gap <= 24 && (start.getDay() === 6 || start.getDay() === 0) && (end.getDay() === 6 || end.getDay() === 0 || end.getDay() === 1);

          if (!isWeekend) {
            var resources = [];
            gantt.eachTask(function (task) {
              if (task.type !== gantt.config.types.project && task.start_date && task.end_date) {
                if (endValue >= task.start_date.getTime() && startValue <= task.end_date.getTime()) {
                  if (task.resources) {
                    task.resources.forEach(function (resource) {
                      if (resources.findIndex(function (x) {
                        return x.id === resource.id;
                      }) === -1) {
                        resources.push(resource);
                      }
                    });
                  }

                  requiredCount += task.requiredWorkerCount ? task.requiredWorkerCount : 0;
                }
              }
            });
            resources.forEach(function (resource) {
              if (getWorkableHours(resource, start, end) > 0) {
                workerCount++;
              }
            });
          }

          return {
            working: workerCount,
            required: requiredCount
          };
        };

        $scope.getTotalCount = function (type) {
          var count = 0;

          if (type === 'R') {
            gantt.eachTask(function (task) {
              if (task.type === gantt.config.types.task) {
                var need = utils.num(task.requiredWorkerCount);
                count = Math.max(need, count);
              }
            });
          } else {
            count = $scope.resourceData && $scope.resourceData.length ? $scope.resourceData.length - 2 : 0;
          }

          return count;
        };

        $scope.addWorker = function () {
          if (!$scope.selectedTask) {
            Notification.error("Please select task first.");
            return;
          }

          $uibModal.open({
            animation: true,
            component: 'addWorkerModal',
            windowClass: 'timeline-add-worker-modal',
            backdrop: 'static',
            resolve: {
              task: function task() {
                return $scope.selectedTask;
              },
              workers: function workers() {
                return $scope.workers;
              },
              subContractors: function subContractors() {
                return $scope.subContractors;
              },
              groups: function groups() {
                return $scope.groups;
              }
            }
          }).result.then(function (result) {
            if (!$scope.selectedTask.resources) {
              $scope.selectedTask.resources = [];
            }

            var resourceData = [];
            $scope.resourceData.forEach(function (x) {
              return resourceData.push(x);
            });
            result.forEach(function (w) {
              if ($scope.selectedTask.resources.findIndex(function (x) {
                return x.id === w._id;
              }) === -1) {
                $scope.selectedTask.resources.push({
                  id: w._id,
                  name: w.name,
                  avatar: w.profilePic,
                  type: w.type === 'worker' ? 1 : 2
                });
                $scope.selectedTask.resourceIds.push(w._id);
              }

              if (w.type === 'worker') {
                if (resourceData.findIndex(function (x) {
                  return x.id === w._id;
                }) === -1) {
                  resourceData.push({
                    id: w._id,
                    text: w.displayName,
                    avatar: w.profilePic,
                    parent: 1
                  });
                }
              } else if (w.type === 'subcontractor') {
                if (resourceData.findIndex(function (x) {
                  return x.id === w._id;
                }) === -1) {
                  resourceData.push({
                    id: w._id,
                    text: w.name,
                    avatar: w.profilePic,
                    parent: 2
                  });
                }
              }
            });
            $scope.resourceData = resourceData;
            gantt.updateTask($scope.selectedTask.id);
            loadCurrentResources($scope.selectedTask);
          }, function (reason) {
            $log.log(reason);
          });
        };

        $scope.removeWorker = function (workerId) {
          if (!$scope.selectedTask) {
            Notification.error("Please select task first.");
            return;
          }

          $uibModal.open({
            animation: true,
            component: 'confirmModal',
            size: 'sm',
            backdrop: 'static',
            keyboard: false
          }).result.then(function () {
            if ($scope.selectedTask.resources) {
              var index = $scope.selectedTask.resources.findIndex(function (x) {
                return x.id === workerId;
              });

              if (index !== -1) {
                $scope.selectedTask.resources.splice(index, 1);
              }
            }

            if ($scope.selectedTask.resourceIds) {
              var _index = $scope.selectedTask.resourceIds.findIndex(function (x) {
                return x === workerId;
              });

              if (_index !== -1) {
                $scope.selectedTask.resourceIds.splice(_index, 1);
              }
            }

            gantt.updateTask($scope.selectedTask.id);
            loadCurrentResources($scope.selectedTask);
          });
        };

        $scope.getWorkerHours = function (resource, start, end, tasks) {
          return getWorkableHours(resource, start, end, tasks);
        };

        $scope.combineAuto = function () {
          $uibModal.open({
            animation: true,
            component: 'alertModal',
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              title: function title() {
                return 'Combine';
              },
              message: function message() {
                return 'Are you going to combine items automatically?';
              },
              positive: function positive() {
                return 'Combine';
              }
            }
          }).result.then(function () {
            combineAuto();
            $scope.isEdited = true;
          });
        }; // loading


        function initData() {
          $scope.isLoading = true;
          var apis = [apiFactory.listAllEmployeeGroups(), apiFactory.getAllEmployees({
            isActive: true
          }), apiFactory.getAllSubcontractors(), apiFactory.listAllHolidays(), apiFactory.getWorkLevelAndTypes(), apiFactory.getAllEvents()];

          if (!$scope.isAllProject) {
            apis.push(apiFactory.fetchTimelineWorkPatterns({
              projectId: $scope.project._id,
              fetchCount: FETCH_WORKPATTERNS_COUNT
            }));
          }

          Promise.all(apis).then(function (resp) {
            // load employee groups
            var groups = resp[0].data.list || [];
            $scope.groups = [];
            groups.forEach(function (element) {
              element.type = "group";
              $scope.groups.push(element);
            }); // load workers

            var workers = resp[1].data.list || [];
            $scope.workers = [];
            workers.forEach(function (element) {
              element.name = element.displayName;
              element.type = 'worker';
              var group = $scope.groups.find(function (group) {
                return group.leader._id === element._id || group.employees.findIndex(function (employee) {
                  return employee._id === element._id;
                }) !== -1;
              });
              element.groupName = group ? group.name : undefined;
              $scope.workers.push(element);
            });
            $scope.workers.sort(function (a, b) {
              var aValue = angular.isDefined(a.groupName);
              var bValue = angular.isDefined(b.groupName);

              if (aValue && bValue) {
                return a.groupName < b.groupName ? -1 : a.groupName > b.groupName ? 1 : 0;
              } else {
                return !aValue && bValue ? 1 : -1;
              }
            });
            $scope.subContractors = resp[2].data.list || [];
            $scope.subContractors.forEach(function (x) {
              return x.type = 'subcontractor';
            });
            $scope.holidays = resp[3].data.list;

            if (!$scope.isAllProject) {
              $scope.availableHours = utils.getWorkingHours($scope.startline, $scope.deadline);

              if ($scope.availableHours === 0) {
                $scope.availableHours = 8;
              }
            } else {
              $scope.availableHours = 0;
            }

            $scope.workLevels = resp[4].data.data.workLevels;
            $scope.workTypes = resp[4].data.data.workTypes;
            $scope.events = resp[5].data.data;

            if (angular.isDefined(resp[6])) {
              $scope.timelineWorkPatterns = resp[6].data.list;
            } // load timeline


            if ($scope.isAllProject) {
              $scope.timeline = undefined; // all project

              storageFactory.getBookmarks().then(function (resp) {
                $scope.projects = resp.data.bookmarks;
                loadTimelineWithAllProject();
                $scope.isLoading = false;
              })["catch"](function (err) {
                $log.error(err);
                Notification.error('Cannot load timeline data from the server.');
                $scope.isLoading = false;
              });
            } else {
              apiFactory.getTimeline($scope.project._id).then(function (resp) {
                $scope.isLoading = false;
                $scope.timeline = resp.data.data;
                $scope.isEdited = $scope.timeline.needSave;
                $scope.hrswItems = $scope.timeline.hrsw || [];

                if ($scope.project.buildingType) {
                  $scope.isLoading = true;
                  apiFactory.getWorkPatternById($scope.project.buildingType._id ? $scope.project.buildingType._id : $scope.project.buildingType).then(function (res) {
                    $scope.isLoading = false;
                    var workPattern = res.data.data;

                    if (!utils.isEmpty(workPattern)) {
                      $scope.sortMap = {};
                      workPattern.items.forEach(function (item, index) {
                        $scope.sortMap[item.tagName] = index;
                      });
                      $scope.workPattern = workPattern;
                    }

                    loadTimelineWithCalc();
                  })["catch"](function (err) {
                    $log.error(err);
                    $scope.isLoading = false;
                    loadTimelineWithCalc();
                  });
                } else {
                  loadTimelineWithCalc();
                }
              })["catch"](function (err) {
                $scope.isLoading = false;
                $log.error(err);
                Notification.error('Cannot load timeline data from the server.');
              });
            }
          })["catch"](function (err) {
            $log.error(err);
            $scope.isLoading = false;
          });
        }

        initData();

        function loadTimelineWithAllProject() {
          if (!$scope.projects) return;
          var items = [];
          var resources = {};

          var _loop = function _loop(i) {
            var project = $scope.projects[i];
            var item = {
              id: project._id,
              text: project.projectName,
              start_date: new Date(project.startDate),
              end_date: new Date(project.endDate),
              type: gantt.config.types.task,
              progress: utils.num(project.progress),
              project: true,
              calcHours: project.calcSheet ? utils.num(project.calcSheet.totalWorkHours) : 0,
              resources: [],
              resourceIds: []
            };

            if (project.timeline && project.timeline.resources) {
              project.timeline.resources.forEach(function (resource) {
                if (resource.worker && resource.worker._id) {
                  var group = $scope.groups.find(function (group) {
                    return group.leader._id === resource.worker._id || group.employees.findIndex(function (employee) {
                      return employee._id === resource.worker._id;
                    }) !== -1;
                  });
                  item.resources.push({
                    id: resource.worker._id,
                    name: resource.worker.displayName || resource.worker.name,
                    avatar: resource.worker.profilePic,
                    type: resource.workerType === 'Employee' ? 1 : 2,
                    groupName: group ? group.name : undefined
                  });
                }
              });
              item.resourceIds = item.resources.map(function (resource) {
                return resource.id;
              });
              item.resources.forEach(function (res) {
                if (!resources[res.id]) {
                  resources[res.id] = res;
                }
              });
            }

            var workHours = utils.getWorkingHours(item.start_date, item.end_date);
            item.requiredWorkerCount = workHours === 0 ? 1 : Math.max(1, Math.ceil(item.calcHours / workHours));
            items.push(item);
          };

          for (var i = 0; i < $scope.projects.length; i++) {
            _loop(i);
          }

          var resourceData = [];
          var workerCount = 0;
          var subcontractorCount = 0;

          for (var id in resources) {
            var resource = resources[id];

            if (resource) {
              resourceData.push({
                id: resource.id,
                text: resource.name,
                groupName: resource.groupName,
                avatar: resource.avatar,
                parent: resource.type
              });

              if (resource.type === 1) {
                workerCount++;
              } else {
                subcontractorCount++;
              }
            }
          }

          resourceData.unshift({
            id: 2,
            text: "Sub Contractors (".concat(subcontractorCount, ")"),
            type: gantt.config.types.project
          });
          resourceData.unshift({
            id: 1,
            text: "Workers (".concat(workerCount, ")"),
            type: gantt.config.types.project
          });
          $scope.ganttData = {
            data: items,
            links: []
          };
          $scope.resourceData = resourceData;
          $scope.currentResources = $scope.resourceData;
          $timeout(function () {
            return gantt.showDate(new Date());
          }, 300);
        }

        function loadTimelineWithCalc(reload) {
          var groups = $scope.timeline.groups;
          var tasks = $scope.timeline.tasks;
          var timeline = {
            gantt: {
              data: [],
              links: []
            },
            resources: {
              workers: {},
              subcontractors: {}
            },
            groups: {
              workType: {},
              workLevel: {}
            }
          };
          $scope.styles = {};
          styleIndex = 0;
          var ganttGroups = {};

          if (groups) {
            groups.forEach(function (group) {
              var item = makeGanttGroup(group, timeline);
              ganttGroups[item.id] = item;
            });
          }

          if (tasks) {
            var csTasks = [];
            var totalWorkHours = 0;
            tasks.forEach(function (task) {
              var csTask = loadCalcTask(task);

              if (csTask) {
                csTasks.push(csTask);
                totalWorkHours += csTask.workHours;
              }
            });
            var deltaPercent = totalWorkHours === 0 ? 1 : $scope.availableHours / totalWorkHours;
            csTasks.forEach(function (csTask) {
              csTask.workHours *= deltaPercent;
              var workHours = Math.max(8, csTask.workHours);
              csTask.requiredWorkerCount = Math.max(1, Math.ceil(csTask.calcHours / workHours));
            });
            var date = new Date($scope.startline);
            tasks.forEach(function (task) {
              var csTask = csTasks.find(function (csTask) {
                return csTask._id === task._id;
              });
              var item = makeGanttTask(task, date, reload, timeline, csTask);
              var group = item.parent ? ganttGroups[item.parent] : undefined;

              while (group) {
                if (item.status === 4 || item.status === 1) {
                  group.status = item.status;
                }

                group.workedHours += item.workedHours;
                group.calcHours += item.calcHours;
                group.progressedHours += item.calcHours * item.progress;
                group.requiredWorkerCount = Math.max(group.requiredWorkerCount, item.requiredWorkerCount);

                if (group.startDate) {
                  if (group.startDate.getTime() > item.start_date.getTime()) {
                    group.startDate = new Date(item.start_date);
                  }
                } else {
                  group.startDate = new Date(item.start_date);
                }

                if (group.endDate) {
                  if (group.endDate.getTime() < item.end_date.getTime()) {
                    group.endDate = new Date(item.end_date);
                  }
                } else {
                  group.endDate = new Date(item.end_date);
                }

                group = group.parent ? ganttGroups[group.parent] : undefined;
              }
            });

            for (var key in ganttGroups) {
              var group = ganttGroups[key];
              if (!group) continue;

              if (group.calcHours === 0) {
                group.progress = 0;
              } else {
                group.progress = group.progressedHours / group.calcHours;
              }

              if (group.startDate && group.endDate) {
                var progress = utils.progressOfDate(group.startDate, group.endDate, new Date(), true);

                if (progress > group.progress) {
                  group.delay = progress - group.progress;
                  group.status = 4;
                }
              }
            }
          }

          var resourceData = [];
          var workerCount = 0;
          var subcontractorCount = 0;

          for (var id in timeline.resources.workers) {
            var worker = timeline.resources.workers[id];

            if (worker) {
              resourceData.push({
                id: worker.id,
                text: worker.name,
                groupName: worker.groupName,
                avatar: worker.avatar,
                parent: 1
              });
              workerCount++;
            }
          }

          for (var _id in timeline.resources.subcontractors) {
            var subcontractor = timeline.resources.subcontractors[_id];

            if (subcontractor) {
              resourceData.push({
                id: subcontractor.id,
                text: subcontractor.name,
                avatar: subcontractor.avatar,
                parent: 2
              });
              subcontractorCount++;
            }
          }

          resourceData.unshift({
            id: 2,
            text: "Sub Contractors (".concat(subcontractorCount, ")"),
            type: gantt.config.types.project
          });
          resourceData.unshift({
            id: 1,
            text: "Workers (".concat(workerCount, ")"),
            type: gantt.config.types.project
          });
          var groupData = [{
            name: 'workType',
            data: []
          }, {
            name: 'workLevel',
            data: []
          }];

          for (var _id2 in timeline.groups.workType) {
            var workType = timeline.groups.workType[_id2];

            if (workType) {
              groupData[0].data.push({
                key: workType,
                label: workType
              });
            }
          }

          for (var _id3 in timeline.groups.workLevel) {
            var workLevel = timeline.groups.workLevel[_id3];

            if (workLevel) {
              groupData[1].data.push({
                key: workLevel,
                label: workLevel
              });
            }
          }

          if (timeline.gantt.data.length === 0) {
            // no message in the case empty sheet after creating new project
            if (tasks.length === 0) {
              Notification.error('There is no data for timeline.');
            }
          } else {
            var now = new Date().getTime();
            timeline.gantt.data.forEach(function (item) {
              if (item.end_date && item.end_date.getTime() < now) {
                $scope.notifications.push("The working time of \"".concat(item.text, "\" is passed away."));
              }
            });
          }

          $scope.ganttData = timeline.gantt;
          $scope.totalProgress = $scope.ganttData.data[0].progress;
          $scope.resourceData = resourceData;
          $scope.groupData = groupData;
          $scope.currentResources = $scope.resourceData;
          $timeout(function () {
            return gantt.showDate(new Date());
          }, 300);
          showAnyModel();
        }

        function makeGanttGroup(group, timeline) {
          var groupItem = {
            id: group._id,
            text: group.name,
            type: gantt.config.types.project,
            calcHours: 0,
            workedHours: 0,
            progressedHours: 0,
            modelId: group.modelId,
            modelType: group.modelType,
            show: true,
            status: 0,
            progress: 0,
            delay: 0,
            requiredWorkerCount: 1
          };

          if (group.parent) {
            groupItem.parent = group.parent;
          }

          timeline.gantt.data.push(groupItem);
          return groupItem;
        }

        function loadCalcTask(task) {
          if (!task.calcSheet || task.taskStyle === 'Subcontractor') return;
          var csTask = {
            _id: task._id,
            skill: task.product ? task.product.groupId : undefined,
            calcHours: utils.num(task.calcHours),
            workHours: utils.num(task.calcHours),
            workers: [],
            requiredWorkerCount: 1,
            workType: task.workType
          };

          if (csTask.skill) {
            $scope.workers.forEach(function (worker) {
              if (worker.listOfSkills) {
                worker.listOfSkills.forEach(function (workerSkill) {
                  if (workerSkill.skill === csTask.skill) {
                    csTask.workers.push(worker);
                  }
                });
              } else {
                csTask.workers.push(worker);
              }
            });
          } else {
            // anyone can work
            $scope.workers.forEach(function (worker) {
              csTask.workers.push(worker);
            });
          }

          return csTask;
        }

        function makeGanttTask(task, date, reload, timeline, csTask) {
          var ganttItem = taskToGantt(task);

          if (task.tasks && task.tasks.length > 0) {
            ganttItem.composeState = 'combined';
            ganttItem.tasks = [];
            var prevSubTask = undefined;
            task.tasks.forEach(function (subTask) {
              var ganttSubItem = subTaskToGantt(subTask, prevSubTask);
              ganttItem.tasks.push(ganttSubItem);
              prevSubTask = ganttSubItem;
            });
          }

          if ((!reload || !task.calcItem) && task.startDate && task.endDate) {
            // load from saved time
            ganttItem.start_date = new Date(task.startDate);
            ganttItem.end_date = new Date(task.endDate);
            ganttItem.requiredWorkerCount = utils.num(task.requiredWorkerCount);
          } else {
            // set time
            var moveTimes = 0;
            var _workType = task.workType;

            if (angular.isDefined($scope.workPattern) && angular.isDefined(_workType)) {
              var prevItem = timeline.gantt.data[timeline.gantt.data.length - 1];

              if (angular.isDefined(prevItem) && prevItem.workType !== _workType) {
                var patternItem = $scope.workPattern.items.find(function (x) {
                  return x.tagName === _workType;
                });

                if (angular.isDefined(patternItem)) {
                  var percentage = patternItem.percentage;

                  if (percentage >= 0 && percentage < 100) {
                    var prevItems = timeline.gantt.data.filter(function (x) {
                      return x.workType === prevItem.workType;
                    });
                    var prevFirstItem = prevItems[0];
                    var prevLastItem = prevItems[prevItems.length - 1];
                    var diffTimes = prevLastItem.end_date.getTime() - prevFirstItem.start_date.getTime();
                    moveTimes = Math.ceil(diffTimes * (100 - percentage) / 100);
                  }
                }
              }
            }

            var startDate = new Date(date.getTime() - moveTimes);
            var taskDuration = csTask ? csTask.workHours : ganttItem.calcHours;

            if (taskDuration < 8) {
              var dates = getTaskDates(startDate, 8 * 3600000);
              ganttItem.start_date = dates.start;
              ganttItem.end_date = dates.end;
              date.setTime(getTaskDates(startDate, taskDuration * 3600000).end.getTime());
            } else {
              var _dates = getTaskDates(startDate, taskDuration * 3600000);

              ganttItem.start_date = _dates.start;
              ganttItem.end_date = _dates.end;
              date.setTime(_dates.end.getTime());
            }

            ganttItem.requiredWorkerCount = csTask ? csTask.requiredWorkerCount : task.requiredWorkerCount;
          } // delay?


          if (ganttItem.status !== 3) {
            var progress = utils.progressOfDate(ganttItem.start_date, ganttItem.end_date, new Date(), true);

            if (ganttItem.progress < progress) {
              ganttItem.delay = progress - ganttItem.progress;
              ganttItem.status = 4;
            }
          }

          if (!reload && task.resources && task.resources.length > 0) {
            // load from saved workers
            ganttItem.resources = [];
            task.resources.forEach(function (res) {
              if (res.worker) {
                var group = $scope.groups.find(function (x) {
                  return x.leader._id === res.worker._id || x.employees.findIndex(function (member) {
                    return member._id === res.worker._id;
                  }) !== -1;
                });
                ganttItem.resources.push({
                  id: res.worker._id,
                  name: res.worker.name || res.worker.displayName,
                  groupName: group ? group.name : undefined,
                  avatar: res.worker.profilePic,
                  type: res.workerType === 'Employee' ? 1 : 2
                });
              }
            });
          } else {
            // set workers
            if (task.taskStyle === 'Subcontractor') {
              var subContractor = $scope.subContractors.find(function (x) {
                return x._id === task.workerId;
              });

              if (subContractor) {
                var resource = {
                  id: subContractor._id,
                  name: subContractor.name,
                  avatar: subContractor.profilePic,
                  type: 2
                };
                ganttItem.resources = [resource];
              }
            } else if (task.taskStyle === 'Worker') {
              if ($scope.workers.length > 0) {
                var worker = $scope.workers[0];
                var _resource = {
                  id: worker._id,
                  name: worker.displayName,
                  groupName: worker.groupName,
                  avatar: worker.profilePic,
                  type: 1
                };
                ganttItem.resources = [_resource];
              }
            } else {
              if (csTask) {
                for (var i = 0; i < csTask.requiredWorkerCount; i++) {
                  if (i >= csTask.workers.length) break;
                  var _worker = csTask.workers[i];
                  var _resource2 = {
                    id: _worker._id,
                    name: _worker.displayName,
                    groupName: _worker.groupName,
                    avatar: _worker.profilePic,
                    type: 1
                  };

                  if (isWorkerAvailable(_resource2, ganttItem.start_date, ganttItem.end_date)) {
                    ganttItem.resources.push(_resource2);
                  }
                }
              }
            }
          }

          for (var _i2 = 0; _i2 < ganttItem.resources.length; _i2++) {
            var _resource3 = ganttItem.resources[_i2];

            if (_resource3.type === 1) {
              if (!timeline.resources.workers[_resource3.id]) {
                timeline.resources.workers[_resource3.id] = _resource3;
              }
            } else {
              if (!timeline.resources.subcontractors[_resource3.id]) {
                timeline.resources.subcontractors[_resource3.id] = _resource3;
              }
            }

            ganttItem.resourceIds.push(_resource3.id);
          } // group


          var workType = ganttItem.workType;
          var workLevel = ganttItem.workLevel;

          if (timeline.groups.workType) {
            if (!timeline.groups.workType[workType]) {
              timeline.groups.workType[workType] = workType;
            }
          }

          if (timeline.groups.workLevel) {
            if (!timeline.groups.workLevel[workLevel]) {
              timeline.groups.workLevel[workLevel] = workLevel;
            }
          }

          timeline.gantt.data.push(ganttItem);

          if (task.dependency) {
            ganttItem.dependency = task.dependency;
            timeline.gantt.links.push({
              id: utils.bsonId(),
              source: ganttItem.dependency,
              target: ganttItem.id,
              type: gantt.config.links.finish_to_start,
              workType: ganttItem.workType
            });
          }

          setStyle(workType);

          if (task.taskStyle === 'Subcontractor') {
            setupSubcontractorTask(ganttItem, timeline.gantt);
          }

          return ganttItem;
        }

        function taskToGantt(task) {
          var ganttItem = {
            id: task._id,
            text: task.name,
            type: gantt.config.types.task,
            description: task.description,
            workLevel: task.workLevel || '1',
            workType: task.workType || '1',
            progress: task.progress,
            delay: 0,
            calcHours: utils.num(task.calcHours),
            workedHours: utils.num(task.workedHours),
            modelId: task.modelId,
            modelType: task.modelType,
            objectId: task.objectId,
            status: utils.num(task.status),
            priority: utils.num(task.priority),
            resources: [],
            resourceIds: [],
            owner: task.owner,
            tasks: [],
            combined: task.combined,
            calcSheet: task.calcSheet,
            calcItem: task.calcItem,
            taskStyle: task.taskStyle,
            project: task.project,
            show: true
          };

          if (task.parent) {
            ganttItem.parent = task.parent;
          }

          if (task.product) {
            ganttItem.product = task.product._id;
          }

          return ganttItem;
        }

        function subTaskToGantt(task, prev) {
          var ganttItem = taskToGantt(task);

          if (task.startDate && task.endDate) {
            ganttItem.start_date = new Date(task.startDate);
            ganttItem.end_date = new Date(task.endDate);
          }

          if (prev && ganttItem.start_date && ganttItem.end_date && prev.start_date && prev.end_date) {
            var start = ganttItem.start_date.getTime() - prev.start_date.getTime();
            var length = prev.end_date.getTime() - prev.start_date.getTime();
            ganttItem.percentage = length === 0 ? 100 : Math.min(100, Math.ceil(start * 100 / length));
          } else {
            ganttItem.percentage = 0;
          }

          if (task.resources && task.resources.length > 0) {
            ganttItem.resources = [];
            task.resources.forEach(function (res) {
              if (res.worker) {
                ganttItem.resources.push({
                  id: res.worker._id,
                  name: res.worker.name || res.worker.displayName,
                  avatar: res.worker.profilePic,
                  type: res.workerType === 'Employee' ? 1 : 2
                });
              }
            });
          }

          return ganttItem;
        }

        function setupSubcontractorTask(task, ganttData) {
          var duration = task.calcHours * 3600000;
          var divider = 250 * 3600000; // 250 hours

          if (duration <= divider) return;
          var date = task.start_date;

          do {
            var ganttItem = angular.copy(task);
            var taskDuration = duration > divider ? divider : duration;
            ganttItem.id = utils.bsonId();
            ganttItem.start_date = new Date(date);
            ganttItem.end_date = new Date(date.getTime() + taskDuration);
            ganttItem.parent = task.id;
            ganttItem.composeState = 'sub-child';
            date = ganttItem.end_date;
            duration -= divider;
            ganttData.data.push(ganttItem);
            ganttData.links.push({
              id: utils.bsonId(),
              source: task.id,
              target: ganttItem.id,
              type: gantt.config.links.start_to_start,
              workType: ganttItem.workType
            });
          } while (duration > 0);
        }

        function setStyle(workType) {
          if (angular.isUndefined($scope.styles[workType])) {
            $scope.styles[workType] = styleIndex;
            styleIndex++;
          }
        }

        function getTaskDates(begin, duration) {
          var date = new Date(begin);
          var availableHourFrom = str2hhss('10:00');
          var availableHourTo = str2hhss('18:00');
          var availableWeekdayFrom = 1;
          var availableWeekdayTo = 5;
          var startTimeValue = getHourMinMillis(date);

          if (startTimeValue < availableHourFrom.millisecs) {
            date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
          } else if (startTimeValue > availableHourTo.millisecs) {
            date.setDate(date.getDate() + 1);
            date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
          }

          considerWeekday(date, availableWeekdayFrom, availableWeekdayTo, availableHourFrom);
          var startTime = new Date(date);
          var firstAvailableDuration = availableHourTo.millisecs - getHourMinMillis(date);
          var availableDuration = availableHourTo.millisecs - availableHourFrom.millisecs;

          if (duration <= firstAvailableDuration) {
            date.setTime(date.getTime() + duration);
          } else {
            date.setDate(date.getDate() + 1);
            date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
            considerWeekday(date, availableWeekdayFrom, availableWeekdayTo, availableHourFrom);
            duration -= firstAvailableDuration;
            var dayCount = Math.floor(duration / availableDuration); // day count

            if (dayCount > 0) {
              addWorkDays(date, dayCount);
              date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
              considerWeekday(date, availableWeekdayFrom, availableWeekdayTo, availableHourFrom);
            }

            var remained = duration - availableDuration * dayCount;

            if (remained > 0) {
              date.setTime(date.getTime() + remained);
            }
          }

          var endTime = date;
          $scope.holidays.forEach(function (holiday) {
            var holiday_startDate = new Date(holiday.startDate);
            var holiday_endDate = new Date(holiday.endDate);

            if (startTime < holiday_startDate) {
              var holiDuration = holiday_endDate - holiday_startDate;
              endTime = new Date(endTime.getTime() + holiDuration);
            }
          });
          return {
            start: startTime,
            end: endTime
          };
        }

        function str2hhss(str) {
          var a = str.split(':'); // split it at the colons
          // minutes are worth 60 seconds. Hours are worth 60 minutes.

          var millisecs = (+a[0] * 60 + +a[1]) * 60000;
          return {
            hours: +a[0],
            minutes: +a[1],
            millisecs: millisecs
          };
        }

        function getHourMinMillis(date) {
          var hour = date.getHours();
          var minutes = date.getMinutes();
          return (hour * 60 + minutes) * 60000;
        }

        function considerWeekday(date, weekFrom, weekTo, hourFrom) {
          var weekday = date.getDay();

          if (weekday < weekFrom) {
            var gap = weekFrom - weekday;
            date.setDate(date.getDate() + gap);
            date.setHours(hourFrom.hours, hourFrom.minutes, 0, 1);
          } else if (weekday > weekTo) {
            var _gap = 7 - weekday + weekFrom;

            date.setDate(date.getDate() + _gap);
            date.setHours(hourFrom.hours, hourFrom.minutes, 0, 1);
          }
        }

        function addWorkDays(date, days) {
          var weekday = date.getDay();
          var daysToAdd = parseInt(days); // If the current day is Sunday add one day

          if (weekday === 0) daysToAdd++; // If the start date plus the additional days falls on or after the closest Saturday calculate weekends

          if (weekday + daysToAdd >= 6) {
            //Subtract days in current working week from work days
            var remainingWorkDays = daysToAdd - (5 - weekday); //Add current working week's weekend

            daysToAdd += 2;

            if (remainingWorkDays > 5) {
              //Add two days for each working week by calculating how many weeks are included
              daysToAdd += 2 * Math.floor(remainingWorkDays / 5); //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks

              if (remainingWorkDays % 5 === 0) daysToAdd -= 2;
            }
          }

          date.setDate(date.getDate() + daysToAdd);
          return date;
        }

        function isWorkerAvailable(resource, startDate, endDate) {
          startDate = new Date(startDate);
          endDate = new Date(endDate);
          var end = new Date(startDate);
          end.setHours(23, 59, 59, 999);

          if (endDate <= end) {
            // it's one day
            return getHoursOnDay(resource, startDate, end) > 0;
          } else {
            var hour = 0;
            var start = startDate;

            while (start <= endDate) {
              hour += getHoursOnDay(resource, start, end);
              start.setDate(start.getDate() + 1);
              start.setHours(0, 0, 0, 0);
              end = new Date(start);
              end.setHours(23, 59, 59, 999);

              if (end.getTime() > endDate.getTime()) {
                end = endDate;
              }
            }

            return hour > 0;
          }
        }

        function getWorkableHours(resource, startTime, endTime, tasks) {
          var start = new Date(startTime);
          var end = new Date(endTime); //get available hour

          end.setTime(end.getTime() - 1000);
          var duration = (end - start) / 3600000;

          if (duration <= 24) {
            // it's small than one day
            return getHoursOnDay(resource, start, end, tasks);
          } else {
            var date = new Date(start);
            var hours = 0;
            var endDate = new Date();

            while (date.getTime() < end.getTime()) {
              endDate.setTime(date.getTime());
              endDate.setHours(23, 59, 59, 0);

              if (endDate.getTime() > end.getTime()) {
                endDate = end;
              }

              hours += getHoursOnDay(resource, date, endDate, tasks);
              date.setTime(date.getTime() + 24 * 3600000);
            }

            return hours;
          }
        }

        function getHoursOnDay(resource, start, end, tasks) {
          var weekday = start.getDay();

          if (weekday === 6 || weekday === 0) {
            return 0;
          }

          var hrsWItem = getHrsWItem(resource, weekday);

          if (hrsWItem) {
            if (weekday >= hrsWItem.startWeekday && weekday <= hrsWItem.endWeekday) {
              var startTime = new Date(start);
              var endTime = new Date(end);
              var time = new Date(hrsWItem.startTime);
              startTime.setHours(time.getHours(), time.getMinutes(), 0, 0);
              time = new Date(hrsWItem.endTime);
              endTime.setHours(time.getHours(), time.getMinutes(), 0, 0);
              return getHoursFromTasksOnDay(tasks, startTime, endTime);
            }

            return 0;
          }

          if (resource.type === 2) {
            return Math.min(8, end - start);
          } else {
            var workerSetting = getWorkerSetting(resource, weekday);

            if (workerSetting && workerSetting.dailyHours) {
              var _startTime = new Date(start);

              var _endTime = new Date(end);

              var _time = utils.getTimeFromString(workerSetting.start);

              _startTime.setHours(_time.hour, _time.minute, 0, 0);

              _time = utils.getTimeFromString(workerSetting.stop);

              _endTime.setHours(_time.hour, _time.minute, 0, 0);

              return getHoursFromTasksOnDay(tasks, _startTime, _endTime, workerSetting.dailyHours);
            }

            return 0;
          }
        }

        function getHrsWItem(resource) {
          var item = undefined;

          if ($scope.hrswItems) {
            item = $scope.hrswItems.find(function (x) {
              return x.worker === resource.id;
            });

            if (!item) {
              item = $scope.hrswItems.find(function (x) {
                return x.worker === 'all';
              });
            }
          }

          return item;
        }

        function getWorkerSetting(resource, weekday) {
          if (resource.type === 1) {
            var worker = $scope.workers.find(function (x) {
              return x._id === resource.id;
            });

            if (worker && worker.employeeSettingId) {
              var workingTimes = worker.employeeSettingId.workingTimes;

              if (workingTimes) {
                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                return workingTimes.find(function (it) {
                  return it.day === days[weekday];
                });
              }
            }
          }

          return undefined;
        }

        function getHoursFromTasksOnDay(tasks, start, end, maxHour) {
          var hours = (end - start) / 3600000;

          if (tasks) {
            var total = 0;
            tasks.forEach(function (task) {
              var duration = hours;

              if (start < task.start_date && task.start_date < end) {
                duration -= (task.start_date - start) / 3600000;
              }

              if (task.end_date < end && task.end_date > start) {
                duration -= (end - task.end_date) / 3600000;
              }

              if (angular.isDefined(maxHour)) {
                duration = Math.min(maxHour, duration);
              }

              total += duration;
            });
            hours = angular.isDefined(maxHour) ? Math.min(maxHour, total) : total;
          } else {
            if (angular.isDefined(maxHour)) {
              hours = Math.min(maxHour, hours);
            }
          }

          hours = Math.min(8, hours);
          return hours;
        }

        var sumReducer = function sumReducer(accumulator, currentValue) {
          return accumulator + currentValue;
        };

        function getPattern(arr) {
          var typeOrderList = [];
          arr.forEach(function (items) {
            typeOrderList.push(items.map(function (x) {
              return x.typeName;
            }).join(','));
          });
          var matchList = [];
          typeOrderList.forEach(function (typeOrder, index) {
            if (typeOrderList.filter(function (x) {
              return x === typeOrder;
            }).length > MINT_MATCH_WORKPATTERNS_COUNT) {
              matchList.push(arr[index]);
            }
          });

          if (!utils.isEmpty(matchList)) {
            matchList.forEach(function (items) {
              for (var i = 0; i < items.length; i++) {
                var item = items[i];

                if (i === 0) {
                  item.percentage = 0;
                } else {
                  var percentage = 100;
                  var prevItem = items[i - 1];
                  var periodTime = new Date(prevItem.endDate).getTime() - new Date(prevItem.startDate).getTime();
                  var movedTime = new Date(prevItem.endDate).getTime() - new Date(item.startDate).getTime();

                  if (movedTime > 0) {
                    percentage = Math.ceil(movedTime / periodTime * 100);
                    if (percentage > 100) percentage = 100;
                  }

                  item.percentage = percentage;
                }
              }
            });
            var pattern = matchList[0];
            pattern.forEach(function (item, index) {
              delete item._id;
              delete item.startDate;
              delete item.endDate;
              item.tagName = item.typeName;
              delete item.typeName;
              item.tagId = $scope.workPattern.items[index].tagId;
              var percentageList = [];
              matchList.forEach(function (items) {
                percentageList.push(items[index].percentage);
              });
              item.percentage = Math.ceil(percentageList.reduce(sumReducer) / matchList.length);
            });
            return pattern;
          }

          return undefined;
        }

        function updateWorkPattern() {
          if (!utils.isEmpty($scope.workPattern)) {
            var levels = {};
            gantt.eachTask(function (task) {
              if (task.type === gantt.config.types.task) {
                if (utils.isEmpty(levels[task.workLevel])) {
                  levels[task.workLevel] = {};
                  levels[task.workLevel][task.workType] = [task];
                } else if (utils.isEmpty(levels[task.workLevel][task.workType])) {
                  levels[task.workLevel][task.workType] = [task];
                } else {
                  levels[task.workLevel][task.workType].push(task);
                }
              }
            });
            var levelList = [];
            Object.values(levels).forEach(function (level) {
              if (Object.keys(level).length === $scope.workPattern.items.length) {
                var _level = [];
                $scope.workPattern.items.forEach(function (type) {
                  var items = level[type.tagName];
                  items.sort(function (a, b) {
                    return a.start_date.getTime() - b.start_date.getTime();
                  });
                  var startDate = items[0].start_date.toJSON();
                  var endDate = items[items.length - 1].end_date.toJSON();
                  var _type = {
                    typeName: type.tagName,
                    startDate: startDate,
                    endDate: endDate
                  };

                  _level.push(_type);
                });
                levelList.push(_level);
              }
            });

            if (!utils.isEmpty(levelList)) {
              var payload = levelList.map(function (items) {
                return {
                  projectId: $scope.project._id,
                  items: items,
                  used: false
                };
              });
              $scope.updating = true;
              apiFactory.createTimelineWorkPatterns(payload).then(function (res) {
                $scope.updating = false;
                $scope.timelineWorkPatterns = $scope.timelineWorkPatterns.concat(res.data.list);
                Notification.success('Saved a new temporary work pattern to cache. It doesn\'t affect work pattern updates yet.');

                if ($scope.timelineWorkPatterns.length >= FETCH_WORKPATTERNS_COUNT) {
                  var pattern = getPattern($scope.timelineWorkPatterns.map(function (x) {
                    return x.items;
                  }).concat(levelList));

                  if (angular.isDefined(pattern)) {
                    payload = {
                      tagId: $scope.workPattern.tagId,
                      items: pattern
                    };
                    $scope.updating = true;
                    Promise.all([apiFactory.updateWorkPattern(payload), apiFactory.markAsUsedWorkPatterns($scope.project._id)]).then(function (res) {
                      $scope.updating = false;
                      $scope.workPattern = res[0].data.data;
                      $scope.timelineWorkPatterns = [];
                      Notification.success('Updated work pattern successfully.');
                    })["catch"](function () {
                      return $scope.updating = false;
                    });
                  }
                }
              })["catch"](function () {
                return $scope.updating = false;
              });
            }
          }
        }

        function saveTimeline() {
          return new Promise(function (resolve, reject) {
            if ($scope.isAllProject) {
              var projects = [];
              gantt.eachTask(function (task) {
                projects.push({
                  id: task.id,
                  startDate: task.start_date.toJSON(),
                  endDate: task.end_date.toJSON()
                });
              });
              apiFactory.updateProjectsDuration({
                projects: projects
              }).then(function () {
                Notification.success("Timeline data is saved.");
                $scope.isEdited = false;
                resolve();
              })["catch"](function (e) {
                $log.error(e);
                Notification.error("Error is occurred during synchronize data.");
                reject();
              });
            } else {
              if (angular.isUndefined($scope.timeline)) {
                if (reject) reject();
                return;
              }

              var groups = [];
              var timelineTasks = [];
              gantt.eachTask(function (task) {
                var index = gantt.getGlobalTaskIndex(task.id);

                if (task.type === gantt.config.types.task) {
                  var timelineTask = makeTimelineTask(task);

                  if (task.composeState === 'combined') {
                    task.tasks.forEach(function (subTask) {
                      timelineTask.tasks.push(subTask.id);
                      timelineTasks.push(makeTimelineTask(subTask));
                    });
                  }

                  timelineTask.order = index;
                  timelineTasks.push(timelineTask);
                } else {
                  groups.push({
                    _id: task.id,
                    order: index
                  });
                }
              });
              var resources = [];

              for (var i = 2; i < $scope.resourceData.length; i++) {
                resources.push({
                  worker: $scope.resourceData[i].id,
                  workerType: $scope.resourceData[i].parent === 1 ? 'Employee' : 'Subcontractor'
                });
              }

              apiFactory.saveTimeline({
                projectId: $scope.project._id,
                groups: groups,
                tasks: timelineTasks,
                progress: $scope.totalProgress,
                resources: resources
              }).then(function () {
                Notification.success("Timeline data is saved.");
                $scope.isEdited = false;
                $scope.refreshFlowline = true;
                if (resolve) resolve();
              })["catch"](function (e) {
                $log.error(e);
                Notification.error("Error is occurred during synchronize data.");
                if (reject) reject(e);
              });
            }
          });
        }

        function makeTimelineTask(ganttTask) {
          var timelineTask = {
            _id: ganttTask.id,
            name: ganttTask.text,
            description: ganttTask.description,
            startDate: ganttTask.start_date,
            endDate: ganttTask.end_date,
            parent: ganttTask.parent,
            dependency: ganttTask.dependency,
            workLevel: ganttTask.workLevel,
            workType: ganttTask.workType,
            progress: ganttTask.progress,
            calcHours: ganttTask.calcHours,
            workedHours: ganttTask.workedHours,
            modelId: ganttTask.modelId,
            modelType: ganttTask.modelType,
            objectId: ganttTask.objectId,
            status: ganttTask.status,
            priority: ganttTask.priority,
            resources: [],
            requiredWorkerCount: ganttTask.requiredWorkerCount,
            owner: ganttTask.owner ? ganttTask.owner._id : $scope.user._id,
            tasks: [],
            combined: ganttTask.combined,
            calcSheet: ganttTask.calcSheet,
            calcItem: ganttTask.calcItem,
            project: $scope.project._id,
            product: ganttTask.product,
            productType: ganttTask.productType,
            taskStyle: ganttTask.taskStyle,
            group: ganttTask.group
          };
          timelineTask.resources = ganttTask.resources.map(function (res) {
            return {
              worker: res.id,
              workerType: res.type === 1 ? 'Employee' : 'Subcontractor'
            };
          });
          return timelineTask;
        }

        function loadCurrentResources(task) {
          var curResources = [];
          var workerCount = 0;
          var subContractorCount = 0;

          if (task.resources) {
            task.resources.forEach(function (resource) {
              if (resource.type === 1) {
                curResources.push({
                  id: resource.id,
                  text: resource.name,
                  groupName: resource.groupName,
                  avatar: resource.avatar,
                  parent: 1
                });
                workerCount++;
              } else {
                curResources.push({
                  id: resource.id,
                  text: resource.name,
                  groupName: '',
                  avatar: resource.avatar,
                  parent: 2
                });
                subContractorCount++;
              }
            });
          }

          curResources.unshift({
            id: 2,
            text: "Sub Contractors (".concat(subContractorCount, ")"),
            type: gantt.config.types.project
          });
          curResources.unshift({
            id: 1,
            text: "Workers (".concat(workerCount, ")"),
            type: gantt.config.types.project
          });
          $scope.currentResources = curResources;
        }

        function selectTask(task) {
          if (task.modelId && task.modelType) {
            $scope.modelViewer = {
              modelType: task.modelType,
              modelId: task.modelId,
              objectId: task.objectId
            };
            $timeout(function () {
              return $scope.$apply();
            });
            return true;
          }

          return false;
        }

        function updateTaskDelay(task) {
          if (task.status !== 3) {
            var progress = utils.progressOfDate(task.start_date, task.end_date, new Date(), true);

            if (task.progress < progress) {
              task.status = 4;
              task.delay = progress - task.progress;
            } else {
              task.status = 1;
              task.delay = 0;
            }
          }
        }

        function refreshWorkersToTimeline() {
          gantt.eachTask(function (task) {
            if (task.type !== gantt.config.types.task) return;

            if (task.resources) {
              for (var i = task.resources.length; i >= 0; i--) {
                var resource = task.resources[i];

                if (!isWorkerAvailable(resource, task.start_date, task.end_date)) {
                  task.resources.splice(i, 1);
                }
              }

              task.resourceIds = [];
              task.resources.forEach(function (x) {
                return task.resourceIds.push(x.id);
              });
            }
          });
          gantt.refreshData();
        }

        function combineAuto() {
          var taskMap = {};
          gantt.eachTask(function (task) {
            if (task.type !== gantt.config.types.task || task.composeState === 'combined' || !task.product) return;
            var key = (task.parent ? task.parent : 'root') + '-' + task.product;
            var items = taskMap[key];

            if (!items) {
              items = [];
              taskMap[key] = items;
            }

            items.push(task);
          });
          gantt.batchUpdate(function () {
            for (var key in taskMap) {
              var items = taskMap[key];
              if (!items || items.length < 2) continue;
              combineOne(items);
            }
          });
        }

        function combineOne(tasks) {
          var resources = [];
          var ids = [];
          var startDate = undefined,
              endDate = undefined;
          var start = 0,
              end = 0;
          var progress = 0;
          var delay = 0;
          var status = 0;
          var calcHours = 0;
          var workedHours = 0;
          var modelId = undefined,
              modelType = undefined,
              objectId = undefined;
          var requiredWorkerCount = 0;

          for (var i = 0; i < tasks.length; i++) {
            tasks[i].percentage = 50;

            if (tasks[i].resources) {
              tasks[i].resources.forEach(function (r) {
                if (resources.findIndex(function (x) {
                  return x.id === r.id;
                }) === -1) {
                  resources.push(r);
                  ids.push(r.id);
                }
              });
            }

            if (i === 0) {
              startDate = tasks[0].start_date;
              endDate = new Date(tasks[0].end_date);
              start = startDate.getTime();
              end = endDate.getTime();
            } else {
              var percentage = 0.5;
              start += (end - start) * percentage;
              end = start + tasks[i].end_date.getTime() - tasks[i].start_date.getTime();

              if (endDate.getTime() < end) {
                endDate.setTime(end);
              }
            }

            progress += utils.num(tasks[i].progress);
            delay += utils.num(tasks[i].delay);
            calcHours += utils.num(tasks[i].calcHours);
            workedHours += utils.num(tasks[i].workedHours);
            tasks[i].combined = true;

            if (tasks[i].modelId && tasks[i].modelType) {
              modelId = tasks[i].modelId;
              modelType = tasks[i].modelType;
              objectId = tasks[i].objectId;
            }

            if (tasks[i].requiredWorkerCount > requiredWorkerCount) {
              requiredWorkerCount = tasks[i].requiredWorkerCount;
            }

            if (tasks[i].status === 4) {
              status = 4;
            }
          }

          var timelineItem = {
            id: utils.bsonId(),
            text: tasks[0].text,
            description: tasks[0].description,
            type: gantt.config.types.task,
            start_date: startDate,
            end_date: endDate,
            parent: tasks[0].parent,
            resources: resources,
            resourceIds: ids,
            composeState: 'combined',
            tasks: tasks,
            progress: progress / tasks.length,
            delay: delay / tasks.length,
            calcHours: calcHours,
            workedHours: workedHours,
            workType: tasks[0].workType,
            workLevel: tasks[0].workLevel,
            status: status,
            modelId: modelId,
            modelType: modelType,
            objectId: objectId,
            requiredWorkerCount: requiredWorkerCount
          };

          for (var _i3 = 0; _i3 < tasks.length; _i3++) {
            tasks[_i3].group = timelineItem.id;
            gantt.deleteTask(tasks[_i3].id);
          }

          gantt.addTask(timelineItem);
        }

        function showAnyModel() {
          var timeline = $scope.ganttData.data || [];

          for (var i = 0; i < timeline.length; i++) {
            var task = timeline[i];

            if (task.modelId && task.modelType) {
              $scope.modelViewer = {
                modelType: task.modelType,
                modelId: task.modelId,
                objectId: task.objectId
              };
              $timeout(function () {
                return $scope.$apply();
              });
              return;
            }
          }
        }

        var TaskStyles = ['blue', //'#537bc4',
        'sky', //'#4dc9f6',
        'orange', //'#f67019',
        'pink', //'#f53794',
        'yellow', //'#acc236',
        'd-green', //'#166a8f',
        'green', //'#00a950',
        'grey', //'#58595b',
        'purple' //'#8549ba',
        ];
        var mainConfig = {
          scale_height: dp(43),
          row_height: dp(32),
          task_height: dp(18),
          columns: [{
            name: "wbs",
            label: "#",
            align: "left",
            width: dp(50),
            template: gantt.getWBSCode
          }, {
            name: "text",
            label: "Title",
            tree: true,
            width: '*',
            min_width: dp(180),
            template: function template(task) {
              return "<span title=\"".concat(task.text, "\">").concat(task.text, "</span>");
            }
          }, {
            name: "start_date",
            label: "Start<br/>Date",
            align: "center",
            width: dp(80),
            min_width: dp(80),
            template: function template(task) {
              return moment(task.start_date).format("D MMM, YYYY");
            }
          }, {
            name: "end_date",
            label: "End<br/>Date",
            align: "center",
            width: dp(80),
            min_width: dp(80),
            template: function template(task) {
              return moment(task.end_date).format("D MMM, YYYY");
            }
          }, {
            name: "status",
            label: "Status",
            align: "center",
            width: dp(40),
            template: function template(task) {
              switch (task.status) {
                case 0:
                  return '<img src="/assets/icons/status-waiting.svg" title="Not Started" alt="">';

                case 1:
                  return '<img src="/assets/icons/status-working.svg" title="On Going" alt="">';

                case 2:
                  return '<img src="/assets/icons/status-warning.svg" title="On Hold" alt="">';

                case 3:
                  return '<img src="/assets/icons/status-completed.svg" title="Completed" alt="">';

                case 4:
                  return '<img src="/assets/icons/status-warning.svg" title="Delayed" alt="">';

                default:
                  return '<img src="/assets/icons/status-waiting.svg" title="Not Started" alt="">';
              }
            }
          }, {
            name: "progress",
            label: "Percent<br/>Complete",
            align: "center",
            width: dp(50),
            template: function template(task) {
              return Math.ceil(task.progress * 100) + '%';
            }
          }, {
            name: "delay",
            label: "Delay",
            align: "center",
            width: dp(50),
            template: function template(task) {
              var delay = utils.num(task.delay);
              return "<div class=\"delay ".concat(delay > 0.5 ? 'delay-warning' : delay > 0 ? 'delay-small' : '', "\">").concat(Math.ceil(delay * 100), "%</div>");
            }
          }, // {
          //   name: "duration", label: "Est.<br/>Hours", align: "center", width: 50, template: function(task) {
          //     let duration = Math.ceil(utils.num(task.duration));
          //     return duration < 1 ? 1 : duration;
          //   }
          // },
          {
            name: "calc_duration",
            label: "Calc.<br/>Hours",
            align: "center",
            width: dp(50),
            template: function template(task) {
              return utils.getRoundNumWithLocale(utils.num(task.calcHours), 2, 'en');
            }
          }, {
            name: "days",
            label: "Working<br/>Days",
            align: "center",
            width: dp(60),
            template: function template(task) {
              var days = Math.ceil(parseFloat(task.duration) / 8.0);
              return days < 1 ? 1 : days;
            }
          }, {
            name: "needs",
            label: "Required<br/>Workers",
            align: "center",
            width: dp(40),
            template: function template(task) {
              return utils.num(task.requiredWorkerCount);
            }
          }, {
            name: "resources",
            label: "Resources",
            align: "center",
            width: 100,
            min_width: dp(100),
            template: function template(task) {
              var content = '<div class="d-flex h-100">';
              var assignments = [];
              getAssignments(task, assignments);

              if (!assignments.length) {
                content += "<div class=\"resource-avatar unassigned my-auto\"></div>unassigned";
              } else {
                if (assignments.length === 1) {
                  var resource = assignments[0];

                  if (resource) {
                    content += makeResourceAvatar(resource);
                  }
                } else {
                  content += makeResourceAvatar(assignments[0]);
                  content += makeResourceAvatar(assignments[1]);

                  if (assignments.length > 2) {
                    content += "+".concat(assignments.length - 2, " more");
                  }
                }
              }

              content += '</div>';
              return content;
            }
          }]
        };
        var simpleResourceConfig = {
          scale_height: 0,
          row_height: dp(26),
          columns: [{
            name: "number",
            label: "R",
            align: "center",
            width: dp(30),
            template: function template(resource) {
              return resource.id;
            }
          }, {
            name: "name",
            label: "name",
            align: "left",
            width: '*',
            min_width: dp(180),
            template: function template(resource) {
              return resource.text;
            }
          }, {
            name: "count",
            label: "count",
            align: "center",
            width: dp(180),
            template: function template(resource) {
              return $scope.getTotalCount ? $scope.getTotalCount(resource.id) : 0;
            }
          }]
        };
        var resourceLabelConfig = {
          scale_height: dp(40),
          columns: [{
            name: "text",
            label: "Name",
            width: dp(180)
          }, {
            name: "group",
            label: "Group",
            tree: true,
            width: dp(110)
          }, {
            name: "progress",
            label: "Complete",
            width: dp(60),
            align: "center"
          }, {
            name: "workload",
            label: "Workload",
            width: dp(80),
            align: "center"
          }, {
            name: "capacity",
            label: "Capacity",
            width: dp(80),
            align: "center"
          }, {
            name: 'worker',
            label: '<div class="d-flex">' + '<img id="plus-worker" class="cursor-point ml-auto" src="/assets/icons/plus-user.svg" alt="">' + '<img id="filter-worker" class="cursor-point ml-10 mr-20" src="/assets/icons/filter-sm.svg" alt="">' + '</div>',
            width: dp(70)
          }]
        };
        var resourceConfig = {
          scale_height: 0,
          row_height: dp(26),
          columns: [{
            name: "text",
            label: "Name",
            tree: true,
            width: dp(180),
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return resource.text;
              }

              if (resource.avatar) {
                return "<div class=\"d-flex\"><img src=\"".concat(resource.avatar, "\" class=\"resource-avatar\"  alt=\"avatar\"/>").concat(resource.text, "</div>");
              } else {
                return "<div class=\"d-flex\"><div class=\"resource-avatar my-auto\">".concat(resource.text ? resource.text.charAt(0).toUpperCase() : 'A', "</div>").concat(resource.text, "</div>");
              }
            }
          }, {
            name: "group",
            label: "Group",
            width: dp(110),
            template: function template(resource) {
              return resource.groupName ? resource.groupName : '';
            }
          }, {
            name: "progress",
            label: "Complete",
            width: dp(60),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                var tasks = gantt.getTaskBy('resourceIds', resource.id);
                var totalDuration = 0;
                var workDuration = 0;
                tasks.forEach(function (task) {
                  totalDuration += task.duration;
                  workDuration += task.duration * utils.num(task.progress);
                });
                var progress = totalDuration === 0 ? 0 : utils.num(Math.ceil(workDuration * 100 / totalDuration));
                return "".concat(progress, "%");
              }
            }
          }, {
            name: "workload",
            label: "Workload",
            width: dp(80),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                var tasks = gantt.getTaskBy('resourceIds', resource.id);
                var totalDuration = 0;
                tasks.forEach(function (task) {
                  totalDuration += task.duration;
                });
                return (totalDuration || 0) + "h";
              }
            }
          }, {
            name: "capacity",
            label: "Capacity",
            width: dp(80),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                // let store = gantt.getDatastore(gantt.config.resource_store);
                // let n = store.hasChild(resource.id) ? store.getChildren(resource.id).length : 1
                var state = gantt.getState();
                return gantt.calculateDuration(state.min_date, state.max_date) * 8 + "h"; //* n * 8 + "h";
              }
            }
          }, {
            name: "worker",
            label: "Worker",
            width: dp(68),
            align: "center",
            template: function template(resource) {
              if (resource.id === 1 || resource.id === 2) {
                return '';
              } else {
                return "<img src=\"/assets/icons/delete1.svg\" class=\"cursor-point\" name=\"remove-worker\" id=\"".concat(resource.id, "\" alt=\"\" />");
              }
            }
          }]
        };
        var defaultLayout = {
          css: "gantt_container",
          cols: [{
            rows: [{
              config: mainConfig,
              cols: [{
                width: dp(580),
                min_width: dp(400),
                rows: [{
                  view: "grid",
                  scrollX: "gridScroll",
                  scrollY: "scrollVer",
                  scrollable: true
                }]
              }, {
                view: "timeline",
                scrollX: "scrollHor",
                scrollY: "scrollVer"
              }]
            }, {
              id: "resource",
              css: "gantt-resource",
              height: dp(52),
              config: simpleResourceConfig,
              cols: [{
                width: dp(580),
                min_width: dp(400),
                rows: [{
                  view: "resourceGrid",
                  scrollX: "gridScroll",
                  scrollable: true
                }, {
                  view: "scrollbar",
                  id: "gridScroll",
                  scroll: "x"
                }]
              }, {
                rows: [{
                  view: "resourceTimeline",
                  scrollX: "scrollHor"
                }, {
                  view: "scrollbar",
                  id: "scrollHor",
                  group: "horizontal"
                }]
              }]
            }]
          }, {
            view: "scrollbar",
            id: "scrollVer",
            group: "vertical"
          }]
        };
        var resourceLayout = {
          css: "gantt_container",
          rows: [{
            config: mainConfig,
            cols: [{
              width: dp(580),
              min_width: dp(400),
              rows: [{
                view: "grid",
                scrollX: "gridScroll",
                scrollY: "scrollVer",
                scrollable: true
              }]
            }, {
              view: "timeline",
              scrollX: "scrollHor",
              scrollY: "scrollVer"
            }, {
              view: "scrollbar",
              id: "scrollVer",
              group: "horizontal"
            }]
          }, {
            resizer: true,
            width: 1,
            next: "resource"
          }, {
            height: dp(40),
            config: resourceLabelConfig,
            cols: [{
              view: "grid",
              width: dp(580),
              min_width: dp(400)
            }, {
              html: "Resource Usage",
              css: "resource-usage"
            }]
          }, {
            id: "resource",
            css: "gantt-resource",
            height: dp(104),
            config: resourceConfig,
            cols: [{
              width: dp(580),
              min_width: dp(400),
              rows: [{
                view: "resourceGrid",
                scrollX: "gridScroll",
                scrollY: "resourceVScroll",
                scrollable: true
              }, {
                view: "scrollbar",
                id: "gridScroll",
                scroll: "x"
              }]
            }, {
              rows: [{
                view: "resourceTimeline",
                scrollX: "scrollHor",
                scrollY: "resourceVScroll"
              }, {
                view: "scrollbar",
                id: "scrollHor",
                group: "horizontal"
              }]
            }, {
              view: "scrollbar",
              id: "resourceVScroll",
              group: "vertical"
            }]
          }]
        };
        initGanttConfig();
        $timeout(function () {
          return gantt.init('project-timeline');
        });

        function initGanttConfig() {
          gantt.plugins({
            auto_scheduling: true,
            grouping: true,
            marker: true
          }); // gantt config

          gantt.config.show_errors = false;
          gantt.config.static_background = false;
          gantt.config.show_task_cells = true;
          gantt.config.smart_scales = true;
          gantt.config.smart_rendering = true;
          gantt.config.show_progress = true;
          gantt.config.work_time = true;
          gantt.config.duration_unit = "hour";
          gantt.config.round_dnd_dates = false;
          gantt.config.min_duration = 24 * 3600000; // 1 day

          gantt.config.skip_off_time = false;
          gantt.config.order_branch = true;
          gantt.config.order_branch_free = false;
          gantt.config.fit_tasks = false;
          gantt.config.open_tree_initially = true;
          gantt.config.grid_resize = false;
          gantt.config.drag_links = false;
          gantt.config.drag_progress = false;
          gantt.config.drag_project = true;
          gantt.config.link_line_width = 1;
          gantt.config.show_links = false;
          gantt.config.auto_scheduling = true;
          gantt.config.auto_scheduling_initial = false;
          gantt.config.resource_store = "resource";
          gantt.config.resource_property = "resourceIds";
          gantt.config.layout = $scope.resourceMode ? resourceLayout : defaultLayout;
          gantt.config.resource_render_empty_cells = !$scope.resourceMode; // renderer

          gantt.config.type_renderers[gantt.config.types.project] = function (task) {
            if (gantt.isSplitTask(task)) return;
            var taskClass = getTaskClass(task.$virtual && $scope.groupType === 'workType' ? task.text : task.workType);
            var element = $document[0].createElement("div");
            element.setAttribute(gantt.config.task_attribute, task.id);
            var size = gantt.getTaskPosition(task);
            element.innerHTML = "<div class=\"gantt_task_content\"><div class='project-left'></div><div class='project-right'></div><div class=\"project-text\">".concat(task.text, "</div></div>");
            element.classList.add("gantt-group");
            element.classList.add(taskClass);
            element.classList.add("gantt_project");
            element.classList.add("gantt_bar_project");
            element.classList.add("gantt_dependent_task");
            element.style.left = size.left + "px";
            element.style.top = size.top + dp(6) + "px";
            element.style.width = size.width + "px";
            $compile(element)($scope);
            return element;
          };

          gantt.config.type_renderers[gantt.config.types.task] = function (task, defaultRender) {
            var element = defaultRender(task);
            if (!element) return;

            if (task.project) {
              element.classList.add("custom-project");
              $compile(element)($scope);
            } else {
              element.setAttribute("droppable", "");
              element.setAttribute("drop-data", "\"".concat(task.id, "\""));
              element.setAttribute("drop-event", "onTaskDropped");
              $compile(element)($scope);
            }

            return element;
          }; // gantt template


          gantt.templates.grid_header_class = function () {
            return "timeline-header-cell";
          };

          gantt.templates.grid_row_class = function (start, end, task) {
            if (drag_id && task.id !== drag_id) {
              if (task.parent !== gantt.getTask(drag_id).parent) {
                return "cant-drop";
              }
            }

            return "";
          };

          gantt.templates.task_class = function (start, end, task) {
            return getTaskClass(task.workType);
          };

          gantt.templates.task_row_class = function () {
            return "gantt-task-row";
          };

          gantt.templates.timeline_cell_class = function (task, date) {
            if (date.getDay() === 0 || date.getDay() === 6) {
              return 'weekend';
            }
          };

          gantt.templates.link_class = function (link) {
            var style = getTaskClass(link.workType);
            if (link.flag) style += ' ' + link.flag;
            return style;
          };

          gantt.templates.task_text = function (start, end, task) {
            return "<span class=\"task-text\">".concat(task.text, "</span><span class=\"progress-text\">").concat(Math.ceil(task.progress * 100), "%</span>");
          };

          gantt.templates.rightside_text = function () {
            return '';
          };

          gantt.templates.resource_cell_class = function (start, end, resource, tasks) {
            var css = [];
            css.push("resource_marker");

            if ($scope.resourceMode) {
              var scale = (end - start) / 3600000;
              if (scale !== 1) scale /= 3;
              var hours = getWorkerHours(resource, start, end, tasks);

              if (hours === scale) {
                css.push("workday_ok");
              } else if (hours > scale) {
                css.push("workday_over");
              } else {
                css.push("workday_less");
              }
            }

            return css.join(" ");
          };

          gantt.templates.resource_cell_value = function (start, end, resource, tasks) {
            var html = "<div>";

            if ($scope.resourceMode) {
              if (resourceMode === "hours") {
                html += getWorkerHours(resource, start, end, tasks);
              } else {
                html += tasks.length;
              }
            } else {
              var count = $scope.getWorkerCount ? $scope.getWorkerCount(gantt, start, end) : {
                working: 0,
                required: 0
              };

              if (resource.id === 'W') {
                html += count.working;
              } else {
                html += count.required;
              }
            }

            html += "</div>";
            return html;
          }; // resource store


          resourceStore = gantt.createDatastore({
            name: gantt.config.resource_store,
            type: "treeDatastore"
          });
          resourceStore.attachEvent("onAfterSelect", function () {
            gantt.refreshData();
          }); // set working time

          gantt.setWorkTime({
            hours: [10, 18]
          }); // lightbox

          gantt.showLightbox = function (taskId) {
            var task = gantt.getTask(taskId);

            if (task.type === gantt.config.types.task && $scope.editTask) {
              $scope.editTask(task);
            }

            return false;
          };

          gantt.hideLightbox = function () {}; // event


          gantt.attachEvent("onTaskDrag", function (id, mode, task) {
            var state = gantt.getState();
            var minDate = state.min_date,
                maxDate = state.max_date;
            var scaleStep = gantt.date.add(new Date(), state.scale_step * 3, state.scale_unit) - new Date();
            var showDate,
                repaint = false;

            if (mode === "resize" || mode === "move") {
              if (Math.abs(task.start_date - minDate) < scaleStep) {
                showDate = task.start_date;
                repaint = true;
              } else if (Math.abs(task.end_date - maxDate) < scaleStep) {
                showDate = task.end_date;
                repaint = true;
              } else {
                var range = gantt.getSubtaskDates();

                if (range.start_date && range.end_date) {
                  if (Math.abs(range.start_date - minDate) > scaleStep) {
                    repaint = true;
                    showDate = null;
                  } else if (Math.abs(maxDate - range.end_date) > scaleStep) {
                    repaint = true;
                    showDate = null;
                  }
                }
              }

              if (repaint) {
                gantt.render();

                if (showDate) {
                  gantt.showDate(showDate);
                }
              }
            }
          });
          gantt.attachEvent("onAfterTaskDrag", function (id, mode) {
            if (mode === "resize" || mode === "move") {
              if (angular.isDefined($scope.taskChanged)) {
                $scope.taskChanged(id, gantt.getTask(id));
              }
            }
          });
          gantt.attachEvent("onBeforeTaskDisplay", function (id, task) {
            return angular.isUndefined(task.show) || task.show;
          });
          gantt.attachEvent("onTaskSelected", function (id) {
            if (angular.isDefined($scope.taskSelected)) {
              $scope.taskSelected(id);
            }
          });
          gantt.attachEvent("onAfterTaskUpdate", function () {
            $scope.taskUpdated();
          });
          gantt.attachEvent("onLinkDblClick", function () {
            return false;
          });
          gantt.attachEvent("onRowDragStart", function (id) {
            drag_id = id;
            return true;
          });
          gantt.attachEvent("onRowDragEnd", function () {
            drag_id = null;
            gantt.render();
          });
          gantt.attachEvent("onBeforeTaskMove", function (id, parent) {
            return gantt.getTask(id).parent === parent;
          }); // gantt.attachEvent("onBeforeRowDragEnd", function(id, target) {
          //   return gantt.getTask(id).parent === target.parent;
          // });
          // markers

          gantt.attachEvent("onGanttRender", function () {
            addMarker('today', new Date(), 'TODAY');

            if ($scope.deadline) {
              addMarker('deadline', $scope.deadline, 'END');
            } else {
              removeMarker('deadline');
            }

            if (gantt.$container && container !== gantt.$container) {
              gantt.event(gantt.$container, "click", function (e) {
                var target = e.target; // check if the target element is our button:

                if (target.closest("[name='remove-worker']")) {
                  // if it's the resource button - do the action
                  var row = target.closest("[data-resource-id]");
                  var resourceId = row.getAttribute("data-resource-id");
                  $scope.removeWorker(resourceId);
                }
              });
              container = gantt.$container;
            }
          });
        }

        function setScaleConfig(value) {
          var cssForScale = function cssForScale(date) {
            var weekday = date.getDay();

            if (weekday === 0 || weekday === 6) {
              return 'subscale scale-weekend';
            }

            return 'subscale';
          };

          switch (value) {
            case "day":
              gantt.config.scale_unit = "day";
              gantt.config.step = 1;
              gantt.config.date_scale = "%d %M";
              gantt.config.subscales = [{
                unit: "hour",
                step: 1,
                date: "%H",
                css: cssForScale
              }];
              gantt.templates.date_scale = null;
              columnWidth = dp(24);
              break;

            case "week":
              gantt.config.scale_unit = "week";
              gantt.config.step = 1;

              gantt.templates.date_scale = function (date) {
                var dateToStr = gantt.date.date_to_str("%d %M");
                var startDate = gantt.date.week_start(new Date(date));
                var endDate = gantt.date.add(gantt.date.add(startDate, 1, "week"), -1, "day");
                return dateToStr(startDate) + " - " + dateToStr(endDate);
              };

              gantt.config.subscales = [{
                unit: "day",
                step: 1,
                date: "%D",
                css: cssForScale
              }];
              columnWidth = dp(24);
              break;

            case "month":
              gantt.config.scale_unit = "month";
              gantt.config.date_scale = "%F %Y";
              gantt.config.subscales = [{
                unit: "day",
                step: 1,
                date: "%j",
                css: cssForScale
              }];
              gantt.templates.date_scale = null;
              columnWidth = dp(24);
              break;

            case "quarter":
              gantt.config.scale_unit = "month";
              gantt.config.step = 1;
              gantt.config.date_scale = "%M";
              gantt.templates.date_scale = null;
              gantt.config.subscales = [{
                unit: "quarter",
                step: 1,
                template: function template(date) {
                  var dateToStr = gantt.date.date_to_str("%M");
                  var endDate = gantt.date.add(gantt.date.add(date, 3, "month"), -1, "day");
                  return dateToStr(date) + " - " + dateToStr(endDate);
                },
                css: cssForScale
              }];
              columnWidth = dp(30);
              break;

            case "year":
              gantt.config.scale_unit = "year";
              gantt.config.step = 1;
              gantt.config.date_scale = "%Y";
              gantt.config.min_column_width = 50 * $scope.zoom;
              gantt.templates.date_scale = null;
              gantt.config.subscales = [{
                unit: "month",
                step: 1,
                date: "%M",
                css: cssForScale
              }];
              columnWidth = dp(40);
              break;
          }

          gantt.config.min_column_width = columnWidth * $scope.zoom;
          gantt.config.start_on_monday = false;
        }

        function searchGantt(keyword, type) {
          if (angular.isUndefined(keyword)) return;
          gantt.eachTask(function (task) {
            if (keyword === '') {
              task.show = true;
            } else {
              if (type === 'type') {
                task.show = angular.isDefined(task.workType) && task.workType.indexOf(keyword) !== -1;
              } else if (type === 'worker') {
                task.show = false;

                if (task.resources) {
                  for (var i = 0; i < task.resources.length; i++) {
                    if (task.resources[i].name && task.resources[i].name.indexOf(keyword) !== -1) {
                      task.show = true;
                      break;
                    }
                  }
                }
              } else {
                task.show = angular.isUndefined(task.text) || task.text.indexOf(keyword) !== -1;
              }
            }
          });
          gantt.refreshData();
        }

        function getWorkerHours(resource, start, end, tasks) {
          if ($scope.getWorkerHours) {
            var hours = $scope.getWorkerHours({
              id: resource.id,
              type: resource.parent
            }, start, end, tasks);
            return Math.ceil(hours);
          }

          return 0;
        }

        function getAssignments(task, assignments) {
          if (gantt.hasChild(task.id)) {
            var children = gantt.getChildren(task.id);

            for (var i = 0; i < children.length; i++) {
              getAssignments(gantt.getTask(children[i]), assignments);
            }
          } else {
            (function () {
              var resources = task.resources;

              if (resources) {
                var _loop2 = function _loop2(_i4) {
                  if (assignments.findIndex(function (x) {
                    return x.id === resources[_i4].id;
                  }) === -1) {
                    assignments.push(resources[_i4]);
                  }
                };

                for (var _i4 = 0; _i4 < resources.length; _i4++) {
                  _loop2(_i4);
                }
              }
            })();
          }
        }

        function makeResourceAvatar(resource) {
          if (!resource) return '';

          if (resource.avatar) {
            return "<img src=\"".concat(resource.avatar, "\" class=\"resource-avatar my-auto\" alt=\"\" />");
          } else {
            return "<div class=\"resource-avatar my-auto\">".concat(resource.name ? resource.name.charAt(0).toUpperCase() : 'A', "</div>");
          }
        }

        function getTaskClass(workType) {
          if (!workType) return 'none';
          var index = utils.num($scope.styles[workType]);
          return TaskStyles[index % TaskStyles.length];
        }

        function addMarker(id, date, text) {
          var marker = angular.element("#" + id);

          if (!marker.length) {
            var elem = $document[0].createElement("div");
            elem.classList.add('gantt-marker');
            elem.classList.add(id);
            elem.id = id;
            elem.innerHTML = "<div class=\"top\">".concat(text, "</div><div class=\"line\"></div>");

            if (gantt.$task) {
              gantt.$task.appendChild(elem);
            }

            marker = angular.element(elem);
          }

          var pos = gantt.posFromDate(date) - 7;
          marker.css("left", pos + "px");
        }

        function removeMarker(id) {
          var marker = angular.element("#" + id);

          if (marker.length && gantt.$task) {
            gantt.$task.removeChild(marker[0]);
          }
        }

        function setupResourceUI() {
          var plusWorker = angular.element('#plus-worker');

          if (plusWorker) {
            gantt.event(plusWorker[0], "click", $scope.addWorker);
          }
        }

        function dp(n) {
          return Math.ceil(utils.num(n) * $rootScope.scale);
        }

        $scope.$watch('ganttData', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          gantt.clearAll();
          gantt.parse(newValue, "json");
          resourceStore.parse([{
            id: 'W',
            text: "Working"
          }, {
            id: 'R',
            text: "Required"
          }]);
        });
        $scope.$watch('resourceData', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          for (var i = 0; i < newValue.length; i++) {
            resourceMap[newValue[i].id] = newValue[i];
          }
        });
        $scope.$watch('groupData', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          for (var i = 0; i < newValue.length; i++) {
            var group = newValue[i];
            gantt.serverList(group.name, group.data);
          }
        });
        $scope.$watch('viewStyle', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          setScaleConfig(newValue);
          gantt.render();
        });
        $scope.$watch('zoomValue', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          gantt.config.min_column_width = columnWidth * newValue;
          gantt.render();
        });
        $scope.$watch('searchText', function (newValue) {
          searchGantt(newValue, $scope.searchType);
        });
        $scope.$watch('searchType', function (newValue) {
          searchGantt($scope.search, newValue);
        });
        $scope.$watch('ganttType', function (newValue) {
          if (newValue) {
            gantt.groupBy({
              groups: gantt.serverList(newValue),
              relation_property: newValue,
              group_id: "key",
              group_text: "label"
            });
            gantt.sort("start_date");
          } else {
            gantt.groupBy(false);
          }
        });
        $scope.$watch('showResources', function (newValue) {
          if (angular.isDefined(newValue)) {
            gantt.config.resource_render_empty_cells = !newValue;
            gantt.config.layout = newValue ? resourceLayout : defaultLayout;
            gantt.resetLayout();

            if (newValue) {
              resourceStore.clearAll();
              resourceStore.parse($scope.currentResources);
              setupResourceUI();
            } else {
              resourceStore.clearAll();
              resourceStore.parse([{
                id: 'W',
                text: "Working",
                count: 1
              }, {
                id: 'R',
                text: "Required",
                count: 1
              }]);
            }
          }
        });
        $scope.$watch('currentResources', function (newValue) {
          if (angular.isDefined(newValue) && $scope.resourceMode) {
            resourceStore.clearAll();
            resourceStore.parse(newValue);
            setupResourceUI();
          }
        });
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app.core').directive('paginationCustomNew', paginationCustomNew);

  function paginationCustomNew() {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/pagination-custom-new/pagination-custom-new.html',
      scope: {
        numPages: '=',
        currentPage: '=',
        onSelectPage: '&'
      },
      replace: true,
      link: function link(scope) {
        scope.pages = [1];
        var pages = [];
        scope.prevPage = 0;
        scope.summaryPages = [];

        scope.updatePageNumBlock = function () {
          scope.pages = [];

          var _iterator = _createForOfIteratorHelper(pages),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var page = _step.value;
              if (pages.length <= 8) scope.pages.push(page);else {
                if (scope.currentPage <= 6) {
                  if (scope.currentPage <= 2) {
                    if (page <= 5) scope.pages.push(page);else {
                      if (page >= pages.length - 1) {
                        if (scope.pages[scope.pages.length - 1] < page - 1) scope.pages.push('...');
                        scope.pages.push(page);
                      }
                    }
                  } else {
                    if (page <= scope.currentPage + 2) {
                      scope.pages.push(page);
                    } else {
                      if (page >= pages.length - 1) {
                        if (scope.pages[scope.pages.length - 1] < page - 1) scope.pages.push('...');
                        scope.pages.push(page);
                      }
                    }
                  }
                } else if (scope.currentPage > 6 && scope.currentPage <= pages.length - 6) {
                  if (page <= 2) scope.pages.push(page);

                  if (page >= scope.currentPage - 2 && scope.currentPage + 2 >= page) {
                    if (scope.pages[scope.pages.length - 1] < page - 1) scope.pages.push('...');
                    scope.pages.push(page);
                  }

                  if (page >= pages.length - 1) {
                    if (scope.pages[scope.pages.length - 1] < page - 1) scope.pages.push('...');
                    scope.pages.push(page);
                  }
                } else {
                  if (scope.currentPage >= pages.length - 1) {
                    if (page <= 2) scope.pages.push(page);else {
                      if (page > pages.length - 5) {
                        if (scope.pages[scope.pages.length - 1] + 2 < scope.currentPage - 2) scope.pages.push('...');
                        scope.pages.push(page);
                      }
                    }
                  } else {
                    if (scope.currentPage <= 6) {
                      scope.pages.push(page);
                    } else {
                      if (page <= 2) scope.pages.push(page);else {
                        if (page >= scope.currentPage - 2) {
                          if (scope.pages[scope.pages.length - 1] + 2 < scope.currentPage - 2) scope.pages.push('...');
                          scope.pages.push(page);
                        }
                      }
                    }
                  }
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        };

        scope.$watch('numPages', function (value) {
          pages = [];

          for (var i = 1; i <= value; i++) {
            pages.push(i);
          }

          if (scope.currentPage > value) {
            scope.selectPage(value);
          }

          scope.updatePageNumBlock();
        });

        scope.noPrevious = function () {
          return scope.currentPage === 1;
        };

        scope.noNext = function () {
          return scope.currentPage === scope.numPages;
        };

        scope.isActive = function (page) {
          if (page === 0) {
            page = 1;
          }

          return scope.currentPage === page;
        };

        scope.$watch('currentPage', function () {
          if (scope.prevPage != 0) scope.onSelectPage();
        });

        scope.selectPage = function (page) {
          if (!scope.isActive(page) && page != '...') {
            scope.prevPage = scope.currentPage;
            scope.currentPage = page;
            scope.updatePageNumBlock();
          }
        };

        scope.selectPrevious = function () {
          if (!scope.noPrevious()) {
            scope.selectPage(scope.currentPage - 1);
          }
        };

        scope.selectNext = function () {
          if (!scope.noNext()) {
            scope.selectPage(scope.currentPage + 1);
          }
        };
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app.core').directive('pagination', pagination);

  function pagination() {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/pagination-custom/pagination-custom.html',
      scope: {
        numPages: '=',
        currentPage: '=',
        onSelectPage: '&'
      },
      replace: true,
      link: function link(scope) {
        scope.pages = [1];
        var pages = [];
        scope.prevPage = 0;
        scope.summaryPages = [];

        scope.updatePageNumBlock = function () {
          scope.pages = [];

          var _iterator = _createForOfIteratorHelper(pages),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var page = _step.value;
              if (pages.length <= 8) scope.pages.push(page);else {
                if (scope.currentPage <= 6) {
                  if (scope.currentPage <= 2) {
                    if (page <= 5) scope.pages.push(page);else {
                      if (page >= pages.length - 1) {
                        if (scope.pages[scope.pages.length - 1] < page - 1) scope.pages.push('...');
                        scope.pages.push(page);
                      }
                    }
                  } else {
                    if (page <= scope.currentPage + 2) {
                      scope.pages.push(page);
                    } else {
                      if (page >= pages.length - 1) {
                        if (scope.pages[scope.pages.length - 1] < page - 1) scope.pages.push('...');
                        scope.pages.push(page);
                      }
                    }
                  }
                } else if (scope.currentPage > 6 && scope.currentPage <= pages.length - 6) {
                  if (page <= 2) scope.pages.push(page);

                  if (page >= scope.currentPage - 2 && scope.currentPage + 2 >= page) {
                    if (scope.pages[scope.pages.length - 1] < page - 1) scope.pages.push('...');
                    scope.pages.push(page);
                  }

                  if (page >= pages.length - 1) {
                    if (scope.pages[scope.pages.length - 1] < page - 1) scope.pages.push('...');
                    scope.pages.push(page);
                  }
                } else {
                  if (scope.currentPage >= pages.length - 1) {
                    if (page <= 2) scope.pages.push(page);else {
                      if (page > pages.length - 5) {
                        if (scope.pages[scope.pages.length - 1] + 2 < scope.currentPage - 2) scope.pages.push('...');
                        scope.pages.push(page);
                      }
                    }
                  } else {
                    if (scope.currentPage <= 6) {
                      scope.pages.push(page);
                    } else {
                      if (page <= 2) scope.pages.push(page);else {
                        if (page >= scope.currentPage - 2) {
                          if (scope.pages[scope.pages.length - 1] + 2 < scope.currentPage - 2) scope.pages.push('...');
                          scope.pages.push(page);
                        }
                      }
                    }
                  }
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        };

        scope.$watch('numPages', function (value) {
          pages = [];

          for (var i = 1; i <= value; i++) {
            pages.push(i);
          }

          if (scope.currentPage > value) {
            scope.selectPage(value);
          }

          scope.updatePageNumBlock();
        });

        scope.noPrevious = function () {
          return scope.currentPage === 1;
        };

        scope.noNext = function () {
          return scope.currentPage === scope.numPages;
        };

        scope.isActive = function (page) {
          if (page === 0) {
            page = 1;
          }

          return scope.currentPage === page;
        };

        scope.$watch('currentPage', function () {
          if (scope.prevPage != 0) scope.onSelectPage();
        });

        scope.selectPage = function (page) {
          if (!scope.isActive(page) && page != '...') {
            scope.prevPage = scope.currentPage;
            scope.currentPage = page;
            scope.updatePageNumBlock();
          }
        };

        scope.selectPrevious = function () {
          if (!scope.noPrevious()) {
            scope.selectPage(scope.currentPage - 1);
          }
        };

        scope.selectNext = function () {
          if (!scope.noNext()) {
            scope.selectPage(scope.currentPage + 1);
          }
        };
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app').directive('overtimeEdit', overtimeEdit);

  function overtimeEdit(utils) {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/overtime-edit/overtime-edit.view.html',
      scope: {
        ngModel: '='
      },
      link: function link($scope) {
        function init() {
          if (angular.isUndefined($scope.ngModel)) {
            $scope.ngModel = '';
          }

          $scope.overtimeList = [];
          var overtimeTextList = $scope.ngModel.split(';');

          var _iterator = _createForOfIteratorHelper(overtimeTextList),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var overtimeText = _step.value;

              if (!utils.isEmpty(overtimeText)) {
                var arr = overtimeText.split('+');
                var timeVal = arr[0];
                var percentVal = arr[1];
                timeVal = timeVal ? timeVal.replace(',', '.') : '';
                percentVal = percentVal ? percentVal.replace(',', '.') : '';
                $scope.overtimeList.push({
                  timeVal: Number.parseFloat(timeVal).toString(),
                  percentVal: Number.parseFloat(percentVal).toString()
                });
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        init();

        $scope.addOvertime = function () {
          if ($scope.overtimeList.length < 2) {
            $scope.overtimeList.push({
              timeVal: '',
              percentVal: ''
            });
          }
        };

        $scope.deleteOvertime = function (index) {
          $scope.overtimeList.splice(index, 1);
        };

        function updateOvertimeList() {
          if (!utils.isEmpty($scope.overtimeList)) {
            var arr = [];

            var _iterator2 = _createForOfIteratorHelper($scope.overtimeList),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var overtime = _step2.value;
                var text = overtime.timeVal ? overtime.timeVal + 'H' : '';

                if (overtime.percentVal) {
                  text = text + '+' + overtime.percentVal + '%';
                }

                arr.push(text);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            $scope.ngModel = arr.join(';');
          } else {
            $scope.ngModel = '';
          }
        }

        $scope.updateOvertime = function () {
          updateOvertimeList();
        };

        $scope.$watch('overtimeList.length', function () {
          updateOvertimeList();
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app.core').directive('noData', noData);

  function noData() {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/no-data/no-data.html',
      scope: {
        text: '@text'
      },
      link: function link() {}
    };
  }
})();


"use strict";

(function () {
  angular.module('app.core').directive('mainTitleBar', mainTitleBar);

  function mainTitleBar($state, $document, $log, globals, $window) {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/main-titlebar/main-titlebar.view.html',
      replace: true,
      scope: {},
      link: linkFunc
    };

    function linkFunc(scope) {
      var projectStore = globals.projectStore,
          userStore = globals.userStore,
          logout = globals.logout;
      var user = userStore.get();
      var project = projectStore.get();
      scope.isFullscreen = false;
      scope.pages = [];
      scope.curPage = undefined;
      init();

      scope.goHome = function () {
        $state.go(globals.getDashboardRoute(user));
      };

      scope.minimize = function () {
        exitFullScreen();
      };

      scope.toggleFullscreen = function () {
        toggleFullscreen();
      };

      scope.closeWindow = function () {
        logout();
      };

      scope.openPage = function () {// scope.pages.push({projectId: project._id, title: project.projectName});
      };

      scope.closePage = function (page, index) {
        if (scope.pages.length < 2) {
          logout();
        } else {
          scope.pages.splice(index, 1);

          if (page === scope.curPage) {
            scope.curPage = scope.pages[0];

            if (page.id === "synergies") {
              scope.goHome();
            } else if (page.id === "tender") {
              $state.go("login");
            }
          }
        }
      };

      scope.selectPage = function (page) {
        if (scope.curPage === page) return;
        scope.curPage = page;

        if (page.id === "login") {
          $state.go("login");
        } else if (page.id === "eco") {
          $window.location.href = "https://eco.cloudes.one";
        }
      };

      function init() {
        var currentRoute = $state.current.url;

        if ($state.current.parent) {
          currentRoute = $state.current.parent;
        }

        if (currentRoute.includes('/')) {
          currentRoute = currentRoute.split('/')[1];
        }

        if (currentRoute === "login" || currentRoute === "tender-list") {
          scope.pages = [{
            id: 'login',
            title: "CloudES"
          }, {
            id: 'eco',
            title: "EcoES"
          }];
        } else if (currentRoute === "register") {
          scope.pages = [{
            id: 'register',
            title: "CloudES"
          }, {
            id: 'eco',
            title: "EcoES"
          }];
        } else if (currentRoute === "setPassword" || currentRoute === "forgetPassword") {
          scope.pages = [{
            title: "CloudES"
          }];
        } else {
          if (project) {
            scope.pages = [{
              projectId: project._id,
              title: project.projectName
            }];
          }
        }

        if (currentRoute === "synergies") {
          scope.pages.push({
            id: "synergies",
            title: "CloudES - Synergy.surf"
          });
          scope.curPage = scope.pages[scope.pages.length - 1];
        } else if (currentRoute === "tender-list") {
          scope.curPage = scope.pages[1];
        } else {
          scope.curPage = scope.pages[0];
        }
      }

      function toggleFullscreen() {
        var doc = $document[0];
        var elem = doc.documentElement;

        if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
          if (elem.requestFullscreen) {
            elem.requestFullscreen();
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          }

          scope.isFullscreen = true;
        } else {
          if (doc.exitFullscreen) {
            doc.exitFullscreen();
          } else if (doc.msExitFullscreen) {
            doc.msExitFullscreen();
          } else if (doc.mozCancelFullScreen) {
            doc.mozCancelFullScreen();
          } else if (doc.webkitExitFullscreen) {
            doc.webkitExitFullscreen();
          }

          scope.isFullscreen = false;
        }
      }

      function exitFullScreen() {
        var doc = $document[0];

        if (doc.fullscreenElement || doc.mozFullScreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement) {
          if (doc.exitFullscreen) {
            doc.exitFullscreen();
          } else if (doc.msExitFullscreen) {
            doc.msExitFullscreen();
          } else if (doc.mozCancelFullScreen) {
            doc.mozCancelFullScreen();
          } else if (doc.webkitExitFullscreen) {
            doc.webkitExitFullscreen();
          }
        }

        scope.isFullscreen = false;
      }
    }
  }
})();


"use strict";

/* eslint-disable no-unused-vars */
(function () {
  angular.module('app.core').directive('mainNavBar', mainNavBar);

  function mainNavBar(globals, $state, $timeout, Notification, authFactory, apiFactory, $rootScope, localStorageService, $document, $log, $uibModal, utils, $window, $filter, storageFactory) {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/main-navbar/main-navbar.view.html',
      scope: {
        type: '@'
      },
      link: linkFunc
    };

    function linkFunc(scope) {
      var menuNameList = ['dashboard', 'project', 'economic', 'calc', 'visual-time', 'qshe'];
      var dashboardSubMenuList = ['ceo-page', 'finance', 'auditmanager-page', 'bidmanager-page', 'economic', 'projectdesign-page', 'productionsboard-page', 'sitemanager-page', 'qshemanager-page', 'collaborator'];
      var dashboardFinanceSubMenuNameList = ['dashboard', 'bank', 'sales', 'purchases', 'reports', 'finance', 'balance', 'vat-settings'];
      var dashboardCollaboratorSubMenuNameList = ['client-page', 'supplier-page', 'subcontractor-page'];
      var moreSubMenuNameList = ['fileManage', 'synergies', 'collaborations', 'mail', 'clients', 'employees', 'sub-contractors', 'suppliers', 'materials', 'equipments', 'control-plan', 'check-list', 'offers', 'orders', 'type-writter', 'spread-sheet', 'calendar', 'todo', 'settings'];
      var calcSubMenuNameList = ['calc', 'budget', 'company-budget'];
      var calcCalcSubMenuNameList = ['extra', 'main', 'versions'];
      var economicSubMenuNameList = ['dashboard', 'invoice', 'bill', 'va-order', 'payroll']; // const economicInvoiceSubMenuList = ['create', 'list'];
      // const economicBillSubMenuList = ['approve', 'list'];

      var economicOrdersSubMenuList = ['create', 'list'];
      var visualTimeSubMenuNameList = ['vp', 'bim', 'pcd', 'photo', 'timeline']; // const visualTimeVpSubMenuNameList = ['new-plan', 'grid'];
      // const visualTimeDynamic3dSubMenuNameList = ['upload-model', 'grid'];

      var qsheSubMenuNameList = ['tq', 'issues', 'report']; // const qsheIssuesSubMenuNameList = ['create', 'overview'];
      // const projectSubMenuList = ['project', 'project-list'];
      // const createprojectSubMenuList = ['create-project', 'createServiceProject', ''];

      var projectStore = globals.projectStore,
          logout = globals.logout,
          userStore = globals.userStore;

      if (!authFactory.checkUser()) {
        logout();
        return;
      }

      scope.userData = userStore.get();
      scope.profilePic = scope.userData.profilePic;
      scope.userName = scope.userData.firstName + scope.userData.lastName;
      scope.email = scope.userData.email;
      scope.isShowSynergy = false;
      scope.isShowDrawing = false;
      scope.isShowInvoice = false;
      scope.isShowBill = false;
      scope.isShowNotification = false;
      scope.drawingCount = 0;
      scope.invoiceCount = 0;
      scope.billCount = 0;
      scope.notificationCount = 0;
      scope.selectedProjectName = ""; // let AccessLabelList = Object.keys(Constants.AccessKey);
      // let AccessValueList = Object.values(Constants.AccessKey);

      var dType = globals.getDashboardType(scope.userData);
      scope.dashboardType = dType; // if (scope.userData.designation === "Admin") {
      //   AccessLabelList.forEach(key => {
      //     scope[key + '_ACCESS_CREATE'] = 4;
      //   });
      // } else {
      //   apiFactory.getAccessSettingDetails({dType, list: AccessValueList})
      //     .then(res => {
      //       AccessLabelList.forEach(key => {
      //         scope[key + '_ACCESS_CREATE'] = res.data.data[Constants.AccessKey[key]] ? res.data.data[Constants.AccessKey[key]] : 0;
      //       })
      //     })
      //     .catch((e) => {
      //       $log.error(e);
      //       Notification.error('Something went wrong try later')
      //     });
      // }

      var loadBookmarksCallback = scope.$on('bookmark:reload', loadBookmarks);
      scope.$on('$destroy', loadBookmarksCallback);
      var onSelProject = $rootScope.$on('on-select-project', function (event, params) {
        scope.project = params;
        scope.selectedProjectName = scope.project.projectName;
        chooseProject(params);
      });
      $rootScope.$on('$destroy', onSelProject);
      scope.$on('onProjectChanged', function () {
        scope.project = projectStore.get();
        scope.selectedProjectName = scope.project.projectName;
      });
      apiFactory.getSystemStatus().then(function (resp) {
        scope.drawingCount = resp.data.drawingCount;
        scope.invoiceCount = resp.data.invoiceCount;
        scope.billCount = resp.data.billCount;
        scope.notificationCount = resp.data.notificationCount;
      })["catch"](function (err) {
        $log.error(err);
      }); // $timeout(() => updateUI());

      loadBookmarks();

      scope.toggleEditProfile = function () {
        $uibModal.open({
          animation: true,
          component: 'editProfileModal',
          windowClass: 'edit-profile-modal'
        });
      };

      scope.toggleUpdateStatus = function () {
        $uibModal.open({
          animation: true,
          component: 'updateStatusModal',
          windowClass: 'update-status-modal'
        });
      };

      scope.toggleHelp = function () {
        $window.open('https://con-cube.com', 'blank');
      };

      scope.statusClass = function () {
        switch (scope.userData.status) {
          case 'Active':
            return ['active'];

          case 'Away':
            return ['away'];

          case 'Do not disturb':
            return ['disturb'];

          case 'Invisible':
            return ['offline'];

          default:
            return ['active'];
        }
      };

      scope.showPermissionError = function () {
        Notification.error('Permission denied');
      };

      scope.showDashboard = function () {
        $state.go(globals.getDashboardRoute(scope.userData));
      };

      scope.goToUpdateProject = function () {
        var project = projectStore.get();

        if (project._id == 'all') {
          Notification.error("Please select project");
        } else {
          $state.go('updateProject', {
            id: project._id
          });
        }
      };

      scope.gotoPage = function (page, permission, flag) {
        var user = userStore.get();
        var project = projectStore.get(); // permission = permission || user.designation === 'Admin' || project.createdBy === user._id;

        permission = true;

        if (!permission) {
          scope.showPermissionError();
          return;
        }

        if (page === 'settings') {
          var currentRoute = $state.current.url;

          if ($state.current.parent) {
            currentRoute = $state.current.parent;
          }

          if (currentRoute.includes('/')) {
            currentRoute = currentRoute.split('/')[1];
          }

          if (currentRoute === page) {
            return;
          }
        }

        if (page === "calcExtra") {
          if (!project || project._id === 'all') {
            Notification.error('Please select project first.');
          } else {
            $state.go(page, {
              id: "prepare"
            });
          }

          return;
        }

        if (project && project._id !== 'all' || flag) {
          if (page === 'createIssue') {
            localStorageService.set('issueData', {});
          } else if (page === 'createReports') {
            localStorageService.set('reportData', {});
          } else if (page === 'createTQ') {
            localStorageService.set('tqData', {});
          } else if (page === 'timeline') {
            if (!project || project._id !== 'all' && project.projectStatus !== 1 && project.projectStatus !== 6) {
              Notification.error('Only ONGOING or PRECAST project can see timeline.');
              return;
            }
          }

          $state.go(page);
        } else {
          if (page === 'fileManage') {
            $state.go(page);
          } else {
            Notification.error('Please select project first.');
          }
        }
      };

      scope.logout = function () {
        logout();
      };

      scope.selectedProject = function (project) {
        if (project._id === 'others') {
          $state.go('projectList');
        } else {
          scope.project = angular.copy(project);
          scope.selectedProjectName = project.projectName;
          projectStore.set(project);

          if ($state.current.parent && $state.current.parent == "appMail") {
            return;
          }

          $state.reload();
        }
      };

      scope.changeProject = function (pName) {
        var filteredProject = scope.activeProjectList.filter(function (el) {
          return el.projectName == pName;
        });
        scope.project = angular.copy(filteredProject[0]);
        projectStore.set(scope.project);
        $state.reload();
      };

      scope.selectedOtherProject = function () {
        $state.go('projectList');
      };

      scope.openDlgUpload = function () {
        if (scope.DVIEWER_ACCESS_CREATE < 3) {
          scope.showPermissionError();
          return;
        }

        $uibModal.open({
          animation: true,
          component: 'uploadModelModal',
          windowClass: 'upload-bim-modal',
          backdrop: 'static'
        });
      };

      scope.addNewPlan = function () {
        if (scope.VP_ACCESS_CREATE < 3) {
          scope.showPermissionError();
          return;
        }

        $uibModal.open({
          animation: true,
          component: 'filePickerModal',
          windowClass: 'file-picker-modal',
          keyboard: false,
          backdrop: 'static'
        });
      };

      scope.showSynergy = function () {
        scope.isShowSynergy = true;
        $uibModal.open({
          animation: false,
          component: 'navSynergyModal',
          windowClass: 'nav-synergy-modal',
          backdropClass: 'nav-synergy-modal-backdrop',
          keyboard: false
        }).result.then(function () {
          scope.isShowSynergy = false;
        }, function () {
          scope.isShowSynergy = false;
        });
      };

      scope.showDrawing = function () {
        scope.isShowDrawing = true;
        $uibModal.open({
          animation: false,
          component: 'navDrawingModal',
          windowClass: 'nav-drawing-modal',
          backdropClass: 'nav-drawing-modal-backdrop',
          keyboard: false
        }).result.then(function () {
          scope.isShowDrawing = false;
        }, function () {
          scope.isShowDrawing = false;
        });
      };

      scope.showInvoice = function () {
        scope.isShowInvoice = true;
        $uibModal.open({
          animation: false,
          component: 'navInvoiceModal',
          windowClass: 'nav-invoice-modal',
          backdropClass: 'nav-invoice-modal-backdrop',
          keyboard: false
        }).result.then(function () {
          scope.isShowInvoice = false;
        }, function () {
          scope.isShowInvoice = false;
        });
      };

      scope.showBill = function () {
        scope.isShowBill = true;
        $uibModal.open({
          animation: false,
          component: 'navBillModal',
          windowClass: 'nav-bill-modal',
          backdropClass: 'nav-bill-modal-backdrop',
          keyboard: false
        }).result.then(function () {
          scope.isShowBill = false;
        }, function () {
          scope.isShowBill = false;
        });
      };

      scope.showNotification = function () {
        scope.isShowNotification = true;
        $uibModal.open({
          animation: false,
          component: 'navNotificationModal',
          windowClass: 'nav-notification-modal',
          backdropClass: 'nav-notification-modal-backdrop',
          keyboard: false
        }).result.then(function (result) {
          scope.isShowNotification = false;

          if (result) {
            scope.notificationCount = 0;
          }
        }, function () {
          scope.isShowNotification = false;
        });
      };

      scope.isInPage = function (state) {
        return $state.current.name === state;
      }; // function loadActiveProjectLists() {
      //   apiFactory
      //   .listAllProjects({
      //     isActive: true
      //   })
      //   .then(resp => {
      //     // let project = projectStore.get();
      //     let project = projectStore.get();
      //     scope.activeProjectList = resp.data.list;
      //     scope.activeProjectList.unshift({_id: 'all', projectName: $filter('translate')("All Projects")});
      //     if (project) {
      //       scope.project = project;
      //     } else if (scope.activeProjectList.length > 2) {
      //       scope.project = scope.activeProjectList[1];
      //       chooseProject(scope.project);
      //     } else {
      //       $log.info('on-select-project-no-bookmark');
      //       scope.$root.$emit('on-select-project-no-bookmark');
      //     }
      //     if(scope.project)
      //       scope.selectedProjectName = scope.project.projectName;
      //   })
      //   .catch(e => {
      //     $log.log(e);
      //   });
      // }
      // loadActiveProjectLists();


      function loadBookmarks() {
        storageFactory.getBookmarks().then(function (resp) {
          scope.bookmarkedProjectList = resp.data.bookmarks || [];
          scope.bookmarkedProjectList.unshift({
            _id: 'all',
            projectName: $filter('translate')("All Projects")
          }); // scope.bookmarkedProjectList.push({_id: 'others', projectName: $filter('translate')("Show Other Projects")});

          var project = projectStore.get();

          if (project) {
            scope.project = project;
          } else if (scope.bookmarkedProjectList.length > 2) {
            scope.project = scope.bookmarkedProjectList[1];
            chooseProject(scope.project);
          } else {
            scope.$root.$emit('on-select-project-no-bookmark');
          }

          scope.selectedProjectName = scope.project.projectName;
          scope.bookmarkedProjectList.forEach(function (item) {
            item.showTooltip = utils.getGlypthWidthForValueSlider(item.projectName, '12px Inter') > 268;
          });
        })["catch"](function (err) {
          $log.error(err);
        });
      }

      function chooseProject(project) {
        if (project._id !== 'all' && project._id !== 'others') {
          var find = scope.bookmarkedProjectList.find(function (x) {
            return x._id === project._id;
          });

          if (!find) {
            var index = scope.bookmarkedProjectList.findIndex(function (x) {
              return x._id === 'others';
            });
            scope.bookmarkedProjectList.splice(index, 1);
            scope.bookmarkedProjectList.push(project);
            scope.bookmarkedProjectList.push({
              _id: 'others',
              projectName: 'Show Other Projects'
            });
          }
        }

        projectStore.set(project);
        scope.$root.$emit('choosed-project');
      }

      function updateUI() {
        if (scope.dashboardType === 5 || scope.type === 'ceo') return;
        var menuElementList = $document[0].getElementsByClassName('nav-item');
        if (menuElementList.length === 0) return;
        var currentRoute = $state.current.url;

        if ($state.current.parent) {
          currentRoute = $state.current.parent;
        }

        if (currentRoute.includes('/')) {
          currentRoute = currentRoute.split('/')[1];
        }

        var index = currentRoute === "finance" ? 0 : menuNameList.findIndex(function (name) {
          return name === currentRoute;
        });

        if (index !== -1 && menuElementList[index]) {
          menuElementList[index].classList.add("active");

          if ($state.current.url.split('/').length > 2) {
            var currentSubRoute = $state.current.url;

            if (currentSubRoute.includes('/')) {
              if ($state.current.parent) {
                currentSubRoute = currentSubRoute.split('/')[1];
              } else {
                currentSubRoute = currentSubRoute.split('/')[2];
              }
            }

            var tempSubMenuNameList;

            if (currentRoute === 'dashboard') {
              tempSubMenuNameList = dashboardSubMenuList;
            } else if (currentRoute === 'visual-time') {
              tempSubMenuNameList = visualTimeSubMenuNameList;
            } else if (currentRoute === 'calc') {
              tempSubMenuNameList = calcSubMenuNameList;
            } else if (currentRoute === 'qshe') {
              tempSubMenuNameList = qsheSubMenuNameList;
            } else if (currentRoute === 'economic') {
              tempSubMenuNameList = economicSubMenuNameList;
            }

            var subIndex = currentRoute === "finance" ? 1 : tempSubMenuNameList.findIndex(function (name) {
              return name === currentSubRoute;
            });

            if (subIndex !== -1 && menuElementList[index].children[1]) {
              menuElementList[index].children[1].children[subIndex].children[0].classList.add('active');

              if (menuElementList[index].children[1].children[subIndex].children[0].children[1]) {
                menuElementList[index].children[1].children[subIndex].children[0].children[1].style.background = "url('/assets/images/dashboard/menu-arrow-right-hover.svg')";
              }

              if ($state.current.url.split('/').length > 3 || currentRoute === "finance") {
                var currentSubSubRoute = $state.current.url;

                if (currentSubSubRoute.includes('/')) {
                  if ($state.current.parent || currentRoute === "finance") {
                    currentSubSubRoute = currentSubSubRoute.split('/')[2];
                  } else {
                    currentSubSubRoute = currentSubSubRoute.split('/')[3];
                  }
                }

                var tempSubSubMenuNameList;
                $log.log(currentSubRoute);

                if (currentSubRoute === 'collaborator') {
                  tempSubSubMenuNameList = dashboardCollaboratorSubMenuNameList;
                } else if (currentSubRoute === 'invoice') {//                  tempSubSubMenuNameList = economicInvoiceSubMenuList;
                } else if (currentSubRoute === 'bill') {//                  tempSubSubMenuNameList = economicBillSubMenuList;
                } else if (currentSubRoute === 'orders') {
                  tempSubSubMenuNameList = economicOrdersSubMenuList;
                } else if (currentSubRoute === 'calc') {
                  tempSubSubMenuNameList = calcCalcSubMenuNameList;
                } else if (currentSubRoute === 'vp') {//                  tempSubSubMenuNameList = visualTimeVpSubMenuNameList;
                } else if (currentSubRoute === 'bim') {//                  tempSubSubMenuNameList = visualTimeDynamic3dSubMenuNameList;
                } else if (currentSubRoute === 'pcd') {//tempSubSubMenuNameList = visualTImePCDSubMenuNameList;
                } else if (currentSubRoute === 'issues') {//                  tempSubSubMenuNameList = qsheIssuesSubMenuNameList;
                } else if (currentRoute === 'finance') {
                  tempSubSubMenuNameList = dashboardFinanceSubMenuNameList;
                }

                if (tempSubSubMenuNameList) {
                  var sub_sub_index = tempSubSubMenuNameList.findIndex(function (element) {
                    return element === currentSubSubRoute;
                  });

                  if (sub_sub_index !== -1 && menuElementList[index].children[1].children[subIndex]) {
                    menuElementList[index].children[1].children[subIndex].children[1].children[sub_sub_index].children[0].classList.add('active');

                    if (menuElementList[index].children[1].children[subIndex].children[1].children[sub_sub_index].children[0].children[1]) {
                      menuElementList[index].children[1].children[subIndex].children[1].children[sub_sub_index].children[0].children[1].style.background = "url('/assets/images/dashboard/menu-arrow-right-hover.svg')";
                    }
                  }
                }
              }
            }
          } else {
            if (currentRoute === "create-project") {
              var _subIndex = 0;

              menuElementList[index].children[1].children[_subIndex].children[0].classList.add('active');

              if (menuElementList[index].children[1].children[_subIndex].children[0].children[1]) {
                menuElementList[index].children[1].children[_subIndex].children[0].children[1].style.background = "url('/assets/images/dashboard/menu-plus-hover.svg')";
              }
            }
          }
        } else {
          index = moreSubMenuNameList.findIndex(function (name) {
            return name === currentRoute;
          });

          if (index !== -1 && menuElementList[6] && menuElementList[6].children[1]) {
            menuElementList[6].classList.add("active");
            var supplier_page = $state.current.url.includes('spread-sheet');
            index = supplier_page ? index + 1 : index;
            menuElementList[6].children[1].children[index].children[0].classList.add('active');
          } else {
            menuElementList[1].classList.add("active");

            if (currentRoute == 'project-list') {
              menuElementList[1].children[1].children[1].children[0].classList.add('active');
            } else {
              menuElementList[1].children[1].children[0].children[0].classList.add('active');
              menuElementList[1].children[1].children[0].children[0].children[1].style.background = "url('/assets/images/dashboard/menu-arrow-right-hover.svg')";
              if (currentRoute == 'create-project') menuElementList[1].children[1].children[0].children[1].children[0].children[0].classList.add('active');else if (currentRoute == 'createServiceProject') menuElementList[1].children[1].children[0].children[1].children[1].children[0].classList.add('active');else menuElementList[1].children[1].children[0].children[1].children[2].children[0].classList.add('active');
            }
          }
        }
      }
    }
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app').directive('liveChatSmall', liveChatSmall);

  function liveChatSmall(globals, Notification, utils, $log, $timeout, apiFactory) {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/live-chat-small/live-chat-small.view.html',
      scope: {
        channelSid: '@',
        uniqueName: '@',
        chatType: '@'
      },
      link: function link($scope) {
        $scope.userData = globals.userStore.get();
        $scope.projectData = globals.projectStore.get();
        var editingMessage = undefined;
        var editedMessageList = [];

        function updateMembers() {
          $scope.activeChannel.memberUsers = [];
          $scope.activeChannel.getMembers().then(function (res) {
            if (res && res.length) {
              var _loop = function _loop(i) {
                var member = res[i];

                if (member.identity !== $scope.userData._id) {
                  var userMember = $scope.inviteMembers.find(function (it) {
                    return it._id === member.identity;
                  });

                  if (userMember) {
                    $scope.activeChannel.memberUsers.push(userMember);
                  }
                }
              };

              for (var i = 0; i < res.length; i++) {
                _loop(i);
              }

              $scope.memberNames = $scope.activeChannel.memberUsers.map(function (x) {
                return x.firstName;
              });
            }

            $timeout(function () {
              $scope.$apply();
            });
          });
        }

        function updateTypingIndicator() {
          var message = 'Typing: ';
          var names = Array.from($scope.typingMembers).slice(0, 3);

          if ($scope.typingMembers.size) {
            message += names.join(', ');
          }

          if ($scope.typingMembers.size > 3) {
            message += ', and ' + ($scope.typingMembers.size - 3) + 'more';
          }

          if ($scope.typingMembers.size) {
            message += '...';
          } else {
            message = '';
          }

          $scope.typingMessage = message;
        }

        function addMessage(message) {
          message.userType = false;
          var _id = message.state.author;
          message.state.dateUpdated = moment(new Date(message.state.dateUpdated)).format('lll');

          if ($scope.userData._id === _id) {
            message.authorName = $scope.userData.displayName;
            message.profilePic = $scope.userData.profilePic;
            message.userType = true;
          } else {
            var index = $scope.inviteMembers.findIndex(function (c) {
              return c._id === _id;
            });
            message.authorName = index !== -1 ? $scope.inviteMembers[index].firstName : _id;
            message.profilePic = index !== -1 ? $scope.inviteMembers[index].profilePic : null;
          }

          $scope.currentMessages.push(message);
          $timeout(function () {
            $scope.$apply();
          });
        }

        function updateMessage(message) {
          var index = $scope.currentMessages.findIndex(function (x) {
            return x.sid === message.sid;
          });

          if (index !== -1) {
            $scope.currentMessages[index] = message;
            editedMessageList.push(message.sid);
            $timeout(function () {
              $scope.$apply();
            });
          }
        }

        function removeMessage(message) {
          var index = $scope.currentMessages.findIndex(function (x) {
            return x.sid === message.sid;
          });

          if (index !== -1) {
            $scope.currentMessages.splice(index, 1);
          }
        }

        function updateChatMessage() {
          $scope.loading = true;
          apiFactory.updateChatMessage({
            channelSid: editingMessage.channel.sid,
            messageSid: editingMessage.sid,
            messageBody: $scope.messageBody
          }).then(function () {
            $scope.loading = false;
            editingMessage = undefined;
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            editingMessage = undefined;
            Notification.error(utils.getErrorMessage(err));
          });
        }

        function chatTime(strDate) {
          return moment().isSame(moment(new Date(strDate)), 'd') ? moment(new Date(strDate)).format('LT') : moment(new Date(strDate)).format('lll');
        }

        function sendMessage(sendBody) {
          if ($scope.attachmentFiles && $scope.attachmentFiles.length > 0) {
            $scope.loading = true;
            apiFactory.newMeetingFileMessage($scope.attachmentFiles).then(function (resp) {
              $scope.loading = false;
              var uploadedFiles = resp.data;
              $scope.attachmentFiles = [];

              var _iterator = _createForOfIteratorHelper(uploadedFiles.data),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var file = _step.value;
                  sendMessage("#file##url#".concat(file.secure_url, "#url##name#").concat(file.originalname, "#name##file#"));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            })["catch"](function (e) {
              $scope.loading = false;
              $log.error(e);
              Notification.error('Failed to upload files');
            });
          } else {
            if (!$scope.messageBody && !sendBody) {
              return;
            }

            if (angular.isDefined(editingMessage)) {
              updateChatMessage();
            } else if (angular.isDefined($scope.quotingMessage)) {
              var quoteDesc = $scope.quotingMessage.authorName + ', ' + chatTime($scope.quotingMessage.timestamp);
              var body = sendBody ? sendBody : $scope.messageBody;
              var messageBody = "#quote##quoteBody#".concat($scope.quotingMessage.body, "#quoteBody##quoteDesc#").concat(quoteDesc, "#quoteDesc##quote##messageBody#").concat(body, "#messageBody#");
              $scope.activeChannel.sendMessage(messageBody);
              $scope.quotingMessage = undefined;
              $scope.messageBody = undefined;
            } else {
              var _body = sendBody ? sendBody : $scope.messageBody;

              $scope.activeChannel.sendMessage(_body);
              $scope.messageBody = undefined;
            }
          }
        }

        function updateMember(member, user) {
          // TODO:
          $log.log('TODO: updateMember: ', member, user);
        }

        function updateActiveChannel() {// TODO:
        }

        function setActiveChannel(channel) {
          if ($scope.activeChannel) {
            $scope.activeChannel.removeListener('messageAdded', addMessage);
            $scope.activeChannel.removeListener('messageRemoved', removeMessage);
            $scope.activeChannel.removeListener('messageUpdated', updateMessage);
            $scope.activeChannel.removeListener('updated', updateActiveChannel);
            $scope.activeChannel.removeListener('memberUpdated', updateMember);
          }

          $scope.activeChannel = channel;
          $scope.activeChannel.on('updated', updateActiveChannel);
          channel.getMessages(30).then(function (page) {
            $scope.activeChannelPage = page;
            page.items.forEach(addMessage);
            channel.on('messageAdded', addMessage);
            channel.on('messageUpdated', updateMessage);
            channel.on('messageRemoved', removeMessage);
            return channel.getMembers();
          }).then(function (members) {
            updateMembers();
            channel.on('memberJoined', updateMembers);
            channel.on('memberLeft', updateMembers);
            channel.on('memberUpdated', updateMember);
            members.forEach(function (member) {
              member.getUser().then(function (user) {
                user.on('updated', function () {
                  updateMember.bind(null, member, user);
                  updateMembers();
                });
              });
            });
            $scope.waiting = false;
          })["catch"](function (err) {
            $log.error(err);
          });
          channel.on('typingStarted', function (member) {
            member.getUser().then(function (user) {
              $scope.typingMembers.add(user.displayName || member.identity);
              updateTypingIndicator();
            });
          });
          channel.on('typingEnded', function (member) {
            member.getUser().then(function (user) {
              $scope.typingMembers["delete"](user.displayName || member.identity);
              updateTypingIndicator();
            });
          });
        }

        function updateChannels(channel) {
          if (channel && !$scope.allChannels.find(function (x) {
            return x.sid == channel.sid;
          })) {
            $scope.allChannels.push(channel);
          }

          if (channel.sid === $scope.channelSid || channel.channelState.uniqueName === $scope.uniqueName) {
            setActiveChannel(channel);
            channel.on('memberJoined', updateMembers);
            channel.on('memberUpdated', function (member) {
              $log.log(member.identity + 'updated their info.');
            });
            channel.on('memberLeft', updateMembers);
            $timeout(function () {
              $scope.$apply();
            });
          }
        }

        function leaveChannel(channel) {
          channel.removeListener('messageAdded', addMessage);
          var index = $scope.allChannels.findIndex(function (x) {
            return x.sid == channel.sid;
          });

          if (index !== -1) {
            $scope.allChannels.splice(index, 1);
          }

          updateChannels();
        }

        function initTwilio(token) {
          $scope.loading = true;
          Twilio.Chat.Client.create(token).then(function (client) {
            $scope.loading = false;
            $scope.waiting = true;
            client.on('channelAdded', updateChannels); // client.on('channelUpdated', updateChannels);

            client.on('channelLeft', leaveChannel);
            client.on('channelRemoved', leaveChannel);
          })["catch"](function (error) {
            $scope.loading = false;
            $log.error(error);
            Notification.error('Something went wrong try later');
          });
        }

        function makeSearchText() {
          var words = $scope.messageBody.split(' ');
          var searchWords = words.filter(function (x) {
            return x.includes('@');
          });

          if (searchWords.length) {
            $scope.searchText = searchWords[searchWords.length - 1].replace('@', '');
          }
        }

        function applySelectedName() {
          $scope.messageBody = $scope.messageBody.replace('@' + $scope.searchText, '@' + $scope.selectedName);
        }

        function getAccessToken() {
          var endpoint = undefined;

          switch ($scope.chatType) {
            case 'issue':
              endpoint = apiFactory.generateChatAccessToken({
                identity: $scope.userData._id,
                device: 'browser'
              });
              break;

            case 'model3d':
              endpoint = apiFactory.generateTextChatAccessToken({
                identity: $scope.userData._id,
                chatType: 'model3d'
              });
              break;

            case 'vp':
              endpoint = apiFactory.generateTextChatAccessToken({
                identity: $scope.userData._id,
                chatType: 'vp'
              });
              break;

            default:
              break;
          }

          if (endpoint) {
            $scope.loading = true;
            endpoint.then(function (resp) {
              $scope.loading = false;
              initTwilio(resp.data.token);
            })["catch"](function (error) {
              $scope.loading = false;
              $log.error(error);
              Notification.error('Something went wrong try later');
            });
          }
        }

        function initChatData() {
          $scope.typingMembers = new Set();
          $scope.typingMessage = '';
          $scope.currentMessages = [];
          $scope.attachmentFiles = [];
          $scope.quotingMessage = undefined;
          $scope.isSearch = false;
          $scope.memberNames = [];
          $scope.selectedName = '';
          $scope.searchText = '';
        }

        function init() {
          $scope.activeChannel = undefined;
          $scope.allChannels = [];
          initChatData();
          $scope.loading = true;
          apiFactory.getInviteMembersForChat($scope.projectData._id).then(function (res) {
            $scope.loading = false;

            if (!utils.isEmpty($scope.uniqueName)) {
              var endpoint = undefined;

              if ($scope.chatType === 'issue') {
                endpoint = apiFactory.updateChannelMembersForIssue({
                  projectId: $scope.projectData._id,
                  issueId: $scope.uniqueName
                });
              } else if ($scope.chatType === 'model3d') {
                endpoint = apiFactory.updateChannelMembersForModel3D({
                  projectId: $scope.projectData._id,
                  model3dId: $scope.uniqueName
                });
              } else if ($scope.chatType === 'vp') {
                endpoint = apiFactory.updateChannelMembersForVP({
                  projectId: $scope.projectData._id,
                  planId: $scope.uniqueName
                });
              }

              $scope.loading = true;

              if (endpoint) {
                endpoint.then(function () {
                  $scope.loading = false;
                  $scope.inviteMembers = res.data.data;
                  getAccessToken();
                })["catch"](function (err) {
                  $scope.loading = false;
                  $log.error(err);
                  Notification.error(utils.getErrorMessage(err));
                });
              }
            } else {
              $scope.inviteMembers = res.data.data;
              getAccessToken();
            }
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
          $timeout(function () {
            $scope.waiting = false;
          }, 10000);
        }

        init();

        $scope.getChatTime = function (date) {
          return moment().isSame(moment(new Date(date)), 'd') ? moment(new Date(date)).format('LT') : date;
        };

        $scope.messageBodyInput = function (e, messageBody) {
          var keyCode = e.which || e.keyCode;

          if (keyCode === 13 && !e.ctrlKey) {
            e.preventDefault();

            if ($scope.isSearch) {
              $scope.isSearch = false;
              applySelectedName();
            } else {
              sendMessage(messageBody);
              return false;
            }
          } else if (keyCode === 64) {
            $scope.isSearch = true;
          } else {
            $scope.activeChannel.typing();

            if (keyCode === 13 && e.ctrlKey) {
              $scope.messageBody += "\n";
            }
          }
        };

        $scope.submitMessageBody = function (messageBody) {
          sendMessage(messageBody);
        };

        $scope.changeAttacheFiles = function (files) {
          if (files) {
            var _iterator2 = _createForOfIteratorHelper(files),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var file = _step2.value;

                if (utils.isImageFile(file)) {
                  file.objectUrl = URL.createObjectURL(file);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            $scope.attachmentFiles = $scope.attachmentFiles.concat(files);
            $timeout(function () {
              $scope.$apply();
            });
          }
        };

        $scope.getMessageBody = function (data) {
          if (data.includes("#file#")) {
            var content = data.split("#file#")[1];
            var contentSplits = content.split('#url#');

            if (contentSplits.length < 2) {
              var url = contentSplits[0];
              var names = url.split('/');
              var name = names[names.length - 1];

              if (url.toLowerCase().includes('.jpg') || url.toLowerCase().includes('.png')) {
                data = "<a target=\"_blank\" href=\"".concat(url, "\"><img src=\"").concat(url, "\" class=\"attached-image\" alt=\"\" /></a>");
              } else {
                data = "<a target=\"_blank\" href=\"".concat(url, "\"><img src=\"").concat(utils.getFileIcon(url), "\" class=\"attach-file-icon\" alt=\"\" /><span>").concat(name, "</span></a>");
              }
            } else {
              var _url = contentSplits[1];
              var _name = contentSplits[2].split('#name#')[1];

              if (_name.toLowerCase().includes('.jpg') || _name.toLowerCase().includes('.png')) {
                data = "<a target=\"_blank\" href=\"".concat(_url, "\"><img src=\"").concat(_url, "\" class=\"attached-image\" alt=\"\" /></a>");
              } else {
                data = "<a target=\"_blank\" href=\"".concat(_url, "\"><img src=\"").concat(utils.getFileIcon(_name), "\" class=\"attach-file-icon\" alt=\"\" /><span>").concat(_name, "</span></a>");
              }
            }
          } else if (data.includes("#quote#")) {
            var quoteBody = data.split('#quoteBody#')[1];
            var quoteDesc = data.split('#quoteDesc#')[1];
            var messageBody = data.split('#messageBody#')[1];
            return "<div class=\"quote-msg\" ng-if=\"ngModel\">\n                      <img class=\"quote-icon\" src=\"/assets/icons/message_orange.svg\" alt=\"\">\n                      <div class=\"message-content\">\n                        <div class=\"message-body\">\n                          ".concat(quoteBody, "\n                        </div>\n                        <div class=\"message-desc\">\n                          ").concat(quoteDesc, "\n                        </div>\n                        <hr>\n                        <div>").concat(messageBody, "</div>\n                      </div>\n                    </div>");
          }

          var words = data.split(' ');
          var atWords = words.filter(function (x) {
            return x.includes('@');
          });

          var _iterator3 = _createForOfIteratorHelper(atWords),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var word = _step3.value;
              data = data.replace(word, "<span style=\"color: #1665D8; font-weight: 600; font-size: 12px;\">".concat(word, "</span>"));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          return data;
        };

        $scope.deleteMessage = function (message) {
          $scope.loading = true;
          apiFactory.deleteChatMessage({
            channelSid: message.channel.sid,
            messageSid: message.sid
          }).then(function (res) {
            $scope.loading = false;
            $log.log(res);
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        };

        $scope.copyMessage = function (message) {
          $scope.messageBody = angular.copy(message.body);
          angular.element('#message-input').focus();
          $timeout(function () {
            $scope.$apply();
          });
        };

        $scope.editMessage = function (message) {
          editingMessage = angular.copy(message);
          $scope.copyMessage(message);
        }; // $scope.forwardMessage = message => {
        //
        // }
        //
        // $scope.downloadFile = message => {
        //
        // }


        $scope.quoteMessage = function (message) {
          $scope.quotingMessage = angular.copy(message);
          angular.element('#message-input').focus();
        };

        $scope.cancelQuoteMessage = function () {
          $scope.quotingMessage = undefined;
          $timeout(function () {
            $scope.$apply();
          });
        };

        $scope.isFileMessage = function (message) {
          return message.body.includes("#file#");
        };

        $scope.isEditedMessage = function (sid) {
          return editedMessageList.findIndex(function (x) {
            return x === sid;
          }) !== -1;
        };

        $scope.selectUserName = function (name) {
          $scope.isSearch = false;
          $scope.selectedName = name;
          applySelectedName();
        };

        $scope.selectUserNameCandidate = function (name) {
          $scope.selectedName = name;
        };

        $scope.$watch('channelSid', function () {
          initChatData();
          var channel = $scope.allChannels.find(function (x) {
            return x.sid == $scope.channelSid;
          });

          if (channel) {
            updateChannels(channel);
          }
        });
        $scope.$watch('uniqueName', function () {
          initChatData();
          var channel = $scope.allChannels.find(function (x) {
            return x.channelState.uniqueName == $scope.uniqueName;
          });

          if (channel) {
            updateChannels(channel);
          }
        });
        $scope.$watch('messageBody', function () {
          if (utils.isEmpty($scope.messageBody)) {
            $scope.searchText = undefined;
            $scope.isSearch = false;
          } else if ($scope.isSearch) {
            makeSearchText();
          }
        });
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app').directive('liveChatNew', liveChatNew);

  function liveChatNew(globals, Notification, utils, $log, $timeout, apiFactory) {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/live-chat-new/live-chat-new.view.html',
      scope: {
        channelSid: '@',
        uniqueName: '@',
        type: '=',
        externLoading: '='
      },
      link: function link($scope) {
        $scope.userData = globals.userStore.get();
        $log.log($scope.userData);
        $scope.projectData = globals.projectStore.get();
        var editingMessage = undefined;
        var editedMessageList = [];

        function updateMembers() {
          $scope.activeChannel.memberUsers = [];
          $scope.activeChannel.getMembers().then(function (res) {
            if (res && res.length) {
              var _loop = function _loop(i) {
                var member = res[i];

                if (member.identity !== $scope.userData._id) {
                  var userMember = $scope.inviteMembers.find(function (it) {
                    return it._id === member.identity;
                  });

                  if (userMember) {
                    $scope.activeChannel.memberUsers.push(userMember);
                  }
                }
              };

              for (var i = 0; i < res.length; i++) {
                _loop(i);
              }

              $scope.memberNames = $scope.activeChannel.memberUsers.map(function (x) {
                return x.firstName;
              });
            }

            $timeout(function () {
              $scope.$apply();
            });
          });
        }

        function updateTypingIndicator() {
          var message = 'Typing: ';
          var names = Array.from($scope.typingMembers).slice(0, 3);

          if ($scope.typingMembers.size) {
            message += names.join(', ');
          }

          if ($scope.typingMembers.size > 3) {
            message += ', and ' + ($scope.typingMembers.size - 3) + 'more';
          }

          if ($scope.typingMembers.size) {
            message += '...';
          } else {
            message = '';
          }

          $scope.typingMessage = message;
        }

        function addMessage(message) {
          message.userType = false;
          var _id = message.state.author;
          message.state.dateUpdated = moment(new Date(message.state.dateUpdated)).format('lll');

          if ($scope.userData._id === _id) {
            message.authorName = $scope.userData.displayName;
            message.profilePic = $scope.userData.profilePic;
            message.userType = true;
          } else {
            var index = $scope.inviteMembers.findIndex(function (c) {
              return c._id === _id;
            });
            message.authorName = index !== -1 ? $scope.inviteMembers[index].firstName : _id;
            message.profilePic = index !== -1 ? $scope.inviteMembers[index].profilePic : null;
          }

          $scope.currentMessages.push(message);
          $timeout(function () {
            $scope.$apply();
          });
        }

        function updateMessage(message) {
          var index = $scope.currentMessages.findIndex(function (x) {
            return x.sid === message.sid;
          });

          if (index !== -1) {
            $scope.currentMessages[index] = message;
            editedMessageList.push(message.sid);
            $timeout(function () {
              $scope.$apply();
            });
          }
        }

        function removeMessage(message) {
          var index = $scope.currentMessages.findIndex(function (x) {
            return x.sid === message.sid;
          });

          if (index !== -1) {
            $scope.currentMessages.splice(index, 1);
          }
        }

        function updateChatMessage() {
          $scope.loading = true;
          apiFactory.updateChatMessage({
            channelSid: editingMessage.channel.sid,
            messageSid: editingMessage.sid,
            messageBody: $scope.messageBody
          }).then(function () {
            $scope.loading = false;
            editingMessage = undefined;
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            editingMessage = undefined;
            Notification.error(utils.getErrorMessage(err));
          });
        }

        function chatTime(strDate) {
          return moment().isSame(moment(new Date(strDate)), 'd') ? moment(new Date(strDate)).format('LT') : moment(new Date(strDate)).format('lll');
        }

        function sendMessage(sendBody) {
          if ($scope.attachmentFiles && $scope.attachmentFiles.length > 0) {
            $scope.loading = true;
            apiFactory.newMeetingFileMessage($scope.attachmentFiles).then(function (resp) {
              $scope.loading = false;
              var uploadedFiles = resp.data;
              $scope.attachmentFiles = [];

              var _iterator = _createForOfIteratorHelper(uploadedFiles.data),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var file = _step.value;
                  sendMessage("#file##url#".concat(file.secure_url, "#url##name#").concat(file.originalname, "#name##file#"));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            })["catch"](function (e) {
              $scope.loading = false;
              $log.error(e);
              Notification.error('Failed to upload files');
            });
          } else {
            if (!$scope.messageBody && !sendBody) {
              return;
            }

            if (angular.isDefined(editingMessage)) {
              updateChatMessage();
            } else if (angular.isDefined($scope.quotingMessage)) {
              var quoteDesc = $scope.quotingMessage.authorName + ', ' + chatTime($scope.quotingMessage.timestamp);
              var body = sendBody ? sendBody : $scope.messageBody;
              var messageBody = "#quote##quoteBody#".concat($scope.quotingMessage.body, "#quoteBody##quoteDesc#").concat(quoteDesc, "#quoteDesc##quote##messageBody#").concat(body, "#messageBody#");
              $scope.activeChannel.sendMessage(messageBody);
              $scope.quotingMessage = undefined;
              $scope.messageBody = undefined;
            } else {
              var _body = sendBody ? sendBody : $scope.messageBody;

              $scope.activeChannel.sendMessage(_body);
              $scope.messageBody = undefined;
            }
          }
        }

        function updateMember() {// TODO:
        }

        function updateActiveChannel() {// TODO:
        }

        function setActiveChannel(channel) {
          if ($scope.activeChannel) {
            $scope.activeChannel.removeListener('messageAdded', addMessage);
            $scope.activeChannel.removeListener('messageRemoved', removeMessage);
            $scope.activeChannel.removeListener('messageUpdated', updateMessage);
            $scope.activeChannel.removeListener('updated', updateActiveChannel);
            $scope.activeChannel.removeListener('memberUpdated', updateMember);
          }

          $scope.activeChannel = channel;
          $scope.activeChannel.on('updated', updateActiveChannel);
          channel.getMessages(30).then(function (page) {
            $scope.activeChannelPage = page;
            page.items.forEach(addMessage);
            channel.on('messageAdded', addMessage);
            channel.on('messageUpdated', updateMessage);
            channel.on('messageRemoved', removeMessage);
            return channel.getMembers();
          }).then(function (members) {
            updateMembers();
            channel.on('memberJoined', updateMembers);
            channel.on('memberLeft', updateMembers);
            channel.on('memberUpdated', updateMember);
            members.forEach(function (member) {
              member.getUser().then(function (user) {
                user.on('updated', function () {
                  updateMember.bind(null, member, user);
                  updateMembers();
                });
              });
            });
            $scope.waiting = false;
          })["catch"](function (err) {
            $log.error(err);
          });
          channel.on('typingStarted', function (member) {
            member.getUser().then(function (user) {
              $scope.typingMembers.add(user.displayName || member.identity);
              updateTypingIndicator();
            });
          });
          channel.on('typingEnded', function (member) {
            member.getUser().then(function (user) {
              $scope.typingMembers["delete"](user.displayName || member.identity);
              updateTypingIndicator();
            });
          });
        }

        function updateChannels(channel) {
          if (channel && !$scope.allChannels.find(function (x) {
            return x.sid == channel.sid;
          })) {
            $scope.allChannels.push(channel);
          }

          if (channel.sid === $scope.channelSid || channel.channelState.uniqueName === $scope.uniqueName) {
            setActiveChannel(channel);
            channel.on('memberJoined', updateMembers); // channel.on('memberUpdated', function (member) {
            // });

            channel.on('memberLeft', updateMembers);
            $timeout(function () {
              $scope.$apply();
            });
          }
        }

        function leaveChannel(channel) {
          channel.removeListener('messageAdded', addMessage);
          var index = $scope.allChannels.findIndex(function (x) {
            return x.sid == channel.sid;
          });

          if (index !== -1) {
            $scope.allChannels.splice(index, 1);
          }

          updateChannels();
        }

        function initTwilio(token) {
          $scope.loading = true;
          Twilio.Chat.Client.create(token).then(function (client) {
            $scope.loading = false;
            $scope.waiting = true;
            client.on('channelAdded', updateChannels); // client.on('channelUpdated', updateChannels);

            client.on('channelLeft', leaveChannel);
            client.on('channelRemoved', leaveChannel);
          })["catch"](function (error) {
            $scope.loading = false;
            $log.error(error);
            Notification.error('Something went wrong try later');
          });
        }

        function makeSearchText() {
          var words = $scope.messageBody.split(' ');
          var searchWords = words.filter(function (x) {
            return x.includes('@');
          });

          if (searchWords.length) {
            $scope.searchText = searchWords[searchWords.length - 1].replace('@', '');
          }
        }

        function applySelectedName() {
          $scope.messageBody = $scope.messageBody.replace('@' + $scope.searchText, '@' + $scope.selectedName);
        }

        function getAccessToken() {
          $scope.loading = true;
          var endpoint = $scope.type == "synergy" ? "generateSynergyChatAccessToken" : "generateChatAccessToken";
          apiFactory[endpoint]({
            identity: $scope.userData._id,
            device: 'browser'
          }).then(function (resp) {
            $scope.loading = false;
            initTwilio(resp.data.token);
          })["catch"](function (error) {
            $scope.loading = false;
            $log.error(error);
            Notification.error('Something went wrong try later');
          });
        }

        function initChatData() {
          $scope.typingMembers = new Set();
          $scope.typingMessage = '';
          $scope.currentMessages = [];
          $scope.attachmentFiles = [];
          $scope.quotingMessage = undefined;
          $scope.isSearch = false;
          $scope.memberNames = [];
          $scope.selectedName = '';
          $scope.searchText = '';
        }

        function init() {
          $scope.activeChannel = undefined;
          $scope.allChannels = [];
          initChatData();
          $scope.loading = true;
          apiFactory.getInviteMembersForChat($scope.projectData._id).then(function (res) {
            $scope.loading = false;

            if (!utils.isEmpty($scope.uniqueName)) {
              $scope.loading = true;
              apiFactory.updateChannelMembersForIssue({
                projectId: $scope.projectData._id,
                issueId: $scope.uniqueName
              }).then(function () {
                $scope.loading = false;
                $scope.inviteMembers = res.data.data;
                getAccessToken();
              })["catch"](function (err) {
                $scope.loading = false;
                $log.error(err);
                Notification.error(utils.getErrorMessage(err));
              });
            } else {
              $scope.inviteMembers = res.data.data;
              getAccessToken();
            }
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
          $timeout(function () {
            $scope.waiting = false;
          }, 10000);
        }

        init();

        $scope.getChatTime = function (date) {
          return moment().isSame(moment(new Date(date)), 'd') ? moment(new Date(date)).format('LT') : date;
        };

        $scope.messageBodyInput = function (e, messageBody) {
          var keyCode = e.which || e.keyCode;

          if (keyCode === 13 && !e.ctrlKey) {
            e.preventDefault();

            if ($scope.isSearch) {
              $scope.isSearch = false;
              applySelectedName();
            } else {
              sendMessage(messageBody);
              return false;
            }
          } else if (keyCode === 64) {
            $scope.isSearch = true;
          } else {
            $scope.activeChannel.typing();

            if (keyCode === 13 && e.ctrlKey) {
              $scope.messageBody += "\n";
            }
          }
        };

        $scope.submitMessageBody = function (messageBody) {
          sendMessage(messageBody);
        };

        $scope.changeAttacheFiles = function (files) {
          if (files) {
            var _iterator2 = _createForOfIteratorHelper(files),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var file = _step2.value;

                if (utils.isImageFile(file)) {
                  file.objectUrl = URL.createObjectURL(file);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            $scope.attachmentFiles = $scope.attachmentFiles.concat(files);
            $timeout(function () {
              $scope.$apply();
            });
          }
        };

        $scope.getMessageBody = function (data) {
          if (data.includes("#file#")) {
            var content = data.split("#file#")[1];
            var contentSplits = content.split('#url#');

            if (contentSplits.length < 2) {
              var url = contentSplits[0];
              var names = url.split('/');
              var name = names[names.length - 1];

              if (url.toLowerCase().includes('.jpg') || url.toLowerCase().includes('.png')) {
                data = "<a target=\"_blank\" href=\"".concat(url, "\"><img src=\"").concat(url, "\" class=\"attached-image\" alt=\"\" /></a>");
              } else {
                data = "<a target=\"_blank\" href=\"".concat(url, "\"><img src=\"").concat(utils.getFileIcon(url), "\" class=\"attach-file-icon\" alt=\"\" /><span>").concat(name, "</span></a>");
              }
            } else {
              var _url = contentSplits[1];
              var _name = contentSplits[2].split('#name#')[1];

              if (!utils.isEmpty(_name) && (_name.toLowerCase().includes('.jpg') || _name.toLowerCase().includes('.png'))) {
                data = "<a target=\"_blank\" href=\"".concat(_url, "\"><img src=\"").concat(_url, "\" class=\"attached-image\" alt=\"\" /></a>");
              } else {
                data = "<a target=\"_blank\" href=\"".concat(_url, "\"><img src=\"").concat(utils.getFileIcon(_name), "\" class=\"attach-file-icon\" alt=\"\" /><span>").concat(_name, "</span></a>");
              }
            }
          } else if (data.includes("#quote#")) {
            var quoteBody = data.split('#quoteBody#')[1];
            var quoteDesc = data.split('#quoteDesc#')[1];
            var messageBody = data.split('#messageBody#')[1];
            return "<div class=\"quote-msg\" ng-if=\"ngModel\">\n                      <img class=\"quote-icon\" src=\"/assets/icons/message_orange.svg\" alt=\"\">\n                      <div class=\"message-content\">\n                        <div class=\"message-body\">\n                          ".concat(quoteBody, "\n                        </div>\n                        <div class=\"message-desc\">\n                          ").concat(quoteDesc, "\n                        </div>\n                        <hr>\n                        <div>").concat(messageBody, "</div>\n                      </div>\n                    </div>");
          }

          var words = data.split(' ');
          var atWords = words.filter(function (x) {
            return x.includes('@');
          });

          var _iterator3 = _createForOfIteratorHelper(atWords),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var word = _step3.value;
              data = data.replace(word, "<span style=\"color: #1665D8; font-size: 16px;\">".concat(word, "</span>"));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          return data;
        };

        $scope.deleteMessage = function (message) {
          $scope.loading = true;
          apiFactory.deleteChatMessage({
            channelSid: message.channel.sid,
            messageSid: message.sid
          }).then(function (res) {
            $log.log(res);
            $scope.loading = false;
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        };

        $scope.copyMessage = function (message) {
          $scope.messageBody = angular.copy(message.body);
          angular.element('#message-input').focus();
          $timeout(function () {
            $scope.$apply();
          });
        };

        $scope.editMessage = function (message) {
          editingMessage = angular.copy(message);
          $scope.copyMessage(message);
        }; // $scope.forwardMessage = message => {
        //
        // }
        //
        // $scope.downloadFile = message => {
        //
        // }


        $scope.quoteMessage = function (message) {
          $scope.quotingMessage = angular.copy(message);
          angular.element('#message-input').focus();
        };

        $scope.cancelQuoteMessage = function () {
          $scope.quotingMessage = undefined;
          $timeout(function () {
            $scope.$apply();
          });
        };

        $scope.isFileMessage = function (message) {
          return message.body.includes("#file#");
        };

        $scope.isEditedMessage = function (sid) {
          return editedMessageList.findIndex(function (x) {
            return x === sid;
          }) !== -1;
        };

        $scope.selectUserName = function (name) {
          $scope.isSearch = false;
          $scope.selectedName = name;
          applySelectedName();
        };

        $scope.selectUserNameCandidate = function (name) {
          $scope.selectedName = name;
        };

        $scope.$watch('channelSid', function () {
          initChatData();
          var channel = $scope.allChannels.find(function (x) {
            return x.sid == $scope.channelSid;
          });

          if (channel) {
            updateChannels(channel);
          }
        });
        $scope.$watch('uniqueName', function () {
          initChatData();
          var channel = $scope.allChannels.find(function (x) {
            return x.channelState.uniqueName == $scope.uniqueName;
          });

          if (channel) {
            updateChannels(channel);
          }
        });
        $scope.$watch('messageBody', function () {
          if (utils.isEmpty($scope.messageBody)) {
            $scope.searchText = undefined;
            $scope.isSearch = false;
          } else if ($scope.isSearch) {
            makeSearchText();
          }
        });
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app').directive('liveChat', liveChat);

  function liveChat(globals, Notification, utils, $log, $timeout, apiFactory) {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/live-chat/live-chat.view.html',
      scope: {
        channelSid: '@',
        uniqueName: '@',
        type: '=',
        externLoading: '='
      },
      link: function link($scope) {
        $scope.userData = globals.userStore.get();
        $scope.projectData = globals.projectStore.get();
        var editingMessage = undefined;
        var editedMessageList = [];

        function updateMembers() {
          $scope.activeChannel.memberUsers = [];
          $scope.activeChannel.getMembers().then(function (res) {
            if (res && res.length) {
              var _loop = function _loop(i) {
                var member = res[i];

                if (member.identity !== $scope.userData._id) {
                  var userMember = $scope.inviteMembers.find(function (it) {
                    return it._id === member.identity;
                  });

                  if (userMember) {
                    $scope.activeChannel.memberUsers.push(userMember);
                  }
                }
              };

              for (var i = 0; i < res.length; i++) {
                _loop(i);
              }

              $scope.memberNames = $scope.activeChannel.memberUsers.map(function (x) {
                return x.firstName;
              });
            }

            $timeout(function () {
              $scope.$apply();
            });
          });
        }

        function updateTypingIndicator() {
          var message = 'Typing: ';
          var names = Array.from($scope.typingMembers).slice(0, 3);

          if ($scope.typingMembers.size) {
            message += names.join(', ');
          }

          if ($scope.typingMembers.size > 3) {
            message += ', and ' + ($scope.typingMembers.size - 3) + 'more';
          }

          if ($scope.typingMembers.size) {
            message += '...';
          } else {
            message = '';
          }

          $scope.typingMessage = message;
        }

        function addMessage(message) {
          message.userType = false;
          var _id = message.state.author;
          message.state.dateUpdated = moment(new Date(message.state.dateUpdated)).format('lll');

          if ($scope.userData._id === _id) {
            message.authorName = $scope.userData.displayName;
            message.profilePic = $scope.userData.profilePic;
            message.userType = true;
          } else {
            var index = $scope.inviteMembers.findIndex(function (c) {
              return c._id === _id;
            });
            message.authorName = index !== -1 ? $scope.inviteMembers[index].firstName : _id;
            message.profilePic = index !== -1 ? $scope.inviteMembers[index].profilePic : null;
          }

          $scope.currentMessages.push(message);
          $timeout(function () {
            $scope.$apply();
          });
        }

        function updateMessage(message) {
          var index = $scope.currentMessages.findIndex(function (x) {
            return x.sid === message.sid;
          });

          if (index !== -1) {
            $scope.currentMessages[index] = message;
            editedMessageList.push(message.sid);
            $timeout(function () {
              $scope.$apply();
            });
          }
        }

        function removeMessage(message) {
          var index = $scope.currentMessages.findIndex(function (x) {
            return x.sid === message.sid;
          });

          if (index !== -1) {
            $scope.currentMessages.splice(index, 1);
          }
        }

        function updateChatMessage() {
          $scope.loading = true;
          apiFactory.updateChatMessage({
            channelSid: editingMessage.channel.sid,
            messageSid: editingMessage.sid,
            messageBody: $scope.messageBody
          }).then(function () {
            $scope.loading = false;
            editingMessage = undefined;
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            editingMessage = undefined;
            Notification.error(utils.getErrorMessage(err));
          });
        }

        function chatTime(strDate) {
          return moment().isSame(moment(new Date(strDate)), 'd') ? moment(new Date(strDate)).format('LT') : moment(new Date(strDate)).format('lll');
        }

        function sendMessage(sendBody) {
          if ($scope.attachmentFiles && $scope.attachmentFiles.length > 0) {
            $scope.loading = true;
            apiFactory.newMeetingFileMessage($scope.attachmentFiles).then(function (resp) {
              $scope.loading = false;
              var uploadedFiles = resp.data;
              $scope.attachmentFiles = [];

              var _iterator = _createForOfIteratorHelper(uploadedFiles.data),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var file = _step.value;
                  sendMessage("#file##url#".concat(file.secure_url, "#url##name#").concat(file.originalname, "#name##file#"));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            })["catch"](function (e) {
              $scope.loading = false;
              $log.error(e);
              Notification.error('Failed to upload files');
            });
          } else {
            if (!$scope.messageBody && !sendBody) {
              return;
            }

            if (angular.isDefined(editingMessage)) {
              updateChatMessage();
            } else if (angular.isDefined($scope.quotingMessage)) {
              var quoteDesc = $scope.quotingMessage.authorName + ', ' + chatTime($scope.quotingMessage.timestamp);
              var body = sendBody ? sendBody : $scope.messageBody;
              var messageBody = "#quote##quoteBody#".concat($scope.quotingMessage.body, "#quoteBody##quoteDesc#").concat(quoteDesc, "#quoteDesc##quote##messageBody#").concat(body, "#messageBody#");
              $scope.activeChannel.sendMessage(messageBody);
              $scope.quotingMessage = undefined;
              $scope.messageBody = undefined;
            } else {
              var _body = sendBody ? sendBody : $scope.messageBody;

              $scope.activeChannel.sendMessage(_body);
              $scope.messageBody = undefined;
            }
          }
        }

        function updateMember() {// TODO:
        }

        function updateActiveChannel() {// TODO:
        }

        function setActiveChannel(channel) {
          if ($scope.activeChannel) {
            $scope.activeChannel.removeListener('messageAdded', addMessage);
            $scope.activeChannel.removeListener('messageRemoved', removeMessage);
            $scope.activeChannel.removeListener('messageUpdated', updateMessage);
            $scope.activeChannel.removeListener('updated', updateActiveChannel);
            $scope.activeChannel.removeListener('memberUpdated', updateMember);
          }

          $scope.activeChannel = channel;
          $scope.activeChannel.on('updated', updateActiveChannel);
          channel.getMessages(30).then(function (page) {
            $scope.activeChannelPage = page;
            page.items.forEach(addMessage);
            channel.on('messageAdded', addMessage);
            channel.on('messageUpdated', updateMessage);
            channel.on('messageRemoved', removeMessage);
            return channel.getMembers();
          }).then(function (members) {
            updateMembers();
            channel.on('memberJoined', updateMembers);
            channel.on('memberLeft', updateMembers);
            channel.on('memberUpdated', updateMember);
            members.forEach(function (member) {
              member.getUser().then(function (user) {
                user.on('updated', function () {
                  updateMember.bind(null, member, user);
                  updateMembers();
                });
              });
            });
            $scope.waiting = false;
          })["catch"](function (err) {
            $log.error(err);
          });
          channel.on('typingStarted', function (member) {
            member.getUser().then(function (user) {
              $scope.typingMembers.add(user.displayName || member.identity);
              updateTypingIndicator();
            });
          });
          channel.on('typingEnded', function (member) {
            member.getUser().then(function (user) {
              $scope.typingMembers["delete"](user.displayName || member.identity);
              updateTypingIndicator();
            });
          });
        }

        function updateChannels(channel) {
          if (channel && !$scope.allChannels.find(function (x) {
            return x.sid == channel.sid;
          })) {
            $scope.allChannels.push(channel);
          }

          if (channel.sid === $scope.channelSid || channel.channelState.uniqueName === $scope.uniqueName) {
            setActiveChannel(channel);
            channel.on('memberJoined', updateMembers); // channel.on('memberUpdated', function (member) {
            // });

            channel.on('memberLeft', updateMembers);
            $timeout(function () {
              $scope.$apply();
            });
          }
        }

        function leaveChannel(channel) {
          channel.removeListener('messageAdded', addMessage);
          var index = $scope.allChannels.findIndex(function (x) {
            return x.sid == channel.sid;
          });

          if (index !== -1) {
            $scope.allChannels.splice(index, 1);
          }

          updateChannels();
        }

        function initTwilio(token) {
          $scope.loading = true;
          Twilio.Chat.Client.create(token).then(function (client) {
            $scope.loading = false;
            $scope.waiting = true;
            client.on('channelAdded', updateChannels); // client.on('channelUpdated', updateChannels);

            client.on('channelLeft', leaveChannel);
            client.on('channelRemoved', leaveChannel);
          })["catch"](function (error) {
            $scope.loading = false;
            $log.error(error);
            Notification.error('Something went wrong try later');
          });
        }

        function makeSearchText() {
          var words = $scope.messageBody.split(' ');
          var searchWords = words.filter(function (x) {
            return x.includes('@');
          });

          if (searchWords.length) {
            $scope.searchText = searchWords[searchWords.length - 1].replace('@', '');
          }
        }

        function applySelectedName() {
          $scope.messageBody = $scope.messageBody.replace('@' + $scope.searchText, '@' + $scope.selectedName);
        }

        function getAccessToken() {
          $scope.loading = true;
          var endpoint = $scope.type == "synergy" ? "generateSynergyChatAccessToken" : "generateChatAccessToken";
          apiFactory[endpoint]({
            identity: $scope.userData._id,
            device: 'browser'
          }).then(function (resp) {
            $scope.loading = false;
            initTwilio(resp.data.token);
          })["catch"](function (error) {
            $scope.loading = false;
            $log.error(error);
            Notification.error('Something went wrong try later');
          });
        }

        function initChatData() {
          $scope.typingMembers = new Set();
          $scope.typingMessage = '';
          $scope.currentMessages = [];
          $scope.attachmentFiles = [];
          $scope.quotingMessage = undefined;
          $scope.isSearch = false;
          $scope.memberNames = [];
          $scope.selectedName = '';
          $scope.searchText = '';
        }

        function init() {
          $scope.activeChannel = undefined;
          $scope.allChannels = [];
          initChatData();
          $scope.loading = true;
          apiFactory.getInviteMembersForChat($scope.projectData._id).then(function (res) {
            $scope.loading = false;

            if (!utils.isEmpty($scope.uniqueName)) {
              $scope.loading = true;
              apiFactory.updateChannelMembersForIssue({
                projectId: $scope.projectData._id,
                issueId: $scope.uniqueName
              }).then(function () {
                $scope.loading = false;
                $scope.inviteMembers = res.data.data;
                getAccessToken();
              })["catch"](function (err) {
                $scope.loading = false;
                $log.error(err);
                Notification.error(utils.getErrorMessage(err));
              });
            } else {
              $scope.inviteMembers = res.data.data;
              getAccessToken();
            }
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
          $timeout(function () {
            $scope.waiting = false;
          }, 10000);
        }

        init();

        $scope.getChatTime = function (date) {
          return moment().isSame(moment(new Date(date)), 'd') ? moment(new Date(date)).format('LT') : date;
        };

        $scope.messageBodyInput = function (e, messageBody) {
          var keyCode = e.which || e.keyCode;

          if (keyCode === 13 && !e.ctrlKey) {
            e.preventDefault();

            if ($scope.isSearch) {
              $scope.isSearch = false;
              applySelectedName();
            } else {
              sendMessage(messageBody);
              return false;
            }
          } else if (keyCode === 64) {
            $scope.isSearch = true;
          } else {
            $scope.activeChannel.typing();

            if (keyCode === 13 && e.ctrlKey) {
              $scope.messageBody += "\n";
            }
          }
        };

        $scope.submitMessageBody = function (messageBody) {
          sendMessage(messageBody);
        };

        $scope.changeAttacheFiles = function (files) {
          if (files) {
            var _iterator2 = _createForOfIteratorHelper(files),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var file = _step2.value;

                if (utils.isImageFile(file)) {
                  file.objectUrl = URL.createObjectURL(file);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            $scope.attachmentFiles = $scope.attachmentFiles.concat(files);
            $timeout(function () {
              $scope.$apply();
            });
          }
        };

        $scope.getMessageBody = function (data) {
          if (data.includes("#file#")) {
            var content = data.split("#file#")[1];
            var contentSplits = content.split('#url#');

            if (contentSplits.length < 2) {
              var url = contentSplits[0];
              var names = url.split('/');
              var name = names[names.length - 1];

              if (url.toLowerCase().includes('.jpg') || url.toLowerCase().includes('.png')) {
                data = "<a target=\"_blank\" href=\"".concat(url, "\"><img src=\"").concat(url, "\" class=\"attached-image\" alt=\"\" /></a>");
              } else {
                data = "<a target=\"_blank\" href=\"".concat(url, "\"><img src=\"").concat(utils.getFileIcon(url), "\" class=\"attach-file-icon\" alt=\"\" /><span>").concat(name, "</span></a>");
              }
            } else {
              var _url = contentSplits[1];
              var _name = contentSplits[2].split('#name#')[1];

              if (!utils.isEmpty(_name) && (_name.toLowerCase().includes('.jpg') || _name.toLowerCase().includes('.png'))) {
                data = "<a target=\"_blank\" href=\"".concat(_url, "\"><img src=\"").concat(_url, "\" class=\"attached-image\" alt=\"\" /></a>");
              } else {
                data = "<a target=\"_blank\" href=\"".concat(_url, "\"><img src=\"").concat(utils.getFileIcon(_name), "\" class=\"attach-file-icon\" alt=\"\" /><span>").concat(_name, "</span></a>");
              }
            }
          } else if (data.includes("#quote#")) {
            var quoteBody = data.split('#quoteBody#')[1];
            var quoteDesc = data.split('#quoteDesc#')[1];
            var messageBody = data.split('#messageBody#')[1];
            return "<div class=\"quote-msg\" ng-if=\"ngModel\">\n                      <img class=\"quote-icon\" src=\"/assets/icons/message_orange.svg\" alt=\"\">\n                      <div class=\"message-content\">\n                        <div class=\"message-body\">\n                          ".concat(quoteBody, "\n                        </div>\n                        <div class=\"message-desc\">\n                          ").concat(quoteDesc, "\n                        </div>\n                        <hr>\n                        <div>").concat(messageBody, "</div>\n                      </div>\n                    </div>");
          }

          var words = data.split(' ');
          var atWords = words.filter(function (x) {
            return x.includes('@');
          });

          var _iterator3 = _createForOfIteratorHelper(atWords),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var word = _step3.value;
              data = data.replace(word, "<span style=\"color: #1665D8; font-size: 16px;\">".concat(word, "</span>"));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          return data;
        };

        $scope.deleteMessage = function (message) {
          $scope.loading = true;
          apiFactory.deleteChatMessage({
            channelSid: message.channel.sid,
            messageSid: message.sid
          }).then(function (res) {
            $scope.loading = false;
            $log.log(res);
          })["catch"](function (err) {
            $scope.loading = false;
            $log.error(err);
            Notification.error(utils.getErrorMessage(err));
          });
        };

        $scope.copyMessage = function (message) {
          $scope.messageBody = angular.copy(message.body);
          angular.element('#message-input').focus();
          $timeout(function () {
            $scope.$apply();
          });
        };

        $scope.editMessage = function (message) {
          editingMessage = angular.copy(message);
          $scope.copyMessage(message);
        }; // $scope.forwardMessage = message => {
        //
        // }
        //
        // $scope.downloadFile = message => {
        //
        // }


        $scope.quoteMessage = function (message) {
          $scope.quotingMessage = angular.copy(message);
          angular.element('#message-input').focus();
        };

        $scope.cancelQuoteMessage = function () {
          $scope.quotingMessage = undefined;
          $timeout(function () {
            $scope.$apply();
          });
        };

        $scope.isFileMessage = function (message) {
          return message.body.includes("#file#");
        };

        $scope.isEditedMessage = function (sid) {
          return editedMessageList.findIndex(function (x) {
            return x === sid;
          }) !== -1;
        };

        $scope.selectUserName = function (name) {
          $scope.isSearch = false;
          $scope.selectedName = name;
          applySelectedName();
        };

        $scope.selectUserNameCandidate = function (name) {
          $scope.selectedName = name;
        };

        $scope.$watch('channelSid', function () {
          initChatData();
          var channel = $scope.allChannels.find(function (x) {
            return x.sid == $scope.channelSid;
          });

          if (channel) {
            updateChannels(channel);
          }
        });
        $scope.$watch('uniqueName', function () {
          initChatData();
          var channel = $scope.allChannels.find(function (x) {
            return x.channelState.uniqueName == $scope.uniqueName;
          });

          if (channel) {
            updateChannels(channel);
          }
        });
        $scope.$watch('messageBody', function () {
          if (utils.isEmpty($scope.messageBody)) {
            $scope.searchText = undefined;
            $scope.isSearch = false;
          } else if ($scope.isSearch) {
            makeSearchText();
          }
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("inventoryCard", inventoryCard);

  function inventoryCard($state, globals) {
    return {
      restrict: "E",
      templateUrl: "app/core/directives/inventory-card/inventory-card.view.html",
      scope: {
        itemData: '=',
        type: '=',
        currencySymbol: '='
      },
      link: function link($scope) {
        var companyStore = globals.companyStore;
        $scope.companyData = companyStore.get();

        $scope.goDetail = function () {
          if ($scope.type === 'material') {
            $state.go('materialDetail', {
              id: $scope.itemData._id
            });
          } else if ($scope.type === 'item') {
            $state.go('itemDetail', {
              id: $scope.itemData._id
            });
          } else if ($scope.type === 'combo') {
            $state.go('dcpDetail', {
              id: $scope.itemData._id
            });
          } else if ($scope.type === 'comboEqu') {
            $state.go('dcqDetail', {
              id: $scope.itemData._id
            });
          }
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app.core').directive('innerSpinner', innerSpinner);

  function innerSpinner() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/core/directives/inner-spinner/inner-spinner.html',
      scope: {
        top: '='
      },
      link: function link() {}
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("dhxGantt", dhxGantt);

  function dhxGantt(apiFactory, $compile, $document, $log, utils) {
    return {
      restrict: "A",
      scope: {
        data: "=",
        resources: "=",
        weather: "=",
        styles: "=",
        deadline: "=",
        onWorkerCount: "=",
        onTotalCount: "="
      },
      transclude: true,
      template: "<div ng-transclude></div>",
      link: function link($scope, $element) {
        var resourceStore;
        var resourceMap = {};
        var columnWidth = 24;
        var TaskStyles = ['blue', //'#537bc4',
        'sky', //'#4dc9f6',
        'orange', //'#f67019',
        'pink', //'#f53794',
        'yellow', //'#acc236',
        'd-green', //'#166a8f',
        'green', //'#00a950',
        'grey', //'#58595b',
        'purple' //'#8549ba',
        ];
        var mainConfig = {
          scale_height: 43,
          row_height: 26,
          task_height: 18,
          columns: [{
            name: "wbs",
            label: "#",
            align: "left",
            width: 40,
            template: gantt.getWBSCode
          }, {
            name: "text",
            label: "Title",
            tree: true,
            width: '*',
            min_width: 160,
            template: function template(task) {
              return "<span title=\"".concat(task.text, "\">").concat(task.text, "</span>");
            }
          }, {
            name: "start_date",
            label: "Start<br/>Date",
            align: "center",
            width: 70,
            template: function template(task) {
              return moment(task.start_date).format("D MMM, YYYY");
            }
          }, {
            name: "end_date",
            label: "End<br/>Date",
            align: "center",
            width: 70,
            template: function template(task) {
              return moment(task.end_date).format("D MMM, YYYY");
            }
          }, {
            name: "status",
            label: "Status",
            align: "center",
            width: 40,
            template: function template(task) {
              switch (task.status) {
                case 0:
                  return '<img src="/assets/icons/status-waiting.svg" title="Not Started" alt="">';

                case 1:
                  return '<img src="/assets/icons/status-working.svg" title="On Going" alt="">';

                case 2:
                  return '<img src="/assets/icons/status-warning.svg" title="On Hold" alt="">';

                case 3:
                  return '<img src="/assets/icons/status-completed.svg" title="Completed" alt="">';

                default:
                  return '<img src="/assets/icons/status-waiting.svg" title="Not Started" alt="">';
              }
            }
          }, {
            name: "progress",
            label: "Percent<br/>Complete",
            align: "center",
            width: 50,
            template: function template(task) {
              return Math.ceil(task.progress * 100) + '%';
            }
          }, {
            name: "delay",
            label: "Delay",
            align: "center",
            width: 50,
            template: function template(task) {
              var delay = task.status === 2 ? 1 - utils.num(task.progress) : 0;
              return "<div class=\"delay ".concat(delay > 0.5 ? 'delay-warning' : delay > 0 ? 'delay-small' : '', "\">").concat(Math.ceil(delay * 100), "%</div>");
            }
          }, {
            name: "duration",
            label: "Est.<br/>Hours",
            align: "center",
            width: 50,
            template: function template(task) {
              var duration = Math.ceil(utils.num(task.duration));
              return duration < 1 ? 1 : duration;
            }
          }, {
            name: "calc_duration",
            label: "Calc.<br/>Hours",
            align: "center",
            width: 50,
            template: function template(task) {
              return utils.getRoundNumWithLocale(utils.num(task.calcHours), 2, 'en');
            }
          }, {
            name: "days",
            label: "Working<br/>Days",
            align: "center",
            width: 60,
            template: function template(task) {
              return Math.ceil(parseFloat(task.duration) / 24.0);
            }
          }, {
            name: "needs",
            label: "Required<br/>Workers",
            align: "center",
            width: 40,
            template: function template(task) {
              return task.type === gantt.config.types.project ? '' : utils.num(task.requiredWorkerCount);
            }
          }, {
            name: "resources",
            label: "Resources",
            align: "center",
            width: 100,
            min_width: 100,
            template: function template(task) {
              var content = '<div class="d-flex h-100">';
              var assignments = [];
              getAssignments(task, assignments);

              if (!assignments.length) {
                content += "<div class=\"resource-avatar unassigned my-auto\"></div>unassigned";
              } else {
                if (assignments.length === 1) {
                  var resource = assignments[0];

                  if (resource) {
                    content += makeResourceAvatar(resource);
                    content += resource.name;
                  }
                } else {
                  content += makeResourceAvatar(assignments[0]);
                  content += makeResourceAvatar(assignments[1]);

                  if (assignments.length > 2) {
                    content += "+".concat(assignments.length - 2, " more");
                  }
                }
              }

              content += '</div>';
              return content;
            }
          }]
        };
        var simpleResourceConfig = {
          scale_height: 0,
          row_height: 26,
          columns: [{
            name: "number",
            label: "R",
            align: "center",
            width: 30,
            template: function template(resource) {
              return resource.id;
            }
          }, {
            name: "name",
            label: "name",
            align: "left",
            width: '*',
            min_width: 180,
            template: function template(resource) {
              return resource.text;
            }
          }, {
            name: "count",
            label: "count",
            align: "center",
            width: 180,
            template: function template(resource) {
              return $scope.onTotalCount ? $scope.onTotalCount(resource.id) : 0;
            }
          }]
        };
        var defaultLayout = {
          css: "gantt_container",
          cols: [{
            rows: [{
              config: mainConfig,
              cols: [{
                width: 380,
                min_width: 300,
                rows: [{
                  view: "grid",
                  scrollX: "gridScroll",
                  scrollY: "scrollVer",
                  scrollable: true
                }]
              }, {
                view: "timeline",
                scrollX: "scrollHor",
                scrollY: "scrollVer"
              }]
            }, {
              id: "resource",
              css: "gantt-resource",
              height: 52,
              config: simpleResourceConfig,
              cols: [{
                width: 380,
                min_width: 300,
                rows: [{
                  view: "resourceGrid",
                  scrollX: "gridScroll",
                  scrollable: true
                }, {
                  view: "scrollbar",
                  id: "gridScroll",
                  scroll: "x"
                }]
              }, {
                rows: [{
                  view: "resourceTimeline",
                  scrollX: "scrollHor"
                }, {
                  view: "scrollbar",
                  id: "scrollHor",
                  group: "horizontal"
                }]
              }]
            }]
          }, {
            view: "scrollbar",
            id: "scrollVer",
            group: "vertical"
          }]
        };
        initGanttConfig();
        loadOffDays();
        gantt.init($element[0]);

        function initGanttConfig() {
          gantt.plugins({
            auto_scheduling: true
          });
          setScaleConfig(); // gantt config

          gantt.config.show_errors = false;
          gantt.config.static_background = false;
          gantt.config.show_task_cells = true;
          gantt.config.smart_scales = true;
          gantt.config.smart_rendering = true;
          gantt.config.show_progress = true;
          gantt.config.work_time = false;
          gantt.config.duration_unit = "hour";
          gantt.config.round_dnd_dates = false;
          gantt.config.min_duration = 3600000; // 1hour

          gantt.config.skip_off_time = false;
          gantt.config.order_branch = false;
          gantt.config.order_branch_free = false;
          gantt.config.fit_tasks = false;
          gantt.config.open_tree_initially = true;
          gantt.config.grid_resize = false;
          gantt.config.drag_links = false;
          gantt.config.drag_progress = false;
          gantt.config.link_line_width = 1;
          gantt.config.show_links = false;
          gantt.config.auto_scheduling = true;
          gantt.config.auto_scheduling_initial = false;
          gantt.config.resource_store = "resource";
          gantt.config.resource_property = "resources";
          gantt.config.layout = defaultLayout;
          gantt.config.resource_render_empty_cells = true; // renderer

          gantt.config.type_renderers[gantt.config.types.project] = function (task) {
            if (gantt.isSplitTask(task)) return;
            var taskClass = getTaskClass(task.$virtual && $scope.groupType === 'workType' ? task.text : task.workType);
            var element = $document[0].createElement("div");
            element.setAttribute(gantt.config.task_attribute, task.id);
            var size = gantt.getTaskPosition(task);
            element.innerHTML = "<div class='project-left'></div><div class='project-right'></div>" + "<div class=\"project-text\">".concat(task.text, "</div>");
            element.classList.add("gantt-group");
            element.classList.add(taskClass);
            element.style.left = size.left + "px";
            element.style.top = size.top + 6 + "px";
            element.style.width = size.width + "px";
            $compile(element)($scope);
            return element;
          };

          gantt.config.type_renderers[gantt.config.types.task] = function (task, defaultRender) {
            var element = defaultRender(task);
            if (!element) return;

            if (task.project) {
              element.classList.add("custom-project");
              $compile(element)($scope);
            } else {
              $compile(element)($scope);
            }

            return element;
          }; // gantt template


          gantt.templates.grid_header_class = function () {
            return "timeline-header-cell";
          };

          gantt.templates.task_class = function (start, end, task) {
            return getTaskClass(task.workType);
          };

          gantt.templates.task_row_class = function () {
            return "gantt-task-row";
          };

          gantt.templates.timeline_cell_class = function (task, date) {
            if (date.getDay() === 0 || date.getDay() === 6) {
              return 'weekend';
            }
          };

          gantt.templates.link_class = function (link) {
            var style = getTaskClass(link.workType);
            if (link.flag) style += ' ' + link.flag;
            return style;
          };

          gantt.templates.task_text = function (start, end, task) {
            return "<span class=\"task-text\">".concat(task.text, "</span><span class=\"progress-text\">").concat(Math.ceil(task.progress * 100), "%</span>");
          };

          gantt.templates.rightside_text = function () {
            return '';
          };

          gantt.templates.resource_cell_class = function () {
            return "resource_marker";
          };

          gantt.templates.resource_cell_value = function (start, end, resource) {
            var html = "<div>";
            var count = $scope.onWorkerCount ? $scope.onWorkerCount(gantt, start, end) : {
              working: 0,
              required: 0
            };

            if (resource.id === 'W') {
              html += count.working;
            } else {
              html += count.required;
            }

            html += "</div>";
            return html;
          }; // resource store


          resourceStore = gantt.createDatastore({
            name: gantt.config.resource_store,
            type: "treeDatastore"
          });
          resourceStore.attachEvent("onAfterSelect", function () {
            gantt.refreshData();
          }); // set working time

          gantt.setWorkTime({
            hours: [10, 18]
          }); // lightbox

          gantt.showLightbox = function () {
            return false;
          };

          gantt.hideLightbox = function () {}; // Do Nothing


          gantt.attachEvent("onBeforeTaskDisplay", function (id, task) {
            return angular.isUndefined(task.show) || task.show;
          });
          gantt.attachEvent("onLinkDblClick", function () {
            return false;
          }); // markers

          gantt.attachEvent("onGanttRender", function () {
            addMarker('today', new Date(), 'TODAY');

            if ($scope.deadline) {
              addMarker('deadline', $scope.deadline, 'END');
            } else {
              removeMarker('deadline');
            }
          });
        }

        function setScaleConfig() {
          var cssForScale = function cssForScale(date) {
            var weekday = date.getDay();

            if (weekday === 0 || weekday === 6) {
              return 'subscale scale-weekend';
            }

            return 'subscale';
          };

          gantt.config.scale_unit = "month";
          gantt.config.date_scale = "%F %Y";
          gantt.config.subscales = [{
            unit: "day",
            step: 1,
            date: "%j",
            css: cssForScale
          }];
          gantt.templates.date_scale = null;
          columnWidth = 24;
          gantt.config.min_column_width = columnWidth;
          gantt.config.start_on_monday = false;
        }

        function loadOffDays() {
          apiFactory.listAllHolidays().then(function (resp) {
            var holidays = resp.data.list.filter(function (v) {
              return v.isActive;
            });
            var i = holidays.length;

            while (i) {
              var element = holidays[--i];
              gantt.setWorkTime({
                date: new Date(element.date),
                hours: false
              });
            }

            gantt.render();
          })["catch"](function (e) {
            $log.log(e);
          });
        }

        function getAssignments(task, assignments) {
          if (gantt.hasChild(task.id)) {
            var children = gantt.getChildren(task.id);

            for (var i = 0; i < children.length; i++) {
              getAssignments(gantt.getTask(children[i]), assignments);
            }
          } else {
            (function () {
              var resources = task.resources;

              if (resources) {
                var _loop = function _loop(_i) {
                  if (assignments.findIndex(function (x) {
                    return x.id === resources[_i].id;
                  }) === -1) {
                    assignments.push(resources[_i]);
                  }
                };

                for (var _i = 0; _i < resources.length; _i++) {
                  _loop(_i);
                }
              }
            })();
          }
        }

        function makeResourceAvatar(resource) {
          if (!resource) return '';

          if (resource.avatar) {
            return "<img src=\"".concat(resource.avatar, "\" class=\"resource-avatar my-auto\" alt=\"\" />");
          } else {
            return "<div class=\"resource-avatar my-auto\">".concat(resource.name ? resource.name.charAt(0).toUpperCase() : 'A', "</div>");
          }
        }

        function getTaskClass(workType) {
          if (!workType || !$scope.styles) return 'none';
          var index = utils.num($scope.styles[workType]);
          return TaskStyles[index % TaskStyles.length];
        }

        function addMarker(id, date, text) {
          var marker = angular.element("#" + id);

          if (!marker.length) {
            var elem = $document[0].createElement("div");
            elem.classList.add('gantt-marker');
            elem.classList.add(id);
            elem.id = id;
            elem.innerHTML = "<div class=\"top\">".concat(text, "</div><div class=\"line\"></div>");
            gantt.$task.appendChild(elem);
            marker = angular.element(elem);
          }

          var pos = gantt.posFromDate(date) - 7;
          marker.css("left", pos + "px");
        }

        function removeMarker(id) {
          var marker = angular.element("#" + id);

          if (marker.length) {
            gantt.$task.removeChild(marker[0]);
          }
        }

        $scope.$watch('data', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          gantt.clearAll();
          gantt.parse(newValue, "json");
          resourceStore.parse([{
            id: 'W',
            text: "Working"
          }, {
            id: 'R',
            text: "Required"
          }]);
        });
        $scope.$watch('resources', function (newValue) {
          if (angular.isUndefined(newValue)) {
            return;
          }

          for (var i = 0; i < newValue.length; i++) {
            resourceMap[newValue[i].id] = newValue[i];
          }

          gantt.render();
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").directive("datePicker", DatePicker);

  function DatePicker($log, $timeout, utils) {
    return {
      restrict: "A",
      scope: {
        date: "=",
        datePicker: "@",
        isOpen: "=",
        change: "&",
        toTop: "=",
        disabledFrom: "=",
        disabledTo: "="
      },
      link: function link(scope, element) {
        var MIN_WIDTH = 220;
        var dateInput = element[0];
        var calendar = undefined;
        var popup = undefined;
        var opt = {
          dateFormat: makeDateFormat(),
          css: "dhx_widget--bordered",
          width: Math.max(MIN_WIDTH, dateInput.clientWidth)
        };

        if (scope.toTop) {
          opt.css = "dhx_widget--bordered to-top";
        }

        createCalendar();
        element.click(function () {
          popup.show(dateInput);
        });
        element.blur(function () {
          if (calendar.getValue() !== dateInput.value) {
            calendar.setValue(dateInput.value);
            popup.hide();
            applyValue();
          }
        });
        scope.$watch('date', function (newVal) {
          if (newVal && angular.isDate(newVal) && newVal.isValid()) {
            var val = new Date(newVal);
            var offset = val.getTimezoneOffset();
            val = new Date(val.getTime() + offset * 60 * 1000);
            $timeout(function () {
              calendar.setValue(val);
              dateInput.value = calendar.getValue();
            });
          }
        });
        scope.$watch('disabledFrom', function (val) {
          var curDate = calendar.getValue();

          opt.disabledDates = function (date) {
            return date > val;
          };

          createCalendar();
          calendar.setValue(curDate);
        });
        scope.$watch('disabledTo', function (val) {
          var curDate = calendar.getValue();

          opt.disabledDates = function (date) {
            return date < val;
          };

          createCalendar();
          calendar.setValue(curDate);
        });
        scope.$watch('isOpen', function (newVal) {
          if (newVal) {
            popup.show(dateInput);
          } else {
            popup.hide();
          }
        });
        scope.$watch(function () {
          return dateInput.clientWidth;
        }, function (newVal) {
          if (newVal) {
            opt.width = Math.max(MIN_WIDTH, newVal);
            createCalendar();
          }
        });
        scope.$on('$destroy', function () {
          popup.hide();
        });

        function makeDateFormat() {
          var format = scope.datePicker;

          if (utils.isEmpty(format)) {
            return "%m/%d/%Y";
          }
          /**
           %d	day as a number with leading zero, 01..31
           %j	day as a number, 1..31
           %D	short name of the day, Su Mo Tu...
           %l	full name of the day, Sunday Monday Tuesday...
           %m	month as a number with leading zero, 01..12
           %n	month as a number, 1..12
           %M	short name of the month, Jan Feb Mar...
           %F	full name of the month, January February March...
           %y	year as a number, 2 digits
           %Y	year as a number, 4 digits
           %h	hours 12-format with leading zero, 01..12)
           %g	hours 12-format, 1..12)
           %H	hours 24-format with leading zero, 00..23
           %G	hours 24-format, 0..23
           %i	minutes with leading zero, 01..59
           %s	seconds with leading zero, 01..59
           %a	am or pm
           %A	AM or PM
           %u	milliseconds
           */


          if (format.includes("yyyy")) {
            format = format.replace("yyyy", "%Y");
          } else if (format.includes("yy")) {
            format = format.replace("yy", "%y");
          }

          if (format.includes("MMMM")) {
            format = format.replace("MMMM", "%F");
          } else if (format.includes("MMM")) {
            format = format.replace("MMM", "%M");
          } else if (format.includes("MM")) {
            format = format.replace("MM", "%m");
          }

          if (format.includes("dd")) {
            format = format.replace("dd", "%d");
          } else if (format.includes("d")) {
            format = format.replace("d", "%j");
          }

          if (format.includes("DD")) {
            format = format.replace("DD", "%d");
          } else if (format.includes("D")) {
            format = format.replace("D", "%j");
          }

          return format;
        }

        function applyValue() {
          scope.$apply(function () {
            var val = new Date(calendar.getValue(true));
            var offset = val.getTimezoneOffset();
            val = new Date(val.getTime() - offset * 60 * 1000);
            scope.date = val;

            if (scope.change) {
              $log.log(scope.date);
              $timeout(function () {
                return scope.change(scope.date);
              });
            }
          });
        }

        function createCalendar() {
          if (popup) {
            popup.destructor();
          }

          if (calendar) {
            calendar.destructor();
          }

          calendar = new dhx.Calendar(null, opt);
          popup = new dhx.Popup();
          calendar.events.on("change", function (date, oldDate, click) {
            if (click) {
              dateInput.value = calendar.getValue();
              popup.hide();
              applyValue();
            }
          });
          popup.attach(calendar);
        }
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("colorSelector", colorSelector);

  function colorSelector($uibModal, $timeout, utils) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/core/directives/color-selector/color-selector.view.html',
      scope: {
        color: "=",
        opacity: "=",
        hideSymbol: '<',
        onChange: "&"
      },
      link: function link(scope) {
        scope.onClick = function () {
          $uibModal.open({
            animation: true,
            component: 'colorSelectorModal',
            windowClass: 'color-selector-modal',
            backdrop: 'static',
            resolve: {
              color: function color() {
                return {
                  color: scope.color,
                  opacity: scope.opacity
                };
              }
            }
          }).result.then(function (result) {
            scope.color = result.color;
            scope.opacity = result.opacity;
            $timeout(function () {
              if (scope.onChange) {
                scope.onChange();
              }
            });
          }, function () {});
        };

        scope.getColor = function () {
          var background = scope.color && angular.isDefined(scope.opacity) ? utils.ha2rgba(scope.color, scope.opacity) : scope.color ? scope.color : 'rgba(0,0,0,0)';
          return {
            background: background
          };
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app').component('colorSelectorModal', {
    controller: colorSelectorModal,
    controllerAs: 'vm',
    templateUrl: 'app/core/directives/color-selector/color-selector-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function colorSelectorModal($scope, $timeout, utils, localStorageService) {
    var vm = this;
    vm.colorModes = [{
      name: 'Hex',
      mode: 'hex'
    }, {
      name: 'RGB',
      mode: 'rgb'
    }, {
      name: 'HSL',
      mode: 'hsl'
    }];
    vm.colorMode = 'hex';
    vm.color = {
      hex: '000000',
      a: 100
    };
    $scope.colorMode = 'hex';
    vm.recents = localStorageService.get('color-selector-recent') || [];
    var board, boardInner, boardPicker;
    var hueSlide, huePicker;
    var isBoardMouseDown = false;
    var isHueMouseDown = false;
    var boardWidth = 252,
        boardHeight = 252,
        hueSlideHeight = 252;
    var currentHue = 0;
    var currentSaturation = 0;
    var currentValue = 0;

    if (vm.recents.length < 7) {
      var length = 7 - vm.recents.length;

      for (var i = 0; i < length; i++) {
        vm.recents.push('');
      }
    }

    vm.$onInit = function () {
      board = angular.element('.color-board');
      boardInner = angular.element('.color-board-inner');
      boardPicker = angular.element('.color-board-picker');
      hueSlide = angular.element('.color-hue');
      huePicker = angular.element('.color-hue-slider');
      boardInner.on('pointerdown', onBoardMouseDown);
      boardInner.on('pointermove', onBoardMouseMove);
      boardInner.on('pointerup pointerleave', onBoardMouseUp);
      hueSlide.on('pointerdown', onHueMouseDown);
      hueSlide.on('pointermove', onHueMouseMove);
      hueSlide.on('pointerup pointerleave', onHueMouseUp);
      var tColor = tinycolor(vm.resolve.color.color);
      vm.color.hex = tColor.toHex(false);
      vm.color.a = vm.resolve.color.opacity;
      setCurrentHSV(tColor);
      $timeout(function () {
        boardWidth = board.width();
        boardHeight = board.height();
        hueSlideHeight = hueSlide.height();
        updatePickers();
      });
    };

    vm.$onDestroy = function () {
      boardInner.off('pointerdown', onBoardMouseDown);
      boardInner.off('pointermove', onBoardMouseMove);
      boardInner.off('pointerup pointerleave', onBoardMouseUp);
      hueSlide.off('pointerdown', onHueMouseDown);
      hueSlide.off('pointermove', onHueMouseMove);
      hueSlide.off('pointerup pointerleave', onHueMouseUp);
    };

    vm.selectRecent = function (index) {
      var color = vm.recents[index];
      if (utils.isEmpty(color)) return;
      var tColor = tinycolor(color);
      fromTinyColor(tColor);
      setCurrentHSV(tColor);
      updatePickers();
    };

    vm.changeMode = function (newVal) {
      if (vm.colorMode === newVal) return;
      var tColor = toTinyColor();
      vm.colorMode = newVal;
      fromTinyColor(tColor);
    };

    vm.changeColor = function () {
      var tColor = toTinyColor().toHsv();
      setCurrentHSV(tColor);
      updatePickers();
    };

    $scope.getCurrentColor = function () {
      return toTinyColor().toHexString(false);
    };

    vm.select = function () {
      var tColor = toTinyColor();
      var color = tColor.toHexString(false);
      tColor.setAlpha(vm.color.a / 100);
      vm.recents.unshift(tColor.toHexString(false));

      if (vm.recents.length > 7) {
        vm.recents.pop();
      }

      localStorageService.set('color-selector-recent', vm.recents);
      vm.modalInstance.close({
        color: color,
        opacity: vm.color.a
      });
    };

    vm.cancel = function () {
      vm.modalInstance.dismiss();
    };

    function onBoardMouseDown(event) {
      isBoardMouseDown = true;
      pickBoard(event);
    }

    function onBoardMouseMove(event) {
      if (isBoardMouseDown) {
        pickBoard(event);
      }
    }

    function onBoardMouseUp() {
      isBoardMouseDown = false;
    }

    function onHueMouseDown(event) {
      isHueMouseDown = true;
      pickHue(event);
    }

    function onHueMouseMove(event) {
      if (isHueMouseDown) {
        pickHue(event);
      }
    }

    function onHueMouseUp() {
      isHueMouseDown = false;
    }

    function pickBoard(event) {
      var dragX = utils.clamp(event.offsetX, 0, boardWidth);
      var dragY = utils.clamp(event.offsetY, 0, boardHeight);
      boardPicker.css({
        left: dragX + 'px',
        top: dragY + 'px'
      });
      currentSaturation = dragX / boardWidth;
      currentValue = (boardHeight - dragY) / boardHeight;
      fromTinyColor(tinycolor.fromRatio({
        h: currentHue,
        s: currentSaturation,
        v: currentValue
      }));
    }

    function pickHue(event) {
      var dragY = utils.clamp(event.offsetY, 0, hueSlideHeight);
      huePicker.css({
        top: dragY + 'px'
      });
      currentHue = dragY / hueSlideHeight;
      updateBoardColor();
      fromTinyColor(tinycolor.fromRatio({
        h: currentHue,
        s: currentSaturation,
        v: currentValue
      }));
    }

    function updatePickers() {
      var h = currentHue;
      var s = currentSaturation;
      var v = currentValue;
      var dragX = s * boardWidth;
      var dragY = boardHeight - v * boardHeight;
      dragX = utils.clamp(dragX, 0, boardWidth);
      dragY = utils.clamp(dragY, 0, boardHeight);
      boardPicker.css({
        top: dragY + "px",
        left: dragX + "px"
      }); // Where to show the bar that displays your current selected hue

      var slideY = h * hueSlideHeight;
      slideY = utils.clamp(slideY, 0, hueSlideHeight);
      huePicker.css({
        top: slideY + "px"
      });
      updateBoardColor();
    }

    function setCurrentHSV(tColor) {
      var hsv = tColor.toHsv();
      currentHue = hsv.h;
      currentSaturation = hsv.s;
      currentValue = hsv.v;
    }

    function updateBoardColor() {
      board.css({
        background: tinycolor.fromRatio({
          h: currentHue,
          s: 1,
          v: 1
        }).toHexString(true)
      });
    }

    function toTinyColor() {
      var tColor;

      if (vm.colorMode === 'rgb') {
        tColor = tinycolor({
          r: vm.color.r,
          g: vm.color.g,
          b: vm.color.b
        });
      } else if (vm.colorMode === 'hsl') {
        tColor = tinycolor({
          h: vm.color.h,
          s: vm.color.s / 100,
          l: vm.color.l / 100
        });
      } else {
        tColor = tinycolor("#".concat(vm.color.hex));
      }

      return tColor;
    }

    function fromTinyColor(tColor) {
      if (vm.colorMode === 'rgb') {
        var rgb = tColor.toRgb();
        vm.color = {
          r: rgb.r,
          g: rgb.g,
          b: rgb.b,
          a: vm.color.a
        };
      } else if (vm.colorMode === 'hsl') {
        var hsl = tColor.toHsl();
        vm.color = {
          h: hsl.h,
          s: Math.round(hsl.s * 100),
          l: Math.round(hsl.l * 100),
          a: vm.color.a
        };
      } else {
        vm.color = {
          hex: tColor.toHex(),
          a: vm.color.a
        };
      }

      $timeout(function () {
        return $scope.$apply();
      });
    }
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("checkbox", checkbox);

  function checkbox() {
    return {
      restrict: "E",
      // replace: true,
      template: '<label ng-class="{\'custom-checkbox\': !isSmall, \'custom-checkbox-16\': isSmall, \'checked\': ngModel}" ng-click="onClick()">\
                    <span class="checkmark" ng-style="{\'border-color\': ngBorderColor ? ngBorderColor : ngModel ? \'#1DA1F2\' : \'#D1D1D1\', \
                    \'background-color\': ngModel ? ngBorderColor ? ngBorderColor : \'#1DA1F2\' : ngBackgroundColor ? ngBackgroundColor : \'#FBFBFB\'}"></span>\
                </label>',
      scope: {
        ngModel: "=",
        isSmall: '@',
        ngBorderColor: '@',
        ngBackgroundColor: '@'
      },
      link: function link(scope) {
        scope.onClick = function () {
          scope.ngModel = !scope.ngModel;
        };
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app').directive('chattingInput', chattingInput);

  function chattingInput(utils) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/core/directives/chatting-input/chatting-input.view.html',
      scope: {
        sending: "=",
        onCommit: '='
      },
      link: function link($scope) {
        $scope.message = '';
        $scope.files = [];

        $scope.onChangeFiles = function (files) {
          var _iterator = _createForOfIteratorHelper(files),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var file = _step.value;
              var fileData = {
                file: file
              };

              if (utils.isImageFile(file)) {
                fileData.isImage = true;
                fileData.imageURL = URL.createObjectURL(file);
              }

              $scope.files.push(fileData);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        };

        $scope.removeFile = function (index) {
          $scope.files.splice(index, 1);
        };

        $scope.onSend = function () {
          if (!$scope.message) return;

          if ($scope.onCommit) {
            $scope.onCommit({
              message: $scope.message,
              files: $scope.files
            });
          }

          $scope.message = '';
          $scope.files = [];
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("calcselectbox", calcselectbox);

  function calcselectbox() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/core/directives/calc-selectbox/selectbox.view.html',
      scope: {
        ngModel: "=",
        options: "=",
        excludeItems: "=",
        isSearch: "@",
        isClickOpen: "@",
        placeholder: "@",
        labelField: "@",
        valueField: "@",
        enableAddItem: "=",
        addItemEvent: "&",
        selectEvent: "&",
        onClose: "&" // disabled: "="

      },
      link: function link(scope, element) {
        scope.isOpen = false;
        scope.cOptions = [];
        scope.selectedLabel = scope.placeholder;

        if (!scope.isClickOpen) {
          scope.isClickOpen = false;
        }

        if (scope.ngModel && scope.options) {
          if (scope.ngModel != {}) {
            var selectedItem = scope.options.find(function (item) {
              return item[scope.valueField] == scope.ngModel;
            });
            if (selectedItem) scope.selectedLabel = selectedItem[scope.labelField];
          }
        }

        var expression = element.attr("exclude-items");
        scope.$parent.$watch(expression, function (newVal) {
          scope.filterExcludeOptions(newVal);
        });

        scope.filterExcludeOptions = function (excludeList) {
          if (excludeList && excludeList.length) {
            var newOptions = [];
            scope.cOptions.map(function (it) {
              if (!excludeList.includes(it[scope.labelField])) {
                newOptions.push(it);
              }
            });
            scope.cOptions = newOptions;
          }
        };

        scope.toggleList = function () {
          scope.isOpen = !scope.isOpen;

          if (scope.isOpen) {
            scope.cOptions = scope.options;

            if (scope.isSearch) {
              scope.searchFunction(scope.selectedLabel);
            }

            scope.filterExcludeOptions(scope.excludeItems);
          }
        };

        scope.updateData = function () {
          if (scope.options && scope.ngModel) {
            var _selectedItem = scope.options.find(function (item) {
              return item[scope.valueField] == scope.ngModel;
            });

            if (_selectedItem) scope.selectedLabel = _selectedItem[scope.labelField];
          } else {
            scope.selectedLabel = scope.placeholder;
          } // scope.selectEvent();

        };

        scope.$watch('ngModel', function (newVal, oldVal) {
          if (newVal != oldVal) {
            scope.updateData();
          }
        }); // scope.$watch( 'options', function (newVal, oldVal) {
        //   let newLength = 0;
        //   let oldLength = 0;
        //   if (newVal) {
        //     newLength = newVal.length;
        //   }
        //   if (oldVal) {
        //     oldLength = oldVal.length
        //   }
        //   if (newLength != oldLength) {
        //     scope.updateData();
        //   }
        // });

        scope.selectItem = function (item) {
          if (scope.ngModel != item[scope.valueField]) {
            scope.ngModel = item[scope.valueField];
            scope.selectedLabel = item[scope.labelField];
            scope.selectEvent({
              selectedValue: scope.ngModel
            });
          }

          scope.isOpen = false;
          scope.isselectedItem = true;
        };

        scope.closeList = function () {
          scope.isOpen = false;

          if (!scope.isselectedItem && scope.options) {
            for (var i = 0; i < scope.options.length; i++) {
              if (scope.options[i][scope.valueField] == scope.ngModel) {
                scope.originLabel = scope.options[i][scope.labelField];
              }
            }

            if (!scope.placeholder) {
              scope.selectedLabel = scope.originLabel;
            }
          }

          scope.onClose();
        };

        scope.openList = function () {
          scope.isOpen = true;
          scope.cOptions = scope.options;
          scope.filterExcludeOptions(scope.excludeItems); // if (scope.isSearch) {
          //   scope.searchFunction(scope.selectedLabel);
          // }
        };

        scope.addItem = function () {
          scope.addItemEvent();
        };

        scope.startSearch = function () {
          scope.isOpen = true;
        };

        scope.searchFunction = function (searchText) {
          scope.isselectedItem = false;
          var output = [];

          if (searchText || searchText == '') {
            if (searchText.length >= 0) {
              angular.forEach(scope.options, function (item) {
                if (item[scope.labelField].toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                  output.push(item);
                }
              });
            }
          }

          scope.cOptions = output;
          scope.filterExcludeOptions(scope.excludeItems);
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("avatarGroup", avatarGroup);

  function avatarGroup(globals) {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/core/directives/avatar-group/avatar-group.view.html',
      scope: {
        ngModel: "=",
        avatars: "=",
        toTop: "=",
        moreCountBorderColor: "=",
        moreCountBackgroundColor: "=",
        moreCountColor: "=",
        avatarBorderColor: "=",
        isOverlap: "=",
        height: "=",
        marginTop: "=",
        width: "=",
        isBlock: "=",
        radius: "@",
        onClose: "="
      },
      link: function link(scope) {
        scope.openTotalList = function () {
          scope.isOpenTotalList = true;
        };

        scope.closeTotalList = function () {
          scope.isOpenTotalList = false;
        };

        scope.getColor = function (name) {
          return globals.getAvatarColor(name);
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive("autocomplete1", autocomplete);

  function autocomplete() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: 'app/core/directives/autocomplete/autocomplete.view.html',
      scope: {
        ngModel: "=",
        options: "=",
        labelField: "@",
        valueField: "@",
        force: "=",
        selectEvent: "&",
        toTop: "@",
        inputClass: "@",
        noMarginRight: "@",
        noFlex: "@",
        fullWidth: '@',
        placeHolder: '@',
        isIcon: '@',
        iconFile: '@'
      },
      link: function link(scope, element) {
        scope.isOpenAutoComplete = false;

        function setInputValue() {
          if (angular.isDefined(scope.options)) {
            var item = scope.options.find(function (it) {
              return it[scope.valueField] === scope.ngModel;
            });

            if (item) {
              scope.inputValue = item[scope.labelField];
            } else {
              scope.inputValue = scope.force ? scope.ngModel : '';
            }
          }
        }

        var expression = element.attr("options");
        scope.$parent.$watch(expression, function (newVal) {
          scope.filteredOptions = newVal;
          setInputValue();
        });
        var expression1 = element.attr("ng-model");
        scope.$parent.$watch(expression1, function () {
          if (scope.ngModel != scope.inputValue) setInputValue();
        });

        scope.selectedItem = function (item) {
          scope.ngModel = item[scope.valueField];
          scope.inputValue = item[scope.labelField];
          scope.selectEvent({
            item: item
          });
          scope.isOpenAutoComplete = false;
        };

        scope.clickInput = function () {
          scope.isOpenAutoComplete = true;
          var output = [];

          if (scope.inputValue && scope.inputValue !== '') {
            // scope.ngModel = scope.inputValue;
            angular.forEach(scope.options, function (item) {
              if (item[scope.labelField].toLowerCase().indexOf(scope.inputValue.toLowerCase()) >= 0) {
                output.push(item);
              }
            });
          } else {
            angular.forEach(scope.options, function (item) {
              output.push(item);
            });
          }

          if (scope.options.length && !output.length) {
            scope.isOpenAutoComplete = false;
          }

          scope.filteredOptions = output;
        };

        scope.changeInput = function () {
          scope.isOpenAutoComplete = true;
          var output = [];

          if (scope.inputValue && scope.inputValue !== '') {
            scope.ngModel = scope.inputValue;
            angular.forEach(scope.options, function (item) {
              if (item[scope.labelField].toLowerCase().indexOf(scope.inputValue.toLowerCase()) >= 0) {
                output.push(item);
              }
            });
          } else {
            angular.forEach(scope.options, function (item) {
              output.push(item);
            });
          }

          if (!output.length) {
            scope.isOpenAutoComplete = false;
          }

          scope.filteredOptions = output;
        };

        scope.closeAutocomplete = function () {
          scope.isOpenAutoComplete = false;
        };
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app').directive('attachFilesSmall', attachFilesSmall);

  function attachFilesSmall(utils, $timeout) {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/attach-files-small/attach-files-small.view.html',
      scope: {
        attachFiles: '='
      },
      link: function link($scope) {
        $scope.utils = utils;

        $scope.appendAttachFiles = function (files) {
          if (files) {
            var _iterator = _createForOfIteratorHelper(files),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var file = _step.value;
                file.objectUrl = URL.createObjectURL(file);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            $timeout(function () {
              $scope.attachFiles = $scope.attachFiles.concat(files);
            });
          }
        };

        $scope.removeAttachFile = function (index) {
          $scope.attachFiles.splice(index, 1);
        };
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module('app').directive('attachFiles', attachFiles);

  function attachFiles(utils, $timeout) {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/attach-files/attach-files.view.html',
      scope: {
        attachFiles: '='
      },
      link: function link($scope) {
        $scope.utils = utils;

        $scope.appendAttachFiles = function (files) {
          if (files) {
            var _iterator = _createForOfIteratorHelper(files),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var file = _step.value;
                file.objectUrl = URL.createObjectURL(file);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            $timeout(function () {
              $scope.attachFiles = $scope.attachFiles.concat(files);
            });
          }
        };

        $scope.removeAttachFile = function (index) {
          $scope.attachFiles.splice(index, 1);
        };
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component("updateStatusModal", {
    controller: updateStatusModal,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/update-status-modal/update-status-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function updateStatusModal($scope, globals, apiFactory, Notification, utils) {
    var vm = this;
    var userStore = globals.userStore;
    vm.userData = userStore.get();
    $scope.status = vm.userData.status || 'Active';
    $scope.statusList = [{
      label: 'Active',
      value: 'Active'
    }, {
      label: 'Away',
      value: 'Away'
    }, {
      label: 'Do not disturb',
      value: 'Do not disturb'
    }, {
      label: 'Invisible',
      value: 'Invisible'
    }];

    vm.$onInit = function () {};

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      $scope.loading = true;
      apiFactory.updateStatus({
        status: $scope.status
      }).then(function () {
        $scope.loading = false; // Notification.success('Changed your status');

        vm.userData.status = $scope.status;
        userStore.set(vm.userData);
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('navSynergyModal', {
    controller: navSynergyModal,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/nav-synergy-modal/nav-synergy-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });
  angular.module('app').directive('horizontalScroll', function () {
    return {
      link: function link(scope, element) {
        var $scope = scope;
        $scope.dragging = false;

        var mousedownHandler = function mousedownHandler(e) {
          angular.element(window).on("mousemove", dragStartHandler);
          angular.element(window).on("mouseup", clickHandler);
          $scope.mousedownEvent = e;
          $scope.mousedownScrollLeft = angular.element(element).scrollLeft();
        };

        var clickHandler = function clickHandler() {
          angular.element(window).off("mousemove", dragStartHandler);
          angular.element(window).off("mouseup", clickHandler);
        };

        var dragStartHandler = function dragStartHandler(e) {
          if (!$scope.dragging) {
            angular.element(window).off("mouseup", clickHandler);
            angular.element(window).on("mouseup", dragEndHandler);
            $scope.dragging = true;
          }

          horizontalScroll(e);
        };

        var dragEndHandler = function dragEndHandler() {
          if ($scope.dragging) {
            angular.element(window).off("mousemove", dragStartHandler);
            angular.element(window).off("mouseup", clickHandler);
            angular.element(window).off("mouseup", dragEndHandler);
            $scope.dragging = false;
          }
        };

        var horizontalScroll = function horizontalScroll(e) {
          e.preventDefault();

          if (e.pageX > 0 && e.pageX < screen.width) {
            angular.element(element).scrollLeft($scope.mousedownScrollLeft + -1 * (e.clientX - $scope.mousedownEvent.clientX));
          }
        };

        angular.element(element).on("mousedown", mousedownHandler);
      }
    };
  });

  function navSynergyModal($scope, utils, $timeout, $log, apiFactory, Notification, globals) {
    var projectStore = globals.projectStore;
    var vm = this;
    vm.project = projectStore.get();
    vm.sortTypes = [{
      id: 'recent',
      label: 'Recent'
    }, {
      id: 'admin',
      label: 'Admin'
    }, {
      id: 'manager',
      label: 'Managers'
    }, {
      id: 'client',
      label: 'Clients'
    }, {
      id: 'supplier',
      label: 'Suppliers'
    }, {
      id: 'subcontractor',
      label: 'Subcontractors'
    }, {
      id: 'employee',
      label: 'Employees'
    }];
    vm.sortType = 'recent';
    vm.isSelected = false;
    vm.isStaffed = false;
    vm.selectedUser = {};
    vm.message = '';
    vm.messages = [];
    vm.allMembers = [];
    vm.admins = [];
    vm.clients = [];
    vm.subContractors = [];
    vm.suppliers = [];
    vm.managers = [];
    vm.employees = [];
    vm.staffs = [];
    vm.attachmentFiles = [];
    $scope.isLoading = false;

    vm.$onInit = function () {
      $scope.isLoading = true;
      var promises = [apiFactory.listAllAdminsForSynergyChat(), apiFactory.listAllManagers(), apiFactory.listAllClients(), apiFactory.getAllSuppliers(), apiFactory.getAllSubcontractors(), apiFactory.getAllEmployees({
        isActive: true
      })];
      Promise.all(promises).then(function (resp) {
        $scope.isLoading = false;
        vm.admins = resp[0].data.list;
        vm.managers = resp[1].data.list;
        vm.clients = resp[2].data.list;
        vm.suppliers = resp[3].data.list;
        vm.subContractors = resp[4].data.list;
        vm.employees = resp[5].data.list;
        vm.sort(vm.sortType, 0);
      })["catch"](function (err) {
        $scope.isLoading = false;

        if (err.status === 403) {
          Notification.error(err.data.message);
        } else {
          Notification.error(utils.getErrorMessage(err, "Couldn't load data."));
        }
      });
    };

    vm.close = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.sort = function (id) {
      vm.sortType = id;
      vm.isStaffed = false;
      vm.staffs = [];
      vm.allMembers = [];

      if (vm.sortType !== 'recent') {
        switch (vm.sortType) {
          case 'admin':
            vm.allMembers = vm.admins;
            break;

          case 'manager':
            vm.allMembers = vm.managers;
            break;

          case 'client':
            vm.allMembers = vm.clients;
            break;

          case 'supplier':
            vm.allMembers = vm.suppliers;
            break;

          case 'subcontractor':
            vm.allMembers = vm.subContractors;
            break;

          case 'employee':
            vm.allMembers = vm.employees;
            break;
        }
      }
    };

    vm.select = function (index, userInfo) {
      if (vm.sortType == 'client' || vm.sortType == 'supplier' || vm.sortType == 'subcontractor') {
        if (!vm.isStaffed) {
          vm.isStaffed = true;
          vm.staffs = vm.allMembers[index].staffs;
        } else {
          vm.isSelected = true;
          vm.selectedUser = userInfo;
        }
      } else {
        vm.isStaffed = false;
        vm.isSelected = true;
        vm.selectedUser = userInfo;
      }
    };

    vm.back = function () {
      vm.isSelected = false;
      vm.isAttach = false;
      vm.selectedUser = {};
      vm.message = '';
      vm.messages = [];
      vm.attachmentFiles = [];
    };

    vm.messageBodyInput = function (e) {
      if (vm.message == '') {
        return;
      }

      var keyCode = e.which || e.keyCode;

      if (keyCode === 13 && !e.ctrlKey) {
        e.preventDefault();
        var message = {
          type: 'send',
          text: vm.message,
          created_at: new Date()
        };
        vm.messages.push(message);
        vm.message = '';
      } else {
        if (keyCode === 13 && e.ctrlKey) {
          vm.message += "\n";
        }
      }
    };

    vm.changeAttacheFiles = function (files) {
      if (files) {
        var _iterator = _createForOfIteratorHelper(files),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var file = _step.value;

            if (utils.isImageFile(file)) {
              file.objectUrl = URL.createObjectURL(file);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        vm.attachmentFiles = vm.attachmentFiles.concat(files);
      }
    };

    vm.getTime = function (date) {
      var currentTime = new Date();
      var dataTime = new Date(date);
      var diff = Math.abs(currentTime - dataTime);

      if (diff === 0) {
        return 'Now';
      } else if (diff / 1000 < 60) {
        return Math.ceil(diff / 1000) + 'seconds ago';
      } else if (diff / (1000 * 60) < 60) {
        return Math.ceil(diff / (1000 * 60)) + 'minutes ago';
      } else if (diff / (1000 * 60 * 60) < 24) {
        return Math.ceil(diff / (1000 * 60 * 60)) + 'hours ago';
      } else {
        return Math.ceil(diff / (1000 * 60 * 60 * 24)) + 'days ago';
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('navNotificationModal', {
    controller: navNotificationModal,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/nav-notification-modal/nav-notification-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function navNotificationModal($scope, $log, $state, apiFactory, globals, Notification, utils) {
    var vm = this;
    var companyData = globals.companyStore.get();
    vm.bills = [];
    vm.companyCurrency = companyData.currentCurrency;
    $scope.isLoading = false;

    vm.$onInit = function () {
      $scope.isLoading = true;
      apiFactory.getUnReadNotification().then(function (resp) {
        $scope.isLoading = false;
        vm.notifications = resp.data.data || [];
        vm.notifications.forEach(function (item) {
          item.updatedTime = utils.getRemainingTime(item.updated);
        });
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.close = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.markNotificationAsReadAll = function () {
      $scope.isLoading = true;
      apiFactory.markNotificationAsReadAll().then(function (resp) {
        $scope.isLoading = false;
        vm.notifications = [];
        Notification.success(resp.data.message);
        vm.modalInstance.close(true);
      })["catch"](function (err) {
        $scope.isLoading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.goToDetail = function (notification) {
      if (utils.isEmpty(notification.route)) {
        return;
      }

      if (!notification.read) {
        apiFactory.markNotificationAsReadByIds([notification._id]).then(function (resp) {
          $log.log(resp.data.message);
          vm.modalInstance.dismiss('cancel');

          if (utils.isEmpty(notification.route.id)) {
            $state.go(notification.route.stateName);
          } else {
            $state.go(notification.route.stateName, {
              id: notification.route.id
            });
          }
        })["catch"](function (err) {
          Notification.error(utils.getErrorMessage(err));
        });
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component("navInvoiceModal", {
    controller: navInvoiceModal,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/nav-invoice-modal/nav-invoice-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function navInvoiceModal($scope, $log, apiFactory, Notification) {
    var vm = this;
    vm.invoices = [];
    $scope.isLoading = false;

    vm.$onInit = function () {
      $scope.isLoading = true;
      apiFactory.listAllInvoices().then(function (resp) {
        $scope.isLoading = false;
        vm.invoices = resp.data.list || [];
        vm.invoices.forEach(function (invoice) {
          invoice.vendorName = invoice.vendor.clientName || invoice.vendor.name;
        });
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
        Notification.error("Cannot get bills");
      });
    };

    vm.close = function () {
      vm.modalInstance.dismiss('cancel');
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('navDrawingModal', {
    controller: navDrawingModal,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/nav-drawing-modal/nav-drawing-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function navDrawingModal($scope, $log, apiFactory, Notification) {
    var vm = this;
    vm.drawings = [];
    $scope.isLoading = false;

    vm.$onInit = function () {
      $scope.isLoading = true;
      apiFactory.listAllRoofPlans().then(function (resp) {
        $scope.isLoading = false;
        vm.drawings = resp.data.list || [];
        vm.drawings.forEach(function (drawing) {
          drawing.isShowChat = false;
          drawing.isShowHistory = false;
          drawing.status = "approved";
        });
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
        Notification.error("Cannot get drawings");
      });
    };

    vm.close = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.approve = function (drawing) {
      drawing.status = "approved";
    };

    vm.request = function (drawing) {
      drawing.status = "requested";
    };

    vm.reject = function (drawing) {
      drawing.status = "rejected";
    };

    vm.toggleChat = function (drawing) {
      drawing.isShowChat = !drawing.isShowChat;

      if (drawing.isShowChat) {
        drawing.isShowHistory = false;
      }
    };

    vm.toggleHistory = function (drawing) {
      drawing.isShowHistory = !drawing.isShowHistory;

      if (drawing.isShowHistory) {
        drawing.isShowChat = false;
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('navBillModal', {
    controller: navBillModal,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/nav-bill-modal/nav-bill-modal.view.html',
    bindings: {
      $close: '&',
      $dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  });

  function navBillModal($scope, $log, apiFactory, globals, Notification) {
    var vm = this;
    var companyData = globals.companyStore.get();
    vm.bills = [];
    vm.companyCurrency = companyData.currentCurrency;
    $scope.isLoading = false;

    vm.$onInit = function () {
      $scope.isLoading = true;
      apiFactory.listSampleBillings().then(function (resp) {
        $scope.isLoading = false;
        vm.bills = resp.data.list || [];
        vm.bills.forEach(function (bill) {
          bill.vendorName = bill.vendor.clientName || bill.vendor.name;
        });
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
        Notification.error("Cannot get bills");
      });
    };

    vm.close = function () {
      vm.modalInstance.dismiss('cancel');
    };

    vm.approve = function () {
      var billIds = [];
      vm.bills.forEach(function (bill) {
        if (bill.checked && bill.status === "pending") {
          billIds.push(bill._id);
        }
      });

      if (billIds.length === 0) {
        Notification.error("No pending bill is selected.");
        return;
      }

      $scope.isLoading = true;
      apiFactory.approveBills({
        ids: billIds
      }).then(function (resp) {
        $scope.isLoading = false;
        var ids = resp.data.data;
        ids.forEach(function (id) {
          var bill = vm.bills.find(function (x) {
            return x._id === id;
          });

          if (bill) {
            bill.status = "approved";
            bill.approval = true;
          }
        });
        vm.bills.forEach(function (x) {
          return x.checked = false;
        });
        Notification.success("Bills are successfully approved.");
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
        Notification.error("Cannot approve bills");
      });
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").component("imageViewerModal", {
    controller: imageViewerModalController,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/image-viewer-modal/image-viewer-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function imageViewerModalController($scope) {
    var vm = this;

    vm.$onInit = function () {
      if (vm.resolve.imageURL) {
        vm.imageURL = vm.resolve.imageURL;
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component("folderPickerModal", {
    controller: folderPickerModalController,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/folder-picker-modal/folder-picker-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function folderPickerModalController(Notification, apiFactory, globals, $log, $scope, utils, $uibModal) {
    var vm = this;
    $scope.folderPaths = [];
    var projectStore = globals.projectStore,
        userStore = globals.userStore,
        companyStore = globals.companyStore;
    vm.projectData = projectStore.get();
    vm.userData = userStore.get();
    vm.companyData = companyStore.get();
    $scope.utils = utils;
    $scope.rootFolders = [];
    vm.selectedFolder = undefined;
    $scope.searchText = undefined;
    vm.breadCrumbList = [];
    vm.browseHistory = [];
    vm.browseHistoryIndex = 0;

    vm.$onInit = function () {
      vm.selectedFolderType = vm.resolve.data.selectedFolderType;
      vm.parentFolder = vm.resolve.data.parentFolder;
      vm.isMoveTo = vm.resolve.data.isMoveTo;
    };

    vm.getPrimaryFolders = function () {
      var payload = {
        projectId: vm.projectData._id
      };
      $scope.loading = true;
      apiFactory.getRootFolders(payload).then(function (resp) {
        $scope.loading = false;
        vm.rootFolders = [{
          _id: 'project',
          name: 'PROJECT',
          children: resp.data.data.project
        }, {
          _id: 'company',
          name: 'COMPANY',
          children: resp.data.data.company
        }, {
          _id: 'personal',
          name: 'PERSONAL',
          children: resp.data.data.personal
        }];
        $scope.selectFolder(vm.rootFolders[0]);
      })["catch"](function (err) {
        $log.error(err);
        $scope.loading = false;
      });
    };

    vm.getPrimaryFolders();

    $scope.isAvailableBackward = function () {
      return vm.browseHistoryIndex > 0;
    };

    $scope.isAvailableForward = function () {
      return vm.browseHistoryIndex < vm.browseHistory.length - 1;
    };

    $scope.backward = function () {
      if (vm.browseHistoryIndex === 0) {
        return;
      }

      vm.browseHistoryIndex--;
      $scope.selectFolder(vm.browseHistory[vm.browseHistoryIndex], true);
    };

    $scope.forward = function () {
      if (vm.browseHistoryIndex === vm.browseHistory.length - 1) {
        return;
      }

      vm.browseHistoryIndex++;
      $scope.selectFolder(vm.browseHistory[vm.browseHistoryIndex], true);
    };

    vm.isRootFolder = function () {
      return vm.selectedFolder._id === 'project' || vm.selectedFolder._id === 'company' || vm.selectedFolder._id === 'personal';
    };

    $scope.addFolder = function () {
      var newFolderModal = $uibModal.open({
        animation: true,
        // size: 'sm',
        component: 'createFolderModal',
        backdrop: 'static',
        keyboard: false
      });
      newFolderModal.result.then(function (name) {
        var payload;
        var isRootFolder;

        if (vm.isRootFolder()) {
          isRootFolder = true;
          payload = {
            name: name,
            isParent: true,
            parentType: vm.selectedFolder._id,
            projectId: vm.projectData._id
          };
        } else {
          isRootFolder = false;
          payload = {
            name: name,
            isParent: false,
            parent: vm.selectedFolder._id
          };
        }

        apiFactory.addHierarchy(payload).then(function (resp) {
          vm.currentFolders.push(resp.data.data);
          vm.currentFilteredFolders.push(resp.data.data);

          if (isRootFolder) {
            $scope.$emit('add_root_folder', {
              type: vm.selectedFolder._id,
              folder: resp.data.data
            });
          } else {
            $scope.$emit('add_sub_folder', {
              type: vm.selectedFolder._id,
              folder: resp.data.data,
              parentFolder: vm.selectedFolder
            });
          }

          Notification.success(resp.data.message);
        })["catch"](function (e) {
          $log.error(e);
        });
      }, function (reason) {
        $log.error('err', reason);
      });
    };

    $scope.selectFolder = function (folder) {
      var historyAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      vm.selectedFolder = folder;

      if (!historyAction) {
        vm.browseHistory.push(folder);
        vm.browseHistoryIndex = vm.browseHistory.length - 1;
      }

      if (vm.isRootFolder()) {
        vm.breadCrumbList = [vm.selectedFolder];
      } else {
        vm.breadCrumbList.push(vm.selectedFolder);
      }

      var API;

      if (folder._id === 'project') {
        API = apiFactory.getProjectHierarchy({
          projectId: vm.projectData._id
        });
      } else if (folder._id === 'company') {
        API = apiFactory.getCompanyHierarchy();
      } else if (folder._id === 'personal') {
        API = apiFactory.getPersonalHierarchy({
          projectId: vm.projectData._id,
          userId: vm.userData._id
        });
      } else {
        API = apiFactory.viewHierarchy(folder._id);
      }

      $scope.loading = true;
      API.then(function (resp) {
        $scope.loading = false;
        vm.currentFolders = angular.isDefined(resp.data.data) ? resp.data.data.hierarchies : resp.data.folders;
        vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
        vm.currentFiles = angular.isDefined(resp.data.data) ? resp.data.data.rootFiles : resp.data.files;
        vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);
      });
    };

    $scope.searchCallback = function () {
      if (utils.isEmpty($scope.searchText)) {
        vm.currentFilteredFolders = Object.assign([], vm.currentFolders);
        vm.currentFilteredFiles = Object.assign([], vm.currentFiles);
      } else {
        vm.currentFilteredFolders = vm.currentFolders.filter(function (x) {
          return x.name.toLowerCase().includes($scope.searchText.toLowerCase());
        });
        vm.currentFilteredFiles = vm.currentFiles.filter(function (x) {
          return x.originalname.toLowerCase().includes($scope.searchText.toLowerCase());
        });
      }
    };

    $scope.ok = function () {
      if (vm.isMoveTo && (!vm.parentFolder && vm.selectedFolder._id === vm.selectedFolderType || vm.parentFolder && vm.parentFolder._id === vm.selectedFolder._id)) {
        Notification.error("It's same folder. Please select another folder.");
      } else {
        vm.modalInstance.close(vm.selectedFolder);
      }
    };

    $scope.cancel = function () {
      vm.modalInstance.dismiss('cancel');
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component("fileNameModal", {
    controller: fileNameModalController,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/fileNameModal/fileNameModal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function fileNameModalController($scope, Notification, utils) {
    var vm = this;
    vm.filename = '';

    vm.$onInit = function () {};

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty(vm.filename)) {
        Notification.error('Please input file name');
      } else {
        vm.modalInstance.close(vm.filename);
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component("exportModal", {
    controller: exportModalController,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/exportModal/exportModal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function exportModalController($scope, Notification, utils) {
    var vm = this;
    vm.filename = '';
    vm.formats = [{
      label: "Portable Document Format (PDF)",
      value: "pdf"
    }, {
      label: "Microsoft Excel Spreadsheet (XLSX)",
      value: "xlsx"
    }];
    vm.format = "pdf";

    vm.$onInit = function () {};

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty(vm.filename)) {
        Notification.error('Please input file name');
      } else {
        vm.modalInstance.close({
          fileName: vm.filename,
          format: vm.format
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component("editStaffModal", {
    controller: editStaffModal,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/edit-staff-modal/edit-staff-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });

  function editStaffModal($scope, globals, utils, $log, Notification) {
    var vm = this;
    $scope.EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    vm.$onInit = function () {
      vm.staff = angular.copy(vm.resolve.staff);

      if (!utils.isEmpty(vm.staff.mobile) && !utils.isEmpty(vm.staff.mobile.dialCode)) {
        vm.staff.mobile.dialCode = vm.staff.mobile.dialCode.replace('+', '');
      }

      globals.getCountryCode().then(function (resp) {
        vm.countryCodes = resp.data;
      })["catch"](function (err) {
        $log.error(err);
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onSubmit = function () {
      if (utils.isEmpty(vm.staff.firstName)) {
        Notification.error('Please input first name');
        return;
      }

      if (utils.isEmpty(vm.staff.lastName)) {
        Notification.error('Please input last name');
        return;
      }

      if (utils.isEmpty(vm.staff.email)) {
        Notification.error('Please input email');
        return;
      }

      if (utils.isEmpty(vm.staff.mobile.dialCode)) {
        Notification.error('Please select dial code');
        return;
      }

      if (utils.isEmpty(vm.staff.mobile.phoneNumber)) {
        Notification.error('Please input phone number');
        return;
      }

      vm.modalInstance.close(vm.staff);
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component("editProfileModal", {
    controller: editProfileModal,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/edit-profile-modal/edit-profile-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });

  function editProfileModal($scope, globals, utils, $log, apiFactory, Notification, $uibModal) {
    var vm = this;
    var userStore = globals.userStore,
        logout = globals.logout;
    vm.userData = Object.assign({}, userStore.get());
    $scope.EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    $scope.genderList = [{
      label: 'Male',
      value: 'male'
    }, {
      label: 'Female',
      value: 'female'
    }];

    vm.$onInit = function () {
      if (!utils.isEmpty(vm.userData.mobile) && !utils.isEmpty(vm.userData.mobile.dialCode)) {
        vm.userData.mobile.dialCode = vm.userData.mobile.dialCode.replace('+', '');
      }

      vm.userData.dateOfBirth = new Date(vm.userData.dateOfBirth);
      globals.getCountryCode().then(function (resp) {
        vm.countryCodes = resp.data;
      })["catch"](function (err) {
        $log.error(err);
      });
    };

    $scope.onChangeAvatar = function (files) {
      if (!files || !files.length) {
        return;
      }

      var file = files[0];
      $scope.PROFILE_IMAGE = URL.createObjectURL(file);
      vm.userData.file = file;
    };

    $scope.removeProfilePic = function () {
      vm.userData.profilePic = null;
      $scope.PROFILE_IMAGE = null;
    };

    $scope.changePassword = function () {
      $uibModal.open({
        animation: true,
        component: 'changePasswordModal',
        windowClass: 'change-password-modal'
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onSubmit = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Confirm update profile',
              message: 'Are you sure update your profile?',
              subMessage: 'If you update your profile, you will be automatically logged out, so please log in again.',
              confirmButtonText: 'Update',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      });
      confirmModal.result.then(function () {
        $scope.loading = true;
        apiFactory.updateMe(vm.userData).then(function (res) {
          $scope.loading = false;
          Notification.success('Profile updated successfully');
          userStore.set(res.data);
          vm.modalInstance.close();
          logout();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error('Failed to update profile');
        });
      }, function () {});
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component("createWorkOrderModal", {
    controller: createWorkOrderModal,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/create-work-order-modal/create-work-order-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });

  function createWorkOrderModal($scope, globals, utils, $log, apiFactory, Notification, $uibModal) {
    var vm = this;
    $scope.curStep = 0;

    $scope.onNextStep = function () {
      $scope.curStep = $scope.curStep + 1;
    };

    $scope.onPrevStep = function () {
      $scope.curStep = $scope.curStep - 1;
    };

    vm.formData = {
      client: 0
    };
    vm.clientList = [{
      _id: 0,
      name: 'Offer'
    }, {
      _id: 1,
      name: 'Ongoing'
    }, {
      _id: 2,
      name: 'Completed'
    }, {
      _id: 3,
      name: 'Cancel'
    }, {
      _id: 4,
      name: 'Lost'
    }, {
      _id: 5,
      name: 'Postponed'
    }, {
      _id: 6,
      name: 'Precast'
    }];
    vm.projectData = {};
    vm.buildingTypeList = [];
    $scope.isLoading = true;
    Promise.all([apiFactory.listAllClients(), apiFactory.listAllBuildingTypes()]).then(function (resp) {
      $scope.isLoading = false;
      vm.clients = resp[0].data.list;
      vm.buildingTypeList = resp[1].data.list;
    });
    vm.inputImg = [];
    vm.uploadImg = [];
    vm.inputFiles = [];
    vm.uploadFiles = [];
    vm.projectImages = [];

    vm.fileUpdated = function (files, event, modal) {
      var fileObj = event.target.files;
      vm.fileNames = Object.keys(fileObj).map(function (x) {
        return fileObj[x].name;
      });
      angular.forEach(files, function (x) {
        x.description = "";

        if (modal === "image") {
          if (vm.uploadImg.length === 0) {
            vm.uploadImg.push(x);
          } else {
            var duplicateImg = false;
            angular.forEach(vm.uploadImg, function (y) {
              if (x.name === y.name) {
                duplicateImg = true;
              }
            });

            if (!duplicateImg) {
              vm.uploadImg.push(x);
            } else {
              Notification.error("File name already exist");
            }
          }
        } else if (modal === 'projectImage') {
          vm.projectImage = x;
        } else {
          if (vm.uploadFiles.length === 0) {
            if (/image/.test(x.type)) {
              vm.uploadImg.push(x);
            } else {
              vm.uploadFiles.push(x);
            }
          } else {
            var _duplicateImg = false;
            angular.forEach([].concat(vm.uploadFiles, vm.uploadImg), function (y) {
              if (x.name === y.name) {
                _duplicateImg = true;
              }
            });

            if (!_duplicateImg) {
              if (/image/.test(x.type)) {
                vm.uploadImg.push(x);
              } else {
                vm.uploadFiles.push(x);
              }
            } else {
              Notification.error("File name already exist");
            }
          }
        }
      });
    };

    vm.deleteFile = function (indexVal, type) {
      if (type === "image") {
        vm.uploadImg.splice(indexVal, 1);
      } else {
        vm.uploadFiles.splice(indexVal, 1);
      }
    };

    var userStore = globals.userStore,
        logout = globals.logout;
    vm.userData = Object.assign({}, userStore.get());
    $scope.EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    $scope.genderList = [{
      label: 'Male',
      value: 'male'
    }, {
      label: 'Female',
      value: 'female'
    }];

    vm.$onInit = function () {
      if (!utils.isEmpty(vm.userData.mobile) && !utils.isEmpty(vm.userData.mobile.dialCode)) {
        vm.userData.mobile.dialCode = vm.userData.mobile.dialCode.replace('+', '');
      }

      vm.userData.dateOfBirth = new Date(vm.userData.dateOfBirth);
      globals.getCountryCode().then(function (resp) {
        vm.countryCodes = resp.data;
      })["catch"](function (err) {
        $log.error(err);
      });
    };

    $scope.onChangeAvatar = function (files) {
      if (!files || !files.length) {
        return;
      }

      var file = files[0];
      $scope.PROFILE_IMAGE = URL.createObjectURL(file);
      vm.userData.file = file;
    };

    $scope.removeProfilePic = function () {
      vm.userData.profilePic = null;
      $scope.PROFILE_IMAGE = null;
    };

    $scope.changePassword = function () {
      $uibModal.open({
        animation: true,
        component: 'changePasswordModal',
        windowClass: 'change-password-modal'
      });
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss();
    };

    $scope.onSubmit = function () {
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Confirm update profile',
              message: 'Are you sure update your profile?',
              subMessage: 'If you update your profile, you will be automatically logged out, so please log in again.',
              confirmButtonText: 'Update',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      });
      confirmModal.result.then(function () {
        $scope.loading = true;
        apiFactory.updateMe(vm.userData).then(function (res) {
          $scope.loading = false;
          Notification.success('Profile updated successfully');
          userStore.set(res.data);
          vm.modalInstance.close();
          logout();
        })["catch"](function (err) {
          $scope.loading = false;
          $log.error(err);
          Notification.error('Failed to update profile');
        });
      }, function () {});
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").component("confirmModal", {
    controller: confirmModalController,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/confirm-modal/confirm-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function confirmModalController($scope) {
    var vm = this;
    vm.title = 'Delete';
    vm.message = 'Are you sure you want delete?';
    vm.subMessage = 'It may produce unexcepted error on related functionalities of this system. Please check again where this item is used.';
    vm.icon = '/assets/icons/red-delete.svg';
    vm.confirmButtonText = 'Delete';

    vm.$onInit = function () {
      if (vm.resolve.data) {
        vm.title = vm.resolve.data.title || vm.title;
        vm.message = vm.resolve.data.message || vm.message;
        vm.subMessage = vm.resolve.data.subMessage || vm.subMessage;
        vm.icon = vm.resolve.data.icon || vm.icon;
        vm.confirmButtonText = vm.resolve.data.confirmButtonText || vm.confirmButtonText;
      }
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      vm.modalInstance.close(true);
    };
  }
})();


"use strict";

(function () {
  angular.module("app").component("changePasswordModal", {
    controller: changePasswordModal,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/change-passsword-modal/change-password-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function changePasswordModal($scope, apiFactory, Notification, utils) {
    var vm = this;

    vm.$onInit = function () {
      $scope.data = {};
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      $scope.loading = true;
      apiFactory.updateMyPassword($scope.data).then(function () {
        $scope.loading = false;
        Notification.success('Password changed successfully');
        vm.modalInstance.close();
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").component("alertModal", {
    controller: alertModalController,
    controllerAs: 'vm',
    templateUrl: 'app/core/components/alert-modal/alert-modal.view.html',
    bindings: {
      $close: "&",
      $dismiss: "&",
      modalInstance: "<",
      resolve: "<"
    }
  });
  /** @ngInject */

  function alertModalController($scope) {
    var vm = this;
    vm.title = 'Alert';
    vm.message = 'Are you sure you want delete?';
    vm.positive = 'Yes';
    vm.negative = 'No';

    vm.$onInit = function () {
      if (vm.resolve.title) {
        vm.title = vm.resolve.title;
      }

      if (vm.resolve.message) {
        vm.message = vm.resolve.message;
      }

      if (vm.resolve.positive) {
        vm.positive = vm.resolve.positive;
      }

      if (vm.resolve.negative) {
        vm.negative = vm.resolve.negative;
      }
    };

    $scope.onClose = function () {
      vm.modalInstance.dismiss('close');
    };

    $scope.onCancel = function () {
      vm.modalInstance.dismiss('cancel');
    };

    $scope.onSubmit = function () {
      vm.modalInstance.close();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('timeline', {
    controller: timelineController,
    controllerAs: 'vm',
    templateUrl: 'app/main/timeline/timeline.view.html'
  });
  /** @ngInject */

  function timelineController($scope, $timeout, $state, apiFactory, globals, $log, $uibModal, utils, Notification, $document, pdfFactory, storageFactory) {
    var vm = this;
    var projectStore = globals.projectStore,
        userStore = globals.userStore;
    vm.project = projectStore.get();
    vm.isAllProject = !vm.project || vm.project._id === 'all';
    vm.user = userStore.get();
    $scope.TIMELINE_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.user);
    // if (vm.user.designation === "Admin") {
    //   $scope.TIMELINE_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.TIMELINE]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.TIMELINE_ACCESS_CREATE = res.data.data[Constants.AccessKey.TIMELINE];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    vm.isMainEstimate = false;
    vm.showOverlay = false;
    vm.groups = [];
    vm.workers = [];
    vm.subContractors = [];
    vm.workTypes = [];
    vm.workLevels = [];
    vm.events = [];
    vm.selectedTask = undefined;
    vm.selectedGroup = undefined;
    vm.modelViewer = undefined;
    vm.refreshModelViewer = undefined;
    vm.ganttData = {
      data: [],
      links: []
    };
    vm.resourceData = [];
    vm.groupData = [];
    vm.showResources = false;
    vm.currentResources = [];
    $scope.searchText = undefined;
    vm.notifications = [];
    vm.hrswItems = [];
    $scope.zoomValue = 1;
    vm.isEdited = false;
    $scope.isLoading = false;
    $scope.updating = false;
    $scope.isMainCalc = false;
    $scope.sheetType = null;
    $scope.sideBoxItems = [{
      name: 'weather',
      icon: '/assets/icons/weather-white.svg'
    }, {
      name: 'notification',
      icon: '/assets/icons/bell-white.svg'
    }, {
      name: 'worker',
      icon: '/assets/icons/add-worker-white.svg'
    }, {
      name: 'setting',
      icon: '/assets/icons/settings-white.svg'
    }]; // color style for timeline

    vm.styles = {};
    var styleIndex = 0;
    var FETCH_WORKPATTERNS_COUNT = 5;
    var MINT_MATCH_WORKPATTERNS_COUNT = 3;
    vm.timelineWorkPatterns = [];

    if (!vm.isAllProject) {
      vm.startline = new Date(vm.project.startDate);
      vm.startline.setHours(0, 0, 0, 0);
      vm.deadline = new Date(vm.project.endDate);
      vm.deadline.setHours(23, 59, 59, 999);
    } // expand area


    $scope.expandedArea = undefined;

    $scope.expandArea = function (area) {
      $scope.expandedArea = area;
      vm.showResources = false;
      $timeout(function () {
        if (angular.isDefined(vm.refreshModelViewer)) {
          vm.refreshModelViewer();
        }
      });
    };

    $scope.showType = 'Type';

    $scope.isShowArea = function (area) {
      return vm.isAllProject ? area === 'gantt' : $scope.expandedArea === area || angular.isUndefined($scope.expandedArea);
    };

    $scope.expandedClass = function (area) {
      return vm.isAllProject && area === 'gantt' || $scope.expandedArea === area ? 'expanded' : '';
    };

    $scope.isExpanded = function (area) {
      return vm.isAllProject && area === 'gantt' || $scope.expandedArea === area;
    };

    $scope.searchType = 'name';
    $scope.viewStyle = 'month';
    $scope.ganttType = undefined; // refresh flowline

    $scope.refreshFlowline = false;
    $scope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (!toState.redirectTo && vm.isEdited) {
        event.preventDefault();
        $uibModal.open({
          animation: true,
          component: 'alertModal',
          size: 'sm',
          resolve: {
            title: function title() {
              return 'Warning';
            },
            message: function message() {
              return 'You have unsaved edit. Do you want to save?';
            },
            positive: function positive() {
              return 'Save';
            }
          }
        }).result.then(function () {
          saveTimeline().then(function () {
            $state.go(toState, toParams);
          });
        }, function (reason) {
          if (reason === 'cancel') {
            vm.isEdited = false;
            $state.go(toState, toParams);
          }
        });
      }
    });

    $scope.selectSheetType = function (sheetType) {
      $scope.sheetType = sheetType;
      $uibModal.open({
        animation: true,
        component: 'alertModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          title: function title() {
            return 'Load Other Timeline';
          },
          message: function message() {
            return 'Are you going to load other timeline?';
          },
          positive: function positive() {
            return 'Yes';
          }
        }
      }).result.then(function () {
        $scope.loadTimeLine(true);
        vm.isEdited = true;
      });
    };

    $scope.selectSearchType = function (type) {
      $scope.searchType = type;
    };

    $scope.selectViewStyle = function (style) {
      $scope.viewStyle = style;
    };

    $scope.selectGanttType = function (type) {
      $scope.ganttType = type;
    };

    vm.addTask = function () {
      $uibModal.open({
        animation: true,
        component: 'addTaskModal',
        windowClass: 'timeline-add-task-modal',
        backdrop: 'static',
        resolve: {
          groups: function groups() {
            return vm.groups;
          },
          workers: function workers() {
            return vm.workers;
          },
          subContractors: function subContractors() {
            return vm.subContractors;
          },
          workLevels: function workLevels() {
            return vm.workLevels;
          },
          workTypes: function workTypes() {
            return vm.workTypes;
          },
          selectedTask: function selectedTask() {
            return vm.selectedTask ? vm.selectedTask : vm.selectedGroup;
          }
        }
      }).result.then(function (result) {
        vm.isEdited = true;
        var task = result;
        var groupData = [vm.groupData[0], vm.groupData[1]];

        if (groupData[0].data.findIndex(function (x) {
          return x.key === task.workType;
        }) === -1) {
          groupData[0].data.push({
            key: task.workType,
            label: task.workType
          });
        }

        if (groupData[1].data.findIndex(function (x) {
          return x.key === task.workLevel;
        }) === -1) {
          groupData[1].data.push({
            key: task.workLevel,
            label: task.workLevel
          });
        }

        vm.groupData = groupData;
        setStyle(task.workType);
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.toggleResources = function () {
      vm.showResources = !vm.showResources;
    };

    vm.editTask = function (task) {
      if (task) {
        vm.selectedTask = task;
      }

      $uibModal.open({
        animation: true,
        component: 'editTaskModal',
        windowClass: 'timeline-edit-task-modal',
        backdrop: 'static',
        resolve: {
          task: function task() {
            return vm.selectedTask;
          },
          isMainEstimate: function isMainEstimate() {
            return vm.isMainEstimate;
          }
        }
      }).result.then(function () {
        vm.isEdited = true;

        if (angular.isDefined(vm.selectedTask)) {
          gantt.updateTask(vm.selectedTask.id);
        }
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.splitTask = function () {
      $uibModal.open({
        animation: true,
        component: 'splitTaskModal',
        windowClass: 'timeline-split-task-modal',
        backdrop: 'static',
        resolve: {
          task: function task() {
            return vm.selectedTask;
          }
        }
      }).result.then(function () {
        vm.isEdited = true;
      });
    };

    vm.combineTask = function () {
      $uibModal.open({
        animation: true,
        component: 'combineTaskModal',
        windowClass: 'timeline-combine-task-modal',
        backdrop: 'static',
        resolve: {
          selectedTask: function selectedTask() {
            return vm.selectedTask ? vm.selectedTask : vm.selectedGroup;
          }
        }
      }).result.then(function () {
        vm.isEdited = true;
      });
    };

    vm.editCombinedTask = function () {
      $uibModal.open({
        animation: true,
        component: 'editCombineTaskModal',
        windowClass: 'timeline-edit-combine-task-modal',
        backdrop: 'static',
        resolve: {
          task: function task() {
            return vm.selectedTask;
          }
        }
      }).result.then(function (result) {
        $log.log(result);
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.hrsW = function () {
      $uibModal.open({
        animation: true,
        component: 'hrsWModal',
        windowClass: 'timeline-hrs-w-modal',
        backdrop: 'static',
        resolve: {
          projectId: function projectId() {
            return vm.project._id;
          },
          workers: function workers() {
            return vm.workers;
          },
          subContractors: function subContractors() {
            return vm.subContractors;
          },
          times: function times() {
            return vm.hrswItems;
          }
        }
      }).result.then(function (result) {
        vm.hrswItems = result;
        refreshWorkersToTimeline();
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.zoomPlus = function () {
      if ($scope.zoomValue >= 10) return;
      $scope.zoomValue++;
    };

    vm.zoomMinus = function () {
      if ($scope.zoomValue <= 1) return;
      $scope.zoomValue--;
    };

    vm.saveTimeline = function () {
      $uibModal.open({
        animation: true,
        component: 'alertModal',
        size: 'sm',
        resolve: {
          title: function title() {
            return 'Save';
          },
          message: function message() {
            return 'Are you going to save?';
          },
          positive: function positive() {
            return 'Save';
          }
        }
      }).result.then(function () {
        saveTimeline();
        updateWorkPattern();
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.exportPdf = function () {
      pdfFactory.exportGantt("timeline", gantt, vm.styles, {
        icon: '/assets/images/logo.png',
        logo: 'CloudES',
        title: vm.project.projectName,
        statusIcons: ["/assets/images/timeline/status-waiting.png", "/assets/images/timeline/status-working.png", "/assets/images/timeline/status-warning.png", "/assets/images/timeline/status-completed.png", "/assets/images/timeline/status-warning.png"],
        ganttType: $scope.ganttType,
        pageSize: {
          width: 1754,
          height: 1240
        } //A4

      });
    };

    vm.exportMpp = function () {
      gantt.exportToMSProject({
        name: 'timeline.xml'
      });
    };

    vm.reloadTimeline = function () {
      $uibModal.open({
        animation: true,
        component: 'alertModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          title: function title() {
            return 'Reload';
          },
          message: function message() {
            return 'Are you going to reload?';
          },
          positive: function positive() {
            return 'Reload';
          }
        }
      }).result.then(function () {
        loadTimelineWithCalc(true);
        vm.isEdited = true;
      });
    };

    vm.showToggleMenus = function (index) {
      $scope.toggleIndex = index;
      var nav = angular.element('#right-side-box');
      var isOpen = nav.hasClass('open');

      if (isOpen) {
        nav.removeClass('open');
      } else {
        nav.addClass('open');
      }

      var toggleItems = $document[0].getElementsByClassName('side-box-item');
      var toggleItemsVisible = isOpen ? 'visible' : 'hidden';

      for (var i = 0; i < toggleItems.length; i++) {
        toggleItems[i].style.visibility = toggleItemsVisible;
      }

      toggleItems[index].style.visibility = 'visible';
    };

    vm.taskChanged = function (id, task) {
      var labourHours = utils.num(task.calcHours);
      var duration = Math.max(8, task.duration);
      var workerCount = labourHours > duration ? Math.ceil(labourHours / duration) : 1;
      task.requiredWorkerCount = workerCount;

      if (task.resources) {
        if (task.resources.length > workerCount) {
          task.resources.splice(workerCount, task.resources.length - workerCount);
        } else if (task.resources.length < workerCount) {
          var workersMap = {};
          var count = task.resources.length;

          for (var i = 0; i < count; i++) {
            workersMap[task.resources[i].id] = task.resources[i];
          }

          for (var _i = 0; _i < vm.workers.length; _i++) {
            var worker = vm.workers[_i];

            if (angular.isUndefined(workersMap[worker._id])) {
              task.resources.push({
                id: worker._id,
                name: worker.displayName,
                avatar: worker.profilePic,
                type: 1
              });
              count++;

              if (count >= workerCount) {
                break;
              }
            }
          }
        }
      }

      updateTaskDelay(task);
      gantt.updateTask(id);
      vm.isEdited = true;
    };

    vm.taskSelected = function (taskId) {
      var task = gantt.getTask(taskId);
      $scope.ganttTask = task;

      if (task.type === gantt.config.types.project) {
        vm.selectedGroup = task;
        vm.selectedTask = undefined;
      } else {
        vm.selectedGroup = undefined;
        vm.selectedTask = task;
      }

      if (vm.selectedTask) {
        loadCurrentResources(vm.selectedTask);
      } else {
        vm.currentResources = vm.resourceData;
      }

      if (task.type === gantt.config.types.project) {
        var calcLevel = task.calcLevel;

        if (calcLevel) {
          if (calcLevel.modelId) {
            vm.modelViewer = {
              modelType: calcLevel.modelType,
              modelId: calcLevel.modelId,
              objectId: calcLevel.objectId
            };
            $timeout(function () {
              return $scope.$apply();
            });
            return;
          }
        } else {
          if (selectTask(task)) return;
        }
      } else {
        if (selectTask(task)) return;
      }

      vm.modelViewer = undefined;
      $timeout(function () {
        return $scope.$apply();
      });
    };

    vm.taskUpdated = function () {
      vm.isEdited = true;
    };

    vm.getWorkerCount = function (gantt, start, end) {
      var workerCount = 0;
      var requiredCount = 0;
      var startValue = start.getTime();
      var endValue = end.getTime();
      var gap = (endValue - startValue) / 3600000;
      var isWeekend = gap <= 24 && (start.getDay() === 6 || start.getDay() === 0) && (end.getDay() === 6 || end.getDay() === 0 || end.getDay() === 1);

      if (!isWeekend) {
        var resources = [];
        gantt.eachTask(function (task) {
          if (task.type !== gantt.config.types.project && task.start_date && task.end_date) {
            if (endValue >= task.start_date.getTime() && startValue <= task.end_date.getTime()) {
              if (task.resources) {
                task.resources.forEach(function (resource) {
                  if (resources.findIndex(function (x) {
                    return x.id === resource.id;
                  }) === -1) {
                    resources.push(resource);
                  }
                });
              }

              requiredCount += task.requiredWorkerCount ? task.requiredWorkerCount : 0;
            }
          }
        });
        resources.forEach(function (resource) {
          if (getWorkableHours(resource, start, end) > 0) {
            workerCount++;
          }
        });
      }

      return {
        working: workerCount,
        required: requiredCount
      };
    };

    vm.getTotalCount = function (type) {
      var count = 0;

      if (type === 'R') {
        gantt.eachTask(function (task) {
          if (task.type === gantt.config.types.task) {
            var need = utils.num(task.requiredWorkerCount);
            count = Math.max(need, count);
          }
        });
      } else {
        count = vm.resourceData && vm.resourceData.length ? vm.resourceData.length - 2 : 0;
      }

      return count;
    };

    vm.addWorker = function () {
      if (!vm.selectedTask) {
        Notification.error("Please select task first.");
        return;
      }

      $uibModal.open({
        animation: true,
        component: 'addWorkerModal',
        windowClass: 'timeline-add-worker-modal',
        backdrop: 'static',
        resolve: {
          task: function task() {
            return vm.selectedTask;
          },
          workers: function workers() {
            return vm.workers;
          },
          subContractors: function subContractors() {
            return vm.subContractors;
          },
          groups: function groups() {
            return vm.groups;
          }
        }
      }).result.then(function (result) {
        if (!vm.selectedTask.resources) {
          vm.selectedTask.resources = [];
        }

        var resourceData = [];
        vm.resourceData.forEach(function (x) {
          return resourceData.push(x);
        });
        result.forEach(function (w) {
          if (vm.selectedTask.resources.findIndex(function (x) {
            return x.id === w._id;
          }) === -1) {
            vm.selectedTask.resources.push({
              id: w._id,
              name: w.name,
              avatar: w.profilePic,
              type: w.type === 'worker' ? 1 : 2
            });
            vm.selectedTask.resourceIds.push(w._id);
          }

          if (w.type === 'worker') {
            if (resourceData.findIndex(function (x) {
              return x.id === w._id;
            }) === -1) {
              resourceData.push({
                id: w._id,
                text: w.displayName,
                avatar: w.profilePic,
                parent: 1
              });
            }
          } else if (w.type === 'subcontractor') {
            if (resourceData.findIndex(function (x) {
              return x.id === w._id;
            }) === -1) {
              resourceData.push({
                id: w._id,
                text: w.name,
                avatar: w.profilePic,
                parent: 2
              });
            }
          }
        });
        vm.resourceData = resourceData;
        gantt.updateTask(vm.selectedTask.id);
        loadCurrentResources(vm.selectedTask);
      }, function (reason) {
        $log.log(reason);
      });
    };

    vm.removeWorker = function (workerId) {
      if (!vm.selectedTask) {
        Notification.error("Please select task first.");
        return;
      }

      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        if (vm.selectedTask.resources) {
          var index = vm.selectedTask.resources.findIndex(function (x) {
            return x.id === workerId;
          });

          if (index !== -1) {
            vm.selectedTask.resources.splice(index, 1);
          }
        }

        if (vm.selectedTask.resourceIds) {
          var _index = vm.selectedTask.resourceIds.findIndex(function (x) {
            return x === workerId;
          });

          if (_index !== -1) {
            vm.selectedTask.resourceIds.splice(_index, 1);
          }
        }

        gantt.updateTask(vm.selectedTask.id);
        loadCurrentResources(vm.selectedTask);
      });
    };

    vm.getWorkerHours = function (resource, start, end, tasks) {
      return getWorkableHours(resource, start, end, tasks);
    };

    vm.combineAuto = function () {
      $uibModal.open({
        animation: true,
        component: 'alertModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          title: function title() {
            return 'Combine';
          },
          message: function message() {
            return 'Are you going to combine items automatically?';
          },
          positive: function positive() {
            return 'Combine';
          }
        }
      }).result.then(function () {
        combineAuto();
        vm.isEdited = true;
      });
    };

    function initFlowlineCombobox() {
      var combobox = new dhx.Combobox('flowline-combobox', {
        data: [{
          id: 'Type',
          value: 'Type'
        }, {
          id: 'Name',
          value: 'Name'
        }],
        readOnly: true,
        value: 'Type'
      });
      combobox.events.on('change', function () {
        var value = combobox.getValue();

        if (value) {
          $scope.showType = value;
          $timeout(function () {
            $scope.$apply();
          });
        }
      });
    } // loading


    function initData() {
      initFlowlineCombobox();
      $scope.isLoading = true;
      var apis = [apiFactory.listAllEmployeeGroups(), apiFactory.getAllEmployees({
        isActive: true
      }), apiFactory.getAllSubcontractors(), apiFactory.listAllHolidays(), apiFactory.getWorkLevelAndTypes(), apiFactory.getAllEvents(), apiFactory.getCalcSheetCount(vm.project._id), apiFactory.getEconomicDashboardData({
        projects: [vm.project._id]
      })];

      if (!vm.isAllProject) {
        apis.push(apiFactory.fetchTimelineWorkPatterns({
          projectId: vm.project._id,
          fetchCount: FETCH_WORKPATTERNS_COUNT
        }));
      }

      Promise.all(apis).then(function (resp) {
        // load employee groups
        var groups = resp[0].data.list || [];
        vm.groups = [];
        groups.forEach(function (element) {
          element.type = "group";
          vm.groups.push(element);
        }); // load workers

        var workers = resp[1].data.list || [];
        vm.workers = [];
        workers.forEach(function (element) {
          element.name = element.displayName;
          element.type = 'worker';
          var group = vm.groups.find(function (group) {
            return group.leader._id === element._id || group.employees.findIndex(function (employee) {
              return employee._id === element._id;
            }) !== -1;
          });
          element.groupName = group ? group.name : undefined;
          vm.workers.push(element);
        });
        vm.workers.sort(function (a, b) {
          var aValue = angular.isDefined(a.groupName);
          var bValue = angular.isDefined(b.groupName);

          if (aValue && bValue) {
            return a.groupName < b.groupName ? -1 : a.groupName > b.groupName ? 1 : 0;
          } else {
            return !aValue && bValue ? 1 : -1;
          }
        });
        vm.subContractors = resp[2].data.list || [];
        vm.subContractors.forEach(function (x) {
          return x.type = 'subcontractor';
        });
        vm.holidays = resp[3].data.list;

        if (!vm.isAllProject) {
          vm.availableHours = utils.getWorkingHours(vm.startline, vm.deadline);

          if (vm.availableHours === 0) {
            vm.availableHours = 8;
          }
        } else {
          vm.availableHours = 0;
        }

        vm.workLevels = resp[4].data.data.workLevels;
        vm.workTypes = resp[4].data.data.workTypes;
        vm.events = resp[5].data.data;

        if (resp[6].data.mainCnt > 0) {
          $scope.isMainCalc = true;
          $scope.sheetType = 'prepare';
        } else {
          $scope.isMainCalc = false;
          $scope.sheetType = null;
        }

        if (angular.isDefined(resp[7])) {
          vm.timelineWorkPatterns = resp[7].data.list;
        }

        vm.graphData = resp[7].data.graphData;

        if (resp[6].data.mainCnt > 0) {
          vm.isMainEstimate = true;
        } // load timeline


        if (!vm.isMainEstimate) $scope.loadTimeLine();else $scope.loadExtraTimeline();
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
      });
    }

    initData();

    $scope.loadExtraTimeline = function () {
      $scope.isLoading = true;

      if (vm.isAllProject) {
        $scope.isLoading = false;
        Notification.error('Cannot load main estimation timeline data for all project.');
      } else {
        apiFactory.getTimelineExtra(vm.project._id).then(function (resp) {
          vm.timelineExtra = resp.data.data;
          $scope.isLoading = false;
          $log.log(vm.timelineExtra);
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error('Cannot load timeline data from the server.');
        });
      }
    };

    $scope.loadTimeLine = function () {
      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      $scope.isLoading = true;

      if (vm.isAllProject) {
        vm.timeline = undefined; // all project

        storageFactory.getBookmarks().then(function (resp) {
          $scope.projects = resp.data.bookmarks;
          loadTimelineWithAllProject();
          $scope.isLoading = false;
        })["catch"](function (err) {
          $log.error(err);
          Notification.error('Cannot load timeline data from the server.');
          $scope.isLoading = false;
        });
      } else {
        apiFactory.getTimeline(vm.project._id, $scope.sheetType).then(function (resp) {
          $scope.isLoading = false;
          vm.timeline = resp.data.data;
          vm.isEdited = vm.timeline.needSave;
          vm.hrswItems = vm.timeline.hrsw || [];

          if (vm.project.buildingType) {
            $scope.isLoading = true;
            apiFactory.getWorkPatternById(vm.project.buildingType._id ? vm.project.buildingType._id : vm.project.buildingType).then(function (res) {
              $scope.isLoading = false;
              var workPattern = res.data.data;

              if (!utils.isEmpty(workPattern)) {
                vm.sortMap = {};
                workPattern.items.forEach(function (item, index) {
                  vm.sortMap[item.tagName] = index;
                });
                vm.workPattern = workPattern;
              }

              loadTimelineWithCalc(reload);
            })["catch"](function (err) {
              $log.error(err);
              $scope.isLoading = false;
              loadTimelineWithCalc(reload);
            });
          } else {
            loadTimelineWithCalc(reload);
          }
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error('Cannot load timeline data from the server.');
        });
      }
    };

    function loadTimelineWithAllProject() {
      if (!$scope.projects) return;
      var items = [];
      var resources = {};

      var _loop = function _loop(i) {
        var project = $scope.projects[i];
        var item = {
          id: project._id,
          text: project.projectName,
          start_date: new Date(project.startDate),
          end_date: new Date(project.endDate),
          type: gantt.config.types.task,
          progress: utils.num(project.progress),
          project: true,
          calcHours: project.calcSheet ? utils.num(project.calcSheet.totalWorkHours) : 0,
          resources: [],
          resourceIds: []
        };

        if (project.timeline && project.timeline.resources) {
          project.timeline.resources.forEach(function (resource) {
            if (resource.worker && resource.worker._id) {
              var group = vm.groups.find(function (group) {
                return group.leader._id === resource.worker._id || group.employees.findIndex(function (employee) {
                  return employee._id === resource.worker._id;
                }) !== -1;
              });
              item.resources.push({
                id: resource.worker._id,
                name: resource.worker.displayName || resource.worker.name,
                avatar: resource.worker.profilePic,
                type: resource.workerType === 'Employee' ? 1 : 2,
                groupName: group ? group.name : undefined
              });
            }
          });
          item.resourceIds = item.resources.map(function (resource) {
            return resource.id;
          });
          item.resources.forEach(function (res) {
            if (!resources[res.id]) {
              resources[res.id] = res;
            }
          });
        }

        var workHours = utils.getWorkingHours(item.start_date, item.end_date);
        item.requiredWorkerCount = workHours === 0 ? 1 : Math.max(1, Math.ceil(item.calcHours / workHours));
        items.push(item);
      };

      for (var i = 0; i < $scope.projects.length; i++) {
        _loop(i);
      }

      var resourceData = [];
      var workerCount = 0;
      var subcontractorCount = 0;

      for (var id in resources) {
        var resource = resources[id];

        if (resource) {
          resourceData.push({
            id: resource.id,
            text: resource.name,
            groupName: resource.groupName,
            avatar: resource.avatar,
            parent: resource.type
          });

          if (resource.type === 1) {
            workerCount++;
          } else {
            subcontractorCount++;
          }
        }
      }

      resourceData.unshift({
        id: 2,
        text: "Sub Contractors (".concat(subcontractorCount, ")"),
        type: gantt.config.types.project
      });
      resourceData.unshift({
        id: 1,
        text: "Workers (".concat(workerCount, ")"),
        type: gantt.config.types.project
      });
      vm.ganttData = {
        data: items,
        links: []
      };
      vm.resourceData = resourceData;
      vm.currentResources = vm.resourceData;
      $timeout(function () {
        return gantt.showDate(new Date());
      }, 300);
    }

    function loadTimelineWithCalc(reload) {
      var groups = vm.timeline.groups;
      var tasks = vm.timeline.tasks;
      var timeline = {
        gantt: {
          data: [],
          links: []
        },
        resources: {
          workers: {},
          subcontractors: {}
        },
        groups: {
          workType: {},
          workLevel: {}
        }
      };
      vm.styles = {};
      styleIndex = 0;
      var ganttGroups = {};

      if (groups) {
        groups.forEach(function (group) {
          var item = makeGanttGroup(group, timeline);
          ganttGroups[item.id] = item;
        });
      }

      if (tasks) {
        var csTasks = [];
        var totalWorkHours = 0;
        tasks.forEach(function (task) {
          var csTask = loadCalcTask(task);

          if (csTask) {
            csTasks.push(csTask);
            totalWorkHours += csTask.workHours;
          }
        });
        var deltaPercent = totalWorkHours === 0 ? 1 : vm.availableHours / totalWorkHours;
        csTasks.forEach(function (csTask) {
          csTask.workHours *= deltaPercent;
          var workHours = Math.max(8, csTask.workHours);
          csTask.requiredWorkerCount = Math.max(1, Math.ceil(csTask.calcHours / workHours));
        });
        var date = new Date(vm.startline);
        tasks.forEach(function (task) {
          var csTask = csTasks.find(function (csTask) {
            return csTask._id === task._id;
          });
          var item = makeGanttTask(task, date, reload, timeline, csTask);
          var group = item.parent ? ganttGroups[item.parent] : undefined;

          while (group) {
            if (item.status === 4 || item.status === 1) {
              group.status = item.status;
            }

            group.workedHours += item.workedHours;
            group.calcHours += item.calcHours;
            group.progressedHours += item.calcHours * item.progress;
            group.requiredWorkerCount = Math.max(group.requiredWorkerCount, item.requiredWorkerCount);

            if (group.startDate) {
              if (group.startDate.getTime() > item.start_date.getTime()) {
                group.startDate = new Date(item.start_date);
              }
            } else {
              group.startDate = new Date(item.start_date);
            }

            if (group.endDate) {
              if (group.endDate.getTime() < item.end_date.getTime()) {
                group.endDate = new Date(item.end_date);
              }
            } else {
              group.endDate = new Date(item.end_date);
            }

            group = group.parent ? ganttGroups[group.parent] : undefined;
          }
        });

        for (var key in ganttGroups) {
          var group = ganttGroups[key];
          if (!group) continue;

          if (group.calcHours === 0) {
            group.progress = 0;
          } else {
            group.progress = group.progressedHours / group.calcHours;
          }

          if (group.startDate && group.endDate) {
            var progress = utils.progressOfDate(group.startDate, group.endDate, new Date(), true);

            if (progress > group.progress) {
              group.delay = progress - group.progress;
              group.status = 4;
            }
          }
        }
      }

      var resourceData = [];
      var workerCount = 0;
      var subcontractorCount = 0;

      for (var id in timeline.resources.workers) {
        var worker = timeline.resources.workers[id];

        if (worker) {
          resourceData.push({
            id: worker.id,
            text: worker.name,
            groupName: worker.groupName,
            avatar: worker.avatar,
            parent: 1
          });
          workerCount++;
        }
      }

      for (var _id in timeline.resources.subcontractors) {
        var subcontractor = timeline.resources.subcontractors[_id];

        if (subcontractor) {
          resourceData.push({
            id: subcontractor.id,
            text: subcontractor.name,
            avatar: subcontractor.avatar,
            parent: 2
          });
          subcontractorCount++;
        }
      }

      resourceData.unshift({
        id: 2,
        text: "Sub Contractors (".concat(subcontractorCount, ")"),
        type: gantt.config.types.project
      });
      resourceData.unshift({
        id: 1,
        text: "Workers (".concat(workerCount, ")"),
        type: gantt.config.types.project
      });
      var groupData = [{
        name: 'workType',
        data: []
      }, {
        name: 'workLevel',
        data: []
      }];

      for (var _id2 in timeline.groups.workType) {
        var workType = timeline.groups.workType[_id2];

        if (workType) {
          groupData[0].data.push({
            key: workType,
            label: workType
          });
        }
      }

      for (var _id3 in timeline.groups.workLevel) {
        var workLevel = timeline.groups.workLevel[_id3];

        if (workLevel) {
          groupData[1].data.push({
            key: workLevel,
            label: workLevel
          });
        }
      }

      if (timeline.gantt.data.length === 0) {
        // no message in the case empty sheet after creating new project
        if (tasks.length === 0) {
          Notification.error('There is no data for timeline.');
        }
      } else {
        var now = new Date().getTime();
        timeline.gantt.data.forEach(function (item) {
          if (item.end_date && item.end_date.getTime() < now) {
            vm.notifications.push("The working time of \"".concat(item.text, "\" is passed away."));
          }
        });
      }

      vm.ganttData = timeline.gantt;
      $scope.totalProgress = vm.ganttData.data[0].progress;
      vm.resourceData = resourceData;
      vm.groupData = groupData;
      vm.currentResources = vm.resourceData;
      $timeout(function () {
        return gantt.showDate(new Date());
      }, 300);
      showAnyModel();
    }

    function makeGanttGroup(group, timeline) {
      var groupItem = {
        id: group._id,
        text: group.name,
        type: gantt.config.types.project,
        calcHours: 0,
        workedHours: 0,
        progressedHours: 0,
        modelId: group.modelId,
        modelType: group.modelType,
        show: true,
        status: 0,
        progress: 0,
        delay: 0,
        requiredWorkerCount: 1
      };

      if (group.parent) {
        groupItem.parent = group.parent;
      }

      timeline.gantt.data.push(groupItem);
      return groupItem;
    }

    function loadCalcTask(task) {
      if (!task.calcSheet || task.taskStyle === 'Subcontractor') return;
      var csTask = {
        _id: task._id,
        skill: task.product ? task.product.groupId : undefined,
        calcHours: utils.num(task.calcHours),
        workHours: utils.num(task.calcHours),
        workers: [],
        requiredWorkerCount: 1,
        workType: task.workType
      };

      if (csTask.skill) {
        vm.workers.forEach(function (worker) {
          if (worker.listOfSkills) {
            worker.listOfSkills.forEach(function (workerSkill) {
              if (workerSkill.skill === csTask.skill) {
                csTask.workers.push(worker);
              }
            });
          } else {
            csTask.workers.push(worker);
          }
        });
      } else {
        // anyone can work
        vm.workers.forEach(function (worker) {
          csTask.workers.push(worker);
        });
      }

      return csTask;
    }

    function makeGanttTask(task, date, reload, timeline, csTask) {
      var ganttItem = taskToGantt(task);

      if (task.tasks && task.tasks.length > 0) {
        ganttItem.composeState = 'combined';
        ganttItem.tasks = [];
        var prevSubTask = undefined;
        task.tasks.forEach(function (subTask) {
          var ganttSubItem = subTaskToGantt(subTask, prevSubTask);
          ganttItem.tasks.push(ganttSubItem);
          prevSubTask = ganttSubItem;
        });
      }

      if ((!reload || !task.calcItem) && task.startDate && task.endDate) {
        // load from saved time
        ganttItem.start_date = new Date(task.startDate);
        ganttItem.end_date = new Date(task.endDate);
        ganttItem.requiredWorkerCount = utils.num(task.requiredWorkerCount);
      } else {
        // set time
        var moveTimes = 0;
        var _workType = task.workType;

        if (angular.isDefined(vm.workPattern) && angular.isDefined(_workType)) {
          var prevItem = timeline.gantt.data[timeline.gantt.data.length - 1];

          if (angular.isDefined(prevItem) && prevItem.workType !== _workType) {
            var patternItem = vm.workPattern.items.find(function (x) {
              return x.tagName === _workType;
            });

            if (angular.isDefined(patternItem)) {
              var percentage = patternItem.percentage;

              if (percentage >= 0 && percentage < 100) {
                var prevItems = timeline.gantt.data.filter(function (x) {
                  return x.workType === prevItem.workType;
                });
                var prevFirstItem = prevItems[0];
                var prevLastItem = prevItems[prevItems.length - 1];
                var diffTimes = prevLastItem.end_date.getTime() - prevFirstItem.start_date.getTime();
                moveTimes = Math.ceil(diffTimes * (100 - percentage) / 100);
              }
            }
          }
        }

        var startDate = new Date(date.getTime() - moveTimes);
        var taskDuration = csTask ? csTask.workHours : ganttItem.calcHours;

        if (taskDuration < 8) {
          var dates = getTaskDates(startDate, 8 * 3600000);
          ganttItem.start_date = dates.start;
          ganttItem.end_date = dates.end;
          date.setTime(getTaskDates(startDate, taskDuration * 3600000).end.getTime());
        } else {
          var _dates = getTaskDates(startDate, taskDuration * 3600000);

          ganttItem.start_date = _dates.start;
          ganttItem.end_date = _dates.end;
          date.setTime(_dates.end.getTime());
        }

        ganttItem.requiredWorkerCount = csTask ? csTask.requiredWorkerCount : task.requiredWorkerCount;
      } // delay?


      if (ganttItem.status !== 3) {
        var progress = utils.progressOfDate(ganttItem.start_date, ganttItem.end_date, new Date(), true);

        if (ganttItem.progress < progress) {
          ganttItem.delay = progress - ganttItem.progress;
          ganttItem.status = 4;
        }
      }

      if (!reload && task.resources && task.resources.length > 0) {
        // load from saved workers
        ganttItem.resources = [];
        task.resources.forEach(function (res) {
          if (res.worker) {
            var group = vm.groups.find(function (x) {
              return x.leader._id === res.worker._id || x.employees.findIndex(function (member) {
                return member._id === res.worker._id;
              }) !== -1;
            });
            ganttItem.resources.push({
              id: res.worker._id,
              name: res.worker.name || res.worker.displayName,
              groupName: group ? group.name : undefined,
              avatar: res.worker.profilePic,
              type: res.workerType === 'Employee' ? 1 : 2
            });
          }
        });
      } else {
        // set workers
        if (task.taskStyle === 'Subcontractor') {
          var subContractor = vm.subContractors.find(function (x) {
            return x._id === task.workerId;
          });

          if (subContractor) {
            var resource = {
              id: subContractor._id,
              name: subContractor.name,
              avatar: subContractor.profilePic,
              type: 2
            };
            ganttItem.resources = [resource];
          }
        } else if (task.taskStyle === 'Worker') {
          if (vm.workers.length > 0) {
            var worker = vm.workers[0];
            var _resource = {
              id: worker._id,
              name: worker.displayName,
              groupName: worker.groupName,
              avatar: worker.profilePic,
              type: 1
            };
            ganttItem.resources = [_resource];
          }
        } else {
          if (csTask) {
            for (var i = 0; i < csTask.requiredWorkerCount; i++) {
              if (i >= csTask.workers.length) break;
              var _worker = csTask.workers[i];
              var _resource2 = {
                id: _worker._id,
                name: _worker.displayName,
                groupName: _worker.groupName,
                avatar: _worker.profilePic,
                type: 1
              };

              if (isWorkerAvailable(_resource2, ganttItem.start_date, ganttItem.end_date)) {
                ganttItem.resources.push(_resource2);
              }
            }
          }
        }
      }

      for (var _i2 = 0; _i2 < ganttItem.resources.length; _i2++) {
        var _resource3 = ganttItem.resources[_i2];

        if (_resource3.type === 1) {
          if (!timeline.resources.workers[_resource3.id]) {
            timeline.resources.workers[_resource3.id] = _resource3;
          }
        } else {
          if (!timeline.resources.subcontractors[_resource3.id]) {
            timeline.resources.subcontractors[_resource3.id] = _resource3;
          }
        }

        ganttItem.resourceIds.push(_resource3.id);
      } // group


      var workType = ganttItem.workType;
      var workLevel = ganttItem.workLevel;

      if (timeline.groups.workType) {
        if (!timeline.groups.workType[workType]) {
          timeline.groups.workType[workType] = workType;
        }
      }

      if (timeline.groups.workLevel) {
        if (!timeline.groups.workLevel[workLevel]) {
          timeline.groups.workLevel[workLevel] = workLevel;
        }
      }

      timeline.gantt.data.push(ganttItem);

      if (task.dependency) {
        ganttItem.dependency = task.dependency;
        timeline.gantt.links.push({
          id: utils.bsonId(),
          source: ganttItem.dependency,
          target: ganttItem.id,
          type: gantt.config.links.finish_to_start,
          workType: ganttItem.workType
        });
      }

      setStyle(workType);

      if (task.taskStyle === 'Subcontractor') {
        setupSubcontractorTask(ganttItem, timeline.gantt);
      }

      return ganttItem;
    }

    function taskToGantt(task) {
      var ganttItem = {
        id: task._id,
        text: task.name,
        type: gantt.config.types.task,
        description: task.description,
        workLevel: task.workLevel || '1',
        workType: task.workType || '1',
        progress: task.progress,
        delay: 0,
        calcHours: utils.num(task.calcHours),
        workedHours: utils.num(task.workedHours),
        modelId: task.modelId,
        modelType: task.modelType,
        objectId: task.objectId,
        status: utils.num(task.status),
        priority: utils.num(task.priority),
        resources: [],
        resourceIds: [],
        owner: task.owner,
        tasks: [],
        combined: task.combined,
        calcSheet: task.calcSheet,
        calcItem: task.calcItem,
        taskStyle: task.taskStyle,
        project: task.project,
        show: true
      };

      if (task.parent) {
        ganttItem.parent = task.parent;
      }

      if (task.product) {
        ganttItem.product = task.product._id;
      }

      return ganttItem;
    }

    function subTaskToGantt(task, prev) {
      var ganttItem = taskToGantt(task);

      if (task.startDate && task.endDate) {
        ganttItem.start_date = new Date(task.startDate);
        ganttItem.end_date = new Date(task.endDate);
      }

      if (prev && ganttItem.start_date && ganttItem.end_date && prev.start_date && prev.end_date) {
        var start = ganttItem.start_date.getTime() - prev.start_date.getTime();
        var length = prev.end_date.getTime() - prev.start_date.getTime();
        ganttItem.percentage = length === 0 ? 100 : Math.min(100, Math.ceil(start * 100 / length));
      } else {
        ganttItem.percentage = 0;
      }

      if (task.resources && task.resources.length > 0) {
        ganttItem.resources = [];
        task.resources.forEach(function (res) {
          if (res.worker) {
            ganttItem.resources.push({
              id: res.worker._id,
              name: res.worker.name || res.worker.displayName,
              avatar: res.worker.profilePic,
              type: res.workerType === 'Employee' ? 1 : 2
            });
          }
        });
      }

      return ganttItem;
    }

    function setupSubcontractorTask(task, ganttData) {
      var duration = task.calcHours * 3600000;
      var divider = 250 * 3600000; // 250 hours

      if (duration <= divider) return;
      var date = task.start_date;

      do {
        var ganttItem = angular.copy(task);
        var taskDuration = duration > divider ? divider : duration;
        ganttItem.id = utils.bsonId();
        ganttItem.start_date = new Date(date);
        ganttItem.end_date = new Date(date.getTime() + taskDuration);
        ganttItem.parent = task.id;
        ganttItem.composeState = 'sub-child';
        date = ganttItem.end_date;
        duration -= divider;
        ganttData.data.push(ganttItem);
        ganttData.links.push({
          id: utils.bsonId(),
          source: task.id,
          target: ganttItem.id,
          type: gantt.config.links.start_to_start,
          workType: ganttItem.workType
        });
      } while (duration > 0);
    }

    function setStyle(workType) {
      if (angular.isUndefined(vm.styles[workType])) {
        vm.styles[workType] = styleIndex;
        styleIndex++;
      }
    }

    function getTaskDates(begin, duration) {
      var date = new Date(begin);
      var availableHourFrom = str2hhss('10:00');
      var availableHourTo = str2hhss('18:00');
      var availableWeekdayFrom = 1;
      var availableWeekdayTo = 5;
      var startTimeValue = getHourMinMillis(date);

      if (startTimeValue < availableHourFrom.millisecs) {
        date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
      } else if (startTimeValue > availableHourTo.millisecs) {
        date.setDate(date.getDate() + 1);
        date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
      }

      considerWeekday(date, availableWeekdayFrom, availableWeekdayTo, availableHourFrom);
      var startTime = new Date(date);
      var firstAvailableDuration = availableHourTo.millisecs - getHourMinMillis(date);
      var availableDuration = availableHourTo.millisecs - availableHourFrom.millisecs;

      if (duration <= firstAvailableDuration) {
        date.setTime(date.getTime() + duration);
      } else {
        date.setDate(date.getDate() + 1);
        date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
        considerWeekday(date, availableWeekdayFrom, availableWeekdayTo, availableHourFrom);
        duration -= firstAvailableDuration;
        var dayCount = Math.floor(duration / availableDuration); // day count

        if (dayCount > 0) {
          addWorkDays(date, dayCount);
          date.setHours(availableHourFrom.hours, availableHourFrom.minutes, 0, 1);
          considerWeekday(date, availableWeekdayFrom, availableWeekdayTo, availableHourFrom);
        }

        var remained = duration - availableDuration * dayCount;

        if (remained > 0) {
          date.setTime(date.getTime() + remained);
        }
      }

      var endTime = date;
      vm.holidays.forEach(function (holiday) {
        var holiday_startDate = new Date(holiday.startDate);
        var holiday_endDate = new Date(holiday.endDate);

        if (startTime < holiday_startDate) {
          var holiDuration = holiday_endDate - holiday_startDate;
          endTime = new Date(endTime.getTime() + holiDuration);
        }
      });
      return {
        start: startTime,
        end: endTime
      };
    }

    function str2hhss(str) {
      var a = str.split(':'); // split it at the colons
      // minutes are worth 60 seconds. Hours are worth 60 minutes.

      var millisecs = (+a[0] * 60 + +a[1]) * 60000;
      return {
        hours: +a[0],
        minutes: +a[1],
        millisecs: millisecs
      };
    }

    function getHourMinMillis(date) {
      var hour = date.getHours();
      var minutes = date.getMinutes();
      return (hour * 60 + minutes) * 60000;
    }

    function considerWeekday(date, weekFrom, weekTo, hourFrom) {
      var weekday = date.getDay();

      if (weekday < weekFrom) {
        var gap = weekFrom - weekday;
        date.setDate(date.getDate() + gap);
        date.setHours(hourFrom.hours, hourFrom.minutes, 0, 1);
      } else if (weekday > weekTo) {
        var _gap = 7 - weekday + weekFrom;

        date.setDate(date.getDate() + _gap);
        date.setHours(hourFrom.hours, hourFrom.minutes, 0, 1);
      }
    }

    function addWorkDays(date, days) {
      var weekday = date.getDay();
      var daysToAdd = parseInt(days); // If the current day is Sunday add one day

      if (weekday === 0) daysToAdd++; // If the start date plus the additional days falls on or after the closest Saturday calculate weekends

      if (weekday + daysToAdd >= 6) {
        //Subtract days in current working week from work days
        var remainingWorkDays = daysToAdd - (5 - weekday); //Add current working week's weekend

        daysToAdd += 2;

        if (remainingWorkDays > 5) {
          //Add two days for each working week by calculating how many weeks are included
          daysToAdd += 2 * Math.floor(remainingWorkDays / 5); //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks

          if (remainingWorkDays % 5 === 0) daysToAdd -= 2;
        }
      }

      date.setDate(date.getDate() + daysToAdd);
      return date;
    }

    function isWorkerAvailable(resource, startDate, endDate) {
      startDate = new Date(startDate);
      endDate = new Date(endDate);
      var end = new Date(startDate);
      end.setHours(23, 59, 59, 999);

      if (endDate <= end) {
        // it's one day
        return getHoursOnDay(resource, startDate, end) > 0;
      } else {
        var hour = 0;
        var start = startDate;

        while (start <= endDate) {
          hour += getHoursOnDay(resource, start, end);
          start.setDate(start.getDate() + 1);
          start.setHours(0, 0, 0, 0);
          end = new Date(start);
          end.setHours(23, 59, 59, 999);

          if (end.getTime() > endDate.getTime()) {
            end = endDate;
          }
        }

        return hour > 0;
      }
    }

    function getWorkableHours(resource, startTime, endTime, tasks) {
      var start = new Date(startTime);
      var end = new Date(endTime); //get available hour

      end.setTime(end.getTime() - 1000);
      var duration = (end - start) / 3600000;

      if (duration <= 24) {
        // it's small than one day
        return getHoursOnDay(resource, start, end, tasks);
      } else {
        var date = new Date(start);
        var hours = 0;
        var endDate = new Date();

        while (date.getTime() < end.getTime()) {
          endDate.setTime(date.getTime());
          endDate.setHours(23, 59, 59, 0);

          if (endDate.getTime() > end.getTime()) {
            endDate = end;
          }

          hours += getHoursOnDay(resource, date, endDate, tasks);
          date.setTime(date.getTime() + 24 * 3600000);
        }

        return hours;
      }
    }

    function getHoursOnDay(resource, start, end, tasks) {
      var weekday = start.getDay();

      if (weekday === 6 || weekday === 0) {
        return 0;
      }

      var hrsWItem = getHrsWItem(resource, weekday);

      if (hrsWItem) {
        if (weekday >= hrsWItem.startWeekday && weekday <= hrsWItem.endWeekday) {
          var startTime = new Date(start);
          var endTime = new Date(end);
          var time = new Date(hrsWItem.startTime);
          startTime.setHours(time.getHours(), time.getMinutes(), 0, 0);
          time = new Date(hrsWItem.endTime);
          endTime.setHours(time.getHours(), time.getMinutes(), 0, 0);
          return getHoursFromTasksOnDay(tasks, startTime, endTime);
        }

        return 0;
      }

      if (resource.type === 2) {
        return Math.min(8, end - start);
      } else {
        var workerSetting = getWorkerSetting(resource, weekday);

        if (workerSetting && workerSetting.dailyHours) {
          var _startTime = new Date(start);

          var _endTime = new Date(end);

          var _time = utils.getTimeFromString(workerSetting.start);

          _startTime.setHours(_time.hour, _time.minute, 0, 0);

          _time = utils.getTimeFromString(workerSetting.stop);

          _endTime.setHours(_time.hour, _time.minute, 0, 0);

          return getHoursFromTasksOnDay(tasks, _startTime, _endTime, workerSetting.dailyHours);
        }

        return 0;
      }
    }

    function getHrsWItem(resource) {
      var item = undefined;

      if (vm.hrswItems) {
        item = vm.hrswItems.find(function (x) {
          return x.worker === resource.id;
        });

        if (!item) {
          item = vm.hrswItems.find(function (x) {
            return x.worker === 'all';
          });
        }
      }

      return item;
    }

    function getWorkerSetting(resource, weekday) {
      if (resource.type === 1) {
        var worker = vm.workers.find(function (x) {
          return x._id === resource.id;
        });

        if (worker && worker.employeeSettingId) {
          var workingTimes = worker.employeeSettingId.workingTimes;

          if (workingTimes) {
            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            return workingTimes.find(function (it) {
              return it.day === days[weekday];
            });
          }
        }
      }

      return undefined;
    }

    function getHoursFromTasksOnDay(tasks, start, end, maxHour) {
      var hours = (end - start) / 3600000;

      if (tasks) {
        var total = 0;
        tasks.forEach(function (task) {
          var duration = hours;

          if (start < task.start_date && task.start_date < end) {
            duration -= (task.start_date - start) / 3600000;
          }

          if (task.end_date < end && task.end_date > start) {
            duration -= (end - task.end_date) / 3600000;
          }

          if (angular.isDefined(maxHour)) {
            duration = Math.min(maxHour, duration);
          }

          total += duration;
        });
        hours = angular.isDefined(maxHour) ? Math.min(maxHour, total) : total;
      } else {
        if (angular.isDefined(maxHour)) {
          hours = Math.min(maxHour, hours);
        }
      }

      hours = Math.min(8, hours);
      return hours;
    }

    var sumReducer = function sumReducer(accumulator, currentValue) {
      return accumulator + currentValue;
    };

    function getPattern(arr) {
      var typeOrderList = [];
      arr.forEach(function (items) {
        typeOrderList.push(items.map(function (x) {
          return x.typeName;
        }).join(','));
      });
      var matchList = [];
      typeOrderList.forEach(function (typeOrder, index) {
        if (typeOrderList.filter(function (x) {
          return x === typeOrder;
        }).length > MINT_MATCH_WORKPATTERNS_COUNT) {
          matchList.push(arr[index]);
        }
      });

      if (!utils.isEmpty(matchList)) {
        matchList.forEach(function (items) {
          for (var i = 0; i < items.length; i++) {
            var item = items[i];

            if (i === 0) {
              item.percentage = 0;
            } else {
              var percentage = 100;
              var prevItem = items[i - 1];
              var periodTime = new Date(prevItem.endDate).getTime() - new Date(prevItem.startDate).getTime();
              var movedTime = new Date(prevItem.endDate).getTime() - new Date(item.startDate).getTime();

              if (movedTime > 0) {
                percentage = Math.ceil(movedTime / periodTime * 100);
                if (percentage > 100) percentage = 100;
              }

              item.percentage = percentage;
            }
          }
        });
        var pattern = matchList[0];
        pattern.forEach(function (item, index) {
          delete item._id;
          delete item.startDate;
          delete item.endDate;
          item.tagName = item.typeName;
          delete item.typeName;
          item.tagId = vm.workPattern.items[index].tagId;
          var percentageList = [];
          matchList.forEach(function (items) {
            percentageList.push(items[index].percentage);
          });
          item.percentage = Math.ceil(percentageList.reduce(sumReducer) / matchList.length);
        });
        return pattern;
      }

      return undefined;
    }

    function updateWorkPattern() {
      if (!utils.isEmpty(vm.workPattern)) {
        var levels = {};
        gantt.eachTask(function (task) {
          if (task.type === gantt.config.types.task) {
            if (utils.isEmpty(levels[task.workLevel])) {
              levels[task.workLevel] = {};
              levels[task.workLevel][task.workType] = [task];
            } else if (utils.isEmpty(levels[task.workLevel][task.workType])) {
              levels[task.workLevel][task.workType] = [task];
            } else {
              levels[task.workLevel][task.workType].push(task);
            }
          }
        });
        var levelList = [];
        Object.values(levels).forEach(function (level) {
          if (Object.keys(level).length === vm.workPattern.items.length) {
            var _level = [];
            vm.workPattern.items.forEach(function (type) {
              var items = level[type.tagName];
              items.sort(function (a, b) {
                return a.start_date.getTime() - b.start_date.getTime();
              });
              var startDate = items[0].start_date.toJSON();
              var endDate = items[items.length - 1].end_date.toJSON();
              var _type = {
                typeName: type.tagName,
                startDate: startDate,
                endDate: endDate
              };

              _level.push(_type);
            });
            levelList.push(_level);
          }
        });

        if (!utils.isEmpty(levelList)) {
          var payload = levelList.map(function (items) {
            return {
              projectId: vm.project._id,
              items: items,
              used: false
            };
          });
          $scope.updating = true;
          apiFactory.createTimelineWorkPatterns(payload).then(function (res) {
            $scope.updating = false;
            vm.timelineWorkPatterns = vm.timelineWorkPatterns.concat(res.data.list);
            Notification.success('Saved a new temporary work pattern to cache. It doesn\'t affect work pattern updates yet.');

            if (vm.timelineWorkPatterns.length >= FETCH_WORKPATTERNS_COUNT) {
              var pattern = getPattern(vm.timelineWorkPatterns.map(function (x) {
                return x.items;
              }).concat(levelList));

              if (angular.isDefined(pattern)) {
                payload = {
                  tagId: vm.workPattern.tagId,
                  items: pattern
                };
                $scope.updating = true;
                Promise.all([apiFactory.updateWorkPattern(payload), apiFactory.markAsUsedWorkPatterns(vm.project._id)]).then(function (res) {
                  $scope.updating = false;
                  vm.workPattern = res[0].data.data;
                  vm.timelineWorkPatterns = [];
                  Notification.success('Updated work pattern successfully.');
                })["catch"](function () {
                  return $scope.updating = false;
                });
              }
            }
          })["catch"](function () {
            return $scope.updating = false;
          });
        }
      }
    }

    function saveTimeline() {
      return new Promise(function (resolve, reject) {
        if (vm.isAllProject) {
          var projects = [];
          gantt.eachTask(function (task) {
            projects.push({
              id: task.id,
              startDate: task.start_date.toJSON(),
              endDate: task.end_date.toJSON()
            });
          });
          apiFactory.updateProjectsDuration({
            projects: projects
          }).then(function () {
            Notification.success("Timeline data is saved.");
            vm.isEdited = false;
            resolve();
          })["catch"](function (e) {
            $log.error(e);
            Notification.error("Error is occurred during synchronize data.");
            reject();
          });
        } else {
          if (vm.isMainEstimate) {
            var tasks = [];
            gantt.eachTask(function (task) {
              if (task.type === gantt.config.types.task) {
                var timelineTask = task;
                timelineTask.startDate = timelineTask.start_date;
                timelineTask.endDate = timelineTask.end_date;
                tasks.push(timelineTask);
              }
            });
            apiFactory.saveTimelineExtra({
              projectId: vm.project._id,
              tasks: tasks
            }).then(function () {
              Notification.success("Timeline data is saved.");
              if (resolve) resolve();
            })["catch"](function (e) {
              $log.error(e);
              Notification.error("Error is occurred during synchronize data.");
              if (reject) reject(e);
            });
          } else {
            if (angular.isUndefined(vm.timeline)) {
              if (reject) reject();
              return;
            }

            var groups = [];
            var timelineTasks = [];
            gantt.eachTask(function (task) {
              var index = gantt.getGlobalTaskIndex(task.id);

              if (task.type === gantt.config.types.task) {
                var timelineTask = makeTimelineTask(task);

                if (task.composeState === 'combined') {
                  task.tasks.forEach(function (subTask) {
                    timelineTask.tasks.push(subTask.id);
                    timelineTasks.push(makeTimelineTask(subTask));
                  });
                }

                timelineTask.order = index;
                timelineTasks.push(timelineTask);
              } else {
                groups.push({
                  _id: task.id,
                  order: index
                });
              }
            });
            var resources = [];

            for (var i = 2; i < vm.resourceData.length; i++) {
              resources.push({
                worker: vm.resourceData[i].id,
                workerType: vm.resourceData[i].parent === 1 ? 'Employee' : 'Subcontractor'
              });
            }

            apiFactory.saveTimeline({
              projectId: vm.project._id,
              groups: groups,
              tasks: timelineTasks,
              progress: $scope.totalProgress,
              resources: resources
            }).then(function () {
              Notification.success("Timeline data is saved.");
              vm.isEdited = false;
              $scope.refreshFlowline = true;
              if (resolve) resolve();
            })["catch"](function (e) {
              $log.error(e);
              Notification.error("Error is occurred during synchronize data.");
              if (reject) reject(e);
            });
          }
        }
      });
    }

    function makeTimelineTask(ganttTask) {
      var timelineTask = {
        _id: ganttTask.id,
        name: ganttTask.text,
        description: ganttTask.description,
        startDate: ganttTask.start_date,
        endDate: ganttTask.end_date,
        parent: ganttTask.parent,
        dependency: ganttTask.dependency,
        workLevel: ganttTask.workLevel,
        workType: ganttTask.workType,
        progress: ganttTask.progress,
        calcHours: ganttTask.calcHours,
        workedHours: ganttTask.workedHours,
        modelId: ganttTask.modelId,
        modelType: ganttTask.modelType,
        objectId: ganttTask.objectId,
        status: ganttTask.status,
        priority: ganttTask.priority,
        resources: [],
        requiredWorkerCount: ganttTask.requiredWorkerCount,
        owner: ganttTask.owner ? ganttTask.owner._id : vm.user._id,
        tasks: [],
        combined: ganttTask.combined,
        calcSheet: ganttTask.calcSheet,
        calcItem: ganttTask.calcItem,
        project: vm.project._id,
        product: ganttTask.product,
        productType: ganttTask.productType,
        taskStyle: ganttTask.taskStyle,
        group: ganttTask.group
      };
      timelineTask.resources = ganttTask.resources.map(function (res) {
        return {
          worker: res.id,
          workerType: res.type === 1 ? 'Employee' : 'Subcontractor'
        };
      });
      return timelineTask;
    }

    function loadCurrentResources(task) {
      var curResources = [];
      var workerCount = 0;
      var subContractorCount = 0;

      if (task.resources) {
        task.resources.forEach(function (resource) {
          if (resource.type === 1) {
            curResources.push({
              id: resource.id,
              text: resource.name,
              groupName: resource.groupName,
              avatar: resource.avatar,
              parent: 1
            });
            workerCount++;
          } else {
            curResources.push({
              id: resource.id,
              text: resource.name,
              groupName: '',
              avatar: resource.avatar,
              parent: 2
            });
            subContractorCount++;
          }
        });
      }

      curResources.unshift({
        id: 2,
        text: "Sub Contractors (".concat(subContractorCount, ")"),
        type: gantt.config.types.project
      });
      curResources.unshift({
        id: 1,
        text: "Workers (".concat(workerCount, ")"),
        type: gantt.config.types.project
      });
      vm.currentResources = curResources;
    }

    function selectTask(task) {
      if (task.modelId && task.modelType) {
        vm.modelViewer = {
          modelType: task.modelType,
          modelId: task.modelId,
          objectId: task.objectId
        };
        $timeout(function () {
          return $scope.$apply();
        });
        return true;
      }

      return false;
    }

    function updateTaskDelay(task) {
      if (task.status !== 3) {
        var progress = utils.progressOfDate(task.start_date, task.end_date, new Date(), true);

        if (task.progress < progress) {
          task.status = 4;
          task.delay = progress - task.progress;
        } else {
          task.status = 1;
          task.delay = 0;
        }
      }
    }

    function refreshWorkersToTimeline() {
      gantt.eachTask(function (task) {
        if (task.type !== gantt.config.types.task) return;

        if (task.resources) {
          for (var i = task.resources.length; i >= 0; i--) {
            var resource = task.resources[i];

            if (!isWorkerAvailable(resource, task.start_date, task.end_date)) {
              task.resources.splice(i, 1);
            }
          }

          task.resourceIds = [];
          task.resources.forEach(function (x) {
            return task.resourceIds.push(x.id);
          });
        }
      });
      gantt.refreshData();
    }

    function combineAuto() {
      var taskMap = {};
      gantt.eachTask(function (task) {
        if (task.type !== gantt.config.types.task || task.composeState === 'combined' || !task.product) return;
        var key = (task.parent ? task.parent : 'root') + '-' + task.product;
        var items = taskMap[key];

        if (!items) {
          items = [];
          taskMap[key] = items;
        }

        items.push(task);
      });
      gantt.batchUpdate(function () {
        for (var key in taskMap) {
          var items = taskMap[key];
          if (!items || items.length < 2) continue;
          combineOne(items);
        }
      });
    }

    function combineOne(tasks) {
      var resources = [];
      var ids = [];
      var startDate = undefined,
          endDate = undefined;
      var start = 0,
          end = 0;
      var progress = 0;
      var delay = 0;
      var status = 0;
      var calcHours = 0;
      var workedHours = 0;
      var modelId = undefined,
          modelType = undefined,
          objectId = undefined;
      var requiredWorkerCount = 0;

      for (var i = 0; i < tasks.length; i++) {
        tasks[i].percentage = 50;

        if (tasks[i].resources) {
          tasks[i].resources.forEach(function (r) {
            if (resources.findIndex(function (x) {
              return x.id === r.id;
            }) === -1) {
              resources.push(r);
              ids.push(r.id);
            }
          });
        }

        if (i === 0) {
          startDate = tasks[0].start_date;
          endDate = new Date(tasks[0].end_date);
          start = startDate.getTime();
          end = endDate.getTime();
        } else {
          var percentage = 0.5;
          start += (end - start) * percentage;
          end = start + tasks[i].end_date.getTime() - tasks[i].start_date.getTime();

          if (endDate.getTime() < end) {
            endDate.setTime(end);
          }
        }

        progress += utils.num(tasks[i].progress);
        delay += utils.num(tasks[i].delay);
        calcHours += utils.num(tasks[i].calcHours);
        workedHours += utils.num(tasks[i].workedHours);
        tasks[i].combined = true;

        if (tasks[i].modelId && tasks[i].modelType) {
          modelId = tasks[i].modelId;
          modelType = tasks[i].modelType;
          objectId = tasks[i].objectId;
        }

        if (tasks[i].requiredWorkerCount > requiredWorkerCount) {
          requiredWorkerCount = tasks[i].requiredWorkerCount;
        }

        if (tasks[i].status === 4) {
          status = 4;
        }
      }

      var timelineItem = {
        id: utils.bsonId(),
        text: tasks[0].text,
        description: tasks[0].description,
        type: gantt.config.types.task,
        start_date: startDate,
        end_date: endDate,
        parent: tasks[0].parent,
        resources: resources,
        resourceIds: ids,
        composeState: 'combined',
        tasks: tasks,
        progress: progress / tasks.length,
        delay: delay / tasks.length,
        calcHours: calcHours,
        workedHours: workedHours,
        workType: tasks[0].workType,
        workLevel: tasks[0].workLevel,
        status: status,
        modelId: modelId,
        modelType: modelType,
        objectId: objectId,
        requiredWorkerCount: requiredWorkerCount
      };

      for (var _i3 = 0; _i3 < tasks.length; _i3++) {
        tasks[_i3].group = timelineItem.id;
        gantt.deleteTask(tasks[_i3].id);
      }

      gantt.addTask(timelineItem);
    }

    function showAnyModel() {
      var timeline = vm.ganttData.data || [];

      for (var i = 0; i < timeline.length; i++) {
        var task = timeline[i];

        if (task.modelId && task.modelType) {
          vm.modelViewer = {
            modelType: task.modelType,
            modelId: task.modelId,
            objectId: task.objectId
          };
          $timeout(function () {
            return $scope.$apply();
          });
          return;
        }
      }
    }
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.settings').config(routerConfig);
  /** @ngInject */

  function routerConfig($stateProvider) {
    $stateProvider.state('settings', {
      url: '/settings',
      component: 'settings'
    }).state('settingsGeneral', {
      url: '/general',
      views: {
        'settingscontent@settings': {
          component: 'settingsGeneral'
        }
      },
      parent: 'settings'
    }).state('entityKeys', {
      url: '/entity-keys',
      views: {
        'settingscontent@settings': {
          component: 'entityKeys'
        }
      },
      parent: 'settings'
    }).state('calculationSetting', {
      url: '/calculation',
      views: {
        'settingscontent@settings': {
          component: 'calculationSetting'
        }
      },
      parent: 'settings'
    }).state('companyInfo', {
      url: '/companyInfo',
      views: {
        'settingscontent@settings': {
          component: 'companyInfo'
        }
      },
      parent: 'settings'
    }).state('settingEconomics', {
      url: '/economics',
      views: {
        'settingscontent@settings': {
          component: 'companyEconomic'
        }
      },
      parent: 'settings'
    }).state('externalEconomics', {
      url: '/external-economics',
      views: {
        'settingscontent@settings': {
          component: 'externalEconomic'
        }
      },
      parent: 'settings'
    }).state('integrationLogs', {
      url: '/integration-logs',
      views: {
        'settingscontent@settings': {
          component: 'integrationLogs'
        }
      },
      parent: 'settings'
    }).state('billApprovers', {
      url: '/billApprovers',
      views: {
        'settingscontent@settings': {
          component: 'billApprovers'
        }
      },
      parent: 'settings'
    }).state('paymentTerms', {
      url: '/paymentTerms',
      views: {
        'settingscontent@settings': {
          component: 'paymentTerms'
        }
      },
      parent: 'settings'
    }).state('settingEmployees', {
      url: '/employees',
      views: {
        'settingscontent@settings': {
          component: 'companyEmployee'
        }
      },
      parent: 'settings'
    }).state('settingCtrlPlan', {
      url: '/control-plan',
      views: {
        'settingscontent@settings': {
          component: 'settingCtrlPlan'
        }
      },
      parent: 'settings'
    }).state('systemTags', {
      url: '/systemTags',
      views: {
        'settingscontent@settings': {
          component: 'systemTags'
        }
      },
      parent: 'settings'
    }).state('companyRoles', {
      url: '/company-role',
      views: {
        'settingscontent@settings': {
          component: 'companyRoles'
        }
      },
      parent: 'settings'
    }).state('accessSettings', {
      url: '/access',
      views: {
        'settingscontent@settings': {
          component: 'accessSettings'
        }
      },
      parent: 'settings'
    }).state('manageSettings', {
      url: '/manage',
      views: {
        'settingscontent@settings': {
          component: 'manageSettings'
        }
      },
      parent: 'settings'
    }).state('warehouses', {
      url: '/warehouses',
      views: {
        'settingscontent@settings': {
          component: 'warehouses'
        }
      },
      parent: 'settings'
    }).state('segments', {
      url: '/segments',
      views: {
        'settingscontent@settings': {
          component: 'segments'
        }
      },
      parent: 'settings'
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.settings').component('settings', {
    controller: settingsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/settings/settings.view.html'
  });
  /** @ngInject */

  function settingsController($scope, $state, globals, localStorageService) {
    var userStore = globals.userStore,
        companyStore = globals.companyStore;
    $scope.userData = userStore.get();
    $scope.companyData = companyStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute($scope.userData));
    };

    $scope.navName = ['General', 'Entity Keys', 'Calculation', 'Economics', 'Company Information', 'Bill Approvers', 'Payment Terms', 'Employees', 'Control Plan', 'System Tags', 'Company Roles', 'Access', 'Warehouses', 'Segments'];

    function onInit() {
      $scope.navNum = localStorageService.get('settingsNavNum') || 0;
      $scope.selPage($scope.navNum);
    }

    $scope.selPage = function (index) {
      $scope.navNum = index;
      localStorageService.set('settingsNavNum', index);

      switch ($scope.navNum) {
        case 0:
          $state.go('settingsGeneral');
          break;

        case 1:
          $state.go('entityKeys');
          break;

        case 2:
          $state.go('calculationSetting');
          break;

        case 3:
          $state.go('settingEconomics');
          break;

        case 4:
          $state.go('companyInfo');
          break;

        case 5:
          $state.go('billApprovers');
          break;

        case 6:
          $state.go('paymentTerms');
          break;

        case 7:
          $state.go('settingEmployees');
          break;

        case 8:
          $state.go('settingCtrlPlan');
          break;

        case 9:
          $state.go('systemTags');
          break;

        case 10:
          $state.go('companyRoles');
          break;

        case 11:
          $state.go('accessSettings');
          break;

        case 12:
          $state.go('warehouses');
          break;

        case 13:
          $state.go('segments');
          break;

        default:
          $state.go('settingsGeneral');
          break;
      }
    };

    onInit();
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('notifications', {
    controller: NotificationsController,
    controllerAs: 'vm',
    templateUrl: 'app/main/notifications/notifications.view.html'
  });
  /** @ngInject */

  function NotificationsController($scope, $log, $state, apiFactory, Notification, globals, $uibModal, utils) {
    var vm = this;
    vm.utils = utils;
    var userStore = globals.userStore,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get();
    vm.userData = userStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    var companyData = companyStore.get();
    vm.companyInputMethod = companyData ? companyData.companyInputMethod : 'European et al.';
    vm.pdfViewing = false;
    vm.variationOrder = undefined;
    $scope.totalCount = 0;
    $scope.numPerPage = 10;
    $scope.noOfPages = 0;
    vm.currentPage = 1;

    vm.fetchNotificationData = function () {
      $scope.isLoading = true;
      apiFactory.getNotification({
        page: vm.currentPage,
        chunk: $scope.numPerPage
      }).then(function (resp) {
        vm.notifications = resp.data.data.map(function (item) {
          item.createdTime = vm.utils.getRemainingTime(item.created);
          return item;
        });
        $scope.totalCount = resp.data.totalCount;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.log(e);
      });
    };

    vm.fetchNotificationData();

    $scope.showDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.goToDetail = function (notification) {
      if (vm.utils.isEmpty(notification.route)) {
        return;
      }

      if (!notification.read) {
        apiFactory.markNotificationAsReadByIds([notification._id]).then(function () {
          if (vm.utils.isEmpty(notification.route.id)) {
            $state.go(notification.route.stateName);
          } else {
            $state.go(notification.route.stateName, {
              id: notification.route.id
            });
          }
        })["catch"](function (err) {
          Notification.error(utils.getErrorMessage(err));
        });
      } else {
        if (vm.utils.isEmpty(notification.route.id)) {
          $state.go(notification.route.stateName);
        } else {
          $state.go(notification.route.stateName, {
            id: notification.route.id
          });
        }
      }
    };

    $scope.select_all = false;

    $scope.selectAll = function () {
      $scope.select_all = !$scope.select_all;

      if ($scope.select_all) {
        var _iterator = _createForOfIteratorHelper(vm.notifications),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            item.checked = true;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _iterator2 = _createForOfIteratorHelper(vm.notifications),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            _item.checked = false;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    };

    $scope.markAsRead = function () {
      var find = vm.notifications.find(function (elem) {
        return elem.checked == true;
      });

      if (!find) {
        Notification.error("Please select one at least");
        return;
      }

      var ids = [];

      var _iterator3 = _createForOfIteratorHelper(vm.notifications),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;

          if (item.checked) {
            ids.push(item._id);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      apiFactory.markNotificationAsReadByIds(ids).then(function (resp) {
        Notification.success(resp.data.message);
        $scope.select_all = false;

        var _iterator4 = _createForOfIteratorHelper(vm.notifications),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var item = _step4.value;
            item.checked = false;
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      })["catch"](function (err) {
        Notification.error(utils.getErrorMessage(err));
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.mail').config(routerConfig);
  /** @ngInject */

  function routerConfig($stateProvider) {
    $stateProvider.state('appMail', {
      url: '/mail',
      component: 'mailComponent',
      redirectTo: 'appMailLogin'
    }).state('appMailLogin', {
      url: '/mail/login',
      component: 'mailLogin',
      resolve: {
        checkLogin: function checkLogin() {
          /*let token = localStorageService.get('mail-token');
          if (token) {
            $state.go('appMailInbox');
          } else {
            return false;
          }*/
          return false;
        }
      }
    }).state('appMailCompose', {
      url: '/compose',
      views: {
        'mailcontent@appMail': {
          component: 'mailCompose'
        }
      },
      parent: 'appMail'
    }).state('appMailInbox', {
      url: '/inbox',
      views: {
        'mailcontent@appMail': {
          component: 'mailInbox'
        }
      },
      parent: 'appMail'
    }).state('appMailStared', {
      url: '/stared',
      views: {
        'mailcontent@appMail': {
          component: 'mailStared'
        }
      },
      parent: 'appMail'
    }).state('appMailDraft', {
      url: '/draft',
      views: {
        'mailcontent@appMail': {
          component: 'mailDraft'
        }
      },
      parent: 'appMail'
    }).state('appMailTrash', {
      url: '/trash',
      views: {
        'mailcontent@appMail': {
          component: 'mailTrash1'
        }
      },
      parent: 'appMail'
    }).state('appMailSent', {
      url: '/sent',
      views: {
        'mailcontent@appMail': {
          component: 'mailSent'
        }
      },
      parent: 'appMail'
    }).state('appMailSetting', {
      url: '/setting',
      views: {
        'mailcontent@appMail': {
          component: 'mailSetting'
        }
      },
      parent: 'appMail'
    }).state('customFolders', {
      url: '/folders/:id',
      views: {
        'mailcontent@appMail': {
          component: 'mailFolders'
        }
      },
      parent: 'appMail'
    }) // Mail
    .state('appMailPersonalInfo', {
      url: '/setting',
      views: {
        'mailcontent@appMail': {
          component: 'mailSetting'
        }
      },
      parent: 'appMail'
    }).state('appMailResponse', {
      url: '/setting/response',
      views: {
        'mailcontent@appMail': {
          component: 'settingResponse'
        }
      },
      parent: 'appMail'
    });
  }
})();


"use strict";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/
(function () {
  'use strict';

  angular.module('app.mail').component('mailComponent', {
    controller: MailComponentController,
    controllerAs: 'vm',
    templateUrl: 'app/main/mail/mail.view.html'
  });
  /** @ngInject */

  function MailComponentController(globals, $scope, $rootScope, $state, $uibModal, Notification, apiFactory, localStorageService, $log, utils) {
    var projectStore = globals.projectStore,
        userStore = globals.userStore;
    var vm = this;
    vm.userData = userStore.get();
    $scope.customFoldersid = '';
    if ($state.current.url.indexOf('/folders') > -1) $scope.customFoldersid = localStorageService.get('folder_id');else localStorageService.set('folder_id');
    $scope.isPrivateHouseMenu = true;
    $scope.isHospitalMenu = false;
    $scope.unseenCount = 0;
    $scope.draftsCount = 0;
    $scope.isCollapse = false;
    vm.rootFolders = [{
      _id: '01',
      name: 'Electrical',
      color: '#D71414',
      children: []
    }, {
      _id: '02',
      name: 'Plumbing',
      color: '#F3A72E',
      children: []
    }, {
      _id: '03',
      name: 'Ventialation',
      color: '#2FA84F',
      children: []
    }, {
      _id: '04',
      name: 'Architect',
      color: '#367BF5',
      children: []
    }, {
      _id: '05',
      name: 'Mechanical',
      color: '#813AC8',
      children: []
    }];
    vm.selectedfolder = vm.rootFolders[0];
    vm.customFolders = [];
    $scope.invitedManagers = [];

    $scope.deleteFolder = function (index) {
      apiFactory.deleteCustomFolder(vm.customFolders[index]._id).then(function () {
        Notification.success("Folder Deleted");
        vm.customFolders.splice(index, 1);
      })["catch"](function (err) {
        Notification.error("Failed");
      });
    };

    $scope.addCustomFolder = function () {
      var params = {
        mode: 'create',
        managers: $scope.invitedManagers,
        foldername: '',
        tags: [],
        inviteUsers: []
      };
      $uibModal.open({
        animation: true,
        component: 'editMailFolder',
        windowClass: 'custom-folders-modal',
        resolve: {
          data: function data() {
            return params;
          }
        }
      }).result.then(function (result) {
        var folder = angular.copy(result);
        folder.projectId = vm.selectedProject._id;
        folder.createBy = vm.userData._id;
        apiFactory.createCustomFolder(folder).then(function (result1) {
          Notification.success("Folder Created");
          folder._id = result1.data.data._id;
          vm.customFolders.push(folder);
        })["catch"](function (err) {
          Notification.error("Failed");
        });
      });
    };

    $scope.goToFolders = function (folder) {
      if (folder == null) {
        $scope.customFoldersid = "";
      } else {
        $scope.customFoldersid = folder._id;
        localStorageService.set('folder_id', folder._id);
        $state.go('customFolders', {
          id: folder._id
        });
      }
    };

    $scope.editFolder = function (index) {
      var params = {
        mode: 'update',
        managers: $scope.invitedManagers,
        foldername: vm.customFolders[index].customFolderName,
        tags: vm.customFolders[index].tags,
        inviteUsers: vm.customFolders[index].inviteUsers
      };
      $uibModal.open({
        animation: true,
        component: 'editMailFolder',
        windowClass: 'custom-folders-modal',
        resolve: {
          data: function data() {
            return params;
          }
        }
      }).result.then(function (result) {
        if (params.mode == 'update') {
          var folder = vm.customFolders[index];
          folder.customFolderName = result.customFolderName;
          folder.tags = result.tags;
          folder.inviteUsers = result.inviteUsers;
          vm.isEdited = true;
          apiFactory.updateCustomFolder(folder).then(function () {
            Notification.success("Folder Updated");
          })["catch"](function (err) {
            Notification.error("Failed");
          });
        }
      });
    };

    $scope.init = function () {
      $scope.expandedIndex = 0;
      $scope.selectedSubIndex = null;
      Promise.all([apiFactory.listAllManagers(), apiFactory.getUnseenCount(), apiFactory.getDraftCount(), apiFactory.getAllCustomListByUserId(vm.userData._id)]).then(function (resp) {
        $scope.invitedManagers = resp[0].data.list;
        $scope.unseenCount = resp[1].data.data;
        $scope.draftsCount = resp[2].data.data;
        vm.customFolders = resp[3].data.list;
      });
      vm.selectedProject = projectStore.get();
    };

    $scope.init();

    $scope.initcallapsedata = function () {
      $scope.isLoading = true;
      apiFactory.getTqListByProjectId({
        projectId: vm.selectedProject._id
      }).then(function (resp) {
        $scope.isLoading = false;
        var resplist = resp.data.list;

        for (var i = 0; i < vm.rootFolders.length; i++) {
          vm.rootFolders[i].children = resplist.filter(function (el) {
            return el.discipline == vm.rootFolders[i].name;
          });
        }
      })["catch"](function (e) {
        $scope.isLoading = false;
        $log.error(e);
      });
    };

    $scope.initcallapsedata();
    $scope.$on('onProjectChanged', function () {
      vm.selectedProject = projectStore.get();
      $scope.initcallapsedata();
    });

    $scope.onExpand = function (index) {
      if ($scope.expandedIndex === index) {
        $scope.expandedIndex = null;
      } else {
        $scope.expandedIndex = index;
      } // if($scope.expandedIndex != null){
      //   apiFactory.getTqListByProjectId({
      //     projectId: vm.selectedProject._id,
      //     discipline: deiscipline
      //   })
      //     .then(resp => {
      //       vm.selectedfolder = vm.rootFolders[index];
      //       vm.selectedfolder.children = resp.data.list;
      //     })
      //     .catch(e => {
      //       $scope.isLoading = false;
      //       $log.error(e);
      //     });
      // }


      $scope.selectedSubIndex = null;
    };

    $scope.downloadTqfile = function (id) {
      apiFactory.getTqAttachList(id).then(function (resp) {
        var attachList = resp.data.list;
        var urls = attachList.map(function (x) {
          return x.filePath;
        });
        utils.downloadFiles(urls).then(function () {
          $log.log('Done downloads: ', urls);
        })["catch"](function (err) {
          $log.error(err);
          Notification.error('Files could not be found.');
        });
      })["catch"](function (e) {
        $scope.isLoading = false;
        $log.error(e);
      });
    };

    $scope.onSelectItem = function (index, key) {
      $scope.selectedSubIndex = key;
    };

    $scope.togglePrivateHouseMenu = function () {
      $scope.isPrivateHouseMenu = !$scope.isPrivateHouseMenu;
    };

    $scope.toggleHospitalMenu = function () {
      $scope.isHospitalMenu = !$scope.isHospitalMenu;
    };

    $scope.onCompose = function () {
      $rootScope.$emit('mail-compose');
    };

    $scope.collapseMenu = function () {
      $scope.isCollapse = !$scope.isCollapse;
      $rootScope.$emit('side-menu-collapse');
    };

    var reduceUnseenCount = $rootScope.$on('reduce_unseen_count', function (ev) {
      $scope.unseenCount--;
    });
    var updateDraftCount = $rootScope.$on('update_draft_count', function (ev, total) {
      $scope.draftsCount = total;
    });
    $rootScope.$on('$destroy', reduceUnseenCount, updateDraftCount);

    $scope.mailLogout = function () {
      apiFactory.mailLogout().then(function (res) {
        localStorageService.remove('mail-token');
        Notification.success("Mail Logout");
        $state.go('appMailLogin');
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error("Connection Failed");
      });
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.fileManage').config(routerConfig);
  /** @ngInject */

  function routerConfig($stateProvider) {
    $stateProvider.state('fileManage', {
      url: '/file-manage',
      component: 'fileManage',
      redirectTo: 'fileManageList'
    }).state('fileManageList', {
      url: '/list',
      views: {
        'fileManagecontent@fileManage': {
          component: 'fileManageList'
        }
      },
      parent: 'fileManage'
    }).state('hierarchyTemplates', {
      url: '/hierarchy-templates',
      views: {
        'fileManagecontent@fileManage': {
          component: 'hierarchyTemplates'
        }
      },
      parent: 'fileManageList'
    }).state('fileVersionList', {
      url: '/versions',
      views: {
        'fileManagecontent@fileManage': {
          component: 'fileVersionList'
        }
      },
      parent: 'fileManageList'
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.fileManage').component('fileManage', {
    controller: fileManageController,
    controllerAs: 'vm',
    templateUrl: 'app/main/fileManage/fileManage.view.html'
  });
  /** @ngInject */

  function fileManageController($scope, $log, globals, apiFactory, authFactory, Notification, utils, $uibModal, $state, $rootScope, $element, fileManagerFactory) {
    var logout = globals.logout,
        userStore = globals.userStore,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore;

    if (!authFactory.checkUser()) {
      logout();
      return;
    }

    var vm = this;
    vm.selectedProject = projectStore.get();
    $scope.isLoading = true;
    apiFactory.listAllProjectNames().then(function (res) {
      $scope.isLoading = false;
      vm.projectList = res.data.list; //console.log(vm.projectList);
    })["catch"](function (err) {
      $scope.isLoading = false;
      Notification.error(utils.getErrorMessage(err));
    });
    $scope.isUpload = true;
    $scope.roofPlanDiv = true;
    $scope.query = "";
    $scope.selectedTemplate = undefined;
    $scope.loading = false;
    $scope.selFiles = [];
    $scope.selFolders = [];
    vm.fileNames = [];
    vm.rootfileNames = [];
    vm.isSharedFolder = false;
    vm.userData = userStore.get();
    vm.selectedFolderType = 'project';

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.FMANAGER_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation == "Admin") {
    //   $scope.FMANAGER_ACCESS_CREATE = 4;
    // } else {
    //   $scope.loading = true;
    //   apiFactory.getAccessSettingDetails({
    //     dType,
    //     list: [Constants.AccessKey.FMANAGER]
    //   }).then(res => {
    //     $scope.loading = false;
    //     $scope.FMANAGER_ACCESS_CREATE = res.data.data[Constants.AccessKey.FMANAGER];
    //   })
    //   .catch((e) => {
    //     $scope.loading = false;
    //     $log.error(e);
    //     Notification.error('Something went wrong try later')
    //   });
    // }

    vm.companyData = companyStore.get();
    vm.companyRootFolders = [];
    vm.projectRootFolders = [];
    vm.personalRootFolders = [];
    vm.companyFolderOpened = false;
    vm.projectFolderOpened = true;
    vm.personalFolderOpened = false;
    vm.selectedFolder = {
      _id: 'project'
    };
    vm.isAvailableManageVersions = false;
    vm.isAvailableSendApproval = false;
    vm.permSettingCount = 0;

    vm.logout = function () {
      logout();
    };

    $scope.$on('change_folder_child', function (event, folder) {
      vm.selectedFolder = folder;
    });
    $scope.$on('select_root_folder', function (event, type) {
      vm.selectedFolder = {
        _id: type
      };
    });
    $scope.$on('add_root_folder', function (event, data) {
      switch (data.type) {
        case 'company':
          vm.companyRootFolders.push(data.folder);
          break;

        case 'project':
          vm.projectRootFolders.push(data.folder);
          break;

        case 'personal':
          vm.personalRootFolders.push(data.folder);
          break;
      }
    });

    $scope.selectedProject = function (project) {
      if (project._id === 'others') {
        $state.go('projectList');
      } else {
        $scope.project = angular.copy(project);
        projectStore.set(project); // $state.reload();

        vm.selectedProject = project;
        vm.getPrimaryFolders();
        $rootScope.$broadcast('selected-project', project);
      }
    };

    function searchFolder(folder, folderId) {
      if (folder._id === folderId) {
        return folder;
      } else if (!utils.isEmpty(folder.children)) {
        var result = undefined;

        for (var i = 0; angular.isUndefined(result) && i < folder.children.length; i++) {
          result = searchFolder(folder.children[i], folderId);
        }

        return result;
      }

      return undefined;
    }

    function searchParentFolder(folder, folderId) {
      if (folder.children.find(function (x) {
        return x._id === folderId;
      })) {
        return folder;
      } else if (!utils.isEmpty(folder.children)) {
        var result = undefined;

        for (var i = 0; angular.isUndefined(result) && i < folder.children.length; i++) {
          result = searchParentFolder(folder.children[i], folderId);
        }

        return result;
      }

      return undefined;
    } // $scope.selectedProject = (item) => {
    //   vm.selectedProject = item;
    // }


    $scope.$on('add_sub_folder', function (event, data) {
      for (var i = 0; i < vm.rootFolders.length; i++) {
        var rootFolder = vm.rootFolders[i];

        if (rootFolder._id !== data.type) {
          continue;
        }

        var _parentFolder = searchFolder(rootFolder, data.parentFolder._id);

        if (angular.isDefined(_parentFolder)) {
          _parentFolder.children.push(data.folder);
        }
      }
    });
    $scope.$on('rename_root_folder', function (event, data) {
      var folder;
      var rootFolders;

      switch (data.type) {
        case 'company':
          rootFolders = vm.companyRootFolders;
          break;

        case 'project':
          rootFolders = vm.projectRootFolders;
          break;

        case 'personal':
          rootFolders = vm.personalRootFolders;
          break;
      }

      folder = rootFolders.find(function (x) {
        return x._id === data.folder._id;
      });

      if (folder) {
        folder.name = data.folder.name;
      }
    });
    $scope.$on('rename_sub_folder', function (event, data) {
      for (var i = 0; i < vm.rootFolders.length; i++) {
        var rootFolder = vm.rootFolders[i];

        if (rootFolder._id !== data.type) {
          continue;
        }

        var folder = searchFolder(rootFolder, data.folder._id);

        if (angular.isDefined(folder)) {
          folder.name = data.folder.name;
        }
      }
    });
    $scope.$on('remove_folders', function (event, data) {
      var removedFolders = data.data;

      for (var i = 0; i < vm.rootFolders.length; i++) {
        var rootFolder = vm.rootFolders[i];

        var _loop = function _loop(j) {
          var removedFolder = removedFolders[j];
          var parentFolder = searchParentFolder(rootFolder, removedFolder._id);

          if (angular.isDefined(parentFolder)) {
            var index = parentFolder.children.findIndex(function (x) {
              return x._id === removedFolder._id;
            });

            if (index !== -1) {
              parentFolder.children.splice(index, 1);
            }
          }
        };

        for (var j = 0; j < removedFolders.length; j++) {
          _loop(j);
        }
      }
    });
    $scope.$on('add_permission_count', function (event, data) {
      vm.permSettingCount += data;
    });
    $scope.$on('clear_permission_count', function () {
      vm.permSettingCount = 0;
    });

    $scope.sendApproval = function () {
      $scope.$broadcast('send_approval');
    };

    $scope.manageVersions = function () {
      $scope.$broadcast("manage_versions");
    };

    function addSpecialFolder(isAdd2D, isAdd3D, isTerms) {
      var apis = [];
      var payload2D = {},
          payload3D = {},
          payloadTerms = {};

      if (isAdd2D) {
        payload2D = {
          name: '2D Plans',
          isParent: true,
          parentType: 'project',
          projectId: vm.selectedProject._id,
          is2DFolder: true
        };
        apis.push(apiFactory.addHierarchy(payload2D));
      }

      if (isAdd3D) {
        payload3D = {
          name: '3D Files',
          isParent: true,
          parentType: 'project',
          projectId: vm.selectedProject._id,
          is3DFolder: true
        };
        apis.push(apiFactory.addHierarchy(payload3D));
      }

      if (isTerms) {
        payloadTerms = {
          name: 'Terms & Conditions',
          isParent: true,
          parentType: 'company',
          projectId: vm.selectedProject._id,
          isTermsFolder: true
        };
        apis.push(apiFactory.addHierarchy(payloadTerms));
      }

      $scope.loading = true;
      Promise.all(apis).then(function () {
        $scope.loading = false;
        vm.getPrimaryFolders();
      })["catch"](function (e) {
        $scope.loading = false;
        $log.error(e);
      });
    }

    function checkSpecialFolders() {
      var promises = [apiFactory.isExistTermsHierarchy(), apiFactory.getUnNotifiedPermSettingsCount()];

      if (vm.selectedProject._id !== 'all') {
        promises = promises.concat([apiFactory.isExist2DHierarchy(vm.selectedProject._id), apiFactory.isExist3DHierarchy(vm.selectedProject._id)]);
      }

      $scope.loading = true;
      Promise.all(promises).then(function (res) {
        $scope.loading = false;
        var existTerms = res[0].data.data;
        vm.permSettingCount = res[1].data.data;
        var exist2D = true;
        var exist3D = true;

        if (res.length === 4) {
          exist2D = res[2].data.data;
          exist3D = res[3].data.data;
        }

        if (!exist2D || !exist3D || !existTerms) {
          addSpecialFolder(!exist2D, !exist3D, !existTerms);
        } else {
          vm.getPrimaryFolders();
        }
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(err.data.message || 'Something went wrong!');
        vm.getPrimaryFolders();
      });
    }

    vm.getPrimaryFolders = function () {
      var payload = {
        projectId: vm.selectedProject._id
      };
      $scope.loading = true;
      apiFactory.getRootFolders(payload).then(function (resp) {
        $scope.loading = false;
        vm.companyRootFolders = resp.data.data.company;
        vm.projectRootFolders = resp.data.data.project;
        vm.personalRootFolders = resp.data.data.personal;
        vm.rootFolders = [{
          _id: 'company',
          name: 'COMPANY',
          children: vm.companyRootFolders
        }, {
          _id: 'personal',
          name: 'PERSONAL',
          children: vm.personalRootFolders
        }];

        if (vm.selectedProject && vm.selectedProject._id !== 'all') {
          vm.rootFolders.unshift({
            _id: 'project',
            name: 'PROJECT',
            children: vm.projectRootFolders
          });
        }

        $scope.$broadcast('initialize', {});
      })["catch"](function (err) {
        $log.error(err);
        $scope.loading = false;
      });
    };

    checkSpecialFolders();
    vm.rootFolders = [];
    vm.showTree = false;
    vm.windowItems = {
      folderData: "",
      folders: [],
      files: []
    };

    $scope.selectFolder = function (folder) {
      vm.selectedFolder = folder;

      if (folder._id === 'project' || folder._id === 'company' || folder._id === 'personal') {
        $scope.$broadcast('change_folder_type', folder._id);
        vm.selectedFolderType = folder._id;
      } else {
        $scope.$broadcast("change_folder", vm.selectedFolder);
      }
    };

    vm.searchCallback = function () {//console.log(vm.searchFolderText);
    };

    vm.projectFolders = function () {
      vm.selectedFolder = {
        _id: 'project'
      };
      vm.projectFolderOpened = true;
      vm.selectedFolderType = 'project';
      $scope.$broadcast('select_root_item', 'project');
    };

    vm.companyFolders = function () {
      vm.selectedFolder = {
        _id: 'company'
      };
      vm.companyFolderOpened = true;
      vm.selectedFolderType = 'company';
      $scope.$broadcast('select_root_item', 'company');
    };

    vm.personalFolders = function () {
      vm.selectedFolder = {
        _id: 'personal'
      };
      vm.personalFolderOpened = true;
      vm.selectedFolderType = 'personal';
      $scope.$broadcast('select_root_item', 'personal');
    };
    /** drag and drop */


    vm.dragDrop = function (selFolder, selFile, selFolderType, mode) {
      $scope.selFiles = [];
      $scope.selFiles.push(selFile);
      var req = {
        folders: $scope.selFolders,
        files: $scope.selFiles,
        mode: mode
      };

      if (vm.parentFolder) {
        req.parentId = vm.parentFolder._id;
      }

      req.sourceType = selFolderType;
      vm.clipboardMode = mode;
      fileManagerFactory.clipBoard.copy(req);
      vm.parentFolder = selFolder;
      var confirmModal = $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function data() {
            return {
              title: 'Confirm move files',
              message: 'Are you sure to move files?',
              subMessage: 'Click OK button to continue',
              confirmButtonText: 'OK',
              icon: '/assets/icons/status-warning.svg'
            };
          }
        }
      });
      confirmModal.result.then(function () {
        paste();
      }, function (reason) {
        $log.info(reason);
      });
    };

    function paste() {
      var req = {
        projectId: vm.selectedProject._id
      };

      if (vm.parentFolder) {
        req.destId = vm.parentFolder._id;
      } else {
        req.rootType = vm.selectedFolderType;

        if (vm.selectedFolderType === 'project') {
          req.projectId = vm.selectedProject._id;
        }
      }

      $scope.loading = true;
      fileManagerFactory.clipBoard.paste(req).then(function () {
        $scope.loading = false;

        if (vm.clipboardMode === 1) {
          $scope.$emit('remove_folders', {
            data: fileManagerFactory.clipBoard.getBuffer().folders
          });
        }

        if (!vm.parentFolder) {
          fileManagerFactory.clipBoard.getBuffer().folders.forEach(function (folder) {
            folder.parentType = vm.selectedFolderType;
            folder.isParent = true;
            $scope.$emit('add_root_folder', {
              type: vm.selectedFolderType,
              folder: folder
            });
          });
        } else {
          fileManagerFactory.clipBoard.getBuffer().folders.forEach(function (folder) {
            folder.isParent = false;
            folder.parent = vm.parentFolder._id;
            $scope.$emit('add_sub_folder', {
              type: vm.selectedFolderType,
              folder: folder,
              parentFolder: vm.parentFolder
            });
          });
        }

        fileManagerFactory.clipBoard.emptyClipboard();
        vm.isCopyMove = false; // vm.showChildHierarchy(vm.parentFolder);

        $scope.dragDrop = null;
        $scope.selectFolder(vm.parentFolder);
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(utils.getErrorMessage(err));
      });
    }

    $scope.saveHierarchyTemplate = function () {
      $scope.loading = true;
      apiFactory.getRootFolders({
        projectId: vm.selectedProject._id
      }).then(function (resp) {
        $scope.loading = false;
        var _payload = {
          projectId: vm.selectedProject._id,
          projectHierarchies: resp.data.data.project,
          companyHierarchies: resp.data.data.company,
          personalHierarchies: resp.data.data.personal,
          description: ''
        };
        var modal = $uibModal.open({
          animation: true,
          component: 'hierarchyTemplateModal',
          windowClass: 'hierarchy-template-modal',
          resolve: {
            payload: function payload() {
              return _payload;
            }
          }
        });
        modal.result.then(function (newTemplate) {
          $scope.templates.unshift(newTemplate);
          $scope.selectedTemplate = newTemplate;
          setToLatestTemplate($scope.selectedTemplate);
        }, function (reason) {
          $log.log(reason);
        });
      })["catch"](function (err) {
        $scope.loading = false;
        $log.error(err);
      });
    };

    function setToLatestTemplate(template) {
      $scope.loading = true;
      apiFactory.updateHierarchyTreeToLatest(template).then(function (res) {
        $scope.loading = false;
        Notification.success(res.data.message || 'Set to latest version successfully');
        template.updatedAt = res.data.data.updatedAt;
        $scope.templates.sort(function (a, b) {
          var aVal = new Date(a.updatedAt);
          var bVal = new Date(b.updatedAt);

          if (aVal < bVal) {
            return 1;
          } else if (aVal > bVal) {
            return -1;
          } else {
            return 0;
          }
        });
      })["catch"](function (err) {
        Notification.error(err.data.message || 'Failed to set to latest version');
      });
    }

    $scope.selectTemplate = function (template) {
      $scope.selectedTemplate = template;
      setToLatestTemplate(template);
    };

    function loadHierarchyTemplates() {
      $scope.loading = true;
      apiFactory.getHierarchyTemplates(vm.companyData._id).then(function (res) {
        $scope.loading = false;
        $scope.templates = res.data.list;
        $scope.selectedTemplate = $scope.templates[0];
      })["catch"](function (err) {
        $scope.loading = false;
        Notification.error(err.data.message || 'Could not be load hierarchy templates.');
      });
    }

    loadHierarchyTemplates();

    function getDragDropFolder(selFolders, folderId) {
      var dragDropFolder = selFolders.find(function (b) {
        return b._id == folderId;
      });

      if (angular.isDefined(dragDropFolder) && !angular.equals(dragDropFolder, {})) {
        $scope.dragDrop = dragDropFolder;
      } else {
        selFolders.forEach(function (selFolder) {
          if (selFolder.children.length) {
            getDragDropFolder(selFolder.children, folderId);
          } else return;
        });
      }
    }
    /** drag and drop */


    $element.on('dragover', function (event) {
      event.preventDefault();
    });
    $element.on('dragenter', function (event) {
      if (event.target.getAttribute('drag') == 'drop-zone') {
        event.target.style.border = 'dashed 1px #E8E8E8';
      }
    });
    $element.on('dragleave', function (event) {
      if (event.target.getAttribute('class') && event.target.getAttribute('class').indexOf('angular-ui-tree-handle') !== -1) {
        event.target.style.border = 'none';
      } else {
        event.target.style.background = '';
      }
    });
    $element.on('drop', function (event) {
      event.preventDefault();

      if (event.target.getAttribute('drag') == 'drop-zone') {
        if (event.target.getAttribute('class').indexOf('angular-ui-tree-handle') !== -1) {
          event.target.style.border = 'none';
        } else {
          event.target.style.background = '';
        }

        var folderId = event.target.getAttribute('drag-id');
        var folderType = event.target.getAttribute('drag-type'); // var selFolder = vm.projectRootFolders.find(b => b._id == folderId) ? vm.projectRootFolders.find(b => b._id == folderId) : (vm.companyRootFolders.find(b => b._id == folderId) ? vm.companyRootFolders.find(b => b._id == folderId) : (vm.personalRootFolders.find(b => b._id == folderId) ? vm.personalRootFolders.find(b => b._id == folderId) : {}));

        getDragDropFolder(vm.projectRootFolders, folderId);
        var selFolder = $scope.dragDrop;

        if (angular.isUndefined(selFolder) || selFolder == null) {
          getDragDropFolder(vm.companyRootFolders, folderId);
          selFolder = $scope.dragDrop;
        }

        if (angular.isUndefined(selFolder) || selFolder == null) {
          getDragDropFolder(vm.personalRootFolders, folderId);
          selFolder = $scope.dragDrop;
        }

        $log.log(selFolder, 'aaa');

        if (angular.isDefined(0) && !angular.equals(selFolder, {})) {
          vm.dragDrop(selFolder, $scope.selectedVendor, folderType, 1);
          $scope.$apply();
        } else {
          if (!$scope.selectedFolder) {
            var confirmModal = $uibModal.open({
              animation: true,
              component: 'confirmModal',
              size: 'sm',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                data: function data() {
                  return {
                    title: 'warning',
                    message: 'Cannot move file to selected folder.',
                    subMessage: 'Please select the correct folder.',
                    confirmButtonText: 'OK',
                    icon: '/assets/icons/status-warning.svg'
                  };
                }
              }
            });
            confirmModal.result.then(function () {
              $scope.selectedFolder = null;
            }, function (reason) {
              $log.info(reason);
              $scope.selectedFolder = null;
            });
          } else {
            $scope.selectedFolder = null;
          }
        }
      }

      $scope.selectedVendor = null;
    });
    var selectedFile = $scope.$on('selected-file', function (event, data) {
      $scope.selectedVendor = data;
    });
    var selectedFolder = $scope.$on('selected-folder', function (event, data) {
      $scope.selectedFolder = data;
    });
    var parentFolder = $scope.$on('parent-folder', function (event, data) {
      vm.parentFolder = data;
    });
    $rootScope.$on('$destroy', selectedFile, selectedFolder, parentFolder);
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('checkList', {
    controller: checkListController,
    controllerAs: 'vm',
    templateUrl: 'app/main/checkList/checkList.view.html'
  });
  /** @ngInject */

  function checkListController($scope, apiFactory, Notification, utils, globals, $log, $uibModal, $state) {
    var vm = this;
    var userStore = globals.userStore,
        projectStore = globals.projectStore;
    vm.userData = userStore.get();
    vm.projectData = projectStore.get();

    $scope.goDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.CHKLIST_ACCESS_CREATE = 100; // let dType = globals.getDashboardType(vm.userData);
    // if (vm.userData.designation === "Admin") {
    //   $scope.CHKLIST_ACCESS_CREATE = 4;
    // } else {
    //   $scope.isLoading = true;
    //   apiFactory.getAccessSettingDetails({dType, list: [Constants.AccessKey.CHKLIST]})
    //     .then(res => {
    //       $scope.isLoading = false;
    //       $scope.CHKLIST_ACCESS_CREATE = res.data.data[Constants.AccessKey.CHKLIST];
    //     })
    //     .catch((e) => {
    //       $scope.isLoading = false;
    //       $log.error(e);
    //       Notification.error('Something went wrong try later')
    //     });
    // }

    $scope.allCheckList = [];
    $scope.data = [];
    $scope.totalCount = 0;
    $scope.numPerPage = 20; //globals.numPerPage();

    $scope.noOfPages = 0;
    vm.currentPage = 1;
    vm.searchText = undefined;
    vm.sortMenuList = [{
      label: 'Title',
      key: 'title'
    }, {
      label: 'Created Date',
      key: 'createdAt'
    }, {
      label: 'Modified Date',
      key: 'updatedAt'
    }, {
      label: 'Checklist Tag',
      key: 'systemTag'
    }];
    vm.sortMenu = "createdAt";
    $scope.periods = [{
      id: '20',
      name: '20'
    }, {
      id: '40',
      name: '40'
    }, {
      id: '60',
      name: '60'
    }];

    vm.allChecklistData = function () {
      var queryObj = {
        page: vm.currentPage,
        chunk: $scope.numPerPage,
        search: vm.searchText,
        sort: vm.sortMenu,
        sortType: "false"
      };

      if (vm.projectData._id !== 'all') {
        queryObj.projectId = vm.projectData._id;
      }

      $scope.isLoading = true;
      apiFactory.getAllChecklist(queryObj).then(function (data) {
        $scope.isLoading = false;
        $scope.allCheckList = data.data.list;
        $scope.totalCount = data.data.total;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
      })["catch"](function (err) {
        $scope.isLoading = false;
        $log.error(err);
        Notification.error(utils.getErrorMessage(err));
      });
    };

    vm.allChecklistData();

    vm.selectNumPage = function (new_num) {
      $scope.numPerPage = new_num;
      vm.allChecklistData();
    };

    $scope.searchCallback = function () {
      if (vm.currentPage > 1) vm.currentPage = 1;
      vm.allChecklistData();
    };

    $scope.openAddChecklistModal = function () {
      $uibModal.open({
        animation: true,
        component: 'createCheckListModal',
        windowClass: 'checklist-modal',
        backdrop: 'static',
        keyboard: true
      }).result.then(function () {
        vm.allChecklistData();
      }, function () {});
    };

    $scope.deleteChecklist = function (data) {
      $uibModal.open({
        animation: true,
        component: 'confirmModal',
        size: 'sm',
        backdrop: 'static',
        keyboard: false
      }).result.then(function () {
        $scope.isLoading = true;
        apiFactory.deleteChecklist(data._id).then(function (resp) {
          $scope.isLoading = false;
          Notification.success(resp.data.message);
          angular.element('#updateModal').modal('hide');
          vm.allChecklistData();
        })["catch"](function (err) {
          $scope.isLoading = false;
          $log.error(err);
          Notification.error(utils.getErrorMessage(err));
        });
      }, function () {});
    };

    $scope.openEditChecklistModal = function (checkList) {
      $uibModal.open({
        animation: true,
        component: 'editCheckListModal',
        windowClass: 'checklist-modal',
        backdrop: 'static',
        keyboard: true,
        resolve: {
          checkListData: function checkListData() {
            return checkList;
          }
        }
      }).result.then(function () {
        vm.allChecklistData();
      }, function () {});
    };
  }
})();


"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  'use strict';

  angular.module('app').component('calendar', {
    controller: calendarController,
    controllerAs: 'vm',
    templateUrl: 'app/main/calendar/calendar.view.html'
  });
  /** @ngInject */

  function calendarController($scope, $log, $uibModal, apiFactory, Notification, globals, $state) {
    var userStore = globals.userStore;
    $scope.types = Constants.EventTypeList;
    $scope.isCollapse = false;
    $scope.calendars = [{
      _id: 0,
      name: 'My Calendars',
      children: [{
        name: $scope.types[0].label,
        color: '#755FE2',
        checked: true
      }, {
        name: $scope.types[1].label,
        color: '#2FA84F',
        checked: true
      }, {
        name: $scope.types[2].label,
        color: '#FF575F',
        checked: true
      }, {
        name: $scope.types[3].label,
        color: '#FFC542',
        checked: true
      }]
    }, {
      _id: 1,
      name: 'Other Calendars',
      children: [{
        name: $scope.types[4].label,
        color: '#1DA1F2',
        checked: true
      }, {
        name: $scope.types[5].label,
        color: '#FDF1CC',
        checked: true
      }]
    }];

    $scope.getAllEvents = function () {
      $scope.isLoading = true;
      apiFactory.getAllEvents().then(function (res) {
        $scope.events = res.data.list.map(function (v) {
          return {
            title: v.name,
            start: v.startTime,
            end: v.endTime,
            _id: v._id,
            allDay: false,
            comingSource: 'Events',
            color: $scope.types[v.type].backgroundColor,
            className: "".concat($scope.types[v.type].key, "-type"),
            description: v.description,
            bgColor: $scope.types[v.type].textColor
          };
        });
        $('#calendar').fullCalendar('removeEvents');
        $('#calendar').fullCalendar('addEventSource', _toConsumableArray($scope.events));
        $scope.isLoading = false;
      })["catch"](function (err) {
        $log.error(err);
        $scope.isLoading = false;
        Notification.error("Failed to get data");
      });
    };

    Promise.all([apiFactory.getAllMembers()]).then(function (res) {
      $scope.users = res[0].data.list;
      $scope.getAllEvents();
    })["catch"](function (err) {
      $log.error(err);
      Notification.error("Failed to get data");
    });

    $scope.detailEvent = function (_event) {
      var eventModal = $uibModal.open({
        animation: true,
        component: 'detailEventModal',
        windowClass: 'detail-event-modal',
        resolve: {
          event: function event() {
            return _event;
          },
          users: function users() {
            return $scope.users;
          },
          permission: function permission() {
            return 4; //$scope.CALENDAR_ACCESS_CREATE;
          }
        }
      });
      eventModal.result.then(function (res) {
        if (res) {
          $scope.getAllEvents();
        }
      }, function (reason) {
        $log.info(reason);
      });
    };

    $scope.addEvent = function () {
      var eventModal = $uibModal.open({
        animation: true,
        component: 'saveEventModal',
        windowClass: 'save-event-modal',
        resolve: {
          users: function users() {
            return $scope.users;
          }
        }
      });
      eventModal.result.then(function (result) {
        if (result) {
          var created = [{
            title: result.name,
            start: result.startTime,
            end: result.endTime,
            _id: result._id,
            allDay: false,
            comingSource: 'Events',
            color: $scope.types[result.type].backgroundColor,
            className: "".concat($scope.types[result.type].key, "-type"),
            description: result.description,
            bgColor: $scope.types[result.type].textColor
          }];
          $('#calendar').fullCalendar('addEventSource', created);
        }
      }, function (reason) {
        $log.info(reason);
      });
    };
    /* Requiring vars */


    var vm = this; //variables declaration to get first and last dates of rendered view.

    vm.StartDate = '';
    vm.LastDate = '';

    function initData() {
      $('#calendar').fullCalendar({
        header: {
          left: 'prev,next, title',
          center: '',
          right: 'month,agendaWeek,agendaDay,listWeek'
        },
        disableDragging: true,
        eventStartEditable: false,
        eventLimit: true,
        navLinks: true,
        views: {
          month: {
            titleFormat: "MMMM YYYY"
          },
          listWeek: {
            listDayFormat: 'ddd',
            listDayAltFormat: 'DD'
          }
        },
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        eventColor: '#f1543b',
        displayEventTime: false,
        eventRender: function eventRender(event, element) {
          if (event.id > 100) {
            element.draggable = false;
          }
        },
        eventMouseover: function eventMouseover() {},
        eventMouseout: function eventMouseout() {},
        eventClick: function eventClick(event, element) {
          $scope.detailEvent(event);
        },
        defaultDate: new Date(),
        editable: true
      });
    }

    initData();

    function formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    }

    angular.element('body').on('click', 'button.fc-prev-button', function () {
      var b = $('#calendar').fullCalendar('getDate');
      var day = b.format('L');
      var date1 = new Date(day);
      var firstDay = new Date(date1.getFullYear(), date1.getMonth(), 1);
      var lastDay = new Date(date1.getFullYear(), date1.getMonth() + 1, 0);
      vm.StartDate = formatDate(firstDay);
      vm.LastDate = formatDate(lastDay);
    });
    angular.element('body').on('click', 'button.fc-next-button', function () {
      var b = $('#calendar').fullCalendar('getDate');
      var day = b.format('L');
      var date1 = new Date(day);
      var firstDay = new Date(date1.getFullYear(), date1.getMonth(), 1);
      var lastDay = new Date(date1.getFullYear(), date1.getMonth() + 1, 0);
      vm.StartDate = formatDate(firstDay);
      vm.LastDate = formatDate(lastDay);
    });

    $scope.clickedTodayBtn = function () {
      $('#calendar').fullCalendar('today');
    };

    $scope.select = function () {
      $('#calendar').fullCalendar('gotoDate', $scope.dt);
    };

    var isToday = function isToday(someDate) {
      var today = new Date();
      return someDate.getDate() == today.getDate() && someDate.getMonth() == today.getMonth() && someDate.getFullYear() == today.getFullYear();
    };

    var side_calendar = new dhx.Calendar("side_calendar", {
      range: true,
      width: '280',
      // disabledDates: function(date) {
      //   if (isToday(date))
      //     return false;
      //   else
      //     return date < new Date();
      // },
      mark: function mark(date) {
        if (isToday(date)) {
          return "highlight-date";
        }
      }
    });
    side_calendar.events.on("Change", function () {
      var tdate = side_calendar.getValue(true);
      console.log(tdate);

      if (angular.isDefined(tdate[0])) {
        vm.deadlineFromDate = tdate[0];
      } else {
        vm.deadlineFromDate = null;
      }

      if (angular.isDefined(tdate[1])) {
        vm.deadlineToDate = tdate[1];
      } else {
        vm.deadlineToDate = null;
      }

      $scope.$apply();
      $scope.onChangeFilterDate();
    });

    $scope.onExpand = function (index) {
      if ($scope.calendars[index].expanded === 'undefined') {
        $scope.calendars.map(function (item) {
          item.expanded = false;
        });
      }

      $scope.calendars[index].expanded = !$scope.calendars[index].expanded;
    };

    $scope.onChangeFilterDate = function () {
      // if (isToday(vm.deadlineFromDate)) {
      //   vm.deadlineFromDate = new Date();
      // }
      // else {
      //   vm.deadlineFromDate.setHours(0, 0, 0, 0);
      // }
      // if (!utils.isEmpty(vm.deadlineToDate)) {
      //   vm.deadlineToDate.setHours(23,59,59,999);
      // }
      // if (!utils.isEmpty(vm.deadlineToDate) && vm.deadlineFromDate > vm.deadlineToDate) {
      //   Notification.error("Invalid Start and End Time.");
      //   return;
      // }
      initData();
    };

    $scope.onSelectItem = function (index, key) {
      if ($scope.calendars[index].children[key].checked) $(".".concat($scope.types[index * 4 + key].key, "-type")).show();else $(".".concat($scope.types[index * 4 + key].key, "-type")).hide();
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').component('activities', {
    controller: ActivitiesController,
    controllerAs: 'vm',
    templateUrl: 'app/main/activities/activities.view.html'
  });
  /** @ngInject */

  function ActivitiesController($scope, $log, $state, apiFactory, Notification, globals, utils) {
    var vm = this;
    vm.utils = utils;
    var userStore = globals.userStore,
        projectStore = globals.projectStore,
        companyStore = globals.companyStore;
    vm.project = projectStore.get();
    vm.userData = userStore.get();

    if (!vm.project || vm.project._id === 'all') {
      Notification.error('Please select project first.');
      $state.go(globals.getDashboardRoute(vm.userData));
      return;
    }

    var companyData = companyStore.get();
    vm.companyInputMethod = companyData ? companyData.companyInputMethod : 'European et al.';
    vm.userData = userStore.get();
    vm.pdfViewing = false;
    vm.variationOrder = undefined;
    $scope.totalCount = 0;
    $scope.numPerPage = 10;
    $scope.noOfPages = 0;
    vm.currentPage = 1;

    vm.fetchActivities = function () {
      $scope.isLoading = true;
      apiFactory.getActivity({
        page: vm.currentPage,
        chunk: $scope.numPerPage
      }).then(function (resp) {
        vm.activities = resp.data.data.map(function (item) {
          item.createdTime = vm.utils.getRemainingTime(item.created);
          return item;
        });
        $scope.totalCount = resp.data.totalCount;
        $scope.noOfPages = Math.ceil($scope.totalCount / $scope.numPerPage);
        $scope.isLoading = false;
      })["catch"](function (e) {
        $log.log(e);
      });
    };

    vm.fetchActivities();

    $scope.showDashboard = function () {
      $state.go(globals.getDashboardRoute(vm.userData));
    };

    $scope.goToDetail = function (activity) {
      if (vm.utils.isEmpty(activity.route)) {
        return;
      }

      if (vm.utils.isEmpty(activity.route.id)) {
        $state.go(activity.route.stateName);
      } else {
        $state.go(activity.route.stateName, {
          id: activity.route.id
        });
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').provider('msApi', msApiProvider);
  /** @ngInject **/

  function msApiProvider() {
    /* ----------------- */

    /* Provider          */

    /* ----------------- */
    var provider = this; // Inject the $log service

    var $log = angular.injector(['ng']).get('$log'); // Data

    var baseUrl = '';
    var api = []; // Methods

    provider.setBaseUrl = setBaseUrl;
    provider.getBaseUrl = getBaseUrl;
    provider.getApiObject = getApiObject;
    provider.register = register; //////////

    /**
     * Set base url for API endpoints
     *
     * @param url {string}
     */

    function setBaseUrl(url) {
      baseUrl = url;
    }
    /**
     * Return the base url
     *
     * @returns {string}
     */


    function getBaseUrl() {
      return baseUrl;
    }
    /**
     * Return the api object
     *
     * @returns {object}
     */


    function getApiObject() {
      return api;
    }
    /**
     * Register API endpoint
     *
     * @param key
     * @param resource
     */


    function register(key, resource) {
      if (!angular.isString(key)) {
        $log.error('"path" must be a string (eg. `dashboard.project`)');
        return;
      }

      if (!angular.isArray(resource)) {
        $log.error('"resource" must be an array and it must follow $resource definition');
        return;
      } // Store the API object


      api[key] = {
        url: baseUrl + (resource[0] || ''),
        paramDefaults: resource[1] || [],
        actions: resource[2] || [],
        options: resource[3] || {}
      };
    }
    /* ----------------- */

    /* Service           */

    /* ----------------- */


    this.$get = function ($log, $q, $resource, $rootScope) {
      // Data
      // Methods
      var service = {
        setBaseUrl: setBaseUrl,
        getBaseUrl: getBaseUrl,
        register: register,
        resolve: resolve,
        request: request
      };
      return service; //////////

      /**
       * Resolve an API endpoint
       *
       * @param action {string}
       * @param parameters {object}
       * @returns {promise|boolean}
       */

      function resolve(action, parameters) {
        // Emit an event
        $rootScope.$broadcast('msApi::resolveStart');
        var actionParts = action.split('@'),
            resource = actionParts[0],
            method = actionParts[1],
            params = parameters || {};

        if (!resource || !method) {
          $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
          return false;
        } // Create a new deferred object


        var deferred = $q.defer(); // Get the correct resource definition from api object

        var apiObject = api[resource];

        if (!apiObject) {
          $log.error('Resource "' + resource + '" is not defined in the api service!');
          deferred.reject('Resource "' + resource + '" is not defined in the api service!');
        } else {
          // Generate the $resource object based on the stored API object
          var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options); // Make the call...

          resourceObject[method](params, // Success
          function (response) {
            deferred.resolve(response); // Emit an event

            $rootScope.$broadcast('msApi::resolveSuccess');
          }, // Error
          function (response) {
            deferred.reject(response); // Emit an event

            $rootScope.$broadcast('msApi::resolveError');
          });
        } // Return the promise


        return deferred.promise;
      }
      /**
       * Make a request to an API endpoint
       *
       * @param action {string}
       * @param [parameters] {object}
       * @param [success] {function}
       * @param [error] {function}
       *
       * @returns {promise|boolean}
       */


      function request(action, parameters, success, error) {
        // Emit an event
        $rootScope.$broadcast('msApi::requestStart');
        var actionParts = action.split('@'),
            resource = actionParts[0],
            method = actionParts[1],
            params = parameters || {};

        if (!resource || !method) {
          $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
          return false;
        } // Create a new deferred object


        var deferred = $q.defer(); // Get the correct resource definition from api object

        var apiObject = api[resource];

        if (!apiObject) {
          $log.error('Resource "' + resource + '" is not defined in the api service!');
          deferred.reject('Resource "' + resource + '" is not defined in the api service!');
        } else {
          // Generate the $resource object based on the stored API object
          var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options); // Make the call...

          resourceObject[method](params, // SUCCESS
          function (response) {
            // Emit an event
            $rootScope.$broadcast('msApi::requestSuccess'); // Resolve the promise

            deferred.resolve(response); // Call the success function if there is one

            if (angular.isDefined(success) && angular.isFunction(success)) {
              success(response);
            }
          }, // ERROR
          function (response) {
            // Emit an event
            $rootScope.$broadcast('msApi::requestError'); // Reject the promise

            deferred.reject(response); // Call the error function if there is one

            if (angular.isDefined(error) && angular.isFunction(error)) {
              error(response);
            }
          });
        } // Return the promise


        return deferred.promise;
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').factory('apiResolver', apiResolverService);
  /** @ngInject */

  function apiResolverService($q, $log, api) {
    var service = {
      resolve: resolve
    };
    return service; //////////

    /**
     * Resolve api
     * @param action
     * @param parameters
     */

    function resolve(action, parameters) {
      var actionParts = action.split('@'),
          resource = actionParts[0],
          method = actionParts[1],
          params = parameters || {};

      if (!resource || !method) {
        $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
        return false;
      } // Create a new deferred object


      var deferred = $q.defer(); // Get the correct api object from api service

      var apiObject = getApiObject(resource);

      if (!apiObject) {
        $log.error('Resource "' + resource + '" is not defined in the api service!');
        deferred.reject('Resource "' + resource + '" is not defined in the api service!');
      } else {
        apiObject[method](params, // Success
        function (response) {
          deferred.resolve(response);
        }, // Error
        function (response) {
          deferred.reject(response);
        });
      } // Return the promise


      return deferred.promise;
    }
    /**
     * Get correct api object
     *
     * @param resource
     * @returns {*}
     */


    function getApiObject(resource) {
      // Split the resource in case if we have a dot notated object
      var resourceParts = resource.split('.'),
          apiObject = api; // Loop through the resource parts and go all the way through
      // the api object and return the correct one

      for (var l = 0; l < resourceParts.length; l++) {
        if (angular.isUndefined(apiObject[resourceParts[l]])) {
          $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
          apiObject = false;
          break;
        }

        apiObject = apiObject[resourceParts[l]];
      }

      if (!apiObject) {
        return false;
      }

      return apiObject;
    }
  }
})();


"use strict";

(function () {
  angular.module("app.core").directive('scrolly', function () {
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {
        var raw = element[0];
        element.bind('scroll', function () {
          if (raw.scrollTop + raw.offsetHeight + 1 > raw.scrollHeight) {
            scope.$apply(attrs.scrolly);
          }
        });
      }
    };
  });
})();


"use strict";

(function () {
  angular.module("app.core").directive("scrollTop", function () {
    return {
      scope: {
        scrollTop: "="
      },
      link: function link(scope, element) {
        scope.$watchCollection("scrollTop", function (newValue) {
          if (newValue) {
            angular.element(element).scrollTop(0);
          }
        });
      }
    };
  });
})();


"use strict";

(function () {
  angular.module("app.core").directive('scrollBottom', function () {
    return {
      scope: {
        scrollBottom: "=",
        scrollBottomAttach: '=',
        scrollBottomQuote: '=',
        scrollBottomAtsign: '@'
      },
      link: function link(scope, element) {
        scope.$watchCollection('scrollBottom', function (newValue) {
          if (newValue) {
            angular.element(element).scrollTop(angular.element(element)[0].scrollHeight);
          }
        });
        scope.$watchCollection('scrollBottomAttach', function (newValue) {
          if (newValue) {
            angular.element(element).scrollTop(angular.element(element)[0].scrollHeight);
          }
        });
        scope.$watch('scrollBottomQuote', function (newValue) {
          if (newValue) {
            angular.element(element).scrollTop(angular.element(element)[0].scrollHeight);
          }
        });
        scope.$watch('scrollBottomAtsign', function (newValue) {
          if (newValue) {
            angular.element(element).scrollTop(angular.element(element)[0].scrollHeight);
          }
        });
      }
    };
  });
})();


"use strict";

(function () {
  angular.module("app.core").directive('numbersOnly', function () {
    return {
      require: 'ngModel',
      link: function link(scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          if (text) {
            var transformedInput = text.replace(/[^0-9]/g, '');

            if (transformedInput !== text) {
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }

            return transformedInput;
          }

          return undefined;
        }

        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  });
})();


"use strict";

(function () {
  angular.module("app").directive("numberEdit", function (globals) {
    return {
      require: "ngModel",
      restrict: 'A',
      scope: {
        numberEdit: "="
      },
      link: function link(scope, element, attrs, ngModelCtrl) {
        var companyStore = globals.companyStore;
        var company = companyStore.get();
        var inputMethod = company ? company.companyInputMethod : "European et al.";
        var regex = /[^-?^0-9.,]/g;
        var place = angular.isDefined(scope.numberEdit) ? Number(scope.numberEdit) : undefined; // view -> model

        ngModelCtrl.$parsers.push(function (viewValue) {
          if (regex.test(viewValue.toString())) {
            ngModelCtrl.$setViewValue('');
            ngModelCtrl.$render();
            return 0;
          } else {
            if (inputMethod === 'European et al.') {
              viewValue = viewValue.toString().replace(/\./gi, '');
              viewValue = viewValue.toString().replace(/,/gi, '.');
            } else {
              viewValue = viewValue.toString().replace(/,/gi, '');
            }

            if (viewValue === '') {
              ngModelCtrl.$setViewValue('');
              ngModelCtrl.$render();
              return 0;
            }

            return Number.parseFloat(viewValue);
          }
        }); // model -> view

        ngModelCtrl.$formatters.push(function (value) {
          if (angular.isDefined(value) && value !== null && !isNaN(value)) {
            var data = '';

            if (value !== '') {
              if (angular.isDefined(place)) {
                data = Number(value).toFixed(place).toString();
              } else {
                data = value.toString();
              }

              if (inputMethod === 'European et al.') {
                data = data.replace(/\./gi, ',');
                data = data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              } else {
                data = data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              }
            }

            ngModelCtrl.$setViewValue(data);
            ngModelCtrl.$render();
            return data;
          }
        });
        element[0].addEventListener('keydown', keyEvent);
        element[0].addEventListener('keyup', keyEvent);
        element[0].addEventListener('keypress', keyEvent);

        function keyEvent(event) {
          if (event.key === 'Enter' || event.keyCode === 13) {
            event.target.blur();
          }

          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Delete' || event.key === 'Backspace' || event.key === 'Shift' || event.key === 'Home' || event.key === 'End') {
            return;
          }

          if (event.key === '-') {
            if (event.target.selectionStart > 0) {
              event.preventDefault();
            }

            return;
          } else if (event.key === 'v') {
            event.preventDefault();
            return;
          }

          if (regex.test(event.key)) {
            event.preventDefault();
          }
        }
      }
    };
  });
})();


"use strict";

(function () {
  angular.module("app").directive("errSrc", function () {
    return {
      link: function link(scope, element, attrs) {
        element.bind("error", function () {
          if (attrs.src != attrs.errSrc) {
            attrs.$set("src", attrs.errSrc);
          }
        });
      }
    };
  });
})();

(function () {
  angular.module("app").directive("numbersOnly", function () {
    return {
      require: "ngModel",
      link: function link(scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          if (text) {
            var transformedInput = text.replace(/[^0-9]/g, "");

            if (transformedInput !== text) {
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }

            return transformedInput;
          }

          return undefined;
        }

        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  });
})();

(function () {
  angular.module("app").directive("calcInputs", function () {
    return {
      require: "ngModel",
      link: function link(scope, element, attrs, ngModelCtrl) {
        ngModelCtrl.$parsers.push(function (data) {
          var ret;

          if (!data.includes(",")) {
            var data1 = data.replace(/\./g, "");
            ret = data1 ? data1.replace(",", ".") : 0;
            ret = Number(ret).toFixed(2);
            return parseFloat(ret);
          } else {
            var num_matches = data.match(/,/gi);
            var count = num_matches.length;
            element.bind("keypress", function (e) {
              if (count == 1) {
                if (e.which == 44 || e.charCode == 44 || e.keyCode == 44) {
                  e.preventDefault();
                } else {
                  var _data = data.replace(/\./g, "");

                  ret = _data ? _data.replace(",", ".") : 0;
                  ret = Number(ret).toFixed(2);
                  return parseFloat(ret);
                }
              } else {
                var _data2 = data.replace(/\./g, "");

                ret = _data2 ? _data2.replace(",", ".") : 0;
                ret = Number(ret).toFixed(2);
                return parseFloat(ret);
              }
            });

            if (count == 1) {
              var _data3 = data.replace(/\./g, "");

              ret = _data3 ? _data3.replace(",", ".") : 0;
              ret = Number(ret).toFixed(2);
              return parseFloat(ret);
            }
          }
        });

        function format(value) {
          if (value) {
            var data = Number(value).toFixed(2);
            value = data.replace(".", ",");
            var NO = value.split(",");
            var result = NO[0];
            var change = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
            value = change + "," + NO[1];
            return value;
          }
        }

        ngModelCtrl.$formatters.push(format);
      }
    };
  });
})();

(function () {
  angular.module("app").directive("calcDecimal", function () {
    return {
      require: "ngModel",
      link: function link(scope, element, attrs, ngModelCtrl) {
        function format(value) {
          if (value) {
            var data = Number(value).toFixed(2);
            return parseFloat(data);
          }
        }

        ngModelCtrl.$formatters.push(format);
      }
    };
  });
})();

(function () {
  angular.module("app").directive("commaFormatNumber", function () {
    return {
      require: "ngModel",
      link: function link(scope, element, attrs, ngModelCtrl) {
        //element.bind('keypress', function(e){
        element.bind("keypress", function (e) {
          var data = scope.modelData;
          var count = scope.count;

          if (e.which > 47 && e.which < 58 || e.which == 44) {
            if (data && data.includes(",")) {
              if (count == 1) {
                if (e.which == 44 || e.charCode == 44 || e.keyCode == 44) {
                  e.preventDefault();
                }
              }
            }
          } else {
            e.preventDefault();
            return false;
          }
        });
        ngModelCtrl.$parsers.push(function (data) {
          var ret;
          scope.modelData = data;
          var num_matches = data.match(/,/gi);

          if (num_matches) {
            scope.count = num_matches.length;
          } else {
            scope.count = 0;
          }

          var count = scope.count;

          if (!data.includes(",")) {
            var data1 = data.replace(/\./g, "");
            ret = data1 ? data1.replace(",", ".") : 0;
            ret = Number(ret).toFixed(2);
            return parseFloat(ret);
          } else {
            if (count == 1) {
              var _data4 = data.replace(/\./g, "");

              ret = _data4 ? _data4.replace(",", ".") : 0;
              ret = Number(ret).toFixed(2);
              return parseFloat(ret);
            } else {
              var _data5 = data.replace(/\./g, "");

              ret = _data5 ? _data5.replace(",", ".") : 0;
              ret = Number(ret).toFixed(2);
              return parseFloat(ret);
            }
          }
        });

        function format(value) {
          if (value) {
            var data = Number(value).toFixed(2);
            value = data.replace(".", ",");
            var NO = value.split(",");
            var result = NO[0];
            var change = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
            value = change + "," + NO[1];
            return value;
          }
        }

        ngModelCtrl.$formatters.push(format);
      }
    };
  });
})();

angular.module("app").directive("ngEnter", function () {
  return function (scope, element, attrs) {
    element.bind("keydown keypress", function (event) {
      if (event.which === 13) {
        scope.$apply(function () {
          scope.$eval(attrs.ngEnter);
        });
        event.preventDefault();
      }
    });
  };
});


"use strict";

(function () {
  'use strict';

  angular.module("app.core").directive('ngRightClick', function ($parse) {
    return function (scope, element, attrs) {
      var fn = $parse(attrs.ngRightClick);
      element.bind('contextmenu', function (event) {
        scope.$apply(function () {
          event.preventDefault();
          fn(scope, {
            $event: event
          });
        });
      });
    };
  });
  angular.module("app.core").directive('fileChange', function () {
    return {
      restrict: 'A',
      scope: {
        fileChange: "="
      },
      link: function link(scope, element) {
        element.on('change', function (ev) {
          scope.fileChange(ev);
        });
        element.on('$destroy', function () {
          element.off();
        });
      }
    };
  });
  angular.module('app.core').directive('enterKey', function () {
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {
        element.bind('keydown keypress', function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.enterKey);
            });
            event.preventDefault();
          }
        });
      }
    };
  });
  angular.module("app.core").directive('ngSglclick', function ($parse, $timeout) {
    return {
      restrict: 'A',
      link: function link(scope, element, attr) {
        var fn = $parse(attr['ngSglclick']);
        var delay = 300,
            clicks = 0,
            timer = null;
        element.on('click', function (event) {
          clicks++; //count clicks

          if (clicks === 1) {
            timer = $timeout(function () {
              scope.$apply(function () {
                fn(scope, {
                  $event: event
                });
              });
              clicks = 0; //after action performed, reset counter
            }, delay);
          } else {
            if (timer) {
              $timeout.cancel(timer); //prevent single-click action

              timer = null;
            }

            clicks = 0; //after action performed, reset counter
          }
        });
      }
    };
  });
})();


"use strict";

(function () {
  angular.module("app.core").directive("draggable", draggable);
  angular.module("app.core").directive("droppable", droppable);

  function draggable() {
    return {
      restrict: "A",
      scope: {
        dragData: "="
      },
      link: function link(scope, element) {
        element.prop('draggable', true);
        element.on('dragstart', function (event) {
          if (scope.dragData) {
            event.originalEvent.dataTransfer.setData('dragData', angular.toJson(scope.dragData));
          }
        });
      }
    };
  }

  function droppable() {
    return {
      restrict: "A",
      scope: {
        dropData: "=",
        dropEvent: "="
      },
      link: function link(scope, element) {
        element.on('dragover', function (event) {
          event.preventDefault();
        });
        element.on('drop', function (event) {
          event.preventDefault();
          var transferData = event.originalEvent.dataTransfer.getData("dragData");

          if (transferData) {
            scope.dropEvent(scope.dropData, angular.fromJson(transferData));
          }
        });
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('filterByTags', filterByTags).filter('filterSingleByTags', filterSingleByTags);
  /** @ngInject */

  function filterByTags() {
    return function (items, tags) {
      if (items.length === 0 || tags.length === 0) {
        return items;
      }

      var filtered = [];
      items.forEach(function (item) {
        var match = tags.every(function (tag) {
          var tagExists = false;
          item.tags.forEach(function (itemTag) {
            if (itemTag.name === tag.name) {
              tagExists = true;
              return;
            }
          });
          return tagExists;
        });

        if (match) {
          filtered.push(item);
        }
      });
      return filtered;
    };
  }
  /** @ngInject */


  function filterSingleByTags() {
    return function (itemTags, tags) {
      if (itemTags.length === 0 || tags.length === 0) {
        return;
      }

      if (itemTags.length < tags.length) {
        return [];
      }

      var filtered = [];
      var match = tags.every(function (tag) {
        var tagExists = false;
        itemTags.forEach(function (itemTag) {
          if (itemTag.name === tag.name) {
            tagExists = true;
            return;
          }
        });
        return tagExists;
      });

      if (match) {
        filtered.push(itemTags);
      }

      return filtered;
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('smartDate', smartDate).filter('smartDateTime', smartDateTime).filter('smartTime', smartTime).filter('slashDate', slashDate).filter('utcDate', utcDate).filter('fullDate', fullDate).filter('weekDate', weekDate).filter('weekDay', weekDay).filter('smartDay', smartDay).filter('smartHour', smartHour);
  /** @ngInject */

  function smartDate() {
    return function (value) {
      if (!value) return '';
      return moment(value).format('DD MMM, YYYY');
    };
  }

  function smartDateTime(globals) {
    return function (value) {
      if (!value) return '';
      var companyStore = globals.companyStore;
      var companyData = companyStore.get();

      if (companyData && companyData.timeShowMethod === '12 hr') {
        return moment(value).format('DD MMM YYYY hh:mm A');
      } else {
        return moment(value).format('DD MMM YYYY HH:mm');
      }
    };
  }

  function smartTime(globals) {
    return function (value) {
      if (!value) return '';
      var companyStore = globals.companyStore;
      var companyData = companyStore.get();

      if (companyData && companyData.timeShowMethod === '12 hr') {
        return moment(value).format('hh:mm A');
      } else {
        return moment(value).format('HH:mm');
      }
    };
  }

  function slashDate() {
    return function (value) {
      if (!value) return '';
      return moment(value).format('DD-MM-YYYY');
    };
  }

  function utcDate() {
    return function (value) {
      if (!value) return '';
      return moment(value).add(moment().utcOffset() / 60, 'hours').format('DD-MM-YYYY');
    };
  }

  function fullDate() {
    return function (value) {
      if (!value) return '';
      return moment(value).format('dddd, MMM DD, YYYY');
    };
  }

  function weekDate() {
    return function (value) {
      if (!value) return '';
      return moment(value).format('DD');
    };
  }

  function weekDay() {
    return function (value) {
      if (!value) return '';
      return moment(value).format('ddd');
    };
  }

  function smartDay() {
    return function (value) {
      if (!value) return '';
      return moment(value).format('D');
    };
  }

  function smartHour(globals) {
    return function (value) {
      if (!value) return '';
      var companyStore = globals.companyStore;
      var companyData = companyStore.get();

      if (companyData && companyData.timeShowMethod === '12 hr') {
        return moment(value).format('hh A');
      } else {
        return moment(value).format('HH');
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('removeComment', removeComment);
  /** @ngInject */

  function removeComment() {
    return function (value) {
      if (value) {
        value = value.replace(/(<!--.*?-->)|(<!--[\S\s]+?-->)|(<!--[\S\s]*?$)/g, "");
      }

      return value;
    };
  }
})();


"use strict";

(function () {
  /* Round number */
  angular.module("app.core").filter("roundNum", roundNum);
  angular.module("app.core").filter('indexFormat', indexFormat);
  angular.module('app.core').filter("readable", readable);
  angular.module('app.core').filter("comma2decimal", comma2decimal);
  angular.module('app.core').filter("padZeroNumber", padZeroNumber);

  function roundNum() {
    return function (input, place) {
      if (!input || isNaN(input) || !isFinite(input)) {
        return 0;
      } else {
        return Number(input).toFixed(place);
      }
    };
  }

  function indexFormat() {
    return function (input) {
      return input + 1 <= 9 ? '0' + (input + 1) : '' + (input + 1);
    };
  }

  function readable(globals, utils) {
    return function (input, place) {
      if (angular.isUndefined(input) || input === null || isNaN(input) || !isFinite(input)) {
        input = 0;
      }

      return utils.makeReadable(input, place, utils.isEuropean());
    };
  }

  function padZeroNumber() {
    return function (input) {
      var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

      if (angular.isUndefined(input) || input === null || isNaN(input) || !isFinite(input)) {
        input = 0;
      }

      return input.toString().padStart(maxLength, '0');
    };
  }

  function comma2decimal() {
    return function (input, place) {
      if (!input || isNaN(input) || !isFinite(input)) {
        return 0;
      } else {
        var data = Number(input).toFixed(place);
        var ret = data ? data.replace(".", ",") : 0;
        var NO = ret.split(",");
        var result = NO[0];
        var change = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");

        if (NO[1]) {
          ret = change + "," + NO[1];
        } else {
          ret = change;
        }

        return ret;
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('mailDate', mailDate);
  /** @ngInject */

  function mailDate() {
    return function (value) {
      var diff = Date.now() - new Date(value);

      if (diff < 60 * 60 * 24 * 1000) {
        /*
         * If in the day
         * e.g. "11:23"
         */
        return moment(value).format('h:mm a');
      } else if (diff < 60 * 60 * 24 * 7 * 1000) {
        /*
         * If in week
         * e.g "Tuesday"
         */
        return moment(value).format('ddd');
      } else {
        /*
         * If more than a week
         * e.g. 03/29/2016
         */
        return moment(value).calendar();
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('mailAvatarChar', mailAvatarChar);
  /** @ngInject */

  function mailAvatarChar() {
    return function (value) {
      if (!value) {
        return '';
      }

      value = value.toUpperCase();
      value = value.replace(/"/g, '');
      value = value.replace('\'', '');
      var chars = value.split(' ');

      if (chars.length < 2) {
        return chars[0][0] ? chars[0][0] + (chars[0][1] ? chars[0][1] : '') : '';
      } else {
        return (chars[0][0] ? chars[0][0] : '') + (chars[1][0] ? chars[1][0] : '');
      }
    };
  }
})();


"use strict";

(function () {
  /* Currenty convertor */
  angular.module("app").filter("convertCurrency", convertCurrency);

  function convertCurrency() {
    return function (input, conversionRate) {
      if (!input) {
        return 0;
      } else {
        return input * conversionRate;
      }
    };
  }

  angular.module("app").filter("strsplice", function () {
    return function (input) {
      input = input || '';
      return input.length >= 14 ? input.slice(0, 13) + '...' : input;
    };
  }); //subcontractor.name.slice(0, 13)

  /* Round number */

  angular.module("app").directive("roundNum", function () {
    return {
      require: 'ngModel',
      link: function link(scope, element, attrs, ngModelController) {
        ngModelController.$parsers.push(function (input) {
          return Number(input).toFixed(2);
        });
        ngModelController.$formatters.push(function (input) {
          return Number(input).toFixed(2);
        });
      }
    };
  }); // angular.module("app").filter("trustUrl", trustUrl);
  // function trustUrl() {
  //   return function (url) {
  //     return $sce.trustAsResourceUrl(url);
  //   };
  // }

  angular.module("app").filter("projStatus", projStatus);

  function projStatus() {
    return function (status) {
      switch (status) {
        case 1:
          return "Ongoing1";

        case 2:
          return "Completed";

        case 0:
          return "Offer";

        case 3:
          return "Cancel";

        case 4:
          return "Lost";

        case 5:
          return "Postponed";

        case 6:
          return "Precast";
      }

      return "";
    };
  }

  angular.module("app").filter("roundNumb", roundNumb);

  function roundNumb() {
    return function (input, place) {
      if (!input) {
        return "";
      } else {
        return Number(input).toFixed(place);
      }
    };
  }
  /* Fetch thumbnail */


  angular.module("app").filter("fetchThumbnail", fetchThumbnail);

  function fetchThumbnail() {
    return function (input) {
      if (!input) return;
      return /cloudinary/.test(input.secure_url) ? input.secure_url.replace(/\.pdf/, ".png") : input.thumbnail;
    };
  }
  /* Parse typing members */


  angular.module("app").filter("parseTypingMembers", parseTypingMembers);

  function parseTypingMembers() {
    return function (input) {
      if (!input || !input.length) {
        return;
      }

      if (input.length > 1) {
        return "".concat(input.length, " people are typing..");
      } else {
        return "".concat(input[0].nickname, " is typing..");
      }
    };
  }
  /*sum of columns*/


  angular.module("app").filter("sumOfColumn", sumOfColumn);

  function sumOfColumn() {
    return function (collection, column) {
      var total = 0;
      collection.forEach(function (item) {
        total += parseInt(item[column]);
      });
      return total;
    };
  }
  /*Autocomplete filter */


  angular.module("app").filter("searchFor", searchFor);

  function searchFor() {
    // All filters must return a function. The first parameter
    // is the data that is to be filtered, and the second is an
    // argument that may be passed with a colon (searchFor:searchString)
    return function (arr, searchString) {
      if (!searchString) {
        return arr;
      }

      var result = [];
      searchString = searchString.toLowerCase(); // Using the forEach helper method to loop through the array

      angular.forEach(arr, function (item) {
        if (item.name.toLowerCase().indexOf(searchString) !== -1) {
          result.push(item);
        } else {
          result.push(searchString);
        }
      });
      return result;
    };
  }
  /* To mark url as trusted for iframe */
  // angular.module("app").filter("trustAsResourceUrl", [
  //   "$sce",
  //   function ($sce) {
  //     return function (val) {
  //       return $sce.trustAsResourceUrl(val);
  //     };
  //   }
  // ]);


  angular.module("app").filter("removeBlackItems", removeBlackItems);

  function removeBlackItems() {
    return function (array) {
      if (!array) {
        return;
      } else {
        return array.filter(function (o, i) {
          if (o == null) {
            if (i > 3) {
              array.splice(i, 1);
            } else {
              array[i] = {};
            }
          } else {
            return o;
          }
        });
      }
    };
  }

  angular.module("app").directive("comma2decimal", function () {
    return {
      require: 'ngModel',
      link: function link(scope, element, attrs, ngModelController) {
        ngModelController.$parsers.push(function (input) {
          if (angular.isDefined(input)) {
            var data = Number(input).toFixed(2);
            var ret = data ? data.replace(".", ",") : 0;
            var NO = ret.split(",");
            var result = NO[0];
            var change = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
            ret = change + "," + NO[1];
            return ret;
          }

          return '';
        });
        ngModelController.$formatters.push(function (input) {
          if (angular.isDefined(input)) {
            var data = Number(input).toFixed(2);
            var ret = data ? data.replace(".", ",") : 0;
            var NO = ret.split(",");
            var result = NO[0];
            var change = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
            ret = change + "," + NO[1];
            return ret;
          }

          return '';
        });
      }
    };
  });
  angular.module("app").filter("makeNoRound", makeNoRound);

  function makeNoRound() {
    return function (input) {
      if (angular.isDefined(input)) {
        return Number(input).toFixed(2);
      }
    };
  } // app.filter("decimalSave", [
  //   function () {
  //     return function (input) {
  //       var ret = input
  //         ? input
  //           .toString()
  //           .trim()
  //           .replace(",", ".")
  //         : null;
  //       return parseFloat(ret);
  //     };
  //   }
  // ]);
  // app.filter('decimal2comma', [
  //   function() {
  //     return function(input) {
  //       var ret=(input)?input.toString().replace(".",","):null;
  //       if(ret){
  //         var decArr=ret.split(",");
  //         if(decArr.length>1){
  //           var dec=decArr[1].length;
  //           if(dec===1){ret+="0";}
  //         }
  //       }
  //       return ret;
  //     };
  //   }
  // ]);


  angular.module("app").filter("checklistCount", function () {
    return function (input) {
      if (!input.length) {
        return "";
      } else {
        var done = input.filter(function (x) {
          return x.checkStatus === "Yes";
        });
        return "".concat(done.length, " out of ").concat(input.length, " item(s) done");
      }
    };
  });
  angular.module("app").filter('millSecondsToTimeString', function () {
    return function (millseconds) {
      var oneSecond = 1000;
      var oneMinute = oneSecond * 60;
      var oneHour = oneMinute * 60;
      var oneDay = oneHour * 24;
      var seconds = Math.floor(millseconds % oneMinute / oneSecond);
      var minutes = Math.floor(millseconds % oneHour / oneMinute);
      var hours = Math.floor(millseconds % oneDay / oneHour);
      var days = Math.floor(millseconds / oneDay);
      var timeString = '';

      if (days !== 0) {
        timeString += days !== 1 ? days + ' days ' : days + ' day ';
      }

      if (hours !== 0) {
        timeString += hours !== 1 ? hours + ' hours ' : hours + ' hour ';
      }

      if (minutes !== 0) {
        timeString += minutes !== 1 ? minutes + ' minutes ' : minutes + ' minute ';
      }

      if (seconds !== 0 || millseconds < 1000) {
        timeString += seconds !== 1 ? seconds + ' seconds ' : seconds + ' second ';
      }

      return timeString;
    };
  });
  angular.module("app").filter("unitFilter", function () {
    return function (input, type, rowstyle) {
      if (!input.length) {
        return [];
      } else {
        var resultList = [];

        switch (type) {
          case 'worker':
            if (rowstyle === 'Combined') {
              resultList = input;
            } else {
              resultList = input.filter(function (x) {
                return x.name === "hrs";
              });
            }

            break;

          case 'subcontractor':
            resultList = input.filter(function (x) {
              return x.name === "hrs";
            });
            break;

          case 'inventory':
            resultList = input;
            break;

          default:
            resultList = input;
            break;
        }

        return resultList;
      }
    };
  });
  angular.module("app").filter('capitalize', function () {
    return function (input) {
      return angular.isString(input) && input.length > 0 ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : input;
    };
  });
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('filterByPropIds', filterByPropIds);
  /** @ngInject */

  function filterByPropIds() {
    return function (items, parameter, ids) {
      if (items.length === 0 || !ids || ids.length === 0) {
        return items;
      }

      var filtered = [];

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var match = false;

        for (var j = 0; j < ids.length; j++) {
          var id = ids[j];

          if (item[parameter].indexOf(id) > -1) {
            match = true;
            break;
          }
        }

        if (match) {
          filtered.push(item);
        }
      }

      return filtered;
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('filterByIds', filterByIds);
  /** @ngInject */

  function filterByIds() {
    return function (items, ids) {
      if (items.length === 0 || !ids) {
        return items;
      }

      if (ids.length === 0) {
        return [];
      }

      var filtered = [];

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var match = false;

        for (var j = 0; j < ids.length; j++) {
          var id = ids[j];

          if (item.id === id) {
            match = true;
            break;
          }
        }

        if (match) {
          filtered.push(item);
        }
      }

      return filtered;
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('filesize', filesize);
  /** @ngInject */

  function filesize() {
    return function (value) {
      if (value / 1024 >= 1) {
        if (value / 1024 / 1024 >= 1) {
          if (value / 1024 / 1024 / 1024 >= 1) {
            return Math.round(value / 1024 / 1024 / 1024 * 10) / 10 + 'GB';
          } else {
            return Math.round(value / 1024 / 1024 * 10) / 10 + 'MB';
          }
        } else {
          return Math.round(value / 1024 * 10) / 10 + 'KB';
        }
      } else {
        return value + 'Byte';
      }
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('toTrusted', toTrustedFilter).filter('htmlToPlaintext', htmlToPlainTextFilter).filter('nospace', nospaceFilter).filter('humanizeDoc', humanizeDocFilter);
  /** @ngInject */

  function toTrustedFilter($sce) {
    return function (value) {
      return $sce.trustAsHtml(value);
    };
  }
  /** @ngInject */


  function htmlToPlainTextFilter() {
    return function (text) {
      return String(text).replace(/<[^>]+>/gm, '');
    };
  }
  /** @ngInject */


  function nospaceFilter() {
    return function (value) {
      return !value ? '' : value.replace(/ /g, '');
    };
  }
  /** @ngInject */


  function humanizeDocFilter() {
    return function (doc) {
      if (!doc) {
        return;
      }

      if (doc.type === 'directive') {
        return doc.name.replace(/([A-Z])/g, function ($1) {
          return '-' + $1.toLowerCase();
        });
      }

      return doc.label || doc.name;
    };
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('altDate', altDate);
  /** @ngInject */

  function altDate() {
    return function (value) {
      var diff = Date.now() - new Date(value);
      /**
       * If in a hour
       * e.g. "2 minutes ago"
       */

      if (diff < 60 * 60 * 1000) {
        return moment(value).fromNow();
      } else if (diff < 60 * 60 * 24 * 1000) {
        /*
         * If in the day
         * e.g. "11:23"
         */
        return moment(value).format('HH:mm');
      } else if (diff < 60 * 60 * 24 * 7 * 1000) {
        /*
         * If in week
         * e.g "Tuesday"
         */
        return moment(value).format('dddd');
      } else {
        /*
         * If more than a week
         * e.g. 03/29/2016
         */
        return moment(value).calendar();
      }
    };
  }
})();


"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*!
 * FullCalendar v3.6.2
 * Docs & License: https://fullcalendar.io/
 * (c) 2017 Adam Shaw
 */
(function (factory) {
  if (typeof define === "function" && define.amd) {
    define(["jquery", "moment"], factory);
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object") {
    // Node/CommonJS
    module.exports = factory(require("jquery"), require("moment"));
  } else {
    factory(jQuery, moment);
  }
})(function ($, moment) {
  var FC = $.fullCalendar = {
    version: "3.6.2",
    // When introducing internal API incompatibilities (where fullcalendar plugins would break),
    // the minor version of the calendar should be upped (ex: 2.7.2 -> 2.8.0)
    // and the below integer should be incremented.
    internalApiVersion: 11
  };
  var fcViews = FC.views = {};

  $.fn.fullCalendar = function (options) {
    var args = Array.prototype.slice.call(arguments, 1); // for a possible method call

    var res = this; // what this function will return (this jQuery object by default)

    this.each(function (i, _element) {
      // loop each DOM element involved
      var element = $(_element);
      var calendar = element.data("fullCalendar"); // get the existing calendar object (if any)

      var singleRes; // the returned value of this single method call
      // a method call

      if (typeof options === "string") {
        if (options === "getCalendar") {
          if (!i) {
            // first element only
            res = calendar;
          }
        } else if (options === "destroy") {
          // don't warn if no calendar object
          if (calendar) {
            calendar.destroy();
            element.removeData("fullCalendar");
          }
        } else if (!calendar) {
          FC.warn("Attempting to call a FullCalendar method on an element with no calendar.");
        } else if ($.isFunction(calendar[options])) {
          singleRes = calendar[options].apply(calendar, args);

          if (!i) {
            res = singleRes; // record the first method call result
          }

          if (options === "destroy") {
            // for the destroy method, must remove Calendar object data
            element.removeData("fullCalendar");
          }
        } else {
          FC.warn("'" + options + "' is an unknown FullCalendar method.");
        }
      } // a new calendar initialization
      else if (!calendar) {
        // don't initialize twice
        calendar = new Calendar(element, options);
        element.data("fullCalendar", calendar);
        calendar.render();
      }
    });
    return res;
  };

  var complexOptions = [// names of options that are objects whose properties should be combined
  "header", "footer", "buttonText", "buttonIcons", "themeButtonIcons"]; // Merges an array of option objects into a single object

  function mergeOptions(optionObjs) {
    return mergeProps(optionObjs, complexOptions);
  } // exports


  FC.applyAll = applyAll;
  FC.debounce = debounce;
  FC.isInt = isInt;
  FC.htmlEscape = htmlEscape;
  FC.cssToStr = cssToStr;
  FC.proxy = proxy;
  FC.capitaliseFirstLetter = capitaliseFirstLetter;
  /* FullCalendar-specific DOM Utilities
  ----------------------------------------------------------------------------------------------------------------------*/
  // Given the scrollbar widths of some other container, create borders/margins on rowEls in order to match the left
  // and right space that was offset by the scrollbars. A 1-pixel border first, then margin beyond that.

  function compensateScroll(rowEls, scrollbarWidths) {
    if (scrollbarWidths.left) {
      rowEls.css({
        "border-left-width": 1,
        "margin-left": scrollbarWidths.left - 1
      });
    }

    if (scrollbarWidths.right) {
      rowEls.css({
        "border-right-width": 1,
        "margin-right": scrollbarWidths.right - 1
      });
    }
  } // Undoes compensateScroll and restores all borders/margins


  function uncompensateScroll(rowEls) {
    rowEls.css({
      "margin-left": "",
      "margin-right": "",
      "border-left-width": "",
      "border-right-width": ""
    });
  } // Make the mouse cursor express that an event is not allowed in the current area


  function disableCursor() {
    $("body").addClass("fc-not-allowed");
  } // Returns the mouse cursor to its original look


  function enableCursor() {
    $("body").removeClass("fc-not-allowed");
  } // Given a total available height to fill, have `els` (essentially child rows) expand to accomodate.
  // By default, all elements that are shorter than the recommended height are expanded uniformly, not considering
  // any other els that are already too tall. if `shouldRedistribute` is on, it considers these tall rows and
  // reduces the available height.


  function distributeHeight(els, availableHeight, shouldRedistribute) {
    // *FLOORING NOTE*: we floor in certain places because zoom can give inaccurate floating-point dimensions,
    // and it is better to be shorter than taller, to avoid creating unnecessary scrollbars.
    var minOffset1 = Math.floor(availableHeight / els.length); // for non-last element

    var minOffset2 = Math.floor(availableHeight - minOffset1 * (els.length - 1)); // for last element *FLOORING NOTE*

    var flexEls = []; // elements that are allowed to expand. array of DOM nodes

    var flexOffsets = []; // amount of vertical space it takes up

    var flexHeights = []; // actual css height

    var usedHeight = 0;
    undistributeHeight(els); // give all elements their natural height
    // find elements that are below the recommended height (expandable).
    // important to query for heights in a single first pass (to avoid reflow oscillation).

    els.each(function (i, el) {
      var minOffset = i === els.length - 1 ? minOffset2 : minOffset1;
      var naturalOffset = $(el).outerHeight(true);

      if (naturalOffset < minOffset) {
        flexEls.push(el);
        flexOffsets.push(naturalOffset);
        flexHeights.push($(el).height());
      } else {
        // this element stretches past recommended height (non-expandable). mark the space as occupied.
        usedHeight += naturalOffset;
      }
    }); // readjust the recommended height to only consider the height available to non-maxed-out rows.

    if (shouldRedistribute) {
      availableHeight -= usedHeight;
      minOffset1 = Math.floor(availableHeight / flexEls.length);
      minOffset2 = Math.floor(availableHeight - minOffset1 * (flexEls.length - 1)); // *FLOORING NOTE*
    } // assign heights to all expandable elements


    $(flexEls).each(function (i, el) {
      var minOffset = i === flexEls.length - 1 ? minOffset2 : minOffset1;
      var naturalOffset = flexOffsets[i];
      var naturalHeight = flexHeights[i];
      var newHeight = minOffset - (naturalOffset - naturalHeight); // subtract the margin/padding

      if (naturalOffset < minOffset) {
        // we check this again because redistribution might have changed things
        $(el).height(newHeight);
      }
    });
  } // Undoes distrubuteHeight, restoring all els to their natural height


  function undistributeHeight(els) {
    els.height("");
  } // Given `els`, a jQuery set of <td> cells, find the cell with the largest natural width and set the widths of all the
  // cells to be that width.
  // PREREQUISITE: if you want a cell to take up width, it needs to have a single inner element w/ display:inline


  function matchCellWidths(els) {
    var maxInnerWidth = 0;
    els.find("> *").each(function (i, innerEl) {
      var innerWidth = $(innerEl).outerWidth();

      if (innerWidth > maxInnerWidth) {
        maxInnerWidth = innerWidth;
      }
    });
    maxInnerWidth++; // sometimes not accurate of width the text needs to stay on one line. insurance

    els.width(maxInnerWidth);
    return maxInnerWidth;
  } // Given one element that resides inside another,
  // Subtracts the height of the inner element from the outer element.


  function subtractInnerElHeight(outerEl, innerEl) {
    var both = outerEl.add(innerEl);
    var diff; // effin' IE8/9/10/11 sometimes returns 0 for dimensions. this weird hack was the only thing that worked

    both.css({
      position: "relative",
      // cause a reflow, which will force fresh dimension recalculation
      left: -1 // ensure reflow in case the el was already relative. negative is less likely to cause new scroll

    });
    diff = outerEl.outerHeight() - innerEl.outerHeight(); // grab the dimensions

    both.css({
      position: "",
      left: ""
    }); // undo hack

    return diff;
  }
  /* Element Geom Utilities
  ----------------------------------------------------------------------------------------------------------------------*/


  FC.getOuterRect = getOuterRect;
  FC.getClientRect = getClientRect;
  FC.getContentRect = getContentRect;
  FC.getScrollbarWidths = _getScrollbarWidths; // borrowed from https://github.com/jquery/jquery-ui/blob/1.11.0/ui/core.js#L51

  function getScrollParent(el) {
    var position = el.css("position"),
        scrollParent = el.parents().filter(function () {
      var parent = $(this);
      return /(auto|scroll)/.test(parent.css("overflow") + parent.css("overflow-y") + parent.css("overflow-x"));
    }).eq(0);
    return position === "fixed" || !scrollParent.length ? $(el[0].ownerDocument || document) : scrollParent;
  } // Queries the outer bounding area of a jQuery element.
  // Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
  // Origin is optional.


  function getOuterRect(el, origin) {
    var offset = el.offset();
    var left = offset.left - (origin ? origin.left : 0);
    var top = offset.top - (origin ? origin.top : 0);
    return {
      left: left,
      right: left + el.outerWidth(),
      top: top,
      bottom: top + el.outerHeight()
    };
  } // Queries the area within the margin/border/scrollbars of a jQuery element. Does not go within the padding.
  // Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
  // Origin is optional.
  // WARNING: given element can't have borders
  // NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.


  function getClientRect(el, origin) {
    var offset = el.offset();

    var scrollbarWidths = _getScrollbarWidths(el);

    var left = offset.left + getCssFloat(el, "border-left-width") + scrollbarWidths.left - (origin ? origin.left : 0);
    var top = offset.top + getCssFloat(el, "border-top-width") + scrollbarWidths.top - (origin ? origin.top : 0);
    return {
      left: left,
      right: left + el[0].clientWidth,
      // clientWidth includes padding but NOT scrollbars
      top: top,
      bottom: top + el[0].clientHeight // clientHeight includes padding but NOT scrollbars

    };
  } // Queries the area within the margin/border/padding of a jQuery element. Assumed not to have scrollbars.
  // Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
  // Origin is optional.


  function getContentRect(el, origin) {
    var offset = el.offset(); // just outside of border, margin not included

    var left = offset.left + getCssFloat(el, "border-left-width") + getCssFloat(el, "padding-left") - (origin ? origin.left : 0);
    var top = offset.top + getCssFloat(el, "border-top-width") + getCssFloat(el, "padding-top") - (origin ? origin.top : 0);
    return {
      left: left,
      right: left + el.width(),
      top: top,
      bottom: top + el.height()
    };
  } // Returns the computed left/right/top/bottom scrollbar widths for the given jQuery element.
  // WARNING: given element can't have borders (which will cause offsetWidth/offsetHeight to be larger).
  // NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.


  function _getScrollbarWidths(el) {
    var leftRightWidth = el[0].offsetWidth - el[0].clientWidth;
    var bottomWidth = el[0].offsetHeight - el[0].clientHeight;
    var widths;
    leftRightWidth = sanitizeScrollbarWidth(leftRightWidth);
    bottomWidth = sanitizeScrollbarWidth(bottomWidth);
    widths = {
      left: 0,
      right: 0,
      top: 0,
      bottom: bottomWidth
    };

    if (getIsLeftRtlScrollbars() && el.css("direction") == "rtl") {
      // is the scrollbar on the left side?
      widths.left = leftRightWidth;
    } else {
      widths.right = leftRightWidth;
    }

    return widths;
  } // The scrollbar width computations in getScrollbarWidths are sometimes flawed when it comes to
  // retina displays, rounding, and IE11. Massage them into a usable value.


  function sanitizeScrollbarWidth(width) {
    width = Math.max(0, width); // no negatives

    width = Math.round(width);
    return width;
  } // Logic for determining if, when the element is right-to-left, the scrollbar appears on the left side


  var _isLeftRtlScrollbars = null;

  function getIsLeftRtlScrollbars() {
    // responsible for caching the computation
    if (_isLeftRtlScrollbars === null) {
      _isLeftRtlScrollbars = computeIsLeftRtlScrollbars();
    }

    return _isLeftRtlScrollbars;
  }

  function computeIsLeftRtlScrollbars() {
    // creates an offscreen test element, then removes it
    var el = $("<div><div/></div>").css({
      position: "absolute",
      top: -1000,
      left: 0,
      border: 0,
      padding: 0,
      overflow: "scroll",
      direction: "rtl"
    }).appendTo("body");
    var innerEl = el.children();
    var res = innerEl.offset().left > el.offset().left; // is the inner div shifted to accommodate a left scrollbar?

    el.remove();
    return res;
  } // Retrieves a jQuery element's computed CSS value as a floating-point number.
  // If the queried value is non-numeric (ex: IE can return "medium" for border width), will just return zero.


  function getCssFloat(el, prop) {
    return parseFloat(el.css(prop)) || 0;
  }
  /* Mouse / Touch Utilities
  ----------------------------------------------------------------------------------------------------------------------*/


  FC.preventDefault = preventDefault; // Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)

  function isPrimaryMouseButton(ev) {
    return ev.which == 1 && !ev.ctrlKey;
  }

  function getEvX(ev) {
    var touches = ev.originalEvent.touches; // on mobile FF, pageX for touch events is present, but incorrect,
    // so, look at touch coordinates first.

    if (touches && touches.length) {
      return touches[0].pageX;
    }

    return ev.pageX;
  }

  function getEvY(ev) {
    var touches = ev.originalEvent.touches; // on mobile FF, pageX for touch events is present, but incorrect,
    // so, look at touch coordinates first.

    if (touches && touches.length) {
      return touches[0].pageY;
    }

    return ev.pageY;
  }

  function getEvIsTouch(ev) {
    return /^touch/.test(ev.type);
  }

  function preventSelection(el) {
    el.addClass("fc-unselectable").on("selectstart", preventDefault);
  }

  function allowSelection(el) {
    el.removeClass("fc-unselectable").off("selectstart", preventDefault);
  } // Stops a mouse/touch event from doing it's native browser action


  function preventDefault(ev) {
    ev.preventDefault();
  }
  /* General Geometry Utils
  ----------------------------------------------------------------------------------------------------------------------*/


  FC.intersectRects = intersectRects; // Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false

  function intersectRects(rect1, rect2) {
    var res = {
      left: Math.max(rect1.left, rect2.left),
      right: Math.min(rect1.right, rect2.right),
      top: Math.max(rect1.top, rect2.top),
      bottom: Math.min(rect1.bottom, rect2.bottom)
    };

    if (res.left < res.right && res.top < res.bottom) {
      return res;
    }

    return false;
  } // Returns a new point that will have been moved to reside within the given rectangle


  function constrainPoint(point, rect) {
    return {
      left: Math.min(Math.max(point.left, rect.left), rect.right),
      top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
  } // Returns a point that is the center of the given rectangle


  function getRectCenter(rect) {
    return {
      left: (rect.left + rect.right) / 2,
      top: (rect.top + rect.bottom) / 2
    };
  } // Subtracts point2's coordinates from point1's coordinates, returning a delta


  function diffPoints(point1, point2) {
    return {
      left: point1.left - point2.left,
      top: point1.top - point2.top
    };
  }
  /* Object Ordering by Field
  ----------------------------------------------------------------------------------------------------------------------*/


  FC.parseFieldSpecs = parseFieldSpecs;
  FC.compareByFieldSpecs = compareByFieldSpecs;
  FC.compareByFieldSpec = compareByFieldSpec;
  FC.flexibleCompare = flexibleCompare;

  function parseFieldSpecs(input) {
    var specs = [];
    var tokens = [];
    var i, token;

    if (typeof input === "string") {
      tokens = input.split(/\s*,\s*/);
    } else if (typeof input === "function") {
      tokens = [input];
    } else if ($.isArray(input)) {
      tokens = input;
    }

    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];

      if (typeof token === "string") {
        specs.push(token.charAt(0) == "-" ? {
          field: token.substring(1),
          order: -1
        } : {
          field: token,
          order: 1
        });
      } else if (typeof token === "function") {
        specs.push({
          func: token
        });
      }
    }

    return specs;
  }

  function compareByFieldSpecs(obj1, obj2, fieldSpecs) {
    var i;
    var cmp;

    for (i = 0; i < fieldSpecs.length; i++) {
      cmp = compareByFieldSpec(obj1, obj2, fieldSpecs[i]);

      if (cmp) {
        return cmp;
      }
    }

    return 0;
  }

  function compareByFieldSpec(obj1, obj2, fieldSpec) {
    if (fieldSpec.func) {
      return fieldSpec.func(obj1, obj2);
    }

    return flexibleCompare(obj1[fieldSpec.field], obj2[fieldSpec.field]) * (fieldSpec.order || 1);
  }

  function flexibleCompare(a, b) {
    if (!a && !b) {
      return 0;
    }

    if (b == null) {
      return -1;
    }

    if (a == null) {
      return 1;
    }

    if ($.type(a) === "string" || $.type(b) === "string") {
      return String(a).localeCompare(String(b));
    }

    return a - b;
  }
  /* Date Utilities
  ----------------------------------------------------------------------------------------------------------------------*/


  FC.computeGreatestUnit = computeGreatestUnit;
  FC.divideRangeByDuration = divideRangeByDuration;
  FC.divideDurationByDuration = divideDurationByDuration;
  FC.multiplyDuration = multiplyDuration;
  FC.durationHasTime = durationHasTime;
  var dayIDs = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  var unitsDesc = ["year", "month", "week", "day", "hour", "minute", "second", "millisecond"]; // descending
  // Diffs the two moments into a Duration where full-days are recorded first, then the remaining time.
  // Moments will have their timezones normalized.

  function diffDayTime(a, b) {
    return moment.duration({
      days: a.clone().stripTime().diff(b.clone().stripTime(), "days"),
      ms: a.time() - b.time() // time-of-day from day start. disregards timezone

    });
  } // Diffs the two moments via their start-of-day (regardless of timezone). Produces whole-day durations.


  function diffDay(a, b) {
    return moment.duration({
      days: a.clone().stripTime().diff(b.clone().stripTime(), "days")
    });
  } // Diffs two moments, producing a duration, made of a whole-unit-increment of the given unit. Uses rounding.


  function diffByUnit(a, b, unit) {
    return moment.duration(Math.round(a.diff(b, unit, true)), // returnFloat=true
    unit);
  } // Computes the unit name of the largest whole-unit period of time.
  // For example, 48 hours will be "days" whereas 49 hours will be "hours".
  // Accepts start/end, a range object, or an original duration object.


  function computeGreatestUnit(start, end) {
    var i, unit;
    var val;

    for (i = 0; i < unitsDesc.length; i++) {
      unit = unitsDesc[i];
      val = computeRangeAs(unit, start, end);

      if (val >= 1 && isInt(val)) {
        break;
      }
    }

    return unit; // will be "milliseconds" if nothing else matches
  } // like computeGreatestUnit, but has special abilities to interpret the source input for clues


  function computeDurationGreatestUnit(duration, durationInput) {
    var unit = computeGreatestUnit(duration); // prevent days:7 from being interpreted as a week

    if (unit === "week" && _typeof(durationInput) === "object" && durationInput.days) {
      unit = "day";
    }

    return unit;
  } // Computes the number of units (like "hours") in the given range.
  // Range can be a {start,end} object, separate start/end args, or a Duration.
  // Results are based on Moment's .as() and .diff() methods, so results can depend on internal handling
  // of month-diffing logic (which tends to vary from version to version).


  function computeRangeAs(unit, start, end) {
    if (end != null) {
      // given start, end
      return end.diff(start, unit, true);
    } else if (moment.isDuration(start)) {
      // given duration
      return start.as(unit);
    } else {
      // given { start, end } range object
      return start.end.diff(start.start, unit, true);
    }
  } // Intelligently divides a range (specified by a start/end params) by a duration


  function divideRangeByDuration(start, end, dur) {
    var months;

    if (durationHasTime(dur)) {
      return (end - start) / dur;
    }

    months = dur.asMonths();

    if (Math.abs(months) >= 1 && isInt(months)) {
      return end.diff(start, "months", true) / months;
    }

    return end.diff(start, "days", true) / dur.asDays();
  } // Intelligently divides one duration by another


  function divideDurationByDuration(dur1, dur2) {
    var months1, months2;

    if (durationHasTime(dur1) || durationHasTime(dur2)) {
      return dur1 / dur2;
    }

    months1 = dur1.asMonths();
    months2 = dur2.asMonths();

    if (Math.abs(months1) >= 1 && isInt(months1) && Math.abs(months2) >= 1 && isInt(months2)) {
      return months1 / months2;
    }

    return dur1.asDays() / dur2.asDays();
  } // Intelligently multiplies a duration by a number


  function multiplyDuration(dur, n) {
    var months;

    if (durationHasTime(dur)) {
      return moment.duration(dur * n);
    }

    months = dur.asMonths();

    if (Math.abs(months) >= 1 && isInt(months)) {
      return moment.duration({
        months: months * n
      });
    }

    return moment.duration({
      days: dur.asDays() * n
    });
  } // Returns a boolean about whether the given duration has any time parts (hours/minutes/seconds/ms)


  function durationHasTime(dur) {
    return Boolean(dur.hours() || dur.minutes() || dur.seconds() || dur.milliseconds());
  }

  function isNativeDate(input) {
    return Object.prototype.toString.call(input) === "[object Date]" || input instanceof Date;
  } // Returns a boolean about whether the given input is a time string, like "06:40:00" or "06:00"


  function isTimeString(str) {
    return typeof str === "string" && /^\d+\:\d+(?:\:\d+\.?(?:\d{3})?)?$/.test(str);
  }
  /* Logging and Debug
  ----------------------------------------------------------------------------------------------------------------------*/


  FC.log = function () {
    var console = window.console;

    if (console && console.log) {
      return console.log.apply(console, arguments);
    }
  };

  FC.warn = function () {
    var console = window.console;

    if (console && console.warn) {
      return console.warn.apply(console, arguments);
    } else {
      return FC.log.apply(FC, arguments);
    }
  };
  /* General Utilities
  ----------------------------------------------------------------------------------------------------------------------*/


  var hasOwnPropMethod = {}.hasOwnProperty; // Merges an array of objects into a single object.
  // The second argument allows for an array of property names who's object values will be merged together.

  function mergeProps(propObjs, complexProps) {
    var dest = {};
    var i, name;
    var complexObjs;
    var j, val;
    var props;

    if (complexProps) {
      for (i = 0; i < complexProps.length; i++) {
        name = complexProps[i];
        complexObjs = []; // collect the trailing object values, stopping when a non-object is discovered

        for (j = propObjs.length - 1; j >= 0; j--) {
          val = propObjs[j][name];

          if (_typeof(val) === "object") {
            complexObjs.unshift(val);
          } else if (val !== undefined) {
            dest[name] = val; // if there were no objects, this value will be used

            break;
          }
        } // if the trailing values were objects, use the merged value


        if (complexObjs.length) {
          dest[name] = mergeProps(complexObjs);
        }
      }
    } // copy values into the destination, going from last to first


    for (i = propObjs.length - 1; i >= 0; i--) {
      props = propObjs[i];

      for (name in props) {
        if (!(name in dest)) {
          // if already assigned by previous props or complex props, don't reassign
          dest[name] = props[name];
        }
      }
    }

    return dest;
  }

  function copyOwnProps(src, dest) {
    for (var name in src) {
      if (hasOwnProp(src, name)) {
        dest[name] = src[name];
      }
    }
  }

  function hasOwnProp(obj, name) {
    return hasOwnPropMethod.call(obj, name);
  }

  function applyAll(functions, thisObj, args) {
    if ($.isFunction(functions)) {
      functions = [functions];
    }

    if (functions) {
      var i;
      var ret;

      for (i = 0; i < functions.length; i++) {
        ret = functions[i].apply(thisObj, args) || ret;
      }

      return ret;
    }
  }

  function removeMatching(array, testFunc) {
    var removeCnt = 0;
    var i = 0;

    while (i < array.length) {
      if (testFunc(array[i])) {
        // truthy value means *remove*
        array.splice(i, 1);
        removeCnt++;
      } else {
        i++;
      }
    }

    return removeCnt;
  }

  function removeExact(array, exactVal) {
    var removeCnt = 0;
    var i = 0;

    while (i < array.length) {
      if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt++;
      } else {
        i++;
      }
    }

    return removeCnt;
  }

  FC.removeExact = removeExact;

  function isArraysEqual(a0, a1) {
    var len = a0.length;
    var i;

    if (len == null || len !== a1.length) {
      // not array? or not same length?
      return false;
    }

    for (i = 0; i < len; i++) {
      if (a0[i] !== a1[i]) {
        return false;
      }
    }

    return true;
  }

  function firstDefined() {
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i] !== undefined) {
        return arguments[i];
      }
    }
  }

  function htmlEscape(s) {
    return (s + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#039;").replace(/"/g, "&quot;").replace(/\n/g, "<br />");
  }

  function stripHtmlEntities(text) {
    return text.replace(/&.*?;/g, "");
  } // Given a hash of CSS properties, returns a string of CSS.
  // Uses property names as-is (no camel-case conversion). Will not make statements for null/undefined values.


  function cssToStr(cssProps) {
    var statements = [];
    $.each(cssProps, function (name, val) {
      if (val != null) {
        statements.push(name + ":" + val);
      }
    });
    return statements.join(";");
  } // Given an object hash of HTML attribute names to values,
  // generates a string that can be injected between < > in HTML


  function attrsToStr(attrs) {
    var parts = [];
    $.each(attrs, function (name, val) {
      if (val != null) {
        parts.push(name + '="' + htmlEscape(val) + '"');
      }
    });
    return parts.join(" ");
  }

  function capitaliseFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function compareNumbers(a, b) {
    // for .sort()
    return a - b;
  }

  function isInt(n) {
    return n % 1 === 0;
  } // Returns a method bound to the given object context.
  // Just like one of the jQuery.proxy signatures, but without the undesired behavior of treating the same method with
  // different contexts as identical when binding/unbinding events.


  function proxy(obj, methodName) {
    var method = obj[methodName];
    return function () {
      return method.apply(obj, arguments);
    };
  } // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  // https://github.com/jashkenas/underscore/blob/1.6.0/underscore.js#L714


  function debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function later() {
      var last = +new Date() - timestamp;

      if (last < wait) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;

        if (!immediate) {
          result = func.apply(context, args);
          context = args = null;
        }
      }
    };

    return function () {
      context = this;
      args = arguments;
      timestamp = +new Date();
      var callNow = immediate && !timeout;

      if (!timeout) {
        timeout = setTimeout(later, wait);
      }

      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  }
  /*
  GENERAL NOTE on moments throughout the *entire rest* of the codebase:
  All moments are assumed to be ambiguously-zoned unless otherwise noted,
  with the NOTABLE EXCEOPTION of start/end dates that live on *Event Objects*.
  Ambiguously-TIMED moments are assumed to be ambiguously-zoned by nature.
  */


  var ambigDateOfMonthRegex = /^\s*\d{4}-\d\d$/;
  var ambigTimeOrZoneRegex = /^\s*\d{4}-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?)?$/;
  var newMomentProto = moment.fn; // where we will attach our new methods

  var oldMomentProto = $.extend({}, newMomentProto); // copy of original moment methods
  // tell momentjs to transfer these properties upon clone

  var momentProperties = moment.momentProperties;
  momentProperties.push("_fullCalendar");
  momentProperties.push("_ambigTime");
  momentProperties.push("_ambigZone"); // Creating
  // -------------------------------------------------------------------------------------------------
  // Creates a new moment, similar to the vanilla moment(...) constructor, but with
  // extra features (ambiguous time, enhanced formatting). When given an existing moment,
  // it will function as a clone (and retain the zone of the moment). Anything else will
  // result in a moment in the local zone.

  FC.moment = function () {
    return makeMoment(arguments);
  }; // Sames as FC.moment, but forces the resulting moment to be in the UTC timezone.


  FC.moment.utc = function () {
    var mom = makeMoment(arguments, true); // Force it into UTC because makeMoment doesn't guarantee it
    // (if given a pre-existing moment for example)

    if (mom.hasTime()) {
      // don't give ambiguously-timed moments a UTC zone
      mom.utc();
    }

    return mom;
  }; // Same as FC.moment, but when given an ISO8601 string, the timezone offset is preserved.
  // ISO8601 strings with no timezone offset will become ambiguously zoned.


  FC.moment.parseZone = function () {
    return makeMoment(arguments, true, true);
  }; // Builds an enhanced moment from args. When given an existing moment, it clones. When given a
  // native Date, or called with no arguments (the current time), the resulting moment will be local.
  // Anything else needs to be "parsed" (a string or an array), and will be affected by:
  //    parseAsUTC - if there is no zone information, should we parse the input in UTC?
  //    parseZone - if there is zone information, should we force the zone of the moment?


  function makeMoment(args, parseAsUTC, parseZone) {
    var input = args[0];
    var isSingleString = args.length == 1 && typeof input === "string";
    var isAmbigTime;
    var isAmbigZone;
    var ambigMatch;
    var mom;

    if (moment.isMoment(input) || isNativeDate(input) || input === undefined) {
      mom = moment.apply(null, args);
    } else {
      // "parsing" is required
      isAmbigTime = false;
      isAmbigZone = false;

      if (isSingleString) {
        if (ambigDateOfMonthRegex.test(input)) {
          // accept strings like '2014-05', but convert to the first of the month
          input += "-01";
          args = [input]; // for when we pass it on to moment's constructor

          isAmbigTime = true;
          isAmbigZone = true;
        } else if (ambigMatch = ambigTimeOrZoneRegex.exec(input)) {
          isAmbigTime = !ambigMatch[5]; // no time part?

          isAmbigZone = true;
        }
      } else if ($.isArray(input)) {
        // arrays have no timezone information, so assume ambiguous zone
        isAmbigZone = true;
      } // otherwise, probably a string with a format


      if (parseAsUTC || isAmbigTime) {
        mom = moment.utc.apply(moment, args);
      } else {
        mom = moment.apply(null, args);
      }

      if (isAmbigTime) {
        mom._ambigTime = true;
        mom._ambigZone = true; // ambiguous time always means ambiguous zone
      } else if (parseZone) {
        // let's record the inputted zone somehow
        if (isAmbigZone) {
          mom._ambigZone = true;
        } else if (isSingleString) {
          mom.utcOffset(input); // if not a valid zone, will assign UTC
        }
      }
    }

    mom._fullCalendar = true; // flag for extended functionality

    return mom;
  } // Week Number
  // -------------------------------------------------------------------------------------------------
  // Returns the week number, considering the locale's custom week number calcuation
  // `weeks` is an alias for `week`


  newMomentProto.week = newMomentProto.weeks = function (input) {
    var weekCalc = this._locale._fullCalendar_weekCalc;

    if (input == null && typeof weekCalc === "function") {
      // custom function only works for getter
      return weekCalc(this);
    } else if (weekCalc === "ISO") {
      return oldMomentProto.isoWeek.apply(this, arguments); // ISO getter/setter
    }

    return oldMomentProto.week.apply(this, arguments); // local getter/setter
  }; // Time-of-day
  // -------------------------------------------------------------------------------------------------
  // GETTER
  // Returns a Duration with the hours/minutes/seconds/ms values of the moment.
  // If the moment has an ambiguous time, a duration of 00:00 will be returned.
  //
  // SETTER
  // You can supply a Duration, a Moment, or a Duration-like argument.
  // When setting the time, and the moment has an ambiguous time, it then becomes unambiguous.


  newMomentProto.time = function (time) {
    // Fallback to the original method (if there is one) if this moment wasn't created via FullCalendar.
    // `time` is a generic enough method name where this precaution is necessary to avoid collisions w/ other plugins.
    if (!this._fullCalendar) {
      return oldMomentProto.time.apply(this, arguments);
    }

    if (time == null) {
      // getter
      return moment.duration({
        hours: this.hours(),
        minutes: this.minutes(),
        seconds: this.seconds(),
        milliseconds: this.milliseconds()
      });
    } else {
      // setter
      this._ambigTime = false; // mark that the moment now has a time

      if (!moment.isDuration(time) && !moment.isMoment(time)) {
        time = moment.duration(time);
      } // The day value should cause overflow (so 24 hours becomes 00:00:00 of next day).
      // Only for Duration times, not Moment times.


      var dayHours = 0;

      if (moment.isDuration(time)) {
        dayHours = Math.floor(time.asDays()) * 24;
      } // We need to set the individual fields.
      // Can't use startOf('day') then add duration. In case of DST at start of day.


      return this.hours(dayHours + time.hours()).minutes(time.minutes()).seconds(time.seconds()).milliseconds(time.milliseconds());
    }
  }; // Converts the moment to UTC, stripping out its time-of-day and timezone offset,
  // but preserving its YMD. A moment with a stripped time will display no time
  // nor timezone offset when .format() is called.


  newMomentProto.stripTime = function () {
    if (!this._ambigTime) {
      this.utc(true); // keepLocalTime=true (for keeping *date* value)
      // set time to zero

      this.set({
        hours: 0,
        minutes: 0,
        seconds: 0,
        ms: 0
      }); // Mark the time as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
      // which clears all ambig flags.

      this._ambigTime = true;
      this._ambigZone = true; // if ambiguous time, also ambiguous timezone offset
    }

    return this; // for chaining
  }; // Returns if the moment has a non-ambiguous time (boolean)


  newMomentProto.hasTime = function () {
    return !this._ambigTime;
  }; // Timezone
  // -------------------------------------------------------------------------------------------------
  // Converts the moment to UTC, stripping out its timezone offset, but preserving its
  // YMD and time-of-day. A moment with a stripped timezone offset will display no
  // timezone offset when .format() is called.


  newMomentProto.stripZone = function () {
    var wasAmbigTime;

    if (!this._ambigZone) {
      wasAmbigTime = this._ambigTime;
      this.utc(true); // keepLocalTime=true (for keeping date and time values)
      // the above call to .utc()/.utcOffset() unfortunately might clear the ambig flags, so restore

      this._ambigTime = wasAmbigTime || false; // Mark the zone as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
      // which clears the ambig flags.

      this._ambigZone = true;
    }

    return this; // for chaining
  }; // Returns of the moment has a non-ambiguous timezone offset (boolean)


  newMomentProto.hasZone = function () {
    return !this._ambigZone;
  }; // implicitly marks a zone


  newMomentProto.local = function (keepLocalTime) {
    // for when converting from ambiguously-zoned to local,
    // keep the time values when converting from UTC -> local
    oldMomentProto.local.call(this, this._ambigZone || keepLocalTime); // ensure non-ambiguous
    // this probably already happened via local() -> utcOffset(), but don't rely on Moment's internals

    this._ambigTime = false;
    this._ambigZone = false;
    return this; // for chaining
  }; // implicitly marks a zone


  newMomentProto.utc = function (keepLocalTime) {
    oldMomentProto.utc.call(this, keepLocalTime); // ensure non-ambiguous
    // this probably already happened via utc() -> utcOffset(), but don't rely on Moment's internals

    this._ambigTime = false;
    this._ambigZone = false;
    return this;
  }; // implicitly marks a zone (will probably get called upon .utc() and .local())


  newMomentProto.utcOffset = function (tzo) {
    if (tzo != null) {
      // setter
      // these assignments needs to happen before the original zone method is called.
      // I forget why, something to do with a browser crash.
      this._ambigTime = false;
      this._ambigZone = false;
    }

    return oldMomentProto.utcOffset.apply(this, arguments);
  }; // Formatting
  // -------------------------------------------------------------------------------------------------


  newMomentProto.format = function () {
    if (this._fullCalendar && arguments[0]) {
      // an enhanced moment? and a format string provided?
      return formatDate(this, arguments[0]); // our extended formatting
    }

    if (this._ambigTime) {
      return oldMomentFormat(englishMoment(this), "YYYY-MM-DD");
    }

    if (this._ambigZone) {
      return oldMomentFormat(englishMoment(this), "YYYY-MM-DD[T]HH:mm:ss");
    }

    if (this._fullCalendar) {
      // enhanced non-ambig moment?
      // moment.format() doesn't ensure english, but we want to.
      return oldMomentFormat(englishMoment(this));
    }

    return oldMomentProto.format.apply(this, arguments);
  };

  newMomentProto.toISOString = function () {
    if (this._ambigTime) {
      return oldMomentFormat(englishMoment(this), "YYYY-MM-DD");
    }

    if (this._ambigZone) {
      return oldMomentFormat(englishMoment(this), "YYYY-MM-DD[T]HH:mm:ss");
    }

    if (this._fullCalendar) {
      // enhanced non-ambig moment?
      // depending on browser, moment might not output english. ensure english.
      // https://github.com/moment/moment/blob/2.18.1/src/lib/moment/format.js#L22
      return oldMomentProto.toISOString.apply(englishMoment(this), arguments);
    }

    return oldMomentProto.toISOString.apply(this, arguments);
  };

  function englishMoment(mom) {
    if (mom.locale() !== "en") {
      return mom.clone().locale("en");
    }

    return mom;
  }

  (function () {
    // exports
    FC.formatDate = formatDate;
    FC.formatRange = formatRange;
    FC.oldMomentFormat = oldMomentFormat;
    FC.queryMostGranularFormatUnit = queryMostGranularFormatUnit; // Config
    // ---------------------------------------------------------------------------------------------------------------------

    /*
    Inserted between chunks in the fake ("intermediate") formatting string.
    Important that it passes as whitespace (\s) because moment often identifies non-standalone months
    via a regexp with an \s.
    */

    var PART_SEPARATOR = "\x0B"; // vertical tab

    /*
    Inserted as the first character of a literal-text chunk to indicate that the literal text is not actually literal text,
    but rather, a "special" token that has custom rendering (see specialTokens map).
    */

    var SPECIAL_TOKEN_MARKER = "\x1F"; // information separator 1

    /*
    Inserted at the beginning and end of a span of text that must have non-zero numeric characters.
    Handling of these markers is done in a post-processing step at the very end of text rendering.
    */

    var MAYBE_MARKER = "\x1E"; // information separator 2

    var MAYBE_REGEXP = new RegExp(MAYBE_MARKER + "([^" + MAYBE_MARKER + "]*)" + MAYBE_MARKER, "g"); // must be global

    /*
    Addition formatting tokens we want recognized
    */

    var specialTokens = {
      t: function t(date) {
        // "a" or "p"
        return oldMomentFormat(date, "a").charAt(0);
      },
      T: function T(date) {
        // "A" or "P"
        return oldMomentFormat(date, "A").charAt(0);
      }
    };
    /*
    The first characters of formatting tokens for units that are 1 day or larger.
    `value` is for ranking relative size (lower means bigger).
    `unit` is a normalized unit, used for comparing moments.
    */

    var largeTokenMap = {
      Y: {
        value: 1,
        unit: "year"
      },
      M: {
        value: 2,
        unit: "month"
      },
      W: {
        value: 3,
        unit: "week"
      },
      // ISO week
      w: {
        value: 3,
        unit: "week"
      },
      // local week
      D: {
        value: 4,
        unit: "day"
      },
      // day of month
      d: {
        value: 4,
        unit: "day"
      } // day of week

    }; // Single Date Formatting
    // ---------------------------------------------------------------------------------------------------------------------

    /*
    Formats `date` with a Moment formatting string, but allow our non-zero areas and special token
    */

    function formatDate(date, formatStr) {
      return renderFakeFormatString(getParsedFormatString(formatStr).fakeFormatString, date);
    }
    /*
    Call this if you want Moment's original format method to be used
    */


    function oldMomentFormat(mom, formatStr) {
      return oldMomentProto.format.call(mom, formatStr); // oldMomentProto defined in moment-ext.js
    } // Date Range Formatting
    // -------------------------------------------------------------------------------------------------
    // TODO: make it work with timezone offset

    /*
    Using a formatting string meant for a single date, generate a range string, like
    "Sep 2 - 9 2013", that intelligently inserts a separator where the dates differ.
    If the dates are the same as far as the format string is concerned, just return a single
    rendering of one date, without any separator.
    */


    function formatRange(date1, date2, formatStr, separator, isRTL) {
      var localeData;
      date1 = FC.moment.parseZone(date1);
      date2 = FC.moment.parseZone(date2);
      localeData = date1.localeData(); // Expand localized format strings, like "LL" -> "MMMM D YYYY".
      // BTW, this is not important for `formatDate` because it is impossible to put custom tokens
      // or non-zero areas in Moment's localized format strings.

      formatStr = localeData.longDateFormat(formatStr) || formatStr;
      return renderParsedFormat(getParsedFormatString(formatStr), date1, date2, separator || " - ", isRTL);
    }
    /*
    Renders a range with an already-parsed format string.
    */


    function renderParsedFormat(parsedFormat, date1, date2, separator, isRTL) {
      var sameUnits = parsedFormat.sameUnits;
      var unzonedDate1 = date1.clone().stripZone(); // for same-unit comparisons

      var unzonedDate2 = date2.clone().stripZone(); // "

      var renderedParts1 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date1);
      var renderedParts2 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date2);
      var leftI;
      var leftStr = "";
      var rightI;
      var rightStr = "";
      var middleI;
      var middleStr1 = "";
      var middleStr2 = "";
      var middleStr = ""; // Start at the leftmost side of the formatting string and continue until you hit a token
      // that is not the same between dates.

      for (leftI = 0; leftI < sameUnits.length && (!sameUnits[leftI] || unzonedDate1.isSame(unzonedDate2, sameUnits[leftI])); leftI++) {
        leftStr += renderedParts1[leftI];
      } // Similarly, start at the rightmost side of the formatting string and move left


      for (rightI = sameUnits.length - 1; rightI > leftI && (!sameUnits[rightI] || unzonedDate1.isSame(unzonedDate2, sameUnits[rightI])); rightI--) {
        // If current chunk is on the boundary of unique date-content, and is a special-case
        // date-formatting postfix character, then don't consume it. Consider it unique date-content.
        // TODO: make configurable
        if (rightI - 1 === leftI && renderedParts1[rightI] === ".") {
          break;
        }

        rightStr = renderedParts1[rightI] + rightStr;
      } // The area in the middle is different for both of the dates.
      // Collect them distinctly so we can jam them together later.


      for (middleI = leftI; middleI <= rightI; middleI++) {
        middleStr1 += renderedParts1[middleI];
        middleStr2 += renderedParts2[middleI];
      }

      if (middleStr1 || middleStr2) {
        if (isRTL) {
          middleStr = middleStr2 + separator + middleStr1;
        } else {
          middleStr = middleStr1 + separator + middleStr2;
        }
      }

      return processMaybeMarkers(leftStr + middleStr + rightStr);
    } // Format String Parsing
    // ---------------------------------------------------------------------------------------------------------------------


    var parsedFormatStrCache = {};
    /*
    Returns a parsed format string, leveraging a cache.
    */

    function getParsedFormatString(formatStr) {
      return parsedFormatStrCache[formatStr] || (parsedFormatStrCache[formatStr] = parseFormatString(formatStr));
    }
    /*
    Parses a format string into the following:
    - fakeFormatString: a momentJS formatting string, littered with special control characters that get post-processed.
    - sameUnits: for every part in fakeFormatString, if the part is a token, the value will be a unit string (like "day"),
    that indicates how similar a range's start & end must be in order to share the same formatted text.
    If not a token, then the value is null.
    Always a flat array (not nested liked "chunks").
    */


    function parseFormatString(formatStr) {
      var chunks = chunkFormatString(formatStr);
      return {
        fakeFormatString: buildFakeFormatString(chunks),
        sameUnits: buildSameUnits(chunks)
      };
    }
    /*
    Break the formatting string into an array of chunks.
    A 'maybe' chunk will have nested chunks.
    */


    function chunkFormatString(formatStr) {
      var chunks = [];
      var match; // TODO: more descrimination
      // \4 is a backreference to the first character of a multi-character set.

      var chunker = /\[([^\]]*)\]|\(([^\)]*)\)|(LTS|LT|(\w)\4*o?)|([^\w\[\(]+)/g;

      while (match = chunker.exec(formatStr)) {
        if (match[1]) {
          // a literal string inside [ ... ]
          chunks.push.apply(chunks, // append
          splitStringLiteral(match[1]));
        } else if (match[2]) {
          // non-zero formatting inside ( ... )
          chunks.push({
            maybe: chunkFormatString(match[2])
          });
        } else if (match[3]) {
          // a formatting token
          chunks.push({
            token: match[3]
          });
        } else if (match[5]) {
          // an unenclosed literal string
          chunks.push.apply(chunks, // append
          splitStringLiteral(match[5]));
        }
      }

      return chunks;
    }
    /*
    Potentially splits a literal-text string into multiple parts. For special cases.
    */


    function splitStringLiteral(s) {
      if (s === ". ") {
        return [".", " "]; // for locales with periods bound to the end of each year/month/date
      } else {
        return [s];
      }
    }
    /*
    Given chunks parsed from a real format string, generate a fake (aka "intermediate") format string with special control
    characters that will eventually be given to moment for formatting, and then post-processed.
    */


    function buildFakeFormatString(chunks) {
      var parts = [];
      var i, chunk;

      for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];

        if (typeof chunk === "string") {
          parts.push("[" + chunk + "]");
        } else if (chunk.token) {
          if (chunk.token in specialTokens) {
            parts.push(SPECIAL_TOKEN_MARKER + // useful during post-processing
            "[" + chunk.token + "]" // preserve as literal text
            );
          } else {
            parts.push(chunk.token); // unprotected text implies a format string
          }
        } else if (chunk.maybe) {
          parts.push(MAYBE_MARKER + // useful during post-processing
          buildFakeFormatString(chunk.maybe) + MAYBE_MARKER);
        }
      }

      return parts.join(PART_SEPARATOR);
    }
    /*
    Given parsed chunks from a real formatting string, generates an array of unit strings (like "day") that indicate
    in which regard two dates must be similar in order to share range formatting text.
    The `chunks` can be nested (because of "maybe" chunks), however, the returned array will be flat.
    */


    function buildSameUnits(chunks) {
      var units = [];
      var i, chunk;
      var tokenInfo;

      for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];

        if (chunk.token) {
          tokenInfo = largeTokenMap[chunk.token.charAt(0)];
          units.push(tokenInfo ? tokenInfo.unit : "second"); // default to a very strict same-second
        } else if (chunk.maybe) {
          units.push.apply(units, // append
          buildSameUnits(chunk.maybe));
        } else {
          units.push(null);
        }
      }

      return units;
    } // Rendering to text
    // ---------------------------------------------------------------------------------------------------------------------

    /*
    Formats a date with a fake format string, post-processes the control characters, then returns.
    */


    function renderFakeFormatString(fakeFormatString, date) {
      return processMaybeMarkers(renderFakeFormatStringParts(fakeFormatString, date).join(""));
    }
    /*
    Formats a date into parts that will have been post-processed, EXCEPT for the "maybe" markers.
    */


    function renderFakeFormatStringParts(fakeFormatString, date) {
      var parts = [];
      var fakeRender = oldMomentFormat(date, fakeFormatString);
      var fakeParts = fakeRender.split(PART_SEPARATOR);
      var i, fakePart;

      for (i = 0; i < fakeParts.length; i++) {
        fakePart = fakeParts[i];

        if (fakePart.charAt(0) === SPECIAL_TOKEN_MARKER) {
          parts.push( // the literal string IS the token's name.
          // call special token's registered function.
          specialTokens[fakePart.substring(1)](date));
        } else {
          parts.push(fakePart);
        }
      }

      return parts;
    }
    /*
    Accepts an almost-finally-formatted string and processes the "maybe" control characters, returning a new string.
    */


    function processMaybeMarkers(s) {
      return s.replace(MAYBE_REGEXP, function (m0, m1) {
        // regex assumed to have 'g' flag
        if (m1.match(/[1-9]/)) {
          // any non-zero numeric characters?
          return m1;
        } else {
          return "";
        }
      });
    } // Misc Utils
    // -------------------------------------------------------------------------------------------------

    /*
    Returns a unit string, either 'year', 'month', 'day', or null for the most granular formatting token in the string.
    */


    function queryMostGranularFormatUnit(formatStr) {
      var chunks = chunkFormatString(formatStr);
      var i, chunk;
      var candidate;
      var best;

      for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];

        if (chunk.token) {
          candidate = largeTokenMap[chunk.token.charAt(0)];

          if (candidate) {
            if (!best || candidate.value > best.value) {
              best = candidate;
            }
          }
        }
      }

      if (best) {
        return best.unit;
      }

      return null;
    }
  })(); // quick local references


  var formatDate = FC.formatDate;
  var _formatRange = FC.formatRange;
  var oldMomentFormat = FC.oldMomentFormat;
  FC.Class = Class; // export
  // Class that all other classes will inherit from

  function Class() {} // Called on a class to create a subclass.
  // Last argument contains instance methods. Any argument before the last are considered mixins.


  Class.extend = function () {
    var members = {};
    var i;

    for (i = 0; i < arguments.length; i++) {
      copyOwnProps(arguments[i], members);
    }

    return extendClass(this, members);
  }; // Adds new member variables/methods to the class's prototype.
  // Can be called with another class, or a plain object hash containing new members.


  Class.mixin = function (members) {
    copyOwnProps(members, this.prototype);
  };

  function extendClass(superClass, members) {
    var subClass; // ensure a constructor for the subclass, forwarding all arguments to the super-constructor if it doesn't exist

    if (hasOwnProp(members, "constructor")) {
      subClass = members.constructor;
    }

    if (typeof subClass !== "function") {
      subClass = members.constructor = function () {
        superClass.apply(this, arguments);
      };
    } // build the base prototype for the subclass, which is an new object chained to the superclass's prototype


    subClass.prototype = Object.create(superClass.prototype); // copy each member variable/method onto the the subclass's prototype

    copyOwnProps(members, subClass.prototype); // copy over all class variables/methods to the subclass, such as `extend` and `mixin`

    copyOwnProps(superClass, subClass);
    return subClass;
  }

  var EmitterMixin = FC.EmitterMixin = {
    // jQuery-ification via $(this) allows a non-DOM object to have
    // the same event handling capabilities (including namespaces).
    on: function on(types, handler) {
      $(this).on(types, this._prepareIntercept(handler));
      return this; // for chaining
    },
    one: function one(types, handler) {
      $(this).one(types, this._prepareIntercept(handler));
      return this; // for chaining
    },
    _prepareIntercept: function _prepareIntercept(handler) {
      // handlers are always called with an "event" object as their first param.
      // sneak the `this` context and arguments into the extra parameter object
      // and forward them on to the original handler.
      var intercept = function intercept(ev, extra) {
        return handler.apply(extra.context || this, extra.args || []);
      }; // mimick jQuery's internal "proxy" system (risky, I know)
      // causing all functions with the same .guid to appear to be the same.
      // https://github.com/jquery/jquery/blob/2.2.4/src/core.js#L448
      // this is needed for calling .off with the original non-intercept handler.


      if (!handler.guid) {
        handler.guid = $.guid++;
      }

      intercept.guid = handler.guid;
      return intercept;
    },
    off: function off(types, handler) {
      $(this).off(types, handler);
      return this; // for chaining
    },
    trigger: function trigger(types) {
      var args = Array.prototype.slice.call(arguments, 1); // arguments after the first
      // pass in "extra" info to the intercept

      $(this).triggerHandler(types, {
        args: args
      });
      return this; // for chaining
    },
    triggerWith: function triggerWith(types, context, args) {
      // `triggerHandler` is less reliant on the DOM compared to `trigger`.
      // pass in "extra" info to the intercept.
      $(this).triggerHandler(types, {
        context: context,
        args: args
      });
      return this; // for chaining
    },
    hasHandlers: function hasHandlers(type) {
      var hash = $._data(this, "events"); // http://blog.jquery.com/2012/08/09/jquery-1-8-released/


      return hash && hash[type] && hash[type].length > 0;
    }
  };
  /*
  Utility methods for easily listening to events on another object,
  and more importantly, easily unlistening from them.
  */

  var ListenerMixin = FC.ListenerMixin = function () {
    var guid = 0;
    var ListenerMixin = {
      listenerId: null,

      /*
      Given an `other` object that has on/off methods, bind the given `callback` to an event by the given name.
      The `callback` will be called with the `this` context of the object that .listenTo is being called on.
      Can be called:
      .listenTo(other, eventName, callback)
      OR
      .listenTo(other, {
      eventName1: callback1,
      eventName2: callback2
      })
      */
      listenTo: function listenTo(other, arg, callback) {
        if (_typeof(arg) === "object") {
          // given dictionary of callbacks
          for (var eventName in arg) {
            if (arg.hasOwnProperty(eventName)) {
              this.listenTo(other, eventName, arg[eventName]);
            }
          }
        } else if (typeof arg === "string") {
          other.on(arg + "." + this.getListenerNamespace(), // use event namespacing to identify this object
          $.proxy(callback, this) // always use `this` context
          // the usually-undesired jQuery guid behavior doesn't matter,
          // because we always unbind via namespace
          );
        }
      },

      /*
      Causes the current object to stop listening to events on the `other` object.
      `eventName` is optional. If omitted, will stop listening to ALL events on `other`.
      */
      stopListeningTo: function stopListeningTo(other, eventName) {
        other.off((eventName || "") + "." + this.getListenerNamespace());
      },

      /*
      Returns a string, unique to this object, to be used for event namespacing
      */
      getListenerNamespace: function getListenerNamespace() {
        if (this.listenerId == null) {
          this.listenerId = guid++;
        }

        return "_listener" + this.listenerId;
      }
    };
    return ListenerMixin;
  }();

  var ParsableModelMixin = {
    standardPropMap: {},
    // will be cloned by defineStandardProps

    /*
    Returns true/false for success.
    Meant to be only called ONCE, at object creation.
    */
    applyProps: function applyProps(rawProps) {
      var standardPropMap = this.standardPropMap;
      var manualProps = {};
      var miscProps = {};
      var propName;

      for (propName in rawProps) {
        if (standardPropMap[propName] === true) {
          // copy verbatim
          this[propName] = rawProps[propName];
        } else if (standardPropMap[propName] === false) {
          manualProps[propName] = rawProps[propName];
        } else {
          miscProps[propName] = rawProps[propName];
        }
      }

      this.applyMiscProps(miscProps);
      return this.applyManualStandardProps(manualProps);
    },

    /*
    If subclasses override, they must call this supermethod and return the boolean response.
    Meant to be only called ONCE, at object creation.
    */
    applyManualStandardProps: function applyManualStandardProps(rawProps) {
      return true;
    },

    /*
    Can be called even after initial object creation.
    */
    applyMiscProps: function applyMiscProps(rawProps) {// subclasses can implement
    },

    /*
    TODO: why is this a method when defineStandardProps is static
    */
    isStandardProp: function isStandardProp(propName) {
      return propName in this.standardPropMap;
    }
  };
  /*
  TODO: devise a better system
  */

  var ParsableModelMixin_defineStandardProps = function ParsableModelMixin_defineStandardProps(propDefs) {
    var proto = this.prototype;

    if (!proto.hasOwnProperty("standardPropMap")) {
      proto.standardPropMap = Object.create(proto.standardPropMap);
    }

    copyOwnProps(propDefs, proto.standardPropMap);
  };
  /*
  TODO: devise a better system
  */


  var ParsableModelMixin_copyVerbatimStandardProps = function ParsableModelMixin_copyVerbatimStandardProps(src, dest) {
    var map = this.prototype.standardPropMap;
    var propName;

    for (propName in map) {
      if (src[propName] != null && // in the src object?
      map[propName] === true // false means "copy verbatim"
      ) {
        dest[propName] = src[propName];
      }
    }
  };

  var Model = Class.extend(EmitterMixin, ListenerMixin, {
    _props: null,
    _watchers: null,
    _globalWatchArgs: {},
    // mutation protection in Model.watch
    constructor: function constructor() {
      this._watchers = {};
      this._props = {};
      this.applyGlobalWatchers();
      this.constructed();
    },
    // useful for monkeypatching. TODO: BaseClass?
    constructed: function constructed() {},
    applyGlobalWatchers: function applyGlobalWatchers() {
      var map = this._globalWatchArgs;
      var name;

      for (name in map) {
        this.watch.apply(this, map[name]);
      }
    },
    has: function has(name) {
      return name in this._props;
    },
    get: function get(name) {
      if (name === undefined) {
        return this._props;
      }

      return this._props[name];
    },
    set: function set(name, val) {
      var newProps;

      if (typeof name === "string") {
        newProps = {};
        newProps[name] = val === undefined ? null : val;
      } else {
        newProps = name;
      }

      this.setProps(newProps);
    },
    reset: function reset(newProps) {
      var oldProps = this._props;
      var changeset = {}; // will have undefined's to signal unsets

      var name;

      for (name in oldProps) {
        changeset[name] = undefined;
      }

      for (name in newProps) {
        changeset[name] = newProps[name];
      }

      this.setProps(changeset);
    },
    unset: function unset(name) {
      // accepts a string or array of strings
      var newProps = {};
      var names;
      var i;

      if (typeof name === "string") {
        names = [name];
      } else {
        names = name;
      }

      for (i = 0; i < names.length; i++) {
        newProps[names[i]] = undefined;
      }

      this.setProps(newProps);
    },
    setProps: function setProps(newProps) {
      var changedProps = {};
      var changedCnt = 0;
      var name, val;

      for (name in newProps) {
        val = newProps[name]; // a change in value?
        // if an object, don't check equality, because might have been mutated internally.
        // TODO: eventually enforce immutability.

        if (_typeof(val) === "object" || val !== this._props[name]) {
          changedProps[name] = val;
          changedCnt++;
        }
      }

      if (changedCnt) {
        this.trigger("before:batchChange", changedProps);

        for (name in changedProps) {
          val = changedProps[name];
          this.trigger("before:change", name, val);
          this.trigger("before:change:" + name, val);
        }

        for (name in changedProps) {
          val = changedProps[name];

          if (val === undefined) {
            delete this._props[name];
          } else {
            this._props[name] = val;
          }

          this.trigger("change:" + name, val);
          this.trigger("change", name, val);
        }

        this.trigger("batchChange", changedProps);
      }
    },
    watch: function watch(name, depList, startFunc, stopFunc) {
      var _this = this;

      this.unwatch(name);
      this._watchers[name] = this._watchDeps(depList, function (deps) {
        var res = startFunc.call(_this, deps);

        if (res && res.then) {
          _this.unset(name); // put in an unset state while resolving


          res.then(function (val) {
            _this.set(name, val);
          });
        } else {
          _this.set(name, res);
        }
      }, function (deps) {
        _this.unset(name);

        if (stopFunc) {
          stopFunc.call(_this, deps);
        }
      });
    },
    unwatch: function unwatch(name) {
      var watcher = this._watchers[name];

      if (watcher) {
        delete this._watchers[name];
        watcher.teardown();
      }
    },
    _watchDeps: function _watchDeps(depList, startFunc, stopFunc) {
      var _this = this;

      var queuedChangeCnt = 0;
      var depCnt = depList.length;
      var satisfyCnt = 0;
      var values = {}; // what's passed as the `deps` arguments

      var bindTuples = []; // array of [ eventName, handlerFunc ] arrays

      var isCallingStop = false;

      function onBeforeDepChange(depName, val, isOptional) {
        queuedChangeCnt++;

        if (queuedChangeCnt === 1) {
          // first change to cause a "stop" ?
          if (satisfyCnt === depCnt) {
            // all deps previously satisfied?
            isCallingStop = true;
            stopFunc(values);
            isCallingStop = false;
          }
        }
      }

      function onDepChange(depName, val, isOptional) {
        if (val === undefined) {
          // unsetting a value?
          // required dependency that was previously set?
          if (!isOptional && values[depName] !== undefined) {
            satisfyCnt--;
          }

          delete values[depName];
        } else {
          // setting a value?
          // required dependency that was previously unset?
          if (!isOptional && values[depName] === undefined) {
            satisfyCnt++;
          }

          values[depName] = val;
        }

        queuedChangeCnt--;

        if (!queuedChangeCnt) {
          // last change to cause a "start"?
          // now finally satisfied or satisfied all along?
          if (satisfyCnt === depCnt) {
            // if the stopFunc initiated another value change, ignore it.
            // it will be processed by another change event anyway.
            if (!isCallingStop) {
              startFunc(values);
            }
          }
        }
      } // intercept for .on() that remembers handlers


      function bind(eventName, handler) {
        _this.on(eventName, handler);

        bindTuples.push([eventName, handler]);
      } // listen to dependency changes


      depList.forEach(function (depName) {
        var isOptional = false;

        if (depName.charAt(0) === "?") {
          // TODO: more DRY
          depName = depName.substring(1);
          isOptional = true;
        }

        bind("before:change:" + depName, function (val) {
          onBeforeDepChange(depName, val, isOptional);
        });
        bind("change:" + depName, function (val) {
          onDepChange(depName, val, isOptional);
        });
      }); // process current dependency values

      depList.forEach(function (depName) {
        var isOptional = false;

        if (depName.charAt(0) === "?") {
          // TODO: more DRY
          depName = depName.substring(1);
          isOptional = true;
        }

        if (_this.has(depName)) {
          values[depName] = _this.get(depName);
          satisfyCnt++;
        } else if (isOptional) {
          satisfyCnt++;
        }
      }); // initially satisfied

      if (satisfyCnt === depCnt) {
        startFunc(values);
      }

      return {
        teardown: function teardown() {
          // remove all handlers
          for (var i = 0; i < bindTuples.length; i++) {
            _this.off(bindTuples[i][0], bindTuples[i][1]);
          }

          bindTuples = null; // was satisfied, so call stopFunc

          if (satisfyCnt === depCnt) {
            stopFunc();
          }
        },
        flash: function flash() {
          if (satisfyCnt === depCnt) {
            stopFunc();
            startFunc(values);
          }
        }
      };
    },
    flash: function flash(name) {
      var watcher = this._watchers[name];

      if (watcher) {
        watcher.flash();
      }
    }
  });

  Model.watch = function (name
  /* , depList, startFunc, stopFunc */
  ) {
    // subclasses should make a masked-copy of the superclass's map
    // TODO: write test
    if (!this.prototype.hasOwnProperty("_globalWatchArgs")) {
      this.prototype._globalWatchArgs = Object.create(this.prototype._globalWatchArgs);
    }

    this.prototype._globalWatchArgs[name] = arguments;
  };

  FC.Model = Model;
  var Promise = {
    construct: function construct(executor) {
      var deferred = $.Deferred();
      var promise = deferred.promise();

      if (typeof executor === "function") {
        executor(function (val) {
          // resolve
          deferred.resolve(val);
          attachImmediatelyResolvingThen(promise, val);
        }, function () {
          // reject
          deferred.reject();
          attachImmediatelyRejectingThen(promise);
        });
      }

      return promise;
    },
    resolve: function resolve(val) {
      var deferred = $.Deferred().resolve(val);
      var promise = deferred.promise();
      attachImmediatelyResolvingThen(promise, val);
      return promise;
    },
    reject: function reject() {
      var deferred = $.Deferred().reject();
      var promise = deferred.promise();
      attachImmediatelyRejectingThen(promise);
      return promise;
    }
  };

  function attachImmediatelyResolvingThen(promise, val) {
    promise.then = function (onResolve) {
      if (typeof onResolve === "function") {
        return Promise.resolve(onResolve(val));
      }

      return promise;
    };
  }

  function attachImmediatelyRejectingThen(promise) {
    promise.then = function (onResolve, onReject) {
      if (typeof onReject === "function") {
        onReject();
      }

      return promise;
    };
  }

  FC.Promise = Promise;
  var TaskQueue = Class.extend(EmitterMixin, {
    q: null,
    isPaused: false,
    isRunning: false,
    constructor: function constructor() {
      this.q = [];
    },
    queue: function
      /* taskFunc, taskFunc... */
    queue() {
      this.q.push.apply(this.q, arguments); // append

      this.tryStart();
    },
    pause: function pause() {
      this.isPaused = true;
    },
    resume: function resume() {
      this.isPaused = false;
      this.tryStart();
    },
    getIsIdle: function getIsIdle() {
      return !this.isRunning && !this.isPaused;
    },
    tryStart: function tryStart() {
      if (!this.isRunning && this.canRunNext()) {
        this.isRunning = true;
        this.trigger("start");
        this.runRemaining();
      }
    },
    canRunNext: function canRunNext() {
      return !this.isPaused && this.q.length;
    },
    runRemaining: function runRemaining() {
      // assumes at least one task in queue. does not check canRunNext for first task.
      var _this = this;

      var task;
      var res;

      do {
        task = this.q.shift(); // always freshly reference q. might have been reassigned.

        res = this.runTask(task);

        if (res && res.then) {
          res.then(function () {
            // jshint ignore:line
            if (_this.canRunNext()) {
              _this.runRemaining();
            }
          });
          return; // prevent marking as stopped
        }
      } while (this.canRunNext());

      this.trigger("stop"); // not really a 'stop' ... more of a 'drained'

      this.isRunning = false; // if 'stop' handler added more tasks.... TODO: write test for this

      this.tryStart();
    },
    runTask: function runTask(task) {
      return task(); // task *is* the function, but subclasses can change the format of a task
    }
  });
  FC.TaskQueue = TaskQueue;
  var RenderQueue = TaskQueue.extend({
    waitsByNamespace: null,
    waitNamespace: null,
    waitId: null,
    constructor: function constructor(waitsByNamespace) {
      TaskQueue.call(this); // super-constructor

      this.waitsByNamespace = waitsByNamespace || {};
    },
    queue: function queue(taskFunc, namespace, type) {
      var task = {
        func: taskFunc,
        namespace: namespace,
        type: type
      };
      var waitMs;

      if (namespace) {
        waitMs = this.waitsByNamespace[namespace];
      }

      if (this.waitNamespace) {
        if (namespace === this.waitNamespace && waitMs != null) {
          this.delayWait(waitMs);
        } else {
          this.clearWait();
          this.tryStart();
        }
      }

      if (this.compoundTask(task)) {
        // appended to queue?
        if (!this.waitNamespace && waitMs != null) {
          this.startWait(namespace, waitMs);
        } else {
          this.tryStart();
        }
      }
    },
    startWait: function startWait(namespace, waitMs) {
      this.waitNamespace = namespace;
      this.spawnWait(waitMs);
    },
    delayWait: function delayWait(waitMs) {
      clearTimeout(this.waitId);
      this.spawnWait(waitMs);
    },
    spawnWait: function spawnWait(waitMs) {
      var _this = this;

      this.waitId = setTimeout(function () {
        _this.waitNamespace = null;

        _this.tryStart();
      }, waitMs);
    },
    clearWait: function clearWait() {
      if (this.waitNamespace) {
        clearTimeout(this.waitId);
        this.waitId = null;
        this.waitNamespace = null;
      }
    },
    canRunNext: function canRunNext() {
      if (!TaskQueue.prototype.canRunNext.apply(this, arguments)) {
        return false;
      } // waiting for a certain namespace to stop receiving tasks?


      if (this.waitNamespace) {
        // if there was a different namespace task in the meantime,
        // that forces all previously-waiting tasks to suddenly execute.
        // TODO: find a way to do this in constant time.
        for (var q = this.q, i = 0; i < q.length; i++) {
          if (q[i].namespace !== this.waitNamespace) {
            return true; // allow execution
          }
        }

        return false;
      }

      return true;
    },
    runTask: function runTask(task) {
      task.func();
    },
    compoundTask: function compoundTask(newTask) {
      var q = this.q;
      var shouldAppend = true;
      var i, task;

      if (newTask.namespace && newTask.type === "destroy") {
        // remove all init/add/remove ops with same namespace, regardless of order
        for (i = q.length - 1; i >= 0; i--) {
          task = q[i];

          switch (task.type) {
            case "init":
              shouldAppend = false;
            // jshint ignore:line
            // the latest destroy is cancelled out by not doing the init
            // and fallthrough....

            case "add":
            case "remove":
              q.splice(i, 1);
            // remove task
          }
        }
      }

      if (shouldAppend) {
        q.push(newTask);
      }

      return shouldAppend;
    }
  });
  FC.RenderQueue = RenderQueue;
  /* A rectangular panel that is absolutely positioned over other content
  ------------------------------------------------------------------------------------------------------------------------
  Options:
  - className (string)
  - content (HTML string or jQuery element set)
  - parentEl
  - top
  - left
  - right (the x coord of where the right edge should be. not a "CSS" right)
  - autoHide (boolean)
  - show (callback)
  - hide (callback)
  */

  var Popover = Class.extend(ListenerMixin, {
    isHidden: true,
    options: null,
    el: null,
    // the container element for the popover. generated by this object
    margin: 10,
    // the space required between the popover and the edges of the scroll container
    constructor: function constructor(options) {
      this.options = options || {};
    },
    // Shows the popover on the specified position. Renders it if not already
    show: function show() {
      if (this.isHidden) {
        if (!this.el) {
          this.render();
        }

        this.el.show();
        this.position();
        this.isHidden = false;
        this.trigger("show");
      }
    },
    // Hides the popover, through CSS, but does not remove it from the DOM
    hide: function hide() {
      if (!this.isHidden) {
        this.el.hide();
        this.isHidden = true;
        this.trigger("hide");
      }
    },
    // Creates `this.el` and renders content inside of it
    render: function render() {
      var _this = this;

      var options = this.options;
      this.el = $('<div class="fc-popover"/>').addClass(options.className || "").css({
        // position initially to the top left to avoid creating scrollbars
        top: 0,
        left: 0
      }).append(options.content).appendTo(options.parentEl); // when a click happens on anything inside with a 'fc-close' className, hide the popover

      this.el.on("click", ".fc-close", function () {
        _this.hide();
      });

      if (options.autoHide) {
        this.listenTo($(document), "mousedown", this.documentMousedown);
      }
    },
    // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
    documentMousedown: function documentMousedown(ev) {
      // only hide the popover if the click happened outside the popover
      if (this.el && !$(ev.target).closest(this.el).length) {
        this.hide();
      }
    },
    // Hides and unregisters any handlers
    removeElement: function removeElement() {
      this.hide();

      if (this.el) {
        this.el.remove();
        this.el = null;
      }

      this.stopListeningTo($(document), "mousedown");
    },
    // Positions the popover optimally, using the top/left/right options
    position: function position() {
      var options = this.options;
      var origin = this.el.offsetParent().offset();
      var width = this.el.outerWidth();
      var height = this.el.outerHeight();
      var windowEl = $(window);
      var viewportEl = getScrollParent(this.el);
      var viewportTop;
      var viewportLeft;
      var viewportOffset;
      var top; // the "position" (not "offset") values for the popover

      var left; //
      // compute top and left

      top = options.top || 0;

      if (options.left !== undefined) {
        left = options.left;
      } else if (options.right !== undefined) {
        left = options.right - width; // derive the left value from the right value
      } else {
        left = 0;
      }

      if (viewportEl.is(window) || viewportEl.is(document)) {
        // normalize getScrollParent's result
        viewportEl = windowEl;
        viewportTop = 0; // the window is always at the top left

        viewportLeft = 0; // (and .offset() won't work if called here)
      } else {
        viewportOffset = viewportEl.offset();
        viewportTop = viewportOffset.top;
        viewportLeft = viewportOffset.left;
      } // if the window is scrolled, it causes the visible area to be further down


      viewportTop += windowEl.scrollTop();
      viewportLeft += windowEl.scrollLeft(); // constrain to the view port. if constrained by two edges, give precedence to top/left

      if (options.viewportConstrain !== false) {
        top = Math.min(top, viewportTop + viewportEl.outerHeight() - height - this.margin);
        top = Math.max(top, viewportTop + this.margin);
        left = Math.min(left, viewportLeft + viewportEl.outerWidth() - width - this.margin);
        left = Math.max(left, viewportLeft + this.margin);
      }

      this.el.css({
        top: top - origin.top,
        left: left - origin.left
      });
    },
    // Triggers a callback. Calls a function in the option hash of the same name.
    // Arguments beyond the first `name` are forwarded on.
    // TODO: better code reuse for this. Repeat code
    trigger: function trigger(name) {
      if (this.options[name]) {
        this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
      }
    }
  });
  /*
  A cache for the left/right/top/bottom/width/height values for one or more elements.
  Works with both offset (from topleft document) and position (from offsetParent).
  options:
  - els
  - isHorizontal
  - isVertical
  */

  var CoordCache = FC.CoordCache = Class.extend({
    els: null,
    // jQuery set (assumed to be siblings)
    forcedOffsetParentEl: null,
    // options can override the natural offsetParent
    origin: null,
    // {left,top} position of offsetParent of els
    boundingRect: null,
    // constrain cordinates to this rectangle. {left,right,top,bottom} or null
    isHorizontal: false,
    // whether to query for left/right/width
    isVertical: false,
    // whether to query for top/bottom/height
    // arrays of coordinates (offsets from topleft of document)
    lefts: null,
    rights: null,
    tops: null,
    bottoms: null,
    constructor: function constructor(options) {
      this.els = $(options.els);
      this.isHorizontal = options.isHorizontal;
      this.isVertical = options.isVertical;
      this.forcedOffsetParentEl = options.offsetParent ? $(options.offsetParent) : null;
    },
    // Queries the els for coordinates and stores them.
    // Call this method before using and of the get* methods below.
    build: function build() {
      var offsetParentEl = this.forcedOffsetParentEl;

      if (!offsetParentEl && this.els.length > 0) {
        offsetParentEl = this.els.eq(0).offsetParent();
      }

      this.origin = offsetParentEl ? offsetParentEl.offset() : null;
      this.boundingRect = this.queryBoundingRect();

      if (this.isHorizontal) {
        this.buildElHorizontals();
      }

      if (this.isVertical) {
        this.buildElVerticals();
      }
    },
    // Destroys all internal data about coordinates, freeing memory
    clear: function clear() {
      this.origin = null;
      this.boundingRect = null;
      this.lefts = null;
      this.rights = null;
      this.tops = null;
      this.bottoms = null;
    },
    // When called, if coord caches aren't built, builds them
    ensureBuilt: function ensureBuilt() {
      if (!this.origin) {
        this.build();
      }
    },
    // Populates the left/right internal coordinate arrays
    buildElHorizontals: function buildElHorizontals() {
      var lefts = [];
      var rights = [];
      this.els.each(function (i, node) {
        var el = $(node);
        var left = el.offset().left;
        var width = el.outerWidth();
        lefts.push(left);
        rights.push(left + width);
      });
      this.lefts = lefts;
      this.rights = rights;
    },
    // Populates the top/bottom internal coordinate arrays
    buildElVerticals: function buildElVerticals() {
      var tops = [];
      var bottoms = [];
      this.els.each(function (i, node) {
        var el = $(node);
        var top = el.offset().top;
        var height = el.outerHeight();
        tops.push(top);
        bottoms.push(top + height);
      });
      this.tops = tops;
      this.bottoms = bottoms;
    },
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    getHorizontalIndex: function getHorizontalIndex(leftOffset) {
      this.ensureBuilt();
      var lefts = this.lefts;
      var rights = this.rights;
      var len = lefts.length;
      var i;

      for (i = 0; i < len; i++) {
        if (leftOffset >= lefts[i] && leftOffset < rights[i]) {
          return i;
        }
      }
    },
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    getVerticalIndex: function getVerticalIndex(topOffset) {
      this.ensureBuilt();
      var tops = this.tops;
      var bottoms = this.bottoms;
      var len = tops.length;
      var i;

      for (i = 0; i < len; i++) {
        if (topOffset >= tops[i] && topOffset < bottoms[i]) {
          return i;
        }
      }
    },
    // Gets the left offset (from document left) of the element at the given index
    getLeftOffset: function getLeftOffset(leftIndex) {
      this.ensureBuilt();
      return this.lefts[leftIndex];
    },
    // Gets the left position (from offsetParent left) of the element at the given index
    getLeftPosition: function getLeftPosition(leftIndex) {
      this.ensureBuilt();
      return this.lefts[leftIndex] - this.origin.left;
    },
    // Gets the right offset (from document left) of the element at the given index.
    // This value is NOT relative to the document's right edge, like the CSS concept of "right" would be.
    getRightOffset: function getRightOffset(leftIndex) {
      this.ensureBuilt();
      return this.rights[leftIndex];
    },
    // Gets the right position (from offsetParent left) of the element at the given index.
    // This value is NOT relative to the offsetParent's right edge, like the CSS concept of "right" would be.
    getRightPosition: function getRightPosition(leftIndex) {
      this.ensureBuilt();
      return this.rights[leftIndex] - this.origin.left;
    },
    // Gets the width of the element at the given index
    getWidth: function getWidth(leftIndex) {
      this.ensureBuilt();
      return this.rights[leftIndex] - this.lefts[leftIndex];
    },
    // Gets the top offset (from document top) of the element at the given index
    getTopOffset: function getTopOffset(topIndex) {
      this.ensureBuilt();
      return this.tops[topIndex];
    },
    // Gets the top position (from offsetParent top) of the element at the given position
    getTopPosition: function getTopPosition(topIndex) {
      this.ensureBuilt();
      return this.tops[topIndex] - this.origin.top;
    },
    // Gets the bottom offset (from the document top) of the element at the given index.
    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
    getBottomOffset: function getBottomOffset(topIndex) {
      this.ensureBuilt();
      return this.bottoms[topIndex];
    },
    // Gets the bottom position (from the offsetParent top) of the element at the given index.
    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
    getBottomPosition: function getBottomPosition(topIndex) {
      this.ensureBuilt();
      return this.bottoms[topIndex] - this.origin.top;
    },
    // Gets the height of the element at the given index
    getHeight: function getHeight(topIndex) {
      this.ensureBuilt();
      return this.bottoms[topIndex] - this.tops[topIndex];
    },
    // Bounding Rect
    // TODO: decouple this from CoordCache
    // Compute and return what the elements' bounding rectangle is, from the user's perspective.
    // Right now, only returns a rectangle if constrained by an overflow:scroll element.
    // Returns null if there are no elements
    queryBoundingRect: function queryBoundingRect() {
      var scrollParentEl;

      if (this.els.length > 0) {
        scrollParentEl = getScrollParent(this.els.eq(0));

        if (!scrollParentEl.is(document)) {
          return getClientRect(scrollParentEl);
        }
      }

      return null;
    },
    isPointInBounds: function isPointInBounds(leftOffset, topOffset) {
      return this.isLeftInBounds(leftOffset) && this.isTopInBounds(topOffset);
    },
    isLeftInBounds: function isLeftInBounds(leftOffset) {
      return !this.boundingRect || leftOffset >= this.boundingRect.left && leftOffset < this.boundingRect.right;
    },
    isTopInBounds: function isTopInBounds(topOffset) {
      return !this.boundingRect || topOffset >= this.boundingRect.top && topOffset < this.boundingRect.bottom;
    }
  });
  /* Tracks a drag's mouse movement, firing various handlers
  ----------------------------------------------------------------------------------------------------------------------*/
  // TODO: use Emitter

  var DragListener = FC.DragListener = Class.extend(ListenerMixin, {
    options: null,
    subjectEl: null,
    // coordinates of the initial mousedown
    originX: null,
    originY: null,
    // the wrapping element that scrolls, or MIGHT scroll if there's overflow.
    // TODO: do this for wrappers that have overflow:hidden as well.
    scrollEl: null,
    isInteracting: false,
    isDistanceSurpassed: false,
    isDelayEnded: false,
    isDragging: false,
    isTouch: false,
    isGeneric: false,
    // initiated by 'dragstart' (jqui)
    delay: null,
    delayTimeoutId: null,
    minDistance: null,
    shouldCancelTouchScroll: true,
    scrollAlwaysKills: false,
    constructor: function constructor(options) {
      this.options = options || {};
    },
    // Interaction (high-level)
    // -----------------------------------------------------------------------------------------------------------------
    startInteraction: function startInteraction(ev, extraOptions) {
      if (ev.type === "mousedown") {
        if (GlobalEmitter.get().shouldIgnoreMouse()) {
          return;
        } else if (!isPrimaryMouseButton(ev)) {
          return;
        } else {
          ev.preventDefault(); // prevents native selection in most browsers
        }
      }

      if (!this.isInteracting) {
        // process options
        extraOptions = extraOptions || {};
        this.delay = firstDefined(extraOptions.delay, this.options.delay, 0);
        this.minDistance = firstDefined(extraOptions.distance, this.options.distance, 0);
        this.subjectEl = this.options.subjectEl;
        preventSelection($("body"));
        this.isInteracting = true;
        this.isTouch = getEvIsTouch(ev);
        this.isGeneric = ev.type === "dragstart";
        this.isDelayEnded = false;
        this.isDistanceSurpassed = false;
        this.originX = getEvX(ev);
        this.originY = getEvY(ev);
        this.scrollEl = getScrollParent($(ev.target));
        this.bindHandlers();
        this.initAutoScroll();
        this.handleInteractionStart(ev);
        this.startDelay(ev);

        if (!this.minDistance) {
          this.handleDistanceSurpassed(ev);
        }
      }
    },
    handleInteractionStart: function handleInteractionStart(ev) {
      this.trigger("interactionStart", ev);
    },
    endInteraction: function endInteraction(ev, isCancelled) {
      if (this.isInteracting) {
        this.endDrag(ev);

        if (this.delayTimeoutId) {
          clearTimeout(this.delayTimeoutId);
          this.delayTimeoutId = null;
        }

        this.destroyAutoScroll();
        this.unbindHandlers();
        this.isInteracting = false;
        this.handleInteractionEnd(ev, isCancelled);
        allowSelection($("body"));
      }
    },
    handleInteractionEnd: function handleInteractionEnd(ev, isCancelled) {
      this.trigger("interactionEnd", ev, isCancelled || false);
    },
    // Binding To DOM
    // -----------------------------------------------------------------------------------------------------------------
    bindHandlers: function bindHandlers() {
      // some browsers (Safari in iOS 10) don't allow preventDefault on touch events that are bound after touchstart,
      // so listen to the GlobalEmitter singleton, which is always bound, instead of the document directly.
      var globalEmitter = GlobalEmitter.get();

      if (this.isGeneric) {
        this.listenTo($(document), {
          // might only work on iOS because of GlobalEmitter's bind :(
          drag: this.handleMove,
          dragstop: this.endInteraction
        });
      } else if (this.isTouch) {
        this.listenTo(globalEmitter, {
          touchmove: this.handleTouchMove,
          touchend: this.endInteraction,
          scroll: this.handleTouchScroll
        });
      } else {
        this.listenTo(globalEmitter, {
          mousemove: this.handleMouseMove,
          mouseup: this.endInteraction
        });
      }

      this.listenTo(globalEmitter, {
        selectstart: preventDefault,
        // don't allow selection while dragging
        contextmenu: preventDefault // long taps would open menu on Chrome dev tools

      });
    },
    unbindHandlers: function unbindHandlers() {
      this.stopListeningTo(GlobalEmitter.get());
      this.stopListeningTo($(document)); // for isGeneric
    },
    // Drag (high-level)
    // -----------------------------------------------------------------------------------------------------------------
    // extraOptions ignored if drag already started
    startDrag: function startDrag(ev, extraOptions) {
      this.startInteraction(ev, extraOptions); // ensure interaction began

      if (!this.isDragging) {
        this.isDragging = true;
        this.handleDragStart(ev);
      }
    },
    handleDragStart: function handleDragStart(ev) {
      this.trigger("dragStart", ev);
    },
    handleMove: function handleMove(ev) {
      var dx = getEvX(ev) - this.originX;
      var dy = getEvY(ev) - this.originY;
      var minDistance = this.minDistance;
      var distanceSq; // current distance from the origin, squared

      if (!this.isDistanceSurpassed) {
        distanceSq = dx * dx + dy * dy;

        if (distanceSq >= minDistance * minDistance) {
          // use pythagorean theorem
          this.handleDistanceSurpassed(ev);
        }
      }

      if (this.isDragging) {
        this.handleDrag(dx, dy, ev);
      }
    },
    // Called while the mouse is being moved and when we know a legitimate drag is taking place
    handleDrag: function handleDrag(dx, dy, ev) {
      this.trigger("drag", dx, dy, ev);
      this.updateAutoScroll(ev); // will possibly cause scrolling
    },
    endDrag: function endDrag(ev) {
      if (this.isDragging) {
        this.isDragging = false;
        this.handleDragEnd(ev);
      }
    },
    handleDragEnd: function handleDragEnd(ev) {
      this.trigger("dragEnd", ev);
    },
    // Delay
    // -----------------------------------------------------------------------------------------------------------------
    startDelay: function startDelay(initialEv) {
      var _this = this;

      if (this.delay) {
        this.delayTimeoutId = setTimeout(function () {
          _this.handleDelayEnd(initialEv);
        }, this.delay);
      } else {
        this.handleDelayEnd(initialEv);
      }
    },
    handleDelayEnd: function handleDelayEnd(initialEv) {
      this.isDelayEnded = true;

      if (this.isDistanceSurpassed) {
        this.startDrag(initialEv);
      }
    },
    // Distance
    // -----------------------------------------------------------------------------------------------------------------
    handleDistanceSurpassed: function handleDistanceSurpassed(ev) {
      this.isDistanceSurpassed = true;

      if (this.isDelayEnded) {
        this.startDrag(ev);
      }
    },
    // Mouse / Touch
    // -----------------------------------------------------------------------------------------------------------------
    handleTouchMove: function handleTouchMove(ev) {
      // prevent inertia and touchmove-scrolling while dragging
      if (this.isDragging && this.shouldCancelTouchScroll) {
        ev.preventDefault();
      }

      this.handleMove(ev);
    },
    handleMouseMove: function handleMouseMove(ev) {
      this.handleMove(ev);
    },
    // Scrolling (unrelated to auto-scroll)
    // -----------------------------------------------------------------------------------------------------------------
    handleTouchScroll: function handleTouchScroll(ev) {
      // if the drag is being initiated by touch, but a scroll happens before
      // the drag-initiating delay is over, cancel the drag
      if (!this.isDragging || this.scrollAlwaysKills) {
        this.endInteraction(ev, true); // isCancelled=true
      }
    },
    // Utils
    // -----------------------------------------------------------------------------------------------------------------
    // Triggers a callback. Calls a function in the option hash of the same name.
    // Arguments beyond the first `name` are forwarded on.
    trigger: function trigger(name) {
      if (this.options[name]) {
        this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
      } // makes _methods callable by event name. TODO: kill this


      if (this["_" + name]) {
        this["_" + name].apply(this, Array.prototype.slice.call(arguments, 1));
      }
    }
  });
  /*
  this.scrollEl is set in DragListener
  */

  DragListener.mixin({
    isAutoScroll: false,
    scrollBounds: null,
    // { top, bottom, left, right }
    scrollTopVel: null,
    // pixels per second
    scrollLeftVel: null,
    // pixels per second
    scrollIntervalId: null,
    // ID of setTimeout for scrolling animation loop
    // defaults
    scrollSensitivity: 30,
    // pixels from edge for scrolling to start
    scrollSpeed: 200,
    // pixels per second, at maximum speed
    scrollIntervalMs: 50,
    // millisecond wait between scroll increment
    initAutoScroll: function initAutoScroll() {
      var scrollEl = this.scrollEl;
      this.isAutoScroll = this.options.scroll && scrollEl && !scrollEl.is(window) && !scrollEl.is(document);

      if (this.isAutoScroll) {
        // debounce makes sure rapid calls don't happen
        this.listenTo(scrollEl, "scroll", debounce(this.handleDebouncedScroll, 100));
      }
    },
    destroyAutoScroll: function destroyAutoScroll() {
      this.endAutoScroll(); // kill any animation loop
      // remove the scroll handler if there is a scrollEl

      if (this.isAutoScroll) {
        this.stopListeningTo(this.scrollEl, "scroll"); // will probably get removed by unbindHandlers too :(
      }
    },
    // Computes and stores the bounding rectangle of scrollEl
    computeScrollBounds: function computeScrollBounds() {
      if (this.isAutoScroll) {
        this.scrollBounds = getOuterRect(this.scrollEl); // TODO: use getClientRect in future. but prevents auto scrolling when on top of scrollbars
      }
    },
    // Called when the dragging is in progress and scrolling should be updated
    updateAutoScroll: function updateAutoScroll(ev) {
      var sensitivity = this.scrollSensitivity;
      var bounds = this.scrollBounds;
      var topCloseness, bottomCloseness;
      var leftCloseness, rightCloseness;
      var topVel = 0;
      var leftVel = 0;

      if (bounds) {
        // only scroll if scrollEl exists
        // compute closeness to edges. valid range is from 0.0 - 1.0
        topCloseness = (sensitivity - (getEvY(ev) - bounds.top)) / sensitivity;
        bottomCloseness = (sensitivity - (bounds.bottom - getEvY(ev))) / sensitivity;
        leftCloseness = (sensitivity - (getEvX(ev) - bounds.left)) / sensitivity;
        rightCloseness = (sensitivity - (bounds.right - getEvX(ev))) / sensitivity; // translate vertical closeness into velocity.
        // mouse must be completely in bounds for velocity to happen.

        if (topCloseness >= 0 && topCloseness <= 1) {
          topVel = topCloseness * this.scrollSpeed * -1; // negative. for scrolling up
        } else if (bottomCloseness >= 0 && bottomCloseness <= 1) {
          topVel = bottomCloseness * this.scrollSpeed;
        } // translate horizontal closeness into velocity


        if (leftCloseness >= 0 && leftCloseness <= 1) {
          leftVel = leftCloseness * this.scrollSpeed * -1; // negative. for scrolling left
        } else if (rightCloseness >= 0 && rightCloseness <= 1) {
          leftVel = rightCloseness * this.scrollSpeed;
        }
      }

      this.setScrollVel(topVel, leftVel);
    },
    // Sets the speed-of-scrolling for the scrollEl
    setScrollVel: function setScrollVel(topVel, leftVel) {
      this.scrollTopVel = topVel;
      this.scrollLeftVel = leftVel;
      this.constrainScrollVel(); // massages into realistic values
      // if there is non-zero velocity, and an animation loop hasn't already started, then START

      if ((this.scrollTopVel || this.scrollLeftVel) && !this.scrollIntervalId) {
        this.scrollIntervalId = setInterval(proxy(this, "scrollIntervalFunc"), // scope to `this`
        this.scrollIntervalMs);
      }
    },
    // Forces scrollTopVel and scrollLeftVel to be zero if scrolling has already gone all the way
    constrainScrollVel: function constrainScrollVel() {
      var el = this.scrollEl;

      if (this.scrollTopVel < 0) {
        // scrolling up?
        if (el.scrollTop() <= 0) {
          // already scrolled all the way up?
          this.scrollTopVel = 0;
        }
      } else if (this.scrollTopVel > 0) {
        // scrolling down?
        if (el.scrollTop() + el[0].clientHeight >= el[0].scrollHeight) {
          // already scrolled all the way down?
          this.scrollTopVel = 0;
        }
      }

      if (this.scrollLeftVel < 0) {
        // scrolling left?
        if (el.scrollLeft() <= 0) {
          // already scrolled all the left?
          this.scrollLeftVel = 0;
        }
      } else if (this.scrollLeftVel > 0) {
        // scrolling right?
        if (el.scrollLeft() + el[0].clientWidth >= el[0].scrollWidth) {
          // already scrolled all the way right?
          this.scrollLeftVel = 0;
        }
      }
    },
    // This function gets called during every iteration of the scrolling animation loop
    scrollIntervalFunc: function scrollIntervalFunc() {
      var el = this.scrollEl;
      var frac = this.scrollIntervalMs / 1000; // considering animation frequency, what the vel should be mult'd by
      // change the value of scrollEl's scroll

      if (this.scrollTopVel) {
        el.scrollTop(el.scrollTop() + this.scrollTopVel * frac);
      }

      if (this.scrollLeftVel) {
        el.scrollLeft(el.scrollLeft() + this.scrollLeftVel * frac);
      }

      this.constrainScrollVel(); // since the scroll values changed, recompute the velocities
      // if scrolled all the way, which causes the vels to be zero, stop the animation loop

      if (!this.scrollTopVel && !this.scrollLeftVel) {
        this.endAutoScroll();
      }
    },
    // Kills any existing scrolling animation loop
    endAutoScroll: function endAutoScroll() {
      if (this.scrollIntervalId) {
        clearInterval(this.scrollIntervalId);
        this.scrollIntervalId = null;
        this.handleScrollEnd();
      }
    },
    // Get called when the scrollEl is scrolled (NOTE: this is delayed via debounce)
    handleDebouncedScroll: function handleDebouncedScroll() {
      // recompute all coordinates, but *only* if this is *not* part of our scrolling animation
      if (!this.scrollIntervalId) {
        this.handleScrollEnd();
      }
    },
    // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
    handleScrollEnd: function handleScrollEnd() {}
  });
  /* Tracks mouse movements over a component and raises events about which hit the mouse is over.
  ------------------------------------------------------------------------------------------------------------------------
  options:
  - subjectEl
  - subjectCenter
  */

  var HitDragListener = DragListener.extend({
    component: null,
    // converts coordinates to hits
    // methods: hitsNeeded, hitsNotNeeded, queryHit
    origHit: null,
    // the hit the mouse was over when listening started
    hit: null,
    // the hit the mouse is over
    coordAdjust: null,
    // delta that will be added to the mouse coordinates when computing collisions
    constructor: function constructor(component, options) {
      DragListener.call(this, options); // call the super-constructor

      this.component = component;
    },
    // Called when drag listening starts (but a real drag has not necessarily began).
    // ev might be undefined if dragging was started manually.
    handleInteractionStart: function handleInteractionStart(ev) {
      var subjectEl = this.subjectEl;
      var subjectRect;
      var origPoint;
      var point;
      this.component.hitsNeeded();
      this.computeScrollBounds(); // for autoscroll

      if (ev) {
        origPoint = {
          left: getEvX(ev),
          top: getEvY(ev)
        };
        point = origPoint; // constrain the point to bounds of the element being dragged

        if (subjectEl) {
          subjectRect = getOuterRect(subjectEl); // used for centering as well

          point = constrainPoint(point, subjectRect);
        }

        this.origHit = this.queryHit(point.left, point.top); // treat the center of the subject as the collision point?

        if (subjectEl && this.options.subjectCenter) {
          // only consider the area the subject overlaps the hit. best for large subjects.
          // TODO: skip this if hit didn't supply left/right/top/bottom
          if (this.origHit) {
            subjectRect = intersectRects(this.origHit, subjectRect) || subjectRect; // in case there is no intersection
          }

          point = getRectCenter(subjectRect);
        }

        this.coordAdjust = diffPoints(point, origPoint); // point - origPoint
      } else {
        this.origHit = null;
        this.coordAdjust = null;
      } // call the super-method. do it after origHit has been computed


      DragListener.prototype.handleInteractionStart.apply(this, arguments);
    },
    // Called when the actual drag has started
    handleDragStart: function handleDragStart(ev) {
      var hit;
      DragListener.prototype.handleDragStart.apply(this, arguments); // call the super-method
      // might be different from this.origHit if the min-distance is large

      hit = this.queryHit(getEvX(ev), getEvY(ev)); // report the initial hit the mouse is over
      // especially important if no min-distance and drag starts immediately

      if (hit) {
        this.handleHitOver(hit);
      }
    },
    // Called when the drag moves
    handleDrag: function handleDrag(dx, dy, ev) {
      var hit;
      DragListener.prototype.handleDrag.apply(this, arguments); // call the super-method

      hit = this.queryHit(getEvX(ev), getEvY(ev));

      if (!isHitsEqual(hit, this.hit)) {
        // a different hit than before?
        if (this.hit) {
          this.handleHitOut();
        }

        if (hit) {
          this.handleHitOver(hit);
        }
      }
    },
    // Called when dragging has been stopped
    handleDragEnd: function handleDragEnd() {
      this.handleHitDone();
      DragListener.prototype.handleDragEnd.apply(this, arguments); // call the super-method
    },
    // Called when a the mouse has just moved over a new hit
    handleHitOver: function handleHitOver(hit) {
      var isOrig = isHitsEqual(hit, this.origHit);
      this.hit = hit;
      this.trigger("hitOver", this.hit, isOrig, this.origHit);
    },
    // Called when the mouse has just moved out of a hit
    handleHitOut: function handleHitOut() {
      if (this.hit) {
        this.trigger("hitOut", this.hit);
        this.handleHitDone();
        this.hit = null;
      }
    },
    // Called after a hitOut. Also called before a dragStop
    handleHitDone: function handleHitDone() {
      if (this.hit) {
        this.trigger("hitDone", this.hit);
      }
    },
    // Called when the interaction ends, whether there was a real drag or not
    handleInteractionEnd: function handleInteractionEnd() {
      DragListener.prototype.handleInteractionEnd.apply(this, arguments); // call the super-method

      this.origHit = null;
      this.hit = null;
      this.component.hitsNotNeeded();
    },
    // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
    handleScrollEnd: function handleScrollEnd() {
      DragListener.prototype.handleScrollEnd.apply(this, arguments); // call the super-method
      // hits' absolute positions will be in new places after a user's scroll.
      // HACK for recomputing.

      if (this.isDragging) {
        this.component.releaseHits();
        this.component.prepareHits();
      }
    },
    // Gets the hit underneath the coordinates for the given mouse event
    queryHit: function queryHit(left, top) {
      if (this.coordAdjust) {
        left += this.coordAdjust.left;
        top += this.coordAdjust.top;
      }

      return this.component.queryHit(left, top);
    }
  }); // Returns `true` if the hits are identically equal. `false` otherwise. Must be from the same component.
  // Two null values will be considered equal, as two "out of the component" states are the same.

  function isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) {
      return true;
    }

    if (hit0 && hit1) {
      return hit0.component === hit1.component && isHitPropsWithin(hit0, hit1) && isHitPropsWithin(hit1, hit0); // ensures all props are identical
    }

    return false;
  } // Returns true if all of subHit's non-standard properties are within superHit


  function isHitPropsWithin(subHit, superHit) {
    for (var propName in subHit) {
      if (!/^(component|left|right|top|bottom)$/.test(propName)) {
        if (subHit[propName] !== superHit[propName]) {
          return false;
        }
      }
    }

    return true;
  }
  /*
  Listens to document and window-level user-interaction events, like touch events and mouse events,
  and fires these events as-is to whoever is observing a GlobalEmitter.
  Best when used as a singleton via GlobalEmitter.get()
  Normalizes mouse/touch events. For examples:
  - ignores the the simulated mouse events that happen after a quick tap: mousemove+mousedown+mouseup+click
  - compensates for various buggy scenarios where a touchend does not fire
  */


  FC.touchMouseIgnoreWait = 500;
  var GlobalEmitter = Class.extend(ListenerMixin, EmitterMixin, {
    isTouching: false,
    mouseIgnoreDepth: 0,
    handleScrollProxy: null,
    bind: function bind() {
      var _this = this;

      this.listenTo($(document), {
        touchstart: this.handleTouchStart,
        touchcancel: this.handleTouchCancel,
        touchend: this.handleTouchEnd,
        mousedown: this.handleMouseDown,
        mousemove: this.handleMouseMove,
        mouseup: this.handleMouseUp,
        click: this.handleClick,
        selectstart: this.handleSelectStart,
        contextmenu: this.handleContextMenu
      }); // because we need to call preventDefault
      // because https://www.chromestatus.com/features/5093566007214080
      // TODO: investigate performance because this is a global handler

      window.addEventListener("touchmove", this.handleTouchMoveProxy = function (ev) {
        _this.handleTouchMove($.Event(ev));
      }, {
        passive: false
      } // allows preventDefault()
      ); // attach a handler to get called when ANY scroll action happens on the page.
      // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
      // http://stackoverflow.com/a/32954565/96342

      window.addEventListener("scroll", this.handleScrollProxy = function (ev) {
        _this.handleScroll($.Event(ev));
      }, true // useCapture
      );
    },
    unbind: function unbind() {
      this.stopListeningTo($(document));
      window.removeEventListener("touchmove", this.handleTouchMoveProxy);
      window.removeEventListener("scroll", this.handleScrollProxy, true // useCapture
      );
    },
    // Touch Handlers
    // -----------------------------------------------------------------------------------------------------------------
    handleTouchStart: function handleTouchStart(ev) {
      // if a previous touch interaction never ended with a touchend, then implicitly end it,
      // but since a new touch interaction is about to begin, don't start the mouse ignore period.
      this.stopTouch(ev, true); // skipMouseIgnore=true

      this.isTouching = true;
      this.trigger("touchstart", ev);
    },
    handleTouchMove: function handleTouchMove(ev) {
      if (this.isTouching) {
        this.trigger("touchmove", ev);
      }
    },
    handleTouchCancel: function handleTouchCancel(ev) {
      if (this.isTouching) {
        this.trigger("touchcancel", ev); // Have touchcancel fire an artificial touchend. That way, handlers won't need to listen to both.
        // If touchend fires later, it won't have any effect b/c isTouching will be false.

        this.stopTouch(ev);
      }
    },
    handleTouchEnd: function handleTouchEnd(ev) {
      this.stopTouch(ev);
    },
    // Mouse Handlers
    // -----------------------------------------------------------------------------------------------------------------
    handleMouseDown: function handleMouseDown(ev) {
      if (!this.shouldIgnoreMouse()) {
        this.trigger("mousedown", ev);
      }
    },
    handleMouseMove: function handleMouseMove(ev) {
      if (!this.shouldIgnoreMouse()) {
        this.trigger("mousemove", ev);
      }
    },
    handleMouseUp: function handleMouseUp(ev) {
      if (!this.shouldIgnoreMouse()) {
        this.trigger("mouseup", ev);
      }
    },
    handleClick: function handleClick(ev) {
      if (!this.shouldIgnoreMouse()) {
        this.trigger("click", ev);
      }
    },
    // Misc Handlers
    // -----------------------------------------------------------------------------------------------------------------
    handleSelectStart: function handleSelectStart(ev) {
      this.trigger("selectstart", ev);
    },
    handleContextMenu: function handleContextMenu(ev) {
      this.trigger("contextmenu", ev);
    },
    handleScroll: function handleScroll(ev) {
      this.trigger("scroll", ev);
    },
    // Utils
    // -----------------------------------------------------------------------------------------------------------------
    stopTouch: function stopTouch(ev, skipMouseIgnore) {
      if (this.isTouching) {
        this.isTouching = false;
        this.trigger("touchend", ev);

        if (!skipMouseIgnore) {
          this.startTouchMouseIgnore();
        }
      }
    },
    startTouchMouseIgnore: function startTouchMouseIgnore() {
      var _this = this;

      var wait = FC.touchMouseIgnoreWait;

      if (wait) {
        this.mouseIgnoreDepth++;
        setTimeout(function () {
          _this.mouseIgnoreDepth--;
        }, wait);
      }
    },
    shouldIgnoreMouse: function shouldIgnoreMouse() {
      return this.isTouching || Boolean(this.mouseIgnoreDepth);
    }
  }); // Singleton
  // ---------------------------------------------------------------------------------------------------------------------

  (function () {
    var globalEmitter = null;
    var neededCount = 0; // gets the singleton

    GlobalEmitter.get = function () {
      if (!globalEmitter) {
        globalEmitter = new GlobalEmitter();
        globalEmitter.bind();
      }

      return globalEmitter;
    }; // called when an object knows it will need a GlobalEmitter in the near future.


    GlobalEmitter.needed = function () {
      GlobalEmitter.get(); // ensures globalEmitter

      neededCount++;
    }; // called when the object that originally called needed() doesn't need a GlobalEmitter anymore.


    GlobalEmitter.unneeded = function () {
      neededCount--;

      if (!neededCount) {
        // nobody else needs it
        globalEmitter.unbind();
        globalEmitter = null;
      }
    };
  })();
  /* Creates a clone of an element and lets it track the mouse as it moves
  ----------------------------------------------------------------------------------------------------------------------*/


  var MouseFollower = Class.extend(ListenerMixin, {
    options: null,
    sourceEl: null,
    // the element that will be cloned and made to look like it is dragging
    el: null,
    // the clone of `sourceEl` that will track the mouse
    parentEl: null,
    // the element that `el` (the clone) will be attached to
    // the initial position of el, relative to the offset parent. made to match the initial offset of sourceEl
    top0: null,
    left0: null,
    // the absolute coordinates of the initiating touch/mouse action
    y0: null,
    x0: null,
    // the number of pixels the mouse has moved from its initial position
    topDelta: null,
    leftDelta: null,
    isFollowing: false,
    isHidden: false,
    isAnimating: false,
    // doing the revert animation?
    constructor: function constructor(sourceEl, options) {
      this.options = options = options || {};
      this.sourceEl = sourceEl;
      this.parentEl = options.parentEl ? $(options.parentEl) : sourceEl.parent(); // default to sourceEl's parent
    },
    // Causes the element to start following the mouse
    start: function start(ev) {
      if (!this.isFollowing) {
        this.isFollowing = true;
        this.y0 = getEvY(ev);
        this.x0 = getEvX(ev);
        this.topDelta = 0;
        this.leftDelta = 0;

        if (!this.isHidden) {
          this.updatePosition();
        }

        if (getEvIsTouch(ev)) {
          this.listenTo($(document), "touchmove", this.handleMove);
        } else {
          this.listenTo($(document), "mousemove", this.handleMove);
        }
      }
    },
    // Causes the element to stop following the mouse. If shouldRevert is true, will animate back to original position.
    // `callback` gets invoked when the animation is complete. If no animation, it is invoked immediately.
    stop: function stop(shouldRevert, callback) {
      var _this = this;

      var revertDuration = this.options.revertDuration;

      function complete() {
        // might be called by .animate(), which might change `this` context
        _this.isAnimating = false;

        _this.removeElement();

        _this.top0 = _this.left0 = null; // reset state for future updatePosition calls

        if (callback) {
          callback();
        }
      }

      if (this.isFollowing && !this.isAnimating) {
        // disallow more than one stop animation at a time
        this.isFollowing = false;
        this.stopListeningTo($(document));

        if (shouldRevert && revertDuration && !this.isHidden) {
          // do a revert animation?
          this.isAnimating = true;
          this.el.animate({
            top: this.top0,
            left: this.left0
          }, {
            duration: revertDuration,
            complete: complete
          });
        } else {
          complete();
        }
      }
    },
    // Gets the tracking element. Create it if necessary
    getEl: function getEl() {
      var el = this.el;

      if (!el) {
        el = this.el = this.sourceEl.clone().addClass(this.options.additionalClass || "").css({
          position: "absolute",
          visibility: "",
          // in case original element was hidden (commonly through hideEvents())
          display: this.isHidden ? "none" : "",
          // for when initially hidden
          margin: 0,
          right: "auto",
          // erase and set width instead
          bottom: "auto",
          // erase and set height instead
          width: this.sourceEl.width(),
          // explicit height in case there was a 'right' value
          height: this.sourceEl.height(),
          // explicit width in case there was a 'bottom' value
          opacity: this.options.opacity || "",
          zIndex: this.options.zIndex
        }); // we don't want long taps or any mouse interaction causing selection/menus.
        // would use preventSelection(), but that prevents selectstart, causing problems.

        el.addClass("fc-unselectable");
        el.appendTo(this.parentEl);
      }

      return el;
    },
    // Removes the tracking element if it has already been created
    removeElement: function removeElement() {
      if (this.el) {
        this.el.remove();
        this.el = null;
      }
    },
    // Update the CSS position of the tracking element
    updatePosition: function updatePosition() {
      var sourceOffset;
      var origin;
      this.getEl(); // ensure this.el
      // make sure origin info was computed

      if (this.top0 === null) {
        sourceOffset = this.sourceEl.offset();
        origin = this.el.offsetParent().offset();
        this.top0 = sourceOffset.top - origin.top;
        this.left0 = sourceOffset.left - origin.left;
      }

      this.el.css({
        top: this.top0 + this.topDelta,
        left: this.left0 + this.leftDelta
      });
    },
    // Gets called when the user moves the mouse
    handleMove: function handleMove(ev) {
      this.topDelta = getEvY(ev) - this.y0;
      this.leftDelta = getEvX(ev) - this.x0;

      if (!this.isHidden) {
        this.updatePosition();
      }
    },
    // Temporarily makes the tracking element invisible. Can be called before following starts
    hide: function hide() {
      if (!this.isHidden) {
        this.isHidden = true;

        if (this.el) {
          this.el.hide();
        }
      }
    },
    // Show the tracking element after it has been temporarily hidden
    show: function show() {
      if (this.isHidden) {
        this.isHidden = false;
        this.updatePosition();
        this.getEl().show();
      }
    }
  });
  /*
  Embodies a div that has potential scrollbars
  */

  var Scroller = FC.Scroller = Class.extend({
    el: null,
    // the guaranteed outer element
    scrollEl: null,
    // the element with the scrollbars
    overflowX: null,
    overflowY: null,
    constructor: function constructor(options) {
      options = options || {};
      this.overflowX = options.overflowX || options.overflow || "auto";
      this.overflowY = options.overflowY || options.overflow || "auto";
    },
    render: function render() {
      this.el = this.renderEl();
      this.applyOverflow();
    },
    renderEl: function renderEl() {
      return this.scrollEl = $('<div class="fc-scroller"></div>');
    },
    // sets to natural height, unlocks overflow
    clear: function clear() {
      this.setHeight("auto");
      this.applyOverflow();
    },
    destroy: function destroy() {
      this.el.remove();
    },
    // Overflow
    // -----------------------------------------------------------------------------------------------------------------
    applyOverflow: function applyOverflow() {
      this.scrollEl.css({
        "overflow-x": this.overflowX,
        "overflow-y": this.overflowY
      });
    },
    // Causes any 'auto' overflow values to resolves to 'scroll' or 'hidden'.
    // Useful for preserving scrollbar widths regardless of future resizes.
    // Can pass in scrollbarWidths for optimization.
    lockOverflow: function lockOverflow(scrollbarWidths) {
      var overflowX = this.overflowX;
      var overflowY = this.overflowY;
      scrollbarWidths = scrollbarWidths || this.getScrollbarWidths();

      if (overflowX === "auto") {
        overflowX = scrollbarWidths.top || scrollbarWidths.bottom || // horizontal scrollbars?
        // OR scrolling pane with massless scrollbars?
        this.scrollEl[0].scrollWidth - 1 > this.scrollEl[0].clientWidth ? // subtract 1 because of IE off-by-one issue
        "scroll" : "hidden";
      }

      if (overflowY === "auto") {
        overflowY = scrollbarWidths.left || scrollbarWidths.right || // vertical scrollbars?
        // OR scrolling pane with massless scrollbars?
        this.scrollEl[0].scrollHeight - 1 > this.scrollEl[0].clientHeight ? // subtract 1 because of IE off-by-one issue
        "scroll" : "hidden";
      }

      this.scrollEl.css({
        "overflow-x": overflowX,
        "overflow-y": overflowY
      });
    },
    // Getters / Setters
    // -----------------------------------------------------------------------------------------------------------------
    setHeight: function setHeight(height) {
      this.scrollEl.height(height);
    },
    getScrollTop: function getScrollTop() {
      return this.scrollEl.scrollTop();
    },
    setScrollTop: function setScrollTop(top) {
      this.scrollEl.scrollTop(top);
    },
    getClientWidth: function getClientWidth() {
      return this.scrollEl[0].clientWidth;
    },
    getClientHeight: function getClientHeight() {
      return this.scrollEl[0].clientHeight;
    },
    getScrollbarWidths: function getScrollbarWidths() {
      return _getScrollbarWidths(this.scrollEl);
    }
  });

  function Iterator(items) {
    this.items = items || [];
  }
  /* Calls a method on every item passing the arguments through */


  Iterator.prototype.proxyCall = function (methodName) {
    var args = Array.prototype.slice.call(arguments, 1);
    var results = [];
    this.items.forEach(function (item) {
      results.push(item[methodName].apply(item, args));
    });
    return results;
  };

  var Interaction = Class.extend({
    view: null,
    component: null,
    constructor: function constructor(component) {
      this.view = component._getView();
      this.component = component;
    },
    opt: function opt(name) {
      return this.view.opt(name);
    },
    end: function end() {// subclasses can implement
    }
  });
  var DateClicking = Interaction.extend({
    dragListener: null,

    /*
    component must implement:
    - bindDateHandlerToEl
    - getSafeHitFootprint
    - getHitEl
    */
    constructor: function constructor(component) {
      Interaction.call(this, component);
      this.dragListener = this.buildDragListener();
    },
    end: function end() {
      this.dragListener.endInteraction();
    },
    bindToEl: function bindToEl(el) {
      var component = this.component;
      var dragListener = this.dragListener;
      component.bindDateHandlerToEl(el, "mousedown", function (ev) {
        if (!component.shouldIgnoreMouse()) {
          dragListener.startInteraction(ev);
        }
      });
      component.bindDateHandlerToEl(el, "touchstart", function (ev) {
        if (!component.shouldIgnoreTouch()) {
          dragListener.startInteraction(ev);
        }
      });
    },
    // Creates a listener that tracks the user's drag across day elements, for day clicking.
    buildDragListener: function buildDragListener() {
      var _this = this;

      var component = this.component;
      var dayClickHit; // null if invalid dayClick

      var dragListener = new HitDragListener(component, {
        scroll: this.opt("dragScroll"),
        interactionStart: function interactionStart() {
          dayClickHit = dragListener.origHit;
        },
        hitOver: function hitOver(hit, isOrig, origHit) {
          // if user dragged to another cell at any point, it can no longer be a dayClick
          if (!isOrig) {
            dayClickHit = null;
          }
        },
        hitOut: function hitOut() {
          // called before mouse moves to a different hit OR moved out of all hits
          dayClickHit = null;
        },
        interactionEnd: function interactionEnd(ev, isCancelled) {
          var componentFootprint;

          if (!isCancelled && dayClickHit) {
            componentFootprint = component.getSafeHitFootprint(dayClickHit);

            if (componentFootprint) {
              _this.view.triggerDayClick(componentFootprint, component.getHitEl(dayClickHit), ev);
            }
          }
        }
      }); // because dragListener won't be called with any time delay, "dragging" will begin immediately,
      // which will kill any touchmoving/scrolling. Prevent this.

      dragListener.shouldCancelTouchScroll = false;
      dragListener.scrollAlwaysKills = true;
      return dragListener;
    }
  });
  var DateSelecting = FC.DateSelecting = Interaction.extend({
    dragListener: null,

    /*
    component must implement:
    - bindDateHandlerToEl
    - getSafeHitFootprint
    - renderHighlight
    - unrenderHighlight
    */
    constructor: function constructor(component) {
      Interaction.call(this, component);
      this.dragListener = this.buildDragListener();
    },
    end: function end() {
      this.dragListener.endInteraction();
    },
    getDelay: function getDelay() {
      var delay = this.opt("selectLongPressDelay");

      if (delay == null) {
        delay = this.opt("longPressDelay"); // fallback
      }

      return delay;
    },
    bindToEl: function bindToEl(el) {
      var _this = this;

      var component = this.component;
      var dragListener = this.dragListener;
      component.bindDateHandlerToEl(el, "mousedown", function (ev) {
        if (_this.opt("selectable") && !component.shouldIgnoreMouse()) {
          dragListener.startInteraction(ev, {
            distance: _this.opt("selectMinDistance")
          });
        }
      });
      component.bindDateHandlerToEl(el, "touchstart", function (ev) {
        if (_this.opt("selectable") && !component.shouldIgnoreTouch()) {
          dragListener.startInteraction(ev, {
            delay: _this.getDelay()
          });
        }
      });
      preventSelection(el);
    },
    // Creates a listener that tracks the user's drag across day elements, for day selecting.
    buildDragListener: function buildDragListener() {
      var _this = this;

      var component = this.component;
      var selectionFootprint; // null if invalid selection

      var dragListener = new HitDragListener(component, {
        scroll: this.opt("dragScroll"),
        interactionStart: function interactionStart() {
          selectionFootprint = null;
        },
        dragStart: function dragStart(ev) {
          _this.view.unselect(ev); // since we could be rendering a new selection, we want to clear any old one

        },
        hitOver: function hitOver(hit, isOrig, origHit) {
          var origHitFootprint;
          var hitFootprint;

          if (origHit) {
            // click needs to have started on a hit
            origHitFootprint = component.getSafeHitFootprint(origHit);
            hitFootprint = component.getSafeHitFootprint(hit);

            if (origHitFootprint && hitFootprint) {
              selectionFootprint = _this.computeSelection(origHitFootprint, hitFootprint);
            } else {
              selectionFootprint = null;
            }

            if (selectionFootprint) {
              component.renderSelectionFootprint(selectionFootprint);
            } else if (selectionFootprint === false) {
              disableCursor();
            }
          }
        },
        hitOut: function hitOut() {
          // called before mouse moves to a different hit OR moved out of all hits
          selectionFootprint = null;
          component.unrenderSelection();
        },
        hitDone: function hitDone() {
          // called after a hitOut OR before a dragEnd
          enableCursor();
        },
        interactionEnd: function interactionEnd(ev, isCancelled) {
          if (!isCancelled && selectionFootprint) {
            // the selection will already have been rendered. just report it
            _this.view.reportSelection(selectionFootprint, ev);
          }
        }
      });
      return dragListener;
    },
    // Given the first and last date-spans of a selection, returns another date-span object.
    // Subclasses can override and provide additional data in the span object. Will be passed to renderSelectionFootprint().
    // Will return false if the selection is invalid and this should be indicated to the user.
    // Will return null/undefined if a selection invalid but no error should be reported.
    computeSelection: function computeSelection(footprint0, footprint1) {
      var wholeFootprint = this.computeSelectionFootprint(footprint0, footprint1);

      if (wholeFootprint && !this.isSelectionFootprintAllowed(wholeFootprint)) {
        return false;
      }

      return wholeFootprint;
    },
    // Given two spans, must return the combination of the two.
    // TODO: do this separation of concerns (combining VS validation) for event dnd/resize too.
    // Assumes both footprints are non-open-ended.
    computeSelectionFootprint: function computeSelectionFootprint(footprint0, footprint1) {
      var ms = [footprint0.unzonedRange.startMs, footprint0.unzonedRange.endMs, footprint1.unzonedRange.startMs, footprint1.unzonedRange.endMs];
      ms.sort(compareNumbers);
      return new ComponentFootprint(new UnzonedRange(ms[0], ms[3]), footprint0.isAllDay);
    },
    isSelectionFootprintAllowed: function isSelectionFootprintAllowed(componentFootprint) {
      return this.component.dateProfile.validUnzonedRange.containsRange(componentFootprint.unzonedRange) && this.view.calendar.isSelectionFootprintAllowed(componentFootprint);
    }
  });
  var EventDragging = FC.EventDragging = Interaction.extend({
    eventPointing: null,
    dragListener: null,
    isDragging: false,

    /*
    component implements:
    - bindSegHandlerToEl
    - publiclyTrigger
    - diffDates
    - eventRangesToEventFootprints
    - isEventInstanceGroupAllowed
    */
    constructor: function constructor(component, eventPointing) {
      Interaction.call(this, component);
      this.eventPointing = eventPointing;
    },
    end: function end() {
      if (this.dragListener) {
        this.dragListener.endInteraction();
      }
    },
    getSelectionDelay: function getSelectionDelay() {
      var delay = this.opt("eventLongPressDelay");

      if (delay == null) {
        delay = this.opt("longPressDelay"); // fallback
      }

      return delay;
    },
    bindToEl: function bindToEl(el) {
      var component = this.component;
      component.bindSegHandlerToEl(el, "mousedown", this.handleMousedown.bind(this));
      component.bindSegHandlerToEl(el, "touchstart", this.handleTouchStart.bind(this));
    },
    handleMousedown: function handleMousedown(seg, ev) {
      if (this.component.canStartDrag(seg, ev)) {
        this.buildDragListener(seg).startInteraction(ev, {
          distance: 5
        });
      }
    },
    handleTouchStart: function handleTouchStart(seg, ev) {
      var component = this.component;
      var settings = {
        delay: this.view.isEventDefSelected(seg.footprint.eventDef) // already selected?
        ? 0 : this.getSelectionDelay()
      };

      if (component.canStartDrag(seg, ev)) {
        this.buildDragListener(seg).startInteraction(ev, settings);
      } else if (component.canStartSelection(seg, ev)) {
        this.buildSelectListener(seg).startInteraction(ev, settings);
      }
    },
    // seg isn't draggable, but let's use a generic DragListener
    // simply for the delay, so it can be selected.
    // Has side effect of setting/unsetting `dragListener`
    buildSelectListener: function buildSelectListener(seg) {
      var _this = this;

      var view = this.view;
      var eventDef = seg.footprint.eventDef;
      var eventInstance = seg.footprint.eventInstance; // null for inverse-background events

      if (this.dragListener) {
        return this.dragListener;
      }

      var dragListener = this.dragListener = new DragListener({
        dragStart: function dragStart(ev) {
          if (dragListener.isTouch && !view.isEventDefSelected(eventDef) && eventInstance) {
            // if not previously selected, will fire after a delay. then, select the event
            view.selectEventInstance(eventInstance);
          }
        },
        interactionEnd: function interactionEnd(ev) {
          _this.dragListener = null;
        }
      });
      return dragListener;
    },
    // Builds a listener that will track user-dragging on an event segment.
    // Generic enough to work with any type of Grid.
    // Has side effect of setting/unsetting `dragListener`
    buildDragListener: function buildDragListener(seg) {
      var _this = this;

      var component = this.component;
      var view = this.view;
      var calendar = view.calendar;
      var eventManager = calendar.eventManager;
      var el = seg.el;
      var eventDef = seg.footprint.eventDef;
      var eventInstance = seg.footprint.eventInstance; // null for inverse-background events

      var isDragging;
      var mouseFollower; // A clone of the original element that will move with the mouse

      var eventDefMutation;

      if (this.dragListener) {
        return this.dragListener;
      } // Tracks mouse movement over the *view's* coordinate map. Allows dragging and dropping between subcomponents
      // of the view.


      var dragListener = this.dragListener = new HitDragListener(view, {
        scroll: this.opt("dragScroll"),
        subjectEl: el,
        subjectCenter: true,
        interactionStart: function interactionStart(ev) {
          seg.component = component; // for renderDrag

          isDragging = false;
          mouseFollower = new MouseFollower(seg.el, {
            additionalClass: "fc-dragging",
            parentEl: view.el,
            opacity: dragListener.isTouch ? null : _this.opt("dragOpacity"),
            revertDuration: _this.opt("dragRevertDuration"),
            zIndex: 2 // one above the .fc-view

          });
          mouseFollower.hide(); // don't show until we know this is a real drag

          mouseFollower.start(ev);
        },
        dragStart: function dragStart(ev) {
          if (dragListener.isTouch && !view.isEventDefSelected(eventDef) && eventInstance) {
            // if not previously selected, will fire after a delay. then, select the event
            view.selectEventInstance(eventInstance);
          }

          isDragging = true; // ensure a mouseout on the manipulated event has been reported

          _this.eventPointing.handleMouseout(seg, ev);

          _this.segDragStart(seg, ev);

          view.hideEventsWithId(seg.footprint.eventDef.id);
        },
        hitOver: function hitOver(hit, isOrig, origHit) {
          var isAllowed = true;
          var origFootprint;
          var footprint;
          var mutatedEventInstanceGroup; // starting hit could be forced (DayGrid.limit)

          if (seg.hit) {
            origHit = seg.hit;
          } // hit might not belong to this grid, so query origin grid


          origFootprint = origHit.component.getSafeHitFootprint(origHit);
          footprint = hit.component.getSafeHitFootprint(hit);

          if (origFootprint && footprint) {
            eventDefMutation = _this.computeEventDropMutation(origFootprint, footprint, eventDef);

            if (eventDefMutation) {
              mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, eventDefMutation);
              isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
            } else {
              isAllowed = false;
            }
          } else {
            isAllowed = false;
          }

          if (!isAllowed) {
            eventDefMutation = null;
            disableCursor();
          } // if a valid drop location, have the subclass render a visual indication


          if (eventDefMutation && view.renderDrag( // truthy if rendered something
          component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg, dragListener.isTouch)) {
            mouseFollower.hide(); // if the subclass is already using a mock event "helper", hide our own
          } else {
            mouseFollower.show(); // otherwise, have the helper follow the mouse (no snapping)
          }

          if (isOrig) {
            // needs to have moved hits to be a valid drop
            eventDefMutation = null;
          }
        },
        hitOut: function hitOut() {
          // called before mouse moves to a different hit OR moved out of all hits
          view.unrenderDrag(seg); // unrender whatever was done in renderDrag

          mouseFollower.show(); // show in case we are moving out of all hits

          eventDefMutation = null;
        },
        hitDone: function hitDone() {
          // Called after a hitOut OR before a dragEnd
          enableCursor();
        },
        interactionEnd: function interactionEnd(ev) {
          delete seg.component; // prevent side effects
          // do revert animation if hasn't changed. calls a callback when finished (whether animation or not)

          mouseFollower.stop(!eventDefMutation, function () {
            if (isDragging) {
              view.unrenderDrag(seg);

              _this.segDragStop(seg, ev);
            }

            view.showEventsWithId(seg.footprint.eventDef.id);

            if (eventDefMutation) {
              // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
              view.reportEventDrop(eventInstance, eventDefMutation, el, ev);
            }
          });
          _this.dragListener = null;
        }
      });
      return dragListener;
    },
    // Called before event segment dragging starts
    segDragStart: function segDragStart(seg, ev) {
      this.isDragging = true;
      this.component.publiclyTrigger("eventDragStart", {
        context: seg.el[0],
        args: [seg.footprint.getEventLegacy(), ev, {}, // jqui dummy
        this.view]
      });
    },
    // Called after event segment dragging stops
    segDragStop: function segDragStop(seg, ev) {
      this.isDragging = false;
      this.component.publiclyTrigger("eventDragStop", {
        context: seg.el[0],
        args: [seg.footprint.getEventLegacy(), ev, {}, // jqui dummy
        this.view]
      });
    },
    // DOES NOT consider overlap/constraint
    computeEventDropMutation: function computeEventDropMutation(startFootprint, endFootprint, eventDef) {
      var eventDefMutation = new EventDefMutation();
      eventDefMutation.setDateMutation(this.computeEventDateMutation(startFootprint, endFootprint));
      return eventDefMutation;
    },
    computeEventDateMutation: function computeEventDateMutation(startFootprint, endFootprint) {
      var date0 = startFootprint.unzonedRange.getStart();
      var date1 = endFootprint.unzonedRange.getStart();
      var clearEnd = false;
      var forceTimed = false;
      var forceAllDay = false;
      var dateDelta;
      var dateMutation;

      if (startFootprint.isAllDay !== endFootprint.isAllDay) {
        clearEnd = true;

        if (endFootprint.isAllDay) {
          forceAllDay = true;
          date0.stripTime();
        } else {
          forceTimed = true;
        }
      }

      dateDelta = this.component.diffDates(date1, date0);
      dateMutation = new EventDefDateMutation();
      dateMutation.clearEnd = clearEnd;
      dateMutation.forceTimed = forceTimed;
      dateMutation.forceAllDay = forceAllDay;
      dateMutation.setDateDelta(dateDelta);
      return dateMutation;
    }
  });
  var EventResizing = FC.EventResizing = Interaction.extend({
    eventPointing: null,
    dragListener: null,
    isResizing: false,

    /*
    component impements:
    - bindSegHandlerToEl
    - publiclyTrigger
    - diffDates
    - eventRangesToEventFootprints
    - isEventInstanceGroupAllowed
    - getSafeHitFootprint
    */
    constructor: function constructor(component, eventPointing) {
      Interaction.call(this, component);
      this.eventPointing = eventPointing;
    },
    end: function end() {
      if (this.dragListener) {
        this.dragListener.endInteraction();
      }
    },
    bindToEl: function bindToEl(el) {
      var component = this.component;
      component.bindSegHandlerToEl(el, "mousedown", this.handleMouseDown.bind(this));
      component.bindSegHandlerToEl(el, "touchstart", this.handleTouchStart.bind(this));
    },
    handleMouseDown: function handleMouseDown(seg, ev) {
      if (this.component.canStartResize(seg, ev)) {
        this.buildDragListener(seg, $(ev.target).is(".fc-start-resizer")).startInteraction(ev, {
          distance: 5
        });
      }
    },
    handleTouchStart: function handleTouchStart(seg, ev) {
      if (this.component.canStartResize(seg, ev)) {
        this.buildDragListener(seg, $(ev.target).is(".fc-start-resizer")).startInteraction(ev);
      }
    },
    // Creates a listener that tracks the user as they resize an event segment.
    // Generic enough to work with any type of Grid.
    buildDragListener: function buildDragListener(seg, isStart) {
      var _this = this;

      var component = this.component;
      var view = this.view;
      var calendar = view.calendar;
      var eventManager = calendar.eventManager;
      var el = seg.el;
      var eventDef = seg.footprint.eventDef;
      var eventInstance = seg.footprint.eventInstance;
      var isDragging;
      var resizeMutation; // zoned event date properties. falsy if invalid resize
      // Tracks mouse movement over the *grid's* coordinate map

      var dragListener = this.dragListener = new HitDragListener(component, {
        scroll: this.opt("dragScroll"),
        subjectEl: el,
        interactionStart: function interactionStart() {
          isDragging = false;
        },
        dragStart: function dragStart(ev) {
          isDragging = true; // ensure a mouseout on the manipulated event has been reported

          _this.eventPointing.handleMouseout(seg, ev);

          _this.segResizeStart(seg, ev);
        },
        hitOver: function hitOver(hit, isOrig, origHit) {
          var isAllowed = true;
          var origHitFootprint = component.getSafeHitFootprint(origHit);
          var hitFootprint = component.getSafeHitFootprint(hit);
          var mutatedEventInstanceGroup;

          if (origHitFootprint && hitFootprint) {
            resizeMutation = isStart ? _this.computeEventStartResizeMutation(origHitFootprint, hitFootprint, seg.footprint) : _this.computeEventEndResizeMutation(origHitFootprint, hitFootprint, seg.footprint);

            if (resizeMutation) {
              mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, resizeMutation);
              isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
            } else {
              isAllowed = false;
            }
          } else {
            isAllowed = false;
          }

          if (!isAllowed) {
            resizeMutation = null;
            disableCursor();
          } else if (resizeMutation.isEmpty()) {
            // no change. (FYI, event dates might have zones)
            resizeMutation = null;
          }

          if (resizeMutation) {
            view.hideEventsWithId(seg.footprint.eventDef.id);
            view.renderEventResize(component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg);
          }
        },
        hitOut: function hitOut() {
          // called before mouse moves to a different hit OR moved out of all hits
          resizeMutation = null;
        },
        hitDone: function hitDone() {
          // resets the rendering to show the original event
          view.unrenderEventResize(seg);
          view.showEventsWithId(seg.footprint.eventDef.id);
          enableCursor();
        },
        interactionEnd: function interactionEnd(ev) {
          if (isDragging) {
            _this.segResizeStop(seg, ev);
          }

          if (resizeMutation) {
            // valid date to resize to?
            // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
            view.reportEventResize(eventInstance, resizeMutation, el, ev);
          }

          _this.dragListener = null;
        }
      });
      return dragListener;
    },
    // Called before event segment resizing starts
    segResizeStart: function segResizeStart(seg, ev) {
      this.isResizing = true;
      this.component.publiclyTrigger("eventResizeStart", {
        context: seg.el[0],
        args: [seg.footprint.getEventLegacy(), ev, {}, // jqui dummy
        this.view]
      });
    },
    // Called after event segment resizing stops
    segResizeStop: function segResizeStop(seg, ev) {
      this.isResizing = false;
      this.component.publiclyTrigger("eventResizeStop", {
        context: seg.el[0],
        args: [seg.footprint.getEventLegacy(), ev, {}, // jqui dummy
        this.view]
      });
    },
    // Returns new date-information for an event segment being resized from its start
    computeEventStartResizeMutation: function computeEventStartResizeMutation(startFootprint, endFootprint, origEventFootprint) {
      var origRange = origEventFootprint.componentFootprint.unzonedRange;
      var startDelta = this.component.diffDates(endFootprint.unzonedRange.getStart(), startFootprint.unzonedRange.getStart());
      var dateMutation;
      var eventDefMutation;

      if (origRange.getStart().add(startDelta) < origRange.getEnd()) {
        dateMutation = new EventDefDateMutation();
        dateMutation.setStartDelta(startDelta);
        eventDefMutation = new EventDefMutation();
        eventDefMutation.setDateMutation(dateMutation);
        return eventDefMutation;
      }

      return false;
    },
    // Returns new date-information for an event segment being resized from its end
    computeEventEndResizeMutation: function computeEventEndResizeMutation(startFootprint, endFootprint, origEventFootprint) {
      var origRange = origEventFootprint.componentFootprint.unzonedRange;
      var endDelta = this.component.diffDates(endFootprint.unzonedRange.getEnd(), startFootprint.unzonedRange.getEnd());
      var dateMutation;
      var eventDefMutation;

      if (origRange.getEnd().add(endDelta) > origRange.getStart()) {
        dateMutation = new EventDefDateMutation();
        dateMutation.setEndDelta(endDelta);
        eventDefMutation = new EventDefMutation();
        eventDefMutation.setDateMutation(dateMutation);
        return eventDefMutation;
      }

      return false;
    }
  });
  var ExternalDropping = FC.ExternalDropping = Interaction.extend(ListenerMixin, {
    dragListener: null,
    isDragging: false,
    // jqui-dragging an external element? boolean

    /*
    component impements:
    - eventRangesToEventFootprints
    - isEventInstanceGroupAllowed
    - isExternalInstanceGroupAllowed
    - renderDrag
    - unrenderDrag
    */
    end: function end() {
      if (this.dragListener) {
        this.dragListener.endInteraction();
      }
    },
    bindToDocument: function bindToDocument() {
      this.listenTo($(document), {
        dragstart: this.handleDragStart,
        // jqui
        sortstart: this.handleDragStart // jqui

      });
    },
    unbindFromDocument: function unbindFromDocument() {
      this.stopListeningTo($(document));
    },
    // Called when a jQuery UI drag is initiated anywhere in the DOM
    handleDragStart: function handleDragStart(ev, ui) {
      var el;
      var accept;

      if (this.opt("droppable")) {
        // only listen if this setting is on
        el = $((ui ? ui.item : null) || ev.target); // Test that the dragged element passes the dropAccept selector or filter function.
        // FYI, the default is "*" (matches all)

        accept = this.opt("dropAccept");

        if ($.isFunction(accept) ? accept.call(el[0], el) : el.is(accept)) {
          if (!this.isDragging) {
            // prevent double-listening if fired twice
            this.listenToExternalDrag(el, ev, ui);
          }
        }
      }
    },
    // Called when a jQuery UI drag starts and it needs to be monitored for dropping
    listenToExternalDrag: function listenToExternalDrag(el, ev, ui) {
      var _this = this;

      var component = this.component;
      var view = this.view;
      var meta = getDraggedElMeta(el); // extra data about event drop, including possible event to create

      var singleEventDef; // a null value signals an unsuccessful drag
      // listener that tracks mouse movement over date-associated pixel regions

      var dragListener = _this.dragListener = new HitDragListener(component, {
        interactionStart: function interactionStart() {
          _this.isDragging = true;
        },
        hitOver: function hitOver(hit) {
          var isAllowed = true;
          var hitFootprint = hit.component.getSafeHitFootprint(hit); // hit might not belong to this grid

          var mutatedEventInstanceGroup;

          if (hitFootprint) {
            singleEventDef = _this.computeExternalDrop(hitFootprint, meta);

            if (singleEventDef) {
              mutatedEventInstanceGroup = new EventInstanceGroup(singleEventDef.buildInstances());
              isAllowed = meta.eventProps // isEvent?
              ? component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup) : component.isExternalInstanceGroupAllowed(mutatedEventInstanceGroup);
            } else {
              isAllowed = false;
            }
          } else {
            isAllowed = false;
          }

          if (!isAllowed) {
            singleEventDef = null;
            disableCursor();
          }

          if (singleEventDef) {
            component.renderDrag( // called without a seg parameter
            component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, view.calendar)));
          }
        },
        hitOut: function hitOut() {
          singleEventDef = null; // signal unsuccessful
        },
        hitDone: function hitDone() {
          // Called after a hitOut OR before a dragEnd
          enableCursor();
          component.unrenderDrag();
        },
        interactionEnd: function interactionEnd(ev) {
          if (singleEventDef) {
            // element was dropped on a valid hit
            view.reportExternalDrop(singleEventDef, Boolean(meta.eventProps), // isEvent
            Boolean(meta.stick), // isSticky
            el, ev, ui);
          }

          _this.isDragging = false;
          _this.dragListener = null;
        }
      });
      dragListener.startDrag(ev); // start listening immediately
    },
    // Given a hit to be dropped upon, and misc data associated with the jqui drag (guaranteed to be a plain object),
    // returns the zoned start/end dates for the event that would result from the hypothetical drop. end might be null.
    // Returning a null value signals an invalid drop hit.
    // DOES NOT consider overlap/constraint.
    // Assumes both footprints are non-open-ended.
    computeExternalDrop: function computeExternalDrop(componentFootprint, meta) {
      var calendar = this.view.calendar;
      var start = FC.moment.utc(componentFootprint.unzonedRange.startMs).stripZone();
      var end;
      var eventDef;

      if (componentFootprint.isAllDay) {
        // if dropped on an all-day span, and element's metadata specified a time, set it
        if (meta.startTime) {
          start.time(meta.startTime);
        } else {
          start.stripTime();
        }
      }

      if (meta.duration) {
        end = start.clone().add(meta.duration);
      }

      start = calendar.applyTimezone(start);

      if (end) {
        end = calendar.applyTimezone(end);
      }

      eventDef = SingleEventDef.parse($.extend({}, meta.eventProps, {
        start: start,
        end: end
      }), new EventSource(calendar));
      return eventDef;
    }
  });
  /* External-Dragging-Element Data
  ----------------------------------------------------------------------------------------------------------------------*/
  // Require all HTML5 data-* attributes used by FullCalendar to have this prefix.
  // A value of '' will query attributes like data-event. A value of 'fc' will query attributes like data-fc-event.

  FC.dataAttrPrefix = ""; // Given a jQuery element that might represent a dragged FullCalendar event, returns an intermediate data structure
  // to be used for Event Object creation.
  // A defined `.eventProps`, even when empty, indicates that an event should be created.

  function getDraggedElMeta(el) {
    var prefix = FC.dataAttrPrefix;
    var eventProps; // properties for creating the event, not related to date/time

    var startTime; // a Duration

    var duration;
    var stick;

    if (prefix) {
      prefix += "-";
    }

    eventProps = el.data(prefix + "event") || null;

    if (eventProps) {
      if (_typeof(eventProps) === "object") {
        eventProps = $.extend({}, eventProps); // make a copy
      } else {
        // something like 1 or true. still signal event creation
        eventProps = {};
      } // pluck special-cased date/time properties


      startTime = eventProps.start;

      if (startTime == null) {
        startTime = eventProps.time;
      } // accept 'time' as well


      duration = eventProps.duration;
      stick = eventProps.stick;
      delete eventProps.start;
      delete eventProps.time;
      delete eventProps.duration;
      delete eventProps.stick;
    } // fallback to standalone attribute values for each of the date/time properties


    if (startTime == null) {
      startTime = el.data(prefix + "start");
    }

    if (startTime == null) {
      startTime = el.data(prefix + "time");
    } // accept 'time' as well


    if (duration == null) {
      duration = el.data(prefix + "duration");
    }

    if (stick == null) {
      stick = el.data(prefix + "stick");
    } // massage into correct data types


    startTime = startTime != null ? moment.duration(startTime) : null;
    duration = duration != null ? moment.duration(duration) : null;
    stick = Boolean(stick);
    return {
      eventProps: eventProps,
      startTime: startTime,
      duration: duration,
      stick: stick
    };
  }

  var EventPointing = FC.EventPointing = Interaction.extend({
    mousedOverSeg: null,
    // the segment object the user's mouse is over. null if over nothing

    /*
    component must implement:
    - publiclyTrigger
    */
    bindToEl: function bindToEl(el) {
      var component = this.component;
      component.bindSegHandlerToEl(el, "click", this.handleClick.bind(this));
      component.bindSegHandlerToEl(el, "mouseenter", this.handleMouseover.bind(this));
      component.bindSegHandlerToEl(el, "mouseleave", this.handleMouseout.bind(this));
    },
    handleClick: function handleClick(seg, ev) {
      var res = this.component.publiclyTrigger("eventClick", {
        // can return `false` to cancel
        context: seg.el[0],
        args: [seg.footprint.getEventLegacy(), ev, this.view]
      });

      if (res === false) {
        ev.preventDefault();
      }
    },
    // Updates internal state and triggers handlers for when an event element is moused over
    handleMouseover: function handleMouseover(seg, ev) {
      if (!GlobalEmitter.get().shouldIgnoreMouse() && !this.mousedOverSeg) {
        this.mousedOverSeg = seg; // TODO: move to EventSelecting's responsibility

        if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
          seg.el.addClass("fc-allow-mouse-resize");
        }

        this.component.publiclyTrigger("eventMouseover", {
          context: seg.el[0],
          args: [seg.footprint.getEventLegacy(), ev, this.view]
        });
      }
    },
    // Updates internal state and triggers handlers for when an event element is moused out.
    // Can be given no arguments, in which case it will mouseout the segment that was previously moused over.
    handleMouseout: function handleMouseout(seg, ev) {
      if (this.mousedOverSeg) {
        this.mousedOverSeg = null; // TODO: move to EventSelecting's responsibility

        if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
          seg.el.removeClass("fc-allow-mouse-resize");
        }

        this.component.publiclyTrigger("eventMouseout", {
          context: seg.el[0],
          args: [seg.footprint.getEventLegacy(), ev || {}, // if given no arg, make a mock mouse event
          this.view]
        });
      }
    },
    end: function end() {
      if (this.mousedOverSeg) {
        this.handleMouseout(this.mousedOverSeg);
      }
    }
  });
  var StandardInteractionsMixin = FC.StandardInteractionsMixin = {
    dateClickingClass: DateClicking,
    dateSelectingClass: DateSelecting,
    eventPointingClass: EventPointing,
    eventDraggingClass: EventDragging,
    eventResizingClass: EventResizing,
    externalDroppingClass: ExternalDropping
  };
  var EventRenderer = FC.EventRenderer = Class.extend({
    view: null,
    component: null,
    fillRenderer: null,
    // might remain null
    fgSegs: null,
    bgSegs: null,
    // derived from options
    eventTimeFormat: null,
    displayEventTime: null,
    displayEventEnd: null,
    constructor: function constructor(component, fillRenderer) {
      // fillRenderer is optional
      this.view = component._getView();
      this.component = component;
      this.fillRenderer = fillRenderer;
    },
    opt: function opt(name) {
      return this.view.opt(name);
    },
    // Updates values that rely on options and also relate to range
    rangeUpdated: function rangeUpdated() {
      var displayEventTime;
      var displayEventEnd;
      this.eventTimeFormat = this.opt("eventTimeFormat") || this.opt("timeFormat") || // deprecated
      this.computeEventTimeFormat();
      displayEventTime = this.opt("displayEventTime");

      if (displayEventTime == null) {
        displayEventTime = this.computeDisplayEventTime(); // might be based off of range
      }

      displayEventEnd = this.opt("displayEventEnd");

      if (displayEventEnd == null) {
        displayEventEnd = this.computeDisplayEventEnd(); // might be based off of range
      }

      this.displayEventTime = displayEventTime;
      this.displayEventEnd = displayEventEnd;
    },
    render: function render(eventsPayload) {
      var dateProfile = this.component._getDateProfile();

      var eventDefId;
      var instanceGroup;
      var eventRanges;
      var bgRanges = [];
      var fgRanges = [];

      for (eventDefId in eventsPayload) {
        instanceGroup = eventsPayload[eventDefId];
        eventRanges = instanceGroup.sliceRenderRanges(dateProfile.activeUnzonedRange);

        if (instanceGroup.getEventDef().hasBgRendering()) {
          bgRanges.push.apply(bgRanges, eventRanges);
        } else {
          fgRanges.push.apply(fgRanges, eventRanges);
        }
      }

      this.renderBgRanges(bgRanges);
      this.renderFgRanges(fgRanges);
    },
    unrender: function unrender() {
      this.unrenderBgRanges();
      this.unrenderFgRanges();
    },
    renderFgRanges: function renderFgRanges(eventRanges) {
      var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
      var segs = this.component.eventFootprintsToSegs(eventFootprints); // render an `.el` on each seg
      // returns a subset of the segs. segs that were actually rendered

      segs = this.renderFgSegEls(segs);

      if (this.renderFgSegs(segs) !== false) {
        // no failure?
        this.fgSegs = segs;
      }
    },
    unrenderFgRanges: function unrenderFgRanges() {
      this.unrenderFgSegs(this.fgSegs || []);
      this.fgSegs = null;
    },
    renderBgRanges: function renderBgRanges(eventRanges) {
      var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
      var segs = this.component.eventFootprintsToSegs(eventFootprints);

      if (this.renderBgSegs(segs) !== false) {
        // no failure?
        this.bgSegs = segs;
      }
    },
    unrenderBgRanges: function unrenderBgRanges() {
      this.unrenderBgSegs();
      this.bgSegs = null;
    },
    getSegs: function getSegs() {
      return (this.bgSegs || []).concat(this.fgSegs || []);
    },
    // Renders foreground event segments onto the grid
    renderFgSegs: function renderFgSegs(segs) {
      // subclasses must implement
      // segs already has rendered els, and has been filtered.
      return false; // signal failure if not implemented
    },
    // Unrenders all currently rendered foreground segments
    unrenderFgSegs: function unrenderFgSegs(segs) {// subclasses must implement
    },
    renderBgSegs: function renderBgSegs(segs) {
      var _this = this;

      if (this.fillRenderer) {
        this.fillRenderer.renderSegs("bgEvent", segs, {
          getClasses: function getClasses(seg) {
            return _this.getBgClasses(seg.footprint.eventDef);
          },
          getCss: function getCss(seg) {
            return {
              "background-color": _this.getBgColor(seg.footprint.eventDef)
            };
          },
          filterEl: function filterEl(seg, el) {
            return _this.filterEventRenderEl(seg.footprint, el);
          }
        });
      } else {
        return false; // signal failure if no fillRenderer
      }
    },
    unrenderBgSegs: function unrenderBgSegs() {
      if (this.fillRenderer) {
        this.fillRenderer.unrender("bgEvent");
      }
    },
    // Renders and assigns an `el` property for each foreground event segment.
    // Only returns segments that successfully rendered.
    renderFgSegEls: function renderFgSegEls(segs, disableResizing) {
      var _this = this;

      var hasEventRenderHandlers = this.view.hasPublicHandlers("eventRender");
      var html = "";
      var renderedSegs = [];
      var i;

      if (segs.length) {
        // don't build an empty html string
        // build a large concatenation of event segment HTML
        for (i = 0; i < segs.length; i++) {
          this.beforeFgSegHtml(segs[i]);
          html += this.fgSegHtml(segs[i], disableResizing);
        } // Grab individual elements from the combined HTML string. Use each as the default rendering.
        // Then, compute the 'el' for each segment. An el might be null if the eventRender callback returned false.


        $(html).each(function (i, node) {
          var seg = segs[i];

          if (!seg) {
            return;
          }

          var el = $(node);

          if (hasEventRenderHandlers) {
            // optimization
            el = _this.filterEventRenderEl(seg.footprint, el);
          }

          if (el) {
            el.data("fc-seg", seg); // used by handlers

            seg.el = el;
            renderedSegs.push(seg);
          }
        });
      }

      return renderedSegs;
    },
    beforeFgSegHtml: function beforeFgSegHtml(seg) {// hack
    },
    // Generates the HTML for the default rendering of a foreground event segment. Used by renderFgSegEls()
    fgSegHtml: function fgSegHtml(seg, disableResizing) {// subclasses should implement
    },
    // Generic utility for generating the HTML classNames for an event segment's element
    getSegClasses: function getSegClasses(seg, isDraggable, isResizable) {
      var classes = ["fc-event", seg.isStart ? "fc-start" : "fc-not-start", seg.isEnd ? "fc-end" : "fc-not-end"].concat(this.getClasses(seg.footprint.eventDef));

      if (isDraggable) {
        classes.push("fc-draggable");
      }

      if (isResizable) {
        classes.push("fc-resizable");
      } // event is currently selected? attach a className.


      if (this.view.isEventDefSelected(seg.footprint.eventDef)) {
        classes.push("fc-selected");
      }

      return classes;
    },
    // Given an event and the default element used for rendering, returns the element that should actually be used.
    // Basically runs events and elements through the eventRender hook.
    filterEventRenderEl: function filterEventRenderEl(eventFootprint, el) {
      var legacy = eventFootprint.getEventLegacy();
      var custom = this.view.publiclyTrigger("eventRender", {
        context: legacy,
        args: [legacy, el, this.view]
      });

      if (custom === false) {
        // means don't render at all
        el = null;
      } else if (custom && custom !== true) {
        el = $(custom);
      }

      return el;
    },
    // Compute the text that should be displayed on an event's element.
    // `range` can be the Event object itself, or something range-like, with at least a `start`.
    // If event times are disabled, or the event has no time, will return a blank string.
    // If not specified, formatStr will default to the eventTimeFormat setting,
    // and displayEnd will default to the displayEventEnd setting.
    getTimeText: function getTimeText(eventFootprint, formatStr, displayEnd) {
      return this._getTimeText(eventFootprint.eventInstance.dateProfile.start, eventFootprint.eventInstance.dateProfile.end, eventFootprint.componentFootprint.isAllDay, formatStr, displayEnd);
    },
    _getTimeText: function _getTimeText(start, end, isAllDay, formatStr, displayEnd) {
      if (formatStr == null) {
        formatStr = this.eventTimeFormat;
      }

      if (displayEnd == null) {
        displayEnd = this.displayEventEnd;
      }

      if (this.displayEventTime && !isAllDay) {
        if (displayEnd && end) {
          return this.view.formatRange({
            start: start,
            end: end
          }, false, // allDay
          formatStr);
        } else {
          return start.format(formatStr);
        }
      }

      return "";
    },
    computeEventTimeFormat: function computeEventTimeFormat() {
      return this.opt("smallTimeFormat");
    },
    computeDisplayEventTime: function computeDisplayEventTime() {
      return true;
    },
    computeDisplayEventEnd: function computeDisplayEventEnd() {
      return true;
    },
    getBgClasses: function getBgClasses(eventDef) {
      var classNames = this.getClasses(eventDef);
      classNames.push("fc-bgevent");
      return classNames;
    },
    getClasses: function getClasses(eventDef) {
      var objs = this.getStylingObjs(eventDef);
      var i;
      var classNames = [];

      for (i = 0; i < objs.length; i++) {
        classNames.push.apply( // append
        classNames, objs[i].eventClassName || objs[i].className || []);
      }

      return classNames;
    },
    // Utility for generating event skin-related CSS properties
    getSkinCss: function getSkinCss(eventDef) {
      return {
        "background-color": this.getBgColor(eventDef),
        "border-color": this.getBorderColor(eventDef),
        color: this.getTextColor(eventDef)
      };
    },
    // Queries for caller-specified color, then falls back to default
    getBgColor: function getBgColor(eventDef) {
      var objs = this.getStylingObjs(eventDef);
      var i;
      var val;

      for (i = 0; i < objs.length && !val; i++) {
        val = objs[i].eventBackgroundColor || objs[i].eventColor || objs[i].backgroundColor || objs[i].color;
      }

      if (!val) {
        val = this.opt("eventBackgroundColor") || this.opt("eventColor");
      }

      return val;
    },
    // Queries for caller-specified color, then falls back to default
    getBorderColor: function getBorderColor(eventDef) {
      var objs = this.getStylingObjs(eventDef);
      var i;
      var val;

      for (i = 0; i < objs.length && !val; i++) {
        val = objs[i].eventBorderColor || objs[i].eventColor || objs[i].borderColor || objs[i].color;
      }

      if (!val) {
        val = this.opt("eventBorderColor") || this.opt("eventColor");
      }

      return val;
    },
    // Queries for caller-specified color, then falls back to default
    getTextColor: function getTextColor(eventDef) {
      var objs = this.getStylingObjs(eventDef);
      var i;
      var val;

      for (i = 0; i < objs.length && !val; i++) {
        val = objs[i].eventTextColor || objs[i].textColor;
      }

      if (!val) {
        val = this.opt("eventTextColor");
      }

      return val;
    },
    getStylingObjs: function getStylingObjs(eventDef) {
      var objs = this.getFallbackStylingObjs(eventDef);
      objs.unshift(eventDef);
      return objs;
    },
    getFallbackStylingObjs: function getFallbackStylingObjs(eventDef) {
      return [eventDef.source];
    },
    sortEventSegs: function sortEventSegs(segs) {
      segs.sort(proxy(this, "compareEventSegs"));
    },
    // A cmp function for determining which segments should take visual priority
    compareEventSegs: function compareEventSegs(seg1, seg2) {
      var f1 = seg1.footprint.componentFootprint;
      var r1 = f1.unzonedRange;
      var f2 = seg2.footprint.componentFootprint;
      var r2 = f2.unzonedRange;
      return r1.startMs - r2.startMs || // earlier events go first
      r2.endMs - r2.startMs - (r1.endMs - r1.startMs) || // tie? longer events go first
      f2.isAllDay - f1.isAllDay || // tie? put all-day events first (booleans cast to 0/1)
      compareByFieldSpecs(seg1.footprint.eventDef, seg2.footprint.eventDef, this.view.eventOrderSpecs);
    }
  });
  var BusinessHourRenderer = FC.BusinessHourRenderer = Class.extend({
    component: null,
    fillRenderer: null,
    segs: null,

    /*
    component implements:
    - eventRangesToEventFootprints
    - eventFootprintsToSegs
    */
    constructor: function constructor(component, fillRenderer) {
      this.component = component;
      this.fillRenderer = fillRenderer;
    },
    render: function render(businessHourGenerator) {
      var component = this.component;

      var unzonedRange = component._getDateProfile().activeUnzonedRange;

      var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(component.hasAllDayBusinessHours, unzonedRange);
      var eventFootprints = eventInstanceGroup ? component.eventRangesToEventFootprints(eventInstanceGroup.sliceRenderRanges(unzonedRange)) : [];
      this.renderEventFootprints(eventFootprints);
    },
    renderEventFootprints: function renderEventFootprints(eventFootprints) {
      var segs = this.component.eventFootprintsToSegs(eventFootprints);
      this.renderSegs(segs);
      this.segs = segs;
    },
    renderSegs: function renderSegs(segs) {
      if (this.fillRenderer) {
        this.fillRenderer.renderSegs("businessHours", segs, {
          getClasses: function getClasses(seg) {
            return ["fc-nonbusiness", "fc-bgevent"];
          }
        });
      }
    },
    unrender: function unrender() {
      if (this.fillRenderer) {
        this.fillRenderer.unrender("businessHours");
      }

      this.segs = null;
    },
    getSegs: function getSegs() {
      return this.segs || [];
    }
  });
  var FillRenderer = FC.FillRenderer = Class.extend({
    // use for highlight, background events, business hours
    fillSegTag: "div",
    component: null,
    elsByFill: null,
    // a hash of jQuery element sets used for rendering each fill. Keyed by fill name.
    constructor: function constructor(component) {
      this.component = component;
      this.elsByFill = {};
    },
    renderFootprint: function renderFootprint(type, componentFootprint, props) {
      this.renderSegs(type, this.component.componentFootprintToSegs(componentFootprint), props);
    },
    renderSegs: function renderSegs(type, segs, props) {
      var els;
      segs = this.buildSegEls(type, segs, props); // assignes `.el` to each seg. returns successfully rendered segs

      els = this.attachSegEls(type, segs);

      if (els) {
        this.reportEls(type, els);
      }

      return segs;
    },
    // Unrenders a specific type of fill that is currently rendered on the grid
    unrender: function unrender(type) {
      var el = this.elsByFill[type];

      if (el) {
        el.remove();
        delete this.elsByFill[type];
      }
    },
    // Renders and assigns an `el` property for each fill segment. Generic enough to work with different types.
    // Only returns segments that successfully rendered.
    buildSegEls: function buildSegEls(type, segs, props) {
      var _this = this;

      var html = "";
      var renderedSegs = [];
      var i;

      if (segs.length) {
        // build a large concatenation of segment HTML
        for (i = 0; i < segs.length; i++) {
          html += this.buildSegHtml(type, segs[i], props);
        } // Grab individual elements from the combined HTML string. Use each as the default rendering.
        // Then, compute the 'el' for each segment.


        $(html).each(function (i, node) {
          var seg = segs[i];
          var el = $(node); // allow custom filter methods per-type

          if (props.filterEl) {
            el = props.filterEl(seg, el);
          }

          if (el) {
            // custom filters did not cancel the render
            el = $(el); // allow custom filter to return raw DOM node
            // correct element type? (would be bad if a non-TD were inserted into a table for example)

            if (el.is(_this.fillSegTag)) {
              seg.el = el;
              renderedSegs.push(seg);
            }
          }
        });
      }

      return renderedSegs;
    },
    // Builds the HTML needed for one fill segment. Generic enough to work with different types.
    buildSegHtml: function buildSegHtml(type, seg, props) {
      // custom hooks per-type
      var classes = props.getClasses ? props.getClasses(seg) : [];
      var css = cssToStr(props.getCss ? props.getCss(seg) : {});
      return "<" + this.fillSegTag + (classes.length ? ' class="' + classes.join(" ") + '"' : "") + (css ? ' style="' + css + '"' : "") + " />";
    },
    // Should return wrapping DOM structure
    attachSegEls: function attachSegEls(type, segs) {// subclasses must implement
    },
    reportEls: function reportEls(type, nodes) {
      if (this.elsByFill[type]) {
        this.elsByFill[type] = this.elsByFill[type].add(nodes);
      } else {
        this.elsByFill[type] = $(nodes);
      }
    }
  });
  var HelperRenderer = FC.HelperRenderer = Class.extend({
    view: null,
    component: null,
    eventRenderer: null,
    helperEls: null,
    constructor: function constructor(component, eventRenderer) {
      this.view = component._getView();
      this.component = component;
      this.eventRenderer = eventRenderer;
    },
    renderComponentFootprint: function renderComponentFootprint(componentFootprint) {
      this.renderEventFootprints([this.fabricateEventFootprint(componentFootprint)]);
    },
    renderEventDraggingFootprints: function renderEventDraggingFootprints(eventFootprints, sourceSeg, isTouch) {
      this.renderEventFootprints(eventFootprints, sourceSeg, "fc-dragging", isTouch ? null : this.view.opt("dragOpacity"));
    },
    renderEventResizingFootprints: function renderEventResizingFootprints(eventFootprints, sourceSeg, isTouch) {
      this.renderEventFootprints(eventFootprints, sourceSeg, "fc-resizing");
    },
    renderEventFootprints: function renderEventFootprints(eventFootprints, sourceSeg, extraClassNames, opacity) {
      var segs = this.component.eventFootprintsToSegs(eventFootprints);
      var classNames = "fc-helper " + (extraClassNames || "");
      var i; // assigns each seg's el and returns a subset of segs that were rendered

      segs = this.eventRenderer.renderFgSegEls(segs);

      for (i = 0; i < segs.length; i++) {
        segs[i].el.addClass(classNames);
      }

      if (opacity != null) {
        for (i = 0; i < segs.length; i++) {
          segs[i].el.css("opacity", opacity);
        }
      }

      this.helperEls = this.renderSegs(segs, sourceSeg);
    },

    /*
    Must return all mock event elements
    */
    renderSegs: function renderSegs(segs, sourceSeg) {// Subclasses must implement
    },
    unrender: function unrender() {
      if (this.helperEls) {
        this.helperEls.remove();
        this.helperEls = null;
      }
    },
    fabricateEventFootprint: function fabricateEventFootprint(componentFootprint) {
      var calendar = this.view.calendar;
      var eventDateProfile = calendar.footprintToDateProfile(componentFootprint);
      var dummyEvent = new SingleEventDef(new EventSource(calendar));
      var dummyInstance;
      dummyEvent.dateProfile = eventDateProfile;
      dummyInstance = dummyEvent.buildInstance();
      return new EventFootprint(componentFootprint, dummyEvent, dummyInstance);
    }
  });
  var Component = Model.extend({
    el: null,
    setElement: function setElement(el) {
      this.el = el;
      this.bindGlobalHandlers();
      this.renderSkeleton();
      this.set("isInDom", true);
    },
    removeElement: function removeElement() {
      this.unset("isInDom");
      this.unrenderSkeleton();
      this.unbindGlobalHandlers();
      this.el.remove(); // NOTE: don't null-out this.el in case the View was destroyed within an API callback.
      // We don't null-out the View's other jQuery element references upon destroy,
      //  so we shouldn't kill this.el either.
    },
    bindGlobalHandlers: function bindGlobalHandlers() {},
    unbindGlobalHandlers: function unbindGlobalHandlers() {},

    /*
    NOTE: Can't have a `render` method. Read the deprecation notice in View::executeDateRender
    */
    // Renders the basic structure of the view before any content is rendered
    renderSkeleton: function renderSkeleton() {// subclasses should implement
    },
    // Unrenders the basic structure of the view
    unrenderSkeleton: function unrenderSkeleton() {// subclasses should implement
    }
  });
  var DateComponent = FC.DateComponent = Component.extend({
    uid: null,
    childrenByUid: null,
    isRTL: false,
    // frequently accessed options
    nextDayThreshold: null,
    // "
    dateProfile: null,
    // hack
    eventRendererClass: null,
    helperRendererClass: null,
    businessHourRendererClass: null,
    fillRendererClass: null,
    eventRenderer: null,
    helperRenderer: null,
    businessHourRenderer: null,
    fillRenderer: null,
    hitsNeededDepth: 0,
    // necessary because multiple callers might need the same hits
    hasAllDayBusinessHours: false,
    // TODO: unify with largeUnit and isTimeScale?
    isDatesRendered: false,
    constructor: function constructor() {
      Component.call(this);
      this.uid = String(DateComponent.guid++);
      this.childrenByUid = {};
      this.nextDayThreshold = moment.duration(this.opt("nextDayThreshold"));
      this.isRTL = this.opt("isRTL");

      if (this.fillRendererClass) {
        this.fillRenderer = new this.fillRendererClass(this);
      }

      if (this.eventRendererClass) {
        // fillRenderer is optional -----v
        this.eventRenderer = new this.eventRendererClass(this, this.fillRenderer);
      }

      if (this.helperRendererClass && this.eventRenderer) {
        this.helperRenderer = new this.helperRendererClass(this, this.eventRenderer);
      }

      if (this.businessHourRendererClass && this.fillRenderer) {
        this.businessHourRenderer = new this.businessHourRendererClass(this, this.fillRenderer);
      }
    },
    addChild: function addChild(child) {
      if (!this.childrenByUid[child.uid]) {
        this.childrenByUid[child.uid] = child;
        return true;
      }

      return false;
    },
    removeChild: function removeChild(child) {
      if (this.childrenByUid[child.uid]) {
        delete this.childrenByUid[child.uid];
        return true;
      }

      return false;
    },
    // TODO: only do if isInDom?
    // TODO: make part of Component, along with children/batch-render system?
    updateSize: function updateSize(totalHeight, isAuto, isResize) {
      this.callChildren("updateSize", arguments);
    },
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    opt: function opt(name) {
      return this._getView().opt(name); // default implementation
    },
    publiclyTrigger: function
      /**/
    publiclyTrigger() {
      var calendar = this._getCalendar();

      return calendar.publiclyTrigger.apply(calendar, arguments);
    },
    hasPublicHandlers: function
      /**/
    hasPublicHandlers() {
      var calendar = this._getCalendar();

      return calendar.hasPublicHandlers.apply(calendar, arguments);
    },
    // Date
    // -----------------------------------------------------------------------------------------------------------------
    executeDateRender: function executeDateRender(dateProfile) {
      this.dateProfile = dateProfile; // for rendering

      this.renderDates(dateProfile);
      this.isDatesRendered = true;
      this.callChildren("executeDateRender", arguments);
    },
    executeDateUnrender: function executeDateUnrender() {
      // wrapper
      this.callChildren("executeDateUnrender", arguments);
      this.dateProfile = null;
      this.unrenderDates();
      this.isDatesRendered = false;
    },
    // date-cell content only
    renderDates: function renderDates(dateProfile) {// subclasses should implement
    },
    // date-cell content only
    unrenderDates: function unrenderDates() {// subclasses should override
    },
    // Now-Indicator
    // -----------------------------------------------------------------------------------------------------------------
    // Returns a string unit, like 'second' or 'minute' that defined how often the current time indicator
    // should be refreshed. If something falsy is returned, no time indicator is rendered at all.
    getNowIndicatorUnit: function getNowIndicatorUnit() {// subclasses should implement
    },
    // Renders a current time indicator at the given datetime
    renderNowIndicator: function renderNowIndicator(date) {
      this.callChildren("renderNowIndicator", arguments);
    },
    // Undoes the rendering actions from renderNowIndicator
    unrenderNowIndicator: function unrenderNowIndicator() {
      this.callChildren("unrenderNowIndicator", arguments);
    },
    // Business Hours
    // ---------------------------------------------------------------------------------------------------------------
    renderBusinessHours: function renderBusinessHours(businessHourGenerator) {
      if (this.businessHourRenderer) {
        this.businessHourRenderer.render(businessHourGenerator);
      }

      this.callChildren("renderBusinessHours", arguments);
    },
    // Unrenders previously-rendered business-hours
    unrenderBusinessHours: function unrenderBusinessHours() {
      this.callChildren("unrenderBusinessHours", arguments);

      if (this.businessHourRenderer) {
        this.businessHourRenderer.unrender();
      }
    },
    // Event Displaying
    // -----------------------------------------------------------------------------------------------------------------
    executeEventRender: function executeEventRender(eventsPayload) {
      if (this.eventRenderer) {
        this.eventRenderer.rangeUpdated(); // poorly named now

        this.eventRenderer.render(eventsPayload);
      } else if (this.renderEvents) {
        // legacy
        this.renderEvents(convertEventsPayloadToLegacyArray(eventsPayload));
      }

      this.callChildren("executeEventRender", arguments);
    },
    executeEventUnrender: function executeEventUnrender() {
      this.callChildren("executeEventUnrender", arguments);

      if (this.eventRenderer) {
        this.eventRenderer.unrender();
      } else if (this.destroyEvents) {
        // legacy
        this.destroyEvents();
      }
    },
    getBusinessHourSegs: function getBusinessHourSegs() {
      // recursive
      var segs = this.getOwnBusinessHourSegs();
      this.iterChildren(function (child) {
        segs.push.apply(segs, child.getBusinessHourSegs());
      });
      return segs;
    },
    getOwnBusinessHourSegs: function getOwnBusinessHourSegs() {
      if (this.businessHourRenderer) {
        return this.businessHourRenderer.getSegs();
      }

      return [];
    },
    getEventSegs: function getEventSegs() {
      // recursive
      var segs = this.getOwnEventSegs();
      this.iterChildren(function (child) {
        segs.push.apply(segs, child.getEventSegs());
      });
      return segs;
    },
    getOwnEventSegs: function getOwnEventSegs() {
      // just for itself
      if (this.eventRenderer) {
        return this.eventRenderer.getSegs();
      }

      return [];
    },
    // Event Rendering Triggering
    // -----------------------------------------------------------------------------------------------------------------
    triggerAfterEventsRendered: function triggerAfterEventsRendered() {
      this.triggerAfterEventSegsRendered(this.getEventSegs());
      this.publiclyTrigger("eventAfterAllRender", {
        context: this,
        args: [this]
      });
    },
    triggerAfterEventSegsRendered: function triggerAfterEventSegsRendered(segs) {
      var _this = this; // an optimization, because getEventLegacy is expensive


      if (this.hasPublicHandlers("eventAfterRender")) {
        segs.forEach(function (seg) {
          var legacy;

          if (seg.el) {
            // necessary?
            legacy = seg.footprint.getEventLegacy();

            _this.publiclyTrigger("eventAfterRender", {
              context: legacy,
              args: [legacy, seg.el, _this]
            });
          }
        });
      }
    },
    triggerBeforeEventsDestroyed: function triggerBeforeEventsDestroyed() {
      this.triggerBeforeEventSegsDestroyed(this.getEventSegs());
    },
    triggerBeforeEventSegsDestroyed: function triggerBeforeEventSegsDestroyed(segs) {
      var _this = this;

      if (this.hasPublicHandlers("eventDestroy")) {
        segs.forEach(function (seg) {
          var legacy;

          if (seg.el) {
            // necessary?
            legacy = seg.footprint.getEventLegacy();

            _this.publiclyTrigger("eventDestroy", {
              context: legacy,
              args: [legacy, seg.el, _this]
            });
          }
        });
      }
    },
    // Event Rendering Utils
    // -----------------------------------------------------------------------------------------------------------------
    // Hides all rendered event segments linked to the given event
    // RECURSIVE with subcomponents
    showEventsWithId: function showEventsWithId(eventDefId) {
      this.getEventSegs().forEach(function (seg) {
        if (seg.footprint.eventDef.id === eventDefId && seg.el // necessary?
        ) {
          seg.el.css("visibility", "");
        }
      });
      this.callChildren("showEventsWithId", arguments);
    },
    // Shows all rendered event segments linked to the given event
    // RECURSIVE with subcomponents
    hideEventsWithId: function hideEventsWithId(eventDefId) {
      this.getEventSegs().forEach(function (seg) {
        if (seg.footprint.eventDef.id === eventDefId && seg.el // necessary?
        ) {
          seg.el.css("visibility", "hidden");
        }
      });
      this.callChildren("hideEventsWithId", arguments);
    },
    // Drag-n-Drop Rendering (for both events and external elements)
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of a event or external-element drag over the given drop zone.
    // If an external-element, seg will be `null`.
    // Must return elements used for any mock events.
    renderDrag: function renderDrag(eventFootprints, seg, isTouch) {
      var renderedHelper = false;
      this.iterChildren(function (child) {
        if (child.renderDrag(eventFootprints, seg, isTouch)) {
          renderedHelper = true;
        }
      });
      return renderedHelper;
    },
    // Unrenders a visual indication of an event or external-element being dragged.
    unrenderDrag: function unrenderDrag() {
      this.callChildren("unrenderDrag", arguments);
    },
    // Event Resizing
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of an event being resized.
    renderEventResize: function renderEventResize(eventFootprints, seg, isTouch) {
      this.callChildren("renderEventResize", arguments);
    },
    // Unrenders a visual indication of an event being resized.
    unrenderEventResize: function unrenderEventResize() {
      this.callChildren("unrenderEventResize", arguments);
    },
    // Selection
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of the selection
    // TODO: rename to `renderSelection` after legacy is gone
    renderSelectionFootprint: function renderSelectionFootprint(componentFootprint) {
      this.renderHighlight(componentFootprint);
      this.callChildren("renderSelectionFootprint", arguments);
    },
    // Unrenders a visual indication of selection
    unrenderSelection: function unrenderSelection() {
      this.unrenderHighlight();
      this.callChildren("unrenderSelection", arguments);
    },
    // Highlight
    // ---------------------------------------------------------------------------------------------------------------
    // Renders an emphasis on the given date range. Given a span (unzoned start/end and other misc data)
    renderHighlight: function renderHighlight(componentFootprint) {
      if (this.fillRenderer) {
        this.fillRenderer.renderFootprint("highlight", componentFootprint, {
          getClasses: function getClasses() {
            return ["fc-highlight"];
          }
        });
      }

      this.callChildren("renderHighlight", arguments);
    },
    // Unrenders the emphasis on a date range
    unrenderHighlight: function unrenderHighlight() {
      if (this.fillRenderer) {
        this.fillRenderer.unrender("highlight");
      }

      this.callChildren("unrenderHighlight", arguments);
    },
    // Hit Areas
    // ---------------------------------------------------------------------------------------------------------------
    // just because all DateComponents support this interface
    // doesn't mean they need to have their own internal coord system. they can defer to sub-components.
    hitsNeeded: function hitsNeeded() {
      if (!this.hitsNeededDepth++) {
        this.prepareHits();
      }

      this.callChildren("hitsNeeded", arguments);
    },
    hitsNotNeeded: function hitsNotNeeded() {
      if (this.hitsNeededDepth && ! --this.hitsNeededDepth) {
        this.releaseHits();
      }

      this.callChildren("hitsNotNeeded", arguments);
    },
    prepareHits: function prepareHits() {// subclasses can implement
    },
    releaseHits: function releaseHits() {// subclasses can implement
    },
    // Given coordinates from the topleft of the document, return data about the date-related area underneath.
    // Can return an object with arbitrary properties (although top/right/left/bottom are encouraged).
    // Must have a `grid` property, a reference to this current grid. TODO: avoid this
    // The returned object will be processed by getHitFootprint and getHitEl.
    queryHit: function queryHit(leftOffset, topOffset) {
      var childrenByUid = this.childrenByUid;
      var uid;
      var hit;

      for (uid in childrenByUid) {
        hit = childrenByUid[uid].queryHit(leftOffset, topOffset);

        if (hit) {
          break;
        }
      }

      return hit;
    },
    getSafeHitFootprint: function getSafeHitFootprint(hit) {
      var footprint = this.getHitFootprint(hit);

      if (!this.dateProfile.activeUnzonedRange.containsRange(footprint.unzonedRange)) {
        return null;
      }

      return footprint;
    },
    getHitFootprint: function getHitFootprint(hit) {},
    // Given position-level information about a date-related area within the grid,
    // should return a jQuery element that best represents it. passed to dayClick callback.
    getHitEl: function getHitEl(hit) {},

    /* Converting eventRange -> eventFootprint
    ------------------------------------------------------------------------------------------------------------------*/
    eventRangesToEventFootprints: function eventRangesToEventFootprints(eventRanges) {
      var eventFootprints = [];
      var i;

      for (i = 0; i < eventRanges.length; i++) {
        eventFootprints.push.apply( // append
        eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
      }

      return eventFootprints;
    },
    eventRangeToEventFootprints: function eventRangeToEventFootprints(eventRange) {
      return [eventRangeToEventFootprint(eventRange)];
    },

    /* Converting componentFootprint/eventFootprint -> segs
    ------------------------------------------------------------------------------------------------------------------*/
    eventFootprintsToSegs: function eventFootprintsToSegs(eventFootprints) {
      var segs = [];
      var i;

      for (i = 0; i < eventFootprints.length; i++) {
        segs.push.apply(segs, this.eventFootprintToSegs(eventFootprints[i]));
      }

      return segs;
    },
    // Given an event's span (unzoned start/end and other misc data), and the event itself,
    // slices into segments and attaches event-derived properties to them.
    // eventSpan - { start, end, isStart, isEnd, otherthings... }
    eventFootprintToSegs: function eventFootprintToSegs(eventFootprint) {
      var unzonedRange = eventFootprint.componentFootprint.unzonedRange;
      var segs;
      var i, seg;
      segs = this.componentFootprintToSegs(eventFootprint.componentFootprint);

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];

        if (!unzonedRange.isStart) {
          seg.isStart = false;
        }

        if (!unzonedRange.isEnd) {
          seg.isEnd = false;
        }

        seg.footprint = eventFootprint; // TODO: rename to seg.eventFootprint
      }

      return segs;
    },
    componentFootprintToSegs: function componentFootprintToSegs(componentFootprint) {
      return [];
    },
    // Utils
    // ---------------------------------------------------------------------------------------------------------------
    callChildren: function callChildren(methodName, args) {
      this.iterChildren(function (child) {
        child[methodName].apply(child, args);
      });
    },
    iterChildren: function iterChildren(func) {
      var childrenByUid = this.childrenByUid;
      var uid;

      for (uid in childrenByUid) {
        func(childrenByUid[uid]);
      }
    },
    _getCalendar: function _getCalendar() {
      // TODO: strip out. move to generic parent.
      return this.calendar || this.view.calendar;
    },
    _getView: function _getView() {
      // TODO: strip out. move to generic parent.
      return this.view;
    },
    _getDateProfile: function _getDateProfile() {
      return this._getView().get("dateProfile");
    }
  });
  DateComponent.guid = 0; // TODO: better system for this?
  // legacy

  function convertEventsPayloadToLegacyArray(eventsPayload) {
    var eventDefId;
    var eventInstances;
    var legacyEvents = [];
    var i;

    for (eventDefId in eventsPayload) {
      eventInstances = eventsPayload[eventDefId].eventInstances;

      for (i = 0; i < eventInstances.length; i++) {
        legacyEvents.push(eventInstances[i].toLegacy());
      }
    }

    return legacyEvents;
  }

  DateComponent.mixin({
    // Generates HTML for an anchor to another view into the calendar.
    // Will either generate an <a> tag or a non-clickable <span> tag, depending on enabled settings.
    // `gotoOptions` can either be a moment input, or an object with the form:
    // { date, type, forceOff }
    // `type` is a view-type like "day" or "week". default value is "day".
    // `attrs` and `innerHtml` are use to generate the rest of the HTML tag.
    buildGotoAnchorHtml: function buildGotoAnchorHtml(gotoOptions, attrs, innerHtml) {
      var date, type, forceOff;
      var finalOptions;

      if ($.isPlainObject(gotoOptions)) {
        date = gotoOptions.date;
        type = gotoOptions.type;
        forceOff = gotoOptions.forceOff;
      } else {
        date = gotoOptions; // a single moment input
      }

      date = FC.moment(date); // if a string, parse it

      finalOptions = {
        // for serialization into the link
        date: date.format("YYYY-MM-DD"),
        type: type || "day"
      };

      if (typeof attrs === "string") {
        innerHtml = attrs;
        attrs = null;
      }

      attrs = attrs ? " " + attrsToStr(attrs) : ""; // will have a leading space

      innerHtml = innerHtml || "";

      if (!forceOff && this.opt("navLinks")) {
        return "<a" + attrs + ' data-goto="' + htmlEscape(JSON.stringify(finalOptions)) + '">' + innerHtml + "</a>";
      } else {
        return "<span" + attrs + ">" + innerHtml + "</span>";
      }
    },
    getAllDayHtml: function getAllDayHtml() {
      return this.opt("allDayHtml") || htmlEscape(this.opt("allDayText"));
    },
    // Computes HTML classNames for a single-day element
    getDayClasses: function getDayClasses(date, noThemeHighlight) {
      var view = this._getView();

      var classes = [];
      var today;
      var holiday;

      if (!this.dateProfile.activeUnzonedRange.containsDate(date)) {
        classes.push("fc-disabled-day"); // TODO: jQuery UI theme?
      } else {
        classes.push("fc-" + dayIDs[date.day()]);

        if (view.isDateInOtherMonth(date, this.dateProfile)) {
          // TODO: use DateComponent subclass somehow
          classes.push("fc-other-month");
        }

        today = view.calendar.getNow();
        holiday = view.calendar.getNow();

        if (date.isSame(today, "day")) {
          classes.push("fc-today");

          if (noThemeHighlight !== true) {
            classes.push(view.calendar.theme.getClass("today"));
          }
        } else if (date < today) {
          classes.push("fc-past");
        } else {
          classes.push("fc-future");
        }
      }

      return classes;
    },
    // Utility for formatting a range. Accepts a range object, formatting string, and optional separator.
    // Displays all-day ranges naturally, with an inclusive end. Takes the current isRTL into account.
    // The timezones of the dates within `range` will be respected.
    formatRange: function formatRange(range, isAllDay, formatStr, separator) {
      var end = range.end;

      if (isAllDay) {
        end = end.clone().subtract(1); // convert to inclusive. last ms of previous day
      }

      return _formatRange(range.start, end, formatStr, separator, this.isRTL);
    },
    // Compute the number of the give units in the "current" range.
    // Will return a floating-point number. Won't round.
    currentRangeAs: function currentRangeAs(unit) {
      return this._getDateProfile().currentUnzonedRange.as(unit);
    },
    // Returns the date range of the full days the given range visually appears to occupy.
    // Returns a plain object with start/end, NOT an UnzonedRange!
    computeDayRange: function computeDayRange(unzonedRange) {
      var calendar = this._getCalendar();

      var startDay = calendar.msToUtcMoment(unzonedRange.startMs, true); // the beginning of the day the range starts

      var end = calendar.msToUtcMoment(unzonedRange.endMs);
      var endTimeMS = +end.time(); // # of milliseconds into `endDay`

      var endDay = end.clone().stripTime(); // the beginning of the day the range exclusively ends
      // If the end time is actually inclusively part of the next day and is equal to or
      // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
      // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.

      if (endTimeMS && endTimeMS >= this.nextDayThreshold) {
        endDay.add(1, "days");
      } // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.


      if (endDay <= startDay) {
        endDay = startDay.clone().add(1, "days");
      }

      return {
        start: startDay,
        end: endDay
      };
    },
    // Does the given range visually appear to occupy more than one day?
    isMultiDayRange: function isMultiDayRange(unzonedRange) {
      var dayRange = this.computeDayRange(unzonedRange);
      return dayRange.end.diff(dayRange.start, "days") > 1;
    }
  });
  var InteractiveDateComponent = FC.InteractiveDateComponent = DateComponent.extend({
    dateClickingClass: null,
    dateSelectingClass: null,
    eventPointingClass: null,
    eventDraggingClass: null,
    eventResizingClass: null,
    externalDroppingClass: null,
    dateClicking: null,
    dateSelecting: null,
    eventPointing: null,
    eventDragging: null,
    eventResizing: null,
    externalDropping: null,
    // self-config, overridable by subclasses
    segSelector: ".fc-event-container > *",
    // what constitutes an event element?
    // if defined, holds the unit identified (ex: "year" or "month") that determines the level of granularity
    // of the date areas. if not defined, assumes to be day and time granularity.
    // TODO: port isTimeScale into same system?
    largeUnit: null,
    constructor: function constructor() {
      DateComponent.call(this);

      if (this.dateSelectingClass) {
        this.dateClicking = new this.dateClickingClass(this);
      }

      if (this.dateSelectingClass) {
        this.dateSelecting = new this.dateSelectingClass(this);
      }

      if (this.eventPointingClass) {
        this.eventPointing = new this.eventPointingClass(this);
      }

      if (this.eventDraggingClass && this.eventPointing) {
        this.eventDragging = new this.eventDraggingClass(this, this.eventPointing);
      }

      if (this.eventResizingClass && this.eventPointing) {
        this.eventResizing = new this.eventResizingClass(this, this.eventPointing);
      }

      if (this.externalDroppingClass) {
        this.externalDropping = new this.externalDroppingClass(this);
      }
    },
    // Sets the container element that the view should render inside of, does global DOM-related initializations,
    // and renders all the non-date-related content inside.
    setElement: function setElement(el) {
      DateComponent.prototype.setElement.apply(this, arguments);

      if (this.dateClicking) {
        this.dateClicking.bindToEl(el);
      }

      if (this.dateSelecting) {
        this.dateSelecting.bindToEl(el);
      }

      this.bindAllSegHandlersToEl(el);
    },
    unrender: function unrender() {
      this.endInteractions();
      DateComponent.prototype.unrender.apply(this, arguments);
    },
    executeEventUnrender: function executeEventUnrender() {
      this.endInteractions();
      DateComponent.prototype.executeEventUnrender.apply(this, arguments);
    },
    bindGlobalHandlers: function bindGlobalHandlers() {
      DateComponent.prototype.bindGlobalHandlers.apply(this, arguments);

      if (this.externalDropping) {
        this.externalDropping.bindToDocument();
      }
    },
    unbindGlobalHandlers: function unbindGlobalHandlers() {
      DateComponent.prototype.unbindGlobalHandlers.apply(this, arguments);

      if (this.externalDropping) {
        this.externalDropping.unbindFromDocument();
      }
    },
    bindDateHandlerToEl: function bindDateHandlerToEl(el, name, handler) {
      var _this = this; // attach a handler to the grid's root element.
      // jQuery will take care of unregistering them when removeElement gets called.


      this.el.on(name, function (ev) {
        if (!$(ev.target).is(_this.segSelector + "," + // directly on an event element
        _this.segSelector + " *," + // within an event element
        ".fc-more," + // a "more.." link
        "a[data-goto]" // a clickable nav link
        )) {
          return handler.call(_this, ev);
        }
      });
    },
    bindAllSegHandlersToEl: function bindAllSegHandlersToEl(el) {
      [this.eventPointing, this.eventDragging, this.eventResizing].forEach(function (eventInteraction) {
        if (eventInteraction) {
          eventInteraction.bindToEl(el);
        }
      });
    },
    bindSegHandlerToEl: function bindSegHandlerToEl(el, name, handler) {
      var _this = this;

      el.on(name, this.segSelector, function (ev) {
        var seg = $(this).data("fc-seg"); // grab segment data. put there by View::renderEventsPayload

        if (seg && !_this.shouldIgnoreEventPointing()) {
          return handler.call(_this, seg, ev); // context will be the Grid
        }
      });
    },
    shouldIgnoreMouse: function shouldIgnoreMouse() {
      // HACK
      // This will still work even though bindDateHandlerToEl doesn't use GlobalEmitter.
      return GlobalEmitter.get().shouldIgnoreMouse();
    },
    shouldIgnoreTouch: function shouldIgnoreTouch() {
      var view = this._getView(); // On iOS (and Android?) when a new selection is initiated overtop another selection,
      // the touchend never fires because the elements gets removed mid-touch-interaction (my theory).
      // HACK: simply don't allow this to happen.
      // ALSO: prevent selection when an *event* is already raised.


      return view.isSelected || view.selectedEvent;
    },
    shouldIgnoreEventPointing: function shouldIgnoreEventPointing() {
      // only call the handlers if there is not a drag/resize in progress
      return this.eventDragging && this.eventDragging.isDragging || this.eventResizing && this.eventResizing.isResizing;
    },
    canStartSelection: function canStartSelection(seg, ev) {
      return getEvIsTouch(ev) && !this.canStartResize(seg, ev) && (this.isEventDefDraggable(seg.footprint.eventDef) || this.isEventDefResizable(seg.footprint.eventDef));
    },
    canStartDrag: function canStartDrag(seg, ev) {
      return !this.canStartResize(seg, ev) && this.isEventDefDraggable(seg.footprint.eventDef);
    },
    canStartResize: function canStartResize(seg, ev) {
      var view = this._getView();

      var eventDef = seg.footprint.eventDef;
      return (!getEvIsTouch(ev) || view.isEventDefSelected(eventDef)) && this.isEventDefResizable(eventDef) && $(ev.target).is(".fc-resizer");
    },
    // Kills all in-progress dragging.
    // Useful for when public API methods that result in re-rendering are invoked during a drag.
    // Also useful for when touch devices misbehave and don't fire their touchend.
    endInteractions: function endInteractions() {
      [this.dateClicking, this.dateSelecting, this.eventPointing, this.eventDragging, this.eventResizing].forEach(function (interaction) {
        if (interaction) {
          interaction.end();
        }
      });
    },
    // Event Drag-n-Drop
    // ---------------------------------------------------------------------------------------------------------------
    // Computes if the given event is allowed to be dragged by the user
    isEventDefDraggable: function isEventDefDraggable(eventDef) {
      return this.isEventDefStartEditable(eventDef);
    },
    isEventDefStartEditable: function isEventDefStartEditable(eventDef) {
      var isEditable = eventDef.isStartExplicitlyEditable();

      if (isEditable == null) {
        isEditable = this.opt("eventStartEditable");

        if (isEditable == null) {
          isEditable = this.isEventDefGenerallyEditable(eventDef);
        }
      }

      return isEditable;
    },
    isEventDefGenerallyEditable: function isEventDefGenerallyEditable(eventDef) {
      var isEditable = eventDef.isExplicitlyEditable();

      if (isEditable == null) {
        isEditable = this.opt("editable");
      }

      return isEditable;
    },
    // Event Resizing
    // ---------------------------------------------------------------------------------------------------------------
    // Computes if the given event is allowed to be resized from its starting edge
    isEventDefResizableFromStart: function isEventDefResizableFromStart(eventDef) {
      return this.opt("eventResizableFromStart") && this.isEventDefResizable(eventDef);
    },
    // Computes if the given event is allowed to be resized from its ending edge
    isEventDefResizableFromEnd: function isEventDefResizableFromEnd(eventDef) {
      return this.isEventDefResizable(eventDef);
    },
    // Computes if the given event is allowed to be resized by the user at all
    isEventDefResizable: function isEventDefResizable(eventDef) {
      var isResizable = eventDef.isDurationExplicitlyEditable();

      if (isResizable == null) {
        isResizable = this.opt("eventDurationEditable");

        if (isResizable == null) {
          isResizable = this.isEventDefGenerallyEditable(eventDef);
        }
      }

      return isResizable;
    },
    // Event Mutation / Constraints
    // ---------------------------------------------------------------------------------------------------------------
    // Diffs the two dates, returning a duration, based on granularity of the grid
    // TODO: port isTimeScale into this system?
    diffDates: function diffDates(a, b) {
      if (this.largeUnit) {
        return diffByUnit(a, b, this.largeUnit);
      } else {
        return diffDayTime(a, b);
      }
    },
    // is it allowed, in relation to the view's validRange?
    // NOTE: very similar to isExternalInstanceGroupAllowed
    isEventInstanceGroupAllowed: function isEventInstanceGroupAllowed(eventInstanceGroup) {
      var view = this._getView();

      var dateProfile = this.dateProfile;
      var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
      var i;

      for (i = 0; i < eventFootprints.length; i++) {
        // TODO: just use getAllEventRanges directly
        if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
          return false;
        }
      }

      return view.calendar.isEventInstanceGroupAllowed(eventInstanceGroup);
    },
    // NOTE: very similar to isEventInstanceGroupAllowed
    // when it's a completely anonymous external drag, no event.
    isExternalInstanceGroupAllowed: function isExternalInstanceGroupAllowed(eventInstanceGroup) {
      var view = this._getView();

      var dateProfile = this.dateProfile;
      var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
      var i;

      for (i = 0; i < eventFootprints.length; i++) {
        if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
          return false;
        }
      }

      for (i = 0; i < eventFootprints.length; i++) {
        // treat it as a selection
        // TODO: pass in eventInstanceGroup instead
        //  because we don't want calendar's constraint system to depend on a component's
        //  determination of footprints.
        if (!view.calendar.isSelectionFootprintAllowed(eventFootprints[i].componentFootprint)) {
          return false;
        }
      }

      return true;
    }
  });
  /*
  A set of rendering and date-related methods for a visual component comprised of one or more rows of day columns.
  Prerequisite: the object being mixed into needs to be a *Grid*
  */

  var DayTableMixin = FC.DayTableMixin = {
    breakOnWeeks: false,
    // should create a new row for each week?
    dayDates: null,
    // whole-day dates for each column. left to right
    dayIndices: null,
    // for each day from start, the offset
    daysPerRow: null,
    rowCnt: null,
    colCnt: null,
    colHeadFormat: null,
    // Populates internal variables used for date calculation and rendering
    updateDayTable: function updateDayTable() {
      var view = this.view;
      var calendar = view.calendar;
      var date = calendar.msToUtcMoment(this.dateProfile.renderUnzonedRange.startMs, true);
      var end = calendar.msToUtcMoment(this.dateProfile.renderUnzonedRange.endMs, true);
      var dayIndex = -1;
      var dayIndices = [];
      var dayDates = [];
      var daysPerRow;
      var firstDay;
      var rowCnt;

      while (date.isBefore(end)) {
        // loop each day from start to end
        if (view.isHiddenDay(date)) {
          dayIndices.push(dayIndex + 0.5); // mark that it's between indices
        } else {
          dayIndex++;
          dayIndices.push(dayIndex);
          dayDates.push(date.clone());
        }

        date.add(1, "days");
      }

      if (this.breakOnWeeks) {
        // count columns until the day-of-week repeats
        firstDay = dayDates[0].day();

        for (daysPerRow = 1; daysPerRow < dayDates.length; daysPerRow++) {
          if (dayDates[daysPerRow].day() == firstDay) {
            break;
          }
        }

        rowCnt = Math.ceil(dayDates.length / daysPerRow);
      } else {
        rowCnt = 1;
        daysPerRow = dayDates.length;
      }

      this.dayDates = dayDates;
      this.dayIndices = dayIndices;
      this.daysPerRow = daysPerRow;
      this.rowCnt = rowCnt;
      this.updateDayTableCols();
    },
    // Computes and assigned the colCnt property and updates any options that may be computed from it
    updateDayTableCols: function updateDayTableCols() {
      this.colCnt = this.computeColCnt();
      this.colHeadFormat = this.opt("columnFormat") || this.computeColHeadFormat();
    },
    // Determines how many columns there should be in the table
    computeColCnt: function computeColCnt() {
      return this.daysPerRow;
    },
    // Computes the ambiguously-timed moment for the given cell
    getCellDate: function getCellDate(row, col) {
      return this.dayDates[this.getCellDayIndex(row, col)].clone();
    },
    // Computes the ambiguously-timed date range for the given cell
    getCellRange: function getCellRange(row, col) {
      var start = this.getCellDate(row, col);
      var end = start.clone().add(1, "days");
      return {
        start: start,
        end: end
      };
    },
    // Returns the number of day cells, chronologically, from the first of the grid (0-based)
    getCellDayIndex: function getCellDayIndex(row, col) {
      return row * this.daysPerRow + this.getColDayIndex(col);
    },
    // Returns the numner of day cells, chronologically, from the first cell in *any given row*
    getColDayIndex: function getColDayIndex(col) {
      if (this.isRTL) {
        return this.colCnt - 1 - col;
      } else {
        return col;
      }
    },
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    getDateDayIndex: function getDateDayIndex(date) {
      var dayIndices = this.dayIndices;
      var dayOffset = date.diff(this.dayDates[0], "days");

      if (dayOffset < 0) {
        return dayIndices[0] - 1;
      } else if (dayOffset >= dayIndices.length) {
        return dayIndices[dayIndices.length - 1] + 1;
      } else {
        return dayIndices[dayOffset];
      }
    },

    /* Options
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes a default column header formatting string if `colFormat` is not explicitly defined
    computeColHeadFormat: function computeColHeadFormat() {
      // if more than one week row, or if there are a lot of columns with not much space,
      // put just the day numbers will be in each cell
      if (this.rowCnt > 1 || this.colCnt > 10) {
        return "ddd"; // "Sat"
      } // multiple days, so full single date string WON'T be in title text
      else if (this.colCnt > 1) {
        return this.opt("dayOfMonthFormat"); // "Sat 12/10"
      } // single day, so full single date string will probably be in title text
      else {
        return "dddd"; // "Saturday"
      }
    },

    /* Slicing
    ------------------------------------------------------------------------------------------------------------------*/
    // Slices up a date range into a segment for every week-row it intersects with
    sliceRangeByRow: function sliceRangeByRow(unzonedRange) {
      var daysPerRow = this.daysPerRow;
      var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold

      var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index

      var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, "days")); // inclusive last index

      var segs = [];
      var row;
      var rowFirst, rowLast; // inclusive day-index range for current row

      var segFirst, segLast; // inclusive day-index range for segment

      for (row = 0; row < this.rowCnt; row++) {
        rowFirst = row * daysPerRow;
        rowLast = rowFirst + daysPerRow - 1; // intersect segment's offset range with the row's

        segFirst = Math.max(rangeFirst, rowFirst);
        segLast = Math.min(rangeLast, rowLast); // deal with in-between indices

        segFirst = Math.ceil(segFirst); // in-between starts round to next cell

        segLast = Math.floor(segLast); // in-between ends round to prev cell

        if (segFirst <= segLast) {
          // was there any intersection with the current row?
          segs.push({
            row: row,
            // normalize to start of row
            firstRowDayIndex: segFirst - rowFirst,
            lastRowDayIndex: segLast - rowFirst,
            // must be matching integers to be the segment's start/end
            isStart: segFirst === rangeFirst,
            isEnd: segLast === rangeLast
          });
        }
      }

      return segs;
    },
    // Slices up a date range into a segment for every day-cell it intersects with.
    // TODO: make more DRY with sliceRangeByRow somehow.
    sliceRangeByDay: function sliceRangeByDay(unzonedRange) {
      var daysPerRow = this.daysPerRow;
      var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold

      var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index

      var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, "days")); // inclusive last index

      var segs = [];
      var row;
      var rowFirst, rowLast; // inclusive day-index range for current row

      var i;
      var segFirst, segLast; // inclusive day-index range for segment

      for (row = 0; row < this.rowCnt; row++) {
        rowFirst = row * daysPerRow;
        rowLast = rowFirst + daysPerRow - 1;

        for (i = rowFirst; i <= rowLast; i++) {
          // intersect segment's offset range with the row's
          segFirst = Math.max(rangeFirst, i);
          segLast = Math.min(rangeLast, i); // deal with in-between indices

          segFirst = Math.ceil(segFirst); // in-between starts round to next cell

          segLast = Math.floor(segLast); // in-between ends round to prev cell

          if (segFirst <= segLast) {
            // was there any intersection with the current row?
            segs.push({
              row: row,
              // normalize to start of row
              firstRowDayIndex: segFirst - rowFirst,
              lastRowDayIndex: segLast - rowFirst,
              // must be matching integers to be the segment's start/end
              isStart: segFirst === rangeFirst,
              isEnd: segLast === rangeLast
            });
          }
        }
      }

      return segs;
    },

    /* Header Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    renderHeadHtml: function renderHeadHtml() {
      var theme = this.view.calendar.theme;
      return "" + '<div class="fc-row ' + theme.getClass("headerRow") + '">' + '<table class="' + theme.getClass("tableGrid") + '">' + "<thead>" + this.renderHeadTrHtml() + "</thead>" + "</table>" + "</div>";
    },
    renderHeadIntroHtml: function renderHeadIntroHtml() {
      return this.renderIntroHtml(); // fall back to generic
    },
    renderHeadTrHtml: function renderHeadTrHtml() {
      return "" + "<tr>" + (this.isRTL ? "" : this.renderHeadIntroHtml()) + this.renderHeadDateCellsHtml() + (this.isRTL ? this.renderHeadIntroHtml() : "") + "</tr>";
    },
    renderHeadDateCellsHtml: function renderHeadDateCellsHtml() {
      var htmls = [];
      var col, date;

      for (col = 0; col < this.colCnt; col++) {
        date = this.getCellDate(0, col);
        htmls.push(this.renderHeadDateCellHtml(date));
      }

      return htmls.join("");
    },
    // TODO: when internalApiVersion, accept an object for HTML attributes
    // (colspan should be no different)
    renderHeadDateCellHtml: function renderHeadDateCellHtml(date, colspan, otherAttrs) {
      var view = this.view;
      var isDateValid = this.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.

      var classNames = ["fc-day-header", view.calendar.theme.getClass("widgetHeader")];
      var innerHtml = htmlEscape(date.format(this.colHeadFormat)); // if only one row of days, the classNames on the header can represent the specific days beneath

      if (this.rowCnt === 1) {
        classNames = classNames.concat( // includes the day-of-week class
        // noThemeHighlight=true (don't highlight the header)
        this.getDayClasses(date, true));
      } else {
        classNames.push("fc-" + dayIDs[date.day()]); // only add the day-of-week class
      }

      return "" + '<th class="' + classNames.join(" ") + '"' + ((isDateValid && this.rowCnt) === 1 ? ' data-date="' + date.format("YYYY-MM-DD") + '"' : "") + (colspan > 1 ? ' colspan="' + colspan + '"' : "") + (otherAttrs ? " " + otherAttrs : "") + ">" + (isDateValid ? // don't make a link if the heading could represent multiple days, or if there's only one day (forceOff)
      view.buildGotoAnchorHtml({
        date: date,
        forceOff: this.rowCnt > 1 || this.colCnt === 1
      }, innerHtml) : // if not valid, display text, but no link
      innerHtml) + "</th>";
    },

    /* Background Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    renderBgTrHtml: function renderBgTrHtml(row) {
      return "" + "<tr>" + (this.isRTL ? "" : this.renderBgIntroHtml(row)) + this.renderBgCellsHtml(row) + (this.isRTL ? this.renderBgIntroHtml(row) : "") + "</tr>";
    },
    renderBgIntroHtml: function renderBgIntroHtml(row) {
      return this.renderIntroHtml(); // fall back to generic
    },
    renderBgCellsHtml: function renderBgCellsHtml(row) {
      var htmls = [];
      var col, date;

      for (col = 0; col < this.colCnt; col++) {
        date = this.getCellDate(row, col);
        htmls.push(this.renderBgCellHtml(date));
      }

      return htmls.join("");
    },
    renderBgCellHtml: function renderBgCellHtml(date, otherAttrs) {
      var view = this.view;
      var isDateValid = this.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.

      var classes = this.getDayClasses(date);
      classes.unshift("fc-day", view.calendar.theme.getClass("widgetContent"));
      return '<td class="' + classes.join(" ") + '"' + (isDateValid ? ' data-date="' + date.format("YYYY-MM-DD") + '"' // if date has a time, won't format it
      : "") + (otherAttrs ? " " + otherAttrs : "") + "></td>";
    },

    /* Generic
    ------------------------------------------------------------------------------------------------------------------*/
    // Generates the default HTML intro for any row. User classes should override
    renderIntroHtml: function renderIntroHtml() {},
    // TODO: a generic method for dealing with <tr>, RTL, intro
    // when increment internalApiVersion
    // wrapTr (scheduler)

    /* Utils
    ------------------------------------------------------------------------------------------------------------------*/
    // Applies the generic "intro" and "outro" HTML to the given cells.
    // Intro means the leftmost cell when the calendar is LTR and the rightmost cell when RTL. Vice-versa for outro.
    bookendCells: function bookendCells(trEl) {
      var introHtml = this.renderIntroHtml();

      if (introHtml) {
        if (this.isRTL) {
          trEl.append(introHtml);
        } else {
          trEl.prepend(introHtml);
        }
      }
    }
  };
  /* An abstract class from which other views inherit from
  ----------------------------------------------------------------------------------------------------------------------*/

  var View = FC.View = InteractiveDateComponent.extend({
    type: null,
    // subclass' view name (string)
    name: null,
    // deprecated. use `type` instead
    title: null,
    // the text that will be displayed in the header's title
    calendar: null,
    // owner Calendar object
    viewSpec: null,
    options: null,
    // hash containing all options. already merged with view-specific-options
    renderQueue: null,
    batchRenderDepth: 0,
    queuedScroll: null,
    isSelected: false,
    // boolean whether a range of time is user-selected or not
    selectedEventInstance: null,
    eventOrderSpecs: null,
    // criteria for ordering events when they have same date/time
    // for date utils, computed from options
    isHiddenDayHash: null,
    // now indicator
    isNowIndicatorRendered: null,
    initialNowDate: null,
    // result first getNow call
    initialNowQueriedMs: null,
    // ms time the getNow was called
    nowIndicatorTimeoutID: null,
    // for refresh timing of now indicator
    nowIndicatorIntervalID: null,
    // "
    constructor: function constructor(calendar, viewSpec) {
      this.calendar = calendar;
      this.viewSpec = viewSpec; // shortcuts

      this.type = viewSpec.type;
      this.options = viewSpec.options; // .name is deprecated

      this.name = this.type;
      InteractiveDateComponent.call(this);
      this.initRenderQueue();
      this.initHiddenDays();
      this.bindBaseRenderHandlers();
      this.eventOrderSpecs = parseFieldSpecs(this.opt("eventOrder")); // legacy

      if (this.initialize) {
        this.initialize();
      }
    },
    _getView: function _getView() {
      return this;
    },
    // Retrieves an option with the given name
    opt: function opt(name) {
      return this.options[name];
    },

    /* Render Queue
    ------------------------------------------------------------------------------------------------------------------*/
    initRenderQueue: function initRenderQueue() {
      this.renderQueue = new RenderQueue({
        event: this.opt("eventRenderWait")
      });
      this.renderQueue.on("start", this.onRenderQueueStart.bind(this));
      this.renderQueue.on("stop", this.onRenderQueueStop.bind(this));
      this.on("before:change", this.startBatchRender);
      this.on("change", this.stopBatchRender);
    },
    onRenderQueueStart: function onRenderQueueStart() {
      this.calendar.freezeContentHeight();
      this.addScroll(this.queryScroll());
    },
    onRenderQueueStop: function onRenderQueueStop() {
      if (this.calendar.updateViewSize()) {
        // success?
        this.popScroll();
      }

      this.calendar.thawContentHeight();
    },
    startBatchRender: function startBatchRender() {
      if (!this.batchRenderDepth++) {
        this.renderQueue.pause();
      }
    },
    stopBatchRender: function stopBatchRender() {
      if (! --this.batchRenderDepth) {
        this.renderQueue.resume();
      }
    },
    requestRender: function requestRender(func, namespace, actionType) {
      this.renderQueue.queue(func, namespace, actionType);
    },
    // given func will auto-bind to `this`
    whenSizeUpdated: function whenSizeUpdated(func) {
      if (this.renderQueue.isRunning) {
        this.renderQueue.one("stop", func.bind(this));
      } else {
        func.call(this);
      }
    },

    /* Title and Date Formatting
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes what the title at the top of the calendar should be for this view
    computeTitle: function computeTitle(dateProfile) {
      var unzonedRange; // for views that span a large unit of time, show the proper interval, ignoring stray days before and after

      if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) {
        unzonedRange = dateProfile.currentUnzonedRange;
      } else {
        // for day units or smaller, use the actual day range
        unzonedRange = dateProfile.activeUnzonedRange;
      }

      return this.formatRange({
        start: this.calendar.msToMoment(unzonedRange.startMs, dateProfile.isRangeAllDay),
        end: this.calendar.msToMoment(unzonedRange.endMs, dateProfile.isRangeAllDay)
      }, dateProfile.isRangeAllDay, this.opt("titleFormat") || this.computeTitleFormat(dateProfile), this.opt("titleRangeSeparator"));
    },
    // Generates the format string that should be used to generate the title for the current date range.
    // Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
    computeTitleFormat: function computeTitleFormat(dateProfile) {
      var currentRangeUnit = dateProfile.currentRangeUnit;

      if (currentRangeUnit == "year") {
        return "YYYY";
      } else if (currentRangeUnit == "month") {
        return this.opt("monthYearFormat"); // like "September 2014"
      } else if (dateProfile.currentUnzonedRange.as("days") > 1) {
        return "ll"; // multi-day range. shorter, like "Sep 9 - 10 2014"
      } else {
        return "LL"; // one day. longer, like "September 9 2014"
      }
    },
    // Date Setting/Unsetting
    // -----------------------------------------------------------------------------------------------------------------
    setDate: function setDate(date) {
      var currentDateProfile = this.get("dateProfile");
      var newDateProfile = this.buildDateProfile(date, null, true); // forceToValid=true

      if (!currentDateProfile || !currentDateProfile.activeUnzonedRange.equals(newDateProfile.activeUnzonedRange)) {
        this.set("dateProfile", newDateProfile);
      }
    },
    unsetDate: function unsetDate() {
      this.unset("dateProfile");
    },
    // Event Data
    // -----------------------------------------------------------------------------------------------------------------
    fetchInitialEvents: function fetchInitialEvents(dateProfile) {
      var calendar = this.calendar;
      var forceAllDay = dateProfile.isRangeAllDay && !this.usesMinMaxTime;
      return calendar.requestEvents(calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, forceAllDay), calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, forceAllDay));
    },
    bindEventChanges: function bindEventChanges() {
      this.listenTo(this.calendar, "eventsReset", this.resetEvents); // TODO: make this a real event
    },
    unbindEventChanges: function unbindEventChanges() {
      this.stopListeningTo(this.calendar, "eventsReset");
    },
    setEvents: function setEvents(eventsPayload) {
      this.set("currentEvents", eventsPayload);
      this.set("hasEvents", true);
    },
    unsetEvents: function unsetEvents() {
      this.unset("currentEvents");
      this.unset("hasEvents");
    },
    resetEvents: function resetEvents(eventsPayload) {
      this.startBatchRender();
      this.unsetEvents();
      this.setEvents(eventsPayload);
      this.stopBatchRender();
    },
    // Date High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    requestDateRender: function requestDateRender(dateProfile) {
      var _this = this;

      this.requestRender(function () {
        _this.executeDateRender(dateProfile);
      }, "date", "init");
    },
    requestDateUnrender: function requestDateUnrender() {
      var _this = this;

      this.requestRender(function () {
        _this.executeDateUnrender();
      }, "date", "destroy");
    },
    // if dateProfile not specified, uses current
    executeDateRender: function executeDateRender(dateProfile) {
      DateComponent.prototype.executeDateRender.apply(this, arguments);

      if (this.render) {
        this.render(); // TODO: deprecate
      }

      this.trigger("datesRendered");
      this.addScroll({
        isDateInit: true
      });
      this.startNowIndicator(); // shouldn't render yet because updateSize will be called soon
    },
    executeDateUnrender: function executeDateUnrender() {
      this.unselect();
      this.stopNowIndicator();
      this.trigger("before:datesUnrendered");

      if (this.destroy) {
        this.destroy(); // TODO: deprecate
      }

      DateComponent.prototype.executeDateUnrender.apply(this, arguments);
    },
    // "Base" rendering
    // -----------------------------------------------------------------------------------------------------------------
    bindBaseRenderHandlers: function bindBaseRenderHandlers() {
      var _this = this;

      this.on("datesRendered", function () {
        _this.whenSizeUpdated(_this.triggerViewRender);
      });
      this.on("before:datesUnrendered", function () {
        _this.triggerViewDestroy();
      });
    },
    triggerViewRender: function triggerViewRender() {
      this.publiclyTrigger("viewRender", {
        context: this,
        args: [this, this.el]
      });
    },
    triggerViewDestroy: function triggerViewDestroy() {
      this.publiclyTrigger("viewDestroy", {
        context: this,
        args: [this, this.el]
      });
    },
    // Event High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    requestEventsRender: function requestEventsRender(eventsPayload) {
      var _this = this;

      this.requestRender(function () {
        _this.executeEventRender(eventsPayload);

        _this.whenSizeUpdated(_this.triggerAfterEventsRendered);
      }, "event", "init");
    },
    requestEventsUnrender: function requestEventsUnrender() {
      var _this = this;

      this.requestRender(function () {
        _this.triggerBeforeEventsDestroyed();

        _this.executeEventUnrender();
      }, "event", "destroy");
    },
    // Business Hour High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    requestBusinessHoursRender: function requestBusinessHoursRender(businessHourGenerator) {
      var _this = this;

      this.requestRender(function () {
        _this.renderBusinessHours(businessHourGenerator);
      }, "businessHours", "init");
    },
    requestBusinessHoursUnrender: function requestBusinessHoursUnrender() {
      var _this = this;

      this.requestRender(function () {
        _this.unrenderBusinessHours();
      }, "businessHours", "destroy");
    },
    // Misc view rendering utils
    // -----------------------------------------------------------------------------------------------------------------
    // Binds DOM handlers to elements that reside outside the view container, such as the document
    bindGlobalHandlers: function bindGlobalHandlers() {
      InteractiveDateComponent.prototype.bindGlobalHandlers.apply(this, arguments);
      this.listenTo(GlobalEmitter.get(), {
        touchstart: this.processUnselect,
        mousedown: this.handleDocumentMousedown
      });
    },
    // Unbinds DOM handlers from elements that reside outside the view container
    unbindGlobalHandlers: function unbindGlobalHandlers() {
      InteractiveDateComponent.prototype.unbindGlobalHandlers.apply(this, arguments);
      this.stopListeningTo(GlobalEmitter.get());
    },

    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    // Immediately render the current time indicator and begins re-rendering it at an interval,
    // which is defined by this.getNowIndicatorUnit().
    // TODO: somehow do this for the current whole day's background too
    startNowIndicator: function startNowIndicator() {
      var _this = this;

      var unit;
      var update;
      var delay; // ms wait value

      if (this.opt("nowIndicator")) {
        unit = this.getNowIndicatorUnit();

        if (unit) {
          update = proxy(this, "updateNowIndicator"); // bind to `this`

          this.initialNowDate = this.calendar.getNow();
          this.initialNowQueriedMs = +new Date(); // wait until the beginning of the next interval

          delay = this.initialNowDate.clone().startOf(unit).add(1, unit) - this.initialNowDate;
          this.nowIndicatorTimeoutID = setTimeout(function () {
            _this.nowIndicatorTimeoutID = null;
            update();
            delay = +moment.duration(1, unit);
            delay = Math.max(100, delay); // prevent too frequent

            _this.nowIndicatorIntervalID = setInterval(update, delay); // update every interval
          }, delay);
        } // rendering will be initiated in updateSize

      }
    },
    // rerenders the now indicator, computing the new current time from the amount of time that has passed
    // since the initial getNow call.
    updateNowIndicator: function updateNowIndicator() {
      if (this.isDatesRendered && this.initialNowDate // activated before?
      ) {
        this.unrenderNowIndicator(); // won't unrender if unnecessary

        this.renderNowIndicator(this.initialNowDate.clone().add(new Date() - this.initialNowQueriedMs) // add ms
        );
        this.isNowIndicatorRendered = true;
      }
    },
    // Immediately unrenders the view's current time indicator and stops any re-rendering timers.
    // Won't cause side effects if indicator isn't rendered.
    stopNowIndicator: function stopNowIndicator() {
      if (this.isNowIndicatorRendered) {
        if (this.nowIndicatorTimeoutID) {
          clearTimeout(this.nowIndicatorTimeoutID);
          this.nowIndicatorTimeoutID = null;
        }

        if (this.nowIndicatorIntervalID) {
          clearInterval(this.nowIndicatorIntervalID);
          this.nowIndicatorIntervalID = null;
        }

        this.unrenderNowIndicator();
        this.isNowIndicatorRendered = false;
      }
    },

    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    updateSize: function updateSize(totalHeight, isAuto, isResize) {
      if (this.setHeight) {
        // for legacy API
        this.setHeight(totalHeight, isAuto);
      } else {
        InteractiveDateComponent.prototype.updateSize.apply(this, arguments);
      }

      this.updateNowIndicator();
    },

    /* Scroller
    ------------------------------------------------------------------------------------------------------------------*/
    addScroll: function addScroll(scroll) {
      var queuedScroll = this.queuedScroll || (this.queuedScroll = {});
      $.extend(queuedScroll, scroll);
    },
    popScroll: function popScroll() {
      this.applyQueuedScroll();
      this.queuedScroll = null;
    },
    applyQueuedScroll: function applyQueuedScroll() {
      if (this.queuedScroll) {
        this.applyScroll(this.queuedScroll);
      }
    },
    queryScroll: function queryScroll() {
      var scroll = {};

      if (this.isDatesRendered) {
        $.extend(scroll, this.queryDateScroll());
      }

      return scroll;
    },
    applyScroll: function applyScroll(scroll) {
      if (scroll.isDateInit && this.isDatesRendered) {
        $.extend(scroll, this.computeInitialDateScroll());
      }

      if (this.isDatesRendered) {
        this.applyDateScroll(scroll);
      }
    },
    computeInitialDateScroll: function computeInitialDateScroll() {
      return {}; // subclasses must implement
    },
    queryDateScroll: function queryDateScroll() {
      return {}; // subclasses must implement
    },
    applyDateScroll: function applyDateScroll(scroll) {// subclasses must implement
    },

    /* Event Drag-n-Drop
    ------------------------------------------------------------------------------------------------------------------*/
    reportEventDrop: function reportEventDrop(eventInstance, eventMutation, el, ev) {
      var eventManager = this.calendar.eventManager;
      var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation, this.calendar);
      var dateMutation = eventMutation.dateMutation; // update the EventInstance, for handlers

      if (dateMutation) {
        eventInstance.dateProfile = dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
      }

      this.triggerEventDrop(eventInstance, // a drop doesn't necessarily mean a date mutation (ex: resource change)
      dateMutation && dateMutation.dateDelta || moment.duration(), undoFunc, el, ev);
    },
    // Triggers event-drop handlers that have subscribed via the API
    triggerEventDrop: function triggerEventDrop(eventInstance, dateDelta, undoFunc, el, ev) {
      this.publiclyTrigger("eventDrop", {
        context: el[0],
        args: [eventInstance.toLegacy(), dateDelta, undoFunc, ev, {}, // {} = jqui dummy
        this]
      });
    },

    /* External Element Drag-n-Drop
    ------------------------------------------------------------------------------------------------------------------*/
    // Must be called when an external element, via jQuery UI, has been dropped onto the calendar.
    // `meta` is the parsed data that has been embedded into the dragging event.
    // `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
    reportExternalDrop: function reportExternalDrop(singleEventDef, isEvent, isSticky, el, ev, ui) {
      if (isEvent) {
        this.calendar.eventManager.addEventDef(singleEventDef, isSticky);
      }

      this.triggerExternalDrop(singleEventDef, isEvent, el, ev, ui);
    },
    // Triggers external-drop handlers that have subscribed via the API
    triggerExternalDrop: function triggerExternalDrop(singleEventDef, isEvent, el, ev, ui) {
      // trigger 'drop' regardless of whether element represents an event
      this.publiclyTrigger("drop", {
        context: el[0],
        args: [singleEventDef.dateProfile.start.clone(), ev, ui, this]
      });

      if (isEvent) {
        // signal an external event landed
        this.publiclyTrigger("eventReceive", {
          context: this,
          args: [singleEventDef.buildInstance().toLegacy(), this]
        });
      }
    },

    /* Event Resizing
    ------------------------------------------------------------------------------------------------------------------*/
    // Must be called when an event in the view has been resized to a new length
    reportEventResize: function reportEventResize(eventInstance, eventMutation, el, ev) {
      var eventManager = this.calendar.eventManager;
      var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation, this.calendar); // update the EventInstance, for handlers

      eventInstance.dateProfile = eventMutation.dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
      this.triggerEventResize(eventInstance, eventMutation.dateMutation.endDelta, undoFunc, el, ev);
    },
    // Triggers event-resize handlers that have subscribed via the API
    triggerEventResize: function triggerEventResize(eventInstance, durationDelta, undoFunc, el, ev) {
      this.publiclyTrigger("eventResize", {
        context: el[0],
        args: [eventInstance.toLegacy(), durationDelta, undoFunc, ev, {}, // {} = jqui dummy
        this]
      });
    },

    /* Selection (time range)
    ------------------------------------------------------------------------------------------------------------------*/
    // Selects a date span on the view. `start` and `end` are both Moments.
    // `ev` is the native mouse event that begin the interaction.
    select: function select(footprint, ev) {
      this.unselect(ev);
      this.renderSelectionFootprint(footprint);
      this.reportSelection(footprint, ev);
    },
    renderSelectionFootprint: function renderSelectionFootprint(footprint, ev) {
      if (this.renderSelection) {
        // legacy method in custom view classes
        this.renderSelection(footprint.toLegacy(this.calendar));
      } else {
        InteractiveDateComponent.prototype.renderSelectionFootprint.apply(this, arguments);
      }
    },
    // Called when a new selection is made. Updates internal state and triggers handlers.
    reportSelection: function reportSelection(footprint, ev) {
      this.isSelected = true;
      this.triggerSelect(footprint, ev);
    },
    // Triggers handlers to 'select'
    triggerSelect: function triggerSelect(footprint, ev) {
      var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?

      this.publiclyTrigger("select", {
        context: this,
        args: [dateProfile.start, dateProfile.end, ev, this]
      });
    },
    // Undoes a selection. updates in the internal state and triggers handlers.
    // `ev` is the native mouse event that began the interaction.
    unselect: function unselect(ev) {
      if (this.isSelected) {
        this.isSelected = false;

        if (this.destroySelection) {
          this.destroySelection(); // TODO: deprecate
        }

        this.unrenderSelection();
        this.publiclyTrigger("unselect", {
          context: this,
          args: [ev, this]
        });
      }
    },

    /* Event Selection
    ------------------------------------------------------------------------------------------------------------------*/
    selectEventInstance: function selectEventInstance(eventInstance) {
      if (!this.selectedEventInstance || this.selectedEventInstance !== eventInstance) {
        this.unselectEventInstance();
        this.getEventSegs().forEach(function (seg) {
          if (seg.footprint.eventInstance === eventInstance && seg.el // necessary?
          ) {
            seg.el.addClass("fc-selected");
          }
        });
        this.selectedEventInstance = eventInstance;
      }
    },
    unselectEventInstance: function unselectEventInstance() {
      if (this.selectedEventInstance) {
        this.getEventSegs().forEach(function (seg) {
          if (seg.el) {
            // necessary?
            seg.el.removeClass("fc-selected");
          }
        });
        this.selectedEventInstance = null;
      }
    },
    isEventDefSelected: function isEventDefSelected(eventDef) {
      // event references might change on refetchEvents(), while selectedEventInstance doesn't,
      // so compare IDs
      return this.selectedEventInstance && this.selectedEventInstance.def.id === eventDef.id;
    },

    /* Mouse / Touch Unselecting (time range & event unselection)
    ------------------------------------------------------------------------------------------------------------------*/
    // TODO: move consistently to down/start or up/end?
    // TODO: don't kill previous selection if touch scrolling
    handleDocumentMousedown: function handleDocumentMousedown(ev) {
      if (isPrimaryMouseButton(ev)) {
        this.processUnselect(ev);
      }
    },
    processUnselect: function processUnselect(ev) {
      this.processRangeUnselect(ev);
      this.processEventUnselect(ev);
    },
    processRangeUnselect: function processRangeUnselect(ev) {
      var ignore; // is there a time-range selection?

      if (this.isSelected && this.opt("unselectAuto")) {
        // only unselect if the clicked element is not identical to or inside of an 'unselectCancel' element
        ignore = this.opt("unselectCancel");

        if (!ignore || !$(ev.target).closest(ignore).length) {
          this.unselect(ev);
        }
      }
    },
    processEventUnselect: function processEventUnselect(ev) {
      if (this.selectedEventInstance) {
        if (!$(ev.target).closest(".fc-selected").length) {
          this.unselectEventInstance();
        }
      }
    },

    /* Triggers
    ------------------------------------------------------------------------------------------------------------------*/
    triggerBaseRendered: function triggerBaseRendered() {
      this.publiclyTrigger("viewRender", {
        context: this,
        args: [this, this.el]
      });
    },
    triggerBaseUnrendered: function triggerBaseUnrendered() {
      this.publiclyTrigger("viewDestroy", {
        context: this,
        args: [this, this.el]
      });
    },
    // Triggers handlers to 'dayClick'
    // Span has start/end of the clicked area. Only the start is useful.
    triggerDayClick: function triggerDayClick(footprint, dayEl, ev) {
      var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?

      this.publiclyTrigger("dayClick", {
        context: dayEl,
        args: [dateProfile.start, ev, this]
      });
    }
  });
  View.watch("displayingDates", ["isInDom", "dateProfile"], function (deps) {
    this.requestDateRender(deps.dateProfile);
  }, function () {
    this.requestDateUnrender();
  });
  View.watch("displayingBusinessHours", ["displayingDates", "businessHourGenerator"], function (deps) {
    this.requestBusinessHoursRender(deps.businessHourGenerator);
  }, function () {
    this.requestBusinessHoursUnrender();
  });
  View.watch("initialEvents", ["dateProfile"], function (deps) {
    return this.fetchInitialEvents(deps.dateProfile);
  });
  View.watch("bindingEvents", ["initialEvents"], function (deps) {
    this.setEvents(deps.initialEvents);
    this.bindEventChanges();
  }, function () {
    this.unbindEventChanges();
    this.unsetEvents();
  });
  View.watch("displayingEvents", ["displayingDates", "hasEvents"], function () {
    this.requestEventsRender(this.get("currentEvents"));
  }, function () {
    this.requestEventsUnrender();
  });
  View.watch("title", ["dateProfile"], function (deps) {
    return this.title = this.computeTitle(deps.dateProfile); // assign to View for legacy reasons
  });
  View.watch("legacyDateProps", ["dateProfile"], function (deps) {
    var calendar = this.calendar;
    var dateProfile = deps.dateProfile; // DEPRECATED, but we need to keep it updated...

    this.start = calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, dateProfile.isRangeAllDay);
    this.end = calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, dateProfile.isRangeAllDay);
    this.intervalStart = calendar.msToMoment(dateProfile.currentUnzonedRange.startMs, dateProfile.isRangeAllDay);
    this.intervalEnd = calendar.msToMoment(dateProfile.currentUnzonedRange.endMs, dateProfile.isRangeAllDay);
  });
  View.mixin({
    usesMinMaxTime: false,
    // whether minTime/maxTime will affect the activeUnzonedRange. Views must opt-in.
    // DEPRECATED
    start: null,
    // use activeUnzonedRange
    end: null,
    // use activeUnzonedRange
    intervalStart: null,
    // use currentUnzonedRange
    intervalEnd: null,
    // use currentUnzonedRange

    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/
    // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    buildPrevDateProfile: function buildPrevDateProfile(date) {
      var dateProfile = this.get("dateProfile");
      var prevDate = date.clone().startOf(dateProfile.currentRangeUnit).subtract(dateProfile.dateIncrement);
      return this.buildDateProfile(prevDate, -1);
    },
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    buildNextDateProfile: function buildNextDateProfile(date) {
      var dateProfile = this.get("dateProfile");
      var nextDate = date.clone().startOf(dateProfile.currentRangeUnit).add(dateProfile.dateIncrement);
      return this.buildDateProfile(nextDate, 1);
    },
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    buildDateProfile: function buildDateProfile(date, direction, forceToValid) {
      var isDateAllDay = !date.hasTime();
      var validUnzonedRange;
      var minTime = null;
      var maxTime = null;
      var currentInfo;
      var isRangeAllDay;
      var renderUnzonedRange;
      var activeUnzonedRange;
      var isValid;
      validUnzonedRange = this.buildValidRange();
      validUnzonedRange = this.trimHiddenDays(validUnzonedRange);

      if (forceToValid) {
        date = this.calendar.msToUtcMoment(validUnzonedRange.constrainDate(date), // returns MS
        isDateAllDay);
      }

      currentInfo = this.buildCurrentRangeInfo(date, direction);
      isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
      renderUnzonedRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.unzonedRange), currentInfo.unit, isRangeAllDay);
      renderUnzonedRange = this.trimHiddenDays(renderUnzonedRange);
      activeUnzonedRange = renderUnzonedRange.clone();

      if (!this.opt("showNonCurrentDates")) {
        activeUnzonedRange = activeUnzonedRange.intersect(currentInfo.unzonedRange);
      }

      minTime = moment.duration(this.opt("minTime"));
      maxTime = moment.duration(this.opt("maxTime"));
      activeUnzonedRange = this.adjustActiveRange(activeUnzonedRange, minTime, maxTime);
      activeUnzonedRange = activeUnzonedRange.intersect(validUnzonedRange); // might return null

      if (activeUnzonedRange) {
        date = this.calendar.msToUtcMoment(activeUnzonedRange.constrainDate(date), // returns MS
        isDateAllDay);
      } // it's invalid if the originally requested date is not contained,
      // or if the range is completely outside of the valid range.


      isValid = currentInfo.unzonedRange.intersectsWith(validUnzonedRange);
      return {
        // constraint for where prev/next operations can go and where events can be dragged/resized to.
        // an object with optional start and end properties.
        validUnzonedRange: validUnzonedRange,
        // range the view is formally responsible for.
        // for example, a month view might have 1st-31st, excluding padded dates
        currentUnzonedRange: currentInfo.unzonedRange,
        // name of largest unit being displayed, like "month" or "week"
        currentRangeUnit: currentInfo.unit,
        isRangeAllDay: isRangeAllDay,
        // dates that display events and accept drag-n-drop
        // will be `null` if no dates accept events
        activeUnzonedRange: activeUnzonedRange,
        // date range with a rendered skeleton
        // includes not-active days that need some sort of DOM
        renderUnzonedRange: renderUnzonedRange,
        // Duration object that denotes the first visible time of any given day
        minTime: minTime,
        // Duration object that denotes the exclusive visible end time of any given day
        maxTime: maxTime,
        isValid: isValid,
        date: date,
        // how far the current date will move for a prev/next operation
        dateIncrement: this.buildDateIncrement(currentInfo.duration) // pass a fallback (might be null) ^

      };
    },
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    buildValidRange: function buildValidRange() {
      return this.getUnzonedRangeOption("validRange", this.calendar.getNow()) || new UnzonedRange(); // completely open-ended
    },
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See buildDateProfile for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    // TODO: accept a MS-time instead of a moment `date`?
    buildCurrentRangeInfo: function buildCurrentRangeInfo(date, direction) {
      var duration = null;
      var unit = null;
      var unzonedRange = null;
      var dayCount;

      if (this.viewSpec.duration) {
        duration = this.viewSpec.duration;
        unit = this.viewSpec.durationUnit;
        unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
      } else if (dayCount = this.opt("dayCount")) {
        unit = "day";
        unzonedRange = this.buildRangeFromDayCount(date, direction, dayCount);
      } else if (unzonedRange = this.buildCustomVisibleRange(date)) {
        unit = computeGreatestUnit(unzonedRange.getStart(), unzonedRange.getEnd());
      } else {
        duration = this.getFallbackDuration();
        unit = computeGreatestUnit(duration);
        unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
      }

      return {
        duration: duration,
        unit: unit,
        unzonedRange: unzonedRange
      };
    },
    getFallbackDuration: function getFallbackDuration() {
      return moment.duration({
        days: 1
      });
    },
    // Returns a new activeUnzonedRange to have time values (un-ambiguate)
    // minTime or maxTime causes the range to expand.
    adjustActiveRange: function adjustActiveRange(unzonedRange, minTime, maxTime) {
      var start = unzonedRange.getStart();
      var end = unzonedRange.getEnd();

      if (this.usesMinMaxTime) {
        if (minTime < 0) {
          start.time(0).add(minTime);
        }

        if (maxTime > 24 * 60 * 60 * 1000) {
          // beyond 24 hours?
          end.time(maxTime - 24 * 60 * 60 * 1000);
        }
      }

      return new UnzonedRange(start, end);
    },
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed computeGreatestUnit value of duration.
    // TODO: accept a MS-time instead of a moment `date`?
    buildRangeFromDuration: function buildRangeFromDuration(date, direction, duration, unit) {
      var alignment = this.opt("dateAlignment");
      var start = date.clone();
      var end;
      var dateIncrementInput;
      var dateIncrementDuration; // if the view displays a single day or smaller

      if (duration.as("days") <= 1) {
        if (this.isHiddenDay(start)) {
          start = this.skipHiddenDays(start, direction);
          start.startOf("day");
        }
      } // compute what the alignment should be


      if (!alignment) {
        dateIncrementInput = this.opt("dateIncrement");

        if (dateIncrementInput) {
          dateIncrementDuration = moment.duration(dateIncrementInput); // use the smaller of the two units

          if (dateIncrementDuration < duration) {
            alignment = computeDurationGreatestUnit(dateIncrementDuration, dateIncrementInput);
          } else {
            alignment = unit;
          }
        } else {
          alignment = unit;
        }
      }

      start.startOf(alignment);
      end = start.clone().add(duration);
      return new UnzonedRange(start, end);
    },
    // Builds the "current" range when a dayCount is specified.
    // TODO: accept a MS-time instead of a moment `date`?
    buildRangeFromDayCount: function buildRangeFromDayCount(date, direction, dayCount) {
      var customAlignment = this.opt("dateAlignment");
      var runningCount = 0;
      var start = date.clone();
      var end;

      if (customAlignment) {
        start.startOf(customAlignment);
      }

      start.startOf("day");
      start = this.skipHiddenDays(start, direction);
      end = start.clone();

      do {
        end.add(1, "day");

        if (!this.isHiddenDay(end)) {
          runningCount++;
        }
      } while (runningCount < dayCount);

      return new UnzonedRange(start, end);
    },
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentUnzonedRange and activeUnzonedRange at the same time.
    // TODO: accept a MS-time instead of a moment `date`?
    buildCustomVisibleRange: function buildCustomVisibleRange(date) {
      var visibleUnzonedRange = this.getUnzonedRangeOption("visibleRange", this.calendar.applyTimezone(date) // correct zone. also generates new obj that avoids mutations
      );

      if (visibleUnzonedRange && (visibleUnzonedRange.startMs === null || visibleUnzonedRange.endMs === null)) {
        return null;
      }

      return visibleUnzonedRange;
    },
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    buildRenderRange: function buildRenderRange(currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
      return currentUnzonedRange.clone();
    },
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    buildDateIncrement: function buildDateIncrement(fallback) {
      var dateIncrementInput = this.opt("dateIncrement");
      var customAlignment;

      if (dateIncrementInput) {
        return moment.duration(dateIncrementInput);
      } else if (customAlignment = this.opt("dateAlignment")) {
        return moment.duration(1, customAlignment);
      } else if (fallback) {
        return fallback;
      } else {
        return moment.duration({
          days: 1
        });
      }
    },
    // Remove days from the beginning and end of the range that are computed as hidden.
    trimHiddenDays: function trimHiddenDays(inputUnzonedRange) {
      var start = inputUnzonedRange.getStart();
      var end = inputUnzonedRange.getEnd();

      if (start) {
        start = this.skipHiddenDays(start);
      }

      if (end) {
        end = this.skipHiddenDays(end, -1, true);
      }

      return new UnzonedRange(start, end);
    },
    // For DateComponent::getDayClasses
    isDateInOtherMonth: function isDateInOtherMonth(date, dateProfile) {
      return false;
    },
    // Arguments after name will be forwarded to a hypothetical function value
    // WARNING: passed-in arguments will be given to generator functions as-is and can cause side-effects.
    // Always clone your objects if you fear mutation.
    getUnzonedRangeOption: function getUnzonedRangeOption(name) {
      var val = this.opt(name);

      if (typeof val === "function") {
        val = val.apply(null, Array.prototype.slice.call(arguments, 1));
      }

      if (val) {
        return this.calendar.parseUnzonedRange(val);
      }
    },

    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/
    // Initializes internal variables related to calculating hidden days-of-week
    initHiddenDays: function initHiddenDays() {
      var hiddenDays = this.opt("hiddenDays") || []; // array of day-of-week indices that are hidden

      var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)

      var dayCnt = 0;
      var i;

      if (this.opt("weekends") === false) {
        hiddenDays.push(0, 6); // 0=sunday, 6=saturday
      }

      for (i = 0; i < 7; i++) {
        if (!(isHiddenDayHash[i] = $.inArray(i, hiddenDays) !== -1)) {
          dayCnt++;
        }
      }

      if (!dayCnt) {
        throw "invalid hiddenDays"; // all days were hidden? bad.
      }

      this.isHiddenDayHash = isHiddenDayHash;
    },
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Moment
    isHiddenDay: function isHiddenDay(day) {
      if (moment.isMoment(day)) {
        day = day.day();
      }

      return this.isHiddenDayHash[day];
    },
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validUnzonedRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    skipHiddenDays: function skipHiddenDays(date, inc, isExclusive) {
      var out = date.clone();
      inc = inc || 1;

      while (this.isHiddenDayHash[(out.day() + (isExclusive ? inc : 0) + 7) % 7]) {
        out.add(inc, "days");
      }

      return out;
    }
  });
  /* Toolbar with buttons and title
  ----------------------------------------------------------------------------------------------------------------------*/

  function Toolbar(calendar, toolbarOptions) {
    var t = this; // exports

    t.setToolbarOptions = setToolbarOptions;
    t.render = render;
    t.removeElement = removeElement;
    t.updateTitle = updateTitle;
    t.activateButton = activateButton;
    t.deactivateButton = deactivateButton;
    t.disableButton = disableButton;
    t.enableButton = enableButton;
    t.getViewsWithButtons = getViewsWithButtons;
    t.el = null; // mirrors local `el`
    // locals

    var el;
    var viewsWithButtons = []; // method to update toolbar-specific options, not calendar-wide options

    function setToolbarOptions(newToolbarOptions) {
      toolbarOptions = newToolbarOptions;
    } // can be called repeatedly and will rerender


    function render() {
      var sections = toolbarOptions.layout;

      if (sections) {
        if (!el) {
          el = this.el = $("<div class='fc-toolbar " + toolbarOptions.extraClasses + "'/>");
        } else {
          el.empty();
        }

        el.append(renderSection("left")).append(renderSection("right")).append(renderSection("center")).append('<div class="fc-clear"/>');
      } else {
        removeElement();
      }
    }

    function removeElement() {
      if (el) {
        el.remove();
        el = t.el = null;
      }
    }

    function renderSection(position) {
      var theme = calendar.theme;
      var sectionEl = $('<div class="fc-' + position + '"/>');
      var buttonStr = toolbarOptions.layout[position];
      var calendarCustomButtons = calendar.opt("customButtons") || {};
      var calendarButtonTextOverrides = calendar.overrides.buttonText || {};
      var calendarButtonText = calendar.opt("buttonText") || {};

      if (buttonStr) {
        $.each(buttonStr.split(" "), function (i) {
          var groupChildren = $();
          var isOnlyButtons = true;
          var groupEl;
          $.each(this.split(","), function (j, buttonName) {
            var customButtonProps;
            var viewSpec;
            var buttonClick;
            var buttonIcon; // only one of these will be set

            var buttonText; // "

            var buttonInnerHtml;
            var buttonClasses;
            var buttonEl;

            if (buttonName == "title") {
              groupChildren = groupChildren.add($("<h2>&nbsp;</h2>")); // we always want it to take up height

              isOnlyButtons = false;
            } else {
              if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = function buttonClick(ev) {
                  if (customButtonProps.click) {
                    customButtonProps.click.call(buttonEl[0], ev);
                  }
                };

                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName)) || (buttonText = customButtonProps.text); // jshint ignore:line
              } else if (viewSpec = calendar.getViewSpec(buttonName)) {
                viewsWithButtons.push(buttonName);

                buttonClick = function buttonClick() {
                  calendar.changeView(buttonName);
                };

                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName)) || (buttonText = viewSpec.buttonTextDefault); // jshint ignore:line
              } else if (calendar[buttonName]) {
                // a calendar method
                buttonClick = function buttonClick() {
                  calendar[buttonName]();
                };

                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName)) || (buttonText = calendarButtonText[buttonName]); // jshint ignore:line
                //            ^ everything else is considered default
              }

              if (buttonClick) {
                buttonClasses = ["fc-" + buttonName + "-button", theme.getClass("button"), theme.getClass("stateDefault")];

                if (buttonText) {
                  buttonInnerHtml = htmlEscape(buttonText);
                } else if (buttonIcon) {
                  buttonInnerHtml = "<span class='" + buttonIcon + "'></span>";
                }

                buttonEl = $( // type="button" so that it doesn't submit a form
                '<button type="button" class="' + buttonClasses.join(" ") + '">' + buttonInnerHtml + "</button>").click(function (ev) {
                  // don't process clicks for disabled buttons
                  if (!buttonEl.hasClass(theme.getClass("stateDisabled"))) {
                    buttonClick(ev); // after the click action, if the button becomes the "active" tab, or disabled,
                    // it should never have a hover class, so remove it now.

                    if (buttonEl.hasClass(theme.getClass("stateActive")) || buttonEl.hasClass(theme.getClass("stateDisabled"))) {
                      buttonEl.removeClass(theme.getClass("stateHover"));
                    }
                  }
                }).mousedown(function () {
                  // the *down* effect (mouse pressed in).
                  // only on buttons that are not the "active" tab, or disabled
                  buttonEl.not("." + theme.getClass("stateActive")).not("." + theme.getClass("stateDisabled")).addClass(theme.getClass("stateDown"));
                }).mouseup(function () {
                  // undo the *down* effect
                  buttonEl.removeClass(theme.getClass("stateDown"));
                }).hover(function () {
                  // the *hover* effect.
                  // only on buttons that are not the "active" tab, or disabled
                  buttonEl.not("." + theme.getClass("stateActive")).not("." + theme.getClass("stateDisabled")).addClass(theme.getClass("stateHover"));
                }, function () {
                  // undo the *hover* effect
                  buttonEl.removeClass(theme.getClass("stateHover")).removeClass(theme.getClass("stateDown")); // if mouseleave happens before mouseup
                });
                groupChildren = groupChildren.add(buttonEl);
              }
            }
          });

          if (isOnlyButtons) {
            groupChildren.first().addClass(theme.getClass("cornerLeft")).end().last().addClass(theme.getClass("cornerRight")).end();
          }

          if (groupChildren.length > 1) {
            groupEl = $("<div/>");

            if (isOnlyButtons) {
              groupEl.addClass(theme.getClass("buttonGroup"));
            }

            groupEl.append(groupChildren);
            sectionEl.append(groupEl);
          } else {
            sectionEl.append(groupChildren); // 1 or 0 children
          }
        });
      }

      return sectionEl;
    }

    function updateTitle(text) {
      if (el) {
        el.find("h2").text(text);
      }
    }

    function activateButton(buttonName) {
      if (el) {
        el.find(".fc-" + buttonName + "-button").addClass(calendar.theme.getClass("stateActive"));
      }
    }

    function deactivateButton(buttonName) {
      if (el) {
        el.find(".fc-" + buttonName + "-button").removeClass(calendar.theme.getClass("stateActive"));
      }
    }

    function disableButton(buttonName) {
      if (el) {
        el.find(".fc-" + buttonName + "-button").addClass(calendar.theme.getClass("stateDisabled"));
      }
    }

    function enableButton(buttonName) {
      if (el) {
        el.find(".fc-" + buttonName + "-button").prop("disabled", false).removeClass(calendar.theme.getClass("stateDisabled"));
      }
    }

    function getViewsWithButtons() {
      return viewsWithButtons;
    }
  }

  var Calendar = FC.Calendar = Class.extend(EmitterMixin, ListenerMixin, {
    view: null,
    // current View object
    viewsByType: null,
    // holds all instantiated view instances, current or not
    currentDate: null,
    // unzoned moment. private (public API should use getDate instead)
    theme: null,
    businessHourGenerator: null,
    loadingLevel: 0,
    // number of simultaneous loading tasks
    constructor: function constructor(el, overrides) {
      // declare the current calendar instance relies on GlobalEmitter. needed for garbage collection.
      // unneeded() is called in destroy.
      GlobalEmitter.needed();
      this.el = el;
      this.viewsByType = {};
      this.viewSpecCache = {};
      this.initOptionsInternals(overrides);
      this.initMomentInternals(); // needs to happen after options hash initialized

      this.initCurrentDate();
      this.initEventManager();
      this.constructed();
    },
    // useful for monkeypatching. TODO: BaseClass?
    constructed: function constructed() {},
    // Public API
    // -----------------------------------------------------------------------------------------------------------------
    getView: function getView() {
      return this.view;
    },
    publiclyTrigger: function publiclyTrigger(name, triggerInfo) {
      var optHandler = this.opt(name);
      var context;
      var args;

      if ($.isPlainObject(triggerInfo)) {
        context = triggerInfo.context;
        args = triggerInfo.args;
      } else if ($.isArray(triggerInfo)) {
        args = triggerInfo;
      }

      if (context == null) {
        context = this.el[0]; // fallback context
      }

      if (!args) {
        args = [];
      }

      this.triggerWith(name, context, args); // Emitter's method

      if (optHandler) {
        return optHandler.apply(context, args);
      }
    },
    hasPublicHandlers: function hasPublicHandlers(name) {
      return this.hasHandlers(name) || this.opt(name); // handler specified in options
    },
    // View
    // -----------------------------------------------------------------------------------------------------------------
    // Given a view name for a custom view or a standard view, creates a ready-to-go View object
    instantiateView: function instantiateView(viewType) {
      var spec = this.getViewSpec(viewType);
      return new spec["class"](this, spec);
    },
    // Returns a boolean about whether the view is okay to instantiate at some point
    isValidViewType: function isValidViewType(viewType) {
      return Boolean(this.getViewSpec(viewType));
    },
    changeView: function changeView(viewName, dateOrRange) {
      if (dateOrRange) {
        if (dateOrRange.start && dateOrRange.end) {
          // a range
          this.recordOptionOverrides({
            // will not rerender
            visibleRange: dateOrRange
          });
        } else {
          // a date
          this.currentDate = this.moment(dateOrRange).stripZone(); // just like gotoDate
        }
      }

      this.renderView(viewName);
    },
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    zoomTo: function zoomTo(newDate, viewType) {
      var spec;
      viewType = viewType || "day"; // day is default zoom

      spec = this.getViewSpec(viewType) || this.getUnitViewSpec(viewType);
      this.currentDate = newDate.clone();
      this.renderView(spec ? spec.type : null);
    },
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    initCurrentDate: function initCurrentDate() {
      var defaultDateInput = this.opt("defaultDate"); // compute the initial ambig-timezone date

      if (defaultDateInput != null) {
        this.currentDate = this.moment(defaultDateInput).stripZone();
      } else {
        this.currentDate = this.getNow(); // getNow already returns unzoned
      }
    },
    prev: function prev() {
      var prevInfo = this.view.buildPrevDateProfile(this.currentDate);

      if (prevInfo.isValid) {
        this.currentDate = prevInfo.date;
        this.renderView();
      }
    },
    next: function next() {
      var nextInfo = this.view.buildNextDateProfile(this.currentDate);

      if (nextInfo.isValid) {
        this.currentDate = nextInfo.date;
        this.renderView();
      }
    },
    prevYear: function prevYear() {
      this.currentDate.add(-1, "years");
      this.renderView();
    },
    nextYear: function nextYear() {
      this.currentDate.add(1, "years");
      this.renderView();
    },
    today: function today() {
      this.currentDate = this.getNow(); // should deny like prev/next?

      this.renderView();
    },
    holiday: function holiday() {
      this.currentDate = this.getNow();
      this.renderView();
    },
    gotoDate: function gotoDate(zonedDateInput) {
      this.currentDate = this.moment(zonedDateInput).stripZone();
      this.renderView();
    },
    incrementDate: function incrementDate(delta) {
      this.currentDate.add(moment.duration(delta));
      this.renderView();
    },
    // for external API
    getDate: function getDate() {
      return this.applyTimezone(this.currentDate); // infuse the calendar's timezone
    },
    // Loading Triggering
    // -----------------------------------------------------------------------------------------------------------------
    // Should be called when any type of async data fetching begins
    pushLoading: function pushLoading() {
      if (!this.loadingLevel++) {
        this.publiclyTrigger("loading", [true, this.view]);
      }
    },
    // Should be called when any type of async data fetching completes
    popLoading: function popLoading() {
      if (! --this.loadingLevel) {
        this.publiclyTrigger("loading", [false, this.view]);
      }
    },
    // Selection
    // -----------------------------------------------------------------------------------------------------------------
    // this public method receives start/end dates in any format, with any timezone
    select: function select(zonedStartInput, zonedEndInput) {
      this.view.select(this.buildSelectFootprint.apply(this, arguments));
    },
    unselect: function unselect() {
      // safe to be called before renderView
      if (this.view) {
        this.view.unselect();
      }
    },
    // Given arguments to the select method in the API, returns a span (unzoned start/end and other info)
    buildSelectFootprint: function buildSelectFootprint(zonedStartInput, zonedEndInput) {
      var start = this.moment(zonedStartInput).stripZone();
      var end;

      if (zonedEndInput) {
        end = this.moment(zonedEndInput).stripZone();
      } else if (start.hasTime()) {
        end = start.clone().add(this.defaultTimedEventDuration);
      } else {
        end = start.clone().add(this.defaultAllDayEventDuration);
      }

      return new ComponentFootprint(new UnzonedRange(start, end), !start.hasTime());
    },
    // Misc
    // -----------------------------------------------------------------------------------------------------------------
    // will return `null` if invalid range
    parseUnzonedRange: function parseUnzonedRange(rangeInput) {
      var start = null;
      var end = null;

      if (rangeInput.start) {
        start = this.moment(rangeInput.start).stripZone();
      }

      if (rangeInput.end) {
        end = this.moment(rangeInput.end).stripZone();
      }

      if (!start && !end) {
        return null;
      }

      if (start && end && end.isBefore(start)) {
        return null;
      }

      return new UnzonedRange(start, end);
    },
    rerenderEvents: function rerenderEvents() {
      // API method. destroys old events if previously rendered.
      this.view.flash("displayingEvents");
    },
    initEventManager: function initEventManager() {
      var _this = this;

      var eventManager = new EventManager(this);
      var rawSources = this.opt("eventSources") || [];
      var singleRawSource = this.opt("events");
      this.eventManager = eventManager;

      if (singleRawSource) {
        rawSources.unshift(singleRawSource);
      }

      eventManager.on("release", function (eventsPayload) {
        _this.trigger("eventsReset", eventsPayload);
      });
      eventManager.freeze();
      rawSources.forEach(function (rawSource) {
        var source = EventSourceParser.parse(rawSource, _this);

        if (source) {
          eventManager.addSource(source);
        }
      });
      eventManager.thaw();
    },
    requestEvents: function requestEvents(start, end) {
      return this.eventManager.requestEvents(start, end, this.opt("timezone"), !this.opt("lazyFetching"));
    }
  });
  /*
  Options binding/triggering system.
  */

  Calendar.mixin({
    dirDefaults: null,
    // option defaults related to LTR or RTL
    localeDefaults: null,
    // option defaults related to current locale
    overrides: null,
    // option overrides given to the fullCalendar constructor
    dynamicOverrides: null,
    // options set with dynamic setter method. higher precedence than view overrides.
    optionsModel: null,
    // all defaults combined with overrides
    initOptionsInternals: function initOptionsInternals(overrides) {
      this.overrides = $.extend({}, overrides); // make a copy

      this.dynamicOverrides = {};
      this.optionsModel = new Model();
      this.populateOptionsHash();
    },
    // public getter/setter
    option: function option(name, value) {
      var newOptionHash;

      if (typeof name === "string") {
        if (value === undefined) {
          // getter
          return this.optionsModel.get(name);
        } else {
          // setter for individual option
          newOptionHash = {};
          newOptionHash[name] = value;
          this.setOptions(newOptionHash);
        }
      } else if (_typeof(name) === "object") {
        // compound setter with object input
        this.setOptions(name);
      }
    },
    // private getter
    opt: function opt(name) {
      return this.optionsModel.get(name);
    },
    setOptions: function setOptions(newOptionHash) {
      var optionCnt = 0;
      var optionName;
      this.recordOptionOverrides(newOptionHash); // will trigger optionsModel watchers

      for (optionName in newOptionHash) {
        optionCnt++;
      } // special-case handling of single option change.
      // if only one option change, `optionName` will be its name.


      if (optionCnt === 1) {
        if (optionName === "height" || optionName === "contentHeight" || optionName === "aspectRatio") {
          this.updateViewSize(true); // isResize=true

          return;
        } else if (optionName === "defaultDate") {
          return; // can't change date this way. use gotoDate instead
        } else if (optionName === "businessHours") {
          return; // optionsModel already reacts to this
        } else if (optionName === "timezone") {
          this.view.flash("initialEvents");
          return;
        }
      } // catch-all. rerender the header and footer and rebuild/rerender the current view


      this.renderHeader();
      this.renderFooter(); // even non-current views will be affected by this option change. do before rerender
      // TODO: detangle

      this.viewsByType = {};
      this.reinitView();
    },
    // Computes the flattened options hash for the calendar and assigns to `this.options`.
    // Assumes this.overrides and this.dynamicOverrides have already been initialized.
    populateOptionsHash: function populateOptionsHash() {
      var locale, localeDefaults;
      var isRTL, dirDefaults;
      var rawOptions;
      locale = firstDefined( // explicit locale option given?
      this.dynamicOverrides.locale, this.overrides.locale);
      localeDefaults = localeOptionHash[locale];

      if (!localeDefaults) {
        // explicit locale option not given or invalid?
        locale = Calendar.defaults.locale;
        localeDefaults = localeOptionHash[locale] || {};
      }

      isRTL = firstDefined( // based on options computed so far, is direction RTL?
      this.dynamicOverrides.isRTL, this.overrides.isRTL, localeDefaults.isRTL, Calendar.defaults.isRTL);
      dirDefaults = isRTL ? Calendar.rtlDefaults : {};
      this.dirDefaults = dirDefaults;
      this.localeDefaults = localeDefaults;
      rawOptions = mergeOptions([// merge defaults and overrides. lowest to highest precedence
      Calendar.defaults, // global defaults
      dirDefaults, localeDefaults, this.overrides, this.dynamicOverrides]);
      populateInstanceComputableOptions(rawOptions); // fill in gaps with computed options

      this.optionsModel.reset(rawOptions);
    },
    // stores the new options internally, but does not rerender anything.
    recordOptionOverrides: function recordOptionOverrides(newOptionHash) {
      var optionName;

      for (optionName in newOptionHash) {
        this.dynamicOverrides[optionName] = newOptionHash[optionName];
      }

      this.viewSpecCache = {}; // the dynamic override invalidates the options in this cache, so just clear it

      this.populateOptionsHash(); // this.options needs to be recomputed after the dynamic override
    }
  });
  Calendar.mixin({
    defaultAllDayEventDuration: null,
    defaultTimedEventDuration: null,
    localeData: null,
    initMomentInternals: function initMomentInternals() {
      var _this = this;

      this.defaultAllDayEventDuration = moment.duration(this.opt("defaultAllDayEventDuration"));
      this.defaultTimedEventDuration = moment.duration(this.opt("defaultTimedEventDuration")); // Called immediately, and when any of the options change.
      // Happens before any internal objects rebuild or rerender, because this is very core.

      this.optionsModel.watch("buildingMomentLocale", ["?locale", "?monthNames", "?monthNamesShort", "?dayNames", "?dayNamesShort", "?firstDay", "?weekNumberCalculation"], function (opts) {
        var weekNumberCalculation = opts.weekNumberCalculation;
        var firstDay = opts.firstDay;

        var _week; // normalize


        if (weekNumberCalculation === "iso") {
          weekNumberCalculation = "ISO"; // normalize
        }

        var localeData = Object.create( // make a cheap copy
        getMomentLocaleData(opts.locale) // will fall back to en
        );

        if (opts.monthNames) {
          localeData._months = opts.monthNames;
        }

        if (opts.monthNamesShort) {
          localeData._monthsShort = opts.monthNamesShort;
        }

        if (opts.dayNames) {
          localeData._weekdays = opts.dayNames;
        }

        if (opts.dayNamesShort) {
          localeData._weekdaysShort = opts.dayNamesShort;
        }

        if (firstDay == null && weekNumberCalculation === "ISO") {
          firstDay = 1;
        }

        if (firstDay != null) {
          _week = Object.create(localeData._week); // _week: { dow: # }

          _week.dow = firstDay;
          localeData._week = _week;
        }

        if ( // whitelist certain kinds of input
        weekNumberCalculation === "ISO" || weekNumberCalculation === "local" || typeof weekNumberCalculation === "function") {
          localeData._fullCalendar_weekCalc = weekNumberCalculation; // moment-ext will know what to do with it
        }

        _this.localeData = localeData; // If the internal current date object already exists, move to new locale.
        // We do NOT need to do this technique for event dates, because this happens when converting to "segments".

        if (_this.currentDate) {
          _this.localizeMoment(_this.currentDate); // sets to localeData

        }
      });
    },
    // Builds a moment using the settings of the current calendar: timezone and locale.
    // Accepts anything the vanilla moment() constructor accepts.
    moment: function moment() {
      var mom;

      if (this.opt("timezone") === "local") {
        mom = FC.moment.apply(null, arguments); // Force the moment to be local, because FC.moment doesn't guarantee it.

        if (mom.hasTime()) {
          // don't give ambiguously-timed moments a local zone
          mom.local();
        }
      } else if (this.opt("timezone") === "UTC") {
        mom = FC.moment.utc.apply(null, arguments); // process as UTC
      } else {
        mom = FC.moment.parseZone.apply(null, arguments); // let the input decide the zone
      }

      this.localizeMoment(mom); // TODO

      return mom;
    },
    msToMoment: function msToMoment(ms, forceAllDay) {
      var mom = FC.moment.utc(ms); // TODO: optimize by using Date.UTC

      if (forceAllDay) {
        mom.stripTime();
      } else {
        mom = this.applyTimezone(mom); // may or may not apply locale
      }

      this.localizeMoment(mom);
      return mom;
    },
    msToUtcMoment: function msToUtcMoment(ms, forceAllDay) {
      var mom = FC.moment.utc(ms); // TODO: optimize by using Date.UTC

      if (forceAllDay) {
        mom.stripTime();
      }

      this.localizeMoment(mom);
      return mom;
    },
    // Updates the given moment's locale settings to the current calendar locale settings.
    localizeMoment: function localizeMoment(mom) {
      mom._locale = this.localeData;
    },
    // Returns a boolean about whether or not the calendar knows how to calculate
    // the timezone offset of arbitrary dates in the current timezone.
    getIsAmbigTimezone: function getIsAmbigTimezone() {
      return this.opt("timezone") !== "local" && this.opt("timezone") !== "UTC";
    },
    // Returns a copy of the given date in the current timezone. Has no effect on dates without times.
    applyTimezone: function applyTimezone(date) {
      if (!date.hasTime()) {
        return date.clone();
      }

      var zonedDate = this.moment(date.toArray());
      var timeAdjust = date.time() - zonedDate.time();
      var adjustedZonedDate; // Safari sometimes has problems with this coersion when near DST. Adjust if necessary. (bug #2396)

      if (timeAdjust) {
        // is the time result different than expected?
        adjustedZonedDate = zonedDate.clone().add(timeAdjust); // add milliseconds

        if (date.time() - adjustedZonedDate.time() === 0) {
          // does it match perfectly now?
          zonedDate = adjustedZonedDate;
        }
      }

      return zonedDate;
    },

    /*
    Assumes the footprint is non-open-ended.
    */
    footprintToDateProfile: function footprintToDateProfile(componentFootprint, ignoreEnd) {
      var start = FC.moment.utc(componentFootprint.unzonedRange.startMs);
      var end;

      if (!ignoreEnd) {
        end = FC.moment.utc(componentFootprint.unzonedRange.endMs);
      }

      if (componentFootprint.isAllDay) {
        start.stripTime();

        if (end) {
          end.stripTime();
        }
      } else {
        start = this.applyTimezone(start);

        if (end) {
          end = this.applyTimezone(end);
        }
      }

      return new EventDateProfile(start, end, this);
    },
    // Returns a moment for the current date, as defined by the client's computer or from the `now` option.
    // Will return an moment with an ambiguous timezone.
    getNow: function getNow() {
      var now = this.opt("now");

      if (typeof now === "function") {
        now = now();
      }

      return this.moment(now).stripZone();
    },
    // Produces a human-readable string for the given duration.
    // Side-effect: changes the locale of the given duration.
    humanizeDuration: function humanizeDuration(duration) {
      return duration.locale(this.opt("locale")).humanize();
    },
    // Event-Specific Date Utilities. TODO: move
    // -----------------------------------------------------------------------------------------------------------------
    // Get an event's normalized end date. If not present, calculate it from the defaults.
    getEventEnd: function getEventEnd(event) {
      if (event.end) {
        return event.end.clone();
      } else {
        return this.getDefaultEventEnd(event.allDay, event.start);
      }
    },
    // Given an event's allDay status and start date, return what its fallback end date should be.
    // TODO: rename to computeDefaultEventEnd
    getDefaultEventEnd: function getDefaultEventEnd(allDay, zonedStart) {
      var end = zonedStart.clone();

      if (allDay) {
        end.stripTime().add(this.defaultAllDayEventDuration);
      } else {
        end.add(this.defaultTimedEventDuration);
      }

      if (this.getIsAmbigTimezone()) {
        end.stripZone(); // we don't know what the tzo should be
      }

      return end;
    }
  });
  Calendar.mixin({
    viewSpecCache: null,
    // cache of view definitions (initialized in Calendar.js)
    // Gets information about how to create a view. Will use a cache.
    getViewSpec: function getViewSpec(viewType) {
      var cache = this.viewSpecCache;
      return cache[viewType] || (cache[viewType] = this.buildViewSpec(viewType));
    },
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    getUnitViewSpec: function getUnitViewSpec(unit) {
      var viewTypes;
      var i;
      var spec;

      if ($.inArray(unit, unitsDesc) != -1) {
        // put views that have buttons first. there will be duplicates, but oh well
        viewTypes = this.header.getViewsWithButtons(); // TODO: include footer as well?

        $.each(FC.views, function (viewType) {
          // all views
          viewTypes.push(viewType);
        });

        for (i = 0; i < viewTypes.length; i++) {
          spec = this.getViewSpec(viewTypes[i]);

          if (spec) {
            if (spec.singleUnit == unit) {
              return spec;
            }
          }
        }
      }
    },
    // Builds an object with information on how to create a given view
    buildViewSpec: function buildViewSpec(requestedViewType) {
      var viewOverrides = this.overrides.views || {};
      var specChain = []; // for the view. lowest to highest priority

      var defaultsChain = []; // for the view. lowest to highest priority

      var overridesChain = []; // for the view. lowest to highest priority

      var viewType = requestedViewType;
      var spec; // for the view

      var overrides; // for the view

      var durationInput;
      var duration;
      var unit; // iterate from the specific view definition to a more general one until we hit an actual View class

      while (viewType) {
        spec = fcViews[viewType];
        overrides = viewOverrides[viewType];
        viewType = null; // clear. might repopulate for another iteration

        if (typeof spec === "function") {
          // TODO: deprecate
          spec = {
            "class": spec
          };
        }

        if (spec) {
          specChain.unshift(spec);
          defaultsChain.unshift(spec.defaults || {});
          durationInput = durationInput || spec.duration;
          viewType = viewType || spec.type;
        }

        if (overrides) {
          overridesChain.unshift(overrides); // view-specific option hashes have options at zero-level

          durationInput = durationInput || overrides.duration;
          viewType = viewType || overrides.type;
        }
      }

      spec = mergeProps(specChain);
      spec.type = requestedViewType;

      if (!spec["class"]) {
        return false;
      } // fall back to top-level `duration` option


      durationInput = durationInput || this.dynamicOverrides.duration || this.overrides.duration;

      if (durationInput) {
        duration = moment.duration(durationInput);

        if (duration.valueOf()) {
          // valid?
          unit = computeDurationGreatestUnit(duration, durationInput);
          spec.duration = duration;
          spec.durationUnit = unit; // view is a single-unit duration, like "week" or "day"
          // incorporate options for this. lowest priority

          if (duration.as(unit) === 1) {
            spec.singleUnit = unit;
            overridesChain.unshift(viewOverrides[unit] || {});
          }
        }
      }

      spec.defaults = mergeOptions(defaultsChain);
      spec.overrides = mergeOptions(overridesChain);
      this.buildViewSpecOptions(spec);
      this.buildViewSpecButtonText(spec, requestedViewType);
      return spec;
    },
    // Builds and assigns a view spec's options object from its already-assigned defaults and overrides
    buildViewSpecOptions: function buildViewSpecOptions(spec) {
      spec.options = mergeOptions([// lowest to highest priority
      Calendar.defaults, // global defaults
      spec.defaults, // view's defaults (from ViewSubclass.defaults)
      this.dirDefaults, this.localeDefaults, // locale and dir take precedence over view's defaults!
      this.overrides, // calendar's overrides (options given to constructor)
      spec.overrides, // view's overrides (view-specific options)
      this.dynamicOverrides // dynamically set via setter. highest precedence
      ]);
      populateInstanceComputableOptions(spec.options);
    },
    // Computes and assigns a view spec's buttonText-related options
    buildViewSpecButtonText: function buildViewSpecButtonText(spec, requestedViewType) {
      // given an options object with a possible `buttonText` hash, lookup the buttonText for the
      // requested view, falling back to a generic unit entry like "week" or "day"
      function queryButtonText(options) {
        var buttonText = options.buttonText || {};
        return buttonText[requestedViewType] || ( // view can decide to look up a certain key
        spec.buttonTextKey ? buttonText[spec.buttonTextKey] : null) || ( // a key like "month"
        spec.singleUnit ? buttonText[spec.singleUnit] : null);
      } // highest to lowest priority


      spec.buttonTextOverride = queryButtonText(this.dynamicOverrides) || queryButtonText(this.overrides) || // constructor-specified buttonText lookup hash takes precedence
      spec.overrides.buttonText; // `buttonText` for view-specific options is a string
      // highest to lowest priority. mirrors buildViewSpecOptions

      spec.buttonTextDefault = queryButtonText(this.localeDefaults) || queryButtonText(this.dirDefaults) || spec.defaults.buttonText || // a single string. from ViewSubclass.defaults
      queryButtonText(Calendar.defaults) || (spec.duration ? this.humanizeDuration(spec.duration) : null) || // like "3 days"
      requestedViewType; // fall back to given view name
    }
  });
  Calendar.mixin({
    el: null,
    contentEl: null,
    suggestedViewHeight: null,
    ignoreUpdateViewSize: 0,
    freezeContentHeightDepth: 0,
    windowResizeProxy: null,
    render: function render() {
      if (!this.contentEl) {
        this.initialRender();
      } else if (this.elementVisible()) {
        // mainly for the public API
        this.calcSize();
        this.renderView();
      }
    },
    initialRender: function initialRender() {
      var _this = this;

      var el = this.el;
      el.addClass("fc"); // event delegation for nav links

      el.on("click.fc", "a[data-goto]", function (ev) {
        var anchorEl = $(this);
        var gotoOptions = anchorEl.data("goto"); // will automatically parse JSON

        var date = _this.moment(gotoOptions.date);

        var viewType = gotoOptions.type; // property like "navLinkDayClick". might be a string or a function

        var customAction = _this.view.opt("navLink" + capitaliseFirstLetter(viewType) + "Click");

        if (typeof customAction === "function") {
          customAction(date, ev);
        } else {
          if (typeof customAction === "string") {
            viewType = customAction;
          }

          _this.zoomTo(date, viewType);
        }
      }); // called immediately, and upon option change

      this.optionsModel.watch("settingTheme", ["?theme", "?themeSystem"], function (opts) {
        var themeClass = ThemeRegistry.getThemeClass(opts.themeSystem || opts.theme);
        var theme = new themeClass(_this.optionsModel);
        var widgetClass = theme.getClass("widget");
        _this.theme = theme;

        if (widgetClass) {
          el.addClass(widgetClass);
        }
      }, function () {
        var widgetClass = _this.theme.getClass("widget");

        _this.theme = null;

        if (widgetClass) {
          el.removeClass(widgetClass);
        }
      });
      this.optionsModel.watch("settingBusinessHourGenerator", ["?businessHours"], function (deps) {
        _this.businessHourGenerator = new BusinessHourGenerator(deps.businessHours, _this);

        if (_this.view) {
          _this.view.set("businessHourGenerator", _this.businessHourGenerator);
        }
      }, function () {
        _this.businessHourGenerator = null;
      }); // called immediately, and upon option change.
      // HACK: locale often affects isRTL, so we explicitly listen to that too.

      this.optionsModel.watch("applyingDirClasses", ["?isRTL", "?locale"], function (opts) {
        el.toggleClass("fc-ltr", !opts.isRTL);
        el.toggleClass("fc-rtl", opts.isRTL);
      });
      this.contentEl = $("<div class='fc-view-container'/>").prependTo(el);
      this.initToolbars();
      this.renderHeader();
      this.renderFooter();
      this.renderView(this.opt("defaultView"));

      if (this.opt("handleWindowResize")) {
        $(window).resize(this.windowResizeProxy = debounce( // prevents rapid calls
        this.windowResize.bind(this), this.opt("windowResizeDelay")));
      }
    },
    destroy: function destroy() {
      if (this.view) {
        this.clearView();
      }

      this.toolbarsManager.proxyCall("removeElement");
      this.contentEl.remove();
      this.el.removeClass("fc fc-ltr fc-rtl"); // removes theme-related root className

      this.optionsModel.unwatch("settingTheme");
      this.optionsModel.unwatch("settingBusinessHourGenerator");
      this.el.off(".fc"); // unbind nav link handlers

      if (this.windowResizeProxy) {
        $(window).unbind("resize", this.windowResizeProxy);
        this.windowResizeProxy = null;
      }

      GlobalEmitter.unneeded();
    },
    elementVisible: function elementVisible() {
      return this.el.is(":visible");
    },
    // Render Queue
    // -----------------------------------------------------------------------------------------------------------------
    bindViewHandlers: function bindViewHandlers(view) {
      var _this = this;

      view.watch("titleForCalendar", ["title"], function (deps) {
        // TODO: better system
        if (view === _this.view) {
          // hack
          _this.setToolbarsTitle(deps.title);
        }
      });
      view.watch("dateProfileForCalendar", ["dateProfile"], function (deps) {
        if (view === _this.view) {
          // hack
          _this.currentDate = deps.dateProfile.date; // might have been constrained by view dates

          _this.updateToolbarButtons(deps.dateProfile);
        }
      });
    },
    unbindViewHandlers: function unbindViewHandlers(view) {
      view.unwatch("titleForCalendar");
      view.unwatch("dateProfileForCalendar");
    },
    // View Rendering
    // -----------------------------------------------------------------------------------
    // Renders a view because of a date change, view-type change, or for the first time.
    // If not given a viewType, keep the current view but render different dates.
    // Accepts an optional scroll state to restore to.
    renderView: function renderView(viewType) {
      var oldView = this.view;
      var newView;
      this.freezeContentHeight();

      if (oldView && viewType && oldView.type !== viewType) {
        this.clearView();
      } // if viewType changed, or the view was never created, create a fresh view


      if (!this.view && viewType) {
        newView = this.view = this.viewsByType[viewType] || (this.viewsByType[viewType] = this.instantiateView(viewType));
        this.bindViewHandlers(newView);
        newView.setElement($("<div class='fc-view fc-" + viewType + "-view' />").appendTo(this.contentEl));
        this.toolbarsManager.proxyCall("activateButton", viewType);
      }

      if (this.view) {
        // prevent unnecessary change firing
        if (this.view.get("businessHourGenerator") !== this.businessHourGenerator) {
          this.view.set("businessHourGenerator", this.businessHourGenerator);
        }

        this.view.setDate(this.currentDate);
      }

      this.thawContentHeight();
    },
    // Unrenders the current view and reflects this change in the Header.
    // Unregsiters the `view`, but does not remove from viewByType hash.
    clearView: function clearView() {
      var currentView = this.view;
      this.toolbarsManager.proxyCall("deactivateButton", currentView.type);
      this.unbindViewHandlers(currentView);
      currentView.removeElement();
      currentView.unsetDate(); // so bindViewHandlers doesn't fire with old values next time

      this.view = null;
    },
    // Destroys the view, including the view object. Then, re-instantiates it and renders it.
    // Maintains the same scroll state.
    // TODO: maintain any other user-manipulated state.
    reinitView: function reinitView() {
      var oldView = this.view;
      var scroll = oldView.queryScroll(); // wouldn't be so complicated if Calendar owned the scroll

      this.freezeContentHeight();
      this.clearView();
      this.calcSize();
      this.renderView(oldView.type); // needs the type to freshly render

      this.view.applyScroll(scroll);
      this.thawContentHeight();
    },
    // Resizing
    // -----------------------------------------------------------------------------------
    getSuggestedViewHeight: function getSuggestedViewHeight() {
      if (this.suggestedViewHeight === null) {
        this.calcSize();
      }

      return this.suggestedViewHeight;
    },
    isHeightAuto: function isHeightAuto() {
      return this.opt("contentHeight") === "auto" || this.opt("height") === "auto";
    },
    updateViewSize: function updateViewSize(isResize) {
      var view = this.view;
      var scroll;

      if (!this.ignoreUpdateViewSize && view) {
        if (isResize) {
          this.calcSize();
          scroll = view.queryScroll();
        }

        this.ignoreUpdateViewSize++;
        view.updateSize(this.getSuggestedViewHeight(), this.isHeightAuto(), isResize);
        this.ignoreUpdateViewSize--;

        if (isResize) {
          view.applyScroll(scroll);
        }

        return true; // signal success
      }
    },
    calcSize: function calcSize() {
      if (this.elementVisible()) {
        this._calcSize();
      }
    },
    _calcSize: function _calcSize() {
      // assumes elementVisible
      var contentHeightInput = this.opt("contentHeight");
      var heightInput = this.opt("height");

      if (typeof contentHeightInput === "number") {
        // exists and not 'auto'
        this.suggestedViewHeight = contentHeightInput;
      } else if (typeof contentHeightInput === "function") {
        // exists and is a function
        this.suggestedViewHeight = contentHeightInput();
      } else if (typeof heightInput === "number") {
        // exists and not 'auto'
        this.suggestedViewHeight = heightInput - this.queryToolbarsHeight();
      } else if (typeof heightInput === "function") {
        // exists and is a function
        this.suggestedViewHeight = heightInput() - this.queryToolbarsHeight();
      } else if (heightInput === "parent") {
        // set to height of parent element
        this.suggestedViewHeight = this.el.parent().height() - this.queryToolbarsHeight();
      } else {
        this.suggestedViewHeight = Math.round(this.contentEl.width() / Math.max(this.opt("aspectRatio"), 0.5));
      }
    },
    windowResize: function windowResize(ev) {
      if (ev.target === window && // so we don't process jqui "resize" events that have bubbled up
      this.view && this.view.isDatesRendered) {
        if (this.updateViewSize(true)) {
          // isResize=true, returns true on success
          this.publiclyTrigger("windowResize", [this.view]);
        }
      }
    },

    /* Height "Freezing"
    -----------------------------------------------------------------------------*/
    freezeContentHeight: function freezeContentHeight() {
      if (!this.freezeContentHeightDepth++) {
        this.forceFreezeContentHeight();
      }
    },
    forceFreezeContentHeight: function forceFreezeContentHeight() {
      this.contentEl.css({
        width: "100%",
        height: this.contentEl.height(),
        overflow: "hidden"
      });
    },
    thawContentHeight: function thawContentHeight() {
      this.freezeContentHeightDepth--; // always bring back to natural height

      this.contentEl.css({
        width: "",
        height: "",
        overflow: ""
      }); // but if there are future thaws, re-freeze

      if (this.freezeContentHeightDepth) {
        this.forceFreezeContentHeight();
      }
    }
  });
  Calendar.mixin({
    header: null,
    footer: null,
    toolbarsManager: null,
    initToolbars: function initToolbars() {
      this.header = new Toolbar(this, this.computeHeaderOptions());
      this.footer = new Toolbar(this, this.computeFooterOptions());
      this.toolbarsManager = new Iterator([this.header, this.footer]);
    },
    computeHeaderOptions: function computeHeaderOptions() {
      return {
        extraClasses: "fc-header-toolbar",
        layout: this.opt("header")
      };
    },
    computeFooterOptions: function computeFooterOptions() {
      return {
        extraClasses: "fc-footer-toolbar",
        layout: this.opt("footer")
      };
    },
    // can be called repeatedly and Header will rerender
    renderHeader: function renderHeader() {
      var header = this.header;
      header.setToolbarOptions(this.computeHeaderOptions());
      header.render();

      if (header.el) {
        this.el.prepend(header.el);
      }
    },
    // can be called repeatedly and Footer will rerender
    renderFooter: function renderFooter() {
      var footer = this.footer;
      footer.setToolbarOptions(this.computeFooterOptions());
      footer.render();

      if (footer.el) {
        this.el.append(footer.el);
      }
    },
    setToolbarsTitle: function setToolbarsTitle(title) {
      this.toolbarsManager.proxyCall("updateTitle", title);
    },
    updateToolbarButtons: function updateToolbarButtons(dateProfile) {
      var now = this.getNow();
      var view = this.view;
      var todayInfo = view.buildDateProfile(now);
      var holidayInfo = view.buildDateProfile(now);
      var prevInfo = view.buildPrevDateProfile(this.currentDate);
      var nextInfo = view.buildNextDateProfile(this.currentDate);
      this.toolbarsManager.proxyCall(todayInfo.isValid && !dateProfile.currentUnzonedRange.containsDate(now) ? "enableButton" : "disableButton", "today");
      this.toolbarsManager.proxyCall(holidayInfo.isValid && !dateProfile.currentUnzonedRange.containsDate(now) ? "enableButton" : "disableButton", "holiday");
      this.toolbarsManager.proxyCall(prevInfo.isValid ? "enableButton" : "disableButton", "prev");
      this.toolbarsManager.proxyCall(nextInfo.isValid ? "enableButton" : "disableButton", "next");
    },
    queryToolbarsHeight: function queryToolbarsHeight() {
      return this.toolbarsManager.items.reduce(function (accumulator, toolbar) {
        var toolbarHeight = toolbar.el ? toolbar.el.outerHeight(true) : 0; // includes margin

        return accumulator + toolbarHeight;
      }, 0);
    }
  });
  /*
  determines if eventInstanceGroup is allowed,
  in relation to other EVENTS and business hours.
  */

  Calendar.prototype.isEventInstanceGroupAllowed = function (eventInstanceGroup) {
    var eventDef = eventInstanceGroup.getEventDef();
    var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
    var i;
    var peerEventInstances = this.getPeerEventInstances(eventDef);
    var peerEventRanges = peerEventInstances.map(eventInstanceToEventRange);
    var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
    var constraintVal = eventDef.getConstraint();
    var overlapVal = eventDef.getOverlap();
    var eventAllowFunc = this.opt("eventAllow");

    for (i = 0; i < eventFootprints.length; i++) {
      if (!this.isFootprintAllowed(eventFootprints[i].componentFootprint, peerEventFootprints, constraintVal, overlapVal, eventFootprints[i].eventInstance)) {
        return false;
      }
    }

    if (eventAllowFunc) {
      for (i = 0; i < eventFootprints.length; i++) {
        if (eventAllowFunc(eventFootprints[i].componentFootprint.toLegacy(this), eventFootprints[i].getEventLegacy()) === false) {
          return false;
        }
      }
    }

    return true;
  };

  Calendar.prototype.getPeerEventInstances = function (eventDef) {
    return this.eventManager.getEventInstancesWithoutId(eventDef.id);
  };

  Calendar.prototype.isSelectionFootprintAllowed = function (componentFootprint) {
    var peerEventInstances = this.eventManager.getEventInstances();
    var peerEventRanges = peerEventInstances.map(eventInstanceToEventRange);
    var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
    var selectAllowFunc;

    if (this.isFootprintAllowed(componentFootprint, peerEventFootprints, this.opt("selectConstraint"), this.opt("selectOverlap"))) {
      selectAllowFunc = this.opt("selectAllow");

      if (selectAllowFunc) {
        return selectAllowFunc(componentFootprint.toLegacy(this)) !== false;
      } else {
        return true;
      }
    }

    return false;
  };

  Calendar.prototype.isFootprintAllowed = function (componentFootprint, peerEventFootprints, constraintVal, overlapVal, subjectEventInstance // optional
  ) {
    var constraintFootprints; // ComponentFootprint[]

    var overlapEventFootprints; // EventFootprint[]

    if (constraintVal != null) {
      constraintFootprints = this.constraintValToFootprints(constraintVal, componentFootprint.isAllDay);

      if (!this.isFootprintWithinConstraints(componentFootprint, constraintFootprints)) {
        return false;
      }
    }

    overlapEventFootprints = this.collectOverlapEventFootprints(peerEventFootprints, componentFootprint);

    if (overlapVal === false) {
      if (overlapEventFootprints.length) {
        return false;
      }
    } else if (typeof overlapVal === "function") {
      if (!isOverlapsAllowedByFunc(overlapEventFootprints, overlapVal, subjectEventInstance)) {
        return false;
      }
    }

    if (subjectEventInstance) {
      if (!isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance)) {
        return false;
      }
    }

    return true;
  }; // Constraint
  // ------------------------------------------------------------------------------------------------


  Calendar.prototype.isFootprintWithinConstraints = function (componentFootprint, constraintFootprints) {
    var i;

    for (i = 0; i < constraintFootprints.length; i++) {
      if (this.footprintContainsFootprint(constraintFootprints[i], componentFootprint)) {
        return true;
      }
    }

    return false;
  };

  Calendar.prototype.constraintValToFootprints = function (constraintVal, isAllDay) {
    var eventInstances;

    if (constraintVal === "businessHours") {
      return this.buildCurrentBusinessFootprints(isAllDay);
    } else if (_typeof(constraintVal) === "object") {
      eventInstances = this.parseEventDefToInstances(constraintVal); // handles recurring events

      if (!eventInstances) {
        // invalid input. fallback to parsing footprint directly
        return this.parseFootprints(constraintVal);
      } else {
        return this.eventInstancesToFootprints(eventInstances);
      }
    } else if (constraintVal != null) {
      // an ID
      eventInstances = this.eventManager.getEventInstancesWithId(constraintVal);
      return this.eventInstancesToFootprints(eventInstances);
    }
  }; // returns ComponentFootprint[]
  // uses current view's range


  Calendar.prototype.buildCurrentBusinessFootprints = function (isAllDay) {
    var view = this.view;
    var businessHourGenerator = view.get("businessHourGenerator");
    var unzonedRange = view.dateProfile.activeUnzonedRange;
    var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(isAllDay, unzonedRange);

    if (eventInstanceGroup) {
      return this.eventInstancesToFootprints(eventInstanceGroup.eventInstances);
    } else {
      return [];
    }
  }; // conversion util


  Calendar.prototype.eventInstancesToFootprints = function (eventInstances) {
    var eventRanges = eventInstances.map(eventInstanceToEventRange);
    var eventFootprints = this.eventRangesToEventFootprints(eventRanges);
    return eventFootprints.map(eventFootprintToComponentFootprint);
  }; // Overlap
  // ------------------------------------------------------------------------------------------------


  Calendar.prototype.collectOverlapEventFootprints = function (peerEventFootprints, targetFootprint) {
    var overlapEventFootprints = [];
    var i;

    for (i = 0; i < peerEventFootprints.length; i++) {
      if (this.footprintsIntersect(targetFootprint, peerEventFootprints[i].componentFootprint)) {
        overlapEventFootprints.push(peerEventFootprints[i]);
      }
    }

    return overlapEventFootprints;
  }; // optional subjectEventInstance


  function isOverlapsAllowedByFunc(overlapEventFootprints, overlapFunc, subjectEventInstance) {
    var i;

    for (i = 0; i < overlapEventFootprints.length; i++) {
      if (!overlapFunc(overlapEventFootprints[i].eventInstance.toLegacy(), subjectEventInstance ? subjectEventInstance.toLegacy() : null)) {
        return false;
      }
    }

    return true;
  }

  function isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance) {
    var subjectLegacyInstance = subjectEventInstance.toLegacy();
    var i;
    var overlapEventInstance;
    var overlapEventDef;
    var overlapVal;

    for (i = 0; i < overlapEventFootprints.length; i++) {
      overlapEventInstance = overlapEventFootprints[i].eventInstance;
      overlapEventDef = overlapEventInstance.def; // don't need to pass in calendar, because don't want to consider global eventOverlap property,
      // because we already considered that earlier in the process.

      overlapVal = overlapEventDef.getOverlap();

      if (overlapVal === false) {
        return false;
      } else if (typeof overlapVal === "function") {
        if (!overlapVal(overlapEventInstance.toLegacy(), subjectLegacyInstance)) {
          return false;
        }
      }
    }

    return true;
  } // Conversion: eventDefs -> eventInstances -> eventRanges -> eventFootprints -> componentFootprints
  // ------------------------------------------------------------------------------------------------
  // NOTE: this might seem like repetitive code with the Grid class, however, this code is related to
  // constraints whereas the Grid code is related to rendering. Each approach might want to convert
  // eventRanges -> eventFootprints in a different way. Regardless, there are opportunities to make
  // this more DRY.

  /*
  Returns false on invalid input.
  */


  Calendar.prototype.parseEventDefToInstances = function (eventInput) {
    var eventManager = this.eventManager;
    var eventDef = EventDefParser.parse(eventInput, new EventSource(this));

    if (!eventDef) {
      // invalid
      return false;
    }

    return eventDef.buildInstances(eventManager.currentPeriod.unzonedRange);
  };

  Calendar.prototype.eventRangesToEventFootprints = function (eventRanges) {
    var i;
    var eventFootprints = [];

    for (i = 0; i < eventRanges.length; i++) {
      eventFootprints.push.apply( // footprints
      eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
    }

    return eventFootprints;
  };

  Calendar.prototype.eventRangeToEventFootprints = function (eventRange) {
    return [eventRangeToEventFootprint(eventRange)];
  };
  /*
  Parses footprints directly.
  Very similar to EventDateProfile::parse :(
  */


  Calendar.prototype.parseFootprints = function (rawInput) {
    var start, end;

    if (rawInput.start) {
      start = this.moment(rawInput.start);

      if (!start.isValid()) {
        start = null;
      }
    }

    if (rawInput.end) {
      end = this.moment(rawInput.end);

      if (!end.isValid()) {
        end = null;
      }
    }

    return [new ComponentFootprint(new UnzonedRange(start, end), start && !start.hasTime() || end && !end.hasTime() // isAllDay
    )];
  }; // Footprint Utils
  // ----------------------------------------------------------------------------------------


  Calendar.prototype.footprintContainsFootprint = function (outerFootprint, innerFootprint) {
    return outerFootprint.unzonedRange.containsRange(innerFootprint.unzonedRange);
  };

  Calendar.prototype.footprintsIntersect = function (footprint0, footprint1) {
    return footprint0.unzonedRange.intersectsWith(footprint1.unzonedRange);
  };

  Calendar.mixin({
    // Sources
    // ------------------------------------------------------------------------------------
    getEventSources: function getEventSources() {
      return this.eventManager.otherSources.slice(); // clone
    },
    getEventSourceById: function getEventSourceById(id) {
      return this.eventManager.getSourceById(EventSource.normalizeId(id));
    },
    addEventSource: function addEventSource(sourceInput) {
      var source = EventSourceParser.parse(sourceInput, this);

      if (source) {
        this.eventManager.addSource(source);
      }
    },
    removeEventSources: function removeEventSources(sourceMultiQuery) {
      var eventManager = this.eventManager;
      var sources;
      var i;

      if (sourceMultiQuery == null) {
        this.eventManager.removeAllSources();
      } else {
        sources = eventManager.multiQuerySources(sourceMultiQuery);
        eventManager.freeze();

        for (i = 0; i < sources.length; i++) {
          eventManager.removeSource(sources[i]);
        }

        eventManager.thaw();
      }
    },
    removeEventSource: function removeEventSource(sourceQuery) {
      var eventManager = this.eventManager;
      var sources = eventManager.querySources(sourceQuery);
      var i;
      eventManager.freeze();

      for (i = 0; i < sources.length; i++) {
        eventManager.removeSource(sources[i]);
      }

      eventManager.thaw();
    },
    refetchEventSources: function refetchEventSources(sourceMultiQuery) {
      var eventManager = this.eventManager;
      var sources = eventManager.multiQuerySources(sourceMultiQuery);
      var i;
      eventManager.freeze();

      for (i = 0; i < sources.length; i++) {
        eventManager.refetchSource(sources[i]);
      }

      eventManager.thaw();
    },
    // Events
    // ------------------------------------------------------------------------------------
    refetchEvents: function refetchEvents() {
      this.eventManager.refetchAllSources();
    },
    renderEvents: function renderEvents(eventInputs, isSticky) {
      this.eventManager.freeze();

      for (var i = 0; i < eventInputs.length; i++) {
        this.renderEvent(eventInputs[i], isSticky);
      }

      this.eventManager.thaw();
    },
    renderEvent: function renderEvent(eventInput, isSticky) {
      var eventManager = this.eventManager;
      var eventDef = EventDefParser.parse(eventInput, eventInput.source || eventManager.stickySource);

      if (eventDef) {
        eventManager.addEventDef(eventDef, isSticky);
      }
    },
    // legacyQuery operates on legacy event instance objects
    removeEvents: function removeEvents(legacyQuery) {
      var eventManager = this.eventManager;
      var legacyInstances = [];
      var idMap = {};
      var eventDef;
      var i;

      if (legacyQuery == null) {
        // shortcut for removing all
        eventManager.removeAllEventDefs(true); // persist=true
      } else {
        eventManager.getEventInstances().forEach(function (eventInstance) {
          legacyInstances.push(eventInstance.toLegacy());
        });
        legacyInstances = filterLegacyEventInstances(legacyInstances, legacyQuery); // compute unique IDs

        for (i = 0; i < legacyInstances.length; i++) {
          eventDef = this.eventManager.getEventDefByUid(legacyInstances[i]._id);
          idMap[eventDef.id] = true;
        }

        eventManager.freeze();

        for (i in idMap) {
          // reuse `i` as an "id"
          eventManager.removeEventDefsById(i, true); // persist=true
        }

        eventManager.thaw();
      }
    },
    // legacyQuery operates on legacy event instance objects
    clientEvents: function clientEvents(legacyQuery) {
      var legacyEventInstances = [];
      this.eventManager.getEventInstances().forEach(function (eventInstance) {
        legacyEventInstances.push(eventInstance.toLegacy());
      });
      return filterLegacyEventInstances(legacyEventInstances, legacyQuery);
    },
    updateEvents: function updateEvents(eventPropsArray) {
      this.eventManager.freeze();

      for (var i = 0; i < eventPropsArray.length; i++) {
        this.updateEvent(eventPropsArray[i]);
      }

      this.eventManager.thaw();
    },
    updateEvent: function updateEvent(eventProps) {
      var eventDef = this.eventManager.getEventDefByUid(eventProps._id);
      var eventInstance;
      var eventDefMutation;

      if (eventDef instanceof SingleEventDef) {
        eventInstance = eventDef.buildInstance();
        eventDefMutation = EventDefMutation.createFromRawProps(eventInstance, eventProps, // raw props
        null // largeUnit -- who uses it?
        );
        this.eventManager.mutateEventsWithId(eventDef.id, eventDefMutation); // will release
      }
    }
  });

  function filterLegacyEventInstances(legacyEventInstances, legacyQuery) {
    if (legacyQuery == null) {
      return legacyEventInstances;
    } else if ($.isFunction(legacyQuery)) {
      return legacyEventInstances.filter(legacyQuery);
    } else {
      // an event ID
      legacyQuery += ""; // normalize to string

      return legacyEventInstances.filter(function (legacyEventInstance) {
        // soft comparison because id not be normalized to string
        return legacyEventInstance.id == legacyQuery || legacyEventInstance._id === legacyQuery; // can specify internal id, but must exactly match
      });
    }
  }

  Calendar.defaults = {
    titleRangeSeparator: " \u2013 ",
    // en dash
    monthYearFormat: "MMMM YYYY",
    // required for en. other locales rely on datepicker computable option
    defaultTimedEventDuration: "02:00:00",
    defaultAllDayEventDuration: {
      days: 1
    },
    forceEventDuration: false,
    nextDayThreshold: "09:00:00",
    // 9am
    // display
    columnHeader: true,
    defaultView: "month",
    aspectRatio: 1.35,
    header: {
      left: "title",
      center: "",
      right: "holiday,today,prev,next"
    },
    weekends: true,
    weekNumbers: false,
    weekNumberTitle: "W",
    weekNumberCalculation: "local",
    //editable: false,
    //nowIndicator: false,
    scrollTime: "06:00:00",
    minTime: "00:00:00",
    maxTime: "24:00:00",
    showNonCurrentDates: true,
    // event ajax
    lazyFetching: true,
    startParam: "start",
    endParam: "end",
    timezoneParam: "timezone",
    timezone: false,
    //allDayDefault: undefined,
    // locale
    isRTL: false,
    buttonText: {
      prev: "prev",
      next: "next",
      prevYear: "prev year",
      nextYear: "next year",
      year: "year",
      // TODO: locale files need to specify this
      today: "Create Event",
      holiday: "Holidays",
      month: "month",
      week: "week",
      day: "day"
    },
    //buttonIcons: null,
    allDayText: "all day",
    // allows setting a min-height to the event segment to prevent short events overlapping each other
    agendaEventMinHeight: 0,
    // jquery-ui theming
    theme: false,
    //themeButtonIcons: null,
    //eventResizableFromStart: false,
    dragOpacity: 0.75,
    dragRevertDuration: 500,
    dragScroll: true,
    //selectable: false,
    unselectAuto: true,
    //selectMinDistance: 0,
    dropAccept: "*",
    eventOrder: "title",
    //eventRenderWait: null,
    eventLimit: false,
    eventLimitText: "more",
    eventLimitClick: "popover",
    dayPopoverFormat: "LL",
    handleWindowResize: true,
    windowResizeDelay: 100,
    // milliseconds before an updateSize happens
    longPressDelay: 1000
  };
  Calendar.englishDefaults = {
    // used by locale.js
    dayPopoverFormat: "dddd, MMMM D"
  };
  Calendar.rtlDefaults = {
    // right-to-left defaults
    header: {
      // TODO: smarter solution (first/center/last ?)
      left: "next,prev, today,holiday",
      center: "",
      right: "title"
    },
    buttonIcons: {
      prev: "right-single-arrow",
      next: "left-single-arrow",
      prevYear: "right-double-arrow",
      nextYear: "left-double-arrow"
    },
    themeButtonIcons: {
      prev: "circle-triangle-e",
      next: "circle-triangle-w",
      nextYear: "seek-prev",
      prevYear: "seek-next"
    }
  };
  var localeOptionHash = FC.locales = {}; // initialize and expose
  // TODO: document the structure and ordering of a FullCalendar locale file
  // Initialize jQuery UI datepicker translations while using some of the translations
  // Will set this as the default locales for datepicker.

  FC.datepickerLocale = function (localeCode, dpLocaleCode, dpOptions) {
    // get the FullCalendar internal option hash for this locale. create if necessary
    var fcOptions = localeOptionHash[localeCode] || (localeOptionHash[localeCode] = {}); // transfer some simple options from datepicker to fc

    fcOptions.isRTL = dpOptions.isRTL;
    fcOptions.weekNumberTitle = dpOptions.weekHeader; // compute some more complex options from datepicker

    $.each(dpComputableOptions, function (name, func) {
      fcOptions[name] = func(dpOptions);
    }); // is jQuery UI Datepicker is on the page?

    if ($.datepicker) {
      // Register the locale data.
      // FullCalendar and MomentJS use locale codes like "pt-br" but Datepicker
      // does it like "pt-BR" or if it doesn't have the locale, maybe just "pt".
      // Make an alias so the locale can be referenced either way.
      $.datepicker.regional[dpLocaleCode] = $.datepicker.regional[localeCode] = dpOptions; // alias
      // Alias 'en' to the default locale data. Do this every time.

      $.datepicker.regional.en = $.datepicker.regional[""]; // Set as Datepicker's global defaults.

      $.datepicker.setDefaults(dpOptions);
    }
  }; // Sets FullCalendar-specific translations. Will set the locales as the global default.


  FC.locale = function (localeCode, newFcOptions) {
    var fcOptions;
    var momOptions; // get the FullCalendar internal option hash for this locale. create if necessary

    fcOptions = localeOptionHash[localeCode] || (localeOptionHash[localeCode] = {}); // provided new options for this locales? merge them in

    if (newFcOptions) {
      fcOptions = localeOptionHash[localeCode] = mergeOptions([fcOptions, newFcOptions]);
    } // compute locale options that weren't defined.
    // always do this. newFcOptions can be undefined when initializing from i18n file,
    // so no way to tell if this is an initialization or a default-setting.


    momOptions = getMomentLocaleData(localeCode); // will fall back to en

    $.each(momComputableOptions, function (name, func) {
      if (fcOptions[name] == null) {
        fcOptions[name] = func(momOptions, fcOptions);
      }
    }); // set it as the default locale for FullCalendar

    Calendar.defaults.locale = localeCode;
  }; // NOTE: can't guarantee any of these computations will run because not every locale has datepicker
  // configs, so make sure there are English fallbacks for these in the defaults file.


  var dpComputableOptions = {
    buttonText: function buttonText(dpOptions) {
      return {
        // the translations sometimes wrongly contain HTML entities
        prev: stripHtmlEntities(dpOptions.prevText),
        next: stripHtmlEntities(dpOptions.nextText),
        today: stripHtmlEntities(dpOptions.currentText),
        holiday: stripHtmlEntities(dpOptions.currentText)
      };
    },
    // Produces format strings like "MMMM YYYY" -> "September 2014"
    monthYearFormat: function monthYearFormat(dpOptions) {
      return dpOptions.showMonthAfterYear ? "YYYY[" + dpOptions.yearSuffix + "] MMMM" : "MMMM YYYY[" + dpOptions.yearSuffix + "]";
    }
  };
  var momComputableOptions = {
    // Produces format strings like "ddd M/D" -> "Fri 9/15"
    dayOfMonthFormat: function dayOfMonthFormat(momOptions, fcOptions) {
      var format = momOptions.longDateFormat("l"); // for the format like "M/D/YYYY"
      // strip the year off the edge, as well as other misc non-whitespace chars

      format = format.replace(/^Y+[^\w\s]*|[^\w\s]*Y+$/g, "");

      if (fcOptions.isRTL) {
        format += " ddd"; // for RTL, add day-of-week to end
      } else {
        format = "ddd " + format; // for LTR, add day-of-week to beginning
      }

      return format;
    },
    // Produces format strings like "h:mma" -> "6:00pm"
    mediumTimeFormat: function mediumTimeFormat(momOptions) {
      // can't be called `timeFormat` because collides with option
      return momOptions.longDateFormat("LT").replace(/\s*a$/i, "a"); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h(:mm)a" -> "6pm" / "6:30pm"
    smallTimeFormat: function smallTimeFormat(momOptions) {
      return momOptions.longDateFormat("LT").replace(":mm", "(:mm)").replace(/(\Wmm)$/, "($1)") // like above, but for foreign locales
      .replace(/\s*a$/i, "a"); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h(:mm)t" -> "6p" / "6:30p"
    extraSmallTimeFormat: function extraSmallTimeFormat(momOptions) {
      return momOptions.longDateFormat("LT").replace(":mm", "(:mm)").replace(/(\Wmm)$/, "($1)") // like above, but for foreign locales
      .replace(/\s*a$/i, "t"); // convert to AM/PM/am/pm to lowercase one-letter. remove any spaces beforehand
    },
    // Produces format strings like "ha" / "H" -> "6pm" / "18"
    hourFormat: function hourFormat(momOptions) {
      return momOptions.longDateFormat("LT").replace(":mm", "").replace(/(\Wmm)$/, "") // like above, but for foreign locales
      .replace(/\s*a$/i, "a"); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h:mm" -> "6:30" (with no AM/PM)
    noMeridiemTimeFormat: function noMeridiemTimeFormat(momOptions) {
      return momOptions.longDateFormat("LT").replace(/\s*a$/i, ""); // remove trailing AM/PM
    }
  }; // options that should be computed off live calendar options (considers override options)
  // TODO: best place for this? related to locale?
  // TODO: flipping text based on isRTL is a bad idea because the CSS `direction` might want to handle it

  var instanceComputableOptions = {
    // Produces format strings for results like "Mo 16"
    smallDayDateFormat: function smallDayDateFormat(options) {
      return options.isRTL ? "D dd" : "dd D";
    },
    // Produces format strings for results like "Wk 5"
    weekFormat: function weekFormat(options) {
      return options.isRTL ? "w[ " + options.weekNumberTitle + "]" : "[" + options.weekNumberTitle + " ]w";
    },
    // Produces format strings for results like "Wk5"
    smallWeekFormat: function smallWeekFormat(options) {
      return options.isRTL ? "w[" + options.weekNumberTitle + "]" : "[" + options.weekNumberTitle + "]w";
    }
  }; // TODO: make these computable properties in optionsModel

  function populateInstanceComputableOptions(options) {
    $.each(instanceComputableOptions, function (name, func) {
      if (options[name] == null) {
        options[name] = func(options);
      }
    });
  } // Returns moment's internal locale data. If doesn't exist, returns English.


  function getMomentLocaleData(localeCode) {
    return moment.localeData(localeCode) || moment.localeData("en");
  } // Initialize English by forcing computation of moment-derived options.
  // Also, sets it as the default.


  FC.locale("en", Calendar.englishDefaults);
  var UnzonedRange = FC.UnzonedRange = Class.extend({
    startMs: null,
    // if null, no start constraint
    endMs: null,
    // if null, no end constraint
    // TODO: move these into footprint.
    // Especially, doesn't make sense for null startMs/endMs.
    isStart: true,
    isEnd: true,
    constructor: function constructor(startInput, endInput) {
      if (moment.isMoment(startInput)) {
        startInput = startInput.clone().stripZone();
      }

      if (moment.isMoment(endInput)) {
        endInput = endInput.clone().stripZone();
      }

      if (startInput) {
        this.startMs = startInput.valueOf();
      }

      if (endInput) {
        this.endMs = endInput.valueOf();
      }
    },
    intersect: function intersect(otherRange) {
      var startMs = this.startMs;
      var endMs = this.endMs;
      var newRange = null;

      if (otherRange.startMs !== null) {
        if (startMs === null) {
          startMs = otherRange.startMs;
        } else {
          startMs = Math.max(startMs, otherRange.startMs);
        }
      }

      if (otherRange.endMs !== null) {
        if (endMs === null) {
          endMs = otherRange.endMs;
        } else {
          endMs = Math.min(endMs, otherRange.endMs);
        }
      }

      if (startMs === null || endMs === null || startMs < endMs) {
        newRange = new UnzonedRange(startMs, endMs);
        newRange.isStart = this.isStart && startMs === this.startMs;
        newRange.isEnd = this.isEnd && endMs === this.endMs;
      }

      return newRange;
    },
    intersectsWith: function intersectsWith(otherRange) {
      return (this.endMs === null || otherRange.startMs === null || this.endMs > otherRange.startMs) && (this.startMs === null || otherRange.endMs === null || this.startMs < otherRange.endMs);
    },
    containsRange: function containsRange(innerRange) {
      return (this.startMs === null || innerRange.startMs !== null && innerRange.startMs >= this.startMs) && (this.endMs === null || innerRange.endMs !== null && innerRange.endMs <= this.endMs);
    },
    // `date` can be a moment, a Date, or a millisecond time.
    containsDate: function containsDate(date) {
      var ms = date.valueOf();
      return (this.startMs === null || ms >= this.startMs) && (this.endMs === null || ms < this.endMs);
    },
    // If the given date is not within the given range, move it inside.
    // (If it's past the end, make it one millisecond before the end).
    // `date` can be a moment, a Date, or a millisecond time.
    // Returns a MS-time.
    constrainDate: function constrainDate(date) {
      var ms = date.valueOf();

      if (this.startMs !== null && ms < this.startMs) {
        ms = this.startMs;
      }

      if (this.endMs !== null && ms >= this.endMs) {
        ms = this.endMs - 1;
      }

      return ms;
    },
    equals: function equals(otherRange) {
      return this.startMs === otherRange.startMs && this.endMs === otherRange.endMs;
    },
    clone: function clone() {
      var range = new UnzonedRange(this.startMs, this.endMs);
      range.isStart = this.isStart;
      range.isEnd = this.isEnd;
      return range;
    },
    // Returns an ambig-zoned moment from startMs.
    // BEWARE: returned moment is not localized.
    // Formatting and start-of-week will be default.
    getStart: function getStart() {
      if (this.startMs !== null) {
        return FC.moment.utc(this.startMs).stripZone();
      }
    },
    // Returns an ambig-zoned moment from startMs.
    // BEWARE: returned moment is not localized.
    // Formatting and start-of-week will be default.
    getEnd: function getEnd() {
      if (this.endMs !== null) {
        return FC.moment.utc(this.endMs).stripZone();
      }
    },
    as: function as(unit) {
      return moment.utc(this.endMs).diff(moment.utc(this.startMs), unit, true);
    }
  });
  /*
  SIDEEFFECT: will mutate eventRanges.
  Will return a new array result.
  Only works for non-open-ended ranges.
  */

  function invertUnzonedRanges(ranges, constraintRange) {
    var invertedRanges = [];
    var startMs = constraintRange.startMs; // the end of the previous range. the start of the new range

    var i;
    var dateRange; // ranges need to be in order. required for our date-walking algorithm

    ranges.sort(compareUnzonedRanges);

    for (i = 0; i < ranges.length; i++) {
      dateRange = ranges[i]; // add the span of time before the event (if there is any)

      if (dateRange.startMs > startMs) {
        // compare millisecond time (skip any ambig logic)
        invertedRanges.push(new UnzonedRange(startMs, dateRange.startMs));
      }

      if (dateRange.endMs > startMs) {
        startMs = dateRange.endMs;
      }
    } // add the span of time after the last event (if there is any)


    if (startMs < constraintRange.endMs) {
      // compare millisecond time (skip any ambig logic)
      invertedRanges.push(new UnzonedRange(startMs, constraintRange.endMs));
    }

    return invertedRanges;
  }
  /*
  Only works for non-open-ended ranges.
  */


  function compareUnzonedRanges(range1, range2) {
    return range1.startMs - range2.startMs; // earlier ranges go first
  }
  /*
  Meant to be immutable
  */


  var ComponentFootprint = FC.ComponentFootprint = Class.extend({
    unzonedRange: null,
    isAllDay: false,
    // component can choose to ignore this
    constructor: function constructor(unzonedRange, isAllDay) {
      this.unzonedRange = unzonedRange;
      this.isAllDay = isAllDay;
    },

    /*
    Only works for non-open-ended ranges.
    */
    toLegacy: function toLegacy(calendar) {
      return {
        start: calendar.msToMoment(this.unzonedRange.startMs, this.isAllDay),
        end: calendar.msToMoment(this.unzonedRange.endMs, this.isAllDay)
      };
    }
  });
  var EventPeriod = Class.extend(EmitterMixin, {
    start: null,
    end: null,
    timezone: null,
    unzonedRange: null,
    requestsByUid: null,
    pendingCnt: 0,
    freezeDepth: 0,
    stuntedReleaseCnt: 0,
    releaseCnt: 0,
    eventDefsByUid: null,
    eventDefsById: null,
    eventInstanceGroupsById: null,
    constructor: function constructor(start, end, timezone) {
      this.start = start;
      this.end = end;
      this.timezone = timezone;
      this.unzonedRange = new UnzonedRange(start.clone().stripZone(), end.clone().stripZone());
      this.requestsByUid = {};
      this.eventDefsByUid = {};
      this.eventDefsById = {};
      this.eventInstanceGroupsById = {};
    },
    isWithinRange: function isWithinRange(start, end) {
      // TODO: use a range util function?
      return !start.isBefore(this.start) && !end.isAfter(this.end);
    },
    // Requesting and Purging
    // -----------------------------------------------------------------------------------------------------------------
    requestSources: function requestSources(sources) {
      this.freeze();

      for (var i = 0; i < sources.length; i++) {
        this.requestSource(sources[i]);
      }

      this.thaw();
    },
    requestSource: function requestSource(source) {
      var _this = this;

      var request = {
        source: source,
        status: "pending"
      };
      this.requestsByUid[source.uid] = request;
      this.pendingCnt += 1;
      source.fetch(this.start, this.end, this.timezone).then(function (eventDefs) {
        if (request.status !== "cancelled") {
          request.status = "completed";
          request.eventDefs = eventDefs;

          _this.addEventDefs(eventDefs);

          _this.pendingCnt--;

          _this.tryRelease();
        }
      }, function () {
        // failure
        if (request.status !== "cancelled") {
          request.status = "failed";
          _this.pendingCnt--;

          _this.tryRelease();
        }
      });
    },
    purgeSource: function purgeSource(source) {
      var request = this.requestsByUid[source.uid];

      if (request) {
        delete this.requestsByUid[source.uid];

        if (request.status === "pending") {
          request.status = "cancelled";
          this.pendingCnt--;
          this.tryRelease();
        } else if (request.status === "completed") {
          request.eventDefs.forEach(this.removeEventDef.bind(this));
        }
      }
    },
    purgeAllSources: function purgeAllSources() {
      var requestsByUid = this.requestsByUid;
      var uid, request;
      var completedCnt = 0;

      for (uid in requestsByUid) {
        request = requestsByUid[uid];

        if (request.status === "pending") {
          request.status = "cancelled";
        } else if (request.status === "completed") {
          completedCnt++;
        }
      }

      this.requestsByUid = {};
      this.pendingCnt = 0;

      if (completedCnt) {
        this.removeAllEventDefs(); // might release
      }
    },
    // Event Definitions
    // -----------------------------------------------------------------------------------------------------------------
    getEventDefByUid: function getEventDefByUid(eventDefUid) {
      return this.eventDefsByUid[eventDefUid];
    },
    getEventDefsById: function getEventDefsById(eventDefId) {
      var a = this.eventDefsById[eventDefId];

      if (a) {
        return a.slice(); // clone
      }

      return [];
    },
    addEventDefs: function addEventDefs(eventDefs) {
      for (var i = 0; i < eventDefs.length; i++) {
        this.addEventDef(eventDefs[i]);
      }
    },
    addEventDef: function addEventDef(eventDef) {
      var eventDefsById = this.eventDefsById;
      var eventDefId = eventDef.id;
      var eventDefs = eventDefsById[eventDefId] || (eventDefsById[eventDefId] = []);
      var eventInstances = eventDef.buildInstances(this.unzonedRange);
      var i;
      eventDefs.push(eventDef);
      this.eventDefsByUid[eventDef.uid] = eventDef;

      for (i = 0; i < eventInstances.length; i++) {
        this.addEventInstance(eventInstances[i], eventDefId);
      }
    },
    removeEventDefsById: function removeEventDefsById(eventDefId) {
      var _this = this;

      this.getEventDefsById(eventDefId).forEach(function (eventDef) {
        _this.removeEventDef(eventDef);
      });
    },
    removeAllEventDefs: function removeAllEventDefs() {
      var isEmpty = $.isEmptyObject(this.eventDefsByUid);
      this.eventDefsByUid = {};
      this.eventDefsById = {};
      this.eventInstanceGroupsById = {};

      if (!isEmpty) {
        this.tryRelease();
      }
    },
    removeEventDef: function removeEventDef(eventDef) {
      var eventDefsById = this.eventDefsById;
      var eventDefs = eventDefsById[eventDef.id];
      delete this.eventDefsByUid[eventDef.uid];

      if (eventDefs) {
        removeExact(eventDefs, eventDef);

        if (!eventDefs.length) {
          delete eventDefsById[eventDef.id];
        }

        this.removeEventInstancesForDef(eventDef);
      }
    },
    // Event Instances
    // -----------------------------------------------------------------------------------------------------------------
    getEventInstances: function getEventInstances() {
      // TODO: consider iterator
      var eventInstanceGroupsById = this.eventInstanceGroupsById;
      var eventInstances = [];
      var id;

      for (id in eventInstanceGroupsById) {
        eventInstances.push.apply(eventInstances, // append
        eventInstanceGroupsById[id].eventInstances);
      }

      return eventInstances;
    },
    getEventInstancesWithId: function getEventInstancesWithId(eventDefId) {
      var eventInstanceGroup = this.eventInstanceGroupsById[eventDefId];

      if (eventInstanceGroup) {
        return eventInstanceGroup.eventInstances.slice(); // clone
      }

      return [];
    },
    getEventInstancesWithoutId: function getEventInstancesWithoutId(eventDefId) {
      // TODO: consider iterator
      var eventInstanceGroupsById = this.eventInstanceGroupsById;
      var matchingInstances = [];
      var id;

      for (id in eventInstanceGroupsById) {
        if (id !== eventDefId) {
          matchingInstances.push.apply(matchingInstances, // append
          eventInstanceGroupsById[id].eventInstances);
        }
      }

      return matchingInstances;
    },
    addEventInstance: function addEventInstance(eventInstance, eventDefId) {
      var eventInstanceGroupsById = this.eventInstanceGroupsById;
      var eventInstanceGroup = eventInstanceGroupsById[eventDefId] || (eventInstanceGroupsById[eventDefId] = new EventInstanceGroup());
      eventInstanceGroup.eventInstances.push(eventInstance);
      this.tryRelease();
    },
    removeEventInstancesForDef: function removeEventInstancesForDef(eventDef) {
      var eventInstanceGroupsById = this.eventInstanceGroupsById;
      var eventInstanceGroup = eventInstanceGroupsById[eventDef.id];
      var removeCnt;

      if (eventInstanceGroup) {
        removeCnt = removeMatching(eventInstanceGroup.eventInstances, function (currentEventInstance) {
          return currentEventInstance.def === eventDef;
        });

        if (!eventInstanceGroup.eventInstances.length) {
          delete eventInstanceGroupsById[eventDef.id];
        }

        if (removeCnt) {
          this.tryRelease();
        }
      }
    },
    // Releasing and Freezing
    // -----------------------------------------------------------------------------------------------------------------
    tryRelease: function tryRelease() {
      if (!this.pendingCnt) {
        if (!this.freezeDepth) {
          this.release();
        } else {
          this.stuntedReleaseCnt++;
        }
      }
    },
    release: function release() {
      this.releaseCnt++;
      this.trigger("release", this.eventInstanceGroupsById);
    },
    whenReleased: function whenReleased() {
      var _this = this;

      if (this.releaseCnt) {
        return Promise.resolve(this.eventInstanceGroupsById);
      } else {
        return Promise.construct(function (onResolve) {
          _this.one("release", onResolve);
        });
      }
    },
    freeze: function freeze() {
      if (!this.freezeDepth++) {
        this.stuntedReleaseCnt = 0;
      }
    },
    thaw: function thaw() {
      if (! --this.freezeDepth && this.stuntedReleaseCnt && !this.pendingCnt) {
        this.release();
      }
    }
  });
  var EventManager = Class.extend(EmitterMixin, ListenerMixin, {
    currentPeriod: null,
    calendar: null,
    stickySource: null,
    otherSources: null,
    // does not include sticky source
    constructor: function constructor(calendar) {
      this.calendar = calendar;
      this.stickySource = new ArrayEventSource(calendar);
      this.otherSources = [];
    },
    requestEvents: function requestEvents(start, end, timezone, force) {
      if (force || !this.currentPeriod || !this.currentPeriod.isWithinRange(start, end) || timezone !== this.currentPeriod.timezone) {
        this.setPeriod( // will change this.currentPeriod
        new EventPeriod(start, end, timezone));
      }

      return this.currentPeriod.whenReleased();
    },
    // Source Adding/Removing
    // -----------------------------------------------------------------------------------------------------------------
    addSource: function addSource(eventSource) {
      this.otherSources.push(eventSource);

      if (this.currentPeriod) {
        this.currentPeriod.requestSource(eventSource); // might release
      }
    },
    removeSource: function removeSource(doomedSource) {
      removeExact(this.otherSources, doomedSource);

      if (this.currentPeriod) {
        this.currentPeriod.purgeSource(doomedSource); // might release
      }
    },
    removeAllSources: function removeAllSources() {
      this.otherSources = [];

      if (this.currentPeriod) {
        this.currentPeriod.purgeAllSources(); // might release
      }
    },
    // Source Refetching
    // -----------------------------------------------------------------------------------------------------------------
    refetchSource: function refetchSource(eventSource) {
      var currentPeriod = this.currentPeriod;

      if (currentPeriod) {
        currentPeriod.freeze();
        currentPeriod.purgeSource(eventSource);
        currentPeriod.requestSource(eventSource);
        currentPeriod.thaw();
      }
    },
    refetchAllSources: function refetchAllSources() {
      var currentPeriod = this.currentPeriod;

      if (currentPeriod) {
        currentPeriod.freeze();
        currentPeriod.purgeAllSources();
        currentPeriod.requestSources(this.getSources());
        currentPeriod.thaw();
      }
    },
    // Source Querying
    // -----------------------------------------------------------------------------------------------------------------
    getSources: function getSources() {
      return [this.stickySource].concat(this.otherSources);
    },
    // like querySources, but accepts multple match criteria (like multiple IDs)
    multiQuerySources: function multiQuerySources(matchInputs) {
      // coerce into an array
      if (!matchInputs) {
        matchInputs = [];
      } else if (!$.isArray(matchInputs)) {
        matchInputs = [matchInputs];
      }

      var matchingSources = [];
      var i; // resolve raw inputs to real event source objects

      for (i = 0; i < matchInputs.length; i++) {
        matchingSources.push.apply( // append
        matchingSources, this.querySources(matchInputs[i]));
      }

      return matchingSources;
    },
    // matchInput can either by a real event source object, an ID, or the function/URL for the source.
    // returns an array of matching source objects.
    querySources: function querySources(matchInput) {
      var sources = this.otherSources;
      var i, source; // given a proper event source object

      for (i = 0; i < sources.length; i++) {
        source = sources[i];

        if (source === matchInput) {
          return [source];
        }
      } // an ID match


      source = this.getSourceById(EventSource.normalizeId(matchInput));

      if (source) {
        return [source];
      } // parse as an event source


      matchInput = EventSourceParser.parse(matchInput, this.calendar);

      if (matchInput) {
        return $.grep(sources, function (source) {
          return isSourcesEquivalent(matchInput, source);
        });
      }
    },

    /*
    ID assumed to already be normalized
    */
    getSourceById: function getSourceById(id) {
      return $.grep(this.otherSources, function (source) {
        return source.id && source.id === id;
      })[0];
    },
    // Event-Period
    // -----------------------------------------------------------------------------------------------------------------
    setPeriod: function setPeriod(eventPeriod) {
      if (this.currentPeriod) {
        this.unbindPeriod(this.currentPeriod);
        this.currentPeriod = null;
      }

      this.currentPeriod = eventPeriod;
      this.bindPeriod(eventPeriod);
      eventPeriod.requestSources(this.getSources());
    },
    bindPeriod: function bindPeriod(eventPeriod) {
      this.listenTo(eventPeriod, "release", function (eventsPayload) {
        this.trigger("release", eventsPayload);
      });
    },
    unbindPeriod: function unbindPeriod(eventPeriod) {
      this.stopListeningTo(eventPeriod);
    },
    // Event Getting/Adding/Removing
    // -----------------------------------------------------------------------------------------------------------------
    getEventDefByUid: function getEventDefByUid(uid) {
      if (this.currentPeriod) {
        return this.currentPeriod.getEventDefByUid(uid);
      }
    },
    addEventDef: function addEventDef(eventDef, isSticky) {
      if (isSticky) {
        this.stickySource.addEventDef(eventDef);
      }

      if (this.currentPeriod) {
        this.currentPeriod.addEventDef(eventDef); // might release
      }
    },
    removeEventDefsById: function removeEventDefsById(eventId) {
      this.getSources().forEach(function (eventSource) {
        eventSource.removeEventDefsById(eventId);
      });

      if (this.currentPeriod) {
        this.currentPeriod.removeEventDefsById(eventId); // might release
      }
    },
    removeAllEventDefs: function removeAllEventDefs() {
      this.getSources().forEach(function (eventSource) {
        eventSource.removeAllEventDefs();
      });

      if (this.currentPeriod) {
        this.currentPeriod.removeAllEventDefs();
      }
    },
    // Event Mutating
    // -----------------------------------------------------------------------------------------------------------------

    /*
    Returns an undo function.
    */
    mutateEventsWithId: function mutateEventsWithId(eventDefId, eventDefMutation) {
      var currentPeriod = this.currentPeriod;
      var eventDefs;
      var undoFuncs = [];

      if (currentPeriod) {
        currentPeriod.freeze();
        eventDefs = currentPeriod.getEventDefsById(eventDefId);
        eventDefs.forEach(function (eventDef) {
          // add/remove esp because id might change
          currentPeriod.removeEventDef(eventDef);
          undoFuncs.push(eventDefMutation.mutateSingle(eventDef));
          currentPeriod.addEventDef(eventDef);
        });
        currentPeriod.thaw();
        return function () {
          currentPeriod.freeze();

          for (var i = 0; i < eventDefs.length; i++) {
            currentPeriod.removeEventDef(eventDefs[i]);
            undoFuncs[i]();
            currentPeriod.addEventDef(eventDefs[i]);
          }

          currentPeriod.thaw();
        };
      }

      return function () {};
    },

    /*
    copies and then mutates
    */
    buildMutatedEventInstanceGroup: function buildMutatedEventInstanceGroup(eventDefId, eventDefMutation) {
      var eventDefs = this.getEventDefsById(eventDefId);
      var i;
      var defCopy;
      var allInstances = [];

      for (i = 0; i < eventDefs.length; i++) {
        defCopy = eventDefs[i].clone();

        if (defCopy instanceof SingleEventDef) {
          eventDefMutation.mutateSingle(defCopy);
          allInstances.push.apply(allInstances, // append
          defCopy.buildInstances());
        }
      }

      return new EventInstanceGroup(allInstances);
    },
    // Freezing
    // -----------------------------------------------------------------------------------------------------------------
    freeze: function freeze() {
      if (this.currentPeriod) {
        this.currentPeriod.freeze();
      }
    },
    thaw: function thaw() {
      if (this.currentPeriod) {
        this.currentPeriod.thaw();
      }
    }
  }); // Methods that straight-up query the current EventPeriod for an array of results.

  ["getEventDefsById", "getEventInstances", "getEventInstancesWithId", "getEventInstancesWithoutId"].forEach(function (methodName) {
    EventManager.prototype[methodName] = function () {
      var currentPeriod = this.currentPeriod;

      if (currentPeriod) {
        return currentPeriod[methodName].apply(currentPeriod, arguments);
      }

      return [];
    };
  });

  function isSourcesEquivalent(source0, source1) {
    return source0.getPrimitive() == source1.getPrimitive();
  }

  var BUSINESS_HOUR_EVENT_DEFAULTS = {
    start: "09:00",
    end: "17:00",
    dow: [1, 2, 3, 4, 5],
    // monday - friday
    rendering: "inverse-background" // classNames are defined in businessHoursSegClasses

  };
  var BusinessHourGenerator = FC.BusinessHourGenerator = Class.extend({
    rawComplexDef: null,
    calendar: null,
    // for anonymous EventSource
    constructor: function constructor(rawComplexDef, calendar) {
      this.rawComplexDef = rawComplexDef;
      this.calendar = calendar;
    },
    buildEventInstanceGroup: function buildEventInstanceGroup(isAllDay, unzonedRange) {
      var eventDefs = this.buildEventDefs(isAllDay);
      var eventInstanceGroup;

      if (eventDefs.length) {
        eventInstanceGroup = new EventInstanceGroup(eventDefsToEventInstances(eventDefs, unzonedRange)); // so that inverse-background rendering can happen even when no eventRanges in view

        eventInstanceGroup.explicitEventDef = eventDefs[0];
        return eventInstanceGroup;
      }
    },
    buildEventDefs: function buildEventDefs(isAllDay) {
      var rawComplexDef = this.rawComplexDef;
      var rawDefs = [];
      var requireDow = false;
      var i;
      var defs = [];

      if (rawComplexDef === true) {
        rawDefs = [{}]; // will get BUSINESS_HOUR_EVENT_DEFAULTS verbatim
      } else if ($.isPlainObject(rawComplexDef)) {
        rawDefs = [rawComplexDef];
      } else if ($.isArray(rawComplexDef)) {
        rawDefs = rawComplexDef;
        requireDow = true; // every sub-definition NEEDS a day-of-week
      }

      for (i = 0; i < rawDefs.length; i++) {
        if (!requireDow || rawDefs[i].dow) {
          defs.push(this.buildEventDef(isAllDay, rawDefs[i]));
        }
      }

      return defs;
    },
    buildEventDef: function buildEventDef(isAllDay, rawDef) {
      var fullRawDef = $.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, rawDef);

      if (isAllDay) {
        fullRawDef.start = null;
        fullRawDef.end = null;
      }

      return RecurringEventDef.parse(fullRawDef, new EventSource(this.calendar) // dummy source
      );
    }
  });
  var EventDefParser = {
    parse: function parse(eventInput, source) {
      if (isTimeString(eventInput.start) || moment.isDuration(eventInput.start) || isTimeString(eventInput.end) || moment.isDuration(eventInput.end)) {
        return RecurringEventDef.parse(eventInput, source);
      } else {
        return SingleEventDef.parse(eventInput, source);
      }
    }
  };
  var EventDef = FC.EventDef = Class.extend(ParsableModelMixin, {
    source: null,
    // required
    id: null,
    // normalized supplied ID
    rawId: null,
    // unnormalized supplied ID
    uid: null,
    // internal ID. new ID for every definition
    // NOTE: eventOrder sorting relies on these
    title: null,
    url: null,
    rendering: null,
    constraint: null,
    overlap: null,
    editable: null,
    startEditable: null,
    durationEditable: null,
    color: null,
    backgroundColor: null,
    borderColor: null,
    textColor: null,
    className: null,
    // an array. TODO: rename to className*s* (API breakage)
    miscProps: null,
    constructor: function constructor(source) {
      this.source = source;
      this.className = [];
      this.miscProps = {};
    },
    isAllDay: function isAllDay() {// subclasses must implement
    },
    buildInstances: function buildInstances(unzonedRange) {// subclasses must implement
    },
    clone: function clone() {
      var copy = new this.constructor(this.source);
      copy.id = this.id;
      copy.rawId = this.rawId;
      copy.uid = this.uid; // not really unique anymore :(

      EventDef.copyVerbatimStandardProps(this, copy);
      copy.className = this.className.slice(); // copy

      copy.miscProps = $.extend({}, this.miscProps);
      return copy;
    },
    hasInverseRendering: function hasInverseRendering() {
      return this.getRendering() === "inverse-background";
    },
    hasBgRendering: function hasBgRendering() {
      var rendering = this.getRendering();
      return rendering === "inverse-background" || rendering === "background";
    },
    getRendering: function getRendering() {
      if (this.rendering != null) {
        return this.rendering;
      }

      return this.source.rendering;
    },
    getConstraint: function getConstraint() {
      if (this.constraint != null) {
        return this.constraint;
      }

      if (this.source.constraint != null) {
        return this.source.constraint;
      }

      return this.source.calendar.opt("eventConstraint"); // what about View option?
    },
    getOverlap: function getOverlap() {
      if (this.overlap != null) {
        return this.overlap;
      }

      if (this.source.overlap != null) {
        return this.source.overlap;
      }

      return this.source.calendar.opt("eventOverlap"); // what about View option?
    },
    isStartExplicitlyEditable: function isStartExplicitlyEditable() {
      if (this.startEditable !== null) {
        return this.startEditable;
      }

      return this.source.startEditable;
    },
    isDurationExplicitlyEditable: function isDurationExplicitlyEditable() {
      if (this.durationEditable !== null) {
        return this.durationEditable;
      }

      return this.source.durationEditable;
    },
    isExplicitlyEditable: function isExplicitlyEditable() {
      if (this.editable !== null) {
        return this.editable;
      }

      return this.source.editable;
    },
    toLegacy: function toLegacy() {
      var obj = $.extend({}, this.miscProps);
      obj._id = this.uid;
      obj.source = this.source;
      obj.className = this.className.slice(); // copy

      obj.allDay = this.isAllDay();

      if (this.rawId != null) {
        obj.id = this.rawId;
      }

      EventDef.copyVerbatimStandardProps(this, obj);
      return obj;
    },
    applyManualStandardProps: function applyManualStandardProps(rawProps) {
      if (rawProps.id != null) {
        this.id = EventDef.normalizeId(this.rawId = rawProps.id);
      } else {
        this.id = EventDef.generateId();
      }

      if (rawProps._id != null) {
        // accept this prop, even tho somewhat internal
        this.uid = String(rawProps._id);
      } else {
        this.uid = EventDef.generateId();
      } // TODO: converge with EventSource


      if ($.isArray(rawProps.className)) {
        this.className = rawProps.className;
      }

      if (typeof rawProps.className === "string") {
        this.className = rawProps.className.split(/\s+/);
      }

      return true;
    },
    applyMiscProps: function applyMiscProps(rawProps) {
      $.extend(this.miscProps, rawProps);
    }
  }); // finish initializing the mixin

  EventDef.defineStandardProps = ParsableModelMixin_defineStandardProps;
  EventDef.copyVerbatimStandardProps = ParsableModelMixin_copyVerbatimStandardProps; // IDs
  // ---------------------------------------------------------------------------------------------------------------------
  // TODO: converge with EventSource

  EventDef.uuid = 0;

  EventDef.normalizeId = function (id) {
    return String(id);
  };

  EventDef.generateId = function () {
    return "_fc" + EventDef.uuid++;
  }; // Parsing
  // ---------------------------------------------------------------------------------------------------------------------


  EventDef.defineStandardProps({
    // not automatically assigned (`false`)
    _id: false,
    id: false,
    className: false,
    source: false,
    // will ignored
    // automatically assigned (`true`)
    title: true,
    url: true,
    rendering: true,
    constraint: true,
    overlap: true,
    editable: true,
    startEditable: true,
    durationEditable: true,
    color: true,
    backgroundColor: true,
    borderColor: true,
    textColor: true
  });

  EventDef.parse = function (rawInput, source) {
    var def = new this(source);

    if (def.applyProps(rawInput)) {
      return def;
    }

    return false;
  };

  var SingleEventDef = EventDef.extend({
    dateProfile: null,

    /*
    Will receive start/end params, but will be ignored.
    */
    buildInstances: function buildInstances() {
      return [this.buildInstance()];
    },
    buildInstance: function buildInstance() {
      return new EventInstance(this, // definition
      this.dateProfile);
    },
    isAllDay: function isAllDay() {
      return this.dateProfile.isAllDay();
    },
    clone: function clone() {
      var def = EventDef.prototype.clone.call(this);
      def.dateProfile = this.dateProfile;
      return def;
    },
    rezone: function rezone() {
      var calendar = this.source.calendar;
      var dateProfile = this.dateProfile;
      this.dateProfile = new EventDateProfile(calendar.moment(dateProfile.start), dateProfile.end ? calendar.moment(dateProfile.end) : null, calendar);
    },

    /*
    NOTE: if super-method fails, should still attempt to apply
    */
    applyManualStandardProps: function applyManualStandardProps(rawProps) {
      var superSuccess = EventDef.prototype.applyManualStandardProps.apply(this, arguments);
      var dateProfile = EventDateProfile.parse(rawProps, this.source); // returns null on failure

      if (dateProfile) {
        this.dateProfile = dateProfile; // make sure `date` shows up in the legacy event objects as-is

        if (rawProps.date != null) {
          this.miscProps.date = rawProps.date;
        }

        return superSuccess;
      } else {
        return false;
      }
    }
  }); // Parsing
  // ---------------------------------------------------------------------------------------------------------------------

  SingleEventDef.defineStandardProps({
    // false = manually process
    start: false,
    date: false,
    // alias for 'start'
    end: false,
    allDay: false
  });
  var RecurringEventDef = EventDef.extend({
    startTime: null,
    // duration
    endTime: null,
    // duration, or null
    dowHash: null,
    // object hash, or null
    isAllDay: function isAllDay() {
      return !this.startTime && !this.endTime;
    },
    buildInstances: function buildInstances(unzonedRange) {
      var calendar = this.source.calendar;
      var unzonedDate = unzonedRange.getStart();
      var unzonedEnd = unzonedRange.getEnd();
      var zonedDayStart;
      var instanceStart, instanceEnd;
      var instances = [];

      while (unzonedDate.isBefore(unzonedEnd)) {
        // if everyday, or this particular day-of-week
        if (!this.dowHash || this.dowHash[unzonedDate.day()]) {
          zonedDayStart = calendar.applyTimezone(unzonedDate);
          instanceStart = zonedDayStart.clone();
          instanceEnd = null;

          if (this.startTime) {
            instanceStart.time(this.startTime);
          } else {
            instanceStart.stripTime();
          }

          if (this.endTime) {
            instanceEnd = zonedDayStart.clone().time(this.endTime);
          }

          instances.push(new EventInstance(this, // definition
          new EventDateProfile(instanceStart, instanceEnd, calendar)));
        }

        unzonedDate.add(1, "days");
      }

      return instances;
    },
    setDow: function setDow(dowNumbers) {
      if (!this.dowHash) {
        this.dowHash = {};
      }

      for (var i = 0; i < dowNumbers.length; i++) {
        this.dowHash[dowNumbers[i]] = true;
      }
    },
    clone: function clone() {
      var def = EventDef.prototype.clone.call(this);

      if (def.startTime) {
        def.startTime = moment.duration(this.startTime);
      }

      if (def.endTime) {
        def.endTime = moment.duration(this.endTime);
      }

      if (this.dowHash) {
        def.dowHash = $.extend({}, this.dowHash);
      }

      return def;
    },

    /*
    NOTE: if super-method fails, should still attempt to apply
    */
    applyProps: function applyProps(rawProps) {
      var superSuccess = EventDef.prototype.applyProps.apply(this, arguments);

      if (rawProps.start) {
        this.startTime = moment.duration(rawProps.start);
      }

      if (rawProps.end) {
        this.endTime = moment.duration(rawProps.end);
      }

      if (rawProps.dow) {
        this.setDow(rawProps.dow);
      }

      return superSuccess;
    }
  }); // Parsing
  // ---------------------------------------------------------------------------------------------------------------------

  RecurringEventDef.defineStandardProps({
    // false = manually process
    start: false,
    end: false,
    dow: false
  });
  var EventInstance = Class.extend({
    def: null,
    // EventDef
    dateProfile: null,
    // EventDateProfile
    constructor: function constructor(def, dateProfile) {
      this.def = def;
      this.dateProfile = dateProfile;
    },
    toLegacy: function toLegacy() {
      var dateProfile = this.dateProfile;
      var obj = this.def.toLegacy();
      obj.start = dateProfile.start.clone();
      obj.end = dateProfile.end ? dateProfile.end.clone() : null;
      return obj;
    }
  });
  /*
  It's expected that there will be at least one EventInstance,
  OR that an explicitEventDef is assigned.
  */

  var EventInstanceGroup = FC.EventInstanceGroup = Class.extend({
    eventInstances: null,
    explicitEventDef: null,
    // optional
    constructor: function constructor(eventInstances) {
      this.eventInstances = eventInstances || [];
    },
    getAllEventRanges: function getAllEventRanges(constraintRange) {
      if (constraintRange) {
        return this.sliceNormalRenderRanges(constraintRange);
      } else {
        return this.eventInstances.map(eventInstanceToEventRange);
      }
    },
    sliceRenderRanges: function sliceRenderRanges(constraintRange) {
      if (this.isInverse()) {
        return this.sliceInverseRenderRanges(constraintRange);
      } else {
        return this.sliceNormalRenderRanges(constraintRange);
      }
    },
    sliceNormalRenderRanges: function sliceNormalRenderRanges(constraintRange) {
      var eventInstances = this.eventInstances;
      var i, eventInstance;
      var slicedRange;
      var slicedEventRanges = [];

      for (i = 0; i < eventInstances.length; i++) {
        eventInstance = eventInstances[i];
        slicedRange = eventInstance.dateProfile.unzonedRange.intersect(constraintRange);

        if (slicedRange) {
          slicedEventRanges.push(new EventRange(slicedRange, eventInstance.def, eventInstance));
        }
      }

      return slicedEventRanges;
    },
    sliceInverseRenderRanges: function sliceInverseRenderRanges(constraintRange) {
      var unzonedRanges = this.eventInstances.map(eventInstanceToUnzonedRange);
      var ownerDef = this.getEventDef();
      unzonedRanges = invertUnzonedRanges(unzonedRanges, constraintRange);
      return unzonedRanges.map(function (unzonedRange) {
        return new EventRange(unzonedRange, ownerDef); // don't give an EventInstance
      });
    },
    isInverse: function isInverse() {
      return this.getEventDef().hasInverseRendering();
    },
    getEventDef: function getEventDef() {
      return this.explicitEventDef || this.eventInstances[0].def;
    }
  });
  /*
  Meant to be immutable
  */

  var EventDateProfile = Class.extend({
    start: null,
    end: null,
    unzonedRange: null,
    constructor: function constructor(start, end, calendar) {
      this.start = start;
      this.end = end || null;
      this.unzonedRange = this.buildUnzonedRange(calendar);
    },
    isAllDay: function isAllDay() {
      // why recompute this every time?
      return !(this.start.hasTime() || this.end && this.end.hasTime());
    },

    /*
    Needs a Calendar object
    */
    buildUnzonedRange: function buildUnzonedRange(calendar) {
      var startMs = this.start.clone().stripZone().valueOf();
      var endMs = this.getEnd(calendar).stripZone().valueOf();
      return new UnzonedRange(startMs, endMs);
    },

    /*
    Needs a Calendar object
    */
    getEnd: function getEnd(calendar) {
      return this.end ? this.end.clone() : // derive the end from the start and allDay. compute allDay if necessary
      calendar.getDefaultEventEnd(this.isAllDay(), this.start);
    }
  });

  EventDateProfile.isStandardProp = function (propName) {
    return propName === "start" || propName === "date" || propName === "end" || propName === "allDay";
  };
  /*
  Needs an EventSource object
  */


  EventDateProfile.parse = function (rawProps, source) {
    var startInput = rawProps.start || rawProps.date;
    var endInput = rawProps.end;

    if (!startInput) {
      return false;
    }

    var calendar = source.calendar;
    var start = calendar.moment(startInput);
    var end = endInput ? calendar.moment(endInput) : null;
    var forcedAllDay = rawProps.allDay;
    var forceEventDuration = calendar.opt("forceEventDuration");

    if (!start.isValid()) {
      return false;
    }

    if (end && (!end.isValid() || !end.isAfter(start))) {
      end = null;
    }

    if (forcedAllDay == null) {
      forcedAllDay = source.allDayDefault;

      if (forcedAllDay == null) {
        forcedAllDay = calendar.opt("allDayDefault");
      }
    }

    if (forcedAllDay === true) {
      start.stripTime();

      if (end) {
        end.stripTime();
      }
    } else if (forcedAllDay === false) {
      if (!start.hasTime()) {
        start.time(0);
      }

      if (end && !end.hasTime()) {
        end.time(0);
      }
    }

    if (!end && forceEventDuration) {
      end = calendar.getDefaultEventEnd(!start.hasTime(), start);
    }

    return new EventDateProfile(start, end, calendar);
  };

  var EventRange = Class.extend({
    unzonedRange: null,
    eventDef: null,
    eventInstance: null,
    // optional
    constructor: function constructor(unzonedRange, eventDef, eventInstance) {
      this.unzonedRange = unzonedRange;
      this.eventDef = eventDef;

      if (eventInstance) {
        this.eventInstance = eventInstance;
      }
    }
  });
  var EventFootprint = FC.EventFootprint = Class.extend({
    componentFootprint: null,
    eventDef: null,
    eventInstance: null,
    // optional
    constructor: function constructor(componentFootprint, eventDef, eventInstance) {
      this.componentFootprint = componentFootprint;
      this.eventDef = eventDef;

      if (eventInstance) {
        this.eventInstance = eventInstance;
      }
    },
    getEventLegacy: function getEventLegacy() {
      return (this.eventInstance || this.eventDef).toLegacy();
    }
  });
  var EventDefMutation = FC.EventDefMutation = Class.extend({
    // won't ever be empty. will be null instead.
    // callers should use setDateMutation for setting.
    dateMutation: null,
    // hacks to get updateEvent/createFromRawProps to work.
    // not undo-able and not considered in isEmpty.
    eventDefId: null,
    // standard manual props
    className: null,
    // "
    verbatimStandardProps: null,
    miscProps: null,

    /*
    eventDef assumed to be a SingleEventDef.
    returns an undo function.
    */
    mutateSingle: function mutateSingle(eventDef) {
      var origDateProfile;

      if (this.dateMutation) {
        origDateProfile = eventDef.dateProfile;
        eventDef.dateProfile = this.dateMutation.buildNewDateProfile(origDateProfile, eventDef.source.calendar);
      } // can't undo
      // TODO: more DRY with EventDef::applyManualStandardProps


      if (this.eventDefId != null) {
        eventDef.id = EventDef.normalizeId(eventDef.rawId = this.eventDefId);
      } // can't undo
      // TODO: more DRY with EventDef::applyManualStandardProps


      if (this.className) {
        eventDef.className = this.className;
      } // can't undo


      if (this.verbatimStandardProps) {
        SingleEventDef.copyVerbatimStandardProps(this.verbatimStandardProps, // src
        eventDef // dest
        );
      } // can't undo


      if (this.miscProps) {
        eventDef.applyMiscProps(this.miscProps);
      }

      if (origDateProfile) {
        return function () {
          eventDef.dateProfile = origDateProfile;
        };
      } else {
        return function () {};
      }
    },
    setDateMutation: function setDateMutation(dateMutation) {
      if (dateMutation && !dateMutation.isEmpty()) {
        this.dateMutation = dateMutation;
      } else {
        this.dateMutation = null;
      }
    },
    isEmpty: function isEmpty() {
      return !this.dateMutation;
    }
  });

  EventDefMutation.createFromRawProps = function (eventInstance, rawProps, largeUnit) {
    var eventDef = eventInstance.def;
    var dateProps = {};
    var standardProps = {};
    var miscProps = {};
    var verbatimStandardProps = {};
    var eventDefId = null;
    var className = null;
    var propName;
    var dateProfile;
    var dateMutation;
    var defMutation;

    for (propName in rawProps) {
      if (EventDateProfile.isStandardProp(propName)) {
        dateProps[propName] = rawProps[propName];
      } else if (eventDef.isStandardProp(propName)) {
        standardProps[propName] = rawProps[propName];
      } else if (eventDef.miscProps[propName] !== rawProps[propName]) {
        // only if changed
        miscProps[propName] = rawProps[propName];
      }
    }

    dateProfile = EventDateProfile.parse(dateProps, eventDef.source);

    if (dateProfile) {
      // no failure?
      dateMutation = EventDefDateMutation.createFromDiff(eventInstance.dateProfile, dateProfile, largeUnit);
    }

    if (standardProps.id !== eventDef.id) {
      eventDefId = standardProps.id; // only apply if there's a change
    }

    if (!isArraysEqual(standardProps.className, eventDef.className)) {
      className = standardProps.className; // only apply if there's a change
    }

    EventDef.copyVerbatimStandardProps(standardProps, // src
    verbatimStandardProps // dest
    );
    defMutation = new EventDefMutation();
    defMutation.eventDefId = eventDefId;
    defMutation.className = className;
    defMutation.verbatimStandardProps = verbatimStandardProps;
    defMutation.miscProps = miscProps;

    if (dateMutation) {
      defMutation.dateMutation = dateMutation;
    }

    return defMutation;
  };

  var EventDefDateMutation = Class.extend({
    clearEnd: false,
    forceTimed: false,
    forceAllDay: false,
    // Durations. if 0-ms duration, will be null instead.
    // Callers should not set this directly.
    dateDelta: null,
    startDelta: null,
    endDelta: null,

    /*
    returns an undo function.
    */
    buildNewDateProfile: function buildNewDateProfile(eventDateProfile, calendar) {
      var start = eventDateProfile.start.clone();
      var end = null;
      var shouldRezone = false;

      if (eventDateProfile.end && !this.clearEnd) {
        end = eventDateProfile.end.clone();
      } // if there will be an end-date mutation, guarantee an end,
      // ambigously-zoned according to the original allDay
      else if (this.endDelta && !end) {
        end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
      }

      if (this.forceTimed) {
        shouldRezone = true;

        if (!start.hasTime()) {
          start.time(0);
        }

        if (end && !end.hasTime()) {
          end.time(0);
        }
      } else if (this.forceAllDay) {
        if (start.hasTime()) {
          start.stripTime();
        }

        if (end && end.hasTime()) {
          end.stripTime();
        }
      }

      if (this.dateDelta) {
        shouldRezone = true;
        start.add(this.dateDelta);

        if (end) {
          end.add(this.dateDelta);
        }
      } // do this before adding startDelta to start, so we can work off of start


      if (this.endDelta) {
        shouldRezone = true;
        end.add(this.endDelta);
      }

      if (this.startDelta) {
        shouldRezone = true;
        start.add(this.startDelta);
      }

      if (shouldRezone) {
        start = calendar.applyTimezone(start);

        if (end) {
          end = calendar.applyTimezone(end);
        }
      } // TODO: okay to access calendar option?


      if (!end && calendar.opt("forceEventDuration")) {
        end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
      }

      return new EventDateProfile(start, end, calendar);
    },
    setDateDelta: function setDateDelta(dateDelta) {
      if (dateDelta && dateDelta.valueOf()) {
        this.dateDelta = dateDelta;
      } else {
        this.dateDelta = null;
      }
    },
    setStartDelta: function setStartDelta(startDelta) {
      if (startDelta && startDelta.valueOf()) {
        this.startDelta = startDelta;
      } else {
        this.startDelta = null;
      }
    },
    setEndDelta: function setEndDelta(endDelta) {
      if (endDelta && endDelta.valueOf()) {
        this.endDelta = endDelta;
      } else {
        this.endDelta = null;
      }
    },
    isEmpty: function isEmpty() {
      return !this.clearEnd && !this.forceTimed && !this.forceAllDay && !this.dateDelta && !this.startDelta && !this.endDelta;
    }
  });

  EventDefDateMutation.createFromDiff = function (dateProfile0, dateProfile1, largeUnit) {
    var clearEnd = dateProfile0.end && !dateProfile1.end;
    var forceTimed = dateProfile0.isAllDay() && !dateProfile1.isAllDay();
    var forceAllDay = !dateProfile0.isAllDay() && dateProfile1.isAllDay();
    var dateDelta;
    var endDiff;
    var endDelta;
    var mutation; // subtracts the dates in the appropriate way, returning a duration

    function subtractDates(date1, date0) {
      // date1 - date0
      if (largeUnit) {
        return diffByUnit(date1, date0, largeUnit); // poorly named
      } else if (dateProfile1.isAllDay()) {
        return diffDay(date1, date0); // poorly named
      } else {
        return diffDayTime(date1, date0); // poorly named
      }
    }

    dateDelta = subtractDates(dateProfile1.start, dateProfile0.start);

    if (dateProfile1.end) {
      // use unzonedRanges because dateProfile0.end might be null
      endDiff = subtractDates(dateProfile1.unzonedRange.getEnd(), dateProfile0.unzonedRange.getEnd());
      endDelta = endDiff.subtract(dateDelta);
    }

    mutation = new EventDefDateMutation();
    mutation.clearEnd = clearEnd;
    mutation.forceTimed = forceTimed;
    mutation.forceAllDay = forceAllDay;
    mutation.setDateDelta(dateDelta);
    mutation.setEndDelta(endDelta);
    return mutation;
  };

  function eventDefsToEventInstances(eventDefs, unzonedRange) {
    var eventInstances = [];
    var i;

    for (i = 0; i < eventDefs.length; i++) {
      eventInstances.push.apply(eventInstances, // append
      eventDefs[i].buildInstances(unzonedRange));
    }

    return eventInstances;
  }

  function eventInstanceToEventRange(eventInstance) {
    return new EventRange(eventInstance.dateProfile.unzonedRange, eventInstance.def, eventInstance);
  }

  function eventRangeToEventFootprint(eventRange) {
    return new EventFootprint(new ComponentFootprint(eventRange.unzonedRange, eventRange.eventDef.isAllDay()), eventRange.eventDef, eventRange.eventInstance // might not exist
    );
  }

  function eventInstanceToUnzonedRange(eventInstance) {
    return eventInstance.dateProfile.unzonedRange;
  }

  function eventFootprintToComponentFootprint(eventFootprint) {
    return eventFootprint.componentFootprint;
  }

  var EventSource = Class.extend(ParsableModelMixin, {
    calendar: null,
    id: null,
    // can stay null
    uid: null,
    color: null,
    backgroundColor: null,
    borderColor: null,
    textColor: null,
    className: null,
    // array
    editable: null,
    startEditable: null,
    durationEditable: null,
    rendering: null,
    overlap: null,
    constraint: null,
    allDayDefault: null,
    eventDataTransform: null,
    // optional function
    // can we do away with calendar? at least for the abstract?
    // useful for buildEventDef
    constructor: function constructor(calendar) {
      this.calendar = calendar;
      this.className = [];
      this.uid = String(EventSource.uuid++);
    },
    fetch: function fetch(start, end, timezone) {// subclasses must implement. must return a promise.
    },
    removeEventDefsById: function removeEventDefsById(eventDefId) {// optional for subclasses to implement
    },
    removeAllEventDefs: function removeAllEventDefs() {// optional for subclasses to implement
    },

    /*
    For compairing/matching
    */
    getPrimitive: function getPrimitive(otherSource) {// subclasses must implement
    },
    parseEventDefs: function parseEventDefs(rawEventDefs) {
      var i;
      var eventDef;
      var eventDefs = [];

      for (i = 0; i < rawEventDefs.length; i++) {
        eventDef = this.parseEventDef(rawEventDefs[i]);

        if (eventDef) {
          eventDefs.push(eventDef);
        }
      }

      return eventDefs;
    },
    parseEventDef: function parseEventDef(rawInput) {
      var calendarTransform = this.calendar.opt("eventDataTransform");
      var sourceTransform = this.eventDataTransform;

      if (calendarTransform) {
        rawInput = calendarTransform(rawInput);
      }

      if (sourceTransform) {
        rawInput = sourceTransform(rawInput);
      }

      return EventDefParser.parse(rawInput, this);
    },
    applyManualStandardProps: function applyManualStandardProps(rawProps) {
      if (rawProps.id != null) {
        this.id = EventSource.normalizeId(rawProps.id);
      } // TODO: converge with EventDef


      if ($.isArray(rawProps.className)) {
        this.className = rawProps.className;
      } else if (typeof rawProps.className === "string") {
        this.className = rawProps.className.split(/\s+/);
      }

      return true;
    }
  }); // finish initializing the mixin

  EventSource.defineStandardProps = ParsableModelMixin_defineStandardProps; // IDs
  // ---------------------------------------------------------------------------------------------------------------------
  // TODO: converge with EventDef

  EventSource.uuid = 0;

  EventSource.normalizeId = function (id) {
    if (id) {
      return String(id);
    }

    return null;
  }; // Parsing
  // ---------------------------------------------------------------------------------------------------------------------


  EventSource.defineStandardProps({
    // manually process...
    id: false,
    className: false,
    // automatically transfer...
    color: true,
    backgroundColor: true,
    borderColor: true,
    textColor: true,
    editable: true,
    startEditable: true,
    durationEditable: true,
    rendering: true,
    overlap: true,
    constraint: true,
    allDayDefault: true,
    eventDataTransform: true
  });
  /*
  rawInput can be any data type!
  */

  EventSource.parse = function (rawInput, calendar) {
    var source = new this(calendar);

    if (_typeof(rawInput) === "object") {
      if (source.applyProps(rawInput)) {
        return source;
      }
    }

    return false;
  };

  FC.EventSource = EventSource;
  var EventSourceParser = {
    sourceClasses: [],
    registerClass: function registerClass(EventSourceClass) {
      this.sourceClasses.unshift(EventSourceClass); // give highest priority
    },
    parse: function parse(rawInput, calendar) {
      var sourceClasses = this.sourceClasses;
      var i;
      var eventSource;

      for (i = 0; i < sourceClasses.length; i++) {
        eventSource = sourceClasses[i].parse(rawInput, calendar);

        if (eventSource) {
          return eventSource;
        }
      }
    }
  };
  FC.EventSourceParser = EventSourceParser;
  var ArrayEventSource = EventSource.extend({
    rawEventDefs: null,
    // unparsed
    eventDefs: null,
    currentTimezone: null,
    constructor: function constructor(calendar) {
      EventSource.apply(this, arguments); // super-constructor

      this.eventDefs = []; // for if setRawEventDefs is never called
    },
    setRawEventDefs: function setRawEventDefs(rawEventDefs) {
      this.rawEventDefs = rawEventDefs;
      this.eventDefs = this.parseEventDefs(rawEventDefs);
    },
    fetch: function fetch(start, end, timezone) {
      var eventDefs = this.eventDefs;
      var i;

      if (this.currentTimezone !== null && this.currentTimezone !== timezone) {
        for (i = 0; i < eventDefs.length; i++) {
          if (eventDefs[i] instanceof SingleEventDef) {
            eventDefs[i].rezone();
          }
        }
      }

      this.currentTimezone = timezone;
      return Promise.resolve(eventDefs);
    },
    addEventDef: function addEventDef(eventDef) {
      this.eventDefs.push(eventDef);
    },

    /*
    eventDefId already normalized to a string
    */
    removeEventDefsById: function removeEventDefsById(eventDefId) {
      return removeMatching(this.eventDefs, function (eventDef) {
        return eventDef.id === eventDefId;
      });
    },
    removeAllEventDefs: function removeAllEventDefs() {
      this.eventDefs = [];
    },
    getPrimitive: function getPrimitive() {
      return this.rawEventDefs;
    },
    applyManualStandardProps: function applyManualStandardProps(rawProps) {
      var superSuccess = EventSource.prototype.applyManualStandardProps.apply(this, arguments);
      this.setRawEventDefs(rawProps.events);
      return superSuccess;
    }
  });
  ArrayEventSource.defineStandardProps({
    events: false // don't automatically transfer

  });

  ArrayEventSource.parse = function (rawInput, calendar) {
    var rawProps; // normalize raw input

    if ($.isArray(rawInput.events)) {
      // extended form
      rawProps = rawInput;
    } else if ($.isArray(rawInput)) {
      // short form
      rawProps = {
        events: rawInput
      };
    }

    if (rawProps) {
      return EventSource.parse.call(this, rawProps, calendar);
    }

    return false;
  };

  EventSourceParser.registerClass(ArrayEventSource);
  FC.ArrayEventSource = ArrayEventSource;
  var FuncEventSource = EventSource.extend({
    func: null,
    fetch: function fetch(start, end, timezone) {
      var _this = this;

      this.calendar.pushLoading();
      return Promise.construct(function (onResolve) {
        _this.func.call(_this.calendar, start.clone(), end.clone(), timezone, function (rawEventDefs) {
          _this.calendar.popLoading();

          onResolve(_this.parseEventDefs(rawEventDefs));
        });
      });
    },
    getPrimitive: function getPrimitive() {
      return this.func;
    },
    applyManualStandardProps: function applyManualStandardProps(rawProps) {
      var superSuccess = EventSource.prototype.applyManualStandardProps.apply(this, arguments);
      this.func = rawProps.events;
      return superSuccess;
    }
  });
  FuncEventSource.defineStandardProps({
    events: false // don't automatically transfer

  });

  FuncEventSource.parse = function (rawInput, calendar) {
    var rawProps; // normalize raw input

    if ($.isFunction(rawInput.events)) {
      // extended form
      rawProps = rawInput;
    } else if ($.isFunction(rawInput)) {
      // short form
      rawProps = {
        events: rawInput
      };
    }

    if (rawProps) {
      return EventSource.parse.call(this, rawProps, calendar);
    }

    return false;
  };

  EventSourceParser.registerClass(FuncEventSource);
  FC.FuncEventSource = FuncEventSource;
  var JsonFeedEventSource = EventSource.extend({
    // these props must all be manually set before calling fetch
    url: null,
    startParam: null,
    endParam: null,
    timezoneParam: null,
    ajaxSettings: null,
    // does not include url
    fetch: function fetch(start, end, timezone) {
      var _this = this;

      var ajaxSettings = this.ajaxSettings;
      var onSuccess = ajaxSettings.success;
      var onError = ajaxSettings.error;
      var requestParams = this.buildRequestParams(start, end, timezone); // todo: eventually handle the promise's then,
      // don't intercept success/error
      // tho will be a breaking API change

      this.calendar.pushLoading();
      return Promise.construct(function (onResolve, onReject) {
        $.ajax($.extend({}, // destination
        JsonFeedEventSource.AJAX_DEFAULTS, ajaxSettings, {
          url: _this.url,
          data: requestParams,
          success: function success(rawEventDefs) {
            var callbackRes;

            _this.calendar.popLoading();

            if (rawEventDefs) {
              callbackRes = applyAll(onSuccess, this, arguments); // redirect `this`

              if ($.isArray(callbackRes)) {
                rawEventDefs = callbackRes;
              }

              onResolve(_this.parseEventDefs(rawEventDefs));
            } else {
              onReject();
            }
          },
          error: function error() {
            _this.calendar.popLoading();

            applyAll(onError, this, arguments); // redirect `this`

            onReject();
          }
        }));
      });
    },
    buildRequestParams: function buildRequestParams(start, end, timezone) {
      var calendar = this.calendar;
      var ajaxSettings = this.ajaxSettings;
      var startParam, endParam, timezoneParam;
      var customRequestParams;
      var params = {};
      startParam = this.startParam;

      if (startParam == null) {
        startParam = calendar.opt("startParam");
      }

      endParam = this.endParam;

      if (endParam == null) {
        endParam = calendar.opt("endParam");
      }

      timezoneParam = this.timezoneParam;

      if (timezoneParam == null) {
        timezoneParam = calendar.opt("timezoneParam");
      } // retrieve any outbound GET/POST $.ajax data from the options


      if ($.isFunction(ajaxSettings.data)) {
        // supplied as a function that returns a key/value object
        customRequestParams = ajaxSettings.data();
      } else {
        // probably supplied as a straight key/value object
        customRequestParams = ajaxSettings.data || {};
      }

      $.extend(params, customRequestParams);
      params[startParam] = start.format();
      params[endParam] = end.format();

      if (timezone && timezone !== "local") {
        params[timezoneParam] = timezone;
      }

      return params;
    },
    getPrimitive: function getPrimitive() {
      return this.url;
    },
    applyMiscProps: function applyMiscProps(rawProps) {
      EventSource.prototype.applyMiscProps.apply(this, arguments);
      this.ajaxSettings = rawProps;
    }
  });
  JsonFeedEventSource.AJAX_DEFAULTS = {
    dataType: "json",
    cache: false
  };
  JsonFeedEventSource.defineStandardProps({
    // automatically transfer (true)...
    url: true,
    startParam: true,
    endParam: true,
    timezoneParam: true
  });

  JsonFeedEventSource.parse = function (rawInput, calendar) {
    var rawProps; // normalize raw input

    if (typeof rawInput.url === "string") {
      // extended form
      rawProps = rawInput;
    } else if (typeof rawInput === "string") {
      // short form
      rawProps = {
        url: rawInput
      };
    }

    if (rawProps) {
      return EventSource.parse.call(this, rawProps, calendar);
    }

    return false;
  };

  EventSourceParser.registerClass(JsonFeedEventSource);
  FC.JsonFeedEventSource = JsonFeedEventSource;
  var ThemeRegistry = FC.ThemeRegistry = {
    themeClassHash: {},
    register: function register(themeName, themeClass) {
      this.themeClassHash[themeName] = themeClass;
    },
    getThemeClass: function getThemeClass(themeSetting) {
      if (!themeSetting) {
        return StandardTheme;
      } else if (themeSetting === true) {
        return JqueryUiTheme;
      } else {
        return this.themeClassHash[themeSetting];
      }
    }
  };
  var Theme = FC.Theme = Class.extend({
    classes: {},
    iconClasses: {},
    baseIconClass: "",
    iconOverrideOption: null,
    iconOverrideCustomButtonOption: null,
    iconOverridePrefix: "",
    constructor: function constructor(optionsModel) {
      this.optionsModel = optionsModel;
      this.processIconOverride();
    },
    processIconOverride: function processIconOverride() {
      if (this.iconOverrideOption) {
        this.setIconOverride(this.optionsModel.get(this.iconOverrideOption));
      }
    },
    setIconOverride: function setIconOverride(iconOverrideHash) {
      var iconClassesCopy;
      var buttonName;

      if ($.isPlainObject(iconOverrideHash)) {
        iconClassesCopy = $.extend({}, this.iconClasses);

        for (buttonName in iconOverrideHash) {
          iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
        }

        this.iconClasses = iconClassesCopy;
      } else if (iconOverrideHash === false) {
        this.iconClasses = {};
      }
    },
    applyIconOverridePrefix: function applyIconOverridePrefix(className) {
      var prefix = this.iconOverridePrefix;

      if (prefix && className.indexOf(prefix) !== 0) {
        // if not already present
        className = prefix + className;
      }

      return className;
    },
    getClass: function getClass(key) {
      return this.classes[key] || "";
    },
    getIconClass: function getIconClass(buttonName) {
      var className = this.iconClasses[buttonName];

      if (className) {
        return this.baseIconClass + " " + className;
      }

      return "";
    },
    getCustomButtonIconClass: function getCustomButtonIconClass(customButtonProps) {
      var className;

      if (this.iconOverrideCustomButtonOption) {
        className = customButtonProps[this.iconOverrideCustomButtonOption];

        if (className) {
          return this.baseIconClass + " " + this.applyIconOverridePrefix(className);
        }
      }

      return "";
    }
  });
  var StandardTheme = Theme.extend({
    classes: {
      widget: "fc-unthemed",
      widgetHeader: "fc-widget-header",
      widgetContent: "fc-widget-content",
      buttonGroup: "fc-button-group",
      button: "fc-button",
      cornerLeft: "fc-corner-left",
      cornerRight: "fc-corner-right",
      stateDefault: "fc-state-default",
      stateActive: "fc-state-active",
      stateDisabled: "fc-state-disabled",
      stateHover: "fc-state-hover",
      stateDown: "fc-state-down",
      popoverHeader: "fc-widget-header",
      popoverContent: "fc-widget-content",
      // day grid
      headerRow: "fc-widget-header",
      dayRow: "fc-widget-content",
      // list view
      listView: "fc-widget-content"
    },
    baseIconClass: "fc-icon",
    iconClasses: {
      close: "fc-icon-x",
      prev: "fa fa-caret-left",
      next: "fa fa-caret-right",
      prevYear: "fc-icon-left-double-arrow",
      nextYear: "fc-icon-right-double-arrow"
    },
    iconOverrideOption: "buttonIcons",
    iconOverrideCustomButtonOption: "icon",
    iconOverridePrefix: "fc-icon-"
  });
  ThemeRegistry.register("standard", StandardTheme);
  var JqueryUiTheme = Theme.extend({
    classes: {
      widget: "ui-widget",
      widgetHeader: "ui-widget-header",
      widgetContent: "ui-widget-content",
      buttonGroup: "fc-button-group",
      button: "ui-button",
      cornerLeft: "ui-corner-left",
      cornerRight: "ui-corner-right",
      stateDefault: "ui-state-default",
      stateActive: "ui-state-active",
      stateDisabled: "ui-state-disabled",
      stateHover: "ui-state-hover",
      stateDown: "ui-state-down",
      today: "ui-state-highlight",
      holiday: "ui-state-highlight",
      popoverHeader: "ui-widget-header",
      popoverContent: "ui-widget-content",
      // day grid
      headerRow: "ui-widget-header",
      dayRow: "ui-widget-content",
      // list view
      listView: "ui-widget-content"
    },
    baseIconClass: "ui-icon",
    iconClasses: {
      close: "ui-icon-closethick",
      prev: "ui-icon-circle-triangle-w",
      next: "ui-icon-circle-triangle-e",
      prevYear: "ui-icon-seek-prev",
      nextYear: "ui-icon-seek-next"
    },
    iconOverrideOption: "themeButtonIcons",
    iconOverrideCustomButtonOption: "themeIcon",
    iconOverridePrefix: "ui-icon-"
  });
  ThemeRegistry.register("jquery-ui", JqueryUiTheme);
  var BootstrapTheme = Theme.extend({
    classes: {
      widget: "fc-bootstrap3",
      tableGrid: "table-bordered",
      // avoid `table` class b/c don't want margins. only border color
      tableList: "table table-striped",
      // `table` class creates bottom margin but who cares
      buttonGroup: "btn-group",
      button: "btn btn-default",
      stateActive: "active",
      stateDisabled: "disabled",
      today: "alert alert-info",
      // the plain `info` class requires `.table`, too much to ask
      holiday: "alert alert-info",
      popover: "panel panel-default",
      popoverHeader: "panel-heading",
      popoverContent: "panel-body",
      // day grid
      headerRow: "panel-default",
      // avoid `panel` class b/c don't want margins/radius. only border color
      dayRow: "panel-default",
      // "
      // list view
      listView: "panel panel-default"
    },
    baseIconClass: "glyphicon",
    iconClasses: {
      close: "glyphicon-remove",
      prev: "glyphicon-chevron-left",
      next: "glyphicon-chevron-right",
      prevYear: "glyphicon-backward",
      nextYear: "glyphicon-forward"
    },
    iconOverrideOption: "bootstrapGlyphicons",
    iconOverrideCustomButtonOption: "bootstrapGlyphicon",
    iconOverridePrefix: "glyphicon-"
  });
  ThemeRegistry.register("bootstrap3", BootstrapTheme);
  var DayGridFillRenderer = FillRenderer.extend({
    fillSegTag: "td",
    // override the default tag name
    attachSegEls: function attachSegEls(type, segs) {
      var nodes = [];
      var i, seg;
      var skeletonEl;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        skeletonEl = this.renderFillRow(type, seg);
        this.component.rowEls.eq(seg.row).append(skeletonEl);
        nodes.push(skeletonEl[0]);
      }

      return nodes;
    },
    // Generates the HTML needed for one row of a fill. Requires the seg's el to be rendered.
    renderFillRow: function renderFillRow(type, seg) {
      var colCnt = this.component.colCnt;
      var startCol = seg.leftCol;
      var endCol = seg.rightCol + 1;
      var className;
      var skeletonEl;
      var trEl;

      if (type === "businessHours") {
        className = "bgevent";
      } else {
        className = type.toLowerCase();
      }

      skeletonEl = $('<div class="fc-' + className + '-skeleton">' + "<table><tr/></table>" + "</div>");
      trEl = skeletonEl.find("tr");

      if (startCol > 0) {
        trEl.append('<td colspan="' + startCol + '"/>');
      }

      trEl.append(seg.el.attr("colspan", endCol - startCol));

      if (endCol < colCnt) {
        trEl.append('<td colspan="' + (colCnt - endCol) + '"/>');
      }

      this.component.bookendCells(trEl);
      return skeletonEl;
    }
  });
  /* Event-rendering methods for the DayGrid class
  ----------------------------------------------------------------------------------------------------------------------*/

  var DayGridEventRenderer = EventRenderer.extend({
    dayGrid: null,
    rowStructs: null,
    // an array of objects, each holding information about a row's foreground event-rendering
    constructor: function constructor(dayGrid) {
      EventRenderer.apply(this, arguments);
      this.dayGrid = dayGrid;
    },
    renderBgRanges: function renderBgRanges(eventRanges) {
      // don't render timed background events
      eventRanges = $.grep(eventRanges, function (eventRange) {
        return eventRange.eventDef.isAllDay();
      });
      EventRenderer.prototype.renderBgRanges.call(this, eventRanges);
    },
    // Renders the given foreground event segments onto the grid
    renderFgSegs: function renderFgSegs(segs) {
      var rowStructs = this.rowStructs = this.renderSegRows(segs); // append to each row's content skeleton

      this.dayGrid.rowEls.each(function (i, rowNode) {
        $(rowNode).find(".fc-content-skeleton > table").append(rowStructs[i].tbodyEl);
      });
    },
    // Unrenders all currently rendered foreground event segments
    unrenderFgSegs: function unrenderFgSegs() {
      var rowStructs = this.rowStructs || [];
      var rowStruct;

      while (rowStruct = rowStructs.pop()) {
        rowStruct.tbodyEl.remove();
      }

      this.rowStructs = null;
    },
    // Uses the given events array to generate <tbody> elements that should be appended to each row's content skeleton.
    // Returns an array of rowStruct objects (see the bottom of `renderSegRow`).
    // PRECONDITION: each segment shoud already have a rendered and assigned `.el`
    renderSegRows: function renderSegRows(segs) {
      var rowStructs = [];
      var segRows;
      var row;
      segRows = this.groupSegRows(segs); // group into nested arrays
      // iterate each row of segment groupings

      for (row = 0; row < segRows.length; row++) {
        rowStructs.push(this.renderSegRow(row, segRows[row]));
      }

      return rowStructs;
    },
    // Given a row # and an array of segments all in the same row, render a <tbody> element, a skeleton that contains
    // the segments. Returns object with a bunch of internal data about how the render was calculated.
    // NOTE: modifies rowSegs
    renderSegRow: function renderSegRow(row, rowSegs) {
      var colCnt = this.dayGrid.colCnt;
      var segLevels = this.buildSegLevels(rowSegs); // group into sub-arrays of levels

      var levelCnt = Math.max(1, segLevels.length); // ensure at least one level

      var tbody = $("<tbody/>");
      var segMatrix = []; // lookup for which segments are rendered into which level+col cells

      var cellMatrix = []; // lookup for all <td> elements of the level+col matrix

      var loneCellMatrix = []; // lookup for <td> elements that only take up a single column

      var i, levelSegs;
      var col;
      var tr;
      var j, seg;
      var td; // populates empty cells from the current column (`col`) to `endCol`

      function emptyCellsUntil(endCol) {
        while (col < endCol) {
          // try to grab a cell from the level above and extend its rowspan. otherwise, create a fresh cell
          td = (loneCellMatrix[i - 1] || [])[col];

          if (td) {
            td.attr("rowspan", parseInt(td.attr("rowspan") || 1, 10) + 1);
          } else {
            td = $("<td/>");
            tr.append(td);
          }

          cellMatrix[i][col] = td;
          loneCellMatrix[i][col] = td;
          col++;
        }
      }

      for (i = 0; i < levelCnt; i++) {
        // iterate through all levels
        levelSegs = segLevels[i];
        col = 0;
        tr = $("<tr/>");
        segMatrix.push([]);
        cellMatrix.push([]);
        loneCellMatrix.push([]); // levelCnt might be 1 even though there are no actual levels. protect against this.
        // this single empty row is useful for styling.

        if (levelSegs) {
          for (j = 0; j < levelSegs.length; j++) {
            // iterate through segments in level
            seg = levelSegs[j];
            emptyCellsUntil(seg.leftCol); // create a container that occupies or more columns. append the event element.

            td = $('<td class="fc-event-container"/>').append(seg.el);

            if (seg.leftCol != seg.rightCol) {
              td.attr("colspan", seg.rightCol - seg.leftCol + 1);
            } else {
              // a single-column segment
              loneCellMatrix[i][col] = td;
            }

            while (col <= seg.rightCol) {
              cellMatrix[i][col] = td;
              segMatrix[i][col] = seg;
              col++;
            }

            tr.append(td);
          }
        }

        emptyCellsUntil(colCnt); // finish off the row

        this.dayGrid.bookendCells(tr);
        tbody.append(tr);
      }

      return {
        // a "rowStruct"
        row: row,
        // the row number
        tbodyEl: tbody,
        cellMatrix: cellMatrix,
        segMatrix: segMatrix,
        segLevels: segLevels,
        segs: rowSegs
      };
    },
    // Stacks a flat array of segments, which are all assumed to be in the same row, into subarrays of vertical levels.
    // NOTE: modifies segs
    buildSegLevels: function buildSegLevels(segs) {
      var levels = [];
      var i, seg;
      var j; // Give preference to elements with certain criteria, so they have
      // a chance to be closer to the top.

      this.sortEventSegs(segs);

      for (i = 0; i < segs.length; i++) {
        seg = segs[i]; // loop through levels, starting with the topmost, until the segment doesn't collide with other segments

        for (j = 0; j < levels.length; j++) {
          if (!isDaySegCollision(seg, levels[j])) {
            break;
          }
        } // `j` now holds the desired subrow index


        seg.level = j; // create new level array if needed and append segment

        (levels[j] || (levels[j] = [])).push(seg);
      } // order segments left-to-right. very important if calendar is RTL


      for (j = 0; j < levels.length; j++) {
        levels[j].sort(compareDaySegCols);
      }

      return levels;
    },
    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's row
    groupSegRows: function groupSegRows(segs) {
      var segRows = [];
      var i;

      for (i = 0; i < this.dayGrid.rowCnt; i++) {
        segRows.push([]);
      }

      for (i = 0; i < segs.length; i++) {
        segRows[segs[i].row].push(segs[i]);
      }

      return segRows;
    },
    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
    computeEventTimeFormat: function computeEventTimeFormat() {
      return this.opt("extraSmallTimeFormat"); // like "6p" or "6:30p"
    },
    // Computes a default `displayEventEnd` value if one is not expliclty defined
    computeDisplayEventEnd: function computeDisplayEventEnd() {
      return this.dayGrid.colCnt === 1; // we'll likely have space if there's only one day
    },
    // Builds the HTML to be used for the default element for an individual segment
    fgSegHtml: function fgSegHtml(seg, disableResizing) {
      var view = this.view;
      var eventDef = seg.footprint.eventDef;
      var isAllDay = seg.footprint.componentFootprint.isAllDay;
      var isDraggable = view.isEventDefDraggable(eventDef);
      var isResizableFromStart = !disableResizing && isAllDay && seg.isStart && view.isEventDefResizableFromStart(eventDef);
      var isResizableFromEnd = !disableResizing && isAllDay && seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
      var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
      var skinCss = cssToStr(this.getSkinCss(eventDef));
      var timeHtml = "";
      var timeText;
      var titleHtml;
      classes.unshift("fc-day-grid-event", "fc-h-event"); // Only display a timed events time if it is the starting segment

      if (seg.isStart) {
        timeText = this.getTimeText(seg.footprint);

        if (timeText) {
          timeHtml = '<span class="fc-time">' + htmlEscape(timeText) + "</span>";
        }
      }

      titleHtml = '<span class="fc-title">' + (htmlEscape(eventDef.title || "") || "&nbsp;") + // we always want one line of height
      "</span>";
      return '<a class="' + classes.join(" ") + '"' + (eventDef.url ? ' href="' + htmlEscape(eventDef.url) + '"' : "") + (skinCss ? ' style="' + skinCss + '"' : "") + ">" + '<div class="fc-content">' + (this.isRTL ? titleHtml + " " + timeHtml // put a natural space in between
      : timeHtml + " " + titleHtml) + //
      "</div>" + (isResizableFromStart ? '<div class="fc-resizer fc-start-resizer" />' : "") + (isResizableFromEnd ? '<div class="fc-resizer fc-end-resizer" />' : "") + "</a>";
    }
  }); // Computes whether two segments' columns collide. They are assumed to be in the same row.

  function isDaySegCollision(seg, otherSegs) {
    var i, otherSeg;

    for (i = 0; i < otherSegs.length; i++) {
      otherSeg = otherSegs[i];

      if (otherSeg.leftCol <= seg.rightCol && otherSeg.rightCol >= seg.leftCol) {
        return true;
      }
    }

    return false;
  } // A cmp function for determining the leftmost event


  function compareDaySegCols(a, b) {
    return a.leftCol - b.leftCol;
  }

  var DayGridHelperRenderer = HelperRenderer.extend({
    // Renders a mock "helper" event. `sourceSeg` is the associated internal segment object. It can be null.
    renderSegs: function renderSegs(segs, sourceSeg) {
      var helperNodes = [];
      var rowStructs; // TODO: not good to call eventRenderer this way

      rowStructs = this.eventRenderer.renderSegRows(segs); // inject each new event skeleton into each associated row

      this.component.rowEls.each(function (row, rowNode) {
        var rowEl = $(rowNode); // the .fc-row

        var skeletonEl = $('<div class="fc-helper-skeleton"><table/></div>'); // will be absolutely positioned

        var skeletonTopEl;
        var skeletonTop; // If there is an original segment, match the top position. Otherwise, put it at the row's top level

        if (sourceSeg && sourceSeg.row === row) {
          skeletonTop = sourceSeg.el.position().top;
        } else {
          skeletonTopEl = rowEl.find(".fc-content-skeleton tbody");

          if (!skeletonTopEl.length) {
            // when no events
            skeletonTopEl = rowEl.find(".fc-content-skeleton table");
          }

          skeletonTop = skeletonTopEl.position().top;
        }

        skeletonEl.css("top", skeletonTop).find("table").append(rowStructs[row].tbodyEl);
        rowEl.append(skeletonEl);
        helperNodes.push(skeletonEl[0]);
      });
      return $(helperNodes); // must return the elements rendered
    }
  });
  /* A component that renders a grid of whole-days that runs horizontally. There can be multiple rows, one per week.
  ----------------------------------------------------------------------------------------------------------------------*/

  var DayGrid = FC.DayGrid = InteractiveDateComponent.extend(StandardInteractionsMixin, DayTableMixin, {
    eventRendererClass: DayGridEventRenderer,
    businessHourRendererClass: BusinessHourRenderer,
    helperRendererClass: DayGridHelperRenderer,
    fillRendererClass: DayGridFillRenderer,
    view: null,
    // TODO: make more general and/or remove
    helperRenderer: null,
    cellWeekNumbersVisible: false,
    // display week numbers in day cell?
    bottomCoordPadding: 0,
    // hack for extending the hit area for the last row of the coordinate grid
    headContainerEl: null,
    // div that hold's the date header
    rowEls: null,
    // set of fake row elements
    cellEls: null,
    // set of whole-day elements comprising the row's background
    rowCoordCache: null,
    colCoordCache: null,
    // isRigid determines whether the individual rows should ignore the contents and be a constant height.
    // Relies on the view's colCnt and rowCnt. In the future, this component should probably be self-sufficient.
    isRigid: false,
    hasAllDayBusinessHours: true,
    constructor: function constructor(view) {
      this.view = view; // do first, for opt calls during initialization

      InteractiveDateComponent.call(this);
    },
    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
    componentFootprintToSegs: function componentFootprintToSegs(componentFootprint) {
      var segs = this.sliceRangeByRow(componentFootprint.unzonedRange);
      var i, seg;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];

        if (this.isRTL) {
          seg.leftCol = this.daysPerRow - 1 - seg.lastRowDayIndex;
          seg.rightCol = this.daysPerRow - 1 - seg.firstRowDayIndex;
        } else {
          seg.leftCol = seg.firstRowDayIndex;
          seg.rightCol = seg.lastRowDayIndex;
        }
      }

      return segs;
    },

    /* Date Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    renderDates: function renderDates(dateProfile) {
      this.dateProfile = dateProfile;
      this.updateDayTable();
      this.renderGrid();
    },
    unrenderDates: function unrenderDates() {
      this.removeSegPopover();
    },
    // Renders the rows and columns into the component's `this.el`, which should already be assigned.
    renderGrid: function renderGrid() {
      var view = this.view;
      var rowCnt = this.rowCnt;
      var colCnt = this.colCnt;
      var html = "";
      var row;
      var col;

      if (this.headContainerEl) {
        this.headContainerEl.html(this.renderHeadHtml());
      }

      for (row = 0; row < rowCnt; row++) {
        html += this.renderDayRowHtml(row, this.isRigid);
      }

      this.el.html(html);
      this.rowEls = this.el.find(".fc-row");
      this.cellEls = this.el.find(".fc-day, .fc-disabled-day");
      this.rowCoordCache = new CoordCache({
        els: this.rowEls,
        isVertical: true
      });
      this.colCoordCache = new CoordCache({
        els: this.cellEls.slice(0, this.colCnt),
        // only the first row
        isHorizontal: true
      }); // trigger dayRender with each cell's element

      for (row = 0; row < rowCnt; row++) {
        for (col = 0; col < colCnt; col++) {
          this.publiclyTrigger("dayRender", {
            context: view,
            args: [this.getCellDate(row, col), this.getCellEl(row, col), view]
          });
        }
      }
    },
    // Generates the HTML for a single row, which is a div that wraps a table.
    // `row` is the row number.
    renderDayRowHtml: function renderDayRowHtml(row, isRigid) {
      var theme = this.view.calendar.theme;
      var classes = ["fc-row", "fc-week", theme.getClass("dayRow")];

      if (isRigid) {
        classes.push("fc-rigid");
      }

      return "" + '<div class="' + classes.join(" ") + '">' + '<div class="fc-bg">' + '<table class="' + theme.getClass("tableGrid") + '">' + this.renderBgTrHtml(row) + "</table>" + "</div>" + '<div class="fc-content-skeleton">' + "<table>" + (this.getIsNumbersVisible() ? "<thead>" + this.renderNumberTrHtml(row) + "</thead>" : "") + "</table>" + "</div>" + "</div>";
    },
    getIsNumbersVisible: function getIsNumbersVisible() {
      return this.getIsDayNumbersVisible() || this.cellWeekNumbersVisible;
    },
    getIsDayNumbersVisible: function getIsDayNumbersVisible() {
      return this.rowCnt > 1;
    },

    /* Grid Number Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    renderNumberTrHtml: function renderNumberTrHtml(row) {
      return "" + "<tr>" + (this.isRTL ? "" : this.renderNumberIntroHtml(row)) + this.renderNumberCellsHtml(row) + (this.isRTL ? this.renderNumberIntroHtml(row) : "") + "</tr>";
    },
    renderNumberIntroHtml: function renderNumberIntroHtml(row) {
      return this.renderIntroHtml();
    },
    renderNumberCellsHtml: function renderNumberCellsHtml(row) {
      var htmls = [];
      var col, date;

      for (col = 0; col < this.colCnt; col++) {
        date = this.getCellDate(row, col);
        htmls.push(this.renderNumberCellHtml(date));
      }

      return htmls.join("");
    },
    // Generates the HTML for the <td>s of the "number" row in the DayGrid's content skeleton.
    // The number row will only exist if either day numbers or week numbers are turned on.
    renderNumberCellHtml: function renderNumberCellHtml(date) {
      var view = this.view;
      var html = "";
      var isDateValid = this.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.

      var isDayNumberVisible = this.getIsDayNumbersVisible() && isDateValid;
      var classes;
      var weekCalcFirstDoW;

      if (!isDayNumberVisible && !this.cellWeekNumbersVisible) {
        // no numbers in day cell (week number must be along the side)
        return "<td/>"; //  will create an empty space above events :(
      }

      classes = this.getDayClasses(date);
      classes.unshift("fc-day-top");

      if (this.cellWeekNumbersVisible) {
        // To determine the day of week number change under ISO, we cannot
        // rely on moment.js methods such as firstDayOfWeek() or weekday(),
        // because they rely on the locale's dow (possibly overridden by
        // our firstDay option), which may not be Monday. We cannot change
        // dow, because that would affect the calendar start day as well.
        if (date._locale._fullCalendar_weekCalc === "ISO") {
          weekCalcFirstDoW = 1; // Monday by ISO 8601 definition
        } else {
          weekCalcFirstDoW = date._locale.firstDayOfWeek();
        }
      }

      html += '<td class="' + classes.join(" ") + '"' + (isDateValid ? ' data-date="' + date.format() + '"' : "") + ">";

      if (this.cellWeekNumbersVisible && date.day() == weekCalcFirstDoW) {
        html += view.buildGotoAnchorHtml({
          date: date,
          type: "week"
        }, {
          "class": "fc-week-number"
        }, date.format("w") // inner HTML
        );
      }

      if (isDayNumberVisible) {
        html += view.buildGotoAnchorHtml(date, {
          "class": "fc-day-number"
        }, date.date() // inner HTML
        );
      }

      html += "</td>";
      return html;
    },

    /* Hit System
    ------------------------------------------------------------------------------------------------------------------*/
    prepareHits: function prepareHits() {
      this.colCoordCache.build();
      this.rowCoordCache.build();
      this.rowCoordCache.bottoms[this.rowCnt - 1] += this.bottomCoordPadding; // hack
    },
    releaseHits: function releaseHits() {
      this.colCoordCache.clear();
      this.rowCoordCache.clear();
    },
    queryHit: function queryHit(leftOffset, topOffset) {
      if (this.colCoordCache.isLeftInBounds(leftOffset) && this.rowCoordCache.isTopInBounds(topOffset)) {
        var col = this.colCoordCache.getHorizontalIndex(leftOffset);
        var row = this.rowCoordCache.getVerticalIndex(topOffset);

        if (row != null && col != null) {
          return this.getCellHit(row, col);
        }
      }
    },
    getHitFootprint: function getHitFootprint(hit) {
      var range = this.getCellRange(hit.row, hit.col);
      return new ComponentFootprint(new UnzonedRange(range.start, range.end), true // all-day?
      );
    },
    getHitEl: function getHitEl(hit) {
      return this.getCellEl(hit.row, hit.col);
    },

    /* Cell System
    ------------------------------------------------------------------------------------------------------------------*/
    // FYI: the first column is the leftmost column, regardless of date
    getCellHit: function getCellHit(row, col) {
      return {
        row: row,
        col: col,
        component: this,
        // needed unfortunately :(
        left: this.colCoordCache.getLeftOffset(col),
        right: this.colCoordCache.getRightOffset(col),
        top: this.rowCoordCache.getTopOffset(row),
        bottom: this.rowCoordCache.getBottomOffset(row)
      };
    },
    getCellEl: function getCellEl(row, col) {
      return this.cellEls.eq(row * this.colCnt + col);
    },

    /* Event Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    // Unrenders all events currently rendered on the grid
    unrenderEvents: function unrenderEvents() {
      this.removeSegPopover(); // removes the "more.." events popover

      InteractiveDateComponent.prototype.unrenderEvents.apply(this, arguments);
    },
    // Retrieves all rendered segment objects currently rendered on the grid
    getOwnEventSegs: function getOwnEventSegs() {
      return InteractiveDateComponent.prototype.getOwnEventSegs.apply(this, arguments) // get the segments from the super-method
      .concat(this.popoverSegs || []); // append the segments from the "more..." popover
    },

    /* Event Drag Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event or external element being dragged.
    // `eventLocation` has zoned start and end (optional)
    renderDrag: function renderDrag(eventFootprints, seg, isTouch) {
      var i;

      for (i = 0; i < eventFootprints.length; i++) {
        this.renderHighlight(eventFootprints[i].componentFootprint);
      } // render drags from OTHER components as helpers


      if (eventFootprints.length && seg && seg.component !== this) {
        this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch);
        return true; // signal helpers rendered
      }
    },
    // Unrenders any visual indication of a hovering event
    unrenderDrag: function unrenderDrag(seg) {
      this.unrenderHighlight();
      this.helperRenderer.unrender();
    },

    /* Event Resize Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being resized
    renderEventResize: function renderEventResize(eventFootprints, seg, isTouch) {
      var i;

      for (i = 0; i < eventFootprints.length; i++) {
        this.renderHighlight(eventFootprints[i].componentFootprint);
      }

      this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
    },
    // Unrenders a visual indication of an event being resized
    unrenderEventResize: function unrenderEventResize(seg) {
      this.unrenderHighlight();
      this.helperRenderer.unrender();
    }
  });
  /* Methods relate to limiting the number events for a given day on a DayGrid
  ----------------------------------------------------------------------------------------------------------------------*/
  // NOTE: all the segs being passed around in here are foreground segs

  DayGrid.mixin({
    segPopover: null,
    // the Popover that holds events that can't fit in a cell. null when not visible
    popoverSegs: null,
    // an array of segment objects that the segPopover holds. null when not visible
    removeSegPopover: function removeSegPopover() {
      if (this.segPopover) {
        this.segPopover.hide(); // in handler, will call segPopover's removeElement
      }
    },
    // Limits the number of "levels" (vertically stacking layers of events) for each row of the grid.
    // `levelLimit` can be false (don't limit), a number, or true (should be computed).
    limitRows: function limitRows(levelLimit) {
      var rowStructs = this.eventRenderer.rowStructs || [];
      var row; // row #

      var rowLevelLimit;

      for (row = 0; row < rowStructs.length; row++) {
        this.unlimitRow(row);

        if (!levelLimit) {
          rowLevelLimit = false;
        } else if (typeof levelLimit === "number") {
          rowLevelLimit = levelLimit;
        } else {
          rowLevelLimit = this.computeRowLevelLimit(row);
        }

        if (rowLevelLimit !== false) {
          this.limitRow(row, rowLevelLimit);
        }
      }
    },
    // Computes the number of levels a row will accomodate without going outside its bounds.
    // Assumes the row is "rigid" (maintains a constant height regardless of what is inside).
    // `row` is the row number.
    computeRowLevelLimit: function computeRowLevelLimit(row) {
      var rowEl = this.rowEls.eq(row); // the containing "fake" row div

      var rowHeight = rowEl.height(); // TODO: cache somehow?

      var trEls = this.eventRenderer.rowStructs[row].tbodyEl.children();
      var i, trEl;
      var trHeight;

      function iterInnerHeights(i, childNode) {
        trHeight = Math.max(trHeight, $(childNode).outerHeight());
      } // Reveal one level <tr> at a time and stop when we find one out of bounds


      for (i = 0; i < trEls.length; i++) {
        trEl = trEls.eq(i).removeClass("fc-limited"); // reset to original state (reveal)
        // with rowspans>1 and IE8, trEl.outerHeight() would return the height of the largest cell,
        // so instead, find the tallest inner content element.

        trHeight = 0;
        trEl.find("> td > :first-child").each(iterInnerHeights);

        if (trEl.position().top + trHeight > rowHeight) {
          return i;
        }
      }

      return false; // should not limit at all
    },
    // Limits the given grid row to the maximum number of levels and injects "more" links if necessary.
    // `row` is the row number.
    // `levelLimit` is a number for the maximum (inclusive) number of levels allowed.
    limitRow: function limitRow(row, levelLimit) {
      var _this = this;

      var rowStruct = this.eventRenderer.rowStructs[row];
      var moreNodes = []; // array of "more" <a> links and <td> DOM nodes

      var col = 0; // col #, left-to-right (not chronologically)

      var levelSegs; // array of segment objects in the last allowable level, ordered left-to-right

      var cellMatrix; // a matrix (by level, then column) of all <td> jQuery elements in the row

      var limitedNodes; // array of temporarily hidden level <tr> and segment <td> DOM nodes

      var i, seg;
      var segsBelow; // array of segment objects below `seg` in the current `col`

      var totalSegsBelow; // total number of segments below `seg` in any of the columns `seg` occupies

      var colSegsBelow; // array of segment arrays, below seg, one for each column (offset from segs's first column)

      var td, rowspan;
      var segMoreNodes; // array of "more" <td> cells that will stand-in for the current seg's cell

      var j;
      var moreTd, moreWrap, moreLink; // Iterates through empty level cells and places "more" links inside if need be

      function emptyCellsUntil(endCol) {
        // goes from current `col` to `endCol`
        while (col < endCol) {
          segsBelow = _this.getCellSegs(row, col, levelLimit);

          if (segsBelow.length) {
            td = cellMatrix[levelLimit - 1][col];
            moreLink = _this.renderMoreLink(row, col, segsBelow);
            moreWrap = $("<div/>").append(moreLink);
            td.append(moreWrap);
            moreNodes.push(moreWrap[0]);
          }

          col++;
        }
      }

      if (levelLimit && levelLimit < rowStruct.segLevels.length) {
        // is it actually over the limit?
        levelSegs = rowStruct.segLevels[levelLimit - 1];
        cellMatrix = rowStruct.cellMatrix;
        limitedNodes = rowStruct.tbodyEl.children().slice(levelLimit) // get level <tr> elements past the limit
        .addClass("fc-limited").get(); // hide elements and get a simple DOM-nodes array
        // iterate though segments in the last allowable level

        for (i = 0; i < levelSegs.length; i++) {
          seg = levelSegs[i];
          emptyCellsUntil(seg.leftCol); // process empty cells before the segment
          // determine *all* segments below `seg` that occupy the same columns

          colSegsBelow = [];
          totalSegsBelow = 0;

          while (col <= seg.rightCol) {
            segsBelow = this.getCellSegs(row, col, levelLimit);
            colSegsBelow.push(segsBelow);
            totalSegsBelow += segsBelow.length;
            col++;
          }

          if (totalSegsBelow) {
            // do we need to replace this segment with one or many "more" links?
            td = cellMatrix[levelLimit - 1][seg.leftCol]; // the segment's parent cell

            rowspan = td.attr("rowspan") || 1;
            segMoreNodes = []; // make a replacement <td> for each column the segment occupies. will be one for each colspan

            for (j = 0; j < colSegsBelow.length; j++) {
              moreTd = $('<td class="fc-more-cell"/>').attr("rowspan", rowspan);
              segsBelow = colSegsBelow[j];
              moreLink = this.renderMoreLink(row, seg.leftCol + j, [seg].concat(segsBelow) // count seg as hidden too
              );
              moreWrap = $("<div/>").append(moreLink);
              moreTd.append(moreWrap);
              segMoreNodes.push(moreTd[0]);
              moreNodes.push(moreTd[0]);
            }

            td.addClass("fc-limited").after($(segMoreNodes)); // hide original <td> and inject replacements

            limitedNodes.push(td[0]);
          }
        }

        emptyCellsUntil(this.colCnt); // finish off the level

        rowStruct.moreEls = $(moreNodes); // for easy undoing later

        rowStruct.limitedEls = $(limitedNodes); // for easy undoing later
      }
    },
    // Reveals all levels and removes all "more"-related elements for a grid's row.
    // `row` is a row number.
    unlimitRow: function unlimitRow(row) {
      var rowStruct = this.eventRenderer.rowStructs[row];

      if (rowStruct.moreEls) {
        rowStruct.moreEls.remove();
        rowStruct.moreEls = null;
      }

      if (rowStruct.limitedEls) {
        rowStruct.limitedEls.removeClass("fc-limited");
        rowStruct.limitedEls = null;
      }
    },
    // Renders an <a> element that represents hidden event element for a cell.
    // Responsible for attaching click handler as well.
    renderMoreLink: function renderMoreLink(row, col, hiddenSegs) {
      var _this = this;

      var view = this.view;
      return $('<a class="fc-more"/>').text(this.getMoreLinkText(hiddenSegs.length)).on("click", function (ev) {
        var clickOption = _this.opt("eventLimitClick");

        var date = _this.getCellDate(row, col);

        var moreEl = $(this);

        var dayEl = _this.getCellEl(row, col);

        var allSegs = _this.getCellSegs(row, col); // rescope the segments to be within the cell's date


        var reslicedAllSegs = _this.resliceDaySegs(allSegs, date);

        var reslicedHiddenSegs = _this.resliceDaySegs(hiddenSegs, date);

        if (typeof clickOption === "function") {
          // the returned value can be an atomic option
          clickOption = _this.publiclyTrigger("eventLimitClick", {
            context: view,
            args: [{
              date: date.clone(),
              dayEl: dayEl,
              moreEl: moreEl,
              segs: reslicedAllSegs,
              hiddenSegs: reslicedHiddenSegs
            }, ev, view]
          });
        }

        if (clickOption === "popover") {
          _this.showSegPopover(row, col, moreEl, reslicedAllSegs);
        } else if (typeof clickOption === "string") {
          // a view name
          view.calendar.zoomTo(date, clickOption);
        }
      });
    },
    // Reveals the popover that displays all events within a cell
    showSegPopover: function showSegPopover(row, col, moreLink, segs) {
      var _this = this;

      var view = this.view;
      var moreWrap = moreLink.parent(); // the <div> wrapper around the <a>

      var topEl; // the element we want to match the top coordinate of

      var options;

      if (this.rowCnt == 1) {
        topEl = view.el; // will cause the popover to cover any sort of header
      } else {
        topEl = this.rowEls.eq(row); // will align with top of row
      }

      options = {
        className: "fc-more-popover " + view.calendar.theme.getClass("popover"),
        content: this.renderSegPopoverContent(row, col, segs),
        parentEl: view.el,
        // attach to root of view. guarantees outside of scrollbars.
        top: topEl.offset().top,
        autoHide: true,
        // when the user clicks elsewhere, hide the popover
        viewportConstrain: this.opt("popoverViewportConstrain"),
        hide: function hide() {
          // kill everything when the popover is hidden
          // notify events to be removed
          if (_this.popoverSegs) {
            _this.triggerBeforeEventSegsDestroyed(_this.popoverSegs);
          }

          _this.segPopover.removeElement();

          _this.segPopover = null;
          _this.popoverSegs = null;
        }
      }; // Determine horizontal coordinate.
      // We use the moreWrap instead of the <td> to avoid border confusion.

      if (this.isRTL) {
        options.right = moreWrap.offset().left + moreWrap.outerWidth() + 1; // +1 to be over cell border
      } else {
        options.left = moreWrap.offset().left - 1; // -1 to be over cell border
      }

      this.segPopover = new Popover(options);
      this.segPopover.show(); // the popover doesn't live within the grid's container element, and thus won't get the event
      // delegated-handlers for free. attach event-related handlers to the popover.

      this.bindAllSegHandlersToEl(this.segPopover.el);
      this.triggerAfterEventSegsRendered(segs);
    },
    // Builds the inner DOM contents of the segment popover
    renderSegPopoverContent: function renderSegPopoverContent(row, col, segs) {
      var view = this.view;
      var theme = view.calendar.theme;
      var title = this.getCellDate(row, col).format(this.opt("dayPopoverFormat"));
      var content = $('<div class="fc-header ' + theme.getClass("popoverHeader") + '">' + '<span class="fc-close ' + theme.getIconClass("close") + '"></span>' + '<span class="fc-title">' + htmlEscape(title) + "</span>" + '<div class="fc-clear"/>' + "</div>" + '<div class="fc-body ' + theme.getClass("popoverContent") + '">' + '<div class="fc-event-container"></div>' + "</div>");
      var segContainer = content.find(".fc-event-container");
      var i; // render each seg's `el` and only return the visible segs

      segs = this.eventRenderer.renderFgSegEls(segs, true); // disableResizing=true

      this.popoverSegs = segs;

      for (i = 0; i < segs.length; i++) {
        // because segments in the popover are not part of a grid coordinate system, provide a hint to any
        // grids that want to do drag-n-drop about which cell it came from
        this.hitsNeeded();
        segs[i].hit = this.getCellHit(row, col);
        this.hitsNotNeeded();
        segContainer.append(segs[i].el);
      }

      return content;
    },
    // Given the events within an array of segment objects, reslice them to be in a single day
    resliceDaySegs: function resliceDaySegs(segs, dayDate) {
      var dayStart = dayDate.clone();
      var dayEnd = dayStart.clone().add(1, "days");
      var dayRange = new UnzonedRange(dayStart, dayEnd);
      var newSegs = [];
      var i, seg;
      var slicedRange;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        slicedRange = seg.footprint.componentFootprint.unzonedRange.intersect(dayRange);

        if (slicedRange) {
          newSegs.push($.extend({}, seg, {
            footprint: new EventFootprint(new ComponentFootprint(slicedRange, seg.footprint.componentFootprint.isAllDay), seg.footprint.eventDef, seg.footprint.eventInstance),
            isStart: seg.isStart && slicedRange.isStart,
            isEnd: seg.isEnd && slicedRange.isEnd
          }));
        }
      } // force an order because eventsToSegs doesn't guarantee one
      // TODO: research if still needed


      this.eventRenderer.sortEventSegs(newSegs);
      return newSegs;
    },
    // Generates the text that should be inside a "more" link, given the number of events it represents
    getMoreLinkText: function getMoreLinkText(num) {
      var opt = this.opt("eventLimitText");

      if (typeof opt === "function") {
        return opt(num);
      } else {
        return "+" + num + " " + opt;
      }
    },
    // Returns segments within a given cell.
    // If `startLevel` is specified, returns only events including and below that level. Otherwise returns all segs.
    getCellSegs: function getCellSegs(row, col, startLevel) {
      var segMatrix = this.eventRenderer.rowStructs[row].segMatrix;
      var level = startLevel || 0;
      var segs = [];
      var seg;

      while (level < segMatrix.length) {
        seg = segMatrix[level][col];

        if (seg) {
          segs.push(seg);
        }

        level++;
      }

      return segs;
    }
  });
  /* An abstract class for the "basic" views, as well as month view. Renders one or more rows of day cells.
  ----------------------------------------------------------------------------------------------------------------------*/
  // It is a manager for a DayGrid subcomponent, which does most of the heavy lifting.
  // It is responsible for managing width/height.

  var BasicView = FC.BasicView = View.extend({
    scroller: null,
    dayGridClass: DayGrid,
    // class the dayGrid will be instantiated from (overridable by subclasses)
    dayGrid: null,
    // the main subcomponent that does most of the heavy lifting
    weekNumberWidth: null,
    // width of all the week-number cells running down the side
    constructor: function constructor() {
      View.apply(this, arguments);
      this.dayGrid = this.instantiateDayGrid();
      this.dayGrid.isRigid = this.hasRigidRows();

      if (this.opt("weekNumbers")) {
        if (this.opt("weekNumbersWithinDays")) {
          this.dayGrid.cellWeekNumbersVisible = true;
          this.dayGrid.colWeekNumbersVisible = false;
        } else {
          this.dayGrid.cellWeekNumbersVisible = false;
          this.dayGrid.colWeekNumbersVisible = true;
        }
      }

      this.addChild(this.dayGrid);
      this.scroller = new Scroller({
        overflowX: "hidden",
        overflowY: "auto"
      });
    },
    // Generates the DayGrid object this view needs. Draws from this.dayGridClass
    instantiateDayGrid: function instantiateDayGrid() {
      // generate a subclass on the fly with BasicView-specific behavior
      // TODO: cache this subclass
      var subclass = this.dayGridClass.extend(basicDayGridMethods);
      return new subclass(this);
    },
    // Computes the date range that will be rendered.
    buildRenderRange: function buildRenderRange(currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
      var renderUnzonedRange = View.prototype.buildRenderRange.apply(this, arguments); // an UnzonedRange

      var start = this.calendar.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
      var end = this.calendar.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay); // year and month views should be aligned with weeks. this is already done for week

      if (/^(year|month)$/.test(currentRangeUnit)) {
        start.startOf("week"); // make end-of-week if not already

        if (end.weekday()) {
          end.add(1, "week").startOf("week"); // exclusively move backwards
        }
      }

      return new UnzonedRange(start, end);
    },
    executeDateRender: function executeDateRender(dateProfile) {
      this.dayGrid.breakOnWeeks = /year|month|week/.test(dateProfile.currentRangeUnit);
      View.prototype.executeDateRender.apply(this, arguments);
    },
    renderSkeleton: function renderSkeleton() {
      var dayGridContainerEl;
      var dayGridEl;
      this.el.addClass("fc-basic-view").html(this.renderSkeletonHtml());
      this.scroller.render();
      dayGridContainerEl = this.scroller.el.addClass("fc-day-grid-container");
      dayGridEl = $('<div class="fc-day-grid" />').appendTo(dayGridContainerEl);
      this.el.find(".fc-body > tr > td").append(dayGridContainerEl);
      this.dayGrid.headContainerEl = this.el.find(".fc-head-container");
      this.dayGrid.setElement(dayGridEl);
    },
    unrenderSkeleton: function unrenderSkeleton() {
      this.dayGrid.removeElement();
      this.scroller.destroy();
    },
    // Builds the HTML skeleton for the view.
    // The day-grid component will render inside of a container defined by this HTML.
    renderSkeletonHtml: function renderSkeletonHtml() {
      var theme = this.calendar.theme;
      return "" + '<table class="' + theme.getClass("tableGrid") + '">' + (this.opt("columnHeader") ? '<thead class="fc-head">' + "<tr>" + '<td class="fc-head-container ' + theme.getClass("widgetHeader") + '">&nbsp;</td>' + "</tr>" + "</thead>" : "") + '<tbody class="fc-body">' + "<tr>" + '<td class="' + theme.getClass("widgetContent") + '"></td>' + "</tr>" + "</tbody>" + "</table>";
    },
    // Generates an HTML attribute string for setting the width of the week number column, if it is known
    weekNumberStyleAttr: function weekNumberStyleAttr() {
      if (this.weekNumberWidth !== null) {
        return 'style="width:' + this.weekNumberWidth + 'px"';
      }

      return "";
    },
    // Determines whether each row should have a constant height
    hasRigidRows: function hasRigidRows() {
      var eventLimit = this.opt("eventLimit");
      return eventLimit && typeof eventLimit !== "number";
    },

    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    // Refreshes the horizontal dimensions of the view
    updateSize: function updateSize(totalHeight, isAuto, isResize) {
      var eventLimit = this.opt("eventLimit");
      var headRowEl = this.dayGrid.headContainerEl.find(".fc-row");
      var scrollerHeight;
      var scrollbarWidths; // hack to give the view some height prior to dayGrid's columns being rendered
      // TODO: separate setting height from scroller VS dayGrid.

      if (!this.dayGrid.rowEls) {
        if (!isAuto) {
          scrollerHeight = this.computeScrollerHeight(totalHeight);
          this.scroller.setHeight(scrollerHeight);
        }

        return;
      }

      View.prototype.updateSize.apply(this, arguments);

      if (this.dayGrid.colWeekNumbersVisible) {
        // Make sure all week number cells running down the side have the same width.
        // Record the width for cells created later.
        this.weekNumberWidth = matchCellWidths(this.el.find(".fc-week-number"));
      } // reset all heights to be natural


      this.scroller.clear();
      uncompensateScroll(headRowEl);
      this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
      // is the event limit a constant level number?

      if (eventLimit && typeof eventLimit === "number") {
        this.dayGrid.limitRows(eventLimit); // limit the levels first so the height can redistribute after
      } // distribute the height to the rows
      // (totalHeight is a "recommended" value if isAuto)


      scrollerHeight = this.computeScrollerHeight(totalHeight);
      this.setGridHeight(scrollerHeight, isAuto); // is the event limit dynamically calculated?

      if (eventLimit && typeof eventLimit !== "number") {
        this.dayGrid.limitRows(eventLimit); // limit the levels after the grid's row heights have been set
      }

      if (!isAuto) {
        // should we force dimensions of the scroll container?
        this.scroller.setHeight(scrollerHeight);
        scrollbarWidths = this.scroller.getScrollbarWidths();

        if (scrollbarWidths.left || scrollbarWidths.right) {
          // using scrollbars?
          compensateScroll(headRowEl, scrollbarWidths); // doing the scrollbar compensation might have created text overflow which created more height. redo

          scrollerHeight = this.computeScrollerHeight(totalHeight);
          this.scroller.setHeight(scrollerHeight);
        } // guarantees the same scrollbar widths


        this.scroller.lockOverflow(scrollbarWidths);
      }
    },
    // given a desired total height of the view, returns what the height of the scroller should be
    computeScrollerHeight: function computeScrollerHeight(totalHeight) {
      return totalHeight - subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    },
    // Sets the height of just the DayGrid component in this view
    setGridHeight: function setGridHeight(height, isAuto) {
      if (isAuto) {
        undistributeHeight(this.dayGrid.rowEls); // let the rows be their natural height with no expanding
      } else {
        distributeHeight(this.dayGrid.rowEls, height, true); // true = compensate for height-hogging rows
      }
    },

    /* Scroll
    ------------------------------------------------------------------------------------------------------------------*/
    computeInitialDateScroll: function computeInitialDateScroll() {
      return {
        top: 0
      };
    },
    queryDateScroll: function queryDateScroll() {
      return {
        top: this.scroller.getScrollTop()
      };
    },
    applyDateScroll: function applyDateScroll(scroll) {
      if (scroll.top !== undefined) {
        this.scroller.setScrollTop(scroll.top);
      }
    }
  }); // Methods that will customize the rendering behavior of the BasicView's dayGrid

  var basicDayGridMethods = {
    // not relly methods anymore
    colWeekNumbersVisible: false,
    // display week numbers along the side?
    // Generates the HTML that will go before the day-of week header cells
    renderHeadIntroHtml: function renderHeadIntroHtml() {
      var view = this.view;

      if (this.colWeekNumbersVisible) {
        return "" + '<th class="fc-week-number ' + view.calendar.theme.getClass("widgetHeader") + '" ' + view.weekNumberStyleAttr() + ">" + "<span>" + // needed for matchCellWidths
        htmlEscape(this.opt("weekNumberTitle")) + "</span>" + "</th>";
      }

      return "";
    },
    // Generates the HTML that will go before content-skeleton cells that display the day/week numbers
    renderNumberIntroHtml: function renderNumberIntroHtml(row) {
      var view = this.view;
      var weekStart = this.getCellDate(row, 0);

      if (this.colWeekNumbersVisible) {
        return "" + '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + ">" + view.buildGotoAnchorHtml( // aside from link, important for matchCellWidths
        {
          date: weekStart,
          type: "week",
          forceOff: this.colCnt === 1
        }, weekStart.format("w") // inner HTML
        ) + "</td>";
      }

      return "";
    },
    // Generates the HTML that goes before the day bg cells for each day-row
    renderBgIntroHtml: function renderBgIntroHtml() {
      var view = this.view;

      if (this.colWeekNumbersVisible) {
        return '<td class="fc-week-number ' + view.calendar.theme.getClass("widgetContent") + '" ' + view.weekNumberStyleAttr() + "></td>";
      }

      return "";
    },
    // Generates the HTML that goes before every other type of row generated by DayGrid.
    // Affects helper-skeleton and highlight-skeleton rows.
    renderIntroHtml: function renderIntroHtml() {
      var view = this.view;

      if (this.colWeekNumbersVisible) {
        return '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + "></td>";
      }

      return "";
    },
    getIsNumbersVisible: function getIsNumbersVisible() {
      return DayGrid.prototype.getIsNumbersVisible.apply(this, arguments) || this.colWeekNumbersVisible;
    }
  };
  /* A month view with day cells running in rows (one-per-week) and columns
  ----------------------------------------------------------------------------------------------------------------------*/

  var MonthView = FC.MonthView = BasicView.extend({
    // Computes the date range that will be rendered.
    buildRenderRange: function buildRenderRange(currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
      var renderUnzonedRange = BasicView.prototype.buildRenderRange.apply(this, arguments);
      var start = this.calendar.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
      var end = this.calendar.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay);
      var rowCnt; // ensure 6 weeks

      if (this.isFixedWeeks()) {
        rowCnt = Math.ceil( // could be partial weeks due to hiddenDays
        end.diff(start, "weeks", true) // dontRound=true
        );
        end.add(6 - rowCnt, "weeks");
      }

      return new UnzonedRange(start, end);
    },
    // Overrides the default BasicView behavior to have special multi-week auto-height logic
    setGridHeight: function setGridHeight(height, isAuto) {
      // if auto, make the height of each row the height that it would be if there were 6 weeks
      if (isAuto) {
        height *= this.rowCnt / 6;
      }

      distributeHeight(this.dayGrid.rowEls, height, !isAuto); // if auto, don't compensate for height-hogging rows
    },
    isFixedWeeks: function isFixedWeeks() {
      return this.opt("fixedWeekCount");
    },
    isDateInOtherMonth: function isDateInOtherMonth(date, dateProfile) {
      return date.month() !== moment.utc(dateProfile.currentUnzonedRange.startMs).month(); // TODO: optimize
    }
  });
  fcViews.basic = {
    "class": BasicView
  };
  fcViews.basicDay = {
    type: "basic",
    duration: {
      days: 1
    }
  };
  fcViews.basicWeek = {
    type: "basic",
    duration: {
      weeks: 1
    }
  };
  fcViews.month = {
    "class": MonthView,
    duration: {
      months: 1
    },
    // important for prev/next
    defaults: {
      fixedWeekCount: true
    }
  };
  var TimeGridFillRenderer = FillRenderer.extend({
    attachSegEls: function attachSegEls(type, segs) {
      var timeGrid = this.component;
      var containerEls; // TODO: more efficient lookup

      if (type === "bgEvent") {
        containerEls = timeGrid.bgContainerEls;
      } else if (type === "businessHours") {
        containerEls = timeGrid.businessContainerEls;
      } else if (type === "highlight") {
        containerEls = timeGrid.highlightContainerEls;
      }

      timeGrid.updateSegVerticals(segs);
      timeGrid.attachSegsByCol(timeGrid.groupSegsByCol(segs), containerEls);
      return segs.map(function (seg) {
        return seg.el[0];
      });
    }
  });
  /*
  Only handles foreground segs.
  Does not own rendering. Use for low-level util methods by TimeGrid.
  */

  var TimeGridEventRenderer = EventRenderer.extend({
    timeGrid: null,
    constructor: function constructor(timeGrid) {
      EventRenderer.apply(this, arguments);
      this.timeGrid = timeGrid;
    },
    renderFgSegs: function renderFgSegs(segs) {
      this.renderFgSegsIntoContainers(segs, this.timeGrid.fgContainerEls);
    },
    // Given an array of foreground segments, render a DOM element for each, computes position,
    // and attaches to the column inner-container elements.
    renderFgSegsIntoContainers: function renderFgSegsIntoContainers(segs, containerEls) {
      var segsByCol;
      var col;
      segsByCol = this.timeGrid.groupSegsByCol(segs);

      for (col = 0; col < this.timeGrid.colCnt; col++) {
        this.updateFgSegCoords(segsByCol[col]);
      }

      this.timeGrid.attachSegsByCol(segsByCol, containerEls);
    },
    unrenderFgSegs: function unrenderFgSegs() {
      if (this.fgSegs) {
        // hack
        this.fgSegs.forEach(function (seg) {
          seg.el.remove();
        });
      }
    },
    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
    computeEventTimeFormat: function computeEventTimeFormat() {
      return this.opt("noMeridiemTimeFormat"); // like "6:30" (no AM/PM)
    },
    // Computes a default `displayEventEnd` value if one is not expliclty defined
    computeDisplayEventEnd: function computeDisplayEventEnd() {
      return true;
    },
    // Renders the HTML for a single event segment's default rendering
    fgSegHtml: function fgSegHtml(seg, disableResizing) {
      var view = this.view;
      var calendar = view.calendar;
      var componentFootprint = seg.footprint.componentFootprint;
      var isAllDay = componentFootprint.isAllDay;
      var eventDef = seg.footprint.eventDef;
      var isDraggable = view.isEventDefDraggable(eventDef);
      var isResizableFromStart = !disableResizing && seg.isStart && view.isEventDefResizableFromStart(eventDef);
      var isResizableFromEnd = !disableResizing && seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
      var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
      var skinCss = cssToStr(this.getSkinCss(eventDef));
      var timeText;
      var fullTimeText; // more verbose time text. for the print stylesheet

      var startTimeText; // just the start time text

      classes.unshift("fc-time-grid-event", "fc-v-event"); // if the event appears to span more than one day...

      if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
        // Don't display time text on segments that run entirely through a day.
        // That would appear as midnight-midnight and would look dumb.
        // Otherwise, display the time text for the *segment's* times (like 6pm-midnight or midnight-10am)
        if (seg.isStart || seg.isEnd) {
          var zonedStart = calendar.msToMoment(seg.startMs);
          var zonedEnd = calendar.msToMoment(seg.endMs);
          timeText = this._getTimeText(zonedStart, zonedEnd, isAllDay);
          fullTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, "LT");
          startTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, null, false); // displayEnd=false
        }
      } else {
        // Display the normal time text for the *event's* times
        timeText = this.getTimeText(seg.footprint);
        fullTimeText = this.getTimeText(seg.footprint, "LT");
        startTimeText = this.getTimeText(seg.footprint, null, false); // displayEnd=false
      }

      return '<a class="' + classes.join(" ") + '"' + (eventDef.url ? ' href="' + htmlEscape(eventDef.url) + '"' : "") + (skinCss ? ' style="' + skinCss + '"' : "") + ">" + '<div class="fc-content">' + (timeText ? '<div class="fc-time"' + ' data-start="' + htmlEscape(startTimeText) + '"' + ' data-full="' + htmlEscape(fullTimeText) + '"' + ">" + "<span>" + htmlEscape(timeText) + "</span>" + "</div>" : "") + (eventDef.title ? '<div class="fc-title">' + htmlEscape(eventDef.title) + "</div>" : "") + "</div>" +
      /*'<div class="fc-bg"/>' +
       TODO: write CSS for this
      (isResizableFromStart ?
      '<div class="fc-resizer fc-start-resizer" />' :
      ''
      ) +
           (isResizableFromEnd
        ? '<div class="fc-resizer fc-end-resizer" />'
        : "") +*/
      "</a>";
    },
    // Given segments that are assumed to all live in the *same column*,
    // compute their verical/horizontal coordinates and assign to their elements.
    updateFgSegCoords: function updateFgSegCoords(segs) {
      this.timeGrid.computeSegVerticals(segs); // horizontals relies on this

      this.computeFgSegHorizontals(segs); // compute horizontal coordinates, z-index's, and reorder the array

      this.timeGrid.assignSegVerticals(segs);
      this.assignFgSegHorizontals(segs);
    },
    // Given an array of segments that are all in the same column, sets the backwardCoord and forwardCoord on each.
    // NOTE: Also reorders the given array by date!
    computeFgSegHorizontals: function computeFgSegHorizontals(segs) {
      var levels;
      var level0;
      var i;
      this.sortEventSegs(segs); // order by certain criteria

      levels = buildSlotSegLevels(segs);
      computeForwardSlotSegs(levels);

      if (level0 = levels[0]) {
        for (i = 0; i < level0.length; i++) {
          computeSlotSegPressures(level0[i]);
        }

        for (i = 0; i < level0.length; i++) {
          this.computeFgSegForwardBack(level0[i], 0, 0);
        }
      }
    },
    // Calculate seg.forwardCoord and seg.backwardCoord for the segment, where both values range
    // from 0 to 1. If the calendar is left-to-right, the seg.backwardCoord maps to "left" and
    // seg.forwardCoord maps to "right" (via percentage). Vice-versa if the calendar is right-to-left.
    //
    // The segment might be part of a "series", which means consecutive segments with the same pressure
    // who's width is unknown until an edge has been hit. `seriesBackwardPressure` is the number of
    // segments behind this one in the current series, and `seriesBackwardCoord` is the starting
    // coordinate of the first segment in the series.
    computeFgSegForwardBack: function computeFgSegForwardBack(seg, seriesBackwardPressure, seriesBackwardCoord) {
      var forwardSegs = seg.forwardSegs;
      var i;

      if (seg.forwardCoord === undefined) {
        // not already computed
        if (!forwardSegs.length) {
          // if there are no forward segments, this segment should butt up against the edge
          seg.forwardCoord = 1;
        } else {
          // sort highest pressure first
          this.sortForwardSegs(forwardSegs); // this segment's forwardCoord will be calculated from the backwardCoord of the
          // highest-pressure forward segment.

          this.computeFgSegForwardBack(forwardSegs[0], seriesBackwardPressure + 1, seriesBackwardCoord);
          seg.forwardCoord = forwardSegs[0].backwardCoord;
        } // calculate the backwardCoord from the forwardCoord. consider the series


        seg.backwardCoord = seg.forwardCoord - (seg.forwardCoord - seriesBackwardCoord) / ( // available width for series
        seriesBackwardPressure + 1); // # of segments in the series
        // use this segment's coordinates to computed the coordinates of the less-pressurized
        // forward segments

        for (i = 0; i < forwardSegs.length; i++) {
          this.computeFgSegForwardBack(forwardSegs[i], 0, seg.forwardCoord);
        }
      }
    },
    sortForwardSegs: function sortForwardSegs(forwardSegs) {
      forwardSegs.sort(proxy(this, "compareForwardSegs"));
    },
    // A cmp function for determining which forward segment to rely on more when computing coordinates.
    compareForwardSegs: function compareForwardSegs(seg1, seg2) {
      // put higher-pressure first
      return seg2.forwardPressure - seg1.forwardPressure || // put segments that are closer to initial edge first (and favor ones with no coords yet)
      (seg1.backwardCoord || 0) - (seg2.backwardCoord || 0) || // do normal sorting...
      this.compareEventSegs(seg1, seg2);
    },
    // Given foreground event segments that have already had their position coordinates computed,
    // assigns position-related CSS values to their elements.
    assignFgSegHorizontals: function assignFgSegHorizontals(segs) {
      var i, seg;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        seg.el.css(this.generateFgSegHorizontalCss(seg)); // if the height is short, add a className for alternate styling

        if (seg.bottom - seg.top < 30) {
          seg.el.addClass("fc-short");
        }
      }
    },
    // Generates an object with CSS properties/values that should be applied to an event segment element.
    // Contains important positioning-related properties that should be applied to any event element, customized or not.
    generateFgSegHorizontalCss: function generateFgSegHorizontalCss(seg) {
      var shouldOverlap = this.opt("slotEventOverlap");
      var backwardCoord = seg.backwardCoord; // the left side if LTR. the right side if RTL. floating-point

      var forwardCoord = seg.forwardCoord; // the right side if LTR. the left side if RTL. floating-point

      var props = this.timeGrid.generateSegVerticalCss(seg); // get top/bottom first

      var left; // amount of space from left edge, a fraction of the total width

      var right; // amount of space from right edge, a fraction of the total width

      if (shouldOverlap) {
        // double the width, but don't go beyond the maximum forward coordinate (1.0)
        forwardCoord = Math.min(1, backwardCoord + (forwardCoord - backwardCoord) * 2);
      }

      if (this.timeGrid.isRTL) {
        left = 1 - forwardCoord;
        right = backwardCoord;
      } else {
        left = backwardCoord;
        right = 1 - forwardCoord;
      }

      props.zIndex = seg.level + 1; // convert from 0-base to 1-based

      props.left = left * 100 + "%";
      props.right = right * 100 + "%";

      if (shouldOverlap && seg.forwardPressure) {
        // add padding to the edge so that forward stacked events don't cover the resizer's icon
        props[this.isRTL ? "marginLeft" : "marginRight"] = 10 * 2; // 10 is a guesstimate of the icon's width
      }

      return props;
    }
  }); // Builds an array of segments "levels". The first level will be the leftmost tier of segments if the calendar is
  // left-to-right, or the rightmost if the calendar is right-to-left. Assumes the segments are already ordered by date.

  function buildSlotSegLevels(segs) {
    var levels = [];
    var i, seg;
    var j;

    for (i = 0; i < segs.length; i++) {
      seg = segs[i]; // go through all the levels and stop on the first level where there are no collisions

      for (j = 0; j < levels.length; j++) {
        if (!computeSlotSegCollisions(seg, levels[j]).length) {
          break;
        }
      }

      seg.level = j;
      (levels[j] || (levels[j] = [])).push(seg);
    }

    return levels;
  } // For every segment, figure out the other segments that are in subsequent
  // levels that also occupy the same vertical space. Accumulate in seg.forwardSegs


  function computeForwardSlotSegs(levels) {
    var i, level;
    var j, seg;
    var k;

    for (i = 0; i < levels.length; i++) {
      level = levels[i];

      for (j = 0; j < level.length; j++) {
        seg = level[j];
        seg.forwardSegs = [];

        for (k = i + 1; k < levels.length; k++) {
          computeSlotSegCollisions(seg, levels[k], seg.forwardSegs);
        }
      }
    }
  } // Figure out which path forward (via seg.forwardSegs) results in the longest path until
  // the furthest edge is reached. The number of segments in this path will be seg.forwardPressure


  function computeSlotSegPressures(seg) {
    var forwardSegs = seg.forwardSegs;
    var forwardPressure = 0;
    var i, forwardSeg;

    if (seg.forwardPressure === undefined) {
      // not already computed
      for (i = 0; i < forwardSegs.length; i++) {
        forwardSeg = forwardSegs[i]; // figure out the child's maximum forward path

        computeSlotSegPressures(forwardSeg); // either use the existing maximum, or use the child's forward pressure
        // plus one (for the forwardSeg itself)

        forwardPressure = Math.max(forwardPressure, 1 + forwardSeg.forwardPressure);
      }

      seg.forwardPressure = forwardPressure;
    }
  } // Find all the segments in `otherSegs` that vertically collide with `seg`.
  // Append into an optionally-supplied `results` array and return.


  function computeSlotSegCollisions(seg, otherSegs, results) {
    results = results || [];

    for (var i = 0; i < otherSegs.length; i++) {
      if (isSlotSegCollision(seg, otherSegs[i])) {
        results.push(otherSegs[i]);
      }
    }

    return results;
  } // Do these segments occupy the same vertical space?


  function isSlotSegCollision(seg1, seg2) {
    return seg1.bottom > seg2.top && seg1.top < seg2.bottom;
  }

  var TimeGridHelperRenderer = HelperRenderer.extend({
    renderSegs: function renderSegs(segs, sourceSeg) {
      var helperNodes = [];
      var i, seg;
      var sourceEl; // TODO: not good to call eventRenderer this way

      this.eventRenderer.renderFgSegsIntoContainers(segs, this.component.helperContainerEls); // Try to make the segment that is in the same row as sourceSeg look the same

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];

        if (sourceSeg && sourceSeg.col === seg.col) {
          sourceEl = sourceSeg.el;
          seg.el.css({
            left: sourceEl.css("left"),
            right: sourceEl.css("right"),
            "margin-left": sourceEl.css("margin-left"),
            "margin-right": sourceEl.css("margin-right")
          });
        }

        helperNodes.push(seg.el[0]);
      }

      return $(helperNodes); // must return the elements rendered
    }
  });
  /* A component that renders one or more columns of vertical time slots
  ----------------------------------------------------------------------------------------------------------------------*/
  // We mixin DayTable, even though there is only a single row of days

  var TimeGrid = FC.TimeGrid = InteractiveDateComponent.extend(StandardInteractionsMixin, DayTableMixin, {
    eventRendererClass: TimeGridEventRenderer,
    businessHourRendererClass: BusinessHourRenderer,
    helperRendererClass: TimeGridHelperRenderer,
    fillRendererClass: TimeGridFillRenderer,
    view: null,
    // TODO: make more general and/or remove
    helperRenderer: null,
    dayRanges: null,
    // UnzonedRange[], of start-end of each day
    slotDuration: null,
    // duration of a "slot", a distinct time segment on given day, visualized by lines
    snapDuration: null,
    // granularity of time for dragging and selecting
    snapsPerSlot: null,
    labelFormat: null,
    // formatting string for times running along vertical axis
    labelInterval: null,
    // duration of how often a label should be displayed for a slot
    headContainerEl: null,
    // div that hold's the date header
    colEls: null,
    // cells elements in the day-row background
    slatContainerEl: null,
    // div that wraps all the slat rows
    slatEls: null,
    // elements running horizontally across all columns
    nowIndicatorEls: null,
    colCoordCache: null,
    slatCoordCache: null,
    bottomRuleEl: null,
    // hidden by default
    contentSkeletonEl: null,
    colContainerEls: null,
    // containers for each column
    // inner-containers for each column where different types of segs live
    fgContainerEls: null,
    bgContainerEls: null,
    helperContainerEls: null,
    highlightContainerEls: null,
    businessContainerEls: null,
    // arrays of different types of displayed segments
    helperSegs: null,
    highlightSegs: null,
    businessSegs: null,
    constructor: function constructor(view) {
      this.view = view; // do first, for opt calls during initialization

      InteractiveDateComponent.call(this); // call the super-constructor

      this.processOptions();
    },
    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
    componentFootprintToSegs: function componentFootprintToSegs(componentFootprint) {
      var segs = this.sliceRangeByTimes(componentFootprint.unzonedRange);
      var i;

      for (i = 0; i < segs.length; i++) {
        if (this.isRTL) {
          segs[i].col = this.daysPerRow - 1 - segs[i].dayIndex;
        } else {
          segs[i].col = segs[i].dayIndex;
        }
      }

      return segs;
    },

    /* Date Handling
    ------------------------------------------------------------------------------------------------------------------*/
    sliceRangeByTimes: function sliceRangeByTimes(unzonedRange) {
      var segs = [];
      var segRange;
      var dayIndex;

      for (dayIndex = 0; dayIndex < this.daysPerRow; dayIndex++) {
        segRange = unzonedRange.intersect(this.dayRanges[dayIndex]);

        if (segRange) {
          segs.push({
            startMs: segRange.startMs,
            endMs: segRange.endMs,
            isStart: segRange.isStart,
            isEnd: segRange.isEnd,
            dayIndex: dayIndex
          });
        }
      }

      return segs;
    },

    /* Options
    ------------------------------------------------------------------------------------------------------------------*/
    // Parses various options into properties of this object
    processOptions: function processOptions() {
      var slotDuration = this.opt("slotDuration");
      var snapDuration = this.opt("snapDuration");
      var input;
      slotDuration = moment.duration(slotDuration);
      snapDuration = snapDuration ? moment.duration(snapDuration) : slotDuration;
      this.slotDuration = slotDuration;
      this.snapDuration = snapDuration;
      this.snapsPerSlot = slotDuration / snapDuration; // TODO: ensure an integer multiple?
      // might be an array value (for TimelineView).
      // if so, getting the most granular entry (the last one probably).

      input = this.opt("slotLabelFormat");

      if ($.isArray(input)) {
        input = input[input.length - 1];
      }

      this.labelFormat = input || this.opt("smallTimeFormat"); // the computed default

      input = this.opt("slotLabelInterval");
      this.labelInterval = input ? moment.duration(input) : this.computeLabelInterval(slotDuration);
    },
    // Computes an automatic value for slotLabelInterval
    computeLabelInterval: function computeLabelInterval(slotDuration) {
      var i;
      var labelInterval;
      var slotsPerLabel; // find the smallest stock label interval that results in more than one slots-per-label

      for (i = AGENDA_STOCK_SUB_DURATIONS.length - 1; i >= 0; i--) {
        labelInterval = moment.duration(AGENDA_STOCK_SUB_DURATIONS[i]);
        slotsPerLabel = divideDurationByDuration(labelInterval, slotDuration);

        if (isInt(slotsPerLabel) && slotsPerLabel > 1) {
          return labelInterval;
        }
      }

      return moment.duration(slotDuration); // fall back. clone
    },

    /* Date Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    renderDates: function renderDates(dateProfile) {
      this.dateProfile = dateProfile;
      this.updateDayTable();
      this.renderSlats();
      this.renderColumns();
    },
    unrenderDates: function unrenderDates() {
      //this.unrenderSlats(); // don't need this because repeated .html() calls clear
      this.unrenderColumns();
    },
    renderSkeleton: function renderSkeleton() {
      var theme = this.view.calendar.theme;
      this.el.html('<div class="fc-bg"></div>' + '<div class="fc-slats"></div>' + '<hr class="fc-divider ' + theme.getClass("widgetHeader") + '" style="display:none" />');
      this.bottomRuleEl = this.el.find("hr");
    },
    renderSlats: function renderSlats() {
      var theme = this.view.calendar.theme;
      this.slatContainerEl = this.el.find("> .fc-slats").html( // avoids needing ::unrenderSlats()
      '<table class="' + theme.getClass("tableGrid") + '">' + this.renderSlatRowHtml() + "</table>");
      this.slatEls = this.slatContainerEl.find("tr");
      this.slatCoordCache = new CoordCache({
        els: this.slatEls,
        isVertical: true
      });
    },
    // Generates the HTML for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
    renderSlatRowHtml: function renderSlatRowHtml() {
      var view = this.view;
      var calendar = view.calendar;
      var theme = calendar.theme;
      var isRTL = this.isRTL;
      var dateProfile = this.dateProfile;
      var html = "";
      var slotTime = moment.duration(+dateProfile.minTime); // wish there was .clone() for durations

      var slotIterator = moment.duration(0);
      var slotDate; // will be on the view's first day, but we only care about its time

      var isLabeled;
      var axisHtml; // Calculate the time for each slot

      while (slotTime < dateProfile.maxTime) {
        slotDate = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs).time(slotTime);
        isLabeled = isInt(divideDurationByDuration(slotIterator, this.labelInterval));
        axisHtml = '<td class="fc-axis fc-time ' + theme.getClass("widgetContent") + '" ' + view.axisStyleAttr() + ">" + (isLabeled ? "<span>" + // for matchCellWidths
        htmlEscape(slotDate.format(this.labelFormat)) + "</span>" : "") + "</td>";
        html += '<tr data-time="' + slotDate.format("HH:mm:ss") + '"' + (isLabeled ? "" : ' class="fc-minor"') + ">" + (!isRTL ? axisHtml : "") + '<td class="' + theme.getClass("widgetContent") + '"/>' + (isRTL ? axisHtml : "") + "</tr>";
        slotTime.add(this.slotDuration);
        slotIterator.add(this.slotDuration);
      }

      return html;
    },
    renderColumns: function renderColumns() {
      var dateProfile = this.dateProfile;
      var theme = this.view.calendar.theme;
      this.dayRanges = this.dayDates.map(function (dayDate) {
        return new UnzonedRange(dayDate.clone().add(dateProfile.minTime), dayDate.clone().add(dateProfile.maxTime));
      });

      if (this.headContainerEl) {
        this.headContainerEl.html(this.renderHeadHtml());
      }

      this.el.find("> .fc-bg").html('<table class="' + theme.getClass("tableGrid") + '">' + this.renderBgTrHtml(0) + // row=0
      "</table>");
      this.colEls = this.el.find(".fc-day, .fc-disabled-day");
      this.colCoordCache = new CoordCache({
        els: this.colEls,
        isHorizontal: true
      });
      this.renderContentSkeleton();
    },
    unrenderColumns: function unrenderColumns() {
      this.unrenderContentSkeleton();
    },

    /* Content Skeleton
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders the DOM that the view's content will live in
    renderContentSkeleton: function renderContentSkeleton() {
      var cellHtml = "";
      var i;
      var skeletonEl;

      for (i = 0; i < this.colCnt; i++) {
        cellHtml += "<td>" + '<div class="fc-content-col">' + '<div class="fc-event-container fc-helper-container"></div>' + '<div class="fc-event-container"></div>' + '<div class="fc-highlight-container"></div>' + '<div class="fc-bgevent-container"></div>' + '<div class="fc-business-container"></div>' + "</div>" + "</td>";
      }

      skeletonEl = this.contentSkeletonEl = $('<div class="fc-content-skeleton">' + "<table>" + "<tr>" + cellHtml + "</tr>" + "</table>" + "</div>");
      this.colContainerEls = skeletonEl.find(".fc-content-col");
      this.helperContainerEls = skeletonEl.find(".fc-helper-container");
      this.fgContainerEls = skeletonEl.find(".fc-event-container:not(.fc-helper-container)");
      this.bgContainerEls = skeletonEl.find(".fc-bgevent-container");
      this.highlightContainerEls = skeletonEl.find(".fc-highlight-container");
      this.businessContainerEls = skeletonEl.find(".fc-business-container");
      this.bookendCells(skeletonEl.find("tr")); // TODO: do this on string level

      this.el.append(skeletonEl);
    },
    unrenderContentSkeleton: function unrenderContentSkeleton() {
      this.contentSkeletonEl.remove();
      this.contentSkeletonEl = null;
      this.colContainerEls = null;
      this.helperContainerEls = null;
      this.fgContainerEls = null;
      this.bgContainerEls = null;
      this.highlightContainerEls = null;
      this.businessContainerEls = null;
    },
    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's col
    groupSegsByCol: function groupSegsByCol(segs) {
      var segsByCol = [];
      var i;

      for (i = 0; i < this.colCnt; i++) {
        segsByCol.push([]);
      }

      for (i = 0; i < segs.length; i++) {
        segsByCol[segs[i].col].push(segs[i]);
      }

      return segsByCol;
    },
    // Given segments grouped by column, insert the segments' elements into a parallel array of container
    // elements, each living within a column.
    attachSegsByCol: function attachSegsByCol(segsByCol, containerEls) {
      var col;
      var segs;
      var i;

      for (col = 0; col < this.colCnt; col++) {
        // iterate each column grouping
        segs = segsByCol[col];

        for (i = 0; i < segs.length; i++) {
          containerEls.eq(col).append(segs[i].el);
        }
      }
    },

    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    getNowIndicatorUnit: function getNowIndicatorUnit() {
      return "minute"; // will refresh on the minute
    },
    renderNowIndicator: function renderNowIndicator(date) {
      // seg system might be overkill, but it handles scenario where line needs to be rendered
      //  more than once because of columns with the same date (resources columns for example)
      var segs = this.componentFootprintToSegs(new ComponentFootprint(new UnzonedRange(date, date.valueOf() + 1), // protect against null range
      false // all-day
      ));
      var top = this.computeDateTop(date, date);
      var nodes = [];
      var i; // render lines within the columns

      for (i = 0; i < segs.length; i++) {
        nodes.push($('<div class="fc-now-indicator fc-now-indicator-line"></div>').css("top", top).appendTo(this.colContainerEls.eq(segs[i].col))[0]);
      } // render an arrow over the axis


      if (segs.length > 0) {
        // is the current time in view?
        nodes.push($('<div class="fc-now-indicator fc-now-indicator-arrow"></div>').css("top", top).appendTo(this.el.find(".fc-content-skeleton"))[0]);
      }

      this.nowIndicatorEls = $(nodes);
    },
    unrenderNowIndicator: function unrenderNowIndicator() {
      if (this.nowIndicatorEls) {
        this.nowIndicatorEls.remove();
        this.nowIndicatorEls = null;
      }
    },

    /* Coordinates
    ------------------------------------------------------------------------------------------------------------------*/
    updateSize: function updateSize(totalHeight, isAuto, isResize) {
      InteractiveDateComponent.prototype.updateSize.apply(this, arguments);
      this.slatCoordCache.build();

      if (isResize) {
        this.updateSegVerticals([].concat(this.eventRenderer.getSegs(), this.businessSegs || []));
      }
    },
    getTotalSlatHeight: function getTotalSlatHeight() {
      return this.slatContainerEl.outerHeight();
    },
    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // `ms` can be a millisecond UTC time OR a UTC moment.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    computeDateTop: function computeDateTop(ms, startOfDayDate) {
      return this.computeTimeTop(moment.duration(ms - startOfDayDate.clone().stripTime()));
    },
    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    computeTimeTop: function computeTimeTop(time) {
      var len = this.slatEls.length;
      var dateProfile = this.dateProfile;
      var slatCoverage = (time - dateProfile.minTime) / this.slotDuration; // floating-point value of # of slots covered

      var slatIndex;
      var slatRemainder; // compute a floating-point number for how many slats should be progressed through.
      // from 0 to number of slats (inclusive)
      // constrained because minTime/maxTime might be customized.

      slatCoverage = Math.max(0, slatCoverage);
      slatCoverage = Math.min(len, slatCoverage); // an integer index of the furthest whole slat
      // from 0 to number slats (*exclusive*, so len-1)

      slatIndex = Math.floor(slatCoverage);
      slatIndex = Math.min(slatIndex, len - 1); // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
      // could be 1.0 if slatCoverage is covering *all* the slots

      slatRemainder = slatCoverage - slatIndex;
      return this.slatCoordCache.getTopPosition(slatIndex) + this.slatCoordCache.getHeight(slatIndex) * slatRemainder;
    },
    // Refreshes the CSS top/bottom coordinates for each segment element.
    // Works when called after initial render, after a window resize/zoom for example.
    updateSegVerticals: function updateSegVerticals(segs) {
      this.computeSegVerticals(segs);
      this.assignSegVerticals(segs);
    },
    // For each segment in an array, computes and assigns its top and bottom properties
    computeSegVerticals: function computeSegVerticals(segs) {
      var eventMinHeight = this.opt("agendaEventMinHeight");
      var i, seg;
      var dayDate;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        dayDate = this.dayDates[seg.dayIndex];
        seg.top = this.computeDateTop(seg.startMs, dayDate);
        seg.bottom = Math.max(seg.top + eventMinHeight, this.computeDateTop(seg.endMs, dayDate));
      }
    },
    // Given segments that already have their top/bottom properties computed, applies those values to
    // the segments' elements.
    assignSegVerticals: function assignSegVerticals(segs) {
      var i, seg;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        seg.el.css(this.generateSegVerticalCss(seg));
      }
    },
    // Generates an object with CSS properties for the top/bottom coordinates of a segment element
    generateSegVerticalCss: function generateSegVerticalCss(seg) {
      return {
        top: seg.top,
        bottom: -seg.bottom // flipped because needs to be space beyond bottom edge of event container

      };
    },

    /* Hit System
    ------------------------------------------------------------------------------------------------------------------*/
    prepareHits: function prepareHits() {
      this.colCoordCache.build();
      this.slatCoordCache.build();
    },
    releaseHits: function releaseHits() {
      this.colCoordCache.clear(); // NOTE: don't clear slatCoordCache because we rely on it for computeTimeTop
    },
    queryHit: function queryHit(leftOffset, topOffset) {
      var snapsPerSlot = this.snapsPerSlot;
      var colCoordCache = this.colCoordCache;
      var slatCoordCache = this.slatCoordCache;

      if (colCoordCache.isLeftInBounds(leftOffset) && slatCoordCache.isTopInBounds(topOffset)) {
        var colIndex = colCoordCache.getHorizontalIndex(leftOffset);
        var slatIndex = slatCoordCache.getVerticalIndex(topOffset);

        if (colIndex != null && slatIndex != null) {
          var slatTop = slatCoordCache.getTopOffset(slatIndex);
          var slatHeight = slatCoordCache.getHeight(slatIndex);
          var partial = (topOffset - slatTop) / slatHeight; // floating point number between 0 and 1

          var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat

          var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
          var snapTop = slatTop + localSnapIndex / snapsPerSlot * slatHeight;
          var snapBottom = slatTop + (localSnapIndex + 1) / snapsPerSlot * slatHeight;
          return {
            col: colIndex,
            snap: snapIndex,
            component: this,
            // needed unfortunately :(
            left: colCoordCache.getLeftOffset(colIndex),
            right: colCoordCache.getRightOffset(colIndex),
            top: snapTop,
            bottom: snapBottom
          };
        }
      }
    },
    getHitFootprint: function getHitFootprint(hit) {
      var start = this.getCellDate(0, hit.col); // row=0

      var time = this.computeSnapTime(hit.snap); // pass in the snap-index

      var end;
      start.time(time);
      end = start.clone().add(this.snapDuration);
      return new ComponentFootprint(new UnzonedRange(start, end), false // all-day?
      );
    },
    // Given a row number of the grid, representing a "snap", returns a time (Duration) from its start-of-day
    computeSnapTime: function computeSnapTime(snapIndex) {
      return moment.duration(this.dateProfile.minTime + this.snapDuration * snapIndex);
    },
    getHitEl: function getHitEl(hit) {
      return this.colEls.eq(hit.col);
    },

    /* Event Drag Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being dragged over the specified date(s).
    // A returned value of `true` signals that a mock "helper" event has been rendered.
    renderDrag: function renderDrag(eventFootprints, seg, isTouch) {
      var i;

      if (seg) {
        // if there is event information for this drag, render a helper event
        if (eventFootprints.length) {
          this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch); // signal that a helper has been rendered

          return true;
        }
      } else {
        // otherwise, just render a highlight
        for (i = 0; i < eventFootprints.length; i++) {
          this.renderHighlight(eventFootprints[i].componentFootprint);
        }
      }
    },
    // Unrenders any visual indication of an event being dragged
    unrenderDrag: function unrenderDrag(seg) {
      this.unrenderHighlight();
      this.helperRenderer.unrender();
    },

    /* Event Resize Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being resized
    renderEventResize: function renderEventResize(eventFootprints, seg, isTouch) {
      this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
    },
    // Unrenders any visual indication of an event being resized
    unrenderEventResize: function unrenderEventResize(seg) {
      this.helperRenderer.unrender();
    },

    /* Selection
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of a selection. Overrides the default, which was to simply render a highlight.
    renderSelectionFootprint: function renderSelectionFootprint(componentFootprint) {
      if (this.opt("selectHelper")) {
        // this setting signals that a mock helper event should be rendered
        this.helperRenderer.renderComponentFootprint(componentFootprint);
      } else {
        this.renderHighlight(componentFootprint);
      }
    },
    // Unrenders any visual indication of a selection
    unrenderSelection: function unrenderSelection() {
      this.helperRenderer.unrender();
      this.unrenderHighlight();
    }
  });
  /* An abstract class for all agenda-related views. Displays one more columns with time slots running vertically.
  ----------------------------------------------------------------------------------------------------------------------*/
  // Is a manager for the TimeGrid subcomponent and possibly the DayGrid subcomponent (if allDaySlot is on).
  // Responsible for managing width/height.

  var AgendaView = FC.AgendaView = View.extend({
    scroller: null,
    timeGridClass: TimeGrid,
    // class used to instantiate the timeGrid. subclasses can override
    timeGrid: null,
    // the main time-grid subcomponent of this view
    dayGridClass: DayGrid,
    // class used to instantiate the dayGrid. subclasses can override
    dayGrid: null,
    // the "all-day" subcomponent. if all-day is turned off, this will be null
    axisWidth: null,
    // the width of the time axis running down the side
    // indicates that minTime/maxTime affects rendering
    usesMinMaxTime: true,
    constructor: function constructor() {
      View.apply(this, arguments);
      this.timeGrid = this.instantiateTimeGrid();
      this.addChild(this.timeGrid);

      if (this.opt("allDaySlot")) {
        // should we display the "all-day" area?
        this.dayGrid = this.instantiateDayGrid(); // the all-day subcomponent of this view

        this.addChild(this.dayGrid);
      }

      this.scroller = new Scroller({
        overflowX: "hidden",
        overflowY: "auto"
      });
    },
    // Instantiates the TimeGrid object this view needs. Draws from this.timeGridClass
    instantiateTimeGrid: function instantiateTimeGrid() {
      var subclass = this.timeGridClass.extend(agendaTimeGridMethods);
      return new subclass(this);
    },
    // Instantiates the DayGrid object this view might need. Draws from this.dayGridClass
    instantiateDayGrid: function instantiateDayGrid() {
      var subclass = this.dayGridClass.extend(agendaDayGridMethods);
      return new subclass(this);
    },

    /* Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    renderSkeleton: function renderSkeleton() {
      var timeGridWrapEl;
      var timeGridEl;
      this.el.addClass("fc-agenda-view").html(this.renderSkeletonHtml());
      this.scroller.render();
      timeGridWrapEl = this.scroller.el.addClass("fc-time-grid-container");
      timeGridEl = $('<div class="fc-time-grid" />').appendTo(timeGridWrapEl);
      this.el.find(".fc-body > tr > td").append(timeGridWrapEl);
      this.timeGrid.headContainerEl = this.el.find(".fc-head-container");
      this.timeGrid.setElement(timeGridEl);

      if (this.dayGrid) {
        this.dayGrid.setElement(this.el.find(".fc-day-grid")); // have the day-grid extend it's coordinate area over the <hr> dividing the two grids

        this.dayGrid.bottomCoordPadding = this.dayGrid.el.next("hr").outerHeight();
      }
    },
    unrenderSkeleton: function unrenderSkeleton() {
      this.timeGrid.removeElement();

      if (this.dayGrid) {
        this.dayGrid.removeElement();
      }

      this.scroller.destroy();
    },
    // Builds the HTML skeleton for the view.
    // The day-grid and time-grid components will render inside containers defined by this HTML.
    renderSkeletonHtml: function renderSkeletonHtml() {
      var theme = this.calendar.theme;
      return "" + '<table class="' + theme.getClass("tableGrid") + '">' + (this.opt("columnHeader") ? '<thead class="fc-head">' + "<tr>" + '<td class="fc-head-container ' + theme.getClass("widgetHeader") + '">&nbsp;</td>' + "</tr>" + "</thead>" : "") + '<tbody class="fc-body">' + "<tr>" + '<td class="' + theme.getClass("widgetContent") + '">' + (this.dayGrid ? '<div class="fc-day-grid"/>' + '<hr class="fc-divider ' + theme.getClass("widgetHeader") + '"/>' : "") + "</td>" + "</tr>" + "</tbody>" + "</table>";
    },
    // Generates an HTML attribute string for setting the width of the axis, if it is known
    axisStyleAttr: function axisStyleAttr() {
      if (this.axisWidth !== null) {
        return 'style="width:' + this.axisWidth + 'px"';
      }

      return "";
    },

    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    getNowIndicatorUnit: function getNowIndicatorUnit() {
      return this.timeGrid.getNowIndicatorUnit();
    },

    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    // Adjusts the vertical dimensions of the view to the specified values
    updateSize: function updateSize(totalHeight, isAuto, isResize) {
      var eventLimit;
      var scrollerHeight;
      var scrollbarWidths;
      View.prototype.updateSize.apply(this, arguments); // make all axis cells line up, and record the width so newly created axis cells will have it

      this.axisWidth = matchCellWidths(this.el.find(".fc-axis")); // hack to give the view some height prior to timeGrid's columns being rendered
      // TODO: separate setting height from scroller VS timeGrid.

      if (!this.timeGrid.colEls) {
        if (!isAuto) {
          scrollerHeight = this.computeScrollerHeight(totalHeight);
          this.scroller.setHeight(scrollerHeight);
        }

        return;
      } // set of fake row elements that must compensate when scroller has scrollbars


      var noScrollRowEls = this.el.find(".fc-row:not(.fc-scroller *)"); // reset all dimensions back to the original state

      this.timeGrid.bottomRuleEl.hide(); // .show() will be called later if this <hr> is necessary

      this.scroller.clear(); // sets height to 'auto' and clears overflow

      uncompensateScroll(noScrollRowEls); // limit number of events in the all-day area

      if (this.dayGrid) {
        this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed

        eventLimit = this.opt("eventLimit");

        if (eventLimit && typeof eventLimit !== "number") {
          eventLimit = AGENDA_ALL_DAY_EVENT_LIMIT; // make sure "auto" goes to a real number
        }

        if (eventLimit) {
          this.dayGrid.limitRows(eventLimit);
        }
      }

      if (!isAuto) {
        // should we force dimensions of the scroll container?
        scrollerHeight = this.computeScrollerHeight(totalHeight);
        this.scroller.setHeight(scrollerHeight);
        scrollbarWidths = this.scroller.getScrollbarWidths();

        if (scrollbarWidths.left || scrollbarWidths.right) {
          // using scrollbars?
          // make the all-day and header rows lines up
          compensateScroll(noScrollRowEls, scrollbarWidths); // the scrollbar compensation might have changed text flow, which might affect height, so recalculate
          // and reapply the desired height to the scroller.

          scrollerHeight = this.computeScrollerHeight(totalHeight);
          this.scroller.setHeight(scrollerHeight);
        } // guarantees the same scrollbar widths


        this.scroller.lockOverflow(scrollbarWidths); // if there's any space below the slats, show the horizontal rule.
        // this won't cause any new overflow, because lockOverflow already called.

        if (this.timeGrid.getTotalSlatHeight() < scrollerHeight) {
          this.timeGrid.bottomRuleEl.show();
        }
      }
    },
    // given a desired total height of the view, returns what the height of the scroller should be
    computeScrollerHeight: function computeScrollerHeight(totalHeight) {
      return totalHeight - subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    },

    /* Scroll
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes the initial pre-configured scroll state prior to allowing the user to change it
    computeInitialDateScroll: function computeInitialDateScroll() {
      var scrollTime = moment.duration(this.opt("scrollTime"));
      var top = this.timeGrid.computeTimeTop(scrollTime); // zoom can give weird floating-point values. rather scroll a little bit further

      top = Math.ceil(top);

      if (top) {
        top++; // to overcome top border that slots beyond the first have. looks better
      }

      return {
        top: top
      };
    },
    queryDateScroll: function queryDateScroll() {
      return {
        top: this.scroller.getScrollTop()
      };
    },
    applyDateScroll: function applyDateScroll(scroll) {
      if (scroll.top !== undefined) {
        this.scroller.setScrollTop(scroll.top);
      }
    },

    /* Hit Areas
    ------------------------------------------------------------------------------------------------------------------*/
    // forward all hit-related method calls to the grids (dayGrid might not be defined)
    getHitFootprint: function getHitFootprint(hit) {
      // TODO: hit.component is set as a hack to identify where the hit came from
      return hit.component.getHitFootprint(hit);
    },
    getHitEl: function getHitEl(hit) {
      // TODO: hit.component is set as a hack to identify where the hit came from
      return hit.component.getHitEl(hit);
    },

    /* Event Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    executeEventRender: function executeEventRender(eventsPayload) {
      var dayEventsPayload = {};
      var timedEventsPayload = {};
      var id, eventInstanceGroup; // separate the events into all-day and timed

      for (id in eventsPayload) {
        eventInstanceGroup = eventsPayload[id];

        if (eventInstanceGroup.getEventDef().isAllDay()) {
          dayEventsPayload[id] = eventInstanceGroup;
        } else {
          timedEventsPayload[id] = eventInstanceGroup;
        }
      }

      this.timeGrid.executeEventRender(timedEventsPayload);

      if (this.dayGrid) {
        this.dayGrid.executeEventRender(dayEventsPayload);
      }
    },

    /* Dragging/Resizing Routing
    ------------------------------------------------------------------------------------------------------------------*/
    // A returned value of `true` signals that a mock "helper" event has been rendered.
    renderDrag: function renderDrag(eventFootprints, seg, isTouch) {
      var groups = groupEventFootprintsByAllDay(eventFootprints);
      var renderedHelper = false;
      renderedHelper = this.timeGrid.renderDrag(groups.timed, seg, isTouch);

      if (this.dayGrid) {
        renderedHelper = this.dayGrid.renderDrag(groups.allDay, seg, isTouch) || renderedHelper;
      }

      return renderedHelper;
    },
    renderEventResize: function renderEventResize(eventFootprints, seg, isTouch) {
      var groups = groupEventFootprintsByAllDay(eventFootprints);
      this.timeGrid.renderEventResize(groups.timed, seg, isTouch);

      if (this.dayGrid) {
        this.dayGrid.renderEventResize(groups.allDay, seg, isTouch);
      }
    },

    /* Selection
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of a selection
    renderSelectionFootprint: function renderSelectionFootprint(componentFootprint) {
      if (!componentFootprint.isAllDay) {
        this.timeGrid.renderSelectionFootprint(componentFootprint);
      } else if (this.dayGrid) {
        this.dayGrid.renderSelectionFootprint(componentFootprint);
      }
    }
  }); // Methods that will customize the rendering behavior of the AgendaView's timeGrid
  // TODO: move into TimeGrid

  var agendaTimeGridMethods = {
    // Generates the HTML that will go before the day-of week header cells
    renderHeadIntroHtml: function renderHeadIntroHtml() {
      var view = this.view;
      var calendar = view.calendar;
      var weekStart = calendar.msToUtcMoment(this.dateProfile.renderUnzonedRange.startMs, true);
      var weekText;

      if (this.opt("weekNumbers")) {
        weekText = weekStart.format(this.opt("smallWeekFormat"));
        return "" + '<th class="fc-axis fc-week-number ' + calendar.theme.getClass("widgetHeader") + '" ' + view.axisStyleAttr() + ">" + view.buildGotoAnchorHtml( // aside from link, important for matchCellWidths
        {
          date: weekStart,
          type: "week",
          forceOff: this.colCnt > 1
        }, htmlEscape(weekText) // inner HTML
        ) + "</th>";
      } else {
        return '<th class="fc-axis ' + calendar.theme.getClass("widgetHeader") + '" ' + view.axisStyleAttr() + "></th>";
      }
    },
    // Generates the HTML that goes before the bg of the TimeGrid slot area. Long vertical column.
    renderBgIntroHtml: function renderBgIntroHtml() {
      var view = this.view;
      return '<td class="fc-axis ' + view.calendar.theme.getClass("widgetContent") + '" ' + view.axisStyleAttr() + "></td>";
    },
    // Generates the HTML that goes before all other types of cells.
    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
    renderIntroHtml: function renderIntroHtml() {
      var view = this.view;
      return '<td class="fc-axis" ' + view.axisStyleAttr() + "></td>";
    }
  }; // Methods that will customize the rendering behavior of the AgendaView's dayGrid

  var agendaDayGridMethods = {
    // Generates the HTML that goes before the all-day cells
    renderBgIntroHtml: function renderBgIntroHtml() {
      var view = this.view;
      return "" + '<td class="fc-axis ' + view.calendar.theme.getClass("widgetContent") + '" ' + view.axisStyleAttr() + ">" + "<span>" + // needed for matchCellWidths
      view.getAllDayHtml() + "</span>" + "</td>";
    },
    // Generates the HTML that goes before all other types of cells.
    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
    renderIntroHtml: function renderIntroHtml() {
      var view = this.view;
      return '<td class="fc-axis" ' + view.axisStyleAttr() + "></td>";
    }
  };

  function groupEventFootprintsByAllDay(eventFootprints) {
    var allDay = [];
    var timed = [];
    var i;

    for (i = 0; i < eventFootprints.length; i++) {
      if (eventFootprints[i].componentFootprint.isAllDay) {
        allDay.push(eventFootprints[i]);
      } else {
        timed.push(eventFootprints[i]);
      }
    }

    return {
      allDay: allDay,
      timed: timed
    };
  }

  var AGENDA_ALL_DAY_EVENT_LIMIT = 5; // potential nice values for the slot-duration and interval-duration
  // from largest to smallest

  var AGENDA_STOCK_SUB_DURATIONS = [{
    hours: 1
  }, {
    minutes: 30
  }, {
    minutes: 15
  }, {
    seconds: 30
  }, {
    seconds: 15
  }];
  fcViews.agenda = {
    "class": AgendaView,
    defaults: {
      allDaySlot: true,
      slotDuration: "00:30:00",
      slotEventOverlap: true // a bad name. confused with overlap/constraint system

    }
  };
  fcViews.agendaDay = {
    type: "agenda",
    duration: {
      days: 1
    }
  };
  fcViews.agendaWeek = {
    type: "agenda",
    duration: {
      weeks: 1
    }
  };
  /*
  Responsible for the scroller, and forwarding event-related actions into the "grid".
  */

  var ListView = FC.ListView = View.extend({
    segSelector: ".fc-list-item",
    // which elements accept event actions
    //eventRendererClass is below
    //eventPointingClass is below
    scroller: null,
    contentEl: null,
    dayDates: null,
    // localized ambig-time moment array
    dayRanges: null,
    // UnzonedRange[], of start-end of each day
    constructor: function constructor() {
      View.apply(this, arguments);
      this.scroller = new Scroller({
        overflowX: "hidden",
        overflowY: "auto"
      });
    },
    renderSkeleton: function renderSkeleton() {
      this.el.addClass("fc-list-view " + this.calendar.theme.getClass("listView"));
      this.scroller.render();
      this.scroller.el.appendTo(this.el);
      this.contentEl = this.scroller.scrollEl; // shortcut
    },
    unrenderSkeleton: function unrenderSkeleton() {
      this.scroller.destroy(); // will remove the Grid too
    },
    updateSize: function updateSize(totalHeight, isAuto, isResize) {
      this.scroller.setHeight(this.computeScrollerHeight(totalHeight));
    },
    computeScrollerHeight: function computeScrollerHeight(totalHeight) {
      return totalHeight - subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    },
    renderDates: function renderDates(dateProfile) {
      var calendar = this.calendar;
      var dayStart = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs, true);
      var viewEnd = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.endMs, true);
      var dayDates = [];
      var dayRanges = [];

      while (dayStart < viewEnd) {
        dayDates.push(dayStart.clone());
        dayRanges.push(new UnzonedRange(dayStart, dayStart.clone().add(1, "day")));
        dayStart.add(1, "day");
      }

      this.dayDates = dayDates;
      this.dayRanges = dayRanges;
      return this.dayDates; // all real rendering happens in EventRenderer
    },
    // slices by day
    componentFootprintToSegs: function componentFootprintToSegs(footprint) {
      var dayRanges = this.dayRanges;
      var dayIndex;
      var segRange;
      var seg;
      var segs = [];

      for (dayIndex = 0; dayIndex < dayRanges.length; dayIndex++) {
        segRange = footprint.unzonedRange.intersect(dayRanges[dayIndex]);

        if (segRange) {
          seg = {
            startMs: segRange.startMs,
            endMs: segRange.endMs,
            isStart: segRange.isStart,
            isEnd: segRange.isEnd,
            dayIndex: dayIndex
          };
          segs.push(seg); // detect when footprint won't go fully into the next day,
          // and mutate the latest seg to the be the end.

          if (!seg.isEnd && !footprint.isAllDay && dayIndex + 1 < dayRanges.length && footprint.unzonedRange.endMs < dayRanges[dayIndex + 1].startMs + this.nextDayThreshold) {
            seg.endMs = footprint.unzonedRange.endMs;
            seg.isEnd = true;
            break;
          }
        }
      }

      return segs;
    },
    eventRendererClass: EventRenderer.extend({
      renderFgSegs: function renderFgSegs(segs) {
        if (!segs.length) {
          this.component.renderEmptyMessage();
        } else {
          this.component.renderSegList(segs);
        }
      },
      // generates the HTML for a single event row
      fgSegHtml: function fgSegHtml(seg) {
        var view = this.view;
        var calendar = view.calendar;
        var theme = calendar.theme;
        var eventFootprint = seg.footprint;
        var eventDef = eventFootprint.eventDef;
        var componentFootprint = eventFootprint.componentFootprint;
        var url = eventDef.url;
        var classes = ["fc-list-item"].concat(this.getClasses(eventDef));
        var bgColor = this.getBgColor(eventDef);
        var timeHtml;

        if (componentFootprint.isAllDay) {
          timeHtml = view.getAllDayHtml();
        } // if the event appears to span more than one day
        else if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
          if (seg.isStart || seg.isEnd) {
            // outer segment that probably lasts part of the day
            timeHtml = htmlEscape(this._getTimeText(calendar.msToMoment(seg.startMs), calendar.msToMoment(seg.endMs), componentFootprint.isAllDay));
          } else {
            // inner segment that lasts the whole day
            timeHtml = view.getAllDayHtml();
          }
        } else {
          // Display the normal time text for the *event's* times
          timeHtml = htmlEscape(this.getTimeText(eventFootprint));
        }

        if (url) {
          classes.push("fc-has-url");
        }

        return '<tr class="' + classes.join(" ") + '">' + (this.displayEventTime ? '<td class="fc-list-item-time ' + theme.getClass("widgetContent") + '">' + (timeHtml || "") + "</td>" : "") + '<td class="fc-list-item-marker ' + theme.getClass("widgetContent") + '">' + '<span class="fc-event-dot"' + (bgColor ? ' style="background-color:' + bgColor + '"' : "") + "></span>" + "</td>" + '<td class="fc-list-item-title ' + theme.getClass("widgetContent") + '">' + "<a" + (url ? ' href="' + htmlEscape(url) + '"' : "") + ">" + htmlEscape(eventDef.title || "") + "</a>" + "</td>" + "</tr>";
      },
      // like "4:00am"
      computeEventTimeFormat: function computeEventTimeFormat() {
        return this.opt("mediumTimeFormat");
      }
    }),
    eventPointingClass: EventPointing.extend({
      // for events with a url, the whole <tr> should be clickable,
      // but it's impossible to wrap with an <a> tag. simulate this.
      handleClick: function handleClick(seg, ev) {
        var url;
        EventPointing.prototype.handleClick.apply(this, arguments); // super. might prevent the default action
        // not clicking on or within an <a> with an href

        if (!$(ev.target).closest("a[href]").length) {
          url = seg.footprint.eventDef.url;

          if (url && !ev.isDefaultPrevented()) {
            // jsEvent not cancelled in handler
            window.location.href = url; // simulate link click
          }
        }
      }
    }),
    renderEmptyMessage: function renderEmptyMessage() {
      this.contentEl.html('<div class="fc-list-empty-wrap2">' + // TODO: try less wraps
      '<div class="fc-list-empty-wrap1">' + '<div class="fc-list-empty">' + htmlEscape(this.opt("noEventsMessage")) + "</div>" + "</div>" + "</div>");
    },
    // render the event segments in the view
    renderSegList: function renderSegList(allSegs) {
      var segsByDay = this.groupSegsByDay(allSegs); // sparse array

      var dayIndex;
      var daySegs;
      var i;
      var tableEl = $('<table class="fc-list-table ' + this.calendar.theme.getClass("tableList") + '"><tbody/></table>');
      var tbodyEl = tableEl.find("tbody");

      for (dayIndex = 0; dayIndex < segsByDay.length; dayIndex++) {
        daySegs = segsByDay[dayIndex];

        if (daySegs) {
          // sparse array, so might be undefined
          // append a day header
          tbodyEl.append(this.dayHeaderHtml(this.dayDates[dayIndex]));
          this.eventRenderer.sortEventSegs(daySegs);

          for (i = 0; i < daySegs.length; i++) {
            tbodyEl.append(daySegs[i].el); // append event row
          }
        }
      }

      this.contentEl.empty().append(tableEl);
    },
    // Returns a sparse array of arrays, segs grouped by their dayIndex
    groupSegsByDay: function groupSegsByDay(segs) {
      var segsByDay = []; // sparse array

      var i, seg;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        (segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = [])).push(seg);
      }

      return segsByDay;
    },
    // generates the HTML for the day headers that live amongst the event rows
    dayHeaderHtml: function dayHeaderHtml(dayDate) {
      var mainFormat = this.opt("listDayFormat");
      var altFormat = this.opt("listDayAltFormat");
      return '<tr class="fc-list-heading" data-date="' + dayDate.format("YYYY-MM-DD") + '">' + '<td class="' + this.calendar.theme.getClass("widgetHeader") + '" colspan="3">' + (mainFormat ? this.buildGotoAnchorHtml(dayDate, {
        "class": "fc-list-heading-main"
      }, htmlEscape(dayDate.format(mainFormat)) // inner HTML
      ) : "") + (altFormat ? this.buildGotoAnchorHtml(dayDate, {
        "class": "fc-list-heading-alt"
      }, htmlEscape(dayDate.format(altFormat)) // inner HTML
      ) : "") + "</td>" + "</tr>";
    }
  });
  fcViews.list = {
    "class": ListView,
    buttonTextKey: "list",
    // what to lookup in locale files
    defaults: {
      buttonText: "list",
      // text to display for English
      listDayFormat: "LL",
      // like "January 1, 2016"
      noEventsMessage: "No events to display"
    }
  };
  fcViews.listDay = {
    type: "list",
    duration: {
      days: 1
    },
    defaults: {
      listDayFormat: "dddd" // day-of-week is all we need. full date is probably in header

    }
  };
  fcViews.listWeek = {
    type: "list",
    duration: {
      weeks: 1
    },
    defaults: {
      listDayFormat: "dddd",
      // day-of-week is more important
      listDayAltFormat: "LL"
    }
  };
  fcViews.listMonth = {
    type: "list",
    duration: {
      month: 1
    },
    defaults: {
      listDayAltFormat: "dddd" // day-of-week is nice-to-have

    }
  };
  fcViews.listYear = {
    type: "list",
    duration: {
      year: 1
    },
    defaults: {
      listDayAltFormat: "dddd" // day-of-week is nice-to-have

    }
  };
  return FC; // export for Node/CommonJS
});


"use strict";

(function () {
  angular.module("app.core").factory("utils", utils);

  function utils($document, $window, $http, globals) {
    var companyStore = globals.companyStore;
    return {
      roundNumber: function roundNumber(number) {
        var fractiondigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        return Math.round(number * Math.pow(10, fractiondigits)) / Math.pow(10, fractiondigits);
      },
      calcFileSize: function calcFileSize(bytes) {
        if (bytes < 1024) {
          return bytes + " Bytes";
        }

        var val = (bytes / 1024).toFixed(2);

        if (val < 1024) {
          return val + " KB";
        }

        val = (val / 1024).toFixed(2);

        if (val < 1024) {
          return val + " MB";
        } else {
          return val + " GB";
        }
      },
      getHttpFromHttps: function getHttpFromHttps(url) {
        if (url.includes('https')) return url.replace(/^https:\/\//i, 'http://');else return url;
      },
      isServerURL: function isServerURL(url) {
        return url.includes('http');
      },
      uuid4: function uuid4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
          return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
        });
      },
      bsonId: function bsonId() {
        var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
          return (Math.random() * 16 | 0).toString(16);
        }).toLowerCase();
      },
      getGlypthWidthForValueSlider: function getGlypthWidthForValueSlider(text) {
        var canvas = $document[0].createElement("canvas");
        var context = canvas.getContext('2d');
        context.font = "bold 18px Montserrat";
        var metrics = context.measureText(text);
        return metrics.width;
      },
      getRoundNumWithLocale: function getRoundNumWithLocale(number, place, locale) {
        if (angular.isUndefined(number) || number === null || isNaN(number)) {
          return '';
        }

        if (locale === 'eu') {
          var data = Number(number).toFixed(place);
          var ret = data ? data.replace(".", ",") : 0;
          var NO = ret.split(",");
          var result = NO[0];
          var change = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
          ret = change + "," + NO[1];
          return ret;
        } else {
          return Math.round(number * Math.pow(10, place)) / Math.pow(10, place);
        }
      },
      getNormalNumber: function getNormalNumber(numberString, locale) {
        var result;

        if (locale == 'en') {
          result = parseFloat(numberString.replace(/,/g, ''));
        } else if (locale == 'eu') {
          var newStr = numberString.replace(/\./g, '');
          result = parseFloat(newStr.replace(/,/g, '.'));
        }

        return result;
      },
      isEmpty: function isEmpty(param) {
        if (angular.isUndefined(param) || param === null) {
          return true;
        }

        if (angular.isDate(param)) {
          return false;
        }

        if (angular.isString(param)) {
          return !param.length;
        } else if (angular.isArray(param)) {
          return !param.length;
        } else if (angular.isObject(param)) {
          return !Object.keys(param).length;
        }

        return false;
      },
      isImageFile: function isImageFile(file) {
        if (!file || !file.type) return false;
        return file.type.indexOf('image') !== -1;
      },
      isPdfFile: function isPdfFile(file) {
        if (!file || !file.type) return false;
        return file.type.indexOf('pdf') !== -1;
      },
      getRandomString: function getRandomString() {
        var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
        var allAscii = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var maxLength = 62;
        var ret = "";
        length = length > maxLength ? maxLength : length;

        for (var i = 0; i < length; i++) {
          var index = Math.floor(Math.random() * 1000) % maxLength;
          ret += allAscii[index];
        }

        return ret;
      },
      makeBlob: function makeBlob(dataURL) {
        if (!dataURL) return;
        var BASE64_MARKER = ';base64,';

        if (dataURL.indexOf(BASE64_MARKER) === -1) {
          var _parts = dataURL.split(',');

          var _contentType = _parts[0].split(':')[1];

          var _raw = decodeURIComponent(_parts[1]);

          return new Blob([_raw], {
            type: _contentType
          });
        }

        var parts = dataURL.split(BASE64_MARKER);
        var contentType = parts[0].split(':')[1];
        var raw = $window.atob(parts[1]);
        var rawLength = raw.length;
        var uInt8Array = new Uint8Array(rawLength);

        for (var i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }

        return new Blob([uInt8Array], {
          type: contentType
        });
      },
      makeTextBlob: function makeTextBlob(data) {
        var text = angular.toJson(data);
        return new Blob([text], {
          type: 'text/plain;charset=utf-8'
        });
      },
      comma2decimal: function comma2decimal(number, place) {
        if (angular.isDefined(number)) {
          var data = Number(number).toFixed(place);
          var ret = data ? data.replace(".", ",") : 0;
          var NO = ret.split(",");
          var result = NO[0];
          var change = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
          ret = change + "," + NO[1];
          return ret;
        }

        return '';
      },
      convertNumFromEuropean: function convertNumFromEuropean(number) {
        var input = number.toString();

        if (this.isEuropean()) {
          return parseFloat(input.replace(/[,.]/g, function (x) {
            return x == "," ? "." : "";
          }));
        } else {
          return parseFloat(input.replace(/[,]/g, ''));
        }
      },
      rand: function rand(min, max) {
        var seed = angular.isDefined(this._seed) ? this._seed : Date.now();
        min = angular.isUndefined(min) ? 0 : min;
        max = angular.isUndefined(max) ? 1 : max;
        this._seed = (seed * 9301 + 49297) % 233280;
        return min + this._seed / 233280 * (max - min);
      },
      rgba2ha: function rgba2ha(rgba) {
        var sep = rgba.indexOf(",") > -1 ? "," : " ";
        if (rgba.startsWith('rgba(')) rgba = rgba.substr(5);else rgba = rgba.substr(4);
        rgba = rgba.split(")")[0].split(sep);
        var r = (+rgba[0]).toString(16),
            g = (+rgba[1]).toString(16),
            b = (+rgba[2]).toString(16),
            a = rgba[3];
        if (r.length === 1) r = "0" + r;
        if (g.length === 1) g = "0" + g;
        if (b.length === 1) b = "0" + b;
        return {
          color: "#" + r + g + b,
          opacity: a
        };
      },
      ha2rgba: function ha2rgba(h, a) {
        var r = 0,
            g = 0,
            b = 0;
        if (!h) h = '#ffffff';

        if (!h.startsWith('#')) {
          h = '#' + h;
        }

        if (h.length === 4) {
          // 3 digits
          r = "0x" + h[1] + h[1];
          g = "0x" + h[2] + h[2];
          b = "0x" + h[3] + h[3];
        } else if (h.length === 7) {
          // 6 digits
          r = "0x" + h[1] + h[2];
          g = "0x" + h[3] + h[4];
          b = "0x" + h[5] + h[6];
        } else if (h.length === 9) {
          // 8 digits
          r = "0x" + h[1] + h[2];
          g = "0x" + h[3] + h[4];
          b = "0x" + h[5] + h[6];
        }

        return "rgba(" + +r + "," + +g + "," + +b + "," + a + ")";
      },
      progressOfDate: function progressOfDate(startDate, endDate, date, remainAfter) {
        var now = date.getTime();
        var start = startDate.getTime();
        var end = endDate.getTime();
        return now <= start ? 0 : now > end ? remainAfter ? 1 : 0 : (now - start) / (end - start);
      },
      dateOfProgress: function dateOfProgress(startDate, endDate, progress) {
        var start = startDate.getTime();
        var end = endDate.getTime();
        var duration = end - start;
        var now = Math.ceil(start + duration * progress);
        return new Date(now);
      },
      isDateRangeOverlap: function isDateRangeOverlap(start1, end1, start2, end2) {
        return start1.getTime() <= end2.getTime() && start2.getTime() <= end1.getTime();
      },
      num: function num(n) {
        if (angular.isUndefined(n) || n === null || !isFinite(n)) return 0;
        return Number(n);
      },
      clamp: function clamp(value, min, max) {
        return Math.max(min, Math.min(value, max));
      },
      getExtensionByName: function getExtensionByName(name) {
        var re = /(?:\.([^.]+))?$/;
        return re.exec(name)[1];
      },
      getFileIcon: function getFileIcon(file) {
        file = file || {};
        var ext = file.format;

        if (angular.isUndefined(ext)) {
          ext = this.getExtensionByName(file.name);
        }

        return this.getFMFileIcon(ext);
      },
      getTqFileIcon: function getTqFileIcon(file) {
        file = file || {};
        var ext = file.format;

        if (angular.isUndefined(ext)) {
          ext = this.getExtensionByName(file.name);
        }

        return this.getTQFileIcon(ext);
      },
      getFMFileIcon: function getFMFileIcon(ext) {
        if (!ext || !angular.isString(ext)) {
          return 'assets/images/filetypes/pdf.png';
        }

        switch (ext.toLowerCase()) {
          case '3ds':
            return 'assets/images/filetypes/3ds.png';

          case 'aac':
            return 'assets/images/filetypes/aac.png';

          case 'ai':
            return 'assets/images/filetypes/ai.png';

          case 'avi':
            return 'assets/images/filetypes/avi.png';

          case 'bmp':
            return 'assets/images/filetypes/bmp.png';

          case 'cad':
            return 'assets/images/filetypes/cad.png';

          case 'cdr':
            return 'assets/images/filetypes/cdr.png';

          case 'css':
            return 'assets/images/filetypes/css.png';

          case 'dat':
            return 'assets/images/filetypes/dat.png';

          case 'dll':
            return 'assets/images/filetypes/dll.png';

          case 'dmg':
            return 'assets/images/filetypes/dmg.png';

          case 'doc':
          case 'docx':
            return 'assets/images/filetypes/doc.png';

          case 'eps':
            return 'assets/images/filetypes/eps.png';

          case 'fla':
            return 'assets/images/filetypes/fla.png';

          case 'flv':
            return 'assets/images/filetypes/flv.png';

          case 'gif':
            return 'assets/images/filetypes/gif.png';

          case 'html':
            return 'assets/images/filetypes/html.png';

          case 'ifc':
            return 'assets/images/filetypes/ifc.png';

          case 'indd':
            return 'assets/images/filetypes/indd.png';

          case 'iso':
            return 'assets/images/filetypes/iso.png';

          case 'jpg':
          case 'jpeg':
            return 'assets/images/filetypes/jpg.png';

          case 'js':
            return 'assets/images/filetypes/js.png';

          case 'midi':
            return 'assets/images/filetypes/midi.png';

          case 'mov':
            return 'assets/images/filetypes/mov.png';

          case 'mp3':
            return 'assets/images/filetypes/mp3.png';

          case 'mpg':
            return 'assets/images/filetypes/mpg.png';

          case 'pdf':
            return 'assets/images/filetypes/pdf.png';

          case 'php':
            return 'assets/images/filetypes/php.png';

          case 'png':
            return 'assets/images/filetypes/png.png';

          case 'ppt':
          case 'pptx':
            return 'assets/images/filetypes/ppt.png';

          case 'ps':
            return 'assets/images/filetypes/ps.png';

          case 'psd':
            return 'assets/images/filetypes/psd.png';

          case 'raw':
            return 'assets/images/filetypes/raw.png';

          case 'sql':
            return 'assets/images/filetypes/sql.png';

          case 'tif':
            return 'assets/images/filetypes/tif.png';

          case 'txt':
            return 'assets/images/filetypes/txt.png';

          case 'wmv':
            return 'assets/images/filetypes/wmv.png';

          case 'xls':
          case 'xlsx':
            return 'assets/images/filetypes/xls.png';

          case 'xml':
            return 'assets/images/filetypes/xml.png';

          case 'zip':
            return 'assets/images/filetypes/zip.png';

          default:
            return 'assets/images/filetypes/pdf.png';
        }
      },
      getTQFileIcon: function getTQFileIcon(ext) {
        if (!ext || !angular.isString(ext)) {
          return 'assets/images/tqfiletypes/pdf.png';
        }

        switch (ext.toLowerCase()) {
          case '3ds':
            return 'assets/images/tqfiletypes/3ds.png';

          case 'aac':
            return 'assets/images/tqfiletypes/aac.png';

          case 'ai':
            return 'assets/images/tqfiletypes/ai.png';

          case 'avi':
            return 'assets/images/tqfiletypes/avi.png';

          case 'bmp':
            return 'assets/images/tqfiletypes/bmp.png';

          case 'cad':
            return 'assets/images/tqfiletypes/cad.png';

          case 'cdr':
            return 'assets/images/tqfiletypes/cdr.png';

          case 'css':
            return 'assets/images/tqfiletypes/css.png';

          case 'dat':
            return 'assets/images/tqfiletypes/dat.png';

          case 'dll':
            return 'assets/images/tqfiletypes/dll.png';

          case 'dmg':
            return 'assets/images/tqfiletypes/dmg.png';

          case 'doc':
          case 'docx':
            return 'assets/images/tqfiletypes/doc.png';

          case 'eps':
            return 'assets/images/tqfiletypes/eps.png';

          case 'fla':
            return 'assets/images/tqfiletypes/fla.png';

          case 'flv':
            return 'assets/images/tqfiletypes/flv.png';

          case 'gif':
            return 'assets/images/tqfiletypes/gif.png';

          case 'html':
            return 'assets/images/tqfiletypes/html.png';

          case 'ifc':
            return 'assets/images/tqfiletypes/ifc.png';

          case 'indd':
            return 'assets/images/tqfiletypes/indd.png';

          case 'iso':
            return 'assets/images/tqfiletypes/iso.png';

          case 'jpg':
          case 'jpeg':
            return 'assets/images/tqfiletypes/jpg.png';

          case 'js':
            return 'assets/images/tqfiletypes/js.png';

          case 'midi':
            return 'assets/images/tqfiletypes/midi.png';

          case 'mov':
            return 'assets/images/tqfiletypes/mov.png';

          case 'mp3':
            return 'assets/images/tqfiletypes/mp3.png';

          case 'mpg':
            return 'assets/images/tqfiletypes/mpg.png';

          case 'pdf':
            return 'assets/images/tqfiletypes/pdf.png';

          case 'php':
            return 'assets/images/tqfiletypes/php.png';

          case 'png':
            return 'assets/images/tqfiletypes/png.png';

          case 'ppt':
          case 'pptx':
            return 'assets/images/tqfiletypes/ppt.png';

          case 'ps':
            return 'assets/images/tqfiletypes/ps.png';

          case 'psd':
            return 'assets/images/tqfiletypes/psd.png';

          case 'raw':
            return 'assets/images/tqfiletypes/raw.png';

          case 'sql':
            return 'assets/images/tqfiletypes/sql.png';

          case 'tif':
            return 'assets/images/tqfiletypes/tif.png';

          case 'txt':
            return 'assets/images/tqfiletypes/txt.png';

          case 'wmv':
            return 'assets/images/tqfiletypes/wmv.png';

          case 'xls':
          case 'xlsx':
            return 'assets/images/tqfiletypes/xls.png';

          case 'xml':
            return 'assets/images/tqfiletypes/xml.png';

          case 'zip':
            return 'assets/images/tqfiletypes/zip.png';

          default:
            return 'assets/images/tqfiletypes/pdf.png';
        }
      },
      getFileIconFromName: function getFileIconFromName(name) {
        var ext = undefined;

        if (name) {
          var names = name.split('.');
          ext = names[names.length - 1];
        }

        return this.getFMFileIcon(ext);
      },
      getErrorMessage: function getErrorMessage(error) {
        var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
        return error && error.data && error.data.message ? error.data.message : angular.isDefined(message) ? message : error.status === 404 ? 'Not found API' : 'Internal server error';
      },
      sumReducer: function sumReducer(acc, val) {
        return acc + val;
      },
      _nameLetter: function _nameLetter(name) {
        var names = name.split(' ');

        if (names.length > 1) {
          return (names[0].charAt(0) + names[1].charAt(0)).toUpperCase();
        } else if (name.charAt(0).match(/[a-z]/i) && /[0-9]/g.test(name)) {
          var strNum = name.replace(/^\D+/g, '');
          return (name.charAt(0) + strNum.charAt(0)).toUpperCase();
        }

        return name.substring(0, 2).toUpperCase();
      },
      nameLetter: function nameLetter(firstName) {
        var lastName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

        if (!this.isEmpty(firstName) && !this.isEmpty(lastName)) {
          return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
        } else if (!this.isEmpty(firstName) || !this.isEmpty(lastName)) {
          return this._nameLetter(firstName || lastName);
        } else {
          return '';
        }
      },
      capitaliseFirstLetter: function capitaliseFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      },
      getFormatDescription: function getFormatDescription(format) {
        if (this.isEmpty(format)) {
          return 'Unknown';
        }

        switch (format.toLowerCase()) {
          case 'pdf':
            return 'PDF Document';

          case 'jpg':
          case 'jpeg':
            return 'JPEG Image';

          case 'png':
            return 'PNG Image';

          case 'csv':
            return 'CSV Document';

          case 'doc':
          case 'docx':
            return 'Microsoft Office Word Document';

          case 'xls':
          case 'xlsx':
            return 'Microsoft Office Excel Document';

          case 'ppt':
          case 'pptx':
            return 'Microsoft Office PowerPoint Document';

          default:
            return format.toUpperCase() + ' File';
        }
      },
      getDaysFromPaymentTermsCode: function getDaysFromPaymentTermsCode(code) {
        if (!code) return;
        var result = {
          days: 0
        };
        var newCode = code;

        if (code.includes('RM')) {
          result.m = true;
          newCode = code.replace("RM", '');
        } else if (code.includes('RW')) {
          result.w = true;
          newCode = code.replace("RW", '');
        }

        if (newCode.includes('+')) {
          newCode = newCode.replace("+", '');
        }

        if (newCode.includes('D')) {
          newCode = newCode.replace("D", '');
        }

        var value = parseInt(newCode);

        if (!isNaN(value)) {
          result.days = value;
        }

        return result;
      },
      getFileNameFromUrl: function getFileNameFromUrl(url) {
        return url.split('/').pop();
      },
      getFileNameWithoutExtension: function getFileNameWithoutExtension(url) {
        return url.split('/').pop().replace(/\.[^.]+$/, '');
      },
      changeExtension: function changeExtension(fileName, ext) {
        var pos = fileName.lastIndexOf(".");
        return fileName.substr(0, pos < 0 ? fileName.length : pos) + "." + ext;
      },
      dataURLtoFile: function dataURLtoFile(dataUrl, filename) {
        var arr = dataUrl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, {
          type: mime
        });
      },
      getBase64: function getBase64(file) {
        return new Promise(function (resolve, reject) {
          var reader = new FileReader();
          reader.readAsDataURL(file);

          reader.onload = function () {
            return resolve(reader.result);
          };

          reader.onerror = function (error) {
            return reject(error);
          };
        });
      },
      downloadFile: function downloadFile(url) {
        var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
        return new Promise(function (resolve, reject) {
          if (!url) {
            reject({
              message: 'URL is not found.'
            });
            return;
          }

          var downloadFileName = fileName;

          if (angular.isUndefined(fileName)) {
            var arr = url.trim().split('/');
            var underlineName = arr[arr.length - 1] || 'download.pdf';
            arr = underlineName.trim().split('_');
            downloadFileName = arr[arr.length - 1];
          }

          $http.get(url, {
            responseType: "arraybuffer"
          }).then(function (response) {
            resolve();
            var headers = response.headers();
            headers["Content-Disposition"] = "attachment";
            var blob = new Blob([response.data], {
              type: "octet/stream"
            });
            var link = $document[0].createElement("a");
            link.href = $window.URL.createObjectURL(blob);
            link.download = downloadFileName;
            $document[0].body.appendChild(link);
            link.click();
            $document[0].body.removeChild(link);
          })["catch"](function (err) {
            reject(err);
          });
        });
      },
      downloadFiles: function downloadFiles(urls) {
        return new Promise(function (resolve, reject) {
          if (!urls || !urls.length) {
            reject({
              message: 'URLs is empty.'
            });
            return;
          }

          var promises = urls.map(function (url) {
            return $http.get(url, {
              responseType: "arraybuffer"
            });
          });
          Promise.all(promises).then(function (resp) {
            for (var i = 0; i < resp.length; i++) {
              var headers = resp[i].headers();
              headers["Content-Disposition"] = "attachment";
              var blob = new Blob([resp[i].data], {
                type: "octet/stream"
              });
              var link = $document[0].createElement("a");
              link.href = $window.URL.createObjectURL(blob);
              link.download = urls[i].split('/').pop();
              $document[0].body.appendChild(link);
              link.click();
              $document[0].body.removeChild(link);
            }

            resolve();
          })["catch"](function (err) {
            reject(err);
          });
        });
      },
      teamColors: ["#FFB900", "#D83B01", "#B50E0E", "#E81123", "#B4009E", "#5C2D91", "#0078D7", "#00B4FF", "#008272", "#107C10"],
      getTeamColor: function getTeamColor(chars) {
        if (!chars) {
          return;
        }

        var codeNum = 0;

        if (chars.length < 2 && chars[0]) {
          codeNum = chars.charCodeAt(0);
        } else if (chars.length >= 2 && chars[0]) {
          codeNum = chars.charCodeAt(0);
        } else if (chars.length >= 2 && chars[1]) {
          codeNum += chars.charCodeAt(1);
        }

        return this.teamColors[codeNum % this.teamColors.length];
      },
      getAddressString: function getAddressString(address) {
        if (this.isEmpty(address)) {
          return '';
        }

        if (angular.isString(address)) {
          return address;
        }

        if (!angular.isObject(address)) {
          return '';
        }

        var addressList = [];

        if (!this.isEmpty(address.line1)) {
          addressList.push(address.line1);
        }

        if (!this.isEmpty(address.line2)) {
          addressList.push(address.line2);
        }

        if (!this.isEmpty(address.line3)) {
          addressList.push(address.line3);
        }

        if (!this.isEmpty(address.city)) {
          addressList.push(address.city);
        }

        if (!this.isEmpty(address.postalCode)) {
          addressList.push(address.postalCode);
        }

        if (!this.isEmpty(address.countryCode)) {
          addressList.push(address.countryCode);
        }

        return addressList.join(', ');
      },
      isValidDuration: function isValidDuration(start, end) {
        if (start - end > 0) {
          return false;
        }

        var startWeekday = start.getDay();
        var endWeekday = end.getDay();
        var workHours = Math.abs(end - start) / 3600000 / 3;
        var restDays = Math.floor(workHours / 8 / 7) * 2;

        if (startWeekday === 0 || startWeekday === 6) {
          restDays += 1;
        }

        if (endWeekday === 0 || endWeekday === 6) {
          restDays += 1;
        }

        workHours -= restDays * 8;
        return workHours > 0;
      },
      getTimeFromString: function getTimeFromString(str) {
        var result = {
          hour: 0,
          minute: 0
        };
        if (!str) return result;
        var arr = str.split('.');

        if (arr[0]) {
          result.hour = Number(arr[0]);
        }

        if (arr[1]) {
          result.minute = Number(arr[1]);
        }

        return result;
      },
      getHoursFromDate: function getHoursFromDate(date) {
        return date.getHours() + date.getMinutes() / 60;
      },
      generateUTCDate: function generateUTCDate(y, m, d) {
        var ret = new Date();
        ret.setUTCFullYear(y);
        ret.setUTCMonth(m);
        ret.setUTCDate(d);
        return ret;
      },
      getWorkingHours: function getWorkingHours(startDate, endDate) {
        var startWeekday = startDate.getDay();
        var endWeekday = endDate.getDay();
        var workHours = Math.abs(endDate.getTime() - startDate.getTime()) / 3600000 / 3;
        var restDays = Math.floor(workHours / 8 / 7) * 2;

        if (startWeekday === 0 || startWeekday === 6) {
          restDays += 1;
        }

        if (endWeekday === 0 || endWeekday === 6) {
          restDays += 1;
        }

        workHours -= restDays * 8;
        return workHours;
      },
      getRemainingTime: function getRemainingTime(date) {
        return moment(new Date(date)).from(new Date());
      },
      timeInRange: function timeInRange(time, begin, end) {
        return time.getTime() >= begin.getTime() && time.getTime() <= end.getTime();
      },
      getDurationDayInRange: function getDurationDayInRange(from, to) {
        return moment.duration(moment(to).diff(moment(from))).asDays();
      },
      getDurationInRange: function getDurationInRange(from, to, rangeBegin, rangeEnd) {
        var fromTime = from.getTime();
        var toTime = to.getTime();
        var beginTime = rangeBegin.getTime();
        var endTime = rangeEnd.getTime();

        if (fromTime > endTime || toTime < beginTime) {
          return 0;
        }

        if (beginTime < fromTime) {
          beginTime = fromTime;
        }

        if (endTime > toTime) {
          endTime = toTime;
        }

        return endTime - beginTime;
      },
      unitize: function unitize(value) {
        var absValue = Math.abs(value);

        if (absValue >= 1000000000) {
          value /= 1000000000;
          value = Math.round(value * 100) / 100;
          value += 'G';
        } else if (absValue >= 1000000) {
          value /= 1000000;
          value = Math.round(value * 100) / 100;
          value += 'M';
        } else if (absValue >= 1000) {
          value /= 1000;
          value = Math.round(value * 100) / 100;
          value += 'K';
        }

        return value;
      },
      makeReadable: function makeReadable(value, place, european) {
        var data = Number(value).toFixed(place);

        if (european) {
          var ret = data ? data.replace(".", ",") : 0;
          var NO = ret.split(",");
          var result = NO[0];
          var change = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");

          if (NO[1]) {
            ret = change + "," + NO[1];
          } else {
            ret = change;
          }

          return ret;
        } else {
          return this.numberWithCommas(data);
        }
      },
      isEuropean: function isEuropean() {
        var company = companyStore.get();
        return company && company.companyInputMethod === 'European et al.';
      },
      isToday: function isToday(someDate) {
        var today = new Date();
        return someDate.getDate() == today.getDate() && someDate.getMonth() == today.getMonth() && someDate.getFullYear() == today.getFullYear();
      },
      isValidDate: function isValidDate(d) {
        return d instanceof Date && !isNaN(d) && new Date(d).getFullYear() != 1970;
      },
      unit2array: function unit2array(unit) {
        if (/\d/.test(unit)) {
          return unit.replace(/'/g, '').split(/(\d+)/).filter(Boolean);
        }

        return [unit];
      },
      numberWithCommas: function numberWithCommas(x) {
        if (this.isEuropean()) {
          x = x.replace('.', ',');
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        } else {
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      },
      paddedSystemTag: function paddedSystemTag(systemTag, padLen) {
        if (this.isEmpty(systemTag)) {
          return '';
        }

        var arr = systemTag.replace(/'/g, '').split(/(\d+)/).filter(Boolean);
        return arr.length >= 2 ? arr[0] + arr[1].padStart(padLen, "0") : systemTag;
      },
      numConsiderInputMethod: function numConsiderInputMethod(numText) {
        var inputMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "European et al.";

        if (!numText) {
          return 0;
        }

        if (inputMethod === "European et al.") {
          var text = numText.replaceAll(/\./g, "");
          text = text.replaceAll(/,/g, ".");
          return Number(text);
        } else {
          var _text = numText.replaceAll(/,/g, "");

          return Number(_text);
        }
      },
      roundNum: function roundNum(x) {
        var place = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        if (!x) return 0;
        return x.toFixed(place);
      },
      convertNum: function convertNum(num) {
        var place = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

        if (this.isEuropean()) {
          return this.comma2decimal(num, place);
        } else {
          return this.roundNum(num, place);
        }
      },
      compareTwoStrings: function compareTwoStrings(first, second) {
        first = first.replace(/\s+/g, '');
        second = second.replace(/\s+/g, '');
        if (first === second) return 1;
        if (first.length < 2 || second.length < 2) return 0;
        var firstBigrams = new Map();

        for (var i = 0; i < first.length - 1; i++) {
          var bigram = first.substring(i, i + 2);
          var count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) + 1 : 1;
          firstBigrams.set(bigram, count);
        }

        var intersectionSize = 0;

        for (var _i = 0; _i < second.length - 1; _i++) {
          var _bigram = second.substring(_i, _i + 2);

          var _count = firstBigrams.has(_bigram) ? firstBigrams.get(_bigram) : 0;

          if (_count > 0) {
            firstBigrams.set(_bigram, _count - 1);
            intersectionSize++;
          }
        }

        return 2.0 * intersectionSize / (first.length + second.length - 2);
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").factory("unitFactory", unitFactory);

  function unitFactory() {
    return {
      mUnits: [{
        name: "mm",
        value: "mm"
      }, {
        name: "cm",
        value: "cm"
      }, {
        name: "m",
        value: "m"
      }, {
        name: "km",
        value: "km"
      }, {
        name: "mm2",
        value: "mm2"
      }, {
        name: "cm2",
        value: "cm2"
      }, {
        name: "m2",
        value: "m2"
      }, {
        name: "km2",
        value: "km2"
      }, {
        name: "mm3",
        value: "mm3"
      }, {
        name: "cm3",
        value: "cm3"
      }, {
        name: "m3",
        value: "m3"
      }, {
        name: "km3",
        value: "km3"
      }, {
        name: "in",
        value: "in"
      }, {
        name: "ft",
        value: "ft"
      }, {
        name: "in2",
        value: "in2"
      }, {
        name: "ft2",
        value: "ft2"
      }, {
        name: "in3",
        value: "in3"
      }, {
        name: "ft3",
        value: "ft3"
      }, {
        name: "pcs",
        value: "pcs"
      }, {
        name: "kg",
        value: "kg"
      }, {
        value: "hrs",
        name: "hrs"
      }, {
        value: "days",
        name: "days"
      }],
      distanceRate: [{
        name: "km",
        rate: 1
      }, {
        name: "m",
        rate: 1000
      }, {
        name: "cm",
        rate: 100000
      }, {
        name: "mile",
        rate: 0.621371
      }, {
        name: "foot",
        rate: 3280.84
      }],
      meterToFeetRate: 3.281,
      materialUnits: function materialUnits() {
        var _this = this;

        return this.mUnits.filter(function (x) {
          return !_this.isTime(x.value);
        });
      },
      distanceUnits: function distanceUnits() {
        var _this2 = this;

        return this.mUnits.filter(function (x) {
          return _this2.isLength(x.value);
        });
      },
      timeUnits: function timeUnits() {
        var _this3 = this;

        return this.mUnits.filter(function (x) {
          return _this3.isTime(x.value);
        });
      },
      isLength: function isLength(unit) {
        return unit === 'm' || unit === 'cm' || unit === 'mm' || unit === 'km' || unit === 'ft' || unit === 'mile' || unit === 'pcs';
      },
      isArea: function isArea(unit) {
        return unit === 'm2' || unit === 'cm2' || unit === 'mm2' || unit === 'km2' || unit === 'ft2' || unit === 'mile2' || unit === 'pcs2';
      },
      isVolume: function isVolume(unit) {
        return unit === 'm3' || unit === 'cm3' || unit === 'mm3' || unit === 'km3' || unit === 'ft3' || unit === 'mile3' || unit === 'pcs3';
      },
      isTime: function isTime(unit) {
        return unit === 'hrs' || unit === 'days' || unit === 'weeks' || unit === 'months';
      },
      isWeight: function isWeight(unit) {
        return unit === 'g' || unit === 'mg' || unit === 'kg';
      },
      getDimension: function getDimension(unit) {
        var result = false;
        var index = unit.indexOf('2');

        if (index >= 0) {
          result = {
            dim: 2,
            unit: unit.slice(0, index)
          };
        } else {
          index = unit.indexOf('3');

          if (index >= 0) {
            result = {
              dim: 3,
              unit: unit.slice(0, index)
            };
          }
        }

        if (!result) {
          var subs = unit.split('.');
          if (subs.length === 0 || subs.length > 2) return result;

          if (subs.length === 1) {
            result = {
              dim: 1,
              unit: unit
            };
          } else {
            if (subs[0] === 'sq') {
              result = {
                dim: 2,
                unit: subs[1]
              };
            } else if (subs[0] === 'cu') {
              result = {
                dim: 3,
                unit: subs[1]
              };
            }
          }
        }

        return result;
      },
      checkUnitDefined: function checkUnitDefined(unit) {
        var units = ['inch', 'm', 'cm', 'mm', 'ft', 'km', 'mile'];
        var newUnit = unit;

        if (newUnit === 'mt') {
          newUnit = 'm';
        } else if (newUnit === 'in') {
          newUnit = 'inch';
        } else if (newUnit === 'pcs') {
          newUnit = 'm';
        }

        if (units.indexOf(newUnit) >= 0) {
          return newUnit;
        } else {
          return false;
        }
      },
      getScaleRatio: function getScaleRatio(input, output) {
        var scale = convertToMeter(input);
        var scaleTmp = convertToMeter(output);
        scale /= scaleTmp;

        function convertToMeter(unit) {
          var ratio = 1;

          switch (unit) {
            case 'inch':
              ratio = 0.0254;
              break;

            case 'm':
              ratio = 1;
              break;

            case 'cm':
              ratio = 0.01;
              break;

            case 'mm':
              ratio = 0.001;
              break;

            case 'ft':
              ratio = 0.3048;
              break;

            case 'km':
              ratio = 1000;
              break;

            case 'mile':
              ratio = 1609.34;
              break;

            default:
              break;
          }

          return ratio;
        }

        return scale;
      },
      getValueWithAbsoluteUnit: function getValueWithAbsoluteUnit(value, unit, isInverted) {
        var scale = 1;

        switch (unit) {
          case 'cm':
            scale = 0.01;
            if (isInverted) scale = 100;
            break;

          case 'mm':
            scale = 0.001;
            if (isInverted) scale = 1000;
            break;

          case 'km':
            scale = 1000;
            if (isInverted) scale = 0.001;
            break;

          case 'inch':
            scale = 0.0254;
            if (isInverted) scale = 39.3701;
            break;

          default:
            break;
        }

        return value * scale;
      }
    };
  }
})();


"use strict";

/* eslint-disable no-undef */
(function () {
  angular.module("app.core").factory("synergySocket", synergySocket);

  function synergySocket($rootScope, $log, SYNERGY_CONSTANTS, globals) {
    var socket;
    var onSocket, emitSocket, offSocket;

    var initConnect = function initConnect() {
      // disconnect current connection, if present
      if (socket) {
        socket.disconnect();
      } // let configOpts = { transports: ["websocket", "polling", "flashsocket"] };


      var configOpts = {}; // auth config using token

      var token = globals.syenrgyStore.getValidClientToken();

      if (token) {
        configOpts.auth = {
          token: token
        };
      }

      socket = io(SYNERGY_CONSTANTS.CHAT_API_URL, configOpts);
      socket.on("connect", function () {
        $log.log("synergy socket factory -- ", "event 'connect' -- ", "synergy chat api url -- ", SYNERGY_CONSTANTS.CHAT_API_URL, "configOpts -- ", configOpts, " socket -- ", socket);
      });
      socket.on("connect_error", function () {
        $log.log("synergy socket factory -- ", "event 'connect_error' -- ", " socket -- ", socket);
      });
      socket.on("disconnect", function (reason) {
        $log.log("synergy socket factory -- ", "event 'disconnect' -- ", "reason -- ", reason, " socket -- ", socket);
      });

      onSocket = function onSocket(eventName, callback) {
        socket.on(eventName, function () {
          var args = arguments;
          $rootScope.$apply(function () {
            callback.apply(socket, args);
          });
        });
      };

      emitSocket = function emitSocket(eventName, data, callback) {
        socket.emit(eventName, data, function () {
          var args = arguments;
          $rootScope.$apply(function () {
            if (callback) {
              callback.apply(socket, args);
            }
          });
        });
      };

      offSocket = function offSocket(eventName, callback) {
        if (typeof callback == "function") {
          socket.removeListener(eventName, callback);
        } else {
          socket.removeAllListeners(eventName);
        }
      };
    };

    initConnect();
    return {
      on: onSocket,
      emit: emitSocket,
      off: offSocket,
      reset: initConnect
    };
  }
})();


"use strict";

/* eslint-disable no-undef */
(function () {
  angular.module("app.core").factory("synergyOrgChatSocket", synergyOrgChatSocket);

  function synergyOrgChatSocket($rootScope, $log, SYNERGY_CONSTANTS, globals) {
    var socket;
    var onSocket, emitSocket, offSocket;

    var initConnect = function initConnect() {
      // disconnect current connection, if present
      if (socket) {
        socket.disconnect();
      } // let configOpts = { transports: ["websocket", "polling", "flashsocket"] };


      var configOpts = {}; // auth config using token

      var token = globals.syenrgyOrgChatStore.getValidOrgChatClientToken();

      if (token) {
        configOpts.auth = {
          token: token
        };
      }

      socket = io(SYNERGY_CONSTANTS.CHAT_API_URL, configOpts);
      socket.on("connect", function () {
        $log.log("synergy org chat socket factory -- ", "event 'connect' -- ", "synergy chat api url -- ", SYNERGY_CONSTANTS.CHAT_API_URL, "configOpts -- ", configOpts, " socket -- ", socket);
      });
      socket.on("connect_error", function () {
        $log.log("synergy org chat socket factory -- ", "event 'connect_error' -- ", " socket -- ", socket);
      });
      socket.on("disconnect", function (reason) {
        $log.log("synergy org chat socket factory -- ", "event 'disconnect' -- ", "reason -- ", reason, " socket -- ", socket);
      });

      onSocket = function onSocket(eventName, callback) {
        socket.on(eventName, function () {
          var args = arguments;
          $rootScope.$apply(function () {
            callback.apply(socket, args);
          });
        });
      };

      emitSocket = function emitSocket(eventName, data, callback) {
        socket.emit(eventName, data, function () {
          var args = arguments;
          $rootScope.$apply(function () {
            if (callback) {
              callback.apply(socket, args);
            }
          });
        });
      };

      offSocket = function offSocket(eventName, callback) {
        if (typeof callback == "function") {
          socket.removeListener(eventName, callback);
        } else {
          socket.removeAllListeners(eventName);
        }
      };
    };

    initConnect();
    return {
      on: onSocket,
      emit: emitSocket,
      off: offSocket,
      reset: initConnect
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").factory("storageFactory", storageFactory);

  function storageFactory(apiFactory, $log, indexeddbFactory) {
    var queryProjectList = function queryProjectList(list, queryObj) {
      var res = angular.copy(list);

      if (queryObj && queryObj.type) {
        var type = queryObj.type;
        res = res.filter(function (x) {
          if (type == 'completed') {
            return x.projectStatus == 2;
          } else if (type == 'ongoing') {
            return x.projectStatus == 1;
          } else {
            if (x.projectStatus == 2) return false;

            if (type == 'tender') {
              return x.isTenderProject == true;
            } else {
              if (x.isTenderProject == true) return false;

              if (type == 'service') {
                return x.isServiceProject == true;
              } else if (type == 'general') {
                return x.isServiceProject != true;
              }
            }
          }
        });
      }

      if (queryObj && queryObj.search) {
        res = res.filter(function (x) {
          if (x.projectName.toLowerCase().match(queryObj.search.toLowerCase())) return true; // if (x.projectDescription.indexOf(queryObj.search) > -1) return true;
          // if (x.systemTag.indexOf(queryObj.search) > -1) return true;
          // if (x.client.clientName.indexOf(queryObj.search) > -1) return true;
          // if (x.address.line1.indexOf(queryObj.search) > -1) return true;
          // if (x.address.line2.indexOf(queryObj.search) > -1) return true;
          // if (x.address.line3.indexOf(queryObj.search) > -1) return true;
          // if (x.address.city.indexOf(queryObj.search) > -1) return true;

          return false;
        });
      }

      return res;
    };

    var paginateProjectList = function paginateProjectList(list, queryObj) {
      var res = angular.copy(list);

      if (queryObj && queryObj.sort && queryObj.sortType) {
        res = res.sort(function (a, b) {
          if (queryObj.sortType == "true") {
            if (b[queryObj.sort] < a[queryObj.sort]) return 1;
            if (b[queryObj.sort] > a[queryObj.sort]) return -1;
            return 0;
          } else {
            if (b[queryObj.sort] > a[queryObj.sort]) return 1;
            if (b[queryObj.sort] < a[queryObj.sort]) return -1;
            return 0;
          }
        });
      }

      if (queryObj && queryObj.page && queryObj.chunk) {
        var page = parseInt(queryObj.page);
        var cnt = parseInt(queryObj.chunk);
        res = res.slice((page - 1) * cnt, page * cnt);
      }

      return res;
    };

    return {
      getBookmarks: function getBookmarks() {
        return new Promise(function (r, e) {
          indexeddbFactory.open("CloudESDB", "all_projects").then(function () {
            indexeddbFactory.get("all_projects").then(function (projectDataList) {
              var projectsData = projectDataList[0];
              apiFactory.getBookmarkIDs().then(function (response) {
                var bookmarkedIds = response.data.bookmarks;
                apiFactory.getResourceStatus().then(function (resp) {
                  var reload = false;
                  var statusList = resp.data.list;
                  var projectStatus = statusList.find(function (x) {
                    return x.resourceKey == "all_projects";
                  });

                  if (!projectsData) {
                    reload = true;
                  } else if (projectStatus) {
                    var stamp = new Date(projectStatus.updatedAt).getTime();

                    if (stamp > projectsData.stamp) {
                      reload = true;
                    }
                  }

                  if (reload) {
                    $log.log('Must reload Project Data for Storage Factory');

                    var _stamp = new Date().getTime();

                    apiFactory.fetchAllProjects() // apiFactory.listAllProjects({
                    // 	fields: "projectName, projectDescription, address, projectStatus, buildingType, enterpriseType, startDate, endDate, projectImage, isTenderProject, isServiceProject"
                    // })
                    .then(function (res) {
                      var data = {
                        list: res.data.list,
                        stamp: _stamp
                      };
                      indexeddbFactory.clear("all_projects").then(function () {
                        indexeddbFactory.set("all_projects", data).then(function () {
                          $log.log('Set Data success to Storage Factory');
                          var list = res.data.list.filter(function (x) {
                            if (bookmarkedIds.indexOf(x._id) > -1) return true;
                            return false;
                          });
                          r({
                            data: {
                              bookmarks: list
                            }
                          });
                        });
                      });
                    })["catch"](function (err) {
                      e(err);
                    });
                  } else {
                    $log.log('Returning data in storage');
                    var list = projectsData.list.filter(function (x) {
                      if (bookmarkedIds.indexOf(x._id) > -1) return true;
                      return false;
                    });
                    r({
                      data: {
                        bookmarks: list
                      }
                    });
                  }
                })["catch"](function (err) {
                  e(err);
                });
              })["catch"](function (err) {
                e(err);
              });
            });
          });
        });
      },
      listAllProjects: function listAllProjects() {
        var queryObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        return new Promise(function (r, e) {
          indexeddbFactory.open("CloudESDB", "all_projects").then(function () {
            $log.log('opened indexed db database!');
            indexeddbFactory.get("all_projects").then(function (projectDataList) {
              var projectsData = projectDataList[0];
              apiFactory.getResourceStatus().then(function (resp) {
                var reload = false;
                var statusList = resp.data.list;
                var projectStatus = statusList.find(function (x) {
                  return x.resourceKey == "all_projects";
                });

                if (!projectsData) {
                  reload = true;
                } else if (projectStatus) {
                  var stamp = new Date(projectStatus.updatedAt).getTime();

                  if (stamp > projectsData.stamp) {
                    reload = true;
                  }
                }

                if (reload) {
                  $log.log('Must reload Project Data for Storage Factory');

                  var _stamp2 = new Date().getTime();

                  apiFactory.fetchAllProjects() // apiFactory.listAllProjects({
                  // 	fields: "projectName, projectDescription, address, projectStatus, buildingType, enterpriseType, startDate, endDate, projectImage, isTenderProject, isServiceProject"
                  // })
                  .then(function (res) {
                    var data = {
                      list: res.data.list,
                      stamp: _stamp2
                    };
                    indexeddbFactory.clear("all_projects").then(function () {
                      indexeddbFactory.set("all_projects", data).then(function () {
                        $log.log('Set Data success to Storage Factory');
                        var totalList = queryProjectList(res.data.list, queryObj);
                        var list = paginateProjectList(totalList, queryObj);
                        r({
                          data: {
                            list: list,
                            total: totalList.length
                          }
                        });
                      });
                    });
                  })["catch"](function (err) {
                    e(err);
                  });
                } else {
                  $log.log('Returning data in storage');
                  var totalList = queryProjectList(projectsData.list, queryObj);
                  var list = paginateProjectList(totalList, queryObj);
                  r({
                    data: {
                      list: list,
                      total: totalList.length
                    }
                  });
                }
              })["catch"](function (err) {
                e(err);
              });
            });
          });
        });
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").factory("indexeddbFactory", indexeddbFactory);

  function indexeddbFactory($window, $q, $log) {
    var indexedDB = $window.indexedDB;
    var db = null;
    return {
      open: function open(dbName, storeName) {
        var deferred = $q.defer();

        if (db) {
          deferred.resolve();
        }

        var request = indexedDB.open(dbName, 8);

        request.onupgradeneeded = function (e) {
          db = e.target.result;
          e.target.transaction.onerror = indexedDB.onerror;

          if (db.objectStoreNames.contains(storeName)) {
            db.deleteObjectStore(storeName);
          }

          db.createObjectStore(storeName, {
            keyPath: "id",
            autoIncrement: true
          });
        };

        request.onsuccess = function (e) {
          db = e.target.result;
          deferred.resolve();
        };

        request.onerror = function () {
          deferred.reject();
        };

        return deferred.promise;
      },
      get: function get(storeName) {
        var deferred = $q.defer();

        try {
          if (db === null) {
            deferred.reject("IndexDB is not opened yet!");
          } else {
            var trans = db.transaction([storeName], "readwrite");
            var store = trans.objectStore(storeName);
            var list = []; // Get everything in the store;

            var keyRange = IDBKeyRange.lowerBound(0);
            var cursorRequest = store.openCursor(keyRange);

            cursorRequest.onsuccess = function (e) {
              var result = e.target.result;

              if (result === null || result === angular.isUndefined) {
                deferred.resolve(list);
              } else {
                list.push(result.value);
                result["continue"]();
              }
            };

            cursorRequest.onerror = function (e) {
              $log.log(e.value);
              deferred.reject("Something went wrong!!!");
            };
          }
        } catch (e) {
          $log.log(e);
          deferred.reject("Something went wrong!!!");
        }

        return deferred.promise;
      },
      clear: function clear(storeName) {
        var deferred = $q.defer();

        if (db === null) {
          deferred.reject("IndexDB is not opened yet!");
        } else {
          var trans = db.transaction([storeName], "readwrite");
          var store = trans.objectStore(storeName);
          var request = store.clear();

          request.onsuccess = function () {
            deferred.resolve();
          };

          request.onerror = function (e) {
            $log.log(e.value);
            deferred.reject("Todo item couldn't be added!");
          };
        }

        return deferred.promise;
      },
      set: function set(storeName, data) {
        var deferred = $q.defer();

        if (db === null) {
          deferred.reject("IndexDB is not opened yet!");
        } else {
          var trans = db.transaction([storeName], "readwrite");
          var store = trans.objectStore(storeName);
          var request = store.put(data);

          request.onsuccess = function () {
            deferred.resolve();
          };

          request.onerror = function (e) {
            $log.log(e.value);
            deferred.reject("Todo item couldn't be added!");
          };
        }

        return deferred.promise;
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app.core").factory("globals", globals);

  function globals($http, $state, $location, $rootScope, ngProgressFactory, localStorageService, indexeddbFactory, moment, $log) {
    /* To avoid redundant function calls of the same type (Eg. multiple token expired messages) */

    /**
    let throttler = (() => {
      let enabled = true;
      return fn => {
        if (enabled) {
          enabled = false;
          $timeout(() => {
            enabled = true;
          });
          fn();
        }
      };
    })();
    */
    var _getDashboardType = function _getDashboardType(user) {
      if (!user) return -1;
      var type = 0;

      if (angular.isUndefined(user.dashboard)) {
        if (user.designation == "Admin") type = 'Admin';else if (user.designation == "Client") type = 'Client';else if (user.designation == "Supplier") type = 'Supplier';else if (user.designation == "Subcontractor") type = 'Subcontractor';
      } else {
        type = user.dashboard[0];
      }

      return type;
    };

    return {
      progress: function () {
        var progressbar = ngProgressFactory.createInstance();
        return progressbar;
      }(),
      checkLogin: function checkLogin() {
        if (!localStorageService.get("cloud-userData")) {
          $location.path("login"); //throttler(() => Notification.error("Please login"));

          return false;
        } else {
          return true;
        }
      },
      logout: function logout() {
        localStorageService.remove("access-token");
        localStorageService.remove("cloud-userData");
        localStorageService.remove("companyData");
        localStorageService.set("currentProject", null);
        localStorageService.set("synergyChatData", null);
        localStorageService.remove("inventoryState");
        localStorageService.remove("step");
        localStorageService.remove("ocrquotes");
        localStorageService.remove("ocrprogress");
        localStorageService.remove("notificationData");
        indexeddbFactory.open("CloudESDB", "all_projects").then(function () {
          indexeddbFactory.get("all_projects").then(function () {
            indexeddbFactory.clear("all_projects");
            $state.go("login");
          });
        }); //throttler(() => Notification.error("Please login"));
      },

      /* Access user info globally */
      userStore: function () {
        var userData = localStorageService.get("cloud-userData") || {};
        return {
          set: function set(data) {
            var userRoles = ["admin", "manager", "sub_contractor", "team_leader", "worker"];
            data.privilege = userRoles.indexOf(data.designation);
            localStorageService.set("cloud-userData", data);
            userData = data;
            return userData;
          },
          get: function get() {
            return userData;
          },
          reset: function reset() {
            localStorageService.remove("cloud-userData");
            userData = {};
          }
        };
      }(),
      companyStore: function () {
        var companyData = localStorageService.get("companyData") || null;
        return {
          set: function set(data) {
            localStorageService.set("companyData", data);
            companyData = data;
            return companyData;
          },
          get: function get() {
            return companyData;
          },

          /* Call refetch when company dependant data is modified */
          refetch: function refetch(id) {
            $http({
              method: "GET",
              headers: {
                "x-access-token": localStorageService.get("access-token"),
                platform: angular.toJson({
                  source: "web"
                })
              },
              url: "https://api.staging.cloudes.one/api/getCompanyById/".concat(id)
            }).then(function (resp) {
              localStorageService.set("companyData", resp.data);
            })["catch"](function (e) {
              $log(e);
            });
          },
          reset: function reset() {
            localStorageService.remove("companyData");
            companyData = {};
          }
        };
      }(),
      filterStore: function () {
        var filterData = localStorageService.get('filterData') || null;
        return {
          set: function set(data) {
            localStorageService.set('filterData', data);
            filterData = data;
            $rootScope.$broadcast("onFilterChanged", data);
            return filterData;
          },
          get: function get() {
            return localStorageService.get('filterData');
          },
          reset: function reset() {
            localStorageService.remove("filterData");
            filterData = null;
          }
        };
      }(),
      projectStore: function () {
        var currentProject = localStorageService.get("currentProject") || null;
        return {
          set: function set(data) {
            localStorageService.set("currentProject", data);
            currentProject = data;
            $rootScope.$broadcast("onProjectChanged", data);
            return currentProject;
          },
          get: function get() {
            return localStorageService.get("currentProject");
          },
          reset: function reset() {
            localStorageService.remove("currentProject");
            currentProject = null;
          },
          update: function update(data) {
            var old = localStorageService.get("currentProject");

            if (old._id === data._id) {
              localStorageService.set("currentProject", data);
              currentProject = data;
            }
          }
        };
      }(),
      syenrgyStore: function () {
        return {
          setClientToken: function setClientToken(data) {
            var token = data.token,
                expiresIn = data.expiresIn,
                synergyContextEid = data.synergyContextEid,
                uid = data.uid;

            if (!token || !expiresIn) {
              $log.log("synergy store -- invalid token, expiresIn");
              return;
            } // expiresIn : possible values are "24h", "8h"


            expiresIn = expiresIn.toString().trim();

            if (expiresIn !== "24h" && expiresIn !== "8h") {
              // invalid
              $log.log("synergy store -- invalid format -- expiresIn");
              return;
            }

            var strHours = expiresIn.slice(0, expiresIn.length - 1);
            var hours = parseInt(strHours, 10);
            var validTillMoment = moment().add(hours, 'h');
            var validTill = validTillMoment.format();
            var synergyChatData = localStorageService.get("synergyChatData") || {};
            Object.assign(synergyChatData, {
              token: token,
              expiresIn: expiresIn,
              validTill: validTill,
              synergyContextEid: synergyContextEid,
              uid: uid
            });
            localStorageService.remove("synergyChatData");
            localStorageService.set("synergyChatData", synergyChatData);
          },
          getValidClientToken: function getValidClientToken() {
            var synergyChatData = localStorageService.get("synergyChatData") || {};
            var token = synergyChatData.token,
                validTill = synergyChatData.validTill;

            if (!token || !validTill) {
              $log.log("synergy store -- invalid token, validTill");
              return null;
            }

            var validTillMoment = moment(validTill);
            var currentMoment = moment();

            if (validTillMoment.isAfter(currentMoment)) {
              // found valid chat client token
              return token;
            }

            $log.log("synergy store -- token invalid i.e. expired");
            return null;
          }
        };
      }(),
      syenrgyOrgChatStore: function () {
        return {
          setOrgChatClientToken: function setOrgChatClientToken(data) {
            var token = data.token,
                expiresIn = data.expiresIn,
                synergyOrgChatContextEid = data.synergyOrgChatContextEid,
                uid = data.uid;

            if (!token || !expiresIn) {
              $log.log("synergy org chat store -- invalid token, expiresIn");
              return;
            } // expiresIn : possible values are "24h", "8h"


            expiresIn = expiresIn.toString().trim();

            if (expiresIn !== "24h" && expiresIn !== "8h") {
              // invalid
              $log.log("synergy org chat store -- invalid format -- expiresIn");
              return;
            }

            var strHours = expiresIn.slice(0, expiresIn.length - 1);
            var hours = parseInt(strHours, 10);
            var validTillMoment = moment().add(hours, 'h');
            var validTill = validTillMoment.format();
            var synergyOrgChatData = localStorageService.get("synergyOrgChatData") || {};
            Object.assign(synergyOrgChatData, {
              token: token,
              expiresIn: expiresIn,
              validTill: validTill,
              synergyOrgChatContextEid: synergyOrgChatContextEid,
              uid: uid
            });
            localStorageService.remove("synergyOrgChatData");
            localStorageService.set("synergyOrgChatData", synergyOrgChatData);
          },
          getValidOrgChatClientToken: function getValidOrgChatClientToken() {
            var synergyOrgChatData = localStorageService.get("synergyOrgChatData") || {};
            var token = synergyOrgChatData.token,
                validTill = synergyOrgChatData.validTill;

            if (!token || !validTill) {
              $log.log("synergy org chat store -- invalid token, validTill");
              return null;
            }

            var validTillMoment = moment(validTill);
            var currentMoment = moment();

            if (validTillMoment.isAfter(currentMoment)) {
              // found valid chat client token
              return token;
            }

            $log.log("synergy org chat store -- token invalid i.e. expired");
            return null;
          }
        };
      }(),

      /* Access notification info globally */
      notificationStore: function () {
        var notificationData = localStorageService.get("notificationData") || {};
        return {
          set: function set(data) {
            localStorageService.set("notificationData", data);
            notificationData = data;
            return notificationData;
          },
          get: function get() {
            return notificationData;
          },
          reset: function reset() {
            localStorageService.remove("notificationData");
            notificationData = {};
          }
        };
      }(),
      dataTablePageState: function dataTablePageState() {
        var dataTablePageState = localStorageService.get("dataTablePageState") || null;
        return {
          setPage: function setPage(data) {
            localStorageService.set("dataTablePageState", data);
            dataTablePageState = data;
            return dataTablePageState;
          },
          get: function get() {
            return localStorageService.get("dataTablePageState");
          }
        };
      },
      inventoryState: function inventoryState() {
        var state = localStorageService.get("inventoryState") || {
          tab: 0,
          url: "",
          sort_material: "",
          sort_combo: "",
          scroll_pos: 0,
          searchText: "",
          page: {
            material: 1,
            combo: 1
          }
        };
        return {
          setUrl: function setUrl(val) {
            state.url = val;
            localStorageService.set("inventoryState", state);
          },
          setScrollPos: function setScrollPos(val) {
            state.scroll_pos = val;
            localStorageService.set("inventoryState", state);
          },
          setSort: function setSort(type, val) {
            if (type == "material") state.sort_material = val;else state.sort_combo = val;
            localStorageService.set("inventoryState", state);
          },
          setPage: function setPage(type, value) {
            state.page[type] = value;
            localStorageService.set("inventoryState", state);
          },
          setTab: function setTab(val) {
            state.tab = val;
            localStorageService.set("inventoryState", state);
          },
          text: function text(_text) {
            state.searchText = _text;
            localStorageService.set("inventoryState", state);
          },
          get: function get() {
            return state;
          }
        };
      },
      getCurrency: function getCurrency() {
        return $http.get("/data/currencies.json");
      },
      getCountryCode: function getCountryCode() {
        return $http.get("/data/CountryCode.json").then(function (res) {
          var getCountryCode = [res.data[0]];
          res.data.forEach(function (item) {
            var isSame = false;
            getCountryCode.forEach(function (it) {
              if (item.dialCode === it.dialCode) {
                isSame = true;
              }
            });

            if (!isSame) {
              getCountryCode.push(item);
            }
          });
          getCountryCode.sort(function (a, b) {
            if (b.dialCode < a.dialCode) return 1;
            if (b.dialCode > a.dialCode) return -1;
            return 0;
          });
          res.data = getCountryCode;
          return res;
        })["catch"](function (err) {
          return err;
        });
      },
      getIndustry: function getIndustry() {
        return $http.get("/data/industry.json");
      },
      getMonthNames: function getMonthNames() {
        return $http.get("/data/monthNames.json");
      },
      // debounce: rate => {
      //   let timer;
      //   return function(fn, args) {
      //     clearTimeout(timer);
      //     timer = setTimeout(() => {
      //       fn.apply(null, args);
      //     }, rate);
      //   };
      // },
      debounce: function debounce($timeout, rate) {
        var timer;
        return function (fn, args) {
          clearTimeout(timer);
          timer = $timeout(function () {
            fn.apply(null, args);
          }, rate);
        };
      },
      genericStore: function genericStore() {
        var item;
        return {
          store: function store(val) {
            item = val;
          },
          get: function get() {
            return item;
          }
        };
      },
      getWeather: function getWeather(source) {
        return new Promise(function (resolve, reject) {
          $http({
            method: "GET",
            url: "https://api.openweathermap.org/data/2.5/weather?lat=".concat(source[0], "&lon=").concat(source[1], "&units=metric&APPID=d8aa7e23da20ae09967c419846f732eb")
          }).then(function (resp) {
            resolve({
              data: {
                name: resp.data.name,
                temp: Math.round(resp.data.main.temp),
                weather: resp.data.weather
              }
            });
          })["catch"](function (e) {
            reject(e);
          });
        });
      },
      gSkillLevelList: [{
        label: '1/10',
        value: '1'
      }, {
        label: '2/10',
        value: '2'
      }, {
        label: '3/10',
        value: '3'
      }, {
        label: '4/10',
        value: '4'
      }, {
        label: '5/10',
        value: '5'
      }, {
        label: '6/10',
        value: '6'
      }, {
        label: '7/10',
        value: '7'
      }, {
        label: '8/10',
        value: '8'
      }, {
        label: '9/10',
        value: '9'
      }, {
        label: '10/10',
        value: '10'
      }],
      getDashboardType: function getDashboardType(user) {
        return _getDashboardType(user);
      },
      getDashboardRoute: function getDashboardRoute(user) {
        if (!user) return "";

        var dashType = _getDashboardType(user);

        $log.log('dashType = ', dashType);
        var userType = Constants.UserTypeList.find(function (x) {
          return x.dashboardType == dashType;
        });
        if (userType) return userType.dashboardRoute;
        return "";
      },
      getManagerList: function getManagerList() {
        return Constants.UserTypeList.filter(function (item) {
          return item.dashboardType < 100;
        });
      },
      getAccessKey: function getAccessKey(value) {
        for (var key in Constants.AccessKey) {
          if (Constants.AccessKey[key] == value) {
            return key;
          }
        }

        return '';
      },
      getDashboardKey: function getDashboardKey(value) {
        var find = Constants.UserTypeList.find(function (elem) {
          return elem.dashboardType == value;
        });

        if (find) {
          return find.key;
        } else {
          return '';
        }
      },
      getDashboardValue: function getDashboardValue(key) {
        var find = Constants.UserTypeList.find(function (elem) {
          return elem.key == key;
        });

        if (find) {
          return find.dashboardType;
        } else {
          return '';
        }
      },
      numPerPage: function numPerPage() {
        return $rootScope.numPerPage;
      },
      getAvatarColor: function getAvatarColor(userName) {
        if (!userName) {
          return;
        }

        userName = userName.replace(/"/g, '');
        var chars = userName.split(' ');
        var codeNum = 0;

        if (chars.length < 2) {
          if (chars[0][0]) {
            codeNum = chars[0].charCodeAt(0);
          }

          if (chars[0][1]) {
            codeNum += chars[0].charCodeAt(1);
          }
        } else {
          if (chars[0][0]) {
            codeNum = chars[0].charCodeAt(0);
          }

          if (chars[1][0]) {
            codeNum += chars[1].charCodeAt(0);
          }
        }

        return Constants.UserAvatarColors.colors[codeNum % Constants.UserAvatarColors.colors.length];
      }
    };
  }
})();


"use strict";

(function () {
  angular.module("app").factory("fileManagerFactory", fileManagerFactory);

  function fileManagerFactory(apiFactory, Notification, $log, $document, utils) {
    return {
      clipBoard: function () {
        var buffer = {
          mode: 0,
          folders: [],
          files: []
        };
        return {
          emptyClipboard: function emptyClipboard() {
            buffer.folders = [];
            buffer.files = [];
            buffer.mode = 0;
          },
          isEmptyClipboard: function isEmptyClipboard() {
            return utils.isEmpty(buffer.folders) && utils.isEmpty(buffer.files);
          },
          getBuffer: function getBuffer() {
            return buffer;
          },
          copy: function copy(req) {
            buffer = Object.assign({}, req);
          },
          paste: function paste(req) {
            var _this = this;

            return new Promise(function (resolve, reject) {
              if (_this.isEmptyClipboard()) {
                Notification.warning("Clipboard is empty");
                resolve(false);
                return;
              }

              var apiType = buffer.mode === 0 ? "cloneFMItems" : "moveFMItems";
              /* Change payload depending upon cut or copy */

              var payload = {
                mode: buffer.mode,
                hierarchyIds: buffer.folders.map(function (x) {
                  return x._id;
                }),
                assetIds: buffer.files.map(function (x) {
                  return x._id;
                }),
                projectId: req.projectId,
                destHierarchyId: req.destId,
                rootType: req.rootType,
                parentId: buffer.parentId
              };

              if (req.rootType === 'project' || req.rootType === 'company' || req.rootType === 'personal') {
                if (buffer.mode !== 0 && (!payload.parentId || !payload.parentId.length)) payload.sourceRootType = buffer.sourceType;
              }

              apiFactory[apiType](payload).then(function (resp) {
                Notification.success(resp.data.message);
                resolve(true);
              })["catch"](function (e) {
                $log.info(e);

                _this.emptyClipboard();

                reject(false);
              });
            });
          }
        };
      }(),
      navigationStack: function navigationStack() {
        var stack = [],
            head = stack.length - 1; // TODO: no action handler required for now
        // attachHandler = action => {
        //   let obj = {};
        //   return obj;
        // };

        return {
          push: function push(item) {
            stack.splice(head + 1, stack.length, item);
            head = stack.length - 1;
          },
          forward: function forward() {
            var obj;

            if (!stack.length) {
              /* Ignore for empty stack */
              return;
            }

            if (head === stack.length - 1) {
              /* Ignore for end of the stack */
              return;
            }

            head++;

            if (stack[head]) {
              stack[head].toggle();
              obj = stack[head];
              return obj;
            }
          },
          backward: function backward() {
            var obj;

            if (!stack.length) {
              /* Ignore for empty stack */
              return;
            }

            if (head < 0) {
              /* Ignore for end of the stack */
              return;
            }

            if (stack[head]) {
              stack[head].toggle();
              head--;
              obj = stack[head];
              return obj;
            }
          }
        };
      },
      breadCrumb: function breadCrumb() {
        var breadCrumbs = [];
        return {
          set: function set(val) {
            breadCrumbs.push(val);
          },
          get: function get() {
            return breadCrumbs;
          }
        };
      },

      /**
       * @param {Object} fileObj
       * @returns {Object}  { s3: [files], cloudinary: [files] }
       */
      splitDestination: function splitDestination(filesArray) {
        return filesArray.reduce(function (acc, x) {
          if (x.size < 50000000) {
            acc.cloudinary.push(x);
          } else {
            /* If file size is greater than 50mb and the file is a pdf, generate a thumbnail */
            acc.s3.push(x);
          }

          return acc;
        }, {
          s3: [],
          cloudinary: []
        });
      },

      /**
       * @param {Object} file
       * @returns {Number}  1 - direct s3, 2 - s3 -> cloudinary
       */
      resolveDestType: function resolveDestType(file) {
        if (file.size < 50000000) {
          return 2;
        }

        return 1;
      },

      /**
       * @param {Object[]} files
       * @returns {Boolean}
       */
      checkUploadCompletion: function checkUploadCompletion(files) {
        var bool = true;
        files.s3.forEach(function (x) {
          if (!x.completed && !x.aborted && bool) {
            bool = false;
          }
        });
        files.cloudinary.forEach(function (x) {
          if (!x.completed && !x.aborted && bool) {
            bool = false;
          }
        });
        return bool;
      },

      /**
       * @param {Object[]} files - Array of file
       * @returns {Promise} - Resolving will fetch an object of files categorized into two arrays
       */
      checkDuplicateFiles: function checkDuplicateFiles(files, destId) {
        return new Promise(function (resolve, reject) {
          apiFactory.checkAssetDuplicate({
            assetNames: files.map(function (x) {
              return x.name;
            }),
            destId: destId
          }).then(function (resp) {
            /* Get duplicate file obj */
            var duplicateFiles = files.map(function (x) {
              x.action = "rename";
              x.assetName = x.name;
              return x;
            }).reduce(function (acc, x) {
              resp.data.duplicates.indexOf(x.name) === -1 ? acc.uploadFiles.push(x) : acc.duplicates.push(x);
              return acc;
            }, {
              duplicates: [],
              uploadFiles: []
            });
            resolve(duplicateFiles);
          })["catch"](function (e) {
            reject(e);
          });
        });
      },

      /**
       * @param {Object[]} files - Array of file
       * @returns {Boolean}
       */
      checkNameChange: function checkNameChange(files) {
        return files.filter(function (x) {
          return x.action === "rename";
        }).reduce(function (acc, x) {
          acc = acc || x.assetName === x.name;
          return acc;
        }, false);
      },

      /**
       * @param {String} fileName
       * @returns {String}
       */
      generateVersion: function generateVersion(fileName) {
        return "".concat(fileName, " (v").concat(Date.now(), ")");
      },

      /**
       * @param {Object} file
       */
      generateThumbnail: function generateThumbnail(file) {
        var reader = new FileReader();

        reader.onload = function () {
          pdfjsLib.getDocument({
            url: reader.result
          }).promise.then(function (doc) {
            doc.getPage(1).then(function (page) {
              var scale = 1;
              var viewport = page.getViewport({
                scale: scale
              });
              var canvas = $document[0].createElement("canvas");
              var context = canvas.getContext("2d");
              canvas.height = viewport.height;
              canvas.width = viewport.width;
              var task = page.render({
                canvasContext: context,
                viewport: viewport
              });
              task.promise.then(function () {
                var dataURL = canvas.toDataURL("image/png");
                var link = $document[0].createElement("a");
                link.download = "roofplan_image_" + Date.now();
                link.href = dataURL;
                $document[0].body.appendChild(link);
                link.click();
                $document[0].body.removeChild(link);
              });
            });
          });
        };

        reader.readAsDataURL(file);
      },
      splitFileDest: function splitFileDest(filesArray) {
        return filesArray.reduce(function (acc, x) {
          if (x.file.size < 50000000) {
            acc.cloudinary.push(x);
          } else {
            acc.s3.push(x);
          }

          return acc;
        }, {
          s3: [],
          cloudinary: []
        });
      }
    };
  }
})();


"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  angular.module("app.core").factory("ecoFactory", ecoFactory);

  function ecoFactory(moment, utils, $log) {
    return {
      getPayrollTotalHours: function getPayrollTotalHours(payroll) {
        var start = moment(payroll.startTime);
        var end = moment(payroll.endTime);
        var total = end.diff(start, 'hours', true);
        var totalBreak = getBreak(payroll);
        return total - totalBreak;
      },
      getPayrollWorkedSalary: function getPayrollWorkedSalary(payroll) {
        var trackedTime = this.getPayrollTotalHours(payroll);
        var workingTimeItem = getWorkingTimeItem(payroll);
        var workingTime = getWorkingTime(payroll, workingTimeItem, trackedTime);
        var overTime = trackedTime - workingTime;
        if (overTime < 0) overTime = 0;
        var overtimeFormat = workingTimeItem && workingTimeItem.overTime ? workingTimeItem.overTime : null;
        var totalExpense = 0;
        var workedSalary = 0;
        var overtimes = getOverTimes(overtimeFormat);

        if (payroll.userId && payroll.userId.salaryAmount) {
          if (overTime > 0) {
            if (overtimes && overtimes.length) {
              workedSalary = workingTime * payroll.userId.salaryAmount;
              angular.forEach(overtimes, function (x) {
                if (overTime > x.to) {
                  workedSalary += (x.to - x.from) * payroll.userId.salaryAmount * (1 + x.value / 100.00);
                } else if (overTime > x.from) {
                  workedSalary += (overTime - x.from) * payroll.userId.salaryAmount * (1 + x.value / 100.00);
                }
              });
            } else {
              workedSalary = trackedTime * payroll.userId.salaryAmount;
            }
          } else {
            workedSalary = trackedTime * payroll.userId.salaryAmount;
          }
        }

        totalExpense = workedSalary;

        if (payroll.userId && payroll.userId.employeeSettingId) {
          var employeeSetting = payroll.userId.employeeSettingId;

          if (workedSalary !== 0) {
            var taskList = payroll.userId && payroll.userId.bonus && payroll.userId.bonus.taskList ? payroll.userId.bonus.taskList : [];
            angular.forEach(taskList, function (x) {
              totalExpense += workedSalary * x.value;
            });
            var companyPension = utils.num(employeeSetting.companyPension);
            totalExpense += workedSalary * companyPension / 100.00;
          }

          var additionalCosts = employeeSetting.additionalCosts ? employeeSetting.additionalCosts : [];
          additionalCosts.forEach(function (additional) {
            if (additional.unit === 'hr') {
              totalExpense += trackedTime * utils.num(additional.cost);
            } else {
              totalExpense += workedSalary * utils.num(additional.cost) / 100.00;
            }
          });

          if (payroll.distance > 0 && employeeSetting.drivingCosts && employeeSetting.drivingCosts.length) {
            employeeSetting.drivingCosts.forEach(function (drivingCost) {
              var unit = drivingCost.unit;
              var scale;

              if (unit === "m") {
                scale = 1000;
              } else if (unit === "km") {
                scale = 1;
              } else if (unit === 'mile') {
                scale = 0.621371;
              } else {
                scale = 0;
              }

              if (scale !== 0) {
                var distance = payroll.distance * scale;
                var from = utils.num(drivingCost.from);

                if (distance > from) {
                  distance -= from;
                  totalExpense += distance * utils.num(drivingCost.cost);
                }
              }
            });
          }

          if (employeeSetting.taskBonus && employeeSetting.taskBonus.length > 0) {
            employeeSetting.taskBonus.forEach(function (bonus) {
              totalExpense += utils.num(bonus.salesPrice);
            });
          }

          if (payroll.otherTypeCosts && payroll.otherTypeCosts.length > 0 && !utils.isEmpty(payroll.userId.employeeSettingId.otherTypeCosts)) {
            var otherTypeCost = payroll.userId.employeeSettingId.otherTypeCosts.find(function (x) {
              return x._id === payroll.otherTypeCosts[0].id;
            });

            if (otherTypeCost) {
              var cost = utils.num(otherTypeCost.cost);

              if (otherTypeCost.unit === 'day') {
                cost /= 24;
              }

              totalExpense += cost * trackedTime;
            }
          }
        }

        return totalExpense;
      },
      getPayrollOverTime: function getPayrollOverTime(payroll) {
        var trackedTime = this.getPayrollTotalHours(payroll);
        var workingTimeItem = getWorkingTimeItem(payroll);
        var workingTime = getWorkingTime(payroll, workingTimeItem, trackedTime);
        return trackedTime - workingTime > 0 ? trackedTime - workingTime : 0;
      },
      getPayrollBreak: function getPayrollBreak(payroll) {
        return getBreak(payroll);
      },
      buildOpCostList: function buildOpCostList(p_invoices, start, end, remain, avgs) {
        var startDate = angular.copy(start);
        var endDate = angular.copy(end);
        endDate.setHours(0, 0, 0, 0);
        var invoices = angular.copy(p_invoices);
        var dailyInvoiceList = [];
        var result = [];
        invoices.forEach(function (x) {
          var item = dailyInvoiceList.find(function (p) {
            return p.key == moment(x.date).format('Y-M-D');
          });

          if (item) {
            if (x.isCreditMemo) {
              item.val -= x.totalPrice;
            } else {
              item.val += x.totalPrice;
            }
          } else {
            dailyInvoiceList.push({
              key: moment(x.date).format('Y-M-D'),
              val: x.totalPrice * (x.isCreditMemo ? -1 : 1)
            });
          }
        });
        dailyInvoiceList = dailyInvoiceList.filter(function (x) {
          return x.val != 0;
        });
        dailyInvoiceList.forEach(function (x) {
          var invoiceDate = new Date(x.key);
          var avg_cost = 0;
          var avg = avgs.find(function (a) {
            return a.key == moment(invoiceDate).format('Y-M');
          });
          if (avg) avg_cost = avg.val;
          var amt = x.val * avg_cost / 100;
          invoiceDate.setHours(0, 0, 0, 0);
          startDate.setHours(0, 0, 0, 0);
          var diff = (invoiceDate.getTime() - startDate.getTime()) / (24 * 3600000);

          for (var i = 0; i <= diff; i++) {
            result.push({
              key: moment(startDate).format('Y-M-D'),
              val: amt / (diff + 1)
            });
            startDate.setDate(startDate.getDate() + 1);
          }
        });

        if (startDate <= endDate) {
          var diff = (endDate.getTime() - startDate.getTime()) / (24 * 3600000);

          while (startDate <= endDate) {
            result.push({
              key: moment(startDate).format('Y-M-D'),
              val: remain / (diff + 1)
            });
            startDate.setDate(startDate.getDate() + 1);
          }
        }

        return result;
      },
      getProjectEconomicValue: function getProjectEconomicValue(project, invoices, billings, payrolls, vaOrders, companyCost) {
        var calcSheet;

        if (project.calcSheet) {
          calcSheet = {
            sum: utils.num(project.calcSheet.sum),
            sumWithAdditionalCost: utils.num(project.calcSheet.sumWithAdditionalCost),
            totalInventoryCost: utils.num(project.calcSheet.totalInventoryCost),
            totalWorkerCost: utils.num(project.calcSheet.totalWorkerCost),
            totalProfit: utils.num(project.calcSheet.totalProfit),
            companyCost: utils.num(project.calcSheet.companyCost),
            totalCompanyCost: utils.num(project.calcSheet.totalCompanyCost),
            totalInventoryNegative: 0,
            totalWorkerNegative: 0
          };

          if (utils.isEmpty(project.calcSheet.levels)) {
            calcSheet.totalInventoryNegative = calcSheet.totalInventoryCost;
            calcSheet.totalWorkerNegative = calcSheet.totalWorkerCost;
          } else {
            project.calcSheet.levels.forEach(function (level) {
              var negative = {
                inventory: 0,
                worker: 0
              };
              getNegativeFromLevel(level, negative);
              calcSheet.totalInventoryNegative += negative.inventory;
              calcSheet.totalWorkerNegative += negative.worker;
            });
          }
        } else {
          calcSheet = {
            sum: 0,
            sumWithAdditionalCost: 0,
            totalInventoryCost: 0,
            totalWorkerCost: 0,
            totalProfit: 0,
            companyCost: utils.num(companyCost),
            totalCompanyCost: 0,
            totalInventoryNegative: 0,
            totalWorkerNegative: 0
          };
        }

        var date = new Date();
        date.setHours(23, 59, 59, 0);
        var startDate = new Date(project.startDate);
        var endDate = new Date(project.endDate);
        endDate.setHours(23, 59, 59, 0);
        var cash = {
          calcSheet: calcSheet,
          costPercent: calcSheet.companyCost,
          totalLaborCost: 0,
          totalInventoryApprovedCost: 0,
          totalInvoiced: 0,
          totalInvoicedWithoutCredit: 0,
          vaApproved: 0,
          vaPending: 0,
          vaBill: 0,
          vaInvoiced: 0,
          vaProfit: 0
        };
        cash.totalCompanyCost = calcSheet.sumWithAdditionalCost * cash.costPercent / 100;
        cash.totalCompanyRevCost = cash.totalCompanyCost * utils.progressOfDate(startDate, endDate, date, true);
        invoices.forEach(function (invoice) {
          if (project._id === invoice.projectId) {
            if (invoice.status !== 'draft') {
              cash.totalInvoiced += utils.num(invoice.totalAmount);
              invoice.showTotalPrice = invoice.totalPrice;

              var _iterator = _createForOfIteratorHelper(invoice.subtractList),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var subtract = _step.value;
                  invoice.showTotalPrice -= subtract.subtractTotalPrice;
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              cash.totalInvoicedWithoutCredit += utils.num(invoice.showTotalPrice);
            }

            if (invoice.fromVariationOrder === true) {
              cash.vaInvoiced += utils.num(invoice.totalPrice);
            }
          }
        });
        payrolls.forEach(function (payroll) {
          try {
            if (project._id === payroll.projectId._id) {
              cash.totalLaborCost += utils.num(payroll.workedSalary);
            }
          } catch (e) {
            $log.log(project, payroll);
          }
        });
        billings.forEach(function (bill) {
          if (project._id === bill.projectId._id) {
            if (bill.status === 'approved') {
              cash.totalInventoryApprovedCost += utils.num(bill.amountWithoutTax);
            }

            if (vaOrders.findIndex(function (vaOrder) {
              return vaOrder._id === bill.vaOrder;
            }) !== -1) {
              cash.vaBill += utils.num(bill.totalAmount);
            }
          }
        });
        vaOrders.forEach(function (item) {
          if (project._id === item.projectId) {
            switch (item.status) {
              case 'pending':
                cash.vaPending += utils.num(item.totalPrice);
                break;

              case 'approved':
                cash.vaApproved += utils.num(item.totalPrice);
                break;

              default:
                break;
            }
          }
        });
        cash.totalCostProfit = -(cash.totalLaborCost + cash.totalInventoryApprovedCost + cash.totalCompanyRevCost - cash.totalInvoicedWithoutCredit);
        cash.vaProfit = cash.vaInvoiced - cash.vaBill;
        cash.totalProfitWithVAData = cash.totalCostProfit + cash.vaProfit;
        return cash;
      }
    };

    function getBreak(payroll) {
      if (payroll.breakup) {
        var st = moment(payroll.breakup.startTime);
        var et = moment(payroll.breakup.endTime);
        return et.diff(st, 'hours', true);
      }

      return 0;
    }

    function getWorkingTimeItem(payroll) {
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var payrollDay = moment(payroll.date).day();
      var workingTimes = [];

      if (payroll.userId && payroll.userId.employeeSettingId) {
        workingTimes = payroll.userId.employeeSettingId.workingTimes ? payroll.userId.employeeSettingId.workingTimes : [];
      }

      return workingTimes.find(function (it) {
        return it.day === days[payrollDay];
      });
    }

    function getWorkingTime(payroll, workingTimeItem, trackedTime) {
      var workingTime = trackedTime;

      if (workingTimeItem) {
        if (workingTimeItem.dailyHours) {
          var daliyHours = utils.num(workingTimeItem.dailyHours);
          var date = moment(payroll.startTime);
          var startTime = date.hours() + date.minutes() / 60;
          date = moment(payroll.endTime);
          var endTime = date.hours() + date.minutes() / 60;
          var needWorkFrom = getHoursFromString(workingTimeItem.start);
          var needWorkTo = getHoursFromString(workingTimeItem.stop);

          if (startTime < needWorkFrom) {
            startTime = needWorkFrom;
          }

          if (endTime > needWorkTo) {
            endTime = needWorkTo;
          }

          workingTime = endTime - startTime;

          if (workingTime < 0) {
            workingTime = 0;
          } else if (workingTime > daliyHours) {
            workingTime = daliyHours;
          }
        } else {
          if (workingTimeItem.day === 'Saturday' || workingTimeItem.number === 'Sunday') {
            workingTime = 0;
          }
        }
      } else {
        workingTime = 0;
      }

      return workingTime;
    }

    function getOverTimes(overtimeString) {
      var overtimes = [];
      var tempOvertimes = [];

      if (overtimeString) {
        var overtimesubstrings = overtimeString.split(';');
        overtimesubstrings.map(function (substring) {
          if (substring) {
            var values = substring.split('H+');
            var overtime = {
              to: Number(values[0].replace(',', '.')),
              value: Number(values[1].replace('%', '').replace(',', '.'))
            };
            tempOvertimes.push(overtime);
          }
        });

        for (var i = 0; i < tempOvertimes.length; i++) {
          var tempOvertime = tempOvertimes[i];

          if (i === 0) {
            tempOvertime.from = 0;
          } else {
            tempOvertime.from = tempOvertimes[i - 1].to;
          }

          if (i === tempOvertimes.length - 1) {
            tempOvertime.to = 24;
          }

          overtimes.push(tempOvertime);
        }
      }

      return overtimes;
    }

    function getHoursFromString(str) {
      var time = utils.getTimeFromString(str);
      return time.hour + time.minute / 60;
    }

    function getNegativeFromLevel(level, negative) {
      if (level.items) {
        level.items.forEach(function (item) {
          var inventoryNegative = item.salesPriceNOld ? utils.num(item.salesPriceNOld) : utils.num(item.inventoryCostPrice);
          var workerNegative = item.workersPriceNOld ? utils.num(item.workersPriceNOld) : utils.num(item.workerCostPrice);
          negative.inventory += inventoryNegative;
          negative.worker += workerNegative;
        });
      }

      if (level.levels) {
        level.levels.forEach(function (subLevel) {
          return getNegativeFromLevel(subLevel, negative);
        });
      }
    }
  }
})();


"use strict";

(function () {
  angular.module("app.core").factory("authFactory", authFactory);

  function authFactory($http, $location, localStorageService) {
    return {
      checkUser: function checkUser() {
        var token = localStorageService.get("access-token");
        return !!token;
      },
      checkPrivilege: function checkPrivilege(type, subType) {
        var _localStorageService$ = localStorageService.get("cloud-userData"),
            privilege = _localStorageService$.privilege;

        var _localStorageService$2 = localStorageService.get("companyData"),
            privileges = _localStorageService$2.privileges;

        return privileges ? privilege <= privileges[type][subType] : true;
      }
    };
  }
})();


"use strict";

(function () {
  angular.module('app.core').factory('apiFactory', apiFactory);

  function apiFactory($http, localStorageService, globals, Upload) {
    var url = 'https://api.staging.cloudes.one',
        bimUrl = "https://bimserver.cloudes.one",
        twilioIssueChatUrl = "https://saffron-guanaco-3368.twil.io/issue-access-token",
        twilioSynergyChatUrl = "https://saffron-guanaco-3368.twil.io/synergy-chat-token",
        headers = function headers(method, token, form) {
      return {
        // 'Access-Control-Allow-Origin': '*',
        'Content-Type': method === 'GET' ? undefined : form ? undefined : 'application/json',
        'x-access-token': token ? localStorageService.get('access-token') : undefined,
        platform: angular.toJson({
          source: 0
        })
      };
    },
        progress = globals.progress,
        logout = globals.logout,
        makeQuery = function makeQuery(queryObj) {
      var query = !queryObj ? '' : Object.keys(queryObj).reduce(function (acc, v) {
        if (queryObj[v]) {
          var str = "".concat(v, "=").concat(queryObj[v], "&");
          acc += str;
        }

        return acc;
      }, '?');
      query = query.slice(0, -1);
      return query;
    };

    return {
      getBaseUrl: function getBaseUrl() {
        return url;
      },

      /* Decorate ajax calls with progress bar */
      progressify: function progressify(promise) {
        return new Promise(function (resolve, reject) {
          progress.start();
          promise.then(function (resp) {
            progress.complete();
            resolve(resp);
          })["catch"](function (err) {
            progress.complete();

            if (err.status === 401) {
              logout();
            }

            reject(err);
          });
        });
      },
      download: function download(url) {
        return this.progressify($http({
          url: url,
          method: 'GET',
          headers: headers('GET'),
          responseType: 'blob'
        }));
      },
      publicTenders: function publicTenders(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/publicTenders").concat(query),
          method: 'GET',
          headers: headers('GET')
        }));
      },
      login: function login(payload) {
        return this.progressify($http({
          url: url + '/authenticate',
          method: 'POST',
          headers: headers('POST'),
          data: payload
        }));
      },
      loginAsClient: function loginAsClient(data) {
        return this.progressify($http({
          url: url + '/authenticateForClient',
          method: 'POST',
          headers: headers('POST'),
          data: data
        }));
      },
      loginAsGuest: function loginAsGuest(data) {
        return this.progressify($http({
          url: url + '/authenticateForOutMembers',
          method: 'POST',
          headers: headers('POST'),
          data: data
        }));
      },
      forgotPassword: function forgotPassword(payload) {
        return this.progressify($http({
          url: url + '/forgetPassword',
          method: 'POST',
          headers: headers('POST'),
          data: payload
        }));
      },
      registration: function registration(payload) {
        return this.progressify($http({
          url: url + '/dashboardRegistration',
          method: 'POST',
          headers: headers('POST'),
          data: payload
        }));
      },
      getRegistrationsByModelId: function getRegistrationsByModelId(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getRegistrationsByModelId/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getRegistrationById: function getRegistrationById(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getRegistration/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      subscribe: function subscribe(payload) {
        return this.progressify($http({
          url: url + '/subscribe',
          method: 'POST',
          headers: headers('POST'),
          data: payload
        }));
      },
      listAllCompanies: function listAllCompanies() {
        return this.progressify($http({
          url: "".concat(url, "/listAllCompanies"),
          method: 'GET',
          headers: headers('GET', false)
        }));
      },
      getCompanyById: function getCompanyById(companyId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getCompanyById/").concat(companyId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSystemStatus: function getSystemStatus() {
        return this.progressify($http({
          url: "".concat(url, "/api/getSystemStatus"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllAdminsForSynergyChat: function listAllAdminsForSynergyChat() {
        return this.progressify($http({
          url: url + '/api/listAllAdminsForSynergyChat',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllAdminUsers: function listAllAdminUsers(projectId) {
        return this.progressify($http({
          url: url + '/api/listAllAdminUsers/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllManageUsers: function listAllManageUsers() {
        return this.progressify($http({
          url: url + '/api/listAllManageUsers',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllTemplates: function listAllTemplates() {
        return this.progressify($http({
          url: url + '/api/listAllTemplates',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listTemplatesByVendor: function listTemplatesByVendor(id) {
        return this.progressify($http({
          url: url + '/api/listTemplatesByVendor/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getTemplateById: function getTemplateById(id) {
        return this.progressify($http({
          url: url + '/api/getTemplateById/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getTemplateByBillingId: function getTemplateByBillingId(id) {
        return this.progressify($http({
          url: url + '/api/getTemplateByBillingId/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createTemplate: function createTemplate(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/createTemplate',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateTemplate: function updateTemplate(templateId, payload) {
        return this.progressify($http({
          url: url + '/api/updateTemplate/' + templateId,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      deleteTemplate: function deleteTemplate(templateId) {
        return this.progressify($http({
          url: url + '/api/deleteTemplate/' + templateId,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listAllProjects: function listAllProjects(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllProjects").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllProjectNames: function listAllProjectNames() {
        return this.progressify($http({
          url: "".concat(url, "/api/listAllProjectName"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      fetchAllProjects: function fetchAllProjects() {
        return this.progressify($http({
          url: "".concat(url, "/api/fetchAllProjects"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getResourceStatus: function getResourceStatus() {
        return this.progressify($http({
          url: "".concat(url, "/api/getResourceStatus"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listTenderProjects: function listTenderProjects(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listTenderProjects").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listOngoingProjects: function listOngoingProjects(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listOngoingProjects").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllCompletedProjects: function listAllCompletedProjects(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllCompletedProjects").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listServiceProjects: function listServiceProjects(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listServiceProjects").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllGeneralProjects: function listAllGeneralProjects(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllGeneralProjects").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllOngoingProjects: function listAllOngoingProjects() {
        return this.progressify($http({
          url: url + '/api/listAllOngoingProjects',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllTimelineProjects: function listAllTimelineProjects() {
        return this.progressify($http({
          url: url + '/api/listAllTimelineProjects',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllAuditProjects: function listAllAuditProjects() {
        return this.progressify($http({
          url: url + '/api/listAllAuditProjects',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllClients: function listAllClients(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllClients").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllRoofers: function listAllRoofers() {
        return this.progressify($http({
          url: url + '/api/listAllRoofers',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createProject: function createProject(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/createProject',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateProject: function updateProject(id, payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateProjectById/' + id,
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateProjectImageById: function updateProjectImageById(id, payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateProjectImageById/' + id,
          data: payload,
          headers: headers('POST', true)
        }));
      },
      updateProjectsDuration: function updateProjectsDuration(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateProjectsDuration"),
          method: 'PUT',
          headers: headers('POST', true),
          data: payload
        }));
      },
      deleteProject: function deleteProject(projectId) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteProjectById/").concat(projectId),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deletePublicTender: function deletePublicTender(id) {
        return this.progressify($http({
          url: "".concat(url, "/deletePublicTender/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE')
        }));
      },
      createIssue: function createIssue(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/createIssue',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      deleteIssue: function deleteIssue(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteIssue/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getIssueById: function getIssueById(issueID) {
        return this.progressify($http({
          url: "".concat(url, "/api/getIssueById/").concat(issueID),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getIssuesBy3DModelId: function getIssuesBy3DModelId(modelId) {
        var queryObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getIssuesBy3DModelId/' + modelId + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getIssueComments: function getIssueComments(issueId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getIssueComments/").concat(issueId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getIssueCommentById: function getIssueCommentById(commentId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getIssueCommentById/").concat(commentId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllTqs: function listAllTqs(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/TQ/TQ/getAllList' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createTq: function createTq(data) {
        return this.progressify(Upload.upload({
          url: url + '/TQ/TQ/create',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      updateTq: function updateTq(tqData, id) {
        return this.progressify($http({
          url: "".concat(url, "/TQ/TQ/update/").concat(id),
          method: 'PUT',
          data: tqData,
          headers: headers('PUT', true, false)
        }));
      },
      getTqById: function getTqById(id) {
        return this.progressify($http({
          url: url + '/TQ/TQ/getById/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getTqListByProjectId: function getTqListByProjectId(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/TQ/TQ/getListByProjectId/' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      uploadTqAttach: function uploadTqAttach(payload) {
        return Upload.upload({
          url: url + '/TQ/TQAttach/create',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        });
      },
      getTqAttachList: function getTqAttachList(tqId) {
        return this.progressify($http({
          url: url + '/TQ/TQAttach/getById/' + tqId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteTq: function deleteTq(id) {
        return this.progressify($http({
          url: url + '/TQ/TQ/delete/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteTqAttach: function deleteTqAttach(id) {
        return this.progressify($http({
          url: url + '/TQ/TQAttach/delete/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getClientById: function getClientById(clientID) {
        return this.progressify($http({
          url: "".concat(url, "/api/getClientById/").concat(clientID),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateIssue: function updateIssue(issueobj, id) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateIssue/' + id,
          method: 'PUT',
          data: issueobj,
          headers: headers('PUT', true)
        }));
      },
      updateMarkedImages: function updateMarkedImages(issueobj, id) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateMarkedImages/' + id,
          method: 'PUT',
          data: issueobj,
          headers: headers('PUT', true)
        }));
      },
      countOfIssues: function countOfIssues(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/countOfIssues"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getIssueStatistic: function getIssueStatistic(projectId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getIssueStatistic/").concat(projectId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      exportIssueAsPDF: function exportIssueAsPDF(issueId) {
        return this.progressify($http({
          url: "".concat(url, "/api/exportIssueAsPDF/").concat(issueId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllRoofPlans: function listAllRoofPlans() {
        return this.progressify($http({
          url: "".concat(url, "/api/listAllRoofPlans/"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getProjectRoofPlans: function getProjectRoofPlans(projectId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getProjectRoofPlans/' + projectId + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      saveRoofPlan: function saveRoofPlan(roofPlanId, payload) {
        return this.progressify($http({
          url: url + '/api/saveRoofPlan/' + roofPlanId,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      getRoofPlan: function getRoofPlan(roofPlanId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getRoofPlan/").concat(roofPlanId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      addModelToRoofPlan: function addModelToRoofPlan(roofPlanId, payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/addModelToRoofPlan/").concat(roofPlanId),
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      deleteModelFromRoofPlan: function deleteModelFromRoofPlan(roofPlanId) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteModelFromRoofPlan/").concat(roofPlanId),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      createItem: function createItem(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/createItem',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      listAllItems: function listAllItems(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllItems' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getItemById: function getItemById(materialID) {
        return this.progressify($http({
          url: "".concat(url, "/api/getItemById/").concat(materialID),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateItemById: function updateItemById(id, payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateItemById/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      createCustomFolder: function createCustomFolder(payload) {
        return this.progressify($http({
          url: url + '/api/createCustomFolder',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      getAllCustomListByUserId: function getAllCustomListByUserId(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getAllCustomListByUserId/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCustomFolderById: function getCustomFolderById(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getCustomFolderById/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteCustomFolder: function deleteCustomFolder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteCustomFolder/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      updateCustomFolder: function updateCustomFolder(payload) {
        return this.progressify($http({
          url: url + '/api/updateCustomFolder/' + payload._id,
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      createMaterial: function createMaterial(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/createMaterial',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      deleteMaterialById: function deleteMaterialById(id) {
        return this.progressify($http({
          url: url + '/api/deleteMaterialById/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listAllMaterials: function listAllMaterials(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllMaterials' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getMaterialById: function getMaterialById(materialID) {
        return this.progressify($http({
          url: "".concat(url, "/api/getMaterialById/").concat(materialID),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listMaterialAI: function listMaterialAI(materialId) {
        return this.progressify($http({
          url: "".concat(url, "/api/listMaterialAI/").concat(materialId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteEquipmentById: function deleteEquipmentById(id) {
        return this.progressify($http({
          url: url + '/api/deleteEquipmentById/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      createEquipment: function createEquipment(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/createEquipment',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      listAllComboMaterials: function listAllComboMaterials(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listComboMaterials' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllEquipments: function listAllEquipments(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllEquipments' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateMaterialById: function updateMaterialById(id, payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateMaterialById/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      updateEquipmentById: function updateEquipmentById(id, payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateEquipmentById/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      getComboMaterialById: function getComboMaterialById(comboId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getComboMaterialById/").concat(comboId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getEquipmentById: function getEquipmentById(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getEquipmentById/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createComboMaterial: function createComboMaterial(payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/createComboMaterial"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateComboMaterialList: function updateComboMaterialList(id, payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateComboMaterialList/").concat(id),
          method: 'PUT',
          headers: headers('POST', true),
          data: payload
        }));
      },
      deleteComboMaterialById: function deleteComboMaterialById(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteComboMaterialById/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      updateComboMaterial: function updateComboMaterial(id, payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/updateComboMaterial/").concat(id),
          method: 'PUT',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getExchangeRate: function getExchangeRate(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getExchangeRate' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createComboEquipment: function createComboEquipment(payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/createComboEquipment"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      listAllComboEquipments: function listAllComboEquipments(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllComboEquipments' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getComboEquipmentById: function getComboEquipmentById(comboId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getComboEquipmentById/").concat(comboId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteComboEquipmentById: function deleteComboEquipmentById(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteComboEquipmentById/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      updateComboEquipmentById: function updateComboEquipmentById(id, payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/updateComboEquipmentById/").concat(id),
          method: 'PUT',
          headers: headers('POST', true),
          data: payload
        }));
      },
      listAllIssues: function listAllIssues(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllIssues' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getIssuesList: function getIssuesList() {
        return this.progressify($http({
          url: url + '/api/allIssues',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      isTokenValid: function isTokenValid(payload) {
        return this.progressify($http({
          url: url + '/isTokenValid',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      setPassword: function setPassword(payload) {
        return this.progressify($http({
          url: url + '/resetPasswordAdmin',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      updateRoleBasedAccess: function updateRoleBasedAccess(payload) {
        return this.progressify($http({
          url: url + '/api/updateRoleBasedAccess',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },

      /* File Manager APIs */
      addSharedFolder: function addSharedFolder(payload) {
        return this.progressify($http({
          url: url + '/api/addSharedFolder',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      addHierarchy: function addHierarchy(payload) {
        return this.progressify($http({
          url: url + '/api/addHierarchy',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getRootFolders: function getRootFolders(payload) {
        return this.progressify($http({
          url: url + '/api/getRootFolders',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getCompanyHierarchy: function getCompanyHierarchy(payload) {
        return this.progressify($http({
          url: url + '/api/getCompanyHierarchy',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getProjectHierarchy: function getProjectHierarchy(payload) {
        return this.progressify($http({
          url: url + '/api/getProjectHierarchy',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getPersonalHierarchy: function getPersonalHierarchy(payload) {
        return this.progressify($http({
          url: url + '/api/getPersonalHierarchy',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      isExist3DHierarchy: function isExist3DHierarchy(projectId) {
        return this.progressify($http({
          url: url + '/api/isExist3DHierarchy/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      isExist2DHierarchy: function isExist2DHierarchy(projectId) {
        return this.progressify($http({
          url: url + '/api/isExist2DHierarchy/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      isExistTermsHierarchy: function isExistTermsHierarchy() {
        return this.progressify($http({
          url: url + '/api/isExistTermsHierarchy',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      viewProjectAssets: function viewProjectAssets(projectId) {
        return this.progressify($http({
          url: url + '/api/viewProjectAssets/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      starFolder: function starFolder(folderId) {
        return this.progressify($http({
          url: url + '/api/updateFolderStarById/' + folderId,
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      starModel3D: function starModel3D(fileId) {
        return this.progressify($http({
          url: url + '/api/updateModel3dStarById/' + fileId,
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      starAsset: function starAsset(fileId) {
        return this.progressify($http({
          url: url + '/api/updateAssetStarById/' + fileId,
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      addFileToHierarchy: function addFileToHierarchy(payload) {
        return Upload.upload({
          url: url + '/api/addFileToHierarchy',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        });
      },
      addFilesToHierarchy: function addFilesToHierarchy(payload) {
        return Upload.upload({
          url: url + '/api/addFilesToHierarchy',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        });
      },
      viewHierarchy: function viewHierarchy(hierarchyId) {
        return this.progressify($http({
          url: url + '/api/viewHierarchy/' + hierarchyId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      cloneFMItems: function cloneFMItems(payload) {
        return this.progressify($http({
          url: url + '/api/cloneFMItems',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      renameFMItem: function renameFMItem(payload) {
        return this.progressify($http({
          url: url + '/api/renameFMItem',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      uploadFileInFileManager: function uploadFileInFileManager(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/uploadFileInFileManager',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      dragMoveNodes: function dragMoveNodes(payload) {
        return this.progressify($http({
          url: url + '/api/dragMoveNodes',
          method: 'PUT',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      moveFMItems: function moveFMItems(payload) {
        return this.progressify($http({
          url: url + '/api/moveFMItems',
          method: 'PUT',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      deleteAssets: function deleteAssets(payload) {
        return this.progressify($http({
          url: url + '/api/deleteAssets',
          method: 'PUT',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      deleteHierarchy: function deleteHierarchy(id) {
        return this.progressify($http({
          url: url + '/api/deleteHierarchy/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteFMItems: function deleteFMItems(payload) {
        return this.progressify($http({
          url: url + '/api/deleteFMItems',
          method: 'DELETE',
          headers: headers('DELETE', true),
          data: payload
        }));
      },
      getAssetsByNames: function getAssetsByNames(payload) {
        return this.progressify($http({
          url: url + '/api/getAssetsByNames',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      existsAssetsByNames: function existsAssetsByNames(payload) {
        return this.progressify($http({
          url: url + '/api/existsAssetsByNames',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      setCurrentVersion: function setCurrentVersion(payload) {
        return this.progressify($http({
          url: url + '/api/setCurrentVersion',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateAssetDescription: function updateAssetDescription(payload) {
        return this.progressify($http({
          url: url + '/api/updateAssetDescription',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      saveAssetPermissions: function saveAssetPermissions(payload) {
        return this.progressify($http({
          url: url + '/api/saveAssetPermissions',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getAssetPermissions: function getAssetPermissions(assetId) {
        return this.progressify($http({
          url: url + '/api/getAssetPermissions/' + assetId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAssetPermUsers: function getAssetPermUsers(assetId) {
        return this.progressify($http({
          url: url + '/api/getAssetPermUsers/' + assetId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSiteEmailsForShareFiles: function getSiteEmailsForShareFiles() {
        return this.progressify($http({
          url: url + '/api/getSiteEmailsForShareFiles',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      shareFileViaEmail: function shareFileViaEmail(data) {
        return this.progressify($http({
          url: url + '/api/shareFileViaEmail',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      updateAssetQshe: function updateAssetQshe(data) {
        return this.progressify($http({
          url: url + '/api/updateAssetQshe',
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      updateAssetApp: function updateAssetApp(data) {
        return this.progressify($http({
          url: url + '/api/updateAssetApp',
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      updateHierarchyQshe: function updateHierarchyQshe(data) {
        return this.progressify($http({
          url: url + '/api/updateHierarchyQshe',
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      updateHierarchyApp: function updateHierarchyApp(data) {
        return this.progressify($http({
          url: url + '/api/updateHierarchyApp',
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      listAllQshedAssets: function listAllQshedAssets(projectId) {
        return this.progressify($http({
          url: url + '/api/listAllQshedAssets/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      //3D-site redirection api call
      get3DPage: function get3DPage() {
        var token = localStorageService.get('access-token');
        var Data3D = {
          'x-access-token': token,
          projectId: '5b697c030a7e97056835a94a'
        };
        return this.progressify($http({
          url: 'https://cloudes-3d.com',
          method: 'POST',
          data: Data3D
        }));
      },
      //create new client
      createClient: function createClient(client) {
        return this.progressify(Upload.upload({
          url: url + '/api/createClient',
          method: 'POST',
          data: client,
          headers: headers('POST', true)
        }));
      },
      saveHierarchyTree: function saveHierarchyTree(payload) {
        return this.progressify($http({
          url: url + '/api/saveHierarchyTree',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      updateHierarchyTreeToLatest: function updateHierarchyTreeToLatest(payload) {
        return this.progressify($http({
          url: url + '/api/updateHierarchyTreeToLatest',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      getSystemTag: function getSystemTag() {
        return this.progressify($http({
          url: url + '/api/getComboSystemTag',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getComboEquSystemTag: function getComboEquSystemTag() {
        return this.progressify($http({
          url: url + '/api/getComboEquSystemTag',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      bookMarkProject: function bookMarkProject(id, added) {
        return this.progressify($http({
          url: url + '/api/bookmarkProject',
          method: 'PUT',
          data: {
            projectId: id,
            added: added
          },
          headers: headers('POST', true)
        }));
      },
      getBookmarkIDs: function getBookmarkIDs() {
        return this.progressify($http({
          url: url + '/api/getBookmarkIDs',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getBookmarks: function getBookmarks() {
        return this.progressify($http({
          url: url + '/api/getBookmarks',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // getLightProjectList: function () {
      //   return this.progressify(
      //     $http({
      //       url: url + '/api/getLightProjectList',
      //       method: 'GET',
      //       headers: headers('GET', true)
      //     })
      //   );
      // },
      getHierarchyTemplates: function getHierarchyTemplates() {
        return this.progressify($http({
          url: url + '/api/getHierarchyTemplates',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      existsHierarchiesByNames: function existsHierarchiesByNames(payload) {
        return this.progressify($http({
          url: url + '/api/existsHierarchiesByNames',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      saveHierarchyPermissions: function saveHierarchyPermissions(payload) {
        return this.progressify($http({
          url: url + '/api/saveHierarchyPermissions',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getHierarchyPermissions: function getHierarchyPermissions(hierarchyId) {
        return this.progressify($http({
          url: url + '/api/getHierarchyPermissions/' + hierarchyId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getHierarchyPermUsers: function getHierarchyPermUsers(hierarchyId) {
        return this.progressify($http({
          url: url + '/api/getHierarchyPermUsers/' + hierarchyId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      notifyHierarchiesPermStatus: function notifyHierarchiesPermStatus(payload) {
        return this.progressify($http({
          url: url + '/api/notifyHierarchiesPermStatus',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getUnNotifiedPermSettingsCount: function getUnNotifiedPermSettingsCount() {
        return this.progressify($http({
          url: url + '/api/getUnNotifiedPermSettingsCount',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateHierarchyPermApproval: function updateHierarchyPermApproval(payload) {
        return this.progressify($http({
          url: url + '/api/updateHierarchyPermApproval',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      notifyAssetsPermStatus: function notifyAssetsPermStatus(payload) {
        return this.progressify($http({
          url: url + '/api/notifyAssetsPermStatus',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateAssetPermApproval: function updateAssetPermApproval(payload) {
        return this.progressify($http({
          url: url + '/api/updateAssetPermApproval',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      newFileUpload: function newFileUpload(payload) {
        return this.progressify($http({
          url: url + '/api/newFileUpload',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      showProjectFiles: function showProjectFiles(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/showProjectFiles' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      changeProjectTemplate: function changeProjectTemplate(payload) {
        return this.progressify($http({
          url: url + '/api/changeProjectTemplate',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      // showProjectFiles: function (id, limit) {
      showProjectFilesApi: function showProjectFilesApi(id, limit) {
        return this.progressify($http({
          url: url + '/api/showProjectFiles/' + id + '?limit=' + limit,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getProjectById: function getProjectById(id) {
        return this.progressify($http({
          url: url + '/api/getProjectById/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      checkAssetDuplicate: function checkAssetDuplicate(payload) {
        return this.progressify($http({
          url: url + '/api/checkAssetDuplicate',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createNewSupplier: function createNewSupplier(supplier) {
        return this.progressify(Upload.upload({
          url: url + '/api/addsupplier',
          method: 'POST',
          data: supplier,
          headers: headers('POST', true)
        }));
      },
      fetchAllCompanyManagers: function fetchAllCompanyManagers() {
        return this.progressify($http({
          url: url + '/api/fetchAllCompanyManagers',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllSuppliers: function getAllSuppliers(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listallsuppliers' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllSupplierName: function getAllSupplierName(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listallsuppliersName' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllSubcontractorName: function getAllSubcontractorName(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllSubContractorName' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllSubcontractors: function getAllSubcontractors(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listallsubcontractor' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getClientFromSearchKey: function getClientFromSearchKey(queryObj) {
        return this.progressify($http({
          url: url + '/api/getClientFromSearchKey',
          method: 'POST',
          headers: headers('POST', true),
          data: queryObj
        }));
      },
      addProjectRoofPlan: function addProjectRoofPlan(payload) {
        return this.progressify($http({
          url: url + '/api/addProjectRoofPlan',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      addAutoProjectRoofPlan: function addAutoProjectRoofPlan(payload) {
        return this.progressify($http({
          url: url + '/api/addAutoProjectRoofPlan',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      generateRoofPlans: function generateRoofPlans(payload) {
        return this.progressify($http({
          url: url + '/api/generateRoofPlans',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      addRoofPlansFromAsset: function addRoofPlansFromAsset(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/addRoofPlansFromAsset',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      addRoofPlansFromAssetWithUpload: function addRoofPlansFromAssetWithUpload(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/addRoofPlansFromAssetWithUpload',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getSupplierById: function getSupplierById(supplierID) {
        return this.progressify($http({
          url: "".concat(url, "/api/getsupplier/").concat(supplierID),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      findSupplierByName: function findSupplierByName() {
        return this.progressify($http({
          url: "".concat(url, "/api/findSupplier"),
          method: 'POST',
          headers: headers('POST', true)
        }));
      },
      createNewSubcontractor: function createNewSubcontractor(subcontractor) {
        return this.progressify(Upload.upload({
          url: url + '/api/addsubcontractor',
          method: 'POST',
          data: subcontractor,
          headers: headers('POST', true)
        }));
      },
      getSubcontractorById: function getSubcontractorById(supplierID) {
        return this.progressify($http({
          url: "".concat(url, "/api/getsubcontractor/").concat(supplierID),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      issueImage: function issueImage(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/issueImage',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      newIssues3FileUpload: function newIssues3FileUpload(payload) {
        return this.progressify($http({
          url: url + '/api/newIssues3FileUpload',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      postCommentForIssue: function postCommentForIssue(id, comment) {
        return this.progressify(Upload.upload({
          url: url + '/api/addcomment/' + id,
          method: 'PUT',
          data: comment,
          headers: headers('PUT', true)
        }));
      },
      saveLocalIssueAsset: function saveLocalIssueAsset(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/saveLocalIssueAsset',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      postMarkImg: function postMarkImg(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/postmarkings',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      reOpenIssueStatusUpdate: function reOpenIssueStatusUpdate(id) {
        var IssuestatusObj = {
          status: 'OPEN'
        };
        return this.progressify($http({
          url: url + '/api/reopenStatus/' + id,
          method: 'PUT',
          data: IssuestatusObj,
          headers: headers('PUT', true)
        }));
      },
      saveIssueAsComplete: function saveIssueAsComplete(id) {
        return this.progressify(Upload.upload({
          url: url + '/api/markissueascomplete/' + id,
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      updateIssueStatusOrPriority: function updateIssueStatusOrPriority(id, payload) {
        return this.progressify($http({
          url: url + '/api/updateIssueStatusOrPriority/' + id,
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      updateClientById: function updateClientById(clientData, id) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateClientById/' + id,
          method: 'POST',
          data: clientData,
          headers: headers('POST', true)
        }));
      },
      deleteClientById: function deleteClientById(queryObj) {
        return this.progressify($http({
          url: url + '/api/deleteClientById/' + queryObj,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      updateClientPaymentTerms: function updateClientPaymentTerms(id, terms) {
        return this.progressify($http({
          url: url + '/api/addClientPaymentTerms/' + id,
          method: 'PUT',
          data: terms,
          headers: headers('PUT', true)
        }));
      },
      createSystemTag: function createSystemTag(object) {
        return this.progressify($http({
          url: url + '/api/createSystemTag',
          method: 'POST',
          data: object,
          headers: headers('POST', true)
        }));
      },
      updateSystemTag: function updateSystemTag(data) {
        return this.progressify($http({
          url: url + '/api/updateSystemTag/' + data._id,
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      getSystemTags: function getSystemTags() {
        return this.progressify($http({
          url: url + '/api/getSystemTagsList',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteSystemTag: function deleteSystemTag(id) {
        return this.progressify($http({
          url: url + '/api/deleteSystemTag/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      createWorkPattern: function createWorkPattern(object) {
        return this.progressify($http({
          url: url + '/api/createWorkPattern',
          method: 'POST',
          data: object,
          headers: headers('POST', true)
        }));
      },
      updateWorkPattern: function updateWorkPattern(data) {
        return this.progressify($http({
          url: url + '/api/updateWorkPattern/' + data.tagId,
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      deleteWorkPattern: function deleteWorkPattern(id) {
        return this.progressify($http({
          url: url + '/api/deleteWorkPattern/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getWorkPatternById: function getWorkPatternById(id) {
        return this.progressify($http({
          url: url + '/api/getWorkPatternById/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      postWip: function postWip(object) {
        return this.progressify($http({
          url: url + '/api/postWip',
          method: 'POST',
          data: object,
          headers: headers('POST', true)
        }));
      },
      getWipItem: function getWipItem(projectId) {
        return this.progressify($http({
          url: url + '/api/getWipItem/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getWipItems: function getWipItems() {
        return this.progressify($http({
          url: url + '/api/getWipItems/',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listWipItems: function listWipItems() {
        return this.progressify($http({
          url: url + '/api/listWipItems/',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createTagList: function createTagList(payload) {
        return this.progressify($http({
          url: url + '/api/createTagList',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      getSkillTags: function getSkillTags() {
        return this.progressify($http({
          url: url + '/api/getSkillTags',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getWorkLevelAndTypes: function getWorkLevelAndTypes() {
        return this.progressify($http({
          url: url + '/api/getWorkLevelAndTypes',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCategoriesList: function getCategoriesList() {
        return this.progressify($http({
          url: url + '/api/getCategoriesList',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSystemCategoryById: function getSystemCategoryById(id) {
        return this.progressify($http({
          url: url + '/api/getCategoryById/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateCategory: function updateCategory(data) {
        return this.progressify($http({
          url: url + '/api/updateCategory/' + data._id,
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      deleteCategory: function deleteCategory(id) {
        return this.progressify($http({
          url: url + '/api/deleteCategory/' + id,
          method: 'DELETE',
          headers: headers('GET', true)
        }));
      },
      updateSubcontractor: function updateSubcontractor(subcontractor) {
        return this.progressify(Upload.upload({
          url: url + '/api/updatesubcontractor/' + subcontractor._id,
          method: 'PUT',
          data: subcontractor,
          headers: headers('PUT', true)
        }));
      },
      editSubContractorProfile: function editSubContractorProfile(subcontractor) {
        return this.progressify(Upload.upload({
          url: url + '/api/editSubContractorProfile/' + subcontractor._id,
          method: 'PUT',
          data: subcontractor,
          headers: headers('PUT', true)
        }));
      },
      editSupplierProfile: function editSupplierProfile(supplier) {
        return this.progressify(Upload.upload({
          url: url + '/api/editSupplierProfile/' + supplier._id,
          method: 'PUT',
          data: supplier,
          headers: headers('PUT', true)
        }));
      },
      assignTagsTofiles: function assignTagsTofiles(payload) {
        return this.progressify($http({
          url: url + '/api/fileManagerAssignTags',
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      updateSupplier: function updateSupplier(supplier) {
        return this.progressify(Upload.upload({
          url: url + '/api/updatesupplier/' + supplier._id,
          method: 'PUT',
          data: supplier,
          headers: headers('PUT', true)
        }));
      },
      //Create New To do
      createTodoList: function createTodoList(input) {
        return this.progressify(Upload.upload({
          url: url + '/api/createTodo',
          method: 'POST',
          data: input,
          headers: headers('POST', true)
        }));
      },
      //list all to do
      listAllTodoList: function listAllTodoList(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getTodoList' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // get project list assigned todo
      getProjectListAssignedTodo: function getProjectListAssignedTodo(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getProjectListAssignedTodo' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // get tag list assigned todo
      getMemberListAssignedTodo: function getMemberListAssignedTodo(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getMemberListAssignedTodo' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // get tag list assigned todo
      getTagListAssignedTodo: function getTagListAssignedTodo(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getTagListAssignedTodo' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      //update to do
      updateTodoList: function updateTodoList(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateTodoList/' + payload._id,
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      deleteTodoList: function deleteTodoList(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteTodoList/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      postCommentForTodo: function postCommentForTodo(id, comment) {
        return this.progressify(Upload.upload({
          url: url + '/api/addTodocomment/' + id,
          method: 'PUT',
          data: comment,
          headers: headers('PUT', true)
        }));
      },
      getAllMembersInCurrentCompany: function getAllMembersInCurrentCompany(companyId) {
        return this.progressify($http({
          url: url + '/api/getCurrentCompanyMembers/' + companyId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getInviteMembersForChat: function getInviteMembersForChat(projectId) {
        return this.progressify($http({
          url: url + '/api/getCallInviteMembers?projectId=' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAdminManagerByCompany: function getAdminManagerByCompany(companyId) {
        return this.progressify($http({
          url: url + '/api/getAdminManagerByCompany/' + companyId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // apis for events
      createEvent: function createEvent(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/createEvent',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      updateEvent: function updateEvent(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateEvent/' + payload._id,
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      getAllEvents: function getAllEvents(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getAllEvents' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getEvent: function getEvent(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getEvent/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteEvent: function deleteEvent(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteEvent/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      createSchedule: function createSchedule(payload) {
        return this.progressify($http({
          url: url + '/api/createSchedule',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      updateSchedule: function updateSchedule(payload) {
        return this.progressify($http({
          url: url + '/api/updateSchedule/' + payload._id,
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      listAllSchedules: function listAllSchedules(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllSchedules' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSchedule: function getSchedule(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getSchedule/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteSchedule: function deleteSchedule(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteSchedule/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getAccessMeetingRoomToken: function getAccessMeetingRoomToken() {
        return $http({
          url: url + '/api/getAccessMeetingRoomToken',
          method: 'GET',
          headers: headers('GET', true)
        });
      },
      inviteUsersToMeeting: function inviteUsersToMeeting(payload) {
        return this.progressify($http({
          url: url + '/api/inviteUsersToMeeting',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      newMeetingFileMessage: function newMeetingFileMessage(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/newMeetingFileMessage',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      generateChatAccessToken: function generateChatAccessToken(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: twilioIssueChatUrl + query,
          method: 'GET'
        }));
      },
      generateSynergyChatAccessToken: function generateSynergyChatAccessToken(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: twilioSynergyChatUrl + query,
          method: 'GET'
        }));
      },
      generateVideoAccessToken: function generateVideoAccessToken(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + "/api/twilioAccessToken".concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      generateTextChatAccessToken: function generateTextChatAccessToken(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/twilioTextChatToken").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSynergyChatToken: function getSynergyChatToken() {
        return this.progressify($http({
          url: "".concat(url, "/api/synergyChatToken"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSynergyOrgChatToken: function getSynergyOrgChatToken() {
        return this.progressify($http({
          url: "".concat(url, "/api/orgChatClientToken"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getMemberUsersInIssue: function getMemberUsersInIssue(roomEid) {
        return this.progressify($http({
          url: "".concat(url, "/api/memberUsersIssueRoom?roomEid=").concat(roomEid),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getMemberUsersInTq: function getMemberUsersInTq(roomEid) {
        return this.progressify($http({
          url: "".concat(url, "/api/getMemberUsersTqRoom?roomEid=").concat(roomEid),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      twilioRegisterBinding: function twilioRegisterBinding(data) {
        return this.progressify($http({
          url: url + '/api/twilioRegisterBinding',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      twilioSendNotification: function twilioSendNotification(data) {
        return this.progressify($http({
          url: url + '/api/twilioSendNotification',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      twilioGetUserRecentCallLogs: function twilioGetUserRecentCallLogs(data) {
        return this.progressify($http({
          url: url + '/api/getUserRecentCallLogs',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      twilioGetRoomInfo: function twilioGetRoomInfo(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/twilioGetRoomInfo/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createInvoice: function createInvoice(payload) {
        return this.progressify($http({
          url: url + '/api/createInvoice',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      createAndSendInvoice: function createAndSendInvoice(payload) {
        return this.progressify($http({
          url: url + '/api/createAndSendInvoice',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      listAllInvoices: function listAllInvoices(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllInvoices").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      queryInvoices: function queryInvoices(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/queryInvoices"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      getInvoice: function getInvoice(invoiceId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getInvoice/").concat(invoiceId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateInvoice: function updateInvoice(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateInvoiceData/").concat(data._id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      updateInvoiceDoc: function updateInvoiceDoc(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateInvoiceDoc/").concat(data._id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      deleteInvoice: function deleteInvoice(invoiceId) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteInvoice/").concat(invoiceId),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listAllCreditMemos: function listAllCreditMemos(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllCreditMemos").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createVariationOrder: function createVariationOrder(payload) {
        return this.progressify($http({
          url: url + '/api/createVariationOrder',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      createAndSendVariationOrder: function createAndSendVariationOrder(payload) {
        return this.progressify($http({
          url: url + '/api/createAndSendVariationOrder',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      sendVariationOrderMail: function sendVariationOrderMail(data) {
        return this.progressify($http({
          url: url + '/api/sendVariationOrderMail',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      listAllVariationOrders: function listAllVariationOrders(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllVariationOrders").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      queryVariationOrders: function queryVariationOrders(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/queryVariationOrders"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getVariationOrder: function getVariationOrder(variationOrderId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getVariationOrder/").concat(variationOrderId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateVariationOrder: function updateVariationOrder(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateVariationOrder/").concat(data._id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      deleteVariationOrder: function deleteVariationOrder(variationOrderId) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteVariationOrder/").concat(variationOrderId),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      actVariationOrder: function actVariationOrder(token) {
        return this.progressify($http({
          url: "".concat(url, "/actVariationOrder"),
          method: 'PUT',
          headers: headers('PUT', false),
          data: {
            token: token
          }
        }));
      },
      getVariationOrderStatusByToken: function getVariationOrderStatusByToken(token) {
        var query = makeQuery({
          token: token
        });
        return this.progressify($http({
          url: "".concat(url, "/getVariationOrderStatusByToken").concat(query),
          method: 'GET',
          headers: headers('GET', false)
        }));
      },
      listAllPendingBills: function listAllPendingBills(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllPendingBills").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllBillings: function listAllBillings(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllBillings").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      queryBillings: function queryBillings(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/queryBillings"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      uploadBillDocument: function uploadBillDocument(file) {
        return this.progressify(Upload.upload({
          url: url + '/api/uploadBillDocument',
          method: 'POST',
          headers: headers('POST', true),
          data: file
        }));
      },
      getEconomicDashboardData: function getEconomicDashboardData(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/getEconomicDashboardData"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getEconomicDashboardTableData: function getEconomicDashboardTableData(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/getEconomicDashboardTableData"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      calcProjectRealDuration: function calcProjectRealDuration(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/calcProjectRealDuration"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      rebuildFinanceAggregationData: function rebuildFinanceAggregationData(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/rebuildFinanceAggregationData"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getFinanceDashboardData: function getFinanceDashboardData(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/getFinanceDashboardData"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getFinanceDashboardInitData: function getFinanceDashboardInitData(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/getFinanceDashboardInitData"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getFinanceBalancesData: function getFinanceBalancesData(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/getFinanceBalancesData"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getDashboardOperationCostPercent: function getDashboardOperationCostPercent() {
        return this.progressify($http({
          url: url + '/api/getDashboardOperationCostPercent',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listSampleBillings: function listSampleBillings() {
        return this.progressify($http({
          url: "".concat(url, "/api/listSampleBillings"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createBilling: function createBilling(data) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/createBilling"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      approveBill: function approveBill(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/approveBill"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      approveBills: function approveBills(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/approveBills"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      checkDuplicatedBillingData: function checkDuplicatedBillingData(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/checkDuplicatedBillingData"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      deleteBilling: function deleteBilling(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteBilling/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      updateBillingData: function updateBillingData(data, id) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateBillingData/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      updateBillingTotalValues: function updateBillingTotalValues(data, id) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateBillingTotalValues/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      sendBillApproveRequest: function sendBillApproveRequest(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/sendBillApproveRequest"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      createPayroll: function createPayroll(payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/createPayroll"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updatePayroll: function updatePayroll(payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/updatePayroll"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      deletePayroll: function deletePayroll(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/deletePayroll/").concat(data._id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listAllPayrolls: function listAllPayrolls(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/listAllPayrolls"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      enablePayrollTracking: function enablePayrollTracking(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/enableGPSTrackingStatus"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      getPayrollWorkingHours: function getPayrollWorkingHours(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/getPayrollWorkingHours"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      assignGroupToPayrolls: function assignGroupToPayrolls(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/assignGroupToPayrolls"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      exportPayrollsToCSV: function exportPayrollsToCSV(query) {
        return this.progressify($http({
          url: "".concat(url, "/api/exportPayrollsToCSV"),
          method: 'POST',
          headers: headers('POST', true),
          data: query
        }));
      },
      createAccident: function createAccident(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/createAccident"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      listAllAccident: function listAllAccident(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllAccident").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateAccident: function updateAccident(id, payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateAccident/").concat(id),
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      deleteAccident: function deleteAccident(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteAccident/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      countOfAccident: function countOfAccident(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/countOfAccident"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createSubcontractorHour: function createSubcontractorHour(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/createSubcontractorHour"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      listAllSubcontractorHour: function listAllSubcontractorHour(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllSubcontractorHour").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateSubcontractorHour: function updateSubcontractorHour(id, payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateSubcontractorHour/").concat(id),
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      deleteSubcontractorHour: function deleteSubcontractorHour(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteSubcontractorHour/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      hoursOfSubcontractorHour: function hoursOfSubcontractorHour(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/hoursOfSubcontractorHour"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      editIssueMarkings: function editIssueMarkings(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/editIssueMarkings',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      updateCompanyLogo: function updateCompanyLogo(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateCompanyLogo',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateCompanyById: function updateCompanyById(companyId, payload) {
        return this.progressify($http({
          url: url + '/api/updateCompanyById/' + companyId,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      getAllSystemTags: function getAllSystemTags() {
        return this.progressify($http({
          url: url + '/api/getAllSystemTags',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllStaffs: function listAllStaffs(id) {
        return this.progressify($http({
          url: url + '/api/getAllStaffs/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createSheetExtra: function createSheetExtra(sheetdata) {
        return this.progressify($http({
          url: url + '/api/createSheetExtra',
          method: 'POST',
          data: sheetdata,
          headers: headers('POST', true)
        }));
      },
      getCalcSheetExtra: function getCalcSheetExtra(projectid) {
        return this.progressify($http({
          url: "".concat(url, "/api/getSheetExtra/").concat(projectid),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getTimelineExtra: function getTimelineExtra(projectid) {
        return this.progressify($http({
          url: "".concat(url, "/api/getTimelineExtra/").concat(projectid),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCalcVersionExtra: function getCalcVersionExtra(projectId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getCalcVersionExtra/").concat(projectId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      restoreCalcVersionExtra: function restoreCalcVersionExtra(versionId, sheetId) {
        return this.progressify($http({
          url: "".concat(url, "/api/restoreCalcVersionExtra"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: {
            versionId: versionId,
            sheetId: sheetId
          }
        }));
      },
      downloadCalcSheetExtraExcel: function downloadCalcSheetExtraExcel(id) {
        return this.progressify($http({
          url: url + '/api/downloadCalcSheetExtraExcel/' + id,
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      createSheet: function createSheet(sheetdata) {
        return this.progressify($http({
          url: url + '/api/createSheet',
          method: 'POST',
          data: sheetdata,
          headers: headers('POST', true)
        }));
      },
      getCalcSheetCount: function getCalcSheetCount(projectid) {
        return this.progressify($http({
          url: "".concat(url, "/api/getCalcSheetCount/").concat(projectid),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCalcSheet: function getCalcSheet(projectid) {
        return this.progressify($http({
          url: "".concat(url, "/api/getSheet/").concat(projectid),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getProfit: function getProfit(projectId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getProfit/").concat(projectId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCalcVersions: function getCalcVersions(projectId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getCalcVersions/").concat(projectId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCalcVersion: function getCalcVersion(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getCalcVersion/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      restoreCalcVersion: function restoreCalcVersion(versionId, sheetId) {
        return this.progressify($http({
          url: "".concat(url, "/api/restoreCalcVersion"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: {
            versionId: versionId,
            sheetId: sheetId
          }
        }));
      },
      // 3d or vp to calculation
      syncViewerToCalc: function syncViewerToCalc(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/syncViewerToCalc"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      saveCalcExtra: function saveCalcExtra(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/saveCalcExtra"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      syncCalcExtraToTimeline: function syncCalcExtraToTimeline(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/syncCalcExtraToTimeline"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      getCalcExtra: function getCalcExtra(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/getCalcExtra"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      saveCalcTemplate: function saveCalcTemplate(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/saveCalcTemplate"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      listAllCalcTemplates: function listAllCalcTemplates() {
        return this.progressify($http({
          url: "".concat(url, "/api/listAllCalcTemplates"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createOffer: function createOffer(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/createOffer"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      createAndSendOffer: function createAndSendOffer(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/createAndSendOffer"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      exportOfferAsPDF: function exportOfferAsPDF(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/exportOfferAsPDF"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true),
          responseType: 'blob'
        }));
      },
      listAllOffers: function listAllOffers(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllOffers").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getOfferDetail: function getOfferDetail(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getOfferDetail/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateOffer: function updateOffer(id, payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateOffer/").concat(id),
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      updateAndSendOffer: function updateAndSendOffer(id, payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateAndSendOffer/").concat(id),
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      deleteOffer: function deleteOffer(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteOffer/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      updateCompanyBillingApprover: function updateCompanyBillingApprover(payload) {
        return this.progressify($http({
          data: payload,
          url: url + '/api/updateCompanyBillingApprover',
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      addOrRemoveBillingApprover: function addOrRemoveBillingApprover(data) {
        return this.progressify($http({
          data: data,
          url: url + '/api/addOrRemoveBillingApprover',
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      listCompanyStaffs: function listCompanyStaffs() {
        return this.progressify($http({
          url: url + '/api/listCompanyStaffs',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // listAllManagers: function() {
      //   return this.progressify(
      //     $http({
      //       url: url + "/api/listAllManagers",
      //       method: "GET",
      //       headers: headers("GET", true)
      //     })
      //   );
      // },
      createCompanyManager: function createCompanyManager(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/createCompanyManager"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      listAllCompanyManagers: function listAllCompanyManagers() {
        return this.progressify($http({
          url: url + '/api/listAllCompanyManagers',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteCompanyManager: function deleteCompanyManager(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteCompanyManager/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      createPaymentTerm: function createPaymentTerm(payload) {
        return this.progressify($http({
          url: url + '/api/createPaymentTerm',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      // resetMarkings: function(payload) {
      //   return this.progressify(
      //     $http({
      //       url: url + "/api/resetMarkings",
      //       method: "PUT",
      //       headers: headers("PUT", true),
      //       data: payload
      //     })
      //   );
      // },
      saveCompanyData: function saveCompanyData(payload) {
        return this.progressify($http({
          url: url + '/api/saveCalcCompanyInfo',
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      updateCompanyMatEqGroup: function updateCompanyMatEqGroup(payload) {
        return this.progressify($http({
          url: url + '/api/updateCompanyMatEqGroup',
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      getInventoryItems: function getInventoryItems(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getInventoryItems' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getInventoryGroups: function getInventoryGroups(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getInventoryGroups' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllManagers: function listAllManagers(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllManagers' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      changeInputMethodForCompany: function changeInputMethodForCompany(inputmethod) {
        var payload = {
          companyInputMethod: inputmethod
        };
        return this.progressify($http({
          url: url + '/api/updatecompanyinputmethod',
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      updateCompanySMSNotification: function updateCompanySMSNotification(smsNotification) {
        var payload = {
          smsNotification: smsNotification
        };
        return this.progressify($http({
          url: url + '/api/updateCompanySMSNotification',
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      updateCompanyEmailNotification: function updateCompanyEmailNotification(emailNotification) {
        var payload = {
          emailNotification: emailNotification
        };
        return this.progressify($http({
          url: url + '/api/updateCompanyEmailNotification',
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      // Company Economic Setting Apis
      listAccountPlans: function listAccountPlans() {
        return this.progressify($http({
          url: url + '/api/listAccountPlans',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAccountBalances: function listAccountBalances(payload) {
        return this.progressify($http({
          url: url + '/api/listAccountBalances',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getInvoiceAccountPlans: function getInvoiceAccountPlans() {
        return this.progressify($http({
          url: url + '/api/getInvoiceAccountPlans',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getEconomicBalanceSetting: function getEconomicBalanceSetting() {
        return this.progressify($http({
          url: url + '/api/getEconomicBalanceSetting',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      setDefaultEconomicBalanceSetting: function setDefaultEconomicBalanceSetting(data) {
        return this.progressify($http({
          url: url + '/api/setDefaultEconomicBalanceSetting',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      createEconomicBalanceSetting: function createEconomicBalanceSetting(data) {
        return this.progressify($http({
          url: url + '/api/createEconomicBalanceSetting',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      updateEconomicBalanceSetting: function updateEconomicBalanceSetting(data) {
        return this.progressify($http({
          url: url + '/api/updateEconomicBalanceSetting',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      deleteEconomicBalanceSetting: function deleteEconomicBalanceSetting(id) {
        return this.progressify($http({
          url: url + '/api/deleteEconomicBalanceSetting/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getEconomicSettingInvoiceItems: function getEconomicSettingInvoiceItems() {
        return this.progressify($http({
          url: url + '/api/getEconomicSettingInvoiceItems',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getBillAccountPlans: function getBillAccountPlans() {
        return this.progressify($http({
          url: url + '/api/getBillAccountPlans',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createAccountPlan: function createAccountPlan(payload) {
        return this.progressify($http({
          url: url + '/api/createAccountPlan',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      postedFinancesByWip: function postedFinancesByWip(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/schedSaveWipJob").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateAccountPlan: function updateAccountPlan(id, payload) {
        return this.progressify($http({
          url: url + '/api/updateAccountPlan/' + id,
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      deleteAccountPlan: function deleteAccountPlan(id) {
        return this.progressify($http({
          url: url + '/api/deleteAccountPlan/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listAccountPlanSections: function listAccountPlanSections() {
        return this.progressify($http({
          url: url + '/api/listAccountPlanSections',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createAccountPlanSection: function createAccountPlanSection(payload) {
        return this.progressify($http({
          url: url + '/api/createAccountPlanSection',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      updateAccountPlanSection: function updateAccountPlanSection(id, payload) {
        return this.progressify($http({
          url: url + '/api/updateAccountPlanSection/' + id,
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      updateAccountPlanSections: function updateAccountPlanSections(payload) {
        return this.progressify($http({
          url: url + '/api/updateAccountPlanSections',
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      deleteAccountPlanSection: function deleteAccountPlanSection(id) {
        return this.progressify($http({
          url: url + '/api/deleteAccountPlanSection/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getEconomicSetting: function getEconomicSetting() {
        return this.progressify($http({
          url: url + '/api/getEconomicSetting',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      saveEconomicSetting: function saveEconomicSetting(data) {
        return this.progressify($http({
          url: url + '/api/saveEconomicSetting',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      saveEconomicSettingItem: function saveEconomicSettingItem(data) {
        return this.progressify($http({
          url: url + '/api/saveEconomicSettingItem',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      deleteEconomicSettingItem: function deleteEconomicSettingItem(id) {
        return this.progressify($http({
          url: url + '/api/deleteEconomicSettingItem/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getPaymentAccounts: function getPaymentAccounts() {
        return this.progressify($http({
          url: url + '/api/getPaymentAccounts',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      addPaymentAccount: function addPaymentAccount(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/addPaymentAccount',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      updatePaymentAccount: function updatePaymentAccount(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/updatePaymentAccount/' + data._id,
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      deletePaymentAccount: function deletePaymentAccount(id) {
        return this.progressify($http({
          url: url + '/api/deletePaymentAccount/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      changeDefaultPaymentAccount: function changeDefaultPaymentAccount(id) {
        return this.progressify($http({
          url: url + '/api/changeDefaultPaymentAccount/' + id,
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      getPaymentSetting: function getPaymentSetting() {
        return this.progressify($http({
          url: url + '/api/getPaymentSetting',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      savePaymentSetting: function savePaymentSetting(data) {
        return this.progressify($http({
          url: url + '/api/savePaymentSetting',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      getBankDetails: function getBankDetails(data) {
        return this.progressify($http({
          url: url + '/api/getBankDetails',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      // Company Economic Setting Apis
      createChecklist: function createChecklist(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/createChecklist"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      deleteChecklist: function deleteChecklist(id) {
        return this.progressify($http({
          url: url + '/api/deleteChecklist/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getChecklistById: function getChecklistById(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getChecklist/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllChecklist: function getAllChecklist(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/getAllChecklist").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateChecklistById: function updateChecklistById(id, payload) {
        return this.progressify($http({
          url: url + '/api/updateChecklistById/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      deleteChecklistById: function deleteChecklistById(id) {
        return this.progressify($http({
          url: url + '/api/deleteChecklist/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      createEmployee: function createEmployee(employeeObj) {
        return this.progressify(Upload.upload({
          url: url + '/api/addnewEmployee',
          method: 'POST',
          data: employeeObj,
          headers: headers('POST', true)
        }));
      },
      deleteEmployee: function deleteEmployee(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteEmployee/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getAllEmployeesAndManagers: function getAllEmployeesAndManagers(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getallEmployeesAndManagers' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllEmployees: function getAllEmployees(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getallEmployees' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getEmployeeById: function getEmployeeById(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getemployeedetails/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getEmployeeGroup: function getEmployeeGroup(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getEmployeeGroup/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateEmployee: function updateEmployee(employee, id) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateemployee/' + id,
          method: 'PUT',
          data: employee,
          headers: headers('PUT', true)
        }));
      },
      updateEmployeeGPSTrackStatus: function updateEmployeeGPSTrackStatus(data, id) {
        return this.progressify($http({
          url: url + '/api/updateEmployeeGPSTrackStatus/' + id,
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      updateEmployeeSettings: function updateEmployeeSettings(employeedetail) {
        return this.progressify($http({
          url: url + '/api/saveemployeedefaultsettings',
          method: 'PUT',
          data: employeedetail,
          headers: headers('PUT', true)
        }));
      },
      saveProjectPlan: function saveProjectPlan(planobject) {
        return this.progressify($http({
          url: url + '/api/newcontrolplan',
          method: 'POST',
          data: planobject,
          headers: headers('POST', true)
        }));
      },
      getControlPlans: function getControlPlans(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getCompanyControlPlans' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getcontrolPlanById: function getcontrolPlanById(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getcontrolPlanById/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateProjectPlan: function updateProjectPlan(planobj, id) {
        return this.progressify($http({
          url: "".concat(url, "/api/updatecontrolplan/").concat(id),
          method: 'PUT',
          data: planobj,
          headers: headers('PUT', true)
        }));
      },
      setControlPlanForCompany: function setControlPlanForCompany(companydata) {
        return this.progressify($http({
          url: url + '/api/updateplanfields',
          method: 'PUT',
          data: companydata,
          headers: headers('PUT', true)
        }));
      },
      generateAssetUrlForReport: function generateAssetUrlForReport(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/generateAssetUrlForReport',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      addDrawingAssetForReport: function addDrawingAssetForReport(data, id) {
        return this.progressify(Upload.upload({
          url: url + '/api/addDrawingAssetForReport/' + id,
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      createReports: function createReports(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/createReports',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      deleteReports: function deleteReports(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteReports/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getAllReports: function getAllReports(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/getAllReports").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      countOfReports: function countOfReports(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/countOfReports"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getReportById: function getReportById(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getReports/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateReportById: function updateReportById(id, payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/updateReports/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      addReportOtherDoc: function addReportOtherDoc(id, payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/addReportOtherDoc/").concat(id),
          method: 'PUT',
          headers: headers('POST', true),
          data: payload
        }));
      },
      postCommentForReport: function postCommentForReport(id, comment) {
        return this.progressify(Upload.upload({
          url: url + '/api/addReportComment/' + id,
          method: 'PUT',
          data: comment,
          headers: headers('PUT', true)
        }));
      },
      addReportRegistration: function addReportRegistration(id, payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/addReportRegistration/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      updateReportRegistration: function updateReportRegistration(id, payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/updateReportRegistration/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      deleteReportRegistration: function deleteReportRegistration(id, payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteReportRegistration/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true),
          data: payload
        }));
      },
      addReportSiteDoc: function addReportSiteDoc(id, payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/addReportSiteDoc/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      updateReportEntityComment: function updateReportEntityComment(id, comment) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateReportEntityComment/' + id,
          method: 'PUT',
          data: comment,
          headers: headers('PUT', true)
        }));
      },
      updateReportSiteDoc: function updateReportSiteDoc(id, payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/updateReportSiteDoc/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      deleteReportSiteDoc: function deleteReportSiteDoc(id, payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteReportSiteDoc/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true),
          data: payload
        }));
      },
      addReportMedia: function addReportMedia(id, payload) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/addReportMedia/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      deleteReportMedia: function deleteReportMedia(id, payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteReportMedia/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true),
          data: payload
        }));
      },
      setSubcontractorsPwd: function setSubcontractorsPwd(id, password) {
        return this.progressify($http({
          url: "".concat(url, "/api/setpassword/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: password
        }));
      },
      loginAsSubcontractor: function loginAsSubcontractor(payload) {
        return this.progressify($http({
          url: url + '/authenticatesubcontractor',
          method: 'POST',
          headers: headers('POST'),
          data: payload
        }));
      },
      createEmployeeGroup: function createEmployeeGroup(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/createEmployeeGroup',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      updateEmployeeGroup: function updateEmployeeGroup(id, group) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/updateEmployeeGroup/").concat(id),
          method: 'PUT',
          data: group,
          headers: headers('PUT', true)
        }));
      },
      listAllEmployeeGroups: function listAllEmployeeGroups(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listallgroups' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteEmployeeGroup: function deleteEmployeeGroup(id) {
        return this.progressify($http({
          url: url + '/api/deleteEmployeeGroup/' + id,
          method: 'delete',
          headers: headers('DELETE', true)
        }));
      },
      getInventoryMaterialItems: function getInventoryMaterialItems() {
        return this.progressify($http({
          url: url + '/api/getInventoryandmaterials',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      exportReportData: function exportReportData(id, payload) {
        return this.progressify($http({
          url: url + '/api/exportReportData/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      addReportControlPlan: function addReportControlPlan(payload) {
        return this.progressify($http({
          url: url + '/api/addReportControlPlan',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      downLoadExcel: function downLoadExcel() {
        return this.progressify($http({
          url: url + '/api/downLoadMaterialData',
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      downLoadEqExcel: function downLoadEqExcel() {
        return this.progressify($http({
          url: url + '/api/downLoadEquipmentData',
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      downLoadDcpExcel: function downLoadDcpExcel() {
        return this.progressify($http({
          url: url + '/api/downLoadDcpData',
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      downloadCalcSheetExcel: function downloadCalcSheetExcel(id) {
        return this.progressify($http({
          url: url + '/api/downloadCalcSheetExcel/' + id,
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      uploadExcel: function uploadExcel(file) {
        return this.progressify(Upload.upload({
          method: 'POST',
          url: url + '/api/uploadMaterialData',
          data: file,
          headers: headers('POST', true)
        }));
      },
      uploadComboMatExcel: function uploadComboMatExcel(file) {
        return this.progressify(Upload.upload({
          method: 'POST',
          url: url + '/api/uploadComboMaterialData',
          data: file,
          headers: headers('POST', true)
        }));
      },
      uploadEquipmentExcel: function uploadEquipmentExcel(file) {
        return this.progressify(Upload.upload({
          method: 'POST',
          url: url + '/api/uploadEquipmentData',
          data: file,
          headers: headers('POST', true)
        }));
      },
      getEquipmentLocations: function getEquipmentLocations() {
        return this.progressify($http({
          method: 'GET',
          url: url + '/api/getEquipmentLocations',
          headers: headers('GET', true)
        }));
      },
      uploadCalcExcel: function uploadCalcExcel(file) {
        return this.progressify(Upload.upload({
          method: 'POST',
          url: url + '/api/uploadCalculationData',
          data: file,
          headers: headers('POST', true)
        }));
      },
      createManager: function createManager(Obj) {
        return this.progressify(Upload.upload({
          url: url + '/api/createManager',
          method: 'POST',
          data: Obj,
          headers: headers('POST', true)
        }));
      },
      deleteManager: function deleteManager(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteManager/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getManagerById: function getManagerById(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getManagerById/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateManager: function updateManager(Manager, id) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateManager/' + id,
          method: 'PUT',
          data: Manager,
          headers: headers('PUT', true)
        }));
      },
      createTaskList: function createTaskList(payload) {
        return this.progressify($http({
          url: url + '/api/createTaskList',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      getTimeline: function getTimeline(projectId) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (type) {
          return this.progressify($http({
            url: "".concat(url, "/api/getTimeline/").concat(projectId, "/").concat(type),
            method: 'GET',
            headers: headers('GET', true)
          }));
        } else {
          return this.progressify($http({
            url: "".concat(url, "/api/getTimeline/").concat(projectId),
            method: 'GET',
            headers: headers('GET', true)
          }));
        }
      },
      saveTimeline: function saveTimeline(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/saveTimeline"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      saveTimelineExtra: function saveTimelineExtra(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/saveTimelineExtra"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      saveHrsw: function saveHrsw(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/saveHrsw"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      queryTasksExtra: function queryTasksExtra(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/queryTasksExtra"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      getTaskExtra: function getTaskExtra(taskId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getTaskExtra/").concat(taskId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getTaskCommentsExtra: function getTaskCommentsExtra(taskId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getTaskCommentsExtra/").concat(taskId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      addCommentToTaskExtra: function addCommentToTaskExtra(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/addCommentToTaskExtra',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      queryTasks: function queryTasks(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/queryTasks"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      getTask: function getTask(taskId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getTask/").concat(taskId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getTaskComments: function getTaskComments(taskId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getTaskComments/").concat(taskId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      addCommentToTask: function addCommentToTask(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/addCommentToTask',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      createWeatherReport: function createWeatherReport(data) {
        return this.progressify($http({
          url: url + '/api/getTimelineWeatherInfo',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      listAllHolidays: function listAllHolidays() {
        return this.progressify($http({
          url: url + '/api/listAllHolidays',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getBillDetails: function getBillDetails(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getBillDetails/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      addCustomBillSupplierInfo: function addCustomBillSupplierInfo(id, payload) {
        return this.progressify($http({
          url: url + '/api/addCustomBillSupplierInfo/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      //api/addCustomBillSupplierInfo/:billId
      createRooferAllotment: function createRooferAllotment(allotmentObj) {
        return this.progressify($http({
          url: url + '/api/createRooferAllotment',
          method: 'POST',
          headers: headers('POST', true),
          data: allotmentObj
        }));
      },
      getAllotmentsById: function getAllotmentsById(id) {
        return this.progressify($http({
          url: url + '/api/listAllRooferAllotmentsByRooferId/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getInventoryBySystemTag: function getInventoryBySystemTag(systemtag) {
        if (systemtag.includes('MATRL')) {
          return this.progressify($http({
            url: url + '/api/getMaterialBySystemTag/' + systemtag,
            method: 'GET',
            headers: headers('GET', true)
          }));
        }

        if (systemtag.includes('EQPMT')) {
          return this.progressify($http({
            url: url + '/api/getEquipmentBySystemTag/' + systemtag,
            method: 'GET',
            headers: headers('GET', true)
          }));
        }

        if (systemtag.includes('COMBOMAT')) {
          return this.progressify($http({
            url: url + '/api/getCmbBySystemTag/' + systemtag,
            method: 'GET',
            headers: headers('GET', true)
          }));
        }
      },
      deleteSubcontractor: function deleteSubcontractor(queryObj) {
        return this.progressify($http({
          url: url + '/api/deletesubcontractor/' + queryObj,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      add2DPlan: function add2DPlan(root2dfiles) {
        return this.progressify(Upload.upload({
          url: url + '/api/add2DPlan',
          method: 'POST',
          data: root2dfiles,
          headers: headers('POST', true)
        }));
      },
      deleteSupplier: function deleteSupplier(queryObj) {
        return this.progressify($http({
          url: url + '/api/deleteSupplier/' + queryObj,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteprojectRoofPlans: function deleteprojectRoofPlans(id) {
        return this.progressify($http({
          url: url + '/api/deleteProjectRoofPlans/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteModel3d: function deleteModel3d(id) {
        return this.progressify($http({
          url: url + '/api/deleteModel3d/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      generateAssetUrlForIssue: function generateAssetUrlForIssue(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/generateAssetUrlForIssue',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      addDrawingAssetForIssue: function addDrawingAssetForIssue(data, id) {
        return this.progressify(Upload.upload({
          url: url + '/api/addDrawingAssetForIssue/' + id,
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },

      /** Meeting Room new 16 05 2019 */
      getMeetingRoomsForProject: function getMeetingRoomsForProject(projectId) {
        return $http({
          url: url + '/api/getMeetingRoomsForProject/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        });
      },
      getMeetingRoomsForCompany: function getMeetingRoomsForCompany() {
        return $http({
          url: url + '/api/getMeetingRoomsForCompany',
          method: 'GET',
          headers: headers('GET', true)
        });
      },
      createMeetingRoom: function createMeetingRoom(payload) {
        return this.progressify($http({
          url: url + '/api/createMeetingRoom',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getMeetingRoomDetail: function getMeetingRoomDetail(meetingRoomId) {
        return this.progressify($http({
          url: url + '/api/getMeetingRoomDetail/' + meetingRoomId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateMeetingRoom: function updateMeetingRoom(meetingRoomId, payload) {
        return this.progressify($http({
          url: url + '/api/updateMeetingRoom/' + meetingRoomId,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      deleteMeetingRoom: function deleteMeetingRoom(meetingRoomId) {
        return this.progressify($http({
          url: url + '/api/deleteMeetingRoom/' + meetingRoomId,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      // Construction Note
      getAllConstructionNotes: function getAllConstructionNotes() {
        return this.progressify($http({
          url: "".concat(url, "/api/getAllConstructionNotes"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteSpreadSheetById: function deleteSpreadSheetById(id) {
        return this.progressify($http({
          url: url + '/api/deleteSpreadSheetById/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteSpreadSheetNoteHistory: function deleteSpreadSheetNoteHistory(payload) {
        return this.progressify($http({
          url: url + '/api/deleteSpreadSheetNoteHistory',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getSpreadSheetById: function getSpreadSheetById(id) {
        return this.progressify($http({
          url: url + '/api/getSpreadSheetById/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSpreadSheetsByUserId: function getSpreadSheetsByUserId(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getSpreadSheetsByUserId' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      saveSpreadSheet: function saveSpreadSheet(payload) {
        return this.progressify($http({
          url: url + '/api/saveSpreadSheet',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      saveConstructionNote: function saveConstructionNote(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/saveConstructionNote',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      saveConstuctionNoteContent: function saveConstuctionNoteContent(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/saveConstructionNote',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      deleteConstructionNoteHistory: function deleteConstructionNoteHistory(payload) {
        return this.progressify($http({
          url: url + '/api/deleteConstructionNoteHistory',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      saveConstructionNoteImage: function saveConstructionNoteImage(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/uploadConstructionNoteImage',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getConstructionNoteById: function getConstructionNoteById(id) {
        return this.progressify($http({
          url: url + '/api/getConstructionNoteById/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getConstructionNotesByUserId: function getConstructionNotesByUserId(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getConstructionNotesByUserId/' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteConstructionNoteById: function deleteConstructionNoteById(id) {
        return this.progressify($http({
          url: url + '/api/deleteConstructionNoteById/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      downloadConstructionNote: function downloadConstructionNote(payload) {
        return this.progressify($http({
          url: url + '/api/downloadConstructionNote',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getConstructionContent: function getConstructionContent(payload) {
        return this.progressify($http({
          url: url + '/api/getConstructionContent',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getAssetById: function getAssetById(id) {
        return this.progressify($http({
          url: url + '/api/getAssetById/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // Company Role
      getRoleById: function getRoleById(id) {
        return this.progressify($http({
          url: url + '/api/getRoleById/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createRole: function createRole(payload) {
        return this.progressify($http({
          url: url + '/api/createRole',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateRole: function updateRole(id, payload) {
        return this.progressify($http({
          url: url + '/api/updateRole/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      deleteRole: function deleteRole(id) {
        return this.progressify($http({
          url: url + '/api/deleteRole/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getRolesForCompany: function getRolesForCompany() {
        return this.progressify($http({
          url: url + '/api/getRolesForCompany',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      saveAccessSetting: function saveAccessSetting(payload) {
        return this.progressify($http({
          url: url + '/api/saveAccessSetting',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getAccessSetting: function getAccessSetting() {
        return this.progressify($http({
          url: url + '/api/getAccessSetting',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAccessSettingDetails: function getAccessSettingDetails(payload) {
        return this.progressify($http({
          url: url + '/api/getAccessSettingDetails',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getSharedFolderItems: function getSharedFolderItems() {
        return this.progressify($http({
          url: "".concat(url, "/api/getSharedFolderItems"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSharedFolder: function getSharedFolder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getSharedFolder/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      list3d: function list3d(projectId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/list3d/").concat(projectId).concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      get3dModel: function get3dModel(modelId) {
        return this.progressify($http({
          url: "".concat(url, "/api/get3dBy/").concat(modelId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      upload3d: function upload3d(payload) {
        return Upload.upload({
          url: "".concat(bimUrl, "/upload3d"),
          method: 'POST',
          headers: headers('POST', false),
          data: payload
        });
      },
      createPlan: function createPlan(planData) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/createPlan"),
          method: 'POST',
          headers: headers('POST', true),
          data: planData
        }));
      },
      updatePlan: function updatePlan(planId, planData) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/updatePlan/").concat(planId),
          method: 'PUT',
          headers: headers('PUT', true),
          data: planData
        }));
      },
      getPlan: function getPlan(planId) {
        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/getPlan/").concat(planId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deletePlan: function deletePlan(planId) {
        return this.progressify($http({
          url: "".concat(url, "/api/deletePlan/").concat(planId),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getMarker: function getMarker(payload) {
        return this.progressify($http({
          url: url + '/api/getMarker',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      saveMarker: function saveMarker(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/saveMarker',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      listInventories: function listInventories(modelId) {
        return this.progressify($http({
          url: "".concat(url, "/api/listInventories/").concat(modelId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      saveInventories: function saveInventories(payload) {
        return this.progressify($http({
          url: url + '/api/saveInventories',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      update3dModel: function update3dModel(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/update3dModel',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      update3dModelPositions: function update3dModelPositions(payload) {
        return this.progressify($http({
          url: url + '/api/update3dModelPositions',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      saveMatchData: function saveMatchData(payload) {
        return this.progressify($http({
          url: url + '/api/saveMatchData',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getExtrusion: function getExtrusion(modelId) {
        return this.progressify($http({
          url: url + '/api/getExtrusion/' + modelId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getHeightinLonLatFromMapBox: function getHeightinLonLatFromMapBox(lon, lat, accesstoken) {
        return this.progressify($http({
          url: 'https://api.mapbox.com/v4/mapbox.mapbox-terrain-v2/tilequery/' + lon + ',' + lat + '.json?layers=contour&limit=50&access_token=' + accesstoken,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getExtrusionListBy3dModelId: function getExtrusionListBy3dModelId(modelId) {
        return this.progressify($http({
          url: url + '/api/getExtrusionListBy3dModelId/' + modelId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      saveShapeListInfo: function saveShapeListInfo(payload) {
        return this.progressify($http({
          url: url + '/api/saveShapeListInfo',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      update3dThumbnail: function update3dThumbnail(payload) {
        return this.progressify($http({
          url: url + '/api/update3dThumbnail',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createCollisionBim: function createCollisionBim(payload) {
        return this.progressify($http({
          url: url + '/api/createCollisionBim',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateCollisionBim: function updateCollisionBim(payload) {
        return this.progressify($http({
          url: url + '/api/updateCollisionBim/' + payload._id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      listCollisionBim: function listCollisionBim(modelId) {
        return this.progressify($http({
          url: url + '/api/listCollisionBim/' + modelId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteCollisionBim: function deleteCollisionBim(id) {
        return this.progressify($http({
          url: url + '/api/deleteCollisionBim/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      createCollisionVp: function createCollisionVp(payload) {
        return this.progressify($http({
          url: url + '/api/createCollisionVp',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateCollisionVp: function updateCollisionVp(payload) {
        return this.progressify($http({
          url: url + '/api/updateCollisionVp/' + payload._id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      listCollisionVp: function listCollisionVp(modelId) {
        return this.progressify($http({
          url: url + '/api/listCollisionVp/' + modelId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteCollisionVp: function deleteCollisionVp(id) {
        return this.progressify($http({
          url: url + '/api/deleteCollisionVp/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getOfferVersion: function getOfferVersion(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getOfferVersion/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateCompanyLanguage: function updateCompanyLanguage(lang) {
        var payload = {
          language: lang
        };
        return this.progressify($http({
          url: url + '/api/updateCompanyLang',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      // Material & Equipment Orders api
      getMatEquOrdersWithTotalInfo: function getMatEquOrdersWithTotalInfo(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getOrdersWithTotalData/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // Mail APIs
      checkMailLogin: function checkMailLogin() {
        return this.progressify($http({
          url: "".concat(url, "/api/checkWebmailLogin"),
          method: 'POST',
          headers: headers('POST', true)
        }));
      },
      mailLogin: function mailLogin(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/webmailLogin"),
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      getMailBoxes: function getMailBoxes(payload) {
        var mailToken = localStorageService.get('mail-token');

        if (payload) {
          payload.token = mailToken;
        } else {
          payload = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/getMailBoxes"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getInboxMails: function getInboxMails(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/getInboxMails"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      getSentMails: function getSentMails(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/getSentMails"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      getTrashMails: function getTrashMails(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/getTrashMails"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      getStarredMails: function getStarredMails(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/getStarredMails"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      getDraftMails: function getDraftMails(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/getDraftMails"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      getMailDetails: function getMailDetails(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/getMailDetails"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      getMailSignature: function getMailSignature(_signId) {
        var mailToken = localStorageService.get('mail-token');
        var data = {
          token: mailToken
        };
        return this.progressify($http({
          url: "".concat(url, "/api/getMailSignature/") + _signId,
          method: 'GET',
          data: data,
          headers: headers('GET', true)
        }));
      },
      getUserMailSignatures: function getUserMailSignatures() {
        var mailToken = localStorageService.get('mail-token');
        var data = {
          token: mailToken
        };
        return this.progressify($http({
          url: "".concat(url, "/api/getUserMailSignatures"),
          method: 'GET',
          data: data,
          headers: headers('GET', true)
        }));
      },
      addMailSignature: function addMailSignature(params) {
        return this.progressify($http({
          url: "".concat(url, "/api/addMailSignature"),
          method: 'POST',
          data: params,
          headers: {
            'Content-Type': undefined,
            'x-access-token': localStorageService.get('access-token'),
            platform: angular.toJson({
              source: 0
            })
          }
        }));
      },
      updateMailSignature: function updateMailSignature(params, _signId) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateMailSignature/") + _signId,
          method: 'PUT',
          data: params,
          headers: {
            'Content-Type': undefined,
            'x-access-token': localStorageService.get('access-token'),
            platform: angular.toJson({
              source: 0
            })
          }
        }));
      },
      getUnseenCount: function getUnseenCount(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/getUnseenCount"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      getDraftCount: function getDraftCount(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/getDraftCount"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      saveDraftMail: function saveDraftMail(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/saveDraftMail"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      sendEmail: function sendEmail(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify(Upload.upload({
          url: "".concat(url, "/api/sendMail"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      deleteMail: function deleteMail(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/deleteMail"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      restoreFromTrash: function restoreFromTrash(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/restoreFromTrash"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      moveToTrash: function moveToTrash(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/moveToTrash"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      addFlag: function addFlag(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/addFlag"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      deleteFlag: function deleteFlag(params) {
        var mailToken = localStorageService.get('mail-token');

        if (params) {
          params.token = mailToken;
        } else {
          params = {
            token: mailToken
          };
        }

        return this.progressify($http({
          url: "".concat(url, "/api/deleteFlag"),
          method: 'POST',
          data: params,
          headers: headers('POST', true)
        }));
      },
      mailLogout: function mailLogout() {
        var mailToken = localStorageService.get('mail-token');
        var data = {
          token: mailToken
        };
        return this.progressify($http({
          url: "".concat(url, "/api/mailLogout"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      listWebmailHost: function listWebmailHost() {
        return this.progressify($http({
          url: "".concat(url, "/api/listWebmailHost"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createWebmailHost: function createWebmailHost(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/createWebmailHost"),
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      getEmployeeTypes: function getEmployeeTypes() {
        return this.progressify($http({
          url: "".concat(url, "/api/getEmployeeTypes"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getWorkTypes: function getWorkTypes() {
        return this.progressify($http({
          url: "".concat(url, "/api/getWorkTypes"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createEmployeeSetting: function createEmployeeSetting(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/createEmployeeSetting"),
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      getAllEmployeeSettings: function getAllEmployeeSettings() {
        return this.progressify($http({
          url: "".concat(url, "/api/getAllEmployeeSettings"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getEmployeeSetting: function getEmployeeSetting(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getEmployeeSetting/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteEmployeeSetting: function deleteEmployeeSetting(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteEmployeeSetting/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      updateEmployeeSetting: function updateEmployeeSetting(id, payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateEmployeeSetting/").concat(id),
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      saveExternalEconomicCreds: function saveExternalEconomicCreds(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/saveExternalEconomicCreds"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      updateExternalEconomics: function updateExternalEconomics(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateExternalEconomics"),
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      getCompanyExternalEconomics: function getCompanyExternalEconomics() {
        return this.progressify($http({
          url: "".concat(url, "/api/companyExternalEconomics"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateExternalInvoices: function updateExternalInvoices() {
        return this.progressify($http({
          url: "".concat(url, "/api/updateExternalInvoices"),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      updateExternalBillings: function updateExternalBillings() {
        return this.progressify($http({
          url: "".concat(url, "/api/updateExternalBillings"),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      companyEconomicIntegrationLogs: function companyEconomicIntegrationLogs(page, chunk) {
        return this.progressify($http({
          url: "".concat(url, "/api/companyEconomicIntegrationLogs?page=").concat(page, "&chunk=").concat(chunk),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      externalInvoiceSyncOp: function externalInvoiceSyncOp(query) {
        return this.progressify($http({
          url: "".concat(url, "/api/externalInvoiceSyncOp").concat(makeQuery(query)),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      externalBillingSyncOp: function externalBillingSyncOp(query) {
        return this.progressify($http({
          url: "".concat(url, "/api/externalBillingSyncOp").concat(makeQuery(query)),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      glAccountsNetChange: function glAccountsNetChange(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/glAccountsNetChange"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      createMaterialGroup: function createMaterialGroup(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/createMaterialGroup"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      createEquipmentGroup: function createEquipmentGroup(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/createEquipmentGroup"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateMaterialGroup: function updateMaterialGroup(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateMaterialGroup/").concat(data._id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      updateEquipmentGroup: function updateEquipmentGroup(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateEquipmentGroup/").concat(data._id),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      deleteMaterialGroup: function deleteMaterialGroup(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteMaterialGroup/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteEquipmentGroup: function deleteEquipmentGroup(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteEquipmentGroup/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getAllMaterialGroup: function getAllMaterialGroup(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/getAllMaterialGroup") + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllEquipmentGroup: function getAllEquipmentGroup(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/getAllEquipmentGroup") + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllBuildingTypes: function listAllBuildingTypes(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllBuildingTypes").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllEnterpriseTypes: function listAllEnterpriseTypes(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllEnterpriseTypes").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllWeatherTypes: function getAllWeatherTypes(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllWeatherTypes' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllReportTypes: function getAllReportTypes(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllReportTypes' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllLevelTypes: function listAllLevelTypes() {
        return this.progressify($http({
          url: url + '/api/listAllLevelTypes',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllWorkTypes: function listAllWorkTypes() {
        return this.progressify($http({
          url: url + '/api/listAllWorkTypes',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllSupplierTypes: function listAllSupplierTypes() {
        return this.progressify($http({
          url: url + '/api/listAllSupplierTypes',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllCalculationTypes: function listAllCalculationTypes() {
        return this.progressify($http({
          url: "".concat(url, "/api/listAllCalculationTypes"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      fetchClientsByIds: function fetchClientsByIds(payload) {
        return this.progressify($http({
          url: url + '/api/fetchClientsByIds',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      fetchSubcontractorsByIds: function fetchSubcontractorsByIds(payload) {
        return this.progressify($http({
          url: url + '/api/fetchSubcontractorsByIds',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      fetchSuppliersByIds: function fetchSuppliersByIds(payload) {
        return this.progressify($http({
          url: url + '/api/fetchSuppliersByIds',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      fetchCompanyManagers: function fetchCompanyManagers(payload) {
        return this.progressify($http({
          url: url + '/api/fetchCompanyManagers',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      createTimelineWorkPatterns: function createTimelineWorkPatterns(payload) {
        return this.progressify($http({
          url: url + '/api/createTimelineWorkPatterns',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      fetchTimelineWorkPatterns: function fetchTimelineWorkPatterns(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/fetchTimelineWorkPatterns' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      markAsUsedWorkPatterns: function markAsUsedWorkPatterns(projectId) {
        return this.progressify($http({
          url: url + '/api/markAsUsedWorkPatterns/' + projectId,
          method: 'POST',
          headers: headers('POST', true)
        }));
      },
      getAllControlMethodTypes: function getAllControlMethodTypes(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllControlMethodTypes' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllMembers: function getAllMembers() {
        return this.progressify($http({
          url: url + '/api/getAllMembers',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // Team Apis
      createTeam: function createTeam(data) {
        return this.progressify($http({
          url: url + '/api/createTeam',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      listAllTeams: function listAllTeams(projectId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllTeams/' + projectId + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      renameTeam: function renameTeam(payload) {
        return this.progressify($http({
          url: url + '/api/renameTeam',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      deleteTeamById: function deleteTeamById(teamId) {
        return this.progressify($http({
          url: url + '/api/deleteTeamById/' + teamId,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      updateFavoriteOfTeam: function updateFavoriteOfTeam(payload) {
        return this.progressify($http({
          url: url + '/api/updateFavoriteOfTeam',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      addTeamMember: function addTeamMember(data) {
        return this.progressify($http({
          url: url + '/api/addTeamMember',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      updateTeamMember: function updateTeamMember(id, data) {
        return this.progressify($http({
          url: url + '/api/updateTeamMember/' + id,
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      updateTeamMembers: function updateTeamMembers(teamId, payload) {
        return this.progressify($http({
          url: url + '/api/updateTeamMembers/' + teamId,
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      listAllTeamMembers: function listAllTeamMembers(teamId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllTeamMembers/' + teamId + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getTeamMemberById: function getTeamMemberById(id) {
        return this.progressify($http({
          url: url + '/api/getTeamMemberById/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteTeamMember: function deleteTeamMember(id) {
        return this.progressify($http({
          url: url + '/api/deleteTeamMember/' + id,
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      inviteTeams: function inviteTeams(data) {
        return this.progressify($http({
          url: url + '/api/inviteTeams',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      inviteMembers: function inviteMembers(payload) {
        return this.progressify($http({
          url: url + '/api/inviteMembers',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      addCommentToTeamGroup: function addCommentToTeamGroup(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/addCommentToTeamGroup',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      fetchCommentsByTeamGroupId: function fetchCommentsByTeamGroupId(groupId) {
        return this.progressify($http({
          url: url + '/api/fetchCommentsByTeamGroupId/' + groupId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateTeamAvatar: function updateTeamAvatar(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateTeamAvatar',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createTeamGroup: function createTeamGroup(payload) {
        return this.progressify($http({
          url: url + '/api/createTeamGroup',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      fetchTeamGroups: function fetchTeamGroups(teamId) {
        return this.progressify($http({
          url: url + '/api/fetchTeamGroups/' + teamId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteTeamGroup: function deleteTeamGroup(groupId) {
        return this.progressify($http({
          url: url + '/api/deleteTeamGroup/' + groupId,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getProjectTeams: function getProjectTeams(id) {
        return this.progressify($http({
          url: url + '/api/getProjectTeams/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getProjectMembers: function getProjectMembers(id) {
        return this.progressify($http({
          url: url + '/api/getProjectMembers/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllProjectTeamMembers: function listAllProjectTeamMembers(projectId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllProjectTeamMembers/' + projectId + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllCompanyInvoiceUsers: function listAllCompanyInvoiceUsers() {
        return this.progressify($http({
          url: url + '/api/listAllCompanyInvoiceUsers/',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllProjectTeamUsers: function listAllProjectTeamUsers(projectId) {
        return this.progressify($http({
          url: url + '/api/listAllProjectTeamUsers/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // Segment apis
      createDepartment: function createDepartment(data) {
        return this.progressify($http({
          url: url + '/api/createDepartment',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      updateDepartment: function updateDepartment(id, data) {
        return this.progressify($http({
          url: url + '/api/updateDepartment/' + id,
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      deleteDepartment: function deleteDepartment(id) {
        return this.progressify($http({
          url: url + '/api/deleteDepartment/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      fetchDepartments: function fetchDepartments(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/fetchDepartments' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createSegment: function createSegment(data) {
        return this.progressify($http({
          url: url + '/api/createSegment',
          method: 'POST',
          data: data,
          headers: headers('POST', true)
        }));
      },
      updateSegment: function updateSegment(data) {
        return this.progressify($http({
          url: url + '/api/updateSegment/' + data._id,
          method: 'PUT',
          data: data,
          headers: headers('PUT', true)
        }));
      },
      listAllSegments: function listAllSegments(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllSegments' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllSupplierSegments: function listAllSupplierSegments(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllSupplierSegments' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllSubcontractorSegments: function listAllSubcontractorSegments(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllSubcontractorSegments' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSegmentsByDepartmentId: function getSegmentsByDepartmentId(departmentId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getSegmentsByDepartmentId/' + departmentId + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSegmentsByDepartmentIds: function getSegmentsByDepartmentIds(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getSegmentsByDepartmentIds/' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSegmentById: function getSegmentById(id) {
        return this.progressify($http({
          url: url + '/api/getSegmentById/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteSegment: function deleteSegment(id) {
        return this.progressify($http({
          url: url + '/api/deleteSegment/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteSegments: function deleteSegments(payload) {
        return this.progressify($http({
          url: url + '/api/deleteSegments',
          method: 'DELETE',
          headers: headers('DELETE', true),
          data: payload
        }));
      },
      getDepartments: function getDepartments() {
        return this.progressify($http({
          url: url + '/api/getDepartments',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getDesignationsByDepartment: function getDesignationsByDepartment(department) {
        return this.progressify($http({
          url: url + '/api/getDesignationsByDepartment/' + department,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getDesignations: function getDesignations() {
        return this.progressify($http({
          url: url + '/api/getDesignations',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateManagerSetting: function updateManagerSetting(Manager, id) {
        return this.progressify($http({
          url: url + '/api/updateManagerSetting/' + id,
          method: 'PUT',
          data: Manager,
          headers: headers('PUT', true)
        }));
      },
      getCompanyRolesTree: function getCompanyRolesTree() {
        return this.progressify($http({
          url: url + '/api/getCompanyRolesTree',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getNoteComments: function getNoteComments(noteId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getNoteComments/").concat(noteId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      addNoteComment: function addNoteComment(noteId, payload) {
        return this.progressify($http({
          url: url + '/api/addNoteComment/' + noteId,
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateProfilePic: function updateProfilePic(payload) {
        return Upload.upload({
          url: url + '/api/updateProfilePic',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        });
      },
      removeProfilePic: function removeProfilePic() {
        return this.progressify($http({
          url: url + '/api/removeProfilePic',
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      updateMe: function updateMe(payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateMe',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      updateMyPassword: function updateMyPassword(payload) {
        return this.progressify($http({
          url: url + '/api/updateMyPassword',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      updateStatus: function updateStatus(payload) {
        return this.progressify($http({
          url: url + '/api/updateStatus',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      updateEntityTag: function updateEntityTag(payload) {
        return this.progressify($http({
          url: url + '/api/updateEntityTag/' + payload._id,
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      getGeoCodes: function getGeoCodes(coordinates) {
        return this.progressify($http({
          url: "https://maps.googleapis.com/maps/api/geocode/json?sensor=false&key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&latlng=".concat(coordinates.toString()),
          method: 'GET'
        }));
      },
      fetchInvitedMembersInProject: function fetchInvitedMembersInProject(projectId) {
        return this.progressify($http({
          url: url + '/api/fetchInvitedMembersInProject/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateInvitedMembers: function updateInvitedMembers(payload) {
        return this.progressify($http({
          url: url + '/api/updateInvitedMembers',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      replyCommentForNote: function replyCommentForNote(id, comment) {
        return this.progressify($http({
          url: url + '/api/replyNoteComment/' + id,
          method: 'PUT',
          data: comment,
          headers: headers('PUT', true)
        }));
      },
      // Stocks
      listAllStocks: function listAllStocks(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllStocks").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllStockMocks: function listAllStockMocks(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllStockMocks").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // Orders
      listAllRentalOrders: function listAllRentalOrders(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllRentalOrders").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllSalesOrders: function listAllSalesOrders(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllSalesOrders").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllProjectOrders: function listAllProjectOrders(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllProjectOrders").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllOrders: function listAllOrders(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllOrders").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllReturnOrders: function listAllReturnOrders(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listAllReturnOrders").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createRentalOrder: function createRentalOrder(payload) {
        return this.progressify($http({
          url: url + '/api/createRentalOrder',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createSalesOrder: function createSalesOrder(payload) {
        return this.progressify($http({
          url: url + '/api/createSalesOrder',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createProjectOrder: function createProjectOrder(payload) {
        return this.progressify($http({
          url: url + '/api/createProjectOrder',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createOrder: function createOrder(payload) {
        return this.progressify($http({
          url: url + '/api/createOrder',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createReturnOrder: function createReturnOrder(payload) {
        return this.progressify($http({
          url: url + '/api/createReturnOrder',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateRentalOrder: function updateRentalOrder(payload) {
        return this.progressify($http({
          url: url + '/api/updateRentalOrder',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      updateSalesOrder: function updateSalesOrder(payload) {
        return this.progressify($http({
          url: url + '/api/updateSalesOrder',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      updateProjectOrder: function updateProjectOrder(payload) {
        return this.progressify($http({
          url: url + '/api/updateProjectOrder',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      updateOrder: function updateOrder(payload) {
        return this.progressify($http({
          url: url + '/api/updateOrder',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      updateReturnOrder: function updateReturnOrder(payload) {
        return this.progressify($http({
          url: url + '/api/updateReturnOrder',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      getRentalOrder: function getRentalOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getRentalOrder/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getSalesOrder: function getSalesOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getSalesOrder/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getProjectOrder: function getProjectOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getProjectOrder/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getOrder: function getOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getOrder/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getReturnOrder: function getReturnOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/getReturnOrder/").concat(id),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      sendOrder: function sendOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/sendOrder/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      sendReturnOrder: function sendReturnOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/sendReturnOrder/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      sendSalesOrder: function sendSalesOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/sendSalesOrder/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      sendProjectOrder: function sendProjectOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/sendProjectOrder/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      sendRentalOrder: function sendRentalOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/sendRentalOrder/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      actOrder: function actOrder(token) {
        return this.progressify($http({
          url: "".concat(url, "/actOrder"),
          method: 'PUT',
          headers: headers('PUT', false),
          data: {
            token: token
          }
        }));
      },
      actReturnOrder: function actReturnOrder(token) {
        return this.progressify($http({
          url: "".concat(url, "/actReturnOrder"),
          method: 'PUT',
          headers: headers('PUT', false),
          data: {
            token: token
          }
        }));
      },
      actSalesOrder: function actSalesOrder(token) {
        return this.progressify($http({
          url: "".concat(url, "/actSalesOrder"),
          method: 'PUT',
          headers: headers('PUT', false),
          data: {
            token: token
          }
        }));
      },
      actProjectOrder: function actProjectOrder(token) {
        return this.progressify($http({
          url: "".concat(url, "/actProjectOrder"),
          method: 'PUT',
          headers: headers('PUT', false),
          data: {
            token: token
          }
        }));
      },
      actRentalOrder: function actRentalOrder(token) {
        return this.progressify($http({
          url: "".concat(url, "/actRentalOrder"),
          method: 'PUT',
          headers: headers('PUT', false),
          data: {
            token: token
          }
        }));
      },
      deleteOrder: function deleteOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteOrder/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteReturnOrder: function deleteReturnOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteReturnOrder/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteSalesOrder: function deleteSalesOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteSalesOrder/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteRentalOrder: function deleteRentalOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteRentalOrder/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      cancelOrder: function cancelOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/cancelOrder/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      cancelReturnOrder: function cancelReturnOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/cancelReturnOrder/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      cancelSalesOrder: function cancelSalesOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/cancelSalesOrder/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      cancelRentalOrder: function cancelRentalOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/cancelRentalOrder/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      cancelProjectOrder: function cancelProjectOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/cancelProjectOrder/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      returnRentalOrder: function returnRentalOrder(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/returnRentalOrder/").concat(id),
          method: 'PUT',
          headers: headers('PUT', true)
        }));
      },
      systemTag: function systemTag(prefix) {
        return this.progressify($http({
          url: "".concat(url, "/api/systemTag/").concat(prefix),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllWarehouses: function listAllWarehouses() {
        return this.progressify($http({
          url: url + '/api/listAllWarehouses',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createWarehouse: function createWarehouse(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/createWarehouse"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      updateWarehouse: function updateWarehouse(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateWarehouse"),
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      deleteWarehouse: function deleteWarehouse(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteWarehouse/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      isInvitedStaff: function isInvitedStaff(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/isInvitedStaff' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      fetchGroupChannel: function fetchGroupChannel(teamGroupId) {
        return this.progressify($http({
          url: url + '/api/fetchGroupChannel/' + teamGroupId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateGroupChannels: function updateGroupChannels(payload) {
        return this.progressify($http({
          url: url + '/api/updateGroupChannels',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      fetchPrivateChannel: function fetchPrivateChannel(projectId, partnerUserId) {
        return this.progressify($http({
          url: "".concat(url, "/api/fetchPrivateChannel/").concat(projectId, "/").concat(partnerUserId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCompanyAdminUser: function getCompanyAdminUser() {
        return this.progressify($http({
          url: url + '/api/getCompanyAdminUser',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateInvitedMembersTreeForProject: function updateInvitedMembersTreeForProject(projectId, payload) {
        return this.progressify($http({
          url: url + '/api/updateInvitedMembersTreeForProject/' + projectId,
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getAuditManagersForCompany: function getAuditManagersForCompany() {
        return this.progressify($http({
          url: url + '/api/getAuditManagersForCompany',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCeoForCompany: function getCeoForCompany() {
        return this.progressify($http({
          url: url + '/api/getCeoForCompany',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateInvitedMembersApproval: function updateInvitedMembersApproval(projectId, payload) {
        return this.progressify($http({
          url: url + '/api/updateInvitedMembersApproval/' + projectId,
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      deleteChatMessage: function deleteChatMessage(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/deleteMessage' + query,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      updateChatMessage: function updateChatMessage(payload) {
        return this.progressify($http({
          url: url + '/api/updateMessage',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      createAudit: function createAudit(payload) {
        return this.progressify($http({
          url: url + '/api/createAudit',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createAudits: function createAudits(payload) {
        return this.progressify($http({
          url: url + '/api/createAudits',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      reopenAudit: function reopenAudit(payload) {
        return this.progressify($http({
          url: url + '/api/reopenAudit',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      saveCompanyBudget: function saveCompanyBudget(payload) {
        return this.progressify($http({
          url: url + '/api/saveCompanyBudget',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      getCompanyBudget: function getCompanyBudget(year) {
        return this.progressify($http({
          url: "".concat(url, "/api/getCompanyBudget/").concat(year),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllCompanyBudgets: function listAllCompanyBudgets() {
        return this.progressify($http({
          url: "".concat(url, "/api/listAllCompanyBudgets"),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      // for notifications
      getNotification: function getNotification(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/getNotification").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getUnReadNotification: function getUnReadNotification() {
        return this.progressify($http({
          url: url + '/api/getUnReadNotification',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      markNotificationAsReadAll: function markNotificationAsReadAll() {
        return this.progressify($http({
          url: url + '/api/markNotificationAsReadAll',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      markNotificationAsReadByIds: function markNotificationAsReadByIds(ids) {
        return this.progressify($http({
          url: url + '/api/markNotificationAsReadByIds',
          method: 'PUT',
          headers: headers('PUT', true),
          data: ids
        }));
      },
      // for activities
      getActivity: function getActivity(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/getActivity").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createCollaborationOffer: function createCollaborationOffer(payload) {
        return this.progressify($http({
          url: url + '/api/createCollaborationOffer',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      createCollaborationOfferTemplate: function createCollaborationOfferTemplate(payload) {
        return this.progressify($http({
          url: url + '/api/createCollaborationOffer',
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      getCollaborationOffers: function getCollaborationOffers(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/getCollaborationOffers").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCollaborationOfferTemplates: function getCollaborationOfferTemplates(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/getCollaborationOfferTemplates").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateCollaborationOffer: function updateCollaborationOffer(data) {
        return this.progressify($http({
          url: url + '/api/updateCollaborationOffer',
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      updateCollaborationOfferTemplate: function updateCollaborationOfferTemplate(data) {
        return this.progressify($http({
          url: url + '/api/updateCollaborationOfferTemplate',
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      updateCollaborationOfferStatus: function updateCollaborationOfferStatus(payload) {
        return this.progressify($http({
          url: url + '/api/updateCollaborationOfferStatus',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      updateBidInvite: function updateBidInvite(payload) {
        return this.progressify($http({
          url: url + '/api/updateBidPackageInvite',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      deleteBidPackageInvite: function deleteBidPackageInvite(payload) {
        return this.progressify($http({
          url: url + '/api/deleteBidPackageInvite',
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      getSubcontractorStaffsInProject: function getSubcontractorStaffsInProject(projectId) {
        return this.progressify($http({
          url: url + '/api/getSubcontractorStaffsInProject/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getUsersInProjectByApprovalType: function getUsersInProjectByApprovalType(projectId, approvalType) {
        var query = makeQuery({
          projectId: projectId,
          approvalType: approvalType
        });
        return this.progressify($http({
          url: "".concat(url, "/api/getUsersInProjectByApprovalType/").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createRFP: function createRFP(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/createRFP',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateRFP: function updateRFP(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateRFP/' + data._id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      updateRFPUrgentFlag: function updateRFPUrgentFlag(id, urgentFlag) {
        return this.progressify($http({
          url: url + '/api/updateRFPUrgentFlag/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: urgentFlag
        }));
      },
      getRFPs: function getRFPs(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getRFPs' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getRFPsForProject: function getRFPsForProject(projectId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getRFPsForProject/' + projectId + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteRFPs: function deleteRFPs(payload) {
        return this.progressify($http({
          url: url + '/api/deleteRFPs',
          method: 'DELETE',
          headers: headers('DELETE', true),
          data: payload
        }));
      },
      getTotalAmountsByVendors: function getTotalAmountsByVendors(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getTotalAmountsByVendors' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getIssueStatistics: function getIssueStatistics(projectId) {
        return this.progressify($http({
          url: url + '/api/getIssueStatistics/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getVariationOrderStatistics: function getVariationOrderStatistics(projectId) {
        return this.progressify($http({
          url: url + '/api/getVariationOrderStatistics/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getEconomicStatistics: function getEconomicStatistics() {
        return this.progressify($http({
          url: url + '/api/getEconomicStatistics',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getEconomicStatisticsAllCountries: function getEconomicStatisticsAllCountries() {
        return this.progressify($http({
          url: url + '/api/getEconomicStatisticsAllCountries',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCountryGeoData: function getCountryGeoData(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getCountryGeoData' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateChannelMembersForIssue: function updateChannelMembersForIssue(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateChannelMembersForIssue"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      updateChannelMembersForModel3D: function updateChannelMembersForModel3D(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateChannelMembersForModel3D"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      updateChannelMembersForVP: function updateChannelMembersForVP(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateChannelMembersForRoofPlan"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      updateChannelMembersForBoard: function updateChannelMembersForBoard(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateChannelMembersForBoard"),
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      sendInvoiceMail: function sendInvoiceMail(data) {
        return this.progressify($http({
          url: "".concat(url, "/api/sendInvoiceMail"),
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      listPCD: function listPCD(projectId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listPCD/").concat(projectId).concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      uploadPCD: function uploadPCD(payload) {
        return Upload.upload({
          url: "".concat(url, "/api/uploadPCD"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        });
      },
      getPCDById: function getPCDById(pcdId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getPCDById/").concat(pcdId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getPanoramaById: function getPanoramaById(photoId) {
        return this.progressify($http({
          url: "".concat(url, "/api/getPanoramaById/").concat(photoId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deletePCD: function deletePCD(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteModelPCD/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listPanorama: function listPanorama(projectId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listPanorama/").concat(projectId).concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      uploadPhoto: function uploadPhoto(payload) {
        return Upload.upload({
          url: "".concat(url, "/api/uploadPanorama"),
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        });
      },
      deletePanorama: function deletePanorama(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deletePanorama/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      hasApprovalInProject: function hasApprovalInProject(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/hasApprovalInProject").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllVatSettings: function listAllVatSettings() {
        return this.progressify($http({
          url: url + '/api/listAllVatSettings',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getVatSetting: function getVatSetting(id) {
        return this.progressify($http({
          url: url + '/api/getVatSetting/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createVatSetting: function createVatSetting(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/createVatSetting"),
          method: 'POST',
          data: payload,
          headers: headers('POST', true)
        }));
      },
      updateVatSetting: function updateVatSetting(payload) {
        return this.progressify($http({
          url: "".concat(url, "/api/updateVatSetting"),
          method: 'PUT',
          data: payload,
          headers: headers('PUT', true)
        }));
      },
      deleteVatSetting: function deleteVatSetting(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteVatSetting/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listPostedFinances: function listPostedFinances(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listPostedFinances").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listPostedFinancesByAccountPlanId: function listPostedFinancesByAccountPlanId(accountPlanId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listPostedFinancesByAccountPlanId/").concat(accountPlanId).concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listPostedFinancesByType: function listPostedFinancesByType(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listPostedFinancesByType").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listPostedFinancesByWip: function listPostedFinancesByWip(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listPostedFinancesByWip").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deletePostedWip: function deletePostedWip(wipAccountPlanId) {
        return this.progressify($http({
          url: url + '/api/deletePostedWip/' + wipAccountPlanId,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      downloadFinancesExcel: function downloadFinancesExcel(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/downloadFinancesExcel").concat(query),
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      downloadFinancesExcelByAccountPlanId: function downloadFinancesExcelByAccountPlanId(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/downloadFinancesExcelByAccountPlanId").concat(query),
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      downloadFinancesWipExcel: function downloadFinancesWipExcel(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/downloadFinancesWipExcel").concat(query),
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      downloadFinancesExcelByType: function downloadFinancesExcelByType(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/downloadFinancesExcelByType").concat(query),
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      downloadFinancesExcelByVendorId: function downloadFinancesExcelByVendorId(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/downloadFinancesExcelByVendorId").concat(query),
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      createVatReport: function createVatReport(data) {
        return this.progressify($http({
          url: url + '/api/createVatReport',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateVatReport: function updateVatReport(id, data) {
        return this.progressify($http({
          url: url + '/api/updateVatReport/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      deleteVatReport: function deleteVatReport(id) {
        return this.progressify($http({
          url: url + '/api/deleteVatReport/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listVatReports: function listVatReports() {
        return this.progressify($http({
          url: url + '/api/listVatReports',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getVatReport: function getVatReport(id) {
        return this.progressify($http({
          url: url + '/api/getVatReport/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createManualJournal: function createManualJournal(data) {
        return this.progressify($http({
          url: url + '/api/createManualJournal',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateManualJournal: function updateManualJournal(id, data) {
        return this.progressify($http({
          url: url + '/api/updateManualJournal/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      getManualJournal: function getManualJournal(id) {
        return this.progressify($http({
          url: url + '/api/getManualJournal/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteManualJournal: function deleteManualJournal(id) {
        return this.progressify($http({
          url: url + '/api/deleteManualJournal/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listManualJournals: function listManualJournals() {
        return this.progressify($http({
          url: url + '/api/listManualJournals',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createReJournal: function createReJournal(data) {
        return this.progressify($http({
          url: url + '/api/createReJournal',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      createReJournalMany: function createReJournalMany(data) {
        return this.progressify($http({
          url: url + '/api/createReJournalMany',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateReJournal: function updateReJournal(id, data) {
        return this.progressify($http({
          url: url + '/api/updateReJournal/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      getReJournal: function getReJournal(id) {
        return this.progressify($http({
          url: url + '/api/getReJournal/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteReJournal: function deleteReJournal(id) {
        return this.progressify($http({
          url: url + '/api/deleteReJournal/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listReJournals: function listReJournals() {
        return this.progressify($http({
          url: url + '/api/listReJournals',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createPaymentJournalFromBillingMemo: function createPaymentJournalFromBillingMemo(data) {
        return this.progressify($http({
          url: url + '/api/createPaymentJournalFromBillingMemo',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      createPostJournal: function createPostJournal(data) {
        return this.progressify($http({
          url: url + '/api/createPostJournal',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      createPaymentJournal: function createPaymentJournal(data) {
        return this.progressify($http({
          url: url + '/api/createPaymentJournal',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updatePaymentJournal: function updatePaymentJournal(id, data) {
        return this.progressify($http({
          url: url + '/api/updatePaymentJournal/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      getPaymentJournal: function getPaymentJournal(id) {
        return this.progressify($http({
          url: url + '/api/getPaymentJournal/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deletePaymentJournalById: function deletePaymentJournalById(id) {
        return this.progressify($http({
          url: url + '/api/deletePaymentJournalById/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deletePaymentJournalByFinanceId: function deletePaymentJournalByFinanceId(financeId) {
        return this.progressify($http({
          url: url + '/api/deletePaymentJournalByFinanceId/' + financeId,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listPaymentJournals: function listPaymentJournals() {
        return this.progressify($http({
          url: url + '/api/listPaymentJournals',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllJournals: function listAllJournals(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllJournals' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAccountPlanBalance: function getAccountPlanBalance(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getAccountPlanBalance' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getStatisticsData: function getStatisticsData(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getStatisticsData' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getOverdueAndBalanceByVendorId: function getOverdueAndBalanceByVendorId(clientId) {
        return this.progressify($http({
          url: url + '/api/getOverdueAndBalanceByVendorId/' + clientId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listBankFinances: function listBankFinances(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listBankFinances' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getFinancesByVendorId: function getFinancesByVendorId(vendorId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getFinancesByVendorId/' + vendorId + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      uploadBankStatements: function uploadBankStatements(payload) {
        return this.progressify($http({
          url: url + '/api/uploadBankStatements',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createBankPost: function createBankPost(payload) {
        return this.progressify($http({
          url: url + '/api/createBankPost',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createBankBalance: function createBankBalance(payload) {
        return this.progressify($http({
          url: url + '/api/createBankBalance',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      createReverseBankBalance: function createReverseBankBalance(id) {
        return this.progressify($http({
          url: url + '/api/createReverseBankBalance/' + id,
          method: 'POST',
          headers: headers('POST', true)
        }));
      },
      createReverseBankPost: function createReverseBankPost(id) {
        return this.progressify($http({
          url: url + '/api/createReverseBankPost/' + id,
          method: 'POST',
          headers: headers('POST', true)
        }));
      },
      getBankStatements: function getBankStatements(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getBankStatements' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      clearBankStatements: function clearBankStatements() {
        return this.progressify($http({
          url: url + '/api/clearBankStatements',
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      updateBankStatement: function updateBankStatement(id, data) {
        return this.progressify($http({
          url: url + '/api/updateBankStatement/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      deleteBankStatement: function deleteBankStatement(id) {
        return this.progressify($http({
          url: url + '/api/deleteBankStatement/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      downloadBillingsExcel: function downloadBillingsExcel(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/downloadBillingsExcel' + query,
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      downloadInvoicesExcel: function downloadInvoicesExcel(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/downloadInvoicesExcel' + query,
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      downloadInvoicesZip: function downloadInvoicesZip(payload) {
        return this.progressify($http({
          url: url + '/api/downloadInvoicesZip',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      addPdfUrlsToHierarchy: function addPdfUrlsToHierarchy(payload) {
        return this.progressify($http({
          url: url + '/api/addPdfUrlsToHierarchy',
          method: 'POST',
          headers: headers('POST', true),
          data: payload
        }));
      },
      updateInvoiceLinkInfo: function updateInvoiceLinkInfo(id, data) {
        return this.progressify($http({
          url: url + '/api/updateInvoiceLinkInfo/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      updateBillingLinkInfo: function updateBillingLinkInfo(id, data) {
        return this.progressify($http({
          url: url + '/api/updateBillingLinkInfo/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      fetchCreditReports: function fetchCreditReports(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/fetchCreditReports' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      fetchDebitReports: function fetchDebitReports(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/fetchDebitReports' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listProjectMaterials: function listProjectMaterials(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/listProjectMaterials").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listWarehouseMaterials: function listWarehouseMaterials(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listWarehouseMaterials' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listWarehouseMatGroups: function listWarehouseMatGroups(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listWarehouseMatGroups' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listWarehouseSuppliers: function listWarehouseSuppliers(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listWarehouseSuppliers' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listAllMaterialGroups: function listAllMaterialGroups(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listAllMaterialGroups' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      exportCreditReports: function exportCreditReports(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/exportCreditReports' + query,
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      exportDebitReports: function exportDebitReports(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/exportDebitReports' + query,
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      createFinanceBalance: function createFinanceBalance(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/createFinanceBalance',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      createFinanceBalancesMany: function createFinanceBalancesMany(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/createFinanceBalancesMany',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateFinanceBalance: function updateFinanceBalance(data) {
        return this.progressify($http({
          url: url + '/api/updateFinanceBalance',
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      getFinanceBalance: function getFinanceBalance(id) {
        return this.progressify($http({
          url: url + '/api/getFinanceBalance/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteFinanceBalance: function deleteFinanceBalance(id) {
        return this.progressify($http({
          url: url + '/api/deleteFinanceBalance/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listAllFinanceBalances: function listAllFinanceBalances() {
        return this.progressify($http({
          url: url + '/api/listAllFinanceBalances',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createFinanceDoc: function createFinanceDoc(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/createFinanceDoc',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      createFinanceDocsMany: function createFinanceDocsMany(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/createFinanceDocsMany',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateFinanceDoc: function updateFinanceDoc(data) {
        return this.progressify($http({
          url: url + '/api/updateFinanceDoc',
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      getFinanceDoc: function getFinanceDoc(id) {
        return this.progressify($http({
          url: url + '/api/getFinanceDoc/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteFinanceDoc: function deleteFinanceDoc(id) {
        return this.progressify($http({
          url: url + '/api/deleteFinanceDoc/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listAllFinanceDocs: function listAllFinanceDocs() {
        return this.progressify($http({
          url: url + '/api/listAllFinanceDocs',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createFinanceDocTemplate: function createFinanceDocTemplate(data) {
        return this.progressify($http({
          url: url + '/api/createFinanceDocTemplate',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateFinanceDocTemplate: function updateFinanceDocTemplate(data) {
        return this.progressify($http({
          url: url + '/api/updateFinanceDocTemplate',
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      getFinanceDocTemplate: function getFinanceDocTemplate(id) {
        return this.progressify($http({
          url: url + '/api/getFinanceDocTemplate/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      deleteFinanceDocTemplate: function deleteFinanceDocTemplate(id) {
        return this.progressify($http({
          url: url + '/api/deleteFinanceDocTemplate/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listAllFinanceDocTemplates: function listAllFinanceDocTemplates() {
        return this.progressify($http({
          url: url + '/api/listAllFinanceDocTemplates',
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCompanyUsers: function getCompanyUsers(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getCompanyUsers' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCompanyVendorAndManagers: function getCompanyVendorAndManagers(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getCompanyVendorAndManagers' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllInvitedList: function getAllInvitedList(projectId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getAllInvitedList/' + projectId + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      listCollaborations: function listCollaborations(projectId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listCollaborations/' + projectId + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createCollaboration: function createCollaboration(data) {
        return this.progressify($http({
          url: url + '/api/createCollaboration',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      deleteCollaboration: function deleteCollaboration(id) {
        return this.progressify($http({
          url: url + '/api/deleteCollaboration/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      updateCollaboration: function updateCollaboration(data) {
        return this.progressify($http({
          url: url + '/api/updateCollaboration',
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      getCollaborationTeamByProjectId: function getCollaborationTeamByProjectId(data) {
        return this.progressify($http({
          url: url + '/api/getCollaborationTeamByProjectId',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateCollaborationTeam: function updateCollaborationTeam(data) {
        return this.progressify($http({
          url: url + '/api/updateCollaborationTeam',
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      deleteCollaborationTeam: function deleteCollaborationTeam(id) {
        return this.progressify($http({
          url: url + '/api/deleteCollaborationTeam/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteCollaborationOffer: function deleteCollaborationOffer(id) {
        return this.progressify($http({
          url: url + '/api/deleteCollaborationOffer/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      deleteCollaborationOfferTemplate: function deleteCollaborationOfferTemplate(id) {
        return this.progressify($http({
          url: url + '/api/deleteCollaborationOfferTemplate/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      listCollaborationTeams: function listCollaborationTeams(projectId, queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/listCollaborationTeams/' + projectId + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getOrgChart: function getOrgChart(projectId) {
        return this.progressify($http({
          url: url + '/api/getOrgChart/' + projectId,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      updateOrgChart: function updateOrgChart(data) {
        return this.progressify($http({
          url: url + '/api/updateOrgChart',
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      addMemberToOrgChart: function addMemberToOrgChart(data) {
        return this.progressify($http({
          url: url + '/api/addMemberToOrgChart',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      removeMemberFromOrgChart: function removeMemberFromOrgChart(data) {
        return this.progressify($http({
          url: url + '/api/removeMemberFromOrgChart',
          method: 'DELETE',
          headers: headers('DELETE', true),
          data: data
        }));
      },
      uploadFinancePayroll: function uploadFinancePayroll(data) {
        return this.progressify($http({
          url: url + '/api/uploadFinancePayroll',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateFinancePayrollLinkInfo: function updateFinancePayrollLinkInfo(id, data) {
        return this.progressify($http({
          url: url + '/api/updateFinancePayrollLinkInfo/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      updateFinanceEntryInfo: function updateFinanceEntryInfo(id, data) {
        return this.progressify($http({
          url: url + '/api/updateFinanceEntryInfo/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      getOperationCostPercent: function getOperationCostPercent(year) {
        return this.progressify($http({
          url: url + '/api/getOperationCostPercent/' + year,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getEconomicCashFlow: function getEconomicCashFlow(period) {
        return this.progressify($http({
          url: url + '/api/getEconomicCashFlow/' + period,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      isExistBankByBankCode: function isExistBankByBankCode(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/isExistBankByBankCode' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createReversePaymentJournal: function createReversePaymentJournal(id) {
        return this.progressify($http({
          url: url + '/api/createReversePaymentJournal/' + id,
          method: 'POST',
          headers: headers('POST', true)
        }));
      },
      getInvitedSuppliers: function getInvitedSuppliers(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getInvitedSuppliers' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getInvitedSubcontractors: function getInvitedSubcontractors(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getInvitedSubcontractors' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createBidPackage: function createBidPackage(data) {
        return this.progressify(Upload.upload({
          url: url + '/api/createBidPackage',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateBidPackage: function updateBidPackage(id, payload) {
        return this.progressify(Upload.upload({
          url: url + '/api/updateBidPackage/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: payload
        }));
      },
      deleteBidPackage: function deleteBidPackage(id) {
        return this.progressify($http({
          url: "".concat(url, "/api/deleteBidPackage/").concat(id),
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getBidPackages: function getBidPackages(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/getBidPackages' + query,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getBidPackage: function getBidPackage(id) {
        return this.progressify($http({
          url: url + '/api/getBidPackage/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      downloadOfferTemplatesExcel: function downloadOfferTemplatesExcel(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: url + '/api/exportOfferTemplatesToExcel' + query,
          method: 'GET',
          responseType: 'arraybuffer',
          headers: headers('GET', true)
        }));
      },
      getCollaborationOfferByBidId: function getCollaborationOfferByBidId(id) {
        return this.progressify($http({
          url: url + '/api/getCollaborationOfferByBidId/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getCollaborationOfferTemplateByBidPackageId: function getCollaborationOfferTemplateByBidPackageId(id) {
        return this.progressify($http({
          url: url + '/api/getCollaborationOfferTemplateByBidPackageId/' + id,
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      exportAccountPlanBalancesToExcel: function exportAccountPlanBalancesToExcel(data) {
        return this.progressify($http({
          url: url + '/api/exportAccountPlanBalancesToExcel',
          method: 'POST',
          responseType: 'arraybuffer',
          headers: headers('POST', true),
          data: data
        }));
      },
      exportAccountPlanBalancesToPdf: function exportAccountPlanBalancesToPdf(data) {
        return this.progressify($http({
          url: url + '/api/exportAccountPlanBalancesToPdf',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      createReverseFinanceDoc: function createReverseFinanceDoc(id) {
        return this.progressify($http({
          url: url + '/api/createReverseFinanceDoc/' + id,
          method: 'POST',
          headers: headers('POST', true)
        }));
      },
      uploadFinanceEntries: function uploadFinanceEntries(data) {
        return this.progressify($http({
          url: url + '/api/uploadFinanceEntries',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      getFinanceScripts: function getFinanceScripts(queryObj) {
        var query = makeQuery(queryObj);
        return this.progressify($http({
          url: "".concat(url, "/api/getFinanceScripts").concat(query),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      generateFinanceScript: function generateFinanceScript(data) {
        return this.progressify($http({
          url: url + '/api/generateFinanceScript',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      deleteFinanceScript: function deleteFinanceScript(id) {
        return this.progressify($http({
          url: url + '/api/deleteFinanceScript/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getAllstates: function getAllstates(search, companyId) {
        return this.progressify($http({
          url: "".concat(url, "/api/gstState/getAll?search=").concat(search, "&company=").concat(companyId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createState: function createState(data) {
        return this.progressify($http({
          url: url + '/api/gstState/create',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      bulkCreateState: function bulkCreateState(data) {
        return this.progressify($http({
          url: url + '/api/gstState/bulk-create',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateState: function updateState(id, data) {
        return this.progressify($http({
          url: url + '/api/gstState/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      deleteState: function deleteState(id) {
        return this.progressify($http({
          url: url + '/api/gstState/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      },
      getAllrates: function getAllrates(search, companyId) {
        return this.progressify($http({
          url: "".concat(url, "/api/gstRate/getAll?search=").concat(search, "&company=").concat(companyId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      getAllratesByType: function getAllratesByType(search, type, companyId) {
        return this.progressify($http({
          url: "".concat(url, "/api/gstRate/getAll?search=").concat(search, "&type=").concat(type, "&company=").concat(companyId),
          method: 'GET',
          headers: headers('GET', true)
        }));
      },
      createRate: function createRate(data) {
        return this.progressify($http({
          url: url + '/api/gstRate/create',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      bulkCreateRate: function bulkCreateRate(data) {
        return this.progressify($http({
          url: url + '/api/gstRate/bulk-create',
          method: 'POST',
          headers: headers('POST', true),
          data: data
        }));
      },
      updateRate: function updateRate(id, data) {
        return this.progressify($http({
          url: url + '/api/gstRate/' + id,
          method: 'PUT',
          headers: headers('PUT', true),
          data: data
        }));
      },
      deleteRate: function deleteRate(id) {
        return this.progressify($http({
          url: url + '/api/gstRate/' + id,
          method: 'DELETE',
          headers: headers('DELETE', true)
        }));
      }
    };
  }
})();


"use strict";

var Constants = {
  UserTypeList: [{
    key: "admin",
    name: "Admin",
    dashboardType: 'Admin',
    dashboardRoute: "auditManage"
  }, {
    key: "client",
    name: "Client",
    dashboardType: 'Client',
    dashboardRoute: "clientManage"
  }, {
    key: "supplier",
    name: "Supplier",
    dashboardType: 'Supplier',
    dashboardRoute: "supplierManage"
  }, {
    key: "subcontractor",
    name: "Subcontractor",
    dashboardType: 'Subcontractor',
    dashboardRoute: "subContractorManage"
  }, {
    key: "ceo",
    name: "CEO",
    dashboardType: 'CEO',
    dashboardRoute: "ceo"
  }, {
    key: "financeManager",
    name: "Finance Manager",
    dashboardType: 'Finance Manager',
    dashboardRoute: "financeDashboard"
  }, {
    key: "auditManager",
    name: "Audit Manager",
    dashboardType: 'Audit Manager',
    dashboardRoute: "auditManage"
  }, {
    key: "bidManager",
    name: "Bid Manager",
    dashboardType: 'Bid Manager',
    dashboardRoute: "bidManage"
  }, {
    key: "salesManager",
    name: "Sales Manager",
    dashboardType: 'Sales Manager',
    dashboardRoute: "calcMain"
  }, {
    key: "siteManager",
    name: "Site Manager",
    dashboardType: 'Site Manager',
    dashboardRoute: "siteManage1"
  }, {
    key: "qsheManager",
    name: "QSHE Manager",
    dashboardType: 'QSHE Manager',
    dashboardRoute: "qsheManage"
  }, {
    key: "designManager",
    name: "Design Manager",
    dashboardType: 'Design Manager',
    dashboardRoute: "projectDesign"
  }, {
    key: "projectManager",
    name: "Project Manager",
    dashboardType: 'Project Manager',
    dashboardRoute: "productionsBoard"
  }],
  AccessKey: {
    PROJECT: 1000,
    //left gap for possible sub actions
    TEAM: 1100,
    NOTE: 1200,
    ISSUE: 1300,
    REPORT: 1400,
    CPLAN: 1500,
    CHKLIST: 1600,
    FMANAGER: 1700,
    DVIEWER: 1800,
    VP: 1900,
    MEETING: 2000,
    CALC: 2100,
    BUDGET: 2200,
    TIMELINE: 2300,
    ECO: 2400,
    MAT: 2500,
    EQ: 2600,
    OFFER: 2700,
    STOCK: 2800,
    SETTING: 2900,
    CLIENT: 3000,
    EMPLOYEE: 3100,
    SUPPLIER: 3200,
    SUBCONTRACTOR: 3300,
    CALENDAR: 3400,
    TODO: 3500,
    PCD: 3600,
    TQ: 3700,
    PHOTO: 3800
  },
  AccessArea: [{
    name: "Project",
    key: "PROJECT"
  }, {
    name: "Team",
    key: "TEAM"
  }, {
    name: "Issue",
    key: "ISSUE"
  }, {
    name: "Report",
    key: "REPORT"
  }, {
    name: "TQ",
    key: "TQ"
  }, {
    name: "Control Plan",
    key: "CPLAN"
  }, {
    name: "Checklist",
    key: "CHKLIST"
  }, {
    name: "File Manager",
    key: "FMANAGER"
  }, {
    name: "Dynamic Viewer",
    key: "DVIEWER"
  }, {
    name: "Visual Planner",
    key: "VP"
  }, {
    name: "Meeting Room",
    key: "MEETING"
  }, {
    name: "Calculation",
    key: "CALC"
  }, {
    name: "Budget",
    key: "BUDGET"
  }, {
    name: "Timeline",
    key: "TIMELINE"
  }, {
    name: "Economic",
    key: "ECO"
  }, {
    name: "Material",
    key: "MAT"
  }, {
    name: "Equipment",
    key: "EQ"
  }, {
    name: "Offer",
    key: "OFFER"
  }, {
    name: "Stock",
    key: "STOCK"
  }, {
    name: "Setting",
    key: "SETTING"
  }, {
    name: "Typewriter",
    key: "NOTE"
  }, {
    name: "Client",
    key: "CLIENT"
  }, {
    name: "Employee",
    key: "EMPLOYEE"
  }, {
    name: "Supplier",
    key: "SUPPLIER"
  }, {
    name: "SubContractor",
    key: "SUBCONTRACTOR"
  }, {
    name: "Calendar",
    key: "CALENDAR"
  }, {
    name: "To Do",
    key: "TODO"
  }],
  EventTypeList: [{
    index: 0,
    key: 'schedule',
    label: 'Marc\'s Schedule',
    backgroundColor: '#E7D7F7',
    textColor: '#367BF5'
  }, {
    index: 1,
    key: 'birthday',
    label: 'Birthday',
    backgroundColor: '#DCF7E3',
    textColor: '#2FA84F'
  }, {
    index: 2,
    key: 'reminder',
    label: 'Reminder',
    backgroundColor: '#FEE4E2',
    textColor: '#D71414'
  }, {
    index: 3,
    key: 'tasks',
    label: 'Tasks',
    backgroundColor: '#FCF3D7',
    textColor: '#069697'
  }, {
    index: 4,
    key: 'dk-holidays',
    label: 'Holidays in Denmark',
    backgroundColor: '#E5EFFF',
    textColor: '#813AC8'
  }, {
    index: 5,
    key: 'in-holidays',
    label: 'Holidays in India',
    backgroundColor: '#FFE8CC',
    textColor: '#FF8B00'
  }],
  ScheduleTypeList: [{
    index: 0,
    key: 'design',
    label: 'Design Team',
    backgroundColor: '#E7D7F7',
    textColor: '#367BF5'
  }, {
    index: 1,
    key: 'qa',
    label: 'QA Team',
    backgroundColor: '#DCF7E3',
    textColor: '#2FA84F'
  }, {
    index: 2,
    key: 'marketing',
    label: 'Marketing Team',
    backgroundColor: '#FEE4E2',
    textColor: '#D71414'
  }, {
    index: 3,
    key: 'development',
    label: 'Development Team',
    backgroundColor: '#FCF3D7',
    textColor: '#069697'
  }, {
    index: 4,
    key: 'productivity',
    label: 'Productivity Team',
    backgroundColor: '#E5EFFF',
    textColor: '#813AC8'
  }, {
    index: 5,
    key: 'program_manager',
    label: 'Program Manager',
    backgroundColor: '#FFE8CC',
    textColor: '#FF8B00'
  }, {
    index: 6,
    key: 'trainee_engineer',
    label: 'Trainee Engineer',
    backgroundColor: '#FFE8CC',
    textColor: '#FF8B00'
  }],
  StockLocationType: ["Warehouse", "Customer", "Project/Construction site"],
  OCRTemplateNormalFieldsList: [{
    name: "invoicenumber",
    bind: "invoicenumber",
    description: "Invoice Number"
  }, {
    name: 'billdate',
    bind: 'billdate',
    description: 'Bill Date'
  }, {
    name: "description",
    bind: "description",
    description: "Description"
  }, {
    name: "qty",
    bind: "qty",
    description: "Qty"
  }, {
    name: "unitprice",
    bind: "unitprice",
    description: "Unit Price"
  }],
  OCRTemplateOnePriceFieldsList: [{
    name: "invoicenumber",
    bind: "invoicenumber",
    description: "Invoice Number"
  }, {
    name: 'billdate',
    bind: 'billdate',
    description: 'Bill Date'
  }, {
    name: "description",
    bind: "description",
    description: "Description"
  }, {
    name: "qty",
    bind: "qty",
    description: "Qty"
  }, {
    name: "totalprice",
    bind: "totalprice",
    description: "Total Price"
  }],
  OCRTemplateLoopFieldsList: ['qty', 'unitprice', 'description'],
  PaperSizeList: [{
    _id: "letter",
    width: 8.5,
    height: 11,
    name: "Letter"
  }, {
    _id: "tabloid",
    width: 11,
    height: 17,
    name: "Tabloid"
  }, {
    _id: "legal",
    width: 8.5,
    height: 14,
    name: "Legal"
  }, {
    _id: "a1",
    width: 23.4,
    height: 33.1,
    name: "A1"
  }, {
    _id: "a2",
    width: 16.5,
    height: 23.4,
    name: "A2"
  }, {
    _id: "a3",
    width: 11.69,
    height: 16.54,
    name: "A3"
  }, {
    _id: "a4",
    width: 8.27,
    height: 11.69,
    name: "A4"
  }, {
    _id: "a5",
    width: 5.83,
    height: 8.27,
    name: "A5"
  }, {
    _id: "b4",
    width: 9.84,
    height: 13.9,
    name: "B4"
  }, {
    _id: "b5",
    width: 6.93,
    height: 9.84,
    name: "B5"
  }],
  OrderTypes: {
    SALES: '0',
    PURCHASE: '1',
    RENTAL: '2',
    PROJECT: '3'
  },
  UserAvatarColors: {
    colors: ["#FFB900", "#D83B01", "#B50E0E", "#E81123", "#B4009E", "#5C2D91", "#0078D7", "#00B4FF", "#008272", "#107C10"]
  }
};


"use strict"; // var angular = require('angular');

(function () {
  var isFunction = angular.isFunction,
      isString = angular.isString;

  function applyPairs(memo, keyValTuple) {
    var key, value;
    if (angular.isArray(keyValTuple)) key = keyValTuple[0], value = keyValTuple[1];
    if (!isString(key)) throw new Error("invalid parameters to applyPairs");
    memo[key] = value;
    return memo;
  }

  function stateChangeStartHandler($transition$) {
    if (!$transition$.options().notify || !$transition$.valid() || $transition$.ignored()) return;
    var $injector = $transition$.injector();
    var $stateEvents = $injector.get('$stateEvents');
    var $rootScope = $injector.get('$rootScope');
    var $state = $injector.get('$state');
    var $urlRouter = $injector.get('$urlRouter');
    var enabledEvents = $stateEvents.provider.enabled();
    var toParams = $transition$.params("to");
    var fromParams = $transition$.params("from");

    if (enabledEvents.$stateChangeSuccess) {
      var startEvent = $rootScope.$broadcast('$stateChangeStart', $transition$.to(), toParams, $transition$.from(), fromParams, $transition$.options(), $transition$);

      if (startEvent.defaultPrevented) {
        if (enabledEvents.$stateChangeCancel) {
          $rootScope.$broadcast('$stateChangeCancel', $transition$.to(), toParams, $transition$.from(), fromParams, $transition$.options(), $transition$);
        } //Don't update and resync url if there's been a new transition started. see issue #2238, #600


        if ($state.transition == null) $urlRouter.update();
        return false;
      }

      $transition$.promise.then(function () {
        $rootScope.$broadcast('$stateChangeSuccess', $transition$.to(), toParams, $transition$.from(), fromParams, $transition$.options(), $transition$);
      });
    }

    if (enabledEvents.$stateChangeError) {
      $transition$.promise["catch"](function (error) {
        if (error && (error.type === 2
        /* RejectType.SUPERSEDED */
        || error.type === 3
        /* RejectType.ABORTED */
        )) return;
        var evt = $rootScope.$broadcast('$stateChangeError', $transition$.to(), toParams, $transition$.from(), fromParams, error, $transition$.options(), $transition$);

        if (!evt.defaultPrevented) {
          $urlRouter.update();
        }
      });
    }
  }

  stateNotFoundHandler.$inject = ['$to$', '$from$', '$state', '$rootScope', '$urlRouter'];

  function stateNotFoundHandler($to$, $from$, injector) {
    var $state = injector.get('$state');
    var $rootScope = injector.get('$rootScope');
    var $urlRouter = injector.get('$urlRouter');
    var redirect = {
      to: $to$.identifier(),
      toParams: $to$.params(),
      options: $to$.options()
    };
    var e = $rootScope.$broadcast('$stateNotFound', redirect, $from$.state(), $from$.params());
    if (e.defaultPrevented || e.retry) $urlRouter.update();

    function redirectFn() {
      return $state.target(redirect.to, redirect.toParams, redirect.options);
    }

    if (e.defaultPrevented) {
      return false;
    } else if (e.retry || !!$state.get(redirect.to)) {
      return e.retry && isFunction(e.retry.then) ? e.retry.then(redirectFn) : redirectFn();
    }
  }

  $StateEventsProvider.$inject = ['$stateProvider'];

  function $StateEventsProvider($stateProvider) {
    $StateEventsProvider.prototype.instance = this;
    var runtime = false;
    var allEvents = ['$stateChangeStart', '$stateNotFound', '$stateChangeSuccess', '$stateChangeError'];
    var enabledStateEvents = allEvents.map(function (e) {
      return [e, true];
    }).reduce(applyPairs, {});

    function assertNotRuntime() {
      if (runtime) throw new Error("Cannot enable events at runtime (use $stateEventsProvider");
    }
    /**
     * Enables the deprecated UI-Router 0.2.x State Events
     * [ '$stateChangeStart', '$stateNotFound', '$stateChangeSuccess', '$stateChangeError' ]
     */


    this.enable = function () {
      var events = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        events[_i - 0] = arguments[_i];
      }

      assertNotRuntime();
      if (!events || !events.length) events = allEvents;
      events.forEach(function (event) {
        return enabledStateEvents[event] = true;
      });
    };
    /**
     * Disables the deprecated UI-Router 0.2.x State Events
     * [ '$stateChangeStart', '$stateNotFound', '$stateChangeSuccess', '$stateChangeError' ]
     */


    this.disable = function () {
      var events = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        events[_i - 0] = arguments[_i];
      }

      assertNotRuntime();
      if (!events || !events.length) events = allEvents;
      events.forEach(function (event) {
        return delete enabledStateEvents[event];
      });
    };

    this.enabled = function () {
      return enabledStateEvents;
    };

    this.$get = $get;
    $get.$inject = ['$transitions'];

    function $get($transitions) {
      runtime = true;
      if (enabledStateEvents["$stateNotFound"]) $stateProvider.onInvalid(stateNotFoundHandler);
      if (enabledStateEvents.$stateChangeStart) $transitions.onBefore({}, stateChangeStartHandler, {
        priority: 1000
      });
      return {
        provider: $StateEventsProvider.prototype.instance
      };
    }
  }

  angular.module('ui.router.state.events', ['ui.router.state']).provider("$stateEvents", $StateEventsProvider).run(runBlockForStateEvent);
  /** @ngInject */

  function runBlockForStateEvent($stateEvents) {
    // please do not remove $stateEvents in parameters
    $stateEvents.to; // for prevent warning.
  }
})();


"use strict";

var firebase;

(function () {
  'use strict';

  angular.module('app').run(runBlock);
  /** @ngInject */

  function runBlock($document, $window, $log, $rootScope, $state, $transitions, tmhDynamicLocale, Notification, globals, editableOptions, localStorageService, $translate) {
    var notificationStore = globals.notificationStore;
    var lang = localStorageService.get('lang') || 'en';
    $translate.use(lang);
    var translateChange = $rootScope.$on('$translateChangeSuccess', function (event, data) {
      tmhDynamicLocale.set(data.language);
      $document[0].documentElement.setAttribute('lang', data.language);
    });
    var stateChange = $rootScope.$on('$stateChangeStart', function (evt, to, params) {
      if (to.redirectTo) {
        evt.preventDefault();
        $state.go(to.redirectTo, params, {
          location: 'replace'
        });
      }
    });
    var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (ev, to) {
      var itemSize = 380;

      function setScale() {
        var curRWidth = $window.screen.width;
        var element = $document[0].documentElement;
        var defaultRWidth = parseInt(getComputedStyle(element).getPropertyValue('--default-resolution-width'));
        var contentWidth = Math.floor((Math.max(defaultRWidth, curRWidth) - 100) / itemSize) * itemSize - 30;
        var scaleX = Math.min(1, curRWidth / defaultRWidth);
        element.style.setProperty('--global-scale-x', scaleX);
        element.style.setProperty('--global-inverse-scale-x', 1 / scaleX);
        element.style.setProperty('--global-content-width', contentWidth + 'px');
        element.style.setProperty('--global-min-width', Math.max(defaultRWidth, contentWidth + 100) + 'px');
        $rootScope.scale = scaleX;
        var numPerRow = Math.ceil((contentWidth + 30) / itemSize);
        $rootScope.numPerPage = itemSize === 285 ? numPerRow * 4 : numPerRow * 2;
      }

      function clearScale() {
        var element = $document[0].documentElement;
        var defaultRWidth = parseInt(getComputedStyle(element).getPropertyValue('--default-resolution-width'));
        element.style.setProperty('--global-scale-x', 1);
        element.style.setProperty('--global-inverse-scale-x', 1);
        element.style.setProperty('--global-content-width', defaultRWidth + 'px');
        element.style.setProperty('--global-min-width', defaultRWidth + 'px');
        $rootScope.scale = 1;
        $rootScope.numPerPage = 6;
      }

      var url = to.url;

      if (url && (url.indexOf("/bim/detail/:id") !== -1 || url.indexOf("/vp/detail/:id") !== -1 || url.indexOf('/issues/marking') !== -1 || url.indexOf('/report/marking') !== -1 || url.indexOf("/gis") !== -1)) {
        clearScale();
      } else {
        itemSize = 380;

        if (url) {
          if (url.indexOf("/type-writter/") !== -1) {
            itemSize = 300;
          } else if (url.indexOf("/check-list") !== -1 || url.indexOf("/control-plan/grid") !== -1) {
            itemSize = 285;
          }
        }

        setScale();
      }
    });

    function goToTeams(data) {
      notificationStore.set(data);
      $state.go('teams');
    }

    function initPushNotification() {
      var firebaseConfig = {
        apiKey: "AIzaSyAMRTh6THgKQ0bwGOd64U9DZ6gL9GBEX7g",
        authDomain: "cloudes-ocr.firebaseapp.com",
        databaseURL: "https://cloudes-ocr.firebaseio.com",
        projectId: "cloudes-ocr",
        storageBucket: "cloudes-ocr.appspot.com",
        messagingSenderId: "358322205035",
        appId: "1:358322205035:web:b967454ba29168771b9c2e",
        measurementId: "G-8S6QYEFYQZ"
      };

      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      } // Retrieve Firebase Messaging object.


      var messaging = firebase.messaging();
      messaging.onMessage(function (payload) {
        if (payload.data.actionType !== "cancel" && payload.data.actionType !== "accept") {
          var data = payload.data;
          var title = data.isVideo === "true" ? 'Incoming Video Call...' : 'Incoming Audio Call...';
          var avatarUrl = data.callerAvatar || '/assets/images/employees/no-avatar.png';
          var message = "<div style=\"display: flex; align-items: center;\">\n              <img src=\"".concat(avatarUrl, "\" alt=\"\" style=\"width: 40px; height: 40px; object-fit: cover; border-radius: 50%; border: 2px solid white; margin-right: 8px\">\n              <div style=\"font: normal 600 14px/40px Inter; color: white;\">").concat(data.callerName, "</div>\n            </div>\n              ");
          Notification.info({
            message: message,
            title: title // closeOnClick: false,
            // delay: 5000

          });
          goToTeams(data);
        }
      });
    }

    initPushNotification();
    editableOptions.theme = 'bs3';
    $rootScope.$on('$destroy', function () {
      stateChange();
      translateChange();
      stateChangeSuccess();
    });
  }
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').config(routerConfig);
  /** @ngInject */

  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('home', {
      url: '/',
      redirectTo: 'login'
    }).state('login', {
      url: '/login',
      component: 'login'
    }).state('register', {
      url: '/register',
      component: 'register'
    }).state('tenderList', {
      url: '/tender-list',
      component: 'tenderList'
    }).state('forgetPassword', {
      url: '/forgetPassword',
      component: 'forgetPassword'
    }).state('setPassword', {
      url: '/setPassword',
      component: 'setPassword'
    }) // .state('termsAndConditions', {
    //   url: '/terms-conditions',
    //   component: 'termsAndConditions'
    // })
    .state('workOrder', {
      url: '/dashboard/workOrder',
      component: 'workOrder'
    }).state('ceo', {
      url: '/dashboard/ceo-page',
      component: 'ceoSpash'
    }).state('procurement', {
      url: '/dashboard/procurement',
      component: 'procurement'
    }).state('ceoEconomics', {
      url: '/dashboard/ceo-economics-page',
      component: 'ceoEconomics'
    }).state('economicManage', {
      url: '/economic/dashboard',
      component: 'economicManage'
    }).state('clientManage', {
      url: '/dashboard/collaborator/client-page',
      component: 'clientManage'
    }).state('subContractorManage', {
      url: '/dashboard/collaborator/subcontractor-page',
      component: 'subContractorManage'
    }).state('supplierManage', {
      url: '/dashboard/collaborator/supplier-page',
      component: 'supplierManage'
    }).state('siteManage1', {
      url: '/dashboard/sitemanager-page',
      component: 'siteManage1'
    }).state('qsheManage', {
      url: '/dashboard/qshemanager-page',
      component: 'qsheManage'
    }).state('productionsBoard', {
      url: '/dashboard/productionsboard-page',
      component: 'productionsBoard'
    }).state('projectDesign', {
      url: '/dashboard/projectdesign-page',
      component: 'projectDesign'
    }).state('bidManage', {
      url: '/dashboard/bidmanager-page',
      component: 'bidManage'
    }).state('auditManage', {
      url: '/dashboard/auditmanager-page',
      component: 'auditManage'
    }).state('salesManage', {
      url: '/dashboard/salesmanager-page',
      component: 'salesManage'
    }).state('pcdGenerate', {
      url: '/visual-time/pcd/generate',
      component: 'pcdGenerate'
    }).state('pcdGrid', {
      url: '/visual-time/pcd/grid',
      component: 'pcdGrid'
    }).state('pcdDetail', {
      url: '/pcd/detail/:id',
      component: 'pcdDetail'
    }).state('photoGrid', {
      url: '/visual-time/photo/grid',
      component: 'photoGrid'
    }).state('photoDetail', {
      url: '/visual-time/photo/detail/:id',
      component: 'photoDetail'
    }).state('bimGrid', {
      url: '/visual-time/bim/grid',
      component: 'bimGrid'
    }).state('bimDetail', {
      url: '/bim/detail/:id',
      component: 'bimDetail'
    }).state('vpGrid', {
      url: '/visual-time/vp/grid',
      component: 'vpGrid'
    }).state('vpDetail', {
      url: '/vp/detail/:id',
      component: 'vpDetail'
    }).state('gis', {
      url: '/gis/:id',
      component: 'gis'
    }) // suppliers pages
    .state('suppliersAdd', {
      url: '/suppliers/add',
      component: 'suppliersAdd'
    }).state('suppliersEdit', {
      url: '/suppliers/edit/:id',
      component: 'suppliersEdit'
    }).state('suppliersDetail', {
      url: '/suppliers/detail/:id',
      component: 'suppliersDetail'
    }).state('suppliersGrid', {
      url: '/suppliers',
      component: 'suppliersGrid'
    }) // sub Contractors pages
    .state('subContractorsAdd', {
      url: '/sub-contractors/add',
      component: 'subContractorsAdd'
    }).state('subContractorsDetail', {
      url: '/sub-contractors/detail/:id',
      component: 'subContractorsDetail'
    }).state('subContractorsEdit', {
      url: '/sub-contractors/edit/:id',
      component: 'subContractorsEdit'
    }).state('subContractorsGrid', {
      url: '/sub-contractors',
      component: 'subContractorsGrid'
    }) // clients pages
    .state('clientsAdd', {
      url: '/clients/add',
      component: 'clientsAdd'
    }).state('clientsDetail', {
      url: '/clients/detail/:id',
      component: 'clientsDetail'
    }).state('clientsEdit', {
      url: '/clients/edit/:id',
      component: 'clientsEdit'
    }).state('clientsGrid', {
      url: '/clients',
      component: 'clientsGrid'
    }) // managers page
    .state('managersAdd', {
      url: '/managers/add',
      component: 'managersAdd'
    }).state('managersDetail', {
      url: '/managers/detail/:id',
      component: 'managersDetail'
    }).state('managersEdit', {
      url: '/managers/edit/:id',
      component: 'managersEdit'
    }).state('managersGrid', {
      url: '/managers',
      component: 'managersGrid'
    }) //check List
    .state('checkList', {
      url: '/check-list',
      component: 'checkList'
    }).state('calendar', {
      url: '/calendar',
      component: 'calendar'
    }).state('companyCalendar', {
      url: '/calendar/company',
      component: 'companyCalendar'
    }) // materials pages for material
    .state('materialList', {
      url: '/materials/material-list',
      component: 'materialList'
    }).state('addMaterial', {
      url: '/materials/add-material',
      component: 'addMaterial'
    }).state('editMaterial', {
      url: '/materials/edit-material/:id',
      component: 'editMaterial'
    }).state('materialDetail', {
      url: '/materials/material-detail/:id',
      component: 'materialDetail'
    }).state('materialAI', {
      url: '/materials/material-ai/:id',
      component: 'materialAI'
    }) // materials pages for dcp
    .state('dcpList', {
      url: '/materials/dcp-list',
      component: 'dcpList'
    }).state('addDcp', {
      url: '/materials/add-dcp',
      component: 'addDcp'
    }).state('editDcp', {
      url: '/materials/edit-dcp/:id',
      component: 'editDcp'
    }).state('dcpDetail', {
      url: '/materials/dcp-detail/:id',
      component: 'dcpDetail'
    }) // materials pages for items
    .state('itemList', {
      url: '/materials/item-list',
      component: 'itemList'
    }).state('addItem', {
      url: '/materials/add-item',
      component: 'addItem'
    }).state('editItem', {
      url: '/materials/edit-item/:id',
      component: 'editItem'
    }).state('itemDetail', {
      url: '/materials/item-detail/:id',
      component: 'itemDetail'
    }) // equipments pages
    .state('equipmentList', {
      url: '/equipments/equipment-list',
      component: 'equipmentList'
    }).state('addEquipment', {
      url: '/equipments/add-equipment',
      component: 'addEquipment'
    }).state('editEquipment', {
      url: '/equipments/edit-equipment/:id',
      component: 'editEquipment'
    }).state('equipmentDetail', {
      url: '/equipments/equipment-detail/:id',
      component: 'equipmentDetail'
    }) // equipments pages for dcq
    .state('dcqList', {
      url: '/equipments/dcq-list',
      component: 'dcqList'
    }).state('addDcq', {
      url: '/equipments/add-dcq',
      component: 'addDcq'
    }).state('editDcq', {
      url: '/equipments/edit-dcq/:id',
      component: 'editDcq'
    }).state('dcqDetail', {
      url: '/equipments/dcq-detail/:id',
      component: 'dcqDetail'
    }) // control plan pages
    .state('controlPlanGrid', {
      url: '/control-plan/grid',
      component: 'controlPlanGrid'
    }).state('controlPlanAdd', {
      url: '/control-plan/add',
      component: 'controlPlanAdd'
    }).state('controlPlanEdit', {
      url: '/control-plan/edit/:id',
      component: 'controlPlanEdit'
    }) // meeting room pages
    .state('meetingRoom', {
      url: '/virtual-mail/meeting-room',
      component: 'meetingRoom'
    }).state('calling', {
      url: '/calling/:type',
      component: 'calling'
    }) // create project room pages
    .state('createProject', {
      url: '/create-project',
      component: 'createProject'
    }).state('createServiceProject', {
      url: '/createServiceProject',
      component: 'createProject'
    }).state('updateProject', {
      url: '/update-project/:id',
      component: 'createProject'
    }).state('projectDetail', {
      url: '/project-detail/:id',
      component: 'projectDetail'
    }).state('projectList', {
      url: '/project-list',
      component: 'projectList'
    }).state('workOrderList', {
      url: '/workOrder-list',
      component: 'workOrderList'
    }) // Offers
    .state('createOffer', {
      url: '/create-offer',
      component: 'createOffer'
    }).state('updateOffer', {
      url: '/update-offer/:id',
      component: 'createOffer'
    }).state('offerDetail', {
      url: '/offer-detail/:id',
      component: 'offerDetail'
    }).state('offerList', {
      url: '/offers',
      component: 'offers'
    }).state('orders', {
      url: '/orders/list',
      component: 'orders'
    }).state('salesOrders', {
      url: '/orders/sales/list',
      component: 'salesOrders'
    }).state('salesProducts', {
      url: '/orders/products/list',
      component: 'salesProducts'
    }).state('purchaseOrders', {
      url: '/orders/purchase/list',
      component: 'purchaseOrders'
    }).state('rentalOrders', {
      url: '/orders/rental/list',
      component: 'rentalOrders'
    }).state('salesBills', {
      url: '/orders/bills/list',
      component: 'salesBills'
    }).state('salesCars', {
      url: '/orders/cars/list',
      component: 'salesCars'
    }).state('createBillsOrder', {
      url: '/orders/bills/create',
      component: 'createBillsOrder'
    }).state('projectOrders', {
      url: '/orders/project/list',
      component: 'projectOrders'
    }).state('salesInvoices', {
      url: '/orders/invoices/list',
      component: 'salesInvoices'
    }).state('createInvoiceOrder', {
      url: '/orders/invoices/create',
      component: 'createInvoiceOrder'
    }).state('returnOrders', {
      url: '/orders/return/list',
      component: 'returnOrders'
    }).state('warehouseOrders', {
      url: '/orders/warehouse/list',
      component: 'warehouseOrders'
    }).state('createSalesOrder', {
      url: '/orders/sales/create',
      component: 'createSalesOrder'
    }).state('editSalesOrder', {
      url: '/orders/sales/edit/:id',
      component: 'createSalesOrder'
    }).state('createPurchaseOrder', {
      url: '/orders/purchase/create',
      component: 'createPurchaseOrder'
    }).state('createPurchaseOrderFromWarehouse', {
      url: '/orders/purchase/create/:warehouseId',
      component: 'createPurchaseOrder'
    }).state('editPurchaseOrder', {
      url: '/orders/purchase/edit/:id',
      component: 'createPurchaseOrder'
    }).state('createRentalOrder', {
      url: '/orders/rental/create',
      component: 'createRentalOrder'
    }).state('editRentalOrder', {
      url: '/orders/rental/edit/:id',
      component: 'createRentalOrder'
    }).state('orderDetail', {
      url: '/orders/detail/:id',
      component: 'orderDetail'
    }).state('orderAction', {
      url: '/order/action',
      component: 'orderAction'
    }).state('salesOrderAction', {
      url: '/sales-order/action',
      component: 'salesOrderAction'
    }).state('projectOrderAction', {
      url: '/project-order/action',
      component: 'projectOrderAction'
    }).state('rentalOrderAction', {
      url: '/rental-order/action',
      component: 'rentalOrderAction'
    }).state('returnOrderAction', {
      url: '/return-order/action',
      component: 'returnOrderAction'
    }) // economic pages
    .state('invoiceList', {
      url: '/economic/invoice/list',
      component: 'invoiceList'
    }).state('createInvoice', {
      url: '/economic/invoice/create',
      component: 'createInvoice'
    }).state('editInvoice', {
      url: '/economic/invoice/edit/:id',
      component: 'createInvoice'
    }).state('invoiceDetail', {
      url: '/economic/invoice/detail/:id',
      component: 'invoiceDetail'
    }).state('vaOrderList', {
      url: '/economic/va-order/list',
      component: 'vaOrderList'
    }).state('createVaOrder', {
      url: '/economic/va-order/create',
      component: 'createVaOrder'
    }).state('editVaOrder', {
      url: '/economic/va-order/edit/:id',
      component: 'createVaOrder'
    }).state('vaOrderDetail', {
      url: '/economic/va-order/detail/:id',
      component: 'vaOrderDetail'
    }).state('vaOrderAction', {
      url: '/economic/va-order/action',
      component: 'vaOrderAction'
    }).state('approveBill', {
      url: '/economic/bill/approve',
      component: 'approveBill'
    }).state('billScanner', {
      url: '/economic/bill/billScanner',
      component: 'billScanner'
    }).state('billList', {
      url: '/economic/bill/list',
      component: 'billList'
    }).state('payroll', {
      url: '/economic/payroll',
      component: 'payroll'
    }) // issues pages
    .state('issuesList', {
      url: '/qshe/issues/overview',
      component: 'issuesList'
    }).state('issueDetail', {
      url: '/qshe/issues/detail/:id',
      component: 'issueDetail'
    }).state('createIssue', {
      url: '/qshe/issues/create',
      component: 'createIssue'
    }).state('editIssue', {
      url: '/qshe/issues/edit',
      component: 'createIssue'
    }).state('issuesMarking', {
      url: '/qshe/issues/marking',
      component: 'issuesMarking'
    }) // report pages
    .state('reportsList', {
      url: '/qshe/report',
      component: 'reportsList'
    }).state('reportsDetails', {
      url: '/qshe/report/detail/:id',
      component: 'reportsDetails'
    }).state('createReports', {
      url: '/qshe/report/create',
      component: 'createReports'
    }).state('editReports', {
      url: '/qshe/report/edit',
      component: 'createReports'
    }).state('reportsMarking', {
      url: '/qshe/registration/marking:id',
      component: 'reportsMarking'
    }).state('addRegistration', {
      url: '/qshe/report/add-registration/:id',
      component: 'addRegistration'
    }) //tq pages
    .state('tqList', {
      url: '/qshe/tq/overview',
      component: 'tqList'
    }).state('createTq', {
      url: '/qshe/tq/createTq',
      component: 'createTq'
    }).state('editTq', {
      url: '/qshe/tq/createTq/:id',
      component: 'createTq'
    }).state('detailTq', {
      url: '/qshe/tq/detailTq/:id',
      component: 'detailTq'
    }) // timeline pages
    .state('timeline', {
      url: '/visual-time/timeline',
      component: 'timeline'
    }) // Calculation
    .state('calcMain', {
      url: '/calc/calc/main',
      component: 'calcMain'
    }).state("calcExtra", {
      url: "/calc/calc/extra/",
      component: 'calcExtra'
    }).state('calcVersions', {
      url: '/calc/calc/versions',
      component: 'calcVersions'
    }).state('calVersionDetail', {
      url: '/calc/version/:id',
      component: 'calVersionDetail'
    }) // budget page
    .state('budget', {
      url: '/calc/budget',
      component: 'budget'
    }).state('companyBudget', {
      url: '/calc/company-budget',
      component: 'companyBudget'
    }).state('companyBudgetTemplate', {
      url: '/calc/company-budget/template',
      component: 'companyBudgetTemplate'
    }) // employee page
    .state('employees', {
      url: '/employees/employees',
      component: 'employees'
    }).state('employeeGroup', {
      url: '/employees/group',
      component: 'employeeGroup'
    }).state('employeesAdd', {
      url: '/employees/add-employee',
      component: 'employeesAdd'
    }).state('employeesEdit', {
      url: '/employees/edit-employee/:id',
      component: 'employeesEdit'
    }).state('employeesDetail', {
      url: '/employees/detail-employee/:id',
      component: 'employeesDetail'
    }).state('groupAdd', {
      url: '/employees/add-group',
      component: 'groupAdd'
    }).state('groupEdit', {
      url: '/employees/edit-group/:id',
      component: 'groupEdit'
    }).state('groupDetail', {
      url: '/employees/detail-group/:id',
      component: 'groupDetail'
    }) // synergies
    .state('synergies', {
      url: '/synergies',
      component: 'synergies'
    }).state('teamsMeeting', {
      url: '/synergies/meeting/:id',
      component: 'teamsMeeting'
    }) // collaborations
    .state('createBidOfferTemplate', {
      url: '/collaborations/bid-packages/create-template',
      component: 'createBidOfferTemplate'
    }).state('editOfferTemplate', {
      url: '/collaborations/bid-packages/editOfferTemplate/:id',
      component: 'createBidOfferTemplate'
    }).state('createBidPackage', {
      url: '/collaborations/bid-packages/create',
      component: 'createBidPackage'
    }).state('editBidPackage', {
      url: '/collaborations/bid-packages/create/:id',
      component: 'createBidPackage'
    }).state('bidPackages', {
      url: '/collaborations/bid-packages/list',
      component: 'bidPackages'
    }).state('offerTemplates', {
      url: '/collaborations/offer-template/list',
      component: 'offerTemplates'
    }).state('collaborationInvites', {
      url: '/collaborations/team/invites',
      component: 'collaborationInvites'
    }).state('projectInvite', {
      url: '/collaborations/project-invite',
      component: 'projectInvite'
    }).state('collaborationOffers', {
      url: '/collaborations/team/offers',
      component: 'collaborationOffers'
    }).state('submitOffers', {
      url: '/collaborations/submitOffers',
      component: 'submitOffers'
    }).state('incomingOffers', {
      url: '/collaborations/incomingOffers',
      component: 'incomingOffers'
    }).state('createTeam', {
      url: '/collaborations/team/create',
      component: 'createTeam'
    }).state('collaborationTeam', {
      url: '/collaborations/team/list',
      component: 'collaborationTeam'
    }) // Typewriter pages
    .state('typeWritterRichTextGrid', {
      url: '/type-writter/rich-text',
      component: 'typeWritterRichTextGrid'
    }).state('typeWritterSpreadSheetGrid', {
      url: '/type-writter/spread-sheet',
      component: 'typeWritterSpreadSheetGrid'
    }).state('typeWritterDetail', {
      url: '/type-writter/detail/:id',
      component: 'typeWritterDetail'
    }).state('typeWritterSpreadSheetDetail', {
      url: '/type-writter/spread-sheet/detail/:id',
      component: 'typeWritterDetailSpreadSheet'
    }).state('typeWritterAdd', {
      url: '/type-writter/add',
      component: 'typeWritterDetail'
    }).state('typeWritterSpreadSheetAdd', {
      url: '/type-writter/spread-sheet/add',
      component: 'typeWritterDetailSpreadSheet'
    }) // To Do
    .state('todo', {
      url: '/todo',
      component: 'todoBoard'
    }) // Notification
    .state('notifications', {
      url: '/notifications',
      component: 'notifications'
    }) // Activities
    .state('activities', {
      url: '/activities',
      component: 'activities'
    }).state('financeDashboard', {
      url: '/finance/dashboard',
      component: 'financeDashboard'
    }).state('financeScript', {
      url: '/finance/script',
      component: 'financeScript'
    }).state('financeBankList', {
      url: '/finance/bank/list',
      component: 'financeBankList'
    }).state('financeBankDetail', {
      url: '/finance/bank/detail',
      component: 'financeBankDetail'
    }).state('financeSales', {
      url: '/finance/sales/list',
      component: 'financeSales'
    }).state('financeClient', {
      url: '/finance/sales/client',
      component: 'financeClient'
    }).state('financePurchases', {
      url: '/finance/purchases/list',
      component: 'financePurchases'
    }).state('financeBillEdit', {
      url: '/finance/purchases/bill/:id',
      component: 'financeBillEdit'
    }).state('financeVendor', {
      url: '/finance/purchases/vendor',
      component: 'financeVendor'
    }).state('financeVatReports', {
      url: '/finance/reports/vat/list',
      component: 'financeVatReports'
    }).state('financeCreateVatReport', {
      url: '/finance/reports/vat/create',
      component: 'financeCreateVatReport'
    }).state('financeEditVatReport', {
      url: '/finance/reports/vat/edit/:id',
      component: 'financeCreateVatReport'
    }).state('financeCreditReports', {
      url: '/finance/reports/credit/list',
      component: 'financeCreditReports'
    }).state('financeDebitReports', {
      url: '/finance/reports/debit/list',
      component: 'financeDebitReports'
    }).state('financeFinance', {
      url: '/finance/finance',
      component: 'financeFinance'
    }).state('financeBalance', {
      url: '/finance/balance',
      component: 'financeBalance'
    }).state('financeVatSettings', {
      url: '/finance/vat-settings/list',
      component: 'financeVatSettings'
    }).state('financeCreateVatSetting', {
      url: '/finance/vat-settings/create',
      component: 'financeCreateVatSetting'
    }).state('financeEditVatSetting', {
      url: '/finance/vat-settings/edit/:id',
      component: 'financeEditVatSetting'
    }).state('financePosts', {
      url: '/finance/posts/:id',
      component: 'financePosts'
    }).state('financePosts2', {
      url: '/finance/posts2?type&type2?&accountPlanId&accountPlanNumber&fromDate&toDate&isOnlyApprovedBills&financialYear',
      component: 'financePosts2'
    }).state('financePosts3', {
      url: '/finance/posts3?vendorId&overdue',
      component: 'financePosts3'
    }).state('financePostsWip', {
      url: '/finance/postswip?wip&type&type2?&accountPlanId&accountPlanNumber&fromDate&toDate&isOnlyApprovedBills',
      component: 'financePostsWip'
    }).state('financeJournal', {
      url: '/finance/journal/list',
      component: 'financeJournalList'
    }).state('financeCreateManualJournal', {
      url: '/finance/journal/manual/create',
      component: 'financeCreateManualJournal'
    }).state('financeEditManualJournal', {
      url: '/finance/journal/manual/edit/:id',
      component: 'financeEditManualJournal'
    }).state('financeCreateReEnterJournal', {
      url: '/finance/journal/reenter/create',
      component: 'financeCreateReEnterJournal'
    }).state('financeEditReEnterJournal', {
      url: '/finance/journal/reenter/edit/:id',
      component: 'financeEditReEnterJournal'
    }).state('financeCreatePaymentJournal', {
      url: '/finance/journal/payment/create',
      component: 'financeCreatePaymentJournal'
    }).state('financeEditPaymentJournal', {
      url: '/finance/journal/payment/edit/:id',
      component: 'financeEditPaymentJournal'
    }).state('financeCreateInvoice', {
      url: '/finance/sales/createInvoice',
      component: 'financeCreateInvoice'
    }).state('financeEditInvoice', {
      url: '/finance/sales/editInvoice/:id',
      component: 'financeCreateInvoice'
    }).state('financeInvoiceDetail', {
      url: '/finance/sales/detailInvoice/:id',
      component: 'financeInvoiceDetail'
    });
    $urlRouterProvider.otherwise('/');
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").constant("SAMPLE_CONSTANT", "Sample constant").constant("SYNERGY_CONSTANTS", {
    CHAT_API_URL: "https://chatapi.synergy.surf",
    ERROR_MSG_INVALID_TOKEN: "invalid token",
    CLIENT_EVENT_SETUP_IDENTITY: "identity",
    CLIENT_EVENT_GET_MESSAGES: "getMessages",
    CLIENT_EVENT_POST_MESSAGE: "postMessage",
    CLIENT_EVENT_USER_TYPING: "userTyping",
    CLIENT_EVENT_EDIT_MESSAGE: "editMessage",
    CLIENT_EVENT_DELETE_MESSAGE: "deleteMessage",
    SERVER_EVENT_NEW_MESSAGE: "newMessage",
    SERVER_EVENT_TYPING_STARTS: "typingStarts",
    SERVER_EVENT_TYPING_STOPS: "typingStops",
    SERVER_EVENT_MESSAGE_EDIT: "messageEdit",
    SERVER_EVENT_MESSAGE_DELETE: "messageDelete",
    CHAT_MESSAGES_FETCH_LIMIT: 20
  });
})();


"use strict";

(function () {
  'use strict';

  angular.module('app').config(configBlock);
  /** @ngInject */

  function configBlock($locationProvider, $logProvider, $translateProvider, tmhDynamicLocaleProvider) {
    angular.lowercase = angular['$$lowercase'];
    $locationProvider.html5Mode(true);
    $logProvider.debugEnabled(true);
    $translateProvider.useStaticFilesLoader({
      // Update `config.locales.directory` in `gulp/config.js` if change.
      prefix: '/locales/',
      suffix: '.json'
    }).preferredLanguage('en').fallbackLanguage('en').useSanitizeValueStrategy('escape').useMissingTranslationHandlerLog();
    tmhDynamicLocaleProvider. // Angular locales pattern used by `buildAngularLocales()` in
    // `gulp/locales.js`.
    localeLocationPattern('/locales/angular-locale_{{locale}}.js').defaultLocale('en');
  }
})();


angular.module('app').run(['$templateCache', function($templateCache) {$templateCache.put('app/main/activities/activities.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div id=activities class=main-container><div class=content-wrapper><div class=sub-navigation><a ng-click=showDashboard() class=ft_14_regular_gray translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class=ft_14_600_black translate=Activities></a></div><div class=content><div class=header-title><div class=ft_24_600_black1 translate=Activities></div></div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0 && isLoading==false"><div class="mb-40 mt-10"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr></tr></thead><tbody><tr ng-class="[\'item2\', !vm.utils.isEmpty(activity.route)? \'cursor-point\': \'\']" ng-repeat="(key, activity) in vm.activities"><td class=checkbox-cell></td><td class="name-wrapper list" ng-click=goToDetail(activity)><div class="ft_16_600_black tx-ellipsis name" ng-bind=activity.title></div><div ng-bind=activity.description class="description tx-ellipsis" title={{activity.description}}></div></td><td class="text-center avatar-cell" ng-click=goToDetail(activity)><img ng-src="{{ activity.createdBy.profilePic?activity.createdBy.profilePic:\'/assets/images/suppliers/upload.svg\' }}" alt=icons class="avatar-60 object-fit-cover" title={{activity.createdBy.displayName}}></td><td class="tx-ellipsis update-time" ng-click=goToDetail(activity) ng-bind=activity.createdTime></td></tr></tbody></table></div><div class="split flex-between"><div><span class="ft_14_600_gray mr-15">Showing {{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.activities.length}}</span> of {{totalCount}} - <span translate=Activities></span></span></div><hr class=split-line><div class=flex-center><pagination num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchActivities()></pagination></div></div></div></div></div></div></main>');
$templateCache.put('app/main/calendar/calendar.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=calendar-wrap class=main-container><div class="content-wrapper-calendar d-flex"><side-navbar page=calendar></side-navbar><div class=side-menu><div class="flex-between mb-16"><div class=box-title><span class=icon><img src=/assets/icons/calendar_line_white.svg></span><span class=title translate=Calendar></span></div><button class="btn-trans cursor-point" ng-click=collapseMenu()><img src=/assets/icons/btn-hamberg-white.svg></button></div><button class="button-create cursor-point" ng-click=addEvent()><img class=mr-4 src=/assets/icons/bx-plus2.svg> <span translate="Create New"></span></button><div class="calendar mt-16 mb-16" id=side_calendar></div><div class=mb-16><searchbox is-icon=true icon-file=/assets/icons/person.svg input-class=search search-event=searchCallback() search-text=vm.searchText place-holder="Search for People"></searchbox></div><ul class="mail-nav pb-4"><li class="cursor-point h-auto d-block pb-24" ng-repeat="($index, item) in calendars"><div class=flex-between ng-click=onExpand($index)><span class=name>{{item.name}}</span> <span><img src=/assets/icons/chevron-down-gray.svg ng-style="{\'display\': item.expanded ? \'block\': \'none\'}"> <img src=/assets/icons/chevron-right-gray.svg ng-style="{\'display\': item.expanded  ? \'none\': \'block\'}"></span></div><ul class=child-ul ng-style="{\'display\': item.expanded ? \'block\': \'none\'}"><li class="cursor-point pr-0 pl-1 tech-menu" ng-repeat="(key, subItem) in item.children"><div class="flex-between child-between"><checkbox class=mr-10 ng-model=subItem.checked ng-click="onSelectItem(item._id, key)" ng-background-color=#363636 ng-border-color={{subItem.color}}></checkbox><span class=name>{{subItem.name}}</span></div></li></ul></li></ul></div><div class=side-menu-collapse ng-if=isCollapse><div class="flex-between mb-2"><button class="btn-trans cursor-point" ng-click=collapseMenu()><img src=/assets/icons/btn-hamberg-white.svg></button></div><button class="button-compose cursor-point" ng-click=onCompose()><img src=/assets/icons/bx-plus2.svg></button><div class=mail-nav-bar><ul class=mail-nav><li ui-sref=appMailInbox ui-sref-active=active class="cursor-point mail-box-li"><!-- <i class="fa fa-inbox mr-4"></i> --> <img src=/assets/icons/inbox_default.svg style="opacity: 0.5;"></li><li ui-sref=appMailSent ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/sent_default.svg></li><li ui-sref=appMailDraft ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/draft_default.svg></li><li ui-sref=appMailImportant ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/spam_default.svg></li><li ui-sref=appMailStared ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/trash_default.svg></li><li ui-sref=appMailSetting ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/setting_default.svg></li></ul></div></div><div class="right-side pos-relative"><!-- <div class="today-btn ft_12_regular_black flex-center cursor-point" ng-click="clickedTodayBtn()" translate="Today"></div> --><div id=calendar></div></div></div></div></main><!--\n<div class="content-wrapper">\n    <div class="sub-navigation">\n      <a href="#" ng-click="goDashboard()" class="ft_14_regular_gray" translate="Dashboard"></a>\n      <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n      <a ui-sref="calendar" class="ft_14_600_gray" translate="Calendar"></a>\n    </div>\n    <div class="calendar-type d-flex">\n      <button class="ft_12_regular_black personal active" translate="Personal"></button>\n      <button class="ft_12_regular_black company" ui-sref="companyCalendar" translate="Company"></button>\n    </div>\n    <div class="content">\n      <div class="d-flex personal-view">\n        <div class="left-side">\n          <div class="left-side-header flex-between">\n            <searchbox\n              search-text="vm.searchText" search-event="searchCallback()" is-small="true"\n              class="search"></searchbox>\n            <button class="btn_primary add-btn" ng-click="addEvent()" ng-if="CALENDAR_ACCESS_CREATE > 2">\n              <img src="/assets/icons/bx-plus.svg" alt="icons"/>\n            </button>\n          </div>\n          <div class="left-side-content">\n            <div date-picker date="dt" class="well well-sm calendar-datepicker" change="select()"></div>\n            <div class="event-block">\n              <div class="ft_10_regular_light title text-uppercase" translate="My Calendar"></div>\n              <div class="event-types">\n                <div class="d-flex align-items-center event-type">\n                  <div class="color-mark calendar flex-center">\n                    <div class="point"></div>\n                  </div>\n                  <div class="ft_12_regular_black" translate="Calendar Events"></div>\n                </div>\n                <div class="d-flex align-items-center event-type">\n                  <div class="color-mark birthday flex-center">\n                    <div class="point"></div>\n                  </div>\n                  <div class="ft_12_regular_black" translate="Birthday Events"></div>\n                </div>\n                <div class="d-flex align-items-center event-type">\n                  <div class="color-mark holiday flex-center">\n                    <div class="point"></div>\n                  </div>\n                  <div class="ft_12_regular_black" translate="Holiday Events"></div>\n                </div>\n                <div class="d-flex align-items-center event-type">\n                  <div class="color-mark site flex-center">\n                    <div class="point"></div>\n                  </div>\n                  <div class="ft_12_regular_black" translate="Site inspections"></div>\n                </div>\n                <div class="d-flex align-items-center event-type">\n                  <div class="color-mark meeting flex-center">\n                    <div class="point"></div>\n                  </div>\n                  <div class="ft_12_regular_black" translate="Meeting"></div>\n                </div>\n                <div class="d-flex align-items-center event-type">\n                  <div class="color-mark other flex-center">\n                    <div class="point"></div>\n                  </div>\n                  <div class="ft_12_regular_black" translate="Other Events"></div>\n                </div>\n              </div>\n            </div>\n            <div class="event-block upcoming-event">\n              <div class="ft_10_regular_light title text-uppercase" translate="Upcoming Events"></div>\n              <div class="info-wrapper">\n                <div class="title ft_14_600_black">\n                  Company Standup Meeting\n                </div>\n                <div class="info ft_12_regular_light text-left">\n                  8:00am - 9:00am, Engineering Room\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="right-side pos-relative">\n          <div class="today-btn ft_12_regular_black flex-center cursor-point" ng-click="clickedTodayBtn()" translate="Today"></div>\n          <div id="calendar"></div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n-->');
$templateCache.put('app/main/checkList/checkList.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=checkList class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Check List"></a></div><div class=ft_24_600_black1 translate="Check List"></div></div><searchbox class=ml-auto search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><button class="btn_new_blue ml-16" ng-click=openAddChecklistModal() ng-if="CHKLIST_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Add Check List"></span></button></div><div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0 && isLoading==false"><div class="card-based-content-grid-wrapper pr-24 pv-24"><div class="quotes-wrapper flex flex-wrap"><div class=profile-card-container ng-repeat="client in allCheckList"><div class=profile-card><div class=card-content><div class="flex header"><div class=name-wrapper ng-click=openEditChecklistModal(client)><div class="name tx-ellipsis ft_16_600_black" ng-bind=client.title></div></div></div><div class=detail><div class="flex-items-center detail-item"><span class="ft_14_regular_gray tx-ellipsis"></span>{{ client.systemTag }}</div></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + allCheckList.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.allChecklistData()></pagination-custom-new></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/fileManage/fileManage.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=fileManage class=main-container ng-if=!isLoading><div class=content-wrapper><spinner ng-show=loading></spinner><div class="fm-content d-flex" ng-if=vm.selectedProject><div class=project-list><div class=file-manager><img src=/assets/icons/folder_default.svg alt=icons><div class=file-manager-title translate="File Manager"></div></div><div class=project-body><div class="dropdown mb-16"><button ng-show=!vm.selectedProject.projectName class="dropdown-toggle place-holder ft_12_regular_gray" type=button data-toggle=dropdown>Select Project</button> <button ng-show=vm.selectedProject.projectName tooltip-enable={{vm.selectedProject.showTooltip}} tooltip-placement=bottom-left uib-tooltip={{vm.selectedProject.projectName}} tooltip-class=customClass class="dropdown-toggle sel-project ft_12_regular_black" type=button id=menu1 data-toggle=dropdown><img src=/assets/icons/fm_project_icon_new.svg alt=""> <span class=project-list-name>{{vm.selectedProject.projectName}}</span></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li><a href=# tooltip-enable={{item.showTooltip}} tooltip-placement=bottom-left uib-tooltip={{item.projectName}} tooltip-class=customClass class="menu-item ft_12_regular_gray" id={{item._id}} data-ng-click=selectedProject(item) ng-repeat="item in vm.projectList">{{item.projectName}}</a></li><li><a href=# class=menu-item ng-if=!vm.projectList.length>No Data</a></li></ul></div><!-- <div class="ft_14_600_white text-left mb-10">\n              <searchbox input-class="fm-searchbox" search-event="searchCallback()" search-text="vm.searchFolderText" place-holder="Search"></searchbox>\n            </div> --><div class=fm-nav ui-tree data-drag-enabled=false ng-if="vm.rootFolders && vm.rootFolders.length"><ul ui-tree-nodes="" ng-model=vm.rootFolders><li ng-repeat="item in vm.rootFolders" ui-tree-node ng-include="\'app/core/components/folder-picker-modal/fm-tree-item.html\'"></li></ul></div></div></div><div class=content><no-data ng-if="totalCount==0"></no-data><div ui-view=fileManagecontent selectedprojectfrom=vm.selectedProject class=fm-ui-view ng-if="totalCount!=0"></div></div></div></div></div></main>');
$templateCache.put('app/main/mail/mail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main id=email-container><div id=email><div class="content-wrapper-mail d-flex"><side-navbar page=mail></side-navbar><div class=side-menu ng-if=!isCollapse><div class="flex-between mb-2"><span class=mail-box-title translate=Mailbox></span> <button class="btn-trans cursor-point" ng-click=collapseMenu()><img src=/assets/icons/btn-hamberg-white.svg></button></div><button class="button-compose cursor-point" ng-click=onCompose()><!-- <i class="fa fa-plus mr-16"></i> --> <img class=mr-4 src=/assets/icons/bx-plus2.svg> Compose</button> <span class=side-section translate=MAILBOXES></span><ul class=mail-nav><li ui-sref=appMailInbox ng-click=goToFolders(null) ui-sref-active=active class="cursor-point mail-box-li"><!-- <i class="fa fa-inbox mr-4"></i> --> <img class=mr-4 src=/assets/icons/inbox_default.svg style="opacity: 0.5;"> <span class=name>Inbox</span> <span class=mail-count ng-if="unseenCount > 0">{{unseenCount}}</span></li><li ui-sref=appMailSent ng-click=goToFolders(null) ui-sref-active=active class="cursor-point mail-box-li"><!-- <i class="fa fa-paper-plane mr-4"></i> --> <img class=mr-4 src=/assets/icons/sent_default.svg> <span class=name>Sent</span></li><li ui-sref=appMailDraft ng-click=goToFolders(null) ui-sref-active=active class="cursor-point mail-box-li"><!-- <i class="fa fa-envelope-open mr-4"></i> --> <img class=mr-4 src=/assets/icons/draft_default.svg> <span class=name>Drafts</span> <span class=mail-count ng-if="draftsCount > 0">{{draftsCount}}</span></li><li ui-sref=appMailStared ng-click=goToFolders(null) ng-click=goToFolders(null) ui-sref-active=active class="cursor-point mail-box-li"><!-- <i class="fa fa-exclamation-circle mr-4"></i> --> <img class=mr-4 src=/assets/icons/spam_default.svg> <span class=name>Spam</span></li><li ui-sref=appMailTrash ng-click=goToFolders(null) ui-sref-active=active class="cursor-point mail-box-li"><!-- <i class="fa fa-trash-alt mr-4"></i> --> <img class=mr-4 src=/assets/icons/trash_default.svg> <span class=name>Trash</span></li><li ui-sref=appMailSetting ng-click=goToFolders(null) ui-sref-active=active class="cursor-point mail-box-li"><!-- <i class="fa fa-cog mr-4"></i> --> <img class=mr-4 src=/assets/icons/setting_default.svg> <span class=name>Settings</span></li><li class="cursor-point mail-box-li flex-space-between" ui-sref-active=active><span class=side-section translate="CUSTOM FOLDERS"></span> <span class=mail-count><img src=/assets/icons/bx-plus2.svg ng-click=addCustomFolder()></span></li><li ng-click=goToFolders(folder) ui-sref-active=active class="cursor-point mail-box-li {{folder._id == customFoldersid ? \'active\' : \'\'}}" ng-repeat="(index, folder) in vm.customFolders"><!-- <i class="fa fa-cog mr-4"></i> --> <img class=mr-4 src=/assets/icons/folder.svg> <span class=name>{{folder.customFolderName}}</span><div><span class=mail-count><img src=/assets/icons/edit1.svg ng-click=editFolder(index)></span><span class=mail-count><img src=/assets/icons/trash_g.svg ng-click=deleteFolder(index)></span></div></li></ul><!-- <div>\n          <searchbox input-class="mail-searchbox" search-event="searchCallback()" search-text="vm.searchFolderText" place-holder="Search"></searchbox>\n        </div> --> <span class="side-section technical-section" translate="TECHNICAL QUERIES"></span><ul class="mail-nav pb-4"><li class="cursor-point h-auto d-block" ng-repeat="($index, item) in vm.rootFolders"><div class=flex-between ng-click=onExpand($index)><span class=dot ng-style="{\'background-color\': item.color}">&nbsp;</span> <span class=name>{{item._id}}. {{item.name}}</span> <span><img class=down src=/assets/icons/chevron-down-gray.svg></span></div><ul class=child-ul ng-style="{\'display\': expandedIndex === $index? \'block\': \'none\'}"><li class="cursor-point pr-0 pl-24 tech-menu" ng-repeat="(key, file) in item.children"><div class="flex-between child-between w-100" ng-click="onSelectItem($index, key)"><span class=dot ng-style="{\'background-color\': item.color}">&nbsp;</span> <span class=name>{{item._id}}.{{file.title}}</span> <span><img src=/assets/icons/bx-download-4.svg ng-click=downloadTqfile(file._id)></span></div></li></ul><!-- <ul class="child-ul" ng-style="{\'display\': expandedIndex === $index? \'block\': \'none\'}">\n              <li class="cursor-point pr-0 pl-24 tech-menu" ng-repeat="(key, file) in selectedfolder">\n                <div class="flex-between child-between w-100" ng-click="onSelectItem($index, key)">\n                  <span class="dot" ng-style="{\'background-color\': selectedfolder.color}">&nbsp;</span>\n                  <span class="name">{{selectedfolder._id}}.{{file._id}} {{file.title}}</span>\n                  <span><img src="/assets/icons/bx-download-4.svg"/></span>\n                </div>\n              </li>\n            </ul> --></li></ul></div><div class=side-menu-collapse ng-if=isCollapse><div class="flex-between mb-2"><button class="btn-trans cursor-point" ng-click=collapseMenu()><img src=/assets/icons/btn-hamberg-white.svg></button></div><button class="button-compose cursor-point" ng-click=onCompose()><img src=/assets/icons/bx-plus2.svg></button><div class=mail-nav-bar><ul class=mail-nav><li ui-sref=appMailInbox ui-sref-active=active class="cursor-point mail-box-li"><!-- <i class="fa fa-inbox mr-4"></i> --> <img src=/assets/icons/inbox_default.svg style="opacity: 0.5;"></li><li ui-sref=appMailSent ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/sent_default.svg></li><li ui-sref=appMailDraft ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/draft_default.svg></li><li ui-sref=appMailImportant ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/spam_default.svg></li><li ui-sref=appMailStared ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/trash_default.svg></li><li ui-sref=appMailSetting ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/setting_default.svg></li></ul></div></div><div class=mail-content-wrapper ng-class="{\'menu-collapse\': isCollapse}"><div class=mail-content style="width: 100%;" ui-view=mailcontent></div></div></div></div></main>');
$templateCache.put('app/main/notifications/notifications.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div id=notifications class=main-container><div class=content-wrapper><div class=sub-navigation><a ng-click=showDashboard() class=ft_14_regular_gray translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class=ft_14_600_black translate=Notifications></a></div><div class=content><div class=header-title><div class=ft_24_600_black1 translate=Notifications></div></div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0 && isLoading==false"><div class="mb-40 mt-10"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell colspan=2><label class=check_yellow_20><div class="ft_14_600_black ml-8 float-left" translate="Select All"></div><input type=checkbox ng-model=select_all ng-click=selectAll()> <span class="checkmark mt-0"></span></label></th><th colspan=2><button class="btn_primary ml-auto" ng-click=markAsRead()><span translate="Mark as read"></span></button></th></tr></thead><tbody><tr ng-class="[notification.read ? \'item2\':\'item1\', !vm.utils.isEmpty(notification.route)? \'cursor-point\': \'\']" ng-repeat="(key, notification) in vm.notifications"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=notification.checked> <span class=checkmark></span></label></td><td class="name-wrapper list" ng-click=goToDetail(notification)><div class="ft_16_600_black tx-ellipsis name" ng-bind=notification.title></div><div ng-bind=notification.description class="description tx-ellipsis" title={{notification.description}}></div></td><td class="text-center avatar-cell" ng-click=goToDetail(notification)><img ng-src="{{ notification.userId.profilePic?notification.userId.profilePic:\'/assets/images/suppliers/upload.svg\' }}" alt=icons class="avatar-60 object-fit-cover" title={{notification.userId.displayName}}></td><td class="tx-ellipsis update-time" ng-click=goToDetail(notification) ng-bind=notification.createdTime></td></tr></tbody></table></div><div class="split flex-between"><div><span class="ft_14_600_gray mr-15">Showing {{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.notifications.length}}</span> of {{totalCount}} - <span translate=Notifications></span></span></div><hr class=split-line><div class=flex-center><pagination num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchNotificationData()></pagination></div></div></div></div></div></div></main>');
$templateCache.put('app/main/settings/settings.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=settings ng-if=!isLoading><spinner ng-if=loading></spinner><div class=content-wrapper><!-- <div class="sub-navigation">\n        <a href="#" ng-click="goDashboard()" class="ft_14_regular_gray" translate="Dashboard"></a>\n        <img src="/assets/icons/chevron-right 1.svg" alt="icons" />\n        <a class="ft_14_regular_gray" ui-sref="settings" translate="Settings"></a>\n        <img src="/assets/icons/chevron-right 1.svg" alt="icons" />\n        <a class="ft_14_600_gray" translate="{{navName[navNum]}} Settings"></a>\n      </div>\n      <div class="title-bar float-left ft_24_600_black" translate="{{navName[navNum]}}"></div> --><div class="d-flex w-100 h-100"><div class=side-menu><div class="settings-white ml-24 mb-16 text-uppercase" translate=Settings></div><ul><li ng-repeat="(key, item) in navName" ng-click=selPage(key) ng-class="navNum==key ? \'active\' : \'\'"><span class=icon><img ng-src=/assets/icons/setting-icon{{key+1}}.svg> </span><span class=name translate={{item}}></span></li></ul></div><div class=setting-content><div class=setting-main ui-view=settingscontent ng-if="totalCount!=0"></div></div></div></div></div></main>');
$templateCache.put('app/main/timeline/timeline.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><spinner ng-if=updating></spinner><div id=timeline class=main-container><div class="pt-5 mt-5 d-flex justify-content-center align-items-center" ng-if="vm.isAllProject && projects.length == 0">No Projects</div><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# class="ft-normal-12-16 blue-2" translate="Visual & Time"></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Timeline></a></div><div class=ft_24_600_black1 translate=Timeline></div></div><div class="ml-auto flex-between" ng-if=!vm.isAllProject><button class="btn_new_blue add-task mr-8" ng-click=vm.addTask() ng-if="TIMELINE_ACCESS_CREATE > 2"><!-- <img src="/assets/icons/bx-plus-circle.svg" alt="icons" class="mr-6"/> --> +&nbsp;<span translate="Add Task"></span></button> <button class="btn_new_blue add-task mr-8" ng-click="vm.showOverlay = !vm.showOverlay" ng-if="TIMELINE_ACCESS_CREATE > 2"><span translate="Toggle Progress Line"></span></button><!-- <button class="btn_new_blue resources mr-8" ng-click="vm.toggleResources()" ng-class="{toggled: vm.showResources}" ng-if="isExpanded(\'gantt\')"> --> <button class="btn_new_blue gray-light resources mr-8" ng-click=vm.toggleResources() ng-class="{toggled: vm.showResources}"><img src=/assets/icons/main-img-black.svg alt=icons class=mr-6> <span translate=Resources></span></button><!-- <button class="btn_new_blue edit-task mr-8" ng-if="vm.selectedTask && TIMELINE_ACCESS_CREATE > 1" ng-click="vm.editTask()"> --> <button class="btn_new_blue gray-light edit-task mr-8" ng-click=vm.editTask()><img src=/assets/icons/bxs-edit-black.svg alt=icons class=mr-6> <span translate="Edit Task"></span></button><!-- <button class="btn_new_blue split-task mr-8"\n          ng-if="vm.selectedTask && vm.selectedTask.composeState!==\'combined\' && TIMELINE_ACCESS_CREATE > 1 && !ganttType" ng-click="vm.splitTask()"> --> <button class="btn_new_blue gray-light split-task mr-8" ng-click=vm.splitTask()><img src=/assets/icons/split-black.svg alt=icons class=mr-6> <span translate="Split Task"></span></button><!-- <div class="cb-label flex-center ft_14_600_black mr-8"\n          ng-if="(vm.selectedGroup || (vm.selectedTask && vm.selectedTask.composeState!==\'combined\')) && TIMELINE_ACCESS_CREATE > 1 && !ganttType"\n          ng-click="vm.combineTask()"> --> <button class="btn_new_blue gray-light cb-label flex-center ft_14_600_black mr-8" ng-click=vm.combineTask()>&nbsp;&nbsp;<span translate=CB></span></button> <button class="btn_new_blue gray-light cb-label flex-center ft_14_600_black mr-8" ng-if="vm.selectedTask.composeState===\'combined\' && !ganttType" ng-click=vm.editCombinedTask()><span translate="Edit CB"></span></button></div><div class=d-flex><div class="has-search d-flex mr-8"><input type=text class=search-box placeholder=Search ng-model=searchText><div class="search-type dropdown d-flex"><div class="cursor-point my-auto" data-toggle=dropdown><img src=/assets/icons/chevron-down-gray.svg alt=icon></div><ul class="dropdown-menu search-menu"><li><a href=# class=menu-item data-ng-click="selectSearchType(\'name\')"><span translate=Name></span><i class="ml-10 fas fa-check" ng-if="searchType===\'name\'"></i> </a><a href=# class=menu-item data-ng-click="selectSearchType(\'type\')"><span translate=Type></span><i class="ml-10 fas fa-check" ng-if="searchType===\'type\'"></i> </a><a href=# class=menu-item data-ng-click="selectSearchType(\'worker\')"><span translate=Worker></span><i class="ml-10 fas fa-check" ng-if="searchType===\'worker\'"></i></a></li></ul></div></div><div class="sheet-type dropdown mr-8" ng-if=isMainCalc><div class="has-calendar flex-between cursor-point" data-toggle=dropdown><div class=d-flex><div class="flex-center calendar-label">{{ sheetType }}</div></div><div class="down_icon flex-center"><img src=/assets/icons/chevron-down-gray.svg alt=icon></div></div><ul class=dropdown-menu><li><a href=# class=menu-item data-ng-click="selectSheetType(\'prepare\')" translate=Prepare></a> <a href=# class=menu-item data-ng-click="selectSheetType(\'design\')" translate=Design></a> <a href=# class=menu-item data-ng-click="selectSheetType(\'estimate\')" translate=Estimate></a> <a href=# class=menu-item data-ng-click="selectSheetType(\'handover\')" translate=Handover></a></li></ul></div><div class="view-style dropdown mr-8"><div class="has-calendar flex-between cursor-point" data-toggle=dropdown><div class=d-flex><div class="flex-center calendar-label">{{ viewStyle }}</div></div><div class="down_icon flex-center"><img src=/assets/icons/chevron-down-gray.svg alt=icon></div></div><ul class=dropdown-menu><li><a href=# class=menu-item data-ng-click="selectViewStyle(\'year\')" translate=Year></a> <a href=# class=menu-item data-ng-click="selectViewStyle(\'month\')" translate=Month></a> <a href=# class=menu-item data-ng-click="selectViewStyle(\'week\')" translate=Week></a> <a href=# class=menu-item data-ng-click="selectViewStyle(\'day\')" translate=Day></a></li></ul></div><div class="zoom flex-between mr-8"><img src=/assets/icons/search-minus.svg alt=icon class="bell_icon cursor-point" ng-click=vm.zoomMinus()><div class="middle d-flex"><img src=/assets/icons/search-plus.svg alt=icon class="bell_icon cursor-point m-auto" ng-click=vm.zoomPlus()></div><div class="gantt-type d-flex dropdown"><div class="cursor-point my-auto" data-toggle=dropdown><img src=/assets/icons/eye.svg alt=icon class="bell_icon cursor-point"></div><ul class="dropdown-menu gantt-menu"><li><a href=# class=menu-item data-ng-click=selectGanttType()><span translate=Task></span><i class="ml-10 fas fa-check" ng-if="ganttType==undefined"></i> </a><a href=# class=menu-item data-ng-click="selectGanttType(\'workLevel\')"><span translate=Level></span><i class="ml-10 fas fa-check" ng-if="ganttType===\'workLevel\'"></i> </a><a href=# class=menu-item data-ng-click="selectGanttType(\'workType\')"><span translate=Type></span><i class="ml-10 fas fa-check" ng-if="ganttType===\'workType\'"></i></a></li></ul></div></div><div class=d-flex><button class="btn_new_blue btn-settime mr-8" ng-click=vm.hrsW() ng-if="TIMELINE_ACCESS_CREATE > 1"><img src=/assets/icons/bx-timer.svg alt=icons class=mr-6> <span translate="Set Time"></span></button> <button class="btn_new_blue btn-switch mr-8" ng-click=vm.reloadTimeline()><img src=/assets/icons/bx-switch.svg alt=icons class=mr-6> <span translate=Switch></span></button><div class=dropdown><button class="btn_new_blue btn-publish" data-toggle=dropdown ng-if="TIMELINE_ACCESS_CREATE > 1"><img src=/assets/icons/bx-publish.svg alt=icons class=mr-6> Publish</button><ul class=dropdown-menu><li><a href=# class=menu-item data-ng-click=vm.saveTimeline() translate=Save></a> <a href=# class=menu-item data-ng-click=vm.exportPdf() translate="Export as PDF"></a> <a href=# class=menu-item data-ng-click=vm.exportMpp() translate="Export as MS Project"></a></li></ul></div><!-- <div class="combine-auto ft_14_600_black ml-10"\n            ng-if="!vm.isAllProject && !ganttType" ng-click="vm.combineAuto()">\n            <span translate="Auto CB"></span>\n          </div> --></div></div></div><div ng-if="(vm.isAllProject && projects.length > 0) || !vm.isAllProject"><div class="mb-24 mt-24 ml-24 mr-24 gantt-wrapper" ng-if="isShowArea(\'gantt\')" ng-class="expandedClass(\'gantt\')"><div class=title-black><div>{{ vm.project.projectName }}</div><div class=d-flex ng-if=!vm.isAllProject><img src=/assets/icons/expand.svg alt=icons ng-click="expandArea(\'gantt\')" ng-if="expandedArea == undefined"> <img src=/assets/icons/close-white.svg alt=icons class=close-icon ng-click=expandArea() ng-if="expandedArea == \'gantt\'"></div></div><div extra-gantt ng-if=vm.isMainEstimate id=gantt data=vm.timelineExtra on-task-changed=vm.taskChanged on-task-selected=vm.taskSelected on-task-updated=vm.taskUpdated() on-worker-count=vm.getWorkerCount on-edit-task=vm.editTask on-total-count=vm.getTotalCount on-add-worker=vm.addWorker on-remove-worker=vm.removeWorker on-worker-hours=vm.getWorkerHours></div><div main-gantt ng-if=!vm.isMainEstimate id=gantt data=vm.ganttData graph-data=vm.graphData show-overlay=vm.showOverlay groups=vm.groupData resources=vm.resourceData weather=weatherData scale=viewStyle zoom=zoomValue search=searchText search-type=searchType group-type=ganttType resource-mode=vm.showResources deadline=vm.deadline styles=vm.styles current-resources=vm.currentResources on-task-changed=vm.taskChanged on-task-selected=vm.taskSelected on-task-updated=vm.taskUpdated() on-worker-count=vm.getWorkerCount on-edit-task=vm.editTask on-total-count=vm.getTotalCount on-add-worker=vm.addWorker on-remove-worker=vm.removeWorker on-worker-hours=vm.getWorkerHours></div><!-- <div project-timeline id="gantt"></div> --></div></div><div class="d-flex mb-24 mt-24 ml-24 mr-24" ng-if=!vm.isMainEstimate><div class=model-wrapper ng-if="isShowArea(\'model\')" ng-class="expandedClass(\'model\')"><div class=title-black><div translate="3D Model"></div><div class=d-flex><img src=/assets/icons/expand.svg alt=icons ng-click="expandArea(\'model\')" ng-if="expandedArea == undefined"> <img src=/assets/icons/close-white.svg alt=icons class=close-icon ng-click=expandArea() ng-if="expandedArea == \'model\'"></div></div><div class=model><model-viewer ng-class="{\'render-3d\': vm.modelViewer.modelType===\'3d\'}" data=vm.modelViewer refresh=vm.refreshModelViewer></model-viewer></div></div><div class=flow-chart-wrapper ng-show="isShowArea(\'flow\')" ng-class="expandedClass(\'flow\')"><div class=title-black><div translate=Flowline></div><div id=flowline-combobox></div><img src=/assets/icons/expand.svg alt=icons ng-click="expandArea(\'flow\')" ng-if="expandedArea == undefined"> <img src=/assets/icons/close-white.svg alt=icons class=close-icon ng-click=expandArea() ng-if="expandedArea == \'flow\'"></div><div id=flow-chart class=flow-chart><flowline gantt-type=ganttType selected-task=ganttTask styles=vm.styles refresh=refreshFlowline show-type=showType holidays=vm.holidays expanded="expandedArea == \'flow\'"></flowline></div></div></div><div id=right-side-box class="right-side-box d-flex"><div class=side-box-toggles><div ng-repeat="item in sideBoxItems track by $index" class="side-box-item {{item.name}}" ng-click=vm.showToggleMenus($index)><img ng-src={{item.icon}} alt={{item.name}}></div></div><div class=side-box-content><!-- weathers --><weathers-box ng-show="toggleIndex === 0" on-close=vm.showToggleMenus(0)></weathers-box><!-- notification --><notifications-box ng-show="toggleIndex === 1" notifications=vm.notifications on-close=vm.showToggleMenus(1)></notifications-box><!-- workers --><workers-box ng-show="toggleIndex === 2" workers=vm.workers on-close=vm.showToggleMenus(2)></workers-box></div></div></div></main>');
$templateCache.put('app/core/components/alert-modal/alert-modal.view.html','<div id=alert-modal><div class=content><div class="flex-between mb-15"><div class=flex><img src=/assets/icons/status-warning.svg alt=icons width=30><div class="ft_18_600_black ml-20" translate={{vm.title}}></div></div><div class=cursor-point ng-click=onClose()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=ft_16_600_black translate={{vm.message}}></div></div><div class=btnGroup><button class=btn_white ng-click=onCancel() translate={{vm.negative}}></button> <button class=btn_primary ng-click=onSubmit() translate={{vm.positive}}></button></div></div>');
$templateCache.put('app/core/components/change-passsword-modal/change-password-modal.view.html','<div id=change-password-modal><div class=header><div class=tx-ellipsis translate="Change Password"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=mb-16><label translate="Current Password"></label><div class=pos-relative><input type=password ng-model=data.oldPassword ng-show=!showOldPassword> <input type=text ng-model=data.oldPassword ng-show=showOldPassword> <img class=show-password-icon ng-src="{{showOldPassword ? \'/assets/icons/eye-off-outline.svg\': \'/assets/icons/eye-outline.svg\'}}" alt="old password" ng-click="showOldPassword = !showOldPassword" ng-init="showOldPassword=false"></div></div><div class=mb-16><label translate="New Password"></label><div class=pos-relative><input type=password ng-model=data.newPassword ng-show=!showNewPassword> <input type=text ng-model=data.newPassword ng-show=showNewPassword> <img class=show-password-icon ng-src="{{showNewPassword ? \'/assets/icons/eye-off-outline.svg\': \'/assets/icons/eye-outline.svg\'}}" alt="old password" ng-click="showNewPassword = !showNewPassword" ng-init="showNewPassword=false"></div></div></div><div class=footer><button class="btn_primary mr-3" ng-click=onSubmit() translate=Save></button> <button class=btn_white ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/core/components/confirm-modal/confirm-modal.view.html','<div id=confirm-modal><div class=content><div class="flex-between mb-15"><div class=flex><img ng-src={{vm.icon}} alt=icons><div class="ft_18_600_black ml-20">{{vm.title}}</div></div><div class=cursor-point ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=ft_16_600_black>{{vm.message}}</div><br><div class=ft_16_600_black>{{vm.subMessage}}</div></div><div class=btnGroup><button class=btn_white ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSubmit()>{{vm.confirmButtonText}}</button></div></div>');
$templateCache.put('app/core/components/edit-profile-modal/edit-profile-modal.view.html','<div id=edit-profile-modal><div class=header><div class=tx-ellipsis translate="Edit Profile"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=avatar-container><img class=avatar ng-src="{{PROFILE_IMAGE || vm.userData.profilePic || \'/assets/icons/bx-user.svg\'}}" alt=""><div><div class="flex-items-center mb-8"><button class=btn-black ngf-select="" ngf-change=onChangeAvatar($files) ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-accept="\'.jpg,.jpeg,.png\'" aria-invalid=false data-wow-delay=0.7s translate="Upload New Photo"></button> <button class=btn-light ng-click=removeProfilePic() translate=Remove></button></div><div class=upload-description>You can upload .jpeg, .gif or .png files.</div><div class=upload-description>Max size of 3mb.</div></div></div><div class=main-input-container><div class=left><div class=mb-16><label for=first-name translate="First Name"></label> <input type=text id=first-name placeholder="First Name" ng-model=vm.userData.firstName></div><div class=mb-16><label for=gender translate=Gender></label><selectbox id=gender options=genderList label-field=label value-field=value ng-model=vm.userData.gender></selectbox></div></div><div class=right><div class=mb-16><label for=last-name translate="Last Name"></label> <input type=text id=last-name placeholder="Last Name" ng-model=vm.userData.lastName></div><div class="has-calendar mb-16"><label for=birthday translate="Date of Birth"></label> <input id=birthday type=text class=calendar-box date-picker=yyyy/MM/dd date=vm.userData.dateOfBirth is-open=isDatepickerOpen ng-required=true> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon ng-click="isDatepickerOpen = !isDatepickerOpen"></div></div></div><div class=mb-16><label for=email-id translate="Email ID"></label> <input id=email-id type=email placeholder=someone@example.com ng-model=vm.userData.email ng-pattern=EMAIL_REGEX required></div><div class=mb-16><label translate="Phone No."></label><div class=d-flex><selectbox-input ng-model=vm.userData.mobile.dialCode options=vm.countryCodes label-field=dialCode value-field=dialCode></selectbox-input><input type=text class=phone-number ng-model=vm.userData.mobile.phoneNumber></div></div><button class="btn-black mb-16" ng-click=changePassword() translate="Change Password"></button></div><div class=footer><button class="btn_primary mr-3" ng-click=onSubmit() translate=Save></button> <button class=btn_white ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/core/components/edit-staff-modal/edit-staff-modal.view.html','<div id=edit-staff-modal><div class=header><div class=tx-ellipsis translate="Edit Staff"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=main-input-container><div class=left><div class=mb-16><label for=first-name class=required translate="First Name"></label> <input type=text id=first-name placeholder="First Name" ng-model=vm.staff.firstName></div><div class=mb-16><label for=email-id class=required>Email ID</label> <input id=email-id type=email placeholder=someone@example.com ng-model=vm.staff.email ng-pattern=EMAIL_REGEX required></div></div><div class=right><div class=mb-16><label for=last-name class=required translate="Last Name"></label> <input type=text id=last-name placeholder="Last Name" ng-model=vm.staff.lastName></div><div class=mb-16><label class=required translate="Phone No."></label><div class=d-flex><selectbox-input ng-model=vm.staff.mobile.dialCode options=vm.countryCodes label-field=dialCode value-field=dialCode></selectbox-input><input type=text class=phone-number ng-model=vm.staff.mobile.phoneNumber></div></div></div></div></div><div class=footer><button class="btn_primary mr-3" ng-click=onSubmit() translate=Ok></button> <button class=btn_white ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/core/components/create-work-order-modal/create-work-order-modal.view.html','<div id=create-work-order-modal><div class=header><div class=tx-ellipsis translate="Create Work Order"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div ng-if="curStep==0" class="bar1 bar-uncompleted"></div><div ng-if="curStep==0" class="bar2 bar-uncompleted"></div><div ng-if="curStep==1" class="bar1 bar-completed"></div><div ng-if="curStep==1" class="bar2 bar-uncompleted"></div><div ng-if="curStep==2" class="bar1 bar-completed"></div><div ng-if="curStep==2" class="bar2 bar-completed"></div><div class="avatar-container flex-around mb-16"><div class="flex-center flex-col w-100"><div ng-if="curStep==0" class=selected><img class=wallet src=/assets/icons/wallet-white.png alt=""></div><div ng-if="curStep==1" class=completed><img class=wallet src=/assets/icons/wallet-white.png alt=""></div><div ng-if="curStep==2" class=completed><img class=wallet src=/assets/icons/wallet-white.png alt=""></div><div class=mt-10>Client</div></div><div class="flex-center flex-col w-100"><div ng-if="curStep==0" class=uncompleted><img class=walletGray src=/assets/icons/wallet-gray.png alt=""></div><div ng-if="curStep==1" class=selected><img class=wallet src=/assets/icons/wallet-white.png alt=""></div><div ng-if="curStep==2" class=completed><img class=wallet src=/assets/icons/wallet-white.png alt=""></div><div class=mt-10>Project</div></div><div class="flex-center flex-col w-100"><div ng-if="curStep==0" class=uncompleted><img class=walletGray src=/assets/icons/wallet-gray.png alt=""></div><div ng-if="curStep==1" class=uncompleted><img class=walletGray src=/assets/icons/wallet-gray.png alt=""></div><div ng-if="curStep==2" class=selected><img class=wallet src=/assets/icons/wallet-white.png alt=""></div><div class=mt-10>Work Order</div></div></div><div class=form-content ng-if="curStep==0"><div class=mb-16><label for=client translate=Client></label><selectbox id=client options=vm.clientList label-field=name value-field=_id ng-model=vm.projectData.client></selectbox></div><div class=flex-between><div class=mb-16><label translate="Area Code"></label><div class=d-flex><selectbox-input ng-model=vm.userData.mobile.dialCode options=vm.countryCodes label-field=dialCode value-field=dialCode></selectbox-input></div></div><div class="mb-16 w-75"><label translate="Phone No."></label><div class=d-flex><input type=text class=phone-number ng-model=vm.userData.mobile.phoneNumber></div></div></div><div class=mb-16><label for=email2 translate=Email></label> <input id=email2 type=text placeholder=someone@example.com ng-model=vm.userData.email ng-pattern=EMAIL_REGEX required></div><div class=mb-16><label for=wordaddr1 translate="Work Address Line 1"></label> <input id=wordaddr1 type=text placeholder="9678 Elgin Street" ng-model=vm.userData.email></div><div class=mb-16><label for=wordaddr2 translate="Work Address Line 2"></label> <input id=wordaddr2 type=text placeholder="Celina Corner, Near Cafe Newlands" ng-model=vm.userData.email></div><div class=main-input-container><div class=left><div class=mb-16><label for=city translate=City></label> <input type=text id=city placeholder=City ng-model=vm.userData.firstName></div><div class=mb-16><label for=country translate=Country></label> <input type=text id=country placeholder=Country ng-model=vm.userData.firstName></div></div><div class=right><div class=mb-16><label for=state translate=State/Province></label> <input type=text id=state placeholder=State/Province ng-model=vm.userData.lastName></div><div class=mb-16><label for=zipcode translate="Postal Zipcode"></label> <input type=text id=zipcode placeholder="Postal Zipcode" ng-model=vm.userData.lastName></div></div></div></div><div class=form-content ng-if="curStep==1"><div class=mb-16><label for=client translate="Service Project"></label><selectbox id=client class=create_work_dropdown options=vm.clientList label-field=name value-field=_id ng-model=vm.projectData.client></selectbox></div><div class="flex-center mb-16"><div>OR</div><button class="btn_create_newproject ml-16" ng-if="curStep!=2" ng-click=onNextStep() translate="Create New Project"></button></div><div class=mb-16><label for=description translate=Description></label> <textarea id=description placeholder=someone@example.com ng-model=vm.userData.email>\n        </textarea></div><div class=mb-16><label for=buildingType translate="Building Type"></label><selectbox class="w-100 input-select create_work_dropdown" ng-model=vm.projectData.buildingType options=vm.buildingTypeList label-field=tagName value-field=_id></selectbox></div><div class=mb-16><label for=buildingType translate="Project Status"></label><selectbox class="w-100 input-select create_work_dropdown" ng-model=vm.projectData.buildingType options=vm.buildingTypeList label-field=tagName value-field=_id></selectbox></div><div class=main-input-container><div class=left><div class=mb-16><label for=startDate translate="Start Date"></label><div class="input-group datePicker"><input type=text class=login_input_new date-picker=dd.MM.yyyy date=startDate is-open=isDatepickerOpenStartDate ng-required=true> <span class=dateArrow ng-click="isDatepickerOpenStartDate = !isDatepickerOpenStartDate"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div><div class=right><div class=mb-16><label for=endDate translate="End Date"></label><div class="input-group datePicker"><input type=text class=login_input_new date-picker=dd.MM.yyyy date=endDate is-open=isDatepickerOpenEndDate ng-required=true> <span class=dateArrow ng-click="isDatepickerOpenEndDate = !isDatepickerOpenEndDate"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div></div><div class=mb-16><label for=buildingType translate="Contact Person"></label><selectbox class="w-100 input-select create_work_dropdown" ng-model=vm.projectData.buildingType options=vm.buildingTypeList label-field=tagName value-field=_id></selectbox></div></div><div class=form-content ng-if="curStep==2"><div class=mb-16><label for=wordaddr1 translate="Work Order Title"></label> <input id=wordaddr1 type=text placeholder="9678 Elgin Street" ng-model=vm.userData.email></div><div class=mb-16><label for=description translate=Description></label> <textarea id=description placeholder=someone@example.com ng-model=vm.userData.email>\n        </textarea></div><div class=mb-16><label for=description translate="Upload File"></label><div class=upload ngf-select ng-model=vm.inputImg ngf-change="vm.fileUpdated($files, $event, \'image\')" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=true ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><p class=text-center><span translate="Drag & drop files here"></span></p><p class=text-center><span translate=or></span></p><button class="btn_create_newproject mt-10" translate="Browse on File Manager"></button></div></div><div class="panel-list2 ml-24"><div ng-if="vm.uploadImg.length > 0" data-ride=carousel data-interval=false><div class="carousel-inner1 row"><div class="carousel-item1 flex-column mb-56" ng-repeat="(key,f) in vm.uploadImg" ng-class={active:!$index}><img ngf-src="f.secure_url || f" alt="First slide" ng-click="vm.currentIndex=key" class=thumb><div class="f_name ml-16">{{ f.assetName || f.name }}</div><a ng-click="vm.deleteFile($index, \'image\');" class="text-danger image_close_btn ml-auto mt-50"><img src=/assets/icons/close-gray-circle.svg alt=icons></a></div></div></div></div></div><div class="flex-between step-button"><button class="btn-gray mb-16 mr-8 w-100" ng-if="curStep==0" ng-click=onCancel() translate=Cancel></button> <button class="btn-gray mb-16 mr-8 w-100" ng-if="curStep!=0" ng-click=onPrevStep() translate=Back></button> <button class="btn_new_blue mb-16 ml-8 w-100" ng-if="curStep!=2" ng-click=onNextStep() translate=Next></button> <button class="btn_new_blue mb-16 ml-8 w-100" ng-if="curStep==2" ng-click=onCreate() translate=Create></button></div></div></div>');
$templateCache.put('app/core/components/exportModal/exportModal.view.html','<div id=export-modal><div class=header><div class=tx-ellipsis translate="Input a file name to export"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><div class=mb-24><div class="ft_12_500_gray mb-2" translate="Export format"></div><selectbox class=dropdown-primary ng-model=vm.format options=vm.formats label-field=label value-field=value></selectbox></div><div><div class="ft_12_500_gray mb-2" translate="File name"></div><input class="input-primary w-100" type=text ng-model=vm.filename placeholder="File name"></div></div><div class=footer><button class="button-ex1 mr-3 ph-20" ng-click=onCancel() translate=Cancel></button> <button class="button-primary ph-20" ng-click=onSubmit() translate=OK></button></div></div>');
$templateCache.put('app/core/components/fileNameModal/fileNameModal.view.html','<div id=file-name-modal><div class=header><div class=tx-ellipsis translate="Input a file name to export"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><div class="ft_12_500_gray mb-2" translate="File name"></div><input type=text ng-model=vm.filename placeholder="File name" autofocus></div><div class=footer><button class="btn_white mr-3" ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/core/components/folder-picker-modal/fm-tree-item.html','<div class=flex-items-center ui-tree-handle ng-class="{active: item._id === vm.selectedFolder._id}" drag=drop-zone drag-id={{item._id}} drag-type={{item._id}}><img ng-if="item.children && item.children.length > 0" class=collapse-icon ng-src="{{this.collapsed ? \'/assets/icons/fm_chevron-down.svg\' : \'/assets/icons/fm_chevron-right.svg\'}}" ng-click=toggle(this) alt=""><div ng-if="!item.children || !item.children.length" class=blank-icon1></div><div class="flex-items-center cursor-point" ng-click=selectFolder(item)><img class=folder-icon ng-class="{active: item._id === vm.selectedFolder._id}" ng-src="{{item._id == vm.selectedFolder._id ? \'/assets/icons/fm_folder_icon_new.svg\' : \'/assets/icons/fm_folder_icon_new.svg\'}}"> <span ng-class="{active: item._id === vm.selectedFolder._id}">{{item.name}}</span></div></div><ol ui-tree-nodes="" ng-model=item.children ng-class="{\'angular-ui-tree-hidden\': !this.collapsed}"><li ng-repeat="item in item.children" ng-init="child=true" ui-tree-node ng-include="\'app/core/components/folder-picker-modal/folder-tree.html\'"></li></ol>');
$templateCache.put('app/core/components/folder-picker-modal/folder-picker-modal.view.html','<div id=folder-picker-modal><div class=header><div class=ft_18_600_black>{{vm.isMoveTo ? \'Move To\' : \'Save To\'}}</div><a href=# data-ng-click=cancel()><img src=/assets/icons/close-12-gray.svg alt=""></a></div><spinner ng-if=loading></spinner><div class=content><div class=content-header><div class="left flex-items-center pl-3"><img ng-if=!isAvailableBackward() class=arrow src=/assets/icons/fm_left_arrow.svg alt=""> <img ng-if=isAvailableBackward() class="arrow active" src=/assets/icons/fm_left_arrow_dark.svg alt="" ng-click=backward()> <img ng-if=!isAvailableForward() class=arrow src=/assets/icons/fm_right_arrow.svg alt=""> <img ng-if=isAvailableForward() class="arrow active" src=/assets/icons/fm_right_arrow_dark.svg alt="" ng-click=forward()><div class=cursor-point ng-click=addFolder()><img class=mr-1 src=/assets/icons/fm_folder_icon.svg alt=""> <span class=ft_12_regular_gray translate="New Folder"></span></div></div><div class="right pr-2"><div class=bread-crumb><img class=folder-icon src=/assets/icons/fm_folder_icon.svg alt=""><div class=bread-crumb-item ng-repeat="breadCrumb in vm.breadCrumbList track by $index"><div class=name>{{breadCrumb.name}}</div><img class=arrow-icon src=/assets/icons/fm-arrow-right-black.svg alt="" ng-if="$index < vm.breadCrumbList.length - 1"></div></div><searchbox input-class=fm-searchbox search-text=searchText search-event=searchCallback()></searchbox></div></div><div class=content-body><div class="left folders-nav" ui-tree data-drag-enabled=false><ul ui-tree-nodes="" ng-model=vm.rootFolders><li ng-repeat="item in vm.rootFolders" ui-tree-node ng-include="\'app/core/components/folder-picker-modal/folder-tree.html\'"></li></ul></div><div class="right folders-container"><div class=tab-bar><div class="tab-item name"><span translate=Name></span> <img src=/assets/icons/fm-arrow-down-deactivated.svg alt=""></div><div class="tab-item type"><span translate=Type></span> <img src=/assets/icons/fm-arrow-down-deactivated.svg alt=""></div><div class="tab-item size"><span translate=Size></span> <img src=/assets/icons/fm-arrow-down-deactivated.svg alt=""></div></div><div class=list-container><div class=list-content><div class="list-content-row cursor-point" ng-repeat="folder in vm.currentFilteredFolders"><div class="list-content-col name"><div class=cursor-point ng-click=selectFolder(folder)><img class=mr-2 src=/assets/icons/fm_folder_icon.svg alt=""> <span>{{folder.name}}</span></div></div><div class="list-content-col type">Folder</div><div class="list-content-col size"></div></div><div class=list-content-row ng-repeat="file in vm.currentFilteredFiles"><div class="list-content-col name"><img class="file-icon mr-2" ng-src={{utils.getFMFileIcon(file.format)}} alt=""> <span>{{file.originalname}}</span></div><div class="list-content-col type">{{file.format | uppercase}}</div><div class="list-content-col size">{{file.bytes | filesize}}</div></div></div></div></div></div></div><div class=footer><button class=btn-gray ng-click=cancel() translate=Cancel></button> <button class=btn-yellow ng-click=ok() translate=Ok></button></div></div>');
$templateCache.put('app/core/components/folder-picker-modal/folder-tree.html','<div class=flex-items-center ui-tree-handle ng-class="{active: item._id === vm.selectedFolder._id}" drag=drop-zone drag-id={{item._id}} drag-type={{item.parentType}}><img ng-if="item.children && item.children.length > 0" class=collapse-icon ng-src="{{this.collapsed ? \'/assets/icons/fm_chevron-down.svg\' : \'/assets/icons/fm_chevron-right.svg\'}}" ng-click=toggle(this) alt=""><div ng-if="!item.children || !item.children.length" class=blank-icon1></div><div class="flex-items-center cursor-point" ng-click=selectFolder(item)><img class=folder-icon src=/assets/icons/fm_folder_icon_new.svg> <span ng-class="{active: item._id === vm.selectedFolder._id}">{{item.name}}</span></div></div><ol ui-tree-nodes="" ng-model=item.children ng-class="{\'angular-ui-tree-hidden\': !this.collapsed}"><li ng-repeat="item in item.children" ng-init="child=true" ui-tree-node ng-include="\'app/core/components/folder-picker-modal/fm-tree-item.html\'"></li></ol>');
$templateCache.put('app/core/components/image-viewer-modal/image-viewer-modal.view.html','<div id=image-viewer-modal><div class=h-100><div class=pos-relative><img src=/assets/icons/close-20-dark.svg ng-click=onCancel() class=img-close> <img class=view-image ng-src="{{ vm.imageURL }}" alt=""></div></div></div>');
$templateCache.put('app/core/components/nav-bill-modal/nav-bill-modal.view.html','<div id=nav-bill-modal><div class=title><div class="tx-ellipsis mr-auto" translate=Bills></div><div class=btn ui-sref=approveBill ng-click=vm.close() translate=Open></div><div class=btn translate=Approve ng-click=vm.approve()></div><div class=close-icon ng-click=vm.close()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=divider></div><div class=content><spinner ng-if=isLoading></spinner><div class=bill-item ng-repeat="bill in vm.bills"><div class=w-100><div class="flex align-items-center"><checkbox class=mr-10 is-small=true ng-model=bill.checked></checkbox><div class=vendor>{{bill.vendorName}}</div><div class="ml-auto amount">{{vm.companyCurrency.symbol}} {{bill.totalAmount | readable: 2}}</div></div><div class=flex-between><div class="ml-26 no">{{bill.billNo}} \u2022 {{bill.billDate | smartDate}}</div><div class=status ng-class=bill.status>{{bill.status}}</div></div></div></div><no-data ng-if="vm.bills.length === 0"></no-data></div></div>');
$templateCache.put('app/core/components/nav-drawing-modal/nav-drawing-modal.view.html','<div id=nav-drawing-modal><div class=title><div class="tx-ellipsis mr-auto" translate="Drawing & Document Approvals"></div><div class=btn ui-sref=vpGrid ng-click=vm.close() translate=Open></div><div class=close-icon ng-click=vm.close()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=divider></div><div class=content><spinner ng-if=isLoading></spinner><div class=drawing-item ng-repeat="drawing in vm.drawings"><div class=item-content><div class=w-100><div class="flex align-items-center"><checkbox class=mr-10 is-small=true ng-model=drawing.checked></checkbox><div class=name>{{drawing.assetObj.title}}</div></div><div class="flex-between mt-8"><div class="ml-26 control-bar"><div class=approve ng-class="{active: drawing.status==\'approved\'}" ng-click=vm.approve(drawing) translate=Approve></div><div class=request ng-class="{active: drawing.status==\'requested\'}" ng-click=vm.request(drawing) translate="Request Change"></div><div class=reject ng-class="{active: drawing.status==\'rejected\'}" ng-click=vm.reject(drawing) translate=Reject></div></div><div><img ng-src="{{drawing.isShowChat ? \'/assets/icons/comment-f.svg\' : \'/assets/icons/comment-d.svg\'}}" class=cursor-point alt="" ng-click=vm.toggleChat(drawing)> <img ng-src="{{drawing.isShowHistory ? \'/assets/icons/history-f.svg\' : \'/assets/icons/history-d.svg\'}}" class=cursor-point alt="" ng-click=vm.toggleHistory(drawing)></div></div></div></div><div class=item-comment ng-if=drawing.isShowChat><live-chat-small unique-name={{drawing._id}} chat-type=vp></live-chat-small></div><div class=item-history ng-if=drawing.isShowHistory></div></div><no-data ng-if="vm.drawings.length === 0"></no-data></div></div>');
$templateCache.put('app/core/components/nav-invoice-modal/nav-invoice-modal.view.html','<div id=nav-invoice-modal><div class=title><div class="tx-ellipsis mr-auto" translate=Invoices></div><div class=btn ui-sref=invoiceList ng-click=vm.close() translate=Open></div><div class=btn translate=Approve></div><div class=close-icon ng-click=vm.close()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=divider></div><div class=content><spinner ng-if=isLoading></spinner><div class=bill-item ng-repeat="invoice in vm.invoices"><div class=w-100><div class="flex align-items-center"><checkbox class=mr-10 is-small=true ng-model=invoice.checked></checkbox><div class=vendor>{{invoice.vendorName}}</div><div class="ml-auto amount">{{invoice.companyCurrency.symbol}} {{invoice.totalAmount | readable: 2}}</div></div><div class=flex-between><div class="ml-26 no">{{invoice.displaySeq}} \u2022 {{invoice.date | smartDate}}</div><div class=status ng-class=invoice.status>{{invoice.status}}</div></div></div></div><no-data ng-if="vm.invoices.length === 0"></no-data></div></div>');
$templateCache.put('app/core/components/nav-synergy-modal/nav-synergy-modal.view.html','<div class=synergy-modal ng-class="{selected: vm.isSelected}"><div ng-if=!vm.isSelected><div class=title><div class="tx-ellipsis mr-auto" translate=Chats></div><i class="i-icon i-close bgc-grey sm" ng-click=vm.close()></i></div><div class=divider></div><div class=nav-items id=scrollMenu horizontal-scroll><nav class="navbar navbar-expand-lg navbar-light"><ul class=navbar-nav><li class=nav-item ng-class="{active: vm.sortType === sortType.id}" ng-click="vm.sort(sortType.id, index)" ng-repeat="(index, sortType) in vm.sortTypes"><span translate={{sortType.label}}></span></li></ul></nav></div><div class=divider></div><div class=content><spinner ng-if=isLoading></spinner><div class="synergy-item flex-between" ng-if="vm.sortType == \'recent\'"><div class="w-100 flex-start synergy-item-info" ng-click="vm.select(0, {})"><div class="synergy-avatar flex-center"><img ng-src=assets/images/employees/no-avatar.png alt=icon class=object-fit-cover></div><div class=synergy-profile><div class=name>Darrell Steward</div><div class=activity>lol your reactions were so cool.</div></div></div><div class=actions><div class=description>10 min ago</div><div class="synergy-actions flex-center mt-2"><i class="i-icon i-call bgc-grey m-2 c-pointer"></i> <i class="i-icon i-message bgc-grey m-2 c-pointer"></i> <i class="i-icon i-video-call bgc-grey m-2 c-pointer"></i></div></div></div><div ng-if="vm.sortType !== \'recent\' && !vm.isStaffed"><div class="synergy-item flex-between" ng-repeat="(index, userInfo) in vm.allMembers"><div class="w-100 flex-start synergy-item-info" ng-click="vm.select(index, userInfo)"><div class="synergy-avatar flex-center"><img ng-src="{{userInfo.profilePic || userInfo.clientLogo || \'assets/images/employees/no-avatar.png\'}}" alt=icon class=object-fit-cover></div><div class=synergy-profile><div class=name>{{userInfo.displayName || userInfo.clientName || userInfo.name}}</div><div class=activity>lol your reactions were so cool.</div></div></div><div class=actions><div class=description>10 min ago</div><div class="synergy-actions flex-center mt-2"><i class="i-icon i-call bgc-grey m-2 c-pointer"></i> <i class="i-icon i-message bgc-grey m-2 c-pointer"></i> <i class="i-icon i-video-call bgc-grey m-2 c-pointer"></i></div></div></div></div><div ng-if="vm.sortType !== \'recent\' && vm.isStaffed"><div class="synergy-item flex-between" ng-repeat="userInfo in vm.staffs"><div class="w-100 flex-start synergy-item-info" ng-click="vm.select(0, userInfo)"><div class="synergy-avatar flex-center"><img ng-src="{{userInfo.profilePic || userInfo.clientLogo || \'assets/images/employees/no-avatar.png\'}}" alt=icon class=object-fit-cover></div><div class=synergy-profile><div class=name>{{userInfo.displayName || userInfo.clientName || userInfo.name}}</div><div class=activity>lol your reactions were so cool.</div></div></div><div class=actions><div class=description>10 min ago</div><div class="synergy-actions flex-center mt-2"><i class="i-icon i-call bgc-grey m-2 c-pointer"></i> <i class="i-icon i-message bgc-grey m-2 c-pointer"></i> <i class="i-icon i-video-call bgc-grey m-2 c-pointer"></i></div></div></div></div><no-data ng-if="vm.allMembers.length === 0 && vm.sortType !== \'recent\'"></no-data></div></div><div ng-if=vm.isSelected><div class="detail-title flex-between"><div class=flex-center ng-if="vm.sortType == \'recent\'"><i class="i-icon i-back bgc-dark c-pointer" ng-click=vm.back()></i><div class="detail-user-avatar flex-center"><img ng-src=assets/images/employees/no-avatar.png alt=icon class=object-fit-cover> <span class="detail-user-status active"></span></div><div class=detail-user-name>Darrell Steward</div></div><div class=flex-center ng-if="vm.sortType !== \'recent\'"><i class="i-icon i-back bgc-dark c-pointer" ng-click=vm.back()></i><div class="detail-user-avatar flex-center"><img ng-src="{{vm.selectedUser.profilePic || vm.selectedUser.clientLogo || \'assets/images/employees/no-avatar.png\'}}" alt=icon class=object-fit-cover> <span class="detail-user-status active"></span></div><div class=detail-user-name><div class=name>{{vm.selectedUser.displayName || vm.selectedUser.clientName || vm.selectedUser.name}}</div></div></div><div class=flex-center><i class="i-icon i-call bgc-dark mr-3 c-pointer"></i> <i class="i-icon i-video-call bgc-dark mr-3 c-pointer"></i> <i class="i-icon i-close bgc-dark md c-pointer" ng-click=vm.close()></i></div></div><div class=divider></div><div class=detail-content ng-class="{attach: vm.attachmentFiles.length}"><div class="detail-content-item sender"><div class=user-avatar><img ng-src="{{vm.selectedUser.profilePic || vm.selectedUser.clientLogo || \'assets/images/employees/no-avatar.png\'}}" alt=icon class=object-fit-cover></div><div class=item-info><div class=text>My mom says its hard to use... ohh and your avatar from Pirates and it looks like Captain Jack Sparrow \uD83D\uDE05</div><div class=time>20 min ago</div></div></div><div class="detail-content-item receiver"><div class=item-info><div class=text>Great idea!!! I am sure this will be loved by the dribble players</div><div class=time>20 min ago</div></div><div class=user-avatar><img ng-src=assets/images/employees/no-avatar.png alt=icon class=object-fit-cover></div></div><div class="detail-content-item sender"><div class=user-avatar><img ng-src="{{vm.selectedUser.profilePic || vm.selectedUser.clientLogo || \'assets/images/employees/no-avatar.png\'}}" alt=icon class=object-fit-cover></div><div class=item-info><div class=text>Yeah!!! For Sure \uD83D\uDE0A</div><div class=time>20 min ago</div></div></div><div class="detail-content-item receiver"><div class=item-info><div class=text>Make sure you tag it on Social Media!! #CloudES</div><div class=time>20 min ago</div></div><div class=user-avatar><img ng-src=assets/images/employees/no-avatar.png alt=icon class=object-fit-cover></div></div><div class=detail-content-item ng-repeat="message in vm.messages" ng-class="{sender: message.type == \'send\', receiver: message.type == \'receiver\'}"><div class=user-avatar ng-if="message.type == \'send\'"><img ng-src="{{vm.selectedUser.profilePic || vm.selectedUser.clientLogo || \'assets/images/employees/no-avatar.png\'}}" alt=icon class=object-fit-cover></div><div class=item-info><div class=text>{{message.text}}</div><div class=time>{{vm.getTime(message.created_at)}}</div></div><div class=user-avatar ng-if="message.type == \'receive\'"><img ng-src=assets/images/employees/no-avatar.png alt=icon class=object-fit-cover></div></div><div class=chat-box ng-if=vm.isSelected><attach-files attach-files=vm.attachmentFiles></attach-files><div class=chat-input><textarea type=text placeholder="Write a commnet" ng-model=vm.message ng-keyup=vm.messageBodyInput($event) emoji-picker emoji-attachment-location="bottom right" emoji-menu-location="top left" id=emoji-area>\n                    </textarea><div class="input-actions flex-center"><i class="i-icon i-attach bgc-light-grey c-pointer" ngf-select ngf-change=vm.changeAttacheFiles($files) ngf-multiple=true></i></div></div></div></div></div></div>');
$templateCache.put('app/core/components/update-status-modal/update-status-modal.view.html','<div id=update-status-modal><div class=header><div class=tx-ellipsis translate="Update Status"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><label for=status translate=Status></label><selectbox2 id=status ng-model=status label-field=label value-field=value options=statusList></selectbox2></div><div class=footer><button class="btn_primary mr-3" ng-click=onSubmit() translate=Save></button> <button class=btn_white ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/core/components/nav-notification-modal/nav-notification-modal.view.html','<div id=nav-notification-modal><div class=title><div class="tx-ellipsis mr-auto" translate=Notifications></div><div class=btn ui-sref=notifications ng-click=vm.close() translate=Open></div><div class=btn ng-click=vm.markNotificationAsReadAll() ng-show="vm.notifications.length > 0" translate="Mark all as read"></div><div class=close-icon ng-click=vm.close()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=divider></div><div class=content><spinner ng-if=isLoading></spinner><div class=notification-item ng-repeat="item in vm.notifications" ng-class="item.route? \'cursor-point\': \'\'" ng-click=vm.goToDetail(item)><div class="notification-avatar flex-center"><img ng-src="{{item.userId.profilePic || \'/assets/images/employees/no-avatar.png\'}}" alt=icon class=object-fit-cover title={{item.userId.displayName}}></div><div class=w-100><div class="w-100 flex-between"><div class=name>{{item.userId.displayName}}</div><div class=time>{{item.updatedTime}}</div></div><div class=description title={{item.description}}>{{item.description}}</div></div></div><no-data ng-if="vm.notifications.length === 0"></no-data></div></div>');
$templateCache.put('app/core/directives/attach-files/attach-files.view.html','<div ng-if="attachFiles && attachFiles.length > 0" class=attach-files><div class=attach-file ng-repeat="file in attachFiles track by $index"><img ng-if=utils.isImageFile(file) ng-src={{file.objectUrl}} class=image-file alt=""><div ng-if=!utils.isImageFile(file) class=no-image title={{file.name}}><img ng-src={{utils.getFileIcon(file)}} class=file-icon alt=""><div class=file-name>{{file.name}}</div><div class=file-size>{{file.size | filesize}}</div></div><img class=remove src=/assets/icons/close-circle-f-gray.svg alt="" ng-click=removeAttachFile($index)></div><button class=btn-add-file ngf-select ngf-change=appendAttachFiles($files) ngf-multiple=true><img src=/assets/icons/plus.svg alt=""></button></div>');
$templateCache.put('app/core/directives/attach-files-small/attach-files-small.view.html','<div ng-if="attachFiles && attachFiles.length > 0" class=attach-files-small><div class=attach-file ng-repeat="file in attachFiles track by $index"><img ng-if=utils.isImageFile(file) ng-src={{file.objectUrl}} class=image-file alt=""><div ng-if=!utils.isImageFile(file) class=no-image title={{file.name}}><img ng-src={{utils.getFileIcon(file)}} class=file-icon alt=""><div class=file-name>{{file.name}}</div><div class=file-size>{{file.size | filesize}}</div></div><img class=remove src=/assets/icons/close-circle-f-gray.svg alt="" ng-click=removeAttachFile($index)></div><button class=btn-add-file ngf-select ngf-change=appendAttachFiles($files) ngf-multiple=true><img src=/assets/icons/plus.svg alt=""></button></div>');
$templateCache.put('app/core/directives/autocomplete/autocomplete.view.html','<div class="autocomplete pos-relative" ng-class="[!noMarginRight? \'mr-4\': \'\', !noFlex? \'flex-1\': \'\', fullWidth ? \'w-100\' : \'\']"><div class=backdrop ng-if=isOpenAutoComplete ng-click=closeAutocomplete()></div><div class=type-option><img src={{iconFile}} alt=Search ng-if=isIcon> <input type=text class=pos-relative ng-class=inputClass ng-model=inputValue ng-keyup=changeInput() ng-click=clickInput() placeholder={{placeHolder}}></div><ul class="list-group w-100 group-list zindex-3 position-absolute mh-300 overflow-auto items-list" ng-class="toTop ? \'upward\' : \'\'" ng-show=isOpenAutoComplete><li class=list-group-item ng-repeat="($index,item) in filteredOptions track by $index" ng-click=selectedItem(item)>{{item[labelField]}}</li></ul></div>');
$templateCache.put('app/core/directives/avatar-group/avatar-group.view.html','<div id=avatar-group ng-class="{\'d-flex\': !isBlock}" ng-style="{\'height\': height? height + \'px\': \'\', \'width\': width? width + \'px\': \'\', \'margin-top\': marginTop? marginTop + \'px\': \'\'}"><div class=backdrop ng-if=isOpenTotalList ng-click=closeTotalList()></div><div ng-repeat="item in avatars track by $index" ng-if="$index < 3 || isBlock" class=flex-items-center ng-class="{\'mb-16\': isBlock}"><div ng-if="item.parent.profilePic || item.profilePic"><img class="avatar-40 object-fit-cover" ng-src="{{item.parent && item.parent.profilePic ? item.parent.profilePic : item.profilePic || \'/assets/images/employees/no-avatar.png\'}}" ng-style="{\'border\': avatarBorderColor? \'2px solid \' + avatarBorderColor: \'none\',\n          \'left\': isOverlap? $index*27 + \'px\': \'\',\n          \'position\': isOverlap? \'absolute\': \'\',\n          \'width\': height? height + \'px\': \'\',\n          \'height\': height? height + \'px\': \'\',\n          \'border-radius\': radius}" alt=icons title={{item.displayName}}></div><div ng-if="!item.parent.profilePic && !item.profilePic"><span class="avatar-text mr-8" ng-style="{ \'background\': (getColor(item.displayName)), \'border-radius\': radius }">{{item.displayName | mailAvatarChar}}</span></div><div ng-if=isBlock><div class=ft_14_regular_black1>{{item.displayName}}</div><div class=ft_12_regular_gray>{{item.email}}</div></div><div ng-if=isBlock class="close-icon ml-auto" ng-click=onClose(item.memberId)><img src=/assets/icons/close-12-gray.svg alt=icons></div><div ng-if="$index == 2 && avatars.length > 3 && !isBlock" class="more-count ft_14_600_yellow flex-center cursor-point pos-relative" ng-click=openTotalList() ng-style="{\'background-color\': moreCountBackgroundColor? moreCountBackgroundColor: \'#ffffff\',\n         \'border\': moreCountBorderColor? \'2px solid \' + moreCountBorderColor: \'none\',\n         \'color\': moreCountColor? moreCountColor: \'#ffffff\',\n         \'left\': isOverlap? ($index + 1)*27 + \'px\': \'\',\n         \'position\': isOverlap? \'absolute\': \'\',\n         \'width\': height? height + \'px\': \'\',\n         \'height\': height? height + \'px\': \'\'\n         }">+{{avatars.length - 3}}</div></div><ul class="list-group w-fit-content group-list zindex-3 position-absolute mh-300 overflow-auto items-list" ng-class="toTop ? \'upward\' : \'\'" ng-style="{\'margin-top\': toTop? \'\': \'42px\'}" ng-show=isOpenTotalList><li class="list-group-item flex-items-center" ng-repeat="($index,item) in avatars track by $index"><div ng-if="item.parent.profilePic || item.profilePic"><img class="avatar-40 object-fit-cover" ng-style="{\'border\': avatarBorderColor? \'2px solid \' + avatarBorderColor: \'none\'}" ng-src="{{item.parent && item.parent.profilePic ? item.parent.profilePic : item.profilePic || \'/assets/images/employees/no-avatar.png\'}}" alt=icons title={{item.displayName}}></div><div ng-if="!item.parent.profilePic && !item.profilePic"><span class="avatar-text mr-8" ng-style="{ \'background\': (getColor(item.displayName)) }">{{item.displayName | mailAvatarChar}}</span></div><div><div>{{item.displayName}}</div></div></li></ul></div>');
$templateCache.put('app/core/directives/calc-selectbox/selectbox.view.html','<div><div class="dropdown selectbox" ng-mouseleave=closeList() ng-show=!isClickOpen><!-- <button ng-if="disabled" class="dropdown-toggle disabled" type="button" ng-click="toggleList()" ng-if="!isSearch" disabled>{{selectedLabel}}</button> --> <button class=dropdown-toggle type=button ng-click=toggleList() ng-if=!isSearch title={{selectedLabel}}>{{selectedLabel}}</button> <input type=text class="dropdown-toggle search-input" ng-model=selectedLabelTemp autocomplete=off ng-keyup=searchFunction(selectedLabelTemp) ng-show=isSearch&&selectedLabelTemp ng-focus=startSearch() ng-mouseover=openList() title={{selectedLabelTemp}}> <input type=text class="dropdown-toggle search-input" ng-model=selectedLabel autocomplete=off ng-keydown=searchFunction(selectedLabel) ng-if=isSearch&&!selectedLabelTemp ng-focus=startSearch() ng-mouseover=openList() title={{selectedLabel}}><ul class=dropdown-menu ng-if=isOpen><!-- <li ng-if="isSearch">\n        <input type="text" ng-model="searchText" placeholder="Search..." autocomplete="off" ng-keyup="searchFunction(searchText)" ng-blur="searchText=\'\'">\n      </li> --><li><a href=# class=menu-item id={{item[valueField]}} data-ng-click=selectItem(item) ng-repeat="item in cOptions" ng-if="options && options!=[]">{{item[labelField]}}</a> <a href=# class=menu-item ng-if="!options || !options.length">No Data</a> <a class=menu-item ng-click=addItem() ng-if=enableAddItem>+ <span translate=Add></span></a></li></ul><!-- <div class="backdrop" ng-click="closeList()" ng-if="isOpen"></div> --></div><div class="dropdown selectbox" ng-show=isClickOpen><div class=backdrop ng-click=closeList() ng-if=isOpen></div><button class=dropdown-toggle type=button ng-click=toggleList() ng-if=!isSearch>{{selectedLabel}}</button> <input type=text class="dropdown-toggle search-input" ng-model=selectedLabelTemp autocomplete=off ng-keyup=searchFunction(selectedLabelTemp) ng-show=isSearch&&selectedLabelTemp ng-focus=openList() ng-click=openList() title={{selectedLabelTemp}}> <input type=text class="dropdown-toggle search-input" ng-model=selectedLabel autocomplete=off ng-keyup=searchFunction(selectedLabel) ng-show=isSearch&&!selectedLabelTemp ng-focus=openList() ng-click=openList() title={{selectedLabel}}><ul class=dropdown-menu ng-if=isOpen><li><a href=# class=menu-item id={{item[valueField]}} data-ng-click=selectItem(item) ng-repeat="item in cOptions" ng-if="options && options!=[]">{{item[labelField]}}</a> <a href=# class=menu-item ng-if="!options || !options.length">No Data</a> <a class=menu-item ng-click=addItem() ng-if=enableAddItem>+ <span translate=Add></span></a></li></ul></div></div>');
$templateCache.put('app/core/directives/chatting-input/chatting-input.view.html','<div class=chatting-input><div class=attach-area ng-if=files.length><div class=attach-item ng-repeat="file in files track by $index"><img class=image_close_btn src=/assets/icons/close-gray-circle-with-border.svg alt=icons ng-click=removeFile($index)><div class=attach-thumbnail><img ng-show=file.isImage ng-src={{file.imageURL}} class=attach-thumbnail alt=""></div><div class="text-center f_name mb-15">{{file.file.name}}</div></div></div><div class=text-input-area><div class="flex-items-center w-100 pr-10"><img class=mr-2 src=/assets/icons/bxs-plus-circle-black.svg alt=attach ngf-select ngf-change=onChangeFiles($files) ngf-multiple=true><div class=input-box><input type=text ng-model=message enter-key=onSend()> <img class=emotion src=/assets/icons/emotion-gray.svg alt=emotion></div></div><div class=flex-items-center><img src=/assets/icons/send-black.svg alt=send ng-click=onSend()></div></div><spinner ng-show=sending></spinner></div>');
$templateCache.put('app/core/directives/color-selector/color-selector-modal.view.html','<div id=color-selector-modal><div class=header><span class=title translate=Color></span> <span class=close-btn ng-click=vm.cancel()></span></div><div class=content><div class=flex-center><div class=sub-title translate="Recent Swatches"></div><img class="cursor-point ml-auto" src=/assets/icons/colorize.svg alt=""></div><div class="flex-between mt-8"><div class="color-item cursor-point" ng-repeat="item in vm.recents track by $index" ng-style="{background: (item === \'\' ? \'transparent\' : item)}" ng-click=vm.selectRecent($index)></div></div><div class="flex-between mt-16"><div class="color-board no-zoom"><div class=color-board-sat><div class=color-board-inner><div class=color-board-picker></div></div></div></div><div class="color-hue no-zoom"><div class=color-hue-slider></div></div></div><div class="flex-items-center mt-16"><selectbox class=color-mode options=vm.colorModes ng-model=colorMode label-field=name value-field=mode select-event=vm.changeMode(colorMode) to-top=true></selectbox><div class="color-item ml-10" ng-style="{background: getCurrentColor()}"></div><div class="color-value hex ml-10" ng-if="vm.colorMode === \'hex\'"><input type=text class=color-code ng-model=vm.color.hex pattern=[a-fA-F\\d]+> <input type=number class=opacity ng-model=vm.color.a min=0 max=100>%</div><div class="color-value rgb ml-10" ng-if="vm.colorMode === \'rgb\'"><input type=number class=color-r ng-model=vm.color.r min=0 max=255 ng-blur=vm.changeColor()> <input type=number class=color-g ng-model=vm.color.g min=0 max=255 ng-blur=vm.changeColor()> <input type=number class=color-b ng-model=vm.color.b min=0 max=255 ng-blur=vm.changeColor()> <input type=number class=opacity ng-model=vm.color.a min=0 max=100>%</div><div class="color-value rgb ml-10" ng-if="vm.colorMode === \'hsl\'"><input type=number class=color-r ng-model=vm.color.h number-edit=2 ng-blur=vm.changeColor()> <input type=number class=color-g ng-model=vm.color.s min=0 max=100 ng-blur=vm.changeColor()> <input type=number class=color-b ng-model=vm.color.l min=0 max=100 ng-blur=vm.changeColor()> <input type=number class=opacity ng-model=vm.color.a min=0 max=100>%</div></div><div class="d-flex mt-20"><div class="button-primary ml-auto" ng-click=vm.select() translate=Select></div><div class="btn_cancel ml-16" ng-click=vm.cancel() translate=Cancel></div></div></div></div>');
$templateCache.put('app/core/directives/color-selector/color-selector.view.html','<div class=color-selector ng-click=onClick()><div class=color-shape ng-style=getColor()></div><div class=color-symbol ng-if=hideSymbol>#</div><div class=color-code>{{color}}</div></div>');
$templateCache.put('app/core/directives/inner-spinner/inner-spinner.html','<div class="inner-spinner ft_24_600_gray"><img src=/assets/icons/spinner.gif alt=icons ng-style="{\'top\': top? top + \'px\': 0}"></div>');
$templateCache.put('app/core/directives/inventory-card/inventory-card.view.html','<div class=inventory-card ng-click=goDetail()><div class=card-image><img ng-src="{{ itemData.designImage ? itemData.designImage.secure_url : itemData.files.images[0].secure_url ||\n                 \'/assets/images/materials/noImg.jpg\'}}" alt=icons class=object-fit-cover></div><div class=detail-wrapper><div class=detail><div class="d-flex flex-between"><div class="tag systemTag">{{itemData.systemTag}}</div><div class="circle b{{itemData.systemTag[itemData.systemTag.length - 1]}}"></div></div><div class=flex-between><p class=name title={{itemData.name}}>{{itemData.name}}</p></div><div class=flex-between><span class="value d-block ft-16 lh-24 fw-600"><span>{{currencySymbol}}</span> <span>{{ type == \'material\' ? itemData.currentRate.materialCost.value : type == \'combo\' ? itemData.totalMaterialCost : type == \'item\' ? itemData.cost[0].itemsCost : itemData.totalEquipmentCost | readable : 2 }}</span></span></div><div class=line></div><div class="flex-between size"><div ng-if="type != \'combo\'"><img src=/assets/icons/tag-outline-blue.svg> <span class=tag-name>{{ type == \'material\' ? itemData.groupId.name : type == \'item\' ? itemData.typeOfSub[0].tagName : \'\'}}</span></div><div ng-if="type != \'combo\'"><img src=/assets/icons/open_in_full.svg> <span class=size-calc>{{itemData.ccs ? itemData.ccs : 1}} x {{itemData.unitSize ? itemData.unitSize : 1}} x {{itemData.itemsUnit ? itemData.itemsUnit : 1}} {{itemData.unit}}</span></div><div class=ml-auto ng-if="type == \'combo\'"><img src=/assets/icons/date-calendar.svg> <span class=size-calc>{{itemData.createdAt | date: "dd MMM yyyy" : \'UTC\'}}</span></div></div></div></div></div>');
$templateCache.put('app/core/directives/live-chat/live-chat.view.html','<div class=live-chat><div class=messages-container><spinner ng-if="loading && !externLoading"></spinner><div class=send-receive id=messages scroll-bottom=currentMessages scroll-bottom-attach=attachmentFiles scroll-bottom-quote=quotingMessage scroll-bottom-atsign={{isSearch}}><div ng-repeat="(key, message) in currentMessages" ng-class="message.userType?\'receive\':\'send\'"><div class=item><div id=my-message-actions class="dropdown dropleft" ng-if=message.userType><img ng-if=isEditedMessage(message.sid) class=edited src=/assets/icons/edit-light.svg alt=""> <img class=more id=call-more-btn-{{key}} data-toggle=dropdown aria-haspopup=true aria-expanded=false src=/assets/icons/more.svg alt=icons><ul class=dropdown-menu role=menu aria-labelledby=my-message-actions><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=editMessage(message) translate=Edit></a></li><li><a href=# class=menu-item ng-click=deleteMessage(message) translate=Delete></a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=copyMessage(message) translate=Copy></a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=quoteMessage(message) translate=Quote></a></li></ul></div><img ng-hide=message.userType class="avatar object-fit-cover mr-8" ng-src="{{!!message.profilePic?message.profilePic:\'/assets/images/employees/no-avatar.png\'}}" alt=icons><div class="talk-bubble tri-right round btm"><div ng-init="limit=1024; moreShown = false" class=talktext><div ng-bind-html="getMessageBody(message.state.body) | limitTo: limit"></div><div class="time ft_12_regular_gray"><img ng-src=/assets/icons/meeting-d.svg alt="" width=16 height=16> <span class=mr-8>{{getChatTime(message.state.dateUpdated)}}</span> <span>{{message.authorName}}</span></div></div></div><img ng-hide=!message.userType class="avatar object-fit-cover ml-8" ng-src="{{!!message.profilePic?message.profilePic:\'/assets/images/employees/no-avatar.png\'}}" alt=icons> <a ng-show="getMessageBody(message.state.body).length > limit" href ng-click="limit=getMessageBody(message.state.body).length; moreShown = true"><u>...More</u> </a><a ng-show=moreShown href ng-click="limit=1024; moreShown = false"><u>Less</u></a><div id=your-message-actions class="dropdown dropleft" ng-if=!message.userType><img ng-if=!isFileMessage(message) class=more id="call-more-btn-{{key + 1000}}" data-toggle=dropdown aria-haspopup=true aria-expanded=false src=/assets/icons/more.svg alt=icons><ul class=dropdown-menu role=menu aria-labelledby=your-message-actions><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=copyMessage(message)>Copy</a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=quoteMessage(message) translate=Quote></a></li></ul></div></div></div><attach-files attach-files=attachmentFiles></attach-files><quote-message ng-if=quotingMessage ng-model=quotingMessage cancel-quote=cancelQuoteMessage()></quote-message><search-list ng-if=isSearch options=memberNames search-text=searchText select-event=selectUserName(name) select-candidate=selectUserNameCandidate(name)></search-list><waiting-indicator ng-if=waiting></waiting-indicator></div><div class=typing-status ng-if=typingStatus><div class=typing-indicator-box><ul><li>{{member.attributes.name}} is typing<div class=typing-indicator><span></span> <span></span> <span></span></div></li></ul></div></div></div><div class=message-input-container><div class=attachment ngf-select ngf-change=changeAttacheFiles($files) ngf-multiple=true ng-disabled=!(!!activeChannel)><img src=/assets/icons/attachment1.svg alt=attachment></div><textarea id=message-input placeholder="Type a message here" ng-disabled=!(!!activeChannel) ng-model=messageBody ng-keypress="messageBodyInput($event, messageBody)">\n    </textarea><div class=send-msg ng-disabled=!(!!activeChannel) ng-click=submitMessageBody(messageBody)><img src=/assets/icons/send-msg.svg alt=icons></div></div></div>');
$templateCache.put('app/core/directives/live-chat-new/live-chat-new.view.html','<div class=live-chat-new><div class=messages-container><spinner ng-if="loading && !externLoading"></spinner><div class=send-receive id=messages scroll-bottom=currentMessages scroll-bottom-attach=attachmentFiles scroll-bottom-quote=quotingMessage scroll-bottom-atsign={{isSearch}}><div class="flex flex-row flex-between flex-items-center"><span class=ft_18_600_black3>Conversations</span> <a class="ft_14_600_moreblue cursor-point">View all conversations</a></div><div class="message-input-container flex flex-row flex-items-center mt-24"><!-- <div\n            class="attachment"\n            ngf-select\n            ngf-change="changeAttacheFiles($files)"\n            ngf-multiple="true"\n            ng-disabled="!(!!activeChannel)"\n        >\n          <img src="/assets/icons/attachment1.svg" alt="attachment" />\n        </div> --> <img ng-src={{userData.profilePic}} class="avatar object-fit-cover"><div class="message-input-box flex flex-row ph-16 flex-items-center flex-1 msgInputTextbox"><textarea id=message-input class=flex-1 placeholder="Type a message here" ng-disabled=!(!!activeChannel) ng-model=messageBody ng-keypress="messageBodyInput($event, messageBody)">\n          </textarea><div class="flex flex-row"><div class=attachment ngf-select ngf-change=changeAttacheFiles($files) ngf-multiple=true ng-disabled=!(!!activeChannel)><img src=/assets/icons/insert_emoticon.svg alt=attachment></div><div class="attachment ml-16" ngf-select ngf-change=changeAttacheFiles($files) ngf-multiple=true ng-disabled=!(!!activeChannel)><img src=/assets/icons/insert_photo.svg alt=attachment></div></div></div><!-- <div class="send-msg" ng-disabled="!(!!activeChannel)" ng-click="submitMessageBody(messageBody)">\n          <img src="/assets/icons/send-msg.svg" alt="icons" />\n        </div> --></div><div class=mt-30 ng-repeat="(key, message) in currentMessages" ng-class="message.userType?\'receive\':\'send\'"><div class=item><div id=my-message-actions class="dropdown dropleft" ng-if=message.userType><img ng-if=isEditedMessage(message.sid) class=edited src=/assets/icons/edit-light.svg alt=""> <img class=more id=call-more-btn-{{key}} data-toggle=dropdown aria-haspopup=true aria-expanded=false src=/assets/icons/more.svg alt=icons><ul class=dropdown-menu role=menu aria-labelledby=my-message-actions><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=editMessage(message) translate=Edit></a></li><li><a href=# class=menu-item ng-click=deleteMessage(message) translate=Delete></a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=copyMessage(message) translate=Copy></a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=quoteMessage(message) translate=Quote></a></li></ul></div><img ng-hide=message.userType class="avatar object-fit-cover" ng-src="{{!!message.profilePic?message.profilePic:\'/assets/images/employees/no-avatar.png\'}}" alt=icons><div class="talk-bubble tri-right round btm"><div ng-init="limit=1024; moreShown = false" class=talktext><div ng-bind-html="getMessageBody(message.state.body) | limitTo: limit"></div><div class="time ft_12_regular_gray"><img ng-src=/assets/icons/meeting-d.svg alt="" width=16 height=16> <span class=mr-8>{{getChatTime(message.state.dateUpdated)}}</span> <span>{{message.authorName}}</span></div></div></div><img ng-hide=!message.userType class="avatar object-fit-cover ml-8" ng-src="{{!!message.profilePic?message.profilePic:\'/assets/images/employees/no-avatar.png\'}}" alt=icons> <a ng-show="getMessageBody(message.state.body).length > limit" href ng-click="limit=getMessageBody(message.state.body).length; moreShown = true"><u>...More</u> </a><a ng-show=moreShown href ng-click="limit=1024; moreShown = false"><u>Less</u></a><div id=your-message-actions class="dropdown dropleft" ng-if=!message.userType><img ng-if=!isFileMessage(message) class=more id="call-more-btn-{{key + 1000}}" data-toggle=dropdown aria-haspopup=true aria-expanded=false src=/assets/icons/more.svg alt=icons><ul class=dropdown-menu role=menu aria-labelledby=your-message-actions><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=copyMessage(message)>Copy</a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=quoteMessage(message) translate=Quote></a></li></ul></div></div></div><attach-files attach-files=attachmentFiles></attach-files><quote-message ng-if=quotingMessage ng-model=quotingMessage cancel-quote=cancelQuoteMessage()></quote-message><search-list ng-if=isSearch options=memberNames search-text=searchText select-event=selectUserName(name) select-candidate=selectUserNameCandidate(name)></search-list><waiting-indicator ng-if=waiting></waiting-indicator></div><div class=typing-status ng-if=typingStatus><div class=typing-indicator-box><ul><li>{{member.attributes.name}} is typing<div class=typing-indicator><span></span> <span></span> <span></span></div></li></ul></div></div></div></div>');
$templateCache.put('app/core/directives/live-chat-small/live-chat-small.view.html','<div class=live-chat-small><div class=messages scroll-bottom=currentMessages scroll-bottom-attach=attachmentFiles scroll-bottom-quote=quotingMessage scroll-bottom-atsign={{isSearch}}><div class=message-item ng-repeat="message in currentMessages track by $index" ng-class="{me: message.userType}"><div class=user-info ng-if="$index==0 || !message.userType"><div class=d-flex><img ng-src="{{ message.profilePic || \'assets/images/login/avatar.png\'}}" alt=logo class="avatar object-fit-cover"><div class=name>{{message.authorName}}</div></div><div class=date>{{message.state.dateUpdated | smartDateTime}}</div></div><div class=d-flex ng-class="{\'flex-content-end\': message.userType}"><div id=message-actions class="dropdown dropleft" ng-if=message.userType><img ng-if=isEditedMessage(message.sid) class=edited src=/assets/icons/edit-light.svg alt=""> <img class=more id=call-more-btn-{{key}} data-toggle=dropdown aria-haspopup=true aria-expanded=false src=/assets/icons/more.svg alt=icons><ul class=dropdown-menu role=menu aria-labelledby=message-actions><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=editMessage(message) translate=Edit></a></li><li><a href=# class=menu-item ng-click=deleteMessage(message) translate=Delete></a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=copyMessage(message) translate=Copy></a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=quoteMessage(message) translate=Quote></a></li></ul></div><div class=message ng-bind-html=getMessageBody(message.state.body)></div><div id=message-actions class="dropdown dropright" ng-if=!message.userType><img ng-if=isEditedMessage(message.sid) class=edited src=/assets/icons/edit-light.svg alt=""> <img ng-if=!isFileMessage(message) class=more id=call-more-btn-{{key}} data-toggle=dropdown aria-haspopup=true aria-expanded=false src=/assets/icons/more.svg alt=icons><ul class=dropdown-menu role=menu aria-labelledby=message-actions><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=copyMessage(message) translate=Copy></a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=quoteMessage(message) translate=Quote></a></li></ul></div></div></div><attach-files attach-files=attachmentFiles></attach-files><quote-message ng-if=quotingMessage ng-model=quotingMessage cancel-quote=cancelQuoteMessage()></quote-message><search-list ng-if=isSearch options=memberNames search-text=searchText select-event=selectUserName(name) select-candidate=selectUserNameCandidate(name)></search-list><waiting-indicator ng-if=waiting></waiting-indicator></div><spinner ng-if=loading></spinner><div class=message-input-container><div class=attachment ngf-select ngf-change=changeAttacheFiles($files) ngf-multiple=true ng-disabled=!(!!activeChannel)><img src=/assets/icons/attachment1.svg alt=attachment></div><textarea id=message-input placeholder="Type a message here" ng-disabled=!(!!activeChannel) ng-model=messageBody ng-keypress="messageBodyInput($event, messageBody)">\n    </textarea><div class=send-msg ng-disabled=!(!!activeChannel) ng-click=submitMessageBody(messageBody)><img src=/assets/icons/send-msg.svg alt=icons></div></div></div>');
$templateCache.put('app/core/directives/main-navbar/main-navbar.view.html','<div class=main-nav-bar><div class="nav-items mr-auto"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/dashboard.svg> <span translate=Dashboard></span> <img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li ng-if="userData.designation == \'Admin\' || userData.dashboard.indexOf(\'Finance Manager\') > -1"><a class="dropdown-item flex-between"><span translate=Finance></span><div class=menu-icon></div></a><ul><div class=dropdown-row><div class=arrow-left></div><div class=dropdown-content><li><a class=dropdown-item data-ng-click="gotoPage(\'financeDashboard\', true, true)" translate=Dashboard></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeBankDetail\', true, true)" translate=Bank></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeSales\', true, true)" translate=Sales></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financePurchases\', true, true)" translate=Purchases></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeVatReports\', true, true)" translate=Reports></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeFinance\', true, true)" translate=Finance></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeBalance\', true, true)" translate=Balance></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeVatSettings\', true, true)" translate="VAT Settings"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeScript\', true, true)" translate=Script></a></li></div></div></ul></li><li ng-if="userData.designation == \'Admin\' || userData.dashboard.indexOf(\'Audit Manager\') > -1"><a class=dropdown-item data-ng-click="gotoPage(\'auditManage\', true, true)" translate="Audit Management"></a></li><li ng-if="userData.designation == \'Admin\' || userData.dashboard.indexOf(\'Bid Manager\') > -1"><a class=dropdown-item data-ng-click="gotoPage(\'bidManage\', dashboardType == 1 || dashboardType == 5, true)" translate="Bid & Tender"></a></li><li ng-if="userData.designation == \'Admin\' || userData.dashboard.indexOf(\'Sales Manager\') > -1"><a class=dropdown-item data-ng-click="gotoPage(\'salesManage\', true, true)" translate="Estimate & Sales"></a></li><li ng-if="userData.designation == \'Admin\' || userData.dashboard.indexOf(\'Design Manager\') > -1"><a class=dropdown-item data-ng-click="gotoPage(\'projectDesign\', true, true)" translate="Project Design"></a></li><li ng-if="userData.designation == \'Admin\' || userData.dashboard.indexOf(\'Project Manager\') > -1"><a class=dropdown-item data-ng-click="gotoPage(\'productionsBoard\', true, true)" translate="Project Manager"></a></li><li ng-if="userData.designation == \'Admin\' || userData.dashboard.indexOf(\'Site Manager\') > -1"><a class=dropdown-item data-ng-click="gotoPage(\'siteManage1\', true, true)" translate="Site Manager"></a></li><li ng-if="userData.designation == \'Admin\' || userData.dashboard.indexOf(\'QSHE Manager\') > -1"><a class=dropdown-item data-ng-click="gotoPage(\'qsheManage\', true, true)" translate="QSHE Manager"></a></li><li ng-if="userData.designation == \'Admin\' || userData.designation == \'Client\' || userData.designation == \'Supplier\' || userData.designation == \'Subcontractor\'"><a class="dropdown-item flex-between"><span translate="Client & Collaborator"></span><div class=menu-icon></div></a><ul><div class=dropdown-row><div class=arrow-left></div><div class=dropdown-content><li ng-if="userData.designation == \'Admin\' || userData.designation == \'Client\'"><a class=dropdown-item data-ng-click="gotoPage(\'clientManage\', true, true)" translate=Client></a></li><li ng-if="userData.designation == \'Admin\' || userData.designation == \'Supplier\'"><a class=dropdown-item data-ng-click="gotoPage(\'supplierManage\', true, true)" translate=Supplier></a></li><li ng-if="userData.designation == \'Admin\' || userData.designation == \'Subcontractor\'"><a class=dropdown-item data-ng-click="gotoPage(\'subContractorManage\', true, true)" translate=Sub-Contractor></a></li></div></div></ul></li></div></ul></li><!-- ECONOMIC --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/economy.svg><span translate=Economic></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li><a class=dropdown-item data-ng-click="gotoPage(\'economicManage\', true, true)" translate=Dashboard></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'invoiceList\', true, true)"><span translate=Invoice></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'billList\', true, true)"><span translate="Bill Approval"></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'vaOrderList\', true, true)"><span translate="VA Orders"></span></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'payroll\', true)" translate=Payroll></a></li></div></ul></li><!-- VISUAL & TIME --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/timeline1.svg><span translate=Timeline></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'vpGrid\', true)"><span translate="Visual Planner"></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'bimGrid\', true)"><span translate="Dynamic 3D"></span></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'pcdGrid\', true)" translate="Point Cloud"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'photoGrid\', true)" translate="360 Degree Photo"></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'timeline\', true, true)" translate=Timeline></a></li></div></ul></li><!-- CALCULATION --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/calculation1.svg><span translate=Calculation></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li><a class=dropdown-item data-ng-click="gotoPage(\'calcExtra\', true)" translate="Create Main Estimate"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcMain\', true)" translate="Create Part Estimate"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcVersions\', true)" translate=Versions></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'budget\', true, true)" translate=Budget></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'companyBudget\', true)" translate="Company Budget"></a></li></div></ul></li><!-- QSHE --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/qshe1.svg><span translate=QSHE></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'tqList\', true)"><span translate=TQ></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'issuesList\', true)"><span translate=Issues></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'reportsList\', true)"><span translate=Report></span></a></li></div></ul></li><!-- MORE --><li class="nav-item dropdown" style="z-index: 1000;"><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/more.svg><span translate=More></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul class=more-list><div class=arrow-up></div><div class=dropdown-content><li><a class=dropdown-item data-ng-click="gotoPage(\'fileManage\', true)" translate="File Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'bidPackages\', true)" translate="Project Collaboration"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'offerList\', true, true)" translate="Sales Offers"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'salesProducts\', true, true)" translate="Warehouses & Orders"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'managersGrid\', true, true)" translate=Managers></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'clientsGrid\', true, true)" translate=Clients></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'suppliersGrid\', true, true)" translate=Supplier></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'subContractorsGrid\', true, true)" translate=Sub-Contractor></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'employees\', true, true)" translate=Employees></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'materialList\', true, true)" translate=Materials></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'equipmentList\', true, true)" translate=Equipments></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'controlPlanGrid\', true, true)" translate=Controlplan></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'checkList\', true, true)" translate=Checklist></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'settings\', true, true)" translate="Company Settings"></a></li></div></ul></li></div><!-- CEO --><div class="nav-items mr-auto" ng-if="false && (dashboardType == 5 || type == \'ceo\')"><li class=nav-item ng-class="{active: isInPage(\'ceo\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'ceo\', true, true)" translate=Overview></a></li><li class=nav-item ng-class="{active: isInPage(\'ceoEconomics\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'ceoEconomics\', true, true)" translate="Global Economics"></a></li><li class=nav-item ng-class="{active: isInPage(\'financeBalance\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'financeBalance\', true, false)" translate=Balance></a></li><li class=nav-item ng-class="{active: isInPage(\'synergies\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'synergies\', true, true)" translate=Synergy></a></li><li class=nav-item ng-class="{active: isInPage(\'todo\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'todo\', TODO_ACCESS_CREATE > 0, true)" translate="To Do"></a></li><li class=nav-item ng-class="{active: isInPage(\'fileManage\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0, true)" translate="File Manager"></a></li></div><!-- Client --><div class="nav-items mr-auto" ng-if="userData.designation == \'Client\'"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/dashboard.svg> <span translate=Dashboard></span> <img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li><a class="dropdown-item flex-between"><span translate=Finance></span><div class=menu-icon></div></a><ul><div class=dropdown-row><div class=arrow-left></div><div class=dropdown-content><li><a class=dropdown-item data-ng-click="gotoPage(\'financeDashboard\', ECO_ACCESS_CREATE > 0, true)" translate=Dashboard></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeBankDetail\', ECO_ACCESS_CREATE > 0, true)" translate=Bank></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeSales\', ECO_ACCESS_CREATE > 0, true)" translate=Sales></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financePurchases\', ECO_ACCESS_CREATE > 0, true)" translate=Purchases></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeVatReports\', ECO_ACCESS_CREATE > 0, true)" translate=Reports></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeFinance\', ECO_ACCESS_CREATE > 0, true)" translate=Finance></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeBalance\', ECO_ACCESS_CREATE > 0, true)" translate=Balance></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeVatSettings\', ECO_ACCESS_CREATE > 0, true)" translate="VAT Settings"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeScript\', ECO_ACCESS_CREATE > 0, true)" translate=Script></a></li></div></div></ul></li><li><a class=dropdown-item data-ng-click="gotoPage(\'auditManage\', dashboardType == 6, true)" translate="Audit Management"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'bidManage\', dashboardType == 1 || dashboardType == 5, true)" translate="Bid & Tender"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'salesManage\', ECO_ACCESS_CREATE > 0, true)" translate="Estimate & Sales"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'projectDesign\', dashboardType == 0, true)" translate="Project Design"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'productionsBoard\', dashboardType == 0, true)" translate="Project Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'siteManage1\', dashboardType == 2, true)" translate="Site Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'qsheManage\', dashboardType == 3, true)" translate="QSHE Manager"></a></li><li><a class="dropdown-item flex-between"><span translate="Client & Collaborator"></span><div class=menu-icon></div></a><ul><div class=dropdown-row><div class=arrow-left></div><div class=dropdown-content><li><a class=dropdown-item data-ng-click="gotoPage(\'clientManage\', dashboardType == 200, true)" translate=Client></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'supplierManage\', dashboardType == 300, true)" translate=Supplier></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'subContractorManage\', dashboardType == 400, true)" translate=Sub-Contractor></a></li></div></div></ul></li></div></ul></li><!-- VA Orders --><li class=nav-item ng-class="{active: isInPage(\'vaOrderList\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'vaOrderList\', true, false)" translate="VA Orders"></a></li><!-- Timeline --><li class=nav-item ng-class="{active: isInPage(\'timeline\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'timeline\', true, true)" translate=Timeline></a></li><!-- QSHE --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/qshe1.svg><span translate=QSHE></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'tqList\', TQ_ACCESS_CREATE > 0)"><span translate=TQ></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'issuesList\', ISSUE_ACCESS_CREATE > 0)"><span translate=Issues></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><span translate=Report></span></a></li></div></ul></li><li class=nav-item ng-class="{active: isInPage(\'fileManage\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'fileManage\', true, false)" translate="File Manager"></a></li></div><div class=form-inline><div class="nav-items mr-auto"><li class=nav-item><a class="nav-link extrl-ul-link" href=#><img class=nav-menu-icon src=/assets/navbar_icons/Glyph.svg></a></li></div><div class="nav-items mr-auto"><li class=nav-item><a class="nav-link extrl-ul-link" href=#><img class=nav-menu-icon src=/assets/navbar_icons/extra.svg></a><ul class=extrl-ul><div class=arrow-up-right></div><div class=dropdown-content><div class=extra-menu-ul><a class=extra-menu href=/mail target=_blank style="color: white"><img class=nav-menu-icon src=/assets/navbar_icons/mail.svg> <span translate=Mail></span> </a><a class=extra-menu data-ng-click="gotoPage(\'calendar\', CALENDAR_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/calendar.svg> <span translate=Calendar></span> </a><a class=extra-menu data-ng-click="gotoPage(\'companyCalendar\', CALENDAR_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/shiftplanner.svg> <span translate=Shiftplanner></span> </a><a class=extra-menu data-ng-click="gotoPage(\'todo\', TODO_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/todo.svg> <span translate=Todo></span> </a><a class=extra-menu><img class=nav-menu-icon src=/assets/navbar_icons/edit.svg> <span translate="">&nbsp;</span> </a><a class=extra-menu data-ng-click="gotoPage(\'typeWritterRichTextGrid\', NOTE_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/typer.svg> <span translate=TypeR></span> </a><a class=extra-menu data-ng-click="gotoPage(\'typeWritterSpreadSheetGrid\', NOTE_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/spreads.svg> <span translate=SpeadS></span></a></div></div></ul></li></div><!-- <div class="dropdown">\n      <button ng-show="!selectedProjectName" class="dropdown-toggle place-holder ft_12_regular_gray" type="button" data-toggle="dropdown" translate="Select Project"></button>\n      <button ng-show="selectedProjectName"  tooltip-placement="bottom-left" tooltip-class="customClass" class="dropdown-toggle sel-project ft_12_regular_black" type="button" id="menu_main_nav" data-toggle="dropdown">{{selectedProjectName}}</button>\n      <ul class="dropdown-menu menu_main_nav" role="menu" aria-labelledby="menu_main_nav">\n        <li>\n          <a href="#" tooltip-enable="{{item.showTooltip}}" tooltip-placement="bottom-left" uib-tooltip="{{item.projectName}}"\n            tooltip-class="customClass" class="menu-item ft_12_regular_gray" [ngClass]="{\'highlight-menu-item\': item._id == \'others\'}" id="{{item._id}}" data-ng-click="selectedProject(item)"\n            ng-repeat="item in bookmarkedProjectList">{{item.projectName}}\n          </a>\n        </li>\n        <li>\n          <a href="#" class="menu-item ft_12_regular_gray highlight-menu-item" id="others" data-ng-click="selectedOtherProject()" translate="Show Other Projects"></a>\n        </li>\n        <li><a href="#" class="menu-item" ng-if="!bookmarkedProjectList" translate="No Data"></a></li>\n      </ul>\n    </div> --><!-- <div class="country">\n      <selectbox-input\n          ng-model="selectedProjectName"\n          options="activeProjectList"\n          label-field="projectName"\n          value-field="projectName"\n          select-event="changeProject(selectedProjectName)">\n      </selectbox-input>\n    </div> --><div class=search-box><img class=search-box-icon src=/assets/navbar_icons/search.svg><!-- <input type="text" placeholder="Eastwood Residences"/> --><div class=dropdown><button ng-show=!selectedProjectName class="dropdown-toggle sel-project ft_12_regular_gray" type=button data-toggle=dropdown translate="Select Project"></button> <button ng-show=selectedProjectName tooltip-placement=bottom-left tooltip-class=customClass class="dropdown-toggle sel-project ft_12_regular_black" type=button id=menu_main_nav data-toggle=dropdown>{{selectedProjectName}}</button><div class=dropdown-menu><div class=arrow-up></div><ul class=sel-project-dropdown role=menu aria-labelledby=menu_main_nav><li><input class=sel-project-search placeholder=Search></li><li ng-repeat="item in bookmarkedProjectList"><a href=# tooltip-enable={{item.showTooltip}} tooltip-placement=bottom-left uib-tooltip={{item.projectName}} tooltip-class=customClass class=sel-project-item [ngclass]="{\'highlight-menu-item\': item._id == \'others\'}" id={{item._id}} data-ng-click=selectedProject(item)>{{item.projectName}}</a></li><li><a href=# class="sel-project-item highlight-menu-item" id=others data-ng-click=selectedOtherProject() translate="Show Other Projects"></a></li><li ng-if=!bookmarkedProjectList><a href=# class=sel-project-item translate="No Data"></a></li></ul></div></div><div class="dropdown dropdown-bubble search-box-more"><a id=dLabel class="nav-link extrl-ul-link" href=# data-toggle=dropdown aria-haspopup=true aria-expanded=false><img src=/assets/navbar_icons/searchmore.svg></a><ul class="extrl-ul-more dropdown-menu" aria-labelledby=dLabel><li><a class=dropdown-item data-ng-click="gotoPage(\'createProject\', ECO_ACCESS_CREATE > 0, true)" translate="Create Project"></a></li><li><a class=dropdown-item data-ng-click=goToUpdateProject() translate="Edit Project"></a></li></ul></div><!-- <div class="nav-items mr-auto search-box-more">\n        <li class="nav-item">\n          <a class="nav-link extrl-ul-link" href="#">\n            <img src="/assets/navbar_icons/searchmore.svg" />\n          </a>\n          <ul class="extrl-ul-more">\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'createProject\', ECO_ACCESS_CREATE > 0, true)"\n                translate="Create Project"></a></li>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'createProject\', ECO_ACCESS_CREATE > 0, true)"\n                translate="Edit Project"></a></li>\n          </ul>\n        </li>\n      </div> --></div><div class="share-button mr-10" translate=Share></div><div class=side-button ng-click=showSynergy() ng-class="{active: isShowSynergy}"><img src=/assets/navbar_icons/synergy.svg alt=synergy><!-- <div class="icon-badge" ng-if="drawingCount > 0"></div> --></div><div class=side-button ng-click=showDrawing() ng-class="{active: isShowDrawing}"><img src=/assets/navbar_icons/Inbox.svg alt=approve><div class=icon-badge ng-if="drawingCount > 0"></div></div><div class=side-button ng-click=showBill() ng-class="{active: isShowBill}"><img src=/assets/navbar_icons/wallet-money.svg alt=bill><div class=icon-badge ng-if="billCount > 0"></div></div><div class=side-button ng-click=showInvoice() ng-class="{active: isShowInvoice}"><img src=/assets/navbar_icons/Cart.svg alt=bucket><div class=icon-badge ng-if="invoiceCount > 0"></div></div><div class=side-button ng-click=showNotification() ng-class="{active: isShowNotification}"><img src=/assets/navbar_icons/Notification.svg alt=icon class=bell-icon><div class=icon-badge ng-if="notificationCount > 0"></div></div><div class="dropdown user-menu"><button id=user-menu-button class=dropdown-toggle data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="pos-relative inline-block"><img ng-src="{{ profilePic || \'/assets/icons/bx-user.svg\'}}" alt=logo class="avatar-logo object-fit-cover"><div class=status-circle ng-class=statusClass()></div></div></button><ul class=dropdown-menu aria-labelledby=user-menu-button><div class=dropdown-item-avatar><img ng-src="{{ profilePic || \'/assets/icons/bx-user.svg\'}}" alt=logo class="dropdown-avatar-logo object-fit-cover"><div><div class="ft_14_600_white tx-ellipsis avatar-label" title={{userName}}>{{userName}}</div><div class="ft_12_regular_white tx-ellipsis avatar-label" title={{email}}>{{email}}</div></div></div><li class="dropdown-item ft_14_regular_white" ng-click=toggleEditProfile()><img src=/assets/icons/edit_white.svg class=avatar-menu-icon alt=profile> <span translate="Edit My Details"></span></li><li class="dropdown-item ft_14_regular_white" ng-click=toggleUpdateStatus()><img src=/assets/icons/build_circle_white.svg class=avatar-menu-icon alt=status> <span translate="Update My Status"></span></li><li class="dropdown-item ft_14_regular_white" ng-click="gotoPage(\'settings\', SETTING_ACCESS_CREATE > 0, true)"><img src=assets/images/dashboard/bx-cog-white.svg class=avatar-menu-icon alt=setting> <span translate=Settings></span></li><li class="dropdown-item ft_14_regular_white" ng-click=toggleHelp()><img src=/assets/icons/help_circle_white.svg class=avatar-menu-icon alt=help> <span translate=Help></span></li><li class="dropdown-item ft_14_regular_white border-top" ng-click=logout()><img src=assets/images/dashboard/log-out-white.svg class=avatar-menu-icon alt=logout> <span translate="Sign Out"></span></li></ul></div></div></div><script>$(document).ready(function () {\n    document.body.scrollTop = document.documentElement.scrollTop = 0;\n  });</script>');
$templateCache.put('app/core/directives/main-navbar/main-navbar1.view.html','<div class=main-nav-bar><div class="nav-items mr-auto" ng-if="userData.designation == \'Admin\'"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/dashboard.svg> <span translate=Dashboard></span> <img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li><a class="dropdown-item flex-between"><span translate=Finance></span><div class=menu-icon></div></a><ul><div class=dropdown-row><div class=arrow-left></div><div class=dropdown-content><li><a class=dropdown-item data-ng-click="gotoPage(\'financeDashboard\', ECO_ACCESS_CREATE > 0, true)" translate=Dashboard></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeBankDetail\', ECO_ACCESS_CREATE > 0, true)" translate=Bank></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeSales\', ECO_ACCESS_CREATE > 0, true)" translate=Sales></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financePurchases\', ECO_ACCESS_CREATE > 0, true)" translate=Purchases></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeVatReports\', ECO_ACCESS_CREATE > 0, true)" translate=Reports></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeFinance\', ECO_ACCESS_CREATE > 0, true)" translate=Finance></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeBalance\', ECO_ACCESS_CREATE > 0, true)" translate=Balance></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeVatSettings\', ECO_ACCESS_CREATE > 0, true)" translate="VAT Settings"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeScript\', ECO_ACCESS_CREATE > 0, true)" translate=Script></a></li></div></div></ul></li><li><a class=dropdown-item data-ng-click="gotoPage(\'auditManage\', dashboardType == 6, true)" translate="Audit Management"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'bidManage\', dashboardType == 1 || dashboardType == 5, true)" translate="Bid & Tender"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcMain\', ECO_ACCESS_CREATE > 0, true)" translate="Estimate & Sales"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'projectDesign\', dashboardType == 0, true)" translate="Project Design"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'productionsBoard\', dashboardType == 0, true)" translate="Project Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'siteManage1\', dashboardType == 2, true)" translate="Site Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'qsheManage\', dashboardType == 3, true)" translate="QSHE Manager"></a></li><li><a class="dropdown-item flex-between"><span translate="Client & Collaborator"></span><div class=menu-icon></div></a><ul><div class=dropdown-row><div class=arrow-left></div><div class=dropdown-content><li><a class=dropdown-item data-ng-click="gotoPage(\'clientManage\', dashboardType == 200, true)" translate=Client></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'supplierManage\', dashboardType == 300, true)" translate=Supplier></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'subContractorManage\', dashboardType == 400, true)" translate=Sub-Contractor></a></li></div></div></ul></li></div></ul></li><!-- ECONOMIC --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/economy.svg><span translate=Economic></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li><a class=dropdown-item data-ng-click="gotoPage(\'economicManage\', ECO_ACCESS_CREATE > 0, true)" translate=Dashboard></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'invoiceList\', ECO_ACCESS_CREATE > 0, true)"><span translate=Invoice></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'billList\', ECO_ACCESS_CREATE > 0, true)"><span translate="Bill Approval"></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'vaOrderList\', ECO_ACCESS_CREATE > 0, true)"><span translate="VA Orders"></span></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'payroll\', ECO_ACCESS_CREATE > 0)" translate=Payroll></a></li></div></ul></li><!-- VISUAL & TIME --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/timeline1.svg><span translate=Timeline></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'vpGrid\', VP_ACCESS_CREATE > 0)"><span translate="Visual Planner"></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'bimGrid\', DVIEWER_ACCESS_CREATE > 0)"><span translate="Dynamic 3D"></span></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'pcdGrid\', PCD_ACCESS_CREATE > 0)" translate="Point Cloud"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'photoGrid\', PHOTO_ACCESS_CREATE > 0)" translate="360 Degree Photo"></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'timeline\', TIMELINE_ACCESS_CREATE > 0, true)" translate=Timeline></a></li></div></ul></li><!-- CALCULATION --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/calculation1.svg><span translate=Calculation></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li><a class=dropdown-item data-ng-click="gotoPage(\'calcExtra\', true)" translate="Create Main Estimate"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcMain\', CALC_ACCESS_CREATE > 0)" translate="Create Part Estimate"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcVersions\', CALC_ACCESS_CREATE > 0)" translate=Versions></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'budget\', BUDGET_ACCESS_CREATE > 0, true)" translate=Budget></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'companyBudget\', BUDGET_ACCESS_CREATE > 0)" translate="Company Budget"></a></li></div></ul></li><!-- QSHE --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/qshe1.svg><span translate=QSHE></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><div class=arrow-up></div><div class=dropdown-content><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'tqList\', TQ_ACCESS_CREATE > 0)"><span translate=TQ></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'issuesList\', ISSUE_ACCESS_CREATE > 0)"><span translate=Issues></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><span translate=Report></span></a></li></div></ul></li><!-- MORE --><li class="nav-item dropdown" style="z-index: 1000;"><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/more.svg><span translate=More></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul class=more-list><div class=arrow-up></div><div class=dropdown-content><li><a class=dropdown-item data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0)" translate="File Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'bidPackages\', TEAM_ACCESS_CREATE > 0)" translate="Project Collaboration"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'offerList\', OFFER_ACCESS_CREATE > 0, true)" translate="Sales Offers"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'managersGrid\', MANAGE_ACCESS_CREATE > 0, true)" translate=Managers></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'clientsGrid\', CLIENT_ACCESS_CREATE > 0, true)" translate=Clients></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'suppliersGrid\', SUPPLIER_ACCESS_CREATE > 0, true)" translate=Supplier></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'subContractorsGrid\', SUBCONTRACTOR_ACCESS_CREATE > 0, true)" translate=Sub-Contractor></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'employees\', EMPLOYEE_ACCESS_CREATE > 0, true)" translate=Employees></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'materialList\', MAT_ACCESS_CREATE > 0, true)" translate=Materials></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'equipmentList\', EQ_ACCESS_CREATE > 0, true)" translate=Equipments></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'controlPlanGrid\', CPLAN_ACCESS_CREATE > 0, true)" translate=Controlplan></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'checkList\', CHKLIST_ACCESS_CREATE > 0, true)" translate=Checklist></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'settings\', SETTING_ACCESS_CREATE > 0, true)" translate="Company Settings"></a></li></div></ul></li></div><div class="nav-items mr-auto" ng-if="userData.designation == \'BidManager\'"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/dashboard.svg><span translate=Dashboard></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'bidManage\', dashboardType == 1 || dashboardType == 5, true)" translate="Bid & Tender"></a></li></ul></li><!-- VISUAL & TIME --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/visualtimeline.svg><span translate="Visual & Time"></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'vpGrid\', VP_ACCESS_CREATE > 0)"><span translate="Visual Planner"></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'bimGrid\', DVIEWER_ACCESS_CREATE > 0)"><span translate="Dynamic 3D"></span></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'pcdGrid\', PCD_ACCESS_CREATE > 0)" translate="Point Cloud"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'photoGrid\', PHOTO_ACCESS_CREATE > 0)" translate="360 Degree Photo"></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'timeline\', TIMELINE_ACCESS_CREATE > 0, true)" translate=Timeline></a></li></ul></li><!-- CALCULATION --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/calculation.svg><span translate=Calculation></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'calcExtra\', true)" translate="Create Main Estimate"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcMain\', CALC_ACCESS_CREATE > 0)" translate="Create Part Estimate"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcVersions\', CALC_ACCESS_CREATE > 0)" translate=Versions></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'budget\', BUDGET_ACCESS_CREATE > 0, true)" translate=Budget></a></li></ul></li><!-- QSHE --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/qshe.svg><span translate=QSHE></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'tqList\', TQ_ACCESS_CREATE > 0)"><span translate=TQ></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'issuesList\', ISSUE_ACCESS_CREATE > 0)"><span translate=Issues></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><span translate=Report></span></a></li></ul></li><!-- MORE --><li class="nav-item dropdown" style="z-index: 1000;"><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/more.svg><span translate=More></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul class=more-list><li><a class=dropdown-item data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0)" translate="File Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'bidPackages\', TEAM_ACCESS_CREATE > 0)" translate=Collaboration></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'subContractorsGrid\', SUBCONTRACTOR_ACCESS_CREATE > 0, true)" translate=Sub-Contractor></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'suppliersGrid\', SUPPLIER_ACCESS_CREATE > 0, true)" translate=Supplier></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'materialList\', MAT_ACCESS_CREATE > 0, true)" translate=Materials></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'equipmentList\', EQ_ACCESS_CREATE > 0, true)" translate=Equipments></a></li></ul></li></div><div class="nav-items mr-auto" ng-if="userData.designation == \'Subcontractor\'"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/dashboard.svg><span translate=Dashboard></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'vaOrderList\', ECO_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/vaorders.svg> <span translate="VA Orders"></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'timeline\', TIMELINE_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/timeline.svg> <span translate=Timeline></span></a></li><!-- QSHE --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/qshe.svg><span translate=QSHE></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'tqList\', TQ_ACCESS_CREATE > 0)"><span translate=TQ></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'issuesList\', ISSUE_ACCESS_CREATE > 0)"><span translate=Issues></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><span translate=Report></span></a></li></ul></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/filemanager.svg> <span translate="File Manager"></span></a></li></div><div class="nav-items mr-auto" ng-if="userData.designation == \'ProjectManager\'"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/dashboard.svg><span translate=Dashboard></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'productionsBoard\', dashboardType == 0, true)" translate="Project Manager"></a></li></ul></li><!-- ECONOMIC --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/economic.svg><span translate=Economic></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'economicManage\', ECO_ACCESS_CREATE > 0, true)" translate=Dashboard></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'invoiceList\', ECO_ACCESS_CREATE > 0, true)"><span translate=Invoice></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'billList\', ECO_ACCESS_CREATE > 0, true)"><span translate="Bill Approval"></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'vaOrderList\', ECO_ACCESS_CREATE > 0, true)"><span translate="VA Orders"></span></a></li></ul></li><!-- VISUAL & TIME --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/visualtimeline.svg><span translate="Visual & Time"></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'vpGrid\', VP_ACCESS_CREATE > 0)"><span translate="Visual Planner"></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'bimGrid\', DVIEWER_ACCESS_CREATE > 0)"><span translate="Dynamic 3D"></span></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'pcdGrid\', PCD_ACCESS_CREATE > 0)" translate="Point Cloud"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'photoGrid\', PHOTO_ACCESS_CREATE > 0)" translate="360 Degree Photo"></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'timeline\', TIMELINE_ACCESS_CREATE > 0, true)" translate=Timeline></a></li></ul></li><!-- CALCULATION --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/calculation.svg><span translate=Calculation></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'calcExtra\', true)" translate="Create Main Estimate"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcMain\', CALC_ACCESS_CREATE > 0)" translate="Create Part Estimate"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcVersions\', CALC_ACCESS_CREATE > 0)" translate=Versions></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'budget\', BUDGET_ACCESS_CREATE > 0, true)" translate="Project Budget"></a></li></ul></li><!-- QSHE --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/qshe.svg><span translate=QSHE></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'tqList\', TQ_ACCESS_CREATE > 0)"><span translate=TQ></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'issuesList\', ISSUE_ACCESS_CREATE > 0)"><span translate=Issues></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><span translate=Report></span></a></li></ul></li><!-- MORE --><li class="nav-item dropdown" style="z-index: 1000;"><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/more.svg><span translate=More></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul class=more-list><li><a class=dropdown-item data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0)" translate="File Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'bidPackages\', TEAM_ACCESS_CREATE > 0)" translate="Project Collaboration"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'subContractorsGrid\', SUBCONTRACTOR_ACCESS_CREATE > 0, true)" translate=Sub-Contractor></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'suppliersGrid\', SUPPLIER_ACCESS_CREATE > 0, true)" translate=Suppliers></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'materialList\', MAT_ACCESS_CREATE > 0, true)" translate=Materials></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'equipmentList\', EQ_ACCESS_CREATE > 0, true)" translate=Equipments></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'controlPlanGrid\', CPLAN_ACCESS_CREATE > 0, true)" translate=Controlplans></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'checkList\', CHKLIST_ACCESS_CREATE > 0, true)" translate=Checklists></a></li></ul></li></div><div class="nav-items mr-auto" ng-if="userData.designation == \'AuditManager\'"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/dashboard.svg><span translate=Dashboard></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'auditManage\', dashboardType == 6, true)" translate="Audit Management"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcMain\', ECO_ACCESS_CREATE > 0, true)" translate="Estimate & Sales"></a></li></ul></li><!-- ECONOMIC --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/economic.svg><span translate=Economic></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'economicManage\', ECO_ACCESS_CREATE > 0, true)" translate=Dashboard></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'invoiceList\', ECO_ACCESS_CREATE > 0, true)"><span translate=Invoice></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'billList\', ECO_ACCESS_CREATE > 0, true)"><span translate="Bill Approval"></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'vaOrderList\', ECO_ACCESS_CREATE > 0, true)"><span translate="VA Orders"></span></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'payroll\', ECO_ACCESS_CREATE > 0)" translate=Payroll></a></li></ul></li><!-- VISUAL & TIME --><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'timeline\', TIMELINE_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/visualtimeline.svg> <span translate=Timeline></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'companyBudget\', BUDGET_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/calculation.svg> <span translate=Budget></span></a></li><!-- QSHE --><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/qshe.svg> <span translate=Report></span></a></li><!-- MORE --><li class="nav-item dropdown" style="z-index: 1000;"><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/more.svg><span translate=More></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul class=more-list><li><a class=dropdown-item data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0)" translate="File Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'employees\', EMPLOYEE_ACCESS_CREATE > 0, true)" translate=Employees></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'subContractorsGrid\', SUBCONTRACTOR_ACCESS_CREATE > 0, true)" translate=Sub-Contractor></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'suppliersGrid\', SUPPLIER_ACCESS_CREATE > 0, true)" translate=Suppliers></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'materialList\', MAT_ACCESS_CREATE > 0, true)" translate=Materials></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'equipmentList\', EQ_ACCESS_CREATE > 0, true)" translate=Equipments></a></li></ul></li></div><div class="nav-items mr-auto" ng-if="userData.designation == \'QSHE\'"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/dashboard.svg><span translate=Dashboard></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'timeline\', TIMELINE_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/visualtimeline.svg> <span translate=Timeline></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'tqList\', TQ_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/tq.svg> <span translate=TQ></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'issuesList\', ISSUE_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/issues.svg> <span translate=Issues></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/report.svg> <span translate=Report></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/filemanager.svg> <span translate="File Manager"></span></a></li><!-- MORE --><li class="nav-item dropdown" style="z-index: 1000;"><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/more.svg><span translate=More></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul class=more-list><li><a class=dropdown-item data-ng-click="gotoPage(\'controlPlanGrid\', CPLAN_ACCESS_CREATE > 0, true)" translate=Controlplan></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'checkList\', CHKLIST_ACCESS_CREATE > 0, true)" translate=Checklist></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'employees\', EMPLOYEE_ACCESS_CREATE > 0, true)" translate=Employees></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'subContractorsGrid\', SUBCONTRACTOR_ACCESS_CREATE > 0, true)" translate=Sub-Contractor></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'suppliersGrid\', SUPPLIER_ACCESS_CREATE > 0, true)" translate=Supplier></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'materialList\', MAT_ACCESS_CREATE > 0, true)" translate=Materials></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'equipmentList\', EQ_ACCESS_CREATE > 0, true)" translate=Equipments></a></li></ul></li></div><div class="nav-items mr-auto" ng-if="userData.designation == \'Supplier\'"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/dashboard.svg><span translate=Dashboard></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'timeline\', TIMELINE_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/visualtimeline.svg> <span translate=Timeline></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'tqList\', TQ_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/tq.svg> <span translate=TQ></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'issuesList\', ISSUE_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/issues.svg> <span translate=Issues></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/report.svg> <span translate=Report></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/filemanager.svg> <span translate="File Manager"></span></a></li></div><div class="nav-items mr-auto" ng-if="userData.designation == \'EcoManager\'"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/dashboard.svg><span translate=Dashboard></span></a></li><!-- ECONOMIC --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/economic.svg><span translate=Economic></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'economicManage\', ECO_ACCESS_CREATE > 0, true)" translate=Dashboard></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'invoiceList\', ECO_ACCESS_CREATE > 0, true)"><span translate=Invoice></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'billList\', ECO_ACCESS_CREATE > 0, true)"><span translate="Bill Approval"></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'vaOrderList\', ECO_ACCESS_CREATE > 0, true)"><span translate="VA Orders"></span></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'payroll\', ECO_ACCESS_CREATE > 0)" translate=Payroll></a></li></ul></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'timeline\', TIMELINE_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/visualtimeline.svg> <span translate=Timeline></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'budget\', BUDGET_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/calculation.svg> <span translate=Budget></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'companyBudget\', BUDGET_ACCESS_CREATE > 0)" translate="Company Budget"></a></li></ul></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/report.svg> <span translate=Report></span></a></li><!-- MORE --><li class="nav-item dropdown" style="z-index: 1000;"><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/more.svg><span translate=More></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul class=more-list><li><a class=dropdown-item data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0)" translate="File Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'employees\', EMPLOYEE_ACCESS_CREATE > 0, true)" translate=Employees></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'offerList\', OFFER_ACCESS_CREATE > 0, true)" translate="Sales Offers"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'salesProducts\', STOCK_ACCESS_CREATE > 0, true)" translate="Warehouses & Orders"></a></li></ul></li></div><div class="nav-items mr-auto" ng-if="userData.designation == \'Client\'"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/dashboard.svg><span translate=Dashboard></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'vaOrderList\', ECO_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/vaorders.svg> <span translate="VA Orders"></span></a></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'timeline\', TIMELINE_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/timeline.svg> <span translate=Timeline></span></a></li><!-- QSHE --><li class=nav-item><a class=nav-link href=#><img class=nav-menu-icon src=/assets/navbar_icons/qshe.svg><span translate=QSHE></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'tqList\', TQ_ACCESS_CREATE > 0)"><span translate=TQ></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'issuesList\', ISSUE_ACCESS_CREATE > 0)"><span translate=Issues></span></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><span translate=Report></span></a></li></ul></li><li class=nav-item><a class=nav-link data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0)"><img class=nav-menu-icon src=/assets/navbar_icons/filemanager.svg> <span translate="File Manager"></span></a></li></div><div class="nav-items mr-auto" ng-if="false && (dashboardType != 5 && dashboardType != 200 && !type)"><!-- DASHBOARD --><li class=nav-item><a class=nav-link href=#><span translate=Dashboard></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between"><span translate=Finance></span><div class=menu-icon></div></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'financeDashboard\', ECO_ACCESS_CREATE > 0, true)" translate=Dashboard></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeBankDetail\', ECO_ACCESS_CREATE > 0, true)" translate=Bank></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeSales\', ECO_ACCESS_CREATE > 0, true)" translate=Sales></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financePurchases\', ECO_ACCESS_CREATE > 0, true)" translate=Purchases></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeVatReports\', ECO_ACCESS_CREATE > 0, true)" translate=Reports></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeFinance\', ECO_ACCESS_CREATE > 0, true)" translate=Finance></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeBalance\', ECO_ACCESS_CREATE > 0, true)" translate=Balance></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeVatSettings\', ECO_ACCESS_CREATE > 0, true)" translate="VAT Settings"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'financeScript\', ECO_ACCESS_CREATE > 0, true)" translate=Script></a></li></ul></li><li><a class=dropdown-item data-ng-click="gotoPage(\'auditManage\', dashboardType == 6, true)" translate="Audit Management"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'bidManage\', dashboardType == 1 || dashboardType == 5, true)" translate="Bid & Tender"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcMain\', ECO_ACCESS_CREATE > 0, true)" translate="Estimate & Sales"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'projectDesign\', dashboardType == 0, true)" translate="Project Design"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'productionsBoard\', dashboardType == 0, true)" translate="Project Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'siteManage1\', dashboardType == 2, true)" translate="Site Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'qsheManage\', dashboardType == 3, true)" translate="QSHE Manager"></a></li><li><a class="dropdown-item flex-between"><span translate="Client & Collaborator"></span><div class=menu-icon></div></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'clientManage\', dashboardType == 200, true)" translate=Client></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'supplierManage\', dashboardType == 300, true)" translate=Supplier></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'subContractorManage\', dashboardType == 400, true)" translate=Sub-Contractor></a></li></ul></li></ul></li><!-- PROJECT --><li class=nav-item><a class=nav-link href=#><span translate=Project></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between"><span translate=Create></span><div class=menu-icon></div></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'createProject\', ECO_ACCESS_CREATE > 0, true)" translate=Project></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'createServiceProject\', ECO_ACCESS_CREATE > 0, true)" translate="Service project"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'workOrderList\', ECO_ACCESS_CREATE > 0, true)" translate="Work Order"></a></li></ul></li><li><a class=dropdown-item data-ng-click="gotoPage(\'projectList\', true , true)" translate="Project Overview"></a></li></ul></li><!-- ECONOMIC --><li class=nav-item><a class=nav-link href=#><span translate="Project Economic"></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'economicManage\', ECO_ACCESS_CREATE > 0, true)" translate=Dashboard></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'invoiceList\', ECO_ACCESS_CREATE > 0, true)"><span translate=Invoice></span><!-- <div class="menu-icon"></div> --> </a><!-- <ul>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'createInvoice\', ECO_ACCESS_CREATE > 2, true)" translate="Create Invoice"></a></li>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'invoiceList\', ECO_ACCESS_CREATE > 0, true)" translate="Invoice List"></a></li>\n          </ul> --></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'billList\', ECO_ACCESS_CREATE > 0, true)"><span translate="Bill Approval"></span><!-- <div class="menu-icon"></div> --> </a><!-- <ul>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'approveBill\', ECO_ACCESS_CREATE > 2, true)" translate="Billing Scanner"></a></li>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'billList\', ECO_ACCESS_CREATE > 0, true)" translate="Billing List"></a></li>\n          </ul> --></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'vaOrderList\', ECO_ACCESS_CREATE > 0, true)"><span translate="VA Orders"></span><!-- <div class="menu-icon"></div> --> </a><!-- <ul>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'createVaOrder\', ECO_ACCESS_CREATE > 2)" translate="Create VA Order"></a></li>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'vaOrderList\', ECO_ACCESS_CREATE > 0, true)" translate="VA Order List"></a></li>\n          </ul> --></li><li><a class=dropdown-item data-ng-click="gotoPage(\'payroll\', ECO_ACCESS_CREATE > 0)" translate=Payroll></a></li></ul></li><!-- CALCULATION --><li class=nav-item><a class=nav-link href=#><span translate=Calculation></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between"><span translate=Calculations></span><div class=menu-icon></div></a><ul><li><a class=dropdown-item data-ng-click="gotoPage(\'calcExtra\', true)" translate="Main Estimate"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcMain\', CALC_ACCESS_CREATE > 0)" translate="Part Estimate"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calcVersions\', CALC_ACCESS_CREATE > 0)" translate=Versions></a></li></ul></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'budget\', BUDGET_ACCESS_CREATE > 0, true)" translate=Budget></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'companyBudget\', BUDGET_ACCESS_CREATE > 0)" translate="Company Budget"></a></li></ul></li><!-- VISUAL & TIME --><li class=nav-item><a class=nav-link href=#><span translate="Visual & Time"></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'vpGrid\', VP_ACCESS_CREATE > 0)"><span translate="Visual Planner"></span><!-- <div class="menu-icon"></div> --> </a><!-- <ul>\n            <li><a class="dropdown-item" data-ng-click="addNewPlan()" translate="New Plan"></a></li>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'vpGrid\', VP_ACCESS_CREATE > 0)" translate="File Picker"></a></li>\n          </ul> --></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'bimGrid\', DVIEWER_ACCESS_CREATE > 0)"><span translate="Dynamic 3D"></span><!-- <div class="menu-icon"></div> --> </a><!-- <ul>\n            <li><a class="dropdown-item" data-ng-click="openDlgUpload()" translate="New Model"></a></li>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'bimGrid\', DVIEWER_ACCESS_CREATE > 0)" translate="File Picker"></a></li>\n          </ul> --></li><li><a class=dropdown-item data-ng-click="gotoPage(\'pcdGrid\', PCD_ACCESS_CREATE > 0)" translate="Point Cloud"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'photoGrid\', PHOTO_ACCESS_CREATE > 0)" translate="360 Degree Photo"></a></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'timeline\', TIMELINE_ACCESS_CREATE > 0, true)" translate=Timeline></a></li></ul></li><!-- QSHE --><li class=nav-item><a class=nav-link href=#><span translate=QSHE></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'tqList\', TQ_ACCESS_CREATE > 0)"><span translate=TQ></span><!-- <div class="menu-icon"></div> --> </a><!-- <ul>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'createTq\', TQ_ACCESS_CREATE > 2)" translate="Create TQ"></a></li>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'tqList\', TQ_ACCESS_CREATE > 0)" translate="TQ Overview"></a></li>\n          </ul> --></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'issuesList\', ISSUE_ACCESS_CREATE > 0)"><span translate=Issues></span><!-- <div class="menu-icon"></div> --> </a><!-- <ul>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'createIssue\', ISSUE_ACCESS_CREATE > 2)" translate="Create Issue"></a></li>\n            <li><a class="dropdown-item">Create Project Request</a></li>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'issuesList\', ISSUE_ACCESS_CREATE > 0)" translate="QSHE Overview"></a></li>\n          </ul> --></li><li><a class="dropdown-item flex-between" data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><span translate=Report></span><!-- <div class="menu-icon"></div> --> </a><!-- <ul>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'createReports\', REPORT_ACCESS_CREATE > 2)" translate="Create Report"></a></li>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)" translate="Reports Overview"></a></li>\n          </ul> --></li></ul></li><!-- MORE --><li class="nav-item dropdown" style="z-index: 1000;"><a class=nav-link href=#><span translate=More></span><img class=nav-arrow src=/assets/icons/chevron-down-white.svg alt=down></a><ul class=more-list><li><a class=dropdown-item data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0)" translate="File Manager"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'synergies\', TEAM_ACCESS_CREATE > 0, true)" translate=Synergy.surf></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'bidPackages\', TEAM_ACCESS_CREATE > 0)" translate="Project Collaboration"></a></li><li><a class=dropdown-item href=/mail target=_blank translate=Mail></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'clientsGrid\', CLIENT_ACCESS_CREATE > 0, true)" translate=Clients></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'employees\', EMPLOYEE_ACCESS_CREATE > 0, true)" translate=Employees></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'subContractorsGrid\', SUBCONTRACTOR_ACCESS_CREATE > 0, true)" translate=Sub-Contractor></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'suppliersGrid\', SUPPLIER_ACCESS_CREATE > 0, true)" translate=Supplier></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'materialList\', MAT_ACCESS_CREATE > 0, true)" translate=Materials></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'equipmentList\', EQ_ACCESS_CREATE > 0, true)" translate=Equipments></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'controlPlanGrid\', CPLAN_ACCESS_CREATE > 0, true)" translate=Controlplan></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'checkList\', CHKLIST_ACCESS_CREATE > 0, true)" translate=Checklist></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'offerList\', OFFER_ACCESS_CREATE > 0, true)" translate="Sales Offers"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'salesProducts\', STOCK_ACCESS_CREATE > 0, true)" translate="Warehouses & Orders"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'typeWritterRichTextGrid\', NOTE_ACCESS_CREATE > 0, true)" translate=Typewriter></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'typeWritterSpreadSheetGrid\', NOTE_ACCESS_CREATE > 0, true)" translate=SpreadSheet></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'calendar\', CALENDAR_ACCESS_CREATE > 0, true)" translate=Calendar></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'todo\', TODO_ACCESS_CREATE > 0, true)" translate="To Do"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'settings\', SETTING_ACCESS_CREATE > 0, true)" translate="Company Settings"></a></li></ul></li></div><!-- CEO --><div class="nav-items mr-auto" ng-if="false && (dashboardType == 5 || type == \'ceo\')"><li class=nav-item ng-class="{active: isInPage(\'ceo\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'ceo\', true, true)" translate=Overview></a></li><li class=nav-item ng-class="{active: isInPage(\'ceoEconomics\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'ceoEconomics\', true, true)" translate="Global Economics"></a></li><li class=nav-item ng-class="{active: isInPage(\'financeBalance\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'financeBalance\', true, false)" translate=Balance></a></li><li class=nav-item ng-class="{active: isInPage(\'synergies\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'synergies\', true, true)" translate=Synergy></a></li><li class=nav-item ng-class="{active: isInPage(\'todo\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'todo\', TODO_ACCESS_CREATE > 0, true)" translate="To Do"></a></li><li class=nav-item ng-class="{active: isInPage(\'fileManage\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0, true)" translate="File Manager"></a></li></div><!-- Client --><div class="nav-items mr-auto" ng-if="false && (dashboardType == 200 || type == \'client\')"><li class=nav-item ng-class="{active: isInPage(\'clientManage\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'clientManage\', true, true)" translate="Client Dashboard"></a></li><li class=nav-item ng-class="{active: isInPage(\'todo\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'todo\', TODO_ACCESS_CREATE > 0, true)" translate="To Do"></a></li><li class=nav-item ng-class="{active: isInPage(\'synergies\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'synergies\', true, true)" translate=Synergy></a></li><li class=nav-item ng-class="{active: isInPage(\'bimGrid\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'bimGrid\', true, false)" translate="3D Viewer"></a></li><li class=nav-item ng-class="{active: isInPage(\'vaOrderList\')}"><a class="nav-link no-arrow" data-ng-click="gotoPage(\'vaOrderList\', true, false)" translate="VA Orders"></a></li></div><div class=form-inline><div class="nav-items mr-auto"><li class=nav-item><a class="nav-link extrl-ul-link" href=#><img class=nav-menu-icon src=/assets/navbar_icons/Glyph.svg></a></li></div><div class="nav-items mr-auto"><li class=nav-item><a class="nav-link extrl-ul-link" href=#><img class=nav-menu-icon src=/assets/navbar_icons/extra.svg></a><ul class=extrl-ul><div class=arrow-up-right></div><div class=dropdown-content><div class=extra-menu-ul><a class=extra-menu href=/mail target=_blank style="color: white"><img class=nav-menu-icon src=/assets/navbar_icons/mail.svg> <span translate=Mail></span> </a><a class=extra-menu data-ng-click="gotoPage(\'calendar\', CALENDAR_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/calendar.svg> <span translate=Calendar></span> </a><a class=extra-menu><img class=nav-menu-icon src=/assets/navbar_icons/shiftplanner.svg> <span translate=Shiftplanner></span> </a><a class=extra-menu data-ng-click="gotoPage(\'todo\', TODO_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/todo.svg> <span translate=Todo></span> </a><a class=extra-menu><img class=nav-menu-icon src=/assets/navbar_icons/edit.svg> <span translate="">&nbsp;</span> </a><a class=extra-menu data-ng-click="gotoPage(\'typeWritterRichTextGrid\', NOTE_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/typer.svg> <span translate=TypeR></span> </a><a class=extra-menu data-ng-click="gotoPage(\'typeWritterSpreadSheetGrid\', NOTE_ACCESS_CREATE > 0, true)"><img class=nav-menu-icon src=/assets/navbar_icons/spreads.svg> <span translate=SpeadS></span></a></div></div></ul></li></div><!-- <div class="dropdown">\n      <button ng-show="!selectedProjectName" class="dropdown-toggle place-holder ft_12_regular_gray" type="button" data-toggle="dropdown" translate="Select Project"></button>\n      <button ng-show="selectedProjectName"  tooltip-placement="bottom-left" tooltip-class="customClass" class="dropdown-toggle sel-project ft_12_regular_black" type="button" id="menu_main_nav" data-toggle="dropdown">{{selectedProjectName}}</button>\n      <ul class="dropdown-menu menu_main_nav" role="menu" aria-labelledby="menu_main_nav">\n        <li>\n          <a href="#" tooltip-enable="{{item.showTooltip}}" tooltip-placement="bottom-left" uib-tooltip="{{item.projectName}}"\n            tooltip-class="customClass" class="menu-item ft_12_regular_gray" [ngClass]="{\'highlight-menu-item\': item._id == \'others\'}" id="{{item._id}}" data-ng-click="selectedProject(item)"\n            ng-repeat="item in bookmarkedProjectList">{{item.projectName}}\n          </a>\n        </li>\n        <li>\n          <a href="#" class="menu-item ft_12_regular_gray highlight-menu-item" id="others" data-ng-click="selectedOtherProject()" translate="Show Other Projects"></a>\n        </li>\n        <li><a href="#" class="menu-item" ng-if="!bookmarkedProjectList" translate="No Data"></a></li>\n      </ul>\n    </div> --><!-- <div class="country">\n      <selectbox-input\n          ng-model="selectedProjectName"\n          options="activeProjectList"\n          label-field="projectName"\n          value-field="projectName"\n          select-event="changeProject(selectedProjectName)">\n      </selectbox-input>\n    </div> --><div class=search-box><img class=search-box-icon src=/assets/navbar_icons/search.svg><!-- <input type="text" placeholder="Eastwood Residences"/> --><div class=dropdown><button ng-show=!selectedProjectName class="dropdown-toggle sel-project ft_12_regular_gray" type=button data-toggle=dropdown translate="Select Project"></button> <button ng-show=selectedProjectName tooltip-placement=bottom-left tooltip-class=customClass class="dropdown-toggle sel-project ft_12_regular_black" type=button id=menu_main_nav data-toggle=dropdown>{{selectedProjectName}}</button><div class=dropdown-menu><div class=arrow-up></div><ul class=sel-project-dropdown role=menu aria-labelledby=menu_main_nav><li><input class=sel-project-search placeholder=Search></li><li ng-repeat="item in bookmarkedProjectList"><a href=# tooltip-enable={{item.showTooltip}} tooltip-placement=bottom-left uib-tooltip={{item.projectName}} tooltip-class=customClass class=sel-project-item [ngclass]="{\'highlight-menu-item\': item._id == \'others\'}" id={{item._id}} data-ng-click=selectedProject(item)>{{item.projectName}}</a></li><li><a href=# class="sel-project-item highlight-menu-item" id=others data-ng-click=selectedOtherProject() translate="Show Other Projects"></a></li><li ng-if=!bookmarkedProjectList><a href=# class=sel-project-item translate="No Data"></a></li></ul></div></div><div class="dropdown dropdown-bubble search-box-more"><a id=dLabel class="nav-link extrl-ul-link" href=# data-toggle=dropdown aria-haspopup=true aria-expanded=false><img src=/assets/navbar_icons/searchmore.svg></a><ul class="extrl-ul-more dropdown-menu" aria-labelledby=dLabel><li><a class=dropdown-item data-ng-click="gotoPage(\'createProject\', ECO_ACCESS_CREATE > 0, true)" translate="Create Project"></a></li><li><a class=dropdown-item data-ng-click="gotoPage(\'createProject\', ECO_ACCESS_CREATE > 0, true)" translate="Edit Project"></a></li></ul></div><!-- <div class="nav-items mr-auto search-box-more">\n        <li class="nav-item">\n          <a class="nav-link extrl-ul-link" href="#">\n            <img src="/assets/navbar_icons/searchmore.svg" />\n          </a>\n          <ul class="extrl-ul-more">\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'createProject\', ECO_ACCESS_CREATE > 0, true)"\n                translate="Create Project"></a></li>\n            <li><a class="dropdown-item" data-ng-click="gotoPage(\'createProject\', ECO_ACCESS_CREATE > 0, true)"\n                translate="Edit Project"></a></li>\n          </ul>\n        </li>\n      </div> --></div><div class="share-button mr-10" translate=Share></div><div class=side-button><img src=/assets/navbar_icons/synergy.svg alt=synergy><!-- <div class="icon-badge" ng-if="drawingCount > 0"></div> --></div><div class=side-button ng-click=showDrawing() ng-class="{active: isShowDrawing}"><img src=/assets/navbar_icons/Inbox.svg alt=approve><div class=icon-badge ng-if="drawingCount > 0"></div></div><div class=side-button ng-click=showBill() ng-class="{active: isShowBill}"><img src=/assets/navbar_icons/wallet-money.svg alt=bill><div class=icon-badge ng-if="billCount > 0"></div></div><div class=side-button ng-click=showInvoice() ng-class="{active: isShowInvoice}"><img src=/assets/navbar_icons/Cart.svg alt=bucket><div class=icon-badge ng-if="invoiceCount > 0"></div></div><div class=side-button ng-click=showNotification() ng-class="{active: isShowNotification}"><img src=/assets/navbar_icons/Notification.svg alt=icon class=bell-icon><div class=icon-badge ng-if="notificationCount > 0"></div></div><div class="dropdown user-menu"><button id=user-menu-button class=dropdown-toggle data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="pos-relative inline-block"><img ng-src="{{ profilePic || \'/assets/icons/bx-user.svg\'}}" alt=logo class="avatar-logo object-fit-cover"><div class=status-circle ng-class=statusClass()></div></div></button><ul class=dropdown-menu aria-labelledby=user-menu-button><div class=dropdown-item-avatar><img ng-src="{{ profilePic || \'/assets/icons/bx-user.svg\'}}" alt=logo class="dropdown-avatar-logo object-fit-cover"><div><div class="ft_14_600_white tx-ellipsis avatar-label" title={{userName}}>{{userName}}</div><div class="ft_12_regular_white tx-ellipsis avatar-label" title={{email}}>{{email}}</div></div></div><li class="dropdown-item ft_14_regular_white" ng-click=toggleEditProfile()><img src=/assets/icons/edit-black-no-rect.svg class=avatar-menu-icon alt=profile> <span translate="Edit My Details"></span></li><li class="dropdown-item ft_14_regular_white" ng-click=toggleUpdateStatus()><img src=/assets/icons/build_circle.svg class=avatar-menu-icon alt=status> <span translate="Update My Status"></span></li><li class="dropdown-item ft_14_regular_white" ng-click="gotoPage(\'settings\', SETTING_ACCESS_CREATE > 0, true)"><img src=assets/images/dashboard/bx-cog.svg class=avatar-menu-icon alt=setting> <span translate=Settings></span></li><li class="dropdown-item ft_14_regular_white" ng-click=toggleHelp()><img src=/assets/icons/help_circle.svg class=avatar-menu-icon alt=help> <span translate=Help></span></li><li class="dropdown-item ft_14_regular_white border-top" ng-click=logout()><img src=assets/images/dashboard/log-out.svg class=avatar-menu-icon alt=logout> <span translate="Sign Out"></span></li></ul></div></div></div><script>$(document).ready(function () {\n    document.body.scrollTop = document.documentElement.scrollTop = 0;\n  });</script>');
$templateCache.put('app/core/directives/main-titlebar/main-titlebar.view.html','<div class=main-title-bar><div class=logo ng-click=goHome()><img src=/assets/icons/logo-small.svg alt=logo></div><div class=title ng-repeat="page in pages" ng-class="{active: curPage === page}" ng-click=selectPage(page)>{{ page.title }} <img src=/assets/icons/close-16-gray.svg class="close-btn ml-16" ng-click="closePage(page, $index)"></div><div class=plus ng-click=openPage()><img src=/assets/icons/plus-16-gray.svg alt=add></div><div class=controls><div class="search mr-10"><img src=/assets/navbar_icons/searchcontrol.svg alt=search> <input type=text placeholder=Search...></div><div class="control mr-10" ng-click=minimize()><img src=/assets/icons/minimize.svg alt=minimize></div><div class="control mr-10" ng-click=toggleFullscreen()><img ng-src="{{isFullscreen ? \'/assets/icons/fullscreen-exit.svg\' : \'/assets/icons/fullscreen-enter.svg\'}}" alt=maximize></div><div class="control mr-10" ng-click=closeWindow()><img src=/assets/icons/close-24-gray.svg alt=close></div></div></div>');
$templateCache.put('app/core/directives/no-data/no-data.html','<div class="no-data ft_24_600_gray">{{text || \'No Data to Display\'}}</div>');
$templateCache.put('app/core/directives/overtime-edit/overtime-edit.view.html','<div class=overtime-edit><div class=d-flex><div class=overtime-value-container ng-repeat="overtime in overtimeList track by $index"><div class=overtime-value-edit><input type=text class=overtime-input number-edit ng-model=overtime.timeVal ng-change=updateOvertime()> <input type=text class=overtime-input number-edit ng-model=overtime.percentVal ng-change=updateOvertime()></div><img src=/assets/icons/close-gray.svg alt="" ng-click=deleteOvertime($index)></div></div><img src=/assets/icons/plus-circle-orange.svg class=cursor-point alt="" ng-click=addOvertime() ng-if="overtimeList.length < 2"></div>');
$templateCache.put('app/core/directives/pagination-custom/pagination-custom.html','<div class="pagination flex"><button ng-class="{disabled: noPrevious()}" ng-click=selectPrevious()><a><img src=/assets/icons/left-arrow.svg alt=icons></a></button> <button ng-repeat="page in pages track by $index" ng-class="{active: isActive(page)}" ng-click=selectPage(page)><a>{{page}}</a></button> <button ng-class="{disabled: noNext()}" ng-click=selectNext()><a><img src=/assets/icons/right-arrow.svg alt=icons></a></button></div>');
$templateCache.put('app/core/directives/pagination-custom-new/pagination-custom-new.html','<div class="pagination-new flex"><button ng-class="{disabled: noPrevious()}" ng-click=selectPrevious()><a><img ng-style="{opacity: noPrevious()?0.6:1.0}" src=/assets/icons/chevron-left-20.svg alt=icons></a></button> <button ng-class="{disabled: noNext()}" ng-click=selectNext()><a><img ng-style="{opacity: noNext()?0.6:1.0}" src=/assets/icons/chevron-right-20.svg alt=icons></a></button></div>');
$templateCache.put('app/core/directives/quote-message/quote-message.view.html','<div class=quote-message ng-if=ngModel><div class="d-flex w-100"><img class=quote-icon src=/assets/icons/message_orange.svg alt=""><div class=message-content><div class=message-body>{{ngModel.body}}</div><div class=message-desc>{{getMessageDescription()}}</div></div></div><img class=close-icon src=/assets/icons/close-12-gray.svg alt="" ng-click=cancelQuote()></div>');
$templateCache.put('app/core/directives/radio/radio.html','<label class=custom-radio><input type=radio ng-model=ngModel ng-value=ngValue ng-disabled=ngDisabled> <span class=radio-checkmark ng-click=clickEvent()></span></label>');
$templateCache.put('app/core/directives/search-list/search-list.view.html','<ul class=search-list><li class=option ng-repeat="option in filteredOptions track by $index" ng-click=selectOption(option) ng-class="{active: option == selectedOption}">{{option}}</li></ul>');
$templateCache.put('app/core/directives/searchbox/searchbox.view.html','<div class="searchbox flex-between" ng-class=inputClass><span class=icon ng-if=isIcon><img src={{iconFile}} alt=Search></span><input type=text ng-class="{small: isSmall}" placeholder="{{(placeHolder || \'Search\') | translate}}" ng-model=searchText><!-- <img\n    src="/assets/icons/search-gray.svg"\n    alt="Search"\n    ng-class="{search_icon: true, small: isSmall}"> --></div>');
$templateCache.put('app/core/directives/selectbox/selectbox.view.html','<div class={{inputClass}}><div class="dropdown selectbox" ng-class="{\'noIcon\': noIcon, small: isSmall}" ng-show=!isClickOpen><!-- <button ng-if="disabled" class="dropdown-toggle disabled" type="button" ng-click="toggleList()" ng-if="!isSearch" disabled>{{selectedLabel}}</button> --><div class=backdrop ng-click=closeList() ng-if=isOpen></div><button class=dropdown-toggle type=button ng-click=toggleList() ng-if=!isSearch title={{selectedLabel}}><span ng-if=!shortLabelField>{{selectedLabel}}</span> <span ng-if=shortLabelField>{{selectedShortLabel}}</span></button> <input type=text class="dropdown-toggle search-input" ng-model=selectedLabelTemp autocomplete=off ng-keyup=searchFunction(selectedLabelTemp) ng-show=isSearch&&selectedLabelTemp ng-focus=startSearch() ng-mouseover=openList() title={{selectedLabelTemp}}> <input type=text class="dropdown-toggle search-input" ng-model=selectedLabel autocomplete=off ng-keydown=searchFunction(selectedLabel) ng-if=isSearch&&!selectedLabelTemp ng-focus=startSearch() ng-mouseover=openList() title={{selectedLabel}}><ul class="dropdown-menu zindex-1005" ng-if=isOpen ng-class="{upward: topMenu === true || toTop === true}"><!-- <li ng-if="isSearch">\n              <input type="text" ng-model="searchText" placeholder="Search..." autocomplete="off" ng-keyup="searchFunction(searchText)" ng-blur="searchText=\'\'">\n            </li> --><li><a href=# class=menu-item id={{item[valueField]}} data-ng-click=selectItem(item) ng-repeat="item in cOptions" ng-if="options && options!=[]" ng-bind-html=item[labelField]></a> <a href=# class=menu-item ng-if="!options || !options.length">No Data</a> <a class=menu-item ng-click=addItem() ng-if=enableAddItem>+ <span translate=Add></span></a></li></ul><!-- <div class="backdrop" ng-click="closeList()" ng-if="isOpen"></div> --></div><div class="dropdown selectbox" ng-class="{\'noIcon\': noIcon}" ng-show=isClickOpen><div class=backdrop ng-click=closeList() ng-if=isOpen></div><button class=dropdown-toggle type=button ng-click=toggleList() ng-if=!isSearch>{{selectedLabel}}</button> <input type=text class="dropdown-toggle search-input" ng-model=selectedLabelTemp autocomplete=off ng-keyup=searchFunction(selectedLabelTemp) ng-show=isSearch&&selectedLabelTemp ng-focus=openList() ng-click=openList() title={{selectedLabelTemp}}> <input type=text class="dropdown-toggle search-input" ng-model=selectedLabel autocomplete=off ng-keyup=searchFunction(selectedLabel) ng-show=isSearch&&!selectedLabelTemp ng-focus=openList() ng-click=openList() title={{selectedLabel}}><ul class="dropdown-menu zindex-1005" ng-if=isOpen ng-class="{upward: topMenu === true || toTop === true}"><li><a href=# class=menu-item id={{item[valueField]}} data-ng-click=selectItem(item) ng-repeat="item in cOptions" ng-if="options && options!=[]" ng-bind-html=item[labelField]></a> <a href=# class=menu-item ng-if="!options || !options.length">No Data</a> <a class=menu-item ng-click=addItem() ng-if=enableAddItem>+ <span translate=Add></span></a></li></ul></div></div>');
$templateCache.put('app/core/directives/selectbox2/selectbox2.view.html','<div title="{{isTitle ? selected[labelField] : null}}"><ui-select ng-model=selected ng-disabled=ngDisabled on-select=onSelect($select.selected)><ui-select-match><span ng-bind=$select.selected[labelField]></span></ui-select-match><ui-select-choices repeat="item in (cOptions | filter: $select.search) track by item[valueField]" position="{{toTop ? \'up\' : \'down\'}}"><span ng-bind=item[labelField] class=menu-item data-ng-click=selectItem(item)></span></ui-select-choices></ui-select></div>');
$templateCache.put('app/core/directives/selectboxinput/selectboxinput.view.html','<div><ui-select ng-model=selected ng-disabled=ngDisabled on-select=onSelect($select.selected)><ui-select-match><span ng-if=!useShortLabel placeholder={{placeholder}} ng-bind=$select.selected[labelField]></span> <span ng-if=useShortLabel placeholder={{placeholder}} ng-bind=$select.selected[shortLabelField]></span> <button class=clear ng-click=clear($event) ng-if=hasClear>&#10006;</button></ui-select-match><ui-select-choices repeat="item in (cOptions | filter: $select.search) track by $index" position="{{toTop ? \'up\' : \'down\'}}"><span ng-bind-html="item[labelField] | highlight: $select.search" class=menu-item></span></ui-select-choices></ui-select></div>');
$templateCache.put('app/core/directives/side-navbar/side-navbar.view.html','<div id=side-navbar><ul><li class=cursor-point ng-class="{active: page==\'mail\'}"><a href=/mail target=_blank><img ng-if="page!=\'mail\'" src=/assets/icons/sms_line_white.svg> <img ng-if="page==\'mail\'" src=/assets/icons/sms_line_white.svg></a></li><li ui-sref=calendar class=cursor-point ng-class="{active: page==\'calendar\'}"><img ng-if="page!=\'calendar\'" src=/assets/icons/calendar_line_white.svg> <img ng-if="page==\'calendar\'" src=/assets/icons/calendar_fill_white.svg></li><li ui-sref=companyCalendar class=cursor-point ng-class="{active: page==\'shiftplanning\'}"><img ng-if="page!=\'shiftplanning\'" src=/assets/icons/profile2_line_white.svg> <img ng-if="page==\'shiftplanning\'" src=/assets/icons/profile2_fill_white.svg></li><li ui-sref=todo class=cursor-point ng-class="{active: page==\'todo\'}"><img ng-if="page!=\'todo\'" src=/assets/icons/clipboard_text_line_white.svg> <img ng-if="page==\'todo\'" src=/assets/icons/clipboard_text_line_white.svg></li><li ui-sref="" class=cursor-point><img src=/assets/icons/edit_line_white.svg></li><li ui-sref=typeWritterRichTextGrid class=cursor-point ng-class="{active: page==\'typewritter\'}"><img ng-if="page!=\'typewritter\'" src=/assets/icons/text-block-line-white.svg> <img ng-if="page==\'typewritter\'" src=/assets/icons/text-block-fill-white.svg></li><li ui-sref=typeWritterSpreadSheetGrid class=cursor-point ng-class="{active: page==\'spreadsheet\'}"><img ng-if="page!=\'spreadsheet\'" src=/assets/icons/grid-line-white.svg> <img ng-if="page==\'spreadsheet\'" src=/assets/icons/grid-fill-white.svg></li></ul></div>');
$templateCache.put('app/core/directives/spinner/spinner.html','<div class="spinner ft_24_600_gray" ng-if=isProgressing><img src=/assets/icons/spinner.gif alt=icons></div><div class=mask ng-click=bgclick() ng-if=isProgressing></div><!-- <div class="mask" ng-if="needMask != false"></div> -->');
$templateCache.put('app/core/directives/synergy-chat/synergy-chat.view.html','<div class=synergy-chat><div class=messages-container><spinner ng-if="loading && !externLoading"></spinner><div class=send-receive id=messages scrolly=loadMore()><div class="flex flex-row flex-between flex-items-center"><span class=ft_18_600_black3>Conversations</span> <a class="ft_14_600_moreblue cursor-point">View all conversations</a></div><div class="message-input-container flex flex-row flex-items-center mt-24"><!-- <div\n            class="attachment"\n            ngf-select\n            ngf-change="changeAttacheFiles($files)"\n            ngf-multiple="true"\n            ng-disabled="!(!!activeChannel)"\n        >\n          <img src="/assets/icons/attachment1.svg" alt="attachment" />\n        </div> --> <img ng-src={{userData.profilePic}} class="avatar object-fit-cover"><div class="message-input-box flex flex-row ph-16 flex-items-center flex-1 msgInputTextbox"><textarea id=message-input class=flex-1 placeholder="Type a message here" ng-disabled=!(isValidRoom) ng-model=messageBody ng-keypress="messageBodyInput($event, messageBody)">\n          </textarea><div class="flex flex-row"><!-- <div\n              class="attachment"\n              ngf-select\n              ngf-change="changeAttacheFiles($files)"\n              ngf-multiple="true"\n              ng-disabled="!(isValidRoom)"\n            >\n              <img src="/assets/icons/insert_emoticon.svg" alt="attachment" />\n            </div> --><div class=attachment ng-click=insertSmiley() ng-disabled=!(isValidRoom)><img src=/assets/icons/insert_emoticon.svg alt=attachment></div><!-- <div\n              class="attachment ml-16"\n              ngf-select\n              ngf-change="changeAttacheFiles($files)"\n              ngf-multiple="true"\n              ng-disabled="!(isValidRoom)"\n            >\n              <img src="/assets/icons/insert_photo.svg" alt="attachment" />\n            </div> --><div class="attachment ml-16" ng-click=onAttachFile() ng-disabled=!(isValidRoom)><img src=/assets/icons/insert_photo.svg alt=attachment></div></div></div><!-- <div class="send-msg" ng-disabled="!(!!activeChannel)" ng-click="submitMessageBody(messageBody)">\n          <img src="/assets/icons/send-msg.svg" alt="icons" />\n        </div> --></div><div class=typing-status ng-if="typingMembers.size > 0"><div class=typing-indicator-box><ul><li>{{typingMessage}}</li></ul></div></div><search-list ng-if=isSearch options=memberNames search-text=searchText select-event=selectUserName(name) select-candidate=selectUserNameCandidate(name)></search-list><div class=mt-30 ng-repeat="(key, message) in currentMessages" ng-class="message.userType?\'receive\':\'send\'"><div class=item><div id=my-message-actions class="dropdown dropleft" ng-if=message.userType><img ng-if=isEditedMessage(message.messageEid) class=edited src=/assets/icons/edit-light.svg alt=""> <img class=more id=call-more-btn-{{key}} data-toggle=dropdown aria-haspopup=true aria-expanded=false src=/assets/icons/more.svg alt=icons><ul class=dropdown-menu role=menu aria-labelledby=my-message-actions><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=editMessage(message) translate=Edit></a></li><li><a href=# class=menu-item ng-click=deleteMessage(message) translate=Delete></a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=copyMessage(message) translate=Copy></a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=quoteMessage(message) translate=Quote></a></li></ul></div><img ng-hide=message.userType class="avatar object-fit-cover" ng-src="{{!!message.profilePic?message.profilePic:\'/assets/images/employees/no-avatar.png\'}}" alt=icons><div class="talk-bubble tri-right round btm"><div ng-init="limit=1024; moreShown = false" class=talktext><div ng-bind-html="getMessageBody(message.message.messageText) | limitTo: limit"></div><div class="time ft_12_regular_gray"><img ng-src=/assets/icons/meeting-d.svg alt="" width=16 height=16> <span class=mr-8>{{getChatTime(message.updatedAt)}}</span> <span>{{message.authorName}}</span></div></div></div><img ng-hide=!message.userType class="avatar object-fit-cover ml-8" ng-src="{{!!message.profilePic?message.profilePic:\'/assets/images/employees/no-avatar.png\'}}" alt=icons> <a ng-show="getMessageBody(message.message.messageText).length > limit" href ng-click="limit=getMessageBody(message.message.messageText).length; moreShown = true"><u>...More</u> </a><a ng-show=moreShown href ng-click="limit=1024; moreShown = false"><u>Less</u></a><div id=your-message-actions class="dropdown dropleft" ng-if=!message.userType><img ng-if=!isFileMessage(message) class=more id="call-more-btn-{{key + 1000}}" data-toggle=dropdown aria-haspopup=true aria-expanded=false src=/assets/icons/more.svg alt=icons><ul class=dropdown-menu role=menu aria-labelledby=your-message-actions><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=copyMessage(message)>Copy</a></li><li ng-if=!isFileMessage(message)><a href=# class=menu-item ng-click=quoteMessage(message) translate=Quote></a></li></ul></div></div></div><attach-files attach-files=attachmentFiles></attach-files><quote-message ng-if=quotingMessage ng-model=quotingMessage cancel-quote=cancelQuoteMessage()></quote-message><waiting-indicator ng-if=waiting></waiting-indicator></div></div></div>');
$templateCache.put('app/core/directives/tab/tab.view.html','<div class=common-tab-container><div class=tab-header><div class=tab-button ng-repeat="tab in tabs" ng-class="{active: tab.id==curTab}" ng-click=selectTab(tab)>{{tab.name}}</div><div class=tab-add ng-if=add ng-click=newTab()><img src=/assets/icons/bx-plus3.svg alt=+></div></div><div class="tab-content ev-2" ng-transclude></div></div>');
$templateCache.put('app/core/directives/waiting-indicator/waiting-indicator.view.html','<div class=waiting-indicator><img src=/assets/icons/waiting.gif alt=icons></div>');
$templateCache.put('app/core/directives/time-picker/time-picker.view.html','<div id=time-picker class=dropdown><div class="dropdown-toggle w-250" data-toggle=dropdown><span class=time-value>{{ ngModel ? (ngModel | smartTime) : placeholder }}</span> <img ng-src="{{icon ? icon : \'/assets/icons/query_builder.svg\'}}" alt=""></div><div class="dropdown-menu w-250" ng-show=!disabled><div class="d-flex align-items-center"><input id=time-picker-hours class="time-input time-text" type=number min=0 max="{{is12Format ? 12 : 23}}" ng-model=hour><div class=time-text>:</div><input id=time-picker-minutes class="time-input time-text" type=number min=0 max=59 ng-model=minute><div class=am-pm ng-if=is12Format><div class=am ng-class="{selected: !isPm}" ng-click="onAmPm($event, false)">AM</div><div class=pm ng-class="{selected: isPm}" ng-click="onAmPm($event, true)">PM</div></div><div class="button ok ml-10" ng-click=onOK() translate=Ok></div></div></div></div>');
$templateCache.put('app/main/auth/forgetPassword/forgetPassword.view.html','<main-title-bar></main-title-bar><div id=forgotPasswordPage class=main-container><div class=content><login-left-block></login-left-block><div class=right-side><img src=/assets/images/login/logo.svg alt=login><div class="login_title mt-24" translate="Forgot Password"></div><div class=account-noti><span class=account translate="I remember my password"></span>&nbsp; <span class="mark cursor-point" ui-sref=login translate="Sign in"></span></div><div class=login-contents><div class=login-items><div class=label translate="Email address"></div><input type=email class=field-input ng-model=vm.forgotPassData.email placeholder="{{\'Enter Email address\' | translate}}" required autocomplete=off></div><div class="btn-login mt-24" translate=Submit ng-click=vm.forgotPass(vm.forgotPassData)></div></div></div></div></div>');
$templateCache.put('app/main/auth/login/login.view.html','<main-title-bar></main-title-bar><div id=login class=main-container><div class=content><login-left-block></login-left-block><div class=right-side><spinner ng-if=loading></spinner><img src=/assets/images/login/logo.svg alt=login><div class="login_title mt-24" translate="Sign in"></div><div class=account-noti><span class=account translate="Don\'t have an account?"></span>&nbsp; <span class="mark cursor-point" ui-sref=register translate="Sign up"></span></div><div class="switch-3 mt-32"><div class=switch-item ng-class="{active: vm.loginData.designation==\'subscriber\'}" ng-click="vm.setDesignation(\'subscriber\')" translate=Subscriber></div><div class=switch-item ng-class="{active: vm.loginData.designation==\'client\'}" ng-click="vm.setDesignation(\'client\')" translate=Client></div><div class=switch-item ng-class="{active: vm.loginData.designation==\'collaborator\'}" ng-click="vm.setDesignation(\'collaborator\')" translate=Collaborator></div></div><div class=login-contents><div class=login-items><div class=label translate="Email address"></div><input type=text class=field-input ng-model=vm.loginData.email placeholder="{{\'Enter Email address\' | translate}}" required autocomplete=off></div><div class="login-items mt-16"><div class=label translate=Password></div><div class=pwd-container><input type=password class=field-input required ng-show=!show_pass ng-model=vm.loginData.password placeholder="{{\'Enter Password\' | translate}}" autocomplete=off> <input type=text class=field-input required ng-show=show_pass ng-model=vm.loginData.password placeholder="Enter Password" autocomplete=off> <img class="icon cursor-point" ng-click="show_pass = !show_pass" ng-init="show_pass=false" alt=Login ng-src="{{show_pass? \'/assets/icons/eye-off-outline.svg\': \'/assets/icons/eye-outline.svg\'}}"></div></div><div class="forgot_password flex-between mt-24"><div class=forgot-content><label class=check_yellow_20><div class=ft_14_600_black ng-model=vm.loginData.rememberMe translate="Remember Me"></div><input type=checkbox checked ng-model=vm.loginData.rememberMe> <span class=checkmark></span></label></div><a class=forgot-mark ui-sref=forgetPassword translate="Forgot Password?"></a></div><div class="btn-login mt-24" translate=Login ng-click=vm.login(vm.loginData)></div></div></div></div></div>');
$templateCache.put('app/main/auth/preLogin/preLogin.view.html','<div id=pre-login><div class=container><div class="ft_24_600_black text-center">CloudES Login</div><div class="ft_14_600_gray text-center mv-15">Select the Login type</div><div class="flex justify-content-between"><div class="login flex-center" ui-sref=login><div><img src=/assets/images/login/login-icon.svg alt=login><div class="ft_18_600_white text-center mt-15">System</div></div></div><div class="tender flex-center" ui-sref=tenderList><div><img src=/assets/images/login/tender-icon.svg alt=register><div class="ft_18_600_black3 text-center mt-15">Tender</div></div></div></div><div class="logo text-center"><img src=/assets/images/login/circle-logo.svg alt=login></div></div></div>');
$templateCache.put('app/main/auth/register/register.view.html','<main-title-bar></main-title-bar><div id=register class=main-container><div class=content><login-left-block></login-left-block><div class=right-side><img src=/assets/images/login/logo.svg alt=login><div class="login_title mt-24" translate="Sign up"></div><div class=account-noti><span class=account translate="Already have an account?"></span>&nbsp; <span class="mark cursor-point" ui-sref=login translate="Sign in"></span></div><div class=login-contents><div class="login-items mt-16"><div class=label translate="Full Name"></div><input autocomplete=off type=text class=field-input ng-model=vm.registerData.name placeholder="{{\'\' | translate}}" required ng-pattern=/^[a-zA-Z\\s]*$/ ></div><div class="login-items mt-16"><div class=label translate="Email ID"></div><input autocomplete=off type=email class=field-input ng-model=vm.registerData.email placeholder="{{\'eg. example@mail.com\' | translate}}" required></div><div class="login-items mt-16"><div class=label translate="Phone Number"></div><div class="d-flex phone"><selectbox-input ng-model=vm.registerData.dialCode options=vm.getCountryCode label-field=dialCode value-field=dialCode></selectbox-input><input autocomplete=off type=tel class="field-input number_input" id=phoneNumber name=phoneNumber ng-model=vm.registerData.phoneNumber placeholder="" required></div></div><div class="login-items mt-16"><div class=label translate="Company Name"></div><input autocomplete=off type=text class=field-input ng-pattern=/^[a-zA-Z\\s]*$/ ng-model=vm.registerData.companyName placeholder="{{\'Enter your company name\' | translate}}" required></div><div class="login-items mt-16"><div class=label translate="Address Line 1"></div><input autocomplete=off type=text class=field-input id=addressLine1 name=addressLine1 ng-model=vm.registerData.addressLine1 placeholder="{{\'Enter your address\' | translate}}" required></div><div class="login-items mt-16"><div class=label translate="Address Line 2"></div><input autocomplete=off type=text class=field-input id=addressLine2 name=addressLine2 ng-model=vm.registerData.addressLine2 placeholder="{{\'Enter your another address\' | translate}}"></div><div class="login-items flex mt-16"><div class="postal-code mr-20"><div class=label translate="Postal Code"></div><input autocomplete=off type=text class=field-input id=postalCode name=postalCode ng-model=vm.registerData.postalCode placeholder="{{\'Postal Code\' | translate}}" required></div><div class=flex-50><!-- <div class="label" translate="Country Code"></div>\n            <input\n              autocomplete="off"\n              type="text"\n              class="field-input"\n              id="countryCode"\n              name="countryCode"\n              ng-model="vm.registerData.countryCode"\n              placeholder="{{\'Country Code\' | translate}}"\n              required\n            /> --></div></div><div class="login-items mt-16"><div class=label translate=City></div><input autocomplete=off type=text class=field-input id=city name=city ng-model=vm.registerData.city placeholder="{{\'City\' | translate}}" required></div><div class="login-items mt-16"><div class=label translate=Country></div><div class=country><selectbox-input ng-model=vm.registerData.countryName options=vm.getCountries label-field=name value-field=name></selectbox-input></div></div><div class="flex mt-24"><label class=check_yellow_20><input type=checkbox ng-model=isAccepted> <span class=checkmark></span></label><div class=accept-label>I agree to the <span class=link-mark>Terms of Service</span> and <span class=link-mark>Privacy Policy</span></div></div><div class="btn-login mt-24" translate="Create Account" ng-click=vm.register(vm.registerData)></div></div></div></div></div><script>/////////select option script\n  $(\'.dropdown-menu\').on(\'click\', \'a\', function () {\n    var text = $(this).html()\n    var htmlText = text\n    $(this)\n      .closest(\'.dropdown\')\n      .find(\'.dropdown-toggle\')\n      .html(htmlText)\n  })</script>');
$templateCache.put('app/main/auth/setPassword/setPassword.view.html','<main-title-bar></main-title-bar><div id=setPasswordPage class=main-container><div class=content><login-left-block></login-left-block><div class=right-side><spinner ng-if=loading></spinner><img src=/assets/images/login/logo.svg alt=login><div class="login_title mt-24" translate="Reset Password"></div><div class=account-noti><span class=account translate="I remember my password"></span>&nbsp; <span class="mark cursor-point" ui-sref=login translate="Sign in"></span></div><div class=login-contents><div class=login-items><div class=label translate=Password></div><input type=password class=field-input ng-model=vm.resetPassData.password placeholder="Enter New Password" required></div><div class="login-items mt-16"><div class=label translate="Confirm Password"></div><input type=password class=field-input ng-model=vm.resetPassData.c_password placeholder="Enter Confirm Password" required></div><div class="btn-login mt-24" translate=Submit ng-click=vm.resetPass()></div></div></div></div></div>');
$templateCache.put('app/main/auth/tenderList/tenderList.view.html','<main-title-bar></main-title-bar><div id=tenderList class=main-container><div class=content-grid-wrapper><div class=flex-between><div class=ft_36_600_black translate="Find public tenders in CloudES"></div><div class=btn-group><div ng-if=!isList><button class=btn-trans ng-click=onListView(true)><img src=/assets/images/sales/bx-list-ul.svg alt=icons class=margin-0></button> <button class=btn-trans ng-click=onListView(false)><img src=/assets/images/sales/grid-f.svg alt=icons class=margin-0></button></div><div ng-if=isList><button class=btn-trans ng-click=onListView(true)><img src=/assets/images/sales/bx-list-ul1.svg alt=icons class=margin-0></button> <button class=btn-trans ng-click=onListView(false)><img src=/assets/images/sales/grid-f1.svg alt=icons class=margin-0></button></div><button class="btn-dark-blue flex-center ml-20" ui-sref=login><img src=/assets/images/login/system-login.svg alt=Login class=mr-10> <span translate="System Login"></span></button></div></div><div class="content mt-20"><div class="table-wrap ft_14_regular_light" ng-if=isList><div class=flex><div class=flex-5><label class=check_yellow_20><input type=checkbox ng-model=isAccepted><span class=checkmark></span></label></div><div class="flex-20 cursor-point" ng-click="vm.sort(\'projectName\')"><span translate=Name></span> <img src=/assets/icons/arrow_drop_down.svg alt=""></div><div class="flex-20 cursor-point" ng-click="vm.sort(\'buildingType\')"><span translate=Type></span> <img src=/assets/icons/arrow_drop_down.svg alt=""></div><div class="flex-20 cursor-point" ng-click="vm.sort(\'created\')"><span translate=Date></span> <img src=/assets/icons/arrow_drop_down.svg alt=""></div><div class="flex-20 cursor-point"><span translate=Location></span> <img src=/assets/icons/arrow_drop_down.svg alt=""></div><div class="flex-10 cursor-point" ng-click="vm.sort(\'projectStatus\')"><span translate=Status></span> <img src=/assets/icons/arrow_drop_down.svg alt=""></div><div class="flex-5 cursor-point" translate=Action></div></div><spinner ng-show=isLoading></spinner><div ng-repeat="p in publicTenders track by $index" ng-click="selTender($event, $index)" ng-class="{\'isActive\': activedTender == $index+1}" ng-if=!isLoading><div class=pos-relative><!-- <img src="/assets/icons/edit.svg" alt="" style="position: absolute;right: 45px;top: 18px;cursor: pointer;" ng-click="goToDetail(p)"> --><div class=item><div class=flex-5><label class=check_yellow_20><input type=checkbox ng-model=p.index ng-change=selProject(p)><span class=checkmark></span></label></div><div class=flex-20><div class="ft_16_600_black tx-ellipsis">{{p.projectName}}</div><div class="ft_14_regular_light tx-ellipsis mt-8">{{p.systemTag}}</div></div><div class=flex-20><div class="ft_14_regular_light tx-ellipsis">Billing: <span>{{p.buildingType}}</span></div><div class="ft_14_regular_light tx-ellipsis mt-8">Enterprise: <span>Private Limited</span></div></div><div class=flex-20><div class=ft_14_regular_light>Start Date: <span>{{ p.startDate | date: "mediumDate" : \'UTC\' }}</span></div><div class="ft_14_regular_light mt-8">End Date: <span>{{ p.endDate | date: "mediumDate" : \'UTC\' }}</span></div></div><div class="flex-20 ft_14_regular_light address">{{p.address.line1}}, {{p.address.city}}, {{p.address.postalCode}}, {{p.address.countryCode}}</div><div class=flex-10><div class=project-status ng-class="{\'opens\':p.projectStatus==0, \'progresses\':p.projectStatus==1, \'complete\':p.projectStatus==2,\n                  \'cancel\': p.projectStatus==3, \'lost\': p.projectStatus==4, \'postponed\': p.projectStatus==5, \'precast\': p.projectStatus==6}" translate="{{p.projectStatus | projStatus}}"></div><!-- <div class="dropdown">\n                  <button class="dropdown-toggle1" type="button" id="menu1" data-toggle="dropdown"><img src="/assets/icons/more2.svg" alt=""></button>\n                  <ul class="dropdown-menu" role="menu" aria-labelledby="menu1">\n                    <li data-ng-click="onStatus($event)" ng-repeat="item in status">\n                      <label class="check_yellow_20"><input type="checkbox" ng-model=\'item.isChecked\'/><span class="checkmark"></span></label>\n                      <a href="#"  class="menu-item" id="{{ item._id }}">{{ item.name }}</a>\n                    </li>\n                    <li><a class="menu-item" ng-if="!status">No Data</a></li>\n                  </ul>\n                </div> --></div><div class=flex-5><button class=btn ng-click=deleteProject(p._id)><img src=/assets/icons/delete4.svg alt=""></button></div></div></div></div></div><div class="flex flex-wrap mh-min15 mb-24" ng-if=!isList><spinner ng-show=isLoading></spinner><div class="card-item ft_14_regular_gray" ng-repeat="p in publicTenders track by $index" ng-click=selTender($index) ng-if=!isLoading><div class=pos-relative><!-- <img src="/assets/icons/edit.svg" alt="" style="position: absolute;right: 20px;top: 20px;cursor: pointer;" ng-click="goToDetail(p)"> --><div ng-click=selProject(p)><div class=img-wrap><img ng-src="{{ p.projectImage?p.projectImage:\'/assets/icons/tender.svg\' }}" alt="" onerror="this.src=\'/assets/icons/tender.svg\'" width=350 height=135></div><div class=card-content><div class=flex-between><div>{{p.systemTag}}</div><div class=project-status ng-class="{\'opens\':p.projectStatus==0, \'progresses\':p.projectStatus==1,\n                      \'complete\':p.projectStatus==2, \'cancel\': p.projectStatus==3, \'lost\': p.projectStatus==4,\n                       \'postponed\': p.projectStatus==5, \'precast\': p.projectStatus==6}" translate="{{p.projectStatus | projStatus}}"></div></div><div class="ft_16_600_black mv-5 tx-ellipsis">{{p.projectName}}</div><div class=tx-ellipsis>{{p.address.line1}}, {{p.address.city}}, {{p.address.postalCode}}, {{p.address.countryCode}}</div></div></div></div></div></div><div class="flex-between mt-15" ng-if=!isLoading><div class="mr-10 ft_14_600_black">Showing {{(vm.currentPage - 1) * numPerPage + 1}} - <span>{{(vm.currentPage - 1) * numPerPage + publicTenders.length}}</span> of {{totalCount}} - Public Tenders</div><hr class=split-line><pagination num-pages=noOfPages current-page=vm.currentPage on-select-page=getPublicTenders()></pagination></div></div></div></div><div id=tenderModal class=modal tabindex=-1 role=dialog data-keyboard=true><div id=tender-modal><div class=body><div class=title-black><div class=m-auto>Preview</div><div class="mr-10 cursor-point" data-dismiss=modal><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class="ft_18_600_black3 mb-20">{{publicTenders[activedTender - 1].systemTag}} - {{publicTenders[activedTender - 1].projectName}}</div><div class=row><div class=col-6><div class=ft_12_regular_gray>Client Info</div><div class=ft_14_600_black>{{publicTenders[activedTender - 1].client.clientName}}</div></div><div class=col-6><div class=ft_12_regular_gray>Contact Person</div><div class=ft_14_600_black>{{publicTenders[activedTender - 1].client.clientContactPerson.firstName}} {{publicTenders[activedTender - 1].client.clientContactPerson.middleName}} {{publicTenders[activedTender - 1].client.clientContactPerson.lastName}}</div></div></div><div class="row mt-15"><div class=col-6><div class=ft_12_regular_gray>Contact No.</div><div class=ft_14_600_black>({{publicTenders[activedTender - 1].client.clientContact.dialCode}}) {{publicTenders[activedTender - 1].client.clientContact.phoneNumber}}</div></div><div class=col-6><div class=ft_12_regular_gray>Email ID</div><div class=ft_14_600_black>{{publicTenders[activedTender - 1].client.email}}</div></div></div><div class="row mt-15"><div class=col-12><div class=ft_12_regular_gray>Description</div><div class=ft_14_600_black>{{publicTenders[activedTender - 1].projectDescription}}</div></div></div><div class="row mt-15"><div class=col-6><div class=ft_12_regular_gray>Tender Type</div><div class=ft_14_600_black>{{publicTenders[activedTender - 1].buildingType}}</div></div><div class=col-6><div class=ft_12_regular_gray>Enterprise Type</div><div class=ft_14_600_black>Private Limited</div></div></div><div class="row mt-15"><div class=col-6><div class=ft_12_regular_gray>Start Date</div><div class=ft_14_600_black>{{ publicTenders[activedTender - 1].startDate | date: "mediumDate" : \'UTC\' }}</div></div><div class=col-6><div class=ft_12_regular_gray>End Date</div><div class=ft_14_600_black>{{ publicTenders[activedTender - 1].endDate | date: "mediumDate" : \'UTC\' }}</div></div></div><div class="btn-group flex-between"><button class="btn_primary bg-gray-dark mr-15">Request for Access</button> <button class=btn_primary>Available Tender Material</button></div></div></div></div></div>');
$templateCache.put('app/main/auth/termsAndConditions/termsAndConditions.view.html','<div id=termsAndConditions class="page-layout simple fullwidth"><nav class="navbar navbar-expand-lg navbar-light nav-bg"><a class="navbar-brand flex-center" href=#><img src=/assets/images/dashboard/Logo.svg alt=logo> </a><button class=navbar-toggler type=button data-toggle=collapse data-target=#navbarSupportedContent aria-controls=navbarSupportedContent aria-expanded=false aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div class="collapse navbar-collapse" id=navbarSupportedContent style="display: flex !important;"><ul class="navbar-nav mr-auto"></ul><div class=form-inline><div class="dropdown w-255"><button class=dropdown-toggle type=button id=menu1 data-toggle=dropdown>Select Project</button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li><a href=# class=menu-item id=1 data-ng-click=ShowId($event)>Project1</a></li><li><a href=# class=menu-item id=2 data-ng-click=ShowId($event)>Project2</a></li></ul></div><img src=/assets/icons/search.svg alt=logo class=search> <img src=/assets/icons/bx-user.svg alt=logo class=avatar><div class=ft_12_regular_white>Hi Jane</div><img src=/assets/icons/dropdownArrowWhite.svg alt=logo class=arrow></div></div></nav><div class=termsAndConditionsContent><div class="ft_36_600_black title">Terms & Conditions</div><div class="ft_14_regular_gray termsAndConditions_items">Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate. Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate.Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate.</div><div class="ft_14_regular_gray termsAndConditions_items">Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate. Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate.Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate.</div><div class="ft_14_regular_gray termsAndConditions_items">Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate. Do eu incididunt id ipsum incididunt aliqua aliqua laborum</div><div class="ft_14_regular_gray termsAndConditions_items">Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate. Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate.Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate.</div><div class="ft_14_regular_gray termsAndConditions_items">Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate. Do eu incididunt id ipsum incididunt aliqua aliqua laborum</div><div class="ft_14_regular_gray termsAndConditions_items">Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat voluptate. Do eu incididunt id ipsum incididunt aliqua aliqua laborum id magna dolor. Officia labore sint aute reprehenderit exercitation nisi veniam. Tempor elit cupidatat</div></div></div>');
$templateCache.put('app/main/calc/budget/budget.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=calculationBudget class=main-container ng-show=!isLoading><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref="calcExtra({id: \'prepare\'})" class="ft-normal-12-16 grey-2" translate=Calculation></a></div><div class=header-title translate=Budget></div></div><button class="btn_new_blue btn-save ml-auto" ng-click=vm.saveSheet() ng-if="BUDGET_ACCESS_CREATE > 2"><img src=/assets/icons/save-icon.svg alt="" class=mr-10><span translate=Save></span></button></div><div class=content-wrap><tab-container class=mb-30 tabs=vm.tabs><tab-page ng-repeat="tab in vm.tabs" tab-id={{tab.id}}><div class=budget-page><budget-group type=tab.id ng-model=vm.budgets currency=companyCurrency.symbol permission=BUDGET_ACCESS_CREATE></budget-group></div></tab-page></tab-container></div></div></main>');
$templateCache.put('app/main/calc/calVersionDetail/calVersionDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=calVersionDetail class=main-container ng-if="vm.mode!=\'compare\'"><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref="calcExtra({id: \'prepare\'})" class="ft-normal-12-16 grey-2" translate=Calculation></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class=ft_14_600_gray>Detail</a></div><div class=header-title>{{vm.selectedVersionSummary.versionSeq != -1 ? \'Version Sequence \' + vm.selectedVersionSummary.versionSeq : \'Current Sequence\'}}</div></div><div class="flex-between ml-auto"><button class=btn_new_blue ng-click=vm.mergeVersion() ng-if="vm.mode==\'treediff\' || vm.mode==\'contentdiff\'">Merge</button> <button class="btn_new_blue client_gray_back ml-16" ng-click=vm.showDetail() ng-if="vm.mode==\'treediff\' || vm.mode==\'contentdiff\'">View Detail</button> <button class="btn_new_blue client_gray_white_back ml-16" ng-click=vm.showDiff() ng-if="vm.mode==\'detail\' || vm.mode==\'treediff\'">View Difference</button> <button class="btn_new_blue client_gray_white_back ml-16" ng-click=vm.showTreeDiff() ng-if="vm.mode==\'detail\' || vm.mode==\'contentdiff\'">View Tree Difference</button></div></div><div class=content-wrap><div ng-show="isLoading==false"><div id=version-card class=mb-30><div class=header><div class="detail ft_12_regular_gray"><div class="ft_14_regular_gray mb-8">Created: <span class=ft_14_600_black>{{vm.selectedVersionSummary.savedBy}}</span></div><div class=ft_14_regular_gray>Created Date: <span class=ft_14_600_black>{{vm.selectedVersionSummary.saveDate | date: "dd/MM/yyyy" : \'UTC\' }}</span></div></div></div><div class="restore mt-20 pos-relative"><div class=flex-between ng-if="vm.selectedVersionSummary.versionSeq != -1"><div class=ft_16_600_black>This version is an older one. Click here to view <span class="ft-blue-back cursor-point" ng-click=vm.viewCurrentVersion()>Current Version.</span></div><button class=btn_primary_38 ng-click=vm.restoreVersion();>Restore</button></div><div class=ft_16_600_black ng-if="vm.selectedVersionSummary.versionSeq == -1">This version is an newest one.</div><div class="btn-left pos-absolute" ng-click=vm.showPrevVersion();><img src=/assets/icons/btn-right1.svg alt=""></div><div class="btn-right pos-absolute" ng-click=vm.showNextVersion();><img src=/assets/icons/btn-left1.svg alt=""></div></div></div><section ng-show="vm.mode===\'detail\'"><div class=bread-crumb><div class=item ng-click=vm.goToRoot()>Root</div><div class=flex ng-repeat="item in vm.currentStateList track by $index"><img src=/assets/icons/arrow-right2.svg alt=""><div class=item ng-click=vm.changeBreadCrumb($index)>{{ item.name }}</div></div></div><div id=version-calc-main><div ng-if=!vm.openBreadCumb ng-repeat="material in tableInventory" ng-init="outerIndex=$index"><calc-fixed-group index=outerIndex ng-model=material company-currency=companyCurrency checkable=false on-enter-child=vm.callBreadCrumb></calc-fixed-group></div><div id=cal-total class=box-shadow-white ng-if=!vm.openBreadCumb><div class=title><div class=flex-4></div><div class=flex-8 translate=Total></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8 translate="Cost Price"></div><div class=flex-8 translate="Labour Hours"></div><div class=flex-8 translate="Operating Cost"></div><div class=flex-8><span translate=Profit></span> in %</div><div class=flex-8 translate=Profit></div><div class="flex-8 overflow-visible"><div class=flex><div><span translate="Sales Price"></span></div><div class=alarm1 ng-mouseover="hoverIn=true" ng-mouseleave="hoverIn=false" ng-init="hoverIn=false"><img src=/assets/icons/alarm1.svg alt=""></div></div><div class="sales-price pos-relative" ng-if=hoverIn><div class="european ft_14_regular_gray"><div><span translate="Sales Price"></span> : {{totalSumWithAdditionalCost | readable: 2}}</div><div><span translate=Material/Equipment></span> : {{totalInventoryCost | readable: 2}}</div><div><span translate="Labour Cost"></span> : {{totalWorkerCost | readable: 2}}</div><div><span translate="Operating Cost"></span> : {{totalCompanyCost | readable: 2}}</div><div><span translate=Profit></span> : {{totalProfit| readable: 2}}</div></div></div></div></div><div class="sum bt-border4"><div class=flex-4></div><div class="flex-8 flex-center">Sum</div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><!-- Cost Price --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ totalCostPrice | readable: 2 }}</div><!-- Operating Cost --><div class=flex-8>{{ totalWorkingHours | readable: 2 }}&nbsp;hours</div><!-- Operating Cost --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ totalCompanyCost | readable: 2 }}</div><!-- Profit % --><div class=flex-8>{{ totalProfit/totalSum*100 | readable: 2 }}</div><!-- Profit --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ totalProfit | readable: 2 }}</div><!--Sales Price --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ totalSumWithAdditionalCost | readable: 2 }}</div></div></div><div ng-if=vm.openBreadCumb><calc-fixed-group index=vm.breadCrumbIndex ng-model=vm.currentState checkable=false company-currency=companyCurrency on-enter-child=breadCrumbSubLevel></calc-fixed-group></div></div></section><section id=contentdiff style="height: 100%;margin-bottom: 30px;" ng-show="vm.mode==\'contentdiff\'"><div class=diff-container><div class=diff-sub><div class="ft_24_600_black mv-10 diff-title">{{vm.selectedVersionSummary.versionSeq != -1 ? \'Version Sequence \' + vm.selectedVersionSummary.versionSeq : \'Current Sequence\'}}</div><calc-version-diff-content tag="\'left-calc-container\'" version=vm.diffedVersion.left company-data=vm.companyData company-currency=vm.leftVersion.companyCurrency></calc-version-diff-content></div><div class=diff-sub><div class="ft_24_600_black mv-10 diff-title">{{vm.rightVersionSeq != undefined ? \'Version Sequence \' + vm.rightVersionSeq : \'Current Sequence\'}}</div><calc-version-diff-content tag="\'right-calc-container\'" version=vm.diffedVersion.right company-data=vm.companyData company-currency=vm.rightVersion.companyCurrency></calc-version-diff-content></div></div></section><section id=treediff style="height: 100%;" ng-show="vm.mode==\'treediff\'"><calc-version-treediff old-data=vm.diffedVersion.left.levels new-data=vm.diffedVersion.right.levels old-version-seq=vm.selectedVersionSummary.versionSeq new-version-seq=vm.rightVersionSeq></calc-version-treediff></section></div></div></div></main><!-- dcp popover template --><script type=text/ng-template id=tpl.html><div>\n    <div class="row">\n      <div class="col-6"><label style="font-size:10px;text-align:left;padding-left: 10px;">{{vm.infosystemTag}}</label></div>\n    </div>\n    <label>Name : {{vm.popover.name}}</label><br>\n    <label>Unit Material Price : {{vm.popover.matValue | readable: 2}}</label><br>\n    <label>Unit Worker Price : {{vm.popover.rooferValue | readable: 2}}</label><br /><br />\n    <label ng-if="vm.popover.conistsMats.length>0"><b>MATERIALS</b></label><br />\n    <div class="row"ng-if="vm.popover.conistsMats.length>0"style="padding-left:10px;">\n      <ul ng-repeat="constmat in vm.popover.conistsMats"style="list-style-type:none;">\n        <li><label>Name : {{constmat.materialName}}</label><br />\n          <label>Unit Material Price : {{constmat.Rates.materialCost.value| readable: 2}}</label><br />\n          <label>Unit Worker Price : {{constmat.Rates.rooferCost.value| readable: 2}}</label><br />\n        </li>\n      </ul>\n    </div>\n  </div></script><!-- equipment popover template --><script type=text/ng-template id=equip.html><div id="equip-popover">\n    <div class="popover-title">Delivery Cost</div>\n    <div class="popover-content">{{ companyCurrency.symbol }} {{vm.popover.deliveryCost | readable: 2}}</div>\n    <div class="popover-content">Unit {{ vm.popover.matUnit }}</div>\n  </div></script><!--Sales Price popover template--><script type=text/ng-template id=summation.html><div>\n    <div class="row">\n      <label><span translate="Sales Price"></span> : {{totalCostPrice | readable: 2}}</label><br>\n      <label>Inventory : {{totalInventoryCost | readable: 2}}</label><br>\n      <label><span translate="Labour Cost"></span> : {{totalWorkerCost | readable: 2}}</label><br>\n      <label><span translate="Operating Cost"></span> : {{totalCompanyCost | readable: 2}}</label><br>\n      <label><span translate="Profit"></span> : {{totalProfit | readable: 2}}</label>\n    </div>\n  </div></script>');
$templateCache.put('app/main/calc/calVersions/calVersions.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=calVersions class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref="calcExtra({id: \'prepare\'})" class="ft-normal-12-16 grey-2" translate=Calculation></a></div><div class=header-title translate=Versions></div></div><button class="btn_new_blue ml-auto" ng-click=vm.compareVersion() translate=Compare></button></div><div class=content-wrap><spinner ng-show=isLoading></spinner><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0 && isLoading==false"><div class=content><div class=item-wrap><div class=header><div class=flex-11 style="padding-left: 20px;"><div class=ml-30 translate=Versions></div></div><div class=flex-11>Information</div><div class=flex-11 translate="Saved Date"></div><div class=flex-11>Sum</div><div class=flex-11 translate="Operating Cost"></div><div class=flex-11 translate="Working Hours"></div><div class=flex-11 translate=Profit></div><div class=flex-11 translate="Cost Price"></div><div class=flex-11 translate=Actions></div><div></div></div><div class=scroll-body><div class=items ng-repeat="version in vm.AllVersions| orderBy:\'versionSeq\':true"><div class=flex-11 style="padding-left: 20px;"><div><label class=check_yellow_20><input type=checkbox ng-change=onSelVersionId(version) ng-model=version.index> <span class=checkmark></span></label></div><div class=ml-30>Version{{version.versionSeq}}</div></div><div class=flex-11>{{version.savedBy}}</div><div class=flex-11>{{version.saveDate | date: "dd/MM/yyyy" }}</div><div class=flex-11>{{ version.companyCurrency.symbol }}&nbsp;{{version.sum | readable:2 }}</div><div class=flex-11>{{ version.companyCurrency.symbol }}&nbsp;{{version.totalCompanyCost | readable:2 }}</div><div class=flex-11>{{version.totalWorkHours | readable:2 }}&nbsp;hours</div><div class=flex-11>{{ version.companyCurrency.symbol }}&nbsp;{{version.totalProfit | readable:2 }}</div><div class=flex-11>{{ version.companyCurrency.symbol }}&nbsp;{{version.totalCostPrice | readable:2 }}</div><div class=flex-11><img src=/assets/icons/preview.svg alt="" class="cursor-point mr-15" ng-click=vm.showVersionInfo(version)> <img src=/assets/icons/restore1.svg alt="" style="width: 15px;" class=cursor-point ng-click=vm.restoreVersion(version)></div></div></div></div><!-- <div class="flex-center">\n            <pagination num-pages="noOfPages" current-page="vm.currentPage" on-select-page="vm.fetchAllClients()"></pagination>\n          </div> --></div></div></div></div></main>');
$templateCache.put('app/main/calc/calcExtra/calcExtra.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div id=calc-extra class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=calcMain class="ft-normal-12-16 grey-2" translate=Calculation></a></div><div class=header-title translate="Main Estimate"></div></div><div class=nav-items><div class=nav-item ng-repeat="item in navItems" ng-class="{active: activeNavItem == item.id}" ng-click=gotoPage(item)>{{item.title}}</div><div class=nav-item ng-click=addNewPage()>+</div></div><div class="flex-between ml-auto"><button class=button-primary ng-click=onSyncToTimeline()><span translate="Sync to Timeline"></span></button> <button class="button-primary ml-16" ng-click=onSync()><span translate=Sync></span></button> <button class="button-primary ml-16" ng-click=onRefreshSheet()><img src=/assets/icons/sync.svg alt=""><span translate=Refresh></span></button> <button class="button-secondary ml-16" ng-click=saveSheet() ng-if="CALC_ACCESS_CREATE > 1"><img src=/assets/icons/save-icon.svg alt=""><span translate=Save></span></button> <button class="button-third ml-16" ng-click=changeProjectSetting() ng-if="CALC_ACCESS_CREATE > 1"><img src=/assets/icons/settings-white.svg alt=""><span translate=Settings></span></button></div></div><div class=d-flex><div class=content-wrapper><div class=groups-container><div class=group-item ng-class="{active: !activeGroupItem}" ng-click=selectGroup()>All</div><div class=group-item ng-repeat="item in currentData.groups" ng-class="{active: activeGroupItem == item.id}" ng-click=selectGroup(item)>{{item.title}}</div><div class=group-item ng-click=addNewGroup()>+</div></div><div class=table-header><div class=flex-3>&nbsp;</div><div class=flex-14 translate=Items></div><div class=flex-5 translate="Sys tag"></div><div class=flex-4 translate=Quantity></div><div class=flex-4 translate=Unit></div><div class=flex-6 translate="Unit Price"></div><div class=flex-9 translate=Dimensions></div><div class=flex-3 translate=Waste></div><div class=flex-4 translate=Level></div><div class=flex-6 translate="Cost Price"></div><div class=flex-6 translate="Labour (H)"></div><div class=flex-9 translate="Operating Cost"></div><div class=flex-6 translate="Profit (%)"></div><div class=flex-9 translate="Profit In"></div><div class=flex-9 translate="Sales Price"></div><div class=flex-3>&nbsp;</div></div><div class=table-body><div ng-repeat="item in currentData.items" ng-if="item.group == activeGroupItem"><div class="lines top-lines" ng-if="item.rowStyle == \'Combined\'"><div class="item-line align-items-center"><!-- <div class="flex-3 d-flex align-items-center justify-content-center">\n                    <img src="/assets/icons/more_vert.svg" alt=""/>\n                  </div> --><calc-selector ng-model=item ng-selected=vm.onSelectStyle(item) class="flex-3 d-flex align-items-center justify-content-center"></calc-selector><div class="flex-14 pr-4"><selectbox2 ng-if="item.subStyle===\'Material\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.materials label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Building Part\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.buildingparts label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCP\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.dcps label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCQ\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.dcqs label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Equipment\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.equipments label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><input ng-if="item.subStyle===\'Custom\'" type=text ng-model=item.item.work></div><div class="flex-5 pr-4 tag-container"><input type=text ng-model=item.item.tag><!-- <div class="dropdown">\n                      <button class="dropdown-toggle text-left" type="button" data-toggle="dropdown" ng-model="item.item.tag">{{item.item.tag}}</button>\n                      <ul class="dropdown-menu" role="menu">\n                        <li class="menu-item" value="" ng-repeat="tag in vm.categoryTags"\n                          ng-click="onTagSelect(tag, item)">\n                          {{tag.tagName}}\n                        </li>\n                      </ul>\n                    </div> --></div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.qty ng-change=calcSingleItem(item)></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.unit>{{item.item.unit}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="unit in vm.units" ng-click="onUnitSelect(unit, item.item)">{{unit.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.unitPrice number-edit=2 ng-change=calcSingleItem(item)></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.dimension class=text-center></div><div class="flex-3 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.item.waste | readable: 2 }}</span></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.level>{{item.item.level}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="level in vm.levels" ng-click="onLevelSelect(level, item.item)">{{level.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.cost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.opCost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profitP ng-change=calcSingleItem(item) number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profit number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.salesPrice number-edit=2></div><div class="flex-3 d-flex align-items-center"><img src=/assets/icons/close-24-dark.svg alt="" ng-click=removeItem(item)></div></div><div class="worker-line align-items-center"><div class="flex-3 d-flex align-items-center"></div><div class="flex-14 pr-4"><selectbox2 class="calc-select inventory-select dropdown-primary" ng-model=item.worker.work options=vm.workers label-field=description value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2></div><div class="flex-5 pr-4 tag-container"></div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.qty ng-change=calcSingleItem(item)></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.worker.unit>{{item.worker.unit}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="unit in vm.units" ng-click="onUnitSelect(unit, item.worker)">{{unit.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.unitPrice number-edit=2 ng-change=calcSingleItem(item)></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-3 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.worker.waste | readable: 2 }}</span></div><div class="flex-4 pr-4 tag-container"></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.cost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.worker.labor | readable: 2 }}</span></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.opCost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.profitP ng-change=calcSingleItem(item) number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.profit number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.salesPrice number-edit=2></div><div class="flex-3 d-flex align-items-center"></div></div></div><div class="lines top-lines" ng-if="item.rowStyle == \'Inventory\'"><div class="item-line align-items-center"><calc-selector ng-model=item ng-selected=vm.onSelectStyle(item) class="flex-3 d-flex align-items-center justify-content-center"></calc-selector><div class="flex-14 pr-4"><selectbox2 ng-if="item.subStyle===\'Material\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.materials label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Building Part\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.buildingparts label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCP\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.dcps label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCQ\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.dcqs label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Equipment\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.equipments label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><input ng-if="item.subStyle===\'Custom\'" type=text ng-model=item.item.work></div><div class="flex-5 pr-4 tag-container"><input type=text ng-model=item.item.tag></div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.qty ng-change=calcSingleItem(item)></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.unit>{{item.item.unit}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="unit in vm.units" ng-click="onUnitSelect(unit, item.item)">{{unit.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.unitPrice number-edit=2 ng-change=calcSingleItem(item)></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.dimension class=text-center></div><div class="flex-3 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.item.waste | readable: 2 }}</span></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.level>{{item.item.level}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="level in vm.levels" ng-click="onLevelSelect(level, item.item)">{{level.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.cost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.opCost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profitP ng-change=calcSingleItem(item) number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profit number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.salesPrice number-edit=2></div><div class="flex-3 d-flex align-items-center"><img src=/assets/icons/close-24-dark.svg alt="" ng-click=removeItem(item)></div></div></div><div class="lines top-lines" ng-if="item.rowStyle == \'Worker\'"><div class="worker-line align-items-center"><calc-selector ng-model=item ng-selected=vm.onSelectStyle(item) class="flex-3 d-flex align-items-center justify-content-center"></calc-selector><div class="flex-14 pr-4"><selectbox2 class="calc-select inventory-select dropdown-primary" ng-model=item.worker.work options=vm.workers label-field=description value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2></div><div class="flex-5 pr-4 tag-container"></div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.qty ng-change=calcSingleItem(item)></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.worker.unit>{{item.worker.unit}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="unit in vm.units" ng-click="onUnitSelect(unit, item.worker)">{{unit.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.unitPrice number-edit=2 ng-change=calcSingleItem(item)></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-3 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.worker.waste | readable: 2 }}</span></div><div class="flex-4 pr-4 tag-container"></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.cost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.worker.labor | readable: 2 }}</span></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.opCost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.profitP ng-change=calcSingleItem(item) number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.profit number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.salesPrice number-edit=2></div><div class="flex-3 d-flex align-items-center"></div></div></div><div class="lines top-lines" ng-if="item.rowStyle == \'Collaborator\'"><div class="item-line align-items-center"><!-- <div class="flex-3 d-flex align-items-center justify-content-center">\n                    <img src="/assets/icons/more_vert.svg" alt=""/>\n                  </div> --><calc-selector ng-model=item ng-selected=vm.onSelectStyle(item) class="flex-3 d-flex align-items-center justify-content-center"></calc-selector><div class="flex-14 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.name></div><div class="flex-5 pr-4 tag-container"><input type=text ng-model=item.item.tag><!-- <div class="dropdown">\n                      <button class="dropdown-toggle text-left" type="button" data-toggle="dropdown" ng-model="item.item.tag">{{item.item.tag}}</button>\n                      <ul class="dropdown-menu" role="menu">\n                        <li class="menu-item" value="" ng-repeat="tag in vm.categoryTags"\n                          ng-click="onTagSelect(tag, item)">\n                          {{tag.tagName}}\n                        </li>\n                      </ul>\n                    </div> --></div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.qty ng-change=calcSingleItem(item)></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.unit>{{item.item.unit}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="unit in vm.units" ng-click="onUnitSelect(unit, item.item)">{{unit.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.unitPrice number-edit=2 ng-change=calcSingleItem(item)></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.dimension class=text-center></div><div class="flex-3 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.item.waste | readable: 2 }}</span></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.level>{{item.item.level}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="level in vm.levels" ng-click="onLevelSelect(level, item.item)">{{level.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.cost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.opCost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profitP ng-change=calcSingleItem(item) number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profit number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.salesPrice number-edit=2></div><div class="flex-3 d-flex align-items-center"><img src=/assets/icons/close-24-dark.svg alt="" ng-click=removeItem(item)></div></div><div class="worker-line align-items-center"><div class="flex-3 d-flex align-items-center"></div><div class="flex-14 pr-4"><input type=text ng-model=item.worker.work></div><div class="flex-5 d-flex pr-4 align-items-center">{{item.worker.work == \'Subcontractor\' ? \'Time\' : \'Delivery\'}}</div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.qty ng-change=calcSingleItem(item)></div><div class="flex-4 pr-4 tag-container">{{item.worker.work == \'Subcontractor\' ? \'days/hr\' : \'days\'}}</div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-3 d-flex pr-4 align-items-center"></div><div class="flex-4 pr-4 tag-container"></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-3 d-flex align-items-center"></div></div></div></div><div ng-repeat="group in currentData.groups" ng-if=!activeGroupItem class=group-container><div class="lines top-lines"><div class="item-line align-items-center"><div class="flex-3 d-flex align-items-center justify-content-center"></div><div class="flex-45 d-flex pr-4 text-wrap"><img src=/assets/icons/arrow_drop_down_collapse_gray.svg alt="" ng-if=!group.opened ng-click="group.opened = true" class=mr-2> <img src=/assets/icons/arrow_drop_down_collapse_open.svg alt="" ng-if=group.opened ng-click="group.opened = false" class=mr-2> {{ group.title }}</div><!-- <div class="flex-5 pr-4 tag-container"></div>\n                <div class="flex-4 d-flex pr-4 align-items-center"></div>\n                <div class="flex-4 pr-4 tag-container"></div>\n                <div class="flex-6 d-flex pr-4 align-items-center"></div> --><!-- <div class="flex-9 d-flex pr-4 align-items-center"></div>\n                <div class="flex-3 d-flex pr-4 align-items-center"></div> --><div class="flex-4 pr-4 tag-container"></div><div class="flex-6 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ calcTotalCost(group.id) | readable: 2 }}</span></div><div class="flex-6 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ calcTotalLabor(group.id) | readable: 2 }}</span></div><div class="flex-9 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ calcTotalCompanyCost(group.id) | readable: 2 }}</span></div><div class="flex-6 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ calcTotalProfitPercent(group.id) | readable: 2 }}</span></div><div class="flex-9 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ calcTotalProfit(group.id) | readable: 2 }}</span></div><div class="flex-9 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ calcTotalSalesPrice(group.id) | readable: 2 }}</span></div><div class="flex-3 d-flex align-items-center"></div></div></div><div ng-repeat="item in currentData.items" ng-if="group.opened && item.group == group.id" class=group-items><div class="lines top-lines" ng-if="item.rowStyle == \'Combined\'"><div class="item-line align-items-center"><!-- <div class="flex-3 d-flex align-items-center justify-content-center">\n                      <img src="/assets/icons/more_vert.svg" alt=""/>\n                    </div> --><calc-selector ng-model=item ng-selected=vm.onSelectStyle(item) class="flex-3 d-flex align-items-center justify-content-center"></calc-selector><div class="flex-14 pr-4"><selectbox2 ng-if="item.subStyle===\'Material\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.materials label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Building Part\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.buildingparts label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCP\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.dcps label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCQ\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.dcqs label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Equipment\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.equipments label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><input ng-if="item.subStyle===\'Custom\'" type=text ng-model=item.item.work></div><div class="flex-5 pr-4 tag-container"><input type=text ng-model=item.item.tag><!-- <div class="dropdown">\n                        <button class="dropdown-toggle text-left" type="button" data-toggle="dropdown" ng-model="item.item.tag">{{item.item.tag}}</button>\n                        <ul class="dropdown-menu" role="menu">\n                          <li class="menu-item" value="" ng-repeat="tag in vm.categoryTags"\n                            ng-click="onTagSelect(tag, item)">\n                            {{tag.tagName}}\n                          </li>\n                        </ul>\n                      </div> --></div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.qty ng-change=calcSingleItem(item)></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.unit>{{item.item.unit}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="unit in vm.units" ng-click="onUnitSelect(unit, item.item)">{{unit.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.unitPrice number-edit=2 ng-change=calcSingleItem(item)></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.dimension class=text-center></div><div class="flex-3 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.item.waste | readable: 2 }}</span></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.level>{{item.item.level}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="level in vm.levels" ng-click="onLevelSelect(level, item.item)">{{level.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.cost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.opCost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profitP ng-change=calcSingleItem(item) number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profit number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.salesPrice number-edit=2></div><div class="flex-3 d-flex align-items-center"><img src=/assets/icons/close-24-dark.svg alt="" ng-click=removeItem(item)></div></div><div class="worker-line align-items-center"><div class="flex-3 d-flex align-items-center"></div><div class="flex-14 pr-4"><selectbox2 class="calc-select inventory-select dropdown-primary" ng-model=item.worker.work options=vm.workers label-field=description value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2></div><div class="flex-5 pr-4 tag-container"></div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.qty ng-change=calcSingleItem(item)></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.worker.unit>{{item.worker.unit}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="unit in vm.units" ng-click="onUnitSelect(unit, item.worker)">{{unit.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.unitPrice number-edit=2 ng-change=calcSingleItem(item)></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-3 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.worker.waste | readable: 2 }}</span></div><div class="flex-4 pr-4 tag-container"></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.cost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.worker.labor | readable: 2 }}</span></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.opCost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.profitP ng-change=calcSingleItem(item) number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.profit number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.salesPrice number-edit=2></div><div class="flex-3 d-flex align-items-center"></div></div></div><div class="lines top-lines" ng-if="item.rowStyle == \'Inventory\'"><div class="item-line align-items-center"><calc-selector ng-model=item ng-selected=vm.onSelectStyle(item) class="flex-3 d-flex align-items-center justify-content-center"></calc-selector><div class="flex-14 pr-4"><selectbox2 ng-if="item.subStyle===\'Material\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.materials label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Building Part\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.buildingparts label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCP\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.dcps label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCQ\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.dcqs label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Equipment\'" class="calc-select inventory-select dropdown-primary" ng-model=item.item.work options=vm.equipments label-field=name value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2><input ng-if="item.subStyle===\'Custom\'" type=text ng-model=item.item.work></div><div class="flex-5 pr-4 tag-container"><input type=text ng-model=item.item.tag></div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.qty ng-change=calcSingleItem(item)></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.unit>{{item.item.unit}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="unit in vm.units" ng-click="onUnitSelect(unit, item.item)">{{unit.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.unitPrice number-edit=2 ng-change=calcSingleItem(item)></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.dimension class=text-center></div><div class="flex-3 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.item.waste | readable: 2 }}</span></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.level>{{item.item.level}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="level in vm.levels" ng-click="onLevelSelect(level, item.item)">{{level.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.cost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.opCost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profitP ng-change=calcSingleItem(item) number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profit number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.salesPrice number-edit=2></div><div class="flex-3 d-flex align-items-center"><img src=/assets/icons/close-24-dark.svg alt="" ng-click=removeItem(item)></div></div></div><div class="lines top-lines" ng-if="item.rowStyle == \'Worker\'"><div class="worker-line align-items-center"><calc-selector ng-model=item ng-selected=vm.onSelectStyle(item) class="flex-3 d-flex align-items-center justify-content-center"></calc-selector><div class="flex-14 pr-4"><selectbox2 class="calc-select inventory-select dropdown-primary" ng-model=item.worker.work options=vm.workers label-field=description value-field=_id select-event="vm.onChangeInventory(item, value)" is-title=true></selectbox2></div><div class="flex-5 pr-4 tag-container"></div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.qty ng-change=calcSingleItem(item)></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.worker.unit>{{item.worker.unit}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="unit in vm.units" ng-click="onUnitSelect(unit, item.worker)">{{unit.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.unitPrice number-edit=2 ng-change=calcSingleItem(item)></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-3 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.worker.waste | readable: 2 }}</span></div><div class="flex-4 pr-4 tag-container"></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.cost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.worker.labor | readable: 2 }}</span></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.opCost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.profitP ng-change=calcSingleItem(item) number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.profit number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.worker.salesPrice number-edit=2></div><div class="flex-3 d-flex align-items-center"></div></div></div><div class="lines top-lines" ng-if="item.rowStyle == \'Collaborator\'"><div class="item-line align-items-center"><!-- <div class="flex-3 d-flex align-items-center justify-content-center">\n                      <img src="/assets/icons/more_vert.svg" alt=""/>\n                    </div> --><calc-selector ng-model=item ng-selected=vm.onSelectStyle(item) class="flex-3 d-flex align-items-center justify-content-center"></calc-selector><div class="flex-14 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.name></div><div class="flex-5 pr-4 tag-container"><input type=text ng-model=item.item.tag><!-- <div class="dropdown">\n                        <button class="dropdown-toggle text-left" type="button" data-toggle="dropdown" ng-model="item.item.tag">{{item.item.tag}}</button>\n                        <ul class="dropdown-menu" role="menu">\n                          <li class="menu-item" value="" ng-repeat="tag in vm.categoryTags"\n                            ng-click="onTagSelect(tag, item)">\n                            {{tag.tagName}}\n                          </li>\n                        </ul>\n                      </div> --></div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.qty ng-change=calcSingleItem(item)></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.unit>{{item.item.unit}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="unit in vm.units" ng-click="onUnitSelect(unit, item.item)">{{unit.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.unitPrice number-edit=2 ng-change=calcSingleItem(item)></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.dimension class=text-center></div><div class="flex-3 d-flex pr-4 align-items-center"><span class="input d-flex align-items-center">{{ item.item.waste | readable: 2 }}</span></div><div class="flex-4 pr-4 tag-container"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.item.level>{{item.item.level}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="level in vm.levels" ng-click="onLevelSelect(level, item.item)">{{level.name}}</li></ul></div></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.cost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.opCost number-edit=2></div><div class="flex-6 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profitP ng-change=calcSingleItem(item) number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.profit number-edit=2></div><div class="flex-9 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.salesPrice number-edit=2></div><div class="flex-3 d-flex align-items-center"><img src=/assets/icons/close-24-dark.svg alt="" ng-click=removeItem(item)></div></div><div class="worker-line align-items-center"><div class="flex-3 d-flex align-items-center"></div><div class="flex-14 pr-4"><input type=text ng-model=item.worker.work></div><div class="flex-5 d-flex pr-4 align-items-center">{{item.worker.work == \'Subcontractor\' ? \'Time\' : \'Delivery\'}}</div><div class="flex-4 d-flex pr-4 align-items-center"><input type=text ng-model=item.item.days></div><div class="flex-4 pr-4 tag-container">{{item.worker.work == \'Subcontractor\' ? \'days/hr\' : \'days\'}}</div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-3 d-flex pr-4 align-items-center"></div><div class="flex-4 pr-4 tag-container"></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-6 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-9 d-flex pr-4 align-items-center"></div><div class="flex-3 d-flex align-items-center"></div></div></div></div></div><div class="lines sum-line"><div class=flex-3>&nbsp;</div><div class=flex-14 translate=Sum></div><div class=flex-5></div><div class=flex-4></div><div class=flex-4></div><div class=flex-6></div><div class=flex-9></div><div class=flex-3></div><div class=flex-4></div><div class=flex-6>{{ companyCurrency.symbol + \' \' + (calcTotalCost() | readable: 2) }}</div><div class=flex-6>{{ \'hr\' + \' \' + (calcTotalLabor() | readable: 2) }}</div><div class=flex-9>{{ companyCurrency.symbol + \' \' + (calcTotalCompanyCost() | readable: 2) }}</div><div class=flex-6>{{ (calcTotalProfitPercent() | readable: 2) + \' %\' }}</div><div class=flex-9>{{ companyCurrency.symbol + \' \' + (calcTotalProfit() | readable: 2) }}</div><div class=flex-9>{{ companyCurrency.symbol + \' \' + (calcTotalSalesPrice() | readable: 2) }}</div><div class=flex-3>&nbsp;</div></div><div class="lines additional-lines"><div class=flex-3>&nbsp;</div><div class="flex-14 d-flex align-items-center">Additional&nbsp;&nbsp;<input type=text ng-model=vm.additional number-edit=2 style="width: 100px;">&nbsp;&nbsp;%</div><div class=flex-5></div><div class=flex-4></div><div class=flex-4></div><div class=flex-6></div><div class=flex-9></div><div class=flex-3></div><div class=flex-4></div><div class=flex-6></div><div class=flex-6></div><div class=flex-9></div><div class=flex-6></div><div class=flex-9></div><div class=flex-9>{{ companyCurrency.symbol + \' \' + ((calcTotalSalesPrice() * vm.additional / 100) | readable: 2) }}</div><div class=flex-3>&nbsp;</div></div><div class="lines sum-line"><div class=flex-3>&nbsp;</div><div class=flex-14 translate="Sum Total"></div><div class=flex-5></div><div class=flex-4></div><div class=flex-4></div><div class=flex-6></div><div class=flex-9></div><div class=flex-3></div><div class=flex-4></div><div class=flex-6>{{ companyCurrency.symbol + \' \' + (calcTotalCost() | readable: 2) }}</div><div class=flex-6>{{ \'hr\' + \' \' + (calcTotalLabor() | readable: 2) }}</div><div class=flex-9>{{ companyCurrency.symbol + \' \' + (calcTotalCompanyCost() | readable: 2) }}</div><div class=flex-6>{{ (calcTotalProfitPercent() | readable: 2) + \' %\' }}</div><div class=flex-9>{{ companyCurrency.symbol + \' \' + (calcTotalProfit() | readable: 2) }}</div><div class=flex-9>{{ companyCurrency.symbol + \' \' + ((calcTotalSalesPrice() * (100 + vm.additional) / 100) | readable: 2) }}</div><div class=flex-3>&nbsp;</div></div></div><div class=table-footer ng-if=activeGroupItem><div class=circle><img src=/assets/icons/plus.svg alt="" ng-click=addNewLine()></div><div translate="Add Item" ng-click=addNewLine()></div></div></div></div></div></main>');
$templateCache.put('app/main/calc/calcMain/calcMain.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div id=calc-main class=main-container ng-if=!isLoading><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=calcMain class="ft-normal-12-16 grey-2" translate=Calculation></a></div><div class=header-title translate="Part Estimate"></div></div><div class="flex-between ml-auto"><button class=button-primary ng-click=onRefreshSheet()><img src=/assets/icons/sync.svg alt=""><span translate=Refresh></span></button> <button class="button-secondary ml-16" ng-click=openVersionModal() ng-if="CALC_ACCESS_CREATE > 1"><img src=/assets/icons/save-icon.svg alt=""><span translate=Save></span></button></div></div><div class=d-flex><div class=side-bar><div class=grid ng-class="{\'icon-active\': sideIconNum == 1}" ng-click=vm.addNewGroup() ng-if="CALC_ACCESS_CREATE > 2" data-toggle=tooltip data-trigger=hover title="Add Root Group"><img src=/assets/icons/bx-plus.svg alt=logo></div><div class=grid ng-class="{\'icon-active\': sideIconNum == 2}" ng-click=vm.gotoVersion() data-toggle=tooltip data-trigger=hover title="Version History"><img src=/assets/icons/calc-history.svg alt=logo></div><!-- <div class="grid" ng-class="{\'icon-active\': sideIconNum == 3}" ng-click="downloadCalcSheet()"\n            data-toggle="tooltip" data-trigger="hover" title="Download sheet">\n          <img src="/assets/icons/calc-download.svg" alt="logo"/>\n        </div> --><div class=grid ng-class="{\'icon-active\': sideIconNum == 5}" ng-click=openConfigModal() ng-if="CALC_ACCESS_CREATE > 1" data-toggle=tooltip data-trigger=hover title=Settings><img src=/assets/icons/setting-icon9.svg alt=logo></div><div class=grid ng-class="{\'icon-active\': sideIconNum == 6}" ng-click=openOrganizeModal() ng-if="CALC_ACCESS_CREATE > 1" data-trigger=hover title="Reorder and Reposition Groups and sublevels"><img src=/assets/icons/organization.svg alt=logo></div><div class=grid ng-class="{\'icon-active\': sideIconNum == 7}" ng-click=openStructureModal() data-trigger=hover data-trigger=hover title="Structure Tree"><img src=/assets/icons/calc-hierarchial.svg alt=logo></div><!-- <div class="grid" ng-class="{\'icon-active\': sideIconNum == 8}" ng-click="openVersionModal()"\n            data-toggle="tooltip" data-trigger="hover" title="Save">\n          <img src="/assets/icons/icon7.svg" alt="logo"/>\n        </div> --></div><div class=content-wrapper><div><div class=bread-crumb><div class=item ng-click=vm.goToRoot() translate=Root></div><div class=flex ng-repeat="item in vm.currentStateList track by $index"><img src=/assets/icons/arrow-right2.svg alt="" class=mr-4><div class=item ng-click=vm.changeBreadCrumb($index)>{{ item.name }}</div></div></div><div ng-if=!vm.openBreadCumb><calc-group ng-repeat="level in tableInventory track by $index" index=$index ng-model=level level-id=levelId work-types=vm.workTypes work-levels=vm.workLevels materials=vm.materials dcps=vm.dcps equipments=vm.equipments dcqs=vm.dcqs workers=vm.workers subcontractors=vm.subcontractors level-depth=vm.levelDepth company-currency=companyCurrency current-state-list=vm.currentStateList global-profit=vm.globalProfit worker-cost=vm.workerCost cost-percents=vm.costPercents on-remove-level=vm.deleteRootLevel on-enter-child=vm.callBreadCrumb on-delete-sub-level=vm.deleteSubLevel on-remove-item=vm.deleteItem on-update-item=vm.onUpdateItem on-item-changed=vm.onItemChanged permission=CALC_ACCESS_CREATE></calc-group><div class="cal-total box-shadow-white" ng-if="vm.extraCosts && vm.extraCosts.length"><div class=title><div class=flex-5>&nbsp;</div><div class=w-24></div><div class=flex-13 translate="Extra Costs"></div><div class=flex-8>&nbsp;</div><div class=flex-7></div><div class=flex-3>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-5>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-6>&nbsp;</div><div class=flex-8 translate="Cost in %"></div><div class=flex-8 translate=Cost></div></div><div class="sum pos-relative" ng-repeat="cost in vm.extraCosts track by $index"><div class=flex-5>&nbsp;</div><div class=w-24></div><div class="flex-13 overflow-visible">{{cost.name}}</div><div class=flex-8>&nbsp;</div><div class=flex-7>&nbsp;</div><div class=flex-3>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-5>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-6>&nbsp;</div><div class=flex-8 title="{{ cost.value | readable: 2 }}">{{ cost.value | readable: 2 }}</div><div class=flex-8 title="{{companyCurrency.symbol + \' \' + ((totalSum * cost.value / 100) | readable: 2)}}">{{ companyCurrency.symbol }}&nbsp;{{ (totalSum * cost.value / 100) | readable: 2 }}</div><div class=delete-com><div class="dropdown btn-del"><button class="dropdown-toggle btn-del" type=button id=menu46 data-toggle=dropdown ng-if="CALC_ACCESS_CREATE > 1"><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu46><li class=menu-item value="" ng-click=openEditCostConfig(cost) ng-if="CALC_ACCESS_CREATE > 1"><img src=/assets/icons/edit-black.svg alt="">Edit</li><li class=menu-item value="" ng-click=removeAdditionalCost(cost) ng-if="CALC_ACCESS_CREATE > 3"><img src=/assets/icons/delete4.svg alt="">Delete</li></ul></div></div></div></div><div class="cal-total box-shadow-white"><div class=title><div class=flex-5>&nbsp;</div><div class=w-24></div><div class=flex-13 translate=Total></div><div class=flex-8>&nbsp;</div><div class=flex-7>&nbsp;</div><div class=flex-3>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-5>&nbsp;</div><div class=flex-8 translate="Cost Price"></div><div class=flex-8 translate="Labour Hours"></div><div class=flex-8><span translate="Operating Cost"></span></div><div class=flex-6><span translate=Profit></span> in %</div><div class=flex-8 translate=Profit></div><div class="flex-8 overflow-visible"><div class=flex><div><span translate="Sales Price"></span></div><div class=alarm1 ng-mouseover="hoverIn=true" ng-mouseleave="hoverIn=false" ng-init="hoverIn=false"><img src=/assets/icons/alarm1.svg alt=""></div></div><div class="sales-price pos-relative" ng-if=hoverIn><div class="european ft_14_regular_gray"><div><span translate="Sales Price"></span> : {{totalSumWithAdditionalCost | readable: 2}}</div><div><span translate=Material/Equipment></span> : {{totalInventoryCost | readable: 2}}</div><div><span translate="Labour Cost"></span> : {{totalWorkerCost | readable: 2}}</div><div><span translate="Operating Cost"></span> : {{totalCompanyCost | readable: 2}}</div><div><span translate=Profit></span> : {{totalProfit| readable: 2}}</div></div></div></div></div><div class=sum><div class=flex-5>&nbsp;</div><div class=w-24></div><div class=flex-13 translate=Sum></div><div class=flex-6>&nbsp;</div><div class=flex-11>&nbsp;</div><div class=flex-3>&nbsp;</div><div class=flex-6>&nbsp;</div><div class=flex-5>&nbsp;</div><div class=flex-8 title="{{companyCurrency.symbol + \' \' + (totalCostPrice | readable: 2)}}">{{ companyCurrency.symbol }}&nbsp;{{ totalCostPrice | readable: 2 }}</div><div class=flex-8 title="{{ \'hr \' + (totalWorkingHours | readable: 2) }}">hr {{ totalWorkingHours | readable: 2 }}</div><div class=flex-8 title="{{companyCurrency.symbol + \' \' + (totalCompanyCost | readable: 2)}}">{{ companyCurrency.symbol }}&nbsp;{{ totalCompanyCost | readable: 2 }}</div><div class=flex-6>{{ (totalProfit / totalSum * 100) | readable: 2 }}</div><div class=flex-8 title="{{ companyCurrency.symbol + \' \' + (totalProfit | readable: 2) }}">{{ companyCurrency.symbol }}&nbsp;{{ totalProfit | readable: 2 }}</div><div class=flex-8 title="{{companyCurrency.symbol + \' \' + (totalSumWithAdditionalCost | readable: 2)}}">{{ companyCurrency.symbol }}&nbsp;{{ totalSumWithAdditionalCost | readable: 2 }}</div></div></div><div class="add-cost-wrapper box-shadow-white"><div class=add-types ng-click=openAddCostConfig() ng-if="CALC_ACCESS_CREATE > 2"><div class=item><img src=/assets/icons/plus.svg alt=""></div><div translate="Add Cost"></div></div><div class=dropdown><button class=dropdown-toggle type=button id=menu1 data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="add-types h-100"><div class=item><img src=/assets/icons/preview-eye2.svg alt=""></div><div translate="View Cost"></div></div></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li class=d-flex id="{{ percent._id }}" ng-repeat="percent in vm.costPercents"><a href=#><div class=item><div class="w-100 d-flex" data-ng-click=openEditCostConfig(percent)><div class=box-border ng-if="percent.type===\'global\'">G</div><div class="percent-name tx-ellipsis">{{ percent.name }}:</div><div class="ml-auto text-right d-inline-block" style="width: 30px;">{{ percent.value }}%</div></div><img class=ml-3 src=/assets/icons/close-circle-f-gray.svg ng-click=removeAdditionalCost(percent)></div></a></li><li ng-if="!vm.costPercents || vm.costPercents.length === 0"><a href=#><div class="d-flex w-100" data-ng-click=openAddCostConfig()><img class=mr-3 src=/assets/icons/bxs-plus-circle.svg alt="Add New"> <span class=ft_12_600_black translate="Add Cost"></span></div></a></li></ul></div></div></div><div ng-if=vm.openBreadCumb><calc-group index=vm.breadCrumbIndex ng-model=vm.currentState work-types=vm.workTypes work-levels=vm.workLevels level-id=levelId materials=vm.materials buildingparts=vm.buildingparts dcps=vm.dcps equipments=vm.equipments dcqs=vm.dcqs workers=vm.workers subcontractors=vm.subcontractors level-depth=vm.levelDepth company-currency=companyCurrency current-state-list=vm.currentStateList global-profit=vm.globalProfit worker-cost=vm.workerCost cost-percents=vm.costPercents on-remove-level=vm.deleteSubLevel on-enter-child=vm.callBreadCrumbSubLevel on-delete-sub-level=vm.deleteSubLevel on-remove-item=vm.deleteItem on-update-item=vm.onUpdateItem on-item-changed=vm.onItemChanged permission=CALC_ACCESS_CREATE></calc-group></div></div></div></div></div></main>');
$templateCache.put('app/main/calc/companyBudget/companyBudget.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=companyBudget class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref="calcExtra({id: \'prepare\'})" class="ft-normal-12-16 grey-2" translate=Calculation></a></div><div class=header-title translate="Company Budget"></div></div><div class="flex-between ml-auto"><selectbox-input class="years dropdown-primary" options=vm.years ng-model=vm.year label-field=year value-field=year select-event=vm.selectYear()></selectbox-input><button class="button-primary template ml-16" ng-click=vm.editTemplate()><img src=/assets/icons/edit-icon.svg alt=""><span translate=Template></span></button> <button class="button-secondary save ml-16" ng-click=vm.save()><img src="/assets/icons/bx-save 2.svg" alt=""> <span translate=Save></span></button></div></div><div class=budget-table ng-repeat="section in vm.sections"><div class="table-col table-grid"><div class=table-content><div class=table-header><div class=table-cell>{{section.name}}</div></div><div class=table-row ng-repeat-start="budget in section.budgets"><div class="table-cell d-flex"><div class=mark-parent ng-if=budget.focus></div><div class=number>{{budget.index}}</div><div class=ml-10><div class=cell-title>{{budget.title}}</div><div class=cell-content>{{budget.subtitle}}</div></div></div></div><div class="table-row child" ng-repeat-end=budget ng-repeat="child in budget.children"><div class="table-cell d-flex"><div class=mark-parent ng-if=child.focus></div><div class=number>{{budget.index}}.{{$index + 1}}</div><div class=pl-10><div class=cell-title>{{child.title}}</div><div class=cell-content>{{child.subtitle}}</div></div></div></div><div class="table-row summary"><div class="table-cell flex-items-center"><div class=number>*</div><div class="cell-title ml-10">{{section.dynamicSum.title}}</div></div></div><div class="table-row summary" ng-repeat="summary in section.summaries"><div class="table-cell flex-items-center"><div class=number>{{summary.index}}</div><div class="cell-title ml-10">{{summary.title}}</div></div></div></div></div><div class="table-col table-times"><div class=table-header><div class=table-cell ng-repeat="date in vm.dates track by $index"><span translate={{date}}></span></div></div><div class=table-content><div class=table-row ng-repeat-start="budget in section.budgets"><div class=table-cell ng-repeat="value in budget.values track by $index"><div class=amount><input type=text number-edit=0 ng-model=value ng-focus=vm.setFocus(budget) ng-blur="vm.changeBudgetValue(section, budget)"></div><div class=percent>100%</div></div></div><div class="table-row child" ng-repeat-end=budget ng-repeat="child in budget.children"><div class=table-cell ng-repeat="value in child.values"><div class=amount><div class="w-100 text-right">{{value.amount | readable: 0}}</div></div><div class=percent>{{value.percent | readable: 0}}%</div></div></div><div class="table-row summary"><div class="table-cell text-right" ng-repeat="value in section.dynamicSum.values track by $index">{{value | readable: 0}}</div></div><div class="table-row summary" ng-repeat="summary in section.summaries"><div class="table-cell text-right" ng-repeat="value in summary.values track by $index">{{value | readable: 0}}</div></div></div></div><div class="table-col table-sum"><div class=table-header><div class=table-cell translate=Sum></div></div><div class=table-content><div class=table-row ng-repeat-start="budget in section.budgets"><div class="table-cell text-right"><div class=amount>{{budget.sum | readable: 0}}</div></div></div><div class="table-row child" ng-repeat-end=budget ng-repeat="child in budget.children"><div class="table-cell text-right"><div class=amount>{{child.sum | readable: 0}}</div></div></div><div class="table-row summary"><div class="table-cell text-right">{{section.dynamicSum.sum | readable: 0}}</div></div><div class="table-row summary" ng-repeat="summary in section.summaries"><div class="table-cell text-right">{{summary.sum | readable: 0}}</div></div></div></div></div><div class="budget-table mt-20" ng-repeat="summary in vm.summaries"><div class="table-col table-grid"><div class=table-content><div class=table-header><div class=table-cell>{{summary.name}}</div></div><div class="table-row summary"><div class=table-cell><div class="cell-title ml-30">{{summary.title}}</div></div></div></div></div><div class="table-col table-times"><div class=table-header><div class=table-cell ng-repeat="date in vm.dates track by $index">{{date}}</div></div><div class=table-content><div class="table-row summary"><div class="table-cell text-right" ng-repeat="value in summary.values track by $index">{{value | readable: 0}}</div></div></div></div><div class="table-col table-sum"><div class=table-header><div class=table-cell translate=Sum></div></div><div class=table-content><div class="table-row summary"><div class="table-cell text-right">{{summary.sum | readable: 0}}</div></div></div></div></div><!-- <div class="budget-table mt-20">\n      <div class="table-col table-grid">\n        <div class="table-header"><div class="table-cell">Total</div></div>\n        <div class="table-content">\n          <div class="table-row summary"><div class="table-cell"><div class="cell-title ml-30">Total Sum</div></div></div>\n        </div>\n      </div>\n      <div class="table-col table-times">\n        <div class="table-header"><div class="table-cell" ng-repeat="date in vm.dates track by $index">{{date}}</div></div>\n        <div class="table-content">\n          <div class="table-row summary">\n            <div class="table-cell text-right" ng-repeat="value in vm.totalValues track by $index">{{value | readable: 0}}</div>\n          </div>\n        </div>\n      </div>\n      <div class="table-col table-sum">\n        <div class="table-header"><div class="table-cell">Sum</div></div>\n        <div class="table-content">\n          <div class="table-row summary"><div class="table-cell text-right">{{vm.totalSum | readable: 0}}</div></div>\n        </div>\n      </div>\n    </div> --><spinner ng-if=isLoading></spinner></div></main>');
$templateCache.put('app/main/calc/directives/calc-version-treeitem.html','<div ui-tree-handle data-nodrag class=calc-version-tree-node ng-class="item.empty ? \'empty\' : item.diff ? \'\' + item.diff : \'diff-none\'"><span class=tree-content>{{item.name}}</span> <a ng-if="item.levels && item.levels.length > 0" class=ml-auto ng-click=toggle(this)><img src=/assets/icons/chevron-down-black.svg ng-if=this.collapsed alt=""> <img src=/assets/icons/chevron-up-black.svg ng-if=!this.collapsed alt=""></a></div><br><ol ui-tree-nodes="" ng-model=item.levels ng-class="{\'angular-ui-tree-hidden\': collapsed}"><li ng-repeat="item in item.levels" ng-init="child=true" ui-tree-node ng-class="item.empty ? \'empty\' : \'\'" ng-include="\'/app/main/calc/directives/calc-version-treeitem.html\'"></li></ol><div class=arrow ng-if=child><span class="line left"></span><span class="line right"></span></div>');
$templateCache.put('app/main/calc/modals/calc-tree.html','<div ui-tree-handle class=calc-tree-node><div>{{level.name}}</div><a ng-if="(level.levels && level.levels.length > 0) || (level.items && level.items.length > 0)" class="ml-auto pl-10" data-nodrag ng-click=toggle(this)><img src=/assets/icons/chevron-down-black.svg ng-if=this.collapsed alt=""> <img src=/assets/icons/chevron-up-black.svg ng-if=!this.collapsed alt=""></a></div><ol ui-tree-nodes ng-model=level.levels ng-class="{\'angular-ui-tree-hidden\': collapsed}"><li ui-tree-node ng-repeat="level in level.levels" ng-init="child=true" ng-include="\'app/main/calc/modals/calc-tree.html\'" class=calc-tree-li data-scroll-container=.calc-tree></li></ol><ol ui-tree-nodes ng-model=level.items ng-class="{\'angular-ui-tree-hidden\': collapsed}"><li ui-tree-node ng-repeat="item in level.items" class=calc-tree-li data-scroll-container=.calc-tree><div ui-tree-handle class=calc-tree-node><span class=ml-10>{{item.inventoryName}}</span> <a ng-if="item.items && item.items.length > 0" class="ml-auto pl-10" data-nodrag ng-click="expandNode(this, $event, item)"><img src=/assets/icons/chevron-down-black.svg ng-if=this.collapsed alt=""> <img src=/assets/icons/chevron-up-black.svg ng-if=!this.collapsed alt=""></a><div class=arrow><span class="line left"></span><span class="line right"></span></div></div><ol ui-tree-nodes ng-model=item.items ng-class="{\'angular-ui-tree-hidden\': collapsed}" ng-if="item.items && item.items.length > 0"><li ui-tree-node ng-repeat="item in item.items" data-scroll-container=.calc-tree><div ui-tree-handle class=calc-tree-node><span class=ml-10>{{item.inventoryName}}</span><div class=arrow><span class="line left"></span><span class="line right"></span></div></div></li></ol></li></ol><div class=arrow ng-if=child><span class="line left"></span><span class="line right"></span></div>');
$templateCache.put('app/main/calendar/company/companyCalendar.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div id=company-calendar class=main-container><div class="content-wrapper-calendar d-flex"><side-navbar page=shiftplanning></side-navbar><div class=side-menu><div class="flex-between mb-16"><div class=box-title><span class=icon><img src=/assets/icons/profile2_line_white.svg></span><span class=title translate="Shift Planning"></span></div><button class="btn-trans cursor-point" ng-click=collapseMenu()><img src=/assets/icons/btn-hamberg-white.svg></button></div><button class="button-create cursor-point" ng-click=vm.addSchedule()><img class=mr-4 src=/assets/icons/bx-plus2.svg> <span translate="Add Schedule"></span></button><div class="calendar mt-16 mb-16" id=side_calendar></div><div class=mb-16><ul class="mail-nav pb-4"><li class="cursor-point pr-0 tech-menu"><div class=flex-between><radio ng-model=currentDesignation ng-value="\'Manager\'"></radio><div class="ft_12_24_regular_white design-label" translate="My Schedule"></div></div></li><li class="cursor-point pr-0 tech-menu"><div class=flex-between><radio ng-model=currentDesignation ng-value="\'Subcontractor\'"></radio><div class="ft_12_24_regular_white design-label" translate="Schedule Overview"></div></div></li><li class="cursor-point pr-0 tech-menu"><div class=flex-between><radio ng-model=currentDesignation ng-value="\'Supplier\'"></radio><div class="ft_12_24_regular_white design-label" translate="Leave Schedule"></div></div></li><li class="cursor-point pr-0 tech-menu"><div class=flex-between><radio ng-model=currentDesignation ng-value="\'Employee\'"></radio><div class="ft_12_24_regular_white design-label" translate="Staff Availability"></div></div></li></ul></div><ul class=mail-nav><li class="cursor-point h-auto d-block pb-24" ng-repeat="($index, item) in calendars"><div class=flex-between ng-click=onExpand($index)><span class=name>{{item.name}}</span> <span><img src=/assets/icons/chevron-down-gray.svg ng-style="{\'display\': item.expanded ? \'block\': \'none\'}"> <img src=/assets/icons/chevron-right-gray.svg ng-style="{\'display\': item.expanded  ? \'none\': \'block\'}"></span></div><ul class=child-ul ng-style="{\'display\': item.expanded ? \'block\': \'none\'}"><li class="cursor-point pr-0 pl-1 tech-menu" ng-repeat="(key, subItem) in item.children"><div class="flex-between child-between" ng-click="onSelectItem($index, key)"><checkbox class=mr-10 ng-model=subItem.checked ng-click="onSelectItem(item._id, key)" ng-background-color=#363636 ng-border-color={{subItem.color}}></checkbox><span class=name>{{subItem.name}}</span></div></li></ul></li></ul></div><div class=side-menu-collapse ng-if=isCollapse><div class="flex-between mb-2"><button class="btn-trans cursor-point" ng-click=collapseMenu()><img src=/assets/icons/btn-hamberg-white.svg></button></div><button class="button-compose cursor-point" ng-click=onCompose()><img src=/assets/icons/bx-plus2.svg></button><div class=mail-nav-bar><ul class=mail-nav><li ui-sref=appMailInbox ui-sref-active=active class="cursor-point mail-box-li"><!-- <i class="fa fa-inbox mr-4"></i> --> <img src=/assets/icons/inbox_default.svg style="opacity: 0.5;"></li><li ui-sref=appMailSent ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/sent_default.svg></li><li ui-sref=appMailDraft ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/draft_default.svg></li><li ui-sref=appMailImportant ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/spam_default.svg></li><li ui-sref=appMailStared ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/trash_default.svg></li><li ui-sref=appMailSetting ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/setting_default.svg></li></ul></div></div><div class="right-side pos-relative"><div class="right-side-header flex-between"><div class=flex-items-center><div class="today-control flex-items-center mr-16"><div class="prev flex-center cursor-point" ng-click=vm.goPrevious()><img src="/assets/icons/chevron-left 3.svg" alt=icons></div><div class="next flex-center cursor-point" ng-click=vm.goNext()><img src="/assets/icons/chevron-right 3.svg" alt=icons></div></div><div class="pos-relative date-picker-control"><span class=ft_18_32_600_black ng-if="viewStyle==\'day\'">{{vm.date | fullDate}}</span> <span class=ft_18_32_600_black ng-if="viewStyle!=\'day\'">{{vm.range.first | smartDate}}-{{vm.range.last | smartDate}}</span><!-- <input type="text" id="date-input" class="ft_12_regular_black mr-16"\n                date-picker="dd/MM/yyyy" date="vm.date" is-open="isDateOpen">\n              <img src="/assets/icons/bx-calendar.svg" class="pos-absolute icon cursor-point" ng-click="isDateOpen = !isDateOpen"> --></div></div><div class="flex-items-center ml-auto"><div class="flex-items-center view-by pos-relative"><div class="ft_12_600_black view-by-label" translate="Lakefront Residences"></div><div class="ft_12_600_black view-by-value cursor-point flex-items-center" id=sort-by-dropdown data-toggle=dropdown>{{vm.sortBy}} <img src=/assets/icons/arrow_drop_down_collapse_open.svg alt=icons></div><ul class=dropdown-menu role=menu aria-labelledby=view-by-dropdown><li class=menu-item value="" ng-click="vm.sortBy = \'Employee\'" translate=Employee></li><li class=menu-item value="" ng-click="vm.sortBy = \'Designations\'" translate=Designations></li><li class=menu-item value="" ng-click="vm.sortBy = \'Teams\'" translate=Teams></li><li class=menu-item value="" ng-click="vm.sortBy = \'Assigned Hours\'" translate="Assigned Hours"></li></ul></div><div class="flex-items-center view-by pos-relative"><div class="ft_12_600_black view-by-value cursor-point flex-items-center" id=view-by-dropdown data-toggle=dropdown><span class=text-capitalize>{{viewStyle}}</span> <img src=/assets/icons/arrow_drop_down_collapse_open.svg alt=icons></div><ul class=dropdown-menu role=menu aria-labelledby=view-by-dropdown><li class=menu-item value="" ng-click="selectViewStyle(\'day\')" translate=Day></li><li class=menu-item value="" ng-click="selectViewStyle(\'week\')" translate=Week></li><li class=menu-item value="" ng-click="selectViewStyle(\'month\')" translate=Month></li></ul></div></div></div><div class="right-side-content pos-relative"><scheduler ng-model=vm.data view-type=viewStyle date=vm.date on-select-schedule=vm.editSchedule></scheduler></div></div></div></div></main>');
$templateCache.put('app/main/clients/clientsAdd/clientsAdd.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=clientsAdd class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=clientsGrid translate=Clients></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Add Client"></a></div><div class=ft_24_600_black1 translate="Add Client"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=createClient(clientdata)><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=createClient(clientdata)><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref=clientsGrid><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="CLIENT DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{!!FILEIMG?FILEIMG:\'/assets/images/suppliers/upload.png\'}}" alt=upload ngf-select ng-model=vm.inputImg name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class=items><div class="ft_14_600_moreblack required" translate="Company or private client"></div><input type=text ng-model=clientdata.clientName id=firstName class="input-primary w-100" placeholder="{{\'Company Name\' | translate}}" autocomplete=off></div><div class="flex-between items"><div class=flex-50><div class="ft_14_600_moreblack required" translate="Email ID"></div><input autocomplete=off type=email placeholder="{{\'Invoice Email ID\' | translate}}" class="input-primary w-100" ng-model=clientdata.email></div><div class=flex-48><div class="ft_14_600_moreblack required" translate="Contact No."></div><div class=flex><div class=w-147 ng-if=vm.countryCodes><selectbox-input class=dropdown-primary ng-model=clientdata.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number placeholder="{{\'Phone Number\' | translate}}" class="input-primary ml-16 w-100" ng-model=clientdata.phoneNumber></div></div></div><div class=items><div class="ft_14_600_moreblack required" translate=Address></div><input autocomplete=off type=text id=address ng-model=clientdata.address class="input-primary w-100" placeholder="{{\'Include a place or address\' | translate}}"></div><div class="items flex-between"><div class=flex-32><div class="ft_14_600_moreblack required" translate=Country></div><div class=w-100><selectbox-input class=dropdown-primary ng-model=clientdata.countryCode options=vm.countryCodes label-field=name value-field=name></selectbox-input></div></div><div class=flex-32><div class="ft_14_600_moreblack required" translate=City></div><input autocomplete=off type=text class="input-primary w-100" placeholder="{{\'City Name\' | translate}}" ng-model=clientdata.city id=city></div><div class=flex-32><div class="ft_14_600_moreblack required" translate="Postal Code"></div><input autocomplete=off type=number class="input-primary w-100" placeholder="{{\'Postal Code\' | translate}}" ng-model=clientdata.postalCode id=postalCode></div></div><div class="items flex-between flex-wrap"><div class=flex-32><div class="ft_14_600_moreblack required" translate="Industry Type"></div><div class=w-100><selectbox-input class=dropdown-primary ng-model=clientdata.industry options=vm.getIndustries label-field=type value-field=type></selectbox-input></div></div><div class=flex-32><div class=ft_14_600_moreblack translate="Year Founded"></div><input autocomplete=off type=number class="input-primary w-100" placeholder="{{\'Year Founded\' | translate}}" ng-model=clientdata.yearFounded></div><div class=flex-32><div class=ft_14_600_moreblack translate=Website></div><input autocomplete=off type=text class="input-primary w-100" placeholder="{{\'Website\' | translate}}" ng-model=clientdata.clientWebsite></div></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate="STAFF MEMBERS"></span><div class="content flex-wrap flex mt-16"><div class="flex-end flex-between w-100 input-items"><div class=flex-22><div class=ft_14_600_moreblack translate="First Name"></div><input autocomplete=off type=text class="input-primary w-100" placeholder="{{\'First Name\' | translate}}" ng-model=staff.firstName></div><div class=flex-22><div class=ft_14_600_moreblack translate="Last Name"></div><input autocomplete=off type=text class="input-primary w-100" placeholder="{{\'Last Name\' | translate}}" ng-model=staff.lastName></div><div class=flex-22><div class=ft_14_600_moreblack translate="Email ID"></div><input autocomplete=off type=email class="input-primary w-100" placeholder="{{\'Email ID\' | translate}}" ng-model=staff.email></div><div class=flex-22><div class=ft_14_600_moreblack translate="Contact No."></div><div class=flex><div class="w-147 mr-15"><selectbox-input class=dropdown-primary ng-model=staff.mobile.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number class="input-primary w-100" placeholder="{{\'Phone Number\' | translate}}" ng-model=staff.mobile.phoneNumber></div></div><div><button class=button-primary ng-click=addStaff(staff)><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div ng-repeat="_staff in staffList track by $index"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind="_staff.firstName + \' \' + _staff.lastName"></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind=_staff.email></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind="\'(\'+_staff.mobile.dialCode + \') \' + _staff.mobile.phoneNumber"></div></div><div class="pos-absolute-1-0 flex-items-center"><!-- <button class="btn-trans">\n                    <img src="/assets/icons/edit_gray.svg" alt="icons" ng-click="editStaff(_staff)" style="width: 16px; height: 16px;"/>\n                  </button> --> <button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click=removeStaff($index)></button></div></div></div></div></div></div><div class=profile-card><span class=label translate="BANK DETAILS"></span><div class="bank flex-between flex-wrap mt-16"><div class=flex-32><div class=ft_14_600_moreblack translate="Account Holder Name"></div><input autocomplete=off type=text class=input-primary ng-model=accountHolderName></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Account Number"></div><input autocomplete=off type=text class=input-primary ng-model=accountNumber></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Name"></div><input autocomplete=off type=text class=input-primary ng-model=bankName></div><div class=flex-100><div class=ft_14_600_moreblack translate="Bank Address"></div><input autocomplete=off type=text class=input-primary ng-model=bankAddress></div><div class=flex-32><div class=ft_14_600_moreblack translate="IBAN Number"></div><input autocomplete=off type=text class=input-primary ng-model=IBAN></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Sort Code"></div><input autocomplete=off type=text class=input-primary ng-model=sortCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Routing Number"></div><input autocomplete=off type=text class=input-primary ng-model=routingNo></div><div class=flex-32><div class=ft_14_600_moreblack translate="SWIFT/BIC Code"></div><input autocomplete=off type=text class=input-primary ng-model=bicCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="IFSC Number"></div><input autocomplete=off type=text class=input-primary ng-model=ifscCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Routing Code"></div><input autocomplete=off type=text class=input-primary ng-model=routingCode></div></div></div><div class=profile-card><span class=label translate="TERMS & CONDITIONS"></span><div class="terms flex-between flex-wrap mt-16"><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT in %"></div><input autocomplete=off type=number class="input-primary w-100" ng-model=clientdata.paymentTerms.vatPercent></div><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT Registration No."></div><input autocomplete=off type=number class="input-primary w-100" ng-model=clientdata.paymentTerms.vatNumber></div><div class=flex-36><div class="ft_14_600_moreblack required" translate="Payment Terms"></div><div class=w-100><selectbox-input class=dropdown-primary ng-model=clientdata.paymentTerms.paymentSetting options=paymentConditions label-field=code value-field=_id></selectbox-input></div></div></div><div class="btnGroup flex mt-32"><button class="button-primary mr-16" ng-click=createClient(clientdata)><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=createClient(clientdata)><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref=clientsGrid><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/clients/clientsDetail/clientsDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=clientsDetail class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=clientsGrid translate=Clients></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Client Details"></a></div><div class=ft_24_600_black1 translate="Client Details"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ui-sref="clientsEdit({id: clientData._id})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="button-third mr-16" ng-click=updateClient()><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class=btn_cancel ui-sref=clientsGrid><img src=/assets/icons/close-circle-black.svg alt=icons><span translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="CLIENT DETAILS"></span><div class="flex mt-16"><!-- upload photo --><div class=img-container data-wow-delay=1.3s><img width=264 height=264 class="bdRadius-4 object-fit-cover" ng-src="{{ FILEIMG ? FILEIMG : !!clientData.clientLogo?clientData.clientLogo:\'/assets/images/suppliers/upload.svg\'}}"></div><div class="w-100 flex-wrap"><div class=items><div class=ft_14_regular_gray2 translate="Client Name"></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=clientData.clientName></div></div><div class="flex-between items"><div class=flex-50><div class=ft_14_regular_gray2 translate="Email ID"></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=clientData.email></div></div><div class=flex-48><div class=ft_14_regular_gray2 translate="Contact No."></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind="\'+\'+clientData.clientContact.dialCode + \' \' + clientData.clientContact.phoneNumber"></div></div></div><div class=items><div class=ft_14_regular_gray2 translate=Address></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=clientData.address[0].line1></div></div><div class="items flex-between"><div class=flex-32><div class=ft_14_regular_gray2 translate=Country></div><div class=w-100><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=clientData.address[0].countryCode></div></div></div><div class=flex-32><div class=ft_14_regular_gray2 translate=City></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=clientData.address[0].city></div></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Postal Code"></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=clientData.address[0].postalCode></div></div></div><div class="items flex-between flex-wrap"><div class=flex-32><div class=ft_14_regular_gray2 translate="Industry Type"></div><div class=w-100><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=clientData.industry[0]></div></div></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Year Founded"></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=clientData.yearFounded></div></div><div class=flex-32><div class=ft_14_regular_gray2 translate=Website></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=clientData.clientWebsite></div></div></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate="STAFF MEMBERS"></span><div class="content flex-wrap flex mt-16"><div ng-repeat="_staff in clientData.staffs"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind="_staff.firstName + \' \' + _staff.lastName"></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind=_staff.email></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind="\'(\'+_staff.mobile.dialCode + \') \' + _staff.mobile.phoneNumber"></div></div><!-- <div class="pos-absolute-1-0 flex-items-center">\n                  <button class="btn-trans">\n                    <img src="/assets/icons/close-gray.svg" alt="icons" ng-click="removeStaff($index)"/>\n                  </button>\n                </div> --></div></div></div></div></div><div class=profile-card><span class=label translate="BANK DETAILS"></span><div class="bank flex-between flex-wrap mt-16"><div class=flex-32><div class=ft_14_regular_gray2 translate="Account Holder Name"></div><input autocomplete=off type=text disabled class=input-primary ng-model=accountHolderName></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Account Number"></div><input autocomplete=off type=text disabled class=input-primary ng-model=accountNumber></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Name"></div><input autocomplete=off type=text disabled class=input-primary ng-model=bankName></div><div class=flex-100><div class=ft_14_regular_gray2 translate="Bank Address"></div><input autocomplete=off type=text disabled class=input-primary ng-model=bankAddress></div><div class=flex-32><div class=ft_14_regular_gray2 translate="IBAN Number"></div><input autocomplete=off type=text disabled class=input-primary ng-model=IBAN></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Sort Code"></div><input autocomplete=off type=text disabled class=input-primary ng-model=sortCode></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Routing Number"></div><input autocomplete=off type=text disabled class=input-primary ng-model=routingNo></div><div class=flex-32><div class=ft_14_regular_gray2 translate="SWIFT/BIC Code"></div><input autocomplete=off type=text disabled class=input-primary ng-model=bicCode></div><div class=flex-32><div class=ft_14_regular_gray2 translate="IFSC Number"></div><input autocomplete=off type=text disabled class=input-primary ng-model=ifscCode></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Routing Code"></div><input autocomplete=off type=text disabled class=input-primary ng-model=routingCode></div></div></div><div class=profile-card><span class=label translate="TERMS & CONDITIONS"></span><div class="terms flex-between flex-wrap mt-24"><div class=flex-30><div class=ft_14_regular_gray2 translate="VAT in %"></div><input autocomplete=off type=number disabled class="input-primary w-100" ng-model=clientData.paymentTerms.vatPercent></div><div class=flex-30><div class=ft_14_regular_gray2 translate="VAT Registration No."></div><input autocomplete=off type=number disabled class="input-primary w-100" ng-model=clientData.paymentTerms.vatNumber></div><div class=flex-30><div class=ft_14_regular_gray2 translate="Payment Terms"></div><input autocomplete=off type=text disabled class="input-primary w-100" ng-model=clientData.paymentTerms.paymentSetting.code></div></div></div></div></div></main>');
$templateCache.put('app/main/clients/clientsEdit/clientsEdit.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=clientsAdd class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=clientsGrid translate=Clients></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Edit Client"></a></div><div class=ft_24_600_black1 translate="Edit Client"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=updateClient()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class=btn_cancel ui-sref="clientsDetail({id: clientData._id})"><img src=/assets/icons/close-circle-black.svg alt=icons><span translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="CLIENT DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{!!FILEIMG?FILEIMG:\'/assets/images/suppliers/upload.png\'}}" alt=upload ngf-select ng-model=vm.inputImg name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class=items><div class="ft_14_600_moreblack required" translate="Company or private client"></div><input type=text ng-model=clientData.clientName id=firstName class="input-primary w-100" placeholder="{{\'Company Name\' | translate}}" autocomplete=off></div><div class="flex-between items"><div class=flex-50><div class="ft_14_600_moreblack required" translate="Email ID"></div><input autocomplete=off type=email placeholder="{{\'Invoice Email ID\' | translate}}" class="input-primary w-100" ng-model=clientData.email></div><div class=flex-48><div class="ft_14_600_moreblack required" translate="Contact No."></div><div class=flex><div class=w-147 ng-if=vm.countryCodes><selectbox-input class=dropdown-primary ng-model=clientData.clientContact.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number placeholder="{{\'Phone Number\' | translate}}" class="input-primary w-100 ml-16" ng-model=clientData.clientContact.phoneNumber></div></div></div><div class=items><div class="ft_14_600_moreblack required" translate=Address></div><input autocomplete=off type=text id=address ng-model=clientData.address[0].line1 class="input-primary w-100" placeholder="{{\'Include a place or address\' | translate}}"></div><div class="items flex-between"><div class=flex-32><div class="ft_14_600_moreblack required" translate=Country></div><div class=w-100><selectbox-input class=dropdown-primary ng-model=clientData.countryCode options=vm.countryCodes label-field=name value-field=name></selectbox-input></div></div><div class=flex-32><div class="ft_14_600_moreblack required" translate=City></div><input autocomplete=off type=text class="input-primary w-100" placeholder="{{\'City Name\' | translate}}" ng-model=clientData.city id=city></div><div class=flex-32><div class="ft_14_600_moreblack required" translate="Postal Code"></div><input autocomplete=off type=number class="input-primary w-100" placeholder="{{\'Postal Code\' | translate}}" ng-model=clientData.postalCode id=postalCode></div></div><div class="items flex-between flex-wrap"><div class=flex-32><div class="ft_14_600_moreblack required" translate="Industry Type"></div><div class=w-100><selectbox-input class=dropdown-primary ng-model=clientData.industry[0] options=vm.getIndustries label-field=type value-field=type></selectbox-input></div></div><div class=flex-32><div class=ft_14_600_moreblack translate="Year Founded"></div><input autocomplete=off type=number class="input-primary w-100" placeholder="{{\'Year Founded\' | translate}}" ng-model=clientData.yearFounded></div><div class=flex-32><div class=ft_14_600_moreblack translate=Website></div><input autocomplete=off type=text class="input-primary w-100" placeholder="{{\'Website\' | translate}}" ng-model=clientData.clientWebsite></div></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate="STAFF MEMBERS"></span><div class="content flex-wrap flex mt-16"><div class="flex-end w-100 input-items"><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="First Name"></div><input autocomplete=off type=text class="input-primary w-100" placeholder="{{\'First Name\' | translate}}" ng-model=staff.firstName></div><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="Last Name"></div><input autocomplete=off type=text class="input-primary w-100" placeholder="{{\'Last Name\' | translate}}" ng-model=staff.lastName></div><div class=flex-25><div class=ft_14_600_moreblack translate="Contact No."></div><div class=flex><div class="w-147 mr-15"><selectbox-input class=dropdown-primary ng-model=staff.mobile.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number class="input-primary w-100" placeholder="{{\'Phone Number\' | translate}}" ng-model=staff.mobile.phoneNumber></div></div></div><div class="flex-end w-100 input-items"><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="Email ID"></div><input autocomplete=off type=email class="input-primary w-100" placeholder="{{\'Email ID\' | translate}}" ng-model=staff.email></div><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate=Password></div><input autocomplete=off type=password class="input-primary w-100" placeholder="{{\'Password\' | translate}}" ng-model=staff.password></div><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="Confirm Password"></div><input autocomplete=off type=password class="input-primary w-100" placeholder="{{\'Confirm Password\' | translate}}" ng-model=staff.confirmPassword></div><div><button class=button-primary ng-click=addStaff(staff)><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div ng-repeat="_staff in staffList track by $index"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind="_staff.firstName + \' \' + _staff.lastName"></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind=_staff.email></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind="\'(\'+_staff.mobile.dialCode + \') \' + _staff.mobile.phoneNumber"></div></div><div class="pos-absolute-1-0 flex-items-center"><!-- <button class="btn-trans">\n                    <img src="/assets/icons/edit_gray.svg" alt="icons" ng-click="editStaff(_staff)" style="width: 16px; height: 16px;"/>\n                  </button> --> <button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click="deleteStaff($index, _staff)"></button></div></div></div></div></div></div><div class=profile-card><span class=label translate="BANK DETAILS"></span><div class="bank flex-between flex-wrap mt-16"><div class=flex-32><div class=ft_14_600_moreblack translate="Account Holder Name"></div><input autocomplete=off type=text class="input-primary w-100" ng-model=bank.accountHolderName></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Account Number"></div><input autocomplete=off type=text class="input-primary w-100" ng-model=bank.accountNumber></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Name"></div><input autocomplete=off type=text class="input-primary w-100" ng-model=bank.bankName></div><div class=flex-100><div class=ft_14_600_moreblack translate="Bank Address"></div><input autocomplete=off type=text class="input-primary w-100" ng-model=bank.bankAddress></div><div class=flex-32><div class=ft_14_600_moreblack translate="IBAN Number"></div><input autocomplete=off type=text class="input-primary w-100" ng-model=bank.IBAN></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Sort Code"></div><input autocomplete=off type=text class="input-primary w-100" ng-model=bank.sortCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Routing Number"></div><input autocomplete=off type=text class="input-primary w-100" ng-model=bank.routingNo></div><div class=flex-32><div class=ft_14_600_moreblack translate="SWIFT/BIC Code"></div><input autocomplete=off type=text class="input-primary w-100" ng-model=bank.bicCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="IFSC Number"></div><input autocomplete=off type=text class="input-primary w-100" ng-model=bank.ifscCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Routing Code"></div><input autocomplete=off type=text class="input-primary w-100" ng-model=bank.routingCode></div></div></div><div class=profile-card><span class=label translate="TERMS & CONDITIONS"></span><div class="terms flex-between flex-wrap mt-16"><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT in %"></div><input autocomplete=off type=number class="input-primary w-100" ng-model=clientData.paymentTerms.vatPercent></div><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT Registration No."></div><input autocomplete=off type=number class="input-primary w-100" ng-model=clientData.paymentTerms.vatNumber></div><div class=flex-36><div class="ft_14_600_moreblack required" translate="Payment Terms"></div><div class=w-100><selectbox-input class=dropdown-primary ng-model=clientData.paymentTerms.paymentSetting options=paymentConditions label-field=code value-field=_id></selectbox-input></div></div></div><div class="btnGroup flex mt-32"><button class="button-primary mr-16" ng-click=updateClient()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class=btn_cancel ui-sref="clientsDetail({id: clientData._id})"><img src=/assets/icons/close-circle-black.svg alt=icons><span translate=Cancel></span></button></div></div></div></div></main>');
$templateCache.put('app/main/clients/clientsGrid/clientsGrid.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=clientsGrid class="main-container client-container"><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Clients></a></div><div class=ft_24_600_black1 translate=Clients></div></div><searchbox class=ml-auto search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><div><button class="btn-trans ml-16" ng-click="isGrid = false"><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click="isGrid = true"><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button></div><button class="button-primary ml-16" ui-sref=clientsAdd ng-if="CLIENT_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Add Client"></span></button></div><div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0 && isLoading==false"><div class="card-based-content-grid-wrapper pr-24 pv-24" ng-if=isGrid><div class="quotes-wrapper flex flex-wrap"><div class=profile-card-container ng-repeat="client in clients"><div class=profile-card><div class=card-content><div class="flex header"><div ng-if=client.clientLogo><img ng-src={{client.clientLogo}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!client.clientLogo><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(client.clientName)) }">{{client.clientName | mailAvatarChar}}</span></div><div class=name-wrapper ng-click=goToDetail(client._id)><div class="name tx-ellipsis ft_16_600_black" ng-bind=client.clientName></div><div class=date ng-bind="client.created | date: \'MMM d, yyyy\' : \'UTC\'"></div></div></div><div class=detail><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/call.svg alt=icons> <span class=ft_14_regular_gray ng-bind="\'+\'+client.clientContact.dialCode+\' \'+client.clientContact.phoneNumber"></span></div><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/email.svg alt=icons> <span class="ft_14_regular_gray tx-ellipsis" ng-bind=client.email></span></div></div></div><div class="flex-between action"><div class=flex-row><img src=/assets/images/suppliers/tag.svg alt=icons> <span class="ft_12_600_black ml-7" ng-bind=client.systemTag></span></div><div class=flex-row><img src=/assets/images/suppliers/calendar.svg alt=icons> <span class="ft_12_regular_gray cal-span">03 Nov 2019</span></div><!-- <a class="link-detail" ng-click="goToDetail(client._id)" translate="View Details"></a> --></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + clients.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllClients()></div></div></div></div><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer" ng-if=!isGrid><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked><span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate=Name></span></th><th class=ft_14_600_black><span translate="Email ID"></span></th><th class=ft_14_600_black><span translate="Contact No."></span></th><th class=ft_14_600_black><span translate=Address></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, client) in clients"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked><span class=checkmark></span></label></td><td ng-click=goToDetail(client._id)><div class="flex-row flex-items-center"><div class=avatar-cell><div ng-if=client.clientLogo><img ng-src={{client.clientLogo}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!client.clientLogo><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(client.clientName)) }">{{client.clientName | mailAvatarChar}}</span></div></div><div class="ft_14_regular_black tx-ellipsis name" ng-bind=client.clientName></div></div></td><td class="tx-ellipsis email ft_14_regular_black" ng-bind=client.email></td><td class=ft_14_regular_black ng-bind="\'(\'+client.clientContact.dialCode+\') \'+client.clientContact.phoneNumber"></td><td class="tx-ellipsis address pr-20 ft_14_regular_black">{{client.address[0].line1}},{{client.address[0].line2}},{{client.address[0].city}},{{client.address[0].postalCode}},{{client.address[0].countryCode}}</td><td class="more flex-items-center"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class=margin-0></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + clients.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllClients()></div></selectbox></div></div></div></div></div></main>');
$templateCache.put('app/main/collaborations/bidPackages/bidPackages.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=bidPackages class="main-container collaboration-page"><div class=title-bar><div class=w-230><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Collaborations></a></div><div class=ft_24_600_black1 translate="Bid Packages"></div></div><collaboration-menu></collaboration-menu><searchbox class=ml-auto search-text=vm.searchText search-event=searchBidPackages()></searchbox><div class="button-primary ml-16 cursor-point" ui-sref=createBidPackage><img src=/assets/icons/plus-white.svg alt=""><span translate="New Bid Package"></span></div></div><div class="content-wrap p-24"><div class="content d-flex flex-column justify-content-between p-0"><div class="table-container pos-relative"><spinner ng-if=loading></spinner><div class=thead><div class=tr><div class="td check-item"><label class="check_yellow_16 check"><input type=checkbox ng-model=selectedAll ng-change=selectAllBidPackages()> <span class=checkmark_16></span></label></div><div class="d-flex main-td-group"><div class="td flex-8" translate=Name></div><div class="td flex-15" translate=Description></div><div class="td flex-20" translate="Type of Work"></div><div class="td flex-15" translate="Collaboration Type"></div><div class="td flex-10" translate="Accept Date"></div><div class="td flex-10" translate=Deadline></div><div class="td flex-13" translate=Contact></div><div class="td flex-7" translate=Files></div><div class="td flex-10" translate=Action></div></div></div></div><div ng-if=vm.bidPackages.length class=tbody><div ng-repeat="bidPackage in vm.bidPackages track by $index"><div class=tr><div class="td check-item"><label class="check_yellow_16 check"><input type=checkbox ng-model=bidPackage.selected ng-change=selectBidPackage(bidPackage)> <span class=checkmark_16></span></label></div><div class="d-flex main-td-group"><div class="td flex-8">{{bidPackage.title}}</div><div class="td flex-15">{{bidPackage.description}}</div><div class="td flex-20 height-auto">{{bidPackage.typeOfWork ? workTypes(bidPackage.typeOfWork) : \'\'}}</div><div class="td flex-15">{{bidPackage.vendorType == 0? \'Supplier\' : \'Sub-contractor\'}}</div><div class="td flex-10">{{bidPackage.acceptUntil | date: "dd/MM/yyyy" : \'UTC\'}}</div><div class="td flex-10">{{bidPackage.bidDeadline | date: "dd/MM/yyyy" : \'UTC\'}}</div><div class="td flex-13">{{bidPackage.email}}</div><div class="td flex-7"><div ng-if=bidPackage.attached.length class="d-flex align-items-center"><img src=/assets/icons/file-black.svg alt="" class=mr-8>{{bidPackage.attached.length}} Files</div></div><div class="td flex-10"><div class="flex dropdown"><img src=/assets/icons/file.svg alt="" class=cursor-point ng-click=gotoEditOfferTemplate(bidPackage._id)> <img src=/assets/icons/edit_gray.svg alt="" class="cursor-point ml-8" ng-click=gotoEditBidPackage(bidPackage._id)> <img src=/assets/icons/trash-alt6.svg alt="" class="cursor-point ml-8" ng-click=deleteBidPackage(bidPackage)></div></div></div></div><div class="tr detail" ng-show=bidPackage.expanded><div class="td check-item"></div><div class=main-detail><div class=flex><div class=flex-30><label translate=Description></label><div class=d-flex>{{bidPackage.description}}</div></div><div class=flex-30><label translate="Accept Deadline"></label><div class=d-flex>{{ bidPackage.acceptDeadline | date: "dd-MM-yyyy hh:mm a"}}</div></div><div class=flex-30><label translate="Tender Deadline"></label><div class=d-flex>{{ bidPackage.tenderDeadline | date: "dd-MM-yyyy hh:mm a"}}</div></div></div></div><div class="td actions flex-center more"></div></div></div></div><div ng-if=!vm.bidPackages.length class=no-bid-pacakges><div class=title>No data to display.</div></div></div><div class="pagination-footer flex-items-center flex-content-end" ng-if=vm.bidPackages.length><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span>{{(vm.currentPage - 1) * numPerPage + vm.bidPackages.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div></div></div></main>');
$templateCache.put('app/main/collaborations/collaborationInvites/collaborationInvites.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=collaboration-invites class="main-container collaboration-page"><div class=title-bar><div class=w-230><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=bidPackages class="ft-normal-12-16 grey-2" translate=Collaborations></a></div><div class=ft_24_600_black1 translate=Invites></div></div><collaboration-menu></collaboration-menu><searchbox class=ml-auto input-class=search search-text=vm.searchText search-event=searchData()></searchbox><div class="button-primary ml-16 cursor-point"><img src=/assets/icons/forward.svg alt=""> <span class=ml-8 translate="Send Invitations"></span></div></div><div class="d-flex content-wrap"><collaboration-filters-panel binding-current-tab=currentTab fetch-data=fetchData()></collaboration-filters-panel><div class=collaborations-main><div class=collaboration-content><div class="table-container pos-relative"><spinner ng-if=loading></spinner><div class=thead><div class=tr><div class="td drop-here justify-content-center" translate="Drop here"></div><div class="d-flex main-td-group" draggable=true><div class="td flex-30" translate="Companies Invited"></div><div class="td flex-15" translate=Staff></div><div class="td flex-15" translate="Bid Package"></div><div class="td flex-15" translate=Deadline></div><div class="td flex-10" translate=Status></div><div class="td flex-10" translate=Documents></div></div><div class="td actions" translate=Actions></div></div></div><div class=tbody><div class=tr ng-repeat="offer in offertemplates"><div class="td drop-here"><div class=rect ref=drop-zone ref-id={{offer._id}} translate="Drop here"></div></div><div class="d-flex main-td-group"><div class="td flex-30 company-wrapper"><div class=checklist-item ng-repeat="item in offer.invited track by $index"><span>{{ getCompanyList(offer._id, item) }}</span> <img class="cursor-point ml-3" src=/assets/icons/close-24.svg ng-click="removeCompany(offer, item)"></div></div><div class="td flex-15"><div class=vendor-staff ng-repeat="sid in offer.invitedStaffs | limitTo : 2"><img ng-if=getStaff(sid).subUserId.profilePic class=avatar ng-src={{getStaff(sid).subUserId.profilePic}} alt=""><div ng-if=!getStaff(sid).subUserId.profilePic data-letters={{utils.nameLetter(getStaff(sid).displayName)}} ng-style="{ \'background\': getColor(getStaff(sid).displayName) }"></div></div><div class=vendor-staff ng-if="offer.invitedStaffs.length > 2"><div data-letters="+{{offer.invitedStaffs.length - 2}}"></div></div></div><div class="td flex-15">{{ offer.title }}</div><div class="td flex-15">{{ offer.bidDeadline | date: "MM/dd/yyyy hh:mm a"}}<br>{{ offer.bidPackageId.tenderDeadline | date: "dd-MM-yyyy hh:mm a": \'UTC\' }}</div><div class="td flex-10"><div class="d-flex align-items-center" ng-show="offer.status == \'Accepted\'"><img src=/assets/icons/check-mark-green.svg alt="" class=mr-8><div translate=Accepted></div></div><div class="d-flex align-items-center" ng-show="offer.status == \'Declined\'"><img src=/assets/icons/close-circle-red1.svg alt="" class=mr-8><div translate=Declined></div></div><div class="d-flex align-items-center" ng-show="offer.status == \'Paused\' || offer.status == \'Pending\'"><img src=/assets/icons/pin-stop.svg alt="" class=mr-8><div>{{offer.status}}</div></div></div><div class="td flex-10"><div class="d-flex align-items-center"><img src=/assets/icons/file-black.svg alt="" class=mr-8> {{ offer.attached.length }} Files</div></div></div><div class="td actions"><div class="d-flex align-items-center justify-content-between w-100"><button class=btn ng-click=exportToExcel(offer._id)><img src=/assets/icons/eye6.svg alt=""></button> <button class=btn ng-click=invite(bidPackage) ng-disabled="bidPackage.status === \'Accepted\'"><img src=/assets/icons/bx-mail.svg alt=""></button> <button class=btn><img class=mb-10 src=/assets/icons/more_horiz-gray.svg alt=""></button></div></div></div></div></div><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="loading == false">{{(vm.currentPage - 1) * numPerPage + bidPackages.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/collaborations/collaborationOffers/collaborationOffers.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=collaboration-offers class="main-container collaboration-page"><div class=title-bar><div class=w-230><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=bidPackages class="ft-normal-12-16 grey-2" translate=Collaborations></a></div><div class=ft_24_600_black1 translate=Offers></div></div><collaboration-menu></collaboration-menu><searchbox class=ml-auto input-class=search search-text=vm.searchText search-event=searchOffers()></searchbox><!-- <div class="btn btn-blue " ng-click="uploadOffer()">\n        <img src="/assets/icons/plus-white.svg" alt="">\n        <span class="ml-8" translate="Add New"></span>\n      </div> --></div><div class="d-flex content-wrap"><div class=collaborations-main><spinner ng-if=isLoading></spinner><div class=collaboration-content><div class="table-container pos-relative"><spinner ng-if=isLoading></spinner><div class=thead><div class=tr><div class="td check-item"><label class="check_yellow_16 check"><input type=checkbox ng-model=selectedAll ng-change=selectAllOffers()> <span class=checkmark_16></span></label></div><div class="d-flex main-td-group"><div class="td work-type" translate="Bid Package"></div><div class="td system-tag" translate="SYS Tag"></div><div class="td collaborator" translate=Collaborator></div><div class="td staff-container" translate=Staff></div><div class="td levels" translate=Levels></div><div class="td no-of-days" translate=Days></div><div class="td no-of-days" translate=""></div><div class="td no-of-days" translate=""></div><div class="td offer-amount" translate="Offer Amount"></div><div class="td best" translate=""></div><div class="td status" translate=Status></div></div><div class="td actions" translate=Actions></div></div></div><div class=tbody><div ng-repeat="bid in bidPackages track by $index"><div class=tr><div class="td check-item"><label class="check_yellow_16 check"><input type=checkbox ng-model=offer.selected ng-change=selectOffer(offer)> <span class=checkmark_16></span></label></div><div class="d-flex main-td-group"><div class="td work-type">{{bid.title}}</div><div class="td system-tag">{{ bid.systag }}</div><div class="td collaborator">{{getCollaborator(bid)}}</div><div class="td staff-container">{{getBidStaffs(bid)}}</div><div class="td levels">{{calcBidLevels(bid)}}</div><div class="td no-of-days">{{calcBidDays(bid)}}</div><div class="td no-of-days"></div><div class="td no-of-days"></div><div class="td offer-amount">{{vm.companyData.currentCurrency.symbol}} {{calcBidOfferAmount(bid) | readable: 2}}</div><div class="td best"><button class="btn income-offer-button" ng-if=calcBest(bid)>{{calcBest(bid)}} best</button></div><div class="td status"><div><img ng-src="{{getBidStatus(bid) == \'Accepted\' ? \'/assets/icons/check-offer-status-f.svg\' : \'/assets/icons/check-offer-status.svg\'}}" alt=""> <img class=ml-8 ng-src="{{getBidStatus(bid) == \'Decliended\' ? \'/assets/icons/close-offer-status-f.svg\' : \'/assets/icons/close-offer-status.svg\'}}" alt=""> <img class=ml-8 ng-src="{{getBidStatus(bid) == \'Paused\' ? \'/assets/icons/pause-offer-status_f.svg\' : \'/assets/icons/pause-offer-status.svg\'}}" alt=""></div></div></div><div class="td actions"><img class=mr-16 src=/assets/icons/file-gray.svg alt=""> <img class=mr-16 ng-click="bid.expanded = !bid.expanded" alt="" ng-src="{{bid.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}"></div></div><div class="tr offers-panel" ng-repeat-start="offer in bid.offers" ng-show=bid.expanded><div class="td check-item"></div><div class="d-flex main-td-group"><div class="td work-type"></div><div class="td system-tag"></div><div class="td collaborator">{{offer.supplierId.name}}</div><div class="td staff-container">{{offer.staffId.displayName}}</div><div class="td levels">{{offer.levels.length}}</div><div class="td no-of-days">{{calcOfferDays(offer)}}</div><div class="td no-of-days"></div><div class="td no-of-days"></div><div class="td offer-amount">{{vm.companyData.currentCurrency.symbol}} {{calcOfferAmount(offer) | readable: 2}}</div><div class="td best"></div><div class="td status"><div><img ng-click="updateStatus(offer, \'Accepted\')" ng-src="{{offer.status == \'Accepted\' ? \'/assets/icons/check-offer-status-f.svg\' : \'/assets/icons/check-offer-status.svg\'}}" alt=""> <img class=ml-8 ng-click="updateStatus(offer, \'Decliended\')" ng-src="{{offer.status == \'Decliended\' ? \'/assets/icons/close-offer-status-f.svg\' : \'/assets/icons/close-offer-status.svg\'}}" alt=""> <img class=ml-8 ng-click="updateStatus(offer, \'Paused\')" ng-src="{{offer.status == \'Paused\' ? \'/assets/icons/pause-offer-status_f.svg\' : \'/assets/icons/pause-offer-status.svg\'}}" alt=""></div></div></div><div class="td actions flex-content-end"><img class=mr-16 ng-click="offer.expanded = !offer.expanded" alt="" ng-src="{{offer.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}"></div></div><div ng-repeat-end="offer in bid.offers" ng-show=offer.expanded><div class=groups-panel ng-show=offer.expanded><!-- <div class="group-name">{{group.name}}</div> --><div class="d-flex justify-content-between"><div class=levels-tab-container><div class=levels-tab ng-click=selectGroup(offer) ng-class="{\'active\': offer.selectedGroup.name == \'All\'}">All</div><div class=levels-tab ng-repeat="group in offer.groups" ng-click="selectGroup(offer, group)" ng-class="{\'active\': offer.selectedGroup.name == group.name}">{{group.name}}</div></div><div class="d-flex ml-40"><input class=hidden id=fileSelector ngf-select ngf-pattern="\'.xlsx\'" ngf-multiple=false ngf-accept="\'.xlsx\'" ngf-change=SelectFile($file)> <button class="btn income-offer-button mr-10" ng-if="offer.selectedGroup.name != \'All\'" ng-click=attachExcelFiles(offer) translate=Upload></button> <button class="btn income-offer-button" ng-click=saveOfferSubmit(offer) translate=Save></button></div></div><div class=group-table><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><label translate=Name></label></div><div class=col-3><label translate=Type></label></div><div class=col-2><label translate=Level></label></div><div class=col-3><label translate=Size></label></div></div></div><div class=col-7><div class=row><div class=col-4><label translate=Description></label></div><div class=col-1><label translate=Days></label></div><div class=col-1><label translate=Qty.></label></div><div class=col-1><label translate=Unit></label></div><div class=col-2><label translate="Unit Price"></label></div><div class=col-3><label translate="Offer Amount"></label></div></div></div></div></div><div ng-show="offer.selectedGroup.name == \'All\'"><div ng-repeat="group in offer.groups"><div class=item><div class="info row"><div class=col-5><div class="d-flex pr-4"><img src=/assets/icons/arrow_drop_down_collapse_gray.svg alt="" ng-if=!group.expanded ng-click="group.expanded = true" class=mr-2> <img src=/assets/icons/arrow_drop_down_collapse_open.svg alt="" ng-if=group.expanded ng-click="group.expanded = false" class=mr-2> {{group.name}}</div></div><div class=col-7><div class=row><div class=col-4></div><div class=col-1>{{calcGroupDays(group)}}</div><div class=col-1>{{calcGroupQuantity(group)}}</div><div class=col-1></div><div class=col-2></div><div class=col-3>{{vm.companyData.currentCurrency.symbol}} {{calcGroupOfferAmount(group) | readable: 2}}</div></div></div></div></div><div class=item-break></div><div ng-repeat="item in group.levels track by $index" ng-show=group.expanded><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><!-- <input type="text" ng-model="item.name" class="login_input_new_no_mt"> --><div class=overflow-wrap>{{item.name}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.type" class="login_input_new_no_mt"> --><div>{{item.type}}</div></div><div class=col-2><!-- <input type="text" ng-model="item.level" class="login_input_new_no_mt"> --><div>{{item.level}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.size" class="login_input_new_no_mt"> --><div>{{item.size}}</div></div></div></div><div class=col-7><div class=row><div class=col-4><!-- <input type="text" class="login_input_new_no_mt" ng-model="item.description"> --><div>{{item.description}}</div></div><div class=col-1><!-- <input type="text" number-edit ng-model="item.days" class="login_input_new_no_mt text-right"> --><div>{{item.days}}</div></div><div class=col-1><!-- <input type="text" number-edit ng-model="item.quantity" class="login_input_new_no_mt text-right"> --><div>{{item.quantity}}</div></div><div class=col-1><!-- <input type="text" ng-model="item.unit" class="login_input_new_no_mt text-right"> --><div>{{item.unit}}</div></div><div class=col-2><!-- <input type="text" number-edit ng-model="item.unitPrice" class="login_input_new_no_mt text-right"> --><div>{{vm.companyData.currentCurrency.symbol}} {{item.unitPrice | readable: 2}}</div></div><div class=col-3><!-- <input type="text" number-edit ng-model="item.amount" class="login_input_new_no_mt text-right"> --><div>{{vm.companyData.currentCurrency.symbol}} {{item.amount | readable: 2}}</div></div></div></div></div></div><div class=item-break></div></div></div></div><div ng-repeat="group in offer.groups"><div ng-repeat="item in group.levels track by $index" ng-show="offer.selectedGroup.name == group.name"><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><!-- <input type="text" ng-model="item.name" class="login_input_new_no_mt"> --><div class=overflow-wrap>{{item.name}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.type" class="login_input_new_no_mt"> --><div>{{item.type}}</div></div><div class=col-2><!-- <input type="text" ng-model="item.level" class="login_input_new_no_mt"> --><div>{{item.level}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.size" class="login_input_new_no_mt"> --><div>{{item.size}}</div></div></div></div><div class=col-7><div class=row><div class=col-4><!-- <input type="text" class="login_input_new_no_mt" ng-model="item.description"> --><div>{{item.description}}</div></div><div class=col-1><input type=text number-edit ng-model=item.days class="login_input_new_no_mt text-right"><!-- <div>{{item.days}}</div> --></div><div class=col-1><input type=text number-edit ng-model=item.quantity class="login_input_new_no_mt text-right" ng-change=calcItemAmount(item)><!-- <div>{{item.quantity}}</div> --></div><div class=col-1><input type=text ng-model=item.unit class="login_input_new_no_mt text-right"><!-- <div>{{item.unit}}</div> --></div><div class=col-2><input type=text number-edit ng-model=item.unitPrice class="login_input_new_no_mt text-right" ng-change=calcItemAmount(item)><!-- <div>{{item.unitPrice}}</div> --></div><div class=col-3><input type=text number-edit ng-model=item.amount class="login_input_new_no_mt text-right"><!-- <div>{{item.amount}}</div> --></div></div></div></div></div><div class=item-break></div></div></div><!-- <div class="item-break"></div> --><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><label translate=""></label></div><div class=col-3><label translate=""></label></div><div class=col-2><label translate=""></label></div><div class=col-3><label translate=""></label></div></div></div><div class=col-7><div class=row><div class=col-4><label translate=Sum></label></div><div class=col-1><label>{{calcGroupDays(offer.selectedGroup)}}</label></div><div class=col-1><label>{{calcGroupQuantity(offer.selectedGroup)}}</label></div><div class=col-1><label translate=""></label></div><div class=col-2><label translate=""></label></div><div class=col-3><label>{{vm.companyData.currentCurrency.symbol}} {{calcGroupOfferAmount(offer.selectedGroup) | readable: 2}}</label></div></div></div></div></div></div><!-- <div class="tr levels-panel" ng-repeat="lv in group.levels" ng-show="offer.expanded">\n                      <div class="td check-item"></div>\n                      <div class="d-flex main-td-group">\n                        <div class="td work-type"></div>\n                        <div class="td offername">{{offer.bidPackageId.sysTag + \'-\' + ($index + 1)}}</div>\n                        <div class="td coordinator"></div>\n                        <div class="td levels"></div>\n                        <div class="td no-of-days">{{lv.name}}</div>\n                        <div class="td offer-amount">{{lv.description}}</div>\n                        <div class="td status">{{lv.type}}</div>\n                        <div class="td status">{{lv.level}}</div>\n                        <div class="td status">{{lv.size}}</div>\n                      </div>\n                      <div class="td actions"></div>\n                    </div> --></div></div></div></div></div><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + offers.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=getOffers()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/collaborations/collaborationTeam/collaborationTeam.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=collaboration-team class="main-container collaboration-page"><div class=title-bar><div class=w-230><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=bidPackages class="ft-normal-12-16 grey-2" translate=Collaborations></a></div><div class=ft_24_600_black1 translate=Team></div></div><collaboration-menu></collaboration-menu></div><div class="d-flex content-wrap"><collaboration-team-panel binding-current-tab=currentTab binding-managers=managers binding-suppliers=suppliers binding-subcontractors=subcontractors></collaboration-team-panel><div class=collaborations-main><div class=collaboration-content><div class=teams-table><div class=thead><div class=tr><div class="td label"></div><div class="td drop-zone-container"><label>Manager</label></div><div class="td drop-zone-container"><label>Collaborators</label></div></div></div><div class=tbody><div class=tr><div class="td label"><label>TQ</label></div><div class="td drop-zone-container"><div class=members-box><div class="d-flex flex-wrap w-100 h-100" ref=drop-zone-tq-manager refid={{collaboration._id}}><div class=member-box ng-repeat="member in collaboration.members.qaMembers track by $index"><span class=mr-8>{{member.displayName}}</span> <img src=/assets/icons/close-16-gray.svg alt="" class=cursor-point ng-click="removeMember(collaboration, collaboration.members.qaMembers, $index)"></div></div></div></div><div class="td drop-zone-container"><div class=members-box><div class="d-flex flex-wrap w-100 h-100" ref=drop-zone-tq-collaborators refid={{collaboration._id}}><div class=member-box ng-repeat="member in collaboration.members.qaMembers track by $index"><span class=mr-8>{{member.displayName}}</span> <img src=/assets/icons/close-16-gray.svg alt="" class=cursor-point ng-click="removeMember(collaboration, collaboration.members.qaMembers, $index)"></div></div></div></div></div><div class=tr><div class="td label"><label>Issues</label></div><div class="td drop-zone-container"><div class=members-box><div class="d-flex flex-wrap w-100 h-100" ref=drop-zone-issue-manager refid={{collaboration._id}}><div class=member-box ng-repeat="member in collaboration.members.qaMembers track by $index"><span class=mr-8>{{member.displayName}}</span> <img src=/assets/icons/close-16-gray.svg alt="" class=cursor-point ng-click="removeMember(collaboration, collaboration.members.qaMembers, $index)"></div></div></div></div><div class="td drop-zone-container"><div class=members-box><div class="d-flex flex-wrap w-100 h-100" ref=drop-zone-issue-collaborators refid={{collaboration._id}}><div class=member-box ng-repeat="member in collaboration.members.qaMembers track by $index"><span class=mr-8>{{member.displayName}}</span> <img src=/assets/icons/close-16-gray.svg alt="" class=cursor-point ng-click="removeMember(collaboration, collaboration.members.qaMembers, $index)"></div></div></div></div></div><div class=tr><div class="td label"><label>Report</label></div><div class="td drop-zone-container"><div class=members-box><div class="d-flex flex-wrap w-100 h-100" ref=drop-zone-report-manager refid={{collaboration._id}}><div class=member-box ng-repeat="member in collaboration.members.qaMembers track by $index"><span class=mr-8>{{member.displayName}}</span> <img src=/assets/icons/close-16-gray.svg alt="" class=cursor-point ng-click="removeMember(collaboration, collaboration.members.qaMembers, $index)"></div></div></div></div><div class="td drop-zone-container"><div class=members-box><div class="d-flex flex-wrap w-100 h-100" ref=drop-zone-report-collaborators refid={{collaboration._id}}><div class=member-box ng-repeat="member in collaboration.members.qaMembers track by $index"><span class=mr-8>{{member.displayName}}</span> <img src=/assets/icons/close-16-gray.svg alt="" class=cursor-point ng-click="removeMember(collaboration, collaboration.members.qaMembers, $index)"></div></div></div></div></div></div><!-- <div class="thead">\n              <div class="tr">\n                <div class="td check-item">\n                  <label class="check_yellow_16 check">\n                    <input type="checkbox" ng-model="selectedAll" ng-change="selectAllCollaborations()" />\n                    <span class="checkmark_16"></span>\n                  </label>\n                </div>\n                <div class="main-columns">\n                  <div class="td flex-30" translate="Collaborator"></div>\n                  <div class="td flex-30" translate="Co-ordinator"></div>\n                  <div class="td flex-20" translate="Contact Info"></div>\n                  <div class="td flex-20" translate="Collaboration Status"></div>\n                </div>\n                <div class="td actions" translate="Actions"></div>\n              </div>\n            </div> --><!-- <div class="tbody pos-relative">\n              <spinner ng-if="isLoading"></spinner>\n              <div ng-repeat="collaboration in suppliers">\n                <div class="tr">\n                  <div class="td check-item">\n                    <label class="check_yellow_16 check">\n                      <input type="checkbox" ng-model="collaboration.selected" ng-change="selectCollaboration()"/>\n                      <span class="checkmark_16"></span>\n                    </label>\n                  </div>\n                  <img ng-src="{{collaboration.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}" alt="" class="cursor-point mr-16" ng-click="collaboration.expanded = !collaboration.expanded">\n                  <div class="main-columns">\n                    <div class="td flex-30">{{collaboration.name}}</div>\n                    <div class="td flex-30">{{collaboration.parent ? collaboration.parent.userId.displayName : \'\'}}</div>\n                    <div class="td flex-20">({{collaboration.parent ? collaboration.parent.userId.mobile.dialCode : \'\'}}) {{collaboration.parent ? collaboration.parent.userId.mobile.phoneNumber : \'\'}}</div>\n                    <div class="td flex-20">\n                      <div class="status-box" ng-class="collaboration.members.status">\n                        <img class="ml-8" ng-if="collaboration.members.status == \'Finished\'" src=\'/assets/icons/check-offer-status-f.svg\'alt=""/>\n                        <img class="ml-8" ng-if="collaboration.members.status == \'Not yet\'"  src=\'/assets/icons/close-offer-status-f.svg\' alt=""/>\n                        <img class="ml-8" ng-if="collaboration.members.status == \'Not completed\'" src=\'/assets/icons/pause-offer-status_f.svg\' alt=""/>\n                        {{collaboration.members.status || \'None\'}}\n                      </div>\n                    </div>\n                  </div>\n                  <div class="td actions">\n                    <button class="btn income-offer-button" ng-click="saveCollaborationTeam(collaboration)" translate="Save"></button>\n                  </div>\n                </div>\n                <div class="members-panel">\n                  <div class="row">\n                    <div class="col-6 mb-24">\n                      <label>QA</label>\n                      <div class="members-box">\n                        <div class="d-flex flex-wrap w-100 h-100" ref="drop-zone-qa" refId="{{collaboration._id}}">\n                          <div class="member-box" ng-repeat="member in collaboration.members.qaMembers track by $index">\n                            <span class="mr-8">{{member.displayName}}</span>\n                            <img src="/assets/icons/close-16-gray.svg" alt="" class="cursor-point" ng-click="removeMember(collaboration, collaboration.members.qaMembers, $index)"/>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="col-6 mb-24">\n                      <label>Issue</label>\n                      <div class="members-box">\n                        <div class="d-flex flex-wrap w-100 h-100" ref="drop-zone-issue" refId="{{collaboration._id}}">\n                          <div class="member-box" ng-repeat="member in collaboration.members.issueMembers track by $index">\n                            <span class="mr-8">{{member.displayName}}</span>\n                            <img src="/assets/icons/close-16-gray.svg" alt="" class="cursor-point" ng-click="removeMember(collaboration, collaboration.members.issueMembers, $index)"/>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="col-6 mb-24">\n                      <label>VA Orders</label>\n                      <div class="members-box">\n                        <div class="d-flex flex-wrap w-100 h-100" ref="drop-zone-vaorder" refId="{{collaboration._id}}">\n                          <div class="member-box" ng-repeat="member in collaboration.members.vaOrderMembers track by $index">\n                            <span class="mr-8">{{member.displayName}}</span>\n                            <img src="/assets/icons/close-16-gray.svg" alt="" class="cursor-point" ng-click="removeMember(collaboration, collaboration.members.vaOrderMembers, $index)"/>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="col-6 mb-24">\n                      <label>Drawing Approval</label>\n                      <div class="members-box">\n                        <div class="d-flex flex-wrap w-100 h-100" ref="drop-zone-drawing" refId="{{collaboration._id}}">\n                          <div class="member-box" ng-repeat="member in collaboration.members.drawingMembers track by $index">\n                            <span class="mr-8">{{member.displayName}}</span>\n                            <img src="/assets/icons/close-16-gray.svg" alt="" class="cursor-point" ng-click="removeMember(collaboration, collaboration.members.drawingMembers, $index)"/>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="col-6 mb-24">\n                      <label>Safety</label>\n                      <div class="members-box">\n                        <div class="d-flex flex-wrap w-100 h-100" ref="drop-zone-safety" refId="{{collaboration._id}}">\n                          <div class="member-box" ng-repeat="member in collaboration.members.safetyMembers track by $index">\n                            <span class="mr-8">{{member.displayName}}</span>\n                            <img src="/assets/icons/close-16-gray.svg" alt="" class="cursor-point" ng-click="removeMember(collaboration, collaboration.members.safetyMembers, $index)"/>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="col-6 mb-24">\n                      <label>TQ Eletrical</label>\n                      <div class="members-box">\n                        <div class="d-flex flex-wrap w-100 h-100" ref="drop-zone-tq-eletrical" refId="{{collaboration._id}}">\n                          <div class="member-box" ng-repeat="member in collaboration.members.tqEletricalMembers track by $index">\n                            <span class="mr-8">{{member.displayName}}</span>\n                            <img src="/assets/icons/close-16-gray.svg" alt="" class="cursor-point" ng-click="removeMember(collaboration, collaboration.members.tqEletricalMembers, $index)"/>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="col-6 mb-24">\n                      <label>TQ Plumming</label>\n                      <div class="members-box">\n                        <div class="d-flex flex-wrap w-100 h-100" ref="drop-zone-tq-plumming" refId="{{collaboration._id}}">\n                          <div class="member-box" ng-repeat="member in collaboration.members.tqPlummingMembers track by $index">\n                            <span class="mr-8">{{member.displayName}}</span>\n                            <img src="/assets/icons/close-16-gray.svg" alt="" class="cursor-point" ng-click="removeMember(collaboration, collaboration.members.tqPlummingMembers, $index)"/>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="col-6 mb-24">\n                      <label>TQ Architect</label>\n                      <div class="members-box">\n                        <div class="d-flex flex-wrap w-100 h-100" ref="drop-zone-tq-architect" refId="{{collaboration._id}}">\n                          <div class="member-box" ng-repeat="member in collaboration.members.tqArchitectMembers track by $index">\n                            <span class="mr-8">{{member.displayName}}</span>\n                            <img src="/assets/icons/close-16-gray.svg" alt="" class="cursor-point" ng-click="removeMember(collaboration, collaboration.members.tqArchitectMembers, $index)"/>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="col-6 mb-24">\n                      <label>TQ Ventilation</label>\n                      <div class="members-box">\n                        <div class="d-flex flex-wrap w-100 h-100" ref="drop-zone-tq-ventilation" refId="{{collaboration._id}}">\n                          <div class="member-box" ng-repeat="member in collaboration.members.tqVentilationMembers track by $index">\n                            <span class="mr-8">{{member.displayName}}</span>\n                            <img src="/assets/icons/close-16-gray.svg" alt="" class="cursor-point" ng-click="removeMember(collaboration, collaboration.members.tqVentilationMembers, $index)"/>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="col-6">\n                      <label>TQ Mechanical</label>\n                      <div class="members-box">\n                        <div class="d-flex flex-wrap w-100 h-100" ref="drop-zone-tq-mechanical" refId="{{collaboration._id}}">\n                          <div class="member-box" ng-repeat="member in collaboration.members.tqMechanicalMembers track by $index">\n                            <span class="mr-8">{{member.displayName}}</span>\n                            <img src="/assets/icons/close-16-gray.svg" alt="" class="cursor-point" ng-click="removeMember(collaboration, collaboration.members.tqMechanicalMembers, $index)"/>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div> --></div></div></div></div></div></main>');
$templateCache.put('app/main/collaborations/createBidOfferTemplate/createBidOfferTemplate.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=create-bid-offer-template class="main-container collaboration-page"><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=bidPackages class="ft-normal-12-16 grey-2" translate=Collaborations></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=offerTemplates class="ft-normal-12-16 grey-2" translate="Offer Templates"></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Create Offer Template"></a></div><div class=ft_24_600_black1 translate="Create Offer Template"></div></div><!-- <collaboration-menu></collaboration-menu> --><div class="btn btn-black ml-auto mr-8" ng-click=openBIMDlg()><span translate="Create From VP"></span></div><div class="btn btn-black mr-8" ng-click=openBIMDlg()><span translate="Create From BIM"></span></div><div class="button-primary mr-8" ng-click=update()><i class="fa fa-cloud-upload-alt mr-2"></i><span translate=Upload></span></div><a class="btn btn-light" href=/assets/csv_templates/offer_template_levels.csv target=_blank><span translate=Discard></span></a></div><div class="flex flex-row" style="height: calc(100% - 76px)"><div class=createOfferLeftPanel><div class="mb-24 mt-8"><span class=ft_14_600_moreblack translate="Bid Package"></span><selectbox-input class=dropdown-primary ng-model=vm.bidOfferTemplate.bidPackageId options=bidPackages label-field=title value-field=_id select-event=changeOfferTemplate()></selectbox-input></div><div class=left-filter-content><div class="flex flex-row flex-items-center addFilterContainer"><img class=mr-10 src=/assets/icons/filter-left-icon.svg alt=icons><div class="search-type-filter flex flex-row flex-items-center"><img src=/assets/icons/search_dark.svg alt=icons> <input type=text class="login_input_new_no_mt w-100" placeholder="Search types" ng-model=filterText ng-keypress=onEnter($event)></div></div><div class="ft_14_600_moreblack mt-30 ml-4">Selected Objects</div><div class="flex flex-row flex-wrap" ng-show="models.length > 0"><div class=checklist-item ng-repeat="(key,item) in models"><span>{{ item }}</span> <img class="cursor-point ml-3" src=/assets/icons/close-24.svg ng-click=removeFilter(key)></div></div><div class="d-flex mt-40"><div class="d-flex justify-content-start cursor-point"><div class="plus-circle mr-8"><img src=/assets/icons/plus.svg alt=""></div><div class=ft_14_600_black>Add Selected</div></div></div></div></div><spinner ng-if=isLoading></spinner><div class="content d-flex w-100 flex-col"><div class="flex flex-content-end mb-16"><div class="button-primary mr-8" ngf-select ngf-pattern="\'.xls,.xlsx\'" ngf-accept="\'.xls,.xlsx\'" ngf-change=changeFiles($files)><i class="fa fa-cloud-upload-alt mr-2"></i> <span translate="Import Levels"></span></div><!-- <div class="btn btn-blue mr-8" ng-click="exportLevels()">\n          <i class="fa fa-cloud-download-alt mr-2"></i>\n          <span translate="Export Levels"></span>\n        </div> --><!-- <a class="btn btn-light" href="/assets/csv_templates/offer_template_levels.csv" target="_blank"> --><div class="btn btn-light" ng-click=exportToExcel(vm.bidOfferTemplate.bidPackageId)><i class="fa fa-cloud-download-alt mr-2"></i> <span translate="Download Template"></span></div><!-- </a> --></div><div class=item><div class=space></div><div class="info row"><div class=col-5><div class=row><div class=col-4><label translate=Name></label></div><div class=col-3><label translate=Type></label></div><div class=col-2><label translate=Level></label></div><div class=col-3><label translate=Size></label></div></div></div><div class=col-7><div class=row><div class=col-3><label translate=Description></label></div><div class=col-2><label translate=Days></label></div><div class=col-2><label translate=Quanties></label></div><div class=col-1><label translate=Unit></label></div><div class="col-1 unit-price"><label translate="Unit Price"></label></div><div class=col-2><label translate=Amount></label></div><div class=col-1></div></div></div></div></div><div class=offerLineList><div class=item ng-repeat="item in vm.bidOfferTemplate.levels track by $index" ng-show=checkFilter(item)><div class=space><input type=checkbox ng-model=item.isChecked></div><div class="info row"><div class=col-5><div class=row><div class=col-4><input type=text ng-model=item.name class=login_input_new_no_mt></div><div class=col-3><input type=text ng-model=item.type class=login_input_new_no_mt></div><div class=col-2><input type=text ng-model=item.level class=login_input_new_no_mt></div><div class=col-3><input type=text ng-model=item.size class=login_input_new_no_mt></div></div></div><div class=col-7><div class=row><div class=col-3><input type=text class=login_input_new_no_mt ng-model=item.description></div><div class=col-2><input type=text number-edit ng-model=item.days class="login_input_new_no_mt text-right"></div><div class=col-2><input type=text number-edit ng-model=item.quantity class="login_input_new_no_mt text-right"></div><div class=col-1><input type=text ng-model=item.unit class="login_input_new_no_mt text-right"></div><div class=col-1><input type=text number-edit ng-model=item.unitPrice class="login_input_new_no_mt text-right"></div><div class=col-2><input type=text number-edit ng-model=item.amount class="login_input_new_no_mt text-right"></div><div class="col-1 d-flex align-items-center justify-content-center"><a href=javascript:; ng-click=removeLevel($index)><i class="fa fa-times text-danger"></i></a></div></div></div></div></div></div><div class="item mt-8"><div class=space></div><!-- <div class="level">\n          <span ng-if="vm.bidOfferTemplate.levels.length" class="font-weight-bold">Total</span>\n        </div> --><div class=info><!-- <div class="flex-15 text-right">\n            <span ng-if="vm.bidOfferTemplate.levels.length">{{vm.totalDays | readable: 2}}</span>\n          </div>\n          <div class="flex-25 text-right">\n            <span ng-if="vm.bidOfferTemplate.levels.length">{{vm.totalAmount | readable: 2}}</span>\n          </div>\n          <div class="flex-20"></div> --><div class=d-flex><div class="d-flex justify-content-start cursor-point" ng-click=addItem()><div class="plus-circle mr-8"><img src=/assets/icons/plus.svg alt=""></div><div class=ft_14_600_black translate="Add New Line"></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/collaborations/createBidPackage/createBidPackage.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=create-bid-package class="main-container collaboration-page"><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=bidPackages class="ft-normal-12-16 grey-2" translate=Collaborations></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=bidPackages class="ft-normal-12-16 grey-2" translate="Bid Packages"></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Create Bid Package"></a></div><div class=ft_24_600_black1 translate="Create Bid Package"></div></div><!-- <collaboration-menu></collaboration-menu> --><div class="button-primary ml-auto" ng-click=onSave()><span ng-if=!vm.editMode translate=Save></span> <span ng-if=vm.editMode translate=Update></span></div><div class="btn_cancel ml-16" ng-click=onDiscard()><span translate=Discard></span></div></div><div class="card-based-content-grid-wrapper p-24"><div class="content flex"><spinner ng-if=loading></spinner><div class=left-content><div class=block><label translate="Bid Title"></label> <input type=text ng-model=bidPackage.title placeholder="Enter title here"></div><div class=block><label translate=Description></label> <textarea ng-model=bidPackage.description placeholder="Enter your description here"></textarea></div><div class=block><label translate="Type of Work"></label><selectbox-input ng-model=workType options=vm.workTypes label-field=tagName value-field=_id select-event=selectWorkType()></selectbox-input><div ng-if="bidPackage.typeOfWork && bidPackage.typeOfWork.length" class=work-types><div class=work-type ng-repeat="workType in bidPackage.typeOfWork track by $index"><div class=mr-16>{{workType.tagName}}</div><img src=/assets/icons/close-16-black.svg alt="" ng-click=removeWorkType($index)></div></div></div><div class=block><label translate="Accept Deadline"></label><div class=d-flex><div class=has-calendar><input type=text class=calendar-box id=accept-deadline-input-date readonly data-widget-control> <img src=/assets/icons/calendar-gray.svg alt=Search class=calendar_icon></div><div class=has-calendar><input type=text class=calendar-box id=accept-deadline-input-time readonly data-widget-control> <img src=/assets/icons/bx-timer-gray.svg alt=Search class=calendar_icon></div></div></div><div class=block><label translate="Bid Deadline"></label><div class=d-flex><div class=has-calendar><input type=text class=calendar-box id=bid-deadline-input-date readonly data-widget-control> <img src=/assets/icons/calendar-gray.svg alt=Search class=calendar_icon></div><div class=has-calendar><input type=text class=calendar-box id=bid-deadline-input-time readonly data-widget-control> <img src=/assets/icons/bx-timer-gray.svg alt=Search class=calendar_icon></div></div></div><div class=block><label translate="Tender Deadline"></label><div class=d-flex><div class=has-calendar><input type=text class=calendar-box id=tender-deadline-input-date readonly data-widget-control> <img src=/assets/icons/calendar-gray.svg alt=Search class=calendar_icon></div><div class=has-calendar><input type=text class=calendar-box id=tender-deadline-input-time readonly data-widget-control> <img src=/assets/icons/bx-timer-gray.svg alt=Search class=calendar_icon></div></div></div></div><div class="right-content ml-100"><div class=block ng-show=vm.editMode><label translate="System Tag"></label> <input type=text ng-model=bidPackage.sysTag placeholder=Automatically readonly></div><div class=block><label translate="Type of Collaborator"></label><selectbox-input ng-model=bidPackage.vendorType options=vm.collaborators label-field=label value-field=value select-event=selectWorkType()></selectbox-input></div><div class=block><label translate="Created By"></label> <input type=text ng-model=vm.createByName placeholder="Enter username here"></div><div class=block><label translate="Email Address"></label> <input type=text ng-model=bidPackage.email placeholder="Enter email address here"></div><!-- <div class="block">\n            <label translate="Contact No."></label>\n            <input type="text" ng-model="bidPackage.contactNo" placeholder="Enter contact no. here"/>\n          </div> --><div class=block><label translate="Contact No."></label><div class="d-flex phone"><selectbox-input ng-model=bidPackage.contactNo.dialCode options=vm.getCountryCode label-field=dialCode value-field=dialCode></selectbox-input><input autocomplete=off type=tel class="field-input number_input" id=phoneNumber name=phoneNumber ng-model=bidPackage.contactNo.phoneNumber placeholder="" required></div></div><!-- <div class="block flex">\n            <div class="btn btn-black" ng-click="onSave()">\n              <span ng-if="!vm.editMode" translate="Create Bid Package"></span>\n              <span ng-if="vm.editMode" translate="Update Bid Package"></span>\n            </div>\n            <div class="btn-white ml-16" ng-click="onDiscard()">\n              <span translate="Discard"></span>\n            </div>\n          </div> --><div class=block><div class="d-flex align-items-center mb-16"><img id=fileSelector src=/assets/icons/attachment4.svg alt="" class="cursor-point mr-8" ngf-select ngf-pattern="\'.pdf,.jpg,.png\'" ngf-multiple=true ngf-accept="\'.pdf,.jpg,.png\'" ngf-change=changeFiles($files)> <label class="cursor-point mb-0" ng-click=attachFiles() translate=Attachments></label></div><div class="d-flex flex-wrap"><div class="d-flex align-items-center mr-8 mb-8 position-relative" ng-repeat="attach in attached"><img ng-if="attach.format.indexOf(\'pdf\') == -1" ng-src={{attach.secure_url}} alt="" class="attach-file mr-16"><div ng-if="attach.format.indexOf(\'pdf\') != -1" class="attach-file pdf mr-16"><div class=ft_14_600_gray>PDF</div></div><div><div class="ft_14_500_black mb-8 w-120 tx-ellipsis">{{attach.fileName}}</div><div class="ft_14_regular_gray w-120 tx-ellipsis">{{attach.bytes | filesize}}</div></div><a href=javascript:; class=remove-icon ng-click=removeFile(attach)><i class="fa fa-times text-danger"></i></a></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/collaborations/createTeam/createTeam.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=create-team class="main-container collaboration-page"><div class=title-bar><div class=w-230><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=bidPackages class="ft-normal-12-16 grey-2" translate=Collaborations></a></div><div class=ft_24_600_black1 translate="Create Team"></div></div><collaboration-menu></collaboration-menu><!-- <div class="export-svg-btn-container d-flex align-items-center justify-content-between">\n        <button class="btn btn-black btn-widh-image" ng-click="exportOrgChart()">\n          <img src="/assets/icons/download-white.svg" alt="">\n        </button>\n      </div> --></div><div class="d-flex content-wrap"><collaboration-managers-panel binding-user-type=userType binding-user-types=userTypes binding-user-id=vm.selectedUserId binding-user-list=userList isolated-expression-func=addMember()></collaboration-managers-panel><div class=collaborations-main><div class=collaboration-content><div class="team-container pos-relative"><spinner ng-if=loading></spinner><members-tree org-chart=vm.orgChart ref=drop-zone></members-tree></div></div></div></div></div></main>');
$templateCache.put('app/main/collaborations/incomingOffers/incomingOffers.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="main-container collaboration-page"><div class=title-bar><div class=title-bar-container><div class=w-250><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Collaborators></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="bid & tender"></a></div><div class=header-title translate="Incoming Offers"></div></div><ul class="navbar-nav nav-container ml-100 mt-4"><li class=nav-item ng-click="setTab(\'Supplier\')" ng-class="{active : SupOrSub == \'Supplier\'}"><a translate=Suppliers></a></li><li class=nav-item ng-click="setTab(\'Subcontractors\')" ng-class="{active : SupOrSub == \'Subcontractors\'}"><a translate=Subcontractors></a></li></ul><div class="d-flex align-items-center ml-auto"><selectbox-input ng-show="SupOrSub == \'Supplier\'" class="select-options ml-16" options=suppliers ng-model=selSupplier label-field=name value-field=_id select-event=selectSupplier()></selectbox-input><selectbox-input ng-show="SupOrSub == \'Subcontractors\'" class="select-options ml-16" options=subContractors ng-model=selSubcontractor label-field=name value-field=_id select-event=selectSubcontractor()></selectbox-input><!-- <selectbox-input class="select-options ml-16"\n            options="projects"\n            ng-model="selectedProject"\n            label-field="projectName" value-field="_id"\n            select-event="selectProject()">\n          </selectbox-input> --><searchbox class=ml-16 search-text=vm.searchText search-event=searchBidPackages()></searchbox></div></div></div><div class="content-wrap p-24"><dashboard-incoming-offer></dashboard-incoming-offer></div></div></main>');
$templateCache.put('app/main/collaborations/offerTemplates/offerTemplates.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=offerTemplates class="main-container collaboration-page"><div class=title-bar><div class=w-230><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Collaborations></a></div><div class=ft_24_600_black1 translate="Offer Templates"></div></div><collaboration-menu></collaboration-menu><searchbox class=ml-auto search-text=vm.searchText search-event=searchBidPackages()></searchbox><div class="button-primary ml-16 cursor-point" ng-click=gotoCreateOfferTemplate()><img src=/assets/icons/plus-white.svg alt=""><span translate="Setup Offer Template"></span></div></div><div class="content-wrap p-24"><div class="content d-flex flex-column justify-content-between p-0"><div class="table-container pos-relative"><spinner ng-if=loading></spinner><div class=thead><div class=tr><div class="td check-item"></div><div class="d-flex main-td-group"><div class="td work-type" translate="Bid Package"></div><div class="td offername" translate="System Tag"></div><div class="td coordinator" translate="Bid Type"></div><div class="td levels" translate="Vendor Type"></div><div class="td no-of-days"></div><div class="td offer-amount"></div><div class="td status"></div><div class="td status"></div><div class="td status"></div></div></div></div><div ng-if=vm.bidPackages.length class=tbody><div ng-repeat="offer in vm.bidPackages"><div class=tr><div class="td check-item"><img ng-click="offer.expanded = !offer.expanded" alt="" ng-src="{{offer.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}"></div><div class="d-flex main-td-group"><div class="td work-type">{{offer.bidPackageId.title}}</div><div class="td offername">{{offer.bidPackageId.sysTag}}</div><div class="td coordinator">{{offer.bidPackageId.typeOfWork ? workTypes(offer.bidPackageId.typeOfWork) : \'\'}}</div><div class="td levels">{{offer.bidPackageId.vendorType == 0? \'Supplier\' : \'Sub-contractor\'}}</div><div class="td no-of-days" ng-class="{\'ft_14_600_light_gray\': !offer.expanded}">Name</div><div class="td offer-amount" ng-class="{\'ft_14_600_light_gray\': !offer.expanded}">Description</div><div class="td status" ng-class="{\'ft_14_600_light_gray\': !offer.expanded}">Type</div><div class="td status" ng-class="{\'ft_14_600_light_gray\': !offer.expanded}">Level</div><div class="td status" ng-class="{\'ft_14_600_light_gray\': !offer.expanded}">Size</div></div><div class="td actions"><div class="dropdown mx-height5"><button class=dropdown-toggle type=button data-toggle=dropdown><img src=/assets/icons/more-horiz.svg alt=""></button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-click=vm.onRemoveOffer(offer._id)><img src=/assets/icons/delete4.svg alt="">Delete</li></ul></div></div></div><div class=groups-panel ng-show=offer.expanded><!-- <div class="group-name">{{group.name}}</div> --><div class=levels-tab-container><div class=levels-tab ng-click=selectGroup(offer) ng-class="{\'active\': offer.selectedGroup.name == \'All\'}">All</div><div class=levels-tab ng-repeat="group in offer.groups" ng-click="selectGroup(offer, group)" ng-class="{\'active\': offer.selectedGroup == group}">{{group.name}}</div></div><div class=group-table><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><label translate=Name></label></div><div class=col-3><label translate=Type></label></div><div class=col-2><label translate=Level></label></div><div class=col-3><label translate=Size></label></div></div></div><div class=col-7><div class=row><div class=col-4><label translate=Description></label></div><div class=col-1><label translate=Days></label></div><div class=col-1><label translate=Qty.></label></div><div class=col-1><label translate=Unit></label></div><div class=col-2><label translate="Unit Price"></label></div><div class=col-3><label translate="Offer Amount"></label></div></div></div></div></div><div ng-show="offer.selectedGroup.name == \'All\'"><div ng-repeat="group in offer.groups"><div class=item><div class="info row"><div class=col-5><div class="d-flex pr-4"><img src=/assets/icons/arrow_drop_down_collapse_gray.svg alt="" ng-if=!group.expanded ng-click="group.expanded = true" class=mr-2> <img src=/assets/icons/arrow_drop_down_collapse_open.svg alt="" ng-if=group.expanded ng-click="group.expanded = false" class=mr-2> {{group.name}}</div></div><div class=col-7><div class=row><div class=col-4></div><div class=col-1>{{calcGroupDays(group)}}</div><div class=col-1>{{calcGroupQuantity(group)}}</div><div class=col-1></div><div class=col-2></div><div class=col-3>{{vm.companyData.currentCurrency.symbol}} {{calcGroupOfferAmount(group) | readable: 2}}</div></div></div></div></div><div class=item-break></div><div ng-repeat="item in group.levels track by $index" ng-show=group.expanded><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><!-- <input type="text" ng-model="item.name" class="login_input_new_no_mt"> --><div class=overflow-wrap>{{item.name}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.type" class="login_input_new_no_mt"> --><div>{{item.type}}</div></div><div class=col-2><!-- <input type="text" ng-model="item.level" class="login_input_new_no_mt"> --><div>{{item.level}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.size" class="login_input_new_no_mt"> --><div>{{item.size}}</div></div></div></div><div class=col-7><div class=row><div class=col-4><!-- <input type="text" class="login_input_new_no_mt" ng-model="item.description"> --><div>{{item.description}}</div></div><div class=col-1><!-- <input type="text" number-edit ng-model="item.days" class="login_input_new_no_mt text-right"> --><div>{{item.days}}</div></div><div class=col-1><!-- <input type="text" number-edit ng-model="item.quantity" class="login_input_new_no_mt text-right"> --><div>{{item.quantity}}</div></div><div class=col-1><!-- <input type="text" ng-model="item.unit" class="login_input_new_no_mt text-right"> --><div>{{item.unit}}</div></div><div class=col-2><!-- <input type="text" number-edit ng-model="item.unitPrice" class="login_input_new_no_mt text-right"> --><div>{{vm.companyData.currentCurrency.symbol}} {{item.unitPrice | readable: 2}}</div></div><div class=col-3><!-- <input type="text" number-edit ng-model="item.amount" class="login_input_new_no_mt text-right"> --><div>{{vm.companyData.currentCurrency.symbol}} {{item.amount | readable: 2}}</div></div></div></div></div></div><div class=item-break></div></div></div></div><div ng-repeat="group in offer.groups"><div ng-repeat="item in group.levels track by $index" ng-show="offer.selectedGroup == group"><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><!-- <input type="text" ng-model="item.name" class="login_input_new_no_mt"> --><div class=overflow-wrap>{{item.name}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.type" class="login_input_new_no_mt"> --><div>{{item.type}}</div></div><div class=col-2><!-- <input type="text" ng-model="item.level" class="login_input_new_no_mt"> --><div>{{item.level}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.size" class="login_input_new_no_mt"> --><div>{{item.size}}</div></div></div></div><div class=col-7><div class=row><div class=col-4><!-- <input type="text" class="login_input_new_no_mt" ng-model="item.description"> --><div>{{item.description}}</div></div><div class=col-1><!-- <input type="text" number-edit ng-model="item.days" class="login_input_new_no_mt text-right"> --><div>{{item.days}}</div></div><div class=col-1><!-- <input type="text" number-edit ng-model="item.quantity" class="login_input_new_no_mt text-right"> --><div>{{item.quantity}}</div></div><div class=col-1><!-- <input type="text" ng-model="item.unit" class="login_input_new_no_mt text-right"> --><div>{{item.unit}}</div></div><div class=col-2><!-- <input type="text" number-edit ng-model="item.unitPrice" class="login_input_new_no_mt text-right"> --><div>{{vm.companyData.currentCurrency.symbol}} {{item.unitPrice | readable: 2}}</div></div><div class=col-3><!-- <input type="text" number-edit ng-model="item.amount" class="login_input_new_no_mt text-right"> --><div>{{vm.companyData.currentCurrency.symbol}} {{item.amount | readable: 2}}</div></div></div></div></div></div><div class=item-break></div></div></div><!-- <div ng-repeat="item in offer.selectedGroup.levels track by $index">\n                    <div class="item-break"></div>\n                    <div class="item">\n                      <div class="info row">\n                        <div class="col-5">\n                          <div class="row">\n                            <div class="col-4">\n                              <div class="overflow-wrap">{{item.name}}</div>\n                            </div>\n                            <div class="col-3">\n                              <div>{{item.type}}</div>\n                            </div>\n                            <div class="col-2">\n                              <div>{{item.level}}</div>\n                            </div>\n                            <div class="col-3">\n                              <div>{{item.size}}</div>\n                            </div>\n                          </div>\n                        </div>\n                        <div class="col-7">\n                          <div class="row">\n                            <div class="col-4">\n                              <div>{{item.description}}</div>\n                            </div>\n                            <div class="col-1">\n                              <div>{{item.days}}</div>\n                            </div>\n                            <div class="col-1">\n                              <div>{{item.quantity}}</div>\n                            </div>\n                            <div class="col-1">\n                              <div>{{item.unit}}</div>\n                            </div>\n                            <div class="col-2">\n                              <div>{{item.unitPrice}}</div>\n                            </div>\n                            <div class="col-3">\n                              <div>{{item.amount}}</div>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div> --><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><label translate=""></label></div><div class=col-3><label translate=""></label></div><div class=col-2><label translate=""></label></div><div class=col-3><label translate=""></label></div></div></div><div class=col-7><div class=row><div class=col-4><label translate=Sum></label></div><div class=col-1><label>{{calcGroupDays(offer.selectedGroup)}}</label></div><div class=col-1><label>{{calcGroupQuantity(offer.selectedGroup)}}</label></div><div class=col-1><label translate=""></label></div><div class=col-2><label translate=""></label></div><div class=col-3><label>{{vm.companyData.currentCurrency.symbol}} {{calcGroupOfferAmount(offer.selectedGroup) | readable: 2}}</label></div></div></div></div></div></div><!-- <div class="tr levels-panel" ng-repeat="lv in group.levels" ng-show="offer.expanded">\n                  <div class="td check-item"></div>\n                  <div class="d-flex main-td-group">\n                    <div class="td work-type"></div>\n                    <div class="td offername">{{offer.bidPackageId.sysTag + \'-\' + ($index + 1)}}</div>\n                    <div class="td coordinator"></div>\n                    <div class="td levels"></div>\n                    <div class="td no-of-days">{{lv.name}}</div>\n                    <div class="td offer-amount">{{lv.description}}</div>\n                    <div class="td status">{{lv.type}}</div>\n                    <div class="td status">{{lv.level}}</div>\n                    <div class="td status">{{lv.size}}</div>\n                  </div>\n                  <div class="td actions"></div>\n                </div> --></div></div></div><div ng-if=!vm.bidPackages.length class=no-bid-pacakges><div class=title>No data to display.</div></div></div><!-- <pagination ng-if="vm.bidPackages.length" class="ml-auto" num-pages="noOfPages" current-page="vm.currentPage" on-select-page="fetchData()"></pagination> --><div class="pagination-footer flex-items-center flex-content-end" ng-if=vm.bidPackages.length><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span>{{(vm.currentPage - 1) * numPerPage + vm.bidPackages.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div></div></div></main>');
$templateCache.put('app/main/collaborations/projectInvite/projectInvite.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=projectInvite class="main-container collaboration-page"><div class=title-bar><div class=w-300><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=bidPackages class="ft-normal-12-16 grey-2" translate=Collaborations></a></div><div class=header-title translate=Invites></div></div><collaboration-menu></collaboration-menu><searchbox class=ml-auto input-class=search search-text=vm.searchText search-event=searchData()></searchbox><div class="bbtn-blue ml-16" ng-click=inviteSelected()><img src=/assets/icons/forward.svg alt=""> <span class=ml-8 translate="Send Invitations"></span></div></div><div class="d-flex content-wrap"><collaboration-filters-panel></collaboration-filters-panel><div class=collaborations-main><div class=collaboration-content><div class="table-container pos-relative"><spinner ng-if=loading></spinner><div class=thead><div class=tr><div class="td check-item"><label class="check_yellow_16 check"><input type=checkbox ng-model=selectedAll ng-change=selectAllVendorAndManagers()> <span class=checkmark_16></span></label></div><div class="d-flex main-td-group"><div class="td collaborator" translate=Collaborator></div><div class="td co-ordinator" translate=Co-ordinator></div><div class="td contact-info" translate="Contact No"></div><div class="td bid-status" translate=Status></div></div><div class="td actions" translate=Actions></div></div></div><div class=tbody><div class=tr ng-repeat="vendorOrManager in vm.companyVendorAndManagers track by $index"><div class="td check-item"><label class="check_yellow_16 check"><input type=checkbox ng-model=vendorOrManager.selected ng-change=selectVendorOrUser(vendorOrManager)> <span class=checkmark_16></span></label></div><div class="d-flex main-td-group"><div class="td collaborator">{{vendorOrManager.clientName || vendorOrManager.name || vendorOrManager.displayName}}</div><div class="td co-ordinator">{{vendorOrManager.email}}</div><div class="td contact-info" ng-if="vendorOrManager.designation !== \'Manager\'">{{utils.getAddressString(vendorOrManager.address) || utils.getAddressString(vendorOrManager.address[0])}}</div><div class="td contact-info" ng-if="vendorOrManager.designation === \'Manager\'">({{vendorOrManager.mobile.dialCode}}) {{vendorOrManager.mobile.phoneNumber}}</div><div class="td bid-status"><div class="d-flex align-items-center"><img ng-if="vendorOrManager.status === \'Accepted\' || vendorOrManager.status === \'Declined\'" ng-src="{{vendorOrManager.status === \'Accepted\' ? \'/assets/icons/check-mark-green.svg\' : \'/assets/icons/close-circle-red1.svg\'}}" alt="" class=mr-8><div>{{vendorOrManager.inviteStatus || \'None\'}}</div></div></div></div><div class="td actions"><div class="d-flex align-items-center justify-content-between w-100"><div class=d-flex><button class="btn btn-view mr-24" ng-click=view(vendorOrManager)><img src=/assets/icons/eye6.svg alt="" class=mr-1> <span>View</span></button> <button class="btn btn-invite mr-24" ng-click=invite(vendorOrManager) ng-disabled="vendorOrManager.inviteStatus === \'Accepted\'"><img src=/assets/icons/bx-mail.svg alt="" class=mr-1> {{vendorOrManager.inviteStatus === \'Accepted\' ? \'Accepted\' : vendorOrManager.inviteStatus === \'Pending\' ? \'Resend\' : \'Invite\'}}</button></div><img src=/assets/icons/more_horiz-gray.svg alt="" class=cursor-point></div></div></div></div></div><pagination class=ml-auto num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination></div></div></div></div></main>');
$templateCache.put('app/main/collaborations/submitOffers/submitOffers.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=submitOffer class="main-container collaboration-page"><div class=title-bar><div class=title-bar-container><div class=w-250><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Collaborators></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="{{userRole == 2 ? \'Supplier\' : \'Sub-Constractor\'}}"></a></div><div class=header-title translate="Submit Offers"></div></div><div class="block-header flex-between ml-auto"><!-- <div class="block-title" translate="Collaboration Offers"></div> --><div class=d-flex><selectbox-input ng-show="userRole == 2" class=select-options options=suppliers ng-model=selSupplier label-field=name value-field=_id select-event=selectSupplier()></selectbox-input><selectbox-input ng-show="userRole == 3" class=select-options options=subContractors ng-model=selSupplier label-field=name value-field=_id select-event=selectSupplier()></selectbox-input><!-- <selectbox-input class="select-options ml-16"\n              options="projects"\n              ng-model="selectedProject"\n              label-field="projectName" value-field="_id"\n              select-event="selectProject()">\n            </selectbox-input> --></div><searchbox class=ml-16 search-text=vm.searchText search-event=searchBidPackages()></searchbox><!-- <div class="action-button ml-16" ui-sref="collaborationOffers" translate="View All"></div> --></div></div></div><div class="content-wrap p-24"><dashboard-submit-offer collaborator-type=userRole></dashboard-submit-offer></div></div></main>');
$templateCache.put('app/main/controlPlan/controlPlanAdd/controlPlanAdd.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=controlPlanAdd class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=controlPlanGrid translate="Control Plan"></a></div><div class=ft_24_600_black1 translate="Add Control Plan"></div></div><div class="dropdown ml-auto"><button class=dropdown-toggle type=button id=menu1 data-toggle=dropdown ng-bind="clientData.clientContact.dialCode ? clientData.clientContact.dialCode : \'Select Control Plan\'" translate="Assigned To"></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li><a href=# class=menu-item id="{{ currency.dialCode }}" data-ng-click=ClientDialCode($event) ng-repeat="currency in vm.getCountryCode">{{ currency.dialCode }}</a></li><li><a class=menu-item ng-if=!vm.getCountryCode translate="No Data"></a></li></ul></div><!-- <selectbox-input\n        class="select-template ml-auto"\n        options="vm.templates"\n        ng-model="vm.templateId"\n        placeholder="Select Control Plan"\n        label-field="name"\n        value-field="_id"\n        select-event="selectTemplate(vm.templateId)">\n      </selectbox-input> --><div class="flex flex-row flex-items-center ml-16"><button class="btn_new_blue mr-16" ng-click=vm.saveControlPlan(vm.tablePlan)><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=controlPlanGrid><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div class="mb-24 mt-24 ml-24 mr-24 flex flex-wrap content"><div class="w-100 control_plan_table"><table class=w-100><thead><tr class=ft_14_600_black><td class="ft_14_600_black number">#</td><td class=ft_14_600_black translate="Control Of"></td><td class=ft_14_600_black translate="Control Method"></td><td class=ft_14_600_black translate="Control Scope"></td><td class="ft_14_600_black freq" translate=Frequency(%)></td><td class=ft_14_600_black translate=Accept></td><td class=ft_14_600_black translate=Documentation></td><td class=ft_14_600_black translate=Responsibility></td><td class=ft_14_600_black translate=Comments></td><td class=no-border ng-click=addGroup()><img src=/assets/icons/bx-plus-circle-green.svg alt=icons></td></tr></thead><tbody ng-repeat="group in vm.tablePlan" ng-init="outerIndex=$index"><tr class=group_row><td colspan=8 class="text-left pl-15"><span class=ft_14_600_black ng-if="group.isEdit==false">{{ group.groupName }}</span> <span class=ft_14_600_black ng-if="group.isEdit==true"><input type=text class="noborder-input text-right" ng-model=group.groupName></span></td><td class="text-right pr-15"><img ng-if="group.isEdit==false" src=/assets/icons/edit.svg alt=icons ng-click=editGroupName(group)> <img ng-if="group.isEdit==true" src=/assets/icons/bx-save-gray.svg alt=icons ng-click=changeGroupName(group)></td><td class=no-border><img ng-click=addRow($index) src=/assets/icons/bx-plus-circle-green.svg alt=icons></td></tr><tr class=ft_14_regular_gray ng-repeat="item in group.groupItems" ng-init="subIndex=$index"><td class=ft_14_600_black>{{ outerIndex + 1 }}.{{ subIndex + 1 }}</td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.controlOf title={{item.controlOf}}></td><td class=text-left><autocomplete1 no-margin-right=true input-class="noborder-input text-ellipsis" ng-model=item.controlMethod title="{{ item.controlMethod }}" label-field=code value-field=_id options=controlMethods></autocomplete1></td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.controlScope title="{{ item.controlScope }}"></td><td><input type=number min=0 max=100 class=freq ng-model=item.frequency></td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.accept title="{{ item.accept }}"></td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.documentation title="{{ item.documentation }}"></td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.responsibility title="{{ item.responsibility }}"></td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.comments title="{{ item.comments }}"></td><td class=no-border><img ng-click=removeRow($index,group.groupItems) src=/assets/icons/close-circle-red.svg alt=icons></td></tr></tbody></table></div></div></div></main>');
$templateCache.put('app/main/controlPlan/controlPlanEdit/controlPlanEdit.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=controlPlanEdit class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=controlPlanGrid translate="Control Plan"></a></div><div class=ft_24_600_black1>{{ vm.Plan.systemTag }}</div></div><div class="dropdown ml-auto"><button class="dropdown-toggle pl-10" type=button id=menu1 data-toggle=dropdown ng-bind="clientData.clientContact.dialCode? clientData.clientContact.dialCode: \'Select Control Plan\'" translate="Assigned To"></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li><a href=# class=menu-item id="{{ currency.dialCode }}" data-ng-click=ClientDialCode($event) ng-repeat="currency in vm.getCountryCode">{{ currency.dialCode }}</a></li><li><a class=menu-item ng-if=!vm.getCountryCode translate="No Data"></a></li></ul></div><!-- <selectbox-input\n        class="select-template ml-auto"\n        options="vm.templates"\n        ng-model="vm.templateId"\n        placeholder="Select Control Plan"\n        label-field="name"\n        value-field="_id"\n        select-event="selectTemplate(vm.templateId)">\n      </selectbox-input> --><div class="flex flex-row flex-items-center ml-16"><button class="btn_new_blue mr-16" ng-click=vm.updateControlPlan(vm.Plan.plan)><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=controlPlanGrid><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="mb-24 mt-24 ml-24 mr-24 flex flex-wrap content"><div class="w-100 control_plan_table"><table class=w-100><thead><tr class=ft_14_600_black><td class="ft_14_600_black number">#</td><td class=ft_14_600_black translate="Control Of"></td><td class=ft_14_600_black translate="Control Method"></td><td class=ft_14_600_black translate="Control Scope"></td><td class="ft_14_600_black freq" translate=Frequency(%)></td><td class=ft_14_600_black translate=Accept></td><td class=ft_14_600_black translate=Documentation></td><td class=ft_14_600_black translate=Responsibility></td><td class=ft_14_600_black translate=Comments></td><td class=no-border><img ng-click=addGroup() src=/assets/icons/bx-plus-circle-green.svg alt=icons></td></tr></thead><tbody ng-repeat="group in vm.Plan.plan" ng-init="outerIndex=$index"><tr class=group_row><td colspan=8 class="text-left pl-15"><span class=ft_14_600_black ng-if="group.isEdit==false || group.isEdit==\'false\'">{{ group.groupName }}</span> <span class=ft_14_600_black ng-if="group.isEdit==true || group.isEdit==\'true\'"><input type=text class="noborder-input text-right" ng-model=group.groupName></span></td><td class="text-right pr-15"><img ng-if="group.isEdit==false || group.isEdit==\'false\'" src=/assets/icons/edit.svg alt=icons ng-click=editGroupName(group)> <img ng-if="group.isEdit==false || group.isEdit==\'false\'" src=/assets/icons/delete-gray1.svg alt=icons ng-click="vm.Plan.plan.splice(outerIndex, 1)"> <img ng-if="group.isEdit==true || group.isEdit==\'true\'" src=/assets/icons/bx-save-gray.svg alt=icons ng-click=changeGroupName(group)> <img ng-if="group.isEdit==true || group.isEdit==\'true\'" src=/assets/icons/close-circle-o-g.svg alt=icons ng-click="group.isEdit = false"></td><td class=no-border><img ng-click=addRow($index) src=/assets/icons/bx-plus-circle-green.svg alt=icons></td></tr><tr class=ft_14_regular_gray ng-repeat="item in group.groupItems" ng-init="subIndex=$index"><td class=ft_14_600_black>{{ outerIndex + 1 }}.{{ subIndex + 1 }}</td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.controlOf title="{{ item.controlOf }}"></td><td class=text-left><autocomplete1 no-margin-right=true input-class="noborder-input text-ellipsis" ng-model=item.controlMethod title="{{ item.controlMethod }}" label-field=code value-field=_id options=controlMethods></autocomplete1></td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.controlScope title="{{ item.controlScope }}"></td><td><input type=number min=0 max=100 class=freq ng-model=item.frequency></td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.accept title="{{ item.accept }}"></td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.documentation title="{{ item.documentation }}"></td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.responsibility title="{{ item.responsibility }}"></td><td><input type=text class="noborder-input text-left text-ellipsis" ng-model=item.comments title="{{ item.comments }}"></td><td class=no-border><img ng-click=removeRow($index,group.groupItems) src=/assets/icons/close-circle-red.svg alt=icons></td></tr></tbody></table></div></div></div></main>');
$templateCache.put('app/main/controlPlan/controlPlanGrid/controlPlanGrid.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=controlPlanGrid class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Control Plan"></a></div><div class=ft_24_600_black1 translate="Control Plan"></div></div><searchbox class=ml-auto search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><button class="btn_new_blue ml-16" ui-sref=controlPlanAdd ng-if="CPLAN_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Add Control Plan"></span></button></div><div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0 && isLoading==false"><div class="card-based-content-grid-wrapper pr-24 pv-24"><div class="quotes-wrapper flex flex-wrap"><div class=profile-card-container ng-repeat="client in controlPlans"><div class=profile-card><div class=card-content><div class="flex header"><div class=name-wrapper ng-click=goToDetail(client._id)><div class="name tx-ellipsis ft_16_600_black" ng-bind=client.systemTag></div></div></div><div class=detail><div class="flex-items-center detail-item" translate="Assigned To"><span class=ft_14_regular_gray ng-repeat="user in client.responsibleUsers">{{ user }} <span ng-if="$index!=client.responsibleUsers.length-1">,</span></span></div><div class="flex-items-center detail-item"><span class="ft_14_regular_gray tx-ellipsis" translate="No. of Groups"></span>: {{ client.plan.length }}</div></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + controlPlans.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllControlPlans()></pagination-custom-new></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/dashboard/auditManage/auditManage.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=audit-manage class="main-container dashboard"><div class=content-dashboard-wrapper><dashboard-side-menu></dashboard-side-menu><div class=content-wrapper1><div class=dashboard-header><div class="flex-center inline-block"><img ng-src="{{ vm.profilePic || \'/assets/icons/bx-user.svg\'}}" alt=logo class="inline-block object-fit-cover avatar-56 mr-16"><div class=inline-block><div class="ft-normal-24-32 black-2"><span translate=Hi></span>, <span class=ft-bold-24-32>{{vm.firstName}}</span></div><div class="ft-normal-16-24 grey-3" translate="Take a moment and have a look at this."></div></div></div><div class=flex-end><div class="btn-border mr-16" ng-click=vm.publish() ng-if=!vm.isAudit><img src=/assets/icons/bx-plus-3.svg alt=icons> <span translate=Publish></span></div><div class="btn-border mr-16" ng-click=vm.reopen() ng-if=vm.isAudit translate=Reopen></div><div class="btn-border mr-16"><img src=/assets/icons/bx-plus-3.svg alt=icons> <span translate=Request></span></div><div class=btn-blue ui-sref=typeWritterAdd ng-if=!vm.isAllProject><img src=/assets/icons/bx-plus.svg alt=icons> <span translate="New Note"></span></div></div></div><div class="filter-wrap mt-30"><div class=select-project><div class=sub-title translate="Select Project"></div><div class=d-flex><selectbox-input class="mt-4 flex-1" ng-model=vm.audit.projectId placeholder="Select Project" options=vm.selProjects label-field=projectName value-field=_id select-event=vm.selectProject(vm.audit.projectId)></selectbox-input><div class="filter-button ml-10 mt-4" ng-click=vm.onShowFilter()><img src=/assets/icons/project-filter.svg alt=icons></div></div><div class=filter-menu ng-show=vm.bShowFilter><div class=filter-menu-title translate="Filter Status"></div><selectbox-input class="mt-4 flex-1" ng-model=vm.projectType placeholder="Select Project Type" options=vm.projectTypeOptioins label-field=label value-field=value select-event=vm.selectProjectType(vm.projectType)></selectbox-input><div class=filter-project-list><div class=filter-menu-item ng-click=vm.checkProject(project._id) ng-repeat="project in vm.filterProjectList track by $index"><div class="d-flex align-items-center"><input type=checkbox ng-checked="vm.tempProjectFilter.indexOf(project._id) > -1"><div class="filter-menu-item-text ml-10">{{project.projectName}}</div></div><!-- <div class="filter-menu-item-count float-right">{{vm.allProjects.length}}</div> --></div></div><!-- <div class="filter-menu-item" ng-click="vm.selectProjectType(\'all\')">\n                <div class="d-flex align-items-center">\n                  <input type="checkbox" ng-checked="vm.tempFilter.length == 3" ng-model="vm.typeAll" />\n                  <div class="filter-menu-item-text ml-10" translate="All Projects"></div>\n                </div>\n                <div class="filter-menu-item-count float-right">{{vm.allProjects.length}}</div>\n              </div>\n              <div class="filter-menu-item" ng-click="vm.selectProjectType(\'ongoing\')">\n                <div class="d-flex align-items-center">\n                  <input type="checkbox" ng-checked="vm.tempFilter.indexOf(\'ongoing\') > -1" />\n                  <div class="filter-menu-item-text ml-10" translate="Ongoing Projects"></div>\n                </div>\n                <div class="filter-menu-item-count float-right">{{vm.ongoingProjects.length}}</div>\n              </div>\n              <div class="filter-menu-item" ng-click="vm.selectProjectType(\'completed\')">\n                <div class="d-flex align-items-center">\n                  <input type="checkbox" ng-checked="vm.tempFilter.indexOf(\'completed\') > -1" />\n                  <div class="filter-menu-item-text ml-10" translate="Completed Projects"></div>\n                </div>\n                <div class="filter-menu-item-count float-right">{{vm.completedProjects.length}}</div>\n              </div>\n              <div class="filter-menu-item" ng-click="vm.selectProjectType(\'service\')">\n                <div class="d-flex align-items-center">\n                  <input type="checkbox" ng-checked="vm.tempFilter.indexOf(\'service\') > -1" />\n                  <div class="filter-menu-item-text ml-10" translate="Service Projects"></div>\n                </div>\n                <div class="filter-menu-item-count float-right">{{vm.serviceProjects.length}}</div>\n              </div> --><div class="d-flex justify-content-between align-items-center mt-4"><div class=d-flex><div class=filter-select-all translate="Select All" ng-click=vm.filterSelectAll()></div><div class="filter-select-all ml-10" translate="Clear All" ng-click=vm.filterClearAll()></div></div><div class="d-flex justify-content-end"><div class="action-button ml-16" translate=OK ng-click=vm.onFilterOk()></div><div class="action-button gray ml-16" translate=Cancel ng-click=vm.onFilterCancel()></div></div></div></div></div><div class=project-manager><div class=sub-title translate="Project Manager"></div><div class="login_input mt-4">{{vm.audit.manager.displayName}}</div></div><div class=filter-item><div class=sub-title translate="Start Date"></div><div class="input-group datePicker mt-4"><input type=text class=login_input date-picker=yyyy-MM-dd date=vm.audit.startDate is-open=isStartDatepickerOpen ng-required=true><div class=dateArrow ng-click="isStartDatepickerOpen = !isStartDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></div></div></div><div class=filter-item><div class=sub-title translate="End Date"></div><div class="input-group datePicker mt-4"><input type=text class=login_input date-picker=yyyy-MM-dd date=vm.audit.endDate is-open=isEndDatepickerOpen ng-required=true><div class=dateArrow ng-click="isEndDatepickerOpen = !isEndDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></div></div></div><div class=filter-item><div class=sub-title translate=Status></div><div class="login_input mt-4 flex-between"><input class=no-border type=number ng-model=vm.audit.duration> <span>Days</span></div></div></div></div><div class=content-wrapper2 ng-if=vm.isAllProject><dashboard-audit-cashflow-block class=mt-30 ng-model=vm.cashGraphData total-values=vm.totalValues currency=vm.companyCurrency.symbol start-date=vm.audit.startDate end-date=vm.audit.endDate></dashboard-audit-cashflow-block><dashboard-economic-cashflow class=mt-30 ng-model=vm.cashflowData currency=vm.companyCurrency.symbol></dashboard-economic-cashflow><dashboard-audit-project-block class=mt-30 ng-model=vm.projectData currency=vm.companyCurrency.symbol></dashboard-audit-project-block><dashboard-audit-chart-block class=mt-30 ng-model=vm.chartData currency=vm.companyCurrency.symbol></dashboard-audit-chart-block><dashboard-audit-bill-block class=mt-30 bills=vm.bills currency=vm.companyCurrency.symbol company-bills=vm.companyBills credit-bills=vm.creditMemoBills></dashboard-audit-bill-block><dashboard-audit-financial-block class=mt-30></dashboard-audit-financial-block></div><div class=content-wrapper2 ng-if=!vm.isAllProject><dashboard-audit-cost-block class=mt-30 ng-model=vm.costData currency=vm.companyCurrency.symbol></dashboard-audit-cost-block><dashboard-economic-cashflow class=mt-30 ng-model=vm.cashflowData currency=vm.companyCurrency.symbol></dashboard-economic-cashflow><dashboard-audit-regulation class=mt-30 ng-model=vm.cashflowData currency=vm.companyCurrency.symbol></dashboard-audit-regulation><dashboard-audit-bill-block class=mt-30 bills=vm.bills currency=vm.companyCurrency.symbol company-bills=vm.companyBills credit-bills=vm.creditMemoBills></dashboard-audit-bill-block></div></div><spinner ng-if=isLoading></spinner></div></main>');
$templateCache.put('app/main/dashboard/bidManage/bidManage.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=bidManage class="main-container dashboard"><div class=content-dashboard-wrapper><dashboard-side-menu></dashboard-side-menu><div class=content-wrapper1><dashboard-header></dashboard-header></div><div class="content-wrapper2 mt-16"><div class=left-content><dashboard-project-summary></dashboard-project-summary><dashboard-collaboration-offer class=mt-24></dashboard-collaboration-offer></div><div class=right-content><dashboard-today-task-block></dashboard-today-task-block><dashboard-bid-tender-block class=mt-24></dashboard-bid-tender-block></div></div></div></div></main>');
$templateCache.put('app/main/dashboard/ceo/ceo.view.html','<main-title-bar></main-title-bar><main-nav-bar type=ceo></main-nav-bar><main id=ceo><div class=ceo-top-bar><div class=ceo-top-bar-title>CLOUDES DATA VISUALISATION</div><div class=ceo-top-bar-search><input type=text placeholder=Search...> <img src=/assets/icons/search-gray.svg></div><div class=ceo-top-bar-menu><div class=ceo-menu ng-class="{active: (currentMenu == \'finance\' || currentMenu == \'report\')}" ng-click="setCurrentMenu(\'finance\')">Finance Proformance</div><div class=ceo-menu ng-class="{active: currentMenu == \'comment\'}" ng-click="setCurrentMenu(\'comment\')">CEO Comment\'s</div><div class=ceo-menu ng-class="{active: currentMenu == \'insight\'}" ng-click="setCurrentMenu(\'insight\')">Insight</div><div class=ceo-menu ng-class="{active: currentMenu == \'statement\'}" ng-click="setCurrentMenu(\'statement\')">Statement</div><div class=ceo-menu ng-class="{active: currentMenu == \'project\'}" ng-click="setCurrentMenu(\'project\')">Projects</div></div><div class=ceo-top-option><img src=/assets/images/ceo/option.svg></div></div><div class=ceo-main ng-if="currentMenu == \'finance\' || currentMenu == \'report\'"><div class=earth_img><img src=/assets/images/ceo/earth.svg><div class=position style="top: 83px; right: 394px"><div class=cell-content ng-click="showReport(\'0\')"><img src=/assets/images/ceo/cell-img1.svg><div class=cell-subcontent><div class=cell-subscontent-title>Toronto</div><div class=cell-subscontent-amount>53,430,001</div></div></div><img src=/assets/images/ceo/downarrow.svg style="margin-top: -1px"> <img class=cell src=/assets/images/ceo/cell.svg></div><div class=position style="top: 258px; right: 580px"><div class=cell-content ng-click="showReport(\'1\')"><img src=/assets/images/ceo/cell-img2.svg><div class=cell-subcontent><div class=cell-subscontent-title>Memphis</div><div class=cell-subscontent-amount>12,320,300</div></div></div><img src=/assets/images/ceo/downarrow.svg style="margin-top: -1px"> <img class=cell src=/assets/images/ceo/cell.svg></div><div class=position style="top: 681px; right: 366px"><div class=cell-content ng-click="showReport(\'2\')"><img src=/assets/images/ceo/cell-img3.svg><div class=cell-subcontent><div class=cell-subscontent-title>Manaus</div><div class=cell-subscontent-amount>23,180,290</div></div></div><img src=/assets/images/ceo/downarrow.svg style="margin-top: -1px"> <img class=cell src=/assets/images/ceo/cell.svg></div><div class=position style="top: 856px; right: 242px"><div class=cell-content ng-click="showReport(\'3\')"><img src=/assets/images/ceo/cell-img4.svg><div class=cell-subcontent><div class=cell-subscontent-title>S\xE3o Paulo</div><div class=cell-subscontent-amount>41,790,031</div></div></div><img src=/assets/images/ceo/downarrow.svg style="margin-top: -1px"> <img class=cell src=/assets/images/ceo/cell.svg></div></div><div class=finance-main ng-if="currentMenu == \'finance\'"><div class=title>Finance <b>Performance</b></div><div class=finance><div class=finance-boxes><div class=finance-box style="border-radius: 10px 10px 0px 0px; border-bottom: 1px solid #E8E8E8;"><div class=finance-box-title>Order Received</div><div class=finance-box-amount><span class=finance-box-price>$12,875</span> <img src=/assets/images/ceo/up.svg> <span class=finance-box-percent>10%</span></div><div class=finance-box-comment>Compared to $21,490 last year</div></div><div class=finance-box style="border-radius: 0px 0px 10px 10px;"><div class=finance-box-title>Order Backlog</div><div class=finance-box-amount><span class=finance-box-price>$43,123</span> <img src=/assets/images/ceo/up.svg> <span class=finance-box-percent>12%</span></div><div class=finance-box-comment>Compared to $21,490 last year</div></div></div><div class=finance-boxes style="margin-left: 64px"><div class=finance-box style="margin-bottom: 44px"><div class=finance-box-title>Net Sales</div><div class=finance-box-amount><span class=finance-box-price>$12,875</span> <img src=/assets/images/ceo/up.svg> <span class=finance-box-percent>10%</span></div><div class=finance-box-comment>Compared to $(21,490) last year</div></div><div class=finance-box><div class=finance-box-title>EBIT</div><div class=finance-box-amount><span class=finance-box-price>$12,875</span> <img src=/assets/images/ceo/up.svg> <span class=finance-box-percent>10%</span></div><div class=finance-box-comment>Compared to $(21,490) last year</div></div></div></div><div class=finance-chart><div class=chart-title>Order Received & Backlog</div><div class=chart-subtitle><div class=chart-subtitle-item>Order Recived</div><div class=chart-subtitle-item>Backlog</div></div><img src=/assets/images/ceo/chart.svg><div class=chart-items><div class=chart-details><div class=chart-image><img src=/assets/images/ceo/chart3.svg></div><div class=chart-item><span class=chart-item-text>Order Received</span><div class=chart-item-details><span class=chart-item-amount>438M</span></div></div><img src=/assets/images/ceo/chart2.svg></div><div class=chart-details><div class=chart-image><img src=/assets/images/ceo/chart4.svg></div><div class=chart-item><span class=chart-item-text>Customers</span><div class=chart-item-details><div class=chart-item-amount>2,340</div><img src=/assets/images/ceo/up.svg> <span class=chart-item-diff>10</span></div></div></div><div class=chart-details><div class=chart-image><img src=/assets/images/ceo/chart5.svg></div><div class=chart-item><span class=chart-item-text>Backlog</span><div class=chart-item-details><span class=chart-item-amount>438M</span></div></div><img src=/assets/images/ceo/chart1.svg></div></div></div></div><div class=report-main ng-if="currentMenu == \'report\'"><div class=title>Interim <b>Report</b> <span>For the fourth Quarter and full-year 2021</span></div><div class=report><div class=report-items><div class=report-item><div class=report-title>Fourth quarter</div><div class=report-list>\u2022 Orders received amounted to SEK 17,750 M (16,223)</div><div class=report-list>\u2022 Net sales totaled SEK 17,832 M (16,273).</div><div class=report-list>\u2022 The result after financial items totaled SEK 229 M (-65).</div><div class=report-list>\u2022 The result after tax amounted to SEK 160 M (-4)</div><div class=report-list>\u2022 Earnings per share after dilution were SEK 1.47 (-0.04)</div></div><div class=report-item><div class=report-title>Full-year 2018</div><div class=report-list>\u2022 Orders received amounted to SEK 61,842 M (56,777).</div><div class=report-list>\u2022 Net sales totaled SEK 57,346 M (54,441).</div><div class=report-list>\u2022 The result after financial items totaled SEK -849 M (983).</div><div class=report-list>\u2022 The result after tax amounted to SEK -750 M (877)</div><div class=report-list>\u2022 Earnings per share after dilution were SEK -7.00(8.07)</div><div class=report-list>\u2022 The Board proposes a dividend of SEK 4.00 (8.00) per share for 2018, divided into two payments (read more on page 11).</div></div></div><div class=report-table><table><tr style="border-bottom: 2px solid #747474;"><td class=report-td-header1>CloudES (subscriber)</td><td class=report-td-header2>2018<br>Oct-Dec.</td><td class=report-td-header2>2017<br>Oct-Dec.</td><td class=report-td-header2>2018<br>Jan-Dec.</td><td class=report-td-header2>2017<br>Jan-Dec.</td></tr><tr class=report-first-tr><td class=report-td-item1>Orders received</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td></tr><tr><td class=report-td-item1>Order backlog</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td></tr><tr><td class=report-td-item1>Net Sales</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td></tr><tr><td class=report-td-item1>Operating Profit/loss</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td></tr><tr><td class=report-td-item1>Profit/loss after financial</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td></tr><tr><td class=report-td-item1>Net profit/loss for period</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td></tr><tr><td class=report-td-item1>Profit/loss per share after dilutions, USD</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td></tr><tr><td class=report-td-item1>Cashflow before financing</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td></tr><tr><td class=report-td-item1>Net cash+/- net indebtdness -</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td><td class=report-td-item2>17,578</td></tr></table></div></div></div></div><div class=ceo-main ng-if="currentMenu == \'comment\'"><div class=comment><div class=comment-left><div class=comment-profile><img src=/assets/images/ceo/comment-profile.png><div class=comment-name><b>Marc</b>&nbsp; <span>Rosenberg</span></div><div class=comment-subtitle>CEO, CloudES</div><img src=/assets/images/ceo/comment-signature.png></div><div class=comment-profile-content><div class=comment-profile-title>Performance <b>Comments</b></div><div class=comment-profile-subtitle>Strong year & Marked position</div><div class=comment-profile-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim ipsum, amet, scelerisque est turpis malesuada ut. Nisi, faucibus quam pellentesque pulvinar facilisis augue felis eu. Ullamcorper morbi pharetra, diam scelerisque augue porttitor morbi. Pharetra, arcu eleifend egestas pharetra ac vitae. Auctor rhoncus aenean eu, congue. Et sed eleifend proin donec vel nibh pulvinar risus vitae. Quis in at non ut arcu a, et. Ut sed neque, platea ornare scelerisque morbi. Nisl, at eu facilisis facilisis sit tellus auctor cursus. Porttitor vel sit gravida ultrices in tellus integer. Ultrices aliquam leo, etiam venenatis tincidunt elementum. Elementum in enim tristique nulla commodo at quisque velit. Orci senectus eget id scelerisque in volutpat sit amet in. Mattis pellentesque ultricies morbi felis nunc, id. Eget nec tellus nunc quis feugiat metus. Malesuada bibendum feugiat nibh platea nec, vivamus gravida. Viverra id donec laoreet et eget euismod. Pulvinar dignissim in maecenas augue luctus egestas et. Consectetur amet, viverra scelerisque nulla pretium. Amet porttitor donec ullamcorper nibh sit egestas. Vel eleifend etiam venenatis neque, nibh. Sit sed commodo sed sit non sem imperdiet. Pretium non leo iaculis adipiscing fermentum id eget malesuada iaculis. Volutpat donec quis nunc sagittis leo proin cras. Euismod fermentum facilisi condimentum gravida sapien, amet, nibh ornare vulputate. Volutpat, mauris in eget gravida et.</div></div></div><div class=comment-right><div class=comment-chart><div class=comment-chart-title>Order Backlog</div><img src=/assets/images/ceo/chart6.svg></div><div class=comment-chart><div class=comment-chart-title>Net Sales</div><img src=/assets/images/ceo/chart7.svg></div></div></div><div class=backlog><div class=backlog-top><div class=backlog-top-title>Backlog & <b>Forecast</b></div><div class=backlog-top-buttons><button class="btn_primary blue"><span translate=Monthly></span></button> <button class="btn_primary blue"><span translate=Yearly></span></button> <button class="btn_primary blue"><span translate="5 Years"></span></button></div></div><img src=/assets/images/ceo/chart8.svg><div class=forcast-title>Forecast <b>Overview</b></div><div class=forcast-items><div class=forcast-item><div class=forcast-item-graph><img src=/assets/images/ceo/circle-percent1.svg></div><div class=forcast-item-details><div class=forcast-item-details-1>Net Sales</div><div class=forcast-item-details-2><div class=forcast-item-amount>$12,875</div><img src=/assets/images/ceo/up.svg> <span class=forcast-item-diff>10%</span></div><div class=forcast-item-details-3>Compared to $21,504 last year</div></div></div><div class=forcast-item><div class=forcast-item-graph><img src=/assets/images/ceo/circle-percent2.svg></div><div class=forcast-item-details><div class=forcast-item-details-1>Backlog</div><div class=forcast-item-details-2><div class=forcast-item-amount>$12,875</div><img src=/assets/images/ceo/up.svg> <span class=forcast-item-diff>10%</span></div><div class=forcast-item-details-3>Compared to $21,504 last year</div></div></div><div class=forcast-item><div class=forcast-item-graph><img src=/assets/images/ceo/circle-percent1.svg></div><div class=forcast-item-details><div class=forcast-item-details-3>Orders Received</div><div class=forcast-item-details-2><div class=forcast-item-amount>$12,875</div><img src=/assets/images/ceo/up.svg> <span class=forcast-item-diff>10%</span></div><div class=forcast-item-details-3>Compared to $21,504 last year</div></div></div><div class=forcast-item><div class=forcast-item-graph><img src=/assets/images/ceo/circle-percent4.svg></div><div class=forcast-item-details><div class=forcast-item-details-1>Sales Offers</div><div class=forcast-item-details-2><div class=forcast-item-amount>$12,875</div><img src=/assets/images/ceo/up.svg> <span class=forcast-item-diff>10%</span></div><div class=forcast-item-details-3>Compared to $21,504 last year</div></div></div></div></div></div><div class=ceo-main ng-if="currentMenu == \'insight\'"><div class=insight><div class=insight-item><div class=insight-content><div class=insight-title>Performance <b>Insights</b></div><div class=insight-text><b>Operating Margin</b> sit amet, consectetur adipiscing elit. Amet ullamcorper accumsan, eleifend hac eget montes, venenatis mi nunc. Eu, vel enim, amet amet ultricies. Morbi a at proin proin nec eget. Posuere sollicitudin quis enim eu pulvinar laoreet lectus. Sit rhoncus, nibh arcu vel duis mauris ultrices morbi et. Vitae tortor id consectetur leo. In sit suscipit fermentum at facilisis tortor neque aliquam. Risus lobortis ut erat vulputate sit vitae urna mauris.<br><br><b>Return on Equity</b> tristique pretium, platea risus nec, vitae quisque. Integer laoreet mattis gravida tristique. Nibh tristique arcu elementum arcu pretium gravida blandit malesuada. Semper quisque est, augue risus. Quis est orci nam euismod egestas tempor sed aliquet. Vestibulum imperdiet interdum quam libero. Leo dignissim orci, dui rhoncus consectetur pellentesque. Vitae, gravida nisl eget pellentesque sem sit sagittis. Risus et blandit tempor commodo sociis. Rhoncus at semper egestas nec enim. Placerat nec nulla imperdiet fermentum tempor sagittis nec sapien elit. Pretium, laoreet amet dictum non arcu in semper leo.<br><br><b>Net Debt/EBITDA</b> egestas vestibulum. Pretium nunc nibh integer ipsum. Quis eu a turpis amet, nisl amet, justo arcu. Hac ornare gravida diam, arcu facilisis velit arcu nunc. Sed pretium urna, non platea placerat dignissim turpis eget id. Morbi eu nunc sed molestie pretium tristique gravida. Eros enim congue cursus dui donec aenean libero. Malesuada faucibus nulla malesuada sem viverra. Sit et est, imperdiet ornare augue in eleifend rutrum condimentum. Ultrices ut in turpis tristique netus. Ante turpis tortor dui purus nisi. Nunc velit ullamcorper vitae viverra nulla. Eget purus id viverra placerat nunc, nunc. Nulla enim id aliquam volutpat tristique et in. Id nulla nunc, suspendisse varius.<br><br><b>Accident Frequency</b> sit turpis convallis nibh. Nunc eget iaculis enim augue sagittis nunc eget. Purus vitae sed netus sodales ornare nibh. Eleifend quis id consectetur mus sapien, suscipit purus, sed sed. Aliquet rhoncus arcu id duis sit sociis.</div></div></div><div class=insight-item><div class=insight-chart><div class=insight-chart-title>Operating Margin</div><img src=/assets/images/ceo/chart10.svg></div><div class=insight-chart><div class=insight-chart-title>Net Debt/EBITDA</div><img src=/assets/images/ceo/chart10.svg></div></div><div class=insight-item><div class=insight-chart><div class=insight-chart-title>Operating Margin</div><img src=/assets/images/ceo/chart10.svg></div><div class=insight-chart><div class=insight-chart-title>Net Debt/EBITDA</div><img src=/assets/images/ceo/chart10.svg></div></div></div></div><div class=ceo-main ng-if="currentMenu == \'statement\'"><div class=statement><div class=statement-item><div class=statement-item-title>Condensed Consolidated <b>Balance Sheet</b></div><table><tr><td class=statement-td-header1>SEK M</td><td class=statement-td-header2>Note 1</td><td class=statement-td-header2>2018<br>Dec. 31</td><td class=statement-td-header2>2017<br>Dec. 31</td></tr><tr><td class=statement-td-item1>ASSETS</td><td class=statement-td-item1></td><td class=statement-td-item1></td><td class=statement-td-item1></td></tr><tr><td class=statement-td-item2>Fixed Assets</td><td class=statement-td-item2></td><td class=statement-td-item2></td><td class=statement-td-item2></td></tr><tr><td class=statement-td-item3>Goodwill</td><td class=statement-td-item3></td><td class=statement-td-item3>1,861</td><td class=statement-td-item3>1,848</td></tr><tr><td class=statement-td-item3>Other intangible assets</td><td class=statement-td-item3></td><td class=statement-td-item3>339</td><td class=statement-td-item3>335</td></tr><tr><td class=statement-td-item3>owner- properties</td><td class=statement-td-item3></td><td class=statement-td-item3>915</td><td class=statement-td-item3>880</td></tr><tr><td class=statement-td-item3>Machinery and equipment</td><td class=statement-td-item3></td><td class=statement-td-item3>3,052</td><td class=statement-td-item3>2,712</td></tr><tr><td class=statement-td-item3>Long-term holdings of securities</td><td class=statement-td-item3></td><td class=statement-td-item3>119</td><td class=statement-td-item3>129</td></tr><tr><td class=statement-td-item3>Long-term interest bearing receivables</td><td class=statement-td-item3></td><td class=statement-td-item3>195</td><td class=statement-td-item3>575</td></tr><tr><td class=statement-td-item3>Other long-term receivables</td><td class=statement-td-item3></td><td class=statement-td-item3>119</td><td class=statement-td-item3>26</td></tr><tr><td class=statement-td-item3>Deffered tax assets</td><td class=statement-td-item3></td><td class=statement-td-item3>531</td><td class=statement-td-item3>338</td></tr><tr><td class=statement-td-item3>Total Fixed Assets</td><td class=statement-td-item3></td><td class=statement-td-item3>7,1333</td><td class=statement-td-item3>6,843</td></tr><tr><td class=statement-td-item2>Current Assets</td><td class=statement-td-item2></td><td class=statement-td-item2></td><td class=statement-td-item2></td></tr><tr><td class=statement-td-item3>Properties held for future development</td><td class=statement-td-item3></td><td class=statement-td-item3>1,633</td><td class=statement-td-item3>1,696</td></tr><tr><td class=statement-td-item3>Ongoing property projects</td><td class=statement-td-item3></td><td class=statement-td-item3>2,292</td><td class=statement-td-item3>1,039</td></tr><tr><td class=statement-td-item3>Completed property projects</td><td class=statement-td-item3></td><td class=statement-td-item3>308</td><td class=statement-td-item3>870</td></tr><tr><td class=statement-td-item3>Participations in associated companies</td><td class=statement-td-item3></td><td class=statement-td-item3>226</td><td class=statement-td-item3></td></tr><tr><td class=statement-td-item3>Materials and inventories</td><td class=statement-td-item3></td><td class=statement-td-item3>902</td><td class=statement-td-item3>764</td></tr><tr><td class=statement-td-item3>Tax Receivables</td><td class=statement-td-item3></td><td class=statement-td-item3>9,629</td><td class=statement-td-item3>8,882</td></tr><tr><td class=statement-td-item3>Worked-up, non-invoiced revenues</td><td class=statement-td-item3></td><td class=statement-td-item3>1,276</td><td class=statement-td-item3>1,554</td></tr><tr><td class=statement-td-item3>Prepaid expenses and accured income</td><td class=statement-td-item3></td><td class=statement-td-item3>1,418</td><td class=statement-td-item3>1,170</td></tr><tr><td class=statement-td-item3>Current interest-bearing receivables</td><td class=statement-td-item3></td><td class=statement-td-item3>163</td><td class=statement-td-item3>167</td></tr><tr><td class=statement-td-item3>Other receivables</td><td class=statement-td-item3></td><td class=statement-td-item3>608</td><td class=statement-td-item3>687</td></tr><tr><td class=statement-td-item3>Short-term investments</td><td class=statement-td-item3></td><td class=statement-td-item3>72</td><td class=statement-td-item3>41</td></tr><tr><td class=statement-td-item3>Cash and cash equivalents</td><td class=statement-td-item3></td><td class=statement-td-item3>1,197</td><td class=statement-td-item3>3,063</td></tr><tr><td class=statement-td-item1>Total Fixed Assets</td><td class=statement-td-item1></td><td class=statement-td-item1>19,868</td><td class=statement-td-item1>20,174</td></tr><tr><td class=statement-td-item1>Total Assets</td><td class=statement-td-item1></td><td class=statement-td-item1>27,001</td><td class=statement-td-item1>27,018</td></tr></table></div><div class=statement-item><div class=statement-item-title>Condensed Consolidated <b>Balance Sheet</b></div><table><tr><td class=statement-td-header1>SEK M</td><td class=statement-td-header2>Note 1</td><td class=statement-td-header2>2018<br>Dec. 31</td><td class=statement-td-header2>2017<br>Dec. 31</td></tr><tr><td class=statement-td-item1>ASSETS</td><td class=statement-td-item1></td><td class=statement-td-item1></td><td class=statement-td-item1></td></tr><tr><td class=statement-td-item2>Fixed Assets</td><td class=statement-td-item2></td><td class=statement-td-item2></td><td class=statement-td-item2></td></tr><tr><td class=statement-td-item3>Goodwill</td><td class=statement-td-item3></td><td class=statement-td-item3>1,861</td><td class=statement-td-item3>1,848</td></tr><tr><td class=statement-td-item3>Other intangible assets</td><td class=statement-td-item3></td><td class=statement-td-item3>339</td><td class=statement-td-item3>335</td></tr><tr><td class=statement-td-item3>owner- properties</td><td class=statement-td-item3></td><td class=statement-td-item3>915</td><td class=statement-td-item3>880</td></tr><tr><td class=statement-td-item3>Machinery and equipment</td><td class=statement-td-item3></td><td class=statement-td-item3>3,052</td><td class=statement-td-item3>2,712</td></tr><tr><td class=statement-td-item3>Long-term holdings of securities</td><td class=statement-td-item3></td><td class=statement-td-item3>119</td><td class=statement-td-item3>129</td></tr><tr><td class=statement-td-item3>Long-term interest bearing receivables</td><td class=statement-td-item3></td><td class=statement-td-item3>195</td><td class=statement-td-item3>575</td></tr><tr><td class=statement-td-item3>Other long-term receivables</td><td class=statement-td-item3></td><td class=statement-td-item3>119</td><td class=statement-td-item3>26</td></tr><tr><td class=statement-td-item3>Deffered tax assets</td><td class=statement-td-item3></td><td class=statement-td-item3>531</td><td class=statement-td-item3>338</td></tr><tr><td class=statement-td-item3>Total Fixed Assets</td><td class=statement-td-item3></td><td class=statement-td-item3>7,1333</td><td class=statement-td-item3>6,843</td></tr><tr><td class=statement-td-item2>Current Assets</td><td class=statement-td-item2></td><td class=statement-td-item2></td><td class=statement-td-item2></td></tr><tr><td class=statement-td-item3>Properties held for future development</td><td class=statement-td-item3></td><td class=statement-td-item3>1,633</td><td class=statement-td-item3>1,696</td></tr><tr><td class=statement-td-item3>Ongoing property projects</td><td class=statement-td-item3></td><td class=statement-td-item3>2,292</td><td class=statement-td-item3>1,039</td></tr><tr><td class=statement-td-item3>Completed property projects</td><td class=statement-td-item3></td><td class=statement-td-item3>308</td><td class=statement-td-item3>870</td></tr><tr><td class=statement-td-item3>Participations in associated companies</td><td class=statement-td-item3></td><td class=statement-td-item3>226</td><td class=statement-td-item3></td></tr><tr><td class=statement-td-item3>Materials and inventories</td><td class=statement-td-item3></td><td class=statement-td-item3>902</td><td class=statement-td-item3>764</td></tr><tr><td class=statement-td-item3>Tax Receivables</td><td class=statement-td-item3></td><td class=statement-td-item3>9,629</td><td class=statement-td-item3>8,882</td></tr><tr><td class=statement-td-item3>Worked-up, non-invoiced revenues</td><td class=statement-td-item3></td><td class=statement-td-item3>1,276</td><td class=statement-td-item3>1,554</td></tr><tr><td class=statement-td-item3>Prepaid expenses and accured income</td><td class=statement-td-item3></td><td class=statement-td-item3>1,418</td><td class=statement-td-item3>1,170</td></tr><tr><td class=statement-td-item3>Current interest-bearing receivables</td><td class=statement-td-item3></td><td class=statement-td-item3>163</td><td class=statement-td-item3>167</td></tr><tr><td class=statement-td-item3>Other receivables</td><td class=statement-td-item3></td><td class=statement-td-item3>608</td><td class=statement-td-item3>687</td></tr><tr><td class=statement-td-item3>Short-term investments</td><td class=statement-td-item3></td><td class=statement-td-item3>72</td><td class=statement-td-item3>41</td></tr><tr><td class=statement-td-item3>Cash and cash equivalents</td><td class=statement-td-item3></td><td class=statement-td-item3>1,197</td><td class=statement-td-item3>3,063</td></tr><tr><td class=statement-td-item1>Total Fixed Assets</td><td class=statement-td-item1></td><td class=statement-td-item1>19,868</td><td class=statement-td-item1>20,174</td></tr><tr><td class=statement-td-item1>Total Assets</td><td class=statement-td-item1></td><td class=statement-td-item1>27,001</td><td class=statement-td-item1>27,018</td></tr></table></div></div></div><div class=ceo-main ng-if="currentMenu == \'project\'">project</div><div class=ceo-bottom-bar><div class=ceo-bottom-text>CLOUDES DATA VISUALISATION</div><div class=ceo-bottom-text>2022</div></div><!-- <div id="ceo" class="main-container">\n    <div class="content-wrap">\n      <div class="left-side">\n        <div class="page-title">Spaze Corporate Park</div>\n        <div class="description">\n          Welcome to Spaze Corporate Park, an address that leads you to a world\n          of its own. As the premier lifestyle and shopping destination, Spaze\n          Corporate Park offers plenty of scope for entertainment too. The\n          Corporate Park is essentially an independent tower that encompasses\n          G+12 floors. It features impressive and world-class amenities and\n          offers best in class facilities to businesses with ample provision for\n          fun and leisure.\n        </div>\n\n        <div class="items-wrap">\n          <div class="flex-between">\n            <div class="item-title mb-8">Total Issues</div>\n            <img class="cursor-point" src="/assets/icons/arrowbottom.svg" alt="arrow" ng-click="isShowIssue = !isShowIssue" />\n          </div>\n          <div class="total-value">{{issueData[0].count + issueData[1].count + issueData[2].count}}</div>\n          <div class="progress-area">\n            <div class="green" ng-style="getProgressStyle(\'issue\', 0)"></div>\n            <div class="red" ng-style="getProgressStyle(\'issue\', 1)"></div>\n            <div class="yellow" ng-style="getProgressStyle(\'issue\', 2)"></div>\n          </div>\n          <div class="item-content" ng-if="isShowIssue">\n            <div class="item-row">\n              <div class="flex align-items-center">\n                <div class="circle-mark green"></div>\n                <div class="item-row-label">Resolved</div>\n              </div>\n              <div class="item-row-value">{{issueData[0].count | readable}}</div>\n            </div>\n            <div class="item-row">\n              <div class="flex align-items-center">\n                <div class="circle-mark red"></div>\n                <div class="item-row-label">Un-resolved</div>\n              </div>\n              <div class="item-row-value">{{issueData[1].count | readable}}</div>\n            </div>\n            <div class="item-row">\n              <div class="flex align-items-center">\n                <div class="circle-mark yellow"></div>\n                <div class="item-row-label">In-Progress</div>\n              </div>\n              <div class="item-row-value">{{issueData[2].count | readable}}</div>\n            </div>\n          </div>\n        </div>\n        <div class="items-wrap">\n          <div class="flex-between">\n            <div class="item-title mb-8">Total VA Orders</div>\n            <img class="cursor-point" src="/assets/icons/arrowbottom.svg" alt="arrow" ng-click="isShowVAOrder = !isShowVAOrder" />\n          </div>\n          <div class="total-value">{{vaOrderData[0].count + vaOrderData[1].count}}</div>\n          <div class="progress-area">\n            <div class="green" ng-style="getProgressStyle(\'va-order\', 0)"></div>\n            <div class="red" ng-style="getProgressStyle(\'va-order\', 1)"></div>\n          </div>\n          <div class="item-content" ng-if="isShowVAOrder">\n            <div class="item-row">\n              <div class="flex align-items-center">\n                <div class="circle-mark blue"></div>\n                <div class="item-row-label">Total Orders</div>\n              </div>\n              <div class="item-row-value">{{vaOrderData[0].count + vaOrderData[1].count}}</div>\n            </div>\n            <div class="item-row">\n              <div class="flex align-items-center">\n                <div class="circle-mark green"></div>\n                <div class="ft-normal-14-24 grey2" translate="Approved"></div>\n              </div>\n              <div class="item-row-value">{{vaOrderData[0].count | readable}}</div>\n            </div>\n            <div class="item-row">\n              <div class="flex align-items-center">\n                <div class="circle-mark red"></div>\n                <div class="ft-normal-14-24 grey2" translate="Pending"></div>\n              </div>\n              <div class="item-row-value">{{vaOrderData[1].count | readable}}</div>\n            </div>\n          </div>\n        </div>\n        <div class="items-wrap">\n          <div class="flex-between">\n            <div class="item-title mb-8">Total Economics</div>\n            <img class="cursor-point" src="/assets/icons/arrowbottom.svg" alt="arrow" ng-click="isShowEconomic = !isShowEconomic" />\n          </div>\n          <div class="total-value">{{economicData[0].count / ((economicData[0].count + economicData[1].count) || 1) * 100 | readable: 1}}%</div>\n          <div class="progress-area">\n            <div class="green" ng-style="getProgressStyle(\'economic\', 0)"></div>\n            <div class="red" ng-style="getProgressStyle(\'economic\', 1)"></div>\n          </div>\n          <div class="item-content" ng-if="isShowEconomic">\n            <div class="item-row">\n              <div class="flex align-items-center">\n                <div class="circle-mark green"></div>\n                <div class="item-row-label">Paid</div>\n              </div>\n              <div class="item-row-value">{{vm.companyData.currentCurrency.symbol}} {{economicData[0].count | readable}}</div>\n            </div>\n            <div class="item-row">\n              <div class="flex align-items-center">\n                <div class="circle-mark red"></div>\n                <div class="item-row-label">Rest</div>\n              </div>\n              <div class="item-row-value">{{vm.companyData.currentCurrency.symbol}} {{economicData[1].count | readable}}</div>\n            </div>\n            <div class="item-row">\n              <div class="flex align-items-center">\n                <div class="circle-mark blue"></div>\n                <div class="item-row-label">Contract</div>\n              </div>\n              <div class="item-row-value">{{vm.companyData.currentCurrency.symbol}} {{economicData[0].count + economicData[1].count | readable}}</div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="right-side">\n        <div class="action-bar">\n          <div class="action-button" ng-class="{active: curPage==\'overview\'}" ng-click="selectPage(\'overview\')">OverView</div>\n          <div class="action-button ml-20" ng-class="{active: curPage==\'floor\'}" ng-click="selectPage(\'floor\')">Floor View</div>\n          <div class="action-button ml-20" ng-class="{active: curPage==\'surrounding\'}" ng-click="selectPage(\'surrounding\')">Surroundings</div>\n        </div>\n      </div>\n    </div>\n  </div> --></main>');
$templateCache.put('app/main/dashboard/ceoEconomics/ceoEconomics.view.html','<main-title-bar></main-title-bar><main-nav-bar type=ceo></main-nav-bar><main><div id=ceo-economics class=main-container><div class=content-wrap><div class=left-side><div class=statistics><div class=cost-item ng-repeat="cost in vm.costItems"><div class=flex-between><div class="ft-600-16-24 black-2 mb-8">{{cost.label}}</div><img src=/assets/icons/chevron-down-darkgray.svg class=cursor-point alt="" ng-click="cost.isDetail = !cost.isDetail"></div><div class=flex><div class=ft_28_regular_black>{{vm.companyData.currentCurrency.symbol}} {{cost.amount | readable: 2}}</div></div><div class="ft-normal-14-20 grey-4">Compared to last year</div><div class=details ng-if=cost.isDetail><div class=cost-row ng-repeat="item in cost.items"><div class=col-circle><div class=circle ng-style=bgColor($index)></div></div><div class=col-label>{{item.name}}</div><div class=col-price>{{vm.companyData.currentCurrency.symbol}} {{item.price | readable}}</div><div class=col-percentage>{{item.percentage | readable}}%</div></div></div></div></div></div><div class=right-side><div id=earth-view class=no-zoom></div></div></div></div></main>');
$templateCache.put('app/main/dashboard/ceoSpash/ceoSpash.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=ceoSpash class=main-container><div class=content-dashboard-wrapper><div class=categories><div class=category-item><div class=category-title>Net Sales</div><div class=category-price><span class=price>$33,380</span> <span class=percent><i class="d-block i-icon i-up bgc-green"></i> <span class=c-green>2.5%</span></span></div><div class=category-summary>Compared to $28,490 last year</div><div class=category-chart><img src=/assets/images/ceoSpash/chart1.svg></div></div><div class=category-item><div class=category-title>Gross Margin</div><div class=category-price><span class=price>38.7%</span> <span class=percent><i class="d-block i-icon i-up bgc-green"></i> <span class=c-green>2.5%</span></span></div><div class=category-summary>Compared to 36.7% last year</div><div class=category-chart><img src=/assets/images/ceoSpash/chart2.svg></div></div><div class=category-item><div class=category-title>EBITDA</div><div class=category-price><span class=price>40.2%</span> <span class=percent><i class="d-block i-icon i-up bgc-green"></i> <span class=c-green>2.5%</span></span></div><div class=category-summary>Compared to 37.7% last year</div><div class=category-chart><img src=/assets/images/ceoSpash/chart3.svg></div></div><div class=category-item><div class=category-title>Net Profit</div><div class=category-price><span class=price>$7,407</span> <span class=percent><i class="d-block i-icon i-up bgc-green"></i> <span class=c-green>2.5%</span></span></div><div class=category-summary>Compared to $6,568 last year</div><div class=category-chart><img src=/assets/images/ceoSpash/chart4.svg></div></div><div class=category-item><div class=category-title>Net Profit</div><div class=category-price><span class=price>$35,380</span> <span class=percent><i class="d-block i-icon i-down bgc-red"></i> <span class=c-red>8.5%</span></span></div><div class=category-summary>Compared to $45,000 last year</div><div class=category-chart><img src=/assets/images/ceoSpash/chart5.svg></div></div><div class=category-item><div class=category-title>FTE</div><div class=category-price><span class=price>$1,080</span> <span class=percent><i class="d-block i-icon i-down bgc-red"></i> <span class=c-red>2.5%</span></span></div><div class=category-summary>Compared to $28,490 last year</div><div class=category-chart><img src=/assets/images/ceoSpash/chart6.svg></div></div></div><div class=detail-container><div class=budget-container><div class=container-header><div class=title>Actual vs Budget Variance</div><selectbox-input class="date-filter input-select ml-auto no-margin-top" ng-model=filter1 options=filterList1 label-field=tagName value-field=_id></selectbox-input></div><div class=budget-detail><div class=detail-header>2021</div><div class=budget-table><div class=table-header><div class="expand-col br-btm-black"></div><div class="entity-col br-btm-black">Entity</div><div class="actual-col br-btm-black text-right">Actual</div><div class="budget-col br-btm-black text-right">Budget</div><div class="variance-col br-btm-black text-center">Variance</div></div><div class=table-body><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey">Net Sales</div><div class="actual-col br-btm-grey">9,895</div><div class="budget-col br-btm-grey">9,895</div><div class=variance-col><div class="variance-col1 br-btm-grey text-right">9,895</div><div class="variance-col2 br-btm-grey text-right">9,895</div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey text-bold">Gross Margin</div><div class="actual-col br-btm-grey text-bold">12,919</div><div class="budget-col br-btm-grey text-bold">12,919</div><div class=variance-col><div class="variance-col1 br-btm-grey text-right text-bold">12,919</div><div class="variance-col2 br-btm-grey text-right text-bold">12,919</div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey text-bold"></div><div class="actual-col br-btm-grey text-bold"></div><div class="budget-col br-btm-grey text-bold"></div><div class=variance-col><div class="variance-col1 br-btm-grey text-right text-bold"></div><div class="variance-col2 br-btm-grey text-right text-bold"></div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"><img src=/assets/icons/fm-arrow-right-black.svg></div><div class="entity-col br-btm-grey">Direct Costs</div><div class="actual-col br-btm-grey">2,340</div><div class="budget-col br-btm-grey">2,340</div><div class=variance-col><div class="variance-col1 br-btm-grey text-right">2,340</div><div class="variance-col2 br-btm-grey text-right">2,340</div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-black"></div><div class="entity-col br-btm-black">Operating Expenses</div><div class="actual-col br-btm-black">33,380</div><div class="budget-col br-btm-black">33,380</div><div class=variance-col><div class="variance-col1 br-btm-black text-right">33,380</div><div class="variance-col2 br-btm-black text-right">33,380</div><div class="variance-col3 br-btm-black"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey text-bold">Operating Income</div><div class="actual-col br-btm-grey text-bold">8,698</div><div class="budget-col br-btm-grey text-bold">8,698</div><div class=variance-col><div class="variance-col1 br-btm-grey text-right text-bold">8,698</div><div class="variance-col2 br-btm-grey text-right text-bold">8,698</div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey text-bold"></div><div class="actual-col br-btm-grey text-bold"></div><div class="budget-col br-btm-grey text-bold"></div><div class=variance-col><div class="variance-col1 br-btm-grey text-right text-bold"></div><div class="variance-col2 br-btm-grey text-right text-bold"></div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-black"></div><div class="entity-col br-btm-black">EBITDA</div><div class="actual-col br-btm-black">33,380</div><div class="budget-col br-btm-black">33,380</div><div class=variance-col><div class="variance-col1 br-btm-black text-right">33,380</div><div class="variance-col2 br-btm-black text-right">33,380</div><div class="variance-col3 br-btm-black"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey text-bold">Net Profit</div><div class="actual-col br-btm-grey text-bold">8,698</div><div class="budget-col br-btm-grey text-bold">8,698</div><div class=variance-col><div class="variance-col1 br-btm-grey text-right text-bold">8,698</div><div class="variance-col2 br-btm-grey text-right text-bold">8,698</div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey text-bold"></div><div class="actual-col br-btm-grey text-bold"></div><div class="budget-col br-btm-grey text-bold"></div><div class=variance-col><div class="variance-col1 br-btm-grey text-right text-bold"></div><div class="variance-col2 br-btm-grey text-right text-bold"></div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"><img src=/assets/icons/fm-arrow-right-black.svg></div><div class="entity-col br-btm-grey">Working Capital</div><div class="actual-col br-btm-grey">33,380</div><div class="budget-col br-btm-grey">33,380</div><div class=variance-col><div class="variance-col1 br-btm-grey text-right">33,380</div><div class="variance-col2 br-btm-grey text-right">33,380</div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey">DSO</div><div class="actual-col br-btm-grey">33,380</div><div class="budget-col br-btm-grey">33,380</div><div class=variance-col><div class="variance-col1 br-btm-grey text-right">33,380</div><div class="variance-col2 br-btm-grey text-right">33,380</div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey">DPO</div><div class="actual-col br-btm-grey">33,380</div><div class="budget-col br-btm-grey">33,380</div><div class=variance-col><div class="variance-col1 br-btm-grey text-right">33,380</div><div class="variance-col2 br-btm-grey text-right">33,380</div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey text-bold"></div><div class="actual-col br-btm-grey text-bold"></div><div class="budget-col br-btm-grey text-bold"></div><div class=variance-col><div class="variance-col1 br-btm-grey text-right text-bold"></div><div class="variance-col2 br-btm-grey text-right text-bold"></div><div class="variance-col3 br-btm-grey"></div></div></div><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey">FTE</div><div class="actual-col br-btm-grey">33,380</div><div class="budget-col br-btm-grey">33,380</div><div class=variance-col><div class="variance-col1 br-btm-grey text-right">33,380</div><div class="variance-col2 br-btm-grey text-right">33,380</div><div class="variance-col3 br-btm-grey"></div></div></div></div></div></div></div><div class=netSale-container><div class=container-header><div class=title>Net Sales</div></div><div class=netSale-table><div class=table-header><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey">Entity</div><div class="actual-col br-btm-grey text-right">Actual</div><div class="budget-col br-btm-grey text-right">Budget</div><div class="percent-col br-btm-grey text-right"><img src=/assets/images/ceoSpash/triangle.svg>%</div><div class="state-col br-btm-grey text-right"></div></div><div class=table-body><div class=table-row><div class="expand-col br-btm-grey"><img src=/assets/icons/fm-arrow-down-activated.svg></div><div class="entity-col br-btm-grey">South America</div><div class="actual-col br-btm-grey text-right">9,895</div><div class="budget-col br-btm-grey text-right">9,895</div><div class="percent-col br-btm-grey text-right">14.8%</div><div class="state-col br-btm-grey text-right"><img src=/assets/images/ceoSpash/arrow-up.svg></div></div><div class=table-row><div class="expand-col br-btm-grey"><img src=/assets/icons/fm-arrow-down-activated.svg></div><div class="entity-col br-btm-grey">Asia</div><div class="actual-col br-btm-grey text-right">18,555</div><div class="budget-col br-btm-grey text-right">18,555</div><div class="percent-col br-btm-grey text-right">14.4%</div><div class="state-col br-btm-grey text-right"><img src=/assets/images/ceoSpash/arrow-up.svg></div></div><div class=table-row><div class="expand-col br-btm-grey"><img src=/assets/icons/fm-arrow-down-activated.svg></div><div class="entity-col br-btm-grey">Europe</div><div class="actual-col br-btm-grey text-right">2,591</div><div class="budget-col br-btm-grey text-right">2,591</div><div class="percent-col br-btm-grey text-right">-7.5%</div><div class="state-col br-btm-grey text-right"><img src=/assets/images/ceoSpash/arrow-down.svg></div></div><div class=table-row><div class="expand-col br-btm-grey"><img src=/assets/icons/fm-arrow-down-activated.svg></div><div class="entity-col br-btm-grey">United States of America</div><div class="actual-col br-btm-grey text-right">2,340</div><div class="budget-col br-btm-grey text-right">2,340</div><div class="percent-col br-btm-grey text-right">-7.9%</div><div class="state-col br-btm-grey text-right"><img src=/assets/images/ceoSpash/arrow-down.svg></div></div><div class=table-row><div class="expand-col br-btm-grey"></div><div class="entity-col br-btm-grey text-semibold">Comma Communications Inc.</div><div class="actual-col br-btm-grey text-right">33,380</div><div class="budget-col br-btm-grey text-right">33,380</div><div class="percent-col br-btm-grey text-right">10.6%</div><div class="state-col br-btm-grey text-right"><img src=/assets/images/ceoSpash/arrow-up.svg></div></div></div></div><div class=container-sub-header><div class=title>Net Sales</div><div class="chart-label actual ml-auto"><span class=color></span> <span class=label>Actual</span></div><div class="chart-label budget"><span class=color></span> <span class=label>Budget</span></div><selectbox-input class="date-filter input-select no-margin-top" ng-model=filter2 options=filterList2 label-field=tagName value-field=_id></selectbox-input></div><div class=netSales-chart><img src=/assets/images/ceoSpash/netSale-chart.svg></div></div></div></div></div></main>');
$templateCache.put('app/main/dashboard/clientManage/clientManage.view.html','<main-title-bar></main-title-bar><main-nav-bar type=client></main-nav-bar><main><div id=clientManage class="main-container dashboard"><div class=content-dashboard-wrapper><dashboard-side-menu></dashboard-side-menu><div class=content-wrapper1><dashboard-header></dashboard-header></div><div class="content-wrapper2 mt-16"><div class=left-content><dashboard-project-summary></dashboard-project-summary><dashboard-project-timeline class=mt-24></dashboard-project-timeline></div><div class=right-content><dashboard-today-task-block></dashboard-today-task-block><dashboard-activity-block class=mt-24></dashboard-activity-block></div></div></div></div></main>');
$templateCache.put('app/main/dashboard/economicManage/economicManage.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=economicManage class="main-container dashboard"><div class=content-dashboard-wrapper><dashboard-side-menu></dashboard-side-menu><div class=content-wrapper1><dashboard-header></dashboard-header></div><div class=mt-16><spinner ng-if=isLoading></spinner><div class=filter-wrap><div class=filter-box><div class=filter-header translate="Project Filters"></div><div class=filter-body><div class="flex-between pos-relative"><div class=filter-item><div class=filter-label translate=Projects></div><div class="d-flex filter-button-container"><selectbox-input class=dropdown-primary ng-model=vm.filter.projectId options=vm.selProjects label-field=projectName value-field=_id select-event=vm.selectFilterProject(vm.filter.projectId)></selectbox-input><div class="filter-button ml-10" ng-click=vm.onShowFilter()><img src=/assets/icons/project-filter.svg alt=icons></div></div></div><div class=filter-menu ng-show=vm.bShowFilter><div class=filter-menu-title translate="Filter Status"></div><selectbox-input class="mt-4 flex-1" ng-model=vm.projectType placeholder="Select Project Type" options=vm.projectTypeOptioins label-field=label value-field=value select-event=vm.selectProjectType(vm.projectType)></selectbox-input><div class=filter-project-list><div class=filter-menu-item ng-click=vm.checkProject(project._id) ng-repeat="project in vm.filterProjectList track by $index"><div class="d-flex align-items-center"><input type=checkbox ng-checked="vm.tempProjectFilter.indexOf(project._id) > -1"><div class="filter-menu-item-text ml-10">{{project.projectName}}</div></div><!-- <div class="filter-menu-item-count float-right">{{vm.allProjects.length}}</div> --></div></div><!-- <div class="filter-menu-item" ng-click="vm.selectProjectType(\'all\')">\n                    <div class="d-flex align-items-center">\n                      <input type="checkbox" ng-checked="vm.tempFilter.length == 3" ng-model="vm.typeAll" />\n                      <div class="filter-menu-item-text ml-10" translate="All Projects"></div>\n                    </div>\n                    <div class="filter-menu-item-count float-right">{{vm.allProjects.length}}</div>\n                  </div>\n                  <div class="filter-menu-item" ng-click="vm.selectProjectType(\'ongoing\')">\n                    <div class="d-flex align-items-center">\n                      <input type="checkbox" ng-checked="vm.tempFilter.indexOf(\'ongoing\') > -1" />\n                      <div class="filter-menu-item-text ml-10" translate="Ongoing Projects"></div>\n                    </div>\n                    <div class="filter-menu-item-count float-right">{{vm.ongoingProjects.length}}</div>\n                  </div>\n                  <div class="filter-menu-item" ng-click="vm.selectProjectType(\'completed\')">\n                    <div class="d-flex align-items-center">\n                      <input type="checkbox" ng-checked="vm.tempFilter.indexOf(\'completed\') > -1" />\n                      <div class="filter-menu-item-text ml-10" translate="Completed Projects"></div>\n                    </div>\n                    <div class="filter-menu-item-count float-right">{{vm.completedProjects.length}}</div>\n                  </div>\n                  <div class="filter-menu-item" ng-click="vm.selectProjectType(\'service\')">\n                    <div class="d-flex align-items-center">\n                      <input type="checkbox" ng-checked="vm.tempFilter.indexOf(\'service\') > -1" />\n                      <div class="filter-menu-item-text ml-10" translate="Service Projects"></div>\n                    </div>\n                    <div class="filter-menu-item-count float-right">{{vm.serviceProjects.length}}</div>\n                  </div> --><div class="d-flex justify-content-between align-items-center mt-4"><div class=d-flex><div class=filter-select-all translate="Select All" ng-click=vm.filterSelectAll()></div><div class="filter-select-all ml-10" translate="Clear All" ng-click=vm.filterClearAll()></div></div><div class="d-flex justify-content-end"><div class="action-button ml-16" translate=OK ng-click=vm.onFilterOk()></div><div class="action-button gray ml-16" translate=Cancel ng-click=vm.onFilterCancel()></div></div></div></div><div class=filter-item><div class=filter-label translate="Client or Vendor1"></div><div class=input-group><selectbox-input class=dropdown-primary ng-model=vm.filter.clientId options=vm.clients placeholder="Select Client" label-field=clientName value-field=_id select-event=vm.selectFilterClient(vm.filter.clientId)></selectbox-input></div></div></div><div class="flex-between mt-16"><div class=filter-item><div class=filter-label translate="Start Period1"></div><div class="input-group datePicker-primary"><input type=text class=input-primary date-picker=dd.MM.yyyy date=vm.filter.startDate is-open=isStartDatepickerOpen ng-required=true change=vm.changeFilterDate()> <span class=dateArrow ng-click="isStartDatepickerOpen = !isStartDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=filter-item><div class=filter-label translate="End Period1"></div><div class="input-group datePicker-primary"><input type=text class=input-primary date-picker=dd.MM.yyyy date=vm.filter.endDate is-open=isEndDatepickerOpen ng-required=true change=vm.changeFilterDate()> <span class=dateArrow ng-click="isEndDatepickerOpen = !isEndDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div></div></div><div class=filter-box><div class=filter-header translate="Client Filters"></div><div class=filter-body><div class=flex-between><div class=filter-item><div class=filter-label translate="Working Hours"></div><div class=input-group><div class=input-primary>{{ vm.totalWorkingHours | readable: 2 }}</div></div></div><div class=filter-item><div class=filter-label translate="Accidents Frequency"></div><div class=input-group><div class=input-primary>0.1%</div></div></div></div><div class="flex-between mt-16"><div class=filter-item><div class=filter-label translate="Number of Accidents"></div><div class=input-group><div class="input-primary w-100">{{ vm.accidentCount }}</div></div></div><div class=filter-item><div class=filter-label translate="SubConstructor Hours"></div><div class=input-group><div class="input-primary w-100">{{ vm.subcontractorHours | readable: 2 }}</div></div></div></div></div></div><div class=filter-box><div class=filter-header translate="Issues & Reports"></div><div class=filter-body><div class=flex-between><div class=filter-item><div class=filter-label translate="Start Date"></div><div class="input-group datePicker-primary"><input type=text class=input-primary date-picker=dd.MM.yyyy date=startDate is-open=isDatepickerOpenStartDate ng-required=true> <span class=dateArrow ng-click="isDatepickerOpenStartDate = !isDatepickerOpenStartDate"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=filter-item><div class=filter-label translate="End Date"></div><div class="input-group datePicker-primary"><input type=text class=input-primary date-picker=dd.MM.yyyy date=endDate is-open=isDatepickerOpenEndDate ng-required=true> <span class=dateArrow ng-click="isDatepickerOpenEndDate = !isDatepickerOpenEndDate"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div><div class="flex-between mt-16"><div class=filter-item><div class=filter-label translate=Issues></div><div class=filter-value><img src=/assets/icons/circle-check-2.svg alt=icon>{{ vm.issuesCount.resolved }}&nbsp; <span translate=Approved1></span></div><div class=filter-value><img src=/assets/icons/warning-red.svg alt=icon>{{ vm.issuesCount.opened }}&nbsp; <span translate=Pending1></span></div></div><div class=filter-item><div class=filter-label translate=Reports></div><div class=filter-value><img src=/assets/icons/circle-check-2.svg alt=icon>{{ vm.reportsCount.resolved }}&nbsp; <span translate=Solved></span></div><div class=filter-value><img src=/assets/icons/warning-red.svg alt=icon>{{ vm.reportsCount.opened }}&nbsp; <span translate=Pending1></span></div></div></div></div></div></div><eco-main-graph class=mt-30 company-currency=companyCurrency graph-data=vm.graphData start-date=vm.filter.startDate end-date=vm.filter.endDate need-render=!isLoading></eco-main-graph><dashboard-economic-cashflow ng-model=vm.cashflowData currency=companyCurrency.symbol></dashboard-economic-cashflow><tab-container class="mt-30 mb-30" tabs=vm.tabs><tab-page tab-id=supplier><div class=block-header><searchbox class=eco-search input-class=eco-search-input search-text=supplierSearchText is-small=true></searchbox><div class=view-all ui-sref=suppliersGrid translate="View All"></div></div><div class=table-wrap><div class=header><div class=flex-25 translate="Project Name"></div><div class=flex-15 translate=Budget></div><div class=flex-15 translate=Supplier></div><div class=flex-15 translate=Approved></div><div class=flex-15 translate=Pending></div><div class=flex-15 translate=Paid></div></div><div class=tr-wrapper><div class=item-tr ng-repeat="item in vm.tableData.supplierItems | filter: supplierSearchText"><div class=flex-25>{{ item.projectName}}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ item.budget | readable: 2 }}</div><div class=flex-15>{{ item.name }}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ item.approved | readable: 2 }}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ item.pending | readable: 2 }}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ item.paid | readable: 2 }}</div></div></div><div class="item-tr sum"><div class=flex-25 translate=Sum></div><div class=flex-15>{{ companyCurrency.symbol }} {{ vm.tableData.supplierBudget | readable: 2 }}</div><div class=flex-15></div><div class=flex-15>{{ companyCurrency.symbol }} {{ vm.tableData.supplierApprovedTotal | readable: 2 }}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ vm.tableData.supplierPendingTotal | readable: 2 }}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ vm.tableData.supplierPaidTotal | readable: 2 }}</div></div></div></tab-page><tab-page tab-id=labor><div class=block-header><searchbox class=eco-search input-class=eco-search-input search-text=laborSearchText is-small=true></searchbox><div class=view-all ui-sref=payroll translate="View All"></div></div><div class=table-wrap><div class=header><div class=flex-25 translate="Project Name"></div><div class=flex-25 translate=Budget></div><div class=flex-25 translate=Group></div><div class=flex-25 translate=Expense></div></div><div class=tr-wrapper><div class=item-tr ng-repeat-start="labor in vm.tableData.laborItems | filter: laborSearchText" ng-if="labor._id==\'unknown\'" draggable drag-data=labor><div class=flex-25>{{ labor.projectName }}</div><div class=flex-25>{{ companyCurrency.symbol }} {{ labor.budget | readable: 2 }}</div><div class=flex-25>{{ labor.name }}</div><div class=flex-25>{{ companyCurrency.symbol }} {{ labor.expense | readable: 2 }}</div></div><div class=item-tr ng-repeat-end=labor ng-if="labor._id!=\'unknown\'" droppable drop-data=labor drop-event=vm.dropLabor><div class=flex-25>{{ labor.projectName }}</div><div class=flex-25>{{ companyCurrency.symbol }} {{ labor.budget | readable: 2 }}</div><div class=flex-25>{{ labor.name }}</div><div class=flex-25>{{ companyCurrency.symbol }} {{ labor.expense | readable: 2 }}</div></div></div><div class="item-tr sum"><div class=flex-25 translate=Sum></div><div class=flex-25>{{ companyCurrency.symbol }} {{ vm.tableData.laborBudget | readable: 2 }}</div><div class=flex-25></div><div class=flex-25>{{ companyCurrency.symbol }} {{ vm.tableData.payrollExpenseTotal | readable: 2 }}</div></div></div></tab-page><tab-page tab-id=subcontractor><div class=block-header><searchbox class=eco-search input-class=eco-search-input search-text=subcontractorSearchText is-small=true></searchbox><div class=view-all ui-sref=subContractorsGrid translate="View All"></div></div><div class=table-wrap><div class=header><div class=flex-25 translate="Project Name"></div><div class=flex-15 translate=Budget></div><div class=flex-15 translate=Group></div><div class=flex-15 translate=Approved></div><div class=flex-15 translate=Pending></div><div class=flex-15 translate=Paid></div></div><div class=tr-wrapper><div class=item-tr ng-repeat="item in vm.tableData.subcontractorItems | filter: subcontractorSearchText"><div class=flex-25>{{item.projectName}}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ item.budget | readable: 2 }}</div><div class=flex-15>{{ item.name }}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ item.approved | readable: 2 }}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ item.pending | readable: 2 }}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ item.paid | readable: 2 }}</div></div></div><div class="item-tr sum"><div class=flex-25 translate=Sum></div><div class=flex-15>{{ companyCurrency.symbol }} {{ vm.tableData.subcontractorBudget | readable: 2 }}</div><div class=flex-15></div><div class=flex-15>{{ companyCurrency.symbol }} {{ vm.tableData.subcontractorApprovedTotal | readable: 2 }}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ vm.tableData.subcontractorPendingTotal | readable: 2 }}</div><div class=flex-15>{{ companyCurrency.symbol }} {{ vm.tableData.subcontractorPaidTotal | readable: 2 }}</div></div></div></tab-page><tab-page tab-id=va-order><div class=block-header><searchbox class=eco-search input-class=eco-search-input search-text=vaorderSearchText is-small=true></searchbox><div class=view-all ui-sref=vaOrderList translate="View All"></div></div><div class=table-wrap><div class=header><div class=flex-19 translate="Client Name"></div><div class=flex-13 translate="Positive Claims"></div><div class=flex-13 translate="Negative Claims"></div><div class=flex-13 translate="Accepted Claims"></div><div class=flex-13 translate=Pending></div><div class=flex-13 translate="Total Sum Claims"></div><div class=flex-8 translate=Total></div></div><div class=tr-wrapper><div class=item-tr ng-repeat="order in vm.tableData.variationOrdersGroup | filter: vaorderSearchText"><div class=flex-19>{{ order.clientName }}</div><div class=flex-13>{{ companyCurrency.symbol }} {{ order.positive | readable: 2 }}</div><div class=flex-13>{{ companyCurrency.symbol }} {{ order.negative | readable: 2 }}</div><div class=flex-13>{{ companyCurrency.symbol }} {{ order.approved | readable: 2 }}</div><div class=flex-13>{{ companyCurrency.symbol }} {{ order.pending | readable: 2 }}</div><div class=flex-13>{{ companyCurrency.symbol }} {{ order.totalWithoutVat | readable: 2 }}</div><div class=flex-8>{{ companyCurrency.symbol }} {{ order.total | readable: 2 }}</div></div></div><div class="item-tr sum"><div class="flex-19 ft_14_600_black" translate="Total Sum"></div><div class=flex-13></div><div class=flex-13></div><div class=flex-13></div><div class=flex-13></div><div class=flex-13></div><div class="flex-8 ft_14_600_black">{{ companyCurrency.symbol }} {{ vm.tableData.variationOrderTotal | readable: 2 }}</div></div></div></tab-page><spinner ng-if=isProcessing></spinner></tab-container></div></div></div></main>');
$templateCache.put('app/main/dashboard/procurement/procurement.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=procurement class=main-container><div class=content-dashboard-wrapper><div class=top-container><div class=left-panel><div class=saving-details><div class=individual-savings><div class=individual-item><div class=item-title>Purchasing Volume</div><div class=item-price><span class=price>$12,875</span> <span class=percent><i class="d-block i-icon i-up bgc-green"></i> <span class=c-green>2.5%</span></span></div><div class=item-summary>Compared to $21,940 last year</div><img src=/assets/images/procurement/volume_chart.svg></div><div class=individual-item><div class=item-title>Avg. Buying Price</div><div class=item-price><span class=price>$12,875</span> <span class=percent><i class="d-block i-icon i-down bgc-red"></i> <span class=c-red>2.5%</span></span></div><div class=item-summary>Compared to 36.7% last year</div><canvas class="chart chart-line" chart-data=data1 chart-colors=colors1 chart-labels=labels chart-series=series1 chart-options=options1 chart-dataset-override=datasetOverride1></canvas></div></div><div class=total-savings><div class=total-header><div class=total-percent><svg><circle cx=36 cy=36 r=32></circle><circle cx=36 cy=36 r=32 ng-style=getProgressStyle(percent)></circle></svg><div class=number>{{(percent * 100) | readable: 0}}%</div></div><div class=total-header-info><div class=total-header-title>Total Savings</div><div class=total-header-price><span class=price>$8.9M</span> <span class=percent><i class="d-block i-icon i-up bgc-green"></i> <span class=c-green>7.9%</span></span></div><div class=total-header-summary>Compared to $21,504 last year</div></div></div><div class=total-detail><div class=nav-items><nav class="navbar navbar-expand-lg navbar-light"><ul class=navbar-nav><li class=nav-item ng-class="{active: sortType === type.id}" ng-click=sort(type.id) ng-repeat="type in sortTypes"><span translate={{type.label}}></span></li></ul></nav></div><div class=total-detail-info><div class=saving-detail><div class=saving-detail-title>top savings</div><div class="saving-item top" ng-repeat="item in topItems"><div class=item-name>{{item.name}}</div><div class=item-percent><span class=progress style="width: 80%;"></span></div><div class=item-amount>${{item.total_amount}}M</div></div></div><div class=divider></div><div class=saving-detail><div class=saving-detail-title>bottom savings</div><div class="saving-item bottom" ng-repeat="item in bottomItems"><div class=item-name>{{item.name}}</div><div class=item-percent><span class=progress style="width: 80%;"></span></div><div class=item-amount>${{item.total_amount}}M</div></div></div></div></div></div></div><div class=category-details><div class=category-details-header><div class=category-details-title>Top Purchasing Categories</div></div><div class=divider></div><div class=category-details-body><div class=category-detail-info ng-repeat="category in categories"><div class=category-detail-title>{{category.name}}</div><div class=category-detail-chart><canvas class="chart chart-line" chart-data=data2 chart-colors=colors2 chart-labels=labels chart-series=series2 chart-options=options2 chart-dataset-override=datasetOverride2></canvas></div><div class=category-detail-price><span class=progress-bar style="width: calc(80% - 100px);"></span> <span class=price>$ {{category.price}}M</span></div></div></div><div class=divider></div><div class=category-details-footer><div class=period>LAST 12 MONTHS</div><div class=category-detail-info-summary><div class=title>PURCHASING VOLUME</div><div class=summary>Current period (<em>line is reference period</em>)</div></div></div></div></div><div class=right-panel><div class=right-panel-header><div class=right-panel-title>Top Purchasing Categories</div><selectbox-input class="product-filter input-select ml-auto no-margin-top" ng-model=filtertypelistvalue1 options=filtertypelist1 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="date-filter input-select no-margin-top" ng-model=filtertypelistvalue2 options=filtertypelist2 label-field=tagName value-field=_id></selectbox-input></div><div class=divider></div><div class=category-chart><div class=supplier-count><div class=right-panel-title>Suppliers</div><div class=right-panel-price><span class=price>237</span> <span class=percent><i class="d-block i-icon i-up bgc-green"></i> <span class=c-green>2.5%</span></span></div><div class=right-panel-summary>Compared to 200 last year</div><canvas class="chart chart-line" chart-data=data2 chart-colors=colors2 chart-labels=labels chart-series=series2 chart-options=options2 chart-dataset-override=datasetOverride2></canvas></div><div class=vertical-divider></div><div class=supplier-price><div class=right-panel-title>Volume per Supplier</div><div class=right-panel-price><span class=price>$12,875</span> <span class=percent><i class="d-block i-icon i-down bgc-red"></i> <span class=c-red>2.5%</span></span></div><div class=right-panel-summary>Compared to $21,490 last year</div><canvas class="chart chart-line" chart-data=data3 chart-colors=colors3 chart-labels=labels chart-series=series2 chart-options=options2 chart-dataset-override=datasetOverride2></canvas></div></div><div class=vendor-list><div class=vendor-list-title>vendor</div><div class=divider></div><div class=vendor-details><div class=vendor-detail ng-repeat="vendor in vendors"><div class=vendor-detail-name>{{vendor.name}}</div><div class=vendor-detail-price><span class=progress-bar style="width: calc(80% - 160px);"></span> <span class=price>$ {{vendor.price}}M (21% of total)</span></div></div></div></div><div class=divider></div><div class=vendor-footer><div class=vendor-detail-info-summary><div class=title>PURCHASING VOLUME</div><div class=summary>Current period (<em>line is reference period</em>)</div></div></div></div></div><div class=analysis-container><div class=analysis-header><div class=analysis-header-title>Purchase Analysis</div><div class=analysis-filter><span>Sort by</span><selectbox-input class="product-filter input-select ml-auto no-margin-top" ng-model=filtertypelistvalue3 options=filtertypelist3 label-field=tagName value-field=_id></selectbox-input></div></div><div class=analysis-category-header><div class=title-col>category</div><div class=volume-col>purchasing volume</div><div class=average-col>average buying price</div><div class=saving-col>savings</div></div><div class=divider></div><div class=analysis-category-details><div class=analysis-category-detail ng-repeat="product in products"><div class=title-col>{{product.name}}</div><div class=volume-col><div class=volume-col-chart><canvas class="chart chart-line" chart-data=data2 chart-colors=colors2 chart-labels=labels chart-series=series2 chart-options=options2 chart-dataset-override=datasetOverride2></canvas></div><div class=volume-col-price><span class=progress-bar style="width: calc(80% - 80px);"></span> <span class=price>$ {{product.volume}}K</span></div></div><div class=average-col><div class=average-col-chart><canvas class="chart chart-line" chart-data=data3 chart-colors=colors3 chart-labels=labels chart-series=series2 chart-options=options3 chart-dataset-override=datasetOverride2></canvas></div><div class=average-col-price><span class=progress-bar style="width: calc(80% - 80px);"></span> <span class=price>$ {{product.avg_price}}</span></div><div class=average-col-percent><span class=progress-bar style="width: calc(80% - 80px);" ng-if="product.avg_percent >= 0"></span> <span class=progress-bar style="position: absolute; width: calc(80% - 80px); left: calc(80px - 80%);" ng-if="product.avg_percent < 0"></span> <span class=price ng-class="{\'c-green\': product.avg_percent > 0, \'c-red\': product.avg_percent < 0}"><i class="d-block i-icon i-up bgc-green" ng-if="product.avg_percent >= 0"></i> <i class="d-block i-icon i-down bgc-red" ng-if="product.avg_percent < 0"></i> <span class=c-green ng-if="product.avg_percent >= 0">+</span> {{product.avg_percent}} %</span></div></div><div class=saving-col><div class=saving-col-percent><span class="progress-bar bgc-green" style="width: calc(80% - 80px);" ng-if="product.avg_percent >= 0"></span> <span class="progress-bar bgc-red" style="position: absolute; width: calc(80% - 80px); left: calc(80px - 80%);" ng-if="product.avg_percent < 0"></span> <span class="price c-green" ng-if="product.avg_percent >= 0">$ {{product.avg_percent}}M </span><span class="price c-red" style="position: absolute; margin: 0; left: calc(-80% -8px); justify-content: end;" ng-if="product.avg_percent < 0">$ {{product.avg_percent}}M</span></div></div></div></div><div class=divider></div><div class=analysis-category-footer><div class=title-col></div><div class=volume-col><div class=period>LAST 12 MONTHS</div><div class=category-detail-info-summary><div class=title>PURCHASING VOLUME</div><div class=summary>Current period (<em>line is reference period</em>)</div></div></div><div class=average-col><div class=period>LAST 12 MONTHS</div><div class=category-detail-info-summary><div class=title>AVERAGE BUYING PRICE</div><div class=summary>Current period (<em>line is reference period</em>)</div></div></div><div class=saving-col><div class=category-detail-info-summary><div class=title>SAVINGS</div><div class=summary>vs last 12 months Average Buying Price</div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/dashboard/productionsBoard/productionsBoard.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=productionsBoard class="main-container dashboard"><div class=content-dashboard-wrapper><dashboard-side-menu></dashboard-side-menu><div class=content-wrapper1><dashboard-header></dashboard-header></div><div class="content-wrapper2 mt-16"><div class=left-content><dashboard-project-summary></dashboard-project-summary><!-- <dashboard-project-timeline class="mt-24"></dashboard-project-timeline> --><div id=timeline class="dashboard-project-timeline mt-24 p-0"><div class=block-header><div class=block-title translate="Project Timeline"></div><div class=action-button ng-click=gotoTimeline()><img src=/assets/icons/fullscreen.svg alt=icons></div></div><div project-timeline id=gantt></div></div></div><div class=right-content><dashboard-today-task-block></dashboard-today-task-block><dashboard-activity-block class=mt-24></dashboard-activity-block></div></div><dashboard-budget-block class="mt-24 mb-30"></dashboard-budget-block></div></div></main>');
$templateCache.put('app/main/dashboard/projectDesign/projectDesign.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=projectDesign class="main-container dashboard"><div class=content-dashboard-wrapper><dashboard-side-menu></dashboard-side-menu><div class=content-wrapper1><dashboard-header></dashboard-header></div><div class="content-wrapper2 mt-16"><div class=left-content><dashboard-project-summary></dashboard-project-summary></div><div class=right-content><dashboard-today-task-block></dashboard-today-task-block></div></div><div id=timeline class="dashboard-project-timeline mt-24 p-0"><div class=block-header><div class=block-title translate="Project Timeline"></div><div class=action-button ng-click=gotoTimeline()><img src=/assets/icons/fullscreen.svg alt=icons></div></div><div project-timeline id=gantt></div></div><dashboard-technical-queries-block class="mt-24 mb-30"></dashboard-technical-queries-block></div></div></main>');
$templateCache.put('app/main/dashboard/qsheManage/qsheManage.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=qsheManage class="main-container dashboard"><div class=content-dashboard-wrapper><dashboard-side-menu></dashboard-side-menu><div class=content-wrapper1><dashboard-header></dashboard-header></div><div class="content-wrapper2 mt-16"><div class=left-content><dashboard-project-summary></dashboard-project-summary><dashboard-qshe-manage class=mt-24></dashboard-qshe-manage></div><div class=right-content><dashboard-quality-block></dashboard-quality-block><dashboard-issue-block class=mt-24></dashboard-issue-block></div></div></div></div></main>');
$templateCache.put('app/main/dashboard/salesManage/salesManage.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=sales-manage class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Estimate & Sales"></a></div><div class=ft_24_600_black1 translate="Estimate & Sales"></div></div></div><div><div class="card-based-content-grid-wrapper pr-40 pt-54"><div class="pb-50 pl-40 text-align-center"><div class=ft_24_600_black1 translate="Choose an option"></div><div class=ft_14_regular_black2 translate="Select and option from below"></div></div><div class="quotes-wrapper flex flex-wrap"><div class=profile-card-container><div class=profile-card><div class=card-content><div class="flex header"><img src=/assets/images/dashboard/shutterstock_1854476623.png></div><div class=detail><div class=ft_18_600_black3 translate="Sales Offer"></div><div class=ft_14_regular_black2 style="opacity: 0.5;" translate="Create a Sales Offer"></div></div></div><div class=action><div class="btn_create ft_14_600_blue" ng-click=create(0)><span>+</span>&nbsp;<span translate=Create></span></div></div></div></div><div class=profile-card-container><div class=profile-card><div class=card-content><div class="flex header"><img src=/assets/images/dashboard/shutterstock_1470302927.png></div><div class=detail><div class=ft_18_600_black3 translate="Part Estimate"></div><div class=ft_14_regular_black2 style="opacity: 0.5;" translate="Create a Part Estimate"></div></div></div><div class=action><div class="btn_create ft_14_600_blue" ng-click=create(1)><span>+</span>&nbsp;<span translate=Create></span></div></div></div></div><div class=profile-card-container><div class=profile-card><div class=card-content><div class="flex header"><img src=/assets/images/dashboard/shutterstock_1125361022.png></div><div class=detail><div class=ft_18_600_black3 translate="Project Estimate"></div><div class=ft_14_regular_black2 style="opacity: 0.5;" translate="Create a Project Estimate"></div></div></div><div class=action><div class="btn_create ft_14_600_blue" ng-click=create(2)><span>+</span>&nbsp;<span translate=Create></span></div></div></div></div><div class=profile-card-container><div class=profile-card><div class=card-content><div class="flex header"><img src=/assets/images/dashboard/shutterstock_781201600.png></div><div class=detail><div class=ft_18_600_black3 translate="FM & Service"></div><div class=ft_14_regular_black2 style="opacity: 0.5;" translate="Create a FM & Service"></div></div></div><div class=action><div class="btn_create ft_14_600_blue" ng-click=create(3)><span>+</span>&nbsp;<span translate=Create></span></div></div></div></div></div></div></div><spinner ng-if=isLoading></spinner></div></main>');
$templateCache.put('app/main/dashboard/siteManage/siteManage.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=siteManage class="main-container dashboard"><div class=content-dashboard-wrapper><dashboard-side-menu></dashboard-side-menu><div class=content-wrapper1><dashboard-header></dashboard-header></div><div class="content-wrapper2 mt-16"><div class=left-content><dashboard-project-summary></dashboard-project-summary><dashboard-project-timeline class=mt-24></dashboard-project-timeline><dashboard-site-manage class=mt-24></dashboard-site-manage></div><div class=right-content><dashboard-today-task-block></dashboard-today-task-block><dashboard-activity-block class=mt-24></dashboard-activity-block><dashboard-todo-block class=mt-24></dashboard-todo-block></div></div></div></div></main>');
$templateCache.put('app/main/dashboard/subContractorManage/subContractorManage.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=subContractorManage class="main-container dashboard"><div class=content-dashboard-wrapper><dashboard-side-menu></dashboard-side-menu><div class=content-wrapper1><dashboard-header></dashboard-header></div><div class="content-wrapper2 mt-16"><div class=left-content><dashboard-project-summary></dashboard-project-summary><dashboard-project-timeline class=mt-24></dashboard-project-timeline></div><div class=right-content><dashboard-today-task-block></dashboard-today-task-block><dashboard-activity-block class=mt-24></dashboard-activity-block></div></div><div class=mt-24><dashboard-collaboration-offer></dashboard-collaboration-offer></div><div class=mt-24><dashboard-project-members></dashboard-project-members></div></div></div></main>');
$templateCache.put('app/main/dashboard/supplierManage/supplierManage.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=supplierManage class="main-container dashboard"><div class=content-dashboard-wrapper><dashboard-side-menu></dashboard-side-menu><div class=content-wrapper1><dashboard-header></dashboard-header></div><div class="content-wrapper2 mt-16"><div class=left-content><dashboard-project-summary></dashboard-project-summary><dashboard-collaboration-offer class=mt-32></dashboard-collaboration-offer></div><div class=right-content><dashboard-today-task-block></dashboard-today-task-block><dashboard-activity-block class=mt-24></dashboard-activity-block></div></div></div></div></main>');
$templateCache.put('app/main/dashboard/workOrder/workOrder.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=workOrder class=main-container><div class=content-dashboard-wrapper><div class=top-container><div class=order-state><div class=title>New Orders <img src=/assets/icons/more2.svg alt=""></div><div class=state>21</div><div class=summary>Total Work Orders: 70</div></div><div class=ongoing-state><div class=title>On-going <img src=/assets/icons/more2.svg alt=""></div><div class=state>21</div><div class=summary>Total Work Orders: 70</div></div><div class=overdue-state><div class=title>Overdue <img src=/assets/icons/more2.svg alt=""></div><div class=state>17</div><div class=summary>Total Work Orders: 70</div></div><div class=complete-state><div class=title>Completed <img src=/assets/icons/more2.svg alt=""></div><div class=state>24</div><div class=summary>Total Work Orders: 70</div></div><div class=accounting-state><div class=title>Accounting</div><div class=detail><div class=detail-value><div class=date>March 1, 2020 - April 31, 2021</div><div class=detail-avg-income>Average Monthly Income</div><div class=detail-avg-income-value>$ 5,849.36</div><div class=detail-avg-income-percent><img src=/assets/icons/income.svg> <span class=percent>3.89%</span> <span class=compare>vs</span> <span class=price>$5,432.74</span></div><div class=detail-avg-income-period>previous 90 days</div></div><div class=detail-chart><img src=/assets/images/workOrder/income_chart.svg></div></div><div class=divider></div><div class=total-value><div class=total-item><img src=/assets/images/workOrder/total_income.svg><div class=total-item-value><div class=price>$ 89,240.38</div><div class=info>Total Income</div></div></div><div class=total-item><img src=/assets/images/workOrder/total_expense.svg><div class=total-item-value><div class=price>$ 16,237.82</div><div class=info>Total Expenses</div></div></div></div></div><div class=bill-state><div class=title>Bills <img src=/assets/icons/more2.svg alt=""></div><div class=state>5</div><div class=summary>Total Work Orders: 70</div></div><div class=invoice-state><div class=title>Invoiced <img src=/assets/icons/more2.svg alt=""></div><div class=state>24</div><div class=summary>Total Work Orders: 70</div></div></div><div class=detail-container><div class=order-container><div class=container-header><div class=title>Work orders</div><div class=filter><div class=filter-type ng-class="{active: orderFilter === type.id}" ng-repeat="type in orderFilters" ng-click="sort(\'order\', type.id)"><span>{{type.label}}</span></div></div></div><div class=detail-list><div class=detail ng-repeat="order in orders"><div class=detail-header><div class=detail-id>#{{order.id}}</div><div class=detail-state ng-class="{\'high\': order.state === \'high\', \'medium\': order.state === \'medium\', \'low\': order.state === \'low\'}">{{order.state}}</div></div><div class=detail-title>{{order.title}}</div><div class=detail-footer><div class=period>02:00 hrs left of 02:00 hrs</div><div class=date><img src=/assets/icons/clock-sm.svg> <span class=due>Due on</span> <span class=value>Mon, Apr 23</span></div></div></div></div></div><div class=bill-container><div class=container-header><div class=title>Bills</div><div class=filter><div class=filter-type ng-class="{active: billFilter === type.id}" ng-repeat="type in billFilters" ng-click="sort(\'bill\', type.id)"><span>{{type.label}}</span></div></div></div><div class=detail-list><div class=detail ng-repeat="bill in bills"><div class=detail-header><div class=detail-id>{{bill.id}}</div><div class=detail-overdue ng-class="{\'overDue\': bill.overDue\'}"><div class=date ng-if=bill.overDue><img src=/assets/icons/clock-red.svg> <span>Overdue by {{bill.dueDate}} days</span></div><div class=date ng-if=!bill.overDue><img src=/assets/icons/clock-sm.svg> <span>Due on 08/27/2021</span></div></div></div><div class=detail-title><div class=title>{{bill.title}}</div><div class=price>$ {{bill.price}}</div></div><div class=detail-footer><div class=period>08/20/2021</div><div class=state><div class=view>View</div><div class=vertical-divider></div><div class=bill-state ng-class="{\'approve\': bill.state === \'approve\', \'paid\': bill.state === \'paid\'}">{{bill.state}}</div></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/economic/payroll/payroll.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=payroll class=main-container><div class="title-bar flex-row"><div><div class="sub-navigation margin-0"><a ui-sref=economicManage class="ft-normal-12-16 blue-2" translate=Economic></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Payroll></a></div><div class=ft_24_600_black1 translate=Payroll></div></div><div class="flex flex-row flex-items-center flex-between ml-120 flex-1"><div class="flex input-wrap flex-items-center"><div class="item mr-8"><div class="input-group datePicker-primary"><input type=text class="input-primary pl-2" date-picker=dd.MM.yyyy date=startDate placeholder="From Date" is-open=isDatepickerOpen ng-required=true change=onChangeFilterDate()> <span class=dateArrow ng-click="isDatepickerOpen = !isDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class="item mr-16"><div class="input-group datePicker-primary"><input type=text class="input-primary pl-2" date-picker=dd.MM.yyyy date=endDate placeholder="To Date" is-open=isDueDatepickerOpen ng-required=true change=onChangeFilterDate()> <span class=dateArrow ng-click="isDueDatepickerOpen = !isDueDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><label class=check_yellow_20><div class=ft_14_600_black translate="Automatic Approval after GPS tracking"></div><input type=checkbox checked><span class=checkmark></span></label></div><div class="flex flex-row flex-items-center"><img src=/assets/icons/bx-import.svg alt="" class="cursor-point mr-10" ng-click=vm.exportAsCSV()> <img src=/assets/icons/filter.svg alt="" class="cursor-point mr-20" ng-click=vm.openFilterModal()><searchbox input-class=mr-20 search-text=searchText search-event=searchFunction(searchText) is-small=true ng-blur="searchText=\'\'"></searchbox><button class="button-primary ml-16" ng-click=vm.addPayroll() ng-if="ECO_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Add New"></span></button></div></div></div><spinner ng-if=isLoading></spinner><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked> <span class=checkmark ng-click=setAllChecked()></span></label></th><th class="ft_14_600_black name-container"><div class=cursor-point ng-click="changeSortItem(\'name\')"><span translate=Name></span> <img ng-src="{{sortItem.sort === \'name\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                             sortItem.sort === \'name\' && !vm.sortItems[1].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                             sortItem.sort !== \'name\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class="ft_14_600_black projectname-container"><div class=cursor-point ng-click="changeSortItem(\'projectName\')"><span translate="Project Name"></span> <img ng-src="{{sortItem.sort === \'projectName\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                             sortItem.sort === \'projectName\' && !vm.sortItems[2].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                             sortItem.sort !== \'projectName\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class="ft_14_600_black task-container"><!-- <div class="cursor-point" ng-click="changeSortItem(\'tasks\')"> --> <span translate=Tasks></span><!-- <img ng-src="{{sortItem.sort === \'tasks\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                             sortItem.sort === \'tasks\' && !vm.sortItems[3].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                             sortItem.sort !== \'tasks\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""/>\n            </div> --></th><th class="ft_14_600_black date-container"><div class=cursor-point ng-click="changeSortItem(\'date\')"><span translate=Date></span> <img ng-src="{{sortItem.sort === \'date\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                             sortItem.sort === \'date\' && !vm.sortItems[4].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                             sortItem.sort !== \'date\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class="ft_14_600_black small-container"><span translate="Start Time"></span></th><th class="ft_14_600_black small-container"><span translate="End Time"></span></th><th class="ft_14_600_black small-container"><span translate=Break></span></th><th class="ft_14_600_black small-container"><span translate=Total></span></th><th class="ft_14_600_black small-container"><span translate="Over Time"></span></th><th class=ft_14_600_black><span translate=Distance></span></th><th class=ft_14_600_black><span translate=Receipts></span></th><th class=ft_14_600_black><span translate="Other Cost"></span></th><th class=ft_14_600_black><span translate=Actions></span></th></tr></thead><tbody><tr ng-class="(key%2) ? \'item2\':\'item1\'" ng-repeat-start="payroll in vm.payrolls track by $index" ng-if=!payroll.editData><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=payroll.checked><span class=checkmark></span></label></td><td class="ft_14_regular_black tx-ellipsis name name-container">{{ payroll.userId.displayName }}</td><td class="ft_14_regular_black tx-ellipsis projectname-container">{{ payroll.projectId.projectName }}</td><td class="ft_14_regular_black task-container">{{getDisplayTaskName(payroll)}}</td><td class="ft_14_regular_black date-container">{{ payroll.date | slashDate }}</td><td class="ft_14_regular_black small-container">{{ payroll.startTime | smartTime }}</td><td class="ft_14_regular_black small-container">{{ payroll.endTime | smartTime }}</td><td class="ft_14_regular_black small-container">{{ getBreak(payroll) | readable: 1 }} Hr</td><td class="ft_14_regular_black small-container">{{ getTotalHours(payroll) | readable: 1 }} Hr</td><td class="ft_14_regular_black small-container">{{ getOverTime(payroll) | readable: 1 }} Hr</td><td class=ft_14_regular_black>{{ payroll.distance | readable: 2 }} km</td><td class=ft_14_regular_black><img ng-if=payroll.receipts.length class=mr-4 src=/assets/icons/attachment4.svg alt=""> {{ payroll.receipts.length }}&nbsp;<span translate=Docs></span></td><td class=ft_14_regular_black>{{ getOtherCost(payroll) }}</td><td class=ft_14_regular_black><img class="mr-2 cursor-point" src=/assets/icons/eye6.svg alt="" ng-click=vm.viewPayroll(payroll)> <img class="mr-2 cursor-point" src=/assets/icons/bx-edit6.svg alt="" ng-click=vm.editPayroll(payroll) ng-if="ECO_ACCESS_CREATE > 1"> <img class=cursor-point src=/assets/icons/trash-alt6.svg alt="" ng-click=vm.removePayroll(payroll) ng-if="ECO_ACCESS_CREATE > 3"></td></tr><tr ng-repeat-end=payroll ng-if=payroll.editData class="item2 payroll-edit-tr"><td style="width: 60px;"></td><td class="name name-container"><selectbox-input class=dropdown-primary ng-model=payroll.editData.userId options=vm.workers label-field=displayName value-field=_id select-event=vm.selectWorker(payroll)></selectbox-input></td><td class="project_name tx-ellipsis text-left ml-2 projectname-container" title={{payroll.projectId.projectName}}>{{ payroll.projectId.projectName }}</td><td class="tasks task-container"><selectbox-input class="tasks-input dropdown-primary" ng-model=payroll.editData.task label-field=name value-field=_id options=vm.tasks select-event=vm.selectTask(payroll)></selectbox-input></td><td class="date date-container">{{ payroll.date | slashDate }}</td><td class="start_time small-container"><time-picker ng-model=payroll.editData.startTime></time-picker></td><td class="end_time small-container"><time-picker ng-model=payroll.editData.endTime></time-picker></td><td class="breakup small-container"><payroll-breakup ng-model=payroll.editData up="$index>6"></payroll-breakup></td><td class="total small-container">{{ getTotalHours(payroll.editData) | readable: 1 }} Hr</td><td class="overtime small-container">{{ getOverTime(payroll.editData) | readable: 1 }} Hr</td><td class=distance><payroll-driving ng-model=payroll.editData up="$index>6"></payroll-driving></td><td class=receipts><payroll-receipt ng-model=payroll.editData up="$index>6"></payroll-receipt></td><td class="other-cost cost-container"><selectbox-input class="tasks-input dropdown-primary" ng-model=payroll.editData.otherTypeCost label-field=costType value-field=_id options=payroll.editData.otherTypeCosts has-clear=true></selectbox-input></td><td class="icons actions"><img class=cursor-point src=/assets/icons/checkmark-24.svg alt="" ng-click=vm.updatePayroll(payroll)> <img class=cursor-point src=/assets/icons/close-24-dark.svg alt="" ng-click="vm.cancelEdit(payroll, $index)"></td></tr><tr class="ft_14_600_black total item2" style="border-top: 1px solid black;"><td style="width: 60px;"></td><td class="name name-container">Total</td><td class="project_name projectname-container"></td><td class="tasks task-container"></td><td class=date></td><td class=start_time></td><td class=end_time></td><td class=breakup>{{ vm.total.breaks | readable: 1 }} Hr</td><td class=total>{{ vm.total.hours | readable: 1 }} Hr</td><td class=overtime>{{ vm.total.overtime | readable: 1 }} Hr</td><td class=distance>{{ vm.total.distance | readable: 2 }} km</td><td class=receipts></td><td class=other-cost></td><td class=actions></td></tr></tbody></table><!-- <div class="text-center ft_18_600_gray" ng-show="totalCount==0" translate="No data to display"></div> --><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.payrolls.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.nextPage()></pagination-custom-new></div></div></div></div></main>');
$templateCache.put('app/main/employees/employees/employees.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=employees class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Employees></a></div><div class=ft_24_600_black1 translate=Employees></div></div><div class=nav-items><div class="nav-item active" ui-sref=employees translate=Employee></div><div class=nav-item ui-sref=employeeGroup translate=Group></div></div><div class="ml-auto show-all"><checkbox class=mr-1 ng-model=vm.showAll ng-click=vm.fetchAllEmployees()>Show All</div><searchbox search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><div><button class="btn-trans ml-16" ng-click="isGrid = false"><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click="isGrid = true"><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button></div><button class="btn_new_blue ml-16" ui-sref=employeesAdd ng-if="EMPLOYEE_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Add Employee"></span></button></div><div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0 && isLoading==false"><div class="card-based-content-grid-wrapper pr-24 pv-24" ng-if=isGrid><div class="quotes-wrapper flex flex-wrap"><div class=profile-card-container ng-repeat="client in employees"><div class=profile-card><div class=card-content><div class="flex header"><div ng-if=client.profilePic><img ng-src={{client.profilePic}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!client.profilePic><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(client.displayName)) }">{{client.displayName | mailAvatarChar}}</span></div><div class=name-wrapper ng-click=goToDetail(client._id)><div class="name tx-ellipsis ft_16_600_black" ng-bind=client.displayName></div><div class="date text-left tx-ellipsis" ng-bind=vm.utils.getAddressString(client.address1)></div></div></div><div class=detail><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/call.svg alt=icons><span class=ft_14_regular_gray ng-bind="\'+\'+client.mobile.dialCode+\' \'+client.mobile.phoneNumber"></span></div><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/email.svg alt=icons><span class="ft_14_regular_gray tx-ellipsis" ng-bind=client.email></span></div></div></div><div class="flex-between action"><div class=flex-row><img src=/assets/images/suppliers/tag.svg alt=icons><span class="ft_12_600_black ml-7" ng-bind=client.systemTag></span></div><div class=flex-row><img src=/assets/images/suppliers/calendar.svg alt=icons><span class="ft_12_regular_gray cal-span" ng-bind="client.created | date: \'dd MMM yyyy\' : \'UTC\'"></span></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + employees.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllEmployees()></pagination-custom-new></div></div></div></div><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer" ng-if=!isGrid><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked><span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate=Name></span></th><th class=ft_14_600_black><span translate="Email ID"></span></th><th class=ft_14_600_black><span translate="Contact No."></span></th><th class=ft_14_600_black><span translate=Address></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, client) in employees"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked><span class=checkmark></span></label></td><td ng-click=goToDetail(client._id)><div class="flex-row flex-items-center"><div class=avatar-cell><div ng-if=client.profilePic><img ng-src={{client.profilePic}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!client.profilePic><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(client.displayName)) }">{{client.displayName | mailAvatarChar}}</span></div></div><div class="ft_14_regular_black tx-ellipsis name" ng-bind=client.displayName></div></div></td><td class="tx-ellipsis email ft_14_regular_black" ng-bind=client.email></td><td class=ft_14_regular_black ng-bind="\'(\'+client.mobile.dialCode+\') \'+client.mobile.phoneNumber"></td><td class="tx-ellipsis address pr-20 ft_14_regular_black">{{ client.address[0].line1}},{{client.address[0].line2}},{{client.address[0].city}},{{client.address[0].postalCode}},{{client.address[0].countryCode }}</td><td class="more flex-items-center"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class=margin-0></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + employees.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllEmployees()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/employees/employeesAdd/employeesAdd.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=employeesAdd class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=employees translate=Employees></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Add Employee"></a> --></div><div class=ft_24_600_black1 translate="Add Employee"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=createEmployee()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=createEmployee()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=employees><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="EMPLOYEE DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{ !!FILEIMG ? FILEIMG : \'/assets/images/suppliers/upload.png\' }}" alt=upload ngf-select ng-model=picFile name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Employee Name"></div><input type=text ng-model=vm.employee.name id=firstName class="login_input name" placeholder="{{\'Employee Name\' | translate}}" autocomplete=off></div><div class=flex-24><div class="ft_14_600_moreblack required" translate=Gender></div><div class=w-100><selectbox-input class=input-select ng-model=vm.employee.gender options=vm.genderList label-field=name value-field=value></selectbox-input></div></div><div class=flex-24><div class="ft_14_600_moreblack required" translate=Status></div><div class=w-100><selectbox-input class=input-select ng-model=vm.employee.isActive options=vm.enableList label-field=name value-field=value></selectbox-input></div></div></div><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Email ID"></div><input autocomplete=off type=email placeholder="{{\'Email ID\' | translate}}" class="login_input mail" ng-model=vm.employee.email></div><div class=flex-49><div class="ft_14_600_moreblack required" translate="Contact No."></div><div class=flex><div class=w-147 ng-if=vm.countryCodes><selectbox-input class=input-select ng-model=vm.employee.mobile.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number placeholder="{{\'Phone Number\' | translate}}" class="login_input phone" ng-model=vm.employee.mobile.phoneNumber></div></div></div><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Date of Birth"></div><input ng-click="isBirthDatepickerOpen = !isBirthDatepickerOpen" type=text class="login_input birth-date" date-picker=dd/MM/yyyy date=vm.employee.dob is-open=isBirthDatepickerOpen ng-required=true></div><div class=flex-49><div class="ft_14_600_moreblack required" translate="Date of Joining"></div><input ng-click="isJoinDatepickerOpen = !isJoinDatepickerOpen" type=text class="login_input joining-date" date-picker=dd/MM/yyyy date=vm.employee.doj is-open=isJoinDatepickerOpen ng-required=true></div></div></div></div></div></div><div class=profile-card><span class=label translate=ADDRESS></span><div class="address flex-between flex-wrap mt-16"><div class=flex-100><div class="ft_14_600_moreblack required" translate="Primary Address"></div><input autocomplete=off type=text id=address ng-model=vm.employee.address1.line1 class="login_input address" placeholder="{{\'Include a place or address\' | translate}}"></div><div class=flex-32><div class="ft_14_600_moreblack required" translate=Country></div><div class="w-100 mb-24"><selectbox-input class=input-select ng-model=vm.employee.address1.countryCode options=vm.countryCodes label-field=name value-field=code></selectbox-input></div></div><div class=flex-32><div class="ft_14_600_moreblack required" translate=City></div><input autocomplete=off type=text class="login_input country" placeholder="{{\'City Name\' | translate}}" ng-model=vm.employee.address1.city id=city></div><div class=flex-32><div class="ft_14_600_moreblack required" translate="Postal Code"></div><input autocomplete=off type=number class="login_input country" placeholder="{{\'Postal Code\' | translate}}" ng-model=vm.employee.address1.postalCode id=postalCode></div><div class=flex-100><div class=ft_14_600_moreblack translate="Secondary Address(Optional)"></div><input autocomplete=off type=text id=address ng-model=vm.employee.address2.line1 class="login_input address" placeholder="{{\'Include a place or address\' | translate}}"></div><div class=flex-32><div class=ft_14_600_moreblack translate=Country></div><div class="w-100 mb-24"><selectbox-input class=input-select ng-model=vm.employee.address2.countryCode options=vm.countryCodes label-field=name value-field=code></selectbox-input></div></div><div class=flex-32><div class=ft_14_600_moreblack translate=City></div><input autocomplete=off type=text class="login_input country" placeholder="{{\'City Name\' | translate}}" ng-model=vm.employee.address2.city id=city></div><div class=flex-32><div class=ft_14_600_moreblack translate="Postal Code"></div><input autocomplete=off type=number class="login_input country" placeholder="{{\'Postal Code\' | translate}}" ng-model=vm.employee.address2.postalCode id=postalCode></div></div></div><div class=profile-card><span class=label translate="ROLE INFORMATION"></span><div class="role flex-between flex-wrap mt-16"><div class="flex-49 mb-24"><div class=ft_14_600_moreblack translate="Labour Settings"></div><div class=w-100><selectbox-input class=input-select ng-model=vm.employee.employeeSettingId options=vm.laberSettingsList label-field=presetName value-field=_id select-event="changeOption(\'EmployeeSetting\', vm.employee.employeeSettingId)"></selectbox-input></div></div><div class="flex-49 mb-24"><div class="ft_14_600_moreblack required" translate=Salary></div><input autocomplete=off type=number class="login_input w-100" ng-model=vm.employee.salaryAmount place-holder=Salary></div><div class=flex-49><div class=ft_14_600_moreblack translate="Add Skill"></div><div class="flex-between flex-end mb-24"><div class=flex-25><selectbox-input class="input-select arrowbottom_46_400 dropdown skill-level" ng-model=vm.addSkillLevel options=vm.addSkillLevelList label-field=label value-field=value ng-disabled=isExistsAllSkill()></selectbox-input></div><div class=flex-57><selectbox-input class="skill input-select" ng-model=vm.addSkill options=vm.allSkills label-field=name value-field=_id ng-disabled=isExistsAllSkill()></selectbox-input></div><div><button class=btn_new_blue ng-click=vm.addSkillAction()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div ng-repeat="(key, item) in vm.employee.skills"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind="item.level + \' / 10 - \' + item.name"></div></div><div class="pos-absolute-1-0 flex-items-center"><button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click=vm.deleteSkillAction(item)></button></div></div></div></div></div><div class="btnGroup flex mt-32"><button class="btn_new_blue mr-16" ng-click=createEmployee()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=createEmployee()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=employees><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/employees/employeesDetail/employeesDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=employeesDetail class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=employees translate=Employees></a></div><div class=ft_24_600_black1 translate="Employee Details"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ui-sref="employeesEdit({id: vm.Employee._id})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=deleteEmployee()><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=employees><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="EMPLOYEE DETAILS"></span><div class="flex mt-16"><!-- upload photo --><div class=img-container data-wow-delay=1.3s><img width=264 height=264 class="bdRadius-4 object-fit-cover" ng-src="{{ FILEIMG ? FILEIMG : !!vm.Employee.profilePic ? vm.Employee.profilePic : \'/assets/images/suppliers/upload.svg\'}}"></div><div class="w-100 flex-wrap"><div class="flex-between items"><div class=flex-49><div class=ft_14_regular_gray2 translate="Employee Name"></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=vm.Employee.displayName></div></div><div class=flex-49><div class=ft_14_regular_gray2 translate=Status></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind="vm.Employee ? vm.Employee.isActive == true ? \'Enable\' : \'Disable\' : \'\'"></div></div></div><div class="flex-between items"><div class=flex-49><div class=ft_14_regular_gray2 translate="Email ID"></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=vm.Employee.email></div></div><div class=flex-49><div class=ft_14_regular_gray2 translate=Designation></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=vm.designationLabel></div></div></div><div class="flex-between items"><div class=flex-49><div class=ft_14_regular_gray2 translate="Date of Birth"></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind="vm.Employee.dateOfBirth | date"></div></div><div class=flex-49><div class=ft_14_regular_gray2 translate="Date of Joining"></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind="vm.Employee.dateOfJoin | date"></div></div></div><div class="items flex-between"><div class=flex-49><div class=ft_14_regular_gray2 translate=Gender></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=vm.Employee.gender></div></div><div class=flex-49><div class=ft_14_regular_gray2 translate="Labour Settings"></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=vm.employeeSettingLabel></div></div></div><div class="items flex-between flex-wrap"><div class=flex-49><div class=ft_14_regular_gray2 translate="Contact No."></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind="\'+\'+vm.Employee.mobile.dialCode + \' \' + vm.Employee.mobile.phoneNumber"></div></div><div class=flex-49><div class=ft_14_regular_gray2 translate=Salary></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=vm.Employee.salaryAmount></div></div></div><div class="items flex-between flex-wrap"><div class=flex-49><div class=mb-24><div class="ft_12_regular_gray mb-8" translate="Primary Address"></div><div class="ft_14_600_black item-data" ng-bind=vm.utils.getAddressString(vm.Employee.address1)></div></div><div><div class="ft_12_regular_gray mb-8" translate="Secondary Address"></div><div class="ft_14_600_black item-data" ng-bind=vm.utils.getAddressString(vm.Employee.address2)></div></div></div><div class=flex-49><div class="ft_12_regular_gray mb-8" translate=Skills></div><div class=item-wrapper><div class="item mb-10" ng-repeat="(key, item) in vm.Employee.skills"><span>{{item.level}}/10 - {{item.name}}</span></div></div></div></div></div></div><div class="btnGroup flex mt-32"><button class="btn_new_blue mr-16" ui-sref="employeesEdit({id: vm.Employee._id})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=deleteEmployee()><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=employees><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div></div></div></div></main>');
$templateCache.put('app/main/employees/employeesEdit/employeesEdit.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoaing></spinner><div id=employeesEdit class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=employees translate=Employees></a></div><div class=ft_24_600_black1 translate="Edit Employee"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=vm.save()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=vm.save()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref="employeesDetail({id: vm.employee._id})"><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="EMPLOYEE DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{ !!FILEIMG ? FILEIMG : \'/assets/images/suppliers/upload.png\' }}" alt=upload ngf-select ng-model=picFile name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Employee Name"></div><input type=text ng-model=vm.employee.name id=firstName class=input-primary placeholder="{{\'Employee Name\' | translate}}" autocomplete=off></div><div class=flex-24><div class="ft_14_600_moreblack required" translate=Gender></div><div class=w-100><selectbox-input class=dropdown-primary ng-model=vm.employee.gender options=vm.genderList label-field=name value-field=value></div></div><div class=flex-24><div class="ft_14_600_moreblack required" translate=Status></div><div class=w-100><selectbox-input class=dropdown-primary ng-model=vm.employee.isActive options=vm.enableList label-field=name value-field=value></div></div></div><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Email ID"></div><input autocomplete=off type=email ng-model=vm.employee.email placeholder="{{\'Invoice Email ID\' | translate}}" class=input-primary></div><div class=flex-49><div class="ft_14_600_moreblack required" translate="Contact No."></div><div class=flex><div class=w-147 ng-if=vm.countryCodes><selectbox-input class=dropdown-primary ng-model=vm.employee.mobile.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></div><input autocomplete=off type=number ng-model=vm.employee.mobile.phoneNumber placeholder="{{\'Phone Number\' | translate}}" class="input-primary ml-16"></div></div></div><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Date of Birth"></div><input ng-click="isBirthDatepickerOpen = !isBirthDatepickerOpen" type=text class=input-primary date-picker=dd/MM/yyyy date=vm.employee.dob is-open=isBirthDatepickerOpen ng-required=true></div><div class=flex-49><div class="ft_14_600_moreblack required" translate="Date of Joining"></div><input ng-click="isJoinDatepickerOpen = !isJoinDatepickerOpen" type=text class=input-primary date-picker=dd/MM/yyyy date=vm.employee.doj is-open=isJoinDatepickerOpen ng-required=true></div></div></div></div></div></div><div class=profile-card><span class=label translate=ADDRESS></span><div class="address flex-between flex-wrap mt-16"><div class=flex-100><div class="ft_14_600_moreblack required" translate="Primary Address"></div><input autocomplete=off type=text id=address ng-model=vm.employee.address1.line1 class=input-primary placeholder="{{\'Include a place or address\' | translate}}"></div><div class=flex-32><div class="ft_14_600_moreblack required" translate=Country></div><div class="w-100 mb-24"><selectbox-input class=dropdown-primary ng-model=vm.employee.address1.countryCode options=vm.countryCodes label-field=name value-field=code></div></div><div class=flex-32><div class="ft_14_600_moreblack required" translate=City></div><input autocomplete=off type=text ng-model=vm.employee.address1.city class=input-primary placeholder="{{\'City Name\' | translate}}" id=city></div><div class=flex-32><div class="ft_14_600_moreblack required" translate="Postal Code"></div><input autocomplete=off type=text ng-model=vm.employee.address1.postalCode class=input-primary placeholder="{{\'Postal Code\' | translate}}" id=postalCode></div><div class=flex-100><div class=ft_14_600_moreblack translate="Secondary Address(Optional)"></div><input autocomplete=off type=text id=address ng-model=vm.employee.address2.line1 class=input-primary placeholder="{{\'Include a place or address\' | translate}}"></div><div class=flex-32><div class=ft_14_600_moreblack translate=Country></div><div class="w-100 mb-24"><selectbox-input class=dropdown-primary ng-model=vm.employee.address2.countryCode options=vm.countryCodes label-field=name value-field=code></div></div><div class=flex-32><div class=ft_14_600_moreblack translate=City></div><input autocomplete=off type=text ng-model=vm.employee.address2.city class=input-primary placeholder="{{\'City Name\' | translate}}" id=city></div><div class=flex-32><div class=ft_14_600_moreblack translate="Postal Code"></div><input autocomplete=off type=text ng-model=vm.employee.address2.postalCode class=input-primary placeholder="{{\'Postal Code\' | translate}}" id=postalCode></div></div></div><div class=profile-card><span class=label translate="ROLE INFORMATION"></span><div class="role flex-between flex-wrap mt-16"><div class="flex-49 mb-24"><div class=ft_14_600_moreblack translate="Labour Settings"></div><div class=w-100><selectbox-input class=dropdown-primary ng-model=vm.employee.employeeSettingId options=vm.laberSettingsList label-field=presetName value-field=_id select-event="changeOption(\'EmployeeSetting\', vm.employee.employeeSettingId)"></div></div><div class="flex-49 mb-24"><div class="ft_14_600_moreblack required" translate=Salary></div><input autocomplete=off type=number class=input-primary ng-model=vm.employee.salaryAmount place-holder=Salary></div><div class=flex-49><div class=ft_14_600_moreblack translate="Add Skill"></div><div class="flex-between flex-end mb-24"><div class=flex-25><selectbox-input class=dropdown-primary ng-model=vm.addSkillLevel options=vm.addSkillLevelList label-field=label value-field=value ng-disabled=isExistsAllSkill()></div><div class=flex-57><selectbox-input class=dropdown-primary ng-model=vm.addSkill options=vm.allSkills label-field=name value-field=_id ng-disabled=isExistsAllSkill()></div><div><button class=button-primary ng-click=vm.addSkillAction()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div class=d-flex><div ng-repeat="(key, item) in vm.employee.skills"><div class="item ft_14_regular_gray"><div class="pr-25 flex-between"><div class="ft_14_600_moreblack tx-ellipsis" ng-if=!item.editMode ng-bind="item.level + \' / 10 - \' + item.name"></div><div class=flex-between ng-if=item.editMode><input type=text ng-model=item.level class=level autofocus><div class="ft_14_600_moreblack tx-ellipsis" ng-bind="\' / 10 - \' + item.name"></div></div></div><div class="pos-absolute-1-0 flex-items-center"><button ng-if=!item.editMode class="btn-trans padding-0"><img src=/assets/icons/edit.svg alt=icons ng-click=vm.editMode(item)></button> <button ng-if=item.editMode class="btn-trans padding-0"><img src=/assets/icons/check-mark.svg alt=icons ng-click=vm.changeSkillLevel(item)></button> <button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click=vm.deleteSkillAction(item)></button></div></div></div></div></div></div><div class="btnGroup flex mt-32"><button class="button-primary mr-16" ng-click=vm.save()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=vm.save()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref="employeesDetail({id: vm.employee._id})"><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/employees/group/group.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=employeeGroup class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Employees></a></div><div class=ft_24_600_black1 translate=Groups></div></div><div class=nav-items><div class=nav-item ui-sref=employees translate=Employee></div><div class="nav-item active" ui-sref=employeeGroup translate=Group></div></div><searchbox class=ml-auto search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><div><button class="btn-trans ml-16" ng-click="isGrid = false"><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click="isGrid = true"><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button></div><button class="btn_new_blue ml-16" ui-sref=groupAdd ng-if="EMPLOYEE_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Add Group"></span></button></div><div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0 && isLoading==false"><div class="card-based-content-grid-wrapper pr-24 pv-24" ng-if=isGrid><div class="quotes-wrapper flex flex-wrap"><div class=profile-card-container ng-repeat="client in vm.groups"><div class=profile-card><div class=card-content><div class="flex header"><div class=name-wrapper ng-click=goToDetail(client._id)><div class="name tx-ellipsis ft_16_600_black" ng-bind=client.name></div><div class=date ng-bind="client.created | date: \'d MMM, yyyy\' : \'UTC\'"></div></div></div><img ng-src="{{ client.image ? client.image : \'/assets/images/suppliers/upload.svg\' }}" class="group-image object-fit-cover" alt=icons><div class=detail><div class=flex><div><div class=sub-title translate=Leader></div><div class="avatars mt-4"><div class=employee-avatar><img ng-src="{{client.leader.profilePic ? client.leader.profilePic : \'/assets/images/employees/no-avatar.png\'}}" alt=""></div></div></div><div class=split-vert></div><div><div class=sub-title translate=Members></div><div class="avatars pl-8 mt-4"><div class="employee-avatar ml-8n" ng-repeat="employee in client.employees | limitTo: 3" ng-style="{\'z-index\': 10-$index}"><img ng-src="{{ employee.profilePic ? employee.profilePic : \'/assets/images/employees/no-avatar.png\' }}" alt=""></div><div class="employee-avatar ml-8n" ng-if="client.employees.length > 3"><div class=more>+{{client.employees.length - 3}}</div></div></div></div></div><div class="flex mt-20"><div class=skill-item ng-repeat="skill in client.skills | limitTo: 2">{{skill.level}}/10 - {{skill.name}}</div><div class="skill-item more" ng-if="client.skills.length > 2">+{{client.skills.length - 2}} More</div></div></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.groups.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.getEmplGrps()></pagination-custom-new></div></div></div></div><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer" ng-if=!isGrid><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked> <span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate=Name></span> <img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class=ft_14_600_black><span translate=Leader></span> <img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class=ft_14_600_black><span translate=Members></span> <img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class=ft_14_600_black><span translate=Skills></span> <img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class="(key%2) ? \'item2\':\'item1\'" ng-repeat="(key, client) in vm.groups"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked> <span class=checkmark></span></label></td><td ng-click=goToDetail(client._id) class="name-wrapper name"><div class="ft_14_regular_black tx-ellipsis name" ng-bind=client.name></div><div ng-bind="client.created | date: \'d MMM, yyyy\' : \'UTC\'"></div></td><td class="tx-ellipsis email ft_14_regular_black leader"><div class=avatars><div class=employee-avatar><img ng-src="{{client.leader.profilePic ? client.leader.profilePic : \'/assets/images/employees/no-avatar.png\'}}" alt=""></div></div></td><td class="ft_14_regular_black member"><div class="avatars pl-8"><div class="employee-avatar ml-8n" ng-repeat="employee in client.employees | limitTo: 3" ng-style="{\'z-index\': 10-$index}"><img ng-src="{{employee.profilePic ? employee.profilePic : \'/assets/images/employees/no-avatar.png\'}}" alt=""></div><div class="employee-avatar ml-8n" ng-if="client.employees.length > 3"><div class=more>+{{client.employees.length - 3}}</div></div></div></td><td class="tx-ellipsis skills pr-20 ft_14_regular_black"><div class=flex><div class=skill-item ng-repeat="skill in client.skills | limitTo: 5">{{skill.name}}</div><div class="skill-item more" ng-if="client.skills.length > 5">+{{client.skills.length - 5}} More</div></div></td><td class="more flex-items-center"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class=margin-0></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.groups.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.getEmplGrps()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/employees/groupAdd/groupAdd.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=groupAdd class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=employeeGroup translate=Groups></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Add Group"></a> --></div><div class=ft_24_600_black1 translate="Add Group"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=vm.save()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=vm.save()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=employeeGroup><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="GROUP DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{ !!FILEIMG ? FILEIMG : \'/assets/images/suppliers/upload.png\' }}" alt=upload ngf-select ng-model=picFile name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Group Name"></div><input type=text ng-model=vm.group.name id=firstName class="login_input name" placeholder="{{\'Group Name\' | translate}}" autocomplete=off></div><div class=flex-49><div class="ft_14_600_moreblack required" translate="Team Leader"></div><div class=w-100><selectbox-input class=input-select ng-model=vm.leader options=vm.leaders label-field=displayName value-field=_id select-event=vm.changeLeader(vm.leader)></selectbox-input></div></div></div><div class="flex-between items" ng-class="vm.group.employees.length? \'mb-0\': \'\'"><div class=flex-49><div class="ft_12_600_gray mb-8 required" translate="Add Workers"></div><selectbox-input class=input-select ng-model=vm.employee options=vm.employees label-field=displayName value-field=_id select-event=vm.changeEmployee(vm.employee)></selectbox-input></div></div><div class="flex-between items"><div class=flex-100><div class=workers-wrapper ng-if=vm.group.employees.length><div class="item mb-15" ng-repeat="(key, item) in vm.group.employees"><img class=avatar ng-src="{{item.profilePic || \'/assets/images/employees/no-avatar.png\'}}" alt=icons> <span>{{item.displayName}}</span> <button class="btn-trans-1 padding-0"><img src=/assets/icons/subtract.svg alt=icons ng-click="cancelSelectWorker(key, item)"></button></div></div></div></div><div class="flex-between items" ng-class="vm.group.skills.length? \'mb-0\': \'\'"><div class=flex-100><div class="ft_12_600_gray mb-8" translate=Skills></div><div class=skills-wrapper ng-if=vm.group.skills.length><div class="item mb-15" ng-repeat="skill in vm.group.skills"><span>{{skill.name}}</span></div></div></div></div></div></div></div><div class="btnGroup flex mt-32"><button class="btn_new_blue mr-16" ng-click=vm.save()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=vm.save()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=employeeGroup><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/employees/groupDetail/groupDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=groupDetail class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=employeeGroup translate=Groups></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Group Details"></a> --></div><div class=ft_24_600_black1 translate="Group Details"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ui-sref="groupEdit({id: vm.group._id})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=vm.deleteEmplGroup()><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=employeeGroup><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="GROUP DETAILS"></span><div class="flex mt-16"><!-- upload photo --><div class=img-container data-wow-delay=1.3s><img class=logo width=264 height=264 ng-src="{{ vm.group.image ? vm.group.image : \'/assets/images/suppliers/upload.svg\' }}" alt=upload ngf-select ng-model=picFile name=file ngf-change=onChange($files) aria-invalid=false class=object-fit-cover data-wow-delay=0.7s class="bdRadius-4 object-fit-cover"><!-- <img\n                width="264"\n                height="264"\n                class="bdRadius-4 object-fit-cover"\n                ng-src="{{ FILEIMG ? FILEIMG : !!vm.Employee.profilePic ? vm.Employee.profilePic : \'/assets/images/suppliers/upload.svg\'}}"/> --></div><div class="w-100 flex-wrap"><div class="flex-between items"><div class=flex-100><div class=ft_14_regular_gray2 translate="Group Name"></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=vm.group.name></div></div></div><div class="flex-between items"><div class=flex-49><div class=ft_14_regular_gray2 translate="Team Leader"></div><div class=d-flex><img class=avatar ng-src="{{ !!vm.group.leader.profilePic?vm.group.leader.profilePic:\'/assets/images/suppliers/upload.svg\' }}" class=object-fit-cover alt=icons><div><div class="ft_14_600_black item-data" ng-bind=vm.group.leader.displayName></div><div class="ft_12_regular_gray item-data" ng-bind=vm.group.leader.designation></div></div></div></div></div><div class="flex-between items" ng-class="vm.group.employees.length? \'mb-0\': \'\'"><div class=flex-100><div class="ft_14_regular_gray2 mb-8" translate=Workers></div><div class="d-flex flex-wrap"><div class="d-flex worker-tag" ng-repeat="worker in vm.group.employees"><img class=avatar ng-src="{{ !!worker.profilePic?worker.profilePic:\'/assets/images/suppliers/upload.svg\' }}" class=object-fit-cover alt=icons><div><div class=ft_14_600_black ng-bind="worker.firstName + \' \' + worker.lastName"></div><div class=ft_12_regular_gray ng-bind=worker.designation></div></div></div></div></div></div><div class="flex-between items" ng-class="vm.group.skills.length? \'mb-0\': \'\'"><div class=flex-100><div class="ft_14_regular_gray2 mb-8" translate=Skills></div><div class=item ng-repeat="skill in vm.group.skills"><span>{{skill.level}}/10 - {{skill.name}}</span></div></div></div></div></div></div><div class="btnGroup flex mt-32"><button class="btn_new_blue mr-16" ui-sref="groupEdit(({id: vm.group._id})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=vm.deleteEmplGroup()><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=employeeGroup><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div></div></div></main>');
$templateCache.put('app/main/employees/groupEdit/groupEdit.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoaing></spinner><div id=groupEdit class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=employeeGroup translate=Groups></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Edit Group"></a> --></div><div class=ft_24_600_black1 translate="Edit Group"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=vm.save()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=vm.save()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="btn_new_blue client_gray_white_back" ng-click=gotoDetail()><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="GROUP DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{ !!FILEIMG ? FILEIMG : \'/assets/images/suppliers/upload.png\' }}" alt=upload ngf-select ng-model=picFile name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Group Name"></div><input type=text ng-model=vm.group.name id=firstName class="login_input name" placeholder="{{\'Group Name\' | translate}}" autocomplete=off></div><div class=flex-49><div class="ft_14_600_moreblack required" translate="Team Leader"></div><div class=w-100><selectbox-input class=input-select ng-model=vm.leader options=vm.leaders label-field=displayName value-field=_id select-event=vm.changeLeader(vm.leader)></selectbox-input></div></div></div><div class="flex-between items" ng-class="vm.group.employees.length? \'mb-0\': \'\'"><div class=flex-49><div class="ft_12_600_gray mb-8 required" translate="Add Workers"></div><selectbox-input class=input-select ng-model=vm.employee options=vm.employees label-field=displayName value-field=_id select-event=vm.changeEmployee(vm.employee)></selectbox-input></div></div><div class="flex-between items"><div class=flex-100><div class=workers-wrapper ng-if=vm.group.employees.length><div class="item mb-15" ng-repeat="(key, item) in vm.group.employees"><img class=avatar ng-src="{{item.profilePic || \'/assets/images/employees/no-avatar.png\'}}" alt=icons> <span>{{item.displayName}}</span> <button class="btn-trans-1 padding-0"><img src=/assets/icons/subtract.svg alt=icons ng-click="cancelSelectWorker(key, item)"></button></div></div></div></div><div class="flex-between items" ng-class="vm.group.skills.length? \'mb-0\': \'\'"><div class=flex-100><div class="ft_12_600_gray mb-8" translate=Skills></div><div class=skills-wrapper ng-if=vm.group.skills.length><div class="item mb-15" ng-repeat="skill in vm.group.skills"><span>{{skill.level}}/10 - {{skill.name}}</span></div></div></div></div></div></div></div><div class="btnGroup flex mt-32"><button class="btn_new_blue mr-16" ng-click=vm.save()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=vm.save()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="btn_new_blue client_gray_white_back" ng-click=gotoDetail()><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/equipments/addDcq/addDcq.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div class="add-dcq main-container"><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=dcqList translate=DCQ></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Add DCP"></a> --></div><div class=ft_24_600_black1 translate="Add DCQ"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=vm.createCombo()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=dcqList><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card pt-24"><span class=label translate="DCQ INFORMATION"></span><div class="flex flex-row mt-16 mb-24"><div class="flex-29 flex flex-col"><div class="flex-1 flex flex-col"><span translate="DCP Name" class="ft_14_600_moreblack required"></span> <input type=text ng-model=vm.comboData.name class=login_input_new></div><div class="flex flex-col flex-50"><span translate=Unit class="ft_14_600_moreblack required"></span><selectbox-input class=input-select options=vm.mUnits label-field=name value-field=value ng-model=vm.comboData.unit></selectbox-input></div></div><div class="flex-69 flex flex-col ml-24"><span translate=Description class=ft_14_600_moreblack></span> <textarea type=text ng-model=vm.comboData.description placeholder="Write some description (optional)" rows=6></textarea></div></div></div><div class=profile-card><span class=label translate=ATTACHMENTS></span><div class="flex-items-center mt-16 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'image\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.objectUrl}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImages.splice($index, 1)"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'file\')" name=file ngf-pattern="\'.pdf,.doc,.docx,.xls,.xlsx\'" ngf-multiple=true ngf-accept="\'.pdf,.doc,.docx,.xls,.xlsx\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadFiles.splice($index, 1)"></div></div></div></div><div class=profile-card><span class=label translate=COMBINATION></span><div class="flex flex-row mt-16 mb-24"><div class="flex-30 flex flex-col"><span translate="Equipment list" class=ft_14_600_moreblack></span><selectbox-input class="w-100 input-select" options=vm.equList label-field=name value-field=_id ng-model=comboEqu.equId select-event=onChangeEqu(comboEqu)></selectbox-input></div><div class="flex-10 flex flex-end ml-24"><button class="btn_new_blue m-t-4" ng-click=addEquipment()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div class="d-flex w-100 flex-wrap mb-24" ng-if=!vm.utils.isEmpty(comboMaterialList)><div class=material ng-repeat="mat in comboMaterialList track by $index"><div class="ft_14_regular_black mr-8">{{equ.name}}</div><img src=/assets/icons/close-16.svg alt=close class=cursor-point ng-click="removeEquipment($index, equ.equId)"></div></div><div class="flex flex-row"><div class="flex-18 flex flex-col"><span class=ft_14_600_moreblack translate=Quantity></span> <input type=text class=login_input_new number-edit ng-model=comboEqu.quantity ng-change=calcComboEquCost(comboEqu)></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Item Cost"></span> <input type=text class=login_input_new number-edit ng-model=comboEqu.baseEquCost disabled></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Worker Cost"></span> <input type=text class=login_input_new number-edit ng-model=comboEqu.baseWorkerCost disabled></div><div class="flex-25 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Type of Addings"></span><selectbox-input ng-model=comboEqu.typeAdding options=vm.typeAddings label-field=name value-field=_id on-change=calcComboEquCost(comboEqu) class=input-select></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="% Value"></span><div class="percentage-wrapper m-t-4"><input class=percentage-input type=text number-edit ng-model=comboEqu.percentage class=form-control ng-change=calcComboEquCost(comboEqu)><div class=percentage>%</div></div></div></div></div><div class="profile-card pt-24 pl-0 pr-0 pb-0"><span class="label ml-24" translate=SUMMARY></span><div class="flex flex-row mt-16 mb-24 ph-24 flex-between"><div class=flex-30><div class="flex-1 flex flex-col"><span class=ft_14_600_moreblack translate="DCQ Name"></span> <input class=login_input_new type=text ng-model=vm.comboData.name disabled></div><div class="flex-1 flex flex-row flex-between mt-16"><div class="flex-1 flex flex-col"><span class=ft_14_600_moreblack translate="Total Equipment Cost"></span><div class="static-input login_input_new">{{getTotalCost(\'equCostRate\') | readable: 2}}</div></div><div class="flex-1 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Total Worker Cost"></span><div class="static-input login_input_new">{{getTotalCost(\'workerCostRate\') | readable: 2}}</div></div></div></div><div class="flex-68 flex flex-col"><span class=ft_14_600_moreblack translate=Description></span> <textarea ng-model=vm.comboData.description class=m-t-4 rows=5 disabled></textarea></div></div><div class="dcp-table w-100 mt-32" ng-if=!vm.utils.isEmpty(comboMaterialList)><div class=thead><div class=tr><div class="td no" translate=Sr.No.></div><div class="td date" translate=Date></div><div class="td name" translate="Equipment Name"></div><div class="td mat-cost" translate="Equipment Cost"></div><div class="td worker-cost" translate="Work Cost"></div></div></div><div class=tbody><div class=tr ng-repeat="comboEqu in comboMaterialList track by $index"><div class="td no">{{$index+1}}</div><div class="td date">{{comboEqu.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td name">{{comboEqu.name}}</div><div class="td mat-cost">{{comboEqu.equCostRate | readable: 2}}</div><div class="td worker-cost">{{comboEqu.workerCostRate | readable: 2}}</div></div></div></div><div class="flex flex-row mt-32 ph-24 pb-24"><button class="btn_new_blue mr-16" ng-click=vm.createCombo()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=dcqList><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/equipments/addEquipment/addEquipment.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if="isLoading || isGetExchangeRate"></spinner><div class="add-equipment main-container"><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=equipmentList translate=Equipments></a></div><div class=ft_24_600_black1 translate="Add Equipment"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=vm.addNewEquipment()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=equipmentList><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card pt-24"><span class="label pl-24" translate="EQUIPMENT INFORMATION"></span><div class="flex flex-between ph-24 mt-16 mb-24"><div class="flex-32 flex flex-col"><span translate="Equipment Name" class="ft_14_600_moreblack required"></span> <input type=text ng-model=vm.addEquipment.name class=login_input_new></div></div><div class="flex flex-between ph-24 mb-24"><div class="flex-32 flex flex-col"><label translate="Equipment Cost"></label> <input type=text number-edit ng-model=vm.addEquipment.equipmentCost class=login_input_new></div><div class="flex-32 flex flex-col"><label translate=Currency></label><selectbox-input class=input-select ng-model=vm.addEquipment.currency options=vm.currencies label-field=cc value-field=cc select-event=onChangeCurrency()></selectbox-input></div><div class="flex-32 flex flex-col"><label translate="Equipment Group"></label><selectbox-input class=input-select ng-model=vm.addEquipment.equipmentGroupName label-field=name value-field=name options=vm.equipmentGroup></selectbox-input></div></div><div class="flex flex-between ph-24 mb-24"><div class="flex-32 flex flex-col"><label translate="Worker Cost" class=required></label> <input type=text number-edit ng-model=vm.addEquipment.rooferCost class=login_input_new></div><div class="flex-32 flex flex-col"><label translate="Responsible Worker"></label><selectbox-input class="arrowbottom_46_400 dropdown one-third input-select" ng-model=vm.addEquipment.workers options=vm.companyEmployees label-field=displayName value-field=_id></selectbox-input></div><div class="flex-32 flex flex-col"></div></div><div class="flex flex-between ph-24 mb-24"><div class="flex-32 flex flex-col"><label translate=Rental></label><selectbox-input class=input-select ng-model=vm.addEquipment.owned options=vm.chargingModeList label-field=label value-field=value></selectbox-input></div><div class="flex-32 flex flex-col"><label translate="Delivery Cost" class=required></label> <input type=text number-edit ng-model=vm.addEquipment.deliveryCost class=login_input_new></div><div class="flex-32 flex flex-col"><label translate="Charging Unit" class=required></label><selectbox-input class=input-select ng-model=vm.addEquipment.unit options=vm.unitList label-field=label value-field=value></selectbox-input></div></div></div><div class="profile-card p-24"><span class=label translate="SUPPLIER COST"></span><div class="flex flex-row flex-between mt-16"><div class="flex-32 flex flex-col"><label translate=Supplier class=required></label><selectbox-input class=input-select ng-model=vm.addEquipment.supplier options=vm.suppliers label-field=name value-field=_id></selectbox-input></div><div class="flex-32 flex flex-col"><label translate="Supplier Equipment ID"></label> <input type=text ng-model=vm.addEquipment.supplierInfo.equipmentID class=login_input_new></div><div class="flex-32 flex flex-col"><label translate="Equipment Serial No."></label> <input type=text ng-model=vm.addEquipment.supplierInfo.equipmentSN class=login_input_new></div></div></div><div class="profile-card p-24"><span class=label translate=ATTACHMENTS></span><div class="flex-items-center mt-16 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'image\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.objectUrl}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImages.splice($index, 1)"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'file\')" name=file ngf-pattern="\'.pdf,.doc,.docx,.xls,.xlsx\'" ngf-multiple=true ngf-accept="\'.pdf,.doc,.docx,.xls,.xlsx\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadFiles.splice($index, 1)"></div></div></div><div class="flex flex-row flex-content-end"><button class="btn_new_blue mr-16" ng-click=vm.addNewEquipment()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=equipmentList><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/equipments/dcqDetail/dcqDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div class="material-detail main-container" ng-if=!isLoading><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=dcqList translate=DCQ></a></div><div class=ft_24_600_black1 translate="DCQ Details"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16"><img src=/assets/icons/model-white.svg alt="" class=mr-8> <span translate="3D Viewer"></span></button> <button class="btn_new_blue client_gray_back mr-16" ui-sref="editDcq({id: vm.comboId})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=dcqList><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card p-24" id=material-information><span class=label translate="DCQ INFORMATION"></span><div class="section-body mt-16"><!-- top info --><div class="d-flex justify-content-between mb-40"><!-- image sliders --><div class=image-sliders><div class=primary-slider><div class=slider ng-if=!vm.utils.isEmpty(vm.uploadImages)><div class=flexslider><ul class=slides><li ng-repeat="f in vm.uploadImages"><img ng-src={{f.secure_url}} alt="" style="margin: auto"></li></ul></div></div><img ng-if=vm.utils.isEmpty(vm.uploadImages) class="no-img object-fit-cover" src=/assets/images/materials/noImg.jpg alt=icons></div><div ng-if="vm.uploadImages.length >= 4" class="mt-16 secondary-slider d-flex flex-column justify-content-between"><div ng-repeat="img in vm.uploadImages.slice(0, 4)"><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div><div ng-if="vm.uploadImages.length > 0 && vm.uploadImages.length < 4" class="mt-16 secondary-slider"><div ng-repeat="img in vm.uploadImages.slice(0, 4)"><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div></div><!-- basic material info --><div class=basic-info><div class="d-flex justify-content-between"><div><div class=tags><div class="tag blue" ng-if=vm.comboData.systemTag>{{ vm.comboData.systemTag }}</div></div><div class="ft_24_600_black1 mt-16 mb-2">{{ vm.comboData.name }}</div><div class="ft_14_regular_gray2 mb-16">{{ vm.comboData.createdAt | date: \'MMMM d, yyyy\' : \'UTC\' }}</div><div class=tags><span translate=OwnerShip></span>: {{vm.comboData.owned}}</div></div><div class=text-center><div class=mb-8><span class=ft_12_600_black translate=Generate>&nbsp;</span> <span class="ft_12_600_yellow cursor-point" translate="QR Code"></span></div><qr type-number=8 correction-level="\'M\'" size=96 input-mode="\'Auto\'" text="\'abc\'" image=true></qr><div class="ft_12_regular_black mt-8">ST100023146</div></div></div><div class="d-flex justify-content-between"><div class="block py-4" ng-repeat="box in boxes track by $index"><div class=symbol><img ng-src={{box.img}} alt=symbol></div><div class=ft_14_500_white>{{box.title}}</div><div class=ft_18_500_white ng-if="$index === 0 && vm.utils.unit2array(box.unit).length === 2">{{vm.utils.unit2array(box.unit)[0]}}<sup>{{vm.utils.unit2array(box.unit)[1]}}</sup></div><div class=ft_18_500_white ng-if="$index === 0 && vm.utils.unit2array(box.unit).length !== 2">{{box.unit}}</div><div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}">{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}</div><div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0 && box.baseValue" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}">{{box.baseValue | readable: 2}}&nbsp;{{box.baseCurrencyCode}}</div></div></div></div></div><!-- bottom info table --><div class=material-info-table><div class=thead><div class=tr><div class="td no" translate=Sr.No.></div><div class="td name" translate="Equipment Name"></div><div class="td unit" translate=Unit></div><div class="td material-cost" translate="Equipment Cost">({{vm.comboData.currencyCode}})</div><div class="td addition" translate="% Addition"></div><div class="td worker-cost" translate="Worker Cost">({{vm.comboData.currencyCode}})</div></div></div><div class=tbody><div class=tr ng-repeat="comboMat in vm.comboData.comboMaterialList track by $index"><div class="td no">{{$index + 1}}</div><div class="td name">{{comboMat.equipmentId.name}}</div><div class="td unit" ng-if="vm.utils.unit2array(comboMat.equipmentId.unit).length === 2">{{vm.utils.unit2array(comboMat.equipmentId.unit)[0]}}<sup>{{vm.utils.unit2array(comboMat.equipmentId.unit)[1]}}</sup></div><div class="td unit" ng-if="vm.utils.unit2array(comboMat.equipmentId.unit).length !== 2">{{comboMat.equipmentId.unit}}</div><div class="td material-cost">{{ comboMat.baseCost.equipmentCost | readable: 2 }}</div><div class="td addition"></div><div class="td worker-cost">{{ comboMat.baseCost.rooferCost | readable: 2 }}</div></div><div class=tr style="background: #E8E8E8"><div class="td no" translate=Total></div><div class="td name"></div><div class="td unit"></div><div class="td material-cost">{{ vm.comboData.totalEquipmentCost | readable: 2 }}</div><div class="td addition"></div><div class="td worker-cost">{{ vm.comboData.totalRooferCost | readable: 2 }}</div></div></div></div></div></div><div class="profile-card p-24 mt-24" id=material-attachments><span class=label translate=ATTACHMENTS></span><div class=section-body><div class="flex-items-center mt-16 mb-16" ng-if=vm.uploadImages.length><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=images ng-if=vm.uploadImages.length><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.secure_url}} alt=thumbnail ng-click=showImage(file.secure_url)><div class=file-name>{{file.name }}</div></div></div><div class="flex-items-center mt-24 mb-16" ng-if=vm.uploadFiles.length><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=images ng-if=vm.uploadFiles.length><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt="" ng-click=vm.utils.downloadFile(file.secure_url)><div class=file-name>{{file.originalname }}</div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/equipments/dcqList/dcqList.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=dcqList class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class=ft_14_600_black translate=Equipments></a></div><div class=ft_24_600_black1 translate=DCQ></div></div><div class="ml-auto flex flex-row flex-items-center"><selectbox class="arrowbottom_46_400 mr-4" ng-model=vm.sortMenuCombo options=vm.sortMenuComboEquipmentList label-field=label value-field=key select-event=vm.sortComboEquipments() is-small=true></selectbox><searchbox input-class=mr-20 search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><div class=flex-items-center><button class="btn-trans ml-16" ng-click=switchViewMode(false)><img ng-src="{{isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\'}}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click=switchViewMode(true)><img ng-src="{{isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\'}}" alt=icons class=margin-0></button></div><button class="btn_new_blue ml-16" ui-sref=addDcq ng-if="EQ_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Add DCQ"></span></button></div></div><div><div class=header><button class=btn_nav_inactive ui-sref=equipmentList translate=Equipments></button> <button class=btn_nav_active translate=DCQ></button></div><no-data ng-if="isLoading == false && totalCount==0"></no-data><div ng-if="totalCount!=0"><div class="card-based-content-grid-wrapper pl-12 pr-12 pv-24 dcq-wrapper flex flex-wrap" ng-if=isGrid><div class="quotes-wrapper flex flex-wrap"><div class=inventory-card-container ng-repeat="item in combos" ng-show="combos.length != 0"><inventory-card class=d-block item-data=item type="\'comboEqu\'" currency-symbol=getCurrencySymbol(item)></inventory-card></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + combos.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.sortComboEquipments()></pagination-custom-new></div></div></div></div><div class=mt-0 ng-if=!isGrid><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=ft_14_600_gray><span translate="DCQ Name"></span> <img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th></th><th class=ft_14_600_gray><span translate="DCQ Tag"></span> <img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class=ft_14_600_gray><span translate="Equipment Cost"></span> <img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class=ft_14_600_gray><span translate="Worker Cost"></span> <img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, item) in combos" class=cursor-point ui-sref="dcqDetail({id: item._id})"><td class="text-center avatar-cell"><img ng-src="{{ item.designImage ? item.designImage.secure_url : item.files.images[0].secure_url ||\n                      \'/assets/images/materials/noImg.jpg\'}}" class="avatar-60 object-fit-cover"></td><td class="name-wrapper list"><div class="ft_16_600_black tx-ellipsis name" title={{item.name}} ng-bind=item.name></div><div ng-bind="item.createdAt | date: \'d MMM, yyyy\' : \'UTC\'"></div></td><td class=tx-ellipsis ng-bind=item.systemTag></td><td>{{getCurrencySymbol(item)}}&nbsp;{{item.totalEquipmentCost | readable: 2}}</td><td>{{getCurrencySymbol(item)}}&nbsp;{{item.totalRooferCost | readable: 2}}</td><td class=more><img src=/assets/images/suppliers/more_horiz.svg alt=icons class=margin-0></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + combos.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.sortComboEquipments()></pagination-custom-new></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/equipments/editDcq/editDcq.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div class="add-dcq main-container"><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=dcqList translate=DCQ></a></div><div class=ft_24_600_black1 translate="Edit DCQ"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=vm.updateCombo()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref="dcqDetail({id: vm.comboId})"><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card pt-24"><span class="label pl-24" translate="DCQ INFORMATION"></span><div class="flex flex-row mt-16 mb-24"><div class="flex-29 flex flex-col"><div class="flex-1 flex flex-col"><span translate="DCQ Name" class="ft_14_600_moreblack required"></span> <input type=text ng-model=vm.comboData.name class=login_input_new></div><div class="flex flex-col flex-50"><span translate=Unit class="ft_14_600_moreblack required"></span><selectbox-input class=input-select options=vm.mUnits label-field=name value-field=value ng-model=vm.comboData.unit></selectbox-input></div></div><div class="flex-69 flex flex-col ml-24"><span translate=Description class=ft_14_600_moreblack></span> <textarea type=text ng-model=vm.comboData.description placeholder="Write some description (optional)" rows=6></textarea></div></div></div><div class=profile-card><span class=label translate=ATTACHMENTS></span><div class="flex-items-center mt-16 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'image\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src="{{file.objectUrl || file.secure_url}}" alt=""><div class=file-name>{{file.name || file.orignialname}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImages.splice($index, 1)"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'file\')" name=file ngf-pattern="\'.pdf,.doc,.docx,.xls,.xlsx\'" ngf-multiple=true ngf-accept="\'.pdf,.doc,.docx,.xls,.xlsx\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=file-name>{{file.name || file.originalname}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadFiles.splice($index, 1)"></div></div></div></div><div class=profile-card><span class=label translate=COMBINATION></span><div class="flex flex-row mt-16 mb-24"><div class="flex-30 flex flex-col"><span translate="Equipment list" class=ft_14_600_moreblack></span><selectbox-input class=input-select options=vm.equList label-field=name value-field=_id ng-model=comboEqu.equId select-event=onChangeEqu(comboEqu)></selectbox-input></div><div class="flex-10 flex flex-end ml-24"><button class="btn_new_blue m-t-4" ng-click=addEquipment()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div class="d-flex w-100 flex-wrap mb-24" ng-if=!vm.utils.isEmpty(comboMaterialList)><div class=material ng-repeat="mat in comboMaterialList track by $index"><div class="ft_14_regular_black mr-8">{{mat.name}}</div><img src=/assets/icons/close-16.svg alt=close class=cursor-point ng-click="removeEquipment($index, equ.equId)"></div></div><div class="flex flex-row"><div class="flex-18 flex flex-col"><span class=ft_14_600_moreblack translate=Quantity></span> <input type=text class=login_input_new number-edit ng-model=comboEqu.quantity ng-change=calcComboEquCost(comboEqu)></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Item Cost"></span> <input type=text class=login_input_new number-edit ng-model=comboEqu.baseEquCost disabled></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Worker Cost"></span> <input type=text class=login_input_new number-edit ng-model=comboEqu.baseWorkerCost disabled></div><div class="flex-25 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Type of Addings"></span><selectbox-input ng-model=comboEqu.typeAdding options=vm.typeAddings label-field=name value-field=_id on-change=calcComboEquCost(comboEqu) class=input-select></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="% Value"></span><div class="percentage-wrapper m-t-4"><input class=percentage-input type=text number-edit ng-model=comboEqu.percentage class=form-control ng-change=calcComboEquCost(comboEqu)><div class=percentage>%</div></div></div></div></div><div class="profile-card pt-24 pl-0 pr-0 pb-0"><span class="label ml-24" translate=SUMMARY></span><div class="flex flex-row mt-16 mb-24 ph-24 flex-between"><div class=flex-30><div class="flex-1 flex flex-col"><span class=ft_14_600_moreblack translate="DCQ Name"></span> <input class=login_input_new type=text ng-model=vm.comboData.name disabled></div><div class="flex-1 flex flex-row flex-between mt-16"><div class="flex-1 flex flex-col"><span class=ft_14_600_moreblack translate="Total Equipment Cost"></span><div class="static-input login_input_new">{{getTotalCost(\'equCostRate\') | readable: 2}}</div></div><div class="flex-1 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Total Worker Cost"></span><div class="static-input login_input_new">{{getTotalCost(\'workerCostRate\') | readable: 2}}</div></div></div></div><div class="flex-68 flex flex-col"><span class=ft_14_600_moreblack translate=Description></span> <textarea ng-model=vm.comboData.description class=m-t-4 rows=5 disabled></textarea></div></div><div class="dcp-table w-100 mt-32" ng-if=!vm.utils.isEmpty(comboMaterialList)><div class=thead><div class=tr><div class="td no" translate=Sr.No.></div><div class="td date" translate=Date></div><div class="td name" translate="Equipment Name"></div><div class="td mat-cost" translate="Equipment Cost"></div><div class="td worker-cost" translate="Work Cost"></div></div></div><div class=tbody><div class=tr ng-repeat="comboMat in comboMaterialList track by $index"><div class="td no">{{$index+1}}</div><div class="td date">{{comboEqu.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td name">{{comboEqu.name}}</div><div class="td mat-cost">{{comboEqu.equCostRate | readable: 2}}</div><div class="td worker-cost">{{comboEqu.workerCostRate | readable: 2}}</div></div></div></div><div class="flex flex-row mt-32 ph-24 pb-24"><button class="btn_new_blue mr-16" ng-click=vm.updateCombo()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref="dcqDetail({id: vm.comboId})"><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div></div></div></main>');
$templateCache.put('app/main/equipments/editEquipment/editEquipment.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if="isLoading || isGetExchangeRate"></spinner><div class="add-equipment main-container"><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=equipmentList translate=Equipments></a></div><div class=ft_24_600_black1 translate="Edit Equipment"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=vm.updateEquipment()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class="btn_light_gray client_gray_white_back" ui-sref="equipmentDetail({id: vm.equipmentId})"><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card p-24"><span class="label pl-24" translate="EQUIPMENT INFORMATION"></span><div class="flex flex-between mt-16 mb-24"><div class="flex-32 flex flex-col"><span translate="Equipment Name" class="ft_14_600_moreblack required"></span> <input type=text ng-model=vm.editEquipment.name class=login_input_new></div></div><div class="flex flex-between mb-24"><div class="flex-32 flex flex-col"><label translate="Rental Cost"></label> <input type=text number-edit ng-model=vm.editEquipment.equipmentCost class=login_input_new></div><div class="flex-32 flex flex-col"><label translate=Currency></label><selectbox-input class=input-select ng-model=vm.editEquipment.currency options=vm.currencies label-field=cc value-field=cc select-event=onChangeCurrency()></selectbox-input></div><div class="flex-32 flex flex-col"><label translate="Equipment Group"></label><selectbox-input class=input-select ng-model=vm.editEquipment.equipmentGroupName label-field=name value-field=name options=vm.equipmentGroup></selectbox-input></div></div><div class="flex flex-between mb-24"><div class="flex-32 flex flex-col"><label translate="Worker Cost" class=required></label> <input type=text number-edit ng-model=vm.editEquipment.rooferCost class=login_input_new></div><div class="flex-32 flex flex-col"><label translate="Responsible Worker"></label><selectbox-input class="arrowbottom_46_400 dropdown one-third input-select" ng-model=vm.workers options=vm.employees label-field=displayName value-field=_id></selectbox-input></div><div class="flex-32 flex flex-col"></div></div><div class="flex flex-between mb-24"><div class="flex-32 flex flex-col"><label translate=Rental></label><selectbox-input class=input-select ng-model=vm.editEquipment.owned options=vm.chargingModeList label-field=label value-field=value></selectbox-input></div><div class="flex-32 flex flex-col justify-content-between"><label translate="Delivery Cost" class=required></label> <input type=text number-edit ng-model=vm.editEquipment.deliveryCost class="input-select login_input_new"></div><div class="flex-32 flex flex-col"><label translate="Charging Unit" class=required></label><selectbox-input class=input-select ng-model=vm.editEquipment.unit options=vm.unitList label-field=label value-field=value></selectbox-input></div></div></div><div class="profile-card p-24"><span class=label translate="SUPPLIER COST"></span><div class="flex flex-row flex-between mt-16"><div class="flex-32 flex flex-col"><label translate=Supplier class=required></label><selectbox-input class=input-select ng-model=vm.editEquipment.supplier options=vm.suppliers label-field=name value-field=_id></selectbox-input></div><div class="flex-32 flex flex-col"><label translate="Supplier Equipment ID"></label> <input type=text ng-model=vm.editEquipment.supplierInfo.equipmentID class=login_input_new></div><div class="flex-32 flex flex-col"><label translate="Equipment Serial No."></label> <input type=text ng-model=vm.editEquipment.supplierInfo.equipmentSN class=login_input_new></div></div></div><div class="profile-card p-24"><span class=label translate=ATTACHMENTS></span><div class="flex-items-center mt-16 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ng-model=vm.inputImg ngf-change="fileUpdated($files, \'image\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src="{{file.objectUrl || file.secure_url}}" alt=""><div class=file-name>{{file.name || file.originalname}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImages.splice($index, 1)"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ng-model=vm.inputFiles ngf-change="fileUpdated($files, \'file\')" name=file ngf-pattern="\'.pdf,.doc,.docx,.xls,.xlsx\'" ngf-multiple=true ngf-accept="\'.pdf,.doc,.docx,.xls,.xlsx\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=file-name>{{file.name || file.originalname}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadFiles.splice($index, 1)"></div></div></div><div class="flex flex-row flex-content-end"><button class="btn_new_blue mr-16" ng-click=vm.updateEquipment()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class="btn_light_gray client_gray_white_back" ui-sref="equipmentDetail({id: vm.equipmentId})"><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div></div></div></main>');
$templateCache.put('app/main/equipments/equipmentDetail/equipmentDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div class="equipment-detail main-container" ng-if=!isLoading><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=equipmentList translate=Equipments></a></div><div class=ft_24_600_black1 translate="Equipment Details"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16"><img src=/assets/icons/model-white.svg alt="" class=mr-8 width=15> <span translate="3D Viewer"></span></button> <button class="btn_new_blue client_gray_back mr-16" ui-sref="editEquipment({id: vm.equipmentId})"><img src=/assets/icons/bx-edit-white.svg alt=icons class=mr-8 width=15><span translate=Edit></span></button> <button class="btn_light_gray client_gray_white_back" ui-sref=equipmentList><img src=/assets/icons/close-circle-black.svg alt=icons class=mr-8 width=15><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card p-24" id=material-information><span class=label translate="EQUIPMENT INFORMATION"></span><div class="section-body mt-16"><!-- top info --><div class="d-flex justify-content-between mb-40"><!-- image sliders --><div class=image-sliders><div class=primary-slider><div class=slider ng-if=!vm.utils.isEmpty(vm.uploadImages)><div class=flexslider><ul class=slides><li ng-repeat="f in vm.uploadImages"><img ng-src={{f.secure_url}} alt="" style="margin: auto"></li></ul></div></div><img ng-if=vm.utils.isEmpty(vm.uploadImages) class="no-img object-fit-cover" src=/assets/images/materials/noImg.jpg alt=icons></div><div ng-if="vm.uploadImages.length >= 4" class="mt-16 secondary-slider d-flex flex-column justify-content-between"><div ng-repeat="img in vm.uploadImages.slice(0, 4)"><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div><div ng-if="vm.uploadImages.length > 0 && vm.uploadImages.length < 4" class="mt-16 secondary-slider"><div ng-repeat="img in vm.uploadImages.slice(0, 4)"><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div></div><!-- basic material info --><div class=basic-info><div class="d-flex justify-content-between"><div><div class=tags><div class="tag blue" ng-if=vm.material.systemTag>{{ vm.equipment.systemTag }}</div></div><div class="ft_24_600_black1 mt-16 mb-2">{{ vm.equipment.name }}</div><div class="ft_14_regular_gray2 mb-16">{{ vm.equipment.createdAt | date: \'MMMM d, yyyy\' : \'UTC\' }}</div><div class=tags><div class="tag dark-blue"><span translate=OwnerShip></span>: {{vm.equipment.owned}}</div></div></div><div class=text-center><div class=mb-8><span class=ft_12_600_black translate=Generate>&nbsp;</span> <span class="ft_12_600_yellow cursor-point" translate="QR Code"></span></div><qr type-number=8 correction-level="\'M\'" size=96 input-mode="\'Auto\'" text="\'abc\'" image=true></qr><div class="ft_12_regular_black mt-8">ST100023146</div></div></div><div class="d-flex justify-content-between"><div class="block py-4" ng-repeat="box in boxes track by $index"><div class=symbol><img ng-src={{box.img}} alt=symbol></div><div class=ft_14_500_white>{{box.title}}</div><div class=ft_18_500_white ng-if="$index === 0 && vm.utils.unit2array(box.unit).length === 2">{{vm.utils.unit2array(box.unit)[0]}}<sup>{{vm.utils.unit2array(box.unit)[1]}}</sup></div><div class=ft_18_500_white ng-if="$index === 0 && vm.utils.unit2array(box.unit).length !== 2">{{box.unit}}</div><div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}">{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}</div><div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0 && box.baseValue" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}">{{box.baseValue | readable: 2}}&nbsp;{{box.baseCurrencyCode}}</div></div></div></div></div><!-- bottom info table --><div class=material-info-table><div class=thead><div class=tr><div class="td no" translate=Sr.No.></div><div class="td name" translate="Equipment Name"></div><div class="td unit" translate="Charging Unit"></div><div class="td material-cost" translate="Rental Cost">({{vm.equipment.baseRate.currencyCode}})</div><div class="td addition" translate="% Addition"></div><div class="td worker-cost" translate="Worker Cost">({{vm.equipment.baseRate.currencyCode}})</div></div></div><div class=tbody><div class=tr><div class="td no">1</div><div class="td name">{{vm.equipment.name}}</div><div class="td unit" ng-if="vm.utils.unit2array(vm.equipment.unit).length === 2">{{vm.utils.unit2array(vm.equipment.unit)[0]}}<sup>{{vm.utils.unit2array(vm.equipment.unit)[1]}}</sup></div><div class="td unit" ng-if="vm.utils.unit2array(vm.equipment.unit).length !== 2">{{vm.equipment.unit}}</div><div class="td material-cost">{{ vm.equipment.baseRate.equipmentCost | readable: 2 }}</div><div class="td addition"></div><div class="td worker-cost">{{ vm.equipment.baseRate.rooferCost | readable: 2 }}</div></div><div class=tr style="background: #E8E8E8"><div class="td no" translate=Total></div><div class="td name"></div><div class="td unit"></div><div class="td material-cost">{{ vm.equipment.baseRate.equipmentCost | readable: 2 }}</div><div class="td addition"></div><div class="td worker-cost">{{ vm.equipment.baseRate.rooferCost | readable: 2 }}</div></div></div></div></div></div><div class="profile-card p-24 mt-24" id=material-attachments><span class=label translate=ATTACHMENTS></span><div class=section-body><div class="flex-items-center mt-16 mb-16" ng-if=vm.uploadImages.length><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.secure_url}} alt=thumbnail ng-click=showImage(file.secure_url)><div class=file-name>{{file.name }}</div></div></div><div class="flex-items-center mt-24 mb-16" ng-if=vm.uploadFiles.length><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt="" ng-click=vm.utils.downloadFile(file.secure_url)><div class=file-name>{{file.originalname }}</div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/equipments/equipmentList/equipmentList.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=equipmentList class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Equipments ng-if="!(vm.isViewGroupList || vm.isViewGroupDetail)"></a> <a ng-click=vm.showAllList() class="ft-normal-12-16 grey-2 cursor-point" translate=Equipments ng-if="vm.isViewGroupList || vm.isViewGroupDetail"></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons ng-if="vm.isViewGroupList || vm.isViewGroupDetail"> <a class="ft-normal-12-16 grey-2" translate=Groups ng-if=vm.isViewGroupList></a> <a ng-click="vm.isViewGroupList = true; vm.isViewGroupDetail = false" class="ft_14_regular_gray cursor-point" translate=Groups ng-if=vm.isViewGroupDetail></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons ng-if=vm.isViewGroupDetail> <a class="ft-normal-12-16 grey-2" ng-if=vm.isViewGroupDetail>{{vm.selectedGroupName}}</a></div><div class=ft_24_600_black1 translate=Equipments></div></div><div class="ml-auto flex flex-row flex-items-center"><selectbox class=arrowbottom_46_400 ng-model=vm.category options=vm.groupCategories label-field=label value-field=key select-event=vm.changedCategory() is-small=true input-class=mr-4></selectbox><selectbox class=arrowbottom_46_400 ng-model=vm.sortMenu options=vm.sortMenuList label-field=label value-field=key select-event=vm.sortEquipments() is-small=true input-class=mr-4></selectbox><div class="w-100 flex-between" ng-if=!vm.isViewGroupList><searchbox search-text=vm.searchText search-event=searchCallback() ng-if=!vm.isViewGroupList is-small=true input-class="w-180 mr-3"></searchbox><div class=flex-items-center><button class="btn-trans ml-16" ng-click=switchViewMode(false)><img ng-src="{{isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\'}}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click=switchViewMode(true)><img ng-src="{{isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\'}}" alt=icons class=margin-0></button></div><button class="btn_new_blue ml-16" ui-sref=addEquipment ng-if="EQ_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Add Equipment"></span></button></div></div></div><div><div class=header><button class=btn_nav_active translate=Equipments></button> <button class=btn_nav_inactive ui-sref=dcqList translate=DCQ></button></div><no-data ng-if="isLoading == false && totalCount==0 && !vm.isViewGroupList"></no-data><div><div class=mt-0 ng-if=vm.isViewGroupList><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class="text-center avatar-cell"></th><th class="name-wrapper list ft_14_600_black"><span translate=Name></span><img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class=ft_14_600_black><span translate=Count></span><img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class=ft_14_600_black><span translate="Created At"></span><img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class=ft_14_600_black><span translate="Updated At"></span><img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, item) in vm.equipmentGroup" ng-click=vm.showEquipmentByGroup(item._id)><td class="text-center avatar-cell"></td><td class="name-wrapper list"><div class="ft_16_600_black tx-ellipsis name" ng-bind=item.name></div></td><td class=tx-ellipsis ng-bind=item.count></td><td>{{item.createdAt | date}}</td><td>{{item.updatedAt | date}}</td><td class=more><img src=/assets/images/suppliers/more_horiz.svg alt=icons class=margin-0></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.equipmentGroup.length}}</span> of {{totalCountForGroup}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPagesForGroup current-page=vm.currentPage on-select-page=vm.sortEquipments()></pagination-custom-new></div></div></div></div></div><div ng-if="totalCount!=0"><div class="card-based-content-grid-wrapper pr-24 pv-24" ng-if="isGrid && !vm.isViewGroupList"><div class="quotes-wrapper flex flex-wrap"><div class=profile-card-container ng-repeat="equipment in equipments"><div class=profile-card ui-sref="equipmentDetail({id: equipment._id})"><div class=card-image><img class=object-fit-cover ng-src="{{ equipment.files.images[0].url || \'/assets/images/materials/noImg.jpg\'}}" alt=icons> <img src=/assets/icons/qr-code.svg class=qr-code></div><div class=detail-wrapper><div class=detail><div class="d-flex align-items-center flex-between"><div class="tag fore-blue">{{equipment.systemTag}}</div><div class="tag back-blue"><span translate="Worker Id"></span>: NR.99</div></div><p class="name ft_16_600_black">{{ equipment.name }}</p><!-- <div class="flex-items-center">\n                      <div><img class="location-icon" src="/assets/icons/location_gray.svg" alt="icons"/></div>\n                      <div>\n                        <p class="ft_12_regular_gray mb-0 location" ng-if="equipment.workers.length">\n                          {{ equipment.workers[0].address1.line1 }},&nbsp;{{ equipment.workers[0].address1.city }}\n                        </p>\n                        <p class="ft_12_regular_gray mb-0 location" ng-if="!equipment.workers.length" translate="No address"></p>\n                      </div>\n                    </div> --></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + equipments.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.sortEquipments()></pagination-custom-new></div></div></div></div><div class=mt-0 ng-if="!isGrid && !vm.isViewGroupList"><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox><span class=checkmark ng-click=setAllChecked()></span></label></th><th class="text-center avatar-cell"></th><th class="name-wrapper list ft_14_600_black"><span translate="Equipment Name"></span><img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class="tx-ellipsis ft_14_600_black"><span translate="Equipment Tag"></span><img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class=ft_14_600_black><span translate="Worker ID"></span><img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class="tx-ellipsis ft_14_600_black"><span translate="Equipment Cost"></span><img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th class="tx-ellipsis ft_14_600_black"><span translate="Worker Cost"></span><img src=/assets/images/suppliers/arrow_drop_down.svg alt=icons class=margin-0></th><th></th><th></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, item) in equipments"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=item.checked><span class=checkmark></span></label></td><td class="text-center avatar-cell"><img ng-src="{{ item.files.images[0].url || \'/assets/images/materials/noImg.jpg\'}}" alt=icons class="avatar-60 object-fit-cover"></td><td class="name-wrapper list"><div class="ft_16_600_black tx-ellipsis name" ng-bind=item.name></div><div ng-bind="item.created | date: \'MMM d, yyyy\' : \'UTC\'"></div></td><td class=tx-ellipsis ng-bind=item.systemTag></td><td>NR.99</td><td class=tx-ellipsis>{{getCurrencySymbol(item)}}&nbsp;{{item.currentRate.equipmentCost.value | readable:2}}</td><td class=tx-ellipsis>{{getCurrencySymbol(item)}}{{item.currentRate.rooferCost.value | readable:2}}</td><td></td><td class="more flex-items-center"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class="margin-0 cursor-point"></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + equipments.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.sortEquipments()></pagination-custom-new></div></div></div></div></div></div></div></main><!--Upload excel model--><div class="modal fade p-0 m-0" id=uploadEqModal tabindex=-1 role=dialog><div><div class="modal-content modal-content-one"><div class=title-black><div class="r_fsize262209 fw-bold" translate="Import Equipment"></div></div><div class=modal-body><a href=https://res.cloudinary.com/dktnhmsjx/raw/upload/v1548924927/equipments_xiyjzn.xlsx class="view_image r_fsize231808 fw-medium c-d1" data-popup=true target=_blank rel=noopener translate="download template"><br></a><br><div class="btn btn-warning r_fsize231808 fw-medium c-d1" type=file ngf-select ng-model=vm.inputExcel name=file ngf-accept="\'.xlsx\'" ngf-multiple=false ngf-max-size=20MB translate=Browse ngf-pattern="\'.xlsx, application/vnd.ms-excel, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'"></div><label class="r_fsize231808 fw-medium c-d1">&nbsp;&nbsp; {{ vm.inputExcel.name }}</label> <button class="btn btn-primary r_fsize231808 fw-medium text-white" ng-if=vm.inputExcel ng-click=upLoadEQExcelFile(vm.inputExcel) translate=upload></button></div></div></div></div>');
$templateCache.put('app/main/fileManage/fileManageList/fileManageList.view.html','<div id=fileManageGrid class=d-flex><spinner ng-show=loading></spinner><div class=table-content><div class="fm_operator_bar flex"><div class="nav-arrow d-flex align-items-center"><a class=cursor-point><img src=/assets/icons/fm_left_arrow.svg ng-click=vm.goPrev()></a><a class=cursor-point><img src=/assets/icons/fm_right_arrow.svg ng-click=vm.goNext()></a><span class="folder-name ml-4" translate={{vm.getTitleStr()}}></span></div></div><div class=divider></div><div class="fm_operator_bar flex-between"><div class=operator-items-wrapper><div class="operator-button mr-8" ng-click=vm.openFileUploadModal()><img src=/assets/icons/bx-Upload-button.svg class=mr-2 alt=""><span translate=Upload></span></div><div class="operator-button-gray mr-8" ng-click=vm.addFolder()><img src=/assets/icons/add-button.svg class=mr-2 alt=""><span translate=Create></span></div><div class=dropdown><div class="operator-button-expand ft_12_regular_black" id=more_menu data-toggle=dropdown><img src=/assets/icons/more_horiz_dot.svg alt=""></div><ul class=dropdown-menu role=menu aria-labelledby=more_menu><li><!-- <a class="operator-item" ng-click="vm.downloadFiles()" ng-if="isSelectedFile() && !isAvailablePaste()"> --> <a class=operator-item ng-click=vm.downloadFiles()><img src=/assets/icons/fm_download.svg alt=""><span translate=Download></span></a></li><li><!-- <a class="operator-item" ng-click="vm.clipboard(1)" ng-if="isSelectedItem() && !isAvailablePaste() && isValidSelects() && FMANAGER_ACCESS_CREATE > 1"> --> <a class=operator-item ng-click=vm.clipboard(1)><img src=/assets/icons/fm_move_new.svg alt=""><span translate=Move></span></a></li><li><!-- <a class="operator-item" ng-click="vm.clipboard(0)" ng-if="isSelectedItem() && !isAvailablePaste() && isValidSelects() && FMANAGER_ACCESS_CREATE > 1"> --> <a class=operator-item ng-click=vm.clipboard(0)><img src=/assets/icons/fm_copy_new.svg alt=""><span translate=Copy></span></a></li><li><!-- <a class="operator-item" ng-click="vm.rename()" ng-if="isOneSelectedItem() && !isAvailablePaste() && isValidSelects() && FMANAGER_ACCESS_CREATE > 1"> --> <a class=operator-item ng-click=vm.rename()><img src=/assets/icons/fm_rename_new.svg alt=""><span translate=Rename></span></a></li><li><!-- <a class="operator-item" ng-click="vm.deleteItems()" ng-if="isSelectedItem() && !isAvailablePaste() && isValidSelects(true) && FMANAGER_ACCESS_CREATE > 3"> --> <a class=operator-item ng-click=vm.deleteItems()><img src=/assets/icons/fm_trash_new.svg alt=""><span translate=Delete></span></a></li><!-- <li>\n              <a class="operator-item" ng-click="vm.permissionItems()" ng-if="isSelectedItem() && !isAvailablePaste() && isValidSelects(true) && FMANAGER_ACCESS_CREATE > 3">\n                <img src="/assets/icons/fm-action-access.svg" alt=""/>\n                <span translate="Permission"></span>\n              </a>\n            </li> --><li ng-if=vm.isCopyMove><!-- <a class="operator-item" ng-click="vm.paste()" ng-if="isAvailablePaste()"> --> <a class=operator-item ng-click=vm.paste()><img src=/assets/icons/fm_copy_outline.svg alt=""><span translate=Paste></span></a></li><li ng-if=vm.isCopyMove><!-- <a class="operator-item" ng-click="vm.cancelPaste()" ng-if="isAvailablePaste()"> --> <a class=operator-item ng-click=vm.cancelPaste()><img src=/assets/icons/fm_cancel.svg alt=""><span translate=Cancel></span></a></li><li><a class=operator-item ng-click=vm.rewindFolder()><img src=/assets/icons/fm_rewind_new.svg alt=""><span translate="Rewind this folder"></span></a></li><li><a class=operator-item><img src=/assets/icons/fm_request_files_new.svg alt=""><span translate="Request Files"></span></a></li><li><a class=operator-item ng-click=vm.starItems()><img src=/assets/icons/fm_star_new.svg alt=""><span translate=Star></span></a></li><li><a class=operator-item ng-click=vm.shareFiles() ng-if="isSelectedItem() && !isAvailablePaste()"><img src=/assets/icons/fm_share_outline.svg class=share-img alt=""><span translate=Share></span></a></li><!-- <li>\n              <a class="operator-item" ng-click="vm.moveTo()" ng-if="isSelectedItem() && !isAvailablePaste() && isValidSelects() && FMANAGER_ACCESS_CREATE > 1">\n                <img src="/assets/icons/fm_moveto.svg" alt=""/>\n                <span translate="Move to"></span>\n              </a>\n            </li> --></ul></div></div><div class=search-box-block><searchbox input-class=fm-searchbox search-event=searchCallback() place-holder=Search search-text=searchText></searchbox><img src=/assets/icons/bx-menu-default.svg class=ml-8 alt=icons></div></div><div class=table-content-wrapper ng-if=!vm.isVersionView><div class=table-content-in><div class="flex t-header"><div class="td-content fm-menu"></div><div class="td-content fm-checkbox"><checkbox ng-model=vm.selectedAll ng-click=vm.selectAll() is-small=true></div><div class="td-content name"><button class="btn-trans flex-center ft_12_600_dark" ng-click=sortItems(0)><span translate=Name></span>&nbsp;<img ng-src={{getSortIcon(0)}} alt=icons></button></div><!-- <div class="td-content type">\n            <button class="btn-trans flex-center ft_12_regular_light" ng-click="sortItems(1)">\n              <span translate="Type"></span>&nbsp;<img ng-src="{{getSortIcon(1)}}" alt="icons"/>\n            </button>\n          </div> --><!-- <div class="td-content level">\n            <button class="btn-trans flex-center ft_12_600_dark" ng-click="sortItems(2)">\n              <span translate="Level"></span> <img ng-src="{{getSortIcon(2)}}" alt="icons"/>\n            </button>\n          </div> --><div class="td-content fm-star"></div><!-- <div class="td-content app">\n            <button class="btn-trans flex-center ft_12_regular_light" ng-click="sortItems(3)">\n              <span translate="App"></span> <img ng-src="{{getSortIcon(3)}}" alt="icons"/>\n            </button>\n          </div>\n          <div class="td-content qshe">\n            <button class="btn-trans flex-center ft_12_regular_light" ng-click="sortItems(4)">\n              <span translate="QSHE"></span> <img ng-src="{{getSortIcon(4)}}" alt="icons"/>\n            </button>\n          </div> --><div class="td-content modified"><button class="btn-trans flex-center ft_12_600_dark" ng-click=sortItems(5)><span translate=Modified></span><!-- <img ng-src="{{getSortIcon(5)}}" alt="icons"/> --></button></div><!-- <div class="td-content status">\n            <button class="btn-trans flex-center ft_12_600_dark w-100" ng-click="sortItems(6)">\n              <span translate="Access"></span> <img ng-src="{{getSortIcon(6)}}" alt="icons"/>\n            </button>\n          </div> --><div class="td-content status"><button class="btn-trans flex-center ft_12_600_dark" ng-click=sortItems(6)><span translate=Members></span><!-- <img ng-src="{{getSortIcon(6)}}" alt="icons"/> --></button></div><div class="td-content actions"><button class="btn-trans flex-center ft_12_600_dark w-100" ng-click=sortItems(7)><span translate=""></span><!-- <img ng-src="{{getSortIcon(7)}}" alt="icons"/> --></button></div></div><div class=list-table-body><div ng-class="{item: true, active: folder._id === vm.selectedData._id}" ng-repeat="folder in vm.currentFilteredFolders track by $index" ref=drop-zone ref-id={{folder._id}}><div class="td-content fm-menu"><!-- <img src="/assets/icons/drag_indicator.svg" alt="icons" /> --></div><div class="td-content fm-checkbox"><checkbox ng-model=folder.selected ng-click=selectFolder(folder) is-small=true></checkbox></div><div class="td-content name" ng-click=vm.previewFolder(folder) ng-dblclick=vm.showChildHierarchy(folder)><div class="flex-items-center ft_12_regular_black cursor-point w-100" ref=drop-zone ref-id={{folder._id}}><img src=/assets/icons/fm_folder_icon.svg alt=icons> <span title={{folder.name}} ref=drop-zone ref-id={{folder._id}}>{{folder.name}}</span></div></div><!-- <div class="td-content type" translate="File Folder"></div> --><!-- <div class="td-content level"></div> --><div class="td-content fm-star" ng-click=vm.starFolders(folder._id)><img ng-if=!folder.star style="filter: invert(72%) sepia(63%) saturate(6022%) hue-rotate(177deg) brightness(98%) contrast(93%)" src=/assets/icons/star-16-outline.svg alt=icons> <img ng-if=folder.star src=/assets/icons/star-blue.svg alt=icons></div><!-- <div class="td-content app">\n              <checkbox ng-model="folder.app" is-small="true" ng-click="vm.checkApp(folder, true)"></checkbox>\n            </div>\n            <div class="td-content qshe">\n              <checkbox ng-model="folder.qshe" is-small="true" ng-click="vm.checkQshe(folder, true)"></checkbox>\n            </div> --><!-- <div class="td-content modified">{{folder.updatedAt | date : \'dd/MM/yyyy h:mm a\'}}</div> --><div class="td-content modified">--</div><!-- <div class="td-content status">\n              <div ng-if="folder.userId._id === vm.userData._id" class="approve-status owner" translate="Owner"></div>\n              <div ng-if="folder.userId._id !== vm.userData._id">\n                <div ng-if="folder.permission && folder.permission.approval === \'Approved\'" class="approve-status approved" translate="Approved"></div>\n                <div ng-if="folder.permission && folder.permission.approval === \'Pending\'" class="approve-status pending" translate="Pending"></div>\n                <div ng-if="folder.permission && folder.permission.approval === \'Declined\'" class="approve-status declined" translate="Declined"></div>\n              </div>\n            </div> --><div class="td-content status" ng-class="{\'empty\': !folder.members.length}"><div ng-if="folder.userId._id !== vm.userData._id" class="approve-status owner" translate="{{!folder.members.length ? \'\' : folder.members.length + \' members\'}}" ng-click="showFolderMembers($event, folder._id)"></div><div ng-if="folder.userId._id === vm.userData._id" class="approve-status owner" translate="{{!folder.members.length ? \'Only You\' : folder.members.length + \' members\'}}" ng-click="showFolderMembers($event, folder._id)"></div><div class=expand-members id=members-group-{{folder._id}}><div class=assigned-member ng-repeat="member in folder.members track by $index"><div class="left flex-items-center"><img ng-if=member.profilePic class=user-avatar ng-src={{member.profilePic}} alt=""><div class=profile-pic ng-if=!member.profilePic data-letters={{nameLetter(member)}} ng-style="{ \'background\': getColor(member.displayName) }"></div><div class=ft_12_regular_gray>{{member.name || member.displayName}}</div></div></div></div><!--\n              <div ng-if="folder.userId._id !== vm.userData._id">\n                <div ng-if="folder.permission && folder.permission.approval === \'Approved\'" class="approve-status approved" translate="Approved"></div>\n                <div ng-if="folder.permission && folder.permission.approval === \'Pending\'" class="approve-status pending" translate="Pending"></div>\n                <div ng-if="folder.permission && folder.permission.approval === \'Declined\'" class="approve-status declined" translate="Declined"></div>\n              </div> --></div><div class="td-content actions"><div class=action-download></div><img class=action-expand src=/assets/icons/more_horiz_default.svg alt=icons ng-click="showPopup($event, folder._id)"><div id=button-group-{{folder._id}} class=expand-button><img class=action-access src=/assets/icons/fm-action-access.svg alt="" ng-click="openPermission(true, folder)" ng-if="FMANAGER_ACCESS_CREATE > 1"><div></div><div></div></div></div></div><div ng-class="{item: true, active: file._id === vm.selectedData._id}" vid={{file._id}} ng-repeat="file in vm.currentFilteredFiles track by $index" draggable=true><div class="td-content fm-menu"><img src=/assets/icons/drag_indicator.svg alt=icons></div><div class="td-content flex-between fm-checkbox"><checkbox ng-model=file.selected ng-click=vm.selectFile(file) is-small=true></checkbox></div><div class="td-content name" ng-click=vm.previewFile(file)><div class="flex-items-center ft_12_regular_black w-100"><img ng-src={{vm.viewIcon(file)}} alt=icons class=type-icon> <span class="tx-ellipsis mr-10" title={{file.originalname}}>{{vm.parentFolder && vm.parentFolder.is3DFolder ? file.name : file.originalname}}</span></div></div><!-- <div class="td-content type">{{file.format | uppercase}}</div> --><!-- <div class="td-content level">{{file.level}}</div> --><div class="td-content fm-star" ng-click=vm.starFiles(file._id)><img ng-if=!file.star style="filter: invert(72%) sepia(63%) saturate(6022%) hue-rotate(177deg) brightness(98%) contrast(93%)" src=/assets/icons/star-16-outline.svg alt=icons> <img ng-if=file.star src=/assets/icons/star-blue.svg alt=icons></div><!-- <div class="td-content app">\n              <checkbox ng-model="file.app" is-small="true" ng-click="vm.checkApp(file, false)"></checkbox>\n            </div>\n            <div class="td-content qshe">\n              <checkbox ng-model="file.qshe" is-small="true" ng-click="vm.checkQshe(file, false)"></checkbox>\n            </div> --><div class="td-content modified">{{file.updatedAt | date : \'dd/MM/yyyy h:mm a\'}}</div><!-- <div class="td-content status">\n              <div ng-if="file.userId._id === vm.userData._id" class="approve-status owner">Owner</div>\n              <div ng-if="file.userId._id !== vm.userData._id">\n                <div ng-if="file.permission && file.permission.approval === \'Approved\'" class="approve-status approved" translate="Approved"></div>\n                <div ng-if="file.permission && file.permission.approval === \'Pending\'" class="approve-status pending" translate="Pending"></div>\n                <div ng-if="file.permission && file.permission.approval === \'Declined\'" class="approve-status declined" translate="Declined"></div>\n              </div>\n            </div> --><div class="td-content status" ng-class="{\'empty\': !file.members.length}"><div ng-if="file.userId._id !== vm.userData._id" class="approve-status owner" translate="{{!file.members.length ? \'\' : file.members.length + \' members\'}}" ng-click="showFileMembers($event, file._id)"></div><div ng-if="file.userId._id === vm.userData._id" class="approve-status owner" translate="{{!file.members.length ? \'Only You\' : file.members.length + \' members\'}}" ng-click="showFileMembers($event, file._id)"></div><div class=expand-members id=members-group-{{file._id}}><div class=assigned-member ng-repeat="member in file.members track by $index"><div class="left flex-items-center"><img ng-if=member.profilePic class=user-avatar ng-src={{member.profilePic}} alt=""><div class=profile-pic ng-if=!member.profilePic data-letters={{nameLetter(member)}} ng-style="{ \'background\': getColor(member.displayName) }"></div><div class=ft_12_regular_gray>{{member.name || member.displayName}}</div></div></div></div><!-- <div ng-if="file.userId._id !== vm.userData._id">\n                <div ng-if="file.permission && file.permission.approval === \'Approved\'" class="approve-status approved" translate="Approved"></div>\n                <div ng-if="file.permission && file.permission.approval === \'Pending\'" class="approve-status pending" translate="Pending"></div>\n                <div ng-if="file.permission && file.permission.approval === \'Declined\'" class="approve-status declined" translate="Declined"></div>\n              </div> --></div><div class="td-content actions"><img class=action-download src=/assets/icons/fm_download.svg alt=icons ng-click=downloadFiles(file._id)> <img class=action-expand src=/assets/icons/more_horiz_default.svg alt=icons ng-click="showPopup($event, file._id)"><div id=button-group-{{file._id}} class=expand-button><img class=action-access src=/assets/icons/fm-action-access.svg alt="" ng-click="openPermission(false, file)" ng-if="FMANAGER_ACCESS_CREATE > 1"> <img class=action-history src=/assets/icons/fm-action-history.svg alt="" ng-click=viewVersionHistory(file)> <img class=action-edit src=/assets/icons/fm-action-edit.svg alt="" ng-click=editFile(file) ng-if="FMANAGER_ACCESS_CREATE > 1"></div></div></div></div></div></div><div class=table-content-wrapper ng-if=vm.isVersionView><file-versions file=getSelectedFiles()[0] go-back=onComeback()></file-versions></div></div><div ng-if="vm.selectedData && vm.previewType == \'folder\'"><folder-preview data=vm.selectedData preview=vm.previewType></folder-preview></div><div ng-if="vm.selectedData && vm.previewType == \'file\'"><file-preview data=vm.selectedData file-type=vm.previewFileType preview=vm.previewType></file-preview></div></div><script>$(document).mouseup(function(e){\n      var buttonsContainer = $(".expand-button");\n      var membersContainer = $(".expand-members");\n\n      // If the target of the click isn\'t the container\n      if(!buttonsContainer.is(e.target) && buttonsContainer.has(e.target).length === 0){\n        buttonsContainer.css(\'display\', \'none\');\n      }\n\n      // If the target of the click isn\'t the container\n      if(!membersContainer.is(e.target) && membersContainer.has(e.target).length === 0){\n        membersContainer.css(\'display\', \'none\');\n      }\n  });</script>');
$templateCache.put('app/main/fileManage/hierarchyTemplates/hierarchyTemplates.view.html','<div id=hierarchy-templates><div class=header><div class=col-version translate=Version></div><div class=col-date translate="Saved Date"></div><div class=col-description translate=Description></div><div class=col-actions translate=Actions></div></div><spinner ng-if=loading></spinner><div class=scroll-body><div class=version-row ng-repeat="template in templates track by $index"><div class=col-version>{{templates.length - $index}}</div><div class=col-date>{{template.updatedAt | smartDateTime}}</div><div class=col-description>{{template.description}}</div><div class=col-actions><img src=/assets/icons/preview.svg alt="" class="cursor-point mr-15" ng-click=showTemplate(template) title="View Tree"> <img src=/assets/icons/restore.svg alt="" style="width: 15px;" class=cursor-point ng-click=applyTemplate(template) title="Set to latest version"></div></div></div></div>');
$templateCache.put('app/main/fileManage/modals/hierarchy-tree.html','<div ui-tree-handle class=calc-tree-node><a ng-if="hierarchy.children && hierarchy.children.length > 0" data-nodrag ng-click=toggle(this) style="padding-left: 10px;"><span ng-if=this.collapsed>&#9660;</span> <span ng-if=!this.collapsed>&#9650;</span> </a>&nbsp;&nbsp;<div>{{hierarchy.name}}</div>&nbsp;&nbsp;</div><ol ui-tree-nodes="" ng-model=hierarchy.children ng-class="{\'angular-ui-tree-hidden\': collapsed}"><li ng-repeat="hierarchy in hierarchy.children" ui-tree-node ng-include="\'app/main/fileManage/modals/hierarchy-tree.html\'"></li></ol>');
$templateCache.put('app/main/finance/finance-balance/finance-balance.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-balance><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><div class="content-header d-flex justify-content-start"><div class="ft_18_600_black3 mr-2" translate=Balance></div><div class=ft_16_regular_black style="line-height: 32px;" ng-if="compareYear !== financialYear">(Financial Year {{compareYear}} - {{financialYear}})</div><div class=ft_16_regular_black style="line-height: 32px;" ng-if="compareYear === financialYear">(Financial Year {{financialYear}})</div></div><div class=content-body><div class=content-sub-header><div class="d-flex justify-content-between flex-end mb-16"><div class=d-flex><div class=mr-24><div class="ft_12_600_black mb-8" translate=Type></div><selectbox class=dropdown-primary ng-model=filterType options=vm.filterTypes label-field=label value-field=value select-event=onChangeFilterType()></selectbox></div><div class=mr-24><div class="ft_12_600_black mb-8" translate="Period Type"></div><selectbox class=dropdown-primary ng-model=periodType options=vm.periodTypes label-field=label value-field=value></selectbox></div><div class=mr-24><div class="ft_12_600_black mb-8" translate="Financial Year"></div><selectbox class="dropdown-primary half" ng-model=financialYear options=vm.financialYears label-field=year value-field=year select-event=onChangeFinancialYear()></selectbox></div><div class=mr-24><div class="ft_12_600_black mb-8" translate=Month></div><selectbox class=dropdown-primary input-class=half ng-model=month options=vm.months label-field=label value-field=value select-event=onChangeMonth()></selectbox></div><div class=mr-24><div class="ft_12_600_black mb-8" translate="Start Date"></div><div class="has-calendar w-130"><input class=calendar-box placeholder="" date-picker=yyyy-MM-dd date=vm.fromDate change=dateFilterChanged() disabled-from=vm.toDate> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div><div class=mr-24><div class="ft_12_600_black mb-8" translate="End Date"></div><div class="has-calendar w-130"><input class=calendar-box placeholder="" date-picker=yyyy-MM-dd date=vm.toDate change=dateFilterChanged() disabled-to=vm.fromDate> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div><div><div class="ft_12_600_black mb-8">&nbsp;</div><searchbox search-text=searchText input-class=finance-searchbox></searchbox></div></div><div class=flex-between><button class="button-primary btn-balance" ng-click=exportBalances()><img src="/assets/icons/bx-export 1.svg" alt=export><span>Export</span></button> <button class="button-secondary btn-balance ml-16" ng-click=onPost()><span translate=Post1></span></button></div></div><div class="d-flex mb-24"><div class="flex-items-center mr-24"><label class=check_yellow_16><input type=checkbox ng-model=hideZeroBalance ng-change=vm.fetchData()><span class=checkmark_16></span></label><div class=ft_12_600_black translate="Hide account with 0 Balance"></div></div><div class="flex-items-center mr-24"><label class=check_yellow_16><input type=checkbox><span class=checkmark_16></span></label><div class=ft_12_600_black translate="Show Year-to-Date"></div></div><div class="flex-items-center mr-24"><label class=check_yellow_16><input type=checkbox><span class=checkmark_16></span></label><div class=ft_12_600_black translate="See Highest Value (Account Plan)"></div></div><div class="flex-items-center mr-24"><label class=check_yellow_16><input type=checkbox ng-model=isOnlyApprovedBills ng-change=vm.fetchData()><span class=checkmark_16></span></label><div class=ft_12_600_black translate="Only Approved Bills"></div></div><div class="flex-items-center mr-24"><label class=check_yellow_16><input type=checkbox ng-model=isShowWip> <span class=checkmark_16></span></label><div class=ft_12_600_black>WIP</div></div><div class="flex-items-center mr-24" ng-show=isShowWip><label class=check_yellow_16><input type=checkbox ng-model=isWipOnly> <span class=checkmark_16></span></label><div class=ft_12_600_black>WIP Only</div></div></div></div><div class=content-sub-body><div class=balance-table ng-repeat="section in vm.accountSections"><div class=thead ng-if="!isWipOnly || (isWipOnly && getAccountPlanCnt(section) > 0)"><div class=tr><div class="td no title">Nr.{{$index + 1}}</div><div class="td name">{{section.name}}</div><div class="td debit">Debit</div><div class="td credit" translate=Credit>Credit</div></div></div><div class=tbody><div ng-repeat="accountPlan in section.items track by $index"><div class=tr ng-if="showAccountPlan(accountPlan) && showAccountPlanByPeriodType(accountPlan) && showWipAccountPlan(accountPlan)"><div class="td no">{{accountPlan.number}}</div><div class="td name"><span>{{accountPlan.name}}</span><span ng-if="isShowWip && accountPlan.wipName.length > 0">{{\', \' + accountPlan.wipName}}</span></div><div class="td debit"><a href=# ng-click="goFinancePostsWip(\'debit\', accountPlan)" ng-if="isShowWip && accountPlan.wipName.length > 0">{{accountPlan.debitWip | readable: 2}} </a><a href=# ng-click="goFinancePosts2(\'debit\', accountPlan)" ng-if="!isShowWip || !accountPlan.wipName || accountPlan.wipName.length == 0">{{accountPlan.debit | readable: 2}}</a></div><div class="td credit"><a href=# ng-click="goFinancePostsWip(\'credit\', accountPlan)" ng-if="isShowWip && accountPlan.wipName.length > 0">{{accountPlan.creditWip | readable:2}} </a><a href=# ng-click="goFinancePosts2(\'credit\', accountPlan)" ng-if="!isShowWip || !accountPlan.wipName || accountPlan.wipName.length == 0">{{accountPlan.credit | readable:2}}</a></div></div></div><div class="tr sum" ng-repeat="summary in section.summaries" ng-show="!isShowWip || !isWipOnly"><div class="td no" translate=Sum></div><div class="td name"></div><div class="td debit"><div ng-if="getSummary(summary) >= 0">{{ getSummary(summary) | readable: 2 }}</div></div><div class="td credit"><div ng-if="getSummary(summary) < 0">{{ getSummary(summary) | readable: 2 }}</div></div></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-bill-edit/finance-bill-edit.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="finance-bill-edit wide-page"><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><div class="sub-header flex-between"><div class=item><div class="ft_14_600_gray mb-8" translate=Type></div><selectbox-input class="w-100 dropdown-primary" ng-model=vm.billing.billType options=vm.economicTypeList label-field=name value-field=_id select-event=vm.selEconomicTypeId()></selectbox-input></div><div class=item><div class="ft_14_600_gray mb-8" translate=Group></div><selectbox-input class="w-100 dropdown-primary" ng-model=billingGroupId options=vm.billingGroups label-field=name value-field=_id select-event=vm.selBillingGroupId(billingGroupId)></selectbox-input></div><div class=item><div class="ft_14_600_gray mb-8" translate="VA Orders"></div><selectbox-input class="w-100 dropdown-primary" ng-model=billingVAOrderId options=vm.billing.vaOrder label-field=displaySeq value-field=_id select-event=vm.selBillingVAOrderId(billingVAOrderId)></selectbox-input></div><div class=item><div class="ft_14_600_gray mb-8" translate="Invoice No."></div><input type=text class="input-primary w-100" ng-model=vm.billing.customSupplierData.invoicenumber></div><div class=item><div class="ft_14_600_gray mb-8" translate="Bill Date"></div><div class="input-group datePicker-primary"><input type=text class="input-primary w-100" date-picker="dd MMM yyyy" date=billDate is-open=isBillDatepickerOpen ng-required=true change=updateBillDate()> <span class=dateArrow ng-click="isBillDatepickerOpen = !isBillDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=item><div class="ft_14_600_gray mb-8" translate="Due Date"></div><div class="input-group datePicker-primary"><input type=text class="input-primary w-100" date-picker="dd MMM yyyy" date=dueDate is-open=isDueDatepickerOpen ng-required=true change=updateDueDate()> <span class=dateArrow ng-click="isDueDatepickerOpen = !isDueDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div><div class=content-body><div class=pdf-container><spinner ng-if=isDownloading></spinner><div class=up-item ng-if=vm.billing><div class=ft_14_600_white ng-bind=vm.billing.billNo></div><img src=/assets/icons/download-white.svg alt="" ng-click=vm.downloadBill(vm.billing)></div><div class=print><div class=print-content><button class=pre ng-click=vm.changePageInBill(false) ng-disabled="vm.currentPageNum <= 1"><img src=/assets/icons/left-arrow1.svg alt=""></button><div class="pdf-wrap no-zoom"><spinner ng-if=isLoadBilling></spinner><canvas id=the-canvas ng-hide=isLoadBilling></canvas></div><button class=next ng-click=vm.changePageInBill(true) ng-disabled="vm.currentPageNum >= vm.numPages"><img src=/assets/icons/right-arrow1.svg alt=""></button></div><div class=icons ng-if=vm.billing><div class=icon ng-click=vm.zoomCanvas(false)><img src=/assets/icons/zoom-in.svg alt=""></div><div class=icon ng-click=vm.zoomCanvas(true)><img src=/assets/icons/zoom-out.svg alt=""></div></div></div></div><div class=table-content><div class="header-tr pos-relative"><div class=flex-25 translate=Description></div><div class=flex-10 translate=QTY></div><div class=flex-10 translate="Unit Price"></div><div class=flex-15 translate=Price></div><div class=flex-15><span translate=VAT></span>&nbsp;{{ vat }} %</div><div class=flex-15 translate="Total Price"></div><div class=flex-10 translate=Actions></div></div><div class=table-body><div class="main-tr pos-relative" ng-repeat="supply in vm.billing.customSupplierData.supplies track by $index"><div class=flex-25 title={{supply.description}}><span ng-if=!supply.editMode>{{ supply.description }}</span> <input ng-if=supply.editMode type=text placeholder=Description class=w-100 ng-model=supply.description ng-disabled=supply.saveMode></div><div class=flex-10><span ng-if=!supply.editMode>{{ supply.qty }}</span> <input ng-if=supply.editMode type=number placeholder=Quantity class=text-center ng-model=supply.qty ng-change=vm.changedQtyAndUPrice(supply)></div><div class=flex-10><span ng-if=!supply.editMode>{{ supply.unitprice | readable: 2 }}</span> <input ng-if=supply.editMode type=number placeholder="Unit Price" class=text-right ng-model=supply.unitprice ng-change=vm.changedQtyAndUPrice(supply)></div><div class=flex-15>{{ supply.price | readable: 2 }}</div><div class=flex-15>{{ supply.vat | readable: 2 }}</div><div class=flex-15>{{ supply.total | readable: 2 }}</div><div class=flex-10><img ng-if=!supply.editMode src=/assets/icons/edit-black.svg class=cursor-point alt="" ng-click=vm.editItem(supply)> <img ng-if=supply.editMode src=/assets/icons/checkmark-24.svg class="check-mark cursor-point" alt="" ng-click="vm.confirmEdit(supply, $index)"> <img src=/assets/icons/delete4.svg class="cursor-point ml-10" alt="" ng-click="vm.deleteItem(supply, $index)"></div></div><div class=add-tr ng-click=vm.addItem()>+&nbsp;<span translate="Add New Item"></span></div><div class=bottom-tr><div class=row><div class="col label" translate=Price></div><div class=col>{{ vm.billing.amountWithoutTax | readable: 2 }}</div></div><div class=row ng-if=vat><div class="col label">VAT {{ vat }} %</div><div class=col>{{ vm.billing.taxAmount | readable: 2 }}</div></div><div class=row><div class="col label" translate="Total Price"></div><div class=col>{{ vm.billing.totalAmount | readable: 2 }}</div></div></div></div></div></div><div class=content-footer><button class="button-primary mr-24 ml-auto" translate=Save ng-click=vm.updateBill()></button> <button class=btn_cancel translate=Cancel ui-sref=financePurchases></button></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-client/finance-client.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="finance-client wide-page"><finance-menu></finance-menu><div class="content pos-relative"><spinner ng-if=loading></spinner><div class=content-header><div class=ft_20_600_black translate=Client></div><div class="d-flex align-items-center"><div class="ft_14_600_black mr-16" translate="Client Search"></div><selectbox-input class="w-256 dropdown-primary" options=vm.clients label-field=clientName value-field=_id ng-model=vm.selectedClientId change-trig=changeClient()></selectbox-input></div></div><div class=content-body><div class=row><div class=col-8><section id=client-info><div class=section-header><div class=section-tab translate="Client Information"></div></div><div class=section-body><div class=row><div class="col-10 offset-2"><div class="row mb-16"><div class=col-7><label translate="Client Name"></label><div class=input-frame>{{vm.currentClient.clientName}}</div></div><div class=col-5><label translate=Country></label><div class=input-frame>{{vm.currentClient.address.countryCode}}</div></div></div><div class="row mb-16"><div class=col-7><label translate=Address></label><div class=input-frame>{{vm.currentClient.address.line1}}</div></div><div class=col-5><label translate=City></label><div class=input-frame>{{vm.currentClient.address.city}}</div></div></div><div class="row mb-16"><div class=col-5><label translate=Mail></label><div class=input-frame>{{vm.currentClient.email}}</div></div><div class=col-2><label translate=Code1></label><div class=input-frame>{{vm.currentClient.clientContact.dialCode}}</div></div><div class=col-5><label translate=Phone></label><div class=input-frame>{{vm.currentClient.clientContact.phoneNumber}}</div></div></div><div class=row><div class=col-3><label>&nbsp;</label><div class="d-flex mb-16"><label class=check_yellow_20><input type=checkbox ng-model=vm.currentClient.open><span class=checkmark></span></label><div class=ft_14_regular_black translate=Open></div></div><div class=d-flex><label class=check_yellow_20><input type=checkbox ng-model=vm.currentClient.blocked><span class=checkmark></span></label><div class=ft_14_regular_black translate=Blocked></div></div></div><div class=col-9><label translate=Comment></label><textarea ng-model=vm.currentClient.comment></textarea></div></div></div></div></div></section></div><div class=col-4><section id=client-data><div class=section-header><div class=section-tab translate="Client Data"></div></div><div class=section-body><div class=mb-16><label translate="Type Data"></label><selectbox-input class=dropdown-primary options=typeData label-field=value value-field=value ng-model=selectedType change-trig=changeTypeData()></selectbox-input></div><div><label translate=Overview1></label><div class=overview-table><div class=thead><div class=tr><div class="th name" translate=Name></div><div class="th qty" translate=Qty></div><div class="th amount" translate=Amount></div></div></div><div class=tbody><div class=tr ng-repeat="statistics in vm.statistics"><div class="td name" translate={{statistics.name}}></div><div class="td qty">{{statistics.qty}}</div><div class="td amount">{{statistics.amount | readable: 2}}</div></div></div></div></div></div></section></div></div><div class=last-row><div class=flex-20><label translate="VAT In %"></label><div class=input-frame>{{vm.currentClient.paymentTerms.vatPercent | readable: 2}}%</div></div><div class=flex-20><label translate="Company registrations number"></label><div class=input-frame>{{vm.currentClient.paymentTerms.vatNumber}}</div></div><div class=flex-20><label translate="Payment Terms"></label><div class=input-frame></div></div><div class=flex-20><label translate="Invoice Mail"></label><div class=input-frame>{{vm.currentClient.email}}</div></div><div class=flex-20><label translate="Creating Date"></label><div class=input-frame>{{vm.currentClient.createdAt | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div></div></div><div class="content-footer justify-content-between align-items-center"><div class=d-flex><button class="button-primary mr-16" translate=Save ng-click=saveClient()></button> <button class=btn_cancel translate=Cancel ui-sref=financeSales></button></div><div class=d-flex><div class=mr-40><span class="ft_20_600_black mr-16" translate=Overdue3></span> <a href=# class=text-decoration-orange ui-sref="financePosts3({vendorId: vm.selectedClientId, overdue: true})"><span class=ft_20_600_orange>{{vm.overdueAndBalance.overdue | readable: 2}}</span></a></div><div><span class="ft_20_600_black mr-16" translate=Balance></span> <a href=# class=text-decoration-orange ui-sref="financePosts3({vendorId: vm.selectedClientId, overdue: false})"><span class=ft_20_600_orange>{{vm.overdueAndBalance.balance | readable: 2}}</span></a></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-dashboard/finance-dashboard.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-dashboard class=main-container><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=isLoading></spinner><dashboard-header></dashboard-header><div class=content><div class=right-side><!-- bank accounts block BEGIN --><div class=project-filter-block><div class=filter-header><div class=ft_16_600_black translate="Project Filters"></div></div><div class=filter-body><div class="flex-between pos-relative"><div class=filter-item><div class=filter-label translate=Projects></div><div class="d-flex filter-button-container"><selectbox-input class=dropdown-primary ng-model=vm.filter.projectId options=vm.selProjects label-field=projectName value-field=_id select-event=vm.selectFilterProject(vm.filter.projectId)></selectbox-input><div class="filter-button ml-10" ng-click=vm.onShowFilter()><img src=/assets/icons/project-filter.svg alt=icons></div></div></div><div class=filter-menu ng-show=vm.bShowFilter><div class=filter-menu-title translate="Filter Status"></div><selectbox-input class="mt-4 flex-1" ng-model=vm.projectType placeholder="Select Project Type" options=vm.projectTypeOptioins label-field=label value-field=value select-event=vm.selectProjectType(vm.projectType)></selectbox-input><div class=filter-project-list><div class=filter-menu-item ng-click=vm.checkProject(project._id) ng-repeat="project in vm.filterProjectList track by $index"><div class="d-flex align-items-center"><input type=checkbox ng-checked="vm.tempProjectFilter.indexOf(project._id) > -1"><div class="filter-menu-item-text ml-10">{{project.projectName}}</div></div><!-- <div class="filter-menu-item-count float-right">{{vm.allProjects.length}}</div> --></div></div><!-- <div class="filter-menu-item" ng-click="vm.selectProjectType(\'all\')">\n                    <div class="d-flex align-items-center">\n                      <input type="checkbox" ng-checked="vm.tempFilter.length == 3" ng-model="vm.typeAll" />\n                      <div class="filter-menu-item-text ml-10" translate="All Projects"></div>\n                    </div>\n                    <div class="filter-menu-item-count float-right">{{vm.allProjects.length}}</div>\n                  </div>\n                  <div class="filter-menu-item" ng-click="vm.selectProjectType(\'ongoing\')">\n                    <div class="d-flex align-items-center">\n                      <input type="checkbox" ng-checked="vm.tempFilter.indexOf(\'ongoing\') > -1" />\n                      <div class="filter-menu-item-text ml-10" translate="Ongoing Projects"></div>\n                    </div>\n                    <div class="filter-menu-item-count float-right">{{vm.ongoingProjects.length}}</div>\n                  </div>\n                  <div class="filter-menu-item" ng-click="vm.selectProjectType(\'completed\')">\n                    <div class="d-flex align-items-center">\n                      <input type="checkbox" ng-checked="vm.tempFilter.indexOf(\'completed\') > -1" />\n                      <div class="filter-menu-item-text ml-10" translate="Completed Projects"></div>\n                    </div>\n                    <div class="filter-menu-item-count float-right">{{vm.completedProjects.length}}</div>\n                  </div>\n                  <div class="filter-menu-item" ng-click="vm.selectProjectType(\'service\')">\n                    <div class="d-flex align-items-center">\n                      <input type="checkbox" ng-checked="vm.tempFilter.indexOf(\'service\') > -1" />\n                      <div class="filter-menu-item-text ml-10" translate="Service Projects"></div>\n                    </div>\n                    <div class="filter-menu-item-count float-right">{{vm.serviceProjects.length}}</div>\n                  </div> --><div class="d-flex justify-content-between align-items-center mt-4"><div class=d-flex><div class=filter-select-all translate="Select All" ng-click=vm.filterSelectAll()></div><div class="filter-select-all ml-10" translate="Clear All" ng-click=vm.filterClearAll()></div></div><div class="d-flex justify-content-end"><div class="action-button ml-16" translate=OK ng-click=vm.onFilterOk()></div><div class="action-button gray ml-16" translate=Cancel ng-click=vm.onFilterCancel()></div></div></div></div><div class=filter-item><div class=filter-label translate="Client or Vendor"></div><selectbox-input class=dropdown-primary ng-model=vm.filter.clientId options=vm.clients placeholder="Select Client" label-field=clientName value-field=_id select-event=vm.selectFilterClient(vm.filter.clientId)></selectbox-input></div></div><div class="flex-between mt-16"><div class=filter-item><div class=filter-label translate="Start Period"></div><div class="input-group datePicker-primary"><input type=text class=input-primary date-picker=dd.MM.yyyy date=vm.filter.startDate is-open=isStartDatepickerOpen ng-required=true change=vm.changeFilterDate()> <span class=dateArrow ng-click="isStartDatepickerOpen = !isStartDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=filter-item><div class=filter-label translate="End Period"></div><div class="input-group datePicker-primary"><input type=text class=input-primary date-picker=dd.MM.yyyy date=vm.filter.endDate is-open=isEndDatepickerOpen ng-required=true change=vm.changeFilterDate()> <span class=dateArrow ng-click="isEndDatepickerOpen = !isEndDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div></div></div></div><div class=left-side><div class="d-flex w-100 justify-content-between"><finance-card type="\'invoice\'" ng-model=vm.total currency=vm.companyCurrency.symbol></finance-card><finance-card type="\'bill\'" ng-model=vm.total currency=vm.companyCurrency.symbol></finance-card></div></div></div><div class=content><div class=left-side><finance-cashflow class=mt-32 graphdata=vm.cashGraphData start-date=vm.filter.startDate end-date=vm.filter.endDate need-render=!isLoading></finance-cashflow><finance-expense-bar-chart class=mt-32 revenue=vm.tasks ecocash=vm.ecoCash need-render=!isLoading opcosts=vm.opCosts></finance-expense-bar-chart></div><div class=right-side><!-- bank accounts block BEGIN --><div class="bank-accounts-block mt-32"><div class=bank-accounts-header><div class=ft_16_600_black translate="Bank Accounts"></div><img class=cursor-point src=/assets/icons/plus-light-gray.svg alt="" ng-click=addBankAccount()></div><div class=bank-accounts-list><div class=bank-account ng-repeat="bankAccount in vm.bankAccounts track by $index"><div class="d-flex justify-content-between mb-10"><div class=flex-60><div class="ft_14_600_black mb-8">{{bankAccount.accountName}}</div><div class=ft_14_600_light_gray>{{bankAccount.accountNumber}}</div></div><div class="flex-40 text-align-right"><img class=bank-logo ng-src="{{bankAccount.logo ? bankAccount.logo : \'/assets/images/materials/noImg.jpg\'}}" alt=""></div></div><div class="d-flex justify-content-between flex-end"><div class=flex-60><div class=ft_12_500_light translate=Balance></div><div class=ft_16_600_black>{{vm.companyCurrency.symbol}} {{bankAccount.totalAmount | readable: 2}}</div></div><div class="flex-40 text-align-right"><img class=cursor-point src=/assets/icons/more_horiz-gray.svg alt=""></div></div></div></div></div><!-- bank accounts block END --><finance-expense-pie-chart class=mt-32 ng-model=vm.chartData currency=vm.companyCurrency.symbol></finance-expense-pie-chart></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-finance/finance-finance.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-finance><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=isLoading></spinner><div class=content><div class=content-header><div class=title translate="Posted Finance"></div><div class=d-flex><searchbox class="finance-searchbox mr-16" search-text=searchText search-event=searchData()></searchbox><div class="dropdown mr-16"><button class=button-primary data-toggle=dropdown aria-haspopup=true aria-expanded=false><img src=/assets/icons/plus.svg alt=""><span translate="Add New Journal"></span></button><ul class=dropdown-menu><a class=dropdown-item href=# translate="Re-enter Posting" ui-sref=financeCreateReEnterJournal></a> <a class=dropdown-item href=# translate=Payments ui-sref=financeCreatePaymentJournal></a> <a class=dropdown-item href=# translate="Manual Posting" ui-sref=financeCreateManualJournal></a> <a class=dropdown-item href=# translate="Labour Posting"></a></ul></div><button class=button-secondary ng-click=exportToExcel()><img src=/assets/icons/export-white.svg alt="" class="export-icon mr-2"><span translate="Export to Excel"></span></button></div></div><div class=content-body><div class=table><div class=thead><div class=tr><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectAll()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-7" translate="Serial No."></div><div class="td flex-8" translate=Date></div><div class="td flex-7" translate=Type></div><div class="td flex-10" translate="Document No."></div><div class="td flex-6" translate="Finance Account"></div><div class="td flex-12" translate=Description></div><div class="td flex-10" translate=Vendor></div><div class="td flex-9" translate="Finance Type"></div><div class="td flex-6" translate="Vat Type"></div><div class="td flex-9 justify-content-end" translate=Amount></div><div class="td flex-8" translate="Bal. Account Type"></div><div class="td flex-8" translate="Bal. Account No"></div></div></div></div><div class=tbody><div class=tr ng-repeat="item in finances track by $index"><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=item.selected ng-change=selectItem()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-7">{{item.serialNo}}</div><div class="td flex-8">{{item.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td flex-7">{{item.postingType}}</div><div class="td flex-10">{{item.documentNo}}</div><div class="td flex-6">{{item.financeAccountNumber}}</div><div class="td flex-12">{{item.description}}</div><div class="td flex-10">{{item.vendor && item.vendor.name ? item.vendor.name : item.vendor.clientName}}</div><div class="td flex-9">{{item.financeKind}}</div><div class="td flex-6">{{item.isIncome ? item.vatType : item.vatType2}}</div><div class="td flex-9 justify-content-end">{{item.amountExVat | readable: 2}}</div><div class="td flex-8">{{item.balAccountType}}</div><div class="td flex-8">{{item.balAccountNo}}</div></div></div></div></div><div ng-if=!finances.length class="ft_24_600_gray text-center mv-auto" translate="No Data to Display"></div></div><div class=content-footer><div class=delete-zone><img src=/assets/icons/delete-red.svg alt="" ng-click=deleteFinances()> <span ng-bind=selectedCount()></span></div><div class="flex flex-row pagination-footer flex-items-center justify-content-end mt-4"><span class="ft_14_regular_black mr-3">Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + finances.length}}</span> of {{vm.totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=vm.noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-posts/finance-posts.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class=finance-posts><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=isLoading></spinner><div class=content><div class=content-header><div class=title translate="Posted Finance"></div><button class="btn btn-black" ng-click=exportToExcel()><img src=/assets/icons/export-white.svg alt="" class=export-icon> <span translate="Export to Excel"></span></button></div><div class=content-body><div class=table><div class=thead><div class=tr><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectAll()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-7" translate="Serial No."></div><div class="td flex-6" translate=Date></div><div class="td flex-7" translate=Type></div><div class="td flex-14" translate="Document No."></div><div class="td flex-6" translate="Finance Account"></div><div class="td flex-18" translate=Description></div><div class="td flex-9" translate="Finance Type"></div><div class="td flex-6" translate="Vat Type"></div><div class="td flex-9 justify-content-end" translate=Amount></div><div class="td flex-8" translate="Bal. Account Type"></div><div class="td flex-8" translate="Bal. Account No"></div></div></div></div><div class=tbody><div class=tr ng-repeat="item in vm.finances track by $index"><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectItem()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-7">{{getSerialNo($index)}}</div><div class="td flex-8">{{item.date || item.billDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td flex-7">{{getType(item)}}</div><div class="td flex-14">{{item.billNo || item.displaySeq}}</div><div class="td flex-6">{{item.accountPlan.number}}</div><div class="td flex-18">{{item.isJournal ? item.finance.billNo || item.finance.displaySeq : item.vendor.clientName || item.vendor.name}}</div><div class="td flex-9">{{item.accountPlan.type}}</div><div class="td flex-6">{{item.accountPlan.vatType.vatType}}</div><div class="td flex-9 justify-content-end">{{item.totalPrice || item.amountWithoutTax | readable: 2}}</div><div class="td flex-8">{{item.accountPlan.type}}</div><div class="td flex-8"></div></div></div></div></div><div ng-if=!vm.finances.length class="ft_24_600_gray text-center mv-auto" translate="No Data to Display"></div></div><div class=content-footer><pagination ng-if=vm.noOfPages num-pages=vm.noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-posts-wip/finance-posts-wip.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class=finance-posts><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=isLoading></spinner><div class=content><div class=content-header><div><span class="title mr-8" translate="Posted WIP"></span> <span class="title mr-8">({{vm.accountPlanNumber}})</span> <span ng-if=vm.isOnlyApprovedBills class=ft_14_regular_black style="font-style: italic">- Only Approved Bills -</span></div><div class=d-flex><searchbox class="finance-searchbox mr-16" search-text=searchText search-event=searchData()></searchbox><button class="btn btn-black" ng-click=exportToExcel()><img src=/assets/icons/export-white.svg alt="" class=export-icon> <span translate="Export to Excel"></span></button></div></div><div class=content-body><div class=table><div class=thead><div class=tr><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectAll()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-6" translate="Serial No."></div><div class="td flex-7" translate=Date></div><div class="td flex-11" translate=Type></div><div class="td flex-16" translate="Document No."></div><div class="td flex-10" translate="Finance Account"></div><div class="td flex-10" translate=Description></div><div class="td flex-9" translate="Finance Type"></div><div class="td flex-9 justify-content-end" translate=Amount></div><div class="td flex-8" translate="Bal. Account Type"></div><div class="td flex-8" translate="Bal. Account No"></div><div class="td flex-6" translate=Action></div></div></div></div><div class=tbody><div class=tr ng-repeat="item in vm.finances track by $index"><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectItem()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-6">{{addZeroes($index + 1, 5)}}</div><div class="td flex-7">{{item.createdAt | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td flex-11">{{item.postingType}}</div><div class="td flex-16">{{item.documentNo}}</div><div class="td flex-10">{{vm.accountPlanNumber}}</div><div class="td flex-10">{{item.description}}</div><div class="td flex-9">{{item.financeKind}}</div><div class="td flex-9 justify-content-end"><div>{{item.amount | readable: 2}}</div></div><div class="td flex-8">{{item.balAccountType}}</div><div class="td flex-8">{{item.balAccountNo}}</div><div class="td flex-6"><img src=/assets/icons/delete1.svg ng-if="item.isNew !== true" alt="" class="ml-10 cursor-point" ng-click=deletePostedWip(item._id)></div></div></div><div class=tr><div class="td check-item"></div><div class=main-columns><div class="td flex-6 font-weight-bold">Sum</div><div class="td flex-7"></div><div class="td flex-11"></div><div class="td flex-16"></div><div class="td flex-10"></div><div class="td flex-10"></div><div class="td flex-9"></div><div class="td flex-9 justify-content-end font-weight-bold">{{ vm.sum | readable: 2 }}</div><div class="td flex-8"></div><div class="td flex-8"></div><div class="td flex-6"></div></div></div></div></div><div ng-if=!vm.finances.length class="ft_24_600_gray text-center mv-auto" translate="No Data to Display"></div></div><div class=content-footer><pagination ng-if=vm.noOfPages num-pages=vm.noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-posts2/finance-posts2.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class=finance-posts><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=isLoading></spinner><div class=content><div class=content-header><div><span class="title mr-8" translate="Posted Finance"></span> <span class="title mr-8">({{vm.accountPlanNumber}})</span> <span ng-if=vm.isOnlyApprovedBills class=ft_14_regular_black style="font-style: italic">- Only Approved Bills -</span></div><div class=d-flex><searchbox class="finance-searchbox mr-16" search-text=searchText search-event=searchData()></searchbox><button class="btn btn-black" ng-click=exportToExcel()><img src=/assets/icons/export-white.svg alt="" class=export-icon> <span translate="Export to Excel"></span></button></div></div><div class=content-body><div class=table><div class=thead><div class=tr><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectAll()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-6" translate="Serial No."></div><div class="td flex-7" translate=Date></div><div class="td flex-6" translate=Type></div><div class="td flex-10" translate="Document No."></div><div class="td flex-5" translate="Finance Account"></div><div class="td flex-10" translate=Description></div><div class="td flex-10" translate=Vendor></div><div class="td flex-9" translate="Finance Type"></div><div class="td flex-5" translate="Vat Type"></div><div class="td flex-7 justify-content-end" translate="Vat Amount"></div><div class="td flex-9 justify-content-end" translate=Amount></div><div class="td flex-8" translate="Bal. Account Type"></div><div class="td flex-8" translate="Bal. Account No"></div></div></div></div><div class=tbody><div class=tr ng-repeat="item in vm.finances.slice(0, vm.finance.length - 1) track by $index"><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectItem()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-6">{{getSerialNo($index)}}-{{item.date | date: \'yy\' : \'UTC\'}}</div><div class="td flex-7">{{item.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td flex-6">{{item.postingType}}</div><div class="td flex-10">{{item.documentNo}}</div><div class="td flex-5">{{item.financeAccountNumber}}</div><div class="td flex-10">{{item.description}}</div><div class="td flex-10">{{(item.vendor && item.vendor.name) ? item.vendor.name : item.vendor.clientName}}</div><div class="td flex-9">{{item.financeKind}}</div><div class="td flex-5">{{item.isIncome == false ? item.vatType2 : item.vatType}}</div><div class="td flex-7 justify-content-end" ng-if=item.vatAmount>{{item.vatAmount | readable: 2 }}</div><div class="td flex-7 justify-content-end" ng-if=!item.vatAmount></div><div class="td flex-9 justify-content-end">{{item.amountExVat | readable: 2}}</div><div class="td flex-8">{{item.balAccountType}}</div><div class="td flex-8">{{item.balAccountNo}}</div></div></div><div class=tr><div class="td check-item"></div><div class=main-columns><div class="td flex-6 font-weight-bold">Sum</div><div class="td flex-7"></div><div class="td flex-6"></div><div class="td flex-12"></div><div class="td flex-5"></div><div class="td flex-16"></div><div class="td flex-9"></div><div class="td flex-6"></div><div class="td flex-8 justify-content-end font-weight-bold" ng-if="vm.finances[vm.finances.length - 1].vatAmount">{{vm.finances[vm.finances.length - 1].vatAmount | readable: 2 }}</div><div class="td flex-8 justify-content-end" ng-if="!vm.finances[vm.finances.length - 1].vatAmount"></div><div class="td flex-9 justify-content-end font-weight-bold">{{vm.finances[vm.finances.length - 1].amountExVat | readable: 2}}</div><div class="td flex-8"></div><div class="td flex-8"></div></div></div></div></div><div ng-if=!vm.finances.length class="ft_24_600_gray text-center mv-auto" translate="No Data to Display"></div></div><div class=content-footer><pagination ng-if=vm.noOfPages num-pages=vm.noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-posts3/finance-posts3.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class=finance-posts><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=isLoading></spinner><div class=content><div class=content-header><!-- <div class="title">{{vm.overdue == \'true\' ? \'Overdue\' : \'Balance\'}}&nbsp;Finances</div> --><div class=title>{{ title }}&nbsp;Statements</div><button class="btn btn-black" ng-click=exportToExcel()><img src=/assets/icons/export-white.svg alt=""> <span translate="Export to Excel"></span></button></div><div class=content-body><div class=table><div class=thead><div class=tr><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectAll()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-6" translate="Serial No."></div><div class="td flex-7" translate=Date></div><div class="td flex-6" translate=Type></div><div class="td flex-10" translate="Document No."></div><div class="td flex-5" translate="Finance Account"></div><div class="td flex-23" translate=Description></div><div class="td flex-6" translate="Finance Type"></div><div class="td flex-5" translate="Vat Type"></div><div class="td flex-8 justify-content-end" translate=Amount></div><div class="td flex-8 justify-content-end" translate=VAT></div><div class="td flex-8 justify-content-end" translate="Total Amount"></div><div class="td flex-8 justify-content-end" translate=Overdue></div></div></div></div><div class=tbody><div class=tr ng-repeat="item in vm.finances track by $index"><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectItem()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-6">{{getSerialNo($index)}}</div><div class="td flex-7">{{item.date || item.billDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td flex-6">{{getType(item)}}</div><div class="td flex-10">{{item.billNo || item.displaySeq || item.systemTag}}</div><div class="td flex-5">{{item.accountPlan.number}}</div><div class="td flex-23">{{getDescription(item)}}</div><div class="td flex-6">{{item.postingType === "Posting" ? \'\' : item.accountPlan.type}}</div><div class="td flex-5">{{item.accountPlan.vatType.vatType}}</div><div class="td flex-8 justify-content-end">{{item.totalPrice || item.amountWithoutTax || item.amountExVat | readable: 2}}</div><div class="td flex-8 justify-content-end">{{item.totalVat || item.taxAmount || item.vatAmount | readable: 2}}</div><div class="td flex-8 justify-content-end">{{item.totalAmount || item.amount | readable: 2}}</div><div class="td flex-8 justify-content-end" ng-if="item.postingType == \'Invoice\' || item.postingType == \'Bill\'">{{ item.remainingAmount | readable: 2}}</div><div class="td flex-8 justify-content-end" ng-if="item.postingType != \'Invoice\' && item.postingType != \'Bill\'"></div></div></div><div class=tr><div class="td check-item"></div><div class=main-columns><div class="td flex-6 font-weight-bold">Sum</div><div class="td flex-7"></div><div class="td flex-6"></div><div class="td flex-10"></div><div class="td flex-5"></div><div class="td flex-23"></div><div class="td flex-6"></div><div class="td flex-5"></div><div class="td flex-8"></div><div class="td flex-8"></div><div class="td flex-8 justify-content-end font-weight-bold">{{vm.totalPrice | readable: 2}}</div><div class="td flex-8 justify-content-end font-weight-bold">{{vm.totalBalance | readable: 2}}</div></div></div></div></div><div ng-if=!vm.finances.length class="ft_24_600_gray text-center mv-auto" translate="No Data to Display"></div></div><div class="content-footer d-flex justify-content-between"><div class=delete-zone><img src=/assets/icons/delete-red.svg alt="" ng-click=deleteFinances()> <span ng-bind=selectedCount()></span></div><div class="flex flex-row pagination-footer flex-items-center justify-content-end mt-4"><span class="ft_14_regular_black mr-3">Items per page</span><selectbox class=duration ng-model=vm.numPerPage options=periods label-field=name value-field=id select-event=selectNumPage(vm.numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * vm.numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * vm.numPerPage + vm.finances.length}}</span> of {{vm.totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=vm.noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-purchases/finance-purchases.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-purchases><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=isLoading></spinner><div class=content><div><div class=content-header><div class=tabs><div class=tab translate=Bill ng-class="{active: currentTab == \'Bill\'}" ng-click="changeTab(\'Bill\')"></div><div class=tab translate=Memo ng-class="{active: currentTab == \'Memo\'}" ng-click="changeTab(\'Memo\')"></div></div><div class=d-flex><searchbox is-small=true search-text=searchText place-holder="{{\'Search by Customer Name\' | translate}}" search-event=searchData() class=mr-16></searchbox><button class="button-primary mr-16" ng-click=exportToExcel()><img src=/assets/icons/export-white.svg alt="" class="export-icon mr-2"><span translate="Export to Excel"></span></button><filter-dropdown class=mr-16 number-title="\'Bill #\'" on-filter=onFilter(filterOption) clear-filter=clearFilter></filter-dropdown><sort-dropdown ng-model=sortOption options=billOptions select-event=changeSortOption(value)></sort-dropdown></div></div><div class=content-body><div class=table><div class=thead><div class=tr><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectAll()><span class=checkmark></span></label></div><div class=main-columns><div class="td flex-8" translate=Date></div><div class="td flex-10" translate="Bill #"></div><div class="td flex-10" translate="Customer Name"></div><div class="td flex-10" translate="Project Name"></div><div class="td flex-8" translate=Status></div><div class="td flex-8" translate="Due Date"></div><div class="td flex-10 text-right" translate=Amount></div><div class="td flex-6 text-right" translate="VAT %"></div><div class="td flex-10 text-right" translate="VAT Amount"></div><div class="td flex-10 text-right" translate="Total Amount"></div><div class="td flex-10 text-right" translate="Balance Amount"></div></div><div class="td actions"></div></div></div><div class=tbody><div class=tr ng-repeat="item in list track by $index"><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=item.selected ng-change=selectItem()><span class=checkmark></span></label></div><div class=main-columns><div class="td flex-8">{{item.billDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td flex-10 bill-no">{{item.billNo}}</div><div class="td flex-10" title={{item.customerName}}>{{item.customerName}}</div><div class="td flex-10" title={{item.customerName}}>{{item.projectId.projectName}}</div><div class="td flex-8 status" ng-style=statusColor(item.status)>{{item.status}}</div><div class="td flex-8">{{item.dueDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td flex-10 text-right" title="{{item.amountWithoutTax | readable: 2}}">{{item.amountWithoutTax | readable: 2}}</div><div class="td flex-6 text-right">{{item.vatPercent | readable: 2}}%</div><div class="td flex-10 text-right" title="{{item.taxAmount | readable: 2}}">{{item.taxAmount | readable: 2}}</div><div class="td flex-10 text-right" title="{{item.totalAmount | readable: 2}}">{{item.totalAmount | readable: 2}}</div><div class="td flex-10 text-right" title="{{item.remainingAmount | readable: 2}}">{{item.remainingAmount | readable: 2}}</div></div><div class="td actions"><a href={{item.bill.secure_url}} target=_blank class=mr-8><img src=/assets/icons/eye6.svg alt=""></a><!-- <div class="cursor-point" ui-sref="financeBillEdit({id: item._id})" ng-if="currentTab === \'Bill\' && item.status == \'init\'"> --><!-- <div class="cursor-point" ui-sref="financeBillEdit({id: item._id})" ng-if="!item.financeItems.length"> --><div class=cursor-point ng-click=vm.gotoEdit(item) ng-if=!item.financeItems.length><img src=/assets/icons/bx-edit6.svg alt=""></div></div></div><no-data ng-if=!list.length></no-data></div></div></div></div><div class=content-footer><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=vm.numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * vm.numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * vm.numPerPage + list.length}}</span> of {{vm.totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div><!-- <pagination ng-if="noOfPages" num-pages="noOfPages" current-page="vm.currentPage" on-select-page="fetchData()"></pagination> --></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-sales/finance-sales.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-sales><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=isLoading></spinner><div class=content><div><div class=content-header><div class=tabs><div class=tab translate=Invoice ng-class="{active: currentTab == \'Invoice\'}" ng-click="changeTab(\'Invoice\')"></div><div class=tab translate="Credit Memo" ng-class="{active: currentTab == \'Credit Memo\'}" ng-click="changeTab(\'Credit Memo\')"></div></div><div class=d-flex><searchbox is-small=true search-text=searchText place-holder="Search by Customer Name" search-event=searchData() class=mr-16></searchbox><button class="button-primary mr-16" ng-click=exportToExcel()><img src=/assets/icons/export-white.svg alt="" class=mr-8> <span translate="Export to Excel"></span></button><filter-dropdown class=mr-16 number-title="\'Invoice #\'" on-filter=onFilter(filterOption) clear-filter=clearFilter></filter-dropdown><sort-dropdown ng-if="currentTab === \'Invoice\'" ng-model=sortOption options=invoiceOptions select-event=changeSortOption(value)></sort-dropdown><sort-dropdown ng-if="currentTab === \'Credit Memo\'" ng-model=sortOption options=creditMemoOptions select-event=changeSortOption(value)></sort-dropdown></div></div><div class=content-body><div ng-show="currentTab === \'Invoice\'" class=table><div class=thead><div class=tr><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectAll()><span class=checkmark></span></label></div><div class=main-columns><div class="td flex-7" translate=Date></div><div class="td flex-14 display-seq" translate="Invoice #"></div><div class="td flex-15 display-seq" translate="Credit Memo #"></div><div class="td flex-14" translate="Customer Name"></div><div class="td flex-6 status" translate=Status></div><div class="td flex-7" translate="Due Date"></div><div class="td flex-8 text-right" translate=Amount></div><div class="td flex-5 text-right" translate="VAT %"></div><div class="td flex-8 text-right" translate="VAT Amount"></div><div class="td flex-8 text-right" translate="Total Amount"></div><div class="td flex-8 text-right" translate="Balance Amount"></div></div><div class="td actions" translate=Actions></div></div></div><div class=tbody><div class=tr ng-repeat="item in list track by $index"><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=item.selected ng-change=selectItem()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-7" title="{{item.date | date: \'dd/MM/yyyy\' : \'UTC\'}}">{{item.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td flex-14 display-seq">{{item.displaySeq}}</div><div class="td flex-15 display-seq" title={{item.creditMemos}}>{{item.creditMemos}}</div><div class="td flex-14" title={{item.customerName}}>{{item.customerName}}</div><div class="td flex-6 status" ng-style=statusColor(item.status) title={{item.status}}>{{item.status}}</div><div class="td flex-7" title="{{item.dueDate | date: \'dd/MM/yyyy\' : \'UTC\'}}">{{item.dueDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td flex-8 text-right" title="{{item.totalPrice | readable: 2}}">{{item.totalPrice | readable: 2}}</div><div class="td flex-5 text-right" title="{{item.totalVat * 100 / item.totalPrice | readable: 2}}%">{{item.totalVat * 100 / item.totalPrice | readable: 2}}%</div><div class="td flex-8 text-right" title="{{item.totalVat | readable: 2}}">{{item.totalVat | readable: 2}}</div><div class="td flex-8 text-right" title="{{item.totalAmount | readable: 2}}">{{item.totalAmount | readable: 2}}</div><div class="td flex-8 text-right" title={{item.remainingAmount}}>{{item.remainingAmount | readable: 2}}</div></div><div class="td actions"><a ng-if="item.status==\'draft\'" href=/finance/sales/editInvoice/{{item._id}} class=mr-8><img src=/assets/icons/edit.svg alt=""></a><a href={{item.invoiceDoc}} target=_blank class=mr-8><img src=/assets/icons/eye6.svg alt=""></a><a href=# ng-click=sendInvoiceMail(item)><img src=/assets/icons/send.svg alt=""></a></div></div><no-data ng-if=!list.length></no-data></div></div><div ng-show="currentTab === \'Credit Memo\'" class=table><div class=thead><div class=tr><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectAll()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-8" translate=Date></div><div class="td flex-16" translate="Credit Memo #"></div><div class="td flex-16" translate="Customer Name"></div><div class="td flex-16" translate="Invoice #"></div><div class="td flex-8" translate=Status></div><div class="td flex-10 text-right" translate=Amount></div><div class="td flex-6 text-right" translate="VAT %"></div><div class="td flex-10 text-right" translate="VAT Amount"></div><div class="td flex-10 text-right" translate="Total Amount"></div></div><div class="td actions" translate=Actions></div></div></div><div class=tbody><div class=tr ng-repeat="item in list track by $index"><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=item.selected ng-change=selectItem()><span class=checkmark></span></label></div><div class=main-columns><div class="td flex-8" title="{{item.date | date: \'dd/MM/yyyy\' : \'UTC\'}}">{{item.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td flex-16 display-seq" title={{item.displaySeq}}>{{item.displaySeq}}</div><div class="td flex-16" title={{item.customerName}}>{{item.customerName}}</div><div class="td flex-16 display-seq" title={{item.creditNote.displaySeq}}>{{item.creditNote.displaySeq}}</div><div class="td flex-8 status" ng-style=statusColor(item.status)>{{item.status}}</div><div class="td flex-10 text-right" title="{{item.totalPrice | readable: 2}}">{{item.totalPrice | readable: 2}}</div><div class="td flex-6 text-right" title="{{item.totalVat * 100 / item.totalPrice | readable: 2}}%">{{item.totalVat * 100 / item.totalPrice | readable: 2}}%</div><div class="td flex-10 text-right" title="{{item.totalVat | readable: 2}}">{{item.totalVat | readable: 2}}</div><div class="td flex-10 text-right" title="{{item.remainingAmount | readable: 2}}">{{item.remainingAmount | readable: 2}}</div></div><div class="td actions"><a ng-if="item.status==\'draft\'" href=/finance/sales/editInvoice/{{item._id}} class=mr-8><img src=/assets/icons/edit.svg alt=""></a><a href={{item.invoiceDoc}} target=_blank class=mr-8><img src=/assets/icons/eye6.svg alt=""></a><a href=# ng-click=sendCopy(item)><img src=/assets/icons/fm_copy_outline.svg alt=""></a></div></div><no-data ng-if=!list.length></no-data></div></div></div></div><div class=content-footer><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=vm.numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * vm.numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * vm.numPerPage + list.length}}</span> of {{vm.totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-script/finance-script.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-script><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=isLoading></spinner><div class=content><div class=content-header><div class=title translate="Finance Scripts"></div><div class=d-flex><button class=button-primary ng-click=generateScript()><span translate="Generate Script"></span></button></div></div><div class=content-body><div class=table><div class=thead><div class=tr><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=selectedAll ng-change=selectAll()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-14" translate=Date></div><div class="td flex-14" translate=Report/Debit></div><div class="td flex-14" translate=Report/Credit></div><div class="td flex-14" translate="Posted Finance (5800)"></div><div class="td flex-14" translate="Posted Finance (6800)"></div><div class="td flex-14" translate="Balance (5800)"></div><div class="td flex-14" translate="Balance (6800)"></div><div class="td flex-2"></div></div></div></div><div class=tbody><div class=tr ng-repeat="item in scripts track by $index"><div class="td check-item"><label class=check_yellow_20><input type=checkbox ng-model=item.selected ng-change=selectItem()> <span class=checkmark></span></label></div><div class=main-columns><div class="td flex-14">{{item.createdAt | date: \'yyyy-MM-dd HH:mm:ss\' : \'UTC\'}}</div><div class="td flex-14" ng-class="{danger: isDanger(\'debit\', item)}"><div id={{item._id}}-debit class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{item.reportDebit | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{item._id}}-debit><div id={{client._id}} class=dropdown-item ng-repeat="client in item.clients track by $index"><div>{{$index + 1}}. {{client.name}}</div><div>{{client.value | readable: 2}}</div></div><div id={{client._id}}-sum class=dropdown-item><div class=font-weight-bold translate=Sum></div><div class=font-weight-bold>{{item.reportDebit | readable: 2}}</div></div></div></div><div class="td flex-14" ng-class="{danger: isDanger(\'credit\', item)}"><div id={{item._id}}-credit class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{item.reportCredit | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{item._id}}-credit><div id={{vendor._id}} class=dropdown-item ng-repeat="vendor in item.vendors track by $index"><div>{{$index + 1}}. {{vendor.name}}</div><div>{{vendor.value | readable: 2}}</div></div><div id={{vendor._id}}-sum class=dropdown-item><div class=font-weight-bold translate=Sum></div><div class=font-weight-bold>{{item.reportCredit | readable: 2}}</div></div></div></div><div class="td flex-14 d-flex align-items-center justify-content-end" ng-class="{danger: isDanger(\'debit\', item)}">{{item.posted5800 | readable: 2}}</div><div class="td flex-14 d-flex align-items-center justify-content-end" ng-class="{danger: isDanger(\'credit\', item)}">{{item.posted6800 | readable: 2}}</div><div class="td flex-14 d-flex align-items-center justify-content-end" ng-class="{danger: isDanger(\'debit\', item)}">{{item.balance5800 | readable: 2}}</div><div class="td flex-14 d-flex align-items-center justify-content-end" ng-class="{danger: isDanger(\'credit\', item)}">{{item.balance6800 | readable: 2}}</div><div class="td flex-2 delete-zone"><img src=/assets/icons/delete-red.svg alt="" ng-click=deleteScript(item._id)></div></div></div></div></div><div ng-if=!scripts.length class="ft_24_600_gray text-center mv-auto" translate="No Data to Display"></div></div><div class=content-footer><div class=delete-zone><img src=/assets/icons/delete-red.svg alt="" ng-click=deleteScripts()> <span ng-bind=selectedCount()></span></div><div class="flex flex-row pagination-footer flex-items-center justify-content-end mt-4"><span class="ft_14_regular_black mr-3">Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + scripts.length}}</span> of {{vm.totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=vm.noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-vendor/finance-vendor.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="finance-client wide-page" id=purchase-vendor><finance-menu></finance-menu><div class="content pos-relative"><spinner ng-if=loading></spinner><div class=content-header><div class=ft_20_600_black translate=Vendor></div><div class="d-flex align-items-center"><div class="ft_14_600_black mr-16" translate="Vendor Search"></div><selectbox-input class="w-192 dropdown-primary" options=vm.vendors label-field=name value-field=_id ng-model=vm.selectedVendorId change-trig=changeVendor()></selectbox-input></div></div><div class=content-body><div class=row><div class=col-8><section id=client-info><div class=section-header><div class=section-tab translate="Vendor Information"></div></div><div class=section-body><div class=row><div class="col-10 offset-2"><div class="row mb-16"><div class=col-7><label translate="Vendor Name"></label><div class=input-frame>{{vm.currentVendor.name}}</div></div><div class=col-5><label translate=Country></label><div class=input-frame>{{vm.currentVendor.address.countryCode}}</div></div></div><div class="row mb-16"><div class=col-7><label translate=Address></label><div class=input-frame>{{vm.currentVendor.address.line1}}</div></div><div class=col-5><label translate=City></label><div class=input-frame>{{vm.currentVendor.address.city}}</div></div></div><div class="row mb-16"><div class=col-5><label translate=Mail></label><div class=input-frame>{{vm.currentVendor.email}}</div></div><div class=col-2><label translate=Code></label><div class=input-frame>{{vm.currentVendor.clientContact.dialCode}}</div></div><div class=col-5><label translate=Phone></label><div class=input-frame>{{vm.currentVendor.clientContact.phoneNumber}}</div></div></div><div class=row><div class=col-3><label>&nbsp;</label><div class="d-flex mb-16"><label class=check_yellow_20><input type=checkbox ng-model=vm.currentVendor.open> <span class=checkmark></span></label><div class=ft_14_regular_black translate=Open></div></div><div class=d-flex><label class=check_yellow_20><input type=checkbox ng-model=vm.currentVendor.blocked> <span class=checkmark></span></label><div class=ft_14_regular_black translate=Blocked></div></div></div><div class=col-9><label translate=Comment></label> <textarea ng-model=vm.currentVendor.comment></textarea></div></div></div></div></div></section></div><div class=col-4><section id=client-data><div class=section-header><div class=section-tab translate="Vendor Data"></div></div><div class=section-body><div class=mb-16><label translate="Type Data"></label><selectbox-input class=dropdown-primary options=typeData label-field=value value-field=value ng-model=selectedType change-trig=changeTypeData()></selectbox-input></div><div><label translate=Overview></label><div class=overview-table><div class=thead><div class=tr><div class="th name" translate=Name></div><div class="th qty" translate=Qty></div><div class="th amount" translate=Amount></div></div></div><div class=tbody><div class=tr ng-repeat="statistics in vm.statistics"><div class="td name">{{statistics.name}}</div><div class="td qty">{{statistics.qty}}</div><div class="td amount">{{statistics.amount | readable: 2}}</div></div></div></div></div></div></section></div></div><div class=last-row><div class=flex-20><label translate="VAT In %"></label><div class=input-frame>{{vm.currentVendor.paymentTerms.vatPercent | readable: 2}}%</div></div><div class=flex-20><label translate="Company registrations number"></label><div class=input-frame>{{vm.currentVendor.paymentTerms.vatNumber}}</div></div><div class=flex-20><label translate="Payment Terms"></label><div class=input-frame></div></div><div class=flex-20><label translate="Invoice Mail"></label><div class=input-frame>{{vm.currentVendor.email}}</div></div><div class=flex-20><label translate="Creating Date"></label><div class=input-frame>{{vm.currentVendor.createdAt | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div></div></div><div class="content-footer justify-content-between align-items-center"><div class=d-flex><button class="button-primary mr-16" translate=Save ng-click=saveVendor()></button> <button class=btn_cancel translate=Cancel ui-sref=financeSales></button></div><div class=d-flex><div class=mr-40><span class="ft_20_600_black mr-16" translate=Overdue></span> <a href=# class=text-decoration-orange ui-sref="financePosts3({vendorId: vm.selectedVendorId, overdue: true})"><span class=ft_20_600_orange>{{vm.overdueAndBalance.overdue | readable: 2}}</span></a></div><div><span class="ft_20_600_black mr-16" translate=Balance></span> <a href=# class=text-decoration-orange ui-sref="financePosts3({vendorId: vm.selectedVendorId, overdue: false})"><span class=ft_20_600_orange>{{vm.overdueAndBalance.balance | readable: 2}}</span></a></div></div></div></div></div></main>');
$templateCache.put('app/main/issues/create-issue/create-issue.view.html','<div id=create-issue-wrap><main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=create-issue class=main-container><div class="title-bar flex flex-row flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2 cursor-point" ng-click=exitCreateIssue() translate=Issues></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2">{{issueData.editMode ? "Edit Issue" : "Add Issue"}}</a></div><div class=ft_24_600_black1 translate="{{issueData.editMode ? \'Edit Issue\' : \'Add Issue1\'}}"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue client_gray_white_back mr-16 pv-8 pl-6 pr-12" ng-click=exitCreateIssue()><img src=/assets/icons/close-16-black.svg style="margin-right: 4px;" alt=icons><span class=ft-600-12-16 translate=Cancel></span></button> <button class="btn_new_blue pv-8 pl-12 pr-6" ng-click=goStep(2) ng-if="issueData.step == 1"><span translate=Next></span><img src=/assets/icons/arrow-right-white-issue.svg style="margin-left: 4px;" alt=icons></button> <button class="btn_new_blue pv-8 pl-12 pr-6" ng-click=vm.createIssue() ng-if="issueData.step == 2"><span>{{issueData.editMode ? "Update" : "Done"}}</span><img src=/assets/icons/arrow-right-white-issue.svg style="margin-left: 4px;" alt=icons></button><!-- <button class="btn_new_blue mr-16" ng-click="vm.createIssue()" ng-if="issueData.editMode" >\n            <img src="/assets/icons/left-arrow1.svg" style="margin-right: 4px;width: 12px; height: 12px;" alt="icons"/><span translate="Update"></span>\n          </button> --> <button class="btn_new_blue pv-8 pl-12 pr-6" ng-click=exitCreateIssue() ng-if="issueData.step == 3"><span translate=Continue></span><img src=/assets/icons/arrow-right-white-issue.svg style="margin-left: 4px;" alt=icons></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><spinner ng-if=loading></spinner><div class="flex flex-row"><div class="flex-20 step-tag-container"><div class="flex flex-row cursor-point" ng-click=goStep(1)><div ng-class="issueData.step==2?\'step-blue-back\':\'\'" class="step-level-circle flex-center"><span class=ft_12_600_blue_back>1</span></div><span class=ml-16 ng-class="issueData.step==1?\'ft_14_600_moreblack\':\'ft_14_regular_black2\'" translate=\'{{issueData.editMode ? "Edit Issue" : "Add Issue1"}}\'></span></div><div class="step-step-bridge ml-12"></div><div class="flex flex-row cursor-point" ng-click=goStep(2)><div ng-class="issueData.step==3?\'step-blue-back\':\'\'" class="step-level-circle flex-center"><span class=ft_12_600_blue_back>2</span></div><span class=ml-16 ng-class="issueData.step==2?\'ft_14_600_moreblack\':\'ft_14_regular_black2\'" translate=\'{{issueData.editMode ? "Edit 2D/3D" : "Add 2D/3D"}}\'></span></div></div><div class="flex-80 p-24"><div class=step1 ng-show="issueData.step==1"><div class=header translate=\'{{issueData.editMode ? "EDIT ISSUE" : "ADD ISSUE"}}\'></div><div class=content><div class="flex flex-row"><div class=flex-1><div class="ft_14_600_moreblack required mt-16" translate="Issue Title"></div><input type=text class="login_input_new mb-24 w-100" placeholder="{{\'Enter Issue\' | translate}} & {{\'Title1\' | translate}}" ng-model=issueData.title autofocus><div class="ft_14_600_moreblack required" translate="Issue Category1"></div><selectbox-input class="arrowbottom_46_400 input-select mb-24" ng-model=issueData.issueCategory options=categoryList label-field=label value-field=key placeholder="Select Category"></selectbox-input><div class=ft_14_600_moreblack translate=Admin></div><div class="w-357 mb-20"><selectbox-input class="arrowbottom_46_400 input-select mb-24" ng-model=issueData.admin options=userList label-field=label value-field=key select-event=changeAdmin() placeholder="Select Admin"></selectbox-input></div><div class=ft_14_600_moreblack translate="Assigned To1"></div><selectbox-input class="arrowbottom_46_400 input-select mb-24" ng-model=issueData.assignedTo options=allRoofers label-field=label value-field=key placeholder="Select Assigned to"></selectbox-input></div><div class=ml-24><button data-wow-delay=1.3s class="btn-trans mt-16"><img width=354 height=310 ng-src="{{!!imageURL ? imageURL : issueData.image.secure_url ? issueData.image.secure_url : \'/assets/images/suppliers/upload.png\'}}" alt=upload ngf-select name=file ngf-change="changeImage($files, $event)" ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-accept="\'.jpg,.jpeg,.png\'" aria-invalid=false data-wow-delay=0.7s onerror="this.style.display=\'none\';" class="br-4 object-fit-cover"></button></div></div><div class=ft_14_600_moreblack translate=Description></div><textarea class=mb-24 placeholder="{{\'Enter your description here\' | translate}}" ng-model=issueData.description rows=6></textarea><div class="flex flex-row mb-8"><div class=flex-1><div class="ft_14_600_moreblack required" translate="Select Priority"></div><selectbox-input class="arrowbottom_46_400 input-select mb-24" ng-model=issueData.priority options=priorityList label-field=label value-field=key placeholder="Select Priority"></selectbox-input><div class=ft_14_600_moreblack translate="Depend on"></div><selectbox-input class="arrowbottom_46_400 input-select mb-24" ng-model=issueData.dependencyOn options=workTypes label-field=tagName value-field=_id placeholder="Select Depends on"></selectbox-input></div><div class="flex-1 ml-24"><div class="ft_14_600_moreblack required" translate="Completion Status"></div><selectbox-input class="arrowbottom_46_400 input-select mb-24" ng-model=issueData.status options=statusList label-field=label value-field=key placeholder="Select Status"></selectbox-input><div class=ft_14_600_moreblack translate=Deadline></div><div class="input-group datePicker mb-24" style="margin-top: 7px;"><input type=text class="login_input_new w-100" date-picker=dd/MM/yyyy date=issueData.deadLine is-open=isDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isDatepickerOpen = !isDatepickerOpen" style=top:16px;><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div><div class="flex flex-row flex-between"><button class="btn_new_blue client_gray_white_back mr-16 pv-8 pl-6 pr-12" ng-click=exitCreateIssue() style="width: 72px;"><img src=/assets/icons/delete1.svg style="margin-right: 4px;" alt=icons><span class=ft-600-12-16 translate=Cancel></span></button> <button class="btn_new_blue pv-8 pl-12 pr-6" ng-click=goStep(2) style="width: 72px;"><span translate=Next></span><img src=/assets/icons/arrow-right-white-issue.svg style="margin-left: 4px;" alt=icons></button></div></div></div><div class=step2 ng-show="issueData.step==2"><div class=header><div>{{issueData.editMode ? \'Edit 3D Model / 2D Drawing\' : \'Add 3D Model / 2D Drawing\'}}</div><div class="switch switch-sm"><input type=checkbox class=switch id=statusValue ng-model=isVP ng-checked=isVP> <label for=statusValue></label></div></div><div class=content><div class="flex flex-col mt-16" ng-show=!isVP><div class="flex flex-row mb-24"><div class="flex-1 mr-12"><div class="ft_14_600_moreblack required" translate="3D Model"></div><selectbox-input class="arrowbottom_46_400 input-select" ng-model=issueData.marker.info3d.modelId options=m3dList label-field=name value-field=_id select-event=change3dModel() disabled placeholder="Select 3D Model"></selectbox-input></div><div class="flex-1 ml-12"><div class=ft_14_600_moreblack translate="Select Level"></div><selectbox-input class="arrowbottom_46_400 input-select" ng-model=issueData.marker.info3d.level options=m3dLevelList label-field=name value-field=guid select-event=change3dModelLevel() disabled placeholder="Select Level"></selectbox-input></div></div><div class="flex flex-row mb-24"><div class="flex-1 mr-12"></div><div class="flex-1 flex-content-end flex-end ml-12"><button class="btn_new_blue pv-8 pl-6 pr-12" ng-click=goAddMarking()><img src=/assets/icons/bx-plus16.svg style="margin-left: 4px;" alt=icons> <span translate="Add Markings"></span></button></div></div><div class="flex flex-row"><div class="flex-1 mr-12"><div id=loading3d-container class=d-none><img src=/assets/images/cgviewer/cloud_loading.gif alt=""></div><div id=model3d-preview-container><div id=model3d-preview class="no-zoom render-3d"></div></div><div class=flex><div class="ft_14_600_gray mr-20"><div class=mb-10 translate=Elevations></div><div class=mb-10 translate=Name></div><div class=mb-10 translate=Level></div></div><div class=ft_14_regular_gray><div class=mb-10>9.7 m</div><div class=mb-10 ng-if=vm.selected3dModel>{{vm.selected3dModel.name}}</div><div class=mb-10 ng-if=issueData.marker.info3d>{{issueData.level}}</div></div></div></div><div class="flex-1 ml-12"><div id=loading2d-container class=d-none><img src=/assets/images/cgviewer/cloud_loading.gif alt=""></div><div id=model2d-preview-container><div id=model2d-preview class=no-zoom></div></div></div></div></div><div class="flex flex-col mt-16" ng-show=isVP><div class="flex flex-row mb-24"><div class=flex-1><div class=ft_14_600_moreblack translate=VP></div><selectbox-input class="arrowbottom_46_400 input-select" ng-model=issueData.marker.info3d.modelId options=vpList label-field=title value-field=_id select-event=changeVP() disabled placeholder=VP></selectbox-input></div><div class="flex-1 flex-content-end flex-end"><button class="btn_new_blue pv-8 pl-6 pr-12" ng-click=goAddMarking()><img src=/assets/icons/bx-plus16.svg style="margin-left: 4px;" alt=icons> <span translate="Add Markings"></span></button></div></div><div id=loadingvp-container class=d-none><img src=/assets/images/cgviewer/cloud_loading.gif alt=""></div><div id=vp-preview-container><div id=vp-preview class=no-zoom></div></div></div><div class="flex flex-row flex-between mt-32"><div><button class="btn_new_blue client_gray_white_back mr-16 pv-8 pl-6 pr-12" ng-click=exitCreateIssue()><img src=/assets/icons/delete1.svg style="margin-right: 4px;" alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div><div class="flex flex-row"><button class="btn_new_blue pv-8 pr-12 pl-6" ng-click=goStep(1) style="width:70px; padding:0"><img src=/assets/icons/left-arrow1.svg style="margin-right: 4px; width: 12px; height: 12px;" alt=icons> <span translate=Prev></span></button> <button class="btn_new_blue pv-8 pl-12 pr-6 ml-16" ng-click=vm.createIssue() style="width:70px; padding:0"><span translate=Done></span><img src=/assets/icons/arrow-right-white-issue.svg style="margin-left: 4px;" alt=icons></button></div></div></div></div><div class=step3 ng-show="issueData.step==3"><div class="content flex-center"><div class=text-center><img src=/assets/icons/checked-lg.svg alt=""><div class="ft_36_600_black mt-30 mb-10" translate=Congratulations></div><div class=ft_24_600_gray>Your issue is successfully {{issueData.editMode ? "updated" : "created"}}</div><div class="ft_24_600_gray mt-10 mb-30">Thank You !</div><button class=btn_primary ng-click=exitCreateIssue() translate=Continue></button></div></div></div></div></div></div></div></div></main></div>');
$templateCache.put('app/main/issues/issue-detail/issue-detail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=issue-detail class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=issuesList translate=Issues></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Issue Details"></a></div><div class=ft_24_600_black1 translate="Issue Details"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=editIssue()><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=deleteIssue()><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=issuesList><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class=content-wrapper><div class=contents><div class=item1><div class=content><div class=flex-between><div class=ft_12_regular_blackgrey>{{issue.systemTag}}</div><div class="flex flex-row"><div class="rect mr-8" ng-class=getIssueStatusClass(issue.status)>{{issue.status}}</div><div class=rect ng-class=getIssuePriorityClass(issue.priority)>{{issue.priority}}</div></div></div><div class="ft_16_600_black mb-8">{{issue.title}}</div><div class=mb-16><button class=mark ng-if="issue.status !== \'Completed\'" ng-click=markIssueAsComplete()><img src=/assets/icons/mark-disable.svg alt="" class=mr-8><div translate="Mark as Complete"></div></button> <button class="mark completed" ng-if="issue.status === \'Completed\'"><img src=/assets/icons/mark-active.svg alt="" class=mr-8><div translate=Completed></div></button></div><div class=mb-24><div class=pos-relative><img ng-if="issue.image && issue.image.secure_url" src=/assets/icons/maximize.svg class=max-icon ng-click="issueImageByType(issue.image, \'photo\')"> <img ng-if="issue.image && issue.image.secure_url" ng-src={{issue.image.secure_url}} class="issue-img object-fit-cover"><div ng-if="!issue.image || !issue.image.secure_url" class=issue-img style="border: 1px dashed #d1d1d1;">No Image</div></div></div><div class="flex-row flex-items-center flex-between mb-24"><div class="flex-1 mr-8"><div class="ft_14_600_moreblack mb-4" translate=Priority></div><div class=dropdown><selectbox-input class="input-select w-100" ng-model=issue.priority options=priorityList label-field=label value-field=value disabled select-event=updateIssueStatusOrPriority()></selectbox-input></div></div><div class="flex-1 ml-8"><div class="ft_14_600_moreblack mb-4" translate=Status></div><div class=dropdown><selectbox-input class="input-select w-100" ng-model=issue.status options=statusList label-field=label value-field=value is-disabled="{{issue.status == \'Completed\'}}" select-event=updateIssueStatusOrPriority()></selectbox-input></div></div></div><!-- <div class="flex-between mb-2" ng-if="issue.marker">\n              <div class="ft_12_600_black">{{(issue.marker.modelType == \'3d\' ? \'2D/3D\' : \'VP\') + \' View\'}}</div>\n              <div class="switch switch-sm" ng-show="issue.marker.modelType == \'3d\'">\n                <input\n                  type="checkbox"\n                  class="switch"\n                  id="statusValue"\n                  ng-model="is3D"\n                  ng-click="viewTypeChanged()"\n                />\n                <label for="statusValue"></label>\n              </div>\n            </div> --><!-- <div class="d-view">\n              <img ng-if="is3D && issue.image3DPath || !is3D && issue.image2DPath" src="/assets/icons/maximize.svg" class="object-fit-cover max-icon"\n                ng-click="issueModelImageByType(issue)"/>\n              <div ng-if="issue.marker.modelType == \'3d\'" class="marking-viewer-container pos-relative">\n                <img ng-if="is3D && issue.image3DPath" ng-src="{{issue.image3DPath}}" alt="" class="marking-viewer object-fit-cover">\n                <img ng-if="!is3D && issue.image2DPath" ng-src="{{issue.image2DPath}}" alt="" class="marking-viewer object-fit-cover">\n                <div ng-if="!issue.image3DPath || !issue.image2DPath" class="issue-img" style="border: 1px dashed #d1d1d1;">No Image</div>\n              </div>\n              <div class="marking-viewer-container pos-relative" ng-if="issue.marker.modelType != \'3d\' && issue.image3DPath">\n                <img ng-src="{{issue.image3DPath}}" alt="" class="issue-img object-fit-cover">\n              </div>\n            </div> --><div class="ft_14_regular_gray2 mb-4" translate="Project Name"></div><div class="ft_14_600_black mb-24">{{issue.projectId.projectName}}</div><div class="flex flex-row"><div class="flex-1 mr-8"><div class="ft_14_regular_gray2 mb-4" translate="Created on"></div><div class="ft_14_600_black mb-16">{{issue.createdAt | date: "dd MMM yyyy" : \'UTC\' }}</div></div><div class="flex-1 ml-8"><div class="ft_14_regular_gray2 mb-4" translate="Due Date"></div><div class="ft_14_600_black mb-16">{{issue.deadLine | date: "dd MMM yyyy" : \'UTC\'}}</div></div></div><!-- <div class="ft_14_regular_gray2 mb-4" translate="Issue Type"></div>\n            <div class="ft_14_600_black mb-16">{{issue.issueCategory}}</div> --><div class="ft_14_regular_gray2 mb-4" ng-if=issue.createdBy translate="Created by"></div><div class="ft_14_600_black mb-16" ng-if=issue.createdBy>{{issue.createdBy}}</div><div class="ft_14_regular_gray2 mb-4" ng-if=issue.assignedTo.length translate="Assigned To"></div><div class="ft_14_600_black mb-16"><img ng-attr-title={{assigner.displayName}} ng-src={{assigner.profilePic}} ng-repeat="assigner in issue.assignedTo" class=assignerAvatar></div></div></div><div class="item2 flex-1"><div class=header><div class=tab ng-click="switchTab(\'Conversations\')" ng-class="currentTab === \'Conversations\' ? \'active\' : \'inactive\'" translate=Conversations></div><div class=tab ng-click="switchTab(\'History\')" ng-class="currentTab === \'History\' ? \'active\' : \'inactive\'" translate=History></div></div><div class=detail><!-- <live-chat-new ng-show="currentTab === \'Conversations\'" unique-name="{{issue._id}}"></live-chat-new> --><synergy-chat ng-show="currentTab === \'Conversations\'" room-eid={{issue.synergyRoomEid}}></synergy-chat><div ng-show="currentTab === \'History\'"><issue-history ng-repeat="activity in activities" ng-model=activity></issue-history></div></div></div></div></div></div><spinner ng-if=isLoading></spinner></main>');
$templateCache.put('app/main/issues/issues-list/issues-list.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=issues-list class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Issues></a></div><div class=ft_24_600_black1 translate=Issues></div></div><searchbox class=ml-auto search-text=searchText search-event=searchIssues() is-small=true></searchbox><div><button class="btn-trans ml-16" ng-click="isGrid = false"><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click="isGrid = true"><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button></div><button class="btn_new_blue ml-16" ng-click=onCreateIssue() ng-if="ISSUE_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Add Issue1"></span></button></div><div><spinner ng-show=loading></spinner><no-data ng-if="totalCount==0" text="{{loading ? \'Loading...\' : \'No Data to Display\'}}"></no-data><div ng-if="totalCount > 0"><div ng-if=isGrid><div class="flex flex-wrap mb-24 card-based-content-grid-wrapper pv-24"><div class="flex flex-wrap flex-row w-100"><div class=card-item ng-repeat="issue in vm.issues"><div class=cursor-point ng-click=goToDetail(issue._id)><div class=card-radius><div class=img-wrap><img ng-src="{{ issue.image && issue.image.secure_url?issue.image.secure_url:\'/assets/icons/tender.svg\' }}" alt="" onerror="this.src=\'/assets/icons/tender.svg\'" width=100% height=156></div><div class=card-content><div class=flex-between><div class="ft_12_600_black tx-ellipsis">{{issue.systemTag}}</div><div class=flex><div class="rect mr-8" ng-class=getIssueStatusClass(issue.status)>{{issue.status}}</div><div class=rect ng-class=getIssuePriorityClass(issue.priority)>{{issue.priority}}</div></div></div><div class="flex mt-10"><div class="ft_16_600_black tx-ellipsis">{{issue.title}}</div></div><div class=flex><div class=ft_14_regular_gray2 translate=Due></div>:&nbsp;<div class=ft_14_regular_gray2>{{issue.createdAt | date: "dd MMM yyyy" : \'UTC\' }}</div></div></div><div class="flex-between issue-card-footer"><div class="flex flex-row"><img style="margin-right: 7px;" src=/assets/images/suppliers/tag.svg alt=icons><div class=ft_12_600_black>{{issue.issueCategory}}</div></div><div class="flex flex-row"><div class=ft_12_600_black>{{issue.projectId.projectName}}</div><img style="margin-left: 7px;" src=/assets/icons/domain-blue.svg alt=icons></div></div></div></div></div></div><div class=flex-1><div class="flex flex-row flex-items-center pull-right"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span>{{vm.currentPage * numPerPage > totalCount? totalCount: vm.currentPage * numPerPage}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=totalPages current-page=vm.currentPage on-select-page=searchIssues()></pagination-custom-new></div></div></div></div></div><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer" ng-if=!isGrid><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=supplier.checked> <span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate=SystemTag></span></th><th class=ft_14_600_black><span translate=Title></span></th><th class=ft_14_600_black><span translate="Project Name"></span></th><th class=ft_14_600_black><span translate="Status & Priority"></span></th><th class=ft_14_600_black><span translate=Date></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, issue) in vm.issues"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=issue.checked> <span class=checkmark></span></label></td><td class=cursor-point ng-click=goToDetail(issue._id) class="ft_14_regular_black tx-ellipsis name">{{issue.systemTag}}</td><td class="tx-ellipsis email ft_14_regular_black" ng-bind=issue.title></td><td class=ft_14_regular_black>{{issue.projectId.projectName}}</td><td class=flex-row><span class="rect mr-8" ng-class=getIssueStatusClass(issue.status)>{{issue.status}}</span> <span class=rect ng-class=getIssuePriorityClass(issue.priority)>{{issue.priority}}</span></td><td class="tx-ellipsis address pr-20 ft_14_regular_black">{{issue.createdAt | date: "dd MMM yyyy" : \'UTC\' }}</td><td class="more flex-items-center cursor-point"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class=margin-0></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span>{{vm.currentPage * numPerPage > totalCount? totalCount: vm.currentPage * numPerPage}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=totalPages current-page=vm.currentPage on-select-page=searchIssues()></pagination-custom-new></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/issues/issues-marking/issues-marking.view.html','<div id=issues-marking><main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="title-bar flex flex-row flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2 cursor-point" ng-click=exitCreateIssue() translate=Issue></a></div><div class=ft_24_600_black1 translate="Issue Marking"></div></div><div class="flex flex-row flex-items-center"><span class="switch switch-sm" ng-show="vm.issueData.marker.modelType == \'3d\' && !isOnly3D"><input type=checkbox class=switch id=statusValue ng-model=is3D ng-checked=viewTypeChanged()> <label for=statusValue></label> </span><button class="btn_new_blue client_gray_white_back mr-16 pv-8 pl-6 pr-12" ng-click=onCancel()><img src=/assets/icons/close-16-black.svg style="margin-right: 4px;" alt=icons><span class=ft-600-12-16 translate=Cancel></span></button> <button class="btn_new_blue pv-8 pr-12 pl-6 mr-16" ng-click=addMarker()><img src=/assets/icons/add-circle.svg style="margin-right: 4px;" alt=icons><span translate="Add Markings"></span></button> <button class="btn_new_blue pv-8 pl-12 pr-6" ng-click=onContinue()><span translate=Next></span><img src=/assets/icons/arrow-right-white-issue.svg style="margin-left: 4px;" alt=icons></button></div></div><!-- <div class="header flex-between">\n      <div class="ft_24_600_white" translate="Issue Marking"></div>\n      <div class="flex-center">\n        <span class="switch switch-sm" ng-show="vm.issueData.marker.modelType == \'3d\' && !isOnly3D">\n          <input type="checkbox" class="switch" id="statusValue" ng-model="is3D" ng-checked="viewTypeChanged()"/>\n          <label for="statusValue"></label>\n        </span>\n        <button class="btn_primary flex-center" ng-click="addMarker()">\n          <img src="/assets/icons/add-circle.svg" alt="" />\n          <div translate="Add Markings"></div>\n        </button>\n        <img src="/assets/icons/trash2.svg" alt="" class="mh-20" ng-click="removeMarker()" />\n        <img src="/assets/icons/close2.svg" alt="" ng-click="onCancel()"/>\n      </div>\n    </div> --><div class=content-wrapper><div class=content><div class=marking-viewer-container><div id=marking-viewer-3d class=marking-viewer ng-show="vm.issueData.marker.modelType == \'3d\'"></div><div id=marking-viewer-2d class=marking-viewer></div><div id=loading><img src=/assets/images/cgviewer/cloud_loading.gif alt=""></div></div><div class=tool-button ng-if=is3D><img src=/assets/images/cgviewer/toolbar/cross-add.svg alt="" class=cursor-point ng-click=vm.addCutter() ng-if=!vm.hasCutter()> <img src=/assets/images/cgviewer/toolbar/cross-visible.svg alt="" class=cursor-point ng-click=vm.removeCutter() ng-if=vm.hasCutter()></div></div></div></main></div>');
$templateCache.put('app/main/mail/compose/compose.view.html','<div id=mailComposeContent><div id=mailComposeMain><div class=filter><div class=left-filter-container><div class=filter-item><span class="ft_14_600_black filter-blank project-blank">Project ID:</span><div class=filter-select><span class="ft_14_600_black filter-blank project-blank">{{vm.selectedProject.systemTag}}</span></div></div><div class="filter-item filter-tq"><span class="ft_14_600_black filter-blank tq-blank">Descipline:</span><div class=filter-select><selectbox id=discipline options=vm.discipList label-field=label value-field=key ng-model=vm.tqDiscipline select-event=changetqDiscipline(vm.tqDiscipline)></selectbox></div></div><div class="filter-item filter-tq"><span class="ft_14_600_black filter-blank tq-blank">TQ:</span><div class=filter-select><selectbox id=gender options=vm.tqlist label-field=title value-field=title ng-model=vm.tqtitle></selectbox></div></div><!-- <div class="filter-item filter-tags">\n          <span class="ft_14_600_black filter-blank tq-blank">Tags:</span>\n          <div class="filter-select">\n            <selectbox\n                id="tags"\n                options="vm.tags"\n                label-field="label"\n                value-field="label"\n                ng-model="vm.tag"\n                placeholder="Important"\n                select-event="changetag(vm.tag)">\n            </selectbox>\n          </div>\n        </div> --></div><div class=filter-item><div class=filter-checked><checkbox class=filter-shared is-small=true ng-model=bill.checked></checkbox><span class=filter-checked-span translate=Shared></span></div><img class="mr-20 cursor-point" src=/assets/icons/warning_outline.svg ng-click=addimportanttag() ng-if=!vm.importanttag> <img class="mr-20 cursor-point" src=/assets/icons/warning-red.svg ng-click=deleteimportanttag() ng-if=vm.importanttag><!-- <img class="mr-20 cursor-point" src="/assets/icons/star_border.svg"/> --><!-- <img class="mr-20 cursor-point" src="/assets/icons/tag-outline.svg" ng-click="onClose()"/>\n        <img class="cursor-point" src="/assets/icons/more_vert.svg" ng-click="onClose()"/> --></div></div><div class="filter tag-filter" ng-if=false><div class=filter-item><div class=filter-checked ng-repeat="tag in vm.tags"><!-- checkbox class="filter-shared" is-small="true" ng-model="tag.checked" ng-change="vm.changetag(tag)"></checkbox>\n          <span class="filter-checked-span"></span>--> <button class="tag-btn {{tag.activeclass}} mr-2 ml-2" ng-click=selecttag(tag)>{{tag.label}}</button></div></div></div><div class=mail-content><div class=send-to><div class="tos send-to-item d-flex"><span class=label>To</span><div class=items><span class=item ng-repeat="item in vm.tos">{{item}} <img class=cursor-point src=/assets/icons/close-16.svg ng-click=removeToItem(item)> </span><input ng-model=to ng-keyup=onKeyupSendto($event) ng-blur=onBlurSendto()> <span class="btn btn-span-cc" ng-click="isCc = !item.statusValue;">Cc</span> <span class="btn btn-span-bcc" ng-click="isBcc = !item.statusValue;">Bcc</span></div></div><div class="cc send-to-item d-flex" ng-if=isCc><span class=label>Cc</span><div class=items><span class=item ng-repeat="item in vm.ccs">{{item}} <img src=/assets/icons/close-16.svg ng-click=removeCcItem(item)> </span><input ng-model=vm.cc ng-keyup=onKeyupCc($event) ng-blur=onBlurCc()> <img class="btn btn-useradd btn-border" src=/assets/icons/user-plus-full.svg ng-click=addCcItem(item)> <img class="btn btn-remove" src=/assets/icons/trash_g.svg ng-click=removeCcItem(item)></div></div><div class="bcc send-to-item d-flex" ng-if=isBcc><span class=label>Bcc</span><div class=items><span class=item ng-repeat="item in vm.bccs">{{item}} <img src=/assets/icons/close-16.svg ng-click=removeBccItem(item)> </span><input ng-model=vm.bcc ng-keyup=onKeyupBcc($event) ng-blur=onBlurBcc()> <img class="btn btn-useradd btn-border" src=/assets/icons/user-plus-full.svg ng-click=addBccItem(item)> <img class="btn btn-remove" src=/assets/icons/trash_g.svg ng-click=removeBccItem(item)></div></div></div><div class=subject><span class="label m-0" translate=Subject></span> <input class=subject-input ng-model=subject></div><div class=mail-compose-content><!-- <text-angular ng-model="message"></text-angular> --> <textarea name=message_area id=message_area ng-model=message rows=10 cols=80></textarea><div class=mail-signature><div class=mail-signature-image-container><img class=signature-icon src={{vm.fileObjectUrl}} ng-if=vm.isSignature> <img class="signature-close cursor-point" src=/assets/icons/close-16.svg ng-if=vm.isSignature ng-click=removeSignature()></div></div><div class=compose-bottom-content><div class="send-options d-flex"><div class=flex-1><button class="send cursor-point" ng-click=sendEmail()><img class=send-icon src=/assets/icons/paper-plane.svg> Send</button></div></div></div></div><!-- <div class="attached-files d-flex flex-wrap p-4">\n        <div class="d-flex align-items-center rounded cloudes-bg-light-grey mr-3 p-3" ng-repeat="attachedFile in vm.attachedFiles" style="width: 150px;">\n          <img src="/assets/icons/file.svg"/>\n          <span class="flex-spacer text-ellipsis" title="{{attachedFile.name}}">{{attachedFile.name}}</span>\n        </div>\n      </div> --></div></div><div id=mailComposeAttach><div class=attach><span class=ft_14_600_black translate=Attachments></span></div><center><div class=browse-file><span translate="Maximum allowed file size 25 MB"></span> <button class="btn_browse outline-none border-0 bg-transparent" ngf-select ng-model=vm.inputImg ngf-change=vm.fileUpdated($files) name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.doc,.DOC,.docx,.DOCX,.pdf,.PDF\'" ngf-multiple=true ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.doc,.DOC,.docx,.DOCX,.pdf,.PDF\'"><img class="icon cursor-point" src=/assets/icons/attachment-white.svg> <span translate="Attach File(s)"></span></button></div></center><!-- Attachments--><div class=block-list><div class=block-header><div class=block-title translate="{{vm.attachCount}} Attachments"></div><div class=action-button ng-click=removeAll()><span translate="Remove all" class=remove-all></span></div></div><div class="bodyScroll pos-relative"><div ng-repeat="attachedFile in vm.attachedFiles track by $index" class=attach-item><div class=item-container><div class=item-icon><img ng-if="attachedFile.type == \'application/msword\' || attachedFile.type == \'application/vnd.openxmlformats-officedocument.wordprocessingml.document\'" src=/assets/images/email/doc.svg> <img ng-if="attachedFile.type == \'application/pdf\'" src=/assets/images/email/pdf.svg> <img ng-if="attachedFile.type == \'image/jpg\' || attachedFile.type == \'image/jpeg\' || attachedFile.type == \'image/png\'" src="{{vm.arrFilesUrl[$index] ? vm.arrFilesUrl[$index] : \'\'}}"></div><div class=item-wrapper><div class="item-name tx-ellipsis">{{attachedFile.name}}</div><div class=flex><div class=item-size>{{attachedFile.size / 1024 | number:2}} KB</div><div class="ml-auto status-tag flex-center"><img class="icon cursor-point" src=/assets/icons/trash_g.svg ng-click=removeFile($index)></div></div></div></div></div></div></div><!-- Technical Queries--><div class=block-list><div class=block-header><div class=block-title translate="Technical Queries"></div><div class=action-button ng-click=removeAll()><img class=filter-export src=/assets/icons/export-default.svg alt=""><span translate="Export as PDF"></span></div></div><div class="bodyScroll pos-relative"><div class=tq-filter-item><span class="ft_12_600_black filter-blank">TQ</span><div class=tq-filter-select><selectbox id=gender options=genderList label-field=label value-field=value ng-model=vm.userData.gender></selectbox></div></div><div class=tq-filter-item><span class="ft_12_600_black filter-blank" translate=Deadline></span><div class=tq-filter-select><div class="input-group datePicker"><input type=text class=filter-input date-picker=dd.MM.yyyy date=startDate is-open=isDatepickerOpenStartDate ng-required=true> <span class=dateArrow ng-click="isDatepickerOpenStartDate = !isDatepickerOpenStartDate"><img src=/assets/icons/bx-calendar-blue.svg alt=""></span></div></div></div><div class=tq-filter-item><span class="ft_12_600_black filter-blank" translate=Status></span><div class=tq-filter-select><div class=btn-group><div class=btn-item-status-delay translate="Delay By"></div><div class=btn-item-status-days>2 <span translate=Days></span></div></div></div></div></div></div><!-- TQ Activity--><div class="block-list block-tq-activity"><div class="block-header block-tq-header"><div class=block-title translate="TQ Activity"></div><div class=flex-center><div class="btn-group ml-15"><div class="btn-item active" ng-class="{\'active\': type == \'open\'}" ng-click="onSelectType(\'open\')">Open</div><div class=btn-item ng-class="{\'active\': type == \'close\'}" ng-click="onSelectType(\'close\')">Close</div></div></div></div><div class="bodyScroll block-tq-bodyscroll pos-relative"><div class=tq-activity-filter-item><div class=filter-value><img src=/assets/icons/message-icon.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.resolved }} Replied by <b>Martin Knudsen</b></span><span class=activity-amount translate=01.003></span></div><div class=filter-value><img src=/assets/icons/checked-default.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.resolved }} Replied</span><span translate="26/09/2021 5:24pm"></span></div><div class="filter-value filter-bottom"><img src=/assets/icons/warning-default.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.opened }} Delay by 2 days</span></div><div class="filter-value filter-seperator"></div></div><div class=tq-activity-filter-item><div class=filter-value><img src=/assets/icons/message-icon.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.resolved }} Replied by <b>Martin Knudsen</b></span><span class=activity-amount translate=01.003></span></div><div class=filter-value><img src=/assets/icons/check-mark-blue.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.resolved }} Opened</span><span translate="26/09/2021 5:24pm"></span></div><div class="filter-value filter-bottom"><img src=/assets/icons/warning-default.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.opened }} Due in by 2 days</span><img class=reminder src=/assets/icons/coolicon.svg alt=icon><span translate="Send Reminder"></span></div><div class="filter-value filter-seperator"></div></div><div class=tq-activity-filter-item><div class=filter-value><img src=/assets/icons/message-icon.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.resolved }} Replied by <b>Martin Knudsen</b></span><span class=activity-amount translate=01.003></span></div><div class=filter-value><img src=/assets/icons/check-mark-blue.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.resolved }} Opened</span><span translate="26/09/2021 5:24pm"></span></div><div class="filter-value filter-bottom"><img src=/assets/icons/warning-default.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.opened }} Due in by 5 days</span><img class=reminder src=/assets/icons/coolicon.svg alt=icon><span translate="Send Reminder"></span></div><div class="filter-value filter-seperator"></div></div><div class=tq-activity-filter-item><div class=filter-value><img src=/assets/icons/message-icon.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.resolved }} Created by <b>Martin Knudsen</b></span><span class=activity-amount translate=01.003></span></div><div class=filter-value><img src=/assets/icons/check-mark-green.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.resolved }} Sent</span><span translate="26/09/2021 5:24pm"></span></div><div class="filter-value filter-bottom"><img src=/assets/icons/warning-default.svg alt=icon><span class=tq-activity>{{ vm.issuesCount.opened }} Due in by 5 days</span></div></div></div></div></div></div>');
$templateCache.put('app/main/mail/detail/detail.view.html','<div id=mailDetail ng-class="{\'menu-collapse\': isCollapse}"><!-- <h1>Mail Inbox</h1> --><div id=user-list-pane class=user-list-pane ng-if=!isCompose><div class=filter><span class=title>{{vm.type}}</span><!-- <img class="search-icon cursor-point" src="/assets/icons/search-16.svg"/> --> <input bse-input submit-required=true class=search-input placeholder=Search ng-keypress=onSearchKeypress($event) ng-model=vm.search></div><div class=user-list scrolly=loadMore()><!-- active || highlight for item-wrapper types --><div class="item-wrapper cursor-point" ng-class="{active: item.seqNo == vm.selectedEmail.seqNo}" ng-repeat="item in vm.mails" ng-click=onMailItemClick(item)><div class=item><!-- <div class="mail-item-active-bar"></div> --><div class="d-flex p-4 flex-1 detail-pd overflow-hidden"><div class=info><div class=name-wrapper><span class="name fw-400" ng-if="vm.type != \'Sent\' && vm.type != \'Drafts\'" ng-class="{\'fw-900\': !item.flags.includes(\'\\\\Seen\') && vm.type==\'Inbox\'}">{{item.from.name ? removeDot(item.from.name) : removeDot(item.from.email)}}</span> <span class="name fw-400" ng-if="vm.type == \'Sent\'">{{item.to.name ? removeDot(item.to.name) : removeDot(item.to.email)}}</span> <span class="name fw-400" ng-if="vm.type == \'Drafts\'">{{item.to.name ? removeDot(item.to.name) : (item.to.email ? removeDot(item.to.email) : \'(none)\')}}</span> <span class=time ng-class="{\'fw-900\': !item.flags.includes(\'\\\\Seen\') && vm.type==\'Inbox\'}">{{item.date | mailDate}}</span></div><div class=title-wrapper><span ng-class="{\'fw-600\': !item.flags.includes(\'\\\\Seen\') && vm.type==\'Inbox\'}" ng-if="vm.type != \'Drafts\'">{{item.subject}}</span> <span ng-if="vm.type == \'Drafts\'">{{item.subject ? item.subject : \'(no subject)\'}}</span> <img class=stared src=/assets/icons/star-16-outline.svg ng-if="!item.flags.includes(\'\\\\Flagged\')" ng-click="addFlag($event, item)" style="filter: invert(72%) sepia(63%) saturate(6022%) hue-rotate(177deg) brightness(98%) contrast(93%);"> <img class=full-stared src=/assets/icons/star-blue.svg ng-if="item.flags.includes(\'\\\\Flagged\')" ng-click="deleteFlag($event, item)"></div><div class=message><span>{{item.text}}</span></div></div></div></div></div></div></div><div class=content-pane ng-if=!isCompose><spinner ng-show="mailLoading == true"></spinner><div class=mail-details-content ng-if="vm.type != \'Drafts\'"><div class="filter right"><span class=project><div class=font-bold>Project ID:</div><div class="font-project mr-4">{{vm.projectdata}}</div><div class=font-bold>TQ:</div><div class="font-project mr-4">{{vm.tqdata}}</div><button ng-if=vm.isshared>Shared</button> </span><img class="mr-16 mr-16 cursor-point" src=/assets/icons/fm_moveto.svg ng-if="vm.type == \'Trash\'" ng-click=restore(vm.selectedEmail) title=Restore><!-- <img class="trash-icon mr-16 cursor-point" src="/assets/icons/warning_outline.svg" ng-click="moveToTrash(vm.selectedEmail)" title="Delete"/> --> <img class="trash-icon mr-16 cursor-point" src=/assets/icons/warning_outline.svg ng-if=!vm.importanttag title=Important> <img class="trash-icon mr-16 cursor-point" src=/assets/icons/warning-red.svg ng-if=vm.importanttag title=Important> <img class="star-icon mr-16 cursor-point" src=/assets/icons/star_outline.svg ng-click="addFlag($event, vm.selectedEmail)" ng-if="!vm.selectedEmail.flags.includes(\'\\\\Flagged\')" title="Add Favourite"> <img class="star-icon mr-16 cursor-point" src=/assets/icons/star-blue.svg ng-click="deleteFlag($event, vm.selectedEmail)" ng-if="vm.selectedEmail.flags.includes(\'\\\\Flagged\')" title="Remove Favourite"> <img class="reply-icon mr-16 cursor-point" src=/assets/icons/tag-outline.svg ng-click=showtag() ng-if=!vm.tagselected title="Show Tags"> <img class="reply-icon mr-16 cursor-point w-24" src=/assets/images/suppliers/tag.svg ng-click=hidetag() ng-if=vm.tagselected title="Hide Tags"><div class=dropdown><img class=cursor-point src=/assets/icons/more_vert.svg data-toggle=dropdown title=More><ul class="dropdown-menu mail-detail-more" aria-labelledby=user-menu-button><li ng-if="vm.type != \'Trash\'" class="cursor-point dropdown-item ft_14_regular_black" ng-click=moveToTrash(vm.selectedEmail)><img src=/assets/icons/trash_g.svg class=avatar-menu-icon alt=profile> <span translate="Move to Trash"></span></li><li ng-if="vm.type == \'Trash\'" class="cursor-point dropdown-item ft_14_regular_black" ng-click=restore(vm.selectedEmail)><!-- <img src="/assets/icons/trash_g.svg" class="avatar-menu-icon" alt="profile"> --> <span translate="Restore Email"></span></li><li ng-if="vm.type == \'Trash\'" class="cursor-point dropdown-item ft_14_regular_black" ng-click=deleteMail(vm.selectedEmail)><!-- <img src="/assets/icons/trash_g.svg" class="avatar-menu-icon" alt="profile"> --> <span translate="Delete Email"></span></li></ul></div></div><div class="mail-content detail-wrapper"><div class="title-section flex-between"><div class=ft_16_600_black1>{{vm.selectedEmail.subject}}</div><div class=flex ng-if=vm.tagselected><!-- <button class="important">Important</button> --> <button class="warnning mr-2 ml-2" ng-if=vm.warnningtag>Warnning</button> <button class="personal mr-2 ml-2" ng-if=vm.personaltag>Personal</button> <button class="work mr-2 ml-2" ng-if=vm.worktag>Work</button> <button class=payment ng-if=vm.paymenttag>Payments</button></div></div><div class="message-section flex-1 pos-relative overflow-hidden" id=printableArea><div class="message-section-wrapper h-100 flex flex-col"><div class="user-info mb-30" ng-if="vm.type != \'Sent\'"><span class="avatar-text mr-15" ng-style="{ \'background\': (vm.selectedEmail.from.value && vm.selectedEmail.from.value[0].name ? getColor(vm.selectedEmail.from.value[0].name) : getColor(vm.selectedEmail.from.value[0].address)) }">{{vm.selectedEmail.from.value && vm.selectedEmail.from.value[0].name ? vm.selectedEmail.from.value[0].name : vm.selectedEmail.from.value[0].address | mailAvatarChar}}</span><div class="name-wrapper mail-main-wrapper"><span class="name ft_14_600_moreblack text-left">{{vm.selectedEmail.from.value ? removeDot(vm.selectedEmail.from.value[0].name) : removeDot(vm.selectedEmail.from.name)}}</span> <span class="email ft_14_regular_light text-left">{{vm.selectedEmail.from.value ? vm.selectedEmail.from.value[0].address : vm.selectedEmail.from.email}}</span></div></div><div class="user-info mb-30" ng-if="vm.type == \'Sent\'"><span class="avatar-text mr-15" ng-style="{ \'background\': (vm.selectedEmail.to.value && vm.selectedEmail.to.value[0].name ? getColor(vm.selectedEmail.to.value[0].name) : getColor(vm.selectedEmail.to.value[0].address)) }">{{vm.selectedEmail.to.value && vm.selectedEmail.to.value[0].name ? vm.selectedEmail.to.value[0].name : vm.selectedEmail.to.value[0].address | mailAvatarChar}}</span><div class=name-wrapper><span class="name ft_14_600_moreblack text-left">{{vm.selectedEmail.to.value ? removeDot(vm.selectedEmail.to.value[0].name) : removeDot(vm.selectedEmail.to.name)}}</span> <span class="email ft_14_regular_light text-left">{{vm.selectedEmail.to.value ? vm.selectedEmail.to.value[0].address : vm.selectedEmail.to.email}}</span></div></div><div class="message mb-30 flex-1 overflow-auto" id=message-content-wrap><div ng-bind-html="vm.selectedEmail.html ? vm.selectedEmail.html : vm.selectedEmail.text | removeComment" class=mail-html-wrapper></div></div><div ng-if="vm.selectedEmail.attachments.length>0" style="margin-bottom: 16px;"><img class=mr-2 src=/assets/icons/attachment.svg> <span style="font-weight: 600;color: #464646;">{{vm.selectedEmail.attachments.length}} attachments</span></div><div class="attachment d-flex flex-wrap"><div class=item ng-repeat="attachment in vm.selectedEmail.attachments"><div class="flex flex-items-center"><span class=icon ng-click=downloadAttachment(attachment)><img ng-src={{attachment.url}} ng-if="attachment.contentType.includes(\'image\')" style="width: 100%; height: 100%; border-radius: 8px;"> <img src=/assets/icons/file.svg ng-if="!attachment.contentType.includes(\'image\') && !attachment.contentType.includes(\'pdf\')"> <img src=/assets/icons/ft-pdf.svg ng-if="!attachment.contentType.includes(\'image\') && attachment.contentType.includes(\'pdf\')"></span><div class=info><span class="name title d-block text-ellipsis">{{attachment.filename}}</span> <span class="size size d-block">{{attachment.size | filesize}}</span></div></div></div></div></div><div class=reply-section><button class=btn-reply ng-click=reply()><img class=cursor-point src=/assets/icons/subdirectory_arrow_right.svg> <span>Reply</span></button> <button class="mr-4 ml-4 btn-all" ng-click=reply()><img class=cursor-point src=/assets/icons/subdirectory_arrow_right.svg> <span>Reply All</span></button> <button class=btn-follow ng-click=forward()><img class=cursor-point src=/assets/icons/arrow-right-blue.svg> <span>Forward</span></button></div></div></div></div><div class=mail-details-content ng-if="vm.type == \'Drafts\'"><mail-compose on-close=onCloseComposer() data=vm.selectedEmail type=composeType style="height: 100%;" ng-if=vm.selectedEmail is-draft=true refresh-mail=vm.refreshMail()></mail-compose></div></div><div class=mail-compose-content ng-if=isCompose><mail-compose on-close=onCloseComposer() data="composeType != 0 ? vm.selectedEmail : null" type=composeType is-draft=false></mail-compose></div></div>');
$templateCache.put('app/main/mail/draft/draft.view.html','<spinner ng-show=loading></spinner><div class=mail-details-container><mail-details mails=mails selected-email=selectedEmail type=Drafts is-compose=isCompose on-close=onDetailsPaneClose() on-mail-item-selected=onMailItemClick(mail) on-load-more=loadMore() refresh-mail=refreshMail()></mail-details></div>');
$templateCache.put('app/main/mail/folders/folders.view.html','<spinner ng-show=loading></spinner><div class=mail-details-container><mail-details mails=mails selected-email=selectedEmail type=Folders is-compose=isCompose on-close=onDetailsPaneClose() on-mail-item-selected=onMailItemClick(mail) on-load-more=loadMore() refresh-mail=refreshMail()></mail-details></div>');
$templateCache.put('app/main/mail/inbox/inbox.view.html','<spinner ng-show=loading></spinner><div class=mail-details-container><mail-details mails=mails selected-email=selectedEmail search=seartchtxt type=Inbox is-compose=isCompose on-close=onDetailsPaneClose() on-mail-item-selected=onMailItemClick(mail) on-load-more=loadMore() refresh-mail=refreshMail()></mail-details></div>');
$templateCache.put('app/main/mail/login/login.view.html','<div id=mailLoginComponent><div class=page-content><div><div class=m-auto><h1 class=text-center>Mail Login</h1></div></div><div class=content><div class="item mb-20" ng-show=errorLoginPage><div class="ft_12_600_gray mb-8">Hosting Server</div><selectbox ng-model=hosting_server options=hosts label-field=imap_server value-field=_id enable-add-item=true add-item-event=onAddHost($event)></selectbox></div><div class=item><div class="ft_12_600_gray mb-8">Email</div><input type=email ng-model=email class=login_input placeholder=Email></div><div class=item><div class="ft_12_600_gray mb-8">Password</div><input type=password ng-model=password class=login_input placeholder=Password required ng-show=!show_pass autocomplete=off><!-- <input type="password" class="field-input"\n              ng-model="vm.loginData.password" placeholder="{{\'Enter Password\' | translate}}" required ng-show="!show_pass"\n              autocomplete="off"/> --> <input type=text class=login_input ng-model=password placeholder="Enter Password" required ng-show=show_pass autocomplete=off> <img class="icon cursor-point" ng-src="{{show_pass? \'/assets/icons/eye-off-outline.svg\': \'/assets/icons/eye-outline.svg\'}}" alt=Login ng-click="show_pass = !show_pass" ng-init="show_pass=false"></div><div class="btnGroup mt-30"><button class=btn_new_blue ng-click=onSubmit()>Login</button></div></div></div></div>');
$templateCache.put('app/main/mail/sent/sent.view.html','<spinner ng-show=loading></spinner><div class=mail-details-container><mail-details mails=mails selected-email=selectedEmail search=seartchtxt type=Sent is-compose=isCompose on-close=onDetailsPaneClose() on-mail-item-selected=onMailItemClick(mail) on-load-more=loadMore() refresh-mail=refreshMail()></mail-details></div>');
$templateCache.put('app/main/mail/setting/setting.view.html','<spinner ng-show=isLoading></spinner><div class=mail-details-container><setting-menu ng-if=!isCompose></setting-menu><div id=mailDetail class=setting-main ng-class="{\'menu-collapse\': isCollapse}"><div class=setting-personal-container ng-if=!isCompose><div id=settingPersonMain><div class=right><div class=mb-16><label for=name translate=Name></label> <input type=text id=name placeholder=Name ng-model=vm.responseData.name></div><div class=mb-16><label for=email translate="Email ID"></label> <input type=text id=emailId placeholder="Email ID" ng-model=vm.responseData.emailID></div><div class=mb-16><label for=name translate=Address></label> <input type=text id=address placeholder=Address ng-model=vm.responseData.address></div><div class=mb-16><label for=text translate="Tel. Number"></label> <input type=text id=telephoneNumber placeholder="Tel. Number" ng-model=vm.responseData.telephoneNumber></div><div class=mb-16><label for=text translate=Mobile></label> <input type=text id=mobileNumber placeholder=Mobile ng-model=vm.responseData.mobileNumber></div><div class=mb-16><label for=text translate=Description></label><!-- <text-angular ng-model="vm.reponseData.description"></text-angular> --> <input type=text id=description placeholder=Description ng-model=vm.responseData.description><!-- <textarea id="description" placeholder="Description" ng-model="vm.reponseData.description"></textarea> --></div><div class=mb-16><label for=text translate=Website></label> <input type=text id=website placeholder=Website ng-model=vm.responseData.website></div><div class="mb-8 change-password"><label for=text translate=Password></label><div class=btn-change-pwd><a class=change-auto ng-click=changePwd() translate="Change Password"></a>&nbsp;&nbsp; <label class=change-label for=text translate="\u2022&nbsp;&nbsp;Last changed 12 Dec 2020"></label> <a class=change-auto ng-click=changePwd() translate=Update></a></div></div><div class=mb-8><label for=text></label> <input type=password id=old-password placeholder="Old password" ng-model=vm.responseData.oldpasswd></div><div class=mb-16><label for=text></label> <input type=password id=new-password placeholder="New password" ng-model=vm.responseData.newpasswd></div><div class=signature-block><label for=text translate=Signature></label><div class=signature-image><!-- <img src="/assets/images/email/signature.svg" alt="icon"> --><div class="d-flex flex-column drag-and-drop" ngf-drop ngf-select ngf-change=fileUpdated($files) name=file ngf-multiple=false ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-accept="\'.jpg,.jpeg,.png\'"><div class=browse><div ng-if=!vm.fileObjectUrl><div class="d-flex align-items-center mb-8"><img src=/assets/icons/btn-upload.svg alt="upload icon" class=upload-icon><div>Drop files to upload</div></div><div class="d-flex align-items-center justify-content-center"><div>or</div><div class="ft-blue ph-5" ngf-select ngf-change=fileUpdated($files) name=file ngf-multiple=false ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-accept="\'.jpg,.jpeg,.png\'" translate=Browse></div></div></div><div ng-if=vm.fileObjectUrl style="display: flex; align-items: center;"><img ng-src={{vm.fileObjectUrl}} alt="" class=upload-image-thumbnail ngf-select ngf-change=fileUpdated($files) name=file ngf-multiple=false ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-accept="\'.jpg,.jpeg,.png\'"></div></div></div></div></div><div class=mb-16><label for=text></label><div class=btn-blank><button class="btn-blue mb-16" ng-click=savePersonalInfo()><img src=/assets/icons/save-blue.svg alt=icon><span translate=Save></span></button></div></div></div></div><div id=settingPersonBlank></div></div><div class=mail-compose-content ng-if=isCompose><mail-compose on-close=onCloseComposer() data="composeType != 0 ? vm.selectedEmail : null" type=composeType is-draft=false></mail-compose></div></div></div>');
$templateCache.put('app/main/mail/stared/stared.view.html','<spinner ng-show=loading></spinner><div class=mail-details-container><mail-details mails=mails selected-email=selectedEmail type=Starred is-compose=isCompose on-close=onDetailsPaneClose() on-mail-item-selected=onMailItemClick(mail) on-load-more=loadMore() refresh-mail=refreshMail()></mail-details></div>');
$templateCache.put('app/main/mail/trash/trash.view.html','<spinner ng-show=loading></spinner><div class=mail-details-container><mail-details mails=mails selected-email=selectedEmail type=Trash is-compose=isCompose on-close=onDetailsPaneClose() on-mail-item-selected=onMailItemClick(mail) on-load-more=loadMore() refresh-mail=refreshMail()></mail-details></div>');
$templateCache.put('app/main/managers/managersAdd/managersAdd.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show="isLoading == true"></spinner><div id=managersAdd class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=managersGrid translate=Managers></a></div><div class=ft_24_600_black1 translate="Add Manager"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=createManager()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=createManager()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref=managersGrid><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="MANAGER DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{ !!FILEIMG ? FILEIMG : \'/assets/images/suppliers/upload.png\' }}" alt=upload ngf-select ng-model=picFile name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Manager Name"></div><input type=text ng-model=vm.Manager.name id=firstName class=input-primary placeholder="{{\'Employee Name\' | translate}}" autocomplete=off></div><div class="flex-49 flex-between"><div class=flex-49><div class="ft_14_600_moreblack required" translate=Gender></div><selectbox-input class=dropdown-primary ng-model=vm.Manager.gender options=vm.genderList label-field=name value-field=value></div><div class=flex-49><div class="ft_14_600_moreblack required" translate=Status></div><selectbox-input class=dropdown-primary ng-model=vm.Manager.isActive options=vm.enableList label-field=name value-field=value></div></div></div><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Email ID"></div><input autocomplete=off type=email placeholder="{{\'Email ID\' | translate}}" class=input-primary ng-model=vm.Manager.email></div><div class=flex-49><div class="ft_14_600_moreblack required" translate="Contact No."></div><div class=flex><div ng-if=vm.countryCodes><selectbox-input class="dropdown-primary w-147" ng-model=vm.Manager.mobile.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></div><input autocomplete=off type=number placeholder="{{\'Phone Number\' | translate}}" class="input-primary ml-16" ng-model=vm.Manager.mobile.phoneNumber></div></div></div><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Date of Birth"></div><input ng-click="isBirthDatepickerOpen = !isBirthDatepickerOpen" type=text class=input-primary date-picker=dd/MM/yyyy date=vm.Manager.dob is-open=isBirthDatepickerOpen ng-required=true></div><div class=flex-49><div class="ft_14_600_moreblack required" translate="Date of Joining"></div><input ng-click="isJoinDatepickerOpen = !isJoinDatepickerOpen" type=text class=input-primary date-picker=dd/MM/yyyy date=vm.Manager.doj is-open=isJoinDatepickerOpen ng-required=true></div></div></div></div></div></div><div class=profile-card><span class=label translate=ADDRESS></span><div class="address flex-between flex-wrap mt-16"><div class=flex-100><div class="ft_14_600_moreblack required" translate="Primary Address"></div><input autocomplete=off type=text id=address ng-model=vm.Manager.address1.line1 class=input-primary placeholder="{{\'Include a place or address\' | translate}}"></div><div class=flex-32><div class="ft_14_600_moreblack required" translate=Country></div><div class="w-100 mb-24"><selectbox-input class=dropdown-primary ng-model=vm.Manager.address1.countryCode options=vm.countryCodes label-field=name value-field=code></div></div><div class=flex-32><div class="ft_14_600_moreblack required" translate=City></div><input autocomplete=off type=text class=input-primary placeholder="{{\'City Name\' | translate}}" ng-model=vm.Manager.address1.city id=city></div><div class=flex-32><div class="ft_14_600_moreblack required" translate="Postal Code"></div><input autocomplete=off type=number class=input-primary placeholder="{{\'Postal Code\' | translate}}" ng-model=vm.Manager.address1.postalCode id=postalCode></div><div class=flex-100><div class=ft_14_600_moreblack translate="Secondary Address(Optional)"></div><input autocomplete=off type=text id=address ng-model=vm.Manager.address2.line1 class=input-primary placeholder="{{\'Include a place or address\' | translate}}"></div><div class=flex-32><div class=ft_14_600_moreblack translate=Country></div><div class="w-100 mb-24"><selectbox-input class=dropdown-primary ng-model=vm.Manager.address2.countryCode options=vm.countryCodes label-field=name value-field=code></div></div><div class=flex-32><div class=ft_14_600_moreblack translate=City></div><input autocomplete=off type=text class=input-primary placeholder="{{\'City Name\' | translate}}" ng-model=vm.Manager.address2.city id=city></div><div class=flex-32><div class=ft_14_600_moreblack translate="Postal Code"></div><input autocomplete=off type=number class=input-primary placeholder="{{\'Postal Code\' | translate}}" ng-model=vm.Manager.address2.postalCode id=postalCode></div></div></div><div class=profile-card><span class=label translate="ROLE INFORMATION"></span><div class="role flex-between flex-wrap mt-16"><div class="flex-49 mb-24"><div class=ft_14_600_moreblack translate=Department></div><selectbox-input class=dropdown-primary ng-model=vm.Manager.department options=vm.departmentList label-field=name value-field=_id></div><div class="flex-49 mb-24"><div class=ft_14_600_moreblack translate=Designation></div><selectbox-input class=dropdown-primary ng-model=vm.Manager.subDesignation options=vm.designationList label-field=name value-field=_id></div><div class="flex-49 mb-24"><div class=ft_14_600_moreblack translate="Labour Settings"></div><selectbox-input class=dropdown-primary ng-model=vm.Manager.employeeSettingId options=vm.laberSettingsList label-field=presetName value-field=_id select-event="changeOption(\'ManagerSetting\', vm.Manager.employeeSettingId)"></div><div class="flex-49 mb-24"><div class="ft_14_600_moreblack required" translate=Salary></div><input autocomplete=off type=number class=input-primary ng-model=vm.Manager.salaryAmount place-holder=Salary></div><div class=flex-49><div class="ft_14_600_moreblack required" translate=Dashboard></div><selectbox-input class=dropdown-primary ng-model=vm.Manager.dashboard options=dashboardList label-field=name value-field=_id></div></div><div class="btnGroup flex mt-32"><button class="button-primary mr-16" ng-click=createManager()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=createManager()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref=managersGrid><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/managers/managersDetail/managersDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show="isLoading == true"></spinner><div id=employeesDetail class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=managersGrid translate=Managers></a></div><div class=ft_24_600_black1 translate="Manager Details"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ui-sref="managersEdit({id: vm.Manager._id})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="button-third mr-16" ng-click=deleteManager()><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class=btn_cancel ui-sref=managersGrid><img src=/assets/icons/close-circle-black.svg alt=icons><span translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="MANAGER DETAILS"></span><div class="flex mt-16"><!-- upload photo --><div class=img-container data-wow-delay=1.3s><img width=264 height=264 class="bdRadius-4 object-fit-cover" ng-src="{{ FILEIMG ? FILEIMG : !!vm.Manager.profilePic ? vm.Manager.profilePic : \'/assets/images/suppliers/upload.svg\'}}"></div><div class="w-100 flex-wrap"><div class="flex-between items"><div class=flex-49><div class=ft_14_regular_gray2 translate="Manager Name"></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=vm.Manager.displayName></div></div><div class=flex-49><div class=ft_14_regular_gray2 translate=Active></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind="vm.Manager ? vm.Manager.isActive == true ? \'Active\' : \'Inactive\' : \'\'"></div></div></div><div class="flex-between items"><div class=flex-49><div class=ft_14_regular_gray2 translate="Email ID"></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=vm.Manager.email></div></div><div class=flex-49><div class=ft_14_regular_gray2 translate=Designation></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=vm.Manager.subDesignation></div></div></div><div class="flex-between items"><div class=flex-49><div class=ft_14_regular_gray2 translate="Date of Birth"></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind="vm.Manager.dateOfBirth | date"></div></div><div class=flex-49><div class=ft_14_regular_gray2 translate="Date of Joining"></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind="vm.Manager.dateOfJoin | date"></div></div></div><div class="items flex-between"><div class=flex-49><div class=ft_14_regular_gray2 translate=Gender></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=vm.Manager.gender></div></div><div class=flex-49><div class=ft_14_regular_gray2 translate="Labour Settings"></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=vm.managerSettingLabel></div></div></div><div class="items flex-between flex-wrap"><div class=flex-49><div class=ft_14_regular_gray2 translate="Contact No."></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind="\'+\'+vm.Manager.mobile.dialCode + \' \' + vm.Manager.mobile.phoneNumber"></div></div><div class=flex-49><div class=ft_14_regular_gray2 translate=Salary></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=vm.Manager.salaryAmount></div></div></div><div class="items flex-between flex-wrap"><div class=flex-49><div class=mb-24><div class="ft_14_regular_gray2 mb-8" translate="Primary Address"></div><div class="ft_14_600_black item-data" ng-bind=vm.utils.getAddressString(vm.Manager.address1)></div></div><div><div class="ft_14_regular_gray2 mb-8" translate="Secondary Address"></div><div class="ft_14_600_black item-data" ng-bind=vm.utils.getAddressString(vm.Manager.address2)></div></div></div><div class=flex-49><div class=mb-24><div class=ft_14_regular_gray2 translate=Department></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=vm.Manager.department></div></div><div class=mb-24><div class=ft_14_regular_gray2 translate=Dashboard></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=getDashboardType(vm.Manager.dashboard)></div></div></div></div></div></div><div class="btnGroup flex mt-32"><button class="button-primary mr-16" ui-sref="managersEdit({id: vm.Manager._id})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="button-third mr-16" ng-click=deleteManager()><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class=btn_cancel ui-sref=managersGrid><img src=/assets/icons/close-circle-black.svg alt=icons><span translate=Cancel></span></button></div></div></div></div></div></main>');
$templateCache.put('app/main/managers/managersEdit/managersEdit.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show="isLoading == true"></spinner><div id=managersEdit class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=managersGrid translate=Managers></a></div><div class=ft_24_600_black1 translate="Edit Manager"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=vm.updateManager(vm.Manager)><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=vm.updateManager(vm.Manager)><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref="managersDetail({id: vm.Manager._id})"><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="MANAGER DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{ !!FILEIMG ? FILEIMG : \'/assets/images/suppliers/upload.png\' }}" alt=upload ngf-select ng-model=picFile name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Manager Name"></div><input type=text ng-model=vm.Manager.name id=firstName class=input-primary placeholder="{{\'Manager Name\' | translate}}" autocomplete=off></div><div class="flex-49 flex-between"><div class=flex-49><div class="ft_14_600_moreblack required" translate=Gender></div><selectbox-input class=dropdown-primary ng-model=vm.Manager.gender options=vm.genderList label-field=name value-field=value></div><div class=flex-49><div class="ft_14_600_moreblack required" translate=Status></div><selectbox-input class=dropdown-primary ng-model=vm.Manager.isActive options=vm.enableList label-field=name value-field=value></div></div></div><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Email ID"></div><input autocomplete=off type=email ng-model=vm.Manager.email placeholder="{{\'Invoice Email ID\' | translate}}" class=input-primary></div><div class=flex-49><div class="ft_14_600_moreblack required" translate="Contact No."></div><div class=flex><div ng-if=vm.countryCodes><selectbox-input class="dropdown-primary w-147" ng-model=vm.Manager.mobile.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></div><input autocomplete=off type=number ng-model=vm.Manager.mobile.phoneNumber placeholder="{{\'Phone Number\' | translate}}" class="input-primary ml-16"></div></div></div><div class="flex-between items"><div class=flex-49><div class="ft_14_600_moreblack required" translate="Date of Birth"></div><input ng-click="isBirthDatepickerOpen = !isBirthDatepickerOpen" type=text class=input-primary date-picker=dd/MM/yyyy date=vm.Manager.dob is-open=isBirthDatepickerOpen ng-required=true></div><div class=flex-49><div class="ft_14_600_moreblack required" translate="Date of Joining"></div><input ng-click="isJoinDatepickerOpen = !isJoinDatepickerOpen" type=text class=input-primary date-picker=dd/MM/yyyy date=vm.Manager.doj is-open=isJoinDatepickerOpen ng-required=true></div></div></div></div></div></div><div class=profile-card><span class=label translate=ADDRESS></span><div class="address flex-between flex-wrap mt-16"><div class=flex-100><div class="ft_14_600_moreblack required" translate="Primary Address"></div><input autocomplete=off type=text id=address ng-model=vm.Manager.address1.line1 class=input-primary placeholder="{{\'Include a place or address\' | translate}}"></div><div class=flex-32><div class="ft_14_600_moreblack required" translate=Country></div><div class="w-100 mb-24"><selectbox-input class=dropdown-primary ng-model=vm.Manager.address1.countryCode options=vm.countryCodes label-field=name value-field=code></div></div><div class=flex-32><div class="ft_14_600_moreblack required" translate=City></div><input autocomplete=off type=text ng-model=vm.Manager.address1.city class=input-primary placeholder="{{\'City Name\' | translate}}" id=city></div><div class=flex-32><div class="ft_14_600_moreblack required" translate="Postal Code"></div><input autocomplete=off type=text ng-model=vm.Manager.address1.postalCode class=input-primary placeholder="{{\'Postal Code\' | translate}}" id=postalCode></div><div class=flex-100><div class=ft_14_600_moreblack translate="Secondary Address(Optional)"></div><input autocomplete=off type=text id=address ng-model=vm.Manager.address2.line1 class=input-primary placeholder="{{\'Include a place or address\' | translate}}"></div><div class=flex-32><div class=ft_14_600_moreblack translate=Country></div><div class="w-100 mb-24"><selectbox-input class=dropdown-primary ng-model=vm.Manager.address2.countryCode options=vm.countryCodes label-field=name value-field=code></div></div><div class=flex-32><div class=ft_14_600_moreblack translate=City></div><input autocomplete=off type=text ng-model=vm.Manager.address2.city class=input-primary placeholder="{{\'City Name\' | translate}}" id=city></div><div class=flex-32><div class=ft_14_600_moreblack translate="Postal Code"></div><input autocomplete=off type=text ng-model=vm.Manager.address2.postalCode class=input-primary placeholder="{{\'Postal Code\' | translate}}" id=postalCode></div></div></div><div class=profile-card><span class=label translate="ROLE INFORMATION"></span><div class="role flex-between flex-wrap mt-16"><div class="flex-49 mb-24"><div class=ft_14_600_moreblack translate=Department></div><selectbox-input class=dropdown-primary ng-model=vm.Manager.department options=vm.departmentList label-field=name value-field=_id></div><div class="flex-49 mb-24"><div class=ft_14_600_moreblack translate=Designation></div><selectbox-input class=dropdown-primary ng-model=vm.Manager.subDesignation options=vm.designationList label-field=name value-field=_id></div><div class="flex-49 mb-24"><div class=ft_14_600_moreblack translate="Labour Settings"></div><selectbox-input class=dropdown-primary ng-model=vm.Manager.employeeSettingId options=vm.laberSettingsList label-field=presetName value-field=_id select-event="changeOption(\'ManagerSetting\', vm.Manager.employeeSettingId)"></div><div class="flex-49 mb-24"><div class="ft_14_600_moreblack required" translate=Salary></div><input autocomplete=off type=text class="input-primary w-100" ng-model=vm.Manager.salaryAmount place-holder=Salary></div><div class=flex-49><div class="ft_14_600_moreblack required" translate=Dashboard></div><!-- <selectbox-input class="dropdown-primary"\n              ng-model="vm.Manager.dashboard"\n              options="dashboardList"\n              label-field="name"\n              value-field="_id"/> --><div class="flex-between w-100 flex-wrap"><div class=w-50 ng-click=vm.selectDashboard(dashboard) ng-repeat="dashboard in dashboardList track by $index"><div class="d-flex justify-content-start align-items-center dashboard-item"><input type=checkbox ng-checked="vm.Manager.dashboard.indexOf(dashboard) > -1"><div class="filter-menu-item-text ml-10">{{dashboard}}</div></div></div><!-- <div class="filter-menu-item-count float-right">{{vm.allProjects.length}}</div> --></div></div></div><div class="btnGroup flex mt-32"><button class="button-primary mr-16" ng-click=vm.updateManager(vm.Manager)><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=vm.updateManager(vm.Manager)><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref="managersDetail({id: vm.Manager._id})"><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/managers/managersGrid/managersGrid.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=managers class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Managers></a></div><div class=ft_24_600_black1 translate=Managers></div></div><div class="ml-auto show-all"><checkbox class=mr-1 ng-model=vm.showAll ng-click=vm.fetchAllManagers()>Show All</div><searchbox class=ml-8 search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><div><button class="btn-trans ml-16" ng-click="isGrid = false"><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click="isGrid = true"><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button></div><button class="button-primary ml-16" ui-sref=managersAdd ng-if="MANAGER_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Add Manager"></span></button></div><div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0 && isLoading==false"><div class="card-based-content-grid-wrapper pr-24 pv-24" ng-if=isGrid><div class="quotes-wrapper flex flex-wrap"><div class=profile-card-container ng-repeat="client in managers"><div class=profile-card><div class=card-content><div class="flex header"><div ng-if=client.profilePic><img ng-src={{client.profilePic}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!client.profilePic><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(client.displayName)) }">{{client.displayName | mailAvatarChar}}</span></div><div class=name-wrapper ng-click=goToDetail(client._id)><div class="name tx-ellipsis ft_16_600_black" ng-bind=client.displayName></div><div class="date text-left tx-ellipsis" ng-bind=vm.utils.getAddressString(client.address1)></div></div></div><div class=detail><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/call.svg alt=icons><span class=ft_14_regular_gray ng-bind="\'+\'+client.mobile.dialCode+\' \'+client.mobile.phoneNumber"></span></div><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/email.svg alt=icons> <span class="ft_14_regular_gray tx-ellipsis" ng-bind=client.email></span></div></div></div><div class="flex-between action"><div class=flex-row><img src=/assets/images/suppliers/tag.svg alt=icons><span class="ft_12_600_black ml-7" ng-bind=client.systemTag></span></div><div class=flex-row><img src=/assets/images/suppliers/calendar.svg alt=icons><span class="ft_12_regular_gray cal-span" ng-bind="client.dateOfJoin | date: \'dd MMM yyyy\' : \'UTC\'"></span></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + managers.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllManagers()></div></div></div></div><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer" ng-if=!isGrid><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked><span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate=Name></span></th><th class=ft_14_600_black><span translate="Email ID"></span></th><th class=ft_14_600_black><span translate="Contact No."></span></th><th class=ft_14_600_black><span translate=Address></span></th><th class=ft_14_600_black><span translate=Department></span></th><th class=ft_14_600_black><span translate=Designation></span></th><th class=ft_14_600_black><span translate=Dashboard></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, client) in managers"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked><span class=checkmark></span></label></td><td ng-click=goToDetail(client._id)><div class="flex-row flex-items-center"><div class=avatar-cell><div ng-if=client.profilePic><img ng-src={{client.profilePic}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!client.profilePic><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(client.displayName)) }">{{client.displayName | mailAvatarChar}}</span></div></div><div class="ft_14_regular_black tx-ellipsis name" ng-bind=client.displayName></div></div></td><td class="tx-ellipsis ft_14_regular_black" ng-bind=client.email></td><td class=ft_14_regular_black ng-bind="\'(\'+client.mobile.dialCode+\') \'+client.mobile.phoneNumber"></td><td class="tx-ellipsis pr-20 ft_14_regular_black">{{vm.utils.getAddressString(client.address1)}}</td><td class=ft_14_regular_black>{{client.department}}</td><td class=ft_14_regular_black>{{client.subDesignation}}</td><td class=ft_14_regular_black>{{getDashboardType(client.dashboard)}}</td><td class="more flex-items-center"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class=margin-0></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + managers.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllClients()></div></div></div></div></div></div></main>');
$templateCache.put('app/main/materials/addDcp/addDcp.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div class="add-dcp main-container"><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=dcpList translate=DCP></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Add DCP"></a> --></div><div class=ft_24_600_black1 translate="Add DCP"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=vm.createCombo()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=dcpList><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><!-- <div class="profile-card p-24">\n        <span class="label" translate="FROM OLD DCP"></span>\n        <div class="flex-50 mt-16">\n          <div class="ft_14_600_moreblack" translate="From Old DCP"></div>\n          <selectbox-input\n            class="w-100 input-select"\n            ng-model="selectedDcpId"\n            options="vm.dcpList"\n            label-field="name"\n            value-field="_id"\n            on-change="selectOldDcp()"\n          ></selectbox-input>\n        </div>\n      </div> --><div class="profile-card pt-24"><span class=label translate="DCP INFORMATION"></span><div class="flex flex-row mt-16 mb-24"><div class="flex-29 flex flex-col"><div class="flex-1 flex flex-col"><span translate="DCP Name" class="ft_14_600_moreblack required"></span> <input type=text ng-model=vm.comboData.name class=login_input_new></div><div class="flex flex-col flex-50"><span translate=Unit class="ft_14_600_moreblack required"></span><selectbox-input class=input-select options=vm.mUnits label-field=name value-field=value ng-model=vm.comboData.unit></selectbox-input></div></div><div class="flex-69 flex flex-col ml-24"><span translate=Description class=ft_14_600_moreblack></span> <textarea type=text ng-model=vm.comboData.description placeholder="Write some description (optional)" rows=6></textarea></div></div></div><div class=profile-card><span class=label translate=ATTACHMENTS></span><div class="flex-items-center mt-16 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'image\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.objectUrl}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImages.splice($index, 1)"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'file\')" name=file ngf-pattern="\'.pdf,.doc,.docx,.xls,.xlsx\'" ngf-multiple=true ngf-accept="\'.pdf,.doc,.docx,.xls,.xlsx\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadFiles.splice($index, 1)"></div></div></div></div><div class=profile-card><span class=label translate=COMBINATION></span><div class="flex flex-row mt-16 mb-24"><div class="flex-30 flex flex-col"><span translate="Material list" class=ft_14_600_moreblack></span><selectbox-input class="w-100 input-select" options=vm.matList label-field=name value-field=_id ng-model=comboMat.matId select-event=onChangeMat(comboMat)></selectbox-input></div><div class="flex-10 flex flex-end ml-24"><button class="btn_new_blue m-t-4" ng-click=addMaterial()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div class="d-flex w-100 flex-wrap mb-24" ng-if=!vm.utils.isEmpty(comboMaterialList)><div class=material ng-repeat="mat in comboMaterialList track by $index"><div class="ft_14_regular_black mr-8">{{mat.quantity}}{{mat.unit}} x {{mat.name}} ( {{mat.typeAdding}}: {{mat.percentage}}% )</div><img src=/assets/icons/close-16.svg alt=close class=cursor-point ng-click="removeMaterial($index, mat.matId)"></div></div><div class="flex flex-row"><div class="flex-18 flex flex-col"><span class=ft_14_600_moreblack translate=Quantity></span> <input type=text class=login_input_new number-edit ng-model=comboMat.quantity ng-change=calcComboMatCost(comboMat)></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Item Cost"></span> <input type=text class=login_input_new number-edit ng-model=comboMat.matCost disabled></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Worker Cost"></span> <input type=text class=login_input_new number-edit ng-model=comboMat.workerCost disabled></div><div class="flex-25 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Type of Addings"></span><selectbox-input ng-model=comboMat.typeAdding options=vm.typeAddings label-field=name value-field=_id on-change=calcComboMatCost(comboMat) class=input-select></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="% Value"></span><div class="percentage-wrapper m-t-4"><input class=percentage-input type=text number-edit ng-model=comboMat.percentage class=form-control ng-change=calcComboMatCost(comboMat)><div class=percentage>%</div></div></div></div></div><div class="profile-card pt-24 pl-0 pr-0 pb-0"><span class="label ml-24" translate=SUMMARY></span><div class="flex flex-row mt-16 mb-24 ph-24 flex-between"><div class=flex-30><div class="flex-1 flex flex-col"><span class=ft_14_600_moreblack translate="DCP Name"></span> <input class=login_input_new type=text ng-model=vm.comboData.name disabled></div><div class="flex-1 flex flex-row flex-between mt-16"><div class="flex-1 flex flex-col"><span class=ft_14_600_moreblack translate="Total Material Cost"></span><div class="static-input login_input_new">{{getTotalCost(\'matCost\') | readable: 2}}</div></div><div class="flex-1 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Total Worker Cost"></span><div class="static-input login_input_new">{{getTotalCost(\'workerCost\') | readable: 2}}</div></div></div></div><div class="flex-68 flex flex-col"><span class=ft_14_600_moreblack translate=Description></span> <textarea ng-model=vm.comboData.description class=m-t-4 rows=5 disabled></textarea></div></div><div class="dcp-table w-100 mt-32" ng-if=!vm.utils.isEmpty(comboMaterialList)><div class=thead><div class=tr><div class="td no" translate=Sr.No.></div><div class="td date" translate=Date></div><div class="td name" translate="Material Name"></div><div class="td mat-cost" translate="Material Cost"></div><div class="td worker-cost" translate="Work Cost"></div></div></div><div class=tbody><div class=tr ng-repeat="comboMat in comboMaterialList track by $index"><div class="td no">{{$index+1}}</div><div class="td date">{{comboMat.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td name">{{comboMat.name}}</div><div class="td mat-cost">{{comboMat.matCost | readable: 2}}</div><div class="td worker-cost">{{comboMat.workerCost | readable: 2}}</div></div></div></div><div class="flex flex-row mt-32 ph-24 pb-24"><button class="btn_new_blue mr-16" ng-click=vm.createCombo()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=dcpList><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/materials/addItem/addItem.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div class="add-item main-container"><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=itemList translate="Building Parts"></a></div><div class=ft_24_600_black1 translate="Create Building Part "></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=vm.addMaterial()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class=btn_cancel ui-sref=itemList><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card pt-24"><span class="label pl-24" translate="BUILDING PART INFORMATION"></span><div class="flex flex-row ph-24 mt-16 mb-24"><div class="flex-25 flex flex-col"><span translate="Item Name" class="ft_14_600_moreblack required"></span> <input type=text ng-model=material.name class=input-primary></div><div class="flex-60 flex flex-col ml-24"><span translate="Color / Texture" class=ft_14_600_moreblack></span><div class="color-container m-t-4"><color-selector color=material.color opacity=material.opacity hide-symbol=true></color-selector><div class=opacity-wrapper><input class=text-right type=text number-edit ng-model=opacity class=form-control><div class=percentage>%</div></div></div></div></div><div class="flex flex-row ph-24 mb-24"><div class="flex-10 flex flex-col"><span translate=Unit class="ft_14_600_moreblack required"></span><selectbox-input class="w-100 dropdown-primary" options=vm.mUnits label-field=name value-field=value ng-model=material.unit></selectbox-input></div><div class="flex-10 flex flex-col ml-24"><span translate="Items / Unit" class=ft_14_600_moreblack></span> <input type=text ng-model=material.itemsUnit class=input-primary></div><div class="flex flex-col ml-24"><span translate="Unit Size" class=ft_14_600_moreblack></span><div class="flex flex-row flex-items-center"><span class="ft_14_regular_black mr-8">1 Unit =</span> <input type=text ng-model=material.unitSize class=input-primary></div></div><div class="flex-10 flex flex-col ml-24"><span translate=CSS class=ft_14_600_moreblack></span> <input type=text ng-model=material.ccs class=input-primary></div></div><div class="flex flex-row ph-24 pb-18 mat-border-bottom"><div class="flex-18 flex flex-col"><span translate="Maintenance Period (Days)" class=ft_14_600_moreblack></span> <input type=text ng-model=material.maintenancePeriod class=input-primary></div><div class="flex-18 flex flex-col ml-24"><span translate="Certified Maintenance" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=material.certifiedMaintenance options=isCertifiedMaintenanceList label-field=label value-field=value></selectbox-input></div></div><div class="flex flex-row ph-24 mt-24 mb-8 flex-end"><div class="flex-24 flex flex-col"><span translate="Add Type of Sub" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=workType options=vm.workTypes label-field=tagName value-field=_id></selectbox-input></div><button class="button-primary ml-24" ng-click=addWorkType()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div><div class="d-flex w-100 ph-24 flex-wrap mb-24 mat-border-bottom"><div class=work-type ng-repeat="workType in material.typeOfSub track by $index"><div class=mr-16>{{workType.tagName}}</div><img src=/assets/icons/close-16-black.svg alt="" ng-click=removeWorkType($index)></div></div><div class="flex flex-row ph-24 mt-24 mb-8 flex-end"><div class="flex-18 flex flex-col"><span translate="Weather Condition" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=weatherCondition.condition options=vm.weatherTypes label-field=tagName value-field=_id on-change=changedWeatherCondition()></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span translate="Weather Remarks" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=weatherCondition.option.isWork options=weatherRemarks label-field=label value-field=value></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span translate=Limited class=ft_14_600_moreblack></span> <input type=text ng-model=weatherCondition.limited class=input-primary></div><button class="button-primary ml-24" ng-click=addWeatherCondition()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div><div class="d-flex w-100 ph-24 flex-wrap mb-24" ng-if=!vm.utils.isEmpty(weatherCondition)><div class=weather-condition ng-repeat="w in material.weatherConditions track by $index"><div class="ft_12_600_black mr-8" ng-bind=getWeatherConditionInfo(w)></div><img src=/assets/icons/close-16.svg alt=close class=cursor-point ng-click=removeWeatherCondition($index)></div></div></div><div class="profile-card p-24"><span class=label translate="SUPPLIER COST"></span><div class="flex flex-row flex-between mt-16"><div class=flex-32><div class=ft_14_600_moreblack translate=Currency></div><selectbox-input class="w-100 dropdown-primary" ng-model=material.cost.currencyCode options=vm.currencies label-field=cc value-field=cc on-change=changeMaterialCurrency()></selectbox-input></div><div class=flex-32><div class="ft_14_600_moreblack required" translate="Building Part Cost"></div><input type=text class="input-primary w-100" ng-model=material.cost.itemsCost></div><div class=flex-32><div class=ft_14_600_moreblack translate="Item ID"></div><input type=text class="input-primary w-100" ng-model=material.cost.itemsId></div></div><div class="flex flex-row flex-between mt-16 flex-algin-item-start"><div class=flex-32><div class=ft_14_600_moreblack translate="Total Time"></div><input type=text class="input-primary w-100" ng-model=material.cost.productionTime></div><div class=flex-50><div class=ft_14_600_moreblack translate="Building Part Name"></div><div class="timeline-content d-flex align-items-center justify-content-center"><div dhx-gantt id=dhx-gantt data=ganttData styles="" deadline="" on-worker-count="" on-total-count="" zoom=1></div></div></div><div class=flex-14></div></div></div><div class="profile-card p-24"><span class=label translate=ATTACHMENTS></span><div class="flex-items-center mt-16 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'image\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.objectUrl}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImages.splice($index, 1)"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'file\')" name=file ngf-multiple=true ngf-pattern="\'.pdf,.doc,.docx,.xls,.xlsx\'" ngf-accept="\'.pdf,.doc,.docx,.xls,.xlsx\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadFiles.splice($index, 1)"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 103px" translate="Images for AR"></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'image_for_ar\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImagesForAR track by $index"><img class=file-thumbnail ng-src={{file.objectUrl}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImagesForAR.splice($index, 1)"></div></div></div><div class="flex flex-row flex-content-end"><button class="button-primary mr-16" ng-click=vm.addMaterial()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class=btn_cancel ui-sref=itemList><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/materials/addMaterial/addMaterial.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div class="add-material main-container"><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=materialList translate=Materials></a></div><div class=ft_24_600_black1 translate="Add Material"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=vm.addMaterial()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class=btn_cancel ui-sref=materialList><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card p-24"><span class=label translate="FROM OLD MATERIAL"></span><div class="flex-50 mt-16"><div class=ft_14_600_moreblack translate="From Old Material"></div><selectbox-input class="w-100 dropdown-primary" ng-model=oldMaterialId options=vm.materials label-field=name value-field=_id on-change=selectOldMaterial()></selectbox-input></div></div><div class="profile-card pt-24"><span class="label pl-24" translate="MATERIAL INFORMATION"></span><div class="flex flex-row ph-24 mt-16 mb-24"><div class="flex-25 flex flex-col"><span translate="Material Name" class="ft_14_600_moreblack required"></span> <input type=text ng-model=material.name class=input-primary></div><div class="flex-60 flex flex-col ml-24"><span translate="Color / Texture" class=ft_14_600_moreblack></span><div class="color-container m-t-4"><color-selector color=material.color opacity=material.opacity hide-symbol=true></color-selector><div class=opacity-wrapper><input class=text-right type=text number-edit ng-model=opacity class=form-control><div class=percentage>%</div></div></div></div></div><div class="flex flex-row ph-24 mb-24"><div class="flex-10 flex flex-col"><span translate=Unit class="ft_14_600_moreblack required"></span><selectbox-input class="w-100 dropdown-primary" options=vm.mUnits label-field=name value-field=value ng-model=material.unit></selectbox-input></div><div class="flex-10 flex flex-col ml-24"><span translate="Items / Unit" class=ft_14_600_moreblack></span> <input type=text ng-model=material.itemsUnit class=input-primary></div><div class="flex-10 flex flex-col ml-24"><span translate="Items / Pallet" class=ft_14_600_moreblack></span> <input type=text ng-model=material.itemsPallet class=input-primary></div><div class="flex-10 flex flex-col ml-24"><span translate=Fullload class=ft_14_600_moreblack></span> <input type=text ng-model=material.fullLoad class=input-primary></div><div class="flex flex-col ml-24"><span translate="Unit Size" class=ft_14_600_moreblack></span><div class="flex flex-row flex-items-center"><span class="ft_14_regular_black mr-8">1 Unit =</span> <input type=text ng-model=material.unitSize class=input-primary></div></div><div class="flex-10 flex flex-col ml-24"><span translate=CSS class=ft_14_600_moreblack></span> <input type=text ng-model=material.ccs class=input-primary></div><div class="flex-10 flex flex-col ml-24"><span translate="Waste (%)" class=ft_14_600_moreblack></span><div class=waste-container><input type=text number-edit ng-model=material.wastePercentage class=input-primary><div class="percentage m-t-4">%</div></div></div></div><div class="flex flex-row ph-24 pb-18 mat-border-bottom"><div class="flex-18 flex flex-col"><span translate="Pallet Length" class=ft_14_600_moreblack></span> <input type=text ng-model=material.dimensions.unit.length class=input-primary></div><div class="flex-18 flex flex-col ml-24"><span translate="Pallet Top/Bottom" class=ft_14_600_moreblack></span> <input type=text ng-model=material.dimensions.unit.width class=input-primary></div><div class="flex-18 flex flex-col ml-24"><span translate="Pallet Height" class=ft_14_600_moreblack></span> <input type=text ng-model=material.dimensions.unit.height class=input-primary></div><div class="flex-18 flex flex-col ml-24"><span translate="Maintenance Period (Days)" class=ft_14_600_moreblack></span> <input type=text ng-model=material.maintenancePeriod class=input-primary></div><div class="flex-18 flex flex-col ml-24"><span translate="Certified Maintenance" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=material.certifiedMaintenance options=isCertifiedMaintenanceList label-field=label value-field=value></selectbox-input></div></div><div class="flex flex-row ph-24 pb-24 mt-30 mat-border-bottom"><div class="flex-18 flex flex-col"><span translate="Material Group" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=material.groupId options=vm.materialGroups label-field=name value-field=_id></selectbox-input></div></div><div class="flex flex-row ph-24 mt-32 mb-8 flex-end"><div class="flex-18 flex flex-col"><span translate="Weather Condition" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=weatherCondition.condition options=vm.weatherTypes label-field=tagName value-field=_id on-change=changedWeatherCondition()></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span translate="Weather Remarks" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=weatherCondition.option.isWork options=weatherRemarks label-field=label value-field=value></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span translate=Limited class=ft_14_600_moreblack></span> <input type=text ng-model=weatherCondition.limited class=input-primary></div><button class="button-primary ml-24" ng-click=addWeatherCondition()><span translate="+ Add"></span></button></div><div class="d-flex w-100 ph-24 flex-wrap mb-24" ng-if=!vm.utils.isEmpty(weatherCondition)><div class=weather-condition ng-repeat="w in material.weatherConditions track by $index"><div class="ft_12_600_black mr-8" ng-bind=getWeatherConditionInfo(w)></div><img src=/assets/icons/close-16.svg alt=close class=cursor-point ng-click=removeWeatherCondition($index)></div></div></div><div class="profile-card p-24"><span class=label translate="SUPPLIER COST"></span><div class="flex flex-row flex-between mt-16"><div class=flex-32><div class="ft_14_600_moreblack required" translate=Supplier></div><selectbox-input class="w-100 dropdown-primary" ng-model=material.supplier options=vm.suppliers label-field=name value-field=_id></selectbox-input></div><div class=flex-32><div class=ft_14_600_moreblack translate="Supplier Material ID"></div><input type=text class="input-primary w-100" ng-model=material.supplierMaterialId></div><div class=flex-32><div class=ft_14_600_moreblack translate="Material Serial No."></div><input type=text class="input-primary w-100" ng-model=material.materialSerialNumber></div></div><div class="flex flex-row flex-between mt-24"><div class=flex-32><div class=ft_14_600_moreblack translate=Currency></div><selectbox-input class="w-100 dropdown-primary" ng-model=material.currency options=vm.currencies label-field=cc value-field=cc on-change=changeMaterialCurrency()></selectbox-input></div><div class=flex-32><div class="ft_14_600_moreblack required" translate="Material Cost"></div><input type=text class="input-primary w-100" ng-model=material.materialCost.value></div><div class=flex-32><div class="ft_14_600_moreblack required" translate="Worker Cost"></div><input type=text class="input-primary w-100" ng-model=material.rooferCost.value></div></div></div><div class="profile-card p-24"><span class=label translate=ATTACHMENTS></span><div class="flex-items-center mt-16 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'image\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.objectUrl}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImages.splice($index, 1)"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'file\')" name=file ngf-pattern="\'.pdf,.doc,.docx,.xls,.xlsx\'" ngf-multiple=true ngf-accept="\'.pdf,.doc,.docx,.xls,.xlsx\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadFiles.splice($index, 1)"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 103px" translate="Images for AR"></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'image_for_ar\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImagesForAR track by $index"><img class=file-thumbnail ng-src={{file.objectUrl}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImagesForAR.splice($index, 1)"></div></div></div><div class="flex flex-row flex-content-end"><button class="button-primary mr-16" ng-click=vm.addMaterial()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class=btn_cancel ui-sref=materialList><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/materials/dcpDetail/dcpDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div class="material-detail main-container" ng-if=!isLoading><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=dcpList translate=DCP></a></div><div class=ft_24_600_black1 translate="DCP Details"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16"><img src=/assets/icons/model-white.svg alt="" class=mr-8> <span translate="3D Viewer"></span></button> <button class="btn_new_blue client_gray_back mr-16" ui-sref="editDcp({id: vm.comboId})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=dcpList><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card p-24" id=material-information><span class=label translate="DCP INFORMATION"></span><div class="section-body mt-16"><!-- top info --><div class="d-flex justify-content-between mb-40"><!-- image sliders --><div class=image-sliders><div class=primary-slider><div class=slider ng-if=!vm.utils.isEmpty(vm.uploadImages)><div class=flexslider><ul class=slides><li ng-repeat="f in vm.uploadImages"><img ng-src={{f.secure_url}} alt="" style="margin: auto"></li></ul></div></div><img ng-if=vm.utils.isEmpty(vm.uploadImages) class="no-img object-fit-cover" src=/assets/images/materials/noImg.jpg alt=icons></div><div ng-if="vm.uploadImages.length >= 4" class="mt-16 secondary-slider d-flex flex-column justify-content-between"><div ng-repeat="img in vm.uploadImages.slice(0, 4)"><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div><div ng-if="vm.uploadImages.length > 0 && vm.uploadImages.length < 4" class="mt-16 secondary-slider"><div ng-repeat="img in vm.uploadImages.slice(0, 4)"><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div></div><!-- basic material info --><div class=basic-info><div class="d-flex justify-content-between"><div><div class=tags><div class="tag blue" ng-if=vm.comboData.systemTag>{{ vm.comboData.systemTag }}</div></div><div class="ft_24_600_black1 mt-16 mb-2">{{ vm.comboData.name }}</div><div class="ft_14_regular_gray2 mb-16">{{ vm.comboData.createdAt | date: \'MMMM d, yyyy\' : \'UTC\' }}</div><div class=tags><div class="tag dark-blue" ng-if=vm.nextMaintenanceDate>Next Maintenance On {{ vm.nextMaintenanceDate }}</div><div class="tag dark-blue" ng-if=!vm.nextMaintenanceDate>Maintenance Date not available</div></div></div><div class=text-center><div class=mb-8><span class=ft_12_600_black translate=Generate>&nbsp;</span> <span class="ft_12_600_yellow cursor-point" translate="QR Code"></span></div><qr type-number=8 correction-level="\'M\'" size=96 input-mode="\'Auto\'" text="\'abc\'" image=true></qr><div class="ft_12_regular_black mt-8">ST100023146</div></div></div><div class="d-flex justify-content-between"><div class="block py-4" ng-repeat="box in boxes track by $index"><div class=symbol><img ng-src={{box.img}} alt=symbol></div><div class=ft_14_500_white>{{box.title}}</div><div class=ft_18_500_white ng-if="$index === 0 && vm.utils.unit2array(box.unit).length === 2">{{vm.utils.unit2array(box.unit)[0]}}<sup>{{vm.utils.unit2array(box.unit)[1]}}</sup></div><div class=ft_18_500_white ng-if="$index === 0 && vm.utils.unit2array(box.unit).length !== 2">{{box.unit}}</div><div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}">{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}</div><div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0 && box.baseValue" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}">{{box.baseValue | readable: 2}}&nbsp;{{box.baseCurrencyCode}}</div></div></div></div></div><!-- bottom info table --><div class=material-info-table><div class=thead><div class=tr><div class="td no" translate=Sr.No.></div><div class="td name" translate="Material Name"></div><div class="td quantity" translate=Quantity></div><div class="td unit" translate=Unit></div><div class="td material-cost" translate="Material Cost">({{vm.comboData.currencyCode}})</div><div class="td addition" translate="% Addition"></div><div class="td worker-cost" translate="Worker Cost">({{vm.comboData.currencyCode}})</div></div></div><div class=tbody><div class=tr ng-repeat="comboMat in vm.comboData.comboMaterialList track by $index"><div class="td no">{{$index + 1}}</div><div class="td name">{{comboMat.materialId.name}}</div><div class="td unit" ng-if="vm.utils.unit2array(comboMat.materialId.unit).length === 2">{{vm.utils.unit2array(comboMat.materialId.unit)[0]}}<sup>{{vm.utils.unit2array(comboMat.materialId.unit)[1]}}</sup></div><div class="td quantity">{{comboMat.quantity}}</div><div class="td unit" ng-if="vm.utils.unit2array(comboMat.materialId.unit).length !== 2">{{comboMat.materialId.unit}}</div><div class="td material-cost">{{ comboMat.baseCost.materialCost | readable: 2 }}</div><div class="td addition"></div><div class="td worker-cost">{{ comboMat.baseCost.rooferCost | readable: 2 }}</div></div><div class=tr style="background: #E8E8E8"><div class="td no" translate=Total></div><div class="td name"></div><div class="td unit"></div><div class="td material-cost">{{ vm.comboData.totalMaterialCost | readable: 2 }}</div><div class="td addition"></div><div class="td worker-cost">{{ vm.comboData.totalRooferCost | readable: 2 }}</div></div></div></div></div></div><div class="profile-card p-24 mt-24" id=material-attachments><span class=label translate=ATTACHMENTS></span><div class=section-body><div class="flex-items-center mt-16 mb-16" ng-if=vm.uploadImages.length><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=images ng-if=vm.uploadImages.length><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.secure_url}} alt=thumbnail ng-click=showImage(file.secure_url)><div class=file-name>{{file.name }}</div></div></div><div class="flex-items-center mt-24 mb-16" ng-if=vm.uploadFiles.length><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=images ng-if=vm.uploadFiles.length><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt="" ng-click=vm.utils.downloadFile(file.secure_url)><div class=file-name>{{file.originalname }}</div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/materials/dcpList/dcpList.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=dcpList class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2">Materials</a></div><div class=ft_24_600_black1 translate=DCP></div></div><div class=nav-items><div ui-sref=materialList class="nav-item inactive" translate=Materials></div><div ui-sref=itemList class="nav-item inactive" translate="Building Parts"></div><div ui-sref=dcpList class="nav-item active" translate=DCP></div></div><div class="ml-auto flex flex-row flex-items-center"><button class="btn-trans ml-16" ng-click=switchViewMode(false)><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click=switchViewMode(true)><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button> <button class="button-primary ml-16" ui-sref=addDcp ng-if="MAT_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Add DCP"></span></button></div></div><div><no-data ng-if="isLoading == false && totalCount==0"></no-data><div ng-if="totalCount!=0"><div class="card-based-content-grid-wrapper pr-24 pv-24" ng-if=isGrid><div class="quotes-wrapper flex flex-wrap"><div class=inventory-card-container ng-repeat="item in combos" ng-show="combos.length != 0"><inventory-card class=d-block item-data=item type="\'combo\'" currency-symbol=getCurrencySymbol(item)></inventory-card></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + combos.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.sortComboMaterials()></pagination-custom-new></div></div></div></div><div class=mt-0 ng-if="!isGrid && !vm.isViewGroupList"><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked> <span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black width=20%><span translate="DCP name"></span></th><th class="ft_14_600_black center"><span translate=Unit></span></th><!-- <th class="ft_14_600_black"><span translate="DCP Tag"></span></th> --><th class="ft_14_600_black center"><span translate=Quantity></span></th><th class="ft_14_600_black center"><span translate="Unit Price"></span></th><th class="ft_14_600_black right"><span translate="DCP Cost"></span></th><th class="ft_14_600_black right"><span translate="% Addition"></span></th><th class="ft_14_600_black right"><span translate="Worker Cost"></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, item) in combos"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=item.checked> <span class=checkmark></span></label></td><td class="ft_14_regular_black cursor-point" width=20% ui-sref="dcpDetail({id: item._id})">{{item.name}}</td><td class="ft_14_regular_black center">{{item.unit}}</td><!-- <td class="ft_14_regular_black">{{item.systemTag}}</td> --><td class="ft_14_regular_black center"></td><td class="ft_14_regular_black center"></td><td class="ft_14_regular_black right">{{getCurrencySymbol(item)}}&nbsp;{{item.totalMaterialCost | readable: 2}}</td><td class="ft_14_regular_black right"></td><td class="ft_14_regular_black right">{{getCurrencySymbol(item)}}&nbsp;{{item.totalRooferCost | readable: 2}}</td><td class="more flex-items-center"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class="margin-0 cursor-point"></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + combos.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.sortComboMaterials()></pagination-custom-new></div></div></div></div></div></div></div></main><!--COMBO MATERIAL ADD--><div class="modal fade p-0 m-0" id=uploadcmbModal tabindex=-1 role=dialog><div class=modal-content-container><div class="modal-content modal-content-one"><div class=title-black><h5>Import ComboMaterials</h5></div><div class=modal-body><a href=https://res.cloudinary.com/dktnhmsjx/raw/upload/v1548924914/combo-materials_qzdpzf.xlsx class=view_image data-popup=true target=_blank rel=noopener>download template</a><br><div class=flex-center><div class="btn btn-warning mt-10" type=file ngf-select ng-model=vm.inputExcel name=file ngf-pattern="\'.xlsx, application/vnd.ms-excel, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-accept="\'.xlsx\'" ngf-multiple=false ngf-max-size=20MB translate=Browse></div><label class="mt-10 mr-10">&nbsp;&nbsp; {{ vm.inputExcel.name }}</label> <button class="btn btn-primary mt-10" ng-if=vm.inputExcel ng-click=upLoadCmbExcelFile(vm.inputExcel)>upload</button></div></div></div></div></div>');
$templateCache.put('app/main/materials/editDcp/editDcp.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div class="add-dcp main-container"><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=dcpList translate=DCP></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Add DCP"></a> --></div><div class=ft_24_600_black1 translate="Edit DCP"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=vm.updateCombo()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref="dcpDetail({id: vm.comboId})"><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><!-- <div class="profile-card p-24">\n        <span class="label" translate="FROM OLD DCP"></span>\n        <div class="flex-50 mt-16">\n          <div class="ft_14_600_moreblack" translate="From Old DCP"></div>\n          <selectbox-input\n            class="w-100 input-select"\n            ng-model="selectedDcpId"\n            options="vm.dcpList"\n            label-field="name"\n            value-field="_id"\n            on-change="selectOldDcp()"\n          ></selectbox-input>\n        </div>\n      </div> --><div class="profile-card pt-24"><span class="label pl-24" translate="DCP INFORMATION"></span><div class="flex flex-row mt-16 mb-24"><div class="flex-29 flex flex-col"><div class="flex-1 flex flex-col"><span translate="DCP Name" class="ft_14_600_moreblack required"></span> <input type=text ng-model=vm.comboData.name class=login_input_new></div><div class="flex flex-col flex-50"><span translate=Unit class="ft_14_600_moreblack required"></span><selectbox-input class=input-select options=vm.mUnits label-field=name value-field=value ng-model=vm.comboData.unit></selectbox-input></div></div><div class="flex-69 flex flex-col ml-24"><span translate=Description class=ft_14_600_moreblack></span> <textarea type=text ng-model=vm.comboData.description placeholder="Write some description (optional)" rows=6></textarea></div></div></div><div class=profile-card><span class=label translate=ATTACHMENTS></span><div class="flex-items-center mt-16 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'image\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src="{{file.objectUrl || file.secure_url}}" alt=""><div class=file-name>{{file.name || file.orignialname}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImages.splice($index, 1)"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ngf-select ngf-change="fileUpdated($files, \'file\')" name=file ngf-pattern="\'.pdf,.doc,.docx,.xls,.xlsx\'" ngf-multiple=true ngf-accept="\'.pdf,.doc,.docx,.xls,.xlsx\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=file-name>{{file.name || file.originalname}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadFiles.splice($index, 1)"></div></div></div></div><div class=profile-card><span class=label translate=COMBINATION></span><div class="flex flex-row mt-16 mb-24"><div class="flex-30 flex flex-col"><span translate="Material list" class=ft_14_600_moreblack></span><selectbox-input class=input-select options=vm.matList label-field=name value-field=_id ng-model=comboMat.matId select-event=onChangeMat(comboMat)></selectbox-input></div><div class="flex-10 flex flex-end ml-24"><button class="btn_new_blue m-t-4" ng-click=addMaterial()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div class="d-flex w-100 flex-wrap mb-24" ng-if=!vm.utils.isEmpty(comboMaterialList)><div class=material ng-repeat="mat in comboMaterialList track by $index"><div class="ft_14_regular_black mr-8">{{mat.quantity}}{{mat.unit}} x {{mat.name}} ( {{mat.typeAdding}}: {{mat.percentage}}% )</div><img src=/assets/icons/close-16.svg alt=close class=cursor-point ng-click="removeMaterial($index, mat.matId)"></div></div><div class="flex flex-row"><div class="flex-18 flex flex-col"><span class=ft_14_600_moreblack translate=Quantity></span> <input type=text class=login_input_new number-edit ng-model=comboMat.quantity ng-change=calcComboMatCost(comboMat)></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Item Cost"></span> <input type=text class=login_input_new number-edit ng-model=comboMat.matCost disabled></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Worker Cost"></span> <input type=text class=login_input_new number-edit ng-model=comboMat.workerCost disabled></div><div class="flex-25 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Type of Addings"></span><selectbox-input ng-model=comboMat.typeAdding options=vm.typeAddings label-field=name value-field=_id on-change=calcComboMatCost(comboMat) class=input-select></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="% Value"></span><div class="percentage-wrapper m-t-4"><input class=percentage-input type=text number-edit ng-model=comboMat.percentage class=form-control ng-change=calcComboMatCost(comboMat)><div class=percentage>%</div></div></div></div></div><div class="profile-card pt-24 pl-0 pr-0 pb-0"><span class="label ml-24" translate=SUMMARY></span><div class="flex flex-row mt-16 mb-24 ph-24 flex-between"><div class=flex-30><div class="flex-1 flex flex-col"><span class=ft_14_600_moreblack translate="DCP Name"></span> <input class=login_input_new type=text ng-model=vm.comboData.name disabled></div><div class="flex-1 flex flex-row flex-between mt-16"><div class="flex-1 flex flex-col"><span class=ft_14_600_moreblack translate="Total Material Cost"></span><div class="static-input login_input_new">{{getTotalCost(\'matCost\') | readable: 2}}</div></div><div class="flex-1 flex flex-col ml-24"><span class=ft_14_600_moreblack translate="Total Worker Cost"></span><div class="static-input login_input_new">{{getTotalCost(\'workerCost\') | readable: 2}}</div></div></div></div><div class="flex-68 flex flex-col"><span class=ft_14_600_moreblack translate=Description></span> <textarea ng-model=vm.comboData.description class=m-t-4 rows=5 disabled></textarea></div></div><div class="dcp-table w-100 mt-32" ng-if=!vm.utils.isEmpty(comboMaterialList)><div class=thead><div class=tr><div class="td no" translate=Sr.No.></div><div class="td date" translate=Date></div><div class="td name" translate="Material Name"></div><div class="td mat-cost" translate="Material Cost"></div><div class="td worker-cost" translate="Work Cost"></div></div></div><div class=tbody><div class=tr ng-repeat="comboMat in comboMaterialList track by $index"><div class="td no">{{$index+1}}</div><div class="td date">{{comboMat.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td name">{{comboMat.name}}</div><div class="td mat-cost">{{comboMat.matCost | readable: 2}}</div><div class="td worker-cost">{{comboMat.workerCost | readable: 2}}</div></div></div></div><div class="flex flex-row mt-32 ph-24 pb-24"><button class="btn_new_blue mr-16" ng-click=vm.updateCombo()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref="dcpDetail({id: vm.comboId})"><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div></div></div></main>');
$templateCache.put('app/main/materials/editItem/editItem.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div class="add-item main-container"><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=itemList translate="Building Parts"></a></div><div class=ft_24_600_black1 translate="Edit Building Part"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=vm.updateMaterial()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class=btn_cancel ui-sref="itemDetail({id: vm.materialId})"><img src=/assets/icons/close-circle-black.svg alt=icons><span translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card pt-24"><span class="label pl-24" translate="BUILDING PART INFORMATION"></span><div class="flex flex-row ph-24 mt-16 mb-24"><div class="flex-25 flex flex-col"><span translate="Item Name" class="ft_14_600_moreblack required"></span> <input type=text ng-model=material.name class=input-primary></div><div class="flex-60 flex flex-col ml-24"><span translate="Color / Texture" class=ft_14_600_moreblack></span><div class="color-container m-t-4"><color-selector color=material.color opacity=material.opacity hide-symbol=true></color-selector><div class=opacity-wrapper><input class=text-right type=text number-edit ng-model=opacity class=form-control><div class=percentage>%</div></div></div></div></div><div class="flex flex-row ph-24 mb-24"><div class="flex-10 flex flex-col"><span translate=Unit class="ft_14_600_moreblack required"></span><selectbox-input class="w-100 dropdown-primary" options=vm.mUnits label-field=name value-field=value ng-model=material.unit></selectbox-input></div><div class="flex-10 flex flex-col ml-24"><span translate="Items / Unit" class=ft_14_600_moreblack></span> <input type=text ng-model=material.itemsUnit class=input-primary></div><div class="flex flex-col ml-24"><span translate="Unit Size" class=ft_14_600_moreblack></span><div class="flex flex-row flex-items-center"><span class="ft_14_regular_black mr-8">1 Unit =</span> <input type=text ng-model=material.unitSize class=input-primary></div></div><div class="flex-10 flex flex-col ml-24"><span translate=CSS class=ft_14_600_moreblack></span> <input type=text ng-model=material.ccs class=input-primary></div></div><div class="flex flex-row ph-24 pb-18 mat-border-bottom"><div class="flex-18 flex flex-col"><span translate="Maintenance Period (Days)" class=ft_14_600_moreblack></span> <input type=text ng-model=material.maintenancePeriod class=input-primary></div><div class="flex-18 flex flex-col ml-24"><span translate="Certified Maintenance" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=material.certifiedMaintenance options=isCertifiedMaintenanceList label-field=label value-field=value></selectbox-input></div></div><div class="flex flex-row ph-24 mt-24 mb-8 flex-end"><div class="flex-24 flex flex-col"><span translate="Add Type of Sub" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=workType options=vm.workTypes label-field=tagName value-field=_id></selectbox-input></div><button class="button-primary ml-24" ng-click=addWorkType()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div><div class="d-flex w-100 ph-24 flex-wrap mb-24 mat-border-bottom"><div class=work-type ng-repeat="workType in material.typeOfSub track by $index"><div class=mr-16>{{workType.tagName}}</div><img src=/assets/icons/close-16-black.svg alt="" ng-click=removeWorkType($index)></div></div><div class="flex flex-row ph-24 mt-32 mb-8 flex-end"><div class="flex-18 flex flex-col"><span translate="Weather Condition" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=weatherCondition.condition options=vm.weatherTypes label-field=tagName value-field=_id on-change=changedWeatherCondition()></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span translate="Weather Remarks" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=weatherCondition.option.isWork options=weatherRemarks label-field=label value-field=value></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span translate=Limited class=ft_14_600_moreblack></span> <input type=text ng-model=weatherCondition.limited class=input-primary></div><button class="button-primary ml-24" ng-click=addWeatherCondition()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div><div class="d-flex w-100 ph-24 flex-wrap mb-24" ng-if=!vm.utils.isEmpty(weatherCondition)><div class=weather-condition ng-repeat="w in material.weatherConditions track by $index"><div class="ft_12_600_black mr-8" ng-bind=getWeatherConditionInfo(w)></div><img src=/assets/icons/close-16.svg alt=close class=cursor-point ng-click=removeWeatherCondition($index)></div></div></div><div class="profile-card p-24"><span class=label translate="SUPPLIER COST"></span><div class="flex flex-row flex-between mt-16"><div class=flex-32><div class=ft_14_600_moreblack translate=Currency></div><selectbox-input class="w-100 dropdown-primary" ng-model=material.cost[0].currencyCode options=vm.currencies label-field=cc value-field=cc on-change=changeMaterialCurrency()></selectbox-input></div><div class=flex-32><div class="ft_14_600_moreblack required" translate="Building Part Cost"></div><input type=text class="input-primary w-100" ng-model=material.cost[0].itemsCost></div><div class=flex-32><div class=ft_14_600_moreblack translate="Item ID"></div><input type=text class="input-primary w-100" ng-model=material.cost[0].itemsId></div></div><div class="flex flex-row flex-between mt-16 flex-algin-item-start"><div class=flex-32><div class=ft_14_600_moreblack translate="Total Time"></div><input type=text class="input-primary w-100" ng-model=material.cost[0].productionTime></div><div class=flex-50><div class=ft_14_600_moreblack translate="Building Part Name"></div><div class="timeline-content d-flex align-items-center justify-content-center"><div dhx-gantt id=dhx-gantt data=ganttData styles="" deadline="" on-worker-count="" on-total-count="" zoom=1></div></div></div><div class=flex-14></div></div></div><div class="profile-card p-24"><span class=label translate=ATTACHMENTS></span><div class="flex-items-center mt-16 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ng-model=vm.inputImages ngf-select ngf-change="fileUpdated($files, \'image\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src="{{file.objectUrl || file.secure_url }}" alt=""><div class=file-name>{{file.name || file.originalname}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.deleteFile($index, \'image\')"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ng-model=vm.inputFiles ngf-select ngf-change="fileUpdated($files, \'file\')" name=file ngf-pattern="\'.pdf,.doc,.docx,.xls,.xlsx\'" ngf-multiple=true ngf-accept="\'.pdf,.doc,.docx,.xls,.xlsx\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=file-name>{{file.name || file.assetName}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.deleteFile($index, \'files\')"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 103px" translate="Images for AR"></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ng-model=vm.inputImagesForAR ngf-select ngf-change="fileUpdated($files, \'image_for_ar\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImagesForAR track by $index"><img class=file-thumbnail ng-src="{{file.objectUrl || file.secure_url}}" alt=""><div class=file-name>{{file.name || file.originalname}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.deleteFile($index, \'image_for_ar\')"></div></div></div><div class="flex flex-row flex-content-end"><button class="button-primary mr-16" ng-click=vm.updateMaterial()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class=btn_cancel ui-sref="itemDetail({id: vm.materialId})"><img src=/assets/icons/close-circle-black.svg alt=icons><span translate=Cancel></span></button></div></div></div></div></main>');
$templateCache.put('app/main/materials/editMaterial/editMaterial.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div class="add-material main-container"><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=materialList translate=Materials></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Edit Material"></a> --></div><div class=ft_24_600_black1 translate="Edit Material"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=vm.updateMaterial()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class=btn_cancel ui-sref="materialDetail({id: vm.materialId})"><img src=/assets/icons/close-circle-black.svg alt=icons><span translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card pt-24"><span class="label pl-24" translate="MATERIAL INFORMATION"></span><div class="flex flex-row ph-24 mt-16 mb-24"><div class="flex-25 flex flex-col"><span translate="Material Name" class="ft_14_600_moreblack required"></span> <input type=text ng-model=material.name class=input-primary></div><div class="flex-60 flex flex-col ml-24"><span translate="Color / Texture" class=ft_14_600_moreblack></span><div class="color-container m-t-4"><color-selector color=material.color opacity=material.opacity hide-symbol=true></color-selector><div class=opacity-wrapper><input class=text-right type=text number-edit ng-model=opacity class=form-control><div class=percentage>%</div></div></div></div></div><div class="flex flex-row ph-24 mb-24"><div class="flex-10 flex flex-col"><span translate=Unit class="ft_14_600_moreblack required"></span><selectbox-input class="w-100 dropdown-primary" options=vm.mUnits label-field=name value-field=value ng-model=material.unit></selectbox-input></div><div class="flex-10 flex flex-col ml-24"><span translate="Items / Unit" class=ft_14_600_moreblack></span> <input type=text ng-model=material.itemsUnit class=input-primary></div><div class="flex-10 flex flex-col ml-24"><span translate="Items / Pallet" class=ft_14_600_moreblack></span> <input type=text ng-model=material.itemsPallet class=input-primary></div><div class="flex-10 flex flex-col ml-24"><span translate=Fullload class=ft_14_600_moreblack></span> <input type=text ng-model=material.fullLoad class=input-primary></div><div class="flex flex-col ml-24"><span translate="Unit Size" class=ft_14_600_moreblack></span><div class="flex flex-row flex-items-center"><span class="ft_14_regular_black mr-8">1 Unit =</span> <input type=text ng-model=material.unitSize class=input-primary></div></div><div class="flex-10 flex flex-col ml-24"><span translate=CSS class=ft_14_600_moreblack></span> <input type=text ng-model=material.ccs class=input-primary></div><div class="flex-10 flex flex-col ml-24"><span translate="Waste (%)" class=ft_14_600_moreblack></span><div class=waste-container><input type=text number-edit ng-model=material.wastePercentage class="text-right m-t-4" style="width: 60px;"><div class="percentage m-t-4">%</div></div></div></div><div class="flex flex-row ph-24 pb-18 mat-border-bottom"><div class="flex-18 flex flex-col"><span translate="Pallet Length" class=ft_14_600_moreblack></span> <input type=text ng-model=material.dimensions.unit.length class=input-primary></div><div class="flex-18 flex flex-col ml-24"><span translate="Pallet Top/Bottom" class=ft_14_600_moreblack></span> <input type=text ng-model=material.dimensions.unit.width class=input-primary></div><div class="flex-18 flex flex-col ml-24"><span translate="Pallet Height" class=ft_14_600_moreblack></span> <input type=text ng-model=material.dimensions.unit.height class=input-primary></div><div class="flex-18 flex flex-col ml-24"><span translate="Maintenance Period (Days)" class=ft_14_600_moreblack></span> <input type=text ng-model=material.maintenancePeriod class=input-primary></div><div class="flex-18 flex flex-col ml-24"><span translate="Certified Maintenance" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=material.certifiedMaintenance options=isCertifiedMaintenanceList label-field=label value-field=value></selectbox-input></div></div><div class="flex flex-row ph-24 pb-24 mt-30 mat-border-bottom"><div class="flex-18 flex flex-col"><span translate="Material Group" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=material.groupId options=vm.materialGroups label-field=name value-field=_id></selectbox-input></div></div><div class="flex flex-row ph-24 mt-32 mb-8 flex-end"><div class="flex-18 flex flex-col"><span translate="Weather Condition" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=weatherCondition.condition options=vm.weatherTypes label-field=tagName value-field=_id on-change=changedWeatherCondition()></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span translate="Weather Remarks" class=ft_14_600_moreblack></span><selectbox-input class="w-100 dropdown-primary" ng-model=weatherCondition.option.isWork options=weatherRemarks label-field=label value-field=value></selectbox-input></div><div class="flex-18 flex flex-col ml-24"><span translate=Limited class=ft_14_600_moreblack></span> <input type=text ng-model=weatherCondition.limited class=input-primary></div><button class="button-primary ml-24" ng-click=addWeatherCondition()><span translate="+ Add"></span></button></div><div class="d-flex w-100 ph-24 flex-wrap mb-24" ng-if=!vm.utils.isEmpty(weatherCondition)><div class=weather-condition ng-repeat="w in material.weatherConditions track by $index"><div class="ft_12_600_black mr-8" ng-bind=getWeatherConditionInfo(w)></div><img src=/assets/icons/close-16.svg alt=close class=cursor-point ng-click=removeWeatherCondition($index)></div></div></div><div class="profile-card p-24"><span class=label translate="SUPPLIER COST"></span><div class="flex flex-row flex-between mt-16"><div class=flex-31><div class="ft_14_600_moreblack required" translate=Supplier></div><selectbox-input class="w-100 dropdown-primary" ng-model=material.supplier options=vm.suppliers label-field=name value-field=_id></selectbox-input></div><div class=flex-31><div class=ft_14_600_moreblack translate="Supplier Material ID"></div><input type=text class="input-primary w-100" ng-model=material.supplierMaterialId></div><div class=flex-31><div class=ft_14_600_moreblack translate="Material Serial No."></div><input type=text class="input-primary w-100" ng-model=material.materialSerialNumber></div></div><div class="flex flex-row flex-between mt-24"><div class=flex-31><div class=ft_14_600_moreblack translate=Currency></div><selectbox-input class="w-100 dropdown-primary" ng-model=material.currency options=vm.currencies label-field=cc value-field=cc on-change=changeMaterialCurrency()></selectbox-input></div><div class=flex-31><div class="ft_14_600_moreblack required" translate="Material Cost"></div><input type=text class="input-primary w-100" ng-model=material.materialCost.value></div><div class=flex-31><div class="ft_14_600_moreblack required" translate="Worker Cost"></div><input type=text class="input-primary w-100" ng-model=material.rooferCost.value></div></div></div><div class="profile-card p-24"><span class=label translate=ATTACHMENTS></span><div class="flex-items-center mt-16 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ng-model=vm.inputImages ngf-select ngf-change="fileUpdated($files, \'image\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src="{{file.objectUrl || file.secure_url }}" alt=""><div class=file-name>{{file.name || file.originalname}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.deleteFile($index, \'image\')"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ng-model=vm.inputFiles ngf-select ngf-change="fileUpdated($files, \'file\')" name=file ngf-pattern="\'.pdf,.doc,.docx,.xls,.xlsx\'" ngf-multiple=true ngf-accept="\'.pdf,.doc,.docx,.xls,.xlsx\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=file-name>{{file.name || file.assetName}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.deleteFile($index, \'files\')"></div></div></div><div class="flex-items-center mt-24 mb-16"><div class="ft_14_600_black1 mr-16" style="min-width: 103px" translate="Images for AR"></div><div class=hr></div></div><div class=image-row><button class=btn-add-image ng-model=vm.inputImagesForAR ngf-select ngf-change="fileUpdated($files, \'image_for_ar\')" name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImagesForAR track by $index"><img class=file-thumbnail ng-src="{{file.objectUrl || file.secure_url}}" alt=""><div class=file-name>{{file.name || file.originalname}}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.deleteFile($index, \'image_for_ar\')"></div></div></div><div class="flex flex-row flex-content-end"><button class="button-primary mr-16" ng-click=vm.updateMaterial()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class=btn_cancel ui-sref="materialDetail({id: vm.materialId})"><img src=/assets/icons/close-circle-black.svg alt=icons><span translate=Cancel></span></button></div></div></div></div></main>');
$templateCache.put('app/main/materials/itemDetail/itemDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div class="item-detail main-container" ng-if=!isLoading><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=itemList translate="Building Parts"></a></div><div class=ft_24_600_black1 translate="Building Part"></div></div><div class="flex flex-row flex-items-center"><!-- <button ng-if="vm.userData.designation == \'Admin\'" class="btn_new_blue mr-16" ui-sref="materialAI({id: vm.materialId})">Material AI</button> --> <button class="btn_new_blue mr-16"><img src=/assets/icons/model-white.svg alt="" class=mr-8> <span>Object</span></button> <button class="btn_new_blue client_gray_back mr-16" ui-sref="editItem({id: vm.materialId})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=itemList><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card p-24" id=material-information><span class=label translate="ITEM INFORMATION"></span><div class="section-body mt-16"><!-- top info --><div class="d-flex justify-content-between mb-40"><!-- image sliders --><div class=image-sliders><div class=primary-slider><div class=slider ng-if=!vm.utils.isEmpty(vm.uploadImages)><div class=flexslider><ul class="slides img-resize"><li ng-repeat="f in vm.uploadImages"><img ng-src={{f.secure_url}} alt="" style="margin: auto"></li></ul></div></div><img ng-if=vm.utils.isEmpty(vm.uploadImages) class="no-img object-fit-cover" src=/assets/images/materials/noImg.jpg alt=icons></div><div ng-if="vm.uploadImages.length >= 4" class="mt-16 secondary-slider d-flex flex-column justify-content-between"><div ng-repeat="img in vm.uploadImages.slice(0, 4)"><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div><div ng-if="vm.uploadImages.length > 0 && vm.uploadImages.length < 4" class="mt-16 secondary-slider d-flex flex-row justify-content-between"><div ng-repeat="img in vm.uploadImages.slice(0, 4)" class=mr-16><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div></div><!-- basic material info --><div class=basic-info><div class="d-flex justify-content-between"><div><div class=tags><div class="tag blue" ng-if=vm.material.systemTag>{{ vm.material.systemTag }}</div></div><div class="ft_24_600_black1 mt-16 mb-2">{{ vm.material.name }}</div><div class="ft_14_regular_gray2 mb-16">{{ vm.material.createdAt | date: \'MMMM d, yyyy\' : \'UTC\' }}</div><div class=tags><img src=assets/icons/settings.svg><div class=tag ng-if=vm.material.maintenancePeriod>Maintenance Period : <span class=bold>{{ vm.material.maintenancePeriod }} days</span></div><div class=tag ng-if=!vm.material.maintenancePeriod>Maintenance Period not available</div></div></div><div class=text-center><div class=mb-8><span class=ft_12_600_black>Generate&nbsp;</span> <span class="ft_12_600_yellow cursor-point">QR Code</span></div><qr type-number=8 correction-level="\'M\'" size=96 input-mode="\'Auto\'" text="\'abc\'" image=true></qr><div class="ft_12_regular_black mt-8">ST100023146</div></div></div><div class="d-flex justify-content-start"><div class="block py-4 mr-24" ng-repeat="box in boxes track by $index"><div class=symbol><img ng-src={{box.img}} alt=symbol></div><div class=ft_14_500_white>{{box.title}}</div><!-- <div class="ft_18_500_white" ng-if="$index === 0 && vm.utils.unit2array(box.unit).length === 2">\n                    {{vm.utils.unit2array(box.unit)[0]}}<sup>{{vm.utils.unit2array(box.unit)[1]}}</sup>\n                  </div> --><div class=ft_18_500_white ng-if="$index === 0 && vm.utils.unit2array(box.unit).length !== 2">{{box.unit}}</div><div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}">{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}</div><!-- <div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0 && box.baseValue" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}">\n                    {{box.baseValue | readable: 2}}&nbsp;{{box.baseCurrencyCode}}\n                  </div> --></div></div></div></div><!-- bottom info table --><div class=material-info-table><div class=thead><div class=tr><div class="td no">Sr.No.</div><div class="td name">Item Name</div><div class="td unit">Unit</div><div class="td material-cost">Quantity</div><div class="td addition">Unit Price</div><div class="td worker-cost">Items Cost</div></div></div><div class=tbody><div class=tr><div class="td no">1</div><div class="td name">{{vm.material.name}}</div><div class="td unit" ng-if="vm.utils.unit2array(vm.material.unit).length === 2">{{vm.utils.unit2array(vm.material.unit)[0]}}<sup>{{vm.utils.unit2array(vm.material.unit)[1]}}</sup></div><div class="td unit" ng-if="vm.utils.unit2array(vm.material.unit).length !== 2">{{vm.material.unit}}</div><div class="td material-cost">{{ vm.material.itemsUnit | readable: 2 }}</div><div class="td addition">{{ vm.material.unitSize }}</div><div class="td worker-cost">{{ vm.material.cost[0].itemsCost | readable: 2 }}</div></div><!-- <div class="tr" style="background: #E8E8E8">\n                <div class="td no">Total</div>\n                <div class="td name"></div>\n                <div class="td unit"></div>\n                <div class="td material-cost">{{ vm.material.baseRate.materialCost | readable: 2 }}</div>\n                <div class="td addition"></div>\n                <div class="td worker-cost">{{ vm.material.baseRate.rooferCost | readable: 2 }}</div>\n              </div> --></div></div></div></div><div class="profile-card p-24 mt-24" id=material-attachments><span class=label translate=ATTACHMENTS></span><div class=section-body><div class="flex-items-center mt-16 mb-16" ng-if=vm.uploadImages.length><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.secure_url}} alt=thumbnail ng-click=showImage(file.secure_url)><div class=file-name>{{file.name }}</div></div></div><div class="flex-items-center mt-24 mb-16" ng-if=vm.uploadFiles.length><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt="" ng-click=vm.utils.downloadFile(file.secure_url)><div class=file-name>{{file.originalname }}</div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/materials/itemList/itemList.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=itemsList class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ng-if="!(vm.isViewGroupList || vm.isViewGroupDetail)" translate=Materials></a> <a ng-click=vm.showAllList() class="ft-normal-12-16 grey-2 cursor-point" translate=Materials ng-if="vm.isViewGroupList || vm.isViewGroupDetail"></a> <img src="/assets/icons/chevron-right 1.svg" ng-if="vm.isViewGroupList || vm.isViewGroupDetail" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Groups ng-if=vm.isViewGroupList></a> <a ng-click="vm.isViewGroupList = true; vm.isViewGroupDetail = false" class="ft_14_regular_gray cursor-point" translate=Groups ng-if=vm.isViewGroupDetail></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons ng-if=vm.isViewGroupDetail> <a class="ft-normal-12-16 grey-2" ng-if=vm.isViewGroupDetail>{{vm.selectedGroupName}}</a></div><div class=ft_24_600_black1 translate=Items></div></div><div class=nav-items><div ui-sref=materialList class="nav-item inactive" translate=Materials></div><div ui-sref=itemList class="nav-item active" translate="Building Parts"></div><div ui-sref=dcpList class="nav-item inactive" translate=DCP></div></div><div class="ml-auto flex flex-row flex-items-center"><div class=flex-between ng-if=!vm.isViewGroupList><searchbox search-text=vm.searchText search-event=searchCallback() ng-if=!vm.isViewGroupList is-small=true input-class="w-200 mr-3"></searchbox><button class="btn-trans ml-16" ng-click=switchViewMode(false)><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click=switchViewMode(true)><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button> <button class="button-primary ml-16" ui-sref=addItem ng-if="MAT_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Add Building Part"></span></button></div></div></div><div><no-data ng-if="isLoading == false && totalCount==0 && !vm.isViewGroupList"></no-data><div><div class=mt-0 ng-if=vm.isViewGroupList><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked> <span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate=Name></span></th><th class=ft_14_600_black><span translate=Count></span></th><th class=ft_14_600_black><span translate="Created At"></span></th><th class=ft_14_600_black><span translate="Updated At"></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, item) in vm.materialGroup"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=item.checked> <span class=checkmark></span></label></td><td class="ft_14_regular_black cursor-point" ng-click=vm.showMaterialsByGroup(item._id)>{{item.name}}</td><td class=ft_14_regular_black>{{item.count}}</td><td class=ft_14_regular_black>{{item.createdAt | date}}</td><td class=ft_14_regular_black>{{item.updatedAt | date}}</td><td class="more flex-items-center"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class="margin-0 cursor-point"></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage_group(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPageForGroup - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPageForGroup - 1) * numPerPage + vm.materialGroup.length}}</span> of {{totalCountForGroup}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPagesForGroup current-page=vm.currentPageForGroup on-select-page=vm.fetchMaterialGroup()></pagination-custom-new></div></div></div></div></div><div ng-if="totalCount!=0"><div class="card-based-content-grid-wrapper pr-24 pv-24" ng-if="isGrid && !vm.isViewGroupList"><div class="quotes-wrapper flex flex-wrap"><div class=inventory-card-container ng-repeat="item in materials" ng-show="materials.length != 0"><inventory-card class=d-block item-data=item type="\'item\'" currency-symbol=getCurrencySymbol(item)></inventory-card></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + materials.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.sortMaterials()></pagination-custom-new></div></div></div></div><div class=mt-0 ng-if="!isGrid && !vm.isViewGroupList"><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked> <span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black width=20%><span translate="Material name"></span></th><th class="ft_14_600_black center"><span translate=Unit></span></th><th class="ft_14_600_black center"><span translate="Items / Unit"></span></th><th class=ft_14_600_black></th><th class=ft_14_600_black></th><th class="ft_14_600_black right"><span translate=Maintenance></span></th><th class="ft_14_600_black center"><span translate=Certified></span></th><th class="ft_14_600_black right"><span translate="Items Cost"></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, item) in materials"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=item.checked> <span class=checkmark></span></label></td><td class="ft_14_regular_black cursor-point" width=20% ui-sref="itemDetail({id: item._id})">{{item.name}}</td><td class="ft_14_regular_black center">{{item.unit}}</td><td class="ft_14_regular_black center">{{item.itemsUnit}}</td><td class=ft_14_regular_black></td><td class=ft_14_regular_black></td><td class="ft_14_regular_black right">{{item.maintenancePeriod}} days</td><td class="ft_14_regular_black center"><img ng-src="{{ item.certifiedMaintenance ? \'/assets/icons/check-mark-green.svg\' : \'assets/icons/check-mark-gray.svg\' }}" class="avatar-20 object-fit-cover"></td><td class="ft_14_regular_black right">{{getCurrencySymbol(item)}}&nbsp;{{item.cost[0].itemsCost | readable: 2}}</td><td class="more flex-items-center"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class="margin-0 cursor-point" ng-click="itemDetail({id: item._id})"></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + materials.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.sortMaterials()></pagination-custom-new></div></div></div></div></div></div></div></main><!--upload modal here--><div class="modal fade p-0 m-0" id=uploadmatModal tabindex=-1 role=dialog><div class=modal-content-container><div class="modal-content modal-content-one"><div class=title-black><h5 translate="Import Materials"></h5></div><div class=modal-body><a href=http://res.cloudinary.com/dktnhmsjx/raw/upload/v1528176008/materialdata.xlsx class=view_image data-popup=true target=_blank rel=noopener translate="download template"></a><br><div class=flex-center><div class="btn btn-warning mt-10" type=file ngf-select ng-model=vm.inputExcel name=file ngf-pattern="\'.xlsx, application/vnd.ms-excel, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-accept="\'.xlsx\'" ngf-multiple=false ngf-max-size=20MB translate=Browse></div><label class="mr-10 mt-15">&nbsp;&nbsp; {{ vm.inputExcel.name }}</label> <button class="btn btn-primary mt-10" ng-if=vm.inputExcel ng-click=upLoadExcelFile(vm.inputExcel) translate=upload></button></div></div></div></div></div>');
$templateCache.put('app/main/materials/materialAI/materialAI.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div class="material-detail main-container"><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=materialList translate=Materials></a></div><div class=ft_24_600_black1 translate="Material AI"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary ph-10 mr-16" ng-click=vm.togglePlay()><img src=/assets/icons/play_circle_outline-white.svg alt=""> <span>{{vm.isPlaying ? "Stop AI" : "Play AI"}}</span></button> <button class="button-third mr-16 ph-10" ui-sref="editMaterial({id: vm.materialId})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_cancel ph-10" ui-sref=materialList><img src=/assets/icons/close-circle-black.svg alt=icons><span translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card p-24" id=material-information><span class=label translate="MATERIAL INFORMATION"></span><div class="section-body mt-16"><!-- top info --><div class="d-flex justify-content-between mb-40"><!-- image sliders --><div class=image-sliders><div class=primary-slider><div class=slider ng-if=!vm.utils.isEmpty(vm.uploadImages)><div class=flexslider><ul class=slides><li ng-repeat="f in vm.uploadImages"><img ng-src={{f.secure_url}} alt="" style="margin: auto"></li></ul></div></div><img ng-if=vm.utils.isEmpty(vm.uploadImages) class="no-img object-fit-cover" src=/assets/images/materials/noImg.jpg alt=icons></div><div ng-if="vm.uploadImages.length >= 4" class="mt-16 secondary-slider d-flex flex-column justify-content-between"><div ng-repeat="img in vm.uploadImages.slice(0, 4)"><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div><div ng-if="vm.uploadImages.length > 0 && vm.uploadImages.length < 4" class="flex-between mt-16 secondary-slider"><div ng-repeat="img in vm.uploadImages.slice(0, 4)"><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div></div><div id=chart class="chart-container no-zoom" ng-show=vm.isPlaying></div><!-- basic material info --><div class=basic-info><div class="d-flex justify-content-between"><div><div class=tags><div class="tag blue" ng-if=vm.material.systemTag>{{ vm.material.systemTag }}</div></div><div class="ft_24_600_black1 mt-16 mb-2">{{ vm.material.name }}</div><div class="ft_14_regular_gray2 mb-16">{{ vm.material.createdAt | date: \'MMMM d, yyyy\' : \'UTC\' }}</div><div class=tags><div class="tag dark-blue" ng-if=vm.nextMaintenanceDate>Next Maintenance On {{ vm.nextMaintenanceDate }}</div><div class="tag dark-blue" ng-if=!vm.nextMaintenanceDate>Maintenance Date not available</div></div></div><div class=text-center><div class=mb-8><span class=ft_12_600_black translate=Generate>&nbsp;</span> <span class="ft_12_600_yellow cursor-point" translate="QR Code"></span></div><qr type-number=8 correction-level="\'M\'" size=96 input-mode="\'Auto\'" text="\'abc\'" image=true></qr><div class="ft_12_regular_black mt-8">ST100023146</div></div></div><div class="d-flex justify-content-between"><div class="block py-4" ng-repeat="box in boxes track by $index"><div class=symbol><img ng-src={{box.img}} alt=symbol></div><div class=ft_14_500_white>{{box.title}}</div><div class=ft_18_500_white ng-if="$index === 0 && vm.utils.unit2array(box.unit).length === 2">{{vm.utils.unit2array(box.unit)[0]}}<sup>{{vm.utils.unit2array(box.unit)[1]}}</sup></div><div class=ft_18_500_white ng-if="$index === 0 && vm.utils.unit2array(box.unit).length !== 2">{{box.unit}}</div><div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}">{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}</div><div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0 && box.baseValue" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}">{{box.baseValue | readable: 2}}&nbsp;{{box.baseCurrencyCode}}</div></div></div></div></div><!-- bottom info table --><div class="material-ai-info-table mb-24 pos-relative"><div class=thead><div class=tr><div class="td no" translate=Sr.No.></div><div class="td geometric-type" translate="Geometric Type"></div><div class="td size" translate=Size></div><div class="td slope" translate=Slope></div><div class="td season" translate=Season></div><div class="td building-type" translate="Building Type"></div><div class="td penetrations" translate=Penetrations/m><sup>2</sup></div><div class="td cost" translate="Avg.Material Cost"></div><div class="td cost" translate="Avg.Work Cost"></div><div class="td cost" translate=vg.Material><br>Cost Unit Based</div><div class="td cost" translate=Avg.Work><br>Cost Unit Based</div></div></div><div class=tbody><div ng-if=!vm.aiInfos.length class="tr justify-content-center"><div class=font-italic>There is no material AI information</div></div><div class=tr ng-repeat="aiInfo in vm.aiInfos track by $index"><div class="td no">{{$index + 1}}</div><div class="td geometric-type"><span class=text-capitalize>{{aiInfo.geometricType}}</span></div><div class="td size"><span>{{aiInfo.size | readable: 2}}</span></div><div class="td slope"><span>{{aiInfo.slope | readable: 0}}&deg;</span></div><div class="td season"><span>{{aiInfo.season}}</span></div><div class="td building-type"><span>{{aiInfo.buildingType}}</span></div><div class="td penetrations"><span>{{aiInfo.penetration | readable: 2}}</span></div><div class="td cost"><span>{{aiInfo.avgMaterialCost | readable: 2}}</span></div><div class="td cost"><span>{{aiInfo.avgLaborCost | readable: 2}}</span></div><div class="td cost"><span>{{aiInfo.avgMaterialCostUnitBased | readable: 2}}</span></div><div class="td cost"><span>{{aiInfo.avgWorkCostUnitBased | readable: 2}}</span></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/materials/materialDetail/materialDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div class="material-detail main-container" ng-if=!isLoading><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=materialList translate=Materials></a></div><div class=ft_24_600_black1 translate="Material Details"></div></div><div class="flex flex-row flex-items-center"><button ng-if="vm.userData.designation == \'Admin\'" class="btn_new_blue mr-16" ui-sref="materialAI({id: vm.materialId})">Material AI</button> <button class="btn_new_blue client_orange_back mr-16"><img src=/assets/icons/model-white.svg alt="" class=mr-8> <span translate="3D Viewer"></span></button> <button class="btn_new_blue client_gray_back mr-16" ui-sref="editMaterial({id: vm.materialId})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=materialList><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class="profile-card p-24" id=material-information><span class=label translate="MATERIAL INFORMATION"></span><div class="section-body mt-16"><!-- top info --><div class="d-flex justify-content-between mb-40"><!-- image sliders --><div class=image-sliders><div class=primary-slider><div class=slider ng-if=!vm.utils.isEmpty(vm.uploadImages)><div class=flexslider><ul class=slides><li ng-repeat="f in vm.uploadImages"><img ng-src={{f.secure_url}} alt="" style="margin: auto"></li></ul></div></div><img ng-if=vm.utils.isEmpty(vm.uploadImages) class="no-img object-fit-cover" src=/assets/images/materials/noImg.jpg alt=icons></div><div ng-if="vm.uploadImages.length >= 4" class="mt-16 secondary-slider d-flex flex-column justify-content-between"><div ng-repeat="img in vm.uploadImages.slice(0, 4)" class=pr-16><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div><div ng-if="vm.uploadImages.length > 0 && vm.uploadImages.length < 4" class="flex-between mt-16 secondary-slider"><div ng-repeat="img in vm.uploadImages.slice(0, 4)" class=pr-16><img class=thumbnail-image ng-src="{{ img.secure_url }}" alt=image ng-click=showImage(img.secure_url)></div></div></div><!-- basic material info --><div class=basic-info><div class="d-flex justify-content-between"><div><div class=tags><div class="tag blue" ng-if=vm.material.systemTag>{{ vm.material.systemTag }}</div></div><div class="ft_24_600_black1 mt-16 mb-2">{{ vm.material.name }}</div><div class="ft_14_regular_gray2 mb-16">{{ vm.material.createdAt | date: \'MMMM d, yyyy\' : \'UTC\' }}</div><div class=tags><div class="tag dark-blue" ng-if=vm.nextMaintenanceDate>Next Maintenance On {{ vm.nextMaintenanceDate }}</div><div class="tag dark-blue" ng-if=!vm.nextMaintenanceDate>Maintenance Date not available</div></div></div><div class=text-center><div class=mb-8><span class=ft_12_600_black translate=Generate>&nbsp;</span> <span class="ft_12_600_yellow cursor-point" translate="QR Code"></span></div><qr type-number=8 correction-level="\'M\'" size=96 input-mode="\'Auto\'" text="\'abc\'" image=true></qr><div class="ft_12_regular_black mt-8">ST100023146</div></div></div><div class="d-flex justify-content-between"><div class="block py-4" ng-repeat="box in boxes track by $index"><div class=symbol><img ng-src={{box.img}} alt=symbol></div><div class=ft_14_500_white translate={{box.title}}></div><div class=ft_18_500_white ng-if="$index === 0 && vm.utils.unit2array(box.unit).length === 2" translate={{vm.utils.unit2array(box.unit)[0]}}><sup translate={{vm.utils.unit2array(box.unit)[1]}}></sup></div><div class=ft_18_500_white ng-if="$index === 0 && vm.utils.unit2array(box.unit).length !== 2" translate={{box.unit}}></div><div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}"><span>{{box.value | readable: 2}}</span>&nbsp; <span translate={{box.currencyCode}}></span></div><div class="ft_18_500_white text-ellipsis text-center" ng-if="$index !== 0 && box.baseValue" style="width: 128px; margin: 0 auto" title="{{box.value | readable: 2}}&nbsp;{{box.currencyCode}}"><span>{{box.baseValue | readable: 2}}</span>&nbsp; <span translate={{box.baseCurrencyCode}}></span></div></div></div></div></div><!-- bottom info table --><div class=material-info-table><div class=thead><div class=tr><div class="td no" translate=Sr.No.></div><div class="td name" translate="Material Name"></div><div class="td unit" translate=Unit></div><div class="td material-cost" translate="Material Cost">({{vm.material.baseRate.currencyCode}})</div><div class="td addition" translate="% Addition"></div><div class="td worker-cost" translate="Worker Cost">({{vm.material.baseRate.currencyCode}})</div></div></div><div class=tbody><div class=tr><div class="td no">1</div><div class="td name">{{vm.material.name}}</div><div class="td unit" ng-if="vm.utils.unit2array(vm.material.unit).length === 2">{{vm.utils.unit2array(vm.material.unit)[0]}}<sup>{{vm.utils.unit2array(vm.material.unit)[1]}}</sup></div><div class="td unit" ng-if="vm.utils.unit2array(vm.material.unit).length !== 2">{{vm.material.unit}}</div><div class="td material-cost">{{ vm.material.baseRate.materialCost | readable: 2 }}</div><div class="td addition"></div><div class="td worker-cost">{{ vm.material.baseRate.rooferCost | readable: 2 }}</div></div><div class=tr style="background: #E8E8E8"><div class="td no" translate=Total></div><div class="td name"></div><div class="td unit"></div><div class="td material-cost">{{ vm.material.baseRate.materialCost | readable: 2 }}</div><div class="td addition"></div><div class="td worker-cost">{{ vm.material.baseRate.rooferCost | readable: 2 }}</div></div></div></div></div></div><div class="profile-card p-24 mt-24" id=material-attachments><span class=label translate=ATTACHMENTS></span><div class=section-body><div class="flex-items-center mt-16 mb-16" ng-if=vm.uploadImages.length><div class="ft_14_600_black1 mr-16" style="min-width: 50px" translate=Images></div><div class=hr></div></div><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.secure_url}} alt=thumbnail ng-click=showImage(file.secure_url)><div class=file-name>{{file.name }}</div></div></div><div class="flex-items-center mt-24 mb-16" ng-if=vm.uploadFiles.length><div class="ft_14_600_black1 mr-16" style="min-width: 78px" translate=Documents></div><div class=hr></div></div><div class=images><div class=image-container ng-repeat="file in vm.uploadFiles track by $index"><img class=file-thumbnail ng-src={{vm.utils.getFileIcon(file)}} alt="" ng-click=vm.utils.downloadFile(file.secure_url)><div class=file-name>{{file.originalname }}</div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/materials/materialList/materialList.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=materialList class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ng-if="!(vm.isViewGroupList || vm.isViewGroupDetail)" translate=Materials></a> <a ng-click=vm.showAllList() class="ft-normal-12-16 grey-2 cursor-point" translate=Materials ng-if="vm.isViewGroupList || vm.isViewGroupDetail"></a> <img src="/assets/icons/chevron-right 1.svg" ng-if="vm.isViewGroupList || vm.isViewGroupDetail" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Groups ng-if=vm.isViewGroupList></a> <a ng-click="vm.isViewGroupList = true; vm.isViewGroupDetail = false" class="ft_14_regular_gray cursor-point" translate=Groups ng-if=vm.isViewGroupDetail></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons ng-if=vm.isViewGroupDetail> <a class="ft-normal-12-16 grey-2" ng-if=vm.isViewGroupDetail>{{vm.selectedGroupName}}</a></div><div class=ft_24_600_black1 translate=Materials></div></div><div class=nav-items><div ui-sref=materialList class="nav-item active" translate=Materials></div><div ui-sref=itemList class="nav-item inactive" translate="Building Parts"></div><div ui-sref=dcpList class="nav-item inactive" translate=DCP></div></div><div class="ml-auto flex flex-row flex-items-center"><div class=flex-between ng-if=!vm.isViewGroupList><searchbox search-text=vm.searchText search-event=searchCallback() ng-if=!vm.isViewGroupList is-small=true input-class="w-200 mr-3"></searchbox><button class="btn-trans ml-16" ng-click=switchViewMode(false)><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click=switchViewMode(true)><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button> <button class="button-primary ml-16" ui-sref=addMaterial ng-if="MAT_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Add Material"></span></button></div></div></div><div><no-data ng-if="isLoading == false && totalCount==0 && !vm.isViewGroupList"></no-data><div><div class=mt-0 ng-if=vm.isViewGroupList><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked> <span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate=Name></span></th><th class=ft_14_600_black><span translate=Count></span></th><th class=ft_14_600_black><span translate="Created At"></span></th><th class=ft_14_600_black><span translate="Updated At"></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, item) in vm.materialGroup"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=item.checked> <span class=checkmark></span></label></td><td class="ft_14_regular_black cursor-point" ng-click=vm.showMaterialsByGroup(item._id)>{{item.name}}</td><td class=ft_14_regular_black>{{item.count}}</td><td class=ft_14_regular_black>{{item.createdAt | date}}</td><td class=ft_14_regular_black>{{item.updatedAt | date}}</td><td class="more flex-items-center"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class="margin-0 cursor-point"></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage_group(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPageForGroup - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPageForGroup - 1) * numPerPage + vm.materialGroup.length}}</span> of {{totalCountForGroup}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPagesForGroup current-page=vm.currentPageForGroup on-select-page=vm.fetchMaterialGroup()></pagination-custom-new></div></div></div></div></div><div ng-if="totalCount!=0"><div class="card-based-content-grid-wrapper pr-24 pv-24" ng-if="isGrid && !vm.isViewGroupList"><div class="quotes-wrapper flex flex-wrap"><div class=inventory-card-container ng-repeat="item in materials" ng-show="materials.length != 0"><inventory-card class=d-block item-data=item type="\'material\'" currency-symbol=getCurrencySymbol(item)></inventory-card></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + materials.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.sortMaterials()></pagination-custom-new></div></div></div></div><div class=mt-0 ng-if="!isGrid && !vm.isViewGroupList"><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked> <span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black width=20%><span translate="Material name"></span></th><th class="ft_14_600_black center"><span translate=Unit></span></th><th class="ft_14_600_black center"><span translate="Items / Unit"></span></th><th class="ft_14_600_black center"><span translate="Items / Pallet"></span></th><th class="ft_14_600_black center"><span translate=Fullload></span></th><th class=ft_14_600_black><span translate="Pallet Size"></span></th><th class="ft_14_600_black right"><span translate=Maintenance></span></th><th class="ft_14_600_black center"><span translate=Certified></span></th><th class="ft_14_600_black right"><span translate="Material Cost"></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, item) in materials"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=item.checked> <span class=checkmark></span></label></td><td class="ft_14_regular_black cursor-point" width=20% ui-sref="materialDetail({id: item._id})">{{item.name}}</td><td class="ft_14_regular_black center">{{item.unit}}</td><td class="ft_14_regular_black center">{{item.itemsUnit}}</td><td class="ft_14_regular_black center">{{item.itemsPallet}}</td><td class="ft_14_regular_black center">{{item.fullLoad}}</td><td class=ft_14_regular_black>{{item.dimensions.unit.length ? item.dimensions.unit.length + " x " + item.dimensions.unit.width + " x " + item.dimensions.unit.height + " " + item.unit : ""}}</td><td class="ft_14_regular_black right">{{item.maintenancePeriod}} days</td><td class="ft_14_regular_black center"><img ng-src="{{ item.certifiedMaintenance ? \'/assets/icons/check-mark-green.svg\' : \'assets/icons/check-mark-gray.svg\' }}" class="avatar-20 object-fit-cover"></td><td class="ft_14_regular_black right">{{getCurrencySymbol(item)}}&nbsp;{{item.currentRate.materialCost.value | readable: 2}}</td><td class="more flex-items-center"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class="margin-0 cursor-point"></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + materials.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.sortMaterials()></pagination-custom-new></div></div></div></div></div></div></div></main><!--upload modal here--><div class="modal fade p-0 m-0" id=uploadmatModal tabindex=-1 role=dialog><div class=modal-content-container><div class="modal-content modal-content-one"><div class=title-black><h5 translate="Import Materials"></h5></div><div class=modal-body><a href=http://res.cloudinary.com/dktnhmsjx/raw/upload/v1528176008/materialdata.xlsx class=view_image data-popup=true target=_blank rel=noopener translate="download template"></a><br><div class=flex-center><div class="btn btn-warning mt-10" type=file ngf-select ng-model=vm.inputExcel name=file ngf-pattern="\'.xlsx, application/vnd.ms-excel, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'" ngf-accept="\'.xlsx\'" ngf-multiple=false ngf-max-size=20MB translate=Browse></div><label class="mr-10 mt-15">&nbsp;&nbsp; {{ vm.inputExcel.name }}</label> <button class="btn btn-primary mt-10" ng-if=vm.inputExcel ng-click=upLoadExcelFile(vm.inputExcel) translate=upload></button></div></div></div></div></div>');
$templateCache.put('app/main/offer/createOffer/createOffer.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=offerList translate=Offers></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Create offer"></a></div><div class=ft_24_600_black1 translate="Create offer"></div></div><div class="flex flex-row flex-items-center" ng-if=isExported><button class="button-primary mr-16" ng-click=vm.saveOffer()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=vm.sendOffer()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ng-click=vm.cancelOfferView()><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div><button ng-if=!isExported class=button-primary ng-click=vm.export()><img src=/assets/icons/bx-Upload.svg alt=icons><span translate=Export></span></button></div><div id=createOffer class=main-container ng-if=!isExported><div class=content-wrapper><div class=content><div class=bread-crumb><div class="item label" ng-click=vm.goToRoot() translate=Root></div><div class=flex ng-repeat="item in vm.currentStateList track by $index"><img src=/assets/icons/arrow-right2.svg alt="" class=mr-2><div class=item ng-click=vm.changeBreadCrumb($index)>{{ item.name }}</div></div></div><spinner ng-show=isLoading></spinner><div ng-if="vm.openBreadCumb==false && !isLoading"><calc-fixed-group ng-repeat="level in tableInventory" index=$index ng-model=level company-currency=companyCurrency checkable=true on-enter-child=vm.callBreadCrumb></calc-fixed-group><div class="cal-total box-shadow-white" ng-if="vm.extraCosts && vm.extraCosts.length"><div class=title><div class=flex-5>&nbsp;</div><div class=flex-13 translate="Extra Costs"></div><div class=flex-8>&nbsp;</div><div class=flex-4>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-6>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8 translate="Cost in %"></div><div class=flex-8 translate=Cost></div></div><div class="sum pos-relative" ng-repeat="cost in vm.extraCosts track by $index"><div class=flex-5>&nbsp;</div><div class="flex-13 overflow-visible">{{cost.name}}</div><div class=flex-8>&nbsp;</div><div class=flex-4>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-6>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8 title="{{ cost.value | readable: 2 }}">{{ cost.value | readable: 2 }}</div><div class=flex-8 title="{{companyCurrency.symbol + \' \' + ((totalSum * cost.value / 100) | readable: 2)}}">{{ companyCurrency.symbol }}&nbsp;{{ (totalSum * cost.value / 100) | readable: 2 }}</div><div class=delete-com><label class=check_yellow_20><input type=checkbox ng-change=stopPropagation(); ng-model=cost.checked> <span class=checkmark></span></label></div></div></div></div><div ng-if="vm.openBreadCumb==true && !isLoading"><calc-fixed-group index=vm.breadCrumbIndex ng-model=vm.currentState company-currency=companyCurrency checkable=true on-enter-child=breadCrumbSubLevel></calc-fixed-group></div></div></div></div><div id=offerInfo class=main-container ng-if=isExported><div class="card-based-content-grid-wrapper p-24"><spinner ng-if=isLoading></spinner><div class=profile-card ng-if=!isLoading><span class=label translate="CLIENT INFORMATION"></span><div class="flex flex-row flex-between"><div class=flex-32><div class=ft_14_600_moreblack translate="Client Name"></div><div class="input-primary w-100">{{ vm.offer.project.client.clientName }}</div></div><div class=flex-32><div class=ft_14_600_moreblack translate=Address></div><div class="input-primary w-100 tx-ellipsis">{{ vm.getCompanyAddress() }}</div></div><div class=flex-32><div class=ft_14_600_moreblack translate="Mail ID"></div><div class="input-primary w-100">{{ vm.offer.project.client.email }}</div></div></div><div class="flex flex-row flex-between mt-24"><div class=flex-46><div class="ft_14_600_moreblack required" translate="Staff Contact"></div><selectbox-input class=dropdown-primary options=vm.offer.client.staffs label-field=displayName value-field=_id ng-model=vm.offerstaff select-event=selStaff(vm.offerstaff)></selectbox-input></div><div class=flex-25><div class=ft_14_600_moreblack translate="First Name"></div><input class="input-primary w-100" type=text ng-model=vm.offer.staff.firstName readonly></div><div class=flex-25><div class=ft_14_600_moreblack translate="Last Name"></div><input class="input-primary w-100" type=text ng-model=vm.offer.staff.lastName readonly></div></div></div><div class=profile-card ng-if=!isLoading><span class=label translate="QUOTE DETAIL"></span><div class="flex flex-row flex-between"><div class=flex-32><div class="ft_14_600_moreblack required" translate="Quote Name"></div><input class="input-primary w-100" type=text ng-model=vm.offer.offerName></div><div class=flex-32><div class=ft_14_600_moreblack translate="Project Name"></div><input class="input-primary w-100" type=text ng-model=vm.offer.project.projectName readonly></div><div class=flex-32><div class=ft_14_600_moreblack translate="Responsible Person"></div><div class="input-primary w-100">{{vm.userData.displayName}}</div></div></div><div class="mt-24 flex flex-row flex-between"><div class=flex-32><div class=ft_14_600_moreblack translate="Quote Date"></div><div class="input-group datePicker-primary mb-20"><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.offer.date is-open=isDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isDatepickerOpen = !isDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div><div class=ft_14_600_moreblack translate="Valid Till"></div><div class="input-group datePicker-primary"><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.offer.validTill is-open=isvalidTillDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isvalidTillDatepickerOpen = !isvalidTillDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=flex-66><div class=ft_14_600_moreblack translate="Description of work"></div><textarea class=text-area style="height: 140px;" placeholder="Enter your description here" ng-model=vm.offer.description></textarea></div></div></div><div class=profile-card ng-if=!isLoading><span class=label translate="PRODUCT DETAIL"></span><div class=combine><button class="button-primary blue" ng-click=onRefresh() translate=Refresh></button> <button class=button-primary ng-click=onCombine() translate=Combine></button></div><div class=products><div class=tr-item><div class=flex-5>&nbsp;</div><div class=flex-10 translate=ID></div><div class=flex-20 translate="Product Name"></div><div class=flex-34 translate=Description></div><div class=flex-7 translate=Qty></div><div class=flex-7 translate="Unit Price"></div><div class=flex-10 translate="Total Amount"></div><div class=flex-7 translate=Actions></div></div><div class=tr-item ng-repeat="item in vm.offer.offerDetails"><div class=flex-5><label class=check_yellow_20><input type=checkbox ng-model=item.index ng-change=onSelOffer(item)><span class=checkmark></span></label></div><div class=flex-10><input type=text ng-model=item.productId></div><div class=flex-20><input type=text ng-model=item.productName></div><div class=flex-34><input type=text ng-model=item.description></div><div class=flex-7>{{ item.quantity }}</div><div class=flex-7>{{ item.unitPrice | readable: 2 }}</div><div class=flex-10><!-- {{ item.currency }}&nbsp; --> {{ item.total | readable: 2 }}</div><div class="icons flex-7"><a href="" ng-click="vm.offer.offerDetails.splice($index, 1)"><img src=/assets/icons/delete3.svg alt=""></a></div></div></div></div><div class=profile-card ng-if=!isLoading><span class=label translate="TERMS & CONDITIONS"></span><div class="flex flex-row flex-between"><div class=flex-32><div class=ft_14_600_moreblack translate=Amount></div><div class="input-primary w-100">{{vm.offer.totalNetAmount | readable: 2}}&nbsp;{{companyCurrency.symbol}}</div></div><div class=flex-32><div class=ft_14_600_moreblack translate=VAT></div><div class="input-primary w-100">{{vm.offer.totalTaxAmount | readable: 2}}&nbsp;{{companyCurrency.symbol}}</div></div><div class=flex-32><div class=ft_14_600_moreblack translate="Sales Price"></div><div class="input-primary w-100">{{vm.offer.offerTotal | readable: 2}}&nbsp;{{companyCurrency.symbol}}</div></div></div><div class="flex flex-row mt-24"><button class="button-primary mr-16" ng-click=vm.saveOffer()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=vm.sendOffer()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ng-click=vm.cancelOfferView()><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/offer/offerDetail/offerDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=offerDetail class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=offerList translate=Offers></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Offer Detail"></a></div><div class=ft_24_600_black1 translate="Offer Detail"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=vm.saveOffer() ng-if="OFFER_ACCESS_CREATE > 1"><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-secondary client_gray_back mr-16" ng-click=vm.sendOffer()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="button-third client_gray_back mr-16" ng-click=vm.deleteOffer() ng-if="OFFER_ACCESS_CREATE > 3"><img src=/assets/icons/delete-icon.svg alt=icons><span translate=Delete></span></button> <button class="btn_cancel client_gray_white_back" ui-sref=offerList><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><spinner ng-if=isLoading></spinner><div class=profile-card><span class=label translate="CLIENT INFORMATION"></span><div class="flex flex-row flex-between"><div class=flex-32><div class=ft_14_600_moreblack translate="Client Name"></div><div class="input-primary w-100">{{ vm.offer.projectId.client.clientName }}</div></div><div class=flex-32><div class=ft_14_600_moreblack translate=Address></div><div class="input-primary w-100 tx-ellipsis">{{ vm.getCompanyAddress() }}</div></div><div class=flex-32><div class=ft_14_600_moreblack translate="Mail ID"></div><div class="input-primary w-100">{{ vm.offer.projectId.client.email }}</div></div></div><div class="flex flex-row flex-between mt-24"><div class=flex-46><div class="ft_14_600_moreblack required" translate="Staff Contact"></div><selectbox-input class=dropdown-primary options=vm.offer.clientId.staffs label-field=displayName value-field=_id ng-model=vm.offerstaff select-event=selStaff(vm.offerstaff)></selectbox-input></div><div class=flex-25><div class=ft_14_600_moreblack translate="First Name"></div><input class="input-primary w-100" type=text ng-model=vm.offer.staff.firstName readonly></div><div class=flex-25><div class=ft_14_600_moreblack translate="Last Name"></div><input class="input-primary w-100" type=text ng-model=vm.offer.staff.lastName readonly></div></div></div><div class=profile-card ng-if=!isLoading><span class=label translate="QUOTE DETAIL"></span><div class="flex flex-row flex-between"><div class=flex-32><div class="ft_14_600_moreblack required" translate="Quote Name"></div><input class="input-primary w-100" type=text ng-model=vm.offer.offerName></div><div class=flex-32><div class=ft_14_600_moreblack translate="Project Name"></div><input class="input-primary w-100" type=text ng-model=vm.offer.projectId.projectName readonly></div><div class=flex-32><div class=ft_14_600_moreblack translate="Responsible Person"></div><div class="input-primary w-100">{{vm.userData.displayName}}</div></div></div><div class="mt-24 flex flex-row flex-between"><div class=flex-32><div class=ft_14_600_moreblack translate="Quote Date"></div><div class="input-group datePicker-primary mb-20"><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.offer.date is-open=isDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isDatepickerOpen = !isDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div><div class=ft_14_600_moreblack translate="Valid Till"></div><div class="input-group datePicker-primary"><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.offer.validTill is-open=isvalidTillDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isvalidTillDatepickerOpen = !isvalidTillDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=flex-66><div class=ft_14_600_moreblack translate="Description of work"></div><textarea class=text-area style="height: 140px;" placeholder="Enter your description here" ng-model=vm.offer.description></textarea></div></div></div><div class=profile-card ng-if=!isLoading><span class=label translate="PRODUCT DETAIL"></span><div class=combine><button class="button-primary blue" ng-click=onRefresh() translate=Refresh></button> <button class=button-primary ng-click=onCombine() translate=Combine></button></div><div class=products><div class=tr-item><div class=flex-5>&nbsp;</div><div class=flex-10 translate=ID></div><div class=flex-20 translate="Product Name"></div><div class=flex-34 translate=Description></div><div class=flex-7 translate=Qty></div><div class=flex-7 translate="Unit Price"></div><div class=flex-10 translate="Total Amount"></div><div class=flex-7 translate=Actions></div></div><div class=tr-item ng-repeat="item in vm.offer.offerDetails"><div class=flex-5><label class=check_yellow_20><input type=checkbox ng-model=item.index ng-change=onSelOffer(item)><span class=checkmark></span></label></div><div class=flex-10><input type=text ng-model=item.productId></div><div class=flex-20><input type=text ng-model=item.productName></div><div class=flex-34><input type=text ng-model=item.description></div><div class=flex-7>{{ item.quantity }}</div><div class=flex-7>{{ item.unitPrice | readable: 2 }}</div><div class=flex-10><!-- {{ item.currency }}&nbsp; --> {{ item.total | readable: 2 }}</div><div class="icons flex-7"><a href="" ng-click="vm.offer.offerDetails.splice($index, 1)"><img src=/assets/icons/delete3.svg alt=""></a></div></div></div></div><div class=profile-card ng-if=!isLoading><span class=label translate="TERMS & CONDITIONS"></span><div class="flex flex-row flex-between"><div class=flex-32><div class=ft_14_600_moreblack translate=Amount></div><div class="input-primary w-100">{{vm.offer.totalNetAmount | readable: 2}}&nbsp;{{companyCurrency.symbol}}</div></div><div class=flex-32><div class=ft_14_600_moreblack translate=VAT></div><div class="input-primary w-100">{{vm.offer.totalTaxAmount | readable: 2}}&nbsp;{{companyCurrency.symbol}}</div></div><div class=flex-32><div class=ft_14_600_moreblack translate="Sales Price"></div><div class="input-primary w-100">{{vm.offer.offerTotal | readable: 2}}&nbsp;{{companyCurrency.symbol}}</div></div></div><div class="flex flex-row mt-24"><button class="button-primary mr-16" ng-click=vm.saveOffer() ng-if="OFFER_ACCESS_CREATE > 1"><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-secondary mr-16" ng-click=vm.sendOffer()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="button-third mr-16" ng-click=vm.deleteOffer() ng-if="OFFER_ACCESS_CREATE > 3"><img src=/assets/icons/delete-icon.svg alt=icons><span translate=Delete></span></button> <button class=btn_cancel ui-sref=offerList><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/offer/offers/offers.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=offers class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Offers></a></div><div class=ft_24_600_black1 translate=Offers></div></div><selectbox class="arrowbottom_46_400 ml-auto" ng-model=vm.sortMenu options=vm.sortMenuList label-field=label value-field=key select-event=vm.selectSort() is-small=true></selectbox><searchbox class=ml-24 search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><div><button class="btn-trans ml-16" ng-click=onListView()><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click=onGridView()><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button></div><button class="button-primary ml-16" ng-click=goToCreate() ng-if="OFFER_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Create New Offer"></span></button></div><div><div><div class=content><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer" ng-if=isList><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked><span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate=Name></span></th><th class=ft_14_600_black><span translate="Email ID"></span></th><th class=ft_14_600_black><span translate="Contact No."></span></th><th class=ft_14_600_black><span translate=Address></span></th><th class=ft_14_600_black><span translate=Status></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="offer in vm.offers | filter:vm.searchText"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=offer.checked><span class=checkmark></span></label></td><td ng-click=goToDetail(offer)><div class="flex-row flex-items-center"><div class=avatar-cell><div ng-if=offer.clientId.clientLogo><img ng-src={{offer.clientId.clientLogo}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!offer.clientId.clientLogo><span class="avatar-text mr-15" ng-style="{\'background\': (getColor(offer.offerName))}">{{offer.offerName | mailAvatarChar}}</span></div></div><div class="flex flex-col"><div class="ft_16_600_black tx-ellipsis name" ng-bind=offer.offerName></div><!-- <div class="ft_14_regular_light tx-ellipsis">{{ offer.createdAt | date: "yyyy-MM-dd HH:mm" }}</div> --></div></div></td><td class="tx-ellipsis email ft_14_regular_black" ng-bind=offer.clientId.email></td><td class=ft_14_regular_black ng-bind="\'+\'+offer.clientId.clientContact.dialCode+\' \'+offer.clientId.clientContact.phoneNumber"></td><td class="tx-ellipsis address pr-20 ft_14_regular_black">{{ getAddress(offer.clientId.address) }}</td><td><div class=project-status-table ng-class="{\'opens\':offer.projectId.projectStatus==0, \'progresses\':offer.projectId.projectStatus==1,\n                      \'complete\':offer.projectId.projectStatus==2, \'cancel\': offer.projectId.projectStatus==3,\n                      \'lost\': offer.projectId.projectStatus==4, \'postponed\': offer.projectId.projectStatus==5,\n                      \'precast\': offer.projectId.projectStatus==6}">{{offer.projectId.projectStatus | projStatus}}</div></td><td class="more flex-items-center"><div class=cursor-point title="Export As PDF" ng-click=vm.downloadPdf(offer)><img src=/assets/icons/cloud-download.svg alt=""></div><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class=ml-8></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.offers.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=initData()></pagination-custom-new></div></div></div><div ng-if=isGrid><spinner ng-show=isLoading></spinner><div class="card-based-content-grid-wrapper pr-24 pv-24"><div class="quotes-wrapper flex flex-wrap"><div class="profile-card-container cursor-point" ng-click=goToDetail(offer) ng-repeat="offer in vm.offers | filter:vm.searchText" ng-if=!isLoading><div class=profile-card><div class=card-content><div class=project-status ng-class="{\'opens\':offer.projectId.projectStatus==0, \'progresses\':offer.projectId.projectStatus==1,\n                        \'complete\':offer.projectId.projectStatus==2, \'cancel\': offer.projectId.projectStatus==3,\n                        \'lost\': offer.projectId.projectStatus==4, \'postponed\': offer.projectId.projectStatus==5,\n                        \'precast\': offer.projectId.projectStatus==6}">{{offer.projectId.projectStatus | projStatus}}</div><div class="flex header"><div ng-if=offer.clientId.clientLogo><img ng-src={{offer.clientId.clientLogo}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!offer.clientId.clientLogo><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(offer.offerName)) }">{{offer.offerName | mailAvatarChar}}</span></div><div class=name-wrapper><div class="name tx-ellipsis ft_16_600_black" ng-bind=offer.offerName></div><div class=date>{{ offer.code }}</div></div></div><div class=detail><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/call.svg alt=icons> <span class=ft_14_regular_gray ng-bind="\'+\'+offer.clientId.clientContact.dialCode+\' \'+offer.clientId.clientContact.phoneNumber"></span></div><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/email.svg alt=icons> <span class="ft_14_regular_gray tx-ellipsis" ng-bind=offer.clientId.email></span></div></div></div><div class="flex-between action"><div class=flex-row><img src=/assets/images/suppliers/tag.svg alt=icons> <span class="ft_12_600_black ml-7" ng-bind=offer.clientId.systemTag></span></div><div class=flex-row><img src=/assets/images/suppliers/calendar.svg alt=icons> <span class="ft_12_regular_gray cal-span">{{ offer.createdAt | date: \'MMM d, yyyy\' : \'UTC\' }}</span></div></div></div></div></div><div class=pull-right ng-if=!isLoading><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.offers.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=initData()></pagination-custom-new></div></div></div></div></div><spinner ng-if=isDownloading></spinner></div></div></div></div></main>');
$templateCache.put('app/main/orders/bills/bills.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=invoices class="main-container d-flex"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class="orders-main flex"><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><span>All Bills</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 green-bk" ui-sref=createBillsOrder><img src=/assets/icons/plus.svg alt=icons><span translate=New></span></button><div class="search ml-10"><input type="" class=w-100 ng-model=vm.searchText> <span class=dateArrow><img src=/assets/icons/search_dark.svg alt=""></span></div><button class="btn_primary ml-10 green" ng-click=searchData()><span translate=Search></span></button></div></div></div><div class=content-block><div class="flex flex-between w-100"><div class=flex><selectbox-input class="w-155 input-select no-margin-top" ng-model=filtertypelistvalue1 options=filtertypelist1 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Apply></span></button></div><div class="btn-group d-flex"><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue2 options=filtertypelist2 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue3 options=filtertypelist3 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue4 options=filtertypelist4 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Filter></span></button></div></div><div class=show-nodata ng-if="isLoading == false && totalCount==0"><no-data ng-if="isLoading == false && totalCount==0"></no-data></div><div class="table-container mt-16" ng-if="totalCount > 0"><div class="table-header flex-items-center ft_14_600_black"><div class=check-item><label class="check_yellow_20 checkall"><input type=checkbox ng-model=vm.selectedAll ng-change=selectAllOrders()> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12 translate=Date></div><div class=flex-10 translate="Bill #"></div><div class=flex-10 translate="Ref #"></div><div class=flex-20 translate="Vendor Name"></div><div class=flex-12 translate=Status></div><div class=flex-10 translate="Due Date"></div><div class=flex-10 translate=Amount></div><div class=flex-12 translate="Balance Due"></div></div><div class=expand-item></div></div><div class=table-body><div class=table-content><div ng-repeat="order in vm.purchaseOrders track by $index"><div class="item flex-items-center ft_14_regular_black"><div class=check-item><label class="check_yellow_20 check"><input type=checkbox ng-model=order.selected ng-change=selectOrder(order)> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12>{{order.date || order.createdAt | date: \'dd MMM, yyyy\' : \'UTC\'}}</div><div class=flex-10>{{order.systemTag}}</div><div class=flex-10>{{order.systemTag}}</div><div class=flex-20>{{order.reference.clientName || order.reference.name}}</div><div class=flex-12><div class="ft_14_600_black tag" ng-style="{ \'color\': getStatusTagColor(order.status).color }">{{getStatus(order.status)}}</div></div><div class=flex-10>{{order.deliveryDate | date: \'dd MMM, yyyy\' : \'UTC\'}}</div><div class=flex-10>{{vm.currentCurrency.symbol}} {{order.total | readable: 2}}</div><div class=flex-12>{{vm.currentCurrency.symbol}} {{order.total | readable: 2}}</div></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.materials.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=initData()></pagination-custom-new></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/cars/cars.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=invoices class="main-container d-flex"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class="orders-main flex"><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><span>All Stock Vehicles</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 green-bk" ui-sref=createBillsOrder><img src=/assets/icons/plus.svg alt=icons><span translate=New></span></button><div class="search ml-10"><input type="" class=w-100 ng-model=vm.searchText> <span class=dateArrow><img src=/assets/icons/search_dark.svg alt=""></span></div><button class="btn_primary ml-10 green" ng-click=searchData()><span translate=Search></span></button></div></div></div><div class=content-block><div class=show-nodata ng-if="isLoading == false && totalCount==0"><no-data ng-if="isLoading == false && totalCount==0"></no-data></div><div class="table-container mt-16" ng-if="totalCount > 0"><div class="flex flex-33 car-info-wrapper" ng-repeat="car in vm.cars"><div class=flex-100><div class="flex car-header"><div class=car-title>{{car.name}}</div><button class="btn_primary black-bk ml-auto" translate=Edit></button> <button class="btn ml-14"><img src=/assets/icons/more-horiz-dark.svg></button></div><div class="flex car-body"><div class="car-info flex"><div class=car-info-title translate=type></div><div class=car-info-description>{{car.type}}</div></div><div class="car-info flex"><div class=car-info-title translate=Model></div><div class=car-info-description>{{car.model}}</div></div><div class="car-info flex"><div class=car-info-title translate="Registered to"></div><div class=car-info-description>{{car.registered}}</div></div><div class="car-info flex"><div class=car-info-title translate="Driver\'s Name"></div><div class=car-info-description>{{car.driver}}</div></div><div class="car-info flex"><div class=car-info-title translate="License No."></div><div class=car-info-description>{{car.licenseno}}</div></div><div class="car-info flex"><div class=car-info-title translate=Phone></div><div class=car-info-description>{{car.phone}}</div></div><div class="car-info flex"><div class=car-info-title translate=Email></div><div class=car-info-description>{{car.email}}</div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.materials.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=initData()></pagination-custom-new></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/createBillsOrder/createBillsOrder.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=createPurchaseOrder class="d-flex main-container"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class=orders-main><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><img src=/assets/icons/sales_local_mall.svg alt=icons class=mr-8> <span translate="Add Bill"></span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 green"><span translate="Save as Draft"></span></button> <button class="btn_primary ml-10 green-bk"><span translate="Save and Send"></span></button> <button class="btn_primary ml-10 white" ui-sref=salesBills><span translate=Cancel></span></button></div></div></div><div class="content-block flex"><div class="flex align-items-center flex-100"><div class="input-label w-160 required" translate="Vender Name"></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160 required" translate="Bill #"></div><div class="input-right ml-16"><input type="" class=w-100 ng-model=""></div><div class="input-label w-160 ml-40" translate="Reference #"></div><div class="input-right ml-16"><input type="" class=w-100 ng-model=""></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate="Bill Date"></div><div class="input-right ml-16 pr"><input type=text class=w-100 date-picker="dd MMM yyyy" date=vm.order.date is-open=isDateOpen ng-required=true> <span class=dateArrow ng-click="isDateOpen = !isDateOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div><div class="input-label w-160 ml-40" translate="Due Date"></div><div class="input-right ml-16 pr"><input type=text class=w-100 date-picker="dd MMM yyyy" date="" is-open=isDateOpen ng-required=true> <span class=dateArrow ng-click="isDateOpen = !isDateOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate="Warehouse Name"></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate="Payment Terms"></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex flex-100 mt-40 flex-dir-col"><div class="dt-table align-items-center"><div class="dt-row dt-header flex flex-100"><div class="flex-35 dt-col" translate="Item Details"></div><div class="flex-15 dt-col" translate=Type></div><div class="flex-10 dt-col tr" translate=Quantity></div><div class="flex-10 dt-col tr" translate="Unit Price"></div><div class="flex-8 dt-col" translate="VAT %"></div><div class="flex-11 dt-col tr" translate="VAT Amount"></div><div class="flex-11 dt-col tr" translate=Amount></div></div><div ng-repeat="detail in vm.order.details track by $index"><div class="dt-row dt-body flex flex-100"><div class="flex-35 dt-col"><selectbox-input ng-model=detail.materialId options=vm.materials label-field=name value-field=_id select-event=vm.changeMaterial(detail)></selectbox-input><!-- <div class="sku">\n                      <div ng-show="detail.material" class="ft_12_regular_gray">ID: {{detail.material.systemTag}}</div>\n                    </div> --> <textarea class="ft_12_regular_black description" placeholder="Add description here to your item here" ng-model=detail.description>\n                    </textarea></div><div class="flex-15 dt-col type"><selectbox-input select-event=""></selectbox-input></div><div class="flex-10 dt-col ft_12_600_black tr"><input class=text-right type=text number-edit=2 ng-model=detail.quantity ng-blur=vm.changeQuantity(detail)></div><div class="flex-10 dt-col ft_12_600_black tr"><div class=text-right>{{detail.price | readable: 2}}</div></div><div class="flex-8 dt-col ft_12_600_black"><selectbox-input ng-model=detail.vatpercent options=vm.vatpercents label-field=name value-field=_id select-event=""></selectbox-input></div><div class="flex-11 dt-col ft_12_600_black tr"><div class=text-right>{{detail.vat | readable: 2}}</div></div><div class="flex-11 dt-col ft_12_600_black tr"><div class=text-right>{{detail.total | readable: 2}}</div></div></div><div class="detail-icon cursor-point"><img src="/assets/icons/sales_Group 8408.svg" alt=icon></div><div class="remove-icon cursor-point"><img src=/assets/icons/sales_minus_circle_outline.svg alt=icon> <img src=/assets/icons/sales_Trash-alt.svg alt=icon ng-click=vm.removeDetail($index)></div></div></div><div class="dt-total d-flex justify-content-between"><div class="flex flex-50 mt-16"><div><div class="flex-between add-btn cursor-point" ng-click=vm.addDetail()><img src=/assets/icons/sales_add_blue.svg alt=icon><div class=ft_12_600_gray translate="Add another line"></div></div></div><div class=seperator></div><div><div class="flex-between add-btn cursor-point"><img src=/assets/icons/sales_add_blue.svg alt=icon><div class=ft_12_600_gray translate="Add items in bulk"></div></div></div></div><div class="flex flex-50 total-statistics"><div class="flex-between item"><div class="ft_12_600_black total-label" translate="Sub Total"></div><div class="ft_12_600_black value">{{vm.order.price | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate="VAT amont"></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate="Discount %"></div><div class="ft_12_600_gray1 symbol"><selectbox-input class="w-80 input-select no-margin-top" select-event=""></selectbox-input></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate=Adjustment></div><div class="ft_12_600_gray1 symbol"><input type=text number-edit=2 ng-model=""></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item sum"><div class="ft_12_600_black total-label" translate="Total ($)"></div><div class="ft_12_600_black value">{{\'1100\' | readable: 2}}</div></div></div></div></div><div class="flex align-items-center flex-100 mt-24"><div class="input-label w-160"><img src=/assets/icons/sales_attachment.svg> <span translate="Attach File(s)"></span></div></div><div class="flex flex-100 mt-8"><div class="flex flex-30"><div class=upload ngf-select ng-model=vm.inputImg ngf-change="vm.fileUpdated($files, $event, \'image\')" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=true ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><p>Drag and drop here<br>or <span translate=Browse></span></p></div></div><div class="flex flex-70 file-mana"><div class=file-item><img src=/assets/icons/pdf.png><div class="file-title ml-10" translate=document1.pdf></div></div></div></div><div class="flex align-items-center flex-100 mt-24"><div class="flex-50 input-label" translate="Deliver Method"></div><div class="flex-50 input-label" translate=Salesperson></div></div><div class="flex align-items-center flex-100 mt-8"><div class="flex-50 pr-40"><textarea class="notes ft_14_regular_black" placeholder="Will be displayed on the purchase order" ng-model="">\n              </textarea></div><div class=flex-50><textarea class="notes ft_14_regular_black" placeholder="Enter the terms and conditions of your business to be displayed in your transaction" ng-model="">\n              </textarea></div></div><div class="flex mt-24"><button class="btn_primary green"><span translate="Save as Draft"></span></button> <button class="btn_primary ml-10 green-bk"><span translate="Save and Send"></span></button> <button class="btn_primary ml-10 white" ui-sref=salesBills><span translate=Cancel></span></button></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/createInvoiceOrder/createInvoiceOrder.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=createPurchaseOrder class="d-flex main-container"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class=orders-main><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><img src=/assets/icons/sales_local_mall.svg alt=icons class=mr-8> <span>Create Invoice</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 green"><span translate="Save as Draft"></span></button> <button class="btn_primary ml-10 green-bk"><span translate="Save and Send"></span></button> <button class="btn_primary ml-10 white" ui-sref=salesInvoices><span translate=Cancel></span></button></div></div></div><div class="content-block flex"><div class="flex align-items-center flex-100"><div class="input-label w-160 required" translate="Vender Name"></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160 required" translate="Invoice #"></div><div class="input-right ml-16"><input type="" class=w-100 ng-model=""></div><div class="input-label w-160 ml-40" translate="Order #"></div><div class="input-right ml-16"><input type="" class=w-100 ng-model=""></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate="Invoice Date"></div><div class="input-right ml-16 pr"><input type=text class=w-100 date-picker="dd MMM yyyy" date=vm.order.date is-open=isDateOpen ng-required=true> <span class=dateArrow ng-click="isDateOpen = !isDateOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div><div class="input-label w-160 ml-40" translate="Due Date"></div><div class="input-right ml-16 pr"><input type=text class=w-100 date-picker="dd MMM yyyy" date="" is-open=isDateOpen ng-required=true> <span class=dateArrow ng-click="isDateOpen = !isDateOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate=Terms></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div><div class="input-label w-160 ml-40" translate=Salesperson></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex flex-100 mt-40 flex-dir-col"><div class="dt-table align-items-center"><div class="dt-row dt-header flex flex-100"><div class="flex-35 dt-col" translate="Item Details"></div><div class="flex-15 dt-col" translate=Type></div><div class="flex-10 dt-col tr" translate=Quantity></div><div class="flex-10 dt-col tr" translate="Unit Price"></div><div class="flex-8 dt-col" translate="VAT %"></div><div class="flex-11 dt-col tr" translate="VAT Amount"></div><div class="flex-11 dt-col tr" translate=Amount></div></div><div ng-repeat="detail in vm.order.details track by $index"><div class="dt-row dt-body flex flex-100"><div class="flex-35 dt-col"><selectbox-input ng-model=detail.materialId options=vm.materials label-field=name value-field=_id select-event=vm.changeMaterial(detail)></selectbox-input><!-- <div class="sku">\n                      <div ng-show="detail.material" class="ft_12_regular_gray">ID: {{detail.material.systemTag}}</div>\n                    </div> --> <textarea class="ft_12_regular_black description" placeholder="Add description here to your item here" ng-model=detail.description>\n                    </textarea></div><div class="flex-15 dt-col type"><selectbox-input select-event=""></selectbox-input></div><div class="flex-10 dt-col ft_12_600_black tr"><input class=text-right type=text number-edit=2 ng-model=detail.quantity ng-blur=vm.changeQuantity(detail)></div><div class="flex-10 dt-col ft_12_600_black tr"><div class=text-right>{{detail.price | readable: 2}}</div></div><div class="flex-8 dt-col ft_12_600_black"><selectbox-input ng-model=detail.vatpercent options=vm.vatpercents label-field=name value-field=_id select-event=""></selectbox-input></div><div class="flex-11 dt-col ft_12_600_black tr"><div class=text-right>{{detail.vat | readable: 2}}</div></div><div class="flex-11 dt-col ft_12_600_black tr"><div class=text-right>{{detail.total | readable: 2}}</div></div></div><div class="detail-icon cursor-point"><img src="/assets/icons/sales_Group 8408.svg" alt=icon></div><div class="remove-icon cursor-point"><img src=/assets/icons/sales_minus_circle_outline.svg alt=icon> <img src=/assets/icons/sales_Trash-alt.svg alt=icon ng-click=vm.removeDetail($index)></div></div></div><div class="dt-total d-flex justify-content-between"><div class="flex flex-50 mt-16"><div><div class="flex-between add-btn cursor-point" ng-click=vm.addDetail()><img src=/assets/icons/sales_add_blue.svg alt=icon><div class=ft_12_600_gray translate="Add another line"></div></div></div><div class=seperator></div><div><div class="flex-between add-btn cursor-point"><img src=/assets/icons/sales_add_blue.svg alt=icon><div class=ft_12_600_gray translate="Add items in bulk"></div></div></div></div><div class="flex flex-50 total-statistics"><div class="flex-between item"><div class="ft_12_600_black total-label" translate="Sub Total"></div><div class="ft_12_600_black value">{{vm.order.price | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate="VAT amont"></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate="Discount %"></div><div class="ft_12_600_gray1 symbol"><selectbox-input class="w-80 input-select no-margin-top" select-event=""></selectbox-input></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate=Adjustment></div><div class="ft_12_600_gray1 symbol"><input type=text number-edit=2 ng-model=""></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item sum"><div class="ft_12_600_black total-label" translate="Total ($)"></div><div class="ft_12_600_black value">{{\'1100\' | readable: 2}}</div></div></div></div></div><div class="flex align-items-center flex-100 mt-24"><div class="input-label w-160"><img src=/assets/icons/sales_attachment.svg> <span translate="Attach File(s)"></span></div></div><div class="flex flex-100 mt-8"><div class="flex flex-30"><div class=upload ngf-select ng-model=vm.inputImg ngf-change="vm.fileUpdated($files, $event, \'image\')" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=true ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><p>Drag and drop here<br>or <span translate=Browse></span></p></div></div><div class="flex flex-70 file-mana"><div class=file-item><img src=/assets/icons/pdf.png><div class="file-title ml-10" translate=document1.pdf></div></div></div></div><div class="flex align-items-center flex-100 mt-24"><div class="flex-50 input-label" translate="Deliver Method"></div><div class="flex-50 input-label" translate=Salesperson></div></div><div class="flex align-items-center flex-100 mt-8"><div class="flex-50 pr-40"><textarea class="notes ft_14_regular_black" placeholder="Will be displayed on the purchase order" ng-model="">\n              </textarea></div><div class=flex-50><textarea class="notes ft_14_regular_black" placeholder="Enter the terms and conditions of your business to be displayed in your transaction" ng-model="">\n              </textarea></div></div><div class="flex mt-24"><button class="btn_primary green"><span translate="Save as Draft"></span></button> <button class="btn_primary ml-10 green-bk"><span translate="Save and Send"></span></button> <button class="btn_primary ml-10 white" ui-sref=salesInvoices><span translate=Cancel></span></button></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/createPurchaseOrder/createPurchaseOrder.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=createPurchaseOrder class="d-flex main-container"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class=orders-main><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><img src=/assets/icons/sales_local_mall.svg alt=icons class=mr-8> <span>New Purchase Order</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 green"><span translate="Save as Draft"></span></button> <button class="btn_primary ml-10 green-bk"><span translate="Save and Send"></span></button> <button class="btn_primary ml-10 white" ui-sref=purchaseOrders><span translate=Cancel></span></button></div></div></div><div class="content-block flex"><div class="flex align-items-center flex-100"><div class="input-label w-160 required" translate="Vender Name"></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex flex-100 mt-40"><div class="input-label w-160 required" translate="Deliver to"></div><div class="flex-50 ml-16"><div class="flex-items-center mb-16"><div class="flex-items-center apply-option mr-4"><radio ng-model=vm.order.deliverToType ng-value=0></radio><div class="ft_12_600_gray type-label" translate=Warehouses></div></div><div class="flex-items-center apply-option mr-4"><radio ng-model=vm.order.deliverToType ng-value=1></radio><div class="ft_12_600_gray type-label" translate=Customer></div></div><div class="flex-items-center apply-option"><radio ng-model=vm.order.deliverToType ng-value=2></radio><div class="ft_12_600_gray type-label" translate="Constructions site"></div></div></div><!-- <div class="flex flex-100 mb-24">\n                <selectbox-input class="w-100 input-select no-margin-top" ng-model="vm.order.reference"\n                  options="vm.referenceOptions[vm.order.deliverToType]"\n                  label-field="label" value-field="value"\n                  select-event="vm.changeReference()"></selectbox-input>\n              </div> --></div></div><div class="flex align-items-center flex-100"><div class="input-label w-160"></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top" ng-model=vm.order.reference options=vm.referenceOptions[vm.order.deliverToType] label-field=label value-field=value select-event=vm.changeReference()></selectbox-input></div><div class="input-label w-160 ml-40" translate="Map Location" ng-if="vm.order.deliverToType == 2"></div><div class="input-right ml-16" ng-if="vm.order.deliverToType == 2"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160 required" translate="Purchase Order#"></div><div class="input-right ml-16"><input type="" class=w-100 ng-model=""></div><div class="input-label w-160 ml-40" translate="Reference #"></div><div class="input-right ml-16"><input type="" class=w-100 ng-model=""></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate=Date></div><div class="input-right ml-16 pr"><input type=text class=w-100 date-picker="dd MMM yyyy" date=vm.order.date is-open=isDateOpen ng-required=true> <span class=dateArrow ng-click="isDateOpen = !isDateOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate="Expected Delivery Date"></div><div class="input-right ml-16 pr"><input type=text class=w-100 date-picker="dd MMM yyyy" date=vm.order.deliveryDate is-open=isDateOpen ng-required=true> <span class=dateArrow ng-click="isDateOpen = !isDateOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div><div class="input-label w-160 ml-40" translate="Confiremed Date & Time"></div><div class="input-right ml-16 pr"><input type=text class=w-100 date-picker="dd MMM yyyy" date="" is-open=isDateOpen ng-required=true> <span class=dateArrow ng-click="isDateOpen = !isDateOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate="Deliver Method"></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div><div class="input-label w-160 ml-40" translate=Salesperson></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate="Payment Terms"></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex flex-100 mt-40 flex-dir-col"><div class="dt-table align-items-center"><div class="dt-row dt-header flex flex-100"><div class="flex-35 dt-col" translate="Item Details"></div><div class="flex-15 dt-col" translate=Type></div><div class="flex-10 dt-col tr" translate=Quantity></div><div class="flex-10 dt-col tr" translate="Unit Price"></div><div class="flex-8 dt-col" translate="VAT %"></div><div class="flex-11 dt-col tr" translate="VAT Amount"></div><div class="flex-11 dt-col tr" translate=Amount></div></div><div ng-repeat="detail in vm.order.details track by $index"><div class="dt-row dt-body flex flex-100"><div class="flex-35 dt-col"><selectbox-input ng-model=detail.materialId options=vm.materials label-field=name value-field=_id select-event=vm.changeMaterial(detail)></selectbox-input><!-- <div class="sku">\n                      <div ng-show="detail.material" class="ft_12_regular_gray">ID: {{detail.material.systemTag}}</div>\n                    </div> --> <textarea class="ft_12_regular_black description" placeholder="Add description here to your item here" ng-model=detail.description>\n                    </textarea></div><div class="flex-15 dt-col type"><selectbox-input select-event=""></selectbox-input></div><div class="flex-10 dt-col ft_12_600_black tr"><input class=text-right type=text number-edit=2 ng-model=detail.quantity ng-blur=vm.changeQuantity(detail)></div><div class="flex-10 dt-col ft_12_600_black tr"><div class=text-right>{{detail.price | readable: 2}}</div></div><div class="flex-8 dt-col ft_12_600_black"><selectbox-input ng-model=detail.vatpercent options=vm.vatpercents label-field=name value-field=_id select-event=""></selectbox-input></div><div class="flex-11 dt-col ft_12_600_black tr"><div class=text-right>{{detail.vat | readable: 2}}</div></div><div class="flex-11 dt-col ft_12_600_black tr"><div class=text-right>{{detail.total | readable: 2}}</div></div></div><div class="detail-icon cursor-point"><img src="/assets/icons/sales_Group 8408.svg" alt=icon></div><div class="remove-icon cursor-point"><img src=/assets/icons/sales_minus_circle_outline.svg alt=icon> <img src=/assets/icons/sales_Trash-alt.svg alt=icon ng-click=vm.removeDetail($index)></div></div></div><div class="dt-total d-flex justify-content-between"><div class="flex flex-50 mt-16"><div><div class="flex-between add-btn cursor-point" ng-click=vm.addDetail()><img src=/assets/icons/sales_add_blue.svg alt=icon><div class=ft_12_600_gray translate="Add another line"></div></div></div><div class=seperator></div><div><div class="flex-between add-btn cursor-point"><img src=/assets/icons/sales_add_blue.svg alt=icon><div class=ft_12_600_gray translate="Add items in bulk"></div></div></div></div><div class="flex flex-50 total-statistics"><div class="flex-between item"><div class="ft_12_600_black total-label" translate="Sub Total"></div><div class="ft_12_600_black value">{{vm.order.price | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate="VAT amont"></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate="Discount %"></div><div class="ft_12_600_gray1 symbol"><selectbox-input class="w-80 input-select no-margin-top" select-event=""></selectbox-input></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate=Adjustment></div><div class="ft_12_600_gray1 symbol"><input type=text number-edit=2 ng-model=""></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item sum"><div class="ft_12_600_black total-label" translate="Total ($)"></div><div class="ft_12_600_black value">{{\'1100\' | readable: 2}}</div></div></div></div></div><div class="flex align-items-center flex-100 mt-24"><div class="input-label w-160"><img src=/assets/icons/sales_attachment.svg> <span translate="Attach File(s)"></span></div></div><div class="flex flex-100 mt-8"><div class="flex flex-30"><div class=upload ngf-select ng-model=vm.inputImg ngf-change="vm.fileUpdated($files, $event, \'image\')" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=true ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><p>Drag and drop here<br>or <span translate=Browse></span></p></div></div><div class="flex flex-70 file-mana"><div class=file-item><img src=/assets/icons/pdf.png><div class="file-title ml-10" translate=document1.pdf></div></div></div></div><div class="flex align-items-center flex-100 mt-24"><div class="flex-50 input-label" translate="Deliver Method"></div><div class="flex-50 input-label" translate=Salesperson></div></div><div class="flex align-items-center flex-100 mt-8"><div class="flex-50 pr-40"><textarea class="notes ft_14_regular_black" placeholder="Will be displayed on the purchase order" ng-model="">\n              </textarea></div><div class=flex-50><textarea class="notes ft_14_regular_black" placeholder="Enter the terms and conditions of your business to be displayed in your transaction" ng-model="">\n              </textarea></div></div><div class="flex mt-24"><button class="btn_primary green"><span translate="Save as Draft"></span></button> <button class="btn_primary ml-10 green-bk"><span translate="Save and Send"></span></button> <button class="btn_primary ml-10 white" ui-sref=purchaseOrders><span translate=Cancel></span></button></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/createRentalOrder/createRentalOrder.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=loading></spinner><div id=createRentalOrder class="d-flex main-container"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=loading></spinner><div class=orders-main><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><img src=/assets/icons/sales_local_mall.svg alt=icons class=mr-8> <span>Create Rental Order</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 green"><span translate="Save as Draft"></span></button> <button class="btn_primary ml-10 green-bk"><span translate="Save and Send"></span></button> <button class="btn_primary ml-10 white" ui-sref=rentalOrders><span translate=Cancel></span></button></div></div></div><div class="content-block flex"><div class="flex align-items-center flex-100"><div class="input-label w-160 required" translate="Customer Name"></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160 required" translate="Rental Order#"></div><div class="input-right ml-16"><input type="" class=w-100 ng-model=""></div><div class="input-label w-160 ml-40" translate="Reference #"></div><div class="input-right ml-16"><input type="" class=w-100 ng-model=""></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160 required" translate="From Date"></div><div class="input-right ml-16 pr"><input type=text class=w-100 date-picker="dd MMM yyyy" date=vm.order.date is-open=isDateOpen ng-required=true> <span class=dateArrow ng-click="isDateOpen = !isDateOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div><div class="input-label w-160 ml-40 required" translate="To Date"></div><div class="input-right ml-16 pr"><input type=text class=w-100 date-picker="dd MMM yyyy" date="" is-open=isDateOpen ng-required=true> <span class=dateArrow ng-click="isDateOpen = !isDateOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate=Terms></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div><div class="input-label w-160 ml-40" translate=Salesperson></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex flex-100 mt-40 flex-dir-col"><div class="dt-table align-items-center"><div class="dt-row dt-header flex flex-100"><div class="flex-35 dt-col" translate="Item Details"></div><div class="flex-15 dt-col" translate=Type></div><div class="flex-10 dt-col tr" translate=Quantity></div><div class="flex-10 dt-col tr" translate="Unit Price"></div><div class="flex-8 dt-col" translate="VAT %"></div><div class="flex-11 dt-col tr" translate="VAT Amount"></div><div class="flex-11 dt-col tr" translate=Amount></div></div><div ng-repeat="detail in vm.order.details track by $index"><div class="dt-row dt-body flex flex-100"><div class="flex-35 dt-col"><selectbox-input ng-model=detail.materialId options=vm.materials label-field=name value-field=_id select-event=vm.changeMaterial(detail)></selectbox-input><!-- <div class="sku">\n                      <div ng-show="detail.material" class="ft_12_regular_gray">ID: {{detail.material.systemTag}}</div>\n                    </div> --> <textarea class="ft_12_regular_black description" placeholder="Add description here to your item here" ng-model=detail.description>\n                    </textarea></div><div class="flex-15 dt-col type"><selectbox-input select-event=""></selectbox-input></div><div class="flex-10 dt-col ft_12_600_black tr"><input class=text-right type=text number-edit=2 ng-model=detail.quantity ng-blur=vm.changeQuantity(detail)></div><div class="flex-10 dt-col ft_12_600_black tr"><div class=text-right>{{detail.price | readable: 2}}</div></div><div class="flex-8 dt-col ft_12_600_black"><selectbox-input ng-model=detail.vatpercent options=vm.vatpercents label-field=name value-field=_id select-event=""></selectbox-input></div><div class="flex-11 dt-col ft_12_600_black tr"><div class=text-right>{{detail.vat | readable: 2}}</div></div><div class="flex-11 dt-col ft_12_600_black tr"><div class=text-right>{{detail.total | readable: 2}}</div></div></div><div class="detail-icon cursor-point"><img src="/assets/icons/sales_Group 8408.svg" alt=icon></div><div class="remove-icon cursor-point"><img src=/assets/icons/sales_minus_circle_outline.svg alt=icon> <img src=/assets/icons/sales_Trash-alt.svg alt=icon ng-click=vm.removeDetail($index)></div></div></div><div class="dt-total d-flex justify-content-between"><div class="flex flex-50 mt-16"><div><div class="flex-between add-btn cursor-point" ng-click=vm.addDetail()><img src=/assets/icons/sales_add_blue.svg alt=icon><div class=ft_12_600_gray translate="Add another line"></div></div></div><div class=seperator></div><div><div class="flex-between add-btn cursor-point"><img src=/assets/icons/sales_add_blue.svg alt=icon><div class=ft_12_600_gray translate="Add items in bulk"></div></div></div></div><div class="flex flex-50 total-statistics"><div class="flex-between item"><div class="ft_12_600_black total-label" translate="Sub Total"></div><div class="ft_12_600_black value">{{vm.order.price | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate="VAT amont"></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate="Shipping Charges"></div><div class="ft_12_600_gray1 symbol"><input type=text number-edit=2 ng-model=""></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate="Discount %"></div><div class="ft_12_600_gray1 symbol"><selectbox-input class="w-80 input-select no-margin-top" select-event=""></selectbox-input></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate=Adjustment></div><div class="ft_12_600_gray1 symbol"><input type=text number-edit=2 ng-model=""></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item sum"><div class="ft_12_600_black total-label" translate="Total ($)"></div><div class="ft_12_600_black value">{{\'1100\' | readable: 2}}</div></div></div></div></div><div class="flex align-items-center flex-100 mt-24"><div class="flex-50 input-label" translate="Deliver Method"></div><div class="flex-50 input-label" translate=Salesperson></div></div><div class="flex align-items-center flex-100 mt-8"><div class="flex-50 pr-40"><textarea class="notes ft_14_regular_black" placeholder="Will be displayed on the purchase order" ng-model="">\n              </textarea></div><div class=flex-50><textarea class="notes ft_14_regular_black" placeholder="Enter the terms and conditions of your business to be displayed in your transaction" ng-model="">\n              </textarea></div></div><div class="flex align-items-center flex-100 mt-24"><div class="input-label w-160"><img src=/assets/icons/sales_attachment.svg> <span translate="Attach File(s)"></span></div></div><div class="flex flex-100 mt-8"><div class="flex flex-30"><div class=upload ngf-select ng-model=vm.inputImg ngf-change="vm.fileUpdated($files, $event, \'image\')" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=true ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><p>Drag and drop here<br>or <span translate=Browse></span></p></div></div><div class="flex flex-70 file-mana"><div class=file-item><img src=/assets/icons/pdf.png><div class="file-title ml-10" translate=document1.pdf></div></div></div></div><div class="flex mt-24"><button class="btn_primary green"><span translate="Save as Draft"></span></button> <button class="btn_primary ml-10 green-bk"><span translate="Save and Send"></span></button> <button class="btn_primary ml-10 white" ui-sref=rentalOrders><span translate=Cancel></span></button></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/createSalesOrder/createSalesOrder.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=createSalesOrder class="d-flex main-container"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=loading></spinner><div class=orders-main><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><img src=/assets/icons/sales_local_mall.svg alt=icons class=mr-8> <span>New Sales Order</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 green"><span translate="Save as Draft"></span></button> <button class="btn_primary ml-10 green-bk"><span translate="Save and Send"></span></button> <button class="btn_primary ml-10 white" ui-sref=salesOrders><span translate=Cancel></span></button></div></div></div><div class="content-block flex"><div class="flex align-items-center flex-100"><div class="input-label w-160 required" translate="Customer Name"></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex flex-100 mt-16"><div class="input-label w-160 required" translate="Deliver to"></div><div class="input-right ml-16 deliverto"><div class="billing-address mb-8" translate="Billing Address"></div><div translate="2118 Thornridge Cir"></div><div translate="Syracuse, Connecticut 35624, USA"></div><div class=add-new translate="Add new address"></div></div><div class="input-right ml-40 deliverto"><div class="billing-address mb-8" translate="Shipping Address"></div><div class=add-new translate="Add new address"></div></div></div><!-- <div class="flex flex-100 mt-40">\n            <div class="input-label w-160 required" translate="Deliver to"></div>\n            <div class="flex-50 ml-16">\n              <div class="flex-items-center mb-16">\n                <div class="flex-items-center apply-option mr-4">\n                  <radio ng-model="vm.order.deliverToType" ng-value="0"></radio>\n                  <div class="ft_12_600_gray type-label" translate="Warehouses"></div>\n                </div>\n            </div>\n          </div> --><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160 required" translate="Sales Order#"></div><div class="input-right ml-16"><input type="" class=w-100 ng-model=""></div><div class="input-label w-160 ml-40" translate="Reference #"></div><div class="input-right ml-16"><input type="" class=w-100 ng-model=""></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate="Sales Order Date"></div><div class="input-right ml-16 pr"><input type=text class=w-100 date-picker="dd MMM yyyy" date=vm.order.date is-open=isDateOpen ng-required=true> <span class=dateArrow ng-click="isDateOpen = !isDateOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div><div class="input-label w-160 ml-40" translate="Shipment Date"></div><div class="input-right ml-16 pr"><input type=text class=w-100 date-picker="dd MMM yyyy" date="" is-open=isDateOpen ng-required=true> <span class=dateArrow ng-click="isDateOpen = !isDateOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class="flex align-items-center flex-100 mt-16"><div class="input-label w-160" translate="Deliver Method"></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div><div class="input-label w-160 ml-40" translate=Salesperson></div><div class="input-right ml-16"><selectbox-input class="w-100 input-select no-margin-top"></selectbox-input></div></div><div class="flex flex-100 mt-40 flex-dir-col"><div class="dt-table align-items-center"><div class="dt-row dt-header flex flex-100"><div class="flex-35 dt-col" translate="Item Details"></div><div class="flex-15 dt-col" translate=Type></div><div class="flex-10 dt-col tr" translate=Quantity></div><div class="flex-10 dt-col tr" translate="Unit Price"></div><div class="flex-8 dt-col" translate="VAT %"></div><div class="flex-11 dt-col tr" translate="VAT Amount"></div><div class="flex-11 dt-col tr" translate=Amount></div></div><div ng-repeat="detail in vm.order.details track by $index"><div class="dt-row dt-body flex flex-100"><div class="flex-35 dt-col"><selectbox-input ng-model=detail.materialId options=vm.materials label-field=name value-field=_id select-event=vm.changeMaterial(detail)></selectbox-input><!-- <div class="sku">\n                      <div ng-show="detail.material" class="ft_12_regular_gray">ID: {{detail.material.systemTag}}</div>\n                    </div> --> <textarea class="ft_12_regular_black description" placeholder="Add description here to your item here" ng-model=detail.description>\n                    </textarea></div><div class="flex-15 dt-col type"><selectbox-input select-event=""></selectbox-input></div><div class="flex-10 dt-col ft_12_600_black tr"><input class=text-right type=text number-edit=2 ng-model=detail.quantity ng-blur=vm.changeQuantity(detail)></div><div class="flex-10 dt-col ft_12_600_black tr"><div class=text-right>{{detail.price | readable: 2}}</div></div><div class="flex-8 dt-col ft_12_600_black"><selectbox-input ng-model=detail.vatpercent options=vm.vatpercents label-field=name value-field=_id select-event=""></selectbox-input></div><div class="flex-11 dt-col ft_12_600_black tr"><div class=text-right>{{detail.vat | readable: 2}}</div></div><div class="flex-11 dt-col ft_12_600_black tr"><div class=text-right>{{detail.total | readable: 2}}</div></div></div><div class="detail-icon cursor-point"><img src="/assets/icons/sales_Group 8408.svg" alt=icon></div><div class="remove-icon cursor-point"><img src=/assets/icons/sales_minus_circle_outline.svg alt=icon> <img src=/assets/icons/sales_Trash-alt.svg alt=icon ng-click=vm.removeDetail($index)></div></div></div><div class="dt-total d-flex justify-content-between"><div class="flex flex-50 mt-16"><div><div class="flex-between add-btn cursor-point" ng-click=vm.addDetail()><img src=/assets/icons/sales_add_blue.svg alt=icon><div class=ft_12_600_gray translate="Add another line"></div></div></div><div class=seperator></div><div><div class="flex-between add-btn cursor-point"><img src=/assets/icons/sales_add_blue.svg alt=icon><div class=ft_12_600_gray translate="Add items in bulk"></div></div></div></div><div class="flex flex-50 total-statistics"><div class="flex-between item"><div class="ft_12_600_black total-label" translate="Sub Total"></div><div class="ft_12_600_black value">{{vm.order.price | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate="VAT amont"></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate="Discount %"></div><div class="ft_12_600_gray1 symbol"><selectbox-input class="w-80 input-select no-margin-top" select-event=""></selectbox-input></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item"><div class="ft_12_600_black total-label" translate=Adjustment></div><div class="ft_12_600_gray1 symbol"><input type=text number-edit=2 ng-model=""></div><div class="ft_12_600_black value">{{vm.order.vat | readable: 2}}</div></div><div class="flex-between item sum"><div class="ft_12_600_black total-label" translate="Total ($)"></div><div class="ft_12_600_black value">{{\'1100\' | readable: 2}}</div></div></div></div></div><div class="flex align-items-center flex-100 mt-24"><div class="flex-50 input-label" translate="Deliver Method"></div><div class="flex-50 input-label" translate=Salesperson></div></div><div class="flex align-items-center flex-100 mt-8"><div class="flex-50 pr-40"><textarea class="notes ft_14_regular_black" placeholder="Will be displayed on the purchase order" ng-model="">\n              </textarea></div><div class=flex-50><textarea class="notes ft_14_regular_black" placeholder="Enter the terms and conditions of your business to be displayed in your transaction" ng-model="">\n              </textarea></div></div><div class="flex align-items-center flex-100 mt-24"><div class="input-label w-160"><img src=/assets/icons/sales_attachment.svg> <span translate="Attach File(s)"></span></div></div><div class="flex flex-100 mt-8"><div class="flex flex-30"><div class=upload ngf-select ng-model=vm.inputImg ngf-change="vm.fileUpdated($files, $event, \'image\')" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=true ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><p>Drag and drop here<br>or <span translate=Browse></span></p></div></div><div class="flex flex-70 file-mana"><div class=file-item><img src=/assets/icons/pdf.png><div class="file-title ml-10" translate=document1.pdf></div></div></div></div><div class="flex mt-24"><button class="btn_primary green"><span translate="Save as Draft"></span></button> <button class="btn_primary ml-10 green-bk"><span translate="Save and Send"></span></button> <button class="btn_primary ml-10 white" ui-sref=salesOrders><span translate=Cancel></span></button></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/invoices/invoices.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=invoices class="main-container d-flex"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class="orders-main flex"><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><span>All Invoices</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 green-bk" ui-sref=createInvoiceOrder><img src=/assets/icons/plus.svg alt=icons><span translate="Add New"></span></button><div class="search ml-10"><input type="" class=w-100 ng-model=vm.searchText> <span class=dateArrow><img src=/assets/icons/search_dark.svg alt=""></span></div><button class="btn_primary ml-10 green" ng-click=searchData()><span translate=Search></span></button></div></div></div><div class=content-block><div class="flex flex-between w-100"><div class=flex><selectbox-input class="w-155 input-select no-margin-top" ng-model=filtertypelistvalue1 options=filtertypelist1 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Apply></span></button></div><div class="btn-group d-flex"><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue2 options=filtertypelist2 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue3 options=filtertypelist3 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue4 options=filtertypelist4 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Filter></span></button></div></div><div class=show-nodata ng-if="isLoading == false && totalCount==0"><no-data ng-if="isLoading == false && totalCount==0"></no-data></div><div class="table-container mt-16" ng-if="totalCount > 0"><div class="table-header flex-items-center ft_14_600_black"><div class=check-item><label class="check_yellow_20 checkall"><input type=checkbox ng-model=vm.selectedAll ng-change=selectAllOrders()> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12 translate=Date></div><div class=flex-10 translate="Invoice #"></div><div class=flex-10 translate="Order #"></div><div class=flex-20 translate="Vendor Name"></div><div class=flex-12 translate=Status></div><div class=flex-10 translate="Due Date"></div><div class=flex-10 translate=Amount></div><div class=flex-12 translate="Balance Due"></div></div><div class=expand-item></div></div><div class=table-body><div class=table-content><div ng-repeat="order in vm.purchaseOrders track by $index"><div class="item flex-items-center ft_14_regular_black"><div class=check-item><label class="check_yellow_20 check"><input type=checkbox ng-model=order.selected ng-change=selectOrder(order)> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12>{{order.date || order.createdAt | date: \'dd MMM, yyyy\' : \'UTC\'}}</div><div class=flex-10>{{order.systemTag}}</div><div class=flex-10>{{order.systemTag}}</div><div class=flex-20>{{order.reference.clientName || order.reference.name}}</div><div class=flex-12><div class="ft_14_600_black tag" ng-style="{ \'color\': getStatusTagColor(order.status).color }">{{getStatus(order.status)}}</div></div><div class=flex-10>{{order.deliveryDate | date: \'dd MMM, yyyy\' : \'UTC\'}}</div><div class=flex-10>{{vm.currentCurrency.symbol}} {{order.total | readable: 2}}</div><div class=flex-12>{{vm.currentCurrency.symbol}} {{order.total | readable: 2}}</div></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.materials.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=initData()></pagination-custom-new></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/orderAction/orderAction.view.html','<main-title-bar></main-title-bar><div id=order-action class=main-container><div class=content><login-left-block></login-left-block><div class=right-side><img src=/assets/images/login/logo.svg alt=login><div class="login_title mt-24" translate=Order></div><div class=account-noti><span class=account translate="I want to"></span>&nbsp; <span class="mark cursor-point" ui-sref=login translate="Sign in"></span></div><div class=login-contents><spinner ng-if=isLoading></spinner><div class=action-content-wrapper ng-if=!isLoading><div class=image-wrapper><div class=approved ng-if="vm.order.status===\'approved\'"><div class=d-flex><img src=/assets/icons/checked-lg2.svg alt=""></div><div class=mt-50>Order ({{vm.order.systemTag}}) was approved.</div></div><div class=declined ng-if="vm.order.status===\'declined\'"><div class=d-flex><img src=/assets/icons/close-lg2.svg alt=""></div><div class=mt-50>Order ({{vm.order.systemTag}}) was declined.</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/orders/products/products.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=sales-products class="main-container d-flex"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class="orders-main flex"><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><span>Products</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 white"><img src=/assets/icons/plus-black.svg alt=icons><span translate="Add New"></span></button> <button class="btn_primary ml-10 white"><img src=/assets/icons/sales_bx-upload.svg alt=icons><span translate=Import></span></button> <button class="btn_primary ml-10 white" ng-click=""><img src=/assets/icons/sales_bx-download.svg alt=icons><span translate=Export></span></button><div class="search ml-10"><input type="" class=w-100> <span class=dateArrow><img src=/assets/icons/search_dark.svg alt=""></span></div><button class="btn_primary ml-10 green" ng-click=""><span translate=Search></span></button></div></div></div><div class=content-block><div class=show-nodata ng-if="isLoading == false && totalCount==0"><no-data ng-if="isLoading == false && totalCount==0"></no-data></div><div class="flex flex-between w-100"><div class=flex><selectbox-input class="w-155 input-select no-margin-top" ng-model=filtertypelistvalue1 options=filtertypelist1 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Apply></span></button></div><div class="btn-group d-flex"><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue2 options=filtertypelist2 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue3 options=filtertypelist3 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue4 options=filtertypelist4 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Filter></span></button></div></div><div class="table-container mt-16" ng-if="totalCount > 0"><div class="table-header flex-items-center ft_14_600_black"><div class=check-item><label class="check_yellow_20 checkall"><input type=checkbox ng-model=vm.selectedAll ng-change=selectAllOrders()> <span class=checkmark></span></label></div><div class=main-items><div class=flex-5 translate=""><img src=/assets/icons/sales_thead_picture.svg></div><div class=flex-20 translate=Name></div><div class=flex-7 translate=ID></div><div class=flex-10 translate=Category></div><div class=flex-15 translate=Supplier></div><div class="flex-12 ac" translate="Stock In-Hand"></div><div class="flex-12 ar" translate="Cost Price"></div><div class="flex-12 ar" translate="Selling Price"></div></div><div class=expand-item></div></div><div class=table-body><div class=table-content><div ng-repeat="order in vm.products track by $index"><div class="item flex-items-center ft_14_regular_black"><div class=check-item><label class="check_yellow_20 check"><input type=checkbox ng-model=order.selected ng-change=selectOrder(order)> <span class=checkmark></span></label></div><div class=main-items><div class=flex-5><img src={{order.image}}></div><div class=flex-20>{{order.name}}</div><div class=flex-7>{{order.id}}</div><div class=flex-10>{{order.category}}</div><div class=flex-15>{{order.supplier}}</div><div class="flex-12 ac">{{order.stock}}</div><div class="flex-12 ar">$ {{order.costprice | readable: 2}}</div><div class="flex-12 ar">$ {{order.sellingprice | readable: 2}}</div></div><div class="expand-item cursor-point"><img src=assets/icons/sales_more_horiz.svg alt="" ng-click=""> <img src=assets/icons/sales_chevron-left.svg alt="" ng-if=!order.isExpanded ng-click="order.isExpanded = !order.isExpanded"> <img src=assets/icons/sales_chevron-down.svg alt="" ng-if=order.isExpanded ng-click="order.isExpanded = !order.isExpanded"></div></div><div ng-if=order.isExpanded class=expanded-table><div class=flex><div class="flex-10 mr-24"><img src=/assets/images/sales/Rectangle5.png></div><div class=flex-85><div class=flex><div class=flex-30><div class="flex detail-title">Name</div><div class="flex detail-content">Taparia CLH 450 Claw Hammer</div></div><div class="flex flex-70"><div class=flex-15><div class="flex detail-title">ID</div><div class="flex detail-content">1264</div></div><div class=flex-15><div class="flex detail-title">Brand</div><div class="flex detail-content">Taparia</div></div><div class=flex-15><div class="flex detail-title">Supplier</div><div class="flex detail-content">Biffco Enterprise</div></div><div class=flex-15><div class="flex detail-title">Item Group</div><div class="flex detail-content">Hammers</div></div></div></div><div class="flex mt-24"><div class="flex flex-30"><div class=flex-50><div class="flex detail-title">Purchase Cost</div><div class="flex detail-content">$ 450.00</div></div><div class=flex-50><div class="flex detail-title">Selling Price</div><div class="flex detail-content">$ 500.00</div></div></div><div class="flex flex-70"><div class=flex-15><div class="flex detail-title">Stock In-Hand</div><div class="flex detail-content">56</div></div><div class=flex-15><div class="flex detail-title">Re-order Level</div><div class="flex detail-content">10</div></div><div class=flex-15><div class="flex detail-title">Stock Location</div><div class="flex detail-content">Warehouse 1</div></div><div class=flex-15><div class="flex detail-title"></div><div class="flex detail-content"></div></div></div></div><div class="flex-100 mt-24"><div class="flex detail-title">Tags</div><div class=flex><div class=work-types><div class=work-type><div>Varnishing</div></div><div class=work-type><div>Stainless Steel</div></div><div class=work-type><div>Safety & Health</div></div></div></div></div><div class="flex mt-24"><button class="btn_primary green-bk" ng-click=""><span translate="Place Order"></span></button> <button class="btn_primary ml-10 white" ng-click=""><span translate=Edit></span></button></div></div></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.products.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=initData()></pagination-custom-new></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/projectOrderAction/projectOrderAction.view.html','<main-title-bar></main-title-bar><div id=project-order-action class="order-action main-container"><div class=content><login-left-block></login-left-block><div class=right-side><img src=/assets/images/login/logo.svg alt=login><div class="login_title mt-24" translate="Project Order"></div><div class=account-noti><span class=account translate="I want to"></span>&nbsp; <span class="mark cursor-point" ui-sref=login translate="Sign in"></span></div><div class=login-contents><spinner ng-if=isLoading></spinner><div class=action-content-wrapper ng-if=!isLoading><div class=image-wrapper><div class=approved ng-if="vm.order.status===\'Confirmed\'"><div class=d-flex><img src=/assets/icons/checked-lg2.svg alt=""></div><div class=mt-50>Project Order ({{vm.order.systemTag}}) was approved.</div></div><div class=declined ng-if="vm.order.status===\'Cancelled\'"><div class=d-flex><img src=/assets/icons/close-lg2.svg alt=""></div><div class=mt-50>Project Order ({{vm.order.systemTag}}) was declined.</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/orders/projectOrders/projectOrders.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=project-orders class="main-container d-flex"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class="orders-main flex"><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><span>All Project Purchases</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 white"><img src=/assets/icons/plus-black.svg alt=icons><span translate="Add New"></span></button> <button class="btn_primary ml-10 white"><img src=/assets/icons/sales_bx-upload.svg alt=icons><span translate=Import></span></button> <button class="btn_primary ml-10 white" ng-click=""><img src=/assets/icons/sales_bx-download.svg alt=icons><span translate=Expert></span></button><div class="search ml-10"><input type="" class=w-100> <span class=dateArrow><img src=/assets/icons/search_dark.svg alt=""></span></div><button class="btn_primary ml-10 green" ng-click=""><span translate=Search></span></button></div></div></div><div class=content-block><div class=show-nodata ng-if="isLoading == false && totalCount==0"><no-data ng-if="isLoading == false && totalCount==0"></no-data></div><div class="flex flex-between w-100"><div class=flex><selectbox-input class="w-155 input-select no-margin-top" ng-model=filtertypelistvalue1 options=filtertypelist1 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Apply></span></button></div><div class="btn-group d-flex"><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue2 options=filtertypelist2 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue3 options=filtertypelist3 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue4 options=filtertypelist4 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Filter></span></button></div></div><div class="table-container mt-16" ng-if="totalCount > 0"><div class="table-header flex-items-center ft_14_600_black"><div class=check-item><label class="ml-24 check_yellow_20 checkall"><input type=checkbox ng-model=vm.selectedAll ng-change=selectAllOrders()> <span class=checkmark></span></label></div><div class=main-items><div class="flex-20 right-border-cell" translate=Material></div><div class="flex-10 pl-20" translate="Order Type"></div><div class=flex-12 translate=Status></div><div class=flex-15 translate="Required Qty."></div><div class=flex-15 translate=Quantity></div><div class=flex-15 translate="Order in %"></div></div><div class=expand-item></div></div><div class=table-body><div class=table-content><div ng-repeat="matGroup in vm.matGroups track by $index"><div class="item flex-items-center ft_14_regular_black"><div class=check-item><img src=assets/icons/sales_chevron-left.svg alt="" ng-if=!matGroup.isExpanded ng-click="matGroup.isExpanded = !matGroup.isExpanded"> <img src=assets/icons/sales_chevron-down.svg alt="" ng-if=matGroup.isExpanded ng-click="matGroup.isExpanded = !matGroup.isExpanded"> <label class="check_yellow_20 check"><input type=checkbox ng-model=order.selected ng-change=selectOrder(matGroup)> <span class=checkmark></span></label></div><div class=main-items><div class="flex-20 right-border-cell">{{matGroup.name}}</div><div class="flex-10 pl-20"><button class="btn_primary {{!matGroup.orderType || matGroup.orderType == \'\' || matGroup.orderType == \'normal\' ? \'normal-order\' : \'split-order\'}}" ui-sref=""><span translate="{{matGroup.orderType == \'\' || !matGroup.orderType ? \'Normal\' : matGroup.orderType}}"></span></button></div><div class=flex-12><div class=percent><div class=percent-bg style=width:75px;></div><div class=percent-value translate=75></div></div></div><div class=flex-15>100</div><div class="flex-15 quentity-wrapper"><input><div class=quantity translate=m2></div></div><div class=flex-15><div class="w-80 order-in"><input type=text number-edit=2 class=percent-value ng-model=matGroup.percentage><div class="icon-wrapper flex-center cursor-point"><img src=assets/icons/sales-check-mark.svg alt=""></div></div></div></div><div class="expand-item cursor-point"><button class="btn_primary ml-10 black-bk" ui-sref=""><span translate="Order all"></span></button> <button class="btn_primary ml-10 black-bk" ui-sref=""><span translate="Order from drawing"></span></button></div></div><div ng-if=matGroup.isExpanded><div class="item flex-items-center ft_14_regular_black"><div class=check-item><label class="ml-24 check_yellow_20 checkall"><input type=checkbox> <span class=checkmark></span></label></div><div class=main-items><div class="flex-20 right-border-cell" translate=Fasteners></div><div class="flex-10 pl-20" translate=""></div><div class=flex-12 translate=""></div><div class=flex-15 translate=""></div><div class=flex-6 translate=Level></div><div class=flex-9 translate=Location></div><div class="flex-15 quentity-wrapper" translate=""><input><div class=quantity translate=m2></div></div><div class=flex-7 translate="">Full-load</div><div class=flex-7 translate="">Amount</div></div></div><div ng-repeat="material in matGroup.list track by $index"></div><div class="item flex-items-center ft_14_regular_black"><div class=check-item><label class="ml-16 check_yellow_20 checkall"><input type=checkbox> <span class=checkmark></span></label></div><div class=main-items><div class="flex-20 right-border-cell">{{material.name}}</div><div class="flex-10 pl-20"><button class="btn_primary {{!material.orderType || material.orderType == \'\' || material.orderType == \'normal\' ? \'normal-order\' : \'split-order\'}}" ui-sref=""><span translate="{{material.orderType == \'\' || !material.orderType ? \'Normal\' : material.orderType}}"></span></button></div><div class=flex-12><div class=percent><div class=percent-bg style=width:45px;></div><div class=percent-value translate=45></div></div></div><div class=flex-15>100</div><div class=flex-6>Level 9</div><div class=flex-9>401-Bedroom</div><div class="flex-15 quentity-wrapper"><input><div class=quantity translate=m2></div></div><div class=flex-7 translate="{{material.quantity}} * {{material.costPrice}} {{material.unit}}"></div><div class=flex-7>400</div></div></div></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.products.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=initData()></pagination-custom-new></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/purchaseOrders/purchaseOrders.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=purchase-orders class="main-container d-flex"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class="orders-main flex"><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><span>All Purchase Orders</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 green-bk" ui-sref=createPurchaseOrder><img src=/assets/icons/plus.svg alt=icons><span translate="Add New"></span></button><div class="search ml-10"><input type="" class=w-100 ng-model=vm.searchText> <span class=dateArrow><img src=/assets/icons/search_dark.svg alt=""></span></div><button class="btn_primary ml-10 green" ng-click=searchData()><span translate=Search></span></button></div></div></div><div class=content-block><div class="flex flex-between w-100"><div class=flex><selectbox-input class="w-155 input-select no-margin-top" ng-model=filtertypelistvalue1 options=filtertypelist1 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Apply></span></button></div><div class="btn-group d-flex"><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue3 options=filtertypelist3 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue4 options=filtertypelist4 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Filter></span></button></div></div><div class=show-nodata ng-if="isLoading == false && totalCount==0"><no-data ng-if="isLoading == false && totalCount==0"></no-data></div><div class="table-container mt-16" ng-if="totalCount > 0"><div class="table-header flex-items-center ft_14_600_black"><div class=check-item><label class="check_yellow_20 checkall"><input type=checkbox ng-model=vm.selectedAll ng-change=selectAllOrders()> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12 translate=Date></div><div class=flex-10 translate="PO #"></div><div class=flex-20 translate="Vendor Name"></div><div class=flex-12 translate=Status></div><div class=flex-15 translate="Bill Status"></div><div class=flex-15 translate="Expected deliveryDate"></div><div class=flex-12 translate=Amount></div></div><div class=expand-item></div></div><div class=table-body><div class=table-content><div ng-repeat="order in vm.purchaseOrders track by $index"><div class="item flex-items-center ft_14_regular_black"><div class=check-item><label class="check_yellow_20 check"><input type=checkbox ng-model=order.selected ng-change=selectOrder(order)> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12>{{order.date || order.createdAt | date: \'dd MMM, yyyy\' : \'UTC\'}}</div><div class=flex-10>{{order.systemTag}}</div><div class=flex-20>{{order.reference.clientName || order.reference.name}}</div><div class=flex-12><div class="ft_14_600_black tag" ng-style="{ \'color\': getStatusTagColor(order.status).color }">{{getStatus(order.status)}}</div></div><div class=flex-15>-</div><div class=flex-15>{{order.deliveryDate | date: \'dd MMM, yyyy\' : \'UTC\'}}</div><div class=flex-12>{{vm.currentCurrency.symbol}} {{order.total | readable: 2}}</div></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.materials.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=initData()></pagination-custom-new></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/rentalOrderAction/rentalOrderAction.view.html','<main-title-bar></main-title-bar><div id=rental-order-action class="order-action main-container"><div class=content><login-left-block></login-left-block><div class=right-side><img src=/assets/images/login/logo.svg alt=login><div class="login_title mt-24" translate="Rental Order"></div><div class=account-noti><span class=account translate="I want to"></span>&nbsp; <span class="mark cursor-point" ui-sref=login translate="Sign in"></span></div><div class=login-contents><spinner ng-if=isLoading></spinner><div class=action-content-wrapper ng-if=!isLoading><div class=image-wrapper><div class=approved ng-if="vm.order.status===\'picked_up\'"><div class=d-flex><img src=/assets/icons/checked-lg2.svg alt=""></div><div class=mt-50>Rental Order ({{vm.order.systemTag}}) was approved.</div></div><div class=declined ng-if="vm.order.status===\'cancelled\'"><div class=d-flex><img src=/assets/icons/close-lg2.svg alt=""></div><div class=mt-50>Rental Order ({{vm.order.systemTag}}) was declined.</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/orders/rentalOrders/rentalOrders.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=rental-orders class="main-container d-flex"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class="orders-main flex"><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><span>All Rental Orders</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 green-bk" ui-sref=createRentalOrder><img src=/assets/icons/plus.svg alt=icons><span translate="Add New"></span></button><div class="search ml-10"><input type="" class=w-100 ng-model=vm.searchText> <span class=dateArrow><img src=/assets/icons/search_dark.svg alt=""></span></div><button class="btn_primary ml-10 green" ng-click=searchData()><span translate=Search></span></button></div></div></div><div class=content-block><div class="flex flex-between w-100"><div class=flex><selectbox-input class="w-155 input-select no-margin-top" ng-model=filtertypelistvalue1 options=filtertypelist1 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Apply></span></button></div><div class="btn-group d-flex"><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue3 options=filtertypelist3 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue4 options=filtertypelist4 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Filter></span></button></div></div><div class=show-nodata ng-if="isLoading == false && totalCount==0"><no-data ng-if="isLoading == false && totalCount==0"></no-data></div><div class="table-container mt-16" ng-if="totalCount > 0"><div class="table-header flex-items-center ft_14_600_black"><div class=check-item><label class="check_yellow_20 checkall"><input type=checkbox ng-model=vm.selectedAll ng-change=selectAllOrders()> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12 translate="Due Date"></div><div class=flex-10 translate="Order #"></div><div class=flex-20 translate="Customer Name"></div><div class=flex-12 translate=Status></div><div class=flex-15 translate=Pickup></div><div class=flex-15 translate=return></div><div class=flex-12 translate=Amount></div></div><div class=expand-item></div></div><div class=table-body><div class=table-content><div ng-repeat="order in vm.purchaseOrders track by $index"><div class="item flex-items-center ft_14_regular_black"><div class=check-item><label class="check_yellow_20 check"><input type=checkbox ng-model=order.selected ng-change=selectOrder(order)> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12>{{order.updatedAt | date: \'dd MMM, yyyy\' : \'UTC\'}}</div><div class=flex-10>{{order.systemTag}}</div><div class=flex-20>{{order.reference.clientName || order.reference.name}}</div><div class=flex-12><div class="ft_14_600_black tag" ng-style="{ \'color\': getStatusTagColor(order.status).color }">{{getStatus(order.status)}}</div></div><div class=flex-15>{{order.date | date: \'dd MMM, yyyy\' : \'UTC\'}}</div><div class=flex-15>{{order.deliveryDate | date: \'dd MMM, yyyy\' : \'UTC\'}}</div><div class=flex-12>{{vm.currentCurrency.symbol}} {{order.total | readable: 2}}</div></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.materials.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=initData()></pagination-custom-new></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/returnOrderAction/returnOrderAction.view.html','<main-title-bar></main-title-bar><div id=return-order-action class="order-action main-container"><div class=content><login-left-block></login-left-block><div class=right-side><img src=/assets/images/login/logo.svg alt=login><div class="login_title mt-24" translate="Return Order"></div><div class=account-noti><span class=account translate="I want to"></span>&nbsp; <span class="mark cursor-point" ui-sref=login translate="Sign in"></span></div><div class=login-contents><spinner ng-if=isLoading></spinner><div class=action-content-wrapper ng-if=!isLoading><div class=image-wrapper><div class=approved ng-if="vm.order.status===\'approved\'"><div class=d-flex><img src=/assets/icons/checked-lg2.svg alt=""></div><div class=mt-50>Return Order ({{vm.order.systemTag}}) was approved.</div></div><div class=declined ng-if="vm.order.status===\'declined\'"><div class=d-flex><img src=/assets/icons/close-lg2.svg alt=""></div><div class=mt-50>Return Order ({{vm.order.systemTag}}) was declined.</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/orders/returnOrders/returnOrders.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=return-orders class="main-container d-flex"><filters-panel payment-tag-colors=paymentTagColors status-tag-colors=statusTagColors updated-order-status=updatedOrderStatusFilter(value) updated-date-filter=updatedDateFilter(value)></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class=orders-main><div class="fm_operator_bar d-flex btn-group"><button class=btn_nav_inactive ui-sref=salesOrders translate="Sales Orders"></button> <button class=btn_nav_inactive ui-sref=purchaseOrders translate="Purchase Orders"></button> <button class=btn_nav_inactive ui-sref=rentalOrders translate="Rental Orders"></button> <button class=btn_nav_inactive ui-sref=projectOrders translate="Project Orders"></button> <button class=btn_nav_active translate="Return Orders"></button> <button class=btn_nav_inactive ui-sref=warehouseOrders translate=Warehouse></button></div><div class=divider></div><div class="fm_operator_button flex-between"><div class=search><searchbox search-text=vm.searchText search-event=searchOrderList() place-holder="Search for the order"></searchbox></div></div><div class=content-block><div class=show-nodata ng-if="isLoading == false && totalCount==0"><no-data ng-if="isLoading == false && totalCount==0"></no-data></div><div class=table-container ng-if="totalCount > 0"><div class="table-header flex-items-center ft_14_600_black"><div class=check-item><label class="check_yellow_20 checkall"><input type=checkbox ng-model=vm.selectedAll ng-change=selectAllOrders()> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12 translate=Date></div><div class=flex-15 translate="Order ID#"></div><div class=flex-27 translate=Warehouse></div><div class=flex-14 translate=Status></div><div class=flex-12 translate="Confirmed Date"></div><div class="flex-20 pr-16 text-right" translate=Amount></div></div><div class=expand-item></div></div><div class=table-body><div class=table-content><div ng-repeat="order in vm.returnOrders track by $index"><div class="item flex-items-center ft_14_regular_black"><div class=check-item><label class="check_yellow_20 check"><input type=checkbox ng-model=order.selected ng-change=selectOrder(order)> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12>{{order.date || order.createdAt | date: \'dd-MM-yyyy\' : \'UTC\'}}</div><div class=flex-15>{{order.systemTag}}</div><div class=flex-27>{{order.reference.name}}</div><div class=flex-14><div class="ft_14_600_black tag" ng-style="{ \'color\': getStatusTagColor(order.status).color, \'background-color\': getStatusTagColor(order.status).bgColor}">{{getStatus(order.status)}}</div></div><div class=flex-12>{{order.confirmedAt | date: \'dd-MM-yyyy\' : \'UTC\'}}</div><div class="flex-20 pr-16 text-right">{{vm.currentCurrency.symbol}} {{order.total | readable: 2}}</div></div><div class="expand-item cursor-point" ng-click="order.isExpanded = !order.isExpanded"><img src=assets/icons/play_circle_outline.svg alt="" ng-if=!order.isExpanded> <img src=assets/icons/play_circle_outline_opposit.svg alt="" ng-if=order.isExpanded></div></div><div ng-if=order.isExpanded class=expanded-table><div class="flex-items-center expanded-table-header ft_14_600_black"><div class=flex-5>#</div><div class=flex-30 translate="Product Name"></div><div class="flex-15 text-right" translate=Price></div><div class="flex-10 text-right" translate=Qty></div><div class="flex-10 text-right" translate="VAT %"></div><div class="flex-15 text-right" translate="VAT Amount"></div><div class="flex-15 text-right" translate=Amount></div></div><div class="expanded-table-content ft_14_regular_black"><div class="flex-items-center item" ng-repeat="detail in order.details track by $index"><div class=flex-5>{{$index + 1}}</div><div class="flex-30 flex-items-center"><div ng-if=detail.material.files.images[0].secure_url class="logo-text mr-8" ng-style="{ \'background-image\': \'url(\' + detail.material.files.images[0].secure_url + \')\', \'background-size\': \'cover\' }"></div><div ng-if=!detail.material.files.images[0].secure_url class="logo-text mr-8" ng-style="{ \'background-image\': \'url(/assets/images/materials/noImg.jpg)\', \'background-size\': \'cover\' }"></div>{{detail.material.name}}</div><div class="flex-15 text-right">{{vm.currentCurrency.symbol}} {{detail.price | readable: 2}}</div><div class="flex-10 text-right">{{detail.quantity | readable: 2}}</div><div class="flex-10 text-right">{{detail.vatPercent | readable: 2}} %</div><div class="flex-15 text-right">{{vm.currentCurrency.symbol}} {{detail.vat | readable: 2}}</div><div class="flex-15 text-right">{{vm.currentCurrency.symbol}} {{detail.total | readable: 2}}</div></div><div class="flex-items-center mt-8"><div class=flex-77></div><div class="flex-23 flex-items-center"><div class=flex-40><div class="ft_14_regular_black mb-12" translate=Sum></div><!--                    <div class="ft_14_regular_black mb-12">VAT 25%</div>--><!--                    <div class="ft_14_regular_black mb-12">VAT 10%</div>--><div class="ft_14_regular_black mb-12" translate=VAT></div><div class="ft_14_600_black mb-0" translate="Sum Total"></div></div><div class="flex-60 text-right"><div class="ft_14_regular_black mb-12">{{vm.currentCurrency.symbol}} {{order.price | readable: 2}}</div><!--                    <div class="ft_14_regular_black mb-12">{{vm.currentCurrency.symbol}} {{order.vat | readable: 2}}</div>--><div class="ft_14_regular_black mb-12">{{vm.currentCurrency.symbol}} {{order.vat | readable: 2}}</div><div class="ft_14_600_black mb-0">{{vm.currentCurrency.symbol}} {{order.total | readable: 2}}</div></div></div></div><div class=buttons-wrapper ng-if="order.status === \'draft\' || order.status === \'pending\' || order.status === \'Pending\'"><button class="btnGray mr-16" translate=Send ng-click=sendOrder(order)></button> <button class="btnRed mr-16" translate=Cancel ng-click=cancelOrder(order)></button></div><div class=buttons-wrapper ng-if="order.status === \'cancelled\' || order.status === \'Canceled\'"><button class="btnRed mr-16" translate=Delete ng-click="deleteOrder(order, $index)"></button></div></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.returnOrders.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchOrderList()></pagination-custom-new></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/salesOrderAction/salesOrderAction.view.html','<main-title-bar></main-title-bar><div id=return-order-action class="order-action main-container"><div class=content><login-left-block></login-left-block><div class=right-side><img src=/assets/images/login/logo.svg alt=login><div class="login_title mt-24" translate="Sales Order"></div><div class=account-noti><span class=account translate="I want to"></span>&nbsp; <span class="mark cursor-point" ui-sref=login translate="Sign in"></span></div><div class=login-contents><spinner ng-if=isLoading></spinner><div class=action-content-wrapper ng-if=!isLoading><div class=image-wrapper><div class=approved ng-if="vm.order.status===\'invoiced\'"><div class=d-flex><img src=/assets/icons/checked-lg2.svg alt=""></div><div class=mt-50>Sales Order ({{vm.order.systemTag}}) was approved.</div></div><div class=declined ng-if="vm.order.status===\'cancelled\'"><div class=d-flex><img src=/assets/icons/close-lg2.svg alt=""></div><div class=mt-50>Sales Order ({{vm.order.systemTag}}) was declined.</div></div></div><div class=login-button><a class=ft_14_600_blue ui-sref=login translate=Login></a></div></div></div></div></div></div>');
$templateCache.put('app/main/orders/salesOrders/salesOrders.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=sales-orders class="main-container d-flex"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><div class="orders-main flex"><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><span>All Purchase Orders</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 green-bk" ui-sref=createSalesOrder><img src=/assets/icons/plus.svg alt=icons><span translate="Add New"></span></button><div class="search ml-10"><input type="" class=w-100 ng-model=vm.searchText> <span class=dateArrow><img src=/assets/icons/search_dark.svg alt=""></span></div><button class="btn_primary ml-10 green" ng-click=searchData()><span translate=Search></span></button></div></div></div><div class=content-block><div class="flex flex-between w-100"><div class=flex><selectbox-input class="w-155 input-select no-margin-top" ng-model=filtertypelistvalue1 options=filtertypelist1 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Apply></span></button></div><div class="btn-group d-flex"><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue3 options=filtertypelist3 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue4 options=filtertypelist4 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Filter></span></button></div></div><div class=show-nodata ng-if="isLoading == false && totalCount==0"><no-data ng-if="isLoading == false && totalCount==0"></no-data></div><div class="table-container mt-16" ng-if="totalCount > 0"><div class="table-header flex-items-center ft_14_600_black"><div class=check-item><label class="check_yellow_20 checkall"><input type=checkbox ng-model=vm.selectedAll ng-change=selectAllOrders()> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12 translate=Date></div><div class=flex-10 translate="Sales Offer #"></div><div class=flex-20 translate="Reference #"></div><div class=flex-15 translate="Customer Name"></div><div class="flex-12 ac" translate=Status></div><div class="flex-15 ar" translate="Due Date"></div><div class="flex-12 ar" translate=Amount></div></div><div class=expand-item></div></div><div class=table-body><div class=table-content><div ng-repeat="order in vm.salesOrders track by $index"><div class="item flex-items-center ft_14_regular_black"><div class=check-item><label class="check_yellow_20 check"><input type=checkbox ng-model=order.selected ng-change=selectOrder(order)> <span class=checkmark></span></label></div><div class=main-items><div class=flex-12>{{order.name}}</div><div class=flex-10>{{order.id}}</div><div class=flex-20>{{order.category}}</div><div class=flex-15>{{order.supplier}}</div><div class="flex-12 ac">{{order.stock}}</div><div class="flex-15 ar">$ {{order.costprice | readable: 2}}</div><div class="flex-12 ar">$ {{order.sellingprice | readable: 2}}</div></div><div class="expand-item cursor-point"><img src=assets/icons/sales_more_horiz.svg alt="" ng-click=""> <img src=assets/icons/sales_chevron-left.svg alt="" ng-if=!order.isExpanded ng-click="order.isExpanded = !order.isExpanded"> <img src=assets/icons/sales_chevron-down.svg alt="" ng-if=order.isExpanded ng-click="order.isExpanded = !order.isExpanded"></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.materials.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=initData()></pagination-custom-new></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/orders/warehouseOrders/warehouseOrders.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=warehouse-orders class="d-flex main-container"><filters-panel active-menu=activemenu></filters-panel><div class=orders-page><spinner ng-show=isLoading></spinner><div class="orders-main flex"><div class="ft_24_600_black header d-flex"><div class="orders-title-bar flex-between w-100"><div class=flex><div class="title flex"><span>Warehouse</span></div></div><div class="btn-group d-flex"><button class="btn_primary ml-10 white"><img src=/assets/icons/plus-black.svg alt=icons><span translate="Add New"></span></button> <button class="btn_primary ml-10 white"><img src=/assets/icons/sales_bx-upload.svg alt=icons><span translate=Import></span></button> <button class="btn_primary ml-10 white" ng-click=""><img src=/assets/icons/sales_bx-download.svg alt=icons><span translate=Export></span></button><div class="search ml-10"><input type="" class=w-100 ng-model=vm.searchText> <span class=dateArrow><img src=/assets/icons/search_dark.svg alt=""></span></div><button class="btn_primary ml-10 green" ng-click=searchData()><span translate=Search></span></button></div></div></div><div class=content-block><div class=show-nodata ng-if="isLoading == false && totalCount==0"><no-data ng-if="isLoading == false && totalCount==0"></no-data></div><div class="flex flex-between w-100"><div class=flex><selectbox-input class="w-155 input-select no-margin-top" ng-model=filtertypelistvalue1 options=filtertypelist1 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Apply></span></button></div><div class="btn-group d-flex"><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue2 options=filtertypelist2 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue3 options=filtertypelist3 label-field=tagName value-field=_id></selectbox-input><selectbox-input class="w-155 input-select ml-10 no-margin-top" ng-model=filtertypelistvalue4 options=filtertypelist4 label-field=tagName value-field=_id></selectbox-input><button class="btn_primary ml-10 green" ng-click=""><span translate=Filter></span></button></div></div><div class="table-container mt-16" ng-if="totalCount > 0"><div class="table-header flex-items-center ft_14_600_black"><div class=check-item><label class="check_yellow_20 checkall"><input type=checkbox ng-model=vm.selectedAll ng-change=selectAllOrders()> <span class=checkmark></span></label></div><div class=main-items><div class=flex-5 translate=""><img src=/assets/icons/sales_thead_picture.svg></div><div class=flex-20 translate=Name></div><div class=flex-7 translate=ID></div><div class=flex-10 translate=Category></div><div class=flex-15 translate=Warehouse></div><div class="flex-12 ac" translate="Stock In-Hand"></div><div class="flex-12 ar" translate="Cost Price"></div><div class="flex-12 ar" translate="Selling Price"></div></div><div class=expand-item></div></div><div class=table-body><div class=table-content><div ng-repeat="order in vm.materials track by $index"><div class="item flex-items-center ft_14_regular_black"><div class=check-item><label class="check_yellow_20 check"><input type=checkbox ng-model=order.selected ng-change=selectOrder(order)> <span class=checkmark></span></label></div><div class=main-items><div class=flex-5><img src="{{order.images[0] ? order.images[0].secure_url : \'/assets/images/sales/Rectangle2.png\'}}"></div><div class=flex-20>{{order.name}}</div><div class=flex-7>{{order.systemTag}}</div><div class=flex-10>{{order.supplier}}</div><div class=flex-15>{{order.qtyPallet}}</div><div class="flex-12 ac">{{order.qtyPallet}}</div><div class="flex-12 ar">$ {{order.costPrice | readable: 2}}</div><div class="flex-12 ar">$ {{order.salesPrice | readable: 2}}</div></div><div class="expand-item cursor-point"><img src=assets/icons/sales_more_horiz.svg alt="" ng-click=""> <img src=assets/icons/sales_chevron-left.svg alt="" ng-if=!order.isExpanded ng-click="order.isExpanded = !order.isExpanded"> <img src=assets/icons/sales_chevron-down.svg alt="" ng-if=order.isExpanded ng-click="order.isExpanded = !order.isExpanded"></div></div><div ng-if=false class=expanded-table><div class=flex><div class="flex-10 mr-24"><img src=/assets/images/sales/Rectangle5.png></div><div class=flex-85><div class=flex><div class=flex-30><div class="flex detail-title">Name</div><div class="flex detail-content">Taparia CLH 450 Claw Hammer</div></div><div class="flex flex-70"><div class=flex-15><div class="flex detail-title">ID</div><div class="flex detail-content">1264</div></div><div class=flex-15><div class="flex detail-title">Brand</div><div class="flex detail-content">Taparia</div></div><div class=flex-15><div class="flex detail-title">Supplier</div><div class="flex detail-content">Biffco Enterprise</div></div><div class=flex-15><div class="flex detail-title">Item Group</div><div class="flex detail-content">Hammers</div></div></div></div><div class="flex mt-24"><div class="flex flex-30"><div class=flex-50><div class="flex detail-title">Purchase Cost</div><div class="flex detail-content">$ 450.00</div></div><div class=flex-50><div class="flex detail-title">Selling Price</div><div class="flex detail-content">$ 500.00</div></div></div><div class="flex flex-70"><div class=flex-15><div class="flex detail-title">Stock In-Hand</div><div class="flex detail-content">56</div></div><div class=flex-15><div class="flex detail-title">Re-order Level</div><div class="flex detail-content">10</div></div><div class=flex-15><div class="flex detail-title">Stock Location</div><div class="flex detail-content">Warehouse 1</div></div><div class=flex-15><div class="flex detail-title"></div><div class="flex detail-content"></div></div></div></div><div class="flex-100 mt-24"><div class="flex detail-title">Tags</div><div class=flex><div class=work-types><div class=work-type><div>Varnishing</div></div><div class=work-type><div>Stainless Steel</div></div><div class=work-type><div>Safety & Health</div></div></div></div></div><div class="flex mt-24"><button class="btn_primary green-bk" ng-click=""><span translate="Place Order"></span></button> <button class="btn_primary ml-10 white" ng-click=""><span translate=Edit></span></button></div></div></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.materials.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=initData()></pagination-custom-new></div></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/projects/createProject/createProject.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=createProject class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=projectList class="ft-normal-12-16 grey-2" translate=Projects></a></div><div class=ft_24_600_black1 ng-if=!vm.edit_project_mode translate="Create Project"></div><div class=ft_24_600_black1 ng-if=vm.edit_project_mode translate="Update Project"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=vm.addProject(vm.projectData) ng-if=!vm.edit_project_mode><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-primary mr-16" ng-click=vm.addProject(vm.projectData) ng-if=vm.edit_project_mode><img src=/assets/icons/save-icon.svg alt=icons><span translate=Update></span></button> <button class=btn_cancel ui-sref=projectList><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div class=content-wrapper><spinner ng-if=isLoading></spinner><div class=contents><div class=content><div class="flex label-title mb-16" translate="PROJECT DETAILS"></div><div class=flex><div class="flex left-panel"><div class=panel-list><div class="ft_12_600_gray new_gray mb-8 required" translate="Project Name"></div><input type=text class="input-primary w-100" ng-model=vm.projectData.projectName><div class="ft_12_600_gray new_gray mb-8 mt-25 required" translate="Building Type"></div><selectbox-input class="w-100 dropdown-primary" ng-model=vm.projectData.buildingType options=vm.buildingTypeList label-field=tagName value-field=_id></selectbox-input><div class="ft_12_600_gray new_gray mb-8 mt-25 required" translate="Start date"></div><div class="input-group datePicker-primary mb-8"><input type=text class="input-primary w-100" date-picker=dd/MM/yyyy date=vm.projectData.startDate is-open=isDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isDatepickerOpen = !isDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div><div ng-if="vm.projectType == \'Service\'"><div class="ft_12_600_gray new_gray mb-8 mt-25" translate="Assigned To"></div><selectbox-input class=dropdown-primary ng-model=vm.assignedToId options=vm.companyUsers label-field=displayName value-field=_id select-event=vm.onSelassignedTo(vm.assignedToId)></selectbox-input></div><div ng-if="vm.projectType == \'Public Tender\' || vm.projectType == \'Private Tender\'"><div class="ft_12_600_gray new_gray mb-8 mt-25" translate="Tender Date"></div><div class="input-group datePicker-primary pos-relative"><input type=text class=input-primary date-picker=dd.MM.yyyy date=vm.projectData.tenderDate is-open=isTendertepickerOpen ng-required=true> <span class=dateArrow ng-click="isTendertepickerOpen = !isTendertepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class="ft_12_600_gray new_gray mb-8 mt-25" translate=Description></div><textarea class=text-area style="height: 143px;" placeholder="{{\'Enter your description here1\' | translate}}" ng-model=vm.projectData.projectDescription></textarea></div><div class=panel-list><div class="ft_12_600_gray new_gray mb-8 required" translate="Project Status"></div><selectbox-input class="project-status dropdown-primary" ng-model=vm.projectData.projectStatus options=vm.projectStatus label-field=name value-field=_id></selectbox-input><div class="ft_12_600_gray new_gray mb-8 mt-25 required" translate="Enterprise Type"></div><selectbox-input class=dropdown-primary ng-model=vm.projectData.enterpriseType options=vm.enterpriseTypeList label-field=tagName value-field=_id></selectbox-input><div class="ft_12_600_gray new_gray mb-8 mt-25 required" translate="End date"></div><div class="input-group datePicker-primary"><input type=text class="input-primary w-100" date-picker=dd/MM/yyyy date=vm.projectData.endDate is-open=isEndDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isEndDatepickerOpen = !isEndDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div><div class="mt-25 pos-relative"><div class="ft_12_600_gray new_gray mb-8 required" translate=Location></div><input places-auto-complete types="[\'geocode\']" class="input-primary w-100" on-place-changed=vm.placeMarker() ng-model=vm.address> <img src="/assets/icons/bx-location-plus 1.svg" alt="" style="position: absolute;top: 30px;right: 10px;"></div><div class="w-100 mt-20"><div class=google-map><div><div class="gmap_viewer w-100"><div map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params="{{ vm.gmap.url }}"><ng-map style=height:172px center="{{ vm.gmap.center }}" zoom="{{ vm.gmap.zoom }}" id=service_map><marker ng-repeat="m in vm.gmap.markers" position="{{ m }}" draggable=true on-dragend=vm.updateMarker() icon="{url: \'/assets/images/cgviewer/vp-issue-completed.svg\', scaledSize: [50, 50], origin: [0,0], anchor: [0,0]}"></marker></ng-map></div></div></div></div></div></div></div><div class="flex right-panel ml-24"><div class=flex><button data-wow-delay=1.3s class=btn-trans><img width=226 height=226 ngf-src="vm.projectImage?vm.projectImage:\'/assets/images/suppliers/uploadPic.svg\'" alt=upload ngf-select ng-model=vm.inputImg name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'projectImage\')" aria-invalid=false data-wow-delay=0.7s class="bdRadius-4 object-fit-cover"></button></div><div class="flex label-title mb-16 w-100" translate="PROJECT TYPE"></div><div class="flex w-100"><div class="radio-group d-flex"><label class="toggle d-flex mr-20" ng-model=vm.projectType uib-btn-radio="\'Service\'"><div class="circle mr-10"></div><div class=radio-label translate="Service Project"></div></label> <label class="toggle d-flex mr-20" ng-model=vm.projectType uib-btn-radio="\'Public Tender\'"><div class="circle mr-10"></div><div class=radio-label translate="Public Tender"></div></label> <label class="toggle d-flex mr-20" ng-model=vm.projectType uib-btn-radio="\'Private Tender\'"><div class="circle mr-10"></div><div class=radio-label translate="Private Tender"></div></label> <label class="toggle d-flex mr-20" ng-model=vm.projectType uib-btn-radio="\'None\'"><div class="circle mr-10"></div><div class=radio-label translate=None></div></label></div></div></div></div></div><div class="content mt-24"><div class="flex label-title mb-16" translate="CLIENT INFORMATION"></div><div class=flex><div class=panel-list2><div class="ft_12_600_gray new_gray mb-8 required" translate="Company Name1"></div><selectbox-input class=dropdown-primary ng-model=vm.clientIdTemp options=vm.clients label-field=clientName value-field=_id on-change=vm.changeClient(vm.clientIdTemp)></selectbox-input></div><!-- <div class="panel-list2 ml-24">\n              <div class="ft_12_600_gray new_gray mb-8" translate="Contact Person"></div>\n              <input type="text" class="input-primary w-100" readonly\n                ng-model="vm.projectData.client.clientContactPerson.firstName + \' \' +  vm.projectData.client.clientContactPerson.lastName"/>\n            </div> --><div class="panel-list2 ml-24"><div class="ft_12_600_gray new_gray mb-8" translate=Staff></div><selectbox-input class=dropdown-primary ng-model=vm.staffIdTemp options=staffs label-field=displayName value-field=_id on-change=vm.changeStaff(vm.staffIdTemp)></selectbox-input></div></div><div class="flex mt-25"><div class=panel-list2><div class="ft_12_600_gray new_gray mb-8" translate="Contact No."></div><div class=flex-between><input type=text class="input-primary w-107 mr-16 dialcode" ng-model=vm.projectData.client.clientContactPerson.mobile.dialCode readonly> <input type=text class="input-primary w-390" ng-model=vm.projectData.client.clientContactPerson.mobile.phoneNumber readonly></div></div><div class="panel-list2 ml-24"><div class="ft_12_600_gray new_gray mb-8" translate="Email Id"></div><input type=text class="input-primary w-100" ng-model=vm.projectData.client.email></div></div><div class="flex mt-25"><div class=w-100><div class="ft_12_600_gray new_gray mb-8" translate=Address></div><input type=text class="w-100 input-primary" ng-model=vm.projectData.client.address[0].loc.position readonly></div></div><div class="flex mt-25"><div class=panel-list2><div class="ft_12_600_gray new_gray mb-8" translate=Country></div><input type=text class="w-100 input-primary" ng-model=vm.projectData.client.address[0].countryCode readonly></div><div class="panel-list2 ml-24"><!-- <div>\n                <div class="ft_12_600_gray new_gray mb-8" translate="State"></div>\n                <input type="text" class="input-primary w-250" ng-model="vm.projectData.client.address[0].state" readonly>\n              </div> --><div class="ft_12_600_gray new_gray mb-8" translate=City></div><input type=text class="w-100 input-primary" ng-model=vm.projectData.client.address[0].city readonly></div><div class="panel-list2 ml-24"><div class="ft_12_600_gray new_gray mb-8" translate="Postal Code"></div><input type=text class="w-100 input-primary" ng-model=vm.projectData.client.address[0].postalCode readonly></div></div><!-- <div class="split-wrap" ng-if="!vm.edit_project_mode">\n            <div class="ft_14_600_black" translate="File Manager Template"></div>\n            <div class="split-line"></div>\n          </div>\n          <selectbox-input\n            ng-if="!vm.edit_project_mode"\n            options="vm.hierarchyTemplates"\n            label-field="description"\n            value-field="_id"\n            ng-model="vm.selectedHierarchyTemplate">\n          </selectbox-input> --><!-- <div class="btnGroup">\n            <button class="btn_white" ui-sref="projectList">\n              <img src="/assets/icons/close-circle-f-gray.svg" alt="icons" class="mr-10"/>\n              <span translate="Cancel"></span>\n            </button>\n            <button class="btn_primary" ng-click="vm.addProject(vm.projectData)" ng-if="!vm.edit_project_mode">\n              <img src="/assets/icons/bx-plus-circle.svg" alt="icons" class="mr-10"/>\n              <span translate="Create"></span>\n            </button>\n            <button class="btn_primary" ng-click="vm.addProject(vm.projectData)" ng-if="vm.edit_project_mode">\n              <img src="/assets/icons/bx-plus-circle.svg" alt="icons" class="mr-10"/>\n              <span translate="Update"></span>\n            </button>\n          </div> --></div><div class="content mt-24"><div class="flex label-title mb-16" translate=ATTACHMENTS></div><!-- <div class="split-wrap" ng-if="vm.projectType == \'Service\'">\n            <div class="ft_14_600_black" translate="Attachments"></div>\n            <div class="split-line"></div>\n          </div> --><div class="flex mt-24"><div class=panel-list2><div class=upload-wrap><div class=upload ngf-select ng-model=vm.inputImg ngf-change="vm.fileUpdated($files, $event, \'image\')" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=true ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><p><span translate="Drag and drop here"></span><br><span translate=or></span>&nbsp; <span class=browse translate=Browse></span></p></div></div></div><div class="panel-list2 ml-24"><div ng-if="vm.uploadImg.length > 0" data-ride=carousel data-interval=false><div class="carousel-inner1 row"><div class="carousel-item1 flex-column mb-56" ng-repeat="(key,f) in vm.uploadImg" ng-class={active:!$index}><img ngf-src="f.secure_url || f" alt="First slide" ng-click="vm.currentIndex=key" class=thumb><div class="f_name ml-16">{{ f.assetName || f.name }}</div><a ng-click="vm.deleteFile($index, \'image\');" class="text-danger image_close_btn ml-auto mt-50"><img src=/assets/icons/close-gray-circle.svg alt=icons></a></div></div></div></div><div class="w-520 upload-wrap" ng-if=0><div class="ft_12_600_gray new_gray" translate="Upload Documents"></div><div class=upload><div ng-if="vm.uploadFiles.length > 0" data-ride=carousel data-interval=false><div class="carousel-inner1 row"><div class="carousel-item1 flex-column" ng-repeat="(key,f) in vm.uploadFiles" ng-class={active:!$index}><a ng-click="vm.deleteFile($index, \'document\');" class="text-danger docs_close_btn"><img src=/assets/icons/close-gray-circle.svg alt=icons> </a><img src=/assets/images/materials/pdf.png alt=doc-icon ng-click="vm.currentIndexDocs=key" class=thumb><div class="text-center f_name mb-15">{{ f.assetName || f.name }}</div></div></div></div><button class=btn_browse ngf-select ng-model=vm.inputFiles ngf-change="vm.fileUpdated($files, $event, \'file\')" name=file ngf-pattern="\'*.*\'" ngf-multiple=true ngf-accept="\'*.*\'"><img src=/assets/icons/plusWhite.svg alt=icons></button></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/projects/projectDetail/projectDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=projectDetail class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Project></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=projectList class="ft-normal-12-16 grey-2" translate="Project Detail"></a></div><div class=ft_24_600_black1 ng-if=!vm.edit_project_mode translate="Project Detail"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=goToCreate()><img src=/assets/icons/edit-icon.svg alt=icons><span translate=Edit></span></button> <button class=btn_cancel ui-sref=projectList><img src=/assets/icons/close-circle-black.svg alt=icons><span translate=Cancel></span></button></div></div><div class=content-wrapper><spinner ng-if=isLoading></spinner><div class=contents><div class=content><div class="flex label-title mb-16">Project Details</div><div class=flex><div class="flex left-panel"><div class=panel-list><div class="ft_12_600_gray mb-8 required" translate="Project Name"></div><div type=text class="login_input_new w-100" ng-bind=vm.projectData.projectName></div><div class="ft_12_600_gray mb-8 mt-25 required" translate="Building Type"></div><div class="login_input_new w-100" ng-bind=vm.projectData.buildingType.tagName label-field=tagName value-field=_id></div><div class="ft_12_600_gray mb-8 mt-25 required" translate="Start date"></div><div class=login_input_new ng-bind=vm.projectData.startDateFormated></div><div ng-if="vm.projectType == \'Service\'"><div class="ft_12_600_gray mb-8 mt-25" translate="Assigned To"></div><div class=login_input_new>{{vm.projectData.assignedTo[0].firstName}} {{vm.projectData.assignedTo[0].lastName}}</div></div><div ng-if="vm.projectType == \'Public Tender\' || vm.projectType == \'Private Tender\'"><div class="ft_12_600_gray mb-8 mt-25" translate="Tender Date"></div><div class=login_input_new ng-bind=vm.projectData.tenderDate></div></div><div class="ft_12_600_gray mb-8 mt-25" translate=Description></div><textarea class=text-area style="height: 143px;" placeholder="Enter your description here" ng-model=vm.projectData.projectDescription readonly></textarea></div><div class=panel-list><div class="ft_12_600_gray mb-8 required" translate="Project Status"></div><div class=login_input_new ng-bind=vm.p_status></div><div class="ft_12_600_gray mb-8 mt-25 required" translate="Enterprise Type"></div><div class=login_input_new ng-bind=vm.projectData.enterpriseType.tagName></div><div class="ft_12_600_gray mb-8 mt-25 required" translate="End date"></div><div class=login_input_new ng-bind=vm.projectData.endDateFormated></div><div class="mt-25 pos-relative"><div class="ft_12_600_gray mb-8 required" translate=Location></div><input places-auto-complete types="[\'geocode\']" class="login_input_new w-100" on-place-changed=vm.placeMarker() ng-model=vm.address readonly> <img src="/assets/icons/bx-location-plus 1.svg" alt="" style="position: absolute;top: 34px;right: 10px;"></div><div class="w-100 mt-20"><div class=google-map><div><div class="gmap_viewer w-100"><div map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params="{{ vm.gmap.url }}"><ng-map style=height:172px center="{{ vm.gmap.center }}" zoom="{{ vm.gmap.zoom }}" id=service_map><marker ng-repeat="m in vm.gmap.markers" position="{{ m }}" draggable=true on-dragend=vm.updateMarker() icon="{url: \'/assets/images/cgviewer/vp-issue-completed.svg\', scaledSize: [50, 50], origin: [0,0], anchor: [0,0]}"></marker></ng-map></div></div></div></div></div></div></div><div class="flex right-panel ml-24"><div class=flex><div data-wow-delay=1.3s class=btn-trans><img width=226 height=226 ngf-src="vm.projectImage?vm.projectImage:\'/assets/images/dashboard/project_logo.png\'" alt=upload class="bdRadius-4 object-fit-cover"></div></div><div class="flex label-title mb-16 w-100">Project Type</div><div class="flex w-100"><div class="radio-group d-flex"><label class="toggle d-flex mr-20" ng-class="{active: vm.projectType === \'Service\'}"><div class="circle mr-10"></div><div class=radio-label translate="Service Project"></div></label> <label class="toggle d-flex mr-20" ng-class="{active: vm.projectType === \'Public Tender\'}"><div class="circle mr-10"></div><div class=radio-label translate="Public Tender"></div></label> <label class="toggle d-flex mr-20" ng-class="{active: vm.projectType === \'Private Tender\'}"><div class="circle mr-10"></div><div class=radio-label translate="Private Tender"></div></label> <label class="toggle d-flex mr-20" ng-class="{active: vm.projectType === \'None\'}"><div class="circle mr-10"></div><div class=radio-label translate=None></div></label></div></div></div></div></div><div class="content mt-24"><div class="flex label-title mb-16">Client Information</div><div class=flex><div class=panel-list2><div class="ft_12_600_gray mb-8 required" translate="Company Name"></div><div class=login_input_new ng-bind=vm.projectData.client.clientName></div></div><!-- <div class="panel-list2 ml-24">\n              <div class="ft_12_600_gray mb-8" translate="Contact Person"></div>\n              <input type="text" class="login_input_new w-100" ng-model="vm.projectData.client.clientContactPerson.firstName + \' \' +  vm.projectData.client.clientContactPerson.lastName" readonly>\n            </div> --><div class="panel-list2 ml-24"><div class="ft_12_600_gray mb-8" translate=Staff></div><input type=text class="login_input_new w-100" ng-model=vm.projectData.staff.displayName readonly></div></div><div class="flex mt-25"><div class=panel-list2><div class="ft_12_600_gray mb-8" translate="Contact No."></div><div class=flex-between><input type=text class="login_input_new w-107 mr-16 dialcode" ng-model=vm.projectData.client.clientContactPerson.mobile.dialCode readonly> <input type=text class="login_input_new w-390" ng-model=vm.projectData.client.clientContactPerson.mobile.phoneNumber readonly></div></div><div class="panel-list2 ml-24"><div class="ft_12_600_gray mb-8" translate="Email Id"></div><input type=text class="login_input_new w-100" ng-model=vm.projectData.client.email readonly></div></div><div class="flex mt-25"><div class=w-100><div class="ft_12_600_gray mb-8" translate=Address></div><input type=text class="w-100 login_input_new" ng-model=vm.projectData.address.loc.position readonly></div></div><div class="flex mt-25"><div class=panel-list2><div class="ft_12_600_gray mb-8" translate=Country></div><input type=text class="w-100 login_input_new" ng-model=vm.projectData.client.address[0].countryCode readonly></div><div class="panel-list2 ml-24"><!-- <div>\n                <div class="ft_12_600_gray mb-8" translate="State"></div>\n                <input type="text" class="login_input_new w-250" ng-model="vm.projectData.client.address[0].state" readonly>\n              </div> --><div class="ft_12_600_gray mb-8" translate=City></div><input type=text class="w-100 login_input_new" ng-model=vm.projectData.client.address[0].city readonly></div><div class="panel-list2 ml-24"><div class="ft_12_600_gray mb-8" translate="Postal Code"></div><input type=text class="w-100 login_input_new" ng-model=vm.projectData.client.address[0].postalCode readonly></div></div><!-- <div class="split-wrap" ng-if="!vm.edit_project_mode">\n            <div class="ft_14_600_black" translate="File Manager Template"></div>\n            <div class="split-line"></div>\n          </div>\n          <selectbox-input\n            ng-if="!vm.edit_project_mode"\n            options="vm.hierarchyTemplates"\n            label-field="description"\n            value-field="_id"\n            ng-model="vm.selectedHierarchyTemplate">\n          </selectbox-input> --><!-- <div class="btnGroup">\n            <button class="btn_white" ui-sref="projectList">\n              <img src="/assets/icons/close-circle-f-gray.svg" alt="icons" class="mr-10"/>\n              <span translate="Cancel"></span>\n            </button>\n            <button class="btn_primary" ng-click="vm.addProject(vm.projectData)" ng-if="!vm.edit_project_mode">\n              <img src="/assets/icons/bx-plus-circle.svg" alt="icons" class="mr-10"/>\n              <span translate="Create"></span>\n            </button>\n            <button class="btn_primary" ng-click="vm.addProject(vm.projectData)" ng-if="vm.edit_project_mode">\n              <img src="/assets/icons/bx-plus-circle.svg" alt="icons" class="mr-10"/>\n              <span translate="Update"></span>\n            </button>\n          </div> --></div><div class="content mt-24" ng-if=!vm.edit_project_mode><div class="flex label-title mb-16">Attachment</div><!-- <div class="split-wrap" ng-if="vm.projectType == \'Service\'">\n            <div class="ft_14_600_black" translate="Attachments"></div>\n            <div class="split-line"></div>\n          </div> --><div class="flex mt-24"><div class=panel-list2><div class=upload-wrap><div class=upload ngf-select ng-model=vm.inputImg ngf-change="vm.fileUpdated($files, $event, \'image\')" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=true ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><p>Drag and drop here<br>or <span translate=Browse></span></p></div></div></div><div class="panel-list2 ml-24"><div ng-if="vm.uploadImg.length > 0" data-ride=carousel data-interval=false><div class="carousel-inner1 row"><div class="carousel-item1 flex-column mb-56" ng-repeat="(key,f) in vm.uploadImg" ng-class={active:!$index}><img ngf-src="f.secure_url || f" alt="First slide" ng-click="vm.currentIndex=key" class=thumb><div class="f_name ml-16">{{ f.assetName || f.name }}</div><a ng-click="vm.deleteFile($index, \'image\');" class="text-danger image_close_btn ml-auto mt-50"><img src=/assets/icons/close-gray-circle.svg alt=icons></a></div></div></div></div><div class="w-520 upload-wrap" ng-if=0><div class=ft_12_600_gray translate="Upload Documents"></div><div class=upload><div ng-if="vm.uploadFiles.length > 0" data-ride=carousel data-interval=false><div class="carousel-inner1 row"><div class="carousel-item1 flex-column" ng-repeat="(key,f) in vm.uploadFiles" ng-class={active:!$index}><a ng-click="vm.deleteFile($index, \'document\');" class="text-danger docs_close_btn"><img src=/assets/icons/close-gray-circle.svg alt=icons></a><img src=/assets/images/materials/pdf.png alt=doc-icon ng-click="vm.currentIndexDocs=key" class=thumb><div class="text-center f_name mb-15">{{ f.assetName || f.name }}</div></div></div></div><button class=btn_browse ngf-select ng-model=vm.inputFiles ngf-change="vm.fileUpdated($files, $event, \'file\')" name=file ngf-pattern="\'*.*\'" ngf-multiple=true ngf-accept="\'*.*\'"><img src=/assets/icons/plusWhite.svg alt=icons></button></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/projects/projectList/projectList.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=projectList class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Projects></a><!-- <a ui-sref="" class="ft_14_600_gray" translate="{{isServiceProjects? \'Service Projects\': isProjects? \'Projects\': isTenders ? \'Tenders\' : isOngoing ? \'Ongoing1\' : \'Completed\'}}"></a> --></div><div class=ft_24_600_black1 translate="Project List"></div></div><div class="projects-tenders flex-center"><div class=item ng-click="fetchProjects(\'Project\')" ng-class="{\'active\': projectType == \'Project\'}" translate="All Projects"></div><div class=item ng-click="fetchProjects(\'Service\')" ng-class="{\'active\': projectType == \'Service\'}" translate="Service Projects"></div><div class=item ng-click="fetchProjects(\'Tender\')" ng-class="{\'active\': projectType == \'Tender\'}" translate=Tenders></div><div class=item ng-click="fetchProjects(\'Offer\')" ng-class="{\'active\': projectType == \'Offer\'}" translate=Offer></div><div class=item ng-click="fetchProjects(\'Ongoing\')" ng-class="{\'active\': projectType == \'Ongoing\'}" translate=Ongoing1></div><div class=item ng-click="fetchProjects(\'Completed\')" ng-class="{\'active\': projectType == \'Completed\'}" translate=Completed></div><div class=item ng-click="fetchProjects(\'Cancel\')" ng-class="{\'active\': projectType == \'Cancel\'}" translate=Cancel></div><div class=item ng-click="fetchProjects(\'Lost\')" ng-class="{\'active\': projectType == \'Lost\'}" translate=Lost></div><div class=item ng-click="fetchProjects(\'Postponed\')" ng-class="{\'active\': projectType == \'Postponed\'}" translate=Postponed></div><div class=item ng-click="fetchProjects(\'Precast\')" ng-class="{\'active\': projectType == \'Precast\'}" translate=Precast></div></div><searchbox class=ml-auto search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><div><button class="btn-trans ml-16" ng-click="isGrid = false"><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click="isGrid = true"><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button></div></div><div><div><div class=content><div class="table-wrap ft_14_regular_light card-based-content-grid-wrapper" ng-if=!isGrid><div class=flex><div class=flex-5><label class=check_yellow_20><input type=checkbox ng-model=isAccepted><span class=checkmark></span></label></div><div class="flex-20 cursor-point" ng-click="vm.sort(\'projectName\')">Name <img src=/assets/icons/arrow_drop_down.svg alt=""></div><div class="flex-16 cursor-point" ng-click="vm.sort(\'buildingType\')">Type <img src=/assets/icons/arrow_drop_down.svg alt=""></div><div class="flex-20 cursor-point" ng-click="vm.sort(\'created\')">Date <img src=/assets/icons/arrow_drop_down.svg alt=""></div><div class="flex-24 cursor-point">Location <img src=/assets/icons/arrow_drop_down.svg alt=""></div><div class="flex-15 cursor-point" ng-click="vm.sort(\'projectStatus\')">Status <img src=/assets/icons/arrow_drop_down.svg alt=""></div></div><spinner ng-show=isLoading></spinner><div ng-repeat="p in vm.projectList" ng-class="{\'isActive\': activedTender == $index+1}" ng-if=!isLoading><div class=pos-relative><img ng-src="{{isBookmark(p) ? \'/assets/icons/star-active.svg\' : \'/assets/icons/star-20-outline-grey.svg\'}}" alt="" class=bookmark ng-click=bookmarkProject(p)> <img src=/assets/icons/edit.svg alt="" style="position: absolute;right: 45px;top: 18px;cursor: pointer;" ng-click=goToDetail(p)><div class=item><div class=flex-5><label class=check_yellow_20><input type=checkbox ng-model=p.index ng-change=selProject(p)><span class=checkmark></span></label></div><div class=flex-20><div class="ft_16_600_black tx-ellipsis">{{p.projectName}}</div><div class="ft_14_regular_light tx-ellipsis">{{p.systemTag}}</div></div><div class=flex-16><div class="ft_14_regular_light tx-ellipsis"><span translate=Building></span>: <span>{{p.buildingType.tagName}}</span></div><div class="ft_14_regular_light tx-ellipsis"><span translate=Enterprise></span>: <span>Private Limited</span></div></div><div class=flex-20><div class=ft_14_regular_light><span translate="Start Date"></span>: <span>{{ p.startDate | date: "mediumDate" : \'UTC\' }}</span></div><div class=ft_14_regular_light><span translate="End Date"></span>: <span>{{ p.endDate | date: "mediumDate" : \'UTC\' }}</span></div></div><div class="flex-24 ft_14_regular_light address">{{p.displayAddress}}</div><div class=flex-15><div class=project-status translate="{{p.projectStatus | projStatus}}" ng-class="{\'opens\':p.projectStatus==0, \'progresses\':p.projectStatus==1,\n                      \'complete\':p.projectStatus==2, \'cancel\': p.projectStatus==3, \'lost\': p.projectStatus==4,\n                       \'postponed\': p.projectStatus==5, \'precast\': p.projectStatus==6}"></div><div class=dropdown><button class=dropdown-toggle1 type=button id=menu1 data-toggle=dropdown><img src=/assets/icons/more2.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li data-ng-click=onStatus($event) ng-repeat="item in status"><label class=check_yellow_20><input type=checkbox ng-model=item.isChecked><span class=checkmark></span></label> <a href=# class=menu-item id="{{ item._id }}">{{ item.name }}</a></li><li><a class=menu-item ng-if=!status translate="No Data"></a></li></ul></div></div></div></div></div></div><div class="flex flex-wrap mh-min15 mb-24 card-based-content-grid-wrapper" ng-if=isGrid><spinner ng-show=isLoading></spinner><div class=card ng-repeat="p in vm.projectList" ng-if=!isLoading><div class="card-item ft_14_regular_gray"><div class=pos-relative><div class=card-controls><img class=bookmark alt="" ng-click=bookmarkProject(p) ng-src="{{isBookmark(p) ? \'/assets/icons/star-active.svg\' : \'/assets/icons/star-20-outline-black.svg\'}}"> <img class=btn-edit alt="" src=/assets/icons/edit_black.svg ng-click=goToDetail(p)></div></div><div ng-click=selProject(p)><div class=img-wrap><img ng-src="{{ p.projectImage?p.projectImage:p.isServiceProject?\'/assets/images/project/service.png\':\'/assets/images/project/project.png\' }}" onerror="this.src=\'/assets/images/project/project.png\'" width=100% height=125 alt=""></div><div class=card-content><div class=flex-between><div>{{p.systemTag}}</div><div class=project-status translate="{{p.projectStatus | projStatus}}" ng-class="{\'opens\':p.projectStatus==0, \'progresses\':p.projectStatus==1,\n                        \'complete\':p.projectStatus==2, \'cancel\': p.projectStatus==3, \'lost\': p.projectStatus==4,\n                        \'postponed\': p.projectStatus==5, \'precast\': p.projectStatus==6}"></div></div><div class="ft_16_600_black mv-5 tx-ellipsis">{{p.projectName}}</div><div class=tx-ellipsis>{{p.displayAddress}}</div></div></div></div></div></div><!-- <div class="flex-between mt-15" ng-if="!isLoading">\n            <div class="mr-10 ft_14_600_black">\n              Showing {{(vm.currentPage - 1) * numPerPage + 1}} -\n              <span>{{(vm.currentPage - 1) * numPerPage + vm.projectList.length}}</span>\n              of {{totalCount}} - {{isServiceProjects? \'Service Projects\': isProjects? \'Projects\': isTenders? \'Tenders\' : isOngoing ? \'Ongoing\' : \'Completes\'}}\n            </div>\n            <hr class="split-line"/>\n            <pagination num-pages="noOfPages" current-page="vm.currentPage" on-select-page="fetchAllProjects()"></pagination>\n          </div> --><div class="flex flex-row pagination-footer flex-items-center justify-content-end mt-4 card-based-content-grid-wrapper"><span class="ft_14_regular_black mr-3">Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.projectList.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchAllProjects()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/projects/workOrderList/workOrderList.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="title-bar flex-between"><div class=d-flex><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Service></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Work Orders"></a></div><div class=ft_24_600_black1 translate="Work Orders"></div></div><div class=filter-panel><div class="mr-40 ml-40 search-wrap"><img src=/assets/icons/search-gray.svg alt="" class=search-icon> <input type=text class=search ng-model=searchText placeholder=Search></div><div class=filter-widget><div class="dropdown mr-30"><div id=dropdownMenuButtonUser data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class="fa fa-user"></span> <span class="ml-6 mr-10">All users</span> <span class="fa fa-caret-down"></span></div><div class=dropdown-menu aria-labelledby=dropdownMenuButtonUser><a class=dropdown-item href=#>option 1</a> <a class=dropdown-item href=#>option 2</a> <a class=dropdown-item href=#>option 3</a></div></div><div class="dropdown mr-30"><div id=dropdownMenuButtonLocation data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class="fa fa-map-marker-alt"></span> <span class="ml-6 mr-10">Any Location</span> <span class="fa fa-caret-down"></span></div><div class=dropdown-menu aria-labelledby=dropdownMenuButtonLocation><a class=dropdown-item href=#>option 1</a> <a class=dropdown-item href=#>option 2</a> <a class=dropdown-item href=#>option 3</a></div></div><div class="dropdown mr-30"><div id=dropdownMenuButtonLocation data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class="fa fa-chart-bar"></span> <span class="ml-6 mr-10">Any Priority</span> <span class="fa fa-caret-down"></span></div><div class=dropdown-menu aria-labelledby=dropdownMenuButtonLocation><a class=dropdown-item href=#>option 1</a> <a class=dropdown-item href=#>option 2</a> <a class=dropdown-item href=#>option 3</a></div></div><div class="dropdown mr-30"><div id=dropdownMenuButtonLocation data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class="fa fa-check-circle"></span> <span class="ml-6 mr-10">Completed, Open</span> <span class="fa fa-caret-down"></span></div><div class=dropdown-menu aria-labelledby=dropdownMenuButtonLocation><a class=dropdown-item href=#>option 1</a> <a class=dropdown-item href=#>option 2</a> <a class=dropdown-item href=#>option 3</a></div></div><div class="dropdown mr-30"><div id=dropdownMenuButtonLocation data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class="fa fa-calendar-alt"></span> <span class="ml-6 mr-10">Any Day</span> <span class="fa fa-caret-down"></span></div><div class=dropdown-menu aria-labelledby=dropdownMenuButtonLocation><a class=dropdown-item href=#>option 1</a> <a class=dropdown-item href=#>option 2</a> <a class=dropdown-item href=#>option 3</a></div></div></div></div></div><button class="button-primary ml-16" ng-click=toggleCreateWorkOrderModal()><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Create Work Order"></span></button></div><div id=workOrder-list><div><div><div class=table-header><div class=btn-group></div></div><div class=listViewContainer><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox><span class=checkmark></span></label></th><th class=ft_14_600_black><span translate="Created On"></span></th><th class=ft_14_600_black><span translate=#WO></span></th><th class=ft_14_600_black><span translate=Status></span></th><th class=ft_14_600_black><span translate="Client Name"></span></th><th class=ft_14_600_black><span translate="Work Order Title"></span></th><th class="ft_14_600_black w150"><span translate=Priority></span></th><th class=ft_14_600_black><span translate="Assigned To"></span></th><th class=ft_14_600_black><span translate="Expected Productions Date"></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, workOrder) in vm.workOrderList"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=workOrder.checked> <span class=checkmark></span></label></td><td class=ft_14_regular_black>{{workOrder.createdOn}}</td><td class=ft_14_regular_black>{{workOrder.wo}}</td><td class=ft_14_regular_black><span class="fa fa-check-circle status-complete"></span> {{workOrder.status}}</td><td class=ft_14_regular_black>{{workOrder.clientName}}</td><td class=ft_14_regular_black>{{workOrder.workOrderTitle}}</td><td class="ft_14_regular_black w150"><div class="priority {{workOrder.priority}}">{{workOrder.priority}}</div></td><td class=ft_14_regular_black>{{workOrder.assignedTo}}</td><td class="ft_14_regular_black text-center">{{workOrder.expectedProductionsDate}}</td><td class="ft_14_regular_black text-right pr-15"><div class=dropdown><img src=/assets/icons/more-horiz.svg alt="" class=cursor-point data-toggle=dropdown><div class=dropdown-menu role=menu><div class="menu-item ml-10" translate=Edit></div><div class="menu-item ml-10" translate=Remove></div></div></div></td></tr></tbody></table><div class=pull-right><div class="flex flex-row pagination-footer flex-items-center"><span class="ft_14_regular_black mr-10">Items per page</span><selectbox class=duration ng-model=numPerPage options=itemPerPage label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">1 - <span>20</span> of 40</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchData()></pagination-custom-new></div></div></div></div><div class=listViewContainer ng-if=isCompanyBills()><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox> <span class=checkmark></span></label></th><th class=ft_14_600_black><span translate="Sr No"></span></th><th class=ft_14_600_black><span translate=Date></span></th><th class=ft_14_600_black><span translate="Bill No"></span></th><th class=ft_14_600_black><span translate="Invoice No"></span></th><th class=ft_14_600_black><span translate=Vendor></span></th><th class=ft_14_600_black><span translate=Amount></span></th><th class=ft_14_600_black><span translate="Vat Amount"></span></th><th class=ft_14_600_black><span translate=Total></span></th><th class=ft_14_600_black><span translate=Status></span></th><th class=ft_14_600_black><span translate=Action></span></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, bill) in vm.billList | filter:searchText"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=bill.checked><span class=checkmark></span></label></td><td>{{ totalCount1 - (vm.currentPage1 - 1)*numPerPage - key }}.</td><td class=ft_14_regular_black ng-bind="bill.billDate ? bill.billDate : bill.customSupplierData.billdate | date"></td><td class=ft_14_regular_black ng-bind=bill.billNo></td><td class=ft_14_regular_black ng-bind=bill.customSupplierData.invoicenumber></td><td class=ft_14_regular_black>{{ bill.vendor.clientName || bill.vendor.name}}</td><td class=ft_14_regular_black>{{ bill.amountWithoutTax | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.taxAmount | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.totalAmount | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.status }}</td><td class=ft_14_regular_black><div class="flex flex-row flex-items-center vaActionContainer"><div class="cursor-point mr-4" ng-click=vm.gotoEdit(bill) ng-if="bill.status==\'pending\' || !bill.externEconomics.isNaviSynced"><img src=/assets/icons/edit.svg alt=""></div><div class="cursor-point mr-4" ng-click=vm.downloadPdf(bill)><img src=/assets/icons/cloud-download.svg alt=""></div><div class=cursor-point ng-click="vm.deleteBill(bill, $index)" ng-if="ECO_ACCESS_CREATE > 3 && bill.status != \'approved\'"><img src=/assets/icons/trash-alt6.svg alt=""></div></div></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage1 - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage1 - 1) * numPerPage + (vm.billList | filter:searchText).length}}</span> of {{totalCount1}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages1 current-page=vm.currentPage1 on-select-page=vm.fetchData()></pagination-custom-new></div></div></div><div class=listViewContainer ng-if=isVendorCreditMemos()><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox><span class=checkmark></span></label></th><th class=ft_14_600_black><span translate="Sr No"></span></th><th class=ft_14_600_black><span translate=Date></span></th><th class=ft_14_600_black><span translate="Bill No"></span></th><th class=ft_14_600_black><span translate="Invoice No"></span></th><th class=ft_14_600_black><span translate=Vendor></span></th><th class=ft_14_600_black><span translate=Amount></span></th><th class=ft_14_600_black><span translate="Vat Amount"></span></th><th class=ft_14_600_black><span translate=Total></span></th><th class=ft_14_600_black><span translate=Status></span></th><th class=ft_14_600_black><span translate=Action></span></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, bill) in vm.billList | filter:searchText"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=bill.checked> <span class=checkmark></span></label></td><td>{{ totalCount2 - (vm.currentPage2 - 1)*numPerPage - key }}.</td><td class=ft_14_regular_black ng-bind="bill.billDate ? bill.billDate : bill.customSupplierData.billdate | date"></td><td class=ft_14_regular_black ng-bind=bill.billNo></td><td class=ft_14_regular_black ng-bind=bill.customSupplierData.invoicenumber></td><td class=ft_14_regular_black>{{ bill.vendor.clientName || bill.vendor.name}}</td><td class=ft_14_regular_black>{{ bill.amountWithoutTax | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.taxAmount | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.totalAmount | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.status }}</td><td class=ft_14_regular_black><div class="flex flex-row flex-items-center vaActionContainer"><div class="cursor-point mr-4" ng-click=vm.gotoEdit(bill) ng-if="bill.status==\'pending\' || !bill.externEconomics.isNaviSynced"><img src=/assets/icons/edit.svg alt=""></div><div class="cursor-point mr-4" ng-click=vm.downloadPdf(bill)><img src=/assets/icons/cloud-download.svg alt=""></div><div class=cursor-point ng-click="vm.deleteBill(bill, $index)" ng-if="ECO_ACCESS_CREATE > 3 && bill.status != \'approved\'"><img src=/assets/icons/trash-alt6.svg alt=""></div></div></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage2 - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage2 - 1) * numPerPage + (vm.billList | filter:searchText).length}}</span> of {{totalCount2}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages2 current-page=vm.currentPage2 on-select-page=vm.fetchData()></pagination-custom-new></div></div></div></div></div><spinner ng-if=isDownloading></spinner></div></main><div ng-if=vm.pdfViewing><pdf-viewer id=pdf-viewer class=pdf-viewer url=vm.bill.bill.secure_url ng-close=vm.closePDFViewer></pdf-viewer></div>');
$templateCache.put('app/main/reports/add-registration/add-registration.view.html','<div id=reports-add-registration-wrap><main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=add-registration class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=reportsList translate=Reports></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2">{{vm.regId?"Edit Registration":"Add Registration"}}</a></div><div class=ft_24_600_black1>{{vm.regId?"Edit Registration":"Add Registration"}}</div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-show="regData.step==1" ng-click=goStep(2)><img src=/assets/icons/arrow-right-white-issue.svg alt=icons><span translate=Continue></span></button> <button class="btn_new_blue mr-16" ng-show="regData.step==2" ng-click=addRegistration()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_white_back" ng-click=cancelRegistration()><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div><spinner ng-if=loading></spinner><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=step1 ng-show="regData.step==1"><div class="header ft_12_600_blue_back">{{vm.regId?"Edit Registration":"Add Registration"}}</div><div class="content d-flex"><div class="info w-100"><div class="ft_14_600_moreblack required" translate="Registration Type"></div><div class="w-100 mb-24"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=regData.registrationType options=registrationTypeList label-field=label value-field=value placeholder="Select Registration Type"></selectbox-input></div><div class="ft_14_600_moreblack required" translate="Group by"></div><div class="w-100 mb-24"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=regData.group options=tagsList label-field=tagName value-field=_id placeholder="Select Group"></selectbox-input></div><div class=ft_14_600_moreblack translate="Control Method"></div><div class="w-100 mb-24"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=regData.controlPlanItem options=controlPlanItems label-field=groupName value-field=groupName placeholder="Select Method"></selectbox-input></div><div class=ft_14_600_moreblack translate=Checklist></div><div class="w-100 mb-24"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=checkListId options=report.checkList label-field=title value-field=_id placeholder="Select Checklist"></selectbox-input><img ng-if=checkListId src=/assets/icons/edit.svg class=ml-3 ng-click=openUpdateChecklistModal()></div><div class="w-100 mb-24"><div class=ft_14_600_moreblack translate=Description></div><textarea rows=6 class=w-100 placeholder="Enter your description here" ng-model=regData.description></textarea></div><div class=btn-group><button class="btn_new_blue mr-16" ng-click=goStep(2)><img src=/assets/icons/arrow-right-white-issue.svg alt=icons><span translate=Continue></span></button> <button class="btn_new_blue mr-16" ng-click=addRegistration() ng-if=vm.regId><img src=/assets/icons/save-icon.svg alt=icons><span class=ft-600-12-16 translate=Update></span></button> <button class="btn_new_blue client_gray_white_back" ng-click=cancelRegistration()><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div class="logo ml-24"><button data-wow-delay=1.3s class=btn-trans><img width=354 height=310 ng-src="{{!!imageURL?imageURL:\'/assets/images/suppliers/upload.png\'}}" alt=upload onerror="this.style.display=\'none\';" ngf-select name=file ngf-change=vm.changeImage($files) aria-invalid=false data-wow-delay=0.7s onerror="this.style.display=\'none\';" class="bdRadius-4 object-fit-cover"></button></div></div></div><div class=step2 ng-show="regData.step==2"><div class="header ft_12_600_blue_back">{{vm.regId?"Edit 3D Model/2D":"Add 3D Model/2D"}}</div><div class=content><div class="mb-3 flex-between"><div class=ft_24_600_black translate="2D Drawing & 3D Model"></div><button class="btn_new_blue pv-8 pl-6 pr-12" ng-click=goAddMarking()><img src=/assets/icons/bx-plus16.svg class=mr-10 alt=icons> <span translate="Add Markings"></span></button></div><div class=mb-4><span class="switch switch-sm"><input type=checkbox class=switch id=statusValue ng-model=isVP ng-checked=isVP> <label for=statusValue></label></span></div><div style="display: flex;align-items: flex-start;justify-content: space-between;" ng-show=!isVP><div class=w-500><div class=flex-between><div><div class="ft_14_600_moreblack required" translate="3D Model"></div><div class="w-310 mb-20"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=regData.marker.info3d.modelId options=m3dList label-field=name value-field=_id select-event=change3dModel() disabled></selectbox-input></div></div><div><div class=ft_14_600_moreblack translate=Level></div><div class="w-160 mb-20"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=regData.marker.info3d.level options=m3dLevelList label-field=name value-field=guid select-event=change3dModelLevel() disabled></selectbox-input></div></div></div><div id=loading3d-container class=d-none><img src=/assets/images/cgviewer/cloud_loading.gif alt=""></div><div id=model3d-preview-container><div id=model3d-preview class="no-zoom render-3d"></div></div></div><div class=w-500><div id=loading2d-container class=d-none><img src=/assets/images/cgviewer/cloud_loading.gif alt=""></div><div id=model2d-preview-container class=mt-90><div id=model2d-preview class=no-zoom></div></div></div></div><div class="d-flex align-items-start justify-content-between" ng-show=isVP><div class=w-100><div class=flex-between><div><div class=ft_14_600_moreblack translate=VP></div><div class="w-310 mb-20"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=regData.marker.info3d.modelId options=vpList label-field=title value-field=_id select-event=changeVP() disabled placeholder=VP></selectbox-input></div></div></div><div id=loadingvp-container class=d-none><img src=/assets/images/cgviewer/cloud_loading.gif alt=""></div><div id=vp-preview-container><div id=vp-preview class=no-zoom></div></div></div></div><div class=btn-group><button class="btn_new_blue mr-16" ng-click=goStep(1)><img src=/assets/icons/left-arrow1.svg style="margin-right: 4px; width: 12px; height: 12px;" alt=icons><span translate="Prev Step"></span></button> <button class="btn_new_blue mr-16" ng-click=addRegistration()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_white_back" ng-click=exitCreateRegisteration()><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div></div><div class=step3 ng-show="regData.step==3"><div class=header><div class="flex50 details cursor-notallowed"><div class=ready-complete><img src=/assets/icons/ready-complete.svg alt=""></div><div class="ft_18_600_black ml-20 ft-yellow" translate="Registration Details"></div></div><div class="flex50 model cursor-notallowed"><div class=ready-complete><img src=/assets/icons/ready-complete.svg alt=""></div><div class="ft_18_600_black ml-20" translate="Add 3D Model/ 2D"></div></div></div><div class="content flex-center"><div class=text-center><img src=/assets/icons/checked-lg.svg alt=""><div class="ft_36_600_black custom-black mt-30 mb-10" translate=Congratulations></div><div class="ft_24_600_gray custom-gray" translate="Your registration is succesfully created"></div><div class="ft_24_600_gray custom-gray mt-10" translate="Thank You !"></div><button class=btn_primary ng-click=exitCreateReport() translate=Continue></button></div></div></div></div></div></div></div></main></div>');
$templateCache.put('app/main/reports/create-reports/create-reports.view.html','<div id=create-reports-wrap><main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=create-reports class=main-container><div class="title-bar flex flex-row flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2 cursor-point" ng-click=exitCreateReport() translate=Reports></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=\'{{reportData.editMode ? "Edit Report" : "Create Report"}}\'></a></div><div class=ft_24_600_black1 translate=\'{{reportData.editMode ? "Edit Report" : "Create Report"}}\'></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue client_gray_white_back mr-16 pv-8 pl-6 pr-12" ng-click=exitCreateReport()><img src=/assets/icons/close-16-black.svg style="margin-right: 4px;" alt=icons><span class=ft-600-12-16 translate=Cancel></span></button> <button class="btn_new_blue pv-8 pl-12 pr-6" ng-click=createReport()><span translate=\'{{reportData.editMode ? "Update" : "Create"}}\'></span><img src=/assets/icons/arrow-right-white-issue.svg style="margin-left: 4px;" alt=icons></button></div></div><div class="card-based-content-grid-wrapper p-24"><spinner ng-show=loading></spinner><div class=contents><div class=step1><div class=header translate=\'{{reportData.editMode ? "Edit Report" : "Create Report"}}\'></div><div class=content><div class="flex flex-row"><div class=flex-1><div class="ft_14_600_moreblack required mt-16" translate="Report Title"></div><input type=text class="login_input_new mb-24 w-100" placeholder="{{\'Enter Report Title\' | translate}}" ng-model=reportData.title autofocus><div class="ft_14_600_moreblack required" translate="Report Category"></div><selectbox-input class="arrowbottom_46_400 input-select mb-24" ng-model=reportData.reportType options=reportTypeList label-field=label value-field=key></selectbox-input><div class=ft_14_600_moreblack translate=Sub-Contractor></div><selectbox-input class="arrowbottom_46_400 input-select" ng-model=reportData.subContractor options=subContractorsList label-field=name value-field=_id></selectbox-input></div><div class=ml-24><button data-wow-delay=1.3s class="btn-trans mt-16"><img width=354 height=310 ng-src="{{!!imageURL ? imageURL : reportData.image.secure_url ? reportData.image.secure_url : \'/assets/images/suppliers/upload.png\'}}" alt=upload ngf-select name=file ngf-change="changeImage($files, $event)" ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-accept="\'.jpg,.jpeg,.png\'" aria-invalid=false data-wow-delay=0.7s onerror="this.style.display=\'none\';" class="br-4 object-fit-cover"></button></div></div><div class="flex flex-row mb-24"><div class="flex-1 mr-12"><div class=ft_14_600_moreblack translate="Registration Interval"></div><selectbox-input class="arrowbottom_46_400 input-select" ng-model=reportData.registrationInterval options=regIntervalList label-field=label value-field=key></selectbox-input></div><div class="flex-1 ml-12"><div class=ft_14_600_moreblack translate="Control Plan"></div><selectbox-input class="arrowbottom_46_400 input-select" ng-model=reportData.controlPlan options=controlPlanList label-field=systemTag value-field=_id></selectbox-input></div></div><div class="flex flex-row mb-24"><div class="flex-1 pr-12"><div class=ft_14_600_moreblack translate=Description></div><textarea class=mb-24 placeholder="{{\'Enter your description here1\' | translate}}" ng-model=reportData.description rows=6></textarea></div><div class="flex-1 pl-12"><div class=ft_14_600_moreblack translate="About Company"></div><textarea class=mb-24 placeholder="Enter about the company" ng-model=reportData.aboutCompany rows=6></textarea></div></div><div class=ft_14_600_moreblack translate=Checklist></div><div class="flex-row flex-items-center flex-between"><selectbox-input class="input-select flex-1" ng-model=checkList options=allCheckList label-field=title value-field=_id></selectbox-input><img src=/assets/icons/plus-blue.svg alt=icons ng-click=selectCheckList() class="add-btn cursor-point"></div><div class="d-flex flex-wrap mt-15"><div class=checklist-item ng-repeat="item in reportData.checkList">{{getChecklistTitle(item)}} <img class="cursor-point ml-3" src=/assets/icons/close-24.svg ng-click=removeCheckList(item)></div></div><div class="flex flex-row flex-between mt-24"><button class="btn_new_blue client_gray_white_back mr-16 pv-8 pl-6 pr-12" ng-click=exitCreateReport()><img src=/assets/icons/delete1.svg style="margin-right: 4px;" alt=icons><span class=ft-600-12-16 translate=Cancel></span></button> <button class="btn_new_blue pv-8 pl-12 pr-6" ng-click=createReport()><span translate=\'{{reportData.editMode ? "Update" : "Create"}}\'></span><img src=/assets/icons/arrow-right-white-issue.svg style="margin-left: 4px;" alt=icons></button></div></div></div></div></div></div></main></div>');
$templateCache.put('app/main/reports/reports-details/reports-details.view.html','<div id=reports-detail-wrap><main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=reports-detail class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=reportsList translate=Reports></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Report Details"></a></div><div class=ft_24_600_black1 translate="Report Details"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=editReport() ng-if="REPORT_ACCESS_CREATE > 1"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=deleteReport() ng-if="REPORT_ACCESS_CREATE > 3"><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=reportsList><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div><div class=contents><div class=item1><div class=content><div class=flex-between><div class=ft_12_regular_blackgrey>{{report.systemTag}}</div><div class="rect resolved">{{getRegIntervalText(report.registrationInterval)}}</div></div><div class="ft_16_600_black mb-16">{{report.title}}</div><div class=mb-16><div ng-show="reportRegPhotoPath && isRegistrationType" class=pos-relative><div class=ft_14_600_black>Image View</div><img src=/assets/icons/maximize.svg class="object-fit-cover max-icon" ng-click=reportImageByType(reportRegPhotoPath)> <img ng-src={{reportRegPhotoPath}} alt="" class=main-img></div><div ng-show="data_url && !isRegistrationType" class=pos-relative><div class=ft_14_600_black>Pdf View</div><img src=/assets/icons/maximize.svg class="object-fit-cover max-icon" ng-click=reportImageByType(data_url)> <img ng-src={{data_url}} alt="" class=main-img></div><div ng-show=isRegistrationType ng-if=isRegImageView><div class="flex-between mb-10"><div class=ft_14_600_black>{{(entityType == \'3d\' ? \'2D / 3D\' : \'VP\') + \' View\'}}</div><div class=switch-wrapper><span class="switch switch-sm" ng-show="entityType == \'3d\'"><input type=checkbox class=switch id=statusValue ng-model=is3D ng-checked=viewTypeChanged()> <label for=statusValue></label></span></div></div><div class=d-view><img src=/assets/icons/maximize.svg class="object-fit-cover max-icon" ng-click=reportRegModelImageByType() alt=""><div class=marking-viewer-container ng-if="entityType == \'3d\'"><img ng-src={{reportRegimage3DPath}} alt="" class=marking-viewer ng-if="is3D && reportRegimage3DPath"> <img ng-src={{reportRegimage2DPath}} alt="" class=marking-viewer ng-if="!is3D && reportRegimage2DPath"></div><div class=marking-viewer-container ng-if="entityType != \'3d\' && reportRegimage3DPath"><img ng-src={{reportRegimage3DPath}} alt="" class=marking-viewer></div></div></div></div><div class="ft_14_regular_gray2 mb-4" translate="Project Name"></div><div class="ft_14_600_black mb-24">{{report.projectId.projectName}}</div><div class="ft_14_regular_gray2 mb-4" translate=Description></div><div class="ft_14_regular_gray2 mb-24" style="word-break: break-all">{{report.description}}</div><div class="ft_14_regular_gray2 mb-4" translate=Category></div><div class="ft_14_600_black mb-24">{{report.reportType}}</div><div class="ft_14_regular_gray2 mb-4" translate="Created by"></div><div class="flex flex-row mb-24 flex-items-center"><img ng-src={{report.createdBy.profilePic}} class="assignerAvatar mr-8 object-fit-cover"><div class=ft_14_600_black>{{report.createdBy.displayName}}</div></div><div class="ft_14_regular_gray2 mb-4" translate=Sub-contractor></div><div class="ft_14_600_black mb-24">{{report.subContractor.name}}</div><div class="flex flex-row"><div class="flex-1 mr-8"><div class="ft_14_regular_gray2 mb-4" translate="Reg. Interval"></div><div class="ft_14_600_black mb-24">{{getRegIntervalText(report.registrationInterval)}}</div></div><div class="flex-1 ml-8"><div class="ft_14_regular_gray2 mb-4" translate="Control method"></div><div class="ft_14_600_black mb-24">{{report.controlPlan.systemTag}}</div></div></div><div class="ft_14_regular_gray2 mb-4" translate=Checklist></div><div class="flex flex-row"><span ng-repeat="item in report.checkList" class="ft_14_600_black checklist_item mr-8">{{item.title}}</span></div></div></div><div class="item2 flex-1"><div class=details><div class=header><div class=flex-70 ng-click=onRegistration() ng-class="isRegAndDoc?\'active\':\'inactive\'" translate="Registration & Site Documents"></div><div class=flex-30 ng-click=onMedia() ng-class="isMedia?\'active\':\'inactive\'" translate=Media></div></div><div class=detail><div ng-if=isRegAndDoc><div class="btn-group flex-between"><div class="flex flex-row"><span class=ft_18_600_black1>Registration & Site Documents</span><div class="flex flex-row flex-items-center pl-8 pr-8 reportDetailSearch ml-32"><img src=/assets/icons/search_dark.svg alt=icons> <input type=text placeholder=Search class=ft_14_regular_gray2 style=border:none></div></div><div class="d-flex regControlContainer"><button class=btn_primary ng-click=onAddRegistration() ng-if="REPORT_ACCESS_CREATE > 1"><img src=/assets/icons/bx-plus-circle-blue.svg alt=icons> <span class=ft_14_600_black2 translate="Add Reg."></span></button> <button class=btn_primary ng-click=onAddSiteDocument() ng-if="REPORT_ACCESS_CREATE > 1"><img src=/assets/icons/bx-plus-circle-blue.svg alt=icons> <span class=ft_14_600_black2 translate="Add Site Doc"></span></button> <button class=btn_primary ng-click=vm.exportReport()><img src=/assets/icons/bx-Upload-blue.svg alt=icons> <span class=ft_14_600_black2 translate=Export></span></button></div></div><spinner ng-show=loading></spinner><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer"><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class="checkbox-cell flex-12"><label class=check_yellow_20><input type=checkbox ng-model=supplier.checked> <span class=checkmark ng-click=setAllChecked()></span></label></th><th class="ft_14_600_black flex-12"><span translate=#></span></th><th class="ft_14_600_black flex-25"><span translate="Created on"></span></th><th class="ft_14_600_black flex-25"><span translate=Type></span></th><th class="ft_14_600_black flex-20"><span translate=Group></span></th><th class="ft_14_600_black flex-1"><span translate=Actions></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr class=tr_elem ng-repeat="entity in entities track by $index"><td class="checkbox-cell flex-12"><label class=check_yellow_20><input type=checkbox value=false ng-model=entity.selected ng-change=onSelEntity(entity)> <span class=checkmark></span></label></td><td class="ft_14_regular_black flex-12">{{ totalEntities - (vm.currentPageForEntity - 1) * numEntitiesPerPage - $index }}</td><td class="ft_14_regular_black tx-ellipsis name flex-25">{{entity.createdAt | smartDate}}</td><td class="ft_14_regular_black flex-25">{{entity.registrationType ? entity.registrationType : \'Site Document\'}}</td><td class="ft_14_regular_black flex-20">{{entity.systemTag}}</td><td class="flex-items-center flex-1 td_actions"><img src=/assets/icons/eye-gray.svg alt="" class=cursor-point ng-click=vm.print(entity) ng-if=!entity.registrationType> <img ng-if=entity.registrationType src=/assets/icons/eye-gray.svg alt="" class=cursor-point ng-click=issueImageByType(entity)> <img ng-if="REPORT_ACCESS_CREATE > 1" src=/assets/icons/bx-edit-gray.svg alt="" class=cursor-point ng-click="editEntity(entity, entity.registrationType ? true : false)"> <img ng-if="REPORT_ACCESS_CREATE > 1" src=/assets/icons/delete-gray.svg alt="" class=cursor-point ng-click="deleteEntity(entity._id, entity.registrationType ? true : false)"></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center" ng-show="entities.length > 0"><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numEntitiesPerPage options=periods label-field=name value-field=id select-event=vm.selectEntityNumPage(numEntitiesPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPageForEntity - 1) * numEntitiesPerPage + 1}} - <span>{{vm.currentPageForEntity * numEntitiesPerPage > totalPagesForEntities? totalPagesForEntities: vm.currentPageForEntity * numEntitiesPerPage}}</span> of {{totalPagesForEntities}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=totalPagesForEntities current-page=vm.currentPageForEntity on-select-page=pagingEntities()></pagination-custom-new></div></div></div></div></div><div ng-if=isMedia><div class="btn-group flex-between"><div class="flex flex-row"><span class=ft_18_600_black1>All Media</span><div class="flex flex-row flex-items-center pl-8 pr-8 reportDetailSearch ml-32"><img src=/assets/icons/search_dark.svg alt=icons> <input type=text placeholder=Search class=ft_14_regular_gray2 style=border:none></div></div><div class="d-flex regControlContainer"><button class=btn_primary ngf-select ng-model=mediaFile ngf-change=uploadMediaFile($files) ng-if="REPORT_ACCESS_CREATE > 1"><img src=/assets/icons/bx-Upload-blue.svg alt=icons> <span class=ft_14_600_black2 translate=Upload></span></button></div></div><div class="media-wrapper flex flex-wrap"><div ng-repeat="media in medias"><div class="media-card d-block"><img src=/assets/icons/delete-icon.svg alt="" class=delete-icon ng-click=deleteIcon(media._id)> <img ng-src={{media.url}} alt="" class="report-media-logo object-fit-cover"><div class="name-wrapper text-center ft_14_regular_black2">{{media.name}}</div></div></div></div><div class="flex flex-row pagination-footer flex-items-center mt-12" ng-show=medias.length><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numMediasPerPage options=periods label-field=name value-field=id select-event=vm.selectMediaNumPage(numMediasPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPageForEntity - 1) * numMediasPerPage + 1}} - <span>{{vm.currentPageForEntity * numMediasPerPage > totalPagesForMedias? totalPagesForMedias: vm.currentPageForEntity * numMediasPerPage}}</span> of {{totalPagesForMedias}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=totalPagesForMedias current-page=vm.currentPageForMedia on-select-page=pagingMedias()></pagination-custom-new></div></div></div></div></div></div></div></div></div></div></main></div><div ng-if=vm.pdfViewing><pdf-viewer id=pdf-viewer class=pdf-viewer url=reportDocURL ng-close=vm.closePDFViewer></pdf-viewer></div>');
$templateCache.put('app/main/reports/reports-list/reports-list.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=reports-list class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Reports></a></div><div class=ft_24_600_black1 translate=Reports></div></div><searchbox class=ml-auto search-text=searchText search-event=searchReports() is-small=true></searchbox><div><button class="btn-trans ml-16" ng-click="isGrid = false"><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click="isGrid = true"><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button></div><button class="btn_new_blue ml-16" ng-click=onCreateReports() ng-if="REPORT_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Create Report"></span></button></div><div><spinner ng-show=loading></spinner><no-data ng-if="totalCount == 0" text="{{loading ? \'Loading...\' : \'No Data to Display\'}}"></no-data><div ng-if="totalCount > 0"><div ng-if=isGrid><div class="flex mb-24 flex-col card-based-content-grid-wrapper pv-24"><div class="flex flex-wrap flex-row w-100"><div class=card-item ng-repeat="issue in vm.reports"><div class=cursor-point ng-click=goToDetail(issue._id)><div class=card-radius><div class=img-wrap><img ng-src="{{ issue.image && issue.image.secure_url?issue.image.secure_url:\'/assets/icons/tender.svg\' }}" alt="" onerror="this.src=\'/assets/icons/tender.svg\'" width=100% height=156></div><div class=card-content><div class=flex-between><div class="ft_12_600_black tx-ellipsis">{{issue.systemTag}}</div><div class="rect resolved">{{getRegIntervalText(issue.registrationInterval)}}</div></div><div class="flex mt-10"><div class="ft_16_600_black tx-ellipsis">{{issue.title}}</div></div><div class=flex><div class=ft_14_600_moregray translate=Admin></div>:&nbsp;<div class=ft_14_regular_gray2>{{issue.createdBy.displayName}}</div></div></div><div class="flex-between issue-card-footer"><div class="flex flex-row"><img style="margin-right: 7px;" src=/assets/images/suppliers/tag.svg alt=icons><div class=ft_12_600_black>{{issue.reportType}}</div></div><div class="flex flex-row"><div class=ft_12_600_black>{{issue.projectId.projectName}}</div><img style="margin-left: 7px;" src=/assets/icons/domain-blue.svg alt=icons></div></div></div></div></div></div><div class="flex-1 pag-footer"><div class="flex flex-row flex-items-center pull-right"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span>{{vm.currentPage * numPerPage > totalCount? totalCount: vm.currentPage * numPerPage}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=totalPages current-page=vm.currentPage on-select-page=init()></pagination-custom-new></div></div></div></div></div><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer" ng-if=!isGrid><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=supplier.checked> <span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate=SystemTag></span></th><th class=ft_14_600_black><span translate=Title></span></th><th class=ft_14_600_black><span translate="Project Name"></span></th><th class=ft_14_600_black><span translate="Registration Interval"></span></th><th class=ft_14_600_black><span translate="Created By"></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, issue) in vm.reports"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=issue.checked> <span class=checkmark></span></label></td><td class=cursor-point ng-click=goToDetail(issue._id) class="ft_14_regular_black tx-ellipsis name">{{issue.systemTag}}</td><td class="tx-ellipsis email ft_14_regular_black" ng-bind=issue.title></td><td class=ft_14_regular_black>{{issue.projectId.projectName}}</td><td class=ft_14_regular_black>{{getRegIntervalText(issue.registrationInterval)}}</td><td class=ft_14_regular_black>issue.createdBy.displayName</td><td class="more flex-items-center cursor-point"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class=margin-0></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span>{{vm.currentPage * numPerPage > totalCount? totalCount: vm.currentPage * numPerPage}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=totalPages current-page=vm.currentPage on-select-page=init()></pagination-custom-new></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/reports/reports-marking/reports-marking.view.html','<div id=reports-marking><main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="title-bar flex flex-row flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2 cursor-point" ng-click=onCancel() translate=Report></a></div><div class=ft_24_600_black1 translate="Registeration Marking"></div></div><div class="flex flex-row flex-items-center"><div class="switch switch-sm mr-16" ng-show="vm.regData.marker.modelType == \'3d\' && !isOnly3D"><input type=checkbox class=switch id=statusValue ng-model=is3D ng-checked=viewTypeChanged()> <label for=statusValue style=margin-bottom:0px></label></div><button class="btn_new_blue client_gray_white_back mr-16 pv-8 pl-6 pr-12" ng-click=onCancel()><img src=/assets/icons/close-16-black.svg style="margin-right: 4px;" alt=icons><span class=ft-600-12-16 translate=Cancel></span></button> <button class="btn_new_blue client_gray_back mr-16 pv-8 pl-6 pr-12" ng-click=removeMarker()><img src=/assets/icons/trash2.svg style="margin-right: 4px;" alt=icons><span class=ft-600-12-16 translate=Delete></span></button> <button class="btn_new_blue pv-8 pr-12 pl-6 mr-16" ng-click=addMarker()><img src=/assets/icons/add-circle.svg style="margin-right: 4px;" alt=icons><span translate="Add Markings"></span></button> <button class="btn_new_blue pv-8 pl-12 pr-6" ng-click=onContinue()><span translate=Next></span><img src=/assets/icons/arrow-right-white-issue.svg style="margin-left: 4px;" alt=icons></button></div></div><div class=content-wrapper><spinner ng-if=loading></spinner><div class=content><div class=marking-viewer-container><div id=marking-viewer-3d class=marking-viewer ng-show="vm.regData.marker.modelType == \'3d\'"></div><div id=marking-viewer-2d class=marking-viewer></div><div id=loading><img src=/assets/images/cgviewer/cloud_loading.gif alt=""></div></div><div class=tool-button ng-if=is3D><img src=/assets/images/cgviewer/toolbar/cross-add.svg alt="" class=cursor-point ng-click=vm.addCutter() ng-if=!vm.hasCutter()> <img src=/assets/images/cgviewer/toolbar/cross-visible.svg alt="" class=cursor-point ng-click=vm.removeCutter() ng-if=vm.hasCutter()></div></div></div></main></div>');
$templateCache.put('app/main/settings/accessSettings/accessSettings.view.html','<div id=accessSettings><spinner ng-if=loading></spinner><div class=header><div class=ft_18_600_black translate="Access Setting"></div><img ng-if="!isEdit && SETTING_ACCESS_CREATE > 1" src=/assets/icons/edit.svg alt="" class=edit ng-click=onEdit()><div ng-if="SETTING_ACCESS_CREATE > 1 && isEdit" class=flex-items-center><img ng-if="SETTING_ACCESS_CREATE > 1" src=/assets/icons/save-icon-light.svg alt="" class=mr-8 ng-click=onSave()> <img src=/assets/icons/close-gray-circle.svg alt="" ng-click=exitEdit()></div></div><div class="content pos-relative"><div class="d-flex justify-content-between"><div class=content-side-menu><ul><li ng-repeat="(key, menuType) in menuTypes" ng-class="contentMenuIndex == key? \'active\': \'\'" ng-click=selContentMenu(key)><div class=ft_14_600_gray>{{menuType.name}}</div></li></ul></div><div class=w-100><table class=w-100><tbody class=w-100><tr class=header-tr><td class="flex-20 text-center">User Type</td><td class="flex-16 text-center" ng-repeat="accessType in accessTypes">{{accessType}}</td></tr><tr class=item ng-repeat="userType in userTypes"><td class="flex-20 text-center">{{userType.name}}</td><td class="flex-16 flex-center" ng-repeat="accessType in accessTypes"><div class=apply-option><radio ng-disabled=!isEdit ng-model=vm[menuTypes[contentMenuIndex].key][userType.key] ng-value=accessType ng-click="clickedOption(userType.key, accessType)"></radio></div></td></tr></tbody></table><no-data ng-if="loading == false && totalCount==0"></no-data></div></div></div></div>');
$templateCache.put('app/main/settings/billApprovers/billApprovers.view.html','<div id=billApprovers><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate="Bill Approvers"></div><div></div></div><div class="content pos-relative"><div class="d-flex flex-end mb-20" ng-if="SETTING_ACCESS_CREATE > 2"><div><div class="ft_12_600_black mb-8" translate=User></div><selectbox2 class="w-342 arrowbottom_46_400 input-select" ng-model=vm.approver options=vm.managerList label-field=displayName value-field=_id></selectbox2></div><div class=mh-30><div class="ft_12_600_black mb-8" translate="Amount Limit"></div><input class="login_input_new w-342" type=number ng-model=vm.limit></div><button class=btn_new_blue ng-click=addApprover() translate=Add></button></div><div class=w-100><table class=w-100><tbody class=w-100><tr class=header-tr><td class=flex-40 translate="Bill Approvers"></td><td class=flex-40 translate="Amount Limit"></td><td class=flex-10 translate=Edit></td><td class=flex-10 translate=Delete></td></tr><tr class=item ng-repeat="approver in pageItems"><td class=flex-40 style="display: flex;align-items: center;"><div ng-if=approver.approver.profilePic><img ng-src={{approver.approver.profilePic}} alt=icons class="avatar-text mr-10"></div><div ng-if=!approver.approver.profilePic><span class="avatar-text mr-10" ng-style="{ \'background\': (getColor(approver.approver.displayName)) }">{{approver.approver.displayName | mailAvatarChar}}</span></div>{{ approver.approver.displayName }}</td><td class=flex-40>{{ approver.limit }}</td><td class=flex-10><img src=/assets/icons/edit.svg alt="" class=cursor-point ng-click=onEdit(approver) ng-if="SETTING_ACCESS_CREATE > 1"></td><td class=flex-10><img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click=onDelete(approver) ng-if="SETTING_ACCESS_CREATE > 3"></td></tr></tbody></table></div><!-- <div class="flex-center">\n      <pagination num-pages="pageCount" current-page="currentPage" on-select-page="setPage()"></pagination>\n    </div> --><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=pageLimit options=periods label-field=name value-field=id select-event=vm.selectNumPage(pageLimit)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(currentPage - 1) * pageLimit + 1}} - <span ng-if="loading == false">{{(currentPage - 1) * pageLimit + pageItems.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=pageCount current-page=currentPage on-select-page=setPage($event)></pagination-custom-new></div></div></div></div></div>');
$templateCache.put('app/main/settings/calculationSetting/calculationSetting.view.html','<div id=calculationSetting><spinner ng-if=loading></spinner><!-- View --><div ng-if=!isEdit class=header><div class="ft_18_600_black text-uppercase" translate=Calculation></div><img ng-if="SETTING_ACCESS_CREATE > 1 && !isEdit" src=/assets/icons/edit.svg alt="" class=edit ng-click=onEdit()></div><div ng-if=!isEdit class="content pos-relative"><div class="d-flex mb-24 align-items-center justify-content-between"><div class=d-flex><div style="margin-right: 100px;"><h5 class="font-weight-bold mb-8" translate="Average Worker Cost"></h5><div class=ft_14_600_black><span class=mr-2>{{ calculationSetting.averageWorkerCost | readable:2 }}</span> <span>{{vm.companyData.currentCurrency.currencyCode}}</span></div></div><div style="margin-right: 100px;"><h5 class="font-weight-bold mb-8" translate="Operating Costs"></h5><div class=ft_14_600_black>{{ calculationSetting.companyCost }} %</div></div><div><h5 class="font-weight-bold mb-8" translate="Company Profit"></h5><div class=ft_14_600_black>{{ calculationSetting.profit }} %</div></div></div><div><button class="btn btn-primary btn-rebuild" ng-click=rebuildFinanceAggregation()><i class="fa fa-exclamation-triangle mr-1"></i><span translate="Recalc Costs"></span></button></div></div><div class=mb-24><div class="d-flex justify-content-between align-items-center"><h5 class=font-weight-bold translate="Avg. Operating Costs"></h5><selectbox-input class="select-year dropdown-primary" options=years label-field=value value-field=value ng-model=vm.selectedYear select-event=selectYear()></selectbox-input></div><div><table class=table id=opcost-table><thead><tr><th translate=Month></th><th><span translate="Percent per Month"></span> (%)</th><th><span translate="Cost per Month"></span> ({{vm.companyData.currentCurrency.currencyCode}})</th><th><span translate="Revenue per Month"></span> ({{vm.companyData.currentCurrency.currencyCode}})</th></tr></thead><tbody><tr ng-repeat="item in monthlyCosts"><td>{{item.name}}</td><td>{{item.percent|readable:2}}</td><td>{{item.cost|readable:2}}</td><td>{{item.revenue|readable:2}}</td></tr></tbody></table></div></div><div><h5 class="font-weight-bold mb-8" translate="Building Type"></h5><div class=d-flex><div class=building-tag-item ng-repeat="tag in vm.buildingTags">{{tag.tagName}}</div></div></div></div><!-- Edit --><div ng-if=isEdit class=header><div class="ft_18_600_black text-uppercase" translate=Calculation></div><div class=flex-items-center><img ng-if="SETTING_ACCESS_CREATE > 1" src=/assets/icons/save-icon-light.svg alt="" class=mr-8 ng-click=onUpdate()> <img src=/assets/icons/close-gray-circle.svg alt="" ng-click=onCancel()></div></div><div ng-if=isEdit class="content-edit pos-relative"><div class="flex-items-center mb-24"><div class=mr-16><div class="ft_12_600_gray mb-8" translate="Average Worker Cost"></div><div class=avcost-input><input type=number ng-model=calculationSetting.averageWorkerCost><div>{{vm.companyData.currentCurrency.currencyCode}}</div></div></div><div class=mr-16><div class="ft_12_600_gray mb-8" translate="Operating Costs (%)"></div><div class=percent-input><input type=number min=0 max=100 step=0.01 ng-model=calculationSetting.companyCost><div>%</div></div></div><div><div class="ft_12_600_gray mb-8" translate="Company Profit (%)"></div><div class=percent-input><input type=number min=0 max=100 step=0.01 ng-model=calculationSetting.profit><div>%</div></div></div></div><div class="d-flex flex-end mb-8"><div class=mr-16><div class="ft_12_600_gray mb-8" translate="Building Type"></div><input class=input-primary type=text ng-model=vm.tagName></div><button class=button-primary ng-click=onAddBuildingTag() translate="+ Add"></button></div><div class=d-flex><div class="building-tag-item has-delete-icon" ng-repeat="tag in vm.buildingTags">{{tag.tagName}}<img class=delete-icon src=/assets/icons/close-16.svg alt="" ng-click=deleteBuildingTag(tag)></div></div></div><div ng-if=isEdit class=footer><button class="button-primary mr-16" ng-click=onUpdate() translate=Update></button> <button class=btn_cancel ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/main/settings/companyInfo/companyInfo.view.html','<div id=companyInfo><spinner ng-if=loading></spinner><div class=header><div class=ft_18_600_black translate="Company Information"></div><img ng-if="SETTING_ACCESS_CREATE > 1 && !isEdit" src=/assets/icons/edit.svg alt="" class=edit ng-click=onEdit()><div ng-if="SETTING_ACCESS_CREATE > 1 && isEdit" class=flex-items-center><img ng-if="SETTING_ACCESS_CREATE > 1" src=/assets/icons/save-icon-light.svg alt="" class=mr-8 ng-click=onSave()> <img src=/assets/icons/close-gray-circle.svg alt="" ng-click=exitEdit()></div></div><div ng-if=!isEdit class="content pos-relative"><div class="d-flex mb-24"><div class=flex-75><div class="ft_32_600_black mb-24">{{ companyInfo.companyName }}</div><div class=d-flex><div class=flex-33><div class="ft_12_600_gray mb-8" translate=Website></div><div class=ft_14_600_black>{{ companyInfo.companyWebsite }}</div></div><div class=flex-33><div class="ft_12_600_gray mb-8" translate="Contact Number"></div><div class=ft_14_600_black>{{ companyInfo.companyContact.dialCode }}{{ companyInfo.companyContact.phoneNumber }}</div></div><div class=flex-33><div class="ft_12_600_gray mb-8" translate="Email address"></div><div class=ft_14_600_black>{{ companyInfo.email }}</div></div></div></div><div class=flex-25><div class=company-logo><img ng-src="{{companyInfo.companyLogo || \'/assets/images/logo1024.png\'}}"></div></div></div><div class="d-flex mb-24"><div class=flex-25><div class="ft_12_600_gray mb-8" translate="Year Founded"></div><div class=ft_14_600_black>{{ companyInfo.yearFounded }}</div></div><div class=flex-25><div class="ft_12_600_gray mb-8" translate=Industry></div><div class="ft_14_600_black pr-30">{{ companyInfo.industry }}</div></div><div class=flex-25><div class="ft_12_600_gray mb-8" translate=Currency></div><div class=ft_14_600_black>{{ companyInfo.annualRevenue.currencyCode }}</div></div><div class=flex-25><div class="ft_12_600_gray mb-8" translate="Annual Revenue"></div><div class=ft_14_600_black>{{ companyInfo.annualRevenue.value }}</div></div></div><div class=w-100><div class="ft_12_600_gray mb-8" translate=Description></div><div class="ft_14_600_black mb-30">{{ companyInfo.description }}</div></div><div class="w-100 mb-24"><div class="ft_12_600_gray mb-8" translate="Primary Address"></div><div class="ft_14_600_black mb-8" ng-if=companyInfo.address1.line1>{{ companyInfo.address1.line1 }}</div><div class="ft_14_600_black mb-8" ng-if=companyInfo.address1.line2>{{ companyInfo.address1.line2 }}</div><div class=ft_14_600_black ng-if="companyInfo.address1.city || companyInfo.address1.postalCode || companyInfo.address1.countryCode">{{ companyInfo.address1.city }} {{companyInfo.address1.postalCode}} {{ companyInfo.address1.countryCode }}</div></div><div class="w-100 mb-24"><div class="ft_12_600_gray mb-8" translate="Secondary Address"></div><div class="ft_14_600_black mb-8" ng-if=companyInfo.address2.line1>{{ companyInfo.address2.line1 }}</div><div class="ft_14_600_black mb-8" ng-if=companyInfo.address2.line2>{{ companyInfo.address2.line2 }}</div><div class=ft_14_600_black ng-if="companyInfo.address2.city || companyInfo.address2.postalCode || companyInfo.address2.countryCode">{{ companyInfo.address2.city }} {{companyInfo.address2.postalCode}} {{ companyInfo.address2.countryCode }}</div></div><div class="w-100 mb-24"><div class="ft_12_600_gray mb-8" translate=Location></div><div class=ft_14_600_black>{{ companyInfo.locationAddress }}</div></div><div class=google-map><div><div class="gmap_viewer w-100"><div map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params="{{ vm.gmap.url }}"><ng-map center="{{ vm.gmap.center }}" zoom="{{ vm.gmap.zoom }}" id=driving_map><marker ng-repeat="m in vm.gmap.markers" position="{{ m }}" draggable=true on-dragend=vm.updateMarker() icon="{url: \'/assets/images/cgviewer/vp-issue-completed.svg\', scaledSize: [50, 50], origin: [0,0], anchor: [0,0]}"></marker></ng-map></div></div></div></div></div><div ng-if=isEdit class=content><div class=flex><button data-wow-delay=1.3s class="btn-trans mr-30"><img width=256 height=256 class="bdRadius-4 object-fit-cover" ng-src="{{!!companyInfo.companyLogo?companyInfo.companyLogo:\'/assets/images/suppliers/uploadPic.svg\'}}" alt=upload ngf-select ng-model=companyInfo.companyLogoPic ngf-change=onChange($files) name=file aria-invalid=false data-wow-delay=0.7s></button><div><div class="ft_12_600_gray mb-8" translate="Company Name"></div><input type=text class="login_input_new mb-20 w-485" placeholder="{{\'Enter Company Name\' | translate}}" ng-model=companyInfo.companyName><div class=flex-between><div><div class="ft_12_600_gray mb-8" translate=Website></div><input type=text class="login_input_new w-227 mb-20" ng-model=companyInfo.companyWebsite></div><div><div class="ft_12_600_gray mb-8" translate="Email address"></div><input type=text class="login_input_new w-227 mb-20" ng-model=companyInfo.email></div></div><div class="ft_12_600_gray mb-8" translate="Contact Number"></div><div class=flex-between><!-- <selectbox-input class="w-107 mb-20" ng-model="companyInfo.companyContact.dialCode" options="vm.getCountryCode" label-field="dialCode"\n            value-field="dialCode">\n          </selectbox-input> --><div class="dropdown w-107 mb-20"><button class="dropdown-toggle dropdown-w-107" type=button id=menu1 data-toggle=dropdown>{{companyInfo.companyContact.dialCode}}</button><ul class="dropdown-menu dropdown-w-107 dropdown-h-300" role=menu aria-labelledby=menu1><li><a href=# class=menu-item id="{{ currency.dialCode }}" data-ng-click=ClientDialCode($event) ng-repeat="currency in vm.getCountryCode">{{ currency.dialCode }}</a></li><li><a class=menu-item ng-if=!vm.getCountryCode translate="No Data"></a></li></ul></div><input type=text class="w-371 login_input_new mb-20" ng-model=companyInfo.companyContact.phoneNumber></div></div></div><div class="ft_12_600_gray mb-8 mt-30" translate=Description></div><textarea class="login_textArea mb-15" ng-model=companyInfo.description></textarea><div class="flex mt-15"><div class=ft_14_600_black translate="Primary Address"></div><div class=hr></div></div><div class=flex><div class=flex50><div class="ft_12_600_gray mb-8" translate="Address Line 1"></div><input type=text class="login_input_new mb-20 w-371" ng-model=companyInfo.address1.line1><div class="ft_12_600_gray mb-8">City</div><div class="w-371 mb-20"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=companyInfo.address1.city options=vm.categoryList label-field=label value-field=key select-event=vm.onCategory(vm.category)></selectbox-input></div><div class="ft_12_600_gray mb-8" translate="Postal Code"></div><input type=text class="login_input_new mb-20 w-371" ng-model=companyInfo.address1.postalCode></div><div class=flex50><div class="ft_12_600_gray mb-8" translate="Address Line 2"></div><input type=text class="login_input_new mb-20 w-371" ng-model=companyInfo.address1.line2><div class="ft_12_600_gray mb-8" translate=State></div><div class="w-371 mb-20"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=vm.category options=vm.categoryList label-field=label value-field=key select-event=vm.onCategory(vm.category)></selectbox-input></div><div class="ft_12_600_gray mb-8" translate=Country></div><div class="w-371 mb-20"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=companyInfo.address1.countryCode options=vm.getCountryCode label-field=name value-field=code select-event=vm.onCategory(vm.category)></selectbox-input></div></div></div><div class="flex mt-15"><div class=ft_14_600_black translate="Secondary Address"></div><div class=hr></div></div><div class=flex><div class=flex50><div class="ft_12_600_gray mb-8" translate="Address Line 1"></div><input type=text class="login_input_new mb-20 w-371" ng-model=companyInfo.address2.line1><div class="ft_12_600_gray mb-8" translate=City></div><div class="w-371 mb-20"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=companyInfo.address2.city options=vm.categoryList label-field=label value-field=key select-event=vm.onCategory(vm.category)></selectbox-input></div><div class="ft_12_600_gray mb-8" translate="Postal Code"></div><input type=text class="login_input_new mb-20 w-371" ng-model=companyInfo.address2.postalCode></div><div class=flex50><div class="ft_12_600_gray mb-8" translate="Address Line 2"></div><input type=text class="login_input_new mb-20 w-371" ng-model=companyInfo.address2.line2><div class="ft_12_600_gray mb-8" translate=State></div><div class="w-371 mb-20"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=vm.category options=vm.categoryList label-field=label value-field=key select-event=vm.onCategory(vm.category)></selectbox-input></div><div class="ft_12_600_gray mb-8" translate=Country></div><div class="w-371 mb-20"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=companyInfo.address2.countryCode options=vm.getCountryCode label-field=name value-field=code select-event=vm.onCategory(vm.category)></selectbox-input></div></div></div><div class="flex mt-15"><div class=ft_14_600_black translate="Other Information"></div><div class=hr></div></div><div class=flex><div class=flex50><div class="ft_12_600_gray mb-8" translate=Industry></div><div class="w-371 mb-20"><!-- <selectbox-input class="arrowbottom_46_400" ng-model="vm.category" options="vm.getIndustries" label-field="label"\n            value-field="key" select-event="vm.onCategory(vm.category)">\n          </selectbox-input> --><div class=dropdown><button class="dropdown-toggle dropdown-w-371" type=button id=menu1 data-toggle=dropdown ng-bind=companyInfo.industry>Industries</button><ul class="dropdown-menu dropdown-w-371 dropdown-h-300" role=menu aria-labelledby=menu1><li><a href=# class=menu-item id="{{ item.type }}" data-ng-click=ClientIndustry($event) ng-repeat="item in vm.getIndustries">{{ item.type }}</a></li><li><a class=menu-item ng-if=!vm.getIndustries translate="No Data"></a></li></ul></div></div><div class="ft_12_600_gray mb-8" translate=Currency></div><div class="w-371 mb-20"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=companyInfo.annualRevenue.currencyCode options=vm.currencies label-field=cc value-field=cc select-event=vm.onCategory(vm.category)></selectbox-input></div></div><div class=flex50><div class="ft_12_600_gray mb-8" translate="Year Founded"></div><div class="w-371 mb-20"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=vm.category options=vm.categoryList label-field=label value-field=key select-event=vm.onCategory(vm.category)></selectbox-input></div><div class="ft_12_600_gray mb-8" translate="Annual Revenue (in Dollars)"></div><input type=text class="login_input_new mb-20 w-371" ng-model=companyInfo.annualRevenue.value></div></div><div class="ft_12_600_gray mb-8" translate=Location></div><div class=pos-relative><input places-auto-complete types="[\'geocode\']" class="login_input_new w-771 mb-20" on-place-changed=vm.placeMarker() id=location_input_to ng-model=companyInfo.location.position><!-- <input type="text" class="login_input_new w-771 mb-20" ng-model="companyInfo.locationAddress"/> --> <img src=/assets/icons/location.svg alt="" class=location></div><div class=google-map><div><div class="gmap_viewer w-100"><div map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params="{{ vm.gmap.url }}"><ng-map center="{{ vm.gmap.center }}" zoom="{{ vm.gmap.zoom }}" id=driving_map><marker ng-repeat="m in vm.gmap.markers" position="{{ m }}" draggable=true on-dragend=vm.updateMarker() icon="{url: \'/assets/images/cgviewer/vp-issue-completed.svg\', scaledSize: [50, 50], origin: [0,0], anchor: [0,0]}"></marker></ng-map></div></div></div></div></div></div>');
$templateCache.put('app/main/settings/companyRoles/companyRoles.view.html','<div id=companyRoles><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate="Company Roles"></div><div></div></div><div class="content pos-relative"><no-data ng-if="loading == false && totalCount==0"></no-data><div class=company-role ui-tree data-drag-enabled=false><ul ui-tree-nodes="" ng-model=newtree><li ng-repeat="item in newtree" ng-init="target=true" ui-tree-node ng-class="item.empty ? \'empty\' : \'\'" ng-include="\'app/main/settings/companyRoles/role-treeitem.html\'"></li></ul></div></div></div>');
$templateCache.put('app/main/settings/companyRoles/role-treeitem.html','<div ui-tree-handle data-nodrag class=team-tree-node ng-class="item.empty ? \'empty\' : item.diff ? \'\' + item.diff : \'diff-none\'"><div class="tree-content flex-center" ng-click="showLevel(item, target)"><div class=main-content><div><div class=ft_14_600_black>{{item.name}}</div></div></div></div><a ng-if="item.levels && item.levels.length > 0" ng-click=toggle(this) style="margin-right: 10px;"><span ng-if=this.collapsed class=cursor-point>&#9660;</span> <span ng-if=!this.collapsed class=cursor-point>&#9650;</span></a></div><br><ol ui-tree-nodes="" ng-model=item.levels ng-class="{\'angular-ui-tree-hidden\': collapsed}"><li ng-repeat="item in item.levels" ui-tree-node ng-class="item.empty ? \'empty\' : \'\'" ng-include="\'app/main/settings/companyRoles/role-treeitem.html\'"></li></ol>');
$templateCache.put('app/main/settings/economic/economic.view.html','<div id=companyEconomic><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate=Economics></div><div class="d-flex align-items-center"><div class="button-primary mr-16" ng-click=vm.addPlanSection()>+&nbsp;<span translate="Add Section"></span></div><div class=button-secondary ui-sref=externalEconomics translate="Economic Settings"></div></div></div><div class="ph-30 content pos-relative"><div class=section><div class=section-header><span class=ft_14_600_black translate="Account Plan"></span></div><div dnd-list=vm.accountSections><div class="plan-section section-table w-100" ng-repeat="section in vm.accountSections" dnd-draggable=section dnd-effect-allowed=move dnd-moved=vm.movePlanSection($index)><table class=w-100><thead><tr class=title-tr><th class="flex-5 justify-center"><span ng-if=!section.isEdit>{{section.order}}</span> <input type=number class=plan-section-name ng-model=section.order ng-if=section.isEdit></th><th class=flex-30><span ng-if=!section.isEdit>{{section.name}}</span> <span ng-if="!section.isEdit && section.isVatSection" class=pl-4>(Vat Section)</span> <input class=plan-section-name ng-if=section.isEdit ng-model=section.name></th><th class=flex-20><div ng-if=section.isEdit class=flex-items-center><input type=checkbox id=status-{{section._id}} name=status-{{section._id}} ng-model=section.isVatSection class=m-0><div class=ml-2 translate="Is VatSection?"></div></div></th><th class=flex-35></th><th class="flex-10 flex align-items-center"><img src=/assets/icons/bx-edit.svg alt=edit class="ml-auto cursor-point" ng-if=!section.isEdit ng-click=vm.editPlanSection(section)> <img src=/assets/icons/bx-save.svg alt=save class="ml-auto cursor-point" ng-if=section.isEdit ng-click="vm.savePlanSectionOrder(section, $index)"> <img src=/assets/icons/delete-icon.svg alt=delete class="ml-10 cursor-point" ng-click="vm.deletePlanSection($index, section)"></th></tr><tr class=subheader-tr><th class="flex-5 sr-num">#</th><th class=flex-10 translate=Type></th><th class=flex-10 translate=Category></th><th class=flex-20 translate=Name></th><th class=flex-10 translate="VAT %"></th><th class=flex-10 translate="VAT Type"></th><th class=flex-10 translate="TAX %"></th><th class=flex-15 translate="Budget Mapping"></th><th class="flex-10 actions" translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat-start="item in section.items" ng-if=!item.isItemEdit ng-class="{expanded: item.expand}"><td class="flex-5 sr-num">{{item.number}}</td><td class=flex-10>{{item.type}}</td><td class=flex-10>{{item.pCategory === \'Labour\' ? \'Labour management\' : (item.pCategory === \'LabourOnSite\' ? \'Labour on site\' : item.pCategory)}}</td><td class=flex-20>{{item.name}}</td><td class=flex-10>{{item.vat}}</td><td class=flex-10>{{item.vatTypeName}}</td><td class=flex-10>{{item.tax}}</td><td class=flex-15>{{item.budgetMapping}}</td><td class="flex-10 actions"><div><img ng-src="{{\'/assets/icons/\' + (item.expand ? \'chevron-up-gray.svg\' : \'chevron-down-gray.svg\')}}" alt="" class="cursor-point mr-8" ng-click=vm.onExpand(item)> <img src=/assets/icons/edit.svg alt="" class="cursor-point mr-8" ng-click="vm.onEdit(item, \'AccountPlan\')"> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.deleteAccountPlan(section, $index, item)"></div></td></tr><tr class=item ng-if=item.isItemEdit ng-class="{expanded: item.expand}"><td class=flex-5><input type=text numbers-only ng-model=item.number></td><td class=flex-10><selectbox-input class="w-100 plan-type" ng-model=item.type options=vm.accountPlanTypes label-field=label value-field=id></selectbox-input></td><td class=flex-10><selectbox-input class=w-100 ng-model=item.pCategory options=getAccountPlanCategories(item) label-field=label value-field=id></selectbox-input></td><td class=flex-20><input ng-model=item.name></td><td class=flex-10><input type=number ng-model=item.vat></td><td class="flex-10 vat-type"><selectbox-input class=w-100 ng-model=item.vatType options=vm.vatSettings label-field=vatName value-field=_id has-clear=true></selectbox-input></td><td class=flex-10><input type=number ng-model=item.tax></td><td class=flex-15><selectbox-input class=w-100 ng-model=item.budgetMapping options=vm.budgets label-field=name value-field=index></selectbox-input></td><td class="flex-10 actions"><div><img ng-src="{{\'/assets/icons/\' + (item.expand ? \'chevron-up-gray.svg\' : \'chevron-down-gray.svg\')}}" alt="" class="cursor-point mr-8" ng-click=vm.onExpand(item)> <img src=/assets/icons/check-mark.svg alt="" class="cursor-point mr-8" ng-click="vm.saveAccountPlan(section, $index, item)"> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.deleteAccountPlan(section, $index, item)"></div></td></tr><tr class=item-extra ng-repeat-end=item ng-if=item.expand><td class=flex-5></td><td class="flex-95 extras"><div class=extra-row><div class=expand-item><div>Internal Balance</div><div class=expand-item-content>{{item.internalBalance | roundNum: 2}}</div></div><div class=expand-item><div>External Balance</div><div class=expand-item-content>{{item.externalBalance | roundNum: 2}}</div></div><div class=expand-item><div>Difference</div><div class=expand-item-content>{{(item.internalBalance - item.externalBalance) | roundNum: 2}}</div></div><!-- <div class="expand-item">\n                    <div>Value Use</div>\n                    <div class="expand-item-content" ng-if="!item.isItemEdit">\n                      {{getItemValueUse(item)}}\n                    </div>\n                    <selectbox-input ng-if="item.isItemEdit"\n                      class="dropdown-primary mt-10"\n                      ng-model="item.valueUse"\n                      options="vm.valueUseOptions" label-field="type" value-field="id">\n                    </selectbox-input>\n                  </div> --><div class=expand-item><div>Period Setting</div><div class=expand-item-content ng-if=!item.isItemEdit>{{getItemPeriod(item)}}</div><selectbox-input ng-if=item.isItemEdit class="dropdown-primary mt-10" ng-model=item.period options=vm.periodOptions label-field=type value-field=id></selectbox-input></div><div class=expand-item><div>Primo VAT</div><div class=expand-item-content ng-if=!item.isItemEdit>{{getItemPrimoVat(item)}}</div><selectbox-input ng-if=item.isItemEdit class="dropdown-primary mt-10" ng-model=item.isPrimoVat options=vm.primoVatOptions label-field=type value-field=id></selectbox-input></div></div><div class="extra-row mt-20"><div class=expand-item><div>Operation Cost</div><div class=expand-item-content ng-if=!item.isItemEdit>{{item.operationCost}}</div><selectbox-input ng-if=item.isItemEdit class="dropdown-primary mt-10" ng-model=item.operationCost options=vm.activeOptions label-field=name value-field=name></selectbox-input></div><div class=expand-item><div>Use forecast</div><div class=expand-item-content ng-if=!item.isItemEdit>{{item.useForecast}}</div><selectbox-input ng-if=item.isItemEdit class="dropdown-primary mt-10" ng-model=item.useForecast options=vm.activeOptions label-field=name value-field=name></selectbox-input></div><div class=expand-item><div>Forecast</div><div class=expand-item-content>{{getAccountPlanForecast(item) | roundNum: 2}}</div></div><div class=expand-item><div>Show as separate in Balance</div><div class=expand-item-content ng-if=!item.isItemEdit>{{item.showAsSeparate}}</div><selectbox-input ng-if=item.isItemEdit class="dropdown-primary mt-10" ng-model=item.showAsSeparate options=vm.activeOptions label-field=name value-field=name></selectbox-input></div><div class=expand-item><div translate="Work in Progress"></div><div class=expand-item-content ng-if=!item.isItemEdit>{{getItemWip(item)}}<!-- None --></div><selectbox-input ng-if=item.isItemEdit class="dropdown-primary mt-10" ng-model=item.wip options=vm.wipOptions label-field=type value-field=id></selectbox-input></div></div></td></tr></tbody><tfoot><tr class=footer-tr ng-repeat="summary in section.summaries"><th class="flex-5 summary-name"><input ng-model=summary.name></th><th class=flex-50></th><th class=flex-20><div class=summary-value><selectbox class=sum-equation ng-model=summary.equation options=vm.equations label-field=label value-field=id></selectbox><div class=sum-field ng-click=vm.changeSumField(summary)>{{vm.getSummaryFields(summary)}}</div></div></th><th class="flex-15 flex-content-end">{{summary.value | readable: 2}}</th><th class="flex-10 actions"><img src=/assets/icons/check-mark.svg alt=save class="ml-auto cursor-point" ng-click=vm.saveSummary(section)> <img src=/assets/icons/delete1.svg alt="" class="ml-10 cursor-point" ng-click="vm.deleteSummary($index, section)"></th></tr></tfoot></table><div class="flex mt-10" ng-if=section._id><div class=add-new-item ng-click=vm.addNewPlan(section)>+&nbsp;<span translate="Add New Line"></span></div><div class="add-new-item ml-20" ng-click=vm.addSummary(section)>+&nbsp;<span translate="Add Sum Line"></span></div></div></div></div><svg class=dash><line stroke=#747474 x1=0 y1=0 x2=100% y2=0 stroke-dasharray="5 5"/></svg></div><div class=section><div class=section-header><span class=ft_14_600_black translate="Service & VA Order"></span></div><div class="section-table w-100"><table class=w-100><thead><tr class=header-tr><th class="flex-5 sr-num">#</th><th class=flex-25 translate=Type></th><th class=flex-30 translate=Description></th><th class=flex-15 translate="Profit %"></th><th class=flex-15 translate="C.Cost %"></th><th class="flex-10 actions" translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat-start="item in vm.serviceAndVAOrders" ng-if=!item.isItemEdit><td class="flex-5 sr-num">{{item.number}}</td><td class=flex-25>{{item.type}}</td><td class=flex-30>{{item.description}}</td><td class=flex-15>{{item.profit}}</td><td class=flex-15>{{item.cost}}</td><td class="flex-10 actions"><div><img src=/assets/icons/edit.svg alt="" class="cursor-point mr-8" ng-click="vm.onEdit(item, \'ServiceAndVAOrder\')"> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.onDelete($index, item, \'ServiceAndVAOrder\')"></div></td></tr><tr class=item ng-repeat-end=item ng-if=item.isItemEdit><td class=flex-5><input numbers-only ng-model=item.number></td><td class=flex-25><selectbox-input class=w-100 ng-model=item.plan options=vm.accountPlanOptions label-field=name value-field=_id select-event="vm.onSelectType(value, item)"></selectbox-input></td><td class=flex-30><input ng-model=item.description></td><td class=flex-15><input type=number ng-model=item.profit></td><td class=flex-15><input type=number ng-model=item.cost></td><td class="flex-10 actions"><div><img src=/assets/icons/check-mark.svg alt="" class=cursor-point ng-click="vm.onSave($index, item, \'ServiceAndVAOrder\')"> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.onDelete($index, item, \'ServiceAndVAOrder\')"></div></td></tr></tbody></table><div class="add-new-item mt-10" ng-click="vm.addNewItem(\'ServiceAndVAOrder\')">+&nbsp;<span translate="Add New Line"></span></div></div><svg class=dash><line stroke=#747474 x1=0 y1=0 x2=100% y2=0 stroke-dasharray="5 5"/></svg></div><div class=section><div class=section-header><span class=ft_14_600_black translate=Labour></span></div><div class="section-table w-100"><table class=w-100><thead><tr class=header-tr><th class="flex-5 sr-num">#</th><th class=flex-25 translate=Name></th><th class=flex-30 translate=Description></th><th class=flex-30 translate="Sales Price"></th><th class="flex-10 actions" translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat-start="item in vm.labors" ng-if=!item.isItemEdit><td class="flex-5 sr-num">{{item.number}}</td><td class=flex-25>{{item.type}}</td><td class=flex-30>{{item.description}}</td><td class=flex-30>{{item.salesPrice}}</td><td class="flex-10 actions"><div><img src=/assets/icons/edit.svg alt="" class="cursor-point mr-8" ng-click="vm.onEdit(item, \'Labor\')"> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.onDelete($index, item, \'Labor\')"></div></td></tr><tr class=item ng-repeat-end=item ng-if=item.isItemEdit><!-- Edit Part --><td class=flex-5><input type=text numbers-only ng-model=item.number></td><td class=flex-25><selectbox-input class=w-100 ng-model=item.plan options=vm.accountPlanOptions label-field=name value-field=_id select-event="vm.onSelectType(value, item)"></selectbox-input></td><td class=flex-30><input ng-model=item.description></td><td class=flex-30><input type=number ng-model=item.salesPrice></td><td class="flex-10 actions"><div><img src=/assets/icons/check-mark.svg alt="" class=cursor-point ng-click="vm.onSave($index, item, \'Labor\')"> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.onDelete($index, item, \'Labor\')"></div></td></tr></tbody></table><div class="add-new-item mt-10" ng-click="vm.addNewItem(\'Labor\')">+&nbsp;<span translate="Add New Line"></span></div></div><svg class=dash><line stroke=#747474 x1=0 y1=0 x2=100% y2=0 stroke-dasharray="5 5"/></svg></div><div class=section><div class=section-header><span class=ft_14_600_black translate="Service Car"></span></div><div class="section-table w-100"><table class=w-100><thead><tr class=header-tr><th class="flex-5 sr-num">#</th><th class=flex-25 translate=Name></th><th class=flex-30 translate=Description></th><th class=flex-15 translate=Type></th><th class=flex-15 translate=Price></th><th class="flex-10 actions" translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat-start="item in vm.serviceCars" ng-if=!item.isItemEdit><td class="flex-5 sr-num">{{item.number}}</td><td class=flex-25>{{item.type}}</td><td class=flex-30>{{item.description}}</td><td class=flex-15>{{item.unit}}</td><td class=flex-15>{{item.price}}</td><td class="flex-10 actions"><div><img src=/assets/icons/edit.svg alt="" class="cursor-point mr-8" ng-click="vm.onEdit(item, \'ServiceCar\')"> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.onDelete($index, item, \'ServiceCar\')"></div></td></tr><tr class=item ng-repeat-end=item ng-if=item.isItemEdit><!-- Edit Part --><td class=flex-5><input type=text numbers-only ng-model=item.number></td><td class=flex-25><selectbox-input class=w-100 ng-model=item.plan options=vm.accountPlanOptions label-field=name value-field=_id select-event="vm.onSelectType(value, item)"></selectbox-input></td><td class=flex-30><input ng-model=item.description></td><td class="flex-15 unit"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-model=item.unit>{{item.unit}}</button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-repeat="unit in vm.units" ng-click=vm.selectUnit(unit,item)>{{unit.name}}</li></ul></div></td><td class=flex-15><input type=number ng-model=item.price></td><td class="flex-10 actions"><div><img src=/assets/icons/check-mark.svg alt="" class=cursor-point ng-click="vm.onSave($index, item, \'ServiceCar\')"> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.onDelete($index, item, \'ServiceCar\')"></div></td></tr></tbody></table><div class="add-new-item mt-10" ng-click="vm.addNewItem(\'ServiceCar\')">+&nbsp;<span translate="Add New Line"></span></div></div><svg class=dash><line stroke=#747474 x1=0 y1=0 x2=100% y2=0 stroke-dasharray="5 5"/></svg></div><div class=section><div class=section-header><span class=ft_14_600_black translate="Payment Info"></span></div><div class="section-table w-100"><table class=w-100><thead><tr class=header-tr><th class="flex-5 sr-num" translate=Default></th><th class=flex-25 translate="Account Number"></th><th class=flex-30 translate="Bank Name"></th><th class=flex-15 translate="IBAN Number"></th><th class=flex-15 translate="SWIFT/BIC Code"></th><th class="flex-10 actions" translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat="item in vm.paymentAccounts"><td class="flex-5 sr-num"><div class=apply-option><radio ng-model=item.isDefault ng-value=true click-event=clickedPaymentAccount(item)></radio></div></td><td class=flex-25>{{item.accountNumber}}</td><td class=flex-30>{{item.bankName}}</td><td class=flex-15>{{item.IBANNumber}}</td><td class=flex-15>{{item.swiftBicCode}}</td><td class="flex-10 actions"><div><img src=/assets/icons/edit.svg alt="" class="cursor-point mr-8" ng-click="vm.openAddPaymentInfoModal(item, true)"> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.onDeletePayment($index, item)"></div></td></tr></tbody></table><div class="add-new-item mt-10" ng-click=vm.openAddPaymentInfoModal()>+ <span translate="Add New Line"></span></div></div></div><!-- <div class="section-header">\n      <span class="ft_14_600_black" translate="Bill Auto Aggregation"></span>\n      <div class="dash"></div>\n    </div>\n    <div class="section-content">\n      <div class="ft_12_600_gray mb-8" translate="Email ID"></div>\n      <div class="flex-between">\n        <div class="form-item d-flex flex-1 pr-10">\n          <input\n            class="login_input flex"\n            ng-model="vm.category"\n            options="vm.categoryList"\n            label-field="label"\n            value-field="key"\n            select-event="vm.onCategory(vm.category)"\n          />\n        </div>\n        <div class="flex-1">\n          <button class="btn_primary" ng-click="saveBillApprovers()">\n            <img src="/assets/icons/save-icon.svg" alt="" translate="Save">\n          </button>\n        </div>\n      </div>\n    </div> --></div></div>');
$templateCache.put('app/main/settings/employee/employee.view.html','<div id=companyEmployee><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate=Employees></div><div><img src=/assets/icons/save-icon-light.svg alt="" class="cursor-point ml-8" ng-click=createNewPreset() ng-if=isCreating> <img src=/assets/icons/save-icon-light.svg alt="" class="cursor-point ml-8" ng-click=updatePreset(vm.preset._id) ng-if=isEditing> <img src=/assets/icons/close-gray-circle.svg alt="" class="cursor-point ml-8" ng-click=cancel() ng-if="isCreating || isEditing"></div></div><div class="content pos-relative" ng-if="!isCreating && !isEditing"><div class="ft_12_regular_gray mb-8">Types of Employee Presets</div><div class=preset-list><div class="preset-item ph-10 flex-between" ng-repeat="preset in vm.presets"><span class="ft_14_600_black name">{{preset.presetName}}</span><div class=d-flex><button class="btn-trans padding-0" ng-click=onEditEmployeeSetting(preset._id) ng-if="SETTING_ACCESS_CREATE > 1"><img src=/assets/icons/bxs-edit.svg alt=icons class=ml-8></button> <button class="btn-trans padding-0" ng-click=deleteEmployeeSetting(preset._id) ng-if="SETTING_ACCESS_CREATE > 3"><img src=/assets/icons/trash-alt-black.svg alt=icons class=ml-8></button></div></div></div><button class=btn_new_blue ng-click=createEmployeeSetting() ng-if="SETTING_ACCESS_CREATE > 2"><img src=/assets/icons/bxs-plus-circle-f.svg alt=icons class=mr-10><span translate="Create New"></span></button></div><div class="content pos-relative" ng-if="isCreating || isEditing"><div class=section-content><div class="w-100 flex mb-24"><div class="section-field-item flex-50"><div class="ft_12_600_gray mb-8" translate="Preset Name"></div><input class="login_input_new w-100" ng-model=vm.preset.presetName></div><div class="section-field-item flex-50"><div class="ft_12_600_gray mb-8" translate="Type of Employee"></div><selectbox-input class="w-100 input-select" ng-model=vm.preset.systemTagId options=vm.typeList label-field=tagName value-field=_id></selectbox-input></div></div><div class="w-100 flex mb-24"><div class="flex width50 pr-10"><div class="section-field-item width50"><div class="ft_12_600_gray mb-8" translate="Salary Duration"></div><selectbox-input class="w-100 input-select" ng-model=vm.preset.salaryDuration options=vm.salaryDurationsList label-field=label value-field=key></selectbox-input></div><div class="section-field-item width50"><div class="ft_12_600_gray mb-8" translate="Paid By"></div><selectbox-input class="w-100 input-select" ng-model=vm.preset.paidBy options=vm.paidByList label-field=label value-field=key></selectbox-input></div></div><div class="flex50 width50"><div class="section-field-item width50"><div class="ft_12_600_gray mb-8" translate="Schedule of Payment"></div><selectbox-input class="w-100 input-select" ng-model=vm.preset.paymentSchedule options=vm.paymentSchedulesList label-field=label value-field=key></selectbox-input></div></div></div><div class="w-100 flex mb-24 pay-block"><div class="pay-item flex-10"><div class="ft_12_600_gray mb-8" translate="Holiday Pay"></div><div class=pay-item-content><input type=number class=pay-input ng-model=vm.preset.holidayPay><div class=pay-percent>%</div></div></div><div class="pay-item flex-15 ml-10"><div class="ft_12_600_gray mb-8" translate="Account Number"></div><div class=pay-item-content><input type=text class=pay-input ng-model=vm.preset.companyPensionAccount><div class="pay-percent fw-semibold">No</div></div></div><div class="pay-item flex-10 ml-10"><div class="ft_12_600_gray mb-8" translate="Company Pension"></div><div class=pay-item-content><input type=number class=pay-input ng-model=vm.preset.companyPension><div class=pay-percent>%</div></div></div><div class="pay-item flex-15 ml-10"><div class="ft_12_600_gray mb-8" translate="Account Number"></div><div class=pay-item-content><input type=text class=pay-input ng-model=vm.preset.employeePensionAccount><div class="pay-percent fw-semibold">No</div></div></div><div class="pay-item flex-15 ml-10"><div class="ft_12_600_gray mb-8" translate="Employee Paid Pension"></div><div class=pay-item-content><input type=number class=pay-input ng-model=vm.preset.employeePaidPension><div class=pay-percent>%</div></div></div><div class="pay-item flex-15 ml-10"><div class="ft_12_600_gray mb-8 ml-10" translate="Account Number"></div><div class=pay-item-content><input type=text class=pay-input ng-model=vm.preset.holidayAccount><div class="pay-percent fw-semibold">No</div></div></div><div class="pay-item flex-15 ml-10"><div class="ft_12_600_gray mb-8" translate="Paid Holidays"></div><div class=pay-item-content><selectbox-input class="w-100 input-select mt-0" ng-model=vm.preset.paidHolidays options=vm.paidHolidaysList label-field=label value-field=key></selectbox-input></div></div></div><div class=section-header><span class="ft_14_600_black text-uppercase" translate="Working Time"></span><div class=dash></div></div><div class="section-table w-100 mb-24"><table class=w-100><thead><tr class=header-tr><th class=flex-5 translate=Number></th><th class=flex-13 translate=Day></th><th class=flex-25 translate=Description></th><th class=flex-8 translate=Start></th><th class=flex-8 translate=Stop></th><th class=flex-10 translate="Daily Hours"></th><th class=flex-23 translate=Overtime></th><th class=flex-8 translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat="item in vm.preset.workingTimes track by $index"><th class=flex-5 ng-if=!item.isItemEdit>{{item.number}}</th><td class=flex-13 ng-if=!item.isItemEdit>{{item.day}}</td><td class="flex-25 text-ellipsis" ng-if=!item.isItemEdit title={{item.description}}>{{item.description}}</td><td class=flex-8 ng-if=!item.isItemEdit>{{item.start}}</td><td class=flex-8 ng-if=!item.isItemEdit>{{item.stop}}</td><td class="flex-10 text-center" ng-if=!item.isItemEdit>{{item.dailyHours | readable: 2}}</td><td class="flex-23 text-ellipsis" ng-if=!item.isItemEdit title={{item.overTime}}>{{item.overTime}}</td><!-- Edit Part --><td class=flex-5 ng-if=item.isItemEdit><input type=text numbers-only ng-model=item.number></td><td class=flex-13 ng-if=item.isItemEdit><selectbox-input class=input-select ng-model=item.day options=vm.weekdays label-field=name value-field=name></selectbox-input></td><td class=flex-25 ng-if=item.isItemEdit><input ng-model=item.description></td><td class=flex-8 ng-if=item.isItemEdit><time-picker ng-model=item.start></time-picker></td><td class=flex-8 ng-if=item.isItemEdit><time-picker ng-model=item.stop></time-picker></td><td class=flex-10 ng-if="item.isItemEdit && vm.companyData.companyInputMethod==\'British/American et al.\'"><input type=number ng-model=item.dailyHours></td><td class=flex-10 ng-if="item.isItemEdit && vm.companyData.companyInputMethod==\'European et al.\'"><input type=text ng-model=item.dailyHours comma-format-number></td><td class=flex-23 ng-if=item.isItemEdit><overtime-edit ng-model=item.overTime></overtime-edit><!--              <input ng-model="item.overTime"/>--></td><td class=flex-8><div><img src=/assets/icons/edit.svg alt="" class=cursor-point ng-click="vm.onEdit(item, \'WorkingTime\')" ng-if=!item.isItemEdit> <img src=/assets/icons/check-mark.svg alt="" class=cursor-point ng-click="vm.onSave(item, \'WorkingTime\')" ng-if=item.isItemEdit> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.preset.workingTimes.splice($index, 1)"></div></td></tr></tbody></table><div class="d-inline-block ft_14_600_blue cursor-point mt-10" ng-click="vm.addNewItem(\'WorkingTime\')">+ <span translate="Add New Line"></span></div></div><div class=section-header><span class="ft_14_600_black text-uppercase" translate="Additional Cost"></span><div class=dash></div></div><div class="section-table w-100 mb-24"><table class=w-100><thead><tr class=header-tr><th class=flex-10 translate=Number></th><th class=flex-20 translate=Type></th><th class=flex-30 translate=Description></th><th class=flex-15 translate=Unit></th><th class=flex-15 translate=Cost></th><th class=flex-10 translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat="item in vm.preset.additionalCosts track by $index"><th class=flex-10 ng-if=!item.isItemEdit>{{item.number}}</th><td class=flex-20 ng-if=!item.isItemEdit>{{item.costType}}</td><td class="flex-30 text-ellipsis" ng-if=!item.isItemEdit title={{item.description}}>{{item.description}}</td><td class=flex-15 ng-if=!item.isItemEdit>{{item.unit}}</td><td class="flex-15 text-ellipsis" ng-if=!item.isItemEdit>{{item.cost | readable: 2}}</td><!-- Edit Part --><td class=flex-10 ng-if=item.isItemEdit><input type=text numbers-only ng-model=item.number></td><td class=flex-20 ng-if=item.isItemEdit><input ng-model=item.costType></td><td class=flex-30 ng-if=item.isItemEdit><input ng-model=item.description></td><td class=flex-15 ng-if=item.isItemEdit><selectbox options=vm.additionalCostUnits label-field=value value-field=value ng-model=item.unit></selectbox></td><td class=flex-15 ng-if=item.isItemEdit><input type=text ng-model=item.cost number-edit=2></td><td class=flex-10><div><img src=/assets/icons/edit.svg alt="" class=cursor-point ng-click=vm.onEdit(item) ng-if=!item.isItemEdit> <img src=/assets/icons/check-mark.svg alt="" class=cursor-point ng-click="vm.onSave(item, \'AdditionalCost\')" ng-if=item.isItemEdit> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.preset.additionalCosts.splice($index, 1)"></div></td></tr></tbody></table><div class="d-inline-block ft_14_600_blue cursor-point mt-10" ng-click="vm.addNewItem(\'AdditionalCost\')">+ <span translate="Add New Line"></span></div></div><div class=section-header><span class="ft_14_600_black text-uppercase">Driving Cost</span><div class=dash></div></div><div class="section-table w-100 mb-24"><table class=w-100><thead><tr class=header-tr><th class=flex-10 translate=Number></th><th class=flex-15 translate=Type></th><th class=flex-25 translate=Description></th><th class=flex-10 translate=From></th><th class=flex-10 translate=To></th><th class=flex-10 translate=Unit></th><th class=flex-10 translate=Cost></th><th class=flex-10 translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat="item in vm.preset.drivingCosts track by $index"><th class=flex-10 ng-if=!item.isItemEdit>{{item.number}}</th><td class=flex-15 ng-if=!item.isItemEdit>{{item.costType}}</td><td class="flex-25 text-ellipsis" ng-if=!item.isItemEdit title={{item.description}}>{{item.description}}</td><td class=flex-10 ng-if=!item.isItemEdit>{{item.from | readable: 2}}</td><td class=flex-10 ng-if=!item.isItemEdit>{{item.to | readable: 2}}</td><td class=flex-10 ng-if=!item.isItemEdit>{{item.unit}}</td><td class="flex-10 text-ellipsis" ng-if=!item.isItemEdit>{{item.cost | readable: 2}}</td><!-- Edit Part --><td class=flex-10 ng-if=item.isItemEdit><input type=text numbers-only ng-model=item.number></td><td class=flex-15 ng-if=item.isItemEdit><input ng-model=item.costType></td><td class=flex-25 ng-if=item.isItemEdit><input ng-model=item.description></td><td class=flex-10 ng-if=item.isItemEdit><input ng-model=item.from number-edit=2></td><td class=flex-10 ng-if=item.isItemEdit><input ng-model=item.to number-edit=2></td><td class=flex-10 ng-if=item.isItemEdit><selectbox options=vm.drivingCostUnits label-field=value value-field=value ng-model=item.unit></selectbox></td><td class=flex-10 ng-if=item.isItemEdit><input type=text ng-model=item.cost number-edit=2></td><td class=flex-10><div><img src=/assets/icons/edit.svg alt="" class=cursor-point ng-click=vm.onEdit(item) ng-if=!item.isItemEdit> <img src=/assets/icons/check-mark.svg alt="" class=cursor-point ng-click="vm.onSave(item, \'DrivingCost\')" ng-if=item.isItemEdit> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.preset.drivingCosts.splice($index, 1)"></div></td></tr></tbody></table><div class="d-inline-block ft_14_600_blue cursor-point mt-10" ng-click="vm.addNewItem(\'DrivingCost\')">+ <span translate="Add New Line"></span></div></div><div class=section-header><span class="ft_14_600_black text-uppercase" translate="Task Bonus"></span><div class=dash></div></div><div class="section-table w-100 mb-24"><table class=w-100><thead><tr class=header-tr><th class=flex-10 translate=Number></th><th class=flex-15 translate=Name></th><th class=flex-50 translate=Description></th><th class=flex-15 translate="Sales Price"></th><th class=flex-10 translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat="item in vm.preset.taskBonus track by $index"><th class=flex-10 ng-if=!item.isItemEdit>{{item.number}}</th><td class="flex-15 text-ellipsis" ng-if=!item.isItemEdit title={{item.name}}>{{item.name}}</td><td class="flex-50 text-ellipsis" ng-if=!item.isItemEdit title={{item.description}}>{{item.description}}</td><td class="flex-15 text-ellipsis" ng-if=!item.isItemEdit>{{item.salesPrice | readable: 2}}</td><!-- Edit Part --><td class=flex-10 ng-if=item.isItemEdit><input type=text numbers-only ng-model=item.number></td><td class=flex-15 ng-if=item.isItemEdit><input ng-model=item.name></td><td class=flex-50 ng-if=item.isItemEdit><input ng-model=item.description></td><td class=flex-15 ng-if=item.isItemEdit><input ng-model=item.salesPrice number-edit=2></td><td class=flex-10><div><img src=/assets/icons/edit.svg alt="" class=cursor-point ng-click=vm.onEdit(item) ng-if=!item.isItemEdit> <img src=/assets/icons/check-mark.svg alt="" class=cursor-point ng-click="vm.onSave(item, \'TaskBonus\')" ng-if=item.isItemEdit> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.preset.taskBonus.splice($index, 1)"></div></td></tr></tbody></table><div class="d-inline-block ft_14_600_blue cursor-point mt-10" ng-click="vm.addNewItem(\'TaskBonus\')">+ <span translate="Add New Line"></span></div></div><div class=section-header><span class="ft_14_600_black text-uppercase" translate="Other Type Cost"></span><div class=dash></div></div><div class="section-table w-100 mb-24"><table class=w-100><thead><tr class=header-tr><th class=flex-10 translate=Number></th><th class=flex-20 translate=Type></th><th class=flex-30 translate=Description></th><th class=flex-15 translate=Unit></th><th class=flex-15 translate=Cost></th><th class=flex-10 translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat="item in vm.preset.otherTypeCosts track by $index"><th class=flex-10 ng-if=!item.isItemEdit>{{item.number}}</th><td class=flex-20 ng-if=!item.isItemEdit>{{item.costType}}</td><td class="flex-30 text-ellipsis" ng-if=!item.isItemEdit title={{item.description}}>{{item.description}}</td><td class=flex-15 ng-if=!item.isItemEdit>{{item.unit}}</td><td class="flex-15 text-ellipsis" ng-if=!item.isItemEdit>{{item.cost | readable: 2}}</td><!-- Edit Part --><td class=flex-10 ng-if=item.isItemEdit><input type=text numbers-only ng-model=item.number></td><td class=flex-20 ng-if=item.isItemEdit><input ng-model=item.costType></td><td class=flex-30 ng-if=item.isItemEdit><input ng-model=item.description></td><td class=flex-15 ng-if=item.isItemEdit><selectbox options=vm.otherCostUnits label-field=value value-field=value ng-model=item.unit></selectbox></td><td class=flex-15 ng-if=item.isItemEdit><input type=text ng-model=item.cost number-edit=2></td><td class=flex-10><div><img src=/assets/icons/edit.svg alt="" class=cursor-point ng-click=vm.onEdit(item) ng-if=!item.isItemEdit> <img src=/assets/icons/check-mark.svg alt="" class=cursor-point ng-click="vm.onSave(item, \'OtherTypeCost\')" ng-if=item.isItemEdit> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.preset.otherTypeCosts.splice($index, 1)"></div></td></tr></tbody></table><div class="d-inline-block ft_14_600_blue cursor-point mt-10" ng-click="vm.addNewItem(\'OtherTypeCost\')">+ <span translate="Add New Line"></span></div></div><div class=section-header><span class="ft_14_600_black text-uppercase" translate="Check Box App"></span><div class=dash></div></div><div class="section-table w-100 mb-24"><table class=w-100><thead><tr class=header-tr><th class=flex-10 translate=Number></th><th class=flex-20 translate=Type></th><th class=flex-30 translate=Description></th><th class=flex-15 translate=Unit></th><th class=flex-15 translate=Cost></th><th class=flex-10 translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat="item in vm.preset.checkBoxApps track by $index"><th class=flex-10 ng-if=!item.isItemEdit>{{item.number}}</th><td class=flex-20 ng-if=!item.isItemEdit>{{item.costType}}</td><td class="flex-30 text-ellipsis" ng-if=!item.isItemEdit title={{item.description}}>{{item.description}}</td><td class=flex-15 ng-if=!item.isItemEdit>{{item.unit}}</td><td class="flex-15 text-ellipsis" ng-if=!item.isItemEdit>{{item.cost | readable: 2}}</td><!-- Edit Part --><td class=flex-10 ng-if=item.isItemEdit><input type=text numbers-only ng-model=item.number></td><td class=flex-20 ng-if=item.isItemEdit><input ng-model=item.costType></td><td class=flex-30 ng-if=item.isItemEdit><input ng-model=item.description></td><td class=flex-15 ng-if=item.isItemEdit><selectbox options=vm.otherCostUnits label-field=value value-field=value ng-model=item.unit></selectbox></td><td class=flex-15 ng-if=item.isItemEdit><input ng-model=item.cost number-edit=2></td><td class=flex-10><div><img src=/assets/icons/edit.svg alt="" class=cursor-point ng-click=vm.onEdit(item) ng-if=!item.isItemEdit> <img src=/assets/icons/check-mark.svg alt="" class=cursor-point ng-click="vm.onSave(item, \'CheckBoxApp\')" ng-if=item.isItemEdit> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.preset.checkBoxApps.splice($index, 1)"></div></td></tr></tbody></table><div class="d-inline-block ft_14_600_blue cursor-point mt-10" ng-click="vm.addNewItem(\'CheckBoxApp\')">+ <span translate="Add New Line"></span></div></div><div class=flex-center><button class=btn_cancel ng-click=cancel() translate=Discard></button> <button class="btn_new_blue ml-16" ng-click=createNewPreset() ng-if=isCreating translate=Create></button> <button class="btn_new_blue ml-16" ng-click=updatePreset(vm.preset._id) ng-if=isEditing translate=Update></button></div></div></div></div>');
$templateCache.put('app/main/settings/entityKeys/entityKeys.view.html','<div id=entityKeys><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate="Entity Keys"></div></div><div class=table-body><table class=pos-relative><thead><tr><th class=order>#</th><th class=type translate=Type></th><th class=current-tag translate="Current Tag"></th><th class=actions translate=Actions></th></tr></thead><tbody><tr ng-repeat="t in vm.allTags"><td class=order>{{ vm.allTags.length - $index }}</td><td class=type>{{ t.name }}</td><td class=current-tag>{{ t.currentTag }}</td><td class=actions ng-click=editEntity(t)><img class="cursor-point mr-2" src=/assets/icons/edit.svg alt="" ng-if="SETTING_ACCESS_CREATE > 1"><!-- <img class="cursor-point ml-2" src="/assets/icons/fm_delete_outline.svg" alt="" ng-if="SETTING_ACCESS_CREATE > 1"> --></td></tr></tbody></table></div></div>');
$templateCache.put('app/main/settings/externalEconomic/externalEconomic.view.html','<div id=externalEconomic><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate="Economic & Integration"></div><div class=d-flex><div class="btn-trans mr-15" ui-sref=integrationLogs><img class=mr-10 src=/assets/icons/setting-log.svg alt=""><span translate="Intergration Logs"></span></div><div class=btn-trans ui-sref=settingEconomics><img class=mr-10 src=/assets/icons/settings-black.svg alt=""><span translate="Economics Settings"></span></div></div></div><div class="ph-30 content pos-relative pt-0"><div class=section><div class=section-header><span class=section-title translate="Financial Period"></span><div class=dash></div></div></div><div class=fields><div class=field-normal><div class=field-label translate="Financial year - Start"></div><div class="field-content input-group datePicker"><input class=input-primary type=text date-picker=dd/MM/yyyy date=vm.fromAccountDate is-open=isToOpen ng-required=true><div class=dateArrow ng-click="isFromOpen = !isFromOpen"><img src=/assets/icons/date-calendar.svg alt=""></div></div></div><div class="field-normal ml-20"><div class=field-label translate="Financial year - End"></div><div class="field-content input-group datePicker"><input class=input-primary type=text date-picker=dd/MM/yyyy date=vm.toAccountDate is-open=isToOpen ng-required=true><div class=dateArrow ng-click="isToOpen = !isToOpen"><img src=/assets/icons/date-calendar.svg alt=""></div></div></div><div class="field-normal ml-20"><div class=field-label translate="VAT - Period"></div><selectbox-input class="field-content dropdown-primary" options=vm.vatPeriodOptions ng-model=vm.vatPeriod label-field=label value-field=value></selectbox-input></div><div class="btn_new_blue w-fit-content px-4 ml-20 mt-28" ng-click=vm.saveAccountDate() translate=Save></div></div><div class=section><div class=section-header><span class=section-title translate="Financial Period for Account Plans"></span><div class=dash></div></div><div class=section-content><span class="ft_14_600_blue cursor-point d-block mb-3" translate="+ Add New Period" ng-click=addBalancePeriod()></span><div class="section-table w-100"><table class=w-100><thead><tr class=header-tr><th class=flex-10 translate=Default></th><th class=flex-20 translate=Year></th><th class=flex-20 translate="Start Date"></th><th class=flex-20 translate="End Date"></th><th class=flex-10 translate="Primo Vat"></th><th class=flex-20 translate=Actions></th></tr></thead><tbody><tr class=item ng-repeat="period in vm.balancePeriodList"><td class=flex-10><radio ng-if=period._id ng-model=vm.defaultPeriodId ng-click=onUpdateDefaultPeriod(period._id) ng-value=period._id></radio></td><td class=flex-20 ng-if=!period.editing>{{ period.year }}</td><td class=flex-20 ng-if=!period.editing>{{ period.start | date: "dd/MM/yyyy" : \'UTC\' }}</td><td class=flex-20 ng-if=!period.editing>{{ period.end | date: "dd/MM/yyyy" : \'UTC\' }}</td><td class=flex-20 ng-if=period.editing><div class=field-content><input type=text ng-model=period.year></div></td><td class=flex-20 ng-if=period.editing><div class="field-content input-group datePicker"><input class=input-primary type=text date-picker=dd/MM/yyyy date=period.start><div class=dateArrow ng-click="isPeriodFromOpen = !isPeriodFromOpen"><img src=/assets/icons/date-calendar.svg alt=""></div></div></td><td class=flex-20 ng-if=period.editing><div class="field-content input-group datePicker"><input class=input-primary type=text date-picker=dd/MM/yyyy date=period.end><div class=dateArrow ng-click="isPeriodToOpen = !isPeriodToOpen"><img src=/assets/icons/date-calendar.svg alt=""></div></div></td><td class=flex-10 ng-if=!period.editing><input type=checkbox ng-model=period.primoVat class=m-0 disabled></td><td class=flex-10 ng-if=period.editing><input type=checkbox ng-model=period.primoVat class=m-0></td><td class=flex-20><img src=/assets/icons/edit.svg alt="" class=cursor-point ng-click="period.editing = true" ng-if=!period.editing> <img src=/assets/icons/check-mark.svg alt="" class=cursor-point ng-click=onSaveBalancePeriod(period) ng-if=period.editing> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click=onDeleteBalancePeriod(period) ng-if=!period.editing> <img src=/assets/icons/lock_2.svg alt="" class=cursor-point ng-click=onUnlockPeriod(period) ng-if="period._id && period.locked"> <img src=/assets/icons/lock_2_opened.svg alt="" class=cursor-point ng-click=onLockPeriod(period) ng-if="period._id && !period.locked"></td></tr></tbody></table></div></div></div><div class=section><div class=section-header><span class=section-title translate="Extern Economic Integration"></span><div class=dash></div></div><div class=section-content><div class=fields><div class=field-normal><div class=field-label translate="Economic Type"></div><selectbox-input class=field-content ng-model=vm.externalCredential.systemType options=vm.economicTypeOptions label-field=name value-field=id></selectbox-input></div><button class="btn_new_blue w-fit-content px-4 ml-20 mt-28" ng-click=vm.saveExternalCredential() translate=Save></button></div><div class="fields mt-24"><div class=field-normal><div class=field-label translate=Username></div><div class=field-content><input type=text ng-model=vm.externalCredential.credentials.userName></div></div><div class="field-normal ml-20"><div class=field-label translate=Password></div><div class=field-content><input type=text ng-model=vm.externalCredential.credentials.password></div></div><div class="field-normal ml-20"><div class=field-label translate=Active></div><selectbox-input class=field-content options=vm.activeOptions ng-model=vm.externalCredential.credentials.isActive label-field=label value-field=value></selectbox-input></div></div><div class="fields mt-24"><div class=field-normal><div class=field-label>API URL</div><div class=field-content><input type=text ng-model=vm.externalCredential.credentials.apiUrl></div></div><div class="field-normal ml-20"><div class=field-label>DOMAIN</div><div class=field-content><input type=text ng-model=vm.externalCredential.credentials.domain></div></div><div class="field-normal ml-20"><div class=field-label>API ID</div><div class=field-content><input type=text ng-model=vm.externalCredential.credentials.apiId></div></div><div class="field-normal ml-20"><div class=field-label>API KEY</div><div class=field-content><input type=text ng-model=vm.externalCredential.credentials.apiKey></div></div></div></div></div><div class=section><div class=section-header><span class=section-title translate="Type Mapping"></span><div class=dash></div></div><div class=section-content><div class=fields><div class=field-normal><div class=field-label>Invocing</div><selectbox-input class=field-content ng-model=vm.externalCredential.typeMapping.invoicing options=vm.typeMappingOptions label-field=name value-field=value></selectbox-input></div><div class="field-normal ml-20"><div class=field-label>Bills</div><selectbox-input class=field-content ng-model=vm.externalCredential.typeMapping.bills options=vm.typeMappingOptions label-field=name value-field=value></selectbox-input></div><div class="field-normal ml-20"><div class=field-label>Resource</div><selectbox-input class=field-content ng-model=vm.externalCredential.typeMapping.resource options=vm.typeMappingOptions label-field=name value-field=value></selectbox-input></div><div class="field-normal ml-20"><div class=field-label>Materials & Equipment</div><selectbox-input class=field-content ng-model=vm.externalCredential.typeMapping.matEq options=vm.typeMappingOptions label-field=name value-field=value></selectbox-input></div></div></div></div><div class=section><div class=section-header><span class=section-title translate="Payment Status Sync"></span><div class=dash></div></div><div class=section-content><div class=fields><div class=field-large><div class="d-flex mb-8"><div class=field-label>Invoicing</div><img src=/assets/icons/clock-history.svg width=18 class="cursor-point ml-10" alt="" ng-click=vm.showInvoiceLogs()></div><div class=d-flex><selectbox-input class=field-content ng-model=vm.externalCredential.naviExport.invoiceSyncFrequency options=vm.syncOptions label-field=name value-field=value></selectbox-input><button class="btn_new_blue w-fit-content px-4 ml-20" ng-click=vm.syncInvoice()>Sync</button></div><div class="d-flex align-items-center mt-8"><span class=sync-status ng-class="{\'job-enabled\': vm.externalCredential.naviExport.isInvSyncJobEnabled}">{{vm.externalCredential.naviExport.isInvSyncJobEnabled ? \'Enabled\' : \'Disabled\'}} </span><span class="ml-10 sync-schedule" ng-if=vm.externalCredential.naviExport.isInvSyncJobEnabled>Next Scheduled: {{vm.externalCredential.naviExport.invSyncNextInvocation | smartDateTime}}</span></div></div><div class="field-large ml-20"><div class="d-flex mb-8"><div class=field-label>Billing</div><img src=/assets/icons/clock-history.svg width=18 class="cursor-point ml-10" alt="" ng-click=vm.showBillingLogs()></div><div class=d-flex><selectbox-input class=field-content ng-model=vm.externalCredential.naviExport.billingSyncFrquency options=vm.syncOptions label-field=name value-field=value></selectbox-input><button class="btn_new_blue w-fit-content px-4 ml-20" ng-click=vm.syncBilling()>Sync</button></div><div class="d-flex align-items-center mt-8"><span class=sync-status ng-class="{\'job-enabled\': vm.externalCredential.naviExport.isBillSyncJobEnabled}">{{vm.externalCredential.naviExport.isBillSyncJobEnabled ? \'Enabled\' : \'Disabled\'}} </span><span class="ml-10 sync-schedule" ng-if=vm.externalCredential.naviExport.isBillSyncJobEnabled>Next Scheduled: {{vm.externalCredential.naviExport.billSyncNextInvocation | smartDateTime}}</span></div></div></div></div></div><div class=section><div class=section-header><span class=section-title translate="Payment Terms"></span><div class=dash></div><span class="ft_14_600_yellow cursor-point" ng-click="vm.addNewItem(\'ServiceCar\')" ng-if=vm.isEdit translate="+ Add New"></span></div><div class=section-content><div class=fields><div class=field-normal><div class=field-label translate="Payment Code"></div><div class=field-content><selectbox-input class=arrowbottom_46_400 ng-model=paymentCodeId options=vm.paymentTerms label-field=code value-field=_id select-event=vm.selectPaymentCode(value) to-top=true></selectbox-input></div></div><div class="field-normal ml-20"><div class=field-label translate="Payment Description"></div><div class=field-content><input type=text ng-model=externCode></div></div><button class="btn_new_blue w-fit-content px-5 ml-20 mt-28" ng-click="addExternCode(paymentCodeId, externCode)">Add</button></div><div class="fields mt-20"><div><div class=field-label>Payment Codes</div><div class="d-flex flex-wrap"><span class="payment-code-item ft_12_600_gray mr-4 px-3 py-2" ng-repeat="item in vm.externalCredential.paymentTerms">{{item.cesCode}} -> {{item.externCode}} <img class="cursor-point ml-3" src=/assets/icons/close-24.svg ng-click=removeExternCode(item)></span></div></div></div></div></div><div class=section><div class=section-header><span class=section-title translate="Data Filtering"></span><div class=dash></div><span class="ft_14_600_blue cursor-point" ng-click=vm.exportAccountNetChange() translate="+ Export Accounts Net Change"></span></div><div class="section-table w-100"><table class=w-100><thead><tr class=header-tr><th class=flex-40 translate="Sr No"></th><th class=flex-20 translate="Project Type"></th><th class=flex-30 translate="Date of Filtering"></th><th class=flex-10 translate=Actions></th></tr></thead><tbody class=w-100><tr class=item ng-repeat="item in vm.serviceCars"><th class=flex-40 ng-if=!item.isItemEdit>{{item.number}}</th><td class=flex-20 ng-if=!item.isItemEdit>{{item.projectType}}</td><td class=flex-30 ng-if=!item.isItemEdit>{{item.dateOfFiltering}}</td><!-- Edit Part --><td class=flex-40 ng-if=item.isItemEdit><input ng-model=item.number></td><td class=flex-20 ng-if=item.isItemEdit><selectbox-input ng-model=item.projectType options=vm.accountPlanOptions label-field=type value-field=_id select-event="vm.onSelectType(value, item)"></selectbox-input></td><td class=flex-30 ng-if=item.isItemEdit><input ng-model=item.dateOfFiltering></td><td class=flex-10><div ng-if=vm.isEdit><img src=/assets/icons/edit.svg alt="" class=cursor-point ng-click="vm.onEdit(item, \'ServiceCar\')" ng-if=!item.isItemEdit> <img src=/assets/icons/check-mark.svg alt="" class=cursor-point ng-click="vm.onSave(item, \'ServiceCar\')" ng-if=item.isItemEdit> <img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click="vm.onDelete(item, \'ServiceCar\')" ng-if=!item.isItemEdit></div></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/main/settings/integrationLogs/integrationLogs.view.html','<div id=integration-logs><div class=header><div class=ft_18_600_black translate="Integration Logs"></div><div class=d-flex><div class="btn-trans mr-15" ui-sref=externalEconomics><img class=mr-10 src=/assets/icons/device-hub.svg alt=""><span translate="Economic Integration"></span></div><div class=btn-trans ui-sref=settingEconomics><img class=mr-10 src=/assets/icons/settings-black.svg alt=""><span translate="Economics Settings"></span></div></div></div><div class=content><div class=table-content ng-show="totalCount !=0"><div class="thead ft_14_600_white bg-dark-grey"><div class="td number">Sr.No.</div><div class="td date">Date Time</div><div class="td type">Type</div><div class="td entity-ref">Entity Ref</div><div class="td id">ID</div><div class="td description">Description</div><div class="td method">Method</div><div class="td status">Status</div></div><div class="tbody ft_14_regular_black"><div class=tr ng-repeat="log in vm.logs track by $index"><div class="td number">{{ $index + (vm.currentPage - 1) * 10 + 1 }}</div><div class="td date">{{ log.createdAt | date : \'short\' }}</div><div class="td type" title={{log.systemType}}>{{ log.systemType }}</div><div class="td entity-ref" title={{log.entityRef}}>{{ log.entityRef }}</div><div class="td id" title={{log._id}}>{{ log._id }}</div><div class="td description" title={{log.remarks}}>{{ log.remarks }}</div><div class="td method" title={{log.apiMethod}}>{{ log.apiMethod }}</div><div class="td status">{{ log.isSuccess ? \'Success\' : \'Failure\' }}</div></div></div></div><div><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.logs.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.nextPage()></pagination-custom-new></div></div><!-- <pagination num-pages="noOfPages" current-page="vm.currentPage" on-select-page="vm.nextPage()"></pagination> --></div></div><spinner ng-if=isLoading></spinner></div>');
$templateCache.put('app/main/settings/manageSettings/manageSettings.view.html','<div id=manageSettings><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate=Managers></div><div></div></div><div class="content pos-relative"><div class=w-100><table class=w-100><tbody class=w-100><tr class=header-tr><td class=flex-5>#</td><td class=flex-30 translate=Name></td><td class=flex-15 translate=Department></td><td class=flex-15 translate=Designation></td><td class=flex-15 translate=Dashboard></td><td class=flex-10 translate=Edit></td><td class=flex-10 translate=Delete></td></tr><tr class=item ng-repeat="manager in vm.allManagers track by $index"><td class=flex-5>{{(currentPage - 1) * numPerPage + $index+1}}</td><td class=flex-30 style="display: flex;align-items: center;"><div ng-if=manager.profilePic><img ng-src={{manager.profilePic}} alt=icons class="avatar-32 mr-10 object-fit-cover"></div><div ng-if=!manager.profilePic><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(manager.displayName)) }">{{manager.displayName | mailAvatarChar}}</span></div></td><td class=flex-15>{{manager.department}}</td><td class=flex-15>{{manager.subDesignation}}</td><td class=flex-15>{{getDashboardType(manager.dashboard)}}</td><td class=flex-10><img src=/assets/icons/edit.svg alt="" class=cursor-point ng-click=editManager(manager) ng-if="SETTING_ACCESS_CREATE > 1"></td><td class=flex-10><img src=/assets/icons/delete1.svg alt="" class=cursor-point ng-click=deleteManager(manager._id) ng-if="SETTING_ACCESS_CREATE > 3"></td></tr></tbody></table><no-data ng-if="loading == false && totalCount==0"></no-data></div><!-- <div class="flex-center" ng-if="totalCount>0">\n      <pagination num-pages="noOfPages" current-page="vm.currentPage" on-select-page="vm.getManagers()"></pagination>\n    </div> --><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="loading == false">{{(vm.currentPage - 1) * numPerPage + vm.allManagers.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.getManagers()></pagination-custom-new></div></div></div></div></div>');
$templateCache.put('app/main/settings/paymentTerms/paymentTerms.view.html','<div id=paymentTerms><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate="Payment Terms"></div><!-- <img ng-if="SETTING_ACCESS_CREATE > 1" src="/assets/icons/save-icon-light.svg" alt="" ng-click="onSave()"/> --><div></div></div><div class="content pos-relative"><div class="d-flex flex-end mb-20" ng-if="SETTING_ACCESS_CREATE > 2"><div class=mr-4><div class="ft_12_600_gray mb-8" translate="Payment Code"></div><div class="pos-relative w-197"><input type=text class="login_input_new w-100" ng-model=paymentItem.code><!-- <div class="alarm" ng-mouseenter="options=true" ng-mouseleave="options=false">\n            <img src="/assets/icons/alarm.svg" alt=""/>\n          </div> --></div></div><div class="flex-1 mr-4"><div class="ft_12_600_gray mb-8" translate="Payment Description"></div><input type=text class="w-100 login_input_new" ng-model=paymentItem.description><!-- <div ng-if="options" class="detail">\n          <img src="/assets/icons/arrow-up.svg" alt=""/>\n          <div class="arrow-up ft_14_regular_gray">\n            <div class="mb-10">Payment Code</div>\n            <div class="mb-10">30D\t30 days</div>\n            <div class="mb-10">2W\t2 weeks</div>\n            <div class="mb-10">CM+10D\tCurrent month plus 10 days</div>\n            <div class="mb-10">CM+1M\tCurrent month plus one month</div>\n            <div class="mb-10">CQ+1M+20D\tCurrent quarter plus one month plus 20 days</div>\n            <div class="mb-10">CW+1W\tCurrent week plus one week</div>\n            <div>D15\tOn the 15th of each month</div>\n          </div>\n        </div> --></div><button class="btn_new_blue w-107" ng-click=addPaymentTerm() translate=Add></button></div><div><div class="ft_12_regular_gray mb-8" translate="Payment Codes"></div><div class=name-list><div class=name-item ng-repeat="paymentTerm in vm.paymentConditions"><span>{{paymentTerm.code}}</span> <button class="btn-trans padding-0"><img src=/assets/icons/close.svg alt=icons ng-click=removePaymentItem(paymentTerm) class=ml-10></button></div></div></div></div></div>');
$templateCache.put('app/main/settings/segments/segments.view.html','<div id=segments><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate=Segments></div><div class=d-flex><button class="btn_new_blue mr-8" ng-click=addDepartment() ng-if="SETTING_ACCESS_CREATE > 2">+&nbsp;<span translate="Add Department"></span></button><div class="tool-btn mr-8"><img src=/assets/icons/cached_g.svg alt=icons class=tool-btn-icon ng-click=fetchDepartments()></div><div class=tool-btn ng-if="SETTING_ACCESS_CREATE > 2"><img src=/assets/icons/trash_g.svg alt=icons class=tool-btn-icon ng-click=deleteDepartments()></div></div></div><div class="content pos-relative"><div class=content-body><table ng-if="totalCount != 0"><thead><tr><th class=checkbox-cell><checkbox ng-model=selectedAll ng-click=selectAll(selectedAll) class=no-border></checkbox></th><th class=description translate=Description></th><th class=code translate=Code></th><th class=updated-at translate="Updated At"></th><th class=updated-by translate="Updated By"></th><th class=actions translate=Actions></th></tr></thead><tbody><tr ng-repeat="department in departments track by $index"><td class=checkbox-cell><checkbox ng-model=department.selected ng-click=selectDepartment()></checkbox></td><td class=description>{{department.description}}</td><td class=code>{{department.code}}</td><td class=updated-at>{{department.updatedAt | date: \'dd/MM/yyyy, HH:mm\' : \'UTC\'}}</td><td class=updated-by>{{department.updatedBy.displayName}}</td><td class=actions><img src=assets/icons/edit.svg alt=edit ng-click="editDepartment(department, $index)"> <img src=assets/icons/delete1.svg alt=edit ng-click="deleteDepartment(department._id, $index)"></td></tr></tbody></table><div class=no-segments ng-if="totalCount == 0">No data to display</div></div><!-- <div class="footer" ng-if="totalCount != 0">\n      <pagination num-pages="noOfPages" current-page="vm.currentPage" on-select-page="fetchDepartments()">\n      </pagination>\n    </div> --><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="loading == false">{{(vm.currentPage - 1) * numPerPage + departments.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchDepartments()></pagination-custom-new></div></div></div></div></div>');
$templateCache.put('app/main/settings/settingCtrlPlan/settingCtrlPlan.view.html','<div id=settingCtrlPlan><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate="Control Plan"></div><img ng-if="SETTING_ACCESS_CREATE > 1" src=/assets/icons/save-icon-light.svg alt="" ng-click=onSave()></div><div class="content pos-relative"><div class=mb-24 ng-if="SETTING_ACCESS_CREATE > 2"><div class="ft_12_600_black mb-8" translate="Control Plan Name"></div><div class="d-flex flex-end"><input class="login_input_new w-342" type=text ng-model=newPlanName><button class="btn_new_blue ml-8" ng-click=addCtrlPlan() translate=Add></button></div></div><div class=table-wrapper><table class=w-100><thead><tr><th class=number>#</th><th class=name translate="Control Plan Name"></th><th class=on-off translate="Switch ON/OFF"></th><th class=actions translate=Actions></th></tr></thead><tbody><tr ng-repeat="plancol in vm.companyControlPlans track by $index"><td class=number>{{$index + 1}}</td><td class=name ng-if=!plancol.isEdit>{{plancol.name}}</td><td class="name edit" ng-if=plancol.isEdit><input class="login_input_new mt-0" type=text ng-model=plancol.name></td><td class=on-off><span class="switch switch-sm"><input type=checkbox class=switch id=statusValue{{$index}} ng-model=plancol.visibility ng-disabled=!plancol.isEdit> <label for=statusValue{{$index}}></label></span></td><td class=actions><img src=/assets/icons/edit.svg alt=edit ng-if="!plancol.isEdit && SETTING_ACCESS_CREATE > 1" ng-click=vm.controlPlanItemEdit(plancol)> <img src=/assets/icons/check-mark.svg alt="edit complete" ng-if=plancol.isEdit ng-click=vm.completeEdit(plancol)> <img src=/assets/icons/delete1.svg alt=delete ng-if="SETTING_ACCESS_CREATE > 3" ng-click=deleteItem($index)></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/main/settings/settingsGeneral/settingsGeneral.view.html','<div id=settingsGeneral><spinner ng-if=loading></spinner><!--  View --><div ng-if=!isEdit class=header><div class="ft_18_600_black text-uppercase" translate="General Settings"></div><img ng-if="SETTING_ACCESS_CREATE > 1 && !isEdit" class=edit src=/assets/icons/edit.svg alt="" ng-click=editSetting()></div><div ng-if=!isEdit class="content pos-relative"><div class="ft_12_600_gray mb-8" translate="Company Currency"></div><div class="ft_14_600_black mb-30">{{settingGeneral.chosenCompanyCurrency.label}}</div><div class="ft_12_600_gray mb-8" translate=Language></div><div class="ft_14_600_black mb-30">{{settingGeneral.chosenLanguage.label}}</div><div class="ft_12_600_gray mb-8" translate="Input Method"></div><div class="ft_14_600_black mb-30">{{settingGeneral.chosenInputMethod}}</div><div class="ft_12_600_gray mb-8" translate="Input Method Drawing"></div><div class="ft_14_600_black mb-30">{{settingGeneral.chosenInputMethod}}</div><div class="ft_12_600_gray mb-8" translate="Time Show Method"></div><div class="ft_14_600_black mb-30">{{settingGeneral.timeShowMethod}}</div><div class="flex-items-center form-group"><span class="switch switch-sm"><input type=checkbox class=switch id=statusSMS ng-model=settingGeneral.smsEnabled ng-disabled=true> <label for=statusSMS class=margin-0></label></span><div class="ft_14_600_black ml-20" translate="SMS Notifications"></div></div><div class="flex-items-center form-group"><span class="switch switch-sm"><input type=checkbox class=switch id=statusEmail ng-model=settingGeneral.emailEnabled ng-disabled=true> <label for=statusEmail class=margin-0></label></span><div class="ft_14_600_black ml-20" translate="Email Notifications"></div></div></div><!--  Edit --><div ng-if=isEdit class=header><div class="ft_18_600_black text-uppercase" translate="General Settings"></div><div class=flex-items-center><img ng-if="SETTING_ACCESS_CREATE > 1" src=/assets/icons/save-icon-light.svg alt="" class=mr-8 ng-click=onSave()> <img src=/assets/icons/close-gray-circle.svg alt="" ng-click=exitEdit()></div></div><div ng-if=isEdit class="content pos-relative"><spinner ng-if=loading></spinner><div class="ft_12_600_gray mb-8" translate="Company Currency"></div><div class="w-370 mb-20"><selectbox-input class="arrowbottom_46_400 dropdown-primary" ng-model=settingGeneral.chosenCompanyCurrency.cc options=vm.currenciesList label-field=label value-field=cc></selectbox-input></div><div class="ft_12_600_gray mb-8" translate=Language></div><div class="w-370 mb-20"><selectbox-input class="arrowbottom_46_400 dropdown-primary" ng-model=settingGeneral.chosenLanguage.key options=vm.languages label-field=label value-field=key></selectbox-input></div><div class="ft_12_600_gray mb-8" translate="Input Method"></div><div class="w-370 mb-20"><selectbox-input class="arrowbottom_46_400 dropdown-primary" ng-model=settingGeneral.chosenInputMethod options=vm.inputMethods label-field=label value-field=key></selectbox-input></div><div class="ft_12_600_gray mb-8" translate="Input Method Drawing"></div><div class="w-370 mb-20"><selectbox-input class="arrowbottom_46_400 dropdown-primary" ng-model=settingGeneral.chosenInputMethod options=vm.inputMethods label-field=label value-field=key></selectbox-input></div><div class="ft_12_600_gray mb-8" translate="Time Show Method"></div><div class="w-370 mb-20"><selectbox-input class=dropdown-primary ng-model=settingGeneral.timeShowMethod options=vm.timeShowMethods label-field=label value-field=value></selectbox-input></div><div class="flex-items-center form-group"><span class="switch switch-sm"><input type=checkbox class=switch id=statusValue ng-model=settingGeneral.smsEnabled> <label for=statusValue class=margin-0></label></span><div class="ft_14_600_black ml-20" translate="SMS Notifications"></div></div><div class="flex-items-center form-group"><span class="switch switch-sm"><input type=checkbox class=switch id=statusValue1 ng-model=settingGeneral.emailEnabled> <label for=statusValue1 class=margin-0></label></span><div class="ft_14_600_black ml-20" translate="Email Notifications"></div></div><div ng-if=isEdit class=footer><button class=button-primary ng-click=onSave() translate=Save></button></div></div></div>');
$templateCache.put('app/main/settings/systemTags/systemTags.view.html','<div id=systemTags><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate="System Tags"></div><div></div></div><div class="content pos-relative"><div class="flex-end mb-40" ng-show="SETTING_ACCESS_CREATE > 2"><div class=mr-24><div class="ft_12_600_gray mb-8" translate="Tag Category"></div><selectbox-input class="w-342 input-select" ng-model=categoryName label-field=categoryName value-field=categoryName options=categoryList select-event=vm.selectedCategory()></selectbox-input></div><div class="d-flex mr-24"><div><div class="ft_12_600_gray mb-8" translate="Tag Name"></div><input class=login_input_new type=text ng-class="isLevelCategory? \'half\': \'\'" ng-model=tagName></div><div ng-show=isLevelCategory class=ml-24><div class="ft_12_600_gray mb-8" translate="Tag Value"></div><input class=login_input_new type=text number-edit class=half ng-model=tagValue></div></div><button class=btn_new_blue ng-click=vm.createTag() translate=Add></button></div><div class=mb-24><div class="flex-items-center ft_12_regular_gray mb-8" translate="Material Group Type"></div><div class=tag-list><div class="tag-item ft_14_600_gray mb-8" ng-repeat="matGroup in vm.allMaterialGroups"><div class=flex-items-center><div ng-if=!matGroup.isEditMode>{{matGroup.name}}</div><input type=text class=edit-tagName ng-model=matGroup.tmpName ng-if=matGroup.isEditMode autofocus> <img ng-if=!matGroup.isEditMode src=/assets/icons/edit.svg alt=icons class=ml-2 ng-click="matGroup.isEditMode = true"> <img ng-if=matGroup.isEditMode src=/assets/icons/check-mark.svg alt=icons class=ml-2 ng-click=vm.updateMaterialGroup(matGroup)> <img ng-if=matGroup.isEditMode src=/assets/icons/close-gray-circle.svg alt=icons class=ml-2 ng-click=vm.cancelEditMatGroup(matGroup)> <img ng-if="SETTING_ACCESS_CREATE > 1" src=/assets/icons/delete3.svg alt=icons ng-click=vm.deleteMaterialGroup(matGroup._id) style="width: 16px;height: 16px;"></div></div></div></div><div class=mb-24><div class="ft_12_regular_gray mb-8" translate="Equipment Group Type"></div><div class=tag-list><div class="tag-item ft_14_600_gray mb-8" ng-repeat="equGroup in vm.allEquipmentGroups"><div class=flex-items-center><div ng-if=!equGroup.isEditMode>{{equGroup.name}}</div><input type=text class=edit-tagName ng-model=equGroup.tmpName ng-if=equGroup.isEditMode autofocus> <img ng-if=!equGroup.isEditMode src=/assets/icons/edit.svg alt=icons class=ml-2 ng-click="equGroup.isEditMode = true"> <img ng-if=equGroup.isEditMode src=/assets/icons/check-mark.svg alt=icons class=ml-2 ng-click=vm.updateEquipmentGroup(equGroup)> <img ng-if=equGroup.isEditMode src=/assets/icons/close-gray-circle.svg alt=icons class=ml-2 ng-click=vm.cancelEditEquGroup(equGroup)> <img src=/assets/icons/delete3.svg alt=icons ng-click=vm.deleteEquipmentGroup(equGroup._id) ng-if="SETTING_ACCESS_CREATE > 1" style="width: 16px;height: 16px;"></div></div></div></div><div ng-repeat="category in categoryList | filter: {categoryName: \'!Material Group\'} | filter: {categoryName: \'!Equipment Group\'}" class=mb-24><div class="flex-items-center ft_12_regular_gray mb-8"><div>{{category.categoryName}} Type</div><img class="category-control-img ml-2" src=/assets/icons/edit.svg alt=icons ng-show=vm.isWritableCategory(category) ng-click=vm.editCategory(category) ng-if="SETTING_ACCESS_CREATE > 1"> <img class=category-control-img src=/assets/icons/delete1.svg alt=icons ng-show=vm.isWritableCategory(category) ng-click=vm.deleteCategory(category) ng-if="SETTING_ACCESS_CREATE > 1"></div><div class=tag-list><div class="tag-item ft_14_600_gray mb-8" ng-repeat="systemTag in vm.allSystemTags" ng-if="systemTag.categoryId == category._id"><div class=flex-items-center><div ng-if=!systemTag.isEditMode>{{systemTag.tagName}}</div><input type=text class=edit-tagName ng-model=systemTag.tmpTagName ng-if=systemTag.isEditMode autofocus> <img ng-if=!systemTag.isEditMode src=/assets/icons/edit.svg alt=icons class=ml-2 ng-click="systemTag.isEditMode = true"> <img ng-if=systemTag.isEditMode src=/assets/icons/check-mark.svg alt=icons class=ml-2 ng-click=vm.updateSystemTag(systemTag)> <img ng-if=systemTag.isEditMode src=/assets/icons/close-gray-circle.svg alt=icons class=ml-2 ng-click=vm.cancelEditSystemTag(systemTag)> <img src=/assets/icons/delete3.svg alt=icons ng-click=vm.deleteSystemTag(systemTag) ng-if="SETTING_ACCESS_CREATE > 1" style="width: 16px; height: 16px;"></div></div></div></div></div></div>');
$templateCache.put('app/main/settings/warehouses/warehouses.view.html','<div id=warehouses><spinner ng-if=loading></spinner><div class=header><div class="ft_18_600_black text-uppercase" translate=Warehouses></div></div><div class="content pos-relative"><div class="flex-between mb-24" ng-if="SETTING_ACCESS_CREATE > 2"><div><div class="ft_12_600_black mb-8" translate="Warehouse Name"></div><input type=text class="warehouse-input login_input_new" ng-model=warehouse.name placeholder="Warehouse Name"></div><div class=mh-24><div class="ft_12_600_black mb-8" translate="Contact Person"></div><input type=text class="warehouse-input login_input_new" ng-model=warehouse.contactPerson placeholder="Contact Person Name"></div><div><div class="ft_12_600_black mb-8" translate="Contact No."></div><input type=text class="warehouse-input login_input_new" ng-model=warehouse.contactNumber placeholder="Phone Number"></div></div><div class="flex-end mb-24"><div class="w-100 mr-24"><div class="ft_12_600_black mb-8" translate=Address></div><input type=text class="warehouse-input w-100 login_input_new" ng-model=warehouse.address placeholder=Address></div><button class=btn_new_blue ng-click=addWarehouse() translate=Add></button></div><table class=w-100><thead><tr><th class=number>#</th><th class=name translate=Name></th><th class=address translate=Address></th><th class=contact-name translate="Contact Person"></th><th class=contact-phone translate="Contact No."></th><th class=actions translate=Actions></th></tr></thead><tbody><tr ng-repeat="warehouse in vm.warehouses track by $index"><td class=number>{{$index + 1}}</td><td class=name>{{warehouse.name}}</td><td class=address>{{warehouse.address}}</td><td class=contact-name>{{warehouse.contactPerson}}</td><td class=contact-phone>{{warehouse.contactNumber}}</td><td class=actions><img src=/assets/icons/edit.svg alt=edit ng-click="editWarehouse(warehouse, $index)"> <img src=/assets/icons/delete1.svg alt=edit ng-click="deleteWarehouse(warehouse, $index)"></td></tr></tbody></table></div></div>');
$templateCache.put('app/main/subContractors/subContractorsAdd/subContractorsAdd.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=subContractorsAdd class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=subContractorsGrid translate="Sub Contractors"></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Add Sub Contractor"></a> --></div><div class=ft_24_600_black1 translate="Add Sub Contractor"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click=addSubContractor()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=addSubContractor()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=subContractorsGrid><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="SUB CONTRACTOR DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{ !!FILEIMG ? FILEIMG : \'/assets/images/suppliers/upload.png\' }}" alt=upload ngf-select ng-model=picFile name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class=items><div class="ft_14_600_moreblack required" translate="Sub Contractor Name"></div><input type=text ng-model=SubContractorData.name id=firstName class="login_input address" placeholder="{{\'Sub Contractor Name\' | translate}}" autocomplete=off></div><div class="flex-between items"><div class=flex-50><div class="ft_14_600_moreblack required" translate="Email ID"></div><input autocomplete=off type=email placeholder="{{\'Invoice Email ID\' | translate}}" class="login_input mail" ng-model=SubContractorData.email></div><div class=flex-48><div class="ft_14_600_moreblack required" translate="Contact No."></div><div class=flex><div class=w-147 ng-if=vm.countryCodes><selectbox-input class=input-select ng-model=SubContractorData.contact.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number placeholder="{{\'Phone Number\' | translate}}" class="login_input phone" ng-model=SubContractorData.contact.phoneNumber></div></div></div><div class=items><div class="ft_14_600_moreblack required" translate=Address></div><input autocomplete=off type=text id=address ng-model=SubContractorData.address.line1 class="login_input address" placeholder="{{\'Include a place or address\' | translate}}"></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate=TYPES></span><div class="content flex-wrap flex mt-16"><div class="flex-end flex-between w-100 input-items"><div class=flex-22><div class=ft_14_600_moreblack translate="Work Type"></div><selectbox-input class=input-select ng-model=workType options=vm.allWorkTypes label-field=tagName value-field=_id></selectbox-input></div><div><button class=btn_new_blue ng-click=addWorkType()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div ng-repeat="(key, item) in workTypes"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind=item.tagName></div></div><div class="pos-absolute-1-0 flex-items-center"><button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click=deleteWorkType(key)></button></div></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate="STAFF MEMBERS"></span><div class="content flex-wrap flex mt-16"><div class="flex-end flex-between w-100 input-items"><div class=flex-22><div class=ft_14_600_moreblack translate="First Name"></div><input autocomplete=off type=text class="login_input name" placeholder="{{\'First Name\' | translate}}" ng-model=staff.firstName></div><div class=flex-22><div class=ft_14_600_moreblack translate="Last Name"></div><input autocomplete=off type=text class="login_input name" placeholder="{{\'Last Name\' | translate}}" ng-model=staff.lastName></div><div class=flex-22><div class=ft_14_600_moreblack translate="Email ID"></div><input autocomplete=off type=email class="login_input email" placeholder="{{\'Email ID\' | translate}}" ng-model=staff.email></div><div class=flex-22><div class=ft_14_600_moreblack translate="Contact No."></div><div class=flex><div class="w-147 mr-15"><selectbox-input class=input-select ng-model=staff.mobile.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number class="login_input number" placeholder="{{\'Phone Number\' | translate}}" ng-model=staff.mobile.phoneNumber></div></div><div><button class=btn_new_blue ng-click=addStaff(staff)><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div ng-repeat="_staff in staffList track by $index"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind="_staff.firstName + \' \' + _staff.lastName"></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind=_staff.email></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind="\'(\'+_staff.mobile.dialCode + \') \' + _staff.mobile.phoneNumber"></div></div><div class="pos-absolute-1-0 flex-items-center"><button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click=removeStaff($index)></button></div></div></div></div></div></div><div class=profile-card><span class=label translate="BANK DETAILS"></span><div class="bank flex-between flex-wrap mt-16"><div class=flex-32><div class=ft_14_600_moreblack translate="Account Holder Name"></div><input autocomplete=off type=text class=login_input ng-model=accountHolderName></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Account Number"></div><input autocomplete=off type=text class=login_input ng-model=accountNumber></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Name"></div><input autocomplete=off type=text class=login_input ng-model=bankName></div><div class=flex-100><div class=ft_14_600_moreblack translate="Bank Address"></div><input autocomplete=off type=text class=login_input ng-model=bankAddress></div><div class=flex-32><div class=ft_14_600_moreblack translate="IBAN Number"></div><input autocomplete=off type=text class=login_input ng-model=IBAN></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Sort Code"></div><input autocomplete=off type=text class=login_input ng-model=sortCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Routing Number"></div><input autocomplete=off type=text class=login_input ng-model=routingNo></div><div class=flex-32><div class=ft_14_600_moreblack translate="SWIFT/BIC Code"></div><input autocomplete=off type=text class=login_input ng-model=bicCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="IFSC Number"></div><input autocomplete=off type=text class=login_input ng-model=ifscCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Routing Code"></div><input autocomplete=off type=text class=login_input ng-model=routingCode></div></div></div><div class=profile-card><span class=label translate="TERMS & CONDITIONS"></span><div class="terms flex-between flex-wrap mt-16"><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT in %"></div><input autocomplete=off type=number class="login_input w-100" ng-model=SubContractorData.paymentTerms.vatPercent></div><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT Registration No."></div><input autocomplete=off type=number class="login_input w-100" ng-model=SubContractorData.paymentTerms.vatNumber></div><div class=flex-36><div class="ft_14_600_moreblack required" translate="Payment Terms"></div><div class=w-100><selectbox-input class=input-select ng-model=SubContractorData.paymentTerms.paymentSetting options=paymentConditions label-field=code value-field=_id></selectbox-input></div></div></div><div class="btnGroup flex mt-32"><button class="btn_new_blue mr-16" ng-click=addSubContractor()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=addSubContractor()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=clientsGrid><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/subContractors/subContractorsDetail/subContractorsDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=subContractorsDetail class=main-container><spinner ng-show=isLoading></spinner><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=subContractorsGrid translate="Sub Contractors"></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Sub Contractor Details"></a> --></div><div class=ft_24_600_black1 translate="Sub Contractor Details"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ui-sref="subContractorsEdit({id: subContractorData._id})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=onDelete()><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=subContractorsGrid><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="SUB CONTRACTOR DETAILS"></span><div class="flex mt-16"><!-- upload photo --><div class=img-container data-wow-delay=1.3s><img width=264 height=264 class="bdRadius-4 object-fit-cover" ng-src="{{ FILEIMG ? FILEIMG : !!subContractorData.profilePic ? subContractorData.profilePic : \'/assets/images/suppliers/upload.svg\' }}"></div><div class="w-100 flex-wrap"><div class=items><div class=ft_14_regular_gray2 translate="Sub Contractor Name"></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=subContractorData.name></div></div><div class="flex-between items"><div class=flex-50><div class=ft_14_regular_gray2 translate="Email ID"></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=subContractorData.email></div></div><div class=flex-48><div class=ft_14_regular_gray2 translate="Contact No."></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind="\'+\'+subContractorData.contact.dialCode + \' \' + subContractorData.contact.phoneNumber"></div></div></div><div class=items><div class=ft_14_regular_gray2 translate=Address></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=vm.utils.getAddressString(subContractorData.address)></div></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate=TYPES></span><div class="content flex-wrap flex mt-16"><div ng-repeat="(key, item) in types"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind=item></div></div></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate="STAFF MEMBERS"></span><div class="content flex-wrap flex mt-16"><div ng-repeat="_staff in subContractorData.staffs"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind="_staff.firstName + \' \' + _staff.lastName"></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind=_staff.email></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind="\'(\'+_staff.mobile.dialCode + \') \' + _staff.mobile.phoneNumber"></div></div></div></div></div></div></div><div class=profile-card><span class=label translate="BANK DETAILS"></span><div class="bank flex-between flex-wrap mt-16"><div class=flex-32><div class=ft_14_regular_gray2 translate="Account Holder Name"></div><input autocomplete=off type=text disabled class=login_input ng-model=accountHolderName></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Account Number"></div><input autocomplete=off type=text disabled class=login_input ng-model=accountNumber></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Name"></div><input autocomplete=off type=text disabled class=login_input ng-model=bankName></div><div class=flex-100><div class=ft_14_regular_gray2 translate="Bank Address"></div><input autocomplete=off type=text disabled class=login_input ng-model=bankAddress></div><div class=flex-32><div class=ft_14_regular_gray2 translate="IBAN Number"></div><input autocomplete=off type=text disabled class=login_input ng-model=IBAN></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Sort Code"></div><input autocomplete=off type=text disabled class=login_input ng-model=sortCode></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Routing Number"></div><input autocomplete=off type=text disabled class=login_input ng-model=routingNo></div><div class=flex-32><div class=ft_14_regular_gray2 translate="SWIFT/BIC Code"></div><input autocomplete=off type=text disabled class=login_input ng-model=bicCode></div><div class=flex-32><div class=ft_14_regular_gray2 translate="IFSC Number"></div><input autocomplete=off type=text disabled class=login_input ng-model=ifscCode></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Routing Code"></div><input autocomplete=off type=text disabled class=login_input ng-model=routingCode></div></div></div><div class=profile-card><span class=label translate="TERMS & CONDITIONS"></span><div class="terms flex-between flex-wrap mt-24"><div class=flex-30><div class=ft_14_regular_gray2 translate=Amount></div><input autocomplete=off type=number disabled class="login_input w-100" ng-model=terms.vatPercent></div><div class=flex-30><div class=ft_14_regular_gray2 ng-bind="\'VAT (\' + terms.vatPercent + \'%)\'"></div><input autocomplete=off type=number disabled class="login_input w-100" ng-model=terms.vatPercent></div><div class=flex-30><div class=ft_14_regular_gray2 translate=Amount></div><input autocomplete=off type=number disabled class="login_input w-100" ng-model=terms.vatPercent></div></div></div></div></div></main>');
$templateCache.put('app/main/subContractors/subContractorsEdit/subContractorsEdit.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=subContractorsEdit class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=subContractorsGrid translate="Sub Contractors"></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Edit Sub Contractor"></a> --></div><div class=ft_24_600_black1 translate="Edit Sub Contractor"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ng-click="updateSubContractor(paymentVat, bank, picFile)"><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click="updateSubContractor(paymentVat, bank, picFile)"><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref="subContractorsDetail({id: SubContractorData._id})"><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="SUB CONTRACTOR DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{ !!FILEIMG ? FILEIMG : \'/assets/images/suppliers/upload.png\' }}" alt=upload ngf-select ng-model=picFile name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class=items><div class="ft_14_600_moreblack required" translate="Sub Contractor Name"></div><input type=text ng-model=SubContractorData.name id=firstName class="login_input address" placeholder="{{\'Sub Contractor Name\' | translate}}" autocomplete=off></div><div class="flex-between items"><div class=flex-50><div class="ft_14_600_moreblack required" translate="Email ID"></div><input autocomplete=off type=email placeholder="{{\'Invoice Email ID\' | translate}}" class="login_input mail" ng-model=SubContractorData.email></div><div class=flex-48><div class="ft_14_600_moreblack required" translate="Contact No."></div><div class=flex><div class=w-147 ng-if=vm.countryCodes><selectbox-input class=input-select ng-model=SubContractorData.contact.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number placeholder="{{\'Phone Number\' | translate}}" class="login_input phone" ng-model=SubContractorData.contact.phoneNumber></div></div></div><div class=items><div class="ft_14_600_moreblack required" translate=Address></div><input autocomplete=off type=text id=address ng-model=vm.utils.getAddressString(SubContractorData.address.line1) class="login_input address" placeholder="{{\'Include a place or address\' | translate}}"></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate=TYPES></span><div class="content flex-wrap flex mt-16"><div class="flex-end flex-between w-100 input-items"><div class=flex-22><div class=ft_14_600_moreblack translate="Work Type"></div><selectbox-input class=input-select ng-model=workType options=vm.allWorkTypes label-field=tagName value-field=_id></selectbox-input></div><div><button class=btn_new_blue ng-click=addWorkType()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div ng-repeat="(key, item) in workTypes"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind=item.tagName></div></div><div class="pos-absolute-1-0 flex-items-center"><button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click=deleteWorkType(key)></button></div></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate="STAFF MEMBERS"></span><div class="content flex-wrap flex mt-16"><div class="flex-end w-100 input-items"><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="First Name"></div><input autocomplete=off type=text class="input-primary m-t-4 w-100" placeholder="{{\'First Name\' | translate}}" ng-model=staff.firstName></div><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="Last Name"></div><input autocomplete=off type=text class="input-primary m-t-4 w-100" placeholder="{{\'Last Name\' | translate}}" ng-model=staff.lastName></div><div class=flex-25><div class=ft_14_600_moreblack translate="Contact No."></div><div class=flex><div class="w-147 mr-15"><selectbox-input class="dropdown-primary m-t-4" ng-model=staff.mobile.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number class="input-primary m-t-4 w-100" placeholder="{{\'Phone Number\' | translate}}" ng-model=staff.mobile.phoneNumber></div></div></div><div class="flex-end w-100 input-items"><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="Email ID"></div><input autocomplete=off type=email class="input-primary m-t-4 w-100" placeholder="{{\'Email ID\' | translate}}" ng-model=staff.email></div><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate=Password></div><input autocomplete=off type=password class="input-primary m-t-4 w-100" placeholder="{{\'Password\' | translate}}" ng-model=staff.password></div><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="Confirm Password"></div><input autocomplete=off type=password class="input-primary m-t-4 w-100" placeholder="{{\'Confirm Password\' | translate}}" ng-model=staff.confirmPassword></div><div><button class=button-primary ng-click=addStaff(staff)><img src=/assets/icons/plus.svg alt=icons class=mr-2><span translate=Add></span></button></div></div><div ng-repeat="_staff in staffList track by $index"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind="_staff.firstName + \' \' + _staff.lastName"></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind=_staff.email></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind="\'(\'+_staff.mobile.dialCode + \') \' + _staff.mobile.phoneNumber"></div></div><div class="pos-absolute-1-0 flex-items-center"><!-- <button class="btn-trans">\n                    <img src="/assets/icons/edit_gray.svg" alt="icons" ng-click="editStaff(_staff)" style="width: 16px; height: 16px;"/>\n                  </button> --> <button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click="deleteStaff($index, _staff)"></button></div></div></div></div></div></div><div class=profile-card><span class=label translate="BANK DETAILS"></span><div class="bank flex-between flex-wrap mt-16"><div class=flex-32><div class=ft_14_600_moreblack translate="Account Holder Name"></div><input autocomplete=off type=text class=login_input ng-model=bank.accountHolderName></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Account Number"></div><input autocomplete=off type=text class=login_input ng-model=bank.accountNumber></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Name"></div><input autocomplete=off type=text class=login_input ng-model=bank.bankName></div><div class=flex-100><div class=ft_14_600_moreblack translate="Bank Address"></div><input autocomplete=off type=text class=login_input ng-model=bank.bankAddress></div><div class=flex-32><div class=ft_14_600_moreblack translate="IBAN Number"></div><input autocomplete=off type=text class=login_input ng-model=bank.IBAN></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Sort Code"></div><input autocomplete=off type=text class=login_input ng-model=bank.sortCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Routing Number"></div><input autocomplete=off type=text class=login_input ng-model=bank.routingNo></div><div class=flex-32><div class=ft_14_600_moreblack translate="SWIFT/BIC Code"></div><input autocomplete=off type=text class=login_input ng-model=bank.bicCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="IFSC Number"></div><input autocomplete=off type=text class=login_input ng-model=bank.ifscCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Routing Code"></div><input autocomplete=off type=text class=login_input ng-model=bank.routingCode></div></div></div><div class=profile-card><span class=label translate="TERMS & CONDITIONS"></span><div class="terms flex-between flex-wrap mt-16"><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT in %"></div><input autocomplete=off type=number class="login_input w-100" ng-model=SubContractorData.paymentTerms.vatPercent></div><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT Registration No."></div><input autocomplete=off type=number class="login_input w-100" ng-model=SubContractorData.paymentTerms.vatNumber></div><div class=flex-36><div class="ft_14_600_moreblack required" translate="Payment Terms"></div><div class=w-100><selectbox-input class=input-select ng-model=SubContractorData.paymentTerms.paymentSetting options=paymentConditions label-field=code value-field=_id></selectbox-input></div></div></div><div class="btnGroup flex mt-32"><button class="btn_new_blue mr-16" ng-click="updateSubContractor(paymentVat, bank, picFile)"><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click="updateSubContractor(paymentVat, bank, picFile)"><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref="subContractorsDetail({id: SubContractorData._id})"><img src=/assets/icons/trash-alt-client.svg alt=icons><span class=ft-600-12-16 translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/subContractors/subContractorsGrid/subContractorsGrid.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=subContractorsGrid class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Sub Contractors"></a></div><div class=ft_24_600_black1 translate="Sub Contractors"></div></div><searchbox class=ml-auto search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><div><button class="btn-trans ml-16" ng-click="isGrid = false"><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click="isGrid = true"><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button></div><button class="btn_new_blue ml-16" ui-sref=subContractorsAdd ng-if="SUBCONTRACTOR_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Add Sub Contractor"></span></button></div><!-- title-bar --><div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0 && isLoading==false"><div class="card-based-content-grid-wrapper pr-24 pv-24" ng-if=isGrid><div class="quotes-wrapper flex flex-wrap"><div class=profile-card-container ng-repeat="item in subContractors"><!--subContractor in subContractors--><div class=profile-card><div class=card-content><div class="flex header"><div ng-if=item.profilePic><img ng-src={{item.profilePic}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!item.profilePic><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(item.name)) }">{{item.name | mailAvatarChar}}</span></div><div class=name-wrapper ng-click=goToDetail(item._id)><div class="name tx-ellipsis ft_16_600_black" ng-bind=item.name></div><div class="date text-left tx-ellipsis" ng-bind=vm.utils.getAddressString(item.address)></div></div></div><div class=detail><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/call.svg alt=icons> <span class=ft_14_regular_gray ng-bind="\'+\'+item.contact.dialCode+\' \'+item.contact.phoneNumber"></span></div><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/email.svg alt=icons><span class="ft_14_regular_gray tx-ellipsis" ng-bind=item.email></span></div></div></div><div class="flex-between action"><div class=flex-row><img src=/assets/images/suppliers/tag.svg alt=icons><span class="ft_12_600_black ml-7" ng-bind=item.systemTag></span></div><div class=flex-row><img src=/assets/images/suppliers/calendar.svg alt=icons> <span class="ft_12_regular_gray cal-span" ng-bind="item.created | date: \'dd MMM yyyy\' : \'UTC\'"></span></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + subContractors.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllSubcontractors()></pagination-custom-new></div></div></div></div><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer" ng-if=!isGrid><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=item.checked><span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate=Name></span></th><th class=ft_14_600_black><span translate="Email ID"></span></th><th class=ft_14_600_black><span translate="Contact No."></span></th><th class=ft_14_600_black><span translate=Address></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, item) in subContractors"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=item.checked><span class=checkmark></span></label></td><td ng-click=goToDetail(item._id)><div class="flex-row flex-items-center"><div class=avatar-cell><div ng-if=item.profilePic><img ng-src={{item.profilePic}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!item.profilePic><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(item.name)) }">{{item.name | mailAvatarChar}}</span></div></div><div class="ft_14_regular_black tx-ellipsis name" ng-bind=item.name></div></div></td><td class="tx-ellipsis email ft_14_regular_black" ng-bind=item.email></td><td class=ft_14_regular_black ng-bind="\'(\'+item.contact.dialCode+\') \'+item.contact.phoneNumber"></td><td class="tx-ellipsis address pr-20 ft_14_regular_black">{{item.address[0].line1}},{{item.address[0].line2}},{{item.address[0].city}},{{item.address[0].postalCode}},{{item.address[0].countryCode}}</td><td class="more flex-items-center"><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class=margin-0></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + subContractors.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllSubcontractors()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/suppliers/suppliersAdd/suppliersAdd.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=addSupplier class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=suppliersGrid translate=Suppliers></a></div><div class=ft_24_600_black1 translate="Create Supplier"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click=createSupplier(supp)><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=createSupplier(supp)><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref=suppliersGrid><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div><!-- end title bar --><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="SUPPLIER DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{ !!FILEIMG ? FILEIMG : \'/assets/images/suppliers/upload.png\'}}" alt=upload ngf-select ng-model=picFile name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class=items><div class="ft_14_600_moreblack required" translate="Supplier Name"></div><input type=text ng-model=supplier_name id=firstName class="input-primary w-100" placeholder="{{\'Supplier Name\' | translate}}" autocomplete=off></div><div class="flex-between items"><div class=flex-50><div class="ft_14_600_moreblack required" translate="Email ID"></div><input autocomplete=off type=email ng-model=email placeholder="{{\'Invoice Email ID\' | translate}}" class="input-primary w-100"></div><div class=flex-48><div class="ft_14_600_moreblack required" translate="Contact No."></div><div class=flex><div class=w-147><selectbox-input class=dropdown-primary ng-model=dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number ng-model=phoneNumber placeholder="{{\'Phone Number\' | translate}}" class="input-primary w-100 ml-16"></div></div></div><div class=items><div class="ft_14_600_moreblack required" translate=Address></div><input autocomplete=off type=text id=address ng-model=address.line1 class="input-primary w-100" placeholder="{{\'Include a place or address\' | translate}}"></div><div class=items><div class=ft_14_600_moreblack translate=SearchKey></div><input autocomplete=off type=text id=searchKey ng-model=searchKey class="input-primary w-100" placeholder="{{\'Include a place or address\' | translate}}"></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate=SUPPLIES></span><div class="content flex-wrap flex mt-16"><div class="flex-end flex-between w-100 input-items"><div class=flex-22><div class=ft_14_600_moreblack translate="Material Name"></div><selectbox-input class=dropdown-primary ng-model=supplierType options=vm.allSupplierTypes label-field=tagName value-field=_id></selectbox-input></div><div><button class=button-primary ng-click=addSupplierType()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div ng-repeat="(key, item) in supplierTypes"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind=item.tagName></div></div><div class="pos-absolute-1-0 flex-items-center"><button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click=deleteSupplierType(key)></button></div></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate="STAFF MEMBERS"></span><div class="content flex-wrap flex mt-16"><div class="flex-end flex-between w-100 input-items"><div class=flex-22><div class=ft_14_600_moreblack translate="First Name"></div><input autocomplete=off type=text ng-model=staff.firstName class="input-primary w-100" placeholder="{{\'First Name\' | translate}}"></div><div class=flex-22><div class=ft_14_600_moreblack translate="Last Name"></div><input autocomplete=off type=text ng-model=staff.lastName class="input-primary w-100" placeholder="{{\'Last Name\' | translate}}"></div><div class=flex-22><div class=ft_14_600_moreblack translate="Email ID"></div><input autocomplete=off type=email class="input-primary w-100" placeholder="{{\'Email ID\' | translate}}" ng-model=staff.email></div><div class=flex-22><div class=ft_14_600_moreblack translate="Contact No."></div><div class=flex><div class="w-147 mr-15"><selectbox-input class=dropdown-primary ng-model=staff.mobile.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number ng-model=staff.mobile.phoneNumber class="input-primary w-100" placeholder="{{\'Phone Number\' | translate}}"></div></div><div><button class=btn_new_blue ng-click=addStaff()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div ng-repeat="_staff in staffList track by $index"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind="_staff.firstName + \' \' + _staff.lastName"></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind=_staff.email></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind="\'(\'+_staff.mobile.dialCode + \') \' + _staff.mobile.phoneNumber"></div></div><div class="pos-absolute-1-0 flex-items-center"><button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click=removeStaff($index)></button></div></div></div></div></div></div><div class=profile-card><span class=label translate="BANK DETAILS"></span><div class="bank flex-between flex-wrap mt-16"><div class=flex-32><div class=ft_14_600_moreblack translate="Account Holder Name"></div><input autocomplete=off type=text class=input-primary ng-model=accountHolderName></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Account Number"></div><input autocomplete=off type=text class=input-primary ng-model=accountNumber></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Name"></div><input autocomplete=off type=text class=input-primary ng-model=bankName></div><div class=flex-100><div class=ft_14_600_moreblack translate="Bank Address"></div><input autocomplete=off type=text class=input-primary ng-model=bankAddress></div><div class=flex-32><div class=ft_14_600_moreblack translate="IBAN Number"></div><input autocomplete=off type=text class=input-primary ng-model=IBAN></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Sort Code"></div><input autocomplete=off type=text class=input-primary ng-model=sortCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Routing Number"></div><input autocomplete=off type=text class=input-primary ng-model=routingNo></div><div class=flex-32><div class=ft_14_600_moreblack translate="SWIFT/BIC Code"></div><input autocomplete=off type=text class=input-primary ng-model=bicCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="IFSC Number"></div><input autocomplete=off type=text class=input-primary ng-model=ifscCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Routing Code"></div><input autocomplete=off type=text class=input-primary ng-model=routingCode></div></div></div><div class=profile-card><span class=label translate="TERMS & CONDITIONS"></span><div class="terms flex-between flex-wrap mt-16"><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT in %"></div><input autocomplete=off type=number class="input-primary w-100" ng-model=supplierData.paymentTerms.vatPercent></div><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT Registration No."></div><input autocomplete=off type=number class="input-primary w-100" ng-model=supplierData.paymentTerms.vatNumber></div><div class=flex-36><div class="ft_14_600_moreblack required" translate="Payment Terms"></div><div class=w-100><selectbox-input class=dropdown-primary ng-model=supplierData.paymentTerms.paymentSetting options=paymentConditions label-field=code value-field=_id></selectbox-input></div></div></div><div class="btnGroup flex mt-32"><button class="button-primary mr-16" ng-click=createSupplier()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=createSupplier()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref=suppliersGrid><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/suppliers/suppliersDetail/suppliersDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=suppliersDetail class=main-container><spinner ng-show=isLoading></spinner><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=suppliersGrid translate=Suppliers></a><!-- <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a class="ft-normal-12-16 grey-2" translate="Client Details"></a> --></div><div class=ft_24_600_black1 translate="Supplier Details"></div></div><div class="flex flex-row flex-items-center"><button class="btn_new_blue mr-16" ui-sref="suppliersEdit({id: supplierData._id})"><img src=/assets/icons/bx-edit-white.svg alt=icons><span translate=Edit></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=deleteSupplier()><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class="btn_new_blue client_gray_white_back" ui-sref=suppliersGrid><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="SUPPLIER DETAILS"></span><div class="flex mt-16"><!-- upload photo --><div class=img-container data-wow-delay=1.3s><img width=264 height=264 class="bdRadius-4 object-fit-cover" ng-src="{{ FILEIMG ? FILEIMG : !!supplierData.profilePic ? supplierData.profilePic : \'/assets/images/suppliers/upload.svg\'}}"></div><div class="w-100 flex-wrap"><div class=items><div class=ft_14_regular_gray2 translate="Supplier Name"></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=supplierData.name></div></div><div class="flex-between items"><div class=flex-50><div class=ft_14_regular_gray2 translate="Email ID"></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind=supplierData.email></div></div><div class=flex-48><div class=ft_14_regular_gray2 translate="Contact No."></div><div class="ft_14_600_moreblack name tx-ellipsis" ng-bind="\'+\'+supplierData.contact.dialCode + \' \' + supplierData.contact.phoneNumber"></div></div></div><div class=items><div class=ft_14_regular_gray2 translate=Address></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=vm.utils.getAddressString(supplierData.address)></div></div><div class=items><div class=ft_14_regular_gray2 translate=SearchKey></div><div class="ft_14_600_moreblack address tx-ellipsis" ng-bind=supplierData.searchKey></div></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate=SUPPLIES></span><div class="content flex-wrap flex mt-16"><div ng-repeat="(key, item) in types"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind=item></div></div></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate="STAFF MEMBERS"></span><div class="content flex-wrap flex mt-16"><div ng-repeat="_staff in supplierData.staffs"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind="_staff.firstName + \' \' + _staff.lastName"></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind=_staff.email></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind="\'(\'+_staff.mobile.dialCode + \') \' + _staff.mobile.phoneNumber"></div></div></div></div></div></div></div><div class=profile-card><span class=label translate="BANK DETAILS"></span><div class="bank flex-between flex-wrap mt-16"><div class=flex-32><div class=ft_14_regular_gray2 translate="Account Holder Name"></div><input autocomplete=off type=text disabled class=login_input ng-model=accountHolderName></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Account Number"></div><input autocomplete=off type=text disabled class=login_input ng-model=accountNumber></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Name"></div><input autocomplete=off type=text disabled class=login_input ng-model=bankName></div><div class=flex-100><div class=ft_14_regular_gray2 translate="Bank Address"></div><input autocomplete=off type=text disabled class=login_input ng-model=bankAddress></div><div class=flex-32><div class=ft_14_regular_gray2 translate="IBAN Number"></div><input autocomplete=off type=text disabled class=login_input ng-model=IBAN></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Sort Code"></div><input autocomplete=off type=text disabled class=login_input ng-model=sortCode></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Routing Number"></div><input autocomplete=off type=text disabled class=login_input ng-model=routingNo></div><div class=flex-32><div class=ft_14_regular_gray2 translate="SWIFT/BIC Code"></div><input autocomplete=off type=text disabled class=login_input ng-model=bicCode></div><div class=flex-32><div class=ft_14_regular_gray2 translate="IFSC Number"></div><input autocomplete=off type=text disabled class=login_input ng-model=ifscCode></div><div class=flex-32><div class=ft_14_regular_gray2 translate="Bank Routing Code"></div><input autocomplete=off type=text disabled class=login_input ng-model=routingCode></div></div></div><div class=profile-card><span class=label translate="TERMS & CONDITIONS"></span><div class="terms flex-between flex-wrap mt-24"><div class=flex-30><div class=ft_14_regular_gray2 translate="VAT in %"></div><input autocomplete=off type=number disabled class="login_input w-100" ng-model=supplierData.paymentTerms.vatPercent></div><div class=flex-30><div class=ft_14_regular_gray2 translate="VAT Registration No."></div><input autocomplete=off type=number disabled class="login_input w-100" ng-model=supplierData.paymentTerms.vatNumber></div><div class=flex-30><div class=ft_14_regular_gray2 translate="Payment Terms"></div><input autocomplete=off disabled class="login_input w-100" ng-model=terms.paymentSetting.code></div></div></div></div></div></main>');
$templateCache.put('app/main/suppliers/suppliersEdit/suppliersEdit.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=addSupplier class=main-container><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" ui-sref=suppliersGrid translate=Suppliers></a></div><div class=ft_24_600_black1 translate="Edit Supplier"></div></div><div class="flex flex-row flex-items-center"><button class="button-primary mr-16" ng-click="updateSupplier(paymentVat, bank, picFile)"><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click="updateSupplier(paymentVat, bank, picFile)"><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref="suppliersDetail({id: supplierData._id})"><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div><div class="card-based-content-grid-wrapper p-24"><div class=profile-card><div class=uploadPhoto><span class=label translate="SUPPLIER DETAILS"></span><div class="flex mt-16"><!-- upload photo --> <button data-wow-delay=1.3s class="btn-trans flex-center"><img width=228 height=228 ng-src="{{ !!FILEIMG ? FILEIMG : \'/assets/images/suppliers/upload.png\' }}" alt=upload ngf-select ng-model=picFile name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-change="vm.fileUpdated($files, $event, \'image\')" aria-invalid=false data-wow-delay=0.7s class=object-fit-cover></button><div class="w-100 flex-wrap"><div class=items><div class="ft_14_600_moreblack required" translate="Supplier Name"></div><input type=text ng-model=supplierData.name id=firstName class="input-primary w-100" placeholder="{{\'Company Name\' | translate}}" autocomplete=off></div><div class="flex-between items"><div class=flex-50><div class="ft_14_600_moreblack required" translate="Email ID"></div><input autocomplete=off type=email placeholder="{{\'Invoice Email ID\' | translate}}" class="input-primary w-100" ng-model=supplierData.email></div><div class=flex-48><div class="ft_14_600_moreblack required" translate="Contact No."></div><div class=flex><div class=w-147 ng-if=vm.countryCodes><selectbox-input class=dropdown-primary ng-model=supplierData.contact.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number placeholder="{{\'Phone Number\' | translate}}" class="input-primary w-100 ml-16" ng-model=supplierData.contact.phoneNumber></div></div></div><div class=items><div class="ft_14_600_moreblack required" translate=Address></div><input autocomplete=off type=text id=address ng-model=supplierData.address.line1 class="input-primary w-100" placeholder="{{\'Include a place or address\' | translate}}"></div><div class=items><div class=ft_14_600_moreblack translate=SearchKey></div><input autocomplete=off type=text id=searchKey ng-model=supplierData.searchKey class="input-primary w-100" placeholder="{{\'CVR nr OR S.E. nr\' | translate}}"></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate=SUPPLIES></span><div class="content flex-wrap flex mt-16"><div class="flex-end flex-between w-100 input-items"><div class=flex-22><div class=ft_14_600_moreblack translate="Material Name"></div><selectbox-input class=dropdown-primary ng-model=supplierType options=vm.allSupplierTypes label-field=tagName value-field=_id></selectbox-input></div><div><button class=btn_new_blue ng-click=addSupplierType()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div></div><div ng-repeat="(key, item) in supplierTypes"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind=item.tagName></div></div><div class="pos-absolute-1-0 flex-items-center"><button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click=deleteSupplierType(key)></button></div></div></div></div></div></div><div class=profile-card><div class=staff><span class=label translate="STAFF MEMBERS"></span><div class="content flex-wrap flex mt-16"><div class="flex-end w-100 input-items"><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="First Name"></div><input autocomplete=off type=text class="input-primary m-t-4 w-100" placeholder="{{\'First Name\' | translate}}" ng-model=staff.firstName></div><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="Last Name"></div><input autocomplete=off type=text class="input-primary m-t-4 w-100" placeholder="{{\'Last Name\' | translate}}" ng-model=staff.lastName></div><div class=flex-25><div class=ft_14_600_moreblack translate="Contact No."></div><div class=flex><div class="w-147 mr-15"><selectbox-input class="dropdown-primary m-t-4" ng-model=staff.mobile.dialCode options=vm.countryCodes label-field=dialCodeName value-field=dialCode></selectbox-input></div><input autocomplete=off type=number class="input-primary m-t-4 w-100" placeholder="{{\'Phone Number\' | translate}}" ng-model=staff.mobile.phoneNumber></div></div></div><div class="flex-end w-100 input-items"><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="Email ID"></div><input autocomplete=off type=email class="input-primary m-t-4 w-100" placeholder="{{\'Email ID\' | translate}}" ng-model=staff.email></div><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate=Password></div><input autocomplete=off type=password class="input-primary m-t-4 w-100" placeholder="{{\'Password\' | translate}}" ng-model=staff.password></div><div class="flex-25 mr-16"><div class=ft_14_600_moreblack translate="Confirm Password"></div><input autocomplete=off type=password class="input-primary m-t-4 w-100" placeholder="{{\'Confirm Password\' | translate}}" ng-model=staff.confirmPassword></div><div><button class=button-primary ng-click=addStaff(staff)><img src=/assets/icons/plus.svg alt=icons class=mr-2><span translate=Add></span></button></div></div><div ng-repeat="_staff in staffList track by $index"><div class="item ft_14_regular_gray d-block"><div class=pr-25><div class="ft_14_600_moreblack tx-ellipsis" ng-bind="_staff.firstName + \' \' + _staff.lastName"></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind=_staff.email></div><div class="tx-ellipsis ft-normal-12-16 black-3 m-t-4" ng-bind="\'(\'+_staff.mobile.dialCode + \') \' + _staff.mobile.phoneNumber"></div></div><div class="pos-absolute-1-0 flex-items-center"><!-- <button class="btn-trans">\n                    <img src="/assets/icons/edit_gray.svg" alt="icons" ng-click="editStaff(_staff)" style="width: 16px; height: 16px;"/>\n                  </button> --> <button class=btn-trans><img src=/assets/icons/close-gray.svg alt=icons ng-click="deleteStaff($index, _staff)"></button></div></div></div></div></div></div><div class=profile-card><span class=label translate="BANK DETAILS"></span><div class="bank flex-between flex-wrap mt-16"><div class=flex-32><div class=ft_14_600_moreblack translate="Account Holder Name"></div><input autocomplete=off type=text class=input-primary ng-model=bank.accountHolderName></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Account Number"></div><input autocomplete=off type=text class=input-primary ng-model=bank.accountNumber></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Name"></div><input autocomplete=off type=text class=input-primary ng-model=bank.bankName></div><div class=flex-100><div class=ft_14_600_moreblack translate="Bank Address"></div><input autocomplete=off type=text class=input-primary ng-model=bank.bankAddress></div><div class=flex-32><div class=ft_14_600_moreblack translate="IBAN Number"></div><input autocomplete=off type=text class=input-primary ng-model=bank.IBAN></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Sort Code"></div><input autocomplete=off type=text class=input-primary ng-model=bank.sortCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Routing Number"></div><input autocomplete=off type=text class=input-primary ng-model=bank.routingNo></div><div class=flex-32><div class=ft_14_600_moreblack translate="SWIFT/BIC Code"></div><input autocomplete=off type=text class=input-primary ng-model=bank.bicCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="IFSC Number"></div><input autocomplete=off type=text class=input-primary ng-model=bank.ifscCode></div><div class=flex-32><div class=ft_14_600_moreblack translate="Bank Routing Code"></div><input autocomplete=off type=text class=input-primary ng-model=bank.routingCode></div></div></div><div class=profile-card><span class=label translate="TERMS & CONDITIONS"></span><div class="terms flex-between flex-wrap mt-16"><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT in %"></div><input autocomplete=off type=number class="input-primary w-100" ng-model=supplierData.paymentTerms.vatPercent></div><div class=flex-30><div class="ft_14_600_moreblack required" translate="VAT Registration No."></div><input autocomplete=off type=number class="input-primary w-100" ng-model=supplierData.paymentTerms.vatNumber></div><div class=flex-36><div class="ft_14_600_moreblack required" translate="Payment Terms"></div><div class=w-100><selectbox-input class=dropdown-primary ng-model=supplierData.paymentTerms.paymentSetting options=paymentConditions label-field=code value-field=_id></selectbox-input></div></div></div><div class="btnGroup flex mt-32"><button class="button-primary mr-16" ng-click=updateSupplier()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="button-third mr-16" ng-click=updateSupplier()><img src=/assets/icons/gps-f.svg alt=icons><span translate="Save & Send"></span></button> <button class=btn_cancel ui-sref="suppliersDetail({id: clientData._id})"><img src=/assets/icons/trash-alt-client.svg alt=icons><span translate=Discard></span></button></div></div></div></div></main>');
$templateCache.put('app/main/suppliers/suppliersGrid/suppliersGrid.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=supplierGrid class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Suppliers></a></div><div class=ft_24_600_black1 translate=Suppliers></div></div><searchbox class=ml-auto search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><div><button class="btn-trans ml-16" ng-click="isGrid = false"><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-16" ng-click="isGrid = true"><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button></div><button class="btn_new_blue ml-16" ui-sref=suppliersAdd ng-if="SUPPLIER_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Add Supplier"></span></button></div><!-- end title bar --><div><no-data ng-if="totalCount==0 && !isLoading"></no-data><div ng-if="totalCount!=0 && !isLoading"><div class="card-based-content-grid-wrapper pr-24 pv-24" ng-if=isGrid><div class="quotes-wrapper flex flex-wrap"><div class=profile-card-container ng-repeat="supplier in suppliers"><div class=profile-card><div class=card-content><div class="flex header"><div ng-if=supplier.profilePic><img ng-src={{supplier.profilePic}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!supplier.profilePic><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(supplier.name)) }">{{supplier.name | mailAvatarChar}}</span></div><div class=name-wrapper ng-click=goToDetail(supplier._id)><div class="name tx-ellipsis ft_16_600_black" ng-bind=supplier.name></div><div class="date text-left tx-ellipsis" ng-bind=vm.utils.getAddressString(supplier.address)></div></div></div><div class=detail><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/call.svg alt=icons> <span class=ft_14_regular_gray ng-bind="\'+\'+supplier.contact.dialCode+\' \'+supplier.contact.phoneNumber"></span></div><div class="flex-items-center detail-item"><img src=/assets/images/suppliers/email.svg alt=icons> <span class="ft_14_regular_gray tx-ellipsis" ng-bind=supplier.email></span></div></div></div><div class="flex-between action"><div class=flex-row><img src=/assets/images/suppliers/tag.svg alt=icons> <span class="ft_12_600_black ml-7" ng-bind=supplier.systemTag></span></div><div class=flex-row><img src=/assets/images/suppliers/calendar.svg alt=icons> <span class="ft_12_regular_gray cal-span" ng-bind="supplier.created | date: \'dd MMM yyyy\' : \'UTC\'"></span></div></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + suppliers.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllSuppliers()></pagination-custom-new></div></div></div></div><!-- end grid view --><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer" ng-if=!isGrid><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=supplier.checked><span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate=Name></span></th><th class=ft_14_600_black><span translate="Email ID"></span></th><th class=ft_14_600_black><span translate="Contact No."></span></th><th class=ft_14_600_black><span translate=Address></span></th><th class=ft_14_600_black></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, supplier) in suppliers"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=supplier.checked><span class=checkmark></span></label></td><td class="flex-row flex-items-center" style="height: 48px;" ng-click=goToDetail(supplier._id)><div class=avatar-cell><div ng-if=supplier.profilePic><img ng-src={{supplier.profilePic}} alt=icons onerror="this.src=\'/assets/images/suppliers/upload.svg\'" class="avatar-48 mr-12 object-fit-cover"></div><div ng-if=!supplier.profilePic><span class="avatar-text mr-15" ng-style="{ \'background\': (getColor(supplier.name)) }">{{supplier.name | mailAvatarChar}}</span></div></div><div class="ft_14_regular_black tx-ellipsis name" ng-bind=supplier.name></div></td><td class="tx-ellipsis email ft_14_regular_black" ng-bind=supplier.email></td><td class=ft_14_regular_black ng-bind="\'(\'+supplier.contact.dialCode+\') \'+supplier.contact.phoneNumber"></td><td class="tx-ellipsis address pr-20 ft_14_regular_black" ng-bind=vm.utils.getAddressString(supplier.address)></td><td class=more><img src=/assets/images/suppliers/more_horiz_grey.svg alt=icons class=margin-0></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + suppliers.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllSuppliers()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/synergies/teams/teams.view.html','<main-title-bar></main-title-bar><synerge-navbar ng-if="vm.screen !== 2" selected-tab=vm.selectedTab change-tab=changeTab></synerge-navbar><main ng-style=getMainStyle()><div id=teams class=main-container ng-show="vm.screen===1"><div class=content-wrapper style="display: flex;flex-direction: column;"><div class=content><spinner ng-show="isLoading || !isInitializedTwilio"></spinner><div class=contact><div class=flex-between><div class="ml-auto dropdown dropleft" ng-if="vm.selectedTab==TAB.MEETINGS"><img class=cursor-point id=call-more-btn data-toggle=dropdown aria-haspopup=true aria-expanded=false src=/assets/icons/more-white.svg alt=icons><div class=dropdown-menu aria-labelledby=call-more-btn><a class="dropdown-item cursor-point" ng-click=createMeetingRoom()>Add Meeting Room</a></div></div></div><div class="ml-20 mr-20 mt-10 search-wrap"><img src=/assets/icons/search-gray.svg alt="" class=search-icon> <input type=text class=search ng-model=searchText placeholder=Search></div><div class="items-wrapper flex-1 overflow-x-hidden"><spinner ng-if=callLogLoading></spinner><div ng-if="vm.selectedTab==TAB.CHAT"><div class="item flex-between"><div class="ft_12_500_white sortitem" ng-click=sortByRecentChats()>Recent Chats<i class="{{isSortRecentChat ? \'fas fa-angle-down\' : \'fas fa-angle-up\'}}" style=margin-left:5px></i></div><div class="ft_12_500_white sortitem" ng-click=sortByNewChats()>New Chat<i class="{{isSortNewChat ? \'fas fa-angle-down\' : \'fas fa-angle-up\'}}" style=margin-left:5px></i></div></div><div class="item d-flex" ng-repeat="channel in getPrivateChannels() track by $index" ng-class="{\'isActive\': channel.sid == activeChannel.sid}" ng-click=setActiveMeeting(channel)><img ng-if=channel.memberUsers[0].profilePic ng-src={{channel.memberUsers[0].profilePic}} alt=logo class="avatar object-fit-cover"><div ng-if=!channel.memberUsers[0].profilePic data-letters="{{vm.utils.nameLetter(channel.memberUsers[0].firstName, channel.memberUsers[0].lastName)}}"></div><div class=item-infos><div class="d-flex flex-between mb-2"><div class=member-names>{{ getChannelMemberName(channel) }}</div><div class=last-chat-time>{{channel.lastMsgTime}}</div></div><div class=last-chat-message title={{channel.lastMsg}}>{{channel.lastMsg}}</div></div></div></div><div ng-if="vm.selectedTab==TAB.CALL"><div class="item flex-between"><div class="ft_12_500_white sortitem" ng-click=sortByRecentChats()>Recent Calls<i class="{{isSortRecentChat ? \'fas fa-angle-down\' : \'fas fa-angle-up\'}}" style=margin-left:5px></i></div><div class="ft_12_500_white sortitem" ng-click=sortByNewChats()>New Call<i class="{{isSortNewChat ? \'fas fa-angle-down\' : \'fas fa-angle-up\'}}" style=margin-left:5px></i></div></div><div class="item d-flex" ng-repeat="log in callLogs track by $index" ng-class="{\'isActive\': activeChannel.sid == log.sid}" ng-click=setActiveMeeting(log)><img ng-if=log.profilePic ng-src={{log.profilePic}} alt=logo class="avatar object-fit-cover"><div ng-if=!log.profilePic data-letters="{{vm.utils.nameLetter(log.firstName, log.lastName)}}"></div><div class="flex-between item-infos"><div><div class=member-names>{{ log.displayName }}</div><div class=flex-items-center><div><img class=mr-1 ng-if="log.status==\'no answer\' && log.type==\'outbound\'" src=/assets/icons/call-missed-outgoing.svg alt=icons> <img class=mr-1 ng-if="log.status==\'no answer\' && log.type==\'inbound\'" src=/assets/icons/call-missed-incoming.svg alt=icons> <img class=mr-1 ng-if="log.status==\'completed\' && log.type==\'outbound\'" src=/assets/icons/call-made-outgoing.svg alt=icons> <img class=mr-1 ng-if="log.status==\'completed\' && log.type==\'inbound\'" src=/assets/icons/call-made-incoming.svg alt=icons></div><div class=ft_12_regular_white>{{ log.time }}</div></div></div><div class=flex-items-center><img src=/assets/icons/videocam-gray.svg alt="" class="call-icon mr-16" ng-click="onChatCall(\'video\')"> <img src=/assets/icons/call-d.svg alt="" class=call-icon ng-click="onChatCall(\'audio\')"></div></div></div></div><div ng-if="vm.selectedTab==TAB.MEETINGS" class=item><div ng-repeat="dt in getDatesOfMeetings()"><div class=meeting-date>{{dt === today ? \'Today\' : dt}}</div><div class=meeting-item ng-repeat="room in meetingRooms[dt] track by $index" ng-class="{\'active\': room._id === selectedRoom._id}" ng-click=setActiveRoom(room)><div class=title>{{room.title}}</div><div class=date><span>{{room.dateFrom | date: \'HH:mm a\' : \'UTC\'}}&nbsp;-&nbsp;</span> <span>{{room.dateTo | date: \'HH:mm a\' : \'UTC\'}}</span></div><div class=meeting-id>Meeting ID: {{room.videoRoomSid}}</div></div></div></div><div ng-if="vm.selectedTab==TAB.CONTACTS" class="item d-flex" ng-repeat="user in inviteMembers track by $index" ng-class="{\'isActive\': selectedUser._id == user._id}" ng-click=setActiveUser(user)><img ng-if=user.profilePic ng-src={{user.profilePic}} alt="" class="avatar object-fit-cover"><div ng-show=!user.profilePic data-letters="{{vm.utils.nameLetter(user.firstName, user.lastName)}}"></div><div class=item-infos><div class=member-names>{{ user.displayName }}</div></div></div></div></div><div class=msg-content id=v-pills-tabContent ng-if="vm.selectedTab==TAB.CHAT && getPrivateChannels().length && activeChannel"><div class="msg-header flex-between"><div><div class=ft_18_600_white>{{activeChannel.memberUsers[0].displayName}}</div><div class=flex-items-center><div class=online>&nbsp;</div><div class=ft_12_regular_gray>Active</div></div></div><div class=icons><img src=/assets/icons/star_border.svg alt=""> <img src=/assets/icons/videocam.svg alt="" ng-click=initVideo(true)> <img src=/assets/icons/call-gray.svg alt="" ng-click=initVideo(false)></div></div><div class=chat-container><live-chat type="\'synergy\'" channel-sid={{activeChannel.sid}}></live-chat></div></div><div class=call-content ng-if="vm.selectedTab==TAB.CALL"><div class="ft_24_600_gray mb-40">Contact Name or Phone Number</div><div class=dial><div class="dial-item ft_24_600_black">1</div><div class="dial-item ft_24_600_black">2</div><div class="dial-item ft_24_600_black">3</div><div class="dial-item ft_24_600_black">4</div><div class="dial-item ft_24_600_black">5</div><div class="dial-item ft_24_600_black">6</div><div class="dial-item ft_24_600_black">7</div><div class="dial-item ft_24_600_black">8</div><div class="dial-item ft_24_600_black">9</div><div class="dial-item ft_24_600_black">*</div><div class="dial-item ft_24_600_black">0</div><div class="dial-item ft_24_600_black">#</div></div><div class=call-btn><img src=/assets/icons/call-white.svg alt=""></div><div class=ft_16_600_gray>Caller ID: ({{vm.userData.mobile.dialCode}}) {{vm.userData.mobile.phoneNumber}}</div></div><div class=meeting-content ng-if="vm.selectedTab==TAB.MEETINGS"><div ng-if=selectedRoom><div class="id-name ft-whtie ft_16_600_gray mb-20">Meeting ID: {{selectedRoom.videoRoomSid}}</div><div class="ft_24_600_black mb-20">{{selectedRoom.name}}</div><div class=item><div class="ft_16_600_black w-130">Date</div><div class=ft_16_regular_gray>: <span>{{selectedRoom.dateFrom | date: \'dd/MM/yyyy HH:mm a\' : \'UTC\'}}&nbsp;-&nbsp;{{selectedRoom.dateTo | date: \'dd/MM/yyyy HH:mm a\' : \'UTC\'}}</span></div></div><div class=item><div class="ft_16_600_black w-130">Title</div><div class=ft_16_regular_gray>: {{selectedRoom.title}}</div></div><div class=item><div class="ft_16_600_black w-130">Status</div><div class=ft_16_regular_gray>: {{getMeetingStatusText()}}</div></div><div class="flex mb-20"><button ng-class="selectedRoom.status !== 1? \'disabled\': null" class=btn_primary ng-click=goToMeeting(selectedRoom._id) ng-disabled="selectedRoom.status !== 1">Join</button> <button class="btn_primary gray" ng-click=editMeetingRoom()><img src=/assets/icons/bxs-edit-gray.svg alt="">Edit</button> <button class="btn_primary gray" ng-click=deleteMeetingRoom()><img src=/assets/icons/trash-gray.svg alt="">Delete</button></div><a href="" ng-if=!selectedRoom.isHide style="color: #FF8B00;" ng-click="selectedRoom.isHide=true">Hide Meeting Invitation</a> <a href="" ng-if=selectedRoom.isHide style="color: #FF8B00;" ng-click="selectedRoom.isHide=false">Show Meeting Invitation</a><div ng-if=!selectedRoom.isHide class=meeting-details><div class=mb-8 ng-if="selectedRoom.createdBy._id == vm.userData._id"><span class=ft-600>You</span> <span>is inviting {{getMeetingRoomMemberNames()}} to a scheduled </span><span class=ft-600>CloudES meeting</span>.</div><div class=mb-8 ng-if="selectedRoom.createdBy._id != vm.userData._id"><span class=ft-600>{{selectedRoom.createdBy.displayName}}&nbsp;</span> <span>is inviting you to a scheduled </span><span class=ft-600>CloudES meeting</span>.</div><div><span class=ft-600>Topic: </span><span>{{selectedRoom.description || \'Not specified\'}}</span></div><div class=mb-8><span class=ft-600>Time: </span><span>{{selectedRoom.dateFrom | date: \'MMM dd, yyyy HH:mm a\' : \'UTC\'}}</span></div><div class=ft-600>CloudES Meeting</div><a target=_blank ng-href=teams/meeting/{{selectedRoom._id}}>{{baseUrl + "/meeting/" + selectedRoom._id}}</a><div><span class=ft-600>Meeting ID: </span><span>{{selectedRoom.videoRoomSid}}</span></div><div><span class=ft-600>Passcode: </span><span></span></div></div></div><no-data ng-if=!selectedRoom></no-data></div><div class=contact-content ng-if="vm.selectedTab==TAB.CONTACTS"><div class="d-flex mb-20"><img ng-if=selectedUser.profilePic ng-src={{selectedUser.profilePic}} alt="" class="icon-lg object-fit-cover"><div ng-if=!selectedUser.profilePic data-letters="{{vm.utils.nameLetter(selectedUser.firstName, selectedUser.lastName)}}"></div><div class=ml-15><div class=flex><div class=ft_24_600_black>{{selectedUser.firstName}} {{selectedUser.lastName}}</div><img src=/assets/icons/star-y.svg alt="" class=ml-10></div><div class=ft_16_regular_gray><span ng-if=selectedUser.designation>{{selectedUser.designation}}</span> <span ng-if=selectedUser.department>&nbsp;|&nbsp;{{selectedUser.department}}</span> <span ng-if=selectedUser.subDesignation>&nbsp;|&nbsp;{{selectedUser.subDesignation}}</span></div><div class=user-status><div class="status-icon mr-8" ng-class=getStatusCSS(selectedUser.status).bgColor></div><div class=ft_16_regular_gray ng-class=getStatusCSS(selectedUser.status).color>{{selectedUser.status || \'Invisible\'}}</div></div></div></div><div class="flex mb-30"><button class=btn_primary ng-click="onChatCall(\'chat\')"><img src=/assets/icons/message-gray.svg alt=""> Chat</button> <button class=btn_primary ng-click="onChatCall(\'audio\')"><img src=/assets/icons/call-gray.svg alt=""> Phone Call</button> <button class=btn_primary ng-click="onChatCall(\'video\')"><img src=/assets/icons/videocam-gray.svg alt=""> Video Call</button> <button class=btn_primary><img src=/assets/icons/message-gray.svg alt="">Meeting</button></div><div class=item><div class="ft_16_600_black w-130">Phone</div><div class=ft_16_regular_gray>: +{{selectedUser.mobile.dialCode}} {{selectedUser.mobile.phoneNumber}}</div></div><div class=item><div class="ft_16_600_black w-130">Internal</div><div class=ft_16_regular_gray>: +1 234 223 2323</div></div><div class=item><div class="ft_16_600_black w-130">Email</div><div class=ft_16_regular_gray>: {{selectedUser.email}}</div></div></div></div></div></div><div id=calling class=main-container ng-if="vm.screen===2"><div class=call-lf><div id=remote-media class=user-img></div><div id=remote-media-voice ng-show=!vm.videoFlag></div><!--        <div>--><!--          <div class="user participant-wrapper mb-20 pos-relative">--><!--            <div class="ft_12_regular_white pos-absolute name-label flex-center">--><!--              <img src="/assets/icons/unmute.svg" class="unmute" ng-if="!vm.audioDisabled">--><!--              <img src="/assets/icons/mute.svg" class="" ng-if="vm.audioDisabled">You--><!--            </div>--><!--            <div class="avatar-wrapper">--><!--              <img ng-src="{{vm.userData.profilePic ? vm.userData.profilePic : \'/assets/icons/user1.svg\'}}">--><!--            </div>--><!--          </div>--><!--        </div>--></div><div ng-if=isReady class=is-ready><audio autoplay loop src=/assets/audio/incoming.mp3></audio><div class=content><div class="main-img flex-center overflow-hidden"><img class=h-100 ng-src="{{incomingAvatar ? incomingAvatar : \'/assets/icons/main-img.svg\'}}" alt=icons></div><div class="ft_24_600_black mt-20 flex-center">{{ incomingName }}</div><div class="mt-20 mb-30 flex-center ft_14_regular_gray">Incomming Call ...</div><div class="btn-group flex-center"><div class="video mr-30" ng-if=!vm.videoDisabled ng-click=acceptCall(true)><img src=/assets/icons/video-on.svg alt=icons></div><div class="video mr-30" ng-click=acceptCall(false)><img src=/assets/icons/accept-call.svg alt=icons></div><div class=call ng-click=cancelCall()><img src=/assets/icons/call-on.svg alt=icons></div></div></div></div><div ng-if=!isReady class=is-voice-calling><audio autoplay loop src=/assets/audio/incoming.mp3 ng-if=!isAttachedPaticipant></audio><div id=mainTrack style="display: none"></div><div id=mainTrack-voice></div><div class=main-wrapper><div ng-if=!isGroupCall><div class="main-img flex-center m-auto"><img ng-src="{{vm.activeUsers[0].profilePic ? vm.activeUsers[0].profilePic : \'/assets/icons/main-img.svg\'}}" alt=icons></div><div class="ft_24_600_white mt-20 flex-center">{{vm.activeUsers[0].displayName}}</div></div><div ng-if=isGroupCall><div class="main-img flex-center m-auto"><img ng-src="{{vm.selectedTeam.avatar ? vm.selectedTeam.avatar : \'/assets/icons/main-img.svg\'}}" alt=icons></div><div class="ft_24_600_white mt-20 flex-center">{{vm.selectedTeam.name}}</div></div></div></div><div ng-if=!isReady class=footer-icons ng-style="{\'margin-top\': singleVideo? \'-100px\' : \'null\' }"><div class="btn-group flex"><div class=microphone ng-click=vm.closeAudio() ng-disabled=vm.audioDisabled ng-class="!vm.audioDisabled? \'cursor-point\': null"><img src=/assets/icons/microphoneoff.svg alt=icons ng-if=!vm.audioFlag class=off-icon> <img src=/assets/icons/microphoneon.svg alt=icons ng-if=vm.audioFlag class=on-icon></div><div class="video mh-30" ng-click=vm.closeVideo() ng-disabled=vm.videoDisabled ng-class="!vm.videoDisabled? \'cursor-point\': null"><img src=/assets/icons/video-on.svg alt=icons ng-if=vm.videoFlag> <img src=/assets/icons/video-off.svg alt=icons ng-if=!vm.videoFlag></div><div class=call ng-click=cancelCall()><img src=/assets/icons/call-on.svg alt=icons></div></div></div><div class="msg flex-center" ng-if=!isShowMsg ng-click=onShowMsg()><img src=/assets/icons/message-icon.svg alt=icons></div><div class="msg-content flex-column" ng-show=isShowMsg><div class=top-bar><div class=ft_18_600_black>{{getChannelMemberName()}}</div><img class=cursor-point src=/assets/icons/close-msg.svg alt=icons ng-click=onHideMsg()></div><live-chat type="\'synergy\'" channel-sid={{activeChannel.sid}} style="height: 100%;"></live-chat></div></div></main>');
$templateCache.put('app/main/synergies/teamsMeeting/teamsMeeting.view.html','<div id=teamsMeeting class=main-container><div id=calling class=main-container ng-if=isReadyJoin><div class=call-lf><div id=remote-media class=user-img></div><div id=remote-media-voice></div></div><div class=is-voice-calling><div id=mainTrack></div><div id=mainTrack-voice></div></div><div class=footer-icons ng-style="{\'margin-top\': singleVideo? \'-100px\' : \'null\' }"><div class="btn-group flex"><div class="microphone mr-30" ng-click=vm.closeAudio() ng-disabled=vm.audioDisabled ng-class="!vm.audioDisabled? \'cursor-point\': null"><img src=/assets/icons/microphoneoff.svg alt=icons ng-if=!vm.audioFlag class=off-icon> <img src=/assets/icons/microphoneon.svg alt=icons ng-if=vm.audioFlag class=on-icon></div><div class="video mr-30" ng-click=vm.closeVideo() ng-disabled=vm.videoDisabled ng-class="!vm.videoDisabled? \'cursor-point\': null"><img src=/assets/icons/video-on.svg alt=icons ng-if=vm.videoFlag> <img src=/assets/icons/video-off.svg alt=icons ng-if=!vm.videoFlag></div><div class=call ng-click=leaveRoom()><img src=/assets/icons/leave-from-room.svg alt=icons></div></div></div></div><div ng-if=!isReadyJoin id=is-ready-join><spinner ng-show="isLoading || !cameraTested"></spinner><main-title-bar></main-title-bar><synerge-navbar></synerge-navbar><main><div class=content-wrapper style="display: flex;flex-direction: column;"><div class=sub-navigation><a class="ft_14_regular_gray text-hover-underline" translate=Dashboard ng-click=goDashboard()></a> <img src=/assets/icons/chevron-right%201.svg alt=icons> <a class=ft_14_regular_gray ui-sref=teams translate=Synergy.surf></a></div><div class=content><div class="w-100 d-flex"><webcam on-stream=onStream(stream) on-error=onError(err) on-streaming=onSuccess() channel=readyChannel></webcam><div ng-if="selectedRoom && cameraTested" class="meeting-content ml-30 mb-20"><div class=item><div class="ft_16_600_black w-130">Date</div><div class=ft_16_regular_gray>: <span>{{selectedRoom.dateFrom | date: \'dd/MM/yyyy HH:mm a\' : \'UTC\'}}&nbsp;-&nbsp;{{selectedRoom.dateTo | date: \'dd/MM/yyyy HH:mm a\' : \'UTC\'}}</span></div></div><div class=item><div class="ft_16_600_black w-130">Title</div><div class=ft_16_regular_gray>: {{selectedRoom.title}}</div></div><div class=item><div class="ft_16_600_black w-130">Status</div><div class=ft_16_regular_gray>: {{getMeetingStatusText()}}</div></div><div class="flex-center mt-30"><button ng-class="selectedRoom.status !== 1? \'disabled\': null" class=btn_primary ng-click=joinRoom() ng-disabled="selectedRoom.status !== 1">Join now</button> <button class="btn_primary gray mr-0" ui-sref=teams>Cancel</button></div></div></div></div></div></main></div></div>');
$templateCache.put('app/main/todo/directives/category-tree.html','<div class="flex-items-center category-items sub-item cursor-point pos-relative" ng-class="{active: item._id === vm.selectedSubCategory._id}" ng-click=selectSubCategory(item) ui-tree-handle><img ng-if="item.children && item.children.length > 0" class=collapse-icon ng-click=toggle(this) alt="" ng-src="{{this.collapsed ? \'/assets/icons/todo-chevron-down-white.svg\' : \'/assets/icons/todo-chevron-right-white.svg\'}}"><div ng-if="!item.children || !item.children.length" class=blank-icon1></div><div class=flex-items-center><span ng-class="{active: item._id === vm.selectedSubCategory._id}">{{item.name}}</span></div></div><ol ui-tree-nodes="" ng-model=item.children ng-class="{\'angular-ui-tree-hidden\': !this.collapsed}"><li ng-repeat="item in item.children" ng-init="child=true" ui-tree-node ng-include="\'app/main/todo/directives/todo-tree-item.html\'"></li></ol>');
$templateCache.put('app/main/todo/directives/content-tree.html','<div class="flex-items-center category-items pos-relative" ng-class="{active: item._id === vm.selectedContent._id, \'cursor-point\': item._id !== vm.selectedContent._id}" ng-click=selectContent(item) ui-tree-handle><img ng-if="item.children && item.children.length > 0" class=collapse-icon ng-click=toggle(this) alt="" ng-src="{{this.collapsed ? \'/assets/icons/todo-chevron-down-white.svg\' : \'/assets/icons/todo-chevron-right-white.svg\'}}"><div ng-if="!item.children || !item.children.length" class=blank-icon1></div><div class="flex-items-center width100"><img class=selected-icon ng-src="{{item._id === vm.selectedContent._id? \'/assets/icons/todo-selected-status.svg\': \'/assets/icons/todo-status.svg\'}}"> <span class=flex-40>{{item.title}}</span><div class="flex-items-center flex-25"><img src=/assets/icons/todo-upcoming-gray.svg> <span class=ft_14_regular_gray>{{item.deadlineTime | date: \'MMM d, yyyy h:mm a\' : \'UTC\'}}</span></div><div class="flex-items-center flex-25"><avatar-group avatars=item.assignedTo to-top=true more-count-border-color="\'#ff8b00\'" more-count-color="\'#ff8b00\'"></avatar-group></div><div class=flex-items-center><img src=/assets/images/dashboard/bx-edit.svg alt=logo class="cursor-point mr-2" ng-click=edit(item._id)> <img src=/assets/images/dashboard/Trash-alt.svg alt=logo class=cursor-point ng-click=delete(item._id)></div></div></div><ol ui-tree-nodes="" ng-model=item.children ng-class="{\'angular-ui-tree-hidden\': !this.collapsed}"><li ng-repeat="item in item.children" ng-init="child=true" ui-tree-node ng-include="\'app/main/todo/directives/todo-tree-item.html\'"></li></ol>');
$templateCache.put('app/main/todo/directives/todo-category-tree.html','<div class="flex-between category-items pos-relative cursor-point" ng-class="{active: item._id === vm.selectedCategory._id}" ng-click=selectCategory(item);toggle(this) ui-tree-handle><div class=flex-items-center><img ng-if=item.icon class=category-icon ng-src={{item.icon}}> <span ng-class="{active: item._id === vm.selectedCategory._id}">{{item.name}}</span></div><img ng-if="item.children && item.children.length > 0" class=collapse-icon ng-click="" alt="" ng-src="{{this.collapsed ? \'/assets/icons/todo-chevron-down-black.svg\' : \'/assets/icons/todo-chevron-right-black.svg\'}}"></div><ol ui-tree-nodes="" ng-model=item.children ng-class="{\'angular-ui-tree-hidden\': !this.collapsed}"><li ng-repeat="item in item.children" ng-init="child=true" ui-tree-node ng-include="\'app/main/todo/directives/category-tree.html\'"></li></ol>');
$templateCache.put('app/main/todo/directives/todo-content-tree-item.html','<div class="flex-items-center category-items cursor-point pos-relative" ui-tree-handle ng-click=toggle(this)><img ng-if="item.children && item.children.length > 0" class=collapse-icon alt="" ng-src="{{!this.collapsed ? \'/assets/icons/todo-chevron-down-black.svg\' : \'/assets/icons/todo-chevron-right-black.svg\'}}"><div ng-if="!item.children || !item.children.length" class=blank-icon1></div><div class=flex-items-center><img ng-if=item.icon class=category-icon ng-src={{item.icon}}> <span ng-class="{active: item._id === vm.selectedContent._id}">{{item.name}} ({{item.children.length}})</span></div></div><ol ui-tree-nodes="" ng-model=item.children ng-class="{\'angular-ui-tree-hidden\': this.collapsed}"><li ng-repeat="item in item.children" ng-init="child=true" ui-tree-node ng-include="\'app/main/todo/directives/content-tree.html\'"></li></ol>');
$templateCache.put('app/main/todo/todoBoard/todoBoard.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-show=isLoading></spinner><div id=todoBoard class=main-container><div class=content-wrapper><side-navbar page=todo></side-navbar><div class=side-menu><div class="d-flex mb-16"><button class="btn-trans cursor-point mr-10" ng-click=collapseMenu()><img src=/assets/icons/btn-hamberg-white.svg></button><div class=box-title><span class=title translate="Task To Do"></span></div></div><button class="button-create cursor-point mb-16" ng-click=addEvent()><img src=/assets/icons/bx-plus2.svg><span translate="Add Task"></span></button><ul class="mail-nav mb-16"><li class="cursor-point h-auto d-block"><div class=flex-between><div><span class=mr-10><img class=down src=/assets/icons/calendar-today-line-green.svg></span><span class=name translate=Today></span></div><span class=ft_14_regular_light_gray1>4</span></div></li><li class="cursor-point h-auto d-block"><div class=flex-between><div><span class=mr-10><img class=down src=/assets/icons/calendar-upcoming-line-orange.svg></span><span class=name translate=Upcoming></span></div><span class=ft_14_regular_light_gray1>12</span></div></li></ul><ul class=mail-nav><li class="cursor-point h-auto d-block mb-16" ng-repeat="($index, item) in rootFolders"><div class=flex-between ng-click=onExpand($index)><div><span><img class=down src=/assets/icons/chevron-down-gray.svg></span><span class="ml-10 name">{{item.name}}</span></div><span ng-if="item._id > 1"><img class=down src=/assets/icons/add-line-gray-light.svg></span></div><ul class=child-ul ng-style="{\'display\': expandedIndex === $index? \'block\': \'none\'}"><li class="cursor-point pr-0 pl-24 d-block tech-menu" ng-repeat="(key, subItem) in item.children"><div class="flex-between child-between" ng-click="onSelectItem($index, key)"><div class=flex-between><div class="color-mark flex-center" ng-if="subItem.type==\'checkbox\'" ng-style="{\'background-color\': subItem.border ? \'unset\' : subItem.color,\n                                  \'border\': subItem.border ? \'2px solid\' : \'none\',\n                                  \'border-color\': subItem.border ? subItem.color : \'unset\'}"><img src=/assets/icons/checkmark-15.svg></div><div ng-if="subItem.type==\'circle\'" class="circle mr-12" ng-style="{\'background-color\': subItem.color}"></div><div ng-if="subItem.type==\'tag\'" class=mr-12><img ng-src={{subItem.src}}></div><span class=ft_14_regular_light_gray1>{{subItem.name}}</span></div><span class=ft_14_regular_light_gray1 ng-if=subItem.val>{{ subItem.val }}</span></div></li></ul></li></ul></div><div class=side-menu-collapse ng-if=isCollapse><div class="flex-between mb-2"><button class="btn-trans cursor-point" ng-click=collapseMenu()><img src=/assets/icons/btn-hamberg-white.svg></button></div><button class="button-compose cursor-point" ng-click=onCompose()><img src=/assets/icons/bx-plus2.svg></button><div class=mail-nav-bar><ul class=mail-nav><li ui-sref=appMailInbox ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/inbox_default.svg style="opacity: 0.5;"></li><li ui-sref=appMailSent ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/sent_default.svg></li><li ui-sref=appMailDraft ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/draft_default.svg></li><li ui-sref=appMailImportant ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/spam_default.svg></li><li ui-sref=appMailStared ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/trash_default.svg></li><li ui-sref=appMailSetting ui-sref-active=active class="cursor-point mail-box-li"><img src=/assets/icons/setting_default.svg></li></ul></div></div><div class=right-side><div class=title-bar><div><div class="ft-lg ft-bold-primary ft-color-primary" translate="Accounting Tasks"></div></div><div class=ml-auto><button class=btn-trans ng-click="isGrid = false"><img ng-src="{{ isGrid ? \'/assets/images/sales/bx-list-ul-inactive.svg\' : \'/assets/images/sales/bx-list-ul-active.svg\' }}" alt=icons class=margin-0></button> <button class="btn-trans ml-8" ng-click="isGrid = true"><img ng-src="{{ isGrid ? \'/assets/images/sales/grid-active.svg\' : \'/assets/images/sales/grid-inactive.svg\' }}" alt=icons class=margin-0></button></div><button class="button-primary ml-8" ui-sref="">+&nbsp;<span translate="Add Section"></span></button> <button class="button-ex1 ml-8" ui-sref=""><img src=/assets/icons/message_gray.svg alt=icons></button> <button class="button-ex1 ml-8" ui-sref=""><img src=/assets/icons/person_add_alt.svg alt=icons></button> <button class="button-ex1 ml-8" ui-sref=""><img src=/assets/icons/import_export.svg alt=icons></button> <button class="btn_cancel ml-8" ui-sref=""><img src=/assets/icons/more-horiz-dark.svg alt=icons></button></div><!-- <div class="header-part flex-between">\n          <searchbox search-text="vm.searchText" search-event="fetchTodoList()" is-small="true"></searchbox>\n          <div class="duration flex-items-center" ng-if="vm.deadlineFromDate || vm.deadlineToDate">\n            <img src="/assets/icons/date-calendar.svg" alt="icons"/>\n            <div class="ft_16_600_black">{{vm.deadlineFromDate | date: "d MMM, yyyy" : \'UTC\'}} - {{vm.deadlineToDate | date: "d MMM, yyyy" : \'UTC\'}}</div>\n          </div>\n        </div> --><div class=content><todo-group-by-status data=vm.todoItems refresh-event=initData() permission=4 grid=isGrid></todo-group-by-status></div></div></div></div></main>');
$templateCache.put('app/main/tq/create-tq/create-tq.view.html','<div id=create-tq-wrap><main-title-bar></main-title-bar><div class=tq-create-header><span class=tq-title><div class=tq-header-title><div><i class="fa fa-angle-left ft-white back-page-icon" ng-click=exitCreatetq()></i> <span class="ft-14 line-height-24 fw-600 ml-16 ft-tq-white">{{vm.editMode ? "Edit TQ" : "Create TQ"}}</span></div></div></span><div class=tq-header-control><div class="switch switch-sm"><input type=checkbox class=switch id=viewValue ng-disabled=isVP ng-model=isPlanViewer ng-checked=isPlanViewer> <label for=viewValue></label></div><button class="btn_new_blue pv-8 pr-12 pl-6 ml-16" ng-click=goAddMarking()><img src=/assets/icons/add-circle.svg style="margin-right: 4px;" alt=icons><span translate="Add Markings"></span></button><div class=tq-dropdown-menu><ul class=tq-ul-nav><li class=dropdown><div class=tq-dropdown-toggle data-toggle=dropdown><img class=content-copy src=/assets/icons/content_copy.svg> <span class="ft-12 line-height-16 fw-600 ft-white ml-6" translate=Compare></span><img src=/assets/icons/dropdown-white.svg class=ml-8></div><ul class=dropdown-menu><li><span translate="Version 01"></span></li><li><span translate="Version 02"></span></li></ul></li></ul></div><img src=/assets/icons/close-24-gray.svg ng-click=exitCreatetq() class="cursor-point ml-20" alt=close></div></div><main style="display: flex"><spinner ng-if=isLoading></spinner><div class=tq-left-panel><div class=tq-left-panel-content><div class="switch-2 mb-16"><div class=switch-item ng-class="{active: !isVP == true}" ng-click=setVPMode(false) translate="3D Model"></div><div class=switch-item ng-class="{active: isVP == true}" ng-click=setVPMode(true) translate=VP></div></div><div ng-if=!isVP><div class="flex flex-row mb-16"><div class=flex-1><div class="ft_14_600_moreblack required" translate="3D Model"></div><selectbox-input class="arrowbottom_46_400 input-select" ng-model=tqData.marker.info3d.modelId options=m3dList label-field=name value-field=_id select-event=change3dModel() disabled placeholder="Select 3D Model"></selectbox-input></div></div><div class="flex flex-row mb-16"><div class=flex-1><div class=ft_14_600_moreblack translate=Level></div><selectbox-input class="arrowbottom_46_400 input-select" ng-model=tqData.marker.info3d.level options=m3dLevelList label-field=name value-field=guid select-event=change3dModelLevel() disabled placeholder="Select Level"></selectbox-input></div></div></div><div ng-if=isVP><div class="flex flex-row mb-16"><div class=flex-1><div class=ft_14_600_moreblack translate=VP></div><selectbox-input class="arrowbottom_46_400 input-select" ng-model=tqData.marker.info2d.modelId options=vpList label-field=title value-field=_id select-event=changeVP() disabled placeholder=VP></selectbox-input></div></div><div class="flex flex-row mb-16"><div class=flex-1><div class=ft_14_600_moreblack translate=Level></div><selectbox-input class="arrowbottom_46_400 input-select" ng-model=tqData.marker.info2d.level options=vm.workLevels label-field=tagName value-field=_id select-event=changeVPLevel() disabled placeholder="Select Level"></selectbox-input></div></div></div><div class=flex-1><div class="ft_14_600_moreblack required" translate=Status></div><selectbox-input class="arrowbottom_46_400 input-select mb-16" ng-model=tqData.status options=statusList label-field=label value-field=key placeholder="Select Status"></selectbox-input></div><div><div class="ft-14 line-height-24 fw-600 ft-black mbl-4 required" translate=Title></div><input type=text class="tq-create-input mb-16" placeholder="Enter title" ng-model=tqData.title autofocus></div><div><div class="ft-14 line-height-24 fw-600 ft-black mbl-4" translate=Description></div><textarea class="tq-textarea mb-16" placeholder="Enter your description here" ng-model=tqData.description></textarea></div><div><div class=ft_14_600_moreblack translate=Discipline></div><selectbox-input class="arrowbottom_46_400 input-select mb-16" ng-model=tqData.discipline options=discipList label-field=label value-field=key placeholder="Select Assigned to"></selectbox-input></div><div><div class=ft_14_600_moreblack translate="Assigned To"></div><selectbox-input class="arrowbottom_46_400 input-select mb-16" ng-model=tqData.assignedTo options=allRoofers label-field=label value-field=key placeholder="Select Assigned to"></selectbox-input></div><div><div class="ft-14 line-height-24 fw-600 ft-black mbl-4" translate=Location></div><input places-auto-complete types="[\'geocode\']" class="tq-create-input mb-16" on-place-changed=vm.placeMarker() ng-model=tqData.location></div><div class=ft_14_600_moreblack translate="Due Date"></div><div class="input-group datePicker mb-16"><input type=text class="login_input_new w-100" date-picker=dd/MM/yyyy date=tqData.deadLine is-open=isDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isDatepickerOpen = !isDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=tq-left-end><div class=tq-create ng-click=createTq() ng-if=!vm.editMode translate=Create></div><div class=tq-create ng-click=createTq() ng-if=vm.editMode translate=Update></div><div class="tq-cancel mr-8" ng-click=exitCreatetq() translate=Cancel></div></div></div><div class=tq-right-panel><div id=initial_loading_popup><img src=/assets/images/cgviewer/cloud_loading.gif></div><div id=bimviewer ng-show="!isVP && !isPlanViewer"></div><div id=model2d-preview-container class=marking-viewer ng-show="!isVP && isPlanViewer"><div id=model2d-preview class=marking-viewer></div></div><tqtoolbox on-selected=vm.toolbarEvent data=toolbarList ng-if=!isVP></tqtoolbox><div id=tq-vp-viewer ng-if=isVP><tq-vp-detail-page ng-repeat="page in vm.vppages" page=page ng-style="{\'visibility\': page===vm.vpCurPage ? \'visible\' : \'hidden\'}"></tq-vp-detail-page><tqtoolbox on-selected=vm.vpCurPage.toolbarEvent data=toolbarList></tqtoolbox></div></div></main></div>');
$templateCache.put('app/main/tq/detail-tq/detail-tq.view.html','<div id=detail-tq-wrap><main-title-bar></main-title-bar><div class=tq-create-header><span class=tq-title>{{modelTitle}}</span><div class=tq-header-control><div class="switch switch-sm"><input type=checkbox class=switch id=viewValue ng-disabled=isVP ng-model=isPlanViewer ng-checked=isPlanViewer> <label for=viewValue></label></div><div class=tq-dropdown-menu><ul class=tq-ul-nav><li class=dropdown><div class=tq-dropdown-toggle data-toggle=dropdown><img class=content-copy src=/assets/icons/content_copy.svg> <span class="ft-12 line-height-16 fw-600 ft-white ml-6" translate=Compare></span><img src=/assets/icons/dropdown-white.svg class=ml-8></div><ul class=dropdown-menu><li><span translate="Version 01"></span></li><li><span translate="Version 02"></span></li></ul></li></ul></div><img src=/assets/icons/close-24-gray.svg ng-click=gotoList() class="cursor-point ml-20" alt=close></div></div><main style="display: flex"><spinner ng-if=isLoading></spinner><div class=detail-left-panel><div class=detail-left-panel-header><div><i class="fa fa-angle-left ml-26 ft-black" ng-click=gotoList()></i> <span class="ft-14 line-height-24 fw-600 ml-16 ft-tq-black" translate="TECHNICAL QUERIES"></span></div><i class="fa fa-times grey-4 float-right cursor-point mr-20" ng-click=gotoList()></i></div><div class=detail-left-panel-content><div class="d-flex flex-between"><span class="ft-16 line-height-24 fw-600 ft-tq-black1">{{tqData.title}}</span> <i class="ft-12 line-height-16 fa fa-edit ft-gray1 cursor-point" ng-click=gotoEditTq(tqData._id)></i></div><div class="ft-14 mt-8 line-height-16 fw-400 ft-gray1 cursor-point">Progress: {{tqData.progress}}%</div><p class="detail-description mt-8" ng-class="vm.readMoreClick ? \'scrollstatus\' : \'hiddenstatus\'"><span>{{vm.readMoreClick ? tqData.description : vm.readMoreText}}</span> <span class="ft-12 line-height-20 blue-2 cursor-point readmore" ng-click=vm.showReadMore() ng-if=vm.readMore>Read More</span></p><div class="d-flex mt-16"><span class="ft-12 line-height-16 fw-400 ft-gray1">Assigned to : </span><span class="ft-12 line-height-16 fw-600 ft-tq-black1 ml-8">{{tqData.assignedTo.displayName}}</span></div><div class="d-flex mt-8"><span class="ft-12 line-height-16 fw-400 ft-gray1">Created by: </span><span class="ft-12 line-height-16 fw-600 ft-tq-black1 ml-8">{{tqData.createdBy}}</span> <span class="ft-12 line-height-16 fw-400 ft-gray1 ml-8">on</span> <span class="ft-12 line-height-16 fw-400 ft-tq-black1 ml-8">{{tqData.createdAt | date: "dd MM, yyyy" : \'UTC\'}}</span></div><div class="d-flex mt-8"><span class="ft-12 line-height-16 fw-400 ft-gray1">Level: </span><span class="ft-12 line-height-16 fw-600 ft-tq-black1 ml-8">{{level}}</span></div><div class="d-flex mt-8"><span class="ft-12 line-height-16 fw-400 ft-gray1">Location: </span><span class="ft-12 line-height-16 fw-600 ft-tq-black1 ml-8">{{tqData.location}}</span></div><div class="d-flex flex-between mt-16"><div ng-class=getTqStatusClass(tqData.status)>{{tqData.status}}<i class="fa fa-angle-down"></i></div><div class=d-flex><span class="ft-12 line-height-16 fw-400 ft-gray1">Due on: </span><span class="ft-12 line-height-16 fw-600 ft-tq-black1 ml-8">{{tqData.deadLine | date: "dd/MM/yyyy" : \'UTC\'}}</span></div></div><div class="d-flex mt-16"><span class="ft-12 line-height-16 fw-400 ft-gray1">A1-1 DMS - FIRST FLOOR PLAN \u2022 V2 (current)</span></div></div><div id=detail-menu class=nav-items><nav class="navbar navbar-expand-lg navbar-light" style="width: 100%;padding: 0px 0px !important;"><ul class=navbar-nav style="width: 100%"><li class=nav-item ng-class="{active: currentTab === \'attach\'}" ng-click="setCurrentTab(\'attach\')"><a href=# class=nav-link translate=Attachments></a></li><li class=nav-item ng-class="{active: currentTab === \'comment\'}" ng-click="setCurrentTab(\'comment\')"><a href=# class=nav-link translate=Comments></a></li><li class=nav-item ng-class="{active: currentTab === \'activity\'}" ng-click="setCurrentTab(\'activity\')"><a href=# class=nav-link translate=Activity></a></li></ul></nav></div><div ng-if="currentTab==\'attach\'" class=upload-box><div class=drag-drop-box ngf-drop ngf-change="vm.fileUpdated($files, $event)" name=file ngf-multiple=true><div class=detail-drag-drop><span translate="Drag and Drop or"></span> <span class="ft-blue ph-5" ngf-select ngf-change="vm.fileUpdated($files, $event)" name=file ngf-multiple=true translate=Browse></span></div></div></div><div ng-if="currentTab==\'attach\'" class=detail-attach-wrap><div class=upload-files ng-if="vm.files && vm.files.length"><div class=upload-file ng-repeat="file in vm.files track by $index" ng-if="file.progressPercentage !== 100"><img class=file-icon ng-src={{vm.utils.getTQFileIcon(file)}} alt=""><div class=progress-container><div class=progress-info><div class=file-name>{{file.name}}</div><div class=progress-value ng-if="file.progressPercentage !== 100">Uploading</div></div><div class=progress-bar><div class=real-progress ng-style="vm.getStyleWidth(file.progressPercentage || 0)"></div></div></div><img ng-if="file.progressPercentage !== 100" class=cancel-icon src=/assets/icons/close-circle-f-gray.svg alt="" ng-click="vm.cancelUpload(file, $index)"> <img ng-if="file.progressPercentage === 100" class=done-icon src=/assets/icons/mark-complete.svg alt=""></div></div><div class=upload-files ng-if=tqData.attachList><div class=upload-file ng-repeat="attach in tqData.attachList track by $index"><img class=file-icon ng-src={{attach.imgSrc}} alt=""><div class=progress-container><div class=progress-info><div class=file-name>{{attach.fileName}}</div><div class=progress-value>Uploaded by <span class="ft-12 line-height-16 fw-400 ft-tq-black1">{{attach.createdBy}} \u2022 </span>{{attach.createdAt | date :\'dd/MM/yyyy\' }}</div></div></div><img src=/assets/icons/Trash-alt.svg class="delete-ico cursor-point ml-8" ng-click=deleteAttach($index,attach._id)></div></div></div><div ng-if="currentTab==\'activity\'" class=detail-activity-wrap><div ng-repeat="activity in tqData.tqActivity track by $index" class=detail-activity-panel><div class=activity-avatar-panel><img src={{activity.pic}} class=activity-avatar><div class=activity-avatar-indicator></div></div><div class=activity-info-panel><div class="d-flex flex-between"><span class="ft-12 line-height-16 fw-600 ft-tq-black1">{{activity.userName}}</span> <span class="ft-12 line-height-16 fw-400 grey-4">{{activity.addedTime | date: "dd MMM yyyy HH:mm" : \'UTC\'}}</span></div><p class=activity-comment>{{activity.activity}}</p></div></div></div><div ng-if="currentTab==\'comment\'" class=detail-chat-wrap><div class=detail-content-chat></div><div class=detail-live-chat><img src=/assets/icons/chat-add.svg> <input type=text class=detail-live-chat-input placeholder="Write your message"> <img src=/assets/icons/chat-emoticon.svg class=ml-12> <img src=/assets/icons/chat-send.svg class=ml-12></div></div></div><div class=tq-right-panel><div id=initial_loading_popup><img src=/assets/images/cgviewer/cloud_loading.gif></div><div id=bimviewer ng-show="!isVP && !isPlanViewer"></div><div id=model2d-container class=marking-viewer ng-show="!isVP && isPlanViewer"><div id=model2d class=marking-viewer></div></div><!-- <tqtoolbox on-selected="vm.toolbarEvent" data="toolbarList" ng-if="!isVP"></tqtoolbox> --><div id=tq-vp-viewer ng-if=isVP><tq-vp-detail-page ng-repeat="page in vm.vppages" page=page ng-style="{\'visibility\': page===vm.vpCurPage ? \'visible\' : \'hidden\'}"></tq-vp-detail-page><!-- <tqtoolbox on-selected="vm.vpCurPage.toolbarEvent" data="toolbarList"></tqtoolbox> --></div></div></main></div>');
$templateCache.put('app/main/tq/tq-list/tq-list.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=tq-list class=main-container><div class="tq-header flex-between"><div><div class=sub-tq-navigation><span ng-click=goDashboard() class="ft-12 line-height-16 fw-400 ft-blue-2 cursor-point" translate=Dashboard></span> <i class="fa fa-angle-right ft-9 ft-black ml-6"></i> <a class="ft-12 line-height-16 fw-normal ft-black ml-6" translate=TQ></a></div><div><div class="d-flex align-center justify-center"><span class="ft_24_600_black ft-black" translate="Technical Queries"></span><div id=tq-menu-nav class=nav-items><nav class="navbar navbar-expand-lg navbar-light"><ul class=navbar-nav><li class=nav-item ng-class="{active:discipline==disType}" ng-repeat="discipline in discipList" ng-click=setDiscipType(discipline)><a href=#>{{discipline}}</a></li></ul></nav></div></div></div></div><searchbox class=ml-auto search-text=searchText search-event=searchTq() is-small=true></searchbox><div class="btn_create_tq ml-16" ng-click=onCreateTQ() ng-if="TQ_ACCESS_CREATE > 2"><i class="fa fa-plus ft-white mr-8"></i> <span class=ft-white translate="Create TQ"></span></div></div><spinner ng-if=loading></spinner><div class="mb-24 mt-24 ml-24 mr-24 listViewContainer"><div class="tq-overview-list-container ft_14_regular_gray"><div class=list-table><div class=table-header><div class=flex-3></div><div class=flex-10 translate=Name></div><div class=flex-10 translate=Progress></div><div class=flex-6 translate=Level></div><div class=flex-8 translate=Status></div><div class=flex-10 translate=Location></div><div class=flex-10 translate="Created by"></div><div class=flex-10 translate="Assigned To"></div><div class=flex-10 translate=Company></div><div class=flex-8 translate="Due Date"></div><div class=flex-3 translate=File></div><div class=flex-2><img src=/assets/icons/attach_file.svg></div><div class=flex-2><img src=/assets/icons/tq-message.svg></div><div class=flex-7></div></div><div class=table-body><div ng-repeat="tq in vm.tqs track by $index"><div class=table-row><div class="flex-3 flex-center expander tq-cell"><img ng-src="{{tq.expand ? \'/assets/icons/arrow-drop-up-black.svg\' : \'/assets/icons/arrow-drop-down-black.svg\'}}" alt="" class=cursor-point ng-click=vm.getData($index)></div><div class="flex-10 text-ellipsis tx-ellipsis name" title={{tq.title}}>{{tq.title}}</div><div class="flex-10 tq-progress"><div class="ft-12 line-height-16 fw-400 ft-gray1 w-100 text-align-center">{{tq.progress}}%</div><input type=range min=0 max=100 value={{tq.progress}} class=slider id=myRange ng-model=tq.progress ng-change=updateTq($index)></div><div class="flex-6 tx-ellipsis detail">{{tq.marker.model.info3d.levelName ? tq.marker.model.info3d.levelName : \'\'}}</div><div class="flex-8 tq-status"><selectbox-input ng-class=getTqStatusClass(tq.status) class=statusSelect ng-model=tq.status options=statusList label-field=label value-field=key placeholder="Select Status" select-event=updateTq($index)></selectbox-input></div><div class="flex-10 tx-ellipsis detail">{{tq.location}}</div><div class="flex-10 tx-ellipsis detail">{{tq.userId.displayName}}</div><div class="flex-10 tx-ellipsis detail">{{tq.assignedTo.displayName}}</div><div class="flex-10 tx-ellipsis detail">{{tq.companyId.companyName}}</div><div class=flex-8>{{tq.deadLine | date: "dd MMM yyyy" : \'UTC\' }}</div><div class="flex-3 tx-ellipsis file"><div class="d-flex align-items-center"><img src=/assets/icons/file-text.svg class=mr-8>{{tq.fileName}}</div></div><div class="flex-2 tq-table-count"><div class=tq-count>{{tq.attachCount}}</div></div><div class="flex-2 tq-table-count"><div class=tq-count>{{tq.commentCount}}</div></div><div class="flex-7 detail"><i class="fa fa-edit cursor-point ml-10" ng-click=gotoTqDetail(tq._id)></i><i class="fa fa-trash ml-10 cursor-point" ng-click=deleteTq($index,tq._id)></i></div></div><div class=table-child ng-if=tq.expand><div style="display: flex;height:460px;position:relative;"><spinner ng-if=isLoadingDetail></spinner><div class=detail-left-panel><div class=tq-header-control><div class="switch switch-sm"><input type=checkbox class=switch id=viewValue ng-disabled=isVP ng-model=isPlanViewer ng-checked=isPlanViewer> <label for=viewValue></label></div></div><div id=bimviewer class=bimviewerClass ng-show="!isVP && !isPlanViewer"></div><div id=model2d-container class=marking-viewer ng-show="!isVP && isPlanViewer"><div id=model2d class=marking-viewer></div></div><tqlisttoolbox on-selected=vm.toolbarEvent data=toolbarList ng-if=!isVP></tqlisttoolbox><div id=tq-vp-viewer ng-if=isVP><tq-vp-detail-page ng-repeat="page in vm.vppages" page=page ng-style="{\'visibility\': page===vm.vpCurPage ? \'visible\' : \'hidden\'}"></tq-vp-detail-page><tqlisttoolbox on-selected=vm.vpCurPage.toolbarEvent data=toolbarList ng-if=isVP></tqlisttoolbox></div></div><div class=tq-right-panel><div id=detail-menu class=nav-items><nav class="navbar navbar-expand-lg navbar-light" style="width: 100%;padding: 0px 0px !important;"><ul class=navbar-nav style="width: 100%"><li class=nav-item ng-class="{active: currentTab === \'attach\'}" ng-click="setCurrentTab(\'attach\')"><a href=# class=nav-link translate=Attachments></a></li><li class=nav-item ng-class="{active: currentTab === \'comment\'}" ng-click="setCurrentTab(\'comment\')"><a href=# class=nav-link translate=Comments></a></li><li class=nav-item ng-class="{active: currentTab === \'activity\'}" ng-click="setCurrentTab(\'activity\')"><a href=# class=nav-link translate=Activity></a></li></ul></nav></div><div ng-if="currentTab==\'attach\'" class=upload-box><div class=drag-drop-box ngf-drop ngf-change="vm.fileUpdated($files, $event)" name=file ngf-multiple=true><div class=detail-drag-drop><span translate="Drag and Drop or"></span> <span class="ft-blue ph-5" ngf-select ngf-change="vm.fileUpdated($files, $event)" name=file ngf-multiple=true translate=Browse></span></div></div></div><div ng-if="currentTab==\'attach\'" class=detail-attach-wrap><div class=upload-files ng-if="vm.files && vm.files.length"><div class=upload-file ng-repeat="file in vm.files track by $index" ng-if="file.progressPercentage !== 100"><img class=file-icon ng-src={{vm.utils.getTQFileIcon(file)}} alt=""><div class=progress-container><div class=progress-info><div class=file-name>{{file.name}}</div><div class=progress-value ng-if="file.progressPercentage !== 100">Uploading</div></div><div class=progress-bar><div class=real-progress ng-style="vm.getStyleWidth(file.progressPercentage || 0)"></div></div></div><img ng-if="file.progressPercentage !== 100" class=cancel-icon src=/assets/icons/close-circle-f-gray.svg alt="" ng-click="vm.cancelUpload(file, $index)"> <img ng-if="file.progressPercentage === 100" class=done-icon src=/assets/icons/mark-complete.svg alt=""></div></div><div class=upload-files ng-if=tqData.attachList><div class=upload-file ng-repeat="attach in tqData.attachList track by $index"><img class=file-icon ng-src={{attach.imgSrc}} alt=""><div class=progress-container><div class=progress-info><div class=file-name>{{attach.fileName}}</div><div class=progress-value>Uploaded by <span class="ft-12 line-height-16 fw-400 ft-tq-black1">{{attach.createdBy}} \u2022 </span>{{attach.createdAt | date :\'dd/MM/yyyy\' }}</div></div></div><img src=/assets/icons/Trash-alt.svg class="delete-ico cursor-point ml-8" ng-click=deleteAttach($index,attach._id)></div></div></div><div ng-if="currentTab==\'activity\'" class=detail-activity-wrap><div ng-repeat="activity in tqData.tqActivity track by $index" class=detail-activity-panel><div class=activity-avatar-panel><img src={{activity.pic}} class=activity-avatar><div class=activity-avatar-indicator></div></div><div class=activity-info-panel><div class="d-flex flex-between"><span class="ft-12 line-height-16 fw-600 ft-tq-black1">{{activity.userName}}</span> <span class="ft-12 line-height-16 fw-400 grey-4">{{activity.addedTime | date: "dd MMM yyyy HH:mm" : \'UTC\'}}</span></div><p class=activity-comment>{{activity.activity}}</p></div></div></div><div ng-if="currentTab==\'comment\'" class=detail-chat-wrap><div class=detail-content-chat></div><div class=detail-live-chat><img src=/assets/icons/chat-add.svg> <input type=text class=detail-live-chat-input placeholder="Write your message"> <img src=/assets/icons/chat-emoticon.svg class=ml-12> <img src=/assets/icons/chat-send.svg class=ml-12></div></div></div></div></div></div></div></div></div><div class="flex flex-row pagination-footer flex-items-center"><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span>{{vm.currentPage * numPerPage > totalCount? totalCount: vm.currentPage * numPerPage}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=totalPages current-page=vm.currentPage on-select-page=searchTq()></div></div></div></div></div></div></main>');
$templateCache.put('app/main/tq/tqVpDetailPage/tqVpDetailPage.view.html','<div class=tq-vp-detail-page><div id=tq-vp-viewer class=vp-viewer></div><div id=collision ng-show=vm.collision></div></div>');
$templateCache.put('app/main/typeWritter/typeWritterDetail/typeWritterDetail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><side-navbar page=typewritter></side-navbar><div id=typeWritterDetail class=main-container ng-style="{\'--h\': vm.height + \'px\', \'--w\': vm.width + \'px\'}"><!-- <div class="sub-navigation">\n      <div class="sub-navigation">\n        <a href="#" ng-click="goDashboard()" class="ft_14_regular_gray" translate="Dashboard"></a>\n        <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n        <a ui-sref="typeWritterRichTextGrid" class="ft_14_600_gray" translate="Typewriter"></a>\n      </div>\n    </div> --><spinner ng-show=isLoading></spinner><!-- <div class="title-bar flex-between">\n      <div class="ft_24_600_black1" translate="Typewriter"></div>\n    </div> --><div class="content flex-between"><div class="block description pos-relative" ng-class="id? \'\': \'is-creating\'"><div class="ft_24_600_black header d-flex"><div class="left flex-center">Typewrit<span class=set-color>R</span></div><div class="right flex-between"><div class=doc-title><input class="login_input title-input ft_18_600_black" type=text ng-model=vm.noteInfo.title></div><div class="btn-group d-flex"><button class="btn_primary blue" ng-click=saveTypeWriter()><img src=/assets/icons/publish.svg alt=icons><span translate=Save></span></button> <button class="btn_primary white"><img src=/assets/icons/export-black.svg alt=icons><span translate=Export></span></button> <button class="btn_primary white" ng-click=addMember()><img src=/assets/icons/share-small.svg alt=icons><span translate=Share></span></button> <button class="btn_primary green" ng-click=saveTypeWriter()><img src=/assets/icons/publish.svg alt=icons><span translate=Publish></span></button></div></div></div><div class=docs-content><div class=left-block ng-if=false><div class="btn-group flex-between"><div class=d-flex><button class="btn1 ft_14_600_black" ng-click=OnCommentList()>Pages</button><!-- <button class="btn2 ft_14_600_black" ng-class=" !isComment ? \'active\':\'\'" ng-click="OnInfoList()">Information</button> --></div><img src=/assets/icons/close-24.svg alt=icon class="close-icon cursor-point"></div><div ng-if=isComment><div class="comments mb-15"><div class="flex-between mb-8"><div class="d-flex cursor-point ml-16" ng-click=showAddComment(true)><img src=/assets/icons/bx-plus-black.svg alt=icons class="new-comment-icon cursor-point"><div class=ft_14_600_black translate="New Comment"></div></div></div><div class=item-group><div class="new-comment mb-8" ng-if=isAddingComment><div class="flex-between mb-16"><div class=flex-items-center><img ng-src="{{vm.userData.profilePic? vm.userData.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-24 avatar"><div><div class=ft_12_600_black>{{vm.userData.displayName}}</div></div></div><img src=/assets/icons/more_horiz-gray.svg alt=icon class="more-icon cursor-point"></div><input class="login_input comment-input mb-8" type=text placeholder="Type your comment here" ng-model=vm.comment><div class=text-align-right><img src=/assets/icons/send.svg alt=icon class="close-icon cursor-point" ng-click=submitComment()> <img src=/assets/icons/close-24.svg alt=icon class="close-icon cursor-point" ng-click=showAddComment(false)></div></div><div ng-repeat="comment in vm.comments track by $index"><div class=item><note-comment ng-model=comment></note-comment></div></div></div></div></div><div ng-if=!isComment><div class=infos><div class="d-flex align-items-center mb-10"><img src=/assets/icons/user-black.svg class=icon><div class=ft_12_regular_black><span translate="Created by"></span>&nbsp;<span class=fw-bold>{{vm.noteInfo.createdBy.displayName}}</span></div></div><div class="d-flex align-items-center mb-16"><img src=/assets/icons/bx-calendar-black.svg class=icon><div class=ft_12_regular_black><span translate="Created on"></span>&nbsp;<span class=fw-bold>{{vm.noteInfo.created | date}}</span></div></div><div class="ft_12_regular_black mb-8" translate="Shared with"></div><div class=pos-relative><avatar-group avatars=vm.noteInfo.members more-count-color="\'#ff8b00\'" is-overlap=true height="\'40\'" more-count-background-color="\'#FFE8CC\'"></avatar-group></div></div></div></div><div class=editor><textarea ui-tinymce=tinymceOptions ng-model=vm.content></textarea></div><div class=pop-availability ng-show=popover ng-style="{left:field.left+5+\'px\',top:field.top+115+\'px\'}"><img ng-click="isAddingCommentContent = !isAddingCommentContent" src=/assets/icons/add-comment-b.svg alt=icon class="close-icon cursor-point"></div><div class=pop-availability-content ng-show=popover ng-style="{left:field.leftContent+5+\'px\',top:field.topContent+170+\'px\'}"><div class="new-comment mb-8" ng-show=isAddingCommentContent><div class="flex-between mb-16"><div class=flex-items-center><img ng-src="{{vm.userData.profilePic? vm.userData.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-32 avatar"><div><div class=ft_14_600_black>{{vm.userData.displayName}}</div></div></div><!-- <img src="/assets/icons/mo re_horiz-gray.svg" alt="icon" class="more-icon cursor-point"/> --></div><input class="login_input comment-input mb-8" type=text placeholder="Reply here" ng-model=vm.comment><div class=text-align-left><!-- <img src="/assets/icons/send.svg" alt="icon" class="close-icon cursor-point" ng-click="submitComment()"/>\n                <img src="/assets/icons/close-24.svg" alt="icon" class="close-icon cursor-point" ng-click="showAddComment(false)"/> --> <button class=submitcomment ng-click=submitComment() translate=Comment></button> <button class=discard ng-click="isAddingCommentContent = !isAddingCommentContent" translate=Discard></button></div></div></div><div class=right-block><div class=btn-group><div class=d-flex style=flex:1;><button class="btn1 ft_14_600_black" ng-class=" isComment ? \'active\':\'\'" ng-click=OnCommentList() translate=Comments></button> <button class="btn2 ft_14_600_black" ng-class=" !isComment ? \'active\':\'\'" ng-click=OnInfoList() translate=History></button></div></div><div ng-if=isComment><div class=d-flex style="width: 250px; justify-content:right;"><img ng-click=showAddComment(true) src=/assets/icons/add-comment.svg alt=icon class="mr-8 close-icon cursor-point"> <select><option>All</option></select></div><div class="comments mb-15"><div class=item-group id=right_block_comment_list><div class="new-comment mb-8" ng-if=isAddingComment><div class="flex-between mb-16"><div class=flex-items-center><img ng-src="{{vm.userData.profilePic? vm.userData.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-32 avatar"><div><div class=ft_14_600_black>{{vm.userData.displayName}}</div></div></div></div><input class="login_input comment-input mb-8" type=text placeholder="Reply here" ng-model=vm.comment><div class=text-align-left><button class=submitcomment ng-click=submitComment() translate=Comment></button> <button class=discard ng-click=showAddComment(false) translate=Discard></button></div></div><div data-comment-id={{comment._id}} ng-repeat="comment in vm.comments track by $index" class=comment-list><!-- <div ng-click="changeActiveComment(comment, $index)" ng-show="comment.position" class="pop-availability" ng-style="{position:absolute, left:comment.position.xPosition+\'px\', top:comment.position.yPosition+\'px\'}">\n                      <img src="/assets/icons/add-comment-b.svg" alt="icon" class="close-icon cursor-point"/>\n                    </div> --><div class=item><div ng-click="changeActiveComment(comment, $index)" class="d-flex align-items-center mb-8 comment-header"><img ng-src="{{comment.commentedBy.profilePic? comment.commentedBy.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-32 avatar"><div class=ml-12><div class=ft_14_600_black>{{comment.commentedBy.displayName}}</div><div style="font-size: 12px">{{comment.addTime | date: \'dd, MM, yyyy hh:mm a\' : \'UTC\'}}</div></div></div><div class=note-comment><div class="ft_12_regular_black comment mb-8 ml-40" title={{comment.comment}}>{{comment.comment}}</div><div class=flex-between><div class="ft_12_regular_light text-left cursor-point reply-avatar mr-10" ng-click=toggleReplyCommentModal(comment)><img ng-if=vm.userData.profilePic class=avatar-32 ng-src={{vm.userData.profilePic}} alt=""><div class=ft_12_500_white style="border-radius: 50%;" ng-if=!vm.userData.profilePic data-letters={{vm.utils.nameLetter(vm.userData.displayName)}} ng-style="{\'background\': getColor(vm.userData.displayName) }"></div></div><!-- <div class="ft_12_regular_light text-left cursor-point" ng-if="comment.replies.length" ng-click="expandReplies(comment)">\n                            {{comment.replies.length}}&nbsp;<span translate="Comments"></span>\n                          </div> --> <input ng-click=toggleReplyCommentModal(comment) class="login_input comment-input mb-8" type=text placeholder="Reply here"></div><div ng-repeat="reply in comment.replies"><div><div class="d-flex align-items-center mb-8"><img ng-src="{{reply.commentedBy.profilePic? reply.commentedBy.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-32 avatar"><div><div class=ft_14_600_black style=margin-top:15px;>{{reply.commentedBy.displayName}}</div><div style="font-size: 12px;">{{reply.addTime | date: \'dd, MM, yyyy hh:mm a\' : \'UTC\'}}</div></div></div><div class="ft_12_regular_black comment mb-8 ml-40" title={{reply.comment}}>{{reply.comment}}</div></div></div></div></div></div></div></div></div><div ng-if=!isComment class=docLogHis><div ng-repeat="log in vm.logHis"><div class="d-flex docLogHisItem"><div class="ft_14_600_black logHisUser"><img class="object-fit-cover avatar-32" ng-if=log.createdBy.profilePic class=avatar ng-src={{log.createdBy.profilePic}} alt=""><div ng-if=!log.createdBy.profilePic data-letters={{utils.nameLetter(log.createdBy.displayName)}} ng-style="{ \'background\': getColor(log.createdBy.displayName) }"></div><!-- <img ng-src="{{comment.commentedBy.profilePic? comment.commentedBy.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-32 avatar" > --><div class=ml-24><div class=ft_14_600_black>{{log.createdBy.displayName}}</div><div style="font-size: 12px">{{log.updated | date: \'dd, MM, yyyy hh:mm a\' : \'UTC\'}}</div></div></div></div><div class="d-flex flex-content-end mb-2"><button class="btn_new_blue blue" ng-click=getConstructionContent(log.contentUrl) translate=restore></button> <button class="btn_primary white" ng-click="removeConstructionContent(log._id, log.contentUrl)" translate=remove></button></div></div><!-- <div class="infos">\n                <div class="d-flex align-items-center mb-10">\n                  <img src="/assets/icons/user-black.svg" class="icon">\n                  <div class="ft_12_regular_black"><span translate="Created by"></span>&nbsp;<span class="fw-bold">{{vm.noteInfo.createdBy.displayName}}</span></div>\n                </div>\n                <div class="d-flex align-items-center mb-16">\n                  <img src="/assets/icons/bx-calendar-black.svg" class="icon">\n                  <div class="ft_12_regular_black"><span translate="Created on"></span>&nbsp;<span class="fw-bold">{{vm.noteInfo.created | date}}</span></div>\n                </div>\n                <div class="ft_12_regular_black mb-8" translate="Shared with"></div>\n                <div class="pos-relative">\n                  <avatar-group avatars="vm.noteInfo.members" more-count-color="\'#ff8b00\'" is-overlap="true" height="\'40\'" more-count-background-color="\'#FFE8CC\'"></avatar-group>\n                </div>\n              </div> --></div></div></div><div class="footer flex-between" ng-if=false><div class="like flex-center cursor-point"><img src=/assets/icons/heart-black.svg class="mr-10 icon"><div class=ft_16_regular_black>{{vm.noteInfo.like || 0}}</div></div><div class="share flex-center cursor-point"><img src=/assets/icons/share-alt.svg class="mr-10 icon"><div class=ft_16_regular_black>share</div></div></div></div><div ng-if=false class="block comments" ng-if=id><div class="ft_16_600_black mb-10">Comments</div><textarea class=comments-area placeholder="Write your comments here" ng-model=vm.comment></textarea> <button class="btn_primary submit-btn ft_12_600_white" ng-click=submitComment() translate=Submit></button></div><div ng-if=false class="right-side block" ng-class="id? \'\': \'is-creating\'"><button class="btn_primary action-btn save-btn mb-15" ng-click=saveTypeWriter() translate=Save></button> <button class="btn_primary action-btn cancel-btn mb-30" ui-sref=typeWritterRichTextGrid translate=Cancel></button><div class=summary ng-if=id><div class="d-flex align-items-center mb-10"><img src=/assets/icons/heart.svg class=icon><div class=ft_12_regular_white><span class=fw-bold>{{vm.noteInfo.like || 0}} people</span> liked this</div></div><div class="d-flex align-items-center mb-10"><img src=/assets/icons/attachment-white.svg class=icon><div class=ft_12_regular_white><span class=fw-bold>{{vm.noteInfo.attachments.length || 0}}</span> attachements</div></div><div class="d-flex align-items-center mb-10"><img src=/assets/icons/user-white.svg class=icon><div class=ft_12_regular_white>Created by <span class=fw-bold>{{vm.noteInfo.createdBy.displayName}}</span></div></div><div class="d-flex align-items-center"><img src=/assets/icons/bx-calendar-white.svg class=icon><div class=ft_12_regular_white>Added on <span class=fw-bold>{{vm.noteInfo.created | date}}</span></div></div></div><div class=attachments><div class=flex-between><div class=ft_14_600_white translate=Attachments></div><button class=btn_browse ngf-select ng-model=vm.inputImg ngf-change=vm.fileUpdated($files) name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=true ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><div class="ft_14_600_yellow cursor-point">+ <span translate=Add></span></div></button></div><div class="img-group flex flex-wrap"><div class="img-item pos-relative" ng-repeat="f in vm.noteInfo.attachments" ng-if=!vm.utils.isEmpty(vm.noteInfo.attachments)><img ngf-src="f.secure_url || f" class=object-fit-cover> <a ng-click=vm.deleteFile($index); class="text-danger image_close_btn"><img src=/assets/icons/subtract_white.svg alt=icons class="icon cursor-point"></a></div></div></div><div class=members><div class="flex-between mb-10"><div class=ft_14_600_white translate=Members></div><div class="ft_14_600_yellow cursor-point" ng-click=addMember() translate=Add></div></div><div class=pos-relative><avatar-group avatars=vm.noteInfo.members to-top=true></avatar-group></div></div><div class="comments mb-15" ng-if=id><div class="flex-between mb-20"><div class=ft_14_600_white translate=Comments></div></div><div class=item-group><div class=item ng-repeat="comment in vm.comments track by $index" ng-if="!isShowAll? $index < 2: true"><div class="d-flex align-items-center mb-10"><img ng-src="{{comment.commentedBy.profilePic? comment.commentedBy.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-40 avatar"><div class=ft_12_regular_white><div class=fw-bold>{{comment.commentedBy.displayName}}</div><div>{{comment.addTime | date: \'dd, MM, yyyy hh:mm a\' : \'UTC\'}}</div></div></div><div class="ft_12_regular_white comment" title={{comment.comment}}>{{comment.comment}}</div></div></div></div><div class="more cursor-point" ng-if="id && vm.comments.length > 2" ng-click=showAll()><div class="flex-between mb-20"><div class=ft_14_600_white>{{isShowAll? \'Less\': \'More\'}} <img ng-src="{{isShowAll? \'/assets/icons/chevron-up-white.svg\': \'/assets/icons/chevron-down-white.svg\'}}" class=more-icon></div></div></div></div></div></div></main>');
$templateCache.put('app/main/typeWritter/typeWritterDetailSpreadSheet/typeWritterDetailSpreadSheet.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=typeWritterDetailSpreadSheet class=main-container><side-navbar page=spreadsheet></side-navbar><spinner ng-show=isLoading></spinner><div class=content><div class="block description pos-relative" ng-class="id? \'\': \'is-creating\'"><div class="ft_24_600_black header d-flex"><div class="title-btn-part flex-between w-100"><div class=flex><div class="logo flex"><span>Spread</span><span class=green>sheets</span></div><div class="doc-title flex-items-center"><!-- <img src="/assets/icons/spreadsheet.svg" alt="icons" class="mr-16"/> --> <input class="login_input title-input ft_18_600_black" type=text ng-model=vm.sheetInfo.title></div></div><div class="btn-group d-flex"><button class="btn_primary blue" ng-click=saveSpreadSheet(false)><img src=/assets/icons/publish.svg alt=icons><span translate=Save></span></button> <button class="btn_primary white"><img src=/assets/icons/export-black.svg alt=icons><span translate=Export></span></button> <button class="btn_primary white" ng-click=addMember()><img src=/assets/icons/share.svg alt=icons><span translate=Share></span></button> <button class="btn_primary green" ng-click=saveSpreadSheet(true)><img src=/assets/icons/publish.svg alt=icons><span translate=Publish></span></button></div></div></div><div class=menu-bar><div class=menu-nav-bar><div class="nav-items mr-auto"><li class=nav-item ng-repeat="menu in menudata"><a class=nav-link href=#><span translate={{menu.title}}></span></a><ul ng-show=menu.child><li ng-repeat="menuitem in menu.child"><div class=seperator ng-show=menuitem.seperator></div><a class="dropdown-item flex-between" ng-show=!menuitem.seperator><div class=flex-between ng-show=menuitem.check><div class=checked-field><i class="fa fa-check"></i></div><span translate={{menuitem.title}}></span></div><span translate={{menuitem.title}} ng-show=!menuitem.check></span><div class=menu-shortkey ng-show=menuitem.shortkey>{{menuitem.shortkey}}</div><div class=menu-icon ng-show=menuitem.child></div></a><ul ng-show=menuitem.child><li ng-repeat="submenuitem in menuitem.child"><div class=seperator ng-show=submenuitem.seperator></div><a class="dropdown-item flex-between" data-ng-click="" ng-show=!submenuitem.seperator><div class=flex-between ng-show=submenuitem.check><i class="fa fa-check"></i><span translate={{submenuitem.title}}></span></div><span translate={{submenuitem.title}} ng-show=!submenuitem.check></span><div class=menu-shortkey ng-show=submenuitem.shortkey>{{submenuitem.shortkey}}</div><div class=menu-icon ng-show=submenuitem.child></div></a><ul class=sub-dropdown ng-show=submenuitem.child><li ng-repeat="nanoitem in submenuitem.child"><a class="dropdown-item flex-between" data-ng-click=""><div class=checked-field ng-show={{nanoitem.check}}><i class="fa fa-check"></i></div><span translate={{nanoitem.title}}></span></a></li></ul></li></ul></li><!-- <li>\n                    <a class="dropdown-item flex-between"><div class="flex-between"><i></i><span translate="Create"></span></div><div class="menu-icon"></div></a>\n                    <ul class="sub-dropdown">\n                      <li><a class="dropdown-item" data-ng-click="gotoPage(\'createProject\', ECO_ACCESS_CREATE > 0, true)" translate="Project"></a></li>\n                      <li>\n                        <a class="dropdown-item" data-ng-click="gotoPage(\'createServiceProject\', ECO_ACCESS_CREATE > 0, true)" translate="Service project"></a>\n                        <ul class="sub-dropdown">\n                          <li><a class="dropdown-item flex-between" data-ng-click=""><div class="checked-field"><i class="fa fa-check"></i></div><span translate="80"></span></a></li>\n                          <li><a class="dropdown-item flex-between" data-ng-click=""><div class="checked-field"></div><span translate="80"></span></a></li>\n                          <li><a class="dropdown-item flex-between" data-ng-click=""><div class="checked-field"></div><span translate="80"></span></a></li>\n                        </ul>\n                      </li>\n                      <li><a class="dropdown-item" data-ng-click="" translate="Work order"></a></li>\n                    </ul>\n                  </li>\n                  <li>\n                    <div class = "seperator"> </div>\n                  </li>\n                  <li>\n                    <a class="dropdown-item flex-between" data-ng-click="gotoPage(\'createProject\', ECO_ACCESS_CREATE > 0, true)"><div class="flex-between"><div class="checked-field"></div><span translate="Overview"></span></div><div class="menu-shortkey">Ctrl + p</div></a>\n                  </li>\n                  <li>\n                    <a class="dropdown-item flex-between" data-ng-click="gotoPage(\'createProject\', ECO_ACCESS_CREATE > 0, true)"><div class="flex-between"><div class="checked-field"><i class="fa fa-check"></i></div><span translate="Overview"></span></div><div class="menu-shortkey">Ctrl + p</div></a>\n                  </li> --></ul></li></div></div><div class=other-tool><div class=tool-wrapper ng-style="{ \'border-top\': \'2px solid \' + (getColor(vm.userData.displayName)) }"><div class=tool-btn ng-style="{ \'background-color\': (getColor(vm.userData.displayName)) }">{{vm.userData.displayName | mailAvatarChar}}</div></div></div></div><div class=docs-content><div class=editor><div id=ssheet></div></div><div class=pop-availability ng-show=popover ng-style="{left:(field.left)+\'px\',top:(field.top - 40) + \'px\'}"><img ng-click="isAddingCommentContent = !isAddingCommentContent" src=/assets/icons/add-comment-b.svg alt=icon class="close-icon cursor-point"></div><div class=pop-availability-content ng-style="{left:(field.left)+\'px\',top:(field.top)+\'px\'}"><div class="new-comment mb-8" ng-show=isAddingCommentContent><div class="flex-between mb-16"><div class=flex-items-center><img ng-src="{{vm.userData.profilePic? vm.userData.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-32 avatar"><div><div class=ft_14_600_black>{{vm.userData.displayName}}</div></div></div><!-- <img src="/assets/icons/mo re_horiz-gray.svg" alt="icon" class="more-icon cursor-point"/> --></div><input class="login_input comment-input mb-8" type=text placeholder="Reply here" ng-model=vm.comment><div class=text-align-left><!-- <img src="/assets/icons/send.svg" alt="icon" class="close-icon cursor-point" ng-click="submitComment()"/>\n                <img src="/assets/icons/close-24.svg" alt="icon" class="close-icon cursor-point" ng-click="showAddComment(false)"/> --> <button class=submitcomment ng-click=submitComment() translate=Comment></button> <button class=discard ng-click="isAddingCommentContent = !isAddingCommentContent" translate=Discard></button></div></div></div><div class=right-block><div class=btn-group><div class=d-flex style=flex:1;><button class="btn1 ft_14_600_black" ng-class=" isComment ? \'active\':\'\'" ng-click=OnCommentList() translate=Comments></button> <button class="btn2 ft_14_600_black" ng-class=" !isComment ? \'active\':\'\'" ng-click=OnInfoList() translate=History></button></div></div><div ng-if=isComment><div class=d-flex style="width: 250px; justify-content:right;"><img ng-click=showAddComment(true) src=/assets/icons/add-comment.svg alt=icon class="mr-8 close-icon cursor-point"> <select><option>All</option></select></div><div class="comments mb-15"><div class=item-group id=right_block_comment_list><div class="new-comment mb-8" ng-if=isAddingComment><div class="flex-between mb-16"><div class=flex-items-center><img ng-src="{{vm.userData.profilePic? vm.userData.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-32 avatar"><div><div class=ft_14_600_black>{{vm.userData.displayName}}</div></div></div></div><input class="login_input comment-input mb-8" type=text placeholder="Reply here" ng-model=vm.comment><div class=text-align-left><button class=submitcomment ng-click=submitComment() translate=Comment></button> <button class=discard ng-click=showAddComment(false) translate=Discard></button></div></div><div data-comment-id={{comment._id}} ng-repeat="comment in vm.comments track by $index" class=comment-list><!-- <div ng-click="changeActiveComment(comment, $index)" ng-show="comment.position" class="pop-availability" ng-style="{position:absolute, left:comment.position.xPosition+\'px\', top:comment.position.yPosition+\'px\'}">\n                      <img src="/assets/icons/add-comment-b.svg" alt="icon" class="close-icon cursor-point"/>\n                    </div> --><div class=item><div ng-click="changeActiveComment(comment, $index)" class="d-flex align-items-center mb-8 comment-header"><img ng-src="{{comment.commentedBy.profilePic? comment.commentedBy.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-32 avatar"><div class=ml-12><div class=ft_14_600_black>{{comment.commentedBy.displayName}}</div><div style="font-size: 12px">{{comment.addTime | date: \'dd, MM, yyyy hh:mm a\' : \'UTC\'}}</div></div></div><div class=note-comment><div class="ft_12_regular_black comment mb-8 ml-40" title={{comment.comment}}>{{comment.comment}}</div><div class=flex-between><div class="ft_12_regular_light text-left cursor-point reply-avatar mr-10" ng-click=toggleReplyCommentModal(comment)><img ng-if=vm.userData.profilePic class=avatar-32 ng-src={{vm.userData.profilePic}} alt=""><div class=ft_12_500_white style="border-radius: 50%;" ng-if=!vm.userData.profilePic data-letters={{vm.utils.nameLetter(vm.userData.displayName)}} ng-style="{\'background\': getColor(vm.userData.displayName) }"></div></div><!-- <div class="ft_12_regular_light text-left cursor-point" ng-if="comment.replies.length" ng-click="expandReplies(comment)">\n                            {{comment.replies.length}}&nbsp;<span translate="Comments"></span>\n                          </div> --> <input ng-click=toggleReplyCommentModal(comment) class="login_input comment-input mb-8" type=text placeholder="Reply here"></div><div ng-repeat="reply in comment.replies"><div><div class="d-flex align-items-center mb-8"><img ng-src="{{reply.commentedBy.profilePic? reply.commentedBy.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-32 avatar"><div><div class=ft_14_600_black style=margin-top:15px;>{{reply.commentedBy.displayName}}</div><div style="font-size: 12px;">{{reply.addTime | date: \'dd, MM, yyyy hh:mm a\' : \'UTC\'}}</div></div></div><div class="ft_12_regular_black comment mb-8 ml-40" title={{reply.comment}}>{{reply.comment}}</div></div></div></div></div></div></div></div></div><div ng-if=!isComment class=docLogHis><div ng-repeat="log in vm.logHis"><div class="d-flex docLogHisItem"><div class="ft_14_600_black logHisUser"><img class="object-fit-cover avatar-32" ng-if=log.createdBy.profilePic class=avatar ng-src={{log.createdBy.profilePic}} alt=""><div ng-if=!log.createdBy.profilePic data-letters={{utils.nameLetter(log.createdBy.displayName)}} ng-style="{ \'background\': getColor(log.createdBy.displayName) }"></div><!-- <img ng-src="{{comment.commentedBy.profilePic? comment.commentedBy.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-32 avatar" > --><div class=ml-24><div class=ft_14_600_black>{{log.createdBy.displayName}}</div><div style="font-size: 12px">{{log.updated | date: \'dd, MM, yyyy hh:mm a\' : \'UTC\'}}</div></div></div></div><div class="d-flex flex-content-end mb-2"><button class="btn_new_blue blue" ng-click=restoreContent(log.contents) translate=restore></button> <button class="btn_primary white" ng-click=removeContent(log._id) translate=remove></button></div></div><!-- <div class="infos">\n                <div class="d-flex align-items-center mb-10">\n                  <img src="/assets/icons/user-black.svg" class="icon">\n                  <div class="ft_12_regular_black"><span translate="Created by"></span>&nbsp;<span class="fw-bold">{{vm.noteInfo.createdBy.displayName}}</span></div>\n                </div>\n                <div class="d-flex align-items-center mb-16">\n                  <img src="/assets/icons/bx-calendar-black.svg" class="icon">\n                  <div class="ft_12_regular_black"><span translate="Created on"></span>&nbsp;<span class="fw-bold">{{vm.noteInfo.created | date}}</span></div>\n                </div>\n                <div class="ft_12_regular_black mb-8" translate="Shared with"></div>\n                <div class="pos-relative">\n                  <avatar-group avatars="vm.noteInfo.members" more-count-color="\'#ff8b00\'" is-overlap="true" height="\'40\'" more-count-background-color="\'#FFE8CC\'"></avatar-group>\n                </div>\n              </div> --></div></div></div></div></div></div></main>');
$templateCache.put('app/main/typeWritter/typeWritterRichTextGrid/typeWritterRichTextGrid.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=typeWritterRichTextGrid class=main-container><div class=content-grid-wrapper><!-- <div class="sub-navigation">\n        <div class="sub-navigation">\n          <a href="#" ng-click="goDashboard()" class="ft_14_regular_gray" translate="Dashboard"></a>\n          <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n          <a ui-sref="typeWritterRichTextGrid" class="ft_14_600_gray" translate="Typewriter"></a>\n        </div>\n      </div> --><div class="title-bar flex-between align-items-center"><div class=title-bar-container><div><div class=flex-between><div><a ng-click=showDashboard() class=ft_14_regular_gray translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref="" class=ft_14_600_gray>typewriter</a></div></div><div class=header-title translate=TypeWriter></div></div><div class="sub-header flex-between align-items-center"><div class=btn-group><searchbox search-text=vm.searchText search-event=searchCallback() is-small=true class=mr-24></searchbox><div ng-if=isGrid><button class=btn-trans ng-click=onListView()><img src=/assets/images/sales/bx-list-ul.svg alt=icons class=margin-0></button> <button class=btn-trans ng-click=onGridView()><img ng-style="{opacity: isGrid ? \'1.0\' :\'0.5\'}" src=/assets/images/sales/grid-blue.svg alt=icons class=ml-2></button></div><div ng-if=isList><button class=btn-trans ng-click=onListView()><img src=/assets/images/sales/bx-list-ul1.svg alt=icons class=margin-0></button> <button class=btn-trans ng-click=onGridView()><img ng-style="{opacity: isGrid ? \'1.0\' :\'0.5\'}" src=/assets/images/sales/grid-blue.svg alt=icons class=ml-2></button></div><button class="btn_new_blue ml-24" ui-sref=typeWritterAdd><img src=/assets/icons/bx-plus-circle.svg alt=icons><span translate="Create New"></span></button></div></div></div></div><spinner ng-show=isLoading></spinner><!-- <div class="sub-header flex-between mb-16">\n        <div class="d-flex btn-group">\n          <button class="btn_nav_active" ui-sref="typeWritterRichTextGrid" translate="RichText"></button>\n          <button class="btn_nav_inactive" ui-sref="typeWritterSpreadSheetGrid" translate="SpreadSheet"></button>\n        </div>\n        <button class="btn_primary ml-24" ui-sref="typeWritterAdd">\n          <img src="/assets/icons/bx-plus-circle.svg" alt="icons"/><span translate="Create New"></span>\n        </button>\n      </div> --><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0"><div class=content><div class="flex flex-wrap" ng-if=isGrid><type-writter-card type="\'note\'" ng-repeat="item in vm.constructionNotes" data=item updated-event=vm.fetchTypeWritter() class=type-writter-card-container permission=NOTE_ACCESS_CREATE></type-writter-card></div><!-- <div class="split flex-between mb-30">\n            <div>\n            <span class="ft_14_600_gray mr-15">Showing {{(vm.currentPage - 1) * numPerPage + 1}} - <span>{{vm.currentPage * numPerPage > totalCount? totalCount: vm.currentPage * numPerPage}}</span> of {{totalCount}} - <span\n              translate="Typewriter RichText"></span></span></span>\n            </div>\n            <hr class="split-line"/>\n            <div class="flex-center">\n              <pagination num-pages="noOfPages" current-page="vm.currentPage"\n                on-select-page="vm.fetchTypeWritter()"></pagination>\n            </div>\n          </div> --><div class="table-wrap ft_14_regular_light card-based-content-grid-wrapper" ng-if=isList><div class="flex thead"><div class=flex-2><!-- <label class="check_yellow_20"><input type="checkbox" ng-model="isAccepted"/><span class="checkmark"></span></label> --></div><div class="flex-15 th cursor-point" ng-click="vm.sort(\'title\')">Name<!-- <img src="/assets/icons/arrow_drop_down.svg" alt=""> --></div><div class="flex-33 th cursor-point" ng-click="vm.sort(\'title\')">Content<!-- <img src="/assets/icons/arrow_drop_down.svg" alt=""> --></div><div class="flex-15 th cursor-point" ng-click="vm.sort(\'created\')">Create Date<!-- <img src="/assets/icons/arrow_drop_down.svg" alt=""> --></div><div class="flex-15 th cursor-point" ng-click="vm.sort(\'updated\')">Last Modified<!-- <img src="/assets/icons/arrow_drop_down.svg" alt=""> --></div></div><spinner ng-show=isLoading></spinner><div class="flex trow" ng-repeat="note in vm.constructionNotes" ng-if=!isLoading><div class="flex-2 td"></div><div class="flex-15 td">{{note.title}}</div><div class="flex-33 td some-content" ng-bind-html=cleanUp(note.content)></div><div class="flex-15 td">{{note.created | date: "dd MMM yyyy" : \'UTC\' }}</div><div class="flex-15 td">{{note.updated | date: "dd MMM yyyy" : \'UTC\' }}</div><div class="flex-20 td operator"><img class=mr-16 src=/assets/images/dashboard/eye-outline.svg alt=logo class=cursor-point> <img class=mr-16 src="/assets/images/dashboard/bxs-download 2.svg" alt=logo class=cursor-point ng-click=download(note._id)> <img class=mr-16 src=/assets/images/dashboard/share-alt.svg alt=logo class=cursor-point> <img class=mr-16 src=/assets/images/dashboard/bx-edit.svg alt=logo class=cursor-point ng-click=showDetail(note._id)> <img class=mr-16 src=/assets/images/dashboard/Trash-alt.svg alt=logo class=cursor-point ng-click=delete(note._id)></div></div></div><div class="flex flex-row pagination-footer flex-items-center flex-content-end"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.constructionNotes.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchTypeWritter()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/typeWritter/typeWritterSpreadSheetGrid/typeWritterSpreadSheetGrid.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=typeWritterSpreadSheetGrid class=main-container><div class="title-bar flex-between align-items-center"><div class=title-bar-container><div><div class=flex-between><div><a ng-click=showDashboard() class=ft_14_regular_gray translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref="" class=ft_14_600_gray>spreadsheet</a></div></div><div class=header-title translate=SpreadSheet></div></div><div class="sub-header flex-between align-items-center"><div class=btn-group><searchbox search-text=vm.searchText search-event=searchCallback() is-small=true class=mr-24></searchbox><div ng-if=isGrid><button class=btn-trans ng-click=onListView()><img src=/assets/images/sales/bx-list-ul.svg alt=icons class=margin-0></button> <button class=btn-trans ng-click=onGridView()><img ng-style="{opacity: isGrid ? \'1.0\' :\'0.5\'}" src=/assets/images/sales/grid-blue.svg alt=icons class=ml-2></button></div><div ng-if=isList><button class=btn-trans ng-click=onListView()><img src=/assets/images/sales/bx-list-ul1.svg alt=icons class=margin-0></button> <button class=btn-trans ng-click=onGridView()><img ng-style="{opacity: isGrid ? \'1.0\' :\'0.5\'}" src=/assets/images/sales/grid-blue.svg alt=icons class=ml-2></button></div><button class="btn_new_blue ml-24" ui-sref=typeWritterSpreadSheetAdd><img src=/assets/icons/bx-plus-circle.svg alt=icons><span translate="Create New"></span></button></div></div></div></div><spinner ng-show=isLoading></spinner><div class=content-grid-wrapper><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0"><div class=content><div class="flex flex-wrap" ng-if=isGrid><type-writter-card type="\'sheet\'" ng-repeat="item in vm.constructionNotes" data=item updated-event=vm.fetchTypeWritter() class=type-writter-card-container permission=NOTE_ACCESS_CREATE></type-writter-card></div><div class="table-wrap ft_14_regular_light card-based-content-grid-wrapper" ng-if=isList><div class="flex thead"><div class=flex-2><!-- <label class="check_yellow_20"><input type="checkbox" ng-model="isAccepted"/><span class="checkmark"></span></label> --></div><div class="flex-30 th cursor-point" ng-click="vm.sort(\'title\')">Name<!-- <img src="/assets/icons/arrow_drop_down.svg" alt=""> --></div><div class="flex-16 th cursor-point" ng-click="vm.sort(\'created\')">Create Date<!-- <img src="/assets/icons/arrow_drop_down.svg" alt=""> --></div><div class="flex-16 th cursor-point" ng-click="vm.sort(\'updated\')">Last Modified<!-- <img src="/assets/icons/arrow_drop_down.svg" alt=""> --></div></div><spinner ng-show=isLoading></spinner><div class="flex trow" ng-repeat="note in vm.constructionNotes" ng-if=!isLoading><div class="flex-2 td"></div><div class="flex-30 td">{{note.title}}</div><div class="flex-16 td">{{note.created | date: "dd MMM yyyy" : \'UTC\' }}</div><div class="flex-16 td">{{note.updated | date: "dd MMM yyyy" : \'UTC\' }}</div><div class="flex-30 td operator"><img src=/assets/images/dashboard/eye-outline.svg alt=logo class=cursor-point> <img src="/assets/images/dashboard/bxs-download 2.svg" alt=logo class=cursor-point ng-click=download(note._id)> <img src=/assets/images/dashboard/share-alt.svg alt=logo class=cursor-point> <img src=/assets/images/dashboard/bx-edit.svg alt=logo class=cursor-point ng-click=showDetail(note._id)> <img src=/assets/images/dashboard/Trash-alt.svg alt=logo class=cursor-point ng-click=delete(note._id)></div></div></div><!-- <div class="flex flex-wrap" ng-if="isList">\n            <type-writter-card \n              type="\'sheet\'" \n              ng-repeat="item in vm.constructionNotes" \n              data="item" \n              updated-event="vm.fetchTypeWritter()" \n              class="type-writter-card-container"\n              permission="NOTE_ACCESS_CREATE">\n            </type-writter-card>\n          </div> --><!-- <div class="split flex-between mb-30 pl-14 pr-14">\n            <div>\n            <span class="ft_14_600_gray mr-15">Showing {{(vm.currentPage - 1) * numPerPage + 1}} - <span>{{vm.currentPage * numPerPage > totalCount? totalCount: vm.currentPage * numPerPage}}</span> of {{totalCount}} - <span\n              translate="Typewriter SpreadSheet"></span></span></span>\n            </div>\n            <hr class="split-line"/>\n            <div class="flex flex-items-center">\n                <pagination-custom-new num-pages="noOfPages" current-page="vm.currentPage" on-select-page="fetchTypeWritter()">\n                </pagination-custom>\n            </div>\n          </div> --><div class="flex flex-row pagination-footer flex-items-center flex-content-end"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{vm.currentPage * numPerPage > totalCount? totalCount: vm.currentPage * numPerPage}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchTypeWritter()></pagination-custom-new></div></div></div></div></div></div></main>');
$templateCache.put('app/main/auth/directives/login-left-block/login-left-block.view.html','<div class=login-left-block><img src=/assets/images/login/ellipse-tl.svg alt="" class=bg-top-left> <img src=/assets/images/login/ellipse-br.svg alt="" class=bg-bottom-right> <img src=/assets/images/login/dots.svg alt="" class=bg-top-right><div class=title-group><div class=title-normal><span translate="Welcome to"></span> <span class=fw-bold>CloudES</span></div><div class="title-large mt-24"><span translate="An end-to-end solution"></span><br><span translate="for construction industry"></span></div><div class="title-detail mt-16"><span translate="Keep track of your company\'s projects, resources and finances with the CloudES"></span><br><span translate="platform, which is specially designed to meet all the needs of the construction"></span><br><span translate=industry.></span></div></div></div>');
$templateCache.put('app/main/auth/modals/authCompaniesModal/authCompaniesModal.view.html','<div id=authCompaniesModal><div class=header><span translate="Select Company"></span><div class=cursor-point ng-click=vm.cancel()><img src=/assets/icons/close-24-dark.svg alt=icons></div></div><div class=content><div class=company-item ng-repeat="company in vm.companies track by $index" ng-click=vm.select(company)><img ng-src={{company.companyLogo}} alt=logo><div class=item-title>{{company.companyName}}</div></div></div></div>');
$templateCache.put('app/main/calc/companyBudget/template/companyBudgetTemplate.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=companyBudgetTemplate class=main-container><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref="calcExtra({id: \'prepare\'})" class="ft-normal-12-16 grey-2" translate=Calculation></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=companyBudget class="ft-normal-12-16 grey-2" translate="Company Budget"></a></div><div class=header-title translate=Template></div></div><div class="flex-between ml-auto"><selectbox-input class="templates dropdown-primary" options=vm.templates ng-model=vm.templateId placeholder="Choose Template" label-field=year value-field=_id select-event=vm.selectTemplate()></selectbox-input><div class="dropdown ml-20"><div class=button-primary data-toggle=dropdown><img src=/assets/icons/bx-plus.svg alt=""><span translate="Add New Section"></span></div><div class=dropdown-menu><div class=menu-item ng-click="vm.addSection(\'revenue\')" translate=Revenue></div><div class=menu-item ng-click="vm.addSection(\'expense\')" translate=Expense></div><div class=menu-item ng-click=vm.addTotalSum() translate=Sum></div></div></div><div class="button-secondary ml-20" ng-click=vm.save()><img src=/assets/icons/bx-save.svg alt=""><span translate="Save Template"></span></div></div></div><div class=budget-table ng-repeat="section in vm.sections"><div class=table-grid><div class=table-header><div class="table-cell d-flex"><input type=text ng-model=section.name> <img src=/assets/icons/trash-alt-white.svg class=cursor-point alt="" ng-click=vm.removeSection($index)></div></div><div class=table-content><div class=table-row ng-repeat-start="budget in section.budgets"><div class="table-cell d-flex"><div class=number>{{budget.index}}</div><div class="ml-10 w-90"><div class=cell-title><input type=text ng-model=budget.title></div><div class=cell-content><input type=text ng-model=budget.subtitle ng-change=vm.changeSubtitle(budget)></div></div><img src=/assets/icons/trash-alt3.svg class="remove-icon cursor-point" alt="" ng-click="vm.removeBudget($index, section)"></div></div><div class="table-row child" ng-repeat-end=budget ng-repeat="child in budget.children"><div class="table-cell d-flex"><div class=number>{{budget.index}}.{{$index + 1}}</div><div class="ml-10 w-90"><div class=cell-title><input type=text ng-model=child.title></div><div class=cell-content><input type=text ng-model=child.subtitle></div></div><img src=/assets/icons/trash-alt3.svg class="remove-icon cursor-point" alt="" ng-click="vm.removeBudgetChild($index, budget)"></div></div><div class="table-row summary"><div class="table-cell flex-items-center"><div class=number>*</div><div class="cell-title ml-10"><input type=text ng-model=section.dynamicSum.title></div></div></div><div class="table-row summary" ng-repeat="summary in section.summaries"><div class="table-cell flex-items-center"><div class=number>{{summary.index}}</div><div class="cell-title ml-10"><input type=text ng-model=summary.title></div><div class=summary-value><selectbox class=sum-equation ng-model=summary.equation.type options=vm.equations label-field=label value-field=id></selectbox><div class=sum-field ng-click=vm.changeSumField(summary)>{{getSummaryFields(summary)}}</div></div><img src=/assets/icons/trash-alt3.svg class="remove-icon cursor-point" alt="" ng-click="vm.removeSummary($index, section)"></div></div></div></div><div class=table-action><div class=dropdown><div class=add-line data-toggle=dropdown><img src=/assets/icons/bx-plus-black.svg alt="" translate="Add New Line"></div><div class=dropdown-menu><div class=menu-item ng-click=vm.addBudget(section)>Data Line</div><div class=menu-item ng-click=vm.addSummary(section)>Summary Line</div></div></div></div></div><div class="budget-table mt-20" ng-repeat="summary in vm.summaries"><div class="table-col table-grid"><div class=table-header><div class="table-cell d-flex"><input type=text ng-model=summary.name> <img src=/assets/icons/trash-alt-white.svg class=cursor-point alt="" ng-click=vm.removeTotalSum($index)></div></div><div class=table-content><div class="table-row summary"><div class="table-cell flex-items-center"><div class="cell-title ml-10"><input type=text ng-model=summary.title></div><div class=summary-value><selectbox class=sum-equation ng-model=summary.equation.type options=vm.equations label-field=label value-field=id></selectbox><div class=sum-field ng-click=vm.changeSumField(summary)>{{getSummaryFields(summary)}}</div></div></div></div></div></div></div></div><spinner ng-if=isLoading></spinner></main>');
$templateCache.put('app/main/calc/directives/budgetGroup/budgetGroup.view.html','<div id=budget-group><div class=level-wrapper><selectbox-input class=level-selector ng-repeat="filter in vm.filters" ng-model=filter.groupId options=filter.groups label-field=name value-field=_id select-event="vm.selectGroup(filter, $index)"></selectbox-input></div><div class=budget-table><div class=table-header><div class=flex-4></div><div class=flex-32 translate={{vm.groupTypeName}}></div><div class=flex-6></div><div class=flex-12 translate="Cost Price"></div><div class=flex-12 translate="Negotiated Price"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-10 translate=Profit></div><div class=flex-12 translate="Sales Price"></div><div class=flex-4></div></div><div class=table-body><div ng-repeat="budgetAll in vm.budget.budgets" ng-if="vm.type === \'all\'"><div class=table-row><div class="flex-4 flex-center"><img ng-src="{{budgetAll.expand ? \'/assets/icons/arrow-drop-up-black.svg\' : \'/assets/icons/arrow-drop-down-black.svg\'}}" alt="" class=cursor-point ng-click="budgetAll.expand = !budgetAll.expand"></div><div class="flex-15 fw-600 text-ellipsis" title={{budgetAll.name}}>{{budgetAll.name}}</div><div class=flex-6></div><div class=flex-4></div><div class=flex-8></div><div class=flex-5></div><div class=flex-12>{{vm.currency}} {{budgetAll.costPrice | readable: 2}}</div><div class="flex-12 ne-input">{{vm.currency}} <input type=text class=text-left ng-model=budgetAll.negotiatedPrice ng-blur=vm.changeBudgetAllNegotiated(budgetAll) number-edit=2></div><div class=flex-8>{{budgetAll.profitPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{budgetAll.profit | readable: 2}}</div><div class=flex-12>{{vm.currency}} {{budgetAll.calculatedPrice | readable: 2}}</div><div class="flex-4 flex-center more"><div class=dropdown><img src=/assets/icons/more-horiz-dark.svg alt="" class=cursor-point data-toggle=dropdown><div class=dropdown-menu role=menu><div class=menu-item ng-click=vm.deleteBudget(budget) ng-if="vm.permission > 3"><img src=/assets/icons/delete4.svg class="ml-4 mr-12" alt="">Delete</div></div></div></div></div><div class=table-row-all ng-repeat="budget in budgetAll.budgets" ng-if=budgetAll.expand ng-include="\'app/main/calc/directives/budgetGroup/budgetItem.html\'"></div></div><div ng-repeat="budget in vm.budget.budgets" ng-if="vm.type !== \'all\'" ng-init="budget.subName=vm.budget.subName" ng-include="\'app/main/calc/directives/budgetGroup/budgetItem.html\'"></div></div><div class=table-footer><div class=flex-8></div><div class="flex-12 fw-600" translate="Calculated Total"></div><div class=flex-4></div><div class=flex-4></div><div class=flex-8></div><div class=flex-6></div><div class=flex-12>{{vm.currency}} {{vm.budget.costPrice | readable: 2}}</div><div class=flex-12>{{vm.currency}} {{vm.budget.negotiatedPrice | readable: 2}}</div><div class=flex-8>{{vm.budget.profitPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{vm.budget.profit | readable: 2}}</div><div class=flex-12>{{vm.currency}} {{vm.budget.calculatedPrice | readable: 2}}</div><div class=flex-4></div></div><div class="table-footer negotiated"><div class=flex-8></div><div class="flex-12 fw-600" translate="Negotiated Total"></div><div class=flex-4></div><div class=flex-4></div><div class=flex-8></div><div class=flex-6></div><div class=flex-12></div><div class=flex-12>{{vm.currency}} {{vm.budget.negotiatedPrice | readable: 2}}</div><div class=flex-8>{{vm.budget.profitNPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{vm.budget.profitN | readable: 2}}</div><div class=flex-12>{{vm.currency}} {{vm.budget.calculatedPrice | readable: 2}}</div><div class=flex-4></div></div></div></div>');
$templateCache.put('app/main/calc/directives/budgetGroup/budgetItem.html','<div class=table-row><div class="flex-4 flex-center expander"><img ng-src="{{budget.expand ? \'/assets/icons/arrow-drop-up-black.svg\' : \'/assets/icons/arrow-drop-down-black.svg\'}}" alt="" class=cursor-point ng-click="budget.expand = !budget.expand"></div><div class="flex-15 fw-600 text-ellipsis" title={{budget.name}}>{{budget.name}}</div><div class=flex-6></div><div class=flex-4></div><div class=flex-8></div><div class=flex-5></div><div class=flex-12>{{vm.currency}} {{budget.costPrice | readable: 2}}</div><div class="flex-12 ne-input">{{vm.currency}} <input type=text class=text-left ng-model=budget.negotiatedPrice ng-blur=vm.changeBudgetNegotiated(budget) number-edit=2></div><div class=flex-8>{{budget.profitPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{budget.profit | readable: 2}}</div><div class=flex-12>{{vm.currency}} {{budget.calculatedPrice | readable: 2}}</div><div class="flex-4 flex-center more"><div class=dropdown><img src=/assets/icons/more-horiz-dark.svg alt="" class=cursor-point data-toggle=dropdown><div class=dropdown-menu role=menu><div class=menu-item value="" ng-click=vm.deleteBudget(budget) ng-if="vm.permission > 3"><img src=/assets/icons/delete4.svg class="ml-4 mr-12" alt="">Delete</div></div></div></div></div><div class=table-child ng-if=budget.expand><div ng-if="!vm.isLabor(budget) && !vm.isEquipment(budget)"><div class="table-child-row header"><div class=flex-4></div><div class=flex-15>{{budget.subName}}</div><div class=flex-6 translate=Quantity></div><div class=flex-4 translate=Unit></div><div class=flex-8 translate="Unit Price"></div><div class=flex-5 translate=Waste></div><div class=flex-12 translate="Cost Price"></div><div class=flex-12 translate="Negotiated Price"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-10 translate=Profit></div><div class=flex-12 translate="Sales Price"></div><div class=flex-4></div></div><div class=table-child-row ng-repeat="item in budget.items"><div class=flex-4></div><div class="flex-15 text-ellipsis" title={{item.inventoryName}}>{{item.inventoryName}}</div><div class=flex-6>{{item.inventoryAmount | readable: 2}}</div><div class=flex-4>{{item.inventoryUnit}}</div><div class=flex-8>{{vm.currency}} {{item.inventoryUnitPrice | readable: 2}}</div><div class="flex-5 waste"><div ng-include="\'app/main/calc/directives/budgetGroup/waste.html\'"></div></div><div class=flex-12>{{vm.currency}} {{item.inventoryCostPrice | readable: 2}}</div><div class="flex-12 ne-input">{{vm.currency}} <input type=text class=text-left ng-model=item.salesPriceN ng-blur="vm.changeItemNegotiated(item, budget, false)" number-edit=2></div><div class=flex-8>{{item.inventoryProfitPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{item.inventoryProfit | readable: 2}}</div><div class=flex-12>{{vm.currency}} {{item.salesPrice | readable: 2}}</div><div class="flex-4 flex-center more"><div class=dropdown><img src=/assets/icons/more-horiz-dark.svg alt="" class=cursor-point data-toggle=dropdown><div class=dropdown-menu role=menu><div class=menu-item ng-click=vm.viewItem(item)><img src=/assets/icons/alarm2.svg class="ml-4 mr-12" alt="">View Material</div><div class=menu-item ng-click=vm.deleteItem(item) ng-if="vm.permission > 3"><img src=/assets/icons/delete4.svg class="ml-4 mr-12" alt="">Delete</div><div class=menu-item ng-if=item.modelId ng-click=vm.locViewItem(item)><img src=/assets/icons/preview-eye1.svg class=mr-8 alt="">Location View</div></div></div></div></div></div><div ng-if=vm.isLabor(budget)><div class="table-child-row header"><div class=flex-4></div><div class=flex-15>{{budget.subName}}</div><div class=flex-6 translate=Quantity></div><div class=flex-4 translate=Unit></div><div class=flex-8 translate="Unit Price"></div><div class=flex-5></div><div class=flex-12 translate="Cost Price"></div><div class=flex-12 translate="Negotiated Price"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-10 translate=Profit></div><div class=flex-12 translate="Sales Price"></div><div class=flex-4></div></div><div class=table-child-row ng-repeat="item in budget.items"><div class=flex-4></div><div class="flex-15 text-ellipsis" title="{{item.inventoryName || item.workerName}}">{{item.inventoryName || item.workerName}}</div><div class=flex-6>{{item.workerAmount | readable: 2}}</div><div class=flex-4>{{item.workerUnit}}</div><div class=flex-8>{{vm.currency}} {{item.workerUnitPrice | readable: 2}}</div><div class=flex-5></div><div class=flex-12>{{vm.currency}} {{item.inventoryCostPrice | readable: 2}}</div><div class="flex-12 ne-input">{{vm.currency}} <input type=text class=text-left ng-model=item.workersPriceN ng-blur="vm.changeItemNegotiated(item, budget, true)" number-edit=2></div><div class=flex-8>{{item.workerProfitPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{item.workerProfit | readable: 2}}</div><div class=flex-12>{{vm.currency}} {{item.workersPrice | readable: 2}}</div><div class="flex-4 flex-center more"><div class=dropdown><img src=/assets/icons/more-horiz-dark.svg alt="" class=cursor-point data-toggle=dropdown><div class=dropdown-menu role=menu><div class=menu-item value="" ng-click=vm.viewItem(item)><img src=/assets/icons/alarm2.svg class=mr-16 alt="">View Material</div><div class=menu-item value="" ng-click=vm.deleteItem(item) ng-if="vm.permission > 3"><img src=/assets/icons/delete4.svg class=mr-16 alt="">Delete</div><div class=menu-item value="" ng-if=item.modelId ng-click=vm.locViewItem(item)><img src=/assets/icons/preview-eye1.svg class=mr-8 alt="">Location View</div></div></div></div></div></div><div ng-if=vm.isEquipment(budget)><div class="table-child-row header"><div class=flex-4></div><div class=flex-10>{{budget.subName}}</div><div class=flex-3 translate=Unit></div><div class=flex-6 translate="Unit Price"></div><div class=flex-5 translate=Rental></div><div class=flex-8 translate="Delivery Cost"></div><div class=flex-6 translate=Worker></div><div class=flex-12 translate="Cost Price"></div><div class=flex-12 translate="Negotiated Price"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-10 translate=Profit></div><div class=flex-12 translate="Sales Price"></div><div class=flex-4></div></div><div class=table-child-row ng-repeat="item in budget.items"><div class=flex-4></div><div class="flex-10 text-ellipsis" title="{{item.inventoryName || item.workerName}}">{{item.inventoryName || item.workerName}}</div><div class=flex-3>{{item.workerUnit}}</div><div class=flex-6>{{vm.currency}} {{item.workerUnitPrice | readable: 2}}</div><div class=flex-5>{{item.rentalPeriod | readable: 0 }}</div><div class="flex-8 delivery"><div ng-include="\'app/main/calc/directives/budgetGroup/delivery.html\'"></div><div class=ml-10>{{item.deliveryCost | readable: 2}}</div></div><div class=flex-6>{{item.workerCost | readable: 2}}</div><div class=flex-12>{{vm.currency}} {{item.inventoryCostPrice | readable: 2}}</div><div class="flex-12 ne-input">{{vm.currency}} <input type=text class=text-left ng-model=item.workersPriceN ng-blur="vm.changeItemNegotiated(item, budget, true)" number-edit=2></div><div class=flex-8>{{item.workerProfitPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{item.workerProfit | readable: 2}}</div><div class=flex-12>{{vm.currency}} {{item.workersPrice | readable: 2}}</div><div class="flex-4 flex-center more"><div class=dropdown><img src=/assets/icons/more-horiz-dark.svg alt="" class=cursor-point data-toggle=dropdown><div class=dropdown-menu role=menu><div class=menu-item ng-click=vm.viewItem(item)><img src=/assets/icons/alarm2.svg class=mr-16 alt="">View Material</div><div class=menu-item ng-click=vm.deleteItem(item) ng-if="vm.permission > 3"><img src=/assets/icons/delete4.svg class=mr-16 alt="">Delete</div><div class=menu-item ng-if=item.modelId ng-click=vm.locViewItem(item)><img src=/assets/icons/preview-eye1.svg class=mr-8 alt="">Location View</div></div></div></div></div></div></div>');
$templateCache.put('app/main/calc/directives/budgetGroup/delivery.html','<div class=dropdown><img src=/assets/icons/eye-outline.svg alt="" class="dropdown-toggle cursor-point" data-toggle=dropdown><div class=dropdown-menu><div class="menu-box ft_12_600_black"><div class=font-weight-semibold><div class=text-align-center translate="Delivery Cost"></div><div class=text-align-center>{{vm.currency}} {{item.deliveryCost || 0 |readable: 2}}</div><div class="d-flex justify-content-center"><span>Unit {{item.deliveryUnit}}</span></div></div></div><div class=arrow></div></div></div>');
$templateCache.put('app/main/calc/directives/budgetGroup/waste.html','<div class=dropdown><img src=/assets/icons/eye-outline.svg alt="" class="dropdown-toggle cursor-point" data-toggle=dropdown><div class=dropdown-menu><div class="menu-box ft_12_600_black"><div class=font-weight-semibold><div class=text-align-center><span translate=Waste></span> {{item.wasteAmount || 0 |readable: 2}} {{item.inventoryUnit || "(N/A)"}}</div><div class="d-flex justify-content-center"><span>{{item.wastePercent}}%</span></div></div></div><div class=arrow></div></div></div>');
$templateCache.put('app/main/calc/directives/calcExtraGroup/calcExtraGroup.view.html','<div id=calc-extra-group><div class=calc-table><div class=table-header><div class="flex-7 type" translate=Type></div><div ng-class="vm.workLevels ? \'flex-10\' : \'flex-16\'" translate="Item Name"></div><div class=flex-6 translate=Level ng-if=vm.workLevels></div><div class=flex-6 translate="Duration Days"></div><div class=flex-6 translate=Quantity></div><div class=flex-5 translate=Unit></div><div class=flex-8 translate="Unit Price"></div><div class=flex-10 translate="Cost Price"></div><div class=flex-11 translate="Operating Cost"></div><div class=flex-6 translate="Profit %"></div><div class=flex-10 translate=Profit></div><div class=flex-11 translate="Sales Price"></div><div class=flex-4></div></div><div class=table-body><div ng-repeat="row in vm.rows track by $index" ng-init="outIndex = $index+1"><div class=table-row><div class="table-cell flex-7 type expander"><selectbox-input class=item-type options=vm.types ng-model=row.type label-field=tagName value-field=tagName></selectbox-input></div><div class="table-cell name fw-600 text-ellipsis" title={{row.name}} ng-class="vm.workLevels ? \'flex-10\' : \'flex-16\'"><span class=index-box ng-click="row.expand = !row.expand">{{outIndex}}</span> <input type=text class="calc-input fw-600 ml-10" ng-model=row.name></div><div class="table-cell flex-6" ng-if=vm.workLevels><selectbox-input class=select-level options=vm.workLevels ng-model=row.workLevel label-field=tagName value-field=tagName></selectbox-input></div><div class="table-cell flex-6">{{row.duration}}</div><div class="table-cell flex-6">{{row.quantity | readable: 2}}</div><div class="table-cell flex-5">{{row.unit}}</div><div class="table-cell flex-8">{{vm.currency}} {{row.unitPrice | readable: 2}}</div><div class="table-cell flex-10">{{vm.currency}} {{row.costPrice | readable: 2}}</div><div class="table-cell flex-11 ne-input">{{vm.currency}} {{row.companyCost | readable: 2}}</div><div class="table-cell flex-6">{{row.profitPercent | readable: 2}} %</div><div class="table-cell flex-10">{{vm.currency}} {{row.profit | readable: 2}}</div><div class="table-cell flex-11">{{vm.currency}} {{row.salesPrice | readable: 2}}</div><div class="flex-4 flex-center more"><div class=dropdown><img src=/assets/icons/more-horiz.svg alt="" class=cursor-point data-toggle=dropdown><div class=dropdown-menu role=menu><div class=menu-item translate="Add Line" ng-click=vm.addRow($index)></div><div class=menu-item translate="Add Sub Line" ng-click=vm.addItem(row)></div><div class=menu-item translate="Remove Line" ng-click=vm.removeRow($index)></div></div></div></div></div><div class=table-child ng-if=row.expand><div class=table-child-row ng-repeat="item in row.items"><div class="table-cell flex-7 flex type"><selectbox-input class=item-type options=vm.types ng-model=item.type label-field=tagName value-field=tagName></selectbox-input></div><div class="table-cell name flex" title={{item.name}} ng-class="vm.workLevels ? \'flex-10\' : \'flex-16\'"><span class="ml-24 index-box">{{outIndex}}.{{$index+1}}</span> <input type=text class="calc-input ml-10" ng-model=item.name></div><div class="table-cell flex-6" ng-if=vm.workLevels><selectbox-input class=select-level options=vm.workLevels ng-model=item.workLevel label-field=tagName value-field=tagName></selectbox-input></div><div class="table-cell flex-6" title="{{item.duration | readable: 2}}"><input type=text class=calc-input ng-model=item.duration ng-change="vm.updateItem(item, \'duration\', row)" number-edit=2></div><div class="table-cell flex-6" title="{{item.quantity | readable: 2}}"><input type=text class=calc-input ng-model=item.quantity ng-change="vm.updateItem(item, \'quantity\', row)" number-edit=2></div><div class="table-cell flex-5"><selectbox-input class=select-unit options=vm.units ng-model=item.unit label-field=name value-field=value></selectbox-input></div><div class="table-cell flex-8 flex" title="{{vm.currency}} {{item.unitPrice | readable: 2}}"><span class=mr-8>{{vm.currency}}</span> <input type=text class=calc-input ng-model=item.unitPrice ng-change="vm.updateItem(item, \'unitPrice\', row)" number-edit=2></div><div class="table-cell flex-10">{{vm.currency}} {{item.costPrice | readable: 2}}</div><div class="table-cell flex-11">{{vm.currency}} {{item.companyCost | readable: 2}}</div><div class="table-cell flex-6 profit-percent"><input type=text class=calc-input ng-model=item.profitPercent ng-change="vm.updateItem(item, \'profitPercent\', row)" number-edit=2> <span class=ml-8>%</span></div><div class="table-cell flex-10">{{vm.currency}} {{item.profit | readable: 2}}</div><div class="table-cell flex-11">{{vm.currency}} {{item.salesPrice | readable: 2}}</div><div class="flex-4 flex-center more"><div class=dropdown><img src=/assets/icons/more-horiz.svg alt="" class=cursor-point data-toggle=dropdown><div class=dropdown-menu role=menu><div class=menu-item translate="Add Line" ng-click="vm.addItem(row, $index)"></div><div class=menu-item translate="Remove Line" ng-click="vm.removeItem(row, $index)"></div></div></div></div></div></div></div><div class="add-btn ml-16 mt-4" ng-click=vm.addRow()><img src=/assets/icons/bxs-plus-circle-blue.svg alt=""><span class=ml-8 translate="Add Line"></span></div></div><div class=table-summary><div class=flex-12></div><div class="flex-11 fw-600" translate="Sum Total"></div><div class=flex-6></div><div class=flex-6></div><div class=flex-5></div><div class=flex-8></div><div class=flex-10>{{vm.currency}} {{vm.summary.costPrice | readable: 2}}</div><div class=flex-11>{{vm.currency}} {{vm.summary.companyCost | readable: 2}}</div><div class=flex-6>{{vm.summary.profitPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{vm.summary.profit | readable: 2}}</div><div class=flex-11>{{vm.currency}} {{vm.summary.salesPrice | readable: 2}}</div><div class=flex-4></div></div></div></div>');
$templateCache.put('app/main/calc/directives/calcFixedGroup/calcFixedGroup.view.html','<div id=calculation-group-fixed class=box-shadow-white><div class=title><div class=item-title title={{vm.model.name}}>{{vm.model.name}}</div></div><!-- Header --><div class=header-item><div class="flex-5 pl-5"><div class="outer-border px-1">{{vm.index+1}}</div></div><div class="flex-13 pl-10" translate=Items></div><div class=flex-8 translate=Amount1></div><div class="flex-4 pl-0 text-left" translate=Unit></div><div class="flex-8 text-left" translate="Unit Price"></div><div class="flex-6 text-center" translate=Waste></div><div class=flex-8 translate="Cost Price"></div><div class=flex-8 translate="Labour Hours"></div><div class=flex-8 translate="Operating Cost"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-8 translate=Profit></div><div class="flex-8 text-left" translate="Sales Price"></div></div><!-- Items --><div><div class=inventory-item ng-repeat="item in vm.model.items | removeBlackItems track by $index" dtr-init=true ng-init="innerIndex0=$index;tree={open: false};" ng-class="tree.open ? \'tree-open\' : \'\'"><div><!-- Combine --><div ng-if="item.rowStyle == \'Combined\'" class=calc-row><img class=tree-icon ng-if="item.items && item.items.length > 0" ng-src="{{tree.open ? \'/assets/icons/arrow-bottom4.svg\' : \'/assets/icons/arrow-right4.svg\'}}" ng-click=vm.toggleTree(tree);><div class=flex><div class="flex-5 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class="flex-13 name"><span class="pos-relative pl-10">{{item.inventoryName}}</span></div><div class=flex-8><span class=calc-input title="{{item.inventoryAmount | readable: 2}}">{{item.inventoryAmount | readable: 2}}</span></div><div class=flex-4><span class=calc-input>{{item.inventoryUnit}}</span></div><div class=flex-8><span ng-if=item.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" style="width: 6em;" title="{{item.inventoryUnitPrice | readable: 2}}">{{item.inventoryUnitPrice | readable: 2}}</span></div><div class="flex-6 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcFixedGroup/calcWaste.html\'"></div><div class=flex-8><span ng-if=item.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCostPrice | readable: 2}}">{{item.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8>&nbsp;</div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCompanyCost | readable: 2}}">{{item.inventoryCompanyCost | readable: 2}}</span></div><div class=flex-8><span class=calc-input ng-if=item.inventoryAmount>{{item.inventoryProfitPercent}}</span></div><div class=flex-8><span ng-if=item.inventoryProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryProfit title="{{item.inventoryProfit | readable: 2}}">{{item.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=item.salesPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{item.salesPrice | readable: 2}}">{{item.salesPrice | readable: 2}}</span></div></div><div class="split-line mr-48" ng-class="tree.open ? \'ml-50\' : \'\'"></div><div class=flex><div class="flex-5 pl-5"></div><div class="flex-13 name"><span class="calc-input pl-10-tx-left" title={{item.workerName}}>{{item.workerName}}</span></div><div class=flex-8><span class=calc-input title="{{item.workerAmount | readable: 2}}">{{item.workerAmount | readable: 2}}</span></div><div class=flex-4><span class=calc-input>{{item.workerUnit}}</span></div><div class=flex-8><span ng-if=item.workerUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{item.workerUnitPrice | readable: 2}}" style="width: 6em;">{{item.workerUnitPrice | readable: 2}}</span></div><div class=flex-6>&nbsp;</div><div class=flex-8><span ng-if=item.workerAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerAmount title="{{item.workerCostPrice | readable: 2}}">{{item.workerCostPrice | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerAmount title="{{item.labourHours | readable: 2}}">hr {{item.labourHours | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerCompanyCost title="{{item.workerCompanyCost | readable: 2}}">{{item.workerCompanyCost | readable: 2}}</span></div><div class=flex-8><input type=text class=calc-input ng-if=item.workerAmount ng-model=item.workerProfitPercent ng-blur=vm.onUpdateItem(item) number-edit></div><div class=flex-8><span ng-if=item.workerProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerProfit title="{{item.workerProfit | readable: 2}}">{{item.workerProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workersPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" ng-if=item.inventoryAmount title="{{item.workersPrice | readable: 2}}">{{item.workersPrice | readable: 2}}</span></div></div><div class=delete-com><label class=check_yellow_20 ng-if=vm.checkable><input type=checkbox ng-change=stopPropagation(); ng-model=item.checked> <span class=checkmark></span></label></div></div><!-- Inventory --><div ng-if="item.rowStyle == \'Inventory\'" class=calc-row><img class=tree-icon ng-if="item.items && item.items.length > 0" ng-src="{{tree.open ? \'/assets/icons/arrow-bottom4.svg\' : \'/assets/icons/arrow-right4.svg\'}}" ng-click=vm.toggleTree(tree);><div class=flex><div class="flex-5 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class="flex-13 name"><span class="pos-relative pl-10">{{item.inventoryName}}</span></div><div class=flex-8><span class=calc-input title="{{item.inventoryAmount | readable: 2}}">{{item.inventoryAmount | readable: 2}}</span></div><div class=flex-4><span class=calc-input>{{item.inventoryUnit}}</span></div><div class=flex-8><span ng-if=item.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" style="width: 6em;" title="{{item.inventoryUnitPrice | readable: 2}}">{{item.inventoryUnitPrice | readable: 2}}</span></div><div class="flex-6 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcFixedGroup/calcWaste.html\'"></div><div class=flex-8><span ng-if=item.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCostPrice | readable: 2}}">{{item.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCompanyCost | readable: 2}}">{{item.inventoryCompanyCost | readable: 2}}</span></div><div class=flex-8><span class=calc-input ng-if=item.inventoryAmount>{{item.inventoryProfitPercent}}</span></div><div class=flex-8><span ng-if=item.inventoryProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryProfit title="{{item.inventoryProfit | readable: 2}}">{{item.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=item.salesPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{item.salesPrice | readable: 2}}">{{item.salesPrice | readable: 2}}</span></div></div><div class=delete-com style="top: 0;"><label class=check_yellow_20 ng-if=vm.checkable><input type=checkbox ng-change=stopPropagation(); ng-model=item.checked> <span class=checkmark></span></label></div></div><!-- Worker --><div ng-if="item.rowStyle == \'Worker\'" class=calc-row><div class=flex><div class="flex-5 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class="flex-13 name"><span class="calc-input pl-10-tx-left" title={{item.workerName}}>{{item.workerName}}</span></div><div class=flex-8><span class=calc-input title="{{item.workerAmount | readable: 2}}">{{item.workerAmount | readable: 2}}</span></div><div class=flex-4><span class=calc-input>{{item.workerUnit}}</span></div><div class=flex-8><span ng-if=item.workerUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{item.workerUnitPrice | readable: 2}}" style="width: 6em;">{{item.workerUnitPrice | readable: 2}}</span></div><div class=flex-6>&nbsp;</div><div class=flex-8><span ng-if=item.workerAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerAmount title="{{item.workerCostPrice | readable: 2}}">{{item.workerCostPrice | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerAmount title="{{item.labourHours | readable: 2}}">hr {{item.labourHours | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerCompanyCost title="{{item.workerCompanyCost | readable: 2}}">{{item.workerCompanyCost | readable: 2}}</span></div><div class=flex-8><span class=calc-input ng-if=item.workerAmount>{{item.workerProfitPercent}}</span></div><div class=flex-8><span ng-if=item.workerProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerProfit title="{{item.workerProfit | readable: 2}}">{{item.workerProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workersPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" ng-if=item.inventoryAmount title="{{item.workersPrice | readable: 2}}">{{item.workersPrice | readable: 2}}</span></div></div><div class=delete-com style="top: 0;"><label class=check_yellow_20 ng-if=vm.checkable><input type=checkbox ng-change=stopPropagation(); ng-model=item.checked> <span class=checkmark></span></label></div></div><!-- Subcontractor --><div ng-if="item.rowStyle == \'Subcontractor\'" class=calc-row><div class=flex><div class="flex-5 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class="flex-13 name"><span class="calc-input pl-10-tx-left" title={{item.workerName}}>{{item.workerName}}</span></div><div class=flex-8><span class=calc-input title="{{item.workerAmount | readable: 2}}">{{item.workerAmount | readable: 2}}</span></div><div class=flex-4><span class=calc-input>{{item.workerUnit}}</span></div><div class=flex-8><span ng-if=item.workerUnitPrice>{{vm.companyCurrency.symbol}}</span>&nbsp; <span class="calc-input text-left" style="width: 6em;" title="{{item.workerUnitPrice | readable: 2}}">{{item.workerUnitPrice | readable: 2}}</span></div><div class="flex-6 pos-relative"></div><div class=flex-8><span ng-if=item.workerAmount>{{vm.companyCurrency.symbol}}</span>&nbsp; <span ng-if=item.workerAmount title="{{item.workerCostPrice | readable: 2}}">{{item.workerCostPrice | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerAmount>hr</span>&nbsp; <span ng-if=item.workerAmount>{{item.labourHours | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerCompanyCost>{{vm.companyCurrency.symbol}}</span>&nbsp; <span ng-if=item.workerCompanyCost title="{{item.workerCompanyCost | readable: 2}}">{{item.workerCompanyCost | readable: 2}}</span></div><div class=flex-8><span class=calc-input ng-if=item.workerAmount>{{item.workerProfitPercent}}</span>&nbsp;</div><div class=flex-8><span ng-if=item.workerProfit>{{vm.companyCurrency.symbol}}</span>&nbsp; <span ng-if=item.workerProfit title="{{item.workerProfit | readable: 2}}">{{item.workerProfit | readable: 2}}</span></div><div class=flex-8 style="display: flex; align-items: flex-start;"><span ng-if=item.workersPrice>{{vm.companyCurrency.symbol}}</span>&nbsp; <span class="calc-input text-left" ng-if=item.workerAmount title="{{item.workersPrice | readable: 2}}">{{item.workersPrice | readable: 2}} </span>&nbsp;</div></div><div class=delete-com style="top: 0;"><label class=check_yellow_20 ng-if=vm.checkable><input type=checkbox ng-change=stopPropagation(); ng-model=item.checked> <span class=checkmark></span></label></div></div></div><!-- Sub Items --><div class=sub-items ng-show=tree.open><div class=divider ng-repeat-start="subitem in item.items track by $index"></div><div class="inventory-item tree" ng-repeat-end=""><div ng-if="subitem.rowStyle == \'Combined\'" class=calc-row><div class=flex><div class="flex-5 pl-5 ml-30"><div class="fill-no px-1">{{(vm.index+1) + \'.\' + (innerIndex0+1) + \'.\' + ($index+1)}}</div></div><div class="flex-13 name"><span class="pos-relative pl-10">{{subitem.inventoryName}}</span></div><div class=flex-8><span class=calc-input title="{{subitem.inventoryAmount | readable: 2}}">{{subitem.inventoryAmount | readable: 2}}</span></div><div class=flex-4><span class=calc-input>{{subitem.inventoryUnit}}</span></div><div class=flex-8><span ng-if=subitem.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" style="width: 6em;" title="{{subitem.inventoryUnitPrice | readable: 2}}">{{subitem.inventoryUnitPrice | readable: 2}}</span></div><div class="flex-6 pos-relative overflow-visible waste"></div><div class=flex-8><span ng-if=subitem.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=subitem.inventoryAmount title="{{subitem.inventoryCostPrice | readable: 2}}">{{subitem.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8>&nbsp;</div><div class=flex-8><span ng-if=subitem.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=subitem.inventoryAmount title="{{subitem.inventoryCompanyCost | readable: 2}}">{{subitem.inventoryCompanyCost | readable: 2}}</span></div><div class=flex-8><span class=calc-input ng-if=subitem.inventoryAmount>{{subitem.inventoryProfitPercent}}</span></div><div class=flex-8><span ng-if=subitem.inventoryProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=subitem.inventoryProfit title="{{subitem.inventoryProfit | readable: 2}}">{{subitem.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=subitem.salesPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{subitem.salesPrice | readable: 2}}">{{subitem.salesPrice | readable: 2}}</span></div></div><div class="split-line ml-50 mr-48"></div><div class=delete-com><div class="dropdown mx-height5"><button class=dropdown-toggle type=button data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-click="vm.onViewDetailItem(subitem, vm.index)"><img src=/assets/icons/alarm2.svg alt="">View Details</li><li class=menu-item value="" ng-if=subitem.modelId ng-click=vm.onLocViewItem(subitem)><img src=/assets/icons/preview-eye1.svg alt="">Location View</li></ul></div></div><div class=flex><div class="flex-5 pl-5 ml-30"></div><div class="flex-13 name"><input type=text ng-model=subitem.workerName class="calc-input pl-10-tx-left" placeholder=Worker ng-keyup="vm.onInitProfit(subitem, vm.index, innerIndex)" title={{subitem.workerName}}></div><div class=flex-8><span class=calc-input title="{{subitem.workerAmount | readable: 2}}">{{subitem.workerAmount | readable: 2}}</span></div><div class=flex-4><span class=calc-input>{{subitem.workerUnit}}</span></div><div class=flex-8><span ng-if=subitem.workerUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{subitem.workerUnitPrice | readable: 2}}" style="width: 6em;">{{subitem.workerUnitPrice | readable: 2}}</span></div><div class=flex-6>&nbsp;</div><div class=flex-8><span ng-if=subitem.workerAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=subitem.workerAmount title="{{subitem.workerCostPrice | readable: 2}}">{{subitem.workerCostPrice | readable: 2}}</span></div><div class=flex-8><span ng-if=subitem.workerAmount title="{{subitem.labourHours | readable: 2}}">hr {{subitem.labourHours | readable: 2}}</span></div><div class=flex-8><span ng-if=subitem.workerCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=subitem.workerCompanyCost title="{{subitem.workerCompanyCost | readable: 2}}">{{subitem.workerCompanyCost | readable: 2}}</span></div><div class=flex-8><span class=calc-input ng-if=subitem.workerAmount>{{subitem.workerProfitPercent}}</span></div><div class=flex-8><span ng-if=subitem.workerProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=subitem.workerProfit title="{{subitem.workerProfit | readable: 2}}">{{subitem.workerProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=subitem.workersPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" ng-if=subitem.inventoryAmount title="{{subitem.workersPrice | readable: 2}}">{{subitem.workersPrice | readable: 2}}</span></div></div></div><div ng-if="subitem.rowStyle == \'Inventory\'" class=calc-row><div class=flex><div class="flex-5 pl-5 ml-30"><div class="outer-border px-1">{{(vm.index+1) + \'.\' + (innerIndex0+1) + \'.\' + ($index+1)}}</div></div><div class="flex-13 name"><span class="pos-relative pl-10">{{subitem.inventoryName}}</span></div><div class=flex-8><span class=calc-input title="{{subitem.inventoryAmount | readable: 2}}">{{subitem.inventoryAmount | readable: 2}}</span></div><div class=flex-4><span class=calc-input>{{subitem.inventoryUnit}}</span></div><div class=flex-8><span ng-if=subitem.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <input type=text class="calc-input text-left" style="width: 6em;" ng-model=subitem.inventoryUnitPrice title="{{subitem.inventoryUnitPrice | readable: 2}}" ng-change=vm.onUpdateItem(subitem) number-edit></div><div class="flex-6 pos-relative overflow-visible waste"></div><div class=flex-8><span ng-if=subitem.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=subitem.inventoryAmount title="{{subitem.inventoryCostPrice | readable: 2}}">{{subitem.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=subitem.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=subitem.inventoryAmount title="{{subitem.inventoryCompanyCost | readable: 2}}">{{subitem.inventoryCompanyCost | readable: 2}}</span></div><div class=flex-8><input type=text class=calc-input ng-if=subitem.inventoryAmount ng-model=subitem.inventoryProfitPercent ng-blur=vm.onUpdateItem(subitem) number-edit></div><div class=flex-8><span ng-if=subitem.inventoryProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=subitem.inventoryProfit title="{{subitem.inventoryProfit | readable: 2}}">{{subitem.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=subitem.salesPrice>{{vm.companyCurrency.symbol}}</span> <input type=text class="calc-input text-left" ng-model=subitem.salesPrice title="{{subitem.salesPrice | readable: 2}}" ng-blur=vm.onUpdateItem(subitem) number-edit></div></div><div class=delete-com style="top: 0;"><div class="dropdown mx-height5"><button class=dropdown-toggle type=button id=menu1 data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li class=menu-item value="" ng-click="vm.onViewDetailItem(subitem, vm.index)"><img src=/assets/icons/alarm2.svg alt="">View Details</li><li class=menu-item value="" ng-if=subitem.modelId ng-click=vm.onLocViewItem(subitem)><img src=/assets/icons/preview-eye1.svg alt="">Location View</li></ul></div></div></div></div></div></div></div><!-- Levels --><div><div class="inventory-level pos-relative" ng-repeat="subLevel in vm.model.levels track by $index"><div class=cursor-point><div class=flex ng-click="vm.onEnterChild(vm.index, $index, subLevel)"><div class="flex-5 pl-5"><div class="outer-border level px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class="flex-13 name"><span class="calc-input ml-10">{{subLevel.name}}</span></div><div class=flex-8></div><div class=flex-4></div><div class=flex-8></div><div class=flex-6></div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (subLevel.sumCostPrice | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{subLevel.sumCostPrice | readable: 2}}</div><div class=flex-8 title="{{\'hr \' + (subLevel.sumHours | readable: 2)}}">hr {{subLevel.sumHours | readable: 2}}</div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (subLevel.sumCompanyCost | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{subLevel.sumCompanyCost | readable: 2}}</div><div class=flex-8>{{subLevel.sumProfit/subLevel.sum*100 | readable: 2}}</div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (subLevel.sumProfit | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{subLevel.sumProfit | readable: 2}}</div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (subLevel.sum | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{subLevel.sum | readable: 2}}</div></div><div class=delete-com style="top: 15px;"><label class=check_yellow_20 ng-if=vm.checkable><input type=checkbox ng-change=stopPropagation(); ng-model=subLevel.checked> <span class=checkmark></span></label></div></div></div></div><!-- Summary --><div class=sum><div class="flex-5 pl-5"></div><div class=flex-13 translate=Sum></div><div class=flex-8></div><div class=flex-4></div><div class=flex-8></div><div class=flex-6></div><!-- Cost Price --><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (vm.model.sumCostPrice | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{vm.model.sumCostPrice | readable: 2}}</div><!-- Operating Cost --><div class=flex-8 title="{{\'hr \' + (vm.model.sumHours | readable: 2)}}">hr {{vm.model.sumHours | readable: 2}}</div><!-- Operating Cost --><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (vm.model.sumCompanyCost | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{vm.model.sumCompanyCost | readable: 2}}</div><!-- Profit % --><div class=flex-8>{{vm.model.sumProfit/vm.model.sum*100 | readable: 2}}</div><!-- Profit --><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (vm.model.sumProfit | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{vm.model.sumProfit | readable: 2}}</div><!--Sales Price --><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (vm.model.sum | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{vm.model.sum | readable: 2}}</div></div></div>');
$templateCache.put('app/main/calc/directives/calcFixedGroup/calcWaste.html','<div class=dropdown><button class=dropdown-toggle type=button id=menu1 data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class=text-center><img src=/assets/icons/preview-eye1.svg alt=""></div></button><div class=dropdown-menu><div class="menu-box ft_12_600_black"><div class=font-weight-semibold><div class=text-align-center><span translate=Waste></span> {{item.wasteAmount || 0 |readable: 2}} {{item.inventoryUnit || "(N/A)"}}</div><div class="d-flex justify-content-center"><span>{{item.wastePercent}}%</span></div></div></div><div class=arrow></div></div></div>');
$templateCache.put('app/main/calc/directives/calcGroup/calcGroup.view.html','<div id=calculation-group class=box-shadow-white><div class=title><div class=item-title ng-if=!vm.model.isEdit title={{vm.model.name}}>{{vm.model.name}}</div><input type=text class=item-title ng-if=vm.model.isEdit ng-model=vm.model.name autofocus title={{vm.model.name}}> <img ng-if="vm.levelDepth !== 2 && vm.levelDepth !== 3 && !vm.model.isEdit && vm.permission > 1" src=/assets/icons/edit-light.svg alt="" ng-click=vm.onEditLevelName()> <img ng-if="vm.levelDepth !== 2 && vm.levelDepth !== 3 && vm.model.isEdit && vm.permission > 1" src=/assets/icons/save-icon-light.svg alt="" ng-click=vm.onChangeLevelName(vm.model.name)> <img ng-if="vm.levelDepth == 0 && vm.permission > 3" style=float:right src=/assets/icons/delete-gray1.svg alt="" class="mh-10 cursor-point" ng-click="vm.onRemoveLevel(vm.model, vm.index)"><div class="add-types scroll-body"><div class=flex><!-- <div class="item">\n          <img src="/assets/icons/plus.svg" alt="">\n        </div>\n        <div>Add Types</div> --><div class="item ft_14_regular_black" ng-if="vm.levelDepth < 3" ng-repeat="item in vm.filterWorkTypes" ng-click="vm.onFilterWorkType(vm.ngModel, item, vm.index)" ng-class="{\'active\': item.selected == true}">{{item.name}}<!-- <img src="/assets/icons/gray-circle-close.svg" alt="" class="ml-2" ng-if="item.selected==false">\n          <img src="/assets/icons/white-circle-close.svg" alt="" class="ml-2" ng-if="item.selected==true"> --></div></div></div></div><!-- Header --><div class=header-item><div class="flex-4 pl-5"><div class="outer-border px-1">{{vm.index+1}}</div></div><div class=w-12></div><div class=flex-13 translate=Items></div><div class=flex-6 translate=Amount1></div><div class=flex-11 translate=Type></div><div class="flex-4 pl-0 text-left" translate=Unit></div><div class="flex-8 text-left" translate="Unit Price"></div><div class="flex-5 text-center" translate=Waste></div><div class=flex-8 translate="Cost Price"></div><div class=flex-8 translate="Labour Hours"></div><div class=flex-8 translate="Operating Cost"></div><div class=flex-6 translate="Profit in %"></div><div class=flex-8 translate=Profit></div><div class="flex-8 text-left" translate="Sales Price"></div></div><!-- Items --><div><div class=inventory-item ng-repeat="item in vm.model.items | removeBlackItems track by $index" dtr-init=true ng-init="innerIndex0=$index;tree={open: false};" ng-class="{\'tree-open\': tree.open}"><div ng-if=item.editMode><!-- Combine --><div ng-if="item.rowStyle == \'Combined\'" class=calc-row><calc-selector ng-if="item.editMode===\'new\'" ng-model=item ng-selected=vm.onSelectStyle(item)></calc-selector><img class=tree-icon ng-if="item.items && item.items.length > 0" ng-click=vm.toggleTree(tree); ng-src="{{tree.open ? \'/assets/icons/arrow-bottom4.svg\' : \'/assets/icons/arrow-right4.svg\'}}"><div class=flex><div class="flex-4 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class="line-mark active"></div><div class="flex-13 name overflow-visible" ng-if="item.editMode===\'new\'"><selectbox2 ng-if="item.subStyle===\'Material\'" class="calc-select inventory-select dropdown-primary" ng-model=item.matID options=vm.materials label-field=name value-field=_id select-event="vm.onChangeInventory(item.rowStyle, item.subStyle, value, innerIndex0)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Building Part\'" class="calc-select inventory-select dropdown-primary" ng-model=item.matID options=vm.buildingparts label-field=name value-field=_id select-event="vm.onChangeInventory(item.rowStyle, item.subStyle, value, innerIndex0)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCP\'" class="calc-select inventory-select dropdown-primary" ng-model=item.matID options=vm.dcps label-field=name value-field=_id select-event="vm.onChangeInventory(item.rowStyle, item.subStyle, value, innerIndex0)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCQ\'" class="calc-select inventory-select dropdown-primary" ng-model=item.matID options=vm.dcqs label-field=name value-field=_id select-event="vm.onChangeInventory(item.rowStyle, item.subStyle, value, innerIndex0)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Equipment\'" class="calc-select inventory-select dropdown-primary" ng-model=item.matID options=vm.equipments label-field=name value-field=_id select-event="vm.onChangeInventory(item.rowStyle, item.subStyle, value, innerIndex0)" is-title=true></selectbox2><input ng-if="item.subStyle===\'Custom\'" type=text class="calc-input input-primary" ng-model=item.inventoryName></div><div class="flex-13 name" title={{item.inventoryName}} ng-if="item.editMode!==\'new\'">{{item.inventoryName}}</div><div class="flex-6 pr-5"><input type=text class="calc-input input-primary" title="{{item.inventoryAmount | readable: 2}}" ng-model=item.inventoryAmount number-edit=2 ng-change="vm.onUpdateItem(item, \'inventoryAmount\', \'{{item.inventoryAmount}}\')"></div><div class="flex-11 work-type"><selectbox2 class="calc-select rounded zindex-2 dropdown-primary" ng-model=item.workType options=vm.workTypes label-field=tagName value-field=tagName select-event=vm.onChangeWorkType(item) is-title=true></selectbox2></div><div class="flex-4 unit"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-click="vm.onOpenUnitsDropdown(\'MAT\')" ng-model=item.inventoryUnit>{{item.inventoryUnit}}</button><ul class=dropdown-menu role=menu ng-if="vm.rowForUnit==\'MAT\'"><li class=menu-item value="" ng-repeat="unit in vm.mUnits | unitFilter : \'inventory\' : item.rowStyle" ng-click="vm.onUnitSelect(unit,item,\'MAT\')">{{unit.name}}</li></ul></div></div><div class=flex-8><span ng-if=item.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <input type=text class="calc-input text-left input-primary" style="width: 6em;" title="{{item.inventoryUnitPrice | readable: 2}}" ng-model=item.inventoryUnitPrice ng-change="vm.onUpdateItem(item, \'inventoryUnitPrice\', \'{{item.inventoryUnitPrice}}\')" number-edit=2></div><div class="flex-5 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcGroup/calcWaste.html\'"></div><div class=flex-8><span ng-if=item.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCostPrice | readable: 2}}">{{item.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8>&nbsp;</div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCompanyCost | readable: 2}}">{{item.inventoryCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><input type=text class="calc-input input-primary" ng-if=item.inventoryAmount ng-model=item.inventoryProfitPercent ng-blur="vm.onUpdateItem(item, \'inventoryProfitPercent\', \'{{item.inventoryProfitPercent}}\')" number-edit=2></div><div class=flex-8><span ng-if="item.inventoryProfit !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.inventoryProfit !== undefined" title="{{item.inventoryProfit | readable: 2}}">{{item.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if="item.salesPrice !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.salesPrice !== undefined" title="{{item.salesPrice | readable: 2}}">{{item.salesPrice | readable: 2}}</span></div></div><div class=split-line ng-class="tree.open ? \'ml-100 mr-100\' : \'\'"></div><div class="flex pt-2"><div class="flex-4 pl-5"></div><div class=w-12></div><div class="flex-13 name overflow-visible" ng-if="item.editMode===\'new\'"><selectbox2 class="calc-select inventory-select dropdown-primary" ng-model=item.workerID options=vm.workers label-field=description value-field=_id select-event="vm.onChangeWorker(item, value, innerIndex)" is-title=true></selectbox2></div><div class="flex-13 name" title={{item.workerName}} ng-if="item.editMode!==\'new\'">{{item.workerName}}</div><div class="flex-6 pr-5"><input type=number class="calc-input input-primary" title="{{item.workerAmount | readable: 2}}" ng-model=item.workerAmount ng-change="vm.onUpdateItem(item, \'workerAmount\', \'{{item.workerAmount}}\')"></div><div class=flex-11></div><div class="flex-4 unit"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-click="vm.onOpenUnitsDropdown(\'WOR\')" ng-model=item.workerUnit readonly>{{item.workerUnit}}</button><ul class=dropdown-menu role=menu ng-if="vm.rowForUnit==\'WOR\'"><li class=menu-item value="" ng-repeat="unit in vm.mUnits | unitFilter : \'worker\' : item.rowStyle" ng-click="vm.onUnitSelect(unit,item,\'WOR\')">{{unit.name}}</li></ul></div></div><div class=flex-8><span ng-if=item.workerUnitPrice>{{vm.companyCurrency.symbol}}</span> <input type=text class="calc-input text-left input-primary" style="width: 6em;" title="{{item.workerUnitPrice | readable: 2}}" ng-model=item.workerUnitPrice ng-change="vm.onUpdateItem(item, \'workerUnitPrice\', \'{{item.workerUnitPrice}}\')" number-edit=2></div><div class=flex-5>&nbsp;</div><div class=flex-8><span ng-if=item.workerAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerAmount title="{{item.workerCostPrice | readable: 2}}">{{item.workerCostPrice | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerAmount title="{{item.labourHours | readable: 2}}">hr {{item.labourHours | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerCompanyCost title="{{item.workerCompanyCost | readable: 2}}">{{item.workerCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><input type=text class="calc-input input-primary" ng-if=item.workerAmount ng-model=item.workerProfitPercent ng-blur="vm.onUpdateItem(item, \'workerProfitPercent\', \'{{item.workerProfitPercent}}\')" number-edit=2></div><div class=flex-8><span ng-if="item.workerProfit !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.workerProfit !== undefined" title="{{item.workerProfit | readable: 2}}">{{item.workerProfit | readable: 2}}</span></div><div class=flex-8><span ng-if="item.workersPrice !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.workersPrice !== undefined" title="{{item.workersPrice | readable: 2}}">{{item.workersPrice | readable: 2}}</span></div></div><div class=edit-controls><img src=/assets/icons/checkmark-24.svg alt="" ng-click=vm.onConfirmEditItem(item)> <img ng-if="item.editMode===\'new\'" src=/assets/icons/close-24-dark.svg alt="" ng-click="vm.onDeleteItem(vm.model, $index)"></div></div><!-- Inventory --><div ng-if="item.rowStyle == \'Inventory\'" class=calc-row><calc-selector ng-if="item.editMode===\'new\'" ng-model=item ng-selected=vm.onSelectStyle(item)></calc-selector><img class=tree-icon ng-if="item.items && item.items.length > 0" ng-click=vm.toggleTree(tree); ng-src="{{tree.open ? \'/assets/icons/arrow-bottom4.svg\' : \'/assets/icons/arrow-right4.svg\'}}"><div class=flex><div class="flex-4 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class="line-mark active"></div><div class="flex-13 name overflow-visible" ng-if="item.editMode===\'new\'"><selectbox2 ng-if="item.subStyle===\'Material\'" class="calc-select inventory-select dropdown-primary" ng-model=item.matID options=vm.materials label-field=name value-field=_id select-event="vm.onChangeInventory(item.rowStyle, item.subStyle, value, innerIndex0)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Building Part\'" class="calc-select inventory-select dropdown-primary" ng-model=item.matID options=vm.buildingparts label-field=name value-field=_id select-event="vm.onChangeInventory(item.rowStyle, item.subStyle, value, innerIndex0)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCP\'" class="calc-select inventory-select dropdown-primary" ng-model=item.matID options=vm.dcps label-field=name value-field=_id select-event="vm.onChangeInventory(item.rowStyle, item.subStyle, value, innerIndex0)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'DCQ\'" class="calc-select inventory-select dropdown-primary" ng-model=item.matID options=vm.dcqs label-field=name value-field=_id select-event="vm.onChangeInventory(item.rowStyle, item.subStyle, value, innerIndex0)" is-title=true></selectbox2><selectbox2 ng-if="item.subStyle===\'Equipment\'" class="calc-select inventory-select dropdown-primary" ng-model=item.matID options=vm.equipments label-field=name value-field=_id select-event="vm.onChangeInventory(item.rowStyle, item.subStyle, value, innerIndex0)" is-title=true></selectbox2><input ng-if="item.subStyle===\'Custom\'" type=text class="calc-input input-primary" ng-model=item.inventoryName></div><div class="flex-13 name" title={{item.inventoryName}} ng-if="item.editMode!==\'new\'">{{item.inventoryName}}</div><div class="flex-6 pr-5"><input type=text class="calc-input input-primary" title="{{item.inventoryAmount | readable: 2}}" ng-model=item.inventoryAmount number-edit=2 ng-change="vm.onUpdateItem(item, \'inventoryAmount\', \'{{item.inventoryAmount}}\')"></div><div class="flex-11 work-type"><selectbox2 class="calc-select rounded zindex-2 dropdown-primary" ng-model=item.workType options=vm.workTypes label-field=tagName value-field=tagName select-event=vm.onChangeWorkType(item) is-title=true></selectbox2></div><div class="flex-4 unit"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-click="vm.onOpenUnitsDropdown(\'MAT\')" ng-model=item.inventoryUnit>{{item.inventoryUnit}}</button><ul class=dropdown-menu role=menu ng-if="vm.rowForUnit==\'MAT\'"><li class=menu-item value="" ng-repeat="unit in vm.mUnits | unitFilter : \'inventory\' : item.rowStyle" ng-click="vm.onUnitSelect(unit,item,\'MAT\')">{{unit.name}}</li></ul></div></div><div class=flex-8><span ng-if=item.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <input type=text class="calc-input text-left input-primary" style="width: 6em;" title="{{item.inventoryUnitPrice | readable: 2}}" ng-model=item.inventoryUnitPrice ng-change="vm.onUpdateItem(item, \'inventoryUnitPrice\', \'{{item.inventoryUnitPrice}}\')" number-edit=2></div><div class="flex-5 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcGroup/calcWaste.html\'"></div><div class=flex-8><span ng-if=item.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCostPrice | readable: 2}}">{{item.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCompanyCost | readable: 2}}">{{item.inventoryCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><input type=text class="calc-input input-primary" ng-if=item.inventoryAmount ng-model=item.inventoryProfitPercent ng-blur="vm.onUpdateItem(item, \'inventoryProfitPercent\', \'{{item.inventoryProfitPercent}}\')" number-edit=2></div><div class=flex-8><span ng-if="item.inventoryProfit !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.inventoryProfit !== undefined" title="{{item.inventoryProfit | readable: 2}}">{{item.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if="item.salesPrice !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.salesPrice !== undefined" title="{{item.salesPrice | readable: 2}}">{{item.salesPrice | readable: 2}}</span></div></div><div class=edit-controls><img src=/assets/icons/checkmark-24.svg alt="" ng-click=vm.onConfirmEditItem(item)> <img ng-if="item.editMode===\'new\'" src=/assets/icons/close-24-dark.svg alt="" ng-click="vm.onDeleteItem(vm.model, $index)"></div></div><!-- Worker --><div ng-if="item.rowStyle == \'Worker\'" class=calc-row><calc-selector ng-if="item.editMode===\'new\'" ng-model=item ng-selected=vm.onSelectStyle(item)></calc-selector><div class=flex><div class="flex-4 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class="line-mark active"></div><div class="flex-13 name overflow-visible" ng-if="item.editMode===\'new\'"><selectbox2 class="calc-select inventory-select dropdown-primary" ng-model=item.matID options=vm.workers label-field=description value-field=_id select-event="vm.onChangeInventory(item.rowStyle, item.subStyle, value, innerIndex0)" is-title=true></selectbox2></div><div class="flex-13 name" title={{item.workerName}} ng-if="item.editMode!==\'new\'">{{item.workerName}}</div><div class="flex-6 pr-5"><input type=text class="calc-input input-primary" title="{{item.workerAmount | readable: 2}}" ng-model=item.workerAmount number-edit=2 ng-change="vm.onUpdateItem(item, \'workerAmount\', \'{{item.workerAmount}}\')"></div><div class="flex-11 work-type"><selectbox2 class="calc-select rounded zindex-2 dropdown-primary" ng-model=item.workType options=vm.workTypes label-field=tagName value-field=tagName select-event=vm.onChangeWorkType(item) is-title=true></selectbox2></div><div class="flex-4 unit"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-click="vm.onOpenUnitsDropdown(\'WOR\')" ng-model=item.workerUnit readonly>{{item.workerUnit}}</button><ul class=dropdown-menu role=menu ng-if="vm.rowForUnit==\'WOR\'"><li class=menu-item value="" ng-repeat="unit in vm.mUnits | unitFilter : \'worker\' : item.rowStyle" ng-click="vm.onUnitSelect(unit,item,\'WOR\')">{{unit.name}}</li></ul></div></div><div class=flex-8><span ng-if=item.workerUnitPrice>{{vm.companyCurrency.symbol}}</span> <input type=text class="calc-input text-left input-primary" style="width: 6em;" title="{{item.workerUnitPrice | readable: 2}}" ng-model=item.workerUnitPrice ng-change="vm.onUpdateItem(item, \'workerUnitPrice\', \'{{item.workerUnitPrice}}\')" number-edit=2></div><div class=flex-5>&nbsp;</div><div class=flex-8><span ng-if=item.workerAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerAmount title="{{item.workerCostPrice | readable: 2}}">{{item.workerCostPrice | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerAmount title="{{item.labourHours | readable: 2}}">hr {{item.labourHours | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerCompanyCost title="{{item.workerCompanyCost | readable: 2}}">{{item.workerCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><input type=text class="calc-input input-primary" ng-if=item.workerAmount ng-model=item.workerProfitPercent ng-blur="vm.onUpdateItem(item, \'workerProfitPercent\', \'{{item.workerProfitPercent}}\')" number-edit=2></div><div class=flex-8><span ng-if=item.workerProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerProfit title="{{item.workerProfit | readable: 2}}">{{item.workerProfit | readable: 2}}</span></div><div class=flex-8><span ng-if="item.workersPrice !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.workersPrice !== undefined" title="{{item.workersPrice | readable: 2}}">{{item.workersPrice | readable: 2}}</span></div></div><div class=edit-controls><img src=/assets/icons/checkmark-24.svg alt="" ng-click=vm.onConfirmEditItem(item)> <img ng-if="item.editMode===\'new\'" src=/assets/icons/close-24-dark.svg alt="" ng-click="vm.onDeleteItem(vm.model, $index)"></div></div><!-- Collaborator --><div ng-if="item.rowStyle == \'Collaborator\'" class=calc-row><calc-selector ng-if="item.editMode===\'new\'" ng-model=item ng-selected=vm.onSelectStyle(item)></calc-selector><div class=flex><div class="flex-4 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class="line-mark active"></div><div class="flex-13 name overflow-visible" ng-if="item.editMode===\'new\'"><input type=text class="pos-relative calc-input input-primary" ng-model=item.inventoryName></div><div class="flex-13 name" title={{item.inventoryName}} ng-if="item.editMode!==\'new\'">{{item.inventoryName}}</div><div class="flex-6 pr-5"><input type=text class="calc-input input-primary" title="{{item.inventoryAmount | readable: 2}}" ng-model=item.inventoryAmount number-edit=2 ng-change="vm.onUpdateItem(item, \'inventoryAmount\', \'{{item.inventoryAmount}}\')"></div><div class="flex-11 work-type"><selectbox2 class="calc-select rounded zindex-2 dropdown-primary" ng-model=item.workType options=vm.workTypes label-field=tagName value-field=tagName select-event=vm.onChangeWorkType(item) is-title=true></selectbox2></div><div class="flex-4 unit"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-click="vm.onOpenUnitsDropdown(\'MAT\')" ng-model=item.inventoryUnit>{{item.inventoryUnit}}</button><ul class=dropdown-menu role=menu ng-if="vm.rowForUnit==\'MAT\'"><li class=menu-item value="" ng-repeat="unit in vm.mUnits | unitFilter : \'inventory\' : item.rowStyle" ng-click="vm.onUnitSelect(unit,item,\'MAT\')">{{unit.name}}</li></ul></div></div><div class=flex-8><span ng-if="item.inventoryUnitPrice !== undefined">{{vm.companyCurrency.symbol}}</span> <input type=text class="calc-input text-left input-primary" style="width: 6em;" title="{{item.inventoryUnitPrice | readable: 2}}" ng-model=item.inventoryUnitPrice ng-change="vm.onUpdateItem(item, \'inventoryUnitPrice\', \'{{item.inventoryUnitPrice}}\')" number-edit=2></div><div class="flex-5 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcGroup/calcWaste.html\'"></div><div class=flex-8><span ng-if=item.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCostPrice | readable: 2}}">{{item.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8>&nbsp;</div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCompanyCost | readable: 2}}">{{item.inventoryCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><input type=text class="calc-input input-primary" ng-if=item.inventoryAmount ng-model=item.inventoryProfitPercent ng-blur="vm.onUpdateItem(item, \'inventoryProfitPercent\', \'{{item.inventoryProfitPercent}}\')" number-edit=2></div><div class=flex-8><span ng-if="item.inventoryProfit !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.inventoryProfit !== undefined" title="{{item.inventoryProfit | readable: 2}}">{{item.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if="item.salesPrice !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.salesPrice !== undefined" title="{{item.salesPrice | readable: 2}}">{{item.salesPrice | readable: 2}}</span></div></div><div class=split-line></div><div class="flex bottom-row"><div class="flex-4 pl-20"><div class="outer-border px-1 float-left" ng-if="item.subStyle == \'Subcontractor\'">SUB</div><div class="outer-border px-1 float-left" ng-if="item.subStyle == \'Supplier\'">SUP</div></div><div class=w-12></div><div class="flex-13 name overflow-visible"><input type=text class="calc-input input-primary" ng-model=item.workerName></div><div class="flex-6 pr-5"><input type=number class="calc-input input-primary" title="{{item.workerAmount | readable: 2}}" ng-model=item.workerAmount ng-change="vm.onUpdateItem(item, \'workerAmount\', \'{{item.workerAmount}}\')"></div><div class=flex-11></div><div class=flex-4><span class=unit-value>hr</span></div><div class=flex-8>&nbsp;</div><div class=flex-5>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-6>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div></div><div class=edit-controls><img src=/assets/icons/checkmark-24.svg alt="" ng-click=vm.onConfirmEditItem(item)> <img ng-if="item.editMode===\'new\'" src=/assets/icons/close-24-dark.svg alt="" ng-click="vm.onDeleteItem(vm.model, $index)"></div></div></div><div ng-if=!item.editMode><!-- Combine --><div ng-if="item.rowStyle == \'Combined\'" class=calc-row><img class=tree-icon ng-if="item.items && item.items.length > 0" ng-click=vm.toggleTree(tree); ng-src="{{tree.open ? \'/assets/icons/arrow-bottom4.svg\' : \'/assets/icons/arrow-right4.svg\'}}"><div class=flex><div class="flex-4 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class=line-mark ng-class="{active: tree.open}"></div><div class="flex-13 name" title={{item.inventoryName}}>{{item.inventoryName}}</div><div class=flex-6><span class=calc-input title="{{item.inventoryAmount | readable: 2}}">{{item.inventoryAmount | readable: 2}}</span></div><div class="flex-11 work-type text-ellipsis" title={{item.workType}}>{{item.workType}}</div><div class=flex-4><span class=unit-value>{{item.inventoryUnit}}</span></div><div class=flex-8><span ng-if=item.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" style="width: 6em;" title="{{item.inventoryUnitPrice | readable: 2}}">{{item.inventoryUnitPrice | readable: 2}}</span></div><div class="flex-5 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcGroup/calcWaste.html\'"></div><div class=flex-8><span ng-if=item.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCostPrice | readable: 2}}">{{item.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8>&nbsp;</div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCompanyCost | readable: 2}}">{{item.inventoryCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><span class=calc-input ng-if=item.inventoryAmount>{{item.inventoryProfitPercent | readable: 2}}</span></div><div class=flex-8><span ng-if="item.inventoryProfit !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.inventoryProfit !== undefined" title="{{item.inventoryProfit | readable: 2}}">{{item.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if="item.salesPrice !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.salesPrice !== undefined" title="{{item.salesPrice | readable: 2}}">{{item.salesPrice | readable: 2}}</span></div></div><div class=split-line ng-class="tree.open ? \'ml-50\' : \'\'"></div><div class="flex pt-2"><div class="flex-4 pl-5"></div><div class=w-12></div><div class="flex-13 name" title={{item.workerName}}>{{item.workerName}}</div><div class=flex-6><span class=calc-input title="{{item.workerAmount | readable: 2}}">{{item.workerAmount | readable: 2}}</span></div><div class=flex-11>&nbsp;</div><div class=flex-4><span class=unit-value>{{item.workerUnit}}</span></div><div class=flex-8><span ng-if=item.workerUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{item.workerUnitPrice | readable: 2}}" style="width: 6em;">{{item.workerUnitPrice | readable: 2}}</span></div><div class=flex-5>&nbsp;</div><div class=flex-8><span ng-if=item.workerAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerAmount title="{{item.workerCostPrice | readable: 2}}">{{item.workerCostPrice | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerAmount title="{{item.labourHours | readable: 2}}">hr {{item.labourHours | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerCompanyCost title="{{item.workerCompanyCost | readable: 2}}">{{item.workerCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><span class=calc-input ng-if=item.workerAmount>{{item.workerProfitPercent | readable: 2}}</span></div><div class=flex-8><span ng-if="item.workerProfit !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.workerProfit !== undefined" title="{{item.workerProfit | readable: 2}}">{{item.workerProfit | readable: 2}}</span></div><div class=flex-8><span ng-if="item.workersPrice !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="item.workersPrice !== undefined" title="{{item.workersPrice | readable: 2}}">{{item.workersPrice | readable: 2}}</span></div></div><div class=delete-com><div class="dropdown mx-height5"><button class=dropdown-toggle type=button data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-click="vm.onViewDetailItem(item, vm.index)"><img src=/assets/icons/alarm2.svg alt="">View Details</li><li class=menu-item value="" ng-click=vm.onEditItem(item) ng-if="item.subStyle !== \'DCP\' && item.subStyle !== \'DCQ\' && vm.permission > 1"><img src=/assets/icons/edit-black.svg alt="">Edit</li><li class=menu-item value="" ng-click="vm.onDeleteItem(vm.model, $index)" ng-if="vm.permission > 3"><img src=/assets/icons/delete4.svg alt="">Delete</li><li class=menu-item value="" ng-if=item.modelId ng-click=vm.onLocViewItem(item)><img src=/assets/icons/preview-eye1.svg alt="">Location View</li></ul></div></div></div><!-- Inventory --><div ng-if="item.rowStyle == \'Inventory\'" class=calc-row><img class=tree-icon ng-if="item.items && item.items.length > 0" ng-click=vm.toggleTree(tree); ng-src="{{tree.open ? \'/assets/icons/arrow-bottom4.svg\' : \'/assets/icons/arrow-right4.svg\'}}"><div class=flex><div class="flex-4 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class=line-mark ng-class="{active: tree.open}"></div><div class="flex-13 name" title={{item.inventoryName}}>{{item.inventoryName}}</div><div class=flex-6><span class=calc-input title="{{item.inventoryAmount | readable: 2}}">{{item.inventoryAmount | readable: 2}}</span></div><div class="flex-11 work-type text-ellipsis" title={{item.workType}}>{{item.workType}}</div><div class=flex-4><span class=unit-value>{{item.inventoryUnit}}</span></div><div class=flex-8><span ng-if=item.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" style="width: 6em;" title="{{item.inventoryUnitPrice | readable: 2}}">{{item.inventoryUnitPrice | readable: 2}}</span></div><div class="flex-5 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcGroup/calcWaste.html\'"></div><div class=flex-8><span ng-if=item.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCostPrice | readable: 2}}">{{item.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCompanyCost | readable: 2}}">{{item.inventoryCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><span class=calc-input ng-if=item.inventoryAmount>{{item.inventoryProfitPercent | readable: 2}}</span></div><div class=flex-8><span ng-if=item.inventoryProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryProfit title="{{item.inventoryProfit | readable: 2}}">{{item.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=item.salesPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{item.salesPrice | readable: 2}}">{{item.salesPrice | readable: 2}}</span></div></div><div class=delete-com style="top: 0;"><div class="dropdown mx-height5"><button class=dropdown-toggle type=button data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-click="vm.onViewDetailItem(item, vm.index)"><img src=/assets/icons/alarm2.svg alt="">View Details</li><li class=menu-item value="" ng-click=vm.onEditItem(item) ng-if="item.subStyle !== \'DCP\' && item.subStyle !== \'DCQ\' && vm.permission > 1"><img src=/assets/icons/edit-black.svg alt="">Edit</li><li class=menu-item value="" ng-click="vm.onDeleteItem(vm.model, $index)"><img src=/assets/icons/delete4.svg alt="">Delete</li><li class=menu-item value="" ng-if=item.modelId ng-click=vm.onLocViewItem(item)><img src=/assets/icons/preview-eye1.svg alt="">Location View</li></ul></div></div></div><!-- Worker --><div ng-if="item.rowStyle == \'Worker\'" class=calc-row><div class=flex><div class="flex-4 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class=line-mark></div><div class="flex-13 name" title={{item.workerName}}>{{item.workerName}}</div><div class=flex-6><span class=calc-input title="{{item.workerAmount | readable: 2}}">{{item.workerAmount | readable: 2}}</span></div><div class="flex-11 work-type text-ellipsis" title={{item.workType}}>{{item.workType}}</div><div class=flex-4><span class=unit-value>{{item.workerUnit}}</span></div><div class=flex-8><span ng-if=item.workerUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{item.workerUnitPrice | readable: 2}}" style="width: 6em;">{{item.workerUnitPrice | readable: 2}}</span></div><div class=flex-5>&nbsp;</div><div class=flex-8><span ng-if=item.workerAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerAmount title="{{item.workerCostPrice | readable: 2}}">{{item.workerCostPrice | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerAmount title="{{item.labourHours | readable: 2}}">hr {{item.labourHours | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerCompanyCost title="{{item.workerCompanyCost | readable: 2}}">{{item.workerCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><span class=calc-input ng-if=item.workerAmount>{{item.workerProfitPercent | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workerProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.workerProfit title="{{item.workerProfit | readable: 2}}">{{item.workerProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=item.workersPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" ng-if=item.inventoryAmount title="{{item.workersPrice | readable: 2}}">{{item.workersPrice | readable: 2}}</span></div></div><div class=delete-com style="top: 0;"><div class="dropdown mx-height5"><button class=dropdown-toggle type=button data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-click="vm.onViewDetailItem(item, vm.index)"><img src=/assets/icons/alarm2.svg alt="">View Details</li><li class=menu-item value="" ng-click=vm.onEditItem(item)><img src=/assets/icons/edit-black.svg alt="">Edit</li><li class=menu-item value="" ng-click="vm.onDeleteItem(vm.model, $index)"><img src=/assets/icons/delete4.svg alt="">Delete</li><li class=menu-item value="" ng-if=item.modelId ng-click=vm.onLocViewItem(item)><img src=/assets/icons/preview-eye1.svg alt="">Location View</li></ul></div></div></div><!-- Collaborator --><div ng-if="item.rowStyle == \'Collaborator\'" class=calc-row><div class=flex><div class="flex-4 pl-5"><div class="outer-border px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class=line-mark ng-class="{active: tree.open}"></div><div class="flex-13 name" title={{item.inventoryName}}>{{item.inventoryName}}</div><div class=flex-6><span class=calc-input title="{{item.inventoryAmount | readable: 2}}">{{item.inventoryAmount | readable: 2}}</span></div><div class="flex-11 work-type text-ellipsis" title={{item.workType}}>{{item.workType}}</div><div class=flex-4><span class=unit-value>{{item.inventoryUnit}}</span></div><div class=flex-8><span ng-if=item.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" style="width: 6em;" title="{{item.inventoryUnitPrice | readable: 2}}">{{item.inventoryUnitPrice | readable: 2}}</span></div><div class="flex-5 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcGroup/calcWaste.html\'"></div><div class=flex-8><span ng-if=item.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCostPrice | readable: 2}}">{{item.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8>&nbsp;</div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryAmount title="{{item.inventoryCompanyCost | readable: 2}}">{{item.inventoryCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><span class=calc-input ng-if=item.inventoryAmount>{{item.inventoryProfitPercent | readable: 2}}</span></div><div class=flex-8><span ng-if=item.inventoryProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=item.inventoryProfit title="{{item.inventoryProfit | readable: 2}}">{{item.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=item.salesPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{item.salesPrice | readable: 2}}">{{item.salesPrice | readable: 2}}</span></div></div><div class=split-line></div><div class="flex bottom-row"><div class="flex-4 pl-20"><div class="outer-border px-1 float-left" ng-if="item.subStyle == \'Subcontractor\'">SUB</div><div class="outer-border px-1 float-left" ng-if="item.subStyle == \'Supplier\'">SUP</div></div><div class=w-12></div><div class="flex-13 name" title={{item.workerName}}>{{item.workerName}}</div><div class=flex-6><span class=calc-input title="{{item.workerAmount | readable: 2}}">{{item.workerAmount | readable: 2}}</span></div><div class=flex-11>&nbsp;</div><div class=flex-4><span class=unit-value>{{item.workerUnit}}</span></div><div class=flex-8>&nbsp;</div><div class=flex-5>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-6>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-8>&nbsp;</div></div><div class=delete-com><div class="dropdown mx-height5"><button class=dropdown-toggle type=button data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-click="vm.onViewDetailItem(item, vm.index)"><img src=/assets/icons/alarm2.svg alt="">View Details</li><li class=menu-item value="" ng-click=vm.onEditItem(item)><img src=/assets/icons/edit-black.svg alt="">Edit</li><li class=menu-item value="" ng-click="vm.onDeleteItem(vm.model, $index)"><img src=/assets/icons/delete4.svg alt="">Delete</li><li class=menu-item value="" ng-if=item.modelId ng-click=vm.onLocViewItem(item)><img src=/assets/icons/preview-eye1.svg alt="">Location View</li></ul></div></div></div></div><!-- Sub Items --><div class=sub-items ng-show=tree.open><div class=divider ng-repeat-start="subItem in item.items track by $index"></div><div class="inventory-item tree" ng-repeat-end="" ng-class="{\'one-row\': subItem.rowStyle===\'Inventory\'}"><div ng-if=subItem.editMode><!-- Combine --><div ng-if="subItem.rowStyle == \'Combined\'" class=calc-row><div class=flex><div class="flex-4 pl-5 ml-30"><div class="fill-no px-1">{{(vm.index+1) + \'.\' + (innerIndex0+1) + \'.\' + ($index+1)}}</div></div><div class="line-mark active"></div><div class="flex-13 name" title={{subItem.inventoryName}}>{{subItem.inventoryName}}</div><div class="flex-6 pr-5"><input type=text class="calc-input input-primary" title="{{subItem.inventoryAmount | readable: 2}}" ng-model=subItem.inventoryAmount number-edit=2 ng-change="vm.onUpdateItem(subItem, \'inventoryAmount\', \'{{subItem.inventoryAmount}}\', item)"></div><div class="flex-11 work-type text-ellipsis" title={{item.workType}}>{{subItem.workType}}</div><div class="flex-4 unit"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-click="vm.onOpenUnitsDropdown(\'MAT\')" ng-model=subItem.inventoryUnit>{{subItem.inventoryUnit}}</button><ul class=dropdown-menu role=menu ng-if="vm.rowForUnit==\'MAT\'"><li class=menu-item value="" ng-repeat="unit in vm.mUnits | unitFilter : \'inventory\' : subItem.rowStyle" ng-click="vm.onUnitSelect(unit,subItem,\'MAT\', true)">{{unit.name}}</li></ul></div></div><div class=flex-8><span ng-if=subItem.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <input type=text class="calc-input text-left input-primary" style="width: 6em;" number-edit=2 title="{{subItem.inventoryUnitPrice | readable: 2}}" ng-model=subItem.inventoryUnitPrice ng-change="vm.onUpdateItem(subItem, \'inventoryUnitPrice\', \'{{subItem.inventoryUnitPrice}}\', item)"></div><div class="flex-5 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcGroup/calcWasteSub.html\'"></div><div class=flex-8><span ng-if=subItem.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.inventoryAmount title="{{subItem.inventoryCostPrice | readable: 2}}">{{subItem.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8>&nbsp;</div><div class=flex-8><span ng-if=subItem.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.inventoryAmount title="{{subItem.inventoryCompanyCost | readable: 2}}">{{subItem.inventoryCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><input type=text class="calc-input input-primary" ng-if=subItem.inventoryAmount ng-model=subItem.inventoryProfitPercent number-edit=2 ng-blur="vm.onUpdateItem(subItem, \'inventoryProfitPercent\', \'{{subItem.inventoryProfitPercent}}\', item)"></div><div class=flex-8><span ng-if="subItem.inventoryProfit !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="subItem.inventoryProfit !== undefined" title="{{subItem.inventoryProfit | readable: 2}}">{{subItem.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if="subItem.salesPrice !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="subItem.salesPrice !== undefined" title="{{subItem.salesPrice | readable: 2}}">{{subItem.salesPrice | readable: 2}}</span></div></div><div class=split-line ng-class="tree.open ? \'ml-50\' : \'\'"></div><div class="flex pt-2"><div class="flex-4 pl-5 ml-30"></div><div class=w-12></div><div class="flex-13 name" title={{subItem.workerName}}>{{subItem.workerName}}</div><div class="flex-6 pr-5"><input type=number class="calc-input input-primary" ng-model=subItem.workerAmount title="{{subItem.workerAmount | readable: 2}}" ng-change="vm.onUpdateItem(subItem, \'workerAmount\', \'{{subItem.workerAmount}}\', item)"></div><div class=flex-11>&nbsp;</div><div class="flex-4 unit"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-click="vm.onOpenUnitsDropdown(\'WOR\')" ng-model=subItem.workerUnit readonly>{{subItem.workerUnit}}</button><ul class=dropdown-menu role=menu ng-if="vm.rowForUnit==\'WOR\'"><li class=menu-item value="" ng-repeat="unit in vm.mUnits | unitFilter : \'worker\' : subItem.rowStyle" ng-click="vm.onUnitSelect(unit,subItem,\'WOR\', true)">{{unit.name}}</li></ul></div></div><div class=flex-8><span ng-if=subItem.workerUnitPrice>{{vm.companyCurrency.symbol}}</span> <input type=text class="calc-input text-left input-primary" style="width: 6em;" number-edit=2 title="{{subItem.workerUnitPrice | readable: 2}}" ng-model=subItem.workerUnitPrice ng-change="vm.onUpdateItem(subItem, \'workerUnitPrice\', \'{{subItem.workerUnitPrice}}\', item)"></div><div class=flex-5>&nbsp;</div><div class=flex-8><span ng-if=subItem.workerAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.workerAmount title="{{subItem.workerCostPrice | readable: 2}}">{{subItem.workerCostPrice | readable: 2}}</span></div><div class=flex-8><span ng-if=subItem.workerAmount title="{{subItem.labourHours | readable: 2}}">hr {{subItem.labourHours | readable: 2}}</span></div><div class=flex-8><span ng-if=subItem.workerCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.workerCompanyCost title="{{subItem.workerCompanyCost | readable: 2}}">{{subItem.workerCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><input type=text class="calc-input input-primary" ng-if=subItem.workerAmount ng-model=subItem.workerProfitPercent number-edit=2 ng-blur="vm.onUpdateItem(subItem, \'workerProfitPercent\', \'{{subItem.workerProfitPercent}}\', item)"></div><div class=flex-8><span ng-if="subItem.workerProfit !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="subItem.workerProfit !== undefined" title="{{subItem.workerProfit | readable: 2}}">{{subItem.workerProfit | readable: 2}}</span></div><div class=flex-8><span ng-if="subItem.workersPrice !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="subItem.workersPrice !== undefined" title="{{subItem.workersPrice | readable: 2}}">{{subItem.workersPrice | readable: 2}}</span></div></div><div class=edit-controls><img src=/assets/icons/checkmark-24.svg alt="" ng-click=vm.onConfirmEditItem(subItem)></div></div><!-- Inventory --><div ng-if="subItem.rowStyle == \'Inventory\'" class=calc-row><div class=flex><div class="flex-4 pl-5 ml-30"><div class="fill-no px-1">{{(vm.index+1) + \'.\' + (innerIndex0+1) + \'.\' + ($index+1)}}</div></div><div class="line-mark active"></div><div class="flex-13 name" title={{subItem.inventoryName}}>{{subItem.inventoryName}}</div><div class="flex-6 pr-5"><input type=text class="calc-input input-primary" title="{{subItem.inventoryAmount | readable: 2}}" ng-model=subItem.inventoryAmount number-edit=2 ng-change="vm.onUpdateItem(subItem, \'inventoryAmount\', \'{{subItem.inventoryAmount}}\', item)"></div><div class="flex-11 work-type text-ellipsis" title={{item.workType}}>{{subItem.workType}}</div><div class="flex-4 unit"><div class=dropdown><button class="dropdown-toggle text-left" type=button data-toggle=dropdown ng-click="vm.onOpenUnitsDropdown(\'MAT\')" ng-model=subItem.inventoryUnit>{{subItem.inventoryUnit}}</button><ul class=dropdown-menu role=menu ng-if="vm.rowForUnit==\'MAT\'"><li class=menu-item value="" ng-repeat="unit in vm.mUnits | unitFilter : \'inventory\' : subItem.rowStyle" ng-click="vm.onUnitSelect(unit,subItem,\'MAT\', true)">{{unit.name}}</li></ul></div></div><div class=flex-8><span ng-if=subItem.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <input type=text class="calc-input text-left input-primary" style="width: 6em;" number-edit=2 title="{{subItem.inventoryUnitPrice | readable: 2}}" ng-model=subItem.inventoryUnitPrice ng-change="vm.onUpdateItem(subItem, \'inventoryUnitPrice\', \'{{subItem.inventoryUnitPrice}}\', item)"></div><div class="flex-5 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcGroup/calcWasteSub.html\'"></div><div class=flex-8><span ng-if=subItem.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.inventoryAmount title="{{subItem.inventoryCostPrice | readable: 2}}">{{subItem.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=subItem.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.inventoryAmount title="{{subItem.inventoryCompanyCost | readable: 2}}">{{subItem.inventoryCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><input type=text class="calc-input input-primary" ng-if=subItem.inventoryAmount ng-model=subItem.inventoryProfitPercent number-edit=2 ng-blur="vm.onUpdateItem(subItem, \'inventoryProfitPercent\', \'{{subItem.inventoryProfitPercent}}\', item)"></div><div class=flex-8><span ng-if="subItem.inventoryProfit !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="subItem.inventoryProfit !== undefined" title="{{subItem.inventoryProfit | readable: 2}}">{{subItem.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if="subItem.salesPrice !== undefined">{{vm.companyCurrency.symbol}}</span> <span ng-if="subItem.salesPrice !== undefined" title="{{subItem.salesPrice | readable: 2}}">{{subItem.salesPrice | readable: 2}}</span></div></div><div class=edit-controls><img src=/assets/icons/checkmark-24.svg alt="" ng-click=vm.onConfirmEditItem(subItem)> <img ng-if="subItem.editMode===\'new\'" src=/assets/icons/close-24-dark.svg alt="" ng-click="vm.onDeleteItem(vm.model, $index)"></div></div></div><div ng-if=!subItem.editMode><div ng-if="subItem.rowStyle == \'Combined\'" class=calc-row><div class=flex><div class="flex-4 pl-5 ml-30"><div class="fill-no px-1">{{(vm.index+1) + \'.\' + (innerIndex0+1) + \'.\' + ($index+1)}}</div></div><div class=line-mark></div><div class="flex-13 name" title={{subItem.inventoryName}}>{{subItem.inventoryName}}</div><div class=flex-6><span class=calc-input title="{{subItem.inventoryAmount | readable: 2}}">{{subItem.inventoryAmount * (subItem.quantity ? subItem.quantity : 1) | readable: 2}}</span></div><div class="flex-11 work-type text-ellipsis" title={{item.workType}}>{{subItem.workType}}</div><div class=flex-4><span class=unit-value>{{subItem.inventoryUnit}}</span></div><div class=flex-8><span ng-if=subItem.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" style="width: 6em;" title="{{subItem.inventoryUnitPrice | readable: 2}}">{{subItem.inventoryUnitPrice | readable: 2}}</span></div><div class="flex-5 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcGroup/calcWasteSub.html\'"></div><div class=flex-8><span ng-if=subItem.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.inventoryAmount title="{{subItem.inventoryCostPrice | readable: 2}}">{{subItem.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8>&nbsp;</div><div class=flex-8><span ng-if=subItem.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.inventoryAmount title="{{subItem.inventoryCompanyCost | readable: 2}}">{{subItem.inventoryCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><span class=calc-input ng-if=subItem.inventoryAmount>{{subItem.inventoryProfitPercent | readable: 2}}</span></div><div class=flex-8><span ng-if=subItem.inventoryProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.inventoryProfit title="{{subItem.inventoryProfit | readable: 2}}">{{subItem.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=subItem.salesPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{subItem.salesPrice | readable: 2}}">{{subItem.salesPrice | readable: 2}}</span></div></div><div class=split-line></div><div class=delete-com><div class="dropdown mx-height5"><button class=dropdown-toggle type=button data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-click="vm.onViewDetailItem(subItem, vm.index)"><img src=/assets/icons/alarm2.svg alt="">View Details</li><li class=menu-item value="" ng-click=vm.onEditItem(subItem) ng-if="item.editMode!==\'new\'"><img src=/assets/icons/edit-black.svg alt="">Edit</li><li class=menu-item value="" ng-if=subItem.modelId ng-click=vm.onLocViewItem(subItem)><img src=/assets/icons/preview-eye1.svg alt="">Location View</li></ul></div></div><div class=flex><div class="flex-4 pl-5 ml-30"></div><div class=w-12></div><div class="flex-13 name" title={{subItem.workerName}}>{{subItem.workerName}}</div><div class=flex-6><span class=calc-input title="{{subItem.workerAmount | readable: 2}}">{{subItem.workerAmount | readable: 2}}</span></div><div class=flex-11>&nbsp;</div><div class=flex-4><span class=unit-value>{{subItem.workerUnit}}</span></div><div class=flex-8><span ng-if=subItem.workerUnitPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{subItem.workerUnitPrice | readable: 2}}" style="width: 6em;">{{subItem.workerUnitPrice | readable: 2}}</span></div><div class=flex-5>&nbsp;</div><div class=flex-8><span ng-if=subItem.workerAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.workerAmount title="{{subItem.workerCostPrice | readable: 2}}">{{subItem.workerCostPrice | readable: 2}}</span></div><div class=flex-8><span ng-if=subItem.workerAmount title="{{subItem.labourHours | readable: 2}}">hr {{subItem.labourHours | readable: 2}}</span></div><div class=flex-8><span ng-if=subItem.workerCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.workerCompanyCost title="{{subItem.workerCompanyCost | readable: 2}}">{{subItem.workerCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><span class=calc-input ng-if=subItem.workerAmount>{{subItem.workerProfitPercent | readable: 2}}</span></div><div class=flex-8><span ng-if=subItem.workerProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.workerProfit title="{{subItem.workerProfit | readable: 2}}">{{subItem.workerProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=subItem.workersPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" ng-if=subItem.inventoryAmount title="{{subItem.workersPrice | readable: 2}}">{{subItem.workersPrice | readable: 2}}</span></div></div></div><div ng-if="subItem.rowStyle == \'Inventory\'" class=calc-row><div class=flex><div class="flex-4 pl-5 ml-30"><div class="fill-no px-1">{{(vm.index+1) + \'.\' + (innerIndex0+1) + \'.\' + ($index+1)}}</div></div><div class=line-mark></div><div class="flex-13 name" title={{subItem.inventoryName}}>{{subItem.inventoryName}}</div><div class=flex-6><span class=calc-input title="{{subItem.inventoryAmount | readable: 2}}">{{subItem.inventoryAmount | readable: 2}}</span></div><div class="flex-11 work-type text-ellipsis" title={{item.workType}}>{{subItem.workType}}</div><div class=flex-4><span class=unit-value>{{subItem.inventoryUnit}}</span></div><div class=flex-8><span ng-if=subItem.inventoryUnitPrice>{{vm.companyCurrency.symbol}}</span> <input type=text class="calc-input text-left input-primary" style="width: 6em;" number-edit=2 title="{{subItem.inventoryUnitPrice | readable: 2}}" ng-model=subItem.inventoryUnitPrice ng-change="vm.onUpdateItem(subItem, \'inventoryUnitPrice\', \'{{subItem.inventoryUnitPrice}}\', item)"></div><div class="flex-5 pos-relative overflow-visible waste" ng-include="\'app/main/calc/directives/calcGroup/calcWasteSub.html\'"></div><div class=flex-8><span ng-if=subItem.inventoryAmount>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.inventoryAmount title="{{subItem.inventoryCostPrice | readable: 2}}">{{subItem.inventoryCostPrice | readable: 2}}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=subItem.inventoryCompanyCost>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.inventoryAmount title="{{subItem.inventoryCompanyCost | readable: 2}}">{{subItem.inventoryCompanyCost | readable: 2}}</span></div><div class="flex-6 profit-percent"><input type=text class="calc-input input-primary" ng-if=subItem.inventoryAmount ng-model=subItem.inventoryProfitPercent number-edit=2 ng-blur="vm.onUpdateItem(subItem, \'inventoryProfitPercent\', \'{{subItem.inventoryProfitPercent}}\', item)"></div><div class=flex-8><span ng-if=subItem.inventoryProfit>{{vm.companyCurrency.symbol}}</span> <span ng-if=subItem.inventoryProfit title="{{subItem.inventoryProfit | readable: 2}}">{{subItem.inventoryProfit | readable: 2}}</span></div><div class=flex-8><span ng-if=subItem.salesPrice>{{vm.companyCurrency.symbol}}</span> <span class="calc-input text-left" title="{{subItem.salesPrice | readable: 2}}">{{subItem.salesPrice | readable: 2}}</span></div></div><div class=delete-com style="top: 0;"><div class="dropdown mx-height5"><button class=dropdown-toggle type=button data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-click="vm.onViewDetailItem(subItem, vm.index)"><img src=/assets/icons/alarm2.svg alt="">View Details</li><li class=menu-item value="" ng-click=vm.onEditItem(subItem) ng-if="item.editMode!==\'new\'"><img src=/assets/icons/edit-black.svg alt="">Edit</li><li class=menu-item value="" ng-if=subItem.modelId ng-click=vm.onLocViewItem(subItem)><img src=/assets/icons/preview-eye1.svg alt="">Location View</li></ul></div></div></div></div></div></div></div></div><!-- Levels --><div><div class="inventory-level pos-relative" ng-repeat="sublevel in vm.model.levels track by $index"><div ng-if=sublevel.isEdit><div class=flex><div class="flex-4 pl-5"><div class="outer-border level px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class="line-mark active"></div><div class="flex-13 name overflow-visible"><selectbox ng-if="vm.workLevels && vm.levelDepth<2" class="pos-relative rounded zindex-2 dropdown-primary level-input" ng-model=sublevel.name options=vm.workLevels exclude-items=vm.excludeWorkLevelList label-field=tagName value-field=tagName placeholder={{sublevel.name}} is-click-open=true select-event=vm.onChangeWorkLevel(sublevel)></selectbox><input ng-if="vm.levelDepth>=2" type=text ng-model=sublevel.name title={{sublevel.name}} class="calc-input pos-relative level-input zindex-2 input-primary"></div><div class=flex-6></div><div class=flex-11></div><div class=flex-4></div><div class=flex-8></div><div class=flex-5></div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (sublevel.sumCostPrice | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{sublevel.sumCostPrice | readable: 2}}</div><div class=flex-8 title="{{\'hr \' + (sublevel.sumHours | readable: 2)}}">hr {{sublevel.sumHours | readable: 2}}</div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (sublevel.sumCompanyCost | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{sublevel.sumCompanyCost | readable: 2}}</div><div class=flex-6>{{(sublevel.sumProfit * 100 / sublevel.sum) | readable: 2}}</div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (sublevel.sumProfit | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{sublevel.sumProfit | readable: 2}}</div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (sublevel.sum | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{sublevel.sum | readable: 2}}</div></div><div class=edit-controls ng-if=sublevel.isEdit><img src=/assets/icons/checkmark-24.svg alt="" ng-click=vm.onCancelSubLevelEdit(sublevel)> <img src=/assets/icons/close-24-dark.svg alt="" ng-click="vm.onDeleteSubLevel($index, vm.model.levels, vm.index)"></div></div><div class=cursor-point ng-if=!sublevel.isEdit><div class=flex ng-click="vm.onEnterChild(vm.index, $index, sublevel)"><div class="flex-4 pl-5"><div class="outer-border level px-1">{{(vm.index+1) + \'.\'+($index+1)}}</div></div><div class=line-mark></div><div class="flex-13 name" title={{sublevel.name}}>{{sublevel.name}}</div><div class=flex-6></div><div class=flex-11></div><div class=flex-4></div><div class=flex-8></div><div class=flex-5></div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (sublevel.sumCostPrice | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{sublevel.sumCostPrice | readable: 2}}</div><div class=flex-8 title="{{\'hr \' + (sublevel.sumHours | readable: 2)}}">hr {{sublevel.sumHours | readable: 2}}</div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (sublevel.sumCompanyCost | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{sublevel.sumCompanyCost | readable: 2}}</div><div class=flex-6>{{(sublevel.sumProfit * 100 / sublevel.sum) | readable: 2}}</div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (sublevel.sumProfit | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{sublevel.sumProfit | readable: 2}}</div><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (sublevel.sum | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{sublevel.sum | readable: 2}}</div></div><div class=delete-com style="top: 5px;"><div class="dropdown btn-del"><button class="dropdown-toggle btn-del" type=button data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu><li class=menu-item value="" ng-click="vm.onViewDetailLevel(sublevel, vm.index)"><img src=/assets/icons/alarm2.svg alt="">View Details</li><li class=menu-item value="" ng-click="vm.onDeleteSubLevel($index, vm.model.levels, vm.index)" ng-if="vm.permission > 3"><img src=/assets/icons/delete4.svg alt="">Delete</li><li class=menu-item value="" ng-if=sublevel.modelId ng-click=vm.onLocViewLevel(sublevel)><img src=/assets/icons/preview-eye1.svg alt="">Location View</li><li class=menu-item value="" ng-if="vm.levelDepth<2 && vm.permission > 1" ng-click=vm.onCloneLevel(sublevel)><img src=/assets/icons/fm_copy.svg alt="">Clone</li></ul></div></div></div></div></div><!-- Summary --><div class=sum><div class="flex-4 pl-5"></div><div class=w-12></div><div class=flex-13 translate=Sum></div><div class=flex-6></div><div class=flex-11></div><div class=flex-4></div><div class=flex-8></div><div class=flex-5></div><!-- Cost Price --><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (vm.model.sumCostPrice | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{vm.model.sumCostPrice | readable: 2}}</div><!-- Hours --><div class=flex-8 title="{{\'hr \' + (vm.model.sumHours | readable: 2)}}">hr {{vm.model.sumHours | readable: 2}}</div><!-- Operating Cost --><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (vm.model.sumCompanyCost | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{vm.model.sumCompanyCost | readable: 2}}</div><!-- Profit % --><div class=flex-6>{{ (vm.model.sumProfit * 100 / vm.model.sum) | readable: 2 }}</div><!-- Profit --><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (vm.model.sumProfit | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{vm.model.sumProfit | readable: 0}}</div><!--Sales Price --><div class=flex-8 title="{{vm.companyCurrency.symbol + \' \' + (vm.model.sum | readable: 2)}}">{{vm.companyCurrency.symbol}}&nbsp;{{vm.model.sum | readable: 2}}</div></div><!-- New Section & Item --><div class="add-new-line-wrap mb-20" ng-if="vm.permission > 2"><div class=add-new-line ng-click=vm.onAddNewLevel(vm.index) ng-if=!vm.isFilter><div class=circle2><img src=/assets/icons/plus.svg alt=""></div><div class=ft_14_600_black ng-if="vm.levelDepth<2" translate="Add New Level"></div><div class=ft_14_600_black ng-if="vm.levelDepth>=2" translate="Add New Section"></div></div><div class="add-new-line ml-10" ng-click=vm.onAddNewItem(vm.index) ng-if="vm.levelDepth>=2"><div class=circle1><img src=/assets/icons/plus.svg alt=""></div><div class=ft_14_600_black translate="Add New Item"></div></div></div></div>');
$templateCache.put('app/main/calc/directives/calcGroup/calcWaste.html','<div class=dropdown><button class=dropdown-toggle type=button id=menu1 data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class=text-center><img src=/assets/icons/preview-eye1.svg alt=""></div></button><div class=dropdown-menu><div class="menu-box ft_12_600_black"><div class=font-weight-semibold><div class=text-align-center><span translate=Waste></span> {{item.wasteAmount || 0 |readable: 2}} {{item.inventoryUnit || "(N/A)"}}</div><div class="d-flex justify-content-center"><input style="width: 30px; margin-top: -2px;" type=text ng-model=item.wastePercent ng-blur="vm.onUpdateItem(item, \'wastePercent\', \'{{item.wastePercent}}\')"> <span>%</span></div></div></div><div class=arrow></div></div></div>');
$templateCache.put('app/main/calc/directives/calcGroup/calcWasteSub.html','<div class=dropdown><button class=dropdown-toggle type=button id=menu1 data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class=text-center><img src=/assets/icons/preview-eye1.svg alt=""></div></button><div class=dropdown-menu><div class="menu-box ft_12_600_black"><div class=font-weight-semibold><div class=text-align-center><span translate=Waste></span> {{subItem.wasteAmount || 0 |readable: 2}} {{subItem.inventoryUnit || "(N/A)"}}</div><div class="d-flex justify-content-center"><input style="width: 30px; margin-top: -2px;" type=text ng-model=subItem.wastePercent ng-blur="vm.onUpdateItem(subItem, \'wastePercent\', \'{{subItem.wastePercent}}\', item)"> <span>%</span></div></div></div><div class=arrow></div></div></div>');
$templateCache.put('app/main/calc/directives/calcSelector/calcSelector.view.html','<div class="calc-selector dropdown mx-height2"><button class=dropdown-toggle type=button data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu><li class=pos-relative ng-repeat="item in options" ng-mouseenter=onShowSub(item) ng-mouseleave=onHideSub(item)><div class="selector-item d-flex" ng-click=onItemSelect(item)><span class=mr-10>{{ item.name }}</span> <img class=ml-auto ng-if=item.sub src=/assets/icons/chevron-right.svg alt=""></div><ul ng-if="item.sub && item.showSub"><li ng-repeat="subItem in item.sub"><div class="selector-item d-flex" ng-click=onItemSelect(subItem)><span class=mr-10>{{ subItem.name }}</span></div></li></ul></li></ul></div>');
$templateCache.put('app/main/calc/directives/calcVersionContent/calcVersionContent.view.html','<div id=diff-content><div class=bread-crumb><div class=item ng-click=goToRoot()>Root</div><div class=flex ng-repeat="item in currentStateList"><img src=/assets/icons/arrow-right2.svg alt=""><div class=item ng-click=changeBreadCrumb($index)>{{ item.name }}</div></div></div><div class=version-calc-main id={{tag}}><div ng-if="openLevel==false" ng-repeat="material in version.levels" ng-init="outerIndex=$index"><div class=version-cal-card><div class=box-shadow-white><div class=title><div class=item-title ng-click=gotoBreadCrumb(outerIndex)>{{material.name}}</div></div><div class=header-item><div class=flex-4><div class=outer-border>{{outerIndex+1}}</div></div><div class=flex-8 style=padding-left:10px translate=Items></div><div class=flex-8 translate=Amount1></div><div class=flex-8 translate=Unit></div><div class=flex-8 translate="Unit Price"></div><div class=flex-8 translate=Waste></div><div class=flex-8 translate="Cost Price"></div><div class=flex-8 translate="Labour Hours"></div><div class=flex-8 translate="Operating Cost"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-8 translate=Profit></div><div class=flex-8 translate="Sales Price"></div></div><!-- Items --><div><div class=inventory-item ng-repeat-start="item in material.items | removeBlackItems track by $index" dtr-init=true ng-init="innerIndex0=$index" ng-if=!item.empty ng-class="\'{{ item.diff }}\'"><!-- Combine --><div class="version-calc-row pos-relative" ng-if="item.rowStyle == \'Combined\'"><div class=flex><div class=flex-4 ng-mouseover=showImage(item,outerIndex,$index)><div class=outer-border>{{(outerIndex+1) + \'.\'+($index+1)}}</div></div><div class="flex-8 name pl-10-tx-left">{{item.inventoryName || \'Inventory\'}}</div><div class=flex-8>{{item.inventoryAmount | readable: 2}}</div><div class=flex-8>{{item.inventoryUnit}}</div><div class=flex-8><span ng-if=item.inventoryUnitPrice>{{ companyCurrency.symbol }}</span>{{item.inventoryUnitPrice | readable: 2}}</div><div class="flex-8 pos-relative overflow-visible"><div ng-click="hoverIn=!hoverIn" ng-init="hoverIn=false" ng-mouseover="hoverIn=true" ng-mouseleave="hoverIn=false"><img src=/assets/icons/preview-eye1.svg alt=""></div><div ng-if=hoverIn class="wastePercent ft_12_600_black"><span translate=Waste></span>-<input type=text ng-model=item.wastePercent><span>%</span><div>{{ item.wasteAmount || 0 |readable: 2 }} {{ item.inventoryUnit || "(N/A)" }}</div></div></div><div class=flex-8><span ng-if=item.inventoryCostPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryCostPrice>{{ item.inventoryCostPrice | readable: 2 }}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryCompanyCost>{{ item.inventoryCompanyCost | readable: 2 }}</span></div><div class=flex-8>{{item.inventoryProfitPercent | readable: 0}}</div><div class=flex-8><span ng-if=item.inventoryProfit>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryProfit>{{ item.inventoryProfit | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.salesPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.salesPrice>{{ item.salesPrice | readable: 2 }}</span></div></div><div class=split-line></div><div class=flex><div class=flex-4></div><div class="flex-8 name pl-10-tx-left">{{item.workerName || \'Worker\'}}</div><div class=flex-8>{{item.workerAmount | readable: 2}}</div><div class=flex-8>{{item.workerUnit}}</div><div class=flex-8><span ng-if=item.workerUnitPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerUnitPrice>{{ item.workerUnitPrice | readable: 2 }}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=item.workerAmount>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerCostPrice>{{ item.workerCostPrice | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.labourHours>{{ item.labourHours | readable: 2 }} hours</span></div><div class=flex-8><span ng-if=item.workerCompanyCost>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerCompanyCost>{{ item.workerCompanyCost | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workerProfitPercent>{{ item.workerProfitPercent | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workerProfit>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerProfit>{{ item.workerProfit | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workersPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.workersPrice>{{ item.workersPrice | readable: 2 }}</span></div></div></div><!-- Inventory --><div class="version-calc-row pos-relative" ng-if="item.rowStyle == \'Inventory\'"><div class=flex><div class=flex-4 ng-mouseover=showImage(item,outerIndex,$index)><div class=outer-border>{{(outerIndex+1) + \'.\'+($index+1)}}</div></div><div class="flex-8 name pl-10-tx-left">{{item.inventoryName || \'Inventory\'}}</div><div class=flex-8>{{item.inventoryAmount | readable: 2}}</div><div class=flex-8>{{item.inventoryUnit}}</div><div class=flex-8><span ng-if=item.inventoryUnitPrice>{{ companyCurrency.symbol }}</span>{{item.inventoryUnitPrice | readable: 2}}</div><div class="flex-8 pos-relative overflow-visible"><div ng-click="hoverIn=!hoverIn" ng-init="hoverIn=false" ng-mouseover="hoverIn=true" ng-mouseleave="hoverIn=false"><img src=/assets/icons/preview-eye1.svg alt=""></div><div ng-if=hoverIn class="wastePercent ft_12_600_black"><span>Waste-</span><input type=text ng-model=item.wastePercent><span>%</span><div>{{ item.wasteAmount || 0 |readable: 2 }} {{ item.inventoryUnit || "(N/A)" }}</div></div></div><div class=flex-8><span ng-if=item.inventoryCostPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryCostPrice>{{ item.inventoryCostPrice | readable: 2 }}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryCompanyCost>{{ item.inventoryCompanyCost | readable: 2 }}</span></div><div class=flex-8>{{item.inventoryProfitPercent | readable: 0}}</div><div class=flex-8><span ng-if=item.inventoryProfit>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryProfit>{{ item.inventoryProfit | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.salesPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.salesPrice>{{ item.salesPrice | readable: 2 }}</span></div></div></div><!-- Worker --><div class="version-calc-row pos-relative" ng-if="item.rowStyle == \'Worker\'"><div class=flex><div class=flex-4></div><div class="flex-8 name pl-10-tx-left">{{item.workerName || \'Worker\'}}</div><div class=flex-8>{{item.workerAmount | readable: 2}}</div><div class=flex-8>{{item.workerUnit}}</div><div class=flex-8><span ng-if=item.workerUnitPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerUnitPrice>{{ item.workerUnitPrice | readable: 2 }}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=item.workerAmount>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerCostPrice>{{ item.workerCostPrice | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.labourHours>{{ item.labourHours | readable: 2 }} hours</span></div><div class=flex-8><span ng-if=item.workerCompanyCost>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerCompanyCost>{{ item.workerCompanyCost | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workerProfitPercent>{{ item.workerProfitPercent | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workerProfit>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerProfit>{{ item.workerProfit | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workersPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.workersPrice>{{ item.workersPrice | readable: 2 }}</span></div></div></div></div><div ng-repeat-end ng-if=item.empty class=empty-item><div></div></div></div><!-- Levels --><div><div class="inventory-level pos-relative" ng-repeat-start="sublevel in material.levels | removeBlackItems track by $index" ng-if=!sublevel.empty ng-class="\'{{sublevel.diff}}\'"><div class=flex ng-click="callBreadCrumb(outerIndex, $index, sublevel)"><div class=flex-4><div class="outer-border level">{{(outerIndex+1) + \'.\'+($index+1)}}</div></div><div class="flex-8 pl-10-tx-left">{{ sublevel.name }}</div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ sublevel.sumCostPrice | readable: 2 }}</div><div class=flex-8>{{ sublevel.sumHours | readable: 2 }}&nbsp;hours</div><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ sublevel.sumCompanyCost | readable: 2 }}</div><div class=flex-8>{{ sublevel.sumProfit/sublevel.sum*100 | readable: 2 }}</div><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ sublevel.sumProfit | readable: 2 }}</div><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ sublevel.sum | readable: 2 }}</div></div></div><div ng-repeat-end ng-if=sublevel.empty class=empty-level><div></div></div></div><div class="sum bt-border4"><div class=flex-4></div><div class="flex-8 flex-center" translate=Sum></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><!-- Cost Price --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ material.sumCostPrice | readable: 2 }}</div><!-- Operating Cost --><div class=flex-8>{{ material.sumHours | readable: 2 }}&nbsp;hours</div><!-- Operating Cost --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ material.sumCompanyCost | readable: 2 }}</div><!-- Profit % --><div class=flex-8>{{ material.sumProfit/material.sum*100 | readable: 2 }}</div><!-- Profit --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ material.sumProfit | readable: 2 }}</div><!--Sales Price --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ material.sum | readable: 2 }}</div></div></div><div class=mb-30></div></div></div><div id=cal-total class=box-shadow-white ng-if="openLevel==false"><div class=title><div class=flex-4>{{ version.levels.length + 1 }}</div><div class=flex-8 translate=Total></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8 translate="Cost Price"></div><div class=flex-8 translate="Labour Hours"></div><div class=flex-8 translate="Operating Cost"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-8 translate=Profit></div><div class="flex-8 overflow-visible"><div class=flex><div translate="Sales Price"></div><div class=alarm1 ng-mouseover="hoverIn=true" ng-mouseleave="hoverIn=false" ng-init="hoverIn=false"><img src=/assets/icons/alarm1.svg alt=""></div></div><div class="sales-price pos-relative" ng-if=hoverIn><div class="european ft_14_regular_gray"><div><span translate="Sales Price"></span> : {{totalSum | readable: 2}}</div><div><span translate=Inventory></span> : {{totalInventoryCost | readable: 2}}</div><div><span translate="Labour Cost"></span> : {{totalWorkerCost | readable: 2}}</div><div><span translate="Operating Cost"></span> : {{totalCompanyCost | readable: 2}}</div><div><span translate=Profit></span> : {{totalProfit| readable: 2}}</div></div></div></div></div><div class="sum bt-border4"><div class=flex-4></div><div class="flex-8 flex-center" translate=Sum></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><!-- Cost Price --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ version.totalCostPrice | readable: 2 }}</div><!-- Working Hours --><div class=flex-8>{{ version.totalWorkingHours | readable: 2 }}&nbsp;hours</div><!-- Operating Cost --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ version.totalCompanyCost | readable: 2 }}</div><!-- Profit % --><div class=flex-8>{{ version.totalProfit/version.sum*100 | readable: 2 }}</div><!-- Profit --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ version.totalProfit | readable: 2 }}</div><!--Sales Price --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ version.sum | readable: 2 }}</div></div></div><div ng-if="openLevel==true" class=box-shadow-white><div class=version-cal-card style="margin-bottom: 0;"><div class=title><div class=item-title>{{currentState.name}}</div></div><div class=header-item><div class=flex-4><div class=outer-border>{{breadCrumbIndex+1}}</div></div><div class=flex-8 style=padding-left:10px translate=Items></div><div class=flex-8 translate=Amount1></div><div class=flex-8 translate=Unit></div><div class=flex-8 translate="Unit Price"></div><div class=flex-8 translate=Waste></div><div class=flex-8 translate="Cost Price"></div><div class=flex-8 translate="Labour Hours"></div><div class=flex-8 translate="Operating Cost"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-8 translate=Profit></div><div class=flex-8 translate="Sales Price"></div></div><!-- Items --><div><div class=inventory-item ng-repeat-start="item in currentState.items | removeBlackItems track by $index" ng-if=!item.empty ng-init="innerIndex0=$index" ng-class="\'{{ item.diff }}\'"><!-- Combine --><div ng-if="item.rowStyle == \'Combined\'" class="version-calc-row pos-relative"><div class=flex><div class=flex-4 ng-mouseover=showImage(item,outerIndex,$index)><div class=outer-border>{{(outerIndex+1) + \'.\'+($index+1)}}</div></div><div class="flex-8 name pl-10-tx-left">{{item.inventoryName || \'Inventory\'}}</div><div class=flex-8>{{item.inventoryAmount | readable: 2}}</div><div class=flex-8>{{item.inventoryUnit}}</div><div class=flex-8><span ng-if=item.inventoryUnitPrice>{{ companyCurrency.symbol }}</span>{{item.inventoryUnitPrice | readable: 2}}</div><div class="flex-8 pos-relative overflow-visible"><div ng-click="hoverIn=!hoverIn" ng-init="hoverIn=false" ng-mouseover="hoverIn=true" ng-mouseleave="hoverIn=false"><img src=/assets/icons/preview-eye1.svg alt=""></div><div ng-if=hoverIn class="wastePercent ft_12_600_black"><span>Waste-</span><input type=text ng-model=item.wastePercent><span>%</span><div>{{ item.wasteAmount || 0 |readable: 2 }} {{ item.inventoryUnit || "(N/A)" }}</div></div></div><div class=flex-8><span ng-if=item.inventoryCostPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryCostPrice>{{ item.inventoryCostPrice | readable: 2 }}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryCompanyCost>{{ item.inventoryCompanyCost | readable: 2 }}</span></div><div class=flex-8>{{item.inventoryProfitPercent | readable}}</div><div class=flex-8><span ng-if=item.inventoryProfit>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryProfit>{{ item.inventoryProfit | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.salesPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.salesPrice>{{ item.salesPrice | readable: 2 }}</span></div></div><div class=split-line></div><div class=flex><div class=flex-4></div><div class="flex-8 name pl-10-tx-left">{{item.workerName || \'Worker\'}}</div><div class=flex-8>{{item.workerAmount | readable: 2}}</div><div class=flex-8>{{item.workerUnit}}</div><div class=flex-8><span ng-if=item.workerUnitPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerUnitPrice>{{ item.workerUnitPrice | readable: 2 }}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=item.workerAmount>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerCostPrice>{{ item.workerCostPrice | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.labourHours>{{ item.labourHours | readable: 2 }} hours</span></div><div class=flex-8><span ng-if=item.workerCompanyCost>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerCompanyCost>{{ item.workerCompanyCost | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workerProfitPercent>{{ item.workerProfitPercent | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workerProfit>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerProfit>{{ item.workerProfit | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workersPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.workersPrice>{{ item.workersPrice | readable: 2 }}</span></div></div></div><!-- Inventory --><div ng-if="item.rowStyle == \'Inventory\'" class="version-calc-row pos-relative"><div class=flex><div class=flex-4 ng-mouseover=showImage(item,outerIndex,$index)><div class=outer-border>{{(outerIndex+1) + \'.\'+($index+1)}}</div></div><div class="flex-8 name pl-10-tx-left">{{item.inventoryName || \'Inventory\'}}</div><div class=flex-8>{{item.inventoryAmount | readable: 2}}</div><div class=flex-8>{{item.inventoryUnit}}</div><div class=flex-8><span ng-if=item.inventoryUnitPrice>{{ companyCurrency.symbol }}</span>{{item.inventoryUnitPrice | readable: 2}}</div><div class="flex-8 pos-relative overflow-visible"><div ng-click="hoverIn=!hoverIn" ng-init="hoverIn=false" ng-mouseover="hoverIn=true" ng-mouseleave="hoverIn=false"><img src=/assets/icons/preview-eye1.svg alt=""></div><div ng-if=hoverIn class="wastePercent ft_12_600_black"><span>Waste-</span><input type=text ng-model=item.wastePercent><span>%</span><div>{{ item.wasteAmount || 0 |readable: 2 }} {{ item.inventoryUnit || "(N/A)" }}</div></div></div><div class=flex-8><span ng-if=item.inventoryCostPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryCostPrice>{{ item.inventoryCostPrice | readable: 2 }}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=item.inventoryCompanyCost>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryCompanyCost>{{ item.inventoryCompanyCost | readable: 2 }}</span></div><div class=flex-8>{{item.inventoryProfitPercent | readable}}</div><div class=flex-8><span ng-if=item.inventoryProfit>{{ companyCurrency.symbol }}</span> <span ng-if=item.inventoryProfit>{{ item.inventoryProfit | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.salesPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.salesPrice>{{ item.salesPrice | readable: 2 }}</span></div></div></div><!-- Worker --><div ng-if="item.rowStyle == \'Worker\'" class="version-calc-row pos-relative"><div class=flex><div class=flex-4></div><div class="flex-8 name pl-10-tx-left">{{item.workerName || \'Worker\'}}</div><div class=flex-8>{{item.workerAmount | readable: 2}}</div><div class=flex-8>{{item.workerUnit}}</div><div class=flex-8><span ng-if=item.workerUnitPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerUnitPrice>{{ item.workerUnitPrice | readable: 2 }}</span></div><div class=flex-8></div><div class=flex-8><span ng-if=item.workerAmount>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerCostPrice>{{ item.workerCostPrice | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.labourHours>{{ item.labourHours | readable: 2 }} hours</span></div><div class=flex-8><span ng-if=item.workerCompanyCost>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerCompanyCost>{{ item.workerCompanyCost | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workerProfitPercent>{{ item.workerProfitPercent | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workerProfit>{{ companyCurrency.symbol }}</span> <span ng-if=item.workerProfit>{{ item.workerProfit | readable: 2 }}</span></div><div class=flex-8><span ng-if=item.workersPrice>{{ companyCurrency.symbol }}</span> <span ng-if=item.workersPrice>{{ item.workersPrice | readable: 2 }}</span></div></div></div></div><div ng-repeat-end ng-if=item.empty class=empty-item><div></div></div></div><!-- Levels --><div><div class="inventory-level pos-relative" ng-repeat="sublevel in currentState.levels| removeBlackItems track by $index" ng-if=!sublevel.empty ng-class="\'{{sublevel.diff}}\'"><div class=flex ng-init="innerIndex1=$index;sublevel.name=(!sublevel.name) ? currentState.name+\'_\'+[$index+1] : sublevel.name" ng-click="breadCrumbSubLevel($index, sublevel)"><div class=flex-4><div class="outer-border level">{{(outerIndex+1) + \'.\'+($index+1)}}</div></div><div class="flex-8 pl-10-tx-left">{{ sublevel.name }}</div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ sublevel.sumCostPrice | readable: 2 }}</div><div class=flex-8>{{ sublevel.sumHours | readable: 2 }}&nbsp;hours</div><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ sublevel.sumCompanyCost | readable: 2 }}</div><div class=flex-8>{{ sublevel.sumProfit/sublevel.sum*100 | readable: 2 }}</div><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ sublevel.sumProfit | readable: 2 }}</div><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ sublevel.sum | readable: 2 }}</div></div></div><div ng-repeat-end ng-if=sublevel.empty class=empty-level><div></div></div></div><div class="sum bt-border4"><div class=flex-4></div><div class="flex-8 flex-center" translate=Sum></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><div class=flex-8></div><!-- Cost Price --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ currentState.sumCostPrice | readable: 2 }}</div><!-- Operating Cost --><div class=flex-8>{{ currentState.sumHours | readable: 2 }}&nbsp;hours</div><!-- Operating Cost --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ currentState.sumCompanyCost | readable: 2 }}</div><!-- Profit % --><div class=flex-8>{{ currentState.sumProfit/currentState.sum*100 | readable: 2 }}</div><!-- Profit --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ currentState.sumProfit | readable: 2 }}</div><!--Sales Price --><div class=flex-8>{{ companyCurrency.symbol }}&nbsp;{{ currentState.sum | readable: 2 }}</div></div></div></div></div></div>');
$templateCache.put('app/main/calc/directives/calcVersionTreeDiff/calcVersionTreeDiff.view.html','<div id=diff-container class=flex-between><div class=diff-sub><div class=title>{{oldVersionSeq != -1 ? \'Version Sequence \' + oldVersionSeq : \'Current Sequence\'}}</div><div class=diff-content><div class=calc-version-tree ui-tree data-drag-enabled=false style="margin: 24px;"><ul ui-tree-nodes="" ng-model=oldtree><div class=join-point></div><li ng-repeat="item in oldtree" ui-tree-node ng-include="\'/app/main/calc/directives/calc-version-treeitem.html\'"></li></ul></div></div></div><div class=diff-sub><div class=title>{{newVersionSeq != undefined ? \'Version Sequence \' + newVersionSeq : \'Current Sequence\'}}</div><div class=diff-content><div class=calc-version-tree ui-tree data-drag-enabled=false style="margin: 24px;"><ul ui-tree-nodes="" ng-model=newtree><div class=join-point></div><li ng-repeat="item in newtree" ng-init="target=true" ui-tree-node ng-class="item.empty ? \'empty\' : \'\'" ng-include="\'/app/main/calc/directives/calc-version-treeitem.html\'"></li></ul></div></div></div></div>');
$templateCache.put('app/main/calc/modals/addCostModal/addCostModal.view.html','<div id=addCostModal><div class=title-black><div class=m-auto>{{isEdit ? \'Update Cost\' : \'Add Cost\'}}</div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div ng-if=!isGlobalCost><div class=overflow-scroll><div class=calc-tree ui-tree><ul style="list-style: none;"><li><div class="calc-tree-node title"><span translate="Structure Tree"></span> <img src=/assets/icons/chevron-down-black.svg ng-if=!vm.rootCollapsed alt="" ng-click=expandRoot()> <img src=/assets/icons/chevron-up-black.svg ng-if=vm.rootCollapsed alt="" ng-click=expandRoot()></div><div class=join-point></div><ol ng-if=!isGlobalCost ui-tree-nodes="" data-drag-enabled=false ng-model=tableInventory ng-show=vm.rootCollapsed><li ng-repeat="item in tableInventory" ng-init="child=true" ui-tree-node ng-include="\'app/main/calc/modals/addCostModal/calc-tree-checkable.html\'"></li></ol></li></ul></div></div></div><div class=cc-wrapper><div class=global-option><span class="switch switch-sm"><input type=checkbox class=switch id=globalCostSwitch ng-model=isGlobalCost> <label for=globalCostSwitch translate="Global Addtional Cost"></label></span></div><div class=inputs><div class=name><div class="ft_12_600_gray mb-8" translate=Name></div><input type=text autocomplete=off class=login_input_new ng-model=vm.addCostConfig.name placeholder=Name></div><div class=cost><div class="ft_12_600_gray mb-8" translate="Cost in %"></div><input type=number class=login_input_new min=0 max=100 ng-model=vm.addCostConfig.value placeholder=Cost></div></div><div class=apply-option-group ng-if=!isGlobalCost><div class=apply-option><radio ng-model=vm.addCostConfig.currentApplyTo ng-value="\'both\'"></radio><div class=ft_14_600_black translate=Both></div></div><div class=apply-option><radio ng-model=vm.addCostConfig.currentApplyTo ng-value="\'inventory\'"></radio><div class=ft_14_600_black translate=Inventory></div></div><div class=apply-option><radio ng-model=vm.addCostConfig.currentApplyTo ng-value="\'worker\'"></radio><div class=ft_14_600_black translate=Worker></div></div></div><div class=btn-group><button class=btn_white ng-click=onCancel() translate=Discard></button> <button ng-if=!isEdit class=btn_new_blue ng-click=applyPercentageToSelectedGroup() translate=Save></button> <button ng-if=isEdit class="btn_new_blue btn-danger" ng-click=deletePercentageToSelectedGroup() translate=Delete></button> <button ng-if=isEdit class=btn_new_blue ng-click=editPercentageToSelectedGroup() translate=Update></button></div></div></div></div>');
$templateCache.put('app/main/calc/modals/addCostModal/calc-tree-checkable.html','<div><div class=calc-tree-node><span class=node-header><input type=checkbox ng-checked=item.isSelected ng-model=item.isSelected ng-click="tickSelected(item, item.isSelected)"> </span><span class=ml-10>{{item.name}}</span> <a ng-if="item.levels && item.levels.length > 0" class="ml-auto pl-10" data-nodrag ng-click="expandNode(this, $event, item)"><img src=/assets/icons/chevron-down-black.svg ng-if=this.collapsed alt=""> <img src=/assets/icons/chevron-up-black.svg ng-if=!this.collapsed alt=""></a></div><ol ng-model=item.items ng-class="{hidden: collapsed, displayed:!collapsed}"><li ng-repeat="item in item.items" ui-tree-node collapsed=false ng-if=item.inventoryName><div class=calc-tree-node><span class=node-header><input type=checkbox ng-checked=item.isSelected ng-model=item.isSelected ng-click="tickSelected(item, item.isSelected)"> </span><span class=ml-10>{{item.inventoryName}}</span> <a ng-if="item.items && item.items.length > 0" class="ml-auto pl-10" data-nodrag ng-click="expandNode(this, $event, item)"><img src=/assets/icons/chevron-down-black.svg ng-if=this.collapsed alt=""> <img src=/assets/icons/chevron-up-black.svg ng-if=!this.collapsed alt=""></a><div class=arrow><span class="line left"></span><span class="line right"></span></div></div><ol ng-model=item.items ng-class="{hidden: collapsed, displayed:!collapsed}" ng-if="item.items && item.items.length > 0"><li ng-repeat="item in item.items" ui-tree-node collapsed=false ng-if=item.inventoryName><div class=calc-tree-node><span class=node-header><input type=checkbox ng-checked=item.isSelected ng-model=item.isSelected ng-click="tickSelected(item, item.isSelected)"> </span><span class=ml-10>{{item.inventoryName}}</span><div class=arrow><span class="line left"></span><span class="line right"></span></div></div></li></ol></li><li ng-repeat="item in item.levels" ui-tree-node ng-init="child=true" collapsed=false ng-include="\'app/main/calc/modals/addCostModal/calc-tree-checkable.html\'"></li></ol><div class=arrow ng-if=child><span class="line left"></span><span class="line right"></span></div></div>');
$templateCache.put('app/main/calc/modals/budgetSummaryModal/budgetSummaryModal.view.html','<div id=budgetSummaryModal><div class=header>{{vm.summary.title}}<div class=cursor-point ng-click=vm.cancel()><img src=/assets/icons/close-24-dark.svg alt=icons></div></div><div class=content><div class=section-title><div class=equations><span translate=Equation></span>&nbsp;({{vm.equation.name}})</div><div class=op></div><div class=fields translate="Select Fields"></div></div><div class=section-content><textarea class=equations ng-model=vm.equation.expression ng-blur=vm.changeExpression()></textarea><div class="op cursor-point" ng-click=vm.selectFields()><img src=/assets/icons/chevrons-left.svg alt=""></div><div class=fields><div class=field ng-repeat="field in vm.fields" ng-class="{selected: field.selected}" ng-click="field.selected = !field.selected"><span ng-if=!field.childIndex>{{field.index}}</span> <span ng-if=field.childIndex>{{field.index}}.{{field.childIndex}}</span> <span class=ml-10>{{field.title}}</span></div></div></div></div><div class=footer><div class=btn-done ng-click=vm.done() translate=Done></div><div class="btn-cancel ml-8" ng-click=vm.cancel() translate=Cancel></div></div></div>');
$templateCache.put('app/main/calc/modals/calcExtraTemplateModal/calcExtraTemplateModal.view.html','<div id=calc-extra-template-modal><div class=header>Template<div class=cursor-point ng-click=vm.cancel()><img src=/assets/icons/close-24-dark.svg alt=icons></div></div><div class=content><div class=sub-title translate="Template Name"></div><div><input class=template-name type=text ng-model=vm.templateName></div></div><div class=footer><div class="btn-done ml-auto" ng-click=vm.done() translate=Done></div><div class="btn-cancel ml-16" ng-click=vm.cancel() translate=Cancel></div></div></div>');
$templateCache.put('app/main/calc/modals/configModal/configModal.view.html','<div id=configModal><div class=title-black><div class=m-auto translate=Configurations></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class="flex-between mb-30"><div><div class="config-label mb-8" translate="Average Working Cost"></div><input class=input-primary ng-model=vm.config.workerCost number-edit=2 type=text></div><div><div class="config-label mb-8" translate="Profit %"></div><input class=input-primary ng-model=vm.config.profit type=number></div></div><div class="btnGroup mt-20"><button class="button-ex1 ml-auto mr-16" ng-click=onCancel() translate=Discard></button> <button class=button-primary ng-click=onSubmit() translate=Save></button></div></div></div>');
$templateCache.put('app/main/calc/modals/configModal2/configModal2.view.html','<div id=configModal2><div class=title-black><div class=m-auto translate=Configurations></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class="flex-between mb-30"><div><div class="config-label mb-8" translate="Operating Cost %"></div><input class=input-primary ng-model=vm.config.opCost type=number></div><div><div class="config-label mb-8" translate="Profit %"></div><input class=input-primary ng-model=vm.config.profit type=number></div></div><div class="btnGroup mt-20"><button class="button-ex1 ml-auto mr-16" ng-click=onCancel() translate=Discard></button> <button class=button-primary ng-click=onSubmit() translate=Save></button></div></div></div>');
$templateCache.put('app/main/calc/modals/editMailFolder/editMailFolder.view.html','<div id=custom-folder-modal><div class=title-black><div class=m-auto ng-if="vm.mode==\'update\'" translate="Edit Custom Folder"></div><div class=m-auto ng-if="vm.mode==\'create\'" translate="Create Custom Folder"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class="flex-center folder-name"><div class="config-label mr-10" translate="Folder Name"></div><input class="login_input flex-50" ng-model=vm.folderName></div><div class="flex-wrap flex mt-16 project-ids"><div class="config-label mr-10" translate=Tags></div><div class="flex flex-50"><input class=login_input ng-model=tag></div><button class="btn_new_blue ml-auto" ng-click=addTag()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div><div class=work-types><div class=work-type ng-repeat="t in tags track by $index"><div class=mr-16>{{t}}</div><img src=/assets/icons/close-16-black.svg alt="" ng-click=removeTag($index)></div></div><div class="flex-wrap flex mt-16 project-ids"><div class="config-label mr-10" translate="Invited Managers"></div><div class="flex flex-50"><selectbox-input class="w-100 input-select" ng-model=manager options=vm.managers label-field=displayName value-field=_id></selectbox-input></div><button class="btn_new_blue ml-auto" ng-click=addManager()><img src=/assets/icons/plus.svg alt=icons><span translate=Add></span></button></div><div class=work-types><div class=work-type ng-repeat="man in invitedManagers track by $index"><img ng-if=man.userId.profilePic class="avatar ml-6" ng-src={{man.userId.profilePic}} alt=""><div ng-if=!man.userId.profilePic class=ml-6 data-letters={{_nameLetter(man.displayName)}}></div><div class="info ml-10"><div class=title title={{man.userId.displayName}}>{{man.userId.displayName}}</div><div class=desc title={{man.userId.name}}>{{man.userId.name}}</div></div><img src=/assets/icons/close-16-black.svg alt="" ng-click=removeManager($index)></div></div><div class="btnGroup mt-20"><button class=btn_primary ng-click=onCancel() translate=Discard></button> <button class="btn_primary green-bk" ng-click=onSubmit() translate=Save></button></div></div></div>');
$templateCache.put('app/main/calc/modals/modelViewModal/modelViewModal.view.html','<div id=model-view-modal><div id=viewer class=no-zoom ng-class="{\'render-3d\': vm.model.type == \'3d\'}"></div><div class=loading ng-if=vm.isLoading><img src=/assets/images/cgviewer/cloud_loading.gif></div></div>');
$templateCache.put('app/main/calc/modals/newGroupModal/newGroupModal.view.html','<div id=new-group-modal><div class=title-black><div class=m-auto translate="Add New Group"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class=group-label translate="Group Name"></div><div class=group-edit><input class=login_input_new ng-model=vm.name type=text></div></div><div class=footer><button class="ml-auto button-ex1" ng-click=onCancel() translate=Cancel></button> <button class="ml-10 button-primary" ng-click=onSubmit() translate=Add></button></div></div>');
$templateCache.put('app/main/calc/modals/newMainEstimateTabModal/newMainEstimateTabModal.view.html','<div id=new-main-estimate-tab-modal><div class=title-black><div class=m-auto translate="Add New Group"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class=group-label translate="Tab Name"></div><div class=group-edit><input class=login_input_new ng-model=vm.name type=text></div></div><div class=footer><button class="ml-auto button-ex1" ng-click=onCancel() translate=Cancel></button> <button class="ml-10 button-primary" ng-click=onSubmit() translate=Add></button></div></div>');
$templateCache.put('app/main/calc/modals/organizeModal/organizeModal.view.html','<div id=organizeModal><div class=title-black><div class=m-auto translate=Organize></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class="calc-tree no-zoom" ui-tree=vm.treeOptions><ul ui-tree-nodes="" ng-model=vm.calcLevels><li ng-repeat="level in vm.calcLevels" ui-tree-node ng-include="\'app/main/calc/modals/calc-tree.html\'"></li></ul></div><div class=btn-group><button class=btn_new_blue ng-click=onSubmit() translate=Save></button></div></div></div>');
$templateCache.put('app/main/calc/modals/structureModal/structureModal.view.html','<div id=structureModal><div class=title-black><div class=m-auto translate="Structure Tree"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class=tree-container><div class="calc-tree no-zoom d-flex" style="justify-content: center;" ui-tree=treeOptions><ul ui-tree-nodes="" ng-model=tableInventory><li ng-repeat="level in tableInventory" ui-tree-node data-nodrag ng-include="\'app/main/calc/modals/calc-tree.html\'"></li></ul></div></div><div class="btnGroup mt-20"><button class=btn_new_blue ng-click=onCancel() translate=Close></button></div></div></div>');
$templateCache.put('app/main/calc/modals/syncMainEstimateModal/syncMainEstimateModal.view.html','<div id=sync-main-estimate-modal><spinner ng-if=isLoading></spinner><div class=title-black><div translate="Filter (Sync)"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class="row m-0"><div class="col-8 left p-0"><div class=group-label translate=Groups></div><div class=search-container><input type=text placeholder="Search for Groups" class=w-100> <span class=search-icon><img src=/assets/icons/search_dark.svg alt=""></span></div><div class=group-edit id=me-table-body><div class=sync-table><div class=thead><div class=tr><div class="td field-name" translate="Group Name"></div><div class="td field-import" translate=Import></div><div class="td field-export" translate=Export></div><div class="td field-sync" translate=Sync></div><div class="td status" ng-class="{\n                  \'none\': !dataLinkStatus || dataLinkStatus === \'none\',\n                  \'linked\': dataLinkStatus === \'linked\',\n                  \'pending\': dataLinkStatus === \'pending\',\n                  \'approved\': dataLinkStatus === \'approved\'\n                }"></div></div></div><div class=tbody><div ng-repeat="data in vm.calcData track by $index"><div class=tr><div class="td field-name"><img src=/assets/icons/arrow_drop_down_collapse_gray.svg alt="" ng-if=!data.opened ng-click="onExpand(data, true)" class=mr-2> <img src=/assets/icons/arrow_drop_down_collapse_open.svg alt="" ng-if=data.opened ng-click="onExpand(data, false)" class=mr-2><div ng-click=setCurrentData(data) ng-class="{\'active\': data.isActive}">{{ getTitle(data, $index) | capitalize}}</div></div><div class="td field-import"><multiselect ng-model=data.selectedImportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 change="onChangeImportFields(data, \'data\')" data-multiple=true></multiselect></div><div class="td field-export"><multiselect ng-model=data.selectedExportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 change="onChangeExportFields(data, \'data\')" data-multiple=true></multiselect></div><div class="td field-sync"><img src=/assets/icons/main-estimate/sync.svg alt=""></div><div class="td status" ng-class="{\n                      \'pulse-container\': data.isSelected,\n                      \'selected\': data.isSelected,\n                      \'none\': !data.linkStatus || data.linkStatus === \'none\',\n                      \'linked\': data.linkStatus === \'linked\',\n                      \'pending\': data.linkStatus === \'pending\',\n                      \'approved\': data.linkStatus === \'approved\'\n                    }" id="{{\'data_\'+data.id}}"><div class=inner-rect ng-if="data.linkStatus == \'approved\'"></div></div></div><div ng-repeat="group in data.groups" ng-show=data.opened><div class=tr><div class="td field-name group"><img src=/assets/icons/arrow_drop_down_collapse_gray.svg alt="" ng-if=!group.opened ng-click="onExpand(group, true)" class=mr-2> <img src=/assets/icons/arrow_drop_down_collapse_open.svg alt="" ng-if=group.opened ng-click="onExpand(group, false)" class=mr-2> {{group.title | capitalize}}</div><div class="td field-import"><multiselect ng-model=group.selectedImportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 change="onChangeImportFields(data, \'group\', group)" data-multiple=true></multiselect></div><div class="td field-export"><multiselect ng-model=group.selectedExportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 change="onChangeExportFields(data, \'group\', group)" data-multiple=true></multiselect></div><div class="td field-sync"><img src=/assets/icons/main-estimate/sync.svg alt=""></div><div class="td status" ng-class="{\n                      \'pulse-container\': group.isSelected,\n                        \'selected\': group.isSelected,\n                        \'none\': !group.linkStatus || group.linkStatus === \'none\',\n                        \'linked\': group.linkStatus === \'linked\',\n                        \'pending\': group.linkStatus === \'pending\',\n                        \'approved\': group.linkStatus === \'approved\'\n                      }" id="{{\'data_\'+data.id+\'_group_\'+group.id}}" ng-click="onSelectMeItem(\'group\', null, group, data)"><div class=inner-rect ng-if="group.linkStatus == \'approved\'"></div></div></div><div ng-repeat="item in data.items" ng-show=group.opened ng-if="item.group == group.id"><div ng-if="item.rowStyle == \'Combined\'"><div class=tr><div class="td field-name item">{{item.item.name | capitalize}}</div><div class="td field-import"><multiselect ng-model=item.item.selectedImportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 data-multiple=true></multiselect></div><div class="td field-export"><multiselect ng-model=item.item.selectedExportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 data-multiple=true></multiselect></div><div class="td field-sync"><img src=/assets/icons/main-estimate/sync.svg alt=""></div><!-- <div class="td status init" id="{{\'item_\'+item.idx}}" ng-click="onSelectMeItem(item, \'item\')"></div> --><div class="td status" ng-class="{\n                            \'pulse-container\': item.isSelected,\n                            \'selected\': item.isSelected,\n                            \'none\': !item.linkStatus || item.linkStatus === \'none\',\n                            \'linked\': item.linkStatus === \'linked\',\n                            \'pending\': item.linkStatus === \'pending\',\n                            \'approved\': item.linkStatus === \'approved\'\n                          }" id="{{\'data_\'+data.id+\'_group_\'+group.id+\'_item_\'+item.idx}}" ng-click="onSelectMeItem(\'item\', item, group, data)" ng-dblclick="onRemoveMeItem(item, \'item\')"><div class=inner-rect ng-if="item.linkStatus == \'approved\'"></div></div></div><div class=tr><div class="td field-name item">{{item.worker.name | capitalize}}</div><div class="td field-import"><multiselect ng-model=item.worker.selectedImportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 data-multiple=true></multiselect></div><div class="td field-export"><multiselect ng-model=item.worker.selectedExportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 data-multiple=true></multiselect></div><div class="td field-sync"><img src=/assets/icons/main-estimate/sync.svg alt=""></div><!-- <div class="td status init" id="{{\'item_worker_\'+item.idx}}" ng-click="onSelectMeItem(item, \'item_worker\')"></div> --><div class="td status" ng-class="{\n                            \'pulse-container\': item.worker.isSelected,\n                            \'selected\': item.worker.isSelected,\n                            \'none\': !item.worker.linkStatus || item.worker.linkStatus === \'none\',\n                            \'linked\': item.worker.linkStatus === \'linked\',\n                            \'pending\': item.worker.linkStatus === \'pending\',\n                            \'approved\': item.worker.linkStatus === \'approved\'\n                          }" id="{{\'data_\'+data.id+\'_group_\'+group.id+\'_item_worker_\'+item.idx}}" ng-click="onSelectMeItem(\'item_worker\', item, group, data)" ng-dblclick="onRemoveMeItem(item, \'item_worker\')"><div class=inner-rect ng-if="item.worker.linkStatus == \'approved\'"></div></div></div></div><div ng-if="item.rowStyle == \'Inventory\'"><div class=tr><div class="td field-name item">{{item.item.name | capitalize}}</div><div class="td field-import"><multiselect ng-model=item.selectedImportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 data-multiple=true></multiselect></div><div class="td field-export"><multiselect ng-model=item.selectedExportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 data-multiple=true></multiselect></div><div class="td field-sync"><img src=/assets/icons/main-estimate/sync.svg alt=""></div><!-- <div class="td status init" id="{{\'item_\'+item.idx}}" ng-click="onSelectMeItem(item, \'item\')"></div> --><div class="td status" ng-class="{\n                            \'pulse-container\': item.isSelected,\n                            \'selected\': item.isSelected,\n                            \'none\': !item.linkStatus || item.linkStatus === \'none\',\n                            \'linked\': item.linkStatus === \'linked\',\n                            \'pending\': item.linkStatus === \'pending\',\n                            \'approved\': item.linkStatus === \'approved\'\n                          }" id="{{\'data_\'+data.id+\'_group_\'+group.id+\'_item_\'+item.idx}}" ng-click="onSelectMeItem(\'item\', item, group, data)" ng-dblclick="onRemoveMeItem(item, \'item\')"><div class=inner-rect ng-if="item.linkStatus == \'approved\'"></div></div></div></div><div ng-if="item.rowStyle == \'Worker\'"><div class=tr><div class="td field-name item">{{item.worker.name | capitalize}}</div><div class="td field-import"><multiselect ng-model=item.selectedImportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 data-multiple=true></multiselect></div><div class="td field-export"><multiselect ng-model=item.selectedExportFields options="c for c in fields" scroll-after-rows=5 data-multiple=true></multiselect></div><div class="td field-sync"><img src=/assets/icons/main-estimate/sync.svg alt=""></div><!-- <div class="td status init" id="{{\'item_\'+item.idx}}" ng-click="onSelectMeItem(item, \'item\')"></div> --><div class="td status" ng-class="{\n                            \'pulse-container\': item.isSelected,\n                            \'selected\': item.isSelected,\n                            \'none\': !item.linkStatus || item.linkStatus === \'none\',\n                            \'linked\': item.linkStatus === \'linked\',\n                            \'pending\': item.linkStatus === \'pending\',\n                            \'approved\': item.linkStatus === \'approved\'\n                          }" id="{{\'data_\'+data.id+\'_group_\'+group.id+\'_item_\'+item.idx}}" ng-click="onSelectMeItem(\'item\', item, group, data)" ng-dblclick="onRemoveMeItem(item, \'item\')"><div class=inner-rect ng-if="item.linkStatus == \'approved\'"></div></div></div></div><div ng-if="item.rowStyle == \'Collaborator\'"><div class=tr><div class="td field-name item">{{item.item.name | capitalize}} (Collaborator)</div><div class="td field-import"><multiselect ng-model=item.selectedImportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 data-multiple=true></multiselect></div><div class="td field-export"><multiselect ng-model=item.selectedExportFields options="c for c in fields" scroll-after-rows=5 filter-after-rows=1 data-multiple=true></multiselect></div><div class="td field-sync"><img src=/assets/icons/main-estimate/sync.svg alt=""></div><!-- <div class="td status init" id="{{\'item_\'+item.idx}}" ng-click="onSelectMeItem(item, \'item\')"></div> --><div class="td status" ng-class="{\n                            \'pulse-container\': item.isSelected,\n                            \'selected\': item.isSelected,\n                            \'none\': !item.linkStatus || item.linkStatus === \'none\',\n                            \'linked\': item.linkStatus === \'linked\',\n                            \'pending\': item.linkStatus === \'pending\',\n                            \'approved\': item.linkStatus === \'approved\'\n                          }" id="{{\'data_\'+data.id+\'_group_\'+group.id+\'_item_\'+item.idx}}" ng-click="onSelectMeItem(\'item\', item, group, data)" ng-dblclick="onRemoveMeItem(item, \'item\')"><div class=inner-rect ng-if="item.linkStatus == \'approved\'"></div></div></div></div></div></div></div></div></div></div></div><div class="col-4 right p-0"><div class=group-label translate="Bid Packages"></div><div class=search-container><input type=text placeholder="Search for Packages" class=w-100> <span class=search-icon><img src=/assets/icons/search_dark.svg alt=""></span></div><div class=group-edit id=bidpackages-table-body><div class=sync-table><div class=thead><div class=tr><div class="td status" ng-class="{\n                  \'none\': !BPLinkStatus || BPLinkStatus === \'none\',\n                  \'linked\': BPLinkStatus === \'linked\',\n                  \'pending\': BPLinkStatus === \'pending\',\n                  \'approved\': BPLinkStatus === \'approved\'\n                }"></div><div class="td title" translate="Bid Package"></div></div></div><div class=tbody><div class="tr justify-content-between" ng-repeat="package in vm.bidPackages"><!-- <div class="td status init" id="{{package._id}}" ng-click="onSelectBidPackage(package)"></div> --><div class=d-flex><div class="td status" ng-class="{\n                              \'selected\': package.isSelected,\n                              \'none\': !package.linkStatus || package.linkStatus === \'none\',\n                              \'linked\': package.linkStatus === \'linked\',\n                              \'pending\': package.linkStatus === \'pending\',\n                              \'approved\': package.linkStatus === \'approved\'\n                            }" id={{package._id}} ng-click=onSelectBidPackage(package)></div><div class="td title">{{package.title}}</div></div><img class=cursor-pointer src=/assets/icons/main-estimate/Import-gray.svg alt="" ng-click=importBidPackage(package)></div></div></div></div></div></div></div><div class=footer><button class="ml-auto button-ex1 button-import" ng-click=onImport()><img src=/assets/icons/main-estimate/Import.svg alt=""> Import</button> <button class="ml-10 button-primary button-export" ng-click=onExport()><img src=/assets/icons/main-estimate/Export.svg alt=""> Export</button></div></div>');
$templateCache.put('app/main/calc/modals/versionModal/versionModal.view.html','<div id=versionModal><div class=title-black><div class=m-auto translate="Version Message"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class=detail><div class=title><div class=flex-3></div><div class=flex-3><span translate="Version Seq"></span>&nbsp;{{lastVersion.versionSeq}}</div><div class=flex-3 translate="Current Version"></div></div><div class=items><div class=item><div class=flex-3-name translate="Operating Cost"></div><div class=flex-3 ng-if="lastVersion.totalCompanyCost == undefined">N/A</div><div class=flex-3 ng-if="lastVersion.totalCompanyCost != undefined">{{ companyCurrency.symbol }}&nbsp;{{lastVersion.totalCompanyCost | readable:2}}</div><div class=flex-3>{{ companyCurrency.symbol }}&nbsp;{{totalCompanyCost | readable:2}}</div></div><div class=item><div class=flex-3-name translate="Sales Price"></div><div class=flex-3 ng-if="lastVersion.sum == undefined">N/A</div><div class=flex-3 ng-if="lastVersion.sum != undefined">{{ companyCurrency.symbol }}&nbsp;{{lastVersion.sum | readable:2}}</div><div class=flex-3>{{ companyCurrency.symbol }}&nbsp;{{totalSum | readable:2}}</div></div><div class=item><div class=flex-3-name translate="Cost Price"></div><div class=flex-3 ng-if="lastVersion.totalCostPrice == undefined">N/A</div><div class=flex-3 ng-if="lastVersion.totalCostPrice != undefined">{{ companyCurrency.symbol }}&nbsp;{{lastVersion.totalCostPrice | readable:2}}</div><div class=flex-3>{{ companyCurrency.symbol }}&nbsp;{{totalCostPrice | readable:2}}</div></div><div class=item><div class=flex-3-name translate="Labour Hours"></div><div class=flex-3 ng-if="lastVersion.totalWorkHours == undefined">N/A</div><div class=flex-3 ng-if="lastVersion.totalWorkHours != undefined">{{ lastVersion.totalWorkHours | readable:2 }}&nbsp;hours</div><div class=flex-3>{{ totalWorkingHours | readable:2 }}&nbsp;hours</div></div><div class=item><div class=flex-3-name translate="Profit Cost"></div><div class=flex-3 ng-if="lastVersion.totalProfit == undefined">N/A</div><div class=flex-3 ng-if="lastVersion.totalProfit != undefined">{{ companyCurrency.symbol }}&nbsp;{{lastVersion.totalProfit | readable:2}}</div><div class=flex-3>{{ companyCurrency.symbol }}&nbsp;{{totalProfit | readable:2}}</div></div></div></div><div class="description mt-25"><div class="ft_12_500_gray mb-8" translate="Version Description"></div><input class=login_input ng-model=versionMessage></div><div class="btnGroup mt-20"><button class=btn_white ng-click=onCancel() translate=Discard></button> <button class=btn_new_blue ng-click=saveSheet() ng-disabled="versionMessage==0||versionMessage==undefined" translate=Save></button></div></div></div>');
$templateCache.put('app/main/calc/modals/viewDetailModal/viewDetailModal.view.html','<div id=viewDetailModal><div class=title-black><div class=m-auto translate="Version Message"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class=header><div class="ft_18_600_black mb-8"><span translate="Version Sequence"></span>&nbsp;{{ vm.selectedVersion.versionSeq}}</div><div class="flex ft_14_regular_gray mb-8"><div style="flex: 0 0 50%;"><span translate="Created By:"></span>&nbsp;{{ vm.selectedVersion.savedBy}}</div><div><span translate="Created Date:"></span>&nbsp;{{ vm.selectedVersion.saveDate | date: "dd/MM/yyyy" : \'UTC\' }}</div></div><div class="ft_14_regular_gray mb-8"><span translate=Description:></span>&nbsp;{{ vm.selectedVersion.versionMessage ? vm.selectedVersion.versionMessage : \'N/A\' }}</div></div><div class=detail><div class=title><div class=flex-27></div><div class=flex-27><span translate="Version Seq"></span>&nbsp;{{ vm.selectedVersion.versionSeq}}</div><div class=flex-27 translate="Current Version"></div><div class=flex-19 translate="Add %"></div></div><div class=items><div class=item><div class="flex-27 name" translate="Operating Cost"></div><div class=flex-27>{{ vm.selectedVersion.companyCurrency.symbol }}&nbsp;{{ vm.selectedVersion.totalCompanyCost | readable:2 }}&nbsp;</div><div class=flex-27>{{ vm.currentVersion.companyCurrency.symbol }}&nbsp;{{ vm.currentVersion.totalCompanyCost | readable:2 }}</div><div class=flex-19>{{ ((vm.currentVersion.totalCompanyCost - vm.selectedVersion.totalCompanyCost) * 100 / vm.selectedVersion.totalCompanyCost) | readable:2 }}&nbsp;%</div></div><div class=item><div class="flex-27 name" translate="Sales Price"></div><div class=flex-27>{{ vm.selectedVersion.companyCurrency.symbol }}&nbsp;{{ vm.selectedVersion.sum | readable:2 }}&nbsp;</div><div class=flex-27>{{ vm.currentVersion.companyCurrency.symbol }}&nbsp;{{ vm.currentVersion.sum | readable:2 }}</div><div class=flex-19>{{ ((vm.currentVersion.sum - vm.selectedVersion.sum) * 100 / vm.selectedVersion.sum) | readable:2 }}&nbsp;%</div></div><div class=item><div class="flex-27 name" translate="Cost Price"></div><div class=flex-27>{{ vm.selectedVersion.companyCurrency.symbol }}&nbsp;{{ vm.selectedVersion.totalCostPrice | readable:2 }}</div><div class=flex-27>{{ vm.currentVersion.companyCurrency.symbol }}&nbsp;{{ vm.currentVersion.totalCostPrice | readable:2 }}</div><div class=flex-19>{{ ((vm.currentVersion.totalCostPrice - vm.selectedVersion.totalCostPrice) * 100 / vm.selectedVersion.totalCostPrice) | readable:2 }}&nbsp;%</div></div><div class=item><div class="flex-27 name" translate="Labour Hours"></div><div class=flex-27>{{ vm.selectedVersion.companyCurrency.symbol }}&nbsp;{{ vm.selectedVersion.totalWorkHours | readable:2 }}&nbsp;</div><div class=flex-27>{{ vm.currentVersion.companyCurrency.symbol }}&nbsp;{{ vm.currentVersion.totalWorkHours | readable:2 }}</div><div class=flex-19>{{ ((vm.currentVersion.totalWorkHours - vm.selectedVersion.totalWorkHours) * 100 / vm.selectedVersion.totalWorkHours) | readable:2 }}&nbsp;%</div></div><div class=item><div class="flex-27 name" translate="Profit Cost"></div><div class=flex-27>{{ vm.selectedVersion.companyCurrency.symbol }}&nbsp;{{ vm.selectedVersion.totalProfit | readable:2 }}&nbsp;</div><div class=flex-27>{{ vm.currentVersion.companyCurrency.symbol }}&nbsp;{{ vm.currentVersion.totalProfit | readable:2 }}</div><div class=flex-19>{{ ((vm.currentVersion.totalProfit - vm.selectedVersion.totalProfit) * 100 / vm.selectedVersion.totalProfit) | readable:2 }}&nbsp;%</div></div></div></div><div class="btnGroup mt-20"><button class=btn_white ng-click=onCancel() translate=Close></button> <button class=btn_new_blue ng-click=vm.showVersionDetail() translate="View Detail"></button></div></div></div>');
$templateCache.put('app/main/calendar/directives/scheduler/scheduler.view.html','<div id=scheduler class=scheduler-root-container ng-class=vm.viewType><div class=scheduler-header><div class=scheduler-grid-header><searchbox is-icon=true icon-file=/assets/icons/search1.svg input-class=search search-event=searchCallback() search-text=vm.searchText place-holder="Search for People"></searchbox><!-- <span ng-if="vm.viewType==\'day\'">{{vm.date | fullDate}}</span>\n      <span ng-if="vm.viewType!=\'day\'">{{vm.range.first | smartDate}}-{{vm.range.last | smartDate}}</span> --></div><div class=scheduler-task-header><div class=scheduler-scale ng-repeat="item in vm.scales" ng-if="vm.viewType == \'day\'"><div class=text-align-center><div>{{item.name}}</div><div ng-show="item.item!==angular.isUndefined">{{item.item}}</div></div></div><div class=scheduler-scale ng-repeat="item in vm.scales" ng-if="vm.viewType == \'week\'"><div class=text-align-center><div>{{item.date | weekDay | uppercase}}</div><div>{{item.date | weekDate}}</div></div></div><div class=scheduler-scale ng-repeat="item in vm.scales" ng-if="vm.viewType == \'month\'"><div class=text-align-center><div>{{item.date | weekDay}}</div><div>{{item.month}}</div><div>{{item.date | weekDate}}</div></div></div><!-- <div class="scheduler-scale month" ng-repeat="item in vm.sections" ng-if="vm.viewType == \'month\'">\n        <div class="top-scale">{{item.name}}</div>\n        <div class="bottom-scale">\n          <div class="scale-item" ng-repeat="sub in item.scales">\n            <div class="scale-item-week">Week {{sub.week}}</div>\n            <div class="scale-item-day">{{sub.first | smartDay}} - {{sub.last | smartDay}}</div>\n          </div>\n        </div>\n      </div> --></div><div class=scheduler-scroller-header></div></div><div class=scheduler-body><div class=scheduler-grid-area><div id=scheduler-grid-content class=scheduler-grid-content><div class=scheduler-grid-cell ng-repeat="item in vm.data"><div ng-if=item.profilePic><img class=avatar ng-src={{item.profilePic}} alt="" onerror="this.src=\'/assets/icons/user1.svg\'"></div><div ng-if=!item.profilePic><span class=avatar-text ng-style="{ \'background\': (vm.getColor(item.displayName)) }">{{item.displayName | mailAvatarChar}}</span></div><div class=ml-8><div class=name>{{item.displayName}}</div><div class=role>{{item.role}}</div></div></div></div></div><div class=scheduler-divider></div><div class=scheduler-task-area><div id=scheduler-task-content class=scheduler-task-content><div class=scheduler-task-row ng-repeat="item in vm.data" ng-if="vm.viewType==\'day\'"><div class="scheduler-task-cell day" ng-repeat="x in vm.scales"></div><div class="scheduler-task-line day" ng-repeat="schedule in item.schedules" ng-style=vm.getTaskLineStyle(schedule) ng-click=vm.selectSchedule(schedule)><div class=task-line-content ng-style="{\'width\': vm.getTaskLineWidth_d(schedule) + \'px\'}"><div class="task-line-time tx-ellipsis">{{schedule.startTime | smartTime}} - {{schedule.endTime | smartTime}}</div><div class="task-line-desc tx-ellipsis">{{schedule.title}} - {{schedule.description}}</div></div></div></div><div class=scheduler-task-row ng-repeat="item in vm.data" ng-if="vm.viewType==\'week\'"><div class="scheduler-task-cell week" ng-repeat="x in vm.scales" ng-style="{\'width\': vm.getTaskLineWidth_w() + \'px\'}"><div class="scheduler-task-line week" ng-if=item.schedules[x.key] ng-click=vm.selectSchedule(item.schedules[x.key]) ng-style=vm.getTaskLineStyle(item.schedules[x.key])><div class=task-line-content ng-style="{\'width\': vm.getTaskLineWidth_w() - 20 + \'px\'}"><div class="task-line-time tx-ellipsis">{{item.schedules[x.key].startTime | smartTime}} - {{item.schedules[x.key].endTime | smartTime}}</div><div class="task-line-desc tx-ellipsis">{{item.schedules[x.key].title}}</div><div class="task-line-time tx-ellipsis">{{item.schedules[x.key].description}}</div></div></div></div></div><div class=scheduler-task-row ng-repeat="item in vm.data" ng-if="vm.viewType==\'month\'"><div class="scheduler-task-cell month" ng-repeat="x in vm.scales"></div><div class="scheduler-task-line month" ng-repeat="schedule in item.schedules" ng-style=vm.getTaskLineStyle(schedule) ng-click=vm.selectSchedule(schedule)><div class=task-line-content ng-style="{\'width\': vm.getTaskLineWidth_d(schedule) + \'px\'}"><div class="task-line-time tx-ellipsis">{{schedule.startTime | smartTime}} - {{schedule.endTime | smartTime}}</div><div class="task-line-desc tx-ellipsis">{{schedule.title}} - {{schedule.description}}</div></div></div></div></div><!-- <div class="scheduler-scroller">\n      <div id="scheduler-scroller-content" class="scheduler-scroller-content">\n        <div class="hidden-row" ng-repeat="item in vm.data"></div>\n      </div>\n    </div> --></div></div></div>');
$templateCache.put('app/main/calendar/modals/detailEventModal/detailEventModal.view.html','<div id=detailEventModal><spinner ng-show=loading></spinner><div class=title ng-style="{\'background\': event.bgColor}"><div class="tx-ellipsis ft_18_600_white">{{event.title}}</div><div class=d-flex><img class="mr-10 cursor-point" src=/assets/icons/bxs-edit-white.svg ng-click=editEvent(event._id) ng-if="permission > 1"> <img class="cursor-point delete-btn" src=/assets/icons/trash-alt-white.svg ng-click=deleteEvent(event._id) ng-if="permission > 3"> <img src=/assets/icons/close-24-white.svg alt=icons class="close-icon cursor-point" ng-click=onCancel()></div></div><div class=content><div class="d-flex mb-20"><div class=width50><div class="text-uppercase ft_12_regular_light fw-600 text-left mb-8" translate="Start Date"></div><div class=ft_14_regular_black>{{event.start}}</div></div><div class=width50><div class="text-uppercase ft_12_regular_light fw-600 text-left mb-8" translate="End Date"></div><div class=ft_14_regular_black>{{event.end}}</div></div></div><div class="text-uppercase ft_12_regular_light fw-600 text-left mb-8" translate=Description></div><div class="ft_14_regular_black description" title={{event.description}}>{{event.description}}</div></div></div>');
$templateCache.put('app/main/calendar/modals/saveEventModal/saveEventModal.view.html','<div id=saveEventModal><spinner ng-show=loading></spinner><div class=title><div class=tx-ellipsis ng-if=!id translate="Create Event"></div><div class=tx-ellipsis ng-if=id translate="Update Event"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><hr><div class=content><div class=mb-16><div class="ft_14_600_black2 mb-2 required" translate=Title></div><input class="input-primary w-100" type=text placeholder="Add title" ng-model=vm.event.name autofocus></div><div class=mb-16><div class="ft_14_600_black2 mb-8" translate=Description></div><textarea class=w-100 placeholder="Write some description (optional)" ng-model=vm.event.description></textarea></div><div class="mb-16 d-flex"><div class="flex-between mr-25"><checkbox class=mr-8 ng-model=vm.isRepeat ng-click=onChangeRepeatType()></checkbox><div class=ft_14_regular_black2 translate=Repeat></div></div><div class=flex-between><checkbox class=mr-8 ng-model=vm.event.isPrivate></checkbox><div class=ft_14_regular_black2 translate=Private></div></div></div><div class=mb-16 ng-if=vm.isRepeat><div class="mb-16 flex-between"><div class=flex-48><div class=ft_14_600_black2 translate=Start></div><div class="input-group datePicker-primary"><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.event.fromDate is-open=isStartpickerOpen ng-required=true> <span class=dateArrow ng-click="isStartpickerOpen = !isStartpickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=flex-48><div class=ft_14_600_black2 translate=End></div><div class="input-group datePicker-primary"><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.event.toDate is-open=isEndpickerOpen ng-required=true> <span class=dateArrow ng-click="isEndpickerOpen = !isEndpickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div><div class="flex-between mb-16"><div class=flex-28><selectbox-input class=dropdown-primary options=repeatTypes label-field=name value-field=_id ng-model=vm.event.repeatType.type></selectbox-input></div><div class="flex-68 flex-between"><radio ng-model=vm.event.repeatType.every.everyWeekday ng-value=false ng-show="vm.event.repeatType.type==1"></radio><div class="ft_14_600_black2 flex-20 ml-auto" translate=Every></div><selectbox-input class="dropdown-primary flex-30" options=repeatDays label-field=value value-field=_id ng-model=vm.event.repeatType.every.value></selectbox-input><div class="ft_14_600_black2 flex-40 ml-auto" ng-if="vm.event.repeatType.type==1" translate=day(s)></div><div class="ft_14_600_black2 flex-40 ml-auto" ng-if="vm.event.repeatType.type==2" translate="week(s) on"></div><div class="ft_14_600_black2 flex-40 ml-auto" ng-if="vm.event.repeatType.type==3" translate=month(s)></div><div class="ft_14_600_black2 flex-40 ml-auto" ng-if="vm.event.repeatType.type==4" translate=year(s)></div></div></div><div class=flex-between ng-show="vm.event.repeatType.type==1"><div class=flex-28></div><div class="flex-68 flex-between"><radio ng-model=vm.event.repeatType.every.everyWeekday ng-value=true></radio><div class="ft_14_600_black2 flex-89 ml-auto" translate="Every weekday"></div></div></div><div class=flex-between ng-show="vm.event.repeatType.type==2"><div class=d-flex><checkbox class=mr-8 ng-model=weekdays[0].checked ng-click=onChangeWeekday() ng-border-color=#F3A72E></checkbox><div class=ft_14_600_black2 translate=Sun></div></div><div class=d-flex><checkbox class=mr-8 ng-model=weekdays[1].checked ng-click=onChangeWeekday() ng-border-color=#2FA84F></checkbox><div class=ft_14_600_black2 translate=Mon></div></div><div class=d-flex><checkbox class=mr-8 ng-model=weekdays[2].checked ng-click=onChangeWeekday() ng-border-color=#D71414></checkbox><div class=ft_14_600_black2 translate=Tue></div></div><div class=d-flex><checkbox class=mr-8 ng-model=weekdays[3].checked ng-click=onChangeWeekday() ng-border-color=#367BF5></checkbox><div class=ft_14_600_black2 translate=Wed></div></div><div class=d-flex><checkbox class=mr-8 ng-model=weekdays[4].checked ng-click=onChangeWeekday() ng-border-color=#069697></checkbox><div class=ft_14_600_black2 translate=Thu></div></div><div class=d-flex><checkbox class=mr-8 ng-model=weekdays[5].checked ng-click=onChangeWeekday() ng-border-color=#813AC8></checkbox><div class=ft_14_600_black2 translate=Fri></div></div><div class=d-flex><checkbox class=mr-8 ng-model=weekdays[6].checked ng-click=onChangeWeekday() ng-border-color=#33BBD8></checkbox><div class=ft_14_600_black2 translate=Sat></div></div></div><div class=flex-between ng-show="vm.event.repeatType.type==4 || vm.event.repeatType.type==3"><div class=flex-33><div class=flex-between ng-show="vm.event.repeatType.type==4"><span class=ft_14_600_black2 translate=in></span><div class=flex-90><selectbox-input class=dropdown-primary options=months label-field=value value-field=_id ng-model=vm.event.repeatType.month></selectbox-input></div></div></div><div class=flex-66><div class="flex-between mb-8"><radio ng-model=vm.everyWeekday ng-value=false></radio><div class="ft_14_600_black2 flex-20 ml-auto" translate="On day"></div><div class=flex-34><selectbox-input class=dropdown-primary options=days label-field=value value-field=value ng-model=vm.event.repeatType.date.date ng-click=onChangeMonth(month)></selectbox-input></div><div class="flex-34 ml-auto"></div></div><div class=flex-between><radio ng-model=vm.everyWeekday ng-value=true></radio><div class="ft_14_600_black2 flex-20 ml-auto" translate="On the"></div><div class=flex-34><selectbox-input class=dropdown-primary options=nths label-field=value value-field=_id ng-model=vm.event.repeatType.date.day.nth ng-click=onChangeMonth(month)></selectbox-input></div><div class="flex-34 ml-auto"><selectbox-input class=dropdown-primary options=weekdays label-field=value value-field=_id ng-model=vm.event.repeatType.date.day.weekday ng-click=onChangeMonth(month)></selectbox-input></div></div></div></div></div><div class="mb-16 flex-between"><span class="ft_14_600_black2 mr-8" translate=Type></span><div class="flex-38 flex flex-col"><selectbox-input class=dropdown-primary options=calendars label-field=name value-field=_id ng-model=vm.eventCategoryId1></selectbox-input></div><div class="ml-8 flex-46 flex flex-col"><div ng-repeat="(key, item) in calendars" ng-if="vm.eventCategoryId1===key"><selectbox-input class=dropdown-primary options=item.children label-field=name value-field=_id ng-model=vm.eventCategoryId2></selectbox-input></div></div></div><!-- <div class="mb-16 d-flex align-items-center">\n      <div class="ft_12_600_gray mr-16 required" translate="Type of Event"></div>\n      <radio ng-repeat="(key, item) in types" ng-model="vm.event.type" ng-value="item.index" ng-class="item.key + \'-type\'" ng-style="getEventTypeColor(key)"\n        title="{{item.label}}"></radio>\n    </div> --><div class="flex-between mb-16"><div class=flex-48><div class="ft_14_600_black2 mb-8 required" translate=From></div><div class=time-picker-disabled ng-if=vm.isRepeat></div><div class="input-group datePicker-primary" ng-if=!vm.isRepeat><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.event.fromDate is-open=isStartpickerOpen ng-required=true> <span class=dateArrow ng-click="isStartpickerOpen = !isStartpickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=flex-48><div class="flex-between mb-8"><checkbox class="ml-auto mr-8" ng-model=vm.event.isAllDay></checkbox><div class=ft_14_regular_black2 translate="All Day"></div></div><div class=time-picker-disabled ng-if=vm.event.isAllDay></div><div ng-if=!vm.event.isAllDay><time-picker class=time-picker ng-model=vm.event.fromTime ng-change=vm.onChangeStartTime disabled></time-picker></div></div></div><div class="flex-between mb-16"><div class=flex-48><div class="ft_14_600_black2 mb-8 requried" translate=To></div><div class=time-picker-disabled ng-if=vm.isRepeat></div><div class="input-group datePicker-primary" ng-if=!vm.isRepeat><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.event.toDate is-open=isEndpickerOpen ng-required=true> <span class=dateArrow ng-click="isEndpickerOpen = !isEndpickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=flex-48><div class="ft_14_600_black2 mb-8" translate="">&nbsp;</div><div class=time-picker-disabled ng-if=vm.event.isAllDay></div><div ng-if=!vm.event.isAllDay><time-picker class=time-picker ng-model=vm.event.toTime ng-change=vm.onChangeEndTime disabled></time-picker></div></div></div><div class="pos-relative mb-16"><div class="ft_14_600_black2 mb-2" translate="Add Location"></div><input places-auto-complete types="[\'geocode\']" class="input-primary w-100" on-place-changed=vm.locationMarker() ng-model=vm.address place-holder="Add Location"> <img src=/assets/icons/location.svg alt="" style="position: absolute;top: 33px;right: 6px;"></div><div class=reminder-wrapper><div class=flex-between><div class="ft_14_600_black2 mb-2" translate=Reminder></div><div class="ft-md ft-bold-primary ft-color-ex1 ml-1 cursor-point" ng-click=addReminder() translate="+ Add"></div></div><div class=flex-between ng-show=vm.isReminder><div class=flex-30><selectbox-input class=dropdown-primary options=reminder_time label-field=value value-field=_id ng-model=vm.event.reminder.time></selectbox-input></div><div class=flex-30><selectbox-input class=dropdown-primary options=reminder_order label-field=value value-field=_id ng-model=vm.event.reminder.order></selectbox-input></div><div class=flex-30><selectbox-input class=dropdown-primary options=reminder_gateway label-field=value value-field=_id ng-model=vm.event.reminder.gateway></selectbox-input></div><div class=flex-5><i class=cursor-point><img src=/assets/icons/close-gray.svg alt=icons ng-click=vm.closeReminder()></i></div></div></div><div class="mb-16 flex-between"><!-- <div class="flex-31 flex flex-col">\n        <selectbox-input\n          class="input-select"\n          options="vm.reminders"\n          label-field="name"\n          value-field="value"\n          ng-model="material.unit">\n        </selectbox-input>\n      </div>\n      <div class="flex-31 flex flex-col">\n        <selectbox-input\n          class="input-select"\n          options="vm.reminders"\n          label-field="name"\n          value-field="value"\n          ng-model="material.unit">\n        </selectbox-input>\n      </div>\n      <div class="flex-31 flex flex-col">\n        <selectbox-input\n          class="input-select"\n          options="vm.reminders"\n          label-field="name"\n          value-field="value"\n          ng-model="material.unit">\n        </selectbox-input>\n      </div> --></div><div class=file-wrapper><div class=flex-between><div class="ft_14_600_black2 mb-2" translate=Attachments></div><div class="ft-md ft-bold-primary ft-color-ex1 ml-1 cursor-point" ngf-select ngf-change="vm.fileUpdated($files, $event)" name=file ngf-multiple=true><span translate="+ Add"></span></div></div><div class="upload-files flex-items-center" ng-if="vm.event.files && vm.event.files.length"><div class="upload-file pos-relative mr-15" ng-repeat="file in vm.event.files track by $index"><a href={{file.secure_url}} target=_blank><img class=file-icon ng-src={{vm.utils.getFileIcon(file)}} alt="" title={{file.name}}> </a><img class="cancel-icon pos-absolute" src=/assets/icons/close-circle-f-gray.svg alt="" ng-click="vm.cancelUpload(file, $index)"></div></div></div><div class="mb-16 flex-between"></div><div><div class="ft_14_600_black2 mb-8" translate="Add Attendees"></div><!-- <div class="d-flex mb-3">\n        <div class="apply-option mr-3">\n          <radio ng-model="currentDesignation" ng-value="\'Manager\'"></radio>\n          <div class="ft_12_600_gray design-label" translate="Manager"></div>\n        </div>\n        <div class="apply-option mr-3">\n          <radio ng-model="currentDesignation" ng-value="\'Subcontractor\'"></radio>\n          <div class="ft_12_600_gray design-label" translate="Subcontractor"></div>\n        </div>\n        <div class="apply-option mr-3">\n          <radio ng-model="currentDesignation" ng-value="\'Supplier\'"></radio>\n          <div class="ft_12_600_gray design-label" translate="Supplier"></div>\n        </div>\n        <div class="apply-option mr-3">\n          <radio ng-model="currentDesignation" ng-value="\'Client\'"></radio>\n          <div class="ft_12_600_gray design-label" translate="Client"></div>\n        </div>\n        <div class="apply-option">\n          <radio ng-model="currentDesignation" ng-value="\'Employee\'"></radio>\n          <div class="ft_12_600_gray design-label" translate="Employee"></div>\n        </div>\n      </div> --><div class=mb-16><div class=flex-between><!-- <searchbox class="flex-100" is-icon="true" icon-file="/assets/icons/person2_fill_black.svg" input-class="search" search-event="searchCallback()" search-text="vm.searchText" place-holder="Enter name or email-id"></searchbox> --><autocomplete1 ng-if="currentDesignation !== \'Other\'" class="fm-search-input flex-85" ng-model=vm.select_user label-field=displayName value-field=_id options=vm.users full-width=true no-flex=true place-holder="Enter name or email-id" to-top=true></autocomplete1><input ng-if="currentDesignation === \'Other\'" type=email class=mr-4 ng-model=vm.select_user placeholder="Start typing an email" ng-pattern=EMAIL_REGEX required><div class="ft-md ft-bold-primary ft-color-ex1 ml-1 cursor-point" ng-click=addAttendee() translate="+ Add"></div></div></div><div class=pos-relative><avatar-group avatars=vm.event.listMembers to-top=true more-count-border-color="\'#ff8b00\'" more-count-color="\'#ff8b00\'"></avatar-group></div></div><div class="w-100 mt-20" ng-if=false><div class=google-map><div><div class="gmap_viewer w-100"><div map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params="{{ vm.gmap.url }}"><ng-map center="{{ vm.gmap.center }}" zoom="{{ vm.gmap.zoom }}" id=service_map><marker ng-repeat="m in vm.gmap.markers" position="{{ m }}" draggable=true on-dragend=vm.updateMarker() icon="{url: \'/assets/images/cgviewer/vp-issue-completed.svg\', scaledSize: [50, 50], origin: [0,0], anchor: [0,0]}"></marker></ng-map></div></div></div></div></div></div><hr><div class="action flex-items-center flex-content-end"><button class="button-primary mr-4 ph-10" ng-click=onSave() ng-if=!id translate=Create></button> <button class="button-primary mr-4 ph-10" ng-click=onSave() ng-if=id translate=Update></button> <button class="btn_cancel ph-10" ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/main/calendar/modals/scheduleModal/scheduleModal.view.html','<div id=scheduleModal><spinner ng-show=loading></spinner><div class=title><div class=ft_18_600_black3 ng-if=!id translate="Create Schedule"></div><div class=ft_18_600_black3 ng-if=id translate="Update Schedule"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><hr><div class=content><div class=mb-16><div class="ft_14_600_black2 mb-2 required" translate=Title></div><input type=text class="input-primary w-100" placeholder="Add title" ng-model=vm.schedule.name autofocus></div><div class=mb-16><div class="ft_14_600_black2 mb-8" translate=Description></div><textarea class=ft_14_regular_black placeholder="Write some description (optional)" ng-model=vm.schedule.description></textarea></div><div class="mb-16 d-flex"><div class="flex-between mr-25"><checkbox class=mr-8 ng-model=vm.isRepeat ng-click=onChangeRepeatType()></checkbox><div class=ft_14_regular_black2 translate=Repeat></div></div><div class=flex-between><checkbox class=mr-8 ng-model=vm.schedule.isPrivate></checkbox><div class=ft_14_regular_black2 translate=Private></div></div></div><div class="mb-16 flex-between"><span class="ft_14_600_black2 mr-8" translate=Type></span><div class="flex-38 flex flex-col"><selectbox-input class=dropdown-primary options=calendars label-field=name value-field=_id ng-model=vm.eventCategoryId1></selectbox-input></div><div class="ml-8 flex-46 flex flex-col"><div ng-repeat="(key, item) in calendars" ng-if="vm.eventCategoryId1===key"><selectbox-input class=dropdown-primary options=item.children label-field=name value-field=_id ng-model=vm.eventCategoryId2></selectbox-input></div></div></div><!-- <div class="mb-15 d-flex align-items-center">\n      <div class="ft_12_600_gray mr-16 required" translate="Type of Schedule"></div>\n      <radio ng-repeat="(key, item) in types" ng-model="vm.schedule.type" title="{{item.label}}"\n        ng-value="item.key" ng-class="item.key + \'-type\'" ng-style="getEventTypeColor(key)">\n      </radio>\n    </div> --><div class="flex-between mb-16"><div class=flex-48><div class="ft_14_600_black2 mbl-4 required" translate=From></div><div class=time-picker-disabled ng-if=vm.isRepeat></div><div class="input-group datePicker-primary" ng-if=!vm.isRepeat><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.schedule.fromDate is-open=isStartpickerOpen ng-required=true> <span class=dateArrow ng-click="isStartpickerOpen = !isStartpickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=flex-48><div class="flex-between mb-8"><checkbox class="ml-auto mr-8" ng-model=vm.schedule.isAllDay></checkbox><div class=ft_14_regular_black2 translate="All Day"></div></div><div class=time-picker-disabled ng-if=vm.schedule.isAllDay></div><div ng-if=!vm.schedule.isAllDay><time-picker class=time-picker ng-model=vm.schedule.fromTime ng-change=vm.onChangeStartTime disabled></time-picker></div></div></div><div class="flex-between mb-16"><div class=flex-48><div class="ft_14_600_black2 mbl-4 required" translate=To></div><div class=time-picker-disabled ng-if=vm.isRepeat></div><div class="input-group datePicker-primary" ng-if=!vm.isRepeat><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.schedule.toDate is-open=isEndpickerOpen ng-required=true> <span class=dateArrow ng-click="isEndpickerOpen = !isEndpickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=flex-48><div class="ft_14_600_black2 mb-8" translate="">&nbsp;</div><div class=time-picker-disabled ng-if=vm.schedule.isAllDay></div><div ng-if=!vm.schedule.isAllDay><time-picker class=time-picker ng-model=vm.schedule.toTime ng-change=vm.onChangeEndTime disabled></time-picker></div></div></div><div><div class="ft_14_600_black2 mb-8" translate="Add Attendees"></div><div class=mb-16><div class=flex-between><autocomplete1 ng-if="currentDesignation !== \'Other\'" class="fm-search-input flex-85" ng-model=vm.select_user label-field=displayName value-field=memberId options=vm.users full-width=true no-flex=true place-holder="Enter name or email-id" to-top=true is-icon=true icon-file=/assets/icons/person2_fill_black.svg></autocomplete1><input ng-if="currentDesignation === \'Other\'" type=email class=mr-4 ng-model=vm.select_user placeholder="Start typing an email" ng-pattern=EMAIL_REGEX required><div class="ft-md ft-bold-primary ft-color-ex1 ml-1 cursor-point" ng-click=addAttendee() translate="+ Add"></div></div></div><div class=pos-relative><avatar-group avatars=vm.schedule.members to-top=true more-count-border-color="\'#ff8b00\'" more-count-color="\'#ff8b00\'" is-block=true radius=8px on-close=vm.close></avatar-group></div></div></div><hr><div class="action flex-items-center flex-content-end"><button class="button-primary mr-4 ph-10" ng-click=onSave() ng-if=!id translate=Add></button> <button class="button-primary mr-4" ng-click=onSave() ng-if=id translate=Update></button> <button class="button-third mr-4" ng-click=onDelete() ng-if=id translate=Delete></button> <button class=btn_cancel ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/main/cgviewer/bim/bimDetail/bim-spatial-tree.html','<div ui-tree-handle class=bim-tree-node><a class=expander ng-if="item.children && item.children.length > 0" data-nodrag ng-click=toggle(this)><img ng-if=this.collapsed src=/assets/icons/arrow-right5.svg> <img ng-if=!this.collapsed src=/assets/images/cgviewer/arrow-dropdown-black.svg> </a>&nbsp;&nbsp;<div class="name tx-ellipsis" title={{item.name}}>{{item.name}}</div><div class="ml-auto color-pick"><div class=color ng-click=vm.showColorPicker(item) ng-style=vm.getModelItemColor(item)></div></div><img class="eye-icon ml-10" ng-click="vm.bimModel.toggleItemVisible(item); vm.viewer.invalidate();" ng-src="{{item.visible && \'/assets/icons/eye-line.svg\' || \'/assets/icons/eye-line-slash.svg\'}}"> <img class="eye-icon mh-10" title=Select alt=select ng-click=vm.toggleSelected(item) ng-src="{{item.selected && \'/assets/icons/select-all.svg\' || \'/assets/icons/select-all-empty.svg\'}}"></div><!-- <div class="bottom-divider"></div> --><ol ui-tree-nodes="" ng-model=item.children ng-if=!collapsed><li ng-repeat="item in item.children" ui-tree-node ng-include="\'app/main/cgviewer/bim/bimDetail/bim-spatial-tree.html\'" data-collapsed=true></li></ol>');
$templateCache.put('app/main/cgviewer/bim/bimDetail/bim-type-tree.html','<div ui-tree-handle class=bim-tree-node><a class=expander ng-if="item.children && item.children.length > 0" data-nodrag ng-click=toggle(this)><img ng-if=this.collapsed src=/assets/icons/arrow-right5.svg> <img ng-if=!this.collapsed src=/assets/images/cgviewer/arrow-dropdown-black.svg> </a>&nbsp;&nbsp;<div class="name tx-ellipsis" title={{item.name}}>{{item.name}}</div><div class="ml-auto color-pick" ng-click="vm.modelCpItem = item;"><div class=color ng-click=vm.showColorPicker(item) ng-style=vm.getModelItemColor(item)></div></div><img class="eye-icon ml-10" title="Toggle show" alt=visible ng-click="vm.bimModel.toggleItemVisible(item); vm.viewer.invalidate();" ng-src="{{item.visible && \'/assets/icons/eye-line.svg\' || \'/assets/icons/eye-line-slash.svg\'}}"> <img class="eye-icon ml-10" title="Assign material" alt=material src=/assets/icons/model-material.svg ng-click=vm.assignMaterial(item)> <img class="eye-icon mh-10" title="Select All" alt=select ng-click=vm.toggleSelected(item) ng-src="{{item.selected && \'/assets/icons/select-all.svg\' || \'/assets/icons/select-all-empty.svg\'}}"></div><!-- <div class="bottom-divider"></div> --><ol ui-tree-nodes="" ng-model=item.children ng-if=!collapsed><li ng-repeat="item in item.children" ui-tree-node><div class=bim-tree-node><div class="name ml-15 tx-ellipsis" title={{item.name}}>{{item.name}}</div><div class="ml-auto color-pick" ng-click="vm.modelCpItem = item;"><div class=color ng-click=vm.showColorPicker(item) ng-style=vm.getModelItemColor(item)></div></div><img class="eye-icon ml-10" title="Toggle show" alt=visible ng-click="vm.bimModel.toggleItemVisible(item); vm.viewer.invalidate();" ng-src="{{item.visible && \'/assets/icons/eye-line.svg\' || \'/assets/icons/eye-line-slash.svg\'}}"> <img class="eye-icon ml-10" title="Assign material" alt=material src=/assets/icons/model-material.svg ng-click=vm.assignMaterial(item)> <img class="eye-icon mh-10" title=Select alt=select ng-click=vm.toggleSelected(item) ng-src="{{item.selected && \'/assets/icons/select-all.svg\' || \'/assets/icons/select-all-empty.svg\'}}"></div><!-- <div class="bottom-divider"></div> --></li></ol>');
$templateCache.put('app/main/cgviewer/bim/bimDetail/bimDetail.view.html','<!-- loading --><div id=initial_loading_popup><img src=/assets/images/cgviewer/cloud_loading.gif></div><div id=bim-detail ng-show="!isShowGisMap && !isShowPointCloud"><div class=detail-content ng-show="vm.mode == \'default\' || vm.mode == \'game\' || vm.mode == \'walk\'"><div id=bimviewer></div><bim-look-around ng-if="vm.mode == \'walk\'" control-event=vm.onWalkControlEvent></bim-look-around><div id=bim-plan-control><img src=/assets/images/cgviewer/bim/confirm.png class=cursor-point ng-click=vm.confirmBimPlan()> <img src=/assets/images/cgviewer/bim/delete.png class=cursor-point ng-click=vm.removeBimPlan()></div><toolbox ng-show="vm.mode == \'default\'" on-selected=vm.toolbarEvent data=toolbarList></toolbox><!-- status bar --><div id=statusbar class=status-bar-container ng-show="vm.mode == \'default\'"><div class=status-bar><div class=status-bar-item><span class=mr-2>X:</span><span>{{vm.statusDisplayData.pos.x | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2>Y:</span><span>{{vm.statusDisplayData.pos.y | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2>Z:</span><span>{{vm.statusDisplayData.pos.z | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2><span translate=Area></span>:</span><span>{{vm.statusDisplayData.info.area | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2><span translate=Width></span>:</span><span>{{vm.statusDisplayData.info.width | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2><span translate=Height></span>:</span><span>{{vm.statusDisplayData.info.height | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2 translate=Units></span> <select id=type ng-change=vm.onChangeUnit(this) ng-model=vm.unit class=unit-area><option value=m>m</option><option value=cm>cm</option><option value=mm>mm</option><option value=inch>inch</option></select></div></div></div><!-- side menu--><nav side-menu id=side_menu class=cg-side-menu ng-show="vm.mode == \'default\'"><a href="" id=menuToggle class=menu-toggle><div id=arrow></div></a><div id=container><!--Properties--><bim-object-properties bim-object=vm.bimObject products=vm.productList on-select=vm.onSelectObject on-changed=vm.contentEdited></bim-object-properties><!-- Text Properties--><text-properties ng-show=vm.textBrush.show ng-properties=vm.textBrush ng-text-change=vm.changeTextInfo ng-change-fill-color=vm.onChangeTextFillColor ng-change-stroke-color=vm.onChangeTextStrokeColor></text-properties><!--  Equipment / Materials  --><bim-equipment-materials ng-if="vm.bimObject && vm.bimObject.isSelected && vm.bimObject.hasInventory()" ng-materials=vm.bimObject.getInventory().materials></bim-equipment-materials><!-- Materials --><drawing-materials ng-selectcolor=vm.setColor ng-selecttexture=vm.setTexture ng-fliptexture=vm.flipTexture cp-color=vm.fillColor></drawing-materials></div></nav><!--property indicator--><bim-property-indicator show=vm.propertyIndicator.show bim-objects=vm.propertyIndicator.bimObjects pos=vm.propertyIndicator.pos unit=vm.unit viewer=vm.viewer update-materials=updateMaterials materials=vm.materials combo-materials=vm.comboMaterials equipments=vm.equipments combo-equipments=vm.comboEquipments work-types=vm.workTypes sections=vm.sections on-assigned=vm.contentEdited></bim-property-indicator></div><bim-plan ng-if="vm.mode==\'plan\'" class=detail-content bim-model=vm.bimModel plans=vm.bimData.plans selected-plan=vm.bimPlanNeedShow on-show-plan=vm.onShowPlan></bim-plan><!-- titlebar --><div id=title_bar class=title-bar ng-show="vm.mode !== \'game\'"><div class=menu-collapse-button ng-click=vm.optionMenu.toggle()><img src=/assets/icons/bars.svg></div><div class="title ft-14 ft-white active"><span>{{ vm.title }}</span></div><div class=right-menu><div ng-if="vm.bimModel && vm.modelId" class="menu-compare-button mr-16" ng-click=vm.collisionMenu.toggle()><img src=/assets/icons/compare-white.svg alt=collision><span translate=Collision></span></div><div ng-if="vm.bimModel && vm.modelId" class="menu-compare-button mr-16" ng-click=vm.issueMenu.toggle()><img src=/assets/icons/alarm4.svg alt=issues><span translate=Issues></span></div><div ng-if="vm.bimModel && vm.modelId" class="menu-compare-button mr-8" ng-click=vm.registrationMenu.toggle()><img src=/assets/icons/alarm4.svg alt=registrations><span translate=Registrations></span></div><ul class="nav navbar-top-links navbar-right"><li class=dropdown><a class=dropdown-toggle data-toggle=dropdown href=#><div translate=View></div><img src=/assets/icons/dropdown-white.svg></a><ul class="dropdown-menu dropdown-alerts"><li><a ng-click=vm.gotoHome()><img src=/assets/icons/home.svg class="mr-10 dropdown-icon"><span translate=Home></span></a></li><li><a ng-click=vm.gotoGIS()><img src=/assets/icons/gis.svg class="mr-10 dropdown-icon"><span translate=GIS></span></a></li><li class=divider></li><li ng-if="DVIEWER_ACCESS_CREATE > 1"><a ng-click=vm.save()><img src=/assets/icons/save-line.svg class="mr-10 dropdown-icon"><span translate=Save></span></a></li><li ng-if="DVIEWER_ACCESS_CREATE > 1 && !vm.collision"><a ng-click=vm.gotoCalc()><img src=/assets/icons/cg-calc.png class="mr-10 dropdown-icon"><span translate=Calculation></span></a></li></ul></li></ul></div></div><!-- option menu --><div class=option-menu ng-show="vm.mode !== \'game\'"><div class=option-menu-bar><div class=option-menu-buttons ng-show=vm.optionMenu.isShow><div class=menu-button ng-click="vm.optionMenu.main.toggle(\'model\')"><img src=/assets/icons/model.svg alt=model></div><div class=menu-button ng-click="vm.optionMenu.main.toggle(\'setting\')"><img src=/assets/icons/settings-black.svg alt=settings></div><div class=menu-button ng-click="vm.optionMenu.main.toggle(\'help\')"><img src=/assets/icons/help.svg alt=help></div></div></div><div id=menu-model class=option-menu-box ng-if="vm.optionMenu.main.isShow(\'model\')"><div class=menu-box-content><div class="menu-model-item divider-bt ft-24 fw-700 title"><span>{{ vm.title }}</span></div><div class="menu-model-item divider-bt" ng-class="{active: vm.optionMenu.model.isShow(\'spatial\')}" ng-click="vm.optionMenu.model.toggle(\'spatial\')"><img class=item-img ng-src="{{vm.optionMenu.model.isShow(\'spatial\') ?  \'/assets/images/cgviewer/bim/model-blue.svg\' : \'/assets/icons/model.svg\'}}"> <span translate="3D Model"></span> <img class="ml-auto arr-r" ng-src="{{vm.optionMenu.model.isShow(\'spatial\') ? \'/assets/icons/arrow-right5-blue.svg\' : \'/assets/icons/arrow-right5.svg\'}}"></div><div class="menu-model-item divider-bt" ng-class="{active: vm.optionMenu.model.isShow(\'types\')}" ng-click="vm.optionMenu.model.toggle(\'types\')"><img class=item-img ng-src="{{vm.optionMenu.model.isShow(\'types\') ?  \'/assets/images/cgviewer/bim/model-blue.svg\' : \'/assets/icons/model.svg\'}}"> <span translate=Objects></span> <img class="ml-auto arr-r" ng-src="{{vm.optionMenu.model.isShow(\'types\') ? \'/assets/icons/arrow-right5-blue.svg\' : \'/assets/icons/arrow-right5.svg\'}}"></div><div class="menu-model-item divider-bt" ng-class="{active: vm.optionMenu.model.isShow(\'floors\')}" ng-click="vm.optionMenu.model.toggle(\'floors\')"><img class=item-img ng-src="{{vm.optionMenu.model.isShow(\'floors\') ?  \'/assets/images/cgviewer/bim/model-blue.svg\' : \'/assets/icons/model.svg\'}}"> <span translate=Levels></span> <img class="ml-auto arr-r" ng-src="{{vm.optionMenu.model.isShow(\'floors\') ? \'/assets/icons/arrow-right5-blue.svg\' : \'/assets/icons/arrow-right5.svg\'}}"></div><div class="menu-model-item divider-bt" ng-class="vm.optionMenu.model.isShow(\'plan\') ? \'active\' : \'\'" ng-click="vm.optionMenu.model.toggle(\'plan\')"><img class=item-img ng-src="{{vm.optionMenu.model.isShow(\'plan\') ?  \'/assets/images/cgviewer/bim/model-folder-blue.svg\' : \'/assets/images/cgviewer/bim/model-folder.svg\'}}"> <span translate=Plans></span> <img class="ml-auto arr-r" ng-src="{{vm.optionMenu.model.isShow(\'plan\') ? \'/assets/icons/arrow-right5-blue.svg\' : \'/assets/icons/arrow-right5.svg\'}}"></div></div><div id=spatial class="menu-box-content divider-le" ng-if="vm.optionMenu.model.isShow(\'spatial\')"><div class=bim-tree data-drag-enabled=false ui-tree><ul ui-tree-nodes="" ng-model=vm.bimModel.treeData style="padding: 0"><li ng-repeat="item in vm.bimModel.treeData" ui-tree-node ng-include="\'app/main/cgviewer/bim/bimDetail/bim-spatial-tree.html\'"></li></ul></div></div><div id=types class="menu-box-content divider-le" ng-if="vm.optionMenu.model.isShow(\'types\')"><div class=bim-tree data-drag-enabled=false ui-tree><ul ui-tree-nodes="" ng-model=vm.bimModel.typeMap style="padding: 0"><li ng-repeat="item in vm.bimModel.typeMap" ui-tree-node ng-include="\'app/main/cgviewer/bim/bimDetail/bim-type-tree.html\'" data-collapsed=true></li></ul></div></div><div id=floors class="menu-box-content divider-le" ng-show="vm.optionMenu.model.isShow(\'floors\')"><div class=floor-item ng-repeat="item in vm.bimModel.floors"><div class="d-flex align-items-center"><img src=/assets/icons/model.svg> <span class="floor-name tx-ellipsis" title="{{ item.name }}">{{ item.name }}</span><div class="ml-auto color-pick"><div class=color ng-click=vm.showColorPicker(item) ng-style=vm.getModelItemColor(item)></div></div><img class="eye-icon my-auto ml-10 cursor-point" ng-src="{{item.visible && \'/assets/icons/eye-line.svg\' || \'/assets/icons/eye-line-slash.svg\'}}" ng-click="vm.bimModel.toggleItemVisible(item); vm.viewer.invalidate();"> <img class="eye-icon ml-10" title=Select alt=select ng-src="{{item.selected && \'/assets/icons/select-all.svg\' || \'/assets/icons/select-all-empty.svg\'}}" ng-click=vm.toggleSelected(item)></div><div class=separator></div><div class=d-flex><selectbox-input class="work-level my-auto" ng-model=item.workLevel options=vm.workLevels label-field=tagName value-field=tagName select-event=vm.contentEdited()></selectbox-input><img class="eye-icon my-auto ml-auto cursor-point" title="Export Semi Plan" src=/assets/icons/model-semi-plan.svg ng-click=vm.exportSemiPlan(item)> <img class="eye-icon my-auto ml-10 cursor-point" title="Export Plan" src=/assets/icons/model-plan-grey.svg ng-click=vm.exportPlan(item)></div></div></div><div id=plan class="menu-box-content divider-le" ng-show="vm.optionMenu.model.isShow(\'plan\')"><div class=plan-add ng-if="DVIEWER_ACCESS_CREATE > 1"><div class=btn_new_blue ng-click=vm.openPDF()>+ <span translate="Add Plan"></span></div></div><div class=plan-list><div class=plan-item ng-repeat="plan in vm.bimData.plans"><img src=/assets/icons/model-plan-black.svg> <span class=plan-item-title title="{{ plan.name }}">{{ plan.name }}</span> <img class="eye-icon my-auto ml-auto cursor-point" ng-src="{{plan.isVisible() && \'/assets/icons/eye-line.svg\' || \'/assets/icons/eye-line-slash.svg\'}}" ng-click=plan.toggleVisible()> <img class="delete-icon my-auto ml-10 cursor-point" src=/assets/icons/delete3.svg ng-click=vm.deleteBimPlan(plan) ng-if=plan.completed></div></div></div></div><!-- settings --><div class=option-menu-box ng-show="vm.optionMenu.main.isShow(\'setting\')"><bim-settings themes=vm.themes selected-theme=vm.theme on-theme-select=vm.themeSelected on-change-quality=vm.qualityChanged on-change-color-mode=vm.colorModeChanged on-change-select-mode=vm.selectModeChanged></bim-settings></div><!-- help --><div class=option-menu-box ng-show="vm.optionMenu.main.isShow(\'help\')"><bim-optional can-change="DVIEWER_ACCESS_CREATE > 1" description=vm.description thumb-file=vm.thumbFile thumbnail=vm.thumbnail location=vm.location loaded="isLoading===false" on-change=vm.contentEdited></bim-optional></div><div class=space ng-click=vm.optionMenu.close();></div></div><!-- compare menu --><div class=compare-space ng-if="vm.issueMenu.isShow || vm.registrationMenu.isShow" ng-click="vm.issueMenu.close(); vm.registrationMenu.close()"></div><!-- Collision check --><bim-collision ng-if="vm.bimModel && vm.modelId" ng-show="vm.mode !== \'game\'" is-show=vm.collisionMenu.isShow viewer=vm.viewer model-id=vm.modelId on-show-item=vm.showCollision></bim-collision><issue-menu ng-if="vm.bimModel && vm.modelId" ng-show="vm.mode !== \'game\'" is-vp=false is-show=vm.issueMenu.isShow model-id=vm.modelId></issue-menu><registration-menu ng-if="vm.bimModel && vm.modelId" ng-show="vm.mode !== \'game\'" is-vp=false is-show=vm.registrationMenu.isShow model-id=vm.modelId></registration-menu><!-- mode bar --><div class=mode-bar ng-show="vm.mode !== \'game\'"><div class=mode-bar-button ng-class="{active: vm.mode==\'default\'}" ng-click=vm.enterDefaultMode()><img src=/assets/images/cgviewer/bim/model-3d.svg></div><div class=mode-bar-button ng-class="{active: vm.mode==\'plan\'}" ng-click=vm.enterPlanMode()><img src=/assets/icons/model-plan.svg></div><div class=mode-bar-button ng-click=vm.enterGameMode()><img src=/assets/images/cgviewer/bim/joystick.svg></div><div class=mode-bar-button ng-class="{active: vm.mode==\'walk\'}" ng-click=vm.enterWalkMode()><img src=/assets/images/cgviewer/bim/work-mode.svg></div></div></div><div class=gis-container ng-show=isShowGisMap><gis-wrapper model-info=vm.modelInfo inject-gis=vm.injectGis call-back=vm.gisCallBack></gis-wrapper></div>');
$templateCache.put('app/main/cgviewer/bim/bimGrid/bimGrid.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=bimGrid class=main-container><spinner ng-show=isLoading></spinner><div class="main-container client-container"><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=vpGrid class="ft-normal-12-16 grey-2" translate=Bim></a></div><div class=ft_24_600_black1 translate="Dynamic Models"></div></div><button class="button-primary ml-auto" ng-click=vm.openDlgUpload() ng-if="DVIEWER_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Add New Model"></span></button></div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount > 0"><div class="card-based-content-grid-wrapper pr-24 pv-24"><div class="content-grid-wrapper flex flex-wrap mt-40 mh-min15"><div ng-repeat="model in models" class=models-container><div class=bim-card><div class=card-header><img ng-src="{{ model.thumbnail?model.thumbnail:\'/assets/images/cgviewer/textures/texture-11.jpg\' }}" class=object-fit-cover onerror="this.src=\'/assets/images/cgviewer/textures/texture-11.jpg\'"></div><div class=card-content><h3 ng-bind=model.name class=tx-ellipsis></h3><div class=flex-between><div><span class=value ng-bind="model.createdAt | smartDateTime"></span></div><div><span class=title translate=Size></span>:&nbsp; <span class=value>{{model.displaySize | readable: 1}}{{model.displaySizeUnit}}</span></div></div></div><div class="card-footer text-center"><a class=link-detail ng-click=goToDetail(model._id) translate="View Details"></a> <img src=/assets/icons/download-blue.svg alt="" class="link-trash mr-20" ng-click=vm.downloadPdf(plan)> <img src=/assets/icons/trash-alt-red.svg alt="" class=link-trash ng-click=deleteProjectRoofPlan(plan._id)></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + models.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllModels()></pagination-custom-new></div></div></div><!-- <div class="split flex-between">\n            <div>\n              <span class="ft_14_600_gray mr-15">Showing {{(vm.currentPage - 1) * numPerPage + 1}} - <span>{{vm.currentPage * numPerPage > totalCount? totalCount: vm.currentPage * numPerPage}}</span> of {{totalCount}} - <span>Dynamic Models</span></span></span>\n            </div>\n            <hr class="split-line"/>\n            <div class="flex-center">\n              <pagination num-pages="noOfPages" current-page="vm.currentPage" on-select-page="vm.fetchAllModels()"></pagination>\n            </div>\n          </div> --></div></div></div></div></main>');
$templateCache.put('app/main/cgviewer/directives/bim-collision/bim-collision.view.html','<div id=collision-menu ng-show=isShow><div class=collision-list-menu><!-- title bar   --><div class=collision-menu-title-bar><div class="active-bar active"></div><div class=title-body translate=Collision></div></div><!-- content   --><div class=collision-list-menu-content><div class=add-box><div class=btn_new_blue ng-click=addCollision()><img src=/assets/icons/circle-plus.svg alt=add><span translate="Add Model"></span></div></div><div class=collision-list><div class=collision ng-repeatuuu="collision in collisions"><div class=collision-info><span class="model-title tx-ellipsis" title={{collision.name}}>{{collision.name}}</span> <img src=/assets/icons/file-icon5.svg class="ml-auto cursor-point" alt=remove ng-click="removeCollision(collision, $index)"> <img ng-if="collision === activeCollision" class="ml-10 cursor-point" src=/assets/icons/cached_g.svg alt=refresh ng-click=refreshCollision(collision)> <img class="ml-10 cursor-point" alt=active ng-click=selectCollision(collision) ng-src="{{collision === activeCollision ? \'/assets/icons/eye-line-black.svg\' : \'/assets/icons/eye-line-slash-black.svg\'}}"></div><div ng-if="collision === activeCollision"><div class=action-box><div class=flex-center>X: <input type=text number-edit=2 ng-model=collision.position.x ng-blur=changePosition(collision)></div><div class=flex-center>Y: <input type=text number-edit=2 ng-model=collision.position.y ng-blur=changePosition(collision)></div><div class=flex-center>Z: <input type=text number-edit=2 ng-model=collision.position.z ng-blur=changePosition(collision)></div><div class=flex-center>A: <input type=text number-edit=2 ng-model=collision.position.angle ng-blur=changePosition(collision)></div></div><div class="collision-item-list mb-16"><div class=collision-item ng-repeat="item in collision.items"><div class=collision-sub ng-click="showCollisionItem(item, $index)"><span>[{{item.object1.name}}] - [{{item.object2.name}}]</span> <img class=ml-auto alt=toggle ng-src="{{item == selectedCollisionItem ? \'/assets/images/cgviewer/arrow-dropdown-black.svg\' : \'/assets/icons/arrow-right5.svg\'}}"></div><div class="preview render-3d" id=preview-container-{{$index}} ng-show="item == selectedCollisionItem"></div><live-chat-small unique-name={{modelId}} chat-type=model3d ng-if="item == selectedCollisionItem"></live-chat-small></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/cgviewer/directives/bim-equipment-materials/bim-equipment-materials.view.html','<section class=card id=bim-equipment-materials><div class=card-header><label class=card-title translate="Equipment / Materials"></label><div class=card-actions><a class="card-action card-action-toggle" data-card-toggle><img src=/assets/icons/dropdown-white.svg alt="dropdown arrow icon"></a></div></div><div class=card-body><div class=row><div class=col-8><label class=title translate=Items></label></div><div class=col-4><label class=title translate=Units></label></div></div><div class=row ng-repeat="mat in ngMaterials"><div class="col-8 d-flex align-items-center"><color-selector color=mat.color opacity=mat.opacity></color-selector><div class=mat-name>{{mat.name}}</div></div><div class="col-4 d-flex align-items-center justify-content-between"><span class=mat-quantity>{{mat.quantity | readable: 2}}{{mat.unit}}</span> <img class=visible-button ng-click=changeVisible() ng-src="{{visible && \'/assets/icons/eye-line.svg\' || \'/assets/icons/eye-line-slash.svg\'}}" alt=""></div></div></div></section>');
$templateCache.put('app/main/cgviewer/directives/bim-look-around/bim-look-around.view.html','<!-- look around --><div id=bim-look-around-container><div id=bim-look-around-control></div></div>');
$templateCache.put('app/main/cgviewer/directives/bim-object-properties/bim-object-properties.view.html','<section id=bim-object-properties card class=card><div class=card-header><label class=card-title translate=Properties></label><div class=card-actions><a class="card-action card-action-toggle" data-card-toggle><img src=/assets/icons/dropdown-white.svg alt="dropdown arrow icon"></a></div></div><div class=card-body><selectbox2 ng-model=selectedElement class=products options=products label-field=name value-field=id select-event=onElementSelected(selectedElement)></selectbox2><div class=component-preview-container><div id=component-preview></div><img class=expand-icon src=/assets/images/cgviewer/expand.svg></div><div><div class=property-item><div class=item-name translate=Type></div><div class=item-value>{{bimObject.type}}</div></div><div class=property-item><div class=item-name translate=Name></div><div class=item-value>{{bimObject.name}}</div></div><div class=property-item><div class=item-name translate=Description></div><div class=item-value><input type=text class=transparent ng-model=bimObject.description ng-change=onChanged()></div></div><div class=property-item><div class=item-name translate=GUID></div><div class=item-value>{{bimObject.guid}}</div></div></div></div></section>');
$templateCache.put('app/main/cgviewer/directives/bim-optional/bim-optional.view.html','<div id=bim-optional class=menu-box-content><div class=optional-section><div class="ft_12_600_gray mb-8" translate=Description></div><textarea class=w-100 placeholder="Write some description" ng-model=description ng-change=onChange()></textarea></div><div class=optional-section><div class="d-flex mb-8"><div class="ft_12_600_gray my-auto" translate="Preview Image"></div><button class="ml-auto btn-gray" ng-click=browseThumbnail() ng-if=canChange translate=Change></button> <input type=file id=thumbnail accept=.gif,.jpg,.jpeg,.png style="display: none" file-change=changeThumbnail></div><div class="d-flex preview-container"><img id=preview-img class="preview-image ml-auto mr-auto" alt="" ng-src={{thumbnail}}></div></div><div class=optional-section><div class="ft_12_600_gray mb-8" translate=Location></div><div class=pos-relative ng-if="isLoading === false"><input places-auto-complete types="[\'geocode\']" class="login_input w-100" on-place-changed=placeMarker() ng-model=address> <img src=/assets/icons/location.svg alt="" style="position: absolute;top: 12px;right: 10px;"></div><div class="w-100 mt-10"><div class=google-map><div><div class="gmap_viewer w-100"><div map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params="https://maps.googleapis.com/maps/api/js?key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&libraries=places"><ng-map center="{{ gmap.center }}" zoom="{{ gmap.zoom }}" id=service_map><marker ng-repeat="m in gmap.markers" position="{{ m }}" draggable=true on-dragend=updateMarker() icon="{url: \'/assets/images/cgviewer/vp-issue-completed.svg\', scaledSize: [50, 50], origin: [0,0], anchor: [0,0]}"></marker></ng-map></div></div></div></div></div></div></div>');
$templateCache.put('app/main/cgviewer/directives/bim-plan/bimPlan.view.html','<div id=bim-plan><div class=select-plan><span class="my-auto mr-10" translate="Select Plan"></span> <select id=plan_select ng-model=selectedPlan ng-options="plan.name for plan in plans" class="form-control animated zoomIn wow py-0 px-3 bkGrey my-auto" data-wow-delay=0.7s ng-change=selectPlan(selectedPlan)></select><div class="ml-auto action-btn" ng-click=gotoPlan() ng-if=bimPlan><img src=/assets/icons/home-white.svg alt=""></div><div class="ml-10 action-btn" ng-click=toggleNavigation() ng-if=bimPlan><img src=/assets/images/cgviewer/bim/light.svg alt=""></div><div class="ml-10 action-btn" ng-click=savePlan() ng-if=bimPlan><img src=/assets/icons/save-icon.svg alt=""></div></div><div class=content><div ng-class="navMode ? \'half\' : \'full\'"><div id=bim-plan-2d></div><toolbox ng-show=!navMode on-selected=toolbarEvent data=toolbarList ng-show=selectedPlan></toolbox></div><div ng-class="navMode ? \'half\' : \'full\'" ng-show=navMode><div id=bim-navigation-3d></div></div></div></div>');
$templateCache.put('app/main/cgviewer/directives/bim-property-indicator/bim-property-indicator.view.html','<div id=property_background_element ng-click=onClickEvent() ng-if=show><div id=property_expand_icon ng-click=onClickExpandIcon($event) ng-style=posStyle()></div></div><div id=property_expand_menu ng-if=show><div class=property-expand-menu-title-bar><div class=title>{{bimObject.name}}</div><img id=property_expand_menu_expand_icon src=/assets/icons/close-12-gray.svg ng-click=onClickCollapseIcon()></div><div class=property-expand-menu-container><!-- properties --> <span class=property-expand-menu-icon ng-class="{active: curPopupId==0}" id=property_expand_menu_properties_icon ng-click=onClickPropertiesIcon()><img ng-src="{{curPopupId == 0 ? \'assets/images/cgviewer/property/properties-active.svg\' : \'assets/images/cgviewer/property/properties.svg\'}}"></span><div class=property-expand-menu-divider></div><!-- eye --> <span class=property-expand-menu-icon id=property_expand_menu_visible_icon ng-click=onClickVisible()><img src=/assets/images/cgviewer/property/eye.svg></span><div class=property-expand-menu-divider></div><!-- items --> <span class=property-expand-menu-icon ng-class="{active: curPopupId==1}" id=property_expand_menu_items_icon ng-click=onClickItemsIcon()><img ng-src="{{curPopupId == 1 ? \'assets/images/cgviewer/property/items-active.svg\' : \'assets/images/cgviewer/property/items.svg\'}}"></span><div class=property-expand-menu-divider></div><!-- share --> <span class=property-expand-menu-icon ng-class="{active: curPopupId==2}" id=property_expand_menu_share_icon><img ng-src="{{curPopupId == 2 ? \'assets/images/cgviewer/property/share-active.svg\' : \'assets/images/cgviewer/property/share.svg\'}}"></span><div class=property-expand-menu-divider></div><!-- download --> <span class=property-expand-menu-icon id=property_expand_menu_download_icon><img src=/assets/images/cgviewer/property/download.svg></span></div><div class="d-flex justify-content-center"><img src=/assets/images/cgviewer/property/inverse_triangle.svg></div></div>');
$templateCache.put('app/main/cgviewer/directives/bim-settings/bim-settings.view.html','<div id=bim-settings class=menu-box-content><div class=setting-area><div class=setting-header translate="Background Themes"></div><div class="setting-content row"><div class="setting-item col-3 p-0 mb-15" ng-repeat="theme in themes"><div class=setting-item-content><img ng-if=theme.empty class=sample-icon ng-src={{theme.image}} ng-click=themeSelected(theme)><div ng-if=!theme.empty class=sample-icon ng-click=themeSelected(theme)><img class=space ng-src={{theme.space}}> <img class=ground ng-src={{theme.ground}}></div><div class=setting-item-focus ng-if="theme == selectedTheme"></div></div></div></div></div><div class=setting-area><div class=setting-header translate="Graphics Quality"></div><div class="setting-content row"><div class="setting-item col-3 p-0 mb-15" ng-repeat="quality in qualities" ng-click=qualitySelected(quality)><div class=setting-item-content><div><img class=sample-icon ng-src={{quality.icon}}><div class=setting-item-title>{{quality.name}}</div></div><div class=setting-item-focus ng-if="quality == selectedQuality"></div></div></div></div></div><div class=setting-area><div class=setting-header translate="Color Mode"></div><div class="setting-content row"><div class="setting-item col-3 p-0 mb-15" ng-repeat="color in colorModes" ng-click=colorModeSelected(color)><div class=setting-item-content><div><img class=sample-icon ng-src={{color.icon}}><div class=setting-item-title>{{color.name}}</div></div><div class=setting-item-focus ng-if="color == selectedColorMode"></div></div></div></div></div><div class=setting-area><div class=setting-header translate="Select Mode"></div><div class="setting-content row"><div class="setting-item col-3 p-0 mb-15" ng-repeat="facemode in selectModes" ng-click=selectModeSelected(facemode)><div class=setting-item-content><div><img class=sample-icon ng-src={{facemode.icon}}><div class=setting-item-title>{{facemode.name}}</div></div><div class=setting-item-focus ng-if="facemode == selectedSelectMode"></div></div></div></div></div></div>');
$templateCache.put('app/main/cgviewer/directives/cgviewer-dropdown/cgviewer-dropdown.view.html','<div class="dropdown cgviewer-dropdown" ng-mouseleave=closeList()><div class=cgviewer-dropdown-header><div ng-show=icon class=cgviewer-icon><img ng-src={{icon}} alt=icon></div><div ng-show=icon class=cgviewer-dropdown-label-with-icon>{{selectedLabel}}</div><div ng-show=!icon class=cgviewer-dropdown-label>{{selectedLabel}}</div><button class=cgviewer-dropdown-toggle type=button ng-click=toggleList()></button></div><ul class=cgviewer-dropdown-menu ng-if=isOpen><li><a href=# id={{item[valueField]}} class=cgviewer-menu-item data-ng-click=selectItem(item) ng-repeat="item in options" ng-if="options && options!=[]"><span>{{item[labelField]}}</span> </a><a href=# class=cgviewer-menu-item ng-if="!options || options==[]">No Data</a></li></ul></div>');
$templateCache.put('app/main/cgviewer/directives/gis-wrapper/gis-wrapper.view.html','<div id=gis><div id=map></div><!-- <div id="container"></div> --><div class=option-menu ng-show=isShowModelInfoOnGis><div id=menu-model class=option-menu-box><div class=menu-box-content><div class="menu-model-item divider-bt ft-24 fw-700 title"><span>{{ title }}</span></div><div class="menu-model-item divider-bt" ng-class="{active: optionMenu.model.isShow(\'spatial\')}" ng-click="optionMenu.model.toggle(\'spatial\')"><img class=item-img ng-src="{{optionMenu.model.isShow(\'spatial\') ?  \'/assets/images/cgviewer/bim/model-blue.svg\' : \'/assets/icons/model.svg\'}}"> <span translate="3D Model"></span> <img class="ml-auto arr-r" ng-src="{{optionMenu.model.isShow(\'spatial\') ? \'/assets/icons/arrow-right5-blue.svg\' : \'/assets/icons/arrow-right5.svg\'}}"></div><div class="menu-model-item divider-bt" ng-class="{active: optionMenu.model.isShow(\'types\')}" ng-click="optionMenu.model.toggle(\'types\')"><img class=item-img ng-src="{{optionMenu.model.isShow(\'types\') ?  \'/assets/images/cgviewer/bim/model-blue.svg\' : \'/assets/icons/model.svg\'}}"> <span translate=Objects></span> <img class="ml-auto arr-r" ng-src="{{optionMenu.model.isShow(\'types\') ? \'/assets/icons/arrow-right5-blue.svg\' : \'/assets/icons/arrow-right5.svg\'}}"></div></div><div id=spatial class="menu-box-content divider-le" ng-if="optionMenu.model.isShow(\'spatial\')"><div class=bim-tree data-drag-enabled=false ui-tree><ul drag-to-reorder-bind=bimModel.treeData ui-tree-nodes="" ng-model=bimModel.treeData style="padding: 0"><li dtr-draggable ng-repeat="item in bimModel.treeData" ui-tree-node ng-include="\'app/main/cgviewer/bim/bimDetail/bim-spatial-tree.html\'"></li></ul></div></div><div id=types class="menu-box-content divider-le" ng-if="optionMenu.model.isShow(\'types\')"><div class=bim-tree data-drag-enabled=false ui-tree><ul drag-to-reorder-bind=bimModel.typeMap ui-tree-nodes="" ng-model=bimModel.typeMap style="padding: 0"><li dtr-draggable ng-repeat="item in bimModel.typeMap" ui-tree-node ng-include="\'app/main/cgviewer/bim/bimDetail/bim-type-tree.html\'"></li></ul></div></div><div id=floors class="menu-box-content divider-le" ng-show="optionMenu.model.isShow(\'floors\')"><div class=floor-item ng-repeat="item in bimModel.floors"><div class="d-flex h-40"><img src=/assets/icons/model.svg> <span class="floor-name tx-ellipsis" title="{{ item.name }}">{{ item.name }}</span><div class="ml-auto color-pick"><div class=color ng-click=showColorPicker(item) ng-style=getModelItemColor(item)></div></div><img class="eye-icon my-auto ml-10 cursor-point" ng-src="{{item.selected && \'/assets/icons/eye-line.svg\' || \'/assets/icons/eye-line-slash.svg\'}}" ng-click="bimModel.toggleItemVisible(item); viewer.invalidate();"></div><div class=separator></div><div class="d-flex h-40"><selectbox-input class="work-level my-auto" ng-model=item.workLevel options=workLevels label-field=tagName value-field=tagName></selectbox-input><img class="eye-icon my-auto ml-auto cursor-point" title="Export Semi Plan" src=/assets/icons/model-semi-plan.svg ng-click=exportSemiPlan(item)> <img class="eye-icon my-auto ml-10 cursor-point" title="Export Plan" src=/assets/icons/model-plan-grey.svg ng-click=exportPlan(item)></div></div></div><div id=plan class="menu-box-content divider-le" ng-show="optionMenu.model.isShow(\'plan\')"><div class=plan-add ng-if="DVIEWER_ACCESS_CREATE > 1"><div class=plan-add-button ng-click=openPDF()>+ <span translate="Add Plan"></span></div></div><div class=plan-list><div class=plan-item ng-repeat="plan in bimData.plans"><img src=/assets/icons/model-plan-black.svg> <span class=plan-item-title title="{{ plan.name }}">{{ plan.name }}</span> <img class="eye-icon my-auto ml-auto cursor-point" ng-src="{{plan.isVisible() && \'/assets/icons/eye-line.svg\' || \'/assets/icons/eye-line-slash.svg\'}}" ng-click=plan.toggleVisible()> <img class="delete-icon my-auto ml-10 cursor-point" src=/assets/icons/delete3.svg ng-click=deleteBimPlan(plan) ng-if=plan.completed></div></div></div></div></div><div class="button-group d-flex"><div class="button mr-10 cursor-point" ng-click=backtoHome() title=Home><div class=circle><img src=/assets/icons/home.svg></div></div><div class="button mr-10 cursor-point" title="View Type" data-toggle=dropdown><div class=circle><img src=/assets/icons/street-map.svg ng-if="mapViewMode == \'street\'"> <img src=/assets/icons/satellite.svg ng-if="mapViewMode == \'satellite\'"> <img src=/assets/icons/3d-modeling.svg ng-if="mapViewMode == \'extrusion\'"></div></div><ul class=dropdown-menu><li><a ng-click=setStreetMap()><img src=/assets/icons/street-map.svg class="mr-10 dropdown-icon">Street</a></li><li><a ng-click=setSattleteMap()><img src=/assets/icons/satellite.svg class="mr-10 dropdown-icon">Satellite</a></li><li><a ng-click=setExtrusionMap()><img src=/assets/icons/3d-modeling.svg class="mr-10 dropdown-icon">Extrusion</a></li></ul><div class="button mr-10 cursor-point" title=Tools ng-click=toggleBuilding()><div class=circle><img src=/assets/icons/settings-black.svg></div></div><div class=control-button-group ng-show=showControl><div class=flex-between><div><div class="d-flex flex-between btn-rotate-group"><div class="button mr-10 cursor-point" id=button-rotate-left><div class=circle><img src=/assets/icons/3d-rotate-left.svg></div></div><div class="button cursor-point" id=button-rotate-right><div class=circle><img src=/assets/icons/3d-rotate-right.svg></div></div></div><div class="d-flex flex-between btn-zoom-group"><div class="button mr-10 mb-0 cursor-point" id=button-scale-positive><div class=circle><img src=/assets/icons/3d-scale-up.svg></div></div><div class="button mb-0 cursor-point" id=button-scale-negative><div class=circle><img src=/assets/icons/3d-scale-down.svg></div></div></div></div><div><div><div class="button cursor-point direct-v" id=button-move-up><div class=circle><img src=/assets/icons/3d-move-up.svg></div></div></div><div class="d-flex flex-between direct-h"><div class="button cursor-point" id=button-move-left><div class=circle><img src=/assets/icons/3d-move-left.svg></div></div><div class="button cursor-point" id=button-move-right><div class=circle><img src=/assets/icons/3d-move-right.svg></div></div></div><div><div class="button cursor-point direct-v" id=button-move-down><div class=circle><img src=/assets/icons/3d-move-down.svg></div></div></div></div><div class="d-flex flex-between direct-reset"><div class="button cursor-point" id=button-reset><div class=circle><img src=/assets/icons/3d-map-reset.svg></div></div></div></div></div><div class="button mr-10 cursor-point" title="{{isShowModel? \'Hide\': \'Show\'}}" ng-click=showHideModel()><div class=circle><img ng-src="{{isShowModel ? \'/assets/icons/eye-line-black.svg\' : \'/assets/icons/eye-line-slash-black.svg\'}}"></div></div><div class="button mr-10 cursor-point" title=Info ng-click=showModelInfoDialog()><div class=circle><img src=/assets/icons/fm_info.svg></div></div><div class="button cursor-point" title=Save ng-click=saveModelInfoInMap()><div class=circle><img src=/assets/icons/save-line-black.svg></div></div></div><div class="header-logo flex-center"><img src=/assets/images/dashboard/Cloudes_Logo.svg alt=logo><div>CloudES</div></div></div>');
$templateCache.put('app/main/cgviewer/directives/issue-menu/issue-menu.view.html','<div id=issue-menu ng-show=isShow><!-- Recent Activities --><div class=issue-list-menu><!-- title bar   --><div class=issue-menu-title-bar><div class="active-bar active"></div><div class=title-body translate="Recent Activities"></div></div><!-- content   --><div class=issue-list-menu-content><div class=categories-box><div class=category><span translate=Issue></span> <span>({{issues.length}})</span> <img src=/assets/icons/close-msg.svg alt=close></div></div><div class=search-box><searchbox search-text=issueSearchText place-holder="Search for Issues, Clash, Collaboration"></searchbox></div><div class=issue-list><side-menu-issue-card ng-repeat="issue in issues track by $index" ng-model=issue custom-height=548px></side-menu-issue-card></div></div><spinner ng-if=loading></spinner></div></div>');
$templateCache.put('app/main/cgviewer/directives/line-properties/line-properties.view.html','<!-- Line Properties --><section card id=line-properties class=card><div class=card-header><label class=card-title translate="Line Properties"></label><div class=card-actions><a class="card-action card-action-toggle" data-card-toggle><img src=/assets/icons/dropdown-white.svg alt="dropdown arrow icon"></a></div></div><div class=card-body><div class="row mb-10"><div class=col-7><div class=line-label translate=Dashes></div><div class="d-flex align-items-center"><cgviewer-dropdown ng-model=ngProperties.dashType ng-change=changeDashType() options=dashTypes label-field=label value-field=value></cgviewer-dropdown></div></div><div class=col-5><div ng-show="ngProperties.dashType !== 1"><div class=line-label></div><cgviewer-dropdown ng-model=ngProperties.strokeDashArray ng-change=changeDashSpace() options=dashDots label-field=label value-field=value></cgviewer-dropdown></div><div ng-show="ngProperties.dashType === 1"><div class=line-label translate=Thickness></div><cgviewer-dropdown ng-model=ngProperties.strokeWidth ng-change=changeThickness() options=strokeWidths label-field=label value-field=value></cgviewer-dropdown></div></div></div><div class=stroke-container><div class=label translate=Color></div><div class=content><div class=color-container><color-selector color=strokeColor opacity=strokeOpacity on-change=changeStrokeColor()></color-selector><div class=opacity-wrapper><input type=number ng-model=strokeOpacity value=100 min=0 max=100 class=form-control ng-change=changeStrokeColor()> <span>%</span></div></div></div></div></div></section>');
$templateCache.put('app/main/cgviewer/directives/materials/materials.view.html','<section card id=materials class=card><div class=card-header><label class=card-title translate=Materials></label><div class=card-actions><a class="card-action card-action-toggle" data-card-toggle><img src=/assets/icons/dropdown-white.svg alt="dropdown arrow icon"></a></div></div><div class="card-body p-0"><div material-tab class=material-tab-container style=height:270px;><div class=material-tab-header><a id=materials-tab1-tab href=#materials-color class=active ng-click="showPreview = true" translate=Color></a> <a id=materials-tab2-tab href=#materials-texture ng-click="showPreview = false" translate=Texture></a> <span class=tab-underline-bar></span></div><div class=tab-content><!-- material color --><div id=materials-color><!-- color --><div id=material_color_list class="row material-list"><div ng-repeat="color in colors track by $index" class="material-item col-2 d-flex justify-content-center mb-15" ng-click=selectColor(color)><div class=material-sample-icon ng-style="{\'background-color\': color}" ng-class="{\'has-border\': isLight(color)}"></div><div class=focus ng-if="color === material"></div></div></div></div><div id=materials-texture><div id=material_texture_list class="row material-list"><div ng-repeat="texture in textures track by $index" class="material-item col-2 d-flex justify-content-center mb-15" ng-click=selectTexture(texture)><div class=material-sample-icon ng-style="{\'background-image\': \'url(\'+texture+\')\'}" style="background-size: contain;"></div><div class=focus ng-if="texture === material"></div></div></div></div></div></div><div ng-show=showPreview class="d-flex align-items-center p-15 add-material"><div class=color-container><color-selector color=newColor opacity=newOpacity hide-symbol=true></color-selector><div class=opacity-wrapper><input type=number ng-model=newOpacity value=100 min=0 max=100 class=form-control><div class=percentage>%</div></div></div><div class="card-action-button ml-10" ng-click=requestColorAdd()><img src=/assets/icons/circle-plus.svg alt="circle plus icon"></div></div><div ng-show=!showPreview class="d-flex align-items-center p-15 add-material"><!-- texture --><div class=d-none><input type=file ng-model=textureFile id=material_texture_add_input accept=image/*></div><div class="card-action-button ml-auto" ng-click=requestTextureAdd()><img src=/assets/icons/circle-plus.svg alt=icon></div></div></div></section>');
$templateCache.put('app/main/cgviewer/directives/object-dropdown/object-dropdown.view.html','<div class="dropdown object-dropdown" ng-mouseleave=closeList()><div class=object-dropdown-header><div class=object-dropdown-label>{{selectedLabel}}</div><button class=object-dropdown-toggle type=button ng-click=toggleList()></button></div><ul ng-class="upward? \'object-dropdown-menu upward\': \'object-dropdown-menu\'" ng-if=isOpen><li><a href=# id={{item[valueField]}} class=object-menu-item data-ng-click=selectItem(item) ng-repeat="item in options" ng-if="options && options!=[]"><span>{{item[labelField]}}</span></a></li></ul></div>');
$templateCache.put('app/main/cgviewer/directives/registration-menu/registration-menu.view.html','<div id=registration-menu ng-show=isShow><!-- Recent Activities --><div class=issue-list-menu><!-- title bar   --><div class=issue-menu-title-bar><div class="active-bar active"></div><div class=title-body translate="Recent Activities"></div></div><!-- content   --><div class=issue-list-menu-content><div class=categories-box><div class=category><span translate=Registration></span> <span>({{registrations.length}})</span> <img src=/assets/icons/close-msg.svg alt=close></div></div><div class=search-box><searchbox search-text=issueSearchText place-holder="Search for Issues, Clash, Collaboration"></searchbox></div><div class=issue-list><side-menu-registration-card ng-repeat="registration in registrations track by $index" ng-model=registration custom-height=548px></side-menu-registration-card></div></div><spinner ng-if=loading></spinner></div></div>');
$templateCache.put('app/main/cgviewer/directives/side-menu-issue-card/side-menu-issue-card.view.html','<div class=side-menu-issue-card ng-class="{expanded: isExpanded}" ng-style="{height: isExpanded ? customHeight : \'auto\'}"><div class=summary-board><div class=summary-board-top><div class=issue-id>{{ngModel.systemTag}}</div><img ng-src="{{isExpanded ? \'/assets/icons/dropup-black.svg\' : \'/assets/icons/dropdown-black.svg\'}}" alt="" ng-click=toggleExpand()></div><div class=summary-board-bottom>{{ngModel.title}}</div></div><div class=tab-bar ng-show=isExpanded><div class=tab ng-class="{active: isDetails}" ng-click=switchTab(true) translate=Details></div><div class=tab ng-class="{active: !isDetails}" ng-click=switchTab(false) translate=Comments></div></div><div ng-if="isExpanded && isDetails" class=issue-content ng-class="{\'pb-0\': !isDetail}"><div class="d-flex mb-16"><div class=width50><label for=status-{{ngModel._id}} translate=Status></label><div id=status-{{ngModel._id}} ng-class=issueStatusClass()>{{ngModel.status}}</div></div><div class=width50><label for=category-{{ngModel._id}} translate=Group></label><div id=category-{{ngModel._id}} class=category-ellipse>{{ngModel.issueCategory}}</div></div></div><div class=mb-16><label for=description-{{ngModel._id}} translate=Description></label><div id=description-{{ngModel._id}} class=ft_12_regular_gray>{{ngModel.description}}</div></div><div class=mb-16><label for=image-{{ngModel._id}} translate=Image></label><div class=issue-image><img ng-if="ngModel.image && ngModel.image.secure_url" id=image-{{ngModel._id}} ng-src={{ngModel.image.secure_url}} alt=""><div ng-if="!ngModel.image || !ngModel.image.secure_url" class=no-image translate="No Image"></div></div></div><div class=mb-16><label for=createdBy-{{ngModel._id}} translate="Created by"></label><div id=createdBy-{{ngModel._id}} class=ft_12_regular_gray>{{ngModel.createdBy}}</div></div></div><div ng-if="isExpanded && !isDetails" class=issue-chat><live-chat-small unique-name={{ngModel._id}} chat-type=issue></live-chat-small></div></div>');
$templateCache.put('app/main/cgviewer/directives/side-menu-registration-card/side-menu-registration-card.view.html','<div class=side-menu-registration-card ng-class="{expanded: isExpanded}" ng-style="{height: isExpanded ? customHeight : \'auto\'}"><div class=summary-board><div class=summary-board-top><div class=registration-id>{{ngModel.systemTag}}</div><img ng-src="{{isExpanded ? \'/assets/icons/dropup-black.svg\' : \'/assets/icons/dropdown-black.svg\'}}" alt="" ng-click=toggleExpand()></div><div class=summary-board-bottom>{{ngModel.title}}</div></div><div class=tab-bar ng-show=isExpanded><div class=tab ng-class="{active: isDetails}" ng-click=switchTab(true) translate=Details></div></div><div ng-if="isExpanded && isDetails" class=registration-content ng-class="{\'pb-0\': !isDetail}"><div class=mb-16><label for=category-{{ngModel._id}} translate=Group></label><div id=category-{{ngModel._id}} class=category-ellipse>{{ngModel.registrationType}}</div></div><div class=mb-16><label for=description-{{ngModel._id}} translate=Description></label><div id=description-{{ngModel._id}} class=ft_12_regular_gray>{{ngModel.description}}</div></div><div class=mb-16><label for=image-{{ngModel._id}} translate=Image></label><div class=registration-image><img ng-if="ngModel.image && ngModel.image.secure_url" id=image-{{ngModel._id}} ng-src={{ngModel.image.secure_url}} alt=""><div ng-if="!ngModel.image || !ngModel.image.secure_url" class=no-image>No Image</div></div></div><div class=mb-16><label for=createdBy-{{ngModel._id}} translate="Created by"></label><div id=createdBy-{{ngModel._id}} class=ft_12_regular_gray>{{ngModel.createdBy.displayName}}</div></div></div></div>');
$templateCache.put('app/main/cgviewer/directives/text-properties/text-properties.view.html','<section card id=bim-text-properties class=card><div class=card-header><label class=card-title translate="Text Properties"></label><div class=card-actions><a class="card-action card-action-toggle" data-card-toggle><img src=/assets/icons/dropdown-white.svg alt="dropdown arrow icon"></a></div></div><div class=card-body><div class="row mb-15"><label for=text class="ml-2 mb-2 mt-10" translate=Text></label> <textarea class=form-control id=text ng-model=ngProperties.text ng-change="ngTextChange(\'text\', ngProperties.text)" ng-disabled=!ngProperties.text placeholder="">\n      </textarea></div><div class=row><cgviewer-dropdown ng-model=ngProperties.fontFamily ng-change="ngTextChange(\'fontFamily\', ngProperties.fontFamily)" options=webSafeFontFamilies label-field=label value-field=value placeholder=Arial></cgviewer-dropdown></div><div class=row><div class=col-6><cgviewer-dropdown ng-model=ngProperties.fontStyle ng-change="ngTextChange(\'fontStyle\', ngProperties.fontStyle)" options=webFontStyles label-field=label value-field=value placeholder=Regular></cgviewer-dropdown></div><div class=col-6><cgviewer-dropdown ng-model=ngProperties.fontSize ng-change="ngTextChange(\'fontSize\', ngProperties.fontSize)" options=webFontSizes label-field=label value-field=value placeholder=10></cgviewer-dropdown></div></div><div class=row><div class=col-6><cgviewer-dropdown ng-model=ngProperties.textHeight options=textHeights label-field=label value-field=value placeholder=auto icon=/assets/icons/text-height.png></cgviewer-dropdown></div><div class=col-6><cgviewer-dropdown ng-model=ngProperties.charSpace options=charSpaces label-field=label value-field=value placeholder=5 icon=/assets/icons/text-char-space.png></cgviewer-dropdown></div></div><div class=row><div class=col-6><cgviewer-dropdown ng-model=ngProperties.lineSpace options=lineSpaces label-field=label value-field=value placeholder=10 icon=/assets/icons/text-line-space.png></cgviewer-dropdown></div><div class=col-6><div class=text-aligns><div class=text-align-item><img src=/assets/icons/text-align-left.png alt=icon></div><div class=text-align-item><img src=/assets/icons/text-align-center.png alt=icon></div><div class=text-align-item><img src=/assets/icons/text-align-right.png alt=icon></div><div class=text-align-item><img src=/assets/icons/text-align-justify.png alt=icon></div></div></div></div><div class=fill-container><div class=label translate=Fill></div><div class=content><div class=color-container><color-selector color=fillColor opacity=fillOpacity on-change=changeFillColor()></color-selector><div class=opacity-wrapper><input type=number ng-model=fillOpacity value=100 min=0 max=100 class=form-control ng-change=changeFillColor()> <span>%</span></div></div></div></div><div class=stroke-container><div class=label translate=Stroke></div><div class=content><div class=color-container><color-selector color=strokeColor opacity=strokeOpacity on-change=changeStrokeColor()></color-selector><div class=opacity-wrapper><input type=number ng-model=strokeOpacity value=100 min=0 max=100 class=form-control ng-change=changeStrokeColor()> <span>%</span></div></div></div></div></div></section>');
$templateCache.put('app/main/cgviewer/directives/toolbox/toolbox.view.html','<div id=toolbox class=drawing-toolbar><div class=toolbar-button ng-repeat-start="item in data track by $index" ng-class="{active: activeItem===item, expanded: expandedItem===item}"><img ng-src="{{\'/assets/images/cgviewer/toolbar/\' + item.icon}}" ng-click=onButtonClick(item) title={{item.description}}><div class=sub ng-if=item.submenu><div class=toolbar-button ng-repeat-start="sub in item.submenu"><img ng-src="{{\'/assets/images/cgviewer/toolbar/\' + sub.icon}}" ng-click="onButtonClick(sub, item)" title={{sub.description}}></div><div class=toolbar-divider ng-repeat-end=sub></div></div></div><div class=toolbar-divider ng-repeat-end=item></div></div>');
$templateCache.put('app/main/cgviewer/directives/vp-collision/vp-collision.view.html','<div id=vp-collision-menu ng-show=isShow><div class=collision-list-menu><!-- title bar   --><div class=collision-menu-title-bar><div class="active-bar active"></div><div class=title-body translate=Collision></div></div><!-- content   --><div class=collision-list-menu-content><div class=add-box><div class=btn_new_blue ng-click=addCollision()><img src=/assets/icons/circle-plus.svg alt=add><span translate="Add Plan"></span></div></div><div class="mb-15 collision"><div class=collision-item ng-click="selectItem(\'original\')" ng-class="{selected: current == \'original\'}"><div class=collision-info><span class="plan-title tx-ellipsis" title={{originalView.data.title}}>{{originalView.data.title}}</span></div><div class=collision-detail><div class=collision-divider></div><div class=collision-control><div class=flex-center><span class="sub-label mr-10" translate=Fill></span><div class=fill-value><input type=number class=opacity-text min=0 max=100 value=50 ng-model=opacity1 ng-change="changeOpacity(originalView, opacity1)"> <span class=percent>%</span></div></div><div class="flex-center ml-10"><span class="sub-label mr-10" translate=Color></span><div class=color-container><color-selector color=color1 opacity=colorOpacity1 on-change=changeColor1()></color-selector><div class=opacity-wrapper><input type=number value=100 min=0 max=100 class=form-control ng-model=colorOpacity1 ng-change=changeColor1()> <span>%</span></div></div></div></div></div></div><div class=collision-item ng-repeat="collision in collisions" ng-class="{selected: current == \'collision\' && activeCollision === collision}" ng-click="selectItem(\'collision\', collision)"><div class=collision-info><span class="plan-title tx-ellipsis" title={{collision.name}}>{{collision.name}}</span> <img src=/assets/icons/file-icon5.svg class="ml-auto cursor-point" ng-click=removeCollision($index)> <img class="ml-10 cursor-point" alt=active ng-click=selectCollision(collision) ng-src="{{collision === activeCollision ? \'/assets/icons/eye-line-black.svg\' : \'/assets/icons/eye-line-slash-black.svg\'}}"></div><div class=collision-detail ng-if="collision === activeCollision"><div class=collision-divider></div><div class=collision-control><div class=flex-center><span class="sub-label mr-10" translate=Fill></span><div class=fill-value><input type=number class=opacity-text min=0 max=100 value=50 ng-model=collision.opacity ng-change="changeOpacity(collisionView, collision.opacity)"> <span class=percent>%</span></div></div><div class="flex-center ml-10"><span class="sub-label mr-10" translate=Color></span><div class=color-container><color-selector color=collision.color opacity=collision.colorOpacity on-change=changeColor(collision)></color-selector><div class=opacity-wrapper><input type=number value=100 min=0 max=100 class=form-control ng-model=collision.colorOpacity ng-change=changeColor(collision)> <span>%</span></div></div></div></div><div class=collision-divider></div><live-chat-small unique-name={{planId}} chat-type=vp></live-chat-small></div></div></div></div></div></div>');
$templateCache.put('app/main/cgviewer/directives/vp-equipment-materials/vp-equipment-materials.view.html','<section class=card id=equipment-materials><div class=card-header><label class=card-title translate="Equipment / Materials"></label><div class=card-actions><a class="card-action card-action-toggle" data-card-toggle><img src=/assets/icons/dropdown-white.svg alt="dropdown arrow icon"></a></div></div><div class=card-body><div class=row><div class=col-8><label class=title translate=Items></label></div><div class=col-4><label class=title translate=Units></label></div></div><div class=row ng-repeat="mat in ngMaterials"><div class="col-8 d-flex align-items-center"><color-selector ng-model=mat.color opacity=mat.opacity></color-selector><div class=mat-name>{{mat.name}}</div></div><div class="col-4 d-flex align-items-center justify-content-between"><span class=mat-quantity>{{mat.quantity}}{{mat.unit}}</span><div class=visible-button ng-click=changeVisible()><img ng-src="{{visible && \'/assets/icons/eye-line.svg\' || \'/assets/icons/eye-line-slash.svg\'}}" alt=""></div></div></div></div></section>');
$templateCache.put('app/main/cgviewer/directives/vp-layers/layers.view.html','<section class=card id=drawing_layer_container><div class=card-header><label class=card-title translate=Layers></label><div class=card-actions><a class="card-action card-action-toggle" data-card-toggle><img src=/assets/icons/dropdown-white.svg alt="dropdown arrow icon"></a></div><!-- <div id="levels-button" class="card-action-button" ng-click="newLevel()">Levels</div> --></div><div class=card-body><div class=layer-search><input type=text placeholder=Search ng-model=searchLayer><img src=/assets/icons/search-gray.svg></div><div id=dlg_layers_content><div class=layer-item ng-repeat="level in levels track by level.id"><div class=content><color-selector color=ngProperties.layerColor opacity=ngProperties.layerOpacity></color-selector><input type=text class=layer-item-title ng-model=level.name ng-readonly=!level.editable><div class=toggle-icon><img ng-src="{{level.editable && \'/assets/icons/edit-done.svg\' || \'../assets/icons/edit.svg\'}}" ng-click="level.editable = !level.editable"></div><div class=toggle-icon><img ng-src="{{level.visible && \'/assets/icons/eye.svg\' || \'../assets/icons/eye-slash.svg\'}}" ng-click=toggleShowLevel(level)></div><div class=toggle-icon><img class=toggle-show ng-src="{{level.expand && \'/assets/icons/left-arrow.svg\' || \'../assets/icons/right-arrow.svg\'}}" ng-click="level.expand = !level.expand"></div></div><div class=sub ng-show=level.expand><div class=layer-item ng-repeat="layer in level.items | filter: {name: searchLayer} track by layer.id"><div class=content><color-selector color=ngProperties.layerColor opacity=ngProperties.layerOpacity></color-selector><input type=text class=layer-item-title ng-model=layer.name ng-readonly=!layer.editable><div class=toggle-icon><img class=edit-icon ng-src="{{layer.editable && \'/assets/icons/edit-done.svg\' || \'../assets/icons/edit.svg\'}}" ng-click="layer.editable = !layer.editable"></div><div class=toggle-icon><img class=eye-icon ng-src="{{layer.visible && \'/assets/icons/eye.svg\' || \'../assets/icons/eye-slash.svg\'}}" ng-click=toggleShowLayer(layer)></div><img class=toggle-show ng-src="{{layer.expand && \'/assets/icons/left-arrow.svg\' || \'../assets/icons/right-arrow.svg\'}}" ng-click="layer.expand = !layer.expand"></div><div class=sub ng-show=layer.expand><div class=item ng-repeat="item in layer.items track by item.objectid"><input type=text class=layer-item-title ng-model=item.name ng-readonly=!item.editable> <img class=edit-icon ng-src="{{item.editable && \'/assets/icons/edit-done.svg\' || \'../assets/icons/edit.svg\'}}" ng-click="item.editable = !item.editable"></div></div></div></div></div></div><button class="btn_new_blue ml-auto" ui-click=newLayer()><img src=/assets/icons/circle-plus.svg alt="circle plus icon"><span class=ft-600-12-16 translate="Add Layer"></span></button><!-- <div class="card-action-button" ng-click="newLayer()">\n      <img src="/assets/icons/circle-plus.svg" alt="circle plus icon"/>\n      <div translate="Add Layer"></div>\n    </div> --></div></section>');
$templateCache.put('app/main/cgviewer/directives/vp-model/vpModel.view.html','<div id=vp-model><div class=detail-content><div id=bimviewer></div><div id=collision></div><div id=bim-plan-control><img src=/assets/images/cgviewer/bim/confirm.png class=cursor-point ng-click=confirmVPPlan()> <img src=/assets/images/cgviewer/bim/delete.png class=cursor-point ng-click=removeVPPlan()></div><!-- loading --><div id=initial_loading_popup><img src=/assets/images/cgviewer/cloud_loading.gif></div></div></div>');
$templateCache.put('app/main/cgviewer/directives/vp-object-properties/object-properties.view.html','<section class=card id=object-properties><div class=card-header><label class=card-title translate=Properties></label><div class=card-actions><a class="card-action card-action-toggle" data-card-toggle><img src=/assets/icons/dropdown-white.svg alt="dropdown arrow icon"></a></div></div><div class=card-body><div class=row><div class="col-6 d-flex align-items-center justify-content-between"><div translate=Property></div><div class=object-button ng-show=euFormat ng-click="euFormat = false;">EU</div><div class=object-button ng-show=!euFormat ng-click="euFormat = true;">AM</div></div><div class=col-6><div class="object-value text-center" ng-show=euFormat>0,0</div><div class="object-value text-center" ng-show=!euFormat>0.0</div></div></div><div class=row><div class=col-6><label class=object-label translate=Units></label><cgviewer-dropdown ng-model=unit ng-change=onChange() options=units label-field=label value-field=value placeholder=m></cgviewer-dropdown></div><div class=col-6><label class=object-label translate=Area></label><div class=object-value><span class=box-value ng-if=!euFormat title="{{ngObject.area*scaleTimes*scaleTimes | roundNum:4}}">{{ngObject.area*scaleTimes*scaleTimes | roundNum:2}} </span><span class=box-value ng-if=euFormat title="{{ngObject.area*scaleTimes*scaleTimes | comma2decimal: 4}}">{{ngObject.area*scaleTimes*scaleTimes | comma2decimal: 2}}</span></div></div></div><div class=row><div class=col-6><label class=object-label translate=Width></label><div class=object-value><span class=box-value ng-if=!euFormat title="{{ngObject.width*scaleTimes | roundNum:2}}">{{ngObject.width*scaleTimes | roundNum:2}} </span><span class=box-value ng-if=euFormat title="{{ngObject.width*scaleTimes | comma2decimal: 2}}">{{ngObject.width*scaleTimes | comma2decimal: 2}}</span></div></div><div class=col-6><label class=object-label>{{ngObject.wallHeight !== undefined ? \'Length\' : \'Height\'}}</label><div class=object-value><span class=box-value ng-if=!euFormat title="{{ngObject.height*scaleTimes | roundNum:2}}">{{ngObject.height*scaleTimes | roundNum:2}} </span><span class=box-value ng-if=euFormat title="{{ngObject.height*scaleTimes | comma2decimal:2}}">{{ngObject.height*scaleTimes | comma2decimal: 2}}</span></div></div></div><div class=row><div class=col-6><label class=object-label translate="Perimeter in"></label><div class=object-value><span class=box-value ng-if=!euFormat title="{{(ngObject.perimeterIn*scaleTimes) | roundNum:2}}">{{ngObject.perimeterIn*scaleTimes | roundNum:2}} </span><span class=box-value ng-if=euFormat title="{{(ngObject.perimeterIn*scaleTimes) | comma2decimal: 2}}">{{ngObject.perimeterIn*scaleTimes | comma2decimal: 2}}</span></div></div><div class=col-6><label class=object-label translate="Perimeter out"></label><div class=object-value><span class=box-value ng-if=!euFormat title="{{ngObject.perimeterOut*scaleTimes | roundNum:2}}">{{ngObject.perimeterOut*scaleTimes | roundNum:2}} </span><span class=box-value ng-if=euFormat title="{{ngObject.perimeterOut*scaleTimes | comma2decimal: 2}}">{{ngObject.perimeterOut*scaleTimes | comma2decimal: 2}}</span></div></div></div><div class=divider ng-if="ngObject.wallHeight !== undefined"></div><div class=row ng-if="ngObject.wallHeight !== undefined"><div class=col-6><label class=object-label translate=Height></label><div class=object-value><span class=box-value ng-if=!euFormat title="{{(ngObject.wallHeight*scaleTimes) | roundNum:2}}">{{ngObject.wallHeight*scaleTimes | roundNum:2}} </span><span class=box-value ng-if=euFormat title="{{(ngObject.wallHeight*scaleTimes) | comma2decimal: 2}}">{{ngObject.wallHeight*scaleTimes | comma2decimal: 2}}</span></div></div><div class=col-6><div class="card-action-button mt-28" ng-click=onChangeWall() translate=Change></div></div></div></div></section>');
$templateCache.put('app/main/cgviewer/directives/vp-property-indicator/vp-property-indicator.view.html','<div id=vp_property_background_element ng-click=onClickEvent()><div id=vp_property_expand_icon ng-click=onClickExpandIcon($event)></div></div><div id=vp_property_expand_menu><div class=property-expand-menu-title-bar><div class=title>{{vpObject.name}}</div><img id=property_expand_menu_expand_icon src=/assets/icons/close-12-gray.svg ng-click=onClickCollapseIcon()></div><div class=property-expand-menu-container><!-- properties --> <span class=property-expand-menu-icon ng-class="{active: curPopupId == 0}" ng-click=onClickPropertiesIcon()><img ng-src="{{curPopupId == 0 ? \'assets/images/cgviewer/property/properties-active.svg\' : \'assets/images/cgviewer/property/properties.svg\'}}"></span><div class=property-expand-menu-divider></div><!-- eye --> <span class=property-expand-menu-icon id=property_expand_menu_visible_icon><img src=assets/images/cgviewer/property/eye.svg></span><div class=property-expand-menu-divider></div><!-- delete --><!--<span class="property-expand-menu-icon" id="property_expand_menu_delete_icon">--><!--  <img src="assets/images/cgviewer/property/trash.svg" />--><!--</span>--><!--<div class="property-expand-menu-divider"></div>--><!-- copy --><!--<span class="property-expand-menu-icon" id="property_expand_menu_copy_icon">--><!--  <img src="assets/images/cgviewer/property/copy.svg" />--><!--</span>--><!--<div class="property-expand-menu-divider"></div>--><!-- cut --><!--<span class="property-expand-menu-icon" id="property_expand_menu_cut_icon">--><!--  <img src="assets/images/cgviewer/property/cut.svg" />--><!--</span>--><!--<div class="property-expand-menu-divider"></div>--><!-- items --> <span class=property-expand-menu-icon ng-class="{active: curPopupId == 1}" ng-click=onClickItemsIcon()><img ng-src="{{curPopupId == 1 ? \'assets/images/cgviewer/property/items-active.svg\' : \'assets/images/cgviewer/property/items.svg\'}}"></span><div class=property-expand-menu-divider></div><!-- share --> <span class=property-expand-menu-icon ng-class="{active: curPopupId == 2}"><img ng-src="{{curPopupId == 2 ? \'assets/images/cgviewer/property/share-active.svg\' : \'assets/images/cgviewer/property/share.svg\'}}"></span><div class=property-expand-menu-divider></div><!-- download --> <span class=property-expand-menu-icon id=property_expand_menu_download_icon><img src=assets/images/cgviewer/property/download.svg></span></div><!-- <div class="d-flex justify-content-center">\n    <img src="/assets/images/cgviewer/property/inverse_triangle.svg" />\n  </div> --></div>');
$templateCache.put('app/main/cgviewer/directives/vp-settings/vp-settings.view.html','<div id=vp-settings class=menu-box-content><div class=setting-area><div class=setting-header translate="Color Mode"></div><div class="setting-content row"><div class="setting-item col-3 p-0 mb-15" ng-repeat="color in colorModes" ng-click=colorModeSelected(color)><div class=setting-item-content><div><img class=sample-icon ng-src={{color.icon}}><div class=setting-item-title>{{color.name}}</div></div><div class=setting-item-focus ng-if="color == selectedColorMode"></div></div></div></div></div></div>');
$templateCache.put('app/main/cgviewer/modals/calibrationModal/calibrationModal.view.html','<div id=vp-calibration-modal><div class=header id=object-properties-header><div class=title translate=Properties></div><img src=/assets/images/cgviewer/property/close-white.svg ng-click=vm.onClose()></div><div class=content><div class=scale-area><div class=object-name translate="Please enter scale"></div><div class=mt-10><input ng-if="vm.companyData && vm.companyData.companyInputMethod==\'British/American et al.\'" type=number ng-model=vm.calibration ng-change=changeCalibrationValue(calibrationValue) class=scale-value calc-decimal> <input ng-if="vm.companyData && vm.companyData.companyInputMethod==\'European et al.\'" type=text ng-model=vm.calibration class=scale-value calc-inputs></div></div><div class="scale-area mt-10"><div class=object-name translate=Unit></div><div class=mt-10><object-dropdown ng-model=vm.unit options=units label-field=label value-field=value ng-change=onChangeUnit()></object-dropdown></div></div></div><div class=footer><div class=buttons><button class="object-button cancel mr-10" ng-click=vm.onClose() translate=Cancel></button> <button class="object-button confirm" ng-click=vm.onConfirm() translate=Confirm></button></div></div></div>');
$templateCache.put('app/main/cgviewer/modals/elementsModal/elementsModal.view.html','<div id=elements-modal><div class=header><span class=title translate=Symbol></span> <span class=close-btn ng-click=cancel()></span></div><div class=body><div class=searchbar><input id=icons_search type=text placeholder="Search by Name or Material ID..." ng-model=iconFilter ng-change=searchIcons()> <img src=/assets/icons/search.svg></div><div><div class=tab-header><div id=sub_tab1 ng-click="changeTab(\'site\');" class=tab-item ng-class="{active:curTab==\'site\'}">Building Site</div><div id=sub_tab2 ng-click="changeTab(\'dynamic\');" class=tab-item ng-class="{active:curTab==\'dynamic\'}">2D Dynamic</div><div id=sub_tab3 ng-click="changeTab(\'equipment\');" class=tab-item ng-class="{active:curTab==\'equipment\'}">Equipment</div></div><div class=sub-tab-content><div id=building_site class=tab-page ng-show="curTab==\'site\'"><div id=icons_content class=scrollable-content></div></div><div id=dynamic_2d class=tab-page ng-show="curTab==\'dynamic\'"><div id=elements_content class=scrollable-content></div></div><div id=equipment class=tab-page ng-show="curTab==\'equipment\'"><div id=equipment_content class=scrollable-content></div></div></div></div><div class=popup-footer><button id=icons_add type=button class=btn translate=Add></button> <button id=icons_assign type=button class=btn translate=Assign></button> <button id=icons_cancel type=button class=btn translate=Cancel></button></div></div></div>');
$templateCache.put('app/main/cgviewer/modals/file-picker-modal/file-picker-modal.view.html','<div id=file-picker-modal><section class=header><div class=ft_18_600_black translate="New Plan"></div><a href=# data-ng-click=close()><img src=/assets/icons/close-12-gray.svg alt=""></a></section><spinner ng-if=loading></spinner><section class=tab-header ng-if=!submitStep><div class="tab ft_16_600_gray" ng-click="switchTab(\'remote\')" ng-class="{active: tab === \'remote\'}" translate="File Manager"></div><div class="tab ft_16_600_gray" ng-click="switchTab(\'local\')" ng-class="{active: tab === \'local\'}" translate=Browse></div></section><section class=select-file ng-if=!submitStep><div class="remote content" ng-if="tab === \'remote\'"><div class=content-header><div class="left flex-items-center flex-between pl-3"><div><img ng-if=!isAvailableBackward() class=arrow src=/assets/icons/fm_left_arrow.svg alt=""> <img ng-if=isAvailableBackward() class="arrow active" src=/assets/icons/fm_left_arrow_dark.svg alt="" ng-click=backward()> <img ng-if=!isAvailableForward() class=arrow src=/assets/icons/fm_right_arrow.svg alt=""> <img ng-if=isAvailableForward() class="arrow active" src=/assets/icons/fm_right_arrow_dark.svg alt="" ng-click=forward()></div></div><div class="right pr-2"><div class=bread-crumb><img class=folder-icon src=/assets/icons/fm_folder_icon.svg alt=""><div class=bread-crumb-item ng-repeat="breadCrumb in vm.breadCrumbList track by $index"><div class=name>{{breadCrumb.name}}</div><img class=arrow-icon src=/assets/icons/fm-arrow-right-black.svg alt="" ng-if="$index < vm.breadCrumbList.length - 1"></div></div><searchbox input-class=fm-searchbox search-text=vm.searchText search-event=vm.searchCallback()></searchbox></div></div><div class=content-body><div class="left folders-nav" ui-tree data-drag-enabled=false><ul ui-tree-nodes="" ng-model=vm.rootFolders><li ng-repeat="item in vm.rootFolders" ui-tree-node ng-include="\'app/core/components/folder-picker-modal/folder-tree.html\'"></li></ul></div><div class="right folders-container"><div class=tab-bar><div class="tab-item name"><span translate=Name></span><img src=/assets/icons/fm-arrow-down-deactivated.svg alt=""></div><div class="tab-item type"><span translate=Type></span><img src=/assets/icons/fm-arrow-down-deactivated.svg alt=""></div><div class="tab-item size"><span translate=Size></span><img src=/assets/icons/fm-arrow-down-deactivated.svg alt=""></div></div><div class=list-container><div class=list-content><div class=list-content-row ng-repeat="folder in vm.currentFilteredFolders"><div class="list-content-col name"><div ng-click=selectFolder(folder)><img class=mr-2 src=/assets/icons/fm_folder_icon.svg alt=""><span>{{folder.name}}</span></div></div><div class="list-content-col type" translate=Folder></div><div class="list-content-col size"></div></div><div ng-class="{\'list-content-row\': true, selected: vm.selectedFile && vm.selectedFile._id === file._id}" ng-repeat="file in vm.currentFilteredFiles" ng-click=selectFile(file) ng-dblclick=selectFileAndOpen(file)><div class="list-content-col name"><img class="file-icon mr-2" ng-src={{utils.getFMFileIcon(file.format)}} alt=""><span>{{file.originalname}}</span></div><div class="list-content-col type">{{file.format | uppercase}}</div><div class="list-content-col size">{{file.bytes | filesize}}</div></div></div></div></div></div></div><div class="local content" ng-if="tab === \'local\'"><div class=browse-container ngf-drop ngf-change="vm.fileUpdated($files, $event)" name=file ngf-pattern="\'.pdf\'" ngf-multiple=false ngf-accept="\'.pdf\'"><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons><span translate="Drag and Drop or"></span> <span class="ft-blue-back ph-5" ngf-select ngf-change="vm.fileUpdated($files, $event)" name=file ngf-pattern="\'.pdf\'" ngf-multiple=true ngf-accept="\'.pdf\'" translate=Browse></span> <span translate="to Upload"></span></div></div><div class=pdf-preview><img class="thumbnail object-fit-cover" ng-if="pdfPages && pdfPages.length" ng-src={{pdfPages[0].url}} alt="first page"></div></div></section><section class=submit-step ng-if=submitStep><div class=pdf-preview><img ng-src={{vm.selectedPage.url}} alt="pdf page" class="thumbnail object-fit-cover"><div class=preview-nav-bar><img class="preview-nav-item mr-4" src=/assets/icons/left-arrow.svg alt=left ng-click=backwardPage()><div class=page-num>{{vm.selectedPageIndex + 1}} / {{pdfPages.length}}</div><img class="preview-nav-item ml-4" src=/assets/icons/right-arrow.svg alt=right ng-click=forwardPage()></div></div><div class=input-form><div class=mb-4><div class="ft_12_500_gray mb-2" translate=Title></div><input type=text class=title-input ng-model=vm.selectedPage.title placeholder="Input title"></div><div class=mb-24><div class="ft_12_500_gray mb-2" translate=Level></div><selectbox2 ng-model=vm.selectedLevel label-field=name value-field=name options=vm.levels></selectbox2></div><div class=mb-4><div class="ft_12_500_gray mb-2" translate=Description></div><textarea class=description ng-model=vm.selectedPage.description placeholder="Write some description"></textarea></div></div></section><section class=footer><button class=btn-gray ng-click=close() ng-if=!submitStep translate=Close></button> <button class=btn-blue ng-click=openPDF() ng-if=!submitStep translate=Open></button> <button class=btn-gray ng-click=cancelSubmit() ng-if=submitStep translate=Cancel></button> <button class=btn-blue ng-click=submit() ng-if=submitStep translate=Submit></button></section></div>');
$templateCache.put('app/main/cgviewer/modals/modelColorModal/modelColorModal.view.html','<div id=model-color-modal><div class=header><span class=title translate="Select Color"></span> <span class=close-btn ng-click=cancel()></span></div><div class=body><div class=no-color ng-click=selectNoColor() translate="No Color"></div><color-selector color=color opacity=opacity></color-selector><div class="d-flex justify-content-center mt-40"><button type=button class="btn_new_blue mr-16" ng-click=select() translate=Select></button> <button type=button class="btn_new_blue client_gray_back" ng-click=cancel() translate=Cancel></button></div></div></div>');
$templateCache.put('app/main/cgviewer/modals/objectInventoriesModal/objectInventoriesModal.view.html','<div id=object-inventories-modal><div class=header id=object-inventories-header><div class=title translate=Items></div><img src=/assets/images/cgviewer/property/close-white.svg ng-click=onClose()></div><ul class="nav nav-tabs"><li ng-class="{active: vm.tab==tab.value}" ng-repeat="tab in vm.tabs"><div ng-click=onTab(tab.value)>{{tab.label}}</div></li></ul><div class=content><div class=tab-page ng-class="{active: vm.tab==tab.value}" ng-repeat="tab in vm.tabs"><div class=p-10><div class=search-container><input type=text placeholder="Search Symbol" ng-model=searchMaterial> <img src=./assets/images/cgviewer/search.svg></div></div><div class=object-information-items-table><div class=header><div class="header-item td-select"></div><div class="header-item td-name" translate=Items></div><div class="header-item td-option" translate=Option></div><div class="header-item td-unit" translate=Unit></div><div class="header-item td-quantity" translate=Quantity></div><div class="header-item td-type" translate="Work Type"></div></div><div class=table-content><div class=table-row ng-repeat="mat in vm.baseData[tab.value] | filter: {name: searchMaterial} track by $index"><div class="table-cell td-select"><checkbox ng-model=mat.checked ng-click="vm.selectMat(mat, tab.value)"></checkbox></div><div class="table-cell td-name">{{mat.name}}</div><div class="table-cell td-option"><object-dropdown options=vm.options ng-model=mat.option label-field=label value-field=value ng-change="vm.changeOption(mat, tab.value)" upward="$index > vm.baseData[tab.value].length- 2"></object-dropdown></div><div class="table-cell td-unit"><object-dropdown ng-if=isLengthUnit(mat.unit) options=units ng-model=mat.unit label-field=label value-field=value ng-change="vm.changeUnit(mat, tab.value)" upward="$index > vm.baseData[tab.value].length- 2"></object-dropdown><object-dropdown ng-if=isAreaUnit(mat.unit) options=units2 ng-model=mat.unit label-field=label value-field=value ng-change="vm.changeUnit(mat, tab.value)" upward="$index > vm.baseData[tab.value].length- 2"></object-dropdown><object-dropdown ng-if=isVolumeUnit(mat.unit) options=units3 ng-model=mat.unit label-field=label value-field=value ng-change="vm.changeUnit(mat, tab.value)" upward="$index > vm.baseData[tab.value].length- 2"></object-dropdown><object-dropdown ng-if=isTimeUnit(mat.unit) options=units4 ng-model=mat.unit label-field=label value-field=value ng-change="vm.changeUnit(mat, tab.value)" upward="$index > vm.baseData[tab.value].length- 2"></object-dropdown><object-dropdown ng-if=isWeightUnit(mat.unit) options=units5 ng-model=mat.unit label-field=label value-field=value ng-change="vm.changeUnit(mat, tab.value)" upward="$index > vm.baseData[tab.value].length- 2"></object-dropdown><object-dropdown ng-if=!mat.unit options=unitsEmpty ng-model=mat.unit label-field=label value-field=value ng-change="vm.changeUnit(mat, tab.value)" upward="$index > vm.baseData[tab.value].length- 2"></object-dropdown></div><div class="table-cell td-quantity"><div class=quantity-container><div class=color-container><div class=color-rect ng-style="{background: getColor(mat)}"></div></div><div class=quantity-rect><span ng-if=isTimeUnit(mat.unit)><input type=text number-edit=2 ng-model=mat.quantity ng-blur="vm.changeQuantity(mat, tab.value)"> </span><span ng-if=!isTimeUnit(mat.unit)>{{mat.quantity | readable: 2}}</span></div></div></div><div class="table-cell td-type"><selectbox-input class=w-100 options=vm.workTypes ng-model=mat.workType label-field=tagName value-field=tagName select-event="vm.changeWorkType(mat, tab.value)" to-top="$index > vm.baseData[tab.value].length- 2"></selectbox-input></div></div></div></div></div></div><div class=footer><div class=d-flex><div class=type-col><div class="type-name left"><span class=my-auto translate=Level></span></div><div class=type-options><div class=work-level>{{vm.workLevel}}</div></div></div><div class="type-col ml-auto"><div class="type-name left"><span class=my-auto translate=Section></span></div><div class=type-options><selectbox-input class=w-100 ng-model=vm.section label-field=name value-field=_id options=vm.sections select-event=vm.selectSection() to-top=true has-clear=true></selectbox-input></div></div></div><div class=d-flex><div class="buttons ml-auto"><button class="object-button cancel" ng-click=onClose() translate=Cancel></button> <button class="object-button assign" ng-click=assign() translate=Assign></button></div></div></div></div>');
$templateCache.put('app/main/cgviewer/modals/objectPropertiesModal/objectPropertiesModal.view.html','<div id=object-properties-modal><div class=header id=object-properties-header><div class=title translate=Properties></div><img src=/assets/images/cgviewer/property/close-white.svg ng-click=onClose()></div><div class=content><div class=row><div class=w-50p><div class=object-name translate=Unit></div></div><div class=w-50p><object-dropdown ng-model=unit options=units label-field=label value-field=value ng-change=vm.changeUnit()></object-dropdown></div></div><div class=row><div class=w-50p><div class=object-name translate=Width></div></div><div class=w-50p><div class=object-value>{{width | readable: 2}}</div></div></div><div class=row><div class=w-50p><div class=object-name>{{isWall ? \'Length\' : \'Height\'}}</div></div><div class=w-50p><div class=object-value>{{height | readable: 2}}</div></div></div><div class=row ng-if=isWall><div class=w-50p><div class=object-name translate=Height></div></div><div class=w-50p><div class=object-value>{{wallHeight | readable: 2}}</div></div></div><div class=row ng-if="isThree && isShape"><div class=w-50p><div class=object-name translate=Length></div></div><div class=w-50p><div class=object-value>{{length | readable: 2}}</div></div></div><div class=row><div class=w-50p><div class=object-name translate=Area></div></div><div class=w-50p><div class=object-value>{{area | readable: 2}}</div></div></div><div class=row ng-if="isThree && isShape"><div class=w-50p><div class=object-name translate=Volume></div></div><div class=w-50p><div class=object-value>{{volume | readable: 2}}</div></div></div></div></div>');
$templateCache.put('app/main/cgviewer/modals/open-pdf-modal/open-pdf-modal.view.html','<div id=open-pdf-modal><section class=header><div class=ft_18_600_black translate="Select PDF"></div><a href=# data-ng-click=close()><img src=/assets/icons/close-12-gray.svg alt=""></a></section><spinner ng-if=loading></spinner><section class=tab-header ng-if=!vm.selectedPage><div class="tab ft_16_600_gray" ng-click="switchTab(\'remote\')" ng-class="{active: tab === \'remote\'}" translate="File Manager"></div><div class="tab ft_16_600_gray" ng-click="switchTab(\'local\')" ng-class="{active: tab === \'local\'}" translate=Browse></div></section><section class=select-file ng-if=!vm.selectedPage><div class="remote content" ng-if="tab === \'remote\'"><div class=content-header><div class="left flex-items-center flex-between pl-3"><div><img ng-if=!isAvailableBackward() class=arrow src=/assets/icons/fm_left_arrow.svg alt=""> <img ng-if=isAvailableBackward() class="arrow active" src=/assets/icons/fm_left_arrow_dark.svg alt="" ng-click=backward()> <img ng-if=!isAvailableForward() class=arrow src=/assets/icons/fm_right_arrow.svg alt=""> <img ng-if=isAvailableForward() class="arrow active" src=/assets/icons/fm_right_arrow_dark.svg alt="" ng-click=forward()></div></div><div class="right pr-2"><div class=bread-crumb><img class=folder-icon src=/assets/icons/fm_folder_icon.svg alt=""><div class=bread-crumb-item ng-repeat="breadCrumb in vm.breadCrumbList track by $index"><div class=name>{{breadCrumb.name}}</div><img class=arrow-icon src=/assets/icons/fm-arrow-right-black.svg alt="" ng-if="$index < vm.breadCrumbList.length - 1"></div></div><searchbox input-class=fm-searchbox search-text=vm.searchText search-event=vm.searchCallback()></searchbox></div></div><div class=content-body><div class="left folders-nav" ui-tree data-drag-enabled=false><ul ui-tree-nodes="" ng-model=vm.rootFolders><li ng-repeat="item in vm.rootFolders" ui-tree-node ng-include="\'app/core/components/folder-picker-modal/folder-tree.html\'"></li></ul></div><div class="right folders-container"><div class=tab-bar><div class="tab-item name"><span translate=Name></span><img src=/assets/icons/fm-arrow-down-deactivated.svg alt=""></div><div class="tab-item type"><span translate=Type></span><img src=/assets/icons/fm-arrow-down-deactivated.svg alt=""></div><div class="tab-item size"><span translate=Size></span><img src=/assets/icons/fm-arrow-down-deactivated.svg alt=""></div></div><div class=list-container><div class=list-content><div class=list-content-row ng-repeat="folder in vm.currentFilteredFolders"><div class="list-content-col name"><div ng-click=selectFolder(folder)><img class=mr-2 src=/assets/icons/fm_folder_icon.svg alt=""><span>{{folder.name}}</span></div></div><div class="list-content-col type">Folder</div><div class="list-content-col size"></div></div><div ng-repeat="file in vm.currentFilteredFiles" ng-class="{\'list-content-row\': true, selected: vm.selectedFile && vm.selectedFile._id === file._id}" ng-click=selectFile(file) ng-dblclick=selectFileAndOpen(file)><div class="list-content-col name"><img class="file-icon mr-2" ng-src={{utils.getFMFileIcon(file.format)}} alt=""> <span>{{file.originalname}}</span></div><div class="list-content-col type">{{file.format | uppercase}}</div><div class="list-content-col size">{{file.bytes | filesize}}</div></div></div></div></div></div></div><div class="local content" ng-if="tab === \'local\'"><div class=browse-container ngf-drop ngf-change="vm.fileUpdated($files, $event)" name=file ngf-pattern="\'.pdf\'" ngf-multiple=false ngf-accept="\'.pdf\'"><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> <span translate="Drag and Drop or"></span> <span class="ft-blue-back ph-5" ngf-select ngf-change="vm.fileUpdated($files, $event)" name=file ngf-pattern="\'.pdf\'" ngf-multiple=true ngf-accept="\'.pdf\'" translate=Browse></span> <span translate="to Upload"></span></div></div><div class=pdf-preview><img class=thumbnail ng-if=vm.previewPage ng-src={{vm.previewPage.image}} alt="first page"></div></div></section><section class=submit-step ng-if=vm.selectedPage><div class=pdf-preview><img ng-src={{vm.selectedPage.image}} alt="pdf page" class=thumbnail><div class=preview-nav-bar><img class="preview-nav-item mr-4" src=/assets/icons/left-arrow.svg alt=left ng-click=backwardPage()><div class=page-num>{{vm.selectedPageIndex + 1}} / {{vm.pdf.numPages}}</div><img class="preview-nav-item ml-4" src=/assets/icons/right-arrow.svg alt=right ng-click=forwardPage()></div></div></section><section class=footer><button class="btn-gray ml-auto" ng-click=close() ng-if=!vm.selectedPage translate=Close></button> <button class=btn_new_blue ng-click=openPDF() ng-if=!vm.selectedPage translate=Open></button> <button class="btn-gray ml-auto" ng-click=cancelSelect() ng-if=vm.selectedPage translate=Cancel></button> <button class=btn_new_blue ng-click=select() ng-if=vm.selectedPage translate=Select></button></section></div>');
$templateCache.put('app/main/cgviewer/modals/openModelModal/openModelModal.view.html','<div id=open-model-modal><div class=header><div class=tx-ellipsis translate="Open IFC Model"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=body><spinner ng-show=vm.loading></spinner><div class=no-data ng-show="!vm.models || !vm.models.length" translate="No model found"></div><div class="flex-wrap flex-around"><div class="bim-card contentWrapper" ng-repeat="model in vm.models track by $index" ng-click="vm.selectedIndex = $index"><div class=card-header><img ng-src="{{ model.thumbnail ? model.thumbnail:\'/assets/images/cgviewer/textures/texture-11.jpg\' }}" class=object-fit-cover onerror="this.src=\'/assets/images/cgviewer/textures/texture-11.jpg\'"></div><div class=card-content><h3 ng-bind=model.name class=tx-ellipsis></h3><div class=row><div class=col-5><span class=title translate="Published on"></span></div><div class=col-7><span class=value ng-bind="model.createdAt | smartDateTime"></span></div></div><div class="row mb-0"><div class=col-5><span class=title translate=Size></span></div><div class=col-7><span class=value>{{model.displaySize}}{{model.displaySizeUnit}}</span></div></div></div><div class=card-overlay ng-if="vm.selectedIndex === $index"><img class=mark src=/assets/icons/mark-active.svg alt=mark></div></div><div class="virtual-card contentWrapper" ng-repeat="x in [].constructor(vm.numLacks) track by $index"></div></div></div><div class=footer><button class="btn_white mr-5" ng-click=onCancel() translate=Cancel></button> <button class=btn_new_blue ng-click=onOk() translate=Ok></button></div></div>');
$templateCache.put('app/main/cgviewer/modals/openVpModal/openVpModal.view.html','<div id=open-vp-modal><div class=header><div class=tx-ellipsis translate="Open Visual Planner"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=body><spinner ng-show=vm.loading></spinner><div class=no-data ng-show="!vm.plans || !vm.plans.length" translate="No plan found"></div><div class="flex-wrap flex-around"><div class="bim-card contentWrapper" ng-repeat="plan in vm.plans track by $index" ng-click="vm.selectedIndex = $index"><div class=card-header><img ng-src="{{ plan.assetObj.url? plan.assetObj.url : \'/assets/images/cgviewer/textures/texture-11.jpg\' }}" class=object-fit-cover onerror="this.src=\'/assets/images/cgviewer/textures/texture-11.jpg\'"></div><div class=card-content><h3 ng-bind=plan.assetObj.title class=tx-ellipsis></h3><div class=row><div class=col-5><span class=title translate="Published on"></span></div><div class=col-7><span class=value ng-bind="plan.createdAt | smartDateTime"></span></div></div><div class="row mb-0"><div class=col-5><span class=title translate=Size></span></div><div class=col-7><span class=value>{{plan.displaySize}}{{plan.displaySizeUnit}}</span></div></div></div><div class=card-overlay ng-if="vm.selectedIndex === $index"><img class=mark src=/assets/icons/mark-active.svg alt=mark></div></div><div class="virtual-card contentWrapper" ng-repeat="x in [].constructor(vm.numLacks) track by $index"></div></div></div><div class=footer><button class="btn_white mr-5" ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onOk() translate=Ok></button></div></div>');
$templateCache.put('app/main/cgviewer/modals/planModal/planModal.view.html','<div id=planModal><div class=content><canvas id=viewer class=no-zoom></canvas><spinner id=spinner need-mask=true></spinner></div><div class=side><div class=title-header><div class=title translate="Extract Plan"></div><div class="ml-auto mr-10" ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons class=cursor-point></div></div><div class="side-item d-flex"><span class=subtitle translate="Render Mode"></span><div class="d-flex ml-auto mr-auto"><label class="toggle d-flex mr-15" ng-model=vm.renderMode uib-btn-radio="\'normal\'" ng-click=vm.selectRenderMode()><div class="circle mr-10"><div class=circle-kernel></div></div><div class=radio-label translate=Normal></div></label> <label class="toggle d-flex ml-10" ng-model=vm.renderMode uib-btn-radio="\'inventory\'" ng-click=vm.selectRenderMode()><div class="circle mr-10"><div class=circle-kernel></div></div><div class=radio-label translate=Material></div></label></div></div><div class=side-item><span translate=Size></span><selectbox class=mt-10 ng-model=vm.pageSize options=vm.pageSizes label-field=label value-field=id select-event=vm.selectPageSize()></selectbox></div><div class=side-item><span class=subtitle translate="Add More"></span><div class="d-flex mt-10"><selectbox-input class=flex-1 ng-model=vm.floor options=vm.floors label-field=name value-field=guid placeholder="Enter levels"></selectbox-input><div class="btn_new_blue ml-10" ng-click=vm.addFloor() translate=Add></div></div><div class="floor-list mt-10"><div class="floor-item ml-10" ng-repeat="floor in vm.addedFloors track by $index"><span>{{ getLetter(floor) }}</span> <img src=/assets/icons/close-24-blue.svg class=cursor-point ng-click=vm.removeFloor($index)></div></div></div><div class="side-item d-flex mt-auto"><button class="btn_new_blue client_gray_back ml-auto" ng-click=onCancel() translate=Cancel></button> <button class="btn_new_blue ml-20" ng-click=onExport() translate=Export></button></div></div></div>');
$templateCache.put('app/main/cgviewer/modals/selectLevelModal/selectLevelModal.view.html','<div id=selectLevelModal><div class=title-black><div class=m-auto translate="Select Level"></div><div class=mr-10 ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons class=cursor-point></div></div><div class=content><selectbox class="arrowbottom_46_400 item" ng-model=vm.workLevel options=workLevels label-field=name value-field=name placeholder="Select Level"></selectbox><div class=btnGroup><button class=btn_white ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSelect() translate=Confirm ng-disabled=!vm.workLevel></button></div></div></div>');
$templateCache.put('app/main/cgviewer/modals/semiPlanModal/semiPlanModal.view.html','<div id=semiPlanModal><div class=content><div id=viewer class=no-zoom></div><spinner id=spinner need-mask=true></spinner></div><div class=side><div class=title-header><div class=title translate="Extract Drawings"></div><div class="ml-auto mr-10" ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons class=cursor-point></div></div><div class="side-item d-flex"><span class=subtitle translate="Render Mode"></span><div class="d-flex ml-auto mr-auto"><label class="toggle d-flex mr-15" ng-model=vm.renderMode uib-btn-radio="\'normal\'" ng-click=vm.selectRenderMode()><div class="circle mr-10"><div class=circle-kernel></div></div><div class=radio-label translate=Normal></div></label> <label class="toggle d-flex ml-10" ng-model=vm.renderMode uib-btn-radio="\'inventory\'" ng-click=vm.selectRenderMode()><div class="circle mr-10"><div class=circle-kernel></div></div><div class=radio-label translate=Material></div></label></div></div><div class=side-item><span class=subtitle translate="Project Name"></span><div class="login_input_new mt-10">{{vm.project.projectName}}</div></div><div class=side-item><span translate=Size></span><selectbox class=mt-10 ng-model=vm.pageSize options=vm.pageSizes label-field=label value-field=id select-event=vm.selectPageSize()></selectbox></div><div class=side-item><span class=subtitle translate="Add More"></span><div class="d-flex mt-10"><selectbox-input class=flex-1 ng-model=vm.floor options=vm.floors label-field=name value-field=guid placeholder="Enter levels"></selectbox-input><div class="btn_new_blue ml-10" ng-click=vm.addFloor() translate=Add></div></div><div class="floor-list mt-10"><div class="floor-item ml-10" ng-repeat="floor in vm.addedFloors track by $index"><span>{{ getLetter(floor) }}</span> <img src=/assets/icons/close-24-blue.svg class=cursor-point ng-click=vm.removeFloor($index)></div></div></div><div class=side-item><span class=subtitle translate="Sections Name"></span> <input class="mt-10 login_input_new" ng-model=vm.name placeholder="Please enter name"></div><div class=side-item><span class=subtitle translate=Description></span> <textarea class=mt-10 placeholder="Write some description (optional)" ng-model=vm.description></textarea></div><div class="side-item d-flex mt-auto"><button class="btn_new_blue client_gray_back ml-auto" ng-click=onCancel() translate=Cancel></button> <button class="btn_new_blue ml-20" ng-click=onExport() translate=Export></button></div></div></div>');
$templateCache.put('app/main/cgviewer/modals/uploadModelModal/uploadModelModal.view.html','<div id=uploadModelModal><div class=header><span class=tx-ellipsis translate="Upload IFC Model"></span><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><div><div><div class="section-title required" translate="Select IFC Model"></div><div class="d-flex flex-column" ngf-drop ng-model=vm.bimFile ngf-change="vm.bimFileUpdated($files, $event)" name=file ngf-pattern="\'.ifc,.IFC\'" ngf-multiple=false ngf-accept="\'.ifc,.IFC\'"><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> <span translate="Drag and Drop or"></span> <span class="ft-blue-back ph-5" ngf-select ng-model=vm.bimFile ngf-change="vm.bimFileUpdated($files, $event)" name=file ngf-pattern="\'.ifc,.IFC\'" ngf-multiple=false ngf-accept="\'.ifc,.IFC\'" translate=Browse></span> <span translate="to Upload"></span></div></div><div class="file mt-10" ng-if=vm.bimFile title={{vm.bimFile.name}}>{{vm.bimFile.name}}</div></div><div><div class=section-title translate="Select Preview Image"></div><div class="d-flex flex-column" ngf-drop ng-model=vm.thumbnail ngf-change="vm.thumbFileUpdated($files, $event)" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=false ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> <span translate="Drag and Drop or"></span> <span class="ft-blue-back ph-5" ngf-select ng-model=vm.thumbnail ngf-change="vm.thumbFileUpdated($files, $event)" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=false ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" translate=Browse></span> <span translate="to Upload"></span></div></div></div><div class="d-flex mt-10"><img id=thumbnail-img class="ml-auto mr-auto" alt=""></div><div class=mt-10><div class=section-title translate=Description></div><textarea class=w-100 placeholder="Write some description (optional)" ng-model=vm.description></textarea></div><div class="w-100 mt-10"><div id=gmap class="google-map no-zoom"></div></div><div id=progress-wrp style="display: none;"><div class=progressbar></div><div class=status>0%</div></div></div></div><div class=footer><button class="gray ml-auto mr-10" ng-click=onCancel() translate=Cancel></button> <button class=btn-blue ng-click=vm.upload() translate=Upload></button></div></div>');
$templateCache.put('app/main/cgviewer/modals/uploadPcdModal/uploadPcdModal.view.html','<div id=uploadPcdModal><div class=header><span class=tx-ellipsis translate="Upload PCD file"></span><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><div><div><div class="section-title required" translate="Select PCD file"></div><div class="d-flex flex-column" ngf-drop ng-model=vm.bimFile ngf-change="vm.bimFileUpdated($files, $event)" name=file ngf-pattern="\'.pcd,.PCD\'" ngf-multiple=false ngf-accept="\'.pcd,.PCD\'"><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> <span translate="Drag and Drop or"></span> <span class="ft-blue-back ph-5" ngf-select ng-model=vm.bimFile ngf-change="vm.bimFileUpdated($files, $event)" name=file ngf-pattern="\'.pcd,.PCD\'" ngf-multiple=false ngf-accept="\'.pcd,.PCD\'" translate=Browse></span> <span translate="to Upload"></span></div></div><div class="file mt-10" ng-if=vm.bimFile title={{vm.bimFile.name}}>{{vm.bimFile.name}}</div></div><div><div class=section-title translate="Select Preview Image"></div><div class="d-flex flex-column" ngf-drop ng-model=vm.thumbnail ngf-change="vm.thumbFileUpdated($files, $event)" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=false ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> <span translate="Drag and Drop or"></span> <span class="ft-blue-back ph-5" ngf-select ng-model=vm.thumbnail ngf-change="vm.thumbFileUpdated($files, $event)" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=false ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" translate=Browse></span> <span translate="to Upload"></span></div></div></div><div class="d-flex mt-10"><img id=thumbnail-img class="ml-auto mr-auto" alt=""></div><div class=mt-10><div class=section-title translate=Description></div><textarea class=w-100 placeholder="Write some description (optional)" ng-model=vm.description></textarea></div><div class="w-100 mt-10"><div id=gmap class="google-map no-zoom"></div></div><div id=progress-wrp style="display: none;"><div class=progressbar></div><div class=status>0%</div></div></div></div><div class=footer><button class="btn_new_blue client_gray_back ml-auto mr-10" ng-click=onCancel() translate=Cancel></button> <button class=btn_new_blue ng-click=vm.upload() translate=Upload></button></div></div>');
$templateCache.put('app/main/cgviewer/modals/uploadPhotoModal/uploadPhotoModal.view.html','<div id=uploadPhotoModal><div class=header><span class=tx-ellipsis translate="Upload 360 Degree Photo File"></span><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><div><div><div class="section-title required" translate=Name></div><input type=text class="form-control mt-0 w-100" placeholder="Please input name" ng-model=vm.name></div><div class=mt-10><div class="section-title required" translate="Select 360 Degree Photo file"></div><div class="d-flex flex-column" ngf-drop ng-model=vm.photoFile ngf-change="vm.photoFileUpdated($files, $event)" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=false ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> <span translate="Drag and Drop or"></span> <span class="ft-blue-back ph-5" ngf-select ng-model=vm.photoFile ngf-change="vm.photoFileUpdated($files, $event)" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=false ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" translate=Browse></span> <span translate="to Upload"></span></div></div></div><div class="d-flex mt-10"><img id=photo-img class="ml-auto mr-auto" alt=""></div><div><div class=section-title translate="Select Preview Image"></div><div class="d-flex flex-column" ngf-drop ng-model=vm.thumbnail ngf-change="vm.thumbFileUpdated($files, $event)" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=false ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> <span translate="Drag and Drop or"></span> <span class="ft-blue-back ph-5" ngf-select ng-model=vm.thumbnail ngf-change="vm.thumbFileUpdated($files, $event)" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=false ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" translate=Browse></span> <span translate="to Upload"></span></div></div></div><div class="d-flex mt-10"><img id=thumbnail-img class="ml-auto mr-auto" alt=""></div><div class=mt-10><div class=section-title translate=Description></div><textarea class=w-100 placeholder="Write some description (optional)" ng-model=vm.description></textarea></div><div class="w-100 mt-10"><div id=gmap class="google-map no-zoom"></div></div><div id=progress-wrp style="display: none;"><div class=progressbar></div><div class=status>0%</div></div></div></div><div class=footer><button class="btn_new_blue client_gray_back ml-auto mr-10" ng-click=onCancel() translate=Cancel></button> <button class=btn_new_blue ng-click=vm.upload() translate=Upload></button></div></div>');
$templateCache.put('app/main/cgviewer/modals/wallModal/wallModal.view.html','<div id=vp-wall-modal><div class=header id=object-properties-header><div class=title translate="Wall Properties"></div><img src=/assets/images/cgviewer/property/close-white.svg ng-click=vm.onClose()></div><div class=content><div class=scale-area><div class=object-name translate="Please enter height"></div><div class=mt-10><input type=text ng-model=vm.height class=scale-value number-edit=2></div></div><div class="scale-area mt-10"><div class=object-name translate=Unit></div><div class=mt-10><object-dropdown ng-model=vm.unit options=units label-field=label value-field=value></object-dropdown></div></div></div><div class=footer><div class=buttons><button class="object-button cancel mr-10" ng-click=vm.onClose() translate=Cancel></button> <button class="object-button confirm" ng-click=vm.onConfirm() translate=Confirm></button></div></div></div>');
$templateCache.put('app/main/cgviewer/pcd/pcdDetail/pcdDetail.view.html','<!-- loading --><div id=initial_loading_popup><img src=/assets/images/cgviewer/cloud_loading.gif></div><div id=pcd><div id=pointCloud></div><div class="button-group d-flex"><div class="button mr-10 cursor-point" ng-click=vm.gotoHome() title=Home><div class=circle><img src=/assets/icons/home.svg></div></div><!-- <div class="button mr-10 cursor-point" title="Open"\n         ngf-select\n         ngf-change="vm.pcdFileUpdated($file, $event)"\n         name="file"\n         ngf-pattern="\'.pcd,.PCD\'"\n         ngf-multiple="false"\n         ngf-accept="\'.pcd,.PCD\'">\n      <div class="circle">\n        <img src="/assets/icons/ic_file_open.png">\n      </div>\n    </div> --><div class="header-logo flex-center"><img src=/assets/images/dashboard/Cloudes_Logo.svg alt=logo><div>CloudES</div></div></div></div>');
$templateCache.put('app/main/cgviewer/pcd/pcdGenerate/pcdGenerate.view.html','<div id=pcdGenerate><div id=pointCloud></div><div class="button-group d-flex"><div class="button mr-10 cursor-point" ng-click=vm.gotoHome() title=Home><div class=circle><img src=/assets/icons/home.svg></div></div><div class="button mr-10 cursor-point" title=Left ngf-select ngf-change="vm.pcdFileUpdatedDepth($file, $event)" name=file ngf-multiple=false><div class=circle><img src=/assets/icons/ic_file_open.png></div></div><div class="button cursor-point" title=Right ngf-select ngf-change="vm.pcdFileUpdatedColor($file, $event)" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=false ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><div class=circle><img src=/assets/icons/ic_file_open.png></div></div></div></div>');
$templateCache.put('app/main/cgviewer/pcd/pcdGrid/pcdGrid.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=pcdGrid class=main-container><spinner ng-show=isLoading></spinner><div class="main-container client-container"><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=vpGrid class="ft-normal-12-16 grey-2" translate="Point Cloud"></a></div><div class=ft_24_600_black1 translate="Point Cloud"></div></div><button class="btn_new_blue ml-16" ng-click=vm.openDlgUpload() ng-if="PCD_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Add PCD"></span></button></div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount > 0"><div class="card-based-content-grid-wrapper pr-24 pv-24"><div class="content-grid-wrapper flex flex-wrap mt-40 mh-min15"><div ng-repeat="pcd in pcds" class=pcds-container><div class=bim-card><div class=card-header><img ng-src="{{ pcd.thumbnail?pcd.thumbnail:\'/assets/images/cgviewer/pcd/pcd-default.png\' }}" class=object-fit-cover onerror="this.src=\'/assets/images/cgviewer/pcd/pcd-default.png\'"></div><div class=card-content><h3 ng-bind=pcd.name class=tx-ellipsis></h3><div class=row><div class=col-5><span class=title translate="Published on"></span></div><div class=col-7><span class=value ng-bind="pcd.createdAt | smartDateTime"></span></div></div><div class=row><div class=col-5><span class=title translate=Size></span></div><div class=col-7><span class=value>{{pcd.displaySize}}{{pcd.displaySizeUnit}}</span></div></div><div class="row mb-0"><div class=col-5><span class=title translate=Type></span></div><div class=col-7><span class=value>{{pcd.type}}</span></div></div></div><div class="card-footer text-center"><a class=link-detail ng-click=goToDetail(pcd._id) translate="View Details"></a> <a class=link-trash href=javascript:; ng-click=deletePointCloud(pcd._id)><i class="fa fa-trash"></i></a></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + pcds.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllPCDs()></pagination-custom-new></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/cgviewer/photo/photoDetail/photoDetail.view.html','<!-- loading --><div id=initial_loading_popup><img src=/assets/images/cgviewer/cloud_loading.gif></div><div id=pcd><div id=panorama></div><div class="button-group d-flex"><div class="button mr-10 cursor-point" ng-click=vm.gotoHome() title=Home><div class=circle><img src=/assets/icons/home.svg></div></div><!-- <div class="button mr-10 cursor-point" title="Open"\n         ngf-select\n         ngf-change="vm.pcdFileUpdated($file, $event)"\n         name="file"\n         ngf-pattern="\'.pcd,.PCD\'"\n         ngf-multiple="false"\n         ngf-accept="\'.pcd,.PCD\'">\n      <div class="circle">\n        <img src="/assets/icons/ic_file_open.png">\n      </div>\n    </div> --><div class="header-logo flex-center"><img src=/assets/images/dashboard/Cloudes_Logo.svg alt=logo><div>CloudES</div></div></div></div>');
$templateCache.put('app/main/cgviewer/photo/photoGrid/photoGrid.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=photoGrid class=main-container><spinner ng-show=isLoading></spinner><div class="main-container client-container"><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=vpGrid class="ft-normal-12-16 grey-2" translate="360 Degree Photo"></a></div><div class=ft_24_600_black1 translate="360 Degree Photo"></div></div><button class="btn_new_blue ml-16" ng-click=vm.openDlgUpload() ng-if="PHOTO_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Add Photo"></span></button></div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount > 0"><div class="card-based-content-grid-wrapper pr-24 pv-24"><div class="content-grid-wrapper flex flex-wrap mt-40 mh-min15"><div ng-repeat="photo in photos" class=photos-container><div class=bim-card><div class=card-header><img ng-src="{{ photo.thumbnail?photo.thumbnail:\'/assets/images/cgviewer/photo/photo-default.png\' }}" class=object-fit-cover onerror="this.src=\'/assets/images/cgviewer/photo/photo-default.png\'"></div><div class=card-content><h3 ng-bind=photo.name class=tx-ellipsis></h3><div class=row><div class=col-5><span class=title translate="Published on"></span></div><div class=col-7><span class=value ng-bind="photo.createdAt | smartDateTime"></span></div></div><div class=row><div class=col-5><span class=title translate=Size></span></div><div class=col-7><span class=value>{{photo.displaySize}}{{photo.displaySizeUnit}}</span></div></div><div class="row mb-0"><div class=col-5><span class=title translate=Type></span></div><div class=col-7><span class=value>{{photo.type}}</span></div></div></div><div class="card-footer text-center"><a class=link-detail ng-click=goToDetail(photo._id) translate="View Details"></a> <a class=link-trash href=javascript:; ng-click=deletePhoto(photo._id)><i class="fa fa-trash"></i></a></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + pcds.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllPhotos()></pagination-custom-new></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/cgviewer/vp/vpDetail/vpDetail.view.html','<div id=vp-detail><div class=detail-content ng-hide=!modelClosed><!-- viewer --><vp-detail-page ng-repeat="page in vm.pages" page=page ng-style="{\'visibility\': page===vm.curPage ? \'visible\' : \'hidden\'}"></vp-detail-page><!-- tool box --><toolbox on-selected=vm.curPage.toolbarEvent data=toolbarList></toolbox><div class=control-bar><div class=mode-bar-button ng-click=vm.curPage.rotateLeft()><img src=/assets/icons/rotate-left.svg></div><div class=mode-bar-button ng-click=vm.curPage.rotateRight()><img src=/assets/icons/rotate-right.svg></div><div class=mode-bar-button ng-click=vm.curPage.flipHorizontal()><img src=/assets/icons/flip-h.svg></div><div class=mode-bar-button ng-click=vm.curPage.flipVertical()><img src=/assets/icons/flip-v.svg></div></div><!-- status bar --><div id=statusbar class=status-bar-container><div class="zoom-bar d-flex align-items-center"><div class=slidecontainer><img src=/assets/icons/undo.svg alt="left-right icon" class="mr-2 cursor-point" ng-click=vm.curPage.undo()> <img src=/assets/icons/redo.svg alt="left-right icon" class="mr-10 cursor-point" ng-click=vm.curPage.redo()> <input type=range min=50 max=1000 value=100 class=slider id=zoom-range ng-change=vm.curPage.zoomSlider(vm.curPage.zoomLevel) ng-model=vm.curPage.zoomLevel> <span class=zoomRangeTxt>{{vm.curPage.zoomLevel}} %</span></div></div><div class=status-bar><div class=status-bar-item><span class=mr-2>X:</span> <span>{{vm.curPage.statusData.pos.x | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2>Y:</span> <span>{{vm.curPage.statusData.pos.y | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2>Z:</span> <span>{{vm.curPage.statusData.pos.z | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2>Area:</span> <span>{{vm.curPage.statusData.info.area | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2>Width:</span> <span>{{vm.curPage.statusData.info.width | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2>{{vm.curPage.statusData.isWall ? \'Length\' : \'Height\'}}:</span> <span>{{vm.curPage.statusData.info.height | readable: 2}}</span></div><div class=status-bar-item ng-if=vm.curPage.statusData.isWall><span class=mr-2>Height:</span> <span>{{vm.curPage.statusData.info.wallHeight | readable: 2}}</span></div><div class=status-bar-item><span class=mr-2>Unit:</span> <select id=type ng-change=vm.curPage.onChangeUnit() ng-model=vm.curPage.unit class=unit-area style="border: none;"><option value=m>m</option><option value=cm>cm</option><option value=mm>mm</option><option value=inch>inch</option></select></div></div><div class=extra-bar></div></div><!-- side menu --><nav side-menu id=side_menu class=cg-side-menu><a href="" id=menuToggle class=menu-toggle><div id=arrow></div></a><div id=container><!-- Object Properties --><vp-object-properties ng-object=vm.curPage.objectPropertyInfo change-unit=vm.onChangePropertyUnit input-method=vm.companyData.companyInputMethod scale-times=vm.propertyScale on-change-wall=vm.curPage.changeWall></vp-object-properties><!--  Equipment / Materials  --><div ng-show="materials.material && materials.material.length"><vp-equipment-materials ng-materials=materials.material></vp-equipment-materials></div><!-- Layers --><drawing-layers levels=vm.curPage.viewer.levels ng-factory=vm.curPage.levelFactory></drawing-layers><!-- Text Properties--><text-properties ng-properties=vm.curPage.textBrush ng-text-change=vm.curPage.changeTextInfo ng-change-fill-color=vm.curPage.onChangeTextFillColor ng-change-stroke-color=vm.curPage.onChangeTextStrokeColor></text-properties><!-- Line Properties --><line-properties ng-properties=vm.curPage.brush ng-change-dash-type=vm.curPage.onChangeDashType ng-change-dash-space=vm.curPage.onChangeDashSpace ng-change-thickness=vm.curPage.onChangeThickness ng-change-stroke-color=vm.curPage.onChangeStrokeColor ng-input-method=vm.companyData.companyInputMethod></line-properties><!-- Materials --><drawing-materials ng-selectcolor=vm.curPage.setColor ng-selecttexture=vm.curPage.setTexture cp-color=vm.curPage.viewer.color></drawing-materials></div></nav><!-- loading screen --><div id=vp_initial_loading_popup><img src=/assets/images/cgviewer/cloud_vp_loading.gif alt=loading></div><!-- context menu --><div id=context_menu_2d class=opacity-popup-background><span class=context-menu-close ng-click=vm.curPage.closeContextMenu()>&times</span><div id=context_menu_copy class=context-menu-item ng-click=vm.curPage.copy()>Copy</div><div id=context_menu_cut class=context-menu-item ng-click=vm.curPage.cut()>Cut</div><div id=context_menu_paste class=context-menu-item ng-click=vm.curPage.paste()>Paste</div><div id=context_menu_apply_negative class=context-menu-item ng-click=vm.curPage.applyNegative()>Negative area</div></div><!--property indicator--><vp-property-indicator id=vp-property-indicator vp-object=vm.curPage.indicator.vpObject pos=vm.curPage.indicator.pos unit=vm.curPage.unit viewer=vm.curPage.viewer materials=vm.materials combo-materials=vm.comboMaterials equipments=vm.equipments combo-equipments=vm.comboEquipments work-level=vm.curPage.workLevel work-types=vm.workTypes sections=vm.sections on-assigned=vm.curPage.inventoryAssigned()></vp-property-indicator></div><vp-model ng-if=vm.curPage.bimModel ng-hide=modelClosed ng-model=vm.curPage.bimModel ng-vp-id=vm.planId ng-vp=vm.curPage.viewer ng-match=vm.curPage.matchData></vp-model><!-- titlebar --><div id=title_bar class=title-bar><div class=menu-collapse-button ng-click=vm.optionMenu.toggle()><img src=/assets/icons/bars.svg></div><div class=title ng-repeat="page in vm.pages" ng-class="{active: vm.curPage === page}" ng-click="vm.curPage = page">{{ page.title }} <img src=/assets/icons/close-24-white.svg class="close-btn ml-20" ng-click="vm.closePage(page, $index)"></div><div class=plus ng-click=vm.openPage()><img src=/assets/icons/plus-white.svg alt=""></div><div class=right-menu><div class="menu-compare-button mr-16" ng-click=vm.collisionMenu.toggle()><img src=/assets/icons/compare-white.svg alt=collision>Collision</div><div class="menu-compare-button mr-16" ng-click=vm.issueMenu.toggle()><img src=/assets/icons/alarm4.svg alt=issues>Issues</div><div class="menu-compare-button mr-8" ng-click=vm.registrationMenu.toggle()><img src=/assets/icons/alarm4.svg alt=registrations>Registrations</div><ul class="nav navbar-top-links navbar-right"><li class=dropdown><a class=dropdown-toggle data-toggle=dropdown href=#><div>View</div><img src=/assets/icons/dropdown-white.svg></a><ul class="dropdown-menu dropdown-alerts"><li><a ng-click=gotoHome()><img src=/assets/icons/home.svg class="mr-10 dropdown-icon">Home</a></li><li class=divider></li><li><a ng-click=save()><img src=/assets/icons/save-line.svg class="mr-10 dropdown-icon">Save</a></li><li><a ng-click=gotoCalc()><img src=/assets/icons/cg-calc.png class="mr-10 dropdown-icon">Calculation</a></li><li><a ng-click=exportPdf()><img src=/assets/icons/printer3.svg class="mr-10 dropdown-icon">Export PDF</a></li></ul></li></ul></div></div><!-- option menu --><div class=option-menu><div class=option-menu-bar><div class=option-menu-buttons ng-show=vm.optionMenu.isShow><div class=menu-button ng-click="vm.optionMenu.main.toggle(\'model\')"><img src=/assets/icons/model.svg alt=model></div><div class=menu-button ng-click="vm.optionMenu.main.toggle(\'setting\')"><img src=/assets/icons/settings-black.svg alt=settings></div><div class=menu-button ng-click="vm.optionMenu.main.toggle(\'help\')"><img src=/assets/icons/help.svg alt=help></div></div></div><div id=menu-model class=option-menu-box ng-if="vm.optionMenu.main.isShow(\'model\')"><div class=menu-box-content><div class="menu-model-item divider-bt"><img class=item-img src=/assets/icons/model.svg> <span class=item-title>{{vm.curPage.bimModel ? vm.curPage.bimModel.name : \'3D Model\'}}</span> <img src=/assets/icons/plus-gray.svg class="ml-auto item-action" ng-click=vm.addModel() ng-hide=vm.curPage.bimModel> <img src=/assets/icons/eye.svg class="ml-auto item-action" ng-click=vm.showModel() ng-show="vm.curPage.bimModel && modelClosed"> <img src=/assets/icons/model-plan-black.svg class="ml-auto item-action" ng-click=vm.closeModel() ng-show="vm.curPage.bimModel && !modelClosed"> <img src=/assets/icons/file-icon5.svg class="ml-10 item-action" ng-click=vm.deleteModel() ng-show=vm.curPage.bimModel></div></div></div><div class=option-menu-box ng-show="vm.optionMenu.main.isShow(\'setting\')"><vp-settings on-change-color-mode=vm.curPage.colorModeChanged></vp-settings></div><div class=option-menu-box ng-show="vm.optionMenu.main.isShow(\'help\')"><div class=menu-box-content><div class=optional-section><div class="ft_12_600_gray mb-8" translate=Title></div><input class=w-100 ng-model=vm.curPage.title></div><div class=optional-section><div class="ft_12_600_gray mb-8" translate=Level></div><selectbox-input class=select-level ng-model=vm.curPage.workLevel options=vm.workLevels label-field=tagName value-field=tagName></selectbox-input></div></div></div><div class=space ng-click=vm.optionMenu.close()></div></div><!-- compare menu --><div class=compare-space ng-if="vm.issueMenu.isShow || vm.registrationMenu.isShow" ng-click="vm.issueMenu.close(); vm.registrationMenu.close();"></div><!-- Collision Check --><vp-collision ng-if=vm.curPage.planId is-show=vm.collisionMenu.isShow vp-page=vm.curPage plan-id=vm.curPage.planId original-view=vm.curPage.viewer1 collision-view=vm.curPage.viewer2></vp-collision><issue-menu is-vp=true is-show=vm.issueMenu.isShow model-id=vm.curPage.planId></issue-menu><registration-menu is-vp=true is-show=vm.registrationMenu.isShow model-id=vm.curPage.planId></registration-menu></div>');
$templateCache.put('app/main/cgviewer/vp/vpDetailPage/vpDetailPage.view.html','<div class=vp-detail-page><div id=vp-viewer class=vp-viewer></div><div id=collision ng-show=vm.collision></div></div>');
$templateCache.put('app/main/cgviewer/vp/vpGrid/vpGrid.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=vpGrid class=main-container><spinner ng-show=isLoading></spinner><div class="main-container client-container"><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=vpGrid class="ft-normal-12-16 grey-2" translate=VP></a></div><div class=ft_24_600_black1 translate=Drawings></div></div><searchbox class=ml-auto search-text=vm.searchText search-event=searchCallback() is-small=true></searchbox><button class="button-primary ml-16" ng-click=addNewPlan() ng-if="VP_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons class=mr-2><span translate="Add New Plan"></span></button></div><no-data ng-if="totalCount==0 && isLoading==false"></no-data><div ng-if="totalCount!=0 && isLoading==false"><div class="card-based-content-grid-wrapper pr-24 pv-24"><div class="content-grid-wrapper flex flex-wrap mt-40 mh-min15"><div ng-repeat="plan in plans" class=plans-container><div class=vp-card><div class=card-header><img class=object-fit-cover onerror="this.src=\'/assets/images/cgviewer/textures/texture-11.jpg\'" ng-src="{{ plan.assetObj.url?plan.assetObj.url:\'/assets/images/cgviewer/textures/texture-11.jpg\' }}"></div><div class=card-content><h3 ng-bind=plan.assetObj.title class=tx-ellipsis></h3><div class=flex-between><div><span class=value ng-bind="plan.createdAt | smartDateTime"></span></div><div><span class=title translate=Size></span>:&nbsp; <span class=value>{{plan.displaySize | readable: 1}}{{plan.displaySizeUnit}}</span></div></div></div><div class="card-footer text-center"><a class=link-detail ng-click=goToDetail(plan._id) translate="View Details"></a> <img src=/assets/icons/download-blue.svg alt="" class="link-trash mr-20" ng-click=vm.downloadPdf(plan)> <img src=/assets/icons/trash-alt-red.svg alt="" class=link-trash ng-click=deleteProjectRoofPlan(plan._id)></div></div></div></div><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + plans.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchAllPlans()></pagination-custom-new></div></div></div></div></div></div></div></main>');
$templateCache.put('app/main/checkList/modals/createCheckListModal/createCheckListModal.view.html','<div class="checklist-modal common-modal"><div class=header><div class="tx-ellipsis label" translate="Add Check List"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><spinner ng-if=isLoading></spinner><div class=mb-16><label translate=Project></label><selectbox-input ng-model=checkListData.projectId options=vm.projects label-field=projectName value-field=_id></selectbox-input></div><div class=mb-16><label translate="Check List Name"></label> <input type=text ng-model=checkListData.title class=required placeholder="Check List Name"></div><section class=checklist-items-section><div class=section-header><div class=section-tab translate="Check List Items"></div></div><div class=section-body><div class=checklist-item ng-repeat="item in checkListData.checkListItem track by $index"><div class="d-flex align-items-center justify-content-between mb-8"><input type=text ng-model=item.check placeholder=Check> <button ng-click=removeCheckListItem($index)><img src=/assets/icons/close-circle-o-g.svg></button></div><div class="d-flex align-items-center justify-content-between"><input type=text ng-model=item.accept placeholder=Accept> <button ng-click=removeCheckListItem($index)><img src=/assets/icons/close-circle-o-g.svg></button></div></div><button class="btn_new_blue mt-16" ng-click=addCheckListItem()><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Add New Item"></span></button></div></section></div><div class=footer><div class="btnGroup flex"><button class="btn_new_blue mr-16" ng-click=onCreate()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_white_back" ng-click=onCancel()><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div></div>');
$templateCache.put('app/main/checkList/modals/editCheckListModal/editCheckListModal.view.html','<div class="checklist-modal common-modal"><div class=header><div class="tx-ellipsis label" translate="Update Check List"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><spinner ng-if=isLoading></spinner><div class=mb-16><label translate=Project></label><selectbox-input ng-model=checkListData.projectId options=vm.projects label-field=projectName value-field=_id></selectbox-input></div><div class=mb-16><label translate="Check List Name"></label> <input type=text ng-model=checkListData.title class=required placeholder="Check List Name"></div><section class=checklist-items-section><div class=section-header><div class=section-tab translate="Check List Items"></div></div><div class=section-body><div class=checklist-item ng-repeat="item in checkListData.checkListItem track by $index"><div class="d-flex align-items-center justify-content-between mb-8"><input type=text ng-model=item.check placeholder=Check> <button ng-click=removeCheckListItem($index)><img src=/assets/icons/close-circle-o-g.svg></button></div><div class="d-flex align-items-center justify-content-between"><input type=text ng-model=item.accept placeholder=Accept> <button ng-click=removeCheckListItem($index)><img src=/assets/icons/close-circle-o-g.svg></button></div></div><button class="btn_new_blue mt-16" ng-click=addCheckListItem()><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ft-600-12-16 translate="Add New Item"></span></button></div></section></div><div class=footer><div class="btnGroup flex"><button class="btn_new_blue mr-16" ng-click=onUpdate()><img src=/assets/icons/save-icon.svg alt=icons><span translate=Save></span></button> <button class="btn_new_blue client_gray_back mr-16" ng-click=deleteChecklist(checkListData)><img src=/assets/icons/trash-alt-white.svg alt=icons><span translate=Delete></span></button> <button class="btn_new_blue client_gray_white_back" ng-click=onCancel()><img src=/assets/icons/close-circle-black.svg alt=icons><span class=ft-600-12-16 translate=Cancel></span></button></div></div></div>');
$templateCache.put('app/main/collaborations/directives/collaborationFiltersPanel/collaborationFiltersPanel.view.html','<div class="collaboration-filters-panel pos-relative"><spinner ng-if=loading></spinner><div class=search-container><searchbox search-text=searchText place-holder=Search search-event=searchData()></searchbox></div><div class=vendor-container><div class=tabs><div ng-class="{tab: true, active: currentTab === \'Suppliers\'}" ng-click=fetchSuppliers() translate=Suppliers></div><div ng-class="{tab: true, active: currentTab === \'Sub-Contractors\'}" ng-click=fetchSubcontractors() translate=Sub-Contractors></div></div><div class=list><div class=dropdown ng-repeat="vendor in vendorList track by $index"><button class=vendor type=button data-toggle=collapse data-target=#{{vendor._id}}-staffs aria-expanded=false aria-controls={{vendor._id}}-staffs ng-click="vendor.expanded = !vendor.expanded"><div>{{vendor.name}}</div><img ng-src="{{vendor.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}" alt=""></button><div class=collapse id={{vendor._id}}-staffs><div class=vendor-staff ng-repeat="staff in vendor.staffs" vid={{vendor._id}} sid={{staff._id}} draggable=true><img ng-if=staff.subUserId.profilePic class=avatar ng-src={{staff.subUserId.profilePic}} alt=""><div ng-if=!staff.subUserId.profilePic data-letters={{utils.nameLetter(staff.displayName)}} ng-style="{ \'background\': getColor(staff.displayName) }"></div><div class=info><div class=title title={{staff.displayName}}>{{staff.displayName}}</div><div class=desc title={{staff.name}}>{{staff.name}}</div></div><img class=drag-handle ng-init="dragImage = \'/assets/icons/drag_handle-gray.svg\'" ng-mouseover="dragImage = \'/assets/icons/drag_handle.svg\'" ng-mouseleave="dragImage = \'/assets/icons/drag_handle-gray.svg\'" ng-src={{dragImage}} alt="" data-drag=true jqyoui-draggable="{animate: true}"></div></div></div></div></div></div>');
$templateCache.put('app/main/collaborations/directives/collaboration-menu/collaboration-menu.view.html','<div id=collaboration-menu class=nav-items><nav class="navbar navbar-expand-lg navbar-light"><ul class=navbar-nav><li class=nav-item ng-class="{active: currentRoute === \'bid-packages/list\' || currentRoute === \'bid-packages/create\'}"><a href=# ui-sref=bidPackages translate="Bid Packages"></a></li><li class=nav-item ng-class="{active: currentRoute === \'offer-template/list\' || currentRoute === \'bid-packages/create-template\'}"><a href=# ui-sref=offerTemplates translate="Offer Templates"></a></li><li class=nav-item ng-class="{active: currentRoute === \'team/invites\'}"><a href=# ui-sref=collaborationInvites translate=Invites></a></li><li class=nav-item ng-class="{active: currentRoute === \'team/offers\'}"><a href=# ui-sref=collaborationOffers translate="Income Offers"></a></li><li class=nav-item ng-class="{active: currentRoute === \'team/create\'}"><a href=# ui-sref=createTeam translate="Create Team"></a></li><li class=nav-item ng-class="{active: currentRoute === \'team/list\'}"><a href=# ui-sref=collaborationTeam translate="Collaboration Team"></a></li><!-- <li class="nav-item dropdown" ng-class="{active: currentRoute === \'bid-packages\'}">\n        <a class="nav-link ft_14_600_gray" href="#" translate="Bid Packages"></a>\n        <div class="dropdown-menu">\n          <a class="dropdown-item" href="#" ui-sref="createBidOfferTemplate" translate="Create Offer Template"></a>\n          <a class="dropdown-item" href="#" ui-sref="createBidPackage" translate="Setup Bid Package"></a>\n          <a class="dropdown-item" href="#" ui-sref="bidPackages" translate="Bid Packages"></a>\n        </div>\n      </li>\n      <li class="nav-item dropdown" ng-class="{active: currentRoute === \'team\'}">\n        <a class="nav-link ft_14_600_gray" href="#" translate="Team"></a>\n        <div class="dropdown-menu">\n          <a class="dropdown-item" href="#" ui-sref="collaborationInvites" translate="Invites"></a>\n          <a class="dropdown-item" href="#" ui-sref="collaborationOffers" translate="Offers"></a>\n          <a class="dropdown-item" href="#" ui-sref="createTeam" translate="Create Team"></a>\n          <a class="dropdown-item" href="#" ui-sref="collaborationTeam" translate="Team"></a>\n        </div>\n      </li> --></ul></nav></div>');
$templateCache.put('app/main/collaborations/directives/collaborationManagersPanel/collaborationManagersPanel.view.html','<div class="collaboration-managers-panel pos-relative"><spinner ng-if=loading></spinner><div class=search-container><searchbox search-text=searchText place-holder=Search search-event=searchData()></searchbox></div><div class="vendor-container managers"><div class="p-2 font-weight-bold text-align-center mb-2" translate="Managers for team creating"></div><div class=list><div class=vendor-staff ng-repeat="manager in managers" mid={{manager._id}} draggable=true><img class=drag-handle ng-init="dragImage = \'/assets/icons/drag_handle-gray.svg\'" ng-mouseover="dragImage = \'/assets/icons/drag_handle.svg\'" ng-mouseleave="dragImage = \'/assets/icons/drag_handle-gray.svg\'" ng-src={{dragImage}} alt="" data-drag=true jqyoui-draggable="{animate: true}"> <img ng-if=manager.userId.profilePic class=avatar ng-src={{manager.userId.profilePic}} alt=""><div ng-if=!manager.userId.profilePic data-letters={{utils.nameLetter(manager.userId.displayName)}}></div><div class=info><div class=title title={{manager.userId.displayName}}>{{manager.userId.displayName}}</div><div class=desc title={{manager.userId.name}}>{{manager.userId.name}}</div></div></div></div></div><div class="vendor-container suppliers"><div class="p-2 font-weight-bold text-align-center mb-2" translate="Add Member"></div><div class="list text-center"><selectbox-input class=mt-16 ng-model=isolatedBindingUserType options=isolatedBindingUserTypes label-field=name value-field=id></selectbox-input><selectbox-input place-holder="Start typing a name" class=mt-16 ng-model=isolatedBindingUserId options=isolatedBindingUserList label-field=displayName value-field=_id></selectbox-input><button class="btn btn-black btn-add mt-16" ng-click=isolatedExpressionFunc() translate=Add></button></div></div></div>');
$templateCache.put('app/main/collaborations/directives/collaborationTeamPanel/collaborationTeamPanel.view.html','<div class="collaboration-team-panel pos-relative"><spinner ng-if=loading></spinner><div class=search-container><searchbox search-text=searchText place-holder=Search search-event=searchData()></searchbox></div><div class=vendor-container><div class=tabs><div ng-class="{tab: true, active: currentTab === \'Managers\'}" ng-click="onClickTab(\'Managers\')">Managers</div><div ng-class="{tab: true, active: currentTab === \'Suppliers\'}" ng-click="onClickTab(\'Suppliers\')">Suppliers</div><div ng-class="{tab: true, active: currentTab === \'Subcontractors\'}" ng-click="onClickTab(\'Subcontractors\')">Sub-contractors</div></div><div class=list><div class=vendor-staff ng-repeat="manager in managers" mid={{manager._id}} draggable=true ng-if="currentTab == \'Managers\'"><img class=drag-handle ng-init="dragImage = \'/assets/icons/drag_handle-gray.svg\'" ng-mouseover="dragImage = \'/assets/icons/drag_handle.svg\'" ng-mouseleave="dragImage = \'/assets/icons/drag_handle-gray.svg\'" ng-src={{dragImage}} alt="" data-drag=true jqyoui-draggable="{animate: true}"> <img ng-if=manager.userId.profilePic class="avatar ml-10" ng-src={{manager.userId.profilePic}} alt=""><div ng-if=!manager.userId.profilePic class=ml-10 data-letters={{utils.nameLetter(manager.userId.displayName)}}></div><div class="info ml-10"><div class=title title={{manager.userId.displayName}}>{{manager.userId.displayName}}</div><div class=desc title={{manager.userId.name}}>{{manager.userId.name}}</div></div></div><div class=dropdown ng-repeat="vendor in suppliers track by $index" ng-if="currentTab == \'Suppliers\'"><button class=vendor type=button data-toggle=collapse data-target=#{{vendor._id}}-staffs aria-expanded=false aria-controls={{vendor._id}}-staffs ng-click="vendor.expanded = !vendor.expanded"><div>{{vendor.name}}</div><img ng-src="{{vendor.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}" alt=""></button><div class=collapse id={{vendor._id}}-staffs><div class=vendor-staff ng-repeat="staff in vendor.staffs" vid={{vendor._id}} sid={{staff._id}} draggable=true><img class=drag-handle ng-init="dragImage = \'/assets/icons/drag_handle-gray.svg\'" ng-mouseover="dragImage = \'/assets/icons/drag_handle.svg\'" ng-mouseleave="dragImage = \'/assets/icons/drag_handle-gray.svg\'" ng-src={{dragImage}} alt="" data-drag=true jqyoui-draggable="{animate: true}"> <img ng-if=staff.subUserId.profilePic class="avatar ml-10" ng-src={{staff.subUserId.profilePic}} alt=""><div ng-if=!staff.subUserId.profilePic class=ml-10 data-letters={{utils.nameLetter(staff.displayName)}} ng-style="{ \'background\': getColor(staff.displayName) }"></div><div class="info ml-10"><div class=title title={{staff.displayName}}>{{staff.displayName}}</div><div class=desc title={{staff.name}}>{{staff.name}}</div></div></div></div></div><div class=dropdown ng-repeat="vendor in subcontractors track by $index" ng-if="currentTab == \'Subcontractors\'"><button class=vendor type=button data-toggle=collapse data-target=#{{vendor._id}}-staffs aria-expanded=false aria-controls={{vendor._id}}-staffs ng-click="vendor.expanded = !vendor.expanded"><div>{{vendor.name}}</div><img ng-src="{{vendor.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}" alt=""></button><div class=collapse id={{vendor._id}}-staffs><div class=vendor-staff ng-repeat="staff in vendor.staffs" vid={{vendor._id}} sid={{staff._id}} draggable=true><img class=drag-handle ng-init="dragImage = \'/assets/icons/drag_handle-gray.svg\'" ng-mouseover="dragImage = \'/assets/icons/drag_handle.svg\'" ng-mouseleave="dragImage = \'/assets/icons/drag_handle-gray.svg\'" ng-src={{dragImage}} alt="" data-drag=true jqyoui-draggable="{animate: true}"> <img ng-if=staff.subUserId.profilePic class="avatar ml-10" ng-src={{staff.subUserId.profilePic}} alt=""><div ng-if=!staff.subUserId.profilePic class=ml-10 data-letters={{utils.nameLetter(staff.displayName)}} ng-style="{ \'background\': getColor(staff.displayName) }"></div><div class="info ml-10"><div class=title title={{staff.displayName}}>{{staff.displayName}}</div><div class=desc title={{staff.name}}>{{staff.name}}</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/collaborations/directives/membersTree/membersTree.view.html','<div class=members-org-tree><spinner ng-if=loading></spinner><div class=btn-export ng-click=onExportPdf()>+ Export as PDF</div><div class=btn-refresh ng-click=onRefresh()><img src=/assets/icons/orgchart_refresh.svg></div><div class=btn-zoom><img class=cursor-pointer ng-click=onZoomIn() src=/assets/icons/orgchart_zoom_in.svg><div class=btn-divider></div><img class=cursor-pointer ng-click=onZoomOut() src=/assets/icons/orgchart_zoom_out.svg></div><div id=members-tree class=no-zoom></div></div>');
$templateCache.put('app/main/collaborations/modals/addCollaborationMemberModal/addCollaborationMemberModal.view.html','<div id=add-collaboration-member-modal><div class=header><div class=tx-ellipsis translate="Add members"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=search-option-group><div class=search-option><radio ng-model=currentDesignation ng-value="\'Manager\'"></radio><div class=label translate=Manager></div></div><div class=search-option><radio ng-model=currentDesignation ng-value="\'Subcontractor\'"></radio><div class=label translate=Subcontractor></div></div><div class=search-option><radio ng-model=currentDesignation ng-value="\'Supplier\'"></radio><div class=label translate=Supplier></div></div><div class=search-option><radio ng-model=currentDesignation ng-value="\'Staff\'"></radio><div class=label translate=Client></div></div></div><div class=search-and-add><autocomplete1 input-class=fm-search-input ng-model=vm.selectedUserId label-field=displayName value-field=_id options=vm.users no-margin-right=true no-flex=true place-holder="Start typing a name"></autocomplete1><button class=btn_primary ng-click=onAdd()><img src=/assets/icons/plus.svg alt=plus><span translate=Add></span></button></div><div class=content-body><div class=assigned-member ng-repeat="member in assignedMembers track by $index"><div class=member-info><div ng-if=member.parent><img ng-if=member.parent.profilePic class="user-avatar object-fit-cover" ng-src={{member.parent.profilePic}} alt=""><div ng-if=!member.parent.profilePic data-letters="{{vm.utils.nameLetter(member.parent.name || member.parent.firstName)}}"></div></div><div ng-if=!member.parent><img ng-if=member.profilePic class="user-avatar object-fit-cover" ng-src={{member.profilePic}} alt=""><div ng-if=!member.profilePic data-letters="{{vm.utils.nameLetter(member.firstName, member.lastName)}}"></div></div><div><div class=ft_12_regular_gray>{{member.displayName}}</div><div class=ft_10_regular_gray>{{member.designation}}</div></div></div><img class=cursor-point src=/assets/icons/close-16.svg alt=remove ng-click=onDelete($index)></div></div><div class=footer><button class=btn_white ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSubmit() translate=Ok></button></div></div></div>');
$templateCache.put('app/main/collaborations/modals/addTeamMemberModal/addTeamMemberModal.view.html','<div id=add-team-member-modal><div class=header><div class=tx-ellipsis translate="Add members"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=search-option-group><div class=search-option><radio ng-model=currentDesignation ng-value="\'Manager\'"></radio><div class=label translate=Manager></div></div><div class="search-option mr-3"><radio ng-model=currentDesignation ng-value="\'Subcontractor\'"></radio><div class=label translate=Subcontractor></div></div><div class=search-option><radio ng-model=currentDesignation ng-value="\'Supplier\'"></radio><div class=label translate=Supplier></div></div><div class=search-option><radio ng-model=currentDesignation ng-value="\'Guest\'"></radio><div class=label translate=Guest></div></div></div><div class=search-and-add><autocomplete1 ng-if="currentDesignation !== \'Guest\'" input-class=fm-search-input ng-model=vm.selectedUserId label-field=displayName value-field=_id options=vm.users no-margin-right=true no-flex=true place-holder="Start typing a name"></autocomplete1><input ng-if="currentDesignation === \'Guest\'" type=email class=fm-search-input ng-model=vm.guestEmail placeholder="Start typing an email" ng-pattern=EMAIL_REGEX required> <button class=btn_primary ng-click=onAdd()><img src=/assets/icons/plus.svg alt=plus><span translate=Add></span></button></div><div ng-if="currentDesignation === \'Subcontractor\' || currentDesignation === \'Supplier\'"><div class=mb-16><label for=department class=ft_12_500_gray translate=Department></label><selectbox-input id=department options=vm.departments label-field=name value-field=name ng-model=vm.department></selectbox-input></div><div class=mb-16><label for=designation class=ft_12_500_gray translate=Designation></label> <input id=designation type=text ng-model=vm.designation placeholder=designation></div></div><div class=content-body><div class=assigned-member ng-repeat="member in assignedMembers track by $index"><div ng-if="member.type !== \'Guest\'" class="left flex-items-center"><img ng-if=member.userId.profilePic class="user-avatar object-fit-cover" ng-src={{member.userId.profilePic}} alt=""><div ng-if=!member.userId.profilePic data-letters="{{vm.utils.nameLetter(member.userId.firstName, member.userId.lastName)}}"></div><div><div class=ft_12_regular_gray>{{member.userId.displayName}}</div><div class=ft_10_regular_gray>{{member.userId.designation}}</div></div></div><div ng-if="member.type === \'Guest\'" class="left flex-items-center"><div class=ft_12_regular_gray>{{member.email}}</div></div><div class="right flex-items-center flex-between"><div class=member-type>{{member.type}}</div><img ng-if="member.type === \'Member\'" class=cursor-point src=/assets/icons/close-16.svg alt=remove ng-click="onDelete($index, member.userId, false)"> <img ng-if="member.type === \'Guest\'" class=cursor-point src=/assets/icons/close-16.svg alt=remove ng-click="onDelete($index, member.email, true)"></div></div></div><div class=footer><button class=btn_white ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSubmit() translate=Ok></button></div></div></div>');
$templateCache.put('app/main/collaborations/modals/createOfferFilterModal/createOfferFilterModal.view.html','<div id=saveEventModal12><spinner ng-show=loading></spinner><div class=title><div class=tx-ellipsis translate=Filter></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div class="flex flex-row flex-items-center addFilterContainer"><img src=/assets/icons/search_dark.svg alt=icons> <input type=text class="login_input_new_no_mt w-100" placeholder="Add Filter" ng-model=filterText ng-keypress=onEnter($event)></div><div class="flex flex-row flex-wrap mt-20" ng-show="models.length > 0"><div class=checklist-item ng-repeat="(key,item) in models"><span>{{ item }}</span> <img class="cursor-point ml-3" src=/assets/icons/close-24.svg ng-click=removeFilter(key)></div></div><!-- <div class="flex flex-row flex-end flex-content-end filterModalFooter">\n      <button class="btn_new_blue mr-16" ng-click="onSubmit()">\n        <img src="/assets/icons/save-icon.svg" alt="icons"/><span translate="Save"></span>\n      </button>\n      <button class="btn_new_blue client_gray_white_back" ng-click="onCancel()">\n        <img src="/assets/icons/trash-alt-client.svg" alt="icons"/><span class="ft-600-12-16" translate="Cancel"></span>\n      </button>\n    </div> --></div></div>');
$templateCache.put('app/main/collaborations/modals/createTeamModal/createTeamModal.view.html','<div id=createTeamModal><div class=title><div class=tx-ellipsis translate="Create Team"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div class=mb-20><div class="ft_12_600_gray mb-8 required" translate="Team Name"></div><input type=text placeholder="Enter the team name" ng-model=vm.team.name autofocus></div><div class=mb-20><div class="ft_12_600_gray mb-8" translate=Description></div><textarea class=w-100 placeholder="Write some description (optional)" ng-model=vm.team.description></textarea></div><div class="flex-items-center flex-content-end mt-20"><button class="gray mr-4" ng-click=onCancel() translate=Cancel></button> <button class=yellow ng-click=onCreate() translate=Create></button></div></div></div>');
$templateCache.put('app/main/collaborations/modals/editTeamMemberModal/editTeamMemberModal.view.html','<div id=edit-team-member-modal><div class=header><div class=tx-ellipsis translate="Input a file name to export"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><div class="ft_12_500_gray mb-2" translate=Designation></div><input type=text ng-model=vm.member.designation placeholder=Designation autofocus><div class="ft_12_500_gray mb-2 mt-4" translate=Description></div><input type=text ng-model=vm.member.description placeholder=Description autofocus></div><div class=footer><button class="btn_white mr-3" ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/main/collaborations/modals/importFromBIMModal/importFromBIMModal.view.html','<div id=import-from-bim-modal class=common-modal><div class=header><div class=tx-ellipsis>Import Levels from BIM</div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class="content pos-relative"><spinner ng-if=loading></spinner><div class="flex flex-wrap mt-40 mh-min15"><div ng-repeat="model in models"><div class="bim-card contentWrapper"><div class=card-header><img ng-src="{{ model.thumbnail?model.thumbnail:\'/assets/images/cgviewer/textures/texture-11.jpg\' }}" class=object-fit-cover onerror="this.src=\'/assets/images/cgviewer/textures/texture-11.jpg\'"></div><div class=card-content><h3 ng-bind=model.name class=tx-ellipsis></h3><div class=row><div class=col-5><span class=title translate="Published on"></span></div><div class=col-7><span class=value ng-bind="model.createdAt | smartDateTime"></span></div></div><div class="row mb-0"><div class=col-5><span class=title translate=Size></span></div><div class=col-7><span class=value>{{model.displaySize | readable: 1}}{{model.displaySizeUnit}}</span></div></div></div><div class="card-footer text-center"><a class=link-detail ng-click=onImport(model._id) translate="Import From this Model"></a></div></div></div><div ng-show="models.length == 0 && loading != true" class="flex-1 text-center"><span class=noBimText translate="No BIM Model"></span></div></div></div><div class=footer><button class="btn btn-light mr-16" ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/main/collaborations/modals/inviteCollaboratorsModal/inviteCollaboratorsModal.view.html','<div id=invite-collaborators-modal class=common-modal><div class=header><div class=tx-ellipsis>Invite Collaborators</div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class="content pos-relative"><spinner ng-if=isLoading></spinner><div class=mb-24><div class="ft_14_600_black mb-2">Select Sub-contractor / Supplier</div><selectbox-input place-holder="Select the company name" ng-model=selectedVendorId options=vm.vendors label-field=name value-field=_id on-change=changeVendor()></selectbox-input></div><div class=mb-16><div class="ft_14_600_black mb-2">Select co-ordinator</div><div class="d-flex justify-content-between"><selectbox-input place-holder="Enter name or email" ng-model=selectedCoordinatorId options=vm.vendorStaffs label-field=displayName value-field=_id style="width: calc(100% - 84px)"></selectbox-input><button class="btn btn-yellow" style="width: 60px" ng-click=addCoordinator() translate=Add></button></div></div><div class=members><div class=member ng-repeat="coordinator in vm.coordinators track by $index"><div class=d-flex><img ng-if=coordinator.profilePic ng-src={{coordinator.profilePic}} alt="" class=profile-pic><div ng-if=!coordinator.profilePic data-letters={{utils.nameLetter(coordinator.displayName)}}></div><div class=member-info><div class=d-flex><div class=display-name>{{coordinator.displayName}}</div><div ng-if=coordinator.isInvited class=accept-status-badge>ALREADY INVITED</div></div><div class=email>{{coordinator.email}}</div></div></div><img ng-if=coordinator.isInvited src=/assets/icons/check-light.svg alt="" class=checkmark-circle ng-click=removeCoordinator($index)> <img ng-if=!coordinator.isInvited src=/assets/icons/check.svg alt="" class=checkmark-circle ng-click=removeCoordinator($index)></div></div></div><div class=footer><button class="btn btn-light mr-16" ng-click=onCancel() translate=Cancel></button> <button class="btn btn-yellow" ng-click=onInvite() translate=Invite></button></div></div>');
$templateCache.put('app/main/collaborations/modals/inviteStaffModal/inviteStaffModal.view.html','<div id=invite-staff-modal class=common-modal><div class=header><div class=tx-ellipsis>Invite Staffs</div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class="content pos-relative"><spinner ng-if=loading></spinner><div class=members><div class=member ng-repeat="staff in vm.staffs track by $index"><div class=d-flex><img ng-if=staff.profilePic ng-src={{staff.profilePic}} alt="" class=profile-pic><div ng-if=!staff.profilePic data-letters={{utils.nameLetter(staff.displayName)}}></div><div class=member-info><div class=d-flex><div class=display-name>{{staff.displayName}}</div><div ng-if="staff.inviteStatus === \'Accepted\'" class=accept-status-badge>ALREADY INVITED</div></div><div class=email>{{staff.email}}</div></div></div><img class=checkmark-circle alt="" ng-src="{{staff.inviteStatus === \'Accepted\' ? \'/assets/icons/check-mark-green.svg\' : staff.selected ? \'/assets/icons/check.svg\' : \'/assets/icons/check-light.svg\'}}" ng-click=selectStaff(staff)></div></div></div><div class=footer><button class="btn btn-light mr-16" ng-click=onCancel() translate=Cancel></button> <button class="btn btn-yellow" ng-click=onInvite() translate=Invite></button></div></div>');
$templateCache.put('app/main/collaborations/modals/rename-team-modal/rename-team-modal.view.html','<div id=rename-team-modal tabindex=-1 role=dialog data-keyboard=true><div class=header><div class=tx-ellipsis translate=Rename></div><div class=close-icon ng-click=cancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class="ft_12_500_gray mb-2" translate=name></div><input class=name-input ng-model=vm.team.name></div><div class=footer><button class="btn_white mr-3" ng-click=cancel() translate=Cancel></button> <button class=btn_primary ng-click=rename() translate=Ok></button></div></div>');
$templateCache.put('app/main/collaborations/modals/selectBIMLevelModal/selectBIMLevelModal.view.html','<div id=select-bim-level-modal class=common-modal><div class=header><div class=tx-ellipsis>Import Levels from BIM</div><searchbox class="ml-auto bp-searchbox" search-text=searchText search-event=searchLevels()></searchbox><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><script id=modelTreeRenderer.html type=text/ng-template><div class="flex mb-4 align-items-center" ng-show="isShow(data)">\n      <label class="check_blue_20" style="margin-bottom: 20px !important">\n        <input type="checkbox" ng-model="data.checked" ng-click="changeFlag(data.children, !data.checked)" />\n        <span class="checkmark"></span>\n      </label>\n      <div class="accept-label">{{ data.type }} (<span class="small">Name: {{data.name}}, GUID: {{data.guid}}</span>)</div>\n      <img class="ml-16"\n        ng-if="data.children.length > 0"\n        ng-src="{{!data.closed ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}"\n        ng-click="data.closed = !data.closed"\n        alt="">\n    </div>\n    <div class="pl-5" ng-if="data.children.length > 0" ng-show="!data.closed">\n      <ng-include\n        onload="data = child"\n        ng-repeat="child in data.children"\n        src="\'modelTreeRenderer.html\'"\n      ></ng-include>\n    </p></script><div class="content pos-relative"><div class="flex mb-4 align-items-center"><label class=check_blue_20 style="margin-bottom: 20px !important"><input type=checkbox ng-model=tree.checked ng-click="changeFlag(tree.children, !tree.checked)"> <span class=checkmark></span></label><div class=accept-label>{{ tree.type }} (<span class=small>Name: {{tree.name}}, GUID: {{tree.guid}}</span>)</div><img class=ml-16 ng-if="tree.children.length > 0" ng-src="{{!tree.closed ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}" ng-click="tree.closed = !tree.closed" alt=""></div><div class=pl-5 ng-if="tree.children.length > 0" ng-show=!tree.closed><ng-include ng-repeat="child in tree.children" src="\'modelTreeRenderer.html\'" onload="data = child"></ng-include></div></div><div class=footer><button class="btn btn-light mr-16" ng-click=onCancel() translate=Cancel></button> <button class="btn btn-primary mr-16" ng-click=onImport() translate=Import></button></div></div>');
$templateCache.put('app/main/collaborations/modals/setApprovalModal/setApprovalModal.view.html','<div id=set-approval-modal><div class=header><div class=tx-ellipsis>Set Approval</div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><!-- Drawing --><div class=panel><uib-accordion close-others=false><div uib-accordion-group class=panel-default is-open=openStatus.drawing><uib-accordion-heading ng-class="{\'br-4\': !openStatus.drawing}"><span translate="Responsible For Drawing"></span> <img src=/assets/icons/chevron-right-gray.svg alt="" ng-if=!openStatus.drawing> <img src=/assets/icons/chevron-down-gray.svg alt="" ng-if=openStatus.drawing></uib-accordion-heading><div class=mb-16><div class=partner-type-label translate=Sub-Contractor></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedDrawingSubcontractorStaff options=vm.availableDrawingSubcontractorStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'Drawing\', \'Subcontractor\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Supplier></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedDrawingSupplierStaff options=vm.availableDrawingSupplierStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'Drawing\', \'Supplier\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Client></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableDrawingClientStaffs label-field=displayName value-field=_id ng-model=vm.selectedDrawingClientStaff></selectbox-input><button class=add ng-click="addMember(\'Drawing\', \'Client\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Manager></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableDrawingManagers label-field=displayName value-field=_id ng-model=vm.selectedDrawingManager></selectbox-input><button class=add ng-click="addMember(\'Drawing\', \'Manager\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=members><div class=member ng-repeat="member in vm.assignedDrawingMembers track by $index"><img ng-if=member.profilePic class=member ng-src={{member.profilePic}} alt="" ng-style="{left: $index * 50 + \'px\'}" title={{member.displayName}}><div ng-if=!member.profilePic class="member no-image" ng-style="{left: $index * 50 + \'px\'}" ng-bind="vm.utils.nameLetter(member.firstName, member.lastName)" title={{member.displayName}}></div><img class=remove-member src=/assets/icons/close-gray-circle-with-border.svg ng-style="{left: $index * 50 + 30 + \'px\', zIndex: 10}" ng-click="removeMember(\'Drawing\', member.designation, $index)"></div></div></div></uib-accordion></div><!-- Report --><div class=panel><uib-accordion close-others=false><div uib-accordion-group class=panel-default is-open=openStatus.report><uib-accordion-heading ng-class="{\'br-4\': !openStatus.report}"><span translate="Responsible For Report"></span> <img src=/assets/icons/chevron-right-gray.svg alt="" ng-if=!openStatus.report> <img src=/assets/icons/chevron-down-gray.svg alt="" ng-if=openStatus.report></uib-accordion-heading><div class=mb-16><div class=partner-type-label translate=Sub-Contractor></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedReportSubcontractorStaff options=vm.availableReportSubcontractorStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'Report\', \'Subcontractor\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Supplier></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedReportSupplierStaff options=vm.availableReportSupplierStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'Report\', \'Supplier\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Client></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableReportClientStaffs label-field=displayName value-field=_id ng-model=vm.selectedReportClientStaff></selectbox-input><button class=add ng-click="addMember(\'Report\', \'Client\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Manager></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableReportManagers label-field=displayName value-field=_id ng-model=vm.selectedReportManager></selectbox-input><button class=add ng-click="addMember(\'Report\', \'Manager\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=members><div class=member ng-repeat="member in vm.assignedReportMembers track by $index"><img ng-if=member.profilePic class=member ng-src={{member.profilePic}} alt="" ng-style="{left: $index * 50 + \'px\'}" title={{member.displayName}}><div ng-if=!member.profilePic class="member no-image" ng-style="{left: $index * 50 + \'px\'}" ng-bind="vm.utils.nameLetter(member.firstName, member.lastName)" title={{member.displayName}}></div><img class=remove-member src=/assets/icons/close-gray-circle-with-border.svg ng-style="{left: $index * 50 + 30 + \'px\', zIndex: 10}" ng-click="removeMember(\'Report\', member.designation, $index)"></div></div></div></uib-accordion></div><!-- Issue --><div class=panel><uib-accordion close-others=false><div uib-accordion-group class=panel-default is-open=openStatus.issue><uib-accordion-heading ng-class="{\'br-4\': !openStatus.issue}"><span translate="Responsible For Issue"></span> <img src=/assets/icons/chevron-right-gray.svg alt="" ng-if=!openStatus.issue> <img src=/assets/icons/chevron-down-gray.svg alt="" ng-if=openStatus.issue></uib-accordion-heading><div class=mb-16><div class=partner-type-label translate=Sub-Contractor></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedIssueSubcontractorStaff options=vm.availableIssueSubcontractorStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'Issue\', \'Subcontractor\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Supplier></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedIssueSupplierStaff options=vm.availableIssueSupplierStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'Issue\', \'Supplier\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Client></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableIssueClientStaffs label-field=displayName value-field=_id ng-model=vm.selectedIssueClientStaff></selectbox-input><button class=add ng-click="addMember(\'Issue\', \'Client\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Manager></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableIssueManagers label-field=displayName value-field=_id ng-model=vm.selectedIssueManager></selectbox-input><button class=add ng-click="addMember(\'Issue\', \'Manager\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=members><div class=member ng-repeat="member in vm.assignedIssueMembers track by $index"><img ng-if=member.profilePic class=member ng-src={{member.profilePic}} alt="" ng-style="{left: $index * 50 + \'px\'}" title={{member.displayName}}><div ng-if=!member.profilePic class="member no-image" ng-style="{left: $index * 50 + \'px\'}" ng-bind="vm.utils.nameLetter(member.firstName, member.lastName)" title={{member.displayName}}></div><img class=remove-member src=/assets/icons/close-gray-circle-with-border.svg ng-style="{left: $index * 50 + 30 + \'px\', zIndex: 10}" ng-click="removeMember(\'Issue\', member.designation, $index)"></div></div></div></uib-accordion></div><!-- VA Order --><div class=panel><uib-accordion close-others=false><div uib-accordion-group class=panel-default is-open=openStatus.vaOrder><uib-accordion-heading ng-class="{\'br-4\': !openStatus.vaOrder}"><span translate="Responsible For VA Order"></span> <img src=/assets/icons/chevron-right-gray.svg alt="" ng-if=!openStatus.vaOrder> <img src=/assets/icons/chevron-down-gray.svg alt="" ng-if=openStatus.vaOrder></uib-accordion-heading><div class=mb-16><div class=partner-type-label translate=Sub-Contractor></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedVAOrderSubcontractorStaff options=vm.availableVAOrderSubcontractorStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'VA Order\', \'Subcontractor\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Supplier></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedVAOrderSupplierStaff options=vm.availableVAOrderSupplierStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'VA Order\', \'Supplier\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Client></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableVAOrderClientStaffs label-field=displayName value-field=_id ng-model=vm.selectedVAOrderClientStaff></selectbox-input><button class=add ng-click="addMember(\'VA Order\', \'Client\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Manager></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableVAOrderManagers label-field=displayName value-field=_id ng-model=vm.selectedVAOrderManager></selectbox-input><button class=add ng-click="addMember(\'VA Order\', \'Manager\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=members><div class=member ng-repeat="member in vm.assignedVAOrderMembers track by $index"><img ng-if=member.profilePic class=member ng-src={{member.profilePic}} alt="" ng-style="{left: $index * 50 + \'px\'}" title={{member.displayName}}><div ng-if=!member.profilePic class="member no-image" ng-style="{left: $index * 50 + \'px\'}" ng-bind="vm.utils.nameLetter(member.firstName, member.lastName)" title={{member.displayName}}></div><img class=remove-member src=/assets/icons/close-gray-circle-with-border.svg ng-style="{left: $index * 50 + 30 + \'px\', zIndex: 10}" ng-click="removeMember(\'VA Order\', member.designation, $index)"></div></div></div></uib-accordion></div><!-- Invoice --><div class=panel><uib-accordion close-others=false><div uib-accordion-group class=panel-default is-open=openStatus.invoice><uib-accordion-heading ng-class="{\'br-4\': !openStatus.invoice}"><span translate="Responsible For Invoice"></span> <img src=/assets/icons/chevron-right-gray.svg alt="" ng-if=!openStatus.invoice> <img src=/assets/icons/chevron-down-gray.svg alt="" ng-if=openStatus.invoice></uib-accordion-heading><div class=mb-16><div class=partner-type-label translate=Sub-Contractor></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedInvoiceSubcontractorStaff options=vm.availableInvoiceSubcontractorStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'Invoice\', \'Subcontractor\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Supplier></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedInvoiceSupplierStaff options=vm.availableInvoiceSupplierStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'Invoice\', \'Supplier\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Client></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableInvoiceClientStaffs label-field=displayName value-field=_id ng-model=vm.selectedInvoiceClientStaff></selectbox-input><button class=add ng-click="addMember(\'Invoice\', \'Client\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Manager></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableInvoiceManagers label-field=displayName value-field=_id ng-model=vm.selectedInvoiceManager></selectbox-input><button class=add ng-click="addMember(\'Invoice\', \'Manager\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=members><div class=member ng-repeat="member in vm.assignedInvoiceMembers track by $index"><img ng-if=member.profilePic class=member ng-src={{member.profilePic}} alt="" ng-style="{left: $index * 50 + \'px\'}" title={{member.displayName}}><div ng-if=!member.profilePic class="member no-image" ng-style="{left: $index * 50 + \'px\'}" ng-bind="vm.utils.nameLetter(member.firstName, member.lastName)" title={{member.displayName}}></div><img class=remove-member src=/assets/icons/close-gray-circle-with-border.svg ng-style="{left: $index * 50 + 30 + \'px\', zIndex: 10}" ng-click="removeMember(\'Invoice\', member.designation, $index)"></div></div></div></uib-accordion></div><!-- Bill --><div class=panel><uib-accordion close-others=false><div uib-accordion-group class=panel-default is-open=openStatus.bill><uib-accordion-heading ng-class="{\'br-4\': !openStatus.bill}"><span translate="Responsible For Bill"></span> <img src=/assets/icons/chevron-right-gray.svg alt="" ng-if=!openStatus.bill> <img src=/assets/icons/chevron-down-gray.svg alt="" ng-if=openStatus.bill></uib-accordion-heading><div class=mb-16><div class=partner-type-label translate=Sub-Contractor></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedBillSubcontractorStaff options=vm.availableBillSubcontractorStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'Bill\', \'Subcontractor\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Supplier></div><div class=flex-items-center><selectbox-input class=partner-select ng-model=vm.selectedBillSupplierStaff options=vm.availableBillSupplierStaffs label-field=displayName value-field=_id></selectbox-input><button class=add ng-click="addMember(\'Bill\', \'Supplier\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Client></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableBillClientStaffs label-field=displayName value-field=_id ng-model=vm.selectedBillClientStaff></selectbox-input><button class=add ng-click="addMember(\'Bill\', \'Client\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=mb-16><div class=partner-type-label translate=Manager></div><div class=flex-items-center><selectbox-input class=partner-select options=vm.availableBillManagers label-field=displayName value-field=_id ng-model=vm.selectedBillManager></selectbox-input><button class=add ng-click="addMember(\'Bill\', \'Manager\')"><img src=/assets/icons/plus.svg alt=""></button></div></div><div class=members><div class=member ng-repeat="member in vm.assignedBillMembers track by $index"><img ng-if=member.profilePic class=member ng-src={{member.profilePic}} alt="" ng-style="{left: $index * 50 + \'px\'}" title={{member.displayName}}><div ng-if=!member.profilePic class="member no-image" ng-style="{left: $index * 50 + \'px\'}" ng-bind="vm.utils.nameLetter(member.firstName, member.lastName)" title={{member.displayName}}></div><img class=remove-member src=/assets/icons/close-gray-circle-with-border.svg ng-style="{left: $index * 50 + 30 + \'px\', zIndex: 10}" ng-click="removeMember(\'Bill\', member.designation, $index)"></div></div></div></uib-accordion></div><div class=footer><button class=btn-light ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSubmit() translate=Ok></button></div></div></div>');
$templateCache.put('app/main/collaborations/modals/team-comment-reply-modal/team-comment-reply-modal.view.html','<div id=team-comment-reply-modal><div class=title><div class=tx-ellipsis translate="Reply comment"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><spinner ng-show=loading></spinner><div class=content><div class=mb-20><div class="ft_12_600_gray mb-8" translate="Reply comments"></div><textarea class=w-100 placeholder="Write your comments here" ng-model=commentData.comment></textarea></div><div class="flex mv-10"><img src=/assets/icons/attachment.svg alt="" class="mr-10 cursor-point"> <img src=/assets/icons/icon-@.svg alt="" class=cursor-point ngf-select="" ngf-change=onChangeFiles($files) aria-invalid=false data-wow-delay=0.7s></div><div class="carousel-inner1 row"><div class=carousel-item1 ng-repeat="file in commentData.files track by $index"><a class=image_close_btn><img src=/assets/images/materials/close_yellow.svg alt=icons ng-click=removeFile($index)></a><div class=attach-thumbnail><img ng-show=file.isImage ng-src={{file.imageURL}} class=attach-thumbnail alt=""></div><div class="text-center f_name mb-15">{{file.file.name}}</div></div></div></div><div class=footer><button class="yellow mr-15" ng-click=postComment() translate=Post></button> <button class=gray ng-click=onCancel() translate=Discard></button></div></div>');
$templateCache.put('app/main/collaborations/modals/upload-offer-modal/upload-offer-modal.view.html','<div id=upload-offer-modal><div class=header><div class=tx-ellipsis translate="Upload Offer"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=mb-16><label for=amount translate=Amount></label> <input id=amount type=text number-edit=2 ng-model=vm.amount autofocus></div><div class="d-flex flex-column" ngf-drop ngf-change=changeFile($files) name=file ngf-multiple=false><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> <span translate="Drag and Drop or"></span> <span class="ft-yellow ph-5" ngf-select ngf-change=changeFile($files) name=file ngf-multiple=false translate=Browse></span> <span translate="to Upload"></span></div></div><div ng-if=vm.uploadFile class="ft_14_regular_gray py-1">{{vm.uploadFile.name}}</div></div><div class=footer><button class="btn_primary mr-3" ng-click=onSubmit() translate=Save></button> <button class=btn_white ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-activity-block/dashboard-activity-block.view.html','<div class=dashboard-activity-block><div class=loading ng-if=loading><img src=/assets/icons/spinner.gif alt=icons></div><div class=block-header><div class=block-title translate="Recent Activities"></div><div class=action-button ui-sref=activities translate="View All"></div></div><div class=bodyScroll><div class=activity-item-container ng-repeat="item in activities track by $index"><div class=activity-item-icon ng-class=getType($index)><img ng-src={{getIcon($index)}} alt=icon></div><div class=activity-item-wrapper><div class="activity-item cursor-point" ng-click=goToDetail(item)><div class=activity-log title={{item.description}}>{{item.description}}</div><div class="ft_12_regular_black date">{{item.created | date: "dd-MM-yyyy" : \'UTC\'}} \u2022 {{item.created | smartTime }}</div></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-audit-bill-block/dashboard-audit-bill-block.view.html','<div id=dashboard-audit-bill-block class=ev-2><div class=block-header><div class="block-title mr-auto" translate=Bills></div><selectbox class="select-view-mode mr-16 w-175" ng-if="companyBills || creditBills" ng-model=category options=categories label-field=label value-field=_id select-event=changeCategory(category)></selectbox><selectbox class=select-view-mode ng-model=viewMode options=viewModes label-field=label value-field=id></selectbox><div class="btn-grey ml-16" ng-click=requestApproval() translate="Request Approval"></div><div class="action-button ml-16 cursor-point" ui-sref=billList translate="View All"></div></div><div class=table><div class=table-header><div class="cell check"><label class=check_yellow_20><input type=checkbox ng-model=isCheckAll ng-click=checkAll(filteredList)> <span class=checkmark></span></label></div><div class="cell bill-no" translate="Bill No"></div><div class="cell project-no" translate="Project Name"></div><div class="cell vendor" translate="Vendor Name"></div><div class="cell approver" translate="Approved by"></div><div class="cell status" translate=Status></div><div class="cell due-date" translate="Due Date"></div><div class="cell amount" translate="Total Amount"></div><div class="cell balance" translate="Balance Amount"></div></div><div class=table-body><div class=table-row ng-repeat="bill in filteredList = (billList | filter: getFilter())"><div class="cell check"><label class=check_yellow_20><input type=checkbox ng-model=bill.checked ng-click="checkBill(bill, filteredList)"> <span class=checkmark></span></label></div><div class="cell bill-no">{{bill.billNo}}</div><div class="cell project-no">{{bill.projectId.projectName}}</div><div class="cell vendor">{{bill.vendor.displayName || bill.vendor.name || bill.vendor.clientName}}</div><div class="cell approver">{{bill.approver.displayName}}</div><div class="cell status"><div class=mark ng-class=bill.status></div>{{bill.status == \'init\' ? \'draft\' : bill.status | capitalize}}</div><div class="cell due-date">{{bill.dueDate | smartDate}}</div><div class="cell amount">{{currency}} {{bill.amountWithoutTax | readable: 0}}</div><div class="cell balance">{{currency}} {{bill.balance | readable: 0}}</div></div></div><div class=table-footer><div class="cell sum">SUM</div><div class="cell amount">{{currency}} {{getTotalAmount(filteredList) | readable: 0}}</div><div class="cell balance">{{currency}} {{getTotalBalance(filteredList) | readable: 0}}</div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-audit-cashflow-block/dashboard-audit-cashflow-block.view.html','<div id=dashboard-audit-cashflow-block><finance-cashflow class=audit-cashflow graphdata=ngModel need-render=!isLoading start-date=startDate end-date=endDate></finance-cashflow><div class=total-part><div class=total-item><div class=block-title translate="Total Receivables"></div><div class="flex-between mt-16"><span class=unpaid-label translate="Total Unpaid"></span> <span class=unpaid-value>{{currency}} {{totalUnpaidInvoices | readable: 2}}</span></div><div class="progress-container mt-8"><div class="progress blue" ng-style="getProgress(\'invoice\')"></div></div><div class="prices d-flex mt-16"><div class=price-item><div class="item-label green"><span translate="Total Invoice"></span></div><div class=item-value>{{currency}} {{totalInvoices | readable: 2}}</div></div><div class=price-item><div class="item-label red"><span translate=Non-payment></span></div><div class=item-value>{{currency}} {{0 | readable: 2}}</div></div></div></div><div class="total-item mt-auto"><div class=block-title translate="Total Payables"></div><div class="flex-between mt-16"><span class=unpaid-label translate="Total Unpaid"></span> <span class=unpaid-value>{{currency}} {{totalUnpaidBills | readable: 2}}</span></div><div class="progress-container mt-8"><div class="progress orange" ng-style="getProgress(\'bill\')"></div></div><div class="prices d-flex mt-16"><div class=price-item><div class="item-label green"><span translate="Total Bill"></span></div><div class=item-value>{{currency}} {{totalBills | readable: 2}}</div></div><div class=price-item><div class="item-label red"><span translate=Non-payment></span></div><div class=item-value>{{currency}} {{0 | readable: 2}}</div></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-audit-chart-block/dashboard-audit-chart-block.view.html','<div id=dashboard-audit-chart-block><div class="audit-bar-chart-wrapper ev-2"><div class="flex-between align-items-center"><div class=block-title translate="Project Overview"></div><selectbox class=duration ng-model=barPeriod options=periods label-field=name value-field=id select-event=selectBarPeriod(barPeriod)></selectbox></div><div id=bar-chart class="mt-40 no-zoom"></div><div class="mt-24 ml-8 prices"><div class=price-item><div class="arrow-wrapper green"><img src=/assets/icons/arrow-down-green.svg alt=icon></div><div class=ml-16><div class=item-value>{{currency}} {{totalIncome | readable: 2}}</div><div class=item-label translate="Total Income"></div></div></div><div class=price-item><div class="arrow-wrapper red"><img src=/assets/icons/arrow-up-red.svg alt=icon></div><div class=ml-16><div class=item-value>{{currency}} {{totalExpense | readable: 2}}</div><div class=item-label translate="Total Expenses"></div></div></div><div class=price-item><div class="arrow-wrapper blue"><img src=/assets/icons/swap-horiz-blue.svg alt=icon></div><div class=ml-16><div class=item-value>{{currency}} {{totalProfit | readable: 2}}</div><div class=item-label translate=Profit></div></div></div></div></div><div class="audit-pie-chart-wrapper ev-2"><div class="flex-between align-items-center mb-16"><div class=block-title translate="Top Expenses"></div><selectbox class=duration ng-model=piePeriod options=periods label-field=name value-field=id select-event=selectPiePeriod(piePeriod)></selectbox></div><div id=pie-chart class=no-zoom></div><div class=legend><div class=legend-item ng-repeat="legend in pieData"><div class=circle ng-style=getLegendColor(legend)></div><div class=legend-text>{{legend.name}}</div><div class="legend-value ml-auto">{{(legend.value * 100) | readable: 2}}%</div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-audit-cost-block/dashboard-audit-cost-block.view.html','<div id=dashboard-audit-cost-block><div class=block-item ng-repeat="item in costs"><div class=flex-between><div class=block-title translate={{item.name}}></div><div class="track-status green" ng-if="item.overdue == 0">On Track</div><div class="track-status red" ng-if="item.overdue != 0">Off Track</div></div><div class="flex-between mt-24"><span class=budget-label>Budget</span> <span class=budget-value>{{currency}} {{item.budget | readable: 2}}</span></div><div class="progress-container mt-8"><div class=progress ng-style=getProgressStyle(item)></div></div><div class="flex mt-20"><div class=flex-50><div class=current-label translate=Current></div><div class=current-value>{{currency}} {{item.current | readable: 2}}</div></div><div class=flex-50><div class=overdue-label translate={{item.overdueLabel}}></div><div class=overdue-value>{{currency}} {{item.overdue | readable: 2}}</div></div></div></div><div class=block-item><div class="flex align-items-center pos-relative"><div class=block-title translate=Progress></div><div class="circle ml-8"></div></div><div class="flex align-items-center mt-8 pos-relative"><div class=inner-circle></div><div class=dashed-line><svg viewBox="0 0 100 100" preserveAspectRatio=none><path d="M0 0L100 100" stroke=#464646 stroke-width=2 stroke-dasharray="6 6" vector-effect=non-scaling-stroke /></svg></div><div class=delay-item><div class=w-100><div class=delay-label><span translate=Delay></span> %</div><div class=delay-percent>{{(delayPercent * 100) | readable: 0}}%</div></div></div><div class=percent><svg><circle cx=64 cy=64 r=64></circle><circle cx=64 cy=64 r=64 class=progress ng-style=getCircleProgress(currentCostPercent)></circle></svg><div class=number><div><div class=percent-value>{{(currentCostPercent * 100) | readable: 0}}%</div><div class=status>Medium</div></div></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-audit-finanical-block/dashboard-audit-finanical-block.view.html','<div id=dashboard-audit-financial-block class=ev-2><div class=block-header><div class=block-title translate="Financial Key Figures"></div></div><div class=financial-items><div class=financial-item ng-repeat="item in items"><div class=item-name translate={{item.name}}></div><div class="percent mt-8"><svg><defs><linearGradient id=blue-gradient x1=0% y1=0% x2=0% y2=100%><stop offset=0% stop-color=#00aace /><stop offset=100% stop-color=#006bce /></linearGradient><linearGradient id=orange-gradient x1=0% y1=0% x2=0% y2=100%><stop offset=0% stop-color=#ffb84d /><stop offset=100% stop-color=#ff7121 /></linearGradient><linearGradient id=yellow-gradient x1=0% y1=0% x2=0% y2=100%><stop offset=0% stop-color=#f09819 /><stop offset=100% stop-color=#edde5d /></linearGradient><linearGradient id=grey-gradient x1=0% y1=0% x2=0% y2=100%><stop offset=0% stop-color=#797979 /><stop offset=100% stop-color=#444444 /></linearGradient></defs><circle cx=70 cy=70 r=70></circle><circle cx=70 cy=70 r=70 class=progress ng-class=item.color ng-style=getPercentStyle(item) ng-if="item.type === \'percent\'"></circle></svg><div class=number><div><div class=year>{{item.items[0].year}}</div><div class=percent-value ng-class=item.color ng-if="item.type === \'percent\'">{{item.items[0].value}}%</div><div class=percent-value ng-class=item.color ng-if="item.type !== \'percent\'">{{item.items[0].value | readable: 2}}</div><div class=status>{{item.items[0].status}}</div></div></div></div><div class=mt-10><div class=item-row ng-repeat-start="row in item.items track by $index" ng-if="$index==0" class=selected><div class=item-cell>{{row.year}}</div><div class="item-cell ml-1px" ng-if="item.type === \'percent\'">{{row.value}}%</div><div class="item-cell ml-1px" ng-if="item.type !== \'percent\'">{{row.value | readable: 2}}</div></div><div class=item-row ng-repeat-end=row ng-if="$index>0"><div class=item-cell>{{row.year}}</div><div class="item-cell ml-1px" ng-if="item.type === \'percent\'"><input type=text number-edit=2 ng-model=row.value>%</div><div class="item-cell ml-1px" ng-if="item.type !== \'percent\'"><input type=text number-edit=2 ng-model=row.value></div></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-audit-project-block/dashboard-audit-project-block.view.html','<div id=dashboard-audit-project-block><div class=block-header><div class=block-title translate=Projects></div><selectbox class="select-view-mode ml-auto" ng-model=viewMode options=viewModes label-field=label value-field=id select-event=selectViewMode(viewMode)></selectbox><div class="action-button ml-16" ui-sref=projectList translate="View All"></div></div><div class=table><div class=table-header><div class="cell name" translate="Project Name"></div><div id=audit-project-table-header-part class=header-group><div class=table-row><div class="cell project-no"><span translate="Project ID"></span> #</div><div class="cell type">Type</div><div class="cell manager" translate=Responsible></div><div class="cell completion" translate="Completion Date"></div><div class="cell amount" translate="Contract Amount"></div><div class="cell regulation" translate=Regulations></div><div class="cell profit" translate=Profit></div><div class="cell pending" translate="Pending of Contract"></div></div></div></div><div class=table-body><div class=name-group><div class=table-row ng-repeat="project in projects"><div class="cell name">{{project.projectName}}</div></div></div><div id=audit-project-table-body-part class=body-group><div class=table-row ng-repeat="project in projects | filter: getFilter()"><div class="cell project-no">{{project.systemTag}}</div><div class="cell type">{{getProjectType(project)}}</div><div class="cell manager">{{project.manager}}</div><div class="cell completion">{{project.endDate | smartDate}}</div><div class="cell amount">{{currency}} {{project.contract | readable: 2}}</div><div class="cell regulation">{{currency}} {{project.regulation | readable: 2}}</div><div class="cell profit">{{currency}} {{project.profit | readable: 2}}</div><div class="cell pending">{{currency}} {{project.pending | readable: 2}}</div></div></div></div><div class=table-footer><div class="cell name">SUM</div><div id=audit-project-table-footer-part class=footer-group><div class=table-row><div class="cell project-no"></div><div class="cell type"></div><div class="cell manager"></div><div class="cell completion"></div><div class="cell amount">{{currency}} {{totalContract | readable: 2}}</div><div class="cell regulation">{{currency}} {{totalRegulation | readable: 2}}</div><div class="cell profit">{{currency}} {{totalProfit | readable: 2}}</div><div class="cell pending">{{currency}} {{totalPending | readable: 2}}</div></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-audit-regulation/dashboard-audit-regulation.view.html','<div class=dashboard-audit-regulation><div class=block-header><div class=block-title translate="Audit Regulations"></div><div class=d-flex><div class="action-button ml-16" translate="Show WIP" ng-click=toggleWip()></div><div class="action-button ml-16" translate="Post WIP" ng-click=postWip()></div></div></div><div class="flex-between mt-8"><div class=regulation-title><div class="flex-items-center mt-28 h-40"><img src=/assets/icons/clock-03.svg alt=icon><div class="regulation-label editing"><div class=work-in-progress translate="Audit Editing"></div>&nbsp; <input class=h-40 type=text number-edit=2 ng-model=editingPercent ng-blur=changeEditingPercent()>%</div></div><!-- <div class="flex-items-center mt-8 h-40">\n        <img src="/assets/icons/clock-03.svg" alt="icon"/>\n        <div class="regulation-label" translate="Budget After Editing"></div>\n      </div> --><div class="flex-items-center mt-8 h-40"><img src=/assets/icons/circle-check-2.svg alt=icon><div class=regulation-label>100 % Budget</div></div><div class="flex-items-center mt-8 h-40"><img src=/assets/icons/clock-01.svg alt=icon><div class=regulation-label translate=Status></div></div><div class="flex-items-center mt-8 h-40"><img src=/assets/icons/clock-02.svg alt=icon><div class=regulation-label><input class=h-40 type=text number-edit=2 ng-model=totalWorkPercent ng-blur=changeTotalWorkPercent()> %&nbsp;<div class=work-in-progress translate="Work in Progress"></div></div></div></div><div class=regulation-item ng-repeat="item in regulations track by $index"><div class=item-title translate={{item.name}}></div><div class="d-flex mt-4"><input ng-if="$index > 0 && item.name!=\'Profit\'" class="input amount editing" number-edit=2 ng-model=item.editing.amount ng-blur=changeEditingAmount($index)><div ng-show="item.name!=\'Profit\'" ng-if="$index == 0" class="input amount editing">{{currency}} {{item.editing.amount | readable: 2}}</div><div ng-show="item.name!=\'Profit\'" class="input percent ml-8 editing">{{item.editing.percent | readable: 2}}%</div><div ng-if="item.name==\'Profit\'" class="input percent ml-8 disabled">&nbsp;</div></div><!-- <div class="d-flex mt-8">\n        <div class="input amount editing">{{currency}} {{item.calced.amount | readable: 2}}</div>\n        <div class="input percent ml-8 editing">{{item.calced.percent | readable: 2}}%</div>\n      </div> --><div class="d-flex mt-8"><div class="input amount">{{currency}} {{item.calced.amount | readable: 2}}</div><div class="input percent ml-8">{{item.calced.percent | readable: 2}}%</div></div><div class="d-flex mt-8"><div class="input amount">{{currency}} {{item.status.amount | readable: 2}}</div><div class="input percent ml-8">{{item.status.percent | readable: 2}}%</div></div><div class="d-flex mt-8"><div class="input amount">{{currency}} {{item.regulation.amount | readable: 2}}</div><div class="input percent ml-8">{{item.regulation.percent | readable: 2}}%</div></div></div></div><div class=wip-popover ng-if=isShowWip><div class=wip-header><div translate="Audit Regulations WIP"></div><i class="fas fa-times cursor-point" ng-click=toggleWip()></i></div><div class=wip-divider></div><div class=wip-body><div class="wip-item mt-2"><div class=wip-item-title translate="Project Sales (Statement)"></div><div class=wip-item-price>{{-data.totalInvoicedWithoutCredit | readable: 2}} {{currency}}</div></div><div class=wip-item><div class=wip-sub-item-title translate="WIP - Sales (Statement)"></div><div class=wip-sub-item-price>{{regulations[2].regulation.amount | readable: 2}} {{currency}}</div></div><div class="wip-item mt-2"><div class=wip-item-title translate="Project Costs (Statement)"></div><div class=wip-item-price>{{data.totalCompanyRevCost + data.totalInventoryApprovedCost | readable: 2}} {{currency}}</div></div><div class=wip-item><div class=wip-sub-item-title translate="WIP - Costs (Statement)"></div><div class=wip-sub-item-price>{{regulations[1].regulation.amount | readable: 2}} {{currency}}</div></div><div class="wip-item mt-2"><div class=wip-item-title translate="Project Costs (Statement)"></div><div class=wip-item-price>{{data.totalLaborCost | readable: 2}} {{currency}}</div></div><div class=wip-item><div class=wip-sub-item-title translate="WIP - Labour (Statement)"></div><div class=wip-sub-item-price>{{regulations[0].regulation.amount + regulations[0].editing.amount | readable: 2}} {{currency}}</div></div><div class="wip-item mt-2"><div class=d-flex><div class=wip-item-title translate="SUM - NoNPosting (Statement)"></div><div class="wip-sub-item-title ml-10">Progress {{totalWorkPercent}} %</div></div><div class=wip-item-price>{{regulations[2].regulation.amount + regulations[1].regulation.amount + regulations[0].regulation.amount + regulations[0].editing.amount | readable: 2}} {{currency}}</div></div><div class="wip-item mt-2"><div class=wip-sub-item-title translate="WIP - Contract (Balance/Current Assets)"></div><div class=wip-sub-item-price>{{totalWorkPercent * regulations[2].calced.amount / 100 | readable: 2}} {{currency}}</div></div><div class=wip-item><div class=wip-sub-item-title translate="WIP - Invoiced (Balance/Current Assets)"></div><div class=wip-sub-item-price>{{regulations[2].status.amount | readable: 2}} {{currency}}</div></div><!-- <div class="wip-item">\n        <div class="wip-sub-item-title" translate="WIP - Project Avance(Balance/Current Assets)"></div>\n        <div class="wip-sub-item-price">{{regulations[3].regulation.amount + regulations[3].status.amount | readable: 2}} {{currency}}</div>\n      </div> --><div class=wip-item><div class=wip-sub-item-title translate="WIP - Work In Progress (Balance/Current Assets)"></div><div class=wip-sub-item-price>{{ (totalWorkPercent * regulations[2].calced.amount / 100) + regulations[2].status.amount | readable: 2}} {{currency}}</div></div><div class="wip-item mt-20"><div class=wip-sub-item-title translate="WIP - Costs (assets)"></div><div class=wip-sub-item-price>{{ (totalWorkPercent * (regulations[1].calced.amount + regulations[0].calced.amount) / 100) - ((totalWorkPercent * regulations[2].calced.amount / 100) + regulations[2].status.amount) - (regulations[2].regulation.amount >= 0 ? (-regulations[2].regulation.amount) : 0) | readable: 2}} {{currency}}</div></div><div class=wip-item><div class=wip-sub-item-title translate="WIP - Costs (Balance/Short-term debt)"></div><div class=wip-sub-item-price>{{ - totalWorkPercent * (regulations[1].calced.amount + regulations[0].calced.amount) / 100 | readable: 2}} {{currency}}</div></div><div class=wip-item><div class=wip-sub-item-title translate="WIP - Upfront Payment"></div><div class=wip-sub-item-price>{{regulations[2].regulation.amount >= 0 ? (-regulations[2].regulation.amount) : "" | readable: 2}} {{currency}}</div></div><div class="d-flex justify-content-end mt-20"><div class="action-button ml-16" translate=POST ng-click=postWip()></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-bid-tender-block/dashboard-bid-tender-block.view.html','<div class=dashboard-bid-tender-block><spinner ng-if=loading></spinner><div class=flex-between><div class="ft-600-18-28 black-2" translate="Bid & Tender"></div><selectbox-input class=years options=years ng-model=year label-field=year value-field=year select-event=selectYear()></selectbox-input></div><div class="ft-600-24-32 grey-2">{{companyData.currentCurrency.symbol}} {{totalAmount | readable: 2}}</div><div class="flex mt-16"><div class=value-container><div class=sales-offers><div class="ft-600-36-42 blue-3">{{offerCount}}</div><div class="ft-600-18-28 black-2" translate="Sales Offers"></div></div><selectbox-input class="project-type mt-16" options=projectTypes ng-model=projectType label-field=label value-field=value select-event=selectProjectType()></selectbox-input></div><div class="percent mt-8"><svg><circle cx=64 cy=64 r=64></circle><circle cx=64 cy=64 r=64 class=progress ng-class=item.color ng-style=getPercentStyle()></circle></svg><div class=number><div><div class=year>{{year}}</div><div class=percent-value>{{percent | readable: 0}}%</div><div class=status>Medium</div></div></div></div></div><div class=bid-items><div class=bid-item ng-repeat="item in items"><div class=mark ng-style=getMarkStyle(item)></div><div class=label>{{item.label}}</div><div class="flex-between flex-1"><div class=amount>{{companyData.currentCurrency.symbol}} {{item.amount | readable: 2}}</div><div class=percent-value>{{item.percent | readable: 2}}%</div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-budget-block/dashboard-budget-block.view.html','<div class=dashboard-budget-block><tab-container tabs=tabs><tab-page ng-repeat="tab in tabs" tab-id={{tab.id}}><div class=budget-page><dashboard-budget-group type=tab.id ng-model=budgets currency=companyCurrency.symbol></dashboard-budget-group></div></tab-page></tab-container><spinner ng-if=loading></spinner></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-budget-block/dashboard-budget-group.view.html','<div class=dashboard-budget-group><div class=level-wrapper><selectbox-input class=level-selector ng-repeat="filter in vm.filters" ng-model=filter.groupId options=filter.groups label-field=name value-field=_id select-event="vm.selectGroup(filter, $index)"></selectbox-input></div><div class=budget-table><div class=table-header><div class=flex-4></div><div class=flex-32 translate={{vm.groupTypeName}}></div><div class=flex-6></div><div class=flex-12 translate="Cost Price"></div><div class=flex-14 translate="Negotiated Price"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-10 translate=Profit></div><div class=flex-14 translate="Sales Price"></div></div><div class=table-body><div ng-repeat="budget in vm.budget.budgets" ng-init="budget.subName=vm.budget.subName"><div class=table-row><div class="flex-4 flex-center expander"><img ng-src="{{budget.expand ? \'/assets/icons/arrow-drop-up-black.svg\' : \'/assets/icons/arrow-drop-down-black.svg\'}}" alt="" class=cursor-point ng-click="budget.expand = !budget.expand"></div><div class="flex-15 fw-600 text-ellipsis" title={{budget.name}}>{{budget.name}}</div><div class=flex-6></div><div class=flex-4></div><div class=flex-8></div><div class=flex-5></div><div class=flex-12>{{vm.currency}} {{budget.costPrice | readable: 2}}</div><div class=flex-14>{{vm.currency}} {{budget.negotiatedPrice | readable: 2}}</div><div class=flex-8>{{budget.profitPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{budget.profit | readable: 2}}</div><div class=flex-14>{{vm.currency}} {{budget.calculatedPrice | readable: 2}}</div></div><div class=table-child ng-if=budget.expand><div ng-if="!vm.isLabor(budget) && !vm.isEquipment(budget)"><div class="table-child-row header"><div class=flex-4></div><div class=flex-15>{{budget.subName}}</div><div class=flex-6 translate=Quantity></div><div class=flex-4 translate=Unit></div><div class=flex-8 translate="Unit Price"></div><div class=flex-5 translate=Waste></div><div class=flex-12 translate="Cost Price"></div><div class=flex-14 translate="Negotiated Price"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-10 translate=Profit></div><div class=flex-14 translate="Sales Price"></div></div><div class=table-child-row ng-repeat="item in budget.items"><div class=flex-4></div><div class="flex-15 text-ellipsis" title={{item.inventoryName}}>{{item.inventoryName}}</div><div class=flex-6>{{item.inventoryAmount | readable: 2}}</div><div class=flex-4>{{item.inventoryUnit}}</div><div class=flex-8>{{vm.currency}} {{item.inventoryUnitPrice | readable: 2}}</div><div class="flex-5 waste"><div ng-include="\'app/main/dashboard/directives/dashboard-budget-block/waste.html\'"></div></div><div class=flex-12>{{vm.currency}} {{item.inventoryCostPrice | readable: 2}}</div><div class=flex-14>{{vm.currency}} {{item.salesPriceN | readable: 2}}</div><div class=flex-8>{{item.inventoryProfitPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{item.inventoryProfit | readable: 2}}</div><div class=flex-14>{{vm.currency}} {{item.salesPrice | readable: 2}}</div></div></div><div ng-if=vm.isLabor(budget)><div class="table-child-row header"><div class=flex-4></div><div class=flex-15>{{budget.subName}}</div><div class=flex-6 translate=Quantity></div><div class=flex-4 translate=Unit></div><div class=flex-8 translate="Unit Price"></div><div class=flex-5></div><div class=flex-12 translate="Cost Price"></div><div class=flex-14 translate="Negotiated Price"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-10 translate=Profit></div><div class=flex-14 translate="Sales Price"></div></div><div class=table-child-row ng-repeat="item in budget.items"><div class=flex-4></div><div class="flex-15 text-ellipsis" title="{{item.inventoryName || item.workerName}}">{{item.inventoryName || item.workerName}}</div><div class=flex-6>{{item.workerAmount | readable: 2}}</div><div class=flex-4>{{item.workerUnit}}</div><div class=flex-8>{{vm.currency}} {{item.workerUnitPrice | readable: 2}}</div><div class=flex-5></div><div class=flex-12>{{vm.currency}} {{item.inventoryCostPrice | readable: 2}}</div><div class=flex-14>{{vm.currency}} {{item.workersPriceN | readable: 2}}</div><div class=flex-8>{{item.workerProfitPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{item.workerProfit | readable: 2}}</div><div class=flex-14>{{vm.currency}} {{item.workersPrice | readable: 2}}</div></div></div><div ng-if=vm.isEquipment(budget)><div class="table-child-row header"><div class=flex-4></div><div class=flex-10>{{budget.subName}}</div><div class=flex-3 translate=Unit></div><div class=flex-6 translate="Unit Price"></div><div class=flex-5 translate=Rental></div><div class=flex-8 translate="Delivery Cost"></div><div class=flex-6 translate=Worker></div><div class=flex-12 translate="Cost Price"></div><div class=flex-14 translate="Negotiated Price"></div><div class=flex-8 translate="Profit in %"></div><div class=flex-10 translate=Profit></div><div class=flex-14 translate="Sales Price"></div></div><div class=table-child-row ng-repeat="item in budget.items"><div class=flex-4></div><div class="flex-10 text-ellipsis" title="{{item.inventoryName || item.workerName}}">{{item.inventoryName || item.workerName}}</div><div class=flex-3>{{item.workerUnit}}</div><div class=flex-6>{{vm.currency}} {{item.workerUnitPrice | readable: 2}}</div><div class=flex-5>{{item.rentalPeriod | readable: 0 }}</div><div class="flex-8 delivery"><div ng-include="\'app/main/dashboard/directives/dashboard-budget-block/delivery.html\'"></div><div class=ml-10>{{item.deliveryCost | readable: 2}}</div></div><div class=flex-6>{{item.workerCost | readable: 2}}</div><div class=flex-12>{{vm.currency}} {{item.inventoryCostPrice | readable: 2}}</div><div class=flex-14>{{vm.currency}} {{item.workersPriceN | readable: 2}}</div><div class=flex-8>{{item.workerProfitPercent | readable: 2}} %</div><div class=flex-10>{{vm.currency}} {{item.workerProfit | readable: 2}}</div><div class=flex-14>{{vm.currency}} {{item.workersPrice | readable: 2}}</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-budget-block/delivery.html','<div class=dropdown><img src=/assets/icons/eye-outline.svg alt="" class="dropdown-toggle cursor-point" data-toggle=dropdown><div class=dropdown-menu><div class="menu-box ft_12_600_black"><div class=font-weight-semibold><div class=text-align-center translate="Delivery Cost"></div><div class=text-align-center>{{vm.currency}} {{item.deliveryCost || 0 |readable: 2}}</div><div class="d-flex justify-content-center"><span>Unit {{item.deliveryUnit}}</span></div></div></div><div class=arrow></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-budget-block/waste.html','<div class=dropdown><img src=/assets/icons/eye-outline.svg alt="" class="dropdown-toggle cursor-point" data-toggle=dropdown><div class=dropdown-menu><div class="menu-box ft_12_600_black"><div class=font-weight-semibold><div class=text-align-center><span translate=Waste></span> {{item.wasteAmount || 0 |readable: 2}} {{item.inventoryUnit || "(N/A)"}}</div><div class="d-flex justify-content-center"><span>{{item.wastePercent}}%</span></div></div></div><div class=arrow></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-collaboration-offer/dashboard-collaboration-offer.view.html','<div class=dashboard-collaboration-offer><div class="block-header flex"><!-- <div class="block-title" translate="Collaboration Offers"></div> --><div class=block-header-container><selectbox-input ng-show="userRole == 2 || currentPage ==\'bid/tender\'" class="select-options ml-16" options=suppliers ng-model=selSupplier label-field=name value-field=_id select-event=selectSupplier()></selectbox-input><selectbox-input ng-show="userRole == 3 || currentPage ==\'bid/tender\'" class="select-options ml-16" options=subContractors ng-model=selSubContractor label-field=name value-field=_id select-event=selectSupplier()></selectbox-input><!-- <selectbox-input class="select-options ml-16"\n                       options="projects"\n                       ng-model="project"\n                       label-field="projectName" value-field="_id"\n                       select-event="selectSupplier()">\n      </selectbox-input> --><div ng-show="currentPage !=\'bid/tender\'" class="action-button1 ml-16" ui-sref=submitOffers>+&nbsp;<span translate="Submit offers"></span></div><div ng-show="currentPage ==\'bid/tender\'" class="action-button1 ml-16 sz-120" ng-click="goto(\'incomingOffers\')"><i class="fa fa-check"></i>&nbsp;&nbsp; Incoming offers</div></div><!-- <div class="action-button ml-16" ui-sref="collaborationOffers" translate="View All"></div> --></div><div class=block-body><spinner ng-if=loading></spinner><div class=w-100 ng-if="offers.length !== 0"><!-- <div class="offer-header">\n        <div class="check">\n          <input type="checkbox" ng-model="isCheckAll"/>\n        </div>\n        <div class="cell first">Project ID</div>\n        <div class="cell second">Project Name</div>\n        <div class="cell">Type of work</div>\n        <div class="cell"></div>\n        <div class="cell status" translate="Status"></div>\n        <div class="cell level">{{currentPage == \'bid/tender\' ? \'levels\' : \'\'}}</div>\n        <div class="cell day">{{currentPage == \'bid/tender\' ? \'Days\' : \'\'}}</div>\n        <div class="cell amount">{{currentPage == \'bid/tender\' ? \'Offer Amount\' : \'\'}}</div>\n        <div class="cell action"></div>\n      </div> --><!-- <div class="offer-body">\n        <div ng-repeat="offer in offers track by $index">\n          <div class="offer-item">\n            <div class="check">\n              <input type="checkbox" ng-model="offer.checked"/>\n            </div>\n            <div class="cell first">{{offer.projectId.systemTag}}</div>\n            <div class="cell second">{{offer.projectId.projectName}}</div>\n            <div class="cell">\n              <div class="work-type">\n                <div class="mr-16">{{offer.projectId.buildingType.tagName}}</div>\n              </div>\n            </div>\n            <div class="cell status">\n              <div class="" ng-class="{{getprojectStatuscss(getprojectStatus(offer.projectId.projectStatus))}}">{{getprojectStatus(offer.projectId.projectStatus)}}</div>\n            </div>\n            <div class="cell level">{{offer.levels.length}}</div>\n            <div class="cell day">{{getOfferDays(offer)}}</div>\n            <div class="cell amount">{{companyData.currentCurrency.symbol}} {{getOfferAmount(offer) | readable: 2}}</div>\n\n            <div class="cell action">\n              <img\n                      ng-src="{{offer.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}"\n                      ng-click="offer.expanded = !offer.expanded"\n                      alt="">\n              <img src="/assets/icons/more.svg" alt="">\n            </div>\n          </div>\n          <div class="offer-header header-for-background" ng-show="offer.expanded">\n            <div class="check"></div>\n            <div class="cell first">Bid package</div>\n            <div class="cell second">Offer template</div>\n            <div class="cell">Type of work</div>\n            <div class="cell status">Status</div>\n            <div class="cell level">levels</div>\n            <div class="cell day"># Days</div>\n            <div class="cell amount">Offer Amount</div>\n            <div class="cell action">Action</div>\n          </div>\n          <div class="offer-item item-for-background" ng-if="offer.editData.index != $index" ng-repeat-start="lv in offer.levels" ng-show="offer.expanded">\n            <div class="check"></div>\n            <div class="cell first">{{offer.bidPackageId.title}}</div>\n            <div class="cell second">{{offer.name}}</div>\n            <div class="cell">{{getWorkTypes(offer.bidPackageId.workTypes)}}</div>\n            <div class="cell status"><div class="" ng-class="getOfferStatusClass(offer.status)">{{offer.status}}</div></div>\n            <div class="cell level">{{lv.level}}</div>\n            <div class="cell day">{{lv.days}}</div>\n            <div class="cell amount">{{companyData.currentCurrency.symbol}} {{lv.amount | readable: 2}}</div>\n            <div class="cell action">\n              <img src="/assets/icons/file-gray.svg"  alt="" ng-click="editDcOffer(offer, lv, $index)">\n              <img src="/assets/icons/file_upload.svg" alt="">\n            </div>\n          </div>\n          <div class="offer-item" ng-if="offer.editData.index == $index" ng-repeat-end="lv in offer.levels" ng-show="offer.expanded">\n            <div class="check"></div>\n            <div class="cell first">{{offer.bidPackageId.title}}</div>\n            <div class="cell second">{{offer.name}}</div>\n            <div class="cell">{{getWorkTypes(offer.bidPackageId.workTypes)}}</div>\n            <div class="cell status">\n              <div class="" ng-class="getOfferStatusClass(offer.status)">{{offer.status}}</div>\n            </div>\n            <div class="cell level">{{lv.level}}</div>\n            <div class="cell day"><input class="w-90" value = "{{offer.editData.days}}"></div>\n            <div class="cell amount">\n              <input class="w-90" value = "{{offer.editData.amount}}">\n            </div>\n            <div class="cell action">\n              <img class="cursor-point" src="/assets/icons/checkmark-24.svg" alt="" ng-click=""/>\n              <img class="cursor-point" src="/assets/icons/close-24-dark.svg" alt="" ng-click="cancelEdit(offer)"/>\n            </div>\n          </div>\n        </div>\n      </div> --><div class=offer-body><!-- <div ng-repeat="offer in offers track by $index">\n          <div class="offer-item">\n            <div class="check">\n              <input type="checkbox" ng-model="offer.checked"/>\n            </div>\n            <div class="cell first">{{offer.projectId}}</div>\n            <div class="cell second">{{offer.projectName}}</div>\n            <div class="cell">\n              <div class="work-type">\n                <div class="mr-16">{{offer.projectId.buildingType.tagName}}</div>\n              </div>\n            </div>\n            <div class="cell"></div>\n            <div class="cell status">\n              <div class="" ng-class="{{getprojectStatuscss(getprojectStatus(offer.status))}}">{{getprojectStatus(offer.status)}}</div>\n            </div>\n            <div class="cell level">{{currentPage == \'bid/tender\' ? gettotallevels(offer) : \'\'}}</div>\n            <div class="cell day">{{currentPage == \'bid/tender\' ? gettotaldays(offer) : \'\'}}</div>\n            <div class="cell amount">{{currentPage == \'bid/tender\' ? gettotalamounts(offer) : \'\'}}</div>\n\n            <div class="cell action">\n              <img ng-src="{{offer.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}"\n                ng-click="offer.expanded = !offer.expanded"\n                alt="">\n              <img src="/assets/icons/more.svg" alt="">\n            </div>\n          </div> --><div class=offer-header ng-show=true><!-- <div class="check"></div> --><div class="cell first" translate="Bid Package"></div><div class="cell second" translate="SYS Tag"></div><div class=cell translate="Type of work"></div><div class="cell supplier">{{currentPage == "bid/tender" ? "Supplier/Sub-contractor" : (currentPage == \'supplier\' ? "Supplier" : "Sub-contractor")}}</div><div class="cell status" translate=Status></div><div class="cell level" translate=levels></div><div class="cell day"># <span translate=Days></span></div><div class="cell amount" translate="Offer Amount"></div><div class="cell action" translate=Action></div></div><!-- <div ng-if="offer.editData.index != $index" ng-repeat="bid in offers" ng-show="true"> --><div class=offer-item ng-if="offer.editData.index != $index" ng-repeat="suboffer in offers" ng-show=true><!-- <div class="check"></div> --><div class="cell first">{{suboffer.bidPackageId.title}}</div><div class="cell second">{{suboffer.bidPackageId.sysTag}}</div><div class="cell worktype">{{getWorkTypes(suboffer.bidPackageId.typeOfWork)}}</div><div class="cell supplier">{{ currentPage != \'bid/tender\' ? (currentPage == \'supplier\' ? suboffer.supplierId.name : suboffer.subcontractorId.name) : \'\'}}</div><div class="cell status"><div ng-show="currentPage!=\'bid/tender\'" ng-class=getOfferStatusClass(suboffer.status)>{{suboffer.status}}</div><div ng-show="currentPage==\'bid/tender\'"><img ng-click="updateofferstatus(suboffer, \'Accepted\')" alt="" ng-src="{{suboffer.status == \'Accepted\' ? \'/assets/icons/check-offer-status-f.svg\' : \'/assets/icons/check-offer-status.svg\'}}"> <img ng-click="updateofferstatus(suboffer, \'Declined\')" alt="" ng-src="{{suboffer.status == \'Not Received\' || suboffer.status == \'Declined\' ? \'/assets/icons/close-offer-status-f.svg\' : \'/assets/icons/close-offer-status.svg\'}}"> <img ng-click="updateofferstatus(suboffer, \'Paused\')" alt="" ng-src="{{suboffer.status == \'Pending\' || suboffer.status == \'Paused\' ? \'/assets/icons/pause-offer-status_f.svg\' : \'/assets/icons/pause-offer-status.svg\'}}"></div></div><div class="cell level">{{suboffer.status == \'Accepted\' || currentPage != \'bid/tender\' ? getlevelcount(suboffer) : 0}}</div><div class="cell day">{{suboffer.status == \'Accepted\' || currentPage != \'bid/tender\' ? getOfferDays(suboffer) : 0}}</div><div class="cell amount">{{companyData.currentCurrency.symbol}} {{(suboffer.status == \'Accepted\' || currentPage != \'bid/tender\' ? getOfferAmount(suboffer) : 0) | readable: 2}}</div><div class="cell action"><img src=/assets/icons/file-gray.svg alt="" ng-click="editDcOffer(offer, lv, $index)"> <img src=/assets/icons/file_upload.svg alt=""></div></div><!-- </div> --><div class=offer-item ng-if="offer.editData.index == $index" ng-repeat-end="lv in offer.levels" ng-show=offer.expanded><!-- <div class="check"></div> --><div class="cell first">{{offer.bidPackageId.title}}</div><div class="cell second">{{offer.name}}</div><div class=cell>{{getWorkTypes(offer.bidPackageId.workTypes)}}</div><div class="cell status"><div ng-class=getOfferStatusClass(offer.status)>{{offer.status}}</div></div><div class="cell level">{{lv.level}}</div><div class="cell day"><input class=w-90 value={{offer.editData.days}}></div><div class="cell amount"><input class=w-90 value={{offer.editData.amount}}></div><div class="cell action"><img class=cursor-point src=/assets/icons/checkmark-24.svg alt="" ng-click=""> <img class=cursor-point src=/assets/icons/close-24-dark.svg alt="" ng-click=cancelEdit(offer)></div></div><!-- </div> --></div></div><div class=empty-data ng-if="!loading && offers.length===0">No Display Data</div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-economic-cashflow/dashboard-economic-cashflow.view.html','<div class=dashboard-economic-cashflow><div class="cash-item mt-30"><div class=item-title><span translate="Budget Economic"></span></div><div class="flex-between mt-16"><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-worker.svg alt=""><div class=item-value>{{ currency }} {{ cash.totalCompanyCost | readable: 2 }}</div><div class=item-label translate="Operating Cost"></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-worker.svg alt=""><div class=item-value>{{ currency }} {{ cash.totalWorkerCost | readable: 2 }}</div><div class=item-label translate=Pay></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-stack.svg alt=""><div class=item-value>{{ currency }} {{ cash.totalInventoryCost | readable: 2 }}</div><div class=item-label translate=Material/Equipment></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-discount.svg alt=""><div class=item-value>{{ currency }} {{ cash.totalSalesPrice | readable: 2 }}</div><div class=item-label translate="Sales price"></div></div><div class="item-field w-100"><img class=bg-symbol src=/assets/icons/cash-stock.svg alt=""><div class=item-value>{{ currency }} {{ cash.totalProfit | readable: 2 }}</div><div class=item-label translate=Profit></div></div></div></div><div class="cash-item mt-16"><div class=item-title translate=Cost></div><div class="flex-between mt-16"><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-worker.svg alt=""><div class=item-value>{{ currency }} {{ cash.totalCompanyRevCost | readable: 2 }}</div><div class=item-label translate="Operating Cost"></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-worker.svg alt=""><div class=item-value>{{ currency }} {{ cash.totalLaborCost | readable: 2 }}</div><div class=item-label translate=Pay></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-stack.svg alt=""><div class=item-value>{{ currency }} {{ cash.totalInventoryApprovedCost | readable: 2 }}</div><div class=item-label translate=Material/Equipment></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-discount.svg alt=""><div class=item-value>{{ currency }} {{ cash.totalInvoicedWithoutCredit | readable: 2 }}</div><div class=item-label translate=Invoiced></div></div><div class=item-field><img class=bg-symbol src=/assets/icons/cash-stock.svg alt=""><div class=item-value>{{ currency }} {{ cash.totalCostProfit | readable: 2 }}</div><div class=item-label translate=Profit></div></div></div></div><div class="cash-item mt-16"><div class=item-title translate="Key Figures"></div><div class="flex-between mt-16"><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-worker.svg alt=""><div class=d-flex><div class="item-value w-50">{{ cash.companyCostPercent | readable: 2 }} %</div><div class="item-value w-50">{{ cash.costPercent | readable: 2 }} %</div></div><div class=item-label translate="Operating Cost"></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-worker.svg alt=""><div class=item-value>{{ cash.laborPercent | readable: 2 }} %</div><div class=item-label translate=Pay></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-stack.svg alt=""><div class=item-value>{{ cash.inventoryPercent | readable: 2 }} %</div><div class=item-label translate=Material/Equipment></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-discount.svg alt=""><div class=item-value>{{ cash.invoicePercent | readable: 2 }} %</div><div class=item-label translate=Invoiced></div></div><div class=item-field><img class=bg-symbol src=/assets/icons/cash-stock.svg alt=""><div class=item-value>{{ cash.profitPercent | readable: 2 }} %</div><div class=item-label translate=Profit></div></div></div></div><div class="cash-item mt-16"><div class=item-title translate="VA Orders"></div><div class="flex-between mt-16"><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-worker.svg alt=""><div class=item-value>{{ currency }} {{ cash.vaApproved | readable: 2 }}</div><div class=item-label translate=Approved></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-worker.svg alt=""><div class=item-value>{{ currency }} {{ cash.vaPending | readable: 2 }}</div><div class=item-label translate="Pending Approval"></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-stack.svg alt=""><div class=item-value>{{ currency }} {{ cash.vaBill | readable: 2 }}</div><div class=item-label translate=Bill></div></div><div class="item-field block-border"><img class=bg-symbol src=/assets/icons/cash-discount.svg alt=""><div class=item-value>{{ currency }} {{ cash.vaInvoiced | readable: 2 }}</div><div class=item-label translate=Invoiced></div></div><div class=item-field><img class=bg-symbol src=/assets/icons/cash-stock.svg alt=""><div class=item-value>{{ currency }} {{ cash.vaProfit | readable: 2 }}</div><div class=item-label translate=Profit></div></div></div></div><div class="cash-item flex-between mt-16 simple"><div class=d-flex><div class="item-title my-auto mr-15" translate=Status></div><div class=item-value>{{(cash.progress * 100) | readable: 2}} %</div></div><div class=d-flex><div class="item-title my-auto mr-15" translate=Profit></div><div class=item-value>{{ currency }} {{ cash.totalCostProfit | readable: 2 }}</div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-economic-main-graph/dashboard-economic-main-graph.view.html','<div id=eco-main-graph class=ev-2><div class="up-item flex-between"><div class=graph-title translate=Economic></div><div class=flex-center><div class="btn-group ml-15"><div class=btn-item ng-class="{\'active\': type == \'custom\'}" translate=Custom></div><div class=btn-item ng-class="{\'active\': type == \'week\'}" ng-click="onSelectType(\'week\')" translate=Weekly1></div><div class=btn-item ng-class="{\'active\': type == \'month\'}" ng-click="onSelectType(\'month\')" translate=Monthly></div><div class=btn-item ng-class="{\'active\': type == \'year\'}" ng-click="onSelectType(\'year\')" translate=Yearly1></div></div></div></div><div ng-show=needRender><div ng-if=!hasGraphData class="ft_14_600_gray p-5 text-center">No Data for Chart</div><div id=eco-line-chart class="graph no-zoom mt-30" ng-show=hasGraphData><svg></svg></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-header/dashboard-header.view.html','<div class=dashboard-header><div class="flex-center inline-block"><img ng-src="{{ profilePic || \'/assets/icons/bx-user.svg\'}}" alt=logo class="inline-block object-fit-cover avatar-56 mr-16"><div class=inline-block><div class="ft-normal-24-32 black-2">Hi, <span class=ft-bold-24-32>{{firstName}}</span></div><div class="ft-normal-16-24 grey-3">Take a moment and have a look at this.</div></div></div><div class=flex-end><div class="btn-border mr-16" ui-sref=projectInvite><img src=/assets/icons/bx-plus-3.svg alt=plus><span translate=Invite></span></div><div class="btn-border mr-16" ui-sref=typeWritterAdd><img src=/assets/icons/bx-plus-3.svg alt=icons><span translate="New Note"></span></div><div class=btn-blue ng-click=onCreateProject()><img src=/assets/icons/bx-plus.svg alt=icons><span translate="Create New"></span></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-incoming-offer/dashboard-incoming-offer.view.html','<div class=dashboard-incoming-offer><spinner ng-if=isLoading></spinner><div class=collaboration-content><div class="table-container pos-relative"><spinner ng-if=isLoading></spinner><div class=thead><div class=tr><div class="td check-item"><!-- <label class="check_yellow_16 check">\n              <input type="checkbox" ng-model="selectedAll" ng-change="selectAllOffers()" />\n              <span class="checkmark_16"></span>\n            </label> --></div><div class="d-flex main-td-group"><div class="td work-type" translate="Bid Package"></div><div class="td system-tag" translate="SYS Tag"></div><div class="td collaborator" translate=Collaborator></div><div class="td staff-container" translate=Staff></div><div class="td status" translate=Status></div><div class="td levels" translate=Levels></div><div class="td no-of-days" translate=Days></div><div class="td no-of-days" translate=""></div><div class="td no-of-days" translate=""></div><div class="td offer-amount" translate="Offer Amount"></div><div class="td best" translate=""></div></div><div class="td actions" translate=Actions></div></div></div><div class=tbody><div ng-repeat="bid in bidPackages track by $index"><div class=tr><div class="td check-item"><!-- <label class="check_yellow_16 check">\n                <input type="checkbox" ng-model="offer.selected" ng-change="selectOffer(offer)" />\n                <span class="checkmark_16"></span>\n              </label> --></div><div class="d-flex main-td-group"><div class="td work-type">{{bid.title}}</div><div class="td system-tag">{{ bid.systag }}</div><div class="td collaborator">{{getCollaborator(bid)}}</div><div class="td staff-container">{{getBidStaffs(bid)}}</div><div class="td status"><div><!-- <div class="" ng-class="getOfferStatusClass(getBidStatus(bid))">{{getBidStatus(bid)}}</div> --> <img ng-src="{{getBidStatus(bid) == \'Accepted\' ? \'/assets/icons/check-offer-status-f.svg\' : \'/assets/icons/check-offer-status.svg\'}}" alt=""> <img class=ml-8 ng-src="{{getBidStatus(bid) == \'Decliended\' ? \'/assets/icons/close-offer-status-f.svg\' : \'/assets/icons/close-offer-status.svg\'}}" alt=""> <img class=ml-8 ng-src="{{getBidStatus(bid) == \'Paused\' ? \'/assets/icons/pause-offer-status_f.svg\' : \'/assets/icons/pause-offer-status.svg\'}}" alt=""></div></div><div class="td levels">{{calcBidLevels(bid)}}</div><div class="td no-of-days">{{calcBidDays(bid)}}</div><div class="td no-of-days"></div><div class="td no-of-days"></div><div class="td offer-amount">{{companyData.currentCurrency.symbol}} {{calcBidOfferAmount(bid) | readable: 2}}</div><div class="td best"><button class="btn income-offer-button" ng-if=calcBest(bid)>{{calcBest(bid)}} best</button></div></div><div class="td actions"><img class=mr-16 src=/assets/icons/file-gray.svg alt=""> <img class=mr-16 ng-src="{{bid.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}" ng-click="bid.expanded = !bid.expanded" alt=""></div></div><div class="tr offers-panel" ng-repeat-start="offer in bid.offers" ng-show=bid.expanded><div class="td check-item"></div><div class="d-flex main-td-group"><div class="td work-type"></div><div class="td system-tag"></div><div class="td collaborator">{{offer.supplierId.name}}</div><div class="td staff-container">{{offer.staffId.displayName}}</div><div class="td status"><div><img ng-click="updateStatus(offer, \'Accepted\')" ng-src="{{offer.status == \'Accepted\' ? \'/assets/icons/check-offer-status-f.svg\' : \'/assets/icons/check-offer-status.svg\'}}" alt=""> <img class=ml-8 ng-click="updateStatus(offer, \'Decliended\')" ng-src="{{offer.status == \'Decliended\' ? \'/assets/icons/close-offer-status-f.svg\' : \'/assets/icons/close-offer-status.svg\'}}" alt=""> <img class=ml-8 ng-click="updateStatus(offer, \'Paused\')" ng-src="{{offer.status == \'Paused\' ? \'/assets/icons/pause-offer-status_f.svg\' : \'/assets/icons/pause-offer-status.svg\'}}" alt=""><!-- <div class="" ng-class="getOfferStatusClass(offer.status)">{{offer.status}}</div> --></div></div><div class="td levels">{{offer.levels.length}}</div><div class="td no-of-days">{{calcOfferDays(offer)}}</div><div class="td no-of-days"></div><div class="td no-of-days"></div><div class="td offer-amount">{{companyData.currentCurrency.symbol}} {{calcOfferAmount(offer) | readable: 2}}</div><div class="td best"></div></div><div class="td actions flex-content-end"><img class=mr-16 ng-src="{{offer.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}" ng-click="offer.expanded = !offer.expanded" alt=""></div></div><div ng-repeat-end="offer in bid.offers" ng-show=offer.expanded><div class=groups-panel ng-show=offer.expanded><!-- <div class="group-name">{{group.name}}</div> --><div class="d-flex justify-content-between"><div class=d-flex><div class=levels-tab ng-click=selectGroup(offer) ng-class="{\'active\': offer.selectedGroup.name == \'All\'}">All</div><div class=levels-tab ng-repeat="group in offer.groups" ng-click="selectGroup(offer, group)" ng-class="{\'active\': offer.selectedGroup == group}">{{group.name}}</div></div><div class=d-flex><input class=hidden id=fileSelector ngf-select ngf-pattern="\'.xlsx\'" ngf-multiple=false ngf-accept="\'.xlsx\'" ngf-change=SelectFile($file)> <button class="btn income-offer-button mr-10" ng-if="offer.selectedGroup.name != \'All\'" ng-click=attachExcelFiles(offer)>Upload</button> <button class="btn income-offer-button" ng-click=saveOfferSubmit(offer)>Save</button></div></div><div class=group-table><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><label translate=Name></label></div><div class=col-3><label translate=Type></label></div><div class=col-2><label translate=Level></label></div><div class=col-3><label translate=Size></label></div></div></div><div class=col-7><div class=row><div class=col-4><label translate=Description></label></div><div class=col-1><label translate=Days></label></div><div class=col-1><label translate=Quanties></label></div><div class=col-1><label translate=Unit></label></div><div class=col-2><label translate="Unit Price"></label></div><div class=col-3><label translate="Offer Amount"></label></div></div></div></div></div><div class=item-container><div ng-repeat="item in offer.selectedGroup.levels track by $index"><div class=item-break></div><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><!-- <input type="text" ng-model="item.name" class="login_input_new_no_mt"> --><div class=overflow-wrap>{{item.name}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.type" class="login_input_new_no_mt"> --><div>{{item.type}}</div></div><div class=col-2><!-- <input type="text" ng-model="item.level" class="login_input_new_no_mt"> --><div>{{item.level}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.size" class="login_input_new_no_mt"> --><div>{{item.size}}</div></div></div></div><div class=col-7><div class=row><div class=col-4><!-- <input type="text" class="login_input_new_no_mt" ng-model="item.description"> --><div>{{item.description}}</div></div><div class=col-1><!-- <input type="text" number-edit ng-model="item.days" class="login_input_new_no_mt text-right"> --><div>{{item.days}}</div></div><div class=col-1><!-- <input type="text" number-edit ng-model="item.quantity" class="login_input_new_no_mt text-right"> --><div>{{item.quantity}}</div></div><div class=col-1><!-- <input type="text" ng-model="item.unit" class="login_input_new_no_mt text-right"> --><div>{{item.unit}}</div></div><div class=col-2><!-- <input type="text" number-edit ng-model="item.unitPrice" class="login_input_new_no_mt text-right"> --><div>{{item.unitPrice}}</div></div><div class=col-3><!-- <input type="text" number-edit ng-model="item.amount" class="login_input_new_no_mt text-right"> --><div>{{item.amount}}</div></div></div></div></div></div></div></div><div class=item-break></div><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><label translate=""></label></div><div class=col-3><label translate=""></label></div><div class=col-2><label translate=""></label></div><div class=col-3><label translate=""></label></div></div></div><div class=col-7><div class=row><div class=col-4><label translate=Sum></label></div><div class=col-1><label>{{calcGroupDays(offer.selectedGroup)}}</label></div><div class=col-1><label>{{calcGroupQuantity(offer.selectedGroup)}}</label></div><div class=col-1><label translate=""></label></div><div class=col-2><label translate=""></label></div><div class=col-3><label>{{calcGroupOfferAmount(offer.selectedGroup)}}</label></div></div></div></div></div></div><!-- <div class="tr levels-panel" ng-repeat="lv in group.levels" ng-show="offer.expanded">\n                <div class="td check-item"></div>\n                <div class="d-flex main-td-group">\n                  <div class="td work-type"></div>\n                  <div class="td offername">{{offer.bidPackageId.sysTag + \'-\' + ($index + 1)}}</div>\n                  <div class="td coordinator"></div>\n                  <div class="td levels"></div>\n                  <div class="td no-of-days">{{lv.name}}</div>\n                  <div class="td offer-amount">{{lv.description}}</div>\n                  <div class="td status">{{lv.type}}</div>\n                  <div class="td status">{{lv.level}}</div>\n                  <div class="td status">{{lv.size}}</div>\n                </div>\n                <div class="td actions"></div>\n              </div> --></div></div><!-- <div ng-repeat-end="offer in bid.offers" ng-show="offer.expanded">\n            <div class="item">\n              <div class="space"></div>\n              <div class="info row">\n                <div class="col-5">\n                  <div class="row">\n                    <div class="col-4"><label translate="Name"></label></div>\n                    <div class="col-3"><label translate="Type"></label></div>\n                    <div class="col-2"><label translate="Level"></label></div>\n                    <div class="col-3"><label translate="Size"></label></div>\n                  </div>\n                </div>\n                <div class="col-7">\n                  <div class="row">\n                    <div class="col-3"><label translate="Description"></label></div>\n                    <div class="col-2"><label translate="Days"></label></div>\n                    <div class="col-2"><label translate="Quanties"></label></div>\n                    <div class="col-1"><label translate="Unit"></label></div>\n                    <div class="col-1"><label translate="Unit Price"></label></div>\n                    <div class="col-2"><label translate="Amount"></label></div>\n                    <div class="col-1"></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="offerLineList">\n\n              <div class="item" ng-repeat="item in vm.bidOfferTemplate.levels track by $index"\n                ng-show="checkFilter(item)">\n                <div class="space">\n                  <input type="checkbox" ng-model="item.isChecked" />\n                </div>\n                <div class="info row">\n                  <div class="col-5">\n                    <div class="row">\n                      <div class="col-4">\n                        <input type="text" ng-model="item.name" class="login_input_new_no_mt">\n                      </div>\n                      <div class="col-3">\n                        <input type="text" ng-model="item.type" class="login_input_new_no_mt">\n                      </div>\n                      <div class="col-2">\n                        <input type="text" ng-model="item.level" class="login_input_new_no_mt">\n                      </div>\n                      <div class="col-3">\n                        <input type="text" ng-model="item.size" class="login_input_new_no_mt">\n                      </div>\n                    </div>\n                  </div>\n                  <div class="col-7">\n                    <div class="row">\n                      <div class="col-3">\n                        <input type="text" class="login_input_new_no_mt" ng-model="item.description">\n                      </div>\n                      <div class="col-2">\n                        <input type="text" number-edit ng-model="item.days" class="login_input_new_no_mt text-right">\n                      </div>\n                      <div class="col-2">\n                        <input type="text" number-edit ng-model="item.quantity"\n                          class="login_input_new_no_mt text-right">\n                      </div>\n                      <div class="col-1">\n                        <input type="text" ng-model="item.unit" class="login_input_new_no_mt text-right">\n                      </div>\n                      <div class="col-1">\n                        <input type="text" number-edit ng-model="item.unitPrice"\n                          class="login_input_new_no_mt text-right">\n                      </div>\n                      <div class="col-2">\n                        <input type="text" number-edit ng-model="item.amount" class="login_input_new_no_mt text-right">\n                      </div>\n                      <div class="col-1 d-flex align-items-center justify-content-center">\n                        <a href="javascript:;" ng-click="removeLevel($index)">\n                          <i class="fa fa-times text-danger"></i>\n                        </a>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div> --><!-- <div ng-repeat-end="offer in bid.offers" ng-show="offer.expanded">\n            <div class="tr levels-panel">\n              <div class="td check-item"></div>\n              <div class="d-flex main-td-group">\n                <div class="td work-type ft_14_600_black2" translate="Name"></div>\n                <div class="td system-tag ft_14_600_black2" translate="SYS Tag"></div>\n                <div class="td collaborator ft_14_600_black2" translate="Description"></div>\n                <div class="td coordinator ft_14_600_black2" translate="Type"></div>\n                <div class="td size ft_14_600_black2" translate="Size"></div>\n                <div class="td status">\n\n                </div>\n                <div class="td levels ft_14_600_black2" translate="Levels"></div>\n                <div class="td no-of-days ft_14_600_black2" translate="Days"></div>\n                <div class="td no-of-days ft_14_600_black2" translate="Quantity"></div>\n                <div class="td no-of-days ft_14_600_black2" translate="Unit Price"></div>\n                <div class="td offer-amount ft_14_600_black2" translate="Offer Amount"></div>\n                <div class="td best"></div>\n              </div>\n              <div class="td actions"></div>\n            </div>\n            <div class="tr levels-panel" ng-repeat="lv in offer.levels">\n              <div class="td check-item"></div>\n              <div class="d-flex main-td-group">\n                <div class="td work-type">{{lv.name}}</div>\n                <div class="td system-tag">{{ bid.systag + \'-\' + ($index + 1) }}</div>\n                <div class="td collaborator">{{lv.description}}</div>\n                <div class="td coordinator">{{lv.type}}</div>\n                <div class="td size">{{lv.size}}</div>\n                <div class="td status"></div>\n                <div class="td levels">{{lv.level}}</div>\n                <div class="td no-of-days">\n                  <span>{{lv.days}}</span>\n                </div>\n                <div class="td no-of-days">\n                  <span>{{lv.quantity}}</span>\n                </div>\n                <div class="td no-of-days">\n                  <span>{{companyData.currentCurrency.symbol}} {{lv.unitPrice | readable: 2}}</span>\n                </div>\n                <div class="td offer-amount">\n                  <span>{{companyData.currentCurrency.symbol}} {{lv.amount | readable: 2}}</span>\n                </div>\n                <div class="td best"></div>\n              </div>\n              <div class="td actions">\n\n              </div>\n            </div>\n            <div class="tr levels-panel">\n              <div class="td check-item"></div>\n              <div class="d-flex main-td-group">\n                <div class="td work-type ft_14_600_black2" translate="Sum"></div>\n                <div class="td system-tag ft_14_600_black2" translate=""></div>\n                <div class="td collaborator ft_14_600_black2" translate=""></div>\n                <div class="td coordinator ft_14_600_black2" translate=""></div>\n                <div class="td size ft_14_600_black2" translate=""></div>\n                <div class="td status">\n\n                </div>\n                <div class="td levels">{{offer.levels.length}}</div>\n                <div class="td no-of-days">{{calcOfferDays(offer)}}</div>\n                <div class="td no-of-days">{{calcOfferQuantity(offer)}}</div>\n                <div class="td no-of-days">{{companyData.currentCurrency.symbol}} {{calcOfferUnitPrice(offer) | readable: 2}}</div>\n                <div class="td offer-amount">{{companyData.currentCurrency.symbol}} {{calcOfferAmount(offer) |\n                  readable: 2}}</div>\n                <div class="td best"></div>\n              </div>\n              <div class="td actions"></div>\n            </div>\n          </div> --></div></div></div><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + offers.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=getOffers()></pagination-custom-new></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-issue-block/dashboard-issue-block.view.html','<div class=dashboard-issue-block><div class=block-header><div class=block-title>Type</div><div class="type-button ml-16">Clash</div><div class="type-button active ml-8">Issue</div><div class="action-button ml-auto" ui-sref=issuesList translate="View All"></div></div><div class=block-body><spinner ng-if=loading></spinner><div class=issue-container ng-if=issue><div class="issue-header mt-16"><div class=issue-mark><img src=/assets/icons/warning-red.svg alt=issue></div><div class="issue-simple-info ml-16"><div class=flex-between><div class=issue-id>{{issue.systemTag}}</div><div class=issue-status ng-class=getIssueStatusClass()>{{issue.status}}</div></div><div class=issue-title>{{issue.title}}</div></div></div><div class="issue-tabs mt-16"><div class=tab ng-class="{active: isDetails}" ng-click="isDetails = true">Details</div><div class=tab ng-class="{active: !isDetails}" ng-click="isDetails = false">Comments</div></div><div class=issue-tab-content><div ng-if=isDetails><div class=mb-16 ng-if="issue.image && issue.image.secure_url"><img class="issue-image object-fit-cover" ng-src={{issue.image.secure_url}} alt=""></div><div class=mb-16 ng-if=issue.description><div class="ft_12_600_black mb-2">Description</div><div class=ft_12_regular_gray>{{issue.description}}</div></div><div class="d-flex w-100 mb-4"><div class="flex-items-center ft_12_600_black width50"><img class=mr-8 src=/assets/icons/bx-copy.svg alt="">Group</div></div><div class="d-flex w-100"><div class=issue-category>{{issue.issueCategory}}</div></div><div class="mt-24 flex"><div class=flex-50><div class="flex-items-center ft_12_600_black"><img class=mr-8 src=/assets/icons/person-orange.svg alt="">Created by</div><div class="flex-items-center mt-8"><img class=avatar-40 ng-src="{{issue.createdBy.profilePic || \'/assets/icons/bx-user.svg\'}}" alt=avatar><div class="ml-8 ft_12_regular_gray">{{issue.createdBy}}</div></div></div><div class=flex-50><div class="flex-items-center ft_12_600_black"><img class=mr-8 src=/assets/icons/group-orange.svg alt="">Members</div><div class="flex-items-center mt-8"><img class=avatar-40 ng-src="{{issue.createdBy.profilePic || \'/assets/icons/bx-user.svg\'}}" alt=avatar></div></div></div></div><div ng-if=!isDetails class=comments-container><live-chat-small unique-name={{issue._id}} chat-type=issue></live-chat-small></div></div></div><div class=empty-data ng-if=!issue>No Display Data</div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-issues-statistics-block/dashboard-issues-statistics-block.view.html','<div class="yellow dashboard-issues-statistics-block flex-column d-flex justify-content-between" ui-sref=issuesList><div class="d-flex justify-content-between action-icons"><img src=/assets/icons/info_outline.svg alt=icons class=action-info> <img src=/assets/icons/more_horiz.svg alt=icons class=action-more></div><div class="ft_18_600_white block-label text-left">Issues Statistics</div><div class=flex-between><div class=inline-block><div class="ft_36_600_white block-label text-center">{{issueStatistic.safety}}</div><div class="ft_14_600_white block-label text-center">SAFETY ISSUES</div></div><div class="inline-block block-border"><div class="ft_36_600_white block-label text-center">{{issueStatistic.total}}</div><div class="ft_14_600_white block-label text-center">PROJECT ISSUES</div></div><div class=inline-block><div class="ft_36_600_white block-label text-center">{{issueStatistic.completed}}</div><div class="ft_14_600_white block-label text-center">ISSUES COMPLETED</div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-mat-eq-block/dashboard-mat-eq-block.view.html','<div class=dashboard-mat-eq-block ng-style="{\'--h\': height}"><div class=item-header><div class="ft_16_600_black float-left">{{type == \'mat\'? \'Material Orders\': \'Equipment Orders\'}}</div><div class=float-right><button class=btn_primary_25 translate="View All"></button></div></div><div class=bodyScroll><div ng-repeat="x in [].constructor(10) track by $index"><div class=flex><img src=/assets/images/dashboard/mat-avatar.svg alt=logo class=mr-10><div class=text-left><div class="flex-left ft_10_regular_gray">Due on 24 Aug, 2019</div><div class=ft_12_600_black>Stress relief annealing of seamless steel pipe</div></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-meeting-block/dashboard-meeting-block.view.html','<div class=meetings ng-style="{\'height\': height + \'px\'}"><div class=item-header><div class="ft_16_600_black float-left">Scheduled Meetings</div><div class=float-right><button class=btn_primary_25 ng-click=addMeetingRoom()>+</button></div></div><div class="bodyScroll pos-relative" ng-style="{\'height\': (height - 81) + \'px\', \'padding-bottom\': \'0\'}"><spinner ng-if=loading></spinner><div ng-repeat="dt in getDatesOfMeetings() track by $index" ng-class="{\'mb-16\': $index !== getDatesOfMeetings().length - 1}"><div class="ft_12_regular_light text-left fw-600 ft_family_inter"><span ng-if="today === dt">Today \u2022 </span>{{dt}}</div><div ng-repeat="meeting in meetings[dt]"><div class=block ng-class="\'type-\' + meeting.status"><div class="flex-between mb-4"><div class="ft_14_600_black tx-ellipsis name" title={{meeting.title}}>{{meeting.title}}</div></div><div class="ft_12_regular_light text-left ft_family_inter mb-4">{{meeting.description}}</div><div class="d-flex align-items-center justify-content-start ft_12_600_gray mb-8"><img src=/assets/images/dashboard/clock.svg alt=icons class=clock><div><span>{{meeting.dateFrom | date: \'HH:mm\' : \'UTC\'}}&nbsp;-&nbsp;</span> <span>{{meeting.dateTo | date: \'HH:mm\' : \'UTC\'}}</span></div></div><div class=flex-between><div class="members d-flex"><div ng-repeat="user in meeting.assignedTo track by $index"><img ng-if=user.profilePic ng-src={{user.profilePic}} alt=icons class="avatar-24 object-fit-cover" title={{user.displayName}}> <img ng-if=!user.profilePic src=/assets/images/employees/no-avatar.png alt=icons class=avatar-24 title={{user.displayName}}></div></div><div class="status-tag ft_12_600_black flex-center" ng-class="\'type-\' + meeting.status">{{getTextStatus(meeting.status)}}</div></div></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-order-block/dashboard-order-block.view.html','<div class=dashboard-order-block><div class="item-header flex-between"><div class="ft_18_600_black2 header">Material / Equipment Orders</div><div class=flex-center><div class="ft_12_regular_black work-type-label">Supplier</div><selectbox-input ng-model=supplier class="select-item ft_12_600_black" options=supplierOptions label-field=name value-field=_id select-event=selectSupplier(supplier)></selectbox-input></div></div><div class=table-container><spinner ng-if=loading></spinner><table class=w-100><thead><tr><th class=ft_12_600_moreblack>PO No.</th><th class=ft_12_600_moreblack>Date</th><th class=ft_12_600_moreblack>Supplier Name</th><th class=ft_12_600_moreblack>Amount</th><th class=ft_12_600_moreblack>Status</th></tr></thead><tbody><tr ng-repeat="order in orders"><td class=ft_12_600_gray>{{order.systemTag}}</td><td class=ft_12_600_gray>{{order.date | smartDate}}</td><td class=ft_12_600_gray>{{order.supplierName}}</td><td class=ft_12_600_gray>{{currency}} {{order.total | readable: 2}}</td><td class=ft_12_600_gray><div class="status-tag flex-center" ng-class="\'type-\'+order.status">{{order.status}}</div></td></tr></tbody></table></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-pipeline/dashboard-pipeline.view.html','<div class=dashboard-pipeline ng-style="{\'height\': height + \'px\'}"><div class="item-header flex-between"><div class="ft_18_600_black2 header" ng-if="type == \'pipeline\'">Pipeline</div><div class="ft_18_600_black2 header" ng-if="type == \'tenderStatus\'">Tender Status</div><div class="ft_18_600_black2 header" ng-if="type == \'project\'">On-going Projects</div><div class="ft_18_600_black2 header" ng-if="type == \'material\'">Material / Equipment Orders</div><div class="ft_18_600_black2 header" ng-if="type == \'tenderInvites\'">Tender Invites</div><div class="ft_18_600_black2 header" ng-if="type == \'offersReceived\'">Offers Received</div><div class=flex-center><div class="ft_12_regular_black work-type-label" ng-if="type == \'project\'">Type of Building</div><selectbox-input ng-if="type == \'project\'" ng-model=buildingTypeId class="select-item ft_12_600_black" options=buildingTypes label-field=tagName value-field=_id on-change=onChangeBuildingType(buildingTypeId)></selectbox-input><div class="ft_12_regular_black work-type-label" ng-if="type == \'tenderStatus\'">Project</div><selectbox-input ng-if="type == \'tenderStatus\'" ng-model=project class="select-item ft_12_600_black" options=projectOptions label-field=label value-field=value></selectbox-input><div class="ft_12_regular_black work-type-label" ng-if="type == \'tenderInvites\'">Tender for</div><selectbox-input ng-show="type == \'tenderInvites\'" ng-model=projectId class="select-item ft_12_600_black" options=ongoingProjects label-field=projectName value-field=_id change-trig=fetchRFPs()></selectbox-input><div class="ft_12_regular_black work-type-label" ng-if="type == \'offersReceived\'">Tender for</div><selectbox-input ng-show="type == \'offersReceived\'" ng-model=projectId class="select-item ft_12_600_black" options=ongoingProjects label-field=projectName value-field=_id change-trig=fetchOffers()></selectbox-input><!--      <button class="btn_primary_25">View All</button>--></div></div><div class="table-container pipeline-table"><table class=w-100 ng-if="type == \'pipeline\'"><thead><tr><th class="ft_12_600_black d-flex"><label class="check_yellow_16 checkall"><input type=checkbox value=false> <span class=checkmark_16></span></label></th><th class=ft_12_600_black>Project Name</th><th class=ft_12_600_black>Status</th><th class=ft_12_600_black>Type</th><th class=ft_12_600_black>Start Date</th><th class=ft_12_600_black>End Date</th><th class=ft_12_600_black>Location</th></tr></thead><tbody><tr ng-repeat="x in [].constructor(10) track by $index"><td class=d-flex><label class="check_yellow_16 check"><input type=checkbox value=false> <span class=checkmark_16></span></label></td><td class=ft_12_600_gray>Johnson & Johnson</td><td class=ft_12_600_gray>Tender</td><td class=ft_12_600_gray>Hospital</td><td class=ft_12_600_gray>01/03/2020</td><td class=ft_12_600_gray>01/03/2020</td><td class=ft_12_600_gray>Hong Kong</td></tr></tbody></table></div><div class="table-container tender-status-table"><table class=w-100 ng-if="type == \'tenderStatus\'"><thead><tr><th class="ft_12_600_black d-flex"><label class="check_yellow_16 checkall"><input type=checkbox value=false> <span class=checkmark_16></span></label></th><th class=ft_12_600_black>Tender ID</th><th class=ft_12_600_black>Tender for</th><th class=ft_12_600_black>Project Name</th><th class=ft_12_600_black>Status</th></tr></thead><tbody><tr ng-repeat="item in data track by $index"><td class=d-flex><label class="check_yellow_16 check"><input type=checkbox value=false> <span class=checkmark_16></span></label></td><td class=ft_12_600_gray>{{item.systemTag}}</td><td class=ft_12_600_gray>{{item.client ? item.client.clientName : \'\'}}</td><td class=ft_12_600_gray>{{item.projectName}}</td><td class=ft_12_600_gray><div class="status-tag flex-center" ng-class="\'type-\'+item.projectStatus">{{tenderStatusList[item.projectStatus]}}</div></td></tr></tbody></table></div><div class="table-container project-table pos-relative"><spinner ng-if="type == \'project\' && loading"></spinner><table class="w-100 project-table" ng-if="type == \'project\'"><thead><tr><th class="ft_12_600_black d-flex"><label class="check_yellow_16 checkall"><input type=checkbox value=false> <span class=checkmark_16></span></label></th><th class=ft_12_600_black>Project ID</th><th class=ft_12_600_black>Project Name</th><th class=ft_12_600_black>Type of Building</th><th class=ft_12_600_black>Status</th></tr></thead><tbody><tr ng-repeat="item in ongoingProjects | filter: {_id: \'!all\'} track by $index"><td class=d-flex><label class="check_yellow_16 check"><input type=checkbox value=false> <span class=checkmark_16></span></label></td><td class=ft_12_600_gray>{{item.systemTag}}</td><td class=ft_12_600_gray>{{item.projectName}}</td><td class=ft_12_600_gray>{{item.buildingType.tagName}}</td><td class=ft_12_600_gray><div class="status-tag flex-center" ng-class="\'type-\'+item.projectStatus">{{projectStatusList[item.projectStatus]}}</div></td></tr></tbody></table></div><div class="table-container tender-invites-table pos-relative"><spinner ng-if="type == \'tenderInvites\' && loading"></spinner><table class=w-100 ng-show="type == \'tenderInvites\'"><thead><tr><th class=ft_12_600_black><label class="check_yellow_16 checkall"><input type=checkbox ng-model=selectedAllRFPs ng-change=selectAllRFPs()> <span class=checkmark_16></span></label></th><th class=ft_12_600_black>Request ID</th><th class=ft_12_600_black>Tender for</th><th class=ft_12_600_black>Supplier Name</th><th class=ft_12_600_black>Status</th></tr></thead><tbody><tr ng-repeat="rfp in rfps track by $index"><td><label class="check_yellow_16 check"><input type=checkbox ng-model=rfp.selected ng-change=selectRFP()> <span class=checkmark_16></span></label></td><td class=ft_12_regular_gray>{{rfp.code}}</td><td class=ft_12_600_black>{{rfp.projectId.projectName}}</td><td class=ft_12_regular_gray>{{getRFPSupplierNames(rfp.staffs)}}</td><td class=ft_12_regular_gray><div class="status-tag flex-center" ng-style=getRFPStatusStyle(rfp.status)>{{rfp.status}}</div></td></tr></tbody></table></div><div class="table-container offers-received-table pos-relative"><spinner ng-if="type == \'offersReceived\' && loading"></spinner><table class=w-100 ng-show="type == \'offersReceived\'"><thead><tr><th class=ft_12_600_black><label class="check_yellow_16 checkall"><input type=checkbox ng-model=selectedAllOffers ng-change=selectAllOffers()> <span class=checkmark_16></span></label></th><th class=ft_12_600_black>Request ID</th><th class=ft_12_600_black>Vendor Name</th><th class=ft_12_600_black>Tender for</th><th class=ft_12_600_black>Amount</th></tr></thead><tbody><tr ng-repeat="offer in offers track by $index"><td><label class="check_yellow_16 check"><input type=checkbox value=false ng-model=offer.selected ng-change=selectOffer()> <span class=checkmark_16></span></label></td><td class=ft_12_regular_gray>{{offer.code}}</td><td class=ft_12_regular_gray ng-if=offer.userId>{{offer.userId.displayName}}</td><td class=ft_12_regular_gray ng-if="!offer.userId && offer.clientId">{{offer.clientId.clientName}}</td><td class=ft_12_regular_gray ng-if="!offer.userId && !offer.clientId"></td><td class=ft_12_regular_gray>{{offer.projectId.projectName}}</td><td class=ft_12_regular_gray>{{companyData.currentCurrency.symbol}} {{offer.amount || offer.offerTotal | readable: 2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-project-members/dashboard-project-members.view.html','<div class=dashboard-project-members><div class=block-header><div class=block-title>Project Members</div><selectbox-input class="select-options ml-auto" options=workTypes ng-model=workType label-field=label value-field=_id select-event=selectWorkType()></selectbox-input><selectbox-input class="select-options ml-16" options=roles ng-model=role label-field=label value-field=_id select-event=selectRole()></selectbox-input><div class="action-button ml-16" ui-sref=employees translate="View All"></div></div><div class=block-body><spinner ng-if=loading></spinner><div class=w-100 ng-if="members.length !== 0"><div class=member-header><div class=check><input type=checkbox ng-model=isCheckAll></div><div class=cell>Employee Name</div><div class=cell>Phone Number</div><div class=cell>Email ID</div><div class=cell>Department</div><div class=cell>Role</div><div class=cell>Certificate</div></div><div class=member-item ng-repeat="member in members track by $index"><div class=check><input type=checkbox ng-model=member.checked></div><div class=cell>{{member.displayName}}</div><div class=cell>{{member.mobile.phoneNumber}}</div><div class=cell>{{member.email}}</div><div class=cell>{{member.department || "Employee"}}</div><div class=cell>{{member.role.name || "Worker"}}</div><div class=cell></div></div></div><div class=empty-data ng-if="!loading && members.length === 0">No Display Data</div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-project-summary/dashboard-project-summary.view.html','<div class=project-summary><img ng-src="{{project.projectImage? project.projectImage: \'/assets/images/dashboard/project_logo.png\'}}" alt=logo class="inline-block project-logo object-fit-cover mr-10"><div class=project-content ng-show=project><div class="d-flex justify-content-between" ng-if="project && project._id != \'all\'"><div class="ft-normal-14-24 grey-2">#{{project.systemTag}}</div><div class="d-flex project-type" translate="{{project.projectStatus | projStatus}}"></div></div><div class="tx-ellipsis project-name" title={{project.projectName}} ui-sref="projectDetail({id: project._id})" ng-if="projects.length > 0 || (project && project._id != \'all\')">{{project.projectName}}</div><div class="tx-ellipsis project-name" title={{project.projectName}} ui-sref="projectDetail({id: project._id})" ng-if="projects.length == 0 && (!project || project._id == \'all\')" translate="No Projects"></div><div ng-if=project.address.loc.position class="project-address tx-ellipsis" title={{project.address.loc.position}}>{{project.address.loc.position}}</div><div class="flex mt-24"><div class=members ng-if="members.length != 0"><img ng-repeat="member in members | limitTo: 4" ng-src="{{member.userId.profilePic || \'/assets/icons/bx-user.svg\'}}" alt=avatar> <span class="ft-normal-16-24 grey-2 ml-8"><span class=ft-600-16-24>{{members.length}} </span><span class=ft-600-16-24 translate="people are working"></span></span></div><div class="no-member ft-normal-16-24 grey-2" ng-if="members.length == 0" translate="No people is working"></div></div><div class="flex mt-24"><div ng-if=project.startDate class="flex flex-1"><div><img src=/assets/icons/bx-calendar-grey2.svg alt=date></div><div class="ml-8 grey-2"><div class=ft-600-16-24>{{project.startDate | date : \'MMM d, yyyy\' : \'UTC\' }}</div><div class=ft-normal-14-24 translate="Start Date"></div></div></div><div ng-if=project.endDate class="flex flex-1"><div><img src=/assets/icons/bx-calendar-grey2.svg alt=date></div><div class="ml-8 grey-2"><div class=ft-600-16-24>{{project.endDate | date : \'MMM d, yyyy\' : \'UTC\' }}</div><div class=ft-normal-14-24 translate="End Date"></div></div></div><div ng-if=project.duration class="flex flex-1"><div><img src=/assets/icons/bx-clock.svg alt=clock></div><div class="ml-8 grey-2"><div class=ft-600-16-24>{{project.duration}} <span translate=Days></span></div><div class=ft-normal-14-24 translate=Duration></div></div></div></div><div class="flex mt-20"><div><img src=/assets/icons/domain.svg alt=domain></div><div class="ml-8 w-100"><div class="flex-between grey-2"><div class=ft-600-16-24 translate="Project Status"></div><div class=ft-normal-14-24>{{progress}}% <span translate=Completed></span></div></div><div class="project-progress mt-10"><div class=progress-value ng-style="{width: progress + \'%\'}"></div></div></div></div></div><div ng-show=!project class="ft_24_600_gray w-100 text-center no-project">No Project to Display</div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-project-timeline/dashboard-project-timeline.view.html','<div class=dashboard-project-timeline><div class=block-header><div class=block-title translate="Project Timeline"></div><div class=action-button ng-click=gotoTimeline()><img src=/assets/icons/fullscreen.svg alt=icons></div></div><div class="timeline-content d-flex align-items-center justify-content-center"><div dhx-gantt id=dhx-gantt data=ganttData resources=resourceData styles=styles deadline=deadline on-worker-count=getWorkerCount on-total-count=getTotalCount ng-if="projects.length > 0"></div><div class=block-title ng-if="projects.length == 0">No Projects</div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-qshe-manage/dashboard-qshe-manage.view.html','<div class=dashboard-qshe-manage><div class=header><div class=levels><div class="ft_14_500_white mr-15">Floors</div><div ng-repeat-start="level in levels track by $index" ng-if="level.plans.length === 1" class=level ng-click=changePlan(level.plans[0]) ng-class="{active: level.name === selectedPlan.assetObj.level}" title={{level.name}}>{{level.name}}</div><div ng-repeat-end=level class=dropdown ng-if="level.plans.length > 1"><div class="level dropdown-toggle" data-toggle=dropdown ng-class="{active: level.name === selectedPlan.assetObj.level}" title={{level.name}}>{{level.name}}</div><div class=dropdown-menu role=menu><li class=plan-item ng-repeat="plan in level.plans" ng-click=changePlan(plan)>{{plan.assetObj.title}}</li></div></div></div><div class=d-flex><div class=mr-8 ng-if="sideMenu === \'Registration\'"><button class="btn btn-blue" ng-if=selectedPlan.registrations.length ng-click=toggleRegistrationsSideMenu(true)><img src=/assets/icons/info.svg alt=info> {{selectedPlan.registrations.length}} New Registrations</button> <button class="btn btn-gray" ng-if="!selectedPlan.registrations || !selectedPlan.registrations.length" disabled><img src=/assets/icons/info.svg alt=info> No Registrations</button></div><div class=mr-8 ng-if="sideMenu === \'Issue\'"><button class="btn btn-blue" ng-if=selectedPlan.issues.length ng-click=toggleIssuesSideMenu(true)><img src=/assets/icons/info.svg alt=info> {{selectedPlan.issues.length}} New Issues</button> <button class="btn btn-gray" ng-if="!selectedPlan.issues || !selectedPlan.issues.length" disabled><img src=/assets/icons/info.svg alt=info> No Issues</button></div><div class=dropdown><img class=cursor-point id=change-side-menu data-toggle=dropdown aria-haspopup=true aria-expanded=false src=/assets/icons/chevron-down-white.svg alt=icons><div class=dropdown-menu aria-labelledby=change-side-menu><a class="dropdown-item cursor-point ft_12_regular_black" ng-click="changeSideMenu(\'Issue\')">Issues</a> <a class="dropdown-item cursor-point ft_12_regular_black" ng-click="changeSideMenu(\'Registration\')">Registrations</a></div></div></div></div><div class=qshe-content><div id=loading class=loading><img src=/assets/images/cgviewer/cloud_loading.gif></div><div class="pos-relative no-zoom" style="width: 100%; height: 100%;"><div id=vp-viewer></div><div ng-show=issue class=pos-absolute ng-style=getIssueDetailViewStyle()><div class="sb-box sb-effect" ng-click=closeIssueDetailView()><div class="flex-items-center mb-8"><div class=ft_14_regular_gray>{{issue.systemTag}}</div><div class="status open" ng-if=issue.status>{{issue.status}}</div></div><div class="ft_14_600_black mb-8 text-left" ng-if=issue.title>{{issue.title}}</div><div class=flex-items-center><div class="ft_14_regular_gray mr-1">Category:</div><div class=ft_14_600_black>{{issue.issueCategory || issue.registrationType}}</div></div></div></div></div><side-menu-issues ng-if=selectedPlan.issues ng-model=selectedPlan.issues></side-menu-issues><side-menu-registrations ng-if=selectedPlan.registrations ng-model=selectedPlan.registrations></side-menu-registrations></div><div class=footer><div class="zoom-bar d-flex align-items-center"><div class=slidecontainer><img src=/assets/icons/arrow-left-white.svg alt="left-right icon" class=cursor-point ng-click=viewer.undo()> <img src=/assets/icons/arrow-right-white.svg alt="left-right icon" class="mr-10 cursor-point" ng-click=viewer.redo()> <input type=range min=50 max=1000 value=100 class=slider id=zoom-range ng-change=zoomSlider(zoomLevel) ng-model=zoomLevel> <span class=zoomRangeTxt>{{zoomLevel}} %</span></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-quality-block/dashboard-quality-block.view.html','<div class=dashboard-quality-block><div class=block-header><div class=block-title>Quality & Safety Status</div><div class=action-button ui-sref=issuesList translate="View All"></div></div><div class=block-body><div class="ft-normal-14-20 grey-2 mt-12">Get an overview on all safety issues</div><div class="flex-around mt-52"><div ng-repeat="item in items"><div class="percent mx-auto"><svg><circle cx=36 cy=36 r=32></circle><circle cx=36 cy=36 r=32 ng-style=getProgressStyle(item)></circle></svg><div class=number>{{(item.percent * 100) | readable: 0}}%</div></div><div class="ft-600-14-24 grey-2 text-center item-name">{{item.name}}</div></div></div><div class="control-bar mt-56"><div class=none ng-class="{active: status==\'none\'}" ng-click="status=\'none\'">None</div><div class=moderate ng-class="{active: status==\'moderate\'}" ng-click="status=\'moderate\'">Moderate</div><div class=serious ng-class="{active: status==\'serious\'}" ng-click="status=\'serious\'">Serious</div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-side-menu/dashboard-side-menu.view.html','<div class=dashboard-side-menu><div class=menu-button ng-click="gotoPage(\'vpGrid\', VP_ACCESS_CREATE > 0)"><img src=/assets/icons/visual-planner.svg alt=icons class=icon><div class=item-label translate="Visual Planner"></div></div><div class="menu-button mt-8" ng-click="gotoPage(\'fileManage\', FMANAGER_ACCESS_CREATE > 0, true)"><img src=/assets/icons/file-manager.svg alt=icons class=icon><div class=item-label translate="File Manager"></div></div><div class="menu-button mt-8" ng-click="gotoPage(\'controlPlanGrid\', CPLAN_ACCESS_CREATE > 0, true)"><img src=/assets/icons/control-plan.svg alt=icons class=icon><div class=item-label translate="Control Plan1"></div></div><div class="menu-button mt-8" ng-click="gotoPage(\'issuesList\', ISSUE_ACCESS_CREATE > 0)"><img src=/assets/icons/project-issues.svg alt=icons class=icon><div class=item-label translate="Project Issues"></div></div><div class="menu-button mt-8" ng-click="gotoPage(\'reportsList\', REPORT_ACCESS_CREATE > 0)"><img src=/assets/icons/chart.svg alt=icons class=icon><div class=item-label translate="Project Reports"></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-site-manage/dashboard-site-manage.view.html','<div class=dashboard-site-manage><div class=header><div class=models><div class="ft_14_500_white mr-15">Models</div><div class=model ng-click=changeToGIS() ng-class="{active: isGIS}">GIS</div><!--      <div--><!--        class="model"--><!--        ng-repeat="model in models track by $index"--><!--        ng-click="changeModel(model)"--><!--        ng-class="{active: model._id === selectedModel._id && !isGIS}">--><!--        <span class="text-ellipsis" title="{{model.name}}">{{model.name}}</span>--><!--      </div>--></div><div class=d-flex><div class=mr-8 ng-if="!isGIS && sideMenu === \'Issue\'"><button class="btn btn-blue" ng-if=selectedModel.issues.length ng-click=toggleIssuesSideMenu(true)><img src=/assets/icons/info.svg alt=info> {{selectedModel.issues.length}} New Issues</button> <button class="btn btn-gray" ng-if="!selectedModel.issues || !selectedModel.issues.length" disabled><img src=/assets/icons/info.svg alt=info> No Issues</button></div><div class=mr-8 ng-if="!isGIS && sideMenu === \'Registration\'"><button class="btn btn-blue" ng-if=selectedModel.registrations.length ng-click=toggleRegistrationsSideMenu(true)><img src=/assets/icons/info.svg alt=info> {{selectedModel.registrations.length}} New Registrations</button> <button class="btn btn-gray" ng-if="!selectedModel.registrations || !selectedModel.registrations.length" disabled><img src=/assets/icons/info.svg alt=info> No Registrations</button></div><div class=dropdown ng-if=!isGIS><img class=cursor-point id=change-side-menu data-toggle=dropdown aria-haspopup=true aria-expanded=false src=/assets/icons/chevron-down-white.svg alt=icons><div class=dropdown-menu aria-labelledby=change-side-menu><a class="dropdown-item cursor-point ft_12_regular_black" ng-click="changeSideMenu(\'Issue\')">Issues</a> <a class="dropdown-item cursor-point ft_12_regular_black" ng-click="changeSideMenu(\'Registration\')">Registrations</a></div></div></div></div><div class=content><div id=loading class=loading><img src=/assets/images/cgviewer/cloud_loading.gif></div><div ng-show=isGIS map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params="https://maps.googleapis.com/maps/api/js?key=AIzaSyA3MIA-mKWq_60q1K0zOHguraxT-1QPxNU&libraries=places"><ng-map center="{{ gmap.center }}" zoom="{{ gmap.zoom }}" id=service_map><marker ng-repeat="marker in gmap.markers track by $index" position="{{ marker.coordinates }}" on-click=gotoDetail($event) icon="{url: \'/assets/images/cgviewer/vp-issue-completed.svg\', scaledSize: [50, 50], origin: [0,0], anchor: [0,0]}"></marker><!--        <custom-marker ng-repeat="marker in gmap.markers track by $index" position="{{ marker.coordinates }}">--><!--          <div>--><!--            <div class="sb-box">--><!--              <img class="thumbnail" ng-src="{{marker.model.thumbnail || \'assets/images/materials/noImg.jpg\'}}" alt="">--><!--              <div class="title" title="{{marker.model.name}}">{{marker.model.name}}</div>--><!--            </div>--><!--          </div>--><!--        </custom-marker>--></ng-map></div><div ng-show=!isGIS id=model-viewer class="no-zoom render-3d"></div><side-menu-issues ng-if=selectedModel.issues ng-model=selectedModel.issues></side-menu-issues><side-menu-registrations ng-if=selectedModel.registrations ng-model=selectedModel.registrations></side-menu-registrations></div><div class=footer><div class="zoom-bar d-flex align-items-center"><div class=slidecontainer><img src=/assets/icons/arrow-left-white.svg alt="left-right icon" class=cursor-point ng-click=viewer3d.undo()> <img src=/assets/icons/arrow-right-white.svg alt="left-right icon" class="mr-10 cursor-point" ng-click=viewer3d.redo()> <input type=range min=50 max=1000 value=100 class=slider id=zoom-range ng-change=zoomSlider(zoomLevel) ng-model=zoomLevel> <span class=zoomRangeTxt>{{zoomLevel}} %</span></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-submit-offer/dashboard-submit-offer.view.html','<div class=dashboard-submit-offer><spinner ng-if=isLoading></spinner><div class=collaboration-content><div class="table-container pos-relative"><spinner ng-if=isLoading></spinner><div class=thead><div class=tr><div class="td check-item"><!-- <label class="check_yellow_16 check">\n              <input type="checkbox" ng-model="selectedAll" ng-change="selectAllOffers()" />\n              <span class="checkmark_16"></span>\n            </label> --></div><div class="d-flex main-td-group"><div class="td work-type" translate="Bid Package"></div><div class="td system-tag" translate="SYS Tag"></div><div class="td collaborator" translate=Collaborator></div><div class="td staff-container" translate=Staff></div><div class="td status" translate=Status></div><div class="td levels" translate=Levels></div><div class="td no-of-days" translate=Days></div><div class="td no-of-days" translate=""></div><div class="td no-of-days" translate=""></div><div class="td offer-amount" translate="Offer Amount"></div><div class="td best" translate=""></div></div><div class="td actions" translate=Actions></div></div></div><div class=tbody><div ng-repeat="bid in bidPackages track by $index"><div class=tr><div class="td check-item"><!-- <label class="check_yellow_16 check">\n                <input type="checkbox" ng-model="offer.selected" ng-change="selectOffer(offer)" />\n                <span class="checkmark_16"></span>\n              </label> --></div><div class="d-flex main-td-group"><div class="td work-type">{{bid.title}}</div><div class="td system-tag">{{ bid.systag }}</div><div class="td collaborator">{{getCollaborator(bid)}}</div><div class="td staff-container">{{getBidStaffs(bid)}}</div><div class="td status"><div><div ng-class=getOfferStatusClass(getBidStatus(bid))>{{getBidStatus(bid)}}</div><!-- <img class=""\n                    ng-src="{{getBidStatus(bid) == \'Accepted\' ? \'/assets/icons/check-offer-status-f.svg\' : \'/assets/icons/check-offer-status.svg\'}}"\n                    alt="">\n                  <img class="ml-8"\n                    ng-src="{{getBidStatus(bid) == \'Decliended\' ? \'/assets/icons/close-offer-status-f.svg\' : \'/assets/icons/close-offer-status.svg\'}}"\n                    alt="">\n                  <img class="ml-8"\n                    ng-src="{{getBidStatus(bid) == \'Paused\' ? \'/assets/icons/pause-offer-status_f.svg\' : \'/assets/icons/pause-offer-status.svg\'}}"\n                    alt=""> --></div></div><div class="td levels">{{calcBidLevels(bid)}}</div><div class="td no-of-days">{{calcBidDays(bid)}}</div><div class="td no-of-days"></div><div class="td no-of-days"></div><div class="td offer-amount">{{companyData.currentCurrency.symbol}} {{calcBidOfferAmount(bid) | readable: 2}}</div><div class="td best"><button class="btn income-offer-button" ng-if=calcBest(bid)>{{calcBest(bid)}} best</button></div></div><div class="td actions"><img class=mr-16 src=/assets/icons/file-gray.svg alt=""> <img class=mr-16 ng-src="{{bid.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}" ng-click="bid.expanded = !bid.expanded" alt=""></div></div><div class="tr offers-panel" ng-repeat-start="offer in bid.offers" ng-show=bid.expanded><div class="td check-item"></div><div class="d-flex main-td-group"><div class="td work-type"></div><div class="td system-tag"></div><div class="td collaborator">{{offer.supplierId.name}}</div><div class="td staff-container">{{offer.staffId.displayName}}</div><div class="td status"><div><!-- <img class="" ng-click="updateStatus(offer, \'Accepted\')"\n                    ng-src="{{offer.status == \'Accepted\' ? \'/assets/icons/check-offer-status-f.svg\' : \'/assets/icons/check-offer-status.svg\'}}"\n                    alt="">\n                  <img class="ml-8" ng-click="updateStatus(offer, \'Decliended\')"\n                    ng-src="{{offer.status == \'Decliended\' ? \'/assets/icons/close-offer-status-f.svg\' : \'/assets/icons/close-offer-status.svg\'}}"\n                    alt="">\n                  <img class="ml-8" ng-click="updateStatus(offer, \'Paused\')"\n                    ng-src="{{offer.status == \'Paused\' ? \'/assets/icons/pause-offer-status_f.svg\' : \'/assets/icons/pause-offer-status.svg\'}}"\n                    alt=""> --><div ng-class=getOfferStatusClass(offer.status)>{{offer.status}}</div></div></div><div class="td levels">{{offer.levels.length}}</div><div class="td no-of-days">{{calcOfferDays(offer)}}</div><div class="td no-of-days"></div><div class="td no-of-days"></div><div class="td offer-amount">{{companyData.currentCurrency.symbol}} {{calcOfferAmount(offer) | readable: 2}}</div><div class="td best"></div></div><div class="td actions flex-content-end"><img class=mr-16 ng-src="{{offer.expanded ? \'/assets/icons/chevron-down-gray.svg\' : \'/assets/icons/chevron-right-gray.svg\'}}" ng-click="offer.expanded = !offer.expanded" alt=""></div></div><div ng-repeat-end="offer in bid.offers" ng-show=offer.expanded><div class=groups-panel ng-show=offer.expanded><!-- <div class="group-name">{{group.name}}</div> --><div class="d-flex justify-content-between"><div class=d-flex><div class=levels-tab ng-click=selectGroup(offer) ng-class="{\'active\': offer.selectedGroup.name == \'All\'}">All</div><div class=levels-tab ng-repeat="group in offer.groups" ng-click="selectGroup(offer, group)" ng-class="{\'active\': offer.selectedGroup == group}">{{group.name}}</div></div><div class=d-flex><input class=hidden id=fileSelector ngf-select ngf-pattern="\'.xlsx\'" ngf-multiple=false ngf-accept="\'.xlsx\'" ngf-change=SelectFile($file)> <button class="btn income-offer-button mr-10" ng-if="offer.selectedGroup.name != \'All\'" ng-click=attachExcelFiles(offer)>Upload</button> <button class="btn income-offer-button" ng-click=saveOfferSubmit(offer)>Save</button></div></div><div class=group-table><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><label translate=Name></label></div><div class=col-3><label translate=Type></label></div><div class=col-2><label translate=Level></label></div><div class=col-3><label translate=Size></label></div></div></div><div class=col-7><div class=row><div class=col-4><label translate=Description></label></div><div class=col-1><label translate=Days></label></div><div class=col-1><label translate=Quanties></label></div><div class=col-1><label translate=Unit></label></div><div class=col-2><label translate="Unit Price"></label></div><div class=col-3><label translate="Offer Amount"></label></div></div></div></div></div><div ng-repeat="item in offer.selectedGroup.levels track by $index"><div class=item-break></div><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><!-- <input type="text" ng-model="item.name" class="login_input_new_no_mt"> --><div class=overflow-wrap>{{item.name}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.type" class="login_input_new_no_mt"> --><div>{{item.type}}</div></div><div class=col-2><!-- <input type="text" ng-model="item.level" class="login_input_new_no_mt"> --><div>{{item.level}}</div></div><div class=col-3><!-- <input type="text" ng-model="item.size" class="login_input_new_no_mt"> --><div>{{item.size}}</div></div></div></div><div class=col-7><div class=row><div class=col-4><!-- <input type="text" class="login_input_new_no_mt" ng-model="item.description"> --><div>{{item.description}}</div></div><div class=col-1><input type=text number-edit ng-model=item.days class="login_input_new_no_mt text-right"><!-- <div>{{item.days}}</div> --></div><div class=col-1><input type=text number-edit ng-model=item.quantity class="login_input_new_no_mt text-right"><!-- <div>{{item.quantity}}</div> --></div><div class=col-1><input type=text ng-model=item.unit class="login_input_new_no_mt text-right"><!-- <div>{{item.unit}}</div> --></div><div class=col-2><input type=text number-edit ng-model=item.unitPrice class="login_input_new_no_mt text-right"><!-- <div>{{item.unitPrice}}</div> --></div><div class=col-3><input type=text number-edit ng-model=item.amount class="login_input_new_no_mt text-right"><!-- <div>{{item.amount}}</div> --></div></div></div></div></div></div><div class=item-break></div><div class=item><div class="info row"><div class=col-5><div class=row><div class=col-4><label translate=""></label></div><div class=col-3><label translate=""></label></div><div class=col-2><label translate=""></label></div><div class=col-3><label translate=""></label></div></div></div><div class=col-7><div class=row><div class=col-4><label translate=Sum></label></div><div class=col-1><label>{{calcGroupDays(offer.selectedGroup)}}</label></div><div class=col-1><label>{{calcGroupQuantity(offer.selectedGroup)}}</label></div><div class=col-1><label translate=""></label></div><div class=col-2><label translate=""></label></div><div class=col-3><label>{{calcGroupOfferAmount(offer.selectedGroup)}}</label></div></div></div></div></div></div><!-- <div class="tr levels-panel" ng-repeat="lv in group.levels" ng-show="offer.expanded">\n                <div class="td check-item"></div>\n                <div class="d-flex main-td-group">\n                  <div class="td work-type"></div>\n                  <div class="td offername">{{offer.bidPackageId.sysTag + \'-\' + ($index + 1)}}</div>\n                  <div class="td coordinator"></div>\n                  <div class="td levels"></div>\n                  <div class="td no-of-days">{{lv.name}}</div>\n                  <div class="td offer-amount">{{lv.description}}</div>\n                  <div class="td status">{{lv.type}}</div>\n                  <div class="td status">{{lv.level}}</div>\n                  <div class="td status">{{lv.size}}</div>\n                </div>\n                <div class="td actions"></div>\n              </div> --></div></div><!-- <div ng-repeat-end="offer in bid.offers" ng-show="offer.expanded">\n            <div class="tr levels-panel">\n              <div class="td check-item"></div>\n              <div class="d-flex main-td-group">\n                <div class="td work-type ft_14_600_black2" translate="Name"></div>\n                <div class="td system-tag ft_14_600_black2" translate="SYS Tag"></div>\n                <div class="td collaborator ft_14_600_black2" translate="Description"></div>\n                <div class="td coordinator ft_14_600_black2" translate="Type"></div>\n                <div class="td size ft_14_600_black2" translate="Size"></div>\n                <div class="td status">\n\n                </div>\n                <div class="td levels ft_14_600_black2" translate="Levels"></div>\n                <div class="td no-of-days ft_14_600_black2" translate="Days"></div>\n                <div class="td no-of-days ft_14_600_black2" translate="Quantity"></div>\n                <div class="td no-of-days ft_14_600_black2" translate="Unit Price"></div>\n                <div class="td offer-amount ft_14_600_black2" translate="Offer Amount"></div>\n                <div class="td best"></div>\n              </div>\n              <div class="td actions">\n                <input ng-if="offer.status==\'Paused\'" class="hidden" id="fileSelector" ngf-select ngf-pattern="\'.xlsx\'"\n                  ngf-multiple="false" ngf-accept="\'.xlsx\'" ngf-change="SelectFile($file)">\n                <div ng-if="offer.status==\'Paused\'" class="upload-btn mr-16" ng-click="attachExcelFiles(offer)"><i class="fa fa-cloud-upload-alt mr-2"></i></div>\n                <img ng-if="offer.status==\'Paused\'" class="cursor-point mr-16" ng-click="saveOfferSubmit(offer)"\n                  src="/assets/icons/save-blue.svg" alt="">\n              </div>\n            </div>\n            <div class="tr levels-panel" ng-repeat="lv in offer.levels">\n              <div class="td check-item"></div>\n              <div class="d-flex main-td-group">\n                <div class="td work-type">{{lv.name}}</div>\n                <div class="td system-tag">{{ bid.systag + \'-\' + ($index + 1) }}</div>\n                <div class="td collaborator">{{lv.description}}</div>\n                <div class="td coordinator">{{lv.type}}</div>\n                <div class="td size">{{lv.size}}</div>\n                <div class="td status"></div>\n                <div class="td levels">{{lv.level}}</div>\n                <div class="td no-of-days">\n                  <input ng-if="offer.status==\'Paused\'" class="input-style-for-level pr-10" ng-model="lv.days"\n                    style="width:90%" />\n                  <span ng-if="offer.status!=\'Paused\'">{{lv.days}}</span>\n                </div>\n                <div class="td no-of-days">\n                  <input ng-if="offer.status==\'Paused\'" class="input-style-for-level pr-10" ng-model="lv.quantity"\n                    ng-change="calcLevelAmount(lv)" style="width:90%" />\n                  <span ng-if="offer.status!=\'Paused\'">{{lv.quantity}}</span>\n                </div>\n                <div class="td no-of-days">\n                  <input ng-if="offer.status==\'Paused\'" class="input-style-for-level pr-10" ng-model="lv.unitPrice"\n                    ng-change="calcLevelAmount(lv)" style="width:90%" />\n                  <span ng-if="offer.status!=\'Paused\'">{{companyData.currentCurrency.symbol}} {{lv.unitPrice | readable: 2}}</span>\n                </div>\n                <div class="td offer-amount">\n                  <input ng-if="offer.status==\'Paused\'" class="input-style-for-level pr-10" ng-model="lv.amount"\n                    style="width:90%" />\n                  <span ng-if="offer.status!=\'Paused\'">{{companyData.currentCurrency.symbol}} {{lv.amount | readable: 2}}</span>\n                </div>\n                <div class="td best"></div>\n              </div>\n              <div class="td actions">\n\n              </div>\n            </div>\n            <div class="tr levels-panel">\n              <div class="td check-item"></div>\n              <div class="d-flex main-td-group">\n                <div class="td work-type ft_14_600_black2" translate="Sum"></div>\n                <div class="td system-tag ft_14_600_black2" translate=""></div>\n                <div class="td collaborator ft_14_600_black2" translate=""></div>\n                <div class="td coordinator ft_14_600_black2" translate=""></div>\n                <div class="td size ft_14_600_black2" translate=""></div>\n                <div class="td status">\n\n                </div>\n                <div class="td levels">{{offer.levels.length}}</div>\n                <div class="td no-of-days">{{calcOfferDays(offer)}}</div>\n                <div class="td no-of-days">{{calcOfferQuantity(offer)}}</div>\n                <div class="td no-of-days">{{companyData.currentCurrency.symbol}} {{calcOfferUnitPrice(offer) | readable: 2}}</div>\n                <div class="td offer-amount">{{companyData.currentCurrency.symbol}} {{calcOfferAmount(offer) |\n                  readable: 2}}</div>\n                <div class="td best"></div>\n              </div>\n              <div class="td actions"></div>\n            </div>\n          </div> --></div></div></div><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + offers.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=getOffers()></pagination-custom-new></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-subscribers-block/dashboard-subscribers-block.view.html','<div class=dashboard-subscribers-block><div class=block-header><div class=block-title translate=Subscribers></div><searchbox class=ml-auto is-small=true></searchbox><span class="ml-16 block-label">License</span><selectbox-input class="select-options ml-16" options=licenses ng-model=license label-field=label value-field=value></selectbox-input><span class="ml-16 block-label">Status</span><selectbox-input class="select-options ml-16" options=statuses ng-model=status label-field=label value-field=value></selectbox-input><div class="action-button ml-16" ui-sref=clientsGrid translate="View All"></div></div><div class=block-body><spinner ng-if=loading></spinner><div class=w-100 ng-if="offers.length !== 0"><div class=subscriber-header><div class=check><input type=checkbox ng-model=isCheckAll></div><div class=cell>Name</div><div class=cell>Contact No</div><div class=cell>Email ID</div><div class="cell status">License Type</div><div class=cell>Renewal Date</div><div class=cell>Status</div><div class=actions></div></div><div class=subscriber-item ng-repeat="item in subscribers track by $index"><div class=check><input type=checkbox ng-model=item.checked></div><div class=cell>{{item.name}}</div><div class=cell>{{item.contactNo}}</div><div class=cell>{{item.email}}</div><div class=cell>{{item.license}}</div><div class=cell>{{item.renewalDate}}</div><div class=cell>{{item.status}}</div><div class=actions></div></div></div><div class=empty-data ng-if="!loading && subscribers.length===0">No Display Data</div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-technical-queries-block/dashboard-technical-queries-block.view.html','<div class=dashboard-technical-queries-block><div class=block-header><div class=block-title translate="Technical Queries"></div></div><div class=block-menu><!-- <div class="query-menu" class="nav-items">\n      <nav class="navbar navbar-expand-lg navbar-light p-0">\n        <ul class="navbar-nav">\n          <li class="nav-item" ng-class="{active:discipline==disType}" ng-repeat="discipline in discipList" ng-click="setDiscipType(discipline)">\n            <a href="#">{{discipline}}</a>\n          </li>\n        </ul>\n      </nav>\n    </div> --><div class="tq-header flex-between"><div><div class="d-flex align-center justify-center"><div id=tq-menu-nav class=nav-items><nav class="navbar navbar-expand-lg navbar-light"><ul class=navbar-nav><li class=nav-item ng-class="{active:discipline==disType}" ng-repeat="discipline in discipList" ng-click=setDiscipType(discipline)><a href=#>{{discipline}}</a></li></ul></nav></div></div></div><searchbox class=ml-auto search-text=searchText search-event=searchTq() is-small=true></searchbox><div class="btn_create_tq ml-16" ng-click=onCreateTQ() ng-if="TQ_ACCESS_CREATE > 2"><i class="fa fa-plus ft-white mr-8"></i> <span class=ft-white translate="Create TQ"></span></div></div></div><div class="bodyScroll pos-relative"><div class=query-table><div class=table-header><div class=flex-3></div><div class=flex-12 translate=Title></div><div class=flex-10 translate=Progress></div><div class=flex-6 translate=Level></div><div class=flex-9 translate=Status></div><div class=flex-10 translate=Location></div><div class=flex-10 translate="Created by"></div><div class=flex-10 translate="Assigned To"></div><div class=flex-15 translate=Company></div><div class=flex-8 translate="Due Date"></div><div class=flex-3 translate=File></div><div class=flex-2><img src=/assets/icons/attach_file.svg></div><div class=flex-2><img src=/assets/icons/tq-message.svg></div><div class=flex-7></div></div><div class=table-body><div ng-repeat="tq in tqs track by $index"><div class=table-row><div class="flex-3 flex-center expander tq-cell"><img ng-src="{{tq.expand ? \'/assets/icons/arrow-drop-up-black.svg\' : \'/assets/icons/arrow-drop-down-black.svg\'}}" alt="" class=cursor-point ng-click=getData($index)></div><div class="flex-12 text-ellipsis tx-ellipsis name" title={{tq.title}}>{{tq.title}}</div><div class="flex-10 tq-progress"><div class="ft-12 line-height-16 fw-400 ft-gray1 w-100 text-align-center">{{tq.progress}}%</div><input type=range min=0 max=100 value={{tq.progress}} class=slider id=myRange ng-model=tq.progress ng-change=updateTq($index)></div><div class="flex-6 tx-ellipsis detail">{{tq.marker.model.info3d.levelName ? tq.marker.model.info3d.levelName : \'\'}}</div><div class="flex-9 tq-status"><selectbox-input ng-class=getTqStatusClass(tq.status) class=statusSelect ng-model=tq.status options=statusList label-field=label value-field=key placeholder="Select Status" select-event=updateTq($index)></selectbox-input></div><div class="flex-10 tx-ellipsis detail">{{tq.location}}</div><div class="flex-10 tx-ellipsis detail">{{tq.userId.displayName}}</div><div class="flex-10 tx-ellipsis detail">{{tq.assignedTo.displayName}}</div><div class="flex-15 tx-ellipsis detail">{{tq.companyId.companyName}}</div><div class=flex-8>{{tq.deadLine | date: "dd MMM yyyy" : \'UTC\' }}</div><div class="flex-3 tx-ellipsis file"><div class="d-flex align-items-center"><img src=/assets/icons/file-text.svg class=mr-8>{{tq.fileName}}</div></div><div class="flex-2 tq-table-count"><div class=tq-count>{{tq.attachCount}}</div></div><div class="flex-2 tq-table-count"><div class=tq-count>{{tq.commentCount}}</div></div><div class="flex-7 detail"></div></div><div class=table-child ng-if=tq.expand><div style="display: flex;height:460px;position:relative;"><spinner ng-if=isLoadingDetail></spinner><div class=detail-left-panel><div class=tq-header-control><div class="switch switch-sm"><input type=checkbox class=switch id=viewValue ng-disabled=isVP ng-model=isPlanViewer ng-checked=isPlanViewer> <label for=viewValue></label></div></div><div id=bimviewer class=bimviewerClass ng-show="!isVP && !isPlanViewer"></div><div id=model2d-container class=marking-viewer ng-show="!isVP && isPlanViewer"><div id=model2d class=marking-viewer></div></div><tqlisttoolbox on-selected=toolbarEvent data=toolbarList ng-if=!isVP></tqlisttoolbox><div id=tq-vp-viewer ng-if=isVP><tq-vp-detail-page ng-repeat="page in vppages" page=page ng-style="{\'visibility\': page===vpCurPage ? \'visible\' : \'hidden\'}"></tq-vp-detail-page><tqlisttoolbox on-selected=vpCurPage.toolbarEvent data=toolbarList ng-if=isVP></tqlisttoolbox></div></div><div class=tq-right-panel><div id=detail-menu class=nav-items><nav class="navbar navbar-expand-lg navbar-light" style="width: 100%;padding: 0px 0px !important;"><ul class=navbar-nav style="width: 100%"><li class=nav-item ng-class="{active: currentTab === \'attach\'}" ng-click="setCurrentTab(\'attach\')"><a href=# class=nav-link translate=Attachments></a></li><li class=nav-item ng-class="{active: currentTab === \'comment\'}" ng-click="setCurrentTab(\'comment\')"><a href=# class=nav-link translate=Comments></a></li><li class=nav-item ng-class="{active: currentTab === \'activity\'}" ng-click="setCurrentTab(\'activity\')"><a href=# class=nav-link translate=Activity></a></li></ul></nav></div><div ng-if="currentTab==\'attach\'" class=upload-box><div class=drag-drop-box ngf-drop ngf-change="fileUpdated($files, $event)" name=file ngf-multiple=true><div class=detail-drag-drop><span translate="Drag and Drop or"></span> <span class="ft-blue ph-5" ngf-select ngf-change="fileUpdated($files, $event)" name=file ngf-multiple=true translate=Browse></span></div></div></div><div ng-if="currentTab==\'attach\'" class=detail-attach-wrap><div class=upload-files ng-if="files && files.length"><div class=upload-file ng-repeat="file in files track by $index" ng-if="file.progressPercentage !== 100"><img class=file-icon ng-src={{utils.getTQFileIcon(file)}} alt=""><div class=progress-container><div class=progress-info><div class=file-name>{{file.name}}</div><div class=progress-value ng-if="file.progressPercentage !== 100">Uploading</div></div><div class=progress-bar><div class=real-progress ng-style="getStyleWidth(file.progressPercentage || 0)"></div></div></div><img ng-if="file.progressPercentage !== 100" class=cancel-icon src=/assets/icons/close-circle-f-gray.svg alt="" ng-click="cancelUpload(file, $index)"> <img ng-if="file.progressPercentage === 100" class=done-icon src=/assets/icons/mark-complete.svg alt=""></div></div><div class=upload-files ng-if=tqData.attachList><div class=upload-file ng-repeat="attach in tqData.attachList track by $index"><img class=file-icon ng-src={{attach.imgSrc}} alt=""><div class=progress-container><div class=progress-info><div class=file-name>{{attach.fileName}}</div><div class=progress-value>Uploaded by <span class="ft-12 line-height-16 fw-400 ft-tq-black1">{{attach.createdBy}} \u2022 </span>{{attach.createdAt | date :\'dd/MM/yyyy\' }}</div></div></div><img src=/assets/icons/Trash-alt.svg class="delete-ico cursor-point ml-8" ng-click=deleteAttach($index,attach._id)></div></div></div><div ng-if="currentTab==\'activity\'" class=detail-activity-wrap><div ng-repeat="activity in tqData.tqActivity track by $index" class=detail-activity-panel><div class=activity-avatar-panel><img src={{activity.pic}} class=activity-avatar><div class=activity-avatar-indicator></div></div><div class=activity-info-panel><div class="d-flex flex-between"><span class="ft-12 line-height-16 fw-600 ft-tq-black1">{{activity.userName}}</span> <span class="ft-12 line-height-16 fw-400 grey-4">{{activity.addedTime | date: "dd MMM yyyy HH:mm" : \'UTC\'}}</span></div><p class=activity-comment>{{activity.activity}}</p></div></div></div><div ng-if="currentTab==\'comment\'" class=detail-chat-wrap><div class=detail-content-chat><div class="chat-content-wrapper l-content"><div class=avatar><img src=/assets/images/tq/avatar/male.png></div><div class="chat-content-side ml-8"><div class=chat-time>Anika Westervelt 12:55:PM</div><div class="chat-content left">Hi I am Kaylynn. can you help me with the best Chat app.</div><div class="chat-content left">It should be from a premium company.</div></div></div><div class="chat-content-wrapper r-content"><div class="chat-content-side mr-8"><div class="chat-time right">Justin Vaccaro 01:55:PM</div><div class="chat-content right">Ok. Will check out and let you know.</div><div class="chat-content right">Sorry. I couldn\'t find them.</div></div><div class=avatar><img src=/assets/images/tq/avatar/female.png></div></div><div class="chat-content-wrapper l-content"><div class=avatar><img src=/assets/images/tq/avatar/male.png></div><div class="chat-content-side ml-8"><div class=chat-time>Anika Westervelt 02:30:PM</div><div class="chat-content left">Hi I am Kaylynn. can you help me with the best Chat app.</div><div class="chat-content left">It should be from a premium company.</div></div></div></div><div class=detail-live-chat><img src=/assets/icons/chat-add.svg> <input type=text class=detail-live-chat-input placeholder="Write your message"> <img src=/assets/icons/chat-emoticon.svg class=ml-12> <img src=/assets/icons/chat-send.svg class=ml-12></div></div></div></div></div></div></div></div></div><div class="flex flex-row pagination-footer flex-items-center"><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(currentPage - 1) * numPerPage + 1}} - <span>{{currentPage * numPerPage > totalCount? totalCount: currentPage * numPerPage}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=totalPages current-page=currentPage on-select-page=searchTq()></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-tender-requirements-block/dashboard-tender-requirements-block.view.html','<div class=dashboard-tender-requirements-block ng-style="{\'height\': height + \'px\'}"><div class="item-header flex-between"><div class="ft_16_600_black float-left">Tender Requirements</div><div class=float-right><button class=btn_primary_25 ui-sref=bidPackageAdd>+</button></div></div><div class=bodyScroll ng-style="{\'height\': (height - 81) + \'px\'}"><div ng-repeat="rfp in data track by $index"><div class=block><div class=ft_12_regular_gray>{{rfp.code}}</div><div class=ft_14_600_black>{{rfp.projectId.projectName}}</div><div class=flex-between><div class=ft_12_regular_gray><span class=ft_12_600_gray>Deadline: </span><span>{{rfp.proposalDeadline | date: \'MMM dd, yyyy\' : \'UTC\'}}</span></div><div class=flex-center><img ng-src={{utils.getFileIcon(rfp.requirement)}} alt="" class="icon-16 ml-4"><div class="ft_12_regular_black ml-4">{{rfp.requirement.originalname}}</div><img src=/assets/icons/file_download_yellow.svg alt="" class="icon-16 cursor-point ml-4" ng-click="utils.downloadFile(rfp.requirement.secure_url, rfp.requirement.originalname)"></div></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-today-task-block/dashboard-today-task-block.view.html','<div class=dashboard-today-task-block><div class=block-header><div class=block-title translate="Todays Task"></div><div class=action-button ng-click=addTask()>+ <span translate="Add Task0"></span></div></div><div class="bodyScroll pos-relative"><spinner ng-if=loading></spinner><div ng-repeat="item in tasks track by $index"><div class=item-container><div class=item-icon><img ng-src={{getIcon($index)}} alt=icon></div><div class=item-wrapper><div class=flex><div class="item-name tx-ellipsis" title={{item.title}}>{{item.title}}</div><div class=item-delete><img ng-src=/assets/icons/delete1.svg></div></div><div class=flex><img src=/assets/images/dashboard/clock.svg alt=icons class=clock><div class=item-date>{{item.date | date: \'dd MMM, yyyy\' : \'UTC\'}} | {{item.date | smartTime}}</div><div class="ml-auto status-tag flex-center" ng-class="\'type-\' + (3 - $index % 4)" translate={{getTextStatus($index)}}></div></div></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-todo-block/dashboard-todo-block.view.html','<div class="todoList pos-relative"><div class=loading ng-if=loading><img src=/assets/icons/spinner.gif alt=icons></div><div class="item-header flex-between"><div class="ft_16_600_black float-left cursor-point" ui-sref=todo>Task To Do</div><div class=float-right><button class=btn_primary_25 ng-click=addTodo()>+</button></div></div><div class=bodyScroll><div ng-repeat="(key, item) in todoList"><div class="ft_12_regular_light text-left fw-600 ft_family_inter type-name" ng-if=item.children.length>{{item.name}}</div><div class="block cursor-point" ng-class="\'type-\' + key" ng-repeat="(subKey, children) in item.children" ui-sref=todo><div class="flex-between mb-4"><div class=ft_14_600_black>{{children.title}}</div></div><div class="d-flex align-items-center justify-content-start ft_12_600_gray"><img src=/assets/images/dashboard/clock.svg alt=icons class=clock><div>{{children.deadlineTime | date: "MMM d, yyyy hh:mm:a" : \'UTC\'}}</div></div></div></div></div></div>');
$templateCache.put('app/main/dashboard/directives/dashboard-weather-block/dashboard-weather-block.view.html','<div class=dashboard-weather-block><div class="ft_24_600_white date">{{getCurrentDate()}}</div><div class="ft_12_600_white weekday">{{getCurrentDay()}}</div><div class="d-flex temp"><div class=value>{{weatherData.temp}}</div><div class=simbol>&#176;</div><div class=unit>C</div><img ng-src={{weatherIcon}} class=weather-logo style="width: 100px;" ng-if=weatherIcon></div><div class="ft_14_600_white location">{{weatherData.name}}</div></div>');
$templateCache.put('app/main/dashboard/directives/side-menu-issues/side-menu-issues.view.html','<div id=side-menu-issues><div class=side-menu-header><div class=ft_12_600_black translate="Issues Registered"></div><img src=/assets/icons/close-16-black.svg alt=icons class=cursor-point ng-click=onClose()></div><div class=side-menu-controls><div class="flex-items-center mb-8"><div class=category-item><div class=title>Issue({{issues.length}})</div><img src=/assets/icons/close-16-dark.svg alt=icons></div><div class=category-item><div class=title>Clash(0)</div><img src=/assets/icons/close-16-dark.svg alt=icons></div></div><searchbox search-text=searchText place-holder="Search here" search-event=onSearchIssue()></searchbox></div><div class=side-menu-body><side-menu-issue-card ng-repeat="issue in issues track by $index" ng-model=issue></side-menu-issue-card></div></div>');
$templateCache.put('app/main/dashboard/directives/side-menu-registrations/side-menu-registrations.view.html','<div id=side-menu-registrations><div class=side-menu-header><div class=ft_12_600_black translate="Registrations Registered"></div><img src=/assets/icons/close-16-black.svg alt=icons class=cursor-point ng-click=onClose()></div><div class=side-menu-controls><div class="flex-items-center mb-8"><div class=category-item><div class=title>Registration({{registrations.length}})</div><img src=/assets/icons/close-16-dark.svg alt=icons></div><div class=category-item><div class=title>Clash(0)</div><img src=/assets/icons/close-16-dark.svg alt=icons></div></div><searchbox search-text=searchText place-holder="Search here" search-event=onSearchRegistrations()></searchbox></div><div class=side-menu-body><side-menu-registration-card ng-repeat="registration in registrations track by $index" ng-model=registration></side-menu-registration-card></div></div>');
$templateCache.put('app/main/economic/bill/approveBill/approveBill.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=approveBill class=main-container><div class="title-bar mb-5 flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=billList class="ft-normal-12-16 grey-2" translate="List of Bills"></a></div><div class=header-title translate="Billing Scanner"></div></div><div class="flex flex-row flex-items-center"><button class=btn_new_blue ng-click=vm.openUploadNewBillModal()><img src=/assets/icons/bx-plus-circle.svg class=mr-10 alt=""><span translate="Add Bill"></span></button> <button class="btn_new_blue yellow ml-10" ng-click=vm.saveBillingData(vm.billing)><img src=/assets/icons/save-icon.svg class=mr-10 alt=""><span translate="Save Bill"></span></button> <button class="btn_new_blue green ml-10" ng-click=vm.approve()><img src=/assets/icons/check1.svg class=mr-10 alt=""><span translate=Approve></span></button> <button class="btn_new_blue red ml-10" ng-click=vm.decline()><img src=/assets/icons/close-circle-red1.svg class=mr-10 alt=""><span translate=Decline></span></button> <input type=file id=pdf-file accept=.pdf style="display: none" file-change=vm.pdfBrowsed></div></div><div class=content><div class=content-wrap><div class=header-title><div class=btn-group><div ng-if="vm.project && vm.project._id !== \'all\'" class=btn1 ng-class="isProjectTab() ? \'active\':\'\'" ng-click=vm.onProjectBills() translate="Billing Approval"></div><div class=btn2 ng-class="{active: isCompanyTab()}" ng-click=vm.onCompanyBills() translate="Company Bills"></div><div class=btn3 ng-class="{active: isPendingTab()}" ng-click=vm.onPendingBills() translate="Pending Bills"></div><div class=btn4 ng-class="{active: isFailedSyncTab()}" ng-click=vm.onFailedSync() translate="Failed Sync"></div><div class=btn5 ng-class="{active: isMemoTab()}" ng-click=vm.onMemo() translate="Vendor Credit Memo"></div></div></div><div class="sub-header flex-between" ng-if=!isPendingTab()><div class=item><div class="ft_12_600_gray mb-8" translate=Type></div><selectbox-input class="w-100 input-select" ng-model=economicTypeId options=vm.economicTypeList label-field=name value-field=_id select-event=vm.selEconomicTypeId(economicTypeId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate=Group></div><selectbox-input class="w-100 input-select" ng-model=billingGroupId options=vm.billingGroups label-field=name value-field=_id select-event=vm.selBillingGroupId(billingGroupId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate="VA Orders"></div><selectbox-input class="w-100 input-select" ng-model=billingVAOrderId options=vm.vaOrderList label-field=displaySeq value-field=_id select-event=vm.selBillingVAOrderId(billingVAOrderId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate="Invoice No."></div><input type=text class="login_input_new w-100" ng-model=vm.billing.customSupplierData.invoicenumber></div><div class=item><div class="ft_12_600_gray mb-8" translate="Bill Date"></div><div class="input-group datePicker"><input type=text class="login_input_new w-100" date-picker="dd MMM yyyy" date=billDate is-open=isBillDatepickerOpen ng-required=true change=updateBillDate()> <span class=dateArrow ng-click="isBillDatepickerOpen = !isBillDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Due Date"></div><div class="input-group datePicker"><input type=text class="login_input_new w-100" date-picker="dd MMM yyyy" date=dueDate is-open=isDueDatepickerOpen ng-required=true change=updateDueDate()> <span class=dateArrow ng-click="isDueDatepickerOpen = !isDueDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div><div class=mb-25 ng-if=isPendingTab()></div><spinner ng-if=isLoading></spinner><div class=main-content ng-hide=isLoading><div class=left-item><div class=up-item ng-if=vm.billing><div class=ft_14_600_white ng-bind=vm.billing.billNo></div><div class=pdf-pagination ng-show="vm.numPages > 1"><button ng-disabled="vm.currentPageNum <= 1" ng-click=vm.changePageInBill(false)><img src=/assets/icons/arrow-left-white.svg alt=""></button><div class=page-no>{{vm.currentPageNum}}</div><button ng-disabled="vm.currentPageNum >= vm.numPages" ng-click=vm.changePageInBill(true)><img src=/assets/icons/arrow-right-white.svg alt=""></button></div><div><img src=/assets/icons/scan.svg alt="" class=mh-10 ng-click=vm.startOCRProgress(vm.billing)> <img src=/assets/icons/bx-edit-white.svg alt="" ng-click=vm.openEditModal()> <img src=/assets/icons/download-white.svg alt="" class=mh-10 ng-click=vm.downloadInvoice(vm.billing)> <img src=/assets/icons/yellow-printer.svg alt="" class=mr-8 ng-click=vm.printDocument()> <img src=/assets/icons/delete-white.svg alt="" width=24 height=24 ng-click=deleteBilling()></div></div><div class=print><div class=print-content><button class=pre ng-click=vm.changeCanvasPage(false) ng-disabled="currentIndex <= 0"><img src=/assets/icons/left-arrow1.svg alt=""></button><div class="pdf-wrap no-zoom"><spinner ng-if=isLoadBilling></spinner><canvas id=the-canvas ng-hide=isLoadBilling></canvas></div><button class=next ng-click=vm.changeCanvasPage(true) ng-disabled="currentIndex >= vm.billList.length - 1"><img src=/assets/icons/right-arrow1.svg alt=""></button></div><div class=icons ng-if=vm.billing><div class=icon ng-click=vm.zoomCanvas(false)><img src=/assets/icons/zoom-in.svg alt=""></div><div class=icon ng-click=vm.zoomCanvas(true)><img src=/assets/icons/zoom-out.svg alt=""></div></div></div></div><div class=right-item><div class="up-item ft_14_600_black"><div class=text-uppercase>{{vm.billing.vendor.name || vm.billing.vendor.clientName}}</div><div translate="Bank Information"></div></div><div class=content-item><div class=flex><div class=flex-70><div class=ft_12_600_black translate="Address Line 1"></div><div class=ft_12_regular_gray>{{vendorDetail.fullAddress}}</div><div class=ft_12_600_black translate="Address Line 2"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.line2"></div><div class=flex><div class=flex-33><div class=ft_12_600_black translate=City></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.city"></div></div><div class=flex-33><div class=ft_12_600_black translate="Postal Code"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.postalCode"></div></div><div class=flex-33><div class=ft_12_600_black translate="Country Code"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.countryCode"></div></div></div><div class=flex><div class=flex-50><div class=ft_12_600_black translate="Email ID"></div><div class=ft_12_regular_gray ng-bind=vendorDetail.email></div></div><div class=flex-50><div class=ft_12_600_black translate="Phone No."></div><div class=ft_12_regular_gray ng-bind=vendorDetail.phoneNumber></div></div></div><div class=ft_12_600_black translate="VAT Registration No."></div><div class=ft_12_regular_gray ng-bind=vendorDetail.vatNumber></div></div><div class="flex-30 text-right"><div class=ft_12_600_black translate=IBAN></div><div class=ft_12_regular_gray ng-bind=bankDetails.IBAN></div><div class=ft_12_600_black translate=SWIFT></div><div class=ft_12_regular_gray ng-bind=bankDetails.bicCode></div><div class=ft_12_600_black translate="Account No"></div><div class=ft_12_regular_gray ng-bind=bankDetails.accountNumber></div><div class=ft_12_600_black translate=BANK></div><div class=ft_12_regular_gray ng-bind=bankDetails.bankName></div></div></div><div class=table-content><div ng-if=isNormalType(vm.billing) class="header-tr pos-relative"><div class=flex-30 translate=Description></div><div class=flex-10 translate=QTY></div><div class=flex-15 translate="Unit Price"></div><div class=flex-15 translate=Price></div><div class=flex-15><span translate=VAT></span>&nbsp;{{ vendorDetail.vat }} %</div><div class=flex-15 translate="Total Price"></div></div><div ng-if=!isNormalType(vm.billing) class=header-tr><div class=flex-90 translate=Description></div><div class=flex-10 translate=QTY></div></div><div class="text-center mt-20" ng-if="vm.billing && isRunningOCRBill(vm.billing)">OCR for this bill is in progress now. This might take some minutes.</div><div ng-if="!vm.billing || !isRunningOCRBill(vm.billing)" class=ocr-data><div ng-class="vm.billing.customSupplierData.supplies.length > 5? \'table-scroll\': \'\'" scroll-bottom=vm.billing.customSupplierData.supplies><div ng-if=isNormalType(vm.billing) class="main-tr pos-relative" ng-repeat="supply in vm.billing.customSupplierData.supplies track by $index"><div class=loading ng-if=supply.saveMode ng-style="{\'height\': (height - 40) + \'px\'}"><img src=/assets/icons/spinner.gif alt=icons></div><div ng-if=!supply.editMode class=flex-30 title={{supply.description}}><div class=delete-com><div ng-class="{\'dropdown\': true, \'btn-del\': true, \'dropup\': $index > 3}"><button class="dropdown-toggle btn-del" type=button id=menu46 data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu46><li class=menu-item value="" ng-click=vm.onEditItem(supply)><img src=/assets/icons/edit-black.svg alt=""><span translate=Edit></span></li><li class=menu-item value="" ng-click=vm.onRemoveItem($index)><img src=/assets/icons/delete4.svg alt=""><span translate=Delete></span></li></ul></div></div><span class=pl-15>{{ supply.description }}</span></div><div ng-if=supply.editMode class=flex-30 title={{supply.description}}><img src=/assets/icons/checkmark-24.svg class=check-mark alt="" ng-click=vm.onCheckEditing($index) ng-disabled=supply.saveMode> <img src=/assets/icons/close-20-dark.svg class=close-mark alt="" ng-click=vm.onCancelEditItem(supply)> <input type=text placeholder=Description class=w-90pct ng-model=editingSupply.description ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class=flex-10>{{ supply.qty }}</div><div ng-if=supply.editMode class=flex-10><input type=number placeholder=Quantity class=text-center ng-model=editingSupply.qty ng-change=vm.changedQtyAndUPrice(supply) ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class=flex-15>{{ supply.unitprice | readable: 2 }}</div><div ng-if=supply.editMode class=flex-15><input type=number placeholder="Unit Price" class=text-right ng-model=editingSupply.unitprice ng-change=vm.changedQtyAndUPrice(supply) ng-disabled=supply.saveMode></div><div class=flex-15>{{ supply.price | readable: 2 }}</div><div class=flex-15>{{ supply.vat | readable: 2 }}</div><div class=flex-15>{{ supply.total | readable: 2 }}</div></div><div ng-if=!isNormalType(vm.billing) class="main-tr pos-relative" ng-repeat="supply in vm.billing.customSupplierData.supplies"><div class=loading ng-if=supply.saveMode ng-style="{\'height\': (height - 40) + \'px\'}"><img src=/assets/icons/spinner.gif alt=icons></div><div ng-if=!supply.editMode class=flex-90 title={{supply.description}}><div class=delete-com><div ng-class="{\'dropdown\': true, \'btn-del\': true, \'dropup\': $index > 3}"><button class="dropdown-toggle btn-del" type=button id=menu47 data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu47><li class=menu-item value="" ng-click=vm.onEditItem(supply)><img src=/assets/icons/edit-black.svg alt="">Edit</li><li class=menu-item value="" ng-click=vm.onRemoveItem($index)><img src=/assets/icons/delete4.svg alt="">Delete</li></ul></div></div><div class=pl-15>{{ supply.description }}</div></div><div ng-if=supply.editMode class=flex-90 title={{supply.description}}><img src=/assets/icons/checkmark-24.svg class=check-mark alt="" ng-click=vm.onCheckEditing($index) ng-disabled=supply.saveMode> <img src=/assets/icons/close-20-dark.svg class=close-mark alt="" ng-click=vm.onCancelEditItem(supply)> <input type=text placeholder=Description class=w-90pct ng-model=editingSupply.description ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class=flex-10>{{ supply.qty }}</div><div ng-if=supply.editMode class=flex-10><input type=number placeholder=Quantity class=text-center ng-model=editingSupply.qty ng-disabled=supply.saveMode></div></div></div><div class=add-tr ng-click=vm.onAddItem() translate="+ Add New Item"></div><div ng-if=isNormalType(vm.billing) class=bottom-tr><div class=row><div class=col translate=Price></div><div class=col>{{ vm.billing.amountWithoutTax | readable: 2 }}</div></div><div class=row ng-if=vendorDetail.vat><div class=col translate=VAT>{{ vendorDetail.vat }} %</div><div class=col>{{ vm.billing.taxAmount | readable: 2 }}</div></div><div class=row><div class=col translate="Total Price"></div><div class=col>{{ vm.billing.totalAmount | readable: 2 }}</div></div></div><div ng-if=!isNormalType(vm.billing) class=bottom-tr><div class=row><div class=col translate=Price></div><div class=col><div ng-if=!vm.billing.editMode><img src=/assets/icons/edit_gray.svg alt="" ng-click=vm.editAmountWithoutTax()> <span>{{ vm.billing.amountWithoutTax | readable: 2 }}</span></div><div ng-if=vm.billing.editMode class=edit-price><img src=/assets/icons/checkmark-24.svg alt="" ng-click=vm.updateAmountWithoutTax()> <img src=/assets/icons/close-20-dark.svg alt="" ng-click=vm.cancelAmountWithoutTax()> <input type=number placeholder=Price ng-model=vm.billing.amountWithoutTaxTemp ng-change=vm.changeAmountWithoutTax()></div></div></div><div class=row ng-if=vendorDetail.vat><div class=col><span translate=VAT></span> {{ vendorDetail.vat }} %</div><div class=col>{{ vm.billing.taxAmount | readable: 2 }}</div></div><div class=row><div class=col translate="Total Price"></div><div class=col>{{ vm.billing.totalAmount | readable: 2 }}</div></div></div><!-- <div class="bottom-tr-left">\n                    <div class="flex-items-center mr-24">\n                      <label class="check_yellow_16">\n                        <input type="checkbox" ng-model="vm.isRemoveVAT" ng-change="changeIsRemoveVAT()" />\n                        <span class="checkmark_16"></span>\n                      </label>\n                      <div class="ft_12_600_black">Remove VAT</div>\n                    </div>\n                  </div> --></div></div></div></div></div></div></div><div id=ocr-processing-window ng-if=isOCRLoading><img src=/assets/images/cgviewer/cloud_loading.gif></div><spinner ng-if=isDownloading></spinner></div></main>');
$templateCache.put('app/main/economic/bill/bill-list/bill-list.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="List of Bills"></a></div><div class=ft_24_600_black1 translate="List of Bills"></div></div><div class="flex flex-row flex-items-center ml-auto"><searchbox search-text=searchText search-event=vm.searchData() is-small=true></searchbox></div><button class="button-primary ml-16" ui-sref=billScanner ng-if="ECO_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span translate="Billing Scanner"></span></button> <button class="button-primary ml-16" ng-if="ECO_ACCESS_CREATE > 2"><img src=/assets/icons/download-white.svg alt=icons><span class=ml-2 translate="Download PDF" ng-click=vm.downloadAll()></span></button></div><div id=bill-list><div><div><div class=table-header><div class=btn-group><button class=btn1 ng-class="{active: isProjectBills()}" ng-click=onProjectBills() translate="Project Bills"></button> <button class=btn2 ng-class="{active: isCompanyBills()}" ng-click=onCompanyBills() translate="Company Bills"></button> <button class=btn3 ng-class="{active: isVendorCreditMemos()}" ng-click=onVendorCreditMemos() translate="Vendor Credit Memos"></button></div></div><div class=listViewContainer ng-if=isProjectBills()><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=isAllChecked ng-change=setAllChecked()><span class=checkmark></span></label></th><th class=ft_14_600_black><span translate="Sr No"></span></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'date\')"><span translate=Date></span> <img ng-src="{{sortItem.sort === \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'date\' && !vm.sortItems[1].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'billNo\')"><span translate="Bill No"></span> <img ng-src="{{sortItem.sort === \'billNo\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'billNo\' && !vm.sortItems[2].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'billNo\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'invoiceNo\')"><span translate="Invoice No"></span> <img ng-src="{{sortItem.sort === \'invoiceNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'invoiceNo\' && !vm.sortItems[3].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'invoiceNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'vendor\')"><span translate=Vendor></span> <img ng-src="{{sortItem.sort === \'vendor\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'vendor\' && !vm.sortItems[4].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'vendor\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'amount\')"><span translate=Amount></span> <img ng-src="{{sortItem.sort === \'amount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'amount\' && !vm.sortItems[5].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'amount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'vatAmount\')"><span translate="Vat Amount"></span> <img ng-src="{{sortItem.sort === \'vatAmount\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'vatAmount\' && !vm.sortItems[6].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'vatAmount\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'total\')"><span translate=Total></span> <img ng-src="{{sortItem.sort === \'total\' &&  vm.sortItems[7].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'total\' && !vm.sortItems[7].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'total\' &&  vm.sortItems[7].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th><div class=dropdown><button tooltip-enable=false tooltip-placement=top-left uib-tooltip=status tooltip-class=customClass class="dropdown-toggle sel-project" type=button id=menu1 data-toggle=dropdown><span class=ft_14_600_black>{{vm.status | capitalize}}</span> <img src=/assets/icons/arrow_drop_down_20.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li><a href=# class="menu-item ft_12_regular_gray" data-ng-click=selectedProject(item.value) ng-repeat="item in vm.statusList">{{item.value | capitalize}}</a></li><li><a href=# class=menu-item ng-if=!vm.statusList.length>No Data</a></li></ul></div></th><th class=ft_14_600_black><span translate=Action></span></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, bill) in vm.billList | filter:searchText"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=bill.checked><span class=checkmark></span></label></td><td>{{ totalCount - (vm.currentPage - 1)*numPerPage - key }}.</td><td class=ft_14_regular_black ng-bind="bill.billDate ? bill.billDate : bill.customSupplierData.billdate | date"></td><td class=ft_14_regular_black ng-bind=bill.billNo></td><td class=ft_14_regular_black ng-bind=bill.customSupplierData.invoicenumber></td><td class=ft_14_regular_black>{{ bill.vendor.clientName || bill.vendor.name}}</td><td class=ft_14_regular_black>{{ bill.amountWithoutTax | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.taxAmount | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.totalAmount | readable: 2 }}</td><td class="ft_14_regular_black {{bill.status}}">{{bill.status | capitalize }}</td><td class=ft_14_regular_black><div class="flex flex-row flex-items-center vaActionContainer"><div class="cursor-point mr-4" ng-click=vm.gotoEdit(bill) ng-if=!bill.financeItems.length><img src=/assets/icons/edit.svg alt=""></div><div class="cursor-point mr-4" ng-click=vm.downloadPdf(bill)><img src=/assets/icons/cloud-download.svg alt=""></div><div class=cursor-point ng-click="vm.deleteBill(bill, $index)" ng-if="ECO_ACCESS_CREATE > 3 && bill.status != \'approved\'"><img src=/assets/icons/trash-alt6.svg alt=""></div></div></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + (vm.billList | filter:searchText).length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchData()></pagination-custom-new></div></div></div><div class=listViewContainer ng-if=isCompanyBills()><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=isAllChecked ng-change=setAllChecked()><span class=checkmark></span></label></th><th class=ft_14_600_black><span translate="Sr No"></span></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'date\')"><span translate=Date></span> <img ng-src="{{sortItem.sort === \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'date\' && !vm.sortItems[1].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'billNo\')"><span translate="Bill No"></span> <img ng-src="{{sortItem.sort === \'billNo\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'billNo\' && !vm.sortItems[2].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'billNo\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'invoiceNo\')"><span translate="Invoice No"></span> <img ng-src="{{sortItem.sort === \'invoiceNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'invoiceNo\' && !vm.sortItems[3].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'invoiceNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'vendor\')"><span translate=Vendor></span> <img ng-src="{{sortItem.sort === \'vendor\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'vendor\' && !vm.sortItems[4].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'vendor\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'amount\')"><span translate=Amount></span> <img ng-src="{{sortItem.sort === \'amount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'amount\' && !vm.sortItems[5].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'amount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'vatAmount\')"><span translate="Vat Amount"></span> <img ng-src="{{sortItem.sort === \'vatAmount\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'vatAmount\' && !vm.sortItems[6].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'vatAmount\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'total\')"><span translate=Total></span> <img ng-src="{{sortItem.sort === \'total\' &&  vm.sortItems[7].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'total\' && !vm.sortItems[7].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'total\' &&  vm.sortItems[7].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th><div class=dropdown><button tooltip-enable=false tooltip-placement=top-left uib-tooltip=status tooltip-class=customClass class="dropdown-toggle sel-project" type=button id=menu1 data-toggle=dropdown><span class=ft_14_600_black>{{vm.status | capitalize}}</span> <img src=/assets/icons/arrow_drop_down_20.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li><a href=# class="menu-item ft_12_regular_gray" data-ng-click=selectedProject(item.value) ng-repeat="item in vm.statusList">{{item.value | capitalize}}</a></li><li><a href=# class=menu-item ng-if=!vm.statusList.length>No Data</a></li></ul></div></th><th class=ft_14_600_black><span translate=Action></span></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, bill) in vm.billList | filter:searchText"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=bill.checked><span class=checkmark></span></label></td><td>{{ totalCount1 - (vm.currentPage1 - 1)*numPerPage - key }}.</td><td class=ft_14_regular_black ng-bind="bill.billDate ? bill.billDate : bill.customSupplierData.billdate | date"></td><td class=ft_14_regular_black ng-bind=bill.billNo></td><td class=ft_14_regular_black ng-bind=bill.customSupplierData.invoicenumber></td><td class=ft_14_regular_black>{{ bill.vendor.clientName || bill.vendor.name}}</td><td class=ft_14_regular_black>{{ bill.amountWithoutTax | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.taxAmount | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.totalAmount | readable: 2 }}</td><td class="ft_14_regular_black {{bill.status}}">{{bill.status | capitalize }}</td><td class=ft_14_regular_black><div class="flex flex-row flex-items-center vaActionContainer"><div class="cursor-point mr-4" ng-click=vm.gotoEdit(bill) ng-if="bill.status==\'draft\'"><img src=/assets/icons/edit.svg alt=""></div><div class="cursor-point mr-4" ng-click=vm.downloadPdf(bill)><img src=/assets/icons/cloud-download.svg alt=""></div><div class=cursor-point ng-click="vm.deleteBill(bill, $index)" ng-if="ECO_ACCESS_CREATE > 3 && bill.status != \'approved\'"><img src=/assets/icons/trash-alt6.svg alt=""></div></div></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage1 - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage1 - 1) * numPerPage + (vm.billList | filter:searchText).length}}</span> of {{totalCount1}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages1 current-page=vm.currentPage1 on-select-page=vm.fetchData()></pagination-custom-new></div></div></div><div class=listViewContainer ng-if=isVendorCreditMemos()><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=isAllChecked ng-change=setAllChecked()><span class=checkmark></span></label></th><th class=ft_14_600_black><span translate="Sr No"></span></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'date\')"><span translate=Date></span> <img ng-src="{{sortItem.sort === \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'date\' && !vm.sortItems[1].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'billNo\')"><span translate="Bill No"></span> <img ng-src="{{sortItem.sort === \'billNo\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'billNo\' && !vm.sortItems[2].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'billNo\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'invoiceNo\')"><span translate="Invoice No"></span> <img ng-src="{{sortItem.sort === \'invoiceNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'invoiceNo\' && !vm.sortItems[3].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'invoiceNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'vendor\')"><span translate=Vendor></span> <img ng-src="{{sortItem.sort === \'vendor\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'vendor\' && !vm.sortItems[4].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'vendor\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'amount\')"><span translate=Amount></span> <img ng-src="{{sortItem.sort === \'amount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'amount\' && !vm.sortItems[5].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'amount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'vatAmount\')"><span translate="Vat Amount"></span> <img ng-src="{{sortItem.sort === \'vatAmount\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'vatAmount\' && !vm.sortItems[6].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'vatAmount\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'total\')"><span translate=Total></span> <img ng-src="{{sortItem.sort === \'total\' &&  vm.sortItems[7].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'total\' && !vm.sortItems[7].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'total\' &&  vm.sortItems[7].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th><div class=dropdown><button tooltip-enable=false tooltip-placement=top-left uib-tooltip=status tooltip-class=customClass class="dropdown-toggle sel-project" type=button id=menu1 data-toggle=dropdown><span class=ft_14_600_black>{{vm.status | capitalize}}</span> <img src=/assets/icons/arrow_drop_down_20.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li><a href=# class="menu-item ft_12_regular_gray" data-ng-click=selectedProject(item.value) ng-repeat="item in vm.statusList">{{item.value | capitalize}}</a></li><li><a href=# class=menu-item ng-if=!vm.statusList.length>No Data</a></li></ul></div></th><th class=ft_14_600_black><span translate=Action></span></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, bill) in vm.billList | filter:searchText"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=bill.checked><span class=checkmark></span></label></td><td>{{ totalCount2 - (vm.currentPage2 - 1)*numPerPage - key }}.</td><td class=ft_14_regular_black ng-bind="bill.billDate ? bill.billDate : bill.customSupplierData.billdate | date"></td><td class=ft_14_regular_black ng-bind=bill.billNo></td><td class=ft_14_regular_black ng-bind=bill.customSupplierData.invoicenumber></td><td class=ft_14_regular_black>{{ bill.vendor.clientName || bill.vendor.name}}</td><td class=ft_14_regular_black>{{ bill.amountWithoutTax | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.taxAmount | readable: 2 }}</td><td class=ft_14_regular_black>{{ bill.totalAmount | readable: 2 }}</td><td class="ft_14_regular_black {{bill.status}}">{{ bill.status | capitalize }}</td><td class=ft_14_regular_black><div class="flex flex-row flex-items-center vaActionContainer"><div class="cursor-point mr-4" ng-click=vm.gotoEdit(bill) ng-if="bill.status==\'draft\'"><img src=/assets/icons/edit.svg alt=""></div><div class="cursor-point mr-4" ng-click=vm.downloadPdf(bill)><img src=/assets/icons/cloud-download.svg alt=""></div><div class=cursor-point ng-click="vm.deleteBill(bill, $index)" ng-if="ECO_ACCESS_CREATE > 3 && bill.status != \'approved\'"><img src=/assets/icons/trash-alt6.svg alt=""></div></div></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage2 - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage2 - 1) * numPerPage + (vm.billList | filter:searchText).length}}</span> of {{totalCount2}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages2 current-page=vm.currentPage2 on-select-page=vm.fetchData()></pagination-custom-new></div></div></div></div></div><spinner ng-if=isDownloading></spinner></div></main><div ng-if=vm.pdfViewing><pdf-viewer id=pdf-viewer class=pdf-viewer url=vm.bill.bill.secure_url ng-close=vm.closePDFViewer></pdf-viewer></div>');
$templateCache.put('app/main/economic/bill/billScanner/billScanner.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=billScanner class=main-container><div class="title-bar mb-24 flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=billList class="ft-normal-12-16 grey-2" translate="List of Bills"></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Bill Approval"></a></div><div class=header-title translate="Billing Scanner"></div></div><div class="flex flex-row flex-items-center"><div class="d-flex flex-row align-items-center"><checkbox class=mr-8 ng-model=vm.bShowApproved ng-click=vm.onChangeShowApproved()></checkbox><label class="d-block ft_12_600_gray mb-0 mr-20" translate="Show Approved Bills"></label></div><!-- <input type="checkbox" ng-model="bShowApproved" ng-change="vm.onChangeShowApproved()" />Show Approved Bills --> <button class=btn_new_blue ng-click=vm.openUploadNewBillModal()><img src=/assets/icons/bx-plus-circle.svg class=mr-10 alt=""><span translate="Add Bill"></span></button> <button class="btn_new_blue yellow ml-10" ng-click=vm.saveBillingData()><img src=/assets/icons/save-icon.svg class=mr-10 alt=""><span translate="Save Bill"></span></button> <button class="btn_new_blue red ml-10" ng-click=vm.pending()><img src=/assets/icons/pause-offer-status_f.svg class=mr-10 alt=""><span translate=Pending></span></button> <button class="btn_new_blue green ml-10" ng-click=vm.approve()><img src=/assets/icons/check1.svg class=mr-10 alt=""><span translate=Approve></span></button> <button class="btn_new_blue gray ml-10" ng-click=vm.decline()><img src=/assets/icons/gray-circle-close.svg class=mr-10 alt=""><span translate=Decline></span></button> <input type=file id=pdf-file accept=.pdf style="display: none" file-change=vm.pdfBrowsed></div></div><div ng-if=!isLoading class=content><div class=content-wrap><div class=header-title><div class=btn-group><div class=button ng-class="currentPage == \'Pending\' ? \'active\' : \'\'" ng-click="setCurrentPage(\'Pending\')" translate="Project Bills"></div><div class=button ng-class="currentPage == \'Company\' ? \'active\' : \'\'" ng-click="setCurrentPage(\'Company\')" translate="Company Bills"></div><div class=button ng-class="currentPage == \'VendorCredit\' ? \'active\' : \'\'" ng-click="setCurrentPage(\'VendorCredit\')" translate="Vendor Credit Memo"></div></div></div><pending-bills ng-if="currentPage == \'Pending\'" delete-billing=vm.deleteBilling(vm.billing) bill-list=vm.pendingBills vendors=vm.vendors billing=vm.billing current-index=vm.currentIndex></pending-bills><pending-bills ng-if="currentPage == \'Company\'" delete-billing=vm.deleteBilling(vm.companyBilling) bill-list=vm.companyBills vendors=vm.vendors billing=vm.companyBilling current-index=vm.currentCompanyIndex></pending-bills><pending-bills ng-if="currentPage == \'VendorCredit\'" delete-billing=vm.deleteBilling(vm.memo) bill-list=vm.vendorCredits vendors=vm.vendors billing=vm.memo current-index=vm.currentMemoIndex></pending-bills><!-- <company-bills ng-if="currentPage == \'Company\'" company-bill-list="vm.companyBills" vendors="vm.vendors" company-billing="vm.companyBilling" current-company-index="vm.currentCompanyIndex"></company-bills>\n        <vendor-credits ng-if="currentPage == \'VendorCredit\'" memo-list="vm.vendorCredits" vendors="vm.vendors" memo="vm.memo" current-memo-index="vm.currentMemoIndex"></vendor-credits> --></div></div><div id=ocr-processing-window ng-if=isOCRLoading><img src=/assets/images/cgviewer/cloud_loading.gif></div><spinner ng-if=isLoading></spinner></div></main>');
$templateCache.put('app/main/economic/directives/payrollBreakup/payrollBreakup.view.html','<div id=payroll-breakup class=dropdown ng-class="{open: opened, dropup: up}"><button class=dropdown-toggle type=button ng-click=toggleDropdown()><span class=breakup-value>{{ getBreak() | readable: 1 }} Hr</span> <img src=/assets/icons/chevron-down.svg alt=""></button><div class=dropdown-menu ng-class="{hour12: is12Format}"><div class=d-flex><div><input id=from-hours class="time-input time-text" type=number min=0 max=23 ng-model=fromHour><div class=time-label translate="From Hour"></div></div><div class="time-text mt-10">:</div><div><input id=from-minutes class="time-input time-text" type=number min=0 max=59 ng-model=fromMinute><div class=time-label translate=Minute></div></div><div class=am-pm ng-if=is12Format><div class=am ng-class="{selected: !fromPm}" ng-click="onAmPm($event, false, true)">AM</div><div class=pm ng-class="{selected: fromPm}" ng-click="onAmPm($event, true, true)">PM</div></div><div class=ml-15><input id=to-hours class="time-input time-text" type=number min=0 max=23 ng-model=toHour><div class=time-label translate="To Hour"></div></div><div class="time-text mt-10">:</div><div><input id=to-minutes class="time-input time-text" type=number min=0 max=59 ng-model=toMinute><div class=time-label translate=Minute></div></div><div class=am-pm ng-if=is12Format><div class=am ng-class="{selected: !toPm}" ng-click="onAmPm($event, false, false)">AM</div><div class=pm ng-class="{selected: toPm}" ng-click="onAmPm($event, true, false)">PM</div></div><div class="button ok ml-16 mt-10" ng-click=onOK() translate=Ok></div></div></div></div>');
$templateCache.put('app/main/economic/directives/payrollDriving/payrollDriving.view.html','<div id=payroll-driving><button class=dropdown-toggle type=button ng-click=showDriving()><span class=breakup-value>{{ ngModel.distance | readable: 2 }} km</span> <img src=/assets/icons/chevron-down.svg alt=""></button></div>');
$templateCache.put('app/main/economic/directives/payrollReceipt/payrollReceipt.view.html','<div id=payroll-receipt class=dropdown ng-class="{open: opened, dropup: up}"><button class=dropdown-toggle type=button ng-click=toggleDropdown()><span class=receipt-value>{{ getReceiptsLength() }} Docs</span> <img src=/assets/icons/chevron-down.svg alt=""></button><div class=dropdown-menu><div class=btn-group ngf-select ng-model=inputImg ngf-change="fileUpdated($files, $event, \'image\')" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=true ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><div class=btn_add><img src=/assets/icons/plus-md.svg alt=""></div><div class=ft_14_600_black translate="Attach Receipts"></div></div><div class=d-flex><div class="receipts flex-wrap"><div class=receipt-item ng-repeat="(key,f) in ngModel.receipts" ng-class={active:!$index}><a ng-click="deleteFile($index, \'recipient\');" class="text-danger image_close_btn"><img src=/assets/icons/subtract.svg alt=icons></a><img ngf-src="f.secure_url || f" alt="First slide" class="thumb object-fit-cover" ng-click=previewImage(f)><div class="text-center f_name mb-15">{{ f.originalname || f.name }}</div></div><div class=receipt-item ng-repeat="(key,f) in ngModel.receipt" ng-class={active:!$index}><a ng-click="deleteFile($index, \'image\');" class="text-danger image_close_btn"><img src=/assets/icons/subtract.svg alt=icons></a><img ngf-src="f.secure_url || f" alt="First slide" class="thumb object-fit-cover" ng-click=previewImage(f)><div class="text-center f_name mb-15">{{ f.originalname || f.name }}</div></div></div></div></div></div>');
$templateCache.put('app/main/economic/directives/pdfViewer/pdfViewer.view.html','<div id=pdfViewer><div class=toolbar><img src=/assets/icons/go-back-left-arrow.svg class=back-button ng-click=closeViewer()></div><iframe ng-if=embedUrl class=pdf-content ng-src={{embedUrl}} frameborder=0></iframe><embed ng-if=blobUrl ng-src="{{ blobUrl }}" class=pdf-content type=application/pdf></div>');
$templateCache.put('app/main/economic/directives/projectOverview/projectOverview.view.html','<div id=project-overview><div class="header flex-between"><div class="a flex-4 align-items-center">A</div><div class="p flex-4">P</div><div class="name flex-18" translate=Name></div><div class="cost flex-18" translate=Cost></div><div class="percent flex-20" translate=Profit-%></div><div class="profit flex-18" translate=Profit></div><div class="sales flex-18" translate="Sales Price"></div></div><spinner ng-if=isLoading></spinner><div class=items-wrapper ng-if=!isLoading><div class="row-item calcs" ng-repeat="row in rows"><div class="a flex-4"><label class=check_14><input type=checkbox class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-model=row.approved ng-change=calculateRow(row) ng-disabled=!row.option> <span class=checkmark></span></label></div><div class="p flex-4"><label class=check_14><input type=checkbox class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-model=row.pending ng-change=calculateRow(row) ng-disabled=!row.option> <span class=checkmark></span></label></div><div class="name flex-18">{{row.name}}</div><div class="cost tx-ellipsis flex-18">{{currency}} {{row.cost | readable: 2 }}</div><div class="percent flex-20"><input class=field type=text ng-model=row.profitPercent ng-blur=calculateRow(row) number-edit=2> %</div><div class="profit tx-ellipsis flex-18">{{currency}} {{row.profit | readable: 2}}</div><div class="sales tx-ellipsis flex-18">{{currency}} {{row.salesPrice | readable: 2}}</div></div><div class=divider></div><div class="row-item summary" ng-repeat="row in summary"><div class="sub-title flex-26">{{row.name}}</div><div class="cost tx-ellipsis flex-18">{{currency}} {{row.cost | readable: 2}}</div><div class="percent tx-ellipsis flex-20">{{row.profitPercent | readable: 2}} %</div><div class="profit tx-ellipsis flex-18">{{currency}} {{row.profit | readable: 2}}</div><div class="sales tx-ellipsis flex-18">{{currency}} {{row.salesPrice | readable: 2}}</div></div></div></div>');
$templateCache.put('app/main/economic/invoice/create/create.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="title-bar mb-5"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=invoiceList class="ft-normal-12-16 grey-2" translate=Invoices></a></div><div class=header-title translate="Create Invoice"></div></div></div><div id=create-invoice><div class=content><spinner ng-if=loading></spinner><div class=content-wrap><div class="sub-header mb-20"><div class="item flex-between mb-16"><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38 required" translate="Customer Name"></div><selectbox-input class="dropdown-primary flex-60" ng-model=vm.vendorIdTemp options=vm.userListTemp label-field=name value-field=_id select-event=vm.changeVendor(vm.vendorIdTemp) is-search=true></selectbox-input></div><div class=flex-35></div><div class=flex-25></div></div><div class="item flex-between mb-16"><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38" translate="Reference No."></div><input type=text class="input-primary flex-60" ng-model=vm.invoice.referenceNo></div><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38" translate="Project ID"></div><input type=text class="input-primary flex-60" ng-model=vm.invoice.projectSystemTag readonly></div><div class=flex-25></div></div><div class="item flex-between mb-16"><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38 required" translate="Invoice Date"></div><div class="input-group datePicker-primary flex-60"><input type=text class="input-primary w-100" change=invoiceDateChanged() date-picker=dd.MM.yyyy date=vm.invoice.date is-open=isDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isDatepickerOpen = !isDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38 required" translate="Due Date"></div><div class="input-group datePicker-primary flex-60"><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.invoice.dueDate is-open=isDueDatepickerOpen ng-required=true readonly> <span class=dateArrow><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=flex-25></div></div><div class="item flex-between"><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38" translate=Staff></div><selectbox-input class="dropdown-primary flex-60" ng-model=vm.invoice.staff options=vm.invoice.vendor.staffs label-field=displayName value-field=_id is-search=true></selectbox-input></div><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38" translate="Created By"></div><input type=text class="input-primary flex-60" ng-model=vm.invoice.createdByName readonly></div><div class=flex-25></div></div></div><div class=pay-content><div class="flex-between mb-20"><div class=flex><label class="check_yellow_20 mr-16"><div class=ft_14_600_black translate="Create Credit Memo"></div><input type=checkbox ng-model=vm.isCreditMemo> <span class=checkmark></span></label> <label class=check_yellow_20><div class=ft_14_600_black translate="Included Terms and Conditions"></div><input type=checkbox ng-model=vm.invoice.termsAndConditions> <span class=checkmark></span></label> <label class="check_yellow_20 ml-16"><div class=ft_14_600_black translate="Final invoice to finish project"></div><input type=checkbox ng-model=vm.finalInvoice> <span class=checkmark></span></label></div><div class="flex btn-group"><button class=button-ex2 ng-style="{\'visibility\': vm.isCreditMemo ? \'visible\' : \'hidden\'}" ng-click=vm.showImportInvoicePopup()>+&nbsp;<span translate="Import Invoices"></span></button><div class="dropdown ml-20 add-payment-terms"><button class=button-ex2 type=button id=menu1 data-toggle=dropdown>+&nbsp;<span translate="Add Payment Terms"></span></button><ul class="dropdown-menu w-210" role=menu aria-labelledby=menu1><li><a href=# class=menu-item ng-repeat="cc in vm.paymentConditions | filter:{validate:\'false\'}" ng-click=vm.addPaymentTerm(cc)>{{ cc.code }}</a></li></ul></div><div class=ml-20><button class=button-ex2 ng-click=vm.toggleProjectOverview()><img src=/assets/icons/eye-blue.svg alt=""><span translate="Project Overview"></span></button></div></div></div><div class=item-wrap ng-if=false><div class=item ng-repeat="term in vm.invoice.paymentTerms track by $index">{{ term.code }}<img src=/assets/icons/close-gray.svg alt="" ng-click=vm.deletePaymentTerm($index)></div></div><div class="items-table mb-16"><div class="tr ft-md ft-bold-secondary ft-color-primary"><div class="th flex-8" translate=Sr.No.></div><div class="th flex-15" translate=Type></div><div class="th flex-25" translate=Description></div><div class="th flex-8 text-right" translate=Qty></div><div class="th flex-10 text-right" translate="Unit Price"></div><div class="th flex-8 text-right" translate="VAT %"></div><div class="th flex-10 text-right" translate="VAT Amount"></div><div class="th flex-10 text-right" translate="Sales Price"></div><div class="th flex-6"></div></div><div ng-repeat="item in vm.invoice.items track by $index"><div class="tr ft-md ft-bold-secondary ft-color-primary"><div class="td flex-8"><selectbox class=dropdown-primary ng-class="{inactive: !item.isEdit}" ng-model=item.itemId options=vm.accountPlans label-field=label value-field=_id short-label-field=number select-event="vm.selectItemType(item.itemId, item, \'accountPlan\')" readonly></selectbox></div><div class="td flex-15"><selectbox input-class=dropdown-primary ng-class="{inactive: !item.isEdit}" ng-model=item.itemNum options=item.settingItems label-field=label value-field=_id select-event="vm.selectItemType(item.itemNum, item, \'settingItem\')" readonly></selectbox></div><div class="td flex-25" ng-if=!item.isServiceAndVAOrder><input type=text class=input-primary ng-class="{inactive: !item.isEdit}" ng-model=item.description ng-readonly=!item.isEdit></div><div class="td flex-25" ng-if=item.isServiceAndVAOrder><input type=text class=input-primary ng-class="{inactive: !item.isEdit}" ng-model=item.description ng-keyup="vm.searchItemDescription(item, item.description, $event)" ng-readonly=!item.isEdit><ul ng-if="filteredItems.length>0 && vm.curItem==item" class=pos-absolute><li class=menu-item ng-click="vm.selectItemDescription(item, fitem)" ng-repeat="fitem in filteredItems">{{ fitem.name }}</li></ul></div><div class="td flex-8 text-right"><input type=number class=input-primary ng-class="{inactive: !item.isEdit, \'text-right\': true}" ng-model=item.quantity ng-blur=vm.calculateItemPrice(item) ng-readonly=!item.isEdit></div><div class="td flex-10 text-right"><input type=number class=input-primary ng-class="{inactive: !item.isEdit, \'text-right\': true}" ng-model=item.unitPrice ng-value=item.unitPrice ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ ng-blur=vm.calculateItemPrice(item) ng-readonly=!item.isEdit></div><div class="td flex-8 text-right"><input ng-if=!item.isSelType class=input-primary type=number ng-class="{inactive: !item.isEdit, \'text-right\': true}" ng-model=item.vatPercent ng-blur=vm.calculateItemPrice(item) ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ ng-readonly=!item.isEdit> <input ng-if=item.isSelType class=input-primary ng-class="{inactive: !item.isEdit, \'text-right\': true}" type=number ng-model=item.vatPercent readonly></div><div class="td flex-10 text-right"><span ng-if=item.vatAmount class=value>{{ item.vatAmount | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class="td flex-10 text-right"><span ng-if=item.price class=value>{{item.price | readable: 2}} {{ companyCurrency.symbol }}</span></div><div class="td flex-6 d-flex justify-content-center align-items-center"><img src=/assets/icons/bxs-edit-blue.svg alt="" class="action-icon mr-16" ng-click=vm.editInvoiceRow(item) ng-if=!item.isEdit> <img src=/assets/icons/check-mark-line-blue.svg alt="" class="action-icon mr-16" ng-click=vm.confirmInvoiceRow(item) ng-if=item.isEdit> <img src=/assets/icons/trash-alt-red.svg alt="" class=action-icon ng-click=vm.removeInvoiceRow($index)></div></div><div class=tr ng-show=item.taxPercent><div class=flex-8>&nbsp;</div><div class=flex-15>&nbsp;</div><div class=flex-25>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-10>&nbsp;</div><div class=flex-8><span translate=Tax></span>&nbsp;% {{ item.taxPercent }}</div><div class=flex-10>&nbsp;</div><div class=flex-10 ng-if=item.taxPercent><span ng-if=item.taxAmount>{{ item.taxAmount | readable: 2 }} {{ companyCurrency.symbol }}</span>&nbsp;</div><div class=flex-6>&nbsp;</div></div></div></div><div class="d-flex flex-between flex-start"><div class="add-new-line flex-23"><div class="ft-md ft-bold-primary ft-color-ex1 ml-1" ng-click=vm.addInvoiceRow() translate="+ Add another line"></div><!-- <div class="ft-md ft-bold-primary ft-color-secondary ml-16">|</div>\n              <div class="ft-md ft-bold-primary ft-color-ex1 ml-16" ng-click="vm.addInvoiceRow()" translate="+ Add items in bulk"></div> --></div><div class=flex-43><project-overview></project-overview></div><div class="mt-10 flex-28"><div class=input-group><!-- <div class="d-block">\n                  <div class="w-350 pb-12">\n                    <span class="ft_14_600_black" translate="Sub Total"></span>\n                    <div></div>\n                    <div>{{ vm.invoice.totalPrice | readable: 2 }} {{ companyCurrency.symbol}}</div>\n                  </div>\n                  <div class="w-350 pb-12">\n                    <span class="ft_14_600_black" translate="Vat"></span>\n                    <div></div>\n                    <div>{{ vm.invoice.totalVat | readable: 2 }} {{ companyCurrency.symbol}}</div>\n                  </div>\n                  <div class="w-350 pb-12 total">\n                    <span class="ft_14_600_black" translate="Total Amount"></span>\n                    <div></div>\n                    <div>{{ vm.invoice.totalAmount | readable: 2 }} {{ companyCurrency.symbol}}</div>\n                  </div>\n                  <div class="w-350 pb-12" ng-if="vm.invoice.totalTax != 0">\n                    <span class="ft_14_600_black" translate="Tax"></span>\n                    <div></div>\n                    <div>{{ vm.invoice.totalTax | readable: 2 }} {{ companyCurrency.symbol}}</div>\n                  </div>\n                </div> --><div class="sum-table ft-md ft-color-primary"><div class=tr><div class=td translate="Sub Total"></div><div class=td>{{ vm.invoice.totalPrice | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=tr><div class=td translate="Vat Amount"></div><div class=td>{{ vm.invoice.totalVat | readable: 2 }} {{ companyCurrency.symbol }}</div></div><!-- <div class="tr">\n                    <div class="td flex-40" translate="Shipping Charges"></div>\n                    <input type="text" class="input-primary flex-30"/>\n                    <div class="td flex-25">0.00</div>\n                  </div>\n                  <div class="tr">\n                    <div class="td flex-40" translate="Discount %"></div>\n                    <input type="text" class="input-primary flex-30"/>\n                    <div class="td flex-25">0.00</div>\n                  </div>\n                  <div class="tr">\n                    <div class="td flex-40" translate="Adjustment %"></div>\n                    <input type="text" class="input-primary flex-30"/>\n                    <div class="td flex-25">0.00</div>\n                  </div>\n                  <div class="tr">\n                    <div class="td" translate="Vat1 %"></div>\n                    <div class="td">{{ vm.invoice.items[0].vatPercent | readable: 2 }} %</div>\n                  </div> --><div class="tr total ft-bold-primary"><div class=td translate=Total(Kr)></div><div class=td>{{ vm.invoice.totalAmount | readable: 2 }} {{ companyCurrency.symbol }}</div></div></div></div></div><div class=flex-6></div></div><!-- <div class="d-flex align-items-center mb-1">\n            <div class="ft_14_600_black mr-16" translate="Attach File(s)"></div>\n            <div class="btn btn-gray">\n              <img src="/assets/icons/file-upload-gray.svg" alt=""/><span translate="Upload File"></span>\n            </div>\n          </div> --><div class="align-items-center mb-1"><div class=mr-16><img src=/assets/icons/paper-clip.svg alt="paper clip"> <span class="ft-md ft-bold-primary ft-color-primary" translate="Attach File(s)"></span></div><div class="d-flex flex-column flex-32" ngf-drop ng-model=vm.thumbnail ngf-change="vm.thumbFileUpdated($files, $event)" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=false ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'"><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> <span translate="Drag and Drop here or"></span> <span class="ft-blue-back ph-5" ngf-select ng-model=vm.thumbnail ngf-change="vm.thumbFileUpdated($files, $event)" name=file ngf-pattern="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" ngf-multiple=false ngf-accept="\'.jpg,.JPG,.jpeg,.JPEG,.png,.PNG\'" translate=Browse></span></div></div></div><div class="ft_12_500_gray mb-40" translate="You can upload a maximum of 5 files, 5MB each"></div><div class="row mb-16"><div class=col-6><label class="ft-md ft-bold-primary ft-color-primary" translate="Terms and Conditions"></label> <textarea placeholder="{{\'Mention your companys terms and conditions\' | translate}}"></textarea></div><div class=col-6><label class="ft-md ft-bold-primary ft-color-primary" translate=Notes></label> <textarea></textarea></div></div></div><div class=content-footer><div class="d-flex align-items-center"><button class="button-primary mr-16" ng-click=vm.save(true) ng-disabled=loading translate="Save as Draft"></button> <button class="button-primary mr-16" ng-click=vm.save(false) ng-disabled=loading translate=Save></button> <button class="button-third mr-16 ph-20" ng-click=vm.showRecipientsPopup(true) ng-disabled=loading translate="Save and Send"></button> <button class=button-ex1 ui-sref=financeSales ng-disabled=loading translate=Cancel></button></div></div></div></div></div></main>');
$templateCache.put('app/main/economic/invoice/detail/detail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div class="title-bar flex-between mb-24"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=invoiceList class="ft-normal-12-16 grey-2" translate=Invoices></a></div><div class=header-title translate="Invoice Detail"></div></div><div class="flex flex-row flex-items-center btn-group-header"><button class="approved ft_14_600_white" ng-if="vm.invoice.status==\'paid\'"><img src=/assets/icons/check-mark-white.svg class=mr-10 alt=""><span translate=Paid></span></button> <button class="pending ft_14_600_white ml-10" ng-if="vm.invoice.status==\'pending\'"><img src=/assets/icons/close-circle-red1.svg class=mr-10 alt=""><span translate=Pending></span></button> <button class="pending ft_14_600_white ml-10" ng-if="vm.invoice.status==\'declined\'"><img src=/assets/icons/close-circle-red1.svg class=mr-10 alt=""><span translate=Declined></span></button></div></div><div id=invoice-detail class=main-container><div class=content><!-- <div class="header-title">\n        <div class="pos-relative">\n          <div class="ft_18_600_black" translate="Invoice Detail"></div>\n          <div class="under-line w-170"></div>\n        </div>\n        <div class="button-group">\n          <button class="approved ft_14_600_white" ng-if="vm.invoice.status==\'paid\'">\n            <img src="/assets/icons/check-mark-white.svg" alt="">\n            <span translate="Paid"></span>\n          </button>\n          <button class="pending ft_14_600_white ml-10" ng-if="vm.invoice.status==\'pending\'">\n            <img src="/assets/icons/close-circle-red1.svg" alt="">\n            <span translate="Pending"></span>\n          </button>\n          <button class="pending ft_14_600_white ml-10" ng-if="vm.invoice.status==\'declined\'">\n            <img src="/assets/icons/close-circle-red1.svg" alt="">\n            <span translate="Declined"></span>\n          </button>\n        </div>\n      </div> --><div class=content-wrap><div class="sub-header mb-20 flex-between flex"><div class=item><div class="ft_12_600_gray mb-8" translate="Client or Vendor"></div><div class="login_input_new tx-ellipsis w-100">{{ vm.invoice.vendorType == "Client" ? vm.invoice.vendor.clientName : vm.invoice.vendor.name }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate=Staff></div><div class="login_input_new tx-ellipsis w-100">{{ vm.invoice.staff.displayName }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate=Date></div><div class="login_input_new w-100">{{ vm.invoice.date | date: "yyyy/MM/dd" : \'UTC\' }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Due Date"></div><div class="login_input_new w-100">{{ vm.invoice.dueDate | date: "yyyy/MM/dd" : \'UTC\' }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Project ID"></div><div class="login_input_new w-100">{{ vm.invoice.projectSystemTag }}</div></div><div class="item margin-0"><div class="ft_12_600_gray mb-8" translate="Created By"></div><div class="login_input_new w-100">{{ vm.invoice.createdBy.displayName }}</div></div></div><div class=pay-content><div class="flex-between mb-20"><div><label class=check_yellow_20><div class=ft_14_600_black translate="Included Terms and Conditions"></div><input type=checkbox checked ng-model=vm.invoice.termsAndConditions disabled> <span class=checkmark></span></label></div></div><div><div class="table-wrap mb-20"><div class=header><div class=flex-10 translate=Sr.No.></div><div class=flex-10 translate=Type></div><div class=flex-30 translate=Description></div><div class=flex-10 translate=Quantity></div><div class=flex-10 translate="Unit Price"></div><div class=flex-10 translate=Vat%></div><div class=flex-10 translate=Vat></div><div class=flex-10 translate=Amount></div></div><div><div ng-repeat="invoiceItem in vm.invoice.items track by $index"><div class=item><div class=flex-10>{{ invoiceItem.type.number }}</div><div class=flex-10>{{ invoiceItem.type.name }}</div><div class=flex-30>{{ invoiceItem.description }}</div><div class=flex-10>{{ invoiceItem.quantity }}</div><div class=flex-10><span ng-if=invoiceItem.unitPrice>{{ invoiceItem.unitPrice | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class=flex-10><span ng-if=invoiceItem.vatPercent>{{ invoiceItem.vatPercent | readable: 2 }}</span></div><div class=flex-10><span ng-if=invoiceItem.vatAmount>{{ invoiceItem.vatAmount | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class=flex-10><span ng-if=invoiceItem.price>{{ invoiceItem.price | readable: 2 }} {{ companyCurrency.symbol }}</span></div></div><div class=item ng-show=invoiceItem.taxPercent><div class=flex-10>&nbsp;</div><div class=flex-10>&nbsp;</div><div class=flex-30>&nbsp;</div><div class=flex-10>&nbsp;</div><div class=flex-10>&nbsp;</div><div class=flex-10><span translate=Tax></span>&nbsp;% {{ invoiceItem.taxPercent }}</div><div class=flex-10>&nbsp;</div><div class=flex-10><span ng-if=invoiceItem.taxAmount>{{ invoiceItem.taxAmount | readable: 2 }} {{ companyCurrency.symbol }}</span>&nbsp;</div></div></div></div></div></div><div class=input-group><div class=d-block><div class=w-350><span class=ft_14_600_black translate="Sum Total"></span><div></div><div class="login_input_new w-200">{{ vm.invoice.totalPrice | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=w-350><span class=ft_14_600_black translate=Vat></span><div></div><div class="login_input_new w-200">{{ vm.invoice.totalVat | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=w-350><span class=ft_14_600_black translate="Total Amount"></span><div></div><div class="login_input_new w-200">{{ vm.invoice.totalAmount | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=w-350 ng-if="vm.invoice.totalTax != 0"><span class=ft_14_600_black translate=Tax></span><div></div><div class="login_input_new w-200">{{ vm.invoice.totalTax | readable: 2 }} {{ companyCurrency.symbol }}</div></div></div></div><div class=btn-group><button class=btn_new_blue ng-click=vm.saveInvoiceDoc() ng-if=!vm.invoice.invoiceDoc><span class=ft_14_20_600_white translate=Save></span></button></div></div></div></div></div><div ng-if=vm.pdfViewing><pdf-viewer id=pdf-viewer class=pdf-viewer url=vm.invoice.invoiceDoc ng-close=vm.closePDFViewer></pdf-viewer></div></main>');
$templateCache.put('app/main/economic/invoice/list/list.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class=title-bar><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate=Invoices></a></div><div class=header-title translate="List of Invoices"></div></div><div class="flex flex-row flex-items-center ml-auto"><searchbox search-text=searchText search-event=vm.searchData() is-small=true></searchbox></div><button class="button-primary ml-16" ui-sref=createInvoice ng-if="ECO_ACCESS_CREATE > 2"><img src=/assets/icons/bx-plus16.svg alt=icons><span class=ml-2 translate="Add Invoice"></span></button> <button class="button-primary ml-16" ng-if="ECO_ACCESS_CREATE > 2" ng-click=vm.downloadAll()><img src=/assets/icons/download-white.svg alt=icons><span class=ml-2 translate="Download PDF"></span></button></div><div id=invoice-list><spinner ng-if="isLoading || isDownloading"></spinner><div><div><div class=btn-group><button class=btn1 ng-class=" isInvoice ? \'active\':\'\'" ng-click=OnInvoiceList() translate=Invoice></button> <button class=btn2 ng-class=" !isInvoice ? \'active\':\'\'" ng-click=OnCreditMemoList() translate="Credit Memo"></button></div><div class=listViewContainer ng-if=isInvoice><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=isAllChecked ng-change=setAllChecked()> <span class=checkmark></span></label></th><th class=ft_14_600_black><span translate="Sr No"></span></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'date\')"><span translate=Date></span> <img ng-src="{{sortItem.sort === \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'date\' && !vm.sortItems[1].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'client\')"><span translate=Client></span> <img ng-src="{{sortItem.sort === \'client\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'client\' && !vm.sortItems[2].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'client\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                           \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'invoiceNo\')"><span translate="Invoice No"></span> <img ng-src="{{sortItem.sort === \'invoiceNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'invoiceNo\' && !vm.sortItems[3].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'invoiceNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                              \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'amount\')"><span translate=Amount></span> <img ng-src="{{sortItem.sort === \'amount\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'amount\' && !vm.sortItems[4].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'amount\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                           \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'vatAmount\')"><span translate="Vat Amount"></span> <img ng-src="{{sortItem.sort === \'vatAmount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'vatAmount\' && !vm.sortItems[5].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'vatAmount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                              \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'total\')"><span translate=Total></span> <img ng-src="{{sortItem.sort === \'total\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'total\' && !vm.sortItems[6].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'total\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                          \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th><div class=dropdown><button tooltip-enable=false tooltip-placement=top-left uib-tooltip=status tooltip-class=customClass class="dropdown-toggle sel-project" type=button id=menu1 data-toggle=dropdown><span class=ft_14_600_black>{{vm.status | capitalize}}</span> <img src=/assets/icons/arrow_drop_down_20.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li><a href=# class="menu-item ft_12_regular_gray" data-ng-click=selectedProject(item.value) ng-repeat="item in vm.statusList">{{item.value | capitalize}}</a></li><li><a href=# class=menu-item ng-if=!vm.statusList.length>No Data</a></li></ul></div></th><th class=ft_14_600_black><span translate=Action></span></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, invoice) in vm.invoiceList"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=invoice.checked> <span class=checkmark></span></label></td><td>{{ totalCount - (vm.currentPage - 1)*numPerPage - $index }}.</td><td class=ft_14_regular_black>{{ invoice.date | date }}</td><td class=ft_14_regular_black>{{ invoice.vendorType == "Client" ? invoice.vendor.clientName : invoice.vendor.name }}</td><td class=ft_14_regular_black>{{ invoice.displaySeq }}</td><td class=ft_14_regular_black>{{ invoice.showTotalPrice | readable: 2 }}</td><td class=ft_14_regular_black>{{ (invoice.showTotalAmount-invoice.showTotalPrice) | readable: 2 }}</td><td class=ft_14_regular_black>{{ invoice.showTotalAmount | readable: 2 }}</td><td class="ft_14_regular_black {{invoice.status}}">{{ invoice.status | capitalize }}</td><td class=ft_14_regular_black><div class="flex flex-row flex-items-center vaActionContainer"><a ng-if="invoice.status==\'draft\'" href=/finance/sales/editInvoice/{{invoice._id}} class=mr-8><img src=/assets/icons/edit.svg alt=""></a><div class="cursor-point mr-4" ng-click=vm.viewInvoice(invoice)><img src=/assets/icons/eye6.svg alt=""></div><div class="cursor-point mr-4" ng-click=vm.downloadPdf(invoice)><img src=/assets/icons/cloud-download.svg alt=""></div><div class=cursor-point ng-click=vm.sendInvoiceMail(invoice)><img src=/assets/icons/send.svg alt=""></div></div></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.invoiceList.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.initData()></pagination-custom-new></div></div></div><div class=listViewContainer ng-if=!isInvoice><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=isAllChecked ng-change=setAllChecked()> <span class=checkmark></span></label></th><th class=ft_14_600_black><span translate="Sr No"></span></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'date\')"><span translate=Date></span> <img ng-src="{{sortItem.sort === \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'date\' && !vm.sortItems[1].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                         \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'client\')"><span translate=Client></span> <img ng-src="{{sortItem.sort === \'client\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'client\' && !vm.sortItems[2].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'client\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                           \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'invoiceNo\')"><span translate="Invoice No"></span> <img ng-src="{{sortItem.sort === \'invoiceNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'invoiceNo\' && !vm.sortItems[3].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'invoiceNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                              \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'amount\')"><span translate=Amount></span> <img ng-src="{{sortItem.sort === \'amount\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'amount\' && !vm.sortItems[4].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'amount\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                           \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'vatAmount\')"><span translate="Vat Amount"></span> <img ng-src="{{sortItem.sort === \'vatAmount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'vatAmount\' && !vm.sortItems[5].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'vatAmount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                              \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'total\')"><span translate=Total></span> <img ng-src="{{sortItem.sort === \'total\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                                 sortItem.sort === \'total\' && !vm.sortItems[6].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                                 sortItem.sort !== \'total\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                          \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th><div class=dropdown><button tooltip-enable=false tooltip-placement=top-left uib-tooltip=status tooltip-class=customClass class="dropdown-toggle sel-project" type=button id=menu1 data-toggle=dropdown><span class=ft_14_600_black>{{vm.status | capitalize}}</span> <img src=/assets/icons/arrow_drop_down_20.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li><a href=# class="menu-item ft_12_regular_gray" data-ng-click=selectedProject(item.value) ng-repeat="item in vm.statusList">{{item.value | capitalize}}</a></li><li><a href=# class=menu-item ng-if=!vm.statusList.length>No Data</a></li></ul></div></th><th class=ft_14_600_black><span translate=Action></span></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, invoice) in vm.creditMemoList"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=invoice.checked> <span class=checkmark></span></label></td><td>{{ totalCount - (vm.currentPage - 1)*numPerPage - $index }}.</td><td class=ft_14_regular_black>{{ invoice.date | date }}</td><td class=ft_14_regular_black>{{ invoice.vendorType == "Client" ? invoice.vendor.clientName : invoice.vendor.name }}</td><td class=ft_14_regular_black>{{ invoice.displaySeq }}</td><td class=ft_14_regular_black>{{ invoice.totalPrice | readable: 2 }}</td><td class=ft_14_regular_black>{{ (invoice.totalAmount-invoice.totalPrice) | readable: 2 }}</td><td class=ft_14_regular_black>{{ (invoice.totalAmount) | readable: 2 }}</td><td class="ft_14_regular_black {{invoice.status}}">{{ invoice.status | capitalize }}</td><td class=ft_14_regular_black><div class="flex flex-row flex-items-center vaActionContainer"><div class="cursor-point mr-4" ng-click=vm.viewInvoice(invoice)><img ng-src="{{invoice.status==\'draft\' ? \'/assets/icons/bx-edit6.svg\' : \'/assets/icons/eye6.svg\'}}" alt=""></div><div class="cursor-point mr-4" ng-click=vm.downloadPdf(invoice)><img src=/assets/icons/cloud-download.svg alt=""></div><div class=cursor-point ng-click=vm.sendInvoiceMail(invoice) ng-if="ECO_ACCESS_CREATE > 3"><img src=/assets/icons/send.svg alt=""></div></div></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.creditMemoList.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages1 current-page=vm.currentPage1 on-select-page=vm.initData()></pagination-custom-new></div></div></div></div></div></div></main><div ng-if=vm.pdfViewing><pdf-viewer id=pdf-viewer class=pdf-viewer url=vm.invoice.invoiceDoc ng-close=vm.closePDFViewer></pdf-viewer></div>');
$templateCache.put('app/main/economic/modals/DuplicatedModal/DuplicatedModal.view.html','<div id=DuplicatedModal><div class=title-black><div class=m-auto translate="Duplicated Bill"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class="ft_16_600_black mb-20"><span translate="This bill is already uploaded"></span>&nbsp; <span>{{vm.oldBilling.billNo}}</span>&nbsp; <span ng-if=!vm.utils.isEmpty(vm.oldBilling.projectId)>in {{vm.oldBilling.projectId.projectName}}</span></div><div class="ft_16_600_black mb-20" translate="Do you want to replace or delete this bill?"></div><div class=btnGroup><button class=btn_white ng-click=onSubmit() translate=Replace></button> <button class=btn_new_blue ng-click=deleteBilling() translate=Delete></button></div></div></div>');
$templateCache.put('app/main/economic/modals/approveBillModal/approveBillModal.view.html','<div id=approveBillModal><spinner ng-if=isLoading></spinner><div class=title><div class=tx-ellipsis translate="Approve Bill"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div class=mb-4><label class="d-block ft_12_600_gray mb-2" translate=Vendor></label><selectbox-input ng-model=vm.vendorId options=vm.vendors label-field=name value-field=_id select-event=""></selectbox-input></div><div class=mb-4><label class="d-block ft_12_600_gray mb-2" translate="Project or Other cost"></label><selectbox-input ng-model=vm.projectId options=vm.projects label-field=projectName value-field=_id></selectbox-input></div><div class=mb-4><label class="d-block ft_12_600_gray mb-2" translate=Approver></label><selectbox-input ng-model=vm.approverId options=vm.approvers label-field=displayName value-field=_id select-event=""></selectbox-input></div><div class="action flex-items-center flex-content-end mt-25"><button class="blue mr-4" ng-click=onApprove() translate=Approve></button> <button class="gray mr-4" ng-click=onCancel() translate=Cancel></button></div></div></div>');
$templateCache.put('app/main/economic/modals/costPercentModal/costPercentModal.view.html','<div id=costPercentModal><div class=title-black><div class=m-auto translate="Cost Additions"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class="flex-between mb-30"><div><div class="config-label mb-8" translate="Cost Percent %"></div><input class=input-primary ng-model=vm.percent type=number></div></div><div class="btnGroup mt-20"><button class=button-ex1 ng-click=onCancel() translate=Discard></button> <button class=button-primary ng-click=onSubmit() translate=Save></button></div></div></div>');
$templateCache.put('app/main/economic/modals/declineBillModal/declineBillModal.view.html','<div id=decline-bill-modal><div class=header><div class=tx-ellipsis translate="Decline a Bill"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class="ft_14_500_gray mb-2" translate=Description></div><textarea class=description ng-model=vm.description placeholder="Write some description">\n    </textarea></div><div class=footer><button class="btn_white mr-3" ng-click=onCancel() translate=Cancel></button> <button class=btn_new_blue ng-click=onOk() translate=Ok></button></div></div>');
$templateCache.put('app/main/economic/modals/drivingModal/drivingModal.view.html','<div id=driving-modal><div class=d-block><div class=title-black><div class=m-auto translate="Add Driving"></div><div class=mr-10 ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons class=cursor-point></div></div><div class=content><div class=flex-between ng-if=!isLoading><div><div class="ft_12_600_gray mb-8 required" translate="Start Location"></div><input places-auto-complete types="[\'geocode\']" class="input-primary w-250" on-place-changed=vm.placeMarker() id=location_input_from ng-model=vm.from.address></div><div><div class="ft_12_600_gray mb-8 required" translate="End Location"></div><input places-auto-complete types="[\'geocode\']" class="input-primary w-250" on-place-changed=vm.placeMarker() id=location_input_to ng-model=vm.to.address></div></div><div class="d-flex mt-10 align-items-center"><div class="ml-auto ft_12_600_gray" translate="Total Distance"></div><div class="ml-20 ft_12_400_gray">{{vm.addDriving.distance | readable : 2}} km</div></div><div class="w-100 mt-20"><div class=google-map><div class="gmap_viewer w-100"><div map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params="{{ vm.gmap.url }}"><ng-map center="{{ vm.gmap.center }}" zoom="{{ vm.gmap.zoom }}" id=driving_map><marker ng-if=vm.gmap.from position="{{ vm.gmap.from }}" draggable=true on-dragend=vm.updateMarker() icon="{ url:\'/assets/icons/pin-start.svg\', origin: [0,0], anchor: [10,10] }"></marker><marker ng-if=vm.gmap.to position="{{ vm.gmap.to }}" draggable=true on-dragend=vm.updateMarker() icon="{ url:\'/assets/icons/pin-stop.svg\', origin: [0,0], anchor: [10,10] }"></marker><directions draggable=true ng-if="vm.gmap.from && vm.gmap.to" panel="" suppress-markers=true waypoints={{vm.gmap.path}} travel-mode=DRIVING origin={{vm.gmap.from}} destination={{vm.gmap.to}} polyline-options="{strokeColor: \'#ff8b00\'}"></directions></ng-map></div></div></div></div><div style="display: flex;justify-content: flex-end;margin-top: 20px;"><button class=button-primary ng-click=vm.onAddNewDriving() translate="Add Driving"></button></div></div></div></div>');
$templateCache.put('app/main/economic/modals/imagePreviewModal/imagePreviewModal.view.html','<div id=image-preview-modal><div class=title-black><div class="tx-ellipsis ml-30" translate="Image Viewer"></div><div class=mr-30 ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons class=close-icon></div></div><div class="content flex-spacer overflow-hidden bg-white"><img class="w-100 h-100" style="object-fit: contain;" ngf-src="ImageURL.secure_url || ImageURL" alt="" ng-if=ImageURL><div class="p-5 text-center" ng-show=!ImageURL translate="No Image"></div></div></div>');
$templateCache.put('app/main/economic/modals/importInvoiceModal/importInvoiceModal.view.html','<div id=importInvoiceModal ng-if=!isItemMode><div class=title-black><div class=m-auto translate="Select Invoice"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons class=cursor-point></div></div><div class=content-wrap><div class=pos-relative><img src=/assets/icons/search1.svg alt="" class=pos-absolute> <input type=text class=login_input class="Type to search" ng-model=vm.searchText ng-change=onSearch()></div><div class=body-scroll><spinner ng-if=isLoading></spinner><table ng-if=!isLoading><tbody class=ft_14_regular_black><tr class=ft_14_600_white><td class=check-td>&nbsp;</td><td translate=Sr.No.></td><td translate=Date></td><td translate=Vendor></td><td translate=Invoice></td><td translate=Amount></td><td translate=Vat></td><td translate=Total></td></tr><tr ng-repeat="invoice in vm.filteredList"><td class=check-td><label class=check_yellow_20><input type=checkbox ng-checked="invoice==vm.creditNote" ng-click="vm.importInvoiceChecked(invoice, $event.target.checked)"> <span class=checkmark></span></label></td><td>{{ vm.invoiceList.length - $index }}.</td><td>{{ invoice.createdAt | date }}</td><td>{{ invoice.vendorType == \'Client\' ? invoice.vendor.clientName : invoice.vendor.name }}</td><td>{{ invoice.displaySeq }}</td><td>{{ invoice.totalPrice | readable: 2 }}</td><td class=text-center>{{ invoice.totalVat | readable: 2 }}</td><td class=text-center>{{ invoice.totalAmount | readable: 2 }}</td></tr></tbody></table></div><div class=btn-wrap><button class=btn_new_blue ng-click=nextStep() translate=Next></button></div></div></div><div id=importInvoiceItemModal ng-if=isItemMode><div class=title-black><div class=m-auto>Import Item</div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons class=cursor-point></div></div><div class=content-wrap><div class=flex><div class=flex-30><div class="ft_12_regular_gray mb-8" translate="Invoice No"></div><div class=ft_14_600_black>{{ vm.creditNote.displaySeq }}</div></div><div class=flex-30><div class="ft_12_regular_gray mb-8" translate="Due Date"></div><div class=ft_14_600_black>{{ vm.creditNote.dueDate | date: "MMM dd, yyyy" : \'UTC\' }}</div></div><div class=flex-30><div class="ft_12_regular_gray mb-8" translate="Payment Terms"></div><div class=ft_14_600_black>{{ vm.creditNote.paymentTerms.length > 0 ? vm.creditNote.paymentTerms[0].code : \'\' }}</div></div></div><div class=body-scroll><table><tbody class=ft_14_regular_black><tr class=ft_14_600_white><td class=check-td>&nbsp;</td><td translate=Item></td><td translate=Quantity></td><td translate="Unit Price"></td><td translate="Vat %"></td><td translate=Vat></td><td translate="Sales Price"></td></tr><tr ng-repeat="item in vm.creditNote.items"><td class=check-td><label class=check_yellow_20><input type=checkbox ng-model=item.checked> <span class=checkmark></span></label></td><td>{{ item.description }}</td><td>{{ item.quantity }}</td><td>{{ item.unitPrice | readable: 2 }}</td><td>{{ item.taxPercent }}</td><td class=text-center>{{ item.taxAmount | readable: 2 }}</td><td class=text-center>{{ item.price | readable: 2 }}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td translate=Sub></td><td>{{ vm.creditNote.totalPrice | readable: 2 }}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td translate=Vat></td><td>{{ vm.creditNote.totalVat | readable: 2 }}</td></tr><tr ng-if=vm.creditNote.totalTax><td></td><td></td><td></td><td></td><td></td><td translate=Tax></td><td>{{ vm.creditNote.totalTax | readable: 2 }}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td translate=Total></td><td class=fw-bold>{{ vm.creditNote.totalAmount | readable: 2 }}</td></tr></tbody></table></div><div class=btn-wrap><button class=btn_new_blue ng-click=onProceed() translate=Proceed></button></div></div></div>');
$templateCache.put('app/main/economic/modals/importVariationModal/importVariationModal.view.html','<div id=importVariationModal ng-if=!isItemMode><div class=title-black><div class=m-auto translate="Select Variation Order"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons class=cursor-point></div></div><div class=content-wrap><div class=pos-relative><img src=/assets/icons/search1.svg alt="" class=pos-absolute> <input type=text class=input-primary class="Type to search" ng-model=searchText></div><div class=body-scroll><spinner ng-if=isLoading></spinner><table ng-if=!isLoading><tbody class=ft_14_regular_black><tr class=ft_14_600_white><td class=check-td>&nbsp;</td><td translate=Sr.No.></td><td translate=Date></td><td translate="Variation Order"></td><td translate=Amount></td><td translate="Vat Amount"></td><td translate=Total></td></tr><tr ng-repeat="vaOrder in vm.variationOrderList | filter:{displaySeq: searchText}"><td class=check-td><label class=check_yellow_20><input type=checkbox ng-checked="vaOrder==vm.importData" ng-click="vm.importVariationOrderChecked(vaOrder, $event.target.checked)"> <span class=checkmark></span></label></td><td>{{ vm.variationOrderList.length - $index }}.</td><td>{{ vaOrder.createdAt | date }}</td><td>{{ vaOrder.displaySeq }}</td><td>{{ vaOrder.totalPrice | readable: 2 }}</td><td>{{ vaOrder.totalVat | readable: 2 }}</td><td>{{ vaOrder.totalAmount | readable: 2 }}</td></tr></tbody></table></div><div class=btn-wrap><button class="button-primary ph-20" ng-click=nextStep() translate=Next></button></div></div></div><div id=importVariationItemModal ng-if=isItemMode><div class=title-black><div class=m-auto translate="Import Item"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons class=cursor-point></div></div><div class=content-wrap><div class=flex><div class=flex-30><div class="ft_12_regular_gray mb-8" translate="Variation Order No"></div><div class=ft_14_600_black>{{ vm.importData.displaySeq }}</div></div><div class=flex-30><div class="ft_12_regular_gray mb-8" translate="Due Date"></div><div class=ft_14_600_black>{{ vm.importData.dueDate | date: "MMM dd, yyyy" : \'UTC\' }}</div></div><div class=flex-30><div class="ft_12_regular_gray mb-8" translate="Payment Terms"></div><div class=ft_14_600_black>{{ vm.importData.paymentTerms.length > 0 ? vm.importData.paymentTerms[0].code : \'\' }}</div></div></div><div class=body-scroll><table><tbody class=ft_14_regular_black><tr class=ft_14_600_white><td class=check-td>&nbsp;</td><td translate=Item></td><td translate=Quantity></td><td translate="Unit Price"></td><td translate="Vat %"></td><td translate=Vat></td><td translate="Sales Price"></td></tr><tr ng-repeat="item in vm.importData.items"><td class=check-td><label class=check_yellow_20><input type=checkbox ng-model=item.checked> <span class=checkmark></span></label></td><td>{{ item.description }}</td><td>{{ item.quantity }}</td><td>{{ item.unitPrice | readable: 2 }}</td><td>{{ item.taxPercent }}</td><td>{{ item.taxAmount | readable: 2 }}</td><td>{{ item.price | readable: 2 }}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td translate=Sub></td><td>{{ vm.importData.totalPrice | readable: 2 }}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td translate=Vat></td><td>{{ vm.importData.totalVat | readable: 2 }}</td></tr><tr ng-if=vm.importData.totalTax><td></td><td></td><td></td><td></td><td></td><td translate=Tax></td><td>{{ vm.importData.totalTax | readable: 2 }}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td translate=Total></td><td class=fw-bold>{{ vm.importData.totalAmount | readable: 2 }}</td></tr></tbody></table></div><div class=btn-wrap><button class=button-primary ng-click=onProceed() translate=Proceed></button></div></div></div>');
$templateCache.put('app/main/economic/modals/payrollFilterModal/payrollFilterModal.view.html','<div id=payroll-filter-modal><div class=title-black><div class=m-auto translate=Filter></div><div class=mr-10 ng-click=vm.onCancel()><img src=/assets/icons/close-18-white.svg alt=icons class=cursor-point></div></div><div class=content ng-if="vm.projects && vm.workers"><label class=check_yellow_20><div class=ft_14_600_black translate=Date></div><input type=checkbox ng-checked=vm.simpleFilter.isDateFilter ng-click=vm.enableDisableDateFilter()> <span class=checkmark></span></label><div class=flex-between><div><div class="ft_12_600_gray mb-8" translate="Start Date"></div><div class="input-group datePicker-primary"><input ng-disabled=!vm.simpleFilter.isDateFilter type=text class=input-primary date-picker=dd.MM.yyyy date=vm.simpleFilter.startTime change=vm.onChangeFilterTime() is-open=isStartpickerOpen ng-required=true> <span class=dateArrow ng-click="isStartpickerOpen = !isStartpickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div><div class="ft_12_600_gray mb-8" translate="End Date"></div><div class="input-group datePicker-primary"><input ng-disabled=!vm.simpleFilter.isDateFilter type=text class=input-primary date-picker=dd.MM.yyyy date=vm.simpleFilter.endTime change=vm.onChangeFilterTime() is-open=isEndpickerOpen ng-required=true> <span class=dateArrow ng-click="isEndpickerOpen = !isEndpickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div><label class=check_yellow_20><div class=ft_14_600_black translate=Project></div><input type=checkbox checked ng-model=vm.simpleFilter.isProjectFilter> <span class=checkmark></span></label><selectbox-input class="mb-20 dropdown-primary" ng-model=projectId options=vm.projects label-field=projectName value-field=_id placeholder={{vm.simpleFilter.project.projectName}} select-event=vm.addProjectTemp(projectId)></selectbox-input><label class=check_yellow_20><div class=ft_14_600_black translate=Employee></div><input type=checkbox checked ng-model=vm.simpleFilter.isClientFilter> <span class=checkmark></span></label><selectbox-input class="mb-20 dropdown-primary" ng-model=workerId options=vm.workers label-field=displayName value-field=_id placeholder={{vm.simpleFilter.client.displayName}} select-event=vm.addWorkerTemp(workerId)></selectbox-input><div class=flex-center><button class=button-primary ng-click=vm.showFilterResult() translate=Results></button></div></div></div>');
$templateCache.put('app/main/economic/modals/payrollModal/payrollModal.view.html','<div id=payroll-modal><div class=title-black><div class="ml-16 my-auto mr-auto" translate=Preview></div><div class=mr-10 ng-click=vm.onCancel()><img src=/assets/icons/close-18-white.svg alt=icons class=cursor-point></div></div><div class=content><div class=detail-info><div class=detail-item><span class=detail-label translate=Name></span> <span class="detail-value tx-ellipsis" title={{vm.payroll.userId.displayName}}>{{vm.payroll.userId.displayName}}</span></div><div class=detail-item><span class=detail-label translate="Project Name"></span> <span class=detail-value>{{vm.payroll.projectId.projectName}}</span></div><div class=detail-item><span class=detail-label translate=Date></span> <span class=detail-value>{{vm.payroll.date | slashDate}}</span></div><div class=detail-item><span class=detail-label translate="Start Time"></span> <span class=detail-value>{{vm.payroll.startTime | smartTime}}</span></div><div class=detail-item><span class=detail-label translate="End Time"></span> <span class=detail-value>{{vm.payroll.endTime | smartTime}}</span></div><div class=detail-item><span class=detail-label translate="Break Hours"></span> <span class=detail-value>{{vm.breakHours | readable: 2}} hrs</span></div><div class=detail-item><span class=detail-label translate="Task Hours"></span> <span class=detail-value>{{vm.workHours | readable: 2}} hrs</span></div><div class=detail-item><span class=detail-label translate="Total Hours"></span> <span class=detail-value>{{vm.totalHours | readable: 2}} hrs</span></div><div class=detail-item><span class=detail-label translate="Distance Covered"></span> <span class=detail-value>{{vm.payroll.distance | readable: 2}} kms</span></div><div class=detail-item><span class=detail-label translate="Over Time"></span> <span class=detail-value>{{vm.overHours | readable: 2}} hrs</span></div></div><div class=driving><div class=addresses><div class=address><div class=sub-title><div class="circle start"></div><span translate="Starting Location"></span></div><div class=value>{{vm.from.address}}</div></div><div class=address><div class=sub-title><div class=circle></div><span translate="Ending Location"></span></div><div class=value>{{vm.to.address}}</div></div><div class=vert-line></div></div><div class=google-map><div class="gmap_viewer w-100"><div map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params="{{ vm.gmap.url }}"><ng-map center="{{ vm.gmap.center }}" zoom="{{ vm.gmap.zoom }}" id=driving_map><marker ng-if=vm.gmap.from position="{{ vm.gmap.from }}" draggable=false icon="{ url:\'/assets/icons/pin-start.svg\', origin: [0,0], anchor: [10,10] }"></marker><marker ng-if=vm.gmap.to position="{{ vm.gmap.to }}" draggable=false icon="{ url:\'/assets/icons/pin-stop.svg\', origin: [0,0], anchor: [10,10] }"></marker><directions draggable=true ng-if="vm.gmap.from && vm.gmap.to" panel="" suppress-markers=true waypoints={{vm.gmap.path}} travel-mode=DRIVING origin={{vm.gmap.from}} destination={{vm.gmap.to}} polyline-options="{strokeColor: \'#ff8b00\'}"></directions></ng-map></div></div><spinner ng-if=vm.loading></spinner></div></div><div class=receipts><div class=sub-title translate=Receipts></div><div class=preview><img ng-src={{vm.receipts[0].secure_url}} alt="" ng-if=vm.receipts.length></div><div class=files><div class=file ng-repeat="receipt in vm.receipts"><img class=object-fit-cover ng-src={{receipt.secure_url}} alt=""></div><div class=file ng-repeat="x in [].constructor(3-vm.receipts.length) track by $index" ng-if="vm.receipts.length < 3"></div></div></div></div></div>');
$templateCache.put('app/main/economic/modals/recipientsModal/recipientsModal.view.html','<div id=recipients-modal><div class=header><div class=tx-ellipsis>{{vm.title}}</div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class="ft_12_600_gray mb-8" translate="Email ID"></div><div class="flex-between mb-16"><input type=email class=login_input placeholder="Start typing an email" ng-model=inputEmail enter-key=addRecipientEmail(inputEmail) ng-pattern=EMAIL_REGEX><div class=btn_add ng-click=addRecipientEmail(inputEmail)><img src=/assets/icons/plus-lg.svg alt=""></div></div><div class="item-wrap mb-16"><div class=item ng-repeat="email in recipients.emails track by $index">{{email}} <img ng-if="$index>0" src=/assets/icons/close-gray.svg alt="" ng-click=removeUserList($index)></div></div><div ng-if=!vm.isVaOrder><div class="ft_12_600_gray mb-8" translate=Managers></div><div class="flex-between mb-16"><selectbox-input style="width: calc(100% - 40px)" ng-model=companyManagerId options=vm.companyManagers label-field=displayName value-field=_id select-event=selCompanyManager(companyManagerId)></selectbox-input><div class=btn_add ng-click=addRecipientManager(inputManager)><img src=/assets/icons/plus-lg.svg alt=""></div></div><div class="item-wrap mb-16"><div class=item ng-repeat="manager in recipients.managers track by $index">{{ manager.displayName }} <img src=/assets/icons/close-gray.svg alt="" ng-click=removeManagerList($index)></div></div></div><div ng-if=vm.isVaOrder><div class=search-option-group><div class=search-option><radio ng-model=currentDesignation ng-value="\'Manager\'"></radio><div class=label translate=Manager></div></div><div class=search-option><radio ng-model=currentDesignation ng-value="\'Subcontractor\'"></radio><div class=label translate=Subcontractor></div></div><div class=search-option><radio ng-model=currentDesignation ng-value="\'Supplier\'"></radio><div class=label translate=Supplier></div></div><div class=search-option><radio ng-model=currentDesignation ng-value="\'Client\'"></radio><div class=label translate=Client></div></div></div><div class=search-and-add><div style="width: calc(100% - 40px);"><autocomplete1 input-class=fm-search-input ng-model=vm.selectedUserId label-field=displayName value-field=_id options=vm.users no-margin-right=true no-flex=true place-holder="Start typing a name" full-width=true></autocomplete1></div><div class=btn_add ng-click=onAdd()><img src=/assets/icons/plus-lg.svg alt=""></div></div><div class=content-body><div class=assigned-member ng-repeat="member in assignedMembers track by $index"><div ng-if="member.type !== \'Guest\'" class="left flex-items-center"><img ng-if=member.userId.profilePic class="user-avatar object-fit-cover" ng-src={{member.userId.profilePic}} alt=""><div ng-if=!member.userId.profilePic data-letters="{{vm.utils.nameLetter(member.userId.firstName, member.userId.lastName)}}"></div><div><div class=ft_12_regular_gray>{{member.userId.displayName}}</div><div class=ft_10_regular_gray>{{member.userId.designation}}</div></div></div><div ng-if="member.type === \'Guest\'" class="left flex-items-center"><div class=ft_12_regular_gray>{{member.email}}</div></div><div class="right flex-items-center flex-between"><div></div><img ng-if="member.type === \'Member\'" class=cursor-point src=/assets/icons/close-16.svg alt=remove ng-click="onDelete($index, member.userId)"></div></div></div></div></div><div class=footer ng-if=vm.showSend><button class=btn_white ng-click=onCancel() translate=Cancel></button> <button class=btn_new_blue ng-click=send() translate=Send></button></div></div>');
$templateCache.put('app/main/economic/modals/templateFieldModal/templateFieldModal.view.html','<div id=template-field-modal><div class=title><div class=tx-ellipsis translate="Add Field"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=input-modal-content><div class=mb-16><div class="ft_12_600_gray mb-8" translate="Please select field name"></div><selectbox-input ng-model=fieldId options=fieldList label-field=description value-field=name select-event=onChangeField(fieldId)></selectbox-input></div><div ng-if="vm.resolve.isManualTemplate && isSelectedLoopField()" class=mb-16><div class="ft_12_600_gray mb-8">{{selectedField.description}}&nbsp;<span translate=Number></span></div><input type=number min=1 max={{MAX_SUPPLIES_COUNT}} step=1 ng-model=vm.currentIndex ng-change=onChangeCurrentIndex()></div><div ng-if="!vm.resolve.isManualTemplate || !isSelectedLoopField()" style="height: 72px;"></div><div class=flex-content-end><button ng-click=onCancel() class="btn_white margin-0" translate=Cancel></button> <button ng-click=onSave() class=btn_new_blue translate=Save></button></div></div></div>');
$templateCache.put('app/main/economic/modals/uploadNewBillModal/uploadNewBillModal.view.html','<div id=uploadNewBillModal><spinner ng-if=isLoading></spinner><div class=title><div class=tx-ellipsis translate="Upload New Bill"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div class=mb-4><label class="d-block ft_12_600_gray mb-2 required">Select Bills</label><div class="d-flex flex-column" ngf-drop ngf-change="vm.fileUpdated($files, $event)" name=file ngf-multiple=true><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> <span translate="Drag and Drop or"></span> <span class="ft-blue-back ph-5" ngf-select ngf-change="vm.fileUpdated($files, $event)" name=file ngf-multiple=true translate=Browse></span> <span translate="to Upload"></span></div><div class=upload-files ng-if="vm.files && vm.files.length"><div class=upload-file ng-repeat="file in vm.files track by $index"><img class=file-icon ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=progress-container><div class=progress-info><div class=file-name>{{file.name}}</div></div></div><img class=cancel-icon src=/assets/icons/close-circle-f-gray.svg alt="" ng-click="vm.cancelUpload(file, $index)"></div></div></div></div><div class="flex-items-center mb-4"><checkbox class=mr-8 ng-model=vm.isMemo></checkbox><label class="d-block ft_12_600_gray margin-0" translate="Vendor Credit Memo"></label></div><!-- <div class="mb-4">\n      <label class="d-block ft_12_600_gray mb-2" translate="Vendor"></label>\n      <selectbox-input class="input-select" ng-model="vm.vendorId" options="vm.vendors" label-field="name" value-field="_id" select-event=""></selectbox-input>\n    </div>\n    <div class="mb-4">\n      <label class="d-block ft_12_600_gray mb-2" translate="Project or Other cost"></label>\n      <selectbox-input class="input-select" ng-model="vm.projectId" options="vm.projects" label-field="projectName" value-field="_id"></selectbox-input>\n    </div>\n    <div class="mb-4">\n      <label class="d-block ft_12_600_gray mb-2" translate="Approver"></label>\n      <selectbox-input class="input-select" ng-model="vm.approverId" options="vm.approvers" label-field="displayName" value-field="_id" select-event=""></selectbox-input>\n    </div> --><div class="action flex-items-center flex-content-end mt-25"><button class="btn_new_blue mr-4" ng-click=onUpload() translate=Upload></button> <button class="gray mr-4" ng-click=onCancel() translate=Cancel></button></div></div></div>');
$templateCache.put('app/main/economic/va-order/action/action.view.html','<main-title-bar></main-title-bar><div id=variation-order-action class=main-container><div class=content><login-left-block></login-left-block><div class=right-side><img src=/assets/images/login/logo.svg alt=login><div class="login_title mt-24">VA Order</div><div class=account-noti><span class=account translate="I want to"></span>&nbsp; <span class="mark cursor-point" ui-sref=login translate="Sign in"></span></div><div class=login-contents><spinner ng-if=isLoading></spinner><div class=action-content-wrapper ng-if=!isLoading><div class=image-wrapper><div class=approved ng-if="vm.vaOrder.status===\'approved\'"><div class=d-flex><img src=/assets/icons/checked-lg2.svg alt=""></div><div class=mt-50 ng-if="vm.vaOrderPrevStatus === \'approved\'">VA Order ({{vm.vaOrder.displaySeq}}) has already been approved.</div><div class=mt-50 ng-if="vm.vaOrderPrevStatus !== \'approved\'">VA Order ({{vm.vaOrder.displaySeq}}) has been approved.</div></div><div class=declined ng-if="vm.vaOrder.status===\'declined\'"><div class=d-flex><img src=/assets/icons/close-lg2.svg alt=""></div><div class=mt-50 ng-if="vm.vaOrderPrevStatus === \'declined\'">VA Order ({{vm.vaOrder.displaySeq}}) has already been declined.</div><div class=mt-50 ng-if="vm.vaOrderPrevStatus !== \'declined\'">VA Order ({{vm.vaOrder.displaySeq}}) has been declined.</div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/economic/va-order/create/create.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="title-bar mb-5"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=invoiceList class="ft-normal-12-16 grey-2" translate="VA Orders"></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Create VA Order"></a></div><div class=header-title translate="Create VA Order"></div></div></div><div id=create-order><div class=content><!-- <div class="sub-navigation">\n        <a ui-sref="economicManage" class="ft_14_regular_gray" translate="Economic"></a>\n        <img src="/assets/icons/chevron-right 1.svg" alt="icons"/>\n        <a class="ft_14_600_gray">{{(vm.isEdit ? \'Variation Order Detail\' : \'Create Variation Order\') | translate}}</a>\n      </div> --><div class="content-wrap ft_14_600_gray flex-center" ng-if=isLoading translate="No data to display"></div><spinner ng-if=isLoading></spinner><spinner ng-if=isSending></spinner><div class="content-wrap pos-relative" ng-if=!isLoading><spinner ng-if=isSaving></spinner><div class="sub-header mb-20 flex-between flex"><div class="item flex-21"><div class="ft_12_600_gray mb-8" translate="Client or Vendor"></div><selectbox-input class="dropdown-primary flex-100" ng-model=vm.vendorIdTemp options=vm.userListTemp label-field=name value-field=_id select-event=vm.clientChanged(vm.vendorIdTemp) is-search=true></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate=Staff></div><selectbox-input class="dropdown-primary w-100" ng-model=vm.vaOrder.staff options=vm.vaOrder.vendor.staffs label-field=displayName value-field=_id is-search=true></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate="Reference No"></div><input type=text class=input-primary ng-model=vm.vaOrder.referenceNo></div><div class="item date-picker"><div class="ft_12_600_gray mb-8" translate=Date></div><div class="input-group datePicker-primary"><input type=text class="input-primary w-100" change=invoiceDateChanged() date-picker=dd.MM.yyyy date=vm.vaOrder.date is-open=isDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isDatepickerOpen = !isDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class="item date-picker"><div class="ft_12_600_gray mb-8" translate="Accept Before"></div><div class="input-group datePicker-primary"><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.vaOrder.dueDate is-open=isDueDatepickerOpen ng-required=true readonly> <span class=dateArrow><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Time Effect \xB1"></div><div class=input-group><div class="dropdown time-effect w-100"><button class=dropdown-toggle type=button id=menu2 data-toggle=dropdown>{{vm.selectedTime}}</button><ul class=dropdown-menu role=menu aria-labelledby=menu2><li><div class="d-flex time-effect-item"><span ng-click=vm.selectTimeEffect(0) translate=Time></span><div class=focus><input type=text number-edit=2 ng-model=vm.additionalTime>Hours</div><span ng-click=vm.selectTimeEffect(0) translate="Additional Time"></span></div></li><li><div class="d-flex time-effect-item"><span ng-click=vm.selectTimeEffect(1) translate=Time></span><div class=focus><input type=text number-edit=2 ng-model=vm.productChange>Hours</div><span ng-click=vm.selectTimeEffect(1) translate="Product Change"></span></div></li></ul></div></div></div><div class="item margin-0"><div class="ft_12_600_gray mb-8" translate="Created By"></div><input type=text class="input-primary w-100" ng-model=vm.vaOrder.createdByName readonly></div></div><div class=pay-content><div class="flex-between mb-20"><div class=flex><label class="check_yellow_20 mr-30"><div class=ft_14_600_black translate="Included Terms and Conditions"></div><input type=checkbox checked ng-model=vm.vaOrder.termsAndConditions> <span class=checkmark></span></label> <label class=check_yellow_20><div class=ft_14_600_black translate="negative VA Order"></div><input type=checkbox ng-model=vm.isNegative ng-change=calculateSummary()> <span class=checkmark></span></label></div><div class=flex><div class=flex><div class="dropdown ml-20 add-payment-terms"><button class=button-ex2 type=button id=menu1 data-toggle=dropdown>+&nbsp;<span translate="Add Payment Terms"></span></button><ul class="dropdown-menu w-190" role=menu aria-labelledby=menu1><li><a href=# class=menu-item ng-repeat="cc in vm.paymentConditions | filter:{validate:\'false\'}" ng-click=vm.addPaymentTerm(cc)>{{ cc.code }}</a></li></ul></div><button class="button-ex2 ml-20" ng-click=vm.showImportVariationPopup()><img src=/assets/icons/bx-import-blue.svg alt=""><span translate="Import Variations"></span></button><div class=ml-20><button class=button-ex2 ng-click=vm.showCostPercentPopup()>+&nbsp;<span translate="Cost Additions"></span></button></div></div></div></div><div class=item-wrap ng-if=false><div class=item ng-repeat="term in vm.vaOrder.paymentTerms track by $index">{{ term.code }}<img src=/assets/icons/close-gray.svg alt="" ng-click=vm.deletePaymentTerm($index)></div></div><div><div class="items-table mb-16"><div class="tr ft-md ft-bold-secondary ft-color-primary"><div class="th flex-8" translate=Sr.No.></div><div class="th flex-15" translate=Type></div><div class="th flex-25" translate=Description></div><div class="th flex-8 text-right" translate=Qty></div><div class="th flex-10 text-right" translate="Unit Price"></div><div class="th flex-8 text-right" translate="Vat %"></div><div class="th flex-10 text-right" translate="Vat Amount"></div><div class="th flex-10 text-right" translate="Sales Price"></div><div class="th flex-6"></div></div><div class="tr ft-md ft-bold-secondary ft-color-primary" ng-repeat="item in vm.vaOrder.items track by $index"><div class="td flex-8 dropdown-wrap"><selectbox class=dropdown-primary ng-model=item.itemId options=vm.accountPlans ng-class="{inactive: !item.isEdit}" label-field=label value-field=_id short-label-field=number select-event="vm.selectItemType(item.itemId, item, \'accountPlan\')" readonly></selectbox></div><div class="td flex-15 dropdown-wrap"><selectbox class=dropdown-primary ng-model=item.itemNum options=item.settingItems ng-class="{inactive: !item.isEdit}" label-field=label value-field=_id select-event="vm.selectItemType(item.itemNum, item, \'settingItem\')" readonly></selectbox></div><div class="td flex-25 dropdown-wrap-lg" ng-if=!item.isServiceAndVAOrder><input class=input-primary type=text ng-model=item.description ng-readonly=!item.isEdit ng-class="{inactive: !item.isEdit}"></div><div class="td flex-25 dropdown-wrap-lg" ng-if=item.isServiceAndVAOrder><input class=input-primary type=text ng-model=item.description ng-class="{inactive: !item.isEdit}" ng-keyup="vm.searchItemDescription(item, item.description, $event)" ng-readonly=!item.isEdit><ul ng-if="filteredItems.length>0 && vm.curItem==item" class=pos-absolute><li class=menu-item ng-click="vm.selectItemDescription(item, fitem)" ng-repeat="fitem in filteredItems">{{ fitem.name }}</li></ul></div><div class="td flex-8"><input class=input-primary type=number ng-class="{inactive: !item.isEdit, \'text-right\': true}" number-edit=2 ng-model=item.quantity ng-blur=vm.calculateItemPrice(item) ng-readonly=!item.isEdit></div><div class="td flex-10"><input class=input-primary type=number ng-class="{inactive: !item.isEdit, \'text-right\': true}" number-edit ng-model=item.unitPrice ng-value=item.unitPrice ng-blur=vm.calculateItemPrice(item) ng-readonly=!item.isEdit></div><div class="td flex-8"><input class=input-primary type=number ng-class="{inactive: !item.isEdit, \'text-right\': true}" number-edit ng-model=item.vatPercent ng-blur=vm.calculateItemPrice(item) ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ ng-readonly=!item.isEdit></div><div class="td flex-10 text-right"><span ng-if=item.vatAmount class=value>{{ item.vatAmount | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class="td flex-10 text-right"><span ng-if="item.price && item.vatAmount" class=value>{{item.price + item.vatAmount | readable: 2}} {{ companyCurrency.symbol }}</span></div><div class="td flex-6 d-flex justify-content-center align-items-center"><!-- <div class="d-flex mr-1 cursor-point">\n                    <img src="/assets/icons/more-light.svg" alt="" class="more"/>\n                    <img src="/assets/icons/more-light.svg" alt="" class="more"/>\n                  </div> --> <img src=/assets/icons/bxs-edit-blue.svg alt="" class="action-icon mr-16" ng-click=vm.editVariationOrderRow(item) ng-if=!item.isEdit> <img src=/assets/icons/check-mark-line-blue.svg alt="" class="action-icon mr-16" ng-click=vm.confirmVariationOrderRow(item) ng-if=item.isEdit> <img src=/assets/icons/trash-alt-red.svg alt="" class=action-icon ng-click=vm.removeVariationOrderRow($index)></div></div><div class=item ng-show=item.taxPercent><div class=flex-8>&nbsp;</div><div class=flex-15>&nbsp;</div><div class=flex-25>&nbsp;</div><div class=flex-8>&nbsp;</div><div class=flex-10>&nbsp;</div><div class=flex-8><span translate=Tax></span>&nbsp;% {{ item.taxPercent }}</div><div class=flex-10>&nbsp;</div><div class=flex-10 ng-if=item.taxPercent><span ng-if=item.taxAmount>{{ item.taxAmount | readable: 2 }} {{ companyCurrency.symbol }} </span>&nbsp;</div><div class=flex-6>&nbsp;</div></div></div><div class=add-new-line><div class="ft-md ft-bold-primary ft-color-ex1 ml-1" ng-click=vm.addVariationOrderRow()>+&nbsp;<span translate="Add New Line"></span></div></div></div><!--<div>\n            <div class="table-wrap">\n              <div class="header">\n                <div class="flex-8" translate="Sr.No."></div>\n                <div class="flex-10" translate="Type"></div>\n                <div class="flex-34" translate="Description"></div>\n                <div class="flex-8" translate="Qty"></div>\n                <div class="flex-8" translate="Unit Price"></div>\n                <div class="flex-8" translate="Vat %"></div>\n                <div class="flex-8" translate="Vat Amount"></div>\n                <div class="flex-8" translate="Sales Price"></div>\n                <div class="flex-8" translate="Actions"></div>\n              </div>\n              <div>\n                <div ng-repeat="item in vm.vaOrder.items track by $index">\n                  <div class="item" ng-class="{active:item.isEdit}">\n                    <div class="flex-8 dropdown-wrap">\n                      <selectbox ng-model="item.itemId"\n                        options="vm.accountPlans"\n                        label-field="label"\n                        value-field="_id"\n                        short-label-field="number"\n                        select-event="vm.selectItemType(item.itemId, item, \'accountPlan\')"\n                        readonly="!item.isEdit">\n                      </selectbox>\n                    </div>\n                    <div class="flex-10 dropdown-wrap">\n                      <selectbox ng-model="item.itemNum"\n                        options="item.settingItems"\n                        label-field="label"\n                        value-field="_id"\n                        select-event="vm.selectItemType(item.itemNum, item, \'settingItem\')"\n                        readonly="!item.isEdit">\n                      </selectbox>\n                    </div>\n                    <div class="flex-34 dropdown-wrap-lg" ng-if="!item.isServiceAndVAOrder">\n                      <input class="field" type="text" ng-model="item.description" ng-readonly="!item.isEdit"/>\n                    </div>\n                    <div class="flex-34 dropdown-wrap-lg" ng-if="item.isServiceAndVAOrder">\n                      <input class="field"\n                        type="text" ng-model="item.description"\n                        ng-keyup="vm.searchItemDescription(item, item.description, $event)"\n                        ng-readonly="!item.isEdit"/>\n                      <ul ng-if="filteredItems.length>0 && vm.curItem==item" class="pos-absolute">\n                        <li class="menu-item" ng-click="vm.selectItemDescription(item, fitem)" ng-repeat="fitem in filteredItems">\n                          {{ fitem.name }}\n                        </li>\n                      </ul>\n                    </div>\n                    <div class="flex-8">\n                      <input class="field" type="number" ng-model="item.quantity" ng-blur="vm.calculateItemPrice(item)" ng-readonly="!item.isEdit"/>\n                    </div>\n                    <div class="flex-8">\n                      <input class="field"\n                        type="number"\n                        ng-model="item.unitPrice"\n                        ng-value="item.unitPrice"\n                        ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"\n                        ng-blur="vm.calculateItemPrice(item)"\n                        ng-readonly="!item.isEdit"/>\n                    </div>\n                    <div class="flex-8">\n                      <input class="field"\n                        type="number"\n                        ng-model="item.vatPercent"\n                        ng-blur="vm.calculateItemPrice(item)"\n                        ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"\n                        readonly/>\n                    </div>\n                    <div class="flex-8">\n                      <span class="field" ng-if="item.vatAmount">\n                        {{ item.vatAmount | readable: 2 }} {{ companyCurrency.symbol }}\n                      </span>\n                    </div>\n                    <div class="flex-8">\n                      <span class="field" ng-if="item.price">\n                        {{ item.price | readable: 2 }} {{ companyCurrency.symbol }}\n                      </span>\n                    </div>\n                    <div class="flex-8" style="text-align: center !important;border: none !important;padding-right: 35px;">\n                      <img src="/assets/icons/bxs-edit3.svg" alt="" class="cursor-point" ng-click="vm.editVariationOrderRow(item)" ng-if="!item.isEdit"/>\n                      <img src="/assets/icons/check-mark3.svg" alt="" class="cursor-point" ng-click="vm.confirmVariationOrderRow(item)" ng-if="item.isEdit"/>\n                      <img src="/assets/icons/trash-alt3.svg" alt="" class="cursor-point" ng-click="vm.removeVariationOrderRow($index)"/>\n                    </div>\n                  </div>\n                  <div class="item" ng-show="item.taxPercent">\n                    <div class="flex-8">&nbsp;</div>\n                    <div class="flex-10">&nbsp;</div>\n                    <div class="flex-34">&nbsp;</div>\n                    <div class="flex-8">&nbsp;</div>\n                    <div class="flex-8">&nbsp;</div>\n                    <div class="flex-8"><span translate="Tax"></span>&nbsp;% {{ item.taxPercent }}</div>\n                    <div class="flex-8">&nbsp;</div>\n                    <div class="flex-8" ng-if="item.taxPercent">\n                      <span ng-if="item.taxAmount">\n                        {{ item.taxAmount | readable: 2 }} {{ companyCurrency.symbol }}\n                      </span>&nbsp;\n                    </div>\n                    <div class="flex-8">&nbsp;</div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="add-new-line">\n              <button class="btn_new_blue w-192" ng-click="vm.addVariationOrderRow()">\n                <img src="/assets/icons/bx-plus-circle.svg" alt="" class="mr-10"/>\n                <span class="ft_14_20_600_white" translate="Add New Line"></span>\n              </button>\n            </div>\n          </div>--><div class="input-group mb-16"><!-- <div class="d-block">\n              <div class="w-350">\n                <span class="ft_14_600_black" translate="Sum Total"></span>\n                <div></div>\n                <div class="input-primary w-200">{{ vm.vaOrder.totalPrice | readable: 2 }} {{ companyCurrency.symbol }}</div>\n              </div>\n              <div class="w-350">\n                <span class="ft_14_600_black" translate="Vat"></span>\n                <div></div>\n                <div class="input-primary w-200">{{ vm.vaOrder.totalVat | readable: 2 }} {{ companyCurrency.symbol }}</div>\n              </div>\n              <div class="w-350">\n                <span class="ft_14_600_black" translate="Total Amount"></span>\n                <div></div>\n                <div class="input-primary w-200">{{ vm.vaOrder.totalAmount | readable: 2 }} {{ companyCurrency.symbol }}</div>\n              </div>\n              <div class="w-350" ng-if="vm.vaOrder.totalTax != 0">\n                <span class="ft_14_600_black" translate="Tax"></span>\n                <div></div>\n                <div class="input-primary w-200">{{ vm.vaOrder.totalTax | readable: 2 }} {{ companyCurrency.symbol }}</div>\n              </div>\n            </div> --><div class="sum-table ft-md ft-color-primary"><div class=tr><div class=td translate="Sub Total"></div><div class=td>{{ vm.vaOrder.totalPrice | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=tr><div class=td translate="Vat Amount"></div><div class=td>{{ vm.vaOrder.totalVat | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class="tr total ft-bold-primary"><div class=td translate=Total(Kr)></div><div class=td>{{ vm.vaOrder.totalAmount | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=tr ng-if="vm.vaOrder.totalTax != 0"><span class=ft_14_600_black translate=Tax></span><div></div><div class="input-primary w-200">{{ vm.vaOrder.totalTax | readable: 2 }} {{ companyCurrency.symbol }}</div></div></div></div><div class=btn-group><button class="button-ex1 w-150p" ng-click=vm.showRecipientsPopup(true) translate=Send></button> <button class="button-primary ml-20 w-150p" ng-click=vm.save() translate=Save></button></div></div></div></div></div></main>');
$templateCache.put('app/main/economic/va-order/detail/detail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div id=variation-order><div class=content><div class=sub-navigation><a ui-sref=economicManage class=ft_14_regular_gray translate=Economic></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class=ft_14_regular_gray ui-sref=vaOrderList translate="Variation Order List"></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class=ft_14_600_gray translate="Variation Order Detail"></a></div><div class=header-title><div class=pos-relative><div class=ft_18_600_black translate="Variation Order Detail"></div><div class="under-line w-240"></div></div><div class=button-group><button class="approved ft_14_600_white" ng-if="vm.variationOrder.status==\'approved\'"><img src=/assets/icons/check-mark-white.svg class=mr-10 alt=""><span translate=Approved></span></button> <button class="pending ft_14_600_white ml-10" ng-if="vm.variationOrder.status==\'pending\'"><img src=/assets/icons/close-circle-red1.svg class=mr-10 alt=""><span translate=Pending></span></button> <button class="pending ft_14_600_white ml-10" ng-if="vm.variationOrder.status==\'declined\'"><img src=/assets/icons/close-circle-red1.svg class=mr-10 alt=""><span translate=Declined></span></button></div></div><div class=content-wrap><div class="sub-header mb-20 flex-between flex"><div class=item><div class="ft_12_600_gray mb-8" translate="Client or Vendor"></div><div class="login_input_new w-250 tx-ellipsis">{{ vm.variationOrder.vendorType == "Client" ? vm.variationOrder.vendor.clientName : vm.variationOrder.vendor.name }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate=Staff></div><div class="login_input_new w-250 tx-ellipsis">{{ vm.variationOrder.staff.displayName }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate=Date></div><div class="login_input_new w-192">{{ vm.variationOrder.date | date: "yyyy/MM/dd" : \'UTC\' }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Due Date"></div><div class="login_input_new w-192">{{ vm.variationOrder.dueDate | date: "yyyy/MM/dd" : \'UTC\' }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Time Effect \xB1"></div><div class="login_input_new w-205">{{ getTimeEffect(vm.variationOrder.timeEffect) }}</div></div><div class="item margin-0"><div class="ft_12_600_gray mb-8" translate="Created By"></div><div class="login_input_new w-192">{{ vm.variationOrder.createdBy.displayName }}</div></div></div><div class=pay-content><div class="flex-between mb-20"><div class=flex><label class=check_yellow_20><div class=ft_14_600_black translate="Included Terms and Conditions"></div><input type=checkbox ng-model=vm.variationOrder.termsAndConditions disabled> <span class=checkmark></span></label></div><div class=flex><div class="flex btn-group"><div class="ft_14_600_black mr-10" translate="Additional Cost"></div><div class="login_input w-170 flex" style="height: 40px;align-items: center;">{{vm.variationOrder.costAdditionPercent}}</div></div></div></div><div><div class="table-wrap mb-20"><div class=header><div class=flex-10 translate=Sr.No.></div><div class=flex-10 translate=Type></div><div class=flex-30 translate=Description></div><div class=flex-10 translate=Quantity></div><div class=flex-10 translate="Unit Price"></div><div class=flex-10 translate="Vat %"></div><div class=flex-10 translate=Vat></div><div class=flex-10 translate=Amount></div></div><div><div ng-repeat="variationOrderItem in vm.variationOrder.items track by $index"><div class=item><div class=flex-10>{{ variationOrderItem.number.number }}</div><div class=flex-10>{{ variationOrderItem.type.type }}</div><div class=flex-30>{{ variationOrderItem.description }}</div><div class=flex-10>{{ variationOrderItem.quantity }}</div><div class=flex-10><span ng-if=variationOrderItem.unitPrice>{{ variationOrderItem.unitPrice | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class=flex-10><span ng-if=variationOrderItem.vatPercent>{{ variationOrderItem.vatPercent | readable: 2 }}</span></div><div class=flex-10><span ng-if=variationOrderItem.vatAmount>{{ variationOrderItem.vatAmount | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class=flex-10><span ng-if=variationOrderItem.price>{{ variationOrderItem.price | readable: 2 }} {{ companyCurrency.symbol }}</span></div></div><div class=item ng-show=variationOrderItem.taxPercent><div class=flex-10>&nbsp;</div><div class=flex-10>&nbsp;</div><div class=flex-30>&nbsp;</div><div class=flex-10>&nbsp;</div><div class=flex-10>&nbsp;</div><div class=flex-10><span translate=Tax></span>&nbsp;% {{ variationOrderItem.taxPercent }}</div><div class=flex-10>&nbsp;</div><div class=flex-10><span ng-if=variationOrderItem.taxAmount>{{ variationOrderItem.taxAmount | readable: 2 }} {{ companyCurrency.symbol }} </span>&nbsp;</div></div></div></div></div></div><div ng-if=!vm.variationOrder.items class="text-center ft_18_600_gray mt-30" translate="No data to display"></div><div class=input-group><div class=d-block><div class=w-350><span class=ft_14_600_black translate="Sum Total"></span><div></div><div class="login_input_new w-200">{{ vm.variationOrder.totalPrice | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=w-350><span class=ft_14_600_black translate=Vat></span><div></div><div class="login_input_new w-200">{{ vm.variationOrder.totalVat | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=w-350><span class=ft_14_600_black translate="Total Amount"></span><div></div><div class="login_input_new w-200">{{ vm.variationOrder.totalAmount | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=w-350 ng-if="vm.variationOrder.totalTax != 0"><span class=ft_14_600_black translate=Tax></span><div></div><div class="login_input_new w-200">{{ vm.variationOrder.totalTax | readable: 2 }} {{ companyCurrency.symbol }}</div></div></div></div><div class=btn-group><button class=btn_white ng-if="vm.variationOrder.status==\'approved\'" ng-click=vm.createInvoice() translate="Create Invoice"></button></div></div></div></div></div><div ng-if=vm.pdfViewing><pdf-viewer id=pdf-viewer class=pdf-viewer url=vm.variationOrder.variationOrderDoc ng-close=vm.closePDFViewer></pdf-viewer></div></main>');
$templateCache.put('app/main/economic/va-order/list/list.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if="isLoading || isDownloading"></spinner><div class="title-bar flex-between"><div><div class="sub-navigation margin-0"><a href=# ng-click=goDashboard() class="ft-normal-12-16 blue-2" translate=Dashboard></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a ui-sref=economicManage class="ft-normal-12-16 grey-2" translate=Economic></a> <img src="/assets/icons/chevron-right 1.svg" alt=icons> <a class="ft-normal-12-16 grey-2" translate="Variation Order List"></a></div><div class=ft_24_600_black1 translate="Variation Order List"></div></div><div class="flex flex-row flex-items-center"></div><button class="button-primary ml-auto" ui-sref=createVaOrder ng-if="ECO_ACCESS_CREATE > 2">+&nbsp;<span translate="Add VA Order"></span></button></div><div id=order-list><div class=listViewContainer><table class="list-item-wrapper ft_14_regular_gray"><thead><tr><th class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=client.checked><span class=checkmark ng-click=setAllChecked()></span></label></th><th class=ft_14_600_black><span translate="Sr No"></span></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'date\')"><span translate=Date></span> <img ng-src="{{sortItem.sort === \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                             sortItem.sort === \'date\' && !vm.sortItems[1].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                             sortItem.sort !== \'date\' &&  vm.sortItems[1].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'client\')"><span translate=Client></span> <img ng-src="{{sortItem.sort === \'client\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                             sortItem.sort === \'client\' && !vm.sortItems[2].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                             sortItem.sort !== \'client\' &&  vm.sortItems[2].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'vaorderNo\')"><span translate="VA Order No"></span> <img ng-src="{{sortItem.sort === \'vaorderNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                             sortItem.sort === \'vaorderNo\' && !vm.sortItems[3].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                             sortItem.sort !== \'vaorderNo\' &&  vm.sortItems[3].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'amount\')"><span translate=Amount></span> <img ng-src="{{sortItem.sort === \'amount\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                             sortItem.sort === \'amount\' && !vm.sortItems[4].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                             sortItem.sort !== \'amount\' &&  vm.sortItems[4].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'vatAmount\')"><span translate="Vat Amount"></span> <img ng-src="{{sortItem.sort === \'vatAmount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                             sortItem.sort === \'vatAmount\' && !vm.sortItems[5].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                             sortItem.sort !== \'vatAmount\' &&  vm.sortItems[5].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th class=ft_14_600_black><div class=cursor-point ng-click="changeSortItem(\'total\')"><span translate=Total></span> <img ng-src="{{sortItem.sort === \'total\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                             sortItem.sort === \'total\' && !vm.sortItems[6].sortType ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                             sortItem.sort !== \'total\' &&  vm.sortItems[6].sortType ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                                                                                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div></th><th><div class=dropdown><button tooltip-enable=false tooltip-placement=top-left uib-tooltip=status tooltip-class=customClass class="dropdown-toggle sel-project" type=button id=menu1 data-toggle=dropdown><span class=ft_14_600_black>{{vm.status | capitalize}}</span> <img src=/assets/icons/arrow_drop_down_20.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu1><li><a href=# class="menu-item ft_12_regular_gray" data-ng-click=selectedProject(item.value) ng-repeat="item in vm.statusList">{{item.value | capitalize}}</a></li><li><a href=# class=menu-item ng-if=!vm.statusList.length>No Data</a></li></ul></div></th><th class=ft_14_600_black><span translate=Action></span></th></tr></thead><tbody><tr ng-class=" (key%2) ? \'item2\':\'item1\'" ng-repeat="(key, variationOrder) in vm.variationOrderList"><td class=checkbox-cell><label class=check_yellow_20><input type=checkbox ng-model=variationOrder.checked><span class=checkmark></span></label></td><td>{{ totalCount - (vm.currentPage - 1)*numPerPage - $index }}.</td><td class=ft_14_regular_black>{{ variationOrder.createdAt | date }}</td><td class=ft_14_regular_black>{{ variationOrder.vendorType == \'Client\' ? variationOrder.vendor.clientName : variationOrder.vendor.name }}</td><td class=ft_14_regular_black>{{ variationOrder.displaySeq }}</td><td class=ft_14_regular_black>{{ variationOrder.totalPrice | readable: 2 }}</td><td class=ft_14_regular_black>{{ (variationOrder.totalAmount-variationOrder.totalPrice) | readable: 2 }}</td><td class=ft_14_regular_black>{{ variationOrder.totalAmount | readable: 2 }}</td><td class="ft_14_regular_black {{variationOrder.status}}">{{ variationOrder.status | capitalize}}</td><td class=ft_14_regular_black><div class="flex flex-row flex-items-center vaActionContainer"><div class="cursor-point mr-4" ng-click=vm.viewVariationOrder(variationOrder)><img ng-src="{{variationOrder.status==\'draft\' ? \'/assets/icons/bx-edit6.svg\' : \'/assets/icons/eye6.svg\'}}" alt=""></div><div class="cursor-point mr-4" ng-click=vm.downloadPdf(variationOrder)><img src=/assets/icons/cloud-download.svg alt=""></div><div class=cursor-point ng-click=vm.sendVariationOrderMail(variationOrder) ng-if="ECO_ACCESS_CREATE > 3"><img src=/assets/icons/send.svg alt=""></div></div></td></tr></tbody></table><div class="flex flex-row pagination-footer flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * numPerPage + 1}} - <span ng-if="isLoading == false">{{(vm.currentPage - 1) * numPerPage + vm.variationOrderList.length}}</span> of {{totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.fetchData()></pagination-custom-new></div></div></div></div></main><div ng-if=vm.pdfViewing><pdf-viewer id=pdf-viewer class=pdf-viewer url=vm.variationOrder.variationOrderDoc ng-close=vm.closePDFViewer></pdf-viewer></div>');
$templateCache.put('app/main/fileManage/directives/file-preview/file-preview.view.html','<div id=file-preview class=pl-20><div class="flex-center thumbnail-block"><img class=file-thumbnail ng-src={{previewThumbnail()}} alt=icons> <img class="preview-close cursor-point" src=/assets/icons/close-16.svg ng-click=closePreview()> <a href="{{data.secure_url || data.sourceUrl || data.webUrl}}" target=_blank><img src=/assets/icons/eye6.svg alt=""></a></div><spinner ng-if=loading></spinner><div><div class="d-flex flex-between ft_14_600_black"><span style="width: 310px; word-break: break-all;">{{fileType == \'3d\' ? data.name : data.originalname}}</span></div><div class="preview-content-wrapper name"><div class="ft_12_400_black text-left mb-8">{{utils.getFormatDescription(data.format || data.type)}}</div><div class=item-content>{{utils.calcFileSize(data.bytes || data.size)}}</div></div><div class=preview-content-wrapper><span class="ft_12_600_black mr-2" translate="Created on"></span> <span class=ft_12_400_black>{{data.createdAt | date : \'dd/MM/yyyy h:mm a\'}}</span></div><div class=preview-content-wrapper><span class="ft_12_600_black mr-2" translate="Last modified on"></span> <span class=ft_12_400_black>{{data.updatedAt | date : \'dd/MM/yyyy h:mm a\'}}</span></div><div class=preview-content-wrapper><span class="ft_12_600_black mr-2" translate=Level></span> <span class=ft_12_400_black>{{data.level}}</span></div><div class=preview-content-wrapper><span class="ft_12_600_black mr-2" translate=QSHE></span> <span class=ft_12_400_black>{{data.qshe ? \'Done\' : \'Not Done\'}}</span></div><!-- <div class="preview-content-wrapper" ng-if="data.assetDescription">\n      <div class="ft_12_600_black" translate="Description"></div>\n      <div class="ft_12_400_black text-right ml-2">{{data.assetDescription}}</div>\n    </div> --><div class=preview-content-wrapper><div class="ft_12_600_black mr-2" translate=Status></div><div class="ft_12_400_black text-left">{{permission}}</div><div ng-if="data.permission.notify && data.permission.approval === \'Pending\'"><div class=ft_10_regular_gray>Please choose approval or decline.</div><div class="flex-items-center flex-between px-4"><button class="btn btn-yellow" ng-click="updateApproval(\'Approved\')" translate=Approval></button> <button class="btn btn-gray" ng-click="updateApproval(\'Declined\')" translate=Decline></button></div></div></div><div class="preview-content-wrapper owner"><div class=ft_12_600_black translate=Owner></div><div class=flex-items-center><img class=owner-avatar ng-if=data.userId.profilePic ng-src={{data.userId.profilePic}} alt=""><div ng-if=!data.userId.profilePic data-letters="{{utils.nameLetter(data.userId.firstName, data.userId.lastName)}}" class="profile-pic mr-8" ng-style="{ \'background\': getColor(data.userId.firstName) }"></div><div><div class=ft_12_400_black>{{data.userId.firstName + \' \' + data.userId.lastName}} <span ng-if="data.userId._id === user._id">(Me)</span></div><div class=ft_12_400_black>{{data.userId.designation}}</div></div></div></div><div class="preview-content-wrapper members"><div class="ft_12_600_black info-item" translate=Members></div><div class=ft_12_regular_gray><div class=pos-relative><div ng-repeat="member in members.slice(0, 3) track by $index"><img ng-if=member.profilePic class=avatar ng-src={{member.profilePic}} alt=logo ng-style="{left: $index * 20 + \'px\'}"><div ng-if=!member.profilePic class=name-letter data-letters="{{utils.nameLetter(member.firstName, member.lastName)}}" ng-style="{left: $index * 20 + \'px\', \'background\': getColor(member.firstName)}"></div></div><div ng-if="members.length > 3" class=name-letter data-letters="+{{members.length - 3}}" ng-style="{left: 60}"></div></div></div></div><div class=preview-content-wrapper><span class="ft_12_600_black mr-2" translate=Tags></span> <span class=ft_12_400_black ng-repeat="tag in data.tags">{{tag}}</span></div></div></div>');
$templateCache.put('app/main/fileManage/directives/file-versions/file-versions.view.html','<div id=file-versions><div class=version-header><div class=flex-items-center><!-- <div class="go-back" ng-click="goBack()">\n        <img src="/assets/icons/arrow_back_ios.svg" alt="">\n      </div> --><h1 translate="Version History"></h1></div><!-- <div class="mb-3">\n      <span class="ft_12_600_black">{{file.originalname}}</span>&nbsp;\n      <span class="ft_12_600_black" translate="Version History"></span>\n    </div>\n    <span class="ft_10_regular_gray" translate="You can restore any version below to make it the current version. All other versions will still be saved"></span> --></div><spinner ng-if=loading></spinner><div class=version-content ng-if=!loading><div class=version-group ng-repeat="group in groups"><div class="file-in-group no-border"><div class="group-title item name">{{group.name}}</div><div class="group-title item fm-checkbox"></div><div class="group-title item time">Time</div><div class="group-title item description">Modified By</div><div class="group-title item size">Size</div><div class="group-title item action">Version</div></div><!-- <div class="group-title">{{group.name}}</div> --><div class=file-in-group ng-repeat="file in group.files"><div class="item fm-checkbox"><checkbox ng-model=file.selected ng-click=vm.selectFile(file) is-small=true></checkbox></div><div class="item name"><img ng-src={{utils.getFMFileIcon(file.format)}} alt=""><div class=text-ellipsis>{{file.originalname}}</div></div><div class="item time">{{file.updatedAt | date: \'HH:mm a\' : \'UTC\'}}</div><div class="item description">{{getVersionDescription(file)}}</div><div class="item size">{{file.bytes | filesize}}</div><div class="item action"><div ng-if=file.isActive translate="Current Version" class=current-version></div><button ng-if=!file.isActive ng-click=setFileToCurrentVersion(file) translate="Set as Current" class=set-current></button></div></div></div></div></div>');
$templateCache.put('app/main/fileManage/directives/folder-preview/folder-preview.view.html','<div id=folder-preview class=pl-20><img class="preview-close cursor-point" src=/assets/icons/close-16.svg ng-click=closePreview()><div class=flex-center><img class=folder-thumbnail src=/assets/icons/fm-folder-icon.svg alt=icons></div><div><div class="ft_14_600_black preview-content-wrapper">{{data.name}}</div><div class=preview-content-wrapper><span class="ft_12_600_gray mr-2" translate="Created on"></span> <span class=ft_12_regular_light>{{data.createdAt | date : \'dd/MM/yyyy h:mm a\'}}</span></div><div class=preview-content-wrapper><div class="ft_12_600_gray mr-2" translate="Modified on"></div><div class=ft_12_regular_light>{{data.updatedAt | date : \'dd/MM/yyyy h:mm a\'}}</div></div><div class=preview-content-wrapper ng-if="data.userId && data.userId.firstName && data.userId.lastName"><div class=ft_12_500_gray translate=Owner></div><div class=flex-items-center><img class=owner-avatar ng-if=data.userId.profilePic ng-src={{data.userId.profilePic}} alt=""><div ng-if=!data.userId.profilePic data-letters="{{utils.nameLetter(data.userId.firstName, data.userId.lastName)}}" class="profile-pic mr-8" ng-style="{ \'background\': getColor(data.userId.firstName) }"></div><div><div class=ft_12_600_gray>{{data.userId.firstName + \' \' + data.userId.lastName}} <span ng-if="data.userId._id === user._id">(Me)</span></div><div class=ft_12_regular_light>{{data.userId.designation}}</div></div></div></div><div class="members preview-content-wrapper" ng-if=members.length><div class="ft_12_500_gray info-item" translate=Members></div><div class=ft_12_regular_gray><div class=pos-relative><div ng-repeat="member in members.slice(0, 3) track by $index"><img ng-if=member.profilePic class=avatar ng-src={{member.profilePic}} alt=logo ng-style="{left: $index * 20 + \'px\'}"><div ng-if=!member.profilePic class=name-letter data-letters="{{utils.nameLetter(member.firstName, member.lastName)}}" ng-style="{left: $index * 20 + \'px\', \'background\': getColor(member.firstName)}"></div></div><div ng-if="members.length > 3" class=name-letter data-letters="+{{members.length - 3}}" ng-style="{left: 60}"></div></div></div></div><div ng-if=data.permission class=preview-content-wrapper><div class="ft_12_500_gray mb-2" translate="Your permission"></div><div class="ft_12_regular_light text-left mb-3">{{permission}}</div><div ng-if="data.permission.notify && data.permission.approval === \'Pending\'"><div class="ft_10_regular_gray mb-3" translate="Please choose approval or decline."></div><div class="flex-items-center flex-between px-4"><button class="btn btn-yellow" ng-click="updateApproval(\'Approved\')" translate=Approval></button> <button class="btn btn-gray" ng-click="updateApproval(\'Declined\')" translate=Decline></button></div></div></div></div></div>');
$templateCache.put('app/main/fileManage/modals/create-folder/create-folder-modal.view.html','<div id=fm-create-folder-modal><div class=header><div class=tx-ellipsis translate="Create folder"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><label for=folder-name translate="Folder Name"></label> <input id=folder-name type=text ng-model=name class=fm-input placeholder="Enter a new folder name" autofocus enter-key=onSubmit()></div><div class=footer><button class="btn_white mr-4" ng-click=onCancel() translate=Cancel></button> <button class=btn_new_blue ng-click=onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/main/fileManage/modals/file-access/file-access-modal.view.html','<div id=file-access-modal><div class=body><div class=title-black><div class=m-auto translate="Access Setting"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><spinner ng-if=loading></spinner><div class=main-content><div ng-repeat="block in blocks"><div class=flex-between><div class=ft_14_regular_black>{{block.title}}</div><div class=d-flex><span class="switch switch-sm flex-center mr-20"><div class="ft_14_regular_black mr-10" translate=View></div><input type=checkbox class=switch id=view-permission-{{block.blockId}} ng-model=block.viewPermission> <label for=view-permission-{{block.blockId}} class=margin-0></label> </span><span class="switch switch-sm flex-center"><div class="ft_14_regular_black mr-10" translate=Upload></div><input type=checkbox class=switch id=upload-permission-{{block.blockId}} ng-model=block.uploadPermission> <label for=upload-permission-{{block.blockId}} class=margin-0></label></span></div></div><div class="flex mt-20"><selectbox class=selectbox options=block.members label-field=name value-field=id ng-model=block.selectedMemberId placeholder="Select {{block.title}}"></selectbox><button class="btn_primary add" ng-click=addMember(block) translate=Add></button><div class=pos-relative><div ng-show="block.addedMembers.length > 4" class="avatar-num pos-absolute ft_12_600_gray flex-center" ng-style="{left: 30 * 4 + \'px\'}">+{{block.addedMembers.length - 4}}</div><img ng-repeat="member in block.addedMembers.slice(0, 4) track by $index" ng-src="{{member.avatar || \'/assets/icons/bx-user.svg\'}}" alt=logo ng-style="{left: $index * 30 + \'px\'}" class=avatar-image></div></div><hr class=split-line></div><div class=btnGroup><button class="btn_white margin-0" ng-click=onCancel() translate=Cancel></button> <button class="btn_primary ml-20" ng-click=onSubmit() translate=Apply></button></div></div></div></div></div>');
$templateCache.put('app/main/fileManage/modals/file-edit/file-edit-modal.view.html','<div id=fm-file-edit-modal><div class=header><div class=tx-ellipsis translate="Edit a file"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class="ft_12_500_gray mb-2" translate=Description></div><textarea class=description ng-model=vm.file.assetDescription placeholder="Write some description">\n    </textarea><div class="ft_12_500_gray mb-2" translate=Level></div><selectbox2 class=dropdown-primary ng-model=vm.file.level label-field=name value-field=name options=vm.levels></selectbox2></div><div class=footer><button class="button-ex1 mr-3 ph-20" ng-click=onCancel() translate=Cancel></button> <button class="button-primary ph-20" ng-click=onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/main/fileManage/modals/file-permission-modal/file-permission-modal.view.html','<div id=fm-file-permission-modal><div class=header><div class=tx-ellipsis translate="Permission Settings"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=search-option-group><div class=search-option><radio ng-model=searchOption ng-value="\'User\'"></radio><div class=label translate=User></div></div><div class=search-option><radio ng-model=searchOption ng-value="\'Team\'"></radio><div class=label translate=Team></div></div><div class=search-option><radio ng-model=searchOption ng-value="\'Employee\'"></radio><div class=label translate=Company></div></div></div><div class=search-and-add><autocomplete1 ng-show="searchOption === \'User\'" input-class=fm-search-input ng-model=vm.selectedUserId label-field=displayName value-field=_id options=users no-margin-right=true no-flex=true place-holder="Start typing a name"></autocomplete1><autocomplete1 ng-show="searchOption === \'Team\'" input-class=fm-search-input ng-model=vm.selectedTeamId label-field=name value-field=_id options=teams no-margin-right=true no-flex=true place-holder="Start typing a name"></autocomplete1><autocomplete1 ng-show="searchOption === \'Employee\'" input-class=fm-search-input ng-model=vm.selectedEmployeeId label-field=displayName value-field=_id options=employees no-margin-right=true no-flex=true place-holder="Start typing a name"></autocomplete1><button class=btn_primary ng-click=onAdd()><img src=/assets/icons/plus.svg alt=plus> <span translate=Add></span></button></div><div class=content-body ng-if=assignedMembers.length><div class="flex-items-center mb-8"><div class="left ft_12_500_light" translate="Users & Teams"></div><div class="right ft_12_500_light" translate="File Permissions"></div></div><div class=assigned-member ng-repeat="member in assignedMembers track by $index"><div class="left flex-items-center"><img ng-if=member.profilePic class=user-avatar ng-src={{member.profilePic}} alt=""><div ng-if=!member.profilePic data-letters={{nameLetter(member)}}></div><div class=ft_12_regular_gray>{{member.name || member.displayName}}</div></div><div class="right flex-items-center flex-between"><selectbox2 options=permissions label-field=label value-field=value ng-model=member.permission style="width: calc(100% - 24px);"></selectbox2><img class=cursor-point src=/assets/icons/close-16.svg alt=remove ng-click=onDelete(member)></div></div></div></div><div class=footer><button class="btn_white mr-4" ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/main/fileManage/modals/file-share/file-share-modal.view.html','<div id=file-share-modal><div class=header><div class=tx-ellipsis translate="Share files"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><label translate=Email></label><div class="flex-items-center flex-between w-100"><autocomplete1 input-class=fm-search-input ng-model=email label-field=email value-field=email options=vm.emails place-holder="Please input email to share"></autocomplete1><img src=/assets/icons/add-orange.svg alt=Add class="cursor-point add-btn" ng-click=vm.addEmail()></div><div class=emails-wrapper><span class="email-item ft_12_600_gray mr-4 px-3 py-2 d-flex align-items-center mb-4" ng-repeat="item in vm.selectedEmails">{{item}} <img class="cursor-point ml-3" src=/assets/icons/close-24.svg ng-click=vm.removeEmail(item)></span></div></div><div class=footer><button class="btn_white mr-4" ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/main/fileManage/modals/file-upload/file-upload-modal.view.html','<div id=fm-file-upload-modal><div class=header><div class=tx-ellipsis translate="Upload a File"></div><div class=close-icon ng-click=onClose()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=mb-24><div class="ft_12_500_gray mb-2" translate=Level></div><selectbox2 ng-model=vm.level label-field=name value-field=name options=vm.levels></selectbox2></div><div class="d-flex flex-column" ngf-drop ngf-change="vm.fileUpdated($files, $event)" name=file ngf-multiple=true><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> <span translate="Drag and Drop or"></span> <span class="ft-blue ph-5" ngf-select ngf-change="vm.fileUpdated($files, $event)" name=file ngf-multiple=true translate=Browse></span> <span translate="to Upload"></span></div><div class=upload-files ng-if="vm.files && vm.files.length"><div class=title translate="Uploaded Files"></div><div class=upload-file ng-repeat="file in vm.files track by $index"><img class=file-icon ng-src={{vm.utils.getFileIcon(file)}} alt=""><div class=progress-container><div class=progress-info><div class=file-name>{{file.name}}</div><div class=progress-value>{{file.progressPercentage || 0}}%</div></div><div class=progress-bar><div class=real-progress ng-style="vm.getStyleWidth(file.progressPercentage || 0)"></div></div></div><img ng-if="file.progressPercentage !== 100" class=cancel-icon src=/assets/icons/close-circle-f-gray.svg alt="" ng-click="vm.cancelUpload(file, $index)"> <img ng-if="file.progressPercentage === 100" class=done-icon src=/assets/icons/mark-complete.svg alt=""></div></div></div></div><div class=footer><button class=btn_new_blue ng-click=onClose() translate=Save></button></div></div>');
$templateCache.put('app/main/fileManage/modals/file-viewer/file-viewer-modal.view.html','<div id=file-viewer><div class=h-100><div class="d-flex justify-content-center align-items-center h-100" ng-show="maximizeView==\'image\'"><div class="pos-relative ml-20 mr-20"><img src=/assets/icons/close-20.svg ng-click=onCancel() class=img-close> <img ng-src="{{ maximizeViewUrl }}" alt="" style="margin-top: 4rem;max-height: 45rem;"></div></div><div class="d-flex justify-content-center h-100" ng-show="maximizeView==\'pdf\'"><spinner ng-if="loadingIFrame == true" need-mask=false></spinner><div id=file_manager_maximize_pdf_canvas class="pos-relative mt-15 ml-20 mr-20"></div></div><div class="d-flex justify-content-center align-items-center h-100" ng-show="maximizeView==\'file3d\'"><div id=initial_loading_popup ng-show=vm.loading3d><img src=/assets/images/cgviewer/cloud_loading.gif></div><div id=file_manager_maximize_model_canvas></div></div></div></div>');
$templateCache.put('app/main/fileManage/modals/hierarchy-template/hierarchy-template-modal.view.html','<div id=hierarchy-template-modal><div class=title><div class=tx-ellipsis translate=Confirmation></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><spinner ng-show=loading></spinner><div class=content><div class=mb-20><div class="ft_12_600_gray mb-8" translate=Description></div><textarea class=w-100 placeholder="Write some description (optional)" ng-model=payload.description></textarea></div></div><div class=footer><button class="yellow mr-15" ng-click=onSave() translate=Send></button> <button class=gray ng-click=onCancel() translate=Discard></button></div></div>');
$templateCache.put('app/main/fileManage/modals/hierarchy-template-tree/hierarchy-template-tree-modal.view.html','<div id=hierarchy-template-tree-modal><div class=title><div class=tx-ellipsis translate="Hierarchy Template Tree"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><spinner ng-show=loading></spinner><div class=content><div ng-if=template.projectHierarchies.length><div class=hierarchy-root-node translate=PROJECT></div><div ui-tree="" id=tree1-root data-clone-enabled=true data-nodrop-enabled=true class=calc-tree><ol ui-tree-nodes="" ng-model=template.projectHierarchies><li ng-repeat="hierarchy in template.projectHierarchies" ui-tree-node="" ng-include="\'app/main/fileManage/modals/hierarchy-tree.html\'"></li></ol></div></div><hr><div ng-if=template.companyHierarchies.length><div class=hierarchy-root-node translate=COMPANY></div><div ui-tree="" id=tree2-root data-clone-enabled=true data-nodrop-enabled=true class=calc-tree><ol ui-tree-nodes="" ng-model=template.companyHierarchies><li ng-repeat="hierarchy in template.companyHierarchies" ui-tree-node="" ng-include="\'app/main/fileManage/modals/hierarchy-tree.html\'"></li></ol></div></div><hr><div ng-if=template.personalHierarchies.length><div class=hierarchy-root-node translate=PERSONAL></div><div ui-tree="" id=tree3-root data-clone-enabled=true data-nodrop-enabled=true class=calc-tree><ol ui-tree-nodes="" ng-model=template.personalHierarchies><li ng-repeat="hierarchy in template.personalHierarchies" ui-tree-node="" ng-include="\'app/main/fileManage/modals/hierarchy-tree.html\'"></li></ol></div></div><hr></div><div class=footer><button class=gray ng-click=onCancel() translate=Close></button></div></div>');
$templateCache.put('app/main/fileManage/modals/rename/rename-modal.view.html','<div id=fm-rename-modal><div class=header><div class=tx-ellipsis><span translate=Rename></span>&nbsp;{{typeText}}</div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><label for=folder-name>{{typeText}}&nbsp;<span translate=Name></span></label> <input id=folder-name type=text ng-model=name class=fm-input placeholder="{{typeText}} Name" autofocus enter-key=onSubmit()></div><div class=footer><button class="btn_white mr-4" ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/main/finance/directives/filter-dropdown/filter-dropdown.view.html','<div class="filter-dropdown dropdown"><button class="btn btn-light dropdown-toggle" type=button ng-click=toggleDropdown()><img src=/assets/icons/filter3.svg alt=""></button><div class=dropdown-menu ng-class="{\'d-block\': isOpen}"><a class="dropdown-item disabled" href=# disabled translate="FILTER BY"></a><div class="filter-item mt-8"><label>{{numberTitle}}</label><input type=text ng-model=filterOption.number tabindex=0 autofocus></div><div class=filter-item><label translate=Date class=mb-2></label><div class="d-flex justify-content-between"><div class=has-calendar><div class="ft_10_600_light text-uppercase mb-2" translate=From></div><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=filterOption.dateFrom tabindex=1> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div><div class=has-calendar><div class="ft_10_600_light text-uppercase mb-2" translate=To></div><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=filterOption.dateTo tabindex=2> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div></div><div class=filter-item><label translate=Amount class=mb-2></label><div class="d-flex justify-content-between"><div style="width: 176px;"><div class="ft_10_600_light text-uppercase mb-2" translate=From></div><input type=text number-edit ng-model=filterOption.amountFrom tabindex=3></div><div style="width: 176px;"><div class="ft_10_600_light text-uppercase mb-2" translate=To></div><input type=text number-edit ng-model=filterOption.amountTo tabindex=4></div></div></div><div class="d-flex justify-content-end pl-16 pr-16"><button class="btn btn-dark mr-16" tabindex=5 ng-click=onReset() translate=Reset></button> <button class="btn btn-light mr-16" tabindex=5 ng-click=onCancel() translate=Cancel></button> <button class="btn btn-blue" tabindex=6 ng-click=onSubmit() translate=Ok></button></div></div></div>');
$templateCache.put('app/main/finance/directives/finance-bank-card/finance-bank-card.view.html','<div class="finance-bank-card ev-2" ng-class="{active: selectedBankId === ngModel._id}"><div class="d-flex justify-content-between"><div><div class="ft_16_600_black mb-8">{{ngModel.name}}</div><div class=ft_14_600_gray>{{ngModel.number}}</div></div><img class=bank-logo ng-src={{ngModel.logo}} alt=""></div><div class="d-flex justify-content-between flex-end"><div><div class=ft_14_600_gray translate=Balance></div><div class=ft_18_600_black3>${{ngModel.balance | readable: 2}}</div></div><img src=/assets/icons/more-horiz.svg alt=""></div></div>');
$templateCache.put('app/main/finance/directives/finance-banking-block/finance-banking-block.view.html','<div class="finance-banking-block ev-2"><div class=header><div class=ft_16_600_black>{{type == \'income\' ? \'Income\' : \'Payout \'}} Bank</div><img src=/assets/icons/dropdown-black.svg alt=""></div><div class=body><div class="banking-row head"><div class="banking-col no">{{type == \'income\' ? \'Invoice\' : \'Bill \'}} No.</div><div class="banking-col name">Customer Name</div><div class="banking-col date">Due Date</div><div class="banking-col amount">Amount</div><div class="banking-col more"></div></div><div class=body-content><div class=banking-row ng-class="{\'income\': type == \'income\', payout: type == \'payout\'}" ng-repeat="item in list track by $index"><div class="banking-col no">{{type == \'income\' ? item.displaySeq : item.billNo || item.displaySeq}}</div><div class="banking-col name">{{item.vendor.clientName || item.vendor.name}}</div><div class="banking-col date">{{item.dueDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="banking-col amount"><span class=mr-1>{{companyData.currentCurrency.symbol}}</span>{{item.totalAmount | readable: 2}}</div><div class="banking-col more"><img src=/assets/icons/more-light.svg alt=""></div></div></div></div></div>');
$templateCache.put('app/main/finance/directives/finance-card/finance-card.view.html','<div class=finance-card><div class=flex-between><div class=ft_16_600_black translate="{{type == \'invoice\' ? \'Total Receivables\' : \'Total Payables\'}}"></div></div><div class=mt-30><span class=ft_14_regular_black>Total Unpaid {{type == \'invoice\' ? \' Invoices\' : \' Bills\'}}</span> <span class=ft_14_600_black>{{currency}} {{type == \'invoice\' ? totalUnpaidInvoices : totalUnpaidBills | readable: 2}}</span></div><div class="progress-container mt-20"><div class=progress ng-class=colorClass ng-style=getProgress()></div></div><div class="prices d-flex mt-30"><div class=price-item><div class="item-label green" translate=Current></div><div class=item-value>{{currency}} {{type == \'invoice\' ? totalInvoices : totalBills | readable: 2}}</div></div><div class=price-item><div class="item-label red" translate=Overdue></div><div class=item-value>{{currency}} {{0 | readable: 2}}</div></div></div></div>');
$templateCache.put('app/main/finance/directives/finance-cashflow/finance-cashflow.view.html','<div class=finance-cashflow><div class=flex-between><div class=ft_16_28_600_black translate="Cash Flow"></div><div class=flex-center><div class="btn-group ml-15"><div class=btn-item ng-class="{\'active\': type == \'custom\'}" translate=Custom></div><div class=btn-item ng-class="{\'active\': type == \'week\'}" ng-click="onSelectType(\'week\')" translate=Weekly></div><div class=btn-item ng-class="{\'active\': type == \'month\'}" ng-click="onSelectType(\'month\')" translate=Monthly></div><div class=btn-item ng-class="{\'active\': type == \'year\'}" ng-click="onSelectType(\'year\')" translate=Yearly></div></div></div></div><div ng-show=needRender><div ng-if=!hasGraphData class="ft_14_600_gray p-5 text-center">No Data for Chart</div><div id=eco-line-chart class="graph no-zoom mt-30" ng-show=hasGraphData><svg></svg></div></div><div class="prices mt-16"><div class=price-item><div class=item-value>{{currency}} {{startCash | readable: 2}}</div><div class=item-label><span translate="Cash on"></span> {{startCashDate | slashDate}}</div></div><div class=price-item><div class=item-value>{{currency}} {{incoming | readable: 2}}</div><div class="item-label green" translate="Incoming Cashflow"></div></div><div class=price-item><div class=item-value>{{currency}} {{outgoing | readable: 2}}</div><div class="item-label red" translate="Outgoing Cashflow"></div></div><div class=price-item><div class=item-value>{{currency}} {{endCash | readable: 2}}</div><div class=item-label><span translate="Cash on"></span> {{endCashDate | slashDate}}</div></div></div><spinner ng-if=isLoading></spinner></div>');
$templateCache.put('app/main/finance/directives/finance-doc-panel/finance-doc-panel.view.html','<div class=finance-doc-panel ng-style="{top: allBankStatement ? \'15%\' : \'calc((100% - 48px) * 0.5)\'}"><div class="pos-relative d-flex align-items-center justify-content-between"><div class=point id=finance-doc-panel-point></div><selectbox-input class="flex-25 dropdown-primary" options=typeList label-field=name value-field=value ng-model=type></selectbox-input><selectbox-input class="flex-25 ml-16 dropdown-primary" ng-show="type == \'fastTrack\'" options=templateList label-field=name value-field=_id ng-model=templateId select-event=changeTemplate()></selectbox-input><selectbox-input class="flex-25 ml-16 dropdown-primary" ng-show="type == \'balance\'" options=balancePlans label-field=label value-field=_id ng-model=accountPlanId select-event=changeBalance()></selectbox-input><selectbox-input class="flex-25 ml-16 dropdown-primary" ng-show="type == \'client\'" options=clients label-field=clientName value-field=_id ng-model=clientId select-event=changeClient()></selectbox-input><selectbox-input class="flex-25 ml-16 dropdown-primary" ng-show="type == \'vendor\'" options=vendors label-field=name value-field=_id ng-model=vendorId select-event=changeVendor()></selectbox-input><input id=description type=text class="ml-16 mr-16 input-primary" placeholder=Description ng-model=description><div class=amount-frame><div class="amount text-right">{{companyData.currentCurrency.currencySymbol}} {{bankStatement.amount || allBankStatement.amount || needFinanceItem.remainingAmount || amount || balanceFinanceItem.remainingAmount | readable: 2}}</div><div class=attach ngf-select ngf-multiple=false ngf-change=fileUpdated($files)><img src=/assets/icons/attachment1.svg alt=""></div><div class=view ng-click="utils.downloadFile(fileObjectUrl, file.name)"><img src=/assets/icons/eye6.svg alt=""></div><div class=save ng-click=save()><img src=/assets/icons/save-icon-light.svg alt=""></div><div class=close-icon ng-click=close()><img src=/assets/icons/close-16.svg alt=""></div></div><spinner ng-if=loading></spinner></div></div>');
$templateCache.put('app/main/finance/directives/finance-expense-bar-chart/finance-expense-bar-chart.view.html','<div class=finance-expense-bar-chart><div class="flex-between align-items-center"><div class=ft_16_600_black translate="Economic Overview"></div><selectbox class=duration ng-model=year options=years label-field=name value-field=id select-event=onSelectYear(year)></selectbox></div><div ng-show=needRender><div ng-if=!hasGraphData class="ft_14_600_gray p-5 text-center">No Data for Chart</div><div id=eco-bar-chart class="graph no-zoom mt-30" ng-show=hasGraphData><svg></svg></div></div><div class=prices><div class=price><div class=item-value>{{currency}} {{totalIncome | readable: 2}}</div><div class=item-label translate="Total Income"></div></div><div class=price><div class=item-value>{{currency}} {{totalExpense | readable: 2}}</div><div class=item-label translate="Total Expenses"></div></div><div class=price><div class=item-value>{{currency}} {{totalProfit | readable: 2}}</div><div class=item-label translate="Total Budget Income"></div></div><div class=price><div class=item-value>{{currency}} {{totalProfit | readable: 2}}</div><div class=item-label translate="Total Budget Expense">TOTAL BUDGET EXPENSE</div></div></div></div>');
$templateCache.put('app/main/finance/directives/finance-expense-pie-chart/finance-expense-pie-chart.view.html','<div class=finance-expense-pie-chart><div class="flex-between align-items-center mb-16"><div class=ft_16_600_black translate="Top Expenses"></div><selectbox class=duration ng-model=piePeriod options=periods label-field=name value-field=id select-event=selectPiePeriod(piePeriod)></selectbox></div><div id=pie-chart class=no-zoom></div><div class=legend><div class=legend-item ng-repeat="legend in pieData"><div class=circle ng-style=getLegendColor(legend)></div><div class=legend-text>{{legend.name}}</div><div class="legend-value ml-auto">{{(legend.value * 100) | readable: 2}}%</div></div></div></div>');
$templateCache.put('app/main/finance/directives/finance-link-point/finance-link-point.view.html','<div class=finance-link-point id={{elementId}}><div ng-class="{\n      \'pulse-container\': isSelected,\n      \'none-container\': linkStatus === \'none\',\n      \'linked-container\': linkStatus === \'linked\',\n      \'pending-container\': linkStatus === \'pending\',\n      \'memo-container\': linkStatus === \'memo\'\n    }"><div ng-class="{\n        \'selected\': isSelected,\n        \'none\': linkStatus === \'none\',\n        \'linked\': linkStatus === \'linked\',\n        \'pending\': linkStatus === \'pending\',\n        \'approved\': linkStatus === \'approved\',\n        \'approved-memo\': linkStatus === \'approved-memo\',\n        \'approved-balance\': linkStatus === \'approved-balance\',\n        \'memo\': linkStatus === \'memo\'\n      }" id=linkpoint-{{elementId}}><div class=inner-rect ng-if="linkStatus !== \'none\'"></div></div></div></div>');
$templateCache.put('app/main/finance/directives/finance-menu/finance-menu.view.html','<div id=finance-navbar><nav class="navbar navbar-expand-lg navbar-light bg-light"><ul class=navbar-nav><li class="nav-item mr-40" ng-class="currentRoute == \'dashboard\' ? \'active\': \'\'"><a class=nav-link href=# ui-sref=financeDashboard><div class=flex-items-center><img src=/assets/icons/finance/dashboard.svg alt=dashboard class=mr-8><div class=ft_14_600_gray>Dashboard</div></div></a></li><li class="nav-item mr-40" ng-class="currentRoute.includes(\'bank\') ? \'active\': \'\'"><a class=nav-link href=# ui-sref=financeBankDetail><div class=flex-items-center><img src=/assets/icons/finance/bank.svg alt=bank class=mr-8><div class=ft_14_600_gray translate=Bank></div></div></a></li><li class="nav-item mr-40 dropdown" ng-class="currentRoute == \'sales\' ? \'active\': \'\'"><a class=nav-link href=#><div class=flex-items-center><img src=/assets/icons/finance/sales.svg alt=sales class=mr-8><div class=ft_14_600_gray translate=Sales></div></div></a><div class=dropdown-menu><a class="dropdown-item disabled" href=# disabled translate=Sales></a> <a class=dropdown-item href=# ui-sref=financeSales translate=Sales></a> <a class=dropdown-item href=# translate="Create Invoice" ui-sref=financeCreateInvoice></a> <a class=dropdown-item href=# ui-sref=financeClient translate=Client></a></div></li><li class="nav-item mr-40 dropdown" ng-class="currentRoute == \'purchases\' ? \'active\': \'\'"><a class=nav-link href=#><div class=flex-items-center><img src=/assets/icons/finance/purchases.svg alt=purchases class=mr-8><div class=ft_14_600_gray translate=Purchases></div></div></a><div class=dropdown-menu><a class="dropdown-item disabled" href=# disabled translate=Purchases></a> <a class=dropdown-item href=# ui-sref=financePurchases translate=Purchases></a> <a class=dropdown-item href=# translate="Billing Scanner" ng-click=goBillScanner()></a> <a class=dropdown-item href=# ui-sref=financeVendor translate=Vendor></a></div></li><li class="nav-item mr-40 dropdown" ng-class="currentRoute == \'reports\' ? \'active\': \'\'"><a class=nav-link href=#><div class=flex-items-center><img src=/assets/icons/finance/reports.svg alt=reports class=mr-8><div class=ft_14_600_gray translate=Reports></div></div></a><div class=dropdown-menu><a class="dropdown-item disabled" href=# disabled translate=Reports></a> <a class=dropdown-item href=# ui-sref=financeVatReports translate=VAT></a> <a class=dropdown-item href=# ui-sref=financeCreditReports translate="Credit, List"></a> <a class=dropdown-item href=# ui-sref=financeDebitReports translate="Debit, List"></a></div></li><li class="nav-item mr-40" ng-class="currentRoute == \'finance\' || currentRoute.includes(\'posts\') || currentRoute.includes(\'journal\') ? \'active\': \'\'"><a class=nav-link href=# ui-sref=financeFinance><div class=flex-items-center><img src=/assets/icons/finance/finance.svg alt=finance class=mr-8><div class=ft_14_600_gray translate=Finance></div></div></a></li><li class="nav-item mr-40" ng-class="currentRoute == \'balance\' ? \'active\': \'\'"><a class=nav-link href=# ui-sref=financeBalance><div class=flex-items-center><img src=/assets/icons/finance/finance.svg alt=balance class=mr-8><div class=ft_14_600_gray translate=Balance></div></div></a></li><li class="nav-item mr-40" ng-class="currentRoute == \'vat-settings\' ? \'active\': \'\'"><a class=nav-link href=# ui-sref=financeVatSettings><div class=flex-items-center><img src=/assets/icons/finance/vat-settings.svg alt=vat-settings class=mr-8><div class=ft_14_600_gray translate="VAT Settings"></div></div></a></li><li class="nav-item mr-40" ng-class="currentRoute == \'script\' ? \'active\': \'\'"><a class=nav-link href=# ui-sref=financeScript><div class=flex-items-center><img src=/assets/icons/finance/script.svg alt=script width=24 class=mr-8><div class=ft_14_600_gray translate=Script></div></div></a></li></ul><div class="dropdown ml-auto"><button id=settings-toggle class="btn btn-light dropdown-toggle" data-toggle=dropdown aria-haspopup=true aria-expanded=false><img src=/assets/icons/finance/vat-settings.svg alt=""></button><div class=dropdown-menu aria-labelledby=settings-toggle><a class="dropdown-item disabled" href=# disabled translate=Settings></a> <a href=# class=dropdown-item translate="VAT, Setting"></a> <a href=# class=dropdown-item translate="VAT, List"></a> <a href=# class=dropdown-item translate=Date></a> <a href=# class=dropdown-item translate=Invoice#></a> <a href=# class=dropdown-item translate="Order Number"></a> <a href=# class=dropdown-item translate="Customer Name"></a> <a href=# class=dropdown-item translate="Due Date"></a> <a href=# class=dropdown-item translate=Amount></a> <a href=# class=dropdown-item translate="Balance Amount"></a> <a href=# class=dropdown-item translate=""><img src=/assets/icons/import-black.svg alt=import class=mr-8> <span translate="Import Invoices"></span> </a><a href=# class=dropdown-item translate=""><img src=/assets/icons/export-black.svg alt=import class=mr-8> <span translate="Export Invoices"></span></a><div class=dropdown-divider></div><a href=# class=dropdown-item translate=""><img src=/assets/icons/cash-black.svg alt=refresh class=mr-8> <span translate=Refresh></span></a></div></div></nav></div>');
$templateCache.put('app/main/finance/directives/finance-selectboxinput/finance-selectboxinput.view.html','<div><ui-select ng-model=selected ng-disabled=ngDisabled on-select=onSelect($select.selected)><ui-select-match><span placeholder={{placeholder}} ng-bind="$select.selected[labelField][\'item1\']"></span></ui-select-match><ui-select-choices repeat="item in (cOptions | filter: $select.search) track by $index" position="{{toTop ? \'up\' : \'down\'}}"><div class="menu-item d-flex" data-ng-click=selectItem(item)><div ng-class="[financeType == \'Billing\' ? \'w-96\' : \'w-176\']" ng-bind="item[labelField][\'item1\']"></div><div class=w-88 ng-bind="item[labelField][\'item2\']"></div><div class=w-104 ng-bind="item[labelField][\'item3\']"></div><div class=w-104 ng-bind="item[labelField][\'item4\']"></div><div class=w-104 ng-bind="item[labelField][\'item5\']"></div></div></ui-select-choices></ui-select></div>');
$templateCache.put('app/main/finance/directives/sort-dropdown/sort-dropdown.view.html','<div class="sort-dropdown dropdown"><button class="btn btn-light dropdown-toggle" type=button id=sort-dropdown-menu-button data-toggle=dropdown aria-haspopup=true aria-expanded=false><img src=/assets/icons/sort-list-dark-gray.svg alt=""></button><div class=dropdown-menu aria-labelledby=sort-dropdown-menu-button><a class="dropdown-item disabled" href=# disabled translate="SORT BY"></a> <a class=dropdown-item href=# ng-repeat="option in options" ng-click=changeValue(option.value)><img ng-if=option.iconUrl ng-src={{option.iconUrl}} alt="" class=mr-8> <span translate={{option.label}}></span></a></div></div>');
$templateCache.put('app/main/finance/finance-bank/finance-bank-detail/finance-bank-detail.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-bank-detail><finance-menu></finance-menu><div class="content-container pos-relative"><div class=content><div class="content-header mb-16"><div class="d-flex align-items-center"><div class=bank-bread><selectbox-input class="w-250 dropdown-primary" options=vm.banks label-field=accountName value-field=_id ng-model=currentBankId on-change=changeBank()></selectbox-input><img class=bank-logo ng-src="{{currentBank.logo ? currentBank.logo : \'/assets/images/materials/noImg.jpg\'}}" alt="Bank Logo"></div><div class=bank-title><div class=title>{{currentBank.accountName}}</div><div class=number>{{currentBank.accountNumber}}</div></div></div><div class="d-flex align-items-center"><div class="dropdown mr-16"><button class=button-primary data-toggle=dropdown aria-haspopup=true aria-expanded=false><img src=/assets/icons/upload-white2.svg alt=""></button><ul class=dropdown-menu><li class=dropdown-item href=# translate="Upload Statement" ng-click=uploadBankStatements()></li><li class=dropdown-item href=# translate="Upload Gen Post" ng-click=uploadGenPostData()></li><li class=dropdown-item href=# translate="Upload Economic Data" ng-click=uploadExternEconomicData()></li><li class=dropdown-item href=# translate="Upload Payroll" ng-click=uploadFinancePayrolls()></li></ul></div><button class="btn btn-dark" ng-click=openFinanceDocTemplateModal()><img src=/assets/icons/plus-circle.svg alt="" class=mr-8><span>Setup Fast Track</span></button></div></div><div class="d-flex align-items-center justify-content-between mb-16"><div class=d-flex><button class="btn btn-month mr-8" ng-repeat="month in months track by $index" ng-class="{\'active\': month.value == selectedMonth.value}" ng-click=selectMonth(month)>{{month.label}}</button></div><div class=d-flex><button class="button-primary mr-16" ng-click=autoLinking()><img src=/assets/icons/cash-white.svg alt="" class=mr-8><span translate=Auto></span></button> <button class="btn btn-green btn-32" ng-click=approve()><img src=/assets/icons/check-mark-white.svg alt="" class=mr-8><span translate=Approve></span></button></div></div><div class=banking-tables><div class="banking-table left"><div class=table-filter><div class=d-flex><button class="btn btn-primary btn-32" ng-click=delete()><img src=/assets/icons/delete-white.svg alt="" class=mr-8><span translate=Delete></span></button></div><div class=d-flex><selectbox-input class="w-78 mr-16 ml-auto dropdown-primary" options=years label-field=value value-field=value ng-model=bankStatementYear change-trig="fetchData(\'bankStatement\')"></selectbox-input><searchbox input-class=finance-searchbox class=m-t-4 search-text=searchTextBankStatement search-event="searchData(\'bankStatement\')"></searchbox></div></div><div class=thead><div class=tr><div class="td check-item"><input type=checkbox ng-model=isAllChecked ng-change=checkAllItems()></div><div class="td id cursor-point" ng-click="changeBankSortItem(\'bankCode\')"><div class=mr-8>ID#</div><img ng-src="{{currentBankSortItem.sort === \'bankCode\' && vm.bankSortItems[0].sortDir > 0 ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                     currentBankSortItem.sort === \'bankCode\' && vm.bankSortItems[0].sortDir < 0 ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                     currentBankSortItem.sort !== \'bankCode\' && vm.bankSortItems[0].sortDir > 0 ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div><div class="td date cursor-point" ng-click="changeBankSortItem(\'date\')"><div class=mr-8 translate=Date></div><img ng-src="{{currentBankSortItem.sort === \'date\' && vm.bankSortItems[1].sortDir > 0 ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                     currentBankSortItem.sort === \'date\' && vm.bankSortItems[1].sortDir < 0 ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                     currentBankSortItem.sort !== \'date\' && vm.bankSortItems[1].sortDir > 0 ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div><div class="td transaction cursor-point" ng-click="changeBankSortItem(\'description\')"><div class=mr-8 translate="Transaction Details"></div><img ng-src="{{currentBankSortItem.sort === \'description\' && vm.bankSortItems[2].sortDir > 0 ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                     currentBankSortItem.sort === \'description\' && vm.bankSortItems[2].sortDir < 0 ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                     currentBankSortItem.sort !== \'description\' && vm.bankSortItems[2].sortDir > 0 ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div><div class="td amount cursor-point" ng-click="changeBankSortItem(\'amount\')"><div class=mr-8 translate=Amount></div><img ng-src="{{currentBankSortItem.sort === \'amount\' && vm.bankSortItems[3].sortDir > 0 ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                     currentBankSortItem.sort === \'amount\' && vm.bankSortItems[3].sortDir < 0 ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                     currentBankSortItem.sort !== \'amount\' && vm.bankSortItems[3].sortDir > 0 ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div><div class="td status"><finance-link-point ng-if="bankStatements && bankStatements.length" element-id={{allBankStatement._id}} link-status=allBankStatement.linkStatus is-selected=allBankStatement.selected ng-click=selectAllBankStatement()></finance-link-point></div></div></div><div class=tbody id=statements-table-body><div ng-repeat="bankStatement in bankStatements track by $index" class="d-flex flex-column"><div class=tr><div class="td check-item"><input type=checkbox ng-model=bankStatement.isChecked></div><div class="td id">{{bankStatement.bankCode}}</div><div class="td date">{{bankStatement.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td transaction" title={{bankStatement.description}}>{{bankStatement.description}}</div><div class="td amount" ng-if=!bankStatement.financeItems.length title="{{bankStatement.amount | readable: 2}}">{{bankStatement.amount | readable: 2}}</div><div class="td amount dropdown" ng-if=bankStatement.financeItems.length title="{{bankStatement.amount | readable: 2}}"><div id=amount-{{bankStatement._id}}-down class="cursor-point w-100" ng-if=!bankStatement.showDetail ng-click="bankStatement.showDetail = true"><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{bankStatement.amount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div id=amount-{{bankStatement._id}}-up class="cursor-point w-100" ng-if=bankStatement.showDetail ng-click="bankStatement.showDetail = false"><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{bankStatement.amount | readable: 2}}</div><img src=/assets/icons/chevron-up-gray.svg alt=""></div></div></div><div class="td status"><finance-link-point element-id={{bankStatement._id}} link-status=bankStatement.linkStatus is-selected=bankStatement.selected ng-sglclick=selectBankStatement(bankStatement) ng-dblclick=setBankStatementForFinanceDoc(bankStatement) remove-link=removeLinkFromBankStatement(bankStatement)></finance-link-point></div></div><div class="tr details" ng-repeat="financeItem in bankStatement.financeItems track by $index" ng-if=bankStatement.showDetail><div class="td check-item"></div><div class="td id font-italic">{{bankStatement.bankCode}}</div><div class="td date font-italic">{{financeItem.item.billDate || financeItem.item.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td transaction font-italic" title="{{financeItem.item.billNo || financeItem.item.displaySeq || financeItem.item.systemTag}}">{{financeItem.item.billNo || financeItem.item.displaySeq || financeItem.item.systemTag}}</div><div class="td amount font-italic" title="{{financeItem.amount | readable: 2}}">{{financeItem.amount | readable: 2}}</div><div class="td status"><finance-link-point element-id=summary-{{financeItem.item._id}}-{{bankStatement._id}} link-status="\'approved\'"></finance-link-point></div></div><div class="tr details" ng-if="bankStatement.showDetail && bankStatement.linkStatus != \'approved\'"><div class="td id font-italic"></div><div class="td date font-italic"></div><div class="td transaction font-italic"></div><div class="td amount font-italic" title="{{bankStatement.remainingAmount | readable: 2}}">{{bankStatement.remainingAmount | readable: 2}}</div><div class="td status"><finance-link-point element-id=summary-{{bankStatement._id}}-remaining-amount link-status="\'none\'" ng-dblclick=setNeedFinanceItem(bankStatement)></finance-link-point></div></div></div></div></div><div class="banking-table right"><div class="table-filter justify-content-end"><selectbox-input class="w-78 mr-16 dropdown-primary" options=years label-field=value value-field=value ng-model=financeYear change-trig="fetchData(\'finance\')"></selectbox-input><multiselect class="w-190 mr-16 dropdown-primary" ng-model=selectedVendorTypes options="c for c in allVendorTypes" scroll-after-rows=5 filter-after-rows=1 change="fetchData(\'finance\')" data-multiple=true></multiselect><!-- <selectbox-input class="w-190 mr-16 dropdown-primary"\n                options="vendorTypes"\n                label-field="label"\n                value-field="value"\n                ng-model="vendorType"\n                change-trig="fetchData(\'finance\')">\n              </selectbox-input> --><selectbox-input class="w-152 mr-16 dropdown-primary" options=transfers label-field=value value-field=value ng-model=transfer change-trig="fetchData(\'finance\')"></selectbox-input><searchbox input-class=finance-searchbox class=m-t-4 search-text=searchTextFinance search-event="searchData(\'finance\')"></searchbox></div><div class=thead><div class=tr><div class="td status"></div><div class="td id cursor-point" ng-click="changeFinanceSortItem(\'bankCode\')"><div class=mr-8>ID#</div><img ng-src="{{currentFinanceSortItem.sort === \'bankCode\' && financeSortItems[0].sortDir > 0 ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                     currentFinanceSortItem.sort === \'bankCode\' && financeSortItems[0].sortDir < 0 ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                     currentFinanceSortItem.sort !== \'bankCode\' && financeSortItems[0].sortDir > 0 ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div><div class="td finance-account" translate=Account></div><div class="td date cursor-point" ng-click="changeFinanceSortItem(\'date\')"><div class=mr-8 translate=Date></div><img ng-src="{{currentFinanceSortItem.sort === \'date\' && financeSortItems[1].sortDir > 0 ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                     currentFinanceSortItem.sort === \'date\' && financeSortItems[1].sortDir < 0 ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                     currentFinanceSortItem.sort !== \'date\' && financeSortItems[1].sortDir > 0 ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div><div class="td doc cursor-point" ng-click="changeFinanceSortItem(\'doc\')"><div class=mr-8>Type doc#</div><img ng-src="{{currentFinanceSortItem.sort === \'doc\' && financeSortItems[2].sortDir > 0 ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                     currentFinanceSortItem.sort === \'doc\' && financeSortItems[2].sortDir < 0 ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                     currentFinanceSortItem.sort !== \'doc\' && financeSortItems[2].sortDir > 0 ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div><div class="td name cursor-point" ng-click="changeFinanceSortItem(\'vendor\')"><div class=mr-8 translate="Vendor Name"></div><img ng-src="{{currentFinanceSortItem.sort === \'vendor\' && financeSortItems[3].sortDir > 0 ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                     currentFinanceSortItem.sort === \'vendor\' && financeSortItems[3].sortDir < 0 ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                     currentFinanceSortItem.sort !== \'vendor\' && financeSortItems[3].sortDir > 0 ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div><div class="td amount cursor-point" ng-click="changeFinanceSortItem(\'amount\')"><div class=mr-8 translate=Amount></div><img ng-src="{{currentFinanceSortItem.sort === \'amount\' && financeSortItems[4].sortDir > 0 ? \'/assets/icons/fm_up_arrow_activated.svg\' :\n                     currentFinanceSortItem.sort === \'amount\' && financeSortItems[4].sortDir < 0 ? \'/assets/icons/fm_down_arrow_activated.svg\' :\n                     currentFinanceSortItem.sort !== \'amount\' && financeSortItems[4].sortDir > 0 ? \'/assets/icons/fm_up_arrow_disabled.svg\' :\n                     \'/assets/icons/fm_down_arrow_disabled.svg\'}}" alt=""></div><div class="td actions" translate=Actions></div></div></div><div class=tbody id=finances-table-body><div ng-repeat="finance in finances track by $index"><div class=tr><div class="td status"><finance-link-point element-id={{finance._id}} link-status=finance.linkStatus is-selected=finance.selected right-direction=true ng-sglclick=selectFinance(finance) ng-dblclick=setBalanceFinanceItem(finance) remove-link=removeLinkFromFinance(finance)></finance-link-point></div><div class="td id" title="{{finance.bankCode || finance.finance.bankCode}}">{{finance.bankCode || finance.finance.bankCode}}</div><div class="td finance-account">{{finance.accountPlan.number}}</div><div class="td date">{{finance.billDate || finance.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td doc" title="{{finance.billNo || finance.displaySeq || finance.systemTag}}">{{finance.billNo || finance.displaySeq || finance.systemTag}}</div><div class="td name" title="{{finance.vendor.clientName || finance.vendor.name || finance.description}}">{{finance.vendor.clientName || finance.vendor.name || finance.description}}</div><div class="td amount" ng-if="!finance.financeItems.length && (!finance.subtractList || !finance.subtractList.length)" title="{{finance.totalAmount || finance.amount | readable: 2}}">{{finance.totalAmount || finance.amount | readable: 2}}</div><div class="td amount dropdown" ng-if="finance.financeItems.length || (finance.subtractList && finance.subtractList.length)" title="{{finance.totalAmount | readable: 2}}"><div id=amount-{{finance._id}}-down class="cursor-point w-100" ng-if=!finance.showDetail ng-click="finance.showDetail = true"><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{finance.totalAmount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div id=amount-{{finance._id}}-down class="cursor-point w-100" ng-if=finance.showDetail ng-click="finance.showDetail = false"><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{finance.totalAmount | readable: 2}}</div><img src=/assets/icons/chevron-up-gray.svg alt=""></div></div></div><div class="td actions"><img ng-if="finance.financeType === \'Invoice\'" src=/assets/icons/eye.svg alt="" class="cursor-point mr-8" ng-click=downloadInvoice(finance)> <img ng-if="finance.financeType === \'Billing\'" src=/assets/icons/eye.svg alt="" class="cursor-point mr-8" ng-click=downloadBill(finance)> <img ng-if="finance.financeType !== \'Invoice\' && finance.financeType !== \'Billing\'" src=/assets/icons/eye.svg alt="" class="cursor-point mr-8" ng-click=downloadAttach(finance)> <img src=/assets/icons/undo-gray.svg alt="" ng-click=reverseFinance(finance)></div></div><div class="tr details" ng-if=finance.showDetail ng-repeat="financeItem in finance.financeItems track by $index"><div class="td status"><finance-link-point element-id=summary-{{financeItem.item._id}}-{{finance._id}} link-status="\'approved\'"></finance-link-point></div><div class="td id font-italic" title={{financeItem.item.bankCode}}>{{financeItem.item.bankCode}}</div><div class="td finance-account font-italic"></div><div class="td date font-italic">{{financeItem.item.date || financeItem.item.billDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td doc font-italic" title=BankStatement ng-if="financeItem.itemType == \'BankStatement\'">BankStatement</div><div class="td doc font-italic" title="{{financeItem.item.systemTag || financeItem.item.billNo}}" ng-if="financeItem.itemType != \'BankStatement\'">{{financeItem.item.systemTag || financeItem.item.billNo}}</div><div class="td name font-italic" title={{financeItem.item.description}} ng-if="financeItem.itemType == \'BankStatement\'">{{financeItem.item.description}}</div><div class="td name font-italic" title="{{finance.vendor.clientName || finance.vendor.name || finance.description}}" ng-if="financeItem.itemType != \'BankStatement\'">{{finance.vendor.clientName || finance.vendor.name || finance.description}}</div><div class="td amount font-italic" title="{{financeItem.amount | readable: 2}}">{{financeItem.amount | readable: 2}}</div><div class="td actions"></div></div><div class="tr details" ng-if=finance.showDetail ng-repeat="subtract in finance.subtractList"><div class="td status"><finance-link-point element-id=subtract-{{subtract._id}}-{{finance._id}} link-status="\'memo\'"></finance-link-point></div><div class="td id font-italic"></div><div class="td finance-account font-italic"></div><div class="td date font-italic">{{finance.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div><div class="td doc font-italic" ng-if="finance.financeType == \'Invoice\'" title="Credit Memo">Credit Memo</div><div class="td doc font-italic" ng-if="finance.financeType == \'Billing\'" title="Credit Memo">Bill Memo</div><div class="td name font-italic" title="{{finance.vendor.clientName || finance.vendor.name || finance.description}}">{{finance.vendor.clientName || finance.vendor.name || finance.description}}</div><div class="td amount font-italic" title="{{subtract.subtractTotalAmount | readable: 2}}">{{subtract.subtractTotalAmount * -1 | readable: 2}}</div><div class="td actions"></div></div><div class="tr details" ng-if="finance.showDetail && finance.linkStatus != \'approved\'"><div class="td status"><finance-link-point element-id=summary-{{finance._id}}-remaining-amount link-status="\'none\'" ng-dblclick=setNeedFinanceItem(finance)></finance-link-point></div><div class="td id font-italic" title={{financeItem.item.bankCode}}></div><div class="td finance-account font-italic"></div><div class="td date font-italic"></div><div class="td doc font-italic"></div><div class="td name font-italic"></div><div class="td amount font-italic" title="{{finance.remainingAmount | readable: 2}}">{{finance.remainingAmount | readable: 2}}</div><div class="td actions"></div></div></div></div><finance-doc-panel ng-if=vm.bankStatementForFinanceDoc clients=vm.clients vendors=vm.vendors balance-plans=vm.balanceOnlyAccountPlans bank-statement=vm.bankStatementForFinanceDoc template-list=vm.financeDocTemplates account-plan=vm.bankAccountPlans[0]._id></finance-doc-panel><finance-doc-panel ng-if=allBankStatement.selected clients=vm.clients vendors=vm.vendors balance-plans=vm.balanceOnlyAccountPlans all-bank-statement=allBankStatement template-list=vm.financeDocTemplates account-plan=vm.bankAccountPlans[0]._id></finance-doc-panel><finance-doc-panel ng-if=needFinanceItem clients=vm.clients vendors=vm.vendors balance-plans=vm.balanceOnlyAccountPlans need-finance-item=needFinanceItem template-list=vm.financeDocTemplates account-plan=vm.bankAccountPlans[0]._id></finance-doc-panel><finance-doc-panel ng-if=needBillingMemo clients=vm.clients vendors=vm.vendors balance-plans=vm.balanceOnlyAccountPlans amount=billMemoAmount need-bill-item=needBillItem need-memo-item=needMemoItem template-list=vm.financeDocTemplates account-plan=vm.bankAccountPlans[0]._id></finance-doc-panel><finance-doc-panel ng-if=needInvoiceMemo clients=vm.clients vendors=vm.vendors balance-plans=vm.balanceOnlyAccountPlans amount=invoiceMemoAmount need-invoice-item=needInvoiceItem need-memo-item=needMemoItem template-list=vm.financeDocTemplates account-plan=vm.bankAccountPlans[0]._id></finance-doc-panel><finance-doc-panel ng-if=balanceFinanceItem clients=vm.clients vendors=vm.vendors balance-plans=vm.balanceOnlyAccountPlans balance-finance-item=balanceFinanceItem template-list=vm.financeDocTemplates account-plan=vm.bankAccountPlans[0]._id></finance-doc-panel></div></div></div></div></div><spinner ng-if=loading></spinner></main>');
$templateCache.put('app/main/finance/finance-bank/finance-bank-list/finance-bank-list.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-bank-list><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><!-- Banking Blocks --><div class="w-100 flex-between mb-30"><finance-banking-block type="\'income\'" list=vm.invoiceList></finance-banking-block><finance-banking-block type="\'payout\'" list=vm.billingList></finance-banking-block></div><!-- All Banks --><div class="w-100 mb-30"><div class="flex-between mb-16"><div class=ft_24_600_black1>All Banks</div><div class=d-flex><button class="btn btn-circle mr-8"><img src=/assets/icons/left-arrow-gray.svg alt="" ng-click=changeBankList(false)></button> <button class="btn btn-circle"><img src=/assets/icons/right-arrow-gray.svg alt="" ng-click=changeBankList(true)></button></div></div><div class=flex-between><finance-bank-card ng-repeat="bank in vm.bankAccounts.slice(0, 3) track by $index" ng-model=bank selected-bank-id=currentBank._id ng-click=changeBank(bank)></finance-bank-card></div></div><!-- Banking Overview --><div class=banking-overview><div class="ft_16_600_black mb-16" translate="Banking Overview"></div><div class="d-flex justify-content-between flex-end mb-16"><div class=flex-items-center><img class=bank-logo ng-src={{currentBank.logo}} alt=""><div><div class=ft_24_600_black1>{{currentBank.name}}</div><div class=ft_16_regular_black>{{currentBank.number}}</div></div></div><div class=flex-items-center><button class="btn btn-yellow mr-16"><img class=mr-8 src=/assets/icons/plus-circle.svg alt=""><div translate="Add Transaction"></div></button> <button class="btn btn-light"><img src=/assets/icons/settings-gray.svg alt=""></button></div></div><div class="banking-row head"><div class="banking-col no" translate="Invoice No."></div><div class="banking-col date" translate=Date></div><div class="banking-col ref-no" translate="Ref No."></div><div class="banking-col details" translate=Details></div><div class="banking-col credit" translate=Credit></div><div class="banking-col debit" translate=Debit></div><div class="banking-col balance" translate=Balance></div><div class="banking-col view"></div></div><div class=banking-row ng-class="{\'income\': $index % 2 == 0, \'payout\': $index % 2 == 1}" ng-repeat="x in [].constructor(10) track by $index"><div class="banking-col no">INV-00645</div><div class="banking-col date">18/09/2016</div><div class="banking-col ref-no">Ref-8188</div><div class="banking-col details">Electronic Purchase on Ebay</div><div class="banking-col credit" ng-if="$index % 2 == 0">${{5784 | readable: 2}}</div><div class="banking-col credit" ng-if="$index % 2 == 1"></div><div class="banking-col debit" ng-if="$index % 2 == 0"></div><div class="banking-col debit" ng-if="$index % 2 == 1">${{5724 | readable: 2}}</div><div class="banking-col balance">{{3034 | readable: 2}}</div><div class="banking-col view"><img src=/assets/icons/eye6.svg alt=""></div></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-invoice/create/finance-create-invoice.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-create-invoice class=wide-page><finance-menu></finance-menu><div class=content-container><spinner ng-if=loading></spinner><div class="content pos-relative"><div class=content-header ng-if=!isEdit><div class=ft_16_600_black translate="New Invoice"></div></div><div class=content-header ng-if=isEdit><div class=ft_16_600_black translate="Edit Invoice"></div></div><div class=content-body><div class="sub-header mb-20"><div class="item flex-between mb-16"><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38 required" translate="Customer Name"></div><selectbox-input class="dropdown-primary flex-60" ng-model=vm.vendorIdTemp options=vm.userListTemp label-field=name value-field=_id select-event=vm.changeVendor(vm.vendorIdTemp) is-search=true></selectbox-input></div><div class=flex-35></div><div class=flex-25></div></div><div class="item flex-between mb-16"><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38" translate="Reference No"></div><input type=text class="input-primary flex-60" ng-model=vm.invoice.referenceNo></div><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38" translate="Project ID"></div><input type=text class="input-primary flex-60" ng-model=vm.invoice.projectSystemTag readonly></div><div class=flex-25></div></div><div class="item flex-between mb-16"><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38 required" translate="Invoice Date"></div><div class="input-group datePicker-primary flex-60"><input type=text class="input-primary w-100" change=invoiceDateChanged() date-picker=dd.MM.yyyy date=vm.invoice.date is-open=isDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isDatepickerOpen = !isDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38 required" translate="Due Date"></div><div class="input-group datePicker-primary flex-60"><input type=text class="input-primary w-100" date-picker=dd.MM.yyyy date=vm.invoice.dueDate is-open=isDueDatepickerOpen ng-required=true readonly> <span class=dateArrow><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=flex-25></div></div><div class="item flex-between"><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38" translate=Staff></div><selectbox-input class="dropdown-primary flex-60" ng-model=vm.invoice.staff options=vm.invoice.vendor.staffs label-field=displayName value-field=_id is-search=true></selectbox-input></div><div class="flex-35 flex-between"><div class="ft_14_600_black2 flex-38" translate="Created By"></div><input type=text class="input-primary flex-60" ng-model=vm.invoice.createdByName readonly></div><div class=flex-25></div></div></div><div class="flex-between mb-20"><div class=flex><label class="check_yellow_20 mr-16"><div class=ft_14_600_black translate="Create Credit Memo"></div><input type=checkbox ng-model=vm.isCreditMemo> <span class=checkmark></span></label> <label class=check_yellow_20><div class=ft_14_600_black translate="Included Terms and Conditions"></div><input type=checkbox ng-model=vm.invoice.termsAndConditions> <span class=checkmark></span></label> <label class="check_yellow_20 ml-16"><div class=ft_14_600_black translate="Final invoice to finish project"></div><input type=checkbox ng-model=vm.finalInvoice> <span class=checkmark></span></label></div><div class="flex btn-group"><button class=button-ex2 ng-style="{\'visibility\': vm.isCreditMemo ? \'visible\' : \'hidden\'}" ng-click=vm.showImportInvoicePopup()>+&nbsp;<span translate="Import Invoices"></span></button><div class="dropdown ml-20 add-payment-terms"><button class=button-ex2 type=button id=menu1 data-toggle=dropdown>+&nbsp;<span translate="Add Payment Terms"></span></button><ul class="dropdown-menu w-210" role=menu aria-labelledby=menu1><li><a href=# class=menu-item ng-repeat="cc in vm.paymentConditions | filter:{validate:\'false\'}" ng-click=vm.addPaymentTerm(cc)>{{ cc.code }}</a></li></ul></div><div class=ml-20><button class=button-ex2 ng-click=vm.toggleProjectOverview()><img src=/assets/icons/eye-blue.svg alt=""><span translate="Project Overview"></span></button></div></div></div><!-- <div class="row mb-24">\n            <div class="col-4">\n              <label translate="Customer Name"></label>\n              <selectbox-input class="dropdown-primary"\n                ng-model="vm.vendorIdTemp"\n                options="vm.userListTemp"\n                label-field="name"\n                value-field="_id"\n                on-change="vm.changeVendor(vm.vendorIdTemp)"\n                is-search="true">\n              </selectbox-input>\n            </div>\n            <div class="col-8">\n              <label translate="Address"></label><div class="input-frame">{{vm.invoice.vendorAddress}}</div>\n            </div>\n          </div>\n          <div class="row mb-24">\n            <div class="col-4">\n              <label translate="Staff1"></label>\n              <selectbox-input class="dropdown-primary"\n                ng-model="vm.invoice.staff"\n                options="vm.invoice.vendor.staffs"\n                label-field="displayName"\n                value-field="_id"\n                is-search="true">\n              </selectbox-input>\n            </div>\n            <div class="col-8">\n              <div class="row">\n                <div class="col-4">\n                  <label translate="Invoice Date"></label>\n                  <div class="has-calendar">\n                    <input class="calendar-box" placeholder="" date-picker="dd MMM yyyy" date="vm.invoice.date" change="invoiceDateChanged()"/>\n                    <div class="calendar-icon"><img src="/assets/icons/calendar-gray.svg" alt=""/></div>\n                  </div>\n                </div>\n                <div class="col-4">\n                  <label translate="Due Date1"></label>\n                  <div class="has-calendar">\n                    <input class="calendar-box" placeholder="" date-picker="dd MMM yyyy" date="vm.invoice.dueDate" readonly/>\n                    <div class="calendar-icon"><img src="/assets/icons/calendar-gray.svg" alt=""/></div>\n                  </div>\n                </div>\n                <div class="col-4">\n                  <label translate="Payment Terms"></label>\n                  <selectbox-input options="vm.paymentConditions"\n                    label-field="code"\n                    value-field="_id"\n                    ng-model="vm.invoice.paymentCondition"\n                    select-event="vm.addPaymentTerm()"\n                  ></selectbox-input>\n                </div>\n              </div>\n            </div>\n          </div> --><div class="items-table mb-16"><div class=tr><div class="th flex-5">#</div><div class="th flex-15" translate=Type></div><div class="th flex-20" translate="Item Details"></div><div class="th flex-8 text-right" translate=Quantity></div><div class="th flex-10 text-right" translate="Unit Price"></div><div class="th flex-10 text-right" translate=Amount></div><div class="th flex-8 text-right" translate="VAT %"></div><div class="th flex-10 text-right" translate="VAT Amount"></div><div class="th flex-10 text-right" translate=Amount></div><div class="th flex-4"></div></div><div class=tr ng-repeat="item in vm.invoice.items track by $index"><div class="td flex-5"><selectbox input-class=invoice-selectbox ng-class="{active: item.isEdit}" ng-model=item.itemId options=vm.accountPlans label-field=label value-field=_id short-label-field=number select-event="vm.selectItemType(item.itemId, item, \'accountPlan\')" readonly></selectbox></div><div class="td flex-15"><selectbox input-class=invoice-selectbox ng-class="{active: item.isEdit}" ng-model=item.itemNum options=item.settingItems label-field=label value-field=_id select-event="vm.selectItemType(item.itemNum, item, \'settingItem\')" readonly></selectbox></div><div class="td flex-20" ng-if=!item.isServiceAndVAOrder><input type=text class=input-primary ng-class="{active: item.isEdit}" ng-model=item.description ng-readonly=!item.isEdit></div><div class="td flex-20" ng-if=item.isServiceAndVAOrder><input type=text class=input-primary ng-class="{active: item.isEdit}" ng-model=item.description ng-keyup="vm.searchItemDescription(item, item.description, $event)" ng-readonly=!item.isEdit><ul ng-if="filteredItems.length>0 && vm.curItem==item" class=pos-absolute><li class=menu-item ng-click="vm.selectItemDescription(item, fitem)" ng-repeat="fitem in filteredItems">{{ fitem.name }}</li></ul></div><div class="td flex-8 text-right"><input type=text ng-class="{active: item.isEdit, \'text-right\': true}" number-edit=2 ng-model=item.quantity ng-blur=vm.calculateItemPrice(item) ng-readonly=!item.isEdit></div><div class="td flex-10 text-right"><input type=text ng-class="{active: item.isEdit, \'text-right\': true}" number-edit=2 ng-model=item.unitPrice ng-value=item.unitPrice ng-blur=vm.calculateItemPrice(item) ng-readonly=!item.isEdit></div><div class="td flex-10 text-right"><span ng-if=item.price class=value>{{ item.price | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class="td flex-8 text-right"><input ng-if=!item.isSelType type=text ng-class="{active: item.isEdit, \'text-right\': true}" number-edit ng-model=item.vatPercent ng-blur=vm.calculateItemPrice(item) ng-readonly=!item.isEdit> <input ng-if=item.isSelType type=text class=text-right number-edit ng-model=item.vatPercent readonly></div><div class="td flex-10 text-right"><span ng-if=item.vatAmount class=value>{{ item.vatAmount | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class="td flex-10 text-right"><span ng-if="item.price && item.vatAmount" class=value>{{item.price + item.vatAmount | readable: 2}} {{ companyCurrency.symbol }}</span></div><div class="td flex-4 d-flex justify-content-center align-items-center"><!-- <div class="d-flex mr-1 cursor-point">\n                  <img src="/assets/icons/more-light.svg" alt="" class="more"/>\n                  <img src="/assets/icons/more-light.svg" alt="" class="more"/>\n                </div> --> <img src=/assets/icons/bxs-edit-blue.svg alt="" class="action-icon mr-8" ng-click=vm.editInvoiceRow(item) ng-if=!item.isEdit> <img src=/assets/icons/check-mark-line-blue.svg alt="" class="action-icon mr-8" ng-click=vm.confirmInvoiceRow(item) ng-if=item.isEdit> <img src=/assets/icons/trash-alt-red.svg alt="" class=action-icon ng-click=vm.removeInvoiceRow($index)></div></div></div><div class="d-flex justify-content-between align-items-start"><div class="d-flex align-items-center cursor-point" ng-click=vm.addInvoiceRow()><!-- <img src="/assets/icons/plus-orange.svg" alt="" class="plus-icon"/> --><div class=ft_14_600_blue>+&nbsp;<span translate="Add another line"></span></div></div><div class=sum-table><div class=tr><div class=td translate=Sum></div><div class=td>{{ vm.invoice.totalPrice | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=tr><div class=td translate="Vat1 %"></div><div class=td>{{ vm.invoice.items[0].vatPercent | readable: 2 }} %</div></div><div class=tr><div class=td translate="Vat Amount"></div><div class=td>{{ vm.invoice.totalVat | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class="tr total"><div class=td translate="Total Amount (Kr)"></div><div class=td>{{ vm.invoice.totalAmount | readable: 2 }} {{ companyCurrency.symbol }}</div></div></div></div><div class="d-flex align-items-center mb-1"><div class="ft_14_600_black mr-16" translate="Attach File(s)"></div><div class="btn btn-gray"><img src=/assets/icons/file-upload-gray.svg alt=""><span translate="Upload File"></span></div></div><div class="ft_12_500_gray mb-40" translate="You can upload a maximum of 5 files, 5MB each"></div><div class="row mb-16"><div class=col-6><label translate="Terms and Conditions"></label> <textarea placeholder="{{\'Mention your companys terms and conditions\' | translate}}"></textarea></div><div class=col-6><label translate=Notes></label><textarea></textarea></div></div></div><div class=content-footer><div class="d-flex align-items-center"><button class="button-primary mr-16" ng-click=vm.save(true) ng-disabled=loading translate="Save as Draft"></button> <button class="button-secondary mr-16" ng-click=vm.save(false) ng-disabled=loading translate=Save></button> <button class="button-third mr-16" ng-click=vm.showRecipientsPopup(true) ng-disabled=loading translate="Save and Send"></button> <button class=btn_cancel ui-sref=financeSales ng-disabled=loading translate=Cancel></button></div><div class=make-recurring><img src=/assets/icons/cash-cerulean.svg alt=""><div translate="Make Recurring"></div></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-invoice/detail/finance-detail-invoice.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><spinner ng-if=isLoading></spinner><div id=finance-invoice-detail class=main-container><finance-menu></finance-menu><div class=content><div class=header-title><div class=pos-relative><div class=ft_18_600_black translate="Invoice Detail"></div><div class="under-line w-170"></div></div><div class=button-group><button class="approved ft_14_600_white" ng-if="vm.invoice.status==\'paid\'"><img src=/assets/icons/check-mark-white.svg alt=""> <span translate=Paid></span></button> <button class="pending ft_14_600_white ml-10" ng-if="vm.invoice.status==\'pending\'"><img src=/assets/icons/close-circle-red1.svg alt=""> <span translate=Pending></span></button> <button class="pending ft_14_600_white ml-10" ng-if="vm.invoice.status==\'declined\'"><img src=/assets/icons/close-circle-red1.svg alt=""> <span translate=Declined></span></button></div></div><div class=content-wrap><div class="sub-header mb-20 flex-between flex"><div class=item><div class="ft_12_600_gray mb-8" translate="Client or Vendor"></div><div class="login_input w-250 tx-ellipsis">{{ vm.invoice.vendorType == "Client" ? vm.invoice.vendor.clientName : vm.invoice.vendor.name }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate=Staff></div><div class="login_input w-250 tx-ellipsis">{{ vm.invoice.staff.displayName }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate=Date></div><div class="login_input w-192">{{ vm.invoice.date | date: "yyyy/MM/dd" : \'UTC\' }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Due Date"></div><div class="login_input w-192">{{ vm.invoice.dueDate | date: "yyyy/MM/dd" : \'UTC\' }}</div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Project ID"></div><div class="login_input w-192">{{ vm.invoice.projectSystemTag }}</div></div><div class="item margin-0"><div class="ft_12_600_gray mb-8" translate="Created By"></div><div class="login_input w-192">{{ vm.invoice.createdBy.displayName }}</div></div></div><div class=pay-content><div class="flex-between mb-20"><div><label class=check_yellow_20><div class=ft_14_600_black>Included Terms and Conditions</div><input type=checkbox checked ng-model=vm.invoice.termsAndConditions disabled> <span class=checkmark></span></label></div></div><div><div class="table-wrap mb-20"><div class=header><div class=flex-10 translate=Sr.No.></div><div class=flex-10 translate=Type></div><div class=flex-30 translate=Description></div><div class=flex-10 translate=Quantity></div><div class=flex-10 translate="Unit Price"></div><div class=flex-10 translate=Vat%></div><div class=flex-10 translate=Vat></div><div class=flex-10 translate=Amount></div></div><div><div ng-repeat="invoiceItem in vm.invoice.items track by $index"><div class=item><div class=flex-10>{{ invoiceItem.type.number }}</div><div class=flex-10>{{ invoiceItem.type.name }}</div><div class=flex-30>{{ invoiceItem.description }}</div><div class=flex-10>{{ invoiceItem.quantity }}</div><div class=flex-10><span ng-if=invoiceItem.unitPrice>{{ invoiceItem.unitPrice | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class=flex-10><span ng-if=invoiceItem.vatPercent>{{ invoiceItem.vatPercent | readable: 2 }}</span></div><div class=flex-10><span ng-if=invoiceItem.vatAmount>{{ invoiceItem.vatAmount | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class=flex-10><span ng-if=invoiceItem.price>{{ invoiceItem.price | readable: 2 }} {{ companyCurrency.symbol }}</span></div></div><div class=item ng-show=invoiceItem.taxPercent><div class=flex-10>&nbsp;</div><div class=flex-10>&nbsp;</div><div class=flex-30>&nbsp;</div><div class=flex-10>&nbsp;</div><div class=flex-10>&nbsp;</div><div class=flex-10>Tax % {{ invoiceItem.taxPercent }}</div><div class=flex-10>&nbsp;</div><div class=flex-10><span ng-if=invoiceItem.taxAmount>{{ invoiceItem.taxAmount | readable: 2 }} {{ companyCurrency.symbol }} </span>&nbsp;</div></div></div></div></div></div><div class=input-group><div class=d-block><div class=w-350><span class=ft_14_600_black translate="Sum Total"></span><div></div><div class="login_input w-200">{{ vm.invoice.totalPrice | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=w-350><span class=ft_14_600_black translate=Vat></span><div></div><div class="login_input w-200">{{ vm.invoice.totalVat | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=w-350><span class=ft_14_600_black translate="Total Amount"></span><div></div><div class="login_input w-200">{{ vm.invoice.totalAmount | readable: 2 }} {{ companyCurrency.symbol }}</div></div><div class=w-350 ng-if="vm.invoice.totalTax != 0"><span class=ft_14_600_black translate=Tax></span><div></div><div class="login_input w-200">{{ vm.invoice.totalTax | readable: 2 }} {{ companyCurrency.symbol }}</div></div></div></div><div class=btn-group><!-- <div class="dropdown paid">\n              <button class="dropdown-toggle tx-ellipsis pr-25" type="button" id="menu1" data-toggle="dropdown">{{vm.invoice.status}}</button>\n              <ul class="dropdown-menu" role="menu" aria-labelledby="menu1">\n                <li><a href="#"  class="menu-item" id="{{ paidItem.id }}" data-ng-click="onPaidBtn($event)" ng-repeat="paidItem in vm.paidBtn">{{ paidItem.value }}</a></li>\n              </ul>\n            </div> --><!-- <button class="btn_primary" style="background-color: #ff7934;color: white !important;width: 120px;height: 46px;border-radius: 4px;">{{vm.invoice.status==\'unpaid\'?\'Unpaid\':\'Paid\'}}</button> --><!-- <div class="dropdown save mh-25">\n              <button class="dropdown-toggle tx-ellipsis pr-30" type="button" id="menu1" data-toggle="dropdown">\n                Save\n              </button>\n              <div style="position: absolute;top: 0;height: 46px;width: 85px;" ng-click="vm.saveInvoice()"></div>\n            </div> --><!-- <button class="btn_primary" ng-click="vm.saveInvoice()">Save</button> --></div></div></div></div></div><div ng-if=vm.pdfViewing><pdf-viewer id=pdf-viewer class=pdf-viewer url=vm.invoice.invoiceDoc ng-close=vm.closePDFViewer></pdf-viewer></div></main>');
$templateCache.put('app/main/finance/finance-journal/finance-create-manual-journal/finance-create-manual-journal.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class=finance-create-manual-journal><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><div class=content-header><div class=title translate="Finance Journal"></div><div class=flex-items-center><button class="button-primary mr-16" ng-click=addTransaction()><img src=/assets/icons/plus.svg alt=""><span translate="Add Transaction"></span></button><div class="dropdown mr-16"><button class="btn btn-light dropdown-toggle" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span translate=More></span><span class=caret></span></button><div class=dropdown-menu aria-labelledby=dropdownMenuButton><a class=dropdown-item href=# translate="Delete selected transactions" ng-click=deleteTransactions()></a></div></div><button class="btn btn-light btn-setting"><img src=/assets/icons/finance/vat-settings.svg alt=""></button></div></div><div class=content-body><div class="d-flex mb-16" ng-repeat="journal in vm.journalList"><div class=left><div class="d-flex align-items-center justify-content-between w-100 mb-8"><label class=check_yellow_20><input type=checkbox ng-model=journal.checked> <span class=checkmark></span></label><div class="value-rect w-120">{{journal.systemTag}}</div><selectbox-input class="w-164 dropdown-primary" ng-model=journal.type options=journalTypes label-field=label value-field=value on-change=changeType(journal)></selectbox-input><div class=has-calendar><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=journal.date> <img src=/assets/icons/bx-calendar-gray.svg alt="" class=calendar_icon></div></div><button class=button-primary style="margin-left: 36px" ng-click=addLine(journal)><img src=/assets/icons/plus.svg alt=""><span translate="Add Line"></span></button></div><div class=right><div ng-repeat="item in journal.items track by $index"><div class="d-flex justify-content-between mb-8"><input type=text ng-model=item.description placeholder=Description class=w-120><selectbox-input class="w-136 dropdown-primary" ng-model=item.accountPlan1 options=vm.accountPlans short-label-field=number use-short-label=true label-field=label value-field=_id></selectbox-input><selectbox-input class="w-136 dropdown-primary" ng-model=item.vatType options=vm.vatSettings label-field=vatType value-field=_id></selectbox-input><input type=text number-edit class=w-136 ng-model=item.debit placeholder=Debit ng-change=calcSum() ng-disabled=item.credit> <input type=text number-edit class=w-136 ng-model=item.credit placeholder=Credit ng-change=calcSum() ng-disabled=item.debit><selectbox-input class="w-136 right-dropdown dropdown-primary" ng-model=item.accountPlan2 options=vm.accountPlans label-field=label short-label-field=number use-short-label=true value-field=_id></selectbox-input></div></div><div class="d-flex justify-content-between mb-8"><div class=w-120></div><div class=w-136></div><div class="w-136 ft_14_600_black" style="line-height: 32px">Sum in Total</div><div class="value-rect w-136"><span class=mr-1>{{vm.currency}}</span> <span>{{journal.totalDebit | readable: 2}}</span></div><div class="value-rect w-136"><span class=mr-1>{{vm.currency}}</span> <span>{{journal.totalCredit | readable: 2}}</span></div><div class="value-rect w-136"><span class=mr-1>{{vm.currency}}</span> <span>{{journal.totalBalance | readable: 2}}</span></div></div></div></div></div><div class=content-footer><div class=d-flex><button class="button-primary green mr-16" ng-click=createManualJournal()><img src=/assets/icons/check-mark-white.svg alt=""> <span translate=Approve></span></button> <button class=btn_cancel ui-sref=financeFinance translate=Cancel></button></div><!--          <div class="d-flex">--><!--            <div class="sum-box">--><!--              <div class="top">--><!--                <div class="info">--><!--                  <div translate="Bank Account"></div>--><!--                  <div class="text-green"><span class="mr-2">{{vm.currency}}</span><span>{{vm.journal.sum.bankAccount | readable: 2}}</span></div>--><!--                </div>--><!--                <div class="info">--><!--                  <div translate="Debit"></div>--><!--                  <div class="text-green"><span class="mr-2">{{vm.currency}}</span><span>{{vm.journal.sum.debit | readable: 2}}</span></div>--><!--                </div>--><!--              </div>--><!--              <div class="bottom">--><!--                <span class="mr-2" translate="Total sum Client"></span>--><!--                <span class="text-green mr-2">{{vm.currency}}</span><span class="text-green">{{vm.journal.sum.totalClient | readable: 2}}</span>--><!--              </div>--><!--            </div>--><!--            <div class="sum-box">--><!--              <div class="top">--><!--                <div class="info">--><!--                  <div translate="Receivables Client"></div>--><!--                  <div class="text-orange"><span class="mr-2">{{vm.currency}}</span><span>{{vm.journal.sum.recvClient | readable: 2}}</span></div>--><!--                </div>--><!--                <div class="info">--><!--                  <div translate="Credit"></div>--><!--                  <div class="text-orange"><span class="mr-2">{{vm.currency}}</span><span>{{vm.journal.sum.credit | readable: 2}}</span></div>--><!--                </div>--><!--              </div>--><!--              <div class="bottom">--><!--                <span class="mr-2">SUM:</span>--><!--                <span class="mr-2">{{vm.currency}}</span><span>{{vm.journal.sum.sum | readable: 2}}</span>--><!--              </div>--><!--            </div>--><!--          </div>--></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-journal/finance-create-payment-journal/finance-create-payment-journal.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class=finance-create-payment-journal><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><div class=content-header><div class=title translate="Finance Journal"></div><div class=flex-items-center><div class="dropdown mr-16"><button class="btn btn-light dropdown-toggle" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span translate=More></span><span class=caret></span></button><div class=dropdown-menu aria-labelledby=dropdownMenuButton><a class=dropdown-item href=# translate="Delete selected transactions" ng-click=deleteTransactions()></a></div></div><button class="btn btn-light btn-setting"><img src=/assets/icons/finance/vat-settings.svg alt=""></button></div></div><div class=content-body><div class="d-flex align-items-center justify-content-between mb-16" ng-repeat="journal in vm.journalList"><label class=check_yellow_20><input type=checkbox ng-model=journal.checked> <span class=checkmark></span></label><div class="input-frame w-136">{{journal.systemTag}}</div><selectbox-input class="w-136 dropdown-primary" ng-model=journal.type options=journalTypes label-field=label value-field=value on-change=changeType(journal)></selectbox-input><div class=has-calendar><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=journal.date> <img src=/assets/icons/bx-calendar-gray.svg alt="" class=calendar_icon></div><selectbox-input class="w-164 dropdown-primary" ng-model=journal.vendor options=journal.vendors label-field=name value-field=_id on-change=changeVendor(journal)></selectbox-input><finance-selectbox-input class="w-192 dropdown-primary" options=journal.finances label-field=label value-field=_id ng-model=journal.finance on-change=changeFinance(journal) finance-type=journal.financeType></finance-selectbox-input><div class="static-input w-192 tx-ellipsis" title={{journal.description}}>{{journal.description}}</div><input type=text number-edit=2 ng-model=journal.amount class="w-136 text-right"><selectbox-input class="w-164 payment-account dropdown-primary" ng-model=journal.accountPlan options=vm.accountPlans label-field=label value-field=_id></selectbox-input></div><div><button class=button-primary ng-click=addTransaction()><img src=/assets/icons/plus.svg alt=""><span translate="Add Transaction"></span></button></div></div><div class=content-footer><div class=d-flex><button class="button-primary green mr-16" ng-click=createPaymentJournal()><img src=/assets/icons/check-mark-white.svg alt=""> <span translate=Approve></span></button> <button class=btn_cancel ui-sref=financeFinance translate=Cancel></button></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-journal/finance-create-reenter-journal/finance-create-reenter-journal.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="finance-create-reenter-journal wide-page"><finance-menu></finance-menu><div class=content-container><spinner ng-if=loading></spinner><div class=content><div class=content-header><div class=title translate="Finance Journal Re-enter Posting"></div><div class=flex-items-center><div class="dropdown mr-16"><button class="btn btn-light dropdown-toggle" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span translate=More></span><span class=caret></span></button><!-- <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">\n               <a class="dropdown-item" href="#" translate="Delete selected transactions" ng-click="deleteTransactions()"></a>\n             </div> --></div><button class="btn btn-light btn-setting"><img src=/assets/icons/finance/vat-settings.svg alt=""></button></div></div><div class=content-body><div class=row ng-repeat="journal in vm.journalList"><div class=col><div class="d-flex mb-16"><div class="input-frame w-112 mr-8">{{journal.systemTag}}</div><div class="has-calendar mr-16"><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=journal.date> <img src=/assets/icons/bx-calendar-gray.svg alt="" class=calendar_icon></div><input type=text class=w-324 placeholder=Description ng-model=journal.description></div><div class=d-flex><label translate=Account class="w-244 mr-16"></label> <label translate=Debit class="w-160 mr-2"></label> <label translate=Credit class=w-160></label></div><div class="d-flex mb-16" ng-repeat="item in journal.items track by $index"><selectbox-input class="w-244 mr-16 dropdown-primary" options=vm.accountPlans label-field=label value-field=_id ng-model=item.accountPlan></selectbox-input><input type=text number-edit class="w-160 mr-2" ng-model=item.debit ng-change=calcSum(journal) ng-disabled=item.credit> <input type=text number-edit class="w-160 mr-2" ng-model=item.credit ng-change=calcSum(journal) ng-disabled=item.debit></div><div class="d-flex mb-8"><div class="ft_14_600_black w-244 mr-16 text-right" style="line-height: 32px">Sum in Total</div><input type=text ng-model=journal.totalDebit number-edit=2 class="w-160 mr-2" ng-disabled=true> <input type=text ng-model=journal.totalCredit number-edit=2 class=w-160 ng-disabled=true></div></div><div class=col></div></div><div class="add-line mb-8"><img src=/assets/icons/plus-gray.svg alt="" class=mr-2> <a href=# ng-click=addTransaction() translate="Add Transaction"></a></div><div class=attach><div class=title translate="Attach File(s)"></div><hr></div><div class="image-row mb-24"><button class=btn-add-image ngf-select ngf-change=fileUpdated($files) name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.objectUrl}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImages.splice($index, 1)"></div></div></div></div><div class=content-footer><div class=d-flex><button class="button-primary mr-16" ng-click=createReJournal()><img src=/assets/icons/check-mark-white.svg alt=""><span translate=Approve></span></button> <button class=btn_cancel ui-sref=financeFinance translate=Cancel></button></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-journal/finance-edit-manual-journal/finance-edit-manual-journal.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class=finance-create-manual-journal><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><div class=content-header><div class=title translate="Finance Journal"></div><div class=flex-items-center><button class="button-primary mr-16" ng-click=addTransaction()><img src=/assets/icons/plus.svg alt=""><span translate="Add Transaction"></span></button><div class="dropdown mr-16"><button class="btn btn-light dropdown-toggle" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span translate=More></span><span class=caret></span></button><div class=dropdown-menu aria-labelledby=dropdownMenuButton><a class=dropdown-item href=# translate="Delete selected transactions" ng-click=deleteTransactions()></a></div></div><button class="btn btn-light btn-setting"><img src=/assets/icons/finance/vat-settings.svg alt=""></button></div></div><div class=content-body><div class="d-flex mb-16" ng-repeat="transaction in vm.journal.transactions"><div class=left><div class="d-flex align-items-center justify-content-between w-100 mb-8"><label class=check_yellow_20><input type=checkbox ng-model=transaction.checked> <span class=checkmark></span></label><div class="value-rect w-72">{{transaction.number | padZeroNumber}}</div><selectbox-input class="w-136 dropdown-primary" ng-model=transaction.type options=journalTypes label-field=label value-field=value on-change=changeType(transaction)></selectbox-input><div class=has-calendar><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=transaction.date> <img src=/assets/icons/bx-calendar-gray.svg alt="" class=calendar_icon></div></div><button class=button-primary style="margin-left: 36px" ng-click=addLine(transaction)><img src=/assets/icons/plus.svg alt=""><span translate="Add Line"></span></button></div><div class=right><div ng-repeat="item in transaction.items track by $index"><div class="d-flex justify-content-between mb-8"><input type=text ng-model=item.description class=w-136><selectbox-input class="w-136 dropdown-primary" ng-model=item.accountPlan1 options=vm.accountPlans short-label-field=number use-short-label=true label-field=label value-field=_id></selectbox-input><selectbox-input class="w-136 dropdown-primary" ng-model=item.vatType options=vm.vatSettings label-field=vatType value-field=_id></selectbox-input><input ng-if="$index === 0" type=text class=w-136 value=Debt. ng-disabled=true> <input ng-if="$index !== 0" type=text class=w-136 number-edit ng-model=item.amount ng-change=calculateSum()> <input ng-if="$index === 0" type=text class=w-136 number-edit ng-model=item.amount ng-change=calculateSum()> <input ng-if="$index !== 0" type=text class=w-136 value=Credit ng-disabled=true><selectbox-input class="w-164 dropdown-primary" ng-model=item.accountPlan2 options=vm.accountPlans label-field=label short-label-field=number use-short-label=true value-field=_id></selectbox-input></div></div><div class="d-flex justify-content-between mb-8"><div class=w-136></div><div class=w-136></div><div class="w-136 ft_14_600_black" style="line-height: 32px">Sum in Total</div><div class="value-rect w-136"><span class=mr-1>{{vm.currency}}</span> <span>{{transaction.debit | readable: 2}}</span></div><div class="value-rect w-136"><span class=mr-1>{{vm.currency}}</span> <span>{{transaction.credit | readable: 2}}</span></div><div class="value-rect w-164"><span class=mr-1>{{vm.currency}}</span> <span>{{transaction.balance | readable: 2}}</span></div></div></div></div></div><div class=content-footer><div class=d-flex><button class="button-primary green mr-16" ng-click=updateManualJournal()><img src=/assets/icons/check-mark-white.svg alt=""> <span translate=Approve></span></button> <button class=btn_cancel ui-sref=financeFinance translate=Cancel></button></div><!--          <div class="d-flex">--><!--            <div class="sum-box">--><!--              <div class="top">--><!--                <div class="info">--><!--                  <div translate="Bank Account"></div>--><!--                  <div class="text-green"><span class="mr-2">{{vm.currency}}</span><span>{{vm.journal.sum.bankAccount | readable: 2}}</span></div>--><!--                </div>--><!--                <div class="info">--><!--                  <div translate="Debit"></div>--><!--                  <div class="text-green"><span class="mr-2">{{vm.currency}}</span><span>{{vm.journal.sum.debit | readable: 2}}</span></div>--><!--                </div>--><!--              </div>--><!--              <div class="bottom">--><!--                <span class="mr-2" translate="Total sum Client"></span>--><!--                <span class="text-green mr-2">{{vm.currency}}</span><span class="text-green">{{vm.journal.sum.totalClient | readable: 2}}</span>--><!--              </div>--><!--            </div>--><!--            <div class="sum-box">--><!--              <div class="top">--><!--                <div class="info">--><!--                  <div translate="Receivables Client"></div>--><!--                  <div class="text-orange"><span class="mr-2">{{vm.currency}}</span><span>{{vm.journal.sum.recvClient | readable: 2}}</span></div>--><!--                </div>--><!--                <div class="info">--><!--                  <div translate="Credit"></div>--><!--                  <div class="text-orange"><span class="mr-2">{{vm.currency}}</span><span>{{vm.journal.sum.credit | readable: 2}}</span></div>--><!--                </div>--><!--              </div>--><!--              <div class="bottom">--><!--                <span class="mr-2">SUM:</span>--><!--                <span class="mr-2">{{vm.currency}}</span><span>{{vm.journal.sum.sum | readable: 2}}</span>--><!--              </div>--><!--            </div>--><!--          </div>--></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-journal/finance-edit-payment-journal/finance-edit-payment-journal.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class=finance-create-payment-journal><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><div class=content-header><div class=title translate="Finance Journal"></div><div class=flex-items-center><div class="dropdown mr-16"><button class="btn btn-light dropdown-toggle" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span translate=More></span><span class=caret></span></button><div class=dropdown-menu aria-labelledby=dropdownMenuButton><a class=dropdown-item href=# translate="Delete selected transactions" ng-click=deleteTransactions()></a></div></div><button class="btn btn-light btn-setting"><img src=/assets/icons/finance/vat-settings.svg alt=""></button></div></div><div class=content-body><div class="d-flex align-items-center justify-content-between mb-16" ng-repeat="transaction in vm.journal.transactions"><label class=check_yellow_20><input type=checkbox ng-model=transaction.checked> <span class=checkmark></span></label><div class="input-frame w-80">{{transaction.number | padZeroNumber}}</div><selectbox-input class="w-136 dropdown-primary" ng-model=transaction.type options=journalTypes label-field=label value-field=value on-change=changeType(transaction)></selectbox-input><div class=has-calendar><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=transaction.date> <img src=/assets/icons/bx-calendar-gray.svg alt="" class=calendar_icon></div><selectbox-input class="w-164 dropdown-primary" ng-model=transaction.vendor options=transaction.vendors label-field=name value-field=_id on-change=changeVendor(transaction)></selectbox-input><selectbox-input class="w-136 dropdown-primary" options=transaction.finances label-field=label value-field=_id ng-model=transaction.finance on-change=changeFinance(transaction)></selectbox-input><div class="static-input w-256">{{transaction.description}}</div><input type=text number-edit ng-model=transaction.amount><selectbox-input class="w-164 payment-account dropdown-primary" ng-model=transaction.accountPlan options=vm.accountPlans label-field=label value-field=_id></selectbox-input></div><div><button class=button-primary ng-click=addTransaction()><img src=/assets/icons/plus.svg alt=""><span translate="Add Transaction"></span></button></div></div><div class=content-footer><div class=d-flex><button class="button-primary green mr-16" ng-click=updatePaymentJournal()><img src=/assets/icons/check-mark-white.svg alt=""> <span translate=Approve></span></button> <button class=btn_cancel ui-sref=financeFinance translate=Cancel></button></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-journal/finance-edit-reenter-journal/finance-edit-reenter-journal.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="finance-create-reenter-journal wide-page"><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><div class=content-header><div class=title translate="Finance Journal Re-enter Posting"></div><div class=flex-items-center><div class="dropdown mr-16"><button class="btn btn-light dropdown-toggle" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span translate=More></span><span class=caret></span></button><!-- <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">\n                <a class="dropdown-item" href="#" translate="Delete selected transactions" ng-click="deleteTransactions()"></a>\n              </div> --></div><button class="btn btn-light btn-setting"><img src=/assets/icons/finance/vat-settings.svg alt=""></button></div></div><div class=content-body><div class=row><div class=col><div class="d-flex mb-16"><div class="input-frame w-72 mr-8">{{vm.journal.number | padZeroNumber}}</div><div class="has-calendar mr-16"><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=vm.journal.date> <img src=/assets/icons/bx-calendar-gray.svg alt="" class=calendar_icon></div><input type=text class=w-324 placeholder=Description ng-model=vm.journal.description></div><div class=d-flex><label translate=Account class="w-204 mr-16"></label> <label translate=Debit class="w-160 mr-2"></label> <label translate=Credit class=w-160></label></div><div class="d-flex mb-16" ng-repeat="item in vm.journal.items track by $index"><selectbox-input class="w-204 mr-16 dropdown-primary" options=vm.accountPlans label-field=label value-field=_id ng-model=item.accountPlan></selectbox-input><input type=text number-edit class="w-160 mr-2" ng-model=item.debit ng-change=calcSum() ng-disabled=item.credit> <input type=text number-edit class="w-160 mr-2" ng-model=item.credit ng-change=calcSum() ng-disabled=item.debit></div><div class="d-flex mb-8"><div class="ft_14_600_black w-204 mr-16 pl-8" style="line-height: 32px">Sum in Total</div><input type=text ng-model=vm.journal.sum.debit number-edit class="w-160 mr-2" ng-disabled=true> <input type=text ng-model=vm.journal.sum.credit number-edit class=w-160 ng-disabled=true></div><div class="add-line mb-8"><img src=/assets/icons/plus-gray.svg alt="" class=mr-2> <a href=# ng-click=addItem() translate="Add Line"></a></div></div><div class=col></div></div><div class=attach><div class=title translate="Attach File(s)"></div><hr></div><div class="image-row mb-24"><button class=btn-add-image ngf-select ngf-change=fileUpdated($files) name=file ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-multiple=true ngf-accept="\'.jpg,.jpeg,.png\'"><img src=/assets/icons/plus-light-gray.svg alt=""></button><div class=images><div class=image-container ng-repeat="file in vm.uploadImages track by $index"><img class=file-thumbnail ng-src={{file.objectUrl}} alt=""><div class=file-name>{{file.name }}</div><img class=delete-icon src=/assets/icons/close-gray-circle-with-border.svg alt="" ng-click="vm.uploadImages.splice($index, 1)"></div></div></div></div><div class=content-footer><div class=d-flex><button class="button-primary mr-16" ng-click=updateReJournal()><img src=/assets/icons/check-mark-white.svg alt=""> <span translate=Approve></span></button> <button class=btn_cancel ui-sref=financeFinance translate=Cancel></button></div></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-vat-setting/finance-create-vat-setting/finance-create-vat-setting.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class=finance-create-vat-setting><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><div class="content-header row"><div class=col-6><div class="ft_18_600_black3 pl-24" translate="Create VAT Setting"></div></div><div class=col-6><div class="ft_18_600_black3 pl-24" translate="Gen. Posting"></div></div></div><div class=content-body><div class="row mb-24"><div class=col-3><div class="ft_14_600_black mb-2 required" translate="VAT Type"></div><input class=input-primary type=text ng-model=vm.vatSetting.vatType></div><div class=col-3><div class="ft_14_600_black mb-2" translate="Sales VAT - Account"></div><selectbox-input class=dropdown-primary options=vm.accountPlans label-field=label value-field=_id ng-model=vm.vatSetting.salesVatAccount></selectbox-input></div><div class=col-3><div class="ft_14_600_black mb-2" translate="Gen. Posting Account Debit"></div><selectbox-input class=dropdown-primary options=vm.accountPlans label-field=label value-field=_id ng-model=vm.vatSetting.postingAccountDebit></selectbox-input></div><div class=col-3><div class="ft_14_600_black mb-2" translate="Gen. Posting Account Credit"></div><selectbox-input class=dropdown-primary options=vm.accountPlans label-field=label value-field=_id ng-model=vm.vatSetting.postingAccountCredit></selectbox-input></div></div><div class="row mb-24"><div class=col-3><div class="ft_14_600_black mb-2 required" translate="VAT Name"></div><input class=input-primary type=text ng-model=vm.vatSetting.vatName></div><div class=col-3><div class="ft_14_600_black mb-2" translate="Purchase VAT - Account"></div><selectbox-input class=dropdown-primary options=vm.accountPlans label-field=label value-field=_id ng-model=vm.vatSetting.purchaseVatAccount></selectbox-input></div></div><div class="row mb-24"><div class=col-3><div class="ft_14_600_black mb-2 required" translate="VAT ID"></div><input class=input-primary type=text ng-model=vm.vatSetting.vatID></div><div class=col-3><div class="ft_14_600_black mb-2" translate="Reverse Charge VAT"></div><selectbox-input class=dropdown-primary options=vm.accountPlans label-field=label value-field=_id ng-model=vm.vatSetting.reverseChargeVat></selectbox-input></div></div><div class=row><div class=col-3><div class="ft_14_600_black mb-2 required" translate="VAT Percent"></div><div class=percentage><input class=input-primary type=text number-edit ng-model=vm.vatSetting.vatPercent><div class=symbol>%</div></div></div></div></div><div class=content-footer><button class="button-primary mr-24" translate=Save ng-click=createVatSetting()></button> <button class=btn_cancel translate=Cancel ui-sref=financeVatSettings></button></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-vat-setting/finance-edit-vat-setting/finance-edit-vat-setting.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class=finance-create-vat-setting><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><div class="content-header row"><div class=col-6><div class="ft_18_600_black3 pl-24" translate="Update VAT Setting"></div></div><div class=col-6><div class="ft_18_600_black3 pl-24" translate="Gen. Posting"></div></div></div><div class=content-body><div class="row mb-24"><div class=col-3><div class="ft_14_600_black mb-2 required" translate="VAT Type"></div><input class=input-primary type=text ng-model=vm.vatSetting.vatType></div><div class=col-3><div class="ft_14_600_black mb-2" translate="Sales VAT - Account"></div><selectbox-input class=dropdown-primary options=vm.accountPlans label-field=label value-field=_id ng-model=vm.vatSetting.salesVatAccount></selectbox-input></div><div class=col-3><div class="ft_14_600_black mb-2" translate="Gen. Posting Account Debit"></div><selectbox-input class=dropdown-primary options=vm.accountPlans label-field=label value-field=_id ng-model=vm.vatSetting.postingAccountDebit></selectbox-input></div><div class=col-3><div class="ft_14_600_black mb-2" translate="Gen. Posting Account Credit"></div><selectbox-input class=dropdown-primary options=vm.accountPlans label-field=label value-field=_id ng-model=vm.vatSetting.postingAccountCredit></selectbox-input></div></div><div class="row mb-24"><div class=col-3><div class="ft_14_600_black mb-2 required" translate="VAT Name"></div><input class=input-primary type=text ng-model=vm.vatSetting.vatName></div><div class=col-3><div class="ft_14_600_black mb-2" translate="Purchase VAT - Account"></div><selectbox-input class=dropdown-primary options=vm.accountPlans label-field=label value-field=_id ng-model=vm.vatSetting.purchaseVatAccount></selectbox-input></div></div><div class="row mb-24"><div class=col-3><div class="ft_14_600_black mb-2 required" translate="VAT ID"></div><input class=input-primary type=text ng-model=vm.vatSetting.vatID></div><div class=col-3><div class="ft_14_600_black mb-2" translate="Reverse Charge VAT"></div><selectbox-input class=dropdown-primary options=vm.accountPlans label-field=label value-field=_id ng-model=vm.vatSetting.reverseChargeVat></selectbox-input></div></div><div class=row><div class=col-3><div class="ft_14_600_black mb-2 required" translate="VAT Percent"></div><div class=percentage><input class=input-primary type=text number-edit ng-model=vm.vatSetting.vatPercent><div class=symbol>%</div></div></div></div></div><div class=content-footer><button class="button-primary mr-24" translate=Save ng-click=updateVatSetting()></button> <button class=btn_cancel translate=Cancel ui-sref=financeVatSettings></button></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-vat-setting/finance-vat-settings/finance-vat-settings.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-vat-settings><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><div><div class=content-header><div class=title translate="VAT Settings"></div><div class=flex-items-center><button class="button-primary mr-8" ui-sref=financeCreateVatSetting><img src=/assets/icons/plus.svg alt=""><span translate="Add New VAT Setting"></span></button> <button class="btn btn-light"><img src=/assets/icons/setting-icon9.svg alt=""></button></div></div><div class=content-body ng-if=chunkedVatList.length><div class=row ng-repeat="chunkedVat in chunkedVatList"><div class=col-6><div class=vat-setting ng-if=chunkedVat[0]><div class="item vat-name">{{chunkedVat[0].vatName}}</div><div class=item><div class="ft_14_600_black mb-2">Type:</div><div class=ft_14_regular_black>{{chunkedVat[0].vatType}}</div></div><div class=item><div class="ft_14_600_black mb-2">ID:</div><div class=ft_14_regular_black>{{chunkedVat[0].vatID}}</div></div><div class=item><div class="ft_14_600_black mb-2" translate=Percent:></div><div class=ft_14_regular_black>{{chunkedVat[0].vatPercent | readable: 2}}%</div></div><div class="item vat-calc"><div class="ft_14_600_black mb-2" translate=Calculation:></div><div class=ft_14_regular_black>Normal VAT</div></div><div class="item vat-edit"><img src=/assets/icons/edit-light.svg alt="" ui-sref="financeEditVatSetting({id: chunkedVat[0]._id})"></div></div></div><div class=col-6><div class=vat-setting ng-if=chunkedVat[1]><div class="item vat-name">{{chunkedVat[1].vatName}}</div><div class=item><div class="ft_14_600_black mb-2">Type:</div><div class=ft_14_regular_black>{{chunkedVat[1].vatType}}</div></div><div class=item><div class="ft_14_600_black mb-2">ID:</div><div class=ft_14_regular_black>{{chunkedVat[1].vatID}}</div></div><div class=item><div class="ft_14_600_black mb-2" translate=Percent:></div><div class=ft_14_regular_black>{{chunkedVat[1].vatPercent | readable: 2}}%</div></div><div class="item vat-calc"><div class="ft_14_600_black mb-2" translate=Calculation:></div><div class=ft_14_regular_black>Normal VAT</div></div><div class="item vat-edit"><img src=/assets/icons/edit-light.svg alt="" ui-sref="financeEditVatSetting({id: chunkedVat[1]._id})"></div></div></div></div></div></div><div ng-if=!chunkedVatList.length class="ft_24_600_gray text-center" translate="No Data to Display"></div><div class=content-footer><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=vm.numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * vm.numPerPage + 1}} - <span ng-if="loading == false">{{(vm.currentPage - 1) * vm.numPerPage + chunkedVatList.length}}</span> of {{vm.totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div><!-- <pagination ng-if="noOfPages" num-pages="noOfPages" current-page="vm.currentPage" on-select-page="fetchData()"></pagination> --></div></div></div></div></main>');
$templateCache.put('app/main/finance/modals/finance-doc-template-modal/finance-doc-template-modal.view.html','<div class="finance-doc-template-modal common-modal"><div class=header><div class=tx-ellipsis>Create Finance Doc</div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class="content pos-relative"><spinner ng-if=isLoading></spinner><div class=row><div class=col-4><div class=mb-24><label translate=Name></label> <input class=input-primary type=text ng-model=vm.financeDocTemplate.name placeholder=Name></div></div><div class=col-4><div class=mb-24><label translate=Description></label> <input class=input-primary type=text ng-model=vm.financeDocTemplate.description placeholder=Description></div></div><div class=col-4><div class=mb-24><label>Search Attributes</label><div class="search-attributes mb-8"><input class=input-primary type=text class=mr-8 ng-model=attrText> <button class="btn btn-search-attr" ng-click=addAttribute()><img src=/assets/icons/tailed-arrow-down-white.svg alt=""></button></div><div class="d-flex flex-wrap"><div class=attr ng-repeat="attr in vm.financeDocTemplate.searchAttributes track by $index"><span>{{attr}}</span> <img src=/assets/icons/close-white.svg alt="" class=cursor-point ng-click="vm.financeDocTemplate.searchAttributes.splice($index, 1)"></div></div></div></div></div><div class="row mb-24"><div class=col-6><label translate="Bank Account"></label><selectbox-input class=dropdown-primary options=vm.bankAccountPlans label-field=label value-field=_id ng-model=vm.financeDocTemplate.bankAccountPlan></selectbox-input></div><div class=col-6><label>Balance Account</label><selectbox-input class=dropdown-primary options=vm.balanceAccountPlans label-field=label value-field=_id ng-model=vm.financeDocTemplate.balanceAccountPlan></selectbox-input></div></div><div class=row><div class=col-6><label>Sales VAT - Account</label><selectbox-input class=dropdown-primary options=vm.vatAccountPlans label-field=label value-field=_id ng-model=vm.financeDocTemplate.vatAccountPlan></selectbox-input><input type=text class="mt-8 input-primary" number-edit=2 placeholder=% ng-model=vm.financeDocTemplate.vatPercent></div><div class=col-6><label>Purchase VAT - Account</label><selectbox-input class=dropdown-primary options=vm.vatAccountPlans label-field=label value-field=_id ng-model=vm.financeDocTemplate.vatAccountPlan2></selectbox-input><input type=text class="mt-8 input-primary" number-edit=2 placeholder=% ng-model=vm.financeDocTemplate.vatPercent2></div></div></div><div class=footer><button class="button-primary mr-16" ng-click=onSave() translate=Save></button> <button class="btn_cancel mr-16" ng-click=onCancel() translate=Cancel></button><selectbox class=dropdown-primary options=vm.templateList label-field=name value-field=_id ng-model=selectedTemplate placeholder=Template to-top=true select-event=changeTemplate()></selectbox></div></div>');
$templateCache.put('app/main/finance/modals/finance-upload-csv-modal/finance-upload-csv-modal.view.html','<div id=finance-upload-csv-modal><div class=header><div class=tx-ellipsis>{{vm.title}}</div><div class=close-icon ng-click=cancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><div class="ft_14_600_gray mb-8" translate="Separator Options"></div><div class="d-flex mb-16"><div class="apply-option mr-16"><radio ng-model=delimiter ng-value="\'semicolon\'"></radio><div class="ft_14_600_gray type-label" translate=">Semicolon"></div></div><div class=apply-option><radio ng-model=delimiter ng-value="\'comma\'"></radio><div class="ft_14_600_gray type-label" translate=Comma></div></div></div><div class="ft_14_600_gray mb-8" translate="Input Method"></div><div class="d-flex mb-16"><div class="apply-option mr-16"><radio ng-model=inputMethod ng-value="\'European et al.\'"></radio><div class="ft_14_600_gray type-label">European et al.</div></div><div class=apply-option><radio ng-model=inputMethod ng-value="\'British/American et al.\'"></radio><div class="ft_14_600_gray type-label">British/American et al.</div></div></div><div class="pos-relative d-flex flex-column mb-16" ngf-drop ngf-change=fileUpdated($files) ngf-multiple=false ngf-pattern=.csv ngf-accept="\'.csv\'"><spinner ng-if=loading></spinner><div class="browse flex-center"><img src=/assets/icons/btn-upload.svg alt=icons> Drag and Drop or <span class="ft-blue-back ph-5" ngf-select ngf-change=fileUpdated($files) ngf-multiple=false ngf-pattern="\'.csv,.txt\'" ngf-accept="\'.csv,.txt\'" translate=Browse></span> to Upload</div></div><div class=preview-table><div class=tbody><div class=tr ng-repeat="row in vm.rows"><div ng-class="getCellClass(row.length, $index)" ng-repeat="cell in row track by $index">{{cell}}</div></div></div></div></div><div class=footer><button class=btn_white ng-click=cancel() translate=Cancel></button> <button class=button-primary ng-click=import() ng-disabled=!vm.rows.length translate=Import></button></div></div>');
$templateCache.put('app/main/finance/modals/finance-upload-entry-modal/finance-upload-entry-modal.view.html','<div id=finance-upload-entry-modal><div class=content ng-if=vm.externEconomic.list.length><div class="d-flex mb-24"><div class=mr-8><div class="ft_14_600_black mb-2" translate="Type Name"></div><input type=text ng-model=vm.externEconomic.name class=w-218 placeholder=Name></div><div class=mr-8><div class="ft_14_600_black mb-2" translate=Description></div><input type=text ng-model=vm.externEconomic.description class=w-512 placeholder=Description></div><div class=mr-8><div class="ft_14_600_black mb-2" translate="Upload Date"></div><div class="has-calendar w-130"><input class=calendar-box placeholder="" date-picker=yyyy-MM-dd date=vm.externEconomic.date> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div><div><div class="ft_14_600_black mb-2" translate=Rule></div><selectbox-input class="w-130 dropdown-primary" options=vm.creditRules label-field=label value-field=value ng-model=vm.externEconomic.creditRule change-trig=changeCreditRule()></selectbox-input></div></div><div class="d-flex mb-8"><div class="ft_14_600_black w-290 mr-10" translate=Account></div><div class="ft_14_600_black w-512 mr-10" translate=Name></div><!-- <div class="ft_14_600_black w-218 mr-10">Client / Vendor</div> --><div class="ft_14_600_black w-130 mr-10" translate=Debit></div><div class="ft_14_600_black w-130" translate=Credit></div></div><div class="d-flex mb-8" ng-repeat="entry in vm.externEconomic.list track by $index"><selectbox-input options=vm.accountPlans label-field=label value-field=_id ng-model=entry.accountPlan class="w-290 mr-8 dropdown-primary"></selectbox-input><input type=text ng-model=entry.vendorName class="w-512 mr-8" ng-disabled=true><!-- <selectbox-input\n        options="vm.vendors"\n        label-field="vendorName"\n        value-field="_id"\n        ng-model="entry.vendor"\n        class="w-218 mr-8"\n        change-trig="changeVendor(entry)"\n      ></selectbox-input> --> <input type=text ng-model=entry.debit number-edit=2 class="w-130 mr-8 text-right" placeholder=Debit ng-change="changeValue(payroll, \'debit\')"> <input type=text ng-model=entry.credit number-edit=2 class="w-130 text-right" placeholder=Credit ng-change="changeValue(payroll, \'credit\')"></div><div class="d-flex mt-16"><div class="ft_14_600_black w-290 mr-10 pl-1" translate=Balance><span>:</span></div><div class="ft_14_600_black w-218 mr-10 pl-1"></div><!-- <div class="ft_14_600_black w-218 mr-10 pl-1"></div> --><div class="ft_14_600_black w-130 mr-10 pl-1 text-right">{{vm.companyData.currentCurrency.symbol}} {{vm.externEconomic.totalDebit | readable: 2}}</div><div class="ft_14_600_black w-130 pl-1 text-right">{{vm.companyData.currentCurrency.symbol}} {{vm.externEconomic.totalCredit | readable: 2}}</div></div></div><div class=no-payroll-data ng-if="!loading && !vm.externEconomic.list.length">No Data</div><div class=no-payroll-data ng-if="loading && !vm.externEconomic.list.length">Loading...</div><div class=footer><div class="d-flex justify-content-end" ng-if=vm.externEconomic.list.length><button class="button-primary mr-16" ng-click=onSave() translate=Save></button> <button class="btn_cancel mr-16" ng-click=onCancel() translate=Cancel></button><selectbox class=dropdown-primary ng-model=selectedTemplate placeholder=Template to-top=true select-event=changeTemplate()></selectbox></div><div class="d-flex justify-content-end" ng-if=!vm.externEconomic.list.length><button class=btn_cancel ng-click=onCancel() translate=Close></button></div></div><spinner ng-if=loading></spinner></div>');
$templateCache.put('app/main/finance/modals/finance-upload-gen-post-modal/finance-upload-gen-post-modal.view.html','<div id=finance-upload-entry-modal><div class=content ng-if=vm.externEconomic.list.length><div class="d-flex mb-24"><div class=mr-8><div class="ft_14_600_black mb-2" translate="Type Name"></div><input type=text ng-model=vm.externEconomic.name class=w-218 placeholder=Name></div><div class=mr-8><div class="ft_14_600_black mb-2" translate=Description></div><input type=text ng-model=vm.externEconomic.description class=w-512 placeholder=Description></div><div class=mr-8><div class="ft_14_600_black mb-2" translate="Upload Date"></div><div class="has-calendar w-130"><input class=calendar-box placeholder="" date-picker=yyyy-MM-dd date=vm.externEconomic.date> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div><div><div class="ft_14_600_black mb-2" translate=Rule></div><selectbox-input class="w-130 dropdown-primary" options=vm.creditRules label-field=label value-field=value ng-model=vm.externEconomic.creditRule change-trig=changeCreditRule()></selectbox-input></div></div><div class="d-flex mb-8"><div class="ft_14_600_black w-16p mr-10" translate=Account></div><div class="ft_14_600_black w-16p mr-10" translate=Code></div><div class="ft_14_600_black w-16p mr-10" translate=Name></div><div class="ft_14_600_black w-16p mr-10" translate="Client / Vendor"></div><div class="ft_14_600_black w-16p mr-10" translate=Debit></div><div class="ft_14_600_black w-16p" translate=Credit></div></div><div class="d-flex mb-8" ng-repeat="entry in vm.externEconomic.list track by $index"><selectbox-input options=vm.accountPlans label-field=label value-field=_id ng-model=entry.accountPlan class="w-16p mr-8 dropdown-primary"></selectbox-input><input type=text ng-model=entry.code class="w-16p mr-8" ng-disabled=true> <input type=text ng-model=entry.vendorName class="w-16p mr-8" ng-disabled=true><selectbox-input options=vm.vendors label-field=vendorName value-field=_id ng-model=entry.vendor class="w-16p mr-8 dropdown-primary" change-trig=changeVendor(entry)></selectbox-input><input type=text ng-model=entry.debit number-edit=2 class="w-16p mr-8 text-right" placeholder=Debit ng-change="changeValue(payroll, \'debit\')"> <input type=text ng-model=entry.credit number-edit=2 class="w-16p text-right" placeholder=Credit ng-change="changeValue(payroll, \'credit\')"></div><div class="d-flex mt-16"><div class="ft_14_600_black w-290 mr-10 pl-1" translate=Balance><span>:</span></div><div class="ft_14_600_black w-218 mr-10 pl-1"></div><!-- <div class="ft_14_600_black w-218 mr-10 pl-1"></div> --><div class="ft_14_600_black w-130 mr-10 pl-1 text-right">{{vm.companyData.currentCurrency.symbol}} {{vm.externEconomic.totalDebit | readable: 2}}</div><div class="ft_14_600_black w-130 pl-1 text-right">{{vm.companyData.currentCurrency.symbol}} {{vm.externEconomic.totalCredit | readable: 2}}</div></div></div><div class=no-payroll-data ng-if="!loading && !vm.externEconomic.list.length">No Data</div><div class=no-payroll-data ng-if="loading && !vm.externEconomic.list.length">Loading...</div><div class=footer><div class="d-flex justify-content-end" ng-if=vm.externEconomic.list.length><button class="button-primary mr-16" ng-click=onSave() translate=Save></button> <button class="btn_cancel mr-16" ng-click=onCancel() translate=Cancel></button><selectbox class=dropdown-primary ng-model=selectedTemplate placeholder=Template to-top=true select-event=changeTemplate()></selectbox></div><div class="d-flex justify-content-end" ng-if=!vm.externEconomic.list.length><button class=btn_cancel ng-click=onCancel() translate=Close></button></div></div><spinner ng-if=loading></spinner></div>');
$templateCache.put('app/main/finance/modals/finance-upload-payroll-modal/finance-upload-payroll-modal.view.html','<div id=finance-upload-payroll-modal><div class=content ng-if=vm.financePayroll.list.length><div class="d-flex mb-24"><div class=mr-8><div class="ft_14_600_black mb-2" translate="Type Name"></div><input type=text ng-model=vm.financePayroll.name class=w-150 placeholder=Name></div><div class=mr-8><div class="ft_14_600_black mb-2" translate=Description></div><input type=text ng-model=vm.financePayroll.description class=w-358 placeholder=Description></div><div class=mr-8><div class="ft_14_600_black mb-2" translate="Payroll Start"></div><div class="has-calendar w-130"><input class=calendar-box placeholder="" date-picker=yyyy-MM-dd date=vm.financePayroll.startDate> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div><div class=mr-8><div class="ft_14_600_black mb-2" translate="Payroll End"></div><div class="has-calendar w-130"><input class=calendar-box placeholder="" date-picker=yyyy-MM-dd date=vm.financePayroll.endDate> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div><div><div class="ft_14_600_black mb-2" translate=Rule></div><selectbox-input class="w-120 dropdown-primary" options=vm.creditRules label-field=label value-field=value ng-model=vm.financePayroll.creditRule change-trig=changeCreditRule()></selectbox-input></div></div><div class="d-flex mb-8"><div class="ft_14_600_black w-290 mr-10" translate=Account></div><div class="ft_14_600_black w-150 mr-10" translate=Description></div><div class="ft_14_600_black w-120 mr-10" translate=Debit></div><div class="ft_14_600_black w-120 mr-10" translate=Credit></div><div class="ft_14_600_black w-120 mr-10" translate=CloudES></div><div class="ft_14_600_black w-80" translate=Type></div></div><div class="d-flex mb-8" ng-repeat="payroll in vm.financePayroll.list track by $index"><selectbox-input options=vm.accountPlans label-field=label value-field=_id ng-model=payroll.accountPlan class="w-290 mr-8 dropdown-primary"></selectbox-input><input type=text ng-model=payroll.description class="w-150 mr-8" placeholder=Description> <input type=text ng-model=payroll.debit number-edit=2 class="w-120 mr-8 text-right" placeholder=Debit ng-change="changeValue(payroll, \'debit\')"> <input type=text ng-model=payroll.credit number-edit=2 class="w-120 mr-8 text-right" placeholder=Credit ng-change="changeValue(payroll, \'credit\')"> <input type=text ng-model=payroll.totalAmount number-edit=2 class="w-120 mr-8 text-right" placeholder=CloudES ng-change="changeValue(payroll, \'balance\')"> <input type=text ng-model=payroll.type class=w-80 placeholder=Type></div><div class="d-flex mt-16"><div class="ft_14_600_black w-290 mr-10 pl-1" translate=Balance><span>:</span></div><div class="ft_14_600_black w-150 mr-10 pl-1"></div><div class="ft_14_600_black w-120 mr-10 pl-1 text-right">{{vm.companyData.currentCurrency.symbol}} {{vm.financePayroll.totalDebit | readable: 2}}</div><div class="ft_14_600_black w-120 mr-10 pl-1 text-right">{{vm.companyData.currentCurrency.symbol}} {{vm.financePayroll.totalCredit | readable: 2}}</div><div class="ft_14_600_black w-120 mr-10 pl-1 text-right">{{vm.companyData.currentCurrency.symbol}} {{vm.financePayroll.totalAmount | readable: 2}}</div><div class="ft_14_600_black w-80 pl-1"></div></div></div><div class=no-payroll-data ng-if=!vm.financePayroll.list.length>No matching account plans were found.</div><div class=footer><div class="d-flex justify-content-end" ng-if=vm.financePayroll.list.length><button class="button-primary mr-16" ng-click=onSave() translate=Save></button> <button class="btn_cancel mr-16" ng-click=onCancel() translate=Cancel></button><selectbox class=dropdown-primary ng-model=selectedTemplate placeholder=Template to-top=true select-event=changeTemplate()></selectbox></div><div class="d-flex justify-content-end" ng-if=!vm.financePayroll.list.length><button class=btn_cancel ng-click=onCancel() translate=Close></button></div></div><spinner ng-if=loading></spinner></div>');
$templateCache.put('app/main/finance/modals/invoice-copy-modal/invoice-copy-modal.view.html','<div class="invoice-copy-modal common-modal"><div class=header><div class=tx-ellipsis translate="Send Copy Invoice"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class="content pos-relative"><spinner ng-if=isLoading></spinner><div class="row mb-16"><div class=col-4><label translate="Client or Vendor" class=mb-8></label><div class=value>{{vm.invoice.vendor.name}}</div></div><div class=col-4><label translate=Staff class=mb-8></label><div class=value>{{vm.invoice.staff.displayName}}</div></div><div class=col-4><label translate=Date class=mb-8></label><div class=value>{{vm.invoice.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div></div><div class="row mb-16"><div class=col-4><label translate="Due Date" class=mb-8></label><div class=value>{{vm.invoice.dueDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class=col-4><label translate="Project ID" class=mb-8></label><div class=value>{{vm.invoice.projectSystemTag}}</div></div><div class=col-4><label translate="Created By" class=mb-8></label><div class=value>{{vm.invoice.createdBy.displayName}}</div></div></div><div class=invoice-detail-table><div class=thead><div class=tr><div class="td no" translate=Sr.No.></div><div class="td type" translate=Type></div><div class="td description" translate=Description></div><div class="td quantity" translate=Quantity></div><div class="td unit-price" translate="Unit Price"></div><div class="td vat-percent" translate="VAT %"></div><div class="td vat-amount" translate=VAT></div><div class="td amount" translate=Amount></div></div></div><div class=tbody><div class=tr ng-repeat="invoiceItem in vm.invoice.items track by $index"><div class="td no">{{ invoiceItem.type.number }}</div><div class="td type">{{ invoiceItem.type.type }}</div><div class="td description">{{ invoiceItem.description }}</div><div class="td quantity">{{ invoiceItem.quantity }}</div><div class="td unit-price"><span ng-if=invoiceItem.unitPrice>{{ invoiceItem.unitPrice | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class="td vat-percent"><span ng-if=invoiceItem.vatPercent>{{ invoiceItem.vatPercent | readable: 2 }}</span></div><div class="td vat-amount"><span ng-if=invoiceItem.vatAmount>{{ invoiceItem.vatAmount | readable: 2 }} {{ companyCurrency.symbol }}</span></div><div class="td amount"><span ng-if=invoiceItem.price>{{ invoiceItem.price | readable: 2 }} {{ companyCurrency.symbol }}</span></div></div></div></div></div><div class=footer><button class="btn_primary mr-16" ng-click=vm.showRecipientsPopup() translate=Send></button> <button class=btn_white ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/main/issues/directives/issue-comment/issue-comment.view.html','<spinner ng-if=loading></spinner><div class=issue-comment ng-if=!loading><img class=issuer ng-src={{ngModel.pic}} alt="" onerror="this.style.display=\'none\';"><div class=comment><div class=comment-body><div><span class="text-blue text-bold">{{ngModel.userName}}</span><span>&nbsp;posted</span></div><div><span class=text-small>{{ngModel.addTime | smartDateTime}}</span></div><div class="mt-10 mb-10">{{ngModel.comment}}</div><div class=attached-files ng-if=ngModel.files.images.length><div class=attached-file ng-repeat="image in ngModel.files.images track by $index"><a href={{image.url}} target=_blank><img class="attached-file-thumbnail thumbnail" ng-src={{image.url}} alt=image title={{image.originalname}}></a></div><div class=attached-file ng-repeat="doc in ngModel.files.docs track by $index"><a href={{doc.secure_url}} target=_blank><img class="attached-file-thumbnail thumbnail" ng-src={{utils.getFileIconFromName(doc.originalname)}} alt=doc title={{doc.originalname}}></a></div></div><div class=flex-start><div ng-if=ngModel.replies.length class=mr-24><div class="cursor-point user-select-none" ng-click=expandReplies()><img class=replies src=/assets/icons/message_blue.svg alt=message> <span class="text-small text-blue">{{ngModel.replies.length}}&nbsp;Comments</span></div></div><div class="cursor-point user-select-none" ng-click=toggleReplyCommentModal()><img class=replies src=/assets/icons/reply-orange.svg alt=message> <span class="text-small text-orange">Reply</span></div></div><hr><div ng-repeat="reply in ngModel.replies" ng-if=ngModel.expand><issue-comment ng-model=reply></issue-comment></div></div><!--    <div class="dropdown user-select-none">--><!--      <button class="dropdown-toggle btn-more" type="button" data-toggle="dropdown" id="more">--><!--        <img class="more" src="/assets/icons/more1.svg" alt="more">--><!--      </button>--><!--      <ul class="dropdown-menu" role="menu" aria-labelledby="more">--><!--        <li class="menu-item" ng-click="toggleReplyCommentModal(ngModel)"><img src="/assets/icons/message-icon.svg" alt="">Reply</li>--><!--      </ul>--><!--    </div>--></div></div>');
$templateCache.put('app/main/issues/directives/issue-history/issue-history.view.html','<div id=issue-history><div class=activity-date><span class=date>{{ngModel.date}}</span></div><div class=activity-list><div class=activity ng-repeat="activity in ngModel.list"><div class=activity-type><img ng-src={{getImage(activity.activity)}}></div><div class=activity-content><div class=activity-body><div ng-bind-html=getHTML(activity)></div><div><span class=text-small translate="Updated By"></span>&nbsp;<span class="text-small text-bold">{{activity.userName}}</span></div></div><div class=activity-time><span>{{activity.addedTime | smartTime}}</span></div></div></div></div></div>');
$templateCache.put('app/main/issues/directives/issue-selectbox/issue-selectbox.view.html','<div class=issue-selectbox><div class=dropdown ng-show=!isClickOpen><div class=backdrop ng-click=closeList() ng-if=isOpen></div><button class=dropdown-toggle type=button ng-click=toggleList() title={{selectedLabel}} ng-disabled="isDisabled == \'true\'">{{selectedLabel}}</button><ul class="dropdown-menu zindex-1005" ng-if=isOpen ng-class="toTop ? \'upward\' : \'\'"><li><a href=# class=menu-item id={{item[valueField]}} data-ng-click=selectItem(item) ng-repeat="item in cOptions" ng-if="options && options!=[]">{{item[labelField]}}</a> <a href=# class=menu-item ng-if="!options || !options.length" translate="No Data"></a> <a class=menu-item ng-click=addItem() ng-if=enableAddItem translate="+ Add"></a></li></ul></div><div class=dropdown ng-show=isClickOpen><div class=backdrop ng-click=closeList() ng-if=isOpen></div><ul class="dropdown-menu zindex-1005" ng-if=isOpen ng-class="toTop ? \'upward\' : \'\'"><li><a href=# class=menu-item id={{item[valueField]}} data-ng-click=selectItem(item) ng-repeat="item in cOptions" ng-if="options && options!=[]">{{item[labelField]}}</a> <a href=# class=menu-item ng-if="!options || !options.length" translate="No Data"></a> <a class=menu-item ng-click=addItem() ng-if=enableAddItem translate="+ Add"></a></li></ul></div></div>');
$templateCache.put('app/main/issues/modals/reply-comment-modal/reply-comment-modal.view.html','<div id=reply-comment-modal><div class=title><div class=tx-ellipsis translate="Reply comment"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><spinner ng-show=loading></spinner><div class=content><div class=mb-20><div class="ft_12_600_gray mb-8" translate="Reply comments"></div><textarea class=w-100 placeholder="Write your comments here" ng-model=commentData.comment></textarea></div><div class="flex mv-10"><img src=/assets/icons/attachment.svg alt="" class="mr-10 cursor-point"> <img src=/assets/icons/icon-@.svg alt="" class=cursor-point ngf-select="" ngf-change=onChangeFiles($files) aria-invalid=false data-wow-delay=0.7s></div><div class="carousel-inner1 row"><div class=carousel-item1 ng-repeat="file in commentData.files track by $index"><a class=image_close_btn><img src=/assets/images/materials/close_yellow.svg alt=icons ng-click=removeFile($index)></a><div class=attach-thumbnail><img ng-show=file.isImage ng-src={{file.imageURL}} class=attach-thumbnail alt=""></div><div class="text-center f_name mb-15">{{file.file.name}}</div></div></div></div><div class=footer><button class="yellow mr-15" ng-click=postComment() translate=Post></button> <button class=gray ng-click=onCancel() translate=Discard></button></div></div>');
$templateCache.put('app/main/mail/directives/setting-menu/setting-menu.view.html','<div id=setting-menu class=nav-items><nav class="navbar navbar-expand-lg navbar-light"><ul class=navbar-nav><li class=nav-item ng-class="{active: currentRoute === \'/setting\'}"><img class=cursor-point src=/assets/icons/person.svg> <a href=# ui-sref=appMailPersonalInfo translate="Personal Info"></a></li><li class=nav-item ng-class="{active: currentRoute === \'/setting/response\'}"><img class=cursor-point src=/assets/icons/message-full.svg> <a href=# ui-sref=appMailResponse translate=Responses></a></li></ul></nav></div>');
$templateCache.put('app/main/mail/modals/createMailHost/createMailHost.view.html','<div id=mailLoginModal><div class=title-black><div class=m-auto>Add Mail Host</div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class=item><div class="ft_12_600_gray mb-8">Name</div><input type=text ng-model=name class=login_input placeholder=Name></div><div class=item><div class="ft_12_600_gray mb-8">IMAP Host</div><input type=text ng-model=imap_server class=login_input placeholder="Imap Host"></div><div class=item><div class="ft_12_600_gray mb-8">IMAP Port</div><input type=number ng-model=imap_port class=login_input placeholder="Imap Port"></div><div class="item d-flex align-items-center mb-20"><checkbox ng-model=imap_tls></checkbox><div class="ft_12_600_gray ml-2">IMAP TLS</div></div><div class=item><div class="ft_12_600_gray mb-8">SMTP Host</div><input type=text ng-model=smtp_server class=login_input placeholder="Smtp Host"></div><div class=item><div class="ft_12_600_gray mb-8">SMTP Port</div><input type=number ng-model=smtp_port class=login_input placeholder="Smtp Port"></div><div class="item d-flex align-items-center mb-20"><checkbox ng-model=smtp_tls></checkbox><div class="ft_12_600_gray ml-2">IMAP TLS</div></div><div class="btnGroup mt-30"><button class=btn_primary ng-click=onSubmit()>Add</button></div></div></div>');
$templateCache.put('app/main/mail/setting/response/response.view.html','<div class=mail-details-container><setting-menu ng-if=!isCompose></setting-menu><div id=mailDetail ng-class="{\'menu-collapse\': isCollapse}"><div class=setting-response-container ng-if=!isCompose><div id=settingResContent><div class=action-button ng-click=createResponse()><img src=/assets/icons/plus-blue.svg alt=icon><span class=create-response translate="Create Response"></span></div><div class=navbar-block><nav class="navbar navbar-expand-lg navbar-light"><ul class=navbar-nav><li class=nav-item ng-repeat="itemResponse in vm.arrResponse" ng-class="{\'active\': $index == vm.currentIndex && vm.currentIndex != -1}"><img src=/assets/icons/message-gray.svg alt=icon> <a href=# ng-click=updateResponse($index) translate={{itemResponse.name}}></a></li></ul></nav></div></div><div id=settingResMain><div class=right><div class=mb-16><label for=name translate=Name></label> <input type=text id=name placeholder=Name ng-model=vm.currentName></div><div class=mb-16><label for=text translate="Response Text"></label> <textarea id=content placeholder="Response Text" ng-model=vm.currentContent></textarea></div><div class=mb-16><label for=text></label><div class=btn-blank><button class="btn-blue mb-16" ng-click=saveResponse()><img src=/assets/icons/save-blue.svg alt=icon><span translate=Save></span></button></div></div></div></div></div><div class=mail-compose-content ng-if=isCompose><mail-compose on-close=onCloseComposer() data="composeType != 0 ? vm.selectedEmail : null" type=composeType is-draft=false></mail-compose></div></div></div>');
$templateCache.put('app/main/orders/directives/filtersPanel/filtersPanel.view.html','<div class=filters-panel><!--  Payment Status --><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'dashboard\' ? \'active\' : \'\'}}"><img class="category-icon mr-16" alt="" src=/assets/icons/sales_dashboard.svg> <span translate=Dashboard></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesProducts\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesProducts\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_products{{activeMenu == \'salesProducts\' ? \'_active\' : \'\'}}.svg"> <span translate=Products></span> <img class="ml-auto collapse-icon" alt="" src="/assets/icons/sales_arrow_drop_down{{activeMenu == \'salesProducts\' ? \'_active\' : \'\'}}.svg"></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'warehouseOrders\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'warehouseOrders\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_warehouse{{activeMenu == \'warehouseOrders\' ? \'_active\' : \'\'}}.svg"> <span translate=Warehouse></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesCustomers\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesCustomers\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_customers{{activeMenu == \'salesCustomers\' ? \'_active\' : \'\'}}.svg"> <span translate=Customers></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesOrders\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesOrders\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_sales_orders{{activeMenu == \'salesOrders\' ? \'_active\' : \'\'}}.svg"> <span translate="Sales Orders"></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'rentalOrders\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'rentalOrders\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_insert_chart_outlined{{activeMenu == \'rentalOrders\' ? \'_active\' : \'\'}}.svg"> <span translate="Rental Orders"></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'projectOrders\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'projectOrders\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_settings{{activeMenu == \'projectOrders\' ? \'_active\' : \'\'}}.svg"> <span translate="Project Orders"></span></div><!-- <div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesPackages\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesPackages\')">\n    <img class="category-icon mr-16" alt="" src="/assets/icons/sales_packages{{activeMenu == \'salesPackages\' ? \'_active\' : \'\'}}.svg">\n    <span translate="Packages"></span>\n  </div> --><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesInvoices\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesInvoices\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_invoices{{activeMenu == \'salesInvoices\' ? \'_active\' : \'\'}}.svg"> <span translate=Invoices></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesPaymentsReceived\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesPaymentsReceived\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_payments_received{{activeMenu == \'salesPaymentsReceived\' ? \'_active\' : \'\'}}.svg"> <span translate="Payments Received"></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'returnOrders\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'returnOrders\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_returns{{activeMenu == \'returnOrders\' ? \'_active\' : \'\'}}.svg"> <span translate=Returns></span> <img class="ml-auto collapse-icon" alt="" src="/assets/icons/sales_arrow_drop_down{{activeMenu == \'returnOrders\' ? \'_active\' : \'\'}}.svg"></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesVendors\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesVendors\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_vendors{{activeMenu == \'salesVendors\' ? \'_active\' : \'\'}}.svg"> <span translate=Vendors></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'purchaseOrders\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'purchaseOrders\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_purchase_orders{{activeMenu == \'purchaseOrders\' ? \'_active\' : \'\'}}.svg"> <span translate="Purchase Orders"></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesBills\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesBills\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_bills{{activeMenu == \'salesBills\' ? \'_active\' : \'\'}}.svg"> <span translate=Bills></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesPaymentsMade\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesPaymentsMade\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_payments_made{{activeMenu == \'salesPaymentsMade\' ? \'_active\' : \'\'}}.svg"> <span translate="Payments Made"></span></div><div class="category flex-items-center pos-relative cursor-point"></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesIntegrations\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesIntegrations\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_integrations{{activeMenu == \'salesIntegrations\' ? \'_active\' : \'\'}}.svg"> <span translate=Integrations></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesReports\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesReports\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_reports{{activeMenu == \'salesReports\' ? \'_active\' : \'\'}}.svg"> <span translate=Reports></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'salesCars\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'salesCars\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_cars{{activeMenu == \'salesCars\' ? \'_active\' : \'\'}}.svg"> <span translate=Cars></span></div><div class="category flex-items-center pos-relative cursor-point {{activeMenu == \'settings\' ? \'active\' : \'\'}}" data-ng-click="gotoPage(\'settings\')"><img class="category-icon mr-16" alt="" src="/assets/icons/sales_settings{{activeMenu == \'settings\' ? \'_active\' : \'\'}}.svg"> <span translate=Settings></span></div></div>');
$templateCache.put('app/main/orders/modals/billScanModal/billScanModal.view.html','<div id=bill-scan-modal><div class=content><div class=title-black><div class=m-auto translate="Bill Scan"></div><div class="mr-8 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content-wrap><div class=header-title><div class=btn-group><div ng-if="vm.project && vm.project._id !== \'all\'" class=btn1 ng-class="isProjectTab() ? \'active\':\'\'" ng-click=vm.onProjectBills() translate="Billing Approval"></div><div class=btn2 ng-class="isCompanyTab() ? \'active\':\'\'" ng-click=vm.onCompanyBills() translate="Company Bills"></div><div class=btn3 ng-class="isPendingTab() ? \'active\':\'\'" ng-click=vm.onPendingBills() translate="Pending Bills"></div><div class=btn4 ng-class="isFailedSyncTab() ? \'active\':\'\'" ng-click=vm.onFailedSync() translate="Failed Sync"></div><div class=btn5 ng-class="isMemoTab() ? \'active\':\'\'" ng-click=vm.onMemo() translate="Vendor Credit Memo"></div></div><div class="flex my-auto mr-25"><button class="btn_primary blue" ng-click=vm.openUploadNewBillModal()><img src=/assets/icons/bx-plus-circle.svg class=mr-10 alt=""> <span translate="Add Bill"></span></button> <button class="btn_primary yellow ml-10" ng-click=vm.saveBillingData(vm.billing)><img src=/assets/icons/save-icon.svg class=mr-10 alt=""> <span translate="Save Bill"></span></button> <button class="btn_primary green ml-10" ng-click=vm.approve()><img src=/assets/icons/check1.svg class=mr-10 alt=""> <span translate=Approve></span></button> <button class="btn_primary red ml-10" ng-click=vm.decline()><img src=/assets/icons/close-circle-red1.svg class=mr-10 alt=""> <span translate=Decline></span></button> <input type=file id=pdf-file accept=.pdf style="display: none" file-change=vm.pdfBrowsed></div></div><div class="sub-header flex-between" ng-if=!isPendingTab()><div class=item><div class="ft_12_600_gray mb-8" translate=Type></div><selectbox-input class=w-200 ng-model=economicTypeId options=vm.economicTypeList label-field=name value-field=_id select-event=vm.selEconomicTypeId(economicTypeId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate=Group></div><selectbox-input class=w-200 ng-model=billingGroupId options=vm.billingGroups label-field=name value-field=_id select-event=vm.selBillingGroupId(billingGroupId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate="VA Orders"></div><selectbox-input class=w-200 ng-model=billingVAOrderId options=vm.vaOrderList label-field=displaySeq value-field=_id select-event=vm.selBillingVAOrderId(billingVAOrderId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate="Invoice No."></div><input type=text class="login_input w-200" ng-model=vm.billing.customSupplierData.invoicenumber></div><div class=item><div class="ft_12_600_gray mb-8" translate="Bill Date"></div><div class="input-group datePicker"><input type=text class="login_input w-200" date-picker="dd MMM yyyy" date=billDate is-open=isBillDatepickerOpen ng-required=true change=updateBillDate()> <span class=dateArrow ng-click="isBillDatepickerOpen = !isBillDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Due Date"></div><div class="input-group datePicker"><input type=text class="login_input w-200" date-picker="dd MMM yyyy" date=dueDate is-open=isDueDatepickerOpen ng-required=true change=updateDueDate()> <span class=dateArrow ng-click="isDueDatepickerOpen = !isDueDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div><div class=mb-25 ng-if=isPendingTab()></div><spinner ng-if=isLoading></spinner><div class=main-content ng-hide=isLoading><div class=left-item><div class=up-item ng-if=vm.billing><div class=ft_14_600_white ng-bind=vm.billing.billNo></div><div class=pdf-pagination ng-show="vm.numPages > 1"><button ng-disabled="vm.currentPageNum <= 1" ng-click=vm.changePageInBill(false)><img src=/assets/icons/arrow-left-white.svg alt=""></button><div class=page-no>{{vm.currentPageNum}}</div><button ng-disabled="vm.currentPageNum >= vm.numPages" ng-click=vm.changePageInBill(true)><img src=/assets/icons/arrow-right-white.svg alt=""></button></div><div><img src=/assets/icons/scan.svg alt="" class=mh-10 ng-click=vm.startOCRProgress(vm.billing)> <img src=/assets/icons/bx-edit-white.svg alt="" ng-click=vm.openEditModal()> <img src=/assets/icons/download-white.svg alt="" class=mh-10 ng-click=vm.downloadInvoice(vm.billing)> <img src=/assets/icons/yellow-printer.svg alt="" class=mr-8 ng-click=vm.printDocument()> <img src=/assets/icons/delete-white.svg alt="" width=24 height=24 ng-click=deleteBilling()></div></div><div class=print><div class=print-content><button class=pre ng-click=vm.changeCanvasPage(false) ng-disabled="currentIndex <= 0"><img src=/assets/icons/left-arrow1.svg alt=""></button><div class="pdf-wrap no-zoom"><spinner ng-if=isLoadBilling></spinner><canvas id=the-canvas ng-hide=isLoadBilling></canvas></div><button class=next ng-click=vm.changeCanvasPage(true) ng-disabled="currentIndex >= vm.billList.length - 1"><img src=/assets/icons/right-arrow1.svg alt=""></button></div><div class=icons ng-if=vm.billing><div class=icon ng-click=vm.zoomCanvas(false)><img src=/assets/icons/zoom-in.svg alt=""></div><div class=icon ng-click=vm.zoomCanvas(true)><img src=/assets/icons/zoom-out.svg alt=""></div></div></div></div><div class=right-item><div class="up-item ft_14_600_black"><div class=text-uppercase>{{vm.billing.vendor.name || vm.billing.vendor.clientName}}</div><div translate="Bank Information"></div></div><div class=content-item><div class=flex><div class=flex-70><div class=ft_12_600_black translate="Address Line 1"></div><div class=ft_12_regular_gray>{{vendorDetail.fullAddress}}</div><div class=ft_12_600_black translate="Address Line 2"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.line2"></div><div class=flex><div class=flex-33><div class=ft_12_600_black translate=City></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.city"></div></div><div class=flex-33><div class=ft_12_600_black translate="Postal Code"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.postalCode"></div></div><div class=flex-33><div class=ft_12_600_black translate="Country Code"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.countryCode"></div></div></div><div class=flex><div class=flex-50><div class=ft_12_600_black translate="Email ID"></div><div class=ft_12_regular_gray ng-bind=vendorDetail.email></div></div><div class=flex-50><div class=ft_12_600_black translate="Phone No."></div><div class=ft_12_regular_gray ng-bind=vendorDetail.phoneNumber></div></div></div><div class=ft_12_600_black translate="VAT Registration No."></div><div class=ft_12_regular_gray ng-bind=vendorDetail.vatNumber></div></div><div class="flex-30 text-right"><div class=ft_12_600_black translate=IBAN></div><div class=ft_12_regular_gray ng-bind=bankDetails.IBAN></div><div class=ft_12_600_black translate=SWIFT></div><div class=ft_12_regular_gray ng-bind=bankDetails.bicCode></div><div class=ft_12_600_black translate="Account No"></div><div class=ft_12_regular_gray ng-bind=bankDetails.accountNumber></div><div class=ft_12_600_black translate=BANK></div><div class=ft_12_regular_gray ng-bind=bankDetails.bankName></div></div></div><div class=table-content><div ng-if=isNormalType(vm.billing) class="header-tr pos-relative"><div class=flex-30 translate=Description></div><div class=flex-10 translate=QTY></div><div class=flex-15 translate="Unit Price"></div><div class=flex-15 translate=Price></div><div class=flex-15><span translate=VAT></span>&nbsp;{{ vendorDetail.vat }} %</div><div class=flex-15 translate="Total Price"></div></div><div ng-if=!isNormalType(vm.billing) class=header-tr><div class=flex-90 translate=Description></div><div class=flex-10 translate=QTY></div></div><div class="text-center mt-20" ng-if="vm.billing && isRunningOCRBill(vm.billing)" translate="OCR for this bill is in progress now. This might take some minutes."></div><div ng-if="!vm.billing || !isRunningOCRBill(vm.billing)" class=ocr-data><div ng-class="vm.billing.customSupplierData.supplies.length > 5? \'table-scroll\': \'\'" scroll-bottom=vm.billing.customSupplierData.supplies><div ng-if=isNormalType(vm.billing) class="main-tr pos-relative" ng-repeat="supply in vm.billing.customSupplierData.supplies track by $index"><div class=loading ng-if=supply.saveMode ng-style="{\'height\': (height - 40) + \'px\'}"><img src=/assets/icons/spinner.gif alt=icons></div><div ng-if=!supply.editMode class=flex-30 title={{supply.description}}><div class=delete-com><div ng-class="{\'dropdown\': true, \'btn-del\': true, \'dropup\': $index > 3}"><button class="dropdown-toggle btn-del" type=button id=menu46 data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu46><li class=menu-item value="" ng-click=vm.onEditItem(supply)><img src=/assets/icons/edit-black.svg alt=""> <span translate=Edit></span></li><li class=menu-item value="" ng-click=vm.onRemoveItem($index)><img src=/assets/icons/delete4.svg alt=""> <span translate=Delete></span></li></ul></div></div><span class=pl-15>{{ supply.description }}</span></div><div ng-if=supply.editMode class=flex-30 title={{supply.description}}><img src=/assets/icons/checkmark-24.svg class=check-mark alt="" ng-click=vm.onCheckEditing($index) ng-disabled=supply.saveMode> <img src=/assets/icons/close-20-dark.svg class=close-mark alt="" ng-click=vm.onCancelEditItem(supply)> <input type=text placeholder=Description class=w-90pct ng-model=editingSupply.description ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class=flex-10>{{ supply.qty }}</div><div ng-if=supply.editMode class=flex-10><input type=number placeholder=Quantity class=text-center ng-model=editingSupply.qty ng-change=vm.changedQtyAndUPrice(supply) ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class=flex-15>{{ supply.unitprice | readable: 2 }}</div><div ng-if=supply.editMode class=flex-15><input type=number placeholder="Unit Price" class=text-right ng-model=editingSupply.unitprice ng-change=vm.changedQtyAndUPrice(supply) ng-disabled=supply.saveMode></div><div class=flex-15>{{ supply.price | readable: 2 }}</div><div class=flex-15>{{ supply.vat | readable: 2 }}</div><div class=flex-15>{{ supply.total | readable: 2 }}</div></div><div ng-if=!isNormalType(vm.billing) class="main-tr pos-relative" ng-repeat="supply in vm.billing.customSupplierData.supplies"><div class=loading ng-if=supply.saveMode ng-style="{\'height\': (height - 40) + \'px\'}"><img src=/assets/icons/spinner.gif alt=icons></div><div ng-if=!supply.editMode class=flex-90 title={{supply.description}}><div class=delete-com><div ng-class="{\'dropdown\': true, \'btn-del\': true, \'dropup\': $index > 3}"><button class="dropdown-toggle btn-del" type=button id=menu47 data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu47><li class=menu-item value="" ng-click=vm.onEditItem(supply)><img src=/assets/icons/edit-black.svg alt=""> <span translate=Edit></span></li><li class=menu-item value="" ng-click=vm.onRemoveItem($index)><img src=/assets/icons/delete4.svg alt=""> <span translate=Delete></span></li></ul></div></div><div class=pl-15>{{ supply.description }}</div></div><div ng-if=supply.editMode class=flex-90 title={{supply.description}}><img src=/assets/icons/checkmark-24.svg class=check-mark alt="" ng-click=vm.onCheckEditing($index) ng-disabled=supply.saveMode> <img src=/assets/icons/close-20-dark.svg class=close-mark alt="" ng-click=vm.onCancelEditItem(supply)> <input type=text placeholder=Description class=w-90pct ng-model=editingSupply.description ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class=flex-10>{{ supply.qty }}</div><div ng-if=supply.editMode class=flex-10><input type=number placeholder=Quantity class=text-center ng-model=editingSupply.qty ng-disabled=supply.saveMode></div></div></div><div class=add-tr ng-click=vm.onAddItem() translate="+ Add New Item"></div><div ng-if=isNormalType(vm.billing) class=bottom-tr><div class=row><div class=col>Price</div><div class=col>{{ vm.billing.amountWithoutTax | readable: 2 }}</div></div><div class=row ng-if=vendorDetail.vat><div class=col><span translate=VAT></span>{{ vendorDetail.vat }} %</div><div class=col>{{ vm.billing.taxAmount | readable: 2 }}</div></div><div class=row><div class=col translate="Total Price"></div><div class=col>{{ vm.billing.totalAmount | readable: 2 }}</div></div></div><div ng-if=!isNormalType(vm.billing) class=bottom-tr><div class=row><div class=col>Price</div><div class=col><div ng-if=!vm.billing.editMode><img src=/assets/icons/edit_gray.svg alt="" ng-click=vm.editAmountWithoutTax()> <span>{{ vm.billing.amountWithoutTax | readable: 2 }}</span></div><div ng-if=vm.billing.editMode class=edit-price><img src=/assets/icons/checkmark-24.svg alt="" ng-click=vm.updateAmountWithoutTax()> <img src=/assets/icons/close-20-dark.svg alt="" ng-click=vm.cancelAmountWithoutTax()> <input type=number placeholder=Price ng-model=vm.billing.amountWithoutTaxTemp ng-change=vm.changeAmountWithoutTax()></div></div></div><div class=row ng-if=vendorDetail.vat><div class=col>VAT {{ vendorDetail.vat }} %</div><div class=col>{{ vm.billing.taxAmount | readable: 2 }}</div></div><div class=row><div class=col>Total Price</div><div class=col>{{ vm.billing.totalAmount | readable: 2 }}</div></div></div><div class=bottom-tr-left><button class="btn btn-dark" translate="Create Order"></button></div></div></div></div></div></div></div></div><div id=ocr-processing-window ng-if=isOCRLoading><img src=/assets/images/cgviewer/cloud_loading.gif></div><spinner ng-if=isDownloading></spinner></div>');
$templateCache.put('app/main/orders/modals/orderDetailModal/orderDetailModal.view.html','<div id=order-detail-modal><div class="d-flex justify-content-end p-3"><img src=/assets/icons/close-gray.svg alt="" class=cursor-point ng-click=onCancel()></div><div class=content><div class="row mb-24"><div class=col-4><div class="ft_12_regular_gray mb-2" translate="Material Name"></div><div class=ft_12_600_black>{{vm.data.name}}</div></div><div class=col-4><div class="ft_12_regular_gray mb-2" translate=Qty></div><div class=ft_12_600_black>{{vm.data.qty}}</div></div><div class=col-4><div class="ft_12_regular_gray mb-2" translate=Price></div><div class=ft_12_600_black>{{vm.data.salesPrice | readable: 2}}</div></div></div><div class="row mb-24"><div class=col-4><div class="ft_12_regular_gray mb-2" translate=Unit></div><div class=ft_12_600_black>{{vm.data.unit}}</div></div><div class=col-4><div class="ft_12_regular_gray mb-2" translate="Qty - Pallet"></div><div class=ft_12_600_black>{{vm.data.itemsPallet}}</div></div><div class=col-4><div class="ft_12_regular_gray mb-2" translate="Material Cost"></div><div class=ft_12_600_black>{{vm.data.materialCost | readable: 2}}</div></div></div><div class="row mb-24"><div class=col-4><div class="ft_12_regular_gray mb-2" translate="Color / Texture"></div><div class="d-flex align-items-center"><div class="color-circle mr-8" ng-style="{background: vm.data.color}"></div><div class=ft_12_regular_black>{{vm.data.color}}</div></div></div><div class=col-4><div class="ft_12_regular_gray mb-2">Pallet Size (L &times; H &times; T)</div><div class=ft_12_600_black>{{vm.data.palletSize.width}} &times; {{vm.data.palletSize.height}} &times; {{vm.data.palletSize.length}}</div></div><div class=col-4><div class="ft_12_regular_gray mb-2" translate="Waste %"></div><div class=ft_12_600_black>{{vm.data.wastePercentage || 0}} %</div></div></div></div><div class=footer><div class="ft_12_600_black mr-16" translate=Refill></div><div class="refill-control mr-16"><div class=value><span class=mr-1>{{vm.data.qty}}</span> <span>{{vm.data.unit}}</span></div><button class=action><img src=/assets/icons/right-arrow1.svg alt=""></button></div><button class="btn btn-black mr-16" translate="Order Pallet"></button> <button class="btn btn-black" translate="Order Fulload"></button></div></div>');
$templateCache.put('app/main/reports/modals/add-sitedoc-modal/add-sitedoc-modal.view.html','<div id=site-doc-modal><div class=header><div class=tx-ellipsis translate="Add Site Document"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-20-addsite.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=d-flex><div class=info><div class="ft_14_600_moreblack required" translate="Date Created"></div><div class="input-group datePicker mb-16"><input type=text class="login_input_new w-100" date-picker=dd/MM/yyyy date=sitedocData.dateCreated is-open=isvalidTillDatepickerOpen ng-required=true placeholder=dd/MM/yyyy> <span class=dateArrow ng-click="isvalidTillDatepickerOpen = !isvalidTillDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div><div class=ft_14_600_moreblack translate="Control Plan Items"></div><div class="w-100 mb-16"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=sitedocData.controlPlanItem options=controlPlanItems label-field=groupName value-field=groupName></selectbox-input></div><div class=ft_14_600_moreblack translate="Add a Tag"></div><div class="w-100 mb-16"><selectbox-input class="arrowbottom_46_400 input-select" ng-model=sitedocData.group options=tagsList label-field=tagName value-field=_id></selectbox-input></div><div class=w-100><div class=ft_14_600_moreblack translate=Description></div><textarea class=w-100 placeholder="Enter your description here" ng-model=sitedocData.description rows=6></textarea></div></div><div class=upload><button data-wow-delay=1.3s ng-if="!FILE_IMAGE && !ICON_IMAGE"><img src=/assets/icons/btn-upload.svg class=upload-icon><div class=ft_16_600_gray translate="Drag & Drop or"></div><div class=ft_16_600_gray><a class=browse ng-model=sitedocData.docFile ngf-select ngf-pattern="\'.pdf\'" ngf-accept="\'.pdf\'" ngf-change=changeFile($files) name=file translate=Browse></a> <span translate="to Upload"></span></div></button> <img ng-if=FILE_IMAGE ng-src={{FILE_IMAGE}} class=doc-image alt="" ngf-select ngf-pattern="\'.pdf\'" ngf-accept="\'.pdf\'" ngf-change=changeFile($files)> <img ng-if=ICON_IMAGE ng-src={{ICON_IMAGE}} class=doc-image alt="" ngf-select ngf-pattern="\'.pdf\'" ngf-accept="\'.pdf\'" ngf-change=changeFile($files)></div></div><div class=footer><div class=radio-group><label class="toggle d-flex mr-20" ng-model=sitedocData.approvalStatus uib-btn-radio="\'Approved\'"><div class="circle mr-10"></div><div class=radio-label translate=Approved></div></label> <label class="toggle d-flex" ng-model=sitedocData.approvalStatus uib-btn-radio="\'Declined\'"><div class="circle mr-10"></div><div class=radio-label translate=Decline></div></label></div><div class=flex-items-center><button class="btn_primary mr-16" ng-click=onSubmit()><img class=mr-8 src=/assets/icons/bx-Upload.svg alt=upload> <span class=ft_12_600_white2 translate=Upload></span></button> <button class=btn_white ng-click=onCancel()><img class=mr-8 src=/assets/icons/trash-alt-black.svg alt=Discard> <span class=ft_12_600_black translate=Discard></span></button></div></div></div></div>');
$templateCache.put('app/main/reports/modals/create-issue-modal/create-issue-modal.view.html','<div id=create-issue-modal><div class=header><div class=tx-ellipsis translate="Create Issue"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=left><div class="d-flex justify-content-between"><div class=issue-image><button data-wow-delay=1.3s ng-if=!FILE_IMAGE><img src=/assets/icons/btn-upload.svg class=upload-icon><div class=ft_11_600_gray translate="Drag & Drop or"></div><div class=ft_11_600_gray><a class=browse ng-model=issueData.uploadImage ngf-select ngf-pattern="\'.jpg,.jpeg,.png,.gif\'" ngf-accept="\'.jpg,.jpeg,.png,.gif\'" ngf-change=changeFile($files) translate=Browse></a> <span translate="to Upload"></span></div></button> <img ng-if=FILE_IMAGE ng-src={{FILE_IMAGE}} class=doc-image alt="issue image" ngf-select ngf-pattern="\'.jpg,.jpeg,.png,.gif\'" ngf-accept="\'.jpg,.jpeg,.png,.gif\'" ngf-change=changeFile($files)></div><div><div class="ft_11_600_gray mb-8 required" translate=Title></div><input type=text class="small-input mb-12" ng-model=issueData.title><div class="ft_11_600_gray mb-8" translate=Admin></div><selectbox-input class=mb-12 options=vm.adminUsers label-field=label value-field=key ng-model=issueData.admin></selectbox-input><div class="ft_11_600_gray mb-8" translate="Assigned To"></div><selectbox-input class=mb-12 options=vm.allRoofers label-field=label value-field=key ng-model=issueData.assignedTo></selectbox-input></div></div><div class="ft_11_600_gray mb-8" translate=Description></div><textarea placeholder="Enter your description here" ng-model=issueData.description class=mb-16></textarea></div><div class=right><div class="ft_11_600_gray mb-8 required" translate="Issue Category"></div><selectbox-input class=mb-12 options=categoryList label-field=label value-field=key ng-model=issueData.issueCategory></selectbox-input><div class="ft_11_600_gray mb-8 required" translate="Select Priority"></div><selectbox-input class=mb-12 options=priorityList label-field=label value-field=key ng-model=issueData.priority></selectbox-input><div class="ft_11_600_gray mb-8 required" translate="Completion Status"></div><selectbox-input class=mb-12 options=statusList label-field=label value-field=key ng-model=issueData.status></selectbox-input><div class="ft_11_600_gray mb-8" translate="Depend On"></div><selectbox-input class=mb-12 options=vm.workTypes label-field=tagName value-field=_id ng-model=issueData.dependencyOn></selectbox-input><div class="ft_11_600_gray mb-8" translate=Deadline></div><div class="input-group datePicker mb-16"><input type=text class="small-input w-256 pl-4" date-picker=dd/MM/yyyy date=issueData.deadLine is-open=isDatepickerOpen ng-required=true> <span class=dateArrow ng-click="isDatepickerOpen = !isDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div><div class=footer><button class=btn_white ng-click=onCancel() translate=Discard></button> <button class=btn_primary ng-click=onSubmit() translate=Create></button></div></div>');
$templateCache.put('app/main/reports/modals/update-checklist-modal/update-checklist-modal.view.html','<div id=update-checklist-modal><div class=header><div class=tx-ellipsis translate="Update Checklist"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class="tx-ellipsis ft_24_600_black"><span>{{vm.checklist.title}}</span></div><hr><div class=bodyScroll><div class="item ft_14_600_black" ng-repeat="item in vm.checklist.checkListItem"><div class="flex-between mb-16"><div class="ft_14_600_black tx-ellipsis">{{item.check}}</div><div class="switch switch-sm"><input type=checkbox class=switch id=checkStatus{{$index}} ng-model=item.checkStatus> <label for=checkStatus{{$index}}></label></div></div><div class="flex-between mb-16"><div class=tx-ellipsis>{{item.accept}}</div><div class="switch switch-sm"><input type=checkbox class=switch id=acceptStatus{{$index}} ng-model=item.acceptStatus> <label for=acceptStatus{{$index}}></label></div></div><div class="flex-between mb-16"><div class=tx-ellipsis translate="Create Issue"></div><div class=flex-items-center><div class="ft_14_regular_gray mr-15" ng-if=item.issueId>{{item.issueSystemTag || item.issueId.systemTag}}</div><div class="switch switch-sm"><input type=checkbox class=switch id=createIssueStatus{{$index}} ng-model=item.createIssueStatus ng-change=onChangeCreateIssueStatus(item)> <label for=createIssueStatus{{$index}}></label></div></div></div><hr></div></div></div><div class=footer><button class=btn_white ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/main/settings/directives/work-types/work-types.view.html','<div id=work-types><div class=work-types-container><div class=draggable ng-repeat="item in items track by $index" ng-style=getItemStyle($index) id=work-type-{{$index}} ng-mousedown=elementMouseDown($event)><div class=content ng-style="{\'background\': COLORS[$index % 9]}">{{item.tagName}} <img src=/assets/icons/close2.svg alt=close ng-click=removeItem($index)></div><div id=work-type-percentage-{{$index}} class=percentage>{{item.percentage}}%</div></div></div></div>');
$templateCache.put('app/main/settings/modals/accountNetChangesModal/accountNetChangesModal.view.html','<div id=accountNetChangesModal><div class=title-black><div class=m-auto translate="Accounts Net Change"></div><div class="mr-10 cursor-point" ng-click=vm.onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><table><thead><tr class=header-tr><th class="flex-20 pl-20" translate="Account No"></th><th class=flex-50 translate=Name></th><th class=flex-30 translate="Net Change"></th></tr></thead></table><div class=table-content><table class="table-wrap w-100"><tbody class=w-100><tr class=item ng-repeat="item in vm.accounts"><th class="flex-20 pl-20">{{item.No}}</th><td class=flex-50>{{item.Name}}</td><td class=flex-30>{{getNetChange(item)}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/main/settings/modals/addDepartmentModal/addDepartmentModal.view.html','<div id=addDepartmentModal><div class=header><div class=tx-ellipsis><span>{{(vm.department._id ? \'Edit\' : \'Create\') | translate}}</span></div><div class=close-icon ng-click=vm.onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class="ft_12_600_black mb-8" translate=Description></div><input type=text ng-model=vm.department.description class="mb-16 login_input_new w-100" autofocus><div class="ft_12_600_black mb-8" translate=Code></div><input type=text ng-model=vm.department.code class="mb-16 text-uppercase login_input_new w-100"></div><div class=footer><button class="btn_cancel mr-3" ng-click=vm.onCancel() translate=Cancel></button> <button class=btn_new_blue ng-click=vm.onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/main/settings/modals/billApprovers/billApprovers.view.html','<div id=billApproversModal><div class=header><div class=tx-ellipsis translate=Edit></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><div class="ft_12_600_gray mb-8" translate="Bill Approver"></div><selectbox2 class="arrowbottom_46_400 mb-20 input-select" ng-model=vm.data.approver._id options=vm.managerList label-field=displayName value-field=_id select-event=vm.onCategory(vm.category)></selectbox2><div class="ft_12_600_gray mb-8" translate="Amount Limit"></div><input class=login_input_new type=text ng-model=vm.data.limit></div><div class="footer mt-16"><button class="btn_cancel mr-16" ng-click=onCancel() translate=Cancel></button> <button class=btn_new_blue ng-click=onSubmit() translate=Update></button></div></div>');
$templateCache.put('app/main/settings/modals/buildingTagModal/buildingTagModal.view.html','<div id=building-tag-modal><div class=title><div class=tx-ellipsis>{{mode}} <span translate="Building Tag"></span></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><spinner ng-show=loading></spinner><div class=content><div class=mb-16><div class="ft_12_600_gray mb-8" translate="Work types"></div><selectbox-input class=arrowbottom_46_400 ng-model=selectedWorkTag options=workTags label-field=tagName value-field=tagName placeholder="Select the work type"></selectbox-input></div><div class=mb-16><label for=percentage class="ft_12_600_gray mb-8" translate=Percentage></label> <input id=percentage type=number min=0 max=100 ng-model=percentage></div><button class="w-100 white mb-16" ng-click=addWorkTag() ng-disabled=!workTags.length translate="Add Type"></button><work-types items=items></work-types></div><div class=footer><button class="yellow mr-15" ng-click=onSave() translate=Update></button> <button class=gray ng-click=onCancel() translate=Discard></button></div></div>');
$templateCache.put('app/main/settings/modals/editCategoryModal/editCategoryModal.view.html','<div id=edit-category-modal><div class=title><div class=tx-ellipsis translate="Edit Tag"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><spinner ng-show=loading></spinner><div class=content><div class=mb-16><div class="ft_12_600_gray mb-8" translate="Category Name"></div><input type=text ng-model=category.categoryName></div><!-- buttons --><div class="d-flex float-right mt-20"><button class="yellow mr-15" ng-click=onSave() translate=Update></button> <button class=gray ng-click=onCancel() translate=Discard></button></div></div></div>');
$templateCache.put('app/main/settings/modals/editEntity/editEntity.view.html','<div id=edit-entity-modal><div class=header><div class=tx-ellipsis translate="Edit Entity"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=mb-16><label class="ft_12_600_black mb-2" translate=Entity></label><input type=text ng-model=vm.entity.name></div><div><label class="ft_12_600_black mb-2" translate=Tag></label><input type=text ng-model=vm.entity.prefix></div></div><div class=footer><button class="button-primary mr-16" ng-click=onSubmit() translate=Update></button> <button class=btn_cancel ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/main/settings/modals/editManager/editManager.view.html','<div id=editManagerModal><div class=title-black><div class=m-auto translate="Edit Manager"></div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class="ft_12_600_gray mb-8" translate="Manager Name"></div><input type=text class="login_input_new mb-20" ng-disabled=true ng-model=employeeName><div class="ft_12_600_gray mb-8" translate=Department></div><selectbox-input class="arrowbottom_46_400 dropdown mb-20 input-select" ng-model=department options=departmentList label-field=name value-field=_id select-event="vm.changeDepartment({name: department})"></selectbox-input><div class="ft_12_600_gray mb-8" translate=Designation></div><selectbox-input class="arrowbottom_46_400 dropdown mb-20 input-select" ng-model=subDesignation options=designationList label-field=name value-field=_id select-event=vm.changedDesignation()></selectbox-input><div class="ft_12_600_gray mb-8" translate=Dashboard></div><selectbox-input class="arrowbottom_46_400 dropdown mb-20 input-select" ng-model=dashboard options=dashboardList label-field=name value-field=_id select-event=vm.changedDesignation()></selectbox-input><div class="btn-group flex-between"><button class=btn_white ng-click=onCancel() translate=Cancel></button> <button class=btn_blue ng-click=onSubmit() translate=Update></button></div></div></div>');
$templateCache.put('app/main/settings/modals/editTagModal/editTagModal.view.html','<div id=edit-tag-modal><div class=title><div class=tx-ellipsis translate="Edit Tag"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><spinner ng-show=loading></spinner><div class=content><div class=mb-16><div class="ft_12_600_gray mb-8" translate="Tag Name"></div><input type=text ng-model=tag.tagName></div><div class=mb-16 ng-show=isLevelCategory><div class="ft_12_600_gray mb-8" translate="Tag Value"></div><input type=number ng-model=tag.tagValue></div><!-- buttons --><div class="d-flex float-right mt-20"><button class="yellow mr-15" ng-click=onSave() translate=Update></button> <button class=gray ng-click=onCancel() translate=Discard></button></div></div></div>');
$templateCache.put('app/main/settings/modals/editWarehouseModal/editWarehouseModal.view.html','<div id=editWarehouseModal><div class=header><div class=tx-ellipsis translate="Edit a warehouse"></div><div class=close-icon ng-click=vm.onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class="ft_12_600_black mb-8" translate="Warehouse Name"></div><input type=text ng-model=vm.warehouse.name class="mb-16 login_input_new w-100"><div class="ft_12_600_black mb-8" translate="Contact Person"></div><input type=text ng-model=vm.warehouse.contactPerson class="mb-16 login_input_new w-100"><div class="ft_12_600_black mb-8" translate="Contact No."></div><input type=text ng-model=vm.warehouse.contactNumber class="mb-16 login_input_new w-100"><div class="ft_12_600_black mb-8" translate=Address></div><input type=text ng-model=vm.warehouse.address class="mb-16 login_input_new w-100"></div><div class=footer><button class="btn_cancel mr-3" ng-click=vm.onCancel() translate=Cancel></button> <button class=btn_new_blue ng-click=vm.onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/main/settings/modals/exportNetChangeModal/exportNetChangeModal.view.html','<div id=exportNetChangeModal><div class=header><div class=tx-ellipsis translate="Export Accounts Net Change"></div><div class=close-icon ng-click=vm.onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class=content><div class="ft_12_600_black mb-8" translate="From Account No"></div><input type=number ng-model=vm.option.fromAcc class=mb-16><div class="ft_12_600_black mb-8" translate="To Account No"></div><input type=number ng-model=vm.option.toAcc class=mb-16><div class="ft_12_600_black mb-8" translate="From Date"></div><div class="input-group datePicker mb-16"><input type=text class=login_input date-picker=dd/MM/yyyy date=vm.option.fromDate is-open=isFromOpen ng-required=true> <span class=dateArrow ng-click="isFromOpen = !isFromOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div><div class="ft_12_600_black mb-8" translate="To Date"></div><div class="input-group datePicker mb-16"><input type=text class=login_input date-picker=dd/MM/yyyy date=vm.option.toDate is-open=isToOpen ng-required=true> <span class=dateArrow ng-click="isToOpen = !isToOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=footer><button class="btn_white mr-3" ng-click=vm.onCancel() translate=Cancel></button> <button class=btn_primary ng-click=vm.onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/main/settings/modals/externalLogsModal/externalLogsModal.view.html','<div id=external-logs-modal><div class=title-black><div class=m-auto>Payment Status Update Operations - {{ vm.isInvoice ? \'Invoices\' : \'Bills\' }}</div><div class="mr-10 cursor-point" ng-click=onCancel()><img src=/assets/icons/close-18-white.svg alt=icons></div></div><div class=content><div class=table-content><table class="table-wrap w-100" ng-show="totalCount !=0"><tbody class=ft_14_regular_black><tr class="ft_14_600_white bg-dark-grey"><td class=p-2 translate=Sr.No.></td><td class=p-2 translate=Date></td><td class=p-2 translate="Job Type"></td><td class="p-2 extern-log" translate="Extern Logs"></td><td class="p-2 updates">{{ vm.isInvoice ? \'Invoices\' : \'Bills\' }} Updated</td></tr><tr ng-repeat="log in vm.logs track by $index"><td class=p-2>{{ $index + (vm.currentPage - 1) * 10 + 1 }}</td><td class=p-2>{{ log.createdAt | date : \'short\' }}</td><td class=p-2>{{ log.jobType }}</td><td class="p-2 extern-log" title={{getExternLog(log)}}>{{ getExternLog(log) }}</td><td class="p-2 updates" title="{{vm.isInvoice ? getInvoiceUpdated(log) : getBillUpdated(log)}}">{{ vm.isInvoice ? getInvoiceUpdated(log) : getBillUpdated(log) }}</td></tr></tbody></table></div><div><pagination num-pages=noOfPages current-page=vm.currentPage on-select-page=vm.loadPage()></pagination></div></div></div>');
$templateCache.put('app/main/settings/modals/paymentInfo/paymentInfo.view.html','<div id=add-payment-info-modal class=common-modal><spinner ng-if=loading></spinner><div class=header><div class=tx-ellipsis>{{vm.isEdit ? \'Update\' : \'Add\'}} Payment Info</div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><div class="content pos-relative"><div class="row mb-24"><div class=col><label translate="Account Holder Name"></label><input class=input-primary type=text ng-model=vm.data.accountName></div></div><div class="row mb-24"><div class=col-6><label translate="Bank Account Number"></label><input class="input-primary mb-24" type=text ng-model=vm.data.accountNumber> <label translate="Bank Name"></label><input class=input-primary type=text ng-model=vm.data.bankName></div><div class=col-6><label translate="Bank Logo"></label><div class="d-flex flex-column" ngf-drop ngf-change=fileUpdated($files) name=file ngf-multiple=false ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-accept="\'.jpg,.jpeg,.png\'"><div class=browse><div ng-if=!vm.fileObjectUrl><div class="d-flex align-items-center mb-8"><img src=/assets/icons/btn-upload.svg alt="upload icon" class=upload-icon><div>Drop files to upload</div></div><div class="d-flex align-items-center justify-content-center"><div>or</div><div class="ft-blue-back ph-5" ngf-select ngf-change=fileUpdated($files) name=file ngf-multiple=false ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-accept="\'.jpg,.jpeg,.png\'" translate=Browse></div></div></div><div ng-if=vm.fileObjectUrl><img ng-src={{vm.fileObjectUrl}} alt="" class=upload-image-thumbnail ngf-select ngf-change=fileUpdated($files) name=file ngf-multiple=false ngf-pattern="\'.jpg,.jpeg,.png\'" ngf-accept="\'.jpg,.jpeg,.png\'"></div></div></div></div></div><div class="row mb-24"><div class=col-6><label translate="IBAN No."></label><input class=input-primary type=text ng-model=vm.data.IBANNumber></div><div class=col-6><label translate="Bank Location"></label><input class=input-primary type=text ng-model=vm.data.bankAddress></div></div><div class="row mb-24"><div class=col-6><label translate="Bank Short Code"></label><input class=input-primary type=text style="text-transform: uppercase" maxlength=2 ng-model=vm.data.bankShortCode></div><div class=col-6><label translate="Registration No."></label><input class=input-primary type=text ng-model=vm.data.registrationNumber></div></div><div class="row mb-24"><div class=col-6><label translate="SWIFT / BIC Code"></label><input class=input-primary type=text ng-model=vm.data.swiftBicCode></div><div class=col-6><label translate="Routing No."></label><input type=text ng-model=vm.data.routingNumber></div></div><div class=row><div class=col-6><label translate="IFSC No."></label><input class=input-primary type=text ng-model=vm.data.ifscNumber></div><div class=col-6><label translate="Bank Routing Code"></label><input class=input-primary type=text ng-model=vm.data.bankRoutingCode></div></div></div><div class=footer><button class="button-primary mr-16" ng-click=onSubmit()>{{(vm.isEdit ? \'Update\' : \'Add\') | translate}}</button> <button class=btn_cancel ng-click=onCancel() translate=Cancel></button></div></div>');
$templateCache.put('app/main/settings/modals/settingSummaryModal/settingSummaryModal.view.html','<div id=settingSummaryModal><div class=header><span translate=Summary></span><div class=cursor-point ng-click=vm.cancel()><img src=/assets/icons/close-24-dark.svg alt=icons></div></div><div class=content><div class=section-title><div class=equations><span translate=Equation></span> ({{vm.equation.name}})</div><div class=op></div><div class=fields translate="Select Fields"></div></div><div class=section-content><textarea class=equations ng-model=vm.equation.expression ng-blur=vm.changeExpression()></textarea><div class="op cursor-point" ng-click=vm.selectFields()><img src=/assets/icons/chevrons-left.svg alt=""></div><div class=fields><div class=field ng-repeat="field in vm.fields" ng-class="{selected: field.selected}" ng-click="field.selected = !field.selected">{{field.number}} {{field.name}}</div></div></div></div><div class=footer><div class=btn-done ng-click=vm.done() translate=Done></div><div class="btn-cancel ml-8" ng-click=vm.cancel() translate=Cancel></div></div></div>');
$templateCache.put('app/main/synergies/directives/synerge-navbar/synerge-navbar.view.html','<div id=synerge-navbar><div class=tabs><div class=tab ng-click=goHome()><img ng-src=/assets/icons/home-d.svg alt=""></div><div class=tab ng-class="{active:selectedTab==TAB.CHAT}" ng-click=changeTab(TAB.CHAT)><img ng-src="{{selectedTab==TAB.CHAT ? \'/assets/icons/message-f.svg\' : \'/assets/icons/message-d.svg\'}}" alt=""></div><div class=tab ng-class="{active:selectedTab==TAB.CALL}" ng-click=changeTab(TAB.CALL)><img ng-src="{{selectedTab==TAB.CALL ? \'/assets/icons/call-f.svg\' : \'/assets/icons/call-d.svg\'}}" alt=""></div><div class=tab ng-class="{active:selectedTab==TAB.MEETINGS}" ng-click=changeTab(TAB.MEETINGS)><img ng-src="{{selectedTab==TAB.MEETINGS ? \'/assets/icons/meeting-f.svg\' : \'/assets/icons/meeting-d.svg\'}}" alt=""></div><div class=tab ng-class="{active:selectedTab==TAB.CONTACTS}" ng-click=changeTab(TAB.CONTACTS)><img ng-src="{{selectedTab==TAB.CONTACTS ? \'/assets/icons/contact-f.svg\' : \'/assets/icons/contact-d.svg\'}}" alt=""></div></div><div class=title>CloudES</div><div class=side-area><div class="mr-20 search-wrap"><img src=/assets/icons/search-gray.svg alt="" class=search-icon> <input type=text class=search ng-model=searchText placeholder="Search by Keyword"></div><div class="dropdown user-menu"><button id=user-menu-button class=dropdown-toggle data-toggle=dropdown><div class="pos-relative inline-block"><img ng-src="{{ profilePic || \'/assets/icons/bx-user.svg\'}}" alt=logo class="avatar-logo object-fit-cover"><div class=status-circle ng-class=statusClass()></div></div></button><ul class=dropdown-menu aria-labelledby=user-menu-button><div class=dropdown-item-avatar><img ng-src="{{ profilePic || \'/assets/icons/bx-user.svg\'}}" alt=logo class="dropdown-avatar-logo object-fit-cover"><div><div class="ft_14_600_black tx-ellipsis avatar-label" title={{userName}}>{{userName}}</div><div class="ft_12_regular_black tx-ellipsis avatar-label" title={{email}}>{{email}}</div></div></div><li class="dropdown-item ft_14_regular_black" ng-click=toggleEditProfile()><img src=/assets/icons/edit-black-no-rect.svg class=avatar-menu-icon alt=profile> <span translate="Edit My Details"></span></li><li class="dropdown-item ft_14_regular_black" ng-click=toggleUpdateStatus()><img src=/assets/icons/build_circle.svg class=avatar-menu-icon alt=status> <span translate="Update My Status"></span></li><li class="dropdown-item ft_14_regular_black" ng-click="gotoPage(\'settingsGeneral\', SETTING_ACCESS_CREATE > 0, true)"><img src=../../../../../assets/images/dashboard/bx-cog.svg class=avatar-menu-icon alt=setting> <span translate=Settings></span></li><li class="dropdown-item ft_14_regular_black" ng-click=toggleHelp()><img src=/assets/icons/help_circle.svg class=avatar-menu-icon alt=help> <span translate=Help></span></li><li class="dropdown-item ft_14_regular_black border-top" ng-click=logout()><img src=../../../../../assets/images/dashboard/log-out.svg class=avatar-menu-icon alt=logout> <span translate="Sign Out"></span></li></ul></div></div></div>');
$templateCache.put('app/main/synergies/modals/createMeetingRoomModal/createMeetingRoomModal.view.html','<div id=create-meeting-room-modal><div class=header><div class=tx-ellipsis>{{vm.isCreate ? \'New Meeting Room\' : \'Update Meeting Room\'}}</div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-16.svg alt=icons></div></div><spinner ng-if=loading></spinner><div class=content><div class=mb-16><label for=title class="ft_12_500_gray mb-8 required" translate="Meeting Room Title"></label> <input id=title type=text ng-model=meetingRoom.title></div><div class=mb-16><label for=description class="ft_12_500_gray mb-8" translate=Description></label> <textarea id=description type=text ng-model=meetingRoom.description></textarea></div><div class="mb-16 flex-between"><div class=w-50><label class="ft_12_500_gray mb-8 required" translate="Start Time"></label> <input type=text id=start-date-input readonly data-widget-control></div><div class=w-50><label class="ft_12_500_gray mb-8 required" translate="End Time"></label> <input type=text id=end-date-input readonly data-widget-control></div></div><div class=mb-16><label for=assigned-to class="ft_12_500_gray mb-8 required" translate="Assigned To"></label><div class="flex-between w-100"><selectbox-input id=assigned-to class=w-100 options=vm.inviteMembers label-field=displayName value-field=_id ng-model=selectedMemberId></selectbox-input><img src=/assets/icons/plus-circle-orange.svg alt=icons ng-click=addMember() class=add-btn></div></div><div class=members-container><div class=member ng-repeat="member in meetingRoom.assignedTo track by $index"><div>{{member._id === vm.userData._id ? \'You\' : member.displayName}}</div><img ng-if="member._id !== vm.userData._id" src=/assets/icons/close-16.svg alt="" ng-click=removeMember($index)></div></div></div><div class=footer><button class=btn_white ng-click=onCancel() translate=Cancel></button> <button class=btn_primary ng-click=onSubmit() translate=Ok></button></div></div>');
$templateCache.put('app/main/timeline/directives/flowline/flowline.view.html','<div id=flowline><div class=level-axis><div class=title translate=Floors></div><div ng-repeat="section in selectedSections"><div class=level ng-repeat="level in section.levels" ng-style="{height: levelHeight + \'px\'}">{{level.text}}</div></div></div><div class=main-axis><div class=date-header><div class=d-flex ng-repeat="date in dates"><div><div class=month>{{date.title}}</div><div class=d-flex><div class=day ng-repeat="day in date.days" ng-style="getDayStyle(date.year, date.month, day)">{{day}}</div></div></div></div></div><div id=chart-container><div class=d-flex ng-repeat="date in dates"><div ng-repeat="day in date.days" ng-style="getDayStyle(date.year, date.month, day)"><div ng-repeat="section in selectedSections"><div class=blank ng-repeat="level in section.levels" ng-style="{width: dayWidth + \'px\', height: levelHeight + \'px\'}"></div></div></div></div><canvas id=flow-canvas></canvas><div id=labels-container></div></div></div><div class=section-axis><div class=title translate=Sections></div><div ng-repeat="section in selectedSections"><div class=section ng-style="{height: levelHeight * section.levels.length + \'px\'}">{{section.text}}</div></div></div></div>');
$templateCache.put('app/main/timeline/directives/miniGantt/miniGantt.view.html','<div class=combined-tasks><div ng-repeat="task in ganttTasks track by $index" class=combine-cell id=combine-cell-{{$index}} ng-style=getCellStyle($index)><div class="cell-body tx-ellipsis" ng-mousedown=elementMouseDown($event) ng-style="{\'background\': COLORS[$index % 12]}">{{ task.text }}</div><div class=percentage ng-if="$index < ganttTasks.length - 1" id=combine-cell-percentage-{{$index}}>{{ ganttTasks[$index + 1].percentage }}%</div></div></div>');
$templateCache.put('app/main/timeline/directives/modelViewer/modelViewer.view.html','<div id=timeline-model-viewer><div id=timeline-model-view class="model-content no-zoom"></div><div class=control ng-if="data.modelType === \'3d\'" ng-click=playModel()><img src=/assets/icons/play_circle_outline-white.svg alt=Play></div><div id=timeline-model-viewer-loading class=loading><img src=/assets/images/cgviewer/cloud_loading.gif alt=Loading></div></div>');
$templateCache.put('app/main/timeline/directives/notifications-box/notifications-box.view.html','<div id=timeline-right-sidebox-notifications><div class=header><div class=brand><div class=delete ng-click=deleteNotifications()><img src=/assets/images/timeline/trash-notifications.svg alt="trash icon"></div><h4 class=title translate=Notifications></h4></div><div class=close-icon><img src=/assets/icons/close-12-gray.svg alt="close icon" ng-click=onClose()></div></div><div class=content-container><div class=content><div class=notifications-wrapper><div ng-if="notifications.length === 0"><div class=notification><div class=notify-content><h5 class=notify-message translate="New Notification data will be Added"></h5></div></div></div><div ng-if="notifications.length !== 0" class=notification ng-repeat="notification in notifications track by $index"><div class=read-status></div><div class=notify-content><h5 class=notify-message>{{notification}}</h5></div></div></div></div></div><div class=footer><span ng-click=markAsRead() translate="Mark all as read"></span></div></div>');
$templateCache.put('app/main/timeline/directives/task-comment/task-comment.view.html','<spinner ng-if=loading></spinner><div class=task-comment ng-if=!loading ng-class="{\'mt-0\': isFirst}"><img class=author ng-src={{ngModel.user.profilePic}} alt="" onerror="this.style.display=\'none\';"><div class=comment><div class=comment-body><div class="flex-items-center flex-between"><div class=ft_12_600_dark_black>{{ngModel.user.firstName + \' \' + ngModel.user.lastName}}</div><div class=text-small>{{ngModel.createdAt | smartDateTime}}</div></div><div class="mt-2 mb-2">{{ngModel.comment}}</div><div class=attached-files ng-if=ngModel.files.images.length><div class=attached-file ng-repeat="image in ngModel.files.images track by $index"><a href={{image.url}} target=_blank><img class="attached-file-thumbnail thumbnail" ng-src={{image.url}} alt=image></a></div></div><div class=flex-start><div class="cursor-point user-select-none mr-3" ng-click=expandReplies() ng-if=ngModel.replies.length><img class=replies src=/assets/icons/message_orange.svg alt=message> <span class=text-small>{{ngModel.replies.length}}&nbsp;</span> <span class=text-small translate=Comments></span></div><div class="cursor-point user-select-none" ng-click=toggleReplyCommentModal()><img class=replies src=/assets/icons/reply-orange.svg alt=message> <span class=text-small translate=Reply></span></div></div><div ng-repeat="reply in ngModel.replies" ng-if=ngModel.expand><task-comment ng-model=reply task-id=taskId fetch-comments=fetchComments()></task-comment></div></div></div></div>');
$templateCache.put('app/main/timeline/directives/timeline-selectbox/timeline-selectbox.view.html','<div class=timeline-selectbox><div class=dropdown ng-show=!isClickOpen><div class=backdrop ng-click=closeList() ng-if=isOpen></div><button class=dropdown-toggle type=button ng-click=toggleList() title={{selectedLabel}} ng-class=getColorClass() ng-disabled="isDisabled == \'true\'">{{selectedLabel}}</button><ul class="dropdown-menu zindex-1005" ng-if=isOpen ng-class="toTop ? \'upward\' : \'\'"><li><a href=# class=menu-item id={{item[valueField]}} data-ng-click=selectItem(item) ng-repeat="item in cOptions" ng-if="options && options!=[]">{{item[labelField]}}</a> <a href=# class=menu-item ng-if="!options || !options.length">No Data</a></li></ul></div><div class=dropdown ng-show=isClickOpen><div class=backdrop ng-click=closeList() ng-if=isOpen></div><ul class="dropdown-menu zindex-1005" ng-if=isOpen ng-class="toTop ? \'upward\' : \'\'"><li><a href=# class=menu-item id={{item[valueField]}} data-ng-click=selectItem(item) ng-repeat="item in cOptions" ng-if="options && options!=[]">{{item[labelField]}}</a> <a href=# class=menu-item ng-if="!options || !options.length" translate="No Data"></a></li></ul></div></div>');
$templateCache.put('app/main/timeline/directives/weathers-box/weathers-box.view.html','<div id=timeline-right-sidebox-weathers><div class=header><div class=brand></div><div class=close-icon><img src=/assets/icons/close-12-gray.svg alt="close icon" ng-click=onClose()></div></div><div class=content-container><div class=content><div ng-repeat="weather in weatherList"><div class=weather-container ng-repeat="data in weather.threeHour"><div class=weather ng-class=data.class><div class="d-flex justify-content-between w-100"><div class=info><img ng-src={{data.icon}} alt="weather icon"><div class=condition-temp><h5 class=condition ng-bind-html=data.condition></h5><div class=temp><h2 class=max ng-bind-html=data.maxTemp></h2><div><h2 class=max>\xB0</h2><h6 class=min>{{data.minTempString}}</h6></div></div></div></div><div class=datetime><h5 class=date ng-bind-html="weather.date | fullDate"></h5><h4 class=time>{{data.timeString}}</h4></div></div><div class="d-flex align-items-center justify-content-between"><div class=item><img src=/assets/images/timeline/weather-precipitation.svg alt=precipitation><h6>{{data.precipitation}}m</h6></div><div class=item><img src=/assets/images/timeline/weather-velocity.svg alt=weather-velocity><h6>{{data.velocity}}m/s</h6></div><div class=item><img src=/assets/images/timeline/weather-wind-direction.svg alt=weather-wind-direction><h6>{{data.direction}}</h6></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/timeline/directives/workers-box/workers-box.view.html','<div id=timeline-right-sidebox-workers><div class=header><div class=brand><div class=delete><img src=/assets/images/timeline/trash-workers.svg alt="trash icon"></div><h4 class=title translate=Members></h4></div><div class=close-icon><img src=/assets/icons/close-12-gray.svg alt="close icon" ng-click=onClose()></div></div><div class=content-container><div class=content><div class=worker ng-repeat="worker in workers"><img class=avatar ng-src="{{worker.profilePic ? worker.profilePic : \'/assets/images/timeline/avatar.svg\'}}"><div class=profile><h5 class=name>{{worker.displayName}}</h5><p class=phone>{{worker.mobile.dialCode}}{{worker.mobile.phoneNumber}}</p><span class=type>{{worker.designation || \'None\'}}</span></div></div></div></div></div>');
$templateCache.put('app/main/timeline/modals/addTaskModal/addTaskModal.view.html','<div id=timeline-add-task><div class=title><div class=tx-ellipsis translate="Add Task"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><!-- Task Type --><div class="d-flex align-items-center mb-4"><div class=d-flex><label class="toggle d-flex mr-15" ng-model=vm.taskType uib-btn-radio="\'Main\'" ng-click=vm.selectTaskType()><div class="circle mr-10"><div class=circle-kernel></div></div><div class=radio-label translate="Main Task"></div></label> <label class="toggle d-flex" ng-model=vm.taskType uib-btn-radio="\'Sub\'" ng-click=vm.selectTaskType()><div class="circle mr-10"><div class=circle-kernel></div></div><div class=radio-label translate="Sub Task"></div></label></div></div><!-- Task Name --><div class=mb-4><div class="ft_12_500_gray mb-2 required" translate="Task Name"></div><input class=login_input_new type=text placeholder="Enter the task name" ng-model=vm.taskName></div><!-- Select Main Task when selected sub task --><div class=mb-4 ng-if="vm.taskType === \'Sub\'"><div class="ft_12_500_gray mb-2 required" translate="Main Task"></div><selectbox-input class=arrowbottom_46_400 ng-model=vm.mainTaskId options=vm.mainTasks label-field=text value-field=id placeholder="Select Main Task" select-event=vm.selectMainTask()></selectbox-input></div><!-- Start & Due Date --><div class="flex-between mb-4"><div class=has-calendar><div class="ft_12_500_gray mb-2 required" translate="Start Date"></div><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=vm.startDate> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div><div class=has-calendar><div class="ft_12_500_gray mb-2 required" translate="Due Date"></div><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=vm.endDate> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div><!-- Task Dependency --><div class=mb-4><div class="ft_12_500_gray mb-2" translate="Task Dependency"></div><selectbox-input class=arrowbottom_46_400 ng-model=vm.dependency options=vm.dependencyTasks label-field=text value-field=id placeholder="Select the task dependent on"></selectbox-input></div><!-- Add Resource --><div class=mb-4><div class="ft_12_500_gray mb-2" translate="Add Resource"></div><div class=flex-between><selectbox-input class="mr-10 w-100" type=text ng-model=vm.resourceType placeholder="Select Resource Type" options=vm.resourceTypes label-field=name value-field=id select-event=vm.selectResourceType(vm.resourceType)></selectbox-input><selectbox-input class="mr-10 w-90" type=text ng-model=vm.resourceId placeholder="Select Resource" options=vm.resources label-field=name value-field=_id></selectbox-input><button class=btn_new_blue ng-click=vm.addResource() translate=Add></button></div></div><!-- Resources --><div class=resource-container ng-if=vm.selectedWorkers.length><div class=resource ng-repeat="worker in vm.selectedWorkers.slice(0,4) track by $index"><img class=avatar ng-src="{{worker.profilePic || \'/assets/icons/bx-user.svg\'}}" alt=""> <img class=delete src=/assets/icons/close-circle-red1.svg alt="" ng-click=vm.removeResource($index)></div><div ng-if="vm.selectedWorkers.length > 4" class=resource-plus>+{{ vm.selectedWorkers.length - 4 }}</div></div><!--    Level & Type --><div class="flex-between mb-4"><div><div class="ft_12_500_gray mb-2 required" translate=Level></div><selectbox-input class="arrowbottom_46_400 w-185" ng-model=vm.workLevel options=vm.workLevels label-field=tagName value-field=tagName placeholder="Select the level"></selectbox-input></div><div><div class="ft_12_500_gray mb-2 required" translate=Type></div><selectbox-input class="arrowbottom_46_400 w-185" ng-model=vm.workType options=vm.workTypes label-field=tagName value-field=tagName placeholder="Select the Type"></selectbox-input></div></div><!-- Description --><div class=mb-4><div class="ft_12_500_gray mb-2" translate=Description></div><textarea class=w-100 placeholder="Write some description (optional)" ng-model=vm.description></textarea></div><!-- buttons --><div class="d-flex mt-4"><button class="btn_new_blue ml-auto mr-16" ng-click=onAdd() translate="Add Task"></button> <button class="btn_new_blue client_gray_back" ng-click=onCancel() translate=Discard></button></div></div></div>');
$templateCache.put('app/main/timeline/modals/addWorkerModal/addWorkerModal.view.html','<div id=timeline-add-worker><div class=header><div class="title ml-20" translate="Add Member"></div><div class="mr-20 cursor-point close-icon" ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div class="timeline-input mb-20"><div class="ft_12_600_gray mb-8" translate=Department></div><div class=w-100><selectbox-input class=arrowbottom_46_400 ng-model=vm.workerType options=vm.workerTypes label-field=value value-field=key select-event=vm.selectWorkerType(vm.workerType) placeholder="Select Department"></selectbox-input></div></div><div class="timeline-input mb-30"><div class="ft_12_600_gray mb-8" translate=Member></div><div class=w-100><selectbox-input class=arrowbottom_46_400 ng-model=vm.selectedWorkerId options=vm.availableWorkers label-field=name value-field=_id placeholder="Select Member"></selectbox-input></div></div><button class="w-100 mb-20 add-member" ng-click=vm.selectWorker(vm.selectedWorkerId) translate="Add Member"></button><div class="ft_12_600_gray mb-8" translate="List of Existing Members"></div><div class=tag-wrapper><div class=tag style="z-index: 100" ng-repeat="worker in vm.selectedWorkers track by $index"><img class=profile-pic ng-src="{{ worker.profilePic ? worker.profilePic : \'/assets/icons/bx-user.svg\'}}" onerror="this.src=\'/assets/icons/bx-user.svg\'"><div class=ml-10><div class=name>{{ worker.name }}</div><div class=desc>{{ worker.designation }}</div></div><img class=btn-delete src=/assets/icons/close-12-gray.svg alt=close ng-click=vm.removeWorker($index)></div></div><div class="btn-group mt-20 d-flex"><button class="gray ml-auto mr-10" ng-click=onCancel() translate=Cancel></button> <button class=yellow ng-click=onAdd() translate=Add></button></div></div></div>');
$templateCache.put('app/main/timeline/modals/combineTaskModal/combineTaskModal.view.html','<div id=timeline-combine-task><div class=header><div class=title translate="Combine Task"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div class=mb-16><div class="ft_12_600_gray mb-8 required" translate="Task List"></div><div class=task-list><div class=task-row ng-repeat="task in vm.availableTasks"><div class=task-check><label class=check_yellow_20><input type=checkbox ng-model=task.checked><span class=checkmark></span></label></div><div class=task-name>{{task.text}}</div></div></div></div><div class=mb-16><div class="ft_12_600_gray mb-8" translate=Percentage></div><input class=login_input_new type=number min=0 max=100 ng-model=vm.percentage></div><button class="btn_new_blue w-100 white mb-16" ng-click=vm.addTask() translate="Add Task"></button><mini-gantt gantt-tasks=vm.tasks></mini-gantt><!--    Task Name --><div class=mb-16><div class="ft_12_600_gray mb-8 required" translate="Add Name"></div><input class=login_input_new type=text placeholder=Name ng-model=vm.taskName></div><!--    Description --><div class=mb-16><div class="ft_12_600_gray mb-8" translate=Description></div><textarea class=w-100 placeholder="Write some description (optional)" ng-model=vm.description></textarea></div><!-- buttons --><div class="d-flex float-right mt-20"><button class="btn_new_blue mr-16" ng-click=onSave() translate=Combine></button> <button class="btn_new_blue client_gray_back" ng-click=onCancel() translate=Discard></button></div></div></div>');
$templateCache.put('app/main/timeline/modals/editCombineTaskModal/editCombineTaskModal.view.html','<div id=timeline-edit-combine-task><div class=header><div class=title translate="Edit Combined Task"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div ng-if=vm.isEdit><div class=mb-16><div class="ft_12_600_gray mb-8 required" translate="Task List"></div><div class=task-list ng-if="vm.availableTasks.length !== 0"><div class=task-row ng-repeat="task in vm.availableTasks"><div class=task-check><label class=check_yellow_20><input type=checkbox ng-model=task.checked> <span class=checkmark></span></label></div><div class=task-name>{{task.text}}</div></div></div><div class=no-tasks ng-if="vm.availableTasks.length == 0" translate="No available tasks"></div></div><div class=mb-16><div class="ft_12_600_gray mb-8" translate=Percentage></div><input type=number min=0 max=100 ng-model=vm.percentage></div><div class="button w-100 white mb-16" ng-click=vm.addTask() translate="Add Task"></div></div><mini-gantt gantt-tasks=vm.tasks></mini-gantt><!-- buttons --><div class="flex-around mt-20"><div class="button yellow mr-15" ng-click=onEdit() ng-if=!vm.isEdit translate=Edit></div><div class="button yellow mr-15" ng-click=onCombine() ng-if=vm.isEdit translate=Combine></div><div class="button white mr-15" ng-click=onUncombine() ng-if=!vm.isEdit translate=Uncombine></div><div class="button gray" ng-click=onSave() translate=Close></div></div></div></div>');
$templateCache.put('app/main/timeline/modals/editTaskModal/editTaskModal.view.html','<div id=timeline-edit-task><div class=title><div class=project-name>{{ vm.project.projectName }} <span translate=Project></span></div><img src=/assets/icons/close-12-gray.svg alt=icons ng-click=onCancel()></div><spinner ng-if=loading></spinner><div class=content ng-if=vm.task><div ng-if=vm.task.parent><span class=ft_12_600_yellow translate="Parent Task"></span>:&nbsp; <span class=ft_12_600_black>{{vm.task.parent.name}}</span></div><div class=ft_18_600_black3>{{vm.task.name}}</div><div><span class=ft_12_regular_gray ng-if=vm.task.owner translate="Created by"></span>&nbsp; <span class=ft_12_600_gray ng-if=vm.task.owner>{{vm.task.owner.displayName}}. </span><span class=ft_12_regular_gray>Last updated on {{Date(vm.task.updatedAt) | smartDateTime}}</span></div><div class=task-progress id=progress ng-style=vm.progressStyle ng-if=!vm.isMainEstimate><div id=progress-bar class=progress ng-style=vm.progressBarStyle></div><div class=value><input id=progress-value type=number min=0 max=100 class=value ng-model=vm.percentage ng-change=changePercentage()> <span>%</span></div></div><div class="row flex-items-center" ng-if=!vm.isMainEstimate><div class=col><div class=text-label translate=Priority></div><div class=flex-items-center><div ng-class="[\'task-priority\', vm.priorityColorClasses[vm.task.priority].class]"></div><div class=dropdown><timeline-selectbox options=vm.priorityList label-field=label value-field=value is-priority=true ng-model=vm.task.priority select-event=vm.changePriority()></timeline-selectbox></div></div></div><div class=col><div class=text-label translate=Status></div><div class=dropdown><timeline-selectbox options=vm.statusList label-field=label value-field=value is-status=true ng-model=vm.task.status select-event=vm.changeStatus()></timeline-selectbox></div></div><div class=col><div class=text-label translate="Estimated Hours"></div><div class=text-value>{{vm.task.duration | readable}}</div></div></div><div class=row><div class=col><div class=text-label translate="Start Date"></div><input class=calendar-box placeholder="" date-picker="DD MMM yyyy" date=vm.startDate change=vm.changeStartDate(vm.startDate)></div><div class=col><div class=text-label translate="End Date"></div><input class=calendar-box placeholder="" date-picker="DD MMM yyyy" date=vm.endDate change=vm.changeEndDate(vm.endDate)></div><div class=col ng-if=!vm.isMainEstimate><div class=text-label translate="Remaining Hours"></div><div class=text-value>{{vm.remainingHours | readable}}</div></div></div><div class=row ng-if=!vm.isMainEstimate><div class=col><div class=text-label translate=Owner></div><div class=flex-items-center><img class=owner ng-src={{vm.task.owner.profilePic}} alt=owner><div><div class=text-value>{{vm.task.owner.displayName}}</div><div class="text-label margin-0">{{vm.task.owner.designation}}</div></div></div></div><div class=col><div class=text-label translate="Assigned To"></div><div class=members ng-if="vm.task.resources.length > 0"><div ng-repeat="member in vm.task.resources.slice(0, 5) track by $index"><img ng-if=member.avatar class=avatar ng-src={{member.avatar}} title={{member.name}} alt=logo ng-style="{left: $index * 24 + \'px\'}"><div ng-if=!member.avatar class=name-letter data-letters={{vm.utils.nameLetter(member.name)}} title={{member.name}} ng-style="{left: $index * 24 + \'px\'}"></div></div><div ng-if="vm.task.resources.length > 5" class=name-letter data-letters="+{{vm.task.resources.length - 5}}" ng-style="{left: 120}"></div></div><div class=not-assigned ng-if=!vm.task.resources.length><label>Not assigned</label></div></div></div><!--    <div class="task-period">--><!--      <div class="date-box">--><!--        <img src="/assets/icons/bx-calendar-gray.svg" alt="start date icon" />--><!--        <div>--><!--          <div class="text-label">Start Date</div>--><!--          <input--><!--            class="calendar-box" placeholder=""--><!--            date-picker="MMM DD, yyyy"--><!--            date="startDate"--><!--            ng-model-options="{ updateOn: \'blur\' }"--><!--            change="vm.changeStartDate(startDate)">--><!--        </div>--><!--      </div>--><!--      <div class="date-box">--><!--        <img src="/assets/icons/bx-calendar-gray.svg" alt="end date icon" />--><!--        <div>--><!--          <div class="text-label">End Date</div>--><!--          <input--><!--            class="calendar-box" placeholder=""--><!--            date-picker="MMM DD, yyyy"--><!--            date="endDate"--><!--            ng-model-options="{ updateOn: \'blur\' }"--><!--            change="vm.changeEndDate(endDate)">--><!--        </div>--><!--      </div>--><!--    </div>--><!--    <div class="task-status">--><!--      <img src="/assets/icons/bx-status.svg" alt="project status icon">--><!--      <div class="text-label">Project Status&nbsp;:&nbsp;</div>--><!--      <div class="text-value">{{ vm.task.delays.length > 0 ? \'Delayed\' : vm.task.progress == 1 ? \'Completed\' : \'Working\' }}</div>--><!--    </div>--><!--    <div class="task-assignedTo">--><!--      <div class="d-flex align-items-center mb-2">--><!--        <img src="/assets/icons/bx-user.svg" alt="user icon" class="user-icon">--><!--        <div class="text-label">Assigned To</div>--><!--      </div>--><!--      <div class="members">--><!--        <div ng-repeat="member in vm.task.resources.slice(0, 10) track by $index">--><!--          <img--><!--              ng-if="member.avatar"--><!--              class="avatar"--><!--              ng-src="{{member.avatar}}"--><!--              title="{{member.name}}"--><!--              alt="logo"--><!--              ng-style="{left: ($index + 1) * 24 + \'px\'}"--><!--          />--><!--          <div--><!--              ng-if="!member.avatar"--><!--              class="name-letter"--><!--              data-letters="{{vm.utils.nameLetter(member.name)}}"--><!--              title="{{member.name}}"--><!--              ng-style="{left: ($index + 1) * 24 + \'px\'}"--><!--          ></div>--><!--        </div>--><!--        <div--><!--            ng-if="vm.task.resources.length > 10"--><!--            class="name-letter"--><!--            data-letters="+{{vm.task.resources.length - 10}}"--><!--            ng-style="{left: 264}"--><!--        ></div>--><!--      </div>--><!--&lt;!&ndash;      <div class="worker" ng-repeat="worker in vm.task.resources">&ndash;&gt;--><!--&lt;!&ndash;        <img ng-src="{{worker.avatar ? worker.avatar : \'/assets/images/timeline/avatar.svg\'}}" alt="">&ndash;&gt;--><!--&lt;!&ndash;        <div>&ndash;&gt;--><!--&lt;!&ndash;          <div class="name">{{worker.name}}</div>&ndash;&gt;--><!--&lt;!&ndash;          <div class="role">{{worker.role}}</div>&ndash;&gt;--><!--&lt;!&ndash;        </div>&ndash;&gt;--><!--&lt;!&ndash;      </div>&ndash;&gt;--><!--      <div class="worker not-assigned" ng-if="!vm.task.resources.length">--><!--        <label>Not assigned</label>--><!--      </div>--><!--    </div>--><!--    <div class="report-buttons">--><!--      <button class="report-delay" ng-click="vm.reportDelay()">--><!--        <img src="/assets/icons/report-delay.svg" alt="report delay icon">--><!--        Report Delay--><!--      </button>--><!--      <button class="report-issue">--><!--        <img src="/assets/icons/report-delay.svg" alt="report issue icon">--><!--        Report Issue--><!--      </button>--><!--    </div>--><!--    <button class="mark-complete" ng-click="vm.markComplete()">--><!--      <img src="/assets/icons/mark-complete.svg" alt="mark as complete icon">--><!--      Mark as Complete--><!--    </button>--></div><div class=comments-container ng-if=!vm.isMainEstimate><!--  no comments if empty comments  --><div class=no-comments ng-if=!vm.taskComments.length translate="No comments to display"></div><!--  comments  --><div class=comment-list ng-if=vm.taskComments.length><div class="ft_12_600_gray mb-2">Comments ({{vm.totalCommentsCount}})</div><task-comment ng-repeat="comment in vm.taskComments track by $index" ng-model=comment task-id=vm.task.id is-first="{{$index === 0}}" fetch-comments=fetchComments()></task-comment></div><!--  attached files  --><div class=attached-files-container ng-if=vm.attachedFiles.length><div class="attachments flex-items-center"><div class=ft_12_600_gray translate=Attachments></div><hr></div><div class=attached-files><div class=attached-file ng-repeat="fileData in vm.attachedFiles track by $index"><img class="attached-file-thumbnail thumbnail" ng-if=fileData.isImage ng-src={{fileData.imageURL}} alt=image title={{fileData.file.name}}> <img class="attached-file-thumbnail thumbnail" ng-if=!fileData.isImage ng-src={{vm.utils.getFMFileIcon(fileData.file.type)}} alt="" title={{fileData.file.name}}> <img class=remove-attached-file src=/assets/icons/fm_cancel.svg alt="" ng-click=vm.removeAttachedFile($index)><div class=name>{{fileData.file.name}}</div></div></div></div><!--  new comment input  --><div class="add-comment-container flex-items-center flex-between"><div class="comment-input-wrapper flex-items-center"><img class=attachment src=/assets/icons/attachment.svg alt="" ngf-select ngf-change=vm.onChangeFiles($files) ngf-multiple=true aria-invalid=false data-wow-delay=0.7s> <input type=text placeholder="Type a new message" ng-model=vm.commentText></div><img class=btn-add-comment src=/assets/icons/send-black.svg alt="" ng-click=vm.addComment()></div></div></div>');
$templateCache.put('app/main/timeline/modals/hrsWModal/hrsWModal.view.html','<div id=timeline-hrs-w><div class=header><div class=title translate="Set Time"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div class=mb-20><div class="ft_12_600_gray mb-8" translate="Type of Work Partner"></div><div class=d-flex><label class="toggle d-flex mr-15" ng-model=vm.typeOfEmployee uib-btn-radio="\'Employee\'"><div class="circle mr-10"><div class=circle-kernel></div></div><div class=radio-label translate=Employee></div></label> <label class="toggle d-flex ml-10" ng-model=vm.typeOfEmployee uib-btn-radio="\'Sub-contractor\'"><div class="circle mr-10"><div class=circle-kernel></div></div><div class=radio-label translate=Sub-Contractor></div></label></div></div><div class=mb-20><tags-input ng-if="vm.typeOfEmployee===\'Employee\'" ng-model=vm.selWorkers placeholder="Select Employee" add-from-autocomplete-only=true allow-leftover-text=false display-property=name key-property=_id text=name ng-blur="text=\'\'"><auto-complete min-length=1 highlight-matched-text=false source=vm.searchEmployee($query) load-on-empty=true load-on-focus=true></auto-complete></tags-input><tags-input ng-if="vm.typeOfEmployee===\'Sub-contractor\'" ng-model=vm.selWorkers placeholder="Select Sub-contractor" add-from-autocomplete-only=true allow-leftover-text=false display-property=name key-property=_id text=name ng-blur="text=\'\'"><auto-complete min-length=1 highlight-matched-text=false source=vm.searchSubcontractor($query) load-on-empty=true load-on-focus=true></auto-complete></tags-input></div><div class="flex-between mb-20"><div class=has-calendar><div class="ft_12_600_gray mb-8" translate="Start Day"></div><selectbox-input class=arrowbottom_46_400 ng-model=vm.startWeekday options=vm.weekdays label-field=value value-field=key></selectbox-input></div><div class=has-calendar><div class="ft_12_600_gray mb-8" translate="End Day"></div><selectbox-input class=arrowbottom_46_400 ng-model=vm.endWeekday options=vm.weekdays label-field=value value-field=key></selectbox-input></div></div><div class="flex-between mb-20"><div class=has-calendar><div class="ft_12_600_gray mb-8" translate="Start Time"></div><time-picker ng-model=vm.from placeholder="Select Time" icon=/assets/icons/bx-calendar-gray.svg></time-picker></div><div class=has-calendar><div class="ft_12_600_gray mb-8" translate="End Time"></div><time-picker ng-model=vm.to placeholder="Select Time" icon=/assets/icons/bx-calendar-gray.svg></time-picker></div></div><button class="w-100 btn_new_blue mb-20" ng-click=vm.addTime() translate="Add Time"></button><div class=tag-wrapper><div class=tag style="z-index: 100" ng-repeat="time in vm.times track by $index"><div class=ml-10><div class=name>{{ time.name }}</div><div class="time d-flex">{{vm.weekdays[time.startWeekday].value}} - {{vm.weekdays[time.endWeekday].value}} ({{time.startTime | smartTime}} to {{time.endTime | smartTime}})</div></div><img class=btn-delete src=/assets/icons/close-12-gray.svg alt=close ng-click=vm.removeTime($index)></div></div><div class="d-flex justify-content-end mt-20"><button class="btn_new_blue mr-16" ng-click=onSave() translate=Save></button> <button class="btn_light_gray client_gray_back" ng-click=onCancel() translate=Cancel></button></div></div><spinner ng-if=isLoading></spinner></div>');
$templateCache.put('app/main/timeline/modals/splitTaskModal/splitTaskModal.view.html','<div id=timeline-split-task><div class=header><div class=title translate="Split Task"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div class="flex-between mb-20"><div class="timeline-input has-calendar"><div class="ft_12_600_gray mb-8" translate="Start Date"></div><input class=login_input_new placeholder="" date-picker=dd/MM/yyyy date=vm.startDate> <img src=/assets/icons/bx-calendar.svg alt=Search class=calendar_icon></div><div class="timeline-input has-calendar"><div class="ft_12_600_gray mb-8" translate="Due Date"></div><input class=login_input_new placeholder="" date-picker=dd/MM/yyyy date=vm.endDate> <img src=/assets/icons/bx-calendar.svg alt=Search class=calendar_icon></div></div><div class="w-100 mb-30"><div class="ft_12_600_gray mb-8" translate=Description></div><textarea class=w-100 placeholder="Write some description (optional)" ng-model=vm.description></textarea></div><div class="timeline-input mb-20"><button class="btn_new_blue ml-auto" ng-click=vm.addTask() translate=Add></button></div><div class="separator mb-20"></div><div class="timeline-input mb-20"><div class="split-cell mb-10 mr-20 inline-block" ng-repeat="task in vm.tasks track by $index">{{ task.text }}</div></div><div class="d-flex float-right mt-20"><button class="btn_new_blue mr-16" ng-click=onSave() ng-show="vm.tasks.length > 1" translate=Split></button> <button class="btn_new_blue client_gray_back" ng-click=onCancel() translate=Discard></button></div></div></div>');
$templateCache.put('app/main/timeline/modals/task-comment-reply-modal/task-comment-reply-modal.view.html','<div id=task-comment-reply-modal><div class=title><div class=tx-ellipsis translate="Reply comment"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><spinner ng-show=loading></spinner><div class=content><div class=mb-20><div class="ft_12_600_gray mb-8" translate="Reply comments"></div><textarea class=w-100 placeholder="Write your comments here" ng-model=commentData.comment></textarea></div><div class="flex mv-10"><img src=/assets/icons/attachment.svg alt="" class="mr-10 cursor-point"> <img src=/assets/icons/icon-@.svg alt="" class=cursor-point ngf-select="" ngf-change=onChangeFiles($files) aria-invalid=false data-wow-delay=0.7s></div><div class="carousel-inner1 row"><div class=carousel-item1 ng-repeat="file in commentData.files track by $index"><a class=image_close_btn><img src=/assets/images/materials/close_yellow.svg alt=icons ng-click=removeFile($index)></a><div class=attach-thumbnail><img ng-show=file.isImage ng-src={{file.imageURL}} class=attach-thumbnail alt=""></div><div class="text-center f_name mb-15">{{file.file.name}}</div></div></div></div><div class=footer><button class="yellow mr-15" ng-click=postComment() translate=Post></button> <button class=gray ng-click=onCancel() translate=Discard></button></div></div>');
$templateCache.put('app/main/todo/directives/todo-group-by-status/todo-group-by-status.view.html','<div id=todo-group-by-status class=w-100 ng-class="{\'flex-between\': grid, \'block_ver_wrapper\': !grid}"><div class="block_ver mb-32" ng-class=groupByStatus._id ng-repeat="(status, groupByStatus) in data" ng-style="{\'display\': !grid ? \'block\': \'none\'}"><div class="block-header flex-between pb-8"><div class=flex-between ng-click=onExpandTitle(status)><img src=/assets/icons/chevron-down-gray.svg ng-if=groupByStatus.expanded> <img src=/assets/icons/chevron-right-gray.svg ng-if=!groupByStatus.expanded> <span class=ft_16_600_black>{{groupByStatus.name}} </span><span class=ft_16_600_gray>({{groupByStatus.children? groupByStatus.children.length: \'0\'}})</span></div></div><div class=block-scroll-body dnd-list=groupByStatus.children ng-style="{\'display\': !groupByStatus.expanded ? \'block\': \'none\'}"><div class=todo-content-card ng-repeat="item in groupByStatus.children track by $index" dnd-draggable=item dnd-moved=movedTodo($index) dnd-dragstart="startForMove(item._id, status)" dnd-effect-allowed=move><div class="flex-between pos-relative"><label class="check_yellow_20 mr-16"><div class="ft_14_600_black tx-ellipsis" title={{item.title}}>{{item.title}}</div><input type=checkbox ng-model=vm.isCreditMemo> <span class=checkmark></span></label><div class="ml-auto delete-com" ng-if="permission > 1"><div class="dropdown btn-del"><button class="dropdown-toggle btn-del" type=button id=menu46 data-toggle=dropdown><img src=/assets/images/suppliers/more_horiz.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu46><li class=menu-item value="" ng-click=edit(item._id)><img src=/assets/icons/edit-black.svg alt=""><span translate=Edit></span></li><li class=menu-item value="" ng-click=delete(item._id) ng-if="permission > 3"><img src=/assets/icons/delete4.svg alt=""><span translate=Delete></span></li></ul></div></div><div ng-click="onExpand($index, status)"><img src=/assets/icons/chevron-down-gray.svg ng-style="{\'display\': item.expanded ? \'block\': \'none\'}"> <img src=/assets/icons/chevron-right-gray.svg ng-style="{\'display\': item.expanded  ? \'none\': \'block\'}"></div></div><div ng-style="{\'display\': item.expanded === true ? \'block\': \'none\'}"><div class="mt-16 pos-relative flex-between"><div ng-if="status == 0" class="progress-img flex-items-center"><span class=ft_12_regular_black translate="Not Started"></span></div><div class="flex-items-center pos-relative" ng-if="status == 1"><div class="progress-img cursor-point"><div ng-click=openEditProgressModal(item)><div class=pie ng-style="{\'--bg\': item.pieBg}"><div class=pie_segment ng-style="{\'--offset\': 0, \'--value\': item.percentage}"></div><div ng-if="item.progress > 50" class=pie_segment ng-style="{\'--offset\': 179, \'--value\': item.revice}"></div><div class="pie_segment1 d-flex"></div></div><span class=ft_12_regular_black>{{item.progress? item.progress: 0}}%</span></div></div><div class=progress-update-wrapper ng-if="item._id == selectedId && taskStatus == true"><img src=/assets/icons/close-12-gray.svg alt=icons class="pos-absolute cursor-point close-icon" ng-click=closeProgress()><div class=mb-8><div class="ft_12_600_gray status-label" translate="Task Status"></div><div class=progress-value><input type=number min=0 max=100 placeholder="" ng-model=progress_value><div class="ft_12_regular_gray progress-unit flex-center">%</div></div></div><div class="flex-content-end actions"><button class="btn_primary cancel mr-16" ng-click=closeProgress() translate=Cancel></button> <button class=btn_primary ng-click="updateProgress(item, progress_value)" translate=Update></button></div></div></div><div ng-if="status == 2" class="progress-img flex-items-center"><img src=/assets/icons/todo-check-mark.svg alt=icons class=mr-8> <span class=ft_12_regular_black translate=Completed></span></div><div class="due-date flex-content-end"><img src=/assets/icons/todo-due-date.svg alt=icons> <span class=ft_12_regular_black ng-if="status != 2">Due {{utils.getRemainingTime(item.deadlineTime)}}</span> <span class=ft_12_regular_black ng-if="status == 2">{{utils.getRemainingTime(item.updatedAt)}}</span></div></div><div class=mt-16 ng-if=item.description><div class="ft_14_600_black mb-8" translate=Description></div><div class=ft_14_regular_gray>{{item.description}}</div></div><div class=mt-16><div class=slider ng-if=!utils.isEmpty(item.files)><div class=flexslider><ul class=slides><li ng-repeat="f in item.files" class="pos-relative cursor-point" ng-click=onShowAttach(f)><img ng-if="f.format == \'pdf\'" ng-src={{utils.getFileIcon(f)}} class=pdf-icon> <img ng-if="f.format != \'pdf\'" ng-src={{f.secure_url}}> <span class="title tx-ellipsis mt-8" title={{f.originalname}}>{{f.originalname}}</span></li></ul></div></div></div><div class=mt-16 ng-if=!utils.isEmpty(item.createdBy)><div class="ft_14_600_black mb-8" translate="Created By"></div><div class=flex-between><avatar-group avatars=[item.createdBy] height="\'32\'" more-count-border-color="\'#D1D1D1\'" more-count-color="\'#ff8b00\'"></avatar-group></div></div><div ng-if=!utils.isEmpty(item.assignedTo)><div class="ft_14_600_black mb-8" translate="Assigned To"></div><div class=flex-between><avatar-group avatars=item.assignedTo height="\'32\'" more-count-border-color="\'#D1D1D1\'" more-count-color="\'#ff8b00\'"></avatar-group></div></div></div></div><div class="flex-items-center cursor-point add-task-btn" ng-click=addTodo(groupByStatus._id) ng-if="permission > 2"><img src=/assets/icons/bx-plus-blue.svg alt=icons> <span class=ft_14_600_blue translate="Add Task"></span></div></div></div><div class="block mb-24" ng-class=groupByStatus._id ng-repeat="(status, groupByStatus) in data" ng-style="{\'display\': grid ? \'block\': \'none\'}"><div class="block-header flex-between"><div><span class=ft_16_600_black>{{groupByStatus.name}} </span><span class=ft_16_600_gray>({{groupByStatus.children? groupByStatus.children.length: \'0\'}})</span></div></div><div class=block-scroll-body dnd-list=groupByStatus.children><div class="todo-content-card mb-16" ng-repeat="item in groupByStatus.children track by $index" dnd-draggable=item dnd-moved=movedTodo($index) dnd-dragstart="startForMove(item._id, status)" dnd-effect-allowed=move><div class="flex-between pos-relative"><label class="check_yellow_20 mr-16"><div class="ft_14_600_black tx-ellipsis" title={{item.title}}>{{item.title}}</div><input type=checkbox ng-model=vm.isCreditMemo> <span class=checkmark></span></label><div class="ml-auto delete-com" ng-if="permission > 1"><div class="dropdown btn-del"><button class="dropdown-toggle btn-del" type=button id=menu46 data-toggle=dropdown><img src=/assets/images/suppliers/more_horiz.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu46><li class=menu-item value="" ng-click=edit(item._id)><img src=/assets/icons/edit-black.svg alt=""><span translate=Edit></span></li><li class=menu-item value="" ng-click=delete(item._id) ng-if="permission > 3"><img src=/assets/icons/delete4.svg alt=""><span translate=Delete></span></li></ul></div></div><div ng-click="onExpand($index, status)"><img src=/assets/icons/chevron-down-gray.svg ng-style="{\'display\': item.expanded ? \'block\': \'none\'}"> <img src=/assets/icons/chevron-right-gray.svg ng-style="{\'display\': item.expanded ? \'none\': \'block\'}"></div></div><div ng-style="{\'display\': item.expanded === true ? \'block\': \'none\'}"><div class="mt-16 pos-relative flex-between"><div ng-if="status == 0" class="progress-img flex-items-center"><span class=ft_12_regular_black translate="Not Started"></span></div><div class="flex-items-center pos-relative" ng-if="status == 1"><div class="progress-img cursor-point"><div ng-click=openEditProgressModal(item)><div class=pie ng-style="{\'--bg\': item.pieBg}"><div class=pie_segment ng-style="{\'--offset\': 0, \'--value\': item.percentage}"></div><div ng-if="item.progress > 50" class=pie_segment ng-style="{\'--offset\': 179, \'--value\': item.revice}"></div><div class="pie_segment1 d-flex"></div></div><span class=ft_12_regular_black>{{item.progress? item.progress: 0}}%</span></div></div><div class=progress-update-wrapper ng-if="item._id == selectedId && taskStatus == true"><img src=/assets/icons/close-12-gray.svg alt=icons class="pos-absolute cursor-point close-icon" ng-click=closeProgress()><div class=mb-8><div class="ft_12_600_gray status-label" translate="Task Status"></div><div class=progress-value><input type=number min=0 max=100 placeholder="" ng-model=progress_value><div class="ft_12_regular_gray progress-unit flex-center">%</div></div></div><div class="flex-content-end actions"><button class="btn_primary cancel mr-16" ng-click=closeProgress() translate=Cancel></button> <button class=btn_primary ng-click="updateProgress(item, progress_value)" translate=Update></button></div></div></div><div ng-if="status == 2" class="progress-img flex-items-center"><img src=/assets/icons/todo-check-mark.svg alt=icons class=mr-8> <span class=ft_12_regular_black translate=Completed></span></div><div class="due-date flex-content-end"><img src=/assets/icons/todo-due-date.svg alt=icons> <span class=ft_12_regular_black ng-if="status != 2">Due {{utils.getRemainingTime(item.deadlineTime)}}</span> <span class=ft_12_regular_black ng-if="status == 2">{{utils.getRemainingTime(item.updatedAt)}}</span></div></div><div class=mt-16 ng-if=item.description><div class="ft_14_600_black mb-8" translate=Description></div><div class=ft_14_regular_gray>{{item.description}}</div></div><div class=mt-16><div class=slider ng-if=!utils.isEmpty(item.files)><div class=flexslider><ul class=slides><li ng-repeat="f in item.files" class="pos-relative cursor-point" ng-click=onShowAttach(f)><img ng-if="f.format == \'pdf\'" ng-src={{utils.getFileIcon(f)}} class=pdf-icon> <img ng-if="f.format != \'pdf\'" ng-src={{f.secure_url}}> <span class="title tx-ellipsis mt-8" title={{f.originalname}}>{{f.originalname}}</span></li></ul></div></div></div><div class=mt-16 ng-if=!utils.isEmpty(item.createdBy)><div class="ft_14_600_black mb-8" translate="Created By"></div><div class=flex-between><avatar-group avatars=[item.createdBy] height="\'32\'" more-count-border-color="\'#D1D1D1\'" more-count-color="\'#ff8b00\'"></avatar-group></div></div><div ng-if=!utils.isEmpty(item.assignedTo)><div class="ft_14_600_black mb-8" translate="Assigned To"></div><div class=flex-between><avatar-group avatars=item.assignedTo height="\'32\'" more-count-border-color="\'#D1D1D1\'" more-count-color="\'#ff8b00\'"></avatar-group></div></div></div></div><div class="flex-items-center cursor-point add-task-btn" ng-click=addTodo(groupByStatus._id) ng-if="permission > 2"><img src=/assets/icons/bx-plus-blue.svg alt=icons> <span class=ft_14_600_blue translate="Add Task"></span></div></div></div></div>');
$templateCache.put('app/main/todo/modals/saveTodoModal/saveTodoModal.view.html','<div id=saveTodoModal><spinner ng-show=loading></spinner><div class=title><div class="tx-ellipsis ft_14_600_black">{{(id ? "Update To Do": "Add To Do") | translate}}</div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div class="mb-15 flex-between"><div><div class="ft_12_600_gray mb-5 required" translate="To Do"></div><input class=input-primary type=text placeholder="To Do" ng-model=vm.todo.title autofocus ng-style="{\'width\': status >= 0? \'366px\': \'260px\'}"></div><div ng-if="!(status >= 0)"><div class="ft_12_600_gray mb-5" translate=Priority></div><selectbox2 class=dropdown-primary id=priority ng-model=vm.todo.priority label-field=label value-field=value options=priorityList></selectbox2></div></div><div class="mb-15 flex-between"><div ng-style="{\'--w\': status >= 0? \'366px\': \'260px\'}"><div class="ft_12_600_gray mb-5" translate=Project></div><selectbox2 class=dropdown-primary id=project ng-model=vm.todo.projectId options=vm.projectOptions label-field=label value-field=value></selectbox2></div><div ng-if="!(status >= 0)"><div class="ft_12_600_gray mb-5 required" translate=Status></div><selectbox2 class=dropdown-primary id=status ng-model=vm.todo.status label-field=label value-field=value options=statusList></selectbox2></div></div><div class=mb-15><div class="ft_12_600_gray mb-5" translate=Description></div><textarea class=w-100 placeholder="Write some description (optional)" ng-model=vm.todo.description></textarea></div><div class="mb-15 flex-between"><div><div class="ft_12_600_gray mb-5 required" translate=Deadline></div><div class="input-group datePicker-primary"><input type=text class="input-primary deadlineDate" date-picker=dd.MM.yyyy date=vm.todo.deadlineDate is-open=isDeadlinePickerOpen ng-required=true> <span class=dateArrow ng-click="isDeadlinePickerOpen = !isDeadlinePickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div><div class="ft_12_600_gray mb-5 required" translate=Time></div><time-picker class="time-picker todo" ng-model=vm.todo.deadlineTime ng-change=vm.onChangeDeadlineTime></time-picker></div></div><div class=tag-wrapper><div class="tags pos-relative w-100"><div class="ft_12_600_gray mb-5" translate=Tags></div><div class=d-flex><autocomplete1 input-class="input-primary w-100" full-width=true to-top=true ng-model=vm.addTag label-field=label value-field=value options=vm.allTags></autocomplete1><div class="flex-items-center flex-content-end"><button class="button-primary add-btn" ng-click=addTag() translate=Add></button></div></div></div><div class=tag ng-class="!vm.todo.tags.length? \'item-wrapper w-100 mb-0\': \'item-wrapper w-100\'"><div class=item ng-repeat="(key,tag) in vm.todo.tags">{{tag}} <i class=cursor-point><img src=/assets/icons/close-gray.svg alt=icons ng-click=vm.removeTagFunc(key)></i></div></div></div><div><div class="d-flex mb-3"><div class="apply-option mr-3"><radio ng-model=currentDesignation ng-value="\'Manager\'"></radio><div class="ft_12_600_gray design-label" translate=Manager></div></div><div class="apply-option mr-3"><radio ng-model=currentDesignation ng-value="\'Subcontractor\'"></radio><div class="ft_12_600_gray design-label" translate=Subcontractor></div></div><div class="apply-option mr-3"><radio ng-model=currentDesignation ng-value="\'Supplier\'"></radio><div class="ft_12_600_gray design-label" translate=Supplier></div></div></div><div class=mb-5><div class=flex-between><autocomplete1 ng-if="currentDesignation !== \'Other\'" input-class="input-primary w-100" ng-model=vm.select_user label-field=displayName value-field=_id options=vm.users full-width=true no-flex=true place-holder="Start typing a name" to-top=true></autocomplete1><input ng-if="currentDesignation === \'Other\'" type=email class="mr-4 input-primary" ng-model=vm.select_user placeholder="Start typing an email" ng-pattern=EMAIL_REGEX required><div class="flex-items-center flex-content-end"><button class="button-primary add-btn" ng-click=addMember() translate=Add></button></div></div></div><div class="pos-relative mb-15 avatars-wrapper"><avatar-group avatars=vm.todo.assignedTo to-top=true more-count-border-color="\'#ff8b00\'" more-count-color="\'#ff8b00\'"></avatar-group></div></div><div class=mb-15><div class="ft-md ft-bold-primary ft-color-ex1 mb-5 flex-items-center cursor-point w-fit-content" ngf-select ngf-change="vm.fileUpdated($files, $event)" name=file ngf-multiple=true>+&nbsp;<span translate="Attach Photo or File"></span></div><div class="upload-files flex-items-center" ng-if="vm.todo.files && vm.todo.files.length"><div class="upload-file pos-relative mr-15" ng-repeat="file in vm.todo.files track by $index"><a href={{file.secure_url}} target=_blank><img class=file-icon ng-src={{vm.utils.getFileIcon(file)}} alt="" title={{file.name}}> </a><img class="cancel-icon pos-absolute" src=/assets/icons/close-circle-f-gray.svg alt="" ng-click="vm.cancelUpload(file, $index)"></div></div></div><div class="footer flex-items-center flex-content-end"><button class="button-primary mr-4" ng-click=onSave() translate=Save></button> <button class="btn_cancel mr-4" ng-click=onCancel() translate=Discard></button></div></div></div>');
$templateCache.put('app/main/tq/directives/tq-list-toolbox/tq-list-toolbox.view.html','<div id=tq-toolbox class=tq-list-drawing-toolbar><div class=tq-toolbar-divider></div><div class="grid-container grid-4"><div class=tq-toolbar-button ng-repeat="item in data.moveTool track by $index" ng-class="{active: activeItem===item, expanded: expandedItem===item}"><img ng-src="{{\'/assets/images/tq/toolbar/\' + item.icon}}" ng-click=onButtonClick(item) title={{item.description}}></div></div><div class=tq-toolbar-divider></div><div class="grid-container grid-10"><div class=tq-toolbar-button ng-repeat="item in data.drawingTool track by $index" ng-class="{active: activeItem===item, expanded: expandedItem===item}"><img ng-src="{{\'/assets/images/tq/toolbar/\' + item.icon}}" ng-click=onButtonClick(item) title={{item.description}}></div></div><div class="d-flex align-items-center justify-center pb-2"><div class=tq-toolbar-button ng-class="{active: activeItem==={id: \'visibleCross\',icon: \'drawing-127.svg\', description: \'Show cross section\'}, expanded: expandedItem==={id: \'visibleCross\',icon: \'drawing-127.svg\', description: \'Show cross section\'}}"><img ng-src=/assets/images/tq/toolbar/drawing-4.svg ng-click="onButtonClick({id: \'visibleCross\',icon: \'drawing-127.svg\', description: \'Show cross section\'})" title="Draw nav"></div></div><div class=tq-toolbar-divider></div><div class="grid-container grid-4"><div class=tq-toolbar-button ng-repeat="item in data.measureTool track by $index" ng-class="{active: activeItem===item, expanded: expandedItem===item}"><img ng-src="{{\'/assets/images/tq/toolbar/\' + item.icon}}" ng-click=onButtonClick(item) title={{item.description}}></div></div><div class=tq-toolbar-divider></div><div class=toolbar-header><img ng-src="{{\'/assets/images/tq/toolbar/close-circle.svg\'}}"></div></div>');
$templateCache.put('app/main/tq/directives/tq-toolbox/tq-toolbox.view.html','<div id=tq-toolbox class=tq-drawing-toolbar><div class=toolbar-header><span class="ft-10 line-height-14 fw-600 ft-white">Tools</span> <i class="fa fa-times ft-10 ft-white"></i></div><div class=tq-toolbar-divider></div><div class=grid-container><div class=tq-toolbar-button ng-repeat="item in data.moveTool track by $index" ng-class="{active: activeItem===item, expanded: expandedItem===item}"><img ng-src="{{\'/assets/images/tq/toolbar/\' + item.icon}}" ng-click=onButtonClick(item) title={{item.description}}></div></div><div class=tq-toolbar-divider></div><div class=grid-container><div class=tq-toolbar-button ng-repeat="item in data.drawingTool track by $index" ng-class="{active: activeItem===item, expanded: expandedItem===item}"><img ng-src="{{\'/assets/images/tq/toolbar/\' + item.icon}}" ng-click=onButtonClick(item) title={{item.description}}></div></div><div class="d-flex align-items-center justify-center pb-2"><div class=tq-toolbar-button ng-class="{active: activeItem==={id: \'visibleCross\',icon: \'drawing-127.svg\', description: \'Show cross section\'}, expanded: expandedItem==={id: \'visibleCross\',icon: \'drawing-127.svg\', description: \'Show cross section\'}}"><img ng-src=/assets/images/tq/toolbar/drawing-4.svg ng-click="onButtonClick({id: \'visibleCross\',icon: \'drawing-127.svg\', description: \'Show cross section\'})" title="Draw nav"></div></div><div class=tq-toolbar-divider></div><div class=grid-container><div class=tq-toolbar-button ng-repeat="item in data.measureTool track by $index" ng-class="{active: activeItem===item, expanded: expandedItem===item}"><img ng-src="{{\'/assets/images/tq/toolbar/\' + item.icon}}" ng-click=onButtonClick(item) title={{item.description}}></div></div></div>');
$templateCache.put('app/main/typeWritter/directives/note-comment/note-comment.view.html','<div class=note-comment><div class="d-flex align-items-center mb-10"><img ng-src="{{ngModel.commentedBy.profilePic? ngModel.commentedBy.profilePic: \'/assets/images/employees/no-avatar.png\'}}" class="object-fit-cover avatar-24 avatar"><div><div class=ft_12_600_black>{{ngModel.commentedBy.displayName}}</div></div></div><div class="ft_12_regular_black comment mb-8" title={{ngModel.comment}}>{{ngModel.comment}}</div><div class="ft_12_regular_light text-left mb-16">{{ngModel.addTime | date: \'MMM d, yyyy h:mm a\' : \'UTC\'}}</div><div class=flex-between><div class="ft_12_regular_light text-left cursor-point" ng-click=toggleReplyCommentModal() translate=Reply></div><div class="ft_12_regular_light text-left cursor-point" ng-if=ngModel.replies.length ng-click=expandReplies()>{{ngModel.replies.length}}&nbsp;<span translate=Comments></span></div></div><div ng-repeat="reply in ngModel.replies" ng-if=ngModel.expand><hr><note-comment ng-model=reply></note-comment></div></div>');
$templateCache.put('app/main/typeWritter/directives/type-writter-card/type-writter-card.view.html','<div class=type-writter-card><div class=log-content><div class=flex-between><div class="logo d-flex"><img src=/assets/icons/file-typewritter.svg alt=logo class=m-auto></div><div class="ft_12_regular_black inline-block text-right update-date"><div translate="Last modified"></div><div class=date-time>{{data.updated | date: \'d/M/yyyy, hh:mm a\'}}</div></div></div><div class="ft_18_600_black mt-10 title tx-ellipsis" title={{data.title}}>{{data.title}}</div><div ng-if="type == \'note\'" class="ft_12_regular_black mt-10 note-content" ng-bind-html=cleanUp(data.content) title={{data.content}}></div><div class=pos-relative><avatar-group avatars=data.members to-top=true more-count-color="\'#1DA1F2\'" is-overlap=true height="\'36\'" margin-top="\'10\'" more-count-background-color="\'#E1F5FE\'"></avatar-group><div ng-if="type == \'note\'" class="ft_12_600_yellow mt-10 cursor-point read-more-position" ng-click=showDetail(data._id) translate="Read More"></div></div></div><div class="tools flex-between"><div class="w-100 d-flex"><img src=/assets/images/dashboard/eye-outline.svg alt=logo class=cursor-point></div><div class="w-100 d-flex"><img src="/assets/images/dashboard/bxs-download 2.svg" alt=logo class=cursor-point ng-click=download(data._id)></div><div class="w-100 d-flex"><img src=/assets/images/dashboard/share-alt.svg alt=logo class=cursor-point></div><div class="w-100 d-flex" ng-if="permission > 1"><img src=/assets/images/dashboard/bx-edit.svg alt=logo class=cursor-point ng-click=showDetail(data._id)></div><div class="w-100 d-flex" ng-if="permission > 3"><img src=/assets/images/dashboard/Trash-alt.svg alt=logo class=cursor-point ng-click=delete(data._id)></div></div></div>');
$templateCache.put('app/main/typeWritter/modals/addTypeWritterMemberModal/addTypeWritterMemberModal.view.html','<div id=addTypeWritterMemberModal><div class=title><div class=tx-ellipsis>Add members</div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div class="d-flex mb-3"><div class="apply-option mr-3"><radio ng-model=currentDesignation ng-value="\'Manager\'"></radio><div class=ft_14_600_black style="margin-left: 26px;" translate=Manager></div></div><div class="apply-option mr-3"><radio ng-model=currentDesignation ng-value="\'Subcontractor\'"></radio><div class=ft_14_600_black style="margin-left: 26px;" translate=Subcontractor></div></div><div class=apply-option><radio ng-model=currentDesignation ng-value="\'Supplier\'"></radio><div class=ft_14_600_black style="margin-left: 26px;" translate=Supplier></div></div></div><div class=mb-20><div class=flex-between><selectbox-input class="mr-15 w-100" type=text ng-model=vm.member.userId placeholder="Start typing a name or email" options=vm.users label-field=displayName value-field=_id></selectbox-input><button class=white ng-click=onCreate() translate=Add></button></div></div><div class=members-container><p class="designation-section ft_14_600_black py-2" translate=Managers></p><div class=item ng-repeat="member in getDesignationUsers(\'Manager\') track by $index"><!-- profilePic --> <img ng-src={{member.profilePic}} alt="" class="icon object-fit-cover" ng-if=member.profilePic> <img src=/assets/images/employees/no-avatar.png alt="" class=icon ng-if=!member.profilePic> <span class="ft_12_regular_gray name">{{member.displayName}}</span> <img src=/assets/icons/close-gray.svg alt="" class=cursor-point ng-click=onDelete(member._id)></div><p class="designation-section ft_14_600_black py-2" translate=Sub-Contractor></p><div class=item ng-repeat="member in getDesignationUsers(\'Subcontractor\') track by $index"><!-- profilePic --> <img ng-src={{member.profilePic}} alt="" class="icon object-fit-cover" ng-if=member.profilePic> <img src=/assets/images/employees/no-avatar.png alt="" class=icon ng-if=!member.profilePic> <span class="ft_12_regular_gray name">{{member.displayName}}</span> <img src=/assets/icons/close-gray.svg alt="" class=cursor-point ng-click=onDelete(member._id)></div><p class="designation-section ft_14_600_black py-2" translate=Supplier></p><div class=item ng-repeat="member in getDesignationUsers(\'Supplier\') track by $index"><!-- profilePic --> <img ng-src={{member.profilePic}} alt="" class="icon object-fit-cover" ng-if=member.profilePic> <img src=/assets/images/employees/no-avatar.png alt="" class=icon ng-if=!member.profilePic> <span class="ft_12_regular_gray name">{{member.displayName}}</span> <img src=/assets/icons/close-gray.svg alt="" class=cursor-point ng-click=onDelete(member._id)></div></div><div class="flex-between mt-20"><div class=cursor-point ng-click=onCancel()><img src=/assets/icons/arrow-left-sm.svg alt=""> <span class=ft_12_regular_gary translate=Back></span></div><button class=yellow ng-click=onCancel() translate=Close></button></div></div></div>');
$templateCache.put('app/main/typeWritter/modals/pageSetupModal/pageSetupModal.view.html','<div id=pageSetupModal><spinner ng-if=isLoading></spinner><div class=title><div class=tx-ellipsis translate="Page Setup"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><div class=content><div class=mb-16><label class="d-block ft_12_600_gray mb-2" translate="Paper Size"></label><selectbox2 id=paper-size ng-model=vm.paperSize options=vm.paperOptions label-field=name value-field=_id></selectbox2></div><div class=mb-8><label class="d-block ft_12_600_gray mb-2" translate=Orientation></label><div class=radio-group><label class="toggle flex-items-center mr-20" ng-model=pageOrientation uib-btn-radio="\'Portrait\'"><div class="circle mr-10"></div><div class="radio-label ft_12_600_gray" translate=Portrait></div></label> <label class="toggle flex-items-center" ng-model=pageOrientation uib-btn-radio="\'Landscape\'"><div class="circle mr-10"></div><div class="radio-label ft_12_600_gray" translate=Landscape></div></label></div></div><div class="action flex-items-center flex-content-end mt-25"><button class="yellow mr-4" ng-click=onOK() translate=Ok></button> <button class="gray mr-4" ng-click=onCancel() translate=Cancel></button></div></div></div>');
$templateCache.put('app/main/typeWritter/modals/reply-note-comment-modal/reply-note-comment-modal.view.html','<div id=reply-note-comment-modal><div class=title><div class=tx-ellipsis translate="Reply comment"></div><div class=close-icon ng-click=onCancel()><img src=/assets/icons/close-12-gray.svg alt=icons></div></div><spinner ng-show=loading></spinner><div class=content><div class=mb-20><div class="ft_12_600_gray mb-8" translate="Reply comments"></div><textarea class=w-100 placeholder="Write your comments here" ng-model=commentData.comment></textarea></div></div><div class=footer><button class="blue mr-15" ng-click=postComment() translate=Post></button> <button class=gray ng-click=onCancel() translate=Discard></button></div></div>');
$templateCache.put('app/main/economic/bill/directives/pending/pendingBills.view.html','<div id=pendingBills><div class="sub-header flex-between"><div class=item><div class="ft_12_600_gray mb-8" translate=Type></div><selectbox-input class="w-100 input-select" ng-model=economicTypeId options=economicTypeList label-field=name value-field=_id select-event=selEconomicTypeId(economicTypeId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate=Group></div><selectbox-input class="w-100 input-select" ng-model=billingGroupId options=billingGroups label-field=name value-field=_id select-event=selBillingGroupId(billingGroupId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate="VA Orders"></div><selectbox-input class="w-100 input-select" ng-model=billingVAOrderId options=vaOrderList label-field=displaySeq value-field=_id select-event=selBillingVAOrderId(billingVAOrderId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate="Invoice No."></div><input type=text class="login_input_new w-100" ng-model=billing.customSupplierData.invoicenumber></div><div class=item><div class="ft_12_600_gray mb-8" translate="Bill Date"></div><div class="input-group datePicker"><input type=text class="login_input_new w-100" date-picker="dd MMM yyyy" date=billDate is-open=isBillDatepickerOpen ng-required=true change=updateBillDate()> <span class=dateArrow ng-click="isBillDatepickerOpen = !isBillDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Due Date"></div><div class="input-group datePicker"><input type=text class="login_input_new w-100" date-picker="dd MMM yyyy" date=dueDate is-open=isDueDatepickerOpen ng-required=true change=updateDueDate()> <span class=dateArrow ng-click="isDueDatepickerOpen = !isDueDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=item><div class="ft_12_600_gray mb-8 text-align-right" translate="Bill Status"></div><div class="input-group datePicker text-align-right">{{billing.status == \'init\' ? \'Draft\' : billing.status | capitalize}}</div></div></div><div class=main-content ng-hide=isLoading><div class=left-item><div class=up-item ng-if=billing><div class=ft_14_600_white ng-bind=billing.billNo></div><div class=pdf-pagination><button ng-disabled="currentPageNum <= 1" ng-click=changePageInBill(false)><img src=/assets/icons/arrow-left-white.svg alt=""></button><div class=page-no>{{currentPageNum}}</div><button ng-disabled="currentPageNum >= numPages" ng-click=changePageInBill(true)><img src=/assets/icons/arrow-right-white.svg alt=""></button></div><div><img src=/assets/icons/download-white.svg alt="" class=mh-10 ng-click=downloadInvoice(billing)> <img src=/assets/icons/yellow-printer.svg alt="" class=mr-8 ng-click=printDocument()> <img src=/assets/icons/delete-white.svg alt="" width=24 height=24 ng-click=deleteCurrentBilling()></div></div><div class=print><div class=print-content><button class=pre ng-click=changeCanvasPage(false) ng-disabled="currentIndex <= 0"><img src=/assets/icons/left-arrow1.svg alt=""></button><div class="pdf-wrap no-zoom"><spinner ng-if=isLoadBilling></spinner><canvas id=the-canvas ng-hide=isLoadBilling></canvas></div><button class=next ng-click=changeCanvasPage(true) ng-disabled="currentIndex >= billList.length - 1"><img src=/assets/icons/right-arrow1.svg alt=""></button></div><div class=icons ng-if=billing><div class=icon ng-click=zoomCanvas(false)><img src=/assets/icons/zoom-in.svg alt=""></div><div class=icon ng-click=zoomCanvas(true)><img src=/assets/icons/zoom-out.svg alt=""></div></div></div></div><div class=right-item><div class="up-item ft_14_600_black"><!-- <div class="text-uppercase">{{billing.vendor.name || billing.vendor.clientName}}</div> --><div class="d-flex flex-row justify-content-center align-items-center"><div translate=Vendor></div><selectbox-input class="input-select ml-10" style="margin-top: 0 !important;" ng-model=currentVendorId options=vendors label-field=displayName value-field=_id select-event=onChangeVendor(currentVendorId)></selectbox-input><!-- </div>\n        <div class="d-flex flex-row justify-content-center align-items-center"> --><div class=ml-24 translate=Project></div><selectbox-input class="input-select ml-10" style="margin-top: 0 !important;" ng-model=billing.projectId._id options=projects label-field=projectName value-field=_id></selectbox-input></div></div><div class="bank-information mt-10" translate="Bank Information"></div><div class=content-item><div class=flex><div class=flex-70><div class="flex align-items-center mb-15"><div class="ft_12_600_black m-0" translate="Address Line 1"></div><div class="ft_12_regular_gray mb-0 ml-15">{{vendorDetail.fullAddress}}</div></div><div class="flex align-items-center mb-15"><div class="ft_12_600_black m-0" translate="Address Line 2"></div><div class="ft_12_regular_gray mb-0 ml-15" ng-bind="\'&nbsp;\'+ vendorDetail.address.line2"></div></div><div class="flex mb-15"><div class="flex flex-33 align-items-center"><div class="ft_12_600_black m-0" translate=City></div><div class="ft_12_regular_gray mb-0 ml-15" ng-bind="\'&nbsp;\'+ vendorDetail.address.city"></div></div><div class="flex flex-33 align-items-center"><div class="ft_12_600_black m-0" translate="Postal Code"></div><div class="ft_12_regular_gray mb-0 ml-15" ng-bind="\'&nbsp;\'+ vendorDetail.address.postalCode"></div></div><div class="flex flex-33 align-items-center"><div class="ft_12_600_black m-0" translate="Country Code"></div><div class="ft_12_regular_gray mb-0 ml-15" ng-bind="\'&nbsp;\'+ vendorDetail.address.countryCode"></div></div></div><div class="flex mb-15"><div class="flex flex-50 align-items-center"><div class="ft_12_600_black m-0" translate="Email ID"></div><div class="ft_12_regular_gray mb-0 ml-15" ng-bind=vendorDetail.email></div></div><div class="flex flex-50 align-items-center"><div class="ft_12_600_black m-0" translate="Phone No."></div><div class="ft_12_regular_gray mb-0 ml-15" ng-bind=vendorDetail.phoneNumber></div></div></div><div class="flex align-items-center mb-15"><div class="ft_12_600_black m-0" translate="VAT Registration No."></div><div class="ft_12_regular_gray mb-0 ml-15" ng-bind=vendorDetail.vatNumber></div></div></div><div class="flex-30 text-left"><div class="flex align-items-center mb-15"><div class="ft_12_600_black m-0" translate=IBAN></div><div class="ft_12_regular_gray mb-0 ml-15" ng-bind=bankDetails.IBAN></div></div><div class="flex align-items-center mb-15"><div class="ft_12_600_black m-0" translate=SWIFT></div><div class="ft_12_regular_gray mb-0 ml-15" ng-bind=bankDetails.bicCode></div></div><div class="flex align-items-center mb-15"><div class="ft_12_600_black m-0" translate="Account No"></div><div class="ft_12_regular_gray mb-0 ml-15" ng-bind=bankDetails.accountNumber></div></div><div class="flex align-items-center mb-15"><div class="ft_12_600_black m-0" translate=BANK></div><div class="ft_12_regular_gray mb-0 ml-15" ng-bind=bankDetails.bankName></div></div></div></div><div class=table-content><div class="header-tr pos-relative"><!-- <div ng-if="isNormalType(billing)" class="header-tr pos-relative"> --><div class=flex-27 translate=Description></div><div class="flex-8 text-right" translate=QTY></div><div class=flex-15 translate="Unit Price"></div><div class=flex-15 translate=Price></div><div class=flex-15><span translate=VAT></span>&nbsp;{{ vendorDetail.vat }} %</div><div class=flex-15 translate="Total Price"></div><div class=flex-5></div></div><!-- <div ng-if="!isNormalType(billing)" class="header-tr">\n            <div class="flex-90" translate="Description"></div>\n            <div class="flex-10" translate="QTY"></div>\n          </div> --><!-- <div class="text-center mt-20" ng-if="billing && isRunningOCRBill(billing)">OCR for this bill is in\n            progress now. This might take some minutes.</div> --><div ng-if=billing class=ocr-data><div ng-class="billing.customSupplierData.supplies.length > 5? \'table-scroll\': \'\'" scroll-bottom=billing.customSupplierData.supplies><div class="main-tr pos-relative" ng-repeat="supply in billing.customSupplierData.supplies track by $index"><!-- <div ng-if="isNormalType(billing)" class="main-tr pos-relative"\n              ng-repeat="supply in billing.customSupplierData.supplies track by $index"> --><div class=loading ng-if=supply.saveMode ng-style="{\'height\': (height - 40) + \'px\'}"><img src=/assets/icons/spinner.gif alt=icons></div><div ng-if=!supply.editMode class="flex align-items-center flex-27" title={{supply.description}}>{{ supply.description }}</div><div ng-if=supply.editMode class="flex align-items-center flex-27" title={{supply.description}}><input type=text placeholder=Description class=w-90pct ng-model=editingSupply.description ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class="flex align-items-center flex-8 justify-content-end">{{ supply.qty }}</div><div ng-if=supply.editMode class="flex align-items-center flex-8"><input type=number placeholder=QTY class=text-center ng-model=editingSupply.qty ng-change=changedQtyAndUPrice(supply) ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class="flex align-items-center flex-15 justify-content-end">{{ supply.unitprice | readable: 2 }}</div><div ng-if=supply.editMode class="flex align-items-center flex-15 justify-content-end"><input type=number placeholder="Unit Price" class=text-right ng-model=editingSupply.unitprice ng-change=changedQtyAndUPrice(supply) ng-disabled=supply.saveMode></div><div class="flex align-items-center flex-15 justify-content-end">{{ supply.price | readable: 2 }}</div><div class="flex align-items-center flex-15 justify-content-end">{{ supply.vat | readable: 2 }}</div><div class="flex align-items-center flex-15 justify-content-end">{{ supply.total | readable: 2 }}</div><div class="flex flex-5 justify-content-around align-items-center" ng-if=!supply.editMode><img src=/assets/icons/bxs-edit-blue.svg class=check-mark alt="" ng-click=onEditItem(supply)> <img src=/assets/icons/trash-alt-red.svg class=close-mark alt="" ng-click=onRemoveItem($index)></div><div class="flex flex-5 justify-content-around align-items-center" ng-if=supply.editMode><img src=/assets/icons/check-mark-line-blue.svg class=check-mark alt="" ng-click=onCheckEditing($index)> <img src=/assets/icons/trash-alt-red.svg class=close-mark alt="" ng-click=onCancelEditItem(supply)></div></div><!-- <div ng-if="!isNormalType(billing)" class="main-tr pos-relative"\n                ng-repeat="supply in billing.customSupplierData.supplies">\n                <div class="loading" ng-if="supply.saveMode" ng-style="{\'height\': (height - 40) + \'px\'}">\n                  <img src="/assets/icons/spinner.gif" alt="icons" />\n                </div>\n                <div ng-if="!supply.editMode" class="flex-90" title="{{supply.description}}">\n                  <div class="delete-com">\n                    <div ng-class="{\'dropdown\': true, \'btn-del\': true, \'dropup\': $index > 3}">\n                      <button class="dropdown-toggle btn-del" type="button" id="menu47" data-toggle="dropdown">\n                        <img src="/assets/icons/more1.svg" alt="" />\n                      </button>\n                      <ul class="dropdown-menu" role="menu" aria-labelledby="menu47">\n                        <li class="menu-item" value="" ng-click="onEditItem(supply)"><img\n                            src="/assets/icons/edit-black.svg" alt="" />Edit</li>\n                        <li class="menu-item" value="" ng-click="onRemoveItem($index)"><img\n                            src="/assets/icons/delete4.svg" alt="" />Delete</li>\n                      </ul>\n                    </div>\n                  </div>\n                  <div class="pl-15">{{ supply.description }}</div>\n                </div>\n                <div ng-if="supply.editMode" class="flex-90" title="{{supply.description}}">\n                  <img src="/assets/icons/checkmark-24.svg" class="check-mark" alt=""\n                    ng-click="onCheckEditing($index)" ng-disabled="supply.saveMode" />\n                  <img src="/assets/icons/close-20-dark.svg" class="close-mark" alt=""\n                    ng-click="onCancelEditItem(supply)" />\n                  <input type="text" placeholder="Description" class="w-90pct" ng-model="editingSupply.description"\n                    ng-disabled="supply.saveMode" />\n                </div>\n                <div ng-if="!supply.editMode" class="flex-10">{{ supply.qty }}</div>\n                <div ng-if="supply.editMode" class="flex-10">\n                  <input type="number" placeholder="Quantity" class="text-center" ng-model="editingSupply.qty"\n                    ng-disabled="supply.saveMode" />\n                </div>\n              </div> --></div><div class=flex><div class="flex-65 add-tr"><div ng-click=onAddItem() translate="+ Add New Item"></div></div><div class="flex-15 price-tr text-left" translate=Price></div><div class="flex-20 value-tr text-right">{{ billing.amountWithoutTax | readable: 2 }}</div></div><div class=flex><div class="flex-65 add-tr"></div><div class="flex-15 price-tr text-left" translate=VAT></div><div class="flex-20 value-tr text-right">{{ billing.taxAmount | readable: 2 }}</div></div><div class=flex><div class="flex-65 add-tr"></div><div class="flex-15 price-tr text-left" translate="Total Price"></div><div class="flex-20 value-tr text-right">{{ billing.totalAmount | readable: 2 }}</div></div><!-- <div ng-if="!isNormalType(billing)" class="bottom-tr">\n              <div class="row">\n                <div class="col" translate="Price"></div>\n                <div class="col">\n                  <div ng-if="!billing.editMode">\n                    <img src="/assets/icons/edit_gray.svg" alt="" ng-click="editAmountWithoutTax()" />\n                    <span>{{ billing.amountWithoutTax | readable: 2 }}</span>\n                  </div>\n                  <div ng-if="billing.editMode" class="edit-price">\n                    <img src="/assets/icons/checkmark-24.svg" alt="" ng-click="updateAmountWithoutTax()" />\n                    <img src="/assets/icons/close-20-dark.svg" alt="" ng-click="cancelAmountWithoutTax()" />\n                    <input type="number" placeholder="Price" ng-model="billing.amountWithoutTaxTemp"\n                      ng-change="changeAmountWithoutTax()" />\n                  </div>\n                </div>\n              </div>\n              <div class="row" ng-if="vendorDetail.vat">\n                <div class="col"><span translate="VAT"></span> {{ vendorDetail.vat }} %</div>\n                <div class="col">{{ billing.taxAmount | readable: 2 }}</div>\n              </div>\n              <div class="row">\n                <div class="col" translate="Total Price"></div>\n                <div class="col">{{ billing.totalAmount | readable: 2 }}</div>\n              </div>\n            </div> --><!-- <div class="bottom-tr-left">\n              <div class="flex-items-center mr-24">\n                <label class="check_yellow_16">\n                  <input type="checkbox" ng-model="isRemoveVAT" ng-change="changeIsRemoveVAT()" />\n                  <span class="checkmark_16"></span>\n                </label>\n                <div class="ft_12_600_black">Remove VAT</div>\n              </div>\n            </div> --></div></div></div></div></div></div>');
$templateCache.put('app/main/economic/bill/directives/company/companyBills.view.html','<div id=pendingBills><div class="sub-header flex-between"><div class=item><div class="ft_12_600_gray mb-8" translate=Type></div><selectbox-input class="w-100 input-select" ng-model=economicTypeId options=economicTypeList label-field=name value-field=_id select-event=selEconomicTypeId(economicTypeId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate=Group></div><selectbox-input class="w-100 input-select" ng-model=companyBillingGroupId options=companyBillingGroups label-field=name value-field=_id select-event=selBillingGroupId(companyBillingGroupId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate="VA Orders"></div><selectbox-input class="w-100 input-select" ng-model=companyBillingVAOrderId options=vaOrderList label-field=displaySeq value-field=_id select-event=selBillingVAOrderId(companyBillingVAOrderId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate="Invoice No."></div><input type=text class="login_input_new w-100" ng-model=companyBilling.customSupplierData.invoicenumber></div><div class=item><div class="ft_12_600_gray mb-8" translate="Bill Date"></div><div class="input-group datePicker"><input type=text class="login_input_new w-100" date-picker="dd MMM yyyy" date=billDate is-open=isBillDatepickerOpen ng-required=true change=updateBillDate()> <span class=dateArrow ng-click="isBillDatepickerOpen = !isBillDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Due Date"></div><div class="input-group datePicker"><input type=text class="login_input_new w-100" date-picker="dd MMM yyyy" date=dueDate is-open=isDueDatepickerOpen ng-required=true change=updateDueDate()> <span class=dateArrow ng-click="isDueDatepickerOpen = !isDueDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div><div class=main-content ng-hide=isLoading><div class=left-item><div class=up-item ng-if=companyBilling><div class=ft_14_600_white ng-bind=companyBilling.billNo></div><div class=pdf-pagination><button ng-disabled="currentPageNum <= 1" ng-click=changePageInBill(false)><img src=/assets/icons/arrow-left-white.svg alt=""></button><div class=page-no>{{currentPageNum}}</div><button ng-disabled="currentPageNum >= numPages" ng-click=changePageInBill(true)><img src=/assets/icons/arrow-right-white.svg alt=""></button></div><div><img src=/assets/icons/download-white.svg alt="" class=mh-10 ng-click=downloadInvoice(companyBilling)> <img src=/assets/icons/yellow-printer.svg alt="" class=mr-8 ng-click=printDocument()> <img src=/assets/icons/delete-white.svg alt="" width=24 height=24 ng-click=deleteBilling()></div></div><div class=print><div class=print-content><button class=pre ng-click=changeCanvasPage(false) ng-disabled="currentIndex <= 0"><img src=/assets/icons/left-arrow1.svg alt=""></button><div class="pdf-wrap no-zoom"><spinner ng-if=isLoadBilling></spinner><canvas id=the-canvas ng-hide=isLoadBilling></canvas></div><button class=next ng-click=changeCanvasPage(true) ng-disabled="currentIndex >= billList.length - 1"><img src=/assets/icons/right-arrow1.svg alt=""></button></div><div class=icons ng-if=companyBilling><div class=icon ng-click=zoomCanvas(false)><img src=/assets/icons/zoom-in.svg alt=""></div><div class=icon ng-click=zoomCanvas(true)><img src=/assets/icons/zoom-out.svg alt=""></div></div></div></div><div class=right-item><div class="up-item ft_14_600_black"><!-- <div class="text-uppercase">{{companyBilling.vendor.name || companyBilling.vendor.clientName}}</div> --><div class="d-flex flex-row justify-content-center align-items-center"><div translate=Vendor></div><selectbox-input class="input-select ml-10" style="margin-top: 0 !important;" ng-model=currentVendorId options=vendors label-field=displayName value-field=_id select-event=onChangeVendor(currentVendorId)></selectbox-input><!-- </div>\n        <div class="d-flex flex-row justify-content-center align-items-center"> --><div class=ml-24 translate=Project></div><selectbox-input class="input-select ml-10" style="margin-top: 0 !important;" ng-model=companyBilling.projectId._id options=projects label-field=projectName value-field=_id></selectbox-input></div><div translate="Bank Information"></div></div><div class=content-item><div class=flex><div class=flex-70><div class=ft_12_600_black translate="Address Line 1"></div><div class=ft_12_regular_gray>{{vendorDetail.fullAddress}}</div><div class=ft_12_600_black translate="Address Line 2"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.line2"></div><div class=flex><div class=flex-33><div class=ft_12_600_black translate=City></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.city"></div></div><div class=flex-33><div class=ft_12_600_black translate="Postal Code"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.postalCode"></div></div><div class=flex-33><div class=ft_12_600_black translate="Country Code"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.countryCode"></div></div></div><div class=flex><div class=flex-50><div class=ft_12_600_black translate="Email ID"></div><div class=ft_12_regular_gray ng-bind=vendorDetail.email></div></div><div class=flex-50><div class=ft_12_600_black translate="Phone No."></div><div class=ft_12_regular_gray ng-bind=vendorDetail.phoneNumber></div></div></div><div class=ft_12_600_black translate="VAT Registration No."></div><div class=ft_12_regular_gray ng-bind=vendorDetail.vatNumber></div></div><div class="flex-30 text-right"><div class=ft_12_600_black translate=IBAN></div><div class=ft_12_regular_gray ng-bind=bankDetails.IBAN></div><div class=ft_12_600_black translate=SWIFT></div><div class=ft_12_regular_gray ng-bind=bankDetails.bicCode></div><div class=ft_12_600_black translate="Account No"></div><div class=ft_12_regular_gray ng-bind=bankDetails.accountNumber></div><div class=ft_12_600_black translate=BANK></div><div class=ft_12_regular_gray ng-bind=bankDetails.bankName></div></div></div><div class=table-content><div class="header-tr pos-relative"><!-- <div ng-if="isNormalType(companyBilling)" class="header-tr pos-relative"> --><div class=flex-30 translate=Description></div><div class=flex-10 translate=QTY></div><div class=flex-15 translate="Unit Price"></div><div class=flex-15 translate=Price></div><div class=flex-15><span translate=VAT></span>&nbsp;{{ vendorDetail.vat }} %</div><div class=flex-15 translate="Total Price"></div></div><!-- <div ng-if="!isNormalType(companyBilling)" class="header-tr">\n            <div class="flex-90" translate="Description"></div>\n            <div class="flex-10" translate="QTY"></div>\n          </div> --><!-- <div class="text-center mt-20" ng-if="companyBilling && isRunningOCRBill(companyBilling)">OCR for this bill is in\n            progress now. This might take some minutes.</div> --><div ng-if=companyBilling class=ocr-data><div ng-class="companyBilling.customSupplierData.supplies.length > 5? \'table-scroll\': \'\'" scroll-bottom=companyBilling.customSupplierData.supplies><div class="main-tr pos-relative" ng-repeat="supply in companyBilling.customSupplierData.supplies track by $index"><!-- <div ng-if="isNormalType(companyBilling)" class="main-tr pos-relative"\n              ng-repeat="supply in companyBilling.customSupplierData.supplies track by $index"> --><div class=loading ng-if=supply.saveMode ng-style="{\'height\': (height - 40) + \'px\'}"><img src=/assets/icons/spinner.gif alt=icons></div><div ng-if=!supply.editMode class=flex-30 title={{supply.description}}><div class=delete-com><div ng-class="{\'dropdown\': true, \'btn-del\': true, \'dropup\': $index > 3}"><button class="dropdown-toggle btn-del" type=button id=menu46 data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu46><li class=menu-item value="" ng-click=onEditItem(supply)><img src=/assets/icons/edit-black.svg alt=""> <span translate=Edit></span></li><li class=menu-item value="" ng-click=onRemoveItem($index)><img src=/assets/icons/delete4.svg alt=""> <span translate=Delete></span></li></ul></div></div><span class=pl-15>{{ supply.description }}</span></div><div ng-if=supply.editMode class=flex-30 title={{supply.description}}><img src=/assets/icons/checkmark-24.svg class=check-mark alt="" ng-click=onCheckEditing($index) ng-disabled=supply.saveMode> <img src=/assets/icons/close-20-dark.svg class=close-mark alt="" ng-click=onCancelEditItem(supply)> <input type=text placeholder=Description class=w-90pct ng-model=editingSupply.description ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class=flex-10>{{ supply.qty }}</div><div ng-if=supply.editMode class=flex-10><input type=number placeholder=Quantity class=text-center ng-model=editingSupply.qty ng-change=changedQtyAndUPrice(supply) ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class=flex-15>{{ supply.unitprice | readable: 2 }}</div><div ng-if=supply.editMode class=flex-15><input type=number placeholder="Unit Price" class=text-right ng-model=editingSupply.unitprice ng-change=changedQtyAndUPrice(supply) ng-disabled=supply.saveMode></div><div class=flex-15>{{ supply.price | readable: 2 }}</div><div class=flex-15>{{ supply.vat | readable: 2 }}</div><div class=flex-15>{{ supply.total | readable: 2 }}</div></div><!-- <div ng-if="!isNormalType(companyBilling)" class="main-tr pos-relative"\n                ng-repeat="supply in companyBilling.customSupplierData.supplies">\n                <div class="loading" ng-if="supply.saveMode" ng-style="{\'height\': (height - 40) + \'px\'}">\n                  <img src="/assets/icons/spinner.gif" alt="icons" />\n                </div>\n                <div ng-if="!supply.editMode" class="flex-90" title="{{supply.description}}">\n                  <div class="delete-com">\n                    <div ng-class="{\'dropdown\': true, \'btn-del\': true, \'dropup\': $index > 3}">\n                      <button class="dropdown-toggle btn-del" type="button" id="menu47" data-toggle="dropdown">\n                        <img src="/assets/icons/more1.svg" alt="" />\n                      </button>\n                      <ul class="dropdown-menu" role="menu" aria-labelledby="menu47">\n                        <li class="menu-item" value="" ng-click="onEditItem(supply)"><img\n                            src="/assets/icons/edit-black.svg" alt="" />Edit</li>\n                        <li class="menu-item" value="" ng-click="onRemoveItem($index)"><img\n                            src="/assets/icons/delete4.svg" alt="" />Delete</li>\n                      </ul>\n                    </div>\n                  </div>\n                  <div class="pl-15">{{ supply.description }}</div>\n                </div>\n                <div ng-if="supply.editMode" class="flex-90" title="{{supply.description}}">\n                  <img src="/assets/icons/checkmark-24.svg" class="check-mark" alt=""\n                    ng-click="onCheckEditing($index)" ng-disabled="supply.saveMode" />\n                  <img src="/assets/icons/close-20-dark.svg" class="close-mark" alt=""\n                    ng-click="onCancelEditItem(supply)" />\n                  <input type="text" placeholder="Description" class="w-90pct" ng-model="editingSupply.description"\n                    ng-disabled="supply.saveMode" />\n                </div>\n                <div ng-if="!supply.editMode" class="flex-10">{{ supply.qty }}</div>\n                <div ng-if="supply.editMode" class="flex-10">\n                  <input type="number" placeholder="Quantity" class="text-center" ng-model="editingSupply.qty"\n                    ng-disabled="supply.saveMode" />\n                </div>\n              </div> --></div><div class=add-tr ng-click=onAddItem() translate="+ Add New Item"></div><div class=bottom-tr><!-- <div ng-if="isNormalType(companyBilling)" class="bottom-tr"> --><div class=row><div class=col translate=Price></div><div class=col>{{ companyBilling.amountWithoutTax | readable: 2 }}</div></div><div class=row ng-if=vendorDetail.vat><div class=col translate=VAT>{{ vendorDetail.vat }} %</div><div class=col>{{ companyBilling.taxAmount | readable: 2 }}</div></div><div class=row><div class=col translate="Total Price"></div><div class=col>{{ companyBilling.totalAmount | readable: 2 }}</div></div></div><!-- <div ng-if="!isNormalType(companyBilling)" class="bottom-tr">\n              <div class="row">\n                <div class="col" translate="Price"></div>\n                <div class="col">\n                  <div ng-if="!companyBilling.editMode">\n                    <img src="/assets/icons/edit_gray.svg" alt="" ng-click="editAmountWithoutTax()" />\n                    <span>{{ companyBilling.amountWithoutTax | readable: 2 }}</span>\n                  </div>\n                  <div ng-if="companyBilling.editMode" class="edit-price">\n                    <img src="/assets/icons/checkmark-24.svg" alt="" ng-click="updateAmountWithoutTax()" />\n                    <img src="/assets/icons/close-20-dark.svg" alt="" ng-click="cancelAmountWithoutTax()" />\n                    <input type="number" placeholder="Price" ng-model="companyBilling.amountWithoutTaxTemp"\n                      ng-change="changeAmountWithoutTax()" />\n                  </div>\n                </div>\n              </div>\n              <div class="row" ng-if="vendorDetail.vat">\n                <div class="col"><span translate="VAT"></span> {{ vendorDetail.vat }} %</div>\n                <div class="col">{{ companyBilling.taxAmount | readable: 2 }}</div>\n              </div>\n              <div class="row">\n                <div class="col" translate="Total Price"></div>\n                <div class="col">{{ companyBilling.totalAmount | readable: 2 }}</div>\n              </div>\n            </div> --><!-- <div class="bottom-tr-left">\n              <div class="flex-items-center mr-24">\n                <label class="check_yellow_16">\n                  <input type="checkbox" ng-model="isRemoveVAT" ng-change="changeIsRemoveVAT()" />\n                  <span class="checkmark_16"></span>\n                </label>\n                <div class="ft_12_600_black">Remove VAT</div>\n              </div>\n            </div> --></div></div></div></div></div></div>');
$templateCache.put('app/main/economic/bill/directives/vendorCredit/vendorCredits.view.html','<div id=vendorCredits><div class="sub-header flex-between"><div class=item><div class="ft_12_600_gray mb-8" translate=Type></div><selectbox-input class="w-100 input-select" ng-model=economicTypeId options=economicTypeList label-field=name value-field=_id select-event=selEconomicTypeId(economicTypeId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate=Group></div><selectbox-input class="w-100 input-select" ng-model=billingGroupId options=billingGroups label-field=name value-field=_id select-event=selBillingGroupId(billingGroupId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate="VA Orders"></div><selectbox-input class="w-100 input-select" ng-model=billingVAOrderId options=vaOrderList label-field=displaySeq value-field=_id select-event=selBillingVAOrderId(billingVAOrderId)></selectbox-input></div><div class=item><div class="ft_12_600_gray mb-8" translate="Invoice No."></div><input type=text class="login_input_new w-100" ng-model=memo.customSupplierData.invoicenumber></div><div class=item><div class="ft_12_600_gray mb-8" translate="Bill Date"></div><div class="input-group datePicker"><input type=text class="login_input_new w-100" date-picker="dd MMM yyyy" date=billDate is-open=isBillDatepickerOpen ng-required=true change=updateBillDate()> <span class=dateArrow ng-click="isBillDatepickerOpen = !isBillDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div><div class=item><div class="ft_12_600_gray mb-8" translate="Due Date"></div><div class="input-group datePicker"><input type=text class="login_input_new w-100" date-picker="dd MMM yyyy" date=dueDate is-open=isDueDatepickerOpen ng-required=true change=updateDueDate()> <span class=dateArrow ng-click="isDueDatepickerOpen = !isDueDatepickerOpen"><img src=/assets/icons/date-calendar.svg alt=""></span></div></div></div><div class=main-content ng-hide=isLoading><div class=left-item><div class=up-item ng-if=memo><div class=ft_14_600_white ng-bind=memo.billNo></div><div class=pdf-pagination><button ng-disabled="currentPageNum <= 1" ng-click=changePageInBill(false)><img src=/assets/icons/arrow-left-white.svg alt=""></button><div class=page-no>{{currentPageNum}}</div><button ng-disabled="currentPageNum >= numPages" ng-click=changePageInBill(true)><img src=/assets/icons/arrow-right-white.svg alt=""></button></div><div><img src=/assets/icons/download-white.svg alt="" class=mh-10 ng-click=downloadInvoice(memo)> <img src=/assets/icons/yellow-printer.svg alt="" class=mr-8 ng-click=printDocument()> <img src=/assets/icons/delete-white.svg alt="" width=24 height=24 ng-click=deleteBilling()></div></div><div class=print><div class=print-content><button class=pre ng-click=changeCanvasPage(false) ng-disabled="currentMemoIndex <= 0"><img src=/assets/icons/left-arrow1.svg alt=""></button><div class="pdf-wrap no-zoom"><spinner ng-if=isLoadBilling></spinner><canvas id=the-canvas ng-hide=isLoadBilling></canvas></div><button class=next ng-click=changeCanvasPage(true) ng-disabled="currentMemoIndex >= memoList.length - 1"><img src=/assets/icons/right-arrow1.svg alt=""></button></div><div class=icons ng-if=memo><div class=icon ng-click=zoomCanvas(false)><img src=/assets/icons/zoom-in.svg alt=""></div><div class=icon ng-click=zoomCanvas(true)><img src=/assets/icons/zoom-out.svg alt=""></div></div></div></div><div class=right-item><div class="up-item ft_14_600_black"><!-- <div class="text-uppercase">{{memo.vendor.name || memo.vendor.clientName}}</div> --><div class="d-flex flex-row justify-content-center align-items-center"><div translate=Vendor></div><selectbox-input class="input-select ml-10" style="margin-top: 0 !important;" ng-model=currentVendorId options=vendors label-field=displayName value-field=_id select-event=onChangeVendor(currentVendorId)></selectbox-input></div><div class="d-flex flex-row justify-content-center align-items-center"><div translate=Project></div><selectbox-input class="input-select ml-10" style="margin-top: 0 !important;" ng-model=memo.projectId._id options=projects label-field=projectName value-field=_id></selectbox-input></div><div translate="Bank Information"></div></div><div class=content-item><div class=flex><div class=flex-70><div class=ft_12_600_black translate="Address Line 1"></div><div class=ft_12_regular_gray>{{vendorDetail.fullAddress}}</div><div class=ft_12_600_black translate="Address Line 2"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.line2"></div><div class=flex><div class=flex-33><div class=ft_12_600_black translate=City></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.city"></div></div><div class=flex-33><div class=ft_12_600_black translate="Postal Code"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.postalCode"></div></div><div class=flex-33><div class=ft_12_600_black translate="Country Code"></div><div class=ft_12_regular_gray ng-bind="\'&nbsp;\'+ vendorDetail.address.countryCode"></div></div></div><div class=flex><div class=flex-50><div class=ft_12_600_black translate="Email ID"></div><div class=ft_12_regular_gray ng-bind=vendorDetail.email></div></div><div class=flex-50><div class=ft_12_600_black translate="Phone No."></div><div class=ft_12_regular_gray ng-bind=vendorDetail.phoneNumber></div></div></div><div class=ft_12_600_black translate="VAT Registration No."></div><div class=ft_12_regular_gray ng-bind=vendorDetail.vatNumber></div></div><div class="flex-30 text-right"><div class=ft_12_600_black translate=IBAN></div><div class=ft_12_regular_gray ng-bind=bankDetails.IBAN></div><div class=ft_12_600_black translate=SWIFT></div><div class=ft_12_regular_gray ng-bind=bankDetails.bicCode></div><div class=ft_12_600_black translate="Account No"></div><div class=ft_12_regular_gray ng-bind=bankDetails.accountNumber></div><div class=ft_12_600_black translate=BANK></div><div class=ft_12_regular_gray ng-bind=bankDetails.bankName></div></div></div><div class=table-content><div class="header-tr pos-relative"><!-- <div ng-if="isNormalType(memo)" class="header-tr pos-relative"> --><div class=flex-30 translate=Description></div><div class=flex-10 translate=QTY></div><div class=flex-15 translate="Unit Price"></div><div class=flex-15 translate=Price></div><div class=flex-15><span translate=VAT></span>&nbsp;{{ vendorDetail.vat }} %</div><div class=flex-15 translate="Total Price"></div></div><!-- <div ng-if="!isNormalType(memo)" class="header-tr">\n            <div class="flex-90" translate="Description"></div>\n            <div class="flex-10" translate="QTY"></div>\n          </div> --><!-- <div class="text-center mt-20" ng-if="memo && isRunningOCRBill(memo)">OCR for this bill is in\n            progress now. This might take some minutes.</div> --><div ng-if=memo class=ocr-data><div ng-class="memo.customSupplierData.supplies.length > 5? \'table-scroll\': \'\'" scroll-bottom=memo.customSupplierData.supplies><div class="main-tr pos-relative" ng-repeat="supply in memo.customSupplierData.supplies track by $index"><!-- <div ng-if="isNormalType(memo)" class="main-tr pos-relative"\n              ng-repeat="supply in memo.customSupplierData.supplies track by $index"> --><div class=loading ng-if=supply.saveMode ng-style="{\'height\': (height - 40) + \'px\'}"><img src=/assets/icons/spinner.gif alt=icons></div><div ng-if=!supply.editMode class=flex-30 title={{supply.description}}><div class=delete-com><div ng-class="{\'dropdown\': true, \'btn-del\': true, \'dropup\': $index > 3}"><button class="dropdown-toggle btn-del" type=button id=menu46 data-toggle=dropdown><img src=/assets/icons/more1.svg alt=""></button><ul class=dropdown-menu role=menu aria-labelledby=menu46><li class=menu-item value="" ng-click=onEditItem(supply)><img src=/assets/icons/edit-black.svg alt=""> <span translate=Edit></span></li><li class=menu-item value="" ng-click=onRemoveItem($index)><img src=/assets/icons/delete4.svg alt=""> <span translate=Delete></span></li></ul></div></div><span class=pl-15>{{ supply.description }}</span></div><div ng-if=supply.editMode class=flex-30 title={{supply.description}}><img src=/assets/icons/checkmark-24.svg class=check-mark alt="" ng-click=onCheckEditing($index) ng-disabled=supply.saveMode> <img src=/assets/icons/close-20-dark.svg class=close-mark alt="" ng-click=onCancelEditItem(supply)> <input type=text placeholder=Description class=w-90pct ng-model=editingSupply.description ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class=flex-10>{{ supply.qty }}</div><div ng-if=supply.editMode class=flex-10><input type=number placeholder=Quantity class=text-center ng-model=editingSupply.qty ng-change=changedQtyAndUPrice(supply) ng-disabled=supply.saveMode></div><div ng-if=!supply.editMode class=flex-15>{{ supply.unitprice | readable: 2 }}</div><div ng-if=supply.editMode class=flex-15><input type=number placeholder="Unit Price" class=text-right ng-model=editingSupply.unitprice ng-change=changedQtyAndUPrice(supply) ng-disabled=supply.saveMode></div><div class=flex-15>{{ supply.price | readable: 2 }}</div><div class=flex-15>{{ supply.vat | readable: 2 }}</div><div class=flex-15>{{ supply.total | readable: 2 }}</div></div><!-- <div ng-if="!isNormalType(memo)" class="main-tr pos-relative"\n                ng-repeat="supply in memo.customSupplierData.supplies">\n                <div class="loading" ng-if="supply.saveMode" ng-style="{\'height\': (height - 40) + \'px\'}">\n                  <img src="/assets/icons/spinner.gif" alt="icons" />\n                </div>\n                <div ng-if="!supply.editMode" class="flex-90" title="{{supply.description}}">\n                  <div class="delete-com">\n                    <div ng-class="{\'dropdown\': true, \'btn-del\': true, \'dropup\': $index > 3}">\n                      <button class="dropdown-toggle btn-del" type="button" id="menu47" data-toggle="dropdown">\n                        <img src="/assets/icons/more1.svg" alt="" />\n                      </button>\n                      <ul class="dropdown-menu" role="menu" aria-labelledby="menu47">\n                        <li class="menu-item" value="" ng-click="onEditItem(supply)"><img\n                            src="/assets/icons/edit-black.svg" alt="" />Edit</li>\n                        <li class="menu-item" value="" ng-click="onRemoveItem($index)"><img\n                            src="/assets/icons/delete4.svg" alt="" />Delete</li>\n                      </ul>\n                    </div>\n                  </div>\n                  <div class="pl-15">{{ supply.description }}</div>\n                </div>\n                <div ng-if="supply.editMode" class="flex-90" title="{{supply.description}}">\n                  <img src="/assets/icons/checkmark-24.svg" class="check-mark" alt=""\n                    ng-click="onCheckEditing($index)" ng-disabled="supply.saveMode" />\n                  <img src="/assets/icons/close-20-dark.svg" class="close-mark" alt=""\n                    ng-click="onCancelEditItem(supply)" />\n                  <input type="text" placeholder="Description" class="w-90pct" ng-model="editingSupply.description"\n                    ng-disabled="supply.saveMode" />\n                </div>\n                <div ng-if="!supply.editMode" class="flex-10">{{ supply.qty }}</div>\n                <div ng-if="supply.editMode" class="flex-10">\n                  <input type="number" placeholder="Quantity" class="text-center" ng-model="editingSupply.qty"\n                    ng-disabled="supply.saveMode" />\n                </div>\n              </div> --></div><div class=add-tr ng-click=onAddItem() translate="+ Add New Item"></div><div class=bottom-tr><!-- <div ng-if="isNormalType(memo)" class="bottom-tr"> --><div class=row><div class=col translate=Price></div><div class=col>{{ memo.amountWithoutTax | readable: 2 }}</div></div><div class=row ng-if=vendorDetail.vat><div class=col translate=VAT>{{ vendorDetail.vat }} %</div><div class=col>{{ memo.taxAmount | readable: 2 }}</div></div><div class=row><div class=col translate="Total Price"></div><div class=col>{{ memo.totalAmount | readable: 2 }}</div></div></div><!-- <div ng-if="!isNormalType(memo)" class="bottom-tr">\n              <div class="row">\n                <div class="col" translate="Price"></div>\n                <div class="col">\n                  <div ng-if="!memo.editMode">\n                    <img src="/assets/icons/edit_gray.svg" alt="" ng-click="editAmountWithoutTax()" />\n                    <span>{{ memo.amountWithoutTax | readable: 2 }}</span>\n                  </div>\n                  <div ng-if="memo.editMode" class="edit-price">\n                    <img src="/assets/icons/checkmark-24.svg" alt="" ng-click="updateAmountWithoutTax()" />\n                    <img src="/assets/icons/close-20-dark.svg" alt="" ng-click="cancelAmountWithoutTax()" />\n                    <input type="number" placeholder="Price" ng-model="memo.amountWithoutTaxTemp"\n                      ng-change="changeAmountWithoutTax()" />\n                  </div>\n                </div>\n              </div>\n              <div class="row" ng-if="vendorDetail.vat">\n                <div class="col"><span translate="VAT"></span> {{ vendorDetail.vat }} %</div>\n                <div class="col">{{ memo.taxAmount | readable: 2 }}</div>\n              </div>\n              <div class="row">\n                <div class="col" translate="Total Price"></div>\n                <div class="col">{{ memo.totalAmount | readable: 2 }}</div>\n              </div>\n            </div> --><!-- <div class="bottom-tr-left">\n              <div class="flex-items-center mr-24">\n                <label class="check_yellow_16">\n                  <input type="checkbox" ng-model="isRemoveVAT" ng-change="changeIsRemoveVAT()" />\n                  <span class="checkmark_16"></span>\n                </label>\n                <div class="ft_12_600_black">Remove VAT</div>\n              </div>\n            </div> --></div></div></div></div></div></div>');
$templateCache.put('app/main/finance/finance-reports/finance-debit-report/finance-debit-reports/finance-debit-reports.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-credit-reports class=wide-page><finance-menu></finance-menu><div class=content-container><div class="content pos-relative"><spinner ng-if=isLoading></spinner><div><div class=content-header><div class="d-flex justify-content-between w-100"><div class="ft_16_600_black d-flex align-items-end" translate="Debt - Due Date"></div><div class=content-sub-header><div class="d-flex justify-content-between flex-end"><div class=d-flex><div class="mr-24 d-flex align-items-center"><div class=ft_12_600_black translate="Start Date"></div></div><div class=mr-24><div class="has-calendar w-130"><input class=calendar-box placeholder="" date-picker=yyyy-MM-dd date=vm.fromDate change=dateFilterChanged() disabled-from=vm.toDate> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div><div class="mr-24 d-flex align-items-center"><div class=ft_12_600_black translate="End Date"></div></div><div class=mr-24><div class="has-calendar w-130"><input class=calendar-box placeholder="" date-picker=yyyy-MM-dd date=vm.toDate change=dateFilterChanged() disabled-to=vm.fromDate> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div><div><div class="d-flex align-items-center"><searchbox class=mr-16 is-small=true input-class=finance-searchbox search-text=searchText search-event=searchData()></searchbox><sort-dropdown ng-model=sort options=sortOptions select-event=changeSortOption(value)></sort-dropdown></div></div></div></div></div></div></div><div class=content-body><div class="report-table pos-relative"><spinner ng-if=loading></spinner><div class=thead><div class=tr><div class="td flex-6" translate="Cust. ID#"></div><div class="td flex-28" translate="Client Name"></div><div class="td flex-11 text-center" translate="0 - 30 Days"></div><div class="td flex-11 text-center" translate="31 - 60 Days"></div><div class="td flex-11 text-center" translate="61 - 90 Days"></div><div class="td flex-11 text-center" translate="After 90 Days"></div><div class="td flex-11 text-center" translate=Payments></div><div class="td flex-11 text-center" translate=Balance></div></div></div><div ng-if=reports.length class=tbody><div class=tr ng-repeat="report in reports track by $index"><div class="td flex-6">{{report.systemTag}}</div><div class="td flex-28 tx-ellipsis" title={{report.clientName}}>{{report.clientName}}</div><div ng-if=report.days30Amount class="td flex-11 dropdown"><div id={{report._id}}-days30 class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{report.days30Amount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{report._id}}-days30><div id={{invoice._id}}-days30 class=dropdown-item ng-repeat="invoice in report.days30List"><div>{{invoice.displaySeq || invoice.systemTag}}</div><div>{{invoice.remainingAmount | readable: 2}}</div></div><div id={{report._id}}-days30-sum class=dropdown-item><div class=font-weight-bold translate=Sum></div><div class=font-weight-bold>{{report.days30Amount | readable: 2}}</div></div></div></div><div ng-if=!report.days30Amount class="td flex-11 text-right">{{report.days30Amount | readable: 2}}</div><div ng-if=report.days60Amount class="td flex-11 dropdown"><div id={{report._id}}-days60 class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{report.days60Amount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{report._id}}-days60><div id={{invoice._id}}-days60 class=dropdown-item ng-repeat="invoice in report.days60List"><div>{{invoice.displaySeq || invoice.systemTag}}</div><div>{{invoice.remainingAmount | readable: 2}}</div></div><div id={{report._id}}-days60-sum class=dropdown-item><div class=font-weight-bold translate=Sum></div><div class=font-weight-bold>{{report.days60Amount | readable: 2}}</div></div></div></div><div ng-if=!report.days60Amount class="td flex-11 text-right">{{report.days60Amount | readable: 2}}</div><div ng-if=report.days90Amount class="td flex-11 dropdown"><div id={{report._id}}-days90 class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{report.days90Amount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{report._id}}-days90><div id={{invoice._id}}-days90 class=dropdown-item ng-repeat="invoice in report.days90List"><div>{{invoice.displaySeq || invoice.systemTag}}</div><div>{{invoice.remainingAmount | readable: 2}}</div></div><div id={{report._id}}-days90-sum class=dropdown-item><div class=font-weight-bold translate=Sum></div><div class=font-weight-bold>{{report.days90Amount | readable: 2}}</div></div></div></div><div ng-if=!report.days90Amount class="td flex-11 text-right">{{report.days90Amount | readable: 2}}</div><div ng-if=report.daysAfterAmount class="td flex-11 dropdown"><div id={{report._id}}-daysAfter class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{report.daysAfterAmount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{report._id}}-daysAfter><div id={{invoice._id}}-daysAfter class=dropdown-item ng-repeat="invoice in report.daysAfterList"><div>{{invoice.displaySeq || invoice.systemTag}}</div><div>{{invoice.remainingAmount | readable: 2}}</div></div><div id={{report._id}}-daysAfter-sum class=dropdown-item><div class=font-weight-bold translate=Sum></div><div class=font-weight-bold>{{report.daysAfterAmount | readable: 2}}</div></div></div></div><div ng-if=!report.daysAfterAmount class="td flex-11 text-right">{{report.daysAfterAmount | readable: 2}}</div><div ng-if=report.bankPostAmount class="td flex-11 dropdown"><div id={{report._id}}-daysAfter class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{report.bankPostAmount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{report._id}}-bankPosts><div id={{post._id}}-bankPost class=dropdown-item ng-repeat="post in report.bankPostList"><div>{{post.systemTag}}</div><div>{{post.amount | readable: 2}}</div></div><div id={{report._id}}-daysAfter-sum class=dropdown-item><div class=font-weight-bold translate=Sum></div><div class=font-weight-bold>{{report.bankPostAmount | readable: 2}}</div></div></div></div><div ng-if=!report.bankPostAmount class="td flex-11 text-right">{{report.bankPostAmount | readable: 2}}</div><div class="td flex-11 text-right">{{report.remainingAmount | readable: 2}}</div></div><div class=tr style="height: 64px"><div class="td flex-6"></div><div class="td flex-28"></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalDays30Amount | readable: 2}}</div><div class=ft_14_600_blue>{{totalDays30Amount / totalBeforeAmount * 100 | readable: 2}} %</div></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalDays60Amount | readable: 2}}</div><div class=ft_14_600_blue>{{totalDays60Amount / totalBeforeAmount * 100 | readable: 2}} %</div></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalDays90Amount | readable: 2}}</div><div class=ft_14_600_blue>{{totalDays90Amount / totalBeforeAmount * 100 | readable: 2}} %</div></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalDaysAfterAmount | readable: 2}}</div><div class=ft_14_600_blue>{{totalDaysAfterAmount / totalBeforeAmount * 100 | readable: 2}} %</div></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalBankPostAmount | readable: 2}}</div><div class=ft_14_600_blue>0.00 %</div></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalRemainingAmount | readable: 2}}</div><div class=ft_14_600_blue>{{totalRemainingAmount / totalBeforeAmount * 100 | readable: 2}} %</div></div></div></div><div ng-if=!reports.length class=no-reports>No Data to Display</div></div></div></div><div class=content-footer><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=vm.numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * vm.numPerPage + 1}} - <span ng-if="loading == false">{{(vm.currentPage - 1) * vm.numPerPage + reports.length}}</span> of {{vm.totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div><!-- <pagination ng-if="noOfPages" num-pages="noOfPages" current-page="vm.currentPage" on-select-page="fetchData()"></pagination> --></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-reports/finance-vat-report/finance-create-vat-report/finance-create-vat-report.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div class="finance-create-vat-report wide-page"><finance-menu></finance-menu><div class="content pos-relative"><spinner ng-if=loading></spinner><div class="content-header flex flex-row"><div class=ft_20_600_black translate="VAT - Report"></div><div class="flex flex-row flex-items-center ml-60"><label translate="Start of Period"></label><div class="has-calendar ml-16"><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=vm.vatReport.startDate change=changeVatAccount()> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div><label class=ml-30 translate="End of Period"></label><div class="has-calendar ml-16"><input class=calendar-box placeholder="" date-picker=dd/MM/yyyy date=vm.vatReport.endDate change=changeVatAccount()> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div></div><div class=content-body><section id=income><div class=section-header><div class=section-tab translate=Income></div></div><div class=section-body><div class="d-flex justify-content-between"><div><div class="d-flex mb-16" ng-repeat="income in vm.vatReport.incomes track by $index"><div class="w-134 mr-16"><label class=tx-ellipsis ng-bind-html=vatAccountName(income.vatAccount)></label><div class=report-input ng-bind-html=vatAccountNumber(income.vatAccount)></div></div><div class=mr-16><label translate=Amount></label><div class="report-input w-212"><span class=mr-1>{{vm.companyData.currentCurrency.symbol}}</span> <span>{{income.vatAmount | readable: 2}}</span></div></div><div><label>&nbsp;</label> <button class=btn ng-click=removeIncome($index)><img src=/assets/icons/close-circle-red1.svg alt=""></button></div></div><div class=d-flex><div class="w-134 mr-16"><label class=tx-ellipsis translate=Select></label><selectbox-input class=dropdown-primary ng-model=vm.income.vatAccount options=vm.accountPlans label-field=label short-label-field=number use-short-label=true value-field=_id on-change=changeIncomeVatAccount()></selectbox-input></div><div ng-if=!vm.income.vatAccount class=mr-16><label translate=Amount></label><div class="report-input w-212"></div></div><div ng-if=vm.income.vatAccount class=mr-16><label translate=Amount></label><div class="report-input w-212"><span class=mr-1>{{vm.companyData.currentCurrency.symbol}}</span> <span>{{vm.income.vatAmount | readable: 2}}</span></div></div><div><label>&nbsp;</label> <button class="button-primary w-auto" ng-click=addIncome() translate=Add></button></div></div></div></div></div></section><section id=deduction><div class=section-header><div class=section-tab translate=Deduction></div></div><div class=section-body><div class="d-flex mb-16" ng-repeat="deduction in vm.vatReport.deductions track by $index"><div class="w-134 mr-16"><label class=tx-ellipsis ng-bind-html=vatAccountName(deduction.vatAccount)></label><div class="report-input w-134" ng-bind-html=vatAccountNumber(deduction.vatAccount)></div></div><div class=mr-16><label translate=Amount></label><div class="report-input w-212"><span class=mr-1>{{vm.companyData.currentCurrency.symbol}}</span> <span>{{deduction.vatAmount | readable: 2}}</span></div></div><div><label>&nbsp;</label> <button class=btn ng-click=removeDeduction($index)><img src=/assets/icons/close-circle-red1.svg alt=""></button></div></div><div class=d-flex><div class="w-134 mr-16"><label class=tx-ellipsis translate=Select></label><selectbox-input class=dropdown-primary ng-model=vm.deduction.vatAccount options=vm.accountPlans label-field=label short-label-field=number use-short-label=true value-field=_id on-change=changeDeductionVatAccount()></selectbox-input></div><div ng-if=!vm.deduction.vatAccount class=mr-16><label translate=Amount></label><div class="report-input w-212"></div></div><div ng-if=vm.deduction.vatAccount class=mr-16><label translate=Amount></label><div class="report-input w-212"><span class=mr-1>{{vm.companyData.currentCurrency.symbol}}</span> <span>{{vm.deduction.vatAmount | readable: 2}}</span></div></div><div><label>&nbsp;</label> <button class="button-primary w-auto" ng-click=addDeduction()>Add</button></div></div></div></section><section id=sum><div class=section-header><div class=section-tab translate=Sum></div></div><div class=section-body><div class="d-flex justify-content-between"><div class=d-flex><div class=mr-16><label translate=Income></label><div class="report-input w-212"><span class=mr-1>{{vm.companyData.currentCurrency.symbol}}</span> <span>{{vm.vatReport.sum.income | readable: 2}}</span></div></div><div><label translate=Deduction></label><div class="report-input w-212"><span class=mr-1>{{vm.companyData.currentCurrency.symbol}}</span> <span>{{vm.vatReport.sum.deduction | readable: 2}}</span></div></div></div><div class=pr-48><label translate=Difference></label><div class="report-input w-212"><span class=mr-1>{{vm.companyData.currentCurrency.symbol}}</span> <span>{{vm.vatReport.sum.diff | readable: 2}}</span></div></div></div></div></section></div><div class=content-footer><button class="button-primary w-auto mr-16" ng-click=createVatReport()>{{vm.vatReportId ? \'Update\' : \'Create\'}}</button> <button class="button-third mr-16" translate=Cancel ui-sref=financeVatReports></button> <button class=btn_cancel><span class=mr-8 translate=Template></span> <img src=/assets/icons/chevron-down-gray.svg alt="" style="margin-right: -8px"></button></div></div></div></main>');
$templateCache.put('app/main/finance/finance-reports/finance-vat-report/finance-vat-reports/finance-vat-reports.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-report-list><finance-menu></finance-menu><div class="content-container pos-relative"><spinner ng-if=loading></spinner><div class=content><div><div class=content-header><div class=title translate="VAT Generated Reports"></div><div class=flex-items-center><button class="button-primary mr-8" ui-sref=financeCreateVatReport><img src=/assets/icons/plus.svg alt=""><span translate="Add New VAT Report"></span></button> <button class="btn btn-light"><img src=/assets/icons/setting-icon9.svg alt=""></button></div></div><div class=content-body ng-if=chunkedReportList.length><div class=row ng-repeat="chunkedReport in chunkedReportList"><div class=col-6><div class=report ng-if=chunkedReport[0]><div class="item report-item"><div class="ft_14_600_black mb-2" translate="Start Period"></div><div class=ft_14_regular_black>{{chunkedReport[0].startDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class="item report-item"><div class="ft_14_600_black mb-2" translate="End Period"></div><div class=ft_14_regular_black>{{chunkedReport[0].endDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class="item report-item"><div class="ft_14_600_black mb-2" translate=Income:></div><div class=ft_14_regular_black>{{chunkedReport[0].sum.income | readable: 2}}</div></div><div class="item report-item"><div class="ft_14_600_black mb-2" translate=Deductions:></div><div class=ft_14_regular_black>{{chunkedReport[0].sum.deduction | readable: 2}}</div></div><div class="item report-item"><div class="ft_14_600_black mb-2" translate=Difference:></div><div class=ft_14_regular_black>{{chunkedReport[0].sum.income + chunkedReport[0].sum.deduction | readable: 2}}</div></div><div class="item report-edit"><img src=/assets/icons/edit-light.svg alt="" ui-sref="financeEditVatReport({id: chunkedReport[0]._id})"></div></div></div><div class=col-6><div class=report ng-if=chunkedReport[1]><div class="item report-item"><div class="ft_14_600_black mb-2" translate="Start Period"></div><div class=ft_14_regular_black>{{chunkedReport[1].startDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class="item report-item"><div class="ft_14_600_black mb-2" translate="End Period"></div><div class=ft_14_regular_black>{{chunkedReport[1].endDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class="item report-item"><div class="ft_14_600_black mb-2" translate=Income:></div><div class=ft_14_regular_black>{{chunkedReport[1].sum.income | readable: 2}}</div></div><div class="item report-item"><div class="ft_14_600_black mb-2" translate=Deductions:></div><div class=ft_14_regular_black>{{chunkedReport[1].sum.deduction | readable: 2}}</div></div><div class="item report-item"><div class="ft_14_600_black mb-2" translate=Difference:></div><div class=ft_14_regular_black>{{chunkedReport[1].sum.income + chunkedReport[1].sum.deduction | readable: 2}}</div></div><div class="item report-edit"><img src=/assets/icons/edit-light.svg alt="" ui-sref="financeEditVatReport({id: chunkedReport[1]._id})"></div></div></div></div></div></div><div ng-if=!chunkedReportList.length class="ft_24_600_gray text-center" translate="No Data to Display"></div><div class=content-footer><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=vm.numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * vm.numPerPage + 1}} - <span ng-if="loading == false">{{(vm.currentPage - 1) * vm.numPerPage + chunkedReportList.length}}</span> of {{vm.totalCount / 2}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div><!-- <pagination ng-if="noOfPages" num-pages="noOfPages" current-page="vm.currentPage" on-select-page="fetchData()"></pagination> --></div></div></div></div></main>');
$templateCache.put('app/main/finance/finance-reports/finance-credit-report/finance-credit-reports/finance-credit-reports.view.html','<main-title-bar></main-title-bar><main-nav-bar></main-nav-bar><main><div id=finance-credit-reports class=wide-page><finance-menu></finance-menu><div class=content-container><div class="content pos-relative"><spinner ng-if=isLoading></spinner><div><div class=content-header><div class="d-flex justify-content-between w-100"><div class="ft_16_600_black d-flex align-items-end">Creditor - Due Date</div><div class=content-sub-header><div class="d-flex justify-content-between flex-end"><div class=d-flex><div class="mr-24 d-flex align-items-center"><div class=ft_12_600_black translate="Start Date"></div></div><div class=mr-24><div class="has-calendar w-130"><input class=calendar-box placeholder="" date-picker=yyyy-MM-dd date=vm.fromDate change=dateFilterChanged() disabled-from=vm.toDate> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div><div class="mr-24 d-flex align-items-center"><div class=ft_12_600_black translate="End Date"></div></div><div class=mr-24><div class="has-calendar w-130"><input class=calendar-box placeholder="" date-picker=yyyy-MM-dd date=vm.toDate change=dateFilterChanged() disabled-to=vm.fromDate> <img src=/assets/icons/bx-calendar-gray.svg alt=Search class=calendar_icon></div></div><div><div class="d-flex align-items-center"><searchbox class=mr-16 is-small=true input-class=finance-searchbox search-text=searchText search-event=searchData()></searchbox><sort-dropdown ng-model=sort options=sortOptions select-event=changeSortOption(value)></sort-dropdown></div></div></div></div></div></div></div><div class=content-body><div class="report-table pos-relative"><spinner ng-if=loading></spinner><div class=thead><div class=tr><div class="td flex-6" translate="Cust. ID#"></div><div class="td flex-28" translate="Client Name"></div><div class="td flex-11 text-center" translate="0 - 30 Days"></div><div class="td flex-11 text-center" translate="31 - 60 Days"></div><div class="td flex-11 text-center" translate="61 - 90 Days"></div><div class="td flex-11 text-center" translate="After 90 Days"></div><div class="td flex-11 text-center" translate=Payments></div><div class="td flex-11 text-center" translate=Balance></div></div></div><div ng-if=reports.length class=tbody><div class=tr ng-repeat="report in reports track by $index"><div class="td flex-6">{{report.systemTag}}</div><div class="td flex-28 tx-ellipsis" title={{report.name}}>{{report.name}}</div><div ng-if=report.days30Amount class="td flex-11 dropdown"><div id={{report._id}}-days30 class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{report.days30Amount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{report._id}}-days30><div id={{bill._id}}-days30 class=dropdown-item ng-repeat="bill in report.days30List"><div>{{bill.billNo || bill.systemTag}}</div><div>{{bill.remainingAmount | readable: 2}}</div></div><div id={{report._id}}-days30-sum class=dropdown-item><div class=font-weight-bold>Sum</div><div class=font-weight-bold>{{report.days30Amount | readable: 2}}</div></div></div></div><div ng-if=!report.days30Amount class="td flex-11 text-right">{{report.days30Amount | readable: 2}}</div><div ng-if=report.days60Amount class="td flex-11 dropdown"><div id={{report._id}}-days60 class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{report.days60Amount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{report._id}}-days60><div id={{bill._id}}-days60 class=dropdown-item ng-repeat="bill in report.days60List"><div>{{bill.billNo || bill.systemTag}}</div><div>{{bill.remainingAmount | readable: 2}}</div></div><div id={{report._id}}-days60-sum class=dropdown-item><div class=font-weight-bold translate=Sum></div><div class=font-weight-bold>{{report.days60Amount | readable: 2}}</div></div></div></div><div ng-if=!report.days60Amount class="td flex-11 text-right">{{report.days60Amount | readable: 2}}</div><div ng-if=report.days90Amount class="td flex-11 dropdown"><div id={{report._id}}-days90 class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{report.days90Amount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{report._id}}-days90><div id={{bill._id}}-days90 class=dropdown-item ng-repeat="bill in report.days90List"><div>{{bill.billNo || bill.systemTag}}</div><div>{{bill.remainingAmount | readable: 2}}</div></div><div id={{report._id}}-days90-sum class=dropdown-item><div class=font-weight-bold translate=Sum></div><div class=font-weight-bold>{{report.days90Amount | readable: 2}}</div></div></div></div><div ng-if=!report.days90Amount class="td flex-11 text-right">{{report.days90Amount | readable: 2}}</div><div ng-if=report.daysAfterAmount class="td flex-11 dropdown"><div id={{report._id}}-daysAfter class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{report.daysAfterAmount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{report._id}}-daysAfter><div id={{bill._id}}-daysAfter class=dropdown-item ng-repeat="bill in report.daysAfterList"><div>{{bill.billNo || bill.systemTag}}</div><div>{{bill.remainingAmount | readable: 2}}</div></div><div id={{report._id}}-daysAfter-sum class=dropdown-item><div class=font-weight-bold translate=Sum></div><div class=font-weight-bold>{{report.daysAfterAmount | readable: 2}}</div></div></div></div><div ng-if=!report.daysAfterAmount class="td flex-11 text-right">{{report.daysAfterAmount | readable: 2}}</div><div ng-if=report.bankPostAmount class="td flex-11 dropdown"><div id={{report._id}}-daysAfter class="cursor-point w-100" data-toggle=dropdown aria-haspopup=true aria-expanded=false><div class="d-flex align-items-center justify-content-end w-100"><div class=text-right>{{report.bankPostAmount | readable: 2}}</div><img src=/assets/icons/chevron-down-darkgray.svg alt=""></div></div><div class=dropdown-menu aria-labelledby={{report._id}}-bankPosts><div id={{post._id}}-bankPost class=dropdown-item ng-repeat="post in report.bankPostList"><div>{{post.systemTag}}</div><div>{{post.amount | readable: 2}}</div></div><div id={{report._id}}-daysAfter-sum class=dropdown-item><div class=font-weight-bold translate=Sum></div><div class=font-weight-bold>{{report.bankPostAmount | readable: 2}}</div></div></div></div><div ng-if=!report.bankPostAmount class="td flex-11 text-right">{{report.bankPostAmount | readable: 2}}</div><div class="td flex-11 text-right">{{report.remainingAmount | readable: 2}}</div></div><div class=tr style="height: 64px"><div class="td flex-6"></div><div class="td flex-28"></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalDays30Amount | readable: 2}}</div><div class=ft_14_600_blue>{{totalDays30Amount / totalBeforeAmount * 100 | readable: 2}} %</div></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalDays60Amount | readable: 2}}</div><div class=ft_14_600_blue>{{totalDays60Amount / totalBeforeAmount * 100 | readable: 2}} %</div></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalDays90Amount | readable: 2}}</div><div class=ft_14_600_blue>{{totalDays90Amount / totalBeforeAmount * 100 | readable: 2}} %</div></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalDaysAfterAmount | readable: 2}}</div><div class=ft_14_600_blue>{{totalDaysAfterAmount / totalBeforeAmount * 100 | readable: 2}} %</div></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalBankPostAmount | readable: 2}}</div><div class=ft_14_600_blue>0.00 %</div></div><div class="td flex-11 text-right"><div class="ft_14_600_black mb-8">{{totalRemainingAmount | readable: 2}}</div><div class=ft_14_600_blue>{{totalRemainingAmount / totalBeforeAmount * 100 | readable: 2}} %</div></div></div></div><div ng-if=!reports.length class=no-reports>No Data to Display</div></div></div></div><div class=content-footer><div class=pull-right><div class="flex flex-row flex-items-center"><span class=ft_14_regular_black>Items per page</span><selectbox class=duration ng-model=vm.numPerPage options=periods label-field=name value-field=id select-event=vm.selectNumPage(numPerPage)></selectbox><div class="flex flex-items-center"><span class="ft_14_regular_light_gray mr-8 ml-25">{{(vm.currentPage - 1) * vm.numPerPage + 1}} - <span ng-if="loading == false">{{(vm.currentPage - 1) * vm.numPerPage + reports.length}}</span> of {{vm.totalCount}}</span></div><div class="flex flex-items-center"><pagination-custom-new num-pages=noOfPages current-page=vm.currentPage on-select-page=fetchData()></pagination-custom-new></div></div></div><!-- <pagination ng-if="noOfPages" num-pages="noOfPages" current-page="vm.currentPage" on-select-page="fetchData()"></pagination> --></div></div></div></div></main>');}]);